
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});


parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8ed5b7d8837dad8a$export$998bcd577473dd93, (v) => $8ed5b7d8837dad8a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8ed5b7d8837dad8a$export$3d6c20d97e46b957, (v) => $8ed5b7d8837dad8a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$998bcd577473dd93;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$3d6c20d97e46b957;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
'use strict';
var $8ed5b7d8837dad8a$var$b = Symbol.for("react.element"), $8ed5b7d8837dad8a$var$c = Symbol.for("react.portal"), $8ed5b7d8837dad8a$var$d = Symbol.for("react.fragment"), $8ed5b7d8837dad8a$var$e = Symbol.for("react.strict_mode"), $8ed5b7d8837dad8a$var$f = Symbol.for("react.profiler"), $8ed5b7d8837dad8a$var$g = Symbol.for("react.provider"), $8ed5b7d8837dad8a$var$h = Symbol.for("react.context"), $8ed5b7d8837dad8a$var$k = Symbol.for("react.server_context"), $8ed5b7d8837dad8a$var$l = Symbol.for("react.forward_ref"), $8ed5b7d8837dad8a$var$m = Symbol.for("react.suspense"), $8ed5b7d8837dad8a$var$n = Symbol.for("react.suspense_list"), $8ed5b7d8837dad8a$var$p = Symbol.for("react.memo"), $8ed5b7d8837dad8a$var$q = Symbol.for("react.lazy"), $8ed5b7d8837dad8a$var$t = Symbol.for("react.offscreen"), $8ed5b7d8837dad8a$var$u;
$8ed5b7d8837dad8a$var$u = Symbol.for("react.module.reference");
function $8ed5b7d8837dad8a$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$m:
                    case $8ed5b7d8837dad8a$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$l:
                            case $8ed5b7d8837dad8a$var$q:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return r;
        }
    }
}
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$g;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$b;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$d;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$q;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$p;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$c;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$f;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$e;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$m;
$8ed5b7d8837dad8a$export$998bcd577473dd93 = $8ed5b7d8837dad8a$var$n;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$q;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$m;
};
$8ed5b7d8837dad8a$export$3d6c20d97e46b957 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$n || a === $8ed5b7d8837dad8a$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$q || a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$l || a.$$typeof === $8ed5b7d8837dad8a$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$v;

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("i4CZ2", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $d286d705bbfd559a$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $d286d705bbfd559a$export$2e2bcd8739ae039 = fn;

});

parcelRegister("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== 'object' || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, 'test');
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});


parcelRegister("jS47X", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $bOqxI = parcelRequire("bOqxI");

var $6phvH = parcelRequire("6phvH");


var debug = (parcelRequire("bM1Sj"))('socket.io-client');
/**
 * Module exports.
 */ module.exports = exports = lookup;
/**
 * Managers cache.
 */ var cache = exports.managers = {};
/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */ function lookup(uri, opts) {
    if (typeof uri === 'object') {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    var parsed = $bOqxI(uri);
    var source = parsed.source;
    var id = parsed.id;
    var path = parsed.path;
    var sameNamespace = cache[id] && path in cache[id].nsps;
    var newConnection = opts.forceNew || opts['force new connection'] || false === opts.multiplex || sameNamespace;
    var io;
    if (newConnection) {
        debug('ignoring socket cache for %s', source);
        io = (parcelRequire("41ecq"))(source, opts);
    } else {
        if (!cache[id]) {
            debug('new io instance for %s', source);
            cache[id] = (parcelRequire("41ecq"))(source, opts);
        }
        io = cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.query;
    return io.socket(parsed.path, opts);
}
/**
 * Protocol version.
 *
 * @api public
 */ exports.protocol = $6phvH.protocol;
/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */ exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */ exports.Manager = (parcelRequire("41ecq"));

exports.Socket = (parcelRequire("4HSAZ"));

});
parcelRegister("bOqxI", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $11NFp = parcelRequire("11NFp");

var $8998f40f5c040ebe$var$debug = (parcelRequire("bM1Sj"))('socket.io-client:url');
/**
 * Module exports.
 */ module.exports = $8998f40f5c040ebe$var$url;
/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */ function $8998f40f5c040ebe$var$url(uri, loc) {
    var obj = uri;
    // default to window.location
    loc = loc || typeof location !== 'undefined' && location;
    if (null == uri) uri = loc.protocol + '//' + loc.host;
    // relative path support
    if ('string' === typeof uri) {
        if ('/' === uri.charAt(0)) {
            if ('/' === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            $8998f40f5c040ebe$var$debug('protocol-less url %s', uri);
            if ('undefined' !== typeof loc) uri = loc.protocol + '//' + uri;
            else uri = 'https://' + uri;
        }
        // parse
        $8998f40f5c040ebe$var$debug('parse %s', uri);
        obj = $11NFp(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = '80';
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = '443';
    }
    obj.path = obj.path || '/';
    var ipv6 = obj.host.indexOf(':') !== -1;
    var host = ipv6 ? '[' + obj.host + ']' : obj.host;
    // define unique id
    obj.id = obj.protocol + '://' + host + ':' + obj.port;
    // define href
    obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : ':' + obj.port);
    return obj;
}

});
parcelRegister("11NFp", function(module, exports) {
/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ var $0bfc69396a695085$var$re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var $0bfc69396a695085$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
module.exports = function parseuri(str) {
    var src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    var m = $0bfc69396a695085$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$0bfc69396a695085$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $0bfc69396a695085$var$pathNames(uri, uri['path']);
    uri.queryKey = $0bfc69396a695085$var$queryKey(uri, uri['query']);
    return uri;
};
function $0bfc69396a695085$var$pathNames(obj, path) {
    var regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.substr(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.substr(path.length - 1, 1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $0bfc69396a695085$var$queryKey(uri, query) {
    var data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});

parcelRegister("bM1Sj", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
var $hPtJY = parcelRequire("hPtJY");

exports = module.exports = (parcelRequire("2lr2q"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $hPtJY !== 'undefined' && 'env' in $hPtJY) r = undefined;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("2lr2q", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("i8tBh"));
/**
 * Active `debug` instances.
 */ exports.instances = [];
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    var prevTime;
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    exports.instances.push(debug);
    return debug;
}
function destroy() {
    var index = exports.instances.indexOf(this);
    if (index !== -1) {
        exports.instances.splice(index, 1);
        return true;
    } else return false;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
    for(i = 0; i < exports.instances.length; i++){
        var instance = exports.instances[i];
        instance.enabled = exports.enabled(instance.namespace);
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    if (name[name.length - 1] === '*') return true;
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("i8tBh", function(module, exports) {
/**
 * Helpers.
 */ var $d33fef54aeab5500$var$s = 1000;
var $d33fef54aeab5500$var$m = $d33fef54aeab5500$var$s * 60;
var $d33fef54aeab5500$var$h = $d33fef54aeab5500$var$m * 60;
var $d33fef54aeab5500$var$d = $d33fef54aeab5500$var$h * 24;
var $d33fef54aeab5500$var$y = $d33fef54aeab5500$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $d33fef54aeab5500$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $d33fef54aeab5500$var$fmtLong(val) : $d33fef54aeab5500$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $d33fef54aeab5500$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $d33fef54aeab5500$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $d33fef54aeab5500$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $d33fef54aeab5500$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $d33fef54aeab5500$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $d33fef54aeab5500$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $d33fef54aeab5500$var$fmtShort(ms) {
    if (ms >= $d33fef54aeab5500$var$d) return Math.round(ms / $d33fef54aeab5500$var$d) + 'd';
    if (ms >= $d33fef54aeab5500$var$h) return Math.round(ms / $d33fef54aeab5500$var$h) + 'h';
    if (ms >= $d33fef54aeab5500$var$m) return Math.round(ms / $d33fef54aeab5500$var$m) + 'm';
    if (ms >= $d33fef54aeab5500$var$s) return Math.round(ms / $d33fef54aeab5500$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $d33fef54aeab5500$var$fmtLong(ms) {
    return $d33fef54aeab5500$var$plural(ms, $d33fef54aeab5500$var$d, 'day') || $d33fef54aeab5500$var$plural(ms, $d33fef54aeab5500$var$h, 'hour') || $d33fef54aeab5500$var$plural(ms, $d33fef54aeab5500$var$m, 'minute') || $d33fef54aeab5500$var$plural(ms, $d33fef54aeab5500$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $d33fef54aeab5500$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});




parcelRegister("6phvH", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $4aa2a9131989d807$export$a51d6b395ff4c65a, (v) => $4aa2a9131989d807$export$a51d6b395ff4c65a = v);
$parcel$export(module.exports, "types", () => $4aa2a9131989d807$export$b14ad400b1d09e0f, (v) => $4aa2a9131989d807$export$b14ad400b1d09e0f = v);
$parcel$export(module.exports, "CONNECT", () => $4aa2a9131989d807$export$df50b52b1548c0dc, (v) => $4aa2a9131989d807$export$df50b52b1548c0dc = v);
$parcel$export(module.exports, "DISCONNECT", () => $4aa2a9131989d807$export$5fd12e2e89ab14dc, (v) => $4aa2a9131989d807$export$5fd12e2e89ab14dc = v);
$parcel$export(module.exports, "EVENT", () => $4aa2a9131989d807$export$e39a34cfd532e15, (v) => $4aa2a9131989d807$export$e39a34cfd532e15 = v);
$parcel$export(module.exports, "ACK", () => $4aa2a9131989d807$export$8b9f6dafceb64eb3, (v) => $4aa2a9131989d807$export$8b9f6dafceb64eb3 = v);
$parcel$export(module.exports, "ERROR", () => $4aa2a9131989d807$export$103bedf43ba882db, (v) => $4aa2a9131989d807$export$103bedf43ba882db = v);
$parcel$export(module.exports, "BINARY_EVENT", () => $4aa2a9131989d807$export$4e593a8e75481d89, (v) => $4aa2a9131989d807$export$4e593a8e75481d89 = v);
$parcel$export(module.exports, "BINARY_ACK", () => $4aa2a9131989d807$export$153fee94313d337d, (v) => $4aa2a9131989d807$export$153fee94313d337d = v);
$parcel$export(module.exports, "Encoder", () => $4aa2a9131989d807$export$a50aceb0e02a00aa, (v) => $4aa2a9131989d807$export$a50aceb0e02a00aa = v);
$parcel$export(module.exports, "Decoder", () => $4aa2a9131989d807$export$f9de6ca0bc043724, (v) => $4aa2a9131989d807$export$f9de6ca0bc043724 = v);
/**
 * Module dependencies.
 */ /**
 * Protocol version.
 *
 * @api public
 */ var $4aa2a9131989d807$export$a51d6b395ff4c65a;
/**
 * Packet types.
 *
 * @api public
 */ var $4aa2a9131989d807$export$b14ad400b1d09e0f;
/**
 * Packet type `connect`.
 *
 * @api public
 */ var $4aa2a9131989d807$export$df50b52b1548c0dc;
/**
 * Packet type `disconnect`.
 *
 * @api public
 */ var $4aa2a9131989d807$export$5fd12e2e89ab14dc;
/**
 * Packet type `event`.
 *
 * @api public
 */ var $4aa2a9131989d807$export$e39a34cfd532e15;
/**
 * Packet type `ack`.
 *
 * @api public
 */ var $4aa2a9131989d807$export$8b9f6dafceb64eb3;
/**
 * Packet type `error`.
 *
 * @api public
 */ var $4aa2a9131989d807$export$103bedf43ba882db;
/**
 * Packet type 'binary event'
 *
 * @api public
 */ var $4aa2a9131989d807$export$4e593a8e75481d89;
/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */ var $4aa2a9131989d807$export$153fee94313d337d;
/**
 * Encoder constructor.
 *
 * @api public
 */ var $4aa2a9131989d807$export$a50aceb0e02a00aa;
/**
 * Decoder constructor.
 *
 * @api public
 */ var $4aa2a9131989d807$export$f9de6ca0bc043724;

var $4aa2a9131989d807$var$debug = (parcelRequire("bM1Sj"))('socket.io-parser');

var $eH30A = parcelRequire("eH30A");

var $lwD8o = parcelRequire("lwD8o");

var $979eI = parcelRequire("979eI");

var $82SCW = parcelRequire("82SCW");
$4aa2a9131989d807$export$a51d6b395ff4c65a = 4;
$4aa2a9131989d807$export$b14ad400b1d09e0f = [
    'CONNECT',
    'DISCONNECT',
    'EVENT',
    'ACK',
    'ERROR',
    'BINARY_EVENT',
    'BINARY_ACK'
];
$4aa2a9131989d807$export$df50b52b1548c0dc = 0;
$4aa2a9131989d807$export$5fd12e2e89ab14dc = 1;
$4aa2a9131989d807$export$e39a34cfd532e15 = 2;
$4aa2a9131989d807$export$8b9f6dafceb64eb3 = 3;
$4aa2a9131989d807$export$103bedf43ba882db = 4;
$4aa2a9131989d807$export$4e593a8e75481d89 = 5;
$4aa2a9131989d807$export$153fee94313d337d = 6;
$4aa2a9131989d807$export$a50aceb0e02a00aa = $4aa2a9131989d807$var$Encoder;
$4aa2a9131989d807$export$f9de6ca0bc043724 = $4aa2a9131989d807$var$Decoder;
/**
 * A socket.io Encoder instance
 *
 * @api public
 */ function $4aa2a9131989d807$var$Encoder() {}
var $4aa2a9131989d807$var$ERROR_PACKET = $4aa2a9131989d807$export$103bedf43ba882db + '"encode error"';
/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */ $4aa2a9131989d807$var$Encoder.prototype.encode = function(obj, callback) {
    $4aa2a9131989d807$var$debug('encoding packet %j', obj);
    if ($4aa2a9131989d807$export$4e593a8e75481d89 === obj.type || $4aa2a9131989d807$export$153fee94313d337d === obj.type) $4aa2a9131989d807$var$encodeAsBinary(obj, callback);
    else {
        var encoding = $4aa2a9131989d807$var$encodeAsString(obj);
        callback([
            encoding
        ]);
    }
};
/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */ function $4aa2a9131989d807$var$encodeAsString(obj) {
    // first is type
    var str = '' + obj.type;
    // attachments if we have them
    if ($4aa2a9131989d807$export$4e593a8e75481d89 === obj.type || $4aa2a9131989d807$export$153fee94313d337d === obj.type) str += obj.attachments + '-';
    // if we have a namespace other than `/`
    // we append it followed by a comma `,`
    if (obj.nsp && '/' !== obj.nsp) str += obj.nsp + ',';
    // immediately followed by the id
    if (null != obj.id) str += obj.id;
    // json data
    if (null != obj.data) {
        var payload = $4aa2a9131989d807$var$tryStringify(obj.data);
        if (payload !== false) str += payload;
        else return $4aa2a9131989d807$var$ERROR_PACKET;
    }
    $4aa2a9131989d807$var$debug('encoded %j as %s', obj, str);
    return str;
}
function $4aa2a9131989d807$var$tryStringify(str) {
    try {
        return JSON.stringify(str);
    } catch (e) {
        return false;
    }
}
/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */ function $4aa2a9131989d807$var$encodeAsBinary(obj, callback) {
    function writeEncoding(bloblessData) {
        var deconstruction = $lwD8o.deconstructPacket(bloblessData);
        var pack = $4aa2a9131989d807$var$encodeAsString(deconstruction.packet);
        var buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        callback(buffers); // write all the buffers
    }
    $lwD8o.removeBlobs(obj, writeEncoding);
}
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */ function $4aa2a9131989d807$var$Decoder() {
    this.reconstructor = null;
}
/**
 * Mix in `Emitter` with Decoder.
 */ $eH30A($4aa2a9131989d807$var$Decoder.prototype);
/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */ $4aa2a9131989d807$var$Decoder.prototype.add = function(obj) {
    var packet;
    if (typeof obj === 'string') {
        if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
        packet = $4aa2a9131989d807$var$decodeString(obj);
        if ($4aa2a9131989d807$export$4e593a8e75481d89 === packet.type || $4aa2a9131989d807$export$153fee94313d337d === packet.type) {
            this.reconstructor = new $4aa2a9131989d807$var$BinaryReconstructor(packet);
            // no attachments, labeled binary but no binary data to follow
            if (this.reconstructor.reconPack.attachments === 0) this.emit('decoded', packet);
        } else this.emit('decoded', packet);
    } else if ($82SCW(obj) || obj.base64) {
        if (!this.reconstructor) throw new Error('got binary data when not reconstructing a packet');
        else {
            packet = this.reconstructor.takeBinaryData(obj);
            if (packet) {
                this.reconstructor = null;
                this.emit('decoded', packet);
            }
        }
    } else throw new Error('Unknown type: ' + obj);
};
function $4aa2a9131989d807$var$isPayloadValid(type, payload) {
    switch(type){
        case 0:
            return typeof payload === "object";
        case 1:
            return payload === undefined;
        case 4:
            return typeof payload === "string" || typeof payload === "object";
        case 2:
        case 5:
            return $979eI(payload) && (typeof payload[0] === "string" || typeof payload[0] === "number");
        case 3:
        case 6:
            return $979eI(payload);
    }
}
/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */ function $4aa2a9131989d807$var$decodeString(str) {
    var i = 0;
    // look up type
    var p = {
        type: Number(str.charAt(0))
    };
    if (null == $4aa2a9131989d807$export$b14ad400b1d09e0f[p.type]) return $4aa2a9131989d807$var$error('unknown packet type ' + p.type);
    // look up attachments if type binary
    if ($4aa2a9131989d807$export$4e593a8e75481d89 === p.type || $4aa2a9131989d807$export$153fee94313d337d === p.type) {
        var start = i + 1;
        while(str.charAt(++i) !== '-' && i != str.length);
        var buf = str.substring(start, i);
        if (buf != Number(buf) || str.charAt(i) !== '-') throw new Error('Illegal attachments');
        p.attachments = Number(buf);
    }
    // look up namespace (if any)
    if ('/' === str.charAt(i + 1)) {
        var start = i + 1;
        while(++i){
            var c = str.charAt(i);
            if (',' === c) break;
            if (i === str.length) break;
        }
        p.nsp = str.substring(start, i);
    } else p.nsp = '/';
    // look up id
    var next = str.charAt(i + 1);
    if ('' !== next && Number(next) == next) {
        var start = i + 1;
        while(++i){
            var c = str.charAt(i);
            if (null == c || Number(c) != c) {
                --i;
                break;
            }
            if (i === str.length) break;
        }
        p.id = Number(str.substring(start, i + 1));
    }
    // look up json data
    if (str.charAt(++i)) {
        var payload = $4aa2a9131989d807$var$tryParse(str.substr(i));
        if ($4aa2a9131989d807$var$isPayloadValid(p.type, payload)) p.data = payload;
        else throw new Error("invalid payload");
    }
    $4aa2a9131989d807$var$debug('decoded %s as %j', str, p);
    return p;
}
function $4aa2a9131989d807$var$tryParse(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return false;
    }
}
/**
 * Deallocates a parser's resources
 *
 * @api public
 */ $4aa2a9131989d807$var$Decoder.prototype.destroy = function() {
    if (this.reconstructor) this.reconstructor.finishedReconstruction();
};
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */ function $4aa2a9131989d807$var$BinaryReconstructor(packet) {
    this.reconPack = packet;
    this.buffers = [];
}
/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */ $4aa2a9131989d807$var$BinaryReconstructor.prototype.takeBinaryData = function(binData) {
    this.buffers.push(binData);
    if (this.buffers.length === this.reconPack.attachments) {
        var packet = $lwD8o.reconstructPacket(this.reconPack, this.buffers);
        this.finishedReconstruction();
        return packet;
    }
    return null;
};
/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */ $4aa2a9131989d807$var$BinaryReconstructor.prototype.finishedReconstruction = function() {
    this.reconPack = null;
    this.buffers = [];
};
function $4aa2a9131989d807$var$error(msg) {
    return {
        type: $4aa2a9131989d807$export$103bedf43ba882db,
        data: 'parser error: ' + msg
    };
}

});
parcelRegister("eH30A", function(module, exports) {
/**
 * Expose `Emitter`.
 */ module.exports = $ab276a41bfc4d39d$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $ab276a41bfc4d39d$var$Emitter(obj) {
    if (obj) return $ab276a41bfc4d39d$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $ab276a41bfc4d39d$var$mixin(obj) {
    for(var key in $ab276a41bfc4d39d$var$Emitter.prototype)obj[key] = $ab276a41bfc4d39d$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $ab276a41bfc4d39d$var$Emitter.prototype.on = $ab276a41bfc4d39d$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $ab276a41bfc4d39d$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $ab276a41bfc4d39d$var$Emitter.prototype.off = $ab276a41bfc4d39d$var$Emitter.prototype.removeListener = $ab276a41bfc4d39d$var$Emitter.prototype.removeAllListeners = $ab276a41bfc4d39d$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $ab276a41bfc4d39d$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $ab276a41bfc4d39d$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $ab276a41bfc4d39d$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("lwD8o", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $fabaf1690f7cdcf4$export$ac2edb9eb7af56f6, (v) => $fabaf1690f7cdcf4$export$ac2edb9eb7af56f6 = v);
$parcel$export(module.exports, "reconstructPacket", () => $fabaf1690f7cdcf4$export$a00da3b1ec037a04, (v) => $fabaf1690f7cdcf4$export$a00da3b1ec037a04 = v);
$parcel$export(module.exports, "removeBlobs", () => $fabaf1690f7cdcf4$export$c546b07ca8124461, (v) => $fabaf1690f7cdcf4$export$c546b07ca8124461 = v);
/*global Blob,File*/ /**
 * Module requirements
 */ /**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */ var $fabaf1690f7cdcf4$export$ac2edb9eb7af56f6;
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */ var $fabaf1690f7cdcf4$export$a00da3b1ec037a04;
/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */ var $fabaf1690f7cdcf4$export$c546b07ca8124461;

var $979eI = parcelRequire("979eI");

var $82SCW = parcelRequire("82SCW");
var $fabaf1690f7cdcf4$var$toString = Object.prototype.toString;
var $fabaf1690f7cdcf4$var$withNativeBlob = typeof Blob === 'function' || typeof Blob !== 'undefined' && $fabaf1690f7cdcf4$var$toString.call(Blob) === '[object BlobConstructor]';
var $fabaf1690f7cdcf4$var$withNativeFile = typeof File === 'function' || typeof File !== 'undefined' && $fabaf1690f7cdcf4$var$toString.call(File) === '[object FileConstructor]';
$fabaf1690f7cdcf4$export$ac2edb9eb7af56f6 = function(packet) {
    var buffers = [];
    var packetData = packet.data;
    var pack = packet;
    pack.data = $fabaf1690f7cdcf4$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
};
function $fabaf1690f7cdcf4$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ($82SCW(data)) {
        var placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if ($979eI(data)) {
        var newData = new Array(data.length);
        for(var i = 0; i < data.length; i++)newData[i] = $fabaf1690f7cdcf4$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === 'object' && !(data instanceof Date)) {
        var newData = {};
        for(var key in data)newData[key] = $fabaf1690f7cdcf4$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
$fabaf1690f7cdcf4$export$a00da3b1ec037a04 = function(packet, buffers) {
    packet.data = $fabaf1690f7cdcf4$var$_reconstructPacket(packet.data, buffers);
    packet.attachments = undefined; // no longer useful
    return packet;
};
function $fabaf1690f7cdcf4$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        var isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if ($979eI(data)) for(var i = 0; i < data.length; i++)data[i] = $fabaf1690f7cdcf4$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === 'object') for(var key in data)data[key] = $fabaf1690f7cdcf4$var$_reconstructPacket(data[key], buffers);
    return data;
}
$fabaf1690f7cdcf4$export$c546b07ca8124461 = function(data, callback) {
    function _removeBlobs(obj, curKey, containingObject) {
        if (!obj) return obj;
        // convert any blob
        if ($fabaf1690f7cdcf4$var$withNativeBlob && obj instanceof Blob || $fabaf1690f7cdcf4$var$withNativeFile && obj instanceof File) {
            pendingBlobs++;
            // async filereader
            var fileReader = new FileReader();
            fileReader.onload = function() {
                if (containingObject) containingObject[curKey] = this.result;
                else bloblessData = this.result;
                // if nothing pending its callback time
                if (!--pendingBlobs) callback(bloblessData);
            };
            fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
        } else if ($979eI(obj)) for(var i = 0; i < obj.length; i++)_removeBlobs(obj[i], i, obj);
        else if (typeof obj === 'object' && !$82SCW(obj)) for(var key in obj)_removeBlobs(obj[key], key, obj);
    }
    var pendingBlobs = 0;
    var bloblessData = data;
    _removeBlobs(bloblessData);
    if (!pendingBlobs) callback(bloblessData);
};

});
parcelRegister("979eI", function(module, exports) {
var $6a2beea50d5ff524$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $6a2beea50d5ff524$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("82SCW", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5db8e26c668aa2ff$require$Buffer = $6ZWSX.Buffer;
module.exports = $5db8e26c668aa2ff$var$isBuf;
var $5db8e26c668aa2ff$var$withNativeBuffer = typeof $5db8e26c668aa2ff$require$Buffer === 'function' && typeof $5db8e26c668aa2ff$require$Buffer.isBuffer === 'function';
var $5db8e26c668aa2ff$var$withNativeArrayBuffer = typeof ArrayBuffer === 'function';
var $5db8e26c668aa2ff$var$isView = function(obj) {
    return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */ function $5db8e26c668aa2ff$var$isBuf(obj) {
    return $5db8e26c668aa2ff$var$withNativeBuffer && $5db8e26c668aa2ff$require$Buffer.isBuffer(obj) || $5db8e26c668aa2ff$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $5db8e26c668aa2ff$var$isView(obj));
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("41ecq", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $9XcnD = parcelRequire("9XcnD");

var $4HSAZ = parcelRequire("4HSAZ");

var $eH30A = parcelRequire("eH30A");

var $6phvH = parcelRequire("6phvH");

var $74aGi = parcelRequire("74aGi");

var $023pJ = parcelRequire("023pJ");

var $2ed24520ccc4d4e7$var$debug = (parcelRequire("bM1Sj"))('socket.io-client:manager');

var $2tKL0 = parcelRequire("2tKL0");

var $6leqr = parcelRequire("6leqr");
/**
 * IE6+ hasOwnProperty
 */ var $2ed24520ccc4d4e7$var$has = Object.prototype.hasOwnProperty;
/**
 * Module exports
 */ module.exports = $2ed24520ccc4d4e7$var$Manager;
/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */ function $2ed24520ccc4d4e7$var$Manager(uri, opts) {
    if (!(this instanceof $2ed24520ccc4d4e7$var$Manager)) return new $2ed24520ccc4d4e7$var$Manager(uri, opts);
    if (uri && 'object' === typeof uri) {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    opts.path = opts.path || '/socket.io';
    this.nsps = {};
    this.subs = [];
    this.opts = opts;
    this.reconnection(opts.reconnection !== false);
    this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
    this.reconnectionDelay(opts.reconnectionDelay || 1000);
    this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
    this.randomizationFactor(opts.randomizationFactor || 0.5);
    this.backoff = new $6leqr({
        min: this.reconnectionDelay(),
        max: this.reconnectionDelayMax(),
        jitter: this.randomizationFactor()
    });
    this.timeout(null == opts.timeout ? 20000 : opts.timeout);
    this.readyState = 'closed';
    this.uri = uri;
    this.connecting = [];
    this.lastPing = null;
    this.encoding = false;
    this.packetBuffer = [];
    var _parser = opts.parser || $6phvH;
    this.encoder = new _parser.Encoder();
    this.decoder = new _parser.Decoder();
    this.autoConnect = opts.autoConnect !== false;
    if (this.autoConnect) this.open();
}
/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.emitAll = function() {
    this.emit.apply(this, arguments);
    for(var nsp in this.nsps)if ($2ed24520ccc4d4e7$var$has.call(this.nsps, nsp)) this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
};
/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.updateSocketIds = function() {
    for(var nsp in this.nsps)if ($2ed24520ccc4d4e7$var$has.call(this.nsps, nsp)) this.nsps[nsp].id = this.generateId(nsp);
};
/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.generateId = function(nsp) {
    return (nsp === '/' ? '' : nsp + '#') + this.engine.id;
};
/**
 * Mix in `Emitter`.
 */ $eH30A($2ed24520ccc4d4e7$var$Manager.prototype);
/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */ $2ed24520ccc4d4e7$var$Manager.prototype.reconnection = function(v) {
    if (!arguments.length) return this._reconnection;
    this._reconnection = !!v;
    return this;
};
/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */ $2ed24520ccc4d4e7$var$Manager.prototype.reconnectionAttempts = function(v) {
    if (!arguments.length) return this._reconnectionAttempts;
    this._reconnectionAttempts = v;
    return this;
};
/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */ $2ed24520ccc4d4e7$var$Manager.prototype.reconnectionDelay = function(v) {
    if (!arguments.length) return this._reconnectionDelay;
    this._reconnectionDelay = v;
    this.backoff && this.backoff.setMin(v);
    return this;
};
$2ed24520ccc4d4e7$var$Manager.prototype.randomizationFactor = function(v) {
    if (!arguments.length) return this._randomizationFactor;
    this._randomizationFactor = v;
    this.backoff && this.backoff.setJitter(v);
    return this;
};
/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */ $2ed24520ccc4d4e7$var$Manager.prototype.reconnectionDelayMax = function(v) {
    if (!arguments.length) return this._reconnectionDelayMax;
    this._reconnectionDelayMax = v;
    this.backoff && this.backoff.setMax(v);
    return this;
};
/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */ $2ed24520ccc4d4e7$var$Manager.prototype.timeout = function(v) {
    if (!arguments.length) return this._timeout;
    this._timeout = v;
    return this;
};
/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.maybeReconnectOnOpen = function() {
    // Only try to reconnect if it's the first time we're connecting
    if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
};
/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */ $2ed24520ccc4d4e7$var$Manager.prototype.open = $2ed24520ccc4d4e7$var$Manager.prototype.connect = function(fn, opts) {
    $2ed24520ccc4d4e7$var$debug('readyState %s', this.readyState);
    if (~this.readyState.indexOf('open')) return this;
    $2ed24520ccc4d4e7$var$debug('opening %s', this.uri);
    this.engine = $9XcnD(this.uri, this.opts);
    var socket = this.engine;
    var self = this;
    this.readyState = 'opening';
    this.skipReconnect = false;
    // emit `open`
    var openSub = $74aGi(socket, 'open', function() {
        self.onopen();
        fn && fn();
    });
    // emit `connect_error`
    var errorSub = $74aGi(socket, 'error', function(data) {
        $2ed24520ccc4d4e7$var$debug('connect_error');
        self.cleanup();
        self.readyState = 'closed';
        self.emitAll('connect_error', data);
        if (fn) {
            var err = new Error('Connection error');
            err.data = data;
            fn(err);
        } else // Only do this if there is no fn to handle the error
        self.maybeReconnectOnOpen();
    });
    // emit `connect_timeout`
    if (false !== this._timeout) {
        var timeout = this._timeout;
        $2ed24520ccc4d4e7$var$debug('connect attempt will timeout after %d', timeout);
        if (timeout === 0) openSub.destroy(); // prevents a race condition with the 'open' event
        // set timer
        var timer = setTimeout(function() {
            $2ed24520ccc4d4e7$var$debug('connect attempt timed out after %d', timeout);
            openSub.destroy();
            socket.close();
            socket.emit('error', 'timeout');
            self.emitAll('connect_timeout', timeout);
        }, timeout);
        this.subs.push({
            destroy: function() {
                clearTimeout(timer);
            }
        });
    }
    this.subs.push(openSub);
    this.subs.push(errorSub);
    return this;
};
/**
 * Called upon transport open.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.onopen = function() {
    $2ed24520ccc4d4e7$var$debug('open');
    // clear old subs
    this.cleanup();
    // mark as open
    this.readyState = 'open';
    this.emit('open');
    // add new subs
    var socket = this.engine;
    this.subs.push($74aGi(socket, 'data', $023pJ(this, 'ondata')));
    this.subs.push($74aGi(socket, 'ping', $023pJ(this, 'onping')));
    this.subs.push($74aGi(socket, 'pong', $023pJ(this, 'onpong')));
    this.subs.push($74aGi(socket, 'error', $023pJ(this, 'onerror')));
    this.subs.push($74aGi(socket, 'close', $023pJ(this, 'onclose')));
    this.subs.push($74aGi(this.decoder, 'decoded', $023pJ(this, 'ondecoded')));
};
/**
 * Called upon a ping.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.onping = function() {
    this.lastPing = new Date();
    this.emitAll('ping');
};
/**
 * Called upon a packet.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.onpong = function() {
    this.emitAll('pong', new Date() - this.lastPing);
};
/**
 * Called with data.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.ondata = function(data) {
    this.decoder.add(data);
};
/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.ondecoded = function(packet) {
    this.emit('packet', packet);
};
/**
 * Called upon socket error.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.onerror = function(err) {
    $2ed24520ccc4d4e7$var$debug('error', err);
    this.emitAll('error', err);
};
/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */ $2ed24520ccc4d4e7$var$Manager.prototype.socket = function(nsp, opts) {
    var socket = this.nsps[nsp];
    if (!socket) {
        socket = new $4HSAZ(this, nsp, opts);
        this.nsps[nsp] = socket;
        var self = this;
        socket.on('connecting', onConnecting);
        socket.on('connect', function() {
            socket.id = self.generateId(nsp);
        });
        if (this.autoConnect) // manually call here since connecting event is fired before listening
        onConnecting();
    }
    function onConnecting() {
        if (!~$2tKL0(self.connecting, socket)) self.connecting.push(socket);
    }
    return socket;
};
/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */ $2ed24520ccc4d4e7$var$Manager.prototype.destroy = function(socket) {
    var index = $2tKL0(this.connecting, socket);
    if (~index) this.connecting.splice(index, 1);
    if (this.connecting.length) return;
    this.close();
};
/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.packet = function(packet) {
    $2ed24520ccc4d4e7$var$debug('writing packet %j', packet);
    var self = this;
    if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
    if (!self.encoding) {
        // encode, then write to engine with result
        self.encoding = true;
        this.encoder.encode(packet, function(encodedPackets) {
            for(var i = 0; i < encodedPackets.length; i++)self.engine.write(encodedPackets[i], packet.options);
            self.encoding = false;
            self.processPacketQueue();
        });
    } else self.packetBuffer.push(packet);
};
/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.processPacketQueue = function() {
    if (this.packetBuffer.length > 0 && !this.encoding) {
        var pack = this.packetBuffer.shift();
        this.packet(pack);
    }
};
/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.cleanup = function() {
    $2ed24520ccc4d4e7$var$debug('cleanup');
    var subsLength = this.subs.length;
    for(var i = 0; i < subsLength; i++){
        var sub = this.subs.shift();
        sub.destroy();
    }
    this.packetBuffer = [];
    this.encoding = false;
    this.lastPing = null;
    this.decoder.destroy();
};
/**
 * Close the current socket.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.close = $2ed24520ccc4d4e7$var$Manager.prototype.disconnect = function() {
    $2ed24520ccc4d4e7$var$debug('disconnect');
    this.skipReconnect = true;
    this.reconnecting = false;
    if ('opening' === this.readyState) // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
    this.backoff.reset();
    this.readyState = 'closed';
    if (this.engine) this.engine.close();
};
/**
 * Called upon engine close.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.onclose = function(reason) {
    $2ed24520ccc4d4e7$var$debug('onclose');
    this.cleanup();
    this.backoff.reset();
    this.readyState = 'closed';
    this.emit('close', reason);
    if (this._reconnection && !this.skipReconnect) this.reconnect();
};
/**
 * Attempt a reconnection.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.reconnect = function() {
    if (this.reconnecting || this.skipReconnect) return this;
    var self = this;
    if (this.backoff.attempts >= this._reconnectionAttempts) {
        $2ed24520ccc4d4e7$var$debug('reconnect failed');
        this.backoff.reset();
        this.emitAll('reconnect_failed');
        this.reconnecting = false;
    } else {
        var delay = this.backoff.duration();
        $2ed24520ccc4d4e7$var$debug('will wait %dms before reconnect attempt', delay);
        this.reconnecting = true;
        var timer = setTimeout(function() {
            if (self.skipReconnect) return;
            $2ed24520ccc4d4e7$var$debug('attempting reconnect');
            self.emitAll('reconnect_attempt', self.backoff.attempts);
            self.emitAll('reconnecting', self.backoff.attempts);
            // check again for the case socket closed in above events
            if (self.skipReconnect) return;
            self.open(function(err) {
                if (err) {
                    $2ed24520ccc4d4e7$var$debug('reconnect attempt error');
                    self.reconnecting = false;
                    self.reconnect();
                    self.emitAll('reconnect_error', err.data);
                } else {
                    $2ed24520ccc4d4e7$var$debug('reconnect success');
                    self.onreconnect();
                }
            });
        }, delay);
        this.subs.push({
            destroy: function() {
                clearTimeout(timer);
            }
        });
    }
};
/**
 * Called upon successful reconnect.
 *
 * @api private
 */ $2ed24520ccc4d4e7$var$Manager.prototype.onreconnect = function() {
    var attempt = this.backoff.attempts;
    this.reconnecting = false;
    this.backoff.reset();
    this.updateSocketIds();
    this.emitAll('reconnect', attempt);
};

});
parcelRegister("9XcnD", function(module, exports) {

module.exports = (parcelRequire("11iUh"));

/**
 * Exports parser
 *
 * @api public
 *
 */ module.exports.parser = (parcelRequire("ePOPf"));

});
parcelRegister("11iUh", function(module, exports) {
/**
 * Module dependencies.
 */ 

var $5vAKJ = parcelRequire("5vAKJ");

var $0be48cf0232b09a2$var$debug = (parcelRequire("lw1zx"))('engine.io-client:socket');

var $2tKL0 = parcelRequire("2tKL0");


var $11NFp = parcelRequire("11NFp");

var $eTGJd = parcelRequire("eTGJd");
/**
 * Module exports.
 */ module.exports = $0be48cf0232b09a2$var$Socket;
/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */ function $0be48cf0232b09a2$var$Socket(uri, opts) {
    if (!(this instanceof $0be48cf0232b09a2$var$Socket)) return new $0be48cf0232b09a2$var$Socket(uri, opts);
    opts = opts || {};
    if (uri && 'object' === typeof uri) {
        opts = uri;
        uri = null;
    }
    if (uri) {
        uri = $11NFp(uri);
        opts.hostname = uri.host;
        opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
        opts.port = uri.port;
        if (uri.query) opts.query = uri.query;
    } else if (opts.host) opts.hostname = $11NFp(opts.host).host;
    this.secure = null != opts.secure ? opts.secure : typeof location !== 'undefined' && 'https:' === location.protocol;
    if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
    this.agent = opts.agent || false;
    this.hostname = opts.hostname || (typeof location !== 'undefined' ? location.hostname : 'localhost');
    this.port = opts.port || (typeof location !== 'undefined' && location.port ? location.port : this.secure ? 443 : 80);
    this.query = opts.query || {};
    if ('string' === typeof this.query) this.query = $eTGJd.decode(this.query);
    this.upgrade = false !== opts.upgrade;
    this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
    this.forceJSONP = !!opts.forceJSONP;
    this.jsonp = false !== opts.jsonp;
    this.forceBase64 = !!opts.forceBase64;
    this.enablesXDR = !!opts.enablesXDR;
    this.withCredentials = false !== opts.withCredentials;
    this.timestampParam = opts.timestampParam || 't';
    this.timestampRequests = opts.timestampRequests;
    this.transports = opts.transports || [
        'polling',
        'websocket'
    ];
    this.transportOptions = opts.transportOptions || {};
    this.readyState = '';
    this.writeBuffer = [];
    this.prevBufferLen = 0;
    this.policyPort = opts.policyPort || 843;
    this.rememberUpgrade = opts.rememberUpgrade || false;
    this.binaryType = null;
    this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
    this.perMessageDeflate = false !== opts.perMessageDeflate ? opts.perMessageDeflate || {} : false;
    if (true === this.perMessageDeflate) this.perMessageDeflate = {};
    if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) this.perMessageDeflate.threshold = 1024;
    // SSL options for Node.js client
    this.pfx = opts.pfx || undefined;
    this.key = opts.key || undefined;
    this.passphrase = opts.passphrase || undefined;
    this.cert = opts.cert || undefined;
    this.ca = opts.ca || undefined;
    this.ciphers = opts.ciphers || undefined;
    this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
    this.forceNode = !!opts.forceNode;
    // detect ReactNative environment
    this.isReactNative = typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative';
    // other options for Node.js or ReactNative client
    if (typeof self === 'undefined' || this.isReactNative) {
        if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) this.extraHeaders = opts.extraHeaders;
        if (opts.localAddress) this.localAddress = opts.localAddress;
    }
    // set on handshake
    this.id = null;
    this.upgrades = null;
    this.pingInterval = null;
    this.pingTimeout = null;
    // set on heartbeat
    this.pingIntervalTimer = null;
    this.pingTimeoutTimer = null;
    this.open();
}
$0be48cf0232b09a2$var$Socket.priorWebsocketSuccess = false;
/**
 * Mix in `Emitter`.
 */ $5vAKJ($0be48cf0232b09a2$var$Socket.prototype);
/**
 * Protocol version.
 *
 * @api public
 */ $0be48cf0232b09a2$var$Socket.protocol = (parcelRequire("ePOPf")).protocol; // this is an int
/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */ $0be48cf0232b09a2$var$Socket.Socket = $0be48cf0232b09a2$var$Socket;

$0be48cf0232b09a2$var$Socket.Transport = (parcelRequire("1kej5"));

$0be48cf0232b09a2$var$Socket.transports = (parcelRequire("2PLP6"));

$0be48cf0232b09a2$var$Socket.parser = (parcelRequire("ePOPf"));
/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.createTransport = function(name) {
    $0be48cf0232b09a2$var$debug('creating transport "%s"', name);
    var query = $0be48cf0232b09a2$var$clone(this.query);
    // append engine.io protocol identifier
    query.EIO = (parcelRequire("ePOPf")).protocol;
    // transport name
    query.transport = name;
    // per-transport options
    var options = this.transportOptions[name] || {};
    // session id if we already have one
    if (this.id) query.sid = this.id;
    var transport = new (parcelRequire("2PLP6"))[name]({
        query: query,
        socket: this,
        agent: options.agent || this.agent,
        hostname: options.hostname || this.hostname,
        port: options.port || this.port,
        secure: options.secure || this.secure,
        path: options.path || this.path,
        forceJSONP: options.forceJSONP || this.forceJSONP,
        jsonp: options.jsonp || this.jsonp,
        forceBase64: options.forceBase64 || this.forceBase64,
        enablesXDR: options.enablesXDR || this.enablesXDR,
        withCredentials: options.withCredentials || this.withCredentials,
        timestampRequests: options.timestampRequests || this.timestampRequests,
        timestampParam: options.timestampParam || this.timestampParam,
        policyPort: options.policyPort || this.policyPort,
        pfx: options.pfx || this.pfx,
        key: options.key || this.key,
        passphrase: options.passphrase || this.passphrase,
        cert: options.cert || this.cert,
        ca: options.ca || this.ca,
        ciphers: options.ciphers || this.ciphers,
        rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
        perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
        extraHeaders: options.extraHeaders || this.extraHeaders,
        forceNode: options.forceNode || this.forceNode,
        localAddress: options.localAddress || this.localAddress,
        requestTimeout: options.requestTimeout || this.requestTimeout,
        protocols: options.protocols || void 0,
        isReactNative: this.isReactNative
    });
    return transport;
};
function $0be48cf0232b09a2$var$clone(obj) {
    var o = {};
    for(var i in obj)if (obj.hasOwnProperty(i)) o[i] = obj[i];
    return o;
}
/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.open = function() {
    var transport;
    if (this.rememberUpgrade && $0be48cf0232b09a2$var$Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) transport = 'websocket';
    else if (0 === this.transports.length) {
        // Emit error on next tick so it can be listened to
        var self1 = this;
        setTimeout(function() {
            self1.emit('error', 'No transports available');
        }, 0);
        return;
    } else transport = this.transports[0];
    this.readyState = 'opening';
    // Retry with the next transport if the transport is disabled (jsonp: false)
    try {
        transport = this.createTransport(transport);
    } catch (e) {
        this.transports.shift();
        this.open();
        return;
    }
    transport.open();
    this.setTransport(transport);
};
/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.setTransport = function(transport) {
    $0be48cf0232b09a2$var$debug('setting transport %s', transport.name);
    var self1 = this;
    if (this.transport) {
        $0be48cf0232b09a2$var$debug('clearing existing transport %s', this.transport.name);
        this.transport.removeAllListeners();
    }
    // set up transport
    this.transport = transport;
    // set up transport listeners
    transport.on('drain', function() {
        self1.onDrain();
    }).on('packet', function(packet) {
        self1.onPacket(packet);
    }).on('error', function(e) {
        self1.onError(e);
    }).on('close', function() {
        self1.onClose('transport close');
    });
};
/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.probe = function(name) {
    $0be48cf0232b09a2$var$debug('probing transport "%s"', name);
    var transport = this.createTransport(name, {
        probe: 1
    });
    var failed = false;
    var self1 = this;
    $0be48cf0232b09a2$var$Socket.priorWebsocketSuccess = false;
    function onTransportOpen() {
        if (self1.onlyBinaryUpgrades) {
            var upgradeLosesBinary = !this.supportsBinary && self1.transport.supportsBinary;
            failed = failed || upgradeLosesBinary;
        }
        if (failed) return;
        $0be48cf0232b09a2$var$debug('probe transport "%s" opened', name);
        transport.send([
            {
                type: 'ping',
                data: 'probe'
            }
        ]);
        transport.once('packet', function(msg) {
            if (failed) return;
            if ('pong' === msg.type && 'probe' === msg.data) {
                $0be48cf0232b09a2$var$debug('probe transport "%s" pong', name);
                self1.upgrading = true;
                self1.emit('upgrading', transport);
                if (!transport) return;
                $0be48cf0232b09a2$var$Socket.priorWebsocketSuccess = 'websocket' === transport.name;
                $0be48cf0232b09a2$var$debug('pausing current transport "%s"', self1.transport.name);
                self1.transport.pause(function() {
                    if (failed) return;
                    if ('closed' === self1.readyState) return;
                    $0be48cf0232b09a2$var$debug('changing transport and sending upgrade packet');
                    cleanup();
                    self1.setTransport(transport);
                    transport.send([
                        {
                            type: 'upgrade'
                        }
                    ]);
                    self1.emit('upgrade', transport);
                    transport = null;
                    self1.upgrading = false;
                    self1.flush();
                });
            } else {
                $0be48cf0232b09a2$var$debug('probe transport "%s" failed', name);
                var err = new Error('probe error');
                err.transport = transport.name;
                self1.emit('upgradeError', err);
            }
        });
    }
    function freezeTransport() {
        if (failed) return;
        // Any callback called by transport should be ignored since now
        failed = true;
        cleanup();
        transport.close();
        transport = null;
    }
    // Handle any error that happens while probing
    function onerror(err) {
        var error = new Error('probe error: ' + err);
        error.transport = transport.name;
        freezeTransport();
        $0be48cf0232b09a2$var$debug('probe transport "%s" failed because of error: %s', name, err);
        self1.emit('upgradeError', error);
    }
    function onTransportClose() {
        onerror('transport closed');
    }
    // When the socket is closed while we're probing
    function onclose() {
        onerror('socket closed');
    }
    // When the socket is upgraded while we're probing
    function onupgrade(to) {
        if (transport && to.name !== transport.name) {
            $0be48cf0232b09a2$var$debug('"%s" works - aborting "%s"', to.name, transport.name);
            freezeTransport();
        }
    }
    // Remove all listeners on the transport and on self
    function cleanup() {
        transport.removeListener('open', onTransportOpen);
        transport.removeListener('error', onerror);
        transport.removeListener('close', onTransportClose);
        self1.removeListener('close', onclose);
        self1.removeListener('upgrading', onupgrade);
    }
    transport.once('open', onTransportOpen);
    transport.once('error', onerror);
    transport.once('close', onTransportClose);
    this.once('close', onclose);
    this.once('upgrading', onupgrade);
    transport.open();
};
/**
 * Called when connection is deemed open.
 *
 * @api public
 */ $0be48cf0232b09a2$var$Socket.prototype.onOpen = function() {
    $0be48cf0232b09a2$var$debug('socket open');
    this.readyState = 'open';
    $0be48cf0232b09a2$var$Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
    this.emit('open');
    this.flush();
    // we check for `readyState` in case an `open`
    // listener already closed the socket
    if ('open' === this.readyState && this.upgrade && this.transport.pause) {
        $0be48cf0232b09a2$var$debug('starting upgrade probes');
        for(var i = 0, l = this.upgrades.length; i < l; i++)this.probe(this.upgrades[i]);
    }
};
/**
 * Handles a packet.
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.onPacket = function(packet) {
    if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
        $0be48cf0232b09a2$var$debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
        this.emit('packet', packet);
        // Socket is live - any packet counts
        this.emit('heartbeat');
        switch(packet.type){
            case 'open':
                this.onHandshake(JSON.parse(packet.data));
                break;
            case 'pong':
                this.setPing();
                this.emit('pong');
                break;
            case 'error':
                var err = new Error('server error');
                err.code = packet.data;
                this.onError(err);
                break;
            case 'message':
                this.emit('data', packet.data);
                this.emit('message', packet.data);
                break;
        }
    } else $0be48cf0232b09a2$var$debug('packet received with socket readyState "%s"', this.readyState);
};
/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.onHandshake = function(data) {
    this.emit('handshake', data);
    this.id = data.sid;
    this.transport.query.sid = data.sid;
    this.upgrades = this.filterUpgrades(data.upgrades);
    this.pingInterval = data.pingInterval;
    this.pingTimeout = data.pingTimeout;
    this.onOpen();
    // In case open handler closes socket
    if ('closed' === this.readyState) return;
    this.setPing();
    // Prolong liveness of socket on heartbeat
    this.removeListener('heartbeat', this.onHeartbeat);
    this.on('heartbeat', this.onHeartbeat);
};
/**
 * Resets ping timeout.
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.onHeartbeat = function(timeout) {
    clearTimeout(this.pingTimeoutTimer);
    var self1 = this;
    self1.pingTimeoutTimer = setTimeout(function() {
        if ('closed' === self1.readyState) return;
        self1.onClose('ping timeout');
    }, timeout || self1.pingInterval + self1.pingTimeout);
};
/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.setPing = function() {
    var self1 = this;
    clearTimeout(self1.pingIntervalTimer);
    self1.pingIntervalTimer = setTimeout(function() {
        $0be48cf0232b09a2$var$debug('writing ping packet - expecting pong within %sms', self1.pingTimeout);
        self1.ping();
        self1.onHeartbeat(self1.pingTimeout);
    }, self1.pingInterval);
};
/**
* Sends a ping packet.
*
* @api private
*/ $0be48cf0232b09a2$var$Socket.prototype.ping = function() {
    var self1 = this;
    this.sendPacket('ping', function() {
        self1.emit('ping');
    });
};
/**
 * Called on `drain` event
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.onDrain = function() {
    this.writeBuffer.splice(0, this.prevBufferLen);
    // setting prevBufferLen = 0 is very important
    // for example, when upgrading, upgrade packet is sent over,
    // and a nonzero prevBufferLen could cause problems on `drain`
    this.prevBufferLen = 0;
    if (0 === this.writeBuffer.length) this.emit('drain');
    else this.flush();
};
/**
 * Flush write buffers.
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.flush = function() {
    if ('closed' !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
        $0be48cf0232b09a2$var$debug('flushing %d packets in socket', this.writeBuffer.length);
        this.transport.send(this.writeBuffer);
        // keep track of current length of writeBuffer
        // splice writeBuffer and callbackBuffer on `drain`
        this.prevBufferLen = this.writeBuffer.length;
        this.emit('flush');
    }
};
/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */ $0be48cf0232b09a2$var$Socket.prototype.write = $0be48cf0232b09a2$var$Socket.prototype.send = function(msg, options, fn) {
    this.sendPacket('message', msg, options, fn);
    return this;
};
/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.sendPacket = function(type, data, options, fn) {
    if ('function' === typeof data) {
        fn = data;
        data = undefined;
    }
    if ('function' === typeof options) {
        fn = options;
        options = null;
    }
    if ('closing' === this.readyState || 'closed' === this.readyState) return;
    options = options || {};
    options.compress = false !== options.compress;
    var packet = {
        type: type,
        data: data,
        options: options
    };
    this.emit('packetCreate', packet);
    this.writeBuffer.push(packet);
    if (fn) this.once('flush', fn);
    this.flush();
};
/**
 * Closes the connection.
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.close = function() {
    if ('opening' === this.readyState || 'open' === this.readyState) {
        this.readyState = 'closing';
        var self1 = this;
        if (this.writeBuffer.length) this.once('drain', function() {
            if (this.upgrading) waitForUpgrade();
            else close();
        });
        else if (this.upgrading) waitForUpgrade();
        else close();
    }
    function close() {
        self1.onClose('forced close');
        $0be48cf0232b09a2$var$debug('socket closing - telling transport to close');
        self1.transport.close();
    }
    function cleanupAndClose() {
        self1.removeListener('upgrade', cleanupAndClose);
        self1.removeListener('upgradeError', cleanupAndClose);
        close();
    }
    function waitForUpgrade() {
        // wait for upgrade to finish since we can't send packets while pausing a transport
        self1.once('upgrade', cleanupAndClose);
        self1.once('upgradeError', cleanupAndClose);
    }
    return this;
};
/**
 * Called upon transport error
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.onError = function(err) {
    $0be48cf0232b09a2$var$debug('socket error %j', err);
    $0be48cf0232b09a2$var$Socket.priorWebsocketSuccess = false;
    this.emit('error', err);
    this.onClose('transport error', err);
};
/**
 * Called upon transport close.
 *
 * @api private
 */ $0be48cf0232b09a2$var$Socket.prototype.onClose = function(reason, desc) {
    if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
        $0be48cf0232b09a2$var$debug('socket close with reason: "%s"', reason);
        var self1 = this;
        // clear timers
        clearTimeout(this.pingIntervalTimer);
        clearTimeout(this.pingTimeoutTimer);
        // stop event from firing again for transport
        this.transport.removeAllListeners('close');
        // ensure transport won't stay open
        this.transport.close();
        // ignore further transport communication
        this.transport.removeAllListeners();
        // set ready state
        this.readyState = 'closed';
        // clear session id
        this.id = null;
        // emit close event
        this.emit('close', reason, desc);
        // clean buffers after, so users can still
        // grab the buffers on `close` event
        self1.writeBuffer = [];
        self1.prevBufferLen = 0;
    }
};
/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */ $0be48cf0232b09a2$var$Socket.prototype.filterUpgrades = function(upgrades) {
    var filteredUpgrades = [];
    for(var i = 0, j = upgrades.length; i < j; i++)if (~$2tKL0(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
    return filteredUpgrades;
};

});
parcelRegister("2PLP6", function(module, exports) {

$parcel$export(module.exports, "polling", () => $210570e73e9b27dc$export$bdbf04fbdcf6ac3c, (v) => $210570e73e9b27dc$export$bdbf04fbdcf6ac3c = v);
$parcel$export(module.exports, "websocket", () => $210570e73e9b27dc$export$3f859614deccc31b, (v) => $210570e73e9b27dc$export$3f859614deccc31b = v);
/**
 * Module dependencies
 */ /**
 * Export transports.
 */ var $210570e73e9b27dc$export$bdbf04fbdcf6ac3c;
var $210570e73e9b27dc$export$3f859614deccc31b;

var $cVOId = parcelRequire("cVOId");

var $6pONJ = parcelRequire("6pONJ");

var $eiqq4 = parcelRequire("eiqq4");

var $4dLfv = parcelRequire("4dLfv");
$210570e73e9b27dc$export$bdbf04fbdcf6ac3c = $210570e73e9b27dc$var$polling;
$210570e73e9b27dc$export$3f859614deccc31b = $4dLfv;
/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */ function $210570e73e9b27dc$var$polling(opts) {
    var xhr;
    var xd = false;
    var xs = false;
    var jsonp = false !== opts.jsonp;
    if (typeof location !== 'undefined') {
        var isSSL = 'https:' === location.protocol;
        var port = location.port;
        // some user agents have empty `location.port`
        if (!port) port = isSSL ? 443 : 80;
        xd = opts.hostname !== location.hostname || port !== opts.port;
        xs = opts.secure !== isSSL;
    }
    opts.xdomain = xd;
    opts.xscheme = xs;
    xhr = new $cVOId(opts);
    if ('open' in xhr && !opts.forceJSONP) return new $6pONJ(opts);
    else {
        if (!jsonp) throw new Error('JSONP disabled');
        return new $eiqq4(opts);
    }
}

});
parcelRegister("cVOId", function(module, exports) {
// browser shim for xmlhttprequest module

var $etUL3 = parcelRequire("etUL3");

var $60qpW = parcelRequire("60qpW");
module.exports = function(opts) {
    var xdomain = opts.xdomain;
    // scheme must be same when usign XDomainRequest
    // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
    var xscheme = opts.xscheme;
    // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
    // https://github.com/Automattic/engine.io-client/pull/217
    var enablesXDR = opts.enablesXDR;
    // XMLHttpRequest can be disabled on IE
    try {
        if ('undefined' !== typeof XMLHttpRequest && (!xdomain || $etUL3)) return new XMLHttpRequest();
    } catch (e) {}
    // Use XDomainRequest for IE8 if enablesXDR is true
    // because loading bar keeps flashing when using jsonp-polling
    // https://github.com/yujiosaka/socke.io-ie8-loading-example
    try {
        if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) return new XDomainRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new $60qpW[[
            'Active'
        ].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) {}
};

});
parcelRegister("etUL3", function(module, exports) {
/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */ try {
    module.exports = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
    module.exports = false;
}

});

parcelRegister("60qpW", function(module, exports) {
module.exports = function() {
    if (typeof self !== 'undefined') return self;
    else if (typeof window !== 'undefined') return window;
    else return Function('return this')(); // eslint-disable-line no-new-func
}();

});


parcelRegister("6pONJ", function(module, exports) {
/* global attachEvent */ /**
 * Module requirements.
 */ 
var $cVOId = parcelRequire("cVOId");

var $bIyRz = parcelRequire("bIyRz");

var $5vAKJ = parcelRequire("5vAKJ");

var $lwW7U = parcelRequire("lwW7U");

var $4abc7be64f481af4$var$debug = (parcelRequire("lw1zx"))('engine.io-client:polling-xhr');

var $60qpW = parcelRequire("60qpW");
/**
 * Module exports.
 */ module.exports = $4abc7be64f481af4$var$XHR;
module.exports.Request = $4abc7be64f481af4$var$Request;
/**
 * Empty function
 */ function $4abc7be64f481af4$var$empty() {}
/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */ function $4abc7be64f481af4$var$XHR(opts) {
    $bIyRz.call(this, opts);
    this.requestTimeout = opts.requestTimeout;
    this.extraHeaders = opts.extraHeaders;
    if (typeof location !== 'undefined') {
        var isSSL = 'https:' === location.protocol;
        var port = location.port;
        // some user agents have empty `location.port`
        if (!port) port = isSSL ? 443 : 80;
        this.xd = typeof location !== 'undefined' && opts.hostname !== location.hostname || port !== opts.port;
        this.xs = opts.secure !== isSSL;
    }
}
/**
 * Inherits from Polling.
 */ $lwW7U($4abc7be64f481af4$var$XHR, $bIyRz);
/**
 * XHR supports binary
 */ $4abc7be64f481af4$var$XHR.prototype.supportsBinary = true;
/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */ $4abc7be64f481af4$var$XHR.prototype.request = function(opts) {
    opts = opts || {};
    opts.uri = this.uri();
    opts.xd = this.xd;
    opts.xs = this.xs;
    opts.agent = this.agent || false;
    opts.supportsBinary = this.supportsBinary;
    opts.enablesXDR = this.enablesXDR;
    opts.withCredentials = this.withCredentials;
    // SSL options for Node.js client
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
    opts.requestTimeout = this.requestTimeout;
    // other options for Node.js client
    opts.extraHeaders = this.extraHeaders;
    return new $4abc7be64f481af4$var$Request(opts);
};
/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */ $4abc7be64f481af4$var$XHR.prototype.doWrite = function(data, fn) {
    var isBinary = typeof data !== 'string' && data !== undefined;
    var req = this.request({
        method: 'POST',
        data: data,
        isBinary: isBinary
    });
    var self = this;
    req.on('success', fn);
    req.on('error', function(err) {
        self.onError('xhr post error', err);
    });
    this.sendXhr = req;
};
/**
 * Starts a poll cycle.
 *
 * @api private
 */ $4abc7be64f481af4$var$XHR.prototype.doPoll = function() {
    $4abc7be64f481af4$var$debug('xhr poll');
    var req = this.request();
    var self = this;
    req.on('data', function(data) {
        self.onData(data);
    });
    req.on('error', function(err) {
        self.onError('xhr poll error', err);
    });
    this.pollXhr = req;
};
/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */ function $4abc7be64f481af4$var$Request(opts) {
    this.method = opts.method || 'GET';
    this.uri = opts.uri;
    this.xd = !!opts.xd;
    this.xs = !!opts.xs;
    this.async = false !== opts.async;
    this.data = undefined !== opts.data ? opts.data : null;
    this.agent = opts.agent;
    this.isBinary = opts.isBinary;
    this.supportsBinary = opts.supportsBinary;
    this.enablesXDR = opts.enablesXDR;
    this.withCredentials = opts.withCredentials;
    this.requestTimeout = opts.requestTimeout;
    // SSL options for Node.js client
    this.pfx = opts.pfx;
    this.key = opts.key;
    this.passphrase = opts.passphrase;
    this.cert = opts.cert;
    this.ca = opts.ca;
    this.ciphers = opts.ciphers;
    this.rejectUnauthorized = opts.rejectUnauthorized;
    // other options for Node.js client
    this.extraHeaders = opts.extraHeaders;
    this.create();
}
/**
 * Mix in `Emitter`.
 */ $5vAKJ($4abc7be64f481af4$var$Request.prototype);
/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */ $4abc7be64f481af4$var$Request.prototype.create = function() {
    var opts = {
        agent: this.agent,
        xdomain: this.xd,
        xscheme: this.xs,
        enablesXDR: this.enablesXDR
    };
    // SSL options for Node.js client
    opts.pfx = this.pfx;
    opts.key = this.key;
    opts.passphrase = this.passphrase;
    opts.cert = this.cert;
    opts.ca = this.ca;
    opts.ciphers = this.ciphers;
    opts.rejectUnauthorized = this.rejectUnauthorized;
    var xhr = this.xhr = new $cVOId(opts);
    var self = this;
    try {
        $4abc7be64f481af4$var$debug('xhr open %s: %s', this.method, this.uri);
        xhr.open(this.method, this.uri, this.async);
        try {
            if (this.extraHeaders) {
                xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                for(var i in this.extraHeaders)if (this.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.extraHeaders[i]);
            }
        } catch (e) {}
        if ('POST' === this.method) try {
            if (this.isBinary) xhr.setRequestHeader('Content-type', 'application/octet-stream');
            else xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        } catch (e) {}
        try {
            xhr.setRequestHeader('Accept', '*/*');
        } catch (e) {}
        // ie6 check
        if ('withCredentials' in xhr) xhr.withCredentials = this.withCredentials;
        if (this.requestTimeout) xhr.timeout = this.requestTimeout;
        if (this.hasXDR()) {
            xhr.onload = function() {
                self.onLoad();
            };
            xhr.onerror = function() {
                self.onError(xhr.responseText);
            };
        } else xhr.onreadystatechange = function() {
            if (xhr.readyState === 2) try {
                var contentType = xhr.getResponseHeader('Content-Type');
                if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') xhr.responseType = 'arraybuffer';
            } catch (e) {}
            if (4 !== xhr.readyState) return;
            if (200 === xhr.status || 1223 === xhr.status) self.onLoad();
            else // make sure the `error` event handler that's user-set
            // does not throw in the same tick and gets caught here
            setTimeout(function() {
                self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
            }, 0);
        };
        $4abc7be64f481af4$var$debug('xhr data %s', this.data);
        xhr.send(this.data);
    } catch (e) {
        // Need to defer since .create() is called directly fhrom the constructor
        // and thus the 'error' event can only be only bound *after* this exception
        // occurs.  Therefore, also, we cannot throw here at all.
        setTimeout(function() {
            self.onError(e);
        }, 0);
        return;
    }
    if (typeof document !== 'undefined') {
        this.index = $4abc7be64f481af4$var$Request.requestsCount++;
        $4abc7be64f481af4$var$Request.requests[this.index] = this;
    }
};
/**
 * Called upon successful response.
 *
 * @api private
 */ $4abc7be64f481af4$var$Request.prototype.onSuccess = function() {
    this.emit('success');
    this.cleanup();
};
/**
 * Called if we have data.
 *
 * @api private
 */ $4abc7be64f481af4$var$Request.prototype.onData = function(data) {
    this.emit('data', data);
    this.onSuccess();
};
/**
 * Called upon error.
 *
 * @api private
 */ $4abc7be64f481af4$var$Request.prototype.onError = function(err) {
    this.emit('error', err);
    this.cleanup(true);
};
/**
 * Cleans up house.
 *
 * @api private
 */ $4abc7be64f481af4$var$Request.prototype.cleanup = function(fromError) {
    if ('undefined' === typeof this.xhr || null === this.xhr) return;
    // xmlhttprequest
    if (this.hasXDR()) this.xhr.onload = this.xhr.onerror = $4abc7be64f481af4$var$empty;
    else this.xhr.onreadystatechange = $4abc7be64f481af4$var$empty;
    if (fromError) try {
        this.xhr.abort();
    } catch (e) {}
    if (typeof document !== 'undefined') delete $4abc7be64f481af4$var$Request.requests[this.index];
    this.xhr = null;
};
/**
 * Called upon load.
 *
 * @api private
 */ $4abc7be64f481af4$var$Request.prototype.onLoad = function() {
    var data;
    try {
        var contentType;
        try {
            contentType = this.xhr.getResponseHeader('Content-Type');
        } catch (e) {}
        if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') data = this.xhr.response || this.xhr.responseText;
        else data = this.xhr.responseText;
    } catch (e) {
        this.onError(e);
    }
    if (null != data) this.onData(data);
};
/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */ $4abc7be64f481af4$var$Request.prototype.hasXDR = function() {
    return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};
/**
 * Aborts the request.
 *
 * @api public
 */ $4abc7be64f481af4$var$Request.prototype.abort = function() {
    this.cleanup();
};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ $4abc7be64f481af4$var$Request.requestsCount = 0;
$4abc7be64f481af4$var$Request.requests = {};
if (typeof document !== 'undefined') {
    if (typeof attachEvent === 'function') attachEvent('onunload', $4abc7be64f481af4$var$unloadHandler);
    else if (typeof addEventListener === 'function') {
        var $4abc7be64f481af4$var$terminationEvent = 'onpagehide' in $60qpW ? 'pagehide' : 'unload';
        addEventListener($4abc7be64f481af4$var$terminationEvent, $4abc7be64f481af4$var$unloadHandler, false);
    }
}
function $4abc7be64f481af4$var$unloadHandler() {
    for(var i in $4abc7be64f481af4$var$Request.requests)if ($4abc7be64f481af4$var$Request.requests.hasOwnProperty(i)) $4abc7be64f481af4$var$Request.requests[i].abort();
}

});
parcelRegister("bIyRz", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $1kej5 = parcelRequire("1kej5");

var $eTGJd = parcelRequire("eTGJd");

var $ePOPf = parcelRequire("ePOPf");

var $lwW7U = parcelRequire("lwW7U");

var $19O1o = parcelRequire("19O1o");

var $887ed8dd11b3fc10$var$debug = (parcelRequire("lw1zx"))('engine.io-client:polling');
/**
 * Module exports.
 */ module.exports = $887ed8dd11b3fc10$var$Polling;

/**
 * Is XHR2 supported?
 */ var $887ed8dd11b3fc10$var$hasXHR2 = function() {
    var XMLHttpRequest = (parcelRequire("cVOId"));
    var xhr = new XMLHttpRequest({
        xdomain: false
    });
    return null != xhr.responseType;
}();
/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */ function $887ed8dd11b3fc10$var$Polling(opts) {
    var forceBase64 = opts && opts.forceBase64;
    if (!$887ed8dd11b3fc10$var$hasXHR2 || forceBase64) this.supportsBinary = false;
    $1kej5.call(this, opts);
}
/**
 * Inherits from Transport.
 */ $lwW7U($887ed8dd11b3fc10$var$Polling, $1kej5);
/**
 * Transport name.
 */ $887ed8dd11b3fc10$var$Polling.prototype.name = 'polling';
/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */ $887ed8dd11b3fc10$var$Polling.prototype.doOpen = function() {
    this.poll();
};
/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */ $887ed8dd11b3fc10$var$Polling.prototype.pause = function(onPause) {
    var self = this;
    this.readyState = 'pausing';
    function pause() {
        $887ed8dd11b3fc10$var$debug('paused');
        self.readyState = 'paused';
        onPause();
    }
    if (this.polling || !this.writable) {
        var total = 0;
        if (this.polling) {
            $887ed8dd11b3fc10$var$debug('we are currently polling - waiting to pause');
            total++;
            this.once('pollComplete', function() {
                $887ed8dd11b3fc10$var$debug('pre-pause polling complete');
                --total || pause();
            });
        }
        if (!this.writable) {
            $887ed8dd11b3fc10$var$debug('we are currently writing - waiting to pause');
            total++;
            this.once('drain', function() {
                $887ed8dd11b3fc10$var$debug('pre-pause writing complete');
                --total || pause();
            });
        }
    } else pause();
};
/**
 * Starts polling cycle.
 *
 * @api public
 */ $887ed8dd11b3fc10$var$Polling.prototype.poll = function() {
    $887ed8dd11b3fc10$var$debug('polling');
    this.polling = true;
    this.doPoll();
    this.emit('poll');
};
/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */ $887ed8dd11b3fc10$var$Polling.prototype.onData = function(data) {
    var self = this;
    $887ed8dd11b3fc10$var$debug('polling got data %s', data);
    var callback = function(packet, index, total) {
        // if its the first message we consider the transport open
        if ('opening' === self.readyState && packet.type === 'open') self.onOpen();
        // if its a close packet, we close the ongoing requests
        if ('close' === packet.type) {
            self.onClose();
            return false;
        }
        // otherwise bypass onData and handle the message
        self.onPacket(packet);
    };
    // decode payload
    $ePOPf.decodePayload(data, this.socket.binaryType, callback);
    // if an event did not trigger closing
    if ('closed' !== this.readyState) {
        // if we got data we're not polling
        this.polling = false;
        this.emit('pollComplete');
        if ('open' === this.readyState) this.poll();
        else $887ed8dd11b3fc10$var$debug('ignoring poll - transport state "%s"', this.readyState);
    }
};
/**
 * For polling, send a close packet.
 *
 * @api private
 */ $887ed8dd11b3fc10$var$Polling.prototype.doClose = function() {
    var self = this;
    function close() {
        $887ed8dd11b3fc10$var$debug('writing close packet');
        self.write([
            {
                type: 'close'
            }
        ]);
    }
    if ('open' === this.readyState) {
        $887ed8dd11b3fc10$var$debug('transport open - closing');
        close();
    } else {
        // in case we're trying to close while
        // handshaking is in progress (GH-164)
        $887ed8dd11b3fc10$var$debug('transport not open - deferring close');
        this.once('open', close);
    }
};
/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */ $887ed8dd11b3fc10$var$Polling.prototype.write = function(packets) {
    var self = this;
    this.writable = false;
    var callbackfn = function() {
        self.writable = true;
        self.emit('drain');
    };
    $ePOPf.encodePayload(packets, this.supportsBinary, function(data) {
        self.doWrite(data, callbackfn);
    });
};
/**
 * Generates uri for connection.
 *
 * @api private
 */ $887ed8dd11b3fc10$var$Polling.prototype.uri = function() {
    var query = this.query || {};
    var schema = this.secure ? 'https' : 'http';
    var port = '';
    // cache busting is forced
    if (false !== this.timestampRequests) query[this.timestampParam] = $19O1o();
    if (!this.supportsBinary && !query.sid) query.b64 = 1;
    query = $eTGJd.encode(query);
    // avoid port if default for schema
    if (this.port && ('https' === schema && Number(this.port) !== 443 || 'http' === schema && Number(this.port) !== 80)) port = ':' + this.port;
    // prepend ? to query
    if (query.length) query = '?' + query;
    var ipv6 = this.hostname.indexOf(':') !== -1;
    return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

});
parcelRegister("1kej5", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $ePOPf = parcelRequire("ePOPf");

var $5vAKJ = parcelRequire("5vAKJ");
/**
 * Module exports.
 */ module.exports = $0f72c1c449ad07d8$var$Transport;
/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */ function $0f72c1c449ad07d8$var$Transport(opts) {
    this.path = opts.path;
    this.hostname = opts.hostname;
    this.port = opts.port;
    this.secure = opts.secure;
    this.query = opts.query;
    this.timestampParam = opts.timestampParam;
    this.timestampRequests = opts.timestampRequests;
    this.readyState = '';
    this.agent = opts.agent || false;
    this.socket = opts.socket;
    this.enablesXDR = opts.enablesXDR;
    this.withCredentials = opts.withCredentials;
    // SSL options for Node.js client
    this.pfx = opts.pfx;
    this.key = opts.key;
    this.passphrase = opts.passphrase;
    this.cert = opts.cert;
    this.ca = opts.ca;
    this.ciphers = opts.ciphers;
    this.rejectUnauthorized = opts.rejectUnauthorized;
    this.forceNode = opts.forceNode;
    // results of ReactNative environment detection
    this.isReactNative = opts.isReactNative;
    // other options for Node.js client
    this.extraHeaders = opts.extraHeaders;
    this.localAddress = opts.localAddress;
}
/**
 * Mix in `Emitter`.
 */ $5vAKJ($0f72c1c449ad07d8$var$Transport.prototype);
/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */ $0f72c1c449ad07d8$var$Transport.prototype.onError = function(msg, desc) {
    var err = new Error(msg);
    err.type = 'TransportError';
    err.description = desc;
    this.emit('error', err);
    return this;
};
/**
 * Opens the transport.
 *
 * @api public
 */ $0f72c1c449ad07d8$var$Transport.prototype.open = function() {
    if ('closed' === this.readyState || '' === this.readyState) {
        this.readyState = 'opening';
        this.doOpen();
    }
    return this;
};
/**
 * Closes the transport.
 *
 * @api private
 */ $0f72c1c449ad07d8$var$Transport.prototype.close = function() {
    if ('opening' === this.readyState || 'open' === this.readyState) {
        this.doClose();
        this.onClose();
    }
    return this;
};
/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */ $0f72c1c449ad07d8$var$Transport.prototype.send = function(packets) {
    if ('open' === this.readyState) this.write(packets);
    else throw new Error('Transport not open');
};
/**
 * Called upon open
 *
 * @api private
 */ $0f72c1c449ad07d8$var$Transport.prototype.onOpen = function() {
    this.readyState = 'open';
    this.writable = true;
    this.emit('open');
};
/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */ $0f72c1c449ad07d8$var$Transport.prototype.onData = function(data) {
    var packet = $ePOPf.decodePacket(data, this.socket.binaryType);
    this.onPacket(packet);
};
/**
 * Called with a decoded packet.
 */ $0f72c1c449ad07d8$var$Transport.prototype.onPacket = function(packet) {
    this.emit('packet', packet);
};
/**
 * Called upon close.
 *
 * @api private
 */ $0f72c1c449ad07d8$var$Transport.prototype.onClose = function() {
    this.readyState = 'closed';
    this.emit('close');
};

});
parcelRegister("ePOPf", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $accd4108108d1692$export$a51d6b395ff4c65a, (v) => $accd4108108d1692$export$a51d6b395ff4c65a = v);
$parcel$export(module.exports, "packets", () => $accd4108108d1692$export$8cec925cdbc069a3, (v) => $accd4108108d1692$export$8cec925cdbc069a3 = v);
$parcel$export(module.exports, "encodePacket", () => $accd4108108d1692$export$57852049361a8e62, (v) => $accd4108108d1692$export$57852049361a8e62 = v);
$parcel$export(module.exports, "encodeBase64Packet", () => $accd4108108d1692$export$1224bd349343a780, (v) => $accd4108108d1692$export$1224bd349343a780 = v);
$parcel$export(module.exports, "decodePacket", () => $accd4108108d1692$export$4647901878f33f31, (v) => $accd4108108d1692$export$4647901878f33f31 = v);
$parcel$export(module.exports, "decodeBase64Packet", () => $accd4108108d1692$export$d8083abc502764be, (v) => $accd4108108d1692$export$d8083abc502764be = v);
$parcel$export(module.exports, "encodePayload", () => $accd4108108d1692$export$144d64fe58dad441, (v) => $accd4108108d1692$export$144d64fe58dad441 = v);
$parcel$export(module.exports, "encodePayloadAsBlob", () => $accd4108108d1692$export$189405ab6c76376a, (v) => $accd4108108d1692$export$189405ab6c76376a = v);
$parcel$export(module.exports, "encodePayloadAsArrayBuffer", () => $accd4108108d1692$export$ae2b9d31affbcbb7, (v) => $accd4108108d1692$export$ae2b9d31affbcbb7 = v);
$parcel$export(module.exports, "decodePayload", () => $accd4108108d1692$export$d10cc2e7f7566a2d, (v) => $accd4108108d1692$export$d10cc2e7f7566a2d = v);
$parcel$export(module.exports, "decodePayloadAsBinary", () => $accd4108108d1692$export$94d8cc1d96592971, (v) => $accd4108108d1692$export$94d8cc1d96592971 = v);
/**
 * Module dependencies.
 */ /**
 * Current protocol version.
 */ var $accd4108108d1692$export$a51d6b395ff4c65a;
var $accd4108108d1692$export$8cec925cdbc069a3;
/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */ var $accd4108108d1692$export$57852049361a8e62;
/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */ var $accd4108108d1692$export$1224bd349343a780;
/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */ var $accd4108108d1692$export$4647901878f33f31;
/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */ var $accd4108108d1692$export$d8083abc502764be;
/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */ var $accd4108108d1692$export$144d64fe58dad441;
/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */ var $accd4108108d1692$export$d10cc2e7f7566a2d;
/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */ var $accd4108108d1692$export$ae2b9d31affbcbb7;
/**
 * Encode as Blob
 */ var $accd4108108d1692$export$189405ab6c76376a;
/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */ var $accd4108108d1692$export$94d8cc1d96592971;

var $7jARb = parcelRequire("7jARb");

var $gdWW9 = parcelRequire("gdWW9");

var $iYIi6 = parcelRequire("iYIi6");

var $efn43 = parcelRequire("efn43");

var $44Z8I = parcelRequire("44Z8I");
var $accd4108108d1692$var$base64encoder;

if (typeof ArrayBuffer !== 'undefined') $accd4108108d1692$var$base64encoder = (parcelRequire("gb2Nb"));
/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */ var $accd4108108d1692$var$isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */ var $accd4108108d1692$var$isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */ var $accd4108108d1692$var$dontSendBlobs = $accd4108108d1692$var$isAndroid || $accd4108108d1692$var$isPhantomJS;
$accd4108108d1692$export$a51d6b395ff4c65a = 3;
/**
 * Packet types.
 */ var $accd4108108d1692$var$packets = $accd4108108d1692$export$8cec925cdbc069a3 = {
    open: 0 // non-ws
    ,
    close: 1 // non-ws
    ,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
};
var $accd4108108d1692$var$packetslist = $7jARb($accd4108108d1692$var$packets);
/**
 * Premade error packet.
 */ var $accd4108108d1692$var$err = {
    type: 'error',
    data: 'parser error'
};

var $kjZ7o = parcelRequire("kjZ7o");
$accd4108108d1692$export$57852049361a8e62 = function(packet, supportsBinary, utf8encode, callback) {
    if (typeof supportsBinary === 'function') {
        callback = supportsBinary;
        supportsBinary = false;
    }
    if (typeof utf8encode === 'function') {
        callback = utf8encode;
        utf8encode = null;
    }
    var data = packet.data === undefined ? undefined : packet.data.buffer || packet.data;
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $accd4108108d1692$var$encodeArrayBuffer(packet, supportsBinary, callback);
    else if (typeof $kjZ7o !== 'undefined' && data instanceof $kjZ7o) return $accd4108108d1692$var$encodeBlob(packet, supportsBinary, callback);
    // might be an object with { base64: true, data: dataAsBase64String }
    if (data && data.base64) return $accd4108108d1692$var$encodeBase64Object(packet, callback);
    // Sending data as a utf-8 string
    var encoded = $accd4108108d1692$var$packets[packet.type];
    // data fragment is optional
    if (undefined !== packet.data) encoded += utf8encode ? $44Z8I.encode(String(packet.data), {
        strict: false
    }) : String(packet.data);
    return callback('' + encoded);
};
function $accd4108108d1692$var$encodeBase64Object(packet, callback) {
    // packet data is an object { base64: true, data: dataAsBase64String }
    var message = 'b' + $accd4108108d1692$export$8cec925cdbc069a3[packet.type] + packet.data.data;
    return callback(message);
}
/**
 * Encode packet helpers for binary types
 */ function $accd4108108d1692$var$encodeArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) return $accd4108108d1692$export$1224bd349343a780(packet, callback);
    var data = packet.data;
    var contentArray = new Uint8Array(data);
    var resultBuffer = new Uint8Array(1 + data.byteLength);
    resultBuffer[0] = $accd4108108d1692$var$packets[packet.type];
    for(var i = 0; i < contentArray.length; i++)resultBuffer[i + 1] = contentArray[i];
    return callback(resultBuffer.buffer);
}
function $accd4108108d1692$var$encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
    if (!supportsBinary) return $accd4108108d1692$export$1224bd349343a780(packet, callback);
    var fr = new FileReader();
    fr.onload = function() {
        $accd4108108d1692$export$57852049361a8e62({
            type: packet.type,
            data: fr.result
        }, supportsBinary, true, callback);
    };
    return fr.readAsArrayBuffer(packet.data);
}
function $accd4108108d1692$var$encodeBlob(packet, supportsBinary, callback) {
    if (!supportsBinary) return $accd4108108d1692$export$1224bd349343a780(packet, callback);
    if ($accd4108108d1692$var$dontSendBlobs) return $accd4108108d1692$var$encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
    var length = new Uint8Array(1);
    length[0] = $accd4108108d1692$var$packets[packet.type];
    var blob = new $kjZ7o([
        length.buffer,
        packet.data
    ]);
    return callback(blob);
}
$accd4108108d1692$export$1224bd349343a780 = function(packet, callback) {
    var message = 'b' + $accd4108108d1692$export$8cec925cdbc069a3[packet.type];
    if (typeof $kjZ7o !== 'undefined' && packet.data instanceof $kjZ7o) {
        var fr = new FileReader();
        fr.onload = function() {
            var b64 = fr.result.split(',')[1];
            callback(message + b64);
        };
        return fr.readAsDataURL(packet.data);
    }
    var b64data;
    try {
        b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
    } catch (e) {
        // iPhone Safari doesn't let you apply with typed arrays
        var typed = new Uint8Array(packet.data);
        var basic = new Array(typed.length);
        for(var i = 0; i < typed.length; i++)basic[i] = typed[i];
        b64data = String.fromCharCode.apply(null, basic);
    }
    message += btoa(b64data);
    return callback(message);
};
$accd4108108d1692$export$4647901878f33f31 = function(data, binaryType, utf8decode) {
    if (data === undefined) return $accd4108108d1692$var$err;
    // String data
    if (typeof data === 'string') {
        if (data.charAt(0) === 'b') return $accd4108108d1692$export$d8083abc502764be(data.substr(1), binaryType);
        if (utf8decode) {
            data = $accd4108108d1692$var$tryDecode(data);
            if (data === false) return $accd4108108d1692$var$err;
        }
        var type = data.charAt(0);
        if (Number(type) != type || !$accd4108108d1692$var$packetslist[type]) return $accd4108108d1692$var$err;
        if (data.length > 1) return {
            type: $accd4108108d1692$var$packetslist[type],
            data: data.substring(1)
        };
        else return {
            type: $accd4108108d1692$var$packetslist[type]
        };
    }
    var asArray = new Uint8Array(data);
    var type = asArray[0];
    var rest = $iYIi6(data, 1);
    if ($kjZ7o && binaryType === 'blob') rest = new $kjZ7o([
        rest
    ]);
    return {
        type: $accd4108108d1692$var$packetslist[type],
        data: rest
    };
};
function $accd4108108d1692$var$tryDecode(data) {
    try {
        data = $44Z8I.decode(data, {
            strict: false
        });
    } catch (e) {
        return false;
    }
    return data;
}
$accd4108108d1692$export$d8083abc502764be = function(msg, binaryType) {
    var type = $accd4108108d1692$var$packetslist[msg.charAt(0)];
    if (!$accd4108108d1692$var$base64encoder) return {
        type: type,
        data: {
            base64: true,
            data: msg.substr(1)
        }
    };
    var data = $accd4108108d1692$var$base64encoder.decode(msg.substr(1));
    if (binaryType === 'blob' && $kjZ7o) data = new $kjZ7o([
        data
    ]);
    return {
        type: type,
        data: data
    };
};
$accd4108108d1692$export$144d64fe58dad441 = function(packets, supportsBinary, callback) {
    if (typeof supportsBinary === 'function') {
        callback = supportsBinary;
        supportsBinary = null;
    }
    var isBinary = $gdWW9(packets);
    if (supportsBinary && isBinary) {
        if ($kjZ7o && !$accd4108108d1692$var$dontSendBlobs) return $accd4108108d1692$export$189405ab6c76376a(packets, callback);
        return $accd4108108d1692$export$ae2b9d31affbcbb7(packets, callback);
    }
    if (!packets.length) return callback('0:');
    function setLengthHeader(message) {
        return message.length + ':' + message;
    }
    function encodeOne(packet, doneCallback) {
        $accd4108108d1692$export$57852049361a8e62(packet, !isBinary ? false : supportsBinary, false, function(message) {
            doneCallback(null, setLengthHeader(message));
        });
    }
    $accd4108108d1692$var$map(packets, encodeOne, function(err, results) {
        return callback(results.join(''));
    });
};
/**
 * Async array map using after
 */ function $accd4108108d1692$var$map(ary, each, done) {
    var result = new Array(ary.length);
    var next = $efn43(ary.length, done);
    var eachWithIndex = function(i, el, cb) {
        each(el, function(error, msg) {
            result[i] = msg;
            cb(error, result);
        });
    };
    for(var i = 0; i < ary.length; i++)eachWithIndex(i, ary[i], next);
}
$accd4108108d1692$export$d10cc2e7f7566a2d = function(data, binaryType, callback) {
    if (typeof data !== 'string') return $accd4108108d1692$export$94d8cc1d96592971(data, binaryType, callback);
    if (typeof binaryType === 'function') {
        callback = binaryType;
        binaryType = null;
    }
    var packet;
    if (data === '') // parser error - ignoring payload
    return callback($accd4108108d1692$var$err, 0, 1);
    var length = '', n, msg;
    for(var i = 0, l = data.length; i < l; i++){
        var chr = data.charAt(i);
        if (chr !== ':') {
            length += chr;
            continue;
        }
        if (length === '' || length != (n = Number(length))) // parser error - ignoring payload
        return callback($accd4108108d1692$var$err, 0, 1);
        msg = data.substr(i + 1, n);
        if (length != msg.length) // parser error - ignoring payload
        return callback($accd4108108d1692$var$err, 0, 1);
        if (msg.length) {
            packet = $accd4108108d1692$export$4647901878f33f31(msg, binaryType, false);
            if ($accd4108108d1692$var$err.type === packet.type && $accd4108108d1692$var$err.data === packet.data) // parser error in individual packet - ignoring payload
            return callback($accd4108108d1692$var$err, 0, 1);
            var ret = callback(packet, i + n, l);
            if (false === ret) return;
        }
        // advance cursor
        i += n;
        length = '';
    }
    if (length !== '') // parser error - ignoring payload
    return callback($accd4108108d1692$var$err, 0, 1);
};
$accd4108108d1692$export$ae2b9d31affbcbb7 = function(packets, callback) {
    if (!packets.length) return callback(new ArrayBuffer(0));
    function encodeOne(packet, doneCallback) {
        $accd4108108d1692$export$57852049361a8e62(packet, true, true, function(data) {
            return doneCallback(null, data);
        });
    }
    $accd4108108d1692$var$map(packets, encodeOne, function(err, encodedPackets) {
        var totalLength = encodedPackets.reduce(function(acc, p) {
            var len;
            if (typeof p === 'string') len = p.length;
            else len = p.byteLength;
            return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
        }, 0);
        var resultArray = new Uint8Array(totalLength);
        var bufferIndex = 0;
        encodedPackets.forEach(function(p) {
            var isString = typeof p === 'string';
            var ab = p;
            if (isString) {
                var view = new Uint8Array(p.length);
                for(var i = 0; i < p.length; i++)view[i] = p.charCodeAt(i);
                ab = view.buffer;
            }
            if (isString) resultArray[bufferIndex++] = 0;
            else resultArray[bufferIndex++] = 1;
            var lenStr = ab.byteLength.toString();
            for(var i = 0; i < lenStr.length; i++)resultArray[bufferIndex++] = parseInt(lenStr[i]);
            resultArray[bufferIndex++] = 255;
            var view = new Uint8Array(ab);
            for(var i = 0; i < view.length; i++)resultArray[bufferIndex++] = view[i];
        });
        return callback(resultArray.buffer);
    });
};
$accd4108108d1692$export$189405ab6c76376a = function(packets, callback) {
    function encodeOne(packet, doneCallback) {
        $accd4108108d1692$export$57852049361a8e62(packet, true, true, function(encoded) {
            var binaryIdentifier = new Uint8Array(1);
            binaryIdentifier[0] = 1;
            if (typeof encoded === 'string') {
                var view = new Uint8Array(encoded.length);
                for(var i = 0; i < encoded.length; i++)view[i] = encoded.charCodeAt(i);
                encoded = view.buffer;
                binaryIdentifier[0] = 0;
            }
            var len = encoded instanceof ArrayBuffer ? encoded.byteLength : encoded.size;
            var lenStr = len.toString();
            var lengthAry = new Uint8Array(lenStr.length + 1);
            for(var i = 0; i < lenStr.length; i++)lengthAry[i] = parseInt(lenStr[i]);
            lengthAry[lenStr.length] = 255;
            if ($kjZ7o) {
                var blob = new $kjZ7o([
                    binaryIdentifier.buffer,
                    lengthAry.buffer,
                    encoded
                ]);
                doneCallback(null, blob);
            }
        });
    }
    $accd4108108d1692$var$map(packets, encodeOne, function(err, results) {
        return callback(new $kjZ7o(results));
    });
};
$accd4108108d1692$export$94d8cc1d96592971 = function(data, binaryType, callback) {
    if (typeof binaryType === 'function') {
        callback = binaryType;
        binaryType = null;
    }
    var bufferTail = data;
    var buffers = [];
    while(bufferTail.byteLength > 0){
        var tailArray = new Uint8Array(bufferTail);
        var isString = tailArray[0] === 0;
        var msgLength = '';
        for(var i = 1;; i++){
            if (tailArray[i] === 255) break;
            // 310 = char length of Number.MAX_VALUE
            if (msgLength.length > 310) return callback($accd4108108d1692$var$err, 0, 1);
            msgLength += tailArray[i];
        }
        bufferTail = $iYIi6(bufferTail, 2 + msgLength.length);
        msgLength = parseInt(msgLength);
        var msg = $iYIi6(bufferTail, 0, msgLength);
        if (isString) try {
            msg = String.fromCharCode.apply(null, new Uint8Array(msg));
        } catch (e) {
            // iPhone Safari doesn't let you apply to typed arrays
            var typed = new Uint8Array(msg);
            msg = '';
            for(var i = 0; i < typed.length; i++)msg += String.fromCharCode(typed[i]);
        }
        buffers.push(msg);
        bufferTail = $iYIi6(bufferTail, msgLength);
    }
    var total = buffers.length;
    buffers.forEach(function(buffer, i) {
        callback($accd4108108d1692$export$4647901878f33f31(buffer, binaryType, true), i, total);
    });
};

});
parcelRegister("7jARb", function(module, exports) {
/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */ module.exports = Object.keys || function keys(obj) {
    var arr = [];
    var has = Object.prototype.hasOwnProperty;
    for(var i in obj)if (has.call(obj, i)) arr.push(i);
    return arr;
};

});

parcelRegister("gdWW9", function(module, exports) {
/* global Blob File */ /*
 * Module requirements.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $bcfb93e5fff67d36$require$Buffer = $6ZWSX.Buffer;

var $2i48Z = parcelRequire("2i48Z");
var $bcfb93e5fff67d36$var$toString = Object.prototype.toString;
var $bcfb93e5fff67d36$var$withNativeBlob = typeof Blob === 'function' || typeof Blob !== 'undefined' && $bcfb93e5fff67d36$var$toString.call(Blob) === '[object BlobConstructor]';
var $bcfb93e5fff67d36$var$withNativeFile = typeof File === 'function' || typeof File !== 'undefined' && $bcfb93e5fff67d36$var$toString.call(File) === '[object FileConstructor]';
/**
 * Module exports.
 */ module.exports = $bcfb93e5fff67d36$var$hasBinary;
/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */ function $bcfb93e5fff67d36$var$hasBinary(obj) {
    if (!obj || typeof obj !== 'object') return false;
    if ($2i48Z(obj)) {
        for(var i = 0, l = obj.length; i < l; i++){
            if ($bcfb93e5fff67d36$var$hasBinary(obj[i])) return true;
        }
        return false;
    }
    if (typeof $bcfb93e5fff67d36$require$Buffer === 'function' && $bcfb93e5fff67d36$require$Buffer.isBuffer && $bcfb93e5fff67d36$require$Buffer.isBuffer(obj) || typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer || $bcfb93e5fff67d36$var$withNativeBlob && obj instanceof Blob || $bcfb93e5fff67d36$var$withNativeFile && obj instanceof File) return true;
    // see: https://github.com/Automattic/has-binary/pull/4
    if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) return $bcfb93e5fff67d36$var$hasBinary(obj.toJSON(), true);
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $bcfb93e5fff67d36$var$hasBinary(obj[key])) return true;
    }
    return false;
}

});
parcelRegister("2i48Z", function(module, exports) {
var $1ab07a1b26cb7b7e$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $1ab07a1b26cb7b7e$var$toString.call(arr) == '[object Array]';
};

});


parcelRegister("iYIi6", function(module, exports) {
/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */ module.exports = function(arraybuffer, start, end) {
    var bytes = arraybuffer.byteLength;
    start = start || 0;
    end = end || bytes;
    if (arraybuffer.slice) return arraybuffer.slice(start, end);
    if (start < 0) start += bytes;
    if (end < 0) end += bytes;
    if (end > bytes) end = bytes;
    if (start >= bytes || start >= end || bytes === 0) return new ArrayBuffer(0);
    var abv = new Uint8Array(arraybuffer);
    var result = new Uint8Array(end - start);
    for(var i = start, ii = 0; i < end; i++, ii++)result[ii] = abv[i];
    return result.buffer;
};

});

parcelRegister("efn43", function(module, exports) {
module.exports = $a5f45b8091796175$var$after;
function $a5f45b8091796175$var$after(count, callback, err_cb) {
    var bail = false;
    err_cb = err_cb || $a5f45b8091796175$var$noop;
    proxy.count = count;
    return count === 0 ? callback() : proxy;
    function proxy(err, result) {
        if (proxy.count <= 0) throw new Error('after called too many times');
        --proxy.count;
        // after first error, rest are passed to err_cb
        if (err) {
            bail = true;
            callback(err);
            // future error callbacks will go to error handler
            callback = err_cb;
        } else if (proxy.count === 0 && !bail) callback(null, result);
    }
}
function $a5f45b8091796175$var$noop() {}

});

parcelRegister("44Z8I", function(module, exports) {
/*! https://mths.be/utf8js v2.1.2 by @mathias */ var $2f86f6347e978f96$var$stringFromCharCode = String.fromCharCode;
// Taken from https://mths.be/punycode
function $2f86f6347e978f96$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    var value;
    var extra;
    while(counter < length){
        value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // high surrogate, and there is a next character
            extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // unmatched surrogate; only append this code unit, in case the next
                // code unit is the high surrogate of a surrogate pair
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
// Taken from https://mths.be/punycode
function $2f86f6347e978f96$var$ucs2encode(array) {
    var length = array.length;
    var index = -1;
    var value;
    var output = '';
    while(++index < length){
        value = array[index];
        if (value > 0xFFFF) {
            value -= 0x10000;
            output += $2f86f6347e978f96$var$stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
            value = 0xDC00 | value & 0x3FF;
        }
        output += $2f86f6347e978f96$var$stringFromCharCode(value);
    }
    return output;
}
function $2f86f6347e978f96$var$checkScalarValue(codePoint, strict) {
    if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
        if (strict) throw Error('Lone surrogate U+' + codePoint.toString(16).toUpperCase() + ' is not a scalar value');
        return false;
    }
    return true;
}
/*--------------------------------------------------------------------------*/ function $2f86f6347e978f96$var$createByte(codePoint, shift) {
    return $2f86f6347e978f96$var$stringFromCharCode(codePoint >> shift & 0x3F | 0x80);
}
function $2f86f6347e978f96$var$encodeCodePoint(codePoint, strict) {
    if ((codePoint & 0xFFFFFF80) == 0) return $2f86f6347e978f96$var$stringFromCharCode(codePoint);
    var symbol = '';
    if ((codePoint & 0xFFFFF800) == 0) symbol = $2f86f6347e978f96$var$stringFromCharCode(codePoint >> 6 & 0x1F | 0xC0);
    else if ((codePoint & 0xFFFF0000) == 0) {
        if (!$2f86f6347e978f96$var$checkScalarValue(codePoint, strict)) codePoint = 0xFFFD;
        symbol = $2f86f6347e978f96$var$stringFromCharCode(codePoint >> 12 & 0x0F | 0xE0);
        symbol += $2f86f6347e978f96$var$createByte(codePoint, 6);
    } else if ((codePoint & 0xFFE00000) == 0) {
        symbol = $2f86f6347e978f96$var$stringFromCharCode(codePoint >> 18 & 0x07 | 0xF0);
        symbol += $2f86f6347e978f96$var$createByte(codePoint, 12);
        symbol += $2f86f6347e978f96$var$createByte(codePoint, 6);
    }
    symbol += $2f86f6347e978f96$var$stringFromCharCode(codePoint & 0x3F | 0x80);
    return symbol;
}
function $2f86f6347e978f96$var$utf8encode(string, opts) {
    opts = opts || {};
    var strict = false !== opts.strict;
    var codePoints = $2f86f6347e978f96$var$ucs2decode(string);
    var length = codePoints.length;
    var index = -1;
    var codePoint;
    var byteString = '';
    while(++index < length){
        codePoint = codePoints[index];
        byteString += $2f86f6347e978f96$var$encodeCodePoint(codePoint, strict);
    }
    return byteString;
}
/*--------------------------------------------------------------------------*/ function $2f86f6347e978f96$var$readContinuationByte() {
    if ($2f86f6347e978f96$var$byteIndex >= $2f86f6347e978f96$var$byteCount) throw Error('Invalid byte index');
    var continuationByte = $2f86f6347e978f96$var$byteArray[$2f86f6347e978f96$var$byteIndex] & 0xFF;
    $2f86f6347e978f96$var$byteIndex++;
    if ((continuationByte & 0xC0) == 0x80) return continuationByte & 0x3F;
    // If we end up here, it’s not a continuation byte
    throw Error('Invalid continuation byte');
}
function $2f86f6347e978f96$var$decodeSymbol(strict) {
    var byte1;
    var byte2;
    var byte3;
    var byte4;
    var codePoint;
    if ($2f86f6347e978f96$var$byteIndex > $2f86f6347e978f96$var$byteCount) throw Error('Invalid byte index');
    if ($2f86f6347e978f96$var$byteIndex == $2f86f6347e978f96$var$byteCount) return false;
    // Read first byte
    byte1 = $2f86f6347e978f96$var$byteArray[$2f86f6347e978f96$var$byteIndex] & 0xFF;
    $2f86f6347e978f96$var$byteIndex++;
    // 1-byte sequence (no continuation bytes)
    if ((byte1 & 0x80) == 0) return byte1;
    // 2-byte sequence
    if ((byte1 & 0xE0) == 0xC0) {
        byte2 = $2f86f6347e978f96$var$readContinuationByte();
        codePoint = (byte1 & 0x1F) << 6 | byte2;
        if (codePoint >= 0x80) return codePoint;
        else throw Error('Invalid continuation byte');
    }
    // 3-byte sequence (may include unpaired surrogates)
    if ((byte1 & 0xF0) == 0xE0) {
        byte2 = $2f86f6347e978f96$var$readContinuationByte();
        byte3 = $2f86f6347e978f96$var$readContinuationByte();
        codePoint = (byte1 & 0x0F) << 12 | byte2 << 6 | byte3;
        if (codePoint >= 0x0800) return $2f86f6347e978f96$var$checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
        else throw Error('Invalid continuation byte');
    }
    // 4-byte sequence
    if ((byte1 & 0xF8) == 0xF0) {
        byte2 = $2f86f6347e978f96$var$readContinuationByte();
        byte3 = $2f86f6347e978f96$var$readContinuationByte();
        byte4 = $2f86f6347e978f96$var$readContinuationByte();
        codePoint = (byte1 & 0x07) << 0x12 | byte2 << 0x0C | byte3 << 0x06 | byte4;
        if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) return codePoint;
    }
    throw Error('Invalid UTF-8 detected');
}
var $2f86f6347e978f96$var$byteArray;
var $2f86f6347e978f96$var$byteCount;
var $2f86f6347e978f96$var$byteIndex;
function $2f86f6347e978f96$var$utf8decode(byteString, opts) {
    opts = opts || {};
    var strict = false !== opts.strict;
    $2f86f6347e978f96$var$byteArray = $2f86f6347e978f96$var$ucs2decode(byteString);
    $2f86f6347e978f96$var$byteCount = $2f86f6347e978f96$var$byteArray.length;
    $2f86f6347e978f96$var$byteIndex = 0;
    var codePoints = [];
    var tmp;
    while((tmp = $2f86f6347e978f96$var$decodeSymbol(strict)) !== false)codePoints.push(tmp);
    return $2f86f6347e978f96$var$ucs2encode(codePoints);
}
module.exports = {
    version: '2.1.2',
    encode: $2f86f6347e978f96$var$utf8encode,
    decode: $2f86f6347e978f96$var$utf8decode
};

});

parcelRegister("gb2Nb", function(module, exports) {

$parcel$export(module.exports, "encode", () => $bc6fd6e764745ccf$export$c564cdbbe6da493, (v) => $bc6fd6e764745ccf$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $bc6fd6e764745ccf$export$2f872c0f2117be69, (v) => $bc6fd6e764745ccf$export$2f872c0f2117be69 = v);
var $bc6fd6e764745ccf$export$c564cdbbe6da493;
var $bc6fd6e764745ccf$export$2f872c0f2117be69;
/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ (function(chars) {
    "use strict";
    $bc6fd6e764745ccf$export$c564cdbbe6da493 = function(arraybuffer) {
        var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
        for(i = 0; i < len; i += 3){
            base64 += chars[bytes[i] >> 2];
            base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
            base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
            base64 += chars[bytes[i + 2] & 63];
        }
        if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
        else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
        return base64;
    };
    $bc6fd6e764745ccf$export$2f872c0f2117be69 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
        for(i = 0; i < len; i += 4){
            encoded1 = chars.indexOf(base64[i]);
            encoded2 = chars.indexOf(base64[i + 1]);
            encoded3 = chars.indexOf(base64[i + 2]);
            encoded4 = chars.indexOf(base64[i + 3]);
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return arraybuffer;
    };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");

});

parcelRegister("kjZ7o", function(module, exports) {
/**
 * Create a blob builder even when vendor prefixes exist
 */ var $ecb4fdd3be6ba171$var$BlobBuilder = typeof $ecb4fdd3be6ba171$var$BlobBuilder !== 'undefined' ? $ecb4fdd3be6ba171$var$BlobBuilder : typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : false;
/**
 * Check if Blob constructor is supported
 */ var $ecb4fdd3be6ba171$var$blobSupported = function() {
    try {
        var a = new Blob([
            'hi'
        ]);
        return a.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */ var $ecb4fdd3be6ba171$var$blobSupportsArrayBufferView = $ecb4fdd3be6ba171$var$blobSupported && function() {
    try {
        var b = new Blob([
            new Uint8Array([
                1,
                2
            ])
        ]);
        return b.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if BlobBuilder is supported
 */ var $ecb4fdd3be6ba171$var$blobBuilderSupported = $ecb4fdd3be6ba171$var$BlobBuilder && $ecb4fdd3be6ba171$var$BlobBuilder.prototype.append && $ecb4fdd3be6ba171$var$BlobBuilder.prototype.getBlob;
/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */ function $ecb4fdd3be6ba171$var$mapArrayBufferViews(ary) {
    return ary.map(function(chunk) {
        if (chunk.buffer instanceof ArrayBuffer) {
            var buf = chunk.buffer;
            // if this is a subarray, make a copy so we only
            // include the subarray region from the underlying buffer
            if (chunk.byteLength !== buf.byteLength) {
                var copy = new Uint8Array(chunk.byteLength);
                copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
                buf = copy.buffer;
            }
            return buf;
        }
        return chunk;
    });
}
function $ecb4fdd3be6ba171$var$BlobBuilderConstructor(ary, options) {
    options = options || {};
    var bb = new $ecb4fdd3be6ba171$var$BlobBuilder();
    $ecb4fdd3be6ba171$var$mapArrayBufferViews(ary).forEach(function(part) {
        bb.append(part);
    });
    return options.type ? bb.getBlob(options.type) : bb.getBlob();
}
function $ecb4fdd3be6ba171$var$BlobConstructor(ary, options) {
    return new Blob($ecb4fdd3be6ba171$var$mapArrayBufferViews(ary), options || {});
}
if (typeof Blob !== 'undefined') {
    $ecb4fdd3be6ba171$var$BlobBuilderConstructor.prototype = Blob.prototype;
    $ecb4fdd3be6ba171$var$BlobConstructor.prototype = Blob.prototype;
}
module.exports = function() {
    if ($ecb4fdd3be6ba171$var$blobSupported) return $ecb4fdd3be6ba171$var$blobSupportsArrayBufferView ? Blob : $ecb4fdd3be6ba171$var$BlobConstructor;
    else if ($ecb4fdd3be6ba171$var$blobBuilderSupported) return $ecb4fdd3be6ba171$var$BlobBuilderConstructor;
    else return undefined;
}();

});


parcelRegister("5vAKJ", function(module, exports) {
/**
 * Expose `Emitter`.
 */ module.exports = $402c5b5899fac7f8$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $402c5b5899fac7f8$var$Emitter(obj) {
    if (obj) return $402c5b5899fac7f8$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $402c5b5899fac7f8$var$mixin(obj) {
    for(var key in $402c5b5899fac7f8$var$Emitter.prototype)obj[key] = $402c5b5899fac7f8$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $402c5b5899fac7f8$var$Emitter.prototype.on = $402c5b5899fac7f8$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $402c5b5899fac7f8$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $402c5b5899fac7f8$var$Emitter.prototype.off = $402c5b5899fac7f8$var$Emitter.prototype.removeListener = $402c5b5899fac7f8$var$Emitter.prototype.removeAllListeners = $402c5b5899fac7f8$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $402c5b5899fac7f8$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $402c5b5899fac7f8$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $402c5b5899fac7f8$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});


parcelRegister("eTGJd", function(module, exports) {

$parcel$export(module.exports, "encode", () => $ad8758b6be953cdb$export$c564cdbbe6da493, (v) => $ad8758b6be953cdb$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $ad8758b6be953cdb$export$2f872c0f2117be69, (v) => $ad8758b6be953cdb$export$2f872c0f2117be69 = v);
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ var $ad8758b6be953cdb$export$c564cdbbe6da493;
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */ var $ad8758b6be953cdb$export$2f872c0f2117be69;
$ad8758b6be953cdb$export$c564cdbbe6da493 = function(obj) {
    var str = '';
    for(var i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
};
$ad8758b6be953cdb$export$2f872c0f2117be69 = function(qs) {
    var qry = {};
    var pairs = qs.split('&');
    for(var i = 0, l = pairs.length; i < l; i++){
        var pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
};

});

parcelRegister("lwW7U", function(module, exports) {
module.exports = function(a, b) {
    var fn = function() {};
    fn.prototype = b.prototype;
    a.prototype = new fn;
    a.prototype.constructor = a;
};

});

parcelRegister("19O1o", function(module, exports) {
'use strict';
var $0d7d6eede8e58089$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $0d7d6eede8e58089$var$length = 64, $0d7d6eede8e58089$var$map = {}, $0d7d6eede8e58089$var$seed = 0, $0d7d6eede8e58089$var$i = 0, $0d7d6eede8e58089$var$prev;
/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */ function $0d7d6eede8e58089$var$encode(num) {
    var encoded = '';
    do {
        encoded = $0d7d6eede8e58089$var$alphabet[num % $0d7d6eede8e58089$var$length] + encoded;
        num = Math.floor(num / $0d7d6eede8e58089$var$length);
    }while (num > 0);
    return encoded;
}
/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */ function $0d7d6eede8e58089$var$decode(str) {
    var decoded = 0;
    for($0d7d6eede8e58089$var$i = 0; $0d7d6eede8e58089$var$i < str.length; $0d7d6eede8e58089$var$i++)decoded = decoded * $0d7d6eede8e58089$var$length + $0d7d6eede8e58089$var$map[str.charAt($0d7d6eede8e58089$var$i)];
    return decoded;
}
/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */ function $0d7d6eede8e58089$var$yeast() {
    var now = $0d7d6eede8e58089$var$encode(+new Date());
    if (now !== $0d7d6eede8e58089$var$prev) return $0d7d6eede8e58089$var$seed = 0, $0d7d6eede8e58089$var$prev = now;
    return now + '.' + $0d7d6eede8e58089$var$encode($0d7d6eede8e58089$var$seed++);
}
//
// Map each character to its index.
//
for(; $0d7d6eede8e58089$var$i < $0d7d6eede8e58089$var$length; $0d7d6eede8e58089$var$i++)$0d7d6eede8e58089$var$map[$0d7d6eede8e58089$var$alphabet[$0d7d6eede8e58089$var$i]] = $0d7d6eede8e58089$var$i;
//
// Expose the `yeast`, `encode` and `decode` functions.
//
$0d7d6eede8e58089$var$yeast.encode = $0d7d6eede8e58089$var$encode;
$0d7d6eede8e58089$var$yeast.decode = $0d7d6eede8e58089$var$decode;
module.exports = $0d7d6eede8e58089$var$yeast;

});

parcelRegister("lw1zx", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
var $hPtJY = parcelRequire("hPtJY");

exports = module.exports = (parcelRequire("khuW3"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $hPtJY !== 'undefined' && 'env' in $hPtJY) r = undefined;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("khuW3", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("9sQKO"));
/**
 * Active `debug` instances.
 */ exports.instances = [];
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    var prevTime;
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    exports.instances.push(debug);
    return debug;
}
function destroy() {
    var index = exports.instances.indexOf(this);
    if (index !== -1) {
        exports.instances.splice(index, 1);
        return true;
    } else return false;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
    for(i = 0; i < exports.instances.length; i++){
        var instance = exports.instances[i];
        instance.enabled = exports.enabled(instance.namespace);
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    if (name[name.length - 1] === '*') return true;
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("9sQKO", function(module, exports) {
/**
 * Helpers.
 */ var $6e3fa66a115b9252$var$s = 1000;
var $6e3fa66a115b9252$var$m = $6e3fa66a115b9252$var$s * 60;
var $6e3fa66a115b9252$var$h = $6e3fa66a115b9252$var$m * 60;
var $6e3fa66a115b9252$var$d = $6e3fa66a115b9252$var$h * 24;
var $6e3fa66a115b9252$var$y = $6e3fa66a115b9252$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $6e3fa66a115b9252$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $6e3fa66a115b9252$var$fmtLong(val) : $6e3fa66a115b9252$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $6e3fa66a115b9252$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $6e3fa66a115b9252$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $6e3fa66a115b9252$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $6e3fa66a115b9252$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $6e3fa66a115b9252$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $6e3fa66a115b9252$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $6e3fa66a115b9252$var$fmtShort(ms) {
    if (ms >= $6e3fa66a115b9252$var$d) return Math.round(ms / $6e3fa66a115b9252$var$d) + 'd';
    if (ms >= $6e3fa66a115b9252$var$h) return Math.round(ms / $6e3fa66a115b9252$var$h) + 'h';
    if (ms >= $6e3fa66a115b9252$var$m) return Math.round(ms / $6e3fa66a115b9252$var$m) + 'm';
    if (ms >= $6e3fa66a115b9252$var$s) return Math.round(ms / $6e3fa66a115b9252$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $6e3fa66a115b9252$var$fmtLong(ms) {
    return $6e3fa66a115b9252$var$plural(ms, $6e3fa66a115b9252$var$d, 'day') || $6e3fa66a115b9252$var$plural(ms, $6e3fa66a115b9252$var$h, 'hour') || $6e3fa66a115b9252$var$plural(ms, $6e3fa66a115b9252$var$m, 'minute') || $6e3fa66a115b9252$var$plural(ms, $6e3fa66a115b9252$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $6e3fa66a115b9252$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});





parcelRegister("eiqq4", function(module, exports) {
/**
 * Module requirements.
 */ 
var $bIyRz = parcelRequire("bIyRz");

var $lwW7U = parcelRequire("lwW7U");

var $60qpW = parcelRequire("60qpW");
/**
 * Module exports.
 */ module.exports = $a6873d77ac1a5de7$var$JSONPPolling;
/**
 * Cached regular expressions.
 */ var $a6873d77ac1a5de7$var$rNewline = /\n/g;
var $a6873d77ac1a5de7$var$rEscapedNewline = /\\n/g;
/**
 * Global JSONP callbacks.
 */ var $a6873d77ac1a5de7$var$callbacks;
/**
 * Noop.
 */ function $a6873d77ac1a5de7$var$empty() {}
/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */ function $a6873d77ac1a5de7$var$JSONPPolling(opts) {
    $bIyRz.call(this, opts);
    this.query = this.query || {};
    // define global callbacks array if not present
    // we do this here (lazily) to avoid unneeded global pollution
    if (!$a6873d77ac1a5de7$var$callbacks) // we need to consider multiple engines in the same page
    $a6873d77ac1a5de7$var$callbacks = $60qpW.___eio = $60qpW.___eio || [];
    // callback identifier
    this.index = $a6873d77ac1a5de7$var$callbacks.length;
    // add callback to jsonp global
    var self = this;
    $a6873d77ac1a5de7$var$callbacks.push(function(msg) {
        self.onData(msg);
    });
    // append to query string
    this.query.j = this.index;
    // prevent spurious errors from being emitted when the window is unloaded
    if (typeof addEventListener === 'function') addEventListener('beforeunload', function() {
        if (self.script) self.script.onerror = $a6873d77ac1a5de7$var$empty;
    }, false);
}
/**
 * Inherits from Polling.
 */ $lwW7U($a6873d77ac1a5de7$var$JSONPPolling, $bIyRz);
/*
 * JSONP only supports binary as base64 encoded strings
 */ $a6873d77ac1a5de7$var$JSONPPolling.prototype.supportsBinary = false;
/**
 * Closes the socket.
 *
 * @api private
 */ $a6873d77ac1a5de7$var$JSONPPolling.prototype.doClose = function() {
    if (this.script) {
        this.script.parentNode.removeChild(this.script);
        this.script = null;
    }
    if (this.form) {
        this.form.parentNode.removeChild(this.form);
        this.form = null;
        this.iframe = null;
    }
    $bIyRz.prototype.doClose.call(this);
};
/**
 * Starts a poll cycle.
 *
 * @api private
 */ $a6873d77ac1a5de7$var$JSONPPolling.prototype.doPoll = function() {
    var self = this;
    var script = document.createElement('script');
    if (this.script) {
        this.script.parentNode.removeChild(this.script);
        this.script = null;
    }
    script.async = true;
    script.src = this.uri();
    script.onerror = function(e) {
        self.onError('jsonp poll error', e);
    };
    var insertAt = document.getElementsByTagName('script')[0];
    if (insertAt) insertAt.parentNode.insertBefore(script, insertAt);
    else (document.head || document.body).appendChild(script);
    this.script = script;
    var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
    if (isUAgecko) setTimeout(function() {
        var iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        document.body.removeChild(iframe);
    }, 100);
};
/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */ $a6873d77ac1a5de7$var$JSONPPolling.prototype.doWrite = function(data, fn) {
    var self = this;
    if (!this.form) {
        var form = document.createElement('form');
        var area = document.createElement('textarea');
        var id = this.iframeId = 'eio_iframe_' + this.index;
        var iframe;
        form.className = 'socketio';
        form.style.position = 'absolute';
        form.style.top = '-1000px';
        form.style.left = '-1000px';
        form.target = id;
        form.method = 'POST';
        form.setAttribute('accept-charset', 'utf-8');
        area.name = 'd';
        form.appendChild(area);
        document.body.appendChild(form);
        this.form = form;
        this.area = area;
    }
    this.form.action = this.uri();
    function complete() {
        initIframe();
        fn();
    }
    function initIframe() {
        if (self.iframe) try {
            self.form.removeChild(self.iframe);
        } catch (e) {
            self.onError('jsonp polling iframe removal error', e);
        }
        try {
            // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
            var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
            iframe = document.createElement(html);
        } catch (e) {
            iframe = document.createElement('iframe');
            iframe.name = self.iframeId;
            iframe.src = 'javascript:0';
        }
        iframe.id = self.iframeId;
        self.form.appendChild(iframe);
        self.iframe = iframe;
    }
    initIframe();
    // escape \n to prevent it from being converted into \r\n by some UAs
    // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
    data = data.replace($a6873d77ac1a5de7$var$rEscapedNewline, '\\\n');
    this.area.value = data.replace($a6873d77ac1a5de7$var$rNewline, '\\n');
    try {
        this.form.submit();
    } catch (e) {}
    if (this.iframe.attachEvent) this.iframe.onreadystatechange = function() {
        if (self.iframe.readyState === 'complete') complete();
    };
    else this.iframe.onload = complete;
};

});

parcelRegister("4dLfv", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $312d070085ce2390$require$Buffer = $6ZWSX.Buffer;

var $1kej5 = parcelRequire("1kej5");

var $ePOPf = parcelRequire("ePOPf");

var $eTGJd = parcelRequire("eTGJd");

var $lwW7U = parcelRequire("lwW7U");

var $19O1o = parcelRequire("19O1o");

var $312d070085ce2390$var$debug = (parcelRequire("lw1zx"))('engine.io-client:websocket');
var $312d070085ce2390$var$BrowserWebSocket, $312d070085ce2390$var$NodeWebSocket;
if (typeof WebSocket !== 'undefined') $312d070085ce2390$var$BrowserWebSocket = WebSocket;
else if (typeof self !== 'undefined') $312d070085ce2390$var$BrowserWebSocket = self.WebSocket || self.MozWebSocket;

if (typeof window === 'undefined') try {
    $312d070085ce2390$var$NodeWebSocket = (parcelRequire("kjyEk"));
} catch (e) {}
/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */ var $312d070085ce2390$var$WebSocketImpl = $312d070085ce2390$var$BrowserWebSocket || $312d070085ce2390$var$NodeWebSocket;
/**
 * Module exports.
 */ module.exports = $312d070085ce2390$var$WS;
/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */ function $312d070085ce2390$var$WS(opts) {
    var forceBase64 = opts && opts.forceBase64;
    if (forceBase64) this.supportsBinary = false;
    this.perMessageDeflate = opts.perMessageDeflate;
    this.usingBrowserWebSocket = $312d070085ce2390$var$BrowserWebSocket && !opts.forceNode;
    this.protocols = opts.protocols;
    if (!this.usingBrowserWebSocket) $312d070085ce2390$var$WebSocketImpl = $312d070085ce2390$var$NodeWebSocket;
    $1kej5.call(this, opts);
}
/**
 * Inherits from Transport.
 */ $lwW7U($312d070085ce2390$var$WS, $1kej5);
/**
 * Transport name.
 *
 * @api public
 */ $312d070085ce2390$var$WS.prototype.name = 'websocket';
/*
 * WebSockets support binary
 */ $312d070085ce2390$var$WS.prototype.supportsBinary = true;
/**
 * Opens socket.
 *
 * @api private
 */ $312d070085ce2390$var$WS.prototype.doOpen = function() {
    if (!this.check()) // let probe timeout
    return;
    var uri = this.uri();
    var protocols = this.protocols;
    var opts = {};
    if (!this.isReactNative) {
        opts.agent = this.agent;
        opts.perMessageDeflate = this.perMessageDeflate;
        // SSL options for Node.js client
        opts.pfx = this.pfx;
        opts.key = this.key;
        opts.passphrase = this.passphrase;
        opts.cert = this.cert;
        opts.ca = this.ca;
        opts.ciphers = this.ciphers;
        opts.rejectUnauthorized = this.rejectUnauthorized;
    }
    if (this.extraHeaders) opts.headers = this.extraHeaders;
    if (this.localAddress) opts.localAddress = this.localAddress;
    try {
        this.ws = this.usingBrowserWebSocket && !this.isReactNative ? protocols ? new $312d070085ce2390$var$WebSocketImpl(uri, protocols) : new $312d070085ce2390$var$WebSocketImpl(uri) : new $312d070085ce2390$var$WebSocketImpl(uri, protocols, opts);
    } catch (err) {
        return this.emit('error', err);
    }
    if (this.ws.binaryType === undefined) this.supportsBinary = false;
    if (this.ws.supports && this.ws.supports.binary) {
        this.supportsBinary = true;
        this.ws.binaryType = 'nodebuffer';
    } else this.ws.binaryType = 'arraybuffer';
    this.addEventListeners();
};
/**
 * Adds event listeners to the socket
 *
 * @api private
 */ $312d070085ce2390$var$WS.prototype.addEventListeners = function() {
    var self1 = this;
    this.ws.onopen = function() {
        self1.onOpen();
    };
    this.ws.onclose = function() {
        self1.onClose();
    };
    this.ws.onmessage = function(ev) {
        self1.onData(ev.data);
    };
    this.ws.onerror = function(e) {
        self1.onError('websocket error', e);
    };
};
/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */ $312d070085ce2390$var$WS.prototype.write = function(packets) {
    var self1 = this;
    this.writable = false;
    // encodePacket efficient as it uses WS framing
    // no need for encodePayload
    var total = packets.length;
    for(var i = 0, l = total; i < l; i++)(function(packet) {
        $ePOPf.encodePacket(packet, self1.supportsBinary, function(data) {
            if (!self1.usingBrowserWebSocket) {
                // always create a new object (GH-437)
                var opts = {};
                if (packet.options) opts.compress = packet.options.compress;
                if (self1.perMessageDeflate) {
                    var len = 'string' === typeof data ? $312d070085ce2390$require$Buffer.byteLength(data) : data.length;
                    if (len < self1.perMessageDeflate.threshold) opts.compress = false;
                }
            }
            // Sometimes the websocket has already been closed but the browser didn't
            // have a chance of informing us about it yet, in that case send will
            // throw an error
            try {
                if (self1.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                self1.ws.send(data);
                else self1.ws.send(data, opts);
            } catch (e) {
                $312d070085ce2390$var$debug('websocket closed before onclose event');
            }
            --total || done();
        });
    })(packets[i]);
    function done() {
        self1.emit('flush');
        // fake drain
        // defer to next tick to allow Socket to clear writeBuffer
        setTimeout(function() {
            self1.writable = true;
            self1.emit('drain');
        }, 0);
    }
};
/**
 * Called upon close
 *
 * @api private
 */ $312d070085ce2390$var$WS.prototype.onClose = function() {
    $1kej5.prototype.onClose.call(this);
};
/**
 * Closes socket.
 *
 * @api private
 */ $312d070085ce2390$var$WS.prototype.doClose = function() {
    if (typeof this.ws !== 'undefined') this.ws.close();
};
/**
 * Generates uri for connection.
 *
 * @api private
 */ $312d070085ce2390$var$WS.prototype.uri = function() {
    var query = this.query || {};
    var schema = this.secure ? 'wss' : 'ws';
    var port = '';
    // avoid port if default for schema
    if (this.port && ('wss' === schema && Number(this.port) !== 443 || 'ws' === schema && Number(this.port) !== 80)) port = ':' + this.port;
    // append timestamp to URI
    if (this.timestampRequests) query[this.timestampParam] = $19O1o();
    // communicate binary support capabilities
    if (!this.supportsBinary) query.b64 = 1;
    query = $eTGJd.encode(query);
    // prepend ? to query
    if (query.length) query = '?' + query;
    var ipv6 = this.hostname.indexOf(':') !== -1;
    return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};
/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */ $312d070085ce2390$var$WS.prototype.check = function() {
    return !!$312d070085ce2390$var$WebSocketImpl && !('__initialize' in $312d070085ce2390$var$WebSocketImpl && this.name === $312d070085ce2390$var$WS.prototype.name);
};

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("2tKL0", function(module, exports) {
var $1ce28f30370cf6c8$var$indexOf = [].indexOf;
module.exports = function(arr, obj) {
    if ($1ce28f30370cf6c8$var$indexOf) return arr.indexOf(obj);
    for(var i = 0; i < arr.length; ++i){
        if (arr[i] === obj) return i;
    }
    return -1;
};

});



parcelRegister("4HSAZ", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $6phvH = parcelRequire("6phvH");

var $eH30A = parcelRequire("eH30A");

var $4MsGS = parcelRequire("4MsGS");

var $74aGi = parcelRequire("74aGi");

var $023pJ = parcelRequire("023pJ");

var debug = (parcelRequire("bM1Sj"))('socket.io-client:socket');

var $eTGJd = parcelRequire("eTGJd");

var $gdWW9 = parcelRequire("gdWW9");
/**
 * Module exports.
 */ module.exports = exports = Socket;
/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */ var events = {
    connect: 1,
    connect_error: 1,
    connect_timeout: 1,
    connecting: 1,
    disconnect: 1,
    error: 1,
    reconnect: 1,
    reconnect_attempt: 1,
    reconnect_failed: 1,
    reconnect_error: 1,
    reconnecting: 1,
    ping: 1,
    pong: 1
};
/**
 * Shortcut to `Emitter#emit`.
 */ var emit = $eH30A.prototype.emit;
/**
 * `Socket` constructor.
 *
 * @api public
 */ function Socket(io, nsp, opts) {
    this.io = io;
    this.nsp = nsp;
    this.json = this; // compat
    this.ids = 0;
    this.acks = {};
    this.receiveBuffer = [];
    this.sendBuffer = [];
    this.connected = false;
    this.disconnected = true;
    this.flags = {};
    if (opts && opts.query) this.query = opts.query;
    if (this.io.autoConnect) this.open();
}
/**
 * Mix in `Emitter`.
 */ $eH30A(Socket.prototype);
/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */ Socket.prototype.subEvents = function() {
    if (this.subs) return;
    var io = this.io;
    this.subs = [
        $74aGi(io, 'open', $023pJ(this, 'onopen')),
        $74aGi(io, 'packet', $023pJ(this, 'onpacket')),
        $74aGi(io, 'close', $023pJ(this, 'onclose'))
    ];
};
/**
 * "Opens" the socket.
 *
 * @api public
 */ Socket.prototype.open = Socket.prototype.connect = function() {
    if (this.connected) return this;
    this.subEvents();
    if (!this.io.reconnecting) this.io.open(); // ensure open
    if ('open' === this.io.readyState) this.onopen();
    this.emit('connecting');
    return this;
};
/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */ Socket.prototype.send = function() {
    var args = $4MsGS(arguments);
    args.unshift('message');
    this.emit.apply(this, args);
    return this;
};
/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */ Socket.prototype.emit = function(ev) {
    if (events.hasOwnProperty(ev)) {
        emit.apply(this, arguments);
        return this;
    }
    var args = $4MsGS(arguments);
    var packet = {
        type: (this.flags.binary !== undefined ? this.flags.binary : $gdWW9(args)) ? $6phvH.BINARY_EVENT : $6phvH.EVENT,
        data: args
    };
    packet.options = {};
    packet.options.compress = !this.flags || false !== this.flags.compress;
    // event ack callback
    if ('function' === typeof args[args.length - 1]) {
        debug('emitting packet with ack id %d', this.ids);
        this.acks[this.ids] = args.pop();
        packet.id = this.ids++;
    }
    if (this.connected) this.packet(packet);
    else this.sendBuffer.push(packet);
    this.flags = {};
    return this;
};
/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.packet = function(packet) {
    packet.nsp = this.nsp;
    this.io.packet(packet);
};
/**
 * Called upon engine `open`.
 *
 * @api private
 */ Socket.prototype.onopen = function() {
    debug('transport is open - connecting');
    // write connect packet if necessary
    if ('/' !== this.nsp) {
        if (this.query) {
            var query = typeof this.query === 'object' ? $eTGJd.encode(this.query) : this.query;
            debug('sending connect packet with query %s', query);
            this.packet({
                type: $6phvH.CONNECT,
                query: query
            });
        } else this.packet({
            type: $6phvH.CONNECT
        });
    }
};
/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */ Socket.prototype.onclose = function(reason) {
    debug('close (%s)', reason);
    this.connected = false;
    this.disconnected = true;
    delete this.id;
    this.emit('disconnect', reason);
};
/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.onpacket = function(packet) {
    var sameNamespace = packet.nsp === this.nsp;
    var rootNamespaceError = packet.type === $6phvH.ERROR && packet.nsp === '/';
    if (!sameNamespace && !rootNamespaceError) return;
    switch(packet.type){
        case $6phvH.CONNECT:
            this.onconnect();
            break;
        case $6phvH.EVENT:
            this.onevent(packet);
            break;
        case $6phvH.BINARY_EVENT:
            this.onevent(packet);
            break;
        case $6phvH.ACK:
            this.onack(packet);
            break;
        case $6phvH.BINARY_ACK:
            this.onack(packet);
            break;
        case $6phvH.DISCONNECT:
            this.ondisconnect();
            break;
        case $6phvH.ERROR:
            this.emit('error', packet.data);
            break;
    }
};
/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.onevent = function(packet) {
    var args = packet.data || [];
    debug('emitting event %j', args);
    if (null != packet.id) {
        debug('attaching ack callback to event');
        args.push(this.ack(packet.id));
    }
    if (this.connected) emit.apply(this, args);
    else this.receiveBuffer.push(args);
};
/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */ Socket.prototype.ack = function(id) {
    var self = this;
    var sent = false;
    return function() {
        // prevent double callbacks
        if (sent) return;
        sent = true;
        var args = $4MsGS(arguments);
        debug('sending ack %j', args);
        self.packet({
            type: $gdWW9(args) ? $6phvH.BINARY_ACK : $6phvH.ACK,
            id: id,
            data: args
        });
    };
};
/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */ Socket.prototype.onack = function(packet) {
    var ack = this.acks[packet.id];
    if ('function' === typeof ack) {
        debug('calling ack %s with %j', packet.id, packet.data);
        ack.apply(this, packet.data);
        delete this.acks[packet.id];
    } else debug('bad ack %s', packet.id);
};
/**
 * Called upon server connect.
 *
 * @api private
 */ Socket.prototype.onconnect = function() {
    this.connected = true;
    this.disconnected = false;
    this.emitBuffered();
    this.emit('connect');
};
/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */ Socket.prototype.emitBuffered = function() {
    var i;
    for(i = 0; i < this.receiveBuffer.length; i++)emit.apply(this, this.receiveBuffer[i]);
    this.receiveBuffer = [];
    for(i = 0; i < this.sendBuffer.length; i++)this.packet(this.sendBuffer[i]);
    this.sendBuffer = [];
};
/**
 * Called upon server disconnect.
 *
 * @api private
 */ Socket.prototype.ondisconnect = function() {
    debug('server disconnect (%s)', this.nsp);
    this.destroy();
    this.onclose('io server disconnect');
};
/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */ Socket.prototype.destroy = function() {
    if (this.subs) {
        // clean subscriptions to avoid reconnections
        for(var i = 0; i < this.subs.length; i++)this.subs[i].destroy();
        this.subs = null;
    }
    this.io.destroy(this);
};
/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */ Socket.prototype.close = Socket.prototype.disconnect = function() {
    if (this.connected) {
        debug('performing disconnect (%s)', this.nsp);
        this.packet({
            type: $6phvH.DISCONNECT
        });
    }
    // remove socket from pool
    this.destroy();
    if (this.connected) // fire events
    this.onclose('io client disconnect');
    return this;
};
/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */ Socket.prototype.compress = function(compress) {
    this.flags.compress = compress;
    return this;
};
/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */ Socket.prototype.binary = function(binary) {
    this.flags.binary = binary;
    return this;
};

});
parcelRegister("4MsGS", function(module, exports) {
module.exports = $37b1e67c2c95c8db$var$toArray;
function $37b1e67c2c95c8db$var$toArray(list, index) {
    var array = [];
    index = index || 0;
    for(var i = index || 0; i < list.length; i++)array[i - index] = list[i];
    return array;
}

});

parcelRegister("74aGi", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $5251312e215c7c54$var$on;
/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */ function $5251312e215c7c54$var$on(obj, ev, fn) {
    obj.on(ev, fn);
    return {
        destroy: function() {
            obj.removeListener(ev, fn);
        }
    };
}

});

parcelRegister("023pJ", function(module, exports) {
/**
 * Slice reference.
 */ var $0062d5fe14b31e58$var$slice = [].slice;
/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */ module.exports = function(obj, fn) {
    if ('string' == typeof fn) fn = obj[fn];
    if ('function' != typeof fn) throw new Error('bind() requires a function');
    var args = $0062d5fe14b31e58$var$slice.call(arguments, 2);
    return function() {
        return fn.apply(obj, args.concat($0062d5fe14b31e58$var$slice.call(arguments)));
    };
};

});


parcelRegister("6leqr", function(module, exports) {
/**
 * Expose `Backoff`.
 */ module.exports = $49dfe4d60e5790fd$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $49dfe4d60e5790fd$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $49dfe4d60e5790fd$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $49dfe4d60e5790fd$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $49dfe4d60e5790fd$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $49dfe4d60e5790fd$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $49dfe4d60e5790fd$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});



parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("gr6fc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf7402f0de7f81b7$var$toDate;

var $bf7402f0de7f81b7$var$_assertString = $bf7402f0de7f81b7$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $bf7402f0de7f81b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bf7402f0de7f81b7$var$toDate(date) {
    (0, $bf7402f0de7f81b7$var$_assertString.default)(date);
    date = Date.parse(date);
    return !isNaN(date) ? new Date(date) : null;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("hZqWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d18d08f8e9af886d$var$assertString;
function $d18d08f8e9af886d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d18d08f8e9af886d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d18d08f8e9af886d$var$_typeof(o);
}
function $d18d08f8e9af886d$var$assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;
    if (!isString) {
        var invalidType = $d18d08f8e9af886d$var$_typeof(input);
        if (input === null) invalidType = 'null';
        else if (invalidType === 'object') invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("2dcMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19c6b7089d1c44e5$var$toFloat;

var $19c6b7089d1c44e5$var$_isFloat = $19c6b7089d1c44e5$var$_interopRequireDefault((parcelRequire("5ARir")));
function $19c6b7089d1c44e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19c6b7089d1c44e5$var$toFloat(str) {
    if (!(0, $19c6b7089d1c44e5$var$_isFloat.default)(str)) return NaN;
    return parseFloat(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("5ARir", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4129a81d3aaabc96$var$isFloat;
module.exports.locales = void 0;

var $4129a81d3aaabc96$var$_assertString = $4129a81d3aaabc96$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $4129a81d3aaabc96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4129a81d3aaabc96$var$isFloat(str, options) {
    (0, $4129a81d3aaabc96$var$_assertString.default)(str);
    options = options || {};
    var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? $alkZf.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (str === '' || str === '.' || str === ',' || str === '-' || str === '+') return false;
    var value = parseFloat(str.replace(',', '.'));
    return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
}
var $4129a81d3aaabc96$var$locales = module.exports.locales = Object.keys($alkZf.decimal);

});
parcelRegister("alkZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.farsiLocales = module.exports.englishLocales = module.exports.dotDecimal = module.exports.decimal = module.exports.commaDecimal = module.exports.bengaliLocales = module.exports.arabicLocales = module.exports.alphanumeric = module.exports.alpha = void 0;
var $787c2518b50629c5$var$alpha = module.exports.alpha = {
    'en-US': /^[A-Z]+$/i,
    'az-AZ': /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    'bg-BG': /^[А-Я]+$/i,
    'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    'da-DK': /^[A-ZÆØÅ]+$/i,
    'de-DE': /^[A-ZÄÖÜß]+$/i,
    'el-GR': /^[Α-ώ]+$/i,
    'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    'fa-IR': /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    'fi-FI': /^[A-ZÅÄÖ]+$/i,
    'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    'ja-JP': /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    'nb-NO': /^[A-ZÆØÅ]+$/i,
    'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    'nn-NO': /^[A-ZÆØÅ]+$/i,
    'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    'pt-PT': /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    'ru-RU': /^[А-ЯЁ]+$/i,
    'kk-KZ': /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
    'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
    'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
    'sv-SE': /^[A-ZÅÄÖ]+$/i,
    'th-TH': /^[ก-๐\s]+$/i,
    'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
    'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    'vi-VN': /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    'ko-KR': /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    'hi-IN': /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    'si-LK': /^[\u0D80-\u0DFF]+$/
};
var $787c2518b50629c5$var$alphanumeric = module.exports.alphanumeric = {
    'en-US': /^[0-9A-Z]+$/i,
    'az-AZ': /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    'bg-BG': /^[0-9А-Я]+$/i,
    'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    'da-DK': /^[0-9A-ZÆØÅ]+$/i,
    'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
    'el-GR': /^[0-9Α-ω]+$/i,
    'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    'fi-FI': /^[0-9A-ZÅÄÖ]+$/i,
    'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    'ja-JP': /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
    'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
    'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    'pt-PT': /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    'ru-RU': /^[0-9А-ЯЁ]+$/i,
    'kk-KZ': /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
    'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
    'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
    'th-TH': /^[ก-๙\s]+$/i,
    'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    'ko-KR': /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    'vi-VN': /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    'hi-IN': /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    'si-LK': /^[0-9\u0D80-\u0DFF]+$/
};
var $787c2518b50629c5$var$decimal = module.exports.decimal = {
    'en-US': '.',
    ar: "\u066B"
};
var $787c2518b50629c5$var$englishLocales = module.exports.englishLocales = [
    'AU',
    'GB',
    'HK',
    'IN',
    'NZ',
    'ZA',
    'ZM'
];
for(var $787c2518b50629c5$var$locale, $787c2518b50629c5$var$i = 0; $787c2518b50629c5$var$i < $787c2518b50629c5$var$englishLocales.length; $787c2518b50629c5$var$i++){
    $787c2518b50629c5$var$locale = "en-".concat($787c2518b50629c5$var$englishLocales[$787c2518b50629c5$var$i]);
    $787c2518b50629c5$var$alpha[$787c2518b50629c5$var$locale] = $787c2518b50629c5$var$alpha['en-US'];
    $787c2518b50629c5$var$alphanumeric[$787c2518b50629c5$var$locale] = $787c2518b50629c5$var$alphanumeric['en-US'];
    $787c2518b50629c5$var$decimal[$787c2518b50629c5$var$locale] = $787c2518b50629c5$var$decimal['en-US'];
}
// Source: http://www.localeplanet.com/java/
var $787c2518b50629c5$var$arabicLocales = module.exports.arabicLocales = [
    'AE',
    'BH',
    'DZ',
    'EG',
    'IQ',
    'JO',
    'KW',
    'LB',
    'LY',
    'MA',
    'QM',
    'QA',
    'SA',
    'SD',
    'SY',
    'TN',
    'YE'
];
for(var $787c2518b50629c5$var$_locale, $787c2518b50629c5$var$_i = 0; $787c2518b50629c5$var$_i < $787c2518b50629c5$var$arabicLocales.length; $787c2518b50629c5$var$_i++){
    $787c2518b50629c5$var$_locale = "ar-".concat($787c2518b50629c5$var$arabicLocales[$787c2518b50629c5$var$_i]);
    $787c2518b50629c5$var$alpha[$787c2518b50629c5$var$_locale] = $787c2518b50629c5$var$alpha.ar;
    $787c2518b50629c5$var$alphanumeric[$787c2518b50629c5$var$_locale] = $787c2518b50629c5$var$alphanumeric.ar;
    $787c2518b50629c5$var$decimal[$787c2518b50629c5$var$_locale] = $787c2518b50629c5$var$decimal.ar;
}
var $787c2518b50629c5$var$farsiLocales = module.exports.farsiLocales = [
    'IR',
    'AF'
];
for(var $787c2518b50629c5$var$_locale2, $787c2518b50629c5$var$_i2 = 0; $787c2518b50629c5$var$_i2 < $787c2518b50629c5$var$farsiLocales.length; $787c2518b50629c5$var$_i2++){
    $787c2518b50629c5$var$_locale2 = "fa-".concat($787c2518b50629c5$var$farsiLocales[$787c2518b50629c5$var$_i2]);
    $787c2518b50629c5$var$alphanumeric[$787c2518b50629c5$var$_locale2] = $787c2518b50629c5$var$alphanumeric.fa;
    $787c2518b50629c5$var$decimal[$787c2518b50629c5$var$_locale2] = $787c2518b50629c5$var$decimal.ar;
}
var $787c2518b50629c5$var$bengaliLocales = module.exports.bengaliLocales = [
    'BD',
    'IN'
];
for(var $787c2518b50629c5$var$_locale3, $787c2518b50629c5$var$_i3 = 0; $787c2518b50629c5$var$_i3 < $787c2518b50629c5$var$bengaliLocales.length; $787c2518b50629c5$var$_i3++){
    $787c2518b50629c5$var$_locale3 = "bn-".concat($787c2518b50629c5$var$bengaliLocales[$787c2518b50629c5$var$_i3]);
    $787c2518b50629c5$var$alpha[$787c2518b50629c5$var$_locale3] = $787c2518b50629c5$var$alpha.bn;
    $787c2518b50629c5$var$alphanumeric[$787c2518b50629c5$var$_locale3] = $787c2518b50629c5$var$alphanumeric.bn;
    $787c2518b50629c5$var$decimal[$787c2518b50629c5$var$_locale3] = $787c2518b50629c5$var$decimal['en-US'];
}
// Source: https://en.wikipedia.org/wiki/Decimal_mark
var $787c2518b50629c5$var$dotDecimal = module.exports.dotDecimal = [
    'ar-EG',
    'ar-LB',
    'ar-LY'
];
var $787c2518b50629c5$var$commaDecimal = module.exports.commaDecimal = [
    'bg-BG',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'el-GR',
    'en-ZM',
    'eo',
    'es-ES',
    'fr-CA',
    'fr-FR',
    'id-ID',
    'it-IT',
    'ku-IQ',
    'hi-IN',
    'hu-HU',
    'nb-NO',
    'nn-NO',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ru-RU',
    'kk-KZ',
    'si-LK',
    'sl-SI',
    'sr-RS@latin',
    'sr-RS',
    'sv-SE',
    'tr-TR',
    'uk-UA',
    'vi-VN'
];
for(var $787c2518b50629c5$var$_i4 = 0; $787c2518b50629c5$var$_i4 < $787c2518b50629c5$var$dotDecimal.length; $787c2518b50629c5$var$_i4++)$787c2518b50629c5$var$decimal[$787c2518b50629c5$var$dotDecimal[$787c2518b50629c5$var$_i4]] = $787c2518b50629c5$var$decimal['en-US'];
for(var $787c2518b50629c5$var$_i5 = 0; $787c2518b50629c5$var$_i5 < $787c2518b50629c5$var$commaDecimal.length; $787c2518b50629c5$var$_i5++)$787c2518b50629c5$var$decimal[$787c2518b50629c5$var$commaDecimal[$787c2518b50629c5$var$_i5]] = ',';
$787c2518b50629c5$var$alpha['fr-CA'] = $787c2518b50629c5$var$alpha['fr-FR'];
$787c2518b50629c5$var$alphanumeric['fr-CA'] = $787c2518b50629c5$var$alphanumeric['fr-FR'];
$787c2518b50629c5$var$alpha['pt-BR'] = $787c2518b50629c5$var$alpha['pt-PT'];
$787c2518b50629c5$var$alphanumeric['pt-BR'] = $787c2518b50629c5$var$alphanumeric['pt-PT'];
$787c2518b50629c5$var$decimal['pt-BR'] = $787c2518b50629c5$var$decimal['pt-PT'];
// see #862
$787c2518b50629c5$var$alpha['pl-Pl'] = $787c2518b50629c5$var$alpha['pl-PL'];
$787c2518b50629c5$var$alphanumeric['pl-Pl'] = $787c2518b50629c5$var$alphanumeric['pl-PL'];
$787c2518b50629c5$var$decimal['pl-Pl'] = $787c2518b50629c5$var$decimal['pl-PL'];
// see #1455
$787c2518b50629c5$var$alpha['fa-AF'] = $787c2518b50629c5$var$alpha.fa;

});



parcelRegister("ab0Id", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $768b7be7bb7a2e5d$var$toInt;

var $768b7be7bb7a2e5d$var$_assertString = $768b7be7bb7a2e5d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $768b7be7bb7a2e5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $768b7be7bb7a2e5d$var$toInt(str, radix) {
    (0, $768b7be7bb7a2e5d$var$_assertString.default)(str);
    return parseInt(str, radix || 10);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dtiFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9cec7601b0e513ca$var$toBoolean;

var $9cec7601b0e513ca$var$_assertString = $9cec7601b0e513ca$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9cec7601b0e513ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9cec7601b0e513ca$var$toBoolean(str, strict) {
    (0, $9cec7601b0e513ca$var$_assertString.default)(str);
    if (strict) return str === '1' || /^true$/i.test(str);
    return str !== '0' && !/^false$/i.test(str) && str !== '';
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("jXY5d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8922243f7c899fb$var$equals;

var $e8922243f7c899fb$var$_assertString = $e8922243f7c899fb$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $e8922243f7c899fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8922243f7c899fb$var$equals(str, comparison) {
    (0, $e8922243f7c899fb$var$_assertString.default)(str);
    return str === comparison;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aZ85Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ff5e1054c060d90$var$contains;

var $7ff5e1054c060d90$var$_assertString = $7ff5e1054c060d90$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $7ff5e1054c060d90$var$_toString = $7ff5e1054c060d90$var$_interopRequireDefault((parcelRequire("dAq0G")));

var $7ff5e1054c060d90$var$_merge = $7ff5e1054c060d90$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $7ff5e1054c060d90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7ff5e1054c060d90$var$defaulContainsOptions = {
    ignoreCase: false,
    minOccurrences: 1
};
function $7ff5e1054c060d90$var$contains(str, elem, options) {
    (0, $7ff5e1054c060d90$var$_assertString.default)(str);
    options = (0, $7ff5e1054c060d90$var$_merge.default)(options, $7ff5e1054c060d90$var$defaulContainsOptions);
    if (options.ignoreCase) return str.toLowerCase().split((0, $7ff5e1054c060d90$var$_toString.default)(elem).toLowerCase()).length > options.minOccurrences;
    return str.split((0, $7ff5e1054c060d90$var$_toString.default)(elem)).length > options.minOccurrences;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("dAq0G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e42d033f9ae4b35$var$toString;
function $9e42d033f9ae4b35$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e42d033f9ae4b35$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e42d033f9ae4b35$var$_typeof(o);
}
function $9e42d033f9ae4b35$var$toString(input) {
    if ($9e42d033f9ae4b35$var$_typeof(input) === 'object' && input !== null) {
        if (typeof input.toString === 'function') input = input.toString();
        else input = '[object Object]';
    } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) input = '';
    return String(input);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9nDkO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d44c6112d12dafe$var$merge;
function $6d44c6112d12dafe$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === 'undefined') obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("5ZSE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $45dd09a0b348eef1$var$matches;

var $45dd09a0b348eef1$var$_assertString = $45dd09a0b348eef1$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $45dd09a0b348eef1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $45dd09a0b348eef1$var$matches(str, pattern, modifiers) {
    (0, $45dd09a0b348eef1$var$_assertString.default)(str);
    if (Object.prototype.toString.call(pattern) !== '[object RegExp]') pattern = new RegExp(pattern, modifiers);
    return !!str.match(pattern);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4tHKL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $342bcf524c691bd2$var$isEmail;

var $342bcf524c691bd2$var$_assertString = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $342bcf524c691bd2$var$_isByteLength = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("lIM5C")));

var $342bcf524c691bd2$var$_isFQDN = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("hNevj")));

var $342bcf524c691bd2$var$_isIP = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("k4gOC")));

var $342bcf524c691bd2$var$_merge = $342bcf524c691bd2$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $342bcf524c691bd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $342bcf524c691bd2$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: '',
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $342bcf524c691bd2$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $342bcf524c691bd2$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $342bcf524c691bd2$var$gmailUserPart = /^[a-z\d]+$/;
var $342bcf524c691bd2$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $342bcf524c691bd2$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $342bcf524c691bd2$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $342bcf524c691bd2$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $342bcf524c691bd2$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1');
    // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
    // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
        // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $342bcf524c691bd2$var$isEmail(str, options) {
    (0, $342bcf524c691bd2$var$_assertString.default)(str);
    options = (0, $342bcf524c691bd2$var$_merge.default)(options, $342bcf524c691bd2$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($342bcf524c691bd2$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1];
            // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, '').replace(/(^<|>$)/g, '');
            // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(' ')) display_name = display_name.slice(0, -1);
            if (!$342bcf524c691bd2$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $342bcf524c691bd2$var$defaultMaxEmailLength) return false;
    var parts = str.split('@');
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join('@');
    if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase();
        // Removing sub-address from username before gmail validation
        var username = user.split('+')[0];
        // Dots are not included in gmail length restriction
        if (!(0, $342bcf524c691bd2$var$_isByteLength.default)(username.replace(/\./g, ''), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split('.');
        for(var i = 0; i < _user_parts.length; i++){
            if (!$342bcf524c691bd2$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $342bcf524c691bd2$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $342bcf524c691bd2$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $342bcf524c691bd2$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $342bcf524c691bd2$var$_isIP.default)(domain)) {
            if (!domain.startsWith('[') || !domain.endsWith(']')) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $342bcf524c691bd2$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $342bcf524c691bd2$var$quotedEmailUserUtf8.test(user) : $342bcf524c691bd2$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $342bcf524c691bd2$var$emailUserUtf8Part : $342bcf524c691bd2$var$emailUserPart;
    var user_parts = user.split('.');
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("lIM5C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd0302a416500dad$var$isByteLength;

var $fd0302a416500dad$var$_assertString = $fd0302a416500dad$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $fd0302a416500dad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fd0302a416500dad$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fd0302a416500dad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fd0302a416500dad$var$_typeof(o);
}
/* eslint-disable prefer-rest-params */ function $fd0302a416500dad$var$isByteLength(str, options) {
    (0, $fd0302a416500dad$var$_assertString.default)(str);
    var min;
    var max;
    if ($fd0302a416500dad$var$_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hNevj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf424376bb64783b$var$isFQDN;

var $cf424376bb64783b$var$_assertString = $cf424376bb64783b$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $cf424376bb64783b$var$_merge = $cf424376bb64783b$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $cf424376bb64783b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cf424376bb64783b$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $cf424376bb64783b$var$isFQDN(str, options) {
    (0, $cf424376bb64783b$var$_assertString.default)(str);
    options = (0, $cf424376bb64783b$var$_merge.default)(options, $cf424376bb64783b$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === '.') str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf('*.') === 0) str = str.substring(2);
    var parts = str.split('.');
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
        // disallow spaces
        if (/\s/.test(tld)) return false;
    }
    // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
        // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("k4gOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e9c1399487ce19b5$var$isIP;

var $e9c1399487ce19b5$var$_assertString = $e9c1399487ce19b5$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $e9c1399487ce19b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $e9c1399487ce19b5$var$IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
var $e9c1399487ce19b5$var$IPv4AddressFormat = "(".concat($e9c1399487ce19b5$var$IPv4SegmentFormat, "[.]){3}").concat($e9c1399487ce19b5$var$IPv4SegmentFormat);
var $e9c1399487ce19b5$var$IPv4AddressRegExp = new RegExp("^".concat($e9c1399487ce19b5$var$IPv4AddressFormat, "$"));
var $e9c1399487ce19b5$var$IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
var $e9c1399487ce19b5$var$IPv6AddressRegExp = new RegExp('^(' + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){7}(?:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){6}(?:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){5}(?::").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){4}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,1}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){3}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,2}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){2}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,3}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, ":){1}(?:(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,4}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(:").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){0,5}:").concat($e9c1399487ce19b5$var$IPv4AddressFormat, "|(?::").concat($e9c1399487ce19b5$var$IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');
function $e9c1399487ce19b5$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, $e9c1399487ce19b5$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $e9c1399487ce19b5$var$isIP(str, 4) || $e9c1399487ce19b5$var$isIP(str, 6);
    if (version === '4') return $e9c1399487ce19b5$var$IPv4AddressRegExp.test(str);
    if (version === '6') return $e9c1399487ce19b5$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("4Cxzb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35d4bf9d9281792e$var$isURL;

var $35d4bf9d9281792e$var$_assertString = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $35d4bf9d9281792e$var$_isFQDN = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("hNevj")));

var $35d4bf9d9281792e$var$_isIP = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("k4gOC")));

var $35d4bf9d9281792e$var$_merge = $35d4bf9d9281792e$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $35d4bf9d9281792e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $35d4bf9d9281792e$var$_slicedToArray(arr, i) {
    return $35d4bf9d9281792e$var$_arrayWithHoles(arr) || $35d4bf9d9281792e$var$_iterableToArrayLimit(arr, i) || $35d4bf9d9281792e$var$_unsupportedIterableToArray(arr, i) || $35d4bf9d9281792e$var$_nonIterableRest();
}
function $35d4bf9d9281792e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $35d4bf9d9281792e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $35d4bf9d9281792e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $35d4bf9d9281792e$var$_arrayLikeToArray(o, minLen);
}
function $35d4bf9d9281792e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $35d4bf9d9281792e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $35d4bf9d9281792e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/*
options for isURL method

require_protocol - if set as true isURL will return false if protocol is not present in the URL
require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
protocols - valid protocols can be modified with this option
require_host - if set as false isURL will not check if host is present in the URL
require_port - if set as true isURL will check if port is present in the URL
allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)

*/ var $35d4bf9d9281792e$var$default_url_options = {
    protocols: [
        'http',
        'https',
        'ftp'
    ],
    require_tld: true,
    require_protocol: false,
    require_host: true,
    require_port: false,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
    allow_fragments: true,
    allow_query_components: true,
    validate_length: true
};
var $35d4bf9d9281792e$var$wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
function $35d4bf9d9281792e$var$isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
}
function $35d4bf9d9281792e$var$checkHost(host, matches) {
    for(var i = 0; i < matches.length; i++){
        var match = matches[i];
        if (host === match || $35d4bf9d9281792e$var$isRegExp(match) && match.test(host)) return true;
    }
    return false;
}
function $35d4bf9d9281792e$var$isURL(url, options) {
    (0, $35d4bf9d9281792e$var$_assertString.default)(url);
    if (!url || /[\s<>]/.test(url)) return false;
    if (url.indexOf('mailto:') === 0) return false;
    options = (0, $35d4bf9d9281792e$var$_merge.default)(options, $35d4bf9d9281792e$var$default_url_options);
    if (options.validate_length && url.length >= 2083) return false;
    if (!options.allow_fragments && url.includes('#')) return false;
    if (!options.allow_query_components && (url.includes('?') || url.includes('&'))) return false;
    var protocol, auth, host, hostname, port, port_str, split, ipv6;
    split = url.split('#');
    url = split.shift();
    split = url.split('?');
    url = split.shift();
    split = url.split('://');
    if (split.length > 1) {
        protocol = split.shift().toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) return false;
    } else if (options.require_protocol) return false;
    else if (url.slice(0, 2) === '//') {
        if (!options.allow_protocol_relative_urls) return false;
        split[0] = url.slice(2);
    }
    url = split.join('://');
    if (url === '') return false;
    split = url.split('/');
    url = split.shift();
    if (url === '' && !options.require_host) return true;
    split = url.split('@');
    if (split.length > 1) {
        if (options.disallow_auth) return false;
        if (split[0] === '') return false;
        auth = split.shift();
        if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) return false;
        var _auth$split = auth.split(':'), _auth$split2 = $35d4bf9d9281792e$var$_slicedToArray(_auth$split, 2), user = _auth$split2[0], password = _auth$split2[1];
        if (user === '' && password === '') return false;
    }
    hostname = split.join('@');
    port_str = null;
    ipv6 = null;
    var ipv6_match = hostname.match($35d4bf9d9281792e$var$wrapped_ipv6);
    if (ipv6_match) {
        host = '';
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
    } else {
        split = hostname.split(':');
        host = split.shift();
        if (split.length) port_str = split.join(':');
    }
    if (port_str !== null && port_str.length > 0) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) return false;
    } else if (options.require_port) return false;
    if (options.host_whitelist) return $35d4bf9d9281792e$var$checkHost(host, options.host_whitelist);
    if (host === '' && !options.require_host) return true;
    if (!(0, $35d4bf9d9281792e$var$_isIP.default)(host) && !(0, $35d4bf9d9281792e$var$_isFQDN.default)(host, options) && (!ipv6 || !(0, $35d4bf9d9281792e$var$_isIP.default)(ipv6, 6))) return false;
    host = host || ipv6;
    if (options.host_blacklist && $35d4bf9d9281792e$var$checkHost(host, options.host_blacklist)) return false;
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("S05Bl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a251d00a80bd0ec$var$isMACAddress;

var $0a251d00a80bd0ec$var$_assertString = $0a251d00a80bd0ec$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $0a251d00a80bd0ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0a251d00a80bd0ec$var$macAddress48 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
var $0a251d00a80bd0ec$var$macAddress48NoSeparators = /^([0-9a-fA-F]){12}$/;
var $0a251d00a80bd0ec$var$macAddress48WithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;
var $0a251d00a80bd0ec$var$macAddress64 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/;
var $0a251d00a80bd0ec$var$macAddress64NoSeparators = /^([0-9a-fA-F]){16}$/;
var $0a251d00a80bd0ec$var$macAddress64WithDots = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
function $0a251d00a80bd0ec$var$isMACAddress(str, options) {
    (0, $0a251d00a80bd0ec$var$_assertString.default)(str);
    if (options !== null && options !== void 0 && options.eui) options.eui = String(options.eui);
    /**
   * @deprecated `no_colons` TODO: remove it in the next major
  */ if (options !== null && options !== void 0 && options.no_colons || options !== null && options !== void 0 && options.no_separators) {
        if (options.eui === '48') return $0a251d00a80bd0ec$var$macAddress48NoSeparators.test(str);
        if (options.eui === '64') return $0a251d00a80bd0ec$var$macAddress64NoSeparators.test(str);
        return $0a251d00a80bd0ec$var$macAddress48NoSeparators.test(str) || $0a251d00a80bd0ec$var$macAddress64NoSeparators.test(str);
    }
    if ((options === null || options === void 0 ? void 0 : options.eui) === '48') return $0a251d00a80bd0ec$var$macAddress48.test(str) || $0a251d00a80bd0ec$var$macAddress48WithDots.test(str);
    if ((options === null || options === void 0 ? void 0 : options.eui) === '64') return $0a251d00a80bd0ec$var$macAddress64.test(str) || $0a251d00a80bd0ec$var$macAddress64WithDots.test(str);
    return $0a251d00a80bd0ec$var$isMACAddress(str, {
        eui: '48'
    }) || $0a251d00a80bd0ec$var$isMACAddress(str, {
        eui: '64'
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9xDwV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f25dbf79de56c7d$var$isIPRange;

var $6f25dbf79de56c7d$var$_assertString = $6f25dbf79de56c7d$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $6f25dbf79de56c7d$var$_isIP = $6f25dbf79de56c7d$var$_interopRequireDefault((parcelRequire("k4gOC")));
function $6f25dbf79de56c7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6f25dbf79de56c7d$var$subnetMaybe = /^\d{1,3}$/;
var $6f25dbf79de56c7d$var$v4Subnet = 32;
var $6f25dbf79de56c7d$var$v6Subnet = 128;
function $6f25dbf79de56c7d$var$isIPRange(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    (0, $6f25dbf79de56c7d$var$_assertString.default)(str);
    var parts = str.split('/');
    // parts[0] -> ip, parts[1] -> subnet
    if (parts.length !== 2) return false;
    if (!$6f25dbf79de56c7d$var$subnetMaybe.test(parts[1])) return false;
    // Disallow preceding 0 i.e. 01, 02, ...
    if (parts[1].length > 1 && parts[1].startsWith('0')) return false;
    var isValidIP = (0, $6f25dbf79de56c7d$var$_isIP.default)(parts[0], version);
    if (!isValidIP) return false;
    // Define valid subnet according to IP's version
    var expectedSubnet = null;
    switch(String(version)){
        case '4':
            expectedSubnet = $6f25dbf79de56c7d$var$v4Subnet;
            break;
        case '6':
            expectedSubnet = $6f25dbf79de56c7d$var$v6Subnet;
            break;
        default:
            expectedSubnet = (0, $6f25dbf79de56c7d$var$_isIP.default)(parts[0], '6') ? $6f25dbf79de56c7d$var$v6Subnet : $6f25dbf79de56c7d$var$v4Subnet;
    }
    return parts[1] <= expectedSubnet && parts[1] >= 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("akLR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7860e4dd34e35154$var$isDate;

var $7860e4dd34e35154$var$_merge = $7860e4dd34e35154$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $7860e4dd34e35154$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7860e4dd34e35154$var$_slicedToArray(arr, i) {
    return $7860e4dd34e35154$var$_arrayWithHoles(arr) || $7860e4dd34e35154$var$_iterableToArrayLimit(arr, i) || $7860e4dd34e35154$var$_unsupportedIterableToArray(arr, i) || $7860e4dd34e35154$var$_nonIterableRest();
}
function $7860e4dd34e35154$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7860e4dd34e35154$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7860e4dd34e35154$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7860e4dd34e35154$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7860e4dd34e35154$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7860e4dd34e35154$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7860e4dd34e35154$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7860e4dd34e35154$var$_arrayLikeToArray(o, minLen);
}
function $7860e4dd34e35154$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7860e4dd34e35154$var$default_date_options = {
    format: 'YYYY/MM/DD',
    delimiters: [
        '/',
        '-'
    ],
    strictMode: false
};
function $7860e4dd34e35154$var$isValidFormat(format) {
    return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
}
function $7860e4dd34e35154$var$zip(date, format) {
    var zippedArr = [], len = Math.min(date.length, format.length);
    for(var i = 0; i < len; i++)zippedArr.push([
        date[i],
        format[i]
    ]);
    return zippedArr;
}
function $7860e4dd34e35154$var$isDate(input, options) {
    if (typeof options === 'string') // Allow backward compatibility for old format isDate(input [, format])
    options = (0, $7860e4dd34e35154$var$_merge.default)({
        format: options
    }, $7860e4dd34e35154$var$default_date_options);
    else options = (0, $7860e4dd34e35154$var$_merge.default)(options, $7860e4dd34e35154$var$default_date_options);
    if (typeof input === 'string' && $7860e4dd34e35154$var$isValidFormat(options.format)) {
        var formatDelimiter = options.delimiters.find(function(delimiter) {
            return options.format.indexOf(delimiter) !== -1;
        });
        var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function(delimiter) {
            return input.indexOf(delimiter) !== -1;
        });
        var dateAndFormat = $7860e4dd34e35154$var$zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
        var dateObj = {};
        var _iterator = $7860e4dd34e35154$var$_createForOfIteratorHelper(dateAndFormat), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $7860e4dd34e35154$var$_slicedToArray(_step.value, 2), dateWord = _step$value[0], formatWord = _step$value[1];
                if (dateWord.length !== formatWord.length) return false;
                dateObj[formatWord.charAt(0)] = dateWord;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var fullYear = dateObj.y;
        // Check if the year starts with a hyphen
        if (fullYear.startsWith('-')) return false; // Hyphen before year is not allowed
        if (dateObj.y.length === 2) {
            var parsedYear = parseInt(dateObj.y, 10);
            if (isNaN(parsedYear)) return false;
            var currentYearLastTwoDigits = new Date().getFullYear() % 100;
            if (parsedYear < currentYearLastTwoDigits) fullYear = "20".concat(dateObj.y);
            else fullYear = "19".concat(dateObj.y);
        }
        var month = dateObj.m;
        if (dateObj.m.length === 1) month = "0".concat(dateObj.m);
        var day = dateObj.d;
        if (dateObj.d.length === 1) day = "0".concat(dateObj.d);
        return new Date("".concat(fullYear, "-").concat(month, "-").concat(day, "T00:00:00.000Z")).getUTCDate() === +dateObj.d;
    }
    if (!options.strictMode) return Object.prototype.toString.call(input) === '[object Date]' && isFinite(input);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7Qjw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b5c87100b87fd89$var$isTime;

var $5b5c87100b87fd89$var$_merge = $5b5c87100b87fd89$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $5b5c87100b87fd89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5b5c87100b87fd89$var$default_time_options = {
    hourFormat: 'hour24',
    mode: 'default'
};
var $5b5c87100b87fd89$var$formats = {
    hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
    },
    hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
    }
};
function $5b5c87100b87fd89$var$isTime(input, options) {
    options = (0, $5b5c87100b87fd89$var$_merge.default)(options, $5b5c87100b87fd89$var$default_time_options);
    if (typeof input !== 'string') return false;
    return $5b5c87100b87fd89$var$formats[options.hourFormat][options.mode].test(input);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5sk3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f8f2114237cf72d$var$isBoolean;

var $3f8f2114237cf72d$var$_assertString = $3f8f2114237cf72d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $3f8f2114237cf72d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3f8f2114237cf72d$var$defaultOptions = {
    loose: false
};
var $3f8f2114237cf72d$var$strictBooleans = [
    'true',
    'false',
    '1',
    '0'
];
var $3f8f2114237cf72d$var$looseBooleans = [].concat($3f8f2114237cf72d$var$strictBooleans, [
    'yes',
    'no'
]);
function $3f8f2114237cf72d$var$isBoolean(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3f8f2114237cf72d$var$defaultOptions;
    (0, $3f8f2114237cf72d$var$_assertString.default)(str);
    if (options.loose) return $3f8f2114237cf72d$var$looseBooleans.includes(str.toLowerCase());
    return $3f8f2114237cf72d$var$strictBooleans.includes(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9E8F4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $705e917039c621bf$var$isLocale;

var $705e917039c621bf$var$_assertString = $705e917039c621bf$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $705e917039c621bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
  = 3ALPHA              ; selected ISO 639 codes
    *2("-" 3ALPHA)      ; permanently reserved
 */ var $705e917039c621bf$var$extlang = '([A-Za-z]{3}(-[A-Za-z]{3}){0,2})';
/*
  = 2*3ALPHA            ; shortest ISO 639 code
    ["-" extlang]       ; sometimes followed by
                        ; extended language subtags
  / 4ALPHA              ; or reserved for future use
  / 5*8ALPHA            ; or registered language subtag
 */ var $705e917039c621bf$var$language = "(([a-zA-Z]{2,3}(-".concat($705e917039c621bf$var$extlang, ")?)|([a-zA-Z]{5,8}))");
/*
  = 4ALPHA              ; ISO 15924 code
 */ var $705e917039c621bf$var$script = '([A-Za-z]{4})';
/*
  = 2ALPHA              ; ISO 3166-1 code
  / 3DIGIT              ; UN M.49 code
 */ var $705e917039c621bf$var$region = '([A-Za-z]{2}|\\d{3})';
/*
  = 5*8alphanum         ; registered variants
  / (DIGIT 3alphanum)
 */ var $705e917039c621bf$var$variant = '([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))';
/*
  = DIGIT               ; 0 - 9
  / %x41-57             ; A - W
  / %x59-5A             ; Y - Z
  / %x61-77             ; a - w
  / %x79-7A             ; y - z
 */ var $705e917039c621bf$var$singleton = '(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])';
/*
  = singleton 1*("-" (2*8alphanum))
                        ; Single alphanumerics
                        ; "x" reserved for private use
 */ var $705e917039c621bf$var$extension = "(".concat($705e917039c621bf$var$singleton, "(-[A-Za-z0-9]{2,8})+)");
/*
  = "x" 1*("-" (1*8alphanum))
 */ var $705e917039c621bf$var$privateuse = '(x(-[A-Za-z0-9]{1,8})+)';
// irregular tags do not match the 'langtag' production and would not
// otherwise be considered 'well-formed'. These tags are all valid, but
// most are deprecated in favor of more modern subtags or subtag combination
var $705e917039c621bf$var$irregular = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))";
// regular tags match the 'langtag' production, but their subtags are not
// extended language or variant subtags: their meaning is defined by
// their registration and all of these are deprecated in favor of a more
// modern subtag or sequence of subtags
var $705e917039c621bf$var$regular = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))";
/*
  = irregular           ; non-redundant tags registered
  / regular             ; during the RFC 3066 era

 */ var $705e917039c621bf$var$grandfathered = "(".concat($705e917039c621bf$var$irregular, "|").concat($705e917039c621bf$var$regular, ")");
/*
  RFC 5646 defines delimitation of subtags via a hyphen:

      "Subtag" refers to a specific section of a tag, delimited by a
      hyphen, such as the subtags 'zh', 'Hant', and 'CN' in the tag "zh-
      Hant-CN".  Examples of subtags in this document are enclosed in
      single quotes ('Hant')

  However, we need to add "_" to maintain the existing behaviour.
 */ var $705e917039c621bf$var$delimiter = '(-|_)';
/*
  = language
    ["-" script]
    ["-" region]
    *("-" variant)
    *("-" extension)
    ["-" privateuse]
 */ var $705e917039c621bf$var$langtag = "".concat($705e917039c621bf$var$language, "(").concat($705e917039c621bf$var$delimiter).concat($705e917039c621bf$var$script, ")?(").concat($705e917039c621bf$var$delimiter).concat($705e917039c621bf$var$region, ")?(").concat($705e917039c621bf$var$delimiter).concat($705e917039c621bf$var$variant, ")*(").concat($705e917039c621bf$var$delimiter).concat($705e917039c621bf$var$extension, ")*(").concat($705e917039c621bf$var$delimiter).concat($705e917039c621bf$var$privateuse, ")?");
/*
  Regex implementation based on BCP RFC 5646
  Tags for Identifying Languages
  https://www.rfc-editor.org/rfc/rfc5646.html
 */ var $705e917039c621bf$var$languageTagRegex = new RegExp("(^".concat($705e917039c621bf$var$privateuse, "$)|(^").concat($705e917039c621bf$var$grandfathered, "$)|(^").concat($705e917039c621bf$var$langtag, "$)"));
function $705e917039c621bf$var$isLocale(str) {
    (0, $705e917039c621bf$var$_assertString.default)(str);
    return $705e917039c621bf$var$languageTagRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ko0io", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ed76474613049cd0$var$isAbaRouting;

var $ed76474613049cd0$var$_assertString = $ed76474613049cd0$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $ed76474613049cd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// http://www.brainjar.com/js/validation/
// https://www.aba.com/news-research/research-analysis/routing-number-policy-procedures
// series reserved for future use are excluded
var $ed76474613049cd0$var$isRoutingReg = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
function $ed76474613049cd0$var$isAbaRouting(str) {
    (0, $ed76474613049cd0$var$_assertString.default)(str);
    if (!$ed76474613049cd0$var$isRoutingReg.test(str)) return false;
    var checkSumVal = 0;
    for(var i = 0; i < str.length; i++){
        if (i % 3 === 0) checkSumVal += str[i] * 3;
        else if (i % 3 === 1) checkSumVal += str[i] * 7;
        else checkSumVal += str[i] * 1;
    }
    return checkSumVal % 10 === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("fvxOe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4a3fa1288ebd161$var$isAlpha;
module.exports.locales = void 0;

var $b4a3fa1288ebd161$var$_assertString = $b4a3fa1288ebd161$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $b4a3fa1288ebd161$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b4a3fa1288ebd161$var$isAlpha(_str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, $b4a3fa1288ebd161$var$_assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
        if (ignore instanceof RegExp) str = str.replace(ignore, '');
        else if (typeof ignore === 'string') str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
        else throw new Error('ignore should be instance of a String or RegExp');
    }
    if (locale in $alkZf.alpha) return $alkZf.alpha[locale].test(str);
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $b4a3fa1288ebd161$var$locales = module.exports.locales = Object.keys($alkZf.alpha);

});

parcelRegister("9AaLY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f9fd5147e20bff2$var$isAlphanumeric;
module.exports.locales = void 0;

var $6f9fd5147e20bff2$var$_assertString = $6f9fd5147e20bff2$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $6f9fd5147e20bff2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f9fd5147e20bff2$var$isAlphanumeric(_str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, $6f9fd5147e20bff2$var$_assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
        if (ignore instanceof RegExp) str = str.replace(ignore, '');
        else if (typeof ignore === 'string') str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, '\\$&'), "]"), 'g'), ''); // escape regex for ignore
        else throw new Error('ignore should be instance of a String or RegExp');
    }
    if (locale in $alkZf.alphanumeric) return $alkZf.alphanumeric[locale].test(str);
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $6f9fd5147e20bff2$var$locales = module.exports.locales = Object.keys($alkZf.alphanumeric);

});

parcelRegister("b9xtB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81ea80af3d27e27d$var$isNumeric;

var $81ea80af3d27e27d$var$_assertString = $81ea80af3d27e27d$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $alkZf = parcelRequire("alkZf");
function $81ea80af3d27e27d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $81ea80af3d27e27d$var$numericNoSymbols = /^[0-9]+$/;
function $81ea80af3d27e27d$var$isNumeric(str, options) {
    (0, $81ea80af3d27e27d$var$_assertString.default)(str);
    if (options && options.no_symbols) return $81ea80af3d27e27d$var$numericNoSymbols.test(str);
    return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? $alkZf.decimal[options.locale] : '.', "])?[0-9]+$")).test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("lpGGU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f96d0c4eeb9e4d0d$var$isPassportNumber;

var $f96d0c4eeb9e4d0d$var$_assertString = $f96d0c4eeb9e4d0d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $f96d0c4eeb9e4d0d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Reference:
 * https://en.wikipedia.org/ -- Wikipedia
 * https://docs.microsoft.com/en-us/microsoft-365/compliance/eu-passport-number -- EU Passport Number
 * https://countrycode.org/ -- Country Codes
 */ var $f96d0c4eeb9e4d0d$var$passportRegexByCountryCode = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{1}\d{8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/,
    // UNITED STATES
    ZA: /^[TAMD]\d{8}$/ // SOUTH AFRICA
};
/**
 * Check if str is a valid passport number
 * relative to provided ISO Country Code.
 *
 * @param {string} str
 * @param {string} countryCode
 * @return {boolean}
 */ function $f96d0c4eeb9e4d0d$var$isPassportNumber(str, countryCode) {
    (0, $f96d0c4eeb9e4d0d$var$_assertString.default)(str);
    /** Remove All Whitespaces, Convert to UPPERCASE */ var normalizedStr = str.replace(/\s/g, '').toUpperCase();
    return countryCode.toUpperCase() in $f96d0c4eeb9e4d0d$var$passportRegexByCountryCode && $f96d0c4eeb9e4d0d$var$passportRegexByCountryCode[countryCode].test(normalizedStr);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("anXSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $78fa8043562920b1$var$isPort;

var $78fa8043562920b1$var$_isInt = $78fa8043562920b1$var$_interopRequireDefault((parcelRequire("3VTZw")));
function $78fa8043562920b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78fa8043562920b1$var$isPort(str) {
    return (0, $78fa8043562920b1$var$_isInt.default)(str, {
        allow_leading_zeroes: false,
        min: 0,
        max: 65535
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("3VTZw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2dd220af97ca2a6a$var$isInt;

var $2dd220af97ca2a6a$var$_assertString = $2dd220af97ca2a6a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $2dd220af97ca2a6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2dd220af97ca2a6a$var$int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var $2dd220af97ca2a6a$var$intLeadingZeroes = /^[-+]?[0-9]+$/;
function $2dd220af97ca2a6a$var$isInt(str, options) {
    (0, $2dd220af97ca2a6a$var$_assertString.default)(str);
    options = options || {};
    // Get the regex to use for testing, based on whether
    // leading zeroes are allowed or not.
    var regex = options.allow_leading_zeroes === false ? $2dd220af97ca2a6a$var$int : $2dd220af97ca2a6a$var$intLeadingZeroes;
    // Check min/max/lt/gt
    var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
    var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
    var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
    var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
    return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("8YYKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $68a30d16883720bb$var$isLowercase;

var $68a30d16883720bb$var$_assertString = $68a30d16883720bb$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $68a30d16883720bb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $68a30d16883720bb$var$isLowercase(str) {
    (0, $68a30d16883720bb$var$_assertString.default)(str);
    return str === str.toLowerCase();
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("Y8gNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b4c04f6a35f5e6a$var$isUppercase;

var $0b4c04f6a35f5e6a$var$_assertString = $0b4c04f6a35f5e6a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $0b4c04f6a35f5e6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b4c04f6a35f5e6a$var$isUppercase(str) {
    (0, $0b4c04f6a35f5e6a$var$_assertString.default)(str);
    return str === str.toUpperCase();
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8DM8E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $64a74e9492c68bc9$var$isIMEI;

var $64a74e9492c68bc9$var$_assertString = $64a74e9492c68bc9$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $64a74e9492c68bc9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $64a74e9492c68bc9$var$imeiRegexWithoutHypens = /^[0-9]{15}$/;
var $64a74e9492c68bc9$var$imeiRegexWithHypens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
function $64a74e9492c68bc9$var$isIMEI(str, options) {
    (0, $64a74e9492c68bc9$var$_assertString.default)(str);
    options = options || {};
    // default regex for checking imei is the one without hyphens
    var imeiRegex = $64a74e9492c68bc9$var$imeiRegexWithoutHypens;
    if (options.allow_hyphens) imeiRegex = $64a74e9492c68bc9$var$imeiRegexWithHypens;
    if (!imeiRegex.test(str)) return false;
    str = str.replace(/-/g, '');
    var sum = 0, mul = 2, l = 14;
    for(var i = 0; i < l; i++){
        var digit = str.substring(l - i - 1, l - i);
        var tp = parseInt(digit, 10) * mul;
        if (tp >= 10) sum += tp % 10 + 1;
        else sum += tp;
        if (mul === 1) mul += 1;
        else mul -= 1;
    }
    var chk = (10 - sum % 10) % 10;
    if (chk !== parseInt(str.substring(14, 15), 10)) return false;
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kv2Jx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec8d2af9a3df3c4$var$isAscii;

var $eec8d2af9a3df3c4$var$_assertString = $eec8d2af9a3df3c4$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $eec8d2af9a3df3c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable no-control-regex */ var $eec8d2af9a3df3c4$var$ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */ function $eec8d2af9a3df3c4$var$isAscii(str) {
    (0, $eec8d2af9a3df3c4$var$_assertString.default)(str);
    return $eec8d2af9a3df3c4$var$ascii.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bWCzj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b23076cff48e676$var$isFullWidth;
module.exports.fullWidth = void 0;

var $8b23076cff48e676$var$_assertString = $8b23076cff48e676$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $8b23076cff48e676$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b23076cff48e676$var$fullWidth = module.exports.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
function $8b23076cff48e676$var$isFullWidth(str) {
    (0, $8b23076cff48e676$var$_assertString.default)(str);
    return $8b23076cff48e676$var$fullWidth.test(str);
}

});

parcelRegister("9f357", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ba7e7b5b229752c$var$isHalfWidth;
module.exports.halfWidth = void 0;

var $6ba7e7b5b229752c$var$_assertString = $6ba7e7b5b229752c$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6ba7e7b5b229752c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6ba7e7b5b229752c$var$halfWidth = module.exports.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
function $6ba7e7b5b229752c$var$isHalfWidth(str) {
    (0, $6ba7e7b5b229752c$var$_assertString.default)(str);
    return $6ba7e7b5b229752c$var$halfWidth.test(str);
}

});

parcelRegister("jYPXr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8bbeca350108392$var$isVariableWidth;

var $e8bbeca350108392$var$_assertString = $e8bbeca350108392$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $bWCzj = parcelRequire("bWCzj");

var $9f357 = parcelRequire("9f357");
function $e8bbeca350108392$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e8bbeca350108392$var$isVariableWidth(str) {
    (0, $e8bbeca350108392$var$_assertString.default)(str);
    return $bWCzj.fullWidth.test(str) && $9f357.halfWidth.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("81UkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d8a1de734322b4d$var$isMultibyte;

var $5d8a1de734322b4d$var$_assertString = $5d8a1de734322b4d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $5d8a1de734322b4d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable no-control-regex */ var $5d8a1de734322b4d$var$multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */ function $5d8a1de734322b4d$var$isMultibyte(str) {
    (0, $5d8a1de734322b4d$var$_assertString.default)(str);
    return $5d8a1de734322b4d$var$multibyte.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("6s9Ea", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b2cd748ca06fca9$var$isSemVer;

var $4b2cd748ca06fca9$var$_assertString = $4b2cd748ca06fca9$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $4b2cd748ca06fca9$var$_multilineRegex = $4b2cd748ca06fca9$var$_interopRequireDefault((parcelRequire("c33Zq")));
function $4b2cd748ca06fca9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Regular Expression to match
 * semantic versioning (SemVer)
 * built from multi-line, multi-parts regexp
 * Reference: https://semver.org/
 */ var $4b2cd748ca06fca9$var$semanticVersioningRegex = (0, $4b2cd748ca06fca9$var$_multilineRegex.default)([
    '^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)',
    '(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))',
    '?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$'
], 'i');
function $4b2cd748ca06fca9$var$isSemVer(str) {
    (0, $4b2cd748ca06fca9$var$_assertString.default)(str);
    return $4b2cd748ca06fca9$var$semanticVersioningRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("c33Zq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c58dc26bf230519$var$multilineRegexp;
/**
 * Build RegExp object from an array
 * of multiple/multi-line regexp parts
 *
 * @param {string[]} parts
 * @param {string} flags
 * @return {object} - RegExp object
 */ function $8c58dc26bf230519$var$multilineRegexp(parts, flags) {
    var regexpAsStringLiteral = parts.join('');
    return new RegExp(regexpAsStringLiteral, flags);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("9zqOS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f7c2fba9f5b4a3d$var$isSurrogatePair;

var $6f7c2fba9f5b4a3d$var$_assertString = $6f7c2fba9f5b4a3d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6f7c2fba9f5b4a3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6f7c2fba9f5b4a3d$var$surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
function $6f7c2fba9f5b4a3d$var$isSurrogatePair(str) {
    (0, $6f7c2fba9f5b4a3d$var$_assertString.default)(str);
    return $6f7c2fba9f5b4a3d$var$surrogatePair.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kfE9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebe45b7e98c30788$var$isDecimal;

var $ebe45b7e98c30788$var$_merge = $ebe45b7e98c30788$var$_interopRequireDefault((parcelRequire("9nDkO")));

var $ebe45b7e98c30788$var$_assertString = $ebe45b7e98c30788$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $ebe45b7e98c30788$var$_includes = $ebe45b7e98c30788$var$_interopRequireDefault((parcelRequire("50PTo")));

var $alkZf = parcelRequire("alkZf");
function $ebe45b7e98c30788$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ebe45b7e98c30788$var$decimalRegExp(options) {
    var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat($alkZf.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
    return regExp;
}
var $ebe45b7e98c30788$var$default_decimal_options = {
    force_decimal: false,
    decimal_digits: '1,',
    locale: 'en-US'
};
var $ebe45b7e98c30788$var$blacklist = [
    '',
    '-',
    '+'
];
function $ebe45b7e98c30788$var$isDecimal(str, options) {
    (0, $ebe45b7e98c30788$var$_assertString.default)(str);
    options = (0, $ebe45b7e98c30788$var$_merge.default)(options, $ebe45b7e98c30788$var$default_decimal_options);
    if (options.locale in $alkZf.decimal) return !(0, $ebe45b7e98c30788$var$_includes.default)($ebe45b7e98c30788$var$blacklist, str.replace(/ /g, '')) && $ebe45b7e98c30788$var$decimalRegExp(options).test(str);
    throw new Error("Invalid locale '".concat(options.locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("50PTo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3a6534927f41e9ed$var$includes = function includes(arr, val) {
    return arr.some(function(arrVal) {
        return val === arrVal;
    });
};
var $3a6534927f41e9ed$var$_default = module.exports.default = $3a6534927f41e9ed$var$includes;
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("38ASS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $248ebae2a70d0d08$var$isHexadecimal;

var $248ebae2a70d0d08$var$_assertString = $248ebae2a70d0d08$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $248ebae2a70d0d08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $248ebae2a70d0d08$var$hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;
function $248ebae2a70d0d08$var$isHexadecimal(str) {
    (0, $248ebae2a70d0d08$var$_assertString.default)(str);
    return $248ebae2a70d0d08$var$hexadecimal.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8h9xl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60674f1165de5f72$var$isOctal;

var $60674f1165de5f72$var$_assertString = $60674f1165de5f72$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $60674f1165de5f72$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $60674f1165de5f72$var$octal = /^(0o)?[0-7]+$/i;
function $60674f1165de5f72$var$isOctal(str) {
    (0, $60674f1165de5f72$var$_assertString.default)(str);
    return $60674f1165de5f72$var$octal.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9v3dq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ea980d33c6d7212$var$isDivisibleBy;

var $6ea980d33c6d7212$var$_assertString = $6ea980d33c6d7212$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $6ea980d33c6d7212$var$_toFloat = $6ea980d33c6d7212$var$_interopRequireDefault((parcelRequire("2dcMT")));
function $6ea980d33c6d7212$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6ea980d33c6d7212$var$isDivisibleBy(str, num) {
    (0, $6ea980d33c6d7212$var$_assertString.default)(str);
    return (0, $6ea980d33c6d7212$var$_toFloat.default)(str) % parseInt(num, 10) === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5U1AD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44c36a6c4bb8e24e$var$isHexColor;

var $44c36a6c4bb8e24e$var$_assertString = $44c36a6c4bb8e24e$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $44c36a6c4bb8e24e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $44c36a6c4bb8e24e$var$hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
function $44c36a6c4bb8e24e$var$isHexColor(str) {
    (0, $44c36a6c4bb8e24e$var$_assertString.default)(str);
    return $44c36a6c4bb8e24e$var$hexcolor.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4TDuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $390aef0b3566d2f4$var$isRgbColor;

var $390aef0b3566d2f4$var$_assertString = $390aef0b3566d2f4$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $390aef0b3566d2f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $390aef0b3566d2f4$var$rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
var $390aef0b3566d2f4$var$rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
var $390aef0b3566d2f4$var$rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/;
var $390aef0b3566d2f4$var$rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/;
function $390aef0b3566d2f4$var$isRgbColor(str) {
    var includePercentValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    (0, $390aef0b3566d2f4$var$_assertString.default)(str);
    if (!includePercentValues) return $390aef0b3566d2f4$var$rgbColor.test(str) || $390aef0b3566d2f4$var$rgbaColor.test(str);
    return $390aef0b3566d2f4$var$rgbColor.test(str) || $390aef0b3566d2f4$var$rgbaColor.test(str) || $390aef0b3566d2f4$var$rgbColorPercent.test(str) || $390aef0b3566d2f4$var$rgbaColorPercent.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("1ItuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1400c76cc59fcb10$var$isHSL;

var $1400c76cc59fcb10$var$_assertString = $1400c76cc59fcb10$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $1400c76cc59fcb10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1400c76cc59fcb10$var$hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
var $1400c76cc59fcb10$var$hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
function $1400c76cc59fcb10$var$isHSL(str) {
    (0, $1400c76cc59fcb10$var$_assertString.default)(str);
    // Strip duplicate spaces before calling the validation regex (See  #1598 for more info)
    var strippedStr = str.replace(/\s+/g, ' ').replace(/\s?(hsla?\(|\)|,)\s?/ig, '$1');
    if (strippedStr.indexOf(',') !== -1) return $1400c76cc59fcb10$var$hslComma.test(strippedStr);
    return $1400c76cc59fcb10$var$hslSpace.test(strippedStr);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("gmTuo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bea9be6c80bd86c5$var$isISRC;

var $bea9be6c80bd86c5$var$_assertString = $bea9be6c80bd86c5$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $bea9be6c80bd86c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
var $bea9be6c80bd86c5$var$isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
function $bea9be6c80bd86c5$var$isISRC(str) {
    (0, $bea9be6c80bd86c5$var$_assertString.default)(str);
    return $bea9be6c80bd86c5$var$isrc.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9ExTf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7072235819306928$var$isIBAN;
module.exports.locales = void 0;

var $7072235819306928$var$_assertString = $7072235819306928$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $7072235819306928$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * List of country codes with
 * corresponding IBAN regular expression
 * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
 */ var $7072235819306928$var$ibanRegexThroughCountryCode = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    DZ: /^(DZ\d{24})$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z0-9]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MA: /^(MA[0-9]{26})$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z0-9]{4}\d{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
};
/**
 * Check if the country codes passed are valid using the
 * ibanRegexThroughCountryCode as a reference
 *
 * @param {array} countryCodeArray
 * @return {boolean}
 */ function $7072235819306928$var$hasOnlyValidCountryCodes(countryCodeArray) {
    var countryCodeArrayFilteredWithObjectIbanCode = countryCodeArray.filter(function(countryCode) {
        return !(countryCode in $7072235819306928$var$ibanRegexThroughCountryCode);
    });
    if (countryCodeArrayFilteredWithObjectIbanCode.length > 0) return false;
    return true;
}
/**
 * Check whether string has correct universal IBAN format
 * The IBAN consists of up to 34 alphanumeric characters, as follows:
 * Country Code using ISO 3166-1 alpha-2, two letters
 * check digits, two digits and
 * Basic Bank Account Number (BBAN), up to 30 alphanumeric characters.
 * NOTE: Permitted IBAN characters are: digits [0-9] and the 26 latin alphabetic [A-Z]
 *
 * @param {string} str - string under validation
 * @param {object} options - object to pass the countries to be either whitelisted or blacklisted
 * @return {boolean}
 */ function $7072235819306928$var$hasValidIbanFormat(str, options) {
    // Strip white spaces and hyphens
    var strippedStr = str.replace(/[\s\-]+/gi, '').toUpperCase();
    var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
    var isoCountryCodeInIbanRegexCodeObject = isoCountryCode in $7072235819306928$var$ibanRegexThroughCountryCode;
    if (options.whitelist) {
        if (!$7072235819306928$var$hasOnlyValidCountryCodes(options.whitelist)) return false;
        var isoCountryCodeInWhiteList = options.whitelist.includes(isoCountryCode);
        if (!isoCountryCodeInWhiteList) return false;
    }
    if (options.blacklist) {
        var isoCountryCodeInBlackList = options.blacklist.includes(isoCountryCode);
        if (isoCountryCodeInBlackList) return false;
    }
    return isoCountryCodeInIbanRegexCodeObject && $7072235819306928$var$ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
}
/**
   * Check whether string has valid IBAN Checksum
   * by performing basic mod-97 operation and
   * the remainder should equal 1
   * -- Start by rearranging the IBAN by moving the four initial characters to the end of the string
   * -- Replace each letter in the string with two digits, A -> 10, B = 11, Z = 35
   * -- Interpret the string as a decimal integer and
   * -- compute the remainder on division by 97 (mod 97)
   * Reference: https://en.wikipedia.org/wiki/International_Bank_Account_Number
   *
   * @param {string} str
   * @return {boolean}
   */ function $7072235819306928$var$hasValidIbanChecksum(str) {
    var strippedStr = str.replace(/[^A-Z0-9]+/gi, '').toUpperCase(); // Keep only digits and A-Z latin alphabetic
    var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
    var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function(char) {
        return char.charCodeAt(0) - 55;
    });
    var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function(acc, value) {
        return Number(acc + value) % 97;
    }, '');
    return remainder === 1;
}
function $7072235819306928$var$isIBAN(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $7072235819306928$var$_assertString.default)(str);
    return $7072235819306928$var$hasValidIbanFormat(str, options) && $7072235819306928$var$hasValidIbanChecksum(str);
}
var $7072235819306928$var$locales = module.exports.locales = Object.keys($7072235819306928$var$ibanRegexThroughCountryCode);

});

parcelRegister("e8bY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a49b18d144a3295b$var$isBIC;

var $a49b18d144a3295b$var$_assertString = $a49b18d144a3295b$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $dVkQR = parcelRequire("dVkQR");
function $a49b18d144a3295b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://en.wikipedia.org/wiki/ISO_9362
var $a49b18d144a3295b$var$isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
function $a49b18d144a3295b$var$isBIC(str) {
    (0, $a49b18d144a3295b$var$_assertString.default)(str);
    // toUpperCase() should be removed when a new major version goes out that changes
    // the regex to [A-Z] (per the spec).
    var countryCode = str.slice(4, 6).toUpperCase();
    if (!$dVkQR.CountryCodes.has(countryCode) && countryCode !== 'XK') return false;
    return $a49b18d144a3295b$var$isBICReg.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("dVkQR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CountryCodes = void 0;
module.exports.default = $a230c5ed9d5317f3$var$isISO31661Alpha2;

var $a230c5ed9d5317f3$var$_assertString = $a230c5ed9d5317f3$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $a230c5ed9d5317f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
var $a230c5ed9d5317f3$var$validISO31661Alpha2CountriesCodes = new Set([
    'AD',
    'AE',
    'AF',
    'AG',
    'AI',
    'AL',
    'AM',
    'AO',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AW',
    'AX',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BL',
    'BM',
    'BN',
    'BO',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BV',
    'BW',
    'BY',
    'BZ',
    'CA',
    'CC',
    'CD',
    'CF',
    'CG',
    'CH',
    'CI',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CR',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DE',
    'DJ',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'EH',
    'ER',
    'ES',
    'ET',
    'FI',
    'FJ',
    'FK',
    'FM',
    'FO',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GL',
    'GM',
    'GN',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GW',
    'GY',
    'HK',
    'HM',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IM',
    'IN',
    'IO',
    'IQ',
    'IR',
    'IS',
    'IT',
    'JE',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KP',
    'KR',
    'KW',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'LY',
    'MA',
    'MC',
    'MD',
    'ME',
    'MF',
    'MG',
    'MH',
    'MK',
    'ML',
    'MM',
    'MN',
    'MO',
    'MP',
    'MQ',
    'MR',
    'MS',
    'MT',
    'MU',
    'MV',
    'MW',
    'MX',
    'MY',
    'MZ',
    'NA',
    'NC',
    'NE',
    'NF',
    'NG',
    'NI',
    'NL',
    'NO',
    'NP',
    'NR',
    'NU',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PF',
    'PG',
    'PH',
    'PK',
    'PL',
    'PM',
    'PN',
    'PR',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RE',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SR',
    'SS',
    'ST',
    'SV',
    'SX',
    'SY',
    'SZ',
    'TC',
    'TD',
    'TF',
    'TG',
    'TH',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'UM',
    'US',
    'UY',
    'UZ',
    'VA',
    'VC',
    'VE',
    'VG',
    'VI',
    'VN',
    'VU',
    'WF',
    'WS',
    'YE',
    'YT',
    'ZA',
    'ZM',
    'ZW'
]);
function $a230c5ed9d5317f3$var$isISO31661Alpha2(str) {
    (0, $a230c5ed9d5317f3$var$_assertString.default)(str);
    return $a230c5ed9d5317f3$var$validISO31661Alpha2CountriesCodes.has(str.toUpperCase());
}
var $a230c5ed9d5317f3$var$CountryCodes = module.exports.CountryCodes = $a230c5ed9d5317f3$var$validISO31661Alpha2CountriesCodes;

});


parcelRegister("gdrTg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bce37eb1c1c7fe42$var$isMD5;

var $bce37eb1c1c7fe42$var$_assertString = $bce37eb1c1c7fe42$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $bce37eb1c1c7fe42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bce37eb1c1c7fe42$var$md5 = /^[a-f0-9]{32}$/;
function $bce37eb1c1c7fe42$var$isMD5(str) {
    (0, $bce37eb1c1c7fe42$var$_assertString.default)(str);
    return $bce37eb1c1c7fe42$var$md5.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7D4H0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58dfd0c424e5d590$var$isHash;

var $58dfd0c424e5d590$var$_assertString = $58dfd0c424e5d590$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $58dfd0c424e5d590$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $58dfd0c424e5d590$var$lengths = {
    md5: 32,
    md4: 32,
    sha1: 40,
    sha256: 64,
    sha384: 96,
    sha512: 128,
    ripemd128: 32,
    ripemd160: 40,
    tiger128: 32,
    tiger160: 40,
    tiger192: 48,
    crc32: 8,
    crc32b: 8
};
function $58dfd0c424e5d590$var$isHash(str, algorithm) {
    (0, $58dfd0c424e5d590$var$_assertString.default)(str);
    var hash = new RegExp("^[a-fA-F0-9]{".concat($58dfd0c424e5d590$var$lengths[algorithm], "}$"));
    return hash.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bRpBC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a2881bb7933cdca$var$isJWT;

var $8a2881bb7933cdca$var$_assertString = $8a2881bb7933cdca$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $8a2881bb7933cdca$var$_isBase = $8a2881bb7933cdca$var$_interopRequireDefault((parcelRequire("2d8yt")));
function $8a2881bb7933cdca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8a2881bb7933cdca$var$isJWT(str) {
    (0, $8a2881bb7933cdca$var$_assertString.default)(str);
    var dotSplit = str.split('.');
    var len = dotSplit.length;
    if (len !== 3) return false;
    return dotSplit.reduce(function(acc, currElem) {
        return acc && (0, $8a2881bb7933cdca$var$_isBase.default)(currElem, {
            urlSafe: true
        });
    }, true);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("2d8yt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19c36e838f8f524b$var$isBase64;

var $19c36e838f8f524b$var$_assertString = $19c36e838f8f524b$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $19c36e838f8f524b$var$_merge = $19c36e838f8f524b$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $19c36e838f8f524b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $19c36e838f8f524b$var$notBase64 = /[^A-Z0-9+\/=]/i;
var $19c36e838f8f524b$var$urlSafeBase64 = /^[A-Z0-9_\-]*$/i;
var $19c36e838f8f524b$var$defaultBase64Options = {
    urlSafe: false
};
function $19c36e838f8f524b$var$isBase64(str, options) {
    (0, $19c36e838f8f524b$var$_assertString.default)(str);
    options = (0, $19c36e838f8f524b$var$_merge.default)(options, $19c36e838f8f524b$var$defaultBase64Options);
    var len = str.length;
    if (options.urlSafe) return $19c36e838f8f524b$var$urlSafeBase64.test(str);
    if (len % 4 !== 0 || $19c36e838f8f524b$var$notBase64.test(str)) return false;
    var firstPaddingChar = str.indexOf('=');
    return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("c8148", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8d470f009bf41c55$var$isJSON;

var $8d470f009bf41c55$var$_assertString = $8d470f009bf41c55$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $8d470f009bf41c55$var$_merge = $8d470f009bf41c55$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $8d470f009bf41c55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8d470f009bf41c55$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8d470f009bf41c55$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8d470f009bf41c55$var$_typeof(o);
}
var $8d470f009bf41c55$var$default_json_options = {
    allow_primitives: false
};
function $8d470f009bf41c55$var$isJSON(str, options) {
    (0, $8d470f009bf41c55$var$_assertString.default)(str);
    try {
        options = (0, $8d470f009bf41c55$var$_merge.default)(options, $8d470f009bf41c55$var$default_json_options);
        var primitives = [];
        if (options.allow_primitives) primitives = [
            null,
            false,
            true
        ];
        var obj = JSON.parse(str);
        return primitives.includes(obj) || !!obj && $8d470f009bf41c55$var$_typeof(obj) === 'object';
    } catch (e) {}
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9itI6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c4cd75abfa8bb24$var$isEmpty;

var $6c4cd75abfa8bb24$var$_assertString = $6c4cd75abfa8bb24$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $6c4cd75abfa8bb24$var$_merge = $6c4cd75abfa8bb24$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $6c4cd75abfa8bb24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6c4cd75abfa8bb24$var$default_is_empty_options = {
    ignore_whitespace: false
};
function $6c4cd75abfa8bb24$var$isEmpty(str, options) {
    (0, $6c4cd75abfa8bb24$var$_assertString.default)(str);
    options = (0, $6c4cd75abfa8bb24$var$_merge.default)(options, $6c4cd75abfa8bb24$var$default_is_empty_options);
    return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("eX4Zk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae2a71e7d26a4a8b$var$isLength;

var $ae2a71e7d26a4a8b$var$_assertString = $ae2a71e7d26a4a8b$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $ae2a71e7d26a4a8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ae2a71e7d26a4a8b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ae2a71e7d26a4a8b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ae2a71e7d26a4a8b$var$_typeof(o);
}
/* eslint-disable prefer-rest-params */ function $ae2a71e7d26a4a8b$var$isLength(str, options) {
    (0, $ae2a71e7d26a4a8b$var$_assertString.default)(str);
    var min;
    var max;
    if ($ae2a71e7d26a4a8b$var$_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isLength(str, min [, max])
        min = arguments[1] || 0;
        max = arguments[2];
    }
    var presentationSequences = str.match(/(\uFE0F|\uFE0E)/g) || [];
    var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
    var len = str.length - presentationSequences.length - surrogatePairs.length;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("99DHM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6aa3c0ee63d0e523$var$isUUID;

var $6aa3c0ee63d0e523$var$_assertString = $6aa3c0ee63d0e523$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6aa3c0ee63d0e523$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6aa3c0ee63d0e523$var$uuid = {
    1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
    4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
    all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};
function $6aa3c0ee63d0e523$var$isUUID(str, version) {
    (0, $6aa3c0ee63d0e523$var$_assertString.default)(str);
    var pattern = $6aa3c0ee63d0e523$var$uuid[![
        undefined,
        null
    ].includes(version) ? version : 'all'];
    return !!pattern && pattern.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("jEKS4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4f61c62c0f4de4a$var$isMongoId;

var $e4f61c62c0f4de4a$var$_assertString = $e4f61c62c0f4de4a$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $e4f61c62c0f4de4a$var$_isHexadecimal = $e4f61c62c0f4de4a$var$_interopRequireDefault((parcelRequire("38ASS")));
function $e4f61c62c0f4de4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e4f61c62c0f4de4a$var$isMongoId(str) {
    (0, $e4f61c62c0f4de4a$var$_assertString.default)(str);
    return (0, $e4f61c62c0f4de4a$var$_isHexadecimal.default)(str) && str.length === 24;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("fGRWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6c4a03b7a1fc8a6$var$isAfter;

var $b6c4a03b7a1fc8a6$var$_toDate = $b6c4a03b7a1fc8a6$var$_interopRequireDefault((parcelRequire("gr6fc")));
function $b6c4a03b7a1fc8a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b6c4a03b7a1fc8a6$var$isAfter(date, options) {
    // For backwards compatibility:
    // isAfter(str [, date]), i.e. `options` could be used as argument for the legacy `date`
    var comparisonDate = (options === null || options === void 0 ? void 0 : options.comparisonDate) || options || Date().toString();
    var comparison = (0, $b6c4a03b7a1fc8a6$var$_toDate.default)(comparisonDate);
    var original = (0, $b6c4a03b7a1fc8a6$var$_toDate.default)(date);
    return !!(original && comparison && original > comparison);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5bvc1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c662d12926f8713$var$isBefore;

var $3c662d12926f8713$var$_assertString = $3c662d12926f8713$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $3c662d12926f8713$var$_toDate = $3c662d12926f8713$var$_interopRequireDefault((parcelRequire("gr6fc")));
function $3c662d12926f8713$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c662d12926f8713$var$isBefore(str) {
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
    (0, $3c662d12926f8713$var$_assertString.default)(str);
    var comparison = (0, $3c662d12926f8713$var$_toDate.default)(date);
    var original = (0, $3c662d12926f8713$var$_toDate.default)(str);
    return !!(original && comparison && original < comparison);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kMIcK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f21a9475445da859$var$isIn;

var $f21a9475445da859$var$_assertString = $f21a9475445da859$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $f21a9475445da859$var$_toString = $f21a9475445da859$var$_interopRequireDefault((parcelRequire("dAq0G")));
function $f21a9475445da859$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f21a9475445da859$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f21a9475445da859$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f21a9475445da859$var$_typeof(o);
}
function $f21a9475445da859$var$isIn(str, options) {
    (0, $f21a9475445da859$var$_assertString.default)(str);
    var i;
    if (Object.prototype.toString.call(options) === '[object Array]') {
        var array = [];
        for(i in options)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if (({}).hasOwnProperty.call(options, i)) array[i] = (0, $f21a9475445da859$var$_toString.default)(options[i]);
        return array.indexOf(str) >= 0;
    } else if ($f21a9475445da859$var$_typeof(options) === 'object') return options.hasOwnProperty(str);
    else if (options && typeof options.indexOf === 'function') return options.indexOf(str) >= 0;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9Ua0q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73611af4fd666dca$var$isLuhnNumber;

var $73611af4fd666dca$var$_assertString = $73611af4fd666dca$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $73611af4fd666dca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $73611af4fd666dca$var$isLuhnNumber(str) {
    (0, $73611af4fd666dca$var$_assertString.default)(str);
    var sanitized = str.replace(/[- ]+/g, '');
    var sum = 0;
    var digit;
    var tmpNum;
    var shouldDouble;
    for(var i = sanitized.length - 1; i >= 0; i--){
        digit = sanitized.substring(i, i + 1);
        tmpNum = parseInt(digit, 10);
        if (shouldDouble) {
            tmpNum *= 2;
            if (tmpNum >= 10) sum += tmpNum % 10 + 1;
            else sum += tmpNum;
        } else sum += tmpNum;
        shouldDouble = !shouldDouble;
    }
    return !!(sum % 10 === 0 ? sanitized : false);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bBCuW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8731034d9066fcdf$var$isCreditCard;

var $8731034d9066fcdf$var$_assertString = $8731034d9066fcdf$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $8731034d9066fcdf$var$_isLuhnNumber = $8731034d9066fcdf$var$_interopRequireDefault((parcelRequire("9Ua0q")));
function $8731034d9066fcdf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8731034d9066fcdf$var$cards = {
    amex: /^3[47][0-9]{13}$/,
    dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
    // /^[25][1-7][0-9]{14}$/;
    unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
    visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
};
var $8731034d9066fcdf$var$allCards = function() {
    var tmpCardsArray = [];
    for(var cardProvider in $8731034d9066fcdf$var$cards)// istanbul ignore else
    if ($8731034d9066fcdf$var$cards.hasOwnProperty(cardProvider)) tmpCardsArray.push($8731034d9066fcdf$var$cards[cardProvider]);
    return tmpCardsArray;
}();
function $8731034d9066fcdf$var$isCreditCard(card) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $8731034d9066fcdf$var$_assertString.default)(card);
    var provider = options.provider;
    var sanitized = card.replace(/[- ]+/g, '');
    if (provider && provider.toLowerCase() in $8731034d9066fcdf$var$cards) {
        // specific provider in the list
        if (!$8731034d9066fcdf$var$cards[provider.toLowerCase()].test(sanitized)) return false;
    } else if (provider && !(provider.toLowerCase() in $8731034d9066fcdf$var$cards)) /* specific provider not in the list */ throw new Error("".concat(provider, " is not a valid credit card provider."));
    else if (!$8731034d9066fcdf$var$allCards.some(function(cardProvider) {
        return cardProvider.test(sanitized);
    })) // no specific provider
    return false;
    return (0, $8731034d9066fcdf$var$_isLuhnNumber.default)(card);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ilQ4n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5c2941d31196eff$var$isIdentityCard;

var $d5c2941d31196eff$var$_assertString = $d5c2941d31196eff$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $d5c2941d31196eff$var$_isInt = $d5c2941d31196eff$var$_interopRequireDefault((parcelRequire("3VTZw")));
function $d5c2941d31196eff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d5c2941d31196eff$var$validators = {
    PL: function PL(str) {
        (0, $d5c2941d31196eff$var$_assertString.default)(str);
        var weightOfDigits = {
            1: 1,
            2: 3,
            3: 7,
            4: 9,
            5: 1,
            6: 3,
            7: 7,
            8: 9,
            9: 1,
            10: 3,
            11: 0
        };
        if (str != null && str.length === 11 && (0, $d5c2941d31196eff$var$_isInt.default)(str, {
            allow_leading_zeroes: true
        })) {
            var digits = str.split('').slice(0, -1);
            var sum = digits.reduce(function(acc, digit, index) {
                return acc + Number(digit) * weightOfDigits[index + 1];
            }, 0);
            var modulo = sum % 10;
            var lastDigit = Number(str.charAt(str.length - 1));
            if (modulo === 0 && lastDigit === 0 || lastDigit === 10 - modulo) return true;
        }
        return false;
    },
    ES: function ES(str) {
        (0, $d5c2941d31196eff$var$_assertString.default)(str);
        var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
        var charsValue = {
            X: 0,
            Y: 1,
            Z: 2
        };
        var controlDigits = [
            'T',
            'R',
            'W',
            'A',
            'G',
            'M',
            'Y',
            'F',
            'P',
            'D',
            'X',
            'B',
            'N',
            'J',
            'Z',
            'S',
            'Q',
            'V',
            'H',
            'L',
            'C',
            'K',
            'E'
        ];
        // sanitize user input
        var sanitized = str.trim().toUpperCase();
        // validate the data structure
        if (!DNI.test(sanitized)) return false;
        // validate the control digit
        var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function(char) {
            return charsValue[char];
        });
        return sanitized.endsWith(controlDigits[number % 23]);
    },
    FI: function FI(str) {
        // https://dvv.fi/en/personal-identity-code#:~:text=control%20character%20for%20a-,personal,-identity%20code%20calculated
        (0, $d5c2941d31196eff$var$_assertString.default)(str);
        if (str.length !== 11) return false;
        if (!str.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) return false;
        var checkDigits = '0123456789ABCDEFHJKLMNPRSTUVWXY';
        var idAsNumber = parseInt(str.slice(0, 6), 10) * 1000 + parseInt(str.slice(7, 10), 10);
        var remainder = idAsNumber % 31;
        var checkDigit = checkDigits[remainder];
        return checkDigit === str.slice(10, 11);
    },
    IN: function IN(str) {
        var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/;
        // multiplication table
        var d = [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ],
            [
                1,
                2,
                3,
                4,
                0,
                6,
                7,
                8,
                9,
                5
            ],
            [
                2,
                3,
                4,
                0,
                1,
                7,
                8,
                9,
                5,
                6
            ],
            [
                3,
                4,
                0,
                1,
                2,
                8,
                9,
                5,
                6,
                7
            ],
            [
                4,
                0,
                1,
                2,
                3,
                9,
                5,
                6,
                7,
                8
            ],
            [
                5,
                9,
                8,
                7,
                6,
                0,
                4,
                3,
                2,
                1
            ],
            [
                6,
                5,
                9,
                8,
                7,
                1,
                0,
                4,
                3,
                2
            ],
            [
                7,
                6,
                5,
                9,
                8,
                2,
                1,
                0,
                4,
                3
            ],
            [
                8,
                7,
                6,
                5,
                9,
                3,
                2,
                1,
                0,
                4
            ],
            [
                9,
                8,
                7,
                6,
                5,
                4,
                3,
                2,
                1,
                0
            ]
        ];
        // permutation table
        var p = [
            [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9
            ],
            [
                1,
                5,
                7,
                6,
                2,
                8,
                3,
                0,
                9,
                4
            ],
            [
                5,
                8,
                0,
                3,
                7,
                9,
                6,
                1,
                4,
                2
            ],
            [
                8,
                9,
                1,
                6,
                0,
                4,
                3,
                5,
                2,
                7
            ],
            [
                9,
                4,
                5,
                3,
                1,
                2,
                6,
                8,
                7,
                0
            ],
            [
                4,
                2,
                8,
                6,
                5,
                7,
                3,
                9,
                0,
                1
            ],
            [
                2,
                7,
                9,
                3,
                8,
                0,
                6,
                4,
                1,
                5
            ],
            [
                7,
                0,
                4,
                6,
                9,
                1,
                3,
                2,
                5,
                8
            ]
        ];
        // sanitize user input
        var sanitized = str.trim();
        // validate the data structure
        if (!DNI.test(sanitized)) return false;
        var c = 0;
        var invertedArray = sanitized.replace(/\s/g, '').split('').map(Number).reverse();
        invertedArray.forEach(function(val, i) {
            c = d[c][p[i % 8][val]];
        });
        return c === 0;
    },
    IR: function IR(str) {
        if (!str.match(/^\d{10}$/)) return false;
        str = "0000".concat(str).slice(str.length - 6);
        if (parseInt(str.slice(3, 9), 10) === 0) return false;
        var lastNumber = parseInt(str.slice(9, 10), 10);
        var sum = 0;
        for(var i = 0; i < 9; i++)sum += parseInt(str.slice(i, i + 1), 10) * (10 - i);
        sum %= 11;
        return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
    },
    IT: function IT(str) {
        if (str.length !== 9) return false;
        if (str === 'CA00000AA') return false; // https://it.wikipedia.org/wiki/Carta_d%27identit%C3%A0_elettronica_italiana
        return str.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
    },
    NO: function NO(str) {
        var sanitized = str.trim();
        if (isNaN(Number(sanitized))) return false;
        if (sanitized.length !== 11) return false;
        if (sanitized === '00000000000') return false;
        // https://no.wikipedia.org/wiki/F%C3%B8dselsnummer
        var f = sanitized.split('').map(Number);
        var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
        var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
        if (k1 !== f[9] || k2 !== f[10]) return false;
        return true;
    },
    TH: function TH(str) {
        if (!str.match(/^[1-8]\d{12}$/)) return false;
        // validate check digit
        var sum = 0;
        for(var i = 0; i < 12; i++)sum += parseInt(str[i], 10) * (13 - i);
        return str[12] === ((11 - sum % 11) % 10).toString();
    },
    LK: function LK(str) {
        var old_nic = /^[1-9]\d{8}[vx]$/i;
        var new_nic = /^[1-9]\d{11}$/i;
        if (str.length === 10 && old_nic.test(str)) return true;
        else if (str.length === 12 && new_nic.test(str)) return true;
        return false;
    },
    'he-IL': function heIL(str) {
        var DNI = /^\d{9}$/;
        // sanitize user input
        var sanitized = str.trim();
        // validate the data structure
        if (!DNI.test(sanitized)) return false;
        var id = sanitized;
        var sum = 0, incNum;
        for(var i = 0; i < id.length; i++){
            incNum = Number(id[i]) * (i % 2 + 1); // Multiply number by 1 or 2
            sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
        }
        return sum % 10 === 0;
    },
    'ar-LY': function arLY(str) {
        // Libya National Identity Number NIN is 12 digits, the first digit is either 1 or 2
        var NIN = /^(1|2)\d{11}$/;
        // sanitize user input
        var sanitized = str.trim();
        // validate the data structure
        if (!NIN.test(sanitized)) return false;
        return true;
    },
    'ar-TN': function arTN(str) {
        var DNI = /^\d{8}$/;
        // sanitize user input
        var sanitized = str.trim();
        // validate the data structure
        if (!DNI.test(sanitized)) return false;
        return true;
    },
    'zh-CN': function zhCN(str) {
        var provincesAndCities = [
            '11',
            // 北京
            '12',
            // 天津
            '13',
            // 河北
            '14',
            // 山西
            '15',
            // 内蒙古
            '21',
            // 辽宁
            '22',
            // 吉林
            '23',
            // 黑龙江
            '31',
            // 上海
            '32',
            // 江苏
            '33',
            // 浙江
            '34',
            // 安徽
            '35',
            // 福建
            '36',
            // 江西
            '37',
            // 山东
            '41',
            // 河南
            '42',
            // 湖北
            '43',
            // 湖南
            '44',
            // 广东
            '45',
            // 广西
            '46',
            // 海南
            '50',
            // 重庆
            '51',
            // 四川
            '52',
            // 贵州
            '53',
            // 云南
            '54',
            // 西藏
            '61',
            // 陕西
            '62',
            // 甘肃
            '63',
            // 青海
            '64',
            // 宁夏
            '65',
            // 新疆
            '71',
            // 台湾
            '81',
            // 香港
            '82',
            // 澳门
            '91' // 国外
        ];
        var powers = [
            '7',
            '9',
            '10',
            '5',
            '8',
            '4',
            '2',
            '1',
            '6',
            '3',
            '7',
            '9',
            '10',
            '5',
            '8',
            '4',
            '2'
        ];
        var parityBit = [
            '1',
            '0',
            'X',
            '9',
            '8',
            '7',
            '6',
            '5',
            '4',
            '3',
            '2'
        ];
        var checkAddressCode = function checkAddressCode(addressCode) {
            return provincesAndCities.includes(addressCode);
        };
        var checkBirthDayCode = function checkBirthDayCode(birDayCode) {
            var yyyy = parseInt(birDayCode.substring(0, 4), 10);
            var mm = parseInt(birDayCode.substring(4, 6), 10);
            var dd = parseInt(birDayCode.substring(6), 10);
            var xdata = new Date(yyyy, mm - 1, dd);
            if (xdata > new Date()) return false;
            else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) return true;
            return false;
        };
        var getParityBit = function getParityBit(idCardNo) {
            var id17 = idCardNo.substring(0, 17);
            var power = 0;
            for(var i = 0; i < 17; i++)power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
            var mod = power % 11;
            return parityBit[mod];
        };
        var checkParityBit = function checkParityBit(idCardNo) {
            return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
        };
        var check15IdCardNo = function check15IdCardNo(idCardNo) {
            var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
            if (!check) return false;
            var addressCode = idCardNo.substring(0, 2);
            check = checkAddressCode(addressCode);
            if (!check) return false;
            var birDayCode = "19".concat(idCardNo.substring(6, 12));
            check = checkBirthDayCode(birDayCode);
            if (!check) return false;
            return true;
        };
        var check18IdCardNo = function check18IdCardNo(idCardNo) {
            var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
            if (!check) return false;
            var addressCode = idCardNo.substring(0, 2);
            check = checkAddressCode(addressCode);
            if (!check) return false;
            var birDayCode = idCardNo.substring(6, 14);
            check = checkBirthDayCode(birDayCode);
            if (!check) return false;
            return checkParityBit(idCardNo);
        };
        var checkIdCardNo = function checkIdCardNo(idCardNo) {
            var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
            if (!check) return false;
            if (idCardNo.length === 15) return check15IdCardNo(idCardNo);
            return check18IdCardNo(idCardNo);
        };
        return checkIdCardNo(str);
    },
    'zh-HK': function zhHK(str) {
        // sanitize user input
        str = str.trim();
        // HKID number starts with 1 or 2 letters, followed by 6 digits,
        // then a checksum contained in square / round brackets or nothing
        var regexHKID = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/;
        var regexIsDigit = /^[0-9]$/;
        // convert the user input to all uppercase and apply regex
        str = str.toUpperCase();
        if (!regexHKID.test(str)) return false;
        str = str.replace(/\[|\]|\(|\)/g, '');
        if (str.length === 8) str = "3".concat(str);
        var checkSumVal = 0;
        for(var i = 0; i <= 7; i++){
            var convertedChar = void 0;
            if (!regexIsDigit.test(str[i])) convertedChar = (str[i].charCodeAt(0) - 55) % 11;
            else convertedChar = str[i];
            checkSumVal += convertedChar * (9 - i);
        }
        checkSumVal %= 11;
        var checkSumConverted;
        if (checkSumVal === 0) checkSumConverted = '0';
        else if (checkSumVal === 1) checkSumConverted = 'A';
        else checkSumConverted = String(11 - checkSumVal);
        if (checkSumConverted === str[str.length - 1]) return true;
        return false;
    },
    'zh-TW': function zhTW(str) {
        var ALPHABET_CODES = {
            A: 10,
            B: 11,
            C: 12,
            D: 13,
            E: 14,
            F: 15,
            G: 16,
            H: 17,
            I: 34,
            J: 18,
            K: 19,
            L: 20,
            M: 21,
            N: 22,
            O: 35,
            P: 23,
            Q: 24,
            R: 25,
            S: 26,
            T: 27,
            U: 28,
            V: 29,
            W: 32,
            X: 30,
            Y: 31,
            Z: 33
        };
        var sanitized = str.trim().toUpperCase();
        if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
        return Array.from(sanitized).reduce(function(sum, number, index) {
            if (index === 0) {
                var code = ALPHABET_CODES[number];
                return code % 10 * 9 + Math.floor(code / 10);
            }
            if (index === 9) return (10 - sum % 10 - Number(number)) % 10 === 0;
            return sum + Number(number) * (9 - index);
        }, 0);
    }
};
function $d5c2941d31196eff$var$isIdentityCard(str, locale) {
    (0, $d5c2941d31196eff$var$_assertString.default)(str);
    if (locale in $d5c2941d31196eff$var$validators) return $d5c2941d31196eff$var$validators[locale](str);
    else if (locale === 'any') {
        for(var key in $d5c2941d31196eff$var$validators)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($d5c2941d31196eff$var$validators.hasOwnProperty(key)) {
            var validator = $d5c2941d31196eff$var$validators[key];
            if (validator(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("5tfrP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fbba4ca931cf742$var$isEAN;

var $3fbba4ca931cf742$var$_assertString = $3fbba4ca931cf742$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $3fbba4ca931cf742$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The most commonly used EAN standard is
 * the thirteen-digit EAN-13, while the
 * less commonly used 8-digit EAN-8 barcode was
 * introduced for use on small packages.
 * Also EAN/UCC-14 is used for Grouping of individual
 * trade items above unit level(Intermediate, Carton or Pallet).
 * For more info about EAN-14 checkout: https://www.gtin.info/itf-14-barcodes/
 * EAN consists of:
 * GS1 prefix, manufacturer code, product code and check digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number
 * Reference: https://www.gtin.info/
 */ /**
 * Define EAN Lenghts; 8 for EAN-8; 13 for EAN-13; 14 for EAN-14
 * and Regular Expression for valid EANs (EAN-8, EAN-13, EAN-14),
 * with exact numberic matching of 8 or 13 or 14 digits [0-9]
 */ var $3fbba4ca931cf742$var$LENGTH_EAN_8 = 8;
var $3fbba4ca931cf742$var$LENGTH_EAN_14 = 14;
var $3fbba4ca931cf742$var$validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
/**
 * Get position weight given:
 * EAN length and digit index/position
 *
 * @param {number} length
 * @param {number} index
 * @return {number}
 */ function $3fbba4ca931cf742$var$getPositionWeightThroughLengthAndIndex(length, index) {
    if (length === $3fbba4ca931cf742$var$LENGTH_EAN_8 || length === $3fbba4ca931cf742$var$LENGTH_EAN_14) return index % 2 === 0 ? 3 : 1;
    return index % 2 === 0 ? 1 : 3;
}
/**
 * Calculate EAN Check Digit
 * Reference: https://en.wikipedia.org/wiki/International_Article_Number#Calculation_of_checksum_digit
 *
 * @param {string} ean
 * @return {number}
 */ function $3fbba4ca931cf742$var$calculateCheckDigit(ean) {
    var checksum = ean.slice(0, -1).split('').map(function(char, index) {
        return Number(char) * $3fbba4ca931cf742$var$getPositionWeightThroughLengthAndIndex(ean.length, index);
    }).reduce(function(acc, partialSum) {
        return acc + partialSum;
    }, 0);
    var remainder = 10 - checksum % 10;
    return remainder < 10 ? remainder : 0;
}
/**
 * Check if string is valid EAN:
 * Matches EAN-8/EAN-13/EAN-14 regex
 * Has valid check digit.
 *
 * @param {string} str
 * @return {boolean}
 */ function $3fbba4ca931cf742$var$isEAN(str) {
    (0, $3fbba4ca931cf742$var$_assertString.default)(str);
    var actualCheckDigit = Number(str.slice(-1));
    return $3fbba4ca931cf742$var$validEanRegex.test(str) && actualCheckDigit === $3fbba4ca931cf742$var$calculateCheckDigit(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("doEvT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c0cf15b883fddea$var$isISIN;

var $9c0cf15b883fddea$var$_assertString = $9c0cf15b883fddea$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9c0cf15b883fddea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9c0cf15b883fddea$var$isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
// this link details how the check digit is calculated:
// https://www.isin.org/isin-format/. it is a little bit
// odd in that it works with digits, not numbers. in order
// to make only one pass through the ISIN characters, the
// each alpha character is handled as 2 characters within
// the loop.
function $9c0cf15b883fddea$var$isISIN(str) {
    (0, $9c0cf15b883fddea$var$_assertString.default)(str);
    if (!$9c0cf15b883fddea$var$isin.test(str)) return false;
    var double = true;
    var sum = 0;
    // convert values
    for(var i = str.length - 2; i >= 0; i--)if (str[i] >= 'A' && str[i] <= 'Z') {
        var value = str[i].charCodeAt(0) - 55;
        var lo = value % 10;
        var hi = Math.trunc(value / 10);
        // letters have two digits, so handle the low order
        // and high order digits separately.
        for(var _i = 0, _arr = [
            lo,
            hi
        ]; _i < _arr.length; _i++){
            var digit = _arr[_i];
            if (double) {
                if (digit >= 5) sum += 1 + (digit - 5) * 2;
                else sum += digit * 2;
            } else sum += digit;
            double = !double;
        }
    } else {
        var _digit = str[i].charCodeAt(0) - '0'.charCodeAt(0);
        if (double) {
            if (_digit >= 5) sum += 1 + (_digit - 5) * 2;
            else sum += _digit * 2;
        } else sum += _digit;
        double = !double;
    }
    var check = Math.trunc((sum + 9) / 10) * 10 - sum;
    return +str[str.length - 1] === check;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("Eh5kE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0790fd4450fa1eb9$var$isISBN;

var $0790fd4450fa1eb9$var$_assertString = $0790fd4450fa1eb9$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $0790fd4450fa1eb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0790fd4450fa1eb9$var$possibleIsbn10 = /^(?:[0-9]{9}X|[0-9]{10})$/;
var $0790fd4450fa1eb9$var$possibleIsbn13 = /^(?:[0-9]{13})$/;
var $0790fd4450fa1eb9$var$factor = [
    1,
    3
];
function $0790fd4450fa1eb9$var$isISBN(isbn, options) {
    (0, $0790fd4450fa1eb9$var$_assertString.default)(isbn);
    // For backwards compatibility:
    // isISBN(str [, version]), i.e. `options` could be used as argument for the legacy `version`
    var version = String((options === null || options === void 0 ? void 0 : options.version) || options);
    if (!(options !== null && options !== void 0 && options.version || options)) return $0790fd4450fa1eb9$var$isISBN(isbn, {
        version: 10
    }) || $0790fd4450fa1eb9$var$isISBN(isbn, {
        version: 13
    });
    var sanitizedIsbn = isbn.replace(/[\s-]+/g, '');
    var checksum = 0;
    if (version === '10') {
        if (!$0790fd4450fa1eb9$var$possibleIsbn10.test(sanitizedIsbn)) return false;
        for(var i = 0; i < version - 1; i++)checksum += (i + 1) * sanitizedIsbn.charAt(i);
        if (sanitizedIsbn.charAt(9) === 'X') checksum += 100;
        else checksum += 10 * sanitizedIsbn.charAt(9);
        if (checksum % 11 === 0) return true;
    } else if (version === '13') {
        if (!$0790fd4450fa1eb9$var$possibleIsbn13.test(sanitizedIsbn)) return false;
        for(var _i = 0; _i < 12; _i++)checksum += $0790fd4450fa1eb9$var$factor[_i % 2] * sanitizedIsbn.charAt(_i);
        if (sanitizedIsbn.charAt(12) - (10 - checksum % 10) % 10 === 0) return true;
    }
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dzNHd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e2517d1df39314e$var$isISSN;

var $9e2517d1df39314e$var$_assertString = $9e2517d1df39314e$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9e2517d1df39314e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9e2517d1df39314e$var$issn = '^\\d{4}-?\\d{3}[\\dX]$';
function $9e2517d1df39314e$var$isISSN(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $9e2517d1df39314e$var$_assertString.default)(str);
    var testIssn = $9e2517d1df39314e$var$issn;
    testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
    testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');
    if (!testIssn.test(str)) return false;
    var digits = str.replace('-', '').toUpperCase();
    var checksum = 0;
    for(var i = 0; i < digits.length; i++){
        var digit = digits[i];
        checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
    }
    return checksum % 11 === 0;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7Nii9", function(module, exports) {
"use strict";
function $5acb4c63d2aa1a61$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5acb4c63d2aa1a61$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5acb4c63d2aa1a61$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5acb4c63d2aa1a61$var$isTaxID;

var $5acb4c63d2aa1a61$var$_assertString = $5acb4c63d2aa1a61$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $5acb4c63d2aa1a61$var$algorithms = $5acb4c63d2aa1a61$var$_interopRequireWildcard((parcelRequire("3SUDT")));

var $5acb4c63d2aa1a61$var$_isDate = $5acb4c63d2aa1a61$var$_interopRequireDefault((parcelRequire("akLR8")));
function $5acb4c63d2aa1a61$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($5acb4c63d2aa1a61$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $5acb4c63d2aa1a61$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $5acb4c63d2aa1a61$var$_typeof(e) && "function" != typeof e) return {
        default: e
    };
    var t = $5acb4c63d2aa1a61$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $5acb4c63d2aa1a61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5acb4c63d2aa1a61$var$_toConsumableArray(arr) {
    return $5acb4c63d2aa1a61$var$_arrayWithoutHoles(arr) || $5acb4c63d2aa1a61$var$_iterableToArray(arr) || $5acb4c63d2aa1a61$var$_unsupportedIterableToArray(arr) || $5acb4c63d2aa1a61$var$_nonIterableSpread();
}
function $5acb4c63d2aa1a61$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5acb4c63d2aa1a61$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5acb4c63d2aa1a61$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5acb4c63d2aa1a61$var$_arrayLikeToArray(o, minLen);
}
function $5acb4c63d2aa1a61$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5acb4c63d2aa1a61$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5acb4c63d2aa1a61$var$_arrayLikeToArray(arr);
}
function $5acb4c63d2aa1a61$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * TIN Validation
 * Validates Tax Identification Numbers (TINs) from the US, EU member states and the United Kingdom.
 *
 * EU-UK:
 * National TIN validity is calculated using public algorithms as made available by DG TAXUD.
 *
 * See `https://ec.europa.eu/taxation_customs/tin/specs/FS-TIN%20Algorithms-Public.docx` for more information.
 *
 * US:
 * An Employer Identification Number (EIN), also known as a Federal Tax Identification Number,
 *  is used to identify a business entity.
 *
 * NOTES:
 *  - Prefix 47 is being reserved for future use
 *  - Prefixes 26, 27, 45, 46 and 47 were previously assigned by the Philadelphia campus.
 *
 * See `http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/How-EINs-are-Assigned-and-Valid-EIN-Prefixes`
 * for more information.
 */ // Locale functions
/*
 * bg-BG validation function
 * (Edinen graždanski nomer (EGN/ЕГН), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last) digit
 */ function $5acb4c63d2aa1a61$var$bgBgCheck(tin) {
    // Extract full year, normalize month and check birth date validity
    var century_year = tin.slice(0, 2);
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 40) {
        month -= 40;
        century_year = "20".concat(century_year);
    } else if (month > 20) {
        month -= 20;
        century_year = "18".concat(century_year);
    } else century_year = "19".concat(century_year);
    if (month < 10) month = "0".concat(month);
    var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    // split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    // Calculate checksum by multiplying digits with fixed values
    var multip_lookup = [
        2,
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
    ];
    var checksum = 0;
    for(var i = 0; i < multip_lookup.length; i++)checksum += digits[i] * multip_lookup[i];
    checksum = checksum % 11 === 10 ? 0 : checksum % 11;
    return checksum === digits[9];
}
/**
 * Check if an input is a valid Canadian SIN (Social Insurance Number)
 *
 * The Social Insurance Number (SIN) is a 9 digit number that
 * you need to work in Canada or to have access to government programs and benefits.
 *
 * https://en.wikipedia.org/wiki/Social_Insurance_Number
 * https://www.canada.ca/en/employment-social-development/services/sin.html
 * https://www.codercrunch.com/challenge/819302488/sin-validator
 *
 * @param {string} input
 * @return {boolean}
 */ function $5acb4c63d2aa1a61$var$isCanadianSIN(input) {
    var digitsArray = input.split('');
    var even = digitsArray.filter(function(_, idx) {
        return idx % 2;
    }).map(function(i) {
        return Number(i) * 2;
    }).join('').split('');
    var total = digitsArray.filter(function(_, idx) {
        return !(idx % 2);
    }).concat(even).map(function(i) {
        return Number(i);
    }).reduce(function(acc, cur) {
        return acc + cur;
    });
    return total % 10 === 0;
}
/*
 * cs-CZ validation function
 * (Rodné číslo (RČ), persons only)
 * Checks if birth date (first six digits) is valid and divisibility by 11
 * Material not in DG TAXUD document sourced from:
 * -`https://lorenc.info/3MA381/overeni-spravnosti-rodneho-cisla.htm`
 * -`https://www.mvcr.cz/clanek/rady-a-sluzby-dokumenty-rodne-cislo.aspx`
 */ function $5acb4c63d2aa1a61$var$csCzCheck(tin) {
    tin = tin.replace(/\W/, '');
    // Extract full year from TIN length
    var full_year = parseInt(tin.slice(0, 2), 10);
    if (tin.length === 10) {
        if (full_year < 54) full_year = "20".concat(full_year);
        else full_year = "19".concat(full_year);
    } else {
        if (tin.slice(6) === '000') return false;
         // Three-zero serial not assigned before 1954
        if (full_year < 54) full_year = "19".concat(full_year);
        else return false; // No 18XX years seen in any of the resources
    }
    // Add missing zero if needed
    if (full_year.length === 3) full_year = [
        full_year.slice(0, 2),
        '0',
        full_year.slice(2)
    ].join('');
    // Extract month from TIN and normalize
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 50) month -= 50;
    if (month > 20) {
        // Month-plus-twenty was only introduced in 2004
        if (parseInt(full_year, 10) < 2004) return false;
        month -= 20;
    }
    if (month < 10) month = "0".concat(month);
    // Check date validity
    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    // Verify divisibility by 11
    if (tin.length === 10) {
        if (parseInt(tin, 10) % 11 !== 0) {
            // Some numbers up to and including 1985 are still valid if
            // check (last) digit equals 0 and modulo of first 9 digits equals 10
            var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;
            if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
                if (parseInt(tin.slice(9), 10) !== 0) return false;
            } else return false;
        }
    }
    return true;
}
/*
 * de-AT validation function
 * (Abgabenkontonummer, persons/entities)
 * Verify TIN validity by calling luhnCheck()
 */ function $5acb4c63d2aa1a61$var$deAtCheck(tin) {
    return $5acb4c63d2aa1a61$var$algorithms.luhnCheck(tin);
}
/*
 * de-DE validation function
 * (Steueridentifikationsnummer (Steuer-IdNr.), persons only)
 * Tests for single duplicate/triplicate value, then calculates ISO 7064 check (last) digit
 * Partial implementation of spec (same result with both algorithms always)
 */ function $5acb4c63d2aa1a61$var$deDeCheck(tin) {
    // Split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    // Fill array with strings of number positions
    var occurences = [];
    for(var i = 0; i < digits.length - 1; i++){
        occurences.push('');
        for(var j = 0; j < digits.length - 1; j++)if (digits[i] === digits[j]) occurences[i] += j;
    }
    // Remove digits with one occurence and test for only one duplicate/triplicate
    occurences = occurences.filter(function(a) {
        return a.length > 1;
    });
    if (occurences.length !== 2 && occurences.length !== 3) return false;
    // In case of triplicate value only two digits are allowed next to each other
    if (occurences[0].length === 3) {
        var trip_locations = occurences[0].split('').map(function(a) {
            return parseInt(a, 10);
        });
        var recurrent = 0; // Amount of neighbour occurences
        for(var _i = 0; _i < trip_locations.length - 1; _i++)if (trip_locations[_i] + 1 === trip_locations[_i + 1]) recurrent += 1;
        if (recurrent === 2) return false;
    }
    return $5acb4c63d2aa1a61$var$algorithms.iso7064Check(tin);
}
/*
 * dk-DK validation function
 * (CPR-nummer (personnummer), persons only)
 * Checks if birth date (first six digits) is valid and assigned to century (seventh) digit,
 * and calculates check (last) digit
 */ function $5acb4c63d2aa1a61$var$dkDkCheck(tin) {
    tin = tin.replace(/\W/, '');
    // Extract year, check if valid for given century digit and add century
    var year = parseInt(tin.slice(4, 6), 10);
    var century_digit = tin.slice(6, 7);
    switch(century_digit){
        case '0':
        case '1':
        case '2':
        case '3':
            year = "19".concat(year);
            break;
        case '4':
        case '9':
            if (year < 37) year = "20".concat(year);
            else year = "19".concat(year);
            break;
        default:
            if (year < 37) year = "20".concat(year);
            else if (year > 58) year = "18".concat(year);
            else return false;
            break;
    }
    // Add missing zero if needed
    if (year.length === 3) year = [
        year.slice(0, 2),
        '0',
        year.slice(2)
    ].join('');
    // Check date validity
    var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    // Split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    var weight = 4;
    // Multiply by weight and add to checksum
    for(var i = 0; i < 9; i++){
        checksum += digits[i] * weight;
        weight -= 1;
        if (weight === 1) weight = 7;
    }
    checksum %= 11;
    if (checksum === 1) return false;
    return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
}
/*
 * el-CY validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons only)
 * Verify TIN validity by calculating ASCII value of check (last) character
 */ function $5acb4c63d2aa1a61$var$elCyCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.slice(0, 8).split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    // add digits in even places
    for(var i = 1; i < digits.length; i += 2)checksum += digits[i];
    // add digits in odd places
    for(var _i2 = 0; _i2 < digits.length; _i2 += 2)if (digits[_i2] < 2) checksum += 1 - digits[_i2];
    else {
        checksum += 2 * (digits[_i2] - 2) + 5;
        if (digits[_i2] > 4) checksum += 2;
    }
    return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
}
/*
 * el-GR validation function
 * (Arithmos Forologikou Mitroou (AFM/ΑΦΜ), persons/entities)
 * Verify TIN validity by calculating check (last) digit
 * Algorithm not in DG TAXUD document- sourced from:
 * - `http://epixeirisi.gr/%CE%9A%CE%A1%CE%99%CE%A3%CE%99%CE%9C%CE%91-%CE%98%CE%95%CE%9C%CE%91%CE%A4%CE%91-%CE%A6%CE%9F%CE%A1%CE%9F%CE%9B%CE%9F%CE%93%CE%99%CE%91%CE%A3-%CE%9A%CE%91%CE%99-%CE%9B%CE%9F%CE%93%CE%99%CE%A3%CE%A4%CE%99%CE%9A%CE%97%CE%A3/23791/%CE%91%CF%81%CE%B9%CE%B8%CE%BC%CF%8C%CF%82-%CE%A6%CE%BF%CF%81%CE%BF%CE%BB%CE%BF%CE%B3%CE%B9%CE%BA%CE%BF%CF%8D-%CE%9C%CE%B7%CF%84%CF%81%CF%8E%CE%BF%CF%85`
 */ function $5acb4c63d2aa1a61$var$elGrCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    for(var i = 0; i < 8; i++)checksum += digits[i] * Math.pow(2, 8 - i);
    return checksum % 11 % 10 === digits[8];
}
/*
 * en-GB validation function (should go here if needed)
 * (National Insurance Number (NINO) or Unique Taxpayer Reference (UTR),
 * persons/entities respectively)
 */ /*
 * en-IE validation function
 * (Personal Public Service Number (PPS No), persons only)
 * Verify TIN validity by calculating check (second to last) character
 */ function $5acb4c63d2aa1a61$var$enIeCheck(tin) {
    var checksum = $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function(a) {
        return parseInt(a, 10);
    }), 8);
    if (tin.length === 9 && tin[8] !== 'W') checksum += (tin[8].charCodeAt(0) - 64) * 9;
    checksum %= 23;
    if (checksum === 0) return tin[7].toUpperCase() === 'W';
    return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
}
// Valid US IRS campus prefixes
var $5acb4c63d2aa1a61$var$enUsCampusPrefix = {
    andover: [
        '10',
        '12'
    ],
    atlanta: [
        '60',
        '67'
    ],
    austin: [
        '50',
        '53'
    ],
    brookhaven: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '11',
        '13',
        '14',
        '16',
        '21',
        '22',
        '23',
        '25',
        '34',
        '51',
        '52',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59',
        '65'
    ],
    cincinnati: [
        '30',
        '32',
        '35',
        '36',
        '37',
        '38',
        '61'
    ],
    fresno: [
        '15',
        '24'
    ],
    internet: [
        '20',
        '26',
        '27',
        '45',
        '46',
        '47'
    ],
    kansas: [
        '40',
        '44'
    ],
    memphis: [
        '94',
        '95'
    ],
    ogden: [
        '80',
        '90'
    ],
    philadelphia: [
        '33',
        '39',
        '41',
        '42',
        '43',
        '46',
        '48',
        '62',
        '63',
        '64',
        '66',
        '68',
        '71',
        '72',
        '73',
        '74',
        '75',
        '76',
        '77',
        '81',
        '82',
        '83',
        '84',
        '85',
        '86',
        '87',
        '88',
        '91',
        '92',
        '93',
        '98',
        '99'
    ],
    sba: [
        '31'
    ]
};
// Return an array of all US IRS campus prefixes
function $5acb4c63d2aa1a61$var$enUsGetPrefixes() {
    var prefixes = [];
    for(var location in $5acb4c63d2aa1a61$var$enUsCampusPrefix)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
    // istanbul ignore else
    if ($5acb4c63d2aa1a61$var$enUsCampusPrefix.hasOwnProperty(location)) prefixes.push.apply(prefixes, $5acb4c63d2aa1a61$var$_toConsumableArray($5acb4c63d2aa1a61$var$enUsCampusPrefix[location]));
    return prefixes;
}
/*
 * en-US validation function
 * Verify that the TIN starts with a valid IRS campus prefix
 */ function $5acb4c63d2aa1a61$var$enUsCheck(tin) {
    return $5acb4c63d2aa1a61$var$enUsGetPrefixes().indexOf(tin.slice(0, 2)) !== -1;
}
/*
 * es-AR validation function
 * Clave Única de Identificación Tributaria (CUIT/CUIL)
 * Sourced from:
 * - https://servicioscf.afip.gob.ar/publico/abc/ABCpaso2.aspx?id_nivel1=3036&id_nivel2=3040&p=Conceptos%20b%C3%A1sicos
 * - https://es.wikipedia.org/wiki/Clave_%C3%9Anica_de_Identificaci%C3%B3n_Tributaria
 */ function $5acb4c63d2aa1a61$var$esArCheck(tin) {
    var accum = 0;
    var digits = tin.split('');
    var digit = parseInt(digits.pop(), 10);
    for(var i = 0; i < digits.length; i++)accum += digits[9 - i] * (2 + i % 6);
    var verif = 11 - accum % 11;
    if (verif === 11) verif = 0;
    else if (verif === 10) verif = 9;
    return digit === verif;
}
/*
 * es-ES validation function
 * (Documento Nacional de Identidad (DNI)
 * or Número de Identificación de Extranjero (NIE), persons only)
 * Verify TIN validity by calculating check (last) character
 */ function $5acb4c63d2aa1a61$var$esEsCheck(tin) {
    // Split characters into an array for further processing
    var chars = tin.toUpperCase().split('');
    // Replace initial letter if needed
    if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
        var lead_replace = 0;
        switch(chars[0]){
            case 'Y':
                lead_replace = 1;
                break;
            case 'Z':
                lead_replace = 2;
                break;
            default:
        }
        chars.splice(0, 1, lead_replace);
    // Fill with zeros if smaller than proper
    } else while(chars.length < 9)chars.unshift(0);
    // Calculate checksum and check according to lookup
    var lookup = [
        'T',
        'R',
        'W',
        'A',
        'G',
        'M',
        'Y',
        'F',
        'P',
        'D',
        'X',
        'B',
        'N',
        'J',
        'Z',
        'S',
        'Q',
        'V',
        'H',
        'L',
        'C',
        'K',
        'E'
    ];
    chars = chars.join('');
    var checksum = parseInt(chars.slice(0, 8), 10) % 23;
    return chars[8] === lookup[checksum];
}
/*
 * et-EE validation function
 * (Isikukood (IK), persons only)
 * Checks if birth date (century digit and six following) is valid and calculates check (last) digit
 * Material not in DG TAXUD document sourced from:
 * - `https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/Estonia-TIN.pdf`
 */ function $5acb4c63d2aa1a61$var$etEeCheck(tin) {
    // Extract year and add century
    var full_year = tin.slice(1, 3);
    var century_digit = tin.slice(0, 1);
    switch(century_digit){
        case '1':
        case '2':
            full_year = "18".concat(full_year);
            break;
        case '3':
        case '4':
            full_year = "19".concat(full_year);
            break;
        default:
            full_year = "20".concat(full_year);
            break;
    }
    // Check date validity
    var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    // Split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 0;
    var weight = 1;
    // Multiply by weight and add to checksum
    for(var i = 0; i < 10; i++){
        checksum += digits[i] * weight;
        weight += 1;
        if (weight === 10) weight = 1;
    }
    // Do again if modulo 11 of checksum is 10
    if (checksum % 11 === 10) {
        checksum = 0;
        weight = 3;
        for(var _i3 = 0; _i3 < 10; _i3++){
            checksum += digits[_i3] * weight;
            weight += 1;
            if (weight === 10) weight = 1;
        }
        if (checksum % 11 === 10) return digits[10] === 0;
    }
    return checksum % 11 === digits[10];
}
/*
 * fi-FI validation function
 * (Henkilötunnus (HETU), persons only)
 * Checks if birth date (first six digits plus century symbol) is valid
 * and calculates check (last) digit
 */ function $5acb4c63d2aa1a61$var$fiFiCheck(tin) {
    // Extract year and add century
    var full_year = tin.slice(4, 6);
    var century_symbol = tin.slice(6, 7);
    switch(century_symbol){
        case '+':
            full_year = "18".concat(full_year);
            break;
        case '-':
            full_year = "19".concat(full_year);
            break;
        default:
            full_year = "20".concat(full_year);
            break;
    }
    // Check date validity
    var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    // Calculate check character
    var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;
    if (checksum < 10) return checksum === parseInt(tin.slice(10), 10);
    checksum -= 10;
    var letters_lookup = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'H',
        'J',
        'K',
        'L',
        'M',
        'N',
        'P',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y'
    ];
    return letters_lookup[checksum] === tin.slice(10);
}
/*
 * fr/nl-BE validation function
 * (Numéro national (N.N.), persons only)
 * Checks if birth date (first six digits) is valid and calculates check (last two) digits
 */ function $5acb4c63d2aa1a61$var$frBeCheck(tin) {
    // Zero month/day value is acceptable
    if (tin.slice(2, 4) !== '00' || tin.slice(4, 6) !== '00') {
        // Extract date from first six digits of TIN
        var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));
        if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
    }
    var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
    var checkdigits = parseInt(tin.slice(9, 11), 10);
    if (checksum !== checkdigits) {
        checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;
        if (checksum !== checkdigits) return false;
    }
    return true;
}
/*
 * fr-FR validation function
 * (Numéro fiscal de référence (numéro SPI), persons only)
 * Verify TIN validity by calculating check (last three) digits
 */ function $5acb4c63d2aa1a61$var$frFrCheck(tin) {
    tin = tin.replace(/\s/g, '');
    var checksum = parseInt(tin.slice(0, 10), 10) % 511;
    var checkdigits = parseInt(tin.slice(10, 13), 10);
    return checksum === checkdigits;
}
/*
 * fr/lb-LU validation function
 * (numéro d’identification personnelle, persons only)
 * Verify birth date validity and run Luhn and Verhoeff checks
 */ function $5acb4c63d2aa1a61$var$frLuCheck(tin) {
    // Extract date and check validity
    var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    // Run Luhn check
    if (!$5acb4c63d2aa1a61$var$algorithms.luhnCheck(tin.slice(0, 12))) return false;
    // Remove Luhn check digit and run Verhoeff check
    return $5acb4c63d2aa1a61$var$algorithms.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
}
/*
 * hr-HR validation function
 * (Osobni identifikacijski broj (OIB), persons/entities)
 * Verify TIN validity by calling iso7064Check(digits)
 */ function $5acb4c63d2aa1a61$var$hrHrCheck(tin) {
    return $5acb4c63d2aa1a61$var$algorithms.iso7064Check(tin);
}
/*
 * hu-HU validation function
 * (Adóazonosító jel, persons only)
 * Verify TIN validity by calculating check (last) digit
 */ function $5acb4c63d2aa1a61$var$huHuCheck(tin) {
    // split digits into an array for further processing
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var checksum = 8;
    for(var i = 1; i < 9; i++)checksum += digits[i] * (i + 1);
    return checksum % 11 === digits[9];
}
/*
 * lt-LT validation function (should go here if needed)
 * (Asmens kodas, persons/entities respectively)
 * Current validation check is alias of etEeCheck- same format applies
 */ /*
 * it-IT first/last name validity check
 * Accepts it-IT TIN-encoded names as a three-element character array and checks their validity
 * Due to lack of clarity between resources ("Are only Italian consonants used?
 * What happens if a person has X in their name?" etc.) only two test conditions
 * have been implemented:
 * Vowels may only be followed by other vowels or an X character
 * and X characters after vowels may only be followed by other X characters.
 */ function $5acb4c63d2aa1a61$var$itItNameCheck(name) {
    // true at the first occurence of a vowel
    var vowelflag = false;
    // true at the first occurence of an X AFTER vowel
    // (to properly handle last names with X as consonant)
    var xflag = false;
    for(var i = 0; i < 3; i++){
        if (!vowelflag && /[AEIOU]/.test(name[i])) vowelflag = true;
        else if (!xflag && vowelflag && name[i] === 'X') xflag = true;
        else if (i > 0) {
            if (vowelflag && !xflag) {
                if (!/[AEIOU]/.test(name[i])) return false;
            }
            if (xflag) {
                if (!/X/.test(name[i])) return false;
            }
        }
    }
    return true;
}
/*
 * it-IT validation function
 * (Codice fiscale (TIN-IT), persons only)
 * Verify name, birth date and codice catastale validity
 * and calculate check character.
 * Material not in DG-TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/Italian_fiscal_code`
 */ function $5acb4c63d2aa1a61$var$itItCheck(tin) {
    // Capitalize and split characters into an array for further processing
    var chars = tin.toUpperCase().split('');
    // Check first and last name validity calling itItNameCheck()
    if (!$5acb4c63d2aa1a61$var$itItNameCheck(chars.slice(0, 3))) return false;
    if (!$5acb4c63d2aa1a61$var$itItNameCheck(chars.slice(3, 6))) return false;
    // Convert letters in number spaces back to numbers if any
    var number_locations = [
        6,
        7,
        9,
        10,
        12,
        13,
        14
    ];
    var number_replace = {
        L: '0',
        M: '1',
        N: '2',
        P: '3',
        Q: '4',
        R: '5',
        S: '6',
        T: '7',
        U: '8',
        V: '9'
    };
    for(var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++){
        var i = _number_locations[_i4];
        if (chars[i] in number_replace) chars.splice(i, 1, number_replace[chars[i]]);
    }
    // Extract month and day, and check date validity
    var month_replace = {
        A: '01',
        B: '02',
        C: '03',
        D: '04',
        E: '05',
        H: '06',
        L: '07',
        M: '08',
        P: '09',
        R: '10',
        S: '11',
        T: '12'
    };
    var month = month_replace[chars[8]];
    var day = parseInt(chars[9] + chars[10], 10);
    if (day > 40) day -= 40;
    if (day < 10) day = "0".concat(day);
    var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
    // Calculate check character by adding up even and odd characters as numbers
    var checksum = 0;
    for(var _i5 = 1; _i5 < chars.length - 1; _i5 += 2){
        var char_to_int = parseInt(chars[_i5], 10);
        if (isNaN(char_to_int)) char_to_int = chars[_i5].charCodeAt(0) - 65;
        checksum += char_to_int;
    }
    var odd_convert = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
    };
    for(var _i6 = 0; _i6 < chars.length - 1; _i6 += 2){
        var _char_to_int = 0;
        if (chars[_i6] in odd_convert) _char_to_int = odd_convert[chars[_i6]];
        else {
            var multiplier = parseInt(chars[_i6], 10);
            _char_to_int = 2 * multiplier + 1;
            if (multiplier > 4) _char_to_int += 2;
        }
        checksum += _char_to_int;
    }
    if (String.fromCharCode(65 + checksum % 26) !== chars[15]) return false;
    return true;
}
/*
 * lv-LV validation function
 * (Personas kods (PK), persons only)
 * Check validity of birth date and calculate check (last) digit
 * Support only for old format numbers (not starting with '32', issued before 2017/07/01)
 * Material not in DG TAXUD document sourced from:
 * `https://boot.ritakafija.lv/forums/index.php?/topic/88314-personas-koda-algoritms-%C4%8Deksumma/`
 */ function $5acb4c63d2aa1a61$var$lvLvCheck(tin) {
    tin = tin.replace(/\W/, '');
    // Extract date from TIN
    var day = tin.slice(0, 2);
    if (day !== '32') {
        // No date/checksum check if new format
        var month = tin.slice(2, 4);
        if (month !== '00') {
            // No date check if unknown month
            var full_year = tin.slice(4, 6);
            switch(tin[6]){
                case '0':
                    full_year = "18".concat(full_year);
                    break;
                case '1':
                    full_year = "19".concat(full_year);
                    break;
                default:
                    full_year = "20".concat(full_year);
                    break;
            }
            // Check date validity
            var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);
            if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
        }
        // Calculate check digit
        var checksum = 1101;
        var multip_lookup = [
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
        ];
        for(var i = 0; i < tin.length - 1; i++)checksum -= parseInt(tin[i], 10) * multip_lookup[i];
        return parseInt(tin[10], 10) === checksum % 11;
    }
    return true;
}
/*
 * mt-MT validation function
 * (Identity Card Number or Unique Taxpayer Reference, persons/entities)
 * Verify Identity Card Number structure (no other tests found)
 */ function $5acb4c63d2aa1a61$var$mtMtCheck(tin) {
    if (tin.length !== 9) {
        // No tests for UTR
        var chars = tin.toUpperCase().split('');
        // Fill with zeros if smaller than proper
        while(chars.length < 8)chars.unshift(0);
        // Validate format according to last character
        switch(tin[7]){
            case 'A':
            case 'P':
                if (parseInt(chars[6], 10) === 0) return false;
                break;
            default:
                var first_part = parseInt(chars.join('').slice(0, 5), 10);
                if (first_part > 32000) return false;
                var second_part = parseInt(chars.join('').slice(5, 7), 10);
                if (first_part === second_part) return false;
        }
    }
    return true;
}
/*
 * nl-NL validation function
 * (Burgerservicenummer (BSN) or Rechtspersonen Samenwerkingsverbanden Informatie Nummer (RSIN),
 * persons/entities respectively)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $5acb4c63d2aa1a61$var$nlNlCheck(tin) {
    return $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11 === parseInt(tin[8], 10);
}
/*
 * pl-PL validation function
 * (Powszechny Elektroniczny System Ewidencji Ludności (PESEL)
 * or Numer identyfikacji podatkowej (NIP), persons/entities)
 * Verify TIN validity by validating birth date (PESEL) and calculating check (last) digit
 */ function $5acb4c63d2aa1a61$var$plPlCheck(tin) {
    // NIP
    if (tin.length === 10) {
        // Calculate last digit by multiplying with lookup
        var lookup = [
            6,
            5,
            7,
            2,
            3,
            4,
            5,
            6,
            7
        ];
        var _checksum = 0;
        for(var i = 0; i < lookup.length; i++)_checksum += parseInt(tin[i], 10) * lookup[i];
        _checksum %= 11;
        if (_checksum === 10) return false;
        return _checksum === parseInt(tin[9], 10);
    }
    // PESEL
    // Extract full year using month
    var full_year = tin.slice(0, 2);
    var month = parseInt(tin.slice(2, 4), 10);
    if (month > 80) {
        full_year = "18".concat(full_year);
        month -= 80;
    } else if (month > 60) {
        full_year = "22".concat(full_year);
        month -= 60;
    } else if (month > 40) {
        full_year = "21".concat(full_year);
        month -= 40;
    } else if (month > 20) {
        full_year = "20".concat(full_year);
        month -= 20;
    } else full_year = "19".concat(full_year);
    // Add leading zero to month if needed
    if (month < 10) month = "0".concat(month);
    // Check date validity
    var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
    if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    // Calculate last digit by mulitplying with odd one-digit numbers except 5
    var checksum = 0;
    var multiplier = 1;
    for(var _i7 = 0; _i7 < tin.length - 1; _i7++){
        checksum += parseInt(tin[_i7], 10) * multiplier % 10;
        multiplier += 2;
        if (multiplier > 10) multiplier = 1;
        else if (multiplier === 5) multiplier += 2;
    }
    checksum = 10 - checksum % 10;
    return checksum === parseInt(tin[10], 10);
}
/*
* pt-BR validation function
* (Cadastro de Pessoas Físicas (CPF, persons)
* Cadastro Nacional de Pessoas Jurídicas (CNPJ, entities)
* Both inputs will be validated
*/ function $5acb4c63d2aa1a61$var$ptBrCheck(tin) {
    if (tin.length === 11) {
        var _sum;
        var remainder;
        _sum = 0;
        if (// Reject known invalid CPFs
        tin === '11111111111' || tin === '22222222222' || tin === '33333333333' || tin === '44444444444' || tin === '55555555555' || tin === '66666666666' || tin === '77777777777' || tin === '88888888888' || tin === '99999999999' || tin === '00000000000') return false;
        for(var i = 1; i <= 9; i++)_sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(9, 10), 10)) return false;
        _sum = 0;
        for(var _i8 = 1; _i8 <= 10; _i8++)_sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(10, 11), 10)) return false;
        return true;
    }
    if (// Reject know invalid CNPJs
    tin === '00000000000000' || tin === '11111111111111' || tin === '22222222222222' || tin === '33333333333333' || tin === '44444444444444' || tin === '55555555555555' || tin === '66666666666666' || tin === '77777777777777' || tin === '88888888888888' || tin === '99999999999999') return false;
    var length = tin.length - 2;
    var identifiers = tin.substring(0, length);
    var verificators = tin.substring(length);
    var sum = 0;
    var pos = length - 7;
    for(var _i9 = length; _i9 >= 1; _i9--){
        sum += identifiers.charAt(length - _i9) * pos;
        pos -= 1;
        if (pos < 2) pos = 9;
    }
    var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(verificators.charAt(0), 10)) return false;
    length += 1;
    identifiers = tin.substring(0, length);
    sum = 0;
    pos = length - 7;
    for(var _i10 = length; _i10 >= 1; _i10--){
        sum += identifiers.charAt(length - _i10) * pos;
        pos -= 1;
        if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result !== parseInt(verificators.charAt(1), 10)) return false;
    return true;
}
/*
 * pt-PT validation function
 * (Número de identificação fiscal (NIF), persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $5acb4c63d2aa1a61$var$ptPtCheck(tin) {
    var checksum = 11 - $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11;
    if (checksum > 9) return parseInt(tin[8], 10) === 0;
    return checksum === parseInt(tin[8], 10);
}
/*
 * ro-RO validation function
 * (Cod Numeric Personal (CNP) or Cod de înregistrare fiscală (CIF),
 * persons only)
 * Verify CNP validity by calculating check (last) digit (test not found for CIF)
 * Material not in DG TAXUD document sourced from:
 * `https://en.wikipedia.org/wiki/National_identification_number#Romania`
 */ function $5acb4c63d2aa1a61$var$roRoCheck(tin) {
    if (tin.slice(0, 4) !== '9000') {
        // No test found for this format
        // Extract full year using century digit if possible
        var full_year = tin.slice(1, 3);
        switch(tin[0]){
            case '1':
            case '2':
                full_year = "19".concat(full_year);
                break;
            case '3':
            case '4':
                full_year = "18".concat(full_year);
                break;
            case '5':
            case '6':
                full_year = "20".concat(full_year);
                break;
            default:
        }
        // Check date validity
        var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
        if (date.length === 8) {
            if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
        } else if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
        // Calculate check digit
        var digits = tin.split('').map(function(a) {
            return parseInt(a, 10);
        });
        var multipliers = [
            2,
            7,
            9,
            1,
            4,
            6,
            3,
            5,
            8,
            2,
            7,
            9
        ];
        var checksum = 0;
        for(var i = 0; i < multipliers.length; i++)checksum += digits[i] * multipliers[i];
        if (checksum % 11 === 10) return digits[12] === 1;
        return digits[12] === checksum % 11;
    }
    return true;
}
/*
 * sk-SK validation function
 * (Rodné číslo (RČ) or bezvýznamové identifikačné číslo (BIČ), persons only)
 * Checks validity of pre-1954 birth numbers (rodné číslo) only
 * Due to the introduction of the pseudo-random BIČ it is not possible to test
 * post-1954 birth numbers without knowing whether they are BIČ or RČ beforehand
 */ function $5acb4c63d2aa1a61$var$skSkCheck(tin) {
    if (tin.length === 9) {
        tin = tin.replace(/\W/, '');
        if (tin.slice(6) === '000') return false;
         // Three-zero serial not assigned before 1954
        // Extract full year from TIN length
        var full_year = parseInt(tin.slice(0, 2), 10);
        if (full_year > 53) return false;
        if (full_year < 10) full_year = "190".concat(full_year);
        else full_year = "19".concat(full_year);
        // Extract month from TIN and normalize
        var month = parseInt(tin.slice(2, 4), 10);
        if (month > 50) month -= 50;
        if (month < 10) month = "0".concat(month);
        // Check date validity
        var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
        if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    }
    return true;
}
/*
 * sl-SI validation function
 * (Davčna številka, persons/entities)
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $5acb4c63d2aa1a61$var$slSiCheck(tin) {
    var checksum = 11 - $5acb4c63d2aa1a61$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 7).map(function(a) {
        return parseInt(a, 10);
    }), 8) % 11;
    if (checksum === 10) return parseInt(tin[7], 10) === 0;
    return checksum === parseInt(tin[7], 10);
}
/*
 * sv-SE validation function
 * (Personnummer or samordningsnummer, persons only)
 * Checks validity of birth date and calls luhnCheck() to validate check (last) digit
 */ function $5acb4c63d2aa1a61$var$svSeCheck(tin) {
    // Make copy of TIN and normalize to two-digit year form
    var tin_copy = tin.slice(0);
    if (tin.length > 11) tin_copy = tin_copy.slice(2);
    // Extract date of birth
    var full_year = '';
    var month = tin_copy.slice(2, 4);
    var day = parseInt(tin_copy.slice(4, 6), 10);
    if (tin.length > 11) full_year = tin.slice(0, 4);
    else {
        full_year = tin.slice(0, 2);
        if (tin.length === 11 && day < 60) {
            // Extract full year from centenarian symbol
            // Should work just fine until year 10000 or so
            var current_year = new Date().getFullYear().toString();
            var current_century = parseInt(current_year.slice(0, 2), 10);
            current_year = parseInt(current_year, 10);
            if (tin[6] === '-') {
                if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) full_year = "".concat(current_century - 1).concat(full_year);
                else full_year = "".concat(current_century).concat(full_year);
            } else {
                full_year = "".concat(current_century - 1).concat(full_year);
                if (current_year - parseInt(full_year, 10) < 100) return false;
            }
        }
    }
    // Normalize day and check date validity
    if (day > 60) day -= 60;
    if (day < 10) day = "0".concat(day);
    var date = "".concat(full_year, "/").concat(month, "/").concat(day);
    if (date.length === 8) {
        if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YY/MM/DD')) return false;
    } else if (!(0, $5acb4c63d2aa1a61$var$_isDate.default)(date, 'YYYY/MM/DD')) return false;
    return $5acb4c63d2aa1a61$var$algorithms.luhnCheck(tin.replace(/\W/, ''));
}
/**
 * uk-UA validation function
 * Verify TIN validity by calculating check (last) digit (variant of MOD 11)
 */ function $5acb4c63d2aa1a61$var$ukUaCheck(tin) {
    // Calculate check digit
    var digits = tin.split('').map(function(a) {
        return parseInt(a, 10);
    });
    var multipliers = [
        -1,
        5,
        7,
        9,
        4,
        6,
        10,
        5,
        7
    ];
    var checksum = 0;
    for(var i = 0; i < multipliers.length; i++)checksum += digits[i] * multipliers[i];
    return checksum % 11 === 10 ? digits[9] === 0 : digits[9] === checksum % 11;
}
// Locale lookup objects
/*
 * Tax id regex formats for various locales
 *
 * Where not explicitly specified in DG-TAXUD document both
 * uppercase and lowercase letters are acceptable.
 */ var $5acb4c63d2aa1a61$var$taxIdFormat = {
    'bg-BG': /^\d{10}$/,
    'cs-CZ': /^\d{6}\/{0,1}\d{3,4}$/,
    'de-AT': /^\d{9}$/,
    'de-DE': /^[1-9]\d{10}$/,
    'dk-DK': /^\d{6}-{0,1}\d{4}$/,
    'el-CY': /^[09]\d{7}[A-Z]$/,
    'el-GR': /^([0-4]|[7-9])\d{8}$/,
    'en-CA': /^\d{9}$/,
    'en-GB': /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
    'en-IE': /^\d{7}[A-W][A-IW]{0,1}$/i,
    'en-US': /^\d{2}[- ]{0,1}\d{7}$/,
    'es-AR': /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
    'es-ES': /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
    'et-EE': /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
    'fi-FI': /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
    'fr-BE': /^\d{11}$/,
    'fr-FR': /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
    // Conforms both to official spec and provided example
    'fr-LU': /^\d{13}$/,
    'hr-HR': /^\d{11}$/,
    'hu-HU': /^8\d{9}$/,
    'it-IT': /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
    'lv-LV': /^\d{6}-{0,1}\d{5}$/,
    // Conforms both to DG TAXUD spec and original research
    'mt-MT': /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
    'nl-NL': /^\d{9}$/,
    'pl-PL': /^\d{10,11}$/,
    'pt-BR': /(?:^\d{11}$)|(?:^\d{14}$)/,
    'pt-PT': /^\d{9}$/,
    'ro-RO': /^\d{13}$/,
    'sk-SK': /^\d{6}\/{0,1}\d{3,4}$/,
    'sl-SI': /^[1-9]\d{7}$/,
    'sv-SE': /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
    'uk-UA': /^\d{10}$/
};
// taxIdFormat locale aliases
$5acb4c63d2aa1a61$var$taxIdFormat['lb-LU'] = $5acb4c63d2aa1a61$var$taxIdFormat['fr-LU'];
$5acb4c63d2aa1a61$var$taxIdFormat['lt-LT'] = $5acb4c63d2aa1a61$var$taxIdFormat['et-EE'];
$5acb4c63d2aa1a61$var$taxIdFormat['nl-BE'] = $5acb4c63d2aa1a61$var$taxIdFormat['fr-BE'];
$5acb4c63d2aa1a61$var$taxIdFormat['fr-CA'] = $5acb4c63d2aa1a61$var$taxIdFormat['en-CA'];
// Algorithmic tax id check functions for various locales
var $5acb4c63d2aa1a61$var$taxIdCheck = {
    'bg-BG': $5acb4c63d2aa1a61$var$bgBgCheck,
    'cs-CZ': $5acb4c63d2aa1a61$var$csCzCheck,
    'de-AT': $5acb4c63d2aa1a61$var$deAtCheck,
    'de-DE': $5acb4c63d2aa1a61$var$deDeCheck,
    'dk-DK': $5acb4c63d2aa1a61$var$dkDkCheck,
    'el-CY': $5acb4c63d2aa1a61$var$elCyCheck,
    'el-GR': $5acb4c63d2aa1a61$var$elGrCheck,
    'en-CA': $5acb4c63d2aa1a61$var$isCanadianSIN,
    'en-IE': $5acb4c63d2aa1a61$var$enIeCheck,
    'en-US': $5acb4c63d2aa1a61$var$enUsCheck,
    'es-AR': $5acb4c63d2aa1a61$var$esArCheck,
    'es-ES': $5acb4c63d2aa1a61$var$esEsCheck,
    'et-EE': $5acb4c63d2aa1a61$var$etEeCheck,
    'fi-FI': $5acb4c63d2aa1a61$var$fiFiCheck,
    'fr-BE': $5acb4c63d2aa1a61$var$frBeCheck,
    'fr-FR': $5acb4c63d2aa1a61$var$frFrCheck,
    'fr-LU': $5acb4c63d2aa1a61$var$frLuCheck,
    'hr-HR': $5acb4c63d2aa1a61$var$hrHrCheck,
    'hu-HU': $5acb4c63d2aa1a61$var$huHuCheck,
    'it-IT': $5acb4c63d2aa1a61$var$itItCheck,
    'lv-LV': $5acb4c63d2aa1a61$var$lvLvCheck,
    'mt-MT': $5acb4c63d2aa1a61$var$mtMtCheck,
    'nl-NL': $5acb4c63d2aa1a61$var$nlNlCheck,
    'pl-PL': $5acb4c63d2aa1a61$var$plPlCheck,
    'pt-BR': $5acb4c63d2aa1a61$var$ptBrCheck,
    'pt-PT': $5acb4c63d2aa1a61$var$ptPtCheck,
    'ro-RO': $5acb4c63d2aa1a61$var$roRoCheck,
    'sk-SK': $5acb4c63d2aa1a61$var$skSkCheck,
    'sl-SI': $5acb4c63d2aa1a61$var$slSiCheck,
    'sv-SE': $5acb4c63d2aa1a61$var$svSeCheck,
    'uk-UA': $5acb4c63d2aa1a61$var$ukUaCheck
};
// taxIdCheck locale aliases
$5acb4c63d2aa1a61$var$taxIdCheck['lb-LU'] = $5acb4c63d2aa1a61$var$taxIdCheck['fr-LU'];
$5acb4c63d2aa1a61$var$taxIdCheck['lt-LT'] = $5acb4c63d2aa1a61$var$taxIdCheck['et-EE'];
$5acb4c63d2aa1a61$var$taxIdCheck['nl-BE'] = $5acb4c63d2aa1a61$var$taxIdCheck['fr-BE'];
$5acb4c63d2aa1a61$var$taxIdCheck['fr-CA'] = $5acb4c63d2aa1a61$var$taxIdCheck['en-CA'];
// Regexes for locales where characters should be omitted before checking format
var $5acb4c63d2aa1a61$var$allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
var $5acb4c63d2aa1a61$var$sanitizeRegexes = {
    'de-AT': $5acb4c63d2aa1a61$var$allsymbols,
    'de-DE': /[\/\\]/g,
    'fr-BE': $5acb4c63d2aa1a61$var$allsymbols
};
// sanitizeRegexes locale aliases
$5acb4c63d2aa1a61$var$sanitizeRegexes['nl-BE'] = $5acb4c63d2aa1a61$var$sanitizeRegexes['fr-BE'];
/*
 * Validator function
 * Return true if the passed string is a valid tax identification number
 * for the specified locale.
 * Throw an error exception if the locale is not supported.
 */ function $5acb4c63d2aa1a61$var$isTaxID(str) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
    (0, $5acb4c63d2aa1a61$var$_assertString.default)(str);
    // Copy TIN to avoid replacement if sanitized
    var strcopy = str.slice(0);
    if (locale in $5acb4c63d2aa1a61$var$taxIdFormat) {
        if (locale in $5acb4c63d2aa1a61$var$sanitizeRegexes) strcopy = strcopy.replace($5acb4c63d2aa1a61$var$sanitizeRegexes[locale], '');
        if (!$5acb4c63d2aa1a61$var$taxIdFormat[locale].test(strcopy)) return false;
        if (locale in $5acb4c63d2aa1a61$var$taxIdCheck) return $5acb4c63d2aa1a61$var$taxIdCheck[locale](strcopy);
        // Fallthrough; not all locales have algorithmic checks
        return true;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("3SUDT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.iso7064Check = $2d425a3de7836668$var$iso7064Check;
module.exports.luhnCheck = $2d425a3de7836668$var$luhnCheck;
module.exports.reverseMultiplyAndSum = $2d425a3de7836668$var$reverseMultiplyAndSum;
module.exports.verhoeffCheck = $2d425a3de7836668$var$verhoeffCheck;
/**
 * Algorithmic validation functions
 * May be used as is or implemented in the workflow of other validators.
 */ /*
 * ISO 7064 validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to ISO 7064 (MOD 11, 10).
 */ function $2d425a3de7836668$var$iso7064Check(str) {
    var checkvalue = 10;
    for(var i = 0; i < str.length - 1; i++)checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 9 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
    checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
    return checkvalue === parseInt(str[10], 10);
}
/*
 * Luhn (mod 10) validation function
 * Called with a string of numbers (incl. check digit)
 * to validate according to the Luhn algorithm.
 */ function $2d425a3de7836668$var$luhnCheck(str) {
    var checksum = 0;
    var second = false;
    for(var i = str.length - 1; i >= 0; i--){
        if (second) {
            var product = parseInt(str[i], 10) * 2;
            if (product > 9) // sum digits of product and add to checksum
            checksum += product.toString().split('').map(function(a) {
                return parseInt(a, 10);
            }).reduce(function(a, b) {
                return a + b;
            }, 0);
            else checksum += product;
        } else checksum += parseInt(str[i], 10);
        second = !second;
    }
    return checksum % 10 === 0;
}
/*
 * Reverse TIN multiplication and summation helper function
 * Called with an array of single-digit integers and a base multiplier
 * to calculate the sum of the digits multiplied in reverse.
 * Normally used in variations of MOD 11 algorithmic checks.
 */ function $2d425a3de7836668$var$reverseMultiplyAndSum(digits, base) {
    var total = 0;
    for(var i = 0; i < digits.length; i++)total += digits[i] * (base - i);
    return total;
}
/*
 * Verhoeff validation helper function
 * Called with a string of numbers
 * to validate according to the Verhoeff algorithm.
 */ function $2d425a3de7836668$var$verhoeffCheck(str) {
    var d_table = [
        [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ],
        [
            1,
            2,
            3,
            4,
            0,
            6,
            7,
            8,
            9,
            5
        ],
        [
            2,
            3,
            4,
            0,
            1,
            7,
            8,
            9,
            5,
            6
        ],
        [
            3,
            4,
            0,
            1,
            2,
            8,
            9,
            5,
            6,
            7
        ],
        [
            4,
            0,
            1,
            2,
            3,
            9,
            5,
            6,
            7,
            8
        ],
        [
            5,
            9,
            8,
            7,
            6,
            0,
            4,
            3,
            2,
            1
        ],
        [
            6,
            5,
            9,
            8,
            7,
            1,
            0,
            4,
            3,
            2
        ],
        [
            7,
            6,
            5,
            9,
            8,
            2,
            1,
            0,
            4,
            3
        ],
        [
            8,
            7,
            6,
            5,
            9,
            3,
            2,
            1,
            0,
            4
        ],
        [
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1,
            0
        ]
    ];
    var p_table = [
        [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ],
        [
            1,
            5,
            7,
            6,
            2,
            8,
            3,
            0,
            9,
            4
        ],
        [
            5,
            8,
            0,
            3,
            7,
            9,
            6,
            1,
            4,
            2
        ],
        [
            8,
            9,
            1,
            6,
            0,
            4,
            3,
            5,
            2,
            7
        ],
        [
            9,
            4,
            5,
            3,
            1,
            2,
            6,
            8,
            7,
            0
        ],
        [
            4,
            2,
            8,
            6,
            5,
            7,
            3,
            9,
            0,
            1
        ],
        [
            2,
            7,
            9,
            3,
            8,
            0,
            6,
            4,
            1,
            5
        ],
        [
            7,
            0,
            4,
            6,
            9,
            1,
            3,
            2,
            5,
            8
        ]
    ];
    // Copy (to prevent replacement) and reverse
    var str_copy = str.split('').reverse().join('');
    var checksum = 0;
    for(var i = 0; i < str_copy.length; i++)checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
    return checksum === 0;
}

});


parcelRegister("4kFi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32790ef4fc8dd756$var$isMobilePhone;
module.exports.locales = void 0;

var $32790ef4fc8dd756$var$_assertString = $32790ef4fc8dd756$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $32790ef4fc8dd756$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ var $32790ef4fc8dd756$var$phones = {
    'am-AM': /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
    'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
    'ar-BH': /^(\+?973)?(3|6)\d{7}$/,
    'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
    'ar-LB': /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    'ar-EG': /^((\+?20)|0)?1[0125]\d{8}$/,
    'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
    'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
    'ar-KW': /^(\+?965)([569]\d{7}|41\d{6})$/,
    'ar-LY': /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    'ar-MA': /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    'ar-OM': /^((\+|00)968)?(9[1-9])\d{6}$/,
    'ar-PS': /^(\+?970|0)5[6|9](\d{7})$/,
    'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
    'ar-SD': /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
    'ar-TN': /^(\+?216)?[2459]\d{7}$/,
    'az-AZ': /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    'bs-BA': /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
    'bn-BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
    'ca-AD': /^(\+376)?[346]\d{5}$/,
    'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    'de-DE': /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    'de-AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
    'de-CH': /^(\+41|0)([1-9])\d{1,9}$/,
    'de-LU': /^(\+352)?((6\d1)\d{6})$/,
    'dv-MV': /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    'el-GR': /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    'el-CY': /^(\+?357?)?(9(9|6)\d{6})$/,
    'en-AI': /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    'en-AU': /^(\+?61|0)4\d{8}$/,
    'en-AG': /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    'en-BM': /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    'en-BS': /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    'en-GB': /^(\+?44|0)7\d{9}$/,
    'en-GG': /^(\+?44|0)1481\d{6}$/,
    'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28|55|59)\d{7}$/,
    'en-GY': /^(\+592|0)6\d{6}$/,
    'en-HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    'en-MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
    'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
    'en-JM': /^(\+?876)?\d{7}$/,
    'en-KE': /^(\+?254|0)(7|1)\d{8}$/,
    'fr-CF': /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    'en-SS': /^(\+?211|0)(9[1257])\d{7}$/,
    'en-KI': /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    'en-KN': /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    'en-LS': /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    'en-MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    'en-MU': /^(\+?230|0)?\d{8}$/,
    'en-MW': /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    'en-NA': /^(\+?264|0)(6|8)\d{7}$/,
    'en-NG': /^(\+?234|0)?[789]\d{9}$/,
    'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
    'en-PG': /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    'en-PK': /^((00|\+)?92|0)3[0-6]\d{8}$/,
    'en-PH': /^(09|\+639)\d{9}$/,
    'en-RW': /^(\+?250|0)?[7]\d{8}$/,
    'en-SG': /^(\+65)?[3689]\d{7}$/,
    'en-SL': /^(\+?232|0)\d{8}$/,
    'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
    'en-UG': /^(\+?256|0)?[7]\d{8}$/,
    'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    'en-ZA': /^(\+?27|0)\d{9}$/,
    'en-ZM': /^(\+?26)?09[567]\d{7}$/,
    'en-ZW': /^(\+263)[0-9]{9}$/,
    'en-BW': /^(\+?267)?(7[1-8]{1})\d{6}$/,
    'es-AR': /^\+?549(11|[2368]\d)\d{8}$/,
    'es-BO': /^(\+?591)?(6|7)\d{7}$/,
    'es-CO': /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    'es-CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    'es-CR': /^(\+506)?[2-8]\d{7}$/,
    'es-CU': /^(\+53|0053)?5\d{7}$/,
    'es-DO': /^(\+?1)?8[024]9\d{7}$/,
    'es-HN': /^(\+?504)?[9|8|3|2]\d{7}$/,
    'es-EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    'es-ES': /^(\+?34)?[6|7]\d{8}$/,
    'es-PE': /^(\+?51)?9\d{8}$/,
    'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
    'es-NI': /^(\+?505)\d{7,8}$/,
    'es-PA': /^(\+?507)\d{7,8}$/,
    'es-PY': /^(\+?595|0)9[9876]\d{7}$/,
    'es-SV': /^(\+?503)?[67]\d{7}$/,
    'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
    'es-VE': /^(\+?58)?(2|4)\d{9}$/,
    'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    'fi-FI': /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    'fj-FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    'fr-BF': /^(\+226|0)[67]\d{7}$/,
    'fr-BJ': /^(\+229)\d{8}$/,
    'fr-CD': /^(\+?243|0)?(8|9)\d{8}$/,
    'fr-CM': /^(\+?237)6[0-9]{8}$/,
    'fr-FR': /^(\+?33|0)[67]\d{8}$/,
    'fr-GF': /^(\+?594|0|00594)[67]\d{8}$/,
    'fr-GP': /^(\+?590|0|00590)[67]\d{8}$/,
    'fr-MQ': /^(\+?596|0|00596)[67]\d{8}$/,
    'fr-PF': /^(\+?689)?8[789]\d{6}$/,
    'fr-RE': /^(\+?262|0|00262)[67]\d{8}$/,
    'fr-WF': /^(\+681)?\d{6}$/,
    'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    'hu-HU': /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    'ir-IR': /^(\+98|0)?9\d{9}$/,
    'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    'it-SM': /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    'ja-JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    'ka-GE': /^(\+?995)?(79\d{7}|5\d{8})$/,
    'kk-KZ': /^(\+?7|8)?7\d{9}$/,
    'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    'ky-KG': /^(\+?7\s?\+?7|0)\s?\d{2}\s?\d{3}\s?\d{4}$/,
    'lt-LT': /^(\+370|8)\d{8}$/,
    'lv-LV': /^(\+?371)2\d{7}$/,
    'mg-MG': /^((\+?261|0)(2|3)\d)?\d{7}$/,
    'mn-MN': /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    'my-MM': /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    'ms-MY': /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    'mz-MZ': /^(\+?258)?8[234567]\d{7}$/,
    'nb-NO': /^(\+?47)?[49]\d{7}$/,
    'ne-NP': /^(\+?977)?9[78]\d{8}$/,
    'nl-BE': /^(\+?32|0)4\d{8}$/,
    'nl-NL': /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    'nl-AW': /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    'nn-NO': /^(\+?47)?[49]\d{7}$/,
    'pl-PL': /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    'pt-BR': /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
    'pt-AO': /^(\+244)\d{9}$/,
    'ro-MD': /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    'ro-RO': /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    'ru-RU': /^(\+?7|8)?9\d{9}$/,
    'si-LK': /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    'so-SO': /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    'sq-AL': /^(\+355|0)6[789]\d{6}$/,
    'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
    'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    'tg-TJ': /^(\+?992)?[5][5]\d{7}$/,
    'th-TH': /^(\+66|66|0)\d{9}$/,
    'tr-TR': /^(\+?90|0)?5\d{9}$/,
    'tk-TM': /^(\+993|993|8)\d{8}$/,
    'uk-UA': /^(\+?38|8)?0\d{9}$/,
    'uz-UZ': /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    'vi-VN': /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    'zh-CN': /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    'zh-TW': /^(\+?886\-?|0)?9\d{8}$/,
    'dz-BT': /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    'ar-YE': /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    'ar-EH': /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    'fa-AF': /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/
};
/* eslint-enable max-len */ // aliases
$32790ef4fc8dd756$var$phones['en-CA'] = $32790ef4fc8dd756$var$phones['en-US'];
$32790ef4fc8dd756$var$phones['fr-CA'] = $32790ef4fc8dd756$var$phones['en-CA'];
$32790ef4fc8dd756$var$phones['fr-BE'] = $32790ef4fc8dd756$var$phones['nl-BE'];
$32790ef4fc8dd756$var$phones['zh-HK'] = $32790ef4fc8dd756$var$phones['en-HK'];
$32790ef4fc8dd756$var$phones['zh-MO'] = $32790ef4fc8dd756$var$phones['en-MO'];
$32790ef4fc8dd756$var$phones['ga-IE'] = $32790ef4fc8dd756$var$phones['en-IE'];
$32790ef4fc8dd756$var$phones['fr-CH'] = $32790ef4fc8dd756$var$phones['de-CH'];
$32790ef4fc8dd756$var$phones['it-CH'] = $32790ef4fc8dd756$var$phones['fr-CH'];
function $32790ef4fc8dd756$var$isMobilePhone(str, locale, options) {
    (0, $32790ef4fc8dd756$var$_assertString.default)(str);
    if (options && options.strictMode && !str.startsWith('+')) return false;
    if (Array.isArray(locale)) return locale.some(function(key) {
        // https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($32790ef4fc8dd756$var$phones.hasOwnProperty(key)) {
            var phone = $32790ef4fc8dd756$var$phones[key];
            if (phone.test(str)) return true;
        }
        return false;
    });
    else if (locale in $32790ef4fc8dd756$var$phones) return $32790ef4fc8dd756$var$phones[locale].test(str);
    else if (!locale || locale === 'any') {
        for(var key in $32790ef4fc8dd756$var$phones)// istanbul ignore else
        if ($32790ef4fc8dd756$var$phones.hasOwnProperty(key)) {
            var phone = $32790ef4fc8dd756$var$phones[key];
            if (phone.test(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
var $32790ef4fc8dd756$var$locales = module.exports.locales = Object.keys($32790ef4fc8dd756$var$phones);

});

parcelRegister("Gjy1y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07f31623c5c5b6f1$var$isEthereumAddress;

var $07f31623c5c5b6f1$var$_assertString = $07f31623c5c5b6f1$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $07f31623c5c5b6f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $07f31623c5c5b6f1$var$eth = /^(0x)[0-9a-f]{40}$/i;
function $07f31623c5c5b6f1$var$isEthereumAddress(str) {
    (0, $07f31623c5c5b6f1$var$_assertString.default)(str);
    return $07f31623c5c5b6f1$var$eth.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("69Ecb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47b2c35952174662$var$isCurrency;

var $47b2c35952174662$var$_merge = $47b2c35952174662$var$_interopRequireDefault((parcelRequire("9nDkO")));

var $47b2c35952174662$var$_assertString = $47b2c35952174662$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $47b2c35952174662$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47b2c35952174662$var$currencyRegex(options) {
    var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
    options.digits_after_decimal.forEach(function(digit, index) {
        if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
    });
    var symbol = "(".concat(options.symbol.replace(/\W/, function(m) {
        return "\\".concat(m);
    }), ")").concat(options.require_symbol ? '' : '?'), negative = '-?', whole_dollar_amount_without_sep = '[1-9]\\d*', whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"), valid_whole_dollar_amounts = [
        '0',
        whole_dollar_amount_without_sep,
        whole_dollar_amount_with_sep
    ], whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"), decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
    var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : '');
    // default is negative sign before symbol, but there are two other options (besides parens)
    if (options.allow_negatives && !options.parens_for_negatives) {
        if (options.negative_sign_after_digits) pattern += negative;
        else if (options.negative_sign_before_digits) pattern = negative + pattern;
    }
    // South African Rand, for example, uses R 123 (space) and R-123 (no space)
    if (options.allow_negative_sign_placeholder) pattern = "( (?!\\-))?".concat(pattern);
    else if (options.allow_space_after_symbol) pattern = " ?".concat(pattern);
    else if (options.allow_space_after_digits) pattern += '( (?!$))?';
    if (options.symbol_after_digits) pattern += symbol;
    else pattern = symbol + pattern;
    if (options.allow_negatives) {
        if (options.parens_for_negatives) pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
        else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) pattern = negative + pattern;
    }
    // ensure there's a dollar and/or decimal amount, and that
    // it doesn't start with a space or a negative sign followed by a space
    return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
}
var $47b2c35952174662$var$default_currency_options = {
    symbol: '$',
    require_symbol: false,
    allow_space_after_symbol: false,
    symbol_after_digits: false,
    allow_negatives: true,
    parens_for_negatives: false,
    negative_sign_before_digits: false,
    negative_sign_after_digits: false,
    allow_negative_sign_placeholder: false,
    thousands_separator: ',',
    decimal_separator: '.',
    allow_decimal: true,
    require_decimal: false,
    digits_after_decimal: [
        2
    ],
    allow_space_after_digits: false
};
function $47b2c35952174662$var$isCurrency(str, options) {
    (0, $47b2c35952174662$var$_assertString.default)(str);
    options = (0, $47b2c35952174662$var$_merge.default)(options, $47b2c35952174662$var$default_currency_options);
    return $47b2c35952174662$var$currencyRegex(options).test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ilHLb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5bc2200059d86b7$var$isBtcAddress;

var $d5bc2200059d86b7$var$_assertString = $d5bc2200059d86b7$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d5bc2200059d86b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d5bc2200059d86b7$var$bech32 = /^(bc1)[a-z0-9]{25,39}$/;
var $d5bc2200059d86b7$var$base58 = /^(1|3)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
function $d5bc2200059d86b7$var$isBtcAddress(str) {
    (0, $d5bc2200059d86b7$var$_assertString.default)(str);
    return $d5bc2200059d86b7$var$bech32.test(str) || $d5bc2200059d86b7$var$base58.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hU7qv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d08d6d658bf74fa2$var$isISO6391;

var $d08d6d658bf74fa2$var$_assertString = $d08d6d658bf74fa2$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d08d6d658bf74fa2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d08d6d658bf74fa2$var$isISO6391Set = new Set([
    'aa',
    'ab',
    'ae',
    'af',
    'ak',
    'am',
    'an',
    'ar',
    'as',
    'av',
    'ay',
    'az',
    'az',
    'ba',
    'be',
    'bg',
    'bh',
    'bi',
    'bm',
    'bn',
    'bo',
    'br',
    'bs',
    'ca',
    'ce',
    'ch',
    'co',
    'cr',
    'cs',
    'cu',
    'cv',
    'cy',
    'da',
    'de',
    'dv',
    'dz',
    'ee',
    'el',
    'en',
    'eo',
    'es',
    'et',
    'eu',
    'fa',
    'ff',
    'fi',
    'fj',
    'fo',
    'fr',
    'fy',
    'ga',
    'gd',
    'gl',
    'gn',
    'gu',
    'gv',
    'ha',
    'he',
    'hi',
    'ho',
    'hr',
    'ht',
    'hu',
    'hy',
    'hz',
    'ia',
    'id',
    'ie',
    'ig',
    'ii',
    'ik',
    'io',
    'is',
    'it',
    'iu',
    'ja',
    'jv',
    'ka',
    'kg',
    'ki',
    'kj',
    'kk',
    'kl',
    'km',
    'kn',
    'ko',
    'kr',
    'ks',
    'ku',
    'kv',
    'kw',
    'ky',
    'la',
    'lb',
    'lg',
    'li',
    'ln',
    'lo',
    'lt',
    'lu',
    'lv',
    'mg',
    'mh',
    'mi',
    'mk',
    'ml',
    'mn',
    'mr',
    'ms',
    'mt',
    'my',
    'na',
    'nb',
    'nd',
    'ne',
    'ng',
    'nl',
    'nn',
    'no',
    'nr',
    'nv',
    'ny',
    'oc',
    'oj',
    'om',
    'or',
    'os',
    'pa',
    'pi',
    'pl',
    'ps',
    'pt',
    'qu',
    'rm',
    'rn',
    'ro',
    'ru',
    'rw',
    'sa',
    'sc',
    'sd',
    'se',
    'sg',
    'si',
    'sk',
    'sl',
    'sm',
    'sn',
    'so',
    'sq',
    'sr',
    'ss',
    'st',
    'su',
    'sv',
    'sw',
    'ta',
    'te',
    'tg',
    'th',
    'ti',
    'tk',
    'tl',
    'tn',
    'to',
    'tr',
    'ts',
    'tt',
    'tw',
    'ty',
    'ug',
    'uk',
    'ur',
    'uz',
    've',
    'vi',
    'vo',
    'wa',
    'wo',
    'xh',
    'yi',
    'yo',
    'za',
    'zh',
    'zu'
]);
function $d08d6d658bf74fa2$var$isISO6391(str) {
    (0, $d08d6d658bf74fa2$var$_assertString.default)(str);
    return $d08d6d658bf74fa2$var$isISO6391Set.has(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("aWF3e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f7f2a0b9464276d$var$isISO8601;

var $7f7f2a0b9464276d$var$_assertString = $7f7f2a0b9464276d$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $7f7f2a0b9464276d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable max-len */ // from http://goo.gl/0ejHHW
var $7f7f2a0b9464276d$var$iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
// same as above, except with a strict 'T' separator between date and time
var $7f7f2a0b9464276d$var$iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */ var $7f7f2a0b9464276d$var$isValidDate = function isValidDate(str) {
    // str must have passed the ISO8601 check
    // this check is meant to catch invalid dates
    // like 2009-02-31
    // first check for ordinal dates
    var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
    if (ordinalMatch) {
        var oYear = Number(ordinalMatch[1]);
        var oDay = Number(ordinalMatch[2]);
        // if is leap year
        if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
        return oDay <= 365;
    }
    var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
    var year = match[1];
    var month = match[2];
    var day = match[3];
    var monthString = month ? "0".concat(month).slice(-2) : month;
    var dayString = day ? "0".concat(day).slice(-2) : day;
    // create a date object and compare
    var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
    if (month && day) return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
    return true;
};
function $7f7f2a0b9464276d$var$isISO8601(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $7f7f2a0b9464276d$var$_assertString.default)(str);
    var check = options.strictSeparator ? $7f7f2a0b9464276d$var$iso8601StrictSeparator.test(str) : $7f7f2a0b9464276d$var$iso8601.test(str);
    if (check && options.strict) return $7f7f2a0b9464276d$var$isValidDate(str);
    return check;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("36TYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $243d5b20df38b9fe$var$isRFC3339;

var $243d5b20df38b9fe$var$_assertString = $243d5b20df38b9fe$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $243d5b20df38b9fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */ var $243d5b20df38b9fe$var$dateFullYear = /[0-9]{4}/;
var $243d5b20df38b9fe$var$dateMonth = /(0[1-9]|1[0-2])/;
var $243d5b20df38b9fe$var$dateMDay = /([12]\d|0[1-9]|3[01])/;
var $243d5b20df38b9fe$var$timeHour = /([01][0-9]|2[0-3])/;
var $243d5b20df38b9fe$var$timeMinute = /[0-5][0-9]/;
var $243d5b20df38b9fe$var$timeSecond = /([0-5][0-9]|60)/;
var $243d5b20df38b9fe$var$timeSecFrac = /(\.[0-9]+)?/;
var $243d5b20df38b9fe$var$timeNumOffset = new RegExp("[-+]".concat($243d5b20df38b9fe$var$timeHour.source, ":").concat($243d5b20df38b9fe$var$timeMinute.source));
var $243d5b20df38b9fe$var$timeOffset = new RegExp("([zZ]|".concat($243d5b20df38b9fe$var$timeNumOffset.source, ")"));
var $243d5b20df38b9fe$var$partialTime = new RegExp("".concat($243d5b20df38b9fe$var$timeHour.source, ":").concat($243d5b20df38b9fe$var$timeMinute.source, ":").concat($243d5b20df38b9fe$var$timeSecond.source).concat($243d5b20df38b9fe$var$timeSecFrac.source));
var $243d5b20df38b9fe$var$fullDate = new RegExp("".concat($243d5b20df38b9fe$var$dateFullYear.source, "-").concat($243d5b20df38b9fe$var$dateMonth.source, "-").concat($243d5b20df38b9fe$var$dateMDay.source));
var $243d5b20df38b9fe$var$fullTime = new RegExp("".concat($243d5b20df38b9fe$var$partialTime.source).concat($243d5b20df38b9fe$var$timeOffset.source));
var $243d5b20df38b9fe$var$rfc3339 = new RegExp("^".concat($243d5b20df38b9fe$var$fullDate.source, "[ tT]").concat($243d5b20df38b9fe$var$fullTime.source, "$"));
function $243d5b20df38b9fe$var$isRFC3339(str) {
    (0, $243d5b20df38b9fe$var$_assertString.default)(str);
    return $243d5b20df38b9fe$var$rfc3339.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("lPnYX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe40f6c125f0e17f$var$isISO31661Alpha3;

var $fe40f6c125f0e17f$var$_assertString = $fe40f6c125f0e17f$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $fe40f6c125f0e17f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
var $fe40f6c125f0e17f$var$validISO31661Alpha3CountriesCodes = new Set([
    'AFG',
    'ALA',
    'ALB',
    'DZA',
    'ASM',
    'AND',
    'AGO',
    'AIA',
    'ATA',
    'ATG',
    'ARG',
    'ARM',
    'ABW',
    'AUS',
    'AUT',
    'AZE',
    'BHS',
    'BHR',
    'BGD',
    'BRB',
    'BLR',
    'BEL',
    'BLZ',
    'BEN',
    'BMU',
    'BTN',
    'BOL',
    'BES',
    'BIH',
    'BWA',
    'BVT',
    'BRA',
    'IOT',
    'BRN',
    'BGR',
    'BFA',
    'BDI',
    'KHM',
    'CMR',
    'CAN',
    'CPV',
    'CYM',
    'CAF',
    'TCD',
    'CHL',
    'CHN',
    'CXR',
    'CCK',
    'COL',
    'COM',
    'COG',
    'COD',
    'COK',
    'CRI',
    'CIV',
    'HRV',
    'CUB',
    'CUW',
    'CYP',
    'CZE',
    'DNK',
    'DJI',
    'DMA',
    'DOM',
    'ECU',
    'EGY',
    'SLV',
    'GNQ',
    'ERI',
    'EST',
    'ETH',
    'FLK',
    'FRO',
    'FJI',
    'FIN',
    'FRA',
    'GUF',
    'PYF',
    'ATF',
    'GAB',
    'GMB',
    'GEO',
    'DEU',
    'GHA',
    'GIB',
    'GRC',
    'GRL',
    'GRD',
    'GLP',
    'GUM',
    'GTM',
    'GGY',
    'GIN',
    'GNB',
    'GUY',
    'HTI',
    'HMD',
    'VAT',
    'HND',
    'HKG',
    'HUN',
    'ISL',
    'IND',
    'IDN',
    'IRN',
    'IRQ',
    'IRL',
    'IMN',
    'ISR',
    'ITA',
    'JAM',
    'JPN',
    'JEY',
    'JOR',
    'KAZ',
    'KEN',
    'KIR',
    'PRK',
    'KOR',
    'KWT',
    'KGZ',
    'LAO',
    'LVA',
    'LBN',
    'LSO',
    'LBR',
    'LBY',
    'LIE',
    'LTU',
    'LUX',
    'MAC',
    'MKD',
    'MDG',
    'MWI',
    'MYS',
    'MDV',
    'MLI',
    'MLT',
    'MHL',
    'MTQ',
    'MRT',
    'MUS',
    'MYT',
    'MEX',
    'FSM',
    'MDA',
    'MCO',
    'MNG',
    'MNE',
    'MSR',
    'MAR',
    'MOZ',
    'MMR',
    'NAM',
    'NRU',
    'NPL',
    'NLD',
    'NCL',
    'NZL',
    'NIC',
    'NER',
    'NGA',
    'NIU',
    'NFK',
    'MNP',
    'NOR',
    'OMN',
    'PAK',
    'PLW',
    'PSE',
    'PAN',
    'PNG',
    'PRY',
    'PER',
    'PHL',
    'PCN',
    'POL',
    'PRT',
    'PRI',
    'QAT',
    'REU',
    'ROU',
    'RUS',
    'RWA',
    'BLM',
    'SHN',
    'KNA',
    'LCA',
    'MAF',
    'SPM',
    'VCT',
    'WSM',
    'SMR',
    'STP',
    'SAU',
    'SEN',
    'SRB',
    'SYC',
    'SLE',
    'SGP',
    'SXM',
    'SVK',
    'SVN',
    'SLB',
    'SOM',
    'ZAF',
    'SGS',
    'SSD',
    'ESP',
    'LKA',
    'SDN',
    'SUR',
    'SJM',
    'SWZ',
    'SWE',
    'CHE',
    'SYR',
    'TWN',
    'TJK',
    'TZA',
    'THA',
    'TLS',
    'TGO',
    'TKL',
    'TON',
    'TTO',
    'TUN',
    'TUR',
    'TKM',
    'TCA',
    'TUV',
    'UGA',
    'UKR',
    'ARE',
    'GBR',
    'USA',
    'UMI',
    'URY',
    'UZB',
    'VUT',
    'VEN',
    'VNM',
    'VGB',
    'VIR',
    'WLF',
    'ESH',
    'YEM',
    'ZMB',
    'ZWE'
]);
function $fe40f6c125f0e17f$var$isISO31661Alpha3(str) {
    (0, $fe40f6c125f0e17f$var$_assertString.default)(str);
    return $fe40f6c125f0e17f$var$validISO31661Alpha3CountriesCodes.has(str.toUpperCase());
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("kkpNa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CurrencyCodes = void 0;
module.exports.default = $ecc9aea7870eee5a$var$isISO4217;

var $ecc9aea7870eee5a$var$_assertString = $ecc9aea7870eee5a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $ecc9aea7870eee5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// from https://en.wikipedia.org/wiki/ISO_4217
var $ecc9aea7870eee5a$var$validISO4217CurrencyCodes = new Set([
    'AED',
    'AFN',
    'ALL',
    'AMD',
    'ANG',
    'AOA',
    'ARS',
    'AUD',
    'AWG',
    'AZN',
    'BAM',
    'BBD',
    'BDT',
    'BGN',
    'BHD',
    'BIF',
    'BMD',
    'BND',
    'BOB',
    'BOV',
    'BRL',
    'BSD',
    'BTN',
    'BWP',
    'BYN',
    'BZD',
    'CAD',
    'CDF',
    'CHE',
    'CHF',
    'CHW',
    'CLF',
    'CLP',
    'CNY',
    'COP',
    'COU',
    'CRC',
    'CUC',
    'CUP',
    'CVE',
    'CZK',
    'DJF',
    'DKK',
    'DOP',
    'DZD',
    'EGP',
    'ERN',
    'ETB',
    'EUR',
    'FJD',
    'FKP',
    'GBP',
    'GEL',
    'GHS',
    'GIP',
    'GMD',
    'GNF',
    'GTQ',
    'GYD',
    'HKD',
    'HNL',
    'HRK',
    'HTG',
    'HUF',
    'IDR',
    'ILS',
    'INR',
    'IQD',
    'IRR',
    'ISK',
    'JMD',
    'JOD',
    'JPY',
    'KES',
    'KGS',
    'KHR',
    'KMF',
    'KPW',
    'KRW',
    'KWD',
    'KYD',
    'KZT',
    'LAK',
    'LBP',
    'LKR',
    'LRD',
    'LSL',
    'LYD',
    'MAD',
    'MDL',
    'MGA',
    'MKD',
    'MMK',
    'MNT',
    'MOP',
    'MRU',
    'MUR',
    'MVR',
    'MWK',
    'MXN',
    'MXV',
    'MYR',
    'MZN',
    'NAD',
    'NGN',
    'NIO',
    'NOK',
    'NPR',
    'NZD',
    'OMR',
    'PAB',
    'PEN',
    'PGK',
    'PHP',
    'PKR',
    'PLN',
    'PYG',
    'QAR',
    'RON',
    'RSD',
    'RUB',
    'RWF',
    'SAR',
    'SBD',
    'SCR',
    'SDG',
    'SEK',
    'SGD',
    'SHP',
    'SLE',
    'SLL',
    'SOS',
    'SRD',
    'SSP',
    'STN',
    'SVC',
    'SYP',
    'SZL',
    'THB',
    'TJS',
    'TMT',
    'TND',
    'TOP',
    'TRY',
    'TTD',
    'TWD',
    'TZS',
    'UAH',
    'UGX',
    'USD',
    'USN',
    'UYI',
    'UYU',
    'UYW',
    'UZS',
    'VES',
    'VND',
    'VUV',
    'WST',
    'XAF',
    'XAG',
    'XAU',
    'XBA',
    'XBB',
    'XBC',
    'XBD',
    'XCD',
    'XDR',
    'XOF',
    'XPD',
    'XPF',
    'XPT',
    'XSU',
    'XTS',
    'XUA',
    'XXX',
    'YER',
    'ZAR',
    'ZMW',
    'ZWL'
]);
function $ecc9aea7870eee5a$var$isISO4217(str) {
    (0, $ecc9aea7870eee5a$var$_assertString.default)(str);
    return $ecc9aea7870eee5a$var$validISO4217CurrencyCodes.has(str.toUpperCase());
}
var $ecc9aea7870eee5a$var$CurrencyCodes = module.exports.CurrencyCodes = $ecc9aea7870eee5a$var$validISO4217CurrencyCodes;

});

parcelRegister("e8aAF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a49a07144f7aa9af$var$isBase32;

var $a49a07144f7aa9af$var$_assertString = $a49a07144f7aa9af$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $a49a07144f7aa9af$var$_merge = $a49a07144f7aa9af$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $a49a07144f7aa9af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a49a07144f7aa9af$var$base32 = /^[A-Z2-7]+=*$/;
var $a49a07144f7aa9af$var$crockfordBase32 = /^[A-HJKMNP-TV-Z0-9]+$/;
var $a49a07144f7aa9af$var$defaultBase32Options = {
    crockford: false
};
function $a49a07144f7aa9af$var$isBase32(str, options) {
    (0, $a49a07144f7aa9af$var$_assertString.default)(str);
    options = (0, $a49a07144f7aa9af$var$_merge.default)(options, $a49a07144f7aa9af$var$defaultBase32Options);
    if (options.crockford) return $a49a07144f7aa9af$var$crockfordBase32.test(str);
    var len = str.length;
    if (len % 8 === 0 && $a49a07144f7aa9af$var$base32.test(str)) return true;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("bgzme", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $021de18270a25cdd$var$isBase58;

var $021de18270a25cdd$var$_assertString = $021de18270a25cdd$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $021de18270a25cdd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Accepted chars - 123456789ABCDEFGH JKLMN PQRSTUVWXYZabcdefghijk mnopqrstuvwxyz
var $021de18270a25cdd$var$base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;
function $021de18270a25cdd$var$isBase58(str) {
    (0, $021de18270a25cdd$var$_assertString.default)(str);
    if ($021de18270a25cdd$var$base58Reg.test(str)) return true;
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("8REOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6742edfa489dd2ed$var$isDataURI;

var $6742edfa489dd2ed$var$_assertString = $6742edfa489dd2ed$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6742edfa489dd2ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6742edfa489dd2ed$var$validMediaType = /^[a-z]+\/[a-z0-9\-\+\._]+$/i;
var $6742edfa489dd2ed$var$validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
var $6742edfa489dd2ed$var$validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
function $6742edfa489dd2ed$var$isDataURI(str) {
    (0, $6742edfa489dd2ed$var$_assertString.default)(str);
    var data = str.split(',');
    if (data.length < 2) return false;
    var attributes = data.shift().trim().split(';');
    var schemeAndMediaType = attributes.shift();
    if (schemeAndMediaType.slice(0, 5) !== 'data:') return false;
    var mediaType = schemeAndMediaType.slice(5);
    if (mediaType !== '' && !$6742edfa489dd2ed$var$validMediaType.test(mediaType)) return false;
    for(var i = 0; i < attributes.length; i++){
        if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') && !$6742edfa489dd2ed$var$validAttribute.test(attributes[i])) return false;
    }
    for(var _i = 0; _i < data.length; _i++){
        if (!$6742edfa489dd2ed$var$validData.test(data[_i])) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ix1xQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d7dc81d17a256047$var$isMagnetURI;

var $d7dc81d17a256047$var$_assertString = $d7dc81d17a256047$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d7dc81d17a256047$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d7dc81d17a256047$var$magnetURIComponent = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
function $d7dc81d17a256047$var$isMagnetURI(url) {
    (0, $d7dc81d17a256047$var$_assertString.default)(url);
    if (url.indexOf('magnet:?') !== 0) return false;
    return $d7dc81d17a256047$var$magnetURIComponent.test(url);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("iIqBH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0384250f1ad87c0f$var$isMailtoURI;

var $0384250f1ad87c0f$var$_trim = $0384250f1ad87c0f$var$_interopRequireDefault((parcelRequire("4wt0T")));

var $0384250f1ad87c0f$var$_isEmail = $0384250f1ad87c0f$var$_interopRequireDefault((parcelRequire("4tHKL")));

var $0384250f1ad87c0f$var$_assertString = $0384250f1ad87c0f$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $0384250f1ad87c0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0384250f1ad87c0f$var$_slicedToArray(arr, i) {
    return $0384250f1ad87c0f$var$_arrayWithHoles(arr) || $0384250f1ad87c0f$var$_iterableToArrayLimit(arr, i) || $0384250f1ad87c0f$var$_unsupportedIterableToArray(arr, i) || $0384250f1ad87c0f$var$_nonIterableRest();
}
function $0384250f1ad87c0f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0384250f1ad87c0f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0384250f1ad87c0f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0384250f1ad87c0f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $0384250f1ad87c0f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $0384250f1ad87c0f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0384250f1ad87c0f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0384250f1ad87c0f$var$_arrayLikeToArray(o, minLen);
}
function $0384250f1ad87c0f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0384250f1ad87c0f$var$parseMailtoQueryString(queryString) {
    var allowedParams = new Set([
        'subject',
        'body',
        'cc',
        'bcc'
    ]), query = {
        cc: '',
        bcc: ''
    };
    var isParseFailed = false;
    var queryParams = queryString.split('&');
    if (queryParams.length > 4) return false;
    var _iterator = $0384250f1ad87c0f$var$_createForOfIteratorHelper(queryParams), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var q = _step.value;
            var _q$split = q.split('='), _q$split2 = $0384250f1ad87c0f$var$_slicedToArray(_q$split, 2), key = _q$split2[0], value = _q$split2[1];
            // checked for invalid and duplicated query params
            if (key && !allowedParams.has(key)) {
                isParseFailed = true;
                break;
            }
            if (value && (key === 'cc' || key === 'bcc')) query[key] = value;
            if (key) allowedParams.delete(key);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return isParseFailed ? false : query;
}
function $0384250f1ad87c0f$var$isMailtoURI(url, options) {
    (0, $0384250f1ad87c0f$var$_assertString.default)(url);
    if (url.indexOf('mailto:') !== 0) return false;
    var _url$replace$split = url.replace('mailto:', '').split('?'), _url$replace$split2 = $0384250f1ad87c0f$var$_slicedToArray(_url$replace$split, 2), to = _url$replace$split2[0], _url$replace$split2$ = _url$replace$split2[1], queryString = _url$replace$split2$ === void 0 ? '' : _url$replace$split2$;
    if (!to && !queryString) return true;
    var query = $0384250f1ad87c0f$var$parseMailtoQueryString(queryString);
    if (!query) return false;
    return "".concat(to, ",").concat(query.cc, ",").concat(query.bcc).split(',').every(function(email) {
        email = (0, $0384250f1ad87c0f$var$_trim.default)(email, ' ');
        if (email) return (0, $0384250f1ad87c0f$var$_isEmail.default)(email, options);
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("4wt0T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34b0a80b14e7b38f$var$trim;

var $34b0a80b14e7b38f$var$_rtrim = $34b0a80b14e7b38f$var$_interopRequireDefault((parcelRequire("l0bpl")));

var $34b0a80b14e7b38f$var$_ltrim = $34b0a80b14e7b38f$var$_interopRequireDefault((parcelRequire("77DLn")));
function $34b0a80b14e7b38f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34b0a80b14e7b38f$var$trim(str, chars) {
    return (0, $34b0a80b14e7b38f$var$_rtrim.default)((0, $34b0a80b14e7b38f$var$_ltrim.default)(str, chars), chars);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("l0bpl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4a272643984d26b$var$rtrim;

var $f4a272643984d26b$var$_assertString = $f4a272643984d26b$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $f4a272643984d26b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f4a272643984d26b$var$rtrim(str, chars) {
    (0, $f4a272643984d26b$var$_assertString.default)(str);
    if (chars) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
        var pattern = new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+$"), 'g');
        return str.replace(pattern, '');
    }
    // Use a faster and more safe than regex trim method https://blog.stevenlevithan.com/archives/faster-trim-javascript
    var strIndex = str.length - 1;
    while(/\s/.test(str.charAt(strIndex)))strIndex -= 1;
    return str.slice(0, strIndex + 1);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("77DLn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52f807f7ca36aa45$var$ltrim;

var $52f807f7ca36aa45$var$_assertString = $52f807f7ca36aa45$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $52f807f7ca36aa45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52f807f7ca36aa45$var$ltrim(str, chars) {
    (0, $52f807f7ca36aa45$var$_assertString.default)(str);
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
    var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "]+"), 'g') : /^\s+/g;
    return str.replace(pattern, '');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});



parcelRegister("ifxP4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d493dd330f4b6dfc$var$isMimeType;

var $d493dd330f4b6dfc$var$_assertString = $d493dd330f4b6dfc$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d493dd330f4b6dfc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/ // Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).
var $d493dd330f4b6dfc$var$mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i; // eslint-disable-line max-len
// Handle "charset" in "text/*"
var $d493dd330f4b6dfc$var$mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
// Handle "boundary" in "multipart/*"
var $d493dd330f4b6dfc$var$mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len
function $d493dd330f4b6dfc$var$isMimeType(str) {
    (0, $d493dd330f4b6dfc$var$_assertString.default)(str);
    return $d493dd330f4b6dfc$var$mimeTypeSimple.test(str) || $d493dd330f4b6dfc$var$mimeTypeText.test(str) || $d493dd330f4b6dfc$var$mimeTypeMultipart.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("hLP11", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cefe66122bbf91f0$var$isLatLong;

var $cefe66122bbf91f0$var$_assertString = $cefe66122bbf91f0$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $cefe66122bbf91f0$var$_merge = $cefe66122bbf91f0$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $cefe66122bbf91f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cefe66122bbf91f0$var$lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var $cefe66122bbf91f0$var$long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
var $cefe66122bbf91f0$var$latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
var $cefe66122bbf91f0$var$longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
var $cefe66122bbf91f0$var$defaultLatLongOptions = {
    checkDMS: false
};
function $cefe66122bbf91f0$var$isLatLong(str, options) {
    (0, $cefe66122bbf91f0$var$_assertString.default)(str);
    options = (0, $cefe66122bbf91f0$var$_merge.default)(options, $cefe66122bbf91f0$var$defaultLatLongOptions);
    if (!str.includes(',')) return false;
    var pair = str.split(',');
    if (pair[0].startsWith('(') && !pair[1].endsWith(')') || pair[1].endsWith(')') && !pair[0].startsWith('(')) return false;
    if (options.checkDMS) return $cefe66122bbf91f0$var$latDMS.test(pair[0]) && $cefe66122bbf91f0$var$longDMS.test(pair[1]);
    return $cefe66122bbf91f0$var$lat.test(pair[0]) && $cefe66122bbf91f0$var$long.test(pair[1]);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("7qOwX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5692286c0b9ed50a$var$isPostalCode;
module.exports.locales = void 0;

var $5692286c0b9ed50a$var$_assertString = $5692286c0b9ed50a$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $5692286c0b9ed50a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// common patterns
var $5692286c0b9ed50a$var$threeDigit = /^\d{3}$/;
var $5692286c0b9ed50a$var$fourDigit = /^\d{4}$/;
var $5692286c0b9ed50a$var$fiveDigit = /^\d{5}$/;
var $5692286c0b9ed50a$var$sixDigit = /^\d{6}$/;
var $5692286c0b9ed50a$var$patterns = {
    AD: /^AD\d{3}$/,
    AT: $5692286c0b9ed50a$var$fourDigit,
    AU: $5692286c0b9ed50a$var$fourDigit,
    AZ: /^AZ\d{4}$/,
    BA: /^([7-8]\d{4}$)/,
    BE: $5692286c0b9ed50a$var$fourDigit,
    BG: $5692286c0b9ed50a$var$fourDigit,
    BR: /^\d{5}-\d{3}$/,
    BY: /^2[1-4]\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: $5692286c0b9ed50a$var$fourDigit,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: $5692286c0b9ed50a$var$fiveDigit,
    DK: $5692286c0b9ed50a$var$fourDigit,
    DO: $5692286c0b9ed50a$var$fiveDigit,
    DZ: $5692286c0b9ed50a$var$fiveDigit,
    EE: $5692286c0b9ed50a$var$fiveDigit,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: $5692286c0b9ed50a$var$fiveDigit,
    FR: /^\d{2}\s?\d{3}$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: $5692286c0b9ed50a$var$fourDigit,
    ID: $5692286c0b9ed50a$var$fiveDigit,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
    IS: $5692286c0b9ed50a$var$threeDigit,
    IT: $5692286c0b9ed50a$var$fiveDigit,
    JP: /^\d{3}\-\d{4}$/,
    KE: $5692286c0b9ed50a$var$fiveDigit,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: $5692286c0b9ed50a$var$fourDigit,
    LV: /^LV\-\d{4}$/,
    LK: $5692286c0b9ed50a$var$fiveDigit,
    MG: $5692286c0b9ed50a$var$threeDigit,
    MX: $5692286c0b9ed50a$var$fiveDigit,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: $5692286c0b9ed50a$var$fiveDigit,
    NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
    NO: $5692286c0b9ed50a$var$fourDigit,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: $5692286c0b9ed50a$var$fourDigit,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: $5692286c0b9ed50a$var$sixDigit,
    RU: $5692286c0b9ed50a$var$sixDigit,
    SA: $5692286c0b9ed50a$var$fiveDigit,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: $5692286c0b9ed50a$var$sixDigit,
    SI: $5692286c0b9ed50a$var$fourDigit,
    SK: /^\d{3}\s?\d{2}$/,
    TH: $5692286c0b9ed50a$var$fiveDigit,
    TN: $5692286c0b9ed50a$var$fourDigit,
    TW: /^\d{3}(\d{2})?$/,
    UA: $5692286c0b9ed50a$var$fiveDigit,
    US: /^\d{5}(-\d{4})?$/,
    ZA: $5692286c0b9ed50a$var$fourDigit,
    ZM: $5692286c0b9ed50a$var$fiveDigit
};
var $5692286c0b9ed50a$var$locales = module.exports.locales = Object.keys($5692286c0b9ed50a$var$patterns);
function $5692286c0b9ed50a$var$isPostalCode(str, locale) {
    (0, $5692286c0b9ed50a$var$_assertString.default)(str);
    if (locale in $5692286c0b9ed50a$var$patterns) return $5692286c0b9ed50a$var$patterns[locale].test(str);
    else if (locale === 'any') {
        for(var key in $5692286c0b9ed50a$var$patterns)// https://github.com/gotwarlost/istanbul/blob/master/ignoring-code-for-coverage.md#ignoring-code-for-coverage-purposes
        // istanbul ignore else
        if ($5692286c0b9ed50a$var$patterns.hasOwnProperty(key)) {
            var pattern = $5692286c0b9ed50a$var$patterns[key];
            if (pattern.test(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}

});

parcelRegister("lhIbP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7ed76b251dcd1fd$var$escape;

var $f7ed76b251dcd1fd$var$_assertString = $f7ed76b251dcd1fd$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $f7ed76b251dcd1fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f7ed76b251dcd1fd$var$escape(str) {
    (0, $f7ed76b251dcd1fd$var$_assertString.default)(str);
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("Oufps", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $097c222895162552$var$unescape;

var $097c222895162552$var$_assertString = $097c222895162552$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $097c222895162552$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $097c222895162552$var$unescape(str) {
    (0, $097c222895162552$var$_assertString.default)(str);
    return str.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`').replace(/&amp;/g, '&');
// &amp; replacement has to be the last one to prevent
// bugs with intermediate strings containing escape sequences
// See: https://github.com/validatorjs/validator.js/issues/1827
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("l68Ml", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5c0f7cd3eb51c3e$var$stripLow;

var $f5c0f7cd3eb51c3e$var$_assertString = $f5c0f7cd3eb51c3e$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $f5c0f7cd3eb51c3e$var$_blacklist = $f5c0f7cd3eb51c3e$var$_interopRequireDefault((parcelRequire("hVEzS")));
function $f5c0f7cd3eb51c3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5c0f7cd3eb51c3e$var$stripLow(str, keep_new_lines) {
    (0, $f5c0f7cd3eb51c3e$var$_assertString.default)(str);
    var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
    return (0, $f5c0f7cd3eb51c3e$var$_blacklist.default)(str, chars);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("hVEzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0d73c6d2b68ff07$var$blacklist;

var $d0d73c6d2b68ff07$var$_assertString = $d0d73c6d2b68ff07$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $d0d73c6d2b68ff07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0d73c6d2b68ff07$var$blacklist(str, chars) {
    (0, $d0d73c6d2b68ff07$var$_assertString.default)(str);
    return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("d4jRJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $983b0ef670b4c2a7$var$whitelist;

var $983b0ef670b4c2a7$var$_assertString = $983b0ef670b4c2a7$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $983b0ef670b4c2a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $983b0ef670b4c2a7$var$whitelist(str, chars) {
    (0, $983b0ef670b4c2a7$var$_assertString.default)(str);
    return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("b8HgM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81c2017f0aec10fa$var$isWhitelisted;

var $81c2017f0aec10fa$var$_assertString = $81c2017f0aec10fa$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $81c2017f0aec10fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $81c2017f0aec10fa$var$isWhitelisted(str, chars) {
    (0, $81c2017f0aec10fa$var$_assertString.default)(str);
    for(var i = str.length - 1; i >= 0; i--){
        if (chars.indexOf(str[i]) === -1) return false;
    }
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("j002o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd4e0bd9ef8f5472$var$normalizeEmail;

var $dd4e0bd9ef8f5472$var$_merge = $dd4e0bd9ef8f5472$var$_interopRequireDefault((parcelRequire("9nDkO")));
function $dd4e0bd9ef8f5472$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dd4e0bd9ef8f5472$var$default_normalize_email_options = {
    // The following options apply to all email addresses
    // Lowercases the local part of the email address.
    // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
    // The domain is always lowercased, as per RFC 1035
    all_lowercase: true,
    // The following conversions are specific to GMail
    // Lowercases the local part of the GMail address (known to be case-insensitive)
    gmail_lowercase: true,
    // Removes dots from the local part of the email address, as that's ignored by GMail
    gmail_remove_dots: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    gmail_remove_subaddress: true,
    // Conversts the googlemail.com domain to gmail.com
    gmail_convert_googlemaildotcom: true,
    // The following conversions are specific to Outlook.com / Windows Live / Hotmail
    // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
    outlookdotcom_lowercase: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    outlookdotcom_remove_subaddress: true,
    // The following conversions are specific to Yahoo
    // Lowercases the local part of the Yahoo address (known to be case-insensitive)
    yahoo_lowercase: true,
    // Removes the subaddress (e.g. "-foo") from the email address
    yahoo_remove_subaddress: true,
    // The following conversions are specific to Yandex
    // Lowercases the local part of the Yandex address (known to be case-insensitive)
    yandex_lowercase: true,
    // The following conversions are specific to iCloud
    // Lowercases the local part of the iCloud address (known to be case-insensitive)
    icloud_lowercase: true,
    // Removes the subaddress (e.g. "+foo") from the email address
    icloud_remove_subaddress: true
};
// List of domains used by iCloud
var $dd4e0bd9ef8f5472$var$icloud_domains = [
    'icloud.com',
    'me.com'
];
// List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/
var $dd4e0bd9ef8f5472$var$outlookdotcom_domains = [
    'hotmail.at',
    'hotmail.be',
    'hotmail.ca',
    'hotmail.cl',
    'hotmail.co.il',
    'hotmail.co.nz',
    'hotmail.co.th',
    'hotmail.co.uk',
    'hotmail.com',
    'hotmail.com.ar',
    'hotmail.com.au',
    'hotmail.com.br',
    'hotmail.com.gr',
    'hotmail.com.mx',
    'hotmail.com.pe',
    'hotmail.com.tr',
    'hotmail.com.vn',
    'hotmail.cz',
    'hotmail.de',
    'hotmail.dk',
    'hotmail.es',
    'hotmail.fr',
    'hotmail.hu',
    'hotmail.id',
    'hotmail.ie',
    'hotmail.in',
    'hotmail.it',
    'hotmail.jp',
    'hotmail.kr',
    'hotmail.lv',
    'hotmail.my',
    'hotmail.ph',
    'hotmail.pt',
    'hotmail.sa',
    'hotmail.sg',
    'hotmail.sk',
    'live.be',
    'live.co.uk',
    'live.com',
    'live.com.ar',
    'live.com.mx',
    'live.de',
    'live.es',
    'live.eu',
    'live.fr',
    'live.it',
    'live.nl',
    'msn.com',
    'outlook.at',
    'outlook.be',
    'outlook.cl',
    'outlook.co.il',
    'outlook.co.nz',
    'outlook.co.th',
    'outlook.com',
    'outlook.com.ar',
    'outlook.com.au',
    'outlook.com.br',
    'outlook.com.gr',
    'outlook.com.pe',
    'outlook.com.tr',
    'outlook.com.vn',
    'outlook.cz',
    'outlook.de',
    'outlook.dk',
    'outlook.es',
    'outlook.fr',
    'outlook.hu',
    'outlook.id',
    'outlook.ie',
    'outlook.in',
    'outlook.it',
    'outlook.jp',
    'outlook.kr',
    'outlook.lv',
    'outlook.my',
    'outlook.ph',
    'outlook.pt',
    'outlook.sa',
    'outlook.sg',
    'outlook.sk',
    'passport.com'
];
// List of domains used by Yahoo Mail
// This list is likely incomplete
var $dd4e0bd9ef8f5472$var$yahoo_domains = [
    'rocketmail.com',
    'yahoo.ca',
    'yahoo.co.uk',
    'yahoo.com',
    'yahoo.de',
    'yahoo.fr',
    'yahoo.in',
    'yahoo.it',
    'ymail.com'
];
// List of domains used by yandex.ru
var $dd4e0bd9ef8f5472$var$yandex_domains = [
    'yandex.ru',
    'yandex.ua',
    'yandex.kz',
    'yandex.com',
    'yandex.by',
    'ya.ru'
];
// replace single dots, but not multiple consecutive dots
function $dd4e0bd9ef8f5472$var$dotsReplacer(match) {
    if (match.length > 1) return match;
    return '';
}
function $dd4e0bd9ef8f5472$var$normalizeEmail(email, options) {
    options = (0, $dd4e0bd9ef8f5472$var$_merge.default)(options, $dd4e0bd9ef8f5472$var$default_normalize_email_options);
    var raw_parts = email.split('@');
    var domain = raw_parts.pop();
    var user = raw_parts.join('@');
    var parts = [
        user,
        domain
    ];
    // The domain is always lowercased, as it's case-insensitive per RFC 1035
    parts[1] = parts[1].toLowerCase();
    if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
        // Address is GMail
        if (options.gmail_remove_subaddress) parts[0] = parts[0].split('+')[0];
        if (options.gmail_remove_dots) // this does not replace consecutive dots like example..email@gmail.com
        parts[0] = parts[0].replace(/\.+/g, $dd4e0bd9ef8f5472$var$dotsReplacer);
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.gmail_lowercase) parts[0] = parts[0].toLowerCase();
        parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
    } else if ($dd4e0bd9ef8f5472$var$icloud_domains.indexOf(parts[1]) >= 0) {
        // Address is iCloud
        if (options.icloud_remove_subaddress) parts[0] = parts[0].split('+')[0];
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.icloud_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($dd4e0bd9ef8f5472$var$outlookdotcom_domains.indexOf(parts[1]) >= 0) {
        // Address is Outlook.com
        if (options.outlookdotcom_remove_subaddress) parts[0] = parts[0].split('+')[0];
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.outlookdotcom_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($dd4e0bd9ef8f5472$var$yahoo_domains.indexOf(parts[1]) >= 0) {
        // Address is Yahoo
        if (options.yahoo_remove_subaddress) {
            var components = parts[0].split('-');
            parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
        }
        if (!parts[0].length) return false;
        if (options.all_lowercase || options.yahoo_lowercase) parts[0] = parts[0].toLowerCase();
    } else if ($dd4e0bd9ef8f5472$var$yandex_domains.indexOf(parts[1]) >= 0) {
        if (options.all_lowercase || options.yandex_lowercase) parts[0] = parts[0].toLowerCase();
        parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preferred
    } else if (options.all_lowercase) // Any other address
    parts[0] = parts[0].toLowerCase();
    return parts.join('@');
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dtWXT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d0bb90990bd8b34$var$isSlug;

var $9d0bb90990bd8b34$var$_assertString = $9d0bb90990bd8b34$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $9d0bb90990bd8b34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9d0bb90990bd8b34$var$charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
function $9d0bb90990bd8b34$var$isSlug(str) {
    (0, $9d0bb90990bd8b34$var$_assertString.default)(str);
    return $9d0bb90990bd8b34$var$charsetRegex.test(str);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("4fo1o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $317b324b592a2f03$var$isLicensePlate;

var $317b324b592a2f03$var$_assertString = $317b324b592a2f03$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $317b324b592a2f03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $317b324b592a2f03$var$validators = {
    'cs-CZ': function csCZ(str) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(str);
    },
    'de-DE': function deDE(str) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
    },
    'de-LI': function deLI(str) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
    },
    'en-IN': function enIN(str) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(str);
    },
    'es-AR': function esAR(str) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(str);
    },
    'fi-FI': function fiFI(str) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(str);
    },
    'hu-HU': function huHU(str) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(str);
    },
    'pt-BR': function ptBR(str) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
    },
    'pt-PT': function ptPT(str) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(str);
    },
    'sq-AL': function sqAL(str) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
    },
    'sv-SE': function svSE(str) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(str.trim());
    },
    'en-PK': function enPK(str) {
        return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(str.trim());
    }
};
function $317b324b592a2f03$var$isLicensePlate(str, locale) {
    (0, $317b324b592a2f03$var$_assertString.default)(str);
    if (locale in $317b324b592a2f03$var$validators) return $317b324b592a2f03$var$validators[locale](str);
    else if (locale === 'any') {
        for(var key in $317b324b592a2f03$var$validators){
            /* eslint guard-for-in: 0 */ var validator = $317b324b592a2f03$var$validators[key];
            if (validator(str)) return true;
        }
        return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("9wP8Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6efec65f0adfb8f9$var$isStrongPassword;

var $6efec65f0adfb8f9$var$_merge = $6efec65f0adfb8f9$var$_interopRequireDefault((parcelRequire("9nDkO")));

var $6efec65f0adfb8f9$var$_assertString = $6efec65f0adfb8f9$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $6efec65f0adfb8f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6efec65f0adfb8f9$var$upperCaseRegex = /^[A-Z]$/;
var $6efec65f0adfb8f9$var$lowerCaseRegex = /^[a-z]$/;
var $6efec65f0adfb8f9$var$numberRegex = /^[0-9]$/;
var $6efec65f0adfb8f9$var$symbolRegex = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/;
var $6efec65f0adfb8f9$var$defaultOptions = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: false,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
};
/* Counts number of occurrences of each char in a string
 * could be moved to util/ ?
*/ function $6efec65f0adfb8f9$var$countChars(str) {
    var result = {};
    Array.from(str).forEach(function(char) {
        var curVal = result[char];
        if (curVal) result[char] += 1;
        else result[char] = 1;
    });
    return result;
}
/* Return information about a password */ function $6efec65f0adfb8f9$var$analyzePassword(password) {
    var charMap = $6efec65f0adfb8f9$var$countChars(password);
    var analysis = {
        length: password.length,
        uniqueChars: Object.keys(charMap).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
    };
    Object.keys(charMap).forEach(function(char) {
        /* istanbul ignore else */ if ($6efec65f0adfb8f9$var$upperCaseRegex.test(char)) analysis.uppercaseCount += charMap[char];
        else if ($6efec65f0adfb8f9$var$lowerCaseRegex.test(char)) analysis.lowercaseCount += charMap[char];
        else if ($6efec65f0adfb8f9$var$numberRegex.test(char)) analysis.numberCount += charMap[char];
        else if ($6efec65f0adfb8f9$var$symbolRegex.test(char)) analysis.symbolCount += charMap[char];
    });
    return analysis;
}
function $6efec65f0adfb8f9$var$scorePassword(analysis, scoringOptions) {
    var points = 0;
    points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
    points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;
    if (analysis.lowercaseCount > 0) points += scoringOptions.pointsForContainingLower;
    if (analysis.uppercaseCount > 0) points += scoringOptions.pointsForContainingUpper;
    if (analysis.numberCount > 0) points += scoringOptions.pointsForContainingNumber;
    if (analysis.symbolCount > 0) points += scoringOptions.pointsForContainingSymbol;
    return points;
}
function $6efec65f0adfb8f9$var$isStrongPassword(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, $6efec65f0adfb8f9$var$_assertString.default)(str);
    var analysis = $6efec65f0adfb8f9$var$analyzePassword(str);
    options = (0, $6efec65f0adfb8f9$var$_merge.default)(options || {}, $6efec65f0adfb8f9$var$defaultOptions);
    if (options.returnScore) return $6efec65f0adfb8f9$var$scorePassword(analysis, options);
    return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("394HB", function(module, exports) {
"use strict";
function $24a5dc2863b9a16a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $24a5dc2863b9a16a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $24a5dc2863b9a16a$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24a5dc2863b9a16a$var$isVAT;
module.exports.vatMatchers = void 0;

var $24a5dc2863b9a16a$var$_assertString = $24a5dc2863b9a16a$var$_interopRequireDefault((parcelRequire("hZqWG")));

var $24a5dc2863b9a16a$var$algorithms = $24a5dc2863b9a16a$var$_interopRequireWildcard((parcelRequire("3SUDT")));
function $24a5dc2863b9a16a$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($24a5dc2863b9a16a$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $24a5dc2863b9a16a$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $24a5dc2863b9a16a$var$_typeof(e) && "function" != typeof e) return {
        default: e
    };
    var t = $24a5dc2863b9a16a$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $24a5dc2863b9a16a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $24a5dc2863b9a16a$var$AU = function AU(str) {
    var match = str.match(/^(AU)?(\d{11})$/);
    if (!match) return false;
    // @see {@link https://abr.business.gov.au/Help/AbnFormat}
    var weights = [
        10,
        1,
        3,
        5,
        7,
        9,
        11,
        13,
        15,
        17,
        19
    ];
    str = str.replace(/^AU/, '');
    var ABN = (parseInt(str.slice(0, 1), 10) - 1).toString() + str.slice(1);
    var total = 0;
    for(var i = 0; i < 11; i++)total += weights[i] * ABN.charAt(i);
    return total !== 0 && total % 89 === 0;
};
var $24a5dc2863b9a16a$var$CH = function CH(str) {
    // @see {@link https://www.ech.ch/de/ech/ech-0097/5.2.0}
    var hasValidCheckNumber = function hasValidCheckNumber(digits) {
        var lastDigit = digits.pop(); // used as check number
        var weights = [
            5,
            4,
            3,
            2,
            7,
            6,
            5,
            4
        ];
        var calculatedCheckNumber = (11 - digits.reduce(function(acc, el, idx) {
            return acc + el * weights[idx];
        }, 0) % 11) % 11;
        return lastDigit === calculatedCheckNumber;
    };
    // @see {@link https://www.estv.admin.ch/estv/de/home/mehrwertsteuer/uid/mwst-uid-nummer.html}
    return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(str) && hasValidCheckNumber(str.match(/\d/g).map(function(el) {
        return +el;
    }));
};
var $24a5dc2863b9a16a$var$PT = function PT(str) {
    var match = str.match(/^(PT)?(\d{9})$/);
    if (!match) return false;
    var tin = match[2];
    var checksum = 11 - $24a5dc2863b9a16a$var$algorithms.reverseMultiplyAndSum(tin.split('').slice(0, 8).map(function(a) {
        return parseInt(a, 10);
    }), 9) % 11;
    if (checksum > 9) return parseInt(tin[8], 10) === 0;
    return checksum === parseInt(tin[8], 10);
};
var $24a5dc2863b9a16a$var$vatMatchers = module.exports.vatMatchers = {
    /**
   * European Union VAT identification numbers
   */ AT: function AT(str) {
        return /^(AT)?U\d{8}$/.test(str);
    },
    BE: function BE(str) {
        return /^(BE)?\d{10}$/.test(str);
    },
    BG: function BG(str) {
        return /^(BG)?\d{9,10}$/.test(str);
    },
    HR: function HR(str) {
        return /^(HR)?\d{11}$/.test(str);
    },
    CY: function CY(str) {
        return /^(CY)?\w{9}$/.test(str);
    },
    CZ: function CZ(str) {
        return /^(CZ)?\d{8,10}$/.test(str);
    },
    DK: function DK(str) {
        return /^(DK)?\d{8}$/.test(str);
    },
    EE: function EE(str) {
        return /^(EE)?\d{9}$/.test(str);
    },
    FI: function FI(str) {
        return /^(FI)?\d{8}$/.test(str);
    },
    FR: function FR(str) {
        return /^(FR)?\w{2}\d{9}$/.test(str);
    },
    DE: function DE(str) {
        return /^(DE)?\d{9}$/.test(str);
    },
    EL: function EL(str) {
        return /^(EL)?\d{9}$/.test(str);
    },
    HU: function HU(str) {
        return /^(HU)?\d{8}$/.test(str);
    },
    IE: function IE(str) {
        return /^(IE)?\d{7}\w{1}(W)?$/.test(str);
    },
    IT: function IT(str) {
        return /^(IT)?\d{11}$/.test(str);
    },
    LV: function LV(str) {
        return /^(LV)?\d{11}$/.test(str);
    },
    LT: function LT(str) {
        return /^(LT)?\d{9,12}$/.test(str);
    },
    LU: function LU(str) {
        return /^(LU)?\d{8}$/.test(str);
    },
    MT: function MT(str) {
        return /^(MT)?\d{8}$/.test(str);
    },
    NL: function NL(str) {
        return /^(NL)?\d{9}B\d{2}$/.test(str);
    },
    PL: function PL(str) {
        return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(str);
    },
    PT: $24a5dc2863b9a16a$var$PT,
    RO: function RO(str) {
        return /^(RO)?\d{2,10}$/.test(str);
    },
    SK: function SK(str) {
        return /^(SK)?\d{10}$/.test(str);
    },
    SI: function SI(str) {
        return /^(SI)?\d{8}$/.test(str);
    },
    ES: function ES(str) {
        return /^(ES)?\w\d{7}[A-Z]$/.test(str);
    },
    SE: function SE(str) {
        return /^(SE)?\d{12}$/.test(str);
    },
    /**
   * VAT numbers of non-EU countries
   */ AL: function AL(str) {
        return /^(AL)?\w{9}[A-Z]$/.test(str);
    },
    MK: function MK(str) {
        return /^(MK)?\d{13}$/.test(str);
    },
    AU: $24a5dc2863b9a16a$var$AU,
    BY: function BY(str) {
        return /^(УНП )?\d{9}$/.test(str);
    },
    CA: function CA(str) {
        return /^(CA)?\d{9}$/.test(str);
    },
    IS: function IS(str) {
        return /^(IS)?\d{5,6}$/.test(str);
    },
    IN: function IN(str) {
        return /^(IN)?\d{15}$/.test(str);
    },
    ID: function ID(str) {
        return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(str);
    },
    IL: function IL(str) {
        return /^(IL)?\d{9}$/.test(str);
    },
    KZ: function KZ(str) {
        return /^(KZ)?\d{12}$/.test(str);
    },
    NZ: function NZ(str) {
        return /^(NZ)?\d{9}$/.test(str);
    },
    NG: function NG(str) {
        return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(str);
    },
    NO: function NO(str) {
        return /^(NO)?\d{9}MVA$/.test(str);
    },
    PH: function PH(str) {
        return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(str);
    },
    RU: function RU(str) {
        return /^(RU)?(\d{10}|\d{12})$/.test(str);
    },
    SM: function SM(str) {
        return /^(SM)?\d{5}$/.test(str);
    },
    SA: function SA(str) {
        return /^(SA)?\d{15}$/.test(str);
    },
    RS: function RS(str) {
        return /^(RS)?\d{9}$/.test(str);
    },
    CH: $24a5dc2863b9a16a$var$CH,
    TR: function TR(str) {
        return /^(TR)?\d{10}$/.test(str);
    },
    UA: function UA(str) {
        return /^(UA)?\d{12}$/.test(str);
    },
    GB: function GB(str) {
        return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(str);
    },
    UZ: function UZ(str) {
        return /^(UZ)?\d{9}$/.test(str);
    },
    /**
   * VAT numbers of Latin American countries
   */ AR: function AR(str) {
        return /^(AR)?\d{11}$/.test(str);
    },
    BO: function BO(str) {
        return /^(BO)?\d{7}$/.test(str);
    },
    BR: function BR(str) {
        return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(str);
    },
    CL: function CL(str) {
        return /^(CL)?\d{8}-\d{1}$/.test(str);
    },
    CO: function CO(str) {
        return /^(CO)?\d{10}$/.test(str);
    },
    CR: function CR(str) {
        return /^(CR)?\d{9,12}$/.test(str);
    },
    EC: function EC(str) {
        return /^(EC)?\d{13}$/.test(str);
    },
    SV: function SV(str) {
        return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(str);
    },
    GT: function GT(str) {
        return /^(GT)?\d{7}-\d{1}$/.test(str);
    },
    HN: function HN(str) {
        return /^(HN)?$/.test(str);
    },
    MX: function MX(str) {
        return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(str);
    },
    NI: function NI(str) {
        return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(str);
    },
    PA: function PA(str) {
        return /^(PA)?$/.test(str);
    },
    PY: function PY(str) {
        return /^(PY)?\d{6,8}-\d{1}$/.test(str);
    },
    PE: function PE(str) {
        return /^(PE)?\d{11}$/.test(str);
    },
    DO: function DO(str) {
        return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(str);
    },
    UY: function UY(str) {
        return /^(UY)?\d{12}$/.test(str);
    },
    VE: function VE(str) {
        return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(str);
    }
};
function $24a5dc2863b9a16a$var$isVAT(str, countryCode) {
    (0, $24a5dc2863b9a16a$var$_assertString.default)(str);
    (0, $24a5dc2863b9a16a$var$_assertString.default)(countryCode);
    if (countryCode in $24a5dc2863b9a16a$var$vatMatchers) return $24a5dc2863b9a16a$var$vatMatchers[countryCode](str);
    throw new Error("Invalid country code: '".concat(countryCode, "'"));
}

});

parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5C8IU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $416744a0a1673bb3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $416744a0a1673bb3$export$e00380445f2b9e0c);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("jjlaj")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("jjlaj")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("ePWXO")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("aVZKi")).default);
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $5rflj = parcelRequire("5rflj");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $ePWXO = parcelRequire("ePWXO");

var $aVZKi = parcelRequire("aVZKi");
'use client';
function $416744a0a1673bb3$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $416744a0a1673bb3$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("5rflj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $e0f035ab0866fe47$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});



parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});



parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("ePWXO", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd3910f2f17ba0e$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
let $acd3910f2f17ba0e$var$cache;
if (typeof document === 'object') $acd3910f2f17ba0e$var$cache = (0, $a9M6v.default)({
    key: 'css',
    prepend: true
});
function $acd3910f2f17ba0e$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $acd3910f2f17ba0e$var$cache ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eP9YU.C), {
        value: $acd3910f2f17ba0e$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});


parcelRegister("aVZKi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f5f1fa669ccc202$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $7f5f1fa669ccc202$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $7f5f1fa669ccc202$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($7f5f1fa669ccc202$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jjlaj.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("2A1GY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("gxvzd")).default);

var $gxvzd = parcelRequire("gxvzd");

});
parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("eQufN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eWm0o")).default);

var $eWm0o = parcelRequire("eWm0o");
$parcel$exportWildcard(module.exports, $eWm0o);

});
parcelRegister("eWm0o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $ae078d4716220a63$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ae078d4716220a63$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ae078d4716220a63$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ae078d4716220a63$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $ae078d4716220a63$export$aad197c7121a6651(Component) || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jPKB.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});
parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || type === $68c5159438cce3ec$var$REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});




parcelRegister("c3nGe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8NnpI")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("2F4pg")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("2PWu5")).default);

var $8NnpI = parcelRequire("8NnpI");

var $2F4pg = parcelRequire("2F4pg");

var $2PWu5 = parcelRequire("2PWu5");

});
parcelRegister("8NnpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $66750fd06db62b1c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $2F4pg = parcelRequire("2F4pg");

var $jrZOE = parcelRequire("jrZOE");

var $2YDV9 = parcelRequire("2YDV9");

var $g91qR = parcelRequire("g91qR");

var $5iHq4 = parcelRequire("5iHq4");

var $2PWu5 = parcelRequire("2PWu5");
const $66750fd06db62b1c$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $66750fd06db62b1c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $1En50.default)(options, $66750fd06db62b1c$var$_excluded);
    const breakpoints = (0, $2F4pg.default)(breakpointsInput);
    const spacing = (0, $2YDV9.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $8nd05.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $8nd05.default)({}, (0, $jrZOE.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2PWu5.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $5iHq4.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $66750fd06db62b1c$export$2e2bcd8739ae039 = $66750fd06db62b1c$var$createTheme;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("2F4pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f02d41e88337c5c$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $1f02d41e88337c5c$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $1f02d41e88337c5c$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $1f02d41e88337c5c$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $8nd05.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $1f02d41e88337c5c$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $1En50.default)(breakpoints, $1f02d41e88337c5c$var$_excluded);
    const sortedValues = $1f02d41e88337c5c$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $8nd05.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("jrZOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2907d4f90ca619b$export$2e2bcd8739ae039);
const $e2907d4f90ca619b$var$shape = {
    borderRadius: 4
};
var $e2907d4f90ca619b$export$2e2bcd8739ae039 = $e2907d4f90ca619b$var$shape;

});

parcelRegister("2YDV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b026ca2499c378$export$2e2bcd8739ae039);

var $fbH80 = parcelRequire("fbH80");
function $22b026ca2499c378$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fbH80.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("fbH80", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $b0e9566e383397d0$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $b0e9566e383397d0$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $b0e9566e383397d0$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $b0e9566e383397d0$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $b0e9566e383397d0$export$6f98e8eaf0be1996);


var $lWAfe = parcelRequire("lWAfe");

var $9liTZ = parcelRequire("9liTZ");

var $aliUM = parcelRequire("aliUM");

var $6MB9o = parcelRequire("6MB9o");
const $b0e9566e383397d0$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $b0e9566e383397d0$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $b0e9566e383397d0$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b0e9566e383397d0$var$getCssProperties = (0, $6MB9o.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b0e9566e383397d0$var$aliases[prop]) prop = $b0e9566e383397d0$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $b0e9566e383397d0$var$properties[a];
    const direction = $b0e9566e383397d0$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b0e9566e383397d0$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $b0e9566e383397d0$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $b0e9566e383397d0$var$spacingKeys = [
    ...$b0e9566e383397d0$export$aab52a0dde05ad8a,
    ...$b0e9566e383397d0$export$f8397d44f03ab6ad
];
function $b0e9566e383397d0$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $9liTZ.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $b0e9566e383397d0$export$1def6f833384e3d1(theme) {
    return $b0e9566e383397d0$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $b0e9566e383397d0$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $b0e9566e383397d0$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b0e9566e383397d0$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b0e9566e383397d0$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b0e9566e383397d0$var$getCssProperties(prop);
    const styleFromPropValue = $b0e9566e383397d0$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $lWAfe.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b0e9566e383397d0$var$style(props, keys) {
    const transformer = $b0e9566e383397d0$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b0e9566e383397d0$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $aliUM.default), {});
}
function $b0e9566e383397d0$export$7ede87f9b603dd3c(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$export$aab52a0dde05ad8a);
}
$b0e9566e383397d0$export$7ede87f9b603dd3c.propTypes = {};
$b0e9566e383397d0$export$7ede87f9b603dd3c.filterProps = $b0e9566e383397d0$export$aab52a0dde05ad8a;
function $b0e9566e383397d0$export$6f98e8eaf0be1996(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$export$f8397d44f03ab6ad);
}
$b0e9566e383397d0$export$6f98e8eaf0be1996.propTypes = {};
$b0e9566e383397d0$export$6f98e8eaf0be1996.filterProps = $b0e9566e383397d0$export$f8397d44f03ab6ad;
function $b0e9566e383397d0$var$spacing(props) {
    return $b0e9566e383397d0$var$style(props, $b0e9566e383397d0$var$spacingKeys);
}
$b0e9566e383397d0$var$spacing.propTypes = {};
$b0e9566e383397d0$var$spacing.filterProps = $b0e9566e383397d0$var$spacingKeys;
var $b0e9566e383397d0$export$2e2bcd8739ae039 = $b0e9566e383397d0$var$spacing;

});
parcelRegister("lWAfe", function(module, exports) {

$parcel$export(module.exports, "values", () => $ff9b2135c2bff8b7$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $ff9b2135c2bff8b7$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $ff9b2135c2bff8b7$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $ff9b2135c2bff8b7$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $ff9b2135c2bff8b7$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $ff9b2135c2bff8b7$export$980e6a259d807490);

var $8nd05 = parcelRequire("8nd05");


var $3z1Ay = parcelRequire("3z1Ay");

var $aliUM = parcelRequire("aliUM");
const $ff9b2135c2bff8b7$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $ff9b2135c2bff8b7$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$ff9b2135c2bff8b7$export$68c286be0e7e55b7[key]}px)`
};
function $ff9b2135c2bff8b7$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $ff9b2135c2bff8b7$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $ff9b2135c2bff8b7$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $ff9b2135c2bff8b7$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $aliUM.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $ff9b2135c2bff8b7$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ff9b2135c2bff8b7$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ff9b2135c2bff8b7$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $ff9b2135c2bff8b7$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $ff9b2135c2bff8b7$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $ff9b2135c2bff8b7$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ff9b2135c2bff8b7$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $ff9b2135c2bff8b7$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $ff9b2135c2bff8b7$export$2e2bcd8739ae039 = $ff9b2135c2bff8b7$var$breakpoints;

});
parcelRegister("aliUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $787a899efa293fda$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $787a899efa293fda$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $787a899efa293fda$export$2e2bcd8739ae039 = $787a899efa293fda$var$merge;

});


parcelRegister("9liTZ", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $6cd4bcc854268e2d$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $6cd4bcc854268e2d$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $6cd4bcc854268e2d$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $lWAfe = parcelRequire("lWAfe");
function $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $6cd4bcc854268e2d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $6cd4bcc854268e2d$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $6cd4bcc854268e2d$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $6cd4bcc854268e2d$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $6cd4bcc854268e2d$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $6cd4bcc854268e2d$export$2e2bcd8739ae039 = $6cd4bcc854268e2d$var$style;

});

parcelRegister("6MB9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f040b160197e08d$export$2e2bcd8739ae039);
function $4f040b160197e08d$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("g91qR", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $bc0e990868bc4709$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $bc0e990868bc4709$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $aliUM = parcelRequire("aliUM");

var $9liTZ = parcelRequire("9liTZ");

var $lWAfe = parcelRequire("lWAfe");

var $5iHq4 = parcelRequire("5iHq4");
function $bc0e990868bc4709$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $bc0e990868bc4709$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $bc0e990868bc4709$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $9liTZ.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $9liTZ.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $9liTZ.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $5iHq4.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $lWAfe.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $bc0e990868bc4709$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $aliUM.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $lWAfe.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($bc0e990868bc4709$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $aliUM.default)(css, breakpointsValues);
                        }
                    } else css = (0, $aliUM.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $lWAfe.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $bc0e990868bc4709$var$styleFunctionSx = $bc0e990868bc4709$export$7d53d8bf2911e013();
$bc0e990868bc4709$var$styleFunctionSx.filterProps = [
    'sx'
];
var $bc0e990868bc4709$export$2e2bcd8739ae039 = $bc0e990868bc4709$var$styleFunctionSx;

});
parcelRegister("5iHq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc050675c3a4812$export$2e2bcd8739ae039);

var $fbH80 = parcelRequire("fbH80");

var $876wo = parcelRequire("876wo");

var $7PeCv = parcelRequire("7PeCv");

var $35ILh = parcelRequire("35ILh");

var $cvP8g = parcelRequire("cvP8g");
const $3dc050675c3a4812$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $876wo.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $876wo.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $35ILh.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $35ILh.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $35ILh.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $fbH80.padding)
    },
    pt: {
        style: (0, $fbH80.padding)
    },
    pr: {
        style: (0, $fbH80.padding)
    },
    pb: {
        style: (0, $fbH80.padding)
    },
    pl: {
        style: (0, $fbH80.padding)
    },
    px: {
        style: (0, $fbH80.padding)
    },
    py: {
        style: (0, $fbH80.padding)
    },
    padding: {
        style: (0, $fbH80.padding)
    },
    paddingTop: {
        style: (0, $fbH80.padding)
    },
    paddingRight: {
        style: (0, $fbH80.padding)
    },
    paddingBottom: {
        style: (0, $fbH80.padding)
    },
    paddingLeft: {
        style: (0, $fbH80.padding)
    },
    paddingX: {
        style: (0, $fbH80.padding)
    },
    paddingY: {
        style: (0, $fbH80.padding)
    },
    paddingInline: {
        style: (0, $fbH80.padding)
    },
    paddingInlineStart: {
        style: (0, $fbH80.padding)
    },
    paddingInlineEnd: {
        style: (0, $fbH80.padding)
    },
    paddingBlock: {
        style: (0, $fbH80.padding)
    },
    paddingBlockStart: {
        style: (0, $fbH80.padding)
    },
    paddingBlockEnd: {
        style: (0, $fbH80.padding)
    },
    m: {
        style: (0, $fbH80.margin)
    },
    mt: {
        style: (0, $fbH80.margin)
    },
    mr: {
        style: (0, $fbH80.margin)
    },
    mb: {
        style: (0, $fbH80.margin)
    },
    ml: {
        style: (0, $fbH80.margin)
    },
    mx: {
        style: (0, $fbH80.margin)
    },
    my: {
        style: (0, $fbH80.margin)
    },
    margin: {
        style: (0, $fbH80.margin)
    },
    marginTop: {
        style: (0, $fbH80.margin)
    },
    marginRight: {
        style: (0, $fbH80.margin)
    },
    marginBottom: {
        style: (0, $fbH80.margin)
    },
    marginLeft: {
        style: (0, $fbH80.margin)
    },
    marginX: {
        style: (0, $fbH80.margin)
    },
    marginY: {
        style: (0, $fbH80.margin)
    },
    marginInline: {
        style: (0, $fbH80.margin)
    },
    marginInlineStart: {
        style: (0, $fbH80.margin)
    },
    marginInlineEnd: {
        style: (0, $fbH80.margin)
    },
    marginBlock: {
        style: (0, $fbH80.margin)
    },
    marginBlockStart: {
        style: (0, $fbH80.margin)
    },
    marginBlockEnd: {
        style: (0, $fbH80.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $7PeCv.gap)
    },
    rowGap: {
        style: (0, $7PeCv.rowGap)
    },
    columnGap: {
        style: (0, $7PeCv.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $cvP8g.sizingTransform)
    },
    maxWidth: {
        style: (0, $cvP8g.maxWidth)
    },
    minWidth: {
        transform: (0, $cvP8g.sizingTransform)
    },
    height: {
        transform: (0, $cvP8g.sizingTransform)
    },
    maxHeight: {
        transform: (0, $cvP8g.sizingTransform)
    },
    minHeight: {
        transform: (0, $cvP8g.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $3dc050675c3a4812$export$2e2bcd8739ae039 = $3dc050675c3a4812$var$defaultSxConfig;

});
parcelRegister("876wo", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $5e840933f788805e$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $5e840933f788805e$export$7a57f79000377ca2);


var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $fbH80 = parcelRequire("fbH80");

var $lWAfe = parcelRequire("lWAfe");
function $5e840933f788805e$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $5e840933f788805e$var$createBorderStyle(prop, transform) {
    return (0, $9liTZ.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $5e840933f788805e$export$1edee58a52776cd9 = $5e840933f788805e$var$createBorderStyle('border', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$f9a7b6bd24892946 = $5e840933f788805e$var$createBorderStyle('borderTop', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$5abca33e6be905d2 = $5e840933f788805e$var$createBorderStyle('borderRight', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$e2ce9f12a980a822 = $5e840933f788805e$var$createBorderStyle('borderBottom', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$47658cca1a909427 = $5e840933f788805e$var$createBorderStyle('borderLeft', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$e7fb0694ba2404fc = $5e840933f788805e$var$createBorderStyle('borderColor');
const $5e840933f788805e$export$126a92c968acdb85 = $5e840933f788805e$var$createBorderStyle('borderTopColor');
const $5e840933f788805e$export$85cc51cb8fbb8c0e = $5e840933f788805e$var$createBorderStyle('borderRightColor');
const $5e840933f788805e$export$340b0327727f6d1a = $5e840933f788805e$var$createBorderStyle('borderBottomColor');
const $5e840933f788805e$export$60beef91a985b4bf = $5e840933f788805e$var$createBorderStyle('borderLeftColor');
const $5e840933f788805e$export$f9258c55612cbed7 = $5e840933f788805e$var$createBorderStyle('outline', $5e840933f788805e$export$34e2febe53ae29cc);
const $5e840933f788805e$export$621fe586efeb64b9 = $5e840933f788805e$var$createBorderStyle('outlineColor');
const $5e840933f788805e$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$5e840933f788805e$export$7a57f79000377ca2.propTypes = {};
$5e840933f788805e$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $5e840933f788805e$var$borders = (0, $hLL0Z.default)($5e840933f788805e$export$1edee58a52776cd9, $5e840933f788805e$export$f9a7b6bd24892946, $5e840933f788805e$export$5abca33e6be905d2, $5e840933f788805e$export$e2ce9f12a980a822, $5e840933f788805e$export$47658cca1a909427, $5e840933f788805e$export$e7fb0694ba2404fc, $5e840933f788805e$export$126a92c968acdb85, $5e840933f788805e$export$85cc51cb8fbb8c0e, $5e840933f788805e$export$340b0327727f6d1a, $5e840933f788805e$export$60beef91a985b4bf, $5e840933f788805e$export$7a57f79000377ca2, $5e840933f788805e$export$f9258c55612cbed7, $5e840933f788805e$export$621fe586efeb64b9);
var $5e840933f788805e$export$2e2bcd8739ae039 = $5e840933f788805e$var$borders;

});
parcelRegister("hLL0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $cefb4bab9b5f3b71$export$2e2bcd8739ae039);

var $aliUM = parcelRequire("aliUM");
function $cefb4bab9b5f3b71$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $aliUM.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $cefb4bab9b5f3b71$export$2e2bcd8739ae039 = $cefb4bab9b5f3b71$var$compose;

});


parcelRegister("7PeCv", function(module, exports) {

$parcel$export(module.exports, "gap", () => $5b28a3156950b99a$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $5b28a3156950b99a$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $5b28a3156950b99a$export$8a833ffa5f5dbeda);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $fbH80 = parcelRequire("fbH80");

var $lWAfe = parcelRequire("lWAfe");

const $5b28a3156950b99a$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$5b28a3156950b99a$export$5df9adcb0db95e1e.propTypes = {};
$5b28a3156950b99a$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $5b28a3156950b99a$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$5b28a3156950b99a$export$ec60d70ff941a580.propTypes = {};
$5b28a3156950b99a$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $5b28a3156950b99a$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fbH80.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fbH80.getValue)(transformer, propValue)
            });
        return (0, $lWAfe.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$5b28a3156950b99a$export$8a833ffa5f5dbeda.propTypes = {};
$5b28a3156950b99a$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $5b28a3156950b99a$export$baf44164ca3a34e8 = (0, $9liTZ.default)({
    prop: 'gridColumn'
});
const $5b28a3156950b99a$export$8f7213a1cd01e832 = (0, $9liTZ.default)({
    prop: 'gridRow'
});
const $5b28a3156950b99a$export$b0e0abbc49ba668 = (0, $9liTZ.default)({
    prop: 'gridAutoFlow'
});
const $5b28a3156950b99a$export$bcd8b929d4b4142 = (0, $9liTZ.default)({
    prop: 'gridAutoColumns'
});
const $5b28a3156950b99a$export$e5039a674e14c828 = (0, $9liTZ.default)({
    prop: 'gridAutoRows'
});
const $5b28a3156950b99a$export$42bd9088661ffb03 = (0, $9liTZ.default)({
    prop: 'gridTemplateColumns'
});
const $5b28a3156950b99a$export$920682ae05b999bc = (0, $9liTZ.default)({
    prop: 'gridTemplateRows'
});
const $5b28a3156950b99a$export$1b88fbdd482fd33a = (0, $9liTZ.default)({
    prop: 'gridTemplateAreas'
});
const $5b28a3156950b99a$export$bdb486e40d52d26f = (0, $9liTZ.default)({
    prop: 'gridArea'
});
const $5b28a3156950b99a$var$grid = (0, $hLL0Z.default)($5b28a3156950b99a$export$5df9adcb0db95e1e, $5b28a3156950b99a$export$ec60d70ff941a580, $5b28a3156950b99a$export$8a833ffa5f5dbeda, $5b28a3156950b99a$export$baf44164ca3a34e8, $5b28a3156950b99a$export$8f7213a1cd01e832, $5b28a3156950b99a$export$b0e0abbc49ba668, $5b28a3156950b99a$export$bcd8b929d4b4142, $5b28a3156950b99a$export$e5039a674e14c828, $5b28a3156950b99a$export$42bd9088661ffb03, $5b28a3156950b99a$export$920682ae05b999bc, $5b28a3156950b99a$export$1b88fbdd482fd33a, $5b28a3156950b99a$export$bdb486e40d52d26f);
var $5b28a3156950b99a$export$2e2bcd8739ae039 = $5b28a3156950b99a$var$grid;

});

parcelRegister("35ILh", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $24048f76f475764b$export$dbaffd4420ea0ac6);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");
function $24048f76f475764b$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $24048f76f475764b$export$35e9368ef982300f = (0, $9liTZ.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $24048f76f475764b$export$dbaffd4420ea0ac6
});
const $24048f76f475764b$export$2506f56c10355b33 = (0, $9liTZ.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $24048f76f475764b$export$dbaffd4420ea0ac6
});
const $24048f76f475764b$export$8c5a050822fd698c = (0, $9liTZ.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $24048f76f475764b$export$dbaffd4420ea0ac6
});
const $24048f76f475764b$var$palette = (0, $hLL0Z.default)($24048f76f475764b$export$35e9368ef982300f, $24048f76f475764b$export$2506f56c10355b33, $24048f76f475764b$export$8c5a050822fd698c);
var $24048f76f475764b$export$2e2bcd8739ae039 = $24048f76f475764b$var$palette;

});

parcelRegister("cvP8g", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $91c00b16c070497b$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $91c00b16c070497b$export$488fda99655ff65a);

var $9liTZ = parcelRequire("9liTZ");

var $hLL0Z = parcelRequire("hLL0Z");

var $lWAfe = parcelRequire("lWAfe");
function $91c00b16c070497b$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $91c00b16c070497b$export$7e3df82ee760448c = (0, $9liTZ.default)({
    prop: 'width',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $lWAfe.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $91c00b16c070497b$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $lWAfe.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$91c00b16c070497b$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $91c00b16c070497b$export$ee148fbbe8357dd2 = (0, $9liTZ.default)({
    prop: 'minWidth',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$ac607276a8fe9f0a = (0, $9liTZ.default)({
    prop: 'height',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$dc0d8bd0b94f8570 = (0, $9liTZ.default)({
    prop: 'maxHeight',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$a43cf604e12f3b17 = (0, $9liTZ.default)({
    prop: 'minHeight',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$ffed9f14fb65e276 = (0, $9liTZ.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$905076ed6620e671 = (0, $9liTZ.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $91c00b16c070497b$export$8afece71750ec241
});
const $91c00b16c070497b$export$6ccc93f785106a58 = (0, $9liTZ.default)({
    prop: 'boxSizing'
});
const $91c00b16c070497b$var$sizing = (0, $hLL0Z.default)($91c00b16c070497b$export$7e3df82ee760448c, $91c00b16c070497b$export$488fda99655ff65a, $91c00b16c070497b$export$ee148fbbe8357dd2, $91c00b16c070497b$export$ac607276a8fe9f0a, $91c00b16c070497b$export$dc0d8bd0b94f8570, $91c00b16c070497b$export$a43cf604e12f3b17, $91c00b16c070497b$export$6ccc93f785106a58);
var $91c00b16c070497b$export$2e2bcd8739ae039 = $91c00b16c070497b$var$sizing;

});



parcelRegister("2PWu5", function(module, exports) {

$parcel$export(module.exports, "default", () => $210db5f09ad53fd7$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $210db5f09ad53fd7$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("jib0t", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("g91qR")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("g91qR")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("6hiu6")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("5iHq4")).default);

var $g91qR = parcelRequire("g91qR");

var $6hiu6 = parcelRequire("6hiu6");

var $5iHq4 = parcelRequire("5iHq4");

});
parcelRegister("6hiu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4922ab3f1f5ee220$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");

var $5iHq4 = parcelRequire("5iHq4");
const $4922ab3f1f5ee220$var$_excluded = [
    "sx"
];
const $4922ab3f1f5ee220$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $5iHq4.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $4922ab3f1f5ee220$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $1En50.default)(props, $4922ab3f1f5ee220$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $4922ab3f1f5ee220$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return (0, $8nd05.default)({}, systemProps, result);
    };
    else finalSx = (0, $8nd05.default)({}, systemProps, inSx);
    return (0, $8nd05.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("dsPLe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cpmCj")).default);

var $cpmCj = parcelRequire("cpmCj");

});

parcelRegister("lYE9x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("1jJMI")).default);

var $1jJMI = parcelRequire("1jJMI");

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), (0, $8nd05.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2a8a963e5702921b$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $1En50.default)(props, $2a8a963e5702921b$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $3vMLS = parcelRequire("3vMLS");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3vMLS.default), (0, $8nd05.default)({}, props));
}
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $3vMLS.useDefaultProps)(params);
}

});
parcelRegister("3vMLS", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $28ea194fe257804a$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $28ea194fe257804a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $28ea194fe257804a$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $28ea194fe257804a$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($28ea194fe257804a$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $28ea194fe257804a$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $28ea194fe257804a$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($28ea194fe257804a$var$PropsContext);
    return $28ea194fe257804a$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $28ea194fe257804a$export$2e2bcd8739ae039 = $28ea194fe257804a$var$DefaultPropsProvider;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $8nd05.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $8nd05.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $8nd05.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("8Uq77")).default);

var $dO5ga = parcelRequire("dO5ga");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

var $PJRTc = parcelRequire("PJRTc");
'use client';
const $0277c5e26ff0d56c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($dO5ga)))({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("dO5ga", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0d40654cceea0e2$var$createStyled;
module.exports.shouldForwardProp = $a0d40654cceea0e2$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $a0d40654cceea0e2$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2 = $1jnue((parcelRequire("c05no")));

var $a0d40654cceea0e2$var$_styledEngine = $a0d40654cceea0e2$var$_interopRequireWildcard((parcelRequire("5C8IU")));

var $3z1Ay = parcelRequire("3z1Ay");

var $a0d40654cceea0e2$var$_capitalize = $1jnue((parcelRequire("2A1GY")));

var $a0d40654cceea0e2$var$_getDisplayName = $1jnue((parcelRequire("eQufN")));

var $a0d40654cceea0e2$var$_createTheme = $1jnue((parcelRequire("c3nGe")));

var $a0d40654cceea0e2$var$_styleFunctionSx = $1jnue((parcelRequire("jib0t")));
const $a0d40654cceea0e2$var$_excluded = [
    "ownerState"
], $a0d40654cceea0e2$var$_excluded2 = [
    "variants"
], $a0d40654cceea0e2$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $a0d40654cceea0e2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a0d40654cceea0e2$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a0d40654cceea0e2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a0d40654cceea0e2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $a0d40654cceea0e2$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a0d40654cceea0e2$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $a0d40654cceea0e2$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $a0d40654cceea0e2$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $a0d40654cceea0e2$var$_createTheme.default)();
const $a0d40654cceea0e2$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a0d40654cceea0e2$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a0d40654cceea0e2$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a0d40654cceea0e2$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a0d40654cceea0e2$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2.default)(_ref, $a0d40654cceea0e2$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $a0d40654cceea0e2$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a0d40654cceea0e2$var$processStyleArg(resolvedStyle, (0, $a0d40654cceea0e2$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $a0d40654cceea0e2$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $a0d40654cceea0e2$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $a0d40654cceea0e2$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $a0d40654cceea0e2$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a0d40654cceea0e2$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $a0d40654cceea0e2$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $a0d40654cceea0e2$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $a0d40654cceea0e2$var$_styleFunctionSx.default)((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
            theme: $a0d40654cceea0e2$var$resolveTheme((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $a0d40654cceea0e2$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a0d40654cceea0e2$var$defaultOverridesResolver($a0d40654cceea0e2$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $a0d40654cceea0e2$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $a0d40654cceea0e2$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a0d40654cceea0e2$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a0d40654cceea0e2$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $a0d40654cceea0e2$var$_styledEngine.default)(tag, (0, $a0d40654cceea0e2$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$a0d40654cceea0e2$var$processStyleArg(stylesArg, (0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    theme: $a0d40654cceea0e2$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a0d40654cceea0e2$var$resolveTheme((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a0d40654cceea0e2$var$processStyleArg(slotStyle, (0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a0d40654cceea0e2$var$resolveTheme((0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a0d40654cceea0e2$var$processStyleArg({
                    variants: themeVariants
                }, (0, $a0d40654cceea0e2$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
'use client';
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $g91qR = parcelRequire("g91qR");
var $5iHq4 = parcelRequire("5iHq4");

var $8NnpI = parcelRequire("8NnpI");


var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");
const $d5615f18e5cd04fc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $d5615f18e5cd04fc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $1En50.default)(options, $d5615f18e5cd04fc$var$_excluded);
    if (options.vars) throw new Error((0, $cpmCj.default)(18));
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $8NnpI.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: (0, $8nd05.default)({}, (0, $lhXgK.default))
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $8nd05.default)({}, (0, $5iHq4.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $g91qR.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $d5615f18e5cd04fc$var$warnedOnce = false;
function $d5615f18e5cd04fc$export$c469355549431d9b(...args) {
    return $d5615f18e5cd04fc$var$createTheme(...args);
}
var $d5615f18e5cd04fc$export$2e2bcd8739ae039 = $d5615f18e5cd04fc$var$createTheme;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $8nd05.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $kTdcz = parcelRequire("kTdcz");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
const $368aaef25f6a2997$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $368aaef25f6a2997$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $dzxhF.default).white,
        default: (0, $dzxhF.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $368aaef25f6a2997$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $dzxhF.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $dzxhF.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $kTdcz.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $kTdcz.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $1En50.default)(palette, $368aaef25f6a2997$var$_excluded);
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $kTdcz.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $368aaef25f6a2997$export$55ce6f3a06c59543,
        light: $368aaef25f6a2997$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3z1Ay.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $8nd05.default)({}, (0, $dzxhF.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("kTdcz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $f3532f4fa6553080$var$alpha;
module.exports.blend = $f3532f4fa6553080$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $f3532f4fa6553080$var$darken;
module.exports.decomposeColor = $f3532f4fa6553080$var$decomposeColor;
module.exports.emphasize = $f3532f4fa6553080$var$emphasize;
module.exports.getContrastRatio = $f3532f4fa6553080$var$getContrastRatio;
module.exports.getLuminance = $f3532f4fa6553080$var$getLuminance;
module.exports.hexToRgb = $f3532f4fa6553080$var$hexToRgb;
module.exports.hslToRgb = $f3532f4fa6553080$var$hslToRgb;
module.exports.lighten = $f3532f4fa6553080$var$lighten;
module.exports.private_safeAlpha = $f3532f4fa6553080$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $f3532f4fa6553080$var$private_safeDarken;
module.exports.private_safeEmphasize = $f3532f4fa6553080$var$private_safeEmphasize;
module.exports.private_safeLighten = $f3532f4fa6553080$var$private_safeLighten;
module.exports.recomposeColor = $f3532f4fa6553080$var$recomposeColor;
module.exports.rgbToHex = $f3532f4fa6553080$var$rgbToHex;

var $f3532f4fa6553080$var$_formatMuiErrorMessage2 = $1jnue((parcelRequire("dsPLe")));

var $f3532f4fa6553080$var$_clamp = $1jnue((parcelRequire("lYE9x")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $f3532f4fa6553080$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $f3532f4fa6553080$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $f3532f4fa6553080$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $f3532f4fa6553080$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $f3532f4fa6553080$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $f3532f4fa6553080$var$decomposeColor($f3532f4fa6553080$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $f3532f4fa6553080$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $f3532f4fa6553080$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $f3532f4fa6553080$var$colorChannel = (color)=>{
    const decomposedColor = $f3532f4fa6553080$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $f3532f4fa6553080$var$colorChannel;
const $f3532f4fa6553080$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $f3532f4fa6553080$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $f3532f4fa6553080$var$private_safeColorChannel;
function $f3532f4fa6553080$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $f3532f4fa6553080$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $f3532f4fa6553080$var$decomposeColor(color);
    return `#${values.map((n, i)=>$f3532f4fa6553080$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $f3532f4fa6553080$var$hslToRgb(color) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $f3532f4fa6553080$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $f3532f4fa6553080$var$getLuminance(color) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $f3532f4fa6553080$var$decomposeColor($f3532f4fa6553080$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $f3532f4fa6553080$var$getContrastRatio(foreground, background) {
    const lumA = $f3532f4fa6553080$var$getLuminance(foreground);
    const lumB = $f3532f4fa6553080$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$alpha(color, value) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    value = $f3532f4fa6553080$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $f3532f4fa6553080$var$recomposeColor(color);
}
function $f3532f4fa6553080$var$private_safeAlpha(color, value, warning) {
    try {
        return $f3532f4fa6553080$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$darken(color, coefficient) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    coefficient = $f3532f4fa6553080$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $f3532f4fa6553080$var$recomposeColor(color);
}
function $f3532f4fa6553080$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $f3532f4fa6553080$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$lighten(color, coefficient) {
    color = $f3532f4fa6553080$var$decomposeColor(color);
    coefficient = $f3532f4fa6553080$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $f3532f4fa6553080$var$recomposeColor(color);
}
function $f3532f4fa6553080$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $f3532f4fa6553080$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $f3532f4fa6553080$var$emphasize(color, coefficient = 0.15) {
    return $f3532f4fa6553080$var$getLuminance(color) > 0.5 ? $f3532f4fa6553080$var$darken(color, coefficient) : $f3532f4fa6553080$var$lighten(color, coefficient);
}
function $f3532f4fa6553080$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $f3532f4fa6553080$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $f3532f4fa6553080$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $f3532f4fa6553080$var$decomposeColor(background);
    const overlayColor = $f3532f4fa6553080$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $f3532f4fa6553080$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $3z1Ay = parcelRequire("3z1Ay");
const $98a01bf22de9dc59$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $1En50.default)(_ref, $98a01bf22de9dc59$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
            letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "duration", () => $845514f3678d3888$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
const $845514f3678d3888$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $8nd05.default)({}, $845514f3678d3888$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $8nd05.default)({}, $845514f3678d3888$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $1En50.default)(options, $845514f3678d3888$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return (0, $8nd05.default)({
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});



parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});







parcelRegister("e4R3c", function(module, exports) {
module.exports = new URL("emailHeadIcon.6baa8a7b.png", import.meta.url).toString();

});

parcelRegister("2rpU4", function(module, exports) {
module.exports = new URL("googleValidatior.ac3f23e4.svg", import.meta.url).toString();

});

parcelRegister("hRmh8", function(module, exports) {
module.exports = new URL("sms_auth.735538eb.svg", import.meta.url).toString();

});

parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3CMpU", function(module, exports) {
module.exports = new URL("send.a9fba190.svg", import.meta.url).toString();

});

parcelRegister("4aBsx", function(module, exports) {
module.exports = new URL("copy.844f5b64.svg", import.meta.url).toString();

});

parcelRegister("kL3qx", function(module, exports) {
module.exports = new URL("add-company-step1.3e05ab18.png", import.meta.url).toString();

});

parcelRegister("gqxg0", function(module, exports) {
module.exports = new URL("add-company-step1.a721c902.png", import.meta.url).toString();

});

parcelRegister("hePpl", function(module, exports) {
module.exports = new URL("add-company-step2.2aa686fa.png", import.meta.url).toString();

});

parcelRegister("idbah", function(module, exports) {
module.exports = new URL("add-company-step3.2dc83c89.png", import.meta.url).toString();

});

parcelRegister("oTBav", function(module, exports) {
module.exports = new URL("searchCompany.7d3c63d9.png", import.meta.url).toString();

});

parcelRegister("lHjlZ", function(module, exports) {
module.exports = new URL("browserIcon.7f2124a5.svg", import.meta.url).toString();

});

parcelRegister("9l2sz", function(module, exports) {
module.exports = new URL("keywordIcon.ff7a9afb.svg", import.meta.url).toString();

});

parcelRegister("5as1I", function(module, exports) {
module.exports = new URL("target-icon.62584419.png", import.meta.url).toString();

});

parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("a8Wtc", function(module, exports) {
module.exports = new URL("icon.77d75949.png", import.meta.url).toString();

});

parcelRegister("2qpNL", function(module, exports) {
module.exports = new URL("pc-to-data-repository.42468e74.gif", import.meta.url).toString();

});

parcelRegister("6bpyB", function(module, exports) {
module.exports = new URL("clarence-to-data-repository.8bef377c.gif", import.meta.url).toString();

});

parcelRegister("lV6Oz", function(module, exports) {
module.exports = new URL("pc-to-data-clarence.38f0238d.gif", import.meta.url).toString();

});

parcelRegister("f5cbi", function(module, exports) {
module.exports = new URL("sorryMessage.ebaede17.png", import.meta.url).toString();

});

parcelRegister("6mnJ3", function(module, exports) {
module.exports = new URL("fillingassistantGirl.6c5641f7.png", import.meta.url).toString();

});

parcelRegister("g1WEs", function(module, exports) {
module.exports = new URL("file_placement.21642384.svg", import.meta.url).toString();

});

parcelRegister("kBFDN", function(module, exports) {
module.exports = new URL("profile-photo.7be027fd.png", import.meta.url).toString();

});

parcelRegister("5hbJu", function(module, exports) {
module.exports = new URL("google_auth.22fdda51.svg", import.meta.url).toString();

});

parcelRegister("liVak", function(module, exports) {
module.exports = new URL("email_auth.d4f961c5.svg", import.meta.url).toString();

});

parcelRegister("hYCi0", function(module, exports) {
module.exports = new URL("pptxIcon.545dc962.png", import.meta.url).toString();

});

parcelRegister("8KwAi", function(module, exports) {
module.exports = new URL("pdfIcon.672d8029.png", import.meta.url).toString();

});

parcelRegister("4CB20", function(module, exports) {
module.exports = new URL("xlsxIcon.6473fbd7.png", import.meta.url).toString();

});

parcelRegister("jnmRN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $e1b1e7274ffc28cf$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $e1b1e7274ffc28cf$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $e1b1e7274ffc28cf$var$getPrefix;
const $e1b1e7274ffc28cf$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $e1b1e7274ffc28cf$var$getPrefix() /*: string*/ {
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = window.document?.documentElement?.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < $e1b1e7274ffc28cf$var$prefixes.length; i++){
        if ($e1b1e7274ffc28cf$var$browserPrefixToKey(prop, $e1b1e7274ffc28cf$var$prefixes[i]) in style) return $e1b1e7274ffc28cf$var$prefixes[i];
    }
    return '';
}
function $e1b1e7274ffc28cf$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `${prefix}${$e1b1e7274ffc28cf$var$kebabToTitleCase(prop)}` : prop;
}
function $e1b1e7274ffc28cf$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `-${prefix.toLowerCase()}-${prop}` : prop;
}
function $e1b1e7274ffc28cf$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $e1b1e7274ffc28cf$var$_default = module.exports.default = $e1b1e7274ffc28cf$var$getPrefix();

});

parcelRegister("7eM6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $544f2767f390b5ca$var$React = $544f2767f390b5ca$var$_interopRequireWildcard((parcelRequire("acw62")));

var $544f2767f390b5ca$var$_propTypes = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $544f2767f390b5ca$var$_reactDom = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $hVGkP = parcelRequire("hVGkP");

var $jc5pr = parcelRequire("jc5pr");

var $7jnr7 = parcelRequire("7jnr7");

var $544f2767f390b5ca$var$_log = $544f2767f390b5ca$var$_interopRequireDefault((parcelRequire("ldVpK")));
function $544f2767f390b5ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $544f2767f390b5ca$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($544f2767f390b5ca$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $544f2767f390b5ca$var$_defineProperty(e, r, t) {
    return (r = $544f2767f390b5ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $544f2767f390b5ca$var$_toPropertyKey(t) {
    var i = $544f2767f390b5ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $544f2767f390b5ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $544f2767f390b5ca$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  allowMobileScroll: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $544f2767f390b5ca$var$DraggableCore extends $544f2767f390b5ca$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $544f2767f390b5ca$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $544f2767f390b5ca$var$_defineProperty(this, "lastX", NaN);
        $544f2767f390b5ca$var$_defineProperty(this, "lastY", NaN);
        $544f2767f390b5ca$var$_defineProperty(this, "touchIdentifier", null);
        $544f2767f390b5ca$var$_defineProperty(this, "mounted", false);
        $544f2767f390b5ca$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $hVGkP.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $hVGkP.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart' && !this.props.allowMobileScroll) e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $hVGkP.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $jc5pr.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $544f2767f390b5ca$var$_log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $hVGkP.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $hVGkP.addEvent)(ownerDocument, $544f2767f390b5ca$var$dragEventFor.move, this.handleDrag);
            (0, $hVGkP.addEvent)(ownerDocument, $544f2767f390b5ca$var$dragEventFor.stop, this.handleDragStop);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $jc5pr.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $jc5pr.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $544f2767f390b5ca$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $jc5pr.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $jc5pr.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $jc5pr.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $hVGkP.scheduleRemoveUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $544f2767f390b5ca$var$_log.default)('DraggableCore: Removing handlers');
                (0, $hVGkP.removeEvent)(thisNode.ownerDocument, $544f2767f390b5ca$var$dragEventFor.move, this.handleDrag);
                (0, $hVGkP.removeEvent)(thisNode.ownerDocument, $544f2767f390b5ca$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onMouseDown", (e)=>{
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onMouseUp", (e)=>{
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $544f2767f390b5ca$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $544f2767f390b5ca$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $544f2767f390b5ca$var$dragEventFor = $544f2767f390b5ca$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $hVGkP.addEvent)(thisNode, $544f2767f390b5ca$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.mouse.move, this.handleDrag);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.touch.move, this.handleDrag);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $hVGkP.removeEvent)(ownerDocument, $544f2767f390b5ca$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $hVGkP.removeEvent)(thisNode, $544f2767f390b5ca$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $hVGkP.scheduleRemoveUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        return this.props?.nodeRef ? this.props?.nodeRef?.current : $544f2767f390b5ca$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $544f2767f390b5ca$var$React.cloneElement($544f2767f390b5ca$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $544f2767f390b5ca$var$DraggableCore;
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "displayName", 'DraggableCore');
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: $544f2767f390b5ca$var$_propTypes.default.bool,
    children: $544f2767f390b5ca$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $544f2767f390b5ca$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $544f2767f390b5ca$var$_propTypes.default.arrayOf($544f2767f390b5ca$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $544f2767f390b5ca$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $544f2767f390b5ca$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $544f2767f390b5ca$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $544f2767f390b5ca$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $544f2767f390b5ca$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $7jnr7.dontSetMe,
    style: $7jnr7.dontSetMe,
    transform: $7jnr7.dontSetMe
});
$544f2767f390b5ca$var$_defineProperty($544f2767f390b5ca$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("hVGkP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $d0d8995f7df729b6$var$addClassName;
module.exports.addEvent = $d0d8995f7df729b6$var$addEvent;
module.exports.addUserSelectStyles = $d0d8995f7df729b6$var$addUserSelectStyles;
module.exports.createCSSTransform = $d0d8995f7df729b6$var$createCSSTransform;
module.exports.createSVGTransform = $d0d8995f7df729b6$var$createSVGTransform;
module.exports.getTouch = $d0d8995f7df729b6$var$getTouch;
module.exports.getTouchIdentifier = $d0d8995f7df729b6$var$getTouchIdentifier;
module.exports.getTranslation = $d0d8995f7df729b6$var$getTranslation;
module.exports.innerHeight = $d0d8995f7df729b6$var$innerHeight;
module.exports.innerWidth = $d0d8995f7df729b6$var$innerWidth;
module.exports.matchesSelector = $d0d8995f7df729b6$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $d0d8995f7df729b6$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $d0d8995f7df729b6$var$offsetXYFromParent;
module.exports.outerHeight = $d0d8995f7df729b6$var$outerHeight;
module.exports.outerWidth = $d0d8995f7df729b6$var$outerWidth;
module.exports.removeClassName = $d0d8995f7df729b6$var$removeClassName;
module.exports.removeEvent = $d0d8995f7df729b6$var$removeEvent;
module.exports.scheduleRemoveUserSelectStyles = $d0d8995f7df729b6$var$scheduleRemoveUserSelectStyles;

var $7jnr7 = parcelRequire("7jnr7");

var $d0d8995f7df729b6$var$_getPrefix = $d0d8995f7df729b6$var$_interopRequireWildcard((parcelRequire("jnmRN")));
function $d0d8995f7df729b6$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d0d8995f7df729b6$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $d0d8995f7df729b6$var$matchesSelectorFunc = '';
function $d0d8995f7df729b6$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$d0d8995f7df729b6$var$matchesSelectorFunc) $d0d8995f7df729b6$var$matchesSelectorFunc = (0, $7jnr7.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $7jnr7.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $7jnr7.isFunction)(el[$d0d8995f7df729b6$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$d0d8995f7df729b6$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $d0d8995f7df729b6$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($d0d8995f7df729b6$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $d0d8995f7df729b6$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $d0d8995f7df729b6$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $d0d8995f7df729b6$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $7jnr7.int)(computedStyle.borderTopWidth);
    height += (0, $7jnr7.int)(computedStyle.borderBottomWidth);
    return height;
}
function $d0d8995f7df729b6$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $7jnr7.int)(computedStyle.borderLeftWidth);
    width += (0, $7jnr7.int)(computedStyle.borderRightWidth);
    return width;
}
function $d0d8995f7df729b6$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $7jnr7.int)(computedStyle.paddingTop);
    height -= (0, $7jnr7.int)(computedStyle.paddingBottom);
    return height;
}
function $d0d8995f7df729b6$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $7jnr7.int)(computedStyle.paddingLeft);
    width -= (0, $7jnr7.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $d0d8995f7df729b6$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $d0d8995f7df729b6$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $d0d8995f7df729b6$var$getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, $d0d8995f7df729b6$var$_getPrefix.browserPrefixToKey)('transform', $d0d8995f7df729b6$var$_getPrefix.default)]: translation
    };
}
function $d0d8995f7df729b6$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $d0d8995f7df729b6$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $d0d8995f7df729b6$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function $d0d8995f7df729b6$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $7jnr7.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $7jnr7.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $d0d8995f7df729b6$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $d0d8995f7df729b6$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $d0d8995f7df729b6$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $d0d8995f7df729b6$var$scheduleRemoveUserSelectStyles(doc /*: ?Document*/ ) {
    // Prevent a possible "forced reflow"
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        $d0d8995f7df729b6$var$removeUserSelectStyles(doc);
    });
    else $d0d8995f7df729b6$var$removeUserSelectStyles(doc);
}
function $d0d8995f7df729b6$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $d0d8995f7df729b6$var$removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $d0d8995f7df729b6$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function $d0d8995f7df729b6$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, 'g'), '');
}

});
parcelRegister("7jnr7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $552c7cc0c70bb1ed$var$dontSetMe;
module.exports.findInArray = $552c7cc0c70bb1ed$var$findInArray;
module.exports.int = $552c7cc0c70bb1ed$var$int;
module.exports.isFunction = $552c7cc0c70bb1ed$var$isFunction;
module.exports.isNum = $552c7cc0c70bb1ed$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $552c7cc0c70bb1ed$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $552c7cc0c70bb1ed$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $552c7cc0c70bb1ed$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $552c7cc0c70bb1ed$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $552c7cc0c70bb1ed$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}

});


parcelRegister("jc5pr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $df93557b6a1aa90a$var$canDragX;
module.exports.canDragY = $df93557b6a1aa90a$var$canDragY;
module.exports.createCoreData = $df93557b6a1aa90a$var$createCoreData;
module.exports.createDraggableData = $df93557b6a1aa90a$var$createDraggableData;
module.exports.getBoundPosition = $df93557b6a1aa90a$var$getBoundPosition;
module.exports.getControlPosition = $df93557b6a1aa90a$var$getControlPosition;
module.exports.snapToGrid = $df93557b6a1aa90a$var$snapToGrid;

var $7jnr7 = parcelRequire("7jnr7");

var $hVGkP = parcelRequire("hVGkP");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $df93557b6a1aa90a$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : $df93557b6a1aa90a$var$cloneBounds(bounds);
    const node = $df93557b6a1aa90a$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else {
            // Flow assigns the wrong return type (Node) for getRootNode(),
            // so we cast it to one of the correct types (Element).
            // The others are Document and ShadowRoot.
            // All three implement querySelector() so it's safe to call.
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $7jnr7.int)(boundNodeStyle.paddingLeft) + (0, $7jnr7.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $7jnr7.int)(boundNodeStyle.paddingTop) + (0, $7jnr7.int)(nodeStyle.marginTop),
            right: (0, $hVGkP.innerWidth)(boundNodeEl) - (0, $hVGkP.outerWidth)(node) - node.offsetLeft + (0, $7jnr7.int)(boundNodeStyle.paddingRight) - (0, $7jnr7.int)(nodeStyle.marginRight),
            bottom: (0, $hVGkP.innerHeight)(boundNodeEl) - (0, $hVGkP.outerHeight)(node) - node.offsetTop + (0, $7jnr7.int)(boundNodeStyle.paddingBottom) - (0, $7jnr7.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $7jnr7.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $7jnr7.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $7jnr7.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $7jnr7.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $df93557b6a1aa90a$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $df93557b6a1aa90a$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $df93557b6a1aa90a$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function $df93557b6a1aa90a$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, $hVGkP.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = $df93557b6a1aa90a$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $hVGkP.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $df93557b6a1aa90a$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $7jnr7.isNum)(draggable.lastX);
    const node = $df93557b6a1aa90a$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $df93557b6a1aa90a$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $df93557b6a1aa90a$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $df93557b6a1aa90a$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("ldVpK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7375926498124e5$var$log;
/*eslint no-console:0*/ function $f7375926498124e5$var$log() {}

});


parcelRegister("bi4Ns", function(module, exports) {
module.exports = new URL("intelligentiaIcon.ba7c1f0e.png", import.meta.url).toString();

});

parcelRegister("dmxYU", function(module, exports) {
module.exports = new URL("clarence-avatar.524d57df.png", import.meta.url).toString();

});

parcelRegister("b0Cmg", function(module, exports) {
module.exports = new URL("Dg-logo.5cca91cf.png", import.meta.url).toString();

});

parcelRegister("6u6RT", function(module, exports) {
module.exports = new URL("autofill-icon.94d7f298.png", import.meta.url).toString();

});

parcelRegister("1K8E2", function(module, exports) {
module.exports = new URL("magic-wand.14d028b2.png", import.meta.url).toString();

});

parcelRegister("dmpf0", function(module, exports) {
module.exports = new URL("steps-number.c5aadd7d.png", import.meta.url).toString();

});

parcelRegister("jRkbT", function(module, exports) {
module.exports = new URL("step-1.0d9219f7.png", import.meta.url).toString();

});

parcelRegister("9BSL1", function(module, exports) {
module.exports = new URL("step-2.2ecffc3d.png", import.meta.url).toString();

});

parcelRegister("lSMjL", function(module, exports) {
module.exports = new URL("step-3.723d7786.png", import.meta.url).toString();

});

parcelRegister("ftlOR", function(module, exports) {
module.exports = new URL("step-4.7e8ae168.png", import.meta.url).toString();

});

parcelRegister("81qdF", function(module, exports) {
module.exports = new URL("step-bottom.5e72b243.png", import.meta.url).toString();

});

parcelRegister("11dP3", function(module, exports) {
module.exports = new URL("select-phase-img.3a26833d.png", import.meta.url).toString();

});

parcelRegister("9YqvR", function(module, exports) {
module.exports = new URL("file-upload-icon.9d2ea223.png", import.meta.url).toString();

});

parcelRegister("3ZIxk", function(module, exports) {
module.exports = new URL("folder-upload-icon.3f16162d.png", import.meta.url).toString();

});

parcelRegister("hA45b", function(module, exports) {
module.exports = new URL("wizard.4ff3bea2.gif", import.meta.url).toString();

});

parcelRegister("dANvg", function(module, exports) {
module.exports = new URL("claude-logo.ffb272b3.png", import.meta.url).toString();

});

parcelRegister("4lWo1", function(module, exports) {
module.exports = new URL("chatgpt-logo.144be6e9.png", import.meta.url).toString();

});

parcelRegister("aR1CT", function(module, exports) {
module.exports = new URL("logo.5df7d4bf.svg", import.meta.url).toString();

});

parcelRegister("8dxNU", function(module, exports) {
module.exports = new URL("add-applicant-ai.7d53157b.png", import.meta.url).toString();

});

parcelRegister("lp3wv", function(module, exports) {
module.exports = new URL("clicktohearme.8476e92d.webp", import.meta.url).toString();

});

parcelRegister("dJEkK", function(module, exports) {
module.exports = new URL("aiWatermark.12d7e38a.png", import.meta.url).toString();

});

parcelRegister("bJ68K", function(module, exports) {
module.exports = new URL("favicon.fc7d35cf.png", import.meta.url).toString();

});

parcelRegister("lm8C6", function(module, exports) {
module.exports = new URL("logodiligentsia.4ead61ee.svg", import.meta.url).toString();

});

parcelRegister("kIY17", function(module, exports) {
module.exports = new URL("logo_white.2cd6dd36.png", import.meta.url).toString();

});

parcelRegister("8RYFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $675256233f0d2ee0$export$2e2bcd8739ae039);

var $gvVBt = parcelRequire("gvVBt");
var $675256233f0d2ee0$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $675256233f0d2ee0$var$index = (0, $gvVBt.default)(function(prop) {
    return $675256233f0d2ee0$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $675256233f0d2ee0$export$2e2bcd8739ae039 = $675256233f0d2ee0$var$index;

});
parcelRegister("gvVBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05c3971f0aa92b4$export$2e2bcd8739ae039);
function $c05c3971f0aa92b4$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $c05c3971f0aa92b4$export$2e2bcd8739ae039 = $c05c3971f0aa92b4$var$memoize;

});


parcelRegister("7CJbu", function(module, exports) {
module.exports = new URL("about-us-top-banner.df7a735b.png", import.meta.url).toString();

});

parcelRegister("9sq0N", function(module, exports) {
module.exports = new URL("mark-picture.07c91369.png", import.meta.url).toString();

});

parcelRegister("gxwGu", function(module, exports) {
module.exports = new URL("jonpicture.03863d06.png", import.meta.url).toString();

});

parcelRegister("hntTQ", function(module, exports) {
module.exports = new URL("paul-morris.13e8955e.png", import.meta.url).toString();

});

parcelRegister("5bmwc", function(module, exports) {
module.exports = new URL("alex-faulconbridge.f7808902.jpg", import.meta.url).toString();

});

parcelRegister("g82aP", function(module, exports) {
module.exports = new URL("jim-tunstall.180ada58.jpeg", import.meta.url).toString();

});

parcelRegister("7oN30", function(module, exports) {
module.exports = new URL("book-call-mark .705d3a5b.png", import.meta.url).toString();

});

parcelRegister("6lUjz", function(module, exports) {
module.exports = new URL("2-minute-test-icon.ef02246b.png", import.meta.url).toString();

});

parcelRegister("iFOmq", function(module, exports) {
module.exports = new URL("contact-us-support.33d06fb4.png", import.meta.url).toString();

});

parcelRegister("1aHMF", function(module, exports) {
module.exports = new URL("contact-us-sales.b8afb00f.png", import.meta.url).toString();

});

parcelRegister("3cMIH", function(module, exports) {
module.exports = new URL("contact-us-patner.abc64329.png", import.meta.url).toString();

});

parcelRegister("isiQT", function(module, exports) {
module.exports = new URL("contact-us-bugs.b6978f65.png", import.meta.url).toString();

});

parcelRegister("hKwh2", function(module, exports) {
module.exports = new URL("contact-us-support-img.480f477a.png", import.meta.url).toString();

});

parcelRegister("7LSyE", function(module, exports) {
module.exports = new URL("book-call.03f57154.png", import.meta.url).toString();

});

parcelRegister("dtHaj", function(module, exports) {
module.exports = new URL("contact-us-bug-img.5ffab1c4.png", import.meta.url).toString();

});

parcelRegister("93zLg", function(module, exports) {
module.exports = new URL("contact-us-option-bg.96f084d8.png", import.meta.url).toString();

});

parcelRegister("6gL2z", function(module, exports) {
module.exports = new URL("customer-join.46b1189d.png", import.meta.url).toString();

});

parcelRegister("kdjt4", function(module, exports) {
module.exports = new URL("co-branded.f026c50c.gif", import.meta.url).toString();

});

parcelRegister("cmxC8", function(module, exports) {
module.exports = new URL("partner-minu.56cd3eb0.png", import.meta.url).toString();

});

parcelRegister("VI0Xf", function(module, exports) {
module.exports = new URL("partner-main-banner-bg1.5fb852fb.png", import.meta.url).toString();

});

parcelRegister("jGXLu", function(module, exports) {
module.exports = new URL("blur-bg.a1f7f13d.png", import.meta.url).toString();

});

parcelRegister("jViIO", function(module, exports) {
module.exports = new URL("genfinance.322f9ae9.png", import.meta.url).toString();

});

parcelRegister("fkt5e", function(module, exports) {
module.exports = new URL("abf.8453d460.png", import.meta.url).toString();

});

parcelRegister("02e9s", function(module, exports) {
module.exports = new URL("jpj.c49cd7fe.png", import.meta.url).toString();

});

parcelRegister("4ghjp", function(module, exports) {
module.exports = new URL("brown_rudnik.e0ccbbdd.png", import.meta.url).toString();

});

parcelRegister("9NBW9", function(module, exports) {
module.exports = new URL("finhouse.b092f565.png", import.meta.url).toString();

});

parcelRegister("iKoy8", function(module, exports) {
module.exports = new URL("kiss_the_fish.3e8b85a4.jpg", import.meta.url).toString();

});

parcelRegister("jJQSv", function(module, exports) {
module.exports = new URL("handshake.df63c029.png", import.meta.url).toString();

});

parcelRegister("6Y8De", function(module, exports) {
module.exports = new URL("cfo.a205a7cf.png", import.meta.url).toString();

});

parcelRegister("aVv03", function(module, exports) {
module.exports = new URL("company.edfdd081.png", import.meta.url).toString();

});

parcelRegister("ayLlv", function(module, exports) {
module.exports = new URL("angel.23f3fd5b.png", import.meta.url).toString();

});

parcelRegister("5AIsY", function(module, exports) {
module.exports = new URL("accountant.a1a43d88.png", import.meta.url).toString();

});

parcelRegister("7EAcl", function(module, exports) {
module.exports = new URL("seedlegal.b4db2e74.png", import.meta.url).toString();

});

parcelRegister("eHYLa", function(module, exports) {
module.exports = new URL("you.8b2c3332.png", import.meta.url).toString();

});

parcelRegister("12dQk", function(module, exports) {
module.exports = new URL("partner-2.43cba0c3.png", import.meta.url).toString();

});

parcelRegister("7fWbC", function(module, exports) {
module.exports = new URL("partner-3.d922ad67.png", import.meta.url).toString();

});

parcelRegister("foBrN", function(module, exports) {
module.exports = new URL("partner-1.97d18bb8.png", import.meta.url).toString();

});

parcelRegister("l1ZKX", function(module, exports) {
module.exports = new URL("abf.9160ca77.png", import.meta.url).toString();

});

parcelRegister("2zIdh", function(module, exports) {
module.exports = new URL("br.03aa7d18.png", import.meta.url).toString();

});

parcelRegister("2SrE0", function(module, exports) {
module.exports = new URL("cyberduedil.9d0e52c4.png", import.meta.url).toString();

});

parcelRegister("kvime", function(module, exports) {
module.exports = new URL("finhouse.7f1b0bdf.png", import.meta.url).toString();

});

parcelRegister("4BY23", function(module, exports) {
module.exports = new URL("fractionality.9ff43057.png", import.meta.url).toString();

});

parcelRegister("5Nwjp", function(module, exports) {
module.exports = new URL("freshbat.fa32a1fe.png", import.meta.url).toString();

});

parcelRegister("5OzpP", function(module, exports) {
module.exports = new URL("gen.b5d9cbdd.png", import.meta.url).toString();

});

parcelRegister("72Xlx", function(module, exports) {
module.exports = new URL("green_ripple.773fa44a.png", import.meta.url).toString();

});

parcelRegister("6XEUD", function(module, exports) {
module.exports = new URL("intelect.f9e6d3fa.png", import.meta.url).toString();

});

parcelRegister("bOKxS", function(module, exports) {
module.exports = new URL("kiss_the_fish.0dcbd96f.png", import.meta.url).toString();

});

parcelRegister("8B5WB", function(module, exports) {
module.exports = new URL("nume.99409a63.png", import.meta.url).toString();

});

parcelRegister("jJRlq", function(module, exports) {
module.exports = new URL("su2su.eb4c5c02.png", import.meta.url).toString();

});

parcelRegister("lx758", function(module, exports) {
module.exports = new URL("avatar-maham-zupash.9cb2240a.png", import.meta.url).toString();

});

parcelRegister("86geU", function(module, exports) {
module.exports = new URL("ecosystem-people.e3e01058.webp", import.meta.url).toString();

});

parcelRegister("gFaBl", function(module, exports) {
module.exports = new URL("avatar-mark-bernstein.9caa43c3.png", import.meta.url).toString();

});

parcelRegister("d3OBY", function(module, exports) {
module.exports = new URL("avatar-ollie-austen.e00fcd77.png", import.meta.url).toString();

});

parcelRegister("8HilG", function(module, exports) {
module.exports = new URL("avatar-chris-enoh.9ec03ee2.png", import.meta.url).toString();

});

parcelRegister("9gLdu", function(module, exports) {
module.exports = new URL("su2su-card.f55676cb.webp", import.meta.url).toString();

});

parcelRegister("hDsbO", function(module, exports) {
module.exports = new URL("su2su-logo.332c7688.webp", import.meta.url).toString();

});

parcelRegister("j42QG", function(module, exports) {
module.exports = new URL("events-header.306e0c5a.webp", import.meta.url).toString();

});

parcelRegister("2FyOx", function(module, exports) {
module.exports = new URL("terms-background.33d44658.png", import.meta.url).toString();

});

parcelRegister("eWMdR", function(module, exports) {
module.exports = new URL("investor_cog.028fc079.png", import.meta.url).toString();

});

parcelRegister("ejUMZ", function(module, exports) {
module.exports = new URL("company_cog.c3de83b4.png", import.meta.url).toString();

});

parcelRegister("4lNiv", function(module, exports) {
module.exports = new URL("diligentsia_cog.c617dbbc.png", import.meta.url).toString();

});

parcelRegister("6SxPm", function(module, exports) {
module.exports = new URL("advisor_cog.973e85de.png", import.meta.url).toString();

});

parcelRegister("d9qvr", function(module, exports) {
module.exports = new URL("seedlegals_logo.470b4f2b.png", import.meta.url).toString();

});

parcelRegister("1UKQy", function(module, exports) {
module.exports = new URL("aI_forge_logo.2eb45a97.png", import.meta.url).toString();

});

parcelRegister("b0jPS", function(module, exports) {
module.exports = new URL("acentis_logo.5c5a1b36.png", import.meta.url).toString();

});

parcelRegister("cUzig", function(module, exports) {
module.exports = new URL("dignus_muneris_logo.d2d8aa52.png", import.meta.url).toString();

});

parcelRegister("874BN", function(module, exports) {
module.exports = new URL("ehe_logo.f6969c94.png", import.meta.url).toString();

});

parcelRegister("lt9td", function(module, exports) {
module.exports = new URL("fractionality_logo.8c1d41c8.png", import.meta.url).toString();

});

parcelRegister("9yjEm", function(module, exports) {
module.exports = new URL("jpj_logo.95b5388e.png", import.meta.url).toString();

});

parcelRegister("bw3Jr", function(module, exports) {
module.exports = new URL("su2su_logo.fd0616df.png", import.meta.url).toString();

});

parcelRegister("r7AxX", function(module, exports) {
module.exports = new URL("acf_investors_logo.7b1e2289.png", import.meta.url).toString();

});

parcelRegister("cxe43", function(module, exports) {
module.exports = new URL("angelgroups_logo.078dbb28.png", import.meta.url).toString();

});

parcelRegister("9x0yD", function(module, exports) {
module.exports = new URL("british_business_bank_logo.e326d38c.png", import.meta.url).toString();

});

parcelRegister("kgN6q", function(module, exports) {
module.exports = new URL("british_design_fund_logo.a5b70a15.png", import.meta.url).toString();

});

parcelRegister("bkJbN", function(module, exports) {
module.exports = new URL("deepbridge_logo.189d1d69.png", import.meta.url).toString();

});

parcelRegister("g4Quf", function(module, exports) {
module.exports = new URL("foresight_logo.e457b85f.png", import.meta.url).toString();

});

parcelRegister("j8Ceg", function(module, exports) {
module.exports = new URL("kero_logo.507dd59f.png", import.meta.url).toString();

});

parcelRegister("8No4I", function(module, exports) {
module.exports = new URL("key_capital_logo.05649527.png", import.meta.url).toString();

});

parcelRegister("1kDTU", function(module, exports) {
module.exports = new URL("key_fund_logo.000c7c9a.png", import.meta.url).toString();

});

parcelRegister("2sCdN", function(module, exports) {
module.exports = new URL("lifted_logo.8cb12a04.png", import.meta.url).toString();

});

parcelRegister("8taOC", function(module, exports) {
module.exports = new URL("mercia_fund_logo.e38cf21d.png", import.meta.url).toString();

});

parcelRegister("2SEjH", function(module, exports) {
module.exports = new URL("northern_gritstone_logo.15638a26.png", import.meta.url).toString();

});

parcelRegister("483jj", function(module, exports) {
module.exports = new URL("northstar_ventures_logo.2a2cbe65.png", import.meta.url).toString();

});

parcelRegister("f8VOs", function(module, exports) {
module.exports = new URL("par_equity_logo.f2a8ede5.png", import.meta.url).toString();

});

parcelRegister("eVMcj", function(module, exports) {
module.exports = new URL("playfair_logo.b1e94a3a.png", import.meta.url).toString();

});

parcelRegister("ko4JQ", function(module, exports) {
module.exports = new URL("river_capital_logo.e56e3d30.png", import.meta.url).toString();

});

parcelRegister("kNkpn", function(module, exports) {
module.exports = new URL("science_angel_logo.04eb97ea.png", import.meta.url).toString();

});

parcelRegister("gaJEH", function(module, exports) {
module.exports = new URL("solidbond_logo.bee39481.png", import.meta.url).toString();

});

parcelRegister("lxIRU", function(module, exports) {
module.exports = new URL("yfm_equity_logo.ecfb3d75.png", import.meta.url).toString();

});

parcelRegister("9MRy1", function(module, exports) {
module.exports = new URL("mark-signature.19757332.png", import.meta.url).toString();

});

parcelRegister("lLAnH", function(module, exports) {
module.exports = new URL("mark-photo.9abc6a44.png", import.meta.url).toString();

});

parcelRegister("5dTa9", function(module, exports) {
module.exports = new URL("katy-davidson.387479a8.png", import.meta.url).toString();

});

parcelRegister("hAmwK", function(module, exports) {
module.exports = new URL("louise-birritteri.33bb47e4.png", import.meta.url).toString();

});

parcelRegister("4TxZa", function(module, exports) {
module.exports = new URL("rik-pancholi.e310d2ff.png", import.meta.url).toString();

});

parcelRegister("3jD7H", function(module, exports) {
module.exports = new URL("richard-whitwell.96ab6aec.png", import.meta.url).toString();

});

parcelRegister("cvZc5", function(module, exports) {
module.exports = new URL("barry-williams.745fa2b8.png", import.meta.url).toString();

});

parcelRegister("duLaW", function(module, exports) {
module.exports = new URL("yourlogohere.4f4645dc.png", import.meta.url).toString();

});

parcelRegister("gPTbN", function(module, exports) {
module.exports = new URL("social1.43c3205c.png", import.meta.url).toString();

});

parcelRegister("3zMud", function(module, exports) {
module.exports = new URL("social2.6c891abf.png", import.meta.url).toString();

});

parcelRegister("8BoXF", function(module, exports) {
module.exports = new URL("social3.7301609e.png", import.meta.url).toString();

});

parcelRegister("iQeGV", function(module, exports) {
module.exports = new URL("certification1.9021fb43.png", import.meta.url).toString();

});

parcelRegister("l61of", function(module, exports) {
module.exports = new URL("certification2.1859405c.png", import.meta.url).toString();

});

parcelRegister("gI7Us", function(module, exports) {
module.exports = new URL("certification3.a5e60efb.png", import.meta.url).toString();

});

parcelRegister("dDjqz", function(module, exports) {
module.exports = new URL("au-certification1.21a827fc.png", import.meta.url).toString();

});

parcelRegister("6tYxP", function(module, exports) {
module.exports = new URL("au-certification2.35b09322.png", import.meta.url).toString();

});

parcelRegister("jndeQ", function(module, exports) {
module.exports = new URL("au-certification3.4aa48965.png", import.meta.url).toString();

});

parcelRegister("jFPjW", function(module, exports) {
module.exports = new URL("pro-pricing-back.217b0289.png", import.meta.url).toString();

});

parcelRegister("jdo6l", function(module, exports) {
module.exports = new URL("checklist-logo.af9eac88.webp", import.meta.url).toString();

});

parcelRegister("iCPHM", function(module, exports) {
module.exports = new URL("close.455703a0.png", import.meta.url).toString();

});

parcelRegister("lvxWB", function(module, exports) {
module.exports = new URL("LI-Logo.ed1b7235.png", import.meta.url).toString();

});

parcelRegister("cfmAr", function(module, exports) {
module.exports = new URL("profile-photo.4587511a.jpeg", import.meta.url).toString();

});

parcelRegister("avtRj", function(module, exports) {
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var WINDOW = IS_BROWSER ? window : {};
    var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
    var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
    var NAMESPACE = 'cropper';
    // Actions
    var ACTION_ALL = 'all';
    var ACTION_CROP = 'crop';
    var ACTION_MOVE = 'move';
    var ACTION_ZOOM = 'zoom';
    var ACTION_EAST = 'e';
    var ACTION_WEST = 'w';
    var ACTION_SOUTH = 's';
    var ACTION_NORTH = 'n';
    var ACTION_NORTH_EAST = 'ne';
    var ACTION_NORTH_WEST = 'nw';
    var ACTION_SOUTH_EAST = 'se';
    var ACTION_SOUTH_WEST = 'sw';
    // Classes
    var CLASS_CROP = "".concat(NAMESPACE, "-crop");
    var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
    var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
    var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
    var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
    var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
    var CLASS_MOVE = "".concat(NAMESPACE, "-move");
    // Data keys
    var DATA_ACTION = "".concat(NAMESPACE, "Action");
    var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");
    // Drag modes
    var DRAG_MODE_CROP = 'crop';
    var DRAG_MODE_MOVE = 'move';
    var DRAG_MODE_NONE = 'none';
    // Events
    var EVENT_CROP = 'crop';
    var EVENT_CROP_END = 'cropend';
    var EVENT_CROP_MOVE = 'cropmove';
    var EVENT_CROP_START = 'cropstart';
    var EVENT_DBLCLICK = 'dblclick';
    var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
    var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
    var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
    var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
    var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
    var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
    var EVENT_READY = 'ready';
    var EVENT_RESIZE = 'resize';
    var EVENT_WHEEL = 'wheel';
    var EVENT_ZOOM = 'zoom';
    // Mime types
    var MIME_TYPE_JPEG = 'image/jpeg';
    // RegExps
    var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
    var REGEXP_DATA_URL = /^data:/;
    var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
    var REGEXP_TAG_NAME = /^img|canvas$/i;
    // Misc
    // Inspired by the default width and height of a canvas element.
    var MIN_CONTAINER_WIDTH = 200;
    var MIN_CONTAINER_HEIGHT = 100;
    var DEFAULTS = {
        // Define the view mode of the cropper
        viewMode: 0,
        // 0, 1, 2, 3
        // Define the dragging mode of the cropper
        dragMode: DRAG_MODE_CROP,
        // 'crop', 'move' or 'none'
        // Define the initial aspect ratio of the crop box
        initialAspectRatio: NaN,
        // Define the aspect ratio of the crop box
        aspectRatio: NaN,
        // An object with the previous cropping result data
        data: null,
        // A selector for adding extra containers to preview
        preview: '',
        // Re-render the cropper when resize the window
        responsive: true,
        // Restore the cropped area after resize the window
        restore: true,
        // Check if the current image is a cross-origin image
        checkCrossOrigin: true,
        // Check the current image's Exif Orientation information
        checkOrientation: true,
        // Show the black modal
        modal: true,
        // Show the dashed lines for guiding
        guides: true,
        // Show the center indicator for guiding
        center: true,
        // Show the white modal to highlight the crop box
        highlight: true,
        // Show the grid background
        background: true,
        // Enable to crop the image automatically when initialize
        autoCrop: true,
        // Define the percentage of automatic cropping area when initializes
        autoCropArea: 0.8,
        // Enable to move the image
        movable: true,
        // Enable to rotate the image
        rotatable: true,
        // Enable to scale the image
        scalable: true,
        // Enable to zoom the image
        zoomable: true,
        // Enable to zoom the image by dragging touch
        zoomOnTouch: true,
        // Enable to zoom the image by wheeling mouse
        zoomOnWheel: true,
        // Define zoom ratio when zoom the image by wheeling mouse
        wheelZoomRatio: 0.1,
        // Enable to move the crop box
        cropBoxMovable: true,
        // Enable to resize the crop box
        cropBoxResizable: true,
        // Toggle drag mode between "crop" and "move" when click twice on the cropper
        toggleDragModeOnDblclick: true,
        // Size limitation
        minCanvasWidth: 0,
        minCanvasHeight: 0,
        minCropBoxWidth: 0,
        minCropBoxHeight: 0,
        minContainerWidth: MIN_CONTAINER_WIDTH,
        minContainerHeight: MIN_CONTAINER_HEIGHT,
        // Shortcuts of events
        ready: null,
        cropstart: null,
        cropmove: null,
        cropend: null,
        crop: null,
        zoom: null
    };
    var TEMPLATE = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
    /**
   * Check if the given value is not a number.
   */ var isNaN = Number.isNaN || WINDOW.isNaN;
    /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */ function isNumber(value) {
        return typeof value === 'number' && !isNaN(value);
    }
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */ function isUndefined(value) {
        return typeof value === 'undefined';
    }
    /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */ function isObject(value) {
        return _typeof(value) === 'object' && value !== null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */ function isPlainObject(value) {
        if (!isObject(value)) return false;
        try {
            var _constructor = value.constructor;
            var prototype = _constructor.prototype;
            return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
        } catch (error) {
            return false;
        }
    }
    /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */ function isFunction(value) {
        return typeof value === 'function';
    }
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */ function forEach(data, callback) {
        if (data && isFunction(callback)) {
            if (Array.isArray(data) || isNumber(data.length)) toArray(data).forEach(function(value, key) {
                callback.call(data, value, key, data);
            });
            else if (isObject(data)) Object.keys(data).forEach(function(key) {
                callback.call(data, data[key], key, data);
            });
        }
        return data;
    }
    /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */ var assign = Object.assign || function assign(target) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (isObject(target) && args.length > 0) args.forEach(function(arg) {
            if (isObject(arg)) Object.keys(arg).forEach(function(key) {
                target[key] = arg[key];
            });
        });
        return target;
    };
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
    /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */ function setStyle(element, styles) {
        var style = element.style;
        forEach(styles, function(value, property) {
            if (REGEXP_SUFFIX.test(property) && isNumber(value)) value = "".concat(value, "px");
            style[property] = value;
        });
    }
    /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */ function hasClass(element, value) {
        return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
    }
    /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */ function addClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                addClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.add(value);
            return;
        }
        var className = element.className.trim();
        if (!className) element.className = value;
        else if (className.indexOf(value) < 0) element.className = "".concat(className, " ").concat(value);
    }
    /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */ function removeClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                removeClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.remove(value);
            return;
        }
        if (element.className.indexOf(value) >= 0) element.className = element.className.replace(value, '');
    }
    /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */ function toggleClass(element, value, added) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                toggleClass(elem, value, added);
            });
            return;
        }
        // IE10-11 doesn't support the second parameter of `classList.toggle`
        if (added) addClass(element, value);
        else removeClass(element, value);
    }
    var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
    /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */ function toParamCase(value) {
        return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
    }
    /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */ function getData(element, name) {
        if (isObject(element[name])) return element[name];
        if (element.dataset) return element.dataset[name];
        return element.getAttribute("data-".concat(toParamCase(name)));
    }
    /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */ function setData(element, name, data) {
        if (isObject(data)) element[name] = data;
        else if (element.dataset) element.dataset[name] = data;
        else element.setAttribute("data-".concat(toParamCase(name)), data);
    }
    /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */ function removeData(element, name) {
        if (isObject(element[name])) try {
            delete element[name];
        } catch (error) {
            element[name] = undefined;
        }
        else if (element.dataset) // #128 Safari not allows to delete dataset property
        try {
            delete element.dataset[name];
        } catch (error) {
            element.dataset[name] = undefined;
        }
        else element.removeAttribute("data-".concat(toParamCase(name)));
    }
    var REGEXP_SPACES = /\s\s*/;
    var onceSupported = function() {
        var supported = false;
        if (IS_BROWSER) {
            var once = false;
            var listener = function listener() {};
            var options = Object.defineProperty({}, 'once', {
                get: function get() {
                    supported = true;
                    return once;
                },
                /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */ set: function set(value) {
                    once = value;
                }
            });
            WINDOW.addEventListener('test', listener, options);
            WINDOW.removeEventListener('test', listener, options);
        }
        return supported;
    }();
    /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function removeListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (!onceSupported) {
                var listeners = element.listeners;
                if (listeners && listeners[event] && listeners[event][listener]) {
                    handler = listeners[event][listener];
                    delete listeners[event][listener];
                    if (Object.keys(listeners[event]).length === 0) delete listeners[event];
                    if (Object.keys(listeners).length === 0) delete element.listeners;
                }
            }
            element.removeEventListener(event, handler, options);
        });
    }
    /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function addListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var _handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (options.once && !onceSupported) {
                var _element$listeners = element.listeners, listeners = _element$listeners === void 0 ? {} : _element$listeners;
                _handler = function handler() {
                    delete listeners[event][listener];
                    element.removeEventListener(event, _handler, options);
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    listener.apply(element, args);
                };
                if (!listeners[event]) listeners[event] = {};
                if (listeners[event][listener]) element.removeEventListener(event, listeners[event][listener], options);
                listeners[event][listener] = _handler;
                element.listeners = listeners;
            }
            element.addEventListener(event, _handler, options);
        });
    }
    /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */ function dispatchEvent(element, type, data) {
        var event;
        // Event and CustomEvent on IE9-11 are global objects, not constructors
        if (isFunction(Event) && isFunction(CustomEvent)) event = new CustomEvent(type, {
            detail: data,
            bubbles: true,
            cancelable: true
        });
        else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(type, true, true, data);
        }
        return element.dispatchEvent(event);
    }
    /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */ function getOffset(element) {
        var box = element.getBoundingClientRect();
        return {
            left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
            top: box.top + (window.pageYOffset - document.documentElement.clientTop)
        };
    }
    var location = WINDOW.location;
    var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
    /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */ function isCrossOriginURL(url) {
        var parts = url.match(REGEXP_ORIGINS);
        return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
    }
    /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */ function addTimestamp(url) {
        var timestamp = "timestamp=".concat(new Date().getTime());
        return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
    }
    /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */ function getTransforms(_ref) {
        var rotate = _ref.rotate, scaleX = _ref.scaleX, scaleY = _ref.scaleY, translateX = _ref.translateX, translateY = _ref.translateY;
        var values = [];
        if (isNumber(translateX) && translateX !== 0) values.push("translateX(".concat(translateX, "px)"));
        if (isNumber(translateY) && translateY !== 0) values.push("translateY(".concat(translateY, "px)"));
        // Rotate should come first before scale to match orientation transform
        if (isNumber(rotate) && rotate !== 0) values.push("rotate(".concat(rotate, "deg)"));
        if (isNumber(scaleX) && scaleX !== 1) values.push("scaleX(".concat(scaleX, ")"));
        if (isNumber(scaleY) && scaleY !== 1) values.push("scaleY(".concat(scaleY, ")"));
        var transform = values.length ? values.join(' ') : 'none';
        return {
            WebkitTransform: transform,
            msTransform: transform,
            transform: transform
        };
    }
    /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */ function getMaxZoomRatio(pointers) {
        var pointers2 = _objectSpread2({}, pointers);
        var maxRatio = 0;
        forEach(pointers, function(pointer, pointerId) {
            delete pointers2[pointerId];
            forEach(pointers2, function(pointer2) {
                var x1 = Math.abs(pointer.startX - pointer2.startX);
                var y1 = Math.abs(pointer.startY - pointer2.startY);
                var x2 = Math.abs(pointer.endX - pointer2.endX);
                var y2 = Math.abs(pointer.endY - pointer2.endY);
                var z1 = Math.sqrt(x1 * x1 + y1 * y1);
                var z2 = Math.sqrt(x2 * x2 + y2 * y2);
                var ratio = (z2 - z1) / z1;
                if (Math.abs(ratio) > Math.abs(maxRatio)) maxRatio = ratio;
            });
        });
        return maxRatio;
    }
    /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */ function getPointer(_ref2, endOnly) {
        var pageX = _ref2.pageX, pageY = _ref2.pageY;
        var end = {
            endX: pageX,
            endY: pageY
        };
        return endOnly ? end : _objectSpread2({
            startX: pageX,
            startY: pageY
        }, end);
    }
    /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */ function getPointersCenter(pointers) {
        var pageX = 0;
        var pageY = 0;
        var count = 0;
        forEach(pointers, function(_ref3) {
            var startX = _ref3.startX, startY = _ref3.startY;
            pageX += startX;
            pageY += startY;
            count += 1;
        });
        pageX /= count;
        pageY /= count;
        return {
            pageX: pageX,
            pageY: pageY
        };
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref4) {
        var aspectRatio = _ref4.aspectRatio, height = _ref4.height, width = _ref4.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */ function getRotatedSizes(_ref5) {
        var width = _ref5.width, height = _ref5.height, degree = _ref5.degree;
        degree = Math.abs(degree) % 180;
        if (degree === 90) return {
            width: height,
            height: width
        };
        var arc = degree % 90 * Math.PI / 180;
        var sinArc = Math.sin(arc);
        var cosArc = Math.cos(arc);
        var newWidth = width * cosArc + height * sinArc;
        var newHeight = width * sinArc + height * cosArc;
        return degree > 90 ? {
            width: newHeight,
            height: newWidth
        } : {
            width: newWidth,
            height: newHeight
        };
    }
    /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */ function getSourceCanvas(image, _ref6, _ref7, _ref8) {
        var imageAspectRatio = _ref6.aspectRatio, imageNaturalWidth = _ref6.naturalWidth, imageNaturalHeight = _ref6.naturalHeight, _ref6$rotate = _ref6.rotate, rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate, _ref6$scaleX = _ref6.scaleX, scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX, _ref6$scaleY = _ref6.scaleY, scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
        var aspectRatio = _ref7.aspectRatio, naturalWidth = _ref7.naturalWidth, naturalHeight = _ref7.naturalHeight;
        var _ref8$fillColor = _ref8.fillColor, fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor, _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled, imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE, _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality, imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ, _ref8$maxWidth = _ref8.maxWidth, maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth, _ref8$maxHeight = _ref8.maxHeight, maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight, _ref8$minWidth = _ref8.minWidth, minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth, _ref8$minHeight = _ref8.minHeight, minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var maxSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var minSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
        var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));
        // Note: should always use image's natural sizes for drawing as
        // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
        var destMaxSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var destMinSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: minWidth,
            height: minHeight
        }, 'cover');
        var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
        var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
        var params = [
            -destWidth / 2,
            -destHeight / 2,
            destWidth,
            destHeight
        ];
        canvas.width = normalizeDecimalNumber(width);
        canvas.height = normalizeDecimalNumber(height);
        context.fillStyle = fillColor;
        context.fillRect(0, 0, width, height);
        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.imageSmoothingEnabled = imageSmoothingEnabled;
        context.imageSmoothingQuality = imageSmoothingQuality;
        context.drawImage.apply(context, [
            image
        ].concat(_toConsumableArray(params.map(function(param) {
            return Math.floor(normalizeDecimalNumber(param));
        }))));
        context.restore();
        return canvas;
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = '';
        length += start;
        for(var i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var REGEXP_DATA_URL_HEAD = /^data:.*,/;
    /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */ function dataURLToArrayBuffer(dataURL) {
        var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
        var binary = atob(base64);
        var arrayBuffer = new ArrayBuffer(binary.length);
        var uint8 = new Uint8Array(arrayBuffer);
        forEach(uint8, function(value, i) {
            uint8[i] = binary.charCodeAt(i);
        });
        return arrayBuffer;
    }
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = [];
        // Chunk Typed Array for better performance (#435)
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation;
        // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart;
            // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D /* bigEndian */ ) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112 /* Orientation */ ) {
                        // 8 is the offset of the current tag's value
                        _offset += 8;
                        // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian);
                        // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (error) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var render = {
        render: function render() {
            this.initContainer();
            this.initCanvas();
            this.initCropBox();
            this.renderCanvas();
            if (this.cropped) this.renderCropBox();
        },
        initContainer: function initContainer() {
            var element = this.element, options = this.options, container = this.container, cropper = this.cropper;
            var minWidth = Number(options.minContainerWidth);
            var minHeight = Number(options.minContainerHeight);
            addClass(cropper, CLASS_HIDDEN);
            removeClass(element, CLASS_HIDDEN);
            var containerData = {
                width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
                height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
            };
            this.containerData = containerData;
            setStyle(cropper, {
                width: containerData.width,
                height: containerData.height
            });
            addClass(element, CLASS_HIDDEN);
            removeClass(cropper, CLASS_HIDDEN);
        },
        // Canvas (image wrapper)
        initCanvas: function initCanvas() {
            var containerData = this.containerData, imageData = this.imageData;
            var viewMode = this.options.viewMode;
            var rotated = Math.abs(imageData.rotate) % 180 === 90;
            var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
            var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
            var aspectRatio = naturalWidth / naturalHeight;
            var canvasWidth = containerData.width;
            var canvasHeight = containerData.height;
            if (containerData.height * aspectRatio > containerData.width) {
                if (viewMode === 3) canvasWidth = containerData.height * aspectRatio;
                else canvasHeight = containerData.width / aspectRatio;
            } else if (viewMode === 3) canvasHeight = containerData.width / aspectRatio;
            else canvasWidth = containerData.height * aspectRatio;
            var canvasData = {
                aspectRatio: aspectRatio,
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                width: canvasWidth,
                height: canvasHeight
            };
            this.canvasData = canvasData;
            this.limited = viewMode === 1 || viewMode === 2;
            this.limitCanvas(true, true);
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            canvasData.left = (containerData.width - canvasData.width) / 2;
            canvasData.top = (containerData.height - canvasData.height) / 2;
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            this.initialCanvasData = assign({}, canvasData);
        },
        limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var viewMode = options.viewMode;
            var aspectRatio = canvasData.aspectRatio;
            var cropped = this.cropped && cropBoxData;
            if (sizeLimited) {
                var minCanvasWidth = Number(options.minCanvasWidth) || 0;
                var minCanvasHeight = Number(options.minCanvasHeight) || 0;
                if (viewMode > 1) {
                    minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
                    minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
                    if (viewMode === 3) {
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                } else if (viewMode > 0) {
                    if (minCanvasWidth) minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
                    else if (minCanvasHeight) minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
                    else if (cropped) {
                        minCanvasWidth = cropBoxData.width;
                        minCanvasHeight = cropBoxData.height;
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                }
                var _getAdjustedSizes = getAdjustedSizes({
                    aspectRatio: aspectRatio,
                    width: minCanvasWidth,
                    height: minCanvasHeight
                });
                minCanvasWidth = _getAdjustedSizes.width;
                minCanvasHeight = _getAdjustedSizes.height;
                canvasData.minWidth = minCanvasWidth;
                canvasData.minHeight = minCanvasHeight;
                canvasData.maxWidth = Infinity;
                canvasData.maxHeight = Infinity;
            }
            if (positionLimited) {
                if (viewMode > (cropped ? 0 : 1)) {
                    var newCanvasLeft = containerData.width - canvasData.width;
                    var newCanvasTop = containerData.height - canvasData.height;
                    canvasData.minLeft = Math.min(0, newCanvasLeft);
                    canvasData.minTop = Math.min(0, newCanvasTop);
                    canvasData.maxLeft = Math.max(0, newCanvasLeft);
                    canvasData.maxTop = Math.max(0, newCanvasTop);
                    if (cropped && this.limited) {
                        canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
                        canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
                        canvasData.maxLeft = cropBoxData.left;
                        canvasData.maxTop = cropBoxData.top;
                        if (viewMode === 2) {
                            if (canvasData.width >= containerData.width) {
                                canvasData.minLeft = Math.min(0, newCanvasLeft);
                                canvasData.maxLeft = Math.max(0, newCanvasLeft);
                            }
                            if (canvasData.height >= containerData.height) {
                                canvasData.minTop = Math.min(0, newCanvasTop);
                                canvasData.maxTop = Math.max(0, newCanvasTop);
                            }
                        }
                    }
                } else {
                    canvasData.minLeft = -canvasData.width;
                    canvasData.minTop = -canvasData.height;
                    canvasData.maxLeft = containerData.width;
                    canvasData.maxTop = containerData.height;
                }
            }
        },
        renderCanvas: function renderCanvas(changed, transformed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            if (transformed) {
                var _getRotatedSizes = getRotatedSizes({
                    width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
                    height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
                    degree: imageData.rotate || 0
                }), naturalWidth = _getRotatedSizes.width, naturalHeight = _getRotatedSizes.height;
                var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
                var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
                canvasData.left -= (width - canvasData.width) / 2;
                canvasData.top -= (height - canvasData.height) / 2;
                canvasData.width = width;
                canvasData.height = height;
                canvasData.aspectRatio = naturalWidth / naturalHeight;
                canvasData.naturalWidth = naturalWidth;
                canvasData.naturalHeight = naturalHeight;
                this.limitCanvas(true, false);
            }
            if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) canvasData.left = canvasData.oldLeft;
            if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) canvasData.top = canvasData.oldTop;
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            this.limitCanvas(false, true);
            canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
            canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            setStyle(this.canvas, assign({
                width: canvasData.width,
                height: canvasData.height
            }, getTransforms({
                translateX: canvasData.left,
                translateY: canvasData.top
            })));
            this.renderImage(changed);
            if (this.cropped && this.limited) this.limitCropBox(true, true);
        },
        renderImage: function renderImage(changed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
            var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
            assign(imageData, {
                width: width,
                height: height,
                left: (canvasData.width - width) / 2,
                top: (canvasData.height - height) / 2
            });
            setStyle(this.image, assign({
                width: imageData.width,
                height: imageData.height
            }, getTransforms(assign({
                translateX: imageData.left,
                translateY: imageData.top
            }, imageData))));
            if (changed) this.output();
        },
        initCropBox: function initCropBox() {
            var options = this.options, canvasData = this.canvasData;
            var aspectRatio = options.aspectRatio || options.initialAspectRatio;
            var autoCropArea = Number(options.autoCropArea) || 0.8;
            var cropBoxData = {
                width: canvasData.width,
                height: canvasData.height
            };
            if (aspectRatio) {
                if (canvasData.height * aspectRatio > canvasData.width) cropBoxData.height = cropBoxData.width / aspectRatio;
                else cropBoxData.width = cropBoxData.height * aspectRatio;
            }
            this.cropBoxData = cropBoxData;
            this.limitCropBox(true, true);
            // Initialize auto crop area
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            // The width/height of auto crop area must large than "minWidth/Height"
            cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
            cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
            cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
            cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            this.initialCropBoxData = assign({}, cropBoxData);
        },
        limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, limited = this.limited;
            var aspectRatio = options.aspectRatio;
            if (sizeLimited) {
                var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
                var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
                var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
                var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;
                // The min/maxCropBoxWidth/Height must be less than container's width/height
                minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
                minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
                if (aspectRatio) {
                    if (minCropBoxWidth && minCropBoxHeight) {
                        if (minCropBoxHeight * aspectRatio > minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                        else minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    } else if (minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                    else if (minCropBoxHeight) minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
                    else maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
                }
                // The minWidth/Height must be less than maxWidth/Height
                cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
                cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
                cropBoxData.maxWidth = maxCropBoxWidth;
                cropBoxData.maxHeight = maxCropBoxHeight;
            }
            if (positionLimited) {
                if (limited) {
                    cropBoxData.minLeft = Math.max(0, canvasData.left);
                    cropBoxData.minTop = Math.max(0, canvasData.top);
                    cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
                    cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
                } else {
                    cropBoxData.minLeft = 0;
                    cropBoxData.minTop = 0;
                    cropBoxData.maxLeft = containerData.width - cropBoxData.width;
                    cropBoxData.maxTop = containerData.height - cropBoxData.height;
                }
            }
        },
        renderCropBox: function renderCropBox() {
            var options = this.options, containerData = this.containerData, cropBoxData = this.cropBoxData;
            if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) cropBoxData.left = cropBoxData.oldLeft;
            if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) cropBoxData.top = cropBoxData.oldTop;
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            this.limitCropBox(false, true);
            cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
            cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            if (options.movable && options.cropBoxMovable) // Turn to move the canvas when the crop box is equal to the container
            setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
            setStyle(this.cropBox, assign({
                width: cropBoxData.width,
                height: cropBoxData.height
            }, getTransforms({
                translateX: cropBoxData.left,
                translateY: cropBoxData.top
            })));
            if (this.cropped && this.limited) this.limitCanvas(true, true);
            if (!this.disabled) this.output();
        },
        output: function output() {
            this.preview();
            dispatchEvent(this.element, EVENT_CROP, this.getData());
        }
    };
    var preview = {
        initPreview: function initPreview() {
            var element = this.element, crossOrigin = this.crossOrigin;
            var preview = this.options.preview;
            var url = crossOrigin ? this.crossOriginUrl : this.url;
            var alt = element.alt || 'The image to preview';
            var image = document.createElement('img');
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = url;
            image.alt = alt;
            this.viewBox.appendChild(image);
            this.viewBoxImage = image;
            if (!preview) return;
            var previews = preview;
            if (typeof preview === 'string') previews = element.ownerDocument.querySelectorAll(preview);
            else if (preview.querySelector) previews = [
                preview
            ];
            this.previews = previews;
            forEach(previews, function(el) {
                var img = document.createElement('img');
                // Save the original size for recover
                setData(el, DATA_PREVIEW, {
                    width: el.offsetWidth,
                    height: el.offsetHeight,
                    html: el.innerHTML
                });
                if (crossOrigin) img.crossOrigin = crossOrigin;
                img.src = url;
                img.alt = alt;
                /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */ img.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"';
                el.innerHTML = '';
                el.appendChild(img);
            });
        },
        resetPreview: function resetPreview() {
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                setStyle(element, {
                    width: data.width,
                    height: data.height
                });
                element.innerHTML = data.html;
                removeData(element, DATA_PREVIEW);
            });
        },
        preview: function preview() {
            var imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var cropBoxWidth = cropBoxData.width, cropBoxHeight = cropBoxData.height;
            var width = imageData.width, height = imageData.height;
            var left = cropBoxData.left - canvasData.left - imageData.left;
            var top = cropBoxData.top - canvasData.top - imageData.top;
            if (!this.cropped || this.disabled) return;
            setStyle(this.viewBoxImage, assign({
                width: width,
                height: height
            }, getTransforms(assign({
                translateX: -left,
                translateY: -top
            }, imageData))));
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                var originalWidth = data.width;
                var originalHeight = data.height;
                var newWidth = originalWidth;
                var newHeight = originalHeight;
                var ratio = 1;
                if (cropBoxWidth) {
                    ratio = originalWidth / cropBoxWidth;
                    newHeight = cropBoxHeight * ratio;
                }
                if (cropBoxHeight && newHeight > originalHeight) {
                    ratio = originalHeight / cropBoxHeight;
                    newWidth = cropBoxWidth * ratio;
                    newHeight = originalHeight;
                }
                setStyle(element, {
                    width: newWidth,
                    height: newHeight
                });
                setStyle(element.getElementsByTagName('img')[0], assign({
                    width: width * ratio,
                    height: height * ratio
                }, getTransforms(assign({
                    translateX: -left * ratio,
                    translateY: -top * ratio
                }, imageData))));
            });
        }
    };
    var events = {
        bind: function bind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) addListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) addListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) addListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) addListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) addListener(element, EVENT_ZOOM, options.zoom);
            addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
            if (options.zoomable && options.zoomOnWheel) addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
            if (options.responsive) addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
        },
        unbind: function unbind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) removeListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) removeListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) removeListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) removeListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) removeListener(element, EVENT_ZOOM, options.zoom);
            removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
            if (options.zoomable && options.zoomOnWheel) removeListener(cropper, EVENT_WHEEL, this.onWheel, {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
            removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
            removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
            if (options.responsive) removeListener(window, EVENT_RESIZE, this.onResize);
        }
    };
    var handlers = {
        resize: function resize() {
            if (this.disabled) return;
            var options = this.options, container = this.container, containerData = this.containerData;
            var ratioX = container.offsetWidth / containerData.width;
            var ratioY = container.offsetHeight / containerData.height;
            var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;
            // Resize when width changed or height changed
            if (ratio !== 1) {
                var canvasData;
                var cropBoxData;
                if (options.restore) {
                    canvasData = this.getCanvasData();
                    cropBoxData = this.getCropBoxData();
                }
                this.render();
                if (options.restore) {
                    this.setCanvasData(forEach(canvasData, function(n, i) {
                        canvasData[i] = n * ratio;
                    }));
                    this.setCropBoxData(forEach(cropBoxData, function(n, i) {
                        cropBoxData[i] = n * ratio;
                    }));
                }
            }
        },
        dblclick: function dblclick() {
            if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) return;
            this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
        },
        wheel: function wheel(event) {
            var _this = this;
            var ratio = Number(this.options.wheelZoomRatio) || 0.1;
            var delta = 1;
            if (this.disabled) return;
            event.preventDefault();
            // Limit wheel speed to prevent zoom too fast (#21)
            if (this.wheeling) return;
            this.wheeling = true;
            setTimeout(function() {
                _this.wheeling = false;
            }, 50);
            if (event.deltaY) delta = event.deltaY > 0 ? 1 : -1;
            else if (event.wheelDelta) delta = -event.wheelDelta / 120;
            else if (event.detail) delta = event.detail > 0 ? 1 : -1;
            this.zoom(-delta * ratio, event);
        },
        cropStart: function cropStart(event) {
            var buttons = event.buttons, button = event.button;
            if (this.disabled || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && // No primary button (Usually the left button)
            (isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 || event.ctrlKey)) return;
            var options = this.options, pointers = this.pointers;
            var action;
            if (event.changedTouches) // Handle touch event
            forEach(event.changedTouches, function(touch) {
                pointers[touch.identifier] = getPointer(touch);
            });
            else // Handle mouse event and pointer event
            pointers[event.pointerId || 0] = getPointer(event);
            if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) action = ACTION_ZOOM;
            else action = getData(event.target, DATA_ACTION);
            if (!REGEXP_ACTIONS.test(action)) return;
            if (dispatchEvent(this.element, EVENT_CROP_START, {
                originalEvent: event,
                action: action
            }) === false) return;
            // This line is required for preventing page zooming in iOS browsers
            event.preventDefault();
            this.action = action;
            this.cropping = false;
            if (action === ACTION_CROP) {
                this.cropping = true;
                addClass(this.dragBox, CLASS_MODAL);
            }
        },
        cropMove: function cropMove(event) {
            var action = this.action;
            if (this.disabled || !action) return;
            var pointers = this.pointers;
            event.preventDefault();
            if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
                originalEvent: event,
                action: action
            }) === false) return;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                // The first parameter should not be undefined (#432)
                assign(pointers[touch.identifier] || {}, getPointer(touch, true));
            });
            else assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
            this.change(event);
        },
        cropEnd: function cropEnd(event) {
            if (this.disabled) return;
            var action = this.action, pointers = this.pointers;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                delete pointers[touch.identifier];
            });
            else delete pointers[event.pointerId || 0];
            if (!action) return;
            event.preventDefault();
            if (!Object.keys(pointers).length) this.action = '';
            if (this.cropping) {
                this.cropping = false;
                toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
            }
            dispatchEvent(this.element, EVENT_CROP_END, {
                originalEvent: event,
                action: action
            });
        }
    };
    var change = {
        change: function change(event) {
            var options = this.options, canvasData = this.canvasData, containerData = this.containerData, cropBoxData = this.cropBoxData, pointers = this.pointers;
            var action = this.action;
            var aspectRatio = options.aspectRatio;
            var left = cropBoxData.left, top = cropBoxData.top, width = cropBoxData.width, height = cropBoxData.height;
            var right = left + width;
            var bottom = top + height;
            var minLeft = 0;
            var minTop = 0;
            var maxWidth = containerData.width;
            var maxHeight = containerData.height;
            var renderable = true;
            var offset;
            // Locking aspect ratio in "free mode" by holding shift key
            if (!aspectRatio && event.shiftKey) aspectRatio = width && height ? width / height : 1;
            if (this.limited) {
                minLeft = cropBoxData.minLeft;
                minTop = cropBoxData.minTop;
                maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
                maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
            }
            var pointer = pointers[Object.keys(pointers)[0]];
            var range = {
                x: pointer.endX - pointer.startX,
                y: pointer.endY - pointer.startY
            };
            var check = function check(side) {
                switch(side){
                    case ACTION_EAST:
                        if (right + range.x > maxWidth) range.x = maxWidth - right;
                        break;
                    case ACTION_WEST:
                        if (left + range.x < minLeft) range.x = minLeft - left;
                        break;
                    case ACTION_NORTH:
                        if (top + range.y < minTop) range.y = minTop - top;
                        break;
                    case ACTION_SOUTH:
                        if (bottom + range.y > maxHeight) range.y = maxHeight - bottom;
                        break;
                }
            };
            switch(action){
                // Move crop box
                case ACTION_ALL:
                    left += range.x;
                    top += range.y;
                    break;
                // Resize crop box
                case ACTION_EAST:
                    if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_EAST);
                    width += range.x;
                    if (width < 0) {
                        action = ACTION_WEST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_NORTH:
                    if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_NORTH);
                    height -= range.y;
                    top += range.y;
                    if (height < 0) {
                        action = ACTION_SOUTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_WEST:
                    if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_WEST);
                    width -= range.x;
                    left += range.x;
                    if (width < 0) {
                        action = ACTION_EAST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_SOUTH:
                    if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_SOUTH);
                    height += range.y;
                    if (height < 0) {
                        action = ACTION_NORTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_NORTH_EAST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else width += range.x;
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_NORTH_WEST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                        left += cropBoxData.width - width;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_WEST:
                    if (aspectRatio) {
                        if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_WEST);
                        width -= range.x;
                        left += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_EAST:
                    if (aspectRatio) {
                        if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_EAST);
                        width += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else width += range.x;
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                // Move canvas
                case ACTION_MOVE:
                    this.move(range.x, range.y);
                    renderable = false;
                    break;
                // Zoom canvas
                case ACTION_ZOOM:
                    this.zoom(getMaxZoomRatio(pointers), event);
                    renderable = false;
                    break;
                // Create crop box
                case ACTION_CROP:
                    if (!range.x || !range.y) {
                        renderable = false;
                        break;
                    }
                    offset = getOffset(this.cropper);
                    left = pointer.startX - offset.left;
                    top = pointer.startY - offset.top;
                    width = cropBoxData.minWidth;
                    height = cropBoxData.minHeight;
                    if (range.x > 0) action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
                    else if (range.x < 0) {
                        left -= width;
                        action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
                    }
                    if (range.y < 0) top -= height;
                    // Show the crop box if is hidden
                    if (!this.cropped) {
                        removeClass(this.cropBox, CLASS_HIDDEN);
                        this.cropped = true;
                        if (this.limited) this.limitCropBox(true, true);
                    }
                    break;
            }
            if (renderable) {
                cropBoxData.width = width;
                cropBoxData.height = height;
                cropBoxData.left = left;
                cropBoxData.top = top;
                this.action = action;
                this.renderCropBox();
            }
            // Override
            forEach(pointers, function(p) {
                p.startX = p.endX;
                p.startY = p.endY;
            });
        }
    };
    var methods = {
        // Show the crop box manually
        crop: function crop() {
            if (this.ready && !this.cropped && !this.disabled) {
                this.cropped = true;
                this.limitCropBox(true, true);
                if (this.options.modal) addClass(this.dragBox, CLASS_MODAL);
                removeClass(this.cropBox, CLASS_HIDDEN);
                this.setCropBoxData(this.initialCropBoxData);
            }
            return this;
        },
        // Reset the image and crop box to their initial states
        reset: function reset() {
            if (this.ready && !this.disabled) {
                this.imageData = assign({}, this.initialImageData);
                this.canvasData = assign({}, this.initialCanvasData);
                this.cropBoxData = assign({}, this.initialCropBoxData);
                this.renderCanvas();
                if (this.cropped) this.renderCropBox();
            }
            return this;
        },
        // Clear the crop box
        clear: function clear() {
            if (this.cropped && !this.disabled) {
                assign(this.cropBoxData, {
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0
                });
                this.cropped = false;
                this.renderCropBox();
                this.limitCanvas(true, true);
                // Render canvas after crop box rendered
                this.renderCanvas();
                removeClass(this.dragBox, CLASS_MODAL);
                addClass(this.cropBox, CLASS_HIDDEN);
            }
            return this;
        },
        /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */ replace: function replace(url) {
            var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (!this.disabled && url) {
                if (this.isImg) this.element.src = url;
                if (hasSameSize) {
                    this.url = url;
                    this.image.src = url;
                    if (this.ready) {
                        this.viewBoxImage.src = url;
                        forEach(this.previews, function(element) {
                            element.getElementsByTagName('img')[0].src = url;
                        });
                    }
                } else {
                    if (this.isImg) this.replaced = true;
                    this.options.data = null;
                    this.uncreate();
                    this.load(url);
                }
            }
            return this;
        },
        // Enable (unfreeze) the cropper
        enable: function enable() {
            if (this.ready && this.disabled) {
                this.disabled = false;
                removeClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        // Disable (freeze) the cropper
        disable: function disable() {
            if (this.ready && !this.disabled) {
                this.disabled = true;
                addClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */ destroy: function destroy() {
            var element = this.element;
            if (!element[NAMESPACE]) return this;
            element[NAMESPACE] = undefined;
            if (this.isImg && this.replaced) element.src = this.originalUrl;
            this.uncreate();
            return this;
        },
        /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */ move: function move(offsetX) {
            var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
            var _this$canvasData = this.canvasData, left = _this$canvasData.left, top = _this$canvasData.top;
            return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
        },
        /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */ moveTo: function moveTo(x) {
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
            var canvasData = this.canvasData;
            var changed = false;
            x = Number(x);
            y = Number(y);
            if (this.ready && !this.disabled && this.options.movable) {
                if (isNumber(x)) {
                    canvasData.left = x;
                    changed = true;
                }
                if (isNumber(y)) {
                    canvasData.top = y;
                    changed = true;
                }
                if (changed) this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoom: function zoom(ratio, _originalEvent) {
            var canvasData = this.canvasData;
            ratio = Number(ratio);
            if (ratio < 0) ratio = 1 / (1 - ratio);
            else ratio = 1 + ratio;
            return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
        },
        /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
            var options = this.options, canvasData = this.canvasData;
            var width = canvasData.width, height = canvasData.height, naturalWidth = canvasData.naturalWidth, naturalHeight = canvasData.naturalHeight;
            ratio = Number(ratio);
            if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
                var newWidth = naturalWidth * ratio;
                var newHeight = naturalHeight * ratio;
                if (dispatchEvent(this.element, EVENT_ZOOM, {
                    ratio: ratio,
                    oldRatio: width / naturalWidth,
                    originalEvent: _originalEvent
                }) === false) return this;
                if (_originalEvent) {
                    var pointers = this.pointers;
                    var offset = getOffset(this.cropper);
                    var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
                        pageX: _originalEvent.pageX,
                        pageY: _originalEvent.pageY
                    };
                    // Zoom from the triggering point of the event
                    canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
                } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
                    canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
                } else {
                    // Zoom from the center of the canvas
                    canvasData.left -= (newWidth - width) / 2;
                    canvasData.top -= (newHeight - height) / 2;
                }
                canvasData.width = newWidth;
                canvasData.height = newHeight;
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotate: function rotate(degree) {
            return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
        },
        /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotateTo: function rotateTo(degree) {
            degree = Number(degree);
            if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
                this.imageData.rotate = degree % 360;
                this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */ scaleX: function scaleX(_scaleX) {
            var scaleY = this.imageData.scaleY;
            return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
        },
        /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scaleY: function scaleY(_scaleY) {
            var scaleX = this.imageData.scaleX;
            return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
        },
        /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scale: function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
            var imageData = this.imageData;
            var transformed = false;
            scaleX = Number(scaleX);
            scaleY = Number(scaleY);
            if (this.ready && !this.disabled && this.options.scalable) {
                if (isNumber(scaleX)) {
                    imageData.scaleX = scaleX;
                    transformed = true;
                }
                if (isNumber(scaleY)) {
                    imageData.scaleY = scaleY;
                    transformed = true;
                }
                if (transformed) this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */ getData: function getData() {
            var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) {
                data = {
                    x: cropBoxData.left - canvasData.left,
                    y: cropBoxData.top - canvasData.top,
                    width: cropBoxData.width,
                    height: cropBoxData.height
                };
                var ratio = imageData.width / imageData.naturalWidth;
                forEach(data, function(n, i) {
                    data[i] = n / ratio;
                });
                if (rounded) {
                    // In case rounding off leads to extra 1px in right or bottom border
                    // we should round the top-left corner and the dimension (#343).
                    var bottom = Math.round(data.y + data.height);
                    var right = Math.round(data.x + data.width);
                    data.x = Math.round(data.x);
                    data.y = Math.round(data.y);
                    data.width = right - data.x;
                    data.height = bottom - data.y;
                }
            } else data = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            if (options.rotatable) data.rotate = imageData.rotate || 0;
            if (options.scalable) {
                data.scaleX = imageData.scaleX || 1;
                data.scaleY = imageData.scaleY || 1;
            }
            return data;
        },
        /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */ setData: function setData(data) {
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData;
            var cropBoxData = {};
            if (this.ready && !this.disabled && isPlainObject(data)) {
                var transformed = false;
                if (options.rotatable) {
                    if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
                        imageData.rotate = data.rotate;
                        transformed = true;
                    }
                }
                if (options.scalable) {
                    if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
                        imageData.scaleX = data.scaleX;
                        transformed = true;
                    }
                    if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
                        imageData.scaleY = data.scaleY;
                        transformed = true;
                    }
                }
                if (transformed) this.renderCanvas(true, true);
                var ratio = imageData.width / imageData.naturalWidth;
                if (isNumber(data.x)) cropBoxData.left = data.x * ratio + canvasData.left;
                if (isNumber(data.y)) cropBoxData.top = data.y * ratio + canvasData.top;
                if (isNumber(data.width)) cropBoxData.width = data.width * ratio;
                if (isNumber(data.height)) cropBoxData.height = data.height * ratio;
                this.setCropBoxData(cropBoxData);
            }
            return this;
        },
        /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */ getContainerData: function getContainerData() {
            return this.ready ? assign({}, this.containerData) : {};
        },
        /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */ getImageData: function getImageData() {
            return this.sized ? assign({}, this.imageData) : {};
        },
        /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */ getCanvasData: function getCanvasData() {
            var canvasData = this.canvasData;
            var data = {};
            if (this.ready) forEach([
                'left',
                'top',
                'width',
                'height',
                'naturalWidth',
                'naturalHeight'
            ], function(n) {
                data[n] = canvasData[n];
            });
            return data;
        },
        /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */ setCanvasData: function setCanvasData(data) {
            var canvasData = this.canvasData;
            var aspectRatio = canvasData.aspectRatio;
            if (this.ready && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) canvasData.left = data.left;
                if (isNumber(data.top)) canvasData.top = data.top;
                if (isNumber(data.width)) {
                    canvasData.width = data.width;
                    canvasData.height = data.width / aspectRatio;
                } else if (isNumber(data.height)) {
                    canvasData.height = data.height;
                    canvasData.width = data.height * aspectRatio;
                }
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */ getCropBoxData: function getCropBoxData() {
            var cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) data = {
                left: cropBoxData.left,
                top: cropBoxData.top,
                width: cropBoxData.width,
                height: cropBoxData.height
            };
            return data || {};
        },
        /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */ setCropBoxData: function setCropBoxData(data) {
            var cropBoxData = this.cropBoxData;
            var aspectRatio = this.options.aspectRatio;
            var widthChanged;
            var heightChanged;
            if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) cropBoxData.left = data.left;
                if (isNumber(data.top)) cropBoxData.top = data.top;
                if (isNumber(data.width) && data.width !== cropBoxData.width) {
                    widthChanged = true;
                    cropBoxData.width = data.width;
                }
                if (isNumber(data.height) && data.height !== cropBoxData.height) {
                    heightChanged = true;
                    cropBoxData.height = data.height;
                }
                if (aspectRatio) {
                    if (widthChanged) cropBoxData.height = cropBoxData.width / aspectRatio;
                    else if (heightChanged) cropBoxData.width = cropBoxData.height * aspectRatio;
                }
                this.renderCropBox();
            }
            return this;
        },
        /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */ getCroppedCanvas: function getCroppedCanvas() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (!this.ready || !window.HTMLCanvasElement) return null;
            var canvasData = this.canvasData;
            var source = getSourceCanvas(this.image, this.imageData, canvasData, options);
            // Returns the source canvas if it is not cropped.
            if (!this.cropped) return source;
            var _this$getData = this.getData(options.rounded), initialX = _this$getData.x, initialY = _this$getData.y, initialWidth = _this$getData.width, initialHeight = _this$getData.height;
            var ratio = source.width / Math.floor(canvasData.naturalWidth);
            if (ratio !== 1) {
                initialX *= ratio;
                initialY *= ratio;
                initialWidth *= ratio;
                initialHeight *= ratio;
            }
            var aspectRatio = initialWidth / initialHeight;
            var maxSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.maxWidth || Infinity,
                height: options.maxHeight || Infinity
            });
            var minSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.minWidth || 0,
                height: options.minHeight || 0
            }, 'cover');
            var _getAdjustedSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.width || (ratio !== 1 ? source.width : initialWidth),
                height: options.height || (ratio !== 1 ? source.height : initialHeight)
            }), width = _getAdjustedSizes.width, height = _getAdjustedSizes.height;
            width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
            height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            canvas.width = normalizeDecimalNumber(width);
            canvas.height = normalizeDecimalNumber(height);
            context.fillStyle = options.fillColor || 'transparent';
            context.fillRect(0, 0, width, height);
            var _options$imageSmoothi = options.imageSmoothingEnabled, imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi, imageSmoothingQuality = options.imageSmoothingQuality;
            context.imageSmoothingEnabled = imageSmoothingEnabled;
            if (imageSmoothingQuality) context.imageSmoothingQuality = imageSmoothingQuality;
            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
            var sourceWidth = source.width;
            var sourceHeight = source.height;
            // Source canvas parameters
            var srcX = initialX;
            var srcY = initialY;
            var srcWidth;
            var srcHeight;
            // Destination canvas parameters
            var dstX;
            var dstY;
            var dstWidth;
            var dstHeight;
            if (srcX <= -initialWidth || srcX > sourceWidth) {
                srcX = 0;
                srcWidth = 0;
                dstX = 0;
                dstWidth = 0;
            } else if (srcX <= 0) {
                dstX = -srcX;
                srcX = 0;
                srcWidth = Math.min(sourceWidth, initialWidth + srcX);
                dstWidth = srcWidth;
            } else if (srcX <= sourceWidth) {
                dstX = 0;
                srcWidth = Math.min(initialWidth, sourceWidth - srcX);
                dstWidth = srcWidth;
            }
            if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
                srcY = 0;
                srcHeight = 0;
                dstY = 0;
                dstHeight = 0;
            } else if (srcY <= 0) {
                dstY = -srcY;
                srcY = 0;
                srcHeight = Math.min(sourceHeight, initialHeight + srcY);
                dstHeight = srcHeight;
            } else if (srcY <= sourceHeight) {
                dstY = 0;
                srcHeight = Math.min(initialHeight, sourceHeight - srcY);
                dstHeight = srcHeight;
            }
            var params = [
                srcX,
                srcY,
                srcWidth,
                srcHeight
            ];
            // Avoid "IndexSizeError"
            if (dstWidth > 0 && dstHeight > 0) {
                var scale = width / initialWidth;
                params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
            }
            // All the numerical parameters should be integer for `drawImage`
            // https://github.com/fengyuanchen/cropper/issues/476
            context.drawImage.apply(context, [
                source
            ].concat(_toConsumableArray(params.map(function(param) {
                return Math.floor(normalizeDecimalNumber(param));
            }))));
            return canvas;
        },
        /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */ setAspectRatio: function setAspectRatio(aspectRatio) {
            var options = this.options;
            if (!this.disabled && !isUndefined(aspectRatio)) {
                // 0 -> NaN
                options.aspectRatio = Math.max(0, aspectRatio) || NaN;
                if (this.ready) {
                    this.initCropBox();
                    if (this.cropped) this.renderCropBox();
                }
            }
            return this;
        },
        /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */ setDragMode: function setDragMode(mode) {
            var options = this.options, dragBox = this.dragBox, face = this.face;
            if (this.ready && !this.disabled) {
                var croppable = mode === DRAG_MODE_CROP;
                var movable = options.movable && mode === DRAG_MODE_MOVE;
                mode = croppable || movable ? mode : DRAG_MODE_NONE;
                options.dragMode = mode;
                setData(dragBox, DATA_ACTION, mode);
                toggleClass(dragBox, CLASS_CROP, croppable);
                toggleClass(dragBox, CLASS_MOVE, movable);
                if (!options.cropBoxMovable) {
                    // Sync drag mode to crop box when it is not movable
                    setData(face, DATA_ACTION, mode);
                    toggleClass(face, CLASS_CROP, croppable);
                    toggleClass(face, CLASS_MOVE, movable);
                }
            }
            return this;
        }
    };
    var AnotherCropper = WINDOW.Cropper;
    var Cropper = /*#__PURE__*/ function() {
        /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */ function Cropper(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, Cropper);
            if (!element || !REGEXP_TAG_NAME.test(element.tagName)) throw new Error('The first argument is required and must be an <img> or <canvas> element.');
            this.element = element;
            this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
            this.cropped = false;
            this.disabled = false;
            this.pointers = {};
            this.ready = false;
            this.reloading = false;
            this.replaced = false;
            this.sized = false;
            this.sizing = false;
            this.init();
        }
        return _createClass(Cropper, [
            {
                key: "init",
                value: function init() {
                    var element = this.element;
                    var tagName = element.tagName.toLowerCase();
                    var url;
                    if (element[NAMESPACE]) return;
                    element[NAMESPACE] = this;
                    if (tagName === 'img') {
                        this.isImg = true;
                        // e.g.: "img/picture.jpg"
                        url = element.getAttribute('src') || '';
                        this.originalUrl = url;
                        // Stop when it's a blank image
                        if (!url) return;
                        // e.g.: "https://example.com/img/picture.jpg"
                        url = element.src;
                    } else if (tagName === 'canvas' && window.HTMLCanvasElement) url = element.toDataURL();
                    this.load(url);
                }
            },
            {
                key: "load",
                value: function load(url) {
                    var _this = this;
                    if (!url) return;
                    this.url = url;
                    this.imageData = {};
                    var element = this.element, options = this.options;
                    if (!options.rotatable && !options.scalable) options.checkOrientation = false;
                    // Only IE10+ supports Typed Arrays
                    if (!options.checkOrientation || !window.ArrayBuffer) {
                        this.clone();
                        return;
                    }
                    // Detect the mime type of the image directly if it is a Data URL
                    if (REGEXP_DATA_URL.test(url)) {
                        // Read ArrayBuffer from Data URL of JPEG images directly for better performance
                        if (REGEXP_DATA_URL_JPEG.test(url)) this.read(dataURLToArrayBuffer(url));
                        else // Only a JPEG image may contains Exif Orientation information,
                        // the rest types of Data URLs are not necessary to check orientation at all.
                        this.clone();
                        return;
                    }
                    // 1. Detect the mime type of the image by a XMLHttpRequest.
                    // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
                    var xhr = new XMLHttpRequest();
                    var clone = this.clone.bind(this);
                    this.reloading = true;
                    this.xhr = xhr;
                    // 1. Cross origin requests are only supported for protocol schemes:
                    // http, https, data, chrome, chrome-extension.
                    // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
                    // in some browsers as IE11 and Safari.
                    xhr.onabort = clone;
                    xhr.onerror = clone;
                    xhr.ontimeout = clone;
                    xhr.onprogress = function() {
                        // Abort the request directly if it not a JPEG image for better performance
                        if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) xhr.abort();
                    };
                    xhr.onload = function() {
                        _this.read(xhr.response);
                    };
                    xhr.onloadend = function() {
                        _this.reloading = false;
                        _this.xhr = null;
                    };
                    // Bust cache when there is a "crossOrigin" property to avoid browser cache error
                    if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) url = addTimestamp(url);
                    // The third parameter is required for avoiding side-effect (#682)
                    xhr.open('GET', url, true);
                    xhr.responseType = 'arraybuffer';
                    xhr.withCredentials = element.crossOrigin === 'use-credentials';
                    xhr.send();
                }
            },
            {
                key: "read",
                value: function read(arrayBuffer) {
                    var options = this.options, imageData = this.imageData;
                    // Reset the orientation value to its default value 1
                    // as some iOS browsers will render image with its orientation
                    var orientation = resetAndGetOrientation(arrayBuffer);
                    var rotate = 0;
                    var scaleX = 1;
                    var scaleY = 1;
                    if (orientation > 1) {
                        // Generate a new URL which has the default orientation value
                        this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
                        var _parseOrientation = parseOrientation(orientation);
                        rotate = _parseOrientation.rotate;
                        scaleX = _parseOrientation.scaleX;
                        scaleY = _parseOrientation.scaleY;
                    }
                    if (options.rotatable) imageData.rotate = rotate;
                    if (options.scalable) {
                        imageData.scaleX = scaleX;
                        imageData.scaleY = scaleY;
                    }
                    this.clone();
                }
            },
            {
                key: "clone",
                value: function clone() {
                    var element = this.element, url = this.url;
                    var crossOrigin = element.crossOrigin;
                    var crossOriginUrl = url;
                    if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
                        if (!crossOrigin) crossOrigin = 'anonymous';
                        // Bust cache when there is not a "crossOrigin" property (#519)
                        crossOriginUrl = addTimestamp(url);
                    }
                    this.crossOrigin = crossOrigin;
                    this.crossOriginUrl = crossOriginUrl;
                    var image = document.createElement('img');
                    if (crossOrigin) image.crossOrigin = crossOrigin;
                    image.src = crossOriginUrl || url;
                    image.alt = element.alt || 'The image to crop';
                    this.image = image;
                    image.onload = this.start.bind(this);
                    image.onerror = this.stop.bind(this);
                    addClass(image, CLASS_HIDE);
                    element.parentNode.insertBefore(image, element.nextSibling);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this2 = this;
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    this.sizing = true;
                    // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
                    var done = function done(naturalWidth, naturalHeight) {
                        assign(_this2.imageData, {
                            naturalWidth: naturalWidth,
                            naturalHeight: naturalHeight,
                            aspectRatio: naturalWidth / naturalHeight
                        });
                        _this2.initialImageData = assign({}, _this2.imageData);
                        _this2.sizing = false;
                        _this2.sized = true;
                        _this2.build();
                    };
                    // Most modern browsers (excepts iOS WebKit)
                    if (image.naturalWidth && !isIOSWebKit) {
                        done(image.naturalWidth, image.naturalHeight);
                        return;
                    }
                    var sizingImage = document.createElement('img');
                    var body = document.body || document.documentElement;
                    this.sizingImage = sizingImage;
                    sizingImage.onload = function() {
                        done(sizingImage.width, sizingImage.height);
                        if (!isIOSWebKit) body.removeChild(sizingImage);
                    };
                    sizingImage.src = image.src;
                    // iOS WebKit will convert the image automatically
                    // with its orientation once append it into DOM (#279)
                    if (!isIOSWebKit) {
                        sizingImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
                        body.appendChild(sizingImage);
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    image.parentNode.removeChild(image);
                    this.image = null;
                }
            },
            {
                key: "build",
                value: function build() {
                    if (!this.sized || this.ready) return;
                    var element = this.element, options = this.options, image = this.image;
                    // Create cropper elements
                    var container = element.parentNode;
                    var template = document.createElement('div');
                    template.innerHTML = TEMPLATE;
                    var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
                    var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
                    var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
                    var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
                    var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
                    this.container = container;
                    this.cropper = cropper;
                    this.canvas = canvas;
                    this.dragBox = dragBox;
                    this.cropBox = cropBox;
                    this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
                    this.face = face;
                    canvas.appendChild(image);
                    // Hide the original image
                    addClass(element, CLASS_HIDDEN);
                    // Inserts the cropper after to the current image
                    container.insertBefore(cropper, element.nextSibling);
                    // Show the hidden image
                    removeClass(image, CLASS_HIDE);
                    this.initPreview();
                    this.bind();
                    options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
                    options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
                    options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
                    addClass(cropBox, CLASS_HIDDEN);
                    if (!options.guides) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
                    if (!options.center) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
                    if (options.background) addClass(cropper, "".concat(NAMESPACE, "-bg"));
                    if (!options.highlight) addClass(face, CLASS_INVISIBLE);
                    if (options.cropBoxMovable) {
                        addClass(face, CLASS_MOVE);
                        setData(face, DATA_ACTION, ACTION_ALL);
                    }
                    if (!options.cropBoxResizable) {
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
                    }
                    this.render();
                    this.ready = true;
                    this.setDragMode(options.dragMode);
                    if (options.autoCrop) this.crop();
                    this.setData(options.data);
                    if (isFunction(options.ready)) addListener(element, EVENT_READY, options.ready, {
                        once: true
                    });
                    dispatchEvent(element, EVENT_READY);
                }
            },
            {
                key: "unbuild",
                value: function unbuild() {
                    if (!this.ready) return;
                    this.ready = false;
                    this.unbind();
                    this.resetPreview();
                    var parentNode = this.cropper.parentNode;
                    if (parentNode) parentNode.removeChild(this.cropper);
                    removeClass(this.element, CLASS_HIDDEN);
                }
            },
            {
                key: "uncreate",
                value: function uncreate() {
                    if (this.ready) {
                        this.unbuild();
                        this.ready = false;
                        this.cropped = false;
                    } else if (this.sizing) {
                        this.sizingImage.onload = null;
                        this.sizing = false;
                        this.sized = false;
                    } else if (this.reloading) {
                        this.xhr.onabort = null;
                        this.xhr.abort();
                    } else if (this.image) this.stop();
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Cropper = AnotherCropper;
                    return Cropper;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    assign(DEFAULTS, isPlainObject(options) && options);
                }
            }
        ]);
    }();
    assign(Cropper.prototype, render, preview, events, handlers, change, methods);
    return Cropper;
});

});

parcelRegister("doQrw", function(module, exports) {
module.exports = new URL("upLoading.0f7b6c78.svg", import.meta.url).toString();

});

parcelRegister("da8Ul", function(module, exports) {
module.exports = new URL("green_tick.e074e19b.svg", import.meta.url).toString();

});

parcelRegister("ipdtS", function(module, exports) {
module.exports = new URL("payment-header.c9bbf3ab.png", import.meta.url).toString();

});

parcelRegister("fumV1", function(module, exports) {
module.exports = new URL("visa.f60ee3b8.png", import.meta.url).toString();

});

parcelRegister("O2jJL", function(module, exports) {
module.exports = new URL("approved-partner-header.00854dc3.png", import.meta.url).toString();

});

parcelRegister("l1H8g", function(module, exports) {
module.exports = new URL("left-person.84498594.png", import.meta.url).toString();

});

parcelRegister("lApJY", function(module, exports) {
module.exports = new URL("left-angle-arrow.13323063.png", import.meta.url).toString();

});

parcelRegister("5g3Sv", function(module, exports) {
module.exports = new URL("speed-img.d16c8def.png", import.meta.url).toString();

});

parcelRegister("5k6Ll", function(module, exports) {
module.exports = new URL("benifts-1.8971431d.png", import.meta.url).toString();

});

parcelRegister("82L9j", function(module, exports) {
module.exports = new URL("benifts-2.cb00222f.png", import.meta.url).toString();

});

parcelRegister("8F1Ms", function(module, exports) {
module.exports = new URL("benifts-3.edaa2a00.png", import.meta.url).toString();

});

parcelRegister("jTIek", function(module, exports) {
module.exports = new URL("benifts-4.10a61233.png", import.meta.url).toString();

});

parcelRegister("cRc7X", function(module, exports) {
module.exports = new URL("benifts-5.38e60243.png", import.meta.url).toString();

});

parcelRegister("4YzyZ", function(module, exports) {
module.exports = new URL("benifts-6.2ad8dd63.png", import.meta.url).toString();

});

parcelRegister("eHMrP", function(module, exports) {
module.exports = new URL("modle-title.e7d66f2d.png", import.meta.url).toString();

});

parcelRegister("b93sb", function(module, exports) {
module.exports = new URL("chatgpt-logo-low.7838e854.png", import.meta.url).toString();

});

parcelRegister("lmMaG", function(module, exports) {
module.exports = new URL("gemini-logo-low.94ff33bd.png", import.meta.url).toString();

});

parcelRegister("4vGhj", function(module, exports) {
module.exports = new URL("logo-icon.f2975a85.svg", import.meta.url).toString();

});

parcelRegister("24u8s", function(module, exports) {
module.exports = new URL("info-icon.c6f74d96.svg", import.meta.url).toString();

});

parcelRegister("kt5GL", function(module, exports) {
module.exports = new URL("delete.6c3ff100.svg", import.meta.url).toString();

});

parcelRegister("4UXHD", function(module, exports) {

var $abgWr = parcelRequire("abgWr");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $394ab417e9bd75cc$var$isEqual(value, other) {
    return $abgWr(value, other);
}
module.exports = $394ab417e9bd75cc$var$isEqual;

});
parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, 'Map');
module.exports = $19b02faa57603249$var$Map;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});

parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});



parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype['delete'] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $c8dKl,
        'map': new ($2cJKd || $iYOpJ),
        'string': new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, 'create');
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});

parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});
parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});


parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});


parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});
parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});




parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, 'DataView');
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, 'Promise');
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, 'Set');
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, 'WeakMap');
module.exports = $aedce50092a1e6a6$var$WeakMap;

});





parcelRegister("jVfJ9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e80f8a4a1c6d6220$require$Buffer = $6ZWSX.Buffer;
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 109);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var format_1 = __webpack_require__(18);
            var leaf_1 = __webpack_require__(19);
            var scroll_1 = __webpack_require__(45);
            var inline_1 = __webpack_require__(46);
            var block_1 = __webpack_require__(47);
            var embed_1 = __webpack_require__(48);
            var text_1 = __webpack_require__(49);
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var store_1 = __webpack_require__(31);
            var Registry = __webpack_require__(1);
            var Parchment = {
                Scope: Registry.Scope,
                create: Registry.create,
                find: Registry.find,
                query: Registry.query,
                register: Registry.register,
                Container: container_1.default,
                Format: format_1.default,
                Leaf: leaf_1.default,
                Embed: embed_1.default,
                Scroll: scroll_1.default,
                Block: block_1.default,
                Inline: inline_1.default,
                Text: text_1.default,
                Attributor: {
                    Attribute: attributor_1.default,
                    Class: class_1.default,
                    Style: style_1.default,
                    Store: store_1.default
                }
            };
            exports.default = Parchment;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var ParchmentError = /** @class */ function(_super) {
                __extends(ParchmentError, _super);
                function ParchmentError(message) {
                    var _this = this;
                    message = '[Parchment] ' + message;
                    _this = _super.call(this, message) || this;
                    _this.message = message;
                    _this.name = _this.constructor.name;
                    return _this;
                }
                return ParchmentError;
            }(Error);
            exports.ParchmentError = ParchmentError;
            var attributes = {};
            var classes = {};
            var tags = {};
            var types = {};
            exports.DATA_KEY = '__blot';
            var Scope;
            (function(Scope) {
                Scope[Scope["TYPE"] = 3] = "TYPE";
                Scope[Scope["LEVEL"] = 12] = "LEVEL";
                Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
                Scope[Scope["BLOT"] = 14] = "BLOT";
                Scope[Scope["INLINE"] = 7] = "INLINE";
                Scope[Scope["BLOCK"] = 11] = "BLOCK";
                Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
                Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
                Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
                Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
                Scope[Scope["ANY"] = 15] = "ANY";
            })(Scope = exports.Scope || (exports.Scope = {}));
            function create(input, value) {
                var match = query(input);
                if (match == null) throw new ParchmentError("Unable to create " + input + " blot");
                var BlotClass = match;
                var node = // @ts-ignore
                input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
                return new BlotClass(node, value);
            }
            exports.create = create;
            function find(node, bubble) {
                if (bubble === void 0) bubble = false;
                if (node == null) return null;
                // @ts-ignore
                if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
                if (bubble) return find(node.parentNode, bubble);
                return null;
            }
            exports.find = find;
            function query(query, scope) {
                if (scope === void 0) scope = Scope.ANY;
                var match;
                if (typeof query === 'string') match = types[query] || attributes[query];
                else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) match = types['text'];
                else if (typeof query === 'number') {
                    if (query & Scope.LEVEL & Scope.BLOCK) match = types['block'];
                    else if (query & Scope.LEVEL & Scope.INLINE) match = types['inline'];
                } else if (query instanceof HTMLElement) {
                    var names = (query.getAttribute('class') || '').split(/\s+/);
                    for(var i in names){
                        match = classes[names[i]];
                        if (match) break;
                    }
                    match = match || tags[query.tagName];
                }
                if (match == null) return null;
                // @ts-ignore
                if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
                return null;
            }
            exports.query = query;
            function register() {
                var Definitions = [];
                for(var _i = 0; _i < arguments.length; _i++)Definitions[_i] = arguments[_i];
                if (Definitions.length > 1) return Definitions.map(function(d) {
                    return register(d);
                });
                var Definition = Definitions[0];
                if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') throw new ParchmentError('Invalid definition');
                else if (Definition.blotName === 'abstract') throw new ParchmentError('Cannot register abstract class');
                types[Definition.blotName || Definition.attrName] = Definition;
                if (typeof Definition.keyName === 'string') attributes[Definition.keyName] = Definition;
                else {
                    if (Definition.className != null) classes[Definition.className] = Definition;
                    if (Definition.tagName != null) {
                        if (Array.isArray(Definition.tagName)) Definition.tagName = Definition.tagName.map(function(tagName) {
                            return tagName.toUpperCase();
                        });
                        else Definition.tagName = Definition.tagName.toUpperCase();
                        var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [
                            Definition.tagName
                        ];
                        tagNames.forEach(function(tag) {
                            if (tags[tag] == null || Definition.className == null) tags[tag] = Definition;
                        });
                    }
                }
                return Definition;
            }
            exports.register = register;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            var diff = __webpack_require__(51);
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var op = __webpack_require__(20);
            var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
            var Delta = function(ops) {
                // Assume we are given a well formed ops
                if (Array.isArray(ops)) this.ops = ops;
                else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
                else this.ops = [];
            };
            Delta.prototype.insert = function(text, attributes) {
                var newOp = {};
                if (text.length === 0) return this;
                newOp.insert = text;
                if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype['delete'] = function(length) {
                if (length <= 0) return this;
                return this.push({
                    'delete': length
                });
            };
            Delta.prototype.retain = function(length, attributes) {
                if (length <= 0) return this;
                var newOp = {
                    retain: length
                };
                if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
                return this.push(newOp);
            };
            Delta.prototype.push = function(newOp) {
                var index = this.ops.length;
                var lastOp = this.ops[index - 1];
                newOp = extend(true, {}, newOp);
                if (typeof lastOp === 'object') {
                    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
                        this.ops[index - 1] = {
                            'delete': lastOp['delete'] + newOp['delete']
                        };
                        return this;
                    }
                    // Since it does not matter if we insert before or after deleting at the same index,
                    // always prefer to insert first
                    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
                        index -= 1;
                        lastOp = this.ops[index - 1];
                        if (typeof lastOp !== 'object') {
                            this.ops.unshift(newOp);
                            return this;
                        }
                    }
                    if (equal(newOp.attributes, lastOp.attributes)) {
                        if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                            this.ops[index - 1] = {
                                insert: lastOp.insert + newOp.insert
                            };
                            if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                            this.ops[index - 1] = {
                                retain: lastOp.retain + newOp.retain
                            };
                            if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        }
                    }
                }
                if (index === this.ops.length) this.ops.push(newOp);
                else this.ops.splice(index, 0, newOp);
                return this;
            };
            Delta.prototype.chop = function() {
                var lastOp = this.ops[this.ops.length - 1];
                if (lastOp && lastOp.retain && !lastOp.attributes) this.ops.pop();
                return this;
            };
            Delta.prototype.filter = function(predicate) {
                return this.ops.filter(predicate);
            };
            Delta.prototype.forEach = function(predicate) {
                this.ops.forEach(predicate);
            };
            Delta.prototype.map = function(predicate) {
                return this.ops.map(predicate);
            };
            Delta.prototype.partition = function(predicate) {
                var passed = [], failed = [];
                this.forEach(function(op) {
                    var target = predicate(op) ? passed : failed;
                    target.push(op);
                });
                return [
                    passed,
                    failed
                ];
            };
            Delta.prototype.reduce = function(predicate, initial) {
                return this.ops.reduce(predicate, initial);
            };
            Delta.prototype.changeLength = function() {
                return this.reduce(function(length, elem) {
                    if (elem.insert) return length + op.length(elem);
                    else if (elem.delete) return length - elem.delete;
                    return length;
                }, 0);
            };
            Delta.prototype.length = function() {
                return this.reduce(function(length, elem) {
                    return length + op.length(elem);
                }, 0);
            };
            Delta.prototype.slice = function(start, end) {
                start = start || 0;
                if (typeof end !== 'number') end = Infinity;
                var ops = [];
                var iter = op.iterator(this.ops);
                var index = 0;
                while(index < end && iter.hasNext()){
                    var nextOp;
                    if (index < start) nextOp = iter.next(start - index);
                    else {
                        nextOp = iter.next(end - index);
                        ops.push(nextOp);
                    }
                    index += op.length(nextOp);
                }
                return new Delta(ops);
            };
            Delta.prototype.compose = function(other) {
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var ops = [];
                var firstOther = otherIter.peek();
                if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
                    var firstLeft = firstOther.retain;
                    while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                        firstLeft -= thisIter.peekLength();
                        ops.push(thisIter.next());
                    }
                    if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
                }
                var delta = new Delta(ops);
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
                    else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (typeof otherOp.retain === 'number') {
                            var newOp = {};
                            if (typeof thisOp.retain === 'number') newOp.retain = length;
                            else newOp.insert = thisOp.insert;
                            // Preserve null when composing with a retain, otherwise remove it for inserts
                            var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                            if (attributes) newOp.attributes = attributes;
                            delta.push(newOp);
                            // Optimization if rest of other is just retain
                            if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                                var rest = new Delta(thisIter.rest());
                                return delta.concat(rest).chop();
                            }
                        // Other op should be delete, we could be an insert or retain
                        // Insert + delete cancels out
                        } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') delta.push(otherOp);
                    }
                }
                return delta.chop();
            };
            Delta.prototype.concat = function(other) {
                var delta = new Delta(this.ops.slice());
                if (other.ops.length > 0) {
                    delta.push(other.ops[0]);
                    delta.ops = delta.ops.concat(other.ops.slice(1));
                }
                return delta;
            };
            Delta.prototype.diff = function(other, index) {
                if (this.ops === other.ops) return new Delta();
                var strings = [
                    this,
                    other
                ].map(function(delta) {
                    return delta.map(function(op) {
                        if (op.insert != null) return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
                        var prep = delta === other ? 'on' : 'with';
                        throw new Error('diff() called ' + prep + ' non-document');
                    }).join('');
                });
                var delta = new Delta();
                var diffResult = diff(strings[0], strings[1], index);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                diffResult.forEach(function(component) {
                    var length = component[1].length;
                    while(length > 0){
                        var opLength = 0;
                        switch(component[0]){
                            case diff.INSERT:
                                opLength = Math.min(otherIter.peekLength(), length);
                                delta.push(otherIter.next(opLength));
                                break;
                            case diff.DELETE:
                                opLength = Math.min(length, thisIter.peekLength());
                                thisIter.next(opLength);
                                delta['delete'](opLength);
                                break;
                            case diff.EQUAL:
                                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                                var thisOp = thisIter.next(opLength);
                                var otherOp = otherIter.next(opLength);
                                if (equal(thisOp.insert, otherOp.insert)) delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                                else delta.push(otherOp)['delete'](opLength);
                                break;
                        }
                        length -= opLength;
                    }
                });
                return delta.chop();
            };
            Delta.prototype.eachLine = function(predicate, newline) {
                newline = newline || '\n';
                var iter = op.iterator(this.ops);
                var line = new Delta();
                var i = 0;
                while(iter.hasNext()){
                    if (iter.peekType() !== 'insert') return;
                    var thisOp = iter.peek();
                    var start = op.length(thisOp) - iter.peekLength();
                    var index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
                    if (index < 0) line.push(iter.next());
                    else if (index > 0) line.push(iter.next(index));
                    else {
                        if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                        i += 1;
                        line = new Delta();
                    }
                }
                if (line.length() > 0) predicate(line, {}, i);
            };
            Delta.prototype.transform = function(other, priority) {
                priority = !!priority;
                if (typeof other === 'number') return this.transformPosition(other, priority);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var delta = new Delta();
                while(thisIter.hasNext() || otherIter.hasNext()){
                    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain(op.length(thisIter.next()));
                    else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (thisOp['delete']) continue;
                        else if (otherOp['delete']) delta.push(otherOp);
                        else // We retain either their retain or insert
                        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                    }
                }
                return delta.chop();
            };
            Delta.prototype.transformPosition = function(index, priority) {
                priority = !!priority;
                var thisIter = op.iterator(this.ops);
                var offset = 0;
                while(thisIter.hasNext() && offset <= index){
                    var length = thisIter.peekLength();
                    var nextType = thisIter.peekType();
                    thisIter.next();
                    if (nextType === 'delete') {
                        index -= Math.min(length, index - offset);
                        continue;
                    } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
                    offset += length;
                }
                return index;
            };
            module1.exports = Delta;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            'use strict';
            var hasOwn = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var defineProperty = Object.defineProperty;
            var gOPD = Object.getOwnPropertyDescriptor;
            var isArray = function isArray(arr) {
                if (typeof Array.isArray === 'function') return Array.isArray(arr);
                return toStr.call(arr) === '[object Array]';
            };
            var isPlainObject = function isPlainObject(obj) {
                if (!obj || toStr.call(obj) !== '[object Object]') return false;
                var hasOwnConstructor = hasOwn.call(obj, 'constructor');
                var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
                // Not own constructor property must be Object
                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.
                var key;
                for(key in obj);
                return typeof key === 'undefined' || hasOwn.call(obj, key);
            };
            // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
            var setProperty = function setProperty(target, options) {
                if (defineProperty && options.name === '__proto__') defineProperty(target, options.name, {
                    enumerable: true,
                    configurable: true,
                    value: options.newValue,
                    writable: true
                });
                else target[options.name] = options.newValue;
            };
            // Return undefined instead of __proto__ if '__proto__' is not an own property
            var getProperty = function getProperty(obj, name) {
                if (name === '__proto__') {
                    if (!hasOwn.call(obj, name)) return void 0;
                    else if (gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
                    // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
                    return gOPD(obj, name).value;
                }
                return obj[name];
            };
            module1.exports = function extend() {
                var options, name, src, copy, copyIsArray, clone;
                var target = arguments[0];
                var i = 1;
                var length = arguments.length;
                var deep = false;
                // Handle a deep copy situation
                if (typeof target === 'boolean') {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
                for(; i < length; ++i){
                    options = arguments[i];
                    // Only deal with non-null/undefined values
                    if (options != null) // Extend the base object
                    for(name in options){
                        src = getProperty(target, name);
                        copy = getProperty(options, name);
                        // Prevent never-ending loop
                        if (target !== copy) {
                            // Recurse if we're merging plain objects or arrays
                            if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                                if (copyIsArray) {
                                    copyIsArray = false;
                                    clone = src && isArray(src) ? src : [];
                                } else clone = src && isPlainObject(src) ? src : {};
                                // Never move original objects, clone them
                                setProperty(target, {
                                    name: name,
                                    newValue: extend(deep, clone, copy)
                                });
                            // Don't bring in undefined values
                            } else if (typeof copy !== 'undefined') setProperty(target, {
                                name: name,
                                newValue: copy
                            });
                        }
                    }
                }
                // Return the modified object
                return target;
            };
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var NEWLINE_LENGTH = 1;
            var BlockEmbed = function(_Parchment$Embed) {
                _inherits(BlockEmbed, _Parchment$Embed);
                function BlockEmbed() {
                    _classCallCheck(this, BlockEmbed);
                    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
                }
                _createClass(BlockEmbed, [
                    {
                        key: 'attach',
                        value: function attach() {
                            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
                            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
                        }
                    },
                    {
                        key: 'delta',
                        value: function delta() {
                            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                            if (attribute != null) this.attributes.attribute(attribute, value);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            this.format(name, value);
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (typeof value === 'string' && value.endsWith('\n')) {
                                var block = _parchment2.default.create(Block.blotName);
                                this.parent.insertBefore(block, index === 0 ? this : this.next);
                                block.insertAt(0, value.slice(0, -1));
                            } else _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
                        }
                    }
                ]);
                return BlockEmbed;
            }(_parchment2.default.Embed);
            BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
            // It is important for cursor behavior BlockEmbeds use tags that are block level elements
            var Block = function(_Parchment$Block) {
                _inherits(Block, _Parchment$Block);
                function Block(domNode) {
                    _classCallCheck(this, Block);
                    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
                    _this2.cache = {};
                    return _this2;
                }
                _createClass(Block, [
                    {
                        key: 'delta',
                        value: function delta() {
                            if (this.cache.delta == null) this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function(delta, leaf) {
                                if (leaf.length() === 0) return delta;
                                else return delta.insert(leaf.value(), bubbleFormats(leaf));
                            }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
                            return this.cache.delta;
                        }
                    },
                    {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length <= 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                                if (index + length === this.length()) this.format(name, value);
                            } else _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
                            if (value.length === 0) return;
                            var lines = value.split('\n');
                            var text = lines.shift();
                            if (text.length > 0) {
                                if (index < this.length() - 1 || this.children.tail == null) _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
                                else this.children.tail.insertAt(this.children.tail.length(), text);
                                this.cache = {};
                            }
                            var block = this;
                            lines.reduce(function(index, line) {
                                block = block.split(index, true);
                                block.insertAt(0, line);
                                return line.length;
                            }, index + text.length);
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            var head = this.children.head;
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
                            if (head instanceof _break2.default) head.remove();
                            this.cache = {};
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            if (this.cache.length == null) this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
                            return this.cache.length;
                        }
                    },
                    {
                        key: 'moveChildren',
                        value: function moveChildren(target, ref) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'path',
                        value: function path(index) {
                            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
                        }
                    },
                    {
                        key: 'removeChild',
                        value: function removeChild(child) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
                            this.cache = {};
                        }
                    },
                    {
                        key: 'split',
                        value: function split(index) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                                var clone = this.clone();
                                if (index === 0) {
                                    this.parent.insertBefore(clone, this);
                                    return this;
                                } else {
                                    this.parent.insertBefore(clone, this.next);
                                    return clone;
                                }
                            } else {
                                var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
                                this.cache = {};
                                return next;
                            }
                        }
                    }
                ]);
                return Block;
            }(_parchment2.default.Block);
            Block.blotName = 'block';
            Block.tagName = 'P';
            Block.defaultChild = 'break';
            Block.allowedChildren = [
                _inline2.default,
                _parchment2.default.Embed,
                _text2.default
            ];
            function bubbleFormats(blot) {
                var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (blot == null) return formats;
                if (typeof blot.formats === 'function') formats = (0, _extend2.default)(formats, blot.formats());
                if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
                return bubbleFormats(blot.parent, formats);
            }
            exports.bubbleFormats = bubbleFormats;
            exports.BlockEmbed = BlockEmbed;
            exports.default = Block;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.overload = exports.expandConfig = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            __webpack_require__(50);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _editor = __webpack_require__(14);
            var _editor2 = _interopRequireDefault(_editor);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _selection = __webpack_require__(15);
            var _selection2 = _interopRequireDefault(_selection);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)('quill');
            var Quill = function() {
                _createClass(Quill, null, [
                    {
                        key: 'debug',
                        value: function debug(limit) {
                            if (limit === true) limit = 'log';
                            _logger2.default.level(limit);
                        }
                    },
                    {
                        key: 'find',
                        value: function find(node) {
                            return node.__quill || _parchment2.default.find(node);
                        }
                    },
                    {
                        key: 'import',
                        value: function _import(name) {
                            if (this.imports[name] == null) debug.error('Cannot import ' + name + '. Are you sure it was registered?');
                            return this.imports[name];
                        }
                    },
                    {
                        key: 'register',
                        value: function register(path, target) {
                            var _this = this;
                            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                            if (typeof path !== 'string') {
                                var name = path.attrName || path.blotName;
                                if (typeof name === 'string') // register(Blot | Attributor, overwrite)
                                this.register('formats/' + name, path, target);
                                else Object.keys(path).forEach(function(key) {
                                    _this.register(key, path[key], target);
                                });
                            } else {
                                if (this.imports[path] != null && !overwrite) debug.warn('Overwriting ' + path + ' with', target);
                                this.imports[path] = target;
                                if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') _parchment2.default.register(target);
                                else if (path.startsWith('modules') && typeof target.register === 'function') target.register();
                            }
                        }
                    }
                ]);
                function Quill(container) {
                    var _this2 = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, Quill);
                    this.options = expandConfig(container, options);
                    this.container = this.options.container;
                    if (this.container == null) return debug.error('Invalid Quill container', container);
                    if (this.options.debug) Quill.debug(this.options.debug);
                    var html = this.container.innerHTML.trim();
                    this.container.classList.add('ql-container');
                    this.container.innerHTML = '';
                    this.container.__quill = this;
                    this.root = this.addContainer('ql-editor');
                    this.root.classList.add('ql-blank');
                    this.root.setAttribute('data-gramm', false);
                    this.scrollingContainer = this.options.scrollingContainer || this.root;
                    this.emitter = new _emitter4.default();
                    this.scroll = _parchment2.default.create(this.root, {
                        emitter: this.emitter,
                        whitelist: this.options.formats
                    });
                    this.editor = new _editor2.default(this.scroll);
                    this.selection = new _selection2.default(this.scroll, this.emitter);
                    this.theme = new this.options.theme(this, this.options);
                    this.keyboard = this.theme.addModule('keyboard');
                    this.clipboard = this.theme.addModule('clipboard');
                    this.history = this.theme.addModule('history');
                    this.theme.init();
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type) {
                        if (type === _emitter4.default.events.TEXT_CHANGE) _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function(source, mutations) {
                        var range = _this2.selection.lastRange;
                        var index = range && range.length === 0 ? range.index : undefined;
                        modify.call(_this2, function() {
                            return _this2.editor.update(null, mutations, index);
                        }, source);
                    });
                    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
                    this.setContents(contents);
                    this.history.clear();
                    if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
                    if (this.options.readOnly) this.disable();
                }
                _createClass(Quill, [
                    {
                        key: 'addContainer',
                        value: function addContainer(container) {
                            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            if (typeof container === 'string') {
                                var className = container;
                                container = document.createElement('div');
                                container.classList.add(className);
                            }
                            this.container.insertBefore(container, refNode);
                            return container;
                        }
                    },
                    {
                        key: 'blur',
                        value: function blur() {
                            this.selection.setRange(null);
                        }
                    },
                    {
                        key: 'deleteText',
                        value: function deleteText(index, length, source) {
                            var _this3 = this;
                            var _overload = overload(index, length, source);
                            var _overload2 = _slicedToArray(_overload, 4);
                            index = _overload2[0];
                            length = _overload2[1];
                            source = _overload2[3];
                            return modify.call(this, function() {
                                return _this3.editor.deleteText(index, length);
                            }, source, index, -1 * length);
                        }
                    },
                    {
                        key: 'disable',
                        value: function disable() {
                            this.enable(false);
                        }
                    },
                    {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.scroll.enable(enabled);
                            this.container.classList.toggle('ql-disabled', !enabled);
                        }
                    },
                    {
                        key: 'focus',
                        value: function focus() {
                            var scrollTop = this.scrollingContainer.scrollTop;
                            this.selection.focus();
                            this.scrollingContainer.scrollTop = scrollTop;
                            this.scrollIntoView();
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            var _this4 = this;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                var range = _this4.getSelection(true);
                                var change = new _quillDelta2.default();
                                if (range == null) return change;
                                else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                                else if (range.length === 0) {
                                    _this4.selection.format(name, value);
                                    return change;
                                } else change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                                _this4.setSelection(range, _emitter4.default.sources.SILENT);
                                return change;
                            }, source);
                        }
                    },
                    {
                        key: 'formatLine',
                        value: function formatLine(index, length, name, value, source) {
                            var _this5 = this;
                            var formats = void 0;
                            var _overload3 = overload(index, length, name, value, source);
                            var _overload4 = _slicedToArray(_overload3, 4);
                            index = _overload4[0];
                            length = _overload4[1];
                            formats = _overload4[2];
                            source = _overload4[3];
                            return modify.call(this, function() {
                                return _this5.editor.formatLine(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: 'formatText',
                        value: function formatText(index, length, name, value, source) {
                            var _this6 = this;
                            var formats = void 0;
                            var _overload5 = overload(index, length, name, value, source);
                            var _overload6 = _slicedToArray(_overload5, 4);
                            index = _overload6[0];
                            length = _overload6[1];
                            formats = _overload6[2];
                            source = _overload6[3];
                            return modify.call(this, function() {
                                return _this6.editor.formatText(index, length, formats);
                            }, source, index, 0);
                        }
                    },
                    {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var bounds = void 0;
                            if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
                            else bounds = this.selection.getBounds(index.index, index.length);
                            var containerBounds = this.container.getBoundingClientRect();
                            return {
                                bottom: bounds.bottom - containerBounds.top,
                                height: bounds.height,
                                left: bounds.left - containerBounds.left,
                                right: bounds.right - containerBounds.left,
                                top: bounds.top - containerBounds.top,
                                width: bounds.width
                            };
                        }
                    },
                    {
                        key: 'getContents',
                        value: function getContents() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload7 = overload(index, length);
                            var _overload8 = _slicedToArray(_overload7, 2);
                            index = _overload8[0];
                            length = _overload8[1];
                            return this.editor.getContents(index, length);
                        }
                    },
                    {
                        key: 'getFormat',
                        value: function getFormat() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            if (typeof index === 'number') return this.editor.getFormat(index, length);
                            else return this.editor.getFormat(index.index, index.length);
                        }
                    },
                    {
                        key: 'getIndex',
                        value: function getIndex(blot) {
                            return blot.offset(this.scroll);
                        }
                    },
                    {
                        key: 'getLength',
                        value: function getLength() {
                            return this.scroll.length();
                        }
                    },
                    {
                        key: 'getLeaf',
                        value: function getLeaf(index) {
                            return this.scroll.leaf(index);
                        }
                    },
                    {
                        key: 'getLine',
                        value: function getLine(index) {
                            return this.scroll.line(index);
                        }
                    },
                    {
                        key: 'getLines',
                        value: function getLines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
                            else return this.scroll.lines(index, length);
                        }
                    },
                    {
                        key: 'getModule',
                        value: function getModule(name) {
                            return this.theme.modules[name];
                        }
                    },
                    {
                        key: 'getSelection',
                        value: function getSelection() {
                            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                            if (focus) this.focus();
                            this.update(); // Make sure we access getRange with editor in consistent state
                            return this.selection.getRange()[0];
                        }
                    },
                    {
                        key: 'getText',
                        value: function getText() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload9 = overload(index, length);
                            var _overload10 = _slicedToArray(_overload9, 2);
                            index = _overload10[0];
                            length = _overload10[1];
                            return this.editor.getText(index, length);
                        }
                    },
                    {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return this.selection.hasFocus();
                        }
                    },
                    {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            var _this7 = this;
                            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
                            return modify.call(this, function() {
                                return _this7.editor.insertEmbed(index, embed, value);
                            }, source, index);
                        }
                    },
                    {
                        key: 'insertText',
                        value: function insertText(index, text, name, value, source) {
                            var _this8 = this;
                            var formats = void 0;
                            var _overload11 = overload(index, 0, name, value, source);
                            var _overload12 = _slicedToArray(_overload11, 4);
                            index = _overload12[0];
                            formats = _overload12[2];
                            source = _overload12[3];
                            return modify.call(this, function() {
                                return _this8.editor.insertText(index, text, formats);
                            }, source, index, text.length);
                        }
                    },
                    {
                        key: 'isEnabled',
                        value: function isEnabled() {
                            return !this.container.classList.contains('ql-disabled');
                        }
                    },
                    {
                        key: 'off',
                        value: function off() {
                            return this.emitter.off.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'on',
                        value: function on() {
                            return this.emitter.on.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'once',
                        value: function once() {
                            return this.emitter.once.apply(this.emitter, arguments);
                        }
                    },
                    {
                        key: 'pasteHTML',
                        value: function pasteHTML(index, html, source) {
                            this.clipboard.dangerouslyPasteHTML(index, html, source);
                        }
                    },
                    {
                        key: 'removeFormat',
                        value: function removeFormat(index, length, source) {
                            var _this9 = this;
                            var _overload13 = overload(index, length, source);
                            var _overload14 = _slicedToArray(_overload13, 4);
                            index = _overload14[0];
                            length = _overload14[1];
                            source = _overload14[3];
                            return modify.call(this, function() {
                                return _this9.editor.removeFormat(index, length);
                            }, source, index);
                        }
                    },
                    {
                        key: 'scrollIntoView',
                        value: function scrollIntoView() {
                            this.selection.scrollIntoView(this.scrollingContainer);
                        }
                    },
                    {
                        key: 'setContents',
                        value: function setContents(delta) {
                            var _this10 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                var length = _this10.getLength();
                                var deleted = _this10.editor.deleteText(0, length);
                                var applied = _this10.editor.applyDelta(delta);
                                var lastOp = applied.ops[applied.ops.length - 1];
                                if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
                                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                                    applied.delete(1);
                                }
                                var ret = deleted.compose(applied);
                                return ret;
                            }, source);
                        }
                    },
                    {
                        key: 'setSelection',
                        value: function setSelection(index, length, source) {
                            if (index == null) this.selection.setRange(null, length || Quill.sources.API);
                            else {
                                var _overload15 = overload(index, length, source);
                                var _overload16 = _slicedToArray(_overload15, 4);
                                index = _overload16[0];
                                length = _overload16[1];
                                source = _overload16[3];
                                this.selection.setRange(new _selection.Range(index, length), source);
                                if (source !== _emitter4.default.sources.SILENT) this.selection.scrollIntoView(this.scrollingContainer);
                            }
                        }
                    },
                    {
                        key: 'setText',
                        value: function setText(text) {
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            var delta = new _quillDelta2.default().insert(text);
                            return this.setContents(delta, source);
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
                            this.selection.update(source);
                            return change;
                        }
                    },
                    {
                        key: 'updateContents',
                        value: function updateContents(delta) {
                            var _this11 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function() {
                                delta = new _quillDelta2.default(delta);
                                return _this11.editor.applyDelta(delta, source);
                            }, source, true);
                        }
                    }
                ]);
                return Quill;
            }();
            Quill.DEFAULTS = {
                bounds: null,
                formats: null,
                modules: {},
                placeholder: '',
                readOnly: false,
                scrollingContainer: null,
                strict: true,
                theme: 'default'
            };
            Quill.events = _emitter4.default.events;
            Quill.sources = _emitter4.default.sources;
            // eslint-disable-next-line no-undef
            Quill.version = "1.3.7";
            Quill.imports = {
                'delta': _quillDelta2.default,
                'parchment': _parchment2.default,
                'core/module': _module2.default,
                'core/theme': _theme2.default
            };
            function expandConfig(container, userConfig) {
                userConfig = (0, _extend2.default)(true, {
                    container: container,
                    modules: {
                        clipboard: true,
                        keyboard: true,
                        history: true
                    }
                }, userConfig);
                if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) userConfig.theme = _theme2.default;
                else {
                    userConfig.theme = Quill.import('themes/' + userConfig.theme);
                    if (userConfig.theme == null) throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
                }
                var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
                [
                    themeConfig,
                    userConfig
                ].forEach(function(config) {
                    config.modules = config.modules || {};
                    Object.keys(config.modules).forEach(function(module1) {
                        if (config.modules[module1] === true) config.modules[module1] = {};
                    });
                });
                var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
                var moduleConfig = moduleNames.reduce(function(config, name) {
                    var moduleClass = Quill.import('modules/' + name);
                    if (moduleClass == null) debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
                    else config[name] = moduleClass.DEFAULTS || {};
                    return config;
                }, {});
                // Special case toolbar shorthand
                if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) userConfig.modules.toolbar = {
                    container: userConfig.modules.toolbar
                };
                userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, {
                    modules: moduleConfig
                }, themeConfig, userConfig);
                [
                    'bounds',
                    'container',
                    'scrollingContainer'
                ].forEach(function(key) {
                    if (typeof userConfig[key] === 'string') userConfig[key] = document.querySelector(userConfig[key]);
                });
                userConfig.modules = Object.keys(userConfig.modules).reduce(function(config, name) {
                    if (userConfig.modules[name]) config[name] = userConfig.modules[name];
                    return config;
                }, {});
                return userConfig;
            }
            // Handle selection preservation and TEXT_CHANGE emission
            // common to modification APIs
            function modify(modifier, source, index, shift) {
                if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) return new _quillDelta2.default();
                var range = index == null ? null : this.getSelection();
                var oldDelta = this.editor.delta;
                var change = modifier();
                if (range != null) {
                    if (index === true) index = range.index;
                    if (shift == null) range = shiftRange(range, change, source);
                    else if (shift !== 0) range = shiftRange(range, index, shift, source);
                    this.setSelection(range, _emitter4.default.sources.SILENT);
                }
                if (change.length() > 0) {
                    var _emitter;
                    var args = [
                        _emitter4.default.events.TEXT_CHANGE,
                        change,
                        oldDelta,
                        source
                    ];
                    (_emitter = this.emitter).emit.apply(_emitter, [
                        _emitter4.default.events.EDITOR_CHANGE
                    ].concat(args));
                    if (source !== _emitter4.default.sources.SILENT) {
                        var _emitter2;
                        (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                    }
                }
                return change;
            }
            function overload(index, length, name, value, source) {
                var formats = {};
                if (typeof index.index === 'number' && typeof index.length === 'number') {
                    // Allow for throwaway end (used by insertText/insertEmbed)
                    if (typeof length !== 'number') source = value, value = name, name = length, length = index.length, index = index.index;
                    else length = index.length, index = index.index;
                } else if (typeof length !== 'number') source = value, value = name, name = length, length = 0;
                // Handle format being object, two format name/value strings or excluded
                if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
                    formats = name;
                    source = value;
                } else if (typeof name === 'string') {
                    if (value != null) formats[name] = value;
                    else source = name;
                }
                // Handle optional source
                source = source || _emitter4.default.sources.API;
                return [
                    index,
                    length,
                    formats,
                    source
                ];
            }
            function shiftRange(range, index, length, source) {
                if (range == null) return null;
                var start = void 0, end = void 0;
                if (index instanceof _quillDelta2.default) {
                    var _map = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
                    });
                    var _map2 = _slicedToArray(_map, 2);
                    start = _map2[0];
                    end = _map2[1];
                } else {
                    var _map3 = [
                        range.index,
                        range.index + range.length
                    ].map(function(pos) {
                        if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
                        if (length >= 0) return pos + length;
                        else return Math.max(index, pos + length);
                    });
                    var _map4 = _slicedToArray(_map3, 2);
                    start = _map4[0];
                    end = _map4[1];
                }
                return new _selection.Range(start, end - start);
            }
            exports.expandConfig = expandConfig;
            exports.overload = overload;
            exports.default = Quill;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Inline = function(_Parchment$Inline) {
                _inherits(Inline, _Parchment$Inline);
                function Inline() {
                    _classCallCheck(this, Inline);
                    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
                }
                _createClass(Inline, [
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                                var blot = this.isolate(index, length);
                                if (value) blot.wrap(name, value);
                            } else _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
                            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                                var parent = this.parent.isolate(this.offset(), this.length());
                                this.moveChildren(parent);
                                parent.wrap(this);
                            }
                        }
                    }
                ], [
                    {
                        key: 'compare',
                        value: function compare(self1, other) {
                            var selfIndex = Inline.order.indexOf(self1);
                            var otherIndex = Inline.order.indexOf(other);
                            if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
                            else if (self1 === other) return 0;
                            else if (self1 < other) return -1;
                            else return 1;
                        }
                    }
                ]);
                return Inline;
            }(_parchment2.default.Inline);
            Inline.allowedChildren = [
                Inline,
                _parchment2.default.Embed,
                _text2.default
            ];
            // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
            Inline.order = [
                'cursor',
                'inline',
                'underline',
                'strike',
                'italic',
                'bold',
                'script',
                'link',
                'code' // Must be higher
            ];
            exports.default = Inline;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TextBlot = function(_Parchment$Text) {
                _inherits(TextBlot, _Parchment$Text);
                function TextBlot() {
                    _classCallCheck(this, TextBlot);
                    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
                }
                return TextBlot;
            }(_parchment2.default.Text);
            exports.default = TextBlot;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _eventemitter = __webpack_require__(54);
            var _eventemitter2 = _interopRequireDefault(_eventemitter);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:events');
            var EVENTS = [
                'selectionchange',
                'mousedown',
                'mouseup',
                'click'
            ];
            EVENTS.forEach(function(eventName) {
                document.addEventListener(eventName, function() {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function(node) {
                        // TODO use WeakMap
                        if (node.__quill && node.__quill.emitter) {
                            var _node$__quill$emitter;
                            (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                        }
                    });
                });
            });
            var Emitter = function(_EventEmitter) {
                _inherits(Emitter, _EventEmitter);
                function Emitter() {
                    _classCallCheck(this, Emitter);
                    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
                    _this.listeners = {};
                    _this.on('error', debug.error);
                    return _this;
                }
                _createClass(Emitter, [
                    {
                        key: 'emit',
                        value: function emit() {
                            debug.log.apply(debug, arguments);
                            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
                        }
                    },
                    {
                        key: 'handleDOM',
                        value: function handleDOM(event) {
                            for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                            (this.listeners[event.type] || []).forEach(function(_ref) {
                                var node = _ref.node, handler = _ref.handler;
                                if (event.target === node || node.contains(event.target)) handler.apply(undefined, [
                                    event
                                ].concat(args));
                            });
                        }
                    },
                    {
                        key: 'listenDOM',
                        value: function listenDOM(eventName, node, handler) {
                            if (!this.listeners[eventName]) this.listeners[eventName] = [];
                            this.listeners[eventName].push({
                                node: node,
                                handler: handler
                            });
                        }
                    }
                ]);
                return Emitter;
            }(_eventemitter2.default);
            Emitter.events = {
                EDITOR_CHANGE: 'editor-change',
                SCROLL_BEFORE_UPDATE: 'scroll-before-update',
                SCROLL_OPTIMIZE: 'scroll-optimize',
                SCROLL_UPDATE: 'scroll-update',
                SELECTION_CHANGE: 'selection-change',
                TEXT_CHANGE: 'text-change'
            };
            Emitter.sources = {
                API: 'api',
                SILENT: 'silent',
                USER: 'user'
            };
            exports.default = Emitter;
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Module = function Module(quill) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                _classCallCheck(this, Module);
                this.quill = quill;
                this.options = options;
            };
            Module.DEFAULTS = {};
            exports.default = Module;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var levels = [
                'error',
                'warn',
                'log',
                'info'
            ];
            var level = 'warn';
            function debug(method) {
                if (levels.indexOf(method) <= levels.indexOf(level)) {
                    var _console;
                    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
                }
            }
            function namespace(ns) {
                return levels.reduce(function(logger, method) {
                    logger[method] = debug.bind(console, method, ns);
                    return logger;
                }, {});
            }
            debug.level = namespace.level = function(newLevel) {
                level = newLevel;
            };
            exports.default = namespace;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            var pSlice = Array.prototype.slice;
            var objectKeys = __webpack_require__(52);
            var isArguments = __webpack_require__(53);
            var deepEqual = module1.exports = function(actual, expected, opts) {
                if (!opts) opts = {};
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) return true;
                else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
                else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
                else return objEquiv(actual, expected, opts);
            };
            function isUndefinedOrNull(value) {
                return value === null || value === undefined;
            }
            function isBuffer(x) {
                if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
                if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
                if (x.length > 0 && typeof x[0] !== 'number') return false;
                return true;
            }
            function objEquiv(a, b, opts) {
                var i, key;
                if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
                // an identical 'prototype' property.
                if (a.prototype !== b.prototype) return false;
                //~~~I've managed to break Object.keys through screwy arguments passing.
                //   Converting to array solves the problem.
                if (isArguments(a)) {
                    if (!isArguments(b)) return false;
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return deepEqual(a, b, opts);
                }
                if (isBuffer(a)) {
                    if (!isBuffer(b)) return false;
                    if (a.length !== b.length) return false;
                    for(i = 0; i < a.length; i++){
                        if (a[i] !== b[i]) return false;
                    }
                    return true;
                }
                try {
                    var ka = objectKeys(a), kb = objectKeys(b);
                } catch (e) {
                    return false;
                }
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length != kb.length) return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for(i = ka.length - 1; i >= 0; i--){
                    if (ka[i] != kb[i]) return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for(i = ka.length - 1; i >= 0; i--){
                    key = ka[i];
                    if (!deepEqual(a[key], b[key], opts)) return false;
                }
                return typeof a === typeof b;
            }
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var Attributor = /** @class */ function() {
                function Attributor(attrName, keyName, options) {
                    if (options === void 0) options = {};
                    this.attrName = attrName;
                    this.keyName = keyName;
                    var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
                    if (options.scope != null) // Ignore type bits, force attribute bit
                    this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
                    else this.scope = Registry.Scope.ATTRIBUTE;
                    if (options.whitelist != null) this.whitelist = options.whitelist;
                }
                Attributor.keys = function(node) {
                    return [].map.call(node.attributes, function(item) {
                        return item.name;
                    });
                };
                Attributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    node.setAttribute(this.keyName, value);
                    return true;
                };
                Attributor.prototype.canAdd = function(node, value) {
                    var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
                    if (match == null) return false;
                    if (this.whitelist == null) return true;
                    if (typeof value === 'string') return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
                    else return this.whitelist.indexOf(value) > -1;
                };
                Attributor.prototype.remove = function(node) {
                    node.removeAttribute(this.keyName);
                };
                Attributor.prototype.value = function(node) {
                    var value = node.getAttribute(this.keyName);
                    if (this.canAdd(node, value) && value) return value;
                    return '';
                };
                return Attributor;
            }();
            exports.default = Attributor;
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Code = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Code = function(_Inline) {
                _inherits(Code, _Inline);
                function Code() {
                    _classCallCheck(this, Code);
                    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
                }
                return Code;
            }(_inline2.default);
            Code.blotName = 'code';
            Code.tagName = 'CODE';
            var CodeBlock = function(_Block) {
                _inherits(CodeBlock, _Block);
                function CodeBlock() {
                    _classCallCheck(this, CodeBlock);
                    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
                }
                _createClass(CodeBlock, [
                    {
                        key: 'delta',
                        value: function delta() {
                            var _this3 = this;
                            var text = this.domNode.textContent;
                            if (text.endsWith('\n')) // Should always be true
                            text = text.slice(0, -1);
                            return text.split('\n').reduce(function(delta, frag) {
                                return delta.insert(frag).insert('\n', _this3.formats());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name === this.statics.blotName && value) return;
                            var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                            if (text != null) text.deleteAt(text.length() - 1, 1);
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length === 0) return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) return;
                            var nextNewline = this.newlineIndex(index);
                            if (nextNewline < 0 || nextNewline >= index + length) return;
                            var prevNewline = this.newlineIndex(index, true) + 1;
                            var isolateLength = nextNewline - prevNewline + 1;
                            var blot = this.isolate(prevNewline, isolateLength);
                            var next = blot.next;
                            blot.format(name, value);
                            if (next instanceof CodeBlock) next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null) return;
                            var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                            text.insertAt(offset, value);
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            var length = this.domNode.textContent.length;
                            if (!this.domNode.textContent.endsWith('\n')) return length + 1;
                            return length;
                        }
                    },
                    {
                        key: 'newlineIndex',
                        value: function newlineIndex(searchIndex) {
                            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (!reverse) {
                                var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
                                return offset > -1 ? searchIndex + offset : -1;
                            } else return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            if (!this.domNode.textContent.endsWith('\n')) this.appendChild(_parchment2.default.create('text', '\n'));
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                                next.optimize(context);
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: 'replace',
                        value: function replace(target) {
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
                            [].slice.call(this.domNode.querySelectorAll('*')).forEach(function(node) {
                                var blot = _parchment2.default.find(node);
                                if (blot == null) node.parentNode.removeChild(node);
                                else if (blot instanceof _parchment2.default.Embed) blot.remove();
                                else blot.unwrap();
                            });
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
                            domNode.setAttribute('spellcheck', false);
                            return domNode;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return CodeBlock;
            }(_block2.default);
            CodeBlock.blotName = 'code-block';
            CodeBlock.tagName = 'PRE';
            CodeBlock.TAB = '  ';
            exports.Code = Code;
            exports.default = CodeBlock;
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var ASCII = /^[ -~]*$/;
            var Editor = function() {
                function Editor(scroll) {
                    _classCallCheck(this, Editor);
                    this.scroll = scroll;
                    this.delta = this.getDelta();
                }
                _createClass(Editor, [
                    {
                        key: 'applyDelta',
                        value: function applyDelta(delta) {
                            var _this = this;
                            var consumeNextNewline = false;
                            this.scroll.update();
                            var scrollLength = this.scroll.length();
                            this.scroll.batchStart();
                            delta = normalizeDelta(delta);
                            delta.reduce(function(index, op) {
                                var length = op.retain || op.delete || op.insert.length || 1;
                                var attributes = op.attributes || {};
                                if (op.insert != null) {
                                    if (typeof op.insert === 'string') {
                                        var text = op.insert;
                                        if (text.endsWith('\n') && consumeNextNewline) {
                                            consumeNextNewline = false;
                                            text = text.slice(0, -1);
                                        }
                                        if (index >= scrollLength && !text.endsWith('\n')) consumeNextNewline = true;
                                        _this.scroll.insertAt(index, text);
                                        var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line = _scroll$line2[0], offset = _scroll$line2[1];
                                        var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                                        if (line instanceof _block2.default) {
                                            var _line$descendant = line.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                                            formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                                        }
                                        attributes = _op2.default.attributes.diff(formats, attributes) || {};
                                    } else if (_typeof(op.insert) === 'object') {
                                        var key = Object.keys(op.insert)[0]; // There should only be one key
                                        if (key == null) return index;
                                        _this.scroll.insertAt(index, key, op.insert[key]);
                                    }
                                    scrollLength += length;
                                }
                                Object.keys(attributes).forEach(function(name) {
                                    _this.scroll.formatAt(index, length, name, attributes[name]);
                                });
                                return index + length;
                            }, 0);
                            delta.reduce(function(index, op) {
                                if (typeof op.delete === 'number') {
                                    _this.scroll.deleteAt(index, op.delete);
                                    return index;
                                }
                                return index + (op.retain || op.insert.length || 1);
                            }, 0);
                            this.scroll.batchEnd();
                            return this.update(delta);
                        }
                    },
                    {
                        key: 'deleteText',
                        value: function deleteText(index, length) {
                            this.scroll.deleteAt(index, length);
                            return this.update(new _quillDelta2.default().retain(index).delete(length));
                        }
                    },
                    {
                        key: 'formatLine',
                        value: function formatLine(index, length) {
                            var _this2 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            this.scroll.update();
                            Object.keys(formats).forEach(function(format) {
                                if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
                                var lines = _this2.scroll.lines(index, Math.max(length, 1));
                                var lengthRemaining = length;
                                lines.forEach(function(line) {
                                    var lineLength = line.length();
                                    if (!(line instanceof _code2.default)) line.format(format, formats[format]);
                                    else {
                                        var codeIndex = index - line.offset(_this2.scroll);
                                        var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                                        line.formatAt(codeIndex, codeLength, format, formats[format]);
                                    }
                                    lengthRemaining -= lineLength;
                                });
                            });
                            this.scroll.optimize();
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'formatText',
                        value: function formatText(index, length) {
                            var _this3 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            Object.keys(formats).forEach(function(format) {
                                _this3.scroll.formatAt(index, length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'getContents',
                        value: function getContents(index, length) {
                            return this.delta.slice(index, index + length);
                        }
                    },
                    {
                        key: 'getDelta',
                        value: function getDelta() {
                            return this.scroll.lines().reduce(function(delta, line) {
                                return delta.concat(line.delta());
                            }, new _quillDelta2.default());
                        }
                    },
                    {
                        key: 'getFormat',
                        value: function getFormat(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var lines = [], leaves = [];
                            if (length === 0) this.scroll.path(index).forEach(function(path) {
                                var _path = _slicedToArray(path, 1), blot = _path[0];
                                if (blot instanceof _block2.default) lines.push(blot);
                                else if (blot instanceof _parchment2.default.Leaf) leaves.push(blot);
                            });
                            else {
                                lines = this.scroll.lines(index, length);
                                leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                            }
                            var formatsArr = [
                                lines,
                                leaves
                            ].map(function(blots) {
                                if (blots.length === 0) return {};
                                var formats = (0, _block.bubbleFormats)(blots.shift());
                                while(Object.keys(formats).length > 0){
                                    var blot = blots.shift();
                                    if (blot == null) return formats;
                                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                                }
                                return formats;
                            });
                            return _extend2.default.apply(_extend2.default, formatsArr);
                        }
                    },
                    {
                        key: 'getText',
                        value: function getText(index, length) {
                            return this.getContents(index, length).filter(function(op) {
                                return typeof op.insert === 'string';
                            }).map(function(op) {
                                return op.insert;
                            }).join('');
                        }
                    },
                    {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            this.scroll.insertAt(index, embed, value);
                            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
                        }
                    },
                    {
                        key: 'insertText',
                        value: function insertText(index, text) {
                            var _this4 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                            this.scroll.insertAt(index, text);
                            Object.keys(formats).forEach(function(format) {
                                _this4.scroll.formatAt(index, text.length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
                        }
                    },
                    {
                        key: 'isBlank',
                        value: function isBlank() {
                            if (this.scroll.children.length == 0) return true;
                            if (this.scroll.children.length > 1) return false;
                            var block = this.scroll.children.head;
                            if (block.statics.blotName !== _block2.default.blotName) return false;
                            if (block.children.length > 1) return false;
                            return block.children.head instanceof _break2.default;
                        }
                    },
                    {
                        key: 'removeFormat',
                        value: function removeFormat(index, length) {
                            var text = this.getText(index, length);
                            var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line = _scroll$line4[0], offset = _scroll$line4[1];
                            var suffixLength = 0, suffix = new _quillDelta2.default();
                            if (line != null) {
                                if (!(line instanceof _code2.default)) suffixLength = line.length() - offset;
                                else suffixLength = line.newlineIndex(offset) - offset + 1;
                                suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
                            }
                            var contents = this.getContents(index, length + suffixLength);
                            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                            var delta = new _quillDelta2.default().retain(index).concat(diff);
                            return this.applyDelta(delta);
                        }
                    },
                    {
                        key: 'update',
                        value: function update(change) {
                            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                            var oldDelta = this.delta;
                            if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                                // Optimization for character changes
                                var textBlot = _parchment2.default.find(mutations[0].target);
                                var formats = (0, _block.bubbleFormats)(textBlot);
                                var index = textBlot.offset(this.scroll);
                                var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
                                var oldText = new _quillDelta2.default().insert(oldValue);
                                var newText = new _quillDelta2.default().insert(textBlot.value());
                                var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                                change = diffDelta.reduce(function(delta, op) {
                                    if (op.insert) return delta.insert(op.insert, formats);
                                    else return delta.push(op);
                                }, new _quillDelta2.default());
                                this.delta = oldDelta.compose(change);
                            } else {
                                this.delta = this.getDelta();
                                if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, cursorIndex);
                            }
                            return change;
                        }
                    }
                ]);
                return Editor;
            }();
            function combineFormats(formats, combined) {
                return Object.keys(combined).reduce(function(merged, name) {
                    if (formats[name] == null) return merged;
                    if (combined[name] === formats[name]) merged[name] = combined[name];
                    else if (Array.isArray(combined[name])) {
                        if (combined[name].indexOf(formats[name]) < 0) merged[name] = combined[name].concat([
                            formats[name]
                        ]);
                    } else merged[name] = [
                        combined[name],
                        formats[name]
                    ];
                    return merged;
                }, {});
            }
            function normalizeDelta(delta) {
                return delta.reduce(function(delta, op) {
                    if (op.insert === 1) {
                        var attributes = (0, _clone2.default)(op.attributes);
                        delete attributes['image'];
                        return delta.insert({
                            image: op.attributes.image
                        }, attributes);
                    }
                    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                        op = (0, _clone2.default)(op);
                        if (op.attributes.list) op.attributes.list = 'ordered';
                        else {
                            op.attributes.list = 'bullet';
                            delete op.attributes.bullet;
                        }
                    }
                    if (typeof op.insert === 'string') {
                        var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                        return delta.insert(text, op.attributes);
                    }
                    return delta.push(op);
                }, new _quillDelta2.default());
            }
            exports.default = Editor;
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Range = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                    return arr2;
                } else return Array.from(arr);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var debug = (0, _logger2.default)('quill:selection');
            var Range = function Range(index) {
                var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _classCallCheck(this, Range);
                this.index = index;
                this.length = length;
            };
            var Selection = function() {
                function Selection(scroll, emitter) {
                    var _this = this;
                    _classCallCheck(this, Selection);
                    this.emitter = emitter;
                    this.scroll = scroll;
                    this.composing = false;
                    this.mouseDown = false;
                    this.root = this.scroll.domNode;
                    this.cursor = _parchment2.default.create('cursor', this);
                    // savedRange is last non-null range
                    this.lastRange = this.savedRange = new Range(0, 0);
                    this.handleComposition();
                    this.handleDragging();
                    this.emitter.listenDOM('selectionchange', document, function() {
                        if (!_this.mouseDown) setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                    });
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type, delta) {
                        if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) _this.update(_emitter4.default.sources.SILENT);
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function() {
                        if (!_this.hasFocus()) return;
                        var native = _this.getNativeRange();
                        if (native == null) return;
                        if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
                        // TODO unclear if this has negative side effects
                        _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function() {
                            try {
                                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                            } catch (ignored) {}
                        });
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function(mutations, context) {
                        if (context.range) {
                            var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                            _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                        }
                    });
                    this.update(_emitter4.default.sources.SILENT);
                }
                _createClass(Selection, [
                    {
                        key: 'handleComposition',
                        value: function handleComposition() {
                            var _this2 = this;
                            this.root.addEventListener('compositionstart', function() {
                                _this2.composing = true;
                            });
                            this.root.addEventListener('compositionend', function() {
                                _this2.composing = false;
                                if (_this2.cursor.parent) {
                                    var range = _this2.cursor.restore();
                                    if (!range) return;
                                    setTimeout(function() {
                                        _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                                    }, 1);
                                }
                            });
                        }
                    },
                    {
                        key: 'handleDragging',
                        value: function handleDragging() {
                            var _this3 = this;
                            this.emitter.listenDOM('mousedown', document.body, function() {
                                _this3.mouseDown = true;
                            });
                            this.emitter.listenDOM('mouseup', document.body, function() {
                                _this3.mouseDown = false;
                                _this3.update(_emitter4.default.sources.USER);
                            });
                        }
                    },
                    {
                        key: 'focus',
                        value: function focus() {
                            if (this.hasFocus()) return;
                            this.root.focus();
                            this.setRange(this.savedRange);
                        }
                    },
                    {
                        key: 'format',
                        value: function format(_format, value) {
                            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
                            this.scroll.update();
                            var nativeRange = this.getNativeRange();
                            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
                            if (nativeRange.start.node !== this.cursor.textNode) {
                                var blot = _parchment2.default.find(nativeRange.start.node, false);
                                if (blot == null) return;
                                // TODO Give blot ability to not split
                                if (blot instanceof _parchment2.default.Leaf) {
                                    var after = blot.split(nativeRange.start.offset);
                                    blot.parent.insertBefore(this.cursor, after);
                                } else blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
                                this.cursor.attach();
                            }
                            this.cursor.format(_format, value);
                            this.scroll.optimize();
                            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                            this.update();
                        }
                    },
                    {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var scrollLength = this.scroll.length();
                            index = Math.min(index, scrollLength - 1);
                            length = Math.min(index + length, scrollLength - 1) - index;
                            var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                            if (leaf == null) return null;
                            var _leaf$position = leaf.position(offset, true);
                            var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                            node = _leaf$position2[0];
                            offset = _leaf$position2[1];
                            var range = document.createRange();
                            if (length > 0) {
                                range.setStart(node, offset);
                                var _scroll$leaf3 = this.scroll.leaf(index + length);
                                var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                                leaf = _scroll$leaf4[0];
                                offset = _scroll$leaf4[1];
                                if (leaf == null) return null;
                                var _leaf$position3 = leaf.position(offset, true);
                                var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                                node = _leaf$position4[0];
                                offset = _leaf$position4[1];
                                range.setEnd(node, offset);
                                return range.getBoundingClientRect();
                            } else {
                                var side = 'left';
                                var rect = void 0;
                                if (node instanceof Text) {
                                    if (offset < node.data.length) {
                                        range.setStart(node, offset);
                                        range.setEnd(node, offset + 1);
                                    } else {
                                        range.setStart(node, offset - 1);
                                        range.setEnd(node, offset);
                                        side = 'right';
                                    }
                                    rect = range.getBoundingClientRect();
                                } else {
                                    rect = leaf.domNode.getBoundingClientRect();
                                    if (offset > 0) side = 'right';
                                }
                                return {
                                    bottom: rect.top + rect.height,
                                    height: rect.height,
                                    left: rect[side],
                                    right: rect[side],
                                    top: rect.top,
                                    width: 0
                                };
                            }
                        }
                    },
                    {
                        key: 'getNativeRange',
                        value: function getNativeRange() {
                            var selection = document.getSelection();
                            if (selection == null || selection.rangeCount <= 0) return null;
                            var nativeRange = selection.getRangeAt(0);
                            if (nativeRange == null) return null;
                            var range = this.normalizeNative(nativeRange);
                            debug.info('getNativeRange', range);
                            return range;
                        }
                    },
                    {
                        key: 'getRange',
                        value: function getRange() {
                            var normalized = this.getNativeRange();
                            if (normalized == null) return [
                                null,
                                null
                            ];
                            var range = this.normalizedToRange(normalized);
                            return [
                                range,
                                normalized
                            ];
                        }
                    },
                    {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return document.activeElement === this.root;
                        }
                    },
                    {
                        key: 'normalizedToRange',
                        value: function normalizedToRange(range) {
                            var _this4 = this;
                            var positions = [
                                [
                                    range.start.node,
                                    range.start.offset
                                ]
                            ];
                            if (!range.native.collapsed) positions.push([
                                range.end.node,
                                range.end.offset
                            ]);
                            var indexes = positions.map(function(position) {
                                var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                                var blot = _parchment2.default.find(node, true);
                                var index = blot.offset(_this4.scroll);
                                if (offset === 0) return index;
                                else if (blot instanceof _parchment2.default.Container) return index + blot.length();
                                else return index + blot.index(node, offset);
                            });
                            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                            var start = Math.min.apply(Math, [
                                end
                            ].concat(_toConsumableArray(indexes)));
                            return new Range(start, end - start);
                        }
                    },
                    {
                        key: 'normalizeNative',
                        value: function normalizeNative(nativeRange) {
                            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) return null;
                            var range = {
                                start: {
                                    node: nativeRange.startContainer,
                                    offset: nativeRange.startOffset
                                },
                                end: {
                                    node: nativeRange.endContainer,
                                    offset: nativeRange.endOffset
                                },
                                native: nativeRange
                            };
                            [
                                range.start,
                                range.end
                            ].forEach(function(position) {
                                var node = position.node, offset = position.offset;
                                while(!(node instanceof Text) && node.childNodes.length > 0){
                                    if (node.childNodes.length > offset) {
                                        node = node.childNodes[offset];
                                        offset = 0;
                                    } else if (node.childNodes.length === offset) {
                                        node = node.lastChild;
                                        offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                                    } else break;
                                }
                                position.node = node, position.offset = offset;
                            });
                            return range;
                        }
                    },
                    {
                        key: 'rangeToNative',
                        value: function rangeToNative(range) {
                            var _this5 = this;
                            var indexes = range.collapsed ? [
                                range.index
                            ] : [
                                range.index,
                                range.index + range.length
                            ];
                            var args = [];
                            var scrollLength = this.scroll.length();
                            indexes.forEach(function(index, i) {
                                index = Math.min(scrollLength - 1, index);
                                var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                                var _leaf$position5 = leaf.position(offset, i !== 0);
                                var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                                node = _leaf$position6[0];
                                offset = _leaf$position6[1];
                                args.push(node, offset);
                            });
                            if (args.length < 2) args = args.concat(args);
                            return args;
                        }
                    },
                    {
                        key: 'scrollIntoView',
                        value: function scrollIntoView(scrollingContainer) {
                            var range = this.lastRange;
                            if (range == null) return;
                            var bounds = this.getBounds(range.index, range.length);
                            if (bounds == null) return;
                            var limit = this.scroll.length() - 1;
                            var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                            var last = first;
                            if (range.length > 0) {
                                var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                                var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                                last = _scroll$line4[0];
                            }
                            if (first == null || last == null) return;
                            var scrollBounds = scrollingContainer.getBoundingClientRect();
                            if (bounds.top < scrollBounds.top) scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                            else if (bounds.bottom > scrollBounds.bottom) scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                        }
                    },
                    {
                        key: 'setNativeRange',
                        value: function setNativeRange(startNode, startOffset) {
                            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
                            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
                            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                            debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
                            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) return;
                            var selection = document.getSelection();
                            if (selection == null) return;
                            if (startNode != null) {
                                if (!this.hasFocus()) this.root.focus();
                                var native = (this.getNativeRange() || {}).native;
                                if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                                    if (startNode.tagName == "BR") {
                                        startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                                        startNode = startNode.parentNode;
                                    }
                                    if (endNode.tagName == "BR") {
                                        endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                                        endNode = endNode.parentNode;
                                    }
                                    var range = document.createRange();
                                    range.setStart(startNode, startOffset);
                                    range.setEnd(endNode, endOffset);
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                }
                            } else {
                                selection.removeAllRanges();
                                this.root.blur();
                                document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
                            }
                        }
                    },
                    {
                        key: 'setRange',
                        value: function setRange(range) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            if (typeof force === 'string') {
                                source = force;
                                force = false;
                            }
                            debug.info('setRange', range);
                            if (range != null) {
                                var args = this.rangeToNative(range);
                                this.setNativeRange.apply(this, _toConsumableArray(args).concat([
                                    force
                                ]));
                            } else this.setNativeRange(null);
                            this.update(source);
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var oldRange = this.lastRange;
                            var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                            this.lastRange = lastRange;
                            if (this.lastRange != null) this.savedRange = this.lastRange;
                            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                                var _emitter;
                                if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) this.cursor.restore();
                                var args = [
                                    _emitter4.default.events.SELECTION_CHANGE,
                                    (0, _clone2.default)(this.lastRange),
                                    (0, _clone2.default)(oldRange),
                                    source
                                ];
                                (_emitter = this.emitter).emit.apply(_emitter, [
                                    _emitter4.default.events.EDITOR_CHANGE
                                ].concat(args));
                                if (source !== _emitter4.default.sources.SILENT) {
                                    var _emitter2;
                                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                                }
                            }
                        }
                    }
                ]);
                return Selection;
            }();
            function contains(parent, descendant) {
                try {
                    // Firefox inserts inaccessible nodes around video elements
                    descendant.parentNode;
                } catch (e) {
                    return false;
                }
                // IE11 has bug with Text nodes
                // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
                if (descendant instanceof Text) descendant = descendant.parentNode;
                return parent.contains(descendant);
            }
            exports.Range = Range;
            exports.default = Selection;
        /***/ },
        /* 16 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Break = function(_Parchment$Embed) {
                _inherits(Break, _Parchment$Embed);
                function Break() {
                    _classCallCheck(this, Break);
                    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
                }
                _createClass(Break, [
                    {
                        key: 'insertInto',
                        value: function insertInto(parent, ref) {
                            if (parent.children.length === 0) _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
                            else this.remove();
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            return 0;
                        }
                    },
                    {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }
                ], [
                    {
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                return Break;
            }(_parchment2.default.Embed);
            Break.blotName = 'break';
            Break.tagName = 'BR';
            exports.default = Break;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var linked_list_1 = __webpack_require__(44);
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var ContainerBlot = /** @class */ function(_super) {
                __extends(ContainerBlot, _super);
                function ContainerBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.build();
                    return _this;
                }
                ContainerBlot.prototype.appendChild = function(other) {
                    this.insertBefore(other);
                };
                ContainerBlot.prototype.attach = function() {
                    _super.prototype.attach.call(this);
                    this.children.forEach(function(child) {
                        child.attach();
                    });
                };
                ContainerBlot.prototype.build = function() {
                    var _this = this;
                    this.children = new linked_list_1.default();
                    // Need to be reversed for if DOM nodes already in order
                    [].slice.call(this.domNode.childNodes).reverse().forEach(function(node) {
                        try {
                            var child = makeBlot(node);
                            _this.insertBefore(child, _this.children.head || undefined);
                        } catch (err) {
                            if (err instanceof Registry.ParchmentError) return;
                            else throw err;
                        }
                    });
                };
                ContainerBlot.prototype.deleteAt = function(index, length) {
                    if (index === 0 && length === this.length()) return this.remove();
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.deleteAt(offset, length);
                    });
                };
                ContainerBlot.prototype.descendant = function(criteria, index) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) return [
                        child,
                        offset
                    ];
                    else if (child instanceof ContainerBlot) return child.descendant(criteria, offset);
                    else return [
                        null,
                        -1
                    ];
                };
                ContainerBlot.prototype.descendants = function(criteria, index, length) {
                    if (index === void 0) index = 0;
                    if (length === void 0) length = Number.MAX_VALUE;
                    var descendants = [];
                    var lengthLeft = length;
                    this.children.forEachAt(index, length, function(child, index, length) {
                        if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) descendants.push(child);
                        if (child instanceof ContainerBlot) descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
                        lengthLeft -= length;
                    });
                    return descendants;
                };
                ContainerBlot.prototype.detach = function() {
                    this.children.forEach(function(child) {
                        child.detach();
                    });
                    _super.prototype.detach.call(this);
                };
                ContainerBlot.prototype.formatAt = function(index, length, name, value) {
                    this.children.forEachAt(index, length, function(child, offset, length) {
                        child.formatAt(offset, length, name, value);
                    });
                };
                ContainerBlot.prototype.insertAt = function(index, value, def) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (child) child.insertAt(offset, value, def);
                    else {
                        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                        this.appendChild(blot);
                    }
                };
                ContainerBlot.prototype.insertBefore = function(childBlot, refBlot) {
                    if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(child) {
                        return childBlot instanceof child;
                    })) throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
                    childBlot.insertInto(this, refBlot);
                };
                ContainerBlot.prototype.length = function() {
                    return this.children.reduce(function(memo, child) {
                        return memo + child.length();
                    }, 0);
                };
                ContainerBlot.prototype.moveChildren = function(targetParent, refNode) {
                    this.children.forEach(function(child) {
                        targetParent.insertBefore(child, refNode);
                    });
                };
                ContainerBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    if (this.children.length === 0) {
                        if (this.statics.defaultChild != null) {
                            var child = Registry.create(this.statics.defaultChild);
                            this.appendChild(child);
                            child.optimize(context);
                        } else this.remove();
                    }
                };
                ContainerBlot.prototype.path = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
                    var position = [
                        [
                            this,
                            index
                        ]
                    ];
                    if (child instanceof ContainerBlot) return position.concat(child.path(offset, inclusive));
                    else if (child != null) position.push([
                        child,
                        offset
                    ]);
                    return position;
                };
                ContainerBlot.prototype.removeChild = function(child) {
                    this.children.remove(child);
                };
                ContainerBlot.prototype.replace = function(target) {
                    if (target instanceof ContainerBlot) target.moveChildren(this);
                    _super.prototype.replace.call(this, target);
                };
                ContainerBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = this.clone();
                    this.parent.insertBefore(after, this.next);
                    this.children.forEachAt(index, this.length(), function(child, offset, length) {
                        child = child.split(offset, force);
                        after.appendChild(child);
                    });
                    return after;
                };
                ContainerBlot.prototype.unwrap = function() {
                    this.moveChildren(this.parent, this.next);
                    this.remove();
                };
                ContainerBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    var addedNodes = [];
                    var removedNodes = [];
                    mutations.forEach(function(mutation) {
                        if (mutation.target === _this.domNode && mutation.type === 'childList') {
                            addedNodes.push.apply(addedNodes, mutation.addedNodes);
                            removedNodes.push.apply(removedNodes, mutation.removedNodes);
                        }
                    });
                    removedNodes.forEach(function(node) {
                        // Check node has actually been removed
                        // One exception is Chrome does not immediately remove IFRAMEs
                        // from DOM but MutationRecord is correct in its reported removal
                        if (node.parentNode != null && // @ts-ignore
                        node.tagName !== 'IFRAME' && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
                        var blot = Registry.find(node);
                        if (blot == null) return;
                        if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) blot.detach();
                    });
                    addedNodes.filter(function(node) {
                        return node.parentNode == _this.domNode;
                    }).sort(function(a, b) {
                        if (a === b) return 0;
                        if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
                        return -1;
                    }).forEach(function(node) {
                        var refBlot = null;
                        if (node.nextSibling != null) refBlot = Registry.find(node.nextSibling);
                        var blot = makeBlot(node);
                        if (blot.next != refBlot || blot.next == null) {
                            if (blot.parent != null) blot.parent.removeChild(_this);
                            _this.insertBefore(blot, refBlot || undefined);
                        }
                    });
                };
                return ContainerBlot;
            }(shadow_1.default);
            function makeBlot(node) {
                var blot = Registry.find(node);
                if (blot == null) try {
                    blot = Registry.create(node);
                } catch (e) {
                    blot = Registry.create(Registry.Scope.INLINE);
                    [].slice.call(node.childNodes).forEach(function(child) {
                        // @ts-ignore
                        blot.domNode.appendChild(child);
                    });
                    if (node.parentNode) node.parentNode.replaceChild(blot.domNode, node);
                    blot.attach();
                }
                return blot;
            }
            exports.default = ContainerBlot;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var store_1 = __webpack_require__(31);
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var FormatBlot = /** @class */ function(_super) {
                __extends(FormatBlot, _super);
                function FormatBlot(domNode) {
                    var _this = _super.call(this, domNode) || this;
                    _this.attributes = new store_1.default(_this.domNode);
                    return _this;
                }
                FormatBlot.formats = function(domNode) {
                    if (typeof this.tagName === 'string') return true;
                    else if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
                    return undefined;
                };
                FormatBlot.prototype.format = function(name, value) {
                    var format = Registry.query(name);
                    if (format instanceof attributor_1.default) this.attributes.attribute(format, value);
                    else if (value) {
                        if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) this.replaceWith(name, value);
                    }
                };
                FormatBlot.prototype.formats = function() {
                    var formats = this.attributes.values();
                    var format = this.statics.formats(this.domNode);
                    if (format != null) formats[this.statics.blotName] = format;
                    return formats;
                };
                FormatBlot.prototype.replaceWith = function(name, value) {
                    var replacement = _super.prototype.replaceWith.call(this, name, value);
                    this.attributes.copy(replacement);
                    return replacement;
                };
                FormatBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    _super.prototype.update.call(this, mutations, context);
                    if (mutations.some(function(mutation) {
                        return mutation.target === _this.domNode && mutation.type === 'attributes';
                    })) this.attributes.build();
                };
                FormatBlot.prototype.wrap = function(name, value) {
                    var wrapper = _super.prototype.wrap.call(this, name, value);
                    if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) this.attributes.move(wrapper);
                    return wrapper;
                };
                return FormatBlot;
            }(container_1.default);
            exports.default = FormatBlot;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var LeafBlot = /** @class */ function(_super) {
                __extends(LeafBlot, _super);
                function LeafBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                LeafBlot.value = function(domNode) {
                    return true;
                };
                LeafBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return Math.min(offset, 1);
                    return -1;
                };
                LeafBlot.prototype.position = function(index, inclusive) {
                    var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                    if (index > 0) offset += 1;
                    return [
                        this.parent.domNode,
                        offset
                    ];
                };
                LeafBlot.prototype.value = function() {
                    var _a;
                    return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
                };
                LeafBlot.scope = Registry.Scope.INLINE_BLOT;
                return LeafBlot;
            }(shadow_1.default);
            exports.default = LeafBlot;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var lib = {
                attributes: {
                    compose: function(a, b, keepNull) {
                        if (typeof a !== 'object') a = {};
                        if (typeof b !== 'object') b = {};
                        var attributes = extend(true, {}, b);
                        if (!keepNull) attributes = Object.keys(attributes).reduce(function(copy, key) {
                            if (attributes[key] != null) copy[key] = attributes[key];
                            return copy;
                        }, {});
                        for(var key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    diff: function(a, b) {
                        if (typeof a !== 'object') a = {};
                        if (typeof b !== 'object') b = {};
                        var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function(attributes, key) {
                            if (!equal(a[key], b[key])) attributes[key] = b[key] === undefined ? null : b[key];
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    transform: function(a, b, priority) {
                        if (typeof a !== 'object') return b;
                        if (typeof b !== 'object') return undefined;
                        if (!priority) return b; // b simply overwrites us without priority
                        var attributes = Object.keys(b).reduce(function(attributes, key) {
                            if (a[key] === undefined) attributes[key] = b[key]; // null is a valid value
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    }
                },
                iterator: function(ops) {
                    return new Iterator(ops);
                },
                length: function(op) {
                    if (typeof op['delete'] === 'number') return op['delete'];
                    else if (typeof op.retain === 'number') return op.retain;
                    else return typeof op.insert === 'string' ? op.insert.length : 1;
                }
            };
            function Iterator(ops) {
                this.ops = ops;
                this.index = 0;
                this.offset = 0;
            }
            Iterator.prototype.hasNext = function() {
                return this.peekLength() < Infinity;
            };
            Iterator.prototype.next = function(length) {
                if (!length) length = Infinity;
                var nextOp = this.ops[this.index];
                if (nextOp) {
                    var offset = this.offset;
                    var opLength = lib.length(nextOp);
                    if (length >= opLength - offset) {
                        length = opLength - offset;
                        this.index += 1;
                        this.offset = 0;
                    } else this.offset += length;
                    if (typeof nextOp['delete'] === 'number') return {
                        'delete': length
                    };
                    else {
                        var retOp = {};
                        if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                        if (typeof nextOp.retain === 'number') retOp.retain = length;
                        else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                        else // offset should === 0, length should === 1
                        retOp.insert = nextOp.insert;
                        return retOp;
                    }
                } else return {
                    retain: Infinity
                };
            };
            Iterator.prototype.peek = function() {
                return this.ops[this.index];
            };
            Iterator.prototype.peekLength = function() {
                if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
                return lib.length(this.ops[this.index]) - this.offset;
                else return Infinity;
            };
            Iterator.prototype.peekType = function() {
                if (this.ops[this.index]) {
                    if (typeof this.ops[this.index]['delete'] === 'number') return 'delete';
                    else if (typeof this.ops[this.index].retain === 'number') return 'retain';
                    else return 'insert';
                }
                return 'retain';
            };
            Iterator.prototype.rest = function() {
                if (!this.hasNext()) return [];
                else if (this.offset === 0) return this.ops.slice(this.index);
                else {
                    var offset = this.offset;
                    var index = this.index;
                    var next = this.next();
                    var rest = this.ops.slice(this.index);
                    this.offset = offset;
                    this.index = index;
                    return [
                        next
                    ].concat(rest);
                }
            };
            module1.exports = lib;
        /***/ },
        /* 21 */ /***/ function(module1, exports) {
            var clone = function() {
                'use strict';
                function _instanceof(obj, type) {
                    return type != null && obj instanceof type;
                }
                var nativeMap;
                try {
                    nativeMap = Map;
                } catch (_) {
                    // maybe a reference error because no `Map`. Give it a dummy value that no
                    // value will ever be an instanceof.
                    nativeMap = function() {};
                }
                var nativeSet;
                try {
                    nativeSet = Set;
                } catch (_) {
                    nativeSet = function() {};
                }
                var nativePromise;
                try {
                    nativePromise = Promise;
                } catch (_) {
                    nativePromise = function() {};
                }
                /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
                    if (typeof circular === 'object') {
                        depth = circular.depth;
                        prototype = circular.prototype;
                        includeNonEnumerable = circular.includeNonEnumerable;
                        circular = circular.circular;
                    }
                    // maintain two arrays for circular references, where corresponding parents
                    // and children have the same index
                    var allParents = [];
                    var allChildren = [];
                    var useBuffer = typeof $e80f8a4a1c6d6220$require$Buffer != 'undefined';
                    if (typeof circular == 'undefined') circular = true;
                    if (typeof depth == 'undefined') depth = Infinity;
                    // recurse this function so we don't reset allParents and allChildren
                    function _clone(parent, depth) {
                        // cloning null always returns null
                        if (parent === null) return null;
                        if (depth === 0) return parent;
                        var child;
                        var proto;
                        if (typeof parent != 'object') return parent;
                        if (_instanceof(parent, nativeMap)) child = new nativeMap();
                        else if (_instanceof(parent, nativeSet)) child = new nativeSet();
                        else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                            parent.then(function(value) {
                                resolve(_clone(value, depth - 1));
                            }, function(err) {
                                reject(_clone(err, depth - 1));
                            });
                        });
                        else if (clone.__isArray(parent)) child = [];
                        else if (clone.__isRegExp(parent)) {
                            child = new RegExp(parent.source, __getRegExpFlags(parent));
                            if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                        } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                        else if (useBuffer && $e80f8a4a1c6d6220$require$Buffer.isBuffer(parent)) {
                            if ($e80f8a4a1c6d6220$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                            child = $e80f8a4a1c6d6220$require$Buffer.allocUnsafe(parent.length);
                            else // Older Node.js versions
                            child = new $e80f8a4a1c6d6220$require$Buffer(parent.length);
                            parent.copy(child);
                            return child;
                        } else if (_instanceof(parent, Error)) child = Object.create(parent);
                        else if (typeof prototype == 'undefined') {
                            proto = Object.getPrototypeOf(parent);
                            child = Object.create(proto);
                        } else {
                            child = Object.create(prototype);
                            proto = prototype;
                        }
                        if (circular) {
                            var index = allParents.indexOf(parent);
                            if (index != -1) return allChildren[index];
                            allParents.push(parent);
                            allChildren.push(child);
                        }
                        if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                            var keyChild = _clone(key, depth - 1);
                            var valueChild = _clone(value, depth - 1);
                            child.set(keyChild, valueChild);
                        });
                        if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                            var entryChild = _clone(value, depth - 1);
                            child.add(entryChild);
                        });
                        for(var i in parent){
                            var attrs;
                            if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                            if (attrs && attrs.set == null) continue;
                            child[i] = _clone(parent[i], depth - 1);
                        }
                        if (Object.getOwnPropertySymbols) {
                            var symbols = Object.getOwnPropertySymbols(parent);
                            for(var i = 0; i < symbols.length; i++){
                                // Don't need to worry about cloning a symbol because it is a primitive,
                                // like a number or string.
                                var symbol = symbols[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                                child[symbol] = _clone(parent[symbol], depth - 1);
                                if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                                    enumerable: false
                                });
                            }
                        }
                        if (includeNonEnumerable) {
                            var allPropertyNames = Object.getOwnPropertyNames(parent);
                            for(var i = 0; i < allPropertyNames.length; i++){
                                var propertyName = allPropertyNames[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                                if (descriptor && descriptor.enumerable) continue;
                                child[propertyName] = _clone(parent[propertyName], depth - 1);
                                Object.defineProperty(child, propertyName, {
                                    enumerable: false
                                });
                            }
                        }
                        return child;
                    }
                    return _clone(parent, depth);
                }
                /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
                    if (parent === null) return null;
                    var c = function() {};
                    c.prototype = parent;
                    return new c();
                };
                // private utility functions
                function __objToStr(o) {
                    return Object.prototype.toString.call(o);
                }
                clone.__objToStr = __objToStr;
                function __isDate(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object Date]';
                }
                clone.__isDate = __isDate;
                function __isArray(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object Array]';
                }
                clone.__isArray = __isArray;
                function __isRegExp(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
                }
                clone.__isRegExp = __isRegExp;
                function __getRegExpFlags(re) {
                    var flags = '';
                    if (re.global) flags += 'g';
                    if (re.ignoreCase) flags += 'i';
                    if (re.multiline) flags += 'm';
                    return flags;
                }
                clone.__getRegExpFlags = __getRegExpFlags;
                return clone;
            }();
            if (typeof module1 === 'object' && module1.exports) module1.exports = clone;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            function isLine(blot) {
                return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
            }
            var Scroll = function(_Parchment$Scroll) {
                _inherits(Scroll, _Parchment$Scroll);
                function Scroll(domNode, config) {
                    _classCallCheck(this, Scroll);
                    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
                    _this.emitter = config.emitter;
                    if (Array.isArray(config.whitelist)) _this.whitelist = config.whitelist.reduce(function(whitelist, format) {
                        whitelist[format] = true;
                        return whitelist;
                    }, {});
                    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
                    _this.domNode.addEventListener('DOMNodeInserted', function() {});
                    _this.optimize();
                    _this.enable();
                    return _this;
                }
                _createClass(Scroll, [
                    {
                        key: 'batchStart',
                        value: function batchStart() {
                            this.batch = true;
                        }
                    },
                    {
                        key: 'batchEnd',
                        value: function batchEnd() {
                            this.batch = false;
                            this.optimize();
                        }
                    },
                    {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                            var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
                            if (last != null && first !== last && offset > 0) {
                                if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                                    this.optimize();
                                    return;
                                }
                                if (first instanceof _code2.default) {
                                    var newlineIndex = first.newlineIndex(first.length(), true);
                                    if (newlineIndex > -1) {
                                        first = first.split(newlineIndex + 1);
                                        if (first === last) {
                                            this.optimize();
                                            return;
                                        }
                                    }
                                } else if (last instanceof _code2.default) {
                                    var _newlineIndex = last.newlineIndex(0);
                                    if (_newlineIndex > -1) last.split(_newlineIndex + 1);
                                }
                                var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                                first.moveChildren(last, ref);
                                first.remove();
                            }
                            this.optimize();
                        }
                    },
                    {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.domNode.setAttribute('contenteditable', enabled);
                        }
                    },
                    {
                        key: 'formatAt',
                        value: function formatAt(index, length, format, value) {
                            if (this.whitelist != null && !this.whitelist[format]) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
                            this.optimize();
                        }
                    },
                    {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null && this.whitelist != null && !this.whitelist[value]) return;
                            if (index >= this.length()) {
                                if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                                    var blot = _parchment2.default.create(this.statics.defaultChild);
                                    this.appendChild(blot);
                                    if (def == null && value.endsWith('\n')) value = value.slice(0, -1);
                                    blot.insertAt(0, value, def);
                                } else {
                                    var embed = _parchment2.default.create(value, def);
                                    this.appendChild(embed);
                                }
                            } else _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
                            this.optimize();
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                                var wrapper = _parchment2.default.create(this.statics.defaultChild);
                                wrapper.appendChild(blot);
                                blot = wrapper;
                            }
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
                        }
                    },
                    {
                        key: 'leaf',
                        value: function leaf(index) {
                            return this.path(index).pop() || [
                                null,
                                -1
                            ];
                        }
                    },
                    {
                        key: 'line',
                        value: function line(index) {
                            if (index === this.length()) return this.line(index - 1);
                            return this.descendant(isLine, index);
                        }
                    },
                    {
                        key: 'lines',
                        value: function lines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            var getLines = function getLines(blot, index, length) {
                                var lines = [], lengthLeft = length;
                                blot.children.forEachAt(index, length, function(child, index, length) {
                                    if (isLine(child)) lines.push(child);
                                    else if (child instanceof _parchment2.default.Container) lines = lines.concat(getLines(child, index, lengthLeft));
                                    lengthLeft -= length;
                                });
                                return lines;
                            };
                            return getLines(this, index, length);
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize() {
                            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            if (this.batch === true) return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                        }
                    },
                    {
                        key: 'path',
                        value: function path(index) {
                            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations) {
                            if (this.batch === true) return;
                            var source = _emitter2.default.sources.USER;
                            if (typeof mutations === 'string') source = mutations;
                            if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
                            if (mutations.length > 0) this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                        }
                    }
                ]);
                return Scroll;
            }(_parchment2.default.Scroll);
            Scroll.blotName = 'scroll';
            Scroll.className = 'ql-editor';
            Scroll.tagName = 'DIV';
            Scroll.defaultChild = 'block';
            Scroll.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                _container2.default
            ];
            exports.default = Scroll;
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SHORTKEY = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:keyboard');
            var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
            var Keyboard = function(_Module) {
                _inherits(Keyboard, _Module);
                _createClass(Keyboard, null, [
                    {
                        key: 'match',
                        value: function match(evt, binding) {
                            binding = normalize(binding);
                            if ([
                                'altKey',
                                'ctrlKey',
                                'metaKey',
                                'shiftKey'
                            ].some(function(key) {
                                return !!binding[key] !== evt[key] && binding[key] !== null;
                            })) return false;
                            return binding.key === (evt.which || evt.keyCode);
                        }
                    }
                ]);
                function Keyboard(quill, options) {
                    _classCallCheck(this, Keyboard);
                    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
                    _this.bindings = {};
                    Object.keys(_this.options.bindings).forEach(function(name) {
                        if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) return;
                        if (_this.options.bindings[name]) _this.addBinding(_this.options.bindings[name]);
                    });
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        shiftKey: null
                    }, handleEnter);
                    _this.addBinding({
                        key: Keyboard.keys.ENTER,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null
                    }, function() {});
                    if (/Firefox/i.test(navigator.userAgent)) {
                        // Need to handle delete and backspace for Firefox in the general case #1171
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true
                        }, handleDelete);
                    } else {
                        _this.addBinding({
                            key: Keyboard.keys.BACKSPACE
                        }, {
                            collapsed: true,
                            prefix: /^.?$/
                        }, handleBackspace);
                        _this.addBinding({
                            key: Keyboard.keys.DELETE
                        }, {
                            collapsed: true,
                            suffix: /^.?$/
                        }, handleDelete);
                    }
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.DELETE
                    }, {
                        collapsed: false
                    }, handleDeleteRange);
                    _this.addBinding({
                        key: Keyboard.keys.BACKSPACE,
                        altKey: null,
                        ctrlKey: null,
                        metaKey: null,
                        shiftKey: null
                    }, {
                        collapsed: true,
                        offset: 0
                    }, handleBackspace);
                    _this.listen();
                    return _this;
                }
                _createClass(Keyboard, [
                    {
                        key: 'addBinding',
                        value: function addBinding(key) {
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            var binding = normalize(key);
                            if (binding == null || binding.key == null) return debug.warn('Attempted to add invalid keyboard binding', binding);
                            if (typeof context === 'function') context = {
                                handler: context
                            };
                            if (typeof handler === 'function') handler = {
                                handler: handler
                            };
                            binding = (0, _extend2.default)(binding, context, handler);
                            this.bindings[binding.key] = this.bindings[binding.key] || [];
                            this.bindings[binding.key].push(binding);
                        }
                    },
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this2 = this;
                            this.quill.root.addEventListener('keydown', function(evt) {
                                if (evt.defaultPrevented) return;
                                var which = evt.which || evt.keyCode;
                                var bindings = (_this2.bindings[which] || []).filter(function(binding) {
                                    return Keyboard.match(evt, binding);
                                });
                                if (bindings.length === 0) return;
                                var range = _this2.quill.getSelection();
                                if (range == null || !_this2.quill.hasFocus()) return;
                                var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line = _quill$getLine2[0], offset = _quill$getLine2[1];
                                var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                                var _ref = range.length === 0 ? [
                                    leafStart,
                                    offsetStart
                                ] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                                var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
                                var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
                                var curContext = {
                                    collapsed: range.length === 0,
                                    empty: range.length === 0 && line.length() <= 1,
                                    format: _this2.quill.getFormat(range),
                                    offset: offset,
                                    prefix: prefixText,
                                    suffix: suffixText
                                };
                                var prevented = bindings.some(function(binding) {
                                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                                    if (binding.empty != null && binding.empty !== curContext.empty) return false;
                                    if (binding.offset != null && binding.offset !== curContext.offset) return false;
                                    if (Array.isArray(binding.format)) {
                                        // any format is present
                                        if (binding.format.every(function(name) {
                                            return curContext.format[name] == null;
                                        })) return false;
                                    } else if (_typeof(binding.format) === 'object') {
                                        // all formats must match
                                        if (!Object.keys(binding.format).every(function(name) {
                                            if (binding.format[name] === true) return curContext.format[name] != null;
                                            if (binding.format[name] === false) return curContext.format[name] == null;
                                            return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                                        })) return false;
                                    }
                                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                                    return binding.handler.call(_this2, range, curContext) !== true;
                                });
                                if (prevented) evt.preventDefault();
                            });
                        }
                    }
                ]);
                return Keyboard;
            }(_module2.default);
            Keyboard.keys = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
            };
            Keyboard.DEFAULTS = {
                bindings: {
                    'bold': makeFormatHandler('bold'),
                    'italic': makeFormatHandler('italic'),
                    'underline': makeFormatHandler('underline'),
                    'indent': {
                        // highlight tab or tab at beginning of list, indent or blockquote
                        key: Keyboard.keys.TAB,
                        format: [
                            'blockquote',
                            'indent',
                            'list'
                        ],
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format('indent', '+1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        format: [
                            'blockquote',
                            'indent',
                            'list'
                        ],
                        // highlight tab or tab at beginning of list, indent or blockquote
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0) return true;
                            this.quill.format('indent', '-1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent backspace': {
                        key: Keyboard.keys.BACKSPACE,
                        collapsed: true,
                        shiftKey: null,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null,
                        format: [
                            'indent',
                            'list'
                        ],
                        offset: 0,
                        handler: function handler(range, context) {
                            if (context.format.indent != null) this.quill.format('indent', '-1', _quill2.default.sources.USER);
                            else if (context.format.list != null) this.quill.format('list', false, _quill2.default.sources.USER);
                        }
                    },
                    'indent code-block': makeCodeBlockHandler(true),
                    'outdent code-block': makeCodeBlockHandler(false),
                    'remove tab': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        collapsed: true,
                        prefix: /\t$/,
                        handler: function handler(range) {
                            this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                        }
                    },
                    'tab': {
                        key: Keyboard.keys.TAB,
                        handler: function handler(range) {
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                        }
                    },
                    'list empty enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'list'
                        ],
                        empty: true,
                        handler: function handler(range, context) {
                            this.quill.format('list', false, _quill2.default.sources.USER);
                            if (context.format.indent) this.quill.format('indent', false, _quill2.default.sources.USER);
                        }
                    },
                    'checklist enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: {
                            list: 'checked'
                        },
                        handler: function handler(range) {
                            var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line = _quill$getLine4[0], offset = _quill$getLine4[1];
                            var formats = (0, _extend2.default)({}, line.formats(), {
                                list: 'checked'
                            });
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, {
                                list: 'unchecked'
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'header enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'header'
                        ],
                        suffix: /^$/,
                        handler: function handler(range, context) {
                            var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line = _quill$getLine6[0], offset = _quill$getLine6[1];
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, {
                                header: null
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'list autofill': {
                        key: ' ',
                        collapsed: true,
                        format: {
                            list: false
                        },
                        prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                        handler: function handler(range, context) {
                            var length = context.prefix.length;
                            var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line = _quill$getLine8[0], offset = _quill$getLine8[1];
                            if (offset > length) return true;
                            var value = void 0;
                            switch(context.prefix.trim()){
                                case '[]':
                                case '[ ]':
                                    value = 'unchecked';
                                    break;
                                case '[x]':
                                    value = 'checked';
                                    break;
                                case '-':
                                case '*':
                                    value = 'bullet';
                                    break;
                                default:
                                    value = 'ordered';
                            }
                            this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, {
                                list: value
                            });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                        }
                    },
                    'code exit': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: [
                            'code-block'
                        ],
                        prefix: /\n\n$/,
                        suffix: /^\s+$/,
                        handler: function handler(range) {
                            var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line = _quill$getLine10[0], offset = _quill$getLine10[1];
                            var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, {
                                'code-block': null
                            }).delete(1);
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                        }
                    },
                    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
                    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
                    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
                    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
                }
            };
            function makeEmbedArrowHandler(key, shiftKey) {
                var _ref3;
                var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
                return _ref3 = {
                    key: key,
                    shiftKey: shiftKey,
                    altKey: null
                }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
                    var index = range.index;
                    if (key === Keyboard.keys.RIGHT) index += range.length + 1;
                    var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
                    if (!(leaf instanceof _parchment2.default.Embed)) return true;
                    if (key === Keyboard.keys.LEFT) {
                        if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                        else this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                    } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                    else this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                    return false;
                }), _ref3;
            }
            function handleBackspace(range, context) {
                if (range.index === 0 || this.quill.getLength() <= 1) return;
                var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line = _quill$getLine12[0];
                var formats = {};
                if (context.offset === 0) {
                    var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
                    if (prev != null && prev.length() > 1) {
                        var curFormats = line.formats();
                        var prevFormats = this.quill.getFormat(range.index - 1, 1);
                        formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
                    }
                }
                // Check for astral symbols
                var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
                this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
                this.quill.focus();
            }
            function handleDelete(range, context) {
                // Check for astral symbols
                var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
                if (range.index >= this.quill.getLength() - length) return;
                var formats = {}, nextLength = 0;
                var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line = _quill$getLine16[0];
                if (context.offset >= line.length() - 1) {
                    var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
                    if (next) {
                        var curFormats = line.formats();
                        var nextFormats = this.quill.getFormat(range.index, 1);
                        formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                        nextLength = next.length();
                    }
                }
                this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
            }
            function handleDeleteRange(range) {
                var lines = this.quill.getLines(range);
                var formats = {};
                if (lines.length > 1) {
                    var firstFormats = lines[0].formats();
                    var lastFormats = lines[lines.length - 1].formats();
                    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
                }
                this.quill.deleteText(range, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
                this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
                this.quill.focus();
            }
            function handleEnter(range, context) {
                var _this3 = this;
                if (range.length > 0) this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
                var lineFormats = Object.keys(context.format).reduce(function(lineFormats, format) {
                    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) lineFormats[format] = context.format[format];
                    return lineFormats;
                }, {});
                this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
                // Earlier scroll.deleteAt might have messed up our selection,
                // so insertText's built in selection preservation is not reliable
                this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                this.quill.focus();
                Object.keys(context.format).forEach(function(name) {
                    if (lineFormats[name] != null) return;
                    if (Array.isArray(context.format[name])) return;
                    if (name === 'link') return;
                    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
                });
            }
            function makeCodeBlockHandler(indent) {
                return {
                    key: Keyboard.keys.TAB,
                    shiftKey: !indent,
                    format: {
                        'code-block': true
                    },
                    handler: function handler(range) {
                        var CodeBlock = _parchment2.default.query('code-block');
                        var index = range.index, length = range.length;
                        var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                        if (block == null) return;
                        var scrollIndex = this.quill.getIndex(block);
                        var start = block.newlineIndex(offset, true) + 1;
                        var end = block.newlineIndex(scrollIndex + offset + length);
                        var lines = block.domNode.textContent.slice(start, end).split('\n');
                        offset = 0;
                        lines.forEach(function(line, i) {
                            if (indent) {
                                block.insertAt(start + offset, CodeBlock.TAB);
                                offset += CodeBlock.TAB.length;
                                if (i === 0) index += CodeBlock.TAB.length;
                                else length += CodeBlock.TAB.length;
                            } else if (line.startsWith(CodeBlock.TAB)) {
                                block.deleteAt(start + offset, CodeBlock.TAB.length);
                                offset -= CodeBlock.TAB.length;
                                if (i === 0) index -= CodeBlock.TAB.length;
                                else length -= CodeBlock.TAB.length;
                            }
                            offset += line.length + 1;
                        });
                        this.quill.update(_quill2.default.sources.USER);
                        this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
                    }
                };
            }
            function makeFormatHandler(format) {
                return {
                    key: format[0].toUpperCase(),
                    shortKey: true,
                    handler: function handler(range, context) {
                        this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
                    }
                };
            }
            function normalize(binding) {
                if (typeof binding === 'string' || typeof binding === 'number') return normalize({
                    key: binding
                });
                if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') binding = (0, _clone2.default)(binding, false);
                if (typeof binding.key === 'string') {
                    if (Keyboard.keys[binding.key.toUpperCase()] != null) binding.key = Keyboard.keys[binding.key.toUpperCase()];
                    else if (binding.key.length === 1) binding.key = binding.key.toUpperCase().charCodeAt(0);
                    else return null;
                }
                if (binding.shortKey) {
                    binding[SHORTKEY] = binding.shortKey;
                    delete binding.shortKey;
                }
                return binding;
            }
            exports.default = Keyboard;
            exports.SHORTKEY = SHORTKEY;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Cursor = function(_Parchment$Embed) {
                _inherits(Cursor, _Parchment$Embed);
                _createClass(Cursor, null, [
                    {
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }
                ]);
                function Cursor(domNode, selection) {
                    _classCallCheck(this, Cursor);
                    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
                    _this.selection = selection;
                    _this.textNode = document.createTextNode(Cursor.CONTENTS);
                    _this.domNode.appendChild(_this.textNode);
                    _this._length = 0;
                    return _this;
                }
                _createClass(Cursor, [
                    {
                        key: 'detach',
                        value: function detach() {
                            // super.detach() will also clear domNode.__blot
                            if (this.parent != null) this.parent.removeChild(this);
                        }
                    },
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (this._length !== 0) return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
                            var target = this, index = 0;
                            while(target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT){
                                index += target.offset(target.parent);
                                target = target.parent;
                            }
                            if (target != null) {
                                this._length = Cursor.CONTENTS.length;
                                target.optimize();
                                target.formatAt(index, Cursor.CONTENTS.length, name, value);
                                this._length = 0;
                            }
                        }
                    },
                    {
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.textNode) return 0;
                            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
                        }
                    },
                    {
                        key: 'length',
                        value: function length() {
                            return this._length;
                        }
                    },
                    {
                        key: 'position',
                        value: function position() {
                            return [
                                this.textNode,
                                this.textNode.data.length
                            ];
                        }
                    },
                    {
                        key: 'remove',
                        value: function remove() {
                            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
                            this.parent = null;
                        }
                    },
                    {
                        key: 'restore',
                        value: function restore() {
                            if (this.selection.composing || this.parent == null) return;
                            var textNode = this.textNode;
                            var range = this.selection.getNativeRange();
                            var restoreText = void 0, start = void 0, end = void 0;
                            if (range != null && range.start.node === textNode && range.end.node === textNode) {
                                var _ref = [
                                    textNode,
                                    range.start.offset,
                                    range.end.offset
                                ];
                                restoreText = _ref[0];
                                start = _ref[1];
                                end = _ref[2];
                            }
                            // Link format will insert text outside of anchor tag
                            while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                            if (this.textNode.data !== Cursor.CONTENTS) {
                                var text = this.textNode.data.split(Cursor.CONTENTS).join('');
                                if (this.next instanceof _text2.default) {
                                    restoreText = this.next.domNode;
                                    this.next.insertAt(0, text);
                                    this.textNode.data = Cursor.CONTENTS;
                                } else {
                                    this.textNode.data = text;
                                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                                    this.textNode = document.createTextNode(Cursor.CONTENTS);
                                    this.domNode.appendChild(this.textNode);
                                }
                            }
                            this.remove();
                            if (start != null) {
                                var _map = [
                                    start,
                                    end
                                ].map(function(offset) {
                                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                                });
                                var _map2 = _slicedToArray(_map, 2);
                                start = _map2[0];
                                end = _map2[1];
                                return {
                                    startNode: restoreText,
                                    startOffset: start,
                                    endNode: restoreText,
                                    endOffset: end
                                };
                            }
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            if (mutations.some(function(mutation) {
                                return mutation.type === 'characterData' && mutation.target === _this2.textNode;
                            })) {
                                var range = this.restore();
                                if (range) context.range = range;
                            }
                        }
                    },
                    {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }
                ]);
                return Cursor;
            }(_parchment2.default.Embed);
            Cursor.blotName = 'cursor';
            Cursor.className = 'ql-cursor';
            Cursor.tagName = 'span';
            Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
            exports.default = Cursor;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Container = function(_Parchment$Container) {
                _inherits(Container, _Parchment$Container);
                function Container() {
                    _classCallCheck(this, Container);
                    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
                }
                return Container;
            }(_parchment2.default.Container);
            Container.allowedChildren = [
                _block2.default,
                _block.BlockEmbed,
                Container
            ];
            exports.default = Container;
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorAttributor = function(_Parchment$Attributor) {
                _inherits(ColorAttributor, _Parchment$Attributor);
                function ColorAttributor() {
                    _classCallCheck(this, ColorAttributor);
                    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
                }
                _createClass(ColorAttributor, [
                    {
                        key: 'value',
                        value: function value(domNode) {
                            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
                            if (!value.startsWith('rgb(')) return value;
                            value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
                            return '#' + value.split(',').map(function(component) {
                                return ('00' + parseInt(component).toString(16)).slice(-2);
                            }).join('');
                        }
                    }
                ]);
                return ColorAttributor;
            }(_parchment2.default.Attributor.Style);
            var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            var ColorStyle = new ColorAttributor('color', 'color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.ColorAttributor = ColorAttributor;
            exports.ColorClass = ColorClass;
            exports.ColorStyle = ColorStyle;
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.sanitize = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Link = function(_Inline) {
                _inherits(Link, _Inline);
                function Link() {
                    _classCallCheck(this, Link);
                    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
                }
                _createClass(Link, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
                            value = this.constructor.sanitize(value);
                            this.domNode.setAttribute('href', value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
                            value = this.sanitize(value);
                            node.setAttribute('href', value);
                            node.setAttribute('rel', 'noopener noreferrer');
                            node.setAttribute('target', '_blank');
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.getAttribute('href');
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
                        }
                    }
                ]);
                return Link;
            }(_inline2.default);
            Link.blotName = 'link';
            Link.tagName = 'A';
            Link.SANITIZED_URL = 'about:blank';
            Link.PROTOCOL_WHITELIST = [
                'http',
                'https',
                'mailto',
                'tel'
            ];
            function _sanitize(url, protocols) {
                var anchor = document.createElement('a');
                anchor.href = url;
                var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
                return protocols.indexOf(protocol) > -1;
            }
            exports.default = Link;
            exports.sanitize = _sanitize;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _dropdown = __webpack_require__(107);
            var _dropdown2 = _interopRequireDefault(_dropdown);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var optionsCounter = 0;
            function toggleAriaAttribute(element, attribute) {
                element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
            }
            var Picker = function() {
                function Picker(select) {
                    var _this = this;
                    _classCallCheck(this, Picker);
                    this.select = select;
                    this.container = document.createElement('span');
                    this.buildPicker();
                    this.select.style.display = 'none';
                    this.select.parentNode.insertBefore(this.container, this.select);
                    this.label.addEventListener('mousedown', function() {
                        _this.togglePicker();
                    });
                    this.label.addEventListener('keydown', function(event) {
                        switch(event.keyCode){
                            // Allows the "Enter" key to open the picker
                            case _keyboard2.default.keys.ENTER:
                                _this.togglePicker();
                                break;
                            // Allows the "Escape" key to close the picker
                            case _keyboard2.default.keys.ESCAPE:
                                _this.escape();
                                event.preventDefault();
                                break;
                            default:
                        }
                    });
                    this.select.addEventListener('change', this.update.bind(this));
                }
                _createClass(Picker, [
                    {
                        key: 'togglePicker',
                        value: function togglePicker() {
                            this.container.classList.toggle('ql-expanded');
                            // Toggle aria-expanded and aria-hidden to make the picker accessible
                            toggleAriaAttribute(this.label, 'aria-expanded');
                            toggleAriaAttribute(this.options, 'aria-hidden');
                        }
                    },
                    {
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var _this2 = this;
                            var item = document.createElement('span');
                            item.tabIndex = '0';
                            item.setAttribute('role', 'button');
                            item.classList.add('ql-picker-item');
                            if (option.hasAttribute('value')) item.setAttribute('data-value', option.getAttribute('value'));
                            if (option.textContent) item.setAttribute('data-label', option.textContent);
                            item.addEventListener('click', function() {
                                _this2.selectItem(item, true);
                            });
                            item.addEventListener('keydown', function(event) {
                                switch(event.keyCode){
                                    // Allows the "Enter" key to select an item
                                    case _keyboard2.default.keys.ENTER:
                                        _this2.selectItem(item, true);
                                        event.preventDefault();
                                        break;
                                    // Allows the "Escape" key to close the picker
                                    case _keyboard2.default.keys.ESCAPE:
                                        _this2.escape();
                                        event.preventDefault();
                                        break;
                                    default:
                                }
                            });
                            return item;
                        }
                    },
                    {
                        key: 'buildLabel',
                        value: function buildLabel() {
                            var label = document.createElement('span');
                            label.classList.add('ql-picker-label');
                            label.innerHTML = _dropdown2.default;
                            label.tabIndex = '0';
                            label.setAttribute('role', 'button');
                            label.setAttribute('aria-expanded', 'false');
                            this.container.appendChild(label);
                            return label;
                        }
                    },
                    {
                        key: 'buildOptions',
                        value: function buildOptions() {
                            var _this3 = this;
                            var options = document.createElement('span');
                            options.classList.add('ql-picker-options');
                            // Don't want screen readers to read this until options are visible
                            options.setAttribute('aria-hidden', 'true');
                            options.tabIndex = '-1';
                            // Need a unique id for aria-controls
                            options.id = 'ql-picker-options-' + optionsCounter;
                            optionsCounter += 1;
                            this.label.setAttribute('aria-controls', options.id);
                            this.options = options;
                            [].slice.call(this.select.options).forEach(function(option) {
                                var item = _this3.buildItem(option);
                                options.appendChild(item);
                                if (option.selected === true) _this3.selectItem(item);
                            });
                            this.container.appendChild(options);
                        }
                    },
                    {
                        key: 'buildPicker',
                        value: function buildPicker() {
                            var _this4 = this;
                            [].slice.call(this.select.attributes).forEach(function(item) {
                                _this4.container.setAttribute(item.name, item.value);
                            });
                            this.container.classList.add('ql-picker');
                            this.label = this.buildLabel();
                            this.buildOptions();
                        }
                    },
                    {
                        key: 'escape',
                        value: function escape() {
                            var _this5 = this;
                            // Close menu and return focus to trigger label
                            this.close();
                            // Need setTimeout for accessibility to ensure that the browser executes
                            // focus on the next process thread and after any DOM content changes
                            setTimeout(function() {
                                return _this5.label.focus();
                            }, 1);
                        }
                    },
                    {
                        key: 'close',
                        value: function close() {
                            this.container.classList.remove('ql-expanded');
                            this.label.setAttribute('aria-expanded', 'false');
                            this.options.setAttribute('aria-hidden', 'true');
                        }
                    },
                    {
                        key: 'selectItem',
                        value: function selectItem(item) {
                            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var selected = this.container.querySelector('.ql-selected');
                            if (item === selected) return;
                            if (selected != null) selected.classList.remove('ql-selected');
                            if (item == null) return;
                            item.classList.add('ql-selected');
                            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                            if (item.hasAttribute('data-value')) this.label.setAttribute('data-value', item.getAttribute('data-value'));
                            else this.label.removeAttribute('data-value');
                            if (item.hasAttribute('data-label')) this.label.setAttribute('data-label', item.getAttribute('data-label'));
                            else this.label.removeAttribute('data-label');
                            if (trigger) {
                                if (typeof Event === 'function') this.select.dispatchEvent(new Event('change'));
                                else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
                                    // IE11
                                    var event = document.createEvent('Event');
                                    event.initEvent('change', true, true);
                                    this.select.dispatchEvent(event);
                                }
                                this.close();
                            }
                        }
                    },
                    {
                        key: 'update',
                        value: function update() {
                            var option = void 0;
                            if (this.select.selectedIndex > -1) {
                                var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
                                option = this.select.options[this.select.selectedIndex];
                                this.selectItem(item);
                            } else this.selectItem(null);
                            var isActive = option != null && option !== this.select.querySelector('option[selected]');
                            this.label.classList.toggle('ql-active', isActive);
                        }
                    }
                ]);
                return Picker;
            }();
            exports.default = Picker;
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            var _cursor = __webpack_require__(24);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _scroll = __webpack_require__(22);
            var _scroll2 = _interopRequireDefault(_scroll);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _clipboard = __webpack_require__(55);
            var _clipboard2 = _interopRequireDefault(_clipboard);
            var _history = __webpack_require__(42);
            var _history2 = _interopRequireDefault(_history);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _quill2.default.register({
                'blots/block': _block2.default,
                'blots/block/embed': _block.BlockEmbed,
                'blots/break': _break2.default,
                'blots/container': _container2.default,
                'blots/cursor': _cursor2.default,
                'blots/embed': _embed2.default,
                'blots/inline': _inline2.default,
                'blots/scroll': _scroll2.default,
                'blots/text': _text2.default,
                'modules/clipboard': _clipboard2.default,
                'modules/history': _history2.default,
                'modules/keyboard': _keyboard2.default
            });
            _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
            exports.default = _quill2.default;
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var Registry = __webpack_require__(1);
            var ShadowBlot = /** @class */ function() {
                function ShadowBlot(domNode) {
                    this.domNode = domNode;
                    // @ts-ignore
                    this.domNode[Registry.DATA_KEY] = {
                        blot: this
                    };
                }
                Object.defineProperty(ShadowBlot.prototype, "statics", {
                    // Hack for accessing inherited static methods
                    get: function() {
                        return this.constructor;
                    },
                    enumerable: true,
                    configurable: true
                });
                ShadowBlot.create = function(value) {
                    if (this.tagName == null) throw new Registry.ParchmentError('Blot definition missing tagName');
                    var node;
                    if (Array.isArray(this.tagName)) {
                        if (typeof value === 'string') {
                            value = value.toUpperCase();
                            if (parseInt(value).toString() === value) value = parseInt(value);
                        }
                        if (typeof value === 'number') node = document.createElement(this.tagName[value - 1]);
                        else if (this.tagName.indexOf(value) > -1) node = document.createElement(value);
                        else node = document.createElement(this.tagName[0]);
                    } else node = document.createElement(this.tagName);
                    if (this.className) node.classList.add(this.className);
                    return node;
                };
                ShadowBlot.prototype.attach = function() {
                    if (this.parent != null) this.scroll = this.parent.scroll;
                };
                ShadowBlot.prototype.clone = function() {
                    var domNode = this.domNode.cloneNode(false);
                    return Registry.create(domNode);
                };
                ShadowBlot.prototype.detach = function() {
                    if (this.parent != null) this.parent.removeChild(this);
                    // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY];
                };
                ShadowBlot.prototype.deleteAt = function(index, length) {
                    var blot = this.isolate(index, length);
                    blot.remove();
                };
                ShadowBlot.prototype.formatAt = function(index, length, name, value) {
                    var blot = this.isolate(index, length);
                    if (Registry.query(name, Registry.Scope.BLOT) != null && value) blot.wrap(name, value);
                    else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                        var parent = Registry.create(this.statics.scope);
                        blot.wrap(parent);
                        parent.format(name, value);
                    }
                };
                ShadowBlot.prototype.insertAt = function(index, value, def) {
                    var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                    var ref = this.split(index);
                    this.parent.insertBefore(blot, ref);
                };
                ShadowBlot.prototype.insertInto = function(parentBlot, refBlot) {
                    if (refBlot === void 0) refBlot = null;
                    if (this.parent != null) this.parent.children.remove(this);
                    var refDomNode = null;
                    parentBlot.children.insertBefore(this, refBlot);
                    if (refBlot != null) refDomNode = refBlot.domNode;
                    if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) parentBlot.domNode.insertBefore(this.domNode, refDomNode);
                    this.parent = parentBlot;
                    this.attach();
                };
                ShadowBlot.prototype.isolate = function(index, length) {
                    var target = this.split(index);
                    target.split(length);
                    return target;
                };
                ShadowBlot.prototype.length = function() {
                    return 1;
                };
                ShadowBlot.prototype.offset = function(root) {
                    if (root === void 0) root = this.parent;
                    if (this.parent == null || this == root) return 0;
                    return this.parent.children.offset(this) + this.parent.offset(root);
                };
                ShadowBlot.prototype.optimize = function(context) {
                    // TODO clean up once we use WeakMap
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY] != null) // @ts-ignore
                    delete this.domNode[Registry.DATA_KEY].mutations;
                };
                ShadowBlot.prototype.remove = function() {
                    if (this.domNode.parentNode != null) this.domNode.parentNode.removeChild(this.domNode);
                    this.detach();
                };
                ShadowBlot.prototype.replace = function(target) {
                    if (target.parent == null) return;
                    target.parent.insertBefore(this, target.next);
                    target.remove();
                };
                ShadowBlot.prototype.replaceWith = function(name, value) {
                    var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
                    replacement.replace(this);
                    return replacement;
                };
                ShadowBlot.prototype.split = function(index, force) {
                    return index === 0 ? this : this.next;
                };
                ShadowBlot.prototype.update = function(mutations, context) {
                // Nothing to do by default
                };
                ShadowBlot.prototype.wrap = function(name, value) {
                    var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
                    if (this.parent != null) this.parent.insertBefore(wrapper, this.next);
                    wrapper.appendChild(this);
                    return wrapper;
                };
                ShadowBlot.blotName = 'abstract';
                return ShadowBlot;
            }();
            exports.default = ShadowBlot;
        /***/ },
        /* 31 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var Registry = __webpack_require__(1);
            var AttributorStore = /** @class */ function() {
                function AttributorStore(domNode) {
                    this.attributes = {};
                    this.domNode = domNode;
                    this.build();
                }
                AttributorStore.prototype.attribute = function(attribute, value) {
                    // verb
                    if (value) {
                        if (attribute.add(this.domNode, value)) {
                            if (attribute.value(this.domNode) != null) this.attributes[attribute.attrName] = attribute;
                            else delete this.attributes[attribute.attrName];
                        }
                    } else {
                        attribute.remove(this.domNode);
                        delete this.attributes[attribute.attrName];
                    }
                };
                AttributorStore.prototype.build = function() {
                    var _this = this;
                    this.attributes = {};
                    var attributes = attributor_1.default.keys(this.domNode);
                    var classes = class_1.default.keys(this.domNode);
                    var styles = style_1.default.keys(this.domNode);
                    attributes.concat(classes).concat(styles).forEach(function(name) {
                        var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                        if (attr instanceof attributor_1.default) _this.attributes[attr.attrName] = attr;
                    });
                };
                AttributorStore.prototype.copy = function(target) {
                    var _this = this;
                    Object.keys(this.attributes).forEach(function(key) {
                        var value = _this.attributes[key].value(_this.domNode);
                        target.format(key, value);
                    });
                };
                AttributorStore.prototype.move = function(target) {
                    var _this = this;
                    this.copy(target);
                    Object.keys(this.attributes).forEach(function(key) {
                        _this.attributes[key].remove(_this.domNode);
                    });
                    this.attributes = {};
                };
                AttributorStore.prototype.values = function() {
                    var _this = this;
                    return Object.keys(this.attributes).reduce(function(attributes, name) {
                        attributes[name] = _this.attributes[name].value(_this.domNode);
                        return attributes;
                    }, {});
                };
                return AttributorStore;
            }();
            exports.default = AttributorStore;
        /***/ },
        /* 32 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function match(node, prefix) {
                var className = node.getAttribute('class') || '';
                return className.split(/\s+/).filter(function(name) {
                    return name.indexOf(prefix + "-") === 0;
                });
            }
            var ClassAttributor = /** @class */ function(_super) {
                __extends(ClassAttributor, _super);
                function ClassAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ClassAttributor.keys = function(node) {
                    return (node.getAttribute('class') || '').split(/\s+/).map(function(name) {
                        return name.split('-').slice(0, -1).join('-');
                    });
                };
                ClassAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    this.remove(node);
                    node.classList.add(this.keyName + "-" + value);
                    return true;
                };
                ClassAttributor.prototype.remove = function(node) {
                    var matches = match(node, this.keyName);
                    matches.forEach(function(name) {
                        node.classList.remove(name);
                    });
                    if (node.classList.length === 0) node.removeAttribute('class');
                };
                ClassAttributor.prototype.value = function(node) {
                    var result = match(node, this.keyName)[0] || '';
                    var value = result.slice(this.keyName.length + 1); // +1 for hyphen
                    return this.canAdd(node, value) ? value : '';
                };
                return ClassAttributor;
            }(attributor_1.default);
            exports.default = ClassAttributor;
        /***/ },
        /* 33 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var attributor_1 = __webpack_require__(12);
            function camelize(name) {
                var parts = name.split('-');
                var rest = parts.slice(1).map(function(part) {
                    return part[0].toUpperCase() + part.slice(1);
                }).join('');
                return parts[0] + rest;
            }
            var StyleAttributor = /** @class */ function(_super) {
                __extends(StyleAttributor, _super);
                function StyleAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StyleAttributor.keys = function(node) {
                    return (node.getAttribute('style') || '').split(';').map(function(value) {
                        var arr = value.split(':');
                        return arr[0].trim();
                    });
                };
                StyleAttributor.prototype.add = function(node, value) {
                    if (!this.canAdd(node, value)) return false;
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = value;
                    return true;
                };
                StyleAttributor.prototype.remove = function(node) {
                    // @ts-ignore
                    node.style[camelize(this.keyName)] = '';
                    if (!node.getAttribute('style')) node.removeAttribute('style');
                };
                StyleAttributor.prototype.value = function(node) {
                    // @ts-ignore
                    var value = node.style[camelize(this.keyName)];
                    return this.canAdd(node, value) ? value : '';
                };
                return StyleAttributor;
            }(attributor_1.default);
            exports.default = StyleAttributor;
        /***/ },
        /* 34 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Theme = function() {
                function Theme(quill, options) {
                    _classCallCheck(this, Theme);
                    this.quill = quill;
                    this.options = options;
                    this.modules = {};
                }
                _createClass(Theme, [
                    {
                        key: 'init',
                        value: function init() {
                            var _this = this;
                            Object.keys(this.options.modules).forEach(function(name) {
                                if (_this.modules[name] == null) _this.addModule(name);
                            });
                        }
                    },
                    {
                        key: 'addModule',
                        value: function addModule(name) {
                            var moduleClass = this.quill.constructor.import('modules/' + name);
                            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                            return this.modules[name];
                        }
                    }
                ]);
                return Theme;
            }();
            Theme.DEFAULTS = {
                modules: {}
            };
            Theme.themes = {
                'default': Theme
            };
            exports.default = Theme;
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var GUARD_TEXT = '\uFEFF';
            var Embed = function(_Parchment$Embed) {
                _inherits(Embed, _Parchment$Embed);
                function Embed(node) {
                    _classCallCheck(this, Embed);
                    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
                    _this.contentNode = document.createElement('span');
                    _this.contentNode.setAttribute('contenteditable', false);
                    [].slice.call(_this.domNode.childNodes).forEach(function(childNode) {
                        _this.contentNode.appendChild(childNode);
                    });
                    _this.leftGuard = document.createTextNode(GUARD_TEXT);
                    _this.rightGuard = document.createTextNode(GUARD_TEXT);
                    _this.domNode.appendChild(_this.leftGuard);
                    _this.domNode.appendChild(_this.contentNode);
                    _this.domNode.appendChild(_this.rightGuard);
                    return _this;
                }
                _createClass(Embed, [
                    {
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.leftGuard) return 0;
                            if (node === this.rightGuard) return 1;
                            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
                        }
                    },
                    {
                        key: 'restore',
                        value: function restore(node) {
                            var range = void 0, textNode = void 0;
                            var text = node.data.split(GUARD_TEXT).join('');
                            if (node === this.leftGuard) {
                                if (this.prev instanceof _text2.default) {
                                    var prevLength = this.prev.length();
                                    this.prev.insertAt(prevLength, text);
                                    range = {
                                        startNode: this.prev.domNode,
                                        startOffset: prevLength + text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            } else if (node === this.rightGuard) {
                                if (this.next instanceof _text2.default) {
                                    this.next.insertAt(0, text);
                                    range = {
                                        startNode: this.next.domNode,
                                        startOffset: text.length
                                    };
                                } else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            }
                            node.data = GUARD_TEXT;
                            return range;
                        }
                    },
                    {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            mutations.forEach(function(mutation) {
                                if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                                    var range = _this2.restore(mutation.target);
                                    if (range) context.range = range;
                                }
                            });
                        }
                    }
                ]);
                return Embed;
            }(_parchment2.default.Embed);
            exports.default = Embed;
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    'right',
                    'center',
                    'justify'
                ]
            };
            var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
            var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
            var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
            exports.AlignAttribute = AlignAttribute;
            exports.AlignClass = AlignClass;
            exports.AlignStyle = AlignStyle;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BackgroundStyle = exports.BackgroundClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _color = __webpack_require__(26);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
                scope: _parchment2.default.Scope.INLINE
            });
            var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.BackgroundClass = BackgroundClass;
            exports.BackgroundStyle = BackgroundStyle;
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    'rtl'
                ]
            };
            var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
            var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
            var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
            exports.DirectionAttribute = DirectionAttribute;
            exports.DirectionClass = DirectionClass;
            exports.DirectionStyle = DirectionStyle;
        /***/ },
        /* 39 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.FontClass = exports.FontStyle = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var config = {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    'serif',
                    'monospace'
                ]
            };
            var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
            var FontStyleAttributor = function(_Parchment$Attributor) {
                _inherits(FontStyleAttributor, _Parchment$Attributor);
                function FontStyleAttributor() {
                    _classCallCheck(this, FontStyleAttributor);
                    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
                }
                _createClass(FontStyleAttributor, [
                    {
                        key: 'value',
                        value: function value(node) {
                            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
                        }
                    }
                ]);
                return FontStyleAttributor;
            }(_parchment2.default.Attributor.Style);
            var FontStyle = new FontStyleAttributor('font', 'font-family', config);
            exports.FontStyle = FontStyle;
            exports.FontClass = FontClass;
        /***/ },
        /* 40 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SizeStyle = exports.SizeClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    'small',
                    'large',
                    'huge'
                ]
            });
            var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: [
                    '10px',
                    '18px',
                    '32px'
                ]
            });
            exports.SizeClass = SizeClass;
            exports.SizeStyle = SizeStyle;
        /***/ },
        /* 41 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            module1.exports = {
                'align': {
                    '': __webpack_require__(76),
                    'center': __webpack_require__(77),
                    'right': __webpack_require__(78),
                    'justify': __webpack_require__(79)
                },
                'background': __webpack_require__(80),
                'blockquote': __webpack_require__(81),
                'bold': __webpack_require__(82),
                'clean': __webpack_require__(83),
                'code': __webpack_require__(58),
                'code-block': __webpack_require__(58),
                'color': __webpack_require__(84),
                'direction': {
                    '': __webpack_require__(85),
                    'rtl': __webpack_require__(86)
                },
                'float': {
                    'center': __webpack_require__(87),
                    'full': __webpack_require__(88),
                    'left': __webpack_require__(89),
                    'right': __webpack_require__(90)
                },
                'formula': __webpack_require__(91),
                'header': {
                    '1': __webpack_require__(92),
                    '2': __webpack_require__(93)
                },
                'italic': __webpack_require__(94),
                'image': __webpack_require__(95),
                'indent': {
                    '+1': __webpack_require__(96),
                    '-1': __webpack_require__(97)
                },
                'link': __webpack_require__(98),
                'list': {
                    'ordered': __webpack_require__(99),
                    'bullet': __webpack_require__(100),
                    'check': __webpack_require__(101)
                },
                'script': {
                    'sub': __webpack_require__(102),
                    'super': __webpack_require__(103)
                },
                'strike': __webpack_require__(104),
                'underline': __webpack_require__(105),
                'video': __webpack_require__(106)
            };
        /***/ },
        /* 42 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getLastChangeIndex = exports.default = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var History = function(_Module) {
                _inherits(History, _Module);
                function History(quill, options) {
                    _classCallCheck(this, History);
                    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
                    _this.lastRecorded = 0;
                    _this.ignoreChange = false;
                    _this.clear();
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(eventName, delta, oldDelta, source) {
                        if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
                        if (!_this.options.userOnly || source === _quill2.default.sources.USER) _this.record(delta, oldDelta);
                        else _this.transform(delta);
                    });
                    _this.quill.keyboard.addBinding({
                        key: 'Z',
                        shortKey: true
                    }, _this.undo.bind(_this));
                    _this.quill.keyboard.addBinding({
                        key: 'Z',
                        shortKey: true,
                        shiftKey: true
                    }, _this.redo.bind(_this));
                    if (/Win/i.test(navigator.platform)) _this.quill.keyboard.addBinding({
                        key: 'Y',
                        shortKey: true
                    }, _this.redo.bind(_this));
                    return _this;
                }
                _createClass(History, [
                    {
                        key: 'change',
                        value: function change(source, dest) {
                            if (this.stack[source].length === 0) return;
                            var delta = this.stack[source].pop();
                            this.stack[dest].push(delta);
                            this.lastRecorded = 0;
                            this.ignoreChange = true;
                            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                            this.ignoreChange = false;
                            var index = getLastChangeIndex(delta[source]);
                            this.quill.setSelection(index);
                        }
                    },
                    {
                        key: 'clear',
                        value: function clear() {
                            this.stack = {
                                undo: [],
                                redo: []
                            };
                        }
                    },
                    {
                        key: 'cutoff',
                        value: function cutoff() {
                            this.lastRecorded = 0;
                        }
                    },
                    {
                        key: 'record',
                        value: function record(changeDelta, oldDelta) {
                            if (changeDelta.ops.length === 0) return;
                            this.stack.redo = [];
                            var undoDelta = this.quill.getContents().diff(oldDelta);
                            var timestamp = Date.now();
                            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                                var delta = this.stack.undo.pop();
                                undoDelta = undoDelta.compose(delta.undo);
                                changeDelta = delta.redo.compose(changeDelta);
                            } else this.lastRecorded = timestamp;
                            this.stack.undo.push({
                                redo: changeDelta,
                                undo: undoDelta
                            });
                            if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
                        }
                    },
                    {
                        key: 'redo',
                        value: function redo() {
                            this.change('redo', 'undo');
                        }
                    },
                    {
                        key: 'transform',
                        value: function transform(delta) {
                            this.stack.undo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                            this.stack.redo.forEach(function(change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                        }
                    },
                    {
                        key: 'undo',
                        value: function undo() {
                            this.change('undo', 'redo');
                        }
                    }
                ]);
                return History;
            }(_module2.default);
            History.DEFAULTS = {
                delay: 1000,
                maxStack: 100,
                userOnly: false
            };
            function endsWithNewlineChange(delta) {
                var lastOp = delta.ops[delta.ops.length - 1];
                if (lastOp == null) return false;
                if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
                if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some(function(attr) {
                    return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
                });
                return false;
            }
            function getLastChangeIndex(delta) {
                var deleteLength = delta.reduce(function(length, op) {
                    length += op.delete || 0;
                    return length;
                }, 0);
                var changeIndex = delta.length() - deleteLength;
                if (endsWithNewlineChange(delta)) changeIndex -= 1;
                return changeIndex;
            }
            exports.default = History;
            exports.getLastChangeIndex = getLastChangeIndex;
        /***/ },
        /* 43 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BaseTooltip = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _keyboard = __webpack_require__(23);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ALIGNS = [
                false,
                'center',
                'right',
                'justify'
            ];
            var COLORS = [
                "#000000",
                "#e60000",
                "#ff9900",
                "#ffff00",
                "#008a00",
                "#0066cc",
                "#9933ff",
                "#ffffff",
                "#facccc",
                "#ffebcc",
                "#ffffcc",
                "#cce8cc",
                "#cce0f5",
                "#ebd6ff",
                "#bbbbbb",
                "#f06666",
                "#ffc266",
                "#ffff66",
                "#66b966",
                "#66a3e0",
                "#c285ff",
                "#888888",
                "#a10000",
                "#b26b00",
                "#b2b200",
                "#006100",
                "#0047b2",
                "#6b24b2",
                "#444444",
                "#5c0000",
                "#663d00",
                "#666600",
                "#003700",
                "#002966",
                "#3d1466"
            ];
            var FONTS = [
                false,
                'serif',
                'monospace'
            ];
            var HEADERS = [
                '1',
                '2',
                '3',
                false
            ];
            var SIZES = [
                'small',
                false,
                'large',
                'huge'
            ];
            var BaseTheme = function(_Theme) {
                _inherits(BaseTheme, _Theme);
                function BaseTheme(quill, options) {
                    _classCallCheck(this, BaseTheme);
                    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
                    var listener = function listener(e) {
                        if (!document.body.contains(quill.root)) return document.body.removeEventListener('click', listener);
                        if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) _this.tooltip.hide();
                        if (_this.pickers != null) _this.pickers.forEach(function(picker) {
                            if (!picker.container.contains(e.target)) picker.close();
                        });
                    };
                    quill.emitter.listenDOM('click', document.body, listener);
                    return _this;
                }
                _createClass(BaseTheme, [
                    {
                        key: 'addModule',
                        value: function addModule(name) {
                            var module1 = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
                            if (name === 'toolbar') this.extendToolbar(module1);
                            return module1;
                        }
                    },
                    {
                        key: 'buildButtons',
                        value: function buildButtons(buttons, icons) {
                            buttons.forEach(function(button) {
                                var className = button.getAttribute('class') || '';
                                className.split(/\s+/).forEach(function(name) {
                                    if (!name.startsWith('ql-')) return;
                                    name = name.slice(3);
                                    if (icons[name] == null) return;
                                    if (name === 'direction') button.innerHTML = icons[name][''] + icons[name]['rtl'];
                                    else if (typeof icons[name] === 'string') button.innerHTML = icons[name];
                                    else {
                                        var value = button.value || '';
                                        if (value != null && icons[name][value]) button.innerHTML = icons[name][value];
                                    }
                                });
                            });
                        }
                    },
                    {
                        key: 'buildPickers',
                        value: function buildPickers(selects, icons) {
                            var _this2 = this;
                            this.pickers = selects.map(function(select) {
                                if (select.classList.contains('ql-align')) {
                                    if (select.querySelector('option') == null) fillSelect(select, ALIGNS);
                                    return new _iconPicker2.default(select, icons.align);
                                } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                                    var format = select.classList.contains('ql-background') ? 'background' : 'color';
                                    if (select.querySelector('option') == null) fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
                                    return new _colorPicker2.default(select, icons[format]);
                                } else {
                                    if (select.querySelector('option') == null) {
                                        if (select.classList.contains('ql-font')) fillSelect(select, FONTS);
                                        else if (select.classList.contains('ql-header')) fillSelect(select, HEADERS);
                                        else if (select.classList.contains('ql-size')) fillSelect(select, SIZES);
                                    }
                                    return new _picker2.default(select);
                                }
                            });
                            var update = function update() {
                                _this2.pickers.forEach(function(picker) {
                                    picker.update();
                                });
                            };
                            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
                        }
                    }
                ]);
                return BaseTheme;
            }(_theme2.default);
            BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            formula: function formula() {
                                this.quill.theme.tooltip.edit('formula');
                            },
                            image: function image() {
                                var _this3 = this;
                                var fileInput = this.container.querySelector('input.ql-image[type=file]');
                                if (fileInput == null) {
                                    fileInput = document.createElement('input');
                                    fileInput.setAttribute('type', 'file');
                                    fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                                    fileInput.classList.add('ql-image');
                                    fileInput.addEventListener('change', function() {
                                        if (fileInput.files != null && fileInput.files[0] != null) {
                                            var reader = new FileReader();
                                            reader.onload = function(e) {
                                                var range = _this3.quill.getSelection(true);
                                                _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({
                                                    image: e.target.result
                                                }), _emitter2.default.sources.USER);
                                                _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                                                fileInput.value = "";
                                            };
                                            reader.readAsDataURL(fileInput.files[0]);
                                        }
                                    });
                                    this.container.appendChild(fileInput);
                                }
                                fileInput.click();
                            },
                            video: function video() {
                                this.quill.theme.tooltip.edit('video');
                            }
                        }
                    }
                }
            });
            var BaseTooltip = function(_Tooltip) {
                _inherits(BaseTooltip, _Tooltip);
                function BaseTooltip(quill, boundsContainer) {
                    _classCallCheck(this, BaseTooltip);
                    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
                    _this4.textbox = _this4.root.querySelector('input[type="text"]');
                    _this4.listen();
                    return _this4;
                }
                _createClass(BaseTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this5 = this;
                            this.textbox.addEventListener('keydown', function(event) {
                                if (_keyboard2.default.match(event, 'enter')) {
                                    _this5.save();
                                    event.preventDefault();
                                } else if (_keyboard2.default.match(event, 'escape')) {
                                    _this5.cancel();
                                    event.preventDefault();
                                }
                            });
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.hide();
                        }
                    },
                    {
                        key: 'edit',
                        value: function edit() {
                            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
                            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            this.root.classList.remove('ql-hidden');
                            this.root.classList.add('ql-editing');
                            if (preview != null) this.textbox.value = preview;
                            else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
                            this.position(this.quill.getBounds(this.quill.selection.savedRange));
                            this.textbox.select();
                            this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
                            this.root.setAttribute('data-mode', mode);
                        }
                    },
                    {
                        key: 'restoreFocus',
                        value: function restoreFocus() {
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.quill.focus();
                            this.quill.scrollingContainer.scrollTop = scrollTop;
                        }
                    },
                    {
                        key: 'save',
                        value: function save() {
                            var value = this.textbox.value;
                            switch(this.root.getAttribute('data-mode')){
                                case 'link':
                                    var scrollTop = this.quill.root.scrollTop;
                                    if (this.linkRange) {
                                        this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
                                        delete this.linkRange;
                                    } else {
                                        this.restoreFocus();
                                        this.quill.format('link', value, _emitter2.default.sources.USER);
                                    }
                                    this.quill.root.scrollTop = scrollTop;
                                    break;
                                case 'video':
                                    value = extractVideoUrl(value);
                                case 'formula':
                                    if (!value) break;
                                    var range = this.quill.getSelection(true);
                                    if (range != null) {
                                        var index = range.index + range.length;
                                        this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
                                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
                                        this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                                    }
                                    break;
                                default:
                            }
                            this.textbox.value = '';
                            this.hide();
                        }
                    }
                ]);
                return BaseTooltip;
            }(_tooltip2.default);
            function extractVideoUrl(url) {
                var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
                if (match) return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
                if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) // eslint-disable-line no-cond-assign
                return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
                return url;
            }
            function fillSelect(select, values) {
                var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                values.forEach(function(value) {
                    var option = document.createElement('option');
                    if (value === defaultValue) option.setAttribute('selected', 'selected');
                    else option.setAttribute('value', value);
                    select.appendChild(option);
                });
            }
            exports.BaseTooltip = BaseTooltip;
            exports.default = BaseTheme;
        /***/ },
        /* 44 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var LinkedList = /** @class */ function() {
                function LinkedList() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
                LinkedList.prototype.append = function() {
                    var nodes = [];
                    for(var _i = 0; _i < arguments.length; _i++)nodes[_i] = arguments[_i];
                    this.insertBefore(nodes[0], null);
                    if (nodes.length > 1) this.append.apply(this, nodes.slice(1));
                };
                LinkedList.prototype.contains = function(node) {
                    var cur, next = this.iterator();
                    while(cur = next()){
                        if (cur === node) return true;
                    }
                    return false;
                };
                LinkedList.prototype.insertBefore = function(node, refNode) {
                    if (!node) return;
                    node.next = refNode;
                    if (refNode != null) {
                        node.prev = refNode.prev;
                        if (refNode.prev != null) refNode.prev.next = node;
                        refNode.prev = node;
                        if (refNode === this.head) this.head = node;
                    } else if (this.tail != null) {
                        this.tail.next = node;
                        node.prev = this.tail;
                        this.tail = node;
                    } else {
                        node.prev = null;
                        this.head = this.tail = node;
                    }
                    this.length += 1;
                };
                LinkedList.prototype.offset = function(target) {
                    var index = 0, cur = this.head;
                    while(cur != null){
                        if (cur === target) return index;
                        index += cur.length();
                        cur = cur.next;
                    }
                    return -1;
                };
                LinkedList.prototype.remove = function(node) {
                    if (!this.contains(node)) return;
                    if (node.prev != null) node.prev.next = node.next;
                    if (node.next != null) node.next.prev = node.prev;
                    if (node === this.head) this.head = node.next;
                    if (node === this.tail) this.tail = node.prev;
                    this.length -= 1;
                };
                LinkedList.prototype.iterator = function(curNode) {
                    if (curNode === void 0) curNode = this.head;
                    // TODO use yield when we can
                    return function() {
                        var ret = curNode;
                        if (curNode != null) curNode = curNode.next;
                        return ret;
                    };
                };
                LinkedList.prototype.find = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    var cur, next = this.iterator();
                    while(cur = next()){
                        var length = cur.length();
                        if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                            cur,
                            index
                        ];
                        index -= length;
                    }
                    return [
                        null,
                        0
                    ];
                };
                LinkedList.prototype.forEach = function(callback) {
                    var cur, next = this.iterator();
                    while(cur = next())callback(cur);
                };
                LinkedList.prototype.forEachAt = function(index, length, callback) {
                    if (length <= 0) return;
                    var _a = this.find(index), startNode = _a[0], offset = _a[1];
                    var cur, curIndex = index - offset, next = this.iterator(startNode);
                    while((cur = next()) && curIndex < index + length){
                        var curLength = cur.length();
                        if (index > curIndex) callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                        else callback(cur, 0, Math.min(curLength, index + length - curIndex));
                        curIndex += curLength;
                    }
                };
                LinkedList.prototype.map = function(callback) {
                    return this.reduce(function(memo, cur) {
                        memo.push(callback(cur));
                        return memo;
                    }, []);
                };
                LinkedList.prototype.reduce = function(callback, memo) {
                    var cur, next = this.iterator();
                    while(cur = next())memo = callback(memo, cur);
                    return memo;
                };
                return LinkedList;
            }();
            exports.default = LinkedList;
        /***/ },
        /* 45 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var OBSERVER_CONFIG = {
                attributes: true,
                characterData: true,
                characterDataOldValue: true,
                childList: true,
                subtree: true
            };
            var MAX_OPTIMIZE_ITERATIONS = 100;
            var ScrollBlot = /** @class */ function(_super) {
                __extends(ScrollBlot, _super);
                function ScrollBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.scroll = _this;
                    _this.observer = new MutationObserver(function(mutations) {
                        _this.update(mutations);
                    });
                    _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
                    _this.attach();
                    return _this;
                }
                ScrollBlot.prototype.detach = function() {
                    _super.prototype.detach.call(this);
                    this.observer.disconnect();
                };
                ScrollBlot.prototype.deleteAt = function(index, length) {
                    this.update();
                    if (index === 0 && length === this.length()) this.children.forEach(function(child) {
                        child.remove();
                    });
                    else _super.prototype.deleteAt.call(this, index, length);
                };
                ScrollBlot.prototype.formatAt = function(index, length, name, value) {
                    this.update();
                    _super.prototype.formatAt.call(this, index, length, name, value);
                };
                ScrollBlot.prototype.insertAt = function(index, value, def) {
                    this.update();
                    _super.prototype.insertAt.call(this, index, value, def);
                };
                ScrollBlot.prototype.optimize = function(mutations, context) {
                    var _this = this;
                    if (mutations === void 0) mutations = [];
                    if (context === void 0) context = {};
                    _super.prototype.optimize.call(this, context);
                    // We must modify mutations directly, cannot make copy and then modify
                    var records = [].slice.call(this.observer.takeRecords());
                    // Array.push currently seems to be implemented by a non-tail recursive function
                    // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
                    while(records.length > 0)mutations.push(records.pop());
                    // TODO use WeakMap
                    var mark = function(blot, markParent) {
                        if (markParent === void 0) markParent = true;
                        if (blot == null || blot === _this) return;
                        if (blot.domNode.parentNode == null) return;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations = [];
                        if (markParent) mark(blot.parent);
                    };
                    var optimize = function(blot) {
                        // Post-order traversal
                        if (// @ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null || // @ts-ignore
                        blot.domNode[Registry.DATA_KEY].mutations == null) return;
                        if (blot instanceof container_1.default) blot.children.forEach(optimize);
                        blot.optimize(context);
                    };
                    var remaining = mutations;
                    for(var i = 0; remaining.length > 0; i += 1){
                        if (i >= MAX_OPTIMIZE_ITERATIONS) throw new Error('[Parchment] Maximum optimize iterations reached');
                        remaining.forEach(function(mutation) {
                            var blot = Registry.find(mutation.target, true);
                            if (blot == null) return;
                            if (blot.domNode === mutation.target) {
                                if (mutation.type === 'childList') {
                                    mark(Registry.find(mutation.previousSibling, false));
                                    [].forEach.call(mutation.addedNodes, function(node) {
                                        var child = Registry.find(node, false);
                                        mark(child, false);
                                        if (child instanceof container_1.default) child.children.forEach(function(grandChild) {
                                            mark(grandChild, false);
                                        });
                                    });
                                } else if (mutation.type === 'attributes') mark(blot.prev);
                            }
                            mark(blot);
                        });
                        this.children.forEach(optimize);
                        remaining = [].slice.call(this.observer.takeRecords());
                        records = remaining.slice();
                        while(records.length > 0)mutations.push(records.pop());
                    }
                };
                ScrollBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (context === void 0) context = {};
                    mutations = mutations || this.observer.takeRecords();
                    // TODO use WeakMap
                    mutations.map(function(mutation) {
                        var blot = Registry.find(mutation.target, true);
                        if (blot == null) return null;
                        // @ts-ignore
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations = [
                                mutation
                            ];
                            return blot;
                        } else {
                            // @ts-ignore
                            blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                            return null;
                        }
                    }).forEach(function(blot) {
                        if (blot == null || blot === _this || //@ts-ignore
                        blot.domNode[Registry.DATA_KEY] == null) return;
                        // @ts-ignore
                        blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
                    });
                    // @ts-ignore
                    if (this.domNode[Registry.DATA_KEY].mutations != null) // @ts-ignore
                    _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
                    this.optimize(mutations, context);
                };
                ScrollBlot.blotName = 'scroll';
                ScrollBlot.defaultChild = 'block';
                ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
                ScrollBlot.tagName = 'DIV';
                return ScrollBlot;
            }(container_1.default);
            exports.default = ScrollBlot;
        /***/ },
        /* 46 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            // Shallow object comparison
            function isEqual(obj1, obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
                // @ts-ignore
                for(var prop in obj1){
                    // @ts-ignore
                    if (obj1[prop] !== obj2[prop]) return false;
                }
                return true;
            }
            var InlineBlot = /** @class */ function(_super) {
                __extends(InlineBlot, _super);
                function InlineBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InlineBlot.formats = function(domNode) {
                    if (domNode.tagName === InlineBlot.tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                InlineBlot.prototype.format = function(name, value) {
                    var _this = this;
                    if (name === this.statics.blotName && !value) {
                        this.children.forEach(function(child) {
                            if (!(child instanceof format_1.default)) child = child.wrap(InlineBlot.blotName, true);
                            _this.attributes.copy(child);
                        });
                        this.unwrap();
                    } else _super.prototype.format.call(this, name, value);
                };
                InlineBlot.prototype.formatAt = function(index, length, name, value) {
                    if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                        var blot = this.isolate(index, length);
                        blot.format(name, value);
                    } else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                InlineBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    var formats = this.formats();
                    if (Object.keys(formats).length === 0) return this.unwrap(); // unformatted span
                    var next = this.next;
                    if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
                        next.moveChildren(this);
                        next.remove();
                    }
                };
                InlineBlot.blotName = 'inline';
                InlineBlot.scope = Registry.Scope.INLINE_BLOT;
                InlineBlot.tagName = 'SPAN';
                return InlineBlot;
            }(format_1.default);
            exports.default = InlineBlot;
        /***/ },
        /* 47 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            var BlockBlot = /** @class */ function(_super) {
                __extends(BlockBlot, _super);
                function BlockBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                BlockBlot.formats = function(domNode) {
                    var tagName = Registry.query(BlockBlot.blotName).tagName;
                    if (domNode.tagName === tagName) return undefined;
                    return _super.formats.call(this, domNode);
                };
                BlockBlot.prototype.format = function(name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) == null) return;
                    else if (name === this.statics.blotName && !value) this.replaceWith(BlockBlot.blotName);
                    else _super.prototype.format.call(this, name, value);
                };
                BlockBlot.prototype.formatAt = function(index, length, name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) != null) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                BlockBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) // Insert text or inline
                    _super.prototype.insertAt.call(this, index, value, def);
                    else {
                        var after = this.split(index);
                        var blot = Registry.create(value, def);
                        after.parent.insertBefore(blot, after);
                    }
                };
                BlockBlot.prototype.update = function(mutations, context) {
                    if (navigator.userAgent.match(/Trident/)) this.build();
                    else _super.prototype.update.call(this, mutations, context);
                };
                BlockBlot.blotName = 'block';
                BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
                BlockBlot.tagName = 'P';
                return BlockBlot;
            }(format_1.default);
            exports.default = BlockBlot;
        /***/ },
        /* 48 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var EmbedBlot = /** @class */ function(_super) {
                __extends(EmbedBlot, _super);
                function EmbedBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EmbedBlot.formats = function(domNode) {
                    return undefined;
                };
                EmbedBlot.prototype.format = function(name, value) {
                    // super.formatAt wraps, which is what we want in general,
                    // but this allows subclasses to overwrite for formats
                    // that just apply to particular embeds
                    _super.prototype.formatAt.call(this, 0, this.length(), name, value);
                };
                EmbedBlot.prototype.formatAt = function(index, length, name, value) {
                    if (index === 0 && length === this.length()) this.format(name, value);
                    else _super.prototype.formatAt.call(this, index, length, name, value);
                };
                EmbedBlot.prototype.formats = function() {
                    return this.statics.formats(this.domNode);
                };
                return EmbedBlot;
            }(leaf_1.default);
            exports.default = EmbedBlot;
        /***/ },
        /* 49 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var __extends = this && this.__extends || function() {
                var extendStatics = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(d, b) {
                    d.__proto__ = b;
                } || function(d, b) {
                    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var leaf_1 = __webpack_require__(19);
            var Registry = __webpack_require__(1);
            var TextBlot = /** @class */ function(_super) {
                __extends(TextBlot, _super);
                function TextBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.text = _this.statics.value(_this.domNode);
                    return _this;
                }
                TextBlot.create = function(value) {
                    return document.createTextNode(value);
                };
                TextBlot.value = function(domNode) {
                    var text = domNode.data;
                    // @ts-ignore
                    if (text['normalize']) text = text['normalize']();
                    return text;
                };
                TextBlot.prototype.deleteAt = function(index, length) {
                    this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
                };
                TextBlot.prototype.index = function(node, offset) {
                    if (this.domNode === node) return offset;
                    return -1;
                };
                TextBlot.prototype.insertAt = function(index, value, def) {
                    if (def == null) {
                        this.text = this.text.slice(0, index) + value + this.text.slice(index);
                        this.domNode.data = this.text;
                    } else _super.prototype.insertAt.call(this, index, value, def);
                };
                TextBlot.prototype.length = function() {
                    return this.text.length;
                };
                TextBlot.prototype.optimize = function(context) {
                    _super.prototype.optimize.call(this, context);
                    this.text = this.statics.value(this.domNode);
                    if (this.text.length === 0) this.remove();
                    else if (this.next instanceof TextBlot && this.next.prev === this) {
                        this.insertAt(this.length(), this.next.value());
                        this.next.remove();
                    }
                };
                TextBlot.prototype.position = function(index, inclusive) {
                    if (inclusive === void 0) inclusive = false;
                    return [
                        this.domNode,
                        index
                    ];
                };
                TextBlot.prototype.split = function(index, force) {
                    if (force === void 0) force = false;
                    if (!force) {
                        if (index === 0) return this;
                        if (index === this.length()) return this.next;
                    }
                    var after = Registry.create(this.domNode.splitText(index));
                    this.parent.insertBefore(after, this.next);
                    this.text = this.statics.value(this.domNode);
                    return after;
                };
                TextBlot.prototype.update = function(mutations, context) {
                    var _this = this;
                    if (mutations.some(function(mutation) {
                        return mutation.type === 'characterData' && mutation.target === _this.domNode;
                    })) this.text = this.statics.value(this.domNode);
                };
                TextBlot.prototype.value = function() {
                    return this.text;
                };
                TextBlot.blotName = 'text';
                TextBlot.scope = Registry.Scope.INLINE_BLOT;
                return TextBlot;
            }(leaf_1.default);
            exports.default = TextBlot;
        /***/ },
        /* 50 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            var elem = document.createElement('div');
            elem.classList.toggle('test-class', false);
            if (elem.classList.contains('test-class')) {
                var _toggle = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function(token, force) {
                    if (arguments.length > 1 && !this.contains(token) === !force) return force;
                    else return _toggle.call(this, token);
                };
            }
            if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.substr(position, searchString.length) === searchString;
            };
            if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
                var subjectString = this.toString();
                if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
                position -= searchString.length;
                var lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
            if (!Array.prototype.find) Object.defineProperty(Array.prototype, "find", {
                value: function value(predicate) {
                    if (this === null) throw new TypeError('Array.prototype.find called on null or undefined');
                    if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
                    var list = Object(this);
                    var length = list.length >>> 0;
                    var thisArg = arguments[1];
                    var value;
                    for(var i = 0; i < length; i++){
                        value = list[i];
                        if (predicate.call(thisArg, value, i, list)) return value;
                    }
                    return undefined;
                }
            });
            document.addEventListener("DOMContentLoaded", function() {
                // Disable resizing in Firefox
                document.execCommand("enableObjectResizing", false, false);
                // Disable automatic linkifying in IE11
                document.execCommand("autoUrlDetect", false, false);
            });
        /***/ },
        /* 51 */ /***/ function(module1, exports) {
            /**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var DIFF_DELETE = -1;
            var DIFF_INSERT = 1;
            var DIFF_EQUAL = 0;
            /**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */ function diff_main(text1, text2, cursor_pos) {
                // Check for equality (speedup).
                if (text1 == text2) {
                    if (text1) return [
                        [
                            DIFF_EQUAL,
                            text1
                        ]
                    ];
                    return [];
                }
                // Check cursor_pos within bounds
                if (cursor_pos < 0 || text1.length < cursor_pos) cursor_pos = null;
                // Trim off common prefix (speedup).
                var commonlength = diff_commonPrefix(text1, text2);
                var commonprefix = text1.substring(0, commonlength);
                text1 = text1.substring(commonlength);
                text2 = text2.substring(commonlength);
                // Trim off common suffix (speedup).
                commonlength = diff_commonSuffix(text1, text2);
                var commonsuffix = text1.substring(text1.length - commonlength);
                text1 = text1.substring(0, text1.length - commonlength);
                text2 = text2.substring(0, text2.length - commonlength);
                // Compute the diff on the middle block.
                var diffs = diff_compute_(text1, text2);
                // Restore the prefix and suffix.
                if (commonprefix) diffs.unshift([
                    DIFF_EQUAL,
                    commonprefix
                ]);
                if (commonsuffix) diffs.push([
                    DIFF_EQUAL,
                    commonsuffix
                ]);
                diff_cleanupMerge(diffs);
                if (cursor_pos != null) diffs = fix_cursor(diffs, cursor_pos);
                diffs = fix_emoji(diffs);
                return diffs;
            }
            /**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function diff_compute_(text1, text2) {
                var diffs;
                if (!text1) // Just add some text (speedup).
                return [
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                if (!text2) // Just delete some text (speedup).
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ]
                ];
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                var i = longtext.indexOf(shorttext);
                if (i != -1) {
                    // Shorter text is inside the longer text (speedup).
                    diffs = [
                        [
                            DIFF_INSERT,
                            longtext.substring(0, i)
                        ],
                        [
                            DIFF_EQUAL,
                            shorttext
                        ],
                        [
                            DIFF_INSERT,
                            longtext.substring(i + shorttext.length)
                        ]
                    ];
                    // Swap insertions for deletions if diff is reversed.
                    if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = DIFF_DELETE;
                    return diffs;
                }
                if (shorttext.length == 1) // Single character string.
                // After the previous speedup, the character can't be an equality.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
                // Check to see if the problem can be split in two.
                var hm = diff_halfMatch_(text1, text2);
                if (hm) {
                    // A half-match was found, sort out the return data.
                    var text1_a = hm[0];
                    var text1_b = hm[1];
                    var text2_a = hm[2];
                    var text2_b = hm[3];
                    var mid_common = hm[4];
                    // Send both pairs off for separate processing.
                    var diffs_a = diff_main(text1_a, text2_a);
                    var diffs_b = diff_main(text1_b, text2_b);
                    // Merge the results.
                    return diffs_a.concat([
                        [
                            DIFF_EQUAL,
                            mid_common
                        ]
                    ], diffs_b);
                }
                return diff_bisect_(text1, text2);
            }
            /**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function diff_bisect_(text1, text2) {
                // Cache the text lengths to prevent multiple calls.
                var text1_length = text1.length;
                var text2_length = text2.length;
                var max_d = Math.ceil((text1_length + text2_length) / 2);
                var v_offset = max_d;
                var v_length = 2 * max_d;
                var v1 = new Array(v_length);
                var v2 = new Array(v_length);
                // Setting all elements to -1 is faster in Chrome & Firefox than mixing
                // integers and undefined.
                for(var x = 0; x < v_length; x++){
                    v1[x] = -1;
                    v2[x] = -1;
                }
                v1[v_offset + 1] = 0;
                v2[v_offset + 1] = 0;
                var delta = text1_length - text2_length;
                // If the total number of characters is odd, then the front path will collide
                // with the reverse path.
                var front = delta % 2 != 0;
                // Offsets for start and end of k loop.
                // Prevents mapping of space beyond the grid.
                var k1start = 0;
                var k1end = 0;
                var k2start = 0;
                var k2end = 0;
                for(var d = 0; d < max_d; d++){
                    // Walk the front path one step.
                    for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
                        var k1_offset = v_offset + k1;
                        var x1;
                        if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
                        else x1 = v1[k1_offset - 1] + 1;
                        var y1 = x1 - k1;
                        while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                            x1++;
                            y1++;
                        }
                        v1[k1_offset] = x1;
                        if (x1 > text1_length) // Ran off the right of the graph.
                        k1end += 2;
                        else if (y1 > text2_length) // Ran off the bottom of the graph.
                        k1start += 2;
                        else if (front) {
                            var k2_offset = v_offset + delta - k1;
                            if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                                // Mirror x2 onto top-left coordinate system.
                                var x2 = text1_length - v2[k2_offset];
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                    // Walk the reverse path one step.
                    for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
                        var k2_offset = v_offset + k2;
                        var x2;
                        if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
                        else x2 = v2[k2_offset - 1] + 1;
                        var y2 = x2 - k2;
                        while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                            x2++;
                            y2++;
                        }
                        v2[k2_offset] = x2;
                        if (x2 > text1_length) // Ran off the left of the graph.
                        k2end += 2;
                        else if (y2 > text2_length) // Ran off the top of the graph.
                        k2start += 2;
                        else if (!front) {
                            var k1_offset = v_offset + delta - k2;
                            if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                                var x1 = v1[k1_offset];
                                var y1 = v_offset + x1 - k1_offset;
                                // Mirror x2 onto top-left coordinate system.
                                x2 = text1_length - x2;
                                if (x1 >= x2) // Overlap detected.
                                return diff_bisectSplit_(text1, text2, x1, y1);
                            }
                        }
                    }
                }
                // Diff took too long and hit the deadline or
                // number of diffs equals number of characters, no commonality at all.
                return [
                    [
                        DIFF_DELETE,
                        text1
                    ],
                    [
                        DIFF_INSERT,
                        text2
                    ]
                ];
            }
            /**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function diff_bisectSplit_(text1, text2, x, y) {
                var text1a = text1.substring(0, x);
                var text2a = text2.substring(0, y);
                var text1b = text1.substring(x);
                var text2b = text2.substring(y);
                // Compute both diffs serially.
                var diffs = diff_main(text1a, text2a);
                var diffsb = diff_main(text1b, text2b);
                return diffs.concat(diffsb);
            }
            /**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function diff_commonPrefix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerstart = 0;
                while(pointermin < pointermid){
                    if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                        pointermin = pointermid;
                        pointerstart = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function diff_commonSuffix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerend = 0;
                while(pointermin < pointermid){
                    if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                        pointermin = pointermid;
                        pointerend = pointermin;
                    } else pointermax = pointermid;
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            /**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function diff_halfMatch_(text1, text2) {
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
                /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
                    // Start with a 1/4 length substring at position i as a seed.
                    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
                    var j = -1;
                    var best_common = '';
                    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
                    while((j = shorttext.indexOf(seed, j + 1)) != -1){
                        var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                        var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                        if (best_common.length < suffixLength + prefixLength) {
                            best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                            best_longtext_a = longtext.substring(0, i - suffixLength);
                            best_longtext_b = longtext.substring(i + prefixLength);
                            best_shorttext_a = shorttext.substring(0, j - suffixLength);
                            best_shorttext_b = shorttext.substring(j + prefixLength);
                        }
                    }
                    if (best_common.length * 2 >= longtext.length) return [
                        best_longtext_a,
                        best_longtext_b,
                        best_shorttext_a,
                        best_shorttext_b,
                        best_common
                    ];
                    else return null;
                }
                // First check if the second quarter is the seed for a half-match.
                var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
                // Check again based on the third quarter.
                var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
                var hm;
                if (!hm1 && !hm2) return null;
                else if (!hm2) hm = hm1;
                else if (!hm1) hm = hm2;
                else // Both matched.  Select the longest.
                hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
                // A half-match was found, sort out the return data.
                var text1_a, text1_b, text2_a, text2_b;
                if (text1.length > text2.length) {
                    text1_a = hm[0];
                    text1_b = hm[1];
                    text2_a = hm[2];
                    text2_b = hm[3];
                } else {
                    text2_a = hm[0];
                    text2_b = hm[1];
                    text1_a = hm[2];
                    text1_b = hm[3];
                }
                var mid_common = hm[4];
                return [
                    text1_a,
                    text1_b,
                    text2_a,
                    text2_b,
                    mid_common
                ];
            }
            /**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */ function diff_cleanupMerge(diffs) {
                diffs.push([
                    DIFF_EQUAL,
                    ''
                ]); // Add a dummy entry at the end.
                var pointer = 0;
                var count_delete = 0;
                var count_insert = 0;
                var text_delete = '';
                var text_insert = '';
                var commonlength;
                while(pointer < diffs.length)switch(diffs[pointer][0]){
                    case DIFF_INSERT:
                        count_insert++;
                        text_insert += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_DELETE:
                        count_delete++;
                        text_delete += diffs[pointer][1];
                        pointer++;
                        break;
                    case DIFF_EQUAL:
                        // Upon reaching an equality, check for prior redundancies.
                        if (count_delete + count_insert > 1) {
                            if (count_delete !== 0 && count_insert !== 0) {
                                // Factor out any common prefixies.
                                commonlength = diff_commonPrefix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                                    else {
                                        diffs.splice(0, 0, [
                                            DIFF_EQUAL,
                                            text_insert.substring(0, commonlength)
                                        ]);
                                        pointer++;
                                    }
                                    text_insert = text_insert.substring(commonlength);
                                    text_delete = text_delete.substring(commonlength);
                                }
                                // Factor out any common suffixies.
                                commonlength = diff_commonSuffix(text_insert, text_delete);
                                if (commonlength !== 0) {
                                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                                }
                            }
                            // Delete the offending records and add the merged ones.
                            if (count_delete === 0) diffs.splice(pointer - count_insert, count_delete + count_insert, [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            else if (count_insert === 0) diffs.splice(pointer - count_delete, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ]);
                            else diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [
                                DIFF_DELETE,
                                text_delete
                            ], [
                                DIFF_INSERT,
                                text_insert
                            ]);
                            pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                            // Merge this equality with the previous one.
                            diffs[pointer - 1][1] += diffs[pointer][1];
                            diffs.splice(pointer, 1);
                        } else pointer++;
                        count_insert = 0;
                        count_delete = 0;
                        text_delete = '';
                        text_insert = '';
                        break;
                }
                if (diffs[diffs.length - 1][1] === '') diffs.pop(); // Remove the dummy entry at the end.
                // Second pass: look for single edits surrounded on both sides by equalities
                // which can be shifted sideways to eliminate an equality.
                // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
                var changes = false;
                pointer = 1;
                // Intentionally ignore the first and last element (don't need checking).
                while(pointer < diffs.length - 1){
                    if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                        // This is a single edit surrounded by equalities.
                        if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                            // Shift the edit over the previous equality.
                            diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                            diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                            diffs.splice(pointer - 1, 1);
                            changes = true;
                        } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                            // Shift the edit over the next equality.
                            diffs[pointer - 1][1] += diffs[pointer + 1][1];
                            diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                            diffs.splice(pointer + 1, 1);
                            changes = true;
                        }
                    }
                    pointer++;
                }
                // If shifts were made, the diff needs reordering and another shift sweep.
                if (changes) diff_cleanupMerge(diffs);
            }
            var diff = diff_main;
            diff.INSERT = DIFF_INSERT;
            diff.DELETE = DIFF_DELETE;
            diff.EQUAL = DIFF_EQUAL;
            module1.exports = diff;
            /*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */ function cursor_normalize_diff(diffs, cursor_pos) {
                if (cursor_pos === 0) return [
                    DIFF_EQUAL,
                    diffs
                ];
                for(var current_pos = 0, i = 0; i < diffs.length; i++){
                    var d = diffs[i];
                    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                        var next_pos = current_pos + d[1].length;
                        if (cursor_pos === next_pos) return [
                            i + 1,
                            diffs
                        ];
                        else if (cursor_pos < next_pos) {
                            // copy to prevent side effects
                            diffs = diffs.slice();
                            // split d into two diff changes
                            var split_pos = cursor_pos - current_pos;
                            var d_left = [
                                d[0],
                                d[1].slice(0, split_pos)
                            ];
                            var d_right = [
                                d[0],
                                d[1].slice(split_pos)
                            ];
                            diffs.splice(i, 1, d_left, d_right);
                            return [
                                i + 1,
                                diffs
                            ];
                        } else current_pos = next_pos;
                    }
                }
                throw new Error('cursor_pos is out of bounds!');
            }
            /*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */ function fix_cursor(diffs, cursor_pos) {
                var norm = cursor_normalize_diff(diffs, cursor_pos);
                var ndiffs = norm[1];
                var cursor_pointer = norm[0];
                var d = ndiffs[cursor_pointer];
                var d_next = ndiffs[cursor_pointer + 1];
                if (d == null) // Text was deleted from end of original string,
                // cursor is now out of bounds in new string
                return diffs;
                else if (d[0] !== DIFF_EQUAL) // A modification happened at the cursor location.
                // This is the expected outcome, so we can return the original diff.
                return diffs;
                else {
                    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                        // Case 1)
                        // It is possible to perform a naive shift
                        ndiffs.splice(cursor_pointer, 2, d_next, d);
                        return merge_tuples(ndiffs, cursor_pointer, 2);
                    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                        // Case 2)
                        // d[1] is a prefix of d_next[1]
                        // We can assume that d_next[0] !== 0, since d[0] === 0
                        // Shift edit locations..
                        ndiffs.splice(cursor_pointer, 2, [
                            d_next[0],
                            d[1]
                        ], [
                            0,
                            d[1]
                        ]);
                        var suffix = d_next[1].slice(d[1].length);
                        if (suffix.length > 0) ndiffs.splice(cursor_pointer + 2, 0, [
                            d_next[0],
                            suffix
                        ]);
                        return merge_tuples(ndiffs, cursor_pointer, 3);
                    } else // Not possible to perform any modification
                    return diffs;
                }
            }
            /*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */ function fix_emoji(diffs) {
                var compact = false;
                var starts_with_pair_end = function(str) {
                    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
                };
                var ends_with_pair_start = function(str) {
                    return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
                };
                for(var i = 2; i < diffs.length; i += 1)if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                    compact = true;
                    diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                    diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                    diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
                }
                if (!compact) return diffs;
                var fixed_diffs = [];
                for(var i = 0; i < diffs.length; i += 1)if (diffs[i][1].length > 0) fixed_diffs.push(diffs[i]);
                return fixed_diffs;
            }
            /*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */ function merge_tuples(diffs, start, length) {
                // Check from (start-1) to (start+length).
                for(var i = start + length - 1; i >= 0 && i >= start - 1; i--)if (i + 1 < diffs.length) {
                    var left_d = diffs[i];
                    var right_d = diffs[i + 1];
                    if (left_d[0] === right_d[1]) diffs.splice(i, 2, [
                        left_d[0],
                        left_d[1] + right_d[1]
                    ]);
                }
                return diffs;
            }
        /***/ },
        /* 52 */ /***/ function(module1, exports) {
            exports = module1.exports = typeof Object.keys === 'function' ? Object.keys : shim;
            exports.shim = shim;
            function shim(obj) {
                var keys = [];
                for(var key in obj)keys.push(key);
                return keys;
            }
        /***/ },
        /* 53 */ /***/ function(module1, exports) {
            var supportsArgumentsClass = function() {
                return Object.prototype.toString.call(arguments);
            }() == '[object Arguments]';
            exports = module1.exports = supportsArgumentsClass ? supported : unsupported;
            exports.supported = supported;
            function supported(object) {
                return Object.prototype.toString.call(object) == '[object Arguments]';
            }
            exports.unsupported = unsupported;
            function unsupported(object) {
                return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
            }
        /***/ },
        /* 54 */ /***/ function(module1, exports) {
            'use strict';
            var has = Object.prototype.hasOwnProperty, prefix = '~';
            /**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */ function Events() {}
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
            }
            /**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */ function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */ function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */ EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0) return names;
                for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
                return names;
            };
            /**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */ EventEmitter.prototype.listeners = function listeners(event, exists) {
                var evt = prefix ? prefix + event : event, available = this._events[evt];
                if (exists) return !!available;
                if (!available) return [];
                if (available.fn) return [
                    available.fn
                ];
                for(var i = 0, l = available.length, ee = new Array(l); i < l; i++)ee[i] = available[i].fn;
                return ee;
            };
            /**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                    switch(len){
                        case 1:
                            return listeners.fn.call(listeners.context), true;
                        case 2:
                            return listeners.fn.call(listeners.context, a1), true;
                        case 3:
                            return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4:
                            return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6:
                            return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                    listeners.fn.apply(listeners.context, args);
                } else {
                    var length = listeners.length, j;
                    for(i = 0; i < length; i++){
                        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                        switch(len){
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
                var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
                var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
                if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn) this._events[evt].push(listener);
                else this._events[evt] = [
                    this._events[evt],
                    listener
                ];
                return this;
            };
            /**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt]) return this;
                if (!fn) {
                    if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                    else if (--this._eventsCount === 0) this._events = new Events();
                    else delete this._events[evt];
                }
                return this;
            };
            /**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) {
                        if (--this._eventsCount === 0) this._events = new Events();
                        else delete this._events[evt];
                    }
                } else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // This function doesn't apply anymore.
            //
            EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
                return this;
            };
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            //
            // Expose the module.
            //
            if ('undefined' !== typeof module1) module1.exports = EventEmitter;
        /***/ },
        /* 55 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend2 = __webpack_require__(3);
            var _extend3 = _interopRequireDefault(_extend2);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _align = __webpack_require__(36);
            var _background = __webpack_require__(37);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _color = __webpack_require__(26);
            var _direction = __webpack_require__(38);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:clipboard');
            var DOM_KEY = '__ql-matcher';
            var CLIPBOARD_CONFIG = [
                [
                    Node.TEXT_NODE,
                    matchText
                ],
                [
                    Node.TEXT_NODE,
                    matchNewline
                ],
                [
                    'br',
                    matchBreak
                ],
                [
                    Node.ELEMENT_NODE,
                    matchNewline
                ],
                [
                    Node.ELEMENT_NODE,
                    matchBlot
                ],
                [
                    Node.ELEMENT_NODE,
                    matchSpacing
                ],
                [
                    Node.ELEMENT_NODE,
                    matchAttributor
                ],
                [
                    Node.ELEMENT_NODE,
                    matchStyles
                ],
                [
                    'li',
                    matchIndent
                ],
                [
                    'b',
                    matchAlias.bind(matchAlias, 'bold')
                ],
                [
                    'i',
                    matchAlias.bind(matchAlias, 'italic')
                ],
                [
                    'style',
                    matchIgnore
                ]
            ];
            var ATTRIBUTE_ATTRIBUTORS = [
                _align.AlignAttribute,
                _direction.DirectionAttribute
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var STYLE_ATTRIBUTORS = [
                _align.AlignStyle,
                _background.BackgroundStyle,
                _color.ColorStyle,
                _direction.DirectionStyle,
                _font.FontStyle,
                _size.SizeStyle
            ].reduce(function(memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var Clipboard = function(_Module) {
                _inherits(Clipboard, _Module);
                function Clipboard(quill, options) {
                    _classCallCheck(this, Clipboard);
                    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
                    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
                    _this.container = _this.quill.addContainer('ql-clipboard');
                    _this.container.setAttribute('contenteditable', true);
                    _this.container.setAttribute('tabindex', -1);
                    _this.matchers = [];
                    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function(_ref) {
                        var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                        if (!options.matchVisual && matcher === matchSpacing) return;
                        _this.addMatcher(selector, matcher);
                    });
                    return _this;
                }
                _createClass(Clipboard, [
                    {
                        key: 'addMatcher',
                        value: function addMatcher(selector, matcher) {
                            this.matchers.push([
                                selector,
                                matcher
                            ]);
                        }
                    },
                    {
                        key: 'convert',
                        value: function convert(html) {
                            if (typeof html === 'string') {
                                this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
                                return this.convert();
                            }
                            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                            if (formats[_code2.default.blotName]) {
                                var text = this.container.innerText;
                                this.container.innerHTML = '';
                                return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                            }
                            var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                            var delta = traverse(this.container, elementMatchers, textMatchers);
                            // Remove trailing newline
                            if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                            debug.log('convert', this.container.innerHTML, delta);
                            this.container.innerHTML = '';
                            return delta;
                        }
                    },
                    {
                        key: 'dangerouslyPasteHTML',
                        value: function dangerouslyPasteHTML(index, html) {
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
                            if (typeof index === 'string') {
                                this.quill.setContents(this.convert(index), html);
                                this.quill.setSelection(0, _quill2.default.sources.SILENT);
                            } else {
                                var paste = this.convert(html);
                                this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                                this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
                            }
                        }
                    },
                    {
                        key: 'onPaste',
                        value: function onPaste(e) {
                            var _this2 = this;
                            if (e.defaultPrevented || !this.quill.isEnabled()) return;
                            var range = this.quill.getSelection();
                            var delta = new _quillDelta2.default().retain(range.index);
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.container.focus();
                            this.quill.selection.update(_quill2.default.sources.SILENT);
                            setTimeout(function() {
                                delta = delta.concat(_this2.convert()).delete(range.length);
                                _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                                // range.length contributes to delta.length()
                                _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                                _this2.quill.scrollingContainer.scrollTop = scrollTop;
                                _this2.quill.focus();
                            }, 1);
                        }
                    },
                    {
                        key: 'prepareMatching',
                        value: function prepareMatching() {
                            var _this3 = this;
                            var elementMatchers = [], textMatchers = [];
                            this.matchers.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                                switch(selector){
                                    case Node.TEXT_NODE:
                                        textMatchers.push(matcher);
                                        break;
                                    case Node.ELEMENT_NODE:
                                        elementMatchers.push(matcher);
                                        break;
                                    default:
                                        [].forEach.call(_this3.container.querySelectorAll(selector), function(node) {
                                            // TODO use weakmap
                                            node[DOM_KEY] = node[DOM_KEY] || [];
                                            node[DOM_KEY].push(matcher);
                                        });
                                        break;
                                }
                            });
                            return [
                                elementMatchers,
                                textMatchers
                            ];
                        }
                    }
                ]);
                return Clipboard;
            }(_module2.default);
            Clipboard.DEFAULTS = {
                matchers: [],
                matchVisual: true
            };
            function applyFormat(delta, format, value) {
                if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') return Object.keys(format).reduce(function(delta, key) {
                    return applyFormat(delta, key, format[key]);
                }, delta);
                else return delta.reduce(function(delta, op) {
                    if (op.attributes && op.attributes[format]) return delta.push(op);
                    else return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                }, new _quillDelta2.default());
            }
            function computeStyle(node) {
                if (node.nodeType !== Node.ELEMENT_NODE) return {};
                var DOM_KEY = '__ql-computed-style';
                return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
            }
            function deltaEndsWith(delta, text) {
                var endText = "";
                for(var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i){
                    var op = delta.ops[i];
                    if (typeof op.insert !== 'string') break;
                    endText = op.insert + endText;
                }
                return endText.slice(-1 * text.length) === text;
            }
            function isLine(node) {
                if (node.childNodes.length === 0) return false; // Exclude embed blocks
                var style = computeStyle(node);
                return [
                    'block',
                    'list-item'
                ].indexOf(style.display) > -1;
            }
            function traverse(node, elementMatchers, textMatchers) {
                // Post-order
                if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce(function(delta, matcher) {
                    return matcher(node, delta);
                }, new _quillDelta2.default());
                else if (node.nodeType === node.ELEMENT_NODE) return [].reduce.call(node.childNodes || [], function(delta, childNode) {
                    var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                    if (childNode.nodeType === node.ELEMENT_NODE) {
                        childrenDelta = elementMatchers.reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                        childrenDelta = (childNode[DOM_KEY] || []).reduce(function(childrenDelta, matcher) {
                            return matcher(childNode, childrenDelta);
                        }, childrenDelta);
                    }
                    return delta.concat(childrenDelta);
                }, new _quillDelta2.default());
                else return new _quillDelta2.default();
            }
            function matchAlias(format, node, delta) {
                return applyFormat(delta, format, true);
            }
            function matchAttributor(node, delta) {
                var attributes = _parchment2.default.Attributor.Attribute.keys(node);
                var classes = _parchment2.default.Attributor.Class.keys(node);
                var styles = _parchment2.default.Attributor.Style.keys(node);
                var formats = {};
                attributes.concat(classes).concat(styles).forEach(function(name) {
                    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
                    if (attr != null) {
                        formats[attr.attrName] = attr.value(node);
                        if (formats[attr.attrName]) return;
                    }
                    attr = ATTRIBUTE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
                    attr = STYLE_ATTRIBUTORS[name];
                    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                        attr = STYLE_ATTRIBUTORS[name];
                        formats[attr.attrName] = attr.value(node) || undefined;
                    }
                });
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                return delta;
            }
            function matchBlot(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null) return delta;
                if (match.prototype instanceof _parchment2.default.Embed) {
                    var embed = {};
                    var value = match.value(node);
                    if (value != null) {
                        embed[match.blotName] = value;
                        delta = new _quillDelta2.default().insert(embed, match.formats(node));
                    }
                } else if (typeof match.formats === 'function') delta = applyFormat(delta, match.blotName, match.formats(node));
                return delta;
            }
            function matchBreak(node, delta) {
                if (!deltaEndsWith(delta, '\n')) delta.insert('\n');
                return delta;
            }
            function matchIgnore() {
                return new _quillDelta2.default();
            }
            function matchIndent(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) return delta;
                var indent = -1, parent = node.parentNode;
                while(!parent.classList.contains('ql-clipboard')){
                    if ((_parchment2.default.query(parent) || {}).blotName === 'list') indent += 1;
                    parent = parent.parentNode;
                }
                if (indent <= 0) return delta;
                return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, {
                    indent: indent
                }));
            }
            function matchNewline(node, delta) {
                if (!deltaEndsWith(delta, '\n')) {
                    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) delta.insert('\n');
                }
                return delta;
            }
            function matchSpacing(node, delta) {
                if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
                    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
                    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) delta.insert('\n');
                }
                return delta;
            }
            function matchStyles(node, delta) {
                var formats = {};
                var style = node.style || {};
                if (style.fontStyle && computeStyle(node).fontStyle === 'italic') formats.italic = true;
                if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) formats.bold = true;
                if (Object.keys(formats).length > 0) delta = applyFormat(delta, formats);
                if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
                delta = new _quillDelta2.default().insert('\t').concat(delta);
                return delta;
            }
            function matchText(node, delta) {
                var text = node.data;
                // Word represents empty line with <o:p>&nbsp;</o:p>
                if (node.parentNode.tagName === 'O:P') return delta.insert(text.trim());
                if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) return delta;
                if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
                    // eslint-disable-next-line func-style
                    var replacer = function replacer(collapse, match) {
                        match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
                        return match.length < 1 && collapse ? ' ' : match;
                    };
                    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
                    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
                    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) text = text.replace(/^\s+/, replacer.bind(replacer, false));
                    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) text = text.replace(/\s+$/, replacer.bind(replacer, false));
                }
                return delta.insert(text);
            }
            exports.default = Clipboard;
            exports.matchAttributor = matchAttributor;
            exports.matchBlot = matchBlot;
            exports.matchNewline = matchNewline;
            exports.matchSpacing = matchSpacing;
            exports.matchText = matchText;
        /***/ },
        /* 56 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Bold = function(_Inline) {
                _inherits(Bold, _Inline);
                function Bold() {
                    _classCallCheck(this, Bold);
                    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
                }
                _createClass(Bold, [
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
                            if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create() {
                            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }
                ]);
                return Bold;
            }(_inline2.default);
            Bold.blotName = 'bold';
            Bold.tagName = [
                'STRONG',
                'B'
            ];
            exports.default = Bold;
        /***/ },
        /* 57 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.addControls = exports.default = undefined;
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var debug = (0, _logger2.default)('quill:toolbar');
            var Toolbar = function(_Module) {
                _inherits(Toolbar, _Module);
                function Toolbar(quill, options) {
                    _classCallCheck(this, Toolbar);
                    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
                    if (Array.isArray(_this.options.container)) {
                        var container = document.createElement('div');
                        addControls(container, _this.options.container);
                        quill.container.parentNode.insertBefore(container, quill.container);
                        _this.container = container;
                    } else if (typeof _this.options.container === 'string') _this.container = document.querySelector(_this.options.container);
                    else _this.container = _this.options.container;
                    if (!(_this.container instanceof HTMLElement)) {
                        var _ret;
                        return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
                    }
                    _this.container.classList.add('ql-toolbar');
                    _this.controls = [];
                    _this.handlers = {};
                    Object.keys(_this.options.handlers).forEach(function(format) {
                        _this.addHandler(format, _this.options.handlers[format]);
                    });
                    [].forEach.call(_this.container.querySelectorAll('button, select'), function(input) {
                        _this.attach(input);
                    });
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(type, range) {
                        if (type === _quill2.default.events.SELECTION_CHANGE) _this.update(range);
                    });
                    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0]; // quill.getSelection triggers update
                        _this.update(range);
                    });
                    return _this;
                }
                _createClass(Toolbar, [
                    {
                        key: 'addHandler',
                        value: function addHandler(format, handler) {
                            this.handlers[format] = handler;
                        }
                    },
                    {
                        key: 'attach',
                        value: function attach(input) {
                            var _this2 = this;
                            var format = [].find.call(input.classList, function(className) {
                                return className.indexOf('ql-') === 0;
                            });
                            if (!format) return;
                            format = format.slice(3);
                            if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
                            if (this.handlers[format] == null) {
                                if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                                    debug.warn('ignoring attaching to disabled format', format, input);
                                    return;
                                }
                                if (_parchment2.default.query(format) == null) {
                                    debug.warn('ignoring attaching to nonexistent format', format, input);
                                    return;
                                }
                            }
                            var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
                            input.addEventListener(eventName, function(e) {
                                var value = void 0;
                                if (input.tagName === 'SELECT') {
                                    if (input.selectedIndex < 0) return;
                                    var selected = input.options[input.selectedIndex];
                                    if (selected.hasAttribute('selected')) value = false;
                                    else value = selected.value || false;
                                } else {
                                    if (input.classList.contains('ql-active')) value = false;
                                    else value = input.value || !input.hasAttribute('value');
                                    e.preventDefault();
                                }
                                _this2.quill.focus();
                                var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                                if (_this2.handlers[format] != null) _this2.handlers[format].call(_this2, value);
                                else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                                    value = prompt('Enter ' + format);
                                    if (!value) return;
                                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                                } else _this2.quill.format(format, value, _quill2.default.sources.USER);
                                _this2.update(range);
                            });
                            // TODO use weakmap
                            this.controls.push([
                                format,
                                input
                            ]);
                        }
                    },
                    {
                        key: 'update',
                        value: function update(range) {
                            var formats = range == null ? {} : this.quill.getFormat(range);
                            this.controls.forEach(function(pair) {
                                var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                                if (input.tagName === 'SELECT') {
                                    var option = void 0;
                                    if (range == null) option = null;
                                    else if (formats[format] == null) option = input.querySelector('option[selected]');
                                    else if (!Array.isArray(formats[format])) {
                                        var value = formats[format];
                                        if (typeof value === 'string') value = value.replace(/\"/g, '\\"');
                                        option = input.querySelector('option[value="' + value + '"]');
                                    }
                                    if (option == null) {
                                        input.value = ''; // TODO make configurable?
                                        input.selectedIndex = -1;
                                    } else option.selected = true;
                                } else {
                                    if (range == null) input.classList.remove('ql-active');
                                    else if (input.hasAttribute('value')) {
                                        // both being null should match (default values)
                                        // '1' should match with 1 (headers)
                                        var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
                                        input.classList.toggle('ql-active', isActive);
                                    } else input.classList.toggle('ql-active', formats[format] != null);
                                }
                            });
                        }
                    }
                ]);
                return Toolbar;
            }(_module2.default);
            Toolbar.DEFAULTS = {};
            function addButton(container, format, value) {
                var input = document.createElement('button');
                input.setAttribute('type', 'button');
                input.classList.add('ql-' + format);
                if (value != null) input.value = value;
                container.appendChild(input);
            }
            function addControls(container, groups) {
                if (!Array.isArray(groups[0])) groups = [
                    groups
                ];
                groups.forEach(function(controls) {
                    var group = document.createElement('span');
                    group.classList.add('ql-formats');
                    controls.forEach(function(control) {
                        if (typeof control === 'string') addButton(group, control);
                        else {
                            var format = Object.keys(control)[0];
                            var value = control[format];
                            if (Array.isArray(value)) addSelect(group, format, value);
                            else addButton(group, format, value);
                        }
                    });
                    container.appendChild(group);
                });
            }
            function addSelect(container, format, values) {
                var input = document.createElement('select');
                input.classList.add('ql-' + format);
                values.forEach(function(value) {
                    var option = document.createElement('option');
                    if (value !== false) option.setAttribute('value', value);
                    else option.setAttribute('selected', 'selected');
                    input.appendChild(option);
                });
                container.appendChild(input);
            }
            Toolbar.DEFAULTS = {
                container: null,
                handlers: {
                    clean: function clean() {
                        var _this3 = this;
                        var range = this.quill.getSelection();
                        if (range == null) return;
                        if (range.length == 0) {
                            var formats = this.quill.getFormat();
                            Object.keys(formats).forEach(function(name) {
                                // Clean functionality in existing apps only clean inline formats
                                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) _this3.quill.format(name, false);
                            });
                        } else this.quill.removeFormat(range, _quill2.default.sources.USER);
                    },
                    direction: function direction(value) {
                        var align = this.quill.getFormat()['align'];
                        if (value === 'rtl' && align == null) this.quill.format('align', 'right', _quill2.default.sources.USER);
                        else if (!value && align === 'right') this.quill.format('align', false, _quill2.default.sources.USER);
                        this.quill.format('direction', value, _quill2.default.sources.USER);
                    },
                    indent: function indent(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        var indent = parseInt(formats.indent || 0);
                        if (value === '+1' || value === '-1') {
                            var modifier = value === '+1' ? 1 : -1;
                            if (formats.direction === 'rtl') modifier *= -1;
                            this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
                        }
                    },
                    link: function link(value) {
                        if (value === true) value = prompt('Enter link URL:');
                        this.quill.format('link', value, _quill2.default.sources.USER);
                    },
                    list: function list(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        if (value === 'check') {
                            if (formats['list'] === 'checked' || formats['list'] === 'unchecked') this.quill.format('list', false, _quill2.default.sources.USER);
                            else this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
                        } else this.quill.format('list', value, _quill2.default.sources.USER);
                    }
                }
            };
            exports.default = Toolbar;
            exports.addControls = addControls;
        /***/ },
        /* 58 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
        /***/ },
        /* 59 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ColorPicker = function(_Picker) {
                _inherits(ColorPicker, _Picker);
                function ColorPicker(select, label) {
                    _classCallCheck(this, ColorPicker);
                    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
                    _this.label.innerHTML = label;
                    _this.container.classList.add('ql-color-picker');
                    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function(item) {
                        item.classList.add('ql-primary');
                    });
                    return _this;
                }
                _createClass(ColorPicker, [
                    {
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
                            item.style.backgroundColor = option.getAttribute('value') || '';
                            return item;
                        }
                    },
                    {
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            var colorLabel = this.label.querySelector('.ql-color-label');
                            var value = item ? item.getAttribute('data-value') || '' : '';
                            if (colorLabel) {
                                if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
                                else colorLabel.style.fill = value;
                            }
                        }
                    }
                ]);
                return ColorPicker;
            }(_picker2.default);
            exports.default = ColorPicker;
        /***/ },
        /* 60 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IconPicker = function(_Picker) {
                _inherits(IconPicker, _Picker);
                function IconPicker(select, icons) {
                    _classCallCheck(this, IconPicker);
                    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
                    _this.container.classList.add('ql-icon-picker');
                    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function(item) {
                        item.innerHTML = icons[item.getAttribute('data-value') || ''];
                    });
                    _this.defaultItem = _this.container.querySelector('.ql-selected');
                    _this.selectItem(_this.defaultItem);
                    return _this;
                }
                _createClass(IconPicker, [
                    {
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            item = item || this.defaultItem;
                            this.label.innerHTML = item.innerHTML;
                        }
                    }
                ]);
                return IconPicker;
            }(_picker2.default);
            exports.default = IconPicker;
        /***/ },
        /* 61 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Tooltip = function() {
                function Tooltip(quill, boundsContainer) {
                    var _this = this;
                    _classCallCheck(this, Tooltip);
                    this.quill = quill;
                    this.boundsContainer = boundsContainer || document.body;
                    this.root = quill.addContainer('ql-tooltip');
                    this.root.innerHTML = this.constructor.TEMPLATE;
                    if (this.quill.root === this.quill.scrollingContainer) this.quill.root.addEventListener('scroll', function() {
                        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
                    });
                    this.hide();
                }
                _createClass(Tooltip, [
                    {
                        key: 'hide',
                        value: function hide() {
                            this.root.classList.add('ql-hidden');
                        }
                    },
                    {
                        key: 'position',
                        value: function position(reference) {
                            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                            // root.scrollTop should be 0 if scrollContainer !== root
                            var top = reference.bottom + this.quill.root.scrollTop;
                            this.root.style.left = left + 'px';
                            this.root.style.top = top + 'px';
                            this.root.classList.remove('ql-flip');
                            var containerBounds = this.boundsContainer.getBoundingClientRect();
                            var rootBounds = this.root.getBoundingClientRect();
                            var shift = 0;
                            if (rootBounds.right > containerBounds.right) {
                                shift = containerBounds.right - rootBounds.right;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.left < containerBounds.left) {
                                shift = containerBounds.left - rootBounds.left;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.bottom > containerBounds.bottom) {
                                var height = rootBounds.bottom - rootBounds.top;
                                var verticalShift = reference.bottom - reference.top + height;
                                this.root.style.top = top - verticalShift + 'px';
                                this.root.classList.add('ql-flip');
                            }
                            return shift;
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            this.root.classList.remove('ql-editing');
                            this.root.classList.remove('ql-hidden');
                        }
                    }
                ]);
                return Tooltip;
            }();
            exports.default = Tooltip;
        /***/ },
        /* 62 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function() {
                function sliceIterator(arr, i) {
                    var _arr = [];
                    var _n = true;
                    var _d = false;
                    var _e = undefined;
                    try {
                        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                            _arr.push(_s.value);
                            if (i && _arr.length === i) break;
                        }
                    } catch (err) {
                        _d = true;
                        _e = err;
                    } finally{
                        try {
                            if (!_n && _i["return"]) _i["return"]();
                        } finally{
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                    else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    {
                        header: [
                            '1',
                            '2',
                            '3',
                            false
                        ]
                    }
                ],
                [
                    'bold',
                    'italic',
                    'underline',
                    'link'
                ],
                [
                    {
                        list: 'ordered'
                    },
                    {
                        list: 'bullet'
                    }
                ],
                [
                    'clean'
                ]
            ];
            var SnowTheme = function(_BaseTheme) {
                _inherits(SnowTheme, _BaseTheme);
                function SnowTheme(quill, options) {
                    _classCallCheck(this, SnowTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-snow');
                    return _this;
                }
                _createClass(SnowTheme, [
                    {
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            toolbar.container.classList.add('ql-snow');
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                                key: 'K',
                                shortKey: true
                            }, function(range, context) {
                                toolbar.handlers['link'].call(toolbar, !context.format.link);
                            });
                        }
                    }
                ]);
                return SnowTheme;
            }(_base2.default);
            SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (value) {
                                    var range = this.quill.getSelection();
                                    if (range == null || range.length == 0) return;
                                    var preview = this.quill.getText(range);
                                    if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = 'mailto:' + preview;
                                    var tooltip = this.quill.theme.tooltip;
                                    tooltip.edit('link', preview);
                                } else this.quill.format('link', false);
                            }
                        }
                    }
                }
            });
            var SnowTooltip = function(_BaseTooltip) {
                _inherits(SnowTooltip, _BaseTooltip);
                function SnowTooltip(quill, bounds) {
                    _classCallCheck(this, SnowTooltip);
                    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
                    _this2.preview = _this2.root.querySelector('a.ql-preview');
                    return _this2;
                }
                _createClass(SnowTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('a.ql-action').addEventListener('click', function(event) {
                                if (_this3.root.classList.contains('ql-editing')) _this3.save();
                                else _this3.edit('link', _this3.preview.textContent);
                                event.preventDefault();
                            });
                            this.root.querySelector('a.ql-remove').addEventListener('click', function(event) {
                                if (_this3.linkRange != null) {
                                    var range = _this3.linkRange;
                                    _this3.restoreFocus();
                                    _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
                                    delete _this3.linkRange;
                                }
                                event.preventDefault();
                                _this3.hide();
                            });
                            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function(range, oldRange, source) {
                                if (range == null) return;
                                if (range.length === 0 && source === _emitter2.default.sources.USER) {
                                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                                    if (link != null) {
                                        _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                                        var preview = _link2.default.formats(link.domNode);
                                        _this3.preview.textContent = preview;
                                        _this3.preview.setAttribute('href', preview);
                                        _this3.show();
                                        _this3.position(_this3.quill.getBounds(_this3.linkRange));
                                        return;
                                    }
                                } else delete _this3.linkRange;
                                _this3.hide();
                            });
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
                            this.root.removeAttribute('data-mode');
                        }
                    }
                ]);
                return SnowTooltip;
            }(_base.BaseTooltip);
            SnowTooltip.TEMPLATE = [
                '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-action"></a>',
                '<a class="ql-remove"></a>'
            ].join('');
            exports.default = SnowTheme;
        /***/ },
        /* 63 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core = __webpack_require__(29);
            var _core2 = _interopRequireDefault(_core);
            var _align = __webpack_require__(36);
            var _direction = __webpack_require__(38);
            var _indent = __webpack_require__(64);
            var _blockquote = __webpack_require__(65);
            var _blockquote2 = _interopRequireDefault(_blockquote);
            var _header = __webpack_require__(66);
            var _header2 = _interopRequireDefault(_header);
            var _list = __webpack_require__(67);
            var _list2 = _interopRequireDefault(_list);
            var _background = __webpack_require__(37);
            var _color = __webpack_require__(26);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            var _italic = __webpack_require__(68);
            var _italic2 = _interopRequireDefault(_italic);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _script = __webpack_require__(69);
            var _script2 = _interopRequireDefault(_script);
            var _strike = __webpack_require__(70);
            var _strike2 = _interopRequireDefault(_strike);
            var _underline = __webpack_require__(71);
            var _underline2 = _interopRequireDefault(_underline);
            var _image = __webpack_require__(72);
            var _image2 = _interopRequireDefault(_image);
            var _video = __webpack_require__(73);
            var _video2 = _interopRequireDefault(_video);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _formula = __webpack_require__(74);
            var _formula2 = _interopRequireDefault(_formula);
            var _syntax = __webpack_require__(75);
            var _syntax2 = _interopRequireDefault(_syntax);
            var _toolbar = __webpack_require__(57);
            var _toolbar2 = _interopRequireDefault(_toolbar);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            var _bubble = __webpack_require__(108);
            var _bubble2 = _interopRequireDefault(_bubble);
            var _snow = __webpack_require__(62);
            var _snow2 = _interopRequireDefault(_snow);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            _core2.default.register({
                'attributors/attribute/direction': _direction.DirectionAttribute,
                'attributors/class/align': _align.AlignClass,
                'attributors/class/background': _background.BackgroundClass,
                'attributors/class/color': _color.ColorClass,
                'attributors/class/direction': _direction.DirectionClass,
                'attributors/class/font': _font.FontClass,
                'attributors/class/size': _size.SizeClass,
                'attributors/style/align': _align.AlignStyle,
                'attributors/style/background': _background.BackgroundStyle,
                'attributors/style/color': _color.ColorStyle,
                'attributors/style/direction': _direction.DirectionStyle,
                'attributors/style/font': _font.FontStyle,
                'attributors/style/size': _size.SizeStyle
            }, true);
            _core2.default.register({
                'formats/align': _align.AlignClass,
                'formats/direction': _direction.DirectionClass,
                'formats/indent': _indent.IndentClass,
                'formats/background': _background.BackgroundStyle,
                'formats/color': _color.ColorStyle,
                'formats/font': _font.FontClass,
                'formats/size': _size.SizeClass,
                'formats/blockquote': _blockquote2.default,
                'formats/code-block': _code2.default,
                'formats/header': _header2.default,
                'formats/list': _list2.default,
                'formats/bold': _bold2.default,
                'formats/code': _code.Code,
                'formats/italic': _italic2.default,
                'formats/link': _link2.default,
                'formats/script': _script2.default,
                'formats/strike': _strike2.default,
                'formats/underline': _underline2.default,
                'formats/image': _image2.default,
                'formats/video': _video2.default,
                'formats/list/item': _list.ListItem,
                'modules/formula': _formula2.default,
                'modules/syntax': _syntax2.default,
                'modules/toolbar': _toolbar2.default,
                'themes/bubble': _bubble2.default,
                'themes/snow': _snow2.default,
                'ui/icons': _icons2.default,
                'ui/picker': _picker2.default,
                'ui/icon-picker': _iconPicker2.default,
                'ui/color-picker': _colorPicker2.default,
                'ui/tooltip': _tooltip2.default
            }, true);
            exports.default = _core2.default;
        /***/ },
        /* 64 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.IndentClass = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var IdentAttributor = function(_Parchment$Attributor) {
                _inherits(IdentAttributor, _Parchment$Attributor);
                function IdentAttributor() {
                    _classCallCheck(this, IdentAttributor);
                    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
                }
                _createClass(IdentAttributor, [
                    {
                        key: 'add',
                        value: function add(node, value) {
                            if (value === '+1' || value === '-1') {
                                var indent = this.value(node) || 0;
                                value = value === '+1' ? indent + 1 : indent - 1;
                            }
                            if (value === 0) {
                                this.remove(node);
                                return true;
                            } else return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
                        }
                    },
                    {
                        key: 'canAdd',
                        value: function canAdd(node, value) {
                            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
                        }
                    },
                    {
                        key: 'value',
                        value: function value(node) {
                            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
                        }
                    }
                ]);
                return IdentAttributor;
            }(_parchment2.default.Attributor.Class);
            var IndentClass = new IdentAttributor('indent', 'ql-indent', {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8
                ]
            });
            exports.IndentClass = IndentClass;
        /***/ },
        /* 65 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Blockquote = function(_Block) {
                _inherits(Blockquote, _Block);
                function Blockquote() {
                    _classCallCheck(this, Blockquote);
                    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
                }
                return Blockquote;
            }(_block2.default);
            Blockquote.blotName = 'blockquote';
            Blockquote.tagName = 'blockquote';
            exports.default = Blockquote;
        /***/ },
        /* 66 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Header = function(_Block) {
                _inherits(Header, _Block);
                function Header() {
                    _classCallCheck(this, Header);
                    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
                }
                _createClass(Header, null, [
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return this.tagName.indexOf(domNode.tagName) + 1;
                        }
                    }
                ]);
                return Header;
            }(_block2.default);
            Header.blotName = 'header';
            Header.tagName = [
                'H1',
                'H2',
                'H3',
                'H4',
                'H5',
                'H6'
            ];
            exports.default = Header;
        /***/ },
        /* 67 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.ListItem = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _container = __webpack_require__(25);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ListItem = function(_Block) {
                _inherits(ListItem, _Block);
                function ListItem() {
                    _classCallCheck(this, ListItem);
                    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
                }
                _createClass(ListItem, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (name === List.blotName && !value) this.replaceWith(_parchment2.default.create(this.statics.scope));
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
                        }
                    },
                    {
                        key: 'remove',
                        value: function remove() {
                            if (this.prev == null && this.next == null) this.parent.remove();
                            else _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
                        }
                    },
                    {
                        key: 'replaceWith',
                        value: function replaceWith(name, value) {
                            this.parent.isolate(this.offset(this.parent), this.length());
                            if (name === this.parent.statics.blotName) {
                                this.parent.replaceWith(name, value);
                                return this;
                            } else {
                                this.parent.unwrap();
                                return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
                            }
                        }
                    }
                ], [
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
                        }
                    }
                ]);
                return ListItem;
            }(_block2.default);
            ListItem.blotName = 'list-item';
            ListItem.tagName = 'LI';
            var List = function(_Container) {
                _inherits(List, _Container);
                _createClass(List, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            var tagName = value === 'ordered' ? 'OL' : 'UL';
                            var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
                            if (value === 'checked' || value === 'unchecked') node.setAttribute('data-checked', value === 'checked');
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'OL') return 'ordered';
                            if (domNode.tagName === 'UL') {
                                if (domNode.hasAttribute('data-checked')) return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
                                else return 'bullet';
                            }
                            return undefined;
                        }
                    }
                ]);
                function List(domNode) {
                    _classCallCheck(this, List);
                    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
                    var listEventHandler = function listEventHandler(e) {
                        if (e.target.parentNode !== domNode) return;
                        var format = _this2.statics.formats(domNode);
                        var blot = _parchment2.default.find(e.target);
                        if (format === 'checked') blot.format('list', 'unchecked');
                        else if (format === 'unchecked') blot.format('list', 'checked');
                    };
                    domNode.addEventListener('touchstart', listEventHandler);
                    domNode.addEventListener('mousedown', listEventHandler);
                    return _this2;
                }
                _createClass(List, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (this.children.length > 0) this.children.tail.format(name, value);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats() {
                            // We don't inherit from FormatBlot
                            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
                        }
                    },
                    {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot instanceof ListItem) _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
                            else {
                                var index = ref == null ? this.length() : ref.offset(this);
                                var after = this.split(index);
                                after.parent.insertBefore(blot, after);
                            }
                        }
                    },
                    {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    },
                    {
                        key: 'replace',
                        value: function replace(target) {
                            if (target.statics.blotName !== this.statics.blotName) {
                                var item = _parchment2.default.create(this.statics.defaultChild);
                                target.moveChildren(item);
                                this.appendChild(item);
                            }
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
                        }
                    }
                ]);
                return List;
            }(_container2.default);
            List.blotName = 'list';
            List.scope = _parchment2.default.Scope.BLOCK_BLOT;
            List.tagName = [
                'OL',
                'UL'
            ];
            List.defaultChild = 'list-item';
            List.allowedChildren = [
                ListItem
            ];
            exports.ListItem = ListItem;
            exports.default = List;
        /***/ },
        /* 68 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Italic = function(_Bold) {
                _inherits(Italic, _Bold);
                function Italic() {
                    _classCallCheck(this, Italic);
                    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
                }
                return Italic;
            }(_bold2.default);
            Italic.blotName = 'italic';
            Italic.tagName = [
                'EM',
                'I'
            ];
            exports.default = Italic;
        /***/ },
        /* 69 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Script = function(_Inline) {
                _inherits(Script, _Inline);
                function Script() {
                    _classCallCheck(this, Script);
                    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
                }
                _createClass(Script, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            if (value === 'super') return document.createElement('sup');
                            else if (value === 'sub') return document.createElement('sub');
                            else return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'SUB') return 'sub';
                            if (domNode.tagName === 'SUP') return 'super';
                            return undefined;
                        }
                    }
                ]);
                return Script;
            }(_inline2.default);
            Script.blotName = 'script';
            Script.tagName = [
                'SUB',
                'SUP'
            ];
            exports.default = Script;
        /***/ },
        /* 70 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Strike = function(_Inline) {
                _inherits(Strike, _Inline);
                function Strike() {
                    _classCallCheck(this, Strike);
                    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
                }
                return Strike;
            }(_inline2.default);
            Strike.blotName = 'strike';
            Strike.tagName = 'S';
            exports.default = Strike;
        /***/ },
        /* 71 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Underline = function(_Inline) {
                _inherits(Underline, _Inline);
                function Underline() {
                    _classCallCheck(this, Underline);
                    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
                }
                return Underline;
            }(_inline2.default);
            Underline.blotName = 'underline';
            Underline.tagName = 'U';
            exports.default = Underline;
        /***/ },
        /* 72 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _link = __webpack_require__(27);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                'alt',
                'height',
                'width'
            ];
            var Image = function(_Parchment$Embed) {
                _inherits(Image, _Parchment$Embed);
                function Image() {
                    _classCallCheck(this, Image);
                    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
                }
                _createClass(Image, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
                            if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: 'match',
                        value: function match(url) {
                            return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return (0, _link.sanitize)(url, [
                                'http',
                                'https',
                                'data'
                            ]) ? url : '//:0';
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }
                ]);
                return Image;
            }(_parchment2.default.Embed);
            Image.blotName = 'image';
            Image.tagName = 'IMG';
            exports.default = Image;
        /***/ },
        /* 73 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _block = __webpack_require__(4);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var ATTRIBUTES = [
                'height',
                'width'
            ];
            var Video = function(_BlockEmbed) {
                _inherits(Video, _BlockEmbed);
                function Video() {
                    _classCallCheck(this, Video);
                    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
                }
                _createClass(Video, [
                    {
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) this.domNode.setAttribute(name, value);
                                else this.domNode.removeAttribute(name);
                            } else _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
                        }
                    }
                ], [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
                            node.setAttribute('frameborder', '0');
                            node.setAttribute('allowfullscreen', true);
                            node.setAttribute('src', this.sanitize(value));
                            return node;
                        }
                    },
                    {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function(formats, attribute) {
                                if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
                                return formats;
                            }, {});
                        }
                    },
                    {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _link2.default.sanitize(url);
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }
                ]);
                return Video;
            }(_block.BlockEmbed);
            Video.blotName = 'video';
            Video.className = 'ql-video';
            Video.tagName = 'IFRAME';
            exports.default = Video;
        /***/ },
        /* 74 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.FormulaBlot = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _embed = __webpack_require__(35);
            var _embed2 = _interopRequireDefault(_embed);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var FormulaBlot = function(_Embed) {
                _inherits(FormulaBlot, _Embed);
                function FormulaBlot() {
                    _classCallCheck(this, FormulaBlot);
                    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
                }
                _createClass(FormulaBlot, null, [
                    {
                        key: 'create',
                        value: function create(value) {
                            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
                            if (typeof value === 'string') {
                                window.katex.render(value, node, {
                                    throwOnError: false,
                                    errorColor: '#f00'
                                });
                                node.setAttribute('data-value', value);
                            }
                            return node;
                        }
                    },
                    {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('data-value');
                        }
                    }
                ]);
                return FormulaBlot;
            }(_embed2.default);
            FormulaBlot.blotName = 'formula';
            FormulaBlot.className = 'ql-formula';
            FormulaBlot.tagName = 'SPAN';
            var Formula = function(_Module) {
                _inherits(Formula, _Module);
                _createClass(Formula, null, [
                    {
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(FormulaBlot, true);
                        }
                    }
                ]);
                function Formula() {
                    _classCallCheck(this, Formula);
                    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
                    if (window.katex == null) throw new Error('Formula module requires KaTeX.');
                    return _this2;
                }
                return Formula;
            }(_module2.default);
            exports.FormulaBlot = FormulaBlot;
            exports.default = Formula;
        /***/ },
        /* 75 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.CodeToken = exports.CodeBlock = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var SyntaxCodeBlock = function(_CodeBlock) {
                _inherits(SyntaxCodeBlock, _CodeBlock);
                function SyntaxCodeBlock() {
                    _classCallCheck(this, SyntaxCodeBlock);
                    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
                }
                _createClass(SyntaxCodeBlock, [
                    {
                        key: 'replaceWith',
                        value: function replaceWith(block) {
                            this.domNode.textContent = this.domNode.textContent;
                            this.attach();
                            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
                        }
                    },
                    {
                        key: 'highlight',
                        value: function highlight(_highlight) {
                            var text = this.domNode.textContent;
                            if (this.cachedText !== text) {
                                if (text.trim().length > 0 || this.cachedText == null) {
                                    this.domNode.innerHTML = _highlight(text);
                                    this.domNode.normalize();
                                    this.attach();
                                }
                                this.cachedText = text;
                            }
                        }
                    }
                ]);
                return SyntaxCodeBlock;
            }(_code2.default);
            SyntaxCodeBlock.className = 'ql-syntax';
            var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
                scope: _parchment2.default.Scope.INLINE
            });
            var Syntax = function(_Module) {
                _inherits(Syntax, _Module);
                _createClass(Syntax, null, [
                    {
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(CodeToken, true);
                            _quill2.default.register(SyntaxCodeBlock, true);
                        }
                    }
                ]);
                function Syntax(quill, options) {
                    _classCallCheck(this, Syntax);
                    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
                    if (typeof _this2.options.highlight !== 'function') throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
                    var timer = null;
                    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                        clearTimeout(timer);
                        timer = setTimeout(function() {
                            _this2.highlight();
                            timer = null;
                        }, _this2.options.interval);
                    });
                    _this2.highlight();
                    return _this2;
                }
                _createClass(Syntax, [
                    {
                        key: 'highlight',
                        value: function highlight() {
                            var _this3 = this;
                            if (this.quill.selection.composing) return;
                            this.quill.update(_quill2.default.sources.USER);
                            var range = this.quill.getSelection();
                            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function(code) {
                                code.highlight(_this3.options.highlight);
                            });
                            this.quill.update(_quill2.default.sources.SILENT);
                            if (range != null) this.quill.setSelection(range, _quill2.default.sources.SILENT);
                        }
                    }
                ]);
                return Syntax;
            }(_module2.default);
            Syntax.DEFAULTS = {
                highlight: function() {
                    if (window.hljs == null) return null;
                    return function(text) {
                        var result = window.hljs.highlightAuto(text);
                        return result.value;
                    };
                }(),
                interval: 1000
            };
            exports.CodeBlock = SyntaxCodeBlock;
            exports.CodeToken = CodeToken;
            exports.default = Syntax;
        /***/ },
        /* 76 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 77 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 78 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 79 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
        /***/ },
        /* 80 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
        /***/ },
        /* 81 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
        /***/ },
        /* 82 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
        /***/ },
        /* 83 */ /***/ function(module1, exports) {
            module1.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
        /***/ },
        /* 84 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
        /***/ },
        /* 85 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
        /***/ },
        /* 86 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
        /***/ },
        /* 87 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 88 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 89 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
        /***/ },
        /* 90 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
        /***/ },
        /* 91 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
        /***/ },
        /* 92 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
        /***/ },
        /* 93 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
        /***/ },
        /* 94 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
        /***/ },
        /* 95 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
        /***/ },
        /* 96 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
        /***/ },
        /* 97 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
        /***/ },
        /* 98 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
        /***/ },
        /* 99 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
        /***/ },
        /* 100 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
        /***/ },
        /* 101 */ /***/ function(module1, exports) {
            module1.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
        /***/ },
        /* 102 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
        /***/ },
        /* 103 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
        /***/ },
        /* 104 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
        /***/ },
        /* 105 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
        /***/ },
        /* 106 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
        /***/ },
        /* 107 */ /***/ function(module1, exports) {
            module1.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
        /***/ },
        /* 108 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BubbleTooltip = undefined;
            var _get = function get(object, property, receiver) {
                if (object === null) object = Function.prototype;
                var desc = Object.getOwnPropertyDescriptor(object, property);
                if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);
                    if (parent === null) return undefined;
                    else return get(parent, property, receiver);
                } else if ("value" in desc) return desc.value;
                else {
                    var getter = desc.get;
                    if (getter === undefined) return undefined;
                    return getter.call(receiver);
                }
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self1, call) {
                if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self1;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var TOOLBAR_CONFIG = [
                [
                    'bold',
                    'italic',
                    'link'
                ],
                [
                    {
                        header: 1
                    },
                    {
                        header: 2
                    },
                    'blockquote'
                ]
            ];
            var BubbleTheme = function(_BaseTheme) {
                _inherits(BubbleTheme, _BaseTheme);
                function BubbleTheme(quill, options) {
                    _classCallCheck(this, BubbleTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = TOOLBAR_CONFIG;
                    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-bubble');
                    return _this;
                }
                _createClass(BubbleTheme, [
                    {
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                            this.tooltip.root.appendChild(toolbar.container);
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                        }
                    }
                ]);
                return BubbleTheme;
            }(_base2.default);
            BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (!value) this.quill.format('link', false);
                                else this.quill.theme.tooltip.edit();
                            }
                        }
                    }
                }
            });
            var BubbleTooltip = function(_BaseTooltip) {
                _inherits(BubbleTooltip, _BaseTooltip);
                function BubbleTooltip(quill, bounds) {
                    _classCallCheck(this, BubbleTooltip);
                    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
                    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function(type, range, oldRange, source) {
                        if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
                        if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                            _this2.show();
                            // Lock our width so we will expand beyond our offsetParent boundaries
                            _this2.root.style.left = '0px';
                            _this2.root.style.width = '';
                            _this2.root.style.width = _this2.root.offsetWidth + 'px';
                            var lines = _this2.quill.getLines(range.index, range.length);
                            if (lines.length === 1) _this2.position(_this2.quill.getBounds(range));
                            else {
                                var lastLine = lines[lines.length - 1];
                                var index = _this2.quill.getIndex(lastLine);
                                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                                _this2.position(_bounds);
                            }
                        } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) _this2.hide();
                    });
                    return _this2;
                }
                _createClass(BubbleTooltip, [
                    {
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('.ql-close').addEventListener('click', function() {
                                _this3.root.classList.remove('ql-editing');
                            });
                            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function() {
                                // Let selection be restored by toolbar handlers before repositioning
                                setTimeout(function() {
                                    if (_this3.root.classList.contains('ql-hidden')) return;
                                    var range = _this3.quill.getSelection();
                                    if (range != null) _this3.position(_this3.quill.getBounds(range));
                                }, 1);
                            });
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.show();
                        }
                    },
                    {
                        key: 'position',
                        value: function position(reference) {
                            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
                            var arrow = this.root.querySelector('.ql-tooltip-arrow');
                            arrow.style.marginLeft = '';
                            if (shift === 0) return shift;
                            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
                        }
                    }
                ]);
                return BubbleTooltip;
            }(_base.BaseTooltip);
            BubbleTooltip.TEMPLATE = [
                '<span class="ql-tooltip-arrow"></span>',
                '<div class="ql-tooltip-editor">',
                '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
                '<a class="ql-close"></a>',
                '</div>'
            ].join('');
            exports.BubbleTooltip = BubbleTooltip;
            exports.default = BubbleTheme;
        /***/ },
        /* 109 */ /***/ function(module1, exports, __webpack_require__) {
            module1.exports = __webpack_require__(63);
        /***/ }
    ])["default"];
});

});

parcelRegister("lwfqC", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == 'symbol' || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, '');
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
module.exports = $faa88de4f0afd1d0$var$debounce;

});

parcelRegister("bqkT1", function(module, exports) {
module.exports = new URL("whiteCheck.c4950e50.png", import.meta.url).toString();

});

parcelRegister("jJgJl", function(module, exports) {
module.exports = new URL("stopwatch.5ea0edf6.svg", import.meta.url).toString();

});

parcelRegister("bYbOr", function(module, exports) {
module.exports = new URL("bronze.5707b48c.png", import.meta.url).toString();

});

parcelRegister("f4EyH", function(module, exports) {
module.exports = new URL("silver.646a4936.png", import.meta.url).toString();

});

parcelRegister("ibdCR", function(module, exports) {
module.exports = new URL("gold.176f2679.png", import.meta.url).toString();

});

parcelRegister("7B6TB", function(module, exports) {
module.exports = new URL("banner1.fb1e5c6e.png", import.meta.url).toString();

});

parcelRegister("eoVin", function(module, exports) {
module.exports = new URL("no-companies-added.305fccc9.png", import.meta.url).toString();

});

parcelRegister("nGQfQ", function(module, exports) {
module.exports = new URL("ai-no-company-add.321715b2.png", import.meta.url).toString();

});

parcelRegister("6u4NZ", function(module, exports) {
(function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ var InvalidCharacterError = function(message) {
        this.message = message;
    };
    InvalidCharacterError.prototype = new Error;
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';
    var error = function(message) {
        // Note: the error messages used throughout this file match those used by
        // the native `atob`/`btoa` implementation in Chromium.
        throw new InvalidCharacterError(message);
    };
    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // http://whatwg.org/html/common-microsyntaxes.html#space-character
    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
    // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396
    var decode = function(input) {
        input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
        var length = input.length;
        if (length % 4 == 0) {
            input = input.replace(/==?$/, '');
            length = input.length;
        }
        if (length % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
        /[^+a-zA-Z0-9/]/.test(input)) error('Invalid character: the string to be decoded is not correctly encoded.');
        var bitCounter = 0;
        var bitStorage;
        var buffer;
        var output = '';
        var position = -1;
        while(++position < length){
            buffer = TABLE.indexOf(input.charAt(position));
            bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
            // Unless this is the first of a group of 4 characters…
            if (bitCounter++ % 4) // …convert the first 8 bits to a single ASCII character.
            output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
        }
        return output;
    };
    // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
    var encode = function(input) {
        input = String(input);
        if (/[^\0-\xFF]/.test(input)) // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error("The string to be encoded contains characters outside of the Latin1 range.");
        var padding = input.length % 3;
        var output = '';
        var position = -1;
        var a;
        var b;
        var c;
        var buffer;
        // Make sure any padding is handled outside of the loop.
        var length = input.length - padding;
        while(++position < length){
            // Read three bytes, i.e. 24 bits.
            a = input.charCodeAt(position) << 16;
            b = input.charCodeAt(++position) << 8;
            c = input.charCodeAt(++position);
            buffer = a + b + c;
            // Turn the 24 bits into four chunks of 6 bits each, and append the
            // matching character for each of them to the output.
            output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
        }
        if (padding == 2) {
            a = input.charCodeAt(position) << 8;
            b = input.charCodeAt(++position);
            buffer = a + b;
            output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
        } else if (padding == 1) {
            buffer = input.charCodeAt(position);
            output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
        }
        return output;
    };
    var base64 = {
        'encode': encode,
        'decode': decode,
        'version': '1.0.0'
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define(function() {
        return base64;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = base64;
        else for(var key in base64)base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
    } else root.base64 = base64;
})(this);

});

parcelRegister("1wHuh", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t, y, e, I, i, o, a, h, C, T, d, p, F, n, r, s, c, P, E, q, g, m, w, l, v, b, x, S, u, k, _, f, A, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y, X, J, K, Q, Z, vt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $ = function(pt) {
        var gt = "1.3", mt = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        function wt(o) {
            var a = {};
            this.subscribe = function(t, e, n) {
                if ("function" != typeof e) return !1;
                a.hasOwnProperty(t) || (a[t] = {});
                var r = Math.random().toString(35);
                return a[t][r] = [
                    e,
                    !!n
                ], r;
            }, this.unsubscribe = function(t) {
                for(var e in a)if (a[e][t]) return delete a[e][t], !0;
                return !1;
            }, this.publish = function(t) {
                if (a.hasOwnProperty(t)) {
                    var e = Array.prototype.slice.call(arguments, 1), n = [];
                    for(var r in a[t]){
                        var i = a[t][r];
                        try {
                            i[0].apply(o, e);
                        } catch (t) {
                            pt.console && console.error("jsPDF PubSub Error", t.message, t);
                        }
                        i[1] && n.push(r);
                    }
                    n.length && n.forEach(this.unsubscribe);
                }
            };
        }
        function yt(t, e, n, r) {
            var i = {};
            "object" === (void 0 === t ? "undefined" : vt(t)) && (t = (i = t).orientation, e = i.unit || e, n = i.format || n, r = i.compress || i.compressPdf || r), e = e || "mm", n = n || "a4", t = ("" + (t || "P")).toLowerCase();
            ("" + n).toLowerCase();
            var K, w, y, o, u, v, a, s, h, c, l, f = !!r && "function" == typeof Uint8Array, Q = i.textColor || "0 g", d = i.drawColor || "0 G", Z = i.fontSize || 16, $ = i.charSpace || 0, tt = i.R2L || !1, et = i.lineHeight || 1.15, p = i.lineWidth || .200025, g = "00000000000000000000000000000000", m = 2, b = !1, x = [], nt = {}, S = {}, k = 0, _ = [], A = [], I = [], C = [], T = [], F = 0, P = 0, E = 0, q = {
                title: "",
                subject: "",
                author: "",
                keywords: "",
                creator: ""
            }, O = {}, rt = new wt(O), B = i.hotfixes || [], R = function(t) {
                var e, n = t.ch1, r = t.ch2, i = t.ch3, o = t.ch4, a = (t.precision, "draw" === t.pdfColorType ? [
                    "G",
                    "RG",
                    "K"
                ] : [
                    "g",
                    "rg",
                    "k"
                ]);
                if ("string" == typeof n && "#" !== n.charAt(0)) {
                    var s = new RGBColor(n);
                    s.ok && (n = s.toHex());
                }
                if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
                    var h = parseInt(n.substr(1), 16);
                    n = h >> 16 & 255, r = h >> 8 & 255, i = 255 & h;
                }
                if (void 0 === r || void 0 === o && n === r && r === i) {
                    if ("string" == typeof n) e = n + " " + a[0];
                    else switch(t.precision){
                        case 2:
                            e = N(n / 255) + " " + a[0];
                            break;
                        case 3:
                        default:
                            e = z(n / 255) + " " + a[0];
                    }
                } else if (void 0 === o || "object" === (void 0 === o ? "undefined" : vt(o))) {
                    if ("string" == typeof n) e = [
                        n,
                        r,
                        i,
                        a[1]
                    ].join(" ");
                    else switch(t.precision){
                        case 2:
                            e = [
                                N(n / 255),
                                N(r / 255),
                                N(i / 255),
                                a[1]
                            ].join(" ");
                            break;
                        default:
                        case 3:
                            e = [
                                z(n / 255),
                                z(r / 255),
                                z(i / 255),
                                a[1]
                            ].join(" ");
                    }
                    o && 0 === o.a && (e = [
                        "255",
                        "255",
                        "255",
                        a[1]
                    ].join(" "));
                } else if ("string" == typeof n) e = [
                    n,
                    r,
                    i,
                    o,
                    a[2]
                ].join(" ");
                else switch(t.precision){
                    case 2:
                        e = [
                            N(n),
                            N(r),
                            N(i),
                            N(o),
                            a[2]
                        ].join(" ");
                        break;
                    case 3:
                    default:
                        e = [
                            z(n),
                            z(r),
                            z(i),
                            z(o),
                            a[2]
                        ].join(" ");
                }
                return e;
            }, j = function(t) {
                var e = function(t) {
                    return ("0" + parseInt(t)).slice(-2);
                }, n = t.getTimezoneOffset(), r = n < 0 ? "+" : "-", i = Math.floor(Math.abs(n / 60)), o = Math.abs(n % 60), a = [
                    r,
                    e(i),
                    "'",
                    e(o),
                    "'"
                ].join("");
                return [
                    "D:",
                    t.getFullYear(),
                    e(t.getMonth() + 1),
                    e(t.getDate()),
                    e(t.getHours()),
                    e(t.getMinutes()),
                    e(t.getSeconds()),
                    a
                ].join("");
            }, D = function(t) {
                var e;
                return void 0 === (void 0 === t ? "undefined" : vt(t)) && (t = new Date), e = "object" === (void 0 === t ? "undefined" : vt(t)) && "[object Date]" === Object.prototype.toString.call(t) ? j(t) : /^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t) ? t : j(new Date), c = e;
            }, M = function(t) {
                var e = c;
                return "jsDate" === t && (e = function(t) {
                    var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), o = parseInt(t.substr(12, 2), 10), a = parseInt(t.substr(14, 2), 10);
                    parseInt(t.substr(16, 2), 10), parseInt(t.substr(20, 2), 10);
                    return new Date(e, n, r, i, o, a, 0);
                }(c)), e;
            }, U = function(t) {
                return t = t || "12345678901234567890123456789012".split("").map(function() {
                    return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
                }).join(""), g = t;
            }, N = function(t) {
                return t.toFixed(2);
            }, z = function(t) {
                return t.toFixed(3);
            }, it = function(t) {
                t = "string" == typeof t ? t : t.toString(), b ? _[o].push(t) : (E += t.length + 1, C.push(t));
            }, L = function() {
                return x[++m] = E, it(m + " 0 obj"), m;
            }, H = function(t) {
                it("stream"), it(t), it("endstream");
            }, W = function() {
                for(var t in it("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), it("/Font <<"), nt)nt.hasOwnProperty(t) && it("/" + t + " " + nt[t].objectNumber + " 0 R");
                it(">>"), it("/XObject <<"), rt.publish("putXobjectDict"), it(">>");
            }, G = function() {
                !function() {
                    for(var t in nt)nt.hasOwnProperty(t) && (e = nt[t], rt.publish("putFont", {
                        font: e,
                        out: it,
                        newObject: L
                    }), !0 !== e.isAlreadyPutted && (e.objectNumber = L(), it("<<"), it("/Type /Font"), it("/BaseFont /" + e.postScriptName), it("/Subtype /Type1"), "string" == typeof e.encoding && it("/Encoding /" + e.encoding), it("/FirstChar 32"), it("/LastChar 255"), it(">>"), it("endobj")));
                    var e;
                }(), rt.publish("putResources"), x[2] = E, it("2 0 obj"), it("<<"), W(), it(">>"), it("endobj"), rt.publish("postPutResources");
            }, V = function(t, e, n) {
                S.hasOwnProperty(e) || (S[e] = {}), S[e][n] = t;
            }, Y = function(t, e, n, r) {
                var i = "F" + (Object.keys(nt).length + 1).toString(10), o = nt[i] = {
                    id: i,
                    postScriptName: t,
                    fontName: e,
                    fontStyle: n,
                    encoding: r,
                    metadata: {}
                };
                return V(i, e, n), rt.publish("addFont", o), i;
            }, ot = function(t, e) {
                return (function(t, e) {
                    var n, r, i, o, a, s, h, c, l;
                    if (i = (e = e || {}).sourceEncoding || "Unicode", a = e.outputEncoding, (e.autoencode || a) && nt[K].metadata && nt[K].metadata[i] && nt[K].metadata[i].encoding && (o = nt[K].metadata[i].encoding, !a && nt[K].encoding && (a = nt[K].encoding), !a && o.codePages && (a = o.codePages[0]), "string" == typeof a && (a = o[a]), a)) {
                        for(h = !1, s = [], n = 0, r = t.length; n < r; n++)(c = a[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (h = !0);
                        t = s.join("");
                    }
                    for(n = t.length; void 0 === h && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (h = !0), n--;
                    if (!h) return t;
                    for(s = e.noBOM ? [] : [
                        254,
                        255
                    ], n = 0, r = t.length; n < r; n++){
                        if ((l = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                        s.push(l), s.push(c - (l << 8));
                    }
                    return String.fromCharCode.apply(void 0, s);
                })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
            }, X = function() {
                (function(t, e) {
                    var n = "string" == typeof e && e.toLowerCase();
                    if ("string" == typeof t) {
                        var r = t.toLowerCase();
                        mt.hasOwnProperty(r) && (t = mt[r][0] / w, e = mt[r][1] / w);
                    }
                    if (Array.isArray(t) && (e = t[1], t = t[0]), n) {
                        switch(n.substr(0, 1)){
                            case "l":
                                t < e && (n = "s");
                                break;
                            case "p":
                                e < t && (n = "s");
                        }
                        "s" === n && (y = t, t = e, e = y);
                    }
                    b = !0, _[++k] = [], I[k] = {
                        width: Number(t) || u,
                        height: Number(e) || v
                    }, A[k] = {}, J(k);
                }).apply(this, arguments), it(N(p * w) + " w"), it(d), 0 !== F && it(F + " J"), 0 !== P && it(P + " j"), rt.publish("addPage", {
                    pageNumber: k
                });
            }, J = function(t) {
                0 < t && t <= k && (u = I[o = t].width, v = I[t].height);
            }, at = function(t, e, n) {
                var r, i = void 0;
                return n = n || {}, t = void 0 !== t ? t : nt[K].fontName, e = void 0 !== e ? e : nt[K].fontStyle, r = t.toLowerCase(), void 0 !== S[r] && void 0 !== S[r][e] ? i = S[r][e] : void 0 !== S[t] && void 0 !== S[t][e] ? i = S[t][e] : !1 === n.disableWarning && console.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = S.times[e]) && (i = S.times.normal), i;
            }, st = function() {
                b = !1, m = 2, E = 0, C = [], x = [], T = [], rt.publish("buildDocument"), it("%PDF-" + gt), it("%\xba\xdf\xac\xe0"), function() {
                    var t, e, n, r, i, o, a, s, h, c = [];
                    for(a = pt.adler32cs || yt.API.adler32cs, f && void 0 === a && (f = !1), t = 1; t <= k; t++){
                        if (c.push(L()), s = (u = I[t].width) * w, h = (v = I[t].height) * w, it("<</Type /Page"), it("/Parent 1 0 R"), it("/Resources 2 0 R"), it("/MediaBox [0 0 " + N(s) + " " + N(h) + "]"), rt.publish("putPage", {
                            pageNumber: t,
                            page: _[t]
                        }), it("/Contents " + (m + 1) + " 0 R"), it(">>"), it("endobj"), e = _[t].join("\n"), L(), f) {
                            for(n = [], r = e.length; r--;)n[r] = e.charCodeAt(r);
                            o = a.from(e), (i = new Deflater(6)).append(new Uint8Array(n)), e = i.flush(), (n = new Uint8Array(e.length + 6)).set(new Uint8Array([
                                120,
                                156
                            ])), n.set(e, 2), n.set(new Uint8Array([
                                255 & o,
                                o >> 8 & 255,
                                o >> 16 & 255,
                                o >> 24 & 255
                            ]), e.length + 2), e = String.fromCharCode.apply(null, n), it("<</Length " + e.length + " /Filter [/FlateDecode]>>");
                        } else it("<</Length " + e.length + ">>");
                        H(e), it("endobj");
                    }
                    x[1] = E, it("1 0 obj"), it("<</Type /Pages");
                    var l = "/Kids [";
                    for(r = 0; r < k; r++)l += c[r] + " 0 R ";
                    it(l + "]"), it("/Count " + k), it(">>"), it("endobj"), rt.publish("postPutPages");
                }(), function() {
                    rt.publish("putAdditionalObjects");
                    for(var t = 0; t < T.length; t++){
                        var e = T[t];
                        x[e.objId] = E, it(e.objId + " 0 obj"), it(e.content), it("endobj");
                    }
                    m += T.length, rt.publish("postPutAdditionalObjects");
                }(), G(), L(), it("<<"), function() {
                    for(var t in it("/Producer (jsPDF " + yt.version + ")"), q)q.hasOwnProperty(t) && q[t] && it("/" + t.substr(0, 1).toUpperCase() + t.substr(1) + " (" + ot(q[t]) + ")");
                    it("/CreationDate (" + c + ")");
                }(), it(">>"), it("endobj"), L(), it("<<"), function() {
                    switch(it("/Type /Catalog"), it("/Pages 1 0 R"), s || (s = "fullwidth"), s){
                        case "fullwidth":
                            it("/OpenAction [3 0 R /FitH null]");
                            break;
                        case "fullheight":
                            it("/OpenAction [3 0 R /FitV null]");
                            break;
                        case "fullpage":
                            it("/OpenAction [3 0 R /Fit]");
                            break;
                        case "original":
                            it("/OpenAction [3 0 R /XYZ null null 1]");
                            break;
                        default:
                            var t = "" + s;
                            "%" === t.substr(t.length - 1) && (s = parseInt(s) / 100), "number" == typeof s && it("/OpenAction [3 0 R /XYZ null null " + N(s) + "]");
                    }
                    switch(h || (h = "continuous"), h){
                        case "continuous":
                            it("/PageLayout /OneColumn");
                            break;
                        case "single":
                            it("/PageLayout /SinglePage");
                            break;
                        case "two":
                        case "twoleft":
                            it("/PageLayout /TwoColumnLeft");
                            break;
                        case "tworight":
                            it("/PageLayout /TwoColumnRight");
                    }
                    a && it("/PageMode /" + a), rt.publish("putCatalog");
                }(), it(">>"), it("endobj");
                var t, e = E, n = "0000000000";
                for(it("xref"), it("0 " + (m + 1)), it(n + " 65535 f "), t = 1; t <= m; t++){
                    var r = x[t];
                    it("function" == typeof r ? (n + x[t]()).slice(-10) + " 00000 n " : (n + x[t]).slice(-10) + " 00000 n ");
                }
                return it("trailer"), it("<<"), it("/Size " + (m + 1)), it("/Root " + m + " 0 R"), it("/Info " + (m - 1) + " 0 R"), it("/ID [ <" + g + "> <" + g + "> ]"), it(">>"), it("startxref"), it("" + e), it("%%EOF"), b = !0, C.join("\n");
            }, ht = function(t) {
                var e = "S";
                return "F" === t ? e = "f" : "FD" === t || "DF" === t ? e = "B" : "f" !== t && "f*" !== t && "B" !== t && "B*" !== t || (e = t), e;
            }, ct = function() {
                for(var t = st(), e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
                return n;
            }, lt = function() {
                return new Blob([
                    ct()
                ], {
                    type: "application/pdf"
                });
            }, ut = ((l = function(t, e) {
                var n = "dataur" === ("" + t).substr(0, 6) ? "data:application/pdf;base64," + btoa(st()) : 0;
                switch(t){
                    case void 0:
                        return st();
                    case "save":
                        if ("object" === ("undefined" == typeof navigator ? "undefined" : vt(navigator)) && navigator.getUserMedia && (void 0 === pt.URL || void 0 === pt.URL.createObjectURL)) return O.output("dataurlnewwindow");
                        bt(lt(), e), "function" == typeof bt.unload && pt.setTimeout && setTimeout(bt.unload, 911);
                        break;
                    case "arraybuffer":
                        return ct();
                    case "blob":
                        return lt();
                    case "bloburi":
                    case "bloburl":
                        return pt.URL && pt.URL.createObjectURL(lt()) || void 0;
                    case "datauristring":
                    case "dataurlstring":
                        return n;
                    case "dataurlnewwindow":
                        var r = pt.open(n);
                        if (r || "undefined" == typeof safari) return r;
                    case "datauri":
                    case "dataurl":
                        return pt.document.location.href = n;
                    default:
                        throw new Error('Output type "' + t + '" is not supported.');
                }
            }).foo = function() {
                try {
                    return l.apply(this, arguments);
                } catch (t) {
                    var e = t.stack || "";
                    ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                    var n = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                    if (!pt.console) throw new Error(n);
                    pt.console.error(n, t), pt.alert && alert(n);
                }
            }, (l.foo.bar = l).foo), ft = function(t) {
                return !0 === Array.isArray(B) && -1 < B.indexOf(t);
            };
            switch(e){
                case "pt":
                    w = 1;
                    break;
                case "mm":
                    w = 72 / 25.4;
                    break;
                case "cm":
                    w = 72 / 2.54;
                    break;
                case "in":
                    w = 72;
                    break;
                case "px":
                    w = 1 == ft("px_scaling") ? .75 : 96 / 72;
                    break;
                case "pc":
                case "em":
                    w = 12;
                    break;
                case "ex":
                    w = 6;
                    break;
                default:
                    throw "Invalid unit: " + e;
            }
            for(var dt in D(), U(), O.internal = {
                pdfEscape: ot,
                getStyle: ht,
                getFont: function() {
                    return nt[at.apply(O, arguments)];
                },
                getFontSize: function() {
                    return Z;
                },
                getCharSpace: function() {
                    return $;
                },
                getTextColor: function() {
                    var t = Q.split(" ");
                    if (2 === t.length && "g" === t[1]) {
                        var e = parseFloat(t[0]);
                        t = [
                            e,
                            e,
                            e,
                            "r"
                        ];
                    }
                    for(var n = "#", r = 0; r < 3; r++)n += ("0" + Math.floor(255 * parseFloat(t[r])).toString(16)).slice(-2);
                    return n;
                },
                getLineHeight: function() {
                    return Z * et;
                },
                write: function(t) {
                    it(1 === arguments.length ? t : Array.prototype.join.call(arguments, " "));
                },
                getCoordinateString: function(t) {
                    return N(t * w);
                },
                getVerticalCoordinateString: function(t) {
                    return N((v - t) * w);
                },
                collections: {},
                newObject: L,
                newAdditionalObject: function() {
                    var t = 2 * _.length + 1, e = {
                        objId: t += T.length,
                        content: ""
                    };
                    return T.push(e), e;
                },
                newObjectDeferred: function() {
                    return x[++m] = function() {
                        return E;
                    }, m;
                },
                newObjectDeferredBegin: function(t) {
                    x[t] = E;
                },
                putStream: H,
                events: rt,
                scaleFactor: w,
                pageSize: {
                    getWidth: function() {
                        return u;
                    },
                    getHeight: function() {
                        return v;
                    }
                },
                output: function(t, e) {
                    return ut(t, e);
                },
                getNumberOfPages: function() {
                    return _.length - 1;
                },
                pages: _,
                out: it,
                f2: N,
                getPageInfo: function(t) {
                    return {
                        objId: 2 * (t - 1) + 3,
                        pageNumber: t,
                        pageContext: A[t]
                    };
                },
                getCurrentPageInfo: function() {
                    return {
                        objId: 2 * (o - 1) + 3,
                        pageNumber: o,
                        pageContext: A[o]
                    };
                },
                getPDFVersion: function() {
                    return gt;
                },
                hasHotfix: ft
            }, O.addPage = function() {
                return X.apply(this, arguments), this;
            }, O.setPage = function() {
                return J.apply(this, arguments), this;
            }, O.insertPage = function(t) {
                return this.addPage(), this.movePage(o, t), this;
            }, O.movePage = function(t, e) {
                if (e < t) {
                    for(var n = _[t], r = I[t], i = A[t], o = t; e < o; o--)_[o] = _[o - 1], I[o] = I[o - 1], A[o] = A[o - 1];
                    _[e] = n, I[e] = r, A[e] = i, this.setPage(e);
                } else if (t < e) {
                    for(n = _[t], r = I[t], i = A[t], o = t; o < e; o++)_[o] = _[o + 1], I[o] = I[o + 1], A[o] = A[o + 1];
                    _[e] = n, I[e] = r, A[e] = i, this.setPage(e);
                }
                return this;
            }, O.deletePage = function() {
                return (function(t) {
                    0 < t && t <= k && (_.splice(t, 1), I.splice(t, 1), --k < o && (o = k), this.setPage(o));
                }).apply(this, arguments), this;
            }, O.setCreationDate = function(t) {
                return D(t), this;
            }, O.getCreationDate = function(t) {
                return M(t);
            }, O.setFileId = function(t) {
                return U(t), this;
            }, O.getFileId = function() {
                return g;
            }, O.setDisplayMode = function(t, e, n) {
                if (s = t, h = e, -1 == [
                    void 0,
                    null,
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "FullScreen"
                ].indexOf(a = n)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + n + '" is not recognized.');
                return this;
            }, O.text = function(t, e, n, i) {
                var r, o, a = "", s = et, h = this;
                function c(t) {
                    for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : "[object Array]" === Object.prototype.toString.call(t) && 1 === e.length ? r.push(e[0]) : r.push([
                        e[0],
                        e[1],
                        e[2]
                    ]);
                    return r;
                }
                function l(t, e) {
                    var n;
                    if ("string" == typeof t) n = e(t)[0];
                    else if ("[object Array]" === Object.prototype.toString.call(t)) {
                        for(var r, i, o = t.concat(), a = [], s = o.length; s--;)"string" == typeof (r = o.shift()) ? a.push(e(r)[0]) : "[object Array]" === Object.prototype.toString.call(r) && "string" === r[0] && (i = e(r[0], r[1], r[2]), a.push([
                            i[0],
                            i[1],
                            i[2]
                        ]));
                        n = a;
                    }
                    return n;
                }
                "number" == typeof t && (o = n, n = e, e = t, t = o);
                var u = i, f = arguments[4], d = arguments[5];
                "object" === (void 0 === u ? "undefined" : vt(u)) && null !== u || ("string" == typeof f && (d = f, f = null), "string" == typeof u && (d = u, u = null), "number" == typeof u && (f = u, u = null), i = {
                    flags: u,
                    angle: f,
                    align: d
                });
                var p = !1, g = !0;
                if ("string" == typeof t) p = !0;
                else if ("[object Array]" === Object.prototype.toString.call(t)) {
                    for(var m, w = t.concat(), y = [], v = w.length; v--;)("string" != typeof (m = w.shift()) || "[object Array]" === Object.prototype.toString.call(m) && "string" != typeof m[0]) && (g = !1);
                    p = g;
                }
                if (!1 === p) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
                var b = nt[K].encoding;
                "WinAnsiEncoding" !== b && "StandardEncoding" !== b || (t = l(t, function(t, e, n) {
                    var r;
                    return [
                        (r = t, r = r.split("\t").join(Array(i.TabLen || 9).join(" ")), ot(r, u)),
                        e,
                        n
                    ];
                })), "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [
                    t
                ]), 0 < (j = i.maxWidth || 0) && ("string" == typeof t ? t = h.splitTextToSize(t, j) : "[object Array]" === Object.prototype.toString.call(t) && (t = h.splitTextToSize(t.join(" "), j)));
                var x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("preProcessText", x), t = x.text;
                f = (i = x.options).angle;
                var S = h.internal.scaleFactor, k = (h.internal.pageSize.getHeight(), []);
                if (f) {
                    f *= Math.PI / 180;
                    var _ = Math.cos(f), A = Math.sin(f), I = function(t) {
                        return t.toFixed(2);
                    };
                    k = [
                        I(_),
                        I(A),
                        I(-1 * A),
                        I(_)
                    ];
                }
                void 0 !== (R = i.charSpace) && (a += R + " Tc\n");
                i.lang;
                var C = -1, T = i.renderingMode || i.stroke, F = h.internal.getCurrentPageInfo().pageContext;
                switch(T){
                    case 0:
                    case !1:
                    case "fill":
                        C = 0;
                        break;
                    case 1:
                    case !0:
                    case "stroke":
                        C = 1;
                        break;
                    case 2:
                    case "fillThenStroke":
                        C = 2;
                        break;
                    case 3:
                    case "invisible":
                        C = 3;
                        break;
                    case 4:
                    case "fillAndAddForClipping":
                        C = 4;
                        break;
                    case 5:
                    case "strokeAndAddPathForClipping":
                        C = 5;
                        break;
                    case 6:
                    case "fillThenStrokeAndAddToPathForClipping":
                        C = 6;
                        break;
                    case 7:
                    case "addToPathForClipping":
                        C = 7;
                }
                var P = F.usedRenderingMode || -1;
                -1 !== C ? a += C + " Tr\n" : -1 !== P && (a += "0 Tr\n"), -1 !== C && (F.usedRenderingMode = C);
                d = i.align || "left";
                var E = Z * s, q = h.internal.pageSize.getHeight(), O = h.internal.pageSize.getWidth(), B = (S = h.internal.scaleFactor, nt[K]), R = i.charSpace || $, j = i.maxWidth || 0, D = (u = {}, []);
                if ("[object Array]" === Object.prototype.toString.call(t)) {
                    var M, U;
                    y = c(t);
                    "left" !== d && (U = y.map(function(t) {
                        return h.getStringUnitWidth(t, {
                            font: B,
                            charSpace: R,
                            fontSize: Z
                        }) * Z / S;
                    }));
                    var N, z = Math.max.apply(Math, U), L = 0;
                    if ("right" === d) {
                        e -= U[0], t = [];
                        var H = 0;
                        for(v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("center" === d) {
                        e -= U[0] / 2, t = [];
                        for(H = 0, v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) / 2 * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("left" === d) {
                        t = [];
                        for(H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, t.push(y[H]);
                    } else {
                        if ("justify" !== d) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                        t = [];
                        for(j = 0 !== j ? j : O, H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, H < v - 1 && D.push(((j - U[H]) / (y[H].split(" ").length - 1) * S).toFixed(2)), t.push([
                            y[H],
                            N,
                            M
                        ]);
                    }
                }
                !0 === ("boolean" == typeof i.R2L ? i.R2L : tt) && (t = l(t, function(t, e, n) {
                    return [
                        t.split("").reverse().join(""),
                        e,
                        n
                    ];
                }));
                x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("postProcessText", x), t = x.text, r = x.mutex.isHex;
                y = c(t);
                t = [];
                var W, G, V, Y = 0, X = (v = y.length, "");
                for(H = 0; H < v; H++)X = "", "[object Array]" !== Object.prototype.toString.call(y[H]) ? (W = parseFloat(e * S).toFixed(2), G = parseFloat((q - n) * S).toFixed(2), V = (r ? "<" : "(") + y[H] + (r ? ">" : ")")) : "[object Array]" === Object.prototype.toString.call(y[H]) && (W = parseFloat(y[H][1]).toFixed(2), G = parseFloat(y[H][2]).toFixed(2), V = (r ? "<" : "(") + y[H][0] + (r ? ">" : ")"), Y = 1), void 0 !== D && void 0 !== D[H] && (X = D[H] + " Tw\n"), 0 !== k.length && 0 === H ? t.push(X + k.join(" ") + " " + W + " " + G + " Tm\n" + V) : 1 === Y || 0 === Y && 0 === H ? t.push(X + W + " " + G + " Td\n" + V) : t.push(X + V);
                t = 0 === Y ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
                var J = "BT\n/" + K + " " + Z + " Tf\n" + (Z * s).toFixed(2) + " TL\n" + Q + "\n";
                return J += a, J += t, it(J += "ET"), h;
            }, O.lstext = function(t, e, n, r) {
                console.warn("jsPDF.lstext is deprecated");
                for(var i = 0, o = t.length; i < o; i++, e += r)this.text(t[i], e, n);
                return this;
            }, O.line = function(t, e, n, r) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ]
                ], t, e);
            }, O.clip = function() {
                it("W"), it("S");
            }, O.clip_fixed = function(t) {
                it("evenodd" === t ? "W*" : "W"), it("n");
            }, O.lines = function(t, e, n, r, i, o) {
                var a, s, h, c, l, u, f, d, p, g, m;
                for("number" == typeof t && (y = n, n = e, e = t, t = y), r = r || [
                    1,
                    1
                ], it(z(e * w) + " " + z((v - n) * w) + " m "), a = r[0], s = r[1], c = t.length, g = e, m = n, h = 0; h < c; h++)2 === (l = t[h]).length ? (g = l[0] * a + g, m = l[1] * s + m, it(z(g * w) + " " + z((v - m) * w) + " l")) : (u = l[0] * a + g, f = l[1] * s + m, d = l[2] * a + g, p = l[3] * s + m, g = l[4] * a + g, m = l[5] * s + m, it(z(u * w) + " " + z((v - f) * w) + " " + z(d * w) + " " + z((v - p) * w) + " " + z(g * w) + " " + z((v - m) * w) + " c"));
                return o && it(" h"), null !== i && it(ht(i)), this;
            }, O.rect = function(t, e, n, r, i) {
                ht(i);
                return it([
                    N(t * w),
                    N((v - e) * w),
                    N(n * w),
                    N(-r * w),
                    "re"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.triangle = function(t, e, n, r, i, o, a) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ],
                    [
                        i - n,
                        o - r
                    ],
                    [
                        t - i,
                        e - o
                    ]
                ], t, e, [
                    1,
                    1
                ], a, !0), this;
            }, O.roundedRect = function(t, e, n, r, i, o, a) {
                var s = 4 / 3 * (Math.SQRT2 - 1);
                return this.lines([
                    [
                        n - 2 * i,
                        0
                    ],
                    [
                        i * s,
                        0,
                        i,
                        o - o * s,
                        i,
                        o
                    ],
                    [
                        0,
                        r - 2 * o
                    ],
                    [
                        0,
                        o * s,
                        -i * s,
                        o,
                        -i,
                        o
                    ],
                    [
                        2 * i - n,
                        0
                    ],
                    [
                        -i * s,
                        0,
                        -i,
                        -o * s,
                        -i,
                        -o
                    ],
                    [
                        0,
                        2 * o - r
                    ],
                    [
                        0,
                        -o * s,
                        i * s,
                        -o,
                        i,
                        -o
                    ]
                ], t + i, e, [
                    1,
                    1
                ], a), this;
            }, O.ellipse = function(t, e, n, r, i) {
                var o = 4 / 3 * (Math.SQRT2 - 1) * n, a = 4 / 3 * (Math.SQRT2 - 1) * r;
                return it([
                    N((t + n) * w),
                    N((v - e) * w),
                    "m",
                    N((t + n) * w),
                    N((v - (e - a)) * w),
                    N((t + o) * w),
                    N((v - (e - r)) * w),
                    N(t * w),
                    N((v - (e - r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t - o) * w),
                    N((v - (e - r)) * w),
                    N((t - n) * w),
                    N((v - (e - a)) * w),
                    N((t - n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), it([
                    N((t - n) * w),
                    N((v - (e + a)) * w),
                    N((t - o) * w),
                    N((v - (e + r)) * w),
                    N(t * w),
                    N((v - (e + r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t + o) * w),
                    N((v - (e + r)) * w),
                    N((t + n) * w),
                    N((v - (e + a)) * w),
                    N((t + n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.circle = function(t, e, n, r) {
                return this.ellipse(t, e, n, n, r);
            }, O.setProperties = function(t) {
                for(var e in q)q.hasOwnProperty(e) && t[e] && (q[e] = t[e]);
                return this;
            }, O.setFontSize = function(t) {
                return Z = t, this;
            }, O.setFont = function(t, e) {
                return K = at(t, e), this;
            }, O.setFontStyle = O.setFontType = function(t) {
                return K = at(void 0, t), this;
            }, O.getFontList = function() {
                var t, e, n, r = {};
                for(t in S)if (S.hasOwnProperty(t)) for(e in r[t] = n = [], S[t])S[t].hasOwnProperty(e) && n.push(e);
                return r;
            }, O.addFont = function(t, e, n, r) {
                Y(t, e, n, r = r || "Identity-H");
            }, O.setLineWidth = function(t) {
                return it((t * w).toFixed(2) + " w"), this;
            }, O.setDrawColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "draw",
                    precision: 2
                })), this;
            }, O.setFillColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "fill",
                    precision: 2
                })), this;
            }, O.setTextColor = function(t, e, n, r) {
                return Q = R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "text",
                    precision: 3
                }), this;
            }, O.setCharSpace = function(t) {
                return $ = t, this;
            }, O.setR2L = function(t) {
                return tt = t, this;
            }, O.CapJoinStyles = {
                0: 0,
                butt: 0,
                but: 0,
                miter: 0,
                1: 1,
                round: 1,
                rounded: 1,
                circle: 1,
                2: 2,
                projecting: 2,
                project: 2,
                square: 2,
                bevel: 2
            }, O.setLineCap = function(t) {
                var e = this.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((F = e) + " J"), this;
            }, O.setLineJoin = function(t) {
                var e = this.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((P = e) + " j"), this;
            }, O.output = ut, O.save = function(t) {
                O.output("save", t);
            }, yt.API)yt.API.hasOwnProperty(dt) && ("events" === dt && yt.API.events.length ? function(t, e) {
                var n, r, i;
                for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
                    n
                ].concat("function" == typeof r ? [
                    r
                ] : r));
            }(rt, yt.API.events) : O[dt] = yt.API[dt]);
            return function() {
                for(var t = "helvetica", e = "times", n = "courier", r = "normal", i = "bold", o = "italic", a = "bolditalic", s = [
                    [
                        "Helvetica",
                        t,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Bold",
                        t,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Oblique",
                        t,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-BoldOblique",
                        t,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier",
                        n,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Bold",
                        n,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Oblique",
                        n,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-BoldOblique",
                        n,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Roman",
                        e,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Bold",
                        e,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Italic",
                        e,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-BoldItalic",
                        e,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "ZapfDingbats",
                        "zapfdingbats",
                        r,
                        null
                    ],
                    [
                        "Symbol",
                        "symbol",
                        r,
                        null
                    ]
                ], h = 0, c = s.length; h < c; h++){
                    var l = Y(s[h][0], s[h][1], s[h][2], s[h][3]), u = s[h][0].split("-");
                    V(l, u[0], u[1] || "");
                }
                rt.publish("addFonts", {
                    fonts: nt,
                    dictionary: S
                });
            }(), K = "F1", X(n, t), rt.publish("initialized"), O;
        }
        return yt.API = {
            events: []
        }, yt.version = "0.0.0", "function" == typeof define && define.amd ? define("jsPDF", function() {
            return yt;
        }) : (0, module.exports) ? (module.exports = yt, module.exports.jsPDF = yt) : pt.jsPDF = yt, yt;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")());
    /** @preserve
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.4.1 Built on 2018-06-06T07:49:34.040Z
   *                           CommitID 3233f44044
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */ /**
   * jsPDF AcroForm Plugin Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ !function(n, t) {
        var l, a, e = 1, r = function(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
        }, s = function(t) {
            return t * (e / 1);
        }, h = function(t) {
            var e = new I, n = N.internal.getHeight(t) || 0, r = N.internal.getWidth(t) || 0;
            return e.BBox = [
                0,
                0,
                r.toFixed(2),
                n.toFixed(2)
            ], e;
        }, i = function(t, e, n) {
            t = t || 0;
            var r = 1;
            if (r <<= e - 1, 1 == (n = n || 1)) t = t | r;
            else t = t & ~r;
            return t;
        }, o = function(t, e, n) {
            n = n || 1.3, t = t || 0;
            return 1 == e.readOnly && (t = i(t, 1)), 1 == e.required && (t = i(t, 2)), 1 == e.noExport && (t = i(t, 3)), 1 == e.multiline && (t = i(t, 13)), e.password && (t = i(t, 14)), e.noToggleToOff && (t = i(t, 15)), e.radio && (t = i(t, 16)), e.pushbutton && (t = i(t, 17)), e.combo && (t = i(t, 18)), e.edit && (t = i(t, 19)), e.sort && (t = i(t, 20)), e.fileSelect && 1.4 <= n && (t = i(t, 21)), e.multiSelect && 1.4 <= n && (t = i(t, 22)), e.doNotSpellCheck && 1.4 <= n && (t = i(t, 23)), 1 == e.doNotScroll && 1.4 <= n && (t = i(t, 24)), e.richText && 1.4 <= n && (t = i(t, 25)), t;
        }, u = function(t) {
            var e = t[0], n = t[1], r = t[2], i = t[3], o = {};
            return Array.isArray(e) ? (e[0] = s(e[0]), e[1] = s(e[1]), e[2] = s(e[2]), e[3] = s(e[3])) : (e = s(e), n = s(n), r = s(r), i = s(i)), o.lowerLeft_X = e || 0, o.lowerLeft_Y = s(a) - n - i || 0, o.upperRight_X = e + r || 0, o.upperRight_Y = s(a) - n || 0, [
                o.lowerLeft_X.toFixed(2),
                o.lowerLeft_Y.toFixed(2),
                o.upperRight_X.toFixed(2),
                o.upperRight_Y.toFixed(2)
            ];
        }, f = function(t) {
            if (t.appearanceStreamContent) return t.appearanceStreamContent;
            if (t.V || t.DV) {
                var e = [], n = t.V || t.DV, r = c(t, n);
                e.push("/Tx BMC"), e.push("q"), e.push("/F1 " + r.fontSize.toFixed(2) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push("BT"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
                var i = new h(t);
                return i.stream = e.join("\n"), i;
            }
        }, c = function(t, e, i, n) {
            n = n || 12, i = i || "helvetica";
            var r = {
                text: "",
                fontSize: ""
            }, o = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" "), a = n, s = N.internal.getHeight(t) || 0;
            s = s < 0 ? -s : s;
            var h = N.internal.getWidth(t) || 0;
            h = h < 0 ? -h : h;
            var c = function(t, e, n) {
                if (t + 1 < o.length) {
                    var r = e + " " + o[t + 1];
                    return A(r, n + "px", i).width <= h - 4;
                }
                return !1;
            };
            a++;
            t: for(;;){
                e = "";
                var l = A("3", --a + "px", i).height, u = t.multiline ? s - a : (s - l) / 2, f = -2, d = u += 2, p = 0, g = 0, m = 0;
                if (a <= 0) {
                    a = 12, e = "(...) Tj\n", e += "% Width of Text: " + A(e, "1px").width + ", FieldWidth:" + h + "\n";
                    break;
                }
                m = A(o[0] + " ", a + "px", i).width;
                var w = "", y = 0;
                for(var v in o){
                    w = " " == (w += o[v] + " ").substr(w.length - 1) ? w.substr(0, w.length - 1) : w;
                    var b = parseInt(v);
                    m = A(w + " ", a + "px", i).width;
                    var x = c(b, w, a), S = v >= o.length - 1;
                    if (!x || S) {
                        if (x || S) {
                            if (S) g = b;
                            else if (t.multiline && s < (l + 2) * (y + 2) + 2) continue t;
                        } else {
                            if (!t.multiline) continue t;
                            if (s < (l + 2) * (y + 2) + 2) continue t;
                            g = b;
                        }
                        for(var k = "", _ = p; _ <= g; _++)k += o[_] + " ";
                        switch(k = " " == k.substr(k.length - 1) ? k.substr(0, k.length - 1) : k, m = A(k, a + "px", i).width, t.Q){
                            case 2:
                                f = h - m - 2;
                                break;
                            case 1:
                                f = (h - m) / 2;
                                break;
                            case 0:
                            default:
                                f = 2;
                        }
                        e += f.toFixed(2) + " " + d.toFixed(2) + " Td\n", e += "(" + k + ") Tj\n", e += -f.toFixed(2) + " 0 Td\n", d = -(a + 2), m = 0, p = g + 1, y++, w = "";
                    } else w += " ";
                }
                break;
            }
            return r.text = e, r.fontSize = a, r;
        }, A = function(t, e, n) {
            n = n || "helvetica";
            var r = l.internal.getFont(n), i = l.getStringUnitWidth(t, {
                font: r,
                fontSize: parseFloat(e),
                charSpace: 0
            }) * parseFloat(e);
            return {
                height: l.getStringUnitWidth("3", {
                    font: r,
                    fontSize: parseFloat(e),
                    charSpace: 0
                }) * parseFloat(e) * 1.5,
                width: i
            };
        }, d = {
            fields: [],
            xForms: [],
            acroFormDictionaryRoot: null,
            printedOut: !1,
            internal: null,
            isInitialized: !1
        }, p = function() {
            for(var t in l.internal.acroformPlugin.acroFormDictionaryRoot.Fields){
                var e = l.internal.acroformPlugin.acroFormDictionaryRoot.Fields[t];
                e.hasAnnotation && m.call(l, e);
            }
        }, g = function(t) {
            l.internal.acroformPlugin.printedOut && (l.internal.acroformPlugin.printedOut = !1, l.internal.acroformPlugin.acroFormDictionaryRoot = null), l.internal.acroformPlugin.acroFormDictionaryRoot || x.call(l), l.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t);
        }, m = function(t) {
            var e = {
                type: "reference",
                object: t
            };
            l.annotationPlugin.annotations[l.internal.getPageInfo(t.page).pageNumber].push(e);
        }, w = function() {
            void 0 !== l.internal.acroformPlugin.acroFormDictionaryRoot ? l.internal.write("/AcroForm " + l.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R") : console.log("Root missing...");
        }, y = function() {
            l.internal.events.unsubscribe(l.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete l.internal.acroformPlugin.acroFormDictionaryRoot._eventID, l.internal.acroformPlugin.printedOut = !0;
        }, v = function(t) {
            var e = !t;
            t || (l.internal.newObjectDeferredBegin(l.internal.acroformPlugin.acroFormDictionaryRoot.objId), l.internal.out(l.internal.acroformPlugin.acroFormDictionaryRoot.getString()));
            t = t || l.internal.acroformPlugin.acroFormDictionaryRoot.Kids;
            for(var n in t){
                var r = t[n], i = r.Rect;
                r.Rect && (r.Rect = u.call(this, r.Rect)), l.internal.newObjectDeferredBegin(r.objId);
                var o = r.objId + " 0 obj\n<<\n";
                if ("object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getContent && (o += r.getContent()), r.Rect = i, r.hasAppearanceStream && !r.appearanceStreamContent) {
                    var a = f.call(this, r);
                    o += "/AP << /N " + a + " >>\n", l.internal.acroformPlugin.xForms.push(a);
                }
                if (r.appearanceStreamContent) {
                    for(var s in o += "/AP << ", r.appearanceStreamContent){
                        var h = r.appearanceStreamContent[s];
                        if (o += "/" + s + " ", o += "<< ", 1 <= Object.keys(h).length || Array.isArray(h)) for(var n in h){
                            var c;
                            "function" == typeof (c = h[n]) && (c = c.call(this, r)), o += "/" + n + " " + c + " ", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        }
                        else "function" == typeof (c = h) && (c = c.call(this, r)), o += "/" + n + " " + c + " \n", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        o += " >>\n";
                    }
                    o += ">>\n";
                }
                o += ">>\nendobj\n", l.internal.out(o);
            }
            e && b.call(this, l.internal.acroformPlugin.xForms);
        }, b = function(t) {
            for(var e in t){
                var n = e, r = t[e];
                l.internal.newObjectDeferredBegin(r && r.objId);
                var i = "";
                "object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getString && (i = r.getString()), l.internal.out(i), delete t[n];
            }
        }, x = function() {
            if (void 0 !== this.internal && (void 0 === this.internal.acroformPlugin || !1 === this.internal.acroformPlugin.isInitialized)) {
                if (l = this, T.FieldNum = 0, this.internal.acroformPlugin = JSON.parse(JSON.stringify(d)), this.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
                e = l.internal.scaleFactor, a = l.internal.pageSize.getHeight(), l.internal.acroformPlugin.acroFormDictionaryRoot = new C, l.internal.acroformPlugin.acroFormDictionaryRoot._eventID = l.internal.events.subscribe("postPutResources", y), l.internal.events.subscribe("buildDocument", p), l.internal.events.subscribe("putCatalog", w), l.internal.events.subscribe("postPutPages", v), l.internal.acroformPlugin.isInitialized = !0;
            }
        }, S = function(t) {
            if (Array.isArray(t)) {
                var e = " [";
                for(var n in t)e += t[n].toString(), e += n < t.length - 1 ? " " : "";
                return e += "]";
            }
        }, k = function(t) {
            return 0 !== (t = t || "").indexOf("(") && (t = "(" + t), ")" != t.substring(t.length - 1) && (t += ")"), t;
        }, _ = function() {
            var t;
            Object.defineProperty(this, "objId", {
                get: function() {
                    return t || (t = l.internal.newObjectDeferred()), t || console.log("Couldn't create Object ID"), t;
                },
                configurable: !1
            });
        };
        _.prototype.toString = function() {
            return this.objId + " 0 R";
        }, _.prototype.getString = function() {
            var t = this.objId + " 0 obj\n<<";
            return t += this.getContent() + ">>\n", this.stream && (t += "stream\n", t += this.stream, t += "\nendstream\n"), t += "endobj\n";
        }, _.prototype.getContent = function() {
            var t = "";
            return t += function(t) {
                var e = "", n = Object.keys(t).filter(function(t) {
                    return "content" != t && "appearanceStreamContent" != t && "_" != t.substring(0, 1);
                });
                for(var r in n){
                    var i = n[r], o = t[i];
                    o && (Array.isArray(o) ? e += "/" + i + " " + S(o) + "\n" : e += o instanceof _ ? "/" + i + " " + o.objId + " 0 R\n" : "/" + i + " " + o + "\n");
                }
                return e;
            }(this);
        };
        var I = function() {
            var e;
            _.call(this), this.Type = "/XObject", this.Subtype = "/Form", this.FormType = 1, this.BBox, this.Matrix, this.Resources = "2 0 R", this.PieceInfo, Object.defineProperty(this, "Length", {
                enumerable: !0,
                get: function() {
                    return void 0 !== e ? e.length : 0;
                }
            }), Object.defineProperty(this, "stream", {
                enumerable: !1,
                set: function(t) {
                    e = t.trim();
                },
                get: function() {
                    return e || null;
                }
            });
        };
        r(I, _);
        var C = function() {
            _.call(this);
            var t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return 0 < t.length ? t : void 0;
                }
            }), Object.defineProperty(this, "Fields", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return t;
                }
            }), this.DA;
        };
        r(C, _);
        var T = function t() {
            var e;
            _.call(this), Object.defineProperty(this, "Rect", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    if (e) return e;
                },
                set: function(t) {
                    e = t;
                }
            });
            var n, r, i, o, a = "";
            Object.defineProperty(this, "FT", {
                enumerable: !0,
                set: function(t) {
                    a = t;
                },
                get: function() {
                    return a;
                }
            }), Object.defineProperty(this, "T", {
                enumerable: !0,
                configurable: !1,
                set: function(t) {
                    n = t;
                },
                get: function() {
                    if (!n || n.length < 1) {
                        if (this instanceof j) return;
                        return "(FieldObject" + t.FieldNum++ + ")";
                    }
                    return "(" == n.substring(0, 1) && n.substring(n.length - 1) ? n : "(" + n + ")";
                }
            }), Object.defineProperty(this, "DA", {
                enumerable: !0,
                get: function() {
                    if (r) return "(" + r + ")";
                },
                set: function(t) {
                    r = t;
                }
            }), Object.defineProperty(this, "DV", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    if (i) return i;
                },
                set: function(t) {
                    i = t;
                }
            }), Object.defineProperty(this, "V", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    if (o) return o;
                },
                set: function(t) {
                    o = t;
                }
            }), Object.defineProperty(this, "Type", {
                enumerable: !0,
                get: function() {
                    return this.hasAnnotation ? "/Annot" : null;
                }
            }), Object.defineProperty(this, "Subtype", {
                enumerable: !0,
                get: function() {
                    return this.hasAnnotation ? "/Widget" : null;
                }
            }), this.BG, Object.defineProperty(this, "hasAnnotation", {
                enumerable: !1,
                get: function() {
                    return !!(this.Rect || this.BC || this.BG);
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            }), Object.defineProperty(this, "page", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            });
        };
        r(T, _);
        var F = function() {
            T.call(this), this.FT = "/Ch", this.Opt = [], this.V = "()", this.TI = 0;
            var e = !1;
            Object.defineProperty(this, "combo", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "edit", {
                enumerable: !0,
                set: function(t) {
                    1 == t ? (this._edit = !0, this.combo = !0) : this._edit = !1;
                },
                get: function() {
                    return !!this._edit && this._edit;
                },
                configurable: !1
            }), this.hasAppearanceStream = !0;
        };
        r(F, T);
        var P = function() {
            F.call(this), this.combo = !1;
        };
        r(P, F);
        var E = function() {
            P.call(this), this.combo = !0;
        };
        r(E, P);
        var q = function() {
            E.call(this), this.edit = !0;
        };
        r(q, E);
        var O = function() {
            T.call(this), this.FT = "/Btn";
        };
        r(O, T);
        var B = function() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "pushbutton", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        r(B, O);
        var R = function() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "radio", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
            var n, t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !0,
                get: function() {
                    if (0 < t.length) return t;
                }
            }), Object.defineProperty(this, "__Kids", {
                get: function() {
                    return t;
                }
            }), Object.defineProperty(this, "noToggleToOff", {
                enumerable: !1,
                get: function() {
                    return n;
                },
                set: function(t) {
                    n = t;
                }
            });
        };
        r(R, O);
        var j = function(t, e) {
            T.call(this), this.Parent = t, this._AppearanceType = N.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(e), this.F = i(this.F, 3, 1), this.MK = this._AppearanceType.createMK(), this.AS = "/Off", this._Name = e;
        };
        r(j, T), R.prototype.setAppearance = function(t) {
            if ("createAppearanceStream" in t && "createMK" in t) for(var e in this.__Kids){
                var n = this.__Kids[e];
                n.appearanceStreamContent = t.createAppearanceStream(n._Name), n.MK = t.createMK();
            }
            else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
        }, R.prototype.createOption = function(t) {
            this.__Kids.length;
            var e = new j(this, t);
            return this.__Kids.push(e), n.addField(e), e;
        };
        var D = function() {
            O.call(this), this.appearanceStreamContent = N.CheckBox.createAppearanceStream(), this.MK = N.CheckBox.createMK(), this.AS = "/On", this.V = "/On";
        };
        r(D, O);
        var M = function() {
            var e, n;
            T.call(this), this.DA = N.createDefaultAppearanceStream(), this.F = 4, Object.defineProperty(this, "V", {
                get: function() {
                    return e ? k(e) : e;
                },
                enumerable: !0,
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "DV", {
                get: function() {
                    return n ? k(n) : n;
                },
                enumerable: !0,
                set: function(t) {
                    n = t;
                }
            });
            var r = !1;
            Object.defineProperty(this, "multiline", {
                enumerable: !1,
                get: function() {
                    return r;
                },
                set: function(t) {
                    r = t;
                }
            });
            var i = !1;
            Object.defineProperty(this, "fileSelect", {
                enumerable: !1,
                get: function() {
                    return i;
                },
                set: function(t) {
                    i = t;
                }
            });
            var o = !1;
            Object.defineProperty(this, "doNotSpellCheck", {
                enumerable: !1,
                get: function() {
                    return o;
                },
                set: function(t) {
                    o = t;
                }
            });
            var a = !1;
            Object.defineProperty(this, "doNotScroll", {
                enumerable: !1,
                get: function() {
                    return a;
                },
                set: function(t) {
                    a = t;
                }
            });
            var s = !1;
            Object.defineProperty(this, "MaxLen", {
                enumerable: !0,
                get: function() {
                    return s;
                },
                set: function(t) {
                    s = t;
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                get: function() {
                    return this.V || this.DV;
                }
            });
        };
        r(M, T);
        var U = function() {
            M.call(this);
            var e = !0;
            Object.defineProperty(this, "password", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        r(U, M);
        var N = {
            CheckBox: {
                createAppearanceStream: function() {
                    return {
                        N: {
                            On: N.CheckBox.YesNormal
                        },
                        D: {
                            On: N.CheckBox.YesPushDown,
                            Off: N.CheckBox.OffPushDown
                        }
                    };
                },
                createMK: function() {
                    return "<< /CA (3)>>";
                },
                YesPushDown: function(t) {
                    var e = h(t), n = [], r = l.internal.getFont("zapfdingbats", "normal").id;
                    t.Q = 1;
                    var i = c(t, "3", "ZapfDingbats", 50);
                    return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + i.fontSize.toFixed(2) + " Tf 0 g"), n.push("BT"), n.push(i.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
                },
                YesNormal: function(t) {
                    var e = h(t), n = l.internal.getFont("zapfdingbats", "normal").id, r = [];
                    t.Q = 1;
                    var i = N.internal.getHeight(t), o = N.internal.getWidth(t), a = c(t, "3", "ZapfDingbats", .9 * i);
                    return r.push("1 g"), r.push("0 0 " + o.toFixed(2) + " " + i.toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("0 0 1 rg"), r.push("0 0 " + (o - 1).toFixed(2) + " " + (i - 1).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push("0 g"), r.push("BT"), r.push("/" + n + " " + a.fontSize.toFixed(2) + " Tf 0 g"), r.push(a.text), r.push("ET"), r.push("Q"), e.stream = r.join("\n"), e;
                },
                OffPushDown: function(t) {
                    var e = h(t), n = [];
                    return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                }
            },
            RadioButton: {
                Circle: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Circle.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Circle.YesNormal, e.D[t] = N.RadioButton.Circle.YesPushDown, e;
                    },
                    createMK: function() {
                        return "<< /CA (l)>>";
                    },
                    YesNormal: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4;
                        r *= .9;
                        var i = N.internal.Bezier_C;
                        return n.push("q"), n.push("1 0 0 1 " + N.internal.getWidth(t) / 2 + " " + N.internal.getHeight(t) / 2 + " cm"), n.push(r + " 0 m"), n.push(r + " " + r * i + " " + r * i + " " + r + " 0 " + r + " c"), n.push("-" + r * i + " " + r + " -" + r + " " + r * i + " -" + r + " 0 c"), n.push("-" + r + " -" + r * i + " -" + r * i + " -" + r + " 0 -" + r + " c"), n.push(r * i + " -" + r + " " + r + " -" + r * i + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C, a = r * N.internal.Bezier_C;
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C;
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    }
                },
                Cross: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Cross.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Cross.YesNormal, e.D[t] = N.RadioButton.Cross.YesPushDown, e;
                    },
                    createMK: function() {
                        return "<< /CA (8)>>";
                    },
                    YesNormal: function(t) {
                        var e = h(t), n = [], r = N.internal.calculateCross(t);
                        return n.push("q"), n.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), n.push("W"), n.push("n"), n.push(r.x1.x.toFixed(2) + " " + r.x1.y.toFixed(2) + " m"), n.push(r.x2.x.toFixed(2) + " " + r.x2.y.toFixed(2) + " l"), n.push(r.x4.x.toFixed(2) + " " + r.x4.y.toFixed(2) + " m"), n.push(r.x3.x.toFixed(2) + " " + r.x3.y.toFixed(2) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = h(t), n = N.internal.calculateCross(t), r = [];
                        return r.push("0.749023 g"), r.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push(n.x1.x.toFixed(2) + " " + n.x1.y.toFixed(2) + " m"), r.push(n.x2.x.toFixed(2) + " " + n.x2.y.toFixed(2) + " l"), r.push(n.x4.x.toFixed(2) + " " + n.x4.y.toFixed(2) + " m"), r.push(n.x3.x.toFixed(2) + " " + n.x3.y.toFixed(2) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = h(t), n = [];
                        return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                    }
                }
            },
            createDefaultAppearanceStream: function(t) {
                return "/F1 0 Tf 0 g";
            }
        };
        N.internal = {
            Bezier_C: .551915024494,
            calculateCross: function(t) {
                var e, n, r = N.internal.getWidth(t), i = N.internal.getHeight(t), o = (n = i) < (e = r) ? n : e;
                return {
                    x1: {
                        x: (r - o) / 2,
                        y: (i - o) / 2 + o
                    },
                    x2: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2
                    },
                    x3: {
                        x: (r - o) / 2,
                        y: (i - o) / 2
                    },
                    x4: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2 + o
                    }
                };
            }
        }, N.internal.getWidth = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[2])), e;
        }, N.internal.getHeight = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[3])), e;
        }, n.addField = function(t) {
            return x.call(this), t instanceof M ? this.addTextField.call(this, t) : t instanceof F ? this.addChoiceField.call(this, t) : t instanceof O ? this.addButton.call(this, t) : t instanceof j ? g.call(this, t) : t && g.call(this, t), t.page = l.internal.getCurrentPageInfo().pageNumber, this;
        }, n.addButton = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Btn", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addTextField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Tx", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addChoiceField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Ch", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, "object" == (void 0 === t ? "undefined" : vt(t)) && (t.ChoiceField = F, t.ListBox = P, t.ComboBox = E, t.EditBox = q, t.Button = O, t.PushButton = B, t.RadioButton = R, t.CheckBox = D, t.TextField = M, t.PasswordField = U, t.AcroForm = {
            Appearance: N
        }), n.AcroFormChoiceField = F, n.AcroFormListBox = P, n.AcroFormComboBox = E, n.AcroFormEditBox = q, n.AcroFormButton = O, n.AcroFormPushButton = B, n.AcroFormRadioButton = R, n.AcroFormCheckBox = D, n.AcroFormTextField = M, n.AcroFormPasswordField = U, n.AcroForm = {
            ChoiceField: F,
            ListBox: P,
            ComboBox: E,
            EditBox: q,
            Button: O,
            PushButton: B,
            RadioButton: R,
            CheckBox: D,
            TextField: M,
            PasswordField: U
        };
    }($.API, "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global), $.API.addHTML = function(t, p, g, s, m) {
        if ("undefined" == typeof html2canvas && "undefined" == typeof rasterizeHTML) throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");
        "number" != typeof p && (s = p, m = g), "function" == typeof s && (m = s, s = null), "function" != typeof m && (m = function() {});
        var e = this.internal, w = e.scaleFactor, y = e.pageSize.getWidth(), v = e.pageSize.getHeight();
        if ((s = s || {}).onrendered = (function(h) {
            p = parseInt(p) || 0, g = parseInt(g) || 0;
            var t = s.dim || {}, c = Object.assign({
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                useFor: "content"
            }, s.margin), e = t.h || Math.min(v, h.height / w), l = t.w || Math.min(y, h.width / w) - p, u = s.format || "JPEG", f = s.imageCompression || "SLOW";
            if (h.height > v - c.top - c.bottom && s.pagesplit) {
                var d = function(t, e, n, r, i) {
                    var o = document.createElement("canvas");
                    o.height = i, o.width = r;
                    var a = o.getContext("2d");
                    return a.mozImageSmoothingEnabled = !1, a.webkitImageSmoothingEnabled = !1, a.msImageSmoothingEnabled = !1, a.imageSmoothingEnabled = !1, a.fillStyle = s.backgroundColor || "#ffffff", a.fillRect(0, 0, r, i), a.drawImage(t, e, n, r, i, 0, 0, r, i), o;
                }, n = (function() {
                    for(var t, e, n = 0, r = 0, i = {}, o = !1;;){
                        var a;
                        if (r = 0, i.top = 0 !== n ? c.top : g, i.left = 0 !== n ? c.left : p, o = (y - c.left - c.right) * w < h.width, "content" === c.useFor ? 0 === n ? (t = Math.min((y - c.left) * w, h.width), e = Math.min((v - c.top) * w, h.height - n)) : (t = Math.min(y * w, h.width), e = Math.min(v * w, h.height - n), i.top = 0) : (t = Math.min((y - c.left - c.right) * w, h.width), e = Math.min((v - c.bottom - c.top) * w, h.height - n)), o) for(;;){
                            "content" === c.useFor && (0 === r ? t = Math.min((y - c.left) * w, h.width) : (t = Math.min(y * w, h.width - r), i.left = 0));
                            var s = [
                                a = d(h, r, n, t, e),
                                i.left,
                                i.top,
                                a.width / w,
                                a.height / w,
                                u,
                                null,
                                f
                            ];
                            if (this.addImage.apply(this, s), (r += t) >= h.width) break;
                            this.addPage();
                        }
                        else s = [
                            a = d(h, 0, n, t, e),
                            i.left,
                            i.top,
                            a.width / w,
                            a.height / w,
                            u,
                            null,
                            f
                        ], this.addImage.apply(this, s);
                        if ((n += e) >= h.height) break;
                        this.addPage();
                    }
                    m(l, n, null, s);
                }).bind(this);
                if ("CANVAS" === h.nodeName) {
                    var r = new Image;
                    r.onload = n, r.src = h.toDataURL("image/png"), h = r;
                } else n();
            } else {
                var i = Math.random().toString(35), o = [
                    h,
                    p,
                    g,
                    l,
                    e,
                    u,
                    i,
                    f
                ];
                this.addImage.apply(this, o), m(l, e, i, o);
            }
        }).bind(this), "undefined" != typeof html2canvas && !s.rstz) return html2canvas(t, s);
        if ("undefined" != typeof rasterizeHTML) {
            var n = "drawDocument";
            return "string" == typeof t && (n = /^http/.test(t) ? "drawURL" : "drawHTML"), s.width = s.width || y * w, rasterizeHTML[n](t, void 0, s).then(function(t) {
                s.onrendered(t.image);
            }, function(t) {
                m(null, t);
            });
        }
        return null;
    }, /** @preserve
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */ function(b) {
        var x = "addImage_", h = {
            PNG: [
                [
                    137,
                    80,
                    78,
                    71
                ]
            ],
            TIFF: [
                [
                    77,
                    77,
                    0,
                    42
                ],
                [
                    73,
                    73,
                    42,
                    0
                ]
            ],
            JPEG: [
                [
                    255,
                    216,
                    255,
                    224,
                    void 0,
                    void 0,
                    74,
                    70,
                    73,
                    70,
                    0
                ],
                [
                    255,
                    216,
                    255,
                    225,
                    void 0,
                    void 0,
                    69,
                    120,
                    105,
                    102,
                    0,
                    0
                ]
            ],
            JPEG2000: [
                [
                    0,
                    0,
                    0,
                    12,
                    106,
                    80,
                    32,
                    32
                ]
            ],
            GIF87a: [
                [
                    71,
                    73,
                    70,
                    56,
                    55,
                    97
                ]
            ],
            GIF89a: [
                [
                    71,
                    73,
                    70,
                    56,
                    57,
                    97
                ]
            ],
            BMP: [
                [
                    66,
                    77
                ],
                [
                    66,
                    65
                ],
                [
                    67,
                    73
                ],
                [
                    67,
                    80
                ],
                [
                    73,
                    67
                ],
                [
                    80,
                    84
                ]
            ]
        };
        b.getImageFileTypeByImageData = function(t, e) {
            var n, r;
            e = e || "UNKNOWN";
            var i, o, a, s = "UNKNOWN";
            for(a in h)for(i = h[a], n = 0; n < i.length; n += 1){
                for(o = !0, r = 0; r < i[n].length; r += 1)if (void 0 !== i[n][r] && i[n][r] !== t.charCodeAt(r)) {
                    o = !1;
                    break;
                }
                if (!0 === o) {
                    s = a;
                    break;
                }
            }
            return "UNKOWN" === s && "UNKNOWN" !== e && (console.warn('FileType of Image not recognized. Processing image as "' + e + '".'), s = e), s;
        };
        var n = function t(e) {
            var n = this.internal.newObject(), r = this.internal.write, i = this.internal.putStream;
            if (e.n = n, r("<</Type /XObject"), r("/Subtype /Image"), r("/Width " + e.w), r("/Height " + e.h), e.cs === this.color_spaces.INDEXED ? r("/ColorSpace [/Indexed /DeviceRGB " + (e.pal.length / 3 - 1) + " " + ("smask" in e ? n + 2 : n + 1) + " 0 R]") : (r("/ColorSpace /" + e.cs), e.cs === this.color_spaces.DEVICE_CMYK && r("/Decode [1 0 1 0 1 0 1 0]")), r("/BitsPerComponent " + e.bpc), "f" in e && r("/Filter /" + e.f), "dp" in e && r("/DecodeParms <<" + e.dp + ">>"), "trns" in e && e.trns.constructor == Array) {
                for(var o = "", a = 0, s = e.trns.length; a < s; a++)o += e.trns[a] + " " + e.trns[a] + " ";
                r("/Mask [" + o + "]");
            }
            if ("smask" in e && r("/SMask " + (n + 1) + " 0 R"), r("/Length " + e.data.length + ">>"), i(e.data), r("endobj"), "smask" in e) {
                var h = "/Predictor " + e.p + " /Colors 1 /BitsPerComponent " + e.bpc + " /Columns " + e.w, c = {
                    w: e.w,
                    h: e.h,
                    cs: "DeviceGray",
                    bpc: e.bpc,
                    dp: h,
                    data: e.smask
                };
                "f" in e && (c.f = e.f), t.call(this, c);
            }
            e.cs === this.color_spaces.INDEXED && (this.internal.newObject(), r("<< /Length " + e.pal.length + ">>"), i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))), r("endobj"));
        }, S = function() {
            var t = this.internal.collections[x + "images"];
            for(var e in t)n.call(this, t[e]);
        }, k = function() {
            var t, e = this.internal.collections[x + "images"], n = this.internal.write;
            for(var r in e)n("/I" + (t = e[r]).i, t.n, "0", "R");
        }, _ = function(t) {
            return "function" == typeof b["process" + t.toUpperCase()];
        }, A = function(t) {
            return "object" === (void 0 === t ? "undefined" : vt(t)) && 1 === t.nodeType;
        }, I = function(t, e) {
            if ("IMG" === t.nodeName && t.hasAttribute("src")) {
                var n = "" + t.getAttribute("src");
                if (0 === n.indexOf("data:image/")) return n;
                !e && /\.png(?:[?#].*)?$/i.test(n) && (e = "png");
            }
            if ("CANVAS" === t.nodeName) var r = t;
            else {
                (r = document.createElement("canvas")).width = t.clientWidth || t.width, r.height = t.clientHeight || t.height;
                var i = r.getContext("2d");
                if (!i) throw "addImage requires canvas to be supported by browser.";
                i.drawImage(t, 0, 0, r.width, r.height);
            }
            return r.toDataURL("png" == ("" + e).toLowerCase() ? "image/png" : "image/jpeg");
        }, C = function(t, e) {
            var n;
            if (e) {
                for(var r in e)if (t === e[r].alias) {
                    n = e[r];
                    break;
                }
            }
            return n;
        };
        b.color_spaces = {
            DEVICE_RGB: "DeviceRGB",
            DEVICE_GRAY: "DeviceGray",
            DEVICE_CMYK: "DeviceCMYK",
            CAL_GREY: "CalGray",
            CAL_RGB: "CalRGB",
            LAB: "Lab",
            ICC_BASED: "ICCBased",
            INDEXED: "Indexed",
            PATTERN: "Pattern",
            SEPARATION: "Separation",
            DEVICE_N: "DeviceN"
        }, b.decode = {
            DCT_DECODE: "DCTDecode",
            FLATE_DECODE: "FlateDecode",
            LZW_DECODE: "LZWDecode",
            JPX_DECODE: "JPXDecode",
            JBIG2_DECODE: "JBIG2Decode",
            ASCII85_DECODE: "ASCII85Decode",
            ASCII_HEX_DECODE: "ASCIIHexDecode",
            RUN_LENGTH_DECODE: "RunLengthDecode",
            CCITT_FAX_DECODE: "CCITTFaxDecode"
        }, b.image_compression = {
            NONE: "NONE",
            FAST: "FAST",
            MEDIUM: "MEDIUM",
            SLOW: "SLOW"
        }, b.sHashCode = function(t) {
            return t = t || "", Array.prototype.reduce && t.split("").reduce(function(t, e) {
                return (t = (t << 5) - t + e.charCodeAt(0)) & t;
            }, 0);
        }, b.isString = function(t) {
            return "string" == typeof t;
        }, b.validateStringAsBase64 = function(t) {
            var e = !0;
            return (t = t || "").length % 4 != 0 && (e = !1), !1 === /[A-Za-z0-9\/]+/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==/.test(t.substr(-2)) && (e = !1), e;
        }, b.extractInfoFromBase64DataURI = function(t) {
            return /^data:([\w]+?\/([\w]+?));base64,(.+)$/g.exec(t);
        }, b.supportsArrayBuffer = function() {
            return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
        }, b.isArrayBuffer = function(t) {
            return !!this.supportsArrayBuffer() && t instanceof ArrayBuffer;
        }, b.isArrayBufferView = function(t) {
            return !!this.supportsArrayBuffer() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
        }, b.binaryStringToUint8Array = function(t) {
            for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
            return n;
        }, b.arrayBufferToBinaryString = function(t) {
            if ("function" == typeof atob) return atob(this.arrayBufferToBase64(t));
            if ("function" == typeof TextDecoder) {
                var e = new TextDecoder("ascii");
                if ("ascii" === e.encoding) return e.decode(t);
            }
            for(var n = this.isArrayBuffer(t) ? t : new Uint8Array(t), r = 20480, i = "", o = Math.ceil(n.byteLength / r), a = 0; a < o; a++)i += String.fromCharCode.apply(null, n.slice(a * r, a * r + r));
            return i;
        }, b.arrayBufferToBase64 = function(t) {
            for(var e, n = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = new Uint8Array(t), o = i.byteLength, a = o % 3, s = o - a, h = 0; h < s; h += 3)n += r[(16515072 & (e = i[h] << 16 | i[h + 1] << 8 | i[h + 2])) >> 18] + r[(258048 & e) >> 12] + r[(4032 & e) >> 6] + r[63 & e];
            return 1 == a ? n += r[(252 & (e = i[s])) >> 2] + r[(3 & e) << 4] + "==" : 2 == a && (n += r[(64512 & (e = i[s] << 8 | i[s + 1])) >> 10] + r[(1008 & e) >> 4] + r[(15 & e) << 2] + "="), n;
        }, b.createImageInfo = function(t, e, n, r, i, o, a, s, h, c, l, u, f) {
            var d = {
                alias: s,
                w: e,
                h: n,
                cs: r,
                bpc: i,
                i: a,
                data: t
            };
            return o && (d.f = o), h && (d.dp = h), c && (d.trns = c), l && (d.pal = l), u && (d.smask = u), f && (d.p = f), d;
        }, b.addImage = function(t, e, n, r, i, o, a, s, h) {
            var c = "";
            if ("string" != typeof e) {
                var l = o;
                o = i, i = r, r = n, n = e, e = l;
            }
            if ("object" === (void 0 === t ? "undefined" : vt(t)) && !A(t) && "imageData" in t) {
                var u = t;
                t = u.imageData, e = u.format || e, n = u.x || n || 0, r = u.y || r || 0, i = u.w || i, o = u.h || o, a = u.alias || a, s = u.compression || s, h = u.rotation || u.angle || h;
            }
            if (isNaN(n) || isNaN(r)) throw console.error("jsPDF.addImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addImage");
            var f, d, p, g, m, w, y, v = (function() {
                var t = this.internal.collections[x + "images"];
                return t || (this.internal.collections[x + "images"] = t = {}, this.internal.events.subscribe("putResources", S), this.internal.events.subscribe("putXobjectDict", k)), t;
            }).call(this);
            if (!(f = C(t, v)) && (A(t) && (t = I(t, e)), (null == (y = a) || 0 === y.length) && (a = "string" == typeof (w = t) && b.sHashCode(w)), !(f = C(a, v)))) {
                if (this.isString(t) && ("" !== (c = this.convertStringToImageData(t)) ? t = c : void 0 !== (c = this.loadImageFile(t)) && (t = c)), e = this.getImageFileTypeByImageData(t, e), !_(e)) throw new Error("addImage does not support files of type '" + e + "', please ensure that a plugin for '" + e + "' support is added.");
                if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (d = t, t = this.binaryStringToUint8Array(t))), !(f = this["process" + e.toUpperCase()](t, (m = 0, (g = v) && (m = Object.keys ? Object.keys(g).length : function(t) {
                    var e = 0;
                    for(var n in t)t.hasOwnProperty(n) && e++;
                    return e;
                }(g)), m), a, ((p = s) && "string" == typeof p && (p = p.toUpperCase()), p in b.image_compression ? p : b.image_compression.NONE), d))) throw new Error("An unkwown error occurred whilst processing the image");
            }
            return (function(t, e, n, r, i, o, a, s) {
                var h = (function(t, e, n) {
                    return t || e || (e = t = -96), t < 0 && (t = -1 * n.w * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.h * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.w / n.h), 0 === e && (e = t * n.h / n.w), [
                        t,
                        e
                    ];
                }).call(this, n, r, i), c = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString;
                if (n = h[0], r = h[1], a[o] = i, s) {
                    s *= Math.PI / 180;
                    var u = Math.cos(s), f = Math.sin(s), d = function(t) {
                        return t.toFixed(4);
                    }, p = [
                        d(u),
                        d(f),
                        d(-1 * f),
                        d(u),
                        0,
                        0,
                        "cm"
                    ];
                }
                this.internal.write("q"), s ? (this.internal.write([
                    1,
                    "0",
                    "0",
                    1,
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    "0",
                    "0",
                    "cm"
                ].join(" "))) : this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write("/I" + i.i + " Do"), this.internal.write("Q");
            }).call(this, n, r, i, o, f, f.i, v, h), this;
        }, b.convertStringToImageData = function(t) {
            var e, n = "";
            this.isString(t) && (null !== (e = this.extractInfoFromBase64DataURI(t)) ? b.validateStringAsBase64(e[3]) && (n = atob(e[3])) : b.validateStringAsBase64(t) && (n = atob(t)));
            return n;
        };
        var c = function(t, e) {
            return t.subarray(e, e + 5);
        };
        b.processJPEG = function(t, e, n, r, i, o) {
            var a, s = this.decode.DCT_DECODE;
            if (!this.isString(t) && !this.isArrayBuffer(t) && !this.isArrayBufferView(t)) return null;
            if (this.isString(t) && (a = function(t) {
                var e;
                if ((t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3), !t.charCodeAt(6) === "J".charCodeAt(0)) || !t.charCodeAt(7) === "F".charCodeAt(0) || !t.charCodeAt(8) === "I".charCodeAt(0) || !t.charCodeAt(9) === "F".charCodeAt(0) || (t.charCodeAt(10), false)) throw new Error("getJpegSize requires a binary string jpeg file");
                for(var n = 256 * t.charCodeAt(4) + t.charCodeAt(5), r = 4, i = t.length; r < i;){
                    if (r += n, 255 !== t.charCodeAt(r)) throw new Error("getJpegSize could not find the size of the image");
                    if (192 === t.charCodeAt(r + 1) || 193 === t.charCodeAt(r + 1) || 194 === t.charCodeAt(r + 1) || 195 === t.charCodeAt(r + 1) || 196 === t.charCodeAt(r + 1) || 197 === t.charCodeAt(r + 1) || 198 === t.charCodeAt(r + 1) || 199 === t.charCodeAt(r + 1)) return e = 256 * t.charCodeAt(r + 5) + t.charCodeAt(r + 6), [
                        256 * t.charCodeAt(r + 7) + t.charCodeAt(r + 8),
                        e,
                        t.charCodeAt(r + 9)
                    ];
                    r += 2, n = 256 * t.charCodeAt(r) + t.charCodeAt(r + 1);
                }
            }(t)), this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t) && (a = function(t) {
                if (65496 != (t[0] << 8 | t[1])) throw new Error("Supplied data is not a JPEG");
                for(var e, n = t.length, r = (t[4] << 8) + t[5], i = 4; i < n;){
                    if (r = ((e = c(t, i += r))[2] << 8) + e[3], (192 === e[1] || 194 === e[1]) && 255 === e[0] && 7 < r) return {
                        width: ((e = c(t, i + 5))[2] << 8) + e[3],
                        height: (e[0] << 8) + e[1],
                        numcomponents: e[4]
                    };
                    i += 2;
                }
                throw new Error("getJpegSizeFromBytes could not find the size of the image");
            }(t), t = i || this.arrayBufferToBinaryString(t)), void 0 === o) switch(a.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                default:
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            return this.createImageInfo(t, a.width, a.height, o, 8, s, e, n);
        }, b.processJPG = function() {
            return this.processJPEG.apply(this, arguments);
        }, b.loadImageFile = function(t, e, n) {
            e = e || !0, n = n || function() {};
            Object.prototype.toString.call("undefined" != typeof $hPtJY ? $hPtJY : 0);
            if (void 0 !== ("undefined" == typeof window ? "undefined" : vt(window)) && "object" === ("undefined" == typeof location ? "undefined" : vt(location)) && "http" === location.protocol.substr(0, 4)) return function(t, e, n) {
                var r = new XMLHttpRequest, i = [], o = 0, a = function(t) {
                    var e = t.length, n = String.fromCharCode;
                    for(o = 0; o < e; o += 1)i.push(n(255 & t.charCodeAt(o)));
                    return i.join("");
                };
                if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                    return a(this.responseText);
                }), r.send(null), 200 === r.status) return e ? a(r.responseText) : void 0;
                console.warn('Unable to load file "' + t + '"');
            }(t, e);
        }, b.getImageProperties = function(t) {
            var e, n, r = "";
            if (A(t) && (t = I(t)), this.isString(t) && ("" !== (r = this.convertStringToImageData(t)) ? t = r : void 0 !== (r = this.loadImageFile(t)) && (t = r)), n = this.getImageFileTypeByImageData(t), !_(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
            if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (t = this.binaryStringToUint8Array(t))), !(e = this["process" + n.toUpperCase()](t))) throw new Error("An unkwown error occurred whilst processing the image");
            return {
                fileType: n,
                width: e.w,
                height: e.h,
                colorSpace: e.cs,
                compressionMode: e.f,
                bitsPerComponent: e.bpc
            };
        };
    }($.API), /**
   * jsPDF Annotations PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ t = $.API, y = {
        annotations: [],
        f2: function(t) {
            return t.toFixed(2);
        },
        notEmpty: function(t) {
            if (void 0 !== t && "" != t) return !0;
        }
    }, $.API.annotationPlugin = y, $.API.events.push([
        "addPage",
        function(t) {
            this.annotationPlugin.annotations[t.pageNumber] = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var e = this.annotationPlugin.annotations[t.pageNumber], n = !1, r = 0; r < e.length && !n; r++)switch((h = e[r]).type){
                case "link":
                    if (y.notEmpty(h.options.url) || y.notEmpty(h.options.pageNumber)) {
                        n = !0;
                        break;
                    }
                case "reference":
                case "text":
                case "freetext":
                    n = !0;
            }
            if (0 != n) {
                this.internal.write("/Annots [");
                var i = this.annotationPlugin.f2, o = this.internal.scaleFactor, a = this.internal.pageSize.getHeight(), s = this.internal.getPageInfo(t.pageNumber);
                for(r = 0; r < e.length; r++){
                    var h;
                    switch((h = e[r]).type){
                        case "reference":
                            this.internal.write(" " + h.object.objId + " 0 R ");
                            break;
                        case "text":
                            var c = this.internal.newAdditionalObject(), l = this.internal.newAdditionalObject(), u = h.title || "Note";
                            m = "<</Type /Annot /Subtype /Text " + (d = "/Rect [" + i(h.bounds.x * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w) * o) + " " + i((a - h.bounds.y) * o) + "] ") + "/Contents (" + h.contents + ")", m += " /Popup " + l.objId + " 0 R", m += " /P " + s.objId + " 0 R", m += " /T (" + u + ") >>", c.content = m;
                            var f = c.objId + " 0 R";
                            m = "<</Type /Annot /Subtype /Popup " + (d = "/Rect [" + i((h.bounds.x + 30) * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w + 30) * o) + " " + i((a - h.bounds.y) * o) + "] ") + " /Parent " + f, h.open && (m += " /Open true"), m += " >>", l.content = m, this.internal.write(c.objId, "0 R", l.objId, "0 R");
                            break;
                        case "freetext":
                            var d = "/Rect [" + i(h.bounds.x * o) + " " + i((a - h.bounds.y) * o) + " " + i(h.bounds.x + h.bounds.w * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + "] ", p = h.color || "#000000";
                            m = "<</Type /Annot /Subtype /FreeText " + d + "/Contents (" + h.contents + ")", m += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + p + ")", m += " /Border [0 0 0]", m += " >>", this.internal.write(m);
                            break;
                        case "link":
                            if (h.options.name) {
                                var g = this.annotations._nameMap[h.options.name];
                                h.options.pageNumber = g.page, h.options.top = g.y;
                            } else h.options.top || (h.options.top = 0);
                            d = "/Rect [" + i(h.x * o) + " " + i((a - h.y) * o) + " " + i((h.x + h.w) * o) + " " + i((a - (h.y + h.h)) * o) + "] ";
                            var m = "";
                            if (h.options.url) m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /A <</S /URI /URI (" + h.options.url + ") >>";
                            else if (h.options.pageNumber) switch(m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /Dest [" + (t = this.internal.getPageInfo(h.options.pageNumber)).objId + " 0 R", h.options.magFactor = h.options.magFactor || "XYZ", h.options.magFactor){
                                case "Fit":
                                    m += " /Fit]";
                                    break;
                                case "FitH":
                                    m += " /FitH " + h.options.top + "]";
                                    break;
                                case "FitV":
                                    h.options.left = h.options.left || 0, m += " /FitV " + h.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var w = i((a - h.options.top) * o);
                                    h.options.left = h.options.left || 0, void 0 === h.options.zoom && (h.options.zoom = 0), m += " /XYZ " + h.options.left + " " + w + " " + h.options.zoom + "]";
                            }
                            "" != m && (m += " >>", this.internal.write(m));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({
            x: t,
            y: e,
            w: n,
            h: r,
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i = this.getTextWidth(t), o = this.internal.getLineHeight() / this.internal.scaleFactor;
        return this.text(t, e, n), n += .2 * o, this.link(e, n - o, i, o, r), i;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    }, t.getLineHeight = function() {
        return this.internal.getLineHeight();
    }, function(t) {
        var a = Object.keys({
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            ur: "Urdu"
        }), u = {
            1569: [
                65152
            ],
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1572: [
                65157,
                65158
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1574: [
                65161,
                65162,
                65163,
                65164
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ],
            1576: [
                65167,
                65168,
                65169,
                65170
            ],
            1577: [
                65171,
                65172
            ],
            1578: [
                65173,
                65174,
                65175,
                65176
            ],
            1579: [
                65177,
                65178,
                65179,
                65180
            ],
            1580: [
                65181,
                65182,
                65183,
                65184
            ],
            1581: [
                65185,
                65186,
                65187,
                65188
            ],
            1582: [
                65189,
                65190,
                65191,
                65192
            ],
            1583: [
                65193,
                65194,
                65193
            ],
            1584: [
                65195,
                65196,
                65195
            ],
            1585: [
                65197,
                65198,
                65197
            ],
            1586: [
                65199,
                65200,
                65199
            ],
            1587: [
                65201,
                65202,
                65203,
                65204
            ],
            1588: [
                65205,
                65206,
                65207,
                65208
            ],
            1589: [
                65209,
                65210,
                65211,
                65212
            ],
            1590: [
                65213,
                65214,
                65215,
                65216
            ],
            1591: [
                65217,
                65218,
                65219,
                65220
            ],
            1592: [
                65221,
                65222,
                65223,
                65224
            ],
            1593: [
                65225,
                65226,
                65227,
                65228
            ],
            1594: [
                65229,
                65230,
                65231,
                65232
            ],
            1601: [
                65233,
                65234,
                65235,
                65236
            ],
            1602: [
                65237,
                65238,
                65239,
                65240
            ],
            1603: [
                65241,
                65242,
                65243,
                65244
            ],
            1604: [
                65245,
                65246,
                65247,
                65248
            ],
            1605: [
                65249,
                65250,
                65251,
                65252
            ],
            1606: [
                65253,
                65254,
                65255,
                65256
            ],
            1607: [
                65257,
                65258,
                65259,
                65260
            ],
            1608: [
                65261,
                65262,
                65261
            ],
            1609: [
                65263,
                65264,
                64488,
                64489
            ],
            1610: [
                65265,
                65266,
                65267,
                65268
            ],
            1649: [
                64336,
                64337
            ],
            1655: [
                64477
            ],
            1657: [
                64358,
                64359,
                64360,
                64361
            ],
            1658: [
                64350,
                64351,
                64352,
                64353
            ],
            1659: [
                64338,
                64339,
                64340,
                64341
            ],
            1662: [
                64342,
                64343,
                64344,
                64345
            ],
            1663: [
                64354,
                64355,
                64356,
                64357
            ],
            1664: [
                64346,
                64347,
                64348,
                64349
            ],
            1667: [
                64374,
                64375,
                64376,
                64377
            ],
            1668: [
                64370,
                64371,
                64372,
                64373
            ],
            1670: [
                64378,
                64379,
                64380,
                64381
            ],
            1671: [
                64382,
                64383,
                64384,
                64385
            ],
            1672: [
                64392,
                64393
            ],
            1676: [
                64388,
                64389
            ],
            1677: [
                64386,
                64387
            ],
            1678: [
                64390,
                64391
            ],
            1681: [
                64396,
                64397
            ],
            1688: [
                64394,
                64395,
                64394
            ],
            1700: [
                64362,
                64363,
                64364,
                64365
            ],
            1702: [
                64366,
                64367,
                64368,
                64369
            ],
            1705: [
                64398,
                64399,
                64400,
                64401
            ],
            1709: [
                64467,
                64468,
                64469,
                64470
            ],
            1711: [
                64402,
                64403,
                64404,
                64405
            ],
            1713: [
                64410,
                64411,
                64412,
                64413
            ],
            1715: [
                64406,
                64407,
                64408,
                64409
            ],
            1722: [
                64414,
                64415
            ],
            1723: [
                64416,
                64417,
                64418,
                64419
            ],
            1726: [
                64426,
                64427,
                64428,
                64429
            ],
            1728: [
                64420,
                64421
            ],
            1729: [
                64422,
                64423,
                64424,
                64425
            ],
            1733: [
                64480,
                64481
            ],
            1734: [
                64473,
                64474
            ],
            1735: [
                64471,
                64472
            ],
            1736: [
                64475,
                64476
            ],
            1737: [
                64482,
                64483
            ],
            1739: [
                64478,
                64479
            ],
            1740: [
                64508,
                64509,
                64510,
                64511
            ],
            1744: [
                64484,
                64485,
                64486,
                64487
            ],
            1746: [
                64430,
                64431
            ],
            1747: [
                64432,
                64433
            ]
        }, f = {
            1570: [
                65269,
                65270,
                65269,
                65270
            ],
            1571: [
                65271,
                65272,
                65271,
                65272
            ],
            1573: [
                65273,
                65274,
                65273,
                65274
            ],
            1575: [
                65275,
                65276,
                65275,
                65276
            ]
        }, d = {
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ]
        }, p = {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }, e = [
            1570,
            1571,
            1573,
            1575
        ], n = [
            1569,
            1570,
            1571,
            1572,
            1573,
            1575,
            1577,
            1583,
            1584,
            1585,
            1586,
            1608,
            1688
        ], o = 0, s = 1, h = 2, c = 3;
        function g(t) {
            return void 0 !== t && void 0 !== u[t.charCodeAt(0)];
        }
        function l(t) {
            return void 0 !== t && 0 <= n.indexOf(t.charCodeAt(0));
        }
        function m(t) {
            return void 0 !== t && 0 <= e.indexOf(t.charCodeAt(0));
        }
        function w(t) {
            return g(t) && 2 <= u[t.charCodeAt(0)].length;
        }
        function y(t, e, n, r) {
            var i;
            return g(t) ? (r = r || {}, u = Object.assign(u, r), !w(t) || !g(e) && !g(n) || !g(n) && l(e) || l(t) && !g(e) || l(t) && m(e) || l(t) && l(e) ? (u = Object.assign(u, d), o) : g(i = t) && 4 == u[i.charCodeAt(0)].length && g(e) && !l(e) && g(n) && w(n) ? (u = Object.assign(u, d), c) : l(t) || !g(n) ? (u = Object.assign(u, d), s) : (u = Object.assign(u, d), h)) : -1;
        }
        var v = t.processArabic = function(t, e) {
            t = t || "", e = e || !1;
            var n, r, i, o = "", a = 0, s = 0, h = "", c = "", l = "";
            for(a = 0; a < t.length; a += 1)h = t[a], c = t[a - 1], l = t[a + 1], g(h) ? void 0 !== c && 1604 === c.charCodeAt(0) && m(h) ? (s = y(h, t[a - 2], t[a + 1], f), n = String.fromCharCode(f[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : void 0 !== c && 1617 === c.charCodeAt(0) && void 0 !== (r = h) && void 0 !== p[r.charCodeAt(0)] ? (s = y(h, t[a - 2], t[a + 1], d), n = String.fromCharCode(p[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : (s = y(h, c, l, d), o += String.fromCharCode(u[h.charCodeAt(0)][s])) : o += e ? ({
                "(": ")",
                ")": "("
            })[i = h] || i : h;
            return e ? o.split("").reverse().join("") : o;
        };
        t.events.push([
            "preProcessText",
            function(t) {
                var e = t.text, n = (t.x, t.y, t.options || {}), r = (t.mutex, n.lang), i = [];
                if (0 <= a.indexOf(r)) {
                    if ("[object Array]" === Object.prototype.toString.call(e)) {
                        var o = 0;
                        for(i = [], o = 0; o < e.length; o += 1)"[object Array]" === Object.prototype.toString.call(e[o]) ? i.push([
                            v(e[o][0], !0),
                            e[o][1],
                            e[o][2]
                        ]) : i.push([
                            v(e[o], !0)
                        ]);
                        t.text = i;
                    } else t.text = v(e, !0);
                    void 0 === n.charSpace && (t.options.charSpace = 0), !0 === n.R2L && (t.options.R2L = !1);
                }
            }
        ]);
    }($.API), $.API.autoPrint = function(t) {
        var e;
        switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
            case "javascript":
                this.addJS("print({});");
                break;
            case "non-conform":
            default:
                this.internal.events.subscribe("postPutResources", function() {
                    e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
                }), this.internal.events.subscribe("putCatalog", function() {
                    this.internal.out("/OpenAction " + e + " 0 R");
                });
        }
        return this;
    }, /**
   * jsPDF Canvas PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (e = $.API).events.push([
        "initialized",
        function() {
            this.canvas.pdf = this;
        }
    ]), e.canvas = {
        getContext: function(t) {
            return (this.pdf.context2d._canvas = this).pdf.context2d;
        },
        childNodes: []
    }, Object.defineProperty(e.canvas, "width", {
        get: function() {
            return this._width;
        },
        set: function(t) {
            this._width = t, this.getContext("2d").pageWrapX = t + 1;
        }
    }), Object.defineProperty(e.canvas, "height", {
        get: function() {
            return this._height;
        },
        set: function(t) {
            this._height = t, this.getContext("2d").pageWrapY = t + 1;
        }
    }), /** ====================================================================
   * jsPDF Cell plugin
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */ I = $.API, C = {
        x: void 0,
        y: void 0,
        w: void 0,
        h: void 0,
        ln: void 0
    }, T = 1, d = function(t, e, n, r, i) {
        C = {
            x: t,
            y: e,
            w: n,
            h: r,
            ln: i
        };
    }, p = function() {
        return C;
    }, F = {
        left: 0,
        top: 0,
        bottom: 0
    }, I.setHeaderFunction = function(t) {
        h = t;
    }, I.getTextDimensions = function(e) {
        i = this.internal.getFont().fontName, o = this.table_font_size || this.internal.getFontSize(), a = this.internal.getFont().fontStyle;
        var t, n, r = 19.049976 / 25.4;
        (n = document.createElement("font")).id = "jsPDFCell";
        try {
            n.style.fontStyle = a;
        } catch (t) {
            n.style.fontWeight = a;
        }
        n.style.fontSize = o + "pt", n.style.fontFamily = i;
        try {
            n.textContent = e;
        } catch (t) {
            n.innerText = e;
        }
        return document.body.appendChild(n), t = {
            w: (n.offsetWidth + 1) * r,
            h: (n.offsetHeight + 1) * r
        }, document.body.removeChild(n), t;
    }, I.cellAddPage = function() {
        var t = this.margins || F;
        this.addPage(), d(t.left, t.top, void 0, void 0), T += 1;
    }, I.cellInitialize = function() {
        C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1;
    }, I.cell = function(t, e, n, r, i, o, a) {
        var s = p(), h = !1;
        if (void 0 !== s.ln) {
            if (s.ln === o) t = s.x + s.w, e = s.y;
            else {
                var c = this.margins || F;
                s.y + s.h + r + 13 >= this.internal.pageSize.getHeight() - c.bottom && (this.cellAddPage(), h = !0, this.printHeaders && this.tableHeaderRow && this.printHeaderRow(o, !0)), e = p().y + p().h, h && (e = 23);
            }
        }
        if (void 0 !== i[0]) {
            if (this.printingHeaderRow ? this.rect(t, e, n, r, "FD") : this.rect(t, e, n, r), "right" === a) {
                i instanceof Array || (i = [
                    i
                ]);
                for(var l = 0; l < i.length; l++){
                    var u = i[l], f = this.getStringUnitWidth(u) * this.internal.getFontSize();
                    this.text(u, t + n - f - 3, e + this.internal.getLineHeight() * (l + 1));
                }
            } else this.text(i, t + 3, e + this.internal.getLineHeight());
        }
        return d(t, e, n, r, o), this;
    }, I.arrayMax = function(t, e) {
        var n, r, i, o = t[0];
        for(n = 0, r = t.length; n < r; n += 1)i = t[n], e ? -1 === e(o, i) && (o = i) : o < i && (o = i);
        return o;
    }, I.table = function(t, e, n, r, i) {
        if (!n) throw "No data for PDF table";
        var o, a, s, h, c, l, u, f, d, p, g = [], m = [], w = {}, y = {}, v = [], b = [], x = !1, S = !0, k = 12, _ = F;
        if (_.width = this.internal.pageSize.getWidth(), i && (!0 === i.autoSize && (x = !0), !1 === i.printHeaders && (S = !1), i.fontSize && (k = i.fontSize), i.css && void 0 !== i.css["font-size"] && (k = 16 * i.css["font-size"]), i.margins && (_ = i.margins)), this.lnMod = 0, C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1, this.printHeaders = S, this.margins = _, this.setFontSize(k), this.table_font_size = k, null == r) g = Object.keys(n[0]);
        else if (r[0] && "string" != typeof r[0]) for(a = 0, s = r.length; a < s; a += 1)o = r[a], g.push(o.name), m.push(o.prompt), y[o.name] = o.width * (19.049976 / 25.4);
        else g = r;
        if (x) for(p = function(t) {
            return t[o];
        }, a = 0, s = g.length; a < s; a += 1){
            for(w[o = g[a]] = n.map(p), v.push(this.getTextDimensions(m[a] || o).w), u = 0, h = (l = w[o]).length; u < h; u += 1)c = l[u], v.push(this.getTextDimensions(c).w);
            y[o] = I.arrayMax(v), v = [];
        }
        if (S) {
            var A = this.calculateLineHeight(g, y, m.length ? m : g);
            for(a = 0, s = g.length; a < s; a += 1)o = g[a], b.push([
                t,
                e,
                y[o],
                A,
                String(m.length ? m[a] : o)
            ]);
            this.setTableHeaderRow(b), this.printHeaderRow(1, !1);
        }
        for(a = 0, s = n.length; a < s; a += 1)for(f = n[a], A = this.calculateLineHeight(g, y, f), u = 0, d = g.length; u < d; u += 1)o = g[u], this.cell(t, e, y[o], A, f[o], a + 2, o.align);
        return this.lastCellPos = C, this.table_x = t, this.table_y = e, this;
    }, I.calculateLineHeight = function(t, e, n) {
        for(var r, i = 0, o = 0; o < t.length; o++){
            n[r = t[o]] = this.splitTextToSize(String(n[r]), e[r] - 3);
            var a = this.internal.getLineHeight() * n[r].length + 3;
            i < a && (i = a);
        }
        return i;
    }, I.setTableHeaderRow = function(t) {
        this.tableHeaderRow = t;
    }, I.printHeaderRow = function(t, e) {
        if (!this.tableHeaderRow) throw "Property tableHeaderRow does not exist.";
        var n, r, i, o;
        if (this.printingHeaderRow = !0, void 0 !== h) {
            var a = h(this, T);
            d(a[0], a[1], a[2], a[3], -1);
        }
        this.setFontStyle("bold");
        var s = [];
        for(i = 0, o = this.tableHeaderRow.length; i < o; i += 1)this.setFillColor(200, 200, 200), n = this.tableHeaderRow[i], e && (this.margins.top = 13, n[1] = this.margins && this.margins.top || 0, s.push(n)), r = [].concat(n), this.cell.apply(this, r.concat(t));
        0 < s.length && this.setTableHeaderRow(s), this.setFontStyle("normal"), this.printingHeaderRow = !1;
    }, /**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ function(t) {
        t.events.push([
            "initialized",
            function() {
                ((this.context2d.pdf = this).context2d.internal.pdf = this).context2d.ctx = new e, this.context2d.ctxStack = [], this.context2d.path = [];
            }
        ]), t.context2d = {
            pageWrapXEnabled: !1,
            pageWrapYEnabled: !1,
            pageWrapX: 9999999,
            pageWrapY: 9999999,
            ctx: new e,
            f2: function(t) {
                return t.toFixed(2);
            },
            fillRect: function(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "f");
                }
            },
            strokeRect: function(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "s");
                }
            },
            clearRect: function(t, e, n, r) {
                if (!this.ctx.ignoreClearRect) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.save(), this.setFillStyle("#ffffff"), this.pdf.rect(i.x, i.y, i.w, i.h, "f"), this.restore();
                }
            },
            save: function() {
                this.ctx._fontSize = this.pdf.internal.getFontSize();
                var t = new e;
                t.copy(this.ctx), this.ctxStack.push(this.ctx), this.ctx = t;
            },
            restore: function() {
                this.ctx = this.ctxStack.pop(), this.setFillStyle(this.ctx.fillStyle), this.setStrokeStyle(this.ctx.strokeStyle), this.setFont(this.ctx.font), this.pdf.setFontSize(this.ctx._fontSize), this.setLineCap(this.ctx.lineCap), this.setLineWidth(this.ctx.lineWidth), this.setLineJoin(this.ctx.lineJoin);
            },
            rect: function(t, e, n, r) {
                this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.closePath();
            },
            beginPath: function() {
                this.path = [];
            },
            closePath: function() {
                this.path.push({
                    type: "close"
                });
            },
            _getRGBA: function(t) {
                var e, n, r, i, o = new RGBColor(t);
                if (!t) return {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0,
                    style: t
                };
                if (this.internal.rxTransparent.test(t)) i = r = n = e = 0;
                else {
                    var a = this.internal.rxRgb.exec(t);
                    null != a ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1) : null != (a = this.internal.rxRgba.exec(t)) ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4])) : (i = 1, "#" != t.charAt(0) && (t = o.ok ? o.toHex() : "#000000"), 4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16));
                }
                return {
                    r: e,
                    g: n,
                    b: r,
                    a: i,
                    style: t
                };
            },
            setFillStyle: function(t) {
                var e = this._getRGBA(t);
                this.ctx.fillStyle = t, this.ctx._isFillTransparent = 0 === e.a, this.ctx._fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            },
            setStrokeStyle: function(t) {
                var e = this._getRGBA(t);
                this.ctx.strokeStyle = e.style, this.ctx._isStrokeTransparent = 0 === e.a, this.ctx._strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            },
            fillText: function(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (h < .01) this.pdf.text(t, e, this._getBaseline(n), null, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), null, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            strokeText: function(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (1 === h) this.pdf.text(t, e, this._getBaseline(n), {
                        stroke: !0
                    }, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), {
                            stroke: !0
                        }, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            setFont: function(t) {
                if (this.ctx.font = t, null != (c = /\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))) {
                    var e = c[1], n = (c[2], c[3]), r = c[4], i = c[5], o = c[6];
                    r = "px" === i ? Math.floor(parseFloat(r)) : "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(r)), this.pdf.setFontSize(r), "bold" === n || "700" === n ? this.pdf.setFontStyle("bold") : "italic" === e ? this.pdf.setFontStyle("italic") : this.pdf.setFontStyle("normal"), l = "bold" === n || "700" === n ? "italic" === e ? "bolditalic" : "bold" : "italic" === e ? "italic" : "normal";
                    for(var a = o.toLowerCase().split(/\s*,\s*/), s = "Times", h = 0; h < a.length; h++){
                        if (void 0 !== this.pdf.internal.getFont(a[h], l, {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h];
                            break;
                        }
                        if ("bolditalic" === l && void 0 !== this.pdf.internal.getFont(a[h], "bold", {
                            noFallback: !0,
                            disableWarning: !0
                        })) s = a[h], l = "bold";
                        else if (void 0 !== this.pdf.internal.getFont(a[h], "normal", {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h], l = "normal";
                            break;
                        }
                    }
                    this.pdf.setFont(s, l);
                } else {
                    var c = /\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);
                    if (null != c) {
                        var l, u = c[1], f = (c[2], c[3]);
                        (l = c[4]) || (l = "normal"), u = "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(u)), this.pdf.setFontSize(u), this.pdf.setFont(f, l);
                    }
                }
            },
            setTextBaseline: function(t) {
                this.ctx.textBaseline = t;
            },
            getTextBaseline: function() {
                return this.ctx.textBaseline;
            },
            setTextAlign: function(t) {
                this.ctx.textAlign = t;
            },
            getTextAlign: function() {
                return this.ctx.textAlign;
            },
            setLineWidth: function(t) {
                this.ctx.lineWidth = t, this.pdf.setLineWidth(t);
            },
            setLineCap: function(t) {
                this.ctx.lineCap = t, this.pdf.setLineCap(t);
            },
            setLineJoin: function(t) {
                this.ctx.lineJoin = t, this.pdf.setLineJoin(t);
            },
            moveTo: function(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "mt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            _wrapX: function(t) {
                return this.pageWrapXEnabled ? t % this.pageWrapX : t;
            },
            _wrapY: function(t) {
                return this.pageWrapYEnabled ? (this._gotoPage(this._page(t)), (t - this.lastBreak) % this.pageWrapY) : t;
            },
            transform: function(t, e, n, r, i, o) {
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ]);
            },
            setTransform: function(t, e, n, r, i, o) {
                this.ctx._transform = [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ];
            },
            _getTransform: function() {
                return this.ctx._transform;
            },
            lastBreak: 0,
            pageBreaks: [],
            _page: function(t) {
                if (this.pageWrapYEnabled) {
                    for(var e = this.lastBreak = 0, n = 0, r = 0; r < this.pageBreaks.length; r++)if (t >= this.pageBreaks[r]) {
                        e++, 0 === this.lastBreak && n++;
                        var i = this.pageBreaks[r] - this.lastBreak;
                        this.lastBreak = this.pageBreaks[r], n += Math.floor(i / this.pageWrapY);
                    }
                    if (0 === this.lastBreak) n += Math.floor(t / this.pageWrapY) + 1;
                    return n + e;
                }
                return this.pdf.internal.getCurrentPageInfo().pageNumber;
            },
            _gotoPage: function(t) {},
            lineTo: function(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "lt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            bezierCurveTo: function(t, e, n, r, i, o) {
                var a;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), i = this._wrapX(i), o = this._wrapY(o), i = (a = this._matrix_map_point(this.ctx._transform, [
                    i,
                    o
                ]))[0], o = a[1];
                var s = {
                    type: "bct",
                    x1: t = (a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = a[1],
                    x2: n = (a = this._matrix_map_point(this.ctx._transform, [
                        n,
                        r
                    ]))[0],
                    y2: r = a[1],
                    x: i,
                    y: o
                };
                this.path.push(s);
            },
            quadraticCurveTo: function(t, e, n, r) {
                var i;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), n = (i = this._matrix_map_point(this.ctx._transform, [
                    n,
                    r
                ]))[0], r = i[1];
                var o = {
                    type: "qct",
                    x1: t = (i = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = i[1],
                    x: n,
                    y: r
                };
                this.path.push(o);
            },
            arc: function(t, e, n, r, i, o) {
                if (t = this._wrapX(t), e = this._wrapY(e), !this._matrix_is_identity(this.ctx._transform)) {
                    var a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]);
                    t = a[0], e = a[1];
                    var s = this._matrix_map_point(this.ctx._transform, [
                        0,
                        0
                    ]), h = this._matrix_map_point(this.ctx._transform, [
                        0,
                        n
                    ]);
                    n = Math.sqrt(Math.pow(h[0] - s[0], 2) + Math.pow(h[1] - s[1], 2));
                }
                var c = {
                    type: "arc",
                    x: t,
                    y: e,
                    radius: n,
                    startAngle: r,
                    endAngle: i,
                    anticlockwise: o
                };
                this.path.push(c);
            },
            drawImage: function(t, e, n, r, i, o, a, s, h) {
                void 0 !== o && (e = o, n = a, r = s, i = h), e = this._wrapX(e), n = this._wrapY(n);
                var c, l = this._matrix_map_rect(this.ctx._transform, {
                    x: e,
                    y: n,
                    w: r,
                    h: i
                }), u = (this._matrix_map_rect(this.ctx._transform, {
                    x: o,
                    y: a,
                    w: s,
                    h: h
                }), /data:image\/(\w+).*/i.exec(t));
                c = null != u ? u[1] : "png", this.pdf.addImage(t, c, l.x, l.y, l.w, l.h);
            },
            _matrix_multiply: function(t, e) {
                var n = e[0], r = e[1], i = e[2], o = e[3], a = e[4], s = e[5], h = n * t[0] + r * t[2], c = i * t[0] + o * t[2], l = a * t[0] + s * t[2] + t[4];
                return r = n * t[1] + r * t[3], o = i * t[1] + o * t[3], s = a * t[1] + s * t[3] + t[5], [
                    n = h,
                    r,
                    i = c,
                    o,
                    a = l,
                    s
                ];
            },
            _matrix_rotation: function(t) {
                return Math.atan2(t[2], t[0]);
            },
            _matrix_decompose: function(t) {
                var e = t[0], n = t[1], r = t[2], i = t[3], o = Math.sqrt(e * e + n * n), a = (e /= o) * r + (n /= o) * i;
                r -= e * a, i -= n * a;
                var s = Math.sqrt(r * r + i * i);
                return a /= s, e * (i /= s) < n * (r /= s) && (e = -e, n = -n, a = -a, o = -o), {
                    scale: [
                        o,
                        0,
                        0,
                        s,
                        0,
                        0
                    ],
                    translate: [
                        1,
                        0,
                        0,
                        1,
                        t[4],
                        t[5]
                    ],
                    rotate: [
                        e,
                        n,
                        -n,
                        e,
                        0,
                        0
                    ],
                    skew: [
                        1,
                        0,
                        a,
                        1,
                        0,
                        0
                    ]
                };
            },
            _matrix_map_point: function(t, e) {
                var n = t[0], r = t[1], i = t[2], o = t[3], a = t[4], s = t[5], h = e[0], c = e[1];
                return [
                    h * n + c * i + a,
                    h * r + c * o + s
                ];
            },
            _matrix_map_point_obj: function(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]);
                return {
                    x: n[0],
                    y: n[1]
                };
            },
            _matrix_map_rect: function(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]), r = this._matrix_map_point(t, [
                    e.x + e.w,
                    e.y + e.h
                ]);
                return {
                    x: n[0],
                    y: n[1],
                    w: r[0] - n[0],
                    h: r[1] - n[1]
                };
            },
            _matrix_is_identity: function(t) {
                return 1 == t[0] && 0 == t[1] && 0 == t[2] && 1 == t[3] && 0 == t[4] && 0 == t[5];
            },
            rotate: function(t) {
                var e = [
                    Math.cos(t),
                    Math.sin(t),
                    -Math.sin(t),
                    Math.cos(t),
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, e);
            },
            scale: function(t, e) {
                var n = [
                    t,
                    0,
                    0,
                    e,
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            translate: function(t, e) {
                var n = [
                    1,
                    0,
                    0,
                    1,
                    t,
                    e
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            stroke: function() {
                if (0 < this.ctx._clip_path.length) {
                    var t;
                    (t = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var e = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._stroke(!0), this.ctx._clip_path = this.path, this.path = e, this._stroke(!1), t.push("Q");
                } else this._stroke(!1);
            },
            _stroke: function(t) {
                if (t || !this._isStrokeTransparent()) {
                    for(var e = [], n = this.path, r = 0; r < n.length; r++){
                        var i = n[r];
                        switch(i.type){
                            case "mt":
                                e.push({
                                    start: i,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var o = [
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o), e[e.length - 1].abs.push(i);
                                break;
                            case "bct":
                                o = [
                                    i.x1 - n[r - 1].x,
                                    i.y1 - n[r - 1].y,
                                    i.x2 - n[r - 1].x,
                                    i.y2 - n[r - 1].y,
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "qct":
                                var a = n[r - 1].x + 2 / 3 * (i.x1 - n[r - 1].x), s = n[r - 1].y + 2 / 3 * (i.y1 - n[r - 1].y), h = i.x + 2 / 3 * (i.x1 - i.x), c = i.y + 2 / 3 * (i.y1 - i.y), l = i.x, u = i.y;
                                o = [
                                    a - n[r - 1].x,
                                    s - n[r - 1].y,
                                    h - n[r - 1].x,
                                    c - n[r - 1].y,
                                    l - n[r - 1].x,
                                    u - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "arc":
                                0 == e.length && e.push({
                                    start: {
                                        x: 0,
                                        y: 0
                                    },
                                    deltas: [],
                                    abs: []
                                }), e[e.length - 1].arc = !0, Array.isArray(e[e.length - 1].abs) && e[e.length - 1].abs.push(i);
                        }
                    }
                    for(r = 0; r < e.length; r++){
                        var f;
                        if (f = r == e.length - 1 ? "s" : null, e[r].arc) for(var d = e[r].abs, p = 0; p < d.length; p++){
                            var g = d[p], m = 360 * g.startAngle / (2 * Math.PI), w = 360 * g.endAngle / (2 * Math.PI), y = g.x, v = g.y;
                            this.internal.arc2(this, y, v, g.radius, m, w, g.anticlockwise, f, t);
                        }
                        else {
                            y = e[r].start.x, v = e[r].start.y;
                            t ? (this.pdf.lines(e[r].deltas, y, v, null, null), this.pdf.clip_fixed()) : this.pdf.lines(e[r].deltas, y, v, null, f);
                        }
                    }
                }
            },
            _isFillTransparent: function() {
                return this.ctx._isFillTransparent || 0 == this.globalAlpha;
            },
            _isStrokeTransparent: function() {
                return this.ctx._isStrokeTransparent || 0 == this.globalAlpha;
            },
            fill: function(t) {
                if (0 < this.ctx._clip_path.length) {
                    var e;
                    (e = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var n = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(t, !0), this.ctx._clip_path = this.path, this.path = n, this._fill(t, !1), e.push("Q");
                } else this._fill(t, !1);
            },
            _fill: function(t, e) {
                if (!this._isFillTransparent()) {
                    var n, r = "function" == typeof this.pdf.internal.newObject2;
                    n = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage();
                    var i = [], o = window.outIntercept;
                    if (r) switch(this.ctx.globalCompositeOperation){
                        case "normal":
                        case "source-over":
                            break;
                        case "destination-in":
                        case "destination-out":
                            var a = this.pdf.internal.newStreamObject(), s = this.pdf.internal.newObject2();
                            s.push("<</Type /ExtGState"), s.push("/SMask <</S /Alpha /G " + a.objId + " 0 R>>"), s.push(">>");
                            var h = "MASK" + s.objId;
                            this.pdf.internal.addGraphicsState(h, s.objId);
                            var c = "/" + h + " gs";
                            n.splice(0, 0, "q"), n.splice(1, 0, c), n.push("Q"), window.outIntercept = a;
                            break;
                        default:
                            var l = "/" + this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];
                            l && this.pdf.internal.out(l + " gs");
                    }
                    var u = this.ctx.globalAlpha;
                    if (this.ctx._fillOpacity < 1 && (u = this.ctx._fillOpacity), r) {
                        var f = this.pdf.internal.newObject2();
                        f.push("<</Type /ExtGState"), f.push("/CA " + u), f.push("/ca " + u), f.push(">>");
                        h = "GS_O_" + f.objId;
                        this.pdf.internal.addGraphicsState(h, f.objId), this.pdf.internal.out("/" + h + " gs");
                    }
                    for(var d = this.path, p = 0; p < d.length; p++){
                        var g = d[p];
                        switch(g.type){
                            case "mt":
                                i.push({
                                    start: g,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var m = [
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m), i[i.length - 1].abs.push(g);
                                break;
                            case "bct":
                                m = [
                                    g.x1 - d[p - 1].x,
                                    g.y1 - d[p - 1].y,
                                    g.x2 - d[p - 1].x,
                                    g.y2 - d[p - 1].y,
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "qct":
                                var w = d[p - 1].x + 2 / 3 * (g.x1 - d[p - 1].x), y = d[p - 1].y + 2 / 3 * (g.y1 - d[p - 1].y), v = g.x + 2 / 3 * (g.x1 - g.x), b = g.y + 2 / 3 * (g.y1 - g.y), x = g.x, S = g.y;
                                m = [
                                    w - d[p - 1].x,
                                    y - d[p - 1].y,
                                    v - d[p - 1].x,
                                    b - d[p - 1].y,
                                    x - d[p - 1].x,
                                    S - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "arc":
                                0 === i.length && i.push({
                                    deltas: [],
                                    abs: []
                                }), i[i.length - 1].arc = !0, Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(g);
                                break;
                            case "close":
                                i.push({
                                    close: !0
                                });
                        }
                    }
                    for(p = 0; p < i.length; p++){
                        var k;
                        if (p == i.length - 1 ? (k = "f", "evenodd" === t && (k += "*")) : k = null, i[p].close) this.pdf.internal.out("h"), k && this.pdf.internal.out(k);
                        else if (i[p].arc) {
                            i[p].start && this.internal.move2(this, i[p].start.x, i[p].start.y);
                            for(var _ = i[p].abs, A = 0; A < _.length; A++){
                                var I = _[A];
                                if (void 0 !== I.startAngle) {
                                    var C = 360 * I.startAngle / (2 * Math.PI), T = 360 * I.endAngle / (2 * Math.PI), F = I.x, P = I.y;
                                    if (0 === A && this.internal.move2(this, F, P), this.internal.arc2(this, F, P, I.radius, C, T, I.anticlockwise, null, e), A === _.length - 1 && i[p].start) {
                                        F = i[p].start.x, P = i[p].start.y;
                                        this.internal.line2(E, F, P);
                                    }
                                } else this.internal.line2(E, I.x, I.y);
                            }
                        } else {
                            F = i[p].start.x, P = i[p].start.y;
                            e ? (this.pdf.lines(i[p].deltas, F, P, null, null), this.pdf.clip_fixed()) : this.pdf.lines(i[p].deltas, F, P, null, k);
                        }
                    }
                    window.outIntercept = o;
                }
            },
            pushMask: function() {
                if ("function" == typeof this.pdf.internal.newObject2) {
                    var t = this.pdf.internal.newStreamObject(), e = this.pdf.internal.newObject2();
                    e.push("<</Type /ExtGState"), e.push("/SMask <</S /Alpha /G " + t.objId + " 0 R>>"), e.push(">>");
                    var n = "MASK" + e.objId;
                    this.pdf.internal.addGraphicsState(n, e.objId);
                    var r = "/" + n + " gs";
                    this.pdf.internal.out(r);
                } else console.log("jsPDF v2 not enabled");
            },
            clip: function() {
                if (0 < this.ctx._clip_path.length) for(var t = 0; t < this.path.length; t++)this.ctx._clip_path.push(this.path[t]);
                else this.ctx._clip_path = this.path;
                this.path = [];
            },
            measureText: function(n) {
                var r = this.pdf;
                return {
                    getWidth: function() {
                        var t = r.internal.getFontSize(), e = r.getStringUnitWidth(n) * t / r.internal.scaleFactor;
                        return e *= 1.3333;
                    },
                    get width () {
                        return this.getWidth(n);
                    }
                };
            },
            _getBaseline: function(t) {
                var e = parseInt(this.pdf.internal.getFontSize()), n = .25 * e;
                switch(this.ctx.textBaseline){
                    case "bottom":
                        return t - n;
                    case "top":
                        return t + e;
                    case "hanging":
                        return t + e - n;
                    case "middle":
                        return t + e / 2 - n;
                    case "ideographic":
                        return t;
                    case "alphabetic":
                    default:
                        return t;
                }
            }
        };
        var E = t.context2d;
        function e() {
            this._isStrokeTransparent = !1, this._strokeOpacity = 1, this.strokeStyle = "#000000", this.fillStyle = "#000000", this._isFillTransparent = !1, this._fillOpacity = 1, this.font = "12pt times", this.textBaseline = "alphabetic", this.textAlign = "start", this.lineWidth = 1, this.lineJoin = "miter", this.lineCap = "butt", this._transform = [
                1,
                0,
                0,
                1,
                0,
                0
            ], this.globalCompositeOperation = "normal", this.globalAlpha = 1, this._clip_path = [], this.ignoreClearRect = !1, this.copy = function(t) {
                this._isStrokeTransparent = t._isStrokeTransparent, this._strokeOpacity = t._strokeOpacity, this.strokeStyle = t.strokeStyle, this._isFillTransparent = t._isFillTransparent, this._fillOpacity = t._fillOpacity, this.fillStyle = t.fillStyle, this.font = t.font, this.lineWidth = t.lineWidth, this.lineJoin = t.lineJoin, this.lineCap = t.lineCap, this.textBaseline = t.textBaseline, this.textAlign = t.textAlign, this._fontSize = t._fontSize, this._transform = t._transform.slice(0), this.globalCompositeOperation = t.globalCompositeOperation, this.globalAlpha = t.globalAlpha, this._clip_path = t._clip_path.slice(0), this.ignoreClearRect = t.ignoreClearRect;
            };
        }
        Object.defineProperty(E, "fillStyle", {
            set: function(t) {
                this.setFillStyle(t);
            },
            get: function() {
                return this.ctx.fillStyle;
            }
        }), Object.defineProperty(E, "strokeStyle", {
            set: function(t) {
                this.setStrokeStyle(t);
            },
            get: function() {
                return this.ctx.strokeStyle;
            }
        }), Object.defineProperty(E, "lineWidth", {
            set: function(t) {
                this.setLineWidth(t);
            },
            get: function() {
                return this.ctx.lineWidth;
            }
        }), Object.defineProperty(E, "lineCap", {
            set: function(t) {
                this.setLineCap(t);
            },
            get: function() {
                return this.ctx.lineCap;
            }
        }), Object.defineProperty(E, "lineJoin", {
            set: function(t) {
                this.setLineJoin(t);
            },
            get: function() {
                return this.ctx.lineJoin;
            }
        }), Object.defineProperty(E, "miterLimit", {
            set: function(t) {
                this.ctx.miterLimit = t;
            },
            get: function() {
                return this.ctx.miterLimit;
            }
        }), Object.defineProperty(E, "textBaseline", {
            set: function(t) {
                this.setTextBaseline(t);
            },
            get: function() {
                return this.getTextBaseline();
            }
        }), Object.defineProperty(E, "textAlign", {
            set: function(t) {
                this.setTextAlign(t);
            },
            get: function() {
                return this.getTextAlign();
            }
        }), Object.defineProperty(E, "font", {
            set: function(t) {
                this.setFont(t);
            },
            get: function() {
                return this.ctx.font;
            }
        }), Object.defineProperty(E, "globalCompositeOperation", {
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            },
            get: function() {
                return this.ctx.globalCompositeOperation;
            }
        }), Object.defineProperty(E, "globalAlpha", {
            set: function(t) {
                this.ctx.globalAlpha = t;
            },
            get: function() {
                return this.ctx.globalAlpha;
            }
        }), Object.defineProperty(E, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        }), Object.defineProperty(E, "ignoreClearRect", {
            set: function(t) {
                this.ctx.ignoreClearRect = t;
            },
            get: function() {
                return this.ctx.ignoreClearRect;
            }
        }), E.internal = {}, E.internal.rxRgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, E.internal.rxRgba = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/, E.internal.rxTransparent = /transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/, E.internal.arc = function(t, e, n, r, i, o, a, s) {
            for(var h = this.pdf.internal.scaleFactor, c = this.pdf.internal.pageSize.getHeight(), l = this.pdf.internal.f2, u = i * (Math.PI / 180), f = o * (Math.PI / 180), d = this.createArc(r, u, f, a), p = 0; p < d.length; p++){
                var g = d[p];
                0 === p ? this.pdf.internal.out([
                    l((g.x1 + e) * h),
                    l((c - (g.y1 + n)) * h),
                    "m",
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")) : this.pdf.internal.out([
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")), t._lastPoint = {
                    x: e,
                    y: n
                };
            }
            null !== s && this.pdf.internal.out(this.pdf.internal.getStyle(s));
        }, E.internal.arc2 = function(t, e, n, r, i, o, a, s, h) {
            var c = e, l = n;
            h ? (this.arc(t, c, l, r, i, o, a, null), this.pdf.clip_fixed()) : this.arc(t, c, l, r, i, o, a, s);
        }, E.internal.move2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2;
            this.pdf.internal.out([
                o(e * r),
                o((i - n) * r),
                "m"
            ].join(" ")), t._lastPoint = {
                x: e,
                y: n
            };
        }, E.internal.line2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2, a = {
                x: e,
                y: n
            };
            this.pdf.internal.out([
                o(a.x * r),
                o((i - a.y) * r),
                "l"
            ].join(" ")), t._lastPoint = a;
        }, E.internal.createArc = function(t, e, n, r) {
            var i = 2 * Math.PI, o = Math.PI / 2, a = e;
            for((a < i || i < a) && (a %= i), a < 0 && (a = i + a); n < e;)e -= i;
            var s = Math.abs(n - e);
            s < i && r && (s = i - s);
            for(var h = [], c = r ? -1 : 1, l = a; 1e-5 < s;){
                var u = l + c * Math.min(s, o);
                h.push(this.createSmallArc(t, l, u)), s -= Math.abs(u - l), l = u;
            }
            return h;
        }, E.internal.getCurrentPage = function() {
            return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber];
        }, E.internal.createSmallArc = function(t, e, n) {
            var r = (n - e) / 2, i = t * Math.cos(r), o = t * Math.sin(r), a = i, s = -o, h = a * a + s * s, c = h + a * i + s * o, l = 4 / 3 * (Math.sqrt(2 * h * c) - c) / (a * o - s * i), u = a - l * s, f = s + l * a, d = u, p = -f, g = r + e, m = Math.cos(g), w = Math.sin(g);
            return {
                x1: t * Math.cos(e),
                y1: t * Math.sin(e),
                x2: u * m - f * w,
                y2: u * w + f * m,
                x3: d * m - p * w,
                y3: d * w + p * m,
                x4: t * Math.cos(n),
                y4: t * Math.sin(n)
            };
        };
    }($.API, "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /** @preserve
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * 
   * ====================================================================
   */ function(t) {
        var T, F, i, a, s, h, c, l, P, v, f, u, d, n, E, q, p, g, m, O;
        T = function() {
            return function(t) {
                return e.prototype = t, new e;
            };
            function e() {}
        }(), v = function(t) {
            var e, n, r, i, o, a, s;
            for(n = 0, r = t.length, e = void 0, a = i = !1; !i && n !== r;)(e = t[n] = t[n].trimLeft()) && (i = !0), n++;
            for(n = r - 1; r && !a && -1 !== n;)(e = t[n] = t[n].trimRight()) && (a = !0), n--;
            for(o = /\s+$/g, s = !0, n = 0; n !== r;)"\u2028" != t[n] && (e = t[n].replace(/\s+/g, " "), s && (e = e.trimLeft()), e && (s = o.test(e)), t[n] = e), n++;
            return t;
        }, u = function(t) {
            var e, n, r;
            for(e = void 0, n = (r = t.split(",")).shift(); !e && n;)e = i[n.trim().toLowerCase()], n = r.shift();
            return e;
        }, d = function(t) {
            var e;
            return -1 < (t = "auto" === t ? "0px" : t).indexOf("em") && !isNaN(Number(t.replace("em", ""))) && (t = 18.719 * Number(t.replace("em", "")) + "px"), -1 < t.indexOf("pt") && !isNaN(Number(t.replace("pt", ""))) && (t = 1.333 * Number(t.replace("pt", "")) + "px"), (e = n[t]) ? e : void 0 !== (e = ({
                "xx-small": 9,
                "x-small": 11,
                small: 13,
                medium: 16,
                large: 19,
                "x-large": 23,
                "xx-large": 28,
                auto: 0
            })[t]) ? n[t] = e / 16 : (e = parseFloat(t)) ? n[t] = e / 16 : (e = t.match(/([\d\.]+)(px)/), Array.isArray(e) && 3 === e.length ? n[t] = parseFloat(e[1]) / 16 : n[t] = 1);
        }, P = function(t) {
            var e, n, r, i, o;
            return o = t, i = document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(o, null) : o.currentStyle ? o.currentStyle : o.style, n = void 0, (e = {})["font-family"] = u((r = function(t) {
                return t = t.replace(/-\D/g, function(t) {
                    return t.charAt(1).toUpperCase();
                }), i[t];
            })("font-family")) || "times", e["font-style"] = a[r("font-style")] || "normal", e["text-align"] = s[r("text-align")] || "left", "bold" === (n = h[r("font-weight")] || "normal") && ("normal" === e["font-style"] ? e["font-style"] = n : e["font-style"] = n + e["font-style"]), e["font-size"] = d(r("font-size")) || 1, e["line-height"] = d(r("line-height")) || 1, e.display = "inline" === r("display") ? "inline" : "block", n = "block" === e.display, e["margin-top"] = n && d(r("margin-top")) || 0, e["margin-bottom"] = n && d(r("margin-bottom")) || 0, e["padding-top"] = n && d(r("padding-top")) || 0, e["padding-bottom"] = n && d(r("padding-bottom")) || 0, e["margin-left"] = n && d(r("margin-left")) || 0, e["margin-right"] = n && d(r("margin-right")) || 0, e["padding-left"] = n && d(r("padding-left")) || 0, e["padding-right"] = n && d(r("padding-right")) || 0, e["page-break-before"] = r("page-break-before") || "auto", e.float = c[r("cssFloat")] || "none", e.clear = l[r("clear")] || "none", e.color = r("color"), e;
        }, E = function(t, e, n) {
            var r, i, o, a, s;
            if (o = !1, a = i = void 0, r = n["#" + t.id]) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            if (r = n[t.nodeName], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            for(s = "string" == typeof t.className ? t.className.split(" ") : [], i = 0; i < s.length; i++)if (r = n["." + s[i]], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            return o;
        }, O = function(t, e) {
            var n, r, i, o, a, s, h, c, l;
            for(n = [], r = [], i = 0, l = t.rows[0].cells.length, h = t.clientWidth; i < l;)c = t.rows[0].cells[i], r[i] = {
                name: c.textContent.toLowerCase().replace(/\s+/g, ""),
                prompt: c.textContent.replace(/\r?\n/g, ""),
                width: c.clientWidth / h * e.pdf.internal.pageSize.getWidth()
            }, i++;
            for(i = 1; i < t.rows.length;){
                for(s = t.rows[i], a = {}, o = 0; o < s.cells.length;)a[r[o].name] = s.cells[o].textContent.replace(/\r?\n/g, ""), o++;
                n.push(a), i++;
            }
            return {
                rows: n,
                headers: r
            };
        };
        var B = {
            SCRIPT: 1,
            STYLE: 1,
            NOSCRIPT: 1,
            OBJECT: 1,
            EMBED: 1,
            SELECT: 1
        }, R = 1;
        F = function(t, i, e) {
            var n, r, o, a, s, h, c, l;
            for(r = t.childNodes, n = void 0, (s = "block" === (o = P(t)).display) && (i.setBlockBoundary(), i.setBlockStyle(o)), a = 0, h = r.length; a < h;){
                if ("object" === (void 0 === (n = r[a]) ? "undefined" : vt(n))) {
                    if (i.executeWatchFunctions(n), 1 === n.nodeType && "HEADER" === n.nodeName) {
                        var u = n, f = i.pdf.margins_doc.top;
                        i.pdf.internal.events.subscribe("addPage", function(t) {
                            i.y = f, F(u, i, e), i.pdf.margins_doc.top = i.y + 10, i.y += 10;
                        }, !1);
                    }
                    if (8 === n.nodeType && "#comment" === n.nodeName) ~n.textContent.indexOf("ADD_PAGE") && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top);
                    else if (1 !== n.nodeType || B[n.nodeName]) {
                        if (3 === n.nodeType) {
                            var d = n.nodeValue;
                            if (n.nodeValue && "LI" === n.parentNode.nodeName) {
                                if ("OL" === n.parentNode.parentNode.nodeName) d = R++ + ". " + d;
                                else {
                                    var p = o["font-size"], g = (3 - .75 * p) * i.pdf.internal.scaleFactor, m = .75 * p * i.pdf.internal.scaleFactor, w = 1.74 * p / i.pdf.internal.scaleFactor;
                                    l = function(t, e) {
                                        this.pdf.circle(t + g, e + m, w, "FD");
                                    };
                                }
                            }
                            16 & n.ownerDocument.body.compareDocumentPosition(n) && i.addText(d, o);
                        } else "string" == typeof n && i.addText(n, o);
                    } else {
                        var y;
                        if ("IMG" === n.nodeName) {
                            var v = n.getAttribute("src");
                            y = q[i.pdf.sHashCode(v) || v];
                        }
                        if (y) {
                            i.pdf.internal.pageSize.getHeight() - i.pdf.margins_doc.bottom < i.y + n.height && i.y > i.pdf.margins_doc.top && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top, i.executeWatchFunctions(n));
                            var b = P(n), x = i.x, S = 12 / i.pdf.internal.scaleFactor, k = (b["margin-left"] + b["padding-left"]) * S, _ = (b["margin-right"] + b["padding-right"]) * S, A = (b["margin-top"] + b["padding-top"]) * S, I = (b["margin-bottom"] + b["padding-bottom"]) * S;
                            void 0 !== b.float && "right" === b.float ? x += i.settings.width - n.width - _ : x += k, i.pdf.addImage(y, x, i.y + A, n.width, n.height), y = void 0, "right" === b.float || "left" === b.float ? (i.watchFunctions.push((function(t, e, n, r) {
                                return i.y >= e ? (i.x += t, i.settings.width += n, !0) : !!(r && 1 === r.nodeType && !B[r.nodeName] && i.x + r.width > i.pdf.margins_doc.left + i.pdf.margins_doc.width) && (i.x += t, i.y = e, i.settings.width += n, !0);
                            }).bind(this, "left" === b.float ? -n.width - k - _ : 0, i.y + n.height + A + I, n.width)), i.watchFunctions.push((function(t, e, n) {
                                return !(i.y < t && e === i.pdf.internal.getNumberOfPages()) || 1 === n.nodeType && "both" === P(n).clear && (i.y = t, !0);
                            }).bind(this, i.y + n.height, i.pdf.internal.getNumberOfPages())), i.settings.width -= n.width + k + _, "left" === b.float && (i.x += n.width + k + _)) : i.y += n.height + A + I;
                        } else if ("TABLE" === n.nodeName) c = O(n, i), i.y += 10, i.pdf.table(i.x, i.y, c.rows, c.headers, {
                            autoSize: !1,
                            printHeaders: e.printHeaders,
                            margins: i.pdf.margins_doc,
                            css: P(n)
                        }), i.y = i.pdf.lastCellPos.y + i.pdf.lastCellPos.h + 20;
                        else if ("OL" === n.nodeName || "UL" === n.nodeName) R = 1, E(n, i, e) || F(n, i, e), i.y += 10;
                        else if ("LI" === n.nodeName) {
                            var C = i.x;
                            i.x += 20 / i.pdf.internal.scaleFactor, i.y += 3, E(n, i, e) || F(n, i, e), i.x = C;
                        } else "BR" === n.nodeName ? (i.y += o["font-size"] * i.pdf.internal.scaleFactor, i.addText("\u2028", T(o))) : E(n, i, e) || F(n, i, e);
                    }
                }
                a++;
            }
            if (e.outY = i.y, s) return i.setBlockBoundary(l);
        }, q = {}, p = function(t, o, e, n) {
            var a, r = t.getElementsByTagName("img"), i = r.length, s = 0;
            function h() {
                o.pdf.internal.events.publish("imagesLoaded"), n(a);
            }
            function c(e, n, r) {
                if (e) {
                    var i = new Image;
                    a = ++s, i.crossOrigin = "", i.onerror = i.onload = function() {
                        if (i.complete && (0 === i.src.indexOf("data:image/") && (i.width = n || i.width || 0, i.height = r || i.height || 0), i.width + i.height)) {
                            var t = o.pdf.sHashCode(e) || e;
                            q[t] = q[t] || i;
                        }
                        --s || h();
                    }, i.src = e;
                }
            }
            for(; i--;)c(r[i].getAttribute("src"), r[i].width, r[i].height);
            return s || h();
        }, g = function(t, o, a) {
            var s = t.getElementsByTagName("footer");
            if (0 < s.length) {
                s = s[0];
                var e = o.pdf.internal.write, n = o.y;
                o.pdf.internal.write = function() {}, F(s, o, a);
                var h = Math.ceil(o.y - n) + 5;
                o.y = n, o.pdf.internal.write = e, o.pdf.margins_doc.bottom += h;
                for(var r = function(t) {
                    var e = void 0 !== t ? t.pageNumber : 1, n = o.y;
                    o.y = o.pdf.internal.pageSize.getHeight() - o.pdf.margins_doc.bottom, o.pdf.margins_doc.bottom -= h;
                    for(var r = s.getElementsByTagName("span"), i = 0; i < r.length; ++i)-1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" pageCounter ") && (r[i].innerHTML = e), -1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && (r[i].innerHTML = "###jsPDFVarTotalPages###");
                    F(s, o, a), o.pdf.margins_doc.bottom += h, o.y = n;
                }, i = s.getElementsByTagName("span"), c = 0; c < i.length; ++c)-1 < (" " + i[c].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && o.pdf.internal.events.subscribe("htmlRenderingFinished", o.pdf.putTotalPages.bind(o.pdf, "###jsPDFVarTotalPages###"), !0);
                o.pdf.internal.events.subscribe("addPage", r, !1), r(), B.FOOTER = 1;
            }
        }, m = function(t, e, n, r, i, o) {
            if (!e) return !1;
            var a, s, h, c;
            "string" == typeof e || e.parentNode || (e = "" + e.innerHTML), "string" == typeof e && (a = e.replace(/<\/?script[^>]*?>/gi, ""), c = "jsPDFhtmlText" + Date.now().toString() + (1e3 * Math.random()).toFixed(0), (h = document.createElement("div")).style.cssText = "position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;", h.innerHTML = '<iframe style="height:1px;width:1px" name="' + c + '" />', document.body.appendChild(h), (s = window.frames[c]).document.open(), s.document.writeln(a), s.document.close(), e = s.document.body);
            var l, u = new f(t, n, r, i);
            return p.call(this, e, u, i.elementHandlers, function(t) {
                g(e, u, i.elementHandlers), F(e, u, i.elementHandlers), u.pdf.internal.events.publish("htmlRenderingFinished"), l = u.dispose(), "function" == typeof o ? o(l) : t && console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!");
            }), l || {
                x: u.x,
                y: u.y
            };
        }, (f = function(t, e, n, r) {
            return this.pdf = t, this.x = e, this.y = n, this.settings = r, this.watchFunctions = [], this.init(), this;
        }).prototype.init = function() {
            return this.paragraph = {
                text: [],
                style: []
            }, this.pdf.internal.write("q");
        }, f.prototype.dispose = function() {
            return this.pdf.internal.write("Q"), {
                x: this.x,
                y: this.y,
                ready: !0
            };
        }, f.prototype.executeWatchFunctions = function(t) {
            var e = !1, n = [];
            if (0 < this.watchFunctions.length) {
                for(var r = 0; r < this.watchFunctions.length; ++r)!0 === this.watchFunctions[r](t) ? e = !0 : n.push(this.watchFunctions[r]);
                this.watchFunctions = n;
            }
            return e;
        }, f.prototype.splitFragmentsIntoLines = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f, d, p, g;
            for(u = this.pdf.internal.scaleFactor, o = {}, s = h = c = g = a = i = l = r = void 0, d = [
                f = []
            ], n = 0, p = this.settings.width; t.length;)if (a = t.shift(), g = e.shift(), a) {
                if ((i = o[(r = g["font-family"]) + (l = g["font-style"])]) || (i = this.pdf.internal.getFont(r, l).metadata.Unicode, o[r + l] = i), c = {
                    widths: i.widths,
                    kerning: i.kerning,
                    fontSize: 12 * g["font-size"],
                    textIndent: n
                }, h = this.pdf.getStringUnitWidth(a, c) * c.fontSize / u, "\u2028" == a) f = [], d.push(f);
                else if (p < n + h) {
                    for(s = this.pdf.splitTextToSize(a, p, c), f.push([
                        s.shift(),
                        g
                    ]); s.length;)f = [
                        [
                            s.shift(),
                            g
                        ]
                    ], d.push(f);
                    n = this.pdf.getStringUnitWidth(f[0][0], c) * c.fontSize / u;
                } else f.push([
                    a,
                    g
                ]), n += h;
            }
            if (void 0 !== g["text-align"] && ("center" === g["text-align"] || "right" === g["text-align"] || "justify" === g["text-align"])) for(var m = 0; m < d.length; ++m){
                var w = this.pdf.getStringUnitWidth(d[m][0][0], c) * c.fontSize / u;
                0 < m && (d[m][0][1] = T(d[m][0][1]));
                var y = p - w;
                if ("right" === g["text-align"]) d[m][0][1]["margin-left"] = y;
                else if ("center" === g["text-align"]) d[m][0][1]["margin-left"] = y / 2;
                else if ("justify" === g["text-align"]) {
                    var v = d[m][0][0].split(" ").length - 1;
                    d[m][0][1]["word-spacing"] = y / v, m === d.length - 1 && (d[m][0][1]["word-spacing"] = 0);
                }
            }
            return d;
        }, f.prototype.RenderTextFragment = function(t, e) {
            var n, r;
            r = 0, this.pdf.internal.pageSize.getHeight() - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize() && (this.pdf.internal.write("ET", "Q"), this.pdf.addPage(), this.y = this.pdf.margins_doc.top, this.pdf.internal.write("q", "BT", this.getPdfColor(e.color), this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td"), r = Math.max(r, e["line-height"], e["font-size"]), this.pdf.internal.write(0, (-12 * r).toFixed(2), "Td")), n = this.pdf.internal.getFont(e["font-family"], e["font-style"]);
            var i = this.getPdfColor(e.color);
            i !== this.lastTextColor && (this.pdf.internal.write(i), this.lastTextColor = i), void 0 !== e["word-spacing"] && 0 < e["word-spacing"] && this.pdf.internal.write(e["word-spacing"].toFixed(2), "Tw"), this.pdf.internal.write("/" + n.id, (12 * e["font-size"]).toFixed(2), "Tf", "(" + this.pdf.internal.pdfEscape(t) + ") Tj"), void 0 !== e["word-spacing"] && this.pdf.internal.write(0, "Tw");
        }, f.prototype.getPdfColor = function(t) {
            var e, n, r, i = new RGBColor(t), o = /rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);
            if (null != o ? (e = parseInt(o[1]), n = parseInt(o[2]), r = parseInt(o[3])) : ("#" != t.charAt(0) && (t = i.ok ? i.toHex() : "#000000"), e = t.substring(1, 3), e = parseInt(e, 16), n = t.substring(3, 5), n = parseInt(n, 16), r = t.substring(5, 7), r = parseInt(r, 16)), "string" == typeof e && /^#[0-9A-Fa-f]{6}$/.test(e)) {
                var a = parseInt(e.substr(1), 16);
                e = a >> 16 & 255, n = a >> 8 & 255, r = 255 & a;
            }
            var s = this.f3;
            return 0 === e && 0 === n && 0 === r || void 0 === n ? s(e / 255) + " g" : [
                s(e / 255),
                s(n / 255),
                s(r / 255),
                "rg"
            ].join(" ");
        }, f.prototype.f3 = function(t) {
            return t.toFixed(3);
        }, f.prototype.renderParagraph = function(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d;
            if (r = v(this.paragraph.text), f = this.paragraph.style, e = this.paragraph.blockstyle, this.paragraph.priorblockstyle, this.paragraph = {
                text: [],
                style: [],
                blockstyle: {},
                priorblockstyle: e
            }, r.join("").trim()) {
                s = this.splitFragmentsIntoLines(r, f), h = a = void 0, n = 12 / this.pdf.internal.scaleFactor, this.priorMarginBottom = this.priorMarginBottom || 0, u = (Math.max((e["margin-top"] || 0) - this.priorMarginBottom, 0) + (e["padding-top"] || 0)) * n, l = ((e["margin-bottom"] || 0) + (e["padding-bottom"] || 0)) * n, this.priorMarginBottom = e["margin-bottom"] || 0, "always" === e["page-break-before"] && (this.pdf.addPage(), this.y = 0, u = ((e["margin-top"] || 0) + (e["padding-top"] || 0)) * n), c = this.pdf.internal.write, o = i = void 0, this.y += u, c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                for(var p = 0; s.length;){
                    for(i = h = 0, o = (a = s.shift()).length; i !== o;)a[i][0].trim() && (h = Math.max(h, a[i][1]["line-height"], a[i][1]["font-size"]), d = 7 * a[i][1]["font-size"]), i++;
                    var g = 0, m = 0;
                    for(void 0 !== a[0][1]["margin-left"] && 0 < a[0][1]["margin-left"] && (g = (m = this.pdf.internal.getCoordinateString(a[0][1]["margin-left"])) - p, p = m), c(g + Math.max(e["margin-left"] || 0, 0) * n, (-12 * h).toFixed(2), "Td"), i = 0, o = a.length; i !== o;)a[i][0] && this.RenderTextFragment(a[i][0], a[i][1]), i++;
                    if (this.y += h * n, this.executeWatchFunctions(a[0][1]) && 0 < s.length) {
                        var w = [], y = [];
                        s.forEach(function(t) {
                            for(var e = 0, n = t.length; e !== n;)t[e][0] && (w.push(t[e][0] + " "), y.push(t[e][1])), ++e;
                        }), s = this.splitFragmentsIntoLines(v(w), y), c("ET", "Q"), c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                    }
                }
                return t && "function" == typeof t && t.call(this, this.x - 9, this.y - d / 2), c("ET", "Q"), this.y += l;
            }
        }, f.prototype.setBlockBoundary = function(t) {
            return this.renderParagraph(t);
        }, f.prototype.setBlockStyle = function(t) {
            return this.paragraph.blockstyle = t;
        }, f.prototype.addText = function(t, e) {
            return this.paragraph.text.push(t), this.paragraph.style.push(e);
        }, i = {
            helvetica: "helvetica",
            "sans-serif": "helvetica",
            "times new roman": "times",
            serif: "times",
            times: "times",
            monospace: "courier",
            courier: "courier"
        }, h = {
            100: "normal",
            200: "normal",
            300: "normal",
            400: "normal",
            500: "bold",
            600: "bold",
            700: "bold",
            800: "bold",
            900: "bold",
            normal: "normal",
            bold: "bold",
            bolder: "bold",
            lighter: "normal"
        }, a = {
            normal: "normal",
            italic: "italic",
            oblique: "italic"
        }, s = {
            left: "left",
            right: "right",
            center: "center",
            justify: "justify"
        }, c = {
            none: "none",
            right: "right",
            left: "left"
        }, l = {
            none: "none",
            both: "both"
        }, n = {
            normal: 1
        }, t.fromHTML = function(t, e, n, r, i, o) {
            return this.margins_doc = o || {
                top: 0,
                bottom: 0
            }, r || (r = {}), r.elementHandlers || (r.elementHandlers = {}), m(this, t, isNaN(e) ? 4 : e, isNaN(n) ? 4 : n, r, i);
        };
    }($.API), $.API.addJS = function(t) {
        return s = t, this.internal.events.subscribe("postPutResources", function(t) {
            n = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (n + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), r = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + s + ")"), this.internal.out(">>"), this.internal.out("endobj");
        }), this.internal.events.subscribe("putCatalog", function() {
            void 0 !== n && void 0 !== r && this.internal.out("/Names <</JavaScript " + n + " 0 R>>");
        }), this;
    }, /**
   * jsPDF Outline PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (c = $.API).events.push([
        "postPutResources",
        function() {
            var t = this, e = /^(\d+) 0 obj$/;
            if (0 < this.outline.root.children.length) for(var n = t.outline.render().split(/\r\n/), r = 0; r < n.length; r++){
                var i = n[r], o = e.exec(i);
                if (null != o) {
                    var a = o[1];
                    t.internal.newObjectDeferredBegin(a);
                }
                t.internal.write(i);
            }
            if (this.outline.createNamedDestinations) {
                var s = this.internal.pages.length, h = [];
                for(r = 0; r < s; r++){
                    var c = t.internal.newObject();
                    h.push(c);
                    var l = t.internal.getPageInfo(r + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var u = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), r = 0; r < h.length; r++)t.internal.write("(page_" + (r + 1) + ")" + h[r] + " 0 R");
                t.internal.write(" ] >>", "endobj"), t.internal.newObject(), t.internal.write("<< /Dests " + u + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), c.events.push([
        "putCatalog",
        function() {
            0 < this.outline.root.children.length && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + namesOid + " 0 R"));
        }
    ]), c.events.push([
        "initialized",
        function() {
            var o = this;
            o.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, o.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, o.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = o, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, o.outline.genIds_r = function(t) {
                t.id = o.internal.newObjectDeferred();
                for(var e = 0; e < t.children.length; e++)this.genIds_r(t.children[e]);
            }, o.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), 0 < t.children.length && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, o.outline.renderItems = function(t) {
                for(var e = 0; e < t.children.length; e++){
                    var n = t.children[e];
                    this.objStart(n), this.line("/Title " + this.makeString(n.title)), this.line("/Parent " + this.makeRef(t)), 0 < e && this.line("/Prev " + this.makeRef(t.children[e - 1])), e < t.children.length - 1 && this.line("/Next " + this.makeRef(t.children[e + 1])), 0 < n.children.length && (this.line("/First " + this.makeRef(n.children[0])), this.line("/Last " + this.makeRef(n.children[n.children.length - 1])));
                    var r = this.count = this.count_r({
                        count: 0
                    }, n);
                    if (0 < r && this.line("/Count " + r), n.options && n.options.pageNumber) {
                        var i = o.internal.getPageInfo(n.options.pageNumber);
                        this.line("/Dest [" + i.objId + " 0 R /XYZ 0 " + this.ctx.pdf.internal.pageSize.getHeight() * this.ctx.pdf.internal.scaleFactor + " 0]");
                    }
                    this.objEnd();
                }
                for(e = 0; e < t.children.length; e++)n = t.children[e], this.renderItems(n);
            }, o.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, o.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, o.outline.makeString = function(t) {
                return "(" + o.internal.pdfEscape(t) + ")";
            }, o.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, o.outline.objEnd = function(t) {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, o.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]), /**@preserve
   *  ====================================================================
   * jsPDF PNG PlugIn
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */ P = $.API, E = function() {
        var t = "function" == typeof Deflater;
        if (!t) throw new Error("requires deflate.js for compression");
        return t;
    }, q = function(t, e, n, r) {
        var i = 5, o = b;
        switch(r){
            case P.image_compression.FAST:
                i = 3, o = v;
                break;
            case P.image_compression.MEDIUM:
                i = 6, o = x;
                break;
            case P.image_compression.SLOW:
                i = 9, o = S;
        }
        t = w(t, e, n, o);
        var a = new Uint8Array(g(i)), s = m(t), h = new Deflater(i), c = h.append(t), l = h.flush(), u = a.length + c.length + l.length, f = new Uint8Array(u + 4);
        return f.set(a), f.set(c, a.length), f.set(l, a.length + c.length), f[u++] = s >>> 24 & 255, f[u++] = s >>> 16 & 255, f[u++] = s >>> 8 & 255, f[u++] = 255 & s, P.arrayBufferToBinaryString(f);
    }, g = function(t, e) {
        var n = Math.LOG2E * Math.log(32768) - 8 << 4 | 8, r = n << 8;
        return r |= Math.min(3, (e - 1 & 255) >> 1) << 6, r |= 0, [
            n,
            255 & (r += 31 - r % 31)
        ];
    }, m = function(t, e) {
        for(var n, r = 1, i = 0, o = t.length, a = 0; 0 < o;){
            for(o -= n = e < o ? e : o; i += r += t[a++], --n;);
            r %= 65521, i %= 65521;
        }
        return (i << 16 | r) >>> 0;
    }, w = function(t, e, n, r) {
        for(var i, o, a, s = t.length / e, h = new Uint8Array(t.length + s), c = k(), l = 0; l < s; l++){
            if (a = l * e, i = t.subarray(a, a + e), r) h.set(r(i, n, o), a + l);
            else {
                for(var u = 0, f = c.length, d = []; u < f; u++)d[u] = c[u](i, n, o);
                var p = _(d.concat());
                h.set(d[p], a + l);
            }
            o = i;
        }
        return h;
    }, l = function(t, e, n) {
        var r = Array.apply([], t);
        return r.unshift(0), r;
    }, v = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 1; o < a; o++)r = t[o - e] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, b = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 2; o < a; o++)r = n && n[o] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, x = function(t, e, n) {
        var r, i, o = [], a = 0, s = t.length;
        for(o[0] = 3; a < s; a++)r = t[a - e] || 0, i = n && n[a] || 0, o[a + 1] = t[a] + 256 - (r + i >>> 1) & 255;
        return o;
    }, S = function(t, e, n) {
        var r, i, o, a, s = [], h = 0, c = t.length;
        for(s[0] = 4; h < c; h++)r = t[h - e] || 0, i = n && n[h] || 0, o = n && n[h - e] || 0, a = u(r, i, o), s[h + 1] = t[h] - a + 256 & 255;
        return s;
    }, u = function(t, e, n) {
        var r = t + e - n, i = Math.abs(r - t), o = Math.abs(r - e), a = Math.abs(r - n);
        return i <= o && i <= a ? t : o <= a ? e : n;
    }, k = function() {
        return [
            l,
            v,
            b,
            x,
            S
        ];
    }, _ = function(t) {
        for(var e, n, r, i = 0, o = t.length; i < o;)((e = f(t[i].slice(1))) < n || !n) && (n = e, r = i), i++;
        return r;
    }, f = function(t) {
        for(var e = 0, n = t.length, r = 0; e < n;)r += Math.abs(t[e++]);
        return r;
    }, P.processPNG = function(t, e, n, r, i) {
        var o, a, s, h, c, l, u = this.color_spaces.DEVICE_RGB, f = this.decode.FLATE_DECODE, d = 8;
        if (this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t)) {
            if ("function" != typeof PNG || "function" != typeof kt) throw new Error("PNG support requires png.js and zlib.js");
            if (t = (o = new PNG(t)).imgData, d = o.bits, u = o.colorSpace, h = o.colors, -1 !== [
                4,
                6
            ].indexOf(o.colorType)) {
                if (8 === o.bits) for(var p, g = (I = 32 == o.pixelBitlength ? new Uint32Array(o.decodePixels().buffer) : 16 == o.pixelBitlength ? new Uint16Array(o.decodePixels().buffer) : new Uint8Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * o.colors), w = new Uint8Array(g), y = o.pixelBitlength - o.bits, v = 0, b = 0; v < g; v++){
                    for(x = I[v], p = 0; p < y;)m[b++] = x >>> p & 255, p += o.bits;
                    w[v] = x >>> p & 255;
                }
                if (16 === o.bits) {
                    g = (I = new Uint32Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * (32 / o.pixelBitlength) * o.colors), w = new Uint8Array(g * (32 / o.pixelBitlength));
                    for(var x, S = 1 < o.colors, k = b = v = 0; v < g;)x = I[v++], m[b++] = x >>> 0 & 255, S && (m[b++] = x >>> 16 & 255, x = I[v++], m[b++] = x >>> 0 & 255), w[k++] = x >>> 16 & 255;
                    d = 8;
                }
                r !== P.image_compression.NONE && E() ? (t = q(m, o.width * o.colors, o.colors, r), l = q(w, o.width, 1, r)) : (t = m, l = w, f = null);
            }
            if (3 === o.colorType && (u = this.color_spaces.INDEXED, c = o.palette, o.transparency.indexed)) {
                var _ = o.transparency.indexed, A = 0;
                for(v = 0, g = _.length; v < g; ++v)A += _[v];
                if ((A /= 255) == g - 1 && -1 !== _.indexOf(0)) s = [
                    _.indexOf(0)
                ];
                else if (A !== g) {
                    var I = o.decodePixels();
                    for(w = new Uint8Array(I.length), v = 0, g = I.length; v < g; v++)w[v] = _[I[v]];
                    l = q(w, o.width, 1);
                }
            }
            var C = function(t) {
                var e;
                switch(t){
                    case P.image_compression.FAST:
                        e = 11;
                        break;
                    case P.image_compression.MEDIUM:
                        e = 13;
                        break;
                    case P.image_compression.SLOW:
                        e = 14;
                        break;
                    default:
                        e = 12;
                }
                return e;
            }(r);
            return a = f === this.decode.FLATE_DECODE ? "/Predictor " + C + " /Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width : "/Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width, (this.isArrayBuffer(t) || this.isArrayBufferView(t)) && (t = this.arrayBufferToBinaryString(t)), (l && this.isArrayBuffer(l) || this.isArrayBufferView(l)) && (l = this.arrayBufferToBinaryString(l)), this.createImageInfo(t, o.width, o.height, u, d, f, e, n, a, s, c, l, C);
        }
        throw new Error("Unsupported PNG image data, try using JPEG instead.");
    }, /**
   * jsPDF gif Support PlugIn
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (A = $.API).processGIF89A = function(t, e, n, r, i) {
        var o = new mt(t), a = o.width, s = o.height, h = [];
        o.decodeAndBlitFrameRGBA(0, h);
        var c = {
            data: h,
            width: a,
            height: s
        }, l = new yt(100).encode(c, 100);
        return A.processJPEG.call(this, l, e, n, r);
    }, A.processGIF87A = A.processGIF89A, /**
   * jsPDF bmp Support PlugIn
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (O = $.API).processBMP = function(t, e, n, r, i) {
        var o = new xt(t, !1), a = o.width, s = o.height, h = {
            data: o.getData(),
            width: a,
            height: s
        }, c = new yt(100).encode(h, 100);
        return O.processJPEG.call(this, c, e, n, r);
    }, $.API.setLanguage = function(t) {
        return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
            af: "Afrikaans",
            sq: "Albanian",
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            an: "Aragonese",
            hy: "Armenian",
            as: "Assamese",
            ast: "Asturian",
            az: "Azerbaijani",
            eu: "Basque",
            be: "Belarusian",
            bn: "Bengali",
            bs: "Bosnian",
            br: "Breton",
            bg: "Bulgarian",
            my: "Burmese",
            ca: "Catalan",
            ch: "Chamorro",
            ce: "Chechen",
            zh: "Chinese",
            "zh-HK": "Chinese (Hong Kong)",
            "zh-CN": "Chinese (PRC)",
            "zh-SG": "Chinese (Singapore)",
            "zh-TW": "Chinese (Taiwan)",
            cv: "Chuvash",
            co: "Corsican",
            cr: "Cree",
            hr: "Croatian",
            cs: "Czech",
            da: "Danish",
            nl: "Dutch (Standard)",
            "nl-BE": "Dutch (Belgian)",
            en: "English",
            "en-AU": "English (Australia)",
            "en-BZ": "English (Belize)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-JM": "English (Jamaica)",
            "en-NZ": "English (New Zealand)",
            "en-PH": "English (Philippines)",
            "en-ZA": "English (South Africa)",
            "en-TT": "English (Trinidad & Tobago)",
            "en-GB": "English (United Kingdom)",
            "en-US": "English (United States)",
            "en-ZW": "English (Zimbabwe)",
            eo: "Esperanto",
            et: "Estonian",
            fo: "Faeroese",
            fj: "Fijian",
            fi: "Finnish",
            fr: "French (Standard)",
            "fr-BE": "French (Belgium)",
            "fr-CA": "French (Canada)",
            "fr-FR": "French (France)",
            "fr-LU": "French (Luxembourg)",
            "fr-MC": "French (Monaco)",
            "fr-CH": "French (Switzerland)",
            fy: "Frisian",
            fur: "Friulian",
            gd: "Gaelic (Scots)",
            "gd-IE": "Gaelic (Irish)",
            gl: "Galacian",
            ka: "Georgian",
            de: "German (Standard)",
            "de-AT": "German (Austria)",
            "de-DE": "German (Germany)",
            "de-LI": "German (Liechtenstein)",
            "de-LU": "German (Luxembourg)",
            "de-CH": "German (Switzerland)",
            el: "Greek",
            gu: "Gujurati",
            ht: "Haitian",
            he: "Hebrew",
            hi: "Hindi",
            hu: "Hungarian",
            is: "Icelandic",
            id: "Indonesian",
            iu: "Inuktitut",
            ga: "Irish",
            it: "Italian (Standard)",
            "it-CH": "Italian (Switzerland)",
            ja: "Japanese",
            kn: "Kannada",
            ks: "Kashmiri",
            kk: "Kazakh",
            km: "Khmer",
            ky: "Kirghiz",
            tlh: "Klingon",
            ko: "Korean",
            "ko-KP": "Korean (North Korea)",
            "ko-KR": "Korean (South Korea)",
            la: "Latin",
            lv: "Latvian",
            lt: "Lithuanian",
            lb: "Luxembourgish",
            mk: "FYRO Macedonian",
            ms: "Malay",
            ml: "Malayalam",
            mt: "Maltese",
            mi: "Maori",
            mr: "Marathi",
            mo: "Moldavian",
            nv: "Navajo",
            ng: "Ndonga",
            ne: "Nepali",
            no: "Norwegian",
            nb: "Norwegian (Bokmal)",
            nn: "Norwegian (Nynorsk)",
            oc: "Occitan",
            or: "Oriya",
            om: "Oromo",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            pl: "Polish",
            pt: "Portuguese",
            "pt-BR": "Portuguese (Brazil)",
            pa: "Punjabi",
            "pa-IN": "Punjabi (India)",
            "pa-PK": "Punjabi (Pakistan)",
            qu: "Quechua",
            rm: "Rhaeto-Romanic",
            ro: "Romanian",
            "ro-MO": "Romanian (Moldavia)",
            ru: "Russian",
            "ru-MO": "Russian (Moldavia)",
            sz: "Sami (Lappish)",
            sg: "Sango",
            sa: "Sanskrit",
            sc: "Sardinian",
            sd: "Sindhi",
            si: "Singhalese",
            sr: "Serbian",
            sk: "Slovak",
            sl: "Slovenian",
            so: "Somani",
            sb: "Sorbian",
            es: "Spanish",
            "es-AR": "Spanish (Argentina)",
            "es-BO": "Spanish (Bolivia)",
            "es-CL": "Spanish (Chile)",
            "es-CO": "Spanish (Colombia)",
            "es-CR": "Spanish (Costa Rica)",
            "es-DO": "Spanish (Dominican Republic)",
            "es-EC": "Spanish (Ecuador)",
            "es-SV": "Spanish (El Salvador)",
            "es-GT": "Spanish (Guatemala)",
            "es-HN": "Spanish (Honduras)",
            "es-MX": "Spanish (Mexico)",
            "es-NI": "Spanish (Nicaragua)",
            "es-PA": "Spanish (Panama)",
            "es-PY": "Spanish (Paraguay)",
            "es-PE": "Spanish (Peru)",
            "es-PR": "Spanish (Puerto Rico)",
            "es-ES": "Spanish (Spain)",
            "es-UY": "Spanish (Uruguay)",
            "es-VE": "Spanish (Venezuela)",
            sx: "Sutu",
            sw: "Swahili",
            sv: "Swedish",
            "sv-FI": "Swedish (Finland)",
            "sv-SV": "Swedish (Sweden)",
            ta: "Tamil",
            tt: "Tatar",
            te: "Teluga",
            th: "Thai",
            tig: "Tigre",
            ts: "Tsonga",
            tn: "Tswana",
            tr: "Turkish",
            tk: "Turkmen",
            uk: "Ukrainian",
            hsb: "Upper Sorbian",
            ur: "Urdu",
            ve: "Venda",
            vi: "Vietnamese",
            vo: "Volapuk",
            wa: "Walloon",
            cy: "Welsh",
            xh: "Xhosa",
            ji: "Yiddish",
            zu: "Zulu"
        })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
        }), this.internal.languageSettings.isSubscribed = !0)), this;
    }, /** @preserve
   * jsPDF split_text_to_size plugin - MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   */ B = $.API, R = B.getCharWidthsArray = function(t, e) {
        var n, r, i, o = (e = e || {}).font || this.internal.getFont(), a = e.fontSize || this.internal.getFontSize(), s = e.charSpace || this.internal.getCharSpace(), h = e.widths ? e.widths : o.metadata.Unicode.widths, c = h.fof ? h.fof : 1, l = e.kerning ? e.kerning : o.metadata.Unicode.kerning, u = l.fof ? l.fof : 1, f = 0, d = h[0] || c, p = [];
        for(n = 0, r = t.length; n < r; n++)i = t.charCodeAt(n), "function" == typeof o.metadata.widthOfString ? p.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i)) + s * (1e3 / a) || 0) / 1e3) : p.push((h[i] || d) / c + (l[i] && l[i][f] || 0) / u), f = i;
        return p;
    }, j = B.getArraySum = function(t) {
        for(var e = t.length, n = 0; e;)n += t[--e];
        return n;
    }, D = B.getStringUnitWidth = function(t, e) {
        var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
        return "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : j(R.apply(this, arguments));
    }, M = function(t, e, n, r) {
        for(var i = [], o = 0, a = t.length, s = 0; o !== a && s + e[o] < n;)s += e[o], o++;
        i.push(t.slice(0, o));
        var h = o;
        for(s = 0; o !== a;)s + e[o] > r && (i.push(t.slice(h, o)), s = 0, h = o), s += e[o], o++;
        return h !== o && i.push(t.slice(h, o)), i;
    }, U = function(t, e, n) {
        n || (n = {});
        var r, i, o, a, s, h, c = [], l = [
            c
        ], u = n.textIndent || 0, f = 0, d = 0, p = t.split(" "), g = R.apply(this, [
            " ",
            n
        ])[0];
        if (h = -1 === n.lineIndent ? p[0].length + 2 : n.lineIndent || 0) {
            var m = Array(h).join(" "), w = [];
            p.map(function(t) {
                1 < (t = t.split(/\s*\n/)).length ? w = w.concat(t.map(function(t, e) {
                    return (e && t.length ? "\n" : "") + t;
                })) : w.push(t[0]);
            }), p = w, h = D.apply(this, [
                m,
                n
            ]);
        }
        for(o = 0, a = p.length; o < a; o++){
            var y = 0;
            if (r = p[o], h && "\n" == r[0] && (r = r.substr(1), y = 1), i = R.apply(this, [
                r,
                n
            ]), e < u + f + (d = j(i)) || y) {
                if (e < d) {
                    for(s = M.apply(this, [
                        r,
                        i,
                        e - (u + f),
                        e
                    ]), c.push(s.shift()), c = [
                        s.pop()
                    ]; s.length;)l.push([
                        s.shift()
                    ]);
                    d = j(i.slice(r.length - (c[0] ? c[0].length : 0)));
                } else c = [
                    r
                ];
                l.push(c), u = d + h, f = g;
            } else c.push(r), u += f + d, f = g;
        }
        if (h) var v = function(t, e) {
            return (e ? m : "") + t.join(" ");
        };
        else v = function(t) {
            return t.join(" ");
        };
        return l.map(v);
    }, B.splitTextToSize = function(t, e, n) {
        var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), o = (function(t) {
            var e = {
                0: 1
            }, n = {};
            if (t.widths && t.kerning) return {
                widths: t.widths,
                kerning: t.kerning
            };
            var r = this.internal.getFont(t.fontName, t.fontStyle), i = "Unicode";
            return r.metadata[i] ? {
                widths: r.metadata[i].widths || e,
                kerning: r.metadata[i].kerning || n
            } : {
                font: r.metadata,
                fontSize: this.internal.getFontSize(),
                charSpace: this.internal.getCharSpace()
            };
        }).call(this, n);
        r = Array.isArray(t) ? t : t.split(/\r?\n/);
        var a = 1 * this.internal.scaleFactor * e / i;
        o.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, o.lineIndent = n.lineIndent;
        var s, h, c = [];
        for(s = 0, h = r.length; s < h; s++)c = c.concat(U.apply(this, [
            r[s],
            a,
            o
        ]));
        return c;
    }, /** @preserve 
  jsPDF standard_fonts_metrics plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  MIT license.
  */ N = $.API, L = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: (z = function(t) {
            for(var e = "klmnopqrstuvwxyz", n = {}, r = 0; r < e.length; r++)n[e[r]] = "0123456789abcdef"[r];
            var i, o, a, s, h, c = {}, l = 1, u = c, f = [], d = "", p = "", g = t.length - 1;
            for(r = 1; r != g;)h = t[r], r += 1, "'" == h ? o ? (s = o.join(""), o = i) : o = [] : o ? o.push(h) : "{" == h ? (f.push([
                u,
                s
            ]), u = {}, s = i) : "}" == h ? ((a = f.pop())[0][a[1]] = u, s = i, u = a[0]) : "-" == h ? l = -1 : s === i ? n.hasOwnProperty(h) ? (d += n[h], s = parseInt(d, 16) * l, l = 1, d = "") : d += h : n.hasOwnProperty(h) ? (p += n[h], u[s] = parseInt(p, 16) * l, l = 1, s = i, p = "") : p += h;
            return c;
        })("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, H = {
        Unicode: {
            Courier: L,
            "Courier-Bold": L,
            "Courier-BoldOblique": L,
            "Courier-Oblique": L,
            Helvetica: L,
            "Helvetica-Bold": L,
            "Helvetica-BoldOblique": L,
            "Helvetica-Oblique": L,
            "Times-Roman": L,
            "Times-Bold": L,
            "Times-BoldItalic": L,
            "Times-Italic": L
        }
    }, W = {
        Unicode: {
            "Courier-Oblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    }, N.events.push([
        "addFont",
        function(t) {
            var e, n, r, i = "Unicode";
            (e = W[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).widths = e.widths, n.kerning = e.kerning), (r = H[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).encoding = r).codePages && r.codePages.length && (t.encoding = r.codePages[0]);
        }
    ]), G = $, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")(), G.API.events.push([
        "addFont",
        function(t) {
            G.API.existsFileInVFS(t.postScriptName) ? (t.metadata = G.API.TTFFont.open(t.postScriptName, t.fontName, G.API.getFileFromVFS(t.postScriptName), t.encoding), t.metadata.Unicode = t.metadata.Unicode || {
                encoding: {},
                kerning: {},
                widths: []
            }) : 14 < t.id.slice(1) && console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('" + t.postScriptName + "').");
        }
    ]), /** @preserve
  jsPDF SVG plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  */ (V = $.API).addSvg = function(t, e, n, r, i) {
        if (void 0 === e || void 0 === n) throw new Error("addSVG needs values for 'x' and 'y'");
        function o(t) {
            for(var e = parseFloat(t[1]), n = parseFloat(t[2]), r = [], i = 3, o = t.length; i < o;)"c" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2]),
                parseFloat(t[i + 3]),
                parseFloat(t[i + 4]),
                parseFloat(t[i + 5]),
                parseFloat(t[i + 6])
            ]), i += 7) : "l" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2])
            ]), i += 3) : i += 1;
            return [
                e,
                n,
                r
            ];
        }
        var a, s, h, c, l, u, f, d, p = (c = document, d = c.createElement("iframe"), l = ".jsPDF_sillysvg_iframe {display:none;position:absolute;}", (f = (u = c).createElement("style")).type = "text/css", f.styleSheet ? f.styleSheet.cssText = l : f.appendChild(u.createTextNode(l)), u.getElementsByTagName("head")[0].appendChild(f), d.name = "childframe", d.setAttribute("width", 0), d.setAttribute("height", 0), d.setAttribute("frameborder", "0"), d.setAttribute("scrolling", "no"), d.setAttribute("seamless", "seamless"), d.setAttribute("class", "jsPDF_sillysvg_iframe"), c.body.appendChild(d), d), g = (a = t, (h = ((s = p).contentWindow || s.contentDocument).document).write(a), h.close(), h.getElementsByTagName("svg")[0]), m = [
            1,
            1
        ], w = parseFloat(g.getAttribute("width")), y = parseFloat(g.getAttribute("height"));
        w && y && (r && i ? m = [
            r / w,
            i / y
        ] : r ? m = [
            r / w,
            r / w
        ] : i && (m = [
            i / y,
            i / y
        ]));
        var v, b, x, S, k = g.childNodes;
        for(v = 0, b = k.length; v < b; v++)(x = k[v]).tagName && "PATH" === x.tagName.toUpperCase() && ((S = o(x.getAttribute("d").split(" ")))[0] = S[0] * m[0] + e, S[1] = S[1] * m[1] + n, this.lines.call(this, S[2], S[0], S[1], m));
        return this;
    }, V.addSVG = V.addSvg, V.addSvgAsImage = function(t, e, n, r, i, o, a, s) {
        if (isNaN(e) || isNaN(n)) throw console.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(r) || isNaN(i)) throw console.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = r, h.height = i;
        var c = h.getContext("2d");
        return c.fillStyle = "#fff", c.fillRect(0, 0, h.width, h.height), canvg(h, t, {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0,
            ignoreClear: !0
        }), this.addImage(h.toDataURL("image/jpeg", 1), e, n, r, i, a, s), this;
    }, $.API.putTotalPages = function(t) {
        for(var e = new RegExp(t, "g"), n = 1; n <= this.internal.getNumberOfPages(); n++)for(var r = 0; r < this.internal.pages[n].length; r++)this.internal.pages[n][r] = this.internal.pages[n][r].replace(e, this.internal.getNumberOfPages());
        return this;
    }, $.API.viewerPreferences = function(t, e) {
        var n;
        t = t || {}, e = e || !1;
        var r, i, o = {
            HideToolbar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideMenubar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideWindowUI: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            FitWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            CenterWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            DisplayDocTitle: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.4
            },
            NonFullScreenPageMode: {
                defaultValue: "UseNone",
                value: "UseNone",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "UseOC"
                ],
                pdfVersion: 1.3
            },
            Direction: {
                defaultValue: "L2R",
                value: "L2R",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "L2R",
                    "R2L"
                ],
                pdfVersion: 1.3
            },
            ViewArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            ViewClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintScaling: {
                defaultValue: "AppDefault",
                value: "AppDefault",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "AppDefault",
                    "None"
                ],
                pdfVersion: 1.6
            },
            Duplex: {
                defaultValue: "",
                value: "none",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "Simplex",
                    "DuplexFlipShortEdge",
                    "DuplexFlipLongEdge",
                    "none"
                ],
                pdfVersion: 1.7
            },
            PickTrayByPDFSize: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.7
            },
            PrintPageRange: {
                defaultValue: "",
                value: "",
                type: "array",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            },
            NumCopies: {
                defaultValue: 1,
                value: 1,
                type: "integer",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            }
        }, a = Object.keys(o), s = [], h = 0, c = 0, l = 0, u = !0;
        function f(t, e) {
            var n, r = !1;
            for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
            return r;
        }
        if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === t || !0 === e) {
            var d = a.length;
            for(l = 0; l < d; l += 1)n[a[l]].value = n[a[l]].defaultValue, n[a[l]].explicitSet = !1;
        }
        if ("object" === (void 0 === t ? "undefined" : vt(t))) {
            for(r in t)if (i = t[r], f(a, r) && void 0 !== i) {
                if ("boolean" === n[r].type && "boolean" == typeof i) n[r].value = i;
                else if ("name" === n[r].type && f(n[r].valueSet, i)) n[r].value = i;
                else if ("integer" === n[r].type && Number.isInteger(i)) n[r].value = i;
                else if ("array" === n[r].type) {
                    for(h = 0; h < i.length; h += 1)if (u = !0, 1 === i[h].length && "number" == typeof i[h][0]) s.push(String(i[h]));
                    else if (1 < i[h].length) {
                        for(c = 0; c < i[h].length; c += 1)"number" != typeof i[h][c] && (u = !1);
                        !0 === u && s.push(String(i[h].join("-")));
                    }
                    n[r].value = String(s);
                } else n[r].value = n[r].defaultValue;
                n[r].explicitSet = !0;
            }
        }
        return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            var t, e = [];
            for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
            0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
        }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
    }, /** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */ Y = $.API, K = J = X = "", Y.addMetadata = function(t, e) {
        return J = e || "http://jspdf.default.namespaceuri/", X = t, this.internal.events.subscribe("postPutResources", function() {
            if (X) {
                var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + J + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(X)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), o = unescape(encodeURIComponent("</x:xmpmeta>")), a = n.length + r.length + i.length + e.length + o.length;
                K = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + a + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + o), this.internal.write("endstream"), this.internal.write("endobj");
            } else K = "";
        }), this.internal.events.subscribe("putCatalog", function() {
            K && this.internal.write("/Metadata " + K + " 0 R");
        }), this;
    }, function(l, t) {
        var e = l.API, m = [
            0
        ];
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "Identity-H" === t.encoding) {
                        for(var r = t.metadata.Unicode.widths, i = t.metadata.subset.encode(m), o = "", a = 0; a < i.length; a++)o += String.fromCharCode(i[a]);
                        var s = n();
                        e("<<"), e("/Length " + o.length), e("/Length1 " + o.length), e(">>"), e("stream"), e(o), e("endstream"), e("endobj");
                        var h = n();
                        e("<<"), e("/Type /FontDescriptor"), e("/FontName /" + t.fontName), e("/FontFile2 " + s + " 0 R"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/Flags " + t.metadata.flags), e("/StemV " + t.metadata.stemV), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e(">>"), e("endobj");
                        var c = n();
                        e("<<"), e("/Type /Font"), e("/BaseFont /" + t.fontName), e("/FontDescriptor " + h + " 0 R"), e("/W " + l.API.PDFObject.convert(r)), e("/CIDToGIDMap /Identity"), e("/DW 1000"), e("/Subtype /CIDFontType2"), e("/CIDSystemInfo"), e("<<"), e("/Supplement 0"), e("/Registry (Adobe)"), e("/Ordering (" + t.encoding + ")"), e(">>"), e(">>"), e("endobj"), t.objectNumber = n(), e("<<"), e("/Type /Font"), e("/Subtype /Type0"), e("/BaseFont /" + t.fontName), e("/Encoding /" + t.encoding), e("/DescendantFonts [" + c + " 0 R]"), e(">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "WinAnsiEncoding" === t.encoding) {
                        t.metadata.Unicode.widths;
                        for(var r = t.metadata.rawData, i = "", o = 0; o < r.length; o++)i += String.fromCharCode(r[o]);
                        var a = n();
                        e("<<"), e("/Length " + i.length), e("/Length1 " + i.length), e(">>"), e("stream"), e(i), e("endstream"), e("endobj");
                        var s = n();
                        for(e("<<"), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e("/StemV " + t.metadata.stemV), e("/Type /FontDescriptor"), e("/FontFile2 " + a + " 0 R"), e("/Flags 96"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/FontName /" + t.fontName), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e(">>"), e("endobj"), t.objectNumber = n(), o = 0; o < t.metadata.hmtx.widths.length; o++)t.metadata.hmtx.widths[o] = parseInt(t.metadata.hmtx.widths[o] * (1e3 / t.metadata.head.unitsPerEm));
                        e("<</Subtype/TrueType/Type/Font/BaseFont/" + t.fontName + "/FontDescriptor " + s + " 0 R/Encoding/" + t.encoding + " /FirstChar 29 /LastChar 255 /Widths " + l.API.PDFObject.convert(t.metadata.hmtx.widths) + ">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        var c = function(t) {
            var e, n, r = t.text || "", i = t.x, o = t.y, a = t.options || {}, s = t.mutex || {}, h = s.pdfEscape, c = s.activeFontKey, l = s.fonts, u = (s.activeFontSize, ""), f = 0, d = "", p = l[n = c].encoding;
            if ("Identity-H" !== l[n].encoding) return {
                text: r,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
            for(d = r, n = c, "[object Array]" === Object.prototype.toString.call(r) && (d = r[0]), f = 0; f < d.length; f += 1)l[n].metadata.hasOwnProperty("cmap") && (e = l[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]), e ? u += d[f] : d[f].charCodeAt(0) < 256 && l[n].metadata.hasOwnProperty("Unicode") ? u += d[f] : u += "";
            var g = "";
            return parseInt(n.slice(1)) < 14 || "WinAnsiEncoding" === p ? g = function(t) {
                for(var e = "", n = 0; n < t.length; n++)e += "" + t.charCodeAt(n).toString(16);
                return e;
            }(h(u, n)) : "Identity-H" === p && (g = function(t, e) {
                for(var n, r = e.metadata.Unicode.widths, i = [
                    "",
                    "0",
                    "00",
                    "000",
                    "0000"
                ], o = [
                    ""
                ], a = 0, s = t.length; a < s; ++a){
                    if (n = e.metadata.characterToGlyph(t.charCodeAt(a)), m.push(n), -1 == r.indexOf(n) && (r.push(n), r.push([
                        parseInt(e.metadata.widthOfGlyph(n), 10)
                    ])), "0" == n) return o.join("");
                    n = n.toString(16), o.push(i[4 - n.length], n);
                }
                return o.join("");
            }(u, l[n])), s.isHex = !0, {
                text: g,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
        };
        e.events.push([
            "postProcessText",
            function(t) {
                var e = t.text || "", n = t.x, r = t.y, i = t.options, o = t.mutex, a = (i.lang, []), s = {
                    text: e,
                    x: n,
                    y: r,
                    options: i,
                    mutex: o
                };
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var h = 0;
                    for(h = 0; h < e.length; h += 1)"[object Array]" === Object.prototype.toString.call(e[h]) && 3 === e[h].length ? a.push([
                        c(Object.assign({}, s, {
                            text: e[h][0]
                        })).text,
                        e[h][1],
                        e[h][2]
                    ]) : a.push(c(Object.assign({}, s, {
                        text: e[h]
                    })).text);
                    t.text = a;
                } else t.text = c(Object.assign({}, s, {
                    text: e
                })).text;
            }
        ]);
    }($, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")()), Q = $.API, Z = {}, Q.existsFileInVFS = function(t) {
        return Z.hasOwnProperty(t);
    }, Q.addFileToVFS = function(t, e) {
        return Z[t] = e, this;
    }, Q.getFileFromVFS = function(t) {
        return Z.hasOwnProperty(t) ? Z[t] : null;
    }, function(t) {
        if (t.URL = t.URL || t.webkitURL, t.Blob && t.URL) try {
            return new Blob;
        } catch (t) {}
        var s = t.BlobBuilder || t.WebKitBlobBuilder || t.MozBlobBuilder || function(t) {
            var s = function(t) {
                return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1];
            }, e = function() {
                this.data = [];
            }, h = function(t, e, n) {
                this.data = t, this.size = t.length, this.type = e, this.encoding = n;
            }, n = e.prototype, r = h.prototype, c = t.FileReaderSync, l = function(t) {
                this.code = this[this.name = t];
            }, i = "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "), o = i.length, a = t.URL || t.webkitURL || t, u = a.createObjectURL, f = a.revokeObjectURL, d = a, p = t.btoa, g = t.atob, m = t.ArrayBuffer, w = t.Uint8Array, y = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
            for(h.fake = r.fake = !0; o--;)l.prototype[i[o]] = o + 1;
            return a.createObjectURL || (d = t.URL = function(t) {
                var e, n = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                return n.href = t, "origin" in n || ("data:" === n.protocol.toLowerCase() ? n.origin = null : (e = t.match(y), n.origin = e && e[1])), n;
            }), d.createObjectURL = function(t) {
                var e, n = t.type;
                return null === n && (n = "application/octet-stream"), t instanceof h ? (e = "data:" + n, "base64" === t.encoding ? e + ";base64," + t.data : "URI" === t.encoding ? e + "," + decodeURIComponent(t.data) : p ? e + ";base64," + p(t.data) : e + "," + encodeURIComponent(t.data)) : u ? u.call(a, t) : void 0;
            }, d.revokeObjectURL = function(t) {
                "data:" !== t.substring(0, 5) && f && f.call(a, t);
            }, n.append = function(t) {
                var e = this.data;
                if (w && (t instanceof m || t instanceof w)) {
                    for(var n = "", r = new w(t), i = 0, o = r.length; i < o; i++)n += String.fromCharCode(r[i]);
                    e.push(n);
                } else if ("Blob" === s(t) || "File" === s(t)) {
                    if (!c) throw new l("NOT_READABLE_ERR");
                    var a = new c;
                    e.push(a.readAsBinaryString(t));
                } else t instanceof h ? "base64" === t.encoding && g ? e.push(g(t.data)) : "URI" === t.encoding ? e.push(decodeURIComponent(t.data)) : "raw" === t.encoding && e.push(t.data) : ("string" != typeof t && (t += ""), e.push(unescape(encodeURIComponent(t))));
            }, n.getBlob = function(t) {
                return arguments.length || (t = null), new h(this.data.join(""), t, "raw");
            }, n.toString = function() {
                return "[object BlobBuilder]";
            }, r.slice = function(t, e, n) {
                var r = arguments.length;
                return r < 3 && (n = null), new h(this.data.slice(t, 1 < r ? e : this.data.length), n, this.encoding);
            }, r.toString = function() {
                return "[object Blob]";
            }, r.close = function() {
                this.size = 0, delete this.data;
            }, e;
        }(t);
        t.Blob = function(t, e) {
            var n = e && e.type || "", r = new s;
            if (t) for(var i = 0, o = t.length; i < o; i++)Uint8Array && t[i] instanceof Uint8Array ? r.append(t[i].buffer) : r.append(t[i]);
            var a = r.getBlob(n);
            return !a.slice && a.webkitSlice && (a.slice = a.webkitSlice), a;
        };
        var e = Object.getPrototypeOf || function(t) {
            return t.__proto__;
        };
        t.Blob.prototype = e(new t.Blob);
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content || window);
    var tt, et, nt, rt, it, ot, at, st, ht, ct, lt, ut, ft, dt, pt, gt, bt = bt || function(s) {
        if (!(void 0 === s || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) {
            var t = s.document, h = function() {
                return s.URL || s.webkitURL || s;
            }, c = t.createElementNS("http://www.w3.org/1999/xhtml", "a"), l = "download" in c, u = /constructor/i.test(s.HTMLElement) || s.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), d = function(t) {
                (s.setImmediate || s.setTimeout)(function() {
                    throw t;
                }, 0);
            }, p = function(t) {
                setTimeout(function() {
                    "string" == typeof t ? h().revokeObjectURL(t) : t.remove();
                }, 4e4);
            }, g = function(t) {
                return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([
                    String.fromCharCode(65279),
                    t
                ], {
                    type: t.type
                }) : t;
            }, r = function(t, n, e) {
                e || (t = g(t));
                var r, i = this, o = "application/octet-stream" === t.type, a = function() {
                    !function(t, e, n) {
                        for(var r = (e = [].concat(e)).length; r--;){
                            var i = t["on" + e[r]];
                            if ("function" == typeof i) try {
                                i.call(t, n || t);
                            } catch (t) {
                                d(t);
                            }
                        }
                    }(i, "writestart progress write writeend".split(" "));
                };
                if (i.readyState = i.INIT, l) return r = h().createObjectURL(t), void setTimeout(function() {
                    var t, e;
                    c.href = r, c.download = n, t = c, e = new MouseEvent("click"), t.dispatchEvent(e), a(), p(r), i.readyState = i.DONE;
                });
                !function() {
                    if ((f || o && u) && s.FileReader) {
                        var e = new FileReader;
                        return e.onloadend = function() {
                            var t = f ? e.result : e.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            s.open(t, "_blank") || (s.location.href = t), t = void 0, i.readyState = i.DONE, a();
                        }, e.readAsDataURL(t), i.readyState = i.INIT;
                    }
                    r || (r = h().createObjectURL(t)), o ? s.location.href = r : s.open(r, "_blank") || (s.location.href = r);
                    i.readyState = i.DONE, a(), p(r);
                }();
            }, e = r.prototype;
            return "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(t, e, n) {
                return e = e || t.name || "download", n || (t = g(t)), navigator.msSaveOrOpenBlob(t, e);
            } : (e.abort = function() {}, e.readyState = e.INIT = 0, e.WRITING = 1, e.DONE = 2, e.error = e.onwritestart = e.onprogress = e.onwrite = e.onabort = e.onerror = e.onwriteend = null, function(t, e, n) {
                return new r(t, e || t.name || "download", n);
            });
        }
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content);
    function mt(x) {
        var t = 0;
        if (71 !== x[t++] || 73 !== x[t++] || 70 !== x[t++] || 56 !== x[t++] || 56 != (x[t++] + 1 & 253) || 97 !== x[t++]) throw "Invalid GIF 87a/89a header.";
        var S = x[t++] | x[t++] << 8, e = x[t++] | x[t++] << 8, n = x[t++], r = n >> 7, i = 1 << (7 & n) + 1;
        x[t++];
        x[t++];
        var o = null;
        r && (o = t, t += 3 * i);
        var a = !0, s = [], h = 0, c = null, l = 0, u = null;
        for(this.width = S, this.height = e; a && t < x.length;)switch(x[t++]){
            case 33:
                switch(x[t++]){
                    case 255:
                        if (11 !== x[t] || 78 == x[t + 1] && 69 == x[t + 2] && 84 == x[t + 3] && 83 == x[t + 4] && 67 == x[t + 5] && 65 == x[t + 6] && 80 == x[t + 7] && 69 == x[t + 8] && 50 == x[t + 9] && 46 == x[t + 10] && 48 == x[t + 11] && 3 == x[t + 12] && 1 == x[t + 13] && 0 == x[t + 16]) t += 14, u = x[t++] | x[t++] << 8, t++;
                        else for(t += 12;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    case 249:
                        if (4 !== x[t++] || 0 !== x[t + 4]) throw "Invalid graphics extension block.";
                        var f = x[t++];
                        h = x[t++] | x[t++] << 8, c = x[t++], 0 == (1 & f) && (c = null), l = f >> 2 & 7, t++;
                        break;
                    case 254:
                        for(;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    default:
                        throw "Unknown graphic control label: 0x" + x[t - 1].toString(16);
                }
                break;
            case 44:
                var d = x[t++] | x[t++] << 8, p = x[t++] | x[t++] << 8, g = x[t++] | x[t++] << 8, m = x[t++] | x[t++] << 8, w = x[t++], y = w >> 6 & 1, v = o, b = !1;
                if (w >> 7) {
                    b = !0;
                    v = t, t += 3 * (1 << (7 & w) + 1);
                }
                var k = t;
                for(t++;;){
                    var _;
                    if (0 === (_ = x[t++])) break;
                    t += _;
                }
                s.push({
                    x: d,
                    y: p,
                    width: g,
                    height: m,
                    has_local_palette: b,
                    palette_offset: v,
                    data_offset: k,
                    data_length: t - k,
                    transparent_index: c,
                    interlaced: !!y,
                    delay: h,
                    disposal: l
                });
                break;
            case 59:
                a = !1;
                break;
            default:
                throw "Unknown gif block: 0x" + x[t - 1].toString(16);
        }
        this.numFrames = function() {
            return s.length;
        }, this.loopCount = function() {
            return u;
        }, this.frameInfo = function(t) {
            if (t < 0 || t >= s.length) throw "Frame index out of range.";
            return s[t];
        }, this.decodeAndBlitFrameBGRA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = b, e[f++] = v, e[f++] = y, e[f++] = 255;
                }
                --c;
            }
        }, this.decodeAndBlitFrameRGBA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = y, e[f++] = v, e[f++] = b, e[f++] = 255;
                }
                --c;
            }
        };
    }
    function wt(t, e, n, r) {
        for(var i = t[e++], o = 1 << i, a = o + 1, s = a + 1, h = i + 1, c = (1 << h) - 1, l = 0, u = 0, f = 0, d = t[e++], p = new Int32Array(4096), g = null;;){
            for(; l < 16 && 0 !== d;)u |= t[e++] << l, l += 8, 1 === d ? d = t[e++] : --d;
            if (l < h) break;
            var m = u & c;
            if (u >>= h, l -= h, m !== o) {
                if (m === a) break;
                for(var w = m < s ? m : g, y = 0, v = w; o < v;)v = p[v] >> 8, ++y;
                var b = v;
                if (r < f + y + (w !== m ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                n[f++] = b;
                var x = f += y;
                for(w !== m && (n[f++] = b), v = w; y--;)v = p[v], n[--x] = 255 & v, v >>= 8;
                null !== g && s < 4096 && (p[s++] = g << 8 | b, c + 1 <= s && h < 12 && (++h, c = c << 1 | 1)), g = m;
            } else s = a + 1, c = (1 << (h = i + 1)) - 1, g = null;
        }
        return f !== r && console.log("Warning, gif stream shorter than expected."), n;
    }
    (0, module.exports) ? module.exports.saveAs = bt : "undefined" != typeof define && null !== define && null !== define.amd && define("FileSaver.js", function() {
        return bt;
    }), $.API.adler32cs = (ot = "function" == typeof ArrayBuffer && "function" == typeof Uint8Array, at = null, st = function() {
        if (!ot) return function() {
            return !1;
        };
        try {
            var t = {};
            "function" == typeof t.Buffer && (at = t.Buffer);
        } catch (t) {}
        return function(t) {
            return t instanceof ArrayBuffer || null !== at && t instanceof at;
        };
    }(), ht = null !== at ? function(t) {
        return new at(t, "utf8").toString("binary");
    } : function(t) {
        return unescape(encodeURIComponent(t));
    }, ct = 65521, lt = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + (255 & e.charCodeAt(i))) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, ut = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + e[i]) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, dt = (ft = {}).Adler32 = (((it = (rt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!isFinite(t = null == t ? 1 : +t)) throw new Error("First arguments needs to be a finite number.");
        this.checksum = t >>> 0;
    }).prototype = {}).constructor = rt).from = ((tt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        this.checksum = lt(1, t.toString());
    }).prototype = it, tt), rt.fromUtf8 = ((et = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        this.checksum = lt(1, e);
    }).prototype = it, et), ot && (rt.fromBuffer = ((nt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(1, e);
    }).prototype = it, nt)), it.update = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return t = t.toString(), this.checksum = lt(this.checksum, t);
    }, it.updateUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return this.checksum = lt(this.checksum, e);
    }, ot && (it.updateBuffer = function(t) {
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(this.checksum, e);
    }), it.clone = function() {
        return new dt(this.checksum);
    }, rt), ft.from = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return lt(1, t.toString());
    }, ft.fromUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return lt(1, e);
    }, ot && (ft.fromBuffer = function(t) {
        if (!st(t)) throw new Error("First argument need to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return ut(1, e);
    }), ft);
    try {
        module.exports.GifWriter = function(w, t, e, n) {
            var y = 0, r = void 0 === (n = void 0 === n ? {} : n).loop ? null : n.loop, v = void 0 === n.palette ? null : n.palette;
            if (t <= 0 || e <= 0 || 65535 < t || 65535 < e) throw "Width/Height invalid.";
            function b(t) {
                var e = t.length;
                if (e < 2 || 256 < e || e & e - 1) throw "Invalid code/color length, must be power of 2 and 2 .. 256.";
                return e;
            }
            w[y++] = 71, w[y++] = 73, w[y++] = 70, w[y++] = 56, w[y++] = 57, w[y++] = 97;
            var i = 0, o = 0;
            if (null !== v) {
                for(var a = b(v); a >>= 1;)++i;
                if (a = 1 << i, --i, void 0 !== n.background) {
                    if (a <= (o = n.background)) throw "Background index out of range.";
                    if (0 === o) throw "Background index explicitly passed as 0.";
                }
            }
            if (w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = (null !== v ? 128 : 0) | i, w[y++] = o, w[y++] = 0, null !== v) for(var s = 0, h = v.length; s < h; ++s){
                var c = v[s];
                w[y++] = c >> 16 & 255, w[y++] = c >> 8 & 255, w[y++] = 255 & c;
            }
            if (null !== r) {
                if (r < 0 || 65535 < r) throw "Loop count invalid.";
                w[y++] = 33, w[y++] = 255, w[y++] = 11, w[y++] = 78, w[y++] = 69, w[y++] = 84, w[y++] = 83, w[y++] = 67, w[y++] = 65, w[y++] = 80, w[y++] = 69, w[y++] = 50, w[y++] = 46, w[y++] = 48, w[y++] = 3, w[y++] = 1, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = 0;
            }
            var x = !1;
            this.addFrame = function(t, e, n, r, i, o) {
                if (!0 === x && (--y, x = !1), o = void 0 === o ? {} : o, t < 0 || e < 0 || 65535 < t || 65535 < e) throw "x/y invalid.";
                if (n <= 0 || r <= 0 || 65535 < n || 65535 < r) throw "Width/Height invalid.";
                if (i.length < n * r) throw "Not enough pixels for the frame size.";
                var a = !0, s = o.palette;
                if (null == s && (a = !1, s = v), null == s) throw "Must supply either a local or global palette.";
                for(var h = b(s), c = 0; h >>= 1;)++c;
                h = 1 << c;
                var l = void 0 === o.delay ? 0 : o.delay, u = void 0 === o.disposal ? 0 : o.disposal;
                if (u < 0 || 3 < u) throw "Disposal out of range.";
                var f = !1, d = 0;
                if (void 0 !== o.transparent && null !== o.transparent && (f = !0, (d = o.transparent) < 0 || h <= d)) throw "Transparent color index.";
                if ((0 !== u || f || 0 !== l) && (w[y++] = 33, w[y++] = 249, w[y++] = 4, w[y++] = u << 2 | (!0 === f ? 1 : 0), w[y++] = 255 & l, w[y++] = l >> 8 & 255, w[y++] = d, w[y++] = 0), w[y++] = 44, w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = 255 & n, w[y++] = n >> 8 & 255, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = !0 === a ? 128 | c - 1 : 0, !0 === a) for(var p = 0, g = s.length; p < g; ++p){
                    var m = s[p];
                    w[y++] = m >> 16 & 255, w[y++] = m >> 8 & 255, w[y++] = 255 & m;
                }
                y = function(e, n, t, r) {
                    e[n++] = t;
                    var i = n++, o = 1 << t, a = o - 1, s = o + 1, h = s + 1, c = t + 1, l = 0, u = 0;
                    function f(t) {
                        for(; t <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === i + 256 && (e[i] = 255, i = n++);
                    }
                    function d(t) {
                        u |= t << l, l += c, f(8);
                    }
                    var p = r[0] & a, g = {};
                    d(o);
                    for(var m = 1, w = r.length; m < w; ++m){
                        var y = r[m] & a, v = p << 8 | y, b = g[v];
                        if (void 0 === b) {
                            for(u |= p << l, l += c; 8 <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === i + 256 && (e[i] = 255, i = n++);
                            4096 === h ? (d(o), h = s + 1, c = t + 1, g = {}) : (1 << c <= h && ++c, g[v] = h++), p = y;
                        } else p = b;
                    }
                    return d(p), d(s), f(1), i + 1 === n ? e[i] = 0 : (e[i] = n - i - 1, e[n++] = 0), n;
                }(w, y, c < 2 ? 2 : c, i);
            }, this.end = function() {
                return !1 === x && (w[y++] = 59, x = !0), y;
            };
        }, module.exports.GifReader = mt;
    } catch (t) {}
    /*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */ function yt(t) {
        var S, k, _, A, e, u = Math.floor, I = new Array(64), C = new Array(64), T = new Array(64), F = new Array(64), w = new Array(65535), y = new Array(65535), Q = new Array(64), v = new Array(64), P = [], E = 0, q = 7, O = new Array(64), B = new Array(64), R = new Array(64), n = new Array(256), j = new Array(2048), b = [
            0,
            1,
            5,
            6,
            14,
            15,
            27,
            28,
            2,
            4,
            7,
            13,
            16,
            26,
            29,
            42,
            3,
            8,
            12,
            17,
            25,
            30,
            41,
            43,
            9,
            11,
            18,
            24,
            31,
            40,
            44,
            53,
            10,
            19,
            23,
            32,
            39,
            45,
            52,
            54,
            20,
            22,
            33,
            38,
            46,
            51,
            55,
            60,
            21,
            34,
            37,
            47,
            50,
            56,
            59,
            61,
            35,
            36,
            48,
            49,
            57,
            58,
            62,
            63
        ], D = [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], M = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], U = [
            0,
            0,
            2,
            1,
            3,
            3,
            2,
            4,
            3,
            5,
            5,
            4,
            4,
            0,
            0,
            1,
            125
        ], N = [
            1,
            2,
            3,
            0,
            4,
            17,
            5,
            18,
            33,
            49,
            65,
            6,
            19,
            81,
            97,
            7,
            34,
            113,
            20,
            50,
            129,
            145,
            161,
            8,
            35,
            66,
            177,
            193,
            21,
            82,
            209,
            240,
            36,
            51,
            98,
            114,
            130,
            9,
            10,
            22,
            23,
            24,
            25,
            26,
            37,
            38,
            39,
            40,
            41,
            42,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            225,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            241,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ], z = [
            0,
            0,
            3,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0
        ], L = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], H = [
            0,
            0,
            2,
            1,
            2,
            4,
            4,
            3,
            4,
            7,
            5,
            4,
            4,
            0,
            1,
            2,
            119
        ], W = [
            0,
            1,
            2,
            3,
            17,
            4,
            5,
            33,
            49,
            6,
            18,
            65,
            81,
            7,
            97,
            113,
            19,
            34,
            50,
            129,
            8,
            20,
            66,
            145,
            161,
            177,
            193,
            9,
            35,
            51,
            82,
            240,
            21,
            98,
            114,
            209,
            10,
            22,
            36,
            52,
            225,
            37,
            241,
            23,
            24,
            25,
            26,
            38,
            39,
            40,
            41,
            42,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            130,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ];
        function r(t, e) {
            for(var n = 0, r = 0, i = new Array, o = 1; o <= 16; o++){
                for(var a = 1; a <= t[o]; a++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = o, r++, n++;
                n *= 2;
            }
            return i;
        }
        function G(t) {
            for(var e = t[0], n = t[1] - 1; 0 <= n;)e & 1 << n && (E |= 1 << q), n--, --q < 0 && (255 == E ? (V(255), V(0)) : V(E), q = 7, E = 0);
        }
        function V(t) {
            P.push(t);
        }
        function Y(t) {
            V(t >> 8 & 255), V(255 & t);
        }
        function X(t, e, n, r, i) {
            for(var o, a = i[0], s = i[240], h = function(t, e) {
                var n, r, i, o, a, s, h, c, l, u, f = 0;
                for(l = 0; l < 8; ++l){
                    n = t[f], r = t[f + 1], i = t[f + 2], o = t[f + 3], a = t[f + 4], s = t[f + 5], h = t[f + 6];
                    var d = n + (c = t[f + 7]), p = n - c, g = r + h, m = r - h, w = i + s, y = i - s, v = o + a, b = o - a, x = d + v, S = d - v, k = g + w, _ = g - w;
                    t[f] = x + k, t[f + 4] = x - k;
                    var A = .707106781 * (_ + S);
                    t[f + 2] = S + A, t[f + 6] = S - A;
                    var I = .382683433 * ((x = b + y) - (_ = m + p)), C = .5411961 * x + I, T = 1.306562965 * _ + I, F = .707106781 * (k = y + m), P = p + F, E = p - F;
                    t[f + 5] = E + C, t[f + 3] = E - C, t[f + 1] = P + T, t[f + 7] = P - T, f += 8;
                }
                for(l = f = 0; l < 8; ++l){
                    n = t[f], r = t[f + 8], i = t[f + 16], o = t[f + 24], a = t[f + 32], s = t[f + 40], h = t[f + 48];
                    var q = n + (c = t[f + 56]), O = n - c, B = r + h, R = r - h, j = i + s, D = i - s, M = o + a, U = o - a, N = q + M, z = q - M, L = B + j, H = B - j;
                    t[f] = N + L, t[f + 32] = N - L;
                    var W = .707106781 * (H + z);
                    t[f + 16] = z + W, t[f + 48] = z - W;
                    var G = .382683433 * ((N = U + D) - (H = R + O)), V = .5411961 * N + G, Y = 1.306562965 * H + G, X = .707106781 * (L = D + R), J = O + X, K = O - X;
                    t[f + 40] = K + V, t[f + 24] = K - V, t[f + 8] = J + Y, t[f + 56] = J - Y, f++;
                }
                for(l = 0; l < 64; ++l)u = t[l] * e[l], Q[l] = 0 < u ? u + .5 | 0 : u - .5 | 0;
                return Q;
            }(t, e), c = 0; c < 64; ++c)v[b[c]] = h[c];
            var l = v[0] - n;
            n = v[0], 0 == l ? G(r[0]) : (G(r[y[o = 32767 + l]]), G(w[o]));
            for(var u = 63; 0 < u && 0 == v[u]; u--);
            if (0 == u) return G(a), n;
            for(var f, d = 1; d <= u;){
                for(var p = d; 0 == v[d] && d <= u; ++d);
                var g = d - p;
                if (16 <= g) {
                    f = g >> 4;
                    for(var m = 1; m <= f; ++m)G(s);
                    g &= 15;
                }
                o = 32767 + v[d], G(i[(g << 4) + y[o]]), G(w[o]), d++;
            }
            return 63 != u && G(a), n;
        }
        function J(t) {
            if (t <= 0 && (t = 1), 100 < t && (t = 100), e != t) (function(t) {
                for(var e = [
                    16,
                    11,
                    10,
                    16,
                    24,
                    40,
                    51,
                    61,
                    12,
                    12,
                    14,
                    19,
                    26,
                    58,
                    60,
                    55,
                    14,
                    13,
                    16,
                    24,
                    40,
                    57,
                    69,
                    56,
                    14,
                    17,
                    22,
                    29,
                    51,
                    87,
                    80,
                    62,
                    18,
                    22,
                    37,
                    56,
                    68,
                    109,
                    103,
                    77,
                    24,
                    35,
                    55,
                    64,
                    81,
                    104,
                    113,
                    92,
                    49,
                    64,
                    78,
                    87,
                    103,
                    121,
                    120,
                    101,
                    72,
                    92,
                    95,
                    98,
                    112,
                    100,
                    103,
                    99
                ], n = 0; n < 64; n++){
                    var r = u((e[n] * t + 50) / 100);
                    r < 1 ? r = 1 : 255 < r && (r = 255), I[b[n]] = r;
                }
                for(var i = [
                    17,
                    18,
                    24,
                    47,
                    99,
                    99,
                    99,
                    99,
                    18,
                    21,
                    26,
                    66,
                    99,
                    99,
                    99,
                    99,
                    24,
                    26,
                    56,
                    99,
                    99,
                    99,
                    99,
                    99,
                    47,
                    66,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99
                ], o = 0; o < 64; o++){
                    var a = u((i[o] * t + 50) / 100);
                    a < 1 ? a = 1 : 255 < a && (a = 255), C[b[o]] = a;
                }
                for(var s = [
                    1,
                    1.387039845,
                    1.306562965,
                    1.175875602,
                    1,
                    .785694958,
                    .5411961,
                    .275899379
                ], h = 0, c = 0; c < 8; c++)for(var l = 0; l < 8; l++)T[h] = 1 / (I[b[h]] * s[c] * s[l] * 8), F[h] = 1 / (C[b[h]] * s[c] * s[l] * 8), h++;
            })(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), e = t;
        }
        this.encode = function(t, e) {
            var n, r;
            (new Date).getTime();
            e && J(e), P = new Array, E = 0, q = 7, Y(65496), Y(65504), Y(16), V(74), V(70), V(73), V(70), V(0), V(1), V(1), V(0), Y(1), Y(1), V(0), V(0), function() {
                Y(65499), Y(132), V(0);
                for(var t = 0; t < 64; t++)V(I[t]);
                V(1);
                for(var e = 0; e < 64; e++)V(C[e]);
            }(), n = t.width, r = t.height, Y(65472), Y(17), V(8), Y(r), Y(n), V(3), V(1), V(17), V(0), V(2), V(17), V(1), V(3), V(17), V(1), function() {
                Y(65476), Y(418), V(0);
                for(var t = 0; t < 16; t++)V(D[t + 1]);
                for(var e = 0; e <= 11; e++)V(M[e]);
                V(16);
                for(var n = 0; n < 16; n++)V(U[n + 1]);
                for(var r = 0; r <= 161; r++)V(N[r]);
                V(1);
                for(var i = 0; i < 16; i++)V(z[i + 1]);
                for(var o = 0; o <= 11; o++)V(L[o]);
                V(17);
                for(var a = 0; a < 16; a++)V(H[a + 1]);
                for(var s = 0; s <= 161; s++)V(W[s]);
            }(), Y(65498), Y(12), V(3), V(1), V(0), V(2), V(17), V(3), V(17), V(0), V(63), V(0);
            var i = 0, o = 0, a = 0;
            E = 0, q = 7, this.encode.displayName = "_encode_";
            for(var s, h, c, l, u, f, d, p, g, m = t.data, w = t.width, y = t.height, v = 4 * w, b = 0; b < y;){
                for(s = 0; s < v;){
                    for(f = u = v * b + s, d = -1, g = p = 0; g < 64; g++)f = u + (p = g >> 3) * v + (d = 4 * (7 & g)), y <= b + p && (f -= v * (b + 1 + p - y)), v <= s + d && (f -= s + d - v + 4), h = m[f++], c = m[f++], l = m[f++], O[g] = (j[h] + j[c + 256 >> 0] + j[l + 512 >> 0] >> 16) - 128, B[g] = (j[h + 768 >> 0] + j[c + 1024 >> 0] + j[l + 1280 >> 0] >> 16) - 128, R[g] = (j[h + 1280 >> 0] + j[c + 1536 >> 0] + j[l + 1792 >> 0] >> 16) - 128;
                    i = X(O, T, i, S, _), o = X(B, F, o, k, A), a = X(R, F, a, k, A), s += 32;
                }
                b += 8;
            }
            if (0 <= q) {
                var x = [];
                x[1] = q + 1, x[0] = (1 << q + 1) - 1, G(x);
            }
            return Y(65497), new Uint8Array(P);
        }, function() {
            (new Date).getTime();
            t || (t = 50), function() {
                for(var t = String.fromCharCode, e = 0; e < 256; e++)n[e] = t(e);
            }(), S = r(D, M), k = r(z, L), _ = r(U, N), A = r(H, W), function() {
                for(var t = 1, e = 2, n = 1; n <= 15; n++){
                    for(var r = t; r < e; r++)y[32767 + r] = n, w[32767 + r] = [], w[32767 + r][1] = n, w[32767 + r][0] = r;
                    for(var i = -(e - 1); i <= -t; i++)y[32767 + i] = n, w[32767 + i] = [], w[32767 + i][1] = n, w[32767 + i][0] = e - 1 + i;
                    t <<= 1, e <<= 1;
                }
            }(), function() {
                for(var t = 0; t < 256; t++)j[t] = 19595 * t, j[t + 256 >> 0] = 38470 * t, j[t + 512 >> 0] = 7471 * t + 32768, j[t + 768 >> 0] = -11059 * t, j[t + 1024 >> 0] = -21709 * t, j[t + 1280 >> 0] = 32768 * t + 8421375, j[t + 1536 >> 0] = -27439 * t, j[t + 1792 >> 0] = -5329 * t;
            }(), J(t), (new Date).getTime();
        }();
    }
    try {
        module.exports = yt;
    } catch (t) {}
    function xt(t, e) {
        if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
            "BM",
            "BA",
            "CI",
            "CP",
            "IC",
            "PT"
        ].indexOf(this.flag)) throw new Error("Invalid BMP File");
        this.parseHeader(), this.parseBGR();
    }
    xt.prototype.parseHeader = function() {
        if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
            var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
            this.palette = new Array(t);
            for(var e = 0; e < t; e++){
                var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0);
                this.palette[e] = {
                    red: i,
                    green: r,
                    blue: n,
                    quad: o
                };
            }
        }
        this.height < 0 && (this.height *= -1, this.bottom_up = !1);
    }, xt.prototype.parseBGR = function() {
        this.pos = this.offset;
        try {
            var t = "bit" + this.bitPP, e = this.width * this.height * 4;
            this.data = new Uint8Array(e), this[t]();
        } catch (t) {
            console.log("bit decode error:" + t);
        }
    }, xt.prototype.bit1 = function() {
        var t = Math.ceil(this.width / 8), e = t % 4, n = 0 <= this.height ? this.height - 1 : -this.height;
        for(n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++)for(var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
                var h = this.palette[o >> 7 - s & 1];
                this.data[a + 4 * s] = h.blue, this.data[a + 4 * s + 1] = h.green, this.data[a + 4 * s + 2] = h.red, this.data[a + 4 * s + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit4 = function() {
        for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
                var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 2 * i * 4, s = o >> 4, h = 15 & o, c = this.palette[s];
                if (this.data[a] = c.blue, this.data[a + 1] = c.green, this.data[a + 2] = c.red, this.data[a + 3] = 255, 2 * i + 1 >= this.width) break;
                c = this.palette[h], this.data[a + 4] = c.blue, this.data[a + 4 + 1] = c.green, this.data[a + 4 + 2] = c.red, this.data[a + 4 + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit8 = function() {
        for(var t = this.width % 4, e = this.height - 1; 0 <= e; e--){
            for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
                var i = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 4 * r;
                if (i < this.palette.length) {
                    var a = this.palette[i];
                    this.data[o] = a.red, this.data[o + 1] = a.green, this.data[o + 2] = a.blue, this.data[o + 3] = 255;
                } else this.data[o] = 255, this.data[o + 1] = 255, this.data[o + 2] = 255, this.data[o + 3] = 255;
            }
            0 != t && (this.pos += 4 - t);
        }
    }, xt.prototype.bit15 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
                var o = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var a = (o & e) / e * 255 | 0, s = (o >> 5 & e) / e * 255 | 0, h = (o >> 10 & e) / e * 255 | 0, c = o >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
                this.data[l] = h, this.data[l + 1] = s, this.data[l + 2] = a, this.data[l + 3] = c;
            }
            this.pos += t;
        }
    }, xt.prototype.bit16 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; 0 <= r; r--){
            for(var i = this.bottom_up ? r : this.height - 1 - r, o = 0; o < this.width; o++){
                var a = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var s = (a & e) / e * 255 | 0, h = (a >> 5 & n) / n * 255 | 0, c = (a >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * o;
                this.data[l] = c, this.data[l + 1] = h, this.data[l + 2] = s, this.data[l + 3] = 255;
            }
            this.pos += t;
        }
    }, xt.prototype.bit24 = function() {
        for(var t = this.height - 1; 0 <= t; t--){
            for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
                var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * n;
                this.data[a] = o, this.data[a + 1] = i, this.data[a + 2] = r, this.data[a + 3] = 255;
            }
            this.pos += this.width % 4;
        }
    }, xt.prototype.bit32 = function() {
        for(var t = this.height - 1; 0 <= t; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
            this.data[s] = o, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = a;
        }
    }, xt.prototype.getData = function() {
        return this.data;
    };
    try {
        module.exports = function(t) {
            var e = new xt(t);
            return {
                data: e.getData(),
                width: e.width,
                height: e.height
            };
        };
    } catch (t) {}
    /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ !function(t) {
        var p = 15, g = 573, e = [
            0,
            1,
            2,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            0,
            0,
            16,
            17,
            18,
            18,
            19,
            19,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29
        ];
        function ut() {
            var d = this;
            function h(t, e) {
                for(var n = 0; n |= 1 & t, t >>>= 1, n <<= 1, 0 < --e;);
                return n >>> 1;
            }
            d.build_tree = function(t) {
                var e, n, r, i = d.dyn_tree, o = d.stat_desc.static_tree, a = d.stat_desc.elems, s = -1;
                for(t.heap_len = 0, t.heap_max = g, e = 0; e < a; e++)0 !== i[2 * e] ? (t.heap[++t.heap_len] = s = e, t.depth[e] = 0) : i[2 * e + 1] = 0;
                for(; t.heap_len < 2;)i[2 * (r = t.heap[++t.heap_len] = s < 2 ? ++s : 0)] = 1, t.depth[r] = 0, t.opt_len--, o && (t.static_len -= o[2 * r + 1]);
                for(d.max_code = s, e = Math.floor(t.heap_len / 2); 1 <= e; e--)t.pqdownheap(i, e);
                for(r = a; e = t.heap[1], t.heap[1] = t.heap[t.heap_len--], t.pqdownheap(i, 1), n = t.heap[1], t.heap[--t.heap_max] = e, t.heap[--t.heap_max] = n, i[2 * r] = i[2 * e] + i[2 * n], t.depth[r] = Math.max(t.depth[e], t.depth[n]) + 1, i[2 * e + 1] = i[2 * n + 1] = r, t.heap[1] = r++, t.pqdownheap(i, 1), 2 <= t.heap_len;);
                t.heap[--t.heap_max] = t.heap[1], function(t) {
                    var e, n, r, i, o, a, s = d.dyn_tree, h = d.stat_desc.static_tree, c = d.stat_desc.extra_bits, l = d.stat_desc.extra_base, u = d.stat_desc.max_length, f = 0;
                    for(i = 0; i <= p; i++)t.bl_count[i] = 0;
                    for(s[2 * t.heap[t.heap_max] + 1] = 0, e = t.heap_max + 1; e < g; e++)u < (i = s[2 * s[2 * (n = t.heap[e]) + 1] + 1] + 1) && (i = u, f++), s[2 * n + 1] = i, n > d.max_code || (t.bl_count[i]++, o = 0, l <= n && (o = c[n - l]), a = s[2 * n], t.opt_len += a * (i + o), h && (t.static_len += a * (h[2 * n + 1] + o)));
                    if (0 !== f) {
                        do {
                            for(i = u - 1; 0 === t.bl_count[i];)i--;
                            t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[u]--, f -= 2;
                        }while (0 < f);
                        for(i = u; 0 !== i; i--)for(n = t.bl_count[i]; 0 !== n;)(r = t.heap[--e]) > d.max_code || (s[2 * r + 1] != i && (t.opt_len += (i - s[2 * r + 1]) * s[2 * r], s[2 * r + 1] = i), n--);
                    }
                }(t), function(t, e, n) {
                    var r, i, o, a = [], s = 0;
                    for(r = 1; r <= p; r++)a[r] = s = s + n[r - 1] << 1;
                    for(i = 0; i <= e; i++)0 !== (o = t[2 * i + 1]) && (t[2 * i] = h(a[o]++, o));
                }(i, d.max_code, t.bl_count);
            };
        }
        function ft(t, e, n, r, i) {
            var o = this;
            o.static_tree = t, o.extra_bits = e, o.extra_base = n, o.elems = r, o.max_length = i;
        }
        ut._length_code = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28
        ], ut.base_length = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            10,
            12,
            14,
            16,
            20,
            24,
            28,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            0
        ], ut.base_dist = [
            0,
            1,
            2,
            3,
            4,
            6,
            8,
            12,
            16,
            24,
            32,
            48,
            64,
            96,
            128,
            192,
            256,
            384,
            512,
            768,
            1024,
            1536,
            2048,
            3072,
            4096,
            6144,
            8192,
            12288,
            16384,
            24576
        ], ut.d_code = function(t) {
            return t < 256 ? e[t] : e[256 + (t >>> 7)];
        }, ut.extra_lbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0
        ], ut.extra_dbits = [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13
        ], ut.extra_blbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            3,
            7
        ], ut.bl_order = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ], ft.static_ltree = [
            12,
            8,
            140,
            8,
            76,
            8,
            204,
            8,
            44,
            8,
            172,
            8,
            108,
            8,
            236,
            8,
            28,
            8,
            156,
            8,
            92,
            8,
            220,
            8,
            60,
            8,
            188,
            8,
            124,
            8,
            252,
            8,
            2,
            8,
            130,
            8,
            66,
            8,
            194,
            8,
            34,
            8,
            162,
            8,
            98,
            8,
            226,
            8,
            18,
            8,
            146,
            8,
            82,
            8,
            210,
            8,
            50,
            8,
            178,
            8,
            114,
            8,
            242,
            8,
            10,
            8,
            138,
            8,
            74,
            8,
            202,
            8,
            42,
            8,
            170,
            8,
            106,
            8,
            234,
            8,
            26,
            8,
            154,
            8,
            90,
            8,
            218,
            8,
            58,
            8,
            186,
            8,
            122,
            8,
            250,
            8,
            6,
            8,
            134,
            8,
            70,
            8,
            198,
            8,
            38,
            8,
            166,
            8,
            102,
            8,
            230,
            8,
            22,
            8,
            150,
            8,
            86,
            8,
            214,
            8,
            54,
            8,
            182,
            8,
            118,
            8,
            246,
            8,
            14,
            8,
            142,
            8,
            78,
            8,
            206,
            8,
            46,
            8,
            174,
            8,
            110,
            8,
            238,
            8,
            30,
            8,
            158,
            8,
            94,
            8,
            222,
            8,
            62,
            8,
            190,
            8,
            126,
            8,
            254,
            8,
            1,
            8,
            129,
            8,
            65,
            8,
            193,
            8,
            33,
            8,
            161,
            8,
            97,
            8,
            225,
            8,
            17,
            8,
            145,
            8,
            81,
            8,
            209,
            8,
            49,
            8,
            177,
            8,
            113,
            8,
            241,
            8,
            9,
            8,
            137,
            8,
            73,
            8,
            201,
            8,
            41,
            8,
            169,
            8,
            105,
            8,
            233,
            8,
            25,
            8,
            153,
            8,
            89,
            8,
            217,
            8,
            57,
            8,
            185,
            8,
            121,
            8,
            249,
            8,
            5,
            8,
            133,
            8,
            69,
            8,
            197,
            8,
            37,
            8,
            165,
            8,
            101,
            8,
            229,
            8,
            21,
            8,
            149,
            8,
            85,
            8,
            213,
            8,
            53,
            8,
            181,
            8,
            117,
            8,
            245,
            8,
            13,
            8,
            141,
            8,
            77,
            8,
            205,
            8,
            45,
            8,
            173,
            8,
            109,
            8,
            237,
            8,
            29,
            8,
            157,
            8,
            93,
            8,
            221,
            8,
            61,
            8,
            189,
            8,
            125,
            8,
            253,
            8,
            19,
            9,
            275,
            9,
            147,
            9,
            403,
            9,
            83,
            9,
            339,
            9,
            211,
            9,
            467,
            9,
            51,
            9,
            307,
            9,
            179,
            9,
            435,
            9,
            115,
            9,
            371,
            9,
            243,
            9,
            499,
            9,
            11,
            9,
            267,
            9,
            139,
            9,
            395,
            9,
            75,
            9,
            331,
            9,
            203,
            9,
            459,
            9,
            43,
            9,
            299,
            9,
            171,
            9,
            427,
            9,
            107,
            9,
            363,
            9,
            235,
            9,
            491,
            9,
            27,
            9,
            283,
            9,
            155,
            9,
            411,
            9,
            91,
            9,
            347,
            9,
            219,
            9,
            475,
            9,
            59,
            9,
            315,
            9,
            187,
            9,
            443,
            9,
            123,
            9,
            379,
            9,
            251,
            9,
            507,
            9,
            7,
            9,
            263,
            9,
            135,
            9,
            391,
            9,
            71,
            9,
            327,
            9,
            199,
            9,
            455,
            9,
            39,
            9,
            295,
            9,
            167,
            9,
            423,
            9,
            103,
            9,
            359,
            9,
            231,
            9,
            487,
            9,
            23,
            9,
            279,
            9,
            151,
            9,
            407,
            9,
            87,
            9,
            343,
            9,
            215,
            9,
            471,
            9,
            55,
            9,
            311,
            9,
            183,
            9,
            439,
            9,
            119,
            9,
            375,
            9,
            247,
            9,
            503,
            9,
            15,
            9,
            271,
            9,
            143,
            9,
            399,
            9,
            79,
            9,
            335,
            9,
            207,
            9,
            463,
            9,
            47,
            9,
            303,
            9,
            175,
            9,
            431,
            9,
            111,
            9,
            367,
            9,
            239,
            9,
            495,
            9,
            31,
            9,
            287,
            9,
            159,
            9,
            415,
            9,
            95,
            9,
            351,
            9,
            223,
            9,
            479,
            9,
            63,
            9,
            319,
            9,
            191,
            9,
            447,
            9,
            127,
            9,
            383,
            9,
            255,
            9,
            511,
            9,
            0,
            7,
            64,
            7,
            32,
            7,
            96,
            7,
            16,
            7,
            80,
            7,
            48,
            7,
            112,
            7,
            8,
            7,
            72,
            7,
            40,
            7,
            104,
            7,
            24,
            7,
            88,
            7,
            56,
            7,
            120,
            7,
            4,
            7,
            68,
            7,
            36,
            7,
            100,
            7,
            20,
            7,
            84,
            7,
            52,
            7,
            116,
            7,
            3,
            8,
            131,
            8,
            67,
            8,
            195,
            8,
            35,
            8,
            163,
            8,
            99,
            8,
            227,
            8
        ], ft.static_dtree = [
            0,
            5,
            16,
            5,
            8,
            5,
            24,
            5,
            4,
            5,
            20,
            5,
            12,
            5,
            28,
            5,
            2,
            5,
            18,
            5,
            10,
            5,
            26,
            5,
            6,
            5,
            22,
            5,
            14,
            5,
            30,
            5,
            1,
            5,
            17,
            5,
            9,
            5,
            25,
            5,
            5,
            5,
            21,
            5,
            13,
            5,
            29,
            5,
            3,
            5,
            19,
            5,
            11,
            5,
            27,
            5,
            7,
            5,
            23,
            5
        ], ft.static_l_desc = new ft(ft.static_ltree, ut.extra_lbits, 257, 286, p), ft.static_d_desc = new ft(ft.static_dtree, ut.extra_dbits, 0, 30, p), ft.static_bl_desc = new ft(null, ut.extra_blbits, 0, 19, 7);
        function n(t, e, n, r, i) {
            var o = this;
            o.good_length = t, o.max_lazy = e, o.nice_length = n, o.max_chain = r, o.func = i;
        }
        var dt = [
            new n(0, 0, 0, 0, 0),
            new n(4, 4, 8, 4, 1),
            new n(4, 5, 16, 8, 1),
            new n(4, 6, 32, 32, 1),
            new n(4, 4, 16, 16, 2),
            new n(8, 16, 32, 32, 2),
            new n(8, 16, 128, 128, 2),
            new n(8, 32, 128, 256, 2),
            new n(32, 128, 258, 1024, 2),
            new n(32, 258, 258, 4096, 2)
        ], pt = [
            "need dictionary",
            "stream end",
            "",
            "",
            "stream error",
            "data error",
            "",
            "buffer error",
            "",
            ""
        ], gt = 262;
        function mt(t, e, n, r) {
            var i = t[2 * e], o = t[2 * n];
            return i < o || i == o && r[e] <= r[n];
        }
        function r() {
            var h, c, l, u, f, d, p, g, i, m, w, y, v, a, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, s, j, D, M, U, N, z, o, L, H, W, G = this, V = new ut, Y = new ut, X = new ut;
            function J() {
                var t;
                for(t = 0; t < 286; t++)s[2 * t] = 0;
                for(t = 0; t < 30; t++)j[2 * t] = 0;
                for(t = 0; t < 19; t++)D[2 * t] = 0;
                s[512] = 1, G.opt_len = G.static_len = 0, N = o = 0;
            }
            function K(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), t[2 * (e + 1) + 1] = 65535, n = 0; n <= e; n++)r = o, o = t[2 * (n + 1) + 1], ++a < s && r == o || (a < h ? D[2 * r] += a : 0 !== r ? (r != i && D[2 * r]++, D[32]++) : a <= 10 ? D[34]++ : D[36]++, i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4));
            }
            function Q(t) {
                G.pending_buf[G.pending++] = t;
            }
            function Z(t) {
                Q(255 & t), Q(t >>> 8 & 255);
            }
            function $(t, e) {
                var n, r = e;
                16 - r < W ? (Z(H |= (n = t) << W & 65535), H = n >>> 16 - W, W += r - 16) : (H |= t << W & 65535, W += r);
            }
            function tt(t, e) {
                var n = 2 * t;
                $(65535 & e[n], 65535 & e[n + 1]);
            }
            function et(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), n = 0; n <= e; n++)if (r = o, o = t[2 * (n + 1) + 1], !(++a < s && r == o)) {
                    if (a < h) for(; tt(r, D), 0 != --a;);
                    else 0 !== r ? (r != i && (tt(r, D), a--), tt(16, D), $(a - 3, 2)) : a <= 10 ? (tt(17, D), $(a - 3, 3)) : (tt(18, D), $(a - 11, 7));
                    i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4);
                }
            }
            function nt() {
                16 == W ? (Z(H), W = H = 0) : 8 <= W && (Q(255 & H), H >>>= 8, W -= 8);
            }
            function rt(t, e) {
                var n, r, i;
                if (G.pending_buf[z + 2 * N] = t >>> 8 & 255, G.pending_buf[z + 2 * N + 1] = 255 & t, G.pending_buf[M + N] = 255 & e, N++, 0 === t ? s[2 * e]++ : (o++, t--, s[2 * (ut._length_code[e] + 256 + 1)]++, j[2 * ut.d_code(t)]++), 0 == (8191 & N) && 2 < q) {
                    for(n = 8 * N, r = I - S, i = 0; i < 30; i++)n += j[2 * i] * (5 + ut.extra_dbits[i]);
                    if (n >>>= 3, o < Math.floor(N / 2) && n < Math.floor(r / 2)) return !0;
                }
                return N == U - 1;
            }
            function it(t, e) {
                var n, r, i, o, a = 0;
                if (0 !== N) for(; n = G.pending_buf[z + 2 * a] << 8 & 65280 | 255 & G.pending_buf[z + 2 * a + 1], r = 255 & G.pending_buf[M + a], a++, 0 === n ? tt(r, t) : (tt((i = ut._length_code[r]) + 256 + 1, t), 0 !== (o = ut.extra_lbits[i]) && $(r -= ut.base_length[i], o), tt(i = ut.d_code(--n), e), 0 !== (o = ut.extra_dbits[i]) && $(n -= ut.base_dist[i], o)), a < N;);
                tt(256, t), L = t[513];
            }
            function ot() {
                8 < W ? Z(H) : 0 < W && Q(255 & H), W = H = 0;
            }
            function at(t, e, n) {
                var r, i, o;
                $(0 + (n ? 1 : 0), 3), r = t, i = e, o = !0, ot(), L = 8, o && (Z(i), Z(~i)), G.pending_buf.set(g.subarray(r, r + i), G.pending), G.pending += i;
            }
            function e(t, e, n) {
                var r, i, o = 0;
                0 < q ? (V.build_tree(G), Y.build_tree(G), o = function() {
                    var t;
                    for(K(s, V.max_code), K(j, Y.max_code), X.build_tree(G), t = 18; 3 <= t && 0 === D[2 * ut.bl_order[t] + 1]; t--);
                    return G.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                }(), r = G.opt_len + 3 + 7 >>> 3, (i = G.static_len + 3 + 7 >>> 3) <= r && (r = i)) : r = i = e + 5, e + 4 <= r && -1 != t ? at(t, e, n) : i == r ? ($(2 + (n ? 1 : 0), 3), it(ft.static_ltree, ft.static_dtree)) : ($(4 + (n ? 1 : 0), 3), function(t, e, n) {
                    var r;
                    for($(t - 257, 5), $(e - 1, 5), $(n - 4, 4), r = 0; r < n; r++)$(D[2 * ut.bl_order[r] + 1], 3);
                    et(s, t - 1), et(j, e - 1);
                }(V.max_code + 1, Y.max_code + 1, o + 1), it(s, j)), J(), n && ot();
            }
            function st(t) {
                e(0 <= S ? S : -1, I - S, t), S = I, h.flush_pending();
            }
            function ht() {
                var t, e, n, r;
                do {
                    if (0 === (r = i - T - I) && 0 === I && 0 === T) r = f;
                    else if (-1 == r) r--;
                    else if (f + f - gt <= I) {
                        for(g.set(g.subarray(f, f + f), 0), C -= f, I -= f, S -= f, n = t = v; e = 65535 & w[--n], w[n] = f <= e ? e - f : 0, 0 != --t;);
                        for(n = t = f; e = 65535 & m[--n], m[n] = f <= e ? e - f : 0, 0 != --t;);
                        r += f;
                    }
                    if (0 === h.avail_in) return;
                    t = h.read_buf(g, I + T, r), 3 <= (T += t) && (y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b);
                }while (T < gt && 0 !== h.avail_in);
            }
            function ct(t) {
                var e, n, r = P, i = I, o = F, a = f - gt < I ? I - (f - gt) : 0, s = R, h = p, c = I + 258, l = g[i + o - 1], u = g[i + o];
                B <= F && (r >>= 2), T < s && (s = T);
                do if (g[(e = t) + o] == u && g[e + o - 1] == l && g[e] == g[i] && g[++e] == g[i + 1]) {
                    i += 2, e++;
                    do ;
                    while (g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && i < c);
                    if (n = 258 - (c - i), i = c - 258, o < n) {
                        if (C = t, s <= (o = n)) break;
                        l = g[i + o - 1], u = g[i + o];
                    }
                }
                while ((t = 65535 & m[t & h]) > a && 0 != --r);
                return o <= T ? o : T;
            }
            function lt(t) {
                return t.total_in = t.total_out = 0, t.msg = null, G.pending = 0, G.pending_out = 0, c = 113, u = 0, V.dyn_tree = s, V.stat_desc = ft.static_l_desc, Y.dyn_tree = j, Y.stat_desc = ft.static_d_desc, X.dyn_tree = D, X.stat_desc = ft.static_bl_desc, W = H = 0, L = 8, J(), function() {
                    var t;
                    for(i = 2 * f, t = w[v - 1] = 0; t < v - 1; t++)w[t] = 0;
                    E = dt[q].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain, k = F = 2, y = A = T = S = I = 0;
                }(), 0;
            }
            G.depth = [], G.bl_count = [], G.heap = [], s = [], j = [], D = [], G.pqdownheap = function(t, e) {
                for(var n = G.heap, r = n[e], i = e << 1; i <= G.heap_len && (i < G.heap_len && mt(t, n[i + 1], n[i], G.depth) && i++, !mt(t, r, n[i], G.depth));)n[e] = n[i], e = i, i <<= 1;
                n[e] = r;
            }, G.deflateInit = function(t, e, n, r, i, o) {
                return r || (r = 8), i || (i = 8), o || (o = 0), t.msg = null, -1 == e && (e = 6), i < 1 || 9 < i || 8 != r || n < 9 || 15 < n || e < 0 || 9 < e || o < 0 || 2 < o ? -2 : (t.dstate = G, p = (f = 1 << (d = n)) - 1, b = (v = 1 << (a = i + 7)) - 1, x = Math.floor((a + 3 - 1) / 3), g = new Uint8Array(2 * f), m = [], w = [], U = 1 << i + 6, G.pending_buf = new Uint8Array(4 * U), l = 4 * U, z = Math.floor(U / 2), M = 3 * U, q = e, O = o, lt(t));
            }, G.deflateEnd = function() {
                return 42 != c && 113 != c && 666 != c ? -2 : (G.pending_buf = null, g = m = w = null, G.dstate = null, 113 == c ? -3 : 0);
            }, G.deflateParams = function(t, e, n) {
                var r = 0;
                return -1 == e && (e = 6), e < 0 || 9 < e || n < 0 || 2 < n ? -2 : (dt[q].func != dt[e].func && 0 !== t.total_in && (r = t.deflate(1)), q != e && (E = dt[q = e].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain), O = n, r);
            }, G.deflateSetDictionary = function(t, e, n) {
                var r, i = n, o = 0;
                if (!e || 42 != c) return -2;
                if (i < 3) return 0;
                for(f - gt < i && (o = n - (i = f - gt)), g.set(e.subarray(o, o + i), 0), S = I = i, y = ((y = 255 & g[0]) << x ^ 255 & g[1]) & b, r = 0; r <= i - 3; r++)y = (y << x ^ 255 & g[r + 2]) & b, m[r & p] = w[y], w[y] = r;
                return 0;
            }, G.deflate = function(t, e) {
                var n, r, i, o, a, s;
                if (4 < e || e < 0) return -2;
                if (!t.next_out || !t.next_in && 0 !== t.avail_in || 666 == c && 4 != e) return t.msg = pt[4], -2;
                if (0 === t.avail_out) return t.msg = pt[7], -5;
                if (h = t, o = u, u = e, 42 == c && (r = 8 + (d - 8 << 4) << 8, 3 < (i = (q - 1 & 255) >> 1) && (i = 3), r |= i << 6, 0 !== I && (r |= 32), c = 113, Q((s = r += 31 - r % 31) >> 8 & 255), Q(255 & s)), 0 !== G.pending) {
                    if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                } else if (0 === h.avail_in && e <= o && 4 != e) return h.msg = pt[7], -5;
                if (666 == c && 0 !== h.avail_in) return t.msg = pt[7], -5;
                if (0 !== h.avail_in || 0 !== T || 0 != e && 666 != c) {
                    switch(a = -1, dt[q].func){
                        case 0:
                            a = function(t) {
                                var e, n = 65535;
                                for(l - 5 < n && (n = l - 5);;){
                                    if (T <= 1) {
                                        if (ht(), 0 === T && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (I += T, e = S + n, ((T = 0) === I || e <= I) && (T = I - e, I = e, st(!1), 0 === h.avail_out)) return 0;
                                    if (f - gt <= I - S && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 1:
                            a = function(t) {
                                for(var e, n = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 !== n && (I - n & 65535) <= f - gt && 2 != O && (k = ct(n)), 3 <= k) {
                                        if (e = rt(I - C, k - 3), T -= k, k <= E && 3 <= T) {
                                            for(k--; y = (y << x ^ 255 & g[++I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I, 0 != --k;);
                                            I++;
                                        } else I += k, k = 0, y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b;
                                    } else e = rt(0, 255 & g[I]), T--, I++;
                                    if (e && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 2:
                            a = function(t) {
                                for(var e, n, r = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), F = k, _ = C, k = 2, 0 !== r && F < E && (I - r & 65535) <= f - gt && (2 != O && (k = ct(r)), k <= 5 && (1 == O || 3 == k && 4096 < I - C) && (k = 2)), 3 <= F && k <= F) {
                                        for(n = I + T - 3, e = rt(I - 1 - _, F - 3), T -= F - 1, F -= 2; ++I <= n && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 != --F;);
                                        if (A = 0, k = 2, I++, e && (st(!1), 0 === h.avail_out)) return 0;
                                    } else if (0 !== A) {
                                        if ((e = rt(0, 255 & g[I - 1])) && st(!1), I++, T--, 0 === h.avail_out) return 0;
                                    } else A = 1, I++, T--;
                                }
                                return 0 !== A && (e = rt(0, 255 & g[I - 1]), A = 0), st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                    }
                    if (2 != a && 3 != a || (c = 666), 0 == a || 2 == a) return 0 === h.avail_out && (u = -1), 0;
                    if (1 == a) {
                        if (1 == e) $(2, 3), tt(256, ft.static_ltree), nt(), 1 + L + 10 - W < 9 && ($(2, 3), tt(256, ft.static_ltree), nt()), L = 7;
                        else if (at(0, 0, !1), 3 == e) for(n = 0; n < v; n++)w[n] = 0;
                        if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                    }
                }
                return 4 != e ? 0 : 1;
            };
        }
        function i() {
            var t = this;
            t.next_in_index = 0, t.next_out_index = 0, t.avail_in = 0, t.total_in = 0, t.avail_out = 0, t.total_out = 0;
        }
        i.prototype = {
            deflateInit: function(t, e) {
                return this.dstate = new r, e || (e = p), this.dstate.deflateInit(this, t, e);
            },
            deflate: function(t) {
                return this.dstate ? this.dstate.deflate(this, t) : -2;
            },
            deflateEnd: function() {
                if (!this.dstate) return -2;
                var t = this.dstate.deflateEnd();
                return this.dstate = null, t;
            },
            deflateParams: function(t, e) {
                return this.dstate ? this.dstate.deflateParams(this, t, e) : -2;
            },
            deflateSetDictionary: function(t, e) {
                return this.dstate ? this.dstate.deflateSetDictionary(this, t, e) : -2;
            },
            read_buf: function(t, e, n) {
                var r = this, i = r.avail_in;
                return n < i && (i = n), 0 === i ? 0 : (r.avail_in -= i, t.set(r.next_in.subarray(r.next_in_index, r.next_in_index + i), e), r.next_in_index += i, r.total_in += i, i);
            },
            flush_pending: function() {
                var t = this, e = t.dstate.pending;
                e > t.avail_out && (e = t.avail_out), 0 !== e && (t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out, t.dstate.pending_out + e), t.next_out_index), t.next_out_index += e, t.dstate.pending_out += e, t.total_out += e, t.avail_out -= e, t.dstate.pending -= e, 0 === t.dstate.pending && (t.dstate.pending_out = 0));
            }
        };
        var o = t.zip || t;
        o.Deflater = o._jzlib_Deflater = function(t) {
            var s = new i, h = new Uint8Array(512), e = t ? t.level : -1;
            void 0 === e && (e = -1), s.deflateInit(e), s.next_out = h, this.append = function(t, e) {
                var n, r = [], i = 0, o = 0, a = 0;
                if (t.length) {
                    s.next_in_index = 0, s.next_in = t, s.avail_in = t.length;
                    do {
                        if (s.next_out_index = 0, s.avail_out = 512, 0 != s.deflate(0)) throw new Error("deflating: " + s.msg);
                        s.next_out_index && (512 == s.next_out_index ? r.push(new Uint8Array(h)) : r.push(new Uint8Array(h.subarray(0, s.next_out_index)))), a += s.next_out_index, e && 0 < s.next_in_index && s.next_in_index != i && (e(s.next_in_index), i = s.next_in_index);
                    }while (0 < s.avail_in || 0 === s.avail_out);
                    return n = new Uint8Array(a), r.forEach(function(t) {
                        n.set(t, o), o += t.length;
                    }), n;
                }
            }, this.flush = function() {
                var t, e, n = [], r = 0, i = 0;
                do {
                    if (s.next_out_index = 0, s.avail_out = 512, 1 != (t = s.deflate(4)) && 0 != t) throw new Error("deflating: " + s.msg);
                    0 < 512 - s.avail_out && n.push(new Uint8Array(h.subarray(0, s.next_out_index))), i += s.next_out_index;
                }while (0 < s.avail_in || 0 === s.avail_out);
                return s.deflateEnd(), e = new Uint8Array(i), n.forEach(function(t) {
                    e.set(t, r), r += t.length;
                }), e;
            };
        };
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /**
   * A class to parse color values
   * @author Stoyan Stefanov <sstoo@gmail.com>
   * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
   * @license Use it if you like it
   */ function(t) {
        function f(t) {
            var e;
            this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = (t = t.replace(/ /g, "")).toLowerCase();
            var l = {
                aliceblue: "f0f8ff",
                antiquewhite: "faebd7",
                aqua: "00ffff",
                aquamarine: "7fffd4",
                azure: "f0ffff",
                beige: "f5f5dc",
                bisque: "ffe4c4",
                black: "000000",
                blanchedalmond: "ffebcd",
                blue: "0000ff",
                blueviolet: "8a2be2",
                brown: "a52a2a",
                burlywood: "deb887",
                cadetblue: "5f9ea0",
                chartreuse: "7fff00",
                chocolate: "d2691e",
                coral: "ff7f50",
                cornflowerblue: "6495ed",
                cornsilk: "fff8dc",
                crimson: "dc143c",
                cyan: "00ffff",
                darkblue: "00008b",
                darkcyan: "008b8b",
                darkgoldenrod: "b8860b",
                darkgray: "a9a9a9",
                darkgreen: "006400",
                darkkhaki: "bdb76b",
                darkmagenta: "8b008b",
                darkolivegreen: "556b2f",
                darkorange: "ff8c00",
                darkorchid: "9932cc",
                darkred: "8b0000",
                darksalmon: "e9967a",
                darkseagreen: "8fbc8f",
                darkslateblue: "483d8b",
                darkslategray: "2f4f4f",
                darkturquoise: "00ced1",
                darkviolet: "9400d3",
                deeppink: "ff1493",
                deepskyblue: "00bfff",
                dimgray: "696969",
                dodgerblue: "1e90ff",
                feldspar: "d19275",
                firebrick: "b22222",
                floralwhite: "fffaf0",
                forestgreen: "228b22",
                fuchsia: "ff00ff",
                gainsboro: "dcdcdc",
                ghostwhite: "f8f8ff",
                gold: "ffd700",
                goldenrod: "daa520",
                gray: "808080",
                green: "008000",
                greenyellow: "adff2f",
                honeydew: "f0fff0",
                hotpink: "ff69b4",
                indianred: "cd5c5c",
                indigo: "4b0082",
                ivory: "fffff0",
                khaki: "f0e68c",
                lavender: "e6e6fa",
                lavenderblush: "fff0f5",
                lawngreen: "7cfc00",
                lemonchiffon: "fffacd",
                lightblue: "add8e6",
                lightcoral: "f08080",
                lightcyan: "e0ffff",
                lightgoldenrodyellow: "fafad2",
                lightgrey: "d3d3d3",
                lightgreen: "90ee90",
                lightpink: "ffb6c1",
                lightsalmon: "ffa07a",
                lightseagreen: "20b2aa",
                lightskyblue: "87cefa",
                lightslateblue: "8470ff",
                lightslategray: "778899",
                lightsteelblue: "b0c4de",
                lightyellow: "ffffe0",
                lime: "00ff00",
                limegreen: "32cd32",
                linen: "faf0e6",
                magenta: "ff00ff",
                maroon: "800000",
                mediumaquamarine: "66cdaa",
                mediumblue: "0000cd",
                mediumorchid: "ba55d3",
                mediumpurple: "9370d8",
                mediumseagreen: "3cb371",
                mediumslateblue: "7b68ee",
                mediumspringgreen: "00fa9a",
                mediumturquoise: "48d1cc",
                mediumvioletred: "c71585",
                midnightblue: "191970",
                mintcream: "f5fffa",
                mistyrose: "ffe4e1",
                moccasin: "ffe4b5",
                navajowhite: "ffdead",
                navy: "000080",
                oldlace: "fdf5e6",
                olive: "808000",
                olivedrab: "6b8e23",
                orange: "ffa500",
                orangered: "ff4500",
                orchid: "da70d6",
                palegoldenrod: "eee8aa",
                palegreen: "98fb98",
                paleturquoise: "afeeee",
                palevioletred: "d87093",
                papayawhip: "ffefd5",
                peachpuff: "ffdab9",
                peru: "cd853f",
                pink: "ffc0cb",
                plum: "dda0dd",
                powderblue: "b0e0e6",
                purple: "800080",
                red: "ff0000",
                rosybrown: "bc8f8f",
                royalblue: "4169e1",
                saddlebrown: "8b4513",
                salmon: "fa8072",
                sandybrown: "f4a460",
                seagreen: "2e8b57",
                seashell: "fff5ee",
                sienna: "a0522d",
                silver: "c0c0c0",
                skyblue: "87ceeb",
                slateblue: "6a5acd",
                slategray: "708090",
                snow: "fffafa",
                springgreen: "00ff7f",
                steelblue: "4682b4",
                tan: "d2b48c",
                teal: "008080",
                thistle: "d8bfd8",
                tomato: "ff6347",
                turquoise: "40e0d0",
                violet: "ee82ee",
                violetred: "d02090",
                wheat: "f5deb3",
                white: "ffffff",
                whitesmoke: "f5f5f5",
                yellow: "ffff00",
                yellowgreen: "9acd32"
            };
            for(var n in l)t == n && (t = l[n]);
            for(var u = [
                {
                    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                    example: [
                        "rgb(123, 234, 45)",
                        "rgb(255,234,245)"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1]),
                            parseInt(t[2]),
                            parseInt(t[3])
                        ];
                    }
                },
                {
                    re: /^(\w{2})(\w{2})(\w{2})$/,
                    example: [
                        "#00ff00",
                        "336699"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1], 16),
                            parseInt(t[2], 16),
                            parseInt(t[3], 16)
                        ];
                    }
                },
                {
                    re: /^(\w{1})(\w{1})(\w{1})$/,
                    example: [
                        "#fb0",
                        "f0f"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1] + t[1], 16),
                            parseInt(t[2] + t[2], 16),
                            parseInt(t[3] + t[3], 16)
                        ];
                    }
                }
            ], r = 0; r < u.length; r++){
                var i = u[r].re, o = u[r].process, a = i.exec(t);
                a && (e = o(a), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
            }
            this.r = this.r < 0 || isNaN(this.r) ? 0 : 255 < this.r ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : 255 < this.g ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : 255 < this.b ? 255 : this.b, this.toRGB = function() {
                return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
            }, this.toHex = function() {
                var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
                return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
            }, this.getHelpXML = function() {
                for(var t = new Array, e = 0; e < u.length; e++)for(var n = u[e].example, r = 0; r < n.length; r++)t[t.length] = n[r];
                for(var i in l)t[t.length] = i;
                var o = document.createElement("ul");
                o.setAttribute("id", "rgbcolor-examples");
                for(e = 0; e < t.length; e++)try {
                    var a = document.createElement("li"), s = new f(t[e]), h = document.createElement("div");
                    h.style.cssText = "margin: 3px; border: 1px solid black; background:" + s.toHex() + "; color:" + s.toHex(), h.appendChild(document.createTextNode("test"));
                    var c = document.createTextNode(" " + t[e] + " -> " + s.toRGB() + " -> " + s.toHex());
                    a.appendChild(h), a.appendChild(c), o.appendChild(a);
                } catch (t) {}
                return o;
            };
        }
        "undefined" != typeof define && define.amd ? define("RGBColor", function() {
            return f;
        }) : (0, module.exports) && (module.exports = f), t.RGBColor = f;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), function(t) {
        var e;
        module.exports = t();
    }(function() {
        return (function o(a, s, h) {
            function c(n, t) {
                if (!s[n]) {
                    if (!a[n]) {
                        var e = undefined;
                        if (!t && e) return e(n, !0);
                        if (l) return l(n, !0);
                        var r = new Error("Cannot find module '" + n + "'");
                        throw r.code = "MODULE_NOT_FOUND", r;
                    }
                    var i = s[n] = {
                        exports: {}
                    };
                    a[n][0].call(i.exports, function(t) {
                        var e = a[n][1][t];
                        return c(e || t);
                    }, i, i.exports, o, a, s, h);
                }
                return s[n].exports;
            }
            for(var l = undefined, t = 0; t < h.length; t++)c(h[t]);
            return c;
        })({
            1: [
                function(t, q, O) {
                    (function(E) {
                        !function(t) {
                            var e = "object" == typeof O && O, n = "object" == typeof q && q && q.exports == e && q, r = "object" == typeof E && E;
                            r.global !== r && r.window !== r || (t = r);
                            var i, o, w = 2147483647, y = 36, v = 1, b = 26, a = 38, s = 700, x = 72, S = 128, k = "-", h = /^xn--/, c = /[^ -~]/, l = /\x2E|\u3002|\uFF0E|\uFF61/g, u = {
                                overflow: "Overflow: input needs wider integers to process",
                                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                                "invalid-input": "Invalid input"
                            }, f = y - v, _ = Math.floor, A = String.fromCharCode;
                            function I(t) {
                                throw RangeError(u[t]);
                            }
                            function d(t, e) {
                                for(var n = t.length; n--;)t[n] = e(t[n]);
                                return t;
                            }
                            function p(t, e) {
                                return d(t.split(l), e).join(".");
                            }
                            function C(t) {
                                for(var e, n, r = [], i = 0, o = t.length; i < o;)55296 <= (e = t.charCodeAt(i++)) && e <= 56319 && i < o ? 56320 == (64512 & (n = t.charCodeAt(i++))) ? r.push(((1023 & e) << 10) + (1023 & n) + 65536) : (r.push(e), i--) : r.push(e);
                                return r;
                            }
                            function T(t) {
                                return d(t, function(t) {
                                    var e = "";
                                    return 65535 < t && (e += A((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += A(t);
                                }).join("");
                            }
                            function F(t, e) {
                                return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                            }
                            function P(t, e, n) {
                                var r = 0;
                                for(t = n ? _(t / s) : t >> 1, t += _(t / e); f * b >> 1 < t; r += y)t = _(t / f);
                                return _(r + (f + 1) * t / (t + a));
                            }
                            function g(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f = [], d = t.length, p = 0, g = S, m = x;
                                for((n = t.lastIndexOf(k)) < 0 && (n = 0), r = 0; r < n; ++r)128 <= t.charCodeAt(r) && I("not-basic"), f.push(t.charCodeAt(r));
                                for(i = 0 < n ? n + 1 : 0; i < d;){
                                    for(o = p, a = 1, s = y; d <= i && I("invalid-input"), u = t.charCodeAt(i++), (y <= (h = u - 48 < 10 ? u - 22 : u - 65 < 26 ? u - 65 : u - 97 < 26 ? u - 97 : y) || h > _((w - p) / a)) && I("overflow"), p += h * a, !(h < (c = s <= m ? v : m + b <= s ? b : s - m)); s += y)a > _(w / (l = y - c)) && I("overflow"), a *= l;
                                    m = P(p - o, e = f.length + 1, 0 == o), _(p / e) > w - g && I("overflow"), g += _(p / e), p %= e, f.splice(p++, 0, g);
                                }
                                return T(f);
                            }
                            function m(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g, m = [];
                                for(f = (t = C(t)).length, e = S, o = x, a = n = 0; a < f; ++a)(u = t[a]) < 128 && m.push(A(u));
                                for(r = i = m.length, i && m.push(k); r < f;){
                                    for(s = w, a = 0; a < f; ++a)e <= (u = t[a]) && u < s && (s = u);
                                    for(s - e > _((w - n) / (d = r + 1)) && I("overflow"), n += (s - e) * d, e = s, a = 0; a < f; ++a)if ((u = t[a]) < e && ++n > w && I("overflow"), u == e) {
                                        for(h = n, c = y; !(h < (l = c <= o ? v : o + b <= c ? b : c - o)); c += y)g = h - l, p = y - l, m.push(A(F(l + g % p, 0))), h = _(g / p);
                                        m.push(A(F(h, 0))), o = P(n, d, r == i), n = 0, ++r;
                                    }
                                    ++n, ++e;
                                }
                                return m.join("");
                            }
                            if (i = {
                                version: "1.2.4",
                                ucs2: {
                                    decode: C,
                                    encode: T
                                },
                                decode: g,
                                encode: m,
                                toASCII: function(t) {
                                    return p(t, function(t) {
                                        return c.test(t) ? "xn--" + m(t) : t;
                                    });
                                },
                                toUnicode: function(t) {
                                    return p(t, function(t) {
                                        return h.test(t) ? g(t.slice(4).toLowerCase()) : t;
                                    });
                                }
                            }, e && !e.nodeType) {
                                if (n) n.exports = i;
                                else for(o in i)i.hasOwnProperty(o) && (e[o] = i[o]);
                            } else t.punycode = i;
                        }(this);
                    }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                },
                {}
            ],
            2: [
                function(t, e, n) {
                    var i = t("./log");
                    function u(t, e) {
                        for(var n = 3 === t.nodeType ? document.createTextNode(t.nodeValue) : t.cloneNode(!1), r = t.firstChild; r;)!0 !== e && 1 === r.nodeType && "SCRIPT" === r.nodeName || n.appendChild(u(r, e)), r = r.nextSibling;
                        return 1 === t.nodeType && (n._scrollTop = t.scrollTop, n._scrollLeft = t.scrollLeft, "CANVAS" === t.nodeName ? function(e, t) {
                            try {
                                t && (t.width = e.width, t.height = e.height, t.getContext("2d").putImageData(e.getContext("2d").getImageData(0, 0, e.width, e.height), 0, 0));
                            } catch (t) {
                                i("Unable to copy canvas content from", e, t);
                            }
                        }(t, n) : "TEXTAREA" !== t.nodeName && "SELECT" !== t.nodeName || (n.value = t.value)), n;
                    }
                    e.exports = function(o, t, e, n, a, s, h) {
                        var c = u(o.documentElement, a.javascriptEnabled), l = t.createElement("iframe");
                        return l.className = "html2canvas-container", l.style.visibility = "hidden", l.style.position = "fixed", l.style.left = "-10000px", l.style.top = "0px", l.style.border = "0", l.width = e, l.height = n, l.scrolling = "no", t.body.appendChild(l), new Promise(function(e) {
                            var t, n, r, i = l.contentWindow.document;
                            l.contentWindow.onload = l.onload = function() {
                                var t = setInterval(function() {
                                    0 < i.body.childNodes.length && (!function t(e) {
                                        if (1 === e.nodeType) {
                                            e.scrollTop = e._scrollTop, e.scrollLeft = e._scrollLeft;
                                            for(var n = e.firstChild; n;)t(n), n = n.nextSibling;
                                        }
                                    }(i.documentElement), clearInterval(t), "view" === a.type && (l.contentWindow.scrollTo(s, h), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || l.contentWindow.scrollY === h && l.contentWindow.scrollX === s || (i.documentElement.style.top = -h + "px", i.documentElement.style.left = -s + "px", i.documentElement.style.position = "absolute")), e(l));
                                }, 50);
                            }, i.open(), i.write("<!DOCTYPE html><html></html>"), n = s, r = h, !(t = o).defaultView || n === t.defaultView.pageXOffset && r === t.defaultView.pageYOffset || t.defaultView.scrollTo(n, r), i.replaceChild(i.adoptNode(c), i.documentElement), i.close();
                        });
                    };
                },
                {
                    "./log": 13
                }
            ],
            3: [
                function(t, e, n) {
                    function r(t) {
                        this.r = 0, this.g = 0, this.b = 0, this.a = null;
                        this.fromArray(t) || this.namedColor(t) || this.rgb(t) || this.rgba(t) || this.hex6(t) || this.hex3(t);
                    }
                    r.prototype.darken = function(t) {
                        var e = 1 - t;
                        return new r([
                            Math.round(this.r * e),
                            Math.round(this.g * e),
                            Math.round(this.b * e),
                            this.a
                        ]);
                    }, r.prototype.isTransparent = function() {
                        return 0 === this.a;
                    }, r.prototype.isBlack = function() {
                        return 0 === this.r && 0 === this.g && 0 === this.b;
                    }, r.prototype.fromArray = function(t) {
                        return Array.isArray(t) && (this.r = Math.min(t[0], 255), this.g = Math.min(t[1], 255), this.b = Math.min(t[2], 255), 3 < t.length && (this.a = t[3])), Array.isArray(t);
                    };
                    var i = /^#([a-f0-9]{3})$/i;
                    r.prototype.hex3 = function(t) {
                        var e;
                        return null !== (e = t.match(i)) && (this.r = parseInt(e[1][0] + e[1][0], 16), this.g = parseInt(e[1][1] + e[1][1], 16), this.b = parseInt(e[1][2] + e[1][2], 16)), null !== e;
                    };
                    var o = /^#([a-f0-9]{6})$/i;
                    r.prototype.hex6 = function(t) {
                        var e = null;
                        return null !== (e = t.match(o)) && (this.r = parseInt(e[1].substring(0, 2), 16), this.g = parseInt(e[1].substring(2, 4), 16), this.b = parseInt(e[1].substring(4, 6), 16)), null !== e;
                    };
                    var a = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    r.prototype.rgb = function(t) {
                        var e;
                        return null !== (e = t.match(a)) && (this.r = Number(e[1]), this.g = Number(e[2]), this.b = Number(e[3])), null !== e;
                    };
                    var s = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
                    r.prototype.rgba = function(t) {
                        var e;
                        return null !== (e = t.match(s)) && (this.r = Number(e[1]), this.g = Number(e[2]), this.b = Number(e[3]), this.a = Number(e[4])), null !== e;
                    }, r.prototype.toString = function() {
                        return null !== this.a && 1 !== this.a ? "rgba(" + [
                            this.r,
                            this.g,
                            this.b,
                            this.a
                        ].join(",") + ")" : "rgb(" + [
                            this.r,
                            this.g,
                            this.b
                        ].join(",") + ")";
                    }, r.prototype.namedColor = function(t) {
                        t = t.toLowerCase();
                        var e = h[t];
                        if (e) this.r = e[0], this.g = e[1], this.b = e[2];
                        else if ("transparent" === t) return this.r = this.g = this.b = this.a = 0, !0;
                        return !!e;
                    }, r.prototype.isColor = !0;
                    var h = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ],
                        yellowgreen: [
                            154,
                            205,
                            50
                        ]
                    };
                    e.exports = r;
                },
                {}
            ],
            4: [
                function(t, e, n) {
                    var p = t("./support"), d = t("./renderers/canvas"), g = t("./imageloader"), m = t("./nodeparser"), r = t("./nodecontainer"), w = t("./log"), i = t("./utils"), y = t("./clone"), v = t("./proxy").loadUrlDocument, b = i.getBounds, x = "data-html2canvas-node", S = 0;
                    function o(t, e) {
                        var n, r, i = S++;
                        if ((e = e || {}).logging && (w.options.logging = !0, w.options.start = Date.now()), e.async = void 0 === e.async || e.async, e.allowTaint = void 0 !== e.allowTaint && e.allowTaint, e.removeContainer = void 0 === e.removeContainer || e.removeContainer, e.javascriptEnabled = void 0 !== e.javascriptEnabled && e.javascriptEnabled, e.imageTimeout = void 0 === e.imageTimeout ? 1e4 : e.imageTimeout, e.renderer = "function" == typeof e.renderer ? e.renderer : d, e.strict = !!e.strict, "string" == typeof t) {
                            if ("string" != typeof e.proxy) return Promise.reject("Proxy must be used when rendering url");
                            var o = null != e.width ? e.width : window.innerWidth, a = null != e.height ? e.height : window.innerHeight;
                            return v((n = t, r = document.createElement("a"), r.href = n, r.href = r.href, r), e.proxy, document, o, a, e).then(function(t) {
                                return k(t.contentWindow.document.documentElement, t, e, o, a);
                            });
                        }
                        var s, h, c, l, u, f = (void 0 === t ? [
                            document.documentElement
                        ] : t.length ? t : [
                            t
                        ])[0];
                        return f.setAttribute(x + i, i), (s = f.ownerDocument, h = e, c = f.ownerDocument.defaultView.innerWidth, l = f.ownerDocument.defaultView.innerHeight, u = i, y(s, s, c, l, h, s.defaultView.pageXOffset, s.defaultView.pageYOffset).then(function(t) {
                            w("Document cloned");
                            var e = x + u, n = "[" + e + "='" + u + "']";
                            s.querySelector(n).removeAttribute(e);
                            var r = t.contentWindow, i = r.document.querySelector(n), o = "function" == typeof h.onclone ? Promise.resolve(h.onclone(r.document)) : Promise.resolve(!0);
                            return o.then(function() {
                                return k(i, t, h, c, l);
                            });
                        })).then(function(t) {
                            return "function" == typeof e.onrendered && (w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"), e.onrendered(t)), t;
                        });
                    }
                    o.CanvasRenderer = d, o.NodeContainer = r, o.log = w, o.utils = i;
                    var a = "undefined" == typeof document || "function" != typeof Object.create || "function" != typeof document.createElement("canvas").getContext ? function() {
                        return Promise.reject("No canvas support");
                    } : o;
                    function k(n, r, i, t, e) {
                        var o, a, s = r.contentWindow, h = new p(s.document), c = new g(i, h), l = b(n), u = "view" === i.type ? t : (o = s.document, Math.max(Math.max(o.body.scrollWidth, o.documentElement.scrollWidth), Math.max(o.body.offsetWidth, o.documentElement.offsetWidth), Math.max(o.body.clientWidth, o.documentElement.clientWidth))), f = "view" === i.type ? e : (a = s.document, Math.max(Math.max(a.body.scrollHeight, a.documentElement.scrollHeight), Math.max(a.body.offsetHeight, a.documentElement.offsetHeight), Math.max(a.body.clientHeight, a.documentElement.clientHeight))), d = new i.renderer(u, f, c, i, document);
                        return new m(n, d, h, c, i).ready.then(function() {
                            var t, e;
                            return w("Finished rendering"), t = "view" === i.type ? _(d.canvas, {
                                width: d.canvas.width,
                                height: d.canvas.height,
                                top: 0,
                                left: 0,
                                x: 0,
                                y: 0
                            }) : n === s.document.body || n === s.document.documentElement || null != i.canvas ? d.canvas : _(d.canvas, {
                                width: null != i.width ? i.width : l.width,
                                height: null != i.height ? i.height : l.height,
                                top: l.top,
                                left: l.left,
                                x: 0,
                                y: 0
                            }), e = r, i.removeContainer && (e.parentNode.removeChild(e), w("Cleaned up container")), t;
                        });
                    }
                    function _(t, e) {
                        var n = document.createElement("canvas"), r = Math.min(t.width - 1, Math.max(0, e.left)), i = Math.min(t.width, Math.max(1, e.left + e.width)), o = Math.min(t.height - 1, Math.max(0, e.top)), a = Math.min(t.height, Math.max(1, e.top + e.height));
                        n.width = e.width, n.height = e.height;
                        var s = i - r, h = a - o;
                        return w("Cropping canvas at:", "left:", e.left, "top:", e.top, "width:", s, "height:", h), w("Resulting crop with width", e.width, "and height", e.height, "with x", r, "and y", o), n.getContext("2d").drawImage(t, r, o, s, h, e.x, e.y, s, h), n;
                    }
                    e.exports = a;
                },
                {
                    "./clone": 2,
                    "./imageloader": 11,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./nodeparser": 15,
                    "./proxy": 16,
                    "./renderers/canvas": 20,
                    "./support": 22,
                    "./utils": 26
                }
            ],
            5: [
                function(t, e, n) {
                    var r = t("./log"), i = t("./utils").smallImage;
                    e.exports = function t(e) {
                        if (this.src = e, r("DummyImageContainer for", e), !this.promise || !this.image) {
                            r("Initiating DummyImageContainer"), t.prototype.image = new Image;
                            var n = this.image;
                            t.prototype.promise = new Promise(function(t, e) {
                                n.onload = t, n.onerror = e, n.src = i(), !0 === n.complete && t(n);
                            });
                        }
                    };
                },
                {
                    "./log": 13,
                    "./utils": 26
                }
            ],
            6: [
                function(t, e, n) {
                    var h = t("./utils").smallImage;
                    e.exports = function(t, e) {
                        var n, r, i = document.createElement("div"), o = document.createElement("img"), a = document.createElement("span"), s = "Hidden Text";
                        i.style.visibility = "hidden", i.style.fontFamily = t, i.style.fontSize = e, i.style.margin = 0, i.style.padding = 0, document.body.appendChild(i), o.src = h(), o.width = 1, o.height = 1, o.style.margin = 0, o.style.padding = 0, o.style.verticalAlign = "baseline", a.style.fontFamily = t, a.style.fontSize = e, a.style.margin = 0, a.style.padding = 0, a.appendChild(document.createTextNode(s)), i.appendChild(a), i.appendChild(o), n = o.offsetTop - a.offsetTop + 1, i.removeChild(a), i.appendChild(document.createTextNode(s)), i.style.lineHeight = "normal", o.style.verticalAlign = "super", r = o.offsetTop - i.offsetTop + 1, document.body.removeChild(i), this.baseline = n, this.lineWidth = 1, this.middle = r;
                    };
                },
                {
                    "./utils": 26
                }
            ],
            7: [
                function(t, e, n) {
                    var r = t("./font");
                    function i() {
                        this.data = {};
                    }
                    i.prototype.getMetrics = function(t, e) {
                        return void 0 === this.data[t + "-" + e] && (this.data[t + "-" + e] = new r(t, e)), this.data[t + "-" + e];
                    }, e.exports = i;
                },
                {
                    "./font": 6
                }
            ],
            8: [
                function(o, t, e) {
                    var a = o("./utils").getBounds, i = o("./proxy").loadUrlDocument;
                    function n(e, t, n) {
                        this.image = null, this.src = e;
                        var r = this, i = a(e);
                        this.promise = (t ? new Promise(function(t) {
                            "about:blank" === e.contentWindow.document.URL || null == e.contentWindow.document.documentElement ? e.contentWindow.onload = e.onload = function() {
                                t(e);
                            } : t(e);
                        }) : this.proxyLoad(n.proxy, i, n)).then(function(t) {
                            return o("./core")(t.contentWindow.document.documentElement, {
                                type: "view",
                                width: t.width,
                                height: t.height,
                                proxy: n.proxy,
                                javascriptEnabled: n.javascriptEnabled,
                                removeContainer: n.removeContainer,
                                allowTaint: n.allowTaint,
                                imageTimeout: n.imageTimeout / 2
                            });
                        }).then(function(t) {
                            return r.image = t;
                        });
                    }
                    n.prototype.proxyLoad = function(t, e, n) {
                        var r = this.src;
                        return i(r.src, t, r.ownerDocument, e.width, e.height, n);
                    }, t.exports = n;
                },
                {
                    "./core": 4,
                    "./proxy": 16,
                    "./utils": 26
                }
            ],
            9: [
                function(t, e, n) {
                    function r(t) {
                        this.src = t.value, this.colorStops = [], this.type = null, this.x0 = .5, this.y0 = .5, this.x1 = .5, this.y1 = .5, this.promise = Promise.resolve(!0);
                    }
                    r.TYPES = {
                        LINEAR: 1,
                        RADIAL: 2
                    }, r.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i, e.exports = r;
                },
                {}
            ],
            10: [
                function(t, e, n) {
                    e.exports = function(n, r) {
                        this.src = n, this.image = new Image;
                        var i = this;
                        this.tainted = null, this.promise = new Promise(function(t, e) {
                            i.image.onload = t, i.image.onerror = e, r && (i.image.crossOrigin = "anonymous"), i.image.src = n, !0 === i.image.complete && t(i.image);
                        });
                    };
                },
                {}
            ],
            11: [
                function(t, e, n) {
                    var o = t("./log"), r = t("./imagecontainer"), i = t("./dummyimagecontainer"), a = t("./proxyimagecontainer"), s = t("./framecontainer"), h = t("./svgcontainer"), c = t("./svgnodecontainer"), l = t("./lineargradientcontainer"), u = t("./webkitgradientcontainer"), f = t("./utils").bind;
                    function d(t, e) {
                        this.link = null, this.options = t, this.support = e, this.origin = this.getOrigin(window.location.href);
                    }
                    d.prototype.findImages = function(t) {
                        var e = [];
                        return t.reduce(function(t, e) {
                            switch(e.node.nodeName){
                                case "IMG":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node.src
                                            ],
                                            method: "url"
                                        }
                                    ]);
                                case "svg":
                                case "IFRAME":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node
                                            ],
                                            method: e.node.nodeName
                                        }
                                    ]);
                            }
                            return t;
                        }, []).forEach(this.addImage(e, this.loadImage), this), e;
                    }, d.prototype.findBackgroundImage = function(t, e) {
                        return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t, this.loadImage), this), t;
                    }, d.prototype.addImage = function(n, r) {
                        return function(e) {
                            e.args.forEach(function(t) {
                                this.imageExists(n, t) || (n.splice(0, 0, r.call(this, e)), o("Added image #" + n.length, "string" == typeof t ? t.substring(0, 100) : t));
                            }, this);
                        };
                    }, d.prototype.hasImageBackground = function(t) {
                        return "none" !== t.method;
                    }, d.prototype.loadImage = function(t) {
                        if ("url" === t.method) {
                            var e = t.args[0];
                            return !this.isSVG(e) || this.support.svg || this.options.allowTaint ? e.match(/data:image\/.*;base64,/i) ? new r(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi, ""), !1) : this.isSameOrigin(e) || !0 === this.options.allowTaint || this.isSVG(e) ? new r(e, !1) : this.support.cors && !this.options.allowTaint && this.options.useCORS ? new r(e, !0) : this.options.proxy ? new a(e, this.options.proxy) : new i(e) : new h(e);
                        }
                        return "linear-gradient" === t.method ? new l(t) : "gradient" === t.method ? new u(t) : "svg" === t.method ? new c(t.args[0], this.support.svg) : "IFRAME" === t.method ? new s(t.args[0], this.isSameOrigin(t.args[0].src), this.options) : new i(t);
                    }, d.prototype.isSVG = function(t) {
                        return "svg" === t.substring(t.length - 3).toLowerCase() || h.prototype.isInline(t);
                    }, d.prototype.imageExists = function(t, e) {
                        return t.some(function(t) {
                            return t.src === e;
                        });
                    }, d.prototype.isSameOrigin = function(t) {
                        return this.getOrigin(t) === this.origin;
                    }, d.prototype.getOrigin = function(t) {
                        var e = this.link || (this.link = document.createElement("a"));
                        return e.href = t, e.href = e.href, e.protocol + e.hostname + e.port;
                    }, d.prototype.getPromise = function(e) {
                        return this.timeout(e, this.options.imageTimeout).catch(function() {
                            return new i(e.src).promise.then(function(t) {
                                e.image = t;
                            });
                        });
                    }, d.prototype.get = function(e) {
                        var n = null;
                        return this.images.some(function(t) {
                            return (n = t).src === e;
                        }) ? n : null;
                    }, d.prototype.fetch = function(t) {
                        return this.images = t.reduce(f(this.findBackgroundImage, this), this.findImages(t)), this.images.forEach(function(e, n) {
                            e.promise.then(function() {
                                o("Succesfully loaded image #" + (n + 1), e);
                            }, function(t) {
                                o("Failed loading image #" + (n + 1), e, t);
                            });
                        }), this.ready = Promise.all(this.images.map(this.getPromise, this)), o("Finished searching images"), this;
                    }, d.prototype.timeout = function(n, r) {
                        var i, t = Promise.race([
                            n.promise,
                            new Promise(function(t, e) {
                                i = setTimeout(function() {
                                    o("Timed out loading image", n), e(n);
                                }, r);
                            })
                        ]).then(function(t) {
                            return clearTimeout(i), t;
                        });
                        return t.catch(function() {
                            clearTimeout(i);
                        }), t;
                    }, e.exports = d;
                },
                {
                    "./dummyimagecontainer": 5,
                    "./framecontainer": 8,
                    "./imagecontainer": 10,
                    "./lineargradientcontainer": 12,
                    "./log": 13,
                    "./proxyimagecontainer": 17,
                    "./svgcontainer": 23,
                    "./svgnodecontainer": 24,
                    "./utils": 26,
                    "./webkitgradientcontainer": 27
                }
            ],
            12: [
                function(t, e, n) {
                    var i = t("./gradientcontainer"), o = t("./color");
                    function r(t) {
                        i.apply(this, arguments), this.type = i.TYPES.LINEAR;
                        var e = r.REGEXP_DIRECTION.test(t.args[0]) || !i.REGEXP_COLORSTOP.test(t.args[0]);
                        e ? t.args[0].split(/\s+/).reverse().forEach(function(t, e) {
                            switch(t){
                                case "left":
                                    this.x0 = 0, this.x1 = 1;
                                    break;
                                case "top":
                                    this.y0 = 0, this.y1 = 1;
                                    break;
                                case "right":
                                    this.x0 = 1, this.x1 = 0;
                                    break;
                                case "bottom":
                                    this.y0 = 1, this.y1 = 0;
                                    break;
                                case "to":
                                    var n = this.y0, r = this.x0;
                                    this.y0 = this.y1, this.x0 = this.x1, this.x1 = r, this.y1 = n;
                                    break;
                                case "center":
                                    break;
                                default:
                                    var i = .01 * parseFloat(t, 10);
                                    if (isNaN(i)) break;
                                    0 === e ? (this.y0 = i, this.y1 = 1 - this.y0) : (this.x0 = i, this.x1 = 1 - this.x0);
                            }
                        }, this) : (this.y0 = 0, this.y1 = 1), this.colorStops = t.args.slice(e ? 1 : 0).map(function(t) {
                            var e = t.match(i.REGEXP_COLORSTOP), n = +e[2], r = 0 === n ? "%" : e[3];
                            return {
                                color: new o(e[1]),
                                stop: "%" === r ? n / 100 : null
                            };
                        }), null === this.colorStops[0].stop && (this.colorStops[0].stop = 0), null === this.colorStops[this.colorStops.length - 1].stop && (this.colorStops[this.colorStops.length - 1].stop = 1), this.colorStops.forEach(function(n, r) {
                            null === n.stop && this.colorStops.slice(r).some(function(t, e) {
                                return null !== t.stop && (n.stop = (t.stop - this.colorStops[r - 1].stop) / (e + 1) + this.colorStops[r - 1].stop, !0);
                            }, this);
                        }, this);
                    }
                    r.prototype = Object.create(i.prototype), r.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i, e.exports = r;
                },
                {
                    "./color": 3,
                    "./gradientcontainer": 9
                }
            ],
            13: [
                function(t, e, n) {
                    var r = function() {
                        r.options.logging && window.console && window.console.log && Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [
                            Date.now() - r.options.start + "ms",
                            "html2canvas:"
                        ].concat([].slice.call(arguments, 0)));
                    };
                    r.options = {
                        logging: !1
                    }, e.exports = r;
                },
                {}
            ],
            14: [
                function(t, e, n) {
                    var o = t("./color"), r = t("./utils"), i = r.getBounds, a = r.parseBackgrounds, s = r.offsetBounds;
                    function h(t, e) {
                        this.node = t, this.parent = e, this.stack = null, this.bounds = null, this.borders = null, this.clip = [], this.backgroundClip = [], this.offsetBounds = null, this.visible = null, this.computedStyles = null, this.colors = {}, this.styles = {}, this.backgroundImages = null, this.transformData = null, this.transformMatrix = null, this.isPseudoElement = !1, this.opacity = null;
                    }
                    function c(t) {
                        return -1 !== t.toString().indexOf("%");
                    }
                    function l(t) {
                        return t.replace("px", "");
                    }
                    function u(t) {
                        return parseFloat(t);
                    }
                    h.prototype.cloneTo = function(t) {
                        t.visible = this.visible, t.borders = this.borders, t.bounds = this.bounds, t.clip = this.clip, t.backgroundClip = this.backgroundClip, t.computedStyles = this.computedStyles, t.styles = this.styles, t.backgroundImages = this.backgroundImages, t.opacity = this.opacity;
                    }, h.prototype.getOpacity = function() {
                        return null === this.opacity ? this.opacity = this.cssFloat("opacity") : this.opacity;
                    }, h.prototype.assignStack = function(t) {
                        (this.stack = t).children.push(this);
                    }, h.prototype.isElementVisible = function() {
                        return this.node.nodeType === Node.TEXT_NODE ? this.parent.visible : "none" !== this.css("display") && "hidden" !== this.css("visibility") && !this.node.hasAttribute("data-html2canvas-ignore") && ("INPUT" !== this.node.nodeName || "hidden" !== this.node.getAttribute("type"));
                    }, h.prototype.css = function(t) {
                        return this.computedStyles || (this.computedStyles = this.isPseudoElement ? this.parent.computedStyle(this.before ? ":before" : ":after") : this.computedStyle(null)), this.styles[t] || (this.styles[t] = this.computedStyles[t]);
                    }, h.prototype.prefixedCss = function(e) {
                        var n = this.css(e);
                        return void 0 === n && [
                            "webkit",
                            "moz",
                            "ms",
                            "o"
                        ].some(function(t) {
                            return void 0 !== (n = this.css(t + e.substr(0, 1).toUpperCase() + e.substr(1)));
                        }, this), void 0 === n ? null : n;
                    }, h.prototype.computedStyle = function(t) {
                        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, t);
                    }, h.prototype.cssInt = function(t) {
                        var e = parseInt(this.css(t), 10);
                        return isNaN(e) ? 0 : e;
                    }, h.prototype.color = function(t) {
                        return this.colors[t] || (this.colors[t] = new o(this.css(t)));
                    }, h.prototype.cssFloat = function(t) {
                        var e = parseFloat(this.css(t));
                        return isNaN(e) ? 0 : e;
                    }, h.prototype.fontWeight = function() {
                        var t = this.css("fontWeight");
                        switch(parseInt(t, 10)){
                            case 401:
                                t = "bold";
                                break;
                            case 400:
                                t = "normal";
                        }
                        return t;
                    }, h.prototype.parseClip = function() {
                        var t = this.css("clip").match(this.CLIP);
                        return t ? {
                            top: parseInt(t[1], 10),
                            right: parseInt(t[2], 10),
                            bottom: parseInt(t[3], 10),
                            left: parseInt(t[4], 10)
                        } : null;
                    }, h.prototype.parseBackgroundImages = function() {
                        return this.backgroundImages || (this.backgroundImages = a(this.css("backgroundImage")));
                    }, h.prototype.cssList = function(t, e) {
                        var n = (this.css(t) || "").split(",");
                        return 1 === (n = (n = n[e || 0] || n[0] || "auto").trim().split(" ")).length && (n = [
                            n[0],
                            c(n[0]) ? "auto" : n[0]
                        ]), n;
                    }, h.prototype.parseBackgroundSize = function(t, e, n) {
                        var r, i, o = this.cssList("backgroundSize", n);
                        if (c(o[0])) r = t.width * parseFloat(o[0]) / 100;
                        else {
                            if (/contain|cover/.test(o[0])) {
                                var a = t.width / t.height, s = e.width / e.height;
                                return a < s ^ "contain" === o[0] ? {
                                    width: t.height * s,
                                    height: t.height
                                } : {
                                    width: t.width,
                                    height: t.width / s
                                };
                            }
                            r = parseInt(o[0], 10);
                        }
                        return i = "auto" === o[0] && "auto" === o[1] ? e.height : "auto" === o[1] ? r / e.width * e.height : c(o[1]) ? t.height * parseFloat(o[1]) / 100 : parseInt(o[1], 10), "auto" === o[0] && (r = i / e.height * e.width), {
                            width: r,
                            height: i
                        };
                    }, h.prototype.parseBackgroundPosition = function(t, e, n, r) {
                        var i, o, a = this.cssList("backgroundPosition", n);
                        return i = c(a[0]) ? (t.width - (r || e).width) * (parseFloat(a[0]) / 100) : parseInt(a[0], 10), o = "auto" === a[1] ? i / e.width * e.height : c(a[1]) ? (t.height - (r || e).height) * parseFloat(a[1]) / 100 : parseInt(a[1], 10), "auto" === a[0] && (i = o / e.height * e.width), {
                            left: i,
                            top: o
                        };
                    }, h.prototype.parseBackgroundRepeat = function(t) {
                        return this.cssList("backgroundRepeat", t)[0];
                    }, h.prototype.parseTextShadows = function() {
                        var t = this.css("textShadow"), e = [];
                        if (t && "none" !== t) for(var n = t.match(this.TEXT_SHADOW_PROPERTY), r = 0; n && r < n.length; r++){
                            var i = n[r].match(this.TEXT_SHADOW_VALUES);
                            e.push({
                                color: new o(i[0]),
                                offsetX: i[1] ? parseFloat(i[1].replace("px", "")) : 0,
                                offsetY: i[2] ? parseFloat(i[2].replace("px", "")) : 0,
                                blur: i[3] ? i[3].replace("px", "") : 0
                            });
                        }
                        return e;
                    }, h.prototype.parseTransform = function() {
                        if (!this.transformData) {
                            if (this.hasTransform()) {
                                var t = this.parseBounds(), e = this.prefixedCss("transformOrigin").split(" ").map(l).map(u);
                                e[0] += t.left, e[1] += t.top, this.transformData = {
                                    origin: e,
                                    matrix: this.parseTransformMatrix()
                                };
                            } else this.transformData = {
                                origin: [
                                    0,
                                    0
                                ],
                                matrix: [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0
                                ]
                            };
                        }
                        return this.transformData;
                    }, h.prototype.parseTransformMatrix = function() {
                        if (!this.transformMatrix) {
                            var t = this.prefixedCss("transform"), e = t ? function(t) {
                                if (t && "matrix" === t[1]) return t[2].split(",").map(function(t) {
                                    return parseFloat(t.trim());
                                });
                                if (t && "matrix3d" === t[1]) {
                                    var e = t[2].split(",").map(function(t) {
                                        return parseFloat(t.trim());
                                    });
                                    return [
                                        e[0],
                                        e[1],
                                        e[4],
                                        e[5],
                                        e[12],
                                        e[13]
                                    ];
                                }
                            }(t.match(this.MATRIX_PROPERTY)) : null;
                            this.transformMatrix = e || [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ];
                        }
                        return this.transformMatrix;
                    }, h.prototype.parseBounds = function() {
                        return this.bounds || (this.bounds = this.hasTransform() ? s(this.node) : i(this.node));
                    }, h.prototype.hasTransform = function() {
                        return "1,0,0,1,0,0" !== this.parseTransformMatrix().join(",") || this.parent && this.parent.hasTransform();
                    }, h.prototype.getValue = function() {
                        var t, e, n = this.node.value || "";
                        return "SELECT" === this.node.tagName ? (t = this.node, n = (e = t.options[t.selectedIndex || 0]) && e.text || "") : "password" === this.node.type && (n = Array(n.length + 1).join("\u2022")), 0 === n.length ? this.node.placeholder || "" : n;
                    }, h.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/, h.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g, h.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g, h.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/, e.exports = h;
                },
                {
                    "./color": 3,
                    "./utils": 26
                }
            ],
            15: [
                function(t, e, n) {
                    var s = t("./log"), h = t("punycode"), c = t("./nodecontainer"), f = t("./textcontainer"), d = t("./pseudoelementcontainer"), l = t("./fontmetrics"), u = t("./color"), p = t("./stackingcontext"), r = t("./utils"), g = r.bind, a = r.getBounds, m = r.parseBackgrounds, w = r.offsetBounds;
                    function i(t, e, n, r, i) {
                        s("Starting NodeParser"), this.renderer = e, this.options = i, this.range = null, this.support = n, this.renderQueue = [], this.stack = new p(!0, 1, t.ownerDocument, null);
                        var o = new c(t, null);
                        if (i.background && e.rectangle(0, 0, e.width, e.height, new u(i.background)), t === t.ownerDocument.documentElement) {
                            var a = new c(o.color("backgroundColor").isTransparent() ? t.ownerDocument.body : t.ownerDocument.documentElement, null);
                            e.rectangle(0, 0, e.width, e.height, a.color("backgroundColor"));
                        }
                        o.visibile = o.isElementVisible(), this.createPseudoHideStyles(t.ownerDocument), this.disableAnimations(t.ownerDocument), this.nodes = L([
                            o
                        ].concat(this.getChildren(o)).filter(function(t) {
                            return t.visible = t.isElementVisible();
                        }).map(this.getPseudoElements, this)), this.fontMetrics = new l, s("Fetched nodes, total:", this.nodes.length), s("Calculate overflow clips"), this.calculateOverflowClips(), s("Start fetching images"), this.images = r.fetch(this.nodes.filter(j)), this.ready = this.images.ready.then(g(function() {
                            return s("Images loaded, starting parsing"), s("Creating stacking contexts"), this.createStackingContexts(), s("Sorting stacking contexts"), this.sortStackingContexts(this.stack), this.parse(this.stack), s("Render queue created with " + this.renderQueue.length + " items"), new Promise(g(function(t) {
                                i.async ? "function" == typeof i.async ? i.async.call(this, this.renderQueue, t) : 0 < this.renderQueue.length ? (this.renderIndex = 0, this.asyncRenderer(this.renderQueue, t)) : t() : (this.renderQueue.forEach(this.paint, this), t());
                            }, this));
                        }, this));
                    }
                    function o(t) {
                        return t.parent && t.parent.clip.length;
                    }
                    function y() {}
                    i.prototype.calculateOverflowClips = function() {
                        this.nodes.forEach(function(t) {
                            if (j(t)) {
                                D(t) && t.appendToDOM(), t.borders = this.parseBorders(t);
                                var e = "hidden" === t.css("overflow") ? [
                                    t.borders.clip
                                ] : [], n = t.parseClip();
                                n && -1 !== [
                                    "absolute",
                                    "fixed"
                                ].indexOf(t.css("position")) && e.push([
                                    [
                                        "rect",
                                        t.bounds.left + n.left,
                                        t.bounds.top + n.top,
                                        n.right - n.left,
                                        n.bottom - n.top
                                    ]
                                ]), t.clip = o(t) ? t.parent.clip.concat(e) : e, t.backgroundClip = "hidden" !== t.css("overflow") ? t.clip.concat([
                                    t.borders.clip
                                ]) : t.clip, D(t) && t.cleanDOM();
                            } else M(t) && (t.clip = o(t) ? t.parent.clip : []);
                            D(t) || (t.bounds = null);
                        }, this);
                    }, i.prototype.asyncRenderer = function(t, e, n) {
                        n = n || Date.now(), this.paint(t[this.renderIndex++]), t.length === this.renderIndex ? e() : n + 20 > Date.now() ? this.asyncRenderer(t, e, n) : setTimeout(g(function() {
                            this.asyncRenderer(t, e);
                        }, this), 0);
                    }, i.prototype.createPseudoHideStyles = function(t) {
                        this.createStyles(t, "." + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }.' + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');
                    }, i.prototype.disableAnimations = function(t) {
                        this.createStyles(t, "* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}");
                    }, i.prototype.createStyles = function(t, e) {
                        var n = t.createElement("style");
                        n.innerHTML = e, t.body.appendChild(n);
                    }, i.prototype.getPseudoElements = function(t) {
                        var e = [
                            [
                                t
                            ]
                        ];
                        if (t.node.nodeType === Node.ELEMENT_NODE) {
                            var n = this.getPseudoElement(t, ":before"), r = this.getPseudoElement(t, ":after");
                            n && e.push(n), r && e.push(r);
                        }
                        return L(e);
                    }, i.prototype.getPseudoElement = function(t, e) {
                        var n = t.computedStyle(e);
                        if (!n || !n.content || "none" === n.content || "-moz-alt-content" === n.content || "none" === n.display) return null;
                        for(var r, i, o = (r = n.content, (i = r.substr(0, 1)) === r.substr(r.length - 1) && i.match(/'|"/) ? r.substr(1, r.length - 2) : r), a = "url" === o.substr(0, 3), s = document.createElement(a ? "img" : "html2canvaspseudoelement"), h = new d(s, t, e), c = n.length - 1; 0 <= c; c--){
                            var l = n.item(c).replace(/(\-[a-z])/g, function(t) {
                                return t.toUpperCase().replace("-", "");
                            });
                            s.style[l] = n[l];
                        }
                        if (s.className = d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER, a) return s.src = m(o)[0].args[0], [
                            h
                        ];
                        var u = document.createTextNode(o);
                        return s.appendChild(u), [
                            h,
                            new f(u, h)
                        ];
                    }, i.prototype.getChildren = function(n) {
                        return L([].filter.call(n.node.childNodes, q).map(function(t) {
                            var e = [
                                t.nodeType === Node.TEXT_NODE ? new f(t, n) : new c(t, n)
                            ].filter(z);
                            return t.nodeType === Node.ELEMENT_NODE && e.length && "TEXTAREA" !== t.tagName ? e[0].isElementVisible() ? e.concat(this.getChildren(e[0])) : [] : e;
                        }, this));
                    }, i.prototype.newStackingContext = function(t, e) {
                        var n = new p(e, t.getOpacity(), t.node, t.parent);
                        t.cloneTo(n), (e ? n.getParentStack(this) : n.parent.stack).contexts.push(n), t.stack = n;
                    }, i.prototype.createStackingContexts = function() {
                        this.nodes.forEach(function(t) {
                            var e, n;
                            j(t) && (this.isRootElement(t) || t.getOpacity() < 1 || (n = (e = t).css("position"), "auto" !== (-1 !== [
                                "absolute",
                                "relative",
                                "fixed"
                            ].indexOf(n) ? e.css("zIndex") : "auto")) || this.isBodyWithTransparentRoot(t) || t.hasTransform()) ? this.newStackingContext(t, !0) : j(t) && (O(t) && T(t) || -1 !== [
                                "inline-block",
                                "inline-table"
                            ].indexOf(t.css("display")) || B(t)) ? this.newStackingContext(t, !1) : t.assignStack(t.parent.stack);
                        }, this);
                    }, i.prototype.isBodyWithTransparentRoot = function(t) {
                        return "BODY" === t.node.nodeName && t.parent.color("backgroundColor").isTransparent();
                    }, i.prototype.isRootElement = function(t) {
                        return null === t.parent;
                    }, i.prototype.sortStackingContexts = function(t) {
                        var n;
                        t.contexts.sort((n = t.contexts.slice(0), function(t, e) {
                            return t.cssInt("zIndex") + n.indexOf(t) / n.length - (e.cssInt("zIndex") + n.indexOf(e) / n.length);
                        })), t.contexts.forEach(this.sortStackingContexts, this);
                    }, i.prototype.parseTextBounds = function(a) {
                        return function(t, e, n) {
                            if ("none" !== a.parent.css("textDecoration").substr(0, 4) || 0 !== t.trim().length) {
                                if (this.support.rangeBounds && !a.parent.hasTransform()) {
                                    var r = n.slice(0, e).join("").length;
                                    return this.getRangeBounds(a.node, r, t.length);
                                }
                                if (a.node && "string" == typeof a.node.data) {
                                    var i = a.node.splitText(t.length), o = this.getWrapperBounds(a.node, a.parent.hasTransform());
                                    return a.node = i, o;
                                }
                            } else this.support.rangeBounds && !a.parent.hasTransform() || (a.node = a.node.splitText(t.length));
                            return {};
                        };
                    }, i.prototype.getWrapperBounds = function(t, e) {
                        var n = t.ownerDocument.createElement("html2canvaswrapper"), r = t.parentNode, i = t.cloneNode(!0);
                        n.appendChild(t.cloneNode(!0)), r.replaceChild(n, t);
                        var o = e ? w(n) : a(n);
                        return r.replaceChild(i, n), o;
                    }, i.prototype.getRangeBounds = function(t, e, n) {
                        var r = this.range || (this.range = t.ownerDocument.createRange());
                        return r.setStart(t, e), r.setEnd(t, e + n), r.getBoundingClientRect();
                    }, i.prototype.parse = function(t) {
                        var e = t.contexts.filter(I), n = t.children.filter(j), r = n.filter(R(B)), i = r.filter(R(O)).filter(R(F)), o = n.filter(R(O)).filter(B), a = r.filter(R(O)).filter(F), s = t.contexts.concat(r.filter(O)).filter(T), h = t.children.filter(M).filter(E), c = t.contexts.filter(C);
                        e.concat(i).concat(o).concat(a).concat(s).concat(h).concat(c).forEach(function(t) {
                            this.renderQueue.push(t), P(t) && (this.parse(t), this.renderQueue.push(new y));
                        }, this);
                    }, i.prototype.paint = function(t) {
                        try {
                            t instanceof y ? this.renderer.ctx.restore() : M(t) ? (D(t.parent) && t.parent.appendToDOM(), this.paintText(t), D(t.parent) && t.parent.cleanDOM()) : this.paintNode(t);
                        } catch (t) {
                            if (s(t), this.options.strict) throw t;
                        }
                    }, i.prototype.paintNode = function(t) {
                        P(t) && (this.renderer.setOpacity(t.opacity), this.renderer.ctx.save(), t.hasTransform() && this.renderer.setTransform(t.parseTransform())), "INPUT" === t.node.nodeName && "checkbox" === t.node.type ? this.paintCheckbox(t) : "INPUT" === t.node.nodeName && "radio" === t.node.type ? this.paintRadio(t) : this.paintElement(t);
                    }, i.prototype.paintElement = function(n) {
                        var r = n.parseBounds();
                        this.renderer.clip(n.backgroundClip, function() {
                            this.renderer.renderBackground(n, r, n.borders.borders.map(N));
                        }, this), this.renderer.clip(n.clip, function() {
                            this.renderer.renderBorders(n.borders.borders);
                        }, this), this.renderer.clip(n.backgroundClip, function() {
                            switch(n.node.nodeName){
                                case "svg":
                                case "IFRAME":
                                    var t = this.images.get(n.node);
                                    t ? this.renderer.renderImage(n, r, n.borders, t) : s("Error loading <" + n.node.nodeName + ">", n.node);
                                    break;
                                case "IMG":
                                    var e = this.images.get(n.node.src);
                                    e ? this.renderer.renderImage(n, r, n.borders, e) : s("Error loading <img>", n.node.src);
                                    break;
                                case "CANVAS":
                                    this.renderer.renderImage(n, r, n.borders, {
                                        image: n.node
                                    });
                                    break;
                                case "SELECT":
                                case "INPUT":
                                case "TEXTAREA":
                                    this.paintFormValue(n);
                            }
                        }, this);
                    }, i.prototype.paintCheckbox = function(t) {
                        var e = t.parseBounds(), n = Math.min(e.width, e.height), r = {
                            width: n - 1,
                            height: n - 1,
                            top: e.top,
                            left: e.left
                        }, i = [
                            3,
                            3
                        ], o = [
                            i,
                            i,
                            i,
                            i
                        ], a = [
                            1,
                            1,
                            1,
                            1
                        ].map(function(t) {
                            return {
                                color: new u("#A5A5A5"),
                                width: t
                            };
                        }), s = S(r, o, a);
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.rectangle(r.left + 1, r.top + 1, r.width - 2, r.height - 2, new u("#DEDEDE")), this.renderer.renderBorders(b(a, r, s, o)), t.node.checked && (this.renderer.font(new u("#424242"), "normal", "normal", "bold", n - 3 + "px", "arial"), this.renderer.text("\u2714", r.left + n / 6, r.top + n - 1));
                        }, this);
                    }, i.prototype.paintRadio = function(t) {
                        var e = t.parseBounds(), n = Math.min(e.width, e.height) - 2;
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.circleStroke(e.left + 1, e.top + 1, n, new u("#DEDEDE"), 1, new u("#A5A5A5")), t.node.checked && this.renderer.circle(Math.ceil(e.left + n / 4) + 1, Math.ceil(e.top + n / 4) + 1, Math.floor(n / 2), new u("#424242"));
                        }, this);
                    }, i.prototype.paintFormValue = function(e) {
                        var t = e.getValue();
                        if (0 < t.length) {
                            var n = e.node.ownerDocument, r = n.createElement("html2canvaswrapper");
                            [
                                "lineHeight",
                                "textAlign",
                                "fontFamily",
                                "fontWeight",
                                "fontSize",
                                "color",
                                "paddingLeft",
                                "paddingTop",
                                "paddingRight",
                                "paddingBottom",
                                "width",
                                "height",
                                "borderLeftStyle",
                                "borderTopStyle",
                                "borderLeftWidth",
                                "borderTopWidth",
                                "boxSizing",
                                "whiteSpace",
                                "wordWrap"
                            ].forEach(function(t) {
                                try {
                                    r.style[t] = e.css(t);
                                } catch (t) {
                                    s("html2canvas: Parse: Exception caught in renderFormValue: " + t.message);
                                }
                            });
                            var i = e.parseBounds();
                            r.style.position = "fixed", r.style.left = i.left + "px", r.style.top = i.top + "px", r.textContent = t, n.body.appendChild(r), this.paintText(new f(r.firstChild, e)), n.body.removeChild(r);
                        }
                    }, i.prototype.paintText = function(n) {
                        n.applyTextTransform();
                        var t, e = h.ucs2.decode(n.node.data), r = this.options.letterRendering && !/^(normal|none|0px)$/.test(n.parent.css("letterSpacing")) || (t = n.node.data, /[^\u0000-\u00ff]/.test(t)) ? e.map(function(t) {
                            return h.ucs2.encode([
                                t
                            ]);
                        }) : function(t) {
                            var e, n = [], r = 0, i = !1;
                            for(; t.length;)o = t[r], -1 !== [
                                32,
                                13,
                                10,
                                9,
                                45
                            ].indexOf(o) === i ? ((e = t.splice(0, r)).length && n.push(h.ucs2.encode(e)), i = !i, r = 0) : r++, r >= t.length && (e = t.splice(0, r)).length && n.push(h.ucs2.encode(e));
                            var o;
                            return n;
                        }(e), i = n.parent.fontWeight(), o = n.parent.css("fontSize"), a = n.parent.css("fontFamily"), s = n.parent.parseTextShadows();
                        this.renderer.font(n.parent.color("color"), n.parent.css("fontStyle"), n.parent.css("fontVariant"), i, o, a), s.length ? this.renderer.fontShadow(s[0].color, s[0].offsetX, s[0].offsetY, s[0].blur) : this.renderer.clearShadow(), this.renderer.clip(n.parent.clip, function() {
                            r.map(this.parseTextBounds(n), this).forEach(function(t, e) {
                                t && !1 === /^\s*$/.test(r[e]) && (this.renderer.text(r[e], t.left, t.bottom), this.renderTextDecoration(n.parent, t, this.fontMetrics.getMetrics(a, o)));
                            }, this);
                        }, this);
                    }, i.prototype.renderTextDecoration = function(t, e, n) {
                        switch(t.css("textDecoration").split(" ")[0]){
                            case "underline":
                                this.renderer.rectangle(e.left, Math.round(e.top + n.baseline + n.lineWidth), e.width, 1, t.color("color"));
                                break;
                            case "overline":
                                this.renderer.rectangle(e.left, Math.round(e.top), e.width, 1, t.color("color"));
                                break;
                            case "line-through":
                                this.renderer.rectangle(e.left, Math.ceil(e.top + n.middle + n.lineWidth), e.width, 1, t.color("color"));
                        }
                    };
                    var v = {
                        inset: [
                            [
                                "darken",
                                .6
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .6
                            ]
                        ]
                    };
                    function b(a, s, h, c) {
                        return a.map(function(t, e) {
                            if (0 < t.width) {
                                var n = s.left, r = s.top, i = s.width, o = s.height - a[2].width;
                                switch(e){
                                    case 0:
                                        o = a[0].width, t.args = _({
                                            c1: [
                                                n,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r
                                            ],
                                            c3: [
                                                n + i - a[1].width,
                                                r + o
                                            ],
                                            c4: [
                                                n + a[3].width,
                                                r + o
                                            ]
                                        }, c[0], c[1], h.topLeftOuter, h.topLeftInner, h.topRightOuter, h.topRightInner);
                                        break;
                                    case 1:
                                        n = s.left + s.width - a[1].width, i = a[1].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r + o + a[2].width
                                            ],
                                            c3: [
                                                n,
                                                r + o
                                            ],
                                            c4: [
                                                n,
                                                r + a[0].width
                                            ]
                                        }, c[1], c[2], h.topRightOuter, h.topRightInner, h.bottomRightOuter, h.bottomRightInner);
                                        break;
                                    case 2:
                                        r = r + s.height - a[2].width, o = a[2].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r + o
                                            ],
                                            c2: [
                                                n,
                                                r + o
                                            ],
                                            c3: [
                                                n + a[3].width,
                                                r
                                            ],
                                            c4: [
                                                n + i - a[3].width,
                                                r
                                            ]
                                        }, c[2], c[3], h.bottomRightOuter, h.bottomRightInner, h.bottomLeftOuter, h.bottomLeftInner);
                                        break;
                                    case 3:
                                        i = a[3].width, t.args = _({
                                            c1: [
                                                n,
                                                r + o + a[2].width
                                            ],
                                            c2: [
                                                n,
                                                r
                                            ],
                                            c3: [
                                                n + i,
                                                r + a[0].width
                                            ],
                                            c4: [
                                                n + i,
                                                r + o
                                            ]
                                        }, c[3], c[0], h.bottomLeftOuter, h.bottomLeftInner, h.topLeftOuter, h.topLeftInner);
                                }
                            }
                            return t;
                        });
                    }
                    function x(t, e, n, r) {
                        var i = (Math.sqrt(2) - 1) / 3 * 4, o = n * i, a = r * i, s = t + n, h = e + r;
                        return {
                            topLeft: k({
                                x: t,
                                y: h
                            }, {
                                x: t,
                                y: h - a
                            }, {
                                x: s - o,
                                y: e
                            }, {
                                x: s,
                                y: e
                            }),
                            topRight: k({
                                x: t,
                                y: e
                            }, {
                                x: t + o,
                                y: e
                            }, {
                                x: s,
                                y: h - a
                            }, {
                                x: s,
                                y: h
                            }),
                            bottomRight: k({
                                x: s,
                                y: e
                            }, {
                                x: s,
                                y: e + a
                            }, {
                                x: t + o,
                                y: h
                            }, {
                                x: t,
                                y: h
                            }),
                            bottomLeft: k({
                                x: s,
                                y: h
                            }, {
                                x: s - o,
                                y: h
                            }, {
                                x: t,
                                y: e + a
                            }, {
                                x: t,
                                y: e
                            })
                        };
                    }
                    function S(t, e, n) {
                        var r = t.left, i = t.top, o = t.width, a = t.height, s = e[0][0] < o / 2 ? e[0][0] : o / 2, h = e[0][1] < a / 2 ? e[0][1] : a / 2, c = e[1][0] < o / 2 ? e[1][0] : o / 2, l = e[1][1] < a / 2 ? e[1][1] : a / 2, u = e[2][0] < o / 2 ? e[2][0] : o / 2, f = e[2][1] < a / 2 ? e[2][1] : a / 2, d = e[3][0] < o / 2 ? e[3][0] : o / 2, p = e[3][1] < a / 2 ? e[3][1] : a / 2, g = o - c, m = a - f, w = o - u, y = a - p;
                        return {
                            topLeftOuter: x(r, i, s, h).topLeft.subdivide(.5),
                            topLeftInner: x(r + n[3].width, i + n[0].width, Math.max(0, s - n[3].width), Math.max(0, h - n[0].width)).topLeft.subdivide(.5),
                            topRightOuter: x(r + g, i, c, l).topRight.subdivide(.5),
                            topRightInner: x(r + Math.min(g, o + n[3].width), i + n[0].width, g > o + n[3].width ? 0 : c - n[3].width, l - n[0].width).topRight.subdivide(.5),
                            bottomRightOuter: x(r + w, i + m, u, f).bottomRight.subdivide(.5),
                            bottomRightInner: x(r + Math.min(w, o - n[3].width), i + Math.min(m, a + n[0].width), Math.max(0, u - n[1].width), f - n[2].width).bottomRight.subdivide(.5),
                            bottomLeftOuter: x(r, i + y, d, p).bottomLeft.subdivide(.5),
                            bottomLeftInner: x(r + n[3].width, i + y, Math.max(0, d - n[3].width), p - n[2].width).bottomLeft.subdivide(.5)
                        };
                    }
                    function k(s, h, c, l) {
                        var u = function(t, e, n) {
                            return {
                                x: t.x + (e.x - t.x) * n,
                                y: t.y + (e.y - t.y) * n
                            };
                        };
                        return {
                            start: s,
                            startControl: h,
                            endControl: c,
                            end: l,
                            subdivide: function(t) {
                                var e = u(s, h, t), n = u(h, c, t), r = u(c, l, t), i = u(e, n, t), o = u(n, r, t), a = u(i, o, t);
                                return [
                                    k(s, e, i, a),
                                    k(a, o, r, l)
                                ];
                            },
                            curveTo: function(t) {
                                t.push([
                                    "bezierCurve",
                                    h.x,
                                    h.y,
                                    c.x,
                                    c.y,
                                    l.x,
                                    l.y
                                ]);
                            },
                            curveToReversed: function(t) {
                                t.push([
                                    "bezierCurve",
                                    c.x,
                                    c.y,
                                    h.x,
                                    h.y,
                                    s.x,
                                    s.y
                                ]);
                            }
                        };
                    }
                    function _(t, e, n, r, i, o, a) {
                        var s = [];
                        return 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            r[1].start.x,
                            r[1].start.y
                        ]), r[1].curveTo(s)) : s.push([
                            "line",
                            t.c1[0],
                            t.c1[1]
                        ]), 0 < n[0] || 0 < n[1] ? (s.push([
                            "line",
                            o[0].start.x,
                            o[0].start.y
                        ]), o[0].curveTo(s), s.push([
                            "line",
                            a[0].end.x,
                            a[0].end.y
                        ]), a[0].curveToReversed(s)) : (s.push([
                            "line",
                            t.c2[0],
                            t.c2[1]
                        ]), s.push([
                            "line",
                            t.c3[0],
                            t.c3[1]
                        ])), 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            i[1].end.x,
                            i[1].end.y
                        ]), i[1].curveToReversed(s)) : s.push([
                            "line",
                            t.c4[0],
                            t.c4[1]
                        ]), s;
                    }
                    function A(t, e, n, r, i, o, a) {
                        0 < e[0] || 0 < e[1] ? (t.push([
                            "line",
                            r[0].start.x,
                            r[0].start.y
                        ]), r[0].curveTo(t), r[1].curveTo(t)) : t.push([
                            "line",
                            o,
                            a
                        ]), (0 < n[0] || 0 < n[1]) && t.push([
                            "line",
                            i[0].start.x,
                            i[0].start.y
                        ]);
                    }
                    function I(t) {
                        return t.cssInt("zIndex") < 0;
                    }
                    function C(t) {
                        return 0 < t.cssInt("zIndex");
                    }
                    function T(t) {
                        return 0 === t.cssInt("zIndex");
                    }
                    function F(t) {
                        return -1 !== [
                            "inline",
                            "inline-block",
                            "inline-table"
                        ].indexOf(t.css("display"));
                    }
                    function P(t) {
                        return t instanceof p;
                    }
                    function E(t) {
                        return 0 < t.node.data.trim().length;
                    }
                    function q(t) {
                        return t.nodeType === Node.TEXT_NODE || t.nodeType === Node.ELEMENT_NODE;
                    }
                    function O(t) {
                        return "static" !== t.css("position");
                    }
                    function B(t) {
                        return "none" !== t.css("float");
                    }
                    function R(t) {
                        var e = this;
                        return function() {
                            return !t.apply(e, arguments);
                        };
                    }
                    function j(t) {
                        return t.node.nodeType === Node.ELEMENT_NODE;
                    }
                    function D(t) {
                        return !0 === t.isPseudoElement;
                    }
                    function M(t) {
                        return t.node.nodeType === Node.TEXT_NODE;
                    }
                    function U(t) {
                        return parseInt(t, 10);
                    }
                    function N(t) {
                        return t.width;
                    }
                    function z(t) {
                        return t.node.nodeType !== Node.ELEMENT_NODE || -1 === [
                            "SCRIPT",
                            "HEAD",
                            "TITLE",
                            "OBJECT",
                            "BR",
                            "OPTION"
                        ].indexOf(t.node.nodeName);
                    }
                    function L(t) {
                        return [].concat.apply([], t);
                    }
                    i.prototype.parseBorders = function(o) {
                        var r, t = o.parseBounds(), e = (r = o, [
                            "TopLeft",
                            "TopRight",
                            "BottomRight",
                            "BottomLeft"
                        ].map(function(t) {
                            var e = r.css("border" + t + "Radius"), n = e.split(" ");
                            return n.length <= 1 && (n[1] = n[0]), n.map(U);
                        })), n = [
                            "Top",
                            "Right",
                            "Bottom",
                            "Left"
                        ].map(function(t, e) {
                            var n = o.css("border" + t + "Style"), r = o.color("border" + t + "Color");
                            "inset" === n && r.isBlack() && (r = new u([
                                255,
                                255,
                                255,
                                r.a
                            ]));
                            var i = v[n] ? v[n][e] : null;
                            return {
                                width: o.cssInt("border" + t + "Width"),
                                color: i ? r[i[0]](i[1]) : r,
                                args: null
                            };
                        }), i = S(t, e, n);
                        return {
                            clip: this.parseBackgroundClip(o, i, n, e, t),
                            borders: b(n, t, i, e)
                        };
                    }, i.prototype.parseBackgroundClip = function(t, e, n, r, i) {
                        var o = [];
                        switch(t.css("backgroundClip")){
                            case "content-box":
                            case "padding-box":
                                A(o, r[0], r[1], e.topLeftInner, e.topRightInner, i.left + n[3].width, i.top + n[0].width), A(o, r[1], r[2], e.topRightInner, e.bottomRightInner, i.left + i.width - n[1].width, i.top + n[0].width), A(o, r[2], r[3], e.bottomRightInner, e.bottomLeftInner, i.left + i.width - n[1].width, i.top + i.height - n[2].width), A(o, r[3], r[0], e.bottomLeftInner, e.topLeftInner, i.left + n[3].width, i.top + i.height - n[2].width);
                                break;
                            default:
                                A(o, r[0], r[1], e.topLeftOuter, e.topRightOuter, i.left, i.top), A(o, r[1], r[2], e.topRightOuter, e.bottomRightOuter, i.left + i.width, i.top), A(o, r[2], r[3], e.bottomRightOuter, e.bottomLeftOuter, i.left + i.width, i.top + i.height), A(o, r[3], r[0], e.bottomLeftOuter, e.topLeftOuter, i.left, i.top + i.height);
                        }
                        return o;
                    }, e.exports = i;
                },
                {
                    "./color": 3,
                    "./fontmetrics": 7,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./pseudoelementcontainer": 18,
                    "./stackingcontext": 21,
                    "./textcontainer": 25,
                    "./utils": 26,
                    punycode: 1
                }
            ],
            16: [
                function(t, e, n) {
                    var a = t("./xhr"), r = t("./utils"), s = t("./log"), h = t("./clone"), c = r.decode64;
                    function l(t, e, n) {
                        var r = "withCredentials" in new XMLHttpRequest;
                        if (!e) return Promise.reject("No proxy configured");
                        var i = f(r), o = d(e, t, i);
                        return r ? a(o) : u(n, o, i).then(function(t) {
                            return c(t.content);
                        });
                    }
                    var i = 0;
                    function u(i, o, a) {
                        return new Promise(function(e, n) {
                            var t = i.createElement("script"), r = function() {
                                delete window.html2canvas.proxy[a], i.body.removeChild(t);
                            };
                            window.html2canvas.proxy[a] = function(t) {
                                r(), e(t);
                            }, t.src = o, t.onerror = function(t) {
                                r(), n(t);
                            }, i.body.appendChild(t);
                        });
                    }
                    function f(t) {
                        return t ? "" : "html2canvas_" + Date.now() + "_" + ++i + "_" + Math.round(1e5 * Math.random());
                    }
                    function d(t, e, n) {
                        return t + "?url=" + encodeURIComponent(e) + (n.length ? "&callback=html2canvas.proxy." + n : "");
                    }
                    n.Proxy = l, n.ProxyURL = function(t, e, n) {
                        var r = "crossOrigin" in new Image, i = f(r), o = d(e, t, i);
                        return r ? Promise.resolve(o) : u(n, o, i).then(function(t) {
                            return "data:" + t.type + ";base64," + t.content;
                        });
                    }, n.loadUrlDocument = function(t, e, n, r, i, o) {
                        var a;
                        return new l(t, e, window.document).then((a = t, function(e) {
                            var n, t = new DOMParser;
                            try {
                                n = t.parseFromString(e, "text/html");
                            } catch (t) {
                                s("DOMParser not supported, falling back to createHTMLDocument"), n = document.implementation.createHTMLDocument("");
                                try {
                                    n.open(), n.write(e), n.close();
                                } catch (t) {
                                    s("createHTMLDocument write not supported, falling back to document.body.innerHTML"), n.body.innerHTML = e;
                                }
                            }
                            var r = n.querySelector("base");
                            if (!r || !r.href.host) {
                                var i = n.createElement("base");
                                i.href = a, n.head.insertBefore(i, n.head.firstChild);
                            }
                            return n;
                        })).then(function(t) {
                            return h(t, n, r, i, o, 0, 0);
                        });
                    };
                },
                {
                    "./clone": 2,
                    "./log": 13,
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            17: [
                function(t, e, n) {
                    var o = t("./proxy").ProxyURL;
                    e.exports = function(n, r) {
                        var t = document.createElement("a");
                        t.href = n, n = t.href, this.src = n, this.image = new Image;
                        var i = this;
                        this.promise = new Promise(function(t, e) {
                            i.image.crossOrigin = "Anonymous", i.image.onload = t, i.image.onerror = e, new o(n, r, document).then(function(t) {
                                i.image.src = t;
                            }).catch(e);
                        });
                    };
                },
                {
                    "./proxy": 16
                }
            ],
            18: [
                function(t, e, n) {
                    var r = t("./nodecontainer");
                    function i(t, e, n) {
                        r.call(this, t, e), this.isPseudoElement = !0, this.before = ":before" === n;
                    }
                    i.prototype.cloneTo = function(t) {
                        i.prototype.cloneTo.call(this, t), t.isPseudoElement = !0, t.before = this.before;
                    }, (i.prototype = Object.create(r.prototype)).appendToDOM = function() {
                        this.before ? this.parent.node.insertBefore(this.node, this.parent.node.firstChild) : this.parent.node.appendChild(this.node), this.parent.node.className += " " + this.getHideClass();
                    }, i.prototype.cleanDOM = function() {
                        this.node.parentNode.removeChild(this.node), this.parent.node.className = this.parent.node.className.replace(this.getHideClass(), "");
                    }, i.prototype.getHideClass = function() {
                        return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before ? "BEFORE" : "AFTER")];
                    }, i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before", i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after", e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            19: [
                function(t, e, n) {
                    var h = t("./log");
                    function r(t, e, n, r, i) {
                        this.width = t, this.height = e, this.images = n, this.options = r, this.document = i;
                    }
                    r.prototype.renderImage = function(t, e, n, r) {
                        var i = t.cssInt("paddingLeft"), o = t.cssInt("paddingTop"), a = t.cssInt("paddingRight"), s = t.cssInt("paddingBottom"), h = n.borders, c = e.width - (h[1].width + h[3].width + i + a), l = e.height - (h[0].width + h[2].width + o + s);
                        this.drawImage(r, 0, 0, r.image.width || c, r.image.height || l, e.left + i + h[3].width, e.top + o + h[0].width, c, l);
                    }, r.prototype.renderBackground = function(t, e, n) {
                        0 < e.height && 0 < e.width && (this.renderBackgroundColor(t, e), this.renderBackgroundImage(t, e, n));
                    }, r.prototype.renderBackgroundColor = function(t, e) {
                        var n = t.color("backgroundColor");
                        n.isTransparent() || this.rectangle(e.left, e.top, e.width, e.height, n);
                    }, r.prototype.renderBorders = function(t) {
                        t.forEach(this.renderBorder, this);
                    }, r.prototype.renderBorder = function(t) {
                        t.color.isTransparent() || null === t.args || this.drawShape(t.args, t.color);
                    }, r.prototype.renderBackgroundImage = function(o, a, s) {
                        o.parseBackgroundImages().reverse().forEach(function(t, e, n) {
                            switch(t.method){
                                case "url":
                                    var r = this.images.get(t.args[0]);
                                    r ? this.renderBackgroundRepeating(o, a, r, n.length - (e + 1), s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "linear-gradient":
                                case "gradient":
                                    var i = this.images.get(t.value);
                                    i ? this.renderBackgroundGradient(i, a, s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "none":
                                    break;
                                default:
                                    h("Unknown background-image type", t.args[0]);
                            }
                        }, this);
                    }, r.prototype.renderBackgroundRepeating = function(t, e, n, r, i) {
                        var o = t.parseBackgroundSize(e, n.image, r), a = t.parseBackgroundPosition(e, n.image, r, o);
                        switch(t.parseBackgroundRepeat(r)){
                            case "repeat-x":
                            case "repeat no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + i[3], e.top + a.top + i[0], 99999, o.height, i);
                                break;
                            case "repeat-y":
                            case "no-repeat repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + i[0], o.width, 99999, i);
                                break;
                            case "no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + a.top + i[0], o.width, o.height, i);
                                break;
                            default:
                                this.renderBackgroundRepeat(n, a, o, {
                                    top: e.top,
                                    left: e.left
                                }, i[3], i[0]);
                        }
                    }, e.exports = r;
                },
                {
                    "./log": 13
                }
            ],
            20: [
                function(t, e, n) {
                    var r = t("../renderer"), i = t("../lineargradientcontainer"), o = t("../log");
                    function a(t, e) {
                        r.apply(this, arguments), this.canvas = this.options.canvas || this.document.createElement("canvas"), this.options.canvas || (this.canvas.width = t, this.canvas.height = e), this.ctx = this.canvas.getContext("2d"), this.taintCtx = this.document.createElement("canvas").getContext("2d"), this.ctx.textBaseline = "bottom", this.variables = {}, o("Initialized CanvasRenderer with size", t, "x", e);
                    }
                    function s(t) {
                        return 0 < t.length;
                    }
                    (a.prototype = Object.create(r.prototype)).setFillStyle = function(t) {
                        return this.ctx.fillStyle = "object" == typeof t && t.isColor ? t.toString() : t, this.ctx;
                    }, a.prototype.rectangle = function(t, e, n, r, i) {
                        this.setFillStyle(i).fillRect(t, e, n, r);
                    }, a.prototype.circle = function(t, e, n, r) {
                        this.setFillStyle(r), this.ctx.beginPath(), this.ctx.arc(t + n / 2, e + n / 2, n / 2, 0, 2 * Math.PI, !0), this.ctx.closePath(), this.ctx.fill();
                    }, a.prototype.circleStroke = function(t, e, n, r, i, o) {
                        this.circle(t, e, n, r), this.ctx.strokeStyle = o.toString(), this.ctx.stroke();
                    }, a.prototype.drawShape = function(t, e) {
                        this.shape(t), this.setFillStyle(e).fill();
                    }, a.prototype.taints = function(e) {
                        if (null === e.tainted) {
                            this.taintCtx.drawImage(e.image, 0, 0);
                            try {
                                this.taintCtx.getImageData(0, 0, 1, 1), e.tainted = !1;
                            } catch (t) {
                                this.taintCtx = document.createElement("canvas").getContext("2d"), e.tainted = !0;
                            }
                        }
                        return e.tainted;
                    }, a.prototype.drawImage = function(t, e, n, r, i, o, a, s, h) {
                        this.taints(t) && !this.options.allowTaint || this.ctx.drawImage(t.image, e, n, r, i, o, a, s, h);
                    }, a.prototype.clip = function(t, e, n) {
                        this.ctx.save(), t.filter(s).forEach(function(t) {
                            this.shape(t).clip();
                        }, this), e.call(n), this.ctx.restore();
                    }, a.prototype.shape = function(t) {
                        return this.ctx.beginPath(), t.forEach(function(t, e) {
                            "rect" === t[0] ? this.ctx.rect.apply(this.ctx, t.slice(1)) : this.ctx[0 === e ? "moveTo" : t[0] + "To"].apply(this.ctx, t.slice(1));
                        }, this), this.ctx.closePath(), this.ctx;
                    }, a.prototype.font = function(t, e, n, r, i, o) {
                        this.setFillStyle(t).font = [
                            e,
                            n,
                            r,
                            i,
                            o
                        ].join(" ").split(",")[0];
                    }, a.prototype.fontShadow = function(t, e, n, r) {
                        this.setVariable("shadowColor", t.toString()).setVariable("shadowOffsetY", e).setVariable("shadowOffsetX", n).setVariable("shadowBlur", r);
                    }, a.prototype.clearShadow = function() {
                        this.setVariable("shadowColor", "rgba(0,0,0,0)");
                    }, a.prototype.setOpacity = function(t) {
                        this.ctx.globalAlpha = t;
                    }, a.prototype.setTransform = function(t) {
                        this.ctx.translate(t.origin[0], t.origin[1]), this.ctx.transform.apply(this.ctx, t.matrix), this.ctx.translate(-t.origin[0], -t.origin[1]);
                    }, a.prototype.setVariable = function(t, e) {
                        return this.variables[t] !== e && (this.variables[t] = this.ctx[t] = e), this;
                    }, a.prototype.text = function(t, e, n) {
                        this.ctx.fillText(t, e, n);
                    }, a.prototype.backgroundRepeatShape = function(t, e, n, r, i, o, a, s, h) {
                        var c = [
                            [
                                "line",
                                Math.round(i),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(s + o)
                            ],
                            [
                                "line",
                                Math.round(i),
                                Math.round(s + o)
                            ]
                        ];
                        this.clip([
                            c
                        ], function() {
                            this.renderBackgroundRepeat(t, e, n, r, h[3], h[0]);
                        }, this);
                    }, a.prototype.renderBackgroundRepeat = function(t, e, n, r, i, o) {
                        var a = Math.round(r.left + e.left + i), s = Math.round(r.top + e.top + o);
                        this.setFillStyle(this.ctx.createPattern(this.resizeImage(t, n), "repeat")), this.ctx.translate(a, s), this.ctx.fill(), this.ctx.translate(-a, -s);
                    }, a.prototype.renderBackgroundGradient = function(t, e) {
                        if (t instanceof i) {
                            var n = this.ctx.createLinearGradient(e.left + e.width * t.x0, e.top + e.height * t.y0, e.left + e.width * t.x1, e.top + e.height * t.y1);
                            t.colorStops.forEach(function(t) {
                                n.addColorStop(t.stop, t.color.toString());
                            }), this.rectangle(e.left, e.top, e.width, e.height, n);
                        }
                    }, a.prototype.resizeImage = function(t, e) {
                        var n = t.image;
                        if (n.width === e.width && n.height === e.height) return n;
                        var r = document.createElement("canvas");
                        return r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(n, 0, 0, n.width, n.height, 0, 0, e.width, e.height), r;
                    }, e.exports = a;
                },
                {
                    "../lineargradientcontainer": 12,
                    "../log": 13,
                    "../renderer": 19
                }
            ],
            21: [
                function(t, e, n) {
                    var i = t("./nodecontainer");
                    function r(t, e, n, r) {
                        i.call(this, n, r), this.ownStacking = t, this.contexts = [], this.children = [], this.opacity = (this.parent ? this.parent.stack.opacity : 1) * e;
                    }
                    (r.prototype = Object.create(i.prototype)).getParentStack = function(t) {
                        var e = this.parent ? this.parent.stack : null;
                        return e ? e.ownStacking ? e : e.getParentStack(t) : t.stack;
                    }, e.exports = r;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            22: [
                function(t, e, n) {
                    function r(t) {
                        this.rangeBounds = this.testRangeBounds(t), this.cors = this.testCORS(), this.svg = this.testSVG();
                    }
                    r.prototype.testRangeBounds = function(t) {
                        var e, n, r = !1;
                        return t.createRange && (e = t.createRange()).getBoundingClientRect && ((n = t.createElement("boundtest")).style.height = "123px", n.style.display = "block", t.body.appendChild(n), e.selectNode(n), 123 === e.getBoundingClientRect().height && (r = !0), t.body.removeChild(n)), r;
                    }, r.prototype.testCORS = function() {
                        return void 0 !== (new Image).crossOrigin;
                    }, r.prototype.testSVG = function() {
                        var t = new Image, e = document.createElement("canvas"), n = e.getContext("2d");
                        t.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
                        try {
                            n.drawImage(t, 0, 0), e.toDataURL();
                        } catch (t) {
                            return !1;
                        }
                        return !0;
                    }, e.exports = r;
                },
                {}
            ],
            23: [
                function(t, e, n) {
                    var r = t("./xhr"), i = t("./utils").decode64;
                    function o(t) {
                        this.src = t, this.image = null;
                        var n = this;
                        this.promise = this.hasFabric().then(function() {
                            return n.isInline(t) ? Promise.resolve(n.inlineFormatting(t)) : r(t);
                        }).then(function(e) {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.loadSVGFromString(e, n.createCanvas.call(n, t));
                            });
                        });
                    }
                    o.prototype.hasFabric = function() {
                        return window.html2canvas.svg && window.html2canvas.svg.fabric ? Promise.resolve() : Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"));
                    }, o.prototype.inlineFormatting = function(t) {
                        return /^data:image\/svg\+xml;base64,/.test(t) ? this.decode64(this.removeContentType(t)) : this.removeContentType(t);
                    }, o.prototype.removeContentType = function(t) {
                        return t.replace(/^data:image\/svg\+xml(;base64)?,/, "");
                    }, o.prototype.isInline = function(t) {
                        return /^data:image\/svg\+xml/i.test(t);
                    }, o.prototype.createCanvas = function(r) {
                        var i = this;
                        return function(t, e) {
                            var n = new window.html2canvas.svg.fabric.StaticCanvas("c");
                            i.image = n.lowerCanvasEl, n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t, e)).renderAll(), r(n.lowerCanvasEl);
                        };
                    }, o.prototype.decode64 = function(t) {
                        return "function" == typeof window.atob ? window.atob(t) : i(t);
                    }, e.exports = o;
                },
                {
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            24: [
                function(t, e, n) {
                    var r = t("./svgcontainer");
                    function i(n, t) {
                        this.src = n, this.image = null;
                        var r = this;
                        this.promise = t ? new Promise(function(t, e) {
                            r.image = new Image, r.image.onload = t, r.image.onerror = e, r.image.src = "data:image/svg+xml," + (new XMLSerializer).serializeToString(n), !0 === r.image.complete && t(r.image);
                        }) : this.hasFabric().then(function() {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.parseSVGDocument(n, r.createCanvas.call(r, t));
                            });
                        });
                    }
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./svgcontainer": 23
                }
            ],
            25: [
                function(t, e, n) {
                    var r = t("./nodecontainer");
                    function i(t, e) {
                        r.call(this, t, e);
                    }
                    function o(t, e, n) {
                        if (0 < t.length) return e + n.toUpperCase();
                    }
                    (i.prototype = Object.create(r.prototype)).applyTextTransform = function() {
                        this.node.data = this.transform(this.parent.css("textTransform"));
                    }, i.prototype.transform = function(t) {
                        var e = this.node.data;
                        switch(t){
                            case "lowercase":
                                return e.toLowerCase();
                            case "capitalize":
                                return e.replace(/(^|\s|:|-|\(|\))([a-z])/g, o);
                            case "uppercase":
                                return e.toUpperCase();
                            default:
                                return e;
                        }
                    }, e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            26: [
                function(t, e, n) {
                    n.smallImage = function() {
                        return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                    }, n.bind = function(t, e) {
                        return function() {
                            return t.apply(e, arguments);
                        };
                    }, /*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */ n.decode64 = function(t) {
                        var e, n, r, i, o, a, s, h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = t.length, l = "";
                        for(e = 0; e < c; e += 4)o = h.indexOf(t[e]) << 2 | (n = h.indexOf(t[e + 1])) >> 4, a = (15 & n) << 4 | (r = h.indexOf(t[e + 2])) >> 2, s = (3 & r) << 6 | (i = h.indexOf(t[e + 3])), l += 64 === r ? String.fromCharCode(o) : 64 === i || -1 === i ? String.fromCharCode(o, a) : String.fromCharCode(o, a, s);
                        return l;
                    }, n.getBounds = function(t) {
                        if (t.getBoundingClientRect) {
                            var e = t.getBoundingClientRect(), n = null == t.offsetWidth ? e.width : t.offsetWidth;
                            return {
                                top: e.top,
                                bottom: e.bottom || e.top + e.height,
                                right: e.left + n,
                                left: e.left,
                                width: n,
                                height: null == t.offsetHeight ? e.height : t.offsetHeight
                            };
                        }
                        return {};
                    }, n.offsetBounds = function(t) {
                        var e = t.offsetParent ? n.offsetBounds(t.offsetParent) : {
                            top: 0,
                            left: 0
                        };
                        return {
                            top: t.offsetTop + e.top,
                            bottom: t.offsetTop + t.offsetHeight + e.top,
                            right: t.offsetLeft + e.left + t.offsetWidth,
                            left: t.offsetLeft + e.left,
                            width: t.offsetWidth,
                            height: t.offsetHeight
                        };
                    }, n.parseBackgrounds = function(t) {
                        var e, n, r, i, o, a, s, h = [], c = 0, l = 0, u = function() {
                            e && ('"' === n.substr(0, 1) && (n = n.substr(1, n.length - 2)), n && s.push(n), "-" === e.substr(0, 1) && 0 < (i = e.indexOf("-", 1) + 1) && (r = e.substr(0, i), e = e.substr(i)), h.push({
                                prefix: r,
                                method: e.toLowerCase(),
                                value: o,
                                args: s,
                                image: null
                            })), s = [], e = r = n = o = "";
                        };
                        return s = [], e = r = n = o = "", t.split("").forEach(function(t) {
                            if (!(0 === c && -1 < " \r\n\t".indexOf(t))) {
                                switch(t){
                                    case '"':
                                        a ? a === t && (a = null) : a = t;
                                        break;
                                    case "(":
                                        if (a) break;
                                        if (0 === c) return c = 1, void (o += t);
                                        l++;
                                        break;
                                    case ")":
                                        if (a) break;
                                        if (1 === c) {
                                            if (0 === l) return c = 0, o += t, void u();
                                            l--;
                                        }
                                        break;
                                    case ",":
                                        if (a) break;
                                        if (0 === c) return void u();
                                        if (1 === c && 0 === l && !e.match(/^url$/i)) return s.push(n), n = "", void (o += t);
                                }
                                o += t, 0 === c ? e += t : n += t;
                            }
                        }), u(), h;
                    };
                },
                {}
            ],
            27: [
                function(t, e, n) {
                    var r = t("./gradientcontainer");
                    function i(t) {
                        r.apply(this, arguments), this.type = "linear" === t.args[0] ? r.TYPES.LINEAR : r.TYPES.RADIAL;
                    }
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./gradientcontainer": 9
                }
            ],
            28: [
                function(t, e, n) {
                    e.exports = function(r) {
                        return new Promise(function(t, e) {
                            var n = new XMLHttpRequest;
                            n.open("GET", r), n.onload = function() {
                                200 === n.status ? t(n.responseText) : e(new Error(n.statusText));
                            }, n.onerror = function() {
                                e(new Error("Network Error"));
                            }, n.send();
                        });
                    };
                },
                {}
            ]
        }, {}, [
            4
        ])(4);
    }), function(t) {
        var n = "+".charCodeAt(0), r = "/".charCodeAt(0), i = "0".charCodeAt(0), o = "a".charCodeAt(0), a = "A".charCodeAt(0), s = "-".charCodeAt(0), h = "_".charCodeAt(0), l = function(t) {
            var e = t.charCodeAt(0);
            return e === n || e === s ? 62 : e === r || e === h ? 63 : e < i ? -1 : e < i + 10 ? e - i + 26 + 26 : e < a + 26 ? e - a : e < o + 26 ? e - o + 26 : void 0;
        };
        t.API.TTFFont = function() {
            function i(t, e, n) {
                var r;
                if (this.rawData = t, r = this.contents = new X(t), this.contents.pos = 4, "ttcf" === r.readString(4)) {
                    if (!e) throw new Error("Must specify a font name for TTC files.");
                    throw new Error("Font " + e + " not found in TTC file.");
                }
                r.pos = 0, this.parse(), this.subset = new T(this), this.registerTTF();
            }
            return i.open = function(t, e, n, r) {
                return new i(function(t) {
                    var e, n, r, i, o, a;
                    if (0 < t.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    var s = t.length;
                    o = "=" === t.charAt(s - 2) ? 2 : "=" === t.charAt(s - 1) ? 1 : 0, a = new Uint8Array(3 * t.length / 4 - o), r = 0 < o ? t.length - 4 : t.length;
                    var h = 0;
                    function c(t) {
                        a[h++] = t;
                    }
                    for(n = e = 0; e < r; e += 4, n += 3)c((16711680 & (i = l(t.charAt(e)) << 18 | l(t.charAt(e + 1)) << 12 | l(t.charAt(e + 2)) << 6 | l(t.charAt(e + 3)))) >> 16), c((65280 & i) >> 8), c(255 & i);
                    return 2 === o ? c(255 & (i = l(t.charAt(e)) << 2 | l(t.charAt(e + 1)) >> 4)) : 1 === o && (c((i = l(t.charAt(e)) << 10 | l(t.charAt(e + 1)) << 4 | l(t.charAt(e + 2)) >> 2) >> 8 & 255), c(255 & i)), a;
                }(n), e, r);
            }, i.prototype.parse = function() {
                return this.directory = new e(this.contents), this.head = new d(this), this.name = new b(this), this.cmap = new m(this), this.hhea = new g(this), this.maxp = new x(this), this.hmtx = new S(this), this.post = new y(this), this.os2 = new w(this), this.loca = new C(this), this.glyf = new _(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
                    this.head.xMin,
                    this.head.yMin,
                    this.head.xMax,
                    this.head.yMax
                ];
            }, i.prototype.registerTTF = function() {
                var i, t, e, n, r;
                if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.bbox).length; t < e; t++)i = n[t], r.push(Math.round(i * this.scaleFactor));
                    return r;
                }).call(this), this.stemV = 0, this.post.exists ? (e = 255 & (n = this.post.italic_angle), !0 & (t = n >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + e)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (r = this.familyClass) || 2 === r || 3 === r || 4 === r || 5 === r || 7 === r, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
            }, i.prototype.characterToGlyph = function(t) {
                var e;
                return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
            }, i.prototype.widthOfGlyph = function(t) {
                var e;
                return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
            }, i.prototype.widthOfString = function(t, e, n) {
                var r, i, o, a, s;
                for(i = a = o = 0, s = (t = "" + t).length; 0 <= s ? a < s : s < a; i = 0 <= s ? ++a : --a)r = t.charCodeAt(i), o += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
                return o * (e / 1e3);
            }, i.prototype.lineHeight = function(t, e) {
                var n;
                return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
            }, i;
        }();
        var c, X = function() {
            function t(t) {
                this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
            }
            return t.prototype.readByte = function() {
                return this.data[this.pos++];
            }, t.prototype.writeByte = function(t) {
                return this.data[this.pos++] = t;
            }, t.prototype.readUInt32 = function() {
                return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
            }, t.prototype.writeUInt32 = function(t) {
                return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt32 = function() {
                var t;
                return 2147483648 <= (t = this.readUInt32()) ? t - 4294967296 : t;
            }, t.prototype.writeInt32 = function(t) {
                return t < 0 && (t += 4294967296), this.writeUInt32(t);
            }, t.prototype.readUInt16 = function() {
                return this.readByte() << 8 | this.readByte();
            }, t.prototype.writeUInt16 = function(t) {
                return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt16 = function() {
                var t;
                return 32768 <= (t = this.readUInt16()) ? t - 65536 : t;
            }, t.prototype.writeInt16 = function(t) {
                return t < 0 && (t += 65536), this.writeUInt16(t);
            }, t.prototype.readString = function(t) {
                var e, n, r;
                for(n = [], e = r = 0; 0 <= t ? r < t : t < r; e = 0 <= t ? ++r : --r)n[e] = String.fromCharCode(this.readByte());
                return n.join("");
            }, t.prototype.writeString = function(t) {
                var e, n, r, i;
                for(i = [], e = n = 0, r = t.length; 0 <= r ? n < r : r < n; e = 0 <= r ? ++n : --n)i.push(this.writeByte(t.charCodeAt(e)));
                return i;
            }, t.prototype.readShort = function() {
                return this.readInt16();
            }, t.prototype.writeShort = function(t) {
                return this.writeInt16(t);
            }, t.prototype.readLongLong = function() {
                var t, e, n, r, i, o, a, s;
                return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), o = this.readByte(), a = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ o) + 256 * (255 ^ a) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * o + 256 * a + s;
            }, t.prototype.readInt = function() {
                return this.readInt32();
            }, t.prototype.writeInt = function(t) {
                return this.writeInt32(t);
            }, t.prototype.read = function(t) {
                var e, n;
                for(e = [], n = 0; 0 <= t ? n < t : t < n; 0 <= t ? ++n : --n)e.push(this.readByte());
                return e;
            }, t.prototype.write = function(t) {
                var e, n, r, i;
                for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
                return i;
            }, t;
        }(), e = function() {
            var p;
            function t(t) {
                var e, n, r;
                for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : r < n; 0 <= r ? ++n : --n)e = {
                    tag: t.readString(4),
                    checksum: t.readInt(),
                    offset: t.readInt(),
                    length: t.readInt()
                }, this.tables[e.tag] = e;
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d;
                for(d in u = Object.keys(t).length, a = Math.log(2), c = 16 * Math.floor(Math.log(u) / a), i = Math.floor(c / a), h = 16 * u - c, (n = new X).writeInt(this.scalarType), n.writeShort(u), n.writeShort(c), n.writeShort(i), n.writeShort(h), r = 16 * u, s = n.pos + r, o = null, f = [], t)for(l = t[d], n.writeString(d), n.writeInt(p(l)), n.writeInt(s), n.writeInt(l.length), f = f.concat(l), "head" === d && (o = s), s += l.length; s % 4;)f.push(0), s++;
                return n.write(f), e = 2981146554 - p(n.data), n.pos = o + 8, n.writeUInt32(e), n.data;
            }, p = function(t) {
                var e, n, r, i;
                for(t = k.call(t); t.length % 4;)t.push(0);
                for(n = new X(t), r = e = 0, i = t.length; r < i; r += 4)e += n.readUInt32();
                return 4294967295 & e;
            }, t;
        }(), u = {}.hasOwnProperty, f = function(t, e) {
            for(var n in e)u.call(e, n) && (t[n] = e[n]);
            function r() {
                this.constructor = t;
            }
            return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
        };
        c = function() {
            function t(t) {
                var e;
                this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
            }
            return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
                return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
            }, t;
        }();
        var d = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "head", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
            }, e;
        }(), p = function() {
            function t(n, t) {
                var e, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v;
                switch(this.platformID = n.readUInt16(), this.encodingID = n.readShort(), this.offset = t + n.readInt(), l = n.pos, n.pos = this.offset, this.format = n.readUInt16(), this.length = n.readUInt16(), this.language = n.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
                    case 0:
                        for(s = m = 0; m < 256; s = ++m)this.codeMap[s] = n.readByte();
                        break;
                    case 4:
                        for(f = n.readUInt16(), u = f / 2, n.pos += 6, i = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), n.pos += 2, p = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), h = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), c = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), r = (this.length - n.pos + this.offset) / 2, a = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= r ? t < r : r < t; s = 0 <= r ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), s = w = 0, v = i.length; w < v; s = ++w)for(g = i[s], e = y = d = p[s]; d <= g ? y <= g : g <= y; e = d <= g ? ++y : --y)0 === c[s] ? o = e + h[s] : 0 !== (o = a[c[s] / 2 + (e - d) - (u - s)] || 0) && (o += h[s]), this.codeMap[e] = 65535 & o;
                }
                n.pos = l;
            }
            return t.encode = function(t, e) {
                var n, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y;
                switch(F = new X, o = Object.keys(t).sort(function(t, e) {
                    return t - e;
                }), e){
                    case "macroman":
                        for(p = 0, g = function() {
                            var t, e;
                            for(e = [], d = t = 0; t < 256; d = ++t)e.push(0);
                            return e;
                        }(), w = {
                            0: 0
                        }, i = {}, P = 0, B = o.length; P < B; P++)null == w[W = t[r = o[P]]] && (w[W] = ++p), i[r] = {
                            old: t[r],
                            new: w[t[r]]
                        }, g[r] = w[t[r]];
                        return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                            charMap: i,
                            subtable: F.data,
                            maxGlyphID: p + 1
                        };
                    case "unicode":
                        for(C = [], l = [], w = {}, n = {}, m = h = null, E = y = 0, R = o.length; E < R; E++)null == w[b = t[r = o[E]]] && (w[b] = ++y), n[r] = {
                            old: b,
                            new: w[b]
                        }, a = w[b] - r, null != m && a === h || (m && l.push(m), C.push(r), h = a), m = r;
                        for(m && l.push(m), l.push(65535), C.push(65535), A = 2 * (_ = C.length), k = 2 * Math.pow(Math.log(_) / Math.LN2, 2), u = Math.log(k / 2) / Math.LN2, S = 2 * _ - k, s = [], x = [], f = [], d = q = 0, j = C.length; q < j; d = ++q){
                            if (I = C[d], c = l[d], 65535 === I) {
                                s.push(0), x.push(0);
                                break;
                            }
                            if (32768 <= I - (T = n[I].new)) for(s.push(0), x.push(2 * (f.length + _ - d)), r = O = I; I <= c ? O <= c : c <= O; r = I <= c ? ++O : --O)f.push(n[r].new);
                            else s.push(T - I), x.push(0);
                        }
                        for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * _ + 2 * f.length), F.writeUInt16(0), F.writeUInt16(A), F.writeUInt16(k), F.writeUInt16(u), F.writeUInt16(S), L = 0, D = l.length; L < D; L++)r = l[L], F.writeUInt16(r);
                        for(F.writeUInt16(0), H = 0, M = C.length; H < M; H++)r = C[H], F.writeUInt16(r);
                        for(G = 0, U = s.length; G < U; G++)a = s[G], F.writeUInt16(a);
                        for(V = 0, N = x.length; V < N; V++)v = x[V], F.writeUInt16(v);
                        for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                        return {
                            charMap: n,
                            subtable: F.data,
                            maxGlyphID: y + 1
                        };
                }
            }, t;
        }(), m = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
                var e, n, r;
                for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : n < r; 0 <= n ? ++r : --r)e = new p(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
                return !0;
            }, e.encode = function(t, e) {
                var n, r;
                return null == e && (e = "macroman"), n = p.encode(t, e), (r = new X).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
            }, e;
        }(), g = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
            }, e;
        }(), w = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "OS/2", e.prototype.parse = function(n) {
                if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
                    var t, e;
                    for(e = [], t = 0; t < 10; ++t)e.push(n.readByte());
                    return e;
                }(), this.charRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(n.readInt());
                    return e;
                }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), 0 < this.version && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 2; ++t)e.push(n.readInt());
                    return e;
                }(), 1 < this.version)) return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
            }, e;
        }(), y = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "post", e.prototype.parse = function(r) {
                var t, e, n, i;
                switch(r.pos = this.offset, this.format = r.readInt(), this.italicAngle = r.readInt(), this.underlinePosition = r.readShort(), this.underlineThickness = r.readShort(), this.isFixedPitch = r.readInt(), this.minMemType42 = r.readInt(), this.maxMemType42 = r.readInt(), this.minMemType1 = r.readInt(), this.maxMemType1 = r.readInt(), this.format){
                    case 65536:
                        break;
                    case 131072:
                        for(e = r.readUInt16(), this.glyphNameIndex = [], n = 0; 0 <= e ? n < e : e < n; 0 <= e ? ++n : --n)this.glyphNameIndex.push(r.readUInt16());
                        for(this.names = [], i = []; r.pos < this.offset + this.length;)t = r.readByte(), i.push(this.names.push(r.readString(t)));
                        return i;
                    case 151552:
                        return e = r.readUInt16(), this.offsets = r.read(e);
                    case 196608:
                        break;
                    case 262144:
                        return this.map = (function() {
                            var t, e, n;
                            for(n = [], t = 0, e = this.file.maxp.numGlyphs; 0 <= e ? t < e : e < t; 0 <= e ? ++t : --t)n.push(r.readUInt32());
                            return n;
                        }).call(this);
                }
            }, e;
        }(), v = function(t, e) {
            this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
        }, b = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "name", e.prototype.parse = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f;
                for(t.pos = this.offset, t.readShort(), e = t.readShort(), a = t.readShort(), n = [], i = c = 0; 0 <= e ? c < e : e < c; i = 0 <= e ? ++c : --c)n.push({
                    platformID: t.readShort(),
                    encodingID: t.readShort(),
                    languageID: t.readShort(),
                    nameID: t.readShort(),
                    length: t.readShort(),
                    offset: this.offset + a + t.readShort()
                });
                for(s = {}, i = l = 0, u = n.length; l < u; i = ++l)r = n[i], t.pos = r.offset, h = t.readString(r.length), o = new v(h, r), null == s[f = r.nameID] && (s[f] = []), s[r.nameID].push(o);
                return this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5], this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, ""), this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
            }, e;
        }(), x = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
            }, e;
        }(), S = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hmtx", e.prototype.parse = function(n) {
                var t, r, i, e, o, a, s;
                for(n.pos = this.offset, this.metrics = [], e = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? e < a : a < e; 0 <= a ? ++e : --e)this.metrics.push({
                    advance: n.readUInt16(),
                    lsb: n.readInt16()
                });
                for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
                    var t, e;
                    for(e = [], t = 0; 0 <= r ? t < r : r < t; 0 <= r ? ++t : --t)e.push(n.readInt16());
                    return e;
                }(), this.widths = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
                    return r;
                }).call(this), t = this.widths[this.widths.length - 1], s = [], o = 0; 0 <= r ? o < r : r < o; 0 <= r ? ++o : --o)s.push(this.widths.push(t));
                return s;
            }, e.prototype.forGlyph = function(t) {
                return t in this.metrics ? this.metrics[t] : {
                    advance: this.metrics[this.metrics.length - 1].advance,
                    lsb: this.leftSideBearings[t - this.metrics.length]
                };
            }, e;
        }(), k = [].slice, _ = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "glyf", e.prototype.parse = function(t) {
                return this.cache = {};
            }, e.prototype.glyphFor = function(t) {
                var e, n, r, i, o, a, s, h, c, l;
                return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, o = (a = new X(e.read(r))).readShort(), h = a.readShort(), l = a.readShort(), s = a.readShort(), c = a.readShort(), this.cache[t] = -1 === o ? new I(a, h, l, s, c) : new A(a, o, h, l, s, c), this.cache[t]));
            }, e.prototype.encode = function(t, e, n) {
                var r, i, o, a, s;
                for(o = [], i = [], a = 0, s = e.length; a < s; a++)r = t[e[a]], i.push(o.length), r && (o = o.concat(r.encode(n)));
                return i.push(o.length), {
                    table: o,
                    offsets: i
                };
            }, e;
        }(), A = function() {
            function t(t, e, n, r, i, o) {
                this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = o, this.compound = !1;
            }
            return t.prototype.encode = function() {
                return this.raw.data;
            }, t;
        }(), I = function() {
            function t(t, e, n, r, i) {
                var o, a;
                for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], o = this.raw; a = o.readShort(), this.glyphOffsets.push(o.pos), this.glyphIDs.push(o.readShort()), 32 & a;)o.pos += 1 & a ? 4 : 2, 128 & a ? o.pos += 8 : 64 & a ? o.pos += 4 : 8 & a && (o.pos += 2);
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o;
                for(n = new X(k.call(this.raw.data)), e = r = 0, i = (o = this.glyphIDs).length; r < i; e = ++r)o[e], n.pos = this.glyphOffsets[e];
                return n.data;
            }, t;
        }(), C = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "loca", e.prototype.parse = function(r) {
                var t;
                return r.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = 0 === t ? (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 2)n.push(2 * r.readUInt16());
                    return n;
                }).call(this) : (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 4)n.push(r.readUInt32());
                    return n;
                }).call(this);
            }, e.prototype.indexOf = function(t) {
                return this.offsets[t];
            }, e.prototype.lengthOf = function(t) {
                return this.offsets[t + 1] - this.offsets[t];
            }, e.prototype.encode = function(t, e) {
                for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, o = 0; o < n.length; ++o)if (n[o] = r, i < e.length && e[i] == o) {
                    ++i, n[o] = r;
                    var a = this.offsets[o], s = this.offsets[o + 1] - a;
                    0 < s && (r += s);
                }
                for(var h = new Array(4 * n.length), c = 0; c < n.length; ++c)h[4 * c + 3] = 255 & n[c], h[4 * c + 2] = (65280 & n[c]) >> 8, h[4 * c + 1] = (16711680 & n[c]) >> 16, h[4 * c] = (4278190080 & n[c]) >> 24;
                return h;
            }, e;
        }(), T = function() {
            function t(t) {
                this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
            }
            return t.prototype.generateCmap = function() {
                var t, e, n, r, i;
                for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
                return t;
            }, t.prototype.glyphsFor = function(t) {
                var e, n, r, i, o, a, s;
                for(r = {}, o = 0, a = t.length; o < a; o++)r[i = t[o]] = this.font.glyf.glyphFor(i);
                for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
                if (0 < e.length) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
                return r;
            }, t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g;
                for(n in e = m.encode(this.generateCmap(), "unicode"), i = this.glyphsFor(t), u = {
                    0: 0
                }, g = e.charMap)u[(a = g[n]).old] = a.new;
                for(f in l = e.maxGlyphID, i)f in u || (u[f] = l++);
                return h = function(t) {
                    var e, n;
                    for(e in n = {}, t)n[t[e]] = e;
                    return n;
                }(u), c = Object.keys(h).sort(function(t, e) {
                    return t - e;
                }), d = function() {
                    var t, e, n;
                    for(n = [], t = 0, e = c.length; t < e; t++)o = c[t], n.push(h[o]);
                    return n;
                }(), r = this.font.glyf.encode(i, d, u), s = this.font.loca.encode(r.offsets, d), p = {
                    cmap: this.font.cmap.raw(),
                    glyf: r.table,
                    loca: s,
                    hmtx: this.font.hmtx.raw(),
                    hhea: this.font.hhea.raw(),
                    maxp: this.font.maxp.raw(),
                    post: this.font.post.raw(),
                    name: this.font.name.raw(),
                    head: this.font.head.raw()
                }, this.font.os2.exists && (p["OS/2"] = this.font.os2.raw()), this.font.directory.encode(p);
            }, t;
        }();
        t.API.PDFObject = function() {
            var o;
            function a() {}
            return o = function(t, e) {
                return (Array(e + 1).join("0") + t).slice(-e);
            }, a.convert = function(r) {
                var i, t, e, n;
                if (Array.isArray(r)) return "[" + (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = r.length; t < e; t++)i = r[t], n.push(a.convert(i));
                    return n;
                })().join(" ") + "]";
                if ("string" == typeof r) return "/" + r;
                if (null != r ? r.isString : void 0) return "(" + r + ")";
                if (r instanceof Date) return "(D:" + o(r.getUTCFullYear(), 4) + o(r.getUTCMonth(), 2) + o(r.getUTCDate(), 2) + o(r.getUTCHours(), 2) + o(r.getUTCMinutes(), 2) + o(r.getUTCSeconds(), 2) + "Z)";
                if ("[object Object]" === ({}).toString.call(r)) {
                    for(t in e = [
                        "<<"
                    ], r)n = r[t], e.push("/" + t + " " + a.convert(n));
                    return e.push(">>"), e.join("\n");
                }
                return "" + r;
            }, a;
        }();
    }($), /*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */ pt = "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")(), gt = function() {
        var c, n, r;
        function i(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d, p;
            for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, a = null;;){
                switch(e = this.readUInt32(), c = (function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                    return e;
                }).call(this).join("")){
                    case "IHDR":
                        this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                        break;
                    case "acTL":
                        this.animation = {
                            numFrames: this.readUInt32(),
                            numPlays: this.readUInt32() || 1 / 0,
                            frames: []
                        };
                        break;
                    case "PLTE":
                        this.palette = this.read(e);
                        break;
                    case "fcTL":
                        a && this.animation.frames.push(a), this.pos += 4, a = {
                            width: this.readUInt32(),
                            height: this.readUInt32(),
                            xOffset: this.readUInt32(),
                            yOffset: this.readUInt32()
                        }, o = this.readUInt16(), i = this.readUInt16() || 100, a.delay = 1e3 * o / i, a.disposeOp = this.data[this.pos++], a.blendOp = this.data[this.pos++], a.data = [];
                        break;
                    case "IDAT":
                    case "fdAT":
                        for("fdAT" === c && (this.pos += 4, e -= 4), t = (null != a ? a.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : e < f; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                        break;
                    case "tRNS":
                        switch(this.transparency = {}, this.colorType){
                            case 3:
                                if (r = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > r) throw new Error("More transparent colors than palette size");
                                if (0 < (l = r - this.transparency.indexed.length)) for(d = 0; 0 <= l ? d < l : l < d; 0 <= l ? ++d : --d)this.transparency.indexed.push(255);
                                break;
                            case 0:
                                this.transparency.grayscale = this.read(e)[0];
                                break;
                            case 2:
                                this.transparency.rgb = this.read(e);
                        }
                        break;
                    case "tEXt":
                        s = (u = this.read(e)).indexOf(0), h = String.fromCharCode.apply(String, u.slice(0, s)), this.text[h] = String.fromCharCode.apply(String, u.slice(s + 1));
                        break;
                    case "IEND":
                        return a && this.animation.frames.push(a), this.colors = (function() {
                            switch(this.colorType){
                                case 0:
                                case 3:
                                case 4:
                                    return 1;
                                case 2:
                                case 6:
                                    return 3;
                            }
                        }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, n = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * n, this.colorSpace = (function() {
                            switch(this.colors){
                                case 1:
                                    return "DeviceGray";
                                case 3:
                                    return "DeviceRGB";
                            }
                        }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                    default:
                        this.pos += e;
                }
                if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
            }
        }
        i.load = function(t, e, n) {
            var r;
            return "function" == typeof e && (n = e), (r = new XMLHttpRequest).open("GET", t, !0), r.responseType = "arraybuffer", r.onload = function() {
                var t;
                return t = new i(new Uint8Array(r.response || r.mozResponseArrayBuffer)), "function" == typeof (null != e ? e.getContext : void 0) && t.render(e), "function" == typeof n ? n(t) : void 0;
            }, r.send(null);
        }, i.prototype.read = function(t) {
            var e, n;
            for(n = [], e = 0; 0 <= t ? e < t : t < e; 0 <= t ? ++e : --e)n.push(this.data[this.pos++]);
            return n;
        }, i.prototype.readUInt32 = function() {
            return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.readUInt16 = function() {
            return this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.decodePixels = function(E) {
            var q = this.pixelBitlength / 8, O = new Uint8Array(this.width * this.height * q), B = 0, R = this;
            if (null == E && (E = this.imgData), 0 === E.length) return new Uint8Array(0);
            function t(t, e, n, r) {
                var i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A = Math.ceil((R.width - t) / n), I = Math.ceil((R.height - e) / r), C = R.width == A && R.height == I;
                for(w = q * A, g = C ? O : new Uint8Array(w * I), c = E.length, o = m = 0; m < I && B < c;){
                    switch(E[B++]){
                        case 0:
                            for(s = b = 0; b < w; s = b += 1)g[o++] = E[B++];
                            break;
                        case 1:
                            for(s = x = 0; x < w; s = x += 1)i = E[B++], h = s < q ? 0 : g[o - q], g[o++] = (i + h) % 256;
                            break;
                        case 2:
                            for(s = S = 0; S < w; s = S += 1)i = E[B++], a = (s - s % q) / q, y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (y + i) % 256;
                            break;
                        case 3:
                            for(s = k = 0; k < w; s = k += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (i + Math.floor((h + y) / 2)) % 256;
                            break;
                        case 4:
                            for(s = _ = 0; _ < w; s = _ += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], 0 === m ? y = v = 0 : (y = g[(m - 1) * w + a * q + s % q], v = a && g[(m - 1) * w + (a - 1) * q + s % q]), l = h + y - v, u = Math.abs(l - h), d = Math.abs(l - y), p = Math.abs(l - v), f = u <= d && u <= p ? h : d <= p ? y : v, g[o++] = (i + f) % 256;
                            break;
                        default:
                            throw new Error("Invalid filter algorithm: " + E[B - 1]);
                    }
                    if (!C) {
                        var T = ((e + m * r) * R.width + t) * q, F = m * w;
                        for(s = 0; s < A; s += 1){
                            for(var P = 0; P < q; P += 1)O[T++] = g[F++];
                            T += (n - 1) * q;
                        }
                    }
                    m++;
                }
            }
            return E = (E = new kt(E)).getBytes(), 1 == R.interlaceMethod ? (t(0, 0, 8, 8), t(4, 0, 8, 8), t(0, 4, 4, 8), t(2, 0, 4, 4), t(0, 2, 2, 4), t(1, 0, 2, 2), t(0, 1, 1, 2)) : t(0, 0, 1, 1), O;
        }, i.prototype.decodePalette = function() {
            var t, e, n, r, i, o, a, s, h;
            for(n = this.palette, o = this.transparency.indexed || [], i = new Uint8Array((o.length || 0) + n.length), r = 0, n.length, e = a = t = 0, s = n.length; a < s; e = a += 3)i[r++] = n[e], i[r++] = n[e + 1], i[r++] = n[e + 2], i[r++] = null != (h = o[t++]) ? h : 255;
            return i;
        }, i.prototype.copyToImageData = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f;
            if (r = this.colors, l = null, n = this.hasAlphaChannel, this.palette.length && (l = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), r = 4, n = !0), c = (i = t.data || t).length, a = l || e, o = s = 0, 1 === r) for(; o < c;)h = l ? 4 * e[o / 4] : s, u = a[h++], i[o++] = u, i[o++] = u, i[o++] = u, i[o++] = n ? a[h++] : 255, s = h;
            else for(; o < c;)h = l ? 4 * e[o / 4] : s, i[o++] = a[h++], i[o++] = a[h++], i[o++] = a[h++], i[o++] = n ? a[h++] : 255, s = h;
        }, i.prototype.decode = function() {
            var t;
            return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
        };
        try {
            n = pt.document.createElement("canvas"), r = n.getContext("2d");
        } catch (t) {
            return -1;
        }
        return c = function(t) {
            var e;
            return r.width = t.width, r.height = t.height, r.clearRect(0, 0, t.width, t.height), r.putImageData(t, 0, 0), (e = new Image).src = n.toDataURL(), e;
        }, i.prototype.decodeFrames = function(t) {
            var e, n, r, i, o, a, s, h;
            if (this.animation) {
                for(h = [], n = o = 0, a = (s = this.animation.frames).length; o < a; n = ++o)e = s[n], r = t.createImageData(e.width, e.height), i = this.decodePixels(new Uint8Array(e.data)), this.copyToImageData(r, i), e.imageData = r, h.push(e.image = c(r));
                return h;
            }
        }, i.prototype.renderFrame = function(t, e) {
            var n, r, i;
            return n = (r = this.animation.frames)[e], i = r[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === n.blendOp && t.clearRect(n.xOffset, n.yOffset, n.width, n.height), t.drawImage(n.image, n.xOffset, n.yOffset);
        }, i.prototype.animate = function(n) {
            var r, i, o, a, s, t, h = this;
            return i = 0, t = this.animation, a = t.numFrames, o = t.frames, s = t.numPlays, (r = function() {
                var t, e;
                if (t = i++ % a, e = o[t], h.renderFrame(n, t), 1 < a && i / a < s) return h.animation._timeout = setTimeout(r, e.delay);
            })();
        }, i.prototype.stopAnimation = function() {
            var t;
            return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
        }, i.prototype.render = function(t) {
            var e, n;
            return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (n = e.createImageData(this.width, this.height), this.copyToImageData(n, this.decodePixels()), e.putImageData(n, 0, 0));
        }, i;
    }(), pt.PNG = gt;
    /*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */ var St = function() {
        function t() {
            this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = null;
        }
        return t.prototype = {
            ensureBuffer: function(t) {
                var e = this.buffer, n = e ? e.byteLength : 0;
                if (t < n) return e;
                for(var r = 512; r < t;)r <<= 1;
                for(var i = new Uint8Array(r), o = 0; o < n; ++o)i[o] = e[o];
                return this.buffer = i;
            },
            getByte: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return this.buffer[this.pos++];
            },
            getBytes: function(t) {
                var e = this.pos;
                if (t) {
                    this.ensureBuffer(e + t);
                    for(var n = e + t; !this.eof && this.bufferLength < n;)this.readBlock();
                    var r = this.bufferLength;
                    r < n && (n = r);
                } else {
                    for(; !this.eof;)this.readBlock();
                    n = this.bufferLength;
                }
                return this.pos = n, this.buffer.subarray(e, n);
            },
            lookChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos]);
            },
            getChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos++]);
            },
            makeSubStream: function(t, e, n) {
                for(var r = t + e; this.bufferLength <= r && !this.eof;)this.readBlock();
                return new Stream(this.buffer, t, e, n);
            },
            skip: function(t) {
                t || (t = 1), this.pos += t;
            },
            reset: function() {
                this.pos = 0;
            }
        }, t;
    }(), kt = function() {
        if ("undefined" != typeof Uint32Array) {
            var F = new Uint32Array([
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ]), P = new Uint32Array([
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                65547,
                65549,
                65551,
                65553,
                131091,
                131095,
                131099,
                131103,
                196643,
                196651,
                196659,
                196667,
                262211,
                262227,
                262243,
                262259,
                327811,
                327843,
                327875,
                327907,
                258,
                258,
                258
            ]), E = new Uint32Array([
                1,
                2,
                3,
                4,
                65541,
                65543,
                131081,
                131085,
                196625,
                196633,
                262177,
                262193,
                327745,
                327777,
                393345,
                393409,
                459009,
                459137,
                524801,
                525057,
                590849,
                591361,
                657409,
                658433,
                724993,
                727041,
                794625,
                798721,
                868353,
                876545
            ]), q = [
                new Uint32Array([
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590016,
                    459016,
                    524384,
                    524320,
                    589984,
                    524288,
                    524416,
                    524352,
                    590048,
                    459012,
                    524376,
                    524312,
                    589968,
                    459028,
                    524408,
                    524344,
                    590032,
                    459020,
                    524392,
                    524328,
                    59e4,
                    524296,
                    524424,
                    524360,
                    590064,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590024,
                    459018,
                    524388,
                    524324,
                    589992,
                    524292,
                    524420,
                    524356,
                    590056,
                    459014,
                    524380,
                    524316,
                    589976,
                    459030,
                    524412,
                    524348,
                    590040,
                    459022,
                    524396,
                    524332,
                    590008,
                    524300,
                    524428,
                    524364,
                    590072,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590020,
                    459017,
                    524386,
                    524322,
                    589988,
                    524290,
                    524418,
                    524354,
                    590052,
                    459013,
                    524378,
                    524314,
                    589972,
                    459029,
                    524410,
                    524346,
                    590036,
                    459021,
                    524394,
                    524330,
                    590004,
                    524298,
                    524426,
                    524362,
                    590068,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590028,
                    459019,
                    524390,
                    524326,
                    589996,
                    524294,
                    524422,
                    524358,
                    590060,
                    459015,
                    524382,
                    524318,
                    589980,
                    459031,
                    524414,
                    524350,
                    590044,
                    459023,
                    524398,
                    524334,
                    590012,
                    524302,
                    524430,
                    524366,
                    590076,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590018,
                    459016,
                    524385,
                    524321,
                    589986,
                    524289,
                    524417,
                    524353,
                    590050,
                    459012,
                    524377,
                    524313,
                    589970,
                    459028,
                    524409,
                    524345,
                    590034,
                    459020,
                    524393,
                    524329,
                    590002,
                    524297,
                    524425,
                    524361,
                    590066,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590026,
                    459018,
                    524389,
                    524325,
                    589994,
                    524293,
                    524421,
                    524357,
                    590058,
                    459014,
                    524381,
                    524317,
                    589978,
                    459030,
                    524413,
                    524349,
                    590042,
                    459022,
                    524397,
                    524333,
                    590010,
                    524301,
                    524429,
                    524365,
                    590074,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590022,
                    459017,
                    524387,
                    524323,
                    589990,
                    524291,
                    524419,
                    524355,
                    590054,
                    459013,
                    524379,
                    524315,
                    589974,
                    459029,
                    524411,
                    524347,
                    590038,
                    459021,
                    524395,
                    524331,
                    590006,
                    524299,
                    524427,
                    524363,
                    590070,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590030,
                    459019,
                    524391,
                    524327,
                    589998,
                    524295,
                    524423,
                    524359,
                    590062,
                    459015,
                    524383,
                    524319,
                    589982,
                    459031,
                    524415,
                    524351,
                    590046,
                    459023,
                    524399,
                    524335,
                    590014,
                    524303,
                    524431,
                    524367,
                    590078,
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590017,
                    459016,
                    524384,
                    524320,
                    589985,
                    524288,
                    524416,
                    524352,
                    590049,
                    459012,
                    524376,
                    524312,
                    589969,
                    459028,
                    524408,
                    524344,
                    590033,
                    459020,
                    524392,
                    524328,
                    590001,
                    524296,
                    524424,
                    524360,
                    590065,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590025,
                    459018,
                    524388,
                    524324,
                    589993,
                    524292,
                    524420,
                    524356,
                    590057,
                    459014,
                    524380,
                    524316,
                    589977,
                    459030,
                    524412,
                    524348,
                    590041,
                    459022,
                    524396,
                    524332,
                    590009,
                    524300,
                    524428,
                    524364,
                    590073,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590021,
                    459017,
                    524386,
                    524322,
                    589989,
                    524290,
                    524418,
                    524354,
                    590053,
                    459013,
                    524378,
                    524314,
                    589973,
                    459029,
                    524410,
                    524346,
                    590037,
                    459021,
                    524394,
                    524330,
                    590005,
                    524298,
                    524426,
                    524362,
                    590069,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590029,
                    459019,
                    524390,
                    524326,
                    589997,
                    524294,
                    524422,
                    524358,
                    590061,
                    459015,
                    524382,
                    524318,
                    589981,
                    459031,
                    524414,
                    524350,
                    590045,
                    459023,
                    524398,
                    524334,
                    590013,
                    524302,
                    524430,
                    524366,
                    590077,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590019,
                    459016,
                    524385,
                    524321,
                    589987,
                    524289,
                    524417,
                    524353,
                    590051,
                    459012,
                    524377,
                    524313,
                    589971,
                    459028,
                    524409,
                    524345,
                    590035,
                    459020,
                    524393,
                    524329,
                    590003,
                    524297,
                    524425,
                    524361,
                    590067,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590027,
                    459018,
                    524389,
                    524325,
                    589995,
                    524293,
                    524421,
                    524357,
                    590059,
                    459014,
                    524381,
                    524317,
                    589979,
                    459030,
                    524413,
                    524349,
                    590043,
                    459022,
                    524397,
                    524333,
                    590011,
                    524301,
                    524429,
                    524365,
                    590075,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590023,
                    459017,
                    524387,
                    524323,
                    589991,
                    524291,
                    524419,
                    524355,
                    590055,
                    459013,
                    524379,
                    524315,
                    589975,
                    459029,
                    524411,
                    524347,
                    590039,
                    459021,
                    524395,
                    524331,
                    590007,
                    524299,
                    524427,
                    524363,
                    590071,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590031,
                    459019,
                    524391,
                    524327,
                    589999,
                    524295,
                    524423,
                    524359,
                    590063,
                    459015,
                    524383,
                    524319,
                    589983,
                    459031,
                    524415,
                    524351,
                    590047,
                    459023,
                    524399,
                    524335,
                    590015,
                    524303,
                    524431,
                    524367,
                    590079
                ]),
                9
            ], O = [
                new Uint32Array([
                    327680,
                    327696,
                    327688,
                    327704,
                    327684,
                    327700,
                    327692,
                    327708,
                    327682,
                    327698,
                    327690,
                    327706,
                    327686,
                    327702,
                    327694,
                    0,
                    327681,
                    327697,
                    327689,
                    327705,
                    327685,
                    327701,
                    327693,
                    327709,
                    327683,
                    327699,
                    327691,
                    327707,
                    327687,
                    327703,
                    327695,
                    0
                ]),
                5
            ];
            return (t.prototype = Object.create(St.prototype)).getBits = function(t) {
                for(var e, n = this.codeSize, r = this.codeBuf, i = this.bytes, o = this.bytesPos; n < t;)void 0 === (e = i[o++]) && B("Bad encoding in flate stream"), r |= e << n, n += 8;
                return e = r & (1 << t) - 1, this.codeBuf = r >> t, this.codeSize = n -= t, this.bytesPos = o, e;
            }, t.prototype.getCode = function(t) {
                for(var e = t[0], n = t[1], r = this.codeSize, i = this.codeBuf, o = this.bytes, a = this.bytesPos; r < n;){
                    var s;
                    void 0 === (s = o[a++]) && B("Bad encoding in flate stream"), i |= s << r, r += 8;
                }
                var h = e[i & (1 << n) - 1], c = h >> 16, l = 65535 & h;
                return (0 == r || r < c || 0 == c) && B("Bad encoding in flate stream"), this.codeBuf = i >> c, this.codeSize = r - c, this.bytesPos = a, l;
            }, t.prototype.generateHuffmanTable = function(t) {
                for(var e = t.length, n = 0, r = 0; r < e; ++r)t[r] > n && (n = t[r]);
                for(var i = 1 << n, o = new Uint32Array(i), a = 1, s = 0, h = 2; a <= n; ++a, s <<= 1, h <<= 1)for(var c = 0; c < e; ++c)if (t[c] == a) {
                    var l = 0, u = s;
                    for(r = 0; r < a; ++r)l = l << 1 | 1 & u, u >>= 1;
                    for(r = l; r < i; r += h)o[r] = a << 16 | c;
                    ++s;
                }
                return [
                    o,
                    n
                ];
            }, t.prototype.readBlock = function() {
                function t(t, e, n, r, i) {
                    for(var o = t.getBits(n) + r; 0 < o--;)e[h++] = i;
                }
                var e = this.getBits(3);
                if (1 & e && (this.eof = !0), 0 != (e >>= 1)) {
                    var n, r;
                    if (1 == e) n = q, r = O;
                    else if (2 == e) {
                        for(var i = this.getBits(5) + 257, o = this.getBits(5) + 1, a = this.getBits(4) + 4, s = Array(F.length), h = 0; h < a;)s[F[h++]] = this.getBits(3);
                        for(var c = this.generateHuffmanTable(s), l = 0, u = (h = 0, i + o), f = new Array(u); h < u;){
                            var d = this.getCode(c);
                            16 == d ? t(this, f, 2, 3, l) : 17 == d ? t(this, f, 3, 3, l = 0) : 18 == d ? t(this, f, 7, 11, l = 0) : f[h++] = l = d;
                        }
                        n = this.generateHuffmanTable(f.slice(0, i)), r = this.generateHuffmanTable(f.slice(i, u));
                    } else B("Unknown block type in flate stream");
                    for(var p = (I = this.buffer) ? I.length : 0, g = this.bufferLength;;){
                        var m = this.getCode(n);
                        if (m < 256) p <= g + 1 && (p = (I = this.ensureBuffer(g + 1)).length), I[g++] = m;
                        else {
                            if (256 == m) return void (this.bufferLength = g);
                            var w = (m = P[m -= 257]) >> 16;
                            0 < w && (w = this.getBits(w));
                            l = (65535 & m) + w;
                            m = this.getCode(r), 0 < (w = (m = E[m]) >> 16) && (w = this.getBits(w));
                            var y = (65535 & m) + w;
                            p <= g + l && (p = (I = this.ensureBuffer(g + l)).length);
                            for(var v = 0; v < l; ++v, ++g)I[g] = I[g - y];
                        }
                    }
                } else {
                    var b, x = this.bytes, S = this.bytesPos;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var k = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), k |= b << 8, void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var _ = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), (_ |= b << 8) != (65535 & ~k) && B("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                    var A = this.bufferLength, I = this.ensureBuffer(A + k), C = A + k;
                    this.bufferLength = C;
                    for(var T = A; T < C; ++T){
                        if (void 0 === (b = x[S++])) {
                            this.eof = !0;
                            break;
                        }
                        I[T] = b;
                    }
                    this.bytesPos = S;
                }
            }, t;
        }
        function B(t) {
            throw new Error(t);
        }
        function t(t) {
            var e = 0, n = t[e++], r = t[e++];
            -1 != n && -1 != r || B("Invalid header in flate stream"), 8 != (15 & n) && B("Unknown compression method in flate stream"), ((n << 8) + r) % 31 != 0 && B("Bad FCHECK in flate stream"), 32 & r && B("FDICT bit set in flate stream"), this.bytes = t, this.bytesPos = 2, this.codeSize = 0, this.codeBuf = 0, St.call(this);
        }
    }();
    return function(t) {
        if ("object" != typeof t.console) {
            t.console = {};
            for(var e, n, r = t.console, i = function() {}, o = [
                "memory"
            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = o.pop();)r[e] || (r[e] = {});
            for(; n = a.pop();)r[n] || (r[n] = i);
        }
        var s, h, c, l, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        void 0 === t.btoa && (t.btoa = function(t) {
            var e, n, r, i, o, a = 0, s = 0, h = "", c = [];
            if (!t) return t;
            for(; e = (o = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, c[s++] = u.charAt(e) + u.charAt(n) + u.charAt(r) + u.charAt(i), a < t.length;);
            h = c.join("");
            var l = t.length % 3;
            return (l ? h.slice(0, l - 3) : h) + "===".slice(l || 3);
        }), void 0 === t.atob && (t.atob = function(t) {
            var e, n, r, i, o, a, s = 0, h = 0, c = [];
            if (!t) return t;
            for(t += ""; e = (a = u.indexOf(t.charAt(s++)) << 18 | u.indexOf(t.charAt(s++)) << 12 | (i = u.indexOf(t.charAt(s++))) << 6 | (o = u.indexOf(t.charAt(s++)))) >> 16 & 255, n = a >> 8 & 255, r = 255 & a, c[h++] = 64 == i ? String.fromCharCode(e) : 64 == o ? String.fromCharCode(e, n) : String.fromCharCode(e, n, r), s < t.length;);
            return c.join("");
        }), Array.prototype.map || (Array.prototype.map = function(t) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var e = Object(this), n = e.length >>> 0, r = new Array(n), i = 1 < arguments.length ? arguments[1] : void 0, o = 0; o < n; o++)o in e && (r[o] = t.call(i, e[o], o, e));
            return r;
        }), Array.isArray || (Array.isArray = function(t) {
            return "[object Array]" === Object.prototype.toString.call(t);
        }), Array.prototype.forEach || (Array.prototype.forEach = function(t, e) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var n = Object(this), r = n.length >>> 0, i = 0; i < r; i++)i in n && t.call(e, n[i], i, n);
        }), Object.keys || (Object.keys = (s = Object.prototype.hasOwnProperty, h = !({
            toString: null
        }).propertyIsEnumerable("toString"), l = (c = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ]).length, function(t) {
            if ("object" != typeof t && ("function" != typeof t || null === t)) throw new TypeError;
            var e, n, r = [];
            for(e in t)s.call(t, e) && r.push(e);
            if (h) for(n = 0; n < l; n++)s.call(t, c[n]) && r.push(c[n]);
            return r;
        })), "function" != typeof Object.assign && (Object.assign = function(t) {
            if (null == t) throw new TypeError("Cannot convert undefined or null to object");
            t = Object(t);
            for(var e = 1; e < arguments.length; e++){
                var n = arguments[e];
                if (null != n) for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
            return t;
        }), String.prototype.trim || (String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, "");
        }), String.prototype.trimLeft || (String.prototype.trimLeft = function() {
            return this.replace(/^\s+/g, "");
        }), String.prototype.trimRight || (String.prototype.trimRight = function() {
            return this.replace(/\s+$/g, "");
        });
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), $;
});

});

parcelRegister("7JB23", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRegister("9pBV1", function(module, exports) {
module.exports = new URL("insufficient-label.93155434.png", import.meta.url).toString();

});

parcelRegister("7YoCF", function(module, exports) {
module.exports = new URL("silver-cup.4f87917e.png", import.meta.url).toString();

});

parcelRegister("gr5qi", function(module, exports) {
module.exports = new URL("gold-cup.ee6731c7.png", import.meta.url).toString();

});

parcelRegister("cXyX2", function(module, exports) {
module.exports = new URL("bronze-cup.805916db.png", import.meta.url).toString();

});

parcelRegister("hiMCQ", function(module, exports) {
module.exports = new URL("bonus.2bda0f76.svg", import.meta.url).toString();

});

parcelRegister("lbArK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5zbQZ").then(()=>parcelRequire('i8Fxz'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("l3dTC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("14NDh").then(()=>parcelRequire('5vLkJ'));

});

parcelRegister("sBxfj", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $055fbb5a82eb5281$export$307591e98609eddd, (v) => $055fbb5a82eb5281$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $055fbb5a82eb5281$export$eb3a06aef9e6ee51, (v) => $055fbb5a82eb5281$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $055fbb5a82eb5281$export$b23711c915539651, (v) => $055fbb5a82eb5281$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $055fbb5a82eb5281$export$80e7718417253a51, (v) => $055fbb5a82eb5281$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $055fbb5a82eb5281$export$83d89fbfd8236492, (v) => $055fbb5a82eb5281$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $055fbb5a82eb5281$export$307591e98609eddd;
var $055fbb5a82eb5281$export$eb3a06aef9e6ee51;
var $055fbb5a82eb5281$export$b23711c915539651;
var $055fbb5a82eb5281$export$80e7718417253a51;
var $055fbb5a82eb5281$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");
function $055fbb5a82eb5281$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $055fbb5a82eb5281$var$p = Object.prototype.hasOwnProperty, $055fbb5a82eb5281$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $055fbb5a82eb5281$var$ha = {}, $055fbb5a82eb5281$var$ia = {};
function $055fbb5a82eb5281$var$ja(a) {
    if ($055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$ia, a)) return !0;
    if ($055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$ha, a)) return !1;
    if ($055fbb5a82eb5281$var$fa.test(a)) return $055fbb5a82eb5281$var$ia[a] = !0;
    $055fbb5a82eb5281$var$ha[a] = !0;
    return !1;
}
function $055fbb5a82eb5281$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $055fbb5a82eb5281$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $055fbb5a82eb5281$var$ka = /[\-:]([a-z])/g;
function $055fbb5a82eb5281$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$055fbb5a82eb5281$var$t.xlinkHref = new $055fbb5a82eb5281$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $055fbb5a82eb5281$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $055fbb5a82eb5281$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($055fbb5a82eb5281$var$u).forEach(function(a) {
    $055fbb5a82eb5281$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $055fbb5a82eb5281$var$u[b] = $055fbb5a82eb5281$var$u[a];
    });
});
var $055fbb5a82eb5281$var$na = /["'&<>]/;
function $055fbb5a82eb5281$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $055fbb5a82eb5281$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $055fbb5a82eb5281$var$oa = /([A-Z])/g, $055fbb5a82eb5281$var$pa = /^ms-/, $055fbb5a82eb5281$var$qa = Array.isArray;
function $055fbb5a82eb5281$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $055fbb5a82eb5281$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $055fbb5a82eb5281$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $055fbb5a82eb5281$var$w(2, null);
        case "math":
            return $055fbb5a82eb5281$var$w(3, null);
        case "foreignObject":
            return $055fbb5a82eb5281$var$w(1, null);
        case "table":
            return $055fbb5a82eb5281$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $055fbb5a82eb5281$var$w(5, null);
        case "colgroup":
            return $055fbb5a82eb5281$var$w(7, null);
        case "tr":
            return $055fbb5a82eb5281$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $055fbb5a82eb5281$var$w(1, null) : a;
}
var $055fbb5a82eb5281$var$sa = new Map;
function $055fbb5a82eb5281$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($055fbb5a82eb5281$var$l(62));
    b = !0;
    for(var d in c)if ($055fbb5a82eb5281$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $055fbb5a82eb5281$var$v(d);
                f = $055fbb5a82eb5281$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $055fbb5a82eb5281$var$sa.get(e);
                void 0 !== g ? e = g : (g = $055fbb5a82eb5281$var$v(e.replace($055fbb5a82eb5281$var$oa, "-$1").toLowerCase().replace($055fbb5a82eb5281$var$pa, "-ms-")), $055fbb5a82eb5281$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$u, d) ? "" + f : f + "px" : $055fbb5a82eb5281$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $055fbb5a82eb5281$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $055fbb5a82eb5281$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $055fbb5a82eb5281$var$t.hasOwnProperty(c) ? $055fbb5a82eb5281$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
            }
        } else if ($055fbb5a82eb5281$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
        }
    }
}
function $055fbb5a82eb5281$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($055fbb5a82eb5281$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($055fbb5a82eb5281$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $055fbb5a82eb5281$var$ua(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $055fbb5a82eb5281$var$va(a, b, c, d) {
    a.push($055fbb5a82eb5281$var$A(c));
    var f = c = null, e;
    for(e in b)if ($055fbb5a82eb5281$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $055fbb5a82eb5281$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $055fbb5a82eb5281$var$y(a, f, c);
    return "string" === typeof c ? (a.push($055fbb5a82eb5281$var$v(c)), null) : c;
}
var $055fbb5a82eb5281$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $055fbb5a82eb5281$var$xa = new Map;
function $055fbb5a82eb5281$var$A(a) {
    var b = $055fbb5a82eb5281$var$xa.get(a);
    if (void 0 === b) {
        if (!$055fbb5a82eb5281$var$wa.test(a)) throw Error($055fbb5a82eb5281$var$l(65, a));
        b = "<" + a;
        $055fbb5a82eb5281$var$xa.set(a, b);
    }
    return b;
}
function $055fbb5a82eb5281$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($055fbb5a82eb5281$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($055fbb5a82eb5281$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $055fbb5a82eb5281$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $055fbb5a82eb5281$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($055fbb5a82eb5281$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($055fbb5a82eb5281$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $055fbb5a82eb5281$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $055fbb5a82eb5281$var$ua(h), $055fbb5a82eb5281$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $055fbb5a82eb5281$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($055fbb5a82eb5281$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($055fbb5a82eb5281$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(91));
                default:
                    $055fbb5a82eb5281$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($055fbb5a82eb5281$var$l(92));
                if ($055fbb5a82eb5281$var$qa(n) && 1 < n.length) throw Error($055fbb5a82eb5281$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($055fbb5a82eb5281$var$v("" + e));
            return null;
        case "input":
            a.push($055fbb5a82eb5281$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($055fbb5a82eb5281$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $055fbb5a82eb5281$var$x(a, d, g, m);
            }
            null !== n ? $055fbb5a82eb5281$var$x(a, d, "checked", n) : null !== k && $055fbb5a82eb5281$var$x(a, d, "checked", k);
            null !== e ? $055fbb5a82eb5281$var$x(a, d, "value", e) : null !== h && $055fbb5a82eb5281$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($055fbb5a82eb5281$var$A("menuitem"));
            for(var C in c)if ($055fbb5a82eb5281$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(400));
                default:
                    $055fbb5a82eb5281$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($055fbb5a82eb5281$var$A("title"));
            e = null;
            for(q in c)if ($055fbb5a82eb5281$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(434));
                default:
                    $055fbb5a82eb5281$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($055fbb5a82eb5281$var$A(b));
            g = e = null;
            for(k in c)if ($055fbb5a82eb5281$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $055fbb5a82eb5281$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($055fbb5a82eb5281$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($055fbb5a82eb5281$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($055fbb5a82eb5281$var$A(b));
            for(var D in c)if ($055fbb5a82eb5281$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(399, b));
                default:
                    $055fbb5a82eb5281$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $055fbb5a82eb5281$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $055fbb5a82eb5281$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $055fbb5a82eb5281$var$va(a, c, b, d);
            a.push($055fbb5a82eb5281$var$A(b));
            g = e = null;
            for(m in c)if ($055fbb5a82eb5281$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $055fbb5a82eb5281$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $055fbb5a82eb5281$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $055fbb5a82eb5281$var$v(h), '"');
            }
            a.push(">");
            $055fbb5a82eb5281$var$y(a, g, e);
            return e;
    }
}
function $055fbb5a82eb5281$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($055fbb5a82eb5281$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $055fbb5a82eb5281$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($055fbb5a82eb5281$var$l(397));
    }
}
function $055fbb5a82eb5281$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($055fbb5a82eb5281$var$l(397));
    }
}
var $055fbb5a82eb5281$var$Ca = /[<\u2028\u2029]/g;
function $055fbb5a82eb5281$var$Da(a) {
    return JSON.stringify(a).replace($055fbb5a82eb5281$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $055fbb5a82eb5281$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $055fbb5a82eb5281$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($055fbb5a82eb5281$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($055fbb5a82eb5281$var$v(b)), a = !0);
    return a;
}
var $055fbb5a82eb5281$var$B = Object.assign, $055fbb5a82eb5281$var$Ga = Symbol.for("react.element"), $055fbb5a82eb5281$var$Ha = Symbol.for("react.portal"), $055fbb5a82eb5281$var$Ia = Symbol.for("react.fragment"), $055fbb5a82eb5281$var$Ja = Symbol.for("react.strict_mode"), $055fbb5a82eb5281$var$Ka = Symbol.for("react.profiler"), $055fbb5a82eb5281$var$La = Symbol.for("react.provider"), $055fbb5a82eb5281$var$Ma = Symbol.for("react.context"), $055fbb5a82eb5281$var$Na = Symbol.for("react.forward_ref"), $055fbb5a82eb5281$var$Oa = Symbol.for("react.suspense"), $055fbb5a82eb5281$var$Pa = Symbol.for("react.suspense_list"), $055fbb5a82eb5281$var$Qa = Symbol.for("react.memo"), $055fbb5a82eb5281$var$Ra = Symbol.for("react.lazy"), $055fbb5a82eb5281$var$Sa = Symbol.for("react.scope"), $055fbb5a82eb5281$var$Ta = Symbol.for("react.debug_trace_mode"), $055fbb5a82eb5281$var$Ua = Symbol.for("react.legacy_hidden"), $055fbb5a82eb5281$var$Va = Symbol.for("react.default_value"), $055fbb5a82eb5281$var$Wa = Symbol.iterator;
function $055fbb5a82eb5281$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $055fbb5a82eb5281$var$Ia:
            return "Fragment";
        case $055fbb5a82eb5281$var$Ha:
            return "Portal";
        case $055fbb5a82eb5281$var$Ka:
            return "Profiler";
        case $055fbb5a82eb5281$var$Ja:
            return "StrictMode";
        case $055fbb5a82eb5281$var$Oa:
            return "Suspense";
        case $055fbb5a82eb5281$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $055fbb5a82eb5281$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $055fbb5a82eb5281$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $055fbb5a82eb5281$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $055fbb5a82eb5281$var$Qa:
            return b = a.displayName || null, null !== b ? b : $055fbb5a82eb5281$var$Xa(a.type) || "Memo";
        case $055fbb5a82eb5281$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $055fbb5a82eb5281$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $055fbb5a82eb5281$var$Ya = {};
function $055fbb5a82eb5281$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $055fbb5a82eb5281$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $055fbb5a82eb5281$var$E = null;
function $055fbb5a82eb5281$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($055fbb5a82eb5281$var$l(401));
        } else {
            if (null === c) throw Error($055fbb5a82eb5281$var$l(401));
            $055fbb5a82eb5281$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $055fbb5a82eb5281$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $055fbb5a82eb5281$var$$a(a);
}
function $055fbb5a82eb5281$var$ab(a) {
    var b = a.parent;
    null !== b && $055fbb5a82eb5281$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $055fbb5a82eb5281$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($055fbb5a82eb5281$var$l(402));
    a.depth === b.depth ? $055fbb5a82eb5281$var$F(a, b) : $055fbb5a82eb5281$var$bb(a, b);
}
function $055fbb5a82eb5281$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($055fbb5a82eb5281$var$l(402));
    a.depth === c.depth ? $055fbb5a82eb5281$var$F(a, c) : $055fbb5a82eb5281$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $055fbb5a82eb5281$var$G(a) {
    var b = $055fbb5a82eb5281$var$E;
    b !== a && (null === b ? $055fbb5a82eb5281$var$ab(a) : null === a ? $055fbb5a82eb5281$var$$a(b) : b.depth === a.depth ? $055fbb5a82eb5281$var$F(b, a) : b.depth > a.depth ? $055fbb5a82eb5281$var$bb(b, a) : $055fbb5a82eb5281$var$cb(b, a), $055fbb5a82eb5281$var$E = a);
}
var $055fbb5a82eb5281$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $055fbb5a82eb5281$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $055fbb5a82eb5281$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $055fbb5a82eb5281$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $055fbb5a82eb5281$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $055fbb5a82eb5281$var$B({}, e, h)) : $055fbb5a82eb5281$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $055fbb5a82eb5281$var$fb = {
    id: 1,
    overflow: ""
};
function $055fbb5a82eb5281$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $055fbb5a82eb5281$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $055fbb5a82eb5281$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $055fbb5a82eb5281$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $055fbb5a82eb5281$var$H = Math.clz32 ? Math.clz32 : $055fbb5a82eb5281$var$hb, $055fbb5a82eb5281$var$ib = Math.log, $055fbb5a82eb5281$var$jb = Math.LN2;
function $055fbb5a82eb5281$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($055fbb5a82eb5281$var$ib(a) / $055fbb5a82eb5281$var$jb | 0) | 0;
}
function $055fbb5a82eb5281$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $055fbb5a82eb5281$var$lb = "function" === typeof Object.is ? Object.is : $055fbb5a82eb5281$var$kb, $055fbb5a82eb5281$var$I = null, $055fbb5a82eb5281$var$ob = null, $055fbb5a82eb5281$var$J = null, $055fbb5a82eb5281$var$K = null, $055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$O = null, $055fbb5a82eb5281$var$P = 0;
function $055fbb5a82eb5281$var$Q() {
    if (null === $055fbb5a82eb5281$var$I) throw Error($055fbb5a82eb5281$var$l(321));
    return $055fbb5a82eb5281$var$I;
}
function $055fbb5a82eb5281$var$pb() {
    if (0 < $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $055fbb5a82eb5281$var$qb() {
    null === $055fbb5a82eb5281$var$K ? null === $055fbb5a82eb5281$var$J ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$J = $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$pb()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$J) : null === $055fbb5a82eb5281$var$K.next ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next = $055fbb5a82eb5281$var$pb()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next);
    return $055fbb5a82eb5281$var$K;
}
function $055fbb5a82eb5281$var$rb() {
    $055fbb5a82eb5281$var$ob = $055fbb5a82eb5281$var$I = null;
    $055fbb5a82eb5281$var$M = !1;
    $055fbb5a82eb5281$var$J = null;
    $055fbb5a82eb5281$var$P = 0;
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$O = null;
}
function $055fbb5a82eb5281$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $055fbb5a82eb5281$var$tb(a, b, c) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
    if ($055fbb5a82eb5281$var$L) {
        var d = $055fbb5a82eb5281$var$K.queue;
        b = d.dispatch;
        if (null !== $055fbb5a82eb5281$var$O && (c = $055fbb5a82eb5281$var$O.get(d), void 0 !== c)) {
            $055fbb5a82eb5281$var$O.delete(d);
            d = $055fbb5a82eb5281$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $055fbb5a82eb5281$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $055fbb5a82eb5281$var$K.memoizedState,
            b
        ];
    }
    a = a === $055fbb5a82eb5281$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $055fbb5a82eb5281$var$K.memoizedState = a;
    a = $055fbb5a82eb5281$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $055fbb5a82eb5281$var$ub.bind(null, $055fbb5a82eb5281$var$I, a);
    return [
        $055fbb5a82eb5281$var$K.memoizedState,
        a
    ];
}
function $055fbb5a82eb5281$var$vb(a, b) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $055fbb5a82eb5281$var$K) {
        var c = $055fbb5a82eb5281$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$055fbb5a82eb5281$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $055fbb5a82eb5281$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $055fbb5a82eb5281$var$ub(a, b, c) {
    if (25 <= $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$l(301));
    if (a === $055fbb5a82eb5281$var$I) {
        if ($055fbb5a82eb5281$var$M = !0, a = {
            action: c,
            next: null
        }, null === $055fbb5a82eb5281$var$O && ($055fbb5a82eb5281$var$O = new Map), c = $055fbb5a82eb5281$var$O.get(b), void 0 === c) $055fbb5a82eb5281$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $055fbb5a82eb5281$var$wb() {
    throw Error($055fbb5a82eb5281$var$l(394));
}
function $055fbb5a82eb5281$var$R() {}
var $055fbb5a82eb5281$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a._currentValue2;
    },
    useMemo: $055fbb5a82eb5281$var$vb,
    useReducer: $055fbb5a82eb5281$var$tb,
    useRef: function(a) {
        $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
        $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
        var b = $055fbb5a82eb5281$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $055fbb5a82eb5281$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $055fbb5a82eb5281$var$tb($055fbb5a82eb5281$var$sb, a);
    },
    useInsertionEffect: $055fbb5a82eb5281$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $055fbb5a82eb5281$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $055fbb5a82eb5281$var$R,
    useEffect: $055fbb5a82eb5281$var$R,
    useDebugValue: $055fbb5a82eb5281$var$R,
    useDeferredValue: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a;
    },
    useTransition: function() {
        $055fbb5a82eb5281$var$Q();
        return [
            !1,
            $055fbb5a82eb5281$var$wb
        ];
    },
    useId: function() {
        var a = $055fbb5a82eb5281$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $055fbb5a82eb5281$var$H(a) - 1)).toString(32) + b;
        var c = $055fbb5a82eb5281$var$S;
        if (null === c) throw Error($055fbb5a82eb5281$var$l(404));
        b = $055fbb5a82eb5281$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $055fbb5a82eb5281$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($055fbb5a82eb5281$var$l(407));
        return c();
    }
}, $055fbb5a82eb5281$var$S = null, $055fbb5a82eb5281$var$yb = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $055fbb5a82eb5281$var$zb(a) {
    console.error(a);
    return null;
}
function $055fbb5a82eb5281$var$T() {}
function $055fbb5a82eb5281$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $055fbb5a82eb5281$var$zb : f,
        onAllReady: void 0 === e ? $055fbb5a82eb5281$var$T : e,
        onShellReady: void 0 === g ? $055fbb5a82eb5281$var$T : g,
        onShellError: void 0 === h ? $055fbb5a82eb5281$var$T : h,
        onFatalError: void 0 === k ? $055fbb5a82eb5281$var$T : k
    };
    c = $055fbb5a82eb5281$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $055fbb5a82eb5281$var$Bb(b, a, null, c, n, $055fbb5a82eb5281$var$Ya, null, $055fbb5a82eb5281$var$fb);
    m.push(a);
    return b;
}
function $055fbb5a82eb5281$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $055fbb5a82eb5281$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $055fbb5a82eb5281$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $055fbb5a82eb5281$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $055fbb5a82eb5281$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $055fbb5a82eb5281$var$Db(a, b, c, d, f) {
    $055fbb5a82eb5281$var$I = {};
    $055fbb5a82eb5281$var$ob = b;
    $055fbb5a82eb5281$var$N = 0;
    for(a = c(d, f); $055fbb5a82eb5281$var$M;)$055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$P += 1, $055fbb5a82eb5281$var$K = null, a = c(d, f);
    $055fbb5a82eb5281$var$rb();
    return a;
}
function $055fbb5a82eb5281$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($055fbb5a82eb5281$var$l(108, $055fbb5a82eb5281$var$Xa(d) || "Unknown", h));
            d = $055fbb5a82eb5281$var$B({}, g, c);
        }
        b.legacyContext = d;
        $055fbb5a82eb5281$var$X(a, b, f);
        b.legacyContext = g;
    } else $055fbb5a82eb5281$var$X(a, b, f);
}
function $055fbb5a82eb5281$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $055fbb5a82eb5281$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $055fbb5a82eb5281$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $055fbb5a82eb5281$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $055fbb5a82eb5281$var$eb(e, c, d, f);
            $055fbb5a82eb5281$var$Eb(a, b, e, c);
        } else {
            e = $055fbb5a82eb5281$var$Za(c, b.legacyContext);
            f = $055fbb5a82eb5281$var$Db(a, b, c, d, e);
            var g = 0 !== $055fbb5a82eb5281$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $055fbb5a82eb5281$var$eb(f, c, d, e), $055fbb5a82eb5281$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $055fbb5a82eb5281$var$gb(d, 1, 0);
                try {
                    $055fbb5a82eb5281$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $055fbb5a82eb5281$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $055fbb5a82eb5281$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $055fbb5a82eb5281$var$ra(g, c, d);
        $055fbb5a82eb5281$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $055fbb5a82eb5281$var$Ua:
            case $055fbb5a82eb5281$var$Ta:
            case $055fbb5a82eb5281$var$Ja:
            case $055fbb5a82eb5281$var$Ka:
            case $055fbb5a82eb5281$var$Ia:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Pa:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Sa:
                throw Error($055fbb5a82eb5281$var$l(343));
            case $055fbb5a82eb5281$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $055fbb5a82eb5281$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $055fbb5a82eb5281$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($055fbb5a82eb5281$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $055fbb5a82eb5281$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $055fbb5a82eb5281$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $055fbb5a82eb5281$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Na:
                d = $055fbb5a82eb5281$var$Db(a, b, c.render, d, f);
                if (0 !== $055fbb5a82eb5281$var$N) {
                    c = b.treeContext;
                    b.treeContext = $055fbb5a82eb5281$var$gb(c, 1, 0);
                    try {
                        $055fbb5a82eb5281$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$Qa:
                c = c.type;
                d = $055fbb5a82eb5281$var$Fb(c, d);
                $055fbb5a82eb5281$var$Gb(a, b, c, d, f);
                return;
            case $055fbb5a82eb5281$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $055fbb5a82eb5281$var$E;
                $055fbb5a82eb5281$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $055fbb5a82eb5281$var$X(a, b, f);
                a = $055fbb5a82eb5281$var$E;
                if (null === a) throw Error($055fbb5a82eb5281$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $055fbb5a82eb5281$var$Va ? a.context._defaultValue : d;
                a = $055fbb5a82eb5281$var$E = a.parent;
                b.context = a;
                return;
            case $055fbb5a82eb5281$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $055fbb5a82eb5281$var$Fb(c, d);
                $055fbb5a82eb5281$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($055fbb5a82eb5281$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $055fbb5a82eb5281$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Ga:
                $055fbb5a82eb5281$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $055fbb5a82eb5281$var$Ha:
                throw Error($055fbb5a82eb5281$var$l(257));
            case $055fbb5a82eb5281$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $055fbb5a82eb5281$var$X(a, b, c);
                return;
        }
        if ($055fbb5a82eb5281$var$qa(c)) {
            $055fbb5a82eb5281$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $055fbb5a82eb5281$var$Wa && c[$055fbb5a82eb5281$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $055fbb5a82eb5281$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($055fbb5a82eb5281$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $055fbb5a82eb5281$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $055fbb5a82eb5281$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $055fbb5a82eb5281$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $055fbb5a82eb5281$var$gb(e, d, f);
        try {
            $055fbb5a82eb5281$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $055fbb5a82eb5281$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $055fbb5a82eb5281$var$X(a, b, c);
    } catch (k) {
        if ($055fbb5a82eb5281$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $055fbb5a82eb5281$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $055fbb5a82eb5281$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $055fbb5a82eb5281$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $055fbb5a82eb5281$var$G(e), k;
    }
}
function $055fbb5a82eb5281$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $055fbb5a82eb5281$var$Kb(this, b, a);
}
function $055fbb5a82eb5281$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($055fbb5a82eb5281$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $055fbb5a82eb5281$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $055fbb5a82eb5281$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $055fbb5a82eb5281$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $055fbb5a82eb5281$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($055fbb5a82eb5281$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $055fbb5a82eb5281$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $055fbb5a82eb5281$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($055fbb5a82eb5281$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($055fbb5a82eb5281$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $055fbb5a82eb5281$var$Cb(a) {
    if (2 !== a.status) {
        var b = $055fbb5a82eb5281$var$E, c = $055fbb5a82eb5281$var$yb.current;
        $055fbb5a82eb5281$var$yb.current = $055fbb5a82eb5281$var$xb;
        var d = $055fbb5a82eb5281$var$S;
        $055fbb5a82eb5281$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $055fbb5a82eb5281$var$G(g.context);
                    try {
                        $055fbb5a82eb5281$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $055fbb5a82eb5281$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($055fbb5a82eb5281$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $055fbb5a82eb5281$var$V(h, q);
                            null === n ? $055fbb5a82eb5281$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $055fbb5a82eb5281$var$Mb(a, a.destination);
        } catch (z) {
            $055fbb5a82eb5281$var$V(a, z), $055fbb5a82eb5281$var$W(a, z);
        } finally{
            $055fbb5a82eb5281$var$S = d, $055fbb5a82eb5281$var$yb.current = c, c === $055fbb5a82eb5281$var$xb && $055fbb5a82eb5281$var$G(b);
        }
    }
}
function $055fbb5a82eb5281$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $055fbb5a82eb5281$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($055fbb5a82eb5281$var$l(390));
    }
}
function $055fbb5a82eb5281$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $055fbb5a82eb5281$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $055fbb5a82eb5281$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $055fbb5a82eb5281$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $055fbb5a82eb5281$var$za(b, a.responseState, d);
        $055fbb5a82eb5281$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $055fbb5a82eb5281$var$za(b, a.responseState, d.id), $055fbb5a82eb5281$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($055fbb5a82eb5281$var$l(391));
    $055fbb5a82eb5281$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $055fbb5a82eb5281$var$Ob(a, b, c) {
    $055fbb5a82eb5281$var$Aa(b, a.responseState, c.formatContext, c.id);
    $055fbb5a82eb5281$var$Nb(a, b, c);
    return $055fbb5a82eb5281$var$Ba(b, c.formatContext);
}
function $055fbb5a82eb5281$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$055fbb5a82eb5281$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($055fbb5a82eb5281$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $055fbb5a82eb5281$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($055fbb5a82eb5281$var$l(392));
        return $055fbb5a82eb5281$var$Ob(a, b, d);
    }
    $055fbb5a82eb5281$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $055fbb5a82eb5281$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $055fbb5a82eb5281$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($055fbb5a82eb5281$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $055fbb5a82eb5281$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $055fbb5a82eb5281$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $055fbb5a82eb5281$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$055fbb5a82eb5281$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$055fbb5a82eb5281$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$055fbb5a82eb5281$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $055fbb5a82eb5281$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $055fbb5a82eb5281$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $055fbb5a82eb5281$var$Mb(a, a.destination);
    } catch (d) {
        $055fbb5a82eb5281$var$V(a, d), $055fbb5a82eb5281$var$W(a, d);
    }
}
function $055fbb5a82eb5281$var$Sb() {}
function $055fbb5a82eb5281$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $055fbb5a82eb5281$var$Ab(a, $055fbb5a82eb5281$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $055fbb5a82eb5281$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $055fbb5a82eb5281$var$Cb(a);
    $055fbb5a82eb5281$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $055fbb5a82eb5281$var$Mb(a, h);
        } catch (m) {
            $055fbb5a82eb5281$var$V(a, m), $055fbb5a82eb5281$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($055fbb5a82eb5281$var$l(426));
    return g;
}
$055fbb5a82eb5281$export$307591e98609eddd = function() {
    throw Error($055fbb5a82eb5281$var$l(207));
};
$055fbb5a82eb5281$export$eb3a06aef9e6ee51 = function(a, b) {
    return $055fbb5a82eb5281$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$055fbb5a82eb5281$export$b23711c915539651 = function() {
    throw Error($055fbb5a82eb5281$var$l(208));
};
$055fbb5a82eb5281$export$80e7718417253a51 = function(a, b) {
    return $055fbb5a82eb5281$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$055fbb5a82eb5281$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("3odmW", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $277dfbc9b64034b1$export$7020a3240b287705, (v) => $277dfbc9b64034b1$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $277dfbc9b64034b1$export$83d89fbfd8236492, (v) => $277dfbc9b64034b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $277dfbc9b64034b1$export$7020a3240b287705;
var $277dfbc9b64034b1$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");
function $277dfbc9b64034b1$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0;
function $277dfbc9b64034b1$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0), a.enqueue(b);
        else {
            var c = $277dfbc9b64034b1$var$l.length - $277dfbc9b64034b1$var$n;
            c < b.length && (0 === c ? a.enqueue($277dfbc9b64034b1$var$l) : ($277dfbc9b64034b1$var$l.set(b.subarray(0, c), $277dfbc9b64034b1$var$n), a.enqueue($277dfbc9b64034b1$var$l), b = b.subarray(c)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0);
            $277dfbc9b64034b1$var$l.set(b, $277dfbc9b64034b1$var$n);
            $277dfbc9b64034b1$var$n += b.length;
        }
    }
}
function $277dfbc9b64034b1$var$t(a, b) {
    $277dfbc9b64034b1$var$p(a, b);
    return !0;
}
function $277dfbc9b64034b1$var$ba(a) {
    $277dfbc9b64034b1$var$l && 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0);
}
var $277dfbc9b64034b1$var$ca = new TextEncoder;
function $277dfbc9b64034b1$var$u(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$w(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $277dfbc9b64034b1$var$x = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $277dfbc9b64034b1$var$fa = {}, $277dfbc9b64034b1$var$ha = {};
function $277dfbc9b64034b1$var$ia(a) {
    if ($277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$ha, a)) return !0;
    if ($277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$fa, a)) return !1;
    if ($277dfbc9b64034b1$var$ea.test(a)) return $277dfbc9b64034b1$var$ha[a] = !0;
    $277dfbc9b64034b1$var$fa[a] = !0;
    return !1;
}
function $277dfbc9b64034b1$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $277dfbc9b64034b1$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $277dfbc9b64034b1$var$ja = /[\-:]([a-z])/g;
function $277dfbc9b64034b1$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$277dfbc9b64034b1$var$z.xlinkHref = new $277dfbc9b64034b1$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $277dfbc9b64034b1$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $277dfbc9b64034b1$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($277dfbc9b64034b1$var$B).forEach(function(a) {
    $277dfbc9b64034b1$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $277dfbc9b64034b1$var$B[b] = $277dfbc9b64034b1$var$B[a];
    });
});
var $277dfbc9b64034b1$var$oa = /["'&<>]/;
function $277dfbc9b64034b1$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $277dfbc9b64034b1$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $277dfbc9b64034b1$var$pa = /([A-Z])/g, $277dfbc9b64034b1$var$qa = /^ms-/, $277dfbc9b64034b1$var$ra = Array.isArray, $277dfbc9b64034b1$var$sa = $277dfbc9b64034b1$var$w("<script>"), $277dfbc9b64034b1$var$ta = $277dfbc9b64034b1$var$w("\x3c/script>"), $277dfbc9b64034b1$var$ua = $277dfbc9b64034b1$var$w('<script src="'), $277dfbc9b64034b1$var$va = $277dfbc9b64034b1$var$w('<script type="module" src="'), $277dfbc9b64034b1$var$wa = $277dfbc9b64034b1$var$w('" async="">\x3c/script>'), $277dfbc9b64034b1$var$xa = /(<\/|<)(s)(cript)/gi;
function $277dfbc9b64034b1$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $277dfbc9b64034b1$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $277dfbc9b64034b1$var$sa : $277dfbc9b64034b1$var$w('<script nonce="' + $277dfbc9b64034b1$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $277dfbc9b64034b1$var$u(("" + c).replace($277dfbc9b64034b1$var$xa, $277dfbc9b64034b1$var$ya)), $277dfbc9b64034b1$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($277dfbc9b64034b1$var$ua, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d[c])), $277dfbc9b64034b1$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($277dfbc9b64034b1$var$va, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(f[d])), $277dfbc9b64034b1$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $277dfbc9b64034b1$var$w(a + "P:"),
        segmentPrefix: $277dfbc9b64034b1$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $277dfbc9b64034b1$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $277dfbc9b64034b1$var$Aa(a) {
    return $277dfbc9b64034b1$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $277dfbc9b64034b1$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $277dfbc9b64034b1$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $277dfbc9b64034b1$var$D(2, null);
        case "math":
            return $277dfbc9b64034b1$var$D(3, null);
        case "foreignObject":
            return $277dfbc9b64034b1$var$D(1, null);
        case "table":
            return $277dfbc9b64034b1$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $277dfbc9b64034b1$var$D(5, null);
        case "colgroup":
            return $277dfbc9b64034b1$var$D(7, null);
        case "tr":
            return $277dfbc9b64034b1$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $277dfbc9b64034b1$var$D(1, null) : a;
}
var $277dfbc9b64034b1$var$Ca = $277dfbc9b64034b1$var$w("\x3c!-- --\x3e");
function $277dfbc9b64034b1$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($277dfbc9b64034b1$var$Ca);
    a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(b)));
    return !0;
}
var $277dfbc9b64034b1$var$Ea = new Map, $277dfbc9b64034b1$var$Fa = $277dfbc9b64034b1$var$w(' style="'), $277dfbc9b64034b1$var$Ga = $277dfbc9b64034b1$var$w(":"), $277dfbc9b64034b1$var$Ha = $277dfbc9b64034b1$var$w(";");
function $277dfbc9b64034b1$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($277dfbc9b64034b1$var$k(62));
    b = !0;
    for(var d in c)if ($277dfbc9b64034b1$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d));
                f = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $277dfbc9b64034b1$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $277dfbc9b64034b1$var$w($277dfbc9b64034b1$var$C(e.replace($277dfbc9b64034b1$var$pa, "-$1").toLowerCase().replace($277dfbc9b64034b1$var$qa, "-ms-"))), $277dfbc9b64034b1$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$B, d) ? $277dfbc9b64034b1$var$u("" + f) : $277dfbc9b64034b1$var$u(f + "px") : $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($277dfbc9b64034b1$var$Fa, e, $277dfbc9b64034b1$var$Ga, f)) : a.push($277dfbc9b64034b1$var$Ha, e, $277dfbc9b64034b1$var$Ga, f);
        }
    }
    b || a.push($277dfbc9b64034b1$var$E);
}
var $277dfbc9b64034b1$var$H = $277dfbc9b64034b1$var$w(" "), $277dfbc9b64034b1$var$I = $277dfbc9b64034b1$var$w('="'), $277dfbc9b64034b1$var$E = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$Ja = $277dfbc9b64034b1$var$w('=""');
function $277dfbc9b64034b1$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $277dfbc9b64034b1$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $277dfbc9b64034b1$var$z.hasOwnProperty(c) ? $277dfbc9b64034b1$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $277dfbc9b64034b1$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$Ja) : !1 !== d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
            }
        } else if ($277dfbc9b64034b1$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
        }
    }
}
var $277dfbc9b64034b1$var$K = $277dfbc9b64034b1$var$w(">"), $277dfbc9b64034b1$var$Ka = $277dfbc9b64034b1$var$w("/>");
function $277dfbc9b64034b1$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($277dfbc9b64034b1$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($277dfbc9b64034b1$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($277dfbc9b64034b1$var$u("" + b));
    }
}
function $277dfbc9b64034b1$var$La(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $277dfbc9b64034b1$var$Ma = $277dfbc9b64034b1$var$w(' selected=""');
function $277dfbc9b64034b1$var$Na(a, b, c, d) {
    a.push($277dfbc9b64034b1$var$M(c));
    var f = c = null, e;
    for(e in b)if ($277dfbc9b64034b1$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $277dfbc9b64034b1$var$J(a, d, e, g);
        }
    }
    a.push($277dfbc9b64034b1$var$K);
    $277dfbc9b64034b1$var$L(a, f, c);
    return "string" === typeof c ? (a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(c))), null) : c;
}
var $277dfbc9b64034b1$var$Oa = $277dfbc9b64034b1$var$w("\n"), $277dfbc9b64034b1$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $277dfbc9b64034b1$var$Qa = new Map;
function $277dfbc9b64034b1$var$M(a) {
    var b = $277dfbc9b64034b1$var$Qa.get(a);
    if (void 0 === b) {
        if (!$277dfbc9b64034b1$var$Pa.test(a)) throw Error($277dfbc9b64034b1$var$k(65, a));
        b = $277dfbc9b64034b1$var$w("<" + a);
        $277dfbc9b64034b1$var$Qa.set(a, b);
    }
    return b;
}
var $277dfbc9b64034b1$var$Ra = $277dfbc9b64034b1$var$w("<!DOCTYPE html>");
function $277dfbc9b64034b1$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($277dfbc9b64034b1$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($277dfbc9b64034b1$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $277dfbc9b64034b1$var$J(a, d, r, h);
                }
            }
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($277dfbc9b64034b1$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($277dfbc9b64034b1$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $277dfbc9b64034b1$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $277dfbc9b64034b1$var$La(h), $277dfbc9b64034b1$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($277dfbc9b64034b1$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($277dfbc9b64034b1$var$Ma);
            } else q && a.push($277dfbc9b64034b1$var$Ma);
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($277dfbc9b64034b1$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($277dfbc9b64034b1$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(91));
                default:
                    $277dfbc9b64034b1$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($277dfbc9b64034b1$var$K);
            if (null != r) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(92));
                if ($277dfbc9b64034b1$var$ra(r) && 1 < r.length) throw Error($277dfbc9b64034b1$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$Oa);
            null !== e && a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C("" + e)));
            return null;
        case "input":
            a.push($277dfbc9b64034b1$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($277dfbc9b64034b1$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $277dfbc9b64034b1$var$J(a, d, g, q);
            }
            null !== r ? $277dfbc9b64034b1$var$J(a, d, "checked", r) : null !== m && $277dfbc9b64034b1$var$J(a, d, "checked", m);
            null !== e ? $277dfbc9b64034b1$var$J(a, d, "value", e) : null !== h && $277dfbc9b64034b1$var$J(a, d, "value", h);
            a.push($277dfbc9b64034b1$var$Ka);
            return null;
        case "menuitem":
            a.push($277dfbc9b64034b1$var$M("menuitem"));
            for(var A in c)if ($277dfbc9b64034b1$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(400));
                default:
                    $277dfbc9b64034b1$var$J(a, d, A, e);
            }
            a.push($277dfbc9b64034b1$var$K);
            return null;
        case "title":
            a.push($277dfbc9b64034b1$var$M("title"));
            e = null;
            for(v in c)if ($277dfbc9b64034b1$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(434));
                default:
                    $277dfbc9b64034b1$var$J(a, d, v, g);
            }
            a.push($277dfbc9b64034b1$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($277dfbc9b64034b1$var$M(b));
            g = e = null;
            for(m in c)if ($277dfbc9b64034b1$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $277dfbc9b64034b1$var$J(a, d, m, h);
            }
            a.push($277dfbc9b64034b1$var$K);
            if (null != g) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($277dfbc9b64034b1$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($277dfbc9b64034b1$var$Oa, $277dfbc9b64034b1$var$u(c)) : a.push($277dfbc9b64034b1$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($277dfbc9b64034b1$var$M(b));
            for(var F in c)if ($277dfbc9b64034b1$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, b));
                default:
                    $277dfbc9b64034b1$var$J(a, d, F, e);
            }
            a.push($277dfbc9b64034b1$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $277dfbc9b64034b1$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($277dfbc9b64034b1$var$Ra), $277dfbc9b64034b1$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $277dfbc9b64034b1$var$Na(a, c, b, d);
            a.push($277dfbc9b64034b1$var$M(b));
            g = e = null;
            for(q in c)if ($277dfbc9b64034b1$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $277dfbc9b64034b1$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $277dfbc9b64034b1$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u(q), $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(h)), $277dfbc9b64034b1$var$E);
            }
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, g, e);
            return e;
    }
}
var $277dfbc9b64034b1$var$Ta = $277dfbc9b64034b1$var$w("</"), $277dfbc9b64034b1$var$Ua = $277dfbc9b64034b1$var$w(">"), $277dfbc9b64034b1$var$Va = $277dfbc9b64034b1$var$w('<template id="'), $277dfbc9b64034b1$var$Wa = $277dfbc9b64034b1$var$w('"></template>'), $277dfbc9b64034b1$var$Xa = $277dfbc9b64034b1$var$w("\x3c!--$--\x3e"), $277dfbc9b64034b1$var$Ya = $277dfbc9b64034b1$var$w('\x3c!--$?--\x3e<template id="'), $277dfbc9b64034b1$var$Za = $277dfbc9b64034b1$var$w('"></template>'), $277dfbc9b64034b1$var$$a = $277dfbc9b64034b1$var$w("\x3c!--$!--\x3e"), $277dfbc9b64034b1$var$ab = $277dfbc9b64034b1$var$w("\x3c!--/$--\x3e"), $277dfbc9b64034b1$var$bb = $277dfbc9b64034b1$var$w("<template"), $277dfbc9b64034b1$var$cb = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$db = $277dfbc9b64034b1$var$w(' data-dgst="');
$277dfbc9b64034b1$var$w(' data-msg="');
$277dfbc9b64034b1$var$w(' data-stck="');
var $277dfbc9b64034b1$var$eb = $277dfbc9b64034b1$var$w("></template>");
function $277dfbc9b64034b1$var$fb(a, b, c) {
    $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$Ya);
    if (null === c) throw Error($277dfbc9b64034b1$var$k(395));
    $277dfbc9b64034b1$var$p(a, c);
    return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$Za);
}
var $277dfbc9b64034b1$var$gb = $277dfbc9b64034b1$var$w('<div hidden id="'), $277dfbc9b64034b1$var$hb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ib = $277dfbc9b64034b1$var$w("</div>"), $277dfbc9b64034b1$var$jb = $277dfbc9b64034b1$var$w('<svg aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$kb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$lb = $277dfbc9b64034b1$var$w("</svg>"), $277dfbc9b64034b1$var$mb = $277dfbc9b64034b1$var$w('<math aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$nb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ob = $277dfbc9b64034b1$var$w("</math>"), $277dfbc9b64034b1$var$pb = $277dfbc9b64034b1$var$w('<table hidden id="'), $277dfbc9b64034b1$var$qb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$rb = $277dfbc9b64034b1$var$w("</table>"), $277dfbc9b64034b1$var$sb = $277dfbc9b64034b1$var$w('<table hidden><tbody id="'), $277dfbc9b64034b1$var$tb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ub = $277dfbc9b64034b1$var$w("</tbody></table>"), $277dfbc9b64034b1$var$vb = $277dfbc9b64034b1$var$w('<table hidden><tr id="'), $277dfbc9b64034b1$var$wb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$xb = $277dfbc9b64034b1$var$w("</tr></table>"), $277dfbc9b64034b1$var$yb = $277dfbc9b64034b1$var$w('<table hidden><colgroup id="'), $277dfbc9b64034b1$var$zb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$Ab = $277dfbc9b64034b1$var$w("</colgroup></table>");
function $277dfbc9b64034b1$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$gb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$hb);
        case 2:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$jb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$kb);
        case 3:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$mb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$nb);
        case 4:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$pb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$qb);
        case 5:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$sb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$tb);
        case 6:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$vb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$wb);
        case 7:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$yb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$zb);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
function $277dfbc9b64034b1$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ib);
        case 2:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$lb);
        case 3:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ob);
        case 4:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$rb);
        case 5:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ub);
        case 6:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$xb);
        case 7:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$Ab);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
var $277dfbc9b64034b1$var$Db = $277dfbc9b64034b1$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $277dfbc9b64034b1$var$Eb = $277dfbc9b64034b1$var$w('$RS("'), $277dfbc9b64034b1$var$Gb = $277dfbc9b64034b1$var$w('","'), $277dfbc9b64034b1$var$Hb = $277dfbc9b64034b1$var$w('")\x3c/script>'), $277dfbc9b64034b1$var$Ib = $277dfbc9b64034b1$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $277dfbc9b64034b1$var$Jb = $277dfbc9b64034b1$var$w('$RC("'), $277dfbc9b64034b1$var$Kb = $277dfbc9b64034b1$var$w('","'), $277dfbc9b64034b1$var$Lb = $277dfbc9b64034b1$var$w('")\x3c/script>'), $277dfbc9b64034b1$var$Mb = $277dfbc9b64034b1$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $277dfbc9b64034b1$var$Nb = $277dfbc9b64034b1$var$w('$RX("'), $277dfbc9b64034b1$var$Ob = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$Pb = $277dfbc9b64034b1$var$w(")\x3c/script>"), $277dfbc9b64034b1$var$Qb = $277dfbc9b64034b1$var$w(","), $277dfbc9b64034b1$var$Rb = /[<\u2028\u2029]/g;
function $277dfbc9b64034b1$var$Sb(a) {
    return JSON.stringify(a).replace($277dfbc9b64034b1$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $277dfbc9b64034b1$var$N = Object.assign, $277dfbc9b64034b1$var$Tb = Symbol.for("react.element"), $277dfbc9b64034b1$var$Ub = Symbol.for("react.portal"), $277dfbc9b64034b1$var$Vb = Symbol.for("react.fragment"), $277dfbc9b64034b1$var$Wb = Symbol.for("react.strict_mode"), $277dfbc9b64034b1$var$Xb = Symbol.for("react.profiler"), $277dfbc9b64034b1$var$Yb = Symbol.for("react.provider"), $277dfbc9b64034b1$var$Zb = Symbol.for("react.context"), $277dfbc9b64034b1$var$$b = Symbol.for("react.forward_ref"), $277dfbc9b64034b1$var$ac = Symbol.for("react.suspense"), $277dfbc9b64034b1$var$bc = Symbol.for("react.suspense_list"), $277dfbc9b64034b1$var$cc = Symbol.for("react.memo"), $277dfbc9b64034b1$var$dc = Symbol.for("react.lazy"), $277dfbc9b64034b1$var$ec = Symbol.for("react.scope"), $277dfbc9b64034b1$var$fc = Symbol.for("react.debug_trace_mode"), $277dfbc9b64034b1$var$gc = Symbol.for("react.legacy_hidden"), $277dfbc9b64034b1$var$hc = Symbol.for("react.default_value"), $277dfbc9b64034b1$var$ic = Symbol.iterator;
function $277dfbc9b64034b1$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $277dfbc9b64034b1$var$Vb:
            return "Fragment";
        case $277dfbc9b64034b1$var$Ub:
            return "Portal";
        case $277dfbc9b64034b1$var$Xb:
            return "Profiler";
        case $277dfbc9b64034b1$var$Wb:
            return "StrictMode";
        case $277dfbc9b64034b1$var$ac:
            return "Suspense";
        case $277dfbc9b64034b1$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $277dfbc9b64034b1$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $277dfbc9b64034b1$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $277dfbc9b64034b1$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $277dfbc9b64034b1$var$cc:
            return b = a.displayName || null, null !== b ? b : $277dfbc9b64034b1$var$jc(a.type) || "Memo";
        case $277dfbc9b64034b1$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $277dfbc9b64034b1$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $277dfbc9b64034b1$var$kc = {};
function $277dfbc9b64034b1$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $277dfbc9b64034b1$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $277dfbc9b64034b1$var$O = null;
function $277dfbc9b64034b1$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($277dfbc9b64034b1$var$k(401));
        } else {
            if (null === c) throw Error($277dfbc9b64034b1$var$k(401));
            $277dfbc9b64034b1$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $277dfbc9b64034b1$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $277dfbc9b64034b1$var$mc(a);
}
function $277dfbc9b64034b1$var$nc(a) {
    var b = a.parent;
    null !== b && $277dfbc9b64034b1$var$nc(b);
    a.context._currentValue = a.value;
}
function $277dfbc9b64034b1$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === b.depth ? $277dfbc9b64034b1$var$P(a, b) : $277dfbc9b64034b1$var$oc(a, b);
}
function $277dfbc9b64034b1$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === c.depth ? $277dfbc9b64034b1$var$P(a, c) : $277dfbc9b64034b1$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $277dfbc9b64034b1$var$Q(a) {
    var b = $277dfbc9b64034b1$var$O;
    b !== a && (null === b ? $277dfbc9b64034b1$var$nc(a) : null === a ? $277dfbc9b64034b1$var$mc(b) : b.depth === a.depth ? $277dfbc9b64034b1$var$P(b, a) : b.depth > a.depth ? $277dfbc9b64034b1$var$oc(b, a) : $277dfbc9b64034b1$var$pc(b, a), $277dfbc9b64034b1$var$O = a);
}
var $277dfbc9b64034b1$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $277dfbc9b64034b1$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $277dfbc9b64034b1$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $277dfbc9b64034b1$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $277dfbc9b64034b1$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $277dfbc9b64034b1$var$N({}, e, h)) : $277dfbc9b64034b1$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $277dfbc9b64034b1$var$sc = {
    id: 1,
    overflow: ""
};
function $277dfbc9b64034b1$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $277dfbc9b64034b1$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $277dfbc9b64034b1$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $277dfbc9b64034b1$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $277dfbc9b64034b1$var$uc = Math.clz32 ? Math.clz32 : $277dfbc9b64034b1$var$vc, $277dfbc9b64034b1$var$wc = Math.log, $277dfbc9b64034b1$var$xc = Math.LN2;
function $277dfbc9b64034b1$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($277dfbc9b64034b1$var$wc(a) / $277dfbc9b64034b1$var$xc | 0) | 0;
}
function $277dfbc9b64034b1$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $277dfbc9b64034b1$var$zc = "function" === typeof Object.is ? Object.is : $277dfbc9b64034b1$var$yc, $277dfbc9b64034b1$var$R = null, $277dfbc9b64034b1$var$Ac = null, $277dfbc9b64034b1$var$Bc = null, $277dfbc9b64034b1$var$S = null, $277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$Cc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$V = null, $277dfbc9b64034b1$var$Dc = 0;
function $277dfbc9b64034b1$var$W() {
    if (null === $277dfbc9b64034b1$var$R) throw Error($277dfbc9b64034b1$var$k(321));
    return $277dfbc9b64034b1$var$R;
}
function $277dfbc9b64034b1$var$Ec() {
    if (0 < $277dfbc9b64034b1$var$Dc) throw Error($277dfbc9b64034b1$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $277dfbc9b64034b1$var$Fc() {
    null === $277dfbc9b64034b1$var$S ? null === $277dfbc9b64034b1$var$Bc ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$Bc = $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Ec()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Bc) : null === $277dfbc9b64034b1$var$S.next ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next = $277dfbc9b64034b1$var$Ec()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next);
    return $277dfbc9b64034b1$var$S;
}
function $277dfbc9b64034b1$var$Gc() {
    $277dfbc9b64034b1$var$Ac = $277dfbc9b64034b1$var$R = null;
    $277dfbc9b64034b1$var$Cc = !1;
    $277dfbc9b64034b1$var$Bc = null;
    $277dfbc9b64034b1$var$Dc = 0;
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$V = null;
}
function $277dfbc9b64034b1$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $277dfbc9b64034b1$var$Ic(a, b, c) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
    if ($277dfbc9b64034b1$var$T) {
        var d = $277dfbc9b64034b1$var$S.queue;
        b = d.dispatch;
        if (null !== $277dfbc9b64034b1$var$V && (c = $277dfbc9b64034b1$var$V.get(d), void 0 !== c)) {
            $277dfbc9b64034b1$var$V.delete(d);
            d = $277dfbc9b64034b1$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $277dfbc9b64034b1$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $277dfbc9b64034b1$var$S.memoizedState,
            b
        ];
    }
    a = a === $277dfbc9b64034b1$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $277dfbc9b64034b1$var$S.memoizedState = a;
    a = $277dfbc9b64034b1$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $277dfbc9b64034b1$var$Jc.bind(null, $277dfbc9b64034b1$var$R, a);
    return [
        $277dfbc9b64034b1$var$S.memoizedState,
        a
    ];
}
function $277dfbc9b64034b1$var$Kc(a, b) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $277dfbc9b64034b1$var$S) {
        var c = $277dfbc9b64034b1$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$277dfbc9b64034b1$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $277dfbc9b64034b1$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $277dfbc9b64034b1$var$Jc(a, b, c) {
    if (25 <= $277dfbc9b64034b1$var$Dc) throw Error($277dfbc9b64034b1$var$k(301));
    if (a === $277dfbc9b64034b1$var$R) {
        if ($277dfbc9b64034b1$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $277dfbc9b64034b1$var$V && ($277dfbc9b64034b1$var$V = new Map), c = $277dfbc9b64034b1$var$V.get(b), void 0 === c) $277dfbc9b64034b1$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $277dfbc9b64034b1$var$Lc() {
    throw Error($277dfbc9b64034b1$var$k(394));
}
function $277dfbc9b64034b1$var$Mc() {}
var $277dfbc9b64034b1$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $277dfbc9b64034b1$var$W();
        return a._currentValue;
    },
    useMemo: $277dfbc9b64034b1$var$Kc,
    useReducer: $277dfbc9b64034b1$var$Ic,
    useRef: function(a) {
        $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
        $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
        var b = $277dfbc9b64034b1$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $277dfbc9b64034b1$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $277dfbc9b64034b1$var$Ic($277dfbc9b64034b1$var$Hc, a);
    },
    useInsertionEffect: $277dfbc9b64034b1$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $277dfbc9b64034b1$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $277dfbc9b64034b1$var$Mc,
    useEffect: $277dfbc9b64034b1$var$Mc,
    useDebugValue: $277dfbc9b64034b1$var$Mc,
    useDeferredValue: function(a) {
        $277dfbc9b64034b1$var$W();
        return a;
    },
    useTransition: function() {
        $277dfbc9b64034b1$var$W();
        return [
            !1,
            $277dfbc9b64034b1$var$Lc
        ];
    },
    useId: function() {
        var a = $277dfbc9b64034b1$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $277dfbc9b64034b1$var$uc(a) - 1)).toString(32) + b;
        var c = $277dfbc9b64034b1$var$Nc;
        if (null === c) throw Error($277dfbc9b64034b1$var$k(404));
        b = $277dfbc9b64034b1$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $277dfbc9b64034b1$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($277dfbc9b64034b1$var$k(407));
        return c();
    }
}, $277dfbc9b64034b1$var$Nc = null, $277dfbc9b64034b1$var$Pc = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $277dfbc9b64034b1$var$Qc(a) {
    console.error(a);
    return null;
}
function $277dfbc9b64034b1$var$X() {}
function $277dfbc9b64034b1$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $277dfbc9b64034b1$var$Qc : f,
        onAllReady: void 0 === e ? $277dfbc9b64034b1$var$X : e,
        onShellReady: void 0 === g ? $277dfbc9b64034b1$var$X : g,
        onShellError: void 0 === h ? $277dfbc9b64034b1$var$X : h,
        onFatalError: void 0 === m ? $277dfbc9b64034b1$var$X : m
    };
    c = $277dfbc9b64034b1$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $277dfbc9b64034b1$var$Tc(b, a, null, c, r, $277dfbc9b64034b1$var$kc, null, $277dfbc9b64034b1$var$sc);
    q.push(a);
    return b;
}
function $277dfbc9b64034b1$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $277dfbc9b64034b1$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $277dfbc9b64034b1$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $277dfbc9b64034b1$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $277dfbc9b64034b1$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $277dfbc9b64034b1$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $277dfbc9b64034b1$var$Wc(a, b, c, d, f) {
    $277dfbc9b64034b1$var$R = {};
    $277dfbc9b64034b1$var$Ac = b;
    $277dfbc9b64034b1$var$U = 0;
    for(a = c(d, f); $277dfbc9b64034b1$var$Cc;)$277dfbc9b64034b1$var$Cc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$Dc += 1, $277dfbc9b64034b1$var$S = null, a = c(d, f);
    $277dfbc9b64034b1$var$Gc();
    return a;
}
function $277dfbc9b64034b1$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($277dfbc9b64034b1$var$k(108, $277dfbc9b64034b1$var$jc(d) || "Unknown", h));
            d = $277dfbc9b64034b1$var$N({}, g, c);
        }
        b.legacyContext = d;
        $277dfbc9b64034b1$var$Z(a, b, f);
        b.legacyContext = g;
    } else $277dfbc9b64034b1$var$Z(a, b, f);
}
function $277dfbc9b64034b1$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $277dfbc9b64034b1$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $277dfbc9b64034b1$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $277dfbc9b64034b1$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $277dfbc9b64034b1$var$rc(e, c, d, f);
            $277dfbc9b64034b1$var$Xc(a, b, e, c);
        } else {
            e = $277dfbc9b64034b1$var$lc(c, b.legacyContext);
            f = $277dfbc9b64034b1$var$Wc(a, b, c, d, e);
            var g = 0 !== $277dfbc9b64034b1$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $277dfbc9b64034b1$var$rc(f, c, d, e), $277dfbc9b64034b1$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $277dfbc9b64034b1$var$tc(d, 1, 0);
                try {
                    $277dfbc9b64034b1$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $277dfbc9b64034b1$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $277dfbc9b64034b1$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $277dfbc9b64034b1$var$Ba(g, c, d);
        $277dfbc9b64034b1$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($277dfbc9b64034b1$var$Ta, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $277dfbc9b64034b1$var$gc:
            case $277dfbc9b64034b1$var$fc:
            case $277dfbc9b64034b1$var$Wb:
            case $277dfbc9b64034b1$var$Xb:
            case $277dfbc9b64034b1$var$Vb:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$bc:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$ec:
                throw Error($277dfbc9b64034b1$var$k(343));
            case $277dfbc9b64034b1$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $277dfbc9b64034b1$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $277dfbc9b64034b1$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($277dfbc9b64034b1$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($277dfbc9b64034b1$var$Ca), q.status = 1, $277dfbc9b64034b1$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $277dfbc9b64034b1$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $277dfbc9b64034b1$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $277dfbc9b64034b1$var$$b:
                d = $277dfbc9b64034b1$var$Wc(a, b, c.render, d, f);
                if (0 !== $277dfbc9b64034b1$var$U) {
                    c = b.treeContext;
                    b.treeContext = $277dfbc9b64034b1$var$tc(c, 1, 0);
                    try {
                        $277dfbc9b64034b1$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$cc:
                c = c.type;
                d = $277dfbc9b64034b1$var$Yc(c, d);
                $277dfbc9b64034b1$var$Zc(a, b, c, d, f);
                return;
            case $277dfbc9b64034b1$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $277dfbc9b64034b1$var$O;
                $277dfbc9b64034b1$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $277dfbc9b64034b1$var$Z(a, b, f);
                a = $277dfbc9b64034b1$var$O;
                if (null === a) throw Error($277dfbc9b64034b1$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $277dfbc9b64034b1$var$hc ? a.context._defaultValue : d;
                a = $277dfbc9b64034b1$var$O = a.parent;
                b.context = a;
                return;
            case $277dfbc9b64034b1$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $277dfbc9b64034b1$var$Yc(c, d);
                $277dfbc9b64034b1$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($277dfbc9b64034b1$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $277dfbc9b64034b1$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $277dfbc9b64034b1$var$Tb:
                $277dfbc9b64034b1$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $277dfbc9b64034b1$var$Ub:
                throw Error($277dfbc9b64034b1$var$k(257));
            case $277dfbc9b64034b1$var$dc:
                var d = c._init;
                c = d(c._payload);
                $277dfbc9b64034b1$var$Z(a, b, c);
                return;
        }
        if ($277dfbc9b64034b1$var$ra(c)) {
            $277dfbc9b64034b1$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $277dfbc9b64034b1$var$ic && c[$277dfbc9b64034b1$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $277dfbc9b64034b1$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($277dfbc9b64034b1$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $277dfbc9b64034b1$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $277dfbc9b64034b1$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $277dfbc9b64034b1$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $277dfbc9b64034b1$var$tc(e, d, f);
        try {
            $277dfbc9b64034b1$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $277dfbc9b64034b1$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $277dfbc9b64034b1$var$Z(a, b, c);
    } catch (m) {
        if ($277dfbc9b64034b1$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $277dfbc9b64034b1$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $277dfbc9b64034b1$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $277dfbc9b64034b1$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $277dfbc9b64034b1$var$Q(e), m;
    }
}
function $277dfbc9b64034b1$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $277dfbc9b64034b1$var$dd(this, b, a);
}
function $277dfbc9b64034b1$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($277dfbc9b64034b1$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $277dfbc9b64034b1$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $277dfbc9b64034b1$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $277dfbc9b64034b1$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $277dfbc9b64034b1$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($277dfbc9b64034b1$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $277dfbc9b64034b1$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $277dfbc9b64034b1$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($277dfbc9b64034b1$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($277dfbc9b64034b1$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $277dfbc9b64034b1$var$Uc(a) {
    if (2 !== a.status) {
        var b = $277dfbc9b64034b1$var$O, c = $277dfbc9b64034b1$var$Pc.current;
        $277dfbc9b64034b1$var$Pc.current = $277dfbc9b64034b1$var$Oc;
        var d = $277dfbc9b64034b1$var$Nc;
        $277dfbc9b64034b1$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $277dfbc9b64034b1$var$Q(g.context);
                    try {
                        $277dfbc9b64034b1$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($277dfbc9b64034b1$var$Ca), g.abortSet.delete(g), m.status = 1, $277dfbc9b64034b1$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($277dfbc9b64034b1$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $277dfbc9b64034b1$var$Y(h, v);
                            null === r ? $277dfbc9b64034b1$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $277dfbc9b64034b1$var$fd(a, a.destination);
        } catch (G) {
            $277dfbc9b64034b1$var$Y(a, G), $277dfbc9b64034b1$var$Vc(a, G);
        } finally{
            $277dfbc9b64034b1$var$Nc = d, $277dfbc9b64034b1$var$Pc.current = c, c === $277dfbc9b64034b1$var$Oc && $277dfbc9b64034b1$var$Q(b);
        }
    }
}
function $277dfbc9b64034b1$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Va);
            $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
            a = $277dfbc9b64034b1$var$u(d.toString(16));
            $277dfbc9b64034b1$var$p(b, a);
            return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$277dfbc9b64034b1$var$p(b, d[e]);
                f = $277dfbc9b64034b1$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$277dfbc9b64034b1$var$p(b, d[e]);
            e < d.length && (f = $277dfbc9b64034b1$var$t(b, d[e]));
            return f;
        default:
            throw Error($277dfbc9b64034b1$var$k(390));
    }
}
function $277dfbc9b64034b1$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $277dfbc9b64034b1$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$$a), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$bb), d && ($277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$db), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d))), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$cb)), $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$eb), $277dfbc9b64034b1$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $277dfbc9b64034b1$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $277dfbc9b64034b1$var$fb(b, a.responseState, d);
        $277dfbc9b64034b1$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $277dfbc9b64034b1$var$fb(b, a.responseState, d.id), $277dfbc9b64034b1$var$gd(a, b, c);
    else {
        $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($277dfbc9b64034b1$var$k(391));
        $277dfbc9b64034b1$var$hd(a, b, c[0]);
    }
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$ab);
}
function $277dfbc9b64034b1$var$id(a, b, c) {
    $277dfbc9b64034b1$var$Bb(b, a.responseState, c.formatContext, c.id);
    $277dfbc9b64034b1$var$hd(a, b, c);
    return $277dfbc9b64034b1$var$Cb(b, c.formatContext);
}
function $277dfbc9b64034b1$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$277dfbc9b64034b1$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Ib));
    if (null === d) throw Error($277dfbc9b64034b1$var$k(395));
    c = $277dfbc9b64034b1$var$u(c.toString(16));
    $277dfbc9b64034b1$var$p(b, d);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Kb);
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    $277dfbc9b64034b1$var$p(b, c);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Lb);
}
function $277dfbc9b64034b1$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($277dfbc9b64034b1$var$k(392));
        return $277dfbc9b64034b1$var$id(a, b, d);
    }
    $277dfbc9b64034b1$var$id(a, b, d);
    a = a.responseState;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Eb) : (a.sentCompleteSegmentFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Db));
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    f = $277dfbc9b64034b1$var$u(f.toString(16));
    $277dfbc9b64034b1$var$p(b, f);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Gb);
    $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
    $277dfbc9b64034b1$var$p(b, f);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Hb);
}
function $277dfbc9b64034b1$var$fd(a, b) {
    $277dfbc9b64034b1$var$l = new Uint8Array(512);
    $277dfbc9b64034b1$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $277dfbc9b64034b1$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$277dfbc9b64034b1$var$p(b, d[c]);
            c < d.length && $277dfbc9b64034b1$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $277dfbc9b64034b1$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Nb) : (h.sentClientRenderFunction = !0, $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Mb));
            if (null === m) throw Error($277dfbc9b64034b1$var$k(395));
            $277dfbc9b64034b1$var$p(d, m);
            $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Ob);
            if (q || r || v) $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(q || "")));
            if (r || v) $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(r || "")));
            v && ($277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(v))));
            if (!$277dfbc9b64034b1$var$t(d, $277dfbc9b64034b1$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$277dfbc9b64034b1$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $277dfbc9b64034b1$var$ba(b);
        $277dfbc9b64034b1$var$l = new Uint8Array(512);
        $277dfbc9b64034b1$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$277dfbc9b64034b1$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$277dfbc9b64034b1$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $277dfbc9b64034b1$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $277dfbc9b64034b1$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $277dfbc9b64034b1$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $277dfbc9b64034b1$var$fd(a, a.destination);
    } catch (d) {
        $277dfbc9b64034b1$var$Y(a, d), $277dfbc9b64034b1$var$Vc(a, d);
    }
}
$277dfbc9b64034b1$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $277dfbc9b64034b1$var$Rc(a, $277dfbc9b64034b1$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $277dfbc9b64034b1$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $277dfbc9b64034b1$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $277dfbc9b64034b1$var$fd(h, a);
                        } catch (A) {
                            $277dfbc9b64034b1$var$Y(h, A), $277dfbc9b64034b1$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $277dfbc9b64034b1$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $277dfbc9b64034b1$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $277dfbc9b64034b1$var$Uc(h);
    });
};
$277dfbc9b64034b1$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("4dikp", function(module, exports) {
module.exports = new URL("referIcon.4b24b1ad.svg", import.meta.url).toString();

});

parcelRegister("dsCVd", function(module, exports) {
module.exports = new URL("cfoCenterLogo.31b0621f.svg", import.meta.url).toString();

});

parcelRegister("eR6rP", function(module, exports) {
module.exports = new URL("telephone.1016c91c.svg", import.meta.url).toString();

});

parcelRegister("9UKFK", function(module, exports) {
module.exports = new URL("right-arrows.b15a1ce1.svg", import.meta.url).toString();

});

parcelRegister("hagGi", function(module, exports) {
module.exports = new URL("refer.c5ed4ccd.png", import.meta.url).toString();

});

parcelRegister("bkYBb", function(module, exports) {
module.exports = new URL("fraction.07bdc9b0.png", import.meta.url).toString();

});

parcelRegister("44sQT", function(module, exports) {
module.exports = new URL("refund.c71c8afc.png", import.meta.url).toString();

});

parcelRegister("dqNS6", function(module, exports) {
module.exports = new URL("referOfferRightIcon.8ce3e003.png", import.meta.url).toString();

});

parcelRegister("9FAif", function(module, exports) {
module.exports = new URL("companyReferOffer.a50c2617.png", import.meta.url).toString();

});

parcelRegister("8zFJt", function(module, exports) {
module.exports = new URL("plus.788eeee6.png", import.meta.url).toString();

});

parcelRegister("c45dO", function(module, exports) {
module.exports = new URL("DiligentsianCfologo.a7303353.png", import.meta.url).toString();

});

parcelRegister("dnTAO", function(module, exports) {
module.exports = new URL("linkedin-logo.a759e08e.svg", import.meta.url).toString();

});

parcelRegister("931hv", function(module, exports) {
module.exports = new URL("applicant-info-ai.1d5b60fe.png", import.meta.url).toString();

});

parcelRegister("1ScrU", function(module, exports) {
module.exports = new URL("pink-question.3449b3b7.svg", import.meta.url).toString();

});

parcelRegister("7hMZV", function(module, exports) {
module.exports = new URL("kpiSidebar.4433a447.png", import.meta.url).toString();

});

parcelRegister("gDTQF", function(module, exports) {
module.exports = new URL("partner-flow-ai-help.0b1a4041.png", import.meta.url).toString();

});

parcelRegister("40qsd", function(module, exports) {
module.exports = new URL("sidebar-partner-checklist-ai.b6bac159.png", import.meta.url).toString();

});

parcelRegister("4VhrM", function(module, exports) {
module.exports = new URL("investor-lead-ai.c963f746.png", import.meta.url).toString();

});

parcelRegister("2M7mC", function(module, exports) {
module.exports = new URL("sidebar-check-icon.ac68d895.png", import.meta.url).toString();

});

parcelRegister("aHhy4", function(module, exports) {
module.exports = new URL("sidebar-cross-icon.9c17ceeb.png", import.meta.url).toString();

});

parcelRegister("e7RTg", function(module, exports) {
module.exports = new URL("sidebar-file-icon.ce60a3fc.png", import.meta.url).toString();

});

parcelRegister("1avjd", function(module, exports) {
module.exports = new URL("investment-readiness-ai.4b6aea13.png", import.meta.url).toString();

});

parcelRegister("jhDfB", function(module, exports) {
module.exports = new URL("report-sidebar-ai.1d2f66c9.png", import.meta.url).toString();

});

parcelRegister("lkR4C", function(module, exports) {
module.exports = new URL("2minutesTestSidebarDiligentsia.51ab926f.png", import.meta.url).toString();

});

parcelRegister("aSPAr", function(module, exports) {
module.exports = new URL("two-minute-test-ai.c23d32cf.png", import.meta.url).toString();

});

parcelRegister("iGe5G", function(module, exports) {
module.exports = new URL("complete-icon-popup.b9882241.png", import.meta.url).toString();

});

parcelRegister("dNazT", function(module, exports) {
module.exports = new URL("complete-logo-popup.908d024a.png", import.meta.url).toString();

});

parcelRegister("blGti", function(module, exports) {
module.exports = new URL("step-1-popup.a0c1b909.png", import.meta.url).toString();

});

parcelRegister("dloz2", function(module, exports) {
module.exports = new URL("step-2-popup.43b8ccdb.png", import.meta.url).toString();

});

parcelRegister("1QZ0E", function(module, exports) {
module.exports = new URL("step-3-popup.2143d8af.png", import.meta.url).toString();

});

parcelRegister("jh3BR", function(module, exports) {
module.exports = new URL("step-4-popup.64a54c4b.png", import.meta.url).toString();

});

parcelRegister("6Ycgy", function(module, exports) {
module.exports = new URL("400-error.ffa12e3d.png", import.meta.url).toString();

});

parcelRegister("hgL6Y", function(module, exports) {
module.exports = new URL("disclaimer.a8fd4f74.png", import.meta.url).toString();

});

parcelRegister("4bpAo", function(module, exports) {
module.exports = new URL("deduper.b311fb66.png", import.meta.url).toString();

});

parcelRegister("8S7PI", function(module, exports) {
module.exports = new URL("empty-inbox.791cfede.svg", import.meta.url).toString();

});

parcelRegister("bx0Zp", function(module, exports) {
module.exports = new URL("filing-assistant-hover.683b3845.png", import.meta.url).toString();

});

parcelRegister("6zDJh", function(module, exports) {
module.exports = new URL("filing-assistant-icon.6715e5d2.png", import.meta.url).toString();

});

parcelRegister("f3vPa", function(module, exports) {
module.exports = new URL("file.34e8aa24.svg", import.meta.url).toString();

});

parcelRegister("hTZXD", function(module, exports) {
module.exports = new URL("girlAI.8ccfbb45.png", import.meta.url).toString();

});

parcelRegister("jp8rB", function(module, exports) {
module.exports = new URL("Group.85afa264.svg", import.meta.url).toString();

});

parcelRegister("8pegU", function(module, exports) {
module.exports = new URL("drive.de54fec0.svg", import.meta.url).toString();

});

parcelRegister("3Eiuc", function(module, exports) {
module.exports = new URL("dropbox.314489a8.svg", import.meta.url).toString();

});

parcelRegister("lauhO", function(module, exports) {
module.exports = new URL("sharepoint.469ee1cc.svg", import.meta.url).toString();

});

parcelRegister("6rlDG", function(module, exports) {
module.exports = new URL("right-arrows1.0b75f82a.svg", import.meta.url).toString();

});

parcelRegister("3yJPW", function(module, exports) {
module.exports = new URL("check.f8bb411b.svg", import.meta.url).toString();

});

parcelRegister("hM019", function(module, exports) {
module.exports = new URL("unallocated-bin-step-1.b968d2f5.png", import.meta.url).toString();

});

parcelRegister("4Xa6G", function(module, exports) {
module.exports = new URL("unallocated-bin-step-2.ca90a343.png", import.meta.url).toString();

});

parcelRegister("886gJ", function(module, exports) {
module.exports = new URL("unallocated-bin-step-3.898fcd22.png", import.meta.url).toString();

});

parcelRegister("4HwwL", function(module, exports) {
module.exports = new URL("filing-assistant-step-1.85fec777.png", import.meta.url).toString();

});

parcelRegister("gX8Sm", function(module, exports) {
module.exports = new URL("filing-assistant-step-2.e11ccbd3.png", import.meta.url).toString();

});

parcelRegister("e82tD", function(module, exports) {
module.exports = new URL("filing-assistant-step-3.5d37969c.png", import.meta.url).toString();

});

parcelRegister("dE8rk", function(module, exports) {
module.exports = new URL("deduper-step-1.960a52d7.png", import.meta.url).toString();

});

parcelRegister("exnR2", function(module, exports) {
module.exports = new URL("deduper-step-2.9986ffb3.png", import.meta.url).toString();

});

parcelRegister("dlLss", function(module, exports) {
module.exports = new URL("deduper-step-3.1cc3017f.png", import.meta.url).toString();

});

parcelRegister("j60gY", function(module, exports) {
module.exports = new URL("deduper-reports-step-1.ef88805d.png", import.meta.url).toString();

});

parcelRegister("75c8P", function(module, exports) {
module.exports = new URL("deduper-reports-step-2.c7dfdb82.png", import.meta.url).toString();

});

parcelRegister("lw4cX", function(module, exports) {
module.exports = new URL("deduper-reports-step-3.08f11e92.png", import.meta.url).toString();

});

parcelRegister("e9Vft", function(module, exports) {
module.exports = new URL("three-steps.67750c04.png", import.meta.url).toString();

});

parcelRegister("iBc1P", function(module, exports) {
module.exports = new URL("tip-icon.312e1873.svg", import.meta.url).toString();

});

parcelRegister("atCxS", function(module, exports) {
module.exports = new URL("tab-files-icon.14d3b008.png", import.meta.url).toString();

});

parcelRegister("5IILg", function(module, exports) {
module.exports = new URL("tab-collaborate-icon.145a2913.png", import.meta.url).toString();

});

parcelRegister("1MTnu", function(module, exports) {
module.exports = new URL("tab-toolbox-icon.b6dbb384.png", import.meta.url).toString();

});

parcelRegister("1Ar70", function(module, exports) {
module.exports = new URL("sync-data-room.fd07c429.png", import.meta.url).toString();

});

parcelRegister("gA5Zr", function(module, exports) {
module.exports = new URL("double-star-icon.b0049897.png", import.meta.url).toString();

});

parcelRegister("bwNCH", function(module, exports) {
module.exports = new URL("left.85d14654.png", import.meta.url).toString();

});

parcelRegister("l0lQ0", function(module, exports) {
module.exports = new URL("center.ebbda78c.png", import.meta.url).toString();

});

parcelRegister("4MwVZ", function(module, exports) {
module.exports = new URL("right.e16900c6.png", import.meta.url).toString();

});

parcelRegister("3N5Zr", function(module, exports) {
module.exports = new URL("logo-advisor.d4014d1a.svg", import.meta.url).toString();

});

parcelRegister("71DfO", function(module, exports) {
module.exports = new URL("banner13-opp.9479e4aa.png", import.meta.url).toString();

});

parcelRegister("aCagb", function(module, exports) {
module.exports = new URL("step-modal-img.ec2dd3d8.png", import.meta.url).toString();

});

parcelRegister("hBlAH", function(module, exports) {
module.exports = new URL("portfolio-dashboard-1.fdcc08f9.png", import.meta.url).toString();

});

parcelRegister("asUrc", function(module, exports) {
module.exports = new URL("portfolio-dashboard-2.653f6449.png", import.meta.url).toString();

});

parcelRegister("5KMDo", function(module, exports) {
module.exports = new URL("portfolio-dashboard-3.17d64cd6.png", import.meta.url).toString();

});

parcelRegister("ldnDr", function(module, exports) {
module.exports = new URL("cards.57e180e4.png", import.meta.url).toString();

});

parcelRegister("9883i", function(module, exports) {
module.exports = new URL("banner25.d118c506.png", import.meta.url).toString();

});

parcelRegister("dIwiD", function(module, exports) {
module.exports = new URL("client-benchmarking-1.afbada97.png", import.meta.url).toString();

});

parcelRegister("c2MyR", function(module, exports) {
module.exports = new URL("client-benchmarking-2.cc1dd16e.png", import.meta.url).toString();

});

parcelRegister("k52TY", function(module, exports) {
module.exports = new URL("client-benchmarking-3.1bbda157.png", import.meta.url).toString();

});

parcelRegister("kretz", function(module, exports) {
module.exports = new URL("banner12-opp.b1fedac5.png", import.meta.url).toString();

});

parcelRegister("eIjoz", function(module, exports) {
module.exports = new URL("diligentsia-pro-plus-1.005fcb64.png", import.meta.url).toString();

});

parcelRegister("hK9yq", function(module, exports) {
module.exports = new URL("diligentsia-pro-plus-2.0d46955c.png", import.meta.url).toString();

});

parcelRegister("9y1fn", function(module, exports) {
module.exports = new URL("diligentsia-pro-plus-3.40f0cb4b.png", import.meta.url).toString();

});

parcelRegister("jBY5D", function(module, exports) {
module.exports = new URL("group-certficate.62d9ac08.png", import.meta.url).toString();

});

parcelRegister("knqcS", function(module, exports) {
module.exports = new URL("banner14-opp.c5ebc64b.png", import.meta.url).toString();

});

parcelRegister("fYwBE", function(module, exports) {
module.exports = new URL("check-icon.8ce34113.png", import.meta.url).toString();

});

parcelRegister("gBgEl", function(module, exports) {
module.exports = new URL("cross-icon.869861b8.png", import.meta.url).toString();

});

parcelRegister("dQ3j7", function(module, exports) {
module.exports = new URL("revenue-generation-leads-1.689eb731.png", import.meta.url).toString();

});

parcelRegister("eE8nI", function(module, exports) {
module.exports = new URL("revenue-generation-leads-2.ac16aa91.png", import.meta.url).toString();

});

parcelRegister("cQdyd", function(module, exports) {
module.exports = new URL("revenue-generation-leads-3.63d703a5.png", import.meta.url).toString();

});

parcelRegister("lB7oR", function(module, exports) {
module.exports = new URL("banner15-opp.e780a42c.png", import.meta.url).toString();

});

parcelRegister("fw9PN", function(module, exports) {
module.exports = new URL("checklist-builder-1.d1149dce.png", import.meta.url).toString();

});

parcelRegister("6XakL", function(module, exports) {
module.exports = new URL("checklist-builder-2.8d9dfa34.png", import.meta.url).toString();

});

parcelRegister("3vuqz", function(module, exports) {
module.exports = new URL("checklist-builder-3.09fb0d4a.png", import.meta.url).toString();

});

parcelRegister("1Q7Rb", function(module, exports) {
module.exports = new URL("workflow-manager.229c449f.png", import.meta.url).toString();

});

parcelRegister("9z55S", function(module, exports) {
module.exports = new URL("workflow-manager-step-1.bdd977a7.png", import.meta.url).toString();

});

parcelRegister("ji7WB", function(module, exports) {
module.exports = new URL("workflow-manager-step-2.8df081db.png", import.meta.url).toString();

});

parcelRegister("dZZKb", function(module, exports) {
module.exports = new URL("workflow-manager-step-3.23ea3a11.png", import.meta.url).toString();

});

parcelRegister("38rPY", function(module, exports) {
module.exports = new URL("portfolio-benchmarking-1.5bd00945.png", import.meta.url).toString();

});

parcelRegister("hviOk", function(module, exports) {
module.exports = new URL("portfolio-benchmarking-2.3d6eeb6e.png", import.meta.url).toString();

});

parcelRegister("chGIW", function(module, exports) {
module.exports = new URL("portfolio-benchmarking-3.b880c20d.png", import.meta.url).toString();

});

parcelRegister("3i2EE", function(module, exports) {
module.exports = new URL("banner7-opp.0a385181.png", import.meta.url).toString();

});

parcelRegister("68Qf7", function(module, exports) {
module.exports = new URL("applicant-leads-1.c0aadbd9.png", import.meta.url).toString();

});

parcelRegister("hfO9Z", function(module, exports) {
module.exports = new URL("applicant-leads-2.7dc75e48.png", import.meta.url).toString();

});

parcelRegister("dh6HU", function(module, exports) {
module.exports = new URL("applicant-leads-3.a846351a.png", import.meta.url).toString();

});

parcelRegister("93hnj", function(module, exports) {
module.exports = new URL("banner-certification-4.1492d8a8.png", import.meta.url).toString();

});

parcelRegister("ki3OO", function(module, exports) {
module.exports = new URL("banner26.f0099834.png", import.meta.url).toString();

});

parcelRegister("3p5l2", function(module, exports) {
module.exports = new URL("qualification-widget-1.acee6bfa.png", import.meta.url).toString();

});

parcelRegister("6f887", function(module, exports) {
module.exports = new URL("qualification-widget-2.797520a6.png", import.meta.url).toString();

});

parcelRegister("jcp8L", function(module, exports) {
module.exports = new URL("qualification-widget-3.4db6db72.png", import.meta.url).toString();

});

parcelRegister("eRXe5", function(module, exports) {
module.exports = new URL("client-dashboard-step-1.b40f00c2.png", import.meta.url).toString();

});

parcelRegister("fsl7i", function(module, exports) {
module.exports = new URL("client-dashboard-step-2.adeaf266.png", import.meta.url).toString();

});

parcelRegister("4QeXl", function(module, exports) {
module.exports = new URL("client-dashboard-step-3.39ba7356.png", import.meta.url).toString();

});

parcelRegister("3Unna", function(module, exports) {
module.exports = new URL("cabinet-left.ec9c3b6f.gif", import.meta.url).toString();

});

parcelRegister("3nDtB", function(module, exports) {
module.exports = new URL("data-repo-step-1.407504ce.png", import.meta.url).toString();

});

parcelRegister("hATCZ", function(module, exports) {
module.exports = new URL("data-repo-step-2.3008562f.png", import.meta.url).toString();

});

parcelRegister("emcHc", function(module, exports) {
module.exports = new URL("data-repo-step-3.085e4083.png", import.meta.url).toString();

});

parcelRegister("izGj8", function(module, exports) {
module.exports = new URL("banner3.3ab6f9b4.png", import.meta.url).toString();

});

parcelRegister("cKOgx", function(module, exports) {
module.exports = new URL("business-step-1.b52cccc9.png", import.meta.url).toString();

});

parcelRegister("gRghN", function(module, exports) {
module.exports = new URL("business-step-2.83219b57.png", import.meta.url).toString();

});

parcelRegister("9T8ub", function(module, exports) {
module.exports = new URL("business-step-3.0b592051.png", import.meta.url).toString();

});

parcelRegister("3QBnO", function(module, exports) {
module.exports = new URL("diligentsia-certification.d97eab87.png", import.meta.url).toString();

});

parcelRegister("9WBs6", function(module, exports) {
module.exports = new URL("banner5.91b74b17.png", import.meta.url).toString();

});

parcelRegister("h5gY8", function(module, exports) {
module.exports = new URL("diligentsia-certification-step-1.761e005f.png", import.meta.url).toString();

});

parcelRegister("5i7wo", function(module, exports) {
module.exports = new URL("diligentsia-certification-step-2.5de85185.png", import.meta.url).toString();

});

parcelRegister("kplav", function(module, exports) {
module.exports = new URL("diligentsia-certification-step-3.6dbd3e9b.png", import.meta.url).toString();

});

parcelRegister("aFTOQ", function(module, exports) {
module.exports = new URL("pack-bottom.e6ec7df9.png", import.meta.url).toString();

});

parcelRegister("bnaJ5", function(module, exports) {
module.exports = new URL("banner10-opp.7df40c8d.png", import.meta.url).toString();

});

parcelRegister("6B6JN", function(module, exports) {
module.exports = new URL("warranty-step-1.b21ec2bc.png", import.meta.url).toString();

});

parcelRegister("4fFAl", function(module, exports) {
module.exports = new URL("warranty-step-2.0fb3ef32.png", import.meta.url).toString();

});

parcelRegister("ibxQi", function(module, exports) {
module.exports = new URL("warranty-step-3.1a82af6c.png", import.meta.url).toString();

});

parcelRegister("3e8So", function(module, exports) {
module.exports = new URL("banner11.3dcdf7c4.png", import.meta.url).toString();

});

parcelRegister("aqBrG", function(module, exports) {
module.exports = new URL("directors-questionnaires-step-1.4b70c580.png", import.meta.url).toString();

});

parcelRegister("f5V3m", function(module, exports) {
module.exports = new URL("directors-questionnaires-step-2.b876e207.png", import.meta.url).toString();

});

parcelRegister("bPJsR", function(module, exports) {
module.exports = new URL("directors-questionnaires-step-3.11c76d49.png", import.meta.url).toString();

});

parcelRegister("7J3ig", function(module, exports) {
module.exports = new URL("banner19-opp.7ef89939.png", import.meta.url).toString();

});

parcelRegister("9JAZQ", function(module, exports) {
module.exports = new URL("diligenstia-pack-step-1.2511015b.png", import.meta.url).toString();

});

parcelRegister("l0CSg", function(module, exports) {
module.exports = new URL("diligenstia-pack-step-2.12637438.png", import.meta.url).toString();

});

parcelRegister("ko7pf", function(module, exports) {
module.exports = new URL("diligenstia-pack-step-3.8ecc3f58.png", import.meta.url).toString();

});

parcelRegister("c1JdN", function(module, exports) {
module.exports = new URL("banner20-opp.6d2d614b.png", import.meta.url).toString();

});

parcelRegister("2tJoi", function(module, exports) {
module.exports = new URL("investor-lead-step-1.9830fad3.png", import.meta.url).toString();

});

parcelRegister("lDJNj", function(module, exports) {
module.exports = new URL("investor-lead-step-2.54d76d2b.png", import.meta.url).toString();

});

parcelRegister("21vwf", function(module, exports) {
module.exports = new URL("investor-lead-step-3.23b46b7c.png", import.meta.url).toString();

});

parcelRegister("kMt1I", function(module, exports) {
module.exports = new URL("cybersecurity.d403b161.png", import.meta.url).toString();

});

parcelRegister("dF4Ki", function(module, exports) {
module.exports = new URL("cyber-security-icon.ed830154.png", import.meta.url).toString();

});

parcelRegister("4IKT1", function(module, exports) {
module.exports = new URL("banner24-new.46ebffc0.png", import.meta.url).toString();

});

parcelRegister("a5jEe", function(module, exports) {
module.exports = new URL("cyberscurity-step-1.587f823a.png", import.meta.url).toString();

});

parcelRegister("5GyoP", function(module, exports) {
module.exports = new URL("cyberscurity-step-2.a94c487b.png", import.meta.url).toString();

});

parcelRegister("hKcfB", function(module, exports) {
module.exports = new URL("cyberscurity-step-3.662378a1.png", import.meta.url).toString();

});

parcelRegister("jalLz", function(module, exports) {
module.exports = new URL("cyberscurity-step-4.90b88794.png", import.meta.url).toString();

});

parcelRegister("388WO", function(module, exports) {
module.exports = new URL("healthboost-heading.ac2a97b7.png", import.meta.url).toString();

});

parcelRegister("8iglb", function(module, exports) {
module.exports = new URL("healthboost-1.377d2a7d.png", import.meta.url).toString();

});

parcelRegister("3pvfN", function(module, exports) {
module.exports = new URL("healthboost-2.83e4bc59.png", import.meta.url).toString();

});

parcelRegister("dqkvX", function(module, exports) {
module.exports = new URL("healthboost-3.c81e6d5c.png", import.meta.url).toString();

});

parcelRegister("9o8tm", function(module, exports) {
module.exports = new URL("healthboost-4.5c0eaaa8.png", import.meta.url).toString();

});

parcelRegister("aZ77G", function(module, exports) {
module.exports = new URL("no-img.bc8d2895.svg", import.meta.url).toString();

});

parcelRegister("9gCOW", function(module, exports) {
module.exports = new URL("hover-list-icon.6db5512e.png", import.meta.url).toString();

});

parcelRegister("dlp4j", function(module, exports) {
module.exports = new URL("gold-star-icon.ec900367.png", import.meta.url).toString();

});

parcelRegister("912EB", function(module, exports) {
module.exports = new URL("3d-credit-card1.71b24d0b.svg", import.meta.url).toString();

});

parcelRegister("i4vA9", function(module, exports) {
module.exports = new URL("partner-module.a16fdb54.png", import.meta.url).toString();

});

parcelRegister("fePM2", function(module, exports) {
module.exports = new URL("health-boost-icon.8efc701a.png", import.meta.url).toString();

});

parcelRegister("2pz0d", function(module, exports) {
module.exports = new URL("healthboost-logo.1ab4195b.png", import.meta.url).toString();

});

parcelRegister("iMeWL", function(module, exports) {
module.exports = new URL("gold-certification-dashboard.ab7e0590.png", import.meta.url).toString();

});

parcelRegister("fOQ2M", function(module, exports) {
module.exports = new URL("videoButton.700d7e28.png", import.meta.url).toString();

});

parcelRegister("jLZXj", function(module, exports) {
module.exports = new URL("Cybersecurity_Mask.5ecd61f0.png", import.meta.url).toString();

});

parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("k3MW3", function(module, exports) {
module.exports = new URL("precentage-icon.c5adb999.png", import.meta.url).toString();

});

parcelRegister("jSVu6", function(module, exports) {
module.exports = new URL("checklist-logo.4311360d.png", import.meta.url).toString();

});

parcelRegister("5DQVD", function(module, exports) {
module.exports = new URL("manual-add-icon.8e0c73a7.svg", import.meta.url).toString();

});

parcelRegister("dcVB2", function(module, exports) {
module.exports = new URL("investment-criteria-icon.712c99a2.svg", import.meta.url).toString();

});

parcelRegister("f7BbQ", function(module, exports) {
module.exports = new URL("report.60f58a9d.svg", import.meta.url).toString();

});

parcelRegister("iXRwJ", function(module, exports) {
module.exports = new URL("banner-certification-3.45ef5903.png", import.meta.url).toString();

});

parcelRegister("gBSL3", function(module, exports) {
module.exports = new URL("banner-certification-2.5b7c9b6e.png", import.meta.url).toString();

});

parcelRegister("9iQ9H", function(module, exports) {
module.exports = new URL("banner-certification-1.30a0abf5.png", import.meta.url).toString();

});

parcelRegister("d4clj", function(module, exports) {
module.exports = new URL("delete.22dbd762.svg", import.meta.url).toString();

});

parcelRegister("gB01D", function(module, exports) {
module.exports = new URL("add-client-1.8e9ed590.png", import.meta.url).toString();

});

parcelRegister("MEFCn", function(module, exports) {
module.exports = new URL("add-client-2.9dece6df.png", import.meta.url).toString();

});

parcelRegister("1XVow", function(module, exports) {
module.exports = new URL("add-client-3.c73d2923.png", import.meta.url).toString();

});

parcelRegister("fjCti", function(module, exports) {
module.exports = new URL("chase1.5b329a39.png", import.meta.url).toString();

});

parcelRegister("X3AOK", function(module, exports) {
module.exports = new URL("add-client-step-1.7804002b.png", import.meta.url).toString();

});

parcelRegister("e0CwZ", function(module, exports) {
module.exports = new URL("add-client-step-2.bb0fda78.png", import.meta.url).toString();

});

parcelRegister("hgbtZ", function(module, exports) {
module.exports = new URL("add-client-step-3.51e0a8ca.png", import.meta.url).toString();

});

parcelRegister("h7BuI", function(module, exports) {
module.exports = new URL("qualified-leads-1.cd51ee06.png", import.meta.url).toString();

});

parcelRegister("fPw2G", function(module, exports) {
module.exports = new URL("qualified-leads-2.ff4abe3b.png", import.meta.url).toString();

});

parcelRegister("iqLwx", function(module, exports) {
module.exports = new URL("qualified-leads-3.6b04c284.png", import.meta.url).toString();

});

parcelRegister("DkP6I", function(module, exports) {
module.exports = new URL("website-widget-step-1.3a8f0ecf.png", import.meta.url).toString();

});

parcelRegister("5UoR7", function(module, exports) {
module.exports = new URL("website-widget-step-2.86cb49bb.png", import.meta.url).toString();

});

parcelRegister("as4ju", function(module, exports) {
module.exports = new URL("website-widget-step-3.5166de39.png", import.meta.url).toString();

});

parcelRegister("fwl3g", function(module, exports) {
module.exports = new URL("none.ea6b97f7.png", import.meta.url).toString();

});

parcelRegister("8QnGH", function(module, exports) {
module.exports = new URL("bronzeLarge.a8dd2d83.png", import.meta.url).toString();

});

parcelRegister("kmrMT", function(module, exports) {
module.exports = new URL("silverLarge.7a0a4319.png", import.meta.url).toString();

});

parcelRegister("1LLUk", function(module, exports) {
module.exports = new URL("goldLarge.3a095b2c.png", import.meta.url).toString();

});

parcelRegister("6iC0x", function(module, exports) {
module.exports = new URL("high warning.e69ce902.svg", import.meta.url).toString();

});

parcelRegister("3GInX", function(module, exports) {
module.exports = new URL("medium warning.f8ece25b.svg", import.meta.url).toString();

});

parcelRegister("5OCVb", function(module, exports) {
module.exports = new URL("low warning.f661b5e7.svg", import.meta.url).toString();

});

parcelRegister("3CdlC", function(module, exports) {
module.exports = new URL("warning icon.139992d4.svg", import.meta.url).toString();

});

parcelRegister("1q1VK", function(module, exports) {
module.exports = new URL("info-icon-tab.a1e2fe5b.svg", import.meta.url).toString();

});

parcelRegister("aYFpF", function(module, exports) {
module.exports = new URL("fillingmodal-lright-area.1c8e1349.png", import.meta.url).toString();

});

parcelRegister("aWpLg", function(module, exports) {
module.exports = new URL("bvca-logo.b3777fa0.png", import.meta.url).toString();

});

parcelRegister("3c5p9", function(module, exports) {
module.exports = new URL("crunchbase-logo.9580242d.png", import.meta.url).toString();

});

parcelRegister("kZBx4", function(module, exports) {
module.exports = new URL("swwdleagals.5b6fac11.png", import.meta.url).toString();

});

parcelRegister("7BAlA", function(module, exports) {
module.exports = new URL("banner-certificate-bottom.8b7afca9.png", import.meta.url).toString();

});

parcelRegister("jowwK", function(module, exports) {
module.exports = new URL("list.49ff6088.png", import.meta.url).toString();

});

parcelRegister("d729Q", function(module, exports) {
module.exports = new URL("arrow.98a64aa3.png", import.meta.url).toString();

});

parcelRegister("ktVzj", function(module, exports) {
module.exports = new URL("whatisit.87e17000.png", import.meta.url).toString();

});

parcelRegister("d6YfF", function(module, exports) {
module.exports = new URL("howitworks.e8cc39c0.png", import.meta.url).toString();

});

parcelRegister("lzxyC", function(module, exports) {
module.exports = new URL("help.76aa5a97.png", import.meta.url).toString();

});

parcelRegister("cNord", function(module, exports) {
module.exports = new URL("R.2652fe02.png", import.meta.url).toString();

});

parcelRegister("bLX5S", function(module, exports) {
module.exports = new URL("WF.53f26421.png", import.meta.url).toString();

});

parcelRegister("h5UTs", function(module, exports) {
module.exports = new URL("insufficient-score.febdd0a9.png", import.meta.url).toString();

});

parcelRegister("1KKTD", function(module, exports) {
module.exports = new URL("investorMatchDisclaimer.890042a7.png", import.meta.url).toString();

});

parcelRegister("FTXhj", function(module, exports) {
module.exports = new URL("appStoreIcon.49186080.png", import.meta.url).toString();

});

parcelRegister("etvvZ", function(module, exports) {
module.exports = new URL("anyListBuilder.a081e0c6.png", import.meta.url).toString();

});

parcelRegister("amtBP", function(module, exports) {
module.exports = new URL("researchAid.7c0ec90b.png", import.meta.url).toString();

});

parcelRegister("2S8Rb", function(module, exports) {
module.exports = new URL("investorMatchFree.72602a15.png", import.meta.url).toString();

});

parcelRegister("8dYc6", function(module, exports) {
module.exports = new URL("investorReadiness.09db956a.png", import.meta.url).toString();

});

parcelRegister("28d7u", function(module, exports) {
module.exports = new URL("kpiReport.a03ffe28.png", import.meta.url).toString();

});

parcelRegister("b6BEA", function(module, exports) {
module.exports = new URL("researchAidReport.3f574b7d.png", import.meta.url).toString();

});

parcelRegister("g4rCm", function(module, exports) {
module.exports = new URL("growthReadiness.fb65dd38.png", import.meta.url).toString();

});

parcelRegister("aeBaH", function(module, exports) {
module.exports = new URL("loanReadiness.9fd2e032.png", import.meta.url).toString();

});

parcelRegister("vzYIQ", function(module, exports) {
module.exports = new URL("exitReadiness.95c40a27.png", import.meta.url).toString();

});

parcelRegister("7bhVJ", function(module, exports) {
module.exports = new URL("diligencePackFree.7d1e4b47.png", import.meta.url).toString();

});

parcelRegister("kqQBl", function(module, exports) {
module.exports = new URL("investorMatchPro.76c37ce4.png", import.meta.url).toString();

});

parcelRegister("8LjKs", function(module, exports) {
module.exports = new URL("diligencePackPro.876f6710.png", import.meta.url).toString();

});

parcelRegister("6pfy5", function(module, exports) {
module.exports = new URL("yourCertificateJourney.73b183fe.png", import.meta.url).toString();

});

parcelRegister("74k55", function(module, exports) {
module.exports = new URL("investorFitReportPro.7fca0c02.png", import.meta.url).toString();

});

parcelRegister("e6E38", function(module, exports) {
module.exports = new URL("researchAid.9994e122.png", import.meta.url).toString();

});

parcelRegister("5EpVu", function(module, exports) {
module.exports = new URL("anylistBulder.79172a21.png", import.meta.url).toString();

});

parcelRegister("eNzUS", function(module, exports) {
module.exports = new URL("partnerModule.0efa577d.png", import.meta.url).toString();

});

parcelRegister("9Aecm", function(module, exports) {
module.exports = new URL("goldenHandshake.55fce579.png", import.meta.url).toString();

});

parcelRegister("1CCPV", function(module, exports) {
module.exports = new URL("locationPin.c1e97f10.png", import.meta.url).toString();

});

parcelRegister("9mZnR", function(module, exports) {
module.exports = new URL("growth.e6b2c56d.png", import.meta.url).toString();

});

parcelRegister("gEFao", function(module, exports) {
module.exports = new URL("exit.cd1a7de6.png", import.meta.url).toString();

});

parcelRegister("ckYT2", function(module, exports) {
module.exports = new URL("investment.340ae7db.png", import.meta.url).toString();

});

parcelRegister("7I9Dg", function(module, exports) {
module.exports = new URL("none.bd11115c.png", import.meta.url).toString();

});

parcelRegister("9oIEm", function(module, exports) {
module.exports = new URL("bronze.0517ab81.png", import.meta.url).toString();

});

parcelRegister("f7wni", function(module, exports) {
module.exports = new URL("silver.57662e4a.png", import.meta.url).toString();

});

parcelRegister("fylCo", function(module, exports) {
module.exports = new URL("gold.62e69f5a.png", import.meta.url).toString();

});

parcelRegister("1v2Rh", function(module, exports) {
module.exports = new URL("yellowDownArrow.6896f083.png", import.meta.url).toString();

});

parcelRegister("99b6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6a8d906b07c31ea5$var$_react = $6a8d906b07c31ea5$var$_interopRequireDefault((parcelRequire("acw62")));

var $inpnQ = parcelRequire("inpnQ");

var $6a8d906b07c31ea5$var$_json2mq = $6a8d906b07c31ea5$var$_interopRequireDefault((parcelRequire("aqP1M")));

var $6a8d906b07c31ea5$var$_defaultProps = $6a8d906b07c31ea5$var$_interopRequireDefault((parcelRequire("bt3o5")));

var $2y81T = parcelRequire("2y81T");
function $6a8d906b07c31ea5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6a8d906b07c31ea5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6a8d906b07c31ea5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6a8d906b07c31ea5$var$_typeof(o);
}
function $6a8d906b07c31ea5$var$_extends() {
    $6a8d906b07c31ea5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a8d906b07c31ea5$var$_extends.apply(this, arguments);
}
function $6a8d906b07c31ea5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a8d906b07c31ea5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a8d906b07c31ea5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6a8d906b07c31ea5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a8d906b07c31ea5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6a8d906b07c31ea5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6a8d906b07c31ea5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6a8d906b07c31ea5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6a8d906b07c31ea5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6a8d906b07c31ea5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6a8d906b07c31ea5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6a8d906b07c31ea5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6a8d906b07c31ea5$var$_setPrototypeOf(subClass, superClass);
}
function $6a8d906b07c31ea5$var$_setPrototypeOf(o, p) {
    $6a8d906b07c31ea5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6a8d906b07c31ea5$var$_setPrototypeOf(o, p);
}
function $6a8d906b07c31ea5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6a8d906b07c31ea5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6a8d906b07c31ea5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6a8d906b07c31ea5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6a8d906b07c31ea5$var$_possibleConstructorReturn(this, result);
    };
}
function $6a8d906b07c31ea5$var$_possibleConstructorReturn(self, call) {
    if (call && ($6a8d906b07c31ea5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6a8d906b07c31ea5$var$_assertThisInitialized(self);
}
function $6a8d906b07c31ea5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6a8d906b07c31ea5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6a8d906b07c31ea5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6a8d906b07c31ea5$var$_getPrototypeOf(o) {
    $6a8d906b07c31ea5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6a8d906b07c31ea5$var$_getPrototypeOf(o);
}
function $6a8d906b07c31ea5$var$_defineProperty(obj, key, value) {
    key = $6a8d906b07c31ea5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6a8d906b07c31ea5$var$_toPropertyKey(t) {
    var i = $6a8d906b07c31ea5$var$_toPrimitive(t, "string");
    return "symbol" == $6a8d906b07c31ea5$var$_typeof(i) ? i : String(i);
}
function $6a8d906b07c31ea5$var$_toPrimitive(t, r) {
    if ("object" != $6a8d906b07c31ea5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6a8d906b07c31ea5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $6a8d906b07c31ea5$var$enquire = (0, $2y81T.canUseDOM)() && (parcelRequire("aqoFQ"));
var $6a8d906b07c31ea5$var$Slider = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    $6a8d906b07c31ea5$var$_inherits(Slider, _React$Component);
    var _super = $6a8d906b07c31ea5$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $6a8d906b07c31ea5$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $6a8d906b07c31ea5$var$_defineProperty($6a8d906b07c31ea5$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $6a8d906b07c31ea5$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $6a8d906b07c31ea5$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $6a8d906b07c31ea5$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $6a8d906b07c31ea5$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $2y81T.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $6a8d906b07c31ea5$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $2y81T.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $6a8d906b07c31ea5$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $6a8d906b07c31ea5$var$_objectSpread($6a8d906b07c31ea5$var$_objectSpread($6a8d906b07c31ea5$var$_objectSpread({}, $6a8d906b07c31ea5$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $6a8d906b07c31ea5$var$_objectSpread($6a8d906b07c31ea5$var$_objectSpread({}, $6a8d906b07c31ea5$var$_defaultProps["default"]), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = $6a8d906b07c31ea5$var$_react["default"].Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) settings.unslick = true;
                return /*#__PURE__*/ $6a8d906b07c31ea5$var$_react["default"].createElement($inpnQ.InnerSlider, $6a8d906b07c31ea5$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, (0, $2y81T.filterSettings)(settings)), newChildren);
            }
        }
    ]);
    return Slider;
}($6a8d906b07c31ea5$var$_react["default"].Component);

});
parcelRegister("inpnQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $d60e10a72c1d1a1a$var$_react = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("acw62")));

var $d60e10a72c1d1a1a$var$_initialState = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("9jP9B")));

var $d60e10a72c1d1a1a$var$_lodash = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("lwfqC")));

var $d60e10a72c1d1a1a$var$_classnames = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");

var $7yZIu = parcelRequire("7yZIu");

var $5dzCO = parcelRequire("5dzCO");

var $gught = parcelRequire("gught");

var $d60e10a72c1d1a1a$var$_resizeObserverPolyfill = $d60e10a72c1d1a1a$var$_interopRequireDefault((parcelRequire("bEEfE")));
function $d60e10a72c1d1a1a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d60e10a72c1d1a1a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d60e10a72c1d1a1a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d60e10a72c1d1a1a$var$_typeof(o);
}
function $d60e10a72c1d1a1a$var$_extends() {
    $d60e10a72c1d1a1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d60e10a72c1d1a1a$var$_extends.apply(this, arguments);
}
function $d60e10a72c1d1a1a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d60e10a72c1d1a1a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d60e10a72c1d1a1a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d60e10a72c1d1a1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d60e10a72c1d1a1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d60e10a72c1d1a1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d60e10a72c1d1a1a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d60e10a72c1d1a1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d60e10a72c1d1a1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d60e10a72c1d1a1a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d60e10a72c1d1a1a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d60e10a72c1d1a1a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d60e10a72c1d1a1a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d60e10a72c1d1a1a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d60e10a72c1d1a1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d60e10a72c1d1a1a$var$_setPrototypeOf(subClass, superClass);
}
function $d60e10a72c1d1a1a$var$_setPrototypeOf(o, p) {
    $d60e10a72c1d1a1a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d60e10a72c1d1a1a$var$_setPrototypeOf(o, p);
}
function $d60e10a72c1d1a1a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d60e10a72c1d1a1a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d60e10a72c1d1a1a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d60e10a72c1d1a1a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d60e10a72c1d1a1a$var$_possibleConstructorReturn(this, result);
    };
}
function $d60e10a72c1d1a1a$var$_possibleConstructorReturn(self, call) {
    if (call && ($d60e10a72c1d1a1a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d60e10a72c1d1a1a$var$_assertThisInitialized(self);
}
function $d60e10a72c1d1a1a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d60e10a72c1d1a1a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d60e10a72c1d1a1a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d60e10a72c1d1a1a$var$_getPrototypeOf(o) {
    $d60e10a72c1d1a1a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d60e10a72c1d1a1a$var$_getPrototypeOf(o);
}
function $d60e10a72c1d1a1a$var$_defineProperty(obj, key, value) {
    key = $d60e10a72c1d1a1a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d60e10a72c1d1a1a$var$_toPropertyKey(t) {
    var i = $d60e10a72c1d1a1a$var$_toPrimitive(t, "string");
    return "symbol" == $d60e10a72c1d1a1a$var$_typeof(i) ? i : String(i);
}
function $d60e10a72c1d1a1a$var$_toPrimitive(t, r) {
    if ("object" != $d60e10a72c1d1a1a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d60e10a72c1d1a1a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d60e10a72c1d1a1a$var$InnerSlider = module.exports.InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $d60e10a72c1d1a1a$var$_inherits(InnerSlider, _React$Component);
    var _super = $d60e10a72c1d1a1a$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $d60e10a72c1d1a1a$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
                _this.list.style.height = (0, $2y81T.getHeight)(elem) + "px";
            }
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $2y81T.getOnDemandLazySlides)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $d60e10a72c1d1a1a$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $d60e10a72c1d1a1a$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $2y81T.getOnDemandLazySlides)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $d60e10a72c1d1a1a$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $2y81T.initializedState)(spec);
            spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $2y81T.getTrackLeft)(spec);
            spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $2y81T.getTrackCSS)(spec);
            if (setTrackStyle || $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children) !== $d60e10a72c1d1a1a$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $2y81T.getPreClones)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $2y81T.getPostClones)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children);
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $2y81T.getPreClones)(spec) + (0, $2y81T.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $2y81T.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $2y81T.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $2y81T.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $2y81T.slideHandler)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $d60e10a72c1d1a1a$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $2y81T.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $2y81T.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $2y81T.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $2y81T.swipeMove)(e, $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $2y81T.swipeEnd)(e, $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $2y81T.canGoNext)($d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $d60e10a72c1d1a1a$var$_defineProperty($d60e10a72c1d1a1a$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $d60e10a72c1d1a1a$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $2y81T.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $2y81T.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($5dzCO.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $2y81T.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($gught.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($gught.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement("div", $d60e10a72c1d1a1a$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $d60e10a72c1d1a1a$var$_react["default"].createElement($7yZIu.Track, $d60e10a72c1d1a1a$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, $d60e10a72c1d1a1a$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
            slideCount: $d60e10a72c1d1a1a$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $d60e10a72c1d1a1a$var$_objectSpread($d60e10a72c1d1a1a$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $d60e10a72c1d1a1a$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($d60e10a72c1d1a1a$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $d60e10a72c1d1a1a$var$_react["default"].Children.count(this.props.children) !== $d60e10a72c1d1a1a$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($d60e10a72c1d1a1a$var$_react["default"].Component);

});
parcelRegister("9jP9B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $6c8d917fbaa95cfd$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $6c8d917fbaa95cfd$var$_default = module.exports["default"] = $6c8d917fbaa95cfd$var$initialState;

});

parcelRegister("2y81T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $1db4fc3826fb9046$var$clamp;
module.exports.extractObject = void 0;
module.exports.filterSettings = $1db4fc3826fb9046$var$filterSettings;
module.exports.validSettings = module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = void 0;

var $1db4fc3826fb9046$var$_react = $1db4fc3826fb9046$var$_interopRequireDefault((parcelRequire("acw62")));

var $1db4fc3826fb9046$var$_defaultProps = $1db4fc3826fb9046$var$_interopRequireDefault((parcelRequire("bt3o5")));
function $1db4fc3826fb9046$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1db4fc3826fb9046$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1db4fc3826fb9046$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1db4fc3826fb9046$var$_typeof(o);
}
function $1db4fc3826fb9046$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1db4fc3826fb9046$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1db4fc3826fb9046$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1db4fc3826fb9046$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1db4fc3826fb9046$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1db4fc3826fb9046$var$_defineProperty(obj, key, value) {
    key = $1db4fc3826fb9046$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1db4fc3826fb9046$var$_toPropertyKey(t) {
    var i = $1db4fc3826fb9046$var$_toPrimitive(t, "string");
    return "symbol" == $1db4fc3826fb9046$var$_typeof(i) ? i : String(i);
}
function $1db4fc3826fb9046$var$_toPrimitive(t, r) {
    if ("object" != $1db4fc3826fb9046$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1db4fc3826fb9046$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1db4fc3826fb9046$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $1db4fc3826fb9046$var$safePreventDefault = module.exports.safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $1db4fc3826fb9046$var$getOnDemandLazySlides = module.exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $1db4fc3826fb9046$var$lazyStartIndex(spec);
    var endIndex = $1db4fc3826fb9046$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
// return list of slides that need to be present
var $1db4fc3826fb9046$var$getRequiredLazySlides = module.exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $1db4fc3826fb9046$var$lazyStartIndex(spec);
    var endIndex = $1db4fc3826fb9046$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
// startIndex that needs to be present
var $1db4fc3826fb9046$var$lazyStartIndex = module.exports.lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $1db4fc3826fb9046$var$lazySlidesOnLeft(spec);
};
var $1db4fc3826fb9046$var$lazyEndIndex = module.exports.lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $1db4fc3826fb9046$var$lazySlidesOnRight(spec);
};
var $1db4fc3826fb9046$var$lazySlidesOnLeft = module.exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $1db4fc3826fb9046$var$lazySlidesOnRight = module.exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
// get width of an element
var $1db4fc3826fb9046$var$getWidth = module.exports.getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $1db4fc3826fb9046$var$getHeight = module.exports.getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $1db4fc3826fb9046$var$getSwipeDirection = module.exports.getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
// whether or not we can go next
var $1db4fc3826fb9046$var$canGoNext = module.exports.canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
// given an object and a list of keys, return new object with given keys
var $1db4fc3826fb9046$var$extractObject = module.exports.extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
// get initialized state
var $1db4fc3826fb9046$var$initializedState = module.exports.initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $1db4fc3826fb9046$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($1db4fc3826fb9046$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($1db4fc3826fb9046$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $1db4fc3826fb9046$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $1db4fc3826fb9046$var$getOnDemandLazySlides($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $1db4fc3826fb9046$var$slideHandler = module.exports.slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $1db4fc3826fb9046$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$1db4fc3826fb9046$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $1db4fc3826fb9046$var$getTrackLeft($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $1db4fc3826fb9046$var$getTrackLeft($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($1db4fc3826fb9046$var$getOnDemandLazySlides($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $1db4fc3826fb9046$var$getTrackCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $1db4fc3826fb9046$var$getTrackAnimateCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $1db4fc3826fb9046$var$getTrackCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $1db4fc3826fb9046$var$changeSlide = module.exports.changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $1db4fc3826fb9046$var$siblingDirection($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $1db4fc3826fb9046$var$keyHandler = module.exports.keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $1db4fc3826fb9046$var$swipeStart = module.exports.swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $1db4fc3826fb9046$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $1db4fc3826fb9046$var$swipeMove = module.exports.swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $1db4fc3826fb9046$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $1db4fc3826fb9046$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $1db4fc3826fb9046$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $1db4fc3826fb9046$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$1db4fc3826fb9046$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $1db4fc3826fb9046$var$getTrackCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $1db4fc3826fb9046$var$safePreventDefault(e);
    }
    return state;
};
var $1db4fc3826fb9046$var$swipeEnd = module.exports.swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $1db4fc3826fb9046$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $1db4fc3826fb9046$var$getSwipeDirection(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $1db4fc3826fb9046$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $1db4fc3826fb9046$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $1db4fc3826fb9046$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $1db4fc3826fb9046$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $1db4fc3826fb9046$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $1db4fc3826fb9046$var$getTrackLeft(spec);
        state["trackStyle"] = $1db4fc3826fb9046$var$getTrackAnimateCSS($1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $1db4fc3826fb9046$var$getNavigableIndexes = module.exports.getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $1db4fc3826fb9046$var$checkNavigable = module.exports.checkNavigable = function checkNavigable(spec, index) {
    var navigables = $1db4fc3826fb9046$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $1db4fc3826fb9046$var$getSlideCount = module.exports.getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $1db4fc3826fb9046$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $1db4fc3826fb9046$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $1db4fc3826fb9046$var$checkSpecKeys = module.exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
var $1db4fc3826fb9046$var$getTrackCSS = module.exports.getTrackCSS = function getTrackCSS(spec) {
    $1db4fc3826fb9046$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $1db4fc3826fb9046$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $1db4fc3826fb9046$var$_objectSpread($1db4fc3826fb9046$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $1db4fc3826fb9046$var$getTrackAnimateCSS = module.exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $1db4fc3826fb9046$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $1db4fc3826fb9046$var$getTrackCSS(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $1db4fc3826fb9046$var$getTrackLeft = module.exports.getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $1db4fc3826fb9046$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$1db4fc3826fb9046$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $1db4fc3826fb9046$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $1db4fc3826fb9046$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $1db4fc3826fb9046$var$getPreClones = module.exports.getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $1db4fc3826fb9046$var$getPostClones = module.exports.getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
var $1db4fc3826fb9046$var$getTotalSlides = module.exports.getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $1db4fc3826fb9046$var$getPreClones(spec) + spec.slideCount + $1db4fc3826fb9046$var$getPostClones(spec);
};
var $1db4fc3826fb9046$var$siblingDirection = module.exports.siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $1db4fc3826fb9046$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $1db4fc3826fb9046$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
var $1db4fc3826fb9046$var$slidesOnRight = module.exports.slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $1db4fc3826fb9046$var$slidesOnLeft = module.exports.slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $1db4fc3826fb9046$var$canUseDOM = module.exports.canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var $1db4fc3826fb9046$var$validSettings = module.exports.validSettings = Object.keys($1db4fc3826fb9046$var$_defaultProps["default"]);
function $1db4fc3826fb9046$var$filterSettings(settings) {
    return $1db4fc3826fb9046$var$validSettings.reduce(function(acc, settingName) {
        if (settings.hasOwnProperty(settingName)) acc[settingName] = settings[settingName];
        return acc;
    }, {});
}

});
parcelRegister("bt3o5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $859507cfc701f467$var$_react = $859507cfc701f467$var$_interopRequireDefault((parcelRequire("acw62")));
function $859507cfc701f467$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $859507cfc701f467$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $859507cfc701f467$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $859507cfc701f467$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    asNavFor: null,
    unslick: false
};
var $859507cfc701f467$var$_default = module.exports["default"] = $859507cfc701f467$var$defaultProps;

});


parcelRegister("7yZIu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $581b95074dd25dbd$var$_react = $581b95074dd25dbd$var$_interopRequireDefault((parcelRequire("acw62")));

var $581b95074dd25dbd$var$_classnames = $581b95074dd25dbd$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");
function $581b95074dd25dbd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $581b95074dd25dbd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $581b95074dd25dbd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $581b95074dd25dbd$var$_typeof(o);
}
function $581b95074dd25dbd$var$_extends() {
    $581b95074dd25dbd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $581b95074dd25dbd$var$_extends.apply(this, arguments);
}
function $581b95074dd25dbd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $581b95074dd25dbd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $581b95074dd25dbd$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $581b95074dd25dbd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $581b95074dd25dbd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $581b95074dd25dbd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $581b95074dd25dbd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $581b95074dd25dbd$var$_setPrototypeOf(subClass, superClass);
}
function $581b95074dd25dbd$var$_setPrototypeOf(o, p) {
    $581b95074dd25dbd$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $581b95074dd25dbd$var$_setPrototypeOf(o, p);
}
function $581b95074dd25dbd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $581b95074dd25dbd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $581b95074dd25dbd$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $581b95074dd25dbd$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $581b95074dd25dbd$var$_possibleConstructorReturn(this, result);
    };
}
function $581b95074dd25dbd$var$_possibleConstructorReturn(self, call) {
    if (call && ($581b95074dd25dbd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $581b95074dd25dbd$var$_assertThisInitialized(self);
}
function $581b95074dd25dbd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $581b95074dd25dbd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($581b95074dd25dbd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $581b95074dd25dbd$var$_getPrototypeOf(o) {
    $581b95074dd25dbd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $581b95074dd25dbd$var$_getPrototypeOf(o);
}
function $581b95074dd25dbd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $581b95074dd25dbd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $581b95074dd25dbd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $581b95074dd25dbd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $581b95074dd25dbd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $581b95074dd25dbd$var$_defineProperty(obj, key, value) {
    key = $581b95074dd25dbd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $581b95074dd25dbd$var$_toPropertyKey(t) {
    var i = $581b95074dd25dbd$var$_toPrimitive(t, "string");
    return "symbol" == $581b95074dd25dbd$var$_typeof(i) ? i : String(i);
}
function $581b95074dd25dbd$var$_toPrimitive(t, r) {
    if ("object" != $581b95074dd25dbd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $581b95074dd25dbd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $581b95074dd25dbd$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $581b95074dd25dbd$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $581b95074dd25dbd$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $581b95074dd25dbd$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $581b95074dd25dbd$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $2y81T.lazyStartIndex)(spec);
    var endIndex = (0, $2y81T.lazyEndIndex)(spec);
    $581b95074dd25dbd$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].createElement("div", null);
        var childStyle = $581b95074dd25dbd$var$getSlideStyle($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $581b95074dd25dbd$var$getSlideClasses($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].cloneElement(child, {
            key: "original" + $581b95074dd25dbd$var$getKey(child, index),
            "data-index": index,
            className: (0, $581b95074dd25dbd$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $2y81T.getPreClones)(spec)) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $581b95074dd25dbd$var$getSlideClasses($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $581b95074dd25dbd$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $581b95074dd25dbd$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            key = childrenCount + index;
            if (key < endIndex) child = elem;
            slideClasses = $581b95074dd25dbd$var$getSlideClasses($581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, spec), {}, {
                index: key
            }));
            postCloneSlides.push(/*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].cloneElement(child, {
                key: "postcloned" + $581b95074dd25dbd$var$getKey(child, key),
                "data-index": key,
                tabIndex: "-1",
                className: (0, $581b95074dd25dbd$var$_classnames["default"])(slideClasses, slideClass),
                "aria-hidden": !slideClasses["slick-active"],
                style: $581b95074dd25dbd$var$_objectSpread($581b95074dd25dbd$var$_objectSpread({}, child.props.style || {}), childStyle),
                onClick: function onClick(e) {
                    child.props && child.props.onClick && child.props.onClick(e);
                    if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                }
            }));
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $581b95074dd25dbd$var$Track = module.exports.Track = /*#__PURE__*/ function(_React$PureComponent) {
    $581b95074dd25dbd$var$_inherits(Track, _React$PureComponent);
    var _super = $581b95074dd25dbd$var$_createSuper(Track);
    function Track() {
        var _this;
        $581b95074dd25dbd$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $581b95074dd25dbd$var$_defineProperty($581b95074dd25dbd$var$_assertThisInitialized(_this), "node", null);
        $581b95074dd25dbd$var$_defineProperty($581b95074dd25dbd$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $581b95074dd25dbd$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $581b95074dd25dbd$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $581b95074dd25dbd$var$_react["default"].createElement("div", $581b95074dd25dbd$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($581b95074dd25dbd$var$_react["default"].PureComponent);

});

parcelRegister("5dzCO", function(module, exports) {
"use strict";
function $3cc9cd0730c6715e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3cc9cd0730c6715e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3cc9cd0730c6715e$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $3cc9cd0730c6715e$var$_react = $3cc9cd0730c6715e$var$_interopRequireDefault((parcelRequire("acw62")));

var $3cc9cd0730c6715e$var$_classnames = $3cc9cd0730c6715e$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");
function $3cc9cd0730c6715e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3cc9cd0730c6715e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cc9cd0730c6715e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cc9cd0730c6715e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cc9cd0730c6715e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cc9cd0730c6715e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cc9cd0730c6715e$var$_defineProperty(obj, key, value) {
    key = $3cc9cd0730c6715e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3cc9cd0730c6715e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3cc9cd0730c6715e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3cc9cd0730c6715e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3cc9cd0730c6715e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3cc9cd0730c6715e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3cc9cd0730c6715e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3cc9cd0730c6715e$var$_toPropertyKey(t) {
    var i = $3cc9cd0730c6715e$var$_toPrimitive(t, "string");
    return "symbol" == $3cc9cd0730c6715e$var$_typeof(i) ? i : String(i);
}
function $3cc9cd0730c6715e$var$_toPrimitive(t, r) {
    if ("object" != $3cc9cd0730c6715e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3cc9cd0730c6715e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3cc9cd0730c6715e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3cc9cd0730c6715e$var$_setPrototypeOf(subClass, superClass);
}
function $3cc9cd0730c6715e$var$_setPrototypeOf(o, p) {
    $3cc9cd0730c6715e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3cc9cd0730c6715e$var$_setPrototypeOf(o, p);
}
function $3cc9cd0730c6715e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3cc9cd0730c6715e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3cc9cd0730c6715e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3cc9cd0730c6715e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3cc9cd0730c6715e$var$_possibleConstructorReturn(this, result);
    };
}
function $3cc9cd0730c6715e$var$_possibleConstructorReturn(self, call) {
    if (call && ($3cc9cd0730c6715e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3cc9cd0730c6715e$var$_assertThisInitialized(self);
}
function $3cc9cd0730c6715e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3cc9cd0730c6715e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3cc9cd0730c6715e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3cc9cd0730c6715e$var$_getPrototypeOf(o) {
    $3cc9cd0730c6715e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3cc9cd0730c6715e$var$_getPrototypeOf(o);
}
var $3cc9cd0730c6715e$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $3cc9cd0730c6715e$var$Dots = module.exports.Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $3cc9cd0730c6715e$var$_inherits(Dots, _React$PureComponent);
    var _super = $3cc9cd0730c6715e$var$_createSuper(Dots);
    function Dots() {
        $3cc9cd0730c6715e$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $3cc9cd0730c6715e$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $3cc9cd0730c6715e$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $2y81T.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $2y81T.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $3cc9cd0730c6715e$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $3cc9cd0730c6715e$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $3cc9cd0730c6715e$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $3cc9cd0730c6715e$var$_react["default"].cloneElement(this.props.appendDots(dots), $3cc9cd0730c6715e$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($3cc9cd0730c6715e$var$_react["default"].PureComponent);

});

parcelRegister("gught", function(module, exports) {
"use strict";
function $c00c13b6f9af96d7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c00c13b6f9af96d7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c00c13b6f9af96d7$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $c00c13b6f9af96d7$var$_react = $c00c13b6f9af96d7$var$_interopRequireDefault((parcelRequire("acw62")));

var $c00c13b6f9af96d7$var$_classnames = $c00c13b6f9af96d7$var$_interopRequireDefault((parcelRequire("8g1PZ")));

var $2y81T = parcelRequire("2y81T");
function $c00c13b6f9af96d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c00c13b6f9af96d7$var$_extends() {
    $c00c13b6f9af96d7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c00c13b6f9af96d7$var$_extends.apply(this, arguments);
}
function $c00c13b6f9af96d7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c00c13b6f9af96d7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c00c13b6f9af96d7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c00c13b6f9af96d7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c00c13b6f9af96d7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c00c13b6f9af96d7$var$_defineProperty(obj, key, value) {
    key = $c00c13b6f9af96d7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c00c13b6f9af96d7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c00c13b6f9af96d7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c00c13b6f9af96d7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c00c13b6f9af96d7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c00c13b6f9af96d7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c00c13b6f9af96d7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c00c13b6f9af96d7$var$_toPropertyKey(t) {
    var i = $c00c13b6f9af96d7$var$_toPrimitive(t, "string");
    return "symbol" == $c00c13b6f9af96d7$var$_typeof(i) ? i : String(i);
}
function $c00c13b6f9af96d7$var$_toPrimitive(t, r) {
    if ("object" != $c00c13b6f9af96d7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c00c13b6f9af96d7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c00c13b6f9af96d7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c00c13b6f9af96d7$var$_setPrototypeOf(subClass, superClass);
}
function $c00c13b6f9af96d7$var$_setPrototypeOf(o, p) {
    $c00c13b6f9af96d7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c00c13b6f9af96d7$var$_setPrototypeOf(o, p);
}
function $c00c13b6f9af96d7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c00c13b6f9af96d7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c00c13b6f9af96d7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c00c13b6f9af96d7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c00c13b6f9af96d7$var$_possibleConstructorReturn(this, result);
    };
}
function $c00c13b6f9af96d7$var$_possibleConstructorReturn(self, call) {
    if (call && ($c00c13b6f9af96d7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c00c13b6f9af96d7$var$_assertThisInitialized(self);
}
function $c00c13b6f9af96d7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c00c13b6f9af96d7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c00c13b6f9af96d7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c00c13b6f9af96d7$var$_getPrototypeOf(o) {
    $c00c13b6f9af96d7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c00c13b6f9af96d7$var$_getPrototypeOf(o);
}
var $c00c13b6f9af96d7$var$PrevArrow = module.exports.PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $c00c13b6f9af96d7$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $c00c13b6f9af96d7$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $c00c13b6f9af96d7$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $c00c13b6f9af96d7$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $c00c13b6f9af96d7$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].cloneElement(this.props.prevArrow, $c00c13b6f9af96d7$var$_objectSpread($c00c13b6f9af96d7$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].createElement("button", $c00c13b6f9af96d7$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($c00c13b6f9af96d7$var$_react["default"].PureComponent);
var $c00c13b6f9af96d7$var$NextArrow = module.exports.NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $c00c13b6f9af96d7$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $c00c13b6f9af96d7$var$_createSuper(NextArrow);
    function NextArrow() {
        $c00c13b6f9af96d7$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $c00c13b6f9af96d7$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $2y81T.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $c00c13b6f9af96d7$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].cloneElement(this.props.nextArrow, $c00c13b6f9af96d7$var$_objectSpread($c00c13b6f9af96d7$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $c00c13b6f9af96d7$var$_react["default"].createElement("button", $c00c13b6f9af96d7$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($c00c13b6f9af96d7$var$_react["default"].PureComponent);

});

parcelRegister("bEEfE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $87c2a74187854fda$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $87c2a74187854fda$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $87c2a74187854fda$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $87c2a74187854fda$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $87c2a74187854fda$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($87c2a74187854fda$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $87c2a74187854fda$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $87c2a74187854fda$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $87c2a74187854fda$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $87c2a74187854fda$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $87c2a74187854fda$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $87c2a74187854fda$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $87c2a74187854fda$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $87c2a74187854fda$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $87c2a74187854fda$var$throttle(this.refresh.bind(this), $87c2a74187854fda$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$87c2a74187854fda$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($87c2a74187854fda$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$87c2a74187854fda$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $87c2a74187854fda$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $87c2a74187854fda$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $87c2a74187854fda$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $87c2a74187854fda$var$global$1;
};
// Placeholder of an empty content rectangle.
var $87c2a74187854fda$var$emptyRect = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $87c2a74187854fda$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $87c2a74187854fda$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $87c2a74187854fda$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $87c2a74187854fda$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $87c2a74187854fda$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $87c2a74187854fda$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $87c2a74187854fda$var$emptyRect;
    var styles = $87c2a74187854fda$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $87c2a74187854fda$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $87c2a74187854fda$var$toFloat(styles.width), height = $87c2a74187854fda$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $87c2a74187854fda$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $87c2a74187854fda$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$87c2a74187854fda$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $87c2a74187854fda$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $87c2a74187854fda$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $87c2a74187854fda$var$isDocumentElement(target) {
    return target === $87c2a74187854fda$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getContentRect(target) {
    if (!$87c2a74187854fda$var$isBrowser) return $87c2a74187854fda$var$emptyRect;
    if ($87c2a74187854fda$var$isSVGGraphicsElement(target)) return $87c2a74187854fda$var$getSVGContentRect(target);
    return $87c2a74187854fda$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $87c2a74187854fda$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $87c2a74187854fda$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $87c2a74187854fda$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $87c2a74187854fda$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $87c2a74187854fda$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $87c2a74187854fda$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $87c2a74187854fda$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $87c2a74187854fda$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $87c2a74187854fda$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $87c2a74187854fda$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $87c2a74187854fda$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $87c2a74187854fda$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $87c2a74187854fda$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $87c2a74187854fda$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $87c2a74187854fda$var$ResizeObserverController.getInstance();
        var observer = new $87c2a74187854fda$var$ResizeObserverSPI(callback, controller, this);
        $87c2a74187854fda$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $87c2a74187854fda$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $87c2a74187854fda$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $87c2a74187854fda$var$index = function() {
    // Export existing implementation if available.
    if (typeof $87c2a74187854fda$var$global$1.ResizeObserver !== 'undefined') return $87c2a74187854fda$var$global$1.ResizeObserver;
    return $87c2a74187854fda$var$ResizeObserver;
}();
var $87c2a74187854fda$export$2e2bcd8739ae039 = $87c2a74187854fda$var$index;

});


parcelRegister("aqP1M", function(module, exports) {

var $8R6TE = parcelRequire("8R6TE");
var $7983ea218c17033a$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $7983ea218c17033a$var$obj2mq = function(obj) {
    var mq = '';
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $8R6TE(feature);
        // Add px to dimension features
        if ($7983ea218c17033a$var$isDimension(feature) && typeof value === 'number') value = value + 'px';
        if (value === true) mq += feature;
        else if (value === false) mq += 'not ' + feature;
        else mq += '(' + feature + ': ' + value + ')';
        if (index < features.length - 1) mq += ' and ';
    });
    return mq;
};
var $7983ea218c17033a$var$json2mq = function(query) {
    var mq = '';
    if (typeof query === 'string') return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $7983ea218c17033a$var$obj2mq(q);
            if (index < query.length - 1) mq += ', ';
        });
        return mq;
    }
    // Handling single media query
    return $7983ea218c17033a$var$obj2mq(query);
};
module.exports = $7983ea218c17033a$var$json2mq;

});
parcelRegister("8R6TE", function(module, exports) {
var $67289f82dff91124$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return '-' + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $67289f82dff91124$var$camel2hyphen;

});


parcelRegister("aqoFQ", function(module, exports) {

var $7Jc9x = parcelRequire("7Jc9x");
module.exports = new $7Jc9x();

});
parcelRegister("7Jc9x", function(module, exports) {

var $gSUE9 = parcelRequire("gSUE9");

var $aLVeZ = parcelRequire("aLVeZ");
var $5a0629a9a4bcaa64$var$each = $aLVeZ.each;
var $5a0629a9a4bcaa64$var$isFunction = $aLVeZ.isFunction;
var $5a0629a9a4bcaa64$var$isArray = $aLVeZ.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $5a0629a9a4bcaa64$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error('matchMedia not present, legacy browsers require a polyfill');
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}
$5a0629a9a4bcaa64$var$MediaQueryDispatch.prototype = {
    constructor: $5a0629a9a4bcaa64$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $gSUE9(q, isUnconditional);
        //normalise to object in an array
        if ($5a0629a9a4bcaa64$var$isFunction(options)) options = {
            match: options
        };
        if (!$5a0629a9a4bcaa64$var$isArray(options)) options = [
            options
        ];
        $5a0629a9a4bcaa64$var$each(options, function(handler) {
            if ($5a0629a9a4bcaa64$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $5a0629a9a4bcaa64$var$MediaQueryDispatch;

});
parcelRegister("gSUE9", function(module, exports) {

var $1QiBY = parcelRequire("1QiBY");

var $aLVeZ = parcelRequire("aLVeZ");
var $c4ada158424eea78$require$each = $aLVeZ.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $c4ada158424eea78$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$c4ada158424eea78$var$MediaQuery.prototype = {
    constuctor: $c4ada158424eea78$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function(handler) {
        var qh = new $1QiBY(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function(handler) {
        var handlers = this.handlers;
        $c4ada158424eea78$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function() {
        $c4ada158424eea78$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function() {
        var action = this.matches() ? 'on' : 'off';
        $c4ada158424eea78$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $c4ada158424eea78$var$MediaQuery;

});
parcelRegister("1QiBY", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $1579159c59fb35b0$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$1579159c59fb35b0$var$QueryHandler.prototype = {
    constructor: $1579159c59fb35b0$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $1579159c59fb35b0$var$QueryHandler;

});

parcelRegister("aLVeZ", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $7d7ab203ebe5c001$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $7d7ab203ebe5c001$var$isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $7d7ab203ebe5c001$var$isFunction(target) {
    return typeof target === 'function';
}
module.exports = {
    isFunction: $7d7ab203ebe5c001$var$isFunction,
    isArray: $7d7ab203ebe5c001$var$isArray,
    each: $7d7ab203ebe5c001$var$each
};

});





parcelRegister("bdueI", function(module, exports) {
module.exports = new URL("advisorMatchIcon.cff34b8b.png", import.meta.url).toString();

});

parcelRegister("5jXbT", function(module, exports) {
module.exports = new URL("03.562dab43.png", import.meta.url).toString();

});

parcelRegister("hxcH4", function(module, exports) {
module.exports = new URL("04.7e661983.png", import.meta.url).toString();

});

parcelRegister("23KCH", function(module, exports) {
module.exports = new URL("05.9215b46b.png", import.meta.url).toString();

});

parcelRegister("j1Rr6", function(module, exports) {
module.exports = new URL("06.7c2bf6fe.png", import.meta.url).toString();

});

parcelRegister("httRN", function(module, exports) {
module.exports = new URL("register-ai-left-img.02662144.png", import.meta.url).toString();

});

parcelRegister("aR2xO", function(module, exports) {
module.exports = new URL("completed2minutetest.44c15da7.png", import.meta.url).toString();

});

parcelRegister("l7mJg", function(module, exports) {
module.exports = new URL("diligencePack.bdf36ff5.svg", import.meta.url).toString();

});

parcelRegister("jGyES", function(module, exports) {
module.exports = new URL("researchAidReport.69c50593.svg", import.meta.url).toString();

});

parcelRegister("9SkeM", function(module, exports) {
module.exports = new URL("getPitching.23c227d6.png", import.meta.url).toString();

});

parcelRegister("itXx6", function(module, exports) {
module.exports = new URL("healthboost.4acbcd71.svg", import.meta.url).toString();

});

parcelRegister("kdws4", function(module, exports) {
module.exports = new URL("advisorAssistant.1ba62e4e.svg", import.meta.url).toString();

});

parcelRegister("dCQNv", function(module, exports) {
module.exports = new URL("company-business-lite-1.e4a79cfb.png", import.meta.url).toString();

});

parcelRegister("ltgw0", function(module, exports) {
module.exports = new URL("company-business-lite-2.ba1790b8.png", import.meta.url).toString();

});

parcelRegister("aydTN", function(module, exports) {
module.exports = new URL("company-business-lite-3.8f647840.png", import.meta.url).toString();

});

parcelRegister("gDAuw", function(module, exports) {
module.exports = new URL("company-data-repo-step-1.5524c12f.png", import.meta.url).toString();

});

parcelRegister("2oIlR", function(module, exports) {
module.exports = new URL("company-data-repo-step-2.60f9d368.png", import.meta.url).toString();

});

parcelRegister("fqHfJ", function(module, exports) {
module.exports = new URL("company-data-repo-step-3.6a5bd5c3.png", import.meta.url).toString();

});

parcelRegister("duikr", function(module, exports) {
module.exports = new URL("workflow.feeabd54.svg", import.meta.url).toString();

});

parcelRegister("ZkulW", function(module, exports) {
module.exports = new URL("anylistBuilder.8d13ee90.svg", import.meta.url).toString();

});

parcelRegister("1PiK1", function(module, exports) {
module.exports = new URL("company-anylist-portfoliopro-1.b21e0175.png", import.meta.url).toString();

});

parcelRegister("jcfD1", function(module, exports) {
module.exports = new URL("company-anylist-portfoliopro-2.1210696e.png", import.meta.url).toString();

});

parcelRegister("4CdTy", function(module, exports) {
module.exports = new URL("company-anylist-portfoliopro-3.a7ff48b6.png", import.meta.url).toString();

});

parcelRegister("4tyyd", function(module, exports) {
module.exports = new URL("2-minute-see.6a476637.png", import.meta.url).toString();

});

parcelRegister("4qXP0", function(module, exports) {
module.exports = new URL("company-2-minute-1.acfb7fd5.png", import.meta.url).toString();

});

parcelRegister("6KEUK", function(module, exports) {
module.exports = new URL("company-2-minute-2.d5ff67ec.png", import.meta.url).toString();

});

parcelRegister("5Pn0p", function(module, exports) {
module.exports = new URL("company-2-minute-3.638c540f.png", import.meta.url).toString();

});

parcelRegister("kk8Qe", function(module, exports) {
module.exports = new URL("banner9.247e2587.png", import.meta.url).toString();

});

parcelRegister("bLZ0V", function(module, exports) {
module.exports = new URL("company-kpi-1.12939d27.png", import.meta.url).toString();

});

parcelRegister("k6BF8", function(module, exports) {
module.exports = new URL("company-kpi-2.adc2526b.png", import.meta.url).toString();

});

parcelRegister("l4ysc", function(module, exports) {
module.exports = new URL("company-kpi-3.de62407e.png", import.meta.url).toString();

});

parcelRegister("2mFD2", function(module, exports) {
module.exports = new URL("company-warranty-1.ffe5e830.png", import.meta.url).toString();

});

parcelRegister("ca6j0", function(module, exports) {
module.exports = new URL("company-warranty-2.2294df22.png", import.meta.url).toString();

});

parcelRegister("5fyAg", function(module, exports) {
module.exports = new URL("company-warranty-3.fc158c7c.png", import.meta.url).toString();

});

parcelRegister("5NBD1", function(module, exports) {
module.exports = new URL("company-directors-1.c4338d74.png", import.meta.url).toString();

});

parcelRegister("gw040", function(module, exports) {
module.exports = new URL("company-directors-2.e70c65b3.png", import.meta.url).toString();

});

parcelRegister("77FeN", function(module, exports) {
module.exports = new URL("company-directors-3.dee1732c.png", import.meta.url).toString();

});

parcelRegister("k6VNW", function(module, exports) {
module.exports = new URL("company-diligence-pack-1.d6eecc6b.png", import.meta.url).toString();

});

parcelRegister("3ASou", function(module, exports) {
module.exports = new URL("company-diligence-pack-2.ef5b67b9.png", import.meta.url).toString();

});

parcelRegister("illzP", function(module, exports) {
module.exports = new URL("company-diligence-pack-3.d8ce69f6.png", import.meta.url).toString();

});

parcelRegister("lqLan", function(module, exports) {
module.exports = new URL("iconHealthboost.efa82016.svg", import.meta.url).toString();

});

parcelRegister("76mOo", function(module, exports) {
module.exports = new URL("company-business-1.50298f03.png", import.meta.url).toString();

});

parcelRegister("eDzCn", function(module, exports) {
module.exports = new URL("company-business-2.5930c771.png", import.meta.url).toString();

});

parcelRegister("6yoVR", function(module, exports) {
module.exports = new URL("company-business-3.96c0d145.png", import.meta.url).toString();

});

parcelRegister("dCrgl", function(module, exports) {
module.exports = new URL("company-investor-leads-1.cf92875c.png", import.meta.url).toString();

});

parcelRegister("kGT2Y", function(module, exports) {
module.exports = new URL("company-investor-leads-2.1f66676c.png", import.meta.url).toString();

});

parcelRegister("50m9m", function(module, exports) {
module.exports = new URL("company-investor-leads-3.b42ad3e7.png", import.meta.url).toString();

});

parcelRegister("8DFan", function(module, exports) {
module.exports = new URL("exp-pro-see.5ffda567.png", import.meta.url).toString();

});

parcelRegister("c4Hy6", function(module, exports) {
module.exports = new URL("company-checklist-1.9fad90c0.png", import.meta.url).toString();

});

parcelRegister("kkcIb", function(module, exports) {
module.exports = new URL("company-checklist-2.4d0d293a.png", import.meta.url).toString();

});

parcelRegister("78dFL", function(module, exports) {
module.exports = new URL("company-checklist-3.9d635f40.png", import.meta.url).toString();

});

parcelRegister("5G1H8", function(module, exports) {
module.exports = new URL("abf-step-1.acaf4781.png", import.meta.url).toString();

});

parcelRegister("cO4sV", function(module, exports) {
module.exports = new URL("abf-step-2.7beb209a.png", import.meta.url).toString();

});

parcelRegister("9nX0s", function(module, exports) {
module.exports = new URL("abf-step-3.c1aec23d.png", import.meta.url).toString();

});

parcelRegister("tYq1A", function(module, exports) {
module.exports = new URL("bfs-intro.7ec404bf.png", import.meta.url).toString();

});

parcelRegister("g06LD", function(module, exports) {
module.exports = new URL("step-5-modal-img.6b4263f9.png", import.meta.url).toString();

});

parcelRegister("hlWaF", function(module, exports) {
module.exports = new URL("bfs-step-1.e75a01e4.png", import.meta.url).toString();

});

parcelRegister("iOEPt", function(module, exports) {
module.exports = new URL("bfs-step-2.25238720.png", import.meta.url).toString();

});

parcelRegister("laFXl", function(module, exports) {
module.exports = new URL("bfs-step-3.1631f85f.png", import.meta.url).toString();

});

parcelRegister("dDdZn", function(module, exports) {
module.exports = new URL("bfs-step-4.2acff82b.png", import.meta.url).toString();

});

parcelRegister("apeEM", function(module, exports) {
module.exports = new URL("bfs-step-5.c8212e40.png", import.meta.url).toString();

});

parcelRegister("j0lPb", function(module, exports) {
module.exports = new URL("audit-certfication.b479fc9d.png", import.meta.url).toString();

});

parcelRegister("kWd14", function(module, exports) {
module.exports = new URL("company-pro-plus-1.70ad53ad.png", import.meta.url).toString();

});

parcelRegister("b1C6b", function(module, exports) {
module.exports = new URL("company-pro-plus-2.16cb93a0.png", import.meta.url).toString();

});

parcelRegister("2P7rJ", function(module, exports) {
module.exports = new URL("company-pro-plus-3.eb456d01.png", import.meta.url).toString();

});

parcelRegister("ektZg", function(module, exports) {
module.exports = new URL("trophy-gold.68bd97c8.png", import.meta.url).toString();

});

parcelRegister("3Zw4L", function(module, exports) {
module.exports = new URL("trophy-silver.1449f00b.png", import.meta.url).toString();

});

parcelRegister("7fl4F", function(module, exports) {
module.exports = new URL("trophy-bronze.385d2ebf.png", import.meta.url).toString();

});

parcelRegister("k17d7", function(module, exports) {
module.exports = new URL("trophyNone.d8055f50.png", import.meta.url).toString();

});

parcelRegister("cjM2l", function(module, exports) {
module.exports = new URL("anychecklist-icon.88ed668c.png", import.meta.url).toString();

});

parcelRegister("43Zse", function(module, exports) {
module.exports = new URL("pro-plus-certificate.dc84f147.png", import.meta.url).toString();

});

parcelRegister("cODJZ", function(module, exports) {
module.exports = new URL("partner-tag.ca60df5a.png", import.meta.url).toString();

});

parcelRegister("2fucc", function(module, exports) {
module.exports = new URL("seeCertificate.c213e00f.png", import.meta.url).toString();

});

parcelRegister("4QCMo", function(module, exports) {
module.exports = new URL("noneStar.78265052.png", import.meta.url).toString();

});

parcelRegister("l8qRI", function(module, exports) {
module.exports = new URL("bronzeStar.40d05870.png", import.meta.url).toString();

});

parcelRegister("7RlQ5", function(module, exports) {
module.exports = new URL("silverStar.3d81c4a2.png", import.meta.url).toString();

});

parcelRegister("7Y2KK", function(module, exports) {
module.exports = new URL("goldStar.6be56d8d.png", import.meta.url).toString();

});

parcelRegister("P717a", function(module, exports) {
module.exports = new URL("check1.dec1c35c.svg", import.meta.url).toString();

});

parcelRegister("dRdvp", function(module, exports) {
module.exports = new URL("check.f48b7733.svg", import.meta.url).toString();

});

parcelRegister("dTtgw", function(module, exports) {
module.exports = new URL("certificategirl.4768f788.png", import.meta.url).toString();

});

parcelRegister("3kPLx", function(module, exports) {
module.exports = new URL("allStars.005714bb.png", import.meta.url).toString();

});

parcelRegister("6YRhl", function(module, exports) {
module.exports = new URL("consolidated-document.072520f6.png", import.meta.url).toString();

});

parcelRegister("8LsaC", function(module, exports) {
module.exports = new URL("reports-docs-logo.2b9957a8.png", import.meta.url).toString();

});

parcelRegister("3QPt8", function(module, exports) {
module.exports = new URL("disclaimer-diligence-pack.5c5d1356.png", import.meta.url).toString();

});

parcelRegister("8azsK", function(module, exports) {
module.exports = new URL("value-diligence-logo.19e2cd37.png", import.meta.url).toString();

});

parcelRegister("bjwHv", function(module, exports) {
module.exports = new URL("foundational-diligence-logo.a66598be.png", import.meta.url).toString();

});

parcelRegister("jNDOY", function(module, exports) {
module.exports = new URL("companies-core-house-white-logo.6a5f29e0.png", import.meta.url).toString();

});

parcelRegister("1SlVW", function(module, exports) {
module.exports = new URL("companies-house-text.b8f114bb.png", import.meta.url).toString();

});

parcelRegister("bqQxn", function(module, exports) {
module.exports = new URL("companies-core-house-logo.9eb87fa3.png", import.meta.url).toString();

});

parcelRegister("cjTf7", function(module, exports) {
module.exports = new URL("filinghistory.67b9ab78.png", import.meta.url).toString();

});

parcelRegister("dR1A7", function(module, exports) {
module.exports = new URL("officersavatar.c0c2f526.png", import.meta.url).toString();

});

parcelRegister("6WOfV", function(module, exports) {
module.exports = new URL("three-dot-icon.cb7d2944.png", import.meta.url).toString();

});

parcelRegister("1icau", function(module, exports) {
module.exports = new URL("research-aid-ai.df28eaa3.png", import.meta.url).toString();

});

parcelRegister("5r3ds", function(module, exports) {
module.exports = new URL("research-aid-ai-pro.59b6468d.png", import.meta.url).toString();

});

parcelRegister("5lyHS", function(module, exports) {
module.exports = new URL("research-aid-ai-lite.32c1de61.png", import.meta.url).toString();

});

parcelRegister("1zadQ", function(module, exports) {
module.exports = new URL("2-minute-time.a57e1f73.png", import.meta.url).toString();

});

parcelRegister("8o63N", function(module, exports) {
module.exports = new URL("lock-100-euro.dae829ad.png", import.meta.url).toString();

});

parcelRegister("3ifeb", function(module, exports) {
module.exports = new URL("5-minute-time.fb7b2797.png", import.meta.url).toString();

});

parcelRegister("jF4Gg", function(module, exports) {
module.exports = new URL("7-minute-time.cea202ea.png", import.meta.url).toString();

});

parcelRegister("bZGhT", function(module, exports) {
module.exports = new URL("save-checklist-left-ai.3b3ebc8f.png", import.meta.url).toString();

});

parcelRegister("c9nfY", function(module, exports) {
module.exports = new URL("save-checklist-left-ai.5f9b64aa.png", import.meta.url).toString();

});

parcelRegister("4HKhG", function(module, exports) {
module.exports = new URL("anylist-checklist-step-1.b3a0a640.png", import.meta.url).toString();

});

parcelRegister("30FZJ", function(module, exports) {
module.exports = new URL("anylist-checklist-step-2.e99b0ccc.png", import.meta.url).toString();

});

parcelRegister("hwktJ", function(module, exports) {
module.exports = new URL("anylist-checklist-step-3.f9ef234a.png", import.meta.url).toString();

});

parcelRegister("hJtjK", function(module, exports) {
module.exports = new URL("not-today-bg.113add19.png", import.meta.url).toString();

});

parcelRegister("iF1TY", function(module, exports) {
module.exports = new URL("arrow-back.986a1fdd.png", import.meta.url).toString();

});

parcelRegister("697mI", function(module, exports) {
module.exports = new URL("not-today-icon.ed776476.png", import.meta.url).toString();

});

parcelRegister("93y1O", function(module, exports) {
module.exports = new URL("investor.0d56fe17.png", import.meta.url).toString();

});

parcelRegister("cculX", function(module, exports) {
module.exports = new URL("website.edfd4619.png", import.meta.url).toString();

});

parcelRegister("8pEOX", function(module, exports) {
module.exports = new URL("promptResponse.76341dd4.png", import.meta.url).toString();

});

parcelRegister("dzNWB", function(module, exports) {
module.exports = new URL("report.6442c685.png", import.meta.url).toString();

});

parcelRegister("bnIhg", function(module, exports) {
module.exports = new URL("contactInvestor.bad2448f.png", import.meta.url).toString();

});

parcelRegister("2kqd2", function(module, exports) {
module.exports = new URL("dateContacted.b8ac0753.png", import.meta.url).toString();

});

parcelRegister("esenB", function(module, exports) {
module.exports = new URL("status.beee6726.png", import.meta.url).toString();

});

parcelRegister("eaAwo", function(module, exports) {
module.exports = new URL("archieve.f54ca4fe.png", import.meta.url).toString();

});

parcelRegister("9J5Dz", function(module, exports) {
module.exports = new URL("info.3e76cf88.png", import.meta.url).toString();

});

parcelRegister("bIdNX", function(module, exports) {
module.exports = new URL("gold.3094ba07.png", import.meta.url).toString();

});

parcelRegister("7dxat", function(module, exports) {
module.exports = new URL("proInfo.f27d8857.png", import.meta.url).toString();

});

parcelRegister("8RPC6", function(module, exports) {
module.exports = new URL("thecfocenter.79002a77.png", import.meta.url).toString();

});

parcelRegister("cBcFJ", function(module, exports) {
module.exports = new URL("cfo-center.5f399010.png", import.meta.url).toString();

});

parcelRegister("5xUdw", function(module, exports) {
module.exports = new URL("research-report-header-bg.c9a5834e.jpg", import.meta.url).toString();

});

parcelRegister("ayytt", function(module, exports) {
module.exports = new URL("four-steps.0376d199.png", import.meta.url).toString();

});

parcelRegister("7UE16", function(module, exports) {
module.exports = new URL("first-time-repository-1.d58c3861.png", import.meta.url).toString();

});

parcelRegister("coXQs", function(module, exports) {
module.exports = new URL("first-time-repository-2.c1b07c16.png", import.meta.url).toString();

});

parcelRegister("1gvNG", function(module, exports) {
module.exports = new URL("first-time-repository-3.40bcf824.png", import.meta.url).toString();

});

parcelRegister("iCdyZ", function(module, exports) {
module.exports = new URL("first-time-repository-4.d446a272.png", import.meta.url).toString();

});

parcelRegister("2SkE2", function(module, exports) {
module.exports = new URL("telephone.facb5295.png", import.meta.url).toString();

});

parcelRegister("n3TJI", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $04552c275ef79ab8$require$Buffer = $6ZWSX.Buffer;










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = root.pdfjsLib = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = typeof $hPtJY === "object" && $hPtJY + "" === "[object process]" && !$hPtJY.versions.nw && !($hPtJY.versions.electron && $hPtJY.type && $hPtJY.type !== "browser");
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url?.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if (dots?.length >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch  {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch  {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || bytes?.length === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch  {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xEF") {
                        let encoding;
                        if (str[0] === "\xFE" && str[1] === "\xFF") encoding = "utf-16be";
                        else if (str[0] === "\xFF" && str[1] === "\xFE") encoding = "utf-16le";
                        else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v?.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                class PromiseCapability {
                    #settled = false;
                    constructor(){
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                this.#settled = true;
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                this.#settled = true;
                                reject(reason);
                            };
                        });
                    }
                    get settled() {
                        return this.#settled;
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DELAYED_CLEANUP_TIMEOUT = 5000;
                const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src) {
                    if (typeof src === "string" || src instanceof URL) src = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) src = {
                        data: src
                    };
                    if (typeof src !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    const task = new PDFDocumentLoadingTask();
                    const { docId } = task;
                    const url = src.url ? getUrlProp(src.url) : null;
                    const data = src.data ? getDataProp(src.data) : null;
                    const httpHeaders = src.httpHeaders || null;
                    const withCredentials = src.withCredentials === true;
                    const password = src.password ?? null;
                    const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    let worker = src.worker instanceof PDFWorker ? src.worker : null;
                    const verbosity = src.verbosity;
                    const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                    const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                    const cMapPacked = src.cMapPacked !== false;
                    const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                    const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                    const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    const ignoreErrors = src.stopAtErrors !== true;
                    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                    const isEvalSupported = src.isEvalSupported !== false;
                    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                    const fontExtraProperties = src.fontExtraProperties === true;
                    const enableXfa = src.enableXfa === true;
                    const ownerDocument = src.ownerDocument || globalThis.document;
                    const disableRange = src.disableRange === true;
                    const disableStream = src.disableStream === true;
                    const disableAutoFetch = src.disableAutoFetch === true;
                    const pdfBug = src.pdfBug === true;
                    const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
                    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                    const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument
                    });
                    const filterFactory = src.filterFactory || new DefaultFilterFactory({
                        docId: docId,
                        ownerDocument: ownerDocument
                    });
                    const styleElement = null;
                    (0, _util.setVerbosityLevel)(verbosity);
                    const transportFactory = {
                        canvasFactory: canvasFactory,
                        filterFactory: filterFactory
                    };
                    if (!useWorkerFetch) {
                        transportFactory.cMapReaderFactory = new CMapReaderFactory({
                            baseUrl: cMapUrl,
                            isCompressed: cMapPacked
                        });
                        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                            baseUrl: standardFontDataUrl
                        });
                    }
                    if (!worker) {
                        const workerParams = {
                            verbosity: verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    const fetchDocParams = {
                        docId: docId,
                        apiVersion: '3.11.174',
                        data: data,
                        password: password,
                        disableAutoFetch: disableAutoFetch,
                        rangeChunkSize: rangeChunkSize,
                        length: length,
                        docBaseUrl: docBaseUrl,
                        enableXfa: enableXfa,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize,
                            disableFontFace: disableFontFace,
                            ignoreErrors: ignoreErrors,
                            isEvalSupported: isEvalSupported,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
                            fontExtraProperties: fontExtraProperties,
                            useSystemFonts: useSystemFonts,
                            cMapUrl: useWorkerFetch ? cMapUrl : null,
                            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                        }
                    };
                    const transportParams = {
                        ignoreErrors: ignoreErrors,
                        isEvalSupported: isEvalSupported,
                        disableFontFace: disableFontFace,
                        fontExtraProperties: fontExtraProperties,
                        enableXfa: enableXfa,
                        ownerDocument: ownerDocument,
                        disableAutoFetch: disableAutoFetch,
                        pdfBug: pdfBug,
                        styleElement: styleElement
                    };
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise = _fetchDocument(worker, fetchDocParams);
                        const networkStreamPromise = new Promise(function(resolve) {
                            let networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: length,
                                initialData: rangeTransport.initialData,
                                progressiveDone: rangeTransport.progressiveDone,
                                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                                disableRange: disableRange,
                                disableStream: disableStream
                            }, rangeTransport);
                            else if (!data) {
                                const createPDFNetworkStream = (params)=>{
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params);
                                    return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                                };
                                networkStream = createPDFNetworkStream({
                                    url: url,
                                    length: length,
                                    httpHeaders: httpHeaders,
                                    withCredentials: withCredentials,
                                    rangeChunkSize: rangeChunkSize,
                                    disableRange: disableRange,
                                    disableStream: disableStream
                                });
                            }
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function([workerId, networkStream]) {
                            if (task.destroyed) throw new Error("Loading aborted");
                            const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    }).catch(task._capability.reject);
                    return task;
                }
                async function _fetchDocument(worker, source) {
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    const workerId = await worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [
                        source.data.buffer
                    ] : null);
                    if (worker.destroyed) throw new Error("Worker was destroyed");
                    return workerId;
                }
                function getUrlProp(val) {
                    if (val instanceof URL) return val.href;
                    try {
                        return new URL(val, window.location).href;
                    } catch  {
                        if (_util.isNodeJS && typeof val === "string") return val;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val) {
                    if (_util.isNodeJS && typeof $04552c275ef79ab8$require$Buffer !== "undefined" && val instanceof $04552c275ef79ab8$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
                    if (typeof val === "string") return (0, _util.stringToBytes)(val);
                    if (typeof val === "object" && !isNaN(val?.length) || (0, _util.isArrayBuffer)(val)) return new Uint8Array(val);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                class PDFDocumentLoadingTask {
                    static #docId = 0;
                    constructor(){
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    async destroy() {
                        this.destroyed = true;
                        try {
                            if (this._worker?.port) this._worker._pendingDestroy = true;
                            await this._transport?.destroy();
                        } catch (ex) {
                            if (this._worker?.port) delete this._worker._pendingDestroy;
                            throw ex;
                        }
                        this._transport = null;
                        if (this._worker) {
                            this._worker.destroy();
                            this._worker = null;
                        }
                    }
                }
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                class PDFDataRangeTransport {
                    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                    addRangeListener(listener) {
                        this._rangeListeners.push(listener);
                    }
                    addProgressListener(listener) {
                        this._progressListeners.push(listener);
                    }
                    addProgressiveReadListener(listener) {
                        this._progressiveReadListeners.push(listener);
                    }
                    addProgressiveDoneListener(listener) {
                        this._progressiveDoneListeners.push(listener);
                    }
                    onDataRange(begin, chunk) {
                        for (const listener of this._rangeListeners)listener(begin, chunk);
                    }
                    onDataProgress(loaded, total) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressListeners)listener(loaded, total);
                        });
                    }
                    onDataProgressiveRead(chunk) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveReadListeners)listener(chunk);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveDoneListeners)listener();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin, end) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    constructor(pdfInfo, transport){
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "getJavaScript", {
                            value: ()=>{
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return this.getJSActions().then((js)=>{
                                    if (!js) return js;
                                    const jsArr = [];
                                    for(const name in js)jsArr.push(...js[name]);
                                    return jsArr;
                                });
                            }
                        });
                    }
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber) {
                        return this._transport.getPage(pageNumber);
                    }
                    getPageIndex(ref) {
                        return this._transport.getPageIndex(ref);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id) {
                        return this._transport.getDestination(id);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    saveDocument() {
                        return this._transport.saveDocument();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    cleanup(keepLoadedFonts = false) {
                        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                class PDFPageProxy {
                    #delayedCleanupTimeout = null;
                    #pendingCleanup = false;
                    constructor(pageIndex, pageInfo, transport, pdfBug = false){
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale, rotation = this.rotate, offsetX = 0, offsetY = 0, dontFlip = false } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    getAnnotations({ intent = "display" } = {}) {
                        const intentArgs = this._transport.getRenderingIntent(intent);
                        return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                    }
                    getJSActions() {
                        return this._transport.getPageJSActions(this._pageIndex);
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    async getXfa() {
                        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                    }
                    render({ canvasContext, viewport, intent = "display", annotationMode = _util.AnnotationMode.ENABLE, transform = null, background = null, optionalContentConfigPromise = null, annotationCanvasMap = null, pageColors = null, printAnnotationStorage = null }) {
                        this._stats?.time("Overall");
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                        if (!intentState.displayReadyCapability) {
                            intentState.displayReadyCapability = new _util.PromiseCapability();
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        const complete = (error)=>{
                            intentState.renderTasks.delete(internalRenderTask);
                            if (this._maybeCleanupAfterRender || intentPrint) this.#pendingCleanup = true;
                            this.#tryCleanup(!intentPrint);
                            if (error) {
                                internalRenderTask.capability.reject(error);
                                this._abortOperatorList({
                                    intentState: intentState,
                                    reason: error instanceof Error ? error : new Error(error)
                                });
                            } else internalRenderTask.capability.resolve();
                            this._stats?.timeEnd("Rendering");
                            this._stats?.timeEnd("Overall");
                        };
                        const internalRenderTask = new InternalRenderTask({
                            callback: complete,
                            params: {
                                canvasContext: canvasContext,
                                viewport: viewport,
                                transform: transform,
                                background: background
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            annotationCanvasMap: annotationCanvasMap,
                            operatorList: intentState.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: this._transport.canvasFactory,
                            filterFactory: this._transport.filterFactory,
                            useRequestAnimationFrame: !intentPrint,
                            pdfBug: this._pdfBug,
                            pageColors: pageColors
                        });
                        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
                        const renderTask = internalRenderTask.task;
                        Promise.all([
                            intentState.displayReadyCapability.promise,
                            optionalContentConfigPromise
                        ]).then(([transparency, optionalContentConfig])=>{
                            if (this.destroyed) {
                                complete();
                                return;
                            }
                            this._stats?.time("Rendering");
                            internalRenderTask.initializeGraphics({
                                transparency: transparency,
                                optionalContentConfig: optionalContentConfig
                            });
                            internalRenderTask.operatorListChanged();
                        }).catch(complete);
                        return renderTask;
                    }
                    getOperatorList({ intent = "display", annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null } = {}) {
                        function operatorListChanged() {
                            if (intentState.operatorList.lastChunk) {
                                intentState.opListReadCapability.resolve(intentState.operatorList);
                                intentState.renderTasks.delete(opListTask);
                            }
                        }
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        let opListTask;
                        if (!intentState.opListReadCapability) {
                            opListTask = Object.create(null);
                            opListTask.operatorListChanged = operatorListChanged;
                            intentState.opListReadCapability = new _util.PromiseCapability();
                            (intentState.renderTasks ||= new Set()).add(opListTask);
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            this._stats?.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        return intentState.opListReadCapability.promise;
                    }
                    streamTextContent({ includeMarkedContent = false, disableNormalization = false } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            includeMarkedContent: includeMarkedContent === true,
                            disableNormalization: disableNormalization === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                            size (textContent) {
                                return textContent.items.length;
                            }
                        });
                    }
                    getTextContent(params = {}) {
                        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>{
                            return _xfa_text.XfaText.textContent(xfa);
                        });
                        const readableStream = this.streamTextContent(params);
                        return new Promise(function(resolve, reject) {
                            function pump() {
                                reader.read().then(function({ value, done }) {
                                    if (done) {
                                        resolve(textContent);
                                        return;
                                    }
                                    Object.assign(textContent.styles, value.styles);
                                    textContent.items.push(...value.items);
                                    pump();
                                }, reject);
                            }
                            const reader = readableStream.getReader();
                            const textContent = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump();
                        });
                    }
                    getStructTree() {
                        return this._transport.getStructTree(this._pageIndex);
                    }
                    _destroy() {
                        this.destroyed = true;
                        const waitOn = [];
                        for (const intentState of this._intentStates.values()){
                            this._abortOperatorList({
                                intentState: intentState,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intentState.opListReadCapability) continue;
                            for (const internalRenderTask of intentState.renderTasks){
                                waitOn.push(internalRenderTask.completed);
                                internalRenderTask.cancel();
                            }
                        }
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        this.#abortDelayedCleanup();
                        return Promise.all(waitOn);
                    }
                    cleanup(resetStats = false) {
                        this.#pendingCleanup = true;
                        const success = this.#tryCleanup(false);
                        if (resetStats && success) this._stats &&= new _display_utils.StatTimer();
                        return success;
                    }
                    #tryCleanup(delayed = false) {
                        this.#abortDelayedCleanup();
                        if (!this.#pendingCleanup || this.destroyed) return false;
                        if (delayed) {
                            this.#delayedCleanupTimeout = setTimeout(()=>{
                                this.#delayedCleanupTimeout = null;
                                this.#tryCleanup(false);
                            }, DELAYED_CLEANUP_TIMEOUT);
                            return false;
                        }
                        for (const { renderTasks, operatorList } of this._intentStates.values()){
                            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                        }
                        this._intentStates.clear();
                        this.objs.clear();
                        this.#pendingCleanup = false;
                        return true;
                    }
                    #abortDelayedCleanup() {
                        if (this.#delayedCleanupTimeout) {
                            clearTimeout(this.#delayedCleanupTimeout);
                            this.#delayedCleanupTimeout = null;
                        }
                    }
                    _startRenderPage(transparency, cacheKey) {
                        const intentState = this._intentStates.get(cacheKey);
                        if (!intentState) return;
                        this._stats?.timeEnd("Page Request");
                        intentState.displayReadyCapability?.resolve(transparency);
                    }
                    _renderPageChunk(operatorListChunk, intentState) {
                        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
                            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                        }
                        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                        if (operatorListChunk.lastChunk) this.#tryCleanup(true);
                    }
                    _pumpOperatorList({ renderingIntent, cacheKey, annotationStorageSerializable }) {
                        const { map, transfers } = annotationStorageSerializable;
                        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                            pageIndex: this._pageIndex,
                            intent: renderingIntent,
                            cacheKey: cacheKey,
                            annotationStorage: map
                        }, transfers);
                        const reader = readableStream.getReader();
                        const intentState = this._intentStates.get(cacheKey);
                        intentState.streamReader = reader;
                        const pump = ()=>{
                            reader.read().then(({ value, done })=>{
                                if (done) {
                                    intentState.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value, intentState);
                                pump();
                            }, (reason)=>{
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState.operatorList) {
                                    intentState.operatorList.lastChunk = true;
                                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                                    this.#tryCleanup(true);
                                }
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                else throw reason;
                            });
                        };
                        pump();
                    }
                    _abortOperatorList({ intentState, reason, force = false }) {
                        if (!intentState.streamReader) return;
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        if (!force) {
                            if (intentState.renderTasks.size > 0) return;
                            if (reason instanceof _display_utils.RenderingCancelledException) {
                                let delay = RENDERING_CANCELLED_TIMEOUT;
                                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                                    intentState.streamReaderCancelTimeout = null;
                                    this._abortOperatorList({
                                        intentState: intentState,
                                        reason: reason,
                                        force: true
                                    });
                                }, delay);
                                return;
                            }
                        }
                        intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(()=>{});
                        intentState.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
                            this._intentStates.delete(curCacheKey);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                class LoopbackPort {
                    #listeners = new Set();
                    #deferred = Promise.resolve();
                    postMessage(obj, transfer) {
                        const event = {
                            data: structuredClone(obj, transfer ? {
                                transfer: transfer
                            } : null)
                        };
                        this.#deferred.then(()=>{
                            for (const listener of this.#listeners)listener.call(this, event);
                        });
                    }
                    addEventListener(name, listener) {
                        this.#listeners.add(listener);
                    }
                    removeEventListener(name, listener) {
                        this.#listeners.delete(listener);
                    }
                    terminate() {
                        this.#listeners.clear();
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    const pdfjsFilePath = document?.currentScript?.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                    let base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch  {
                        return false;
                    }
                    const other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    const wrapper = `importScripts("${url}");`;
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                class PDFWorker {
                    static #workerPorts;
                    constructor({ name = null, port = null, verbosity = (0, _util.getVerbosityLevel)() } = {}){
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            if (PDFWorker.#workerPorts?.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (PDFWorker.#workerPorts ||= new WeakMap()).set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                    get promise() {
                        return this._readyCapability.promise;
                    }
                    get port() {
                        return this._port;
                    }
                    get messageHandler() {
                        return this._messageHandler;
                    }
                    _initializeFromPort(port) {
                        this._port = port;
                        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                        this._messageHandler.on("ready", function() {});
                        this._readyCapability.resolve();
                        this._messageHandler.send("configure", {
                            verbosity: this.verbosity
                        });
                    }
                    _initialize() {
                        if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                            let { workerSrc } = PDFWorker;
                            try {
                                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                const worker = new Worker(workerSrc);
                                const messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                const terminateEarly = ()=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    messageHandler.destroy();
                                    worker.terminate();
                                    if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                    else this._setupFakeWorker();
                                };
                                const onWorkerError = ()=>{
                                    if (!this._webWorker) terminateEarly();
                                };
                                worker.addEventListener("error", onWorkerError);
                                messageHandler.on("test", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    if (data) {
                                        this._messageHandler = messageHandler;
                                        this._port = worker;
                                        this._webWorker = worker;
                                        this._readyCapability.resolve();
                                        messageHandler.send("configure", {
                                            verbosity: this.verbosity
                                        });
                                    } else {
                                        this._setupFakeWorker();
                                        messageHandler.destroy();
                                        worker.terminate();
                                    }
                                });
                                messageHandler.on("ready", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    try {
                                        sendTest();
                                    } catch  {
                                        this._setupFakeWorker();
                                    }
                                });
                                const sendTest = ()=>{
                                    const testObj = new Uint8Array();
                                    messageHandler.send("test", testObj, [
                                        testObj.buffer
                                    ]);
                                };
                                sendTest();
                                return;
                            } catch  {
                                (0, _util.info)("The worker has been disabled.");
                            }
                        }
                        this._setupFakeWorker();
                    }
                    _setupFakeWorker() {
                        if (!PDFWorkerUtil.isWorkerDisabled) {
                            (0, _util.warn)("Setting up fake worker.");
                            PDFWorkerUtil.isWorkerDisabled = true;
                        }
                        PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
                            if (this.destroyed) {
                                this._readyCapability.reject(new Error("Worker was destroyed"));
                                return;
                            }
                            const port = new LoopbackPort();
                            this._port = port;
                            const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                            const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                            WorkerMessageHandler.setup(workerHandler, port);
                            const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                            this._messageHandler = messageHandler;
                            this._readyCapability.resolve();
                            messageHandler.send("configure", {
                                verbosity: this.verbosity
                            });
                        }).catch((reason)=>{
                            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                        });
                    }
                    destroy() {
                        this.destroyed = true;
                        if (this._webWorker) {
                            this._webWorker.terminate();
                            this._webWorker = null;
                        }
                        PDFWorker.#workerPorts?.delete(this._port);
                        this._port = null;
                        if (this._messageHandler) {
                            this._messageHandler.destroy();
                            this._messageHandler = null;
                        }
                    }
                    static fromPort(params) {
                        if (!params?.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
                        const cachedPort = this.#workerPorts?.get(params.port);
                        if (cachedPort) {
                            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                            return cachedPort;
                        }
                        return new PDFWorker(params);
                    }
                    static get workerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                            if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return PDFWorkerUtil.fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    static get _mainThreadWorkerMessageHandler() {
                        try {
                            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
                        } catch  {
                            return null;
                        }
                    }
                    static get _setupFakeWorkerGlobal() {
                        const loader = async ()=>{
                            const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                            if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                            if (_util.isNodeJS && true) {
                                const worker = eval("require")(this.workerSrc);
                                return worker.WorkerMessageHandler;
                            }
                            await (0, _display_utils.loadScript)(this.workerSrc);
                            return window.pdfjsWorker.WorkerMessageHandler;
                        };
                        return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                    }
                }
                exports.PDFWorker = PDFWorker;
                class WorkerTransport {
                    #methodPromises = new Map();
                    #pageCache = new Map();
                    #pagePromises = new Map();
                    #passwordCapability = null;
                    constructor(messageHandler, loadingTask, networkStream, params, factory){
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        this.canvasFactory = factory.canvasFactory;
                        this.filterFactory = factory.filterFactory;
                        this.cMapReaderFactory = factory.cMapReaderFactory;
                        this.standardFontDataFactory = factory.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                    #cacheSimpleMethod(name, data = null) {
                        const cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, data);
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                        let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                        let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                        switch(intent){
                            case "any":
                                renderingIntent = _util.RenderingIntentFlag.ANY;
                                break;
                            case "display":
                                break;
                            case "print":
                                renderingIntent = _util.RenderingIntentFlag.PRINT;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                        }
                        switch(annotationMode){
                            case _util.AnnotationMode.DISABLE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                break;
                            case _util.AnnotationMode.ENABLE:
                                break;
                            case _util.AnnotationMode.ENABLE_FORMS:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                break;
                            case _util.AnnotationMode.ENABLE_STORAGE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                                annotationStorageSerializable = annotationStorage.serializable;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                        }
                        if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                        return {
                            renderingIntent: renderingIntent,
                            cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                            annotationStorageSerializable: annotationStorageSerializable
                        };
                    }
                    destroy() {
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = new _util.PromiseCapability();
                        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn = [];
                        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
                        this.#pageCache.clear();
                        this.#pagePromises.clear();
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn.push(terminated);
                        Promise.all(waitOn).then(()=>{
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            this.#methodPromises.clear();
                            this.filterFactory.destroy();
                            this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler, loadingTask } = this;
                        messageHandler.on("GetReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt)=>{
                                this._lastProgress = {
                                    loaded: evt.loaded,
                                    total: evt.total
                                };
                            };
                            sink.onPull = ()=>{
                                this._fullReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                this._fullReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("ReaderHeadersReady", (data)=>{
                            const headersCapability = new _util.PromiseCapability();
                            const fullReader = this._fullReader;
                            fullReader.headersReady.then(()=>{
                                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                    if (this._lastProgress) loadingTask.onProgress?.(this._lastProgress);
                                    fullReader.onProgress = (evt)=>{
                                        loadingTask.onProgress?.({
                                            loaded: evt.loaded,
                                            total: evt.total
                                        });
                                    };
                                }
                                headersCapability.resolve({
                                    isStreamingSupported: fullReader.isStreamingSupported,
                                    isRangeSupported: fullReader.isRangeSupported,
                                    contentLength: fullReader.contentLength
                                });
                            }, headersCapability.reject);
                            return headersCapability.promise;
                        });
                        messageHandler.on("GetRangeReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
                            if (!rangeReader) {
                                sink.close();
                                return;
                            }
                            sink.onPull = ()=>{
                                rangeReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                rangeReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("GetDoc", ({ pdfInfo })=>{
                            this._numPages = pdfInfo.numPages;
                            this._htmlForXfa = pdfInfo.htmlForXfa;
                            delete pdfInfo.htmlForXfa;
                            loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                        });
                        messageHandler.on("DocException", function(ex) {
                            let reason;
                            switch(ex.name){
                                case "PasswordException":
                                    reason = new _util.PasswordException(ex.message, ex.code);
                                    break;
                                case "InvalidPDFException":
                                    reason = new _util.InvalidPDFException(ex.message);
                                    break;
                                case "MissingPDFException":
                                    reason = new _util.MissingPDFException(ex.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                    break;
                                case "UnknownErrorException":
                                    reason = new _util.UnknownErrorException(ex.message, ex.details);
                                    break;
                                default:
                                    (0, _util.unreachable)("DocException - expected a valid Error.");
                            }
                            loadingTask._capability.reject(reason);
                        });
                        messageHandler.on("PasswordRequest", (exception)=>{
                            this.#passwordCapability = new _util.PromiseCapability();
                            if (loadingTask.onPassword) {
                                const updatePassword = (password)=>{
                                    if (password instanceof Error) this.#passwordCapability.reject(password);
                                    else this.#passwordCapability.resolve({
                                        password: password
                                    });
                                };
                                try {
                                    loadingTask.onPassword(updatePassword, exception.code);
                                } catch (ex) {
                                    this.#passwordCapability.reject(ex);
                                }
                            } else this.#passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                            return this.#passwordCapability.promise;
                        });
                        messageHandler.on("DataLoaded", (data)=>{
                            loadingTask.onProgress?.({
                                loaded: data.length,
                                total: data.length
                            });
                            this.downloadInfoCapability.resolve(data);
                        });
                        messageHandler.on("StartRenderPage", (data)=>{
                            if (this.destroyed) return;
                            const page = this.#pageCache.get(data.pageIndex);
                            page._startRenderPage(data.transparency, data.cacheKey);
                        });
                        messageHandler.on("commonobj", ([id, type, exportedData])=>{
                            if (this.destroyed) return;
                            if (this.commonObjs.has(id)) return;
                            switch(type){
                                case "Font":
                                    const params = this._params;
                                    if ("error" in exportedData) {
                                        const exportedError = exportedData.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError}`);
                                        this.commonObjs.resolve(id, exportedError);
                                        break;
                                    }
                                    const inspectFont = params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                                    const font = new _font_loader.FontFaceObject(exportedData, {
                                        isEvalSupported: params.isEvalSupported,
                                        disableFontFace: params.disableFontFace,
                                        ignoreErrors: params.ignoreErrors,
                                        inspectFont: inspectFont
                                    });
                                    this.fontLoader.bind(font).catch((reason)=>{
                                        return messageHandler.sendWithPromise("FontFallback", {
                                            id: id
                                        });
                                    }).finally(()=>{
                                        if (!params.fontExtraProperties && font.data) font.data = null;
                                        this.commonObjs.resolve(id, font);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                case "Pattern":
                                    this.commonObjs.resolve(id, exportedData);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type}`);
                            }
                        });
                        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
                            if (this.destroyed) return;
                            const pageProxy = this.#pageCache.get(pageIndex);
                            if (pageProxy.objs.has(id)) return;
                            switch(type){
                                case "Image":
                                    pageProxy.objs.resolve(id, imageData);
                                    if (imageData) {
                                        let length;
                                        if (imageData.bitmap) {
                                            const { width, height } = imageData;
                                            length = width * height * 4;
                                        } else length = imageData.data?.length || 0;
                                        if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                                    }
                                    break;
                                case "Pattern":
                                    pageProxy.objs.resolve(id, imageData);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type}`);
                            }
                        });
                        messageHandler.on("DocProgress", (data)=>{
                            if (this.destroyed) return;
                            loadingTask.onProgress?.({
                                loaded: data.loaded,
                                total: data.total
                            });
                        });
                        messageHandler.on("FetchBuiltInCMap", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.cMapReaderFactory.fetch(data);
                        });
                        messageHandler.on("FetchStandardFontData", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.standardFontDataFactory.fetch(data);
                        });
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    saveDocument() {
                        if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        const { map, transfers } = this.annotationStorage.serializable;
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: map,
                            filename: this._fullReader?.filename ?? null
                        }, transfers).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getPage(pageNumber) {
                        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
                        const pageIndex = pageNumber - 1, cachedPromise = this.#pagePromises.get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex
                        }).then((pageInfo)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                            this.#pageCache.set(pageIndex, page);
                            return page;
                        });
                        this.#pagePromises.set(pageIndex, promise);
                        return promise;
                    }
                    getPageIndex(ref) {
                        if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            num: ref.num,
                            gen: ref.gen
                        });
                    }
                    getAnnotations(pageIndex, intent) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex,
                            intent: intent
                        });
                    }
                    getFieldObjects() {
                        return this.#cacheSimpleMethod("GetFieldObjects");
                    }
                    hasJSActions() {
                        return this.#cacheSimpleMethod("HasJSActions");
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id) {
                        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getDocJSActions() {
                        return this.#cacheSimpleMethod("GetDocJSActions");
                    }
                    getPageJSActions(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex
                        });
                    }
                    getStructTree(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results)=>{
                            return new _optional_content_config.OptionalContentConfig(results);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        const name = "GetMetadata", cachedPromise = this.#methodPromises.get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>{
                            return {
                                info: results[0],
                                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                contentDispositionFilename: this._fullReader?.filename ?? null,
                                contentLength: this._fullReader?.contentLength ?? null
                            };
                        });
                        this.#methodPromises.set(name, promise);
                        return promise;
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    async startCleanup(keepLoadedFonts = false) {
                        if (this.destroyed) return;
                        await this.messageHandler.sendWithPromise("Cleanup", null);
                        for (const page of this.#pageCache.values()){
                            const cleanupSuccessful = page.cleanup();
                            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts) this.fontLoader.clear();
                        this.#methodPromises.clear();
                        this.filterFactory.destroy(true);
                    }
                    get loadingParams() {
                        const { disableAutoFetch, enableXfa } = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: disableAutoFetch,
                            enableXfa: enableXfa
                        });
                    }
                }
                class PDFObjects {
                    #objs = Object.create(null);
                    #ensureObj(objId) {
                        return this.#objs[objId] ||= {
                            capability: new _util.PromiseCapability(),
                            data: null
                        };
                    }
                    get(objId, callback = null) {
                        if (callback) {
                            const obj = this.#ensureObj(objId);
                            obj.capability.promise.then(()=>callback(obj.data));
                            return null;
                        }
                        const obj = this.#objs[objId];
                        if (!obj?.capability.settled) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                        return obj.data;
                    }
                    has(objId) {
                        const obj = this.#objs[objId];
                        return obj?.capability.settled || false;
                    }
                    resolve(objId, data = null) {
                        const obj = this.#ensureObj(objId);
                        obj.data = data;
                        obj.capability.resolve();
                    }
                    clear() {
                        for(const objId in this.#objs){
                            const { data } = this.#objs[objId];
                            data?.bitmap?.close();
                        }
                        this.#objs = Object.create(null);
                    }
                }
                class RenderTask {
                    #internalRenderTask = null;
                    constructor(internalRenderTask){
                        this.#internalRenderTask = internalRenderTask;
                        this.onContinue = null;
                    }
                    get promise() {
                        return this.#internalRenderTask.capability.promise;
                    }
                    cancel(extraDelay = 0) {
                        this.#internalRenderTask.cancel(null, extraDelay);
                    }
                    get separateAnnots() {
                        const { separateAnnots } = this.#internalRenderTask.operatorList;
                        if (!separateAnnots) return false;
                        const { annotationCanvasMap } = this.#internalRenderTask;
                        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
                    }
                }
                exports.RenderTask = RenderTask;
                class InternalRenderTask {
                    static #canvasInUse = new WeakSet();
                    constructor({ callback, params, objs, commonObjs, annotationCanvasMap, operatorList, pageIndex, canvasFactory, filterFactory, useRequestAnimationFrame = false, pdfBug = false, pageColors = null }){
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this._pdfBug = pdfBug;
                        this.pageColors = pageColors;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                    get completed() {
                        return this.capability.promise.catch(function() {});
                    }
                    initializeGraphics({ transparency = false, optionalContentConfig }) {
                        if (this.cancelled) return;
                        if (this._canvas) {
                            if (InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                            InternalRenderTask.#canvasInUse.add(this._canvas);
                        }
                        if (this._pdfBug && globalThis.StepperManager?.enabled) {
                            this.stepper = globalThis.StepperManager.create(this._pageIndex);
                            this.stepper.init(this.operatorList);
                            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                        }
                        const { canvasContext, viewport, transform, background } = this.params;
                        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                            optionalContentConfig: optionalContentConfig
                        }, this.annotationCanvasMap, this.pageColors);
                        this.gfx.beginDrawing({
                            transform: transform,
                            viewport: viewport,
                            transparency: transparency,
                            background: background
                        });
                        this.operatorListIdx = 0;
                        this.graphicsReady = true;
                        this.graphicsReadyCallback?.();
                    }
                    cancel(error = null, extraDelay = 0) {
                        this.running = false;
                        this.cancelled = true;
                        this.gfx?.endDrawing();
                        InternalRenderTask.#canvasInUse.delete(this._canvas);
                        this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
                    }
                    operatorListChanged() {
                        if (!this.graphicsReady) {
                            this.graphicsReadyCallback ||= this._continueBound;
                            return;
                        }
                        this.stepper?.updateOperatorList(this.operatorList);
                        if (this.running) return;
                        this._continue();
                    }
                    _continue() {
                        this.running = true;
                        if (this.cancelled) return;
                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                        else this._scheduleNext();
                    }
                    _scheduleNext() {
                        if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                            this._nextBound().catch(this._cancelBound);
                        });
                        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                    }
                    async _next() {
                        if (this.cancelled) return;
                        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                        if (this.operatorListIdx === this.operatorList.argsArray.length) {
                            this.running = false;
                            if (this.operatorList.lastChunk) {
                                this.gfx.endDrawing();
                                InternalRenderTask.#canvasInUse.delete(this._canvas);
                                this.callback();
                            }
                        }
                    }
                }
                const version = '3.11.174';
                exports.version = version;
                const build = 'ce8716743';
                exports.build = build;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _murmurhash = __w_pdfjs_require__(8);
                const SerializableEmpty = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports.SerializableEmpty = SerializableEmpty;
                class AnnotationStorage {
                    #modified = false;
                    #storage = new Map();
                    constructor(){
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                    getValue(key, defaultValue) {
                        const value = this.#storage.get(key);
                        if (value === undefined) return defaultValue;
                        return Object.assign(defaultValue, value);
                    }
                    getRawValue(key) {
                        return this.#storage.get(key);
                    }
                    remove(key) {
                        this.#storage.delete(key);
                        if (this.#storage.size === 0) this.resetModified();
                        if (typeof this.onAnnotationEditor === "function") {
                            for (const value of this.#storage.values()){
                                if (value instanceof _editor.AnnotationEditor) return;
                            }
                            this.onAnnotationEditor(null);
                        }
                    }
                    setValue(key, value) {
                        const obj = this.#storage.get(key);
                        let modified = false;
                        if (obj !== undefined) {
                            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                                modified = true;
                                obj[entry] = val;
                            }
                        } else {
                            modified = true;
                            this.#storage.set(key, value);
                        }
                        if (modified) this.#setModified();
                        if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
                    }
                    has(key) {
                        return this.#storage.has(key);
                    }
                    getAll() {
                        return this.#storage.size > 0 ? (0, _util.objectFromMap)(this.#storage) : null;
                    }
                    setAll(obj) {
                        for (const [key, val] of Object.entries(obj))this.setValue(key, val);
                    }
                    get size() {
                        return this.#storage.size;
                    }
                    #setModified() {
                        if (!this.#modified) {
                            this.#modified = true;
                            if (typeof this.onSetModified === "function") this.onSetModified();
                        }
                    }
                    resetModified() {
                        if (this.#modified) {
                            this.#modified = false;
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get print() {
                        return new PrintAnnotationStorage(this);
                    }
                    get serializable() {
                        if (this.#storage.size === 0) return SerializableEmpty;
                        const map = new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                        const context = Object.create(null);
                        let hasBitmap = false;
                        for (const [key, val] of this.#storage){
                            const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                            if (serialized) {
                                map.set(key, serialized);
                                hash.update(`${key}:${JSON.stringify(serialized)}`);
                                hasBitmap ||= !!serialized.bitmap;
                            }
                        }
                        if (hasBitmap) {
                            for (const value of map.values())if (value.bitmap) transfers.push(value.bitmap);
                        }
                        return map.size > 0 ? {
                            map: map,
                            hash: hash.hexdigest(),
                            transfers: transfers
                        } : SerializableEmpty;
                    }
                }
                exports.AnnotationStorage = AnnotationStorage;
                class PrintAnnotationStorage extends AnnotationStorage {
                    #serializable;
                    constructor(parent){
                        super();
                        const { map, hash, transfers } = parent.serializable;
                        const clone = structuredClone(map, transfers ? {
                            transfer: transfers
                        } : null);
                        this.#serializable = {
                            map: clone,
                            hash: hash,
                            transfers: transfers
                        };
                    }
                    get print() {
                        (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
                    }
                    get serializable() {
                        return this.#serializable;
                    }
                }
                exports.PrintAnnotationStorage = PrintAnnotationStorage;
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditor = void 0;
                var _tools = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class AnnotationEditor {
                    #altText = "";
                    #altTextDecorative = false;
                    #altTextButton = null;
                    #altTextTooltip = null;
                    #altTextTooltipTimeout = null;
                    #keepAspectRatio = false;
                    #resizersDiv = null;
                    #boundFocusin = this.focusin.bind(this);
                    #boundFocusout = this.focusout.bind(this);
                    #hasBeenClicked = false;
                    #isEditing = false;
                    #isInEditMode = false;
                    _initialOptions = Object.create(null);
                    _uiManager = null;
                    _focusEventsAllowed = true;
                    _l10nPromise = null;
                    #isDraggable = false;
                    #zIndex = AnnotationEditor._zIndex++;
                    static _borderLineWidth = -1;
                    static _colorManager = new _tools.ColorManager();
                    static _zIndex = 1;
                    static SMALL_EDITOR_SIZE = 0;
                    constructor(parameters){
                        if (this.constructor === AnnotationEditor) (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters.parent;
                        this.id = parameters.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters.parent.pageIndex;
                        this.name = parameters.name;
                        this.div = null;
                        this._uiManager = parameters.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters.isCentered;
                        this._structTreeParentId = null;
                        const { rotation, rawDims: { pageWidth, pageHeight, pageX, pageY } } = this.parent.viewport;
                        this.rotation = rotation;
                        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth,
                            pageHeight
                        ];
                        this.pageTranslation = [
                            pageX,
                            pageY
                        ];
                        const [width, height] = this.parentDimensions;
                        this.x = parameters.x / width;
                        this.y = parameters.y / height;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                    get editorType() {
                        return Object.getPrototypeOf(this).constructor._type;
                    }
                    static get _defaultLineColor() {
                        return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                    }
                    static deleteAnnotationElement(editor) {
                        const fakeEditor = new FakeEditor({
                            id: editor.parent.getNextId(),
                            parent: editor.parent,
                            uiManager: editor._uiManager
                        });
                        fakeEditor.annotationElementId = editor.annotationElementId;
                        fakeEditor.deleted = true;
                        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                    }
                    static initialize(l10n, options = null) {
                        AnnotationEditor._l10nPromise ||= new Map([
                            "editor_alt_text_button_label",
                            "editor_alt_text_edit_button_label",
                            "editor_alt_text_decorative_tooltip"
                        ].map((str)=>[
                                str,
                                l10n.get(str)
                            ]));
                        if (options?.strings) for (const str of options.strings)AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                        if (AnnotationEditor._borderLineWidth !== -1) return;
                        const style = getComputedStyle(document.documentElement);
                        AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
                    }
                    static updateDefaultParams(_type, _value) {}
                    static get defaultPropertiesToUpdate() {
                        return [];
                    }
                    static isHandlingMimeForPasting(mime) {
                        return false;
                    }
                    static paste(item, parent) {
                        (0, _util.unreachable)("Not implemented");
                    }
                    get propertiesToUpdate() {
                        return [];
                    }
                    get _isDraggable() {
                        return this.#isDraggable;
                    }
                    set _isDraggable(value) {
                        this.#isDraggable = value;
                        this.div?.classList.toggle("draggable", value);
                    }
                    center() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        switch(this.parentRotation){
                            case 90:
                                this.x -= this.height * pageHeight / (pageWidth * 2);
                                this.y += this.width * pageWidth / (pageHeight * 2);
                                break;
                            case 180:
                                this.x += this.width / 2;
                                this.y += this.height / 2;
                                break;
                            case 270:
                                this.x += this.height * pageHeight / (pageWidth * 2);
                                this.y -= this.width * pageWidth / (pageHeight * 2);
                                break;
                            default:
                                this.x -= this.width / 2;
                                this.y -= this.height / 2;
                                break;
                        }
                        this.fixAndSetPosition();
                    }
                    addCommands(params) {
                        this._uiManager.addCommands(params);
                    }
                    get currentLayer() {
                        return this._uiManager.currentLayer;
                    }
                    setInBackground() {
                        this.div.style.zIndex = 0;
                    }
                    setInForeground() {
                        this.div.style.zIndex = this.#zIndex;
                    }
                    setParent(parent) {
                        if (parent !== null) {
                            this.pageIndex = parent.pageIndex;
                            this.pageDimensions = parent.pageDimensions;
                        }
                        this.parent = parent;
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.#hasBeenClicked) this.parent.setSelected(this);
                        else this.#hasBeenClicked = false;
                    }
                    focusout(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!this.isAttachedToDOM) return;
                        const target = event.relatedTarget;
                        if (target?.closest(`#${this.id}`)) return;
                        event.preventDefault();
                        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
                    }
                    commitOrRemove() {
                        if (this.isEmpty()) this.remove();
                        else this.commit();
                    }
                    commit() {
                        this.addToAnnotationStorage();
                    }
                    addToAnnotationStorage() {
                        this._uiManager.addToAnnotationStorage(this);
                    }
                    setAt(x, y, tx, ty) {
                        const [width, height] = this.parentDimensions;
                        [tx, ty] = this.screenToPageTranslation(tx, ty);
                        this.x = (x + tx) / width;
                        this.y = (y + ty) / height;
                        this.fixAndSetPosition();
                    }
                    #translate([width, height], x, y) {
                        [x, y] = this.screenToPageTranslation(x, y);
                        this.x += x / width;
                        this.y += y / height;
                        this.fixAndSetPosition();
                    }
                    translate(x, y) {
                        this.#translate(this.parentDimensions, x, y);
                    }
                    translateInPage(x, y) {
                        this.#translate(this.pageDimensions, x, y);
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    drag(tx, ty) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.x += tx / parentWidth;
                        this.y += ty / parentHeight;
                        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                            const { x, y } = this.div.getBoundingClientRect();
                            if (this.parent.findNewParent(this, x, y)) {
                                this.x -= Math.floor(this.x);
                                this.y -= Math.floor(this.y);
                            }
                        }
                        let { x, y } = this;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        this.div.style.left = `${(100 * x).toFixed(2)}%`;
                        this.div.style.top = `${(100 * y).toFixed(2)}%`;
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    #getBaseTranslation() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const { _borderLineWidth } = AnnotationEditor;
                        const x = _borderLineWidth / parentWidth;
                        const y = _borderLineWidth / parentHeight;
                        switch(this.rotation){
                            case 90:
                                return [
                                    -x,
                                    y
                                ];
                            case 180:
                                return [
                                    x,
                                    y
                                ];
                            case 270:
                                return [
                                    x,
                                    -y
                                ];
                            default:
                                return [
                                    -x,
                                    -y
                                ];
                        }
                    }
                    fixAndSetPosition() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        let { x, y, width, height } = this;
                        width *= pageWidth;
                        height *= pageHeight;
                        x *= pageWidth;
                        y *= pageHeight;
                        switch(this.rotation){
                            case 0:
                                x = Math.max(0, Math.min(pageWidth - width, x));
                                y = Math.max(0, Math.min(pageHeight - height, y));
                                break;
                            case 90:
                                x = Math.max(0, Math.min(pageWidth - height, x));
                                y = Math.min(pageHeight, Math.max(width, y));
                                break;
                            case 180:
                                x = Math.min(pageWidth, Math.max(width, x));
                                y = Math.min(pageHeight, Math.max(height, y));
                                break;
                            case 270:
                                x = Math.min(pageWidth, Math.max(height, x));
                                y = Math.max(0, Math.min(pageHeight - width, y));
                                break;
                        }
                        this.x = x /= pageWidth;
                        this.y = y /= pageHeight;
                        const [bx, by] = this.#getBaseTranslation();
                        x += bx;
                        y += by;
                        const { style } = this.div;
                        style.left = `${(100 * x).toFixed(2)}%`;
                        style.top = `${(100 * y).toFixed(2)}%`;
                        this.moveInDOM();
                    }
                    static #rotatePoint(x, y, angle) {
                        switch(angle){
                            case 90:
                                return [
                                    y,
                                    -x
                                ];
                            case 180:
                                return [
                                    -x,
                                    -y
                                ];
                            case 270:
                                return [
                                    -y,
                                    x
                                ];
                            default:
                                return [
                                    x,
                                    y
                                ];
                        }
                    }
                    screenToPageTranslation(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
                    }
                    pageTranslationToScreen(x, y) {
                        return AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
                    }
                    #getRotationMatrix(rotation) {
                        switch(rotation){
                            case 90:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        -pageWidth / pageHeight,
                                        pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            case 180:
                                return [
                                    -1,
                                    0,
                                    0,
                                    -1
                                ];
                            case 270:
                                {
                                    const [pageWidth, pageHeight] = this.pageDimensions;
                                    return [
                                        0,
                                        pageWidth / pageHeight,
                                        -pageHeight / pageWidth,
                                        0
                                    ];
                                }
                            default:
                                return [
                                    1,
                                    0,
                                    0,
                                    1
                                ];
                        }
                    }
                    get parentScale() {
                        return this._uiManager.viewParameters.realScale;
                    }
                    get parentRotation() {
                        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                    }
                    get parentDimensions() {
                        const { parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
                        const scaledWidth = pageWidth * parentScale;
                        const scaledHeight = pageHeight * parentScale;
                        return _util.FeatureTest.isCSSRoundSupported ? [
                            Math.round(scaledWidth),
                            Math.round(scaledHeight)
                        ] : [
                            scaledWidth,
                            scaledHeight
                        ];
                    }
                    setDims(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio) this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                        this.#altTextButton?.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                    }
                    fixDims() {
                        const { style } = this.div;
                        const { height, width } = style;
                        const widthPercent = width.endsWith("%");
                        const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
                        if (widthPercent && heightPercent) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (!widthPercent) style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                        if (!this.#keepAspectRatio && !heightPercent) style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                    }
                    getInitialTranslation() {
                        return [
                            0,
                            0
                        ];
                    }
                    #createResizers() {
                        if (this.#resizersDiv) return;
                        this.#resizersDiv = document.createElement("div");
                        this.#resizersDiv.classList.add("resizers");
                        const classes = [
                            "topLeft",
                            "topRight",
                            "bottomRight",
                            "bottomLeft"
                        ];
                        if (!this._willKeepAspectRatio) classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                        for (const name of classes){
                            const div = document.createElement("div");
                            this.#resizersDiv.append(div);
                            div.classList.add("resizer", name);
                            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name));
                            div.addEventListener("contextmenu", _display_utils.noContextMenu);
                        }
                        this.div.prepend(this.#resizersDiv);
                    }
                    #resizerPointerdown(name, event) {
                        event.preventDefault();
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
                        const savedDraggable = this._isDraggable;
                        this._isDraggable = false;
                        const pointerMoveOptions = {
                            passive: true,
                            capture: true
                        };
                        window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const savedParentCursor = this.parent.div.style.cursor;
                        const savedCursor = this.div.style.cursor;
                        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                        const pointerUpCallback = ()=>{
                            this._isDraggable = savedDraggable;
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                            this.parent.div.style.cursor = savedParentCursor;
                            this.div.style.cursor = savedCursor;
                            const newX = this.x;
                            const newY = this.y;
                            const newWidth = this.width;
                            const newHeight = this.height;
                            if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
                            this.addCommands({
                                cmd: ()=>{
                                    this.width = newWidth;
                                    this.height = newHeight;
                                    this.x = newX;
                                    this.y = newY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                                    this.fixAndSetPosition();
                                },
                                undo: ()=>{
                                    this.width = savedWidth;
                                    this.height = savedHeight;
                                    this.x = savedX;
                                    this.y = savedY;
                                    const [parentWidth, parentHeight] = this.parentDimensions;
                                    this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                                    this.fixAndSetPosition();
                                },
                                mustExec: true
                            });
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    #resizerPointermove(name, event) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const savedX = this.x;
                        const savedY = this.y;
                        const savedWidth = this.width;
                        const savedHeight = this.height;
                        const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                        const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                        const round = (x)=>Math.round(x * 10000) / 10000;
                        const rotationMatrix = this.#getRotationMatrix(this.rotation);
                        const transf = (x, y)=>[
                                rotationMatrix[0] * x + rotationMatrix[2] * y,
                                rotationMatrix[1] * x + rotationMatrix[3] * y
                            ];
                        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
                        const invTransf = (x, y)=>[
                                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                                invRotationMatrix[1] * x + invRotationMatrix[3] * y
                            ];
                        let getPoint;
                        let getOpposite;
                        let isDiagonal = false;
                        let isHorizontal = false;
                        switch(name){
                            case "topLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h
                                    ];
                                break;
                            case "topMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                break;
                            case "topRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        0
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h
                                    ];
                                break;
                            case "middleRight":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                break;
                            case "bottomRight":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        w,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        0,
                                        0
                                    ];
                                break;
                            case "bottomMiddle":
                                getPoint = (w, h)=>[
                                        w / 2,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w / 2,
                                        0
                                    ];
                                break;
                            case "bottomLeft":
                                isDiagonal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        0
                                    ];
                                break;
                            case "middleLeft":
                                isHorizontal = true;
                                getPoint = (w, h)=>[
                                        0,
                                        h / 2
                                    ];
                                getOpposite = (w, h)=>[
                                        w,
                                        h / 2
                                    ];
                                break;
                        }
                        const point = getPoint(savedWidth, savedHeight);
                        const oppositePoint = getOpposite(savedWidth, savedHeight);
                        let transfOppositePoint = transf(...oppositePoint);
                        const oppositeX = round(savedX + transfOppositePoint[0]);
                        const oppositeY = round(savedY + transfOppositePoint[1]);
                        let ratioX = 1;
                        let ratioY = 1;
                        let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
                        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
                        if (isDiagonal) {
                            const oldDiag = Math.hypot(savedWidth, savedHeight);
                            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                        } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                        else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                        const newWidth = round(savedWidth * ratioX);
                        const newHeight = round(savedHeight * ratioY);
                        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
                        const newX = oppositeX - transfOppositePoint[0];
                        const newY = oppositeY - transfOppositePoint[1];
                        this.width = newWidth;
                        this.height = newHeight;
                        this.x = newX;
                        this.y = newY;
                        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                        this.fixAndSetPosition();
                    }
                    async addAltTextButton() {
                        if (this.#altTextButton) return;
                        const altText = this.#altTextButton = document.createElement("button");
                        altText.className = "altText";
                        const msg = await AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                        altText.textContent = msg;
                        altText.setAttribute("aria-label", msg);
                        altText.tabIndex = "0";
                        altText.addEventListener("contextmenu", _display_utils.noContextMenu);
                        altText.addEventListener("pointerdown", (event)=>event.stopPropagation());
                        altText.addEventListener("click", (event)=>{
                            event.preventDefault();
                            this._uiManager.editAltText(this);
                        }, {
                            capture: true
                        });
                        altText.addEventListener("keydown", (event)=>{
                            if (event.target === altText && event.key === "Enter") {
                                event.preventDefault();
                                this._uiManager.editAltText(this);
                            }
                        });
                        this.#setAltTextButtonState();
                        this.div.append(altText);
                        if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                            const PERCENT = 40;
                            AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                        }
                    }
                    async #setAltTextButtonState() {
                        const button = this.#altTextButton;
                        if (!button) return;
                        if (!this.#altText && !this.#altTextDecorative) {
                            button.classList.remove("done");
                            this.#altTextTooltip?.remove();
                            return;
                        }
                        AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg)=>{
                            button.setAttribute("aria-label", msg);
                        });
                        let tooltip = this.#altTextTooltip;
                        if (!tooltip) {
                            this.#altTextTooltip = tooltip = document.createElement("span");
                            tooltip.className = "tooltip";
                            tooltip.setAttribute("role", "tooltip");
                            const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                            button.setAttribute("aria-describedby", id);
                            const DELAY_TO_SHOW_TOOLTIP = 100;
                            button.addEventListener("mouseenter", ()=>{
                                this.#altTextTooltipTimeout = setTimeout(()=>{
                                    this.#altTextTooltipTimeout = null;
                                    this.#altTextTooltip.classList.add("show");
                                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            subtype: this.editorType,
                                            data: {
                                                action: "alt_text_tooltip"
                                            }
                                        }
                                    });
                                }, DELAY_TO_SHOW_TOOLTIP);
                            });
                            button.addEventListener("mouseleave", ()=>{
                                clearTimeout(this.#altTextTooltipTimeout);
                                this.#altTextTooltipTimeout = null;
                                this.#altTextTooltip?.classList.remove("show");
                            });
                        }
                        button.classList.add("done");
                        tooltip.innerText = this.#altTextDecorative ? await AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
                        if (!tooltip.parentNode) button.append(tooltip);
                    }
                    getClientDimensions() {
                        return this.div.getBoundingClientRect();
                    }
                    get altTextData() {
                        return {
                            altText: this.#altText,
                            decorative: this.#altTextDecorative
                        };
                    }
                    set altTextData({ altText, decorative }) {
                        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
                        this.#altText = altText;
                        this.#altTextDecorative = decorative;
                        this.#setAltTextButtonState();
                    }
                    render() {
                        this.div = document.createElement("div");
                        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                        this.div.className = this.name;
                        this.div.setAttribute("id", this.id);
                        this.div.setAttribute("tabIndex", 0);
                        this.setInForeground();
                        this.div.addEventListener("focusin", this.#boundFocusin);
                        this.div.addEventListener("focusout", this.#boundFocusout);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (this.parentRotation % 180 !== 0) {
                            this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                            this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                        }
                        const [tx, ty] = this.getInitialTranslation();
                        this.translate(tx, ty);
                        (0, _tools.bindEvents)(this, this.div, [
                            "pointerdown"
                        ]);
                        return this.div;
                    }
                    pointerdown(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) {
                            event.preventDefault();
                            return;
                        }
                        this.#hasBeenClicked = true;
                        this.#setUpDragSession(event);
                    }
                    #setUpDragSession(event) {
                        if (!this._isDraggable) return;
                        const isSelected = this._uiManager.isSelected(this);
                        this._uiManager.setUpDragSession();
                        let pointerMoveOptions, pointerMoveCallback;
                        if (isSelected) {
                            pointerMoveOptions = {
                                passive: true,
                                capture: true
                            };
                            pointerMoveCallback = (e)=>{
                                const [tx, ty] = this.screenToPageTranslation(e.movementX, e.movementY);
                                this._uiManager.dragSelectedEditors(tx, ty);
                            };
                            window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                        }
                        const pointerUpCallback = ()=>{
                            window.removeEventListener("pointerup", pointerUpCallback);
                            window.removeEventListener("blur", pointerUpCallback);
                            if (isSelected) window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                            this.#hasBeenClicked = false;
                            if (!this._uiManager.endDragSession()) {
                                const { isMac } = _util.FeatureTest.platform;
                                if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
                                else this.parent.setSelected(this);
                            }
                        };
                        window.addEventListener("pointerup", pointerUpCallback);
                        window.addEventListener("blur", pointerUpCallback);
                    }
                    moveInDOM() {
                        this.parent?.moveEditorInDOM(this);
                    }
                    _setParentAndPosition(parent, x, y) {
                        parent.changeParent(this);
                        this.x = x;
                        this.y = y;
                        this.fixAndSetPosition();
                    }
                    getRect(tx, ty) {
                        const scale = this.parentScale;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const [pageX, pageY] = this.pageTranslation;
                        const shiftX = tx / scale;
                        const shiftY = ty / scale;
                        const x = this.x * pageWidth;
                        const y = this.y * pageHeight;
                        const width = this.width * pageWidth;
                        const height = this.height * pageHeight;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x + shiftX + pageX,
                                    pageHeight - y - shiftY - height + pageY,
                                    x + shiftX + width + pageX,
                                    pageHeight - y - shiftY + pageY
                                ];
                            case 90:
                                return [
                                    x + shiftY + pageX,
                                    pageHeight - y + shiftX + pageY,
                                    x + shiftY + height + pageX,
                                    pageHeight - y + shiftX + width + pageY
                                ];
                            case 180:
                                return [
                                    x - shiftX - width + pageX,
                                    pageHeight - y + shiftY + pageY,
                                    x - shiftX + pageX,
                                    pageHeight - y + shiftY + height + pageY
                                ];
                            case 270:
                                return [
                                    x - shiftY - height + pageX,
                                    pageHeight - y - shiftX - width + pageY,
                                    x - shiftY + pageX,
                                    pageHeight - y - shiftX + pageY
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    getRectInCurrentCoords(rect, pageHeight) {
                        const [x1, y1, x2, y2] = rect;
                        const width = x2 - x1;
                        const height = y2 - y1;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x1,
                                    pageHeight - y2,
                                    width,
                                    height
                                ];
                            case 90:
                                return [
                                    x1,
                                    pageHeight - y1,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    x2,
                                    pageHeight - y1,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    x2,
                                    pageHeight - y2,
                                    height,
                                    width
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    onceAdded() {}
                    isEmpty() {
                        return false;
                    }
                    enableEditMode() {
                        this.#isInEditMode = true;
                    }
                    disableEditMode() {
                        this.#isInEditMode = false;
                    }
                    isInEditMode() {
                        return this.#isInEditMode;
                    }
                    shouldGetKeyboardEvents() {
                        return false;
                    }
                    needsToBeRebuilt() {
                        return this.div && !this.isAttachedToDOM;
                    }
                    rebuild() {
                        this.div?.addEventListener("focusin", this.#boundFocusin);
                        this.div?.addEventListener("focusout", this.#boundFocusout);
                    }
                    serialize(isForCopying = false, context = null) {
                        (0, _util.unreachable)("An editor must be serializable");
                    }
                    static deserialize(data, parent, uiManager) {
                        const editor = new this.prototype.constructor({
                            parent: parent,
                            id: parent.getNextId(),
                            uiManager: uiManager
                        });
                        editor.rotation = data.rotation;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
                        editor.x = x / pageWidth;
                        editor.y = y / pageHeight;
                        editor.width = width / pageWidth;
                        editor.height = height / pageHeight;
                        return editor;
                    }
                    remove() {
                        this.div.removeEventListener("focusin", this.#boundFocusin);
                        this.div.removeEventListener("focusout", this.#boundFocusout);
                        if (!this.isEmpty()) this.commit();
                        if (this.parent) this.parent.remove(this);
                        else this._uiManager.removeEditor(this);
                        this.#altTextButton?.remove();
                        this.#altTextButton = null;
                        this.#altTextTooltip = null;
                    }
                    get isResizable() {
                        return false;
                    }
                    makeResizable() {
                        if (this.isResizable) {
                            this.#createResizers();
                            this.#resizersDiv.classList.remove("hidden");
                        }
                    }
                    select() {
                        this.makeResizable();
                        this.div?.classList.add("selectedEditor");
                    }
                    unselect() {
                        this.#resizersDiv?.classList.add("hidden");
                        this.div?.classList.remove("selectedEditor");
                        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                    }
                    updateParams(type, value) {}
                    disableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = true;
                    }
                    enableEditing() {
                        if (this.#altTextButton) this.#altTextButton.hidden = false;
                    }
                    enterInEditMode() {}
                    get contentDiv() {
                        return this.div;
                    }
                    get isEditing() {
                        return this.#isEditing;
                    }
                    set isEditing(value) {
                        this.#isEditing = value;
                        if (!this.parent) return;
                        if (value) {
                            this.parent.setSelected(this);
                            this.parent.setActiveEditor(this);
                        } else this.parent.setActiveEditor(null);
                    }
                    setAspectRatio(width, height) {
                        this.#keepAspectRatio = true;
                        const aspectRatio = width / height;
                        const { style } = this.div;
                        style.aspectRatio = aspectRatio;
                        style.height = "auto";
                    }
                    static get MIN_SIZE() {
                        return 16;
                    }
                }
                exports.AnnotationEditor = AnnotationEditor;
                class FakeEditor extends AnnotationEditor {
                    constructor(params){
                        super(params);
                        this.annotationElementId = params.annotationElementId;
                        this.deleted = true;
                    }
                    serialize() {
                        return {
                            id: this.annotationElementId,
                            deleted: true,
                            pageIndex: this.pageIndex
                        };
                    }
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
                exports.bindEvents = bindEvents;
                exports.opacityToHex = opacityToHex;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                function bindEvents(obj, element, names) {
                    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
                }
                function opacityToHex(opacity) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
                }
                class IdManager {
                    #id = 0;
                    getId() {
                        return `${_util.AnnotationEditorPrefix}${this.#id++}`;
                    }
                }
                class ImageManager {
                    #baseId = (0, _util.getUuid)();
                    #id = 0;
                    #cache = null;
                    static get _isSVGFittingCanvas() {
                        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                        const canvas = new OffscreenCanvas(1, 3);
                        const ctx = canvas.getContext("2d");
                        const image = new Image();
                        image.src = svg;
                        const promise = image.decode().then(()=>{
                            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                        });
                        return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
                    }
                    async #get(key, rawData) {
                        this.#cache ||= new Map();
                        let data = this.#cache.get(key);
                        if (data === null) return null;
                        if (data?.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        try {
                            data ||= {
                                bitmap: null,
                                id: `image_${this.#baseId}_${this.#id++}`,
                                refCounter: 0,
                                isSvg: false
                            };
                            let image;
                            if (typeof rawData === "string") {
                                data.url = rawData;
                                const response = await fetch(rawData);
                                if (!response.ok) throw new Error(response.statusText);
                                image = await response.blob();
                            } else image = data.file = rawData;
                            if (image.type === "image/svg+xml") {
                                const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                                const fileReader = new FileReader();
                                const imageElement = new Image();
                                const imagePromise = new Promise((resolve, reject)=>{
                                    imageElement.onload = ()=>{
                                        data.bitmap = imageElement;
                                        data.isSvg = true;
                                        resolve();
                                    };
                                    fileReader.onload = async ()=>{
                                        const url = data.svgUrl = fileReader.result;
                                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                                    };
                                    imageElement.onerror = fileReader.onerror = reject;
                                });
                                fileReader.readAsDataURL(image);
                                await imagePromise;
                            } else data.bitmap = await createImageBitmap(image);
                            data.refCounter = 1;
                        } catch (e) {
                            console.error(e);
                            data = null;
                        }
                        this.#cache.set(key, data);
                        if (data) this.#cache.set(data.id, data);
                        return data;
                    }
                    async getFromFile(file) {
                        const { lastModified, name, size, type } = file;
                        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
                    }
                    async getFromUrl(url) {
                        return this.#get(url, url);
                    }
                    async getFromId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return null;
                        if (data.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        if (data.file) return this.getFromFile(data.file);
                        return this.getFromUrl(data.url);
                    }
                    getSvgUrl(id) {
                        const data = this.#cache.get(id);
                        if (!data?.isSvg) return null;
                        return data.svgUrl;
                    }
                    deleteId(id) {
                        this.#cache ||= new Map();
                        const data = this.#cache.get(id);
                        if (!data) return;
                        data.refCounter -= 1;
                        if (data.refCounter !== 0) return;
                        data.bitmap = null;
                    }
                    isValidId(id) {
                        return id.startsWith(`image_${this.#baseId}_`);
                    }
                }
                class CommandManager {
                    #commands = [];
                    #locked = false;
                    #maxSize;
                    #position = -1;
                    constructor(maxSize = 128){
                        this.#maxSize = maxSize;
                    }
                    add({ cmd, undo, mustExec, type = NaN, overwriteIfSameType = false, keepUndo = false }) {
                        if (mustExec) cmd();
                        if (this.#locked) return;
                        const save = {
                            cmd: cmd,
                            undo: undo,
                            type: type
                        };
                        if (this.#position === -1) {
                            if (this.#commands.length > 0) this.#commands.length = 0;
                            this.#position = 0;
                            this.#commands.push(save);
                            return;
                        }
                        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
                            if (keepUndo) save.undo = this.#commands[this.#position].undo;
                            this.#commands[this.#position] = save;
                            return;
                        }
                        const next = this.#position + 1;
                        if (next === this.#maxSize) this.#commands.splice(0, 1);
                        else {
                            this.#position = next;
                            if (next < this.#commands.length) this.#commands.splice(next);
                        }
                        this.#commands.push(save);
                    }
                    undo() {
                        if (this.#position === -1) return;
                        this.#locked = true;
                        this.#commands[this.#position].undo();
                        this.#locked = false;
                        this.#position -= 1;
                    }
                    redo() {
                        if (this.#position < this.#commands.length - 1) {
                            this.#position += 1;
                            this.#locked = true;
                            this.#commands[this.#position].cmd();
                            this.#locked = false;
                        }
                    }
                    hasSomethingToUndo() {
                        return this.#position !== -1;
                    }
                    hasSomethingToRedo() {
                        return this.#position < this.#commands.length - 1;
                    }
                    destroy() {
                        this.#commands = null;
                    }
                }
                exports.CommandManager = CommandManager;
                class KeyboardManager {
                    constructor(callbacks){
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        const { isMac } = _util.FeatureTest.platform;
                        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
                            const isMacKey = key.startsWith("mac+");
                            if (isMac && isMacKey) {
                                this.callbacks.set(key.slice(4), {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            } else if (!isMac && !isMacKey) {
                                this.callbacks.set(key, {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            }
                        }
                    }
                    #serialize(event) {
                        if (event.altKey) this.buffer.push("alt");
                        if (event.ctrlKey) this.buffer.push("ctrl");
                        if (event.metaKey) this.buffer.push("meta");
                        if (event.shiftKey) this.buffer.push("shift");
                        this.buffer.push(event.key);
                        const str = this.buffer.join("+");
                        this.buffer.length = 0;
                        return str;
                    }
                    exec(self, event) {
                        if (!this.allKeys.has(event.key)) return;
                        const info = this.callbacks.get(this.#serialize(event));
                        if (!info) return;
                        const { callback, options: { bubbles = false, args = [], checker = null } } = info;
                        if (checker && !checker(self, event)) return;
                        callback.bind(self, ...args)();
                        if (!bubbles) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }
                }
                exports.KeyboardManager = KeyboardManager;
                class ColorManager {
                    static _colorsMapping = new Map([
                        [
                            "CanvasText",
                            [
                                0,
                                0,
                                0
                            ]
                        ],
                        [
                            "Canvas",
                            [
                                255,
                                255,
                                255
                            ]
                        ]
                    ]);
                    get _colors() {
                        const colors = new Map([
                            [
                                "CanvasText",
                                null
                            ],
                            [
                                "Canvas",
                                null
                            ]
                        ]);
                        (0, _display_utils.getColorValues)(colors);
                        return (0, _util.shadow)(this, "_colors", colors);
                    }
                    convert(color) {
                        const rgb = (0, _display_utils.getRGB)(color);
                        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
                        for (const [name, RGB] of this._colors){
                            if (RGB.every((x, i)=>x === rgb[i])) return ColorManager._colorsMapping.get(name);
                        }
                        return rgb;
                    }
                    getHexCode(name) {
                        const rgb = this._colors.get(name);
                        if (!rgb) return name;
                        return _util.Util.makeHexColor(...rgb);
                    }
                }
                exports.ColorManager = ColorManager;
                class AnnotationEditorUIManager {
                    #activeEditor = null;
                    #allEditors = new Map();
                    #allLayers = new Map();
                    #altTextManager = null;
                    #annotationStorage = null;
                    #commandManager = new CommandManager();
                    #currentPageIndex = 0;
                    #deletedAnnotationsElementIds = new Set();
                    #draggingEditors = null;
                    #editorTypes = null;
                    #editorsToRescale = new Set();
                    #filterFactory = null;
                    #idManager = new IdManager();
                    #isEnabled = false;
                    #isWaiting = false;
                    #lastActiveElement = null;
                    #mode = _util.AnnotationEditorType.NONE;
                    #selectedEditors = new Set();
                    #pageColors = null;
                    #boundBlur = this.blur.bind(this);
                    #boundFocus = this.focus.bind(this);
                    #boundCopy = this.copy.bind(this);
                    #boundCut = this.cut.bind(this);
                    #boundPaste = this.paste.bind(this);
                    #boundKeydown = this.keydown.bind(this);
                    #boundOnEditingAction = this.onEditingAction.bind(this);
                    #boundOnPageChanging = this.onPageChanging.bind(this);
                    #boundOnScaleChanging = this.onScaleChanging.bind(this);
                    #boundOnRotationChanging = this.onRotationChanging.bind(this);
                    #previousStates = {
                        isEditing: false,
                        isEmpty: true,
                        hasSomethingToUndo: false,
                        hasSomethingToRedo: false,
                        hasSelectedEditor: false
                    };
                    #translation = [
                        0,
                        0
                    ];
                    #translationTimeoutId = null;
                    #container = null;
                    #viewer = null;
                    static TRANSLATE_SMALL = 1;
                    static TRANSLATE_BIG = 10;
                    static get _keyboardManager() {
                        const proto = AnnotationEditorUIManager.prototype;
                        const arrowChecker = (self)=>{
                            const { activeElement } = document;
                            return activeElement && self.#container.contains(activeElement) && self.hasSomethingToControl();
                        };
                        const small = this.TRANSLATE_SMALL;
                        const big = this.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([
                            [
                                [
                                    "ctrl+a",
                                    "mac+meta+a"
                                ],
                                proto.selectAll
                            ],
                            [
                                [
                                    "ctrl+z",
                                    "mac+meta+z"
                                ],
                                proto.undo
                            ],
                            [
                                [
                                    "ctrl+y",
                                    "ctrl+shift+z",
                                    "mac+meta+shift+z",
                                    "ctrl+shift+Z",
                                    "mac+meta+shift+Z"
                                ],
                                proto.redo
                            ],
                            [
                                [
                                    "Backspace",
                                    "alt+Backspace",
                                    "ctrl+Backspace",
                                    "shift+Backspace",
                                    "mac+Backspace",
                                    "mac+alt+Backspace",
                                    "mac+ctrl+Backspace",
                                    "Delete",
                                    "ctrl+Delete",
                                    "shift+Delete",
                                    "mac+Delete"
                                ],
                                proto.delete
                            ],
                            [
                                [
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.unselectAll
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors){
                        this.#container = container;
                        this.#viewer = viewer;
                        this.#altTextManager = altTextManager;
                        this._eventBus = eventBus;
                        this._eventBus._on("editingaction", this.#boundOnEditingAction);
                        this._eventBus._on("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
                        this.#annotationStorage = pdfDocument.annotationStorage;
                        this.#filterFactory = pdfDocument.filterFactory;
                        this.#pageColors = pageColors;
                        this.viewParameters = {
                            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                    destroy() {
                        this.#removeKeyboardManager();
                        this.#removeFocusManager();
                        this._eventBus._off("editingaction", this.#boundOnEditingAction);
                        this._eventBus._off("pagechanging", this.#boundOnPageChanging);
                        this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
                        this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
                        for (const layer of this.#allLayers.values())layer.destroy();
                        this.#allLayers.clear();
                        this.#allEditors.clear();
                        this.#editorsToRescale.clear();
                        this.#activeEditor = null;
                        this.#selectedEditors.clear();
                        this.#commandManager.destroy();
                        this.#altTextManager.destroy();
                    }
                    get hcmFilter() {
                        return (0, _util.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
                    }
                    get direction() {
                        return (0, _util.shadow)(this, "direction", getComputedStyle(this.#container).direction);
                    }
                    editAltText(editor) {
                        this.#altTextManager?.editAltText(this, editor);
                    }
                    onPageChanging({ pageNumber }) {
                        this.#currentPageIndex = pageNumber - 1;
                    }
                    focusMainContainer() {
                        this.#container.focus();
                    }
                    findParent(x, y) {
                        for (const layer of this.#allLayers.values()){
                            const { x: layerX, y: layerY, width, height } = layer.div.getBoundingClientRect();
                            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
                        }
                        return null;
                    }
                    disableUserSelect(value = false) {
                        this.#viewer.classList.toggle("noUserSelect", value);
                    }
                    addShouldRescale(editor) {
                        this.#editorsToRescale.add(editor);
                    }
                    removeShouldRescale(editor) {
                        this.#editorsToRescale.delete(editor);
                    }
                    onScaleChanging({ scale }) {
                        this.commitOrRemove();
                        this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
                        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
                    }
                    onRotationChanging({ pagesRotation }) {
                        this.commitOrRemove();
                        this.viewParameters.rotation = pagesRotation;
                    }
                    addToAnnotationStorage(editor) {
                        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
                    }
                    #addFocusManager() {
                        window.addEventListener("focus", this.#boundFocus);
                        window.addEventListener("blur", this.#boundBlur);
                    }
                    #removeFocusManager() {
                        window.removeEventListener("focus", this.#boundFocus);
                        window.removeEventListener("blur", this.#boundBlur);
                    }
                    blur() {
                        if (!this.hasSelection) return;
                        const { activeElement } = document;
                        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
                            this.#lastActiveElement = [
                                editor,
                                activeElement
                            ];
                            editor._focusEventsAllowed = false;
                            break;
                        }
                    }
                    focus() {
                        if (!this.#lastActiveElement) return;
                        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
                        this.#lastActiveElement = null;
                        lastActiveElement.addEventListener("focusin", ()=>{
                            lastEditor._focusEventsAllowed = true;
                        }, {
                            once: true
                        });
                        lastActiveElement.focus();
                    }
                    #addKeyboardManager() {
                        window.addEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #removeKeyboardManager() {
                        window.removeEventListener("keydown", this.#boundKeydown, {
                            capture: true
                        });
                    }
                    #addCopyPasteListeners() {
                        document.addEventListener("copy", this.#boundCopy);
                        document.addEventListener("cut", this.#boundCut);
                        document.addEventListener("paste", this.#boundPaste);
                    }
                    #removeCopyPasteListeners() {
                        document.removeEventListener("copy", this.#boundCopy);
                        document.removeEventListener("cut", this.#boundCut);
                        document.removeEventListener("paste", this.#boundPaste);
                    }
                    addEditListeners() {
                        this.#addKeyboardManager();
                        this.#addCopyPasteListeners();
                    }
                    removeEditListeners() {
                        this.#removeKeyboardManager();
                        this.#removeCopyPasteListeners();
                    }
                    copy(event) {
                        event.preventDefault();
                        this.#activeEditor?.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [];
                        for (const editor of this.#selectedEditors){
                            const serialized = editor.serialize(true);
                            if (serialized) editors.push(serialized);
                        }
                        if (editors.length === 0) return;
                        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                    }
                    cut(event) {
                        this.copy(event);
                        this.delete();
                    }
                    paste(event) {
                        event.preventDefault();
                        const { clipboardData } = event;
                        for (const item of clipboardData.items){
                            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                                editorType.paste(item, this.currentLayer);
                                return;
                            }
                        }
                        let data = clipboardData.getData("application/pdfjs");
                        if (!data) return;
                        try {
                            data = JSON.parse(data);
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                            return;
                        }
                        if (!Array.isArray(data)) return;
                        this.unselectAll();
                        const layer = this.currentLayer;
                        try {
                            const newEditors = [];
                            for (const editor of data){
                                const deserializedEditor = layer.deserialize(editor);
                                if (!deserializedEditor) return;
                                newEditors.push(deserializedEditor);
                            }
                            const cmd = ()=>{
                                for (const editor of newEditors)this.#addEditorToLayer(editor);
                                this.#selectEditors(newEditors);
                            };
                            const undo = ()=>{
                                for (const editor of newEditors)editor.remove();
                            };
                            this.addCommands({
                                cmd: cmd,
                                undo: undo,
                                mustExec: true
                            });
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                        }
                    }
                    keydown(event) {
                        if (!this.getActive()?.shouldGetKeyboardEvents()) AnnotationEditorUIManager._keyboardManager.exec(this, event);
                    }
                    onEditingAction(details) {
                        if ([
                            "undo",
                            "redo",
                            "delete",
                            "selectAll"
                        ].includes(details.name)) this[details.name]();
                    }
                    #dispatchUpdateStates(details) {
                        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
                        if (hasChanged) this._eventBus.dispatch("annotationeditorstateschanged", {
                            source: this,
                            details: Object.assign(this.#previousStates, details)
                        });
                    }
                    #dispatchUpdateUI(details) {
                        this._eventBus.dispatch("annotationeditorparamschanged", {
                            source: this,
                            details: details
                        });
                    }
                    setEditingState(isEditing) {
                        if (isEditing) {
                            this.#addFocusManager();
                            this.#addKeyboardManager();
                            this.#addCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: this.#mode !== _util.AnnotationEditorType.NONE,
                                isEmpty: this.#isEmpty(),
                                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                                hasSelectedEditor: false
                            });
                        } else {
                            this.#removeFocusManager();
                            this.#removeKeyboardManager();
                            this.#removeCopyPasteListeners();
                            this.#dispatchUpdateStates({
                                isEditing: false
                            });
                            this.disableUserSelect(false);
                        }
                    }
                    registerEditorTypes(types) {
                        if (this.#editorTypes) return;
                        this.#editorTypes = types;
                        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
                    }
                    getId() {
                        return this.#idManager.getId();
                    }
                    get currentLayer() {
                        return this.#allLayers.get(this.#currentPageIndex);
                    }
                    getLayer(pageIndex) {
                        return this.#allLayers.get(pageIndex);
                    }
                    get currentPageIndex() {
                        return this.#currentPageIndex;
                    }
                    addLayer(layer) {
                        this.#allLayers.set(layer.pageIndex, layer);
                        if (this.#isEnabled) layer.enable();
                        else layer.disable();
                    }
                    removeLayer(layer) {
                        this.#allLayers.delete(layer.pageIndex);
                    }
                    updateMode(mode, editId = null) {
                        if (this.#mode === mode) return;
                        this.#mode = mode;
                        if (mode === _util.AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            this.#disableAll();
                            return;
                        }
                        this.setEditingState(true);
                        this.#enableAll();
                        this.unselectAll();
                        for (const layer of this.#allLayers.values())layer.updateMode(mode);
                        if (!editId) return;
                        for (const editor of this.#allEditors.values())if (editor.annotationElementId === editId) {
                            this.setSelected(editor);
                            editor.enterInEditMode();
                            break;
                        }
                    }
                    updateToolbar(mode) {
                        if (mode === this.#mode) return;
                        this._eventBus.dispatch("switchannotationeditormode", {
                            source: this,
                            mode: mode
                        });
                    }
                    updateParams(type, value) {
                        if (!this.#editorTypes) return;
                        if (type === _util.AnnotationEditorParamsType.CREATE) {
                            this.currentLayer.addNewEditor(type);
                            return;
                        }
                        for (const editor of this.#selectedEditors)editor.updateParams(type, value);
                        for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
                    }
                    enableWaiting(mustWait = false) {
                        if (this.#isWaiting === mustWait) return;
                        this.#isWaiting = mustWait;
                        for (const layer of this.#allLayers.values()){
                            if (mustWait) layer.disableClick();
                            else layer.enableClick();
                            layer.div.classList.toggle("waiting", mustWait);
                        }
                    }
                    #enableAll() {
                        if (!this.#isEnabled) {
                            this.#isEnabled = true;
                            for (const layer of this.#allLayers.values())layer.enable();
                        }
                    }
                    #disableAll() {
                        this.unselectAll();
                        if (this.#isEnabled) {
                            this.#isEnabled = false;
                            for (const layer of this.#allLayers.values())layer.disable();
                        }
                    }
                    getEditors(pageIndex) {
                        const editors = [];
                        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) editors.push(editor);
                        return editors;
                    }
                    getEditor(id) {
                        return this.#allEditors.get(id);
                    }
                    addEditor(editor) {
                        this.#allEditors.set(editor.id, editor);
                    }
                    removeEditor(editor) {
                        this.#allEditors.delete(editor.id);
                        this.unselect(editor);
                        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
                    }
                    addDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
                        editor.deleted = true;
                    }
                    isDeletedAnnotationElement(annotationElementId) {
                        return this.#deletedAnnotationsElementIds.has(annotationElementId);
                    }
                    removeDeletedAnnotationElement(editor) {
                        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
                        editor.deleted = false;
                    }
                    #addEditorToLayer(editor) {
                        const layer = this.#allLayers.get(editor.pageIndex);
                        if (layer) layer.addOrRebuild(editor);
                        else this.addEditor(editor);
                    }
                    setActiveEditor(editor) {
                        if (this.#activeEditor === editor) return;
                        this.#activeEditor = editor;
                        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
                    }
                    toggleSelected(editor) {
                        if (this.#selectedEditors.has(editor)) {
                            this.#selectedEditors.delete(editor);
                            editor.unselect();
                            this.#dispatchUpdateStates({
                                hasSelectedEditor: this.hasSelection
                            });
                            return;
                        }
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    setSelected(editor) {
                        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
                        this.#selectedEditors.clear();
                        this.#selectedEditors.add(editor);
                        editor.select();
                        this.#dispatchUpdateUI(editor.propertiesToUpdate);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    isSelected(editor) {
                        return this.#selectedEditors.has(editor);
                    }
                    unselect(editor) {
                        editor.unselect();
                        this.#selectedEditors.delete(editor);
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: this.hasSelection
                        });
                    }
                    get hasSelection() {
                        return this.#selectedEditors.size !== 0;
                    }
                    undo() {
                        this.#commandManager.undo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                            hasSomethingToRedo: true,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    redo() {
                        this.#commandManager.redo();
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                            isEmpty: this.#isEmpty()
                        });
                    }
                    addCommands(params) {
                        this.#commandManager.add(params);
                        this.#dispatchUpdateStates({
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: false,
                            isEmpty: this.#isEmpty()
                        });
                    }
                    #isEmpty() {
                        if (this.#allEditors.size === 0) return true;
                        if (this.#allEditors.size === 1) {
                            for (const editor of this.#allEditors.values())return editor.isEmpty();
                        }
                        return false;
                    }
                    delete() {
                        this.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const cmd = ()=>{
                            for (const editor of editors)editor.remove();
                        };
                        const undo = ()=>{
                            for (const editor of editors)this.#addEditorToLayer(editor);
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    commitOrRemove() {
                        this.#activeEditor?.commitOrRemove();
                    }
                    hasSomethingToControl() {
                        return this.#activeEditor || this.hasSelection;
                    }
                    #selectEditors(editors) {
                        this.#selectedEditors.clear();
                        for (const editor of editors){
                            if (editor.isEmpty()) continue;
                            this.#selectedEditors.add(editor);
                            editor.select();
                        }
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: true
                        });
                    }
                    selectAll() {
                        for (const editor of this.#selectedEditors)editor.commit();
                        this.#selectEditors(this.#allEditors.values());
                    }
                    unselectAll() {
                        if (this.#activeEditor) {
                            this.#activeEditor.commitOrRemove();
                            return;
                        }
                        if (!this.hasSelection) return;
                        for (const editor of this.#selectedEditors)editor.unselect();
                        this.#selectedEditors.clear();
                        this.#dispatchUpdateStates({
                            hasSelectedEditor: false
                        });
                    }
                    translateSelectedEditors(x, y, noCommit = false) {
                        if (!noCommit) this.commitOrRemove();
                        if (!this.hasSelection) return;
                        this.#translation[0] += x;
                        this.#translation[1] += y;
                        const [totalX, totalY] = this.#translation;
                        const editors = [
                            ...this.#selectedEditors
                        ];
                        const TIME_TO_WAIT = 1000;
                        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
                        this.#translationTimeoutId = setTimeout(()=>{
                            this.#translationTimeoutId = null;
                            this.#translation[0] = this.#translation[1] = 0;
                            this.addCommands({
                                cmd: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(totalX, totalY);
                                },
                                undo: ()=>{
                                    for (const editor of editors)if (this.#allEditors.has(editor.id)) editor.translateInPage(-totalX, -totalY);
                                },
                                mustExec: false
                            });
                        }, TIME_TO_WAIT);
                        for (const editor of editors)editor.translateInPage(x, y);
                    }
                    setUpDragSession() {
                        if (!this.hasSelection) return;
                        this.disableUserSelect(true);
                        this.#draggingEditors = new Map();
                        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
                            savedX: editor.x,
                            savedY: editor.y,
                            savedPageIndex: editor.pageIndex,
                            newX: 0,
                            newY: 0,
                            newPageIndex: -1
                        });
                    }
                    endDragSession() {
                        if (!this.#draggingEditors) return false;
                        this.disableUserSelect(false);
                        const map = this.#draggingEditors;
                        this.#draggingEditors = null;
                        let mustBeAddedInUndoStack = false;
                        for (const [{ x, y, pageIndex }, value] of map){
                            value.newX = x;
                            value.newY = y;
                            value.newPageIndex = pageIndex;
                            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
                        }
                        if (!mustBeAddedInUndoStack) return false;
                        const move = (editor, x, y, pageIndex)=>{
                            if (this.#allEditors.has(editor.id)) {
                                const parent = this.#allLayers.get(pageIndex);
                                if (parent) editor._setParentAndPosition(parent, x, y);
                                else {
                                    editor.pageIndex = pageIndex;
                                    editor.x = x;
                                    editor.y = y;
                                }
                            }
                        };
                        this.addCommands({
                            cmd: ()=>{
                                for (const [editor, { newX, newY, newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
                            },
                            undo: ()=>{
                                for (const [editor, { savedX, savedY, savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
                            },
                            mustExec: true
                        });
                        return true;
                    }
                    dragSelectedEditors(tx, ty) {
                        if (!this.#draggingEditors) return;
                        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
                    }
                    rebuild(editor) {
                        if (editor.parent === null) {
                            const parent = this.getLayer(editor.pageIndex);
                            if (parent) {
                                parent.changeParent(editor);
                                parent.addOrRebuild(editor);
                            } else {
                                this.addEditor(editor);
                                this.addToAnnotationStorage(editor);
                                editor.rebuild();
                            }
                        } else editor.parent.addOrRebuild(editor);
                    }
                    isActive(editor) {
                        return this.#activeEditor === editor;
                    }
                    getActive() {
                        return this.#activeEditor;
                    }
                    getMode() {
                        return this.#mode;
                    }
                    get imageManager() {
                        return (0, _util.shadow)(this, "imageManager", new ImageManager());
                    }
                }
                exports.AnnotationEditorUIManager = AnnotationEditorUIManager;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.deprecated = deprecated;
                exports.getColorValues = getColorValues;
                exports.getCurrentTransform = getCurrentTransform;
                exports.getCurrentTransformInverse = getCurrentTransformInverse;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getRGB = getRGB;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                exports.noContextMenu = noContextMenu;
                exports.setLayerDimensions = setLayerDimensions;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const SVG_NS = "http://www.w3.org/2000/svg";
                class PixelsPerInch {
                    static CSS = 96.0;
                    static PDF = 72.0;
                    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
                }
                exports.PixelsPerInch = PixelsPerInch;
                class DOMFilterFactory extends _base_factory.BaseFilterFactory {
                    #_cache;
                    #_defs;
                    #docId;
                    #document;
                    #hcmFilter;
                    #hcmKey;
                    #hcmUrl;
                    #hcmHighlightFilter;
                    #hcmHighlightKey;
                    #hcmHighlightUrl;
                    #id = 0;
                    constructor({ docId, ownerDocument = globalThis.document } = {}){
                        super();
                        this.#docId = docId;
                        this.#document = ownerDocument;
                    }
                    get #cache() {
                        return this.#_cache ||= new Map();
                    }
                    get #defs() {
                        if (!this.#_defs) {
                            const div = this.#document.createElement("div");
                            const { style } = div;
                            style.visibility = "hidden";
                            style.contain = "strict";
                            style.width = style.height = 0;
                            style.position = "absolute";
                            style.top = style.left = 0;
                            style.zIndex = -1;
                            const svg = this.#document.createElementNS(SVG_NS, "svg");
                            svg.setAttribute("width", 0);
                            svg.setAttribute("height", 0);
                            this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
                            div.append(svg);
                            svg.append(this.#_defs);
                            this.#document.body.append(div);
                        }
                        return this.#_defs;
                    }
                    addFilter(maps) {
                        if (!maps) return "none";
                        let value = this.#cache.get(maps);
                        if (value) return value;
                        let tableR, tableG, tableB, key;
                        if (maps.length === 1) {
                            const mapR = maps[0];
                            const buffer = new Array(256);
                            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
                            key = tableR = tableG = tableB = buffer.join(",");
                        } else {
                            const [mapR, mapG, mapB] = maps;
                            const bufferR = new Array(256);
                            const bufferG = new Array(256);
                            const bufferB = new Array(256);
                            for(let i = 0; i < 256; i++){
                                bufferR[i] = mapR[i] / 255;
                                bufferG[i] = mapG[i] / 255;
                                bufferB[i] = mapB[i] / 255;
                            }
                            tableR = bufferR.join(",");
                            tableG = bufferG.join(",");
                            tableB = bufferB.join(",");
                            key = `${tableR}${tableG}${tableB}`;
                        }
                        value = this.#cache.get(key);
                        if (value) {
                            this.#cache.set(maps, value);
                            return value;
                        }
                        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
                        const url = `url(#${id})`;
                        this.#cache.set(maps, url);
                        this.#cache.set(key, url);
                        const filter = this.#createFilter(id);
                        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
                        return url;
                    }
                    addHCMFilter(fgColor, bgColor) {
                        const key = `${fgColor}-${bgColor}`;
                        if (this.#hcmKey === key) return this.#hcmUrl;
                        this.#hcmKey = key;
                        this.#hcmUrl = "none";
                        this.#hcmFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmUrl;
                        const fgRGB = this.#getRGB(fgColor);
                        fgColor = _util.Util.makeHexColor(...fgRGB);
                        const bgRGB = this.#getRGB(bgColor);
                        bgColor = _util.Util.makeHexColor(...bgRGB);
                        this.#defs.style.color = "";
                        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return this.#hcmUrl;
                        const map = new Array(256);
                        for(let i = 0; i <= 255; i++){
                            const x = i / 255;
                            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
                        }
                        const table = map.join(",");
                        const id = `g_${this.#docId}_hcm_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addTransferMapConversion(table, table, table, filter);
                        this.#addGrayConversion(filter);
                        const getSteps = (c, n)=>{
                            const start = fgRGB[c] / 255;
                            const end = bgRGB[c] / 255;
                            const arr = new Array(n + 1);
                            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
                            return arr.join(",");
                        };
                        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
                        this.#hcmUrl = `url(#${id})`;
                        return this.#hcmUrl;
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                        if (this.#hcmHighlightKey === key) return this.#hcmHighlightUrl;
                        this.#hcmHighlightKey = key;
                        this.#hcmHighlightUrl = "none";
                        this.#hcmHighlightFilter?.remove();
                        if (!fgColor || !bgColor) return this.#hcmHighlightUrl;
                        const [fgRGB, bgRGB] = [
                            fgColor,
                            bgColor
                        ].map(this.#getRGB.bind(this));
                        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                        let [newFgRGB, newBgRGB] = [
                            newFgColor,
                            newBgColor
                        ].map(this.#getRGB.bind(this));
                        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
                            bgGray,
                            fgGray,
                            newBgRGB,
                            newFgRGB
                        ];
                        this.#defs.style.color = "";
                        const getSteps = (fg, bg, n)=>{
                            const arr = new Array(256);
                            const step = (bgGray - fgGray) / n;
                            const newStart = fg / 255;
                            const newStep = (bg - fg) / (255 * n);
                            let prev = 0;
                            for(let i = 0; i <= n; i++){
                                const k = Math.round(fgGray + i * step);
                                const value = newStart + i * newStep;
                                for(let j = prev; j <= k; j++)arr[j] = value;
                                prev = k + 1;
                            }
                            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
                            return arr.join(",");
                        };
                        const id = `g_${this.#docId}_hcm_highlight_filter`;
                        const filter = this.#hcmHighlightFilter = this.#createFilter(id);
                        this.#addGrayConversion(filter);
                        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
                        this.#hcmHighlightUrl = `url(#${id})`;
                        return this.#hcmHighlightUrl;
                    }
                    destroy(keepHCM = false) {
                        if (keepHCM && (this.#hcmUrl || this.#hcmHighlightUrl)) return;
                        if (this.#_defs) {
                            this.#_defs.parentNode.parentNode.remove();
                            this.#_defs = null;
                        }
                        if (this.#_cache) {
                            this.#_cache.clear();
                            this.#_cache = null;
                        }
                        this.#id = 0;
                    }
                    #addGrayConversion(filter) {
                        const feColorMatrix = this.#document.createElementNS(SVG_NS, "feColorMatrix");
                        feColorMatrix.setAttribute("type", "matrix");
                        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                        filter.append(feColorMatrix);
                    }
                    #createFilter(id) {
                        const filter = this.#document.createElementNS(SVG_NS, "filter");
                        filter.setAttribute("color-interpolation-filters", "sRGB");
                        filter.setAttribute("id", id);
                        this.#defs.append(filter);
                        return filter;
                    }
                    #appendFeFunc(feComponentTransfer, func, table) {
                        const feFunc = this.#document.createElementNS(SVG_NS, func);
                        feFunc.setAttribute("type", "discrete");
                        feFunc.setAttribute("tableValues", table);
                        feComponentTransfer.append(feFunc);
                    }
                    #addTransferMapConversion(rTable, gTable, bTable, filter) {
                        const feComponentTransfer = this.#document.createElementNS(SVG_NS, "feComponentTransfer");
                        filter.append(feComponentTransfer);
                        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
                        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
                    }
                    #getRGB(color) {
                        this.#defs.style.color = color;
                        return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
                    }
                }
                exports.DOMFilterFactory = DOMFilterFactory;
                class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
                    constructor({ ownerDocument = globalThis.document } = {}){
                        super();
                        this._document = ownerDocument;
                    }
                    _createCanvas(width, height) {
                        const canvas = this._document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        return canvas;
                    }
                }
                exports.DOMCanvasFactory = DOMCanvasFactory;
                async function fetchData(url, asTypedArray = false) {
                    if (isValidFetchUrl(url, document.baseURI)) {
                        const response = await fetch(url);
                        if (!response.ok) throw new Error(response.statusText);
                        return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util.stringToBytes)(await response.text());
                    }
                    return new Promise((resolve, reject)=>{
                        const request = new XMLHttpRequest();
                        request.open("GET", url, true);
                        if (asTypedArray) request.responseType = "arraybuffer";
                        request.onreadystatechange = ()=>{
                            if (request.readyState !== XMLHttpRequest.DONE) return;
                            if (request.status === 200 || request.status === 0) {
                                let data;
                                if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                if (data) {
                                    resolve(data);
                                    return;
                                }
                            }
                            reject(new Error(request.statusText));
                        };
                        request.send(null);
                    });
                }
                class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url, this.isCompressed).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url, true);
                    }
                }
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                class DOMSVGFactory extends _base_factory.BaseSVGFactory {
                    _createSVG(type) {
                        return document.createElementNS(SVG_NS, type);
                    }
                }
                exports.DOMSVGFactory = DOMSVGFactory;
                class PageViewport {
                    constructor({ viewBox, scale, rotation, offsetX = 0, offsetY = 0, dontFlip = false }){
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        const centerX = (viewBox[2] + viewBox[0]) / 2;
                        const centerY = (viewBox[3] + viewBox[1]) / 2;
                        let rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        let offsetCanvasX, offsetCanvasY;
                        let width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = (viewBox[3] - viewBox[1]) * scale;
                            height = (viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = (viewBox[2] - viewBox[0]) * scale;
                            height = (viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                    get rawDims() {
                        const { viewBox } = this;
                        return (0, _util.shadow)(this, "rawDims", {
                            pageWidth: viewBox[2] - viewBox[0],
                            pageHeight: viewBox[3] - viewBox[1],
                            pageX: viewBox[0],
                            pageY: viewBox[1]
                        });
                    }
                    clone({ scale = this.scale, rotation = this.rotation, offsetX = this.offsetX, offsetY = this.offsetY, dontFlip = false } = {}) {
                        return new PageViewport({
                            viewBox: this.viewBox.slice(),
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    convertToViewportPoint(x, y) {
                        return _util.Util.applyTransform([
                            x,
                            y
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect) {
                        const topLeft = _util.Util.applyTransform([
                            rect[0],
                            rect[1]
                        ], this.transform);
                        const bottomRight = _util.Util.applyTransform([
                            rect[2],
                            rect[3]
                        ], this.transform);
                        return [
                            topLeft[0],
                            topLeft[1],
                            bottomRight[0],
                            bottomRight[1]
                        ];
                    }
                    convertToPdfPoint(x, y) {
                        return _util.Util.applyInverseTransform([
                            x,
                            y
                        ], this.transform);
                    }
                }
                exports.PageViewport = PageViewport;
                class RenderingCancelledException extends _util.BaseException {
                    constructor(msg, extraDelay = 0){
                        super(msg, "RenderingCancelledException");
                        this.extraDelay = extraDelay;
                    }
                }
                exports.RenderingCancelledException = RenderingCancelledException;
                function isDataScheme(url) {
                    const ii = url.length;
                    let i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url, onlyStripPath = false) {
                    if (!onlyStripPath) [url] = url.split(/[#?]/, 1);
                    return url.substring(url.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI = reURI.exec(url);
                    let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch  {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                class StatTimer {
                    started = Object.create(null);
                    times = [];
                    time(name) {
                        if (name in this.started) (0, _util.warn)(`Timer is already running for ${name}`);
                        this.started[name] = Date.now();
                    }
                    timeEnd(name) {
                        if (!(name in this.started)) (0, _util.warn)(`Timer has not been started for ${name}`);
                        this.times.push({
                            name: name,
                            start: this.started[name],
                            end: Date.now()
                        });
                        delete this.started[name];
                    }
                    toString() {
                        const outBuf = [];
                        let longest = 0;
                        for (const { name } of this.times)longest = Math.max(name.length, longest);
                        for (const { name, start, end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
                        return outBuf.join("");
                    }
                }
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        const { protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        return protocol === "http:" || protocol === "https:";
                    } catch  {
                        return false;
                    }
                }
                function noContextMenu(e) {
                    e.preventDefault();
                }
                function loadScript(src, removeScriptElement = false) {
                    return new Promise((resolve, reject)=>{
                        const script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error(`Cannot load script at: ${script.src}`));
                        };
                        (document.head || document.documentElement).append(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                let pdfDateStringRegex;
                class PDFDateString {
                    static toDateObject(input) {
                        if (!input || typeof input !== "string") return null;
                        pdfDateStringRegex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                        const matches = pdfDateStringRegex.exec(input);
                        if (!matches) return null;
                        const year = parseInt(matches[1], 10);
                        let month = parseInt(matches[2], 10);
                        month = month >= 1 && month <= 12 ? month - 1 : 0;
                        let day = parseInt(matches[3], 10);
                        day = day >= 1 && day <= 31 ? day : 1;
                        let hour = parseInt(matches[4], 10);
                        hour = hour >= 0 && hour <= 23 ? hour : 0;
                        let minute = parseInt(matches[5], 10);
                        minute = minute >= 0 && minute <= 59 ? minute : 0;
                        let second = parseInt(matches[6], 10);
                        second = second >= 0 && second <= 59 ? second : 0;
                        const universalTimeRelation = matches[7] || "Z";
                        let offsetHour = parseInt(matches[8], 10);
                        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                        let offsetMinute = parseInt(matches[9], 10) || 0;
                        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                        if (universalTimeRelation === "-") {
                            hour += offsetHour;
                            minute += offsetMinute;
                        } else if (universalTimeRelation === "+") {
                            hour -= offsetHour;
                            minute -= offsetMinute;
                        }
                        return new Date(Date.UTC(year, month, day, hour, minute, second));
                    }
                }
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, { scale = 1, rotation = 0 }) {
                    const { width, height } = xfaPage.attributes.style;
                    const viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
                function getRGB(color) {
                    if (color.startsWith("#")) {
                        const colorRGB = parseInt(color.slice(1), 16);
                        return [
                            (colorRGB & 0xff0000) >> 16,
                            (colorRGB & 0x00ff00) >> 8,
                            colorRGB & 0x0000ff
                        ];
                    }
                    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
                    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
                    (0, _util.warn)(`Not a valid color format: "${color}"`);
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues(colors) {
                    const span = document.createElement("span");
                    span.style.visibility = "hidden";
                    document.body.append(span);
                    for (const name of colors.keys()){
                        span.style.color = name;
                        const computedColor = window.getComputedStyle(span).color;
                        colors.set(name, getRGB(computedColor));
                    }
                    span.remove();
                }
                function getCurrentTransform(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function getCurrentTransformInverse(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform().invertSelf();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
                    if (viewport instanceof PageViewport) {
                        const { pageWidth, pageHeight } = viewport.rawDims;
                        const { style } = div;
                        const useRound = _util.FeatureTest.isCSSRoundSupported;
                        const w = `var(--scale-factor) * ${pageWidth}px`, h = `var(--scale-factor) * ${pageHeight}px`;
                        const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
                        if (!mustFlip || viewport.rotation % 180 === 0) {
                            style.width = widthStr;
                            style.height = heightStr;
                        } else {
                            style.width = heightStr;
                            style.height = widthStr;
                        }
                    }
                    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
                }
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _util = __w_pdfjs_require__(1);
                class BaseFilterFactory {
                    constructor(){
                        if (this.constructor === BaseFilterFactory) (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                    addFilter(maps) {
                        return "none";
                    }
                    addHCMFilter(fgColor, bgColor) {
                        return "none";
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        return "none";
                    }
                    destroy(keepHCM = false) {}
                }
                exports.BaseFilterFactory = BaseFilterFactory;
                class BaseCanvasFactory {
                    constructor(){
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    create(width, height) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        const canvas = this._createCanvas(width, height);
                        return {
                            canvas: canvas,
                            context: canvas.getContext("2d")
                        };
                    }
                    reset(canvasAndContext, width, height) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext.canvas.width = width;
                        canvasAndContext.canvas.height = height;
                    }
                    destroy(canvasAndContext) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext.canvas.width = 0;
                        canvasAndContext.canvas.height = 0;
                        canvasAndContext.canvas = null;
                        canvasAndContext.context = null;
                    }
                    _createCanvas(width, height) {
                        (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                    }
                }
                exports.BaseCanvasFactory = BaseCanvasFactory;
                class BaseCMapReaderFactory {
                    constructor({ baseUrl = null, isCompressed = true }){
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                    async fetch({ name }) {
                        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        if (!name) throw new Error("CMap name must be specified.");
                        const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                        const compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                        return this._fetchData(url, compressionType).catch((reason)=>{
                            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
                        });
                    }
                    _fetchData(url, compressionType) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                class BaseStandardFontDataFactory {
                    constructor({ baseUrl = null }){
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                    async fetch({ filename }) {
                        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        if (!filename) throw new Error("Font filename must be specified.");
                        const url = `${this.baseUrl}${filename}`;
                        return this._fetchData(url).catch((reason)=>{
                            throw new Error(`Unable to load font data at: ${url}`);
                        });
                    }
                    _fetchData(url) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                class BaseSVGFactory {
                    constructor(){
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    create(width, height, skipDimensions = false) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                        const svg = this._createSVG("svg:svg");
                        svg.setAttribute("version", "1.1");
                        if (!skipDimensions) {
                            svg.setAttribute("width", `${width}px`);
                            svg.setAttribute("height", `${height}px`);
                        }
                        svg.setAttribute("preserveAspectRatio", "none");
                        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                        return svg;
                    }
                    createElement(type) {
                        if (typeof type !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type);
                    }
                    _createSVG(type) {
                        (0, _util.unreachable)("Abstract method `_createSVG` called.");
                    }
                }
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(1);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _util = __w_pdfjs_require__(1);
                class FontLoader {
                    #systemFonts = new Set();
                    constructor({ ownerDocument = globalThis.document, styleElement = null }){
                        this._document = ownerDocument;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                    addNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.add(nativeFontFace);
                        this._document.fonts.add(nativeFontFace);
                    }
                    removeNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.delete(nativeFontFace);
                        this._document.fonts.delete(nativeFontFace);
                    }
                    insertRule(rule) {
                        if (!this.styleElement) {
                            this.styleElement = this._document.createElement("style");
                            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                        }
                        const styleSheet = this.styleElement.sheet;
                        styleSheet.insertRule(rule, styleSheet.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
                        this.nativeFontFaces.clear();
                        this.#systemFonts.clear();
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    async loadSystemFont(info) {
                        if (!info || this.#systemFonts.has(info.loadedName)) return;
                        (0, _util.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                        if (this.isFontLoadingAPISupported) {
                            const { loadedName, src, style } = info;
                            const fontFace = new FontFace(loadedName, src, style);
                            this.addNativeFontFace(fontFace);
                            try {
                                await fontFace.load();
                                this.#systemFonts.add(loadedName);
                            } catch  {
                                (0, _util.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                                this.removeNativeFontFace(fontFace);
                            }
                            return;
                        }
                        (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                    }
                    async bind(font) {
                        if (font.attached || font.missingFile && !font.systemFontInfo) return;
                        font.attached = true;
                        if (font.systemFontInfo) {
                            await this.loadSystemFont(font.systemFontInfo);
                            return;
                        }
                        if (this.isFontLoadingAPISupported) {
                            const nativeFontFace = font.createNativeFontFace();
                            if (nativeFontFace) {
                                this.addNativeFontFace(nativeFontFace);
                                try {
                                    await nativeFontFace.loaded;
                                } catch (ex) {
                                    (0, _util.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                                    font.disableFontFace = true;
                                    throw ex;
                                }
                            }
                            return;
                        }
                        const rule = font.createFontFaceRule();
                        if (rule) {
                            this.insertRule(rule);
                            if (this.isSyncFontLoadingSupported) return;
                            await new Promise((resolve)=>{
                                const request = this._queueLoadingCallback(resolve);
                                this._prepareFontLoadEvent(font, request);
                            });
                        }
                    }
                    get isFontLoadingAPISupported() {
                        const hasFonts = !!this._document?.fonts;
                        return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                    }
                    get isSyncFontLoadingSupported() {
                        let supported = false;
                        if (_util.isNodeJS) supported = true;
                        else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
                        return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                    }
                    _queueLoadingCallback(callback) {
                        function completeRequest() {
                            (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                            request.done = true;
                            while(loadingRequests.length > 0 && loadingRequests[0].done){
                                const otherRequest = loadingRequests.shift();
                                setTimeout(otherRequest.callback, 0);
                            }
                        }
                        const { loadingRequests } = this;
                        const request = {
                            done: false,
                            complete: completeRequest,
                            callback: callback
                        };
                        loadingRequests.push(request);
                        return request;
                    }
                    get _loadTestFont() {
                        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        return (0, _util.shadow)(this, "_loadTestFont", testFont);
                    }
                    _prepareFontLoadEvent(font, request) {
                        function int32(data, offset) {
                            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                        }
                        function spliceString(s, offset, remove, insert) {
                            const chunk1 = s.substring(0, offset);
                            const chunk2 = s.substring(offset + remove);
                            return chunk1 + insert + chunk2;
                        }
                        let i, ii;
                        const canvas = this._document.createElement("canvas");
                        canvas.width = 1;
                        canvas.height = 1;
                        const ctx = canvas.getContext("2d");
                        let called = 0;
                        function isFontReady(name, callback) {
                            if (++called > 30) {
                                (0, _util.warn)("Load test font never loaded.");
                                callback();
                                return;
                            }
                            ctx.font = "30px " + name;
                            ctx.fillText(".", 0, 20);
                            const imageData = ctx.getImageData(0, 0, 1, 1);
                            if (imageData.data[3] > 0) {
                                callback();
                                return;
                            }
                            setTimeout(isFontReady.bind(null, name, callback));
                        }
                        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data = this._loadTestFont;
                        const COMMENT_OFFSET = 976;
                        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                        const CFF_CHECKSUM_OFFSET = 16;
                        const XXXX_VALUE = 0x58585858;
                        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
                        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                        const url = `url(data:font/opentype;base64,${btoa(data)});`;
                        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
                        this.insertRule(rule);
                        const div = this._document.createElement("div");
                        div.style.visibility = "hidden";
                        div.style.width = div.style.height = "10px";
                        div.style.position = "absolute";
                        div.style.top = div.style.left = "0px";
                        for (const name of [
                            font.loadedName,
                            loadTestFontId
                        ]){
                            const span = this._document.createElement("span");
                            span.textContent = "Hi";
                            span.style.fontFamily = name;
                            div.append(span);
                        }
                        this._document.body.append(div);
                        isFontReady(loadTestFontId, ()=>{
                            div.remove();
                            request.complete();
                        });
                    }
                }
                exports.FontLoader = FontLoader;
                class FontFaceObject {
                    constructor(translatedData, { isEvalSupported = true, disableFontFace = false, ignoreErrors = false, inspectFont = null }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._inspectFont = inspectFont;
                    }
                    createNativeFontFace() {
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace;
                        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                        }
                        this._inspectFont?.(this);
                        return nativeFontFace;
                    }
                    createFontFaceRule() {
                        if (!this.data || this.disableFontFace) return null;
                        const data = (0, _util.bytesToString)(this.data);
                        const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
                        let rule;
                        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
                        else {
                            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
                        }
                        this._inspectFont?.(this, url);
                        return rule;
                    }
                    getPathGenerator(objs, character) {
                        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                        let cmds;
                        try {
                            cmds = objs.get(this.loadedName + "_path_" + character);
                        } catch (ex) {
                            if (!this.ignoreErrors) throw ex;
                            (0, _util.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                            return this.compiledGlyphs[character] = function(c, size) {};
                        }
                        if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const jsBuf = [];
                            for (const current of cmds){
                                const args = current.args !== undefined ? current.args.join(",") : "";
                                jsBuf.push("c.", current.cmd, "(", args, ");\n");
                            }
                            return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                        }
                        return this.compiledGlyphs[character] = function(c, size) {
                            for (const current of cmds){
                                if (current.cmd === "scale") current.args = [
                                    size,
                                    -size
                                ];
                                c[current.cmd].apply(c, current.args);
                            }
                        };
                    }
                }
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const fetchData = function(url) {
                    return new Promise((resolve, reject)=>{
                        const fs = (parcelRequire("kjyEk"));
                        fs.readFile(url, (error, data)=>{
                            if (error || !data) {
                                reject(new Error(error));
                                return;
                            }
                            resolve(new Uint8Array(data));
                        });
                    });
                };
                class NodeFilterFactory extends _base_factory.BaseFilterFactory {
                }
                exports.NodeFilterFactory = NodeFilterFactory;
                class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
                    _createCanvas(width, height) {
                        const Canvas = (parcelRequire("kjyEk"));
                        return Canvas.createCanvas(width, height);
                    }
                }
                exports.NodeCanvasFactory = NodeCanvasFactory;
                class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url);
                    }
                }
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _pattern_helper = __w_pdfjs_require__(12);
                var _image_utils = __w_pdfjs_require__(13);
                const MIN_FONT_SIZE = 16;
                const MAX_FONT_SIZE = 100;
                const MAX_GROUP_SIZE = 4096;
                const EXECUTION_TIME = 15;
                const EXECUTION_STEPS = 10;
                const MAX_SIZE_TO_COMPILE = 1000;
                const FULL_CHUNK_HEIGHT = 16;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = ()=>{
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                class CachedCanvases {
                    constructor(canvasFactory){
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                    getCanvas(id, width, height) {
                        let canvasEntry;
                        if (this.cache[id] !== undefined) {
                            canvasEntry = this.cache[id];
                            this.canvasFactory.reset(canvasEntry, width, height);
                        } else {
                            canvasEntry = this.canvasFactory.create(width, height);
                            this.cache[id] = canvasEntry;
                        }
                        return canvasEntry;
                    }
                    delete(id) {
                        delete this.cache[id];
                    }
                    clear() {
                        for(const id in this.cache){
                            const canvasEntry = this.cache[id];
                            this.canvasFactory.destroy(canvasEntry);
                            delete this.cache[id];
                        }
                    }
                }
                function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                    const [a, b, c, d, tx, ty] = (0, _display_utils.getCurrentTransform)(ctx);
                    if (b === 0 && c === 0) {
                        const tlX = destX * a + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destY * d + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destX + destW) * a + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destY + destH) * d + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rWidth,
                            rHeight
                        ];
                    }
                    if (a === 0 && d === 0) {
                        const tlX = destY * c + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destX * b + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destY + destH) * c + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destX + destW) * b + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rHeight,
                            rWidth
                        ];
                    }
                    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                    const scaleX = Math.hypot(a, b);
                    const scaleY = Math.hypot(c, d);
                    return [
                        scaleX * destW,
                        scaleY * destH
                    ];
                }
                function compileType3Glyph(imgData) {
                    const { width, height } = imgData;
                    if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) return null;
                    const POINT_TO_PROCESS_LIMIT = 1000;
                    const POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width1 = width + 1;
                    let points = new Uint8Array(width1 * (height + 1));
                    let i, j, j0;
                    const lineSize = width + 7 & -8;
                    let data = new Uint8Array(lineSize * height), pos = 0;
                    for (const elem of imgData.data){
                        let mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    let count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    const steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const path = new Path2D();
                    for(i = 0; count && i <= height; i++){
                        let p = i * width1;
                        const end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        path.moveTo(p % width1, i);
                        const p0 = p;
                        let type = points[p];
                        do {
                            const step = steps[type];
                            do p += step;
                            while (!points[p]);
                            const pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            path.lineTo(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        --i;
                    }
                    data = null;
                    points = null;
                    const drawOutline = function(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.fill(path);
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                class CanvasExtraState {
                    constructor(width, height){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.clipBox = this.clipBox.slice();
                        return clone;
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    updatePathMinMax(transform, x, y) {
                        [x, y] = _util.Util.applyTransform([
                            x,
                            y
                        ], transform);
                        this.minX = Math.min(this.minX, x);
                        this.minY = Math.min(this.minY, y);
                        this.maxX = Math.max(this.maxX, x);
                        this.maxY = Math.max(this.maxY, y);
                    }
                    updateRectMinMax(transform, rect) {
                        const p1 = _util.Util.applyTransform(rect, transform);
                        const p2 = _util.Util.applyTransform(rect.slice(2), transform);
                        this.minX = Math.min(this.minX, p1[0], p2[0]);
                        this.minY = Math.min(this.minY, p1[1], p2[1]);
                        this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                        this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                    }
                    updateScalingPathMinMax(transform, minMax) {
                        _util.Util.scaleMinMax(transform, minMax);
                        this.minX = Math.min(this.minX, minMax[0]);
                        this.maxX = Math.max(this.maxX, minMax[1]);
                        this.minY = Math.min(this.minY, minMax[2]);
                        this.maxY = Math.max(this.maxY, minMax[3]);
                    }
                    updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                        const box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                        if (minMax) {
                            minMax[0] = Math.min(minMax[0], box[0], box[2]);
                            minMax[1] = Math.max(minMax[1], box[0], box[2]);
                            minMax[2] = Math.min(minMax[2], box[1], box[3]);
                            minMax[3] = Math.max(minMax[3], box[1], box[3]);
                            return;
                        }
                        this.updateRectMinMax(transform, box);
                    }
                    getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        const box = [
                            this.minX,
                            this.minY,
                            this.maxX,
                            this.maxY
                        ];
                        if (pathType === _pattern_helper.PathType.STROKE) {
                            if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                            const scale = _util.Util.singularValueDecompose2dScale(transform);
                            const xStrokePad = scale[0] * this.lineWidth / 2;
                            const yStrokePad = scale[1] * this.lineWidth / 2;
                            box[0] -= xStrokePad;
                            box[1] -= yStrokePad;
                            box[2] += xStrokePad;
                            box[3] += yStrokePad;
                        }
                        return box;
                    }
                    updateClipFromPath() {
                        const intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                        this.startNewPathAndClipBox(intersect || [
                            0,
                            0,
                            0,
                            0
                        ]);
                    }
                    isEmptyClip() {
                        return this.minX === Infinity;
                    }
                    startNewPathAndClipBox(box) {
                        this.clipBox = box;
                        this.minX = Infinity;
                        this.minY = Infinity;
                        this.maxX = 0;
                        this.maxY = 0;
                    }
                    getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                    }
                }
                function putBinaryImageData(ctx, imgData) {
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0, destPos;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    let i, j, thisChunkHeight, elemsInThisChunk;
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        const srcLength = src.byteLength;
                        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        const dest32DataLength = dest32.length;
                        const fullSrcDiff = width + 7 >> 3;
                        const white = 0xffffffff;
                        const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                const srcDiff = srcLength - srcPos;
                                let k = 0;
                                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                const kEndUnrolled = kEnd & -8;
                                let mask = 0;
                                let srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error(`bad image kind: ${imgData.kind}`);
                }
                function putBinaryImageMask(ctx, imgData) {
                    if (imgData.bitmap) {
                        ctx.drawImage(imgData.bitmap, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    for(let i = 0; i < totalChunks; i++){
                        const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        ({ srcPos } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                            src: src,
                            srcPos: srcPos,
                            dest: dest,
                            width: width,
                            height: thisChunkHeight,
                            nonBlackColor: 0
                        }));
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    const properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                    if (!_util.isNodeJS) {
                        const { filter } = ctx;
                        if (filter !== "none" && filter !== "") ctx.filter = "none";
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    const length = bytes.length;
                    for(let i = 3; i < length; i += 4){
                        const alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            const alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    const scale = 1 / 255;
                    for(let i = 3; i < length; i += 4){
                        const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    for(let i = 3; i < length; i += 4){
                        const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    const hasBackdrop = !!backdrop;
                    const r0 = hasBackdrop ? backdrop[0] : 0;
                    const g0 = hasBackdrop ? backdrop[1] : 0;
                    const b0 = hasBackdrop ? backdrop[2] : 0;
                    const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                    const PIXELS_TO_PROCESS = 1048576;
                    const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(let row = 0; row < height; row += chunkSize){
                        const chunkHeight = Math.min(chunkSize, height - row);
                        const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    const layerOffsetX = layerBox[0];
                    const layerOffsetY = layerBox[1];
                    const layerWidth = layerBox[2] - layerOffsetX;
                    const layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    const scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const NORMAL_CLIP = {};
                const EO_CLIP = {};
                class CanvasGraphics {
                    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig, markedContentStack = null }, annotationCanvasMap, pageColors){
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack || [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    beginDrawing({ transform, viewport, transparency = false, background = null }) {
                        const width = this.ctx.canvas.width;
                        const height = this.ctx.canvas.height;
                        const savedFillStyle = this.ctx.fillStyle;
                        this.ctx.fillStyle = background || "#ffffff";
                        this.ctx.fillRect(0, 0, width, height);
                        this.ctx.fillStyle = savedFillStyle;
                        if (transparency) {
                            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                            this.compositeCtx = this.ctx;
                            this.transparentCanvas = transparentCanvas.canvas;
                            this.ctx = transparentCanvas.context;
                            this.ctx.save();
                            this.ctx.transform(...(0, _display_utils.getCurrentTransform)(this.compositeCtx));
                        }
                        this.ctx.save();
                        resetCtxToDefault(this.ctx);
                        if (transform) {
                            this.ctx.transform(...transform);
                            this.outputScaleX = transform[0];
                            this.outputScaleY = transform[0];
                        }
                        this.ctx.transform(...viewport.transform);
                        this.viewportScale = viewport.scale;
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                    }
                    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        let i = executionStartIdx || 0;
                        const argsArrayLen = argsArray.length;
                        if (argsArrayLen === i) return i;
                        const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                        const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                        let steps = 0;
                        const commonObjs = this.commonObjs;
                        const objs = this.objs;
                        let fnId;
                        while(true){
                            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                stepper.breakIt(i, continueCallback);
                                return i;
                            }
                            fnId = fnArray[i];
                            if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                            else for (const depObjId of argsArray[i]){
                                const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                if (!objsPool.has(depObjId)) {
                                    objsPool.get(depObjId, continueCallback);
                                    return i;
                                }
                            }
                            i++;
                            if (i === argsArrayLen) return i;
                            if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                if (Date.now() > endTime) {
                                    continueCallback();
                                    return i;
                                }
                                steps = 0;
                            }
                        }
                    }
                    #restoreInitialState() {
                        while(this.stateStack.length || this.inSMaskMode)this.restore();
                        this.ctx.restore();
                        if (this.transparentCanvas) {
                            this.ctx = this.compositeCtx;
                            this.ctx.save();
                            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                            this.ctx.drawImage(this.transparentCanvas, 0, 0);
                            this.ctx.restore();
                            this.transparentCanvas = null;
                        }
                    }
                    endDrawing() {
                        this.#restoreInitialState();
                        this.cachedCanvases.clear();
                        this.cachedPatterns.clear();
                        for (const cache of this._cachedBitmapsMap.values()){
                            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
                            cache.clear();
                        }
                        this._cachedBitmapsMap.clear();
                        this.#drawFilter();
                    }
                    #drawFilter() {
                        if (this.pageColors) {
                            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                            if (hcmFilterId !== "none") {
                                const savedFilter = this.ctx.filter;
                                this.ctx.filter = hcmFilterId;
                                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                                this.ctx.filter = savedFilter;
                            }
                        }
                    }
                    _scaleImage(img, inverseTransform) {
                        const width = img.width;
                        const height = img.height;
                        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                        let paintWidth = width, paintHeight = height;
                        let tmpCanvasId = "prescale1";
                        let tmpCanvas, tmpCtx;
                        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                            let newWidth = paintWidth, newHeight = paintHeight;
                            if (widthScale > 2 && paintWidth > 1) {
                                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                                widthScale /= paintWidth / newWidth;
                            }
                            if (heightScale > 2 && paintHeight > 1) {
                                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                                heightScale /= paintHeight / newHeight;
                            }
                            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                            tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, newWidth, newHeight);
                            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                            img = tmpCanvas.canvas;
                            paintWidth = newWidth;
                            paintHeight = newHeight;
                            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                        }
                        return {
                            img: img,
                            paintWidth: paintWidth,
                            paintHeight: paintHeight
                        };
                    }
                    _createMaskCanvas(img) {
                        const ctx = this.ctx;
                        const { width, height } = img;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        let cache, cacheKey, scaled, maskCanvas;
                        if ((img.bitmap || img.data) && img.count > 1) {
                            const mainKey = img.bitmap || img.data.buffer;
                            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                                currentTransform.slice(0, 4),
                                fillColor
                            ]);
                            cache = this._cachedBitmapsMap.get(mainKey);
                            if (!cache) {
                                cache = new Map();
                                this._cachedBitmapsMap.set(mainKey, cache);
                            }
                            const cachedImage = cache.get(cacheKey);
                            if (cachedImage && !isPatternFill) {
                                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                                return {
                                    canvas: cachedImage,
                                    offsetX: offsetX,
                                    offsetY: offsetY
                                };
                            }
                            scaled = cachedImage;
                        }
                        if (!scaled) {
                            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            putBinaryImageMask(maskCanvas.context, img);
                        }
                        let maskToCanvas = _util.Util.transform(currentTransform, [
                            1 / width,
                            0,
                            0,
                            -1 / height,
                            0,
                            0
                        ]);
                        maskToCanvas = _util.Util.transform(maskToCanvas, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            -height
                        ]);
                        const cord1 = _util.Util.applyTransform([
                            0,
                            0
                        ], maskToCanvas);
                        const cord2 = _util.Util.applyTransform([
                            width,
                            height
                        ], maskToCanvas);
                        const rect = _util.Util.normalizeRect([
                            cord1[0],
                            cord1[1],
                            cord2[0],
                            cord2[1]
                        ]);
                        const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                        const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                        const fillCtx = fillCanvas.context;
                        const offsetX = Math.min(cord1[0], cord2[0]);
                        const offsetY = Math.min(cord1[1], cord2[1]);
                        fillCtx.translate(-offsetX, -offsetY);
                        fillCtx.transform(...maskToCanvas);
                        if (!scaled) {
                            scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
                            scaled = scaled.img;
                            if (cache && isPatternFill) cache.set(cacheKey, scaled);
                        }
                        fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
                        drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                        fillCtx.globalCompositeOperation = "source-in";
                        const inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [
                            1,
                            0,
                            0,
                            1,
                            -offsetX,
                            -offsetY
                        ]);
                        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                        fillCtx.fillRect(0, 0, width, height);
                        if (cache && !isPatternFill) {
                            this.cachedCanvases.delete("fillCanvas");
                            cache.set(cacheKey, fillCanvas.canvas);
                        }
                        return {
                            canvas: fillCanvas.canvas,
                            offsetX: Math.round(offsetX),
                            offsetY: Math.round(offsetY)
                        };
                    }
                    setLineWidth(width) {
                        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                        this.current.lineWidth = width;
                        this.ctx.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.ctx.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.ctx.miterLimit = limit;
                    }
                    setDash(dashArray, dashPhase) {
                        const ctx = this.ctx;
                        if (ctx.setLineDash !== undefined) {
                            ctx.setLineDash(dashArray);
                            ctx.lineDashOffset = dashPhase;
                        }
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value[0], value[1]);
                                break;
                            case "CA":
                                this.current.strokeAlpha = value;
                                break;
                            case "ca":
                                this.current.fillAlpha = value;
                                this.ctx.globalAlpha = value;
                                break;
                            case "BM":
                                this.ctx.globalCompositeOperation = value;
                                break;
                            case "SMask":
                                this.current.activeSMask = value ? this.tempSMask : null;
                                this.tempSMask = null;
                                this.checkSMaskState();
                                break;
                            case "TR":
                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                                break;
                        }
                    }
                    get inSMaskMode() {
                        return !!this.suspendedCtx;
                    }
                    checkSMaskState() {
                        const inSMaskMode = this.inSMaskMode;
                        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                    }
                    beginSMaskMode() {
                        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                        const drawnWidth = this.ctx.canvas.width;
                        const drawnHeight = this.ctx.canvas.height;
                        const cacheId = "smaskGroupAt" + this.groupLevel;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        this.suspendedCtx = this.ctx;
                        this.ctx = scratchCanvas.context;
                        const ctx = this.ctx;
                        ctx.setTransform(...(0, _display_utils.getCurrentTransform)(this.suspendedCtx));
                        copyCtxState(this.suspendedCtx, ctx);
                        mirrorContextOperations(ctx, this.suspendedCtx);
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                    }
                    endSMaskMode() {
                        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                        this.ctx._removeMirroring();
                        copyCtxState(this.ctx, this.suspendedCtx);
                        this.ctx = this.suspendedCtx;
                        this.suspendedCtx = null;
                    }
                    compose(dirtyBox) {
                        if (!this.current.activeSMask) return;
                        if (!dirtyBox) dirtyBox = [
                            0,
                            0,
                            this.ctx.canvas.width,
                            this.ctx.canvas.height
                        ];
                        else {
                            dirtyBox[0] = Math.floor(dirtyBox[0]);
                            dirtyBox[1] = Math.floor(dirtyBox[1]);
                            dirtyBox[2] = Math.ceil(dirtyBox[2]);
                            dirtyBox[3] = Math.ceil(dirtyBox[3]);
                        }
                        const smask = this.current.activeSMask;
                        const suspendedCtx = this.suspendedCtx;
                        composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                        this.ctx.restore();
                    }
                    save() {
                        if (this.inSMaskMode) {
                            copyCtxState(this.ctx, this.suspendedCtx);
                            this.suspendedCtx.save();
                        } else this.ctx.save();
                        const old = this.current;
                        this.stateStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                        if (this.stateStack.length !== 0) {
                            this.current = this.stateStack.pop();
                            if (this.inSMaskMode) {
                                this.suspendedCtx.restore();
                                copyCtxState(this.suspendedCtx, this.ctx);
                            } else this.ctx.restore();
                            this.checkSMaskState();
                            this.pendingClip = null;
                            this._cachedScaleForStroking[0] = -1;
                            this._cachedGetSinglePixelWidth = null;
                        }
                    }
                    transform(a, b, c, d, e, f) {
                        this.ctx.transform(a, b, c, d, e, f);
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                    }
                    constructPath(ops, args, minMax) {
                        const ctx = this.ctx;
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let startX, startY;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                        const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                        for(let i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                ctx.moveTo(x, y);
                                if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                else {
                                    ctx.lineTo(xw, y);
                                    ctx.lineTo(xw, yh);
                                    ctx.lineTo(x, yh);
                                }
                                if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                                    x,
                                    y,
                                    xw,
                                    yh
                                ]);
                                ctx.closePath();
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.moveTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.lineTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.curveTo:
                                startX = x;
                                startY = y;
                                x = args[j + 4];
                                y = args[j + 5];
                                ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                startX = x;
                                startY = y;
                                ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                startX = x;
                                startY = y;
                                x = args[j + 2];
                                y = args[j + 3];
                                ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                ctx.closePath();
                                break;
                        }
                        if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                        current.setCurrentPoint(x, y);
                    }
                    closePath() {
                        this.ctx.closePath();
                    }
                    stroke(consumePath = true) {
                        const ctx = this.ctx;
                        const strokeColor = this.current.strokeColor;
                        ctx.globalAlpha = this.current.strokeAlpha;
                        if (this.contentVisible) {
                            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                                ctx.save();
                                ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                                this.rescaleAndStroke(false);
                                ctx.restore();
                            } else this.rescaleAndStroke(true);
                        }
                        if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                        ctx.globalAlpha = this.current.fillAlpha;
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    fill(consumePath = true) {
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        let needRestore = false;
                        if (isPatternFill) {
                            ctx.save();
                            ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            needRestore = true;
                        }
                        const intersect = this.current.getClippedPathBoundingBox();
                        if (this.contentVisible && intersect !== null) {
                            if (this.pendingEOFill) {
                                ctx.fill("evenodd");
                                this.pendingEOFill = false;
                            } else ctx.fill();
                        }
                        if (needRestore) ctx.restore();
                        if (consumePath) this.consumePath(intersect);
                    }
                    eoFill() {
                        this.pendingEOFill = true;
                        this.fill();
                    }
                    fillStroke() {
                        this.fill(false);
                        this.stroke(false);
                        this.consumePath();
                    }
                    eoFillStroke() {
                        this.pendingEOFill = true;
                        this.fillStroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.pendingEOFill = true;
                        this.closePath();
                        this.fillStroke();
                    }
                    endPath() {
                        this.consumePath();
                    }
                    clip() {
                        this.pendingClip = NORMAL_CLIP;
                    }
                    eoClip() {
                        this.pendingClip = EO_CLIP;
                    }
                    beginText() {
                        this.current.textMatrix = _util.IDENTITY_MATRIX;
                        this.current.textMatrixScale = 1;
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    endText() {
                        const paths = this.pendingTextPaths;
                        const ctx = this.ctx;
                        if (paths === undefined) {
                            ctx.beginPath();
                            return;
                        }
                        ctx.save();
                        ctx.beginPath();
                        for (const path of paths){
                            ctx.setTransform(...path.transform);
                            ctx.translate(path.x, path.y);
                            path.addToPath(ctx, path.fontSize);
                        }
                        ctx.restore();
                        ctx.clip();
                        ctx.beginPath();
                        delete this.pendingTextPaths;
                    }
                    setCharSpacing(spacing) {
                        this.current.charSpacing = spacing;
                    }
                    setWordSpacing(spacing) {
                        this.current.wordSpacing = spacing;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setFont(fontRefName, size) {
                        const fontObj = this.commonObjs.get(fontRefName);
                        const current = this.current;
                        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        this.current.font = fontObj;
                        this.current.fontSize = size;
                        if (fontObj.isType3Font) return;
                        const name = fontObj.loadedName || "sans-serif";
                        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        let browserFontSize = size;
                        if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                        else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                        this.current.fontSizeScale = size / browserFontSize;
                        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
                    }
                    setTextRenderingMode(mode) {
                        this.current.textRenderingMode = mode;
                    }
                    setTextRise(rise) {
                        this.current.textRise = rise;
                    }
                    moveText(x, y) {
                        this.current.x = this.current.lineX += x;
                        this.current.y = this.current.lineY += y;
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        this.current.textMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.current.textMatrixScale = Math.hypot(a, b);
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    paintChar(character, x, y, patternTransform) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const textRenderingMode = current.textRenderingMode;
                        const fontSize = current.fontSize / current.fontSizeScale;
                        const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                        const patternFill = current.patternFill && !font.missingFile;
                        let addToPath;
                        if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                        if (font.disableFontFace || patternFill) {
                            ctx.save();
                            ctx.translate(x, y);
                            ctx.beginPath();
                            addToPath(ctx, fontSize);
                            if (patternTransform) ctx.setTransform(...patternTransform);
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.stroke();
                            ctx.restore();
                        } else {
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
                        }
                        if (isAddToPathSet) {
                            const paths = this.pendingTextPaths ||= [];
                            paths.push({
                                transform: (0, _display_utils.getCurrentTransform)(ctx),
                                x: x,
                                y: y,
                                fontSize: fontSize,
                                addToPath: addToPath
                            });
                        }
                    }
                    get isFontSubpixelAAEnabled() {
                        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                        ctx.scale(1.5, 1);
                        ctx.fillText("I", 0, 10);
                        const data = ctx.getImageData(0, 0, 10, 10).data;
                        let enabled = false;
                        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                            enabled = true;
                            break;
                        }
                        return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        if (font.isType3Font) return this.showType3Text(glyphs);
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return undefined;
                        const ctx = this.ctx;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const glyphsLength = glyphs.length;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y + current.textRise);
                        if (fontDirection > 0) ctx.scale(textHScale, -1);
                        else ctx.scale(textHScale, 1);
                        let patternTransform;
                        if (current.patternFill) {
                            ctx.save();
                            const pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
                            ctx.restore();
                            ctx.fillStyle = pattern;
                        }
                        let lineWidth = current.lineWidth;
                        const scale = current.textMatrixScale;
                        if (scale === 0 || lineWidth === 0) {
                            const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
                        } else lineWidth /= scale;
                        if (fontSizeScale !== 1.0) {
                            ctx.scale(fontSizeScale, fontSizeScale);
                            lineWidth /= fontSizeScale;
                        }
                        ctx.lineWidth = lineWidth;
                        if (font.isInvalidPDFjsFont) {
                            const chars = [];
                            let width = 0;
                            for (const glyph of glyphs){
                                chars.push(glyph.unicode);
                                width += glyph.width;
                            }
                            ctx.fillText(chars.join(""), 0, 0);
                            current.x += width * widthAdvanceScale * textHScale;
                            ctx.restore();
                            this.compose();
                            return undefined;
                        }
                        let x = 0, i;
                        for(i = 0; i < glyphsLength; ++i){
                            const glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            let restoreNeeded = false;
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            const accent = glyph.accent;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (font.remeasure && width > 0) {
                                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                    const characterScaleX = width / measuredWidth;
                                    restoreNeeded = true;
                                    ctx.save();
                                    ctx.scale(characterScaleX, 1);
                                    scaledX /= characterScaleX;
                                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                            }
                            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                else {
                                    this.paintChar(character, scaledX, scaledY, patternTransform);
                                    if (accent) {
                                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                                    }
                                }
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                            if (restoreNeeded) ctx.restore();
                        }
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        ctx.restore();
                        this.compose();
                        return undefined;
                    }
                    showType3Text(glyphs) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        const fontDirection = current.fontDirection;
                        const spacingDir = font.vertical ? 1 : -1;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const textHScale = current.textHScale * fontDirection;
                        const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        const glyphsLength = glyphs.length;
                        const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                        let i, glyph, width, spacingLength;
                        if (isTextInvisible || fontSize === 0) return;
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y);
                        ctx.scale(textHScale, fontDirection);
                        for(i = 0; i < glyphsLength; ++i){
                            glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                spacingLength = spacingDir * glyph * fontSize / 1000;
                                this.ctx.translate(spacingLength, 0);
                                current.x += spacingLength * textHScale;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const operatorList = font.charProcOperatorList[glyph.operatorListId];
                            if (!operatorList) {
                                (0, _util.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                                continue;
                            }
                            if (this.contentVisible) {
                                this.processingType3 = glyph;
                                this.save();
                                ctx.scale(fontSize, fontSize);
                                ctx.transform(...fontMatrix);
                                this.executeOperatorList(operatorList);
                                this.restore();
                            }
                            const transformed = _util.Util.applyTransform([
                                glyph.width,
                                0
                            ], fontMatrix);
                            width = transformed[0] * fontSize + spacing;
                            ctx.translate(width, 0);
                            current.x += width * textHScale;
                        }
                        ctx.restore();
                        this.processingType3 = null;
                    }
                    setCharWidth(xWidth, yWidth) {}
                    setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                        this.ctx.rect(llx, lly, urx - llx, ury - lly);
                        this.ctx.clip();
                        this.endPath();
                    }
                    getColorN_Pattern(IR) {
                        let pattern;
                        if (IR[0] === "TilingPattern") {
                            const color = IR[1];
                            const baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
                            const canvasGraphicsFactory = {
                                createCanvasGraphics: (ctx)=>{
                                    return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                        optionalContentConfig: this.optionalContentConfig,
                                        markedContentStack: this.markedContentStack
                                    });
                                }
                            };
                            pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                        } else pattern = this._getPattern(IR[1], IR[2]);
                        return pattern;
                    }
                    setStrokeColorN() {
                        this.current.strokeColor = this.getColorN_Pattern(arguments);
                    }
                    setFillColorN() {
                        this.current.fillColor = this.getColorN_Pattern(arguments);
                        this.current.patternFill = true;
                    }
                    setStrokeRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.strokeStyle = color;
                        this.current.strokeColor = color;
                    }
                    setFillRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.fillStyle = color;
                        this.current.fillColor = color;
                        this.current.patternFill = false;
                    }
                    _getPattern(objId, matrix = null) {
                        let pattern;
                        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                        else {
                            pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                            this.cachedPatterns.set(objId, pattern);
                        }
                        if (matrix) pattern.matrix = matrix;
                        return pattern;
                    }
                    shadingFill(objId) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        this.save();
                        const pattern = this._getPattern(objId);
                        ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                        const inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
                        if (inv) {
                            const { width, height } = ctx.canvas;
                            const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                width,
                                height
                            ], inv);
                            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                        this.compose(this.current.getClippedPathBoundingBox());
                        this.restore();
                    }
                    beginInlineImage() {
                        (0, _util.unreachable)("Should not call beginInlineImage");
                    }
                    beginImageData() {
                        (0, _util.unreachable)("Should not call beginImageData");
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (!this.contentVisible) return;
                        this.save();
                        this.baseTransformStack.push(this.baseTransform);
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(...matrix);
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            this.ctx.rect(bbox[0], bbox[1], width, height);
                            this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
                            this.clip();
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {
                        if (!this.contentVisible) return;
                        this.restore();
                        this.baseTransform = this.baseTransformStack.pop();
                    }
                    beginGroup(group) {
                        if (!this.contentVisible) return;
                        this.save();
                        if (this.inSMaskMode) {
                            this.endSMaskMode();
                            this.current.activeSMask = null;
                        }
                        const currentCtx = this.ctx;
                        if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                        if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                        const currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
                        if (group.matrix) currentCtx.transform(...group.matrix);
                        if (!group.bbox) throw new Error("Bounding box is required.");
                        let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
                        const canvasBounds = [
                            0,
                            0,
                            currentCtx.canvas.width,
                            currentCtx.canvas.height
                        ];
                        bounds = _util.Util.intersect(bounds, canvasBounds) || [
                            0,
                            0,
                            0,
                            0
                        ];
                        const offsetX = Math.floor(bounds[0]);
                        const offsetY = Math.floor(bounds[1]);
                        let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                        let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                        let scaleX = 1, scaleY = 1;
                        if (drawnWidth > MAX_GROUP_SIZE) {
                            scaleX = drawnWidth / MAX_GROUP_SIZE;
                            drawnWidth = MAX_GROUP_SIZE;
                        }
                        if (drawnHeight > MAX_GROUP_SIZE) {
                            scaleY = drawnHeight / MAX_GROUP_SIZE;
                            drawnHeight = MAX_GROUP_SIZE;
                        }
                        this.current.startNewPathAndClipBox([
                            0,
                            0,
                            drawnWidth,
                            drawnHeight
                        ]);
                        let cacheId = "groupAt" + this.groupLevel;
                        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        const groupCtx = scratchCanvas.context;
                        groupCtx.scale(1 / scaleX, 1 / scaleY);
                        groupCtx.translate(-offsetX, -offsetY);
                        groupCtx.transform(...currentTransform);
                        if (group.smask) this.smaskStack.push({
                            canvas: scratchCanvas.canvas,
                            context: groupCtx,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            scaleX: scaleX,
                            scaleY: scaleY,
                            subtype: group.smask.subtype,
                            backdrop: group.smask.backdrop,
                            transferMap: group.smask.transferMap || null,
                            startTransformInverse: null
                        });
                        else {
                            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                            currentCtx.translate(offsetX, offsetY);
                            currentCtx.scale(scaleX, scaleY);
                            currentCtx.save();
                        }
                        copyCtxState(currentCtx, groupCtx);
                        this.ctx = groupCtx;
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                        this.groupStack.push(currentCtx);
                        this.groupLevel++;
                    }
                    endGroup(group) {
                        if (!this.contentVisible) return;
                        this.groupLevel--;
                        const groupCtx = this.ctx;
                        const ctx = this.groupStack.pop();
                        this.ctx = ctx;
                        this.ctx.imageSmoothingEnabled = false;
                        if (group.smask) {
                            this.tempSMask = this.smaskStack.pop();
                            this.restore();
                        } else {
                            this.ctx.restore();
                            const currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
                            this.restore();
                            this.ctx.save();
                            this.ctx.setTransform(...currentMtx);
                            const dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                groupCtx.canvas.width,
                                groupCtx.canvas.height
                            ], currentMtx);
                            this.ctx.drawImage(groupCtx.canvas, 0, 0);
                            this.ctx.restore();
                            this.compose(dirtyBox);
                        }
                    }
                    beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                        this.#restoreInitialState();
                        resetCtxToDefault(this.ctx);
                        this.ctx.save();
                        this.save();
                        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
                        if (Array.isArray(rect) && rect.length === 4) {
                            const width = rect[2] - rect[0];
                            const height = rect[3] - rect[1];
                            if (hasOwnCanvas && this.annotationCanvasMap) {
                                transform = transform.slice();
                                transform[4] -= rect[0];
                                transform[5] -= rect[1];
                                rect = rect.slice();
                                rect[0] = rect[1] = 0;
                                rect[2] = width;
                                rect[3] = height;
                                const [scaleX, scaleY] = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx));
                                const { viewportScale } = this;
                                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                const { canvas, context } = this.annotationCanvas;
                                this.annotationCanvasMap.set(id, canvas);
                                this.annotationCanvas.savedCtx = this.ctx;
                                this.ctx = context;
                                this.ctx.save();
                                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                resetCtxToDefault(this.ctx);
                            } else {
                                resetCtxToDefault(this.ctx);
                                this.ctx.rect(rect[0], rect[1], width, height);
                                this.ctx.clip();
                                this.endPath();
                            }
                        }
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.transform(...transform);
                        this.transform(...matrix);
                    }
                    endAnnotation() {
                        if (this.annotationCanvas) {
                            this.ctx.restore();
                            this.#drawFilter();
                            this.ctx = this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas;
                        }
                    }
                    paintImageMaskXObject(img) {
                        if (!this.contentVisible) return;
                        const count = img.count;
                        img = this.getObject(img.data, img);
                        img.count = count;
                        const ctx = this.ctx;
                        const glyph = this.processingType3;
                        if (glyph) {
                            if (glyph.compiled === undefined) glyph.compiled = compileType3Glyph(img);
                            if (glyph.compiled) {
                                glyph.compiled(ctx);
                                return;
                            }
                        }
                        const mask = this._createMaskCanvas(img);
                        const maskCanvas = mask.canvas;
                        ctx.save();
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                        if (!this.contentVisible) return;
                        img = this.getObject(img.data, img);
                        const ctx = this.ctx;
                        ctx.save();
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                        const mask = this._createMaskCanvas(img);
                        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                        for(let i = 0, ii = positions.length; i < ii; i += 2){
                            const trans = _util.Util.transform(currentTransform, [
                                scaleX,
                                skewX,
                                skewY,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ]);
                            const [x, y] = _util.Util.applyTransform([
                                0,
                                0
                            ], trans);
                            ctx.drawImage(mask.canvas, x, y);
                        }
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectGroup(images) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        for (const image of images){
                            const { data, width, height, transform } = image;
                            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            const maskCtx = maskCanvas.context;
                            maskCtx.save();
                            const img = this.getObject(data, image);
                            putBinaryImageMask(maskCtx, img);
                            maskCtx.globalCompositeOperation = "source-in";
                            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                            maskCtx.fillRect(0, 0, width, height);
                            maskCtx.restore();
                            ctx.save();
                            ctx.transform(...transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintImageXObject(objId) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        const width = imgData.width;
                        const height = imgData.height;
                        const map = [];
                        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
                            transform: [
                                scaleX,
                                0,
                                0,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ],
                            x: 0,
                            y: 0,
                            w: width,
                            h: height
                        });
                        this.paintInlineImageXObjectGroup(imgData, map);
                    }
                    applyTransferMapsToCanvas(ctx) {
                        if (this.current.transferMaps !== "none") {
                            ctx.filter = this.current.transferMaps;
                            ctx.drawImage(ctx.canvas, 0, 0);
                            ctx.filter = "none";
                        }
                        return ctx.canvas;
                    }
                    applyTransferMapsToBitmap(imgData) {
                        if (this.current.transferMaps === "none") return imgData.bitmap;
                        const { bitmap, width, height } = imgData;
                        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                        const tmpCtx = tmpCanvas.context;
                        tmpCtx.filter = this.current.transferMaps;
                        tmpCtx.drawImage(bitmap, 0, 0);
                        tmpCtx.filter = "none";
                        return tmpCanvas.canvas;
                    }
                    paintInlineImageXObject(imgData) {
                        if (!this.contentVisible) return;
                        const width = imgData.width;
                        const height = imgData.height;
                        const ctx = this.ctx;
                        this.save();
                        if (!_util.isNodeJS) {
                            const { filter } = ctx;
                            if (filter !== "none" && filter !== "") ctx.filter = "none";
                        }
                        ctx.scale(1 / width, -1 / height);
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
                        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                        else {
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        const scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
                        ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
                        drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                        this.compose();
                        this.restore();
                    }
                    paintInlineImageXObjectGroup(imgData, map) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = imgData.bitmap;
                        else {
                            const w = imgData.width;
                            const h = imgData.height;
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        for (const entry of map){
                            ctx.save();
                            ctx.transform(...entry.transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintSolidColorImageMask() {
                        if (!this.contentVisible) return;
                        this.ctx.fillRect(0, 0, 1, 1);
                        this.compose();
                    }
                    markPoint(tag) {}
                    markPointProps(tag, properties) {}
                    beginMarkedContent(tag) {
                        this.markedContentStack.push({
                            visible: true
                        });
                    }
                    beginMarkedContentProps(tag, properties) {
                        if (tag === "OC") this.markedContentStack.push({
                            visible: this.optionalContentConfig.isVisible(properties)
                        });
                        else this.markedContentStack.push({
                            visible: true
                        });
                        this.contentVisible = this.isContentVisible();
                    }
                    endMarkedContent() {
                        this.markedContentStack.pop();
                        this.contentVisible = this.isContentVisible();
                    }
                    beginCompat() {}
                    endCompat() {}
                    consumePath(clipBox) {
                        const isEmpty = this.current.isEmptyClip();
                        if (this.pendingClip) this.current.updateClipFromPath();
                        if (!this.pendingClip) this.compose(clipBox);
                        const ctx = this.ctx;
                        if (this.pendingClip) {
                            if (!isEmpty) {
                                if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                else ctx.clip();
                            }
                            this.pendingClip = null;
                        }
                        this.current.startNewPathAndClipBox(this.current.clipBox);
                        ctx.beginPath();
                    }
                    getSinglePixelWidth() {
                        if (!this._cachedGetSinglePixelWidth) {
                            const m = (0, _display_utils.getCurrentTransform)(this.ctx);
                            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                            else {
                                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                const normX = Math.hypot(m[0], m[2]);
                                const normY = Math.hypot(m[1], m[3]);
                                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                            }
                        }
                        return this._cachedGetSinglePixelWidth;
                    }
                    getScaleForStroking() {
                        if (this._cachedScaleForStroking[0] === -1) {
                            const { lineWidth } = this.current;
                            const { a, b, c, d } = this.ctx.getTransform();
                            let scaleX, scaleY;
                            if (b === 0 && c === 0) {
                                const normX = Math.abs(a);
                                const normY = Math.abs(d);
                                if (normX === normY) {
                                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                                    else {
                                        const scaledLineWidth = normX * lineWidth;
                                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                                    }
                                } else if (lineWidth === 0) {
                                    scaleX = 1 / normX;
                                    scaleY = 1 / normY;
                                } else {
                                    const scaledXLineWidth = normX * lineWidth;
                                    const scaledYLineWidth = normY * lineWidth;
                                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                                }
                            } else {
                                const absDet = Math.abs(a * d - b * c);
                                const normX = Math.hypot(a, b);
                                const normY = Math.hypot(c, d);
                                if (lineWidth === 0) {
                                    scaleX = normY / absDet;
                                    scaleY = normX / absDet;
                                } else {
                                    const baseArea = lineWidth * absDet;
                                    scaleX = normY > baseArea ? normY / baseArea : 1;
                                    scaleY = normX > baseArea ? normX / baseArea : 1;
                                }
                            }
                            this._cachedScaleForStroking[0] = scaleX;
                            this._cachedScaleForStroking[1] = scaleY;
                        }
                        return this._cachedScaleForStroking;
                    }
                    rescaleAndStroke(saveRestore) {
                        const { ctx } = this;
                        const { lineWidth } = this.current;
                        const [scaleX, scaleY] = this.getScaleForStroking();
                        ctx.lineWidth = lineWidth || 1;
                        if (scaleX === 1 && scaleY === 1) {
                            ctx.stroke();
                            return;
                        }
                        const dashes = ctx.getLineDash();
                        if (saveRestore) ctx.save();
                        ctx.scale(scaleX, scaleY);
                        if (dashes.length > 0) {
                            const scale = Math.max(scaleX, scaleY);
                            ctx.setLineDash(dashes.map((x)=>x / scale));
                            ctx.lineDashOffset /= scale;
                        }
                        ctx.stroke();
                        if (saveRestore) ctx.restore();
                    }
                    isContentVisible() {
                        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
                            if (!this.markedContentStack[i].visible) return false;
                        }
                        return true;
                    }
                }
                exports.CanvasGraphics = CanvasGraphics;
                for(const op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox) return;
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    const region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                class BaseShadingPattern {
                    constructor(){
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    getPattern() {
                        (0, _util.unreachable)("Abstract method `getPattern` called.");
                    }
                }
                class RadialAxialShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._type = IR[1];
                        this._bbox = IR[2];
                        this._colorStops = IR[3];
                        this._p0 = IR[4];
                        this._p1 = IR[5];
                        this._r0 = IR[6];
                        this._r1 = IR[7];
                        this.matrix = null;
                    }
                    _createGradient(ctx) {
                        let grad;
                        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
                        return grad;
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let pattern;
                        if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                            const tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.beginPath();
                            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                            inverse = _util.Util.transform(inverse, [
                                1,
                                0,
                                0,
                                1,
                                ownerBBox[0],
                                ownerBBox[1]
                            ]);
                            tmpCtx.transform(...owner.baseTransform);
                            if (this.matrix) tmpCtx.transform(...this.matrix);
                            applyBoundingBox(tmpCtx, this._bbox);
                            tmpCtx.fillStyle = this._createGradient(tmpCtx);
                            tmpCtx.fill();
                            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                            const domMatrix = new DOMMatrix(inverse);
                            pattern.setTransform(domMatrix);
                        } else {
                            applyBoundingBox(ctx, this._bbox);
                            pattern = this._createGradient(ctx);
                        }
                        return pattern;
                    }
                }
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    const coords = context.coords, colors = context.colors;
                    const bytes = data.data, rowSize = data.width * 4;
                    let tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    const minY = Math.round(y1), maxY = Math.round(y3);
                    let xa, car, cag, cab;
                    let xb, cbr, cbg, cbb;
                    for(let y = minY; y <= maxY; y++){
                        if (y < y2) {
                            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * k;
                            car = c1r - (c1r - c2r) * k;
                            cag = c1g - (c1g - c2g) * k;
                            cab = c1b - (c1b - c2b) * k;
                        } else {
                            let k;
                            if (y > y3) k = 1;
                            else if (y2 === y3) k = 0;
                            else k = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * k;
                            car = c2r - (c2r - c3r) * k;
                            cag = c2g - (c2g - c3g) * k;
                            cab = c2b - (c2b - c3b) * k;
                        }
                        let k;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        const x1_ = Math.round(Math.min(xa, xb));
                        const x2_ = Math.round(Math.max(xa, xb));
                        let j = rowSize * y + x1_ * 4;
                        for(let x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    const ps = figure.coords;
                    const cs = figure.colors;
                    let i, ii;
                    switch(figure.type){
                        case "lattice":
                            const verticesPerRow = figure.verticesPerRow;
                            const rows = Math.floor(ps.length / verticesPerRow) - 1;
                            const cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                let q = i * verticesPerRow;
                                for(let j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern extends BaseShadingPattern {
                    constructor(IR){
                        super();
                        this._coords = IR[2];
                        this._colors = IR[3];
                        this._figures = IR[4];
                        this._bounds = IR[5];
                        this._bbox = IR[7];
                        this._background = IR[8];
                        this.matrix = null;
                    }
                    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                        const EXPECTED_SCALE = 1.1;
                        const MAX_PATTERN_SIZE = 3000;
                        const BORDER_SIZE = 2;
                        const offsetX = Math.floor(this._bounds[0]);
                        const offsetY = Math.floor(this._bounds[1]);
                        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const scaleX = boundsWidth / width;
                        const scaleY = boundsHeight / height;
                        const context = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX,
                            offsetY: -offsetY,
                            scaleX: 1 / scaleX,
                            scaleY: 1 / scaleY
                        };
                        const paddedWidth = width + BORDER_SIZE * 2;
                        const paddedHeight = height + BORDER_SIZE * 2;
                        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                        const tmpCtx = tmpCanvas.context;
                        const data = tmpCtx.createImageData(width, height);
                        if (backgroundColor) {
                            const bytes = data.data;
                            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                                bytes[i] = backgroundColor[0];
                                bytes[i + 1] = backgroundColor[1];
                                bytes[i + 2] = backgroundColor[2];
                                bytes[i + 3] = 255;
                            }
                        }
                        for (const figure of this._figures)drawFigure(data, figure, context);
                        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                        const canvas = tmpCanvas.canvas;
                        return {
                            canvas: canvas,
                            offsetX: offsetX - BORDER_SIZE * scaleX,
                            offsetY: offsetY - BORDER_SIZE * scaleY,
                            scaleX: scaleX,
                            scaleY: scaleY
                        };
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        applyBoundingBox(ctx, this._bbox);
                        let scale;
                        if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
                        else {
                            scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                            if (this.matrix) {
                                const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                scale = [
                                    scale[0] * matrixScale[0],
                                    scale[1] * matrixScale[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                        if (pathType !== PathType.SHADING) {
                            ctx.setTransform(...owner.baseTransform);
                            if (this.matrix) ctx.transform(...this.matrix);
                        }
                        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                    }
                }
                class DummyShadingPattern extends BaseShadingPattern {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error(`Unknown IR type: ${IR[0]}`);
                }
                const PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern {
                    static MAX_PATTERN_SIZE = 3000;
                    constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform){
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                    createPatternCanvas(owner) {
                        const operatorList = this.operatorList;
                        const bbox = this.bbox;
                        const xstep = this.xstep;
                        const ystep = this.ystep;
                        const paintType = this.paintType;
                        const tilingType = this.tilingType;
                        const color = this.color;
                        const canvasGraphicsFactory = this.canvasGraphicsFactory;
                        (0, _util.info)("TilingType: " + tilingType);
                        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                        const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale = [
                            matrixScale[0] * curMatrixScale[0],
                            matrixScale[1] * curMatrixScale[1]
                        ];
                        const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                        const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                        const tmpCtx = tmpCanvas.context;
                        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                        graphics.groupLevel = owner.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                        let adjustedX0 = x0;
                        let adjustedY0 = y0;
                        let adjustedX1 = x1;
                        let adjustedY1 = y1;
                        if (x0 < 0) {
                            adjustedX0 = 0;
                            adjustedX1 += Math.abs(x0);
                        }
                        if (y0 < 0) {
                            adjustedY0 = 0;
                            adjustedY1 += Math.abs(y0);
                        }
                        tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                        tmpCtx.save();
                        this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                        graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
                        graphics.executeOperatorList(operatorList);
                        graphics.endDrawing();
                        return {
                            canvas: tmpCanvas.canvas,
                            scaleX: dimx.scale,
                            scaleY: dimy.scale,
                            offsetX: adjustedX0,
                            offsetY: adjustedY0
                        };
                    }
                    getSizeAndScale(step, realOutputSize, scale) {
                        step = Math.abs(step);
                        const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                        let size = Math.ceil(step * scale);
                        if (size >= maxSize) size = maxSize;
                        else scale = size / step;
                        return {
                            scale: scale,
                            size: size
                        };
                    }
                    clipBbox(graphics, x0, y0, x1, y1) {
                        const bboxWidth = x1 - x0;
                        const bboxHeight = y1 - y0;
                        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                        graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [
                            x0,
                            y0,
                            x1,
                            y1
                        ]);
                        graphics.clip();
                        graphics.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics, paintType, color) {
                        const context = graphics.ctx, current = graphics.current;
                        switch(paintType){
                            case PaintType.COLORED:
                                const ctx = this.ctx;
                                context.fillStyle = ctx.fillStyle;
                                context.strokeStyle = ctx.strokeStyle;
                                current.fillColor = ctx.fillStyle;
                                current.strokeColor = ctx.strokeStyle;
                                break;
                            case PaintType.UNCOLORED:
                                const cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                context.fillStyle = cssColor;
                                context.strokeStyle = cssColor;
                                current.fillColor = cssColor;
                                current.strokeColor = cssColor;
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported paint type: ${paintType}`);
                        }
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let matrix = inverse;
                        if (pathType !== PathType.SHADING) {
                            matrix = _util.Util.transform(matrix, owner.baseTransform);
                            if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                        }
                        const temporaryPatternCanvas = this.createPatternCanvas(owner);
                        let domMatrix = new DOMMatrix(matrix);
                        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                        pattern.setTransform(domMatrix);
                        return pattern;
                    }
                }
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(1);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src, srcPos = 0, dest, width, height, nonBlackColor = 0xffffffff, inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src, srcPos = 0, dest, destPos = 0, width, height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = null;
                GlobalWorkerOptions.workerSrc = "";
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(1);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this.#processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this.#createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    #createStreamSink(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const self = this, action = this.actionHandler[data.action];
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = new _util.PromiseCapability();
                                    this.ready = this.sinkCapability.promise;
                                }
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: new _util.PromiseCapability(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    #processStreamMessage(data) {
                        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) streamController.startCall.resolve();
                                else streamController.startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) streamController.pullCall.resolve();
                                else streamController.pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!streamSink) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                                streamSink.desiredSize = data.desiredSize;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onPull?.());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(streamController, "enqueue should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(streamController, "close should have stream controller");
                                if (streamController.isClosed) break;
                                streamController.isClosed = true;
                                streamController.controller.close();
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(streamController, "error should have stream controller");
                                streamController.controller.error(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) streamController.cancelCall.resolve();
                                else streamController.cancelCall.reject(wrapReason(data.reason));
                                this.#deleteStreamController(streamController, streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!streamSink) break;
                                new Promise(function(resolve) {
                                    resolve(streamSink.onCancel?.(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                streamSink.sinkCapability.reject(wrapReason(data.reason));
                                streamSink.isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async #deleteStreamController(streamController, streamId) {
                        await Promise.allSettled([
                            streamController.startCall?.promise,
                            streamController.pullCall?.promise,
                            streamController.cancelCall?.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(1);
                class Metadata {
                    #metadataMap;
                    #data;
                    constructor({ parsedData, rawData }){
                        this.#metadataMap = parsedData;
                        this.#data = rawData;
                    }
                    getRaw() {
                        return this.#data;
                    }
                    get(name) {
                        return this.#metadataMap.get(name) ?? null;
                    }
                    getAll() {
                        return (0, _util.objectFromMap)(this.#metadataMap);
                    }
                    has(name) {
                        return this.#metadataMap.has(name);
                    }
                }
                exports.Metadata = Metadata;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(1);
                var _murmurhash = __w_pdfjs_require__(8);
                const INTERNAL = Symbol("INTERNAL");
                class OptionalContentGroup {
                    #visible = true;
                    constructor(name, intent){
                        this.name = name;
                        this.intent = intent;
                    }
                    get visible() {
                        return this.#visible;
                    }
                    _setVisible(internal, visible) {
                        if (internal !== INTERNAL) (0, _util.unreachable)("Internal method `_setVisible` called.");
                        this.#visible = visible;
                    }
                }
                class OptionalContentConfig {
                    #cachedGetHash = null;
                    #groups = new Map();
                    #initialHash = null;
                    #order = null;
                    constructor(data){
                        this.name = null;
                        this.creator = null;
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        this.#order = data.order;
                        for (const group of data.groups)this.#groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
                        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible(INTERNAL, false);
                        for (const on of data.on)this.#groups.get(on)._setVisible(INTERNAL, true);
                        for (const off of data.off)this.#groups.get(off)._setVisible(INTERNAL, false);
                        this.#initialHash = this.getHash();
                    }
                    #evaluateVisibilityExpression(array) {
                        const length = array.length;
                        if (length < 2) return true;
                        const operator = array[0];
                        for(let i = 1; i < length; i++){
                            const element = array[i];
                            let state;
                            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
                            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
                            else {
                                (0, _util.warn)(`Optional content group not found: ${element}`);
                                return true;
                            }
                            switch(operator){
                                case "And":
                                    if (!state) return false;
                                    break;
                                case "Or":
                                    if (state) return true;
                                    break;
                                case "Not":
                                    return !state;
                                default:
                                    return true;
                            }
                        }
                        return operator === "And";
                    }
                    isVisible(group) {
                        if (this.#groups.size === 0) return true;
                        if (!group) {
                            (0, _util.warn)("Optional content group not defined.");
                            return true;
                        }
                        if (group.type === "OCG") {
                            if (!this.#groups.has(group.id)) {
                                (0, _util.warn)(`Optional content group not found: ${group.id}`);
                                return true;
                            }
                            return this.#groups.get(group.id).visible;
                        } else if (group.type === "OCMD") {
                            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
                            if (!group.policy || group.policy === "AnyOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOn") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return false;
                                }
                                return true;
                            } else if (group.policy === "AnyOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!this.#groups.get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOff") {
                                for (const id of group.ids){
                                    if (!this.#groups.has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (this.#groups.get(id).visible) return false;
                                }
                                return true;
                            }
                            (0, _util.warn)(`Unknown optional content policy ${group.policy}.`);
                            return true;
                        }
                        (0, _util.warn)(`Unknown group type ${group.type}.`);
                        return true;
                    }
                    setVisibility(id, visible = true) {
                        if (!this.#groups.has(id)) {
                            (0, _util.warn)(`Optional content group not found: ${id}`);
                            return;
                        }
                        this.#groups.get(id)._setVisible(INTERNAL, !!visible);
                        this.#cachedGetHash = null;
                    }
                    get hasInitialVisibility() {
                        return this.#initialHash === null || this.getHash() === this.#initialHash;
                    }
                    getOrder() {
                        if (!this.#groups.size) return null;
                        if (this.#order) return this.#order.slice();
                        return [
                            ...this.#groups.keys()
                        ];
                    }
                    getGroups() {
                        return this.#groups.size > 0 ? (0, _util.objectFromMap)(this.#groups) : null;
                    }
                    getGroup(id) {
                        return this.#groups.get(id) || null;
                    }
                    getHash() {
                        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
                        const hash = new _murmurhash.MurmurHash3_64();
                        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
                        return this.#cachedGetHash = hash.hexdigest();
                    }
                }
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class PDFDataTransportStream {
                    constructor({ length, initialData, progressiveDone = false, contentDispositionFilename = null, disableRange = false, disableStream = false }, pdfDataRangeTransport){
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone;
                        this._contentDispositionFilename = contentDispositionFilename;
                        if (initialData?.length > 0) {
                            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !disableStream;
                        this._isRangeSupported = !disableRange;
                        this._contentLength = length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
                            this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded, total)=>{
                            this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
                            this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _onReceiveData({ begin, chunk }) {
                        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                        if (begin === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                            else this._queuedChunks.push(buffer);
                        } else {
                            const found = this._rangeReaders.some(function(rangeReader) {
                                if (rangeReader._begin !== begin) return false;
                                rangeReader._enqueue(buffer);
                                return true;
                            });
                            (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    _onProgress(evt) {
                        if (evt.total === undefined) this._rangeReaders[0]?.onProgress?.({
                            loaded: evt.loaded
                        });
                        else this._fullRequestReader?.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.total
                        });
                    }
                    _onProgressiveDone() {
                        this._fullRequestReader?.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader) {
                        const i = this._rangeReaders.indexOf(reader);
                        if (i >= 0) this._rangeReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                        this._pdfDataRangeTransport.requestDataRange(begin, end);
                        this._rangeReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
                        this._pdfDataRangeTransport.abort();
                    }
                }
                exports.PDFDataTransportStream = PDFDataTransportStream;
                class PDFDataTransportStreamReader {
                    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk);
                        this._loaded += chunk.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    async read() {
                        if (this._queuedChunks.length > 0) {
                            const chunk = this._queuedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                }
                class PDFDataTransportStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk;
                        else {
                            const requestsCapability = this._requests.shift();
                            requestsCapability.resolve({
                                value: chunk,
                                done: false
                            });
                            for (const requestCapability of this._requests)requestCapability.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                }
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    const headers = new Headers();
                    for(const property in httpHeaders){
                        const value = httpHeaders[property];
                        if (value === undefined) continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                function getArrayBuffer(val) {
                    if (val instanceof Uint8Array) return val.buffer;
                    if (val instanceof ArrayBuffer) return val;
                    (0, _util.warn)(`getArrayBuffer - unexpected data format: ${val}`);
                    return new Uint8Array(val).buffer;
                }
                class PDFFetchStream {
                    constructor(source){
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFFetchStreamRangeReader(this, begin, end);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFFetchStream = PDFFetchStream;
                class PDFFetchStreamReader {
                    constructor(stream){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._reader = response.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader = (name)=>{
                                return response.headers.get(name);
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._headersCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
                class PDFFetchStreamRangeReader {
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = new _util.PromiseCapability();
                        this._isStreamingSupported = !source.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._readCapability.resolve();
                            this._reader = response.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        const { value, done } = await this._reader.read();
                        if (done) return {
                            value: value,
                            done: done
                        };
                        this._loaded += value.byteLength;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        return {
                            value: getArrayBuffer(value),
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader?.cancel(reason);
                        this._abortController.abort();
                    }
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(1);
                var _content_disposition = __w_pdfjs_require__(21);
                var _display_utils = __w_pdfjs_require__(6);
                function validateRangeRequestCapabilities({ getResponseHeader, isHttp, rangeChunkSize, disableRange }) {
                    const returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    const contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch  {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(1);
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    let needsEncodingFixup = true;
                    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        const filename = rfc2047decode(tmp);
                        return fixupEncoding(filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                const decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                const buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch  {}
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        const matches = [];
                        let match;
                        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            let [, n, quot, part] = match;
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        const parts = [];
                        for(let n = 0; n < matches.length; ++n){
                            if (!(n in matches)) break;
                            let [quot, part] = matches[n];
                            part = rfc2616unquote(part);
                            if (quot) {
                                part = unescape(part);
                                if (n === 0) part = rfc5987decode(part);
                            }
                            parts.push(part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            const parts = value.slice(1).split('\\"');
                            for(let i = 0; i < parts.length; ++i){
                                const quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        const encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        const encoding = extvalue.slice(0, encodingend);
                        const langvalue = extvalue.slice(encodingend + 1);
                        const value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replaceAll("_", " ");
                                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch  {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const OK_RESPONSE = 200;
                const PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    const data = xhr.response;
                    if (typeof data !== "string") return data;
                    return (0, _util.stringToBytes)(data).buffer;
                }
                class NetworkManager {
                    constructor(url, args = {}){
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    requestRange(begin, end, listeners) {
                        const args = {
                            begin: begin,
                            end: end
                        };
                        for(const prop in listeners)args[prop] = listeners[prop];
                        return this.request(args);
                    }
                    requestFull(listeners) {
                        return this.request(listeners);
                    }
                    request(args) {
                        const xhr = new XMLHttpRequest();
                        const xhrId = this.currXhrId++;
                        const pendingRequest = this.pendingRequests[xhrId] = {
                            xhr: xhr
                        };
                        xhr.open("GET", this.url);
                        xhr.withCredentials = this.withCredentials;
                        for(const property in this.httpHeaders){
                            const value = this.httpHeaders[property];
                            if (value === undefined) continue;
                            xhr.setRequestHeader(property, value);
                        }
                        if (this.isHttp && "begin" in args && "end" in args) {
                            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                            pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                        } else pendingRequest.expectedStatus = OK_RESPONSE;
                        xhr.responseType = "arraybuffer";
                        if (args.onError) xhr.onerror = function(evt) {
                            args.onError(xhr.status);
                        };
                        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                        xhr.onprogress = this.onProgress.bind(this, xhrId);
                        pendingRequest.onHeadersReceived = args.onHeadersReceived;
                        pendingRequest.onDone = args.onDone;
                        pendingRequest.onError = args.onError;
                        pendingRequest.onProgress = args.onProgress;
                        xhr.send(null);
                        return xhrId;
                    }
                    onProgress(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        pendingRequest.onProgress?.(evt);
                    }
                    onStateChange(xhrId, evt) {
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        const xhr = pendingRequest.xhr;
                        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                            pendingRequest.onHeadersReceived();
                            delete pendingRequest.onHeadersReceived;
                        }
                        if (xhr.readyState !== 4) return;
                        if (!(xhrId in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId];
                        if (xhr.status === 0 && this.isHttp) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const xhrStatus = xhr.status || OK_RESPONSE;
                        const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                            pendingRequest.onError?.(xhr.status);
                            return;
                        }
                        const chunk = getArrayBuffer(xhr);
                        if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                            const rangeHeader = xhr.getResponseHeader("Content-Range");
                            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                            pendingRequest.onDone({
                                begin: parseInt(matches[1], 10),
                                chunk: chunk
                            });
                        } else if (chunk) pendingRequest.onDone({
                            begin: 0,
                            chunk: chunk
                        });
                        else pendingRequest.onError?.(xhr.status);
                    }
                    getRequestXhr(xhrId) {
                        return this.pendingRequests[xhrId].xhr;
                    }
                    isPendingRequest(xhrId) {
                        return xhrId in this.pendingRequests;
                    }
                    abortRequest(xhrId) {
                        const xhr = this.pendingRequests[xhrId].xhr;
                        delete this.pendingRequests[xhrId];
                        xhr.abort();
                    }
                }
                class PDFNetworkStream {
                    constructor(source){
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _onRangeRequestReaderClosed(reader) {
                        const i = this._rangeRequestReaders.indexOf(reader);
                        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNetworkStream = PDFNetworkStream;
                class PDFNetworkStreamFullRequestReader {
                    constructor(manager, source){
                        this._manager = manager;
                        const args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _onHeadersReceived() {
                        const fullRequestXhrId = this._fullRequestId;
                        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                        const getResponseHeader = (name)=>{
                            return fullRequestXhr.getResponseHeader(name);
                        };
                        const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests) this._isRangeSupported = true;
                        this._contentLength = suggestedLength || this._contentLength;
                        this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(data) {
                        if (data) {
                            if (this._requests.length > 0) {
                                const requestCapability = this._requests.shift();
                                requestCapability.resolve({
                                    value: data.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(data.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        this._headersReceivedCapability.reject(this._storedError);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(evt) {
                        this.onProgress?.({
                            loaded: evt.loaded,
                            total: evt.lengthComputable ? evt.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._cachedChunks.length > 0) {
                            const chunk = this._cachedChunks.shift();
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason);
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader {
                    constructor(manager, begin, end){
                        this._manager = manager;
                        const args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _close() {
                        this.onClosed?.(this);
                    }
                    _onDone(data) {
                        const chunk = data.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunk = chunk;
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._queuedChunk = null;
                    }
                    _onProgress(evt) {
                        if (!this.isStreamingSupported) this.onProgress?.({
                            loaded: evt.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._queuedChunk !== null) {
                            const chunk = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability = new _util.PromiseCapability();
                        this._requests.push(requestCapability);
                        return requestCapability.promise;
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    const url = (parcelRequire("kjyEk"));
                    const parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse(`file:///${sourceUrl}`);
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                class PDFNodeStream {
                    constructor(source){
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                        this._rangeRequestReaders.push(rangeReader);
                        return rangeReader;
                    }
                    cancelAllRequests(reason) {
                        this._fullRequestReader?.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFNodeStream = PDFNodeStream;
                class BaseFullReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        this._headersCapability = new _util.PromiseCapability();
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                class BaseRangeReader {
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        const source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = new _util.PromiseCapability();
                            return this.read();
                        }
                        this._loaded += chunk.length;
                        this.onProgress?.({
                            loaded: this._loaded
                        });
                        const buffer = new Uint8Array(chunk).buffer;
                        return {
                            value: buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                class PDFNodeStreamFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response);
                            const getResponseHeader = (name)=>{
                                return this._readableStream.headers[name.toLowerCase()];
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("kjyEk"));
                            this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("kjyEk"));
                            this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                            this._headersCapability.reject(reason);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        this._httpHeaders = {};
                        for(const property in stream.httpHeaders){
                            const value = stream.httpHeaders[property];
                            if (value === undefined) continue;
                            this._httpHeaders[property] = value;
                        }
                        this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                return;
                            }
                            this._setReadableStream(response);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("kjyEk"));
                            this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("kjyEk"));
                            this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("kjyEk"));
                        fs.lstat(path, (error, stat)=>{
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException(`Missing PDF "${path}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._contentLength = stat.size;
                            this._setReadableStream(fs.createReadStream(path));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("kjyEk"));
                        this._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                    }
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _display_utils = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(1);
                const SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                const XML_NS = "http://www.w3.org/XML/1998/namespace";
                const XLINK_NS = "http://www.w3.org/1999/xlink";
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const createObjectURL = function(data, contentType = "", forceDataSchema = false) {
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer = `data:${contentType};base64,`;
                    for(let i = 0, ii = data.length; i < ii; i += 3){
                        const b1 = data[i] & 0xff;
                        const b2 = data[i + 1] & 0xff;
                        const b3 = data[i + 2] & 0xff;
                        const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                };
                const convertImgDataToPng = function() {
                    const PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    const CHUNK_WRAPPER_SIZE = 12;
                    const crcTable = new Int32Array(256);
                    for(let i = 0; i < 256; i++){
                        let c = i;
                        for(let h = 0; h < 8; h++)c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        let crc = -1;
                        for(let i = start; i < end; i++){
                            const a = (crc ^ data[i]) & 0xff;
                            const b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        let p = offset;
                        const len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        const crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        let a = 1;
                        let b = 0;
                        for(let i = start; i < end; ++i){
                            a = (a + (data[i] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_util.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            const input = parseInt($hPtJY.versions.node) >= 8 ? literals : $04552c275ef79ab8$require$Buffer.from(literals);
                            const output = (parcelRequire("kjyEk")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        let len = literals.length;
                        const maxBlockLength = 0xffff;
                        const deflateBlocks = Math.ceil(len / maxBlockLength);
                        const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        let pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        let pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        const adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        let bitDepth, colorType, lineSize;
                        const bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        const literals = new Uint8Array((1 + lineSize) * height);
                        let offsetLiterals = 0, offsetBytes = 0;
                        for(let y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(let y = 0; y < height; y++){
                                offsetLiterals++;
                                for(let i = 0; i < lineSize; i++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        const ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        const idat = deflateSync(literals);
                        const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        const data = new Uint8Array(pngLength);
                        let offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return createObjectURL(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                class SVGExtraState {
                    constructor(){
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                }
                function opListToTree(opList) {
                    let opTree = [];
                    const tmp = [];
                    for (const opListElement of opList){
                        if (opListElement.fn === "save") {
                            opTree.push({
                                fnId: 92,
                                fn: "group",
                                items: []
                            });
                            tmp.push(opTree);
                            opTree = opTree.at(-1).items;
                            continue;
                        }
                        if (opListElement.fn === "restore") opTree = tmp.pop();
                        else opTree.push(opListElement);
                    }
                    return opTree;
                }
                function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const s = value.toFixed(10);
                    let i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                }
                function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return `scale(${pf(m[0])} ${pf(m[3])})`;
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            const a = Math.acos(m[0]) * 180 / Math.PI;
                            return `rotate(${pf(a)})`;
                        }
                    } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return `translate(${pf(m[4])} ${pf(m[5])})`;
                    return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ` + `${pf(m[5])})`;
                }
                let clipCount = 0;
                let maskCount = 0;
                let shadingCount = 0;
                class SVGGraphics {
                    constructor(commonObjs, objs, forceDataSchema = false){
                        (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(const op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    save() {
                        this.transformStack.push(this.transformMatrix);
                        const old = this.current;
                        this.extraStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        this.transformMatrix = this.transformStack.pop();
                        this.current = this.extraStack.pop();
                        this.pendingClip = null;
                        this.tgrp = null;
                    }
                    group(items) {
                        this.save();
                        this.executeOpTree(items);
                        this.restore();
                    }
                    loadDependencies(operatorList) {
                        const fnArray = operatorList.fnArray;
                        const argsArray = operatorList.argsArray;
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            if (fnArray[i] !== _util.OPS.dependency) continue;
                            for (const obj of argsArray[i]){
                                const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                                const promise = new Promise((resolve)=>{
                                    objsPool.get(obj, resolve);
                                });
                                this.current.dependencies.push(promise);
                            }
                        }
                        return Promise.all(this.current.dependencies);
                    }
                    transform(a, b, c, d, e, f) {
                        const transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                        this.tgrp = null;
                    }
                    getSVG(operatorList, viewport) {
                        this.viewport = viewport;
                        const svgElement = this._initialize(viewport);
                        return this.loadDependencies(operatorList).then(()=>{
                            this.transformMatrix = _util.IDENTITY_MATRIX;
                            this.executeOpTree(this.convertOpList(operatorList));
                            return svgElement;
                        });
                    }
                    convertOpList(operatorList) {
                        const operatorIdMapping = this._operatorIdMapping;
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        const opList = [];
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            const fnId = fnArray[i];
                            opList.push({
                                fnId: fnId,
                                fn: operatorIdMapping[fnId],
                                args: argsArray[i]
                            });
                        }
                        return opListToTree(opList);
                    }
                    executeOpTree(opTree) {
                        for (const opTreeElement of opTree){
                            const fn = opTreeElement.fn;
                            const fnId = opTreeElement.fnId;
                            const args = opTreeElement.args;
                            switch(fnId | 0){
                                case _util.OPS.beginText:
                                    this.beginText();
                                    break;
                                case _util.OPS.dependency:
                                    break;
                                case _util.OPS.setLeading:
                                    this.setLeading(args);
                                    break;
                                case _util.OPS.setLeadingMoveText:
                                    this.setLeadingMoveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setFont:
                                    this.setFont(args);
                                    break;
                                case _util.OPS.showText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.showSpacedText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.endText:
                                    this.endText();
                                    break;
                                case _util.OPS.moveText:
                                    this.moveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setCharSpacing:
                                    this.setCharSpacing(args[0]);
                                    break;
                                case _util.OPS.setWordSpacing:
                                    this.setWordSpacing(args[0]);
                                    break;
                                case _util.OPS.setHScale:
                                    this.setHScale(args[0]);
                                    break;
                                case _util.OPS.setTextMatrix:
                                    this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.setTextRise:
                                    this.setTextRise(args[0]);
                                    break;
                                case _util.OPS.setTextRenderingMode:
                                    this.setTextRenderingMode(args[0]);
                                    break;
                                case _util.OPS.setLineWidth:
                                    this.setLineWidth(args[0]);
                                    break;
                                case _util.OPS.setLineJoin:
                                    this.setLineJoin(args[0]);
                                    break;
                                case _util.OPS.setLineCap:
                                    this.setLineCap(args[0]);
                                    break;
                                case _util.OPS.setMiterLimit:
                                    this.setMiterLimit(args[0]);
                                    break;
                                case _util.OPS.setFillRGBColor:
                                    this.setFillRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeRGBColor:
                                    this.setStrokeRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeColorN:
                                    this.setStrokeColorN(args);
                                    break;
                                case _util.OPS.setFillColorN:
                                    this.setFillColorN(args);
                                    break;
                                case _util.OPS.shadingFill:
                                    this.shadingFill(args[0]);
                                    break;
                                case _util.OPS.setDash:
                                    this.setDash(args[0], args[1]);
                                    break;
                                case _util.OPS.setRenderingIntent:
                                    this.setRenderingIntent(args[0]);
                                    break;
                                case _util.OPS.setFlatness:
                                    this.setFlatness(args[0]);
                                    break;
                                case _util.OPS.setGState:
                                    this.setGState(args[0]);
                                    break;
                                case _util.OPS.fill:
                                    this.fill();
                                    break;
                                case _util.OPS.eoFill:
                                    this.eoFill();
                                    break;
                                case _util.OPS.stroke:
                                    this.stroke();
                                    break;
                                case _util.OPS.fillStroke:
                                    this.fillStroke();
                                    break;
                                case _util.OPS.eoFillStroke:
                                    this.eoFillStroke();
                                    break;
                                case _util.OPS.clip:
                                    this.clip("nonzero");
                                    break;
                                case _util.OPS.eoClip:
                                    this.clip("evenodd");
                                    break;
                                case _util.OPS.paintSolidColorImageMask:
                                    this.paintSolidColorImageMask();
                                    break;
                                case _util.OPS.paintImageXObject:
                                    this.paintImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintInlineImageXObject:
                                    this.paintInlineImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintImageMaskXObject:
                                    this.paintImageMaskXObject(args[0]);
                                    break;
                                case _util.OPS.paintFormXObjectBegin:
                                    this.paintFormXObjectBegin(args[0], args[1]);
                                    break;
                                case _util.OPS.paintFormXObjectEnd:
                                    this.paintFormXObjectEnd();
                                    break;
                                case _util.OPS.closePath:
                                    this.closePath();
                                    break;
                                case _util.OPS.closeStroke:
                                    this.closeStroke();
                                    break;
                                case _util.OPS.closeFillStroke:
                                    this.closeFillStroke();
                                    break;
                                case _util.OPS.closeEOFillStroke:
                                    this.closeEOFillStroke();
                                    break;
                                case _util.OPS.nextLine:
                                    this.nextLine();
                                    break;
                                case _util.OPS.transform:
                                    this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.constructPath:
                                    this.constructPath(args[0], args[1]);
                                    break;
                                case _util.OPS.endPath:
                                    this.endPath();
                                    break;
                                case 92:
                                    this.group(opTreeElement.items);
                                    break;
                                default:
                                    (0, _util.warn)(`Unimplemented operator ${fn}`);
                                    break;
                            }
                        }
                    }
                    setWordSpacing(wordSpacing) {
                        this.current.wordSpacing = wordSpacing;
                    }
                    setCharSpacing(charSpacing) {
                        this.current.charSpacing = charSpacing;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const current = this.current;
                        current.textMatrix = current.lineMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        current.textMatrixScale = Math.hypot(a, b);
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtElement.append(current.tspan);
                    }
                    beginText() {
                        const current = this.current;
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.textMatrix = _util.IDENTITY_MATRIX;
                        current.lineMatrix = _util.IDENTITY_MATRIX;
                        current.textMatrixScale = 1;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtgrp = this.svgFactory.createElement("svg:g");
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    moveText(x, y) {
                        const current = this.current;
                        current.x = current.lineX += x;
                        current.y = current.lineY += y;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        let x = 0;
                        for (const glyph of glyphs){
                            if (glyph === null) {
                                x += fontDirection * wordSpacing;
                                continue;
                            } else if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                let vx;
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                vx = -vx * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (glyph.isInFont || font.missingFile) {
                                current.xcoords.push(current.x + scaledX);
                                if (vertical) current.ycoords.push(-current.y + scaledY);
                                current.tspan.textContent += character;
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                        }
                        current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                        if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                        else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                        const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                            if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                        else current.tspan.setAttributeNS(null, "fill", "none");
                        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            const lineWidthScale = 1 / (current.textMatrixScale || 1);
                            this._setStrokeAttributes(current.tspan, lineWidthScale);
                        }
                        let textMatrix = current.textMatrix;
                        if (current.textRise !== 0) {
                            textMatrix = textMatrix.slice();
                            textMatrix[5] += current.textRise;
                        }
                        current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                        current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                        current.txtElement.append(current.tspan);
                        current.txtgrp.append(current.txtElement);
                        this._ensureTransformGroup().append(current.txtElement);
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    addFontStyle(fontObj) {
                        if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                        if (!this.cssStyle) {
                            this.cssStyle = this.svgFactory.createElement("svg:style");
                            this.cssStyle.setAttributeNS(null, "type", "text/css");
                            this.defs.append(this.cssStyle);
                        }
                        const url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                        this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}";` + ` src: url(${url}); }\n`;
                    }
                    setFont(details) {
                        const current = this.current;
                        const fontObj = this.commonObjs.get(details[0]);
                        let size = details[1];
                        current.font = fontObj;
                        if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                            this.addFontStyle(fontObj);
                            this.embeddedFonts[fontObj.loadedName] = fontObj;
                        }
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        current.fontSize = size;
                        current.fontFamily = fontObj.loadedName;
                        current.fontWeight = bold;
                        current.fontStyle = italic;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    endText() {
                        const current = this.current;
                        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement?.hasChildNodes()) {
                            current.element = current.txtElement;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    setLineWidth(width) {
                        if (width > 0) this.current.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.current.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.current.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.current.miterLimit = limit;
                    }
                    setStrokeAlpha(strokeAlpha) {
                        this.current.strokeAlpha = strokeAlpha;
                    }
                    setStrokeRGBColor(r, g, b) {
                        this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                    }
                    setFillAlpha(fillAlpha) {
                        this.current.fillAlpha = fillAlpha;
                    }
                    setFillRGBColor(r, g, b) {
                        this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                        this.current.tspan = this.svgFactory.createElement("svg:tspan");
                        this.current.xcoords = [];
                        this.current.ycoords = [];
                    }
                    setStrokeColorN(args) {
                        this.current.strokeColor = this._makeColorN_Pattern(args);
                    }
                    setFillColorN(args) {
                        this.current.fillColor = this._makeColorN_Pattern(args);
                    }
                    shadingFill(args) {
                        const { width, height } = this.viewport;
                        const inv = _util.Util.inverseTransform(this.transformMatrix);
                        const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                            0,
                            0,
                            width,
                            height
                        ], inv);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", x0);
                        rect.setAttributeNS(null, "y", y0);
                        rect.setAttributeNS(null, "width", x1 - x0);
                        rect.setAttributeNS(null, "height", y1 - y0);
                        rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                        if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                        this._ensureTransformGroup().append(rect);
                    }
                    _makeColorN_Pattern(args) {
                        if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                        return this._makeShadingPattern(args);
                    }
                    _makeTilingPattern(args) {
                        const color = args[1];
                        const operatorList = args[2];
                        const matrix = args[3] || _util.IDENTITY_MATRIX;
                        const [x0, y0, x1, y1] = args[4];
                        const xstep = args[5];
                        const ystep = args[6];
                        const paintType = args[7];
                        const tilingId = `shading${shadingCount++}`;
                        const [tx0, ty0, tx1, ty1] = _util.Util.normalizeRect([
                            ..._util.Util.applyTransform([
                                x0,
                                y0
                            ], matrix),
                            ..._util.Util.applyTransform([
                                x1,
                                y1
                            ], matrix)
                        ]);
                        const [xscale, yscale] = _util.Util.singularValueDecompose2dScale(matrix);
                        const txstep = xstep * xscale;
                        const tystep = ystep * yscale;
                        const tiling = this.svgFactory.createElement("svg:pattern");
                        tiling.setAttributeNS(null, "id", tilingId);
                        tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                        tiling.setAttributeNS(null, "width", txstep);
                        tiling.setAttributeNS(null, "height", tystep);
                        tiling.setAttributeNS(null, "x", `${tx0}`);
                        tiling.setAttributeNS(null, "y", `${ty0}`);
                        const svg = this.svg;
                        const transformMatrix = this.transformMatrix;
                        const fillColor = this.current.fillColor;
                        const strokeColor = this.current.strokeColor;
                        const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                        this.svg = bbox;
                        this.transformMatrix = matrix;
                        if (paintType === 2) {
                            const cssColor = _util.Util.makeHexColor(...color);
                            this.current.fillColor = cssColor;
                            this.current.strokeColor = cssColor;
                        }
                        this.executeOpTree(this.convertOpList(operatorList));
                        this.svg = svg;
                        this.transformMatrix = transformMatrix;
                        this.current.fillColor = fillColor;
                        this.current.strokeColor = strokeColor;
                        tiling.append(bbox.childNodes[0]);
                        this.defs.append(tiling);
                        return `url(#${tilingId})`;
                    }
                    _makeShadingPattern(args) {
                        if (typeof args === "string") args = this.objs.get(args);
                        switch(args[0]){
                            case "RadialAxial":
                                const shadingId = `shading${shadingCount++}`;
                                const colorStops = args[3];
                                let gradient;
                                switch(args[1]){
                                    case "axial":
                                        const point0 = args[4];
                                        const point1 = args[5];
                                        gradient = this.svgFactory.createElement("svg:linearGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "x1", point0[0]);
                                        gradient.setAttributeNS(null, "y1", point0[1]);
                                        gradient.setAttributeNS(null, "x2", point1[0]);
                                        gradient.setAttributeNS(null, "y2", point1[1]);
                                        break;
                                    case "radial":
                                        const focalPoint = args[4];
                                        const circlePoint = args[5];
                                        const focalRadius = args[6];
                                        const circleRadius = args[7];
                                        gradient = this.svgFactory.createElement("svg:radialGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                        gradient.setAttributeNS(null, "r", circleRadius);
                                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                        gradient.setAttributeNS(null, "fr", focalRadius);
                                        break;
                                    default:
                                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                                }
                                for (const colorStop of colorStops){
                                    const stop = this.svgFactory.createElement("svg:stop");
                                    stop.setAttributeNS(null, "offset", colorStop[0]);
                                    stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                    gradient.append(stop);
                                }
                                this.defs.append(gradient);
                                return `url(#${shadingId})`;
                            case "Mesh":
                                (0, _util.warn)("Unimplemented pattern Mesh");
                                return null;
                            case "Dummy":
                                return "hotpink";
                            default:
                                throw new Error(`Unknown IR type: ${args[0]}`);
                        }
                    }
                    setDash(dashArray, dashPhase) {
                        this.current.dashArray = dashArray;
                        this.current.dashPhase = dashPhase;
                    }
                    constructPath(ops, args) {
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let d = [];
                        let j = 0;
                        for (const op of ops)switch(op | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("M", pf(x), pf(y));
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("L", pf(x), pf(y));
                                break;
                            case _util.OPS.curveTo:
                                x = args[j + 4];
                                y = args[j + 5];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                x = args[j + 2];
                                y = args[j + 3];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                d.push("Z");
                                break;
                        }
                        d = d.join(" ");
                        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                        else {
                            current.path = this.svgFactory.createElement("svg:path");
                            this._ensureTransformGroup().append(current.path);
                        }
                        current.path.setAttributeNS(null, "d", d);
                        current.path.setAttributeNS(null, "fill", "none");
                        current.element = current.path;
                        current.setCurrentPoint(x, y);
                    }
                    endPath() {
                        const current = this.current;
                        current.path = null;
                        if (!this.pendingClip) return;
                        if (!current.element) {
                            this.pendingClip = null;
                            return;
                        }
                        const clipId = `clippath${clipCount++}`;
                        const clipPath = this.svgFactory.createElement("svg:clipPath");
                        clipPath.setAttributeNS(null, "id", clipId);
                        clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                        const clipElement = current.element.cloneNode(true);
                        if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                        else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                        this.pendingClip = null;
                        clipPath.append(clipElement);
                        this.defs.append(clipPath);
                        if (current.activeClipUrl) {
                            current.clipGroup = null;
                            for (const prev of this.extraStack)prev.clipGroup = null;
                            clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                        }
                        current.activeClipUrl = `url(#${clipId})`;
                        this.tgrp = null;
                    }
                    clip(type) {
                        this.pendingClip = type;
                    }
                    closePath() {
                        const current = this.current;
                        if (current.path) {
                            const d = `${current.path.getAttributeNS(null, "d")}Z`;
                            current.path.setAttributeNS(null, "d", d);
                        }
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setTextRise(textRise) {
                        this.current.textRise = textRise;
                    }
                    setTextRenderingMode(textRenderingMode) {
                        this.current.textRenderingMode = textRenderingMode;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value);
                                break;
                            case "CA":
                                this.setStrokeAlpha(value);
                                break;
                            case "ca":
                                this.setFillAlpha(value);
                                break;
                            default:
                                (0, _util.warn)(`Unimplemented graphic state operator ${key}`);
                                break;
                        }
                    }
                    fill() {
                        const current = this.current;
                        if (current.element) {
                            current.element.setAttributeNS(null, "fill", current.fillColor);
                            current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                            this.endPath();
                        }
                    }
                    stroke() {
                        const current = this.current;
                        if (current.element) {
                            this._setStrokeAttributes(current.element);
                            current.element.setAttributeNS(null, "fill", "none");
                            this.endPath();
                        }
                    }
                    _setStrokeAttributes(element, lineWidthScale = 1) {
                        const current = this.current;
                        let dashArray = current.dashArray;
                        if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                            return lineWidthScale * value;
                        });
                        element.setAttributeNS(null, "stroke", current.strokeColor);
                        element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                        element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                        element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                        element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                        element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                        element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                        element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                    }
                    eoFill() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fill();
                    }
                    fillStroke() {
                        this.stroke();
                        this.fill();
                    }
                    eoFillStroke() {
                        this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fillStroke();
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.closePath();
                        this.eoFillStroke();
                    }
                    paintSolidColorImageMask() {
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", "1px");
                        rect.setAttributeNS(null, "height", "1px");
                        rect.setAttributeNS(null, "fill", this.current.fillColor);
                        this._ensureTransformGroup().append(rect);
                    }
                    paintImageXObject(objId) {
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintInlineImageXObject(imgData, mask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                        const cliprect = this.svgFactory.createElement("svg:rect");
                        cliprect.setAttributeNS(null, "x", "0");
                        cliprect.setAttributeNS(null, "y", "0");
                        cliprect.setAttributeNS(null, "width", pf(width));
                        cliprect.setAttributeNS(null, "height", pf(height));
                        this.current.element = cliprect;
                        this.clip("nonzero");
                        const imgEl = this.svgFactory.createElement("svg:image");
                        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                        imgEl.setAttributeNS(null, "x", "0");
                        imgEl.setAttributeNS(null, "y", pf(-height));
                        imgEl.setAttributeNS(null, "width", pf(width) + "px");
                        imgEl.setAttributeNS(null, "height", pf(height) + "px");
                        imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                        if (mask) mask.append(imgEl);
                        else this._ensureTransformGroup().append(imgEl);
                    }
                    paintImageMaskXObject(img) {
                        const imgData = this.getObject(img.data, img);
                        if (imgData.bitmap) {
                            (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                            return;
                        }
                        const current = this.current;
                        const width = imgData.width;
                        const height = imgData.height;
                        const fillColor = current.fillColor;
                        current.maskId = `mask${maskCount++}`;
                        const mask = this.svgFactory.createElement("svg:mask");
                        mask.setAttributeNS(null, "id", current.maskId);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", pf(width));
                        rect.setAttributeNS(null, "height", pf(height));
                        rect.setAttributeNS(null, "fill", fillColor);
                        rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                        this.defs.append(mask);
                        this._ensureTransformGroup().append(rect);
                        this.paintInlineImageXObject(imgData, mask);
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            const cliprect = this.svgFactory.createElement("svg:rect");
                            cliprect.setAttributeNS(null, "x", bbox[0]);
                            cliprect.setAttributeNS(null, "y", bbox[1]);
                            cliprect.setAttributeNS(null, "width", pf(width));
                            cliprect.setAttributeNS(null, "height", pf(height));
                            this.current.element = cliprect;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {}
                    _initialize(viewport) {
                        const svg = this.svgFactory.create(viewport.width, viewport.height);
                        const definitions = this.svgFactory.createElement("svg:defs");
                        svg.append(definitions);
                        this.defs = definitions;
                        const rootGroup = this.svgFactory.createElement("svg:g");
                        rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                        svg.append(rootGroup);
                        this.svg = rootGroup;
                        return svg;
                    }
                    _ensureClipGroup() {
                        if (!this.current.clipGroup) {
                            const clipGroup = this.svgFactory.createElement("svg:g");
                            clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                            this.svg.append(clipGroup);
                            this.current.clipGroup = clipGroup;
                        }
                        return this.current.clipGroup;
                    }
                    _ensureTransformGroup() {
                        if (!this.tgrp) {
                            this.tgrp = this.svgFactory.createElement("svg:g");
                            this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                            if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                            else this.svg.append(this.tgrp);
                        }
                        return this.tgrp;
                    }
                }
                exports.SVGGraphics = SVGGraphics;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                class XfaText {
                    static textContent(xfa) {
                        const items = [];
                        const output = {
                            items: items,
                            styles: Object.create(null)
                        };
                        function walk(node) {
                            if (!node) return;
                            let str = null;
                            const name = node.name;
                            if (name === "#text") str = node.value;
                            else if (!XfaText.shouldBuildText(name)) return;
                            else if (node?.attributes?.textContent) str = node.attributes.textContent;
                            else if (node.value) str = node.value;
                            if (str !== null) items.push({
                                str: str
                            });
                            if (!node.children) return;
                            for (const child of node.children)walk(child);
                        }
                        walk(xfa);
                        return output;
                    }
                    static shouldBuildText(name) {
                        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                    }
                }
                exports.XfaText = XfaText;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextLayerRenderTask = void 0;
                exports.renderTextLayer = renderTextLayer;
                exports.updateTextLayer = updateTextLayer;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const MAX_TEXT_DIVS_TO_RENDER = 100000;
                const DEFAULT_FONT_SIZE = 30;
                const DEFAULT_FONT_ASCENT = 0.8;
                const ascentCache = new Map();
                function getCtx(size, isOffscreenCanvasSupported) {
                    let ctx;
                    if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(size, size).getContext("2d", {
                        alpha: false
                    });
                    else {
                        const canvas = document.createElement("canvas");
                        canvas.width = canvas.height = size;
                        ctx = canvas.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx;
                }
                function getAscent(fontFamily, isOffscreenCanvasSupported) {
                    const cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    const ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
                    ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
                    const metrics = ctx.measureText("");
                    let ascent = metrics.fontBoundingBoxAscent;
                    let descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        ctx.canvas.width = ctx.canvas.height = 0;
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(let i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(let i = 0, ii = pixels.length; i < ii; i += 4)if (pixels[i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.canvas.width = ctx.canvas.height = 0;
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles) {
                    const textDiv = document.createElement("span");
                    const textDivProperties = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        fontSize: 0
                    };
                    task._textDivs.push(textDiv);
                    const tx = _util.Util.transform(task._transform, geom.transform);
                    let angle = Math.atan2(tx[1], tx[0]);
                    const style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    const fontHeight = Math.hypot(tx[2], tx[3]);
                    const fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
                    let left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    const scaleFactorStr = "calc(var(--scale-factor)*";
                    const divStyle = textDiv.style;
                    if (task._container === task._rootContainer) {
                        divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
                        divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
                    } else {
                        divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
                        divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
                    }
                    divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
                    divStyle.fontFamily = style.fontFamily;
                    textDivProperties.fontSize = fontHeight;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    let shouldScaleText = false;
                    if (geom.str.length > 1) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._isReadableStream) task._layoutText(textDiv);
                }
                function layout(params) {
                    const { div, scale, properties, ctx, prevFontSize, prevFontFamily } = params;
                    const { style } = div;
                    let transform = "";
                    if (properties.canvasWidth !== 0 && properties.hasText) {
                        const { fontFamily } = style;
                        const { canvasWidth, fontSize } = properties;
                        if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                            ctx.font = `${fontSize * scale}px ${fontFamily}`;
                            params.prevFontSize = fontSize;
                            params.prevFontFamily = fontFamily;
                        }
                        const { width } = ctx.measureText(div.textContent);
                        if (width > 0) transform = `scaleX(${canvasWidth * scale / width})`;
                    }
                    if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
                    if (transform.length > 0) style.transform = transform;
                }
                function render(task) {
                    if (task._canceled) return;
                    const textDivs = task._textDivs;
                    const capability = task._capability;
                    const textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        capability.resolve();
                        return;
                    }
                    if (!task._isReadableStream) for (const textDiv of textDivs)task._layoutText(textDiv);
                    capability.resolve();
                }
                class TextLayerRenderTask {
                    constructor({ textContentSource, container, viewport, textDivs, textDivProperties, textContentItemsStr, isOffscreenCanvasSupported }){
                        this._textContentSource = textContentSource;
                        this._isReadableStream = textContentSource instanceof ReadableStream;
                        this._container = this._rootContainer = container;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                        this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                        this._reader = null;
                        this._textDivProperties = textDivProperties || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx(0, isOffscreenCanvasSupported)
                        };
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX,
                            pageY + pageHeight
                        ];
                        this._pageWidth = pageWidth;
                        this._pageHeight = pageHeight;
                        (0, _display_utils.setLayerDimensions)(container, viewport);
                        this._capability.promise.finally(()=>{
                            this._layoutTextParams = null;
                        }).catch(()=>{});
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(()=>{});
                            this._reader = null;
                        }
                        this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
                    }
                    _processItems(items, styleCache) {
                        for (const item of items){
                            if (item.str === undefined) {
                                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                                    const parent = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (item.id !== null) this._container.setAttribute("id", `${item.id}`);
                                    parent.append(this._container);
                                } else if (item.type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(item.str);
                            appendText(this, item, styleCache);
                        }
                    }
                    _layoutText(textDiv) {
                        const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                        this._layoutTextParams.div = textDiv;
                        layout(this._layoutTextParams);
                        if (textDivProperties.hasText) this._container.append(textDiv);
                        if (textDivProperties.hasEOL) {
                            const br = document.createElement("br");
                            br.setAttribute("role", "presentation");
                            this._container.append(br);
                        }
                    }
                    _render() {
                        const capability = new _util.PromiseCapability();
                        let styleCache = Object.create(null);
                        if (this._isReadableStream) {
                            const pump = ()=>{
                                this._reader.read().then(({ value, done })=>{
                                    if (done) {
                                        capability.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache, value.styles);
                                    this._processItems(value.items, styleCache);
                                    pump();
                                }, capability.reject);
                            };
                            this._reader = this._textContentSource.getReader();
                            pump();
                        } else if (this._textContentSource) {
                            const { items, styles } = this._textContentSource;
                            this._processItems(items, styles);
                            capability.resolve();
                        } else throw new Error('No "textContentSource" parameter specified.');
                        capability.promise.then(()=>{
                            styleCache = null;
                            render(this);
                        }, this._capability.reject);
                    }
                }
                exports.TextLayerRenderTask = TextLayerRenderTask;
                function renderTextLayer(params) {
                    if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                        (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params.textContentSource = params.textContent || params.textContentStream;
                    }
                    const { container, viewport } = params;
                    const style = getComputedStyle(container);
                    const visibility = style.getPropertyValue("visibility");
                    const scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
                    if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    const task = new TextLayerRenderTask(params);
                    task._render();
                    return task;
                }
                function updateTextLayer({ container, viewport, textDivs, textDivProperties, isOffscreenCanvasSupported, mustRotate = true, mustRescale = true }) {
                    if (mustRotate) (0, _display_utils.setLayerDimensions)(container, {
                        rotation: viewport.rotation
                    });
                    if (mustRescale) {
                        const ctx = getCtx(0, isOffscreenCanvasSupported);
                        const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                        const params = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale,
                            properties: null,
                            ctx: ctx
                        };
                        for (const div of textDivs){
                            params.properties = textDivProperties.get(div);
                            params.div = div;
                            layout(params);
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditorLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _freetext = __w_pdfjs_require__(28);
                var _ink = __w_pdfjs_require__(33);
                var _display_utils = __w_pdfjs_require__(6);
                var _stamp = __w_pdfjs_require__(34);
                class AnnotationEditorLayer {
                    #accessibilityManager;
                    #allowClick = false;
                    #annotationLayer = null;
                    #boundPointerup = this.pointerup.bind(this);
                    #boundPointerdown = this.pointerdown.bind(this);
                    #editors = new Map();
                    #hadPointerDown = false;
                    #isCleaningUp = false;
                    #isDisabling = false;
                    #uiManager;
                    static _initialized = false;
                    constructor({ uiManager, pageIndex, div, accessibilityManager, annotationLayer, viewport, l10n }){
                        const editorTypes = [
                            _freetext.FreeTextEditor,
                            _ink.InkEditor,
                            _stamp.StampEditor
                        ];
                        if (!AnnotationEditorLayer._initialized) {
                            AnnotationEditorLayer._initialized = true;
                            for (const editorType of editorTypes)editorType.initialize(l10n);
                        }
                        uiManager.registerEditorTypes(editorTypes);
                        this.#uiManager = uiManager;
                        this.pageIndex = pageIndex;
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationLayer = annotationLayer;
                        this.viewport = viewport;
                        this.#uiManager.addLayer(this);
                    }
                    get isEmpty() {
                        return this.#editors.size === 0;
                    }
                    updateToolbar(mode) {
                        this.#uiManager.updateToolbar(mode);
                    }
                    updateMode(mode = this.#uiManager.getMode()) {
                        this.#cleanup();
                        if (mode === _util.AnnotationEditorType.INK) {
                            this.addInkEditorIfNeeded(false);
                            this.disableClick();
                        } else this.enableClick();
                        if (mode !== _util.AnnotationEditorType.NONE) {
                            this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
                            this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
                            this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
                            this.div.hidden = false;
                        }
                    }
                    addInkEditorIfNeeded(isCommitting) {
                        if (!isCommitting && this.#uiManager.getMode() !== _util.AnnotationEditorType.INK) return;
                        if (!isCommitting) {
                            for (const editor of this.#editors.values())if (editor.isEmpty()) {
                                editor.setInBackground();
                                return;
                            }
                        }
                        const editor = this.#createAndAddNewEditor({
                            offsetX: 0,
                            offsetY: 0
                        }, false);
                        editor.setInBackground();
                    }
                    setEditingState(isEditing) {
                        this.#uiManager.setEditingState(isEditing);
                    }
                    addCommands(params) {
                        this.#uiManager.addCommands(params);
                    }
                    enable() {
                        this.div.style.pointerEvents = "auto";
                        const annotationElementIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.enableEditing();
                            if (editor.annotationElementId) annotationElementIds.add(editor.annotationElementId);
                        }
                        if (!this.#annotationLayer) return;
                        const editables = this.#annotationLayer.getEditableAnnotations();
                        for (const editable of editables){
                            editable.hide();
                            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
                            if (annotationElementIds.has(editable.data.id)) continue;
                            const editor = this.deserialize(editable);
                            if (!editor) continue;
                            this.addOrRebuild(editor);
                            editor.enableEditing();
                        }
                    }
                    disable() {
                        this.#isDisabling = true;
                        this.div.style.pointerEvents = "none";
                        const hiddenAnnotationIds = new Set();
                        for (const editor of this.#editors.values()){
                            editor.disableEditing();
                            if (!editor.annotationElementId || editor.serialize() !== null) {
                                hiddenAnnotationIds.add(editor.annotationElementId);
                                continue;
                            }
                            this.getEditableAnnotation(editor.annotationElementId)?.show();
                            editor.remove();
                        }
                        if (this.#annotationLayer) {
                            const editables = this.#annotationLayer.getEditableAnnotations();
                            for (const editable of editables){
                                const { id } = editable.data;
                                if (hiddenAnnotationIds.has(id) || this.#uiManager.isDeletedAnnotationElement(id)) continue;
                                editable.show();
                            }
                        }
                        this.#cleanup();
                        if (this.isEmpty) this.div.hidden = true;
                        this.#isDisabling = false;
                    }
                    getEditableAnnotation(id) {
                        return this.#annotationLayer?.getEditableAnnotation(id) || null;
                    }
                    setActiveEditor(editor) {
                        const currentActive = this.#uiManager.getActive();
                        if (currentActive === editor) return;
                        this.#uiManager.setActiveEditor(editor);
                    }
                    enableClick() {
                        this.div.addEventListener("pointerdown", this.#boundPointerdown);
                        this.div.addEventListener("pointerup", this.#boundPointerup);
                    }
                    disableClick() {
                        this.div.removeEventListener("pointerdown", this.#boundPointerdown);
                        this.div.removeEventListener("pointerup", this.#boundPointerup);
                    }
                    attach(editor) {
                        this.#editors.set(editor.id, editor);
                        const { annotationElementId } = editor;
                        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
                    }
                    detach(editor) {
                        this.#editors.delete(editor.id);
                        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
                    }
                    remove(editor) {
                        this.detach(editor);
                        this.#uiManager.removeEditor(editor);
                        if (editor.div.contains(document.activeElement)) setTimeout(()=>{
                            this.#uiManager.focusMainContainer();
                        }, 0);
                        editor.div.remove();
                        editor.isAttachedToDOM = false;
                        if (!this.#isCleaningUp) this.addInkEditorIfNeeded(false);
                    }
                    changeParent(editor) {
                        if (editor.parent === this) return;
                        if (editor.annotationElementId) {
                            this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
                            _editor.AnnotationEditor.deleteAnnotationElement(editor);
                            editor.annotationElementId = null;
                        }
                        this.attach(editor);
                        editor.parent?.detach(editor);
                        editor.setParent(this);
                        if (editor.div && editor.isAttachedToDOM) {
                            editor.div.remove();
                            this.div.append(editor.div);
                        }
                    }
                    add(editor) {
                        this.changeParent(editor);
                        this.#uiManager.addEditor(editor);
                        this.attach(editor);
                        if (!editor.isAttachedToDOM) {
                            const div = editor.render();
                            this.div.append(div);
                            editor.isAttachedToDOM = true;
                        }
                        editor.fixAndSetPosition();
                        editor.onceAdded();
                        this.#uiManager.addToAnnotationStorage(editor);
                    }
                    moveEditorInDOM(editor) {
                        if (!editor.isAttachedToDOM) return;
                        const { activeElement } = document;
                        if (editor.div.contains(activeElement)) {
                            editor._focusEventsAllowed = false;
                            setTimeout(()=>{
                                if (!editor.div.contains(document.activeElement)) {
                                    editor.div.addEventListener("focusin", ()=>{
                                        editor._focusEventsAllowed = true;
                                    }, {
                                        once: true
                                    });
                                    activeElement.focus();
                                } else editor._focusEventsAllowed = true;
                            }, 0);
                        }
                        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                    }
                    addOrRebuild(editor) {
                        if (editor.needsToBeRebuilt()) editor.rebuild();
                        else this.add(editor);
                    }
                    addUndoableEditor(editor) {
                        const cmd = ()=>editor._uiManager.rebuild(editor);
                        const undo = ()=>{
                            editor.remove();
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: false
                        });
                    }
                    getNextId() {
                        return this.#uiManager.getId();
                    }
                    #createNewEditor(params) {
                        switch(this.#uiManager.getMode()){
                            case _util.AnnotationEditorType.FREETEXT:
                                return new _freetext.FreeTextEditor(params);
                            case _util.AnnotationEditorType.INK:
                                return new _ink.InkEditor(params);
                            case _util.AnnotationEditorType.STAMP:
                                return new _stamp.StampEditor(params);
                        }
                        return null;
                    }
                    pasteEditor(mode, params) {
                        this.#uiManager.updateToolbar(mode);
                        this.#uiManager.updateMode(mode);
                        const { offsetX, offsetY } = this.#getCenterPoint();
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: offsetX,
                            y: offsetY,
                            uiManager: this.#uiManager,
                            isCentered: true,
                            ...params
                        });
                        if (editor) this.add(editor);
                    }
                    deserialize(data) {
                        switch(data.annotationType ?? data.annotationEditorType){
                            case _util.AnnotationEditorType.FREETEXT:
                                return _freetext.FreeTextEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.INK:
                                return _ink.InkEditor.deserialize(data, this, this.#uiManager);
                            case _util.AnnotationEditorType.STAMP:
                                return _stamp.StampEditor.deserialize(data, this, this.#uiManager);
                        }
                        return null;
                    }
                    #createAndAddNewEditor(event, isCentered) {
                        const id = this.getNextId();
                        const editor = this.#createNewEditor({
                            parent: this,
                            id: id,
                            x: event.offsetX,
                            y: event.offsetY,
                            uiManager: this.#uiManager,
                            isCentered: isCentered
                        });
                        if (editor) this.add(editor);
                        return editor;
                    }
                    #getCenterPoint() {
                        const { x, y, width, height } = this.div.getBoundingClientRect();
                        const tlX = Math.max(0, x);
                        const tlY = Math.max(0, y);
                        const brX = Math.min(window.innerWidth, x + width);
                        const brY = Math.min(window.innerHeight, y + height);
                        const centerX = (tlX + brX) / 2 - x;
                        const centerY = (tlY + brY) / 2 - y;
                        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
                            centerX,
                            centerY
                        ] : [
                            centerY,
                            centerX
                        ];
                        return {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                    }
                    addNewEditor() {
                        this.#createAndAddNewEditor(this.#getCenterPoint(), true);
                    }
                    setSelected(editor) {
                        this.#uiManager.setSelected(editor);
                    }
                    toggleSelected(editor) {
                        this.#uiManager.toggleSelected(editor);
                    }
                    isSelected(editor) {
                        return this.#uiManager.isSelected(editor);
                    }
                    unselect(editor) {
                        this.#uiManager.unselect(editor);
                    }
                    pointerup(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        if (!this.#hadPointerDown) return;
                        this.#hadPointerDown = false;
                        if (!this.#allowClick) {
                            this.#allowClick = true;
                            return;
                        }
                        if (this.#uiManager.getMode() === _util.AnnotationEditorType.STAMP) {
                            this.#uiManager.unselectAll();
                            return;
                        }
                        this.#createAndAddNewEditor(event, false);
                    }
                    pointerdown(event) {
                        if (this.#hadPointerDown) {
                            this.#hadPointerDown = false;
                            return;
                        }
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        this.#hadPointerDown = true;
                        const editor = this.#uiManager.getActive();
                        this.#allowClick = !editor || editor.isEmpty();
                    }
                    findNewParent(editor, x, y) {
                        const layer = this.#uiManager.findParent(x, y);
                        if (layer === null || layer === this) return false;
                        layer.changeParent(editor);
                        return true;
                    }
                    destroy() {
                        if (this.#uiManager.getActive()?.parent === this) {
                            this.#uiManager.commitOrRemove();
                            this.#uiManager.setActiveEditor(null);
                        }
                        for (const editor of this.#editors.values()){
                            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
                            editor.setParent(null);
                            editor.isAttachedToDOM = false;
                            editor.div.remove();
                        }
                        this.div = null;
                        this.#editors.clear();
                        this.#uiManager.removeLayer(this);
                    }
                    #cleanup() {
                        this.#isCleaningUp = true;
                        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
                        this.#isCleaningUp = false;
                    }
                    render({ viewport }) {
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, viewport);
                        for (const editor of this.#uiManager.getEditors(this.pageIndex))this.add(editor);
                        this.updateMode();
                    }
                    update({ viewport }) {
                        this.#uiManager.commitOrRemove();
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, {
                            rotation: viewport.rotation
                        });
                        this.updateMode();
                    }
                    get pageDimensions() {
                        const { pageWidth, pageHeight } = this.viewport.rawDims;
                        return [
                            pageWidth,
                            pageHeight
                        ];
                    }
                }
                exports.AnnotationEditorLayer = AnnotationEditorLayer;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FreeTextEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _tools = __w_pdfjs_require__(5);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                class FreeTextEditor extends _editor.AnnotationEditor {
                    #boundEditorDivBlur = this.editorDivBlur.bind(this);
                    #boundEditorDivFocus = this.editorDivFocus.bind(this);
                    #boundEditorDivInput = this.editorDivInput.bind(this);
                    #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
                    #color;
                    #content = "";
                    #editorDivId = `${this.id}-editor`;
                    #fontSize;
                    #initialData = null;
                    static _freeTextDefaultContent = "";
                    static _internalPadding = 0;
                    static _defaultColor = null;
                    static _defaultFontSize = 10;
                    static get _keyboardManager() {
                        const proto = FreeTextEditor.prototype;
                        const arrowChecker = (self)=>self.isEmpty();
                        const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                        const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([
                            [
                                [
                                    "ctrl+s",
                                    "mac+meta+s",
                                    "ctrl+p",
                                    "mac+meta+p"
                                ],
                                proto.commitOrRemove,
                                {
                                    bubbles: true
                                }
                            ],
                            [
                                [
                                    "ctrl+Enter",
                                    "mac+meta+Enter",
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.commitOrRemove
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    static _type = "freetext";
                    constructor(params){
                        super({
                            ...params,
                            name: "freeTextEditor"
                        });
                        this.#color = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                        this.#fontSize = params.fontSize || FreeTextEditor._defaultFontSize;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "free_text2_default_content",
                                "editor_free_text2_aria_label"
                            ]
                        });
                        const style = getComputedStyle(document.documentElement);
                        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                FreeTextEditor._defaultFontSize = value;
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                FreeTextEditor._defaultColor = value;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                this.#updateFontSize(value);
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                this.#updateColor(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                FreeTextEditor._defaultFontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                this.#fontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                this.#color
                            ]
                        ];
                    }
                    #updateFontSize(fontSize) {
                        const setFontsize = (size)=>{
                            this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
                            this.translate(0, -(size - this.#fontSize) * this.parentScale);
                            this.#fontSize = size;
                            this.#setEditorDimensions();
                        };
                        const savedFontsize = this.#fontSize;
                        this.addCommands({
                            cmd: ()=>{
                                setFontsize(fontSize);
                            },
                            undo: ()=>{
                                setFontsize(savedFontsize);
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.#color;
                        this.addCommands({
                            cmd: ()=>{
                                this.#color = this.editorDiv.style.color = color;
                            },
                            undo: ()=>{
                                this.#color = this.editorDiv.style.color = savedColor;
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    _translateEmpty(x, y) {
                        this._uiManager.translateSelectedEditors(x, y, true);
                    }
                    getInitialTranslation() {
                        const scale = this.parentScale;
                        return [
                            -FreeTextEditor._internalPadding * scale,
                            -(FreeTextEditor._internalPadding + this.#fontSize) * scale
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    enableEditMode() {
                        if (this.isInEditMode()) return;
                        this.parent.setEditingState(false);
                        this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
                        super.enableEditMode();
                        this.overlayDiv.classList.remove("enabled");
                        this.editorDiv.contentEditable = true;
                        this._isDraggable = false;
                        this.div.removeAttribute("aria-activedescendant");
                        this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode()) return;
                        this.parent.setEditingState(true);
                        super.disableEditMode();
                        this.overlayDiv.classList.add("enabled");
                        this.editorDiv.contentEditable = false;
                        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
                        this._isDraggable = true;
                        this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
                        this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
                        this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
                        this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
                        this.div.focus({
                            preventScroll: true
                        });
                        this.isEditing = false;
                        this.parent.div.classList.add("freeTextEditing");
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        if (event.target !== this.editorDiv) this.editorDiv.focus();
                    }
                    onceAdded() {
                        if (this.width) {
                            this.#cheatInitialRect();
                            return;
                        }
                        this.enableEditMode();
                        this.editorDiv.focus();
                        if (this._initialOptions?.isCentered) this.center();
                        this._initialOptions = null;
                    }
                    isEmpty() {
                        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                    }
                    remove() {
                        this.isEditing = false;
                        if (this.parent) {
                            this.parent.setEditingState(true);
                            this.parent.div.classList.add("freeTextEditing");
                        }
                        super.remove();
                    }
                    #extractText() {
                        const divs = this.editorDiv.getElementsByTagName("div");
                        if (divs.length === 0) return this.editorDiv.innerText;
                        const buffer = [];
                        for (const div of divs)buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                        return buffer.join("\n");
                    }
                    #setEditorDimensions() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        let rect;
                        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
                        else {
                            const { currentLayer, div } = this;
                            const savedDisplay = div.style.display;
                            div.style.display = "hidden";
                            currentLayer.div.append(this.div);
                            rect = div.getBoundingClientRect();
                            div.remove();
                            div.style.display = savedDisplay;
                        }
                        if (this.rotation % 180 === this.parentRotation % 180) {
                            this.width = rect.width / parentWidth;
                            this.height = rect.height / parentHeight;
                        } else {
                            this.width = rect.height / parentWidth;
                            this.height = rect.width / parentHeight;
                        }
                        this.fixAndSetPosition();
                    }
                    commit() {
                        if (!this.isInEditMode()) return;
                        super.commit();
                        this.disableEditMode();
                        const savedText = this.#content;
                        const newText = this.#content = this.#extractText().trimEnd();
                        if (savedText === newText) return;
                        const setText = (text)=>{
                            this.#content = text;
                            if (!text) {
                                this.remove();
                                return;
                            }
                            this.#setContent();
                            this._uiManager.rebuild(this);
                            this.#setEditorDimensions();
                        };
                        this.addCommands({
                            cmd: ()=>{
                                setText(newText);
                            },
                            undo: ()=>{
                                setText(savedText);
                            },
                            mustExec: false
                        });
                        this.#setEditorDimensions();
                    }
                    shouldGetKeyboardEvents() {
                        return this.isInEditMode();
                    }
                    enterInEditMode() {
                        this.enableEditMode();
                        this.editorDiv.focus();
                    }
                    dblclick(event) {
                        this.enterInEditMode();
                    }
                    keydown(event) {
                        if (event.target === this.div && event.key === "Enter") {
                            this.enterInEditMode();
                            event.preventDefault();
                        }
                    }
                    editorDivKeydown(event) {
                        FreeTextEditor._keyboardManager.exec(this, event);
                    }
                    editorDivFocus(event) {
                        this.isEditing = true;
                    }
                    editorDivBlur(event) {
                        this.isEditing = false;
                    }
                    editorDivInput(event) {
                        this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                    }
                    disableEditing() {
                        this.editorDiv.setAttribute("role", "comment");
                        this.editorDiv.removeAttribute("aria-multiline");
                    }
                    enableEditing() {
                        this.editorDiv.setAttribute("role", "textbox");
                        this.editorDiv.setAttribute("aria-multiline", true);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.editorDiv = document.createElement("div");
                        this.editorDiv.className = "internal";
                        this.editorDiv.setAttribute("id", this.#editorDivId);
                        this.enableEditing();
                        _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg)=>this.editorDiv?.setAttribute("aria-label", msg));
                        _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg)=>this.editorDiv?.setAttribute("default-content", msg));
                        this.editorDiv.contentEditable = true;
                        const { style } = this.editorDiv;
                        style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
                        style.color = this.#color;
                        this.div.append(this.editorDiv);
                        this.overlayDiv = document.createElement("div");
                        this.overlayDiv.classList.add("overlay", "enabled");
                        this.div.append(this.overlayDiv);
                        (0, _tools.bindEvents)(this, this.div, [
                            "dblclick",
                            "keydown"
                        ]);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            if (this.annotationElementId) {
                                const { position } = this.#initialData;
                                let [tx, ty] = this.getInitialTranslation();
                                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                const [pageX, pageY] = this.pageTranslation;
                                let posX, posY;
                                switch(this.rotation){
                                    case 0:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                                        break;
                                    case 90:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            ty,
                                            -tx
                                        ];
                                        break;
                                    case 180:
                                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            -tx,
                                            -ty
                                        ];
                                        break;
                                    case 270:
                                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                                        [tx, ty] = [
                                            -ty,
                                            tx
                                        ];
                                        break;
                                }
                                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                            } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#setContent();
                            this._isDraggable = true;
                            this.editorDiv.contentEditable = false;
                        } else {
                            this._isDraggable = false;
                            this.editorDiv.contentEditable = true;
                        }
                        return this.div;
                    }
                    #setContent() {
                        this.editorDiv.replaceChildren();
                        if (!this.#content) return;
                        for (const line of this.#content.split("\n")){
                            const div = document.createElement("div");
                            div.append(line ? document.createTextNode(line) : document.createElement("br"));
                            this.editorDiv.append(div);
                        }
                    }
                    get contentDiv() {
                        return this.editorDiv;
                    }
                    static deserialize(data, parent, uiManager) {
                        let initialData = null;
                        if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
                            const { data: { defaultAppearanceData: { fontSize, fontColor }, rect, rotation, id }, textContent, textPosition, parent: { page: { pageNumber } } } = data;
                            if (!textContent || textContent.length === 0) return null;
                            initialData = data = {
                                annotationType: _util.AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor),
                                fontSize: fontSize,
                                value: textContent.join("\n"),
                                position: textPosition,
                                pageIndex: pageNumber - 1,
                                rect: rect,
                                rotation: rotation,
                                id: id,
                                deleted: false
                            };
                        }
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.#fontSize = data.fontSize;
                        editor.#color = _util.Util.makeHexColor(...data.color);
                        editor.#content = data.value;
                        editor.annotationElementId = data.id || null;
                        editor.#initialData = initialData;
                        return editor;
                    }
                    serialize(isForCopying = false) {
                        if (this.isEmpty()) return null;
                        if (this.deleted) return {
                            pageIndex: this.pageIndex,
                            id: this.annotationElementId,
                            deleted: true
                        };
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        const rect = this.getRect(padding, padding);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.FREETEXT,
                            color: color,
                            fontSize: this.#fontSize,
                            value: this.#content,
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) return serialized;
                        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
                        serialized.id = this.annotationElementId;
                        return serialized;
                    }
                    #hasElementChanged(serialized) {
                        const { value, fontSize, color, rect, pageIndex } = this.#initialData;
                        return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i)=>Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
                    }
                    #cheatInitialRect(delayed = false) {
                        if (!this.annotationElementId) return;
                        this.#setEditorDimensions();
                        if (!delayed && (this.width === 0 || this.height === 0)) {
                            setTimeout(()=>this.#cheatInitialRect(true), 0);
                            return;
                        }
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        this.#initialData.rect = this.getRect(padding, padding);
                    }
                }
                exports.FreeTextEditor = FreeTextEditor;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _scripting_utils = __w_pdfjs_require__(30);
                var _displayL10n_utils = __w_pdfjs_require__(31);
                var _xfa_layer = __w_pdfjs_require__(32);
                const DEFAULT_TAB_INDEX = 1000;
                const DEFAULT_FONT_SIZE = 9;
                const GetElementsByNameSet = new WeakSet();
                function getRectDims(rect) {
                    return {
                        width: rect[2] - rect[0],
                        height: rect[3] - rect[1]
                    };
                }
                class AnnotationElementFactory {
                    static create(parameters) {
                        const subtype = parameters.data.annotationType;
                        switch(subtype){
                            case _util.AnnotationType.LINK:
                                return new LinkAnnotationElement(parameters);
                            case _util.AnnotationType.TEXT:
                                return new TextAnnotationElement(parameters);
                            case _util.AnnotationType.WIDGET:
                                const fieldType = parameters.data.fieldType;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement(parameters);
                                    case "Btn":
                                        if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                        else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                        return new PushButtonWidgetAnnotationElement(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotationElement(parameters);
                                }
                                return new WidgetAnnotationElement(parameters);
                            case _util.AnnotationType.POPUP:
                                return new PopupAnnotationElement(parameters);
                            case _util.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement(parameters);
                            case _util.AnnotationType.LINE:
                                return new LineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUARE:
                                return new SquareAnnotationElement(parameters);
                            case _util.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement(parameters);
                            case _util.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement(parameters);
                            case _util.AnnotationType.CARET:
                                return new CaretAnnotationElement(parameters);
                            case _util.AnnotationType.INK:
                                return new InkAnnotationElement(parameters);
                            case _util.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement(parameters);
                            case _util.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement(parameters);
                            case _util.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement(parameters);
                            case _util.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement(parameters);
                            case _util.AnnotationType.STAMP:
                                return new StampAnnotationElement(parameters);
                            case _util.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement(parameters);
                            default:
                                return new AnnotationElement(parameters);
                        }
                    }
                }
                class AnnotationElement {
                    #hasBorder = false;
                    constructor(parameters, { isRenderable = false, ignoreBorder = false, createQuadrilaterals = false } = {}){
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this.parent = parameters.parent;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this._createQuadrilaterals();
                    }
                    static _hasPopupData({ titleObj, contentsObj, richText }) {
                        return !!(titleObj?.str || contentsObj?.str || richText?.str);
                    }
                    get hasPopupData() {
                        return AnnotationElement._hasPopupData(this.data);
                    }
                    _createContainer(ignoreBorder) {
                        const { data, parent: { page, viewport } } = this;
                        const container = document.createElement("section");
                        container.setAttribute("data-annotation-id", data.id);
                        if (!(this instanceof WidgetAnnotationElement)) container.tabIndex = DEFAULT_TAB_INDEX;
                        container.style.zIndex = this.parent.zIndex++;
                        if (this.data.popupRef) container.setAttribute("aria-haspopup", "dialog");
                        if (data.noRotate) container.classList.add("norotate");
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        if (!data.rect || this instanceof PopupAnnotationElement) {
                            const { rotation } = data;
                            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
                            return container;
                        }
                        const { width, height } = getRectDims(data.rect);
                        const rect = _util.Util.normalizeRect([
                            data.rect[0],
                            page.view[3] - data.rect[1] + page.view[1],
                            data.rect[2],
                            page.view[3] - data.rect[3] + page.view[1]
                        ]);
                        if (!ignoreBorder && data.borderStyle.width > 0) {
                            container.style.borderWidth = `${data.borderStyle.width}px`;
                            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
                            const verticalRadius = data.borderStyle.verticalCornerRadius;
                            if (horizontalRadius > 0 || verticalRadius > 0) {
                                const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                                const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            }
                            switch(data.borderStyle.style){
                                case _util.AnnotationBorderStyleType.SOLID:
                                    container.style.borderStyle = "solid";
                                    break;
                                case _util.AnnotationBorderStyleType.DASHED:
                                    container.style.borderStyle = "dashed";
                                    break;
                                case _util.AnnotationBorderStyleType.BEVELED:
                                    (0, _util.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util.AnnotationBorderStyleType.INSET:
                                    (0, _util.warn)("Unimplemented border style: inset");
                                    break;
                                case _util.AnnotationBorderStyleType.UNDERLINE:
                                    container.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            const borderColor = data.borderColor || null;
                            if (borderColor) {
                                this.#hasBorder = true;
                                container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                            } else container.style.borderWidth = 0;
                        }
                        container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                        container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                        const { rotation } = data;
                        if (data.hasOwnCanvas || rotation === 0) {
                            container.style.width = `${100 * width / pageWidth}%`;
                            container.style.height = `${100 * height / pageHeight}%`;
                        } else this.setRotation(rotation, container);
                        return container;
                    }
                    setRotation(angle, container = this.container) {
                        if (!this.data.rect) return;
                        const { pageWidth, pageHeight } = this.parent.viewport.rawDims;
                        const { width, height } = getRectDims(this.data.rect);
                        let elementWidth, elementHeight;
                        if (angle % 180 === 0) {
                            elementWidth = 100 * width / pageWidth;
                            elementHeight = 100 * height / pageHeight;
                        } else {
                            elementWidth = 100 * height / pageWidth;
                            elementHeight = 100 * width / pageHeight;
                        }
                        container.style.width = `${elementWidth}%`;
                        container.style.height = `${elementHeight}%`;
                        container.setAttribute("data-main-rotation", (360 - angle) % 360);
                    }
                    get _commonActions() {
                        const setColor = (jsName, styleName, event)=>{
                            const color = event.detail[jsName];
                            const colorType = color[0];
                            const colorArray = color.slice(1);
                            event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                            this.annotationStorage.setValue(this.data.id, {
                                [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                            });
                        };
                        return (0, _util.shadow)(this, "_commonActions", {
                            display: (event)=>{
                                const { display } = event.detail;
                                const hidden = display % 2 === 1;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noView: hidden,
                                    noPrint: display === 1 || display === 2
                                });
                            },
                            print: (event)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: !event.detail.print
                                });
                            },
                            hidden: (event)=>{
                                const { hidden } = event.detail;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: hidden,
                                    noView: hidden
                                });
                            },
                            focus: (event)=>{
                                setTimeout(()=>event.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event)=>{
                                event.target.title = event.detail.userName;
                            },
                            readonly: (event)=>{
                                event.target.disabled = event.detail.readonly;
                            },
                            required: (event)=>{
                                this._setRequired(event.target, event.detail.required);
                            },
                            bgColor: (event)=>{
                                setColor("bgColor", "backgroundColor", event);
                            },
                            fillColor: (event)=>{
                                setColor("fillColor", "backgroundColor", event);
                            },
                            fgColor: (event)=>{
                                setColor("fgColor", "color", event);
                            },
                            textColor: (event)=>{
                                setColor("textColor", "color", event);
                            },
                            borderColor: (event)=>{
                                setColor("borderColor", "borderColor", event);
                            },
                            strokeColor: (event)=>{
                                setColor("strokeColor", "borderColor", event);
                            },
                            rotation: (event)=>{
                                const angle = event.detail.rotation;
                                this.setRotation(angle);
                                this.annotationStorage.setValue(this.data.id, {
                                    rotation: angle
                                });
                            }
                        });
                    }
                    _dispatchEventFromSandbox(actions, jsEvent) {
                        const commonActions = this._commonActions;
                        for (const name of Object.keys(jsEvent.detail)){
                            const action = actions[name] || commonActions[name];
                            action?.(jsEvent);
                        }
                    }
                    _setDefaultPropertiesFromJS(element) {
                        if (!this.enableScripting) return;
                        const storedData = this.annotationStorage.getRawValue(this.data.id);
                        if (!storedData) return;
                        const commonActions = this._commonActions;
                        for (const [actionName, detail] of Object.entries(storedData)){
                            const action = commonActions[actionName];
                            if (action) {
                                const eventProxy = {
                                    detail: {
                                        [actionName]: detail
                                    },
                                    target: element
                                };
                                action(eventProxy);
                                delete storedData[actionName];
                            }
                        }
                    }
                    _createQuadrilaterals() {
                        if (!this.container) return;
                        const { quadPoints } = this.data;
                        if (!quadPoints) return;
                        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                        if (quadPoints.length === 1) {
                            const [, { x: trX, y: trY }, { x: blX, y: blY }] = quadPoints[0];
                            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
                        }
                        const { style } = this.container;
                        let svgBuffer;
                        if (this.#hasBorder) {
                            const { borderColor, borderWidth } = style;
                            style.borderWidth = 0;
                            svgBuffer = [
                                "url('data:image/svg+xml;utf8,",
                                `<svg xmlns="http://www.w3.org/2000/svg"`,
                                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
                            ];
                            this.container.classList.add("hasBorder");
                        }
                        const width = rectTrX - rectBlX;
                        const height = rectTrY - rectBlY;
                        const { svgFactory } = this;
                        const svg = svgFactory.createElement("svg");
                        svg.classList.add("quadrilateralsContainer");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        const defs = svgFactory.createElement("defs");
                        svg.append(defs);
                        const clipPath = svgFactory.createElement("clipPath");
                        const id = `clippath_${this.data.id}`;
                        clipPath.setAttribute("id", id);
                        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                        defs.append(clipPath);
                        for (const [, { x: trX, y: trY }, { x: blX, y: blY }] of quadPoints){
                            const rect = svgFactory.createElement("rect");
                            const x = (blX - rectBlX) / width;
                            const y = (rectTrY - trY) / height;
                            const rectWidth = (trX - blX) / width;
                            const rectHeight = (trY - blY) / height;
                            rect.setAttribute("x", x);
                            rect.setAttribute("y", y);
                            rect.setAttribute("width", rectWidth);
                            rect.setAttribute("height", rectHeight);
                            clipPath.append(rect);
                            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
                        }
                        if (this.#hasBorder) {
                            svgBuffer.push(`</g></svg>')`);
                            style.backgroundImage = svgBuffer.join("");
                        }
                        this.container.append(svg);
                        this.container.style.clipPath = `url(#${id})`;
                    }
                    _createPopup() {
                        const { container, data } = this;
                        container.setAttribute("aria-haspopup", "dialog");
                        const popup = new PopupAnnotationElement({
                            data: {
                                color: data.color,
                                titleObj: data.titleObj,
                                modificationDate: data.modificationDate,
                                contentsObj: data.contentsObj,
                                richText: data.richText,
                                parentRect: data.rect,
                                borderStyle: 0,
                                id: `popup_${data.id}`,
                                rotation: data.rotation
                            },
                            parent: this.parent,
                            elements: [
                                this
                            ]
                        });
                        this.parent.div.append(popup.render());
                    }
                    render() {
                        (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                    _getElementsByName(name, skipId = null) {
                        const fields = [];
                        if (this._fieldObjects) {
                            const fieldObj = this._fieldObjects[name];
                            if (fieldObj) for (const { page, id, exportValues } of fieldObj){
                                if (page === -1) continue;
                                if (id === skipId) continue;
                                const exportValue = typeof exportValues === "string" ? exportValues : null;
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_getElementsByName - element not allowed: ${id}`);
                                    continue;
                                }
                                fields.push({
                                    id: id,
                                    exportValue: exportValue,
                                    domElement: domElement
                                });
                            }
                            return fields;
                        }
                        for (const domElement of document.getElementsByName(name)){
                            const { exportValue } = domElement;
                            const id = domElement.getAttribute("data-element-id");
                            if (id === skipId) continue;
                            if (!GetElementsByNameSet.has(domElement)) continue;
                            fields.push({
                                id: id,
                                exportValue: exportValue,
                                domElement: domElement
                            });
                        }
                        return fields;
                    }
                    show() {
                        if (this.container) this.container.hidden = false;
                        this.popup?.maybeShow();
                    }
                    hide() {
                        if (this.container) this.container.hidden = true;
                        this.popup?.forceHide();
                    }
                    getElementsToTriggerPopup() {
                        return this.container;
                    }
                    addHighlightArea() {
                        const triggers = this.getElementsToTriggerPopup();
                        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
                        else triggers.classList.add("highlightArea");
                    }
                    _editOnDoubleClick() {
                        const { annotationEditorType: mode, data: { id: editId } } = this;
                        this.container.addEventListener("dblclick", ()=>{
                            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                                source: this,
                                mode: mode,
                                editId: editId
                            });
                        });
                    }
                }
                class LinkAnnotationElement extends AnnotationElement {
                    constructor(parameters, options = null){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: !!options?.ignoreBorder,
                            createQuadrilaterals: true
                        });
                        this.isTooltipOnly = parameters.data.isTooltipOnly;
                    }
                    render() {
                        const { data, linkService } = this;
                        const link = document.createElement("a");
                        link.setAttribute("data-element-id", data.id);
                        let isBound = false;
                        if (data.url) {
                            linkService.addLinkAttributes(link, data.url, data.newWindow);
                            isBound = true;
                        } else if (data.action) {
                            this._bindNamedAction(link, data.action);
                            isBound = true;
                        } else if (data.attachment) {
                            this._bindAttachment(link, data.attachment);
                            isBound = true;
                        } else if (data.setOCGState) {
                            this.#bindSetOCGState(link, data.setOCGState);
                            isBound = true;
                        } else if (data.dest) {
                            this._bindLink(link, data.dest);
                            isBound = true;
                        } else {
                            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                this._bindJSAction(link, data);
                                isBound = true;
                            }
                            if (data.resetForm) {
                                this._bindResetFormAction(link, data.resetForm);
                                isBound = true;
                            } else if (this.isTooltipOnly && !isBound) {
                                this._bindLink(link, "");
                                isBound = true;
                            }
                        }
                        this.container.classList.add("linkAnnotation");
                        if (isBound) this.container.append(link);
                        return this.container;
                    }
                    #setInternalLink() {
                        this.container.setAttribute("data-internal-link", "");
                    }
                    _bindLink(link, destination) {
                        link.href = this.linkService.getDestinationHash(destination);
                        link.onclick = ()=>{
                            if (destination) this.linkService.goToDestination(destination);
                            return false;
                        };
                        if (destination || destination === "") this.#setInternalLink();
                    }
                    _bindNamedAction(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeNamedAction(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindAttachment(link, attachment) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.downloadManager?.openOrDownloadData(this.container, attachment.content, attachment.filename);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    #bindSetOCGState(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeSetOCGState(action);
                            return false;
                        };
                        this.#setInternalLink();
                    }
                    _bindJSAction(link, data) {
                        link.href = this.linkService.getAnchorUrl("");
                        const map = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name of Object.keys(data.actions)){
                            const jsName = map.get(name);
                            if (!jsName) continue;
                            link[jsName] = ()=>{
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data.id,
                                        name: name
                                    }
                                });
                                return false;
                            };
                        }
                        if (!link.onclick) link.onclick = ()=>false;
                        this.#setInternalLink();
                    }
                    _bindResetFormAction(link, resetForm) {
                        const otherClickAction = link.onclick;
                        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                        this.#setInternalLink();
                        if (!this._fieldObjects) {
                            (0, _util.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
                            if (!otherClickAction) link.onclick = ()=>false;
                            return;
                        }
                        link.onclick = ()=>{
                            otherClickAction?.();
                            const { fields: resetFormFields, refs: resetFormRefs, include } = resetForm;
                            const allFields = [];
                            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                const fieldIds = new Set(resetFormRefs);
                                for (const fieldName of resetFormFields){
                                    const fields = this._fieldObjects[fieldName] || [];
                                    for (const { id } of fields)fieldIds.add(id);
                                }
                                for (const fields of Object.values(this._fieldObjects)){
                                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                                }
                            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
                            const storage = this.annotationStorage;
                            const allIds = [];
                            for (const field of allFields){
                                const { id } = field;
                                allIds.push(id);
                                switch(field.type){
                                    case "text":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "checkbox":
                                    case "radiobutton":
                                        {
                                            const value = field.defaultValue === field.exportValues;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "combobox":
                                    case "listbox":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    default:
                                        continue;
                                }
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (!domElement) continue;
                                else if (!GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                                    continue;
                                }
                                domElement.dispatchEvent(new Event("resetform"));
                            }
                            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: "app",
                                    ids: allIds,
                                    name: "ResetForm"
                                }
                            });
                            return false;
                        };
                    }
                }
                class TextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                    }
                    render() {
                        this.container.classList.add("textAnnotation");
                        const image = document.createElement("img");
                        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image.alt = "[{{type}} Annotation]";
                        image.dataset.l10nId = "text_annotation_type";
                        image.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.append(image);
                        return this.container;
                    }
                }
                class WidgetAnnotationElement extends AnnotationElement {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    showElementAndHideCanvas(element) {
                        if (this.data.hasOwnCanvas) {
                            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
                            element.hidden = false;
                        }
                    }
                    _getKeyModifier(event) {
                        const { isWin, isMac } = _util.FeatureTest.platform;
                        return isWin && event.ctrlKey || isMac && event.metaKey;
                    }
                    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event),
                                    shift: event.shiftKey,
                                    modifier: this._getKeyModifier(event)
                                }
                            });
                        });
                        else element.addEventListener(baseName, (event)=>{
                            if (baseName === "blur") {
                                if (!elementData.focused || !event.relatedTarget) return;
                                elementData.focused = false;
                            } else if (baseName === "focus") {
                                if (elementData.focused) return;
                                elementData.focused = true;
                            }
                            if (!valueGetter) return;
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event)
                                }
                            });
                        });
                    }
                    _setEventListeners(element, elementData, names, getter) {
                        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
                            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                                focused: false
                            };
                            this._setEventListener(element, elementData, baseName, eventName, getter);
                            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
                            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
                        }
                    }
                    _setBackgroundColor(element) {
                        const color = this.data.backgroundColor || null;
                        element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                    }
                    _setTextStyle(element) {
                        const TEXT_ALIGNMENT = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontColor } = this.data.defaultAppearanceData;
                        const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                        const style = element.style;
                        let computedFontSize;
                        const BORDER_SIZE = 2;
                        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
                        if (this.data.multiLine) {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            const numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
                            const lineHeight = height / numberOfLines;
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
                        } else {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util.LINE_FACTOR));
                        }
                        style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                        style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                    }
                    _setRequired(element, isRequired) {
                        if (isRequired) element.setAttribute("required", true);
                        else element.removeAttribute("required");
                        element.setAttribute("aria-required", isRequired);
                    }
                }
                class TextWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        super(parameters, {
                            isRenderable: isRenderable
                        });
                    }
                    setPropertyOnSiblings(base, key, value, keyInStorage) {
                        const storage = this.annotationStorage;
                        for (const element of this._getElementsByName(base.name, base.id)){
                            if (element.domElement) element.domElement[key] = value;
                            storage.setValue(element.id, {
                                [keyInStorage]: value
                            });
                        }
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        this.container.classList.add("textWidgetAnnotation");
                        let element = null;
                        if (this.renderForms) {
                            const storedData = storage.getValue(id, {
                                value: this.data.fieldValue
                            });
                            let textContent = storedData.value || "";
                            const maxLen = storage.getValue(id, {
                                charLimit: this.data.maxLen
                            }).charLimit;
                            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
                            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
                            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                            const elementData = {
                                userValue: textContent,
                                formattedValue: fieldFormattedValues,
                                lastCommittedValue: null,
                                commitKey: 1,
                                focused: false
                            };
                            if (this.data.multiLine) {
                                element = document.createElement("textarea");
                                element.textContent = fieldFormattedValues ?? textContent;
                                if (this.data.doNotScroll) element.style.overflowY = "hidden";
                            } else {
                                element = document.createElement("input");
                                element.type = "text";
                                element.setAttribute("value", fieldFormattedValues ?? textContent);
                                if (this.data.doNotScroll) element.style.overflowX = "hidden";
                            }
                            if (this.data.hasOwnCanvas) element.hidden = true;
                            GetElementsByNameSet.add(element);
                            element.setAttribute("data-element-id", id);
                            element.disabled = this.data.readOnly;
                            element.name = this.data.fieldName;
                            element.tabIndex = DEFAULT_TAB_INDEX;
                            this._setRequired(element, this.data.required);
                            if (maxLen) element.maxLength = maxLen;
                            element.addEventListener("input", (event)=>{
                                storage.setValue(id, {
                                    value: event.target.value
                                });
                                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                elementData.formattedValue = null;
                            });
                            element.addEventListener("resetform", (event)=>{
                                const defaultValue = this.data.defaultFieldValue ?? "";
                                element.value = elementData.userValue = defaultValue;
                                elementData.formattedValue = null;
                            });
                            let blurListener = (event)=>{
                                const { formattedValue } = elementData;
                                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                                event.target.scrollLeft = 0;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                element.addEventListener("focus", (event)=>{
                                    if (elementData.focused) return;
                                    const { target } = event;
                                    if (elementData.userValue) target.value = elementData.userValue;
                                    elementData.lastCommittedValue = target.value;
                                    elementData.commitKey = 1;
                                    elementData.focused = true;
                                });
                                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                    this.showElementAndHideCanvas(jsEvent.target);
                                    const actions = {
                                        value (event) {
                                            elementData.userValue = event.detail.value ?? "";
                                            storage.setValue(id, {
                                                value: elementData.userValue.toString()
                                            });
                                            event.target.value = elementData.userValue;
                                        },
                                        formattedValue (event) {
                                            const { formattedValue } = event.detail;
                                            elementData.formattedValue = formattedValue;
                                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                                            storage.setValue(id, {
                                                formattedValue: formattedValue
                                            });
                                        },
                                        selRange (event) {
                                            event.target.setSelectionRange(...event.detail.selRange);
                                        },
                                        charLimit: (event)=>{
                                            const { charLimit } = event.detail;
                                            const { target } = event;
                                            if (charLimit === 0) {
                                                target.removeAttribute("maxLength");
                                                return;
                                            }
                                            target.setAttribute("maxLength", charLimit);
                                            let value = elementData.userValue;
                                            if (!value || value.length <= charLimit) return;
                                            value = value.slice(0, charLimit);
                                            target.value = elementData.userValue = value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                                source: this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: 1,
                                                    selStart: target.selectionStart,
                                                    selEnd: target.selectionEnd
                                                }
                                            });
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions, jsEvent);
                                });
                                element.addEventListener("keydown", (event)=>{
                                    elementData.commitKey = 1;
                                    let commitKey = -1;
                                    if (event.key === "Escape") commitKey = 0;
                                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                                    else if (event.key === "Tab") elementData.commitKey = 3;
                                    if (commitKey === -1) return;
                                    const { value } = event.target;
                                    if (elementData.lastCommittedValue === value) return;
                                    elementData.lastCommittedValue = value;
                                    elementData.userValue = value;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener = blurListener;
                                blurListener = null;
                                element.addEventListener("blur", (event)=>{
                                    if (!elementData.focused || !event.relatedTarget) return;
                                    elementData.focused = false;
                                    const { value } = event.target;
                                    elementData.userValue = value;
                                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: elementData.commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                    _blurListener(event);
                                });
                                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                                    elementData.lastCommittedValue = null;
                                    const { data, target } = event;
                                    const { value, selectionStart, selectionEnd } = target;
                                    let selStart = selectionStart, selEnd = selectionEnd;
                                    switch(event.inputType){
                                        case "deleteWordBackward":
                                            {
                                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                                if (match) selStart -= match[0].length;
                                                break;
                                            }
                                        case "deleteWordForward":
                                            {
                                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                                if (match) selEnd += match[0].length;
                                                break;
                                            }
                                        case "deleteContentBackward":
                                            if (selectionStart === selectionEnd) selStart -= 1;
                                            break;
                                        case "deleteContentForward":
                                            if (selectionStart === selectionEnd) selEnd += 1;
                                            break;
                                    }
                                    event.preventDefault();
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            change: data || "",
                                            willCommit: false,
                                            selStart: selStart,
                                            selEnd: selEnd
                                        }
                                    });
                                });
                                this._setEventListeners(element, elementData, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event)=>event.target.value);
                            }
                            if (blurListener) element.addEventListener("blur", blurListener);
                            if (this.data.comb) {
                                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                                const combWidth = fieldWidth / maxLen;
                                element.classList.add("comb");
                                element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                            }
                        } else {
                            element = document.createElement("div");
                            element.textContent = this.data.fieldValue;
                            element.style.verticalAlign = "middle";
                            element.style.display = "table-cell";
                        }
                        this._setTextStyle(element);
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: !!parameters.data.hasOwnCanvas
                        });
                    }
                }
                class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.exportValue === data.fieldValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== "Off";
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "checkbox";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.setAttribute("exportValue", data.exportValue);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const checkbox of this._getElementsByName(name, id)){
                                const curChecked = checked && checkbox.exportValue === data.exportValue;
                                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                storage.setValue(checkbox.id, {
                                    value: curChecked
                                });
                            }
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue || "Off";
                            event.target.checked = defaultValue === data.exportValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        event.target.checked = event.detail.value !== "Off";
                                        storage.setValue(id, {
                                            value: event.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.fieldValue === data.buttonValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== data.buttonValue;
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "radio";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                                value: false
                            });
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue;
                            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue = data.buttonValue;
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value: (event)=>{
                                        const checked = pdfButtonValue === event.detail.value;
                                        for (const radio of this._getElementsByName(event.target.name)){
                                            const curChecked = checked && radio.id === id;
                                            if (radio.domElement) radio.domElement.checked = curChecked;
                                            storage.setValue(radio.id, {
                                                value: curChecked
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                }
                class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                    render() {
                        const container = super.render();
                        container.classList.add("buttonWidgetAnnotation", "pushButton");
                        if (this.data.alternativeText) container.title = this.data.alternativeText;
                        const linkElement = container.lastChild;
                        if (this.enableScripting && this.hasJSActions && linkElement) {
                            this._setDefaultPropertiesFromJS(linkElement);
                            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                this._dispatchEventFromSandbox({}, jsEvent);
                            });
                        }
                        return container;
                    }
                }
                class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                    render() {
                        this.container.classList.add("choiceWidgetAnnotation");
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        const storedData = storage.getValue(id, {
                            value: this.data.fieldValue
                        });
                        const selectElement = document.createElement("select");
                        GetElementsByNameSet.add(selectElement);
                        selectElement.setAttribute("data-element-id", id);
                        selectElement.disabled = this.data.readOnly;
                        this._setRequired(selectElement, this.data.required);
                        selectElement.name = this.data.fieldName;
                        selectElement.tabIndex = DEFAULT_TAB_INDEX;
                        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                        if (!this.data.combo) {
                            selectElement.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement.multiple = true;
                        }
                        selectElement.addEventListener("resetform", (event)=>{
                            const defaultValue = this.data.defaultFieldValue;
                            for (const option of selectElement.options)option.selected = option.value === defaultValue;
                        });
                        for (const option of this.data.options){
                            const optionElement = document.createElement("option");
                            optionElement.textContent = option.displayValue;
                            optionElement.value = option.exportValue;
                            if (storedData.value.includes(option.exportValue)) {
                                optionElement.setAttribute("selected", true);
                                addAnEmptyEntry = false;
                            }
                            selectElement.append(optionElement);
                        }
                        let removeEmptyEntry = null;
                        if (addAnEmptyEntry) {
                            const noneOptionElement = document.createElement("option");
                            noneOptionElement.value = " ";
                            noneOptionElement.setAttribute("hidden", true);
                            noneOptionElement.setAttribute("selected", true);
                            selectElement.prepend(noneOptionElement);
                            removeEmptyEntry = ()=>{
                                noneOptionElement.remove();
                                selectElement.removeEventListener("input", removeEmptyEntry);
                                removeEmptyEntry = null;
                            };
                            selectElement.addEventListener("input", removeEmptyEntry);
                        }
                        const getValue = (isExport)=>{
                            const name = isExport ? "value" : "textContent";
                            const { options, multiple } = selectElement;
                            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
                        };
                        let selectedValues = getValue(false);
                        const getItems = (event)=>{
                            const options = event.target.options;
                            return Array.prototype.map.call(options, (option)=>{
                                return {
                                    displayValue: option.textContent,
                                    exportValue: option.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        removeEmptyEntry?.();
                                        const value = event.detail.value;
                                        const values = new Set(Array.isArray(value) ? value : [
                                            value
                                        ]);
                                        for (const option of selectElement.options)option.selected = values.has(option.value);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    multipleSelection (event) {
                                        selectElement.multiple = true;
                                    },
                                    remove (event) {
                                        const options = selectElement.options;
                                        const index = event.detail.remove;
                                        options[index].selected = false;
                                        selectElement.remove(index);
                                        if (options.length > 0) {
                                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                                            if (i === -1) options[0].selected = true;
                                        }
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    clear (event) {
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        storage.setValue(id, {
                                            value: null,
                                            items: []
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    insert (event) {
                                        const { index, displayValue, exportValue } = event.detail.insert;
                                        const selectChild = selectElement.children[index];
                                        const optionElement = document.createElement("option");
                                        optionElement.textContent = displayValue;
                                        optionElement.value = exportValue;
                                        if (selectChild) selectChild.before(optionElement);
                                        else selectElement.append(optionElement);
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    items (event) {
                                        const { items } = event.detail;
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        for (const item of items){
                                            const { displayValue, exportValue } = item;
                                            const optionElement = document.createElement("option");
                                            optionElement.textContent = displayValue;
                                            optionElement.value = exportValue;
                                            selectElement.append(optionElement);
                                        }
                                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    indices (event) {
                                        const indices = new Set(event.detail.indices);
                                        for (const option of event.target.options)option.selected = indices.has(option.index);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    editable (event) {
                                        event.target.disabled = !event.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            selectElement.addEventListener("input", (event)=>{
                                const exportValue = getValue(true);
                                storage.setValue(id, {
                                    value: exportValue
                                });
                                event.preventDefault();
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id,
                                        name: "Keystroke",
                                        value: selectedValues,
                                        changeEx: exportValue,
                                        willCommit: false,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement, null, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ],
                                [
                                    "input",
                                    "Validate"
                                ]
                            ], (event)=>event.target.value);
                        } else selectElement.addEventListener("input", function(event) {
                            storage.setValue(id, {
                                value: getValue(true)
                            });
                        });
                        if (this.data.combo) this._setTextStyle(selectElement);
                        this._setBackgroundColor(selectElement);
                        this._setDefaultPropertiesFromJS(selectElement);
                        this.container.append(selectElement);
                        return this.container;
                    }
                }
                class PopupAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        const { data, elements } = parameters;
                        super(parameters, {
                            isRenderable: AnnotationElement._hasPopupData(data)
                        });
                        this.elements = elements;
                    }
                    render() {
                        this.container.classList.add("popupAnnotation");
                        const popup = new PopupElement({
                            container: this.container,
                            color: this.data.color,
                            titleObj: this.data.titleObj,
                            modificationDate: this.data.modificationDate,
                            contentsObj: this.data.contentsObj,
                            richText: this.data.richText,
                            rect: this.data.rect,
                            parentRect: this.data.parentRect || null,
                            parent: this.parent,
                            elements: this.elements,
                            open: this.data.open
                        });
                        const elementIds = [];
                        for (const element of this.elements){
                            element.popup = popup;
                            elementIds.push(element.data.id);
                            element.addHighlightArea();
                        }
                        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${_util.AnnotationPrefix}${id}`).join(","));
                        return this.container;
                    }
                }
                class PopupElement {
                    #dateTimePromise = null;
                    #boundKeyDown = this.#keyDown.bind(this);
                    #boundHide = this.#hide.bind(this);
                    #boundShow = this.#show.bind(this);
                    #boundToggle = this.#toggle.bind(this);
                    #color = null;
                    #container = null;
                    #contentsObj = null;
                    #elements = null;
                    #parent = null;
                    #parentRect = null;
                    #pinned = false;
                    #popup = null;
                    #rect = null;
                    #richText = null;
                    #titleObj = null;
                    #wasVisible = false;
                    constructor({ container, color, elements, titleObj, modificationDate, contentsObj, richText, parent, rect, parentRect, open }){
                        this.#container = container;
                        this.#titleObj = titleObj;
                        this.#contentsObj = contentsObj;
                        this.#richText = richText;
                        this.#parent = parent;
                        this.#color = color;
                        this.#rect = rect;
                        this.#parentRect = parentRect;
                        this.#elements = elements;
                        const dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
                        if (dateObject) this.#dateTimePromise = parent.l10n.get("annotation_date_string", {
                            date: dateObject.toLocaleDateString(),
                            time: dateObject.toLocaleTimeString()
                        });
                        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
                        for (const element of this.trigger){
                            element.addEventListener("click", this.#boundToggle);
                            element.addEventListener("mouseenter", this.#boundShow);
                            element.addEventListener("mouseleave", this.#boundHide);
                            element.classList.add("popupTriggerArea");
                        }
                        for (const element of elements)element.container?.addEventListener("keydown", this.#boundKeyDown);
                        this.#container.hidden = true;
                        if (open) this.#toggle();
                    }
                    render() {
                        if (this.#popup) return;
                        const { page: { view }, viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } = this.#parent;
                        const popup = this.#popup = document.createElement("div");
                        popup.className = "popup";
                        if (this.#color) {
                            const baseColor = popup.style.outlineColor = _util.Util.makeHexColor(...this.#color);
                            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                            else {
                                const BACKGROUND_ENLIGHT = 0.7;
                                popup.style.backgroundColor = _util.Util.makeHexColor(...this.#color.map((c)=>Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
                            }
                        }
                        const header = document.createElement("span");
                        header.className = "header";
                        const title = document.createElement("h1");
                        header.append(title);
                        ({ dir: title.dir, str: title.textContent } = this.#titleObj);
                        popup.append(header);
                        if (this.#dateTimePromise) {
                            const modificationDate = document.createElement("span");
                            modificationDate.classList.add("popupDate");
                            this.#dateTimePromise.then((localized)=>{
                                modificationDate.textContent = localized;
                            });
                            header.append(modificationDate);
                        }
                        const contentsObj = this.#contentsObj;
                        const richText = this.#richText;
                        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) {
                            _xfa_layer.XfaLayer.render({
                                xfaHtml: richText.html,
                                intent: "richText",
                                div: popup
                            });
                            popup.lastChild.classList.add("richText", "popupContent");
                        } else {
                            const contents = this._formatContents(contentsObj);
                            popup.append(contents);
                        }
                        let useParentRect = !!this.#parentRect;
                        let rect = useParentRect ? this.#parentRect : this.#rect;
                        for (const element of this.#elements)if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
                            rect = element.data.rect;
                            useParentRect = true;
                            break;
                        }
                        const normalizedRect = _util.Util.normalizeRect([
                            rect[0],
                            view[3] - rect[1] + view[1],
                            rect[2],
                            view[3] - rect[3] + view[1]
                        ]);
                        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                        const popupLeft = normalizedRect[0] + parentWidth;
                        const popupTop = normalizedRect[1];
                        const { style } = this.#container;
                        style.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                        style.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                        this.#container.append(popup);
                    }
                    _formatContents({ str, dir }) {
                        const p = document.createElement("p");
                        p.classList.add("popupContent");
                        p.dir = dir;
                        const lines = str.split(/(?:\r\n?|\n)/);
                        for(let i = 0, ii = lines.length; i < ii; ++i){
                            const line = lines[i];
                            p.append(document.createTextNode(line));
                            if (i < ii - 1) p.append(document.createElement("br"));
                        }
                        return p;
                    }
                    #keyDown(event) {
                        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
                        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
                    }
                    #toggle() {
                        this.#pinned = !this.#pinned;
                        if (this.#pinned) {
                            this.#show();
                            this.#container.addEventListener("click", this.#boundToggle);
                            this.#container.addEventListener("keydown", this.#boundKeyDown);
                        } else {
                            this.#hide();
                            this.#container.removeEventListener("click", this.#boundToggle);
                            this.#container.removeEventListener("keydown", this.#boundKeyDown);
                        }
                    }
                    #show() {
                        if (!this.#popup) this.render();
                        if (!this.isVisible) {
                            this.#container.hidden = false;
                            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
                        } else if (this.#pinned) this.#container.classList.add("focused");
                    }
                    #hide() {
                        this.#container.classList.remove("focused");
                        if (this.#pinned || !this.isVisible) return;
                        this.#container.hidden = true;
                        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
                    }
                    forceHide() {
                        this.#wasVisible = this.isVisible;
                        if (!this.#wasVisible) return;
                        this.#container.hidden = true;
                    }
                    maybeShow() {
                        if (!this.#wasVisible) return;
                        this.#wasVisible = false;
                        this.#container.hidden = false;
                    }
                    get isVisible() {
                        return this.#container.hidden === false;
                    }
                }
                class FreeTextAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.textContent = parameters.data.textContent;
                        this.textPosition = parameters.data.textPosition;
                        this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
                    }
                    render() {
                        this.container.classList.add("freeTextAnnotation");
                        if (this.textContent) {
                            const content = document.createElement("div");
                            content.classList.add("annotationTextContent");
                            content.setAttribute("role", "comment");
                            for (const line of this.textContent){
                                const lineSpan = document.createElement("span");
                                lineSpan.textContent = line;
                                content.append(lineSpan);
                            }
                            this.container.append(content);
                        }
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this._editOnDoubleClick();
                        return this.container;
                    }
                }
                exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
                class LineAnnotationElement extends AnnotationElement {
                    #line = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("lineAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const line = this.#line = this.svgFactory.createElement("svg:line");
                        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                        line.setAttribute("stroke-width", data.borderStyle.width || 1);
                        line.setAttribute("stroke", "transparent");
                        line.setAttribute("fill", "transparent");
                        svg.append(line);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#line;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class SquareAnnotationElement extends AnnotationElement {
                    #square = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("squareAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const square = this.#square = this.svgFactory.createElement("svg:rect");
                        square.setAttribute("x", borderWidth / 2);
                        square.setAttribute("y", borderWidth / 2);
                        square.setAttribute("width", width - borderWidth);
                        square.setAttribute("height", height - borderWidth);
                        square.setAttribute("stroke-width", borderWidth || 1);
                        square.setAttribute("stroke", "transparent");
                        square.setAttribute("fill", "transparent");
                        svg.append(square);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#square;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class CircleAnnotationElement extends AnnotationElement {
                    #circle = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("circleAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
                        circle.setAttribute("cx", width / 2);
                        circle.setAttribute("cy", height / 2);
                        circle.setAttribute("rx", width / 2 - borderWidth / 2);
                        circle.setAttribute("ry", height / 2 - borderWidth / 2);
                        circle.setAttribute("stroke-width", borderWidth || 1);
                        circle.setAttribute("stroke", "transparent");
                        circle.setAttribute("fill", "transparent");
                        svg.append(circle);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#circle;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolylineAnnotationElement extends AnnotationElement {
                    #polyline = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        let points = [];
                        for (const coordinate of data.vertices){
                            const x = coordinate.x - data.rect[0];
                            const y = data.rect[3] - coordinate.y;
                            points.push(x + "," + y);
                        }
                        points = points.join(" ");
                        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
                        polyline.setAttribute("points", points);
                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                        polyline.setAttribute("stroke", "transparent");
                        polyline.setAttribute("fill", "transparent");
                        svg.append(polyline);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polyline;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                class PolygonAnnotationElement extends PolylineAnnotationElement {
                    constructor(parameters){
                        super(parameters);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("caretAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                class InkAnnotationElement extends AnnotationElement {
                    #polylines = [];
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                        this.annotationEditorType = _util.AnnotationEditorType.INK;
                    }
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        for (const inkList of data.inkLists){
                            let points = [];
                            for (const coordinate of inkList){
                                const x = coordinate.x - data.rect[0];
                                const y = data.rect[3] - coordinate.y;
                                points.push(`${x},${y}`);
                            }
                            points = points.join(" ");
                            const polyline = this.svgFactory.createElement(this.svgElementName);
                            this.#polylines.push(polyline);
                            polyline.setAttribute("points", points);
                            polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                            polyline.setAttribute("stroke", "transparent");
                            polyline.setAttribute("fill", "transparent");
                            if (!data.popupRef && this.hasPopupData) this._createPopup();
                            svg.append(polyline);
                        }
                        this.container.append(svg);
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#polylines;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                }
                exports.InkAnnotationElement = InkAnnotationElement;
                class HighlightAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("highlightAnnotation");
                        return this.container;
                    }
                }
                class UnderlineAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("underlineAnnotation");
                        return this.container;
                    }
                }
                class SquigglyAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("squigglyAnnotation");
                        return this.container;
                    }
                }
                class StrikeOutAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("strikeoutAnnotation");
                        return this.container;
                    }
                }
                class StampAnnotationElement extends AnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.classList.add("stampAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                }
                exports.StampAnnotationElement = StampAnnotationElement;
                class FileAttachmentAnnotationElement extends AnnotationElement {
                    #trigger = null;
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                        const { filename, content } = this.data.file;
                        this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
                        this.content = content;
                        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                            source: this,
                            filename: filename,
                            content: content
                        });
                    }
                    render() {
                        this.container.classList.add("fileAttachmentAnnotation");
                        const { container, data } = this;
                        let trigger;
                        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
                        else {
                            trigger = document.createElement("img");
                            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
                            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
                        }
                        trigger.addEventListener("dblclick", this.#download.bind(this));
                        this.#trigger = trigger;
                        const { isMac } = _util.FeatureTest.platform;
                        container.addEventListener("keydown", (evt)=>{
                            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
                        });
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        else trigger.classList.add("popupTriggerArea");
                        container.append(trigger);
                        return container;
                    }
                    getElementsToTriggerPopup() {
                        return this.#trigger;
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    #download() {
                        this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                    }
                }
                class AnnotationLayer {
                    #accessibilityManager = null;
                    #annotationCanvasMap = null;
                    #editableAnnotations = new Map();
                    constructor({ div, accessibilityManager, annotationCanvasMap, l10n, page, viewport }){
                        this.div = div;
                        this.#accessibilityManager = accessibilityManager;
                        this.#annotationCanvasMap = annotationCanvasMap;
                        this.l10n = l10n;
                        this.page = page;
                        this.viewport = viewport;
                        this.zIndex = 0;
                        this.l10n ||= _displayL10n_utils.NullL10n;
                    }
                    #appendElement(element, id) {
                        const contentElement = element.firstChild || element;
                        contentElement.id = `${_util.AnnotationPrefix}${id}`;
                        this.div.append(element);
                        this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
                    }
                    async render(params) {
                        const { annotations } = params;
                        const layer = this.div;
                        (0, _display_utils.setLayerDimensions)(layer, this.viewport);
                        const popupToElements = new Map();
                        const elementParams = {
                            data: null,
                            layer: layer,
                            linkService: params.linkService,
                            downloadManager: params.downloadManager,
                            imageResourcesPath: params.imageResourcesPath || "",
                            renderForms: params.renderForms !== false,
                            svgFactory: new _display_utils.DOMSVGFactory(),
                            annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
                            enableScripting: params.enableScripting === true,
                            hasJSActions: params.hasJSActions,
                            fieldObjects: params.fieldObjects,
                            parent: this,
                            elements: null
                        };
                        for (const data of annotations){
                            if (data.noHTML) continue;
                            const isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
                            if (!isPopupAnnotation) {
                                const { width, height } = getRectDims(data.rect);
                                if (width <= 0 || height <= 0) continue;
                            } else {
                                const elements = popupToElements.get(data.id);
                                if (!elements) continue;
                                elementParams.elements = elements;
                            }
                            elementParams.data = data;
                            const element = AnnotationElementFactory.create(elementParams);
                            if (!element.isRenderable) continue;
                            if (!isPopupAnnotation && data.popupRef) {
                                const elements = popupToElements.get(data.popupRef);
                                if (!elements) popupToElements.set(data.popupRef, [
                                    element
                                ]);
                                else elements.push(element);
                            }
                            if (element.annotationEditorType > 0) this.#editableAnnotations.set(element.data.id, element);
                            const rendered = element.render();
                            if (data.hidden) rendered.style.visibility = "hidden";
                            this.#appendElement(rendered, data.id);
                        }
                        this.#setAnnotationCanvasMap();
                        await this.l10n.translate(layer);
                    }
                    update({ viewport }) {
                        const layer = this.div;
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(layer, {
                            rotation: viewport.rotation
                        });
                        this.#setAnnotationCanvasMap();
                        layer.hidden = false;
                    }
                    #setAnnotationCanvasMap() {
                        if (!this.#annotationCanvasMap) return;
                        const layer = this.div;
                        for (const [id, canvas] of this.#annotationCanvasMap){
                            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                            if (!element) continue;
                            const { firstChild } = element;
                            if (!firstChild) element.append(canvas);
                            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
                            else firstChild.before(canvas);
                        }
                        this.#annotationCanvasMap.clear();
                    }
                    getEditableAnnotations() {
                        return Array.from(this.#editableAnnotations.values());
                    }
                    getEditableAnnotation(id) {
                        return this.#editableAnnotations.get(id);
                    }
                }
                exports.AnnotationLayer = AnnotationLayer;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp(x) {
                    return Math.max(0, Math.min(255, 255 * x));
                }
                class ColorConverters {
                    static CMYK_G([c, y, m, k]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                        ];
                    }
                    static G_CMYK([g]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g
                        ];
                    }
                    static G_RGB([g]) {
                        return [
                            "RGB",
                            g,
                            g,
                            g
                        ];
                    }
                    static G_rgb([g]) {
                        g = scaleAndClamp(g);
                        return [
                            g,
                            g,
                            g
                        ];
                    }
                    static G_HTML([g]) {
                        const G = makeColorComp(g);
                        return `#${G}${G}${G}`;
                    }
                    static RGB_G([r, g, b]) {
                        return [
                            "G",
                            0.3 * r + 0.59 * g + 0.11 * b
                        ];
                    }
                    static RGB_rgb(color) {
                        return color.map(scaleAndClamp);
                    }
                    static RGB_HTML(color) {
                        return `#${color.map(makeColorComp).join("")}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static T_rgb() {
                        return [
                            null
                        ];
                    }
                    static CMYK_RGB([c, y, m, k]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c + k),
                            1 - Math.min(1, m + k),
                            1 - Math.min(1, y + k)
                        ];
                    }
                    static CMYK_rgb([c, y, m, k]) {
                        return [
                            scaleAndClamp(1 - Math.min(1, c + k)),
                            scaleAndClamp(1 - Math.min(1, m + k)),
                            scaleAndClamp(1 - Math.min(1, y + k))
                        ];
                    }
                    static CMYK_HTML(components) {
                        const rgb = this.CMYK_RGB(components).slice(1);
                        return this.RGB_HTML(rgb);
                    }
                    static RGB_CMYK([r, g, b]) {
                        const c = 1 - r;
                        const m = 1 - g;
                        const y = 1 - b;
                        const k = Math.min(c, m, y);
                        return [
                            "CMYK",
                            c,
                            m,
                            y,
                            k
                        ];
                    }
                }
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NullL10n = void 0;
                exports.getL10nFallback = getL10nFallback;
                const DEFAULT_L10N_STRINGS = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
                function getL10nFallback(key, args) {
                    switch(key){
                        case "find_match_count":
                            key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                            break;
                        case "find_match_count_limit":
                            key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                            break;
                    }
                    return DEFAULT_L10N_STRINGS[key] || "";
                }
                function formatL10nValue(text, args) {
                    if (!args) return text;
                    return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name)=>{
                        return name in args ? args[name] : "{{" + name + "}}";
                    });
                }
                const NullL10n = {
                    async getLanguage () {
                        return "en-us";
                    },
                    async getDirection () {
                        return "ltr";
                    },
                    async get (key, args = null, fallback = getL10nFallback(key, args)) {
                        return formatL10nValue(fallback, args);
                    },
                    async translate (element) {}
                };
                exports.NullL10n = NullL10n;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _xfa_text = __w_pdfjs_require__(25);
                class XfaLayer {
                    static setupStorage(html, id, element, storage, intent) {
                        const storedData = storage.getValue(id, {
                            value: null
                        });
                        switch(element.name){
                            case "textarea":
                                if (storedData.value !== null) html.textContent = storedData.value;
                                if (intent === "print") break;
                                html.addEventListener("input", (event)=>{
                                    storage.setValue(id, {
                                        value: event.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                    if (intent === "print") break;
                                    html.addEventListener("change", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                        });
                                    });
                                } else {
                                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                    if (intent === "print") break;
                                    html.addEventListener("input", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData.value !== null) {
                                    html.setAttribute("value", storedData.value);
                                    for (const option of element.children){
                                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                                    }
                                }
                                html.addEventListener("input", (event)=>{
                                    const options = event.target.options;
                                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes({ html, element, storage = null, intent, linkService }) {
                        const { attributes } = element;
                        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
                        for (const [key, value] of Object.entries(attributes)){
                            if (value === null || value === undefined) continue;
                            switch(key){
                                case "class":
                                    if (value.length) html.setAttribute(key, value.join(" "));
                                    break;
                                case "dataId":
                                    break;
                                case "id":
                                    html.setAttribute("data-element-id", value);
                                    break;
                                case "style":
                                    Object.assign(html.style, value);
                                    break;
                                case "textContent":
                                    html.textContent = value;
                                    break;
                                default:
                                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
                            }
                        }
                        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                    }
                    static render(parameters) {
                        const storage = parameters.annotationStorage;
                        const linkService = parameters.linkService;
                        const root = parameters.xfaHtml;
                        const intent = parameters.intent || "display";
                        const rootHtml = document.createElement(root.name);
                        if (root.attributes) this.setAttributes({
                            html: rootHtml,
                            element: root,
                            intent: intent,
                            linkService: linkService
                        });
                        const stack = [
                            [
                                root,
                                -1,
                                rootHtml
                            ]
                        ];
                        const rootDiv = parameters.div;
                        rootDiv.append(rootHtml);
                        if (parameters.viewport) {
                            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                            rootDiv.style.transform = transform;
                        }
                        if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                        const textDivs = [];
                        while(stack.length > 0){
                            const [parent, i, html] = stack.at(-1);
                            if (i + 1 === parent.children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = parent.children[++stack.at(-1)[1]];
                            if (child === null) continue;
                            const { name } = child;
                            if (name === "#text") {
                                const node = document.createTextNode(child.value);
                                textDivs.push(node);
                                html.append(node);
                                continue;
                            }
                            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                            html.append(childHtml);
                            if (child.attributes) this.setAttributes({
                                html: childHtml,
                                element: child,
                                storage: storage,
                                intent: intent,
                                linkService: linkService
                            });
                            if (child.children && child.children.length > 0) stack.push([
                                child,
                                -1,
                                childHtml
                            ]);
                            else if (child.value) {
                                const node = document.createTextNode(child.value);
                                if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(node);
                                childHtml.append(node);
                            }
                        }
                        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
                        return {
                            textDivs: textDivs
                        };
                    }
                    static update(parameters) {
                        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                        parameters.div.style.transform = transform;
                        parameters.div.hidden = false;
                    }
                }
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.InkEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _display_utils = __w_pdfjs_require__(6);
                var _tools = __w_pdfjs_require__(5);
                class InkEditor extends _editor.AnnotationEditor {
                    #baseHeight = 0;
                    #baseWidth = 0;
                    #boundCanvasPointermove = this.canvasPointermove.bind(this);
                    #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
                    #boundCanvasPointerup = this.canvasPointerup.bind(this);
                    #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
                    #currentPath2D = new Path2D();
                    #disableEditing = false;
                    #hasSomethingToDraw = false;
                    #isCanvasInitialized = false;
                    #observer = null;
                    #realWidth = 0;
                    #realHeight = 0;
                    #requestFrameCallback = null;
                    static _defaultColor = null;
                    static _defaultOpacity = 1;
                    static _defaultThickness = 1;
                    static _type = "ink";
                    constructor(params){
                        super({
                            ...params,
                            name: "inkEditor"
                        });
                        this.color = params.color || null;
                        this.thickness = params.thickness || null;
                        this.opacity = params.opacity || null;
                        this.paths = [];
                        this.bezierPath2D = [];
                        this.allRawPaths = [];
                        this.currentPath = [];
                        this.scaleFactor = 1;
                        this.translationX = this.translationY = 0;
                        this.x = 0;
                        this.y = 0;
                        this._willKeepAspectRatio = true;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "editor_ink_canvas_aria_label",
                                "editor_ink2_aria_label"
                            ]
                        });
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                InkEditor._defaultThickness = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                InkEditor._defaultColor = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                InkEditor._defaultOpacity = value / 100;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                this.#updateThickness(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                this.#updateColor(value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                this.#updateOpacity(value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(InkEditor._defaultOpacity * 100)
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                this.thickness || InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(100 * (this.opacity ?? InkEditor._defaultOpacity))
                            ]
                        ];
                    }
                    #updateThickness(thickness) {
                        const savedThickness = this.thickness;
                        this.addCommands({
                            cmd: ()=>{
                                this.thickness = thickness;
                                this.#fitToContent();
                            },
                            undo: ()=>{
                                this.thickness = savedThickness;
                                this.#fitToContent();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_THICKNESS,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateColor(color) {
                        const savedColor = this.color;
                        this.addCommands({
                            cmd: ()=>{
                                this.color = color;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.color = savedColor;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_COLOR,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    #updateOpacity(opacity) {
                        opacity /= 100;
                        const savedOpacity = this.opacity;
                        this.addCommands({
                            cmd: ()=>{
                                this.opacity = opacity;
                                this.#redraw();
                            },
                            undo: ()=>{
                                this.opacity = savedOpacity;
                                this.#redraw();
                            },
                            mustExec: true,
                            type: _util.AnnotationEditorParamsType.INK_OPACITY,
                            overwriteIfSameType: true,
                            keepUndo: true
                        });
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.canvas) {
                            this.#createCanvas();
                            this.#createObserver();
                        }
                        if (!this.isAttachedToDOM) {
                            this.parent.add(this);
                            this.#setCanvasDims();
                        }
                        this.#fitToContent();
                    }
                    remove() {
                        if (this.canvas === null) return;
                        if (!this.isEmpty()) this.commit();
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.remove();
                        this.canvas = null;
                        this.#observer.disconnect();
                        this.#observer = null;
                        super.remove();
                    }
                    setParent(parent) {
                        if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
                        else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
                        super.setParent(parent);
                    }
                    onScaleChanging() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const width = this.width * parentWidth;
                        const height = this.height * parentHeight;
                        this.setDimensions(width, height);
                    }
                    enableEditMode() {
                        if (this.#disableEditing || this.canvas === null) return;
                        super.enableEditMode();
                        this._isDraggable = false;
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    disableEditMode() {
                        if (!this.isInEditMode() || this.canvas === null) return;
                        super.disableEditMode();
                        this._isDraggable = !this.isEmpty();
                        this.div.classList.remove("editing");
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                    }
                    onceAdded() {
                        this._isDraggable = !this.isEmpty();
                    }
                    isEmpty() {
                        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                    }
                    #getInitialBBox() {
                        const { parentRotation, parentDimensions: [width, height] } = this;
                        switch(parentRotation){
                            case 90:
                                return [
                                    0,
                                    height,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    width,
                                    height,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    width,
                                    0,
                                    height,
                                    width
                                ];
                            default:
                                return [
                                    0,
                                    0,
                                    width,
                                    height
                                ];
                        }
                    }
                    #setStroke() {
                        const { ctx, color, opacity, thickness, parentScale, scaleFactor } = this;
                        ctx.lineWidth = thickness * parentScale / scaleFactor;
                        ctx.lineCap = "round";
                        ctx.lineJoin = "round";
                        ctx.miterLimit = 10;
                        ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
                    }
                    #startDrawing(x, y) {
                        this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
                        this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
                        this.isEditing = true;
                        if (!this.#isCanvasInitialized) {
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.thickness ||= InkEditor._defaultThickness;
                            this.color ||= InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
                            this.opacity ??= InkEditor._defaultOpacity;
                        }
                        this.currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = false;
                        this.#setStroke();
                        this.#requestFrameCallback = ()=>{
                            this.#drawPoints();
                            if (this.#requestFrameCallback) window.requestAnimationFrame(this.#requestFrameCallback);
                        };
                        window.requestAnimationFrame(this.#requestFrameCallback);
                    }
                    #draw(x, y) {
                        const [lastX, lastY] = this.currentPath.at(-1);
                        if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
                        const currentPath = this.currentPath;
                        let path2D = this.#currentPath2D;
                        currentPath.push([
                            x,
                            y
                        ]);
                        this.#hasSomethingToDraw = true;
                        if (currentPath.length <= 2) {
                            path2D.moveTo(...currentPath[0]);
                            path2D.lineTo(x, y);
                            return;
                        }
                        if (currentPath.length === 3) {
                            this.#currentPath2D = path2D = new Path2D();
                            path2D.moveTo(...currentPath[0]);
                        }
                        this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
                    }
                    #endPath() {
                        if (this.currentPath.length === 0) return;
                        const lastPoint = this.currentPath.at(-1);
                        this.#currentPath2D.lineTo(...lastPoint);
                    }
                    #stopDrawing(x, y) {
                        this.#requestFrameCallback = null;
                        x = Math.min(Math.max(x, 0), this.canvas.width);
                        y = Math.min(Math.max(y, 0), this.canvas.height);
                        this.#draw(x, y);
                        this.#endPath();
                        let bezier;
                        if (this.currentPath.length !== 1) bezier = this.#generateBezierPoints();
                        else {
                            const xy = [
                                x,
                                y
                            ];
                            bezier = [
                                [
                                    xy,
                                    xy.slice(),
                                    xy.slice(),
                                    xy
                                ]
                            ];
                        }
                        const path2D = this.#currentPath2D;
                        const currentPath = this.currentPath;
                        this.currentPath = [];
                        this.#currentPath2D = new Path2D();
                        const cmd = ()=>{
                            this.allRawPaths.push(currentPath);
                            this.paths.push(bezier);
                            this.bezierPath2D.push(path2D);
                            this.rebuild();
                        };
                        const undo = ()=>{
                            this.allRawPaths.pop();
                            this.paths.pop();
                            this.bezierPath2D.pop();
                            if (this.paths.length === 0) this.remove();
                            else {
                                if (!this.canvas) {
                                    this.#createCanvas();
                                    this.#createObserver();
                                }
                                this.#fitToContent();
                            }
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    #drawPoints() {
                        if (!this.#hasSomethingToDraw) return;
                        this.#hasSomethingToDraw = false;
                        const thickness = Math.ceil(this.thickness * this.parentScale);
                        const lastPoints = this.currentPath.slice(-3);
                        const x = lastPoints.map((xy)=>xy[0]);
                        const y = lastPoints.map((xy)=>xy[1]);
                        const xMin = Math.min(...x) - thickness;
                        const xMax = Math.max(...x) + thickness;
                        const yMin = Math.min(...y) - thickness;
                        const yMax = Math.max(...y) + thickness;
                        const { ctx } = this;
                        ctx.save();
                        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                        ctx.stroke(this.#currentPath2D);
                        ctx.restore();
                    }
                    #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                        const prevX = (x0 + x1) / 2;
                        const prevY = (y0 + y1) / 2;
                        const x3 = (x1 + x2) / 2;
                        const y3 = (y1 + y2) / 2;
                        path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                    }
                    #generateBezierPoints() {
                        const path = this.currentPath;
                        if (path.length <= 2) return [
                            [
                                path[0],
                                path[0],
                                path.at(-1),
                                path.at(-1)
                            ]
                        ];
                        const bezierPoints = [];
                        let i;
                        let [x0, y0] = path[0];
                        for(i = 1; i < path.length - 2; i++){
                            const [x1, y1] = path[i];
                            const [x2, y2] = path[i + 1];
                            const x3 = (x1 + x2) / 2;
                            const y3 = (y1 + y2) / 2;
                            const control1 = [
                                x0 + 2 * (x1 - x0) / 3,
                                y0 + 2 * (y1 - y0) / 3
                            ];
                            const control2 = [
                                x3 + 2 * (x1 - x3) / 3,
                                y3 + 2 * (y1 - y3) / 3
                            ];
                            bezierPoints.push([
                                [
                                    x0,
                                    y0
                                ],
                                control1,
                                control2,
                                [
                                    x3,
                                    y3
                                ]
                            ]);
                            [x0, y0] = [
                                x3,
                                y3
                            ];
                        }
                        const [x1, y1] = path[i];
                        const [x2, y2] = path[i + 1];
                        const control1 = [
                            x0 + 2 * (x1 - x0) / 3,
                            y0 + 2 * (y1 - y0) / 3
                        ];
                        const control2 = [
                            x2 + 2 * (x1 - x2) / 3,
                            y2 + 2 * (y1 - y2) / 3
                        ];
                        bezierPoints.push([
                            [
                                x0,
                                y0
                            ],
                            control1,
                            control2,
                            [
                                x2,
                                y2
                            ]
                        ]);
                        return bezierPoints;
                    }
                    #redraw() {
                        if (this.isEmpty()) {
                            this.#updateTransform();
                            return;
                        }
                        this.#setStroke();
                        const { canvas, ctx } = this;
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        this.#updateTransform();
                        for (const path of this.bezierPath2D)ctx.stroke(path);
                    }
                    commit() {
                        if (this.#disableEditing) return;
                        super.commit();
                        this.isEditing = false;
                        this.disableEditMode();
                        this.setInForeground();
                        this.#disableEditing = true;
                        this.div.classList.add("disabled");
                        this.#fitToContent(true);
                        this.makeResizable();
                        this.parent.addInkEditorIfNeeded(true);
                        this.moveInDOM();
                        this.div.focus({
                            preventScroll: true
                        });
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        this.enableEditMode();
                    }
                    canvasPointerdown(event) {
                        if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) return;
                        this.setInForeground();
                        event.preventDefault();
                        if (event.type !== "mouse") this.div.focus();
                        this.#startDrawing(event.offsetX, event.offsetY);
                    }
                    canvasPointermove(event) {
                        event.preventDefault();
                        this.#draw(event.offsetX, event.offsetY);
                    }
                    canvasPointerup(event) {
                        event.preventDefault();
                        this.#endDrawing(event);
                    }
                    canvasPointerleave(event) {
                        this.#endDrawing(event);
                    }
                    #endDrawing(event) {
                        this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
                        this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
                        this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
                        this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
                        setTimeout(()=>{
                            this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
                        }, 10);
                        this.#stopDrawing(event.offsetX, event.offsetY);
                        this.addToAnnotationStorage();
                        this.setInBackground();
                    }
                    #createCanvas() {
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.className = "inkEditorCanvas";
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg)=>this.canvas?.setAttribute("aria-label", msg));
                        this.div.append(this.canvas);
                        this.ctx = this.canvas.getContext("2d");
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    get isResizable() {
                        return !this.isEmpty() && this.#disableEditing;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg)=>this.div?.setAttribute("aria-label", msg));
                        const [x, y, w, h] = this.#getInitialBBox();
                        this.setAt(x, y, 0, 0);
                        this.setDims(w, h);
                        this.#createCanvas();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            this.#isCanvasInitialized = true;
                            this.#setCanvasDims();
                            this.setDims(this.width * parentWidth, this.height * parentHeight);
                            this.#redraw();
                            this.div.classList.add("disabled");
                        } else {
                            this.div.classList.add("editing");
                            this.enableEditMode();
                        }
                        this.#createObserver();
                        return this.div;
                    }
                    #setCanvasDims() {
                        if (!this.#isCanvasInitialized) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.canvas.width = Math.ceil(this.width * parentWidth);
                        this.canvas.height = Math.ceil(this.height * parentHeight);
                        this.#updateTransform();
                    }
                    setDimensions(width, height) {
                        const roundedWidth = Math.round(width);
                        const roundedHeight = Math.round(height);
                        if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) return;
                        this.#realWidth = roundedWidth;
                        this.#realHeight = roundedHeight;
                        this.canvas.style.visibility = "hidden";
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.fixAndSetPosition();
                        if (this.#disableEditing) this.#setScaleFactor(width, height);
                        this.#setCanvasDims();
                        this.#redraw();
                        this.canvas.style.visibility = "visible";
                        this.fixDims();
                    }
                    #setScaleFactor(width, height) {
                        const padding = this.#getPadding();
                        const scaleFactorW = (width - padding) / this.#baseWidth;
                        const scaleFactorH = (height - padding) / this.#baseHeight;
                        this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                    }
                    #updateTransform() {
                        const padding = this.#getPadding() / 2;
                        this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                    }
                    static #buildPath2D(bezier) {
                        const path2D = new Path2D();
                        for(let i = 0, ii = bezier.length; i < ii; i++){
                            const [first, control1, control2, second] = bezier[i];
                            if (i === 0) path2D.moveTo(...first);
                            path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                        }
                        return path2D;
                    }
                    static #toPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] += blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] + blX;
                                    points[i + 1] = x + blY;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] += blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trX - points[i + 1];
                                    points[i + 1] = trY - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    static #fromPDFCoordinates(points, rect, rotation) {
                        const [blX, blY, trX, trY] = rect;
                        switch(rotation){
                            case 0:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] -= blX;
                                    points[i + 1] = trY - points[i + 1];
                                }
                                break;
                            case 90:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = points[i + 1] - blY;
                                    points[i + 1] = x - blX;
                                }
                                break;
                            case 180:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    points[i] = trX - points[i];
                                    points[i + 1] -= blY;
                                }
                                break;
                            case 270:
                                for(let i = 0, ii = points.length; i < ii; i += 2){
                                    const x = points[i];
                                    points[i] = trY - points[i + 1];
                                    points[i + 1] = trX - x;
                                }
                                break;
                            default:
                                throw new Error("Invalid rotation");
                        }
                        return points;
                    }
                    #serializePaths(s, tx, ty, rect) {
                        const paths = [];
                        const padding = this.thickness / 2;
                        const shiftX = s * tx + padding;
                        const shiftY = s * ty + padding;
                        for (const bezier of this.paths){
                            const buffer = [];
                            const points = [];
                            for(let j = 0, jj = bezier.length; j < jj; j++){
                                const [first, control1, control2, second] = bezier[j];
                                const p10 = s * first[0] + shiftX;
                                const p11 = s * first[1] + shiftY;
                                const p20 = s * control1[0] + shiftX;
                                const p21 = s * control1[1] + shiftY;
                                const p30 = s * control2[0] + shiftX;
                                const p31 = s * control2[1] + shiftY;
                                const p40 = s * second[0] + shiftX;
                                const p41 = s * second[1] + shiftY;
                                if (j === 0) {
                                    buffer.push(p10, p11);
                                    points.push(p10, p11);
                                }
                                buffer.push(p20, p21, p30, p31, p40, p41);
                                points.push(p20, p21);
                                if (j === jj - 1) points.push(p40, p41);
                            }
                            paths.push({
                                bezier: InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
                                points: InkEditor.#toPDFCoordinates(points, rect, this.rotation)
                            });
                        }
                        return paths;
                    }
                    #getBbox() {
                        let xMin = Infinity;
                        let xMax = -Infinity;
                        let yMin = Infinity;
                        let yMax = -Infinity;
                        for (const path of this.paths)for (const [first, control1, control2, second] of path){
                            const bbox = _util.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                            xMin = Math.min(xMin, bbox[0]);
                            yMin = Math.min(yMin, bbox[1]);
                            xMax = Math.max(xMax, bbox[2]);
                            yMax = Math.max(yMax, bbox[3]);
                        }
                        return [
                            xMin,
                            yMin,
                            xMax,
                            yMax
                        ];
                    }
                    #getPadding() {
                        return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                    }
                    #fitToContent(firstTime = false) {
                        if (this.isEmpty()) return;
                        if (!this.#disableEditing) {
                            this.#redraw();
                            return;
                        }
                        const bbox = this.#getBbox();
                        const padding = this.#getPadding();
                        this.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        this.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
                        const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setAspectRatio(width, height);
                        const prevTranslationX = this.translationX;
                        const prevTranslationY = this.translationY;
                        this.translationX = -bbox[0];
                        this.translationY = -bbox[1];
                        this.#setCanvasDims();
                        this.#redraw();
                        this.#realWidth = width;
                        this.#realHeight = height;
                        this.setDims(width, height);
                        const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                        this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.InkAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.thickness = data.thickness;
                        editor.color = _util.Util.makeHexColor(...data.color);
                        editor.opacity = data.opacity;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const width = editor.width * pageWidth;
                        const height = editor.height * pageHeight;
                        const scaleFactor = editor.parentScale;
                        const padding = data.thickness / 2;
                        editor.#disableEditing = true;
                        editor.#realWidth = Math.round(width);
                        editor.#realHeight = Math.round(height);
                        const { paths, rect, rotation } = data;
                        for (let { bezier } of paths){
                            bezier = InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
                            const path = [];
                            editor.paths.push(path);
                            let p0 = scaleFactor * (bezier[0] - padding);
                            let p1 = scaleFactor * (bezier[1] - padding);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const p10 = scaleFactor * (bezier[i] - padding);
                                const p11 = scaleFactor * (bezier[i + 1] - padding);
                                const p20 = scaleFactor * (bezier[i + 2] - padding);
                                const p21 = scaleFactor * (bezier[i + 3] - padding);
                                const p30 = scaleFactor * (bezier[i + 4] - padding);
                                const p31 = scaleFactor * (bezier[i + 5] - padding);
                                path.push([
                                    [
                                        p0,
                                        p1
                                    ],
                                    [
                                        p10,
                                        p11
                                    ],
                                    [
                                        p20,
                                        p21
                                    ],
                                    [
                                        p30,
                                        p31
                                    ]
                                ]);
                                p0 = p30;
                                p1 = p31;
                            }
                            const path2D = this.#buildPath2D(path);
                            editor.bezierPath2D.push(path2D);
                        }
                        const bbox = editor.#getBbox();
                        editor.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
                        editor.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
                        editor.#setScaleFactor(width, height);
                        return editor;
                    }
                    serialize() {
                        if (this.isEmpty()) return null;
                        const rect = this.getRect(0, 0);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                        return {
                            annotationType: _util.AnnotationEditorType.INK,
                            color: color,
                            thickness: this.thickness,
                            opacity: this.opacity,
                            paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                    }
                }
                exports.InkEditor = InkEditor;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_layer = __w_pdfjs_require__(29);
                class StampEditor extends _editor.AnnotationEditor {
                    #bitmap = null;
                    #bitmapId = null;
                    #bitmapPromise = null;
                    #bitmapUrl = null;
                    #bitmapFile = null;
                    #canvas = null;
                    #observer = null;
                    #resizeTimeoutId = null;
                    #isSvg = false;
                    #hasBeenAddedInUndoStack = false;
                    static _type = "stamp";
                    constructor(params){
                        super({
                            ...params,
                            name: "stampEditor"
                        });
                        this.#bitmapUrl = params.bitmapUrl;
                        this.#bitmapFile = params.bitmapFile;
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n);
                    }
                    static get supportedTypes() {
                        const types = [
                            "apng",
                            "avif",
                            "bmp",
                            "gif",
                            "jpeg",
                            "png",
                            "svg+xml",
                            "webp",
                            "x-icon"
                        ];
                        return (0, _util.shadow)(this, "supportedTypes", types.map((type)=>`image/${type}`));
                    }
                    static get supportedTypesStr() {
                        return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                    }
                    static isHandlingMimeForPasting(mime) {
                        return this.supportedTypes.includes(mime);
                    }
                    static paste(item, parent) {
                        parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
                            bitmapFile: item.getAsFile()
                        });
                    }
                    #getBitmapFetched(data, fromId = false) {
                        if (!data) {
                            this.remove();
                            return;
                        }
                        this.#bitmap = data.bitmap;
                        if (!fromId) {
                            this.#bitmapId = data.id;
                            this.#isSvg = data.isSvg;
                        }
                        this.#createCanvas();
                    }
                    #getBitmapDone() {
                        this.#bitmapPromise = null;
                        this._uiManager.enableWaiting(false);
                        if (this.#canvas) this.div.focus();
                    }
                    #getBitmap() {
                        if (this.#bitmapId) {
                            this._uiManager.enableWaiting(true);
                            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapUrl) {
                            const url = this.#bitmapUrl;
                            this.#bitmapUrl = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        if (this.#bitmapFile) {
                            const file = this.#bitmapFile;
                            this.#bitmapFile = null;
                            this._uiManager.enableWaiting(true);
                            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
                            return;
                        }
                        const input = document.createElement("input");
                        input.type = "file";
                        input.accept = StampEditor.supportedTypesStr;
                        this.#bitmapPromise = new Promise((resolve)=>{
                            input.addEventListener("change", async ()=>{
                                if (!input.files || input.files.length === 0) this.remove();
                                else {
                                    this._uiManager.enableWaiting(true);
                                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                                    this.#getBitmapFetched(data);
                                }
                                resolve();
                            });
                            input.addEventListener("cancel", ()=>{
                                this.remove();
                                resolve();
                            });
                        }).finally(()=>this.#getBitmapDone());
                        input.click();
                    }
                    remove() {
                        if (this.#bitmapId) {
                            this.#bitmap = null;
                            this._uiManager.imageManager.deleteId(this.#bitmapId);
                            this.#canvas?.remove();
                            this.#canvas = null;
                            this.#observer?.disconnect();
                            this.#observer = null;
                        }
                        super.remove();
                    }
                    rebuild() {
                        if (!this.parent) {
                            if (this.#bitmapId) this.#getBitmap();
                            return;
                        }
                        super.rebuild();
                        if (this.div === null) return;
                        if (this.#bitmapId) this.#getBitmap();
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    onceAdded() {
                        this._isDraggable = true;
                        this.div.focus();
                    }
                    isEmpty() {
                        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
                    }
                    get isResizable() {
                        return true;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.div.hidden = true;
                        if (this.#bitmap) this.#createCanvas();
                        else this.#getBitmap();
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                        }
                        return this.div;
                    }
                    #createCanvas() {
                        const { div } = this;
                        let { width, height } = this.#bitmap;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const MAX_RATIO = 0.75;
                        if (this.width) {
                            width = this.width * pageWidth;
                            height = this.height * pageHeight;
                        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                            width *= factor;
                            height *= factor;
                        }
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                        this._uiManager.enableWaiting(false);
                        const canvas = this.#canvas = document.createElement("canvas");
                        div.append(canvas);
                        div.hidden = false;
                        this.#drawBitmap(width, height);
                        this.#createObserver();
                        if (!this.#hasBeenAddedInUndoStack) {
                            this.parent.addUndoableEditor(this);
                            this.#hasBeenAddedInUndoStack = true;
                        }
                        this._uiManager._eventBus.dispatch("reporttelemetry", {
                            source: this,
                            details: {
                                type: "editing",
                                subtype: this.editorType,
                                data: {
                                    action: "inserted_image"
                                }
                            }
                        });
                        this.addAltTextButton();
                    }
                    #setDimensions(width, height) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.setDims(width, height);
                        if (this._initialOptions?.isCentered) this.center();
                        else this.fixAndSetPosition();
                        this._initialOptions = null;
                        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
                        const TIME_TO_WAIT = 200;
                        this.#resizeTimeoutId = setTimeout(()=>{
                            this.#resizeTimeoutId = null;
                            this.#drawBitmap(width, height);
                        }, TIME_TO_WAIT);
                    }
                    #scaleBitmap(width, height) {
                        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
                        let newWidth = bitmapWidth;
                        let newHeight = bitmapHeight;
                        let bitmap = this.#bitmap;
                        while(newWidth > 2 * width || newHeight > 2 * height){
                            const prevWidth = newWidth;
                            const prevHeight = newHeight;
                            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                            const offscreen = new OffscreenCanvas(newWidth, newHeight);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                            bitmap = offscreen.transferToImageBitmap();
                        }
                        return bitmap;
                    }
                    #drawBitmap(width, height) {
                        width = Math.ceil(width);
                        height = Math.ceil(height);
                        const canvas = this.#canvas;
                        if (!canvas || canvas.width === width && canvas.height === height) return;
                        canvas.width = width;
                        canvas.height = height;
                        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
                        const ctx = canvas.getContext("2d");
                        ctx.filter = this._uiManager.hcmFilter;
                        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                    }
                    #serializeBitmap(toUrl) {
                        if (toUrl) {
                            if (this.#isSvg) {
                                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                                if (url) return url;
                            }
                            const canvas = document.createElement("canvas");
                            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
                            const ctx = canvas.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0);
                            return canvas.toDataURL();
                        }
                        if (this.#isSvg) {
                            const [pageWidth, pageHeight] = this.pageDimensions;
                            const width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                            const offscreen = new OffscreenCanvas(width, height);
                            const ctx = offscreen.getContext("2d");
                            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
                            return offscreen.transferToImageBitmap();
                        }
                        return structuredClone(this.#bitmap);
                    }
                    #createObserver() {
                        this.#observer = new ResizeObserver((entries)=>{
                            const rect = entries[0].contentRect;
                            if (rect.width && rect.height) this.#setDimensions(rect.width, rect.height);
                        });
                        this.#observer.observe(this.div);
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.StampAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        const { rect, bitmapUrl, bitmapId, isSvg, accessibilityData } = data;
                        if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) editor.#bitmapId = bitmapId;
                        else editor.#bitmapUrl = bitmapUrl;
                        editor.#isSvg = isSvg;
                        const [parentWidth, parentHeight] = editor.pageDimensions;
                        editor.width = (rect[2] - rect[0]) / parentWidth;
                        editor.height = (rect[3] - rect[1]) / parentHeight;
                        if (accessibilityData) editor.altTextData = accessibilityData;
                        return editor;
                    }
                    serialize(isForCopying = false, context = null) {
                        if (this.isEmpty()) return null;
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.STAMP,
                            bitmapId: this.#bitmapId,
                            pageIndex: this.pageIndex,
                            rect: this.getRect(0, 0),
                            rotation: this.rotation,
                            isSvg: this.#isSvg,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) {
                            serialized.bitmapUrl = this.#serializeBitmap(true);
                            serialized.accessibilityData = this.altTextData;
                            return serialized;
                        }
                        const { decorative, altText } = this.altTextData;
                        if (!decorative && altText) serialized.accessibilityData = {
                            type: "Figure",
                            alt: altText
                        };
                        if (context === null) return serialized;
                        context.stamps ||= new Map();
                        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                        if (!context.stamps.has(this.#bitmapId)) {
                            context.stamps.set(this.#bitmapId, {
                                area: area,
                                serialized: serialized
                            });
                            serialized.bitmap = this.#serializeBitmap(false);
                        } else if (this.#isSvg) {
                            const prevData = context.stamps.get(this.#bitmapId);
                            if (area > prevData.area) {
                                prevData.area = area;
                                prevData.serialized.bitmap.close();
                                prevData.serialized.bitmap = this.#serializeBitmap(false);
                            }
                        }
                        return serialized;
                    }
                }
                exports.StampEditor = StampEditor;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AbortException", {
                enumerable: true,
                get: function() {
                    return _util.AbortException;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_editor_layer.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function() {
                    return _tools.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "DOMSVGFactory", {
                enumerable: true,
                get: function() {
                    return _display_utils.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports, "FeatureTest", {
                enumerable: true,
                get: function() {
                    return _util.FeatureTest;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "ImageKind", {
                enumerable: true,
                get: function() {
                    return _util.ImageKind;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "PromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util.PromiseCapability;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _api.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isDataScheme", {
                enumerable: true,
                get: function() {
                    return _display_utils.isDataScheme;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "noContextMenu", {
                enumerable: true,
                get: function() {
                    return _display_utils.noContextMenu;
                }
            });
            Object.defineProperty(exports, "normalizeUnicode", {
                enumerable: true,
                get: function() {
                    return _util.normalizeUnicode;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "setLayerDimensions", {
                enumerable: true,
                get: function() {
                    return _display_utils.setLayerDimensions;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "updateTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.updateTextLayer;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function() {
                    return _api.version;
                }
            });
            var _util = __w_pdfjs_require__(1);
            var _api = __w_pdfjs_require__(2);
            var _display_utils = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            const pdfjsVersion = '3.11.174';
            const pdfjsBuild = 'ce8716743';
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});

parcelRegister("aYpFv", function(module, exports) {
module.exports = new URL("analyser.5d7563a7.png", import.meta.url).toString();

});

parcelRegister("8r03d", function(module, exports) {
module.exports = new URL("standard_right_bg.def4a57d.png", import.meta.url).toString();

});

parcelRegister("3BbyF", function(module, exports) {
module.exports = new URL("duedig_logo.2c0bb450.png", import.meta.url).toString();

});

parcelRegister("javVb", function(module, exports) {
module.exports = new URL("dueDig.63cd5fdd.png", import.meta.url).toString();

});

parcelRegister("aE6n3", function(module, exports) {
module.exports = new URL("knoli_logo.002f3f89.png", import.meta.url).toString();

});

parcelRegister("lRae8", function(module, exports) {
module.exports = new URL("knolli.8de66cab.png", import.meta.url).toString();

});

parcelRegister("dyKJW", function(module, exports) {
module.exports = new URL("knoli_right_bg_one.9f623970.png", import.meta.url).toString();

});

parcelRegister("dYkl9", function(module, exports) {
module.exports = new URL("knoli_right_bg_two.6a585c7a.png", import.meta.url).toString();

});

parcelRegister("hPEJZ", function(module, exports) {
module.exports = new URL("genfinance.ai_logo.7cb6b44f.png", import.meta.url).toString();

});

parcelRegister("1HDNE", function(module, exports) {
module.exports = new URL("genfinance.ai.7fd2a734.png", import.meta.url).toString();

});

parcelRegister("3Tb8j", function(module, exports) {
module.exports = new URL("yoono.ai_logo.3d9f9154.png", import.meta.url).toString();

});

parcelRegister("kMbGU", function(module, exports) {
module.exports = new URL("yoono.ai.67a52de9.png", import.meta.url).toString();

});

parcelRegister("eqFVc", function(module, exports) {
module.exports = new URL("kissthefish_logo.3a7bd3c9.png", import.meta.url).toString();

});

parcelRegister("a3JXO", function(module, exports) {
module.exports = new URL("kissthefish.9670f740.png", import.meta.url).toString();

});

parcelRegister("aqeGv", function(module, exports) {
module.exports = new URL("nume_logo.54b35ff8.png", import.meta.url).toString();

});

parcelRegister("bnvTy", function(module, exports) {
module.exports = new URL("nume.be4d6e5f.png", import.meta.url).toString();

});

parcelRegister("4yNMH", function(module, exports) {
module.exports = new URL("startup2standup_logo.c4e0cdcf.png", import.meta.url).toString();

});

parcelRegister("2Ap9I", function(module, exports) {
module.exports = new URL("startup2standup.eb167540.png", import.meta.url).toString();

});

parcelRegister("aUWiE", function(module, exports) {
module.exports = new URL("freshbat_logo.b79dbcba.png", import.meta.url).toString();

});

parcelRegister("5CJ1x", function(module, exports) {
module.exports = new URL("freshbat.f2992858.png", import.meta.url).toString();

});

parcelRegister("9KZLI", function(module, exports) {
module.exports = new URL("goeo_logo.5a175611.png", import.meta.url).toString();

});

parcelRegister("9ypgU", function(module, exports) {
module.exports = new URL("goeo.f967a13b.png", import.meta.url).toString();

});

parcelRegister("cULhn", function(module, exports) {
module.exports = new URL("intelectgroup_logo.084d92ae.png", import.meta.url).toString();

});

parcelRegister("3p35q", function(module, exports) {
module.exports = new URL("intelectgroup.375137d3.png", import.meta.url).toString();

});

parcelRegister("haYIc", function(module, exports) {
module.exports = new URL("greenripple_logo.57da29f2.png", import.meta.url).toString();

});

parcelRegister("jNsLY", function(module, exports) {
module.exports = new URL("greenripple.d47b4461.png", import.meta.url).toString();

});

parcelRegister("jdErA", function(module, exports) {
module.exports = new URL("flocast_logo.a2e91a65.png", import.meta.url).toString();

});

parcelRegister("3TXzc", function(module, exports) {
module.exports = new URL("flocast.b5eb5407.png", import.meta.url).toString();

});

parcelRegister("7XACG", function(module, exports) {
module.exports = new URL("appStore.5c5c4516.svg", import.meta.url).toString();

});

parcelRegister("fYhjK", function(module, exports) {
module.exports = new URL("partners-30-minutes.99f1aa08.png", import.meta.url).toString();

});

parcelRegister("8L0Le", function(module, exports) {
module.exports = new URL("knoli_bottom_img.1788a24e.png", import.meta.url).toString();

});

parcelRegister("d6bjp", function(module, exports) {
module.exports = new URL("yoono.ai_right_img.8b804dbc.png", import.meta.url).toString();

});

parcelRegister("fnOP2", function(module, exports) {
module.exports = new URL("startup2standup_popup.43a13d23.png", import.meta.url).toString();

});

parcelRegister("coacY", function(module, exports) {
module.exports = new URL("certifii_right_img.a82e35aa.png", import.meta.url).toString();

});

parcelRegister("9D14E", function(module, exports) {
module.exports = new URL("vaultinum_right_img.ae530aed.png", import.meta.url).toString();

});

parcelRegister("lfuBX", function(module, exports) {
module.exports = new URL("opus_right_img.ae530aed.png", import.meta.url).toString();

});

parcelRegister("kcO1m", function(module, exports) {
module.exports = new URL("undo.b4394e8f.svg", import.meta.url).toString();

});

parcelRegister("2Z82J", function(module, exports) {
module.exports = new URL("demo-checklist-sidebar-three.77f33efd.png", import.meta.url).toString();

});

parcelRegister("h9XVc", function(module, exports) {
module.exports = new URL("demo-checklist-sidebar-two.7924950d.png", import.meta.url).toString();

});

parcelRegister("fv0ry", function(module, exports) {
module.exports = new URL("demo-checklist-sidebar-one.7d6518de.png", import.meta.url).toString();

});

parcelRegister("16z8Y", function(module, exports) {
module.exports = new URL("demo-checklist-pre-populate.190f4230.png", import.meta.url).toString();

});

parcelRegister("ase4v", function(module, exports) {
module.exports = new URL("firework.cea2e85e.gif", import.meta.url).toString();

});

parcelRegister("kpQLa", function(module, exports) {
module.exports = new URL("apply-climb26-popup.1ec323f2.png", import.meta.url).toString();

});

parcelRegister("1IN79", function(module, exports) {
module.exports = new URL("apply-ehe-popup.688b4f13.png", import.meta.url).toString();

});

parcelRegister("9FXIX", function(module, exports) {
module.exports = new URL("apply-box-popup.7f71221c.png", import.meta.url).toString();

});

parcelRegister("dCaAd", function(module, exports) {
module.exports = new URL("kpmg-popup-ai.f5a28785.png", import.meta.url).toString();

});

parcelRegister("3Ow7q", function(module, exports) {
module.exports = new URL("GDrive.92040dea.gif", import.meta.url).toString();

});

parcelRegister("46E3R", function(module, exports) {
module.exports = new URL("dropbox.edaea965.gif", import.meta.url).toString();

});

parcelRegister("8HFxV", function(module, exports) {
module.exports = new URL("sharepoint.a9a7e09d.gif", import.meta.url).toString();

});

parcelRegister("3DH5F", function(module, exports) {
module.exports = new URL("demo-checklist-popup-workflow.2cf1b77b.png", import.meta.url).toString();

});

parcelRegister("2Gkf0", function(module, exports) {
module.exports = new URL("demo-checklist-popup-report.7c20dbc3.png", import.meta.url).toString();

});

parcelRegister("169qC", function(module, exports) {
module.exports = new URL("wispr-logo.6c8acd69.png", import.meta.url).toString();

});

parcelRegister("4Rkxv", function(module, exports) {
module.exports = new URL("fillingassistanticons.9da332b7.png", import.meta.url).toString();

});

parcelRegister("3nZQn", function(module, exports) {
module.exports = new URL("google-drive-icon.e9238fa7.png", import.meta.url).toString();

});

parcelRegister("dRr6z", function(module, exports) {
module.exports = new URL("drop-box-icon.355d7481.png", import.meta.url).toString();

});

parcelRegister("lnvWz", function(module, exports) {
module.exports = new URL("share-point-icon.264cfecd.png", import.meta.url).toString();

});

parcelRegister("8xM0j", function(module, exports) {
module.exports = new URL("folder-replication.c900d31b.png", import.meta.url).toString();

});

parcelRegister("aMopV", function(module, exports) {
module.exports = new URL("two-way-sync.16bc3de5.png", import.meta.url).toString();

});

parcelRegister("40cRe", function(module, exports) {
module.exports = new URL("import-existing-files.6d94f366.png", import.meta.url).toString();

});

parcelRegister("4W4iq", function(module, exports) {
module.exports = new URL("source-colour-coding.5d472715.png", import.meta.url).toString();

});

parcelRegister("hxhdZ", function(module, exports) {
module.exports = new URL("shield-check-mark.be1ab926.png", import.meta.url).toString();

});

parcelRegister("eYpf8", function(module, exports) {
module.exports = new URL("about-img.46723a04.png", import.meta.url).toString();

});

parcelRegister("54Tzx", function(module, exports) {
module.exports = new URL("not-yet-certification.712f0ae3.png", import.meta.url).toString();

});

parcelRegister("k9drL", function(module, exports) {
module.exports = new URL("bronze-certification.656b9043.png", import.meta.url).toString();

});

parcelRegister("7yGAu", function(module, exports) {
module.exports = new URL("silver-certification.89ba43af.png", import.meta.url).toString();

});

parcelRegister("hnx8c", function(module, exports) {
module.exports = new URL("gold-certification.a8005c64.png", import.meta.url).toString();

});

parcelRegister("5r6c6", function(module, exports) {
module.exports = new URL("cName.627bc6d8.png", import.meta.url).toString();

});

parcelRegister("h9sGd", function(module, exports) {
module.exports = new URL("cReg.b46fafcf.png", import.meta.url).toString();

});

parcelRegister("e2Yht", function(module, exports) {
module.exports = new URL("cWebsite.9e31d4b7.png", import.meta.url).toString();

});

parcelRegister("fSLCH", function(module, exports) {
module.exports = new URL("cPhone.b8e62d93.png", import.meta.url).toString();

});

parcelRegister("kUe3E", function(module, exports) {
module.exports = new URL("cAddress.1f643ed5.png", import.meta.url).toString();

});

parcelRegister("gaJU8", function(module, exports) {
module.exports = new URL("cEmail.62b07199.png", import.meta.url).toString();

});

parcelRegister("k0W4k", function(module, exports) {
module.exports = new URL("applicant-preparedness-one.02a7737c.png", import.meta.url).toString();

});

parcelRegister("bcgpJ", function(module, exports) {
module.exports = new URL("applicant-preparedness-two.d5c5c3ce.png", import.meta.url).toString();

});

parcelRegister("5oLQF", function(module, exports) {
module.exports = new URL("applicant-preparedness-three.107ce497.png", import.meta.url).toString();

});

parcelRegister("8lNxh", function(module, exports) {
module.exports = new URL("cLock.720fb427.png", import.meta.url).toString();

});

parcelRegister("4h5pa", function(module, exports) {
module.exports = new URL("quick-response-ai.d3de71ff.png", import.meta.url).toString();

});

parcelRegister("7jB25", function(module, exports) {
module.exports = new URL("sidebar-details-ai.97ba4423.png", import.meta.url).toString();

});

parcelRegister("a1Fed", function(module, exports) {
module.exports = new URL("sidebar-skills-experience.7f352c5b.png", import.meta.url).toString();

});

parcelRegister("5Mjhm", function(module, exports) {
module.exports = new URL("crown-circle.3e6fb245.png", import.meta.url).toString();

});

parcelRegister("f44BT", function(module, exports) {
module.exports = new URL("companies-investment.36495881.svg", import.meta.url).toString();

});

parcelRegister("eRrFC", function(module, exports) {
module.exports = new URL("companies-growth.c55a4ab0.svg", import.meta.url).toString();

});

parcelRegister("kzdFc", function(module, exports) {
module.exports = new URL("companies-exit.867ae33a.svg", import.meta.url).toString();

});

parcelRegister("6U4As", function(module, exports) {
module.exports = new URL("investment-growth-exit.ec47c0f7.png", import.meta.url).toString();

});

parcelRegister("ayKVW", function(module, exports) {
module.exports = new URL("morsebridge-icon.d1d9685c.png", import.meta.url).toString();

});

parcelRegister("aHS0B", function(module, exports) {
module.exports = new URL("morsebridge-icon-white.092f84a6.png", import.meta.url).toString();

});

parcelRegister("9r8tK", function(module, exports) {
module.exports = new URL("diligentsia-icon.4538bd00.png", import.meta.url).toString();

});

parcelRegister("dbmM1", function(module, exports) {
module.exports = new URL("vc-top-banner.586a1f13.png", import.meta.url).toString();

});

parcelRegister("eC1vN", function(module, exports) {
module.exports = new URL("book-a-call-mark.705d3a5b.png", import.meta.url).toString();

});

parcelRegister("6OAvy", function(module, exports) {
module.exports = new URL("what-vcs-look-for-series-a.91a93503.jpg", import.meta.url).toString();

});

parcelRegister("7OZMl", function(module, exports) {
module.exports = new URL("how-ai-is-changing-due-diligence-growth-stage.d84f82c3.jpg", import.meta.url).toString();

});

parcelRegister("leiZk", function(module, exports) {
module.exports = new URL("how-vcs-evaluate-early-stage-companies.f1fd0f20.jpg", import.meta.url).toString();

});

parcelRegister("fLEMS", function(module, exports) {
module.exports = new URL("how-to-prepare-for-vc-due-diligence.c5af0399.jpg", import.meta.url).toString();

});

parcelRegister("kbpHI", function(module, exports) {
module.exports = new URL("what-do-investors-check-in-due-diligence.084ae932.jpg", import.meta.url).toString();

});

parcelRegister("jcBRH", function(module, exports) {
module.exports = new URL("how-to-prepare-for-exit-due-diligence.3ffa7886.jpg", import.meta.url).toString();

});

parcelRegister("bnQh1", function(module, exports) {
module.exports = new URL("how-fractional-cfos-use-diligentsia.41d5c438.jpg", import.meta.url).toString();

});

parcelRegister("j4E5S", function(module, exports) {
module.exports = new URL("what-angel-investors-look-for.96eef5e4.jpg", import.meta.url).toString();

});

parcelRegister("b8il8", function(module, exports) {
module.exports = new URL("how-to-prepare-due-diligence-pack-seed-investment.116c3fb2.jpg", import.meta.url).toString();

});

parcelRegister("dZoB9", function(module, exports) {
module.exports = new URL("how-long-does-startup-due-diligence-take.4b5189f1.jpg", import.meta.url).toString();

});

parcelRegister("jJl01", function(module, exports) {
module.exports = new URL("what-is-pisces-core-disclosures.f8546c2f.jpg", import.meta.url).toString();

});

parcelRegister("8iBsD", function(module, exports) {
module.exports = new URL("how-to-complete-pisces-core-disclosures.0dd2d5c1.jpg", import.meta.url).toString();

});

parcelRegister("7WyJA", function(module, exports) {
module.exports = new URL("how-ai-is-changing-pisces-disclosure-preparation.5009700c.jpg", import.meta.url).toString();

});

parcelRegister("4fMcK", function(module, exports) {
module.exports = new URL("sme-due-diligence-cost-statistics.b781283a.jpg", import.meta.url).toString();

});

parcelRegister("lmUZO", function(module, exports) {
module.exports = new URL("how-ai-is-changing-fractional-cfo-role.da21d219.jpg", import.meta.url).toString();

});

parcelRegister("3uZxt", function(module, exports) {
module.exports = new URL("what-happens-when-grant-funding-ends.854bc64c.jpg", import.meta.url).toString();

});

parcelRegister("427SA", function(module, exports) {
module.exports = new URL("how-angel-networks-improve-startup-funding-rates.de4e6fe1.jpg", import.meta.url).toString();

});

parcelRegister("3hTs8", function(module, exports) {
module.exports = new URL("how-to-prepare-for-angel-due-diligence.843e6acc.jpg", import.meta.url).toString();

});

parcelRegister("iajSD", function(module, exports) {
module.exports = new URL("how-accelerators-improve-startup-funding-rates.0b1ff614.jpg", import.meta.url).toString();

});

parcelRegister("1NWfs", function(module, exports) {
module.exports = new URL("how-long-to-get-investment-ready.3ed00ba9.jpg", import.meta.url).toString();

});

parcelRegister("724aZ", function(module, exports) {
module.exports = new URL("get-more-value-from-business-support-adviser.ab881dce.jpg", import.meta.url).toString();

});

parcelRegister("gNT8r", function(module, exports) {
module.exports = new URL("companies-top-banner.c33b1bd3.png", import.meta.url).toString();

});

parcelRegister("jm5NV", function(module, exports) {
module.exports = new URL("diligence-pack.eba81803.png", import.meta.url).toString();

});

parcelRegister("b6j5K", function(module, exports) {
module.exports = new URL("growth-ready-icon.f3c8d4fd.png", import.meta.url).toString();

});

parcelRegister("5I4PL", function(module, exports) {
module.exports = new URL("exit-ready-icon.9f4ef05f.png", import.meta.url).toString();

});

parcelRegister("lka2d", function(module, exports) {
module.exports = new URL("sync-datarooms.fec98395.png", import.meta.url).toString();

});

parcelRegister("lACR8", function(module, exports) {
module.exports = new URL("ai-autofill.008f847c.png", import.meta.url).toString();

});

parcelRegister("2inU5", function(module, exports) {
module.exports = new URL("certificates.d7602528.png", import.meta.url).toString();

});

parcelRegister("1CdQQ", function(module, exports) {
module.exports = new URL("form-background-3.1cc5cd46.png", import.meta.url).toString();

});

parcelRegister("jtDwL", function(module, exports) {
module.exports = new URL("ceo-background-image.9a53c190.png", import.meta.url).toString();

});

parcelRegister("bEcQf", function(module, exports) {
module.exports = new URL("light-cololr-circle.fce8c8fd.png", import.meta.url).toString();

});

parcelRegister("g80Ou", function(module, exports) {
module.exports = new URL("spirel.65ba8386.png", import.meta.url).toString();

});

parcelRegister("isHPH", function(module, exports) {
module.exports = new URL("blue-circle.3e66fc4e.png", import.meta.url).toString();

});

parcelRegister("huYd5", function(module, exports) {
module.exports = new URL("half-curve.1641c46a.png", import.meta.url).toString();

});

parcelRegister("aXBsB", function(module, exports) {
module.exports = new URL("reactangle-image.1b9f314f.png", import.meta.url).toString();

});

parcelRegister("P76E6", function(module, exports) {
module.exports = new URL("ball-certficate.870f03b7.png", import.meta.url).toString();

});

parcelRegister("aGe1o", function(module, exports) {
module.exports = new URL("diligentsia-certification.4e639088.png", import.meta.url).toString();

});

parcelRegister("giguH", function(module, exports) {
module.exports = new URL("form-blur.3293b973.png", import.meta.url).toString();

});

parcelRegister("9itwL", function(module, exports) {
module.exports = new URL("fit-report-blur.c5d698e2.png", import.meta.url).toString();

});

parcelRegister("gbppE", function(module, exports) {
module.exports = new URL("investor-form.3293b973.png", import.meta.url).toString();

});

parcelRegister("lmLdj", function(module, exports) {
module.exports = new URL("application-moda-img.da5866eb.png", import.meta.url).toString();

});

parcelRegister("24ldb", function(module, exports) {
module.exports = new URL("how-modal.2037d7ab.png", import.meta.url).toString();

});

parcelRegister("3DCvD", function(module, exports) {
module.exports = new URL("form-background.5b538b4e.png", import.meta.url).toString();

});

parcelRegister("hHzl1", function(module, exports) {
module.exports = new URL("key-feature-certificates.f69a5db5.png", import.meta.url).toString();

});

parcelRegister("jVRke", function(module, exports) {
module.exports = new URL("key-feature-gold-certificate.46833048.png", import.meta.url).toString();

});

parcelRegister("7JLrt", function(module, exports) {
module.exports = new URL("accounts-lawrs-bloon-2.82cf0160.png", import.meta.url).toString();

});

parcelRegister("hkSFW", function(module, exports) {
module.exports = new URL("accounts-lawrs-bloon-1.ac6e76b8.png", import.meta.url).toString();

});

parcelRegister("cV878", function(module, exports) {
module.exports = new URL("binocular-eyes.f4ff336d.png", import.meta.url).toString();

});

parcelRegister("9RTcM", function(module, exports) {
module.exports = new URL("angle-main-banner.98528ad4.png", import.meta.url).toString();

});

parcelRegister("elPjF", function(module, exports) {
module.exports = new URL("conv-ceo.7e5f274b.png", import.meta.url).toString();

});

parcelRegister("aEyq0", function(module, exports) {
module.exports = new URL("banner free.56259675.png", import.meta.url).toString();

});

parcelRegister("8QUJK", function(module, exports) {
module.exports = new URL("banner23-opp.c31801ba.png", import.meta.url).toString();

});

parcelRegister("bMTa0", function(module, exports) {
module.exports = new URL("banner22.1bd95e92.png", import.meta.url).toString();

});

parcelRegister("jQaaA", function(module, exports) {
module.exports = new URL("banner24.5da9c1dd.png", import.meta.url).toString();

});

parcelRegister("1RI5O", function(module, exports) {
module.exports = new URL("daimond.92f0180e.png", import.meta.url).toString();

});

parcelRegister("cGrEE", function(module, exports) {
module.exports = new URL("banner1-left.39d5536a.png", import.meta.url).toString();

});

parcelRegister("g2mEf", function(module, exports) {
module.exports = new URL("right-side-zak.7a0b547c.png", import.meta.url).toString();

});

parcelRegister("gkva9", function(module, exports) {
module.exports = new URL("blue-animation-half-circle.c6df3bba.png", import.meta.url).toString();

});

parcelRegister("bb24K", function(module, exports) {
module.exports = new URL("cabinet-right.0e484fd6.gif", import.meta.url).toString();

});

parcelRegister("3eaG9", function(module, exports) {
module.exports = new URL("angels-bloon-1.c6182954.png", import.meta.url).toString();

});

parcelRegister("9yeTX", function(module, exports) {
module.exports = new URL("banner18-opp.934c9bcd.png", import.meta.url).toString();

});

parcelRegister("2VRxR", function(module, exports) {
module.exports = new URL("banner18.8f05013a.png", import.meta.url).toString();

});

parcelRegister("etzTw", function(module, exports) {
module.exports = new URL("banner11-opp.dfacc149.png", import.meta.url).toString();

});

parcelRegister("h66Qq", function(module, exports) {
module.exports = new URL("banner15.99e79a11.png", import.meta.url).toString();

});

parcelRegister("dyyh4", function(module, exports) {
module.exports = new URL("rect-animation.611ebf87.png", import.meta.url).toString();

});

parcelRegister("3KuBs", function(module, exports) {
module.exports = new URL("angels-bloon-2.b796d751.png", import.meta.url).toString();

});

parcelRegister("gXpUq", function(module, exports) {
module.exports = new URL("banner7.e6e99aca.png", import.meta.url).toString();

});

parcelRegister("fNv1Y", function(module, exports) {
module.exports = new URL("thumbnail6.6bcf4614.png", import.meta.url).toString();

});

parcelRegister("lt5KC", function(module, exports) {
module.exports = new URL("calculation10-1.86410830.gif", import.meta.url).toString();

});

parcelRegister("fXJEg", function(module, exports) {
module.exports = new URL("vestd_logo.7669c2f8.png", import.meta.url).toString();

});

parcelRegister("59R3Z", function(module, exports) {
module.exports = new URL("jp_jenkins_logo.a3052cbf.jpg", import.meta.url).toString();

});

parcelRegister("7j8Vt", function(module, exports) {
module.exports = new URL("pisces-top-banner.7aa2a2ea.png", import.meta.url).toString();

});

parcelRegister("3WQfg", function(module, exports) {
module.exports = new URL("climb26-play.30c17a08.png", import.meta.url).toString();

});

parcelRegister("i6Lkf", function(module, exports) {
module.exports = new URL("video-play.9b028fb9.png", import.meta.url).toString();

});

parcelRegister("iRgdw", function(module, exports) {
module.exports = new URL("climb26-logo.bbd5953b.png", import.meta.url).toString();

});

parcelRegister("3S7TI", function(module, exports) {
module.exports = new URL("climb26-company-banner.4c8f7aa7.png", import.meta.url).toString();

});

parcelRegister("duAsp", function(module, exports) {
module.exports = new URL("climb26-company-slide1.39f33a05.jpg", import.meta.url).toString();

});

parcelRegister("YlaV4", function(module, exports) {
module.exports = new URL("climb26-company-slide2.822f6771.jpg", import.meta.url).toString();

});

parcelRegister("j0cx9", function(module, exports) {
module.exports = new URL("climb26-company-slide3.88f275cd.jpg", import.meta.url).toString();

});

parcelRegister("99eVd", function(module, exports) {
module.exports = new URL("climb26-company-slide4.ab9db586.jpg", import.meta.url).toString();

});

parcelRegister("6ji0O", function(module, exports) {
module.exports = new URL("climb26-company-slide5.cef8f91c.jpg", import.meta.url).toString();

});

parcelRegister("1lqJw", function(module, exports) {
module.exports = new URL("climb26-company-slide6.6bf5adec.jpg", import.meta.url).toString();

});

parcelRegister("87Kue", function(module, exports) {
module.exports = new URL("climb26-company-slide7.9c26a788.jpg", import.meta.url).toString();

});

parcelRegister("dFPSK", function(module, exports) {
module.exports = new URL("climb26-company-slide8.f236d0c8.jpg", import.meta.url).toString();

});

parcelRegister("gVfeF", function(module, exports) {
module.exports = new URL("climb26-company-slide9.87520dfa.webp", import.meta.url).toString();

});

parcelRegister("7VzoB", function(module, exports) {
module.exports = new URL("pes-main-banner.5ef5aa33.png", import.meta.url).toString();

});

parcelRegister("ewAEC", function(module, exports) {
module.exports = new URL("climb26-investor-slide1.58438f1e.jpg", import.meta.url).toString();

});

parcelRegister("3fHVW", function(module, exports) {
module.exports = new URL("climb26-investor-slide2.a210fd8c.jpg", import.meta.url).toString();

});

parcelRegister("53r3z", function(module, exports) {
module.exports = new URL("climb26-investor-slide3.f71760b6.jpg", import.meta.url).toString();

});

parcelRegister("5NQYz", function(module, exports) {
module.exports = new URL("climb26-investor-slide4.c11a453c.jpg", import.meta.url).toString();

});

parcelRegister("lQLLF", function(module, exports) {
module.exports = new URL("climb26-investor-slide5.4c8266c8.jpg", import.meta.url).toString();

});

parcelRegister("5phyI", function(module, exports) {
module.exports = new URL("climb26-investor-slide6.969943f1.jpg", import.meta.url).toString();

});

parcelRegister("7Z5XR", function(module, exports) {
module.exports = new URL("climb26-investor-slide7.62f81018.jpg", import.meta.url).toString();

});

parcelRegister("jEpcG", function(module, exports) {
module.exports = new URL("accountant-top-banner.d36fc951.png", import.meta.url).toString();

});

parcelRegister("asck4", function(module, exports) {
module.exports = new URL("angel-networks-top-banner.97e78643.png", import.meta.url).toString();

});

parcelRegister("9WBJo", function(module, exports) {
module.exports = new URL("certificates.d7602528.png", import.meta.url).toString();

});

parcelRegister("lgmiQ", function(module, exports) {
module.exports = new URL("better-signal-icon.591bc429.png", import.meta.url).toString();

});

parcelRegister("dZpNf", function(module, exports) {
module.exports = new URL("faster-closes-icon.8cf56537.png", import.meta.url).toString();

});

parcelRegister("fj5w3", function(module, exports) {
module.exports = new URL("first-mover-advantage-icon.5818b988.png", import.meta.url).toString();

});

parcelRegister("8oTWu", function(module, exports) {
module.exports = new URL("fractionality.b3d68081.png", import.meta.url).toString();

});

parcelRegister("cN5F9", function(module, exports) {
module.exports = new URL("ascentis.3ea8a52e.png", import.meta.url).toString();

});

parcelRegister("at5J5", function(module, exports) {
module.exports = new URL("cfo-centre.32e4ab30.jpg", import.meta.url).toString();

});

parcelRegister("5Qq06", function(module, exports) {
module.exports = new URL("fd-consultant.a723c56e.png", import.meta.url).toString();

});

parcelRegister("hvcd1", function(module, exports) {
module.exports = new URL("leftTestimonial.7ad6c73d.svg", import.meta.url).toString();

});

parcelRegister("1GDu4", function(module, exports) {
module.exports = new URL("centerTestimonial.a1ae9254.svg", import.meta.url).toString();

});

parcelRegister("9AO8n", function(module, exports) {
module.exports = new URL("rightTestimonial.6265ab7c.svg", import.meta.url).toString();

});

parcelRegister("fqEzo", function(module, exports) {
module.exports = new URL("fractional-top-banner.b152c0d7.png", import.meta.url).toString();

});

parcelRegister("3wIsR", function(module, exports) {
module.exports = new URL("fractional-carosuel.eff7e69c.png", import.meta.url).toString();

});

parcelRegister("aX9EE", function(module, exports) {
module.exports = new URL("checklist-step-ai.1b35f7f6.png", import.meta.url).toString();

});

parcelRegister("dF0gl", function(module, exports) {
module.exports = new URL("example-1.07d05c40.png", import.meta.url).toString();

});

parcelRegister("8SKvM", function(module, exports) {
module.exports = new URL("example-img.293891e5.png", import.meta.url).toString();

});

parcelRegister("9BNWP", function(module, exports) {
module.exports = new URL("module-risk.7e6a82bb.png", import.meta.url).toString();

});

parcelRegister("bP0qH", function(module, exports) {
module.exports = new URL("checklist-active.b26318f0.png", import.meta.url).toString();

});

parcelRegister("h2aya", function(module, exports) {
module.exports = new URL("award1.7e66bfad.svg", import.meta.url).toString();

});

parcelRegister("6fqXD", function(module, exports) {
module.exports = new URL("dog-paws.1a59c177.gif", import.meta.url).toString();

});

parcelRegister("itq9G", function(module, exports) {
module.exports = new URL("aisidebar-1.f07e8fdb.png", import.meta.url).toString();

});

parcelRegister("el9yf", function(module, exports) {
module.exports = new URL("aisidebar-3.8666d15e.png", import.meta.url).toString();

});

parcelRegister("6COsh", function(module, exports) {
module.exports = new URL("aisidebar-4.76f33930.png", import.meta.url).toString();

});

parcelRegister("5QU0j", function(module, exports) {
module.exports = new URL("aisidebar-6.e464aef2.png", import.meta.url).toString();

});

parcelRegister("ksxjC", function(module, exports) {
module.exports = new URL("aisidebar-8.aa85494e.png", import.meta.url).toString();

});

parcelRegister("xz5vj", function(module, exports) {
module.exports = new URL("confetti.000ff962.png", import.meta.url).toString();

});

parcelRegister("8MWG0", function(module, exports) {
module.exports = new URL("step-completed-icon.a4c01916.png", import.meta.url).toString();

});

parcelRegister("1fXrE", function(module, exports) {
module.exports = new URL("checklist-popup-step3.04341895.png", import.meta.url).toString();

});

parcelRegister("01Jdq", function(module, exports) {
module.exports = new URL("intro-ai.6d83b7d2.png", import.meta.url).toString();

});

parcelRegister("72cmh", function(module, exports) {
module.exports = new URL("intro-how-it-works.2e3cc5a0.png", import.meta.url).toString();

});

parcelRegister("lNukX", function(module, exports) {
module.exports = new URL("5-minute.aa6bfb94.png", import.meta.url).toString();

});

parcelRegister("8BbWM", function(module, exports) {
module.exports = new URL("create-demo-checklist.1023c792.png", import.meta.url).toString();

});

parcelRegister("6BG4x", function(module, exports) {
module.exports = new URL("kpi-demo-checklist.f0f0f140.png", import.meta.url).toString();

});

parcelRegister("dLJ5b", function(module, exports) {
module.exports = new URL("create-demo-checklist-popup.d25ea774.png", import.meta.url).toString();

});

parcelRegister("kTWaK", function(module, exports) {
module.exports = new URL("cdd-intro.07e03369.png", import.meta.url).toString();

});

parcelRegister("2XZuD", function(module, exports) {
module.exports = new URL("ehe-intro.d0dee576.png", import.meta.url).toString();

});

parcelRegister("bazo5", function(module, exports) {
module.exports = new URL("abf-intro.b262bd5f.png", import.meta.url).toString();

});

parcelRegister("9bT7c", function(module, exports) {
module.exports = new URL("bfs-checklist-free.ac612ad4.png", import.meta.url).toString();

});

parcelRegister("hILNG", function(module, exports) {
module.exports = new URL("bfs-how-we-work.c0eed883.png", import.meta.url).toString();

});

parcelRegister("crPA1", function(module, exports) {
module.exports = new URL("cdd-how-we-work.1786a65a.png", import.meta.url).toString();

});

parcelRegister("1cmaD", function(module, exports) {
module.exports = new URL("ehe-how-we-work.11136161.png", import.meta.url).toString();

});

parcelRegister("hBWDP", function(module, exports) {
module.exports = new URL("abf-how-we-work.d16bb2b7.png", import.meta.url).toString();

});

parcelRegister("5NO0k", function(module, exports) {
module.exports = new URL("prequel-sidebar-ai.e33faed7.png", import.meta.url).toString();

});

parcelRegister("8Dtkj", function(module, exports) {
module.exports = new URL("kpi-partner-checklist.f0f0f140.png", import.meta.url).toString();

});

parcelRegister("eWGre", function(module, exports) {
module.exports = new URL("create-partner-checklist-popup.c5da0803.png", import.meta.url).toString();

});

parcelRegister("4kGay", function(module, exports) {
module.exports = new URL("generate-research-aid-ai.24140e0f.png", import.meta.url).toString();

});

parcelRegister("29DXw", function(module, exports) {
module.exports = new URL("generate-research-aid-popup.dd0d2a6b.png", import.meta.url).toString();

});

parcelRegister("htxVj", function(module, exports) {
module.exports = new URL("manual-intro-ai.c53bc7c1.png", import.meta.url).toString();

});

parcelRegister("gJSKe", function(module, exports) {
module.exports = new URL("manual-add-page.48621052.png", import.meta.url).toString();

});

parcelRegister("47A80", function(module, exports) {
module.exports = new URL("seedlegals-icon.849a96f2.png", import.meta.url).toString();

});

parcelRegister("5I8Ls", function(module, exports) {
module.exports = new URL("climb26-new-banner.4b1da093.png", import.meta.url).toString();

});

parcelRegister("bc4ez", function(module, exports) {
module.exports = new URL("ehe-banner.e08b1c10.png", import.meta.url).toString();

});

parcelRegister("dl4Qp", function(module, exports) {
module.exports = new URL("seedlegals-banner.b28394ad.png", import.meta.url).toString();

});

parcelRegister("79gM3", function(module, exports) {
module.exports = new URL("startup2standup.5fcfac5f.png", import.meta.url).toString();

});

parcelRegister("1z0JF", function(module, exports) {
module.exports = new URL("angelgroups-banner.8fc492d9.png", import.meta.url).toString();

});

parcelRegister("aBAKs", function(module, exports) {
module.exports = new URL("britishdesignfund-banner.c026468a.png", import.meta.url).toString();

});

parcelRegister("iWPnk", function(module, exports) {
module.exports = new URL("banner.d9063d08.png", import.meta.url).toString();

});

parcelRegister("2jAKB", function(module, exports) {
module.exports = new URL("three-steps.b4f4f11c.png", import.meta.url).toString();

});

parcelRegister("cqG6l", function(module, exports) {
module.exports = new URL("angel-group-step-1.e763b8ed.png", import.meta.url).toString();

});

parcelRegister("2NoJu", function(module, exports) {
module.exports = new URL("angel-group-step-2.bfbef988.png", import.meta.url).toString();

});

parcelRegister("kYJGG", function(module, exports) {
module.exports = new URL("british-design-fund-step-2.8af9f6bd.png", import.meta.url).toString();

});

parcelRegister("lGMEG", function(module, exports) {
module.exports = new URL("angel-group-step-3-accepted-expand.690cc002.png", import.meta.url).toString();

});

parcelRegister("bzTgU", function(module, exports) {
module.exports = new URL("angel-group-step-3-accepted.43873d18.png", import.meta.url).toString();

});

parcelRegister("cSf3N", function(module, exports) {
module.exports = new URL("angel-group-step-3-or.0da4c5d5.png", import.meta.url).toString();

});

parcelRegister("af8S3", function(module, exports) {
module.exports = new URL("angel-group-step-3-unsuccessful-expand.3d867d46.png", import.meta.url).toString();

});

parcelRegister("928kb", function(module, exports) {
module.exports = new URL("angel-group-step-3-unsuccessful.f4543462.png", import.meta.url).toString();

});

parcelRegister("cylnH", function(module, exports) {
module.exports = new URL("30-mint-time.a8a399a1.svg", import.meta.url).toString();

});

parcelRegister("1U6Hr", function(module, exports) {
module.exports = new URL("climb26-oneform-left-ai.3450a0c6.png", import.meta.url).toString();

});

parcelRegister("eaQ0b", function(module, exports) {
module.exports = new URL("ehe-oneform-left-ai.dd48c60f.png", import.meta.url).toString();

});

parcelRegister("dH1Di", function(module, exports) {
module.exports = new URL("kpmg-oneform-left-ai.a428c428.png", import.meta.url).toString();

});

parcelRegister("6Org2", function(module, exports) {
module.exports = new URL("investment-readiness-box.02bf1c56.png", import.meta.url).toString();

});

parcelRegister("4cpGT", function(module, exports) {
module.exports = new URL("seedlegals-investor-matches-box.bed3fc55.png", import.meta.url).toString();

});

parcelRegister("h7dyn", function(module, exports) {
module.exports = new URL("investor-matches-box.193f5da4.png", import.meta.url).toString();

});

parcelRegister("epuex", function(module, exports) {
module.exports = new URL("how-it-work-bg.06a9182d.png", import.meta.url).toString();

});

parcelRegister("3iSKt", function(module, exports) {
module.exports = new URL("climb26-how-it-work.403d4546.png", import.meta.url).toString();

});

parcelRegister("4UmTt", function(module, exports) {
module.exports = new URL("ehe-how-it-work.609a62c3.png", import.meta.url).toString();

});

parcelRegister("y9sDx", function(module, exports) {
module.exports = new URL("climb26-banner.1a71b5dc.png", import.meta.url).toString();

});

parcelRegister("aLtQ4", function(module, exports) {
module.exports = new URL("investment-readiness-report-box.62294cf0.png", import.meta.url).toString();

});

parcelRegister("erEj1", function(module, exports) {
module.exports = new URL("kpi-report-box.1cbebbc0.png", import.meta.url).toString();

});

parcelRegister("6qGM8", function(module, exports) {
module.exports = new URL("researchaid-report-box.5a1559c2.png", import.meta.url).toString();

});

parcelRegister("geNqC", function(module, exports) {
module.exports = new URL("investor-matches-kpmg-popup.7501ab1a.png", import.meta.url).toString();

});

parcelRegister("fltHn", function(module, exports) {
module.exports = new URL("test-page-bg.9fbe515e.png", import.meta.url).toString();

});

parcelRegister("gnZup", function(module, exports) {
module.exports = new URL("linkedIn-title-logo.74bd1a2e.png", import.meta.url).toString();

});

parcelRegister("2LVbM", function(module, exports) {
module.exports = new URL("test-page-ai.7e4a4846.png", import.meta.url).toString();

});

parcelRegister("6QpiR", function(module, exports) {
module.exports = new URL("two-minute-popup.b048a8cd.png", import.meta.url).toString();

});

parcelRegister("55qLI", function(module, exports) {
module.exports = new URL("bg.296849e1.png", import.meta.url).toString();

});

parcelRegister("ewrEr", function(module, exports) {
module.exports = new URL("growthRoad.c213376d.png", import.meta.url).toString();

});

parcelRegister("5fCxK", function(module, exports) {
module.exports = new URL("didYouKnow.1046d12e.png", import.meta.url).toString();

});

parcelRegister("glVqS", function(module, exports) {
module.exports = new URL("growthRoad.1e5c0285.png", import.meta.url).toString();

});

parcelRegister("gAPn9", function(module, exports) {
module.exports = new URL("helpCircle.db19a52f.svg", import.meta.url).toString();

});

parcelRegister("9Xx3j", function(module, exports) {
module.exports = new URL("infoIcon.501780d2.svg", import.meta.url).toString();

});

parcelRegister("cLEoh", function(module, exports) {
module.exports = new URL("dataroom.a4c8b3b7.svg", import.meta.url).toString();

});

parcelRegister("e3B3T", function(module, exports) {
module.exports = new URL("certificationPricing1.22cf75a4.svg", import.meta.url).toString();

});

parcelRegister("7ccEw", function(module, exports) {
module.exports = new URL("certificationPricing2.eac81392.svg", import.meta.url).toString();

});

parcelRegister("61dei", function(module, exports) {
module.exports = new URL("certificationPricing3.cf738ad7.svg", import.meta.url).toString();

});

parcelRegister("38fuN", function(module, exports) {
module.exports = new URL("proPlus.6890a089.png", import.meta.url).toString();

});

parcelRegister("9gced", function(module, exports) {
module.exports = new URL("check.dfe5d650.svg", import.meta.url).toString();

});

parcelRegister("kCxNU", function(module, exports) {
module.exports = new URL("tag.3f282a1b.png", import.meta.url).toString();

});

parcelRegister("1DYXg", function(module, exports) {
module.exports = new URL("discountVector.ad3358a5.png", import.meta.url).toString();

});

parcelRegister("2hF7P", function(module, exports) {
module.exports = new URL("hands.948d1291.png", import.meta.url).toString();

});

parcelRegister("6OV3P", function(module, exports) {
module.exports = new URL("portfolioPro.2bb1fa6e.png", import.meta.url).toString();

});

parcelRegister("jbHw4", function(module, exports) {
module.exports = new URL("join-community-icon.4cf77590.png", import.meta.url).toString();

});

parcelRegister("lnUEE", function(module, exports) {
module.exports = new URL("join-community.c3c386ec.png", import.meta.url).toString();

});

parcelRegister("bEnHb", function(module, exports) {
module.exports = new URL("community-bg-popup.dfdefb75.png", import.meta.url).toString();

});

parcelRegister("jUCG1", function(module, exports) {
module.exports = new URL("community-img.ae530aed.png", import.meta.url).toString();

});

parcelRegister("dacuF", function(module, exports) {
module.exports = new URL("mark-profile-circle.6e97ab3d.png", import.meta.url).toString();

});

var $dda70436ebfe2f2c$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"Y15zO\",\"index.7eefb795.js\",\"2vTFN\",\"emailHeadIcon.6baa8a7b.png\",\"3lvTa\",\"googleValidatior.ac3f23e4.svg\",\"dnL34\",\"sms_auth.735538eb.svg\",\"de7Ik\",\"send.a9fba190.svg\",\"8ujfz\",\"copy.844f5b64.svg\",\"ijPVL\",\"add-company-step1.3e05ab18.png\",\"3Gxex\",\"add-company-step1.a721c902.png\",\"7EPlg\",\"add-company-step2.2aa686fa.png\",\"k9KEi\",\"add-company-step3.2dc83c89.png\",\"93CPQ\",\"searchCompany.7d3c63d9.png\",\"ieBBi\",\"browserIcon.7f2124a5.svg\",\"3Uqrp\",\"keywordIcon.ff7a9afb.svg\",\"lWFcO\",\"target-icon.62584419.png\",\"23btD\",\"icon.77d75949.png\",\"l4N0v\",\"pc-to-data-repository.42468e74.gif\",\"5ZQlu\",\"clarence-to-data-repository.8bef377c.gif\",\"drUln\",\"pc-to-data-clarence.38f0238d.gif\",\"gax6L\",\"sorryMessage.ebaede17.png\",\"u8XZn\",\"fillingassistantGirl.6c5641f7.png\",\"ccZOI\",\"file_placement.21642384.svg\",\"eXXPm\",\"profile-photo.7be027fd.png\",\"dFbhw\",\"google_auth.22fdda51.svg\",\"jOSSX\",\"email_auth.d4f961c5.svg\",\"fVB3t\",\"pptxIcon.545dc962.png\",\"hAujc\",\"pdfIcon.672d8029.png\",\"fVD39\",\"xlsxIcon.6473fbd7.png\",\"97MRA\",\"intelligentiaIcon.ba7c1f0e.png\",\"13geI\",\"clarence-avatar.524d57df.png\",\"lbUUY\",\"Dg-logo.5cca91cf.png\",\"eqH3F\",\"autofill-icon.94d7f298.png\",\"jajXS\",\"magic-wand.14d028b2.png\",\"4eZCd\",\"steps-number.c5aadd7d.png\",\"dxGTS\",\"step-1.0d9219f7.png\",\"dvXkH\",\"step-2.2ecffc3d.png\",\"clWbs\",\"step-3.723d7786.png\",\"jFBG1\",\"step-4.7e8ae168.png\",\"8jJyi\",\"step-bottom.5e72b243.png\",\"8untl\",\"select-phase-img.3a26833d.png\",\"fZCXX\",\"file-upload-icon.9d2ea223.png\",\"g6zUa\",\"folder-upload-icon.3f16162d.png\",\"eej2K\",\"wizard.4ff3bea2.gif\",\"eqrSN\",\"claude-logo.ffb272b3.png\",\"2kVxi\",\"chatgpt-logo.144be6e9.png\",\"lApy2\",\"logo.5df7d4bf.svg\",\"haxxG\",\"add-applicant-ai.7d53157b.png\",\"ctMqb\",\"clicktohearme.8476e92d.webp\",\"lOtMu\",\"aiWatermark.12d7e38a.png\",\"59rrF\",\"favicon.fc7d35cf.png\",\"3DduR\",\"logodiligentsia.4ead61ee.svg\",\"hnSOa\",\"logo_white.2cd6dd36.png\",\"bP8Vv\",\"about-us-top-banner.df7a735b.png\",\"jPOu2\",\"mark-picture.07c91369.png\",\"h4Kud\",\"jonpicture.03863d06.png\",\"9pUum\",\"paul-morris.13e8955e.png\",\"aAvBp\",\"alex-faulconbridge.f7808902.jpg\",\"dRG5c\",\"jim-tunstall.180ada58.jpeg\",\"b2FZI\",\"book-call-mark .705d3a5b.png\",\"dYBMH\",\"diligentsia-icon.2d20d42a.png\",\"g3ekF\",\"morsebridge-logo.a2616dc1.png\",\"aCwge\",\"morsebridge-icon.ebe35931.png\",\"ldSw5\",\"morsebridge-hero.9f123c4a.png\",\"7BzET\",\"certifii.3c485a26.png\",\"8weWI\",\"where-to-start-1.349d250e.png\",\"8QGY4\",\"where-to-start-2.ea1103a2.png\",\"26VLL\",\"CTI-dashboard-1.349d250e.png\",\"datE4\",\"CTI-dashboard-2.ea1103a2.png\",\"jw9xW\",\"CTI-dashboard-3.e4a70932.png\",\"kIPbG\",\"diligentsia-logo.7f301676.png\",\"bW4b8\",\"vaultinum.00e7d68f.png\",\"5naes\",\"docker-no-code-access.911f8ee9.png\",\"2YUUD\",\"tech-dd-dashboard.26743be2.png\",\"dZBZt\",\"team-knowledge-distribution.2dbb281c.png\",\"4Cm2X\",\"logo.a781d4d3.png\",\"5VdOB\",\"hero-graphic.bfe69b21.png\",\"gkmCM\",\"foster-neil-bio.e334a4b1.png\",\"1Bd1i\",\"paul-morris.299a0bb9.jpg\",\"eENov\",\"ollie-austen.5f28745a.jpg\",\"1Biv4\",\"call-button-mark.88558b90.png\",\"ibLf2\",\"2-minute-test-icon.ef02246b.png\",\"5AkqW\",\"contact-us-support.33d06fb4.png\",\"7EkWK\",\"contact-us-sales.b8afb00f.png\",\"69A33\",\"contact-us-patner.abc64329.png\",\"2Ptnb\",\"contact-us-bugs.b6978f65.png\",\"dpNbg\",\"contact-us-support-img.480f477a.png\",\"9iCJI\",\"book-call.03f57154.png\",\"929pI\",\"contact-us-bug-img.5ffab1c4.png\",\"1EkbS\",\"contact-us-option-bg.96f084d8.png\",\"kkXCO\",\"customer-join.46b1189d.png\",\"9neYa\",\"co-branded.f026c50c.gif\",\"iYpAl\",\"partner-minu.56cd3eb0.png\",\"4ccqH\",\"partner-main-banner-bg1.5fb852fb.png\",\"gnaWS\",\"blur-bg.a1f7f13d.png\",\"6TViT\",\"genfinance.322f9ae9.png\",\"kKdtj\",\"abf.8453d460.png\",\"k2ia9\",\"jpj.c49cd7fe.png\",\"cIuwe\",\"brown_rudnik.e0ccbbdd.png\",\"h0zfq\",\"finhouse.b092f565.png\",\"5g3yb\",\"kiss_the_fish.3e8b85a4.jpg\",\"baTBX\",\"handshake.df63c029.png\",\"1OALx\",\"cfo.a205a7cf.png\",\"l86F9\",\"company.edfdd081.png\",\"cxjnO\",\"angel.23f3fd5b.png\",\"3RYwJ\",\"accountant.a1a43d88.png\",\"4xzez\",\"seedlegal.b4db2e74.png\",\"5BU8g\",\"you.8b2c3332.png\",\"gCBbR\",\"partner-2.43cba0c3.png\",\"5M5JH\",\"partner-3.d922ad67.png\",\"8MHBW\",\"partner-1.97d18bb8.png\",\"budUc\",\"abf.9160ca77.png\",\"gAzqr\",\"br.03aa7d18.png\",\"lMCn8\",\"cyberduedil.9d0e52c4.png\",\"g2kVn\",\"finhouse.7f1b0bdf.png\",\"2Ga29\",\"fractionality.9ff43057.png\",\"aUbmD\",\"freshbat.fa32a1fe.png\",\"buLqd\",\"gen.b5d9cbdd.png\",\"842RS\",\"green_ripple.773fa44a.png\",\"rb1lg\",\"intelect.f9e6d3fa.png\",\"dQc6M\",\"kiss_the_fish.0dcbd96f.png\",\"iu3rV\",\"nume.99409a63.png\",\"1tCAY\",\"su2su.eb4c5c02.png\",\"bMol5\",\"avatar-maham-zupash.9cb2240a.png\",\"69aJF\",\"ecosystem-people.e3e01058.webp\",\"hRVqZ\",\"avatar-mark-bernstein.9caa43c3.png\",\"bZmd6\",\"avatar-ollie-austen.e00fcd77.png\",\"6Pkbc\",\"avatar-chris-enoh.9ec03ee2.png\",\"kiZ2l\",\"su2su-card.f55676cb.webp\",\"NQS3T\",\"su2su-logo.332c7688.webp\",\"7rhHT\",\"events-header.306e0c5a.webp\",\"7bpHO\",\"terms-background.33d44658.png\",\"8HPhI\",\"investor_cog.028fc079.png\",\"9doUw\",\"company_cog.c3de83b4.png\",\"dPdUs\",\"diligentsia_cog.c617dbbc.png\",\"1Ax0w\",\"advisor_cog.973e85de.png\",\"cCY3e\",\"seedlegals_logo.470b4f2b.png\",\"iTWFD\",\"aI_forge_logo.2eb45a97.png\",\"7v3eh\",\"acentis_logo.5c5a1b36.png\",\"juMCJ\",\"dignus_muneris_logo.d2d8aa52.png\",\"h0ytz\",\"ehe_logo.f6969c94.png\",\"fX1ZL\",\"fractionality_logo.8c1d41c8.png\",\"5Y82o\",\"jpj_logo.95b5388e.png\",\"bT6a3\",\"su2su_logo.fd0616df.png\",\"bVh6H\",\"acf_investors_logo.7b1e2289.png\",\"2PUuZ\",\"angelgroups_logo.078dbb28.png\",\"dxIuj\",\"british_business_bank_logo.e326d38c.png\",\"6ot9G\",\"british_design_fund_logo.a5b70a15.png\",\"lN3Qh\",\"deepbridge_logo.189d1d69.png\",\"3vyzT\",\"foresight_logo.e457b85f.png\",\"erlis\",\"kero_logo.507dd59f.png\",\"1DKOl\",\"key_capital_logo.05649527.png\",\"abqnj\",\"key_fund_logo.000c7c9a.png\",\"93hhY\",\"lifted_logo.8cb12a04.png\",\"83qZE\",\"mercia_fund_logo.e38cf21d.png\",\"6b8do\",\"northern_gritstone_logo.15638a26.png\",\"erqpB\",\"northstar_ventures_logo.2a2cbe65.png\",\"hsDTu\",\"par_equity_logo.f2a8ede5.png\",\"5dd9y\",\"playfair_logo.b1e94a3a.png\",\"hZQBN\",\"river_capital_logo.e56e3d30.png\",\"bDtoR\",\"science_angel_logo.04eb97ea.png\",\"dlncK\",\"solidbond_logo.bee39481.png\",\"xeHbh\",\"yfm_equity_logo.ecfb3d75.png\",\"CiEzJ\",\"anthony.b26586ad.jpg\",\"rBCZT\",\"mojee_wilson.8db5b3bd.jpg\",\"4lBwh\",\"paul_morris.d45f7620.png\",\"2RUql\",\"foster_neil.15182d00.jpg\",\"8ZsK2\",\"kevin.c4a78c0a.jpg\",\"iM5qF\",\"mark-signature.19757332.png\",\"3nPJ1\",\"mark-photo.9abc6a44.png\",\"fyhNo\",\"katy-davidson.387479a8.png\",\"5wwR4\",\"louise-birritteri.33bb47e4.png\",\"fJnss\",\"rik-pancholi.e310d2ff.png\",\"iDehx\",\"richard-whitwell.96ab6aec.png\",\"4smQ3\",\"barry-williams.745fa2b8.png\",\"4bdin\",\"yourlogohere.4f4645dc.png\",\"3R4s6\",\"social1.43c3205c.png\",\"5vn3G\",\"social2.6c891abf.png\",\"cppKC\",\"social3.7301609e.png\",\"6QmwD\",\"certification1.9021fb43.png\",\"kMSNP\",\"certification2.1859405c.png\",\"70hkt\",\"certification3.a5e60efb.png\",\"9yGAy\",\"au-certification1.21a827fc.png\",\"9kqWE\",\"au-certification2.35b09322.png\",\"5lZRB\",\"au-certification3.4aa48965.png\",\"3LTO9\",\"pro-pricing-back.217b0289.png\",\"yZXM5\",\"checklist-logo.af9eac88.webp\",\"rtfSW\",\"close.455703a0.png\",\"7T9Ju\",\"LI-Logo.ed1b7235.png\",\"gEw9S\",\"profile-photo.4587511a.jpeg\",\"eXGFo\",\"upLoading.0f7b6c78.svg\",\"7FQg3\",\"green_tick.e074e19b.svg\",\"gC2cW\",\"payment-header.c9bbf3ab.png\",\"3mfZ5\",\"visa.f60ee3b8.png\",\"hCmG1\",\"approved-partner-header.00854dc3.png\",\"5PURt\",\"left-person.84498594.png\",\"3YMIY\",\"left-angle-arrow.13323063.png\",\"4DujQ\",\"speed-img.d16c8def.png\",\"g9WAN\",\"benifts-1.8971431d.png\",\"cePqR\",\"benifts-2.cb00222f.png\",\"bwAgr\",\"benifts-3.edaa2a00.png\",\"66oK6\",\"benifts-4.10a61233.png\",\"9oKzS\",\"benifts-5.38e60243.png\",\"61tMv\",\"benifts-6.2ad8dd63.png\",\"iLKcA\",\"modle-title.e7d66f2d.png\",\"lLYQx\",\"chatgpt-logo-low.7838e854.png\",\"5HVOQ\",\"gemini-logo-low.94ff33bd.png\",\"1xKC5\",\"logo-icon.f2975a85.svg\",\"kZFWD\",\"info-icon.c6f74d96.svg\",\"jBZJr\",\"delete.6c3ff100.svg\",\"6rRd7\",\"whiteCheck.c4950e50.png\",\"bgtll\",\"stopwatch.5ea0edf6.svg\",\"d0pfW\",\"bronze.5707b48c.png\",\"3oXnD\",\"silver.646a4936.png\",\"3gcml\",\"gold.176f2679.png\",\"lBPtv\",\"banner1.fb1e5c6e.png\",\"9xgAc\",\"no-companies-added.305fccc9.png\",\"1Id2M\",\"ai-no-company-add.321715b2.png\",\"hQIhY\",\"insufficient-label.93155434.png\",\"fnVN0\",\"silver-cup.4f87917e.png\",\"hDYmr\",\"gold-cup.ee6731c7.png\",\"b82oC\",\"bronze-cup.805916db.png\",\"gTSvp\",\"bonus.2bda0f76.svg\",\"5zbQZ\",\"purify.486014f5.js\",\"14NDh\",\"index.es.36abefba.js\",\"c0avj\",\"referIcon.4b24b1ad.svg\",\"gXmW3\",\"cfoCenterLogo.31b0621f.svg\",\"iNkTc\",\"telephone.1016c91c.svg\",\"2nqYB\",\"right-arrows.b15a1ce1.svg\",\"ctzgV\",\"refer.c5ed4ccd.png\",\"6IpKx\",\"fraction.07bdc9b0.png\",\"24rok\",\"refund.c71c8afc.png\",\"c4l10\",\"referOfferRightIcon.8ce3e003.png\",\"dzyRG\",\"companyReferOffer.a50c2617.png\",\"akK0g\",\"plus.788eeee6.png\",\"lLh2a\",\"DiligentsianCfologo.a7303353.png\",\"iuHdX\",\"linkedin-logo.a759e08e.svg\",\"1hEoR\",\"applicant-info-ai.1d5b60fe.png\",\"emdkP\",\"pink-question.3449b3b7.svg\",\"gXosj\",\"kpiSidebar.4433a447.png\",\"861d1\",\"partner-flow-ai-help.0b1a4041.png\",\"5CjGe\",\"sidebar-partner-checklist-ai.b6bac159.png\",\"a9I0s\",\"investor-lead-ai.c963f746.png\",\"bcfNI\",\"sidebar-check-icon.ac68d895.png\",\"8o2DM\",\"sidebar-cross-icon.9c17ceeb.png\",\"gNi5R\",\"sidebar-file-icon.ce60a3fc.png\",\"6fOow\",\"investment-readiness-ai.4b6aea13.png\",\"5a8OC\",\"report-sidebar-ai.1d2f66c9.png\",\"le5Bd\",\"2minutesTestSidebarDiligentsia.51ab926f.png\",\"8XuNR\",\"two-minute-test-ai.c23d32cf.png\",\"2UvXG\",\"complete-icon-popup.b9882241.png\",\"gTlhX\",\"complete-logo-popup.908d024a.png\",\"5mW1r\",\"step-1-popup.a0c1b909.png\",\"eH6ZE\",\"step-2-popup.43b8ccdb.png\",\"7YbDO\",\"step-3-popup.2143d8af.png\",\"hHoPI\",\"step-4-popup.64a54c4b.png\",\"lFmqr\",\"400-error.ffa12e3d.png\",\"7qcUR\",\"disclaimer.a8fd4f74.png\",\"7u4h7\",\"deduper.b311fb66.png\",\"bjcnt\",\"empty-inbox.791cfede.svg\",\"daY8G\",\"filing-assistant-hover.683b3845.png\",\"6UsGc\",\"filing-assistant-icon.6715e5d2.png\",\"03ovH\",\"file.34e8aa24.svg\",\"02ClE\",\"girlAI.8ccfbb45.png\",\"CNLzo\",\"Group.85afa264.svg\",\"dreGZ\",\"drive.de54fec0.svg\",\"4KuJh\",\"dropbox.314489a8.svg\",\"7edIe\",\"sharepoint.469ee1cc.svg\",\"5BTOp\",\"right-arrows1.0b75f82a.svg\",\"8nv9m\",\"check.f8bb411b.svg\",\"hSxqP\",\"unallocated-bin-step-1.b968d2f5.png\",\"6PhmQ\",\"unallocated-bin-step-2.ca90a343.png\",\"3xuni\",\"unallocated-bin-step-3.898fcd22.png\",\"5FxK9\",\"filing-assistant-step-1.85fec777.png\",\"7dX0b\",\"filing-assistant-step-2.e11ccbd3.png\",\"eFSJN\",\"filing-assistant-step-3.5d37969c.png\",\"gCQ73\",\"deduper-step-1.960a52d7.png\",\"aJU4U\",\"deduper-step-2.9986ffb3.png\",\"85use\",\"deduper-step-3.1cc3017f.png\",\"auFGQ\",\"deduper-reports-step-1.ef88805d.png\",\"4Cl11\",\"deduper-reports-step-2.c7dfdb82.png\",\"dZ9TS\",\"deduper-reports-step-3.08f11e92.png\",\"jlYFA\",\"three-steps.67750c04.png\",\"b4imv\",\"tip-icon.312e1873.svg\",\"b3Mfi\",\"tab-files-icon.14d3b008.png\",\"fyGUO\",\"tab-collaborate-icon.145a2913.png\",\"bFaD0\",\"tab-toolbox-icon.b6dbb384.png\",\"yAn3Y\",\"sync-data-room.fd07c429.png\",\"7bAjT\",\"double-star-icon.b0049897.png\",\"97ric\",\"left.85d14654.png\",\"4E4dT\",\"center.ebbda78c.png\",\"cUarH\",\"right.e16900c6.png\",\"bLu5g\",\"logo-advisor.d4014d1a.svg\",\"3hrC6\",\"banner13-opp.9479e4aa.png\",\"1Zix4\",\"step-modal-img.ec2dd3d8.png\",\"hCx3K\",\"portfolio-dashboard-1.fdcc08f9.png\",\"iPhZb\",\"portfolio-dashboard-2.653f6449.png\",\"aJkhq\",\"portfolio-dashboard-3.17d64cd6.png\",\"2sdkG\",\"cards.57e180e4.png\",\"asOJG\",\"banner25.d118c506.png\",\"35ZSD\",\"client-benchmarking-1.afbada97.png\",\"3d9ZS\",\"client-benchmarking-2.cc1dd16e.png\",\"cQCIH\",\"client-benchmarking-3.1bbda157.png\",\"3r3Cq\",\"banner12-opp.b1fedac5.png\",\"eNa1H\",\"diligentsia-pro-plus-1.005fcb64.png\",\"eKgJk\",\"diligentsia-pro-plus-2.0d46955c.png\",\"4PskZ\",\"diligentsia-pro-plus-3.40f0cb4b.png\",\"6qVBP\",\"group-certficate.62d9ac08.png\",\"5JMEQ\",\"banner14-opp.c5ebc64b.png\",\"cTYXd\",\"check-icon.8ce34113.png\",\"hRR9o\",\"cross-icon.869861b8.png\",\"fHY3Y\",\"revenue-generation-leads-1.689eb731.png\",\"9ZiWW\",\"revenue-generation-leads-2.ac16aa91.png\",\"bh7f6\",\"revenue-generation-leads-3.63d703a5.png\",\"ydfQ7\",\"banner15-opp.e780a42c.png\",\"3i3K0\",\"checklist-builder-1.d1149dce.png\",\"9j16C\",\"checklist-builder-2.8d9dfa34.png\",\"gmKyg\",\"checklist-builder-3.09fb0d4a.png\",\"cnQKc\",\"workflow-manager.229c449f.png\",\"b4ktx\",\"workflow-manager-step-1.bdd977a7.png\",\"lRI1w\",\"workflow-manager-step-2.8df081db.png\",\"amzob\",\"workflow-manager-step-3.23ea3a11.png\",\"hjEjt\",\"portfolio-benchmarking-1.5bd00945.png\",\"bNmcT\",\"portfolio-benchmarking-2.3d6eeb6e.png\",\"czJki\",\"portfolio-benchmarking-3.b880c20d.png\",\"kd5tP\",\"banner7-opp.0a385181.png\",\"cDRmR\",\"applicant-leads-1.c0aadbd9.png\",\"i6g63\",\"applicant-leads-2.7dc75e48.png\",\"6EN3B\",\"applicant-leads-3.a846351a.png\",\"kkonn\",\"banner-certification-4.1492d8a8.png\",\"dIOLz\",\"banner26.f0099834.png\",\"1oRMn\",\"qualification-widget-1.acee6bfa.png\",\"Ox4Oh\",\"qualification-widget-2.797520a6.png\",\"dRwPA\",\"qualification-widget-3.4db6db72.png\",\"2d76o\",\"client-dashboard-step-1.b40f00c2.png\",\"7V3n3\",\"client-dashboard-step-2.adeaf266.png\",\"4in1E\",\"client-dashboard-step-3.39ba7356.png\",\"lxQ2u\",\"cabinet-left.ec9c3b6f.gif\",\"eXdXX\",\"data-repo-step-1.407504ce.png\",\"gGism\",\"data-repo-step-2.3008562f.png\",\"gyDX0\",\"data-repo-step-3.085e4083.png\",\"ccwWw\",\"banner3.3ab6f9b4.png\",\"kzxDY\",\"business-step-1.b52cccc9.png\",\"dU1fI\",\"business-step-2.83219b57.png\",\"3ubQE\",\"business-step-3.0b592051.png\",\"iMpPJ\",\"diligentsia-certification.d97eab87.png\",\"dbFoh\",\"banner5.91b74b17.png\",\"kEF4F\",\"diligentsia-certification-step-1.761e005f.png\",\"LXD2P\",\"diligentsia-certification-step-2.5de85185.png\",\"cEz2F\",\"diligentsia-certification-step-3.6dbd3e9b.png\",\"aMBaS\",\"pack-bottom.e6ec7df9.png\",\"XGcR3\",\"banner10-opp.7df40c8d.png\",\"SYyKE\",\"warranty-step-1.b21ec2bc.png\",\"8iPNJ\",\"warranty-step-2.0fb3ef32.png\",\"cjZtu\",\"warranty-step-3.1a82af6c.png\",\"4AtI3\",\"banner11.3dcdf7c4.png\",\"chKd9\",\"directors-questionnaires-step-1.4b70c580.png\",\"gHkNd\",\"directors-questionnaires-step-2.b876e207.png\",\"lURNg\",\"directors-questionnaires-step-3.11c76d49.png\",\"4rFZZ\",\"banner19-opp.7ef89939.png\",\"25D9F\",\"diligenstia-pack-step-1.2511015b.png\",\"lKfG9\",\"diligenstia-pack-step-2.12637438.png\",\"5edIL\",\"diligenstia-pack-step-3.8ecc3f58.png\",\"7xpz1\",\"banner20-opp.6d2d614b.png\",\"88qb8\",\"investor-lead-step-1.9830fad3.png\",\"6jNqb\",\"investor-lead-step-2.54d76d2b.png\",\"6aPLr\",\"investor-lead-step-3.23b46b7c.png\",\"jJuCF\",\"cybersecurity.d403b161.png\",\"jGXP0\",\"cyber-security-icon.ed830154.png\",\"c2Ubs\",\"banner24-new.46ebffc0.png\",\"2uTgE\",\"cyberscurity-step-1.587f823a.png\",\"81vV8\",\"cyberscurity-step-2.a94c487b.png\",\"bYV2Q\",\"cyberscurity-step-3.662378a1.png\",\"1XdAv\",\"cyberscurity-step-4.90b88794.png\",\"PjgPY\",\"healthboost-heading.ac2a97b7.png\",\"6J3r3\",\"healthboost-1.377d2a7d.png\",\"6ApZ0\",\"healthboost-2.83e4bc59.png\",\"3iYBA\",\"healthboost-3.c81e6d5c.png\",\"lMzzb\",\"healthboost-4.5c0eaaa8.png\",\"14LQx\",\"no-img.bc8d2895.svg\",\"gDJTS\",\"hover-list-icon.6db5512e.png\",\"2bWOT\",\"gold-star-icon.ec900367.png\",\"1CpWr\",\"3d-credit-card1.71b24d0b.svg\",\"8oNrB\",\"partner-module.a16fdb54.png\",\"gTAkC\",\"health-boost-icon.8efc701a.png\",\"6L1Ph\",\"healthboost-logo.1ab4195b.png\",\"7UcS6\",\"gold-certification-dashboard.ab7e0590.png\",\"2iSFr\",\"videoButton.700d7e28.png\",\"fjOgN\",\"Cybersecurity_Mask.5ecd61f0.png\",\"2qAcm\",\"precentage-icon.c5adb999.png\",\"1GGiJ\",\"checklist-logo.4311360d.png\",\"4ZPOu\",\"manual-add-icon.8e0c73a7.svg\",\"aLn35\",\"investment-criteria-icon.712c99a2.svg\",\"dwARF\",\"report.60f58a9d.svg\",\"foolL\",\"banner-certification-3.45ef5903.png\",\"3mGeh\",\"banner-certification-2.5b7c9b6e.png\",\"35wEQ\",\"banner-certification-1.30a0abf5.png\",\"lTFgj\",\"delete.22dbd762.svg\",\"hBR6G\",\"add-client-1.8e9ed590.png\",\"iWxeZ\",\"add-client-2.9dece6df.png\",\"2NCO2\",\"add-client-3.c73d2923.png\",\"jpt1h\",\"chase1.5b329a39.png\",\"kKAVY\",\"add-client-step-1.7804002b.png\",\"bTOUB\",\"add-client-step-2.bb0fda78.png\",\"7gcfM\",\"add-client-step-3.51e0a8ca.png\",\"dsr0t\",\"qualified-leads-1.cd51ee06.png\",\"1GzD0\",\"qualified-leads-2.ff4abe3b.png\",\"ehsy2\",\"qualified-leads-3.6b04c284.png\",\"WJWN5\",\"website-widget-step-1.3a8f0ecf.png\",\"7GAnY\",\"website-widget-step-2.86cb49bb.png\",\"ct6a7\",\"website-widget-step-3.5166de39.png\",\"akqAx\",\"none.ea6b97f7.png\",\"b7F82\",\"bronzeLarge.a8dd2d83.png\",\"zR517\",\"silverLarge.7a0a4319.png\",\"4KmRC\",\"goldLarge.3a095b2c.png\",\"ejoPV\",\"high warning.e69ce902.svg\",\"3TA9d\",\"medium warning.f8ece25b.svg\",\"dvru6\",\"low warning.f661b5e7.svg\",\"3PGDH\",\"warning icon.139992d4.svg\",\"jsLgU\",\"info-icon-tab.a1e2fe5b.svg\",\"jP85s\",\"fillingmodal-lright-area.1c8e1349.png\",\"ge7CW\",\"bvca-logo.b3777fa0.png\",\"j8c6Y\",\"crunchbase-logo.9580242d.png\",\"eUgPx\",\"swwdleagals.5b6fac11.png\",\"gCMba\",\"banner-certificate-bottom.8b7afca9.png\",\"5zFRm\",\"list.49ff6088.png\",\"dPGYh\",\"arrow.98a64aa3.png\",\"5612U\",\"whatisit.87e17000.png\",\"je4Qs\",\"howitworks.e8cc39c0.png\",\"3mV3K\",\"help.76aa5a97.png\",\"lBbi1\",\"R.2652fe02.png\",\"ce4za\",\"WF.53f26421.png\",\"32sHW\",\"insufficient-score.febdd0a9.png\",\"a5PZN\",\"investorMatchDisclaimer.890042a7.png\",\"36qOV\",\"appStoreIcon.49186080.png\",\"5UYSm\",\"anyListBuilder.a081e0c6.png\",\"8yErB\",\"researchAid.7c0ec90b.png\",\"lzzsB\",\"investorMatchFree.72602a15.png\",\"4UfZC\",\"investorReadiness.09db956a.png\",\"gFeTI\",\"kpiReport.a03ffe28.png\",\"j8Yrq\",\"researchAidReport.3f574b7d.png\",\"e74z3\",\"growthReadiness.fb65dd38.png\",\"4KQCk\",\"loanReadiness.9fd2e032.png\",\"01Cvl\",\"exitReadiness.95c40a27.png\",\"73hMJ\",\"diligencePackFree.7d1e4b47.png\",\"dkGMf\",\"investorMatchPro.76c37ce4.png\",\"3qqY7\",\"diligencePackPro.876f6710.png\",\"cAcjt\",\"yourCertificateJourney.73b183fe.png\",\"lVJTj\",\"investorFitReportPro.7fca0c02.png\",\"kzcWb\",\"researchAid.9994e122.png\",\"2nADx\",\"anylistBulder.79172a21.png\",\"ddssZ\",\"partnerModule.0efa577d.png\",\"fgEVR\",\"goldenHandshake.55fce579.png\",\"bvh0D\",\"locationPin.c1e97f10.png\",\"6fpYn\",\"growth.e6b2c56d.png\",\"lT0dO\",\"exit.cd1a7de6.png\",\"ciHaf\",\"investment.340ae7db.png\",\"iWVnJ\",\"none.bd11115c.png\",\"f6ltr\",\"bronze.0517ab81.png\",\"99l0L\",\"silver.57662e4a.png\",\"gAuI1\",\"gold.62e69f5a.png\",\"jnbFX\",\"yellowDownArrow.6896f083.png\",\"7c96W\",\"advisorMatchIcon.cff34b8b.png\",\"7f58c\",\"03.562dab43.png\",\"hTQBb\",\"04.7e661983.png\",\"4YxUK\",\"05.9215b46b.png\",\"lUIoh\",\"06.7c2bf6fe.png\",\"kKBax\",\"register-ai-left-img.02662144.png\",\"keOqs\",\"completed2minutetest.44c15da7.png\",\"75g4o\",\"diligencePack.bdf36ff5.svg\",\"3HdLB\",\"researchAidReport.69c50593.svg\",\"cjBri\",\"getPitching.23c227d6.png\",\"hRRs1\",\"healthboost.4acbcd71.svg\",\"1Emf6\",\"advisorAssistant.1ba62e4e.svg\",\"c4VRd\",\"company-business-lite-1.e4a79cfb.png\",\"bUu2H\",\"company-business-lite-2.ba1790b8.png\",\"5Ekhg\",\"company-business-lite-3.8f647840.png\",\"8fKzS\",\"company-data-repo-step-1.5524c12f.png\",\"bnvCu\",\"company-data-repo-step-2.60f9d368.png\",\"2iT7b\",\"company-data-repo-step-3.6a5bd5c3.png\",\"8mVSR\",\"workflow.feeabd54.svg\",\"hYVTn\",\"anylistBuilder.8d13ee90.svg\",\"ayvbp\",\"company-anylist-portfoliopro-1.b21e0175.png\",\"jMyxz\",\"company-anylist-portfoliopro-2.1210696e.png\",\"l8OCy\",\"company-anylist-portfoliopro-3.a7ff48b6.png\",\"lLL8S\",\"2-minute-see.6a476637.png\",\"3By3a\",\"company-2-minute-1.acfb7fd5.png\",\"fCvgr\",\"company-2-minute-2.d5ff67ec.png\",\"apvPH\",\"company-2-minute-3.638c540f.png\",\"aUfvg\",\"banner9.247e2587.png\",\"aj2iv\",\"company-kpi-1.12939d27.png\",\"lD1u2\",\"company-kpi-2.adc2526b.png\",\"87Jso\",\"company-kpi-3.de62407e.png\",\"0CnUh\",\"company-warranty-1.ffe5e830.png\",\"5icz1\",\"company-warranty-2.2294df22.png\",\"eXFSs\",\"company-warranty-3.fc158c7c.png\",\"hoHPZ\",\"company-directors-1.c4338d74.png\",\"h4Mc8\",\"company-directors-2.e70c65b3.png\",\"aukfY\",\"company-directors-3.dee1732c.png\",\"jcBHk\",\"company-diligence-pack-1.d6eecc6b.png\",\"8YcGq\",\"company-diligence-pack-2.ef5b67b9.png\",\"hLXSc\",\"company-diligence-pack-3.d8ce69f6.png\",\"hipR6\",\"iconHealthboost.efa82016.svg\",\"3714M\",\"company-business-1.50298f03.png\",\"1lswj\",\"company-business-2.5930c771.png\",\"a2hl5\",\"company-business-3.96c0d145.png\",\"bF6zc\",\"company-investor-leads-1.cf92875c.png\",\"kuzXF\",\"company-investor-leads-2.1f66676c.png\",\"PSykt\",\"company-investor-leads-3.b42ad3e7.png\",\"c4c3B\",\"exp-pro-see.5ffda567.png\",\"jnLR6\",\"company-checklist-1.9fad90c0.png\",\"bwVsd\",\"company-checklist-2.4d0d293a.png\",\"BiJ3u\",\"company-checklist-3.9d635f40.png\",\"hZt0j\",\"abf-step-1.acaf4781.png\",\"kSuqz\",\"abf-step-2.7beb209a.png\",\"1aeKt\",\"abf-step-3.c1aec23d.png\",\"ltbPj\",\"bfs-intro.7ec404bf.png\",\"aFYjx\",\"step-5-modal-img.6b4263f9.png\",\"kim2x\",\"bfs-step-1.e75a01e4.png\",\"3VcR0\",\"bfs-step-2.25238720.png\",\"39ReF\",\"bfs-step-3.1631f85f.png\",\"6iZUq\",\"bfs-step-4.2acff82b.png\",\"7yCpn\",\"bfs-step-5.c8212e40.png\",\"EswKy\",\"audit-certfication.b479fc9d.png\",\"4Ncql\",\"company-pro-plus-1.70ad53ad.png\",\"9cWBz\",\"company-pro-plus-2.16cb93a0.png\",\"8pmie\",\"company-pro-plus-3.eb456d01.png\",\"lAJvq\",\"trophy-gold.68bd97c8.png\",\"44Vxq\",\"trophy-silver.1449f00b.png\",\"2GodK\",\"trophy-bronze.385d2ebf.png\",\"mmiw7\",\"trophyNone.d8055f50.png\",\"1BNPe\",\"anychecklist-icon.88ed668c.png\",\"gS9aM\",\"pro-plus-certificate.dc84f147.png\",\"fhvcg\",\"partner-tag.ca60df5a.png\",\"8QcCF\",\"seeCertificate.c213e00f.png\",\"hTAJV\",\"noneStar.78265052.png\",\"1W00P\",\"bronzeStar.40d05870.png\",\"58XNO\",\"silverStar.3d81c4a2.png\",\"kasJu\",\"goldStar.6be56d8d.png\",\"fVYlB\",\"check1.dec1c35c.svg\",\"56o3u\",\"check.f48b7733.svg\",\"4WiQK\",\"certificategirl.4768f788.png\",\"h5frT\",\"allStars.005714bb.png\",\"1JT0x\",\"consolidated-document.072520f6.png\",\"875ve\",\"reports-docs-logo.2b9957a8.png\",\"f4nPM\",\"disclaimer-diligence-pack.5c5d1356.png\",\"fdfwl\",\"value-diligence-logo.19e2cd37.png\",\"90s8j\",\"foundational-diligence-logo.a66598be.png\",\"6tLL6\",\"companies-core-house-white-logo.6a5f29e0.png\",\"lRCDd\",\"companies-house-text.b8f114bb.png\",\"jpuPm\",\"companies-core-house-logo.9eb87fa3.png\",\"gqZfc\",\"filinghistory.67b9ab78.png\",\"dlneb\",\"officersavatar.c0c2f526.png\",\"br3my\",\"three-dot-icon.cb7d2944.png\",\"87aE0\",\"research-aid-ai.df28eaa3.png\",\"j6Dzx\",\"research-aid-ai-pro.59b6468d.png\",\"d0fIr\",\"research-aid-ai-lite.32c1de61.png\",\"gNCr6\",\"2-minute-time.a57e1f73.png\",\"5di6F\",\"lock-100-euro.dae829ad.png\",\"idrJH\",\"5-minute-time.fb7b2797.png\",\"3LmfM\",\"7-minute-time.cea202ea.png\",\"koYDA\",\"save-checklist-left-ai.3b3ebc8f.png\",\"l2LEy\",\"save-checklist-left-ai.5f9b64aa.png\",\"fbpiM\",\"anylist-checklist-step-1.b3a0a640.png\",\"4qgNE\",\"anylist-checklist-step-2.e99b0ccc.png\",\"eqbYV\",\"anylist-checklist-step-3.f9ef234a.png\",\"5fkZd\",\"not-today-bg.113add19.png\",\"aAOR0\",\"arrow-back.986a1fdd.png\",\"jXrSR\",\"not-today-icon.ed776476.png\",\"6wrC6\",\"investor.0d56fe17.png\",\"9Sb6m\",\"website.edfd4619.png\",\"lg0N2\",\"promptResponse.76341dd4.png\",\"hmUF7\",\"report.6442c685.png\",\"7VvWd\",\"contactInvestor.bad2448f.png\",\"hWY7l\",\"dateContacted.b8ac0753.png\",\"ahRsy\",\"status.beee6726.png\",\"1QfBB\",\"archieve.f54ca4fe.png\",\"dKbKX\",\"info.3e76cf88.png\",\"3BXFg\",\"gold.3094ba07.png\",\"eiVNM\",\"proInfo.f27d8857.png\",\"cRGUo\",\"thecfocenter.79002a77.png\",\"1ZPzB\",\"cfo-center.5f399010.png\",\"6see8\",\"research-report-header-bg.c9a5834e.jpg\",\"gL3dd\",\"four-steps.0376d199.png\",\"dLJl5\",\"first-time-repository-1.d58c3861.png\",\"c4GPo\",\"first-time-repository-2.c1b07c16.png\",\"d7Abb\",\"first-time-repository-3.40bcf824.png\",\"dfEoQ\",\"first-time-repository-4.d446a272.png\",\"gGMLQ\",\"reportHDRBg.0cd0e4a6.png\",\"cEHqe\",\"telephone.facb5295.png\",\"jYMCA\",\"analyser.5d7563a7.png\",\"gPMxR\",\"standard_right_bg.def4a57d.png\",\"aASaw\",\"duedig_logo.2c0bb450.png\",\"c5Yww\",\"dueDig.63cd5fdd.png\",\"eH7bG\",\"knoli_logo.002f3f89.png\",\"2DZNe\",\"knolli.8de66cab.png\",\"7WhNj\",\"knoli_right_bg_one.9f623970.png\",\"8hbFZ\",\"knoli_right_bg_two.6a585c7a.png\",\"kCiz0\",\"genfinance.ai_logo.7cb6b44f.png\",\"1KEOo\",\"genfinance.ai.7fd2a734.png\",\"kVYg6\",\"yoono.ai_logo.3d9f9154.png\",\"2QtH3\",\"yoono.ai.67a52de9.png\",\"dtiG1\",\"kissthefish_logo.3a7bd3c9.png\",\"6yTSl\",\"kissthefish.9670f740.png\",\"cdEtE\",\"nume_logo.54b35ff8.png\",\"8pc1y\",\"nume.be4d6e5f.png\",\"jQ5IJ\",\"startup2standup_logo.c4e0cdcf.png\",\"chZZM\",\"startup2standup.eb167540.png\",\"aPWx9\",\"freshbat_logo.b79dbcba.png\",\"9yiLL\",\"freshbat.f2992858.png\",\"3zVvm\",\"goeo_logo.5a175611.png\",\"apKci\",\"goeo.f967a13b.png\",\"9ERVR\",\"intelectgroup_logo.084d92ae.png\",\"fb1ES\",\"intelectgroup.375137d3.png\",\"g2OL6\",\"greenripple_logo.57da29f2.png\",\"6BkVC\",\"greenripple.d47b4461.png\",\"aOVhN\",\"flocast_logo.a2e91a65.png\",\"7KDd2\",\"flocast.b5eb5407.png\",\"bTQR4\",\"appStore.5c5c4516.svg\",\"e6IdL\",\"partners-30-minutes.99f1aa08.png\",\"c7NLA\",\"knoli_bottom_img.1788a24e.png\",\"2Zo6l\",\"yoono.ai_right_img.8b804dbc.png\",\"jjIiv\",\"startup2standup_popup.43a13d23.png\",\"c0Wem\",\"certifii_right_img.a82e35aa.png\",\"74Ej9\",\"vaultinum_right_img.ae530aed.png\",\"i6O0o\",\"opus_right_img.ae530aed.png\",\"jBGMc\",\"undo.b4394e8f.svg\",\"9lMqU\",\"demo-checklist-sidebar-three.77f33efd.png\",\"iYYGz\",\"demo-checklist-sidebar-two.7924950d.png\",\"kiFFC\",\"demo-checklist-sidebar-one.7d6518de.png\",\"jUPdc\",\"demo-checklist-pre-populate.190f4230.png\",\"cz4Du\",\"firework.cea2e85e.gif\",\"eOO4E\",\"apply-climb26-popup.1ec323f2.png\",\"5gD6C\",\"apply-ehe-popup.688b4f13.png\",\"8xs0c\",\"apply-box-popup.7f71221c.png\",\"50gqI\",\"kpmg-popup-ai.f5a28785.png\",\"soYDh\",\"GDrive.92040dea.gif\",\"4l7vI\",\"dropbox.edaea965.gif\",\"hATAC\",\"sharepoint.a9a7e09d.gif\",\"5kDxq\",\"demo-checklist-popup-workflow.2cf1b77b.png\",\"ak6g3\",\"demo-checklist-popup-report.7c20dbc3.png\",\"6TgtY\",\"wispr-logo.6c8acd69.png\",\"7kIe7\",\"fillingassistanticons.9da332b7.png\",\"dirzc\",\"google-drive-icon.e9238fa7.png\",\"j6nGT\",\"drop-box-icon.355d7481.png\",\"alMVM\",\"share-point-icon.264cfecd.png\",\"9m5O6\",\"folder-replication.c900d31b.png\",\"801YK\",\"two-way-sync.16bc3de5.png\",\"82Jbl\",\"import-existing-files.6d94f366.png\",\"6St8S\",\"source-colour-coding.5d472715.png\",\"kvssd\",\"shield-check-mark.be1ab926.png\",\"3uUpi\",\"about-img.46723a04.png\",\"f8LjQ\",\"not-yet-certification.712f0ae3.png\",\"eh8KT\",\"bronze-certification.656b9043.png\",\"6TNDA\",\"silver-certification.89ba43af.png\",\"6o6DM\",\"gold-certification.a8005c64.png\",\"8DdrI\",\"cName.627bc6d8.png\",\"2eRSx\",\"cReg.b46fafcf.png\",\"aRvEi\",\"cWebsite.9e31d4b7.png\",\"eYBsX\",\"cPhone.b8e62d93.png\",\"4cqsF\",\"cAddress.1f643ed5.png\",\"h93tP\",\"cEmail.62b07199.png\",\"cdgOD\",\"applicant-preparedness-one.02a7737c.png\",\"bS483\",\"applicant-preparedness-two.d5c5c3ce.png\",\"gEFeM\",\"applicant-preparedness-three.107ce497.png\",\"5rArH\",\"cLock.720fb427.png\",\"cRoBW\",\"quick-response-ai.d3de71ff.png\",\"4e3AO\",\"sidebar-details-ai.97ba4423.png\",\"cyLFK\",\"sidebar-skills-experience.7f352c5b.png\",\"drpmu\",\"crown-circle.3e6fb245.png\",\"dOthq\",\"companies-investment.36495881.svg\",\"lvl6Z\",\"companies-growth.c55a4ab0.svg\",\"7Jtmx\",\"companies-exit.867ae33a.svg\",\"cHRmR\",\"investment-growth-exit.ec47c0f7.png\",\"9S35w\",\"morsebridge-icon.d1d9685c.png\",\"3Bl50\",\"morsebridge-icon-white.092f84a6.png\",\"1Eq6d\",\"diligentsia-icon.4538bd00.png\",\"iHJ8q\",\"vc-top-banner.586a1f13.png\",\"99lgy\",\"book-a-call-mark.705d3a5b.png\",\"cWpt6\",\"what-vcs-look-for-series-a.91a93503.jpg\",\"8MLQC\",\"how-ai-is-changing-due-diligence-growth-stage.d84f82c3.jpg\",\"bQslU\",\"how-vcs-evaluate-early-stage-companies.f1fd0f20.jpg\",\"cRvnC\",\"how-to-prepare-for-vc-due-diligence.c5af0399.jpg\",\"aEf6W\",\"what-do-investors-check-in-due-diligence.084ae932.jpg\",\"6HIpy\",\"how-to-prepare-for-exit-due-diligence.3ffa7886.jpg\",\"cYLfJ\",\"how-fractional-cfos-use-diligentsia.41d5c438.jpg\",\"6ILDc\",\"what-angel-investors-look-for.96eef5e4.jpg\",\"bcjdv\",\"how-to-prepare-due-diligence-pack-seed-investment.116c3fb2.jpg\",\"dUiA5\",\"how-long-does-startup-due-diligence-take.4b5189f1.jpg\",\"38kdn\",\"what-is-pisces-core-disclosures.f8546c2f.jpg\",\"1Le5r\",\"how-to-complete-pisces-core-disclosures.0dd2d5c1.jpg\",\"9OGk4\",\"how-ai-is-changing-pisces-disclosure-preparation.5009700c.jpg\",\"bImCe\",\"sme-due-diligence-cost-statistics.b781283a.jpg\",\"fEKb1\",\"how-ai-is-changing-fractional-cfo-role.da21d219.jpg\",\"hEwM8\",\"what-happens-when-grant-funding-ends.854bc64c.jpg\",\"3WzDy\",\"how-angel-networks-improve-startup-funding-rates.de4e6fe1.jpg\",\"cuIE8\",\"how-to-prepare-for-angel-due-diligence.843e6acc.jpg\",\"cohEq\",\"how-accelerators-improve-startup-funding-rates.0b1ff614.jpg\",\"9Ft1x\",\"how-long-to-get-investment-ready.3ed00ba9.jpg\",\"9GPqi\",\"get-more-value-from-business-support-adviser.ab881dce.jpg\",\"lOjT6\",\"companies-top-banner.c33b1bd3.png\",\"kOp1K\",\"diligentsia.ff820755.png\",\"hn7vs\",\"clarence-transparent.88cf0204.png\",\"2Hjsf\",\"diligence-pack.eba81803.png\",\"vI9UX\",\"growth-ready-icon.f3c8d4fd.png\",\"3hQ90\",\"exit-ready-icon.9f4ef05f.png\",\"f4vqs\",\"sync-datarooms.fec98395.png\",\"5t2Hj\",\"ai-autofill.008f847c.png\",\"bGMJd\",\"certificates.d7602528.png\",\"8GVHB\",\"form-background-3.1cc5cd46.png\",\"jREMP\",\"ceo-background-image.9a53c190.png\",\"4CT0o\",\"light-cololr-circle.fce8c8fd.png\",\"4zNLn\",\"spirel.65ba8386.png\",\"kex1E\",\"blue-circle.3e66fc4e.png\",\"fy6rW\",\"half-curve.1641c46a.png\",\"kN3QB\",\"reactangle-image.1b9f314f.png\",\"h1rhY\",\"ball-certficate.870f03b7.png\",\"zUVKp\",\"diligentsia-certification.4e639088.png\",\"3f78g\",\"form-blur.3293b973.png\",\"1E1Ad\",\"fit-report-blur.c5d698e2.png\",\"eBFJS\",\"investor-form.3293b973.png\",\"k1eRE\",\"application-moda-img.da5866eb.png\",\"9IVox\",\"how-modal.2037d7ab.png\",\"7spiI\",\"form-background.5b538b4e.png\",\"h5kBb\",\"key-feature-certificates.f69a5db5.png\",\"3VQA1\",\"key-feature-gold-certificate.46833048.png\",\"cvvla\",\"accounts-lawrs-bloon-2.82cf0160.png\",\"cEHnC\",\"accounts-lawrs-bloon-1.ac6e76b8.png\",\"jAyTt\",\"binocular-eyes.f4ff336d.png\",\"1Ykhy\",\"angle-main-banner.98528ad4.png\",\"5PvND\",\"conv-ceo.7e5f274b.png\",\"2R5Ud\",\"banner free.56259675.png\",\"kTXeT\",\"banner23-opp.c31801ba.png\",\"7FLYI\",\"banner22.1bd95e92.png\",\"6LR7P\",\"banner24.5da9c1dd.png\",\"lKC9j\",\"daimond.92f0180e.png\",\"gYL7f\",\"banner1-left.39d5536a.png\",\"kFdNM\",\"right-side-zak.7a0b547c.png\",\"6KdiD\",\"blue-animation-half-circle.c6df3bba.png\",\"iB5Np\",\"cabinet-right.0e484fd6.gif\",\"7LHWu\",\"angels-bloon-1.c6182954.png\",\"1qc8L\",\"banner18-opp.934c9bcd.png\",\"hJ6UH\",\"banner18.8f05013a.png\",\"19zy5\",\"banner11-opp.dfacc149.png\",\"eUS8w\",\"banner15.99e79a11.png\",\"eMBAG\",\"rect-animation.611ebf87.png\",\"ksS6i\",\"angels-bloon-2.b796d751.png\",\"2ofmB\",\"banner7.e6e99aca.png\",\"hpkI9\",\"thumbnail6.6bcf4614.png\",\"1dfYn\",\"calculation10-1.86410830.gif\",\"cabbw\",\"vestd_logo.7669c2f8.png\",\"kQRsT\",\"jp_jenkins_logo.a3052cbf.jpg\",\"8s6uK\",\"pisces-top-banner.7aa2a2ea.png\",\"5JCMt\",\"climb26-play.30c17a08.png\",\"4edrM\",\"video-play.9b028fb9.png\",\"a4C1o\",\"climb26-logo.bbd5953b.png\",\"d6V2p\",\"climb26-company-banner.4c8f7aa7.png\",\"3v4A9\",\"climb26-company-slide1.39f33a05.jpg\",\"lSsbA\",\"climb26-company-slide2.822f6771.jpg\",\"5yfvQ\",\"climb26-company-slide3.88f275cd.jpg\",\"3wcI6\",\"climb26-company-slide4.ab9db586.jpg\",\"2wVk6\",\"climb26-company-slide5.cef8f91c.jpg\",\"929uz\",\"climb26-company-slide6.6bf5adec.jpg\",\"buM6v\",\"climb26-company-slide7.9c26a788.jpg\",\"lqecr\",\"climb26-company-slide8.f236d0c8.jpg\",\"7jqGb\",\"climb26-company-slide9.87520dfa.webp\",\"2ZPFC\",\"pes-main-banner.5ef5aa33.png\",\"6EZIV\",\"climb26-investor-slide1.58438f1e.jpg\",\"byvQG\",\"climb26-investor-slide2.a210fd8c.jpg\",\"9InJK\",\"climb26-investor-slide3.f71760b6.jpg\",\"ilI9T\",\"climb26-investor-slide4.c11a453c.jpg\",\"7ZBIu\",\"climb26-investor-slide5.4c8266c8.jpg\",\"kYgBL\",\"climb26-investor-slide6.969943f1.jpg\",\"jT15m\",\"climb26-investor-slide7.62f81018.jpg\",\"cMf3n\",\"accountant-top-banner.d36fc951.png\",\"aa0eN\",\"angel-networks-top-banner.97e78643.png\",\"8swZe\",\"about-cycle.a5c99cb7.png\",\"kOysH\",\"certificates.d7602528.png\",\"fNDxM\",\"better-signal-icon.591bc429.png\",\"lWdb2\",\"faster-closes-icon.8cf56537.png\",\"74Eek\",\"first-mover-advantage-icon.5818b988.png\",\"6OQQu\",\"fractionality.b3d68081.png\",\"30bZf\",\"ascentis.3ea8a52e.png\",\"96PPB\",\"cfo-centre.32e4ab30.jpg\",\"8UmMB\",\"fd-consultant.a723c56e.png\",\"3XvFn\",\"leftTestimonial.7ad6c73d.svg\",\"1JtBy\",\"centerTestimonial.a1ae9254.svg\",\"af6YH\",\"rightTestimonial.6265ab7c.svg\",\"9Thw3\",\"fractional-top-banner.b152c0d7.png\",\"fSQVc\",\"fractional-carosuel.eff7e69c.png\",\"jud3p\",\"checklist-step-ai.1b35f7f6.png\",\"5vgZx\",\"example-1.07d05c40.png\",\"4gzBr\",\"example-img.293891e5.png\",\"3J3fM\",\"module-risk.7e6a82bb.png\",\"8j9Td\",\"checklist-active.b26318f0.png\",\"2AuvG\",\"award1.7e66bfad.svg\",\"4i68o\",\"dog-paws.1a59c177.gif\",\"dhmqJ\",\"aisidebar-1.f07e8fdb.png\",\"dhacG\",\"aisidebar-3.8666d15e.png\",\"3jaAd\",\"aisidebar-4.76f33930.png\",\"89riX\",\"aisidebar-6.e464aef2.png\",\"76knq\",\"aisidebar-8.aa85494e.png\",\"5G1u4\",\"confetti.000ff962.png\",\"cHPCW\",\"step-completed-icon.a4c01916.png\",\"5Z57u\",\"checklist-popup-step3.04341895.png\",\"ir6Yy\",\"intro-ai.6d83b7d2.png\",\"bF79I\",\"intro-how-it-works.2e3cc5a0.png\",\"7c8Zc\",\"5-minute.aa6bfb94.png\",\"dUAdB\",\"create-demo-checklist.1023c792.png\",\"19Zo9\",\"kpi-demo-checklist.f0f0f140.png\",\"dsAsY\",\"create-demo-checklist-popup.d25ea774.png\",\"kvPj6\",\"cdd-intro.07e03369.png\",\"hTvnL\",\"ehe-intro.d0dee576.png\",\"2DKTf\",\"abf-intro.b262bd5f.png\",\"cvcQH\",\"bfs-checklist-free.ac612ad4.png\",\"7a1Bf\",\"bfs-how-we-work.c0eed883.png\",\"3o2zl\",\"cdd-how-we-work.1786a65a.png\",\"b2BiB\",\"ehe-how-we-work.11136161.png\",\"knq1f\",\"abf-how-we-work.d16bb2b7.png\",\"fGmgN\",\"prequel-sidebar-ai.e33faed7.png\",\"9VrNC\",\"kpi-partner-checklist.f0f0f140.png\",\"4i1mR\",\"create-partner-checklist-popup.c5da0803.png\",\"j35uP\",\"generate-research-aid-ai.24140e0f.png\",\"1TMMC\",\"generate-research-aid-popup.dd0d2a6b.png\",\"ccKdq\",\"manual-intro-ai.c53bc7c1.png\",\"8GhV5\",\"manual-add-page.48621052.png\",\"hn62q\",\"seedlegals-icon.849a96f2.png\",\"lKoEX\",\"climb26-new-banner.4b1da093.png\",\"l2vTJ\",\"ehe-banner.e08b1c10.png\",\"aLxBx\",\"seedlegals-banner.b28394ad.png\",\"dPdku\",\"startup2standup.5fcfac5f.png\",\"99ccz\",\"angelgroups-banner.8fc492d9.png\",\"8Rpm2\",\"britishdesignfund-banner.c026468a.png\",\"lvtgb\",\"banner.d9063d08.png\",\"1WQTk\",\"three-steps.b4f4f11c.png\",\"3En6r\",\"angel-group-step-1.e763b8ed.png\",\"83aeu\",\"angel-group-step-2.bfbef988.png\",\"eNSXc\",\"british-design-fund-step-2.8af9f6bd.png\",\"j609f\",\"angel-group-step-3-accepted-expand.690cc002.png\",\"cGF9E\",\"angel-group-step-3-accepted.43873d18.png\",\"1Jnit\",\"angel-group-step-3-or.0da4c5d5.png\",\"bfiRe\",\"angel-group-step-3-unsuccessful-expand.3d867d46.png\",\"jrtSs\",\"angel-group-step-3-unsuccessful.f4543462.png\",\"5UAaV\",\"30-mint-time.a8a399a1.svg\",\"e2fqu\",\"climb26-oneform-left-ai.3450a0c6.png\",\"iqAFQ\",\"ehe-oneform-left-ai.dd48c60f.png\",\"crkFO\",\"kpmg-oneform-left-ai.a428c428.png\",\"6L9Xg\",\"investment-readiness-box.02bf1c56.png\",\"ciN6T\",\"seedlegals-investor-matches-box.bed3fc55.png\",\"glBWw\",\"investor-matches-box.193f5da4.png\",\"3pLEw\",\"how-it-work-bg.06a9182d.png\",\"dgIp6\",\"climb26-how-it-work.403d4546.png\",\"bCuEI\",\"ehe-how-it-work.609a62c3.png\",\"1bjrj\",\"climb26-banner.1a71b5dc.png\",\"knIgR\",\"investment-readiness-report-box.62294cf0.png\",\"fs6rK\",\"kpi-report-box.1cbebbc0.png\",\"5F79J\",\"researchaid-report-box.5a1559c2.png\",\"dMKuz\",\"investor-matches-kpmg-popup.7501ab1a.png\",\"9SWSx\",\"test-page-bg.9fbe515e.png\",\"kprR0\",\"linkedIn-title-logo.74bd1a2e.png\",\"krRFO\",\"test-page-ai.7e4a4846.png\",\"d5nIG\",\"two-minute-popup.b048a8cd.png\",\"druHJ\",\"1.8d2ccbcd.png\",\"cimzO\",\"1.1.bf7cc66c.png\",\"1lDt5\",\"2.8956b714.png\",\"7H9TA\",\"2.1.a56b091a.png\",\"cgboq\",\"3.e1e1a162.png\",\"fSClA\",\"3.1.bdd81098.png\",\"5PQ3B\",\"4.b0eefce6.png\",\"lobN0\",\"4.1.77bc405f.png\",\"awbYX\",\"5.0eae77b5.png\",\"emJ7Q\",\"6.ff03b220.png\",\"3OnoW\",\"6.1.b8ec2aff.png\",\"jQBTT\",\"7.3f97efe8.png\",\"eePln\",\"bg.296849e1.png\",\"2LStU\",\"growthRoad.c213376d.png\",\"hWuhR\",\"didYouKnow.1046d12e.png\",\"3iuSz\",\"1.c711818e.png\",\"eBO9c\",\"1.1.9a25f7b7.png\",\"c4uIp\",\"2.a5ad09de.png\",\"4Mn2A\",\"2.1.875c640c.png\",\"jYbMs\",\"3.6a9d29df.png\",\"ej321\",\"3.1.5887c6ab.png\",\"80PXx\",\"4.0738b820.png\",\"kK0jm\",\"4.1.d41ac0cf.png\",\"bXSpg\",\"5.ae51b701.png\",\"gk0ic\",\"growthRoad.1e5c0285.png\",\"8gBty\",\"1.b84ec870.png\",\"ft8jl\",\"1.1.3ae4053b.png\",\"96rgD\",\"2.01a34422.png\",\"38ZiR\",\"2.1.a022e55b.png\",\"5dUvp\",\"3.1bcd3f7a.png\",\"kO62P\",\"3.1.77bc405f.png\",\"8GUMz\",\"4.70884f9b.png\",\"kGgT2\",\"4.1.460d1838.png\",\"5aZPP\",\"5.5e549a98.png\",\"i9DpW\",\"5.1.6e234f77.png\",\"covB9\",\"6.59f0a7f5.png\",\"5Ypk2\",\"investment.48af5bb2.png\",\"fUibm\",\"exit.774e25f3.png\",\"dIRoT\",\"growth.39f1e255.png\",\"jrFFQ\",\"advisorInvestment.566c7a3f.png\",\"gMmxK\",\"advisorExit.387bee2f.png\",\"8gWUS\",\"advisorGrowth.6b1d0fdc.png\",\"4zWdU\",\"investorInvestment.5cfdf7a2.png\",\"7rCU1\",\"investorExit.722d5f06.png\",\"hHcL7\",\"investorGrowth.0d8693a1.png\",\"djSut\",\"helpCircle.db19a52f.svg\",\"dMkkD\",\"infoIcon.501780d2.svg\",\"iakgl\",\"dataroom.a4c8b3b7.svg\",\"2xlUq\",\"certificationPricing1.22cf75a4.svg\",\"cruF9\",\"certificationPricing2.eac81392.svg\",\"epiK6\",\"certificationPricing3.cf738ad7.svg\",\"hGCuP\",\"proPlus.6890a089.png\",\"g5mfZ\",\"check.dfe5d650.svg\",\"g7V8X\",\"innerPricingPlan.e3352f07.png\",\"cKT0R\",\"activeLite.e67a85a4.png\",\"aFwNa\",\"proCard.387eb881.png\",\"ejXOl\",\"proTip.c1c3fc34.png\",\"bCxgX\",\"tag.3f282a1b.png\",\"lGJzF\",\"discountVector.ad3358a5.png\",\"6hpzm\",\"hands.948d1291.png\",\"5mOLU\",\"portfolioPro.2bb1fa6e.png\",\"kyOrm\",\"join-community-icon.4cf77590.png\",\"6CbEb\",\"join-community.c3c386ec.png\",\"hIzbO\",\"community-bg-popup.dfdefb75.png\",\"ek988\",\"community-img.ae530aed.png\",\"2qfRa\",\"mark-profile-circle.6e97ab3d.png\",\"8koGT\",\"index.bc5acd79.css\"]"));


var $ayMG0 = parcelRequire("ayMG0");

var $1u0KT = parcelRequire("1u0KT");
var $abf5cf1e2baa21a7$exports = {};
'use strict';
var $ef6fc817f3a93d11$exports = {};
var $5e2b04a3f6d2e99d$exports = {};
/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */ var $5e2b04a3f6d2e99d$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
function $5e2b04a3f6d2e99d$var$InvalidCharacterError(message) {
    this.message = message;
}
$5e2b04a3f6d2e99d$var$InvalidCharacterError.prototype = new Error();
$5e2b04a3f6d2e99d$var$InvalidCharacterError.prototype.name = 'InvalidCharacterError';
function $5e2b04a3f6d2e99d$var$polyfill(input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) throw new $5e2b04a3f6d2e99d$var$InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    for(// initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = ''; // get next character
    buffer = str.charAt(idx++); // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) && (output += String.fromCharCode(255 & bs >> (-2 * bc & 6))))// try to find character in table (0-63, not found => -1)
    buffer = $5e2b04a3f6d2e99d$var$chars.indexOf(buffer);
    return output;
}
$5e2b04a3f6d2e99d$exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || $5e2b04a3f6d2e99d$var$polyfill;


function $ef6fc817f3a93d11$var$b64DecodeUnicode(str) {
    return decodeURIComponent($5e2b04a3f6d2e99d$exports(str).replace(/(.)/g, function(m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = '0' + code;
        return '%' + code;
    }));
}
$ef6fc817f3a93d11$exports = function(str) {
    var output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return $ef6fc817f3a93d11$var$b64DecodeUnicode(output);
    } catch (err) {
        return $5e2b04a3f6d2e99d$exports(output);
    }
};


function $abf5cf1e2baa21a7$var$InvalidTokenError(message) {
    this.message = message;
}
$abf5cf1e2baa21a7$var$InvalidTokenError.prototype = new Error();
$abf5cf1e2baa21a7$var$InvalidTokenError.prototype.name = 'InvalidTokenError';
$abf5cf1e2baa21a7$exports = function(token, options) {
    if (typeof token !== 'string') throw new $abf5cf1e2baa21a7$var$InvalidTokenError('Invalid token specified');
    options = options || {};
    var pos = options.header === true ? 0 : 1;
    try {
        return JSON.parse($ef6fc817f3a93d11$exports(token.split('.')[pos]));
    } catch (e) {
        throw new $abf5cf1e2baa21a7$var$InvalidTokenError('Invalid token specified: ' + e.message);
    }
};
$abf5cf1e2baa21a7$exports.InvalidTokenError = $abf5cf1e2baa21a7$var$InvalidTokenError;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hfliI = parcelRequire("hfliI");
var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("i5mAx"));



var $1u0KT = parcelRequire("1u0KT");


var $1u0KT = parcelRequire("1u0KT");
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
let $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
const $f9089991fdc24c9c$export$4b9874722d0da7bc = (newBatch)=>$f9089991fdc24c9c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = ()=>$f9089991fdc24c9c$var$batch;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $55099852ccad0564$var$ContextKey = Symbol.for(`react-redux-context`);
const $55099852ccad0564$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55099852ccad0564$var$getContext() {
    var _gT$ContextKey;
    if (!$acw62.createContext) return {};
    const contextMap = (_gT$ContextKey = $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey]) != null ? _gT$ContextKey : $55099852ccad0564$var$gT[$55099852ccad0564$var$ContextKey] = new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
const $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ $55099852ccad0564$var$getContext();
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;


function $11518dc3bb05d381$export$d4d6226d5fc61558(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $acw62.useContext)(context);
        return contextValue;
    };
}
const $11518dc3bb05d381$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $11518dc3bb05d381$export$d4d6226d5fc61558();



const $d2699e687deeb28e$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};


let $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = (0, $d2699e687deeb28e$export$20656a4825650bd0);
const $d8fc8d639f906efc$export$e2e6e3f3f3b782e3 = (fn)=>{
    $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = fn;
};
const $d8fc8d639f906efc$var$refEquality = (a, b)=>a === b;
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : (0, $11518dc3bb05d381$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $d8fc8d639f906efc$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $acw62.useRef)(true);
        const wrappedSelector = (0, $acw62.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
var $8eaf5463f712f9ea$exports = {};
'use strict';

$8eaf5463f712f9ea$exports = (parcelRequire("cgj07"));



var $1En50 = parcelRequire("1En50");
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $98b92028b84cbd13$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98b92028b84cbd13$var$verify(mapStateToProps, 'mapStateToProps');
    $98b92028b84cbd13$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $98b92028b84cbd13$var$verify(mergeProps, 'mergeProps');
}


const $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $1En50.default)(_ref, $2eb761e6a8ffbe36$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $859ec94da7aa38c4$export$2e2bcd8739ae039)(value)) (0, $58c9380df5fc9ad2$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $2d566511964cb2c4$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $f019d9508e58fcb7$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $d4dd493c66c4df43$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)((dispatch)=>(0, $6a22b9cec285f673$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mapDispatchToProps, 'mapDispatchToProps');
}




function $f337fd5395077a96$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $2d566511964cb2c4$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $2d566511964cb2c4$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mapStateToProps, 'mapStateToProps');
}



var $8nd05 = parcelRequire("8nd05");


function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$59349e43bbd01749$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : (0, $f019d9508e58fcb7$export$19ef7b929f7e2559)(mergeProps, 'mergeProps');
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    const batch = (0, $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $de1db2bafb2c3b5a$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $de1db2bafb2c3b5a$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $acw62 = parcelRequire("acw62");
const $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 ? $acw62.useLayoutEffect : $acw62.useEffect;


function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $dbe46e5c642d971b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $dbe46e5c642d971b$var$useSyncExternalStore = (0, $d2699e687deeb28e$export$20656a4825650bd0);
const $dbe46e5c642d971b$export$36d45daa6a4925b8 = (fn)=>{
    $dbe46e5c642d971b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $dbe46e5c642d971b$var$EMPTY_ARRAY = [
    null,
    0
];
const $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $dbe46e5c642d971b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $dbe46e5c642d971b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $dbe46e5c642d971b$var$initStateUpdates = ()=>$dbe46e5c642d971b$var$EMPTY_ARRAY;
function $dbe46e5c642d971b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $dbe46e5c642d971b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $dbe46e5c642d971b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $dbe46e5c642d971b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $66f27f2048ec2805$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $55099852ccad0564$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $f337fd5395077a96$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $d4dd493c66c4df43$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $59349e43bbd01749$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $1En50.default)(props, $dbe46e5c642d971b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $8eaf5463f712f9ea$exports.isContextConsumer)(/*#__PURE__*/ $acw62.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $acw62.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $2eb761e6a8ffbe36$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $acw62.useRef();
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef();
            const renderIsScheduled = $acw62.useRef(false);
            const isProcessingDispatch = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef();
            (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs($dbe46e5c642d971b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $dbe46e5c642d971b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $acw62.createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $acw62.createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $dbe46e5c642d971b$export$2e2bcd8739ae039 = $dbe46e5c642d971b$var$connect;



var $acw62 = parcelRequire("acw62");



function $31f4d8f6ffbbb628$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $acw62.useMemo(()=>{
        const subscription = (0, $de1db2bafb2c3b5a$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $7a11fbbe9e9ac5f8$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $55099852ccad0564$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;







function $391671225302c365$export$671dba69185d0304(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $11518dc3bb05d381$export$c1275ca9a6fd3ec5) : (0, $11518dc3bb05d381$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();


function $20d80f3cecee513e$export$bc9b55530897c558(context = (0, $55099852ccad0564$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $55099852ccad0564$export$cc80c08dc91f1c00) ? (0, $391671225302c365$export$6ccbb43953eebf8) : (0, $391671225302c365$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();









(0, $d8fc8d639f906efc$export$e2e6e3f3f3b782e3)((0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector));
(0, $dbe46e5c642d971b$export$36d45daa6a4925b8)((0, $hfliI.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $f9089991fdc24c9c$export$4b9874722d0da7bc)((0, $1u0KT.unstable_batchedUpdates));


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


var $i4CZ2 = parcelRequire("i4CZ2");

// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $7062a3595350e02d$var$NOT_FOUND = 'NOT_FOUND';
function $7062a3595350e02d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7062a3595350e02d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $7062a3595350e02d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $7062a3595350e02d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7062a3595350e02d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7062a3595350e02d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $7062a3595350e02d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7062a3595350e02d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $7062a3595350e02d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7062a3595350e02d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $7062a3595350e02d$var$createSingletonCache(comparator) : $7062a3595350e02d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7062a3595350e02d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $501bc638b8425ea6$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $501bc638b8425ea6$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $501bc638b8425ea6$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $501bc638b8425ea6$export$595d22ed68ca2841 = /* #__PURE__ */ $501bc638b8425ea6$export$5943f4447f6ef248((0, $7062a3595350e02d$export$281bff7f05488aa2));
var $501bc638b8425ea6$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $501bc638b8425ea6$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;



var $hPtJY = parcelRequire("hPtJY");
var $74cf642ba7fa99c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74cf642ba7fa99c2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $74cf642ba7fa99c2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $74cf642ba7fa99c2$var$__defProp = Object.defineProperty;
var $74cf642ba7fa99c2$var$__defProps = Object.defineProperties;
var $74cf642ba7fa99c2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $74cf642ba7fa99c2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $74cf642ba7fa99c2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $74cf642ba7fa99c2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $74cf642ba7fa99c2$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $74cf642ba7fa99c2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $74cf642ba7fa99c2$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($74cf642ba7fa99c2$var$__hasOwnProp.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    if ($74cf642ba7fa99c2$var$__getOwnPropSymbols) for(var _i = 0, _c = $74cf642ba7fa99c2$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($74cf642ba7fa99c2$var$__propIsEnum.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $74cf642ba7fa99c2$var$__spreadProps = function(a, b) {
    return $74cf642ba7fa99c2$var$__defProps(a, $74cf642ba7fa99c2$var$__getOwnPropDescs(b));
};
var $74cf642ba7fa99c2$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $74cf642ba7fa99c2$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $501bc638b8425ea6$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $74cf642ba7fa99c2$var$__spreadArray([
            (0, $i4CZ2.isDraft)(value) ? (0, $i4CZ2.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $74cf642ba7fa99c2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $ad4393542232627c$export$f672e0b6f7222cd7;
    return (0, $ad4393542232627c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $74cf642ba7fa99c2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $74cf642ba7fa99c2$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $74cf642ba7fa99c2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $74cf642ba7fa99c2$export$b956e38827fca970(action) {
    return $74cf642ba7fa99c2$export$53b83ca8eaab0383(action) && "type" in action;
}
function $74cf642ba7fa99c2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $74cf642ba7fa99c2$var$hasMatchFunction(action);
}
function $74cf642ba7fa99c2$export$ebd532f9034651f3(action) {
    return $74cf642ba7fa99c2$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($74cf642ba7fa99c2$var$isValidKey);
}
function $74cf642ba7fa99c2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $74cf642ba7fa99c2$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $74cf642ba7fa99c2$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $74cf642ba7fa99c2$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $74cf642ba7fa99c2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $74cf642ba7fa99c2$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $74cf642ba7fa99c2$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $74cf642ba7fa99c2$var$freezeDraftable(val) {
    return (0, $i4CZ2.isDraftable)(val) ? (0, $i4CZ2.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $74cf642ba7fa99c2$var$isProduction = true;
var $74cf642ba7fa99c2$var$prefix = "Invariant failed";
function $74cf642ba7fa99c2$var$invariant(condition, message) {
    if (condition) return;
    if ($74cf642ba7fa99c2$var$isProduction) throw new Error($74cf642ba7fa99c2$var$prefix);
    throw new Error($74cf642ba7fa99c2$var$prefix + ": " + (message || ""));
}
function $74cf642ba7fa99c2$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $74cf642ba7fa99c2$var$getSerialize(serializer, decycler), indent);
}
function $74cf642ba7fa99c2$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $74cf642ba7fa99c2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $74cf642ba7fa99c2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $74cf642ba7fa99c2$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $74cf642ba7fa99c2$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $74cf642ba7fa99c2$export$53b83ca8eaab0383(val);
}
function $74cf642ba7fa99c2$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $74cf642ba7fa99c2$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $74cf642ba7fa99c2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $74cf642ba7fa99c2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $74cf642ba7fa99c2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$74cf642ba7fa99c2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $74cf642ba7fa99c2$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $74cf642ba7fa99c2$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $74cf642ba7fa99c2$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options);
    };
}
function $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $74cf642ba7fa99c2$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($74cf642ba7fa99c2$var$isBoolean(thunk)) middlewareArray.push((0, $ac5d5956ce0b399b$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $ac5d5956ce0b399b$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $74cf642ba7fa99c2$var$IS_PRODUCTION = true;
function $74cf642ba7fa99c2$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $74cf642ba7fa99c2$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($74cf642ba7fa99c2$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $ad4393542232627c$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $ad4393542232627c$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $ad4393542232627c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $74cf642ba7fa99c2$var$composeWithDevTools($74cf642ba7fa99c2$var$__spreadValues({
        trace: !$74cf642ba7fa99c2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $74cf642ba7fa99c2$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $74cf642ba7fa99c2$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $ad4393542232627c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $74cf642ba7fa99c2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $74cf642ba7fa99c2$var$isStateFunction(x) {
    return typeof x === "function";
}
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation = false;
function $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($74cf642ba7fa99c2$var$isStateFunction(initialState)) getInitialState = function() {
        return $74cf642ba7fa99c2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $74cf642ba7fa99c2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $74cf642ba7fa99c2$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $i4CZ2.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $i4CZ2.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $i4CZ2.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2 = false;
function $74cf642ba7fa99c2$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $hPtJY;
    var initialState = typeof options.initialState == "function" ? options.initialState : $74cf642ba7fa99c2$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $74cf642ba7fa99c2$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareCallback) : $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $74cf642ba7fa99c2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $74cf642ba7fa99c2$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($74cf642ba7fa99c2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $74cf642ba7fa99c2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $74cf642ba7fa99c2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $74cf642ba7fa99c2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $74cf642ba7fa99c2$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $i4CZ2.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $i4CZ2.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $74cf642ba7fa99c2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $74cf642ba7fa99c2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $74cf642ba7fa99c2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably),
        removeOne: $74cf642ba7fa99c2$var$createStateOperator(removeOneMutably),
        removeMany: $74cf642ba7fa99c2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sort) {
    var _c = $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($74cf642ba7fa99c2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $74cf642ba7fa99c2$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $74cf642ba7fa99c2$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $74cf642ba7fa99c2$var$createInitialStateFactory();
    var selectorsFactory = $74cf642ba7fa99c2$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sortComparer) : $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId);
    return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $74cf642ba7fa99c2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $74cf642ba7fa99c2$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $74cf642ba7fa99c2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $74cf642ba7fa99c2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $74cf642ba7fa99c2$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $74cf642ba7fa99c2$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $74cf642ba7fa99c2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $74cf642ba7fa99c2$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $74cf642ba7fa99c2$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $74cf642ba7fa99c2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $74cf642ba7fa99c2$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$74cf642ba7fa99c2$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $74cf642ba7fa99c2$var$RejectWithValue) throw result;
                                                if (result instanceof $74cf642ba7fa99c2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $74cf642ba7fa99c2$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($74cf642ba7fa99c2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $74cf642ba7fa99c2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $74cf642ba7fa99c2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $74cf642ba7fa99c2$var$matches = function(matcher, action) {
    if ($74cf642ba7fa99c2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $74cf642ba7fa99c2$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $74cf642ba7fa99c2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $74cf642ba7fa99c2$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $74cf642ba7fa99c2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $74cf642ba7fa99c2$var$noop = function() {};
var $74cf642ba7fa99c2$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $74cf642ba7fa99c2$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $74cf642ba7fa99c2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $74cf642ba7fa99c2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $74cf642ba7fa99c2$var$task = "task";
var $74cf642ba7fa99c2$var$listener = "listener";
var $74cf642ba7fa99c2$var$completed = "completed";
var $74cf642ba7fa99c2$var$cancelled = "cancelled";
var $74cf642ba7fa99c2$var$taskCancelled = "task-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$taskCompleted = "task-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$var$listenerCancelled = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$listenerCompleted = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $74cf642ba7fa99c2$var$task + " " + $74cf642ba7fa99c2$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $74cf642ba7fa99c2$var$validateActive = function(signal) {
    if (signal.aborted) throw new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason);
};
function $74cf642ba7fa99c2$var$raceWithSignal(signal, promise2) {
    var cleanup = $74cf642ba7fa99c2$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $74cf642ba7fa99c2$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $74cf642ba7fa99c2$var$noop;
    });
}
var $74cf642ba7fa99c2$var$runTask = function(task2, cleanUp) {
    return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
        var value, error_1;
        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $74cf642ba7fa99c2$var$createPause = function(signal) {
    return function(promise2) {
        return $74cf642ba7fa99c2$var$catchRejection($74cf642ba7fa99c2$var$raceWithSignal(signal, promise2).then(function(output) {
            $74cf642ba7fa99c2$var$validateActive(signal);
            return output;
        }));
    };
};
var $74cf642ba7fa99c2$var$createDelay = function(signal) {
    var pause = $74cf642ba7fa99c2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $74cf642ba7fa99c2$var$assign = Object.assign;
var $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN = {};
var $74cf642ba7fa99c2$var$alm = "listenerMiddleware";
var $74cf642ba7fa99c2$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $74cf642ba7fa99c2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $74cf642ba7fa99c2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $74cf642ba7fa99c2$var$runTask(function() {
            return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
                var result2;
                return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $74cf642ba7fa99c2$var$validateActive(parentAbortSignal);
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $74cf642ba7fa99c2$var$createPause(childAbortController.signal),
                                    delay: $74cf642ba7fa99c2$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $74cf642ba7fa99c2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCancelled);
            }
        };
    };
};
var $74cf642ba7fa99c2$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $74cf642ba7fa99c2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$catchRejection(take(predicate, timeout));
    };
};
var $74cf642ba7fa99c2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $74cf642ba7fa99c2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $74cf642ba7fa99c2$var$createListenerEntry = function(options) {
    var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $74cf642ba7fa99c2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
    });
};
var $74cf642ba7fa99c2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($74cf642ba7fa99c2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $74cf642ba7fa99c2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $74cf642ba7fa99c2$export$f03a6b845d3fb58b = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/add");
var $74cf642ba7fa99c2$export$b1b8022855fb2b71 = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/removeAll");
var $74cf642ba7fa99c2$export$b03e9483f936dccb = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/remove");
var $74cf642ba7fa99c2$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $74cf642ba7fa99c2$var$__spreadArray([
        $74cf642ba7fa99c2$var$alm + "/error"
    ], args));
};
function $74cf642ba7fa99c2$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $74cf642ba7fa99c2$var$defaultErrorHandler : _c;
    $74cf642ba7fa99c2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $74cf642ba7fa99c2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $74cf642ba7fa99c2$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $74cf642ba7fa99c2$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $74cf642ba7fa99c2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $74cf642ba7fa99c2$var$createDelay(internalTaskController.signal),
                                pause: $74cf642ba7fa99c2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $74cf642ba7fa99c2$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f)) $74cf642ba7fa99c2$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $74cf642ba7fa99c2$var$abortControllerWithReason(internalTaskController, $74cf642ba7fa99c2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $74cf642ba7fa99c2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$74cf642ba7fa99c2$export$b956e38827fca970(action)) return next(action);
                if ($74cf642ba7fa99c2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($74cf642ba7fa99c2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($74cf642ba7fa99c2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN) throw new Error($74cf642ba7fa99c2$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $74cf642ba7fa99c2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $74cf642ba7fa99c2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $74cf642ba7fa99c2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$74cf642ba7fa99c2$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $74cf642ba7fa99c2$var$promise;
var $74cf642ba7fa99c2$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($74cf642ba7fa99c2$var$promise || ($74cf642ba7fa99c2$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $74cf642ba7fa99c2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $74cf642ba7fa99c2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $74cf642ba7fa99c2$var$createQueueWithTimer(10);
var $74cf642ba7fa99c2$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $74cf642ba7fa99c2$var$queueMicrotaskShim : options.type === "raf" ? $74cf642ba7fa99c2$var$rAF : options.type === "callback" ? options.queueNotification : $74cf642ba7fa99c2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$74cf642ba7fa99c2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $i4CZ2.enableES5)();



var $acw62 = parcelRequire("acw62");
var $b36a05dffe55b995$export$1e511d4a378977f5;
var $b36a05dffe55b995$export$2e2bcd8739ae039;
"use strict";
$b36a05dffe55b995$export$1e511d4a378977f5 = true;
$b36a05dffe55b995$export$2e2bcd8739ae039 = void 0;

var $b36a05dffe55b995$var$_createWebStorage = $b36a05dffe55b995$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $b36a05dffe55b995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b36a05dffe55b995$var$_default = (0, $b36a05dffe55b995$var$_createWebStorage.default)('local');
$b36a05dffe55b995$export$2e2bcd8739ae039 = $b36a05dffe55b995$var$_default;


var $dc4a47ea750d5f98$export$711117ad6ad27992 = 'persist:';
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = 'persist/FLUSH';
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = 'persist/REHYDRATE';
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = 'persist/PAUSE';
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = 'persist/PERSIST';
var $dc4a47ea750d5f98$export$5514fc3b4067675f = 'persist/PURGE';
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = 'persist/REGISTER';
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;


function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === 'function') serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error('redux-persist/createPersistoid: error serializing state', err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === 'function') deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}


function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2df6cf986f188332$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error("redux-persist: persist timed out for persist key \"".concat(config.key, "\"")));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $a17e9ce2c74bd9e8$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $4db55e14b5a1f785$export$2e2bcd8739ae039)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $dc4a47ea750d5f98$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === 'object') Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === '_persist') return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === 'object';
}


function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $792f2290643e73f9$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(config, (0, $ad4393542232627c$export$66e4520cdb265d18)(reducers));
}




function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $dc4a47ea750d5f98$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $ad4393542232627c$export$f51a9068ac82ea43)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $dc4a47ea750d5f98$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}









var $acw62 = parcelRequire("acw62");
function $6e12196636af0b10$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6e12196636af0b10$var$_typeof(obj);
}
function $6e12196636af0b10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e12196636af0b10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e12196636af0b10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e12196636af0b10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e12196636af0b10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6e12196636af0b10$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e12196636af0b10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6e12196636af0b10$var$_assertThisInitialized(self);
}
function $6e12196636af0b10$var$_getPrototypeOf(o) {
    $6e12196636af0b10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e12196636af0b10$var$_getPrototypeOf(o);
}
function $6e12196636af0b10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e12196636af0b10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6e12196636af0b10$var$_setPrototypeOf(subClass, superClass);
}
function $6e12196636af0b10$var$_setPrototypeOf(o, p) {
    $6e12196636af0b10$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e12196636af0b10$var$_setPrototypeOf(o, p);
}
function $6e12196636af0b10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6e12196636af0b10$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $6e12196636af0b10$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $6e12196636af0b10$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6e12196636af0b10$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $6e12196636af0b10$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $6e12196636af0b10$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === 'function') return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $acw62.PureComponent));
$6e12196636af0b10$var$_defineProperty($6e12196636af0b10$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});


/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



function $3e06475c4dbec09d$export$2e2bcd8739ae039(user = {}) {
    const userSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "user",
        initialState: user,
        reducers: {
            updateUser: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            }
        }
    });
    return userSlice.reducer;
}
const $3e06475c4dbec09d$export$e3ac7a5d19605772 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("user/updateUser");



// Initialize dataLayer if it doesn't exist
window.dataLayer = window.dataLayer || [];
const $6ee05925f8d16f34$export$92ab14d0aa42e41e = (page)=>{
    window.dataLayer.push({
        event: 'page_view',
        page: page
    });
};
const $6ee05925f8d16f34$export$1deff90544a4c4e9 = (popupName)=>{
    window.dataLayer.push({
        event: 'popup_open',
        popup_name: popupName
    });
};
const $6ee05925f8d16f34$export$cdd110eef83fd2bd = (popupName)=>{
    window.dataLayer.push({
        event: 'popup_close',
        popup_name: popupName
    });
};
const $6ee05925f8d16f34$export$d33a5bb646105e4c = (formName, formData)=>{
    window.dataLayer.push({
        event: 'form_submit',
        form_name: formName,
        form_data: formData
    });
};
const $6ee05925f8d16f34$export$32da4af7ebb91d8c = (buttonName, buttonData = {})=>{
    window.dataLayer.push({
        event: 'button_click',
        button_name: buttonName,
        ...buttonData
    });
};
const $6ee05925f8d16f34$export$1a9c1bab8f0497b4 = (eventName, eventData = {})=>{
    window.dataLayer.push({
        event: eventName,
        ...eventData
    });
};


function $ee5327cdf6cdce8c$export$2e2bcd8739ae039(modal = {
    open: ''
}) {
    const modalSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "modal",
        initialState: {
            ...modal,
            resetTab: false,
            modalHistory: null,
            historyData: null,
            errorData: null
        },
        reducers: {
            update: (state, action)=>{
                if (action.payload.open !== '') (0, $6ee05925f8d16f34$export$1deff90544a4c4e9)(action.payload.open);
                else (0, $6ee05925f8d16f34$export$cdd110eef83fd2bd)(state.open);
                return {
                    ...state,
                    ...action.payload
                };
            },
            resetTab: (state, action)=>{
                return {
                    ...state,
                    resetTab: action.payload
                };
            },
            SET_HISTORY_MODAL: (state, action)=>{
                return {
                    ...state,
                    ...action.payload.modalHistory ? {
                        modalHistory: action.payload.modalHistory
                    } : {},
                    ...action.payload.historyData ? {
                        historyData: action.payload.historyData
                    } : {}
                };
            }
        }
    });
    return modalSlice.reducer;
}
const $ee5327cdf6cdce8c$export$313c6d35f75fc0e = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("modal/update");
const $ee5327cdf6cdce8c$export$c42821355a5f8135 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("modal/resetTab");
const $ee5327cdf6cdce8c$export$25316803c042c1e3 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("modal/SET_HISTORY_MODAL");



function $7fa194fc86099528$export$2e2bcd8739ae039(loginType = {
    smsEnabled: '',
    twoFaEnabled: '',
    emailEnabled: '',
    hash: '',
    isBillingRoute: false
}) {
    const loginSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "loginType",
        initialState: loginType,
        reducers: {
            setLoginType: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            }
        }
    });
    return loginSlice.reducer;
}
const $7fa194fc86099528$export$9b16b760c6b5c1ae = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("loginType/setLoginType");



function $b73aa58a82b722b1$export$2e2bcd8739ae039(module = {}) {
    const moduleSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "module",
        initialState: module,
        reducers: {
            updateModule: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            }
        }
    });
    return moduleSlice.reducer;
}
const $b73aa58a82b722b1$export$4ad686614bba9050 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("module/updateModule");



function $3d3d7a2ee763f32a$export$2e2bcd8739ae039(partner = {}) {
    const partnerSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "partner",
        initialState: partner,
        reducers: {
            updatePartner: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            }
        }
    });
    return partnerSlice.reducer;
}
const $3d3d7a2ee763f32a$export$6af6109222273956 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("partner/updatePartner");



function $0b8fb0446eadf91e$export$2e2bcd8739ae039(dealRoom = false) {
    const dealRoomSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "dealRoom",
        initialState: {
            isOn: dealRoom
        },
        reducers: {
            setDealRoom: (state, action)=>{
                return {
                    ...state,
                    isOn: !!action.payload
                };
            }
        }
    });
    return dealRoomSlice.reducer;
}
const $0b8fb0446eadf91e$export$e1724ae90b5a8316 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("dealRoom/setDealRoom");



// require('dotenv').config();
/* -- set app title --*/ const $6a6b4b5ab5be324d$export$c47813c84e32780f = 'Frontend Diligentsia';
/* -- Feature Flags --*/ // Set to true to show AutoFill and Ask Clarence AI features; set to false to hide them
const $6a6b4b5ab5be324d$export$2908142509316f06 = true;
/* -- set app mode -- */ // const AppMode = 'demo';
// const AppMode = 'development';
const $6a6b4b5ab5be324d$export$e5d97828673c2a38 = 'production';
let $6a6b4b5ab5be324d$export$61abde59b50deb8e, $6a6b4b5ab5be324d$export$bc0b79747356381c = 'pk_test_51MpurgLOHSjP8ChLmQdb5P3Ef1de2dt9dG9dFlZxFo9SI3d3LqahKDH2BGiRURNQ9swNjn0UyKSHxSYwik4QHibK00bllnaJh4';
let $6a6b4b5ab5be324d$export$75ca824b364dfc45 = {
    'Lite': {
        priceId: 'price_1MqEcPLOHSjP8ChLXlJS8eAE',
        price: '99',
        currency: 'gbp'
    },
    'Pro': {
        priceId: 'price_1MqEc4LOHSjP8ChLwW6ZzQV0',
        price: '999',
        currency: 'gbp'
    },
    'DEPF006': {
        priceId: 'price_1RRB6CQ10I0nR9drdAObIpul',
        price: 500,
        currency: 'gbp',
        name: 'Warranty Disclosure Schedule',
        id: 'warranty-disclosure'
    },
    //c
    'DEPF007': {
        priceId: 'price_1RRB5LQ10I0nR9drrC7f9LZN',
        price: 250,
        currency: 'gbp',
        name: 'Directors Questionnaire',
        id: 'directors-questionnaire'
    },
    // c
    'HEYBP': {
        priceId: 'price_1RRB8KQ10I0nR9drejMHp7BW',
        price: 99,
        currency: 'gbp',
        name: 'H - Enhancing Your Business Plan',
        id: 'healthboost-enhancing-your-business-plan'
    },
    'HLTGP': {
        priceId: 'price_1RRB5LQ10I0nR9drrC7f9LZN',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Long Term Growth Planning',
        id: 'healthboost-long-term-growth-planning'
    },
    'HIYKV': {
        priceId: 'price_1RTLnIQ10I0nR9drbijwc7UH',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Improving Your KPIs',
        id: 'healthboost-improving-your-kpis'
    },
    'HMYKR': {
        priceId: 'price_1RTLnsQ10I0nR9draQTsRKZq',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Mitigating Your Key Risks',
        id: 'healthboost-mitigating-your-key-risks'
    },
    'HICKY': {
        priceId: 'price_1RTMuEQ10I0nR9drQshrbykV',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Improving Compliance',
        id: 'healthboost-improving-compliance'
    },
    'HBNFR': {
        priceId: 'price_1RTMv5Q10I0nR9drvbnCzREz',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Building New Funding Relationships',
        id: 'healthboost-building-new-funding-relationships'
    },
    'HIYEFT': {
        priceId: 'price_1RTMwCQ10I0nR9dr5qs4jOuL',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Improving Your Existing Funding Terms',
        id: 'healthboost-improving-your-existing-funding-terms'
    },
    'HIYRI': {
        priceId: 'price_1RTMxbQ10I0nR9drKYsYEasW',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Increasing Your Revenues',
        id: 'healthboost-increasing-your-revenues'
    },
    'HDYMP': {
        priceId: 'price_1RTMyRQ10I0nR9drQW61Kyvj',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Driving Your Margins & Profit',
        id: 'healthboost-driving-your-margins-profit'
    },
    'HIYCC': {
        priceId: 'price_1RTMzIQ10I0nR9drf7VsKgPF',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Improving Your Cashflow',
        id: 'healthboost-improving-your-cashflow'
    },
    'HBOED': {
        priceId: 'price_1RTN0LQ10I0nR9drReXGZExM',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Boosting Outsourcing Efficiency',
        id: 'healthboost-boosting-outsourcing-efficiency'
    },
    'HSYCO': {
        priceId: 'price_1RTN1EQ10I0nR9dr7kjzdcNY',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Strengthening Your Controls',
        id: 'healthboost-strengthening-your-controls'
    },
    'HOYTI': {
        priceId: 'price_1RTN2DQ10I0nR9drNvEoOtGY',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Optimising Your Taxation',
        id: 'healthboost-optimising-your-taxation'
    },
    'HEYSMBB': {
        priceId: 'price_1RTN3PQ10I0nR9dr9hAUVO92',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Enhancing Your Social Media - B2B Businesses',
        id: 'healthboost-enhancing-your-social-media-b2b-businesses'
    },
    'HEYSMBBWTCPU': {
        priceId: 'price_1RTN4OQ10I0nR9drZW3GwG9I',
        price: 99,
        currency: 'gbp',
        name: 'HealthBoost - Enhancing Your Social Media - B2C Businesses',
        id: 'healthboost-enhancing-your-social-media-b2c-businesses'
    }
};
switch($6a6b4b5ab5be324d$export$e5d97828673c2a38){
    case 'development':
        $6a6b4b5ab5be324d$export$61abde59b50deb8e = location.host.match(/localhost:\d+/) ? 'http://localhost:4000' : "https://devserver.diligentsia.co.uk";
        break;
    case 'demo':
        $6a6b4b5ab5be324d$export$61abde59b50deb8e = location.host.match(/localhost:\d+/) ? 'http://localhost:8000' : "https://demoserver.diligentsia.co.uk";
        break;
    case 'production':
        $6a6b4b5ab5be324d$export$61abde59b50deb8e = location.host.match(/localhost:\d+/) ? 'http://localhost:4000' : "https://prodserver.diligentsia.co.uk";
        $6a6b4b5ab5be324d$export$bc0b79747356381c = "pk_live_51M6YZmLbuPrFlceS9gw3MoEgj37hepLFA0QujIYgoGxoGNhjEyfDoUTKDQZZo9x1ZSnZXyDwuPAGCF9o9F5RToWb00zH94XFiO";
        $6a6b4b5ab5be324d$export$75ca824b364dfc45 = {
            'Lite': {
                priceId: 'price_1PVDmNLbuPrFlceSRwwRK3Pn',
                price: '99',
                currency: 'gbp'
            },
            'Pro': {
                priceId: 'price_1PVVgGLbuPrFlceST5cT5kh8',
                price: '999',
                currency: 'gbp'
            },
            'DEPN004': {
                priceId: 'price_1N48p4LOHSjP8ChLRFaBFNTC',
                price: 500,
                currency: 'gbp',
                name: 'Software Development',
                id: 'software-development'
            },
            'DEPF005': {
                priceId: 'price_1N48qdLOHSjP8ChLxJ1bXEtO',
                price: 500,
                currency: 'gbp',
                name: 'Environmental Social & Governmental (ESG)',
                id: 'esg'
            },
            'DEPF008': {
                priceId: 'price_1RTNGlLbuPrFlceS49NtdqW1',
                price: 500,
                currency: 'gbp',
                name: 'Investor Lead Introduction',
                id: 'investor-lead'
            },
            'DEPF006': {
                priceId: 'price_1RTNGsLbuPrFlceSPJMzF4mc',
                price: 500,
                currency: 'gbp',
                name: 'Warranty Disclosure Schedule',
                id: 'warranty-disclosure'
            },
            'DEPF007': {
                priceId: 'price_1RTNGqLbuPrFlceSRscFee1W',
                price: 250,
                currency: 'gbp',
                name: 'Directors Questionnaire',
                id: 'directors-questionnaire'
            },
            'HEYBP': {
                priceId: 'price_1RTNGwLbuPrFlceSQQkfmt9q',
                price: 99,
                currency: 'gbp',
                name: 'H - Enhancing Your Business Plan',
                id: 'healthboost-enhancing-your-business-plan'
            },
            'HLTGP': {
                priceId: 'price_1RTNGuLbuPrFlceS37aSzDdc',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Long Term Growth Planning',
                id: 'healthboost-long-term-growth-planning'
            },
            'HIYKV': {
                priceId: 'price_1RTMt3LbuPrFlceS2m6V5vur',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Improving Your KPIs',
                id: 'healthboost-improving-your-kpis'
            },
            'HMYKR': {
                priceId: 'price_1RTMt1LbuPrFlceSYUqYkQOR',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Mitigating Your Key Risks',
                id: 'healthboost-mitigating-your-key-risks'
            },
            'HICKY': {
                priceId: 'price_1RTMuJLbuPrFlceShHzDf9qW',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Improving Compliance',
                id: 'healthboost-improving-compliance'
            },
            'HBNFR': {
                priceId: 'price_1RTMvHLbuPrFlceSpOp2cbem',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Building New Funding Relationships',
                id: 'healthboost-building-new-funding-relationships'
            },
            'HIYEFT': {
                priceId: 'price_1RTMwHLbuPrFlceSYOTqBuIl',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Improving Your Existing Funding Terms',
                id: 'healthboost-improving-your-existing-funding-terms'
            },
            'HIYRI': {
                priceId: 'price_1RTMxgLbuPrFlceSHghpcD1R',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Increasing Your Revenues',
                id: 'healthboost-increasing-your-revenues'
            },
            'HDYMP': {
                priceId: 'price_1RTNGXLbuPrFlceSp1ksSHpF',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Driving Your Margins & Profit',
                id: 'healthboost-driving-your-margins-profit'
            },
            'HIYCC': {
                priceId: 'price_1RTMzNLbuPrFlceSuA2dRpnY',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Improving Your Cashflow',
                id: 'healthboost-improving-your-cashflow'
            },
            'HBOED': {
                priceId: 'price_1RTN0RLbuPrFlceSuqbLYyzd',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Boosting Outsourcing Efficiency',
                id: 'healthboost-boosting-outsourcing-efficiency'
            },
            'HSYCO': {
                priceId: 'price_1RTN1LLbuPrFlceSxhEBMz0b',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Strengthening Your Controls',
                id: 'healthboost-strengthening-your-controls'
            },
            'HOYTI': {
                priceId: 'price_1RTN2ILbuPrFlceS7nwKHRWw',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Optimising Your Taxation',
                id: 'healthboost-optimising-your-taxation'
            },
            'HEYSMBB': {
                priceId: 'price_1RTNGKLbuPrFlceSB3utKyEJ',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Enhancing Your Social Media - B2B Businesses',
                id: 'healthboost-enhancing-your-social-media-b2b-businesses'
            },
            'HEYSMBBWTCPU': {
                priceId: 'price_1RTdFxLbuPrFlceST1uFymey',
                price: 99,
                currency: 'gbp',
                name: 'HealthBoost - Enhancing Your Social Media - B2C Businesses',
                id: 'healthboost-enhancing-your-social-media-b2c-businesses'
            }
        };
        break;
    default:
        $6a6b4b5ab5be324d$export$61abde59b50deb8e = "http://localhost:4000";
}
console.log('******** URL = ', $6a6b4b5ab5be324d$export$61abde59b50deb8e);
console.log('******** AppMode = ', $6a6b4b5ab5be324d$export$e5d97828673c2a38);



var $jS47X = parcelRequire("jS47X");
var $bebe1cbb5a309c8c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jS47X))).connect((0, $6a6b4b5ab5be324d$export$61abde59b50deb8e));
const $bebe1cbb5a309c8c$var$_urlToken = new URLSearchParams(window.location.search).get('token');
if ($bebe1cbb5a309c8c$var$_urlToken) localStorage.setItem('token', $bebe1cbb5a309c8c$var$_urlToken);
let $bebe1cbb5a309c8c$export$9e1725a4cfeada27 = localStorage.getItem('token');
let $bebe1cbb5a309c8c$export$d9aa71f96dda8d28 = localStorage.getItem('userId');
const $bebe1cbb5a309c8c$export$57e714f81a2c3d86 = (newToken)=>$bebe1cbb5a309c8c$export$9e1725a4cfeada27 = newToken;
const $bebe1cbb5a309c8c$export$7f5abdb7f5093137 = (newUserId)=>$bebe1cbb5a309c8c$export$d9aa71f96dda8d28 = newUserId;
const $bebe1cbb5a309c8c$export$5863150075eb9294 = (refresh = true)=>{
    $bebe1cbb5a309c8c$export$9e1725a4cfeada27 = '';
    $bebe1cbb5a309c8c$export$d9aa71f96dda8d28 = '';
    localStorage.clear("");
    sessionStorage.clear("");
    localStorage.setItem('isCookies', true);
    for (const key of [
        "token",
        "hash",
        "userId"
    ])document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    if (refresh) window.location.replace(window.origin);
};
// Helper to add shareCode headers for external user requests
const $bebe1cbb5a309c8c$var$addShareCodeHeaders = (myHeaders)=>{
    const currentPath = window.location.pathname;
    // Check if user is accessing via shareCode URL
    if (!currentPath.includes('/shareCode/')) return;
    // Extract shareCode and companyId from URL
    const pathParts = currentPath.split('/');
    const codeIndex = pathParts.indexOf('shareCode');
    const companyIndex = pathParts.indexOf('diligence-pack');
    if (codeIndex !== -1 && companyIndex !== -1) {
        const code = pathParts[codeIndex + 1];
        const companyId = pathParts[companyIndex + 1];
        myHeaders.append('x-share-code', code);
        myHeaders.append('x-company-id', companyId);
    }
};
const $bebe1cbb5a309c8c$export$42ff643f16b1faa2 = async (endpoint, obj, noLoader, animate, hideToast)=>{
    let fileUploadAnimation;
    const spinner = document.getElementById("e1jygW4piZH1");
    if (endpoint !== '/question/saveCV' && !noLoader) spinner.classList.remove("op0");
    if (!endpoint.includes('/company/generateAIReport') && !noLoader) spinner.classList.remove("op0");
    if (endpoint == '/user/reportBug' || endpoint == '/user/updateProfile' || !noLoader) fileUploadAnimation = spinner;
    if (animate === "noAnimation") fileUploadAnimation = null;
    try {
        let myHeaders = new Headers();
        if ($bebe1cbb5a309c8c$export$d9aa71f96dda8d28) myHeaders.append("id", $bebe1cbb5a309c8c$export$d9aa71f96dda8d28);
        if ($bebe1cbb5a309c8c$export$9e1725a4cfeada27) myHeaders.append("Authorization", `Bearer ${$bebe1cbb5a309c8c$export$9e1725a4cfeada27}`);
        // Add shareCode headers for external users (if applicable)
        $bebe1cbb5a309c8c$var$addShareCodeHeaders(myHeaders);
        const formData = new FormData();
        if (endpoint.includes("sync") && endpoint.toLowerCase().includes("dataroom") || endpoint == '/company/allocateFiles') fileUploadAnimation && fileUploadAnimation?.classList.remove("op0");
        Object.entries(obj).forEach((arr)=>{
            if (arr[0] === "attachment" && obj.attachment.length) {
                fileUploadAnimation && fileUploadAnimation?.classList.remove("op0");
                for (const file of obj.attachment)formData.append("attachment", file);
            } else if (arr[0] === "files" && obj.files.length) {
                fileUploadAnimation && fileUploadAnimation?.classList.remove("op0");
                formData.append(arr[0], JSON.stringify(arr[1]));
            } else if (typeof arr[1] == "object") formData.append(arr[0], JSON.stringify(arr[1]));
            else formData.append(...arr);
        });
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formData,
            redirect: 'follow',
            timeout: 600000
        };
        let response = await fetch(`${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api${endpoint}`, requestOptions).then((response)=>response.json());
        // TODO: if code 401 then logout
        if (response['code'] == 401) $bebe1cbb5a309c8c$export$5863150075eb9294();
        else if (response['code'] != 200 && !hideToast) $bebe1cbb5a309c8c$export$787f5d117f138d13(response['message']);
        return response;
    } catch (e) {
        console.error("*****Error in postRequest*****", e);
        $bebe1cbb5a309c8c$export$787f5d117f138d13('Something went wrong');
    } finally{
        if (!noLoader) spinner.classList.add('op0');
        fileUploadAnimation && fileUploadAnimation?.classList.add('op0');
    }
};
const $bebe1cbb5a309c8c$export$2d492ccf07929802 = async (endpoint, obj, noLoader, hideToast)=>{
    const spinner = document.getElementById("e1jygW4piZH1");
    if (!noLoader) spinner.classList.remove("op0");
    try {
        let myHeaders = new Headers();
        if ($bebe1cbb5a309c8c$export$d9aa71f96dda8d28) myHeaders.append("id", $bebe1cbb5a309c8c$export$d9aa71f96dda8d28);
        if ($bebe1cbb5a309c8c$export$9e1725a4cfeada27) myHeaders.append("Authorization", `Bearer ${$bebe1cbb5a309c8c$export$9e1725a4cfeada27}`);
        const formData = new FormData();
        Object.entries(obj).forEach((arr)=>{
            if (arr[0] === "attachment" && obj.attachment?.length) for (const file of obj.attachment)formData.append("attachment", file);
            else if (arr[0] === "files" && obj.files?.length) formData.append(arr[0], JSON.stringify(arr[1]));
            else if (typeof arr[1] == "object") formData.append(arr[0], JSON.stringify(arr[1]));
            else formData.append(...arr);
        });
        let requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: formData,
            redirect: 'follow',
            timeout: 600000
        };
        let response = await fetch(`${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api${endpoint}`, requestOptions).then((response)=>response.json());
        if (response['code'] == 401) $bebe1cbb5a309c8c$export$5863150075eb9294();
        else if (response['code'] != 200 && !hideToast) $bebe1cbb5a309c8c$export$787f5d117f138d13(response['message']);
        return response;
    } catch (e) {
        console.error("*****Error in putRequest*****", e);
        $bebe1cbb5a309c8c$export$787f5d117f138d13('Something went wrong');
    } finally{
        if (!noLoader) spinner.classList.add('op0');
    }
};
const $bebe1cbb5a309c8c$export$73d2141cd2451ba9 = async (endpoint, obj = {}, noLoader, hideToast)=>{
    const spinner = document.getElementById("e1jygW4piZH1");
    if (!noLoader) spinner.classList.remove("op0");
    try {
        let myHeaders = new Headers();
        if ($bebe1cbb5a309c8c$export$d9aa71f96dda8d28) myHeaders.append("id", $bebe1cbb5a309c8c$export$d9aa71f96dda8d28);
        if ($bebe1cbb5a309c8c$export$9e1725a4cfeada27) myHeaders.append("Authorization", `Bearer ${$bebe1cbb5a309c8c$export$9e1725a4cfeada27}`);
        let requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            redirect: 'follow',
            timeout: 600000
        };
        // Add body if obj is provided and not empty
        if (Object.keys(obj).length > 0) {
            const formData = new FormData();
            Object.entries(obj).forEach((arr)=>{
                if (typeof arr[1] == "object") formData.append(arr[0], JSON.stringify(arr[1]));
                else formData.append(...arr);
            });
            requestOptions.body = formData;
        }
        let response = await fetch(`${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api${endpoint}`, requestOptions).then((response)=>response.json());
        if (response['code'] == 401) $bebe1cbb5a309c8c$export$5863150075eb9294();
        else if (response['code'] != 200 && !hideToast) $bebe1cbb5a309c8c$export$787f5d117f138d13(response['message']);
        return response;
    } catch (e) {
        console.error("*****Error in deleteRequest*****", e);
        $bebe1cbb5a309c8c$export$787f5d117f138d13('Something went wrong');
    } finally{
        if (!noLoader) spinner.classList.add('op0');
    }
};
const $bebe1cbb5a309c8c$export$e17608451341e929 = (endpoint, action)=>{
    return new Promise(async (resolve)=>{
        const spinner = document.getElementById('e1jygW4piZH1');
        spinner.classList.remove('op0');
        try {
            let myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
            if ($bebe1cbb5a309c8c$export$d9aa71f96dda8d28) myHeaders.append('id', $bebe1cbb5a309c8c$export$d9aa71f96dda8d28);
            if ($bebe1cbb5a309c8c$export$9e1725a4cfeada27) myHeaders.append('Authorization', `Bearer ${$bebe1cbb5a309c8c$export$9e1725a4cfeada27}`);
            // Add shareCode headers for external users (if applicable)
            $bebe1cbb5a309c8c$var$addShareCodeHeaders(myHeaders);
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
                timeout: 600000
            };
            let response = await fetch(`${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api${endpoint}`, requestOptions).then((response)=>response.json());
            if (response['code'] == 401 && action !== 'return-response') $bebe1cbb5a309c8c$export$5863150075eb9294();
            else if (response['code'] != 200 && action == 'not-showMessage') return;
            else if (response['code'] != 200 && action == 'return-response') return resolve(response);
            else if (response['code'] != 200) return $bebe1cbb5a309c8c$export$787f5d117f138d13(response['message']);
            return resolve(response);
        } catch (e) {
            console.error("*****Error in getRequest*****", e);
            $bebe1cbb5a309c8c$export$787f5d117f138d13('Something went wrong');
        } finally{
            spinner.classList.add('op0');
        }
    });
};
const $bebe1cbb5a309c8c$export$787f5d117f138d13 = async (message)=>{
    let popupTimeout;
    if (!document.getElementById('popup-message')) return setTimeout(()=>$bebe1cbb5a309c8c$export$787f5d117f138d13(message), 1000);
    const popupEl = document.getElementById('popup-message');
    let timeout = 0;
    if (!popupEl.classList.toString().includes('hidden')) {
        popupEl.classList.add('hidden');
        timeout = 600;
    }
    setTimeout(()=>{
        popupEl.innerText = message;
        popupEl.classList.remove('hidden');
        clearTimeout(popupTimeout);
        popupTimeout = setTimeout(()=>popupEl.classList.add('hidden'), 5000);
    }, timeout);
};
const $bebe1cbb5a309c8c$export$464b02f563870b9e = ()=>{
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = mobileRegex.test(userAgent);
    return isMobile;
};


let $b4397434d961d2b4$var$moduleContent = {
    'kpi': {
        heading: 'KPI',
        aiEnhanced: true,
        uploadFiles: false,
        subheading: 'Key Performance Indicators'
    },
    'repository': {
        aiEnhanced: false,
        uploadFiles: true,
        heading: 'Repository',
        subheading: 'Securely store all your important documents here'
    },
    'business-audit-investment': {
        aiEnhanced: true,
        uploadFiles: false,
        heading: 'Business Audit',
        subheading: 'Get expert recommendations on how to reduce risk'
    },
    'business-audit-growth': {
        aiEnhanced: true,
        uploadFiles: false,
        heading: 'Business Audit',
        subheading: 'Get expert recommendations on how to reduce risk'
    },
    'business-audit-exit': {
        aiEnhanced: true,
        uploadFiles: false,
        heading: 'Business Audit',
        subheading: 'Get expert recommendations on how to reduce risk'
    },
    'directors-questionnaire': {
        aiEnhanced: false,
        uploadFiles: true,
        heading: 'Directors Questionnaire',
        subheading: ''
    },
    'two-minute-test-exit': {
        aiEnhanced: true,
        uploadFiles: false,
        heading: 'Exit Ready Test',
        subheading: 'See How Exit Ready You Are'
    },
    'two-minute-test-growth': {
        aiEnhanced: true,
        uploadFiles: false,
        heading: 'Growth Ready Test',
        subheading: 'See How Growth Ready You Are'
    },
    'two-minute-test-investment': {
        aiEnhanced: true,
        uploadFiles: false,
        heading: 'Investment Ready Test',
        subheading: 'How Investment Ready Are You'
    },
    'esg': {
        aiEnhanced: false,
        uploadFiles: true,
        heading: 'Environmental, Social & Governmental',
        subheading: 'Get expert recommendations on how to reduce risk'
    },
    'software-development': {
        aiEnhanced: false,
        uploadFiles: true,
        heading: 'Software Development',
        subheading: 'Get expert recommendations on how to reduce risk'
    },
    'warranty-disclosure': {
        aiEnhanced: false,
        uploadFiles: true,
        heading: 'Warranty Disclosure Schedule',
        subheading: 'Get expert recommendations on how to reduce risk'
    },
    'unaudited-certification': {
        sections: [],
        heading: 'Certification',
        subheading: 'This is your current certification'
    },
    'investor-lead': {
        uploadFiles: true,
        heading: 'Investor Match',
        subheading: 'Securely store all your important documents here'
    }
};
function $b4397434d961d2b4$var$matchesSlug(module, slug) {
    if (!module || !slug) return false;
    const s = slug.toLowerCase();
    if (module.slug?.toLowerCase() === s) return true;
    if (module.moduleKey?.toLowerCase() === s) return true;
    if (module.type?.toLowerCase() === s) return true;
    const normalized = (module.moduleName || '').trim().toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-');
    if (normalized === s) return true;
    if (normalized.replace(/-/g, '') === s) return true;
    return false;
}
const $b4397434d961d2b4$export$ec32c87d8f133bda = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("company/fetchTempModuleData", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const { companyId: companyId, moduleSlug: moduleSlug } = data;
        if (!companyId || !moduleSlug) return rejectWithValue("companyId and moduleSlug are required");
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/dashboard-cards?companyId=${companyId}&modules=true&sections=true&questions=true&answers=true`);
        const cards = response?.body?.cards;
        if (!Array.isArray(cards)) return rejectWithValue("Failed to load module data.");
        let matchedModule = null;
        for (const card of cards){
            for (const m of card.modules || [])if ($b4397434d961d2b4$var$matchesSlug(m, moduleSlug)) {
                matchedModule = m;
                break;
            }
            if (matchedModule) break;
        }
        if (!matchedModule) return rejectWithValue(`Module "${moduleSlug}" not found.`);
        const sections = matchedModule.sections || [];
        sections.forEach((sec)=>{
            (sec.questions || []).forEach((q)=>{
                const ans = (q.answers || [])[0];
                q.answer = ans || {};
            });
        });
        return {
            module: matchedModule,
            sections: sections,
            cards: cards
        };
    } catch (error) {
        console.log(error, "fetchTempModuleData error");
        return rejectWithValue(error?.response?.data || "Something went wrong");
    }
});
const $b4397434d961d2b4$export$ac018a53362d1a6b = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("company/fetchCompanyData", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const { moduleName: moduleName, companyId: companyId, selectedCompany: selectedCompany } = data;
        let baseUrl = `/company/get/${companyId}`;
        if (moduleName) baseUrl += `?moduleName=${moduleName}`;
        // Replace with your API endpoint
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(baseUrl);
        if (response['code'] == 200) {
            response['body']['modules']['kpi'] = {
                type: "kpi",
                sections: []
            };
            for (let module of Object.values(response['body']['modules'])){
                let content = module['type'].includes('directors-questionnaire') ? $b4397434d961d2b4$var$moduleContent['directors-questionnaire'] : $b4397434d961d2b4$var$moduleContent[module['type']];
                if (content) {
                    module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
                    module['aiEnhanced'] = content['aiEnhanced'];
                    module['subheading'] = content['subHeading'];
                    module['uploadFiles'] = content['uploadFiles'];
                }
            }
            response['body']['modules']['unaudited-certification'] = $b4397434d961d2b4$var$moduleContent['unaudited-certification'];
            if (!moduleName && selectedCompany?.['modules']) response['body']['modules'] = selectedCompany['modules'];
            return response['body'];
        }
        return response.body; // Returning the API response
    } catch (error) {
        console.log(error, "error");
        return rejectWithValue(error.response.data || "Something went wrong");
    }
});
function $b4397434d961d2b4$export$2e2bcd8739ae039(company = {}) {
    const companySlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "company",
        initialState: {
            company: company,
            selectedCompany: {},
            tempModule: null,
            tempModuleSections: [],
            tempModuleCards: [],
            tempModuleLoading: false,
            tempModuleError: null
        },
        reducers: {
            updateCompany: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            },
            selectedCompany: (state, action)=>{
                return {
                    ...state,
                    selectedCompany: action.payload
                };
            },
            setFirstVisit: (state, action)=>{
                return {
                    ...state,
                    selectedCompany: {
                        ...state.selectedCompany,
                        firstVisitRepository: action.payload
                    }
                };
            },
            updateTempModuleAnswers: (state, action)=>{
                const savedQuestions = action.payload;
                if (!Array.isArray(savedQuestions) || !state.tempModuleSections) return;
                const answerMap = new Map();
                for (const sq of savedQuestions)if (sq._id) answerMap.set(sq._id.toString(), sq.answer);
                state.tempModuleSections = state.tempModuleSections.map((section)=>({
                        ...section,
                        questions: (section.questions || []).map((q)=>{
                            const updatedAnswer = answerMap.get(q._id?.toString());
                            if (updatedAnswer) return {
                                ...q,
                                answer: updatedAnswer
                            };
                            return q;
                        })
                    }));
            }
        },
        extraReducers: (builder)=>{
            builder.addCase($b4397434d961d2b4$export$ac018a53362d1a6b.pending, (state)=>{
                state.loading = true;
                state.error = null;
            }).addCase($b4397434d961d2b4$export$ac018a53362d1a6b.fulfilled, (state, action)=>{
                state.loading = false;
                state.selectedCompany = action.payload;
            }).addCase($b4397434d961d2b4$export$ac018a53362d1a6b.rejected, (state, action)=>{
                state.loading = false;
                state.error = action.payload;
            }).addCase($b4397434d961d2b4$export$ec32c87d8f133bda.pending, (state)=>{
                state.tempModuleLoading = true;
                state.tempModuleError = null;
            }).addCase($b4397434d961d2b4$export$ec32c87d8f133bda.fulfilled, (state, action)=>{
                state.tempModuleLoading = false;
                state.tempModule = action.payload.module;
                state.tempModuleSections = action.payload.sections;
                state.tempModuleCards = action.payload.cards;
                state.tempModuleError = null;
            }).addCase($b4397434d961d2b4$export$ec32c87d8f133bda.rejected, (state, action)=>{
                state.tempModuleLoading = false;
                state.tempModuleError = action.payload;
            });
        }
    });
    return companySlice.reducer;
}
const $b4397434d961d2b4$export$50f0ed8944cb1d90 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("company/updateCompany");
const $b4397434d961d2b4$export$56500b0941c6fe84 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("company/selectedCompany");
const $b4397434d961d2b4$export$3df9b217bc62436a = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("company/setFirstVisit");
const $b4397434d961d2b4$export$1d932f019d3ae55e = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("company/updateTempModuleAnswers");



function $c968c32a840f1f4e$export$2e2bcd8739ae039(linkedIn = {
    isFromLinkedIn: false
}) {
    const linkedInSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "linkedIn",
        initialState: linkedIn,
        reducers: {
            updateLinkedIn: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            }
        }
    });
    return linkedInSlice.reducer;
}
const $c968c32a840f1f4e$export$69e58c86f065e022 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("linkedIn/updateLinkedIn");



function $b9bcf9787e5ad456$export$2e2bcd8739ae039(companies = []) {
    const companiesSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "companies",
        initialState: companies,
        reducers: {
            refresh: (state, action)=>{
                return [
                    ...action.payload
                ];
            },
            setCompanies: (state, action)=>{
                return [
                    ...action.payload
                ];
            },
            removeCompany: (state, { payload: payload })=>{
                const index = state.findIndex((company)=>company._id === payload._id);
                if (index !== -1) state.splice(index, 1);
            }
        }
    });
    return companiesSlice.reducer;
}
const $b9bcf9787e5ad456$export$2102c8f11f9a72ed = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("companies/refresh");
const $b9bcf9787e5ad456$export$52d586c008658f4c = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("companies/setCompanies");
const $b9bcf9787e5ad456$export$1ee9ca58a1c41c03 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("companies/removeCompany");



function $b11447c30838833f$export$2e2bcd8739ae039() {
    const fileManagementSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "fileManagement",
        initialState: {
            type: null,
            totalFile: 0,
            data: []
        },
        reducers: {
            startSyncing: (state, action)=>{
                return {
                    ...state,
                    totalFile: action.payload.totalFile,
                    data: action.payload.data,
                    type: 'syncing'
                };
            },
            startSyncingFolders: (state)=>{
                return {
                    ...state,
                    type: 'syncingFolders'
                };
            },
            syncingFoldersComplete: (state)=>{
                return {
                    ...state,
                    type: null
                };
            },
            findAndUpdateSyncing: (state, action)=>{
                state.data = state.data.map(({ file: file, answer: answer, ...rest })=>{
                    if (file.originalname === action.payload.file.originalname && answer.qNo === action.payload.answer.qNo) return action.payload; // replace with new payload
                    return {
                        file: file,
                        answer: answer,
                        ...rest,
                        type: 'syncing'
                    }; // keep as is
                });
            },
            resetSyncing: (state)=>{
                state.totalFile = 0;
                state.data = [];
                state.type = null;
            },
            startReSyncing: (state, action)=>{
                return {
                    ...state,
                    totalFile: action.payload.totalFile,
                    data: action.payload.data,
                    type: 'reSyncing'
                };
            },
            findAndUpdateReSyncing: (state, action)=>{
                const incoming = action.payload?.data?.answer;
                if (!incoming) return;
                const incomingId = incoming._id != null ? String(incoming._id) : null;
                const incomingQNo = incoming.qNo != null ? String(incoming.qNo) : null;
                state.data = state.data.map((answer)=>{
                    const answerId = answer._id != null ? String(answer._id) : null;
                    const matchById = incomingId && answerId && answerId === incomingId;
                    const matchByQNo = incomingQNo && answer.qNo != null && String(answer.qNo) === incomingQNo;
                    if (matchById || matchByQNo) return {
                        ...answer,
                        processed: true
                    };
                    return answer;
                });
            },
            resetReSyncing: (state)=>{
                state.totalFile = 0;
                state.data = [];
                state.type = null;
            }
        }
    });
    return fileManagementSlice.reducer;
}
const $b11447c30838833f$export$7a34e0accbb4df68 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/startSyncing");
const $b11447c30838833f$export$b3e07c78a2c60bfb = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/startSyncingFolders");
const $b11447c30838833f$export$b961a89ac79a5350 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/SyncingFoldersComplete");
const $b11447c30838833f$export$74c9a4d719d4ea5c = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/findAndUpdateSyncing");
const $b11447c30838833f$export$8c5c317902a771de = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/resetSyncing");
const $b11447c30838833f$export$e6096d4f512f501c = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/startReSyncing");
const $b11447c30838833f$export$c4374b4dd5806893 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/findAndUpdateReSyncing");
const $b11447c30838833f$export$6c77a92cea265c06 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("fileManagement/resetReSyncing");




const $d1a7983fbe4975c9$export$e3353be9699b5e24 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("clarence/sendMessage", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const { companyId: companyId, message: message, conversationId: conversationId, selectedFiles: selectedFiles } = data;
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/chat', {
            companyId: companyId,
            message: message,
            conversationId: conversationId,
            selectedFiles: selectedFiles
        });
        if (response['code'] === 200) return response['body'];
        return rejectWithValue(response['message'] || 'Failed to send message');
    } catch (error) {
        return rejectWithValue(error?.['message'] || 'Something went wrong');
    }
});
const $d1a7983fbe4975c9$export$6915c58a3b507046 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("clarence/fetchConversations", async (companyId, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/clarence/conversations/${companyId}`);
        if (response['code'] === 200) return response['body']['conversations'];
        return rejectWithValue(response['message'] || 'Failed to fetch conversations');
    } catch (error) {
        return rejectWithValue(error?.['message'] || 'Something went wrong');
    }
});
const $d1a7983fbe4975c9$export$89f5d178e3282cc4 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("clarence/fetchSuggestions", async (companyId, { rejectWithValue: rejectWithValue })=>{
    try {
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/clarence/suggestions/${companyId}`);
        if (response['code'] === 200) return response['body']['suggestions'];
        return rejectWithValue(response['message'] || 'Failed to fetch suggestions');
    } catch (error) {
        return rejectWithValue(error?.['message'] || 'Something went wrong');
    }
});
const $d1a7983fbe4975c9$export$18b4897f0921f175 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("clarence/confirmClassification", async (data, { rejectWithValue: rejectWithValue })=>{
    try {
        const { conversationId: conversationId, classificationId: classificationId, confirmed: confirmed, correctedType: correctedType, correctedCode: correctedCode } = data;
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/classify/confirm', {
            conversationId: conversationId,
            classificationId: classificationId,
            confirmed: confirmed,
            correctedType: correctedType,
            correctedCode: correctedCode
        });
        if (response['code'] === 200) return response['body'];
        return rejectWithValue(response['message'] || 'Failed to confirm classification');
    } catch (error) {
        return rejectWithValue(error?.['message'] || 'Something went wrong');
    }
});
const $d1a7983fbe4975c9$var$initialState = {
    isOpen: false,
    messages: [],
    conversations: [],
    currentConversationId: null,
    suggestions: [],
    pendingClassification: null,
    agentActions: [],
    isLoading: false,
    isTyping: false,
    error: null
};
function $d1a7983fbe4975c9$export$2e2bcd8739ae039() {
    const clarenceSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "clarence",
        initialState: $d1a7983fbe4975c9$var$initialState,
        reducers: {
            toggleClarence: (state, action)=>{
                state['isOpen'] = action['payload'] !== undefined ? action['payload'] : !state['isOpen'];
            },
            addMessage: (state, action)=>{
                state['messages'].push(action['payload']);
            },
            setMessages: (state, action)=>{
                state['messages'] = action['payload'];
            },
            setCurrentConversation: (state, action)=>{
                state['currentConversationId'] = action['payload'];
            },
            clearConversation: (state)=>{
                state['messages'] = [];
                state['currentConversationId'] = null;
                state['agentActions'] = [];
                state['pendingClassification'] = null;
            },
            setTyping: (state, action)=>{
                state['isTyping'] = action['payload'];
            },
            addAgentAction: (state, action)=>{
                state['agentActions'].push(action['payload']);
            },
            updateAgentAction: (state, action)=>{
                const { index: index, status: status } = action['payload'];
                if (state['agentActions'][index]) state['agentActions'][index]['status'] = status;
            },
            clearAgentActions: (state)=>{
                state['agentActions'] = [];
            },
            setPendingClassification: (state, action)=>{
                state['pendingClassification'] = action['payload'];
            },
            clearPendingClassification: (state)=>{
                state['pendingClassification'] = null;
            }
        },
        extraReducers: (builder)=>{
            builder.addCase($d1a7983fbe4975c9$export$e3353be9699b5e24.pending, (state)=>{
                state['isLoading'] = true;
                state['isTyping'] = true;
                state['error'] = null;
            }).addCase($d1a7983fbe4975c9$export$e3353be9699b5e24.fulfilled, (state, action)=>{
                state['isLoading'] = false;
                state['isTyping'] = false;
                if (action['payload']['conversationId']) state['currentConversationId'] = action['payload']['conversationId'];
                if (action['payload']['message']) state['messages'].push(action['payload']['message']);
                if (action['payload']['pendingClassification']) state['pendingClassification'] = action['payload']['pendingClassification'];
            }).addCase($d1a7983fbe4975c9$export$e3353be9699b5e24.rejected, (state, action)=>{
                state['isLoading'] = false;
                state['isTyping'] = false;
                state['error'] = action['payload'];
            }).addCase($d1a7983fbe4975c9$export$6915c58a3b507046.pending, (state)=>{
                state['isLoading'] = true;
            }).addCase($d1a7983fbe4975c9$export$6915c58a3b507046.fulfilled, (state, action)=>{
                state['isLoading'] = false;
                state['conversations'] = action['payload'];
            }).addCase($d1a7983fbe4975c9$export$6915c58a3b507046.rejected, (state, action)=>{
                state['isLoading'] = false;
                state['error'] = action['payload'];
            }).addCase($d1a7983fbe4975c9$export$89f5d178e3282cc4.fulfilled, (state, action)=>{
                state['suggestions'] = action['payload'];
            }).addCase($d1a7983fbe4975c9$export$18b4897f0921f175.fulfilled, (state, action)=>{
                state['pendingClassification'] = null;
                if (action['payload']['message']) state['messages'].push(action['payload']['message']);
            });
        }
    });
    return clarenceSlice.reducer;
}
const $d1a7983fbe4975c9$export$ef9ba44853d57fd8 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/toggleClarence");
const $d1a7983fbe4975c9$export$367764fcaf2b13e9 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/addMessage");
const $d1a7983fbe4975c9$export$1ec1d236a6e82f42 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/setMessages");
const $d1a7983fbe4975c9$export$ac89cd34401258c3 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/setCurrentConversation");
const $d1a7983fbe4975c9$export$3628bd4b1ba80fe9 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/clearConversation");
const $d1a7983fbe4975c9$export$690ac02606dab9a9 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/setTyping");
const $d1a7983fbe4975c9$export$637a0312aa0bb08f = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/addAgentAction");
const $d1a7983fbe4975c9$export$c3c7e5f7209a81ea = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/updateAgentAction");
const $d1a7983fbe4975c9$export$587c801c62ec995f = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/clearAgentActions");
const $d1a7983fbe4975c9$export$21145aa70ad64340 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/setPendingClassification");
const $d1a7983fbe4975c9$export$10d1fabb5dec9fa7 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("clarence/clearPendingClassification");




var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");
var $bad1c3ae594eb6ef$exports = {};
"use strict";
function $bad1c3ae594eb6ef$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bad1c3ae594eb6ef$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bad1c3ae594eb6ef$var$_typeof(o);
}
Object.defineProperty($bad1c3ae594eb6ef$exports, "__esModule", {
    value: true
});
$bad1c3ae594eb6ef$exports.default = void 0;

var $bad1c3ae594eb6ef$var$_toDate = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("gr6fc")));

var $bad1c3ae594eb6ef$var$_toFloat = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("2dcMT")));

var $bad1c3ae594eb6ef$var$_toInt = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ab0Id")));

var $bad1c3ae594eb6ef$var$_toBoolean = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dtiFd")));

var $bad1c3ae594eb6ef$var$_equals = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("jXY5d")));

var $bad1c3ae594eb6ef$var$_contains = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("aZ85Q")));

var $bad1c3ae594eb6ef$var$_matches = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5ZSE3")));

var $bad1c3ae594eb6ef$var$_isEmail = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4tHKL")));

var $bad1c3ae594eb6ef$var$_isURL = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4Cxzb")));

var $bad1c3ae594eb6ef$var$_isMACAddress = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("S05Bl")));

var $bad1c3ae594eb6ef$var$_isIP = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("k4gOC")));

var $bad1c3ae594eb6ef$var$_isIPRange = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9xDwV")));

var $bad1c3ae594eb6ef$var$_isFQDN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("hNevj")));

var $bad1c3ae594eb6ef$var$_isDate = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("akLR8")));

var $bad1c3ae594eb6ef$var$_isTime = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("7Qjw0")));

var $bad1c3ae594eb6ef$var$_isBoolean = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5sk3S")));

var $bad1c3ae594eb6ef$var$_isLocale = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9E8F4")));

var $bad1c3ae594eb6ef$var$_isAbaRouting = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ko0io")));

var $bad1c3ae594eb6ef$var$_isAlpha = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("fvxOe")));

var $bad1c3ae594eb6ef$var$_isAlphanumeric = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("9AaLY")));

var $bad1c3ae594eb6ef$var$_isNumeric = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("b9xtB")));

var $bad1c3ae594eb6ef$var$_isPassportNumber = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lpGGU")));

var $bad1c3ae594eb6ef$var$_isPort = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("anXSC")));

var $bad1c3ae594eb6ef$var$_isLowercase = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8YYKA")));

var $bad1c3ae594eb6ef$var$_isUppercase = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Y8gNP")));

var $bad1c3ae594eb6ef$var$_isIMEI = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8DM8E")));

var $bad1c3ae594eb6ef$var$_isAscii = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("kv2Jx")));

var $bad1c3ae594eb6ef$var$_isFullWidth = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bWCzj")));

var $bad1c3ae594eb6ef$var$_isHalfWidth = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9f357")));

var $bad1c3ae594eb6ef$var$_isVariableWidth = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("jYPXr")));

var $bad1c3ae594eb6ef$var$_isMultibyte = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("81UkT")));

var $bad1c3ae594eb6ef$var$_isSemVer = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("6s9Ea")));

var $bad1c3ae594eb6ef$var$_isSurrogatePair = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9zqOS")));

var $bad1c3ae594eb6ef$var$_isInt = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("3VTZw")));

var $bad1c3ae594eb6ef$var$_isFloat = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("5ARir")));

var $bad1c3ae594eb6ef$var$_isDecimal = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("kfE9J")));

var $bad1c3ae594eb6ef$var$_isHexadecimal = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("38ASS")));

var $bad1c3ae594eb6ef$var$_isOctal = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8h9xl")));

var $bad1c3ae594eb6ef$var$_isDivisibleBy = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9v3dq")));

var $bad1c3ae594eb6ef$var$_isHexColor = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5U1AD")));

var $bad1c3ae594eb6ef$var$_isRgbColor = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4TDuE")));

var $bad1c3ae594eb6ef$var$_isHSL = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("1ItuH")));

var $bad1c3ae594eb6ef$var$_isISRC = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("gmTuo")));

var $bad1c3ae594eb6ef$var$_isIBAN = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("9ExTf")));

var $bad1c3ae594eb6ef$var$_isBIC = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("e8bY8")));

var $bad1c3ae594eb6ef$var$_isMD = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("gdrTg")));

var $bad1c3ae594eb6ef$var$_isHash = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("7D4H0")));

var $bad1c3ae594eb6ef$var$_isJWT = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bRpBC")));

var $bad1c3ae594eb6ef$var$_isJSON = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("c8148")));

var $bad1c3ae594eb6ef$var$_isEmpty = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9itI6")));

var $bad1c3ae594eb6ef$var$_isLength = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("eX4Zk")));

var $bad1c3ae594eb6ef$var$_isByteLength = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lIM5C")));

var $bad1c3ae594eb6ef$var$_isUUID = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("99DHM")));

var $bad1c3ae594eb6ef$var$_isMongoId = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("jEKS4")));

var $bad1c3ae594eb6ef$var$_isAfter = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("fGRWQ")));

var $bad1c3ae594eb6ef$var$_isBefore = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5bvc1")));

var $bad1c3ae594eb6ef$var$_isIn = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("kMIcK")));

var $bad1c3ae594eb6ef$var$_isLuhnNumber = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9Ua0q")));

var $bad1c3ae594eb6ef$var$_isCreditCard = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bBCuW")));

var $bad1c3ae594eb6ef$var$_isIdentityCard = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ilQ4n")));

var $bad1c3ae594eb6ef$var$_isEAN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("5tfrP")));

var $bad1c3ae594eb6ef$var$_isISIN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("doEvT")));

var $bad1c3ae594eb6ef$var$_isISBN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Eh5kE")));

var $bad1c3ae594eb6ef$var$_isISSN = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dzNHd")));

var $bad1c3ae594eb6ef$var$_isTaxID = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("7Nii9")));

var $bad1c3ae594eb6ef$var$_isMobilePhone = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("4kFi1")));

var $bad1c3ae594eb6ef$var$_isEthereumAddress = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Gjy1y")));

var $bad1c3ae594eb6ef$var$_isCurrency = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("69Ecb")));

var $bad1c3ae594eb6ef$var$_isBtcAddress = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ilHLb")));
var $1ea585294f10c24c$exports = {};
"use strict";
Object.defineProperty($1ea585294f10c24c$exports, "__esModule", {
    value: true
});
$1ea585294f10c24c$exports.isFreightContainerID = void 0;
$1ea585294f10c24c$exports.isISO6346 = $1ea585294f10c24c$var$isISO6346;

var $1ea585294f10c24c$var$_assertString = $1ea585294f10c24c$var$_interopRequireDefault((parcelRequire("hZqWG")));
function $1ea585294f10c24c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://en.wikipedia.org/wiki/ISO_6346
// according to ISO6346 standard, checksum digit is mandatory for freight container but recommended
// for other container types (J and Z)
var $1ea585294f10c24c$var$isISO6346Str = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/;
var $1ea585294f10c24c$var$isDigit = /^[0-9]$/;
function $1ea585294f10c24c$var$isISO6346(str) {
    (0, $1ea585294f10c24c$var$_assertString.default)(str);
    str = str.toUpperCase();
    if (!$1ea585294f10c24c$var$isISO6346Str.test(str)) return false;
    if (str.length === 11) {
        var sum = 0;
        for(var i = 0; i < str.length - 1; i++)if (!$1ea585294f10c24c$var$isDigit.test(str[i])) {
            var convertedCode = void 0;
            var letterCode = str.charCodeAt(i) - 55;
            if (letterCode < 11) convertedCode = letterCode;
            else if (letterCode >= 11 && letterCode <= 20) convertedCode = 12 + letterCode % 11;
            else if (letterCode >= 21 && letterCode <= 30) convertedCode = 23 + letterCode % 21;
            else convertedCode = 34 + letterCode % 31;
            sum += convertedCode * Math.pow(2, i);
        } else sum += str[i] * Math.pow(2, i);
        var checkSumDigit = sum % 11;
        return Number(str[str.length - 1]) === checkSumDigit;
    }
    return true;
}
var $1ea585294f10c24c$var$isFreightContainerID = $1ea585294f10c24c$exports.isFreightContainerID = $1ea585294f10c24c$var$isISO6346;



var $bad1c3ae594eb6ef$var$_isISO2 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("hU7qv")));

var $bad1c3ae594eb6ef$var$_isISO3 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("aWF3e")));

var $bad1c3ae594eb6ef$var$_isRFC = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("36TYP")));

var $bad1c3ae594eb6ef$var$_isISO31661Alpha = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dVkQR")));

var $bad1c3ae594eb6ef$var$_isISO31661Alpha2 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lPnYX")));

var $bad1c3ae594eb6ef$var$_isISO4 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("kkpNa")));

var $bad1c3ae594eb6ef$var$_isBase = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("e8aAF")));

var $bad1c3ae594eb6ef$var$_isBase2 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("bgzme")));

var $bad1c3ae594eb6ef$var$_isBase3 = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("2d8yt")));

var $bad1c3ae594eb6ef$var$_isDataURI = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("8REOh")));

var $bad1c3ae594eb6ef$var$_isMagnetURI = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ix1xQ")));

var $bad1c3ae594eb6ef$var$_isMailtoURI = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("iIqBH")));

var $bad1c3ae594eb6ef$var$_isMimeType = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("ifxP4")));

var $bad1c3ae594eb6ef$var$_isLatLong = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("hLP11")));

var $bad1c3ae594eb6ef$var$_isPostalCode = $bad1c3ae594eb6ef$var$_interopRequireWildcard((parcelRequire("7qOwX")));

var $bad1c3ae594eb6ef$var$_ltrim = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("77DLn")));

var $bad1c3ae594eb6ef$var$_rtrim = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("l0bpl")));

var $bad1c3ae594eb6ef$var$_trim = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4wt0T")));

var $bad1c3ae594eb6ef$var$_escape = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("lhIbP")));

var $bad1c3ae594eb6ef$var$_unescape = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("Oufps")));

var $bad1c3ae594eb6ef$var$_stripLow = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("l68Ml")));

var $bad1c3ae594eb6ef$var$_whitelist = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("d4jRJ")));

var $bad1c3ae594eb6ef$var$_blacklist = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("hVEzS")));

var $bad1c3ae594eb6ef$var$_isWhitelisted = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("b8HgM")));

var $bad1c3ae594eb6ef$var$_normalizeEmail = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("j002o")));

var $bad1c3ae594eb6ef$var$_isSlug = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("dtWXT")));

var $bad1c3ae594eb6ef$var$_isLicensePlate = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("4fo1o")));

var $bad1c3ae594eb6ef$var$_isStrongPassword = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("9wP8Z")));

var $bad1c3ae594eb6ef$var$_isVAT = $bad1c3ae594eb6ef$var$_interopRequireDefault((parcelRequire("394HB")));
function $bad1c3ae594eb6ef$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bad1c3ae594eb6ef$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $bad1c3ae594eb6ef$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $bad1c3ae594eb6ef$var$_typeof(e) && "function" != typeof e) return {
        default: e
    };
    var t = $bad1c3ae594eb6ef$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $bad1c3ae594eb6ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bad1c3ae594eb6ef$var$version = '13.12.0';
var $bad1c3ae594eb6ef$var$validator = {
    version: $bad1c3ae594eb6ef$var$version,
    toDate: $bad1c3ae594eb6ef$var$_toDate.default,
    toFloat: $bad1c3ae594eb6ef$var$_toFloat.default,
    toInt: $bad1c3ae594eb6ef$var$_toInt.default,
    toBoolean: $bad1c3ae594eb6ef$var$_toBoolean.default,
    equals: $bad1c3ae594eb6ef$var$_equals.default,
    contains: $bad1c3ae594eb6ef$var$_contains.default,
    matches: $bad1c3ae594eb6ef$var$_matches.default,
    isEmail: $bad1c3ae594eb6ef$var$_isEmail.default,
    isURL: $bad1c3ae594eb6ef$var$_isURL.default,
    isMACAddress: $bad1c3ae594eb6ef$var$_isMACAddress.default,
    isIP: $bad1c3ae594eb6ef$var$_isIP.default,
    isIPRange: $bad1c3ae594eb6ef$var$_isIPRange.default,
    isFQDN: $bad1c3ae594eb6ef$var$_isFQDN.default,
    isBoolean: $bad1c3ae594eb6ef$var$_isBoolean.default,
    isIBAN: $bad1c3ae594eb6ef$var$_isIBAN.default,
    isBIC: $bad1c3ae594eb6ef$var$_isBIC.default,
    isAbaRouting: $bad1c3ae594eb6ef$var$_isAbaRouting.default,
    isAlpha: $bad1c3ae594eb6ef$var$_isAlpha.default,
    isAlphaLocales: $bad1c3ae594eb6ef$var$_isAlpha.locales,
    isAlphanumeric: $bad1c3ae594eb6ef$var$_isAlphanumeric.default,
    isAlphanumericLocales: $bad1c3ae594eb6ef$var$_isAlphanumeric.locales,
    isNumeric: $bad1c3ae594eb6ef$var$_isNumeric.default,
    isPassportNumber: $bad1c3ae594eb6ef$var$_isPassportNumber.default,
    isPort: $bad1c3ae594eb6ef$var$_isPort.default,
    isLowercase: $bad1c3ae594eb6ef$var$_isLowercase.default,
    isUppercase: $bad1c3ae594eb6ef$var$_isUppercase.default,
    isAscii: $bad1c3ae594eb6ef$var$_isAscii.default,
    isFullWidth: $bad1c3ae594eb6ef$var$_isFullWidth.default,
    isHalfWidth: $bad1c3ae594eb6ef$var$_isHalfWidth.default,
    isVariableWidth: $bad1c3ae594eb6ef$var$_isVariableWidth.default,
    isMultibyte: $bad1c3ae594eb6ef$var$_isMultibyte.default,
    isSemVer: $bad1c3ae594eb6ef$var$_isSemVer.default,
    isSurrogatePair: $bad1c3ae594eb6ef$var$_isSurrogatePair.default,
    isInt: $bad1c3ae594eb6ef$var$_isInt.default,
    isIMEI: $bad1c3ae594eb6ef$var$_isIMEI.default,
    isFloat: $bad1c3ae594eb6ef$var$_isFloat.default,
    isFloatLocales: $bad1c3ae594eb6ef$var$_isFloat.locales,
    isDecimal: $bad1c3ae594eb6ef$var$_isDecimal.default,
    isHexadecimal: $bad1c3ae594eb6ef$var$_isHexadecimal.default,
    isOctal: $bad1c3ae594eb6ef$var$_isOctal.default,
    isDivisibleBy: $bad1c3ae594eb6ef$var$_isDivisibleBy.default,
    isHexColor: $bad1c3ae594eb6ef$var$_isHexColor.default,
    isRgbColor: $bad1c3ae594eb6ef$var$_isRgbColor.default,
    isHSL: $bad1c3ae594eb6ef$var$_isHSL.default,
    isISRC: $bad1c3ae594eb6ef$var$_isISRC.default,
    isMD5: $bad1c3ae594eb6ef$var$_isMD.default,
    isHash: $bad1c3ae594eb6ef$var$_isHash.default,
    isJWT: $bad1c3ae594eb6ef$var$_isJWT.default,
    isJSON: $bad1c3ae594eb6ef$var$_isJSON.default,
    isEmpty: $bad1c3ae594eb6ef$var$_isEmpty.default,
    isLength: $bad1c3ae594eb6ef$var$_isLength.default,
    isLocale: $bad1c3ae594eb6ef$var$_isLocale.default,
    isByteLength: $bad1c3ae594eb6ef$var$_isByteLength.default,
    isUUID: $bad1c3ae594eb6ef$var$_isUUID.default,
    isMongoId: $bad1c3ae594eb6ef$var$_isMongoId.default,
    isAfter: $bad1c3ae594eb6ef$var$_isAfter.default,
    isBefore: $bad1c3ae594eb6ef$var$_isBefore.default,
    isIn: $bad1c3ae594eb6ef$var$_isIn.default,
    isLuhnNumber: $bad1c3ae594eb6ef$var$_isLuhnNumber.default,
    isCreditCard: $bad1c3ae594eb6ef$var$_isCreditCard.default,
    isIdentityCard: $bad1c3ae594eb6ef$var$_isIdentityCard.default,
    isEAN: $bad1c3ae594eb6ef$var$_isEAN.default,
    isISIN: $bad1c3ae594eb6ef$var$_isISIN.default,
    isISBN: $bad1c3ae594eb6ef$var$_isISBN.default,
    isISSN: $bad1c3ae594eb6ef$var$_isISSN.default,
    isMobilePhone: $bad1c3ae594eb6ef$var$_isMobilePhone.default,
    isMobilePhoneLocales: $bad1c3ae594eb6ef$var$_isMobilePhone.locales,
    isPostalCode: $bad1c3ae594eb6ef$var$_isPostalCode.default,
    isPostalCodeLocales: $bad1c3ae594eb6ef$var$_isPostalCode.locales,
    isEthereumAddress: $bad1c3ae594eb6ef$var$_isEthereumAddress.default,
    isCurrency: $bad1c3ae594eb6ef$var$_isCurrency.default,
    isBtcAddress: $bad1c3ae594eb6ef$var$_isBtcAddress.default,
    isISO6346: $1ea585294f10c24c$exports.isISO6346,
    isFreightContainerID: $1ea585294f10c24c$exports.isFreightContainerID,
    isISO6391: $bad1c3ae594eb6ef$var$_isISO2.default,
    isISO8601: $bad1c3ae594eb6ef$var$_isISO3.default,
    isRFC3339: $bad1c3ae594eb6ef$var$_isRFC.default,
    isISO31661Alpha2: $bad1c3ae594eb6ef$var$_isISO31661Alpha.default,
    isISO31661Alpha3: $bad1c3ae594eb6ef$var$_isISO31661Alpha2.default,
    isISO4217: $bad1c3ae594eb6ef$var$_isISO4.default,
    isBase32: $bad1c3ae594eb6ef$var$_isBase.default,
    isBase58: $bad1c3ae594eb6ef$var$_isBase2.default,
    isBase64: $bad1c3ae594eb6ef$var$_isBase3.default,
    isDataURI: $bad1c3ae594eb6ef$var$_isDataURI.default,
    isMagnetURI: $bad1c3ae594eb6ef$var$_isMagnetURI.default,
    isMailtoURI: $bad1c3ae594eb6ef$var$_isMailtoURI.default,
    isMimeType: $bad1c3ae594eb6ef$var$_isMimeType.default,
    isLatLong: $bad1c3ae594eb6ef$var$_isLatLong.default,
    ltrim: $bad1c3ae594eb6ef$var$_ltrim.default,
    rtrim: $bad1c3ae594eb6ef$var$_rtrim.default,
    trim: $bad1c3ae594eb6ef$var$_trim.default,
    escape: $bad1c3ae594eb6ef$var$_escape.default,
    unescape: $bad1c3ae594eb6ef$var$_unescape.default,
    stripLow: $bad1c3ae594eb6ef$var$_stripLow.default,
    whitelist: $bad1c3ae594eb6ef$var$_whitelist.default,
    blacklist: $bad1c3ae594eb6ef$var$_blacklist.default,
    isWhitelisted: $bad1c3ae594eb6ef$var$_isWhitelisted.default,
    normalizeEmail: $bad1c3ae594eb6ef$var$_normalizeEmail.default,
    toString: toString,
    isSlug: $bad1c3ae594eb6ef$var$_isSlug.default,
    isStrongPassword: $bad1c3ae594eb6ef$var$_isStrongPassword.default,
    isTaxID: $bad1c3ae594eb6ef$var$_isTaxID.default,
    isDate: $bad1c3ae594eb6ef$var$_isDate.default,
    isTime: $bad1c3ae594eb6ef$var$_isTime.default,
    isLicensePlate: $bad1c3ae594eb6ef$var$_isLicensePlate.default,
    isVAT: $bad1c3ae594eb6ef$var$_isVAT.default,
    ibanLocales: $bad1c3ae594eb6ef$var$_isIBAN.locales
};
var $bad1c3ae594eb6ef$var$_default = $bad1c3ae594eb6ef$exports.default = $bad1c3ae594eb6ef$var$validator;
$bad1c3ae594eb6ef$exports = $bad1c3ae594eb6ef$exports.default;
$bad1c3ae594eb6ef$exports.default = $bad1c3ae594eb6ef$exports.default;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}



var $8nd05 = parcelRequire("8nd05");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $8nd05.default)({}, otherProps, {
        ownerState: (0, $8nd05.default)({}, otherProps.ownerState, ownerState)
    });
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;



var $8nd05 = parcelRequire("8nd05");

var $9QePP = parcelRequire("9QePP");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $8nd05.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $8nd05.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)((0, $8nd05.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $8nd05.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $8nd05.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;


'use client';
const $aa69d7725f45330b$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $1En50.default)(parameters, $aa69d7725f45330b$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}

function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $1d88113360503233$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode
    });
});
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;




parcelRequire("acw62");

var $8NnpI = parcelRequire("8NnpI");

var $acw62 = parcelRequire("acw62");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
'use client';
function $3c4de721067b1c27$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $3c4de721067b1c27$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $eP9YU.T));
    return !contextTheme || $3c4de721067b1c27$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $3c4de721067b1c27$export$2e2bcd8739ae039 = $3c4de721067b1c27$var$useTheme;


'use client';
const $fd286b02fb568257$export$35e57303dbd8a66 = (0, $8NnpI.default)();
function $fd286b02fb568257$var$useTheme(defaultTheme = $fd286b02fb568257$export$35e57303dbd8a66) {
    return (0, $3c4de721067b1c27$export$2e2bcd8739ae039)(defaultTheme);
}
var $fd286b02fb568257$export$2e2bcd8739ae039 = $fd286b02fb568257$var$useTheme;



var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)((0, $jR9F1.default));
    return theme[0, $4jPsi.default] || theme;
}


const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}



'use client';
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $27fddc0219860a83$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e5a92158e7d9bd4$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $5e5a92158e7d9bd4$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $5e5a92158e7d9bd4$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4838e5a14e330013$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5c4c540114ae85ab$export$9927a91fd93152bd), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $1En50.default)(props, $4838e5a14e330013$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4838e5a14e330013$var$BackdropRoot, (0, $8nd05.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $9QePP.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $8nd05.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $71912e551e227707$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $71912e551e227707$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, show);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $0200cab69b9251c8$export$2e2bcd8739ae039)((0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$defaultManager = new (0, $52971d86e2bcd483$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $f86e7d122c1fa324$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $4c8156a231c9130b$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $acw62.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $52971d86e2bcd483$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $8nd05.default)({}, propsEventHandlers, otherHandlers);
        return (0, $8nd05.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $8nd05.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0bdcbfecdf3275a2$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $0cea91a79e26c98a$export$67960e22b12a638d), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $1En50.default)(props, $0bdcbfecdf3275a2$var$_excluded);
    const propsWithDefaults = (0, $8nd05.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $f86e7d122c1fa324$export$2e2bcd8739ae039)((0, $8nd05.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $8nd05.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0bdcbfecdf3275a2$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $8nd05.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $9QePP.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, (0, $8nd05.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, (0, $8nd05.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f30200a1e85b3f20$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");



var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}




var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $bmoVh = parcelRequire("bmoVh");




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $247ae09dccc3464c$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $beCSm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$export$2e2bcd8739ae039 = $247ae09dccc3464c$var$collapseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $848dc8709a4309c5$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $247ae09dccc3464c$export$5162da8f798e0959), classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $8nd05.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $bmoVh.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $848dc8709a4309c5$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseRoot, (0, $8nd05.default)({
                as: component,
                className: (0, $9QePP.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $8nd05.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $8nd05.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapper, {
                    ownerState: (0, $8nd05.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapperInner, {
                        ownerState: (0, $8nd05.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$export$2e2bcd8739ae039 = $848dc8709a4309c5$var$Collapse;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $23fa506264c010ed$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $23fa506264c010ed$export$2e2bcd8739ae039 = $23fa506264c010ed$var$getOverlayAlpha;



var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $595185d0d7275c3b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ec306d48089c2c9$export$29cdb466b9b6f20b), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $8nd05.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $8nd05.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $kTdcz.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $kTdcz.alpha)('#fff', (0, $23fa506264c010ed$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $1En50.default)(props, $595185d0d7275c3b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other));
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
var $5bbfcb95732dc207$export$2e2bcd8739ae039 = $5bbfcb95732dc207$var$AccordionContext;



var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $77aad105771eb889$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");




'use client';
const $49e8399bd2388464$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $49e8399bd2388464$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $49e8399bd2388464$var$_excluded3 = [
    "component"
];
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $1En50.default)(parameters, $49e8399bd2388464$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $1En50.default)(externalForwardedProps, $49e8399bd2388464$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $135391549c807611$export$2e2bcd8739ae039)((0, $8nd05.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $1En50.default)(_mergeSlotProps.props, $49e8399bd2388464$var$_excluded3);
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $8nd05.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, (0, $8nd05.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e14e8c767477d992$export$80fb6a2cb3f13b8b(slot) {
    return (0, $4Cod0.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $beCSm.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$export$2e2bcd8739ae039 = $e14e8c767477d992$var$accordionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5c228c234852d575$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e14e8c767477d992$export$80fb6a2cb3f13b8b), classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $e14e8c767477d992$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $e14e8c767477d992$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $1En50.default)(props, $5c228c234852d575$var$_excluded);
    const [expanded, setExpandedState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $8nd05.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $8nd05.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $848dc8709a4309c5$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5c228c234852d575$var$AccordionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5bbfcb95732dc207$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, (0, $8nd05.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $5c228c234852d575$export$2e2bcd8739ae039 = $5c228c234852d575$var$Accordion;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $7a3a319e7e555608$var$maybeReactUseId = $acw62['useId'.toString()];
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $032c0e7078a9cb7d$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $1En50.default)(props, $032c0e7078a9cb7d$var$_excluded);
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const heightRef = $acw62.useRef(null);
    const shadowRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $acw62.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", (0, $8nd05.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $8nd05.default)({}, $032c0e7078a9cb7d$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;


function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;



var $acw62 = parcelRequire("acw62");

'use client';
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $8426ae8303951a73$export$2e2bcd8739ae039));
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");


'use client';
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $aab859a020ad749e$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

parcelRequire("acw62");


var $aVZKi = parcelRequire("aVZKi");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $699894d3e78e9c81$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aVZKi.default), {
        styles: globalStyles
    });
}
var $699894d3e78e9c81$export$2e2bcd8739ae039 = $699894d3e78e9c81$var$GlobalStyles;



var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $699894d3e78e9c81$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    }));
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $69d1b2c99a8dc649$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $jTnBY.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9b9dde6aa920e08c$export$ef57d5c8ca2278f6), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $69d1b2c99a8dc649$export$a1ad29c901026019 = (0, $d8seH.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $8nd05.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $8nd05.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $69d1b2c99a8dc649$var$inputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03fc756f7adfd498$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $1En50.default)(props, $69d1b2c99a8dc649$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $8nd05.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $8nd05.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $032c0e7078a9cb7d$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$a1ad29c901026019;
    inputProps = (0, $8nd05.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $69d1b2c99a8dc649$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, (0, $8nd05.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $8nd05.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $8nd05.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $76910a07fd4ac4fe$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $80c774dd7f29b734$export$cdb270390122322b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $8nd05.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}, .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $76910a07fd4ac4fe$var$_excluded);
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bb335d5457c07f5b$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b0b42157daacd8b1$export$3331e419f1a48437), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $69d1b2c99a8dc649$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $8nd05.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}, .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $bb335d5457c07f5b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $746323a953600e78$var$_span;
const $746323a953600e78$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)('fieldset', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)('legend', {
    shouldForwardProp: (0, $8Uq77.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $8nd05.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $1En50.default)(props, $746323a953600e78$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $8nd05.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = (0, $8nd05.default)({}, (0, $9b9dde6aa920e08c$export$2e2bcd8739ae039), (0, $beCSm.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;




var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5d55d2dd82639e9$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6a1dc6d1d7e1816a$export$89922944c7227687), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $69d1b2c99a8dc649$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $8nd05.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).focused} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).error} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).disabled} .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $8nd05.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $746323a953600e78$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $69d1b2c99a8dc649$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $69d1b2c99a8dc649$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $1En50.default)(props, $d5d55d2dd82639e9$var$_excluded);
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5d55d2dd82639e9$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), (0, $8nd05.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d5d55d2dd82639e9$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $8nd05.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9b0ab7de0d37835d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c678fac155df4fc3$export$f7d501e40371cd17), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $1En50.default)(props, $9b0ab7de0d37835d$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;



var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09846a8ab0aba36e$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $9b0ab7de0d37835d$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c678fac155df4fc3$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $8nd05.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $8nd05.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $8nd05.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $1En50.default)(props, $09846a8ab0aba36e$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, (0, $8nd05.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $37dfa52af4926933$export$2e2bcd8739ae039);




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcd22a386c6068c0$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ce03a37a8cfb980d$export$149c8b8bab2289d1), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $8nd05.default)({}, styles.root, styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $bcd22a386c6068c0$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $1e4827e2a850b1f0$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $90a633ad7a979daa$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props, true) || (0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a46b344d341d82c0$export$a394fa61b1d583a9), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $a46b344d341d82c0$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $1En50.default)(props, $d23aa5c3ca6913fb$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $4c8156a231c9130b$export$2e2bcd8739ae039);



var $jTnBY = parcelRequire("jTnBY");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $889f7a05097f3e52$var$_excluded = [
    "value"
];
const $889f7a05097f3e52$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $889f7a05097f3e52$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $1En50.default)(_ref, $889f7a05097f3e52$var$_excluded);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($889f7a05097f3e52$var$RtlContext.Provider, (0, $8nd05.default)({
        value: value != null ? value : true
    }, props));
}
const $889f7a05097f3e52$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($889f7a05097f3e52$var$RtlContext);
    return value != null ? value : false;
};
var $889f7a05097f3e52$export$2e2bcd8739ae039 = $889f7a05097f3e52$var$RtlProvider;




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $640cd381f5e8b3ea$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $adbbc5717e0d0350$export$c6bd6795ed6e3203), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $1En50.default)(props, $640cd381f5e8b3ea$var$_excluded);
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;



var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $0200cab69b9251c8$export$2e2bcd8739ae039);





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fbb3fa0cdc277971$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $1En50.default)(props, $fbb3fa0cdc277971$var$_excluded);
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $0d80e79907b6bdbc$export$2e2bcd8739ae039)((0, $c10afe25107351d9$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");








var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039);




var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $71912e551e227707$export$2e2bcd8739ae039);




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");









var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d6f4882a3b1c59f2$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $d6f4882a3b1c59f2$var$_excluded);
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                style: (0, $8nd05.default)({
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $d6f4882a3b1c59f2$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;





var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $012baef8dc9ae9d0$var$_excluded = [
    "onEntering"
], $012baef8dc9ae9d0$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $012baef8dc9ae9d0$var$_excluded3 = [
    "slotProps"
];
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ea2c25a800e729b1$export$88f455dd56c95edb), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $012baef8dc9ae9d0$var$_excluded), other = (0, $1En50.default)(props, $012baef8dc9ae9d0$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $acw62.useRef();
    const handlePaperRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $8nd05.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $c10afe25107351d9$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $c10afe25107351d9$export$2e2bcd8739ae039)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $012baef8dc9ae9d0$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $012baef8dc9ae9d0$export$821346c38a2d9390;
    const paperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $8nd05.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $8nd05.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $1En50.default)(_useSlotProps, $012baef8dc9ae9d0$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, (0, $8nd05.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $364f3db28d8d2e79$var$_excluded = [
    "onEntering"
], $364f3db28d8d2e79$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fb1e7d0ac8fac824$export$2cf86a63a84fe23d), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $012baef8dc9ae9d0$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $fbb3fa0cdc277971$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $1En50.default)(props.TransitionProps, $364f3db28d8d2e79$var$_excluded), other = (0, $1En50.default)(props, $364f3db28d8d2e79$var$_excluded2);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $364f3db28d8d2e79$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, (0, $8nd05.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $8nd05.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuMenuList, (0, $8nd05.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $9QePP.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;



var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db2c454fb2e8bc3c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $49a1663d7631a8fa$export$1ee13051fd9e2ab5), classes);
};
const $db2c454fb2e8bc3c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $8nd05.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($db2c454fb2e8bc3c$export$c1eccd1617458c87);
const $db2c454fb2e8bc3c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $49a1663d7631a8fa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($db2c454fb2e8bc3c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $db2c454fb2e8bc3c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, (0, $8nd05.default)({
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;




var $d8seH = parcelRequire("d8seH");
var $PJRTc = parcelRequire("PJRTc");



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $db2c454fb2e8bc3c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $844e08aea9053c4b$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $db2c454fb2e8bc3c$export$e7a817afd12a40d0));
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $844e08aea9053c4b$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $1En50.default)(props, $8bd650259be885cb$var$_excluded);
    const [value, setValueState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $1e4827e2a850b1f0$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = (0, $8nd05.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, (0, $8nd05.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, (0, $8nd05.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $364f3db28d8d2e79$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $8nd05.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $8nd05.default)({}, MenuProps.slotProps, {
                    paper: (0, $8nd05.default)({}, paperProps, {
                        style: (0, $8nd05.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;




parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $1iOpW = parcelRequire("1iOpW");


var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96e1233e8d06bb2d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $96e1233e8d06bb2d$var$_excluded2 = [
    "root"
];
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $76910a07fd4ac4fe$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $d5d55d2dd82639e9$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $bb335d5457c07f5b$export$2e2bcd8739ae039), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $1En50.default)(props, $96e1233e8d06bb2d$var$_excluded);
    const inputComponent = native ? (0, $db2c454fb2e8bc3c$export$2e2bcd8739ae039) : (0, $8bd650259be885cb$export$2e2bcd8739ae039);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $1En50.default)(classes, $96e1233e8d06bb2d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, (0, $1d88113360503233$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, (0, $8nd05.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $8nd05.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $8nd05.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d8826083c5af4ea7$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $76910a07fd4ac4fe$export$2e2bcd8739ae039),
    filled: (0, $bb335d5457c07f5b$export$2e2bcd8739ae039),
    outlined: (0, $d5d55d2dd82639e9$export$2e2bcd8739ae039)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $25a6b464d3ca38da$export$c1bdcbaf0596aeda), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $1En50.default)(props, $d8826083c5af4ea7$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputComponent, (0, $8nd05.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d8826083c5af4ea7$var$TextFieldRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), (0, $8nd05.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $6hiu6 = parcelRequire("6hiu6");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2531239e3a525689$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $837556bdf75d281f$export$24c1f8f60cbac79e), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $2531239e3a525689$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $2531239e3a525689$var$transformDeprecatedColors = (color)=>{
    return $2531239e3a525689$var$colorTransformations[color] || color;
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $2531239e3a525689$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $6hiu6.default)((0, $8nd05.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping } = props, other = (0, $1En50.default)(props, $2531239e3a525689$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, (0, $8nd05.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other));
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;


// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $3195bad5b20c0860$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


var $dee3edaff9a60012$var$objectConstructor = {}.constructor;
function $dee3edaff9a60012$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $dee3edaff9a60012$var$objectConstructor;
}


function $9e438765c352ad8a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9e438765c352ad8a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9e438765c352ad8a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9e438765c352ad8a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9e438765c352ad8a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9e438765c352ad8a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9e438765c352ad8a$var$_slicedToArray(arr, i) {
    return $9e438765c352ad8a$var$_arrayWithHoles(arr) || $9e438765c352ad8a$var$_iterableToArrayLimit(arr, i) || $9e438765c352ad8a$var$_unsupportedIterableToArray(arr, i) || $9e438765c352ad8a$var$_nonIterableRest();
}
function $9e438765c352ad8a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e438765c352ad8a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e438765c352ad8a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e438765c352ad8a$var$_arrayLikeToArray(o, minLen);
}
function $9e438765c352ad8a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e438765c352ad8a$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9e438765c352ad8a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9e438765c352ad8a$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $9e438765c352ad8a$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === 'string') text = arg_1;
    else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $9e438765c352ad8a$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $dee3edaff9a60012$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $caa639c664fc3f13$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $caa639c664fc3f13$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $caa639c664fc3f13$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $caa639c664fc3f13$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $caa639c664fc3f13$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $caa639c664fc3f13$var$SLASHES = "\uFF0F/";
var $caa639c664fc3f13$var$DOTS = "\uFF0E.";
var $caa639c664fc3f13$export$20542845033f576e = " \xA0\xAD\u200B\u2060\u3000";
var $caa639c664fc3f13$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $caa639c664fc3f13$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $caa639c664fc3f13$export$7f01587e28f9194 = "".concat($caa639c664fc3f13$var$DASHES).concat($caa639c664fc3f13$var$SLASHES).concat($caa639c664fc3f13$var$DOTS).concat($caa639c664fc3f13$export$20542845033f576e).concat($caa639c664fc3f13$var$BRACKETS).concat($caa639c664fc3f13$var$TILDES);
var $caa639c664fc3f13$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $1024cdac75ec2b33$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1024cdac75ec2b33$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1024cdac75ec2b33$var$_typeof(obj);
}
function $1024cdac75ec2b33$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1024cdac75ec2b33$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1024cdac75ec2b33$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1024cdac75ec2b33$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1024cdac75ec2b33$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1024cdac75ec2b33$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1024cdac75ec2b33$var$_setPrototypeOf(subClass, superClass);
}
function $1024cdac75ec2b33$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1024cdac75ec2b33$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1024cdac75ec2b33$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1024cdac75ec2b33$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1024cdac75ec2b33$var$_possibleConstructorReturn(this, result);
    };
}
function $1024cdac75ec2b33$var$_possibleConstructorReturn(self, call) {
    if (call && ($1024cdac75ec2b33$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1024cdac75ec2b33$var$_assertThisInitialized(self);
}
function $1024cdac75ec2b33$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1024cdac75ec2b33$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $1024cdac75ec2b33$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$1024cdac75ec2b33$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $1024cdac75ec2b33$var$_construct(Class, arguments, $1024cdac75ec2b33$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $1024cdac75ec2b33$var$_setPrototypeOf(Wrapper, Class);
    };
    return $1024cdac75ec2b33$var$_wrapNativeSuper(Class);
}
function $1024cdac75ec2b33$var$_construct(Parent, args, Class) {
    if ($1024cdac75ec2b33$var$_isNativeReflectConstruct()) $1024cdac75ec2b33$var$_construct = Reflect.construct;
    else $1024cdac75ec2b33$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $1024cdac75ec2b33$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $1024cdac75ec2b33$var$_construct.apply(null, arguments);
}
function $1024cdac75ec2b33$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1024cdac75ec2b33$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $1024cdac75ec2b33$var$_setPrototypeOf(o, p) {
    $1024cdac75ec2b33$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1024cdac75ec2b33$var$_setPrototypeOf(o, p);
}
function $1024cdac75ec2b33$var$_getPrototypeOf(o) {
    $1024cdac75ec2b33$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1024cdac75ec2b33$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $1024cdac75ec2b33$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $1024cdac75ec2b33$var$_inherits(ParseError, _Error);
    var _super = $1024cdac75ec2b33$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $1024cdac75ec2b33$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($1024cdac75ec2b33$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $1024cdac75ec2b33$var$_createClass(ParseError);
}(/*#__PURE__*/ $1024cdac75ec2b33$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $186afb3191e0d707$export$2e2bcd8739ae039(a, b) {
    a = a.split('-');
    b = b.split('-');
    var pa = a[0].split('.');
    var pb = b[0].split('.');
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $f80aac35004a54c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f80aac35004a54c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f80aac35004a54c3$var$_typeof(obj);
}
function $f80aac35004a54c3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f80aac35004a54c3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f80aac35004a54c3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f80aac35004a54c3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f80aac35004a54c3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $f80aac35004a54c3$var$V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".
var $f80aac35004a54c3$var$V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.
var $f80aac35004a54c3$var$V4 = '1.7.35';
var $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX = ' ext. ';
var $f80aac35004a54c3$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $f80aac35004a54c3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Metadata);
        $f80aac35004a54c3$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $f80aac35004a54c3$var$setVersion.call(this, metadata);
    }
    $f80aac35004a54c3$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== '001';
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $f80aac35004a54c3$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== '001') {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $f80aac35004a54c3$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $f80aac35004a54c3$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') return this.metadata.countries['001'];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $f80aac35004a54c3$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $f80aac35004a54c3$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $f80aac35004a54c3$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $f80aac35004a54c3$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $f80aac35004a54c3$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $f80aac35004a54c3$var$getType(this.types(), _type2)) return new $f80aac35004a54c3$var$Type($f80aac35004a54c3$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $f80aac35004a54c3$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $f80aac35004a54c3$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$f80aac35004a54c3$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $f80aac35004a54c3$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $f80aac35004a54c3$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $f80aac35004a54c3$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $f80aac35004a54c3$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $f80aac35004a54c3$var$getType(types, type) {
    switch(type){
        case 'FIXED_LINE':
            return types[0];
        case 'MOBILE':
            return types[1];
        case 'TOLL_FREE':
            return types[2];
        case 'PREMIUM_RATE':
            return types[3];
        case 'PERSONAL_NUMBER':
            return types[4];
        case 'VOICEMAIL':
            return types[5];
        case 'UAN':
            return types[6];
        case 'PAGER':
            return types[7];
        case 'VOIP':
            return types[8];
        case 'SHARED_COST':
            return types[9];
    }
}
function $f80aac35004a54c3$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
     // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $dee3edaff9a60012$export$2e2bcd8739ae039)(metadata) || !(0, $dee3edaff9a60012$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $dee3edaff9a60012$export$2e2bcd8739ae039)(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + $f80aac35004a54c3$var$typeOf(metadata) + ': ' + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $f80aac35004a54c3$var$typeOf = function typeOf(_) {
    return $f80aac35004a54c3$var$_typeof(_);
};
function $f80aac35004a54c3$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $f80aac35004a54c3$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $f80aac35004a54c3$var$DEFAULT_EXT_PREFIX;
}
function $f80aac35004a54c3$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $f80aac35004a54c3$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $f80aac35004a54c3$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $f80aac35004a54c3$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $186afb3191e0d707$export$2e2bcd8739ae039)(version, $f80aac35004a54c3$var$V3) === -1) this.v2 = true;
        else if ((0, $186afb3191e0d707$export$2e2bcd8739ae039)(version, $f80aac35004a54c3$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $c5309573f87def67$var$RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $c5309573f87def67$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $caa639c664fc3f13$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $c5309573f87def67$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = '20';
    /** @type {string} */ var extLimitAfterLikelyLabel = '15';
    /** @type {string} */ var extLimitAfterAmbiguousChar = '9';
    /** @type {string} */ var extLimitWhenNotSure = '6';
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $c5309573f87def67$var$RFC3966_EXTN_PREFIX + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $c5309573f87def67$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $4e8c00bca37e184a$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']{' + (0, $caa639c664fc3f13$export$cd8355bcbe13154) + '}'; //
var $4e8c00bca37e184a$export$a77dd7471651eee = '[' + (0, $caa639c664fc3f13$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + ']*' + '[' + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']' + '){3,}' + '[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $caa639c664fc3f13$export$207c99ccf3902df8) + ']{0,1}' + '(?:' + '[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + ']*' + '[' + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']' + '){1,2}' + '$', 'i');
var $4e8c00bca37e184a$export$a2d12a04749c087d = $4e8c00bca37e184a$export$a77dd7471651eee + // Phone number extensions
'(?:' + (0, $c5309573f87def67$export$2e2bcd8739ae039)() + ')?'; // The combined regular expression for valid phone numbers:
//
var $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + $4e8c00bca37e184a$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + $4e8c00bca37e184a$export$a2d12a04749c087d + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
function $4e8c00bca37e184a$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $caa639c664fc3f13$export$cd8355bcbe13154) && $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $4e8c00bca37e184a$export$4c3f76c95c05197c(number) {
    return $4e8c00bca37e184a$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $7592affeb0e135a4$var$EXTN_PATTERN = new RegExp('(?:' + (0, $c5309573f87def67$export$2e2bcd8739ae039)() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
function $7592affeb0e135a4$export$2e2bcd8739ae039(number) {
    var start = number.search($7592affeb0e135a4$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($7592affeb0e135a4$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $b28b7cc57bbfdda6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b28b7cc57bbfdda6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b28b7cc57bbfdda6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b28b7cc57bbfdda6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b28b7cc57bbfdda6$var$_arrayLikeToArray(o, minLen);
}
function $b28b7cc57bbfdda6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $b28b7cc57bbfdda6$export$2848f3d68c08fe69 = {
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    "\uFF10": '0',
    // Fullwidth digit 0
    "\uFF11": '1',
    // Fullwidth digit 1
    "\uFF12": '2',
    // Fullwidth digit 2
    "\uFF13": '3',
    // Fullwidth digit 3
    "\uFF14": '4',
    // Fullwidth digit 4
    "\uFF15": '5',
    // Fullwidth digit 5
    "\uFF16": '6',
    // Fullwidth digit 6
    "\uFF17": '7',
    // Fullwidth digit 7
    "\uFF18": '8',
    // Fullwidth digit 8
    "\uFF19": '9',
    // Fullwidth digit 9
    "\u0660": '0',
    // Arabic-indic digit 0
    "\u0661": '1',
    // Arabic-indic digit 1
    "\u0662": '2',
    // Arabic-indic digit 2
    "\u0663": '3',
    // Arabic-indic digit 3
    "\u0664": '4',
    // Arabic-indic digit 4
    "\u0665": '5',
    // Arabic-indic digit 5
    "\u0666": '6',
    // Arabic-indic digit 6
    "\u0667": '7',
    // Arabic-indic digit 7
    "\u0668": '8',
    // Arabic-indic digit 8
    "\u0669": '9',
    // Arabic-indic digit 9
    "\u06F0": '0',
    // Eastern-Arabic digit 0
    "\u06F1": '1',
    // Eastern-Arabic digit 1
    "\u06F2": '2',
    // Eastern-Arabic digit 2
    "\u06F3": '3',
    // Eastern-Arabic digit 3
    "\u06F4": '4',
    // Eastern-Arabic digit 4
    "\u06F5": '5',
    // Eastern-Arabic digit 5
    "\u06F6": '6',
    // Eastern-Arabic digit 6
    "\u06F7": '7',
    // Eastern-Arabic digit 7
    "\u06F8": '8',
    // Eastern-Arabic digit 8
    "\u06F9": '9' // Eastern-Arabic digit 9
};
function $b28b7cc57bbfdda6$export$1d16fddea1437169(character) {
    return $b28b7cc57bbfdda6$export$2848f3d68c08fe69[character];
}
function $b28b7cc57bbfdda6$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $b28b7cc57bbfdda6$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $b28b7cc57bbfdda6$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $5d722be4de9b0760$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5d722be4de9b0760$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5d722be4de9b0760$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5d722be4de9b0760$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5d722be4de9b0760$var$_arrayLikeToArray(o, minLen);
}
function $5d722be4de9b0760$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5d722be4de9b0760$export$2e2bcd8739ae039(string) {
    var result = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $5d722be4de9b0760$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $5d722be4de9b0760$export$13d8790d7fb84c28(character, result) || '';
    }
    return result;
}
function $5d722be4de9b0760$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === '+') {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === 'function') emitEvent('end');
            return;
        }
        return '+';
    } // Allow digits.
    return (0, $b28b7cc57bbfdda6$export$1d16fddea1437169)(character);
}




function $0981b63057bf1955$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0981b63057bf1955$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0981b63057bf1955$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0981b63057bf1955$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0981b63057bf1955$var$_arrayLikeToArray(o, minLen);
}
function $0981b63057bf1955$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0981b63057bf1955$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $0981b63057bf1955$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $e150d39adca76f23$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return 'IS_POSSIBLE';
    if (type === 'FIXED_LINE_OR_MOBILE') {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type('FIXED_LINE')) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $e150d39adca76f23$export$69333f603c7d5931(nationalNumber, 'MOBILE', metadata);
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $0981b63057bf1955$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return 'INVALID_LENGTH';
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return 'IS_POSSIBLE';
    if (minimum_length > actual_length) return 'TOO_SHORT';
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return 'TOO_LONG';
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}


function $1fb3749e6a970dcc$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error('Invalid phone number object passed');
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $1fb3749e6a970dcc$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $1fb3749e6a970dcc$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $e150d39adca76f23$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'IS_POSSIBLE':
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $e3bd2e2fc8506edb$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || '';
    return new RegExp('^(?:' + regular_expression + ')$').test(text);
}




function $1bfc4a83ba58b3fa$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $1bfc4a83ba58b3fa$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1bfc4a83ba58b3fa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1bfc4a83ba58b3fa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1bfc4a83ba58b3fa$var$_arrayLikeToArray(o, minLen);
}
function $1bfc4a83ba58b3fa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $1bfc4a83ba58b3fa$var$NON_FIXED_LINE_PHONE_TYPES = [
    'MOBILE',
    'PREMIUM_RATE',
    'TOLL_FREE',
    'SHARED_COST',
    'VOIP',
    'PERSONAL_NUMBER',
    'PAGER',
    'UAN',
    'VOICEMAIL'
]; // Finds out national phone number type (fixed line, mobile, etc)
function $1bfc4a83ba58b3fa$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, 'FIXED_LINE', metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') return 'FIXED_LINE_OR_MOBILE';
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type('MOBILE')) return 'FIXED_LINE_OR_MOBILE';
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, 'MOBILE', metadata)) return 'FIXED_LINE_OR_MOBILE';
        return 'FIXED_LINE';
    }
    for(var _iterator = $1bfc4a83ba58b3fa$var$_createForOfIteratorHelperLoose($1bfc4a83ba58b3fa$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $1bfc4a83ba58b3fa$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $0d191497cc70e02d$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $1bfc4a83ba58b3fa$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $e87b5e5a63f1114a$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $e87b5e5a63f1114a$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $e87b5e5a63f1114a$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




var $fe72b81dc9349c1d$var$CAPTURING_DIGIT_PATTERN = new RegExp('([' + (0, $caa639c664fc3f13$export$852d1d4a47329634) + '])');
function $fe72b81dc9349c1d$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($fe72b81dc9349c1d$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $599ebbe585179a66$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $fdffd8ab78eb7a6a$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $599ebbe585179a66$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$fdffd8ab78eb7a6a$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$fdffd8ab78eb7a6a$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $fdffd8ab78eb7a6a$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $fdffd8ab78eb7a6a$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $e150d39adca76f23$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $4c6da243f5876ae1$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $fdffd8ab78eb7a6a$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $fdffd8ab78eb7a6a$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $e150d39adca76f23$export$2e2bcd8739ae039)(nationalNumber, metadata) === 'TOO_LONG') return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $f54cbb82e68a0281$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== '+') {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $fe72b81dc9349c1d$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = '+' + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $4c6da243f5876ae1$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === '0') return {};
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $caa639c664fc3f13$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }





function $102fa0905276e10f$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $caa639c664fc3f13$export$7f01587e28f9194), "]+"), 'g'), ' ').trim();
}


var $958c47b8ffb0646a$export$4f32ad1c51a7a6be = /(\$\d)/;
function $958c47b8ffb0646a$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($958c47b8ffb0646a$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $102fa0905276e10f$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $9970fd541d189be2$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $9970fd541d189be2$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($9970fd541d189be2$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $946307579c3e17b5$var$_slicedToArray(arr, i) {
    return $946307579c3e17b5$var$_arrayWithHoles(arr) || $946307579c3e17b5$var$_iterableToArrayLimit(arr, i) || $946307579c3e17b5$var$_unsupportedIterableToArray(arr, i) || $946307579c3e17b5$var$_nonIterableRest();
}
function $946307579c3e17b5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $946307579c3e17b5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $946307579c3e17b5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $946307579c3e17b5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $946307579c3e17b5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $946307579c3e17b5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $946307579c3e17b5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $946307579c3e17b5$var$_arrayLikeToArray(o, minLen);
}
function $946307579c3e17b5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $946307579c3e17b5$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, 'tel=');
    for(var _iterator = $946307579c3e17b5$var$_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split('='), _part$split2 = $946307579c3e17b5$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case 'tel':
                number = value;
                break;
            case 'ext':
                ext = value;
                break;
            case 'phone-context':
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === '+') number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $4e8c00bca37e184a$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $946307579c3e17b5$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return '';
    if (number[0] !== '+') throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
    return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}


function $42e9d0c72bf602b5$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $42e9d0c72bf602b5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $42e9d0c72bf602b5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $42e9d0c72bf602b5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $42e9d0c72bf602b5$var$_arrayLikeToArray(o, minLen);
}
function $42e9d0c72bf602b5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $42e9d0c72bf602b5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $42e9d0c72bf602b5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $42e9d0c72bf602b5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $42e9d0c72bf602b5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $42e9d0c72bf602b5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $42e9d0c72bf602b5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $42e9d0c72bf602b5$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $42e9d0c72bf602b5$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $42e9d0c72bf602b5$var$_objectSpread($42e9d0c72bf602b5$var$_objectSpread({}, $42e9d0c72bf602b5$var$DEFAULT_OPTIONS), options);
    else options = $42e9d0c72bf602b5$var$DEFAULT_OPTIONS;
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== '001') {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || '';
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case 'NATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return '';
            number = $42e9d0c72bf602b5$var$formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
            return $42e9d0c72bf602b5$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $42e9d0c72bf602b5$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $42e9d0c72bf602b5$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
            return (0, $946307579c3e17b5$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case 'IDD':
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $42e9d0c72bf602b5$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $42e9d0c72bf602b5$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
    }
}
function $42e9d0c72bf602b5$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $42e9d0c72bf602b5$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $958c47b8ffb0646a$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $42e9d0c72bf602b5$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $42e9d0c72bf602b5$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $42e9d0c72bf602b5$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $42e9d0c72bf602b5$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $42e9d0c72bf602b5$var$formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === '1') return countryCallingCode + ' ' + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $9970fd541d189be2$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($42e9d0c72bf602b5$var$formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
}


function $25295587638b13c7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $25295587638b13c7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $25295587638b13c7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $25295587638b13c7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $25295587638b13c7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $25295587638b13c7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25295587638b13c7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $25295587638b13c7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $25295587638b13c7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $25295587638b13c7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $25295587638b13c7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $25295587638b13c7$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $25295587638b13c7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $25295587638b13c7$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError('First argument is required');
        if (typeof countryOrCountryCallingCode !== 'string') throw new TypeError('First argument must be a string');
         // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (typeof countryOrCountryCallingCode === 'string') {
            if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) throw new TypeError('`metadata` argument not passed');
            if ((0, $dee3edaff9a60012$export$2e2bcd8739ae039)(nationalNumber) && (0, $dee3edaff9a60012$export$2e2bcd8739ae039)(nationalNumber.countries)) {
                metadata = nationalNumber;
                var e164Number = countryOrCountryCallingCode;
                if (!$25295587638b13c7$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
                var _extractCountryCallin = (0, $f54cbb82e68a0281$export$2e2bcd8739ae039)(e164Number, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                nationalNumber = number;
                countryOrCountryCallingCode = _countryCallingCode;
                if (!nationalNumber) throw new Error('Invalid `number` argument passed: too short');
            }
        } // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError('`nationalNumber` argument is required');
        if (typeof nationalNumber !== 'string') throw new TypeError('`nationalNumber` argument must be a string');
         // Validate `metadata` argument.
        (0, $f80aac35004a54c3$export$a0b100d4662a8795)(metadata); // Initialize properties.
        var _getCountryAndCountry = $25295587638b13c7$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $25295587638b13c7$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $e87b5e5a63f1114a$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $1fb3749e6a970dcc$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $0d191497cc70e02d$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $1bfc4a83ba58b3fa$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $42e9d0c72bf602b5$export$2e2bcd8739ae039)(this, _format, options ? $25295587638b13c7$var$_objectSpread($25295587638b13c7$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format('NATIONAL', options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format('INTERNATIONAL', options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format('RFC3966', options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $25295587638b13c7$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $25295587638b13c7$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($25295587638b13c7$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($25295587638b13c7$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = '001';
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $25295587638b13c7$var$E164_NUMBER_REGEXP = /^\+\d+$/;








function $67e4fba183b60e52$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $67e4fba183b60e52$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $67e4fba183b60e52$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $67e4fba183b60e52$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $67e4fba183b60e52$var$_arrayLikeToArray(o, minLen);
}
function $67e4fba183b60e52$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $67e4fba183b60e52$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $67e4fba183b60e52$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $1bfc4a83ba58b3fa$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $292282cd70c66425$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $292282cd70c66425$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($292282cd70c66425$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return '001';
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $67e4fba183b60e52$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $8b1ad0c6c5572892$export$1ddc7eed78155f68 = '+';
var $8b1ad0c6c5572892$var$RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var $8b1ad0c6c5572892$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']' + '|' + $8b1ad0c6c5572892$var$RFC3966_VISUAL_SEPARATOR_ + ')';
var $8b1ad0c6c5572892$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $8b1ad0c6c5572892$export$1ddc7eed78155f68 + $8b1ad0c6c5572892$var$RFC3966_PHONE_DIGIT_ + '*' + '[' + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']' + $8b1ad0c6c5572892$var$RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $8b1ad0c6c5572892$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($8b1ad0c6c5572892$var$RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $8b1ad0c6c5572892$var$ALPHANUM_ = (0, $caa639c664fc3f13$export$852d1d4a47329634);
var $8b1ad0c6c5572892$var$RFC3966_DOMAINLABEL_ = '[' + $8b1ad0c6c5572892$var$ALPHANUM_ + ']+((\\-)*[' + $8b1ad0c6c5572892$var$ALPHANUM_ + '])*';
var $8b1ad0c6c5572892$var$VALID_ALPHA_ = 'a-zA-Z';
var $8b1ad0c6c5572892$var$RFC3966_TOPLABEL_ = '[' + $8b1ad0c6c5572892$var$VALID_ALPHA_ + ']+((\\-)*[' + $8b1ad0c6c5572892$var$ALPHANUM_ + '])*';
var $8b1ad0c6c5572892$var$RFC3966_DOMAINNAME_ = '^(' + $8b1ad0c6c5572892$var$RFC3966_DOMAINLABEL_ + '\\.)*' + $8b1ad0c6c5572892$var$RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $8b1ad0c6c5572892$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($8b1ad0c6c5572892$var$RFC3966_DOMAINNAME_, 'g');
var $8b1ad0c6c5572892$export$70d485ce3f6de783 = 'tel:';
var $8b1ad0c6c5572892$export$f6d5879d582c3a27 = ';phone-context=';
var $8b1ad0c6c5572892$export$9e356e12edb00a81 = ';isub=';
function $8b1ad0c6c5572892$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($8b1ad0c6c5572892$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $8b1ad0c6c5572892$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return '';
    var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $8b1ad0c6c5572892$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $8b1ad0c6c5572892$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $8b1ad0c6c5572892$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $0cdb7b8f4c21e427$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $8b1ad0c6c5572892$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $8b1ad0c6c5572892$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('NOT_A_NUMBER');
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
    else {
        phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $8b1ad0c6c5572892$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $8b1ad0c6c5572892$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $8b1ad0c6c5572892$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $8b1ad0c6c5572892$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $8b1ad0c6c5572892$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== '') return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $14d3f7a95f38bf90$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $14d3f7a95f38bf90$var$PHONE_NUMBER_START_PATTERN = new RegExp('[' + (0, $caa639c664fc3f13$export$207c99ccf3902df8) + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $14d3f7a95f38bf90$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + (0, $caa639c664fc3f13$export$852d1d4a47329634) + '#' + ']+$');
var $14d3f7a95f38bf90$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $14d3f7a95f38bf90$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $14d3f7a95f38bf90$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === 'TOO_SHORT') throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('TOO_SHORT');
            throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('NOT_A_NUMBER');
        }
        return {};
    }
    var _parsePhoneNumber = $14d3f7a95f38bf90$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('INVALID_COUNTRY');
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $caa639c664fc3f13$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('TOO_SHORT');
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $caa639c664fc3f13$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('TOO_LONG');
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $25295587638b13c7$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $e3bd2e2fc8506edb$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $14d3f7a95f38bf90$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $1fb3749e6a970dcc$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $14d3f7a95f38bf90$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $14d3f7a95f38bf90$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)('TOO_LONG');
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($14d3f7a95f38bf90$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($14d3f7a95f38bf90$var$AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $14d3f7a95f38bf90$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $0cdb7b8f4c21e427$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $14d3f7a95f38bf90$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $4e8c00bca37e184a$export$2e2bcd8739ae039)(number)) {
        if ((0, $4e8c00bca37e184a$export$4c3f76c95c05197c)(number)) return {
            error: 'TOO_SHORT'
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $7592affeb0e135a4$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $14d3f7a95f38bf90$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $14d3f7a95f38bf90$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $f54cbb82e68a0281$export$2e2bcd8739ae039)((0, $5d722be4de9b0760$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($14d3f7a95f38bf90$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = '001';
            }
        }
        countryCallingCode = defaultCallingCode || (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $fdffd8ab78eb7a6a$export$2e2bcd8739ae039)((0, $5d722be4de9b0760$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $292282cd70c66425$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === '001') ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $bdcbe04d95094f3d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bdcbe04d95094f3d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bdcbe04d95094f3d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bdcbe04d95094f3d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bdcbe04d95094f3d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bdcbe04d95094f3d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bdcbe04d95094f3d$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $14d3f7a95f38bf90$export$2e2bcd8739ae039)(text, $bdcbe04d95094f3d$var$_objectSpread($bdcbe04d95094f3d$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $7d413597caf73a03$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7d413597caf73a03$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7d413597caf73a03$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7d413597caf73a03$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7d413597caf73a03$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7d413597caf73a03$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d413597caf73a03$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $f80aac35004a54c3$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $7d413597caf73a03$var$_objectSpread($7d413597caf73a03$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $bdcbe04d95094f3d$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $1024cdac75ec2b33$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $fe2783d9f9ccca74$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $9e438765c352ad8a$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $7d413597caf73a03$export$2e2bcd8739ae039)(text, options, metadata);
}


function $dfa9013f08ee2b8a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dfa9013f08ee2b8a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dfa9013f08ee2b8a$var$_typeof(o);
}
function $dfa9013f08ee2b8a$export$2e2bcd8739ae039(value, format, metadata) {
    if (!metadata) {
        if ($dfa9013f08ee2b8a$var$_typeof(format) === 'object') {
            metadata = format;
            format = 'NATIONAL';
        }
    }
    if (!value) return '';
    var phoneNumber = (0, $fe2783d9f9ccca74$export$2e2bcd8739ae039)(value, metadata);
    if (!phoneNumber) return '';
    // Deprecated.
    // Legacy `format`s.
    switch(format){
        case 'National':
            format = 'NATIONAL';
            break;
        case 'International':
            format = 'INTERNATIONAL';
            break;
    }
    return phoneNumber.format(format);
}
function $dfa9013f08ee2b8a$export$88012462592bc004(value, metadata) {
    return $dfa9013f08ee2b8a$export$2e2bcd8739ae039(value, 'INTERNATIONAL', metadata);
}


function $34c4bee83c07f6dd$export$2e2bcd8739ae039(metadata) {
    return new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata).getCountries();
}



function $6451538427aaf2b0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6451538427aaf2b0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6451538427aaf2b0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6451538427aaf2b0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6451538427aaf2b0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6451538427aaf2b0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6451538427aaf2b0$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $9e438765c352ad8a$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $6451538427aaf2b0$var$_objectSpread($6451538427aaf2b0$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $7d413597caf73a03$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isPossible() || false;
}



function $bbd8ac01a56cfc98$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbd8ac01a56cfc98$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbd8ac01a56cfc98$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bbd8ac01a56cfc98$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbd8ac01a56cfc98$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbd8ac01a56cfc98$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbd8ac01a56cfc98$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $9e438765c352ad8a$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $bbd8ac01a56cfc98$var$_objectSpread($bbd8ac01a56cfc98$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $7d413597caf73a03$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");


function $f63e1671b767c734$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f63e1671b767c734$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f63e1671b767c734$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f63e1671b767c734$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f63e1671b767c734$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//
var $f63e1671b767c734$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $f63e1671b767c734$var$_classCallCheck(this, AsYouTypeState);
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $f63e1671b767c734$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(_ref2) {
                var country = _ref2.country, callingCode = _ref2.callingCode;
                this.international = false;
                this.missingPlus = false;
                this.IDDPrefix = undefined;
                this.callingCode = undefined;
                this.digits = '';
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "update",
            value: function update(properties) {
                for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                    var key = _Object$keys[_i];
                    this[key] = properties[key];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                this.onCallingCodeChange(callingCode, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(country, callingCode) {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();


function $fe74fd6609d199cf$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fe74fd6609d199cf$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fe74fd6609d199cf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fe74fd6609d199cf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fe74fd6609d199cf$var$_arrayLikeToArray(o, minLen);
}
function $fe74fd6609d199cf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $fe74fd6609d199cf$export$2a0174a7c311f338 = 'x'; // '\u2008' (punctuation space)
var $fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($fe74fd6609d199cf$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $fe74fd6609d199cf$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = $fe74fd6609d199cf$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $fe74fd6609d199cf$export$76d90c956114f2c2(string, times) {
    if (times < 1) return '';
    var result = '';
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $fe74fd6609d199cf$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ')') cutBeforeIndex++;
    return $fe74fd6609d199cf$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $fe74fd6609d199cf$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $fe74fd6609d199cf$export$af0de81b5898251d('(', retained_template);
    var closing_braces = $fe74fd6609d199cf$export$af0de81b5898251d(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $fe74fd6609d199cf$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === '(') dangling_braces.push(i);
        else if (string[i] === ')') dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = '';
    dangling_braces.push(string.length);
    for(var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++){
        var index = _dangling_braces[_i];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $fe74fd6609d199cf$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = $fe74fd6609d199cf$var$_createForOfIteratorHelperLoose(digits.split('')), _step2; !(_step2 = _iterator2()).done;){
        var digit = _step2.value;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($fe74fd6609d199cf$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}





function $2ee6f7e5d3aef803$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $2ee6f7e5d3aef803$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $2ee6f7e5d3aef803$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $e150d39adca76f23$export$2e2bcd8739ae039)(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}
function $2ee6f7e5d3aef803$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $2ee6f7e5d3aef803$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $958c47b8ffb0646a$export$2e2bcd8739ae039)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
    if ($2ee6f7e5d3aef803$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $2ee6f7e5d3aef803$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $b28b7cc57bbfdda6$export$2e2bcd8739ae039)(formattedNationalNumber) === state.getNationalDigits();
}


function $7b7fb9365e469673$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7b7fb9365e469673$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7b7fb9365e469673$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7b7fb9365e469673$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7b7fb9365e469673$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $7b7fb9365e469673$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternParser() {
        $7b7fb9365e469673$var$_classCallCheck(this, PatternParser);
    }
    $7b7fb9365e469673$var$_createClass(PatternParser, [
        {
            key: "parse",
            value: function parse(pattern) {
                this.context = [
                    {
                        or: true,
                        instructions: []
                    }
                ];
                this.parsePattern(pattern);
                if (this.context.length !== 1) throw new Error('Non-finalized contexts left when pattern parse ended');
                var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
                if (branches) return {
                    op: '|',
                    args: branches.concat([
                        $7b7fb9365e469673$var$expandSingleElementArray(instructions)
                    ])
                };
                /* istanbul ignore if */ if (instructions.length === 0) throw new Error('Pattern is required');
                if (instructions.length === 1) return instructions[0];
                return instructions;
            }
        },
        {
            key: "startContext",
            value: function startContext(context) {
                this.context.push(context);
            }
        },
        {
            key: "endContext",
            value: function endContext() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function parsePattern(pattern) {
                if (!pattern) throw new Error('Pattern is required');
                var match = pattern.match($7b7fb9365e469673$var$OPERATOR);
                if (!match) {
                    if ($7b7fb9365e469673$var$ILLEGAL_CHARACTER_REGEXP.test(pattern)) throw new Error("Illegal characters found in a pattern: ".concat(pattern));
                    this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
                    return;
                }
                var operator = match[1];
                var before = pattern.slice(0, match.index);
                var rightPart = pattern.slice(match.index + operator.length);
                switch(operator){
                    case '(?:':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            or: true,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ')':
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (before) this.parsePattern(before);
                        if (this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var _this$getContext = this.getContext(), branches = _this$getContext.branches;
                        branches.push($7b7fb9365e469673$var$expandSingleElementArray(this.getContext().instructions));
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '|',
                            args: branches
                        });
                        break;
                    case '|':
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (before) this.parsePattern(before);
                         // The top-level is an implicit "or" group, if required.
                        if (!this.getContext().branches) {
                            // `branches` are not defined only for the root implicit "or" operator.
                            /* istanbul ignore else */ if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($7b7fb9365e469673$var$expandSingleElementArray(this.getContext().instructions));
                        this.getContext().instructions = [];
                        break;
                    case '[':
                        if (before) this.parsePattern(before);
                        this.startContext({
                            oneOfSet: true
                        });
                        break;
                    case ']':
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext();
                        this.getContext().instructions.push({
                            op: '[]',
                            args: $7b7fb9365e469673$var$parseOneOfSet(before)
                        });
                        break;
                    /* istanbul ignore next */ default:
                        throw new Error("Unknown operator: ".concat(operator));
                }
                if (rightPart) this.parsePattern(rightPart);
            }
        }
    ]);
    return PatternParser;
}();
function $7b7fb9365e469673$var$parseOneOfSet(pattern) {
    var values = [];
    var i = 0;
    while(i < pattern.length){
        if (pattern[i] === '-') {
            if (i === 0 || i === pattern.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
            var prevValue = pattern[i - 1].charCodeAt(0) + 1;
            var nextValue = pattern[i + 1].charCodeAt(0) - 1;
            var value = prevValue;
            while(value <= nextValue){
                values.push(String.fromCharCode(value));
                value++;
            }
        } else values.push(pattern[i]);
        i++;
    }
    return values;
}
var $7b7fb9365e469673$var$ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var $7b7fb9365e469673$var$OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function $7b7fb9365e469673$var$expandSingleElementArray(array) {
    if (array.length === 1) return array[0];
    return array;
}


function $c611626fb7b38494$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c611626fb7b38494$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c611626fb7b38494$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c611626fb7b38494$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c611626fb7b38494$var$_arrayLikeToArray(o, minLen);
}
function $c611626fb7b38494$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c611626fb7b38494$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c611626fb7b38494$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c611626fb7b38494$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c611626fb7b38494$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c611626fb7b38494$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $c611626fb7b38494$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternMatcher(pattern) {
        $c611626fb7b38494$var$_classCallCheck(this, PatternMatcher);
        this.matchTree = new (0, $7b7fb9365e469673$export$2e2bcd8739ae039)().parse(pattern);
    }
    $c611626fb7b38494$var$_createClass(PatternMatcher, [
        {
            key: "match",
            value: function match(string) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
                if (!string) throw new Error('String is required');
                var result = $c611626fb7b38494$var$_match(string.split(''), this.matchTree, true);
                if (result && result.match) delete result.matchedChars;
                if (result && result.overflow) {
                    if (!allowOverflow) return;
                }
                return result;
            }
        }
    ]);
    return PatternMatcher;
}();
function $c611626fb7b38494$var$_match(characters, tree, last) {
    // If `tree` is a string, then `tree` is a single character.
    // That's because when a pattern is parsed, multi-character-string parts
    // of a pattern are compiled into arrays of single characters.
    // I still wrote this piece of code for a "general" hypothetical case
    // when `tree` could be a string of several characters, even though
    // such case is not possible with the current implementation.
    if (typeof tree === 'string') {
        var characterString = characters.join('');
        if (tree.indexOf(characterString) === 0) {
            // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore else */ if (characters.length === tree.length) return {
                match: true,
                matchedChars: characters
            };
             // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore next */ return {
                partialMatch: true // matchedChars: characters
            };
        }
        if (characterString.indexOf(tree) === 0) {
            if (last) {
                // The `else` path is not possible because `tree` is always a single character.
                // The `else` case for `characters.length > tree.length` would be
                // `characters.length <= tree.length` which means `characters.length <= 1`.
                // `characters` array can't be empty, so that means `characters === [tree]`,
                // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
                // that the `if (tree.indexOf(characterString) === 0)` condition before this
                // `if` condition would be entered, and returned from there, not reaching this code.
                /* istanbul ignore else */ if (characters.length > tree.length) return {
                    overflow: true
                };
            }
            return {
                match: true,
                matchedChars: characters.slice(0, tree.length)
            };
        }
        return;
    }
    if (Array.isArray(tree)) {
        var restCharacters = characters.slice();
        var i = 0;
        while(i < tree.length){
            var subtree = tree[i];
            var result = $c611626fb7b38494$var$_match(restCharacters, subtree, last && i === tree.length - 1);
            if (!result) return;
            else if (result.overflow) return result;
            else if (result.match) {
                // Continue with the next subtree with the rest of the characters.
                restCharacters = restCharacters.slice(result.matchedChars.length);
                if (restCharacters.length === 0) {
                    if (i === tree.length - 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    else return {
                        partialMatch: true // matchedChars: characters
                    };
                }
            } else {
                /* istanbul ignore else */ if (result.partialMatch) return {
                    partialMatch: true // matchedChars: characters
                };
                else throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
            }
            i++;
        } // If `last` then overflow has already been checked
        // by the last element of the `tree` array.
        /* istanbul ignore if */ if (last) return {
            overflow: true
        };
        return {
            match: true,
            matchedChars: characters.slice(0, characters.length - restCharacters.length)
        };
    }
    switch(tree.op){
        case '|':
            var partialMatch;
            for(var _iterator = $c611626fb7b38494$var$_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;){
                var branch = _step.value;
                var _result = $c611626fb7b38494$var$_match(characters, branch, last);
                if (_result) {
                    if (_result.overflow) return _result;
                    else if (_result.match) return {
                        match: true,
                        matchedChars: _result.matchedChars
                    };
                    else {
                        /* istanbul ignore else */ if (_result.partialMatch) partialMatch = true;
                        else throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
                    }
                }
            }
            if (partialMatch) return {
                partialMatch: true // matchedChars: ...
            };
             // Not even a partial match.
            return;
        case '[]':
            for(var _iterator2 = $c611626fb7b38494$var$_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;){
                var _char = _step2.value;
                if (characters[0] === _char) {
                    if (characters.length === 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    if (last) return {
                        overflow: true
                    };
                    return {
                        match: true,
                        matchedChars: [
                            _char
                        ]
                    };
                }
            } // No character matches.
            return;
        /* istanbul ignore next */ default:
            throw new Error("Unsupported instruction tree: ".concat(tree));
    }
}






function $77c6294fe142cf3c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $77c6294fe142cf3c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $77c6294fe142cf3c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $77c6294fe142cf3c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $77c6294fe142cf3c$var$_arrayLikeToArray(o, minLen);
}
function $77c6294fe142cf3c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $77c6294fe142cf3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $77c6294fe142cf3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $77c6294fe142cf3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $77c6294fe142cf3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $77c6294fe142cf3c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// Could be any digit, I guess.
var $77c6294fe142cf3c$var$DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`
var $77c6294fe142cf3c$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $77c6294fe142cf3c$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $fe74fd6609d199cf$export$76d90c956114f2c2)($77c6294fe142cf3c$var$DUMMY_DIGIT, $77c6294fe142cf3c$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $77c6294fe142cf3c$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $77c6294fe142cf3c$var$CREATE_CHARACTER_CLASS_PATTERN = $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $77c6294fe142cf3c$var$CREATE_STANDALONE_DIGIT_PATTERN = $77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $77c6294fe142cf3c$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + ']*' + '(\\$\\d[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $77c6294fe142cf3c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var state = _ref.state, metadata = _ref.metadata;
        $77c6294fe142cf3c$var$_classCallCheck(this, AsYouTypeFormatter);
        this.metadata = metadata;
        this.resetFormat();
    }
    $77c6294fe142cf3c$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === '1';
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $2ee6f7e5d3aef803$export$9e33d25ea5d3e526)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = $77c6294fe142cf3c$var$_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;){
                    var format = _step.value;
                    var formattedCompleteNumber = (0, $2ee6f7e5d3aef803$export$2e2bcd8739ae039)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
                            return _this.getSeparatorAfterNationalPrefix(format);
                        }
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $fe74fd6609d199cf$export$2a0174a7c311f338)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $fe74fd6609d199cf$export$2a0174a7c311f338));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref2) {
                var _this2 = this;
                var nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start narrowing down the list of possible formats based on the leading digits.
                // (only previously matched formats take part in the narrowing down process)
                // `leading_digits_patterns` start with 3 digits min
                // and then go up from there one digit at a time.
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
                // to be minimum 3 digits long in order to be eligible
                // for checking those with a leading digits pattern.
                //
                // Since `leading_digits_patterns` start with 3 digits min,
                // Google's original `libphonenumber` library only starts
                // excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                //
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Also, `leading_digits_patterns` doesn't always correspond to a single
                // digits count. For example, `60|8` pattern would already match `8`
                // but the `60` part would require having at least two leading digits,
                // so the whole pattern would require inputting two digits first in order to
                // decide on whether it matches the input, even when the input is "80".
                //
                // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
                // even when there's only 1 or 2 digits of the national (significant) number.
                // To do that, it uses a non-strict pattern matcher written specifically for that.
                //
                if (leadingDigits.length < $77c6294fe142cf3c$var$MIN_LEADING_DIGITS_LENGTH) // Before leading digits < 3 matching was implemented:
                // return true
                //
                // After leading digits < 3 matching was implemented:
                try {
                    return new (0, $c611626fb7b38494$export$2e2bcd8739ae039)(leadingDigitsPattern).match(leadingDigits, {
                        allowOverflow: true
                    }) !== undefined;
                } catch (error) /* istanbul ignore next */ {
                    // There's a slight possibility that there could be some undiscovered bug
                    // in the pattern matcher code. Since the "leading digits < 3 matching"
                    // feature is not "essential" for operation, it can fall back to the old way
                    // in case of any issues rather than halting the application's execution.
                    console.error(error);
                    return true;
                }
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
                // available then use the usual regular expression matching.
                //
                // The whole pattern is wrapped in round brackets (`()`) because
                // the pattern can use "or" operator (`|`) at the top level of the pattern.
                //
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this3 = this;
                var _loop = function _loop() {
                    var format = _step2.value;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this3.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$77c6294fe142cf3c$var$NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) return "continue";
                    if (!_this3.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this3.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                //
                // For some weird reason, `istanbul` says "else path not taken"
                // for the `for of` line below. Supposedly that means that
                // the loop doesn't ever go over the last element in the list.
                // That's true because there always is `this.chosenFormat`
                // when `this.matchingFormats` is non-empty.
                // And, for some weird reason, it doesn't think that the case
                // with empty `this.matchingFormats` qualifies for a valid "else" path.
                // So simply muting this `istanbul` warning.
                // It doesn't skip the contents of the `for of` loop,
                // it just skips the `for of` line.
                //
                /* istanbul ignore next */ for(var _iterator2 = $77c6294fe142cf3c$var$_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;){
                    var _ret = _loop();
                    if (_ret === "break") break;
                    if (_ret === "continue") continue;
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf('|') >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function getSeparatorAfterNationalPrefix(format) {
                // `US` metadata doesn't have a `national_prefix_formatting_rule`,
                // so the `if` condition below doesn't apply to `US`,
                // but in reality there shoudl be a separator
                // between a national prefix and a national (significant) number.
                // So `US` national prefix separator is a "special" "hardcoded" case.
                if (this.isNANP) return ' ';
                 // If a `format` has a `national_prefix_formatting_rule`
                // and that rule has a separator after a national prefix,
                // then it means that there should be a separator
                // between a national prefix and a national (significant) number.
                if (format && format.nationalPrefixFormattingRule() && $77c6294fe142cf3c$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return ' ';
                 // At this point, there seems to be no clear evidence that
                // there should be a separator between a national prefix
                // and a national (significant) number. So don't insert one.
                return '';
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
                var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
                if (missingPlus) return '';
                return '+';
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : '';
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $fe74fd6609d199cf$export$2a0174a7c311f338), index + 1);
                    i++;
                }
                return (0, $fe74fd6609d199cf$export$ac095dcff0205861)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $fe74fd6609d199cf$export$2a0174a7c311f338)) + (0, $fe74fd6609d199cf$export$76d90c956114f2c2)((0, $fe74fd6609d199cf$export$2a0174a7c311f338), state.callingCode.length) + ' ' + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref4) {
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($77c6294fe142cf3c$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($77c6294fe142cf3c$var$CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
                .replace($77c6294fe142cf3c$var$CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $77c6294fe142cf3c$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp('^' + pattern + '$');
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $77c6294fe142cf3c$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $958c47b8ffb0646a$export$4f32ad1c51a7a6be), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $b28b7cc57bbfdda6$export$2e2bcd8739ae039)(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + (0, $b28b7cc57bbfdda6$export$2e2bcd8739ae039)('$1')) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $fe74fd6609d199cf$export$2a0174a7c311f338));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($77c6294fe142cf3c$var$DUMMY_DIGIT, 'g'), (0, $fe74fd6609d199cf$export$2a0174a7c311f338)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $fe74fd6609d199cf$export$76d90c956114f2c2)((0, $fe74fd6609d199cf$export$2a0174a7c311f338), complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $fe74fd6609d199cf$export$76d90c956114f2c2)((0, $fe74fd6609d199cf$export$2a0174a7c311f338), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $102fa0905276e10f$export$2e2bcd8739ae039)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $fe74fd6609d199cf$export$a15547494b55ca4e)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $fe74fd6609d199cf$export$ac095dcff0205861)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
                var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
                if (format.nationalPrefixFormattingRule()) {
                    // In some countries, `national_prefix_formatting_rule` is `($1)`,
                    // so it applies even if the user hasn't input a national prefix.
                    // `format.usesNationalPrefix()` detects such cases.
                    var usesNationalPrefix = format.usesNationalPrefix();
                    if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
                }
            }
        }
    ]);
    return AsYouTypeFormatter;
}();








function $b611684da4cccb02$var$_slicedToArray(arr, i) {
    return $b611684da4cccb02$var$_arrayWithHoles(arr) || $b611684da4cccb02$var$_iterableToArrayLimit(arr, i) || $b611684da4cccb02$var$_unsupportedIterableToArray(arr, i) || $b611684da4cccb02$var$_nonIterableRest();
}
function $b611684da4cccb02$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b611684da4cccb02$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b611684da4cccb02$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b611684da4cccb02$var$_arrayLikeToArray(o, minLen);
}
function $b611684da4cccb02$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b611684da4cccb02$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b611684da4cccb02$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b611684da4cccb02$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b611684da4cccb02$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b611684da4cccb02$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b611684da4cccb02$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b611684da4cccb02$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']+';
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var $b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $caa639c664fc3f13$export$207c99ccf3902df8) + ']' + '[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']*' + '|' + '[' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']+' + ')';
var $b611684da4cccb02$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + (0, $caa639c664fc3f13$export$7f01587e28f9194) + (0, $caa639c664fc3f13$export$852d1d4a47329634) + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $b611684da4cccb02$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $b611684da4cccb02$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $b611684da4cccb02$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $b611684da4cccb02$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $b611684da4cccb02$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $b611684da4cccb02$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $b28b7cc57bbfdda6$export$2e2bcd8739ae039)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                        return state.update(stateUpdate);
                    });
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $f54cbb82e68a0281$export$2e2bcd8739ae039)('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $b611684da4cccb02$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $599ebbe585179a66$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $599ebbe585179a66$export$2e2bcd8739ae039)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
                    return state.update(stateUpdate);
                })) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $fe72b81dc9349c1d$export$2e2bcd8739ae039)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state, {
                        country: undefined,
                        callingCode: undefined
                    });
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $4c6da243f5876ae1$export$2e2bcd8739ae039)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state, {
                            country: state.country,
                            callingCode: newCallingCode
                        });
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state, _ref3) {
                var country = _ref3.country, callingCode = _ref3.callingCode;
                state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                    return state.update(stateUpdate);
                });
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $b611684da4cccb02$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === '+') {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($b611684da4cccb02$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.
    if (hasPlus) text = '+' + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $b611684da4cccb02$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $b611684da4cccb02$var$extractFormattedPhoneNumber(text) || ''; // Trim a `+`.
    if (extractedNumber[0] === '+') return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $b611684da4cccb02$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $b611684da4cccb02$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $b611684da4cccb02$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$b611684da4cccb02$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = '';
    return [
        formattedDigits,
        hasPlus
    ];
}





function $db4ccf0f77fcc72f$var$_slicedToArray(arr, i) {
    return $db4ccf0f77fcc72f$var$_arrayWithHoles(arr) || $db4ccf0f77fcc72f$var$_iterableToArrayLimit(arr, i) || $db4ccf0f77fcc72f$var$_unsupportedIterableToArray(arr, i) || $db4ccf0f77fcc72f$var$_nonIterableRest();
}
function $db4ccf0f77fcc72f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $db4ccf0f77fcc72f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $db4ccf0f77fcc72f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $db4ccf0f77fcc72f$var$_arrayLikeToArray(o, minLen);
}
function $db4ccf0f77fcc72f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $db4ccf0f77fcc72f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $db4ccf0f77fcc72f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $db4ccf0f77fcc72f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $db4ccf0f77fcc72f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $db4ccf0f77fcc72f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $db4ccf0f77fcc72f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $db4ccf0f77fcc72f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $db4ccf0f77fcc72f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $db4ccf0f77fcc72f$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $db4ccf0f77fcc72f$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
        // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
        // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $db4ccf0f77fcc72f$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ((0, $dee3edaff9a60012$export$2e2bcd8739ae039)(optionsOrDefaultCountry)) {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = '001';
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = '+';
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $f63e1671b767c734$export$2e2bcd8739ae039)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $77c6294fe142cf3c$export$2e2bcd8739ae039)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $b611684da4cccb02$export$2e2bcd8739ae039)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset({
                    country: this.defaultCountry,
                    callingCode: this.defaultCallingCode
                });
                this.formattedOutput = '';
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                // If the number is being input in national format and some "default calling code"
                // has been passed to `AsYouType` constructor, then `this.state.callingCode`
                // is equal to that "default calling code".
                //
                // If the number is being input in national format and no "default calling code"
                // has been passed to `AsYouType` constructor, then returns `undefined`,
                // even if a "default country" has been passed to `AsYouType` constructor.
                //
                if (this.isInternational()) return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
                if (digits) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function _getCountry() {
                var country = this.state.country;
                /* istanbul ignore if */ if ($db4ccf0f77fcc72f$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                    // `AsYouType.getCountry()` returns `undefined`
                    // for "non-geographic" phone numbering plans.
                    if (country === '001') return;
                }
                return country;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $fe74fd6609d199cf$export$2a0174a7c311f338));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $292282cd70c66425$export$2e2bcd8739ae039)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
                    nationalNumber: this.state.nationalSignificantNumber,
                    defaultCountry: this.defaultCountry,
                    metadata: this.metadata
                }));
            }
        },
        {
            key: "getNumberValue",
            value: function getNumberValue() {
                var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
                if (!digits) return;
                if (this.isInternational()) {
                    if (callingCode) return '+' + callingCode + nationalSignificantNumber;
                    else return '+' + digits;
                } else if (country || callingCode) {
                    var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
                    return '+' + callingCode_ + nationalSignificantNumber;
                }
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
                // with the only change that it return `undefined` in case of a
                // "non-geographic" numbering plan instead of `"001"` "internal use" value.
                var country = this._getCountry();
                if (!nationalSignificantNumber) return;
                 // `state.country` and `state.callingCode` aren't required to be in sync.
                // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
                // So `country` and `callingCode` are totally independent.
                if (!country && !callingCode) return;
                 // By default, if `defaultCountry` parameter was passed when
                // creating `AsYouType` instance, `state.country` is gonna be
                // that `defaultCountry`, which doesn't entirely conform with
                // `parsePhoneNumber()`'s behavior where it attempts to determine
                // the country more precisely in cases when multiple countries
                // could correspond to the same `countryCallingCode`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
                //
                // Because `AsYouType.getNumber()` method is supposed to be a 1:1
                // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
                // then it should also behave accordingly in cases of `country` ambiguity.
                // That's how users of this library would expect it to behave anyway.
                //
                if (country) {
                    if (country === this.defaultCountry) {
                        // `state.country` and `state.callingCode` aren't required to be in sync.
                        // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
                        // So `state.country` and `state.callingCode` are totally independent.
                        var metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(this.metadata.metadata);
                        metadata.selectNumberingPlan(country);
                        var _callingCode = metadata.numberingPlan.callingCode();
                        var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);
                        if (ambiguousCountries.length > 1) {
                            var exactCountry = (0, $67e4fba183b60e52$export$2e2bcd8739ae039)(nationalSignificantNumber, {
                                countries: ambiguousCountries,
                                defaultCountry: this.defaultCountry,
                                metadata: this.metadata.metadata
                            });
                            if (exactCountry) country = exactCountry;
                        }
                    }
                }
                var phoneNumber = new (0, $25295587638b13c7$export$2e2bcd8739ae039)(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? '+' : '') + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
            }
        }
    ]);
    return AsYouType;
}();



var $0dabc91bce1ee96e$var$ONLY_DIGITS_REGEXP = /^\d+$/;
function $0dabc91bce1ee96e$export$2e2bcd8739ae039(country, metadata) {
    // Standard international phone number prefix: "+" and "country calling code".
    var prefix = '+' + (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(country, metadata);
    // "Leading digits" can't be used to rule out any countries.
    // So the "pre-fill with leading digits on country selection" feature had to be reverted.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10#note_1231042367
    // // Get "leading digits" for a phone number of the country.
    // // If there're "leading digits" then they can be part of the prefix too.
    // // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10
    // metadata = new Metadata(metadata)
    // metadata.selectNumberingPlan(country)
    // // "Leading digits" patterns are only defined for about 20% of all countries.
    // // By definition, matching "leading digits" is a sufficient but not a necessary
    // // condition for a phone number to belong to a country.
    // // The point of "leading digits" check is that it's the fastest one to get a match.
    // // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // const leadingDigits = metadata.numberingPlan.leadingDigits()
    // if (leadingDigits && ONLY_DIGITS_REGEXP.test(leadingDigits)) {
    // 	prefix += leadingDigits
    // }
    return prefix;
}


// Tells if `value: string` is an `E.164` phone number.
//
// Returns a boolean.
//
// It doesn't validate that the minimum national (significant) number length
// is at least 2 characters.
//
function $0967a0ff85311523$export$2e2bcd8739ae039(value) {
    if (value.length < 2) return false;
    if (value[0] !== '+') return false;
    var i = 1;
    while(i < value.length){
        var character = value.charCodeAt(i);
        if (character >= 48 && character <= 57) ;
        else return false;
        i++;
    }
    return true;
}
function $0967a0ff85311523$export$a32cb4373414cedd(value) {
    if (!$0967a0ff85311523$export$2e2bcd8739ae039(value)) console.error('[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got', value);
}



function $b1cc26643c331962$export$38cc8c9e484aa66b(_ref) {
    var inputFormat = _ref.inputFormat, country = _ref.country, metadata = _ref.metadata;
    return inputFormat === 'NATIONAL_PART_OF_INTERNATIONAL' ? "+".concat((0, $f80aac35004a54c3$export$32876ca2f1919cf0)(country, metadata)) : '';
}
function $b1cc26643c331962$export$4be51b112e32592b(value, prefix) {
    if (prefix) {
        value = value.slice(prefix.length);
        if (value[0] === ' ') value = value.slice(1);
    }
    return value;
}


function $61c383d560ece5c9$var$_slicedToArray(arr, i) {
    return $61c383d560ece5c9$var$_arrayWithHoles(arr) || $61c383d560ece5c9$var$_iterableToArrayLimit(arr, i) || $61c383d560ece5c9$var$_unsupportedIterableToArray(arr, i) || $61c383d560ece5c9$var$_nonIterableRest();
}
function $61c383d560ece5c9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $61c383d560ece5c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $61c383d560ece5c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $61c383d560ece5c9$var$_arrayLikeToArray(o, minLen);
}
function $61c383d560ece5c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $61c383d560ece5c9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $61c383d560ece5c9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $61c383d560ece5c9$export$2e2bcd8739ae039(_ref) {
    var _this = this;
    var value = _ref.value, onChange = _ref.onChange, country = _ref.country, defaultCountry = _ref.defaultCountry, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, useNationalFormatForDefaultCountryValue = _ref.useNationalFormatForDefaultCountryValue, metadata = _ref.metadata;
    // Validate the use of `withCountryCallingCode` property.
    if (typeof withCountryCallingCode === 'boolean' && !(country && international)) console.error('[react-phone-number-input] `withCountryCallingCode` property can only be used together with `country` and `international` properties');
    // Validate the use of `country` and `defaultCountry` properties.
    if (country && defaultCountry) console.error('[react-phone-number-input] When `country` property is passed, `defaultCountry` property has no effect and therefore shouldn\'t be passed');
    // Validate the use of `international` property.
    if (typeof international === 'boolean' && !country) console.error('[react-phone-number-input] `international` property can only be used together with `country` property');
    var inputFormat = $61c383d560ece5c9$var$getInputFormat({
        international: international,
        country: country,
        defaultCountry: defaultCountry,
        withCountryCallingCode: withCountryCallingCode
    });
    var countryMismatchDetected = (0, $acw62.useRef)();
    var onCountryMismatch = function onCountryMismatch(value, country, actualCountry) {
        console.error("[react-phone-number-input] Expected phone number ".concat(value, " to correspond to country ").concat(country, " but ").concat(actualCountry ? 'in reality it corresponds to country ' + actualCountry : 'it doesn\'t', "."));
        countryMismatchDetected.current = true;
    };
    var getInitialPhoneDigits = function getInitialPhoneDigits(options) {
        // Validate that the initially-supplied `value` is in `E.164` format.
        // Because sometimes people attempt to supply a `value` like "+1 (879) 490-8676".
        // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/231#note_2016334796
        if (value) (0, $0967a0ff85311523$export$a32cb4373414cedd)(value);
        return $61c383d560ece5c9$var$getPhoneDigitsForValue(value, country, defaultCountry, inputFormat, useNationalFormatForDefaultCountryValue, metadata, function() {
            if (options && options.onCountryMismatch) options.onCountryMismatch();
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            onCountryMismatch.apply(_this, args);
        });
    };
    // This is only used to detect `country` property change.
    var _useState = (0, $acw62.useState)(country), _useState2 = $61c383d560ece5c9$var$_slicedToArray(_useState, 2), prevCountry = _useState2[0], setPrevCountry = _useState2[1];
    // This is only used to detect `defaultCountry` property change.
    var _useState3 = (0, $acw62.useState)(defaultCountry), _useState4 = $61c383d560ece5c9$var$_slicedToArray(_useState3, 2), prevDefaultCountry = _useState4[0], setPrevDefaultCountry = _useState4[1];
    // `phoneDigits` is the a property that gets passed to the `<input/>` component as its "value":
    // * `phoneDigits` is the `<input value/>` property.
    // * `value` is the `<PhoneInput value/>` property.
    var _useState5 = (0, $acw62.useState)(getInitialPhoneDigits()), _useState6 = $61c383d560ece5c9$var$_slicedToArray(_useState5, 2), phoneDigits = _useState6[0], setPhoneDigits = _useState6[1];
    // This is only used to detect `value` property changes.
    var _useState7 = (0, $acw62.useState)(value), _useState8 = $61c383d560ece5c9$var$_slicedToArray(_useState7, 2), valueForPhoneDigits = _useState8[0], setValueForPhoneDigits = _useState8[1];
    // Rerender hack.
    var _useState9 = (0, $acw62.useState)(), _useState10 = $61c383d560ece5c9$var$_slicedToArray(_useState9, 2), rerenderTrigger = _useState10[0], setRerenderTrigger = _useState10[1];
    var rerender = (0, $acw62.useCallback)(function() {
        return setRerenderTrigger({});
    }, [
        setRerenderTrigger
    ]);
    function getValueForPhoneDigits(phoneDigits) {
        // If the user hasn't input any digits then `value` is `undefined`.
        if (!phoneDigits) return;
        if (inputFormat === 'NATIONAL_PART_OF_INTERNATIONAL') phoneDigits = "+".concat((0, $f80aac35004a54c3$export$32876ca2f1919cf0)(country, metadata)).concat(phoneDigits);
        // Return the E.164 phone number value.
        //
        // Even if no "national (significant) number" digits have been input,
        // still return a non-`undefined` value.
        // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
        //
        // For example, if the user has selected country `US` and entered `"1"`
        // then that `"1"` is just a "national prefix" and no "national (significant) number"
        // digits have been input yet. Still, return `"+1"` as `value` in such cases,
        // because otherwise the app would think that the input is empty and mark it as such
        // while in reality it isn't empty, which might be thought of as a "bug", or just
        // a "weird" behavior.
        //
        // The only case when there's any input and `getNumberValue()` still returns `undefined`
        // is when that input is `"+"`.
        //
        var asYouType = new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(country || defaultCountry, metadata);
        asYouType.input(phoneDigits);
        return asYouType.getNumberValue();
    }
    // If `value` property has been changed externally
    // then re-initialize the component.
    (0, $acw62.useEffect)(function() {
        if (value !== valueForPhoneDigits) {
            setValueForPhoneDigits(value);
            setPhoneDigits(getInitialPhoneDigits());
        }
    }, [
        value
    ]);
    // If the `country` has been changed then re-initialize the component.
    (0, $acw62.useEffect)(function() {
        if (country !== prevCountry) {
            setPrevCountry(country);
            var _countryMismatchDetected;
            var _phoneDigits = getInitialPhoneDigits({
                onCountryMismatch: function onCountryMismatch() {
                    _countryMismatchDetected = true;
                }
            });
            setPhoneDigits(_phoneDigits);
            if (_countryMismatchDetected) setValueForPhoneDigits(getValueForPhoneDigits(_phoneDigits));
        }
    }, [
        country
    ]);
    // If the `defaultCountry` has been changed then re-initialize the component.
    (0, $acw62.useEffect)(function() {
        if (defaultCountry !== prevDefaultCountry) {
            setPrevDefaultCountry(defaultCountry);
            setPhoneDigits(getInitialPhoneDigits());
        }
    }, [
        defaultCountry
    ]);
    // Update the `value` after `valueForPhoneDigits` has been updated.
    (0, $acw62.useEffect)(function() {
        if (valueForPhoneDigits !== value) onChange(valueForPhoneDigits);
    }, [
        valueForPhoneDigits
    ]);
    var onSetPhoneDigits = (0, $acw62.useCallback)(function(phoneDigits) {
        var value;
        if (country) {
            if (inputFormat === 'INTERNATIONAL') {
                // The `<input/>` value must start with the country calling code.
                var prefix = (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(country, metadata);
                if (phoneDigits.indexOf(prefix) !== 0) {
                    // If a user tabs into a phone number input field
                    // that is in `withCountryCallingCode` mode,
                    // and then starts inputting local phone number digits,
                    // the first digit would get "swallowed" if the fix below wasn't implemented.
                    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
                    if (phoneDigits && phoneDigits[0] !== '+') phoneDigits = prefix + phoneDigits;
                    else {
                        // // Reset phone digits if they don't start with the correct prefix.
                        // // Undo the `<input/>` value change if it doesn't.
                        if (countryMismatchDetected.current) ;
                        else {
                            // If it simply did `phoneDigits = prefix` here,
                            // then it could have no effect when erasing phone number
                            // via Backspace, because `phoneDigits` in `state` wouldn't change
                            // as a result, because it was `prefix` and it became `prefix`,
                            // so the component wouldn't rerender, and the user would be able
                            // to erase the country calling code part, and that part is
                            // assumed to be non-eraseable. That's why the component is
                            // forcefully rerendered here.
                            setPhoneDigits(prefix);
                            setValueForPhoneDigits(undefined);
                            // Force a re-render of the `<input/>` with previous `phoneDigits` value.
                            return rerender();
                        }
                    }
                }
            } else // Entering phone number either in "NATIONAL" or in "NATIONAL_PART_OF_INTERNATIONAL" format.
            // Therefore, `+` is not allowed.
            if (phoneDigits && phoneDigits[0] === '+') // Remove the `+`.
            phoneDigits = phoneDigits.slice(1);
        } else if (!defaultCountry) // Force a `+` in the beginning of a `value`
        // when no `country` and `defaultCountry` have been specified.
        {
            if (phoneDigits && phoneDigits[0] !== '+') // Prepend a `+`.
            phoneDigits = '+' + phoneDigits;
        }
        // Convert `phoneDigits` to `value`.
        if (phoneDigits) value = getValueForPhoneDigits(phoneDigits);
        setPhoneDigits(phoneDigits);
        setValueForPhoneDigits(value);
    }, [
        country,
        inputFormat,
        defaultCountry,
        metadata,
        setPhoneDigits,
        setValueForPhoneDigits,
        rerender,
        countryMismatchDetected
    ]);
    return {
        phoneDigits: phoneDigits,
        setPhoneDigits: onSetPhoneDigits,
        inputFormat: inputFormat
    };
}
/**
 * Returns phone number input field value for a E.164 phone number `value`.
 * @param  {string} [value]
 * @param  {string} [country]
 * @param  {string} [inputFormat]
 * @param  {string} [defaultCountry]
 * @param  {boolean} [useNationalFormatForDefaultCountryValue]
 * @param  {object} metadata
 * @return {string}
 */ function $61c383d560ece5c9$var$getPhoneDigitsForValue(value, country, defaultCountry, inputFormat, useNationalFormatForDefaultCountryValue, metadata, onCountryMismatch) {
    if (country && inputFormat === 'INTERNATIONAL') {
        var prefix = (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(country, metadata);
        if (value) {
            if (value.indexOf(prefix) !== 0) onCountryMismatch(value, country);
            return value;
        }
        return prefix;
    }
    if (!value) return '';
    if (!country && !defaultCountry) return value;
    var asYouType = new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(undefined, metadata);
    asYouType.input(value);
    var phoneNumber = asYouType.getNumber();
    if (phoneNumber) {
        if (country) {
            // Check for `country` property mismatch for the actual `value`.
            if (phoneNumber.country && phoneNumber.country !== country) onCountryMismatch(value, country, phoneNumber.country);
            else if (phoneNumber.countryCallingCode !== (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(country, metadata)) onCountryMismatch(value, country);
            switch(inputFormat){
                case 'NATIONAL':
                    return (0, $b28b7cc57bbfdda6$export$2e2bcd8739ae039)(phoneNumber.formatNational());
                case 'NATIONAL_PART_OF_INTERNATIONAL':
                    return (0, $b28b7cc57bbfdda6$export$2e2bcd8739ae039)((0, $b1cc26643c331962$export$4be51b112e32592b)(phoneNumber.formatInternational(), (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(country, metadata)));
                case 'INTERNATIONAL':
                    throw new Error('`inputFormat: "INTERNATIONAL"` case should\'ve already been handled earlier in the code');
                case 'INTERNATIONAL_OR_NATIONAL':
                    throw new Error('`inputFormat: "INTERNATIONAL_OR_NATIONAL"` is not possible when `country` is fixed');
                default:
                    throw new Error("Unknown `inputFormat`: ".concat(inputFormat));
            }
        } else {
            // `phoneNumber.countryCallingCode` is compared here  instead of
            // `phoneNumber.country`, because, for example, a person could have
            // previously input a phone number (in "national" format) that isn't
            // 100% valid for the `defaultCountry`, and if `phoneNumber.country`
            // was compared, then it wouldn't match, and such phone number
            // wouldn't be formatted as a "national" one, and instead would be
            // formatted as an "international" one, confusing the user.
            // Comparing `phoneNumber.countryCallingCode` works around such issues.
            //
            // Example: `defaultCountry="US"` and the `<input/>` is empty.
            // The user inputs: "222 333 4444", which gets formatted to "(222) 333-4444".
            // The user then clicks "Save", the page is refreshed, and the user sees
            // that the `<input/>` value is now "+1 222 333 4444" which confuses the user:
            // the user expected the `<input/>` value to be "(222) 333-4444", same as it
            // was when they've just typed it in. The cause of the issue is that "222 333 4444"
            // is not a valid national number for US, and `phoneNumber.country` is compared
            // instead of `phoneNumber.countryCallingCode`. After the `phoneNumber.country`
            // comparison is replaced with `phoneNumber.countryCallingCode` one, the issue
            // is no longer the case.
            //
            if (phoneNumber.countryCallingCode && phoneNumber.countryCallingCode === (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(defaultCountry, metadata) && useNationalFormatForDefaultCountryValue) return (0, $b28b7cc57bbfdda6$export$2e2bcd8739ae039)(phoneNumber.formatNational());
            return value;
        }
    } else return '';
}
function $61c383d560ece5c9$var$getInputFormat(_ref2) {
    var international = _ref2.international, country = _ref2.country, defaultCountry = _ref2.defaultCountry, withCountryCallingCode = _ref2.withCountryCallingCode;
    return country ? international ? withCountryCallingCode ? 'INTERNATIONAL' : 'NATIONAL_PART_OF_INTERNATIONAL' : 'NATIONAL' : defaultCountry ? 'INTERNATIONAL_OR_NATIONAL' : 'INTERNATIONAL';
}



var $c9Z8w = parcelRequire("c9Z8w");
var $44b453c2a900e1fd$export$dbb5e893e736e4ee = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
    country_calling_codes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    countries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
});
var $44b453c2a900e1fd$export$a238cb463698c900 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string);


var $ead78670e00f3ae5$var$_excluded = [
    "Component",
    "country",
    "defaultCountry",
    "useNationalFormatForDefaultCountryValue",
    "value",
    "onChange",
    "metadata",
    "international",
    "withCountryCallingCode"
];
function $ead78670e00f3ae5$var$_extends() {
    $ead78670e00f3ae5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ead78670e00f3ae5$var$_extends.apply(this, arguments);
}
function $ead78670e00f3ae5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ead78670e00f3ae5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ead78670e00f3ae5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ead78670e00f3ae5$var$PhoneInput(_ref, ref) {
    var Component = _ref.Component, country = _ref.country, defaultCountry = _ref.defaultCountry, _ref$useNationalForma = _ref.useNationalFormatForDefaultCountryValue, useNationalFormatForDefaultCountryValue = _ref$useNationalForma === void 0 ? true : _ref$useNationalForma, value = _ref.value, onChange = _ref.onChange, metadata = _ref.metadata, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, rest = $ead78670e00f3ae5$var$_objectWithoutProperties(_ref, $ead78670e00f3ae5$var$_excluded);
    // "Phone digits" includes not only "digits" but also a `+` sign.
    var _usePhoneDigits = (0, $61c383d560ece5c9$export$2e2bcd8739ae039)({
        value: value,
        onChange: onChange,
        country: country,
        defaultCountry: defaultCountry,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        useNationalFormatForDefaultCountryValue: useNationalFormatForDefaultCountryValue,
        metadata: metadata
    }), phoneDigits = _usePhoneDigits.phoneDigits, setPhoneDigits = _usePhoneDigits.setPhoneDigits, inputFormat = _usePhoneDigits.inputFormat;
    // * Passing `international` property is deprecated.
    // * Passing `withCountryCallingCode` property is deprecated.
    // * Passing `country` property: it should've been called `defaultCountry` instead
    //   because it only applies when the user inputs a phone number in a national format
    //   and is completely ignored when the user inputs a phone number in an international format.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $ead78670e00f3ae5$var$_extends({}, rest, {
        ref: ref,
        metadata: metadata,
        inputFormat: inputFormat,
        international: international,
        withCountryCallingCode: withCountryCallingCode,
        country: country || defaultCountry,
        value: phoneDigits,
        onChange: setPhoneDigits
    }));
}
$ead78670e00f3ae5$var$PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($ead78670e00f3ae5$var$PhoneInput);
$ead78670e00f3ae5$var$PhoneInput.propTypes = {
    /**
   * The phone number (in E.164 format).
   * Examples: `"+12"`, `"+12133734253"`.
   * An "empty" `value` could be represented by any "falsy" value like `undefined`, `null` or an empty string `""`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * A function of `value: string?`.
   * Updates the `value` property (to `undefined` in case it's empty).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * A two-letter country code for formatting `value`
   * as a national phone number (example: `(213) 373-4253`),
   * or as an international phone number without "country calling code"
   * if `international` property is passed (example: `213 373 4253`).
   * Example: "US".
   * If no `country` is passed then `value`
   * is formatted as an international phone number.
   * (example: `+1 213 373 4253`)
   */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * A two-letter country code for formatting `value`
   * when a user inputs a national phone number (example: `(213) 373-4253`).
   * The user can still input a phone number in international format.
   * Example: "US".
   * `country` and `defaultCountry` properties are mutually exclusive.
   */ defaultCountry: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `country` property is passed along with `international={true}` property
   * then the phone number will be input in "international" format for that `country`
   * (without "country calling code").
   * For example, if `country="US"` property is passed to "without country select" input
   * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
   * But if both `country="US"` and `international={true}` properties are passed then
   * the phone number will be input in the "international" format for `US` (`213 373 4253`)
   * (without "country calling code" `+1`).
   */ international: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `country` and `international` properties are set,
   * then by default it won't include "country calling code" in the input field.
   * To change that, pass `withCountryCallingCode` property,
   * and it will include "country calling code" in the input field.
   */ withCountryCallingCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * A component that renders the `<input/>` itself and also
   * parses and formats its `value` as the user inputs it.
   * See `InputBasic.js` and `InputSmart.js` for an example.
   */ Component: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType.isRequired,
    /**
   * When `defaultCountry` is defined and the initial `value` corresponds to `defaultCountry`,
   * then the `value` will be formatted as a national phone number by default.
   * To format the initial `value` of `defaultCountry` as an international number instead
   * set `useNationalFormatForDefaultCountryValue` property to `true`.
   */ useNationalFormatForDefaultCountryValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * `libphonenumber-js` metadata.
   */ metadata: (0, $44b453c2a900e1fd$export$dbb5e893e736e4ee)
};
var $ead78670e00f3ae5$export$2e2bcd8739ae039 = $ead78670e00f3ae5$var$PhoneInput;



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//
function $bd4000fb22cccaa7$export$2e2bcd8739ae039(value, caret, operation) {
    switch(operation){
        case 'Backspace':
            // If there exists the previous character,
            // then erase it and reposition the caret.
            if (caret > 0) {
                // Remove the previous character
                value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was
                caret--;
            }
            break;
        case 'Delete':
            // Remove current digit (if any)
            value = value.slice(0, caret) + value.slice(caret + 1);
            break;
    }
    return {
        value: value,
        caret: caret
    };
}


// Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value, context)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// `context` argument is just a utility empty object that is shared within the bounds
// of parsing a single input string. The `_parse()` function could use that object
// to store any kind of "flags" in it in order to alter its behavior based when
// parsing next characters within the same string. Or it could completely ignore it.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//
function $239798236dda80d1$export$2e2bcd8739ae039(text, caret_position, parse_character) {
    var context = {};
    var value = '';
    var focused_input_character_index = 0;
    var index = 0;
    while(index < text.length){
        var character = parse_character(text[index], value, context);
        if (character !== undefined) {
            value += character;
            if (caret_position !== undefined) {
                if (caret_position === index) focused_input_character_index = value.length - 1;
                else if (caret_position > index) focused_input_character_index = value.length;
            }
        }
        index++;
    } // If caret position wasn't specified
    if (caret_position === undefined) // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
    var result = {
        value: value,
        caret: focused_input_character_index
    };
    return result;
}


function $f156bffdf8a1980c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f156bffdf8a1980c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f156bffdf8a1980c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f156bffdf8a1980c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f156bffdf8a1980c$var$_arrayLikeToArray(o, minLen);
}
function $f156bffdf8a1980c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f156bffdf8a1980c$export$15741e15817e73b8(symbol, string) {
    var count = 0; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // so skipping such miscellaneous "exotic" characters
    // won't matter here for just counting placeholder character occurrences.
    for(var _iterator = $f156bffdf8a1980c$var$_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
}



function $8ca5d86fa1fd8a83$export$2e2bcd8739ae039(retained_template, template) {
    var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
    var cut_before = retained_template.length;
    var opening_braces = (0, $f156bffdf8a1980c$export$15741e15817e73b8)('(', retained_template);
    var closing_braces = (0, $f156bffdf8a1980c$export$15741e15817e73b8)(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        retained_template += template[cut_before].replace(placeholder, empty_placeholder);
        if (template[cut_before] === ')') dangling_braces--;
        cut_before++;
    }
    return retained_template;
}


function $e92a6929987b746f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e92a6929987b746f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e92a6929987b746f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e92a6929987b746f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e92a6929987b746f$var$_arrayLikeToArray(o, minLen);
}
function $e92a6929987b746f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e92a6929987b746f$export$2e2bcd8739ae039(template) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
    var shouldCloseBraces = arguments.length > 2 ? arguments[2] : undefined;
    if (!template) return function(value) {
        return {
            text: value
        };
    };
    var placeholdersCountInTemplate = (0, $f156bffdf8a1980c$export$15741e15817e73b8)(placeholder, template);
    return function(value) {
        if (!value) return {
            text: '',
            template: template
        };
        var characterIndexInValue = 0;
        var templateWithFilledInPlaceholders = ''; // Using `.split('')` here instead of normal `for ... of`
        // because the importing application doesn't neccessarily include an ES6 polyfill.
        // The `.split('')` approach discards "exotic" UTF-8 characters
        // (the ones consisting of four bytes)
        // but template placeholder characters don't fall into that range
        // and appending UTF-8 characters to a string in parts still works.
        for(var _iterator = $e92a6929987b746f$var$_createForOfIteratorHelperLoose(template.split('')), _step; !(_step = _iterator()).done;){
            var character = _step.value;
            if (character !== placeholder) {
                templateWithFilledInPlaceholders += character;
                continue;
            }
            templateWithFilledInPlaceholders += value[characterIndexInValue];
            characterIndexInValue++; // If the last available value character has been filled in,
            // then return the filled in template
            // (either trim the right part or retain it,
            //  if no more character placeholders in there)
            if (characterIndexInValue === value.length) {
                // If there are more character placeholders
                // in the right part of the template
                // then simply trim it.
                if (value.length < placeholdersCountInTemplate) break;
            }
        }
        if (shouldCloseBraces) templateWithFilledInPlaceholders = (0, $8ca5d86fa1fd8a83$export$2e2bcd8739ae039)(templateWithFilledInPlaceholders, template);
        return {
            text: templateWithFilledInPlaceholders,
            template: template
        };
    };
}


function $fcd2f67e20b50d8a$export$2e2bcd8739ae039(value, caret, formatter) {
    if (typeof formatter === 'string') formatter = (0, $e92a6929987b746f$export$2e2bcd8739ae039)(formatter);
    var _ref = formatter(value) || {}, text = _ref.text, template = _ref.template;
    if (text === undefined) text = value;
    if (template) {
        if (caret === undefined) caret = text.length;
        else {
            var index = 0;
            var found = false;
            var possibly_last_input_character_index = -1;
            while(index < text.length && index < template.length){
                // Character placeholder found
                if (text[index] !== template[index]) {
                    if (caret === 0) {
                        found = true;
                        caret = index;
                        break;
                    }
                    possibly_last_input_character_index = index;
                    caret--;
                }
                index++;
            } // If the caret was positioned after last input character,
            // then the text caret index is just after the last input character.
            if (!found) caret = possibly_last_input_character_index + 1;
        }
    }
    return {
        text: text,
        caret: caret
    };
}


function $ee0d3dd1a63aa54b$export$2498094d90b6ac72(element) {
    return element.hasAttribute('readonly');
} // Gets <input/> selection bounds
function $ee0d3dd1a63aa54b$export$ca798a7e6e94638c(element) {
    // If no selection, return nothing
    if (element.selectionStart === element.selectionEnd) return;
    return {
        start: element.selectionStart,
        end: element.selectionEnd
    };
} // Key codes
var $ee0d3dd1a63aa54b$export$4b0075e5ea5e1f26 = {
    Backspace: 8,
    Delete: 46
}; // Finds out the operation to be intercepted and performed
function $ee0d3dd1a63aa54b$export$d4e837035315abd8(event) {
    switch(event.keyCode){
        case $ee0d3dd1a63aa54b$export$4b0075e5ea5e1f26.Backspace:
            return 'Backspace';
        case $ee0d3dd1a63aa54b$export$4b0075e5ea5e1f26.Delete:
            return 'Delete';
    }
} // Gets <input/> caret position
function $ee0d3dd1a63aa54b$export$7d120213748299d3(element) {
    return element.selectionStart;
} // Sets <input/> caret position
function $ee0d3dd1a63aa54b$export$97ab23b40042f8af(element, caret_position) {
    // Sanity check
    if (caret_position === undefined) return;
     // Set caret position.
    // There has been an issue with caret positioning on Android devices.
    // https://github.com/catamphetamine/input-format/issues/2
    // I was revisiting this issue and looked for similar issues in other libraries.
    // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
    // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
    // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
    // https://github.com/text-mask/text-mask/issues/300
    // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
    // https://github.com/text-mask/text-mask/pull/400/files
    // I've implemented the same workaround here.
    if ($ee0d3dd1a63aa54b$var$isAndroid()) setTimeout(function() {
        return element.setSelectionRange(caret_position, caret_position);
    }, 0);
    else element.setSelectionRange(caret_position, caret_position);
}
function $ee0d3dd1a63aa54b$var$isAndroid() {
    // `navigator` is not defined when running mocha tests.
    if (typeof navigator !== 'undefined') return $ee0d3dd1a63aa54b$var$ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
}
var $ee0d3dd1a63aa54b$var$ANDROID_USER_AGENT_REG_EXP = /Android/i;


function $df9d66cd822d81ee$export$330ca67a316b532c(event, input, _parse, _format, on_change) {
    if ((0, $ee0d3dd1a63aa54b$export$2498094d90b6ac72)(input)) return;
     // The actual cut hasn't happened just yet hence the timeout.
    setTimeout(function() {
        return $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
    }, 0);
} // Deprecated.
function $df9d66cd822d81ee$export$48aae1120b60938a(event, input, _parse, _format, on_change) {
    if ((0, $ee0d3dd1a63aa54b$export$2498094d90b6ac72)(input)) return;
    var selection = (0, $ee0d3dd1a63aa54b$export$ca798a7e6e94638c)(input); // If selection is made,
    // just erase the selected text
    // prior to pasting
    if (selection) $df9d66cd822d81ee$var$eraseSelection(input, selection);
    $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
}
function $df9d66cd822d81ee$export$bd913411069e59d3(event, input, _parse, _format, on_change) {
    $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
function $df9d66cd822d81ee$export$de8e1b1372cdb41b(event, input, _parse, _format, on_change) {
    if ((0, $ee0d3dd1a63aa54b$export$2498094d90b6ac72)(input)) return;
    var operation = (0, $ee0d3dd1a63aa54b$export$d4e837035315abd8)(event);
    switch(operation){
        case 'Delete':
        case 'Backspace':
            // Intercept this operation and perform it manually.
            event.preventDefault();
            var selection = (0, $ee0d3dd1a63aa54b$export$ca798a7e6e94638c)(input); // If a selection is made, just erase the selected text.
            if (selection) {
                $df9d66cd822d81ee$var$eraseSelection(input, selection);
                return $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, undefined, on_change);
            } // Else, perform the (character erasing) operation manually.
            return $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, operation, on_change);
        default:
    }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */ function $df9d66cd822d81ee$var$eraseSelection(input, selection) {
    var text = input.value;
    text = text.slice(0, selection.start) + text.slice(selection.end);
    input.value = text;
    (0, $ee0d3dd1a63aa54b$export$97ab23b40042f8af)(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */ function $df9d66cd822d81ee$var$formatInputText(input, _parse, _format, operation, on_change) {
    // Parse `<input/>` textual value.
    // Get the `value` and `caret` position.
    var _parse2 = (0, $239798236dda80d1$export$2e2bcd8739ae039)(input.value, (0, $ee0d3dd1a63aa54b$export$7d120213748299d3)(input), _parse), value = _parse2.value, caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
    // then apply that operation and get the new `value` and `caret` position.
    if (operation) {
        var newValueAndCaret = (0, $bd4000fb22cccaa7$export$2e2bcd8739ae039)(value, caret, operation);
        value = newValueAndCaret.value;
        caret = newValueAndCaret.caret;
    } // Format the `value`.
    // (and reposition the caret accordingly)
    var formatted = (0, $fcd2f67e20b50d8a$export$2e2bcd8739ae039)(value, caret, _format);
    var text = formatted.text;
    caret = formatted.caret; // Set `<input/>` textual value manually
    // to prevent React from resetting the caret position
    // later inside a subsequent `render()`.
    // Doesn't work for custom `inputComponent`s for some reason.
    input.value = text; // Position the caret properly.
    (0, $ee0d3dd1a63aa54b$export$97ab23b40042f8af)(input, caret); // If the `<input/>` textual value did change,
    // then the parsed `value` may have changed too.
    if (on_change) on_change(value);
}


var $cf61940a0901e5b0$var$_excluded = [
    "ref",
    "parse",
    "format",
    "value",
    "defaultValue",
    "controlled",
    "onChange",
    "onKeyDown"
];
function $cf61940a0901e5b0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cf61940a0901e5b0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cf61940a0901e5b0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cf61940a0901e5b0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cf61940a0901e5b0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cf61940a0901e5b0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf61940a0901e5b0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf61940a0901e5b0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf61940a0901e5b0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cf61940a0901e5b0$export$2e2bcd8739ae039(_ref) {
    var ref = _ref.ref, parse = _ref.parse, format = _ref.format, value = _ref.value, defaultValue = _ref.defaultValue, _ref$controlled = _ref.controlled, controlled = _ref$controlled === void 0 ? true : _ref$controlled, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, rest = $cf61940a0901e5b0$var$_objectWithoutProperties(_ref, $cf61940a0901e5b0$var$_excluded);
    // It doesn't seem to be required to alert a developer about controlled/uncontrolled misuse:
    // if `controlled` is `true` then `defaultValue` is simply ignored.
    //
    // if (defaultValue && controlled) {
    // 	console.error('[input-format] You\'ve passed both `defaultValue` and `controlled: true` properties which is an invalid use case')
    // }
    var internalRef = (0, $acw62.useRef)();
    var setRef = (0, $acw62.useCallback)(function(instance) {
        internalRef.current = instance;
        if (ref) {
            if (typeof ref === 'function') ref(instance);
            else ref.current = instance;
        }
    }, [
        ref
    ]);
    var _onChange = (0, $acw62.useCallback)(function(event) {
        return (0, $df9d66cd822d81ee$export$bd913411069e59d3)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange
    ]);
    var _onKeyDown = (0, $acw62.useCallback)(function(event) {
        if (onKeyDown) onKeyDown(event);
         // If `onKeyDown()` handler above has called `event.preventDefault()`
        // then ignore this `keydown` event.
        if (event.defaultPrevented) return;
        return (0, $df9d66cd822d81ee$export$de8e1b1372cdb41b)(event, internalRef.current, parse, format, onChange);
    }, [
        internalRef,
        parse,
        format,
        onChange,
        onKeyDown
    ]);
    var commonProps = $cf61940a0901e5b0$var$_objectSpread($cf61940a0901e5b0$var$_objectSpread({}, rest), {}, {
        ref: setRef,
        onChange: _onChange,
        onKeyDown: _onKeyDown
    });
    if (controlled) return $cf61940a0901e5b0$var$_objectSpread($cf61940a0901e5b0$var$_objectSpread({}, commonProps), {}, {
        value: format($cf61940a0901e5b0$var$isEmptyValue(value) ? '' : value).text
    });
    return $cf61940a0901e5b0$var$_objectSpread($cf61940a0901e5b0$var$_objectSpread({}, commonProps), {}, {
        defaultValue: format($cf61940a0901e5b0$var$isEmptyValue(defaultValue) ? '' : defaultValue).text
    });
}
function $cf61940a0901e5b0$var$isEmptyValue(value) {
    return value === undefined || value === null;
}


var $0d2a50088275844b$var$_excluded = [
    "inputComponent",
    "parse",
    "format",
    "value",
    "defaultValue",
    "onChange",
    "controlled",
    "onKeyDown",
    "type"
];
function $0d2a50088275844b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0d2a50088275844b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0d2a50088275844b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0d2a50088275844b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0d2a50088275844b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0d2a50088275844b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0d2a50088275844b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0d2a50088275844b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0d2a50088275844b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
//
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//
function $0d2a50088275844b$var$Input(_ref, ref) {
    var _ref$inputComponent = _ref.inputComponent, InputComponent = _ref$inputComponent === void 0 ? 'input' : _ref$inputComponent, parse = _ref.parse, format = _ref.format, value = _ref.value, defaultValue = _ref.defaultValue, onChange = _ref.onChange, controlled = _ref.controlled, onKeyDown = _ref.onKeyDown, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, rest = $0d2a50088275844b$var$_objectWithoutProperties(_ref, $0d2a50088275844b$var$_excluded);
    var inputProps = (0, $cf61940a0901e5b0$export$2e2bcd8739ae039)($0d2a50088275844b$var$_objectSpread({
        ref: ref,
        parse: parse,
        format: format,
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        controlled: controlled,
        onKeyDown: onKeyDown,
        type: type
    }, rest));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(InputComponent, inputProps);
}
$0d2a50088275844b$var$Input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($0d2a50088275844b$var$Input);
$0d2a50088275844b$var$Input.propTypes = {
    // Parses a single characher of `<input/>` text.
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    // Formats `value` into `<input/>` text.
    format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    // Renders `<input/>` by default.
    inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    // `<input/>` `type` attribute.
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Is parsed from <input/> text.
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // An initial value for an "uncontrolled" <input/>.
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // This handler is called each time `<input/>` text is changed.
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    // Whether this input should be "controlled" or "uncontrolled".
    // The default value is `true` meaning "uncontrolled".
    controlled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    // Passthrough
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onCut: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onPaste: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $0d2a50088275844b$export$2e2bcd8739ae039 = $0d2a50088275844b$var$Input;





function $b946be75d7cecb7c$export$2e2bcd8739ae039(character, prevParsedCharacters, context) {
    // `context` argument was added as a third argument of `parse()` function
    // in `input-format` package on Dec 26th, 2023. So it could potentially be
    // `undefined` here if a 3rd-party app somehow ends up with this newer version
    // of `react-phone-number-input` and an older version of `input-format`.
    // Dunno how, but just in case, it could be `undefined` here and it wouldn't break.
    // Maybe it's not required to handle `undefined` case here.
    //
    // The addition of the `context` argument was to fix the slightly-weird behavior
    // of parsing an input string when the user inputs something like `"2+7"
    // https://github.com/catamphetamine/react-phone-number-input/issues/437
    //
    // If the parser encounters an unexpected `+` in a string being parsed
    // then it simply discards that out-of-place `+` and any following characters.
    //
    if (context && context.ignoreRest) return;
    var emitEvent = function emitEvent(eventName) {
        if (context) switch(eventName){
            case 'end':
                context.ignoreRest = true;
                break;
        }
    };
    return (0, $5d722be4de9b0760$export$13d8790d7fb84c28)(character, prevParsedCharacters, emitEvent);
}



var $acw62 = parcelRequire("acw62");
function $792f316d66ac07e9$export$2e2bcd8739ae039(_ref) {
    var onKeyDown = _ref.onKeyDown, inputFormat = _ref.inputFormat;
    return (0, $acw62.useCallback)(function(event) {
        // Usability:
        // Don't allow the user to erase a leading "+" character when "international" input mode is forced.
        // That indicates to the user that they can't possibly enter the phone number in a non-international format.
        if (event.keyCode === $792f316d66ac07e9$var$BACKSPACE_KEY_CODE && inputFormat === 'INTERNATIONAL') {
            // It checks `event.target` here for being an `<input/>` element
            // because "keydown" events may bubble from arbitrary child elements
            // so there's no guarantee that `event.target` represents an `<input/>` element.
            // Also, since `inputComponent` is not neceesarily an `<input/>`, this check is required too.
            if (event.target instanceof HTMLInputElement) {
                if ($792f316d66ac07e9$var$getCaretPosition(event.target) === $792f316d66ac07e9$var$LEADING_PLUS.length) {
                    event.preventDefault();
                    return;
                }
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        onKeyDown,
        inputFormat
    ]);
}
// Gets the caret position in an `<input/>` field.
// The caret position starts with `0` which means "before the first character".
function $792f316d66ac07e9$var$getCaretPosition(element) {
    return element.selectionStart;
}
var $792f316d66ac07e9$var$BACKSPACE_KEY_CODE = 8;
var $792f316d66ac07e9$var$LEADING_PLUS = '+';


var $513c28f3788e7bce$var$_excluded = [
    "onKeyDown",
    "country",
    "inputFormat",
    "metadata",
    "international",
    "withCountryCallingCode"
];
function $513c28f3788e7bce$var$_extends() {
    $513c28f3788e7bce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $513c28f3788e7bce$var$_extends.apply(this, arguments);
}
function $513c28f3788e7bce$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $513c28f3788e7bce$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $513c28f3788e7bce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $513c28f3788e7bce$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputSmart` is a "smarter" implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's and maintains the caret's position in the process.
   * The caret positioning is maintained using `input-format` library.
   * Relies on being run in a DOM environment for calling caret positioning functions.
   */ function InputSmart(_ref, ref) {
        var onKeyDown = _ref.onKeyDown, country = _ref.country, inputFormat = _ref.inputFormat, _ref$metadata = _ref.metadata, metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, rest = $513c28f3788e7bce$var$_objectWithoutProperties(_ref, $513c28f3788e7bce$var$_excluded);
        var format = (0, $acw62.useCallback)(function(value) {
            // "As you type" formatter.
            var formatter = new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(country, metadata);
            var prefix = (0, $b1cc26643c331962$export$38cc8c9e484aa66b)({
                inputFormat: inputFormat,
                country: country,
                metadata: metadata
            });
            // Format the number.
            var text = formatter.input(prefix + value);
            var template = formatter.getTemplate();
            if (prefix) {
                text = (0, $b1cc26643c331962$export$4be51b112e32592b)(text, prefix);
                // `AsYouType.getTemplate()` can be `undefined`.
                if (template) template = (0, $b1cc26643c331962$export$4be51b112e32592b)(template, prefix);
            }
            return {
                text: text,
                template: template
            };
        }, [
            country,
            metadata
        ]);
        var _onKeyDown = (0, $792f316d66ac07e9$export$2e2bcd8739ae039)({
            onKeyDown: onKeyDown,
            inputFormat: inputFormat
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0d2a50088275844b$export$2e2bcd8739ae039), $513c28f3788e7bce$var$_extends({}, rest, {
            ref: ref,
            parse: (0, $b946be75d7cecb7c$export$2e2bcd8739ae039),
            format: format,
            onKeyDown: _onKeyDown
        }));
    }
    InputSmart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(InputSmart);
    InputSmart.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        /**
     * The format that the input field value is being input/output in.
     */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'INTERNATIONAL',
            'NATIONAL_PART_OF_INTERNATIONAL',
            'NATIONAL',
            'INTERNATIONAL_OR_NATIONAL'
        ]).isRequired,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    };
    return InputSmart;
}
var $513c28f3788e7bce$export$2e2bcd8739ae039 = $513c28f3788e7bce$export$d80fffb1deb3b97e();



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

function $fc4973399c9bb964$export$2e2bcd8739ae039(value, optionsOrDefaultCountry, metadata) {
    if (!metadata) {
        metadata = optionsOrDefaultCountry;
        optionsOrDefaultCountry = undefined;
    }
    return new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(optionsOrDefaultCountry, metadata).input(value);
}




var $d27e17e9551ae473$var$_excluded = [
    "value",
    "onChange",
    "onKeyDown",
    "country",
    "inputFormat",
    "metadata",
    "inputComponent",
    "international",
    "withCountryCallingCode"
];
function $d27e17e9551ae473$var$_extends() {
    $d27e17e9551ae473$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d27e17e9551ae473$var$_extends.apply(this, arguments);
}
function $d27e17e9551ae473$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d27e17e9551ae473$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d27e17e9551ae473$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d27e17e9551ae473$export$d80fffb1deb3b97e(defaultMetadata) {
    /**
   * `InputBasic` is the most basic implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's input but doesn't control the caret in the process:
   * when erasing or inserting digits in the middle of a phone number
   * the caret usually jumps to the end (this is the expected behavior).
   * Why does `InputBasic` exist when there's `InputSmart`?
   * One reason is working around the [Samsung Galaxy smart caret positioning bug]
   * (https://github.com/catamphetamine/react-phone-number-input/issues/75).
   * Another reason is that, unlike `InputSmart`, it doesn't require DOM environment.
   */ function InputBasic(_ref, ref) {
        var value = _ref.value, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, country = _ref.country, inputFormat = _ref.inputFormat, _ref$metadata = _ref.metadata, metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata, _ref$inputComponent = _ref.inputComponent, Input = _ref$inputComponent === void 0 ? 'input' : _ref$inputComponent, international = _ref.international, withCountryCallingCode = _ref.withCountryCallingCode, rest = $d27e17e9551ae473$var$_objectWithoutProperties(_ref, $d27e17e9551ae473$var$_excluded);
        var prefix = (0, $b1cc26643c331962$export$38cc8c9e484aa66b)({
            inputFormat: inputFormat,
            country: country,
            metadata: metadata
        });
        var _onChange = (0, $acw62.useCallback)(function(event) {
            var newValue = (0, $5d722be4de9b0760$export$2e2bcd8739ae039)(event.target.value);
            // By default, if a value is something like `"(123)"`
            // then Backspace would only erase the rightmost brace
            // becoming something like `"(123"`
            // which would give the same `"123"` value
            // which would then be formatted back to `"(123)"`
            // and so a user wouldn't be able to erase the phone number.
            //
            // This issue is worked around with this simple hack:
            // when "old" and "new" parsed values are the same,
            // it checks if the "new" formatted value could be obtained
            // from the "old" formatted value by erasing some (or no) characters at the right side.
            // If it could then it's likely that the user has hit a Backspace key
            // and what they really intended was to erase a rightmost digit rather than
            // a rightmost punctuation character.
            //
            if (newValue === value) {
                var newValueFormatted = $d27e17e9551ae473$var$format(prefix, newValue, country, metadata);
                if (newValueFormatted.indexOf(event.target.value) === 0) // Trim the last digit (or plus sign).
                newValue = newValue.slice(0, -1);
            }
            onChange(newValue);
        }, [
            prefix,
            value,
            onChange,
            country,
            metadata
        ]);
        var _onKeyDown = (0, $792f316d66ac07e9$export$2e2bcd8739ae039)({
            onKeyDown: onKeyDown,
            inputFormat: inputFormat
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, $d27e17e9551ae473$var$_extends({}, rest, {
            ref: ref,
            value: $d27e17e9551ae473$var$format(prefix, value, country, metadata),
            onChange: _onChange,
            onKeyDown: _onKeyDown
        }));
    }
    InputBasic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(InputBasic);
    InputBasic.propTypes = {
        /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        /**
     * A function of `value: string`.
     * Updates the `value` property.
     */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */ country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        /**
     * The format that the input field value is being input/output in.
     */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'INTERNATIONAL',
            'NATIONAL_PART_OF_INTERNATIONAL',
            'NATIONAL',
            'INTERNATIONAL_OR_NATIONAL'
        ]).isRequired,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        /**
     * The `<input/>` component.
     */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
    };
    return InputBasic;
}
var $d27e17e9551ae473$export$2e2bcd8739ae039 = $d27e17e9551ae473$export$d80fffb1deb3b97e();
function $d27e17e9551ae473$var$format(prefix, value, country, metadata) {
    return (0, $b1cc26643c331962$export$4be51b112e32592b)((0, $fc4973399c9bb964$export$2e2bcd8739ae039)(prefix + value, country, metadata), prefix);
}


var $4f7645b27d7fe2d8$var$_excluded = [
    "type",
    "autoComplete",
    "smartCaret",
    "metadata"
];
function $4f7645b27d7fe2d8$var$_extends() {
    $4f7645b27d7fe2d8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f7645b27d7fe2d8$var$_extends.apply(this, arguments);
}
function $4f7645b27d7fe2d8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4f7645b27d7fe2d8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4f7645b27d7fe2d8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4f7645b27d7fe2d8$export$d80fffb1deb3b97e(defaultMetadata) {
    function PhoneInput(_ref, ref) {
        var _ref$type = _ref.type, type = _ref$type === void 0 ? 'tel' : _ref$type, _ref$autoComplete = _ref.autoComplete, autoComplete = _ref$autoComplete === void 0 ? 'tel' : _ref$autoComplete, _ref$smartCaret = _ref.smartCaret, smartCaret = _ref$smartCaret === void 0 ? true : _ref$smartCaret, _ref$metadata = _ref.metadata, metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata, rest = $4f7645b27d7fe2d8$var$_objectWithoutProperties(_ref, $4f7645b27d7fe2d8$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ead78670e00f3ae5$export$2e2bcd8739ae039), $4f7645b27d7fe2d8$var$_extends({}, rest, {
            type: type,
            autoComplete: autoComplete,
            metadata: metadata,
            ref: ref,
            Component: smartCaret ? (0, $513c28f3788e7bce$export$2e2bcd8739ae039) : (0, $d27e17e9551ae473$export$2e2bcd8739ae039)
        }));
    }
    PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(PhoneInput);
    PhoneInput.propTypes = {
        /**
     * HTML `<input/>` `type` attribute.
     */ type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        /**
     * HTML `<input/>` `autocomplete` attribute.
     */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        /**
     * By default, the caret position is being "intelligently" managed
     * while a user inputs a phone number.
     * This "smart" caret behavior can be turned off
     * by passing `smartCaret={false}` property.
     * This is just an "escape hatch" for any possible caret position issues.
     */ // Is `true` by default.
        smartCaret: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        /**
     * `libphonenumber-js` metadata.
     */ metadata: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    };
    return PhoneInput;
}
var $4f7645b27d7fe2d8$export$2e2bcd8739ae039 = $4f7645b27d7fe2d8$export$d80fffb1deb3b97e();


function $331000cdd042dde5$var$call(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $3195bad5b20c0860$export$2e2bcd8739ae039));
    return func.apply(this, args);
}
var $331000cdd042dde5$export$2e2bcd8739ae039 = (0, $4f7645b27d7fe2d8$export$d80fffb1deb3b97e)((0, $3195bad5b20c0860$export$2e2bcd8739ae039));
function $331000cdd042dde5$export$da44e4eaa54bc82e() {
    return $331000cdd042dde5$var$call((0, $fe2783d9f9ccca74$export$2e2bcd8739ae039), arguments);
}
function $331000cdd042dde5$export$842dcfa371c6bb83() {
    return $331000cdd042dde5$var$call((0, $dfa9013f08ee2b8a$export$2e2bcd8739ae039), arguments);
}
function $331000cdd042dde5$export$88012462592bc004() {
    return $331000cdd042dde5$var$call((0, $dfa9013f08ee2b8a$export$88012462592bc004), arguments);
}
function $331000cdd042dde5$export$992e2df24bec72ba() {
    return $331000cdd042dde5$var$call((0, $bbd8ac01a56cfc98$export$2e2bcd8739ae039), arguments);
}
function $331000cdd042dde5$export$e102acdf1aeb3167() {
    return $331000cdd042dde5$var$call((0, $6451538427aaf2b0$export$2e2bcd8739ae039), arguments);
}
function $331000cdd042dde5$export$44f7508c6c352cc6() {
    return $331000cdd042dde5$var$call((0, $34c4bee83c07f6dd$export$2e2bcd8739ae039), arguments);
}
function $331000cdd042dde5$export$32876ca2f1919cf0() {
    return $331000cdd042dde5$var$call((0, $f80aac35004a54c3$export$32876ca2f1919cf0), arguments);
}
function $331000cdd042dde5$export$bd9e113b8b17202a() {
    return $331000cdd042dde5$var$call((0, $f80aac35004a54c3$export$bd9e113b8b17202a), arguments);
}



var $c842ddb70f8ccad0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($c842ddb70f8ccad0$exports, "__esModule", {
    value: true
});
$c842ddb70f8ccad0$exports.default = void 0;

var $c842ddb70f8ccad0$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c842ddb70f8ccad0$var$_default = $c842ddb70f8ccad0$exports.default = (0, $c842ddb70f8ccad0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');



var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


'use client';
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

'use client';
let $15e2b45accdb3531$var$hadKeyboardEvent = true;
let $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
const $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
const $15e2b45accdb3531$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $15e2b45accdb3531$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $15e2b45accdb3531$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $15e2b45accdb3531$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $15e2b45accdb3531$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $15e2b45accdb3531$var$handlePointerDown() {
    $15e2b45accdb3531$var$hadKeyboardEvent = false;
}
function $15e2b45accdb3531$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($15e2b45accdb3531$var$hadFocusVisibleRecently) $15e2b45accdb3531$var$hadKeyboardEvent = true;
    }
}
function $15e2b45accdb3531$var$prepare(doc) {
    doc.addEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $15e2b45accdb3531$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $15e2b45accdb3531$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $15e2b45accdb3531$var$handleVisibilityChange, true);
}
function $15e2b45accdb3531$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $15e2b45accdb3531$var$hadKeyboardEvent || $15e2b45accdb3531$var$focusTriggersKeyboardModality(target);
}
function $15e2b45accdb3531$export$2e2bcd8739ae039() {
    const ref = $acw62.useCallback((node)=>{
        if (node != null) $15e2b45accdb3531$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $acw62.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $15e2b45accdb3531$var$hadFocusVisibleRecently = true;
            $15e2b45accdb3531$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $15e2b45accdb3531$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($15e2b45accdb3531$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $8fc8239a3939454e$export$2e2bcd8739ae039 = (0, $15e2b45accdb3531$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;



var $9QePP = parcelRequire("9QePP");

var $jjlaj = parcelRequire("jjlaj");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $855224273a002a0f$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $855224273a002a0f$var$_ = (t)=>t, $855224273a002a0f$var$_t, $855224273a002a0f$var$_t2, $855224273a002a0f$var$_t3, $855224273a002a0f$var$_t4;
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t || ($855224273a002a0f$var$_t = $855224273a002a0f$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $855224273a002a0f$var$exitKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t2 || ($855224273a002a0f$var$_t2 = $855224273a002a0f$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $855224273a002a0f$var$pulsateKeyframe = (0, $jjlaj.keyframes)($855224273a002a0f$var$_t3 || ($855224273a002a0f$var$_t3 = $855224273a002a0f$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $cb2cd8c78d72bd92$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($855224273a002a0f$var$_t4 || ($855224273a002a0f$var$_t4 = $855224273a002a0f$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible, $855224273a002a0f$var$enterKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving, $855224273a002a0f$var$exitKeyframe, $855224273a002a0f$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate, $855224273a002a0f$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $1En50.default)(props, $855224273a002a0f$var$_excluded);
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $755fb323846f60d4$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $755fb323846f60d4$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $755fb323846f60d4$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, (0, $8nd05.default)({
        className: (0, $9QePP.default)((0, $755fb323846f60d4$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a35786d89db9dda$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $42d7f65840078ec1$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $42d7f65840078ec1$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $1En50.default)(props, $4a35786d89db9dda$var$_excluded);
    const buttonRef = $acw62.useRef(null);
    const rippleRef = $acw62.useRef(null);
    const handleRippleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $acw62.useRef(false);
    const handleKeyDown = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $331f3746e6346411$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $8nd05.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, (0, $8nd05.default)({
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $ayMG0.jsx)((0, $855224273a002a0f$export$2e2bcd8739ae039), (0, $8nd05.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d55ba52db43b55df$export$282216ad123d6580(slot) {
    return (0, $4Cod0.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $beCSm.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$export$2e2bcd8739ae039 = $d55ba52db43b55df$var$accordionSummaryClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a792f5a0c37e2ab$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d55ba52db43b55df$export$282216ad123d6580), classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $d8seH.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $d55ba52db43b55df$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $1En50.default)(props, $1a792f5a0c37e2ab$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $5bbfcb95732dc207$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $8nd05.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a792f5a0c37e2ab$var$AccordionSummaryRoot, (0, $8nd05.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $9QePP.default)(classes.root, className),
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $1a792f5a0c37e2ab$export$2e2bcd8739ae039 = $1a792f5a0c37e2ab$var$AccordionSummary;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4b72c3145e33d8$export$a6afb527becfac26(slot) {
    return (0, $4Cod0.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $beCSm.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$export$2e2bcd8739ae039 = $6e4b72c3145e33d8$var$accordionDetailsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1b78273c1c27a2e1$var$_excluded = [
    "className"
];
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6e4b72c3145e33d8$export$a6afb527becfac26), classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $d8seH.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $1b78273c1c27a2e1$var$_excluded);
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $1b78273c1c27a2e1$export$2e2bcd8739ae039 = $1b78273c1c27a2e1$var$AccordionDetails;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
const $f26e6702e19c1cff$var$renderElementFromObject = (elementObj)=>{
    if (typeof elementObj === 'string' || typeof elementObj === 'number') return elementObj;
    if (!elementObj || typeof elementObj !== 'object') return null;
    const { type: type, props: props } = elementObj;
    const children = Array.isArray(props?.children) ? props.children.map((child, i)=>$f26e6702e19c1cff$var$renderElementFromObject(child)) : $f26e6702e19c1cff$var$renderElementFromObject(props?.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(type, {
        ...props,
        key: props?.key || Math.random()
    }, children);
};
const $f26e6702e19c1cff$var$Button = ({ text: text, onClick: onClick, icon: icon = false, prefixIcon: prefixIcon = false, loading: loading = false, btnType: btnType = "default", customClassName: customClassName = "", disabled: disabled = false, type: type = "button", textClassName: textClassName = "", ...props })=>{
    const defaultClasses = "br50px py0-75rem cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac";
    const btnTypeClasses = btnType === "warningOutlined" ? "bg1 c4 bw1px bss bo4 br50px" : btnType === "warning" ? "bg4 c1" : btnType === "dark" ? "bg2 c1" : "bg3 c1";
    const disabledClass = disabled ?? loading ? "button-disabled op60" : "";
    const combinedClasses = `${defaultClasses} ${btnTypeClasses} ${disabledClass} ${customClassName}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        onClick: (e)=>{
            if (!loading && !disabled) onClick?.(e);
        },
        className: combinedClasses,
        type: type,
        ...props,
        children: [
            prefixIcon && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mr0-5rem df aic",
                children: prefixIcon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: textClassName,
                children: typeof text === 'object' ? $f26e6702e19c1cff$var$renderElementFromObject(text) : text
            }),
            icon && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ml0-5rem df aic",
                children: icon
            })
        ]
    });
};
$f26e6702e19c1cff$var$Button.propTypes = {
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    btnType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "default",
        "warning"
    ]),
    customClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $f26e6702e19c1cff$export$2e2bcd8739ae039 = $f26e6702e19c1cff$var$Button;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");






const $9ec55e6e0def7a00$var$imageMap = {
    emailHeadIcon: (parcelRequire("e4R3c")),
    googleValidatior: (parcelRequire("2rpU4")),
    smsHeadIcon: (parcelRequire("hRmh8"))
};
const $9ec55e6e0def7a00$var$ModalWrapper = ({ children: children, girlComponent: girlComponent, modalType: modalType, headerType: headerType, headerBgIcon: headerBgIcon, heading: heading, onCloseHandler: onCloseHandler, modalCardClasses: modalCardClasses = "", customStyle: customStyle })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const handleClose = ()=>{
        if (modalType !== 'confirmDescription') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (onCloseHandler) onCloseHandler();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: modal['open'] === modalType,
        onClose: handleClose,
        className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df aic jcc mainModalWrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `mah80 oya bg1 shadow w100 bsbb df fdc maw700px br20px ${modalCardClasses} hideScrollbar`,
                    style: customStyle ? customStyle : {
                        padding: headerType ? "0rem !important" : "2rem",
                        zIndex: 9,
                        marginTop: "2rem"
                    },
                    children: [
                        headerType && [
                            "primary"
                        ].includes(headerType) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg-gradient3 p1rem df aic pr",
                            style: {
                                height: "50px",
                                padding: '1rem 1.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c1",
                                    children: heading
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "pa",
                                    src: $9ec55e6e0def7a00$var$imageMap[headerBgIcon ?? "emailHeadIcon"],
                                    alt: "headerBgIcon",
                                    style: {
                                        width: '80px',
                                        right: "80px",
                                        bottom: "0px"
                                    }
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `pr ${modalType == 'fit-report' && 'osc'}`,
                            style: {
                                padding: headerType ? "3rem" : "0rem"
                            },
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc aic",
                    children: girlComponent && girlComponent
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    className: "pa cp",
                    onClick: handleClose,
                    style: {
                        left: '50%',
                        transform: 'translateX(-50%)',
                        bottom: '12px'
                    },
                    width: "60",
                    height: "60",
                    viewBox: "0 0 60 60",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            opacity: "0.8",
                            x: "4",
                            y: "4",
                            width: "52",
                            height: "52",
                            rx: "26",
                            fill: "#151313"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                            fill: "white"
                        })
                    ]
                })
            ]
        })
    });
};
var $9ec55e6e0def7a00$export$2e2bcd8739ae039 = $9ec55e6e0def7a00$var$ModalWrapper;





const $1275acb5c60c38a5$var$EnterCode = ({ authMethod: authMethod, codeEntered: codeEntered, smsEnabled: smsEnabled, twoFaEnabled: twoFaEnabled, emailEnabled: emailEnabled, resendCode: resendCode, counter: counter, modalType: modalType, loading: loading, buttonText: buttonText, isButtonDisabled: isButtonDisabled, loginFor: loginFor })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const onCloseHandler = ()=>{
        dispatch((0, $7fa194fc86099528$export$9b16b760c6b5c1ae)({
            smsEnabled: '',
            twoFaEnabled: '',
            emailEnabled: '',
            hash: '',
            isBillingRoute: false
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            onCloseHandler: onCloseHandler,
            modalType: modalType,
            headerBgIcon: loginFor && loginFor === "google" ? "googleValidatior" : loginFor && loginFor === "sms" ? "smsHeadIcon" : "emailHeadIcon",
            headerType: "primary",
            heading: `${loginFor && loginFor === "google" ? "Google Authenticator" : authMethod ?? ""} Code`,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "c15 fs1-5rem tas w100 lh1 fw600 mb0-5rem",
                        children: [
                            loginFor && loginFor === "google" ? "Google Authenticator" : authMethod,
                            " Verification"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "c43 fs14px w100 tas mb2rem ttl",
                        children: [
                            "Check your ",
                            authMethod == 'Phone' && 'saved',
                            " ",
                            authMethod,
                            " ",
                            authMethod == 'Phone' && 'number',
                            " for a code"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc gg1rem mxa",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    placeholder: "Enter 6 Digit Code",
                                    className: "bg1 pl4rem w100 bg1 bs1px brss bo42 br8px p1rem",
                                    onChange: codeEntered
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "center-vertically f3 pa l0 ml1rem w2rem",
                                    width: "19",
                                    height: "18",
                                    viewBox: "0 0 19 18",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                            "clip-path": "url(#clip0_5984_45681)",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.8048 7.09079C17.1032 7.09079 17.3894 6.97226 17.6003 6.76128C17.8113 6.55031 17.9298 6.26416 17.9298 5.96579C17.9298 5.66742 17.8113 5.38127 17.6003 5.17029C17.3894 4.95932 17.1032 4.84079 16.8048 4.84079H14.8846L15.3817 2.98598C15.4209 2.84297 15.4315 2.69363 15.4128 2.54653C15.394 2.39944 15.3464 2.25749 15.2727 2.12886C15.1989 2.00024 15.1004 1.88746 14.9829 1.79702C14.8654 1.70658 14.7312 1.64026 14.5879 1.60188C14.4447 1.5635 14.2953 1.55382 14.1483 1.57338C14.0013 1.59294 13.8597 1.64137 13.7315 1.71588C13.6033 1.79039 13.491 1.88951 13.4013 2.00753C13.3115 2.12556 13.246 2.26017 13.2084 2.40362L12.5552 4.84079H8.60324L9.52117 1.41562C9.55996 1.27274 9.57017 1.12361 9.55121 0.976779C9.53225 0.829947 9.4845 0.688301 9.41068 0.559963C9.33687 0.431624 9.23845 0.319117 9.12107 0.228892C9.00369 0.138667 8.86965 0.0724993 8.72664 0.0341816C8.58364 -0.0041362 8.43447 -0.01385 8.2877 0.00559722C8.14093 0.0250444 7.99945 0.07327 7.87136 0.147509C7.74326 0.221748 7.63108 0.320541 7.54125 0.438222C7.45141 0.555904 7.38569 0.69016 7.34785 0.833293L6.27389 4.84079H2.125C1.82663 4.84079 1.54048 4.95932 1.3295 5.17029C1.11853 5.38127 1 5.66742 1 5.96579C1 6.26416 1.11853 6.55031 1.3295 6.76128C1.54048 6.97226 1.82663 7.09079 2.125 7.09079H5.67104L4.6482 10.9081H2.125C1.82663 10.9081 1.54048 11.0267 1.3295 11.2376C1.11853 11.4486 1 11.7348 1 12.0331C1 12.3315 1.11853 12.6176 1.3295 12.8286C1.54048 13.0396 1.82663 13.1581 2.125 13.1581H4.0453L3.5483 15.0129C3.5091 15.1559 3.49855 15.3053 3.51727 15.4524C3.53599 15.5995 3.5836 15.7414 3.65737 15.87C3.73114 15.9987 3.82961 16.1115 3.94712 16.2019C4.06463 16.2923 4.19885 16.3587 4.34208 16.397C4.48531 16.4354 4.63472 16.4451 4.7817 16.4255C4.92869 16.406 5.07035 16.3575 5.19856 16.283C5.32676 16.2085 5.43897 16.1094 5.52873 15.9914C5.61849 15.8734 5.68403 15.7387 5.72159 15.5953L6.37469 13.1581H10.3266L9.40867 16.5833C9.36988 16.7262 9.35967 16.8753 9.37863 17.0221C9.39759 17.169 9.44535 17.3106 9.51916 17.439C9.59297 17.5673 9.69139 17.6798 9.80877 17.77C9.92616 17.8602 10.0602 17.9264 10.2032 17.9647C10.3462 18.0031 10.4954 18.0128 10.6421 17.9933C10.7889 17.9739 10.9304 17.9256 11.0585 17.8514C11.1866 17.7772 11.2988 17.6784 11.3886 17.5607C11.4784 17.443 11.5442 17.3088 11.582 17.1656L12.6558 13.1581H16.8048C17.1032 13.1581 17.3894 13.0396 17.6003 12.8286C17.8113 12.6176 17.9298 12.3315 17.9298 12.0331C17.9298 11.7348 17.8113 11.4486 17.6003 11.2376C17.3894 11.0267 17.1032 10.9081 16.8048 10.9081H13.2588L14.2817 7.09079H16.8048ZM10.9295 10.9081H6.97755L8.00038 7.09079H11.9523L10.9295 10.9081Z",
                                                fill: "#151313"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                id: "clip0_5984_45681",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                    width: "18",
                                                    height: "18",
                                                    fill: "white",
                                                    transform: "translate(0.84375 -0.000244141)"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb fdc aic",
                        children: [
                            authMethod !== 'App' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "mt1rem w100 fs1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        if (loading || counter || isButtonDisabled) return;
                                        resendCode();
                                    },
                                    className: "c3 lh3 usn cp",
                                    children: buttonText
                                })
                            }),
                            smsEnabled + twoFaEnabled + emailEnabled > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt2rem w100 fs1rem df jcc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                    btnType: "warning",
                                    text: "Authenticate",
                                    onClick: codeEntered
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $1275acb5c60c38a5$export$2e2bcd8739ae039 = $1275acb5c60c38a5$var$EnterCode;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



function $12074930bd2c1829$export$2e2bcd8739ae039() {
    const filesAllocation = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "FILES_ALLOCATIONS",
        initialState: {
            fileReport: {},
            company: null,
            currentScore: 0,
            reportHistories: [],
            profileClass: null,
            tab: 'repository',
            underProcessingTab: '',
            logList: [],
            rModalData: {
                key: '',
                from: '',
                index: 0,
                fileName: ''
            },
            openRModal: false,
            targetSection: {},
            processing: false,
            autoFillContext: null,
            tempModuleAllocationPatch: null,
            tempModule: null
        },
        reducers: {
            RESET_FILE_ALLOCATION: ()=>{
                return {
                    fileReport: {},
                    company: null,
                    currentScore: 0,
                    reportHistories: [],
                    profileClass: null,
                    tab: 'repository',
                    logList: [],
                    underProcessingTab: '',
                    rModalData: {
                        key: '',
                        from: '',
                        index: 0,
                        fileName: ''
                    },
                    openRModal: false,
                    targetSection: {},
                    processing: false,
                    autoFillContext: null,
                    tempModuleAllocationPatch: null,
                    tempModule: null
                };
            },
            UPDATE: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            },
            SET_LOG_LIST: (state, action)=>{
                return {
                    ...state,
                    logList: action.payload
                };
            },
            SET_FILE_REPORT: (state, action)=>{
                return {
                    ...state,
                    fileReport: action.payload
                };
            },
            SET_CURRENT_SCORE: (state, action)=>{
                return {
                    ...state,
                    currentScore: action.payload
                };
            },
            SET_R_MODAL_DATA: (state, action)=>{
                return {
                    ...state,
                    rModalData: action.payload
                };
            },
            SET_OPEN_R_MODAL: (state, action)=>{
                return {
                    ...state,
                    openRModal: action.payload
                };
            },
            SET_TARGET_SELECTION: (state, action)=>{
                return {
                    ...state,
                    targetSection: action.payload
                };
            },
            SET_FILE_ALLOCATION_COMPANY: (state, action)=>{
                return {
                    ...state,
                    company: action.payload
                };
            },
            SET_PREVIOUS_FILE_DELETE_DATA: (state, action)=>{
                return {
                    ...state,
                    rModalData: {
                        ...state.rModalData,
                        deletedFile: action.payload
                    }
                };
            },
            SET_CHANGE_IMPORT_RESULT: (state, action)=>{
                const { index: index, section: section, originalSection: originalSection } = action.payload;
                return {
                    ...state,
                    fileReport: {
                        ...state.fileReport,
                        importResult: {
                            ...state.fileReport.importResult,
                            [index]: {
                                ...state.fileReport.importResult[index],
                                section: state.fileReport.importResult[index].section.includes(section) ? [
                                    ...state.fileReport.importResult[index].section
                                ] : [
                                    ...state.fileReport.importResult[index].section.slice(0, index),
                                    section,
                                    ...state.fileReport.importResult[index].section.slice(index + 1)
                                ],
                                originalSection: state.fileReport.importResult[index].originalSection.includes(originalSection) ? [
                                    ...state.fileReport.importResult[index].originalSection
                                ] : [
                                    ...state.fileReport.importResult[index].originalSection.slice(0, index),
                                    originalSection,
                                    ...state.fileReport.importResult[index].originalSection.slice(index + 1)
                                ]
                            }
                        }
                    }
                };
            },
            SET_DELETE_IMPORT_RESULT: (state, action)=>{
                const { index: index, qNo: qNo } = action.payload;
                let { [index]: removed, ...newImportResult } = state.fileReport.importResult;
                if (removed.section.length > 1) newImportResult = {
                    ...state.fileReport.importResult,
                    [index]: {
                        ...state.fileReport.importResult[index],
                        section: state.fileReport.importResult[index].section.filter((item)=>item !== qNo),
                        originalSection: state.fileReport.importResult[index].originalSection.filter((item)=>item !== qNo)
                    }
                };
                return {
                    ...state,
                    fileReport: {
                        ...state.fileReport,
                        importResult: newImportResult
                    }
                };
            },
            SET_MATCH_FILE_PROCESSING: (state, action)=>{
                return {
                    ...state,
                    processing: action.payload
                };
            },
            SET_TEMP_MODULE: (state, action)=>{
                return {
                    ...state,
                    tempModule: action.payload
                };
            },
            CLEAR_TEMP_MODULE: (state)=>{
                return {
                    ...state,
                    tempModule: null
                };
            }
        }
    });
    return filesAllocation.reducer;
}
const $12074930bd2c1829$export$7372fe6818c27bf4 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/UPDATE");
const $12074930bd2c1829$export$73dba2c4178787b2 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_LOG_LIST");
const $12074930bd2c1829$export$9291658802bc1f31 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_FILE_REPORT");
const $12074930bd2c1829$export$fb8d60304f3762b3 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_CURRENT_SCORE");
const $12074930bd2c1829$export$9e71295be638232a = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/RESET_FILE_ALLOCATION");
const $12074930bd2c1829$export$ed5d3f61872c9f46 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_FILE_ALLOCATION_COMPANY");
const $12074930bd2c1829$export$484cc9173fdb35fb = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_R_MODAL_DATA");
const $12074930bd2c1829$export$a8d03de66a369b2f = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_OPEN_R_MODAL");
const $12074930bd2c1829$export$d9cc0dc4121e3dbf = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_TARGET_SELECTION");
const $12074930bd2c1829$export$9414060b0d0c1dbd = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_PREVIOUS_FILE_DELETE_DATA");
const $12074930bd2c1829$export$2483210142a94a62 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_CHANGE_IMPORT_RESULT");
const $12074930bd2c1829$export$9a2984d9e2ffd426 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_DELETE_IMPORT_RESULT");
const $12074930bd2c1829$export$4bdbd1eea6fc9500 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_MATCH_FILE_PROCESSING");
const $12074930bd2c1829$export$65113a50fb519714 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/SET_TEMP_MODULE");
const $12074930bd2c1829$export$f7e2ffccf44ba912 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ALLOCATIONS/CLEAR_TEMP_MODULE");



var $8nd05 = parcelRequire("8nd05");
function $c5db23e5823ab236$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}



var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $0c11739df3ac35ad$exports = {};
var $12969ca4851cc4ab$exports = {};
var $4e551d8e73f04819$exports = {};
var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};

var $o8HxT = parcelRequire("o8HxT");
var $03e9beb856e9b4cd$exports = {};

var $o8HxT = parcelRequire("o8HxT");
var $6b5a5095e0934938$exports = {};

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $57wYk = parcelRequire("57wYk");
var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;



var $o8HxT = parcelRequire("o8HxT");

/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $6b5a5095e0934938$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


var $aba0e6d66e8d80dd$exports = {};
var $3da413f0b86c10df$exports = {};
var $96b401257ea00d24$exports = {};
var $31e24313ace94404$exports = {};

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$31e24313ace94404$exports = $31e24313ace94404$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $31e24313ace94404$exports) $31e24313ace94404$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$96b401257ea00d24$exports = $96b401257ea00d24$var$baseAssignValue;



var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $96b401257ea00d24$exports(object, key, value);
}
$3da413f0b86c10df$exports = $3da413f0b86c10df$var$assignValue;




var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $4d60aa8c33155976$exports(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $3da413f0b86c10df$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$aba0e6d66e8d80dd$exports = $aba0e6d66e8d80dd$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $fd2d90f592c63519$exports(object, path);
        if (predicate(value, path)) $aba0e6d66e8d80dd$exports(result, $38afcbfab85a0553$exports(path, object), value);
    }
    return result;
}
$4e551d8e73f04819$exports = $4e551d8e73f04819$var$basePickBy;


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};


var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;


/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $12969ca4851cc4ab$var$basePick(object, paths) {
    return $4e551d8e73f04819$exports(object, paths, function(value, path) {
        return $221e04e57e35dd04$exports(object, path);
    });
}
$12969ca4851cc4ab$exports = $12969ca4851cc4ab$var$basePick;


var $65f64eb9f31faa0d$exports = {};
var $1774e6065e7ade58$exports = {};
var $b1d5985487d54dea$exports = {};

var $hynws = parcelRequire("hynws");
var $035bd928078475ee$exports = {};

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
$035bd928078475ee$exports = $035bd928078475ee$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $035bd928078475ee$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$b1d5985487d54dea$exports = $b1d5985487d54dea$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $b1d5985487d54dea$exports(array, 1) : [];
}
$1774e6065e7ade58$exports = $1774e6065e7ade58$var$flatten;


var $81a5758ee0248452$exports = {};
var $e22d8f7aab4ea8e2$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$e22d8f7aab4ea8e2$exports = $e22d8f7aab4ea8e2$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $e22d8f7aab4ea8e2$exports(func, this, otherArgs);
    };
}
$81a5758ee0248452$exports = $81a5758ee0248452$var$overRest;


var $d9b21a2cad7f96c2$exports = {};
var $1dca5cc74bf5ffaf$exports = {};
var $7111863c3c692f0e$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
$7111863c3c692f0e$exports = $7111863c3c692f0e$var$constant;



var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;


/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$31e24313ace94404$exports ? $37dff9aa04444f9c$exports : function(func, string) {
    return $31e24313ace94404$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $7111863c3c692f0e$exports(string),
        'writable': true
    });
};
$1dca5cc74bf5ffaf$exports = $1dca5cc74bf5ffaf$var$baseSetToString;


var $5c7bd4e931ae22e5$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$5c7bd4e931ae22e5$exports = $5c7bd4e931ae22e5$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $5c7bd4e931ae22e5$exports($1dca5cc74bf5ffaf$exports);
$d9b21a2cad7f96c2$exports = $d9b21a2cad7f96c2$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $d9b21a2cad7f96c2$exports($81a5758ee0248452$exports(func, undefined, $1774e6065e7ade58$exports), func + '');
}
$65f64eb9f31faa0d$exports = $65f64eb9f31faa0d$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0c11739df3ac35ad$var$pick = $65f64eb9f31faa0d$exports(function(object, paths) {
    return object == null ? {} : $12969ca4851cc4ab$exports(object, paths);
});
$0c11739df3ac35ad$exports = $0c11739df3ac35ad$var$pick;


/**
 * Bind `target` event `eventName`'s callback `listener`.
 * @param target The DOM element
 * @param eventType The event name
 * @param listener  The event listener
 * @param options   The event options
 * @returns   The event listener
 */ function $4b481efe1bd5818f$export$2e2bcd8739ae039(target, eventType, listener, options) {
    if (options === void 0) options = false;
    target.addEventListener(eventType, listener, options);
    return {
        off: function off() {
            target.removeEventListener(eventType, listener, options);
        }
    };
}


/**
 * Checks if the current environment is in the browser and can access and modify the DOM.
 */ var $811fd19a8e8dd84e$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $811fd19a8e8dd84e$export$2e2bcd8739ae039 = $811fd19a8e8dd84e$var$canUseDOM;


var $32e2b5e693256d0e$var$vendorMap = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd'
};
function $32e2b5e693256d0e$var$getAnimationEnd() {
    if (!(0, $811fd19a8e8dd84e$export$2e2bcd8739ae039)) return;
    var tempAnimationEnd;
    var style = document.createElement('div').style;
    for(tempAnimationEnd in $32e2b5e693256d0e$var$vendorMap){
        if (style[tempAnimationEnd] !== undefined) return $32e2b5e693256d0e$var$vendorMap[tempAnimationEnd];
    }
}
var $32e2b5e693256d0e$export$2e2bcd8739ae039 = $32e2b5e693256d0e$var$getAnimationEnd;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $d92de691e2831d3f$var$fallback = function fallback(context, node) {
    if (!node) return false;
    do {
        if (node === context) return true;
    }while (node.parentNode && (node = node.parentNode));
    return false;
};
/**
 * Checks if an element contains another given element.
 *
 * @param context The context element
 * @param node The element to check
 * @returns  `true` if the given element is contained, `false` otherwise
 */ var $d92de691e2831d3f$var$contains = function contains(context, node) {
    if (!node) return false;
    if (context.contains) return context.contains(node);
    else if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
    return $d92de691e2831d3f$var$fallback(context, node);
};
var $d92de691e2831d3f$export$2e2bcd8739ae039 = function() {
    return (0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) ? $d92de691e2831d3f$var$contains : $d92de691e2831d3f$var$fallback;
}();



'use client';
var $f1801b0896212a0f$export$8d4e26484c874870 = [
    'lg',
    'md',
    'sm',
    'xs'
];
var $f1801b0896212a0f$export$6afa82b29063cfdc = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $f1801b0896212a0f$export$e50006273435e7d4 = [
    'success',
    'warning',
    'error',
    'info'
];
var $f1801b0896212a0f$export$9b982809044276a6 = [
    'red',
    'orange',
    'yellow',
    'green',
    'cyan',
    'blue',
    'violet'
];
var $f1801b0896212a0f$export$c9e8246f5d409ed4 = [
    'top',
    'bottom',
    'right',
    'left'
];
var $f1801b0896212a0f$export$b93c8cf315cd2a84 = [
    'bottomStart',
    'bottomEnd',
    'topStart',
    'topEnd',
    'leftStart',
    'rightStart',
    'leftEnd',
    'rightEnd'
];
var $f1801b0896212a0f$export$ef781feda84f57d4 = [
    'auto',
    'autoVertical',
    'autoVerticalStart',
    'autoVerticalEnd',
    'autoHorizontal',
    'autoHorizontalStart',
    'autoHorizontalEnd'
];
var $f1801b0896212a0f$export$c34b629d6f12159b = [].concat($f1801b0896212a0f$export$c9e8246f5d409ed4, $f1801b0896212a0f$export$b93c8cf315cd2a84, $f1801b0896212a0f$export$ef781feda84f57d4);
var $f1801b0896212a0f$export$e9d4f6a9a3f298cc = /*#__PURE__*/ function(CHECK_STATE) {
    CHECK_STATE[CHECK_STATE["UNCHECK"] = 0] = "UNCHECK";
    CHECK_STATE[CHECK_STATE["CHECK"] = 1] = "CHECK";
    CHECK_STATE[CHECK_STATE["INDETERMINATE"] = 2] = "INDETERMINATE";
    return CHECK_STATE;
}({});
var $f1801b0896212a0f$export$6d7c697b881f54e2 = /*#__PURE__*/ function(TREE_NODE_DROP_POSITION) {
    TREE_NODE_DROP_POSITION[TREE_NODE_DROP_POSITION["DRAG_OVER"] = 0] = "DRAG_OVER";
    TREE_NODE_DROP_POSITION[TREE_NODE_DROP_POSITION["DRAG_OVER_TOP"] = 1] = "DRAG_OVER_TOP";
    TREE_NODE_DROP_POSITION[TREE_NODE_DROP_POSITION["DRAG_OVER_BOTTOM"] = 2] = "DRAG_OVER_BOTTOM";
    return TREE_NODE_DROP_POSITION;
}({});
var $f1801b0896212a0f$export$5e6a7bdea4157c1c = {
    // Navigation Keys
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown',
    END: 'End',
    HOME: 'Home',
    PAGE_DOWN: 'PageDown',
    PAGE_UP: 'PageUp',
    // Whitespace Keys
    ENTER: 'Enter',
    TAB: 'Tab',
    SPACE: ' ',
    // Editing Keys
    BACKSPACE: 'Backspace',
    DELETE: 'Delete',
    COMMA: ',',
    // UI Keys
    ESC: 'Escape'
};
var $f1801b0896212a0f$export$be389cd803adedc0 = /*#__PURE__*/ function(DATERANGE_DISABLED_TARGET) {
    DATERANGE_DISABLED_TARGET["CALENDAR"] = "CALENDAR";
    DATERANGE_DISABLED_TARGET["TOOLBAR_BUTTON_OK"] = "TOOLBAR_BUTTON_OK";
    DATERANGE_DISABLED_TARGET["TOOLBAR_SHORTCUT"] = "TOOLBAR_SHORTCUT";
    DATERANGE_DISABLED_TARGET["INPUT"] = "INPUT";
    return DATERANGE_DISABLED_TARGET;
}({});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
var $7f5c205b6c67eb69$export$700979bc83e7db82 = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $7f5c205b6c67eb69$export$2e2bcd8739ae039 = $7f5c205b6c67eb69$export$700979bc83e7db82;


'use client';
function $f59008c787bd7bc5$export$ee5b5d04074a389e(fn) {
    var ref = (0, $acw62.useRef)(fn);
    /**
   * use useLayoutEffect instead of useEffect.
   * useLayoutEffect is earlier than useEffect, sometimes we use setState and then use callback immediately,
   * However the state in callback is not the latest, because useEffect is not triggered.
   */ (0, $7f5c205b6c67eb69$export$2e2bcd8739ae039)(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        var _ref$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.call.apply(_ref$current, [
            ref
        ].concat(args));
    }, []);
}
var $f59008c787bd7bc5$export$2e2bcd8739ae039 = $f59008c787bd7bc5$export$ee5b5d04074a389e;


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

'use client';
var $511f343af0455e99$var$MountedPortal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(_ref) {
    var children = _ref.children, container = _ref.container;
    var _useState = (0, $acw62.useState)(false), mounted = _useState[0], setMounted = _useState[1];
    (0, $acw62.useEffect)(function() {
        return setMounted(true);
    }, []);
    if (container && mounted) return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
    return null;
});
function $511f343af0455e99$export$b1072f43c67b540c(props) {
    if (props === void 0) props = {};
    var _props = props, container = _props.container, _props$waitMount = _props.waitMount, waitMount = _props$waitMount === void 0 ? false : _props$waitMount;
    var containerElement = typeof container === 'function' ? container() : container;
    var rootElement = (0, $acw62.useMemo)(function() {
        return (0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) ? containerElement || document.body : null;
    }, [
        containerElement
    ]);
    var Portal = (0, $acw62.useCallback)(function(_ref2) {
        var children = _ref2.children;
        return rootElement != null ? /*#__PURE__*/ (0, $1u0KT.createPortal)(children, rootElement) : null;
    }, [
        rootElement
    ]);
    var WaitMountPortal = (0, $acw62.useCallback)(function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($511f343af0455e99$var$MountedPortal, (0, $8nd05.default)({
            container: rootElement
        }, props));
    }, [
        rootElement
    ]);
    return {
        target: rootElement,
        Portal: waitMount ? WaitMountPortal : Portal
    };
}
var $511f343af0455e99$export$2e2bcd8739ae039 = $511f343af0455e99$export$b1072f43c67b540c;


var $acw62 = parcelRequire("acw62");
'use client';
function $3632fa4a4b1066ee$export$83e2c5f24f19bfaa(value) {
    var valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}
var $3632fa4a4b1066ee$export$2e2bcd8739ae039 = $3632fa4a4b1066ee$export$83e2c5f24f19bfaa;



var $acw62 = parcelRequire("acw62");
'use client';
function $04ef43fe2810d94c$export$328d69a66df243d8(fn) {
    var onUnmount = (0, $3632fa4a4b1066ee$export$2e2bcd8739ae039)(fn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}
var $04ef43fe2810d94c$export$2e2bcd8739ae039 = $04ef43fe2810d94c$export$328d69a66df243d8;


'use client';
function $2a7f3a886704e9aa$export$a34401a08725357c() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.filter(function(f) {
        return f !== null && typeof f !== 'undefined';
    }).reduce(function(acc, f) {
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === undefined) return f;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            f.apply(this, args);
        };
    }, undefined);
}
var $2a7f3a886704e9aa$export$2e2bcd8739ae039 = $2a7f3a886704e9aa$export$a34401a08725357c;

'use client';
var $7404c70a0717e9c1$var$toFnRef = function toFnRef(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $7404c70a0717e9c1$export$c9058316764c140e(refA, refB) {
    var a = $7404c70a0717e9c1$var$toFnRef(refA);
    var b = $7404c70a0717e9c1$var$toFnRef(refB);
    return function(value) {
        if (typeof a === 'function') a(value);
        if (typeof b === 'function') b(value);
    };
}
var $7404c70a0717e9c1$export$2e2bcd8739ae039 = $7404c70a0717e9c1$export$c9058316764c140e;


/**
 * Check whether an element has a specific class
 *
 * @param target The element to be checked
 * @param className The class to be checked
 *
 * @returns `true` if the element has the class, `false` otherwise
 */ function $b96687a822e6b6b3$export$2e2bcd8739ae039(target, className) {
    if (target.classList) return !!className && target.classList.contains(className);
    return (" " + target.className + " ").indexOf(" " + className + " ") !== -1;
}


function $980d0a078c16379b$export$2e2bcd8739ae039(target, className) {
    if (className) {
        if (target.classList) target.classList.add(className);
        else if (!(0, $b96687a822e6b6b3$export$2e2bcd8739ae039)(target, className)) target.className = target.className + " " + className;
    }
    return target;
}


/**
 * Remove a class from a given element
 *
 * @param target The element to remove the class from
 * @param className The class to be removed
 *
 * @returns The target element
 */ function $1033df41708f516f$export$2e2bcd8739ae039(target, className) {
    if (className) {
        if (target.classList) target.classList.remove(className);
        else target.className = target.className.replace(new RegExp("(^|\\s)" + className + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
        .replace(/^\s*|\s*$/g, ''); // trim the ends
    }
    return target;
}


/* eslint-disable */ /**
 * @example
 * underscoreName('getList');
 * => get_list
 */ function $13a1e5f9b9b042d0$export$730f2a930033e8f0(string) {
    return string.replace(/([A-Z])/g, '_$1').toLowerCase();
}
function $13a1e5f9b9b042d0$export$161d051f5dd25de7(string) {
    return string.replace(/\-(\w)/g, function(_char) {
        return _char.slice(1).toUpperCase();
    });
}
function $13a1e5f9b9b042d0$export$6e6a0a3676c4b8bb(string) {
    return string.replace(/([A-Z])/g, '-$1').toLowerCase();
}
function $13a1e5f9b9b042d0$export$4950aa0f605343fb(pattern) {
    var pointer = 0, i;
    for(i = 1; i < arguments.length; i += 1){
        pattern = pattern.split("{" + pointer + "}").join(arguments[i]);
        pointer += 1;
    }
    return pattern;
}


var $8be7b38b60e0f143$var$msPattern = /^ms-/;
var $8be7b38b60e0f143$export$2e2bcd8739ae039 = function(string) {
    return (0, $13a1e5f9b9b042d0$export$6e6a0a3676c4b8bb)(string).replace($8be7b38b60e0f143$var$msPattern, '-ms-');
};


function $a211fe1fc0be32cd$var$_removeStyle(node, key) {
    var _style, _style$removeProperty;
    (_style = node.style) === null || _style === void 0 || (_style$removeProperty = _style.removeProperty) === null || _style$removeProperty === void 0 || _style$removeProperty.call(_style, key);
}
function $a211fe1fc0be32cd$export$2e2bcd8739ae039(node, keys) {
    if (typeof keys === 'string') $a211fe1fc0be32cd$var$_removeStyle(node, keys);
    else if (Array.isArray(keys)) keys.forEach(function(key) {
        return $a211fe1fc0be32cd$var$_removeStyle(node, key);
    });
}


function $71263d6e8f12c1e0$var$addStyle(node, property, value) {
    var css = '';
    var props = property;
    if (typeof property === 'string') {
        if (value === undefined) throw new Error('value is undefined');
        (props = {})[property] = value;
    }
    if (typeof props === 'object') {
        for(var _key in props)if (Object.prototype.hasOwnProperty.call(props, _key)) {
            if (!props[_key] && props[_key] !== 0) (0, $a211fe1fc0be32cd$export$2e2bcd8739ae039)(node, (0, $8be7b38b60e0f143$export$2e2bcd8739ae039)(_key));
            else css += (0, $8be7b38b60e0f143$export$2e2bcd8739ae039)(_key) + ":" + props[_key] + ";";
        }
    }
    node.style.cssText += ";" + css;
}
var $71263d6e8f12c1e0$export$2e2bcd8739ae039 = $71263d6e8f12c1e0$var$addStyle;



var $4a0371c39033e42b$var$msPattern = /^-ms-/;
function $4a0371c39033e42b$export$2e2bcd8739ae039(name) {
    // The `-ms` prefix is converted to lowercase `ms`.
    // http://www.andismith.com/blog/2012/02/modernizr-prefixed/
    return (0, $13a1e5f9b9b042d0$export$161d051f5dd25de7)(name.replace($4a0371c39033e42b$var$msPattern, 'ms-'));
}


var $8e96af1b59ffed00$export$2e2bcd8739ae039 = function(node) {
    if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
    var doc = node.ownerDocument;
    if ('defaultView' in doc) {
        if (doc.defaultView.opener) return node.ownerDocument.defaultView.getComputedStyle(node, null);
        return window.getComputedStyle(node, null);
    }
    return null;
};



function $9af53a4d95c8e25d$export$2e2bcd8739ae039(node, property) {
    if (property) {
        var value = node.style[(0, $4a0371c39033e42b$export$2e2bcd8739ae039)(property)];
        if (value) return value;
        var styles = (0, $8e96af1b59ffed00$export$2e2bcd8739ae039)(node);
        if (styles) return styles.getPropertyValue((0, $8be7b38b60e0f143$export$2e2bcd8739ae039)(property));
    }
    return node.style || (0, $8e96af1b59ffed00$export$2e2bcd8739ae039)(node);
}



var $5f7bfdbdf15b6461$var$size;
function $5f7bfdbdf15b6461$export$2e2bcd8739ae039(recalc) {
    if ($5f7bfdbdf15b6461$var$size === undefined || recalc) {
        if (0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            var body = document.body;
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            body.appendChild(scrollDiv);
            $5f7bfdbdf15b6461$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            body.removeChild(scrollDiv);
        }
    }
    return $5f7bfdbdf15b6461$var$size;
}


/**
 * Get the Window object of browser
 * @param node The DOM element
 * @returns The Window object of browser
 */ function $7f32e46a43e58923$export$2e2bcd8739ae039(node) {
    if (node === (node === null || node === void 0 ? void 0 : node.window)) return node;
    return (node === null || node === void 0 ? void 0 : node.nodeType) === 9 ? (node === null || node === void 0 ? void 0 : node.defaultView) || (node === null || node === void 0 ? void 0 : node.parentWindow) : null;
}


/**
 * Returns the top-level document object of the node.
 * @param node The DOM element
 * @returns The top-level document object of the node
 */ function $98436911cf31d997$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $c6e5828dd334f8e1$var$bodyIsOverflowing(node) {
    var doc = (0, $98436911cf31d997$export$2e2bcd8739ae039)(node);
    var win = (0, $7f32e46a43e58923$export$2e2bcd8739ae039)(doc);
    var fullWidth = win.innerWidth;
    if (doc.body) return doc.body.clientWidth < fullWidth;
    return false;
}
function $c6e5828dd334f8e1$export$2e2bcd8739ae039(container) {
    var win = (0, $7f32e46a43e58923$export$2e2bcd8739ae039)(container);
    var isBody = container && container.tagName.toLowerCase() === 'body';
    return win || isBody ? $c6e5828dd334f8e1$var$bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}


'use client';
function $d4b3bf816da24b42$var$findIndexOf(arr, cb) {
    var index = -1;
    arr.some(function(d, i) {
        if (cb(d, i)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $d4b3bf816da24b42$var$findContainer(data, modal) {
    return $d4b3bf816da24b42$var$findIndexOf(data, function(d) {
        return d.modals.indexOf(modal) !== -1;
    });
}
var $d4b3bf816da24b42$var$ModalManager = /*#__PURE__*/ function() {
    function ModalManager() {
        this.modals = [];
        this.containers = [];
        this.data = [];
    }
    var _proto = ModalManager.prototype;
    _proto.add = function add(modal, container, className) {
        var modalIndex = this.modals.indexOf(modal);
        var containerIndex = this.containers.indexOf(container);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        if (containerIndex !== -1) {
            this.data[containerIndex].modals.push(modal);
            return modalIndex;
        }
        var containerState = {
            modals: [
                modal
            ],
            classes: className ? className.split(/\s+/) : [],
            style: {
                overflow: container.style.overflow,
                paddingRight: container.style.paddingRight
            },
            overflowing: (0, $c6e5828dd334f8e1$export$2e2bcd8739ae039)(container)
        };
        if (containerState.overflowing) {
            var paddingRight = parseInt((0, $9af53a4d95c8e25d$export$2e2bcd8739ae039)(container, 'paddingRight') || 0, 10);
            var barSize = (0, $5f7bfdbdf15b6461$export$2e2bcd8739ae039)();
            (0, $71263d6e8f12c1e0$export$2e2bcd8739ae039)(container, {
                paddingRight: (barSize ? paddingRight + barSize : paddingRight) + 'px'
            });
        }
        containerState.classes.forEach((0, $980d0a078c16379b$export$2e2bcd8739ae039).bind(null, container));
        this.containers.push(container);
        this.data.push(containerState);
        return modalIndex;
    };
    _proto.remove = function remove(modal) {
        var modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return;
        var containerIndex = $d4b3bf816da24b42$var$findContainer(this.data, modal);
        var containerState = this.data[containerIndex];
        var container = this.containers[containerIndex];
        containerState.modals.splice(containerState.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        if (containerState.modals.length === 0) {
            Object.keys(containerState.style).forEach(function(key) {
                return container.style[key] = containerState.style[key];
            });
            containerState.classes.forEach((0, $1033df41708f516f$export$2e2bcd8739ae039).bind(null, container));
            this.containers.splice(containerIndex, 1);
            this.data.splice(containerIndex, 1);
        }
    };
    _proto.isTopModal = function isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    };
    return ModalManager;
}();
var $d4b3bf816da24b42$export$2e2bcd8739ae039 = $d4b3bf816da24b42$var$ModalManager;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

function $7b0b1ad88b17cbf9$var$getTransitionProperties() {
    if (!(0, $811fd19a8e8dd84e$export$2e2bcd8739ae039)) return {};
    var vendorMap = {
        O: function O(e) {
            return "o" + e.toLowerCase();
        },
        Moz: function Moz(e) {
            return e.toLowerCase();
        },
        Webkit: function Webkit(e) {
            return "webkit" + e;
        },
        ms: function ms(e) {
            return "MS" + e;
        }
    };
    var vendors = Object.keys(vendorMap);
    var style = document.createElement('div').style;
    var tempTransitionEnd;
    var tempPrefix = '';
    for(var i = 0; i < vendors.length; i += 1){
        var vendor = vendors[i];
        if (vendor + "TransitionProperty" in style) {
            tempPrefix = "-" + vendor.toLowerCase();
            tempTransitionEnd = vendorMap[vendor]('TransitionEnd');
            break;
        }
    }
    if (!tempTransitionEnd && 'transitionProperty' in style) tempTransitionEnd = 'transitionend';
    style = null;
    var addPrefix = function addPrefix(name) {
        return tempPrefix + "-" + name;
    };
    return {
        end: tempTransitionEnd,
        backfaceVisibility: addPrefix('backface-visibility'),
        transform: addPrefix('transform'),
        property: addPrefix('transition-property'),
        timing: addPrefix('transition-timing-function'),
        delay: addPrefix('transition-delay'),
        duration: addPrefix('transition-duration')
    };
}
var $7b0b1ad88b17cbf9$export$2e2bcd8739ae039 = $7b0b1ad88b17cbf9$var$getTransitionProperties;


function $7b2db0ed3c68edb6$export$2e2bcd8739ae039() {
    return (0, $7b0b1ad88b17cbf9$export$2e2bcd8739ae039)().end;
}




var $8g1PZ = parcelRequire("8g1PZ");

var $01ubZ = parcelRequire("01ubZ");
var $3c843a8ff84cd42d$exports = {};

var $ee040e257a097984$exports = {};

var $g779E = parcelRequire("g779E");
var $88035f224ff89479$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$88035f224ff89479$exports = $88035f224ff89479$var$arrayEach;



var $0b43ef5c64ba7f70$exports = {};
var $971be9a5edcd8d07$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $96b401257ea00d24$exports(object, key, newValue);
        else $3da413f0b86c10df$exports(object, key, newValue);
    }
    return object;
}
$971be9a5edcd8d07$exports = $971be9a5edcd8d07$var$copyObject;



var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $971be9a5edcd8d07$exports(source, $LAMcS(source), object);
}
$0b43ef5c64ba7f70$exports = $0b43ef5c64ba7f70$var$baseAssign;


var $0e266213253a5976$exports = {};

var $af87da9a76941740$exports = {};

var $8C60w = parcelRequire("8C60w");
var $363905e043db7569$exports = {};

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");
var $578c86548a505f7a$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$578c86548a505f7a$exports = $578c86548a505f7a$var$nativeKeysIn;


/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $578c86548a505f7a$exports(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$363905e043db7569$exports = $363905e043db7569$var$baseKeysIn;



var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $363905e043db7569$exports(object);
}
$af87da9a76941740$exports = $af87da9a76941740$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $971be9a5edcd8d07$exports(source, $af87da9a76941740$exports(source), object);
}
$0e266213253a5976$exports = $0e266213253a5976$var$baseAssignIn;



var $uQ1Em = parcelRequire("uQ1Em");
var $7b3d95b0cd9dcb32$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$7b3d95b0cd9dcb32$exports = $7b3d95b0cd9dcb32$var$copyArray;


var $ce60b583e6a24a63$exports = {};


var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $971be9a5edcd8d07$exports(source, $6YcYN(source), object);
}
$ce60b583e6a24a63$exports = $ce60b583e6a24a63$var$copySymbols;


var $55e06195de8b50ba$exports = {};

var $77e3eeed2d30c6bc$exports = {};

var $hynws = parcelRequire("hynws");
var $8e492c1d7a7ea307$exports = {};

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
$8e492c1d7a7ea307$exports = $8e492c1d7a7ea307$var$getPrototype;



var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $8e492c1d7a7ea307$exports(object);
    }
    return result;
};
$77e3eeed2d30c6bc$exports = $77e3eeed2d30c6bc$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $971be9a5edcd8d07$exports(source, $77e3eeed2d30c6bc$exports(source), object);
}
$55e06195de8b50ba$exports = $55e06195de8b50ba$var$copySymbolsIn;



var $apVCl = parcelRequire("apVCl");
var $d1b85174ea17081a$exports = {};

var $ctgi8 = parcelRequire("ctgi8");


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $af87da9a76941740$exports, $77e3eeed2d30c6bc$exports);
}
$d1b85174ea17081a$exports = $d1b85174ea17081a$var$getAllKeysIn;



var $67A6V = parcelRequire("67A6V");
var $392dfd68f4953502$exports = {};
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $392dfd68f4953502$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$392dfd68f4953502$exports = $392dfd68f4953502$var$initCloneArray;


var $85aa01d56b12d536$exports = {};
var $e0e8a62ea95bc20a$exports = {};

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
$e0e8a62ea95bc20a$exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;


var $7d49423a2080f7e8$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $e0e8a62ea95bc20a$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$7d49423a2080f7e8$exports = $7d49423a2080f7e8$var$cloneDataView;


var $42a38980bea1ca34$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$42a38980bea1ca34$exports = $42a38980bea1ca34$var$cloneRegExp;


var $e3a191b3227aae5b$exports = {};

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
$e3a191b3227aae5b$exports = $e3a191b3227aae5b$var$cloneSymbol;


var $42cd9d64f56ec214$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $e0e8a62ea95bc20a$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$42cd9d64f56ec214$exports = $42cd9d64f56ec214$var$cloneTypedArray;


/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = '[object Boolean]', $85aa01d56b12d536$var$dateTag = '[object Date]', $85aa01d56b12d536$var$mapTag = '[object Map]', $85aa01d56b12d536$var$numberTag = '[object Number]', $85aa01d56b12d536$var$regexpTag = '[object RegExp]', $85aa01d56b12d536$var$setTag = '[object Set]', $85aa01d56b12d536$var$stringTag = '[object String]', $85aa01d56b12d536$var$symbolTag = '[object Symbol]';
var $85aa01d56b12d536$var$arrayBufferTag = '[object ArrayBuffer]', $85aa01d56b12d536$var$dataViewTag = '[object DataView]', $85aa01d56b12d536$var$float32Tag = '[object Float32Array]', $85aa01d56b12d536$var$float64Tag = '[object Float64Array]', $85aa01d56b12d536$var$int8Tag = '[object Int8Array]', $85aa01d56b12d536$var$int16Tag = '[object Int16Array]', $85aa01d56b12d536$var$int32Tag = '[object Int32Array]', $85aa01d56b12d536$var$uint8Tag = '[object Uint8Array]', $85aa01d56b12d536$var$uint8ClampedTag = '[object Uint8ClampedArray]', $85aa01d56b12d536$var$uint16Tag = '[object Uint16Array]', $85aa01d56b12d536$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $e0e8a62ea95bc20a$exports(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $7d49423a2080f7e8$exports(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $42cd9d64f56ec214$exports(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $42a38980bea1ca34$exports(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $e3a191b3227aae5b$exports(object);
    }
}
$85aa01d56b12d536$exports = $85aa01d56b12d536$var$initCloneByTag;


var $9f425e619197b80f$exports = {};
var $39ce05228f203f9a$exports = {};

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$39ce05228f203f9a$exports = $39ce05228f203f9a$var$baseCreate;




var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3wZFp(object) ? $39ce05228f203f9a$exports($8e492c1d7a7ea307$exports(object)) : {};
}
$9f425e619197b80f$exports = $9f425e619197b80f$var$initCloneObject;



var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");
var $abac330771f68232$exports = {};
var $7262133281c40437$exports = {};

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
$7262133281c40437$exports = $7262133281c40437$var$baseIsMap;



var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $7262133281c40437$exports;
$abac330771f68232$exports = $abac330771f68232$var$isMap;



var $lsJ54 = parcelRequire("lsJ54");
var $e8d4e2fa1f2b8f08$exports = {};
var $aad482e59457493b$exports = {};

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
$aad482e59457493b$exports = $aad482e59457493b$var$baseIsSet;



var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $aad482e59457493b$exports;
$e8d4e2fa1f2b8f08$exports = $e8d4e2fa1f2b8f08$var$isSet;



var $LAMcS = parcelRequire("LAMcS");

/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = '[object Arguments]', $ee040e257a097984$var$arrayTag = '[object Array]', $ee040e257a097984$var$boolTag = '[object Boolean]', $ee040e257a097984$var$dateTag = '[object Date]', $ee040e257a097984$var$errorTag = '[object Error]', $ee040e257a097984$var$funcTag = '[object Function]', $ee040e257a097984$var$genTag = '[object GeneratorFunction]', $ee040e257a097984$var$mapTag = '[object Map]', $ee040e257a097984$var$numberTag = '[object Number]', $ee040e257a097984$var$objectTag = '[object Object]', $ee040e257a097984$var$regexpTag = '[object RegExp]', $ee040e257a097984$var$setTag = '[object Set]', $ee040e257a097984$var$stringTag = '[object String]', $ee040e257a097984$var$symbolTag = '[object Symbol]', $ee040e257a097984$var$weakMapTag = '[object WeakMap]';
var $ee040e257a097984$var$arrayBufferTag = '[object ArrayBuffer]', $ee040e257a097984$var$dataViewTag = '[object DataView]', $ee040e257a097984$var$float32Tag = '[object Float32Array]', $ee040e257a097984$var$float64Tag = '[object Float64Array]', $ee040e257a097984$var$int8Tag = '[object Int8Array]', $ee040e257a097984$var$int16Tag = '[object Int16Array]', $ee040e257a097984$var$int32Tag = '[object Int32Array]', $ee040e257a097984$var$uint8Tag = '[object Uint8Array]', $ee040e257a097984$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ee040e257a097984$var$uint16Tag = '[object Uint16Array]', $ee040e257a097984$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $392dfd68f4953502$exports(value);
        if (!isDeep) return $7b3d95b0cd9dcb32$exports(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $9f425e619197b80f$exports(value);
            if (!isDeep) return isFlat ? $55e06195de8b50ba$exports(value, $0e266213253a5976$exports(result, value)) : $ce60b583e6a24a63$exports(value, $0b43ef5c64ba7f70$exports(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $85aa01d56b12d536$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($e8d4e2fa1f2b8f08$exports(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($abac330771f68232$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $d1b85174ea17081a$exports : $apVCl : isFlat ? $af87da9a76941740$exports : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $88035f224ff89479$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $3da413f0b86c10df$exports(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$ee040e257a097984$exports = $ee040e257a097984$var$baseClone;


var $c48cdc53eae67a7f$exports = {};

var $c9d0ae50fd1d1372$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$c9d0ae50fd1d1372$exports = $c9d0ae50fd1d1372$var$last;


var $b03c5325a6e99e83$exports = {};

var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $b03c5325a6e99e83$var$parent(object, path) {
    return path.length < 2 ? object : $fd2d90f592c63519$exports(object, $109fb88fe59de104$exports(path, 0, -1));
}
$b03c5325a6e99e83$exports = $b03c5325a6e99e83$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c48cdc53eae67a7f$var$baseUnset(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    object = $b03c5325a6e99e83$exports(object, path);
    return object == null || delete object[$4d60aa8c33155976$exports($c9d0ae50fd1d1372$exports(path))];
}
$c48cdc53eae67a7f$exports = $c48cdc53eae67a7f$var$baseUnset;




var $fd10ae4394ad99ac$exports = {};
var $0658be17f7793a43$exports = {};

var $eq6CV = parcelRequire("eq6CV");


var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $8e492c1d7a7ea307$exports(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
$0658be17f7793a43$exports = $0658be17f7793a43$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $fd10ae4394ad99ac$var$customOmitClone(value) {
    return $0658be17f7793a43$exports(value) ? undefined : value;
}
$fd10ae4394ad99ac$exports = $fd10ae4394ad99ac$var$customOmitClone;




/** Used to compose bitmasks for cloning. */ var $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG = 1, $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG = 2, $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3c843a8ff84cd42d$var$omit = $65f64eb9f31faa0d$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $d26d80da1ba3948c$exports(paths, function(path) {
        path = $38afcbfab85a0553$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $971be9a5edcd8d07$exports(object, $d1b85174ea17081a$exports(object), result);
    if (isDeep) result = $ee040e257a097984$exports(result, $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG | $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG | $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG, $fd10ae4394ad99ac$exports);
    var length = paths.length;
    while(length--)$c48cdc53eae67a7f$exports(result, paths[length]);
    return result;
});
$3c843a8ff84cd42d$exports = $3c843a8ff84cd42d$var$omit;



var $1u0KT = parcelRequire("1u0KT");
'use client';
function $6ab3c00540e04187$var$safeFindDOMNode(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) {
        var _ReactDOM$findDOMNode;
        // eslint-disable-next-line react/no-find-dom-node
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))), componentOrElement);
    }
    return componentOrElement !== null && componentOrElement !== void 0 ? componentOrElement : null;
}
var $6ab3c00540e04187$var$getRefTarget = function getRefTarget(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
function $6ab3c00540e04187$export$f39f755673ece9e2(elementOrRef) {
    // If elementOrRef is an instance of Position, child is returned. [PositionInstance]
    var element = (elementOrRef === null || elementOrRef === void 0 ? void 0 : elementOrRef.root) || (elementOrRef === null || elementOrRef === void 0 ? void 0 : elementOrRef.child) || $6ab3c00540e04187$var$getRefTarget(elementOrRef);
    // Native HTML elements
    if (element !== null && element !== void 0 && element.nodeType && typeof (element === null || element === void 0 ? void 0 : element.nodeName) === 'string') return element;
    // If you can't get the native HTML element, you can only get it through findDOMNode.
    // eslint-disable-next-line react/no-find-dom-node
    return $6ab3c00540e04187$var$safeFindDOMNode(element);
}
var $6ab3c00540e04187$export$2e2bcd8739ae039 = $6ab3c00540e04187$export$f39f755673ece9e2;



var $c9Z8w = parcelRequire("c9Z8w");
'use client';
function $a77f7e738cb2befc$export$28d0368b780d535f() {
    var style = document.createElement('div').style;
    if ('webkitAnimation' in style) return 'webkitAnimationEnd';
    return 'animationend';
}
var $a77f7e738cb2befc$export$6df8085e712d47be = {
    onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};


'use client';
var $bd85cc44fa7d33b8$var$_excluded = [
    "children",
    "className",
    "exitedClassName",
    "enteringClassName",
    "enteredClassName",
    "exitingClassName"
];
var $bd85cc44fa7d33b8$export$e50006273435e7d4 = /*#__PURE__*/ function(STATUS) {
    STATUS[STATUS["UNMOUNTED"] = 0] = "UNMOUNTED";
    STATUS[STATUS["EXITED"] = 1] = "EXITED";
    STATUS[STATUS["ENTERING"] = 2] = "ENTERING";
    STATUS[STATUS["ENTERED"] = 3] = "ENTERED";
    STATUS[STATUS["EXITING"] = 4] = "EXITING";
    return STATUS;
}({});
var $bd85cc44fa7d33b8$export$8368a12614335edb = (0, $8nd05.default)({}, (0, $a77f7e738cb2befc$export$6df8085e712d47be), {
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    transitionAppear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    timeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    exitedClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    exitingClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    enteredClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    enteringClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
});
/**
 * A Transition component for animation.
 * @see https://rsuitejs.com/components/animation/#transition
 */ var $bd85cc44fa7d33b8$var$Transition = /*#__PURE__*/ function(_React$Component) {
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.animationEventListener = null;
        _this.instanceElement = null;
        _this.nextCallback = null;
        _this.needsUpdate = null;
        _this.childRef = void 0;
        var initialStatus;
        if (props.in) initialStatus = props.transitionAppear ? $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITED : $bd85cc44fa7d33b8$export$e50006273435e7d4.ENTERED;
        else initialStatus = props.unmountOnExit ? $bd85cc44fa7d33b8$export$e50006273435e7d4.UNMOUNTED : $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        _this.childRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        return _this;
    }
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.in && nextProps.unmountOnExit) {
            if (prevState.status === $bd85cc44fa7d33b8$export$e50006273435e7d4.UNMOUNTED) // Start enter transition in componentDidUpdate.
            return {
                status: $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITED
            };
        }
        return null;
    };
    var _proto = Transition.prototype;
    _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate() {
        if (!this.props.in || !this.props.unmountOnExit) this.needsUpdate = true;
        return null;
    };
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.transitionAppear && this.props.in) this.performEnter(this.props);
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var status = this.state.status;
        var unmountOnExit = this.props.unmountOnExit;
        if (unmountOnExit && status === $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITED) {
            if (this.props.in) this.performEnter(this.props);
            else if (this.instanceElement) this.setState({
                status: $bd85cc44fa7d33b8$export$e50006273435e7d4.UNMOUNTED
            });
            return;
        }
        if (this.needsUpdate) {
            this.needsUpdate = false;
            if (this.props.in) {
                if (status === $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITING || status === $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITED) this.performEnter(this.props);
            } else if (status === $bd85cc44fa7d33b8$export$e50006273435e7d4.ENTERING || status === $bd85cc44fa7d33b8$export$e50006273435e7d4.ENTERED) this.performExit(this.props);
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
        this.instanceElement = null;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, handler) {
        var _this$animationEventL;
        this.setNextCallback(handler);
        (_this$animationEventL = this.animationEventListener) === null || _this$animationEventL === void 0 || _this$animationEventL.off();
        if (!this.nextCallback) return;
        if (node) {
            var _this$props = this.props, timeout = _this$props.timeout, animation = _this$props.animation;
            this.animationEventListener = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(node, animation ? (0, $a77f7e738cb2befc$export$28d0368b780d535f)() : (0, $7b2db0ed3c68edb6$export$2e2bcd8739ae039)(), this.nextCallback);
            if (timeout !== null) setTimeout(this.nextCallback, timeout);
        } else setTimeout(this.nextCallback, 0);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this2 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (!active) return;
            if (event) {
                if (_this2.instanceElement === event.target) {
                    callback(event);
                    active = false;
                    _this2.nextCallback = null;
                }
                return;
            }
            callback(event);
            active = false;
            _this2.nextCallback = null;
        };
        if (this.nextCallback) this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.getChildElement = function getChildElement() {
        if (this.childRef.current) return (0, $6ab3c00540e04187$export$f39f755673ece9e2)(this.childRef.current);
        return (0, $6ab3c00540e04187$export$f39f755673ece9e2)(this);
    };
    _proto.performEnter = function performEnter(props) {
        var _this3 = this;
        var _ref = props || this.props, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered;
        this.cancelNextCallback();
        var node = this.getChildElement();
        this.instanceElement = node;
        onEnter === null || onEnter === void 0 || onEnter(node);
        this.safeSetState({
            status: $bd85cc44fa7d33b8$export$e50006273435e7d4.ENTERING
        }, function() {
            onEntering === null || onEntering === void 0 || onEntering(node);
            _this3.onTransitionEnd(node, function() {
                _this3.safeSetState({
                    status: $bd85cc44fa7d33b8$export$e50006273435e7d4.ENTERED
                }, function() {
                    onEntered === null || onEntered === void 0 || onEntered(node);
                });
            });
        });
    };
    _proto.performExit = function performExit(props) {
        var _this4 = this;
        var _ref2 = props || this.props, onExit = _ref2.onExit, onExiting = _ref2.onExiting, onExited = _ref2.onExited;
        this.cancelNextCallback();
        var node = this.getChildElement();
        this.instanceElement = node;
        onExit === null || onExit === void 0 || onExit(node);
        this.safeSetState({
            status: $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITING
        }, function() {
            onExiting === null || onExiting === void 0 || onExiting(node);
            _this4.onTransitionEnd(node, function() {
                _this4.safeSetState({
                    status: $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITED
                }, function() {
                    onExited === null || onExited === void 0 || onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        if (this.instanceElement) {
            var nextCallback = this.setNextCallback(callback);
            this.setState(nextState, function() {
                return nextCallback === null || nextCallback === void 0 ? void 0 : nextCallback();
            });
        }
    };
    _proto.render = function render() {
        var _child$props;
        var status = this.state.status;
        if (status === $bd85cc44fa7d33b8$export$e50006273435e7d4.UNMOUNTED) return null;
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, exitedClassName = _this$props2.exitedClassName, enteringClassName = _this$props2.enteringClassName, enteredClassName = _this$props2.enteredClassName, exitingClassName = _this$props2.exitingClassName, rest = (0, $1En50.default)(_this$props2, $bd85cc44fa7d33b8$var$_excluded);
        var childProps = (0, (/*@__PURE__*/$parcel$interopDefault($3c843a8ff84cd42d$exports)))(rest, Object.keys($bd85cc44fa7d33b8$export$8368a12614335edb));
        var transitionClassName;
        if (status === $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITED) transitionClassName = exitedClassName;
        else if (status === $bd85cc44fa7d33b8$export$e50006273435e7d4.ENTERING) transitionClassName = enteringClassName;
        else if (status === $bd85cc44fa7d33b8$export$e50006273435e7d4.ENTERED) transitionClassName = enteredClassName;
        else if (status === $bd85cc44fa7d33b8$export$e50006273435e7d4.EXITING) transitionClassName = exitingClassName;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($01ubZ)))(children)) {
            childProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, transitionClassName);
            return children(childProps, this.childRef);
        }
        var child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, (0, $8nd05.default)({}, childProps, {
            ref: this.childRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.className, transitionClassName)
        }));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$bd85cc44fa7d33b8$var$Transition.propTypes = $bd85cc44fa7d33b8$export$8368a12614335edb;
$bd85cc44fa7d33b8$var$Transition.displayName = 'Transition';
$bd85cc44fa7d33b8$var$Transition.defaultProps = {
    timeout: 1000
};
var $bd85cc44fa7d33b8$export$2e2bcd8739ae039 = $bd85cc44fa7d33b8$var$Transition;



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8g1PZ = parcelRequire("8g1PZ");
var $102d560d26171c3c$exports = {};
var $64bd5b6036bdbf9d$exports = {};
var $8f1d974446c092f9$exports = {};

var $031ea876c9117ba4$exports = {};

var $f0N2p = parcelRequire("f0N2p");
/** Used to store function metadata. */ var $031ea876c9117ba4$var$metaMap = $f0N2p && new $f0N2p;
$031ea876c9117ba4$exports = $031ea876c9117ba4$var$metaMap;


/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8f1d974446c092f9$var$baseSetData = !$031ea876c9117ba4$exports ? $37dff9aa04444f9c$exports : function(func, data) {
    $031ea876c9117ba4$exports.set(func, data);
    return func;
};
$8f1d974446c092f9$exports = $8f1d974446c092f9$var$baseSetData;


var $818905d6edb24a46$exports = {};
var $abb13d5f92d6242d$exports = {};


var $lsJ54 = parcelRequire("lsJ54");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $abb13d5f92d6242d$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $39ce05228f203f9a$exports(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $lsJ54(result) ? result : thisBinding;
    };
}
$abb13d5f92d6242d$exports = $abb13d5f92d6242d$var$createCtor;



var $23YZo = parcelRequire("23YZo");
/** Used to compose bitmasks for function metadata. */ var $818905d6edb24a46$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $818905d6edb24a46$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $818905d6edb24a46$var$WRAP_BIND_FLAG, Ctor = $abb13d5f92d6242d$exports(func);
    function wrapper() {
        var fn = this && this !== $23YZo && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
$818905d6edb24a46$exports = $818905d6edb24a46$var$createBind;


var $f2f9295ccbd7047e$exports = {};


var $40e17ca020405bb7$exports = {};
var $9febeb5629b7a37f$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9febeb5629b7a37f$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $9febeb5629b7a37f$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $9febeb5629b7a37f$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
$9febeb5629b7a37f$exports = $9febeb5629b7a37f$var$composeArgs;


var $9fa26f0fcdcfef63$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9fa26f0fcdcfef63$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $9fa26f0fcdcfef63$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $9fa26f0fcdcfef63$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
$9fa26f0fcdcfef63$exports = $9fa26f0fcdcfef63$var$composeArgsRight;


var $24aad2532b3518f1$exports = {};
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $24aad2532b3518f1$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
$24aad2532b3518f1$exports = $24aad2532b3518f1$var$countHolders;



var $1dfec37085ff9232$exports = {};
var $d5fed6392e1281d7$exports = {};
var $a688c734ec374fd4$exports = {};

var $97a874876d05d0d4$exports = {};
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $97a874876d05d0d4$var$baseLodash() {
// No operation performed.
}
$97a874876d05d0d4$exports = $97a874876d05d0d4$var$baseLodash;


/** Used as references for the maximum length and index of an array. */ var $a688c734ec374fd4$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $a688c734ec374fd4$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $a688c734ec374fd4$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$a688c734ec374fd4$var$LazyWrapper.prototype = $39ce05228f203f9a$exports($97a874876d05d0d4$exports.prototype);
$a688c734ec374fd4$var$LazyWrapper.prototype.constructor = $a688c734ec374fd4$var$LazyWrapper;
$a688c734ec374fd4$exports = $a688c734ec374fd4$var$LazyWrapper;


var $96aba6b902e52ad0$exports = {};

var $6c554e32feae9faa$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
$6c554e32feae9faa$exports = $6c554e32feae9faa$var$noop;


/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $96aba6b902e52ad0$var$getData = !$031ea876c9117ba4$exports ? $6c554e32feae9faa$exports : function(func) {
    return $031ea876c9117ba4$exports.get(func);
};
$96aba6b902e52ad0$exports = $96aba6b902e52ad0$var$getData;


var $afd38c5e3d2ed256$exports = {};
var $8a5c0f3c41d7b4c1$exports = {};
/** Used to lookup unminified function names. */ var $8a5c0f3c41d7b4c1$var$realNames = {};
$8a5c0f3c41d7b4c1$exports = $8a5c0f3c41d7b4c1$var$realNames;


/** Used for built-in method references. */ var $afd38c5e3d2ed256$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $afd38c5e3d2ed256$var$hasOwnProperty = $afd38c5e3d2ed256$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $afd38c5e3d2ed256$var$getFuncName(func) {
    var result = func.name + '', array = $8a5c0f3c41d7b4c1$exports[result], length = $afd38c5e3d2ed256$var$hasOwnProperty.call($8a5c0f3c41d7b4c1$exports, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
$afd38c5e3d2ed256$exports = $afd38c5e3d2ed256$var$getFuncName;


var $59f0d26926dc3a0c$exports = {};

var $59bcfdf0c565caf8$exports = {};


/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $59bcfdf0c565caf8$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$59bcfdf0c565caf8$var$LodashWrapper.prototype = $39ce05228f203f9a$exports($97a874876d05d0d4$exports.prototype);
$59bcfdf0c565caf8$var$LodashWrapper.prototype.constructor = $59bcfdf0c565caf8$var$LodashWrapper;
$59bcfdf0c565caf8$exports = $59bcfdf0c565caf8$var$LodashWrapper;




var $o8HxT = parcelRequire("o8HxT");

var $8l89S = parcelRequire("8l89S");
var $f55df2f31b700310$exports = {};



/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $f55df2f31b700310$var$wrapperClone(wrapper) {
    if (wrapper instanceof $a688c734ec374fd4$exports) return wrapper.clone();
    var result = new $59bcfdf0c565caf8$exports(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $7b3d95b0cd9dcb32$exports(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
$f55df2f31b700310$exports = $f55df2f31b700310$var$wrapperClone;


/** Used for built-in method references. */ var $59f0d26926dc3a0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59f0d26926dc3a0c$var$hasOwnProperty = $59f0d26926dc3a0c$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $59f0d26926dc3a0c$var$lodash(value) {
    if ($8l89S(value) && !$o8HxT(value) && !(value instanceof $a688c734ec374fd4$exports)) {
        if (value instanceof $59bcfdf0c565caf8$exports) return value;
        if ($59f0d26926dc3a0c$var$hasOwnProperty.call(value, '__wrapped__')) return $f55df2f31b700310$exports(value);
    }
    return new $59bcfdf0c565caf8$exports(value);
}
// Ensure wrappers are instances of `baseLodash`.
$59f0d26926dc3a0c$var$lodash.prototype = $97a874876d05d0d4$exports.prototype;
$59f0d26926dc3a0c$var$lodash.prototype.constructor = $59f0d26926dc3a0c$var$lodash;
$59f0d26926dc3a0c$exports = $59f0d26926dc3a0c$var$lodash;


/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $d5fed6392e1281d7$var$isLaziable(func) {
    var funcName = $afd38c5e3d2ed256$exports(func), other = $59f0d26926dc3a0c$exports[funcName];
    if (typeof other != 'function' || !(funcName in $a688c734ec374fd4$exports.prototype)) return false;
    if (func === other) return true;
    var data = $96aba6b902e52ad0$exports(other);
    return !!data && func === data[0];
}
$d5fed6392e1281d7$exports = $d5fed6392e1281d7$var$isLaziable;


var $07f0c55826027de7$exports = {};


/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $07f0c55826027de7$var$setData = $5c7bd4e931ae22e5$exports($8f1d974446c092f9$exports);
$07f0c55826027de7$exports = $07f0c55826027de7$var$setData;


var $696b97c20a313755$exports = {};
var $e12bb3bc395fd1b9$exports = {};
/** Used to match wrap detail comments. */ var $e12bb3bc395fd1b9$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $e12bb3bc395fd1b9$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $e12bb3bc395fd1b9$var$getWrapDetails(source) {
    var match = source.match($e12bb3bc395fd1b9$var$reWrapDetails);
    return match ? match[1].split($e12bb3bc395fd1b9$var$reSplitDetails) : [];
}
$e12bb3bc395fd1b9$exports = $e12bb3bc395fd1b9$var$getWrapDetails;


var $9fbf010585c1ecd7$exports = {};
/** Used to match wrap detail comments. */ var $9fbf010585c1ecd7$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $9fbf010585c1ecd7$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($9fbf010585c1ecd7$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
$9fbf010585c1ecd7$exports = $9fbf010585c1ecd7$var$insertWrapDetails;



var $7c0cf40da5f8aa6c$exports = {};

var $a541279ebb64f2c9$exports = {};
var $565b5ed18efa4b9c$exports = {};
var $a9e76203bd7c412f$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a9e76203bd7c412f$exports = $a9e76203bd7c412f$var$baseFindIndex;


var $c66d4063f81f4687$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
$c66d4063f81f4687$exports = $c66d4063f81f4687$var$baseIsNaN;


var $a1f1a90cd7caaefa$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$a1f1a90cd7caaefa$exports = $a1f1a90cd7caaefa$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $a1f1a90cd7caaefa$exports(array, value, fromIndex) : $a9e76203bd7c412f$exports(array, $c66d4063f81f4687$exports, fromIndex);
}
$565b5ed18efa4b9c$exports = $565b5ed18efa4b9c$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $565b5ed18efa4b9c$exports(array, value, 0) > -1;
}
$a541279ebb64f2c9$exports = $a541279ebb64f2c9$var$arrayIncludes;


/** Used to compose bitmasks for function metadata. */ var $7c0cf40da5f8aa6c$var$WRAP_BIND_FLAG = 1, $7c0cf40da5f8aa6c$var$WRAP_BIND_KEY_FLAG = 2, $7c0cf40da5f8aa6c$var$WRAP_CURRY_FLAG = 8, $7c0cf40da5f8aa6c$var$WRAP_CURRY_RIGHT_FLAG = 16, $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_FLAG = 32, $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $7c0cf40da5f8aa6c$var$WRAP_ARY_FLAG = 128, $7c0cf40da5f8aa6c$var$WRAP_REARG_FLAG = 256, $7c0cf40da5f8aa6c$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $7c0cf40da5f8aa6c$var$wrapFlags = [
    [
        'ary',
        $7c0cf40da5f8aa6c$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $7c0cf40da5f8aa6c$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $7c0cf40da5f8aa6c$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $7c0cf40da5f8aa6c$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $7c0cf40da5f8aa6c$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $7c0cf40da5f8aa6c$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $7c0cf40da5f8aa6c$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $7c0cf40da5f8aa6c$var$updateWrapDetails(details, bitmask) {
    $88035f224ff89479$exports($7c0cf40da5f8aa6c$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$a541279ebb64f2c9$exports(details, value)) details.push(value);
    });
    return details.sort();
}
$7c0cf40da5f8aa6c$exports = $7c0cf40da5f8aa6c$var$updateWrapDetails;


/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $696b97c20a313755$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $d9b21a2cad7f96c2$exports(wrapper, $9fbf010585c1ecd7$exports(source, $7c0cf40da5f8aa6c$exports($e12bb3bc395fd1b9$exports(source), bitmask)));
}
$696b97c20a313755$exports = $696b97c20a313755$var$setWrapToString;


/** Used to compose bitmasks for function metadata. */ var $1dfec37085ff9232$var$WRAP_BIND_FLAG = 1, $1dfec37085ff9232$var$WRAP_BIND_KEY_FLAG = 2, $1dfec37085ff9232$var$WRAP_CURRY_BOUND_FLAG = 4, $1dfec37085ff9232$var$WRAP_CURRY_FLAG = 8, $1dfec37085ff9232$var$WRAP_PARTIAL_FLAG = 32, $1dfec37085ff9232$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1dfec37085ff9232$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $1dfec37085ff9232$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $1dfec37085ff9232$var$WRAP_PARTIAL_FLAG : $1dfec37085ff9232$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $1dfec37085ff9232$var$WRAP_PARTIAL_RIGHT_FLAG : $1dfec37085ff9232$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $1dfec37085ff9232$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($1dfec37085ff9232$var$WRAP_BIND_FLAG | $1dfec37085ff9232$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($d5fed6392e1281d7$exports(func)) $07f0c55826027de7$exports(result, newData);
    result.placeholder = placeholder;
    return $696b97c20a313755$exports(result, func, bitmask);
}
$1dfec37085ff9232$exports = $1dfec37085ff9232$var$createRecurry;


var $bef6e44f852309be$exports = {};
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $bef6e44f852309be$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
$bef6e44f852309be$exports = $bef6e44f852309be$var$getHolder;


var $04bba2c64082f641$exports = {};


var $iyUuu = parcelRequire("iyUuu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $04bba2c64082f641$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $04bba2c64082f641$var$reorder(array, indexes) {
    var arrLength = array.length, length = $04bba2c64082f641$var$nativeMin(indexes.length, arrLength), oldArray = $7b3d95b0cd9dcb32$exports(array);
    while(length--){
        var index = indexes[length];
        array[length] = $iyUuu(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
$04bba2c64082f641$exports = $04bba2c64082f641$var$reorder;


var $f70e1ff2ede69093$exports = {};
/** Used as the internal argument placeholder. */ var $f70e1ff2ede69093$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $f70e1ff2ede69093$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $f70e1ff2ede69093$var$PLACEHOLDER) {
            array[index] = $f70e1ff2ede69093$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
$f70e1ff2ede69093$exports = $f70e1ff2ede69093$var$replaceHolders;



var $23YZo = parcelRequire("23YZo");
/** Used to compose bitmasks for function metadata. */ var $40e17ca020405bb7$var$WRAP_BIND_FLAG = 1, $40e17ca020405bb7$var$WRAP_BIND_KEY_FLAG = 2, $40e17ca020405bb7$var$WRAP_CURRY_FLAG = 8, $40e17ca020405bb7$var$WRAP_CURRY_RIGHT_FLAG = 16, $40e17ca020405bb7$var$WRAP_ARY_FLAG = 128, $40e17ca020405bb7$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $40e17ca020405bb7$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $40e17ca020405bb7$var$WRAP_ARY_FLAG, isBind = bitmask & $40e17ca020405bb7$var$WRAP_BIND_FLAG, isBindKey = bitmask & $40e17ca020405bb7$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($40e17ca020405bb7$var$WRAP_CURRY_FLAG | $40e17ca020405bb7$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $40e17ca020405bb7$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $abb13d5f92d6242d$exports(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $bef6e44f852309be$exports(wrapper), holdersCount = $24aad2532b3518f1$exports(args, placeholder);
        if (partials) args = $9febeb5629b7a37f$exports(args, partials, holders, isCurried);
        if (partialsRight) args = $9fa26f0fcdcfef63$exports(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $f70e1ff2ede69093$exports(args, placeholder);
            return $1dfec37085ff9232$exports(func, bitmask, $40e17ca020405bb7$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $04bba2c64082f641$exports(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $23YZo && this instanceof wrapper) fn = Ctor || $abb13d5f92d6242d$exports(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
$40e17ca020405bb7$exports = $40e17ca020405bb7$var$createHybrid;






var $23YZo = parcelRequire("23YZo");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $f2f9295ccbd7047e$var$createCurry(func, bitmask, arity) {
    var Ctor = $abb13d5f92d6242d$exports(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $bef6e44f852309be$exports(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $f70e1ff2ede69093$exports(args, placeholder);
        length -= holders.length;
        if (length < arity) return $1dfec37085ff9232$exports(func, bitmask, $40e17ca020405bb7$exports, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $23YZo && this instanceof wrapper ? Ctor : func;
        return $e22d8f7aab4ea8e2$exports(fn, this, args);
    }
    return wrapper;
}
$f2f9295ccbd7047e$exports = $f2f9295ccbd7047e$var$createCurry;



var $75fe43ab8fadbeb8$exports = {};



var $23YZo = parcelRequire("23YZo");
/** Used to compose bitmasks for function metadata. */ var $75fe43ab8fadbeb8$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $75fe43ab8fadbeb8$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $75fe43ab8fadbeb8$var$WRAP_BIND_FLAG, Ctor = $abb13d5f92d6242d$exports(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $23YZo && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $e22d8f7aab4ea8e2$exports(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
$75fe43ab8fadbeb8$exports = $75fe43ab8fadbeb8$var$createPartial;



var $fdb8ed38e46ba210$exports = {};



/** Used as the internal argument placeholder. */ var $fdb8ed38e46ba210$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $fdb8ed38e46ba210$var$WRAP_BIND_FLAG = 1, $fdb8ed38e46ba210$var$WRAP_BIND_KEY_FLAG = 2, $fdb8ed38e46ba210$var$WRAP_CURRY_BOUND_FLAG = 4, $fdb8ed38e46ba210$var$WRAP_CURRY_FLAG = 8, $fdb8ed38e46ba210$var$WRAP_ARY_FLAG = 128, $fdb8ed38e46ba210$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fdb8ed38e46ba210$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $fdb8ed38e46ba210$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($fdb8ed38e46ba210$var$WRAP_BIND_FLAG | $fdb8ed38e46ba210$var$WRAP_BIND_KEY_FLAG | $fdb8ed38e46ba210$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $fdb8ed38e46ba210$var$WRAP_ARY_FLAG && bitmask == $fdb8ed38e46ba210$var$WRAP_CURRY_FLAG || srcBitmask == $fdb8ed38e46ba210$var$WRAP_ARY_FLAG && bitmask == $fdb8ed38e46ba210$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($fdb8ed38e46ba210$var$WRAP_ARY_FLAG | $fdb8ed38e46ba210$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $fdb8ed38e46ba210$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $fdb8ed38e46ba210$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $fdb8ed38e46ba210$var$WRAP_BIND_FLAG ? 0 : $fdb8ed38e46ba210$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $9febeb5629b7a37f$exports(partials, value, source[4]) : value;
        data[4] = partials ? $f70e1ff2ede69093$exports(data[3], $fdb8ed38e46ba210$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $9fa26f0fcdcfef63$exports(partials, value, source[6]) : value;
        data[6] = partials ? $f70e1ff2ede69093$exports(data[5], $fdb8ed38e46ba210$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $fdb8ed38e46ba210$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $fdb8ed38e46ba210$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
$fdb8ed38e46ba210$exports = $fdb8ed38e46ba210$var$mergeData;




var $20712de2064d78dd$exports = {};
var $6ceabe126a95a54e$exports = {};
var $dc614d828223dea6$exports = {};
var $0542da1d887b1c4d$exports = {};
var $ef99cce288c7323e$exports = {};
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$ef99cce288c7323e$exports = $ef99cce288c7323e$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $ef99cce288c7323e$exports(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
$0542da1d887b1c4d$exports = $0542da1d887b1c4d$var$baseTrim;



var $lsJ54 = parcelRequire("lsJ54");

/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6b5a5095e0934938$exports(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lsJ54(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $0542da1d887b1c4d$exports(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $dc614d828223dea6$exports(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$6ceabe126a95a54e$exports = $6ceabe126a95a54e$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $6ceabe126a95a54e$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$20712de2064d78dd$exports = $20712de2064d78dd$var$toInteger;


/** Error message constants. */ var $64bd5b6036bdbf9d$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $64bd5b6036bdbf9d$var$WRAP_BIND_FLAG = 1, $64bd5b6036bdbf9d$var$WRAP_BIND_KEY_FLAG = 2, $64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG = 8, $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG = 16, $64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG = 32, $64bd5b6036bdbf9d$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $64bd5b6036bdbf9d$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $64bd5b6036bdbf9d$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $64bd5b6036bdbf9d$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($64bd5b6036bdbf9d$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG | $64bd5b6036bdbf9d$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $64bd5b6036bdbf9d$var$nativeMax($20712de2064d78dd$exports(ary), 0);
    arity = arity === undefined ? arity : $20712de2064d78dd$exports(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $64bd5b6036bdbf9d$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $96aba6b902e52ad0$exports(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fdb8ed38e46ba210$exports(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $64bd5b6036bdbf9d$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG | $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG | $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $64bd5b6036bdbf9d$var$WRAP_BIND_FLAG) var result = $818905d6edb24a46$exports(func, bitmask, thisArg);
    else if (bitmask == $64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG || bitmask == $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG) result = $f2f9295ccbd7047e$exports(func, bitmask, arity);
    else if ((bitmask == $64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG || bitmask == ($64bd5b6036bdbf9d$var$WRAP_BIND_FLAG | $64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $75fe43ab8fadbeb8$exports(func, bitmask, thisArg, partials);
    else result = $40e17ca020405bb7$exports.apply(undefined, newData);
    var setter = data ? $8f1d974446c092f9$exports : $07f0c55826027de7$exports;
    return $696b97c20a313755$exports(setter(result, newData), func, bitmask);
}
$64bd5b6036bdbf9d$exports = $64bd5b6036bdbf9d$var$createWrap;


/** Used to compose bitmasks for function metadata. */ var $102d560d26171c3c$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $102d560d26171c3c$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $64bd5b6036bdbf9d$exports(func, $102d560d26171c3c$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $102d560d26171c3c$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$102d560d26171c3c$var$curry.placeholder = {};
$102d560d26171c3c$exports = $102d560d26171c3c$var$curry;


'use client';
var $ccc57d972485f17c$export$642ee85e8d3ab480 = 'rs-';
var $ccc57d972485f17c$export$103f2b9564b2dd0a = function getClassNamePrefix() {
    // TODO: A prefix that can be replaced at runtime.
    return $ccc57d972485f17c$export$642ee85e8d3ab480;
};
var $ccc57d972485f17c$export$31f03d109ded3cc7 = function defaultClassPrefix(name) {
    return "" + $ccc57d972485f17c$export$103f2b9564b2dd0a() + name;
};
function $ccc57d972485f17c$export$82e9f45cca5ba907(pre, className) {
    if (!pre || !className) return '';
    if (Array.isArray(className)) return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className.filter(function(name) {
        return !!name;
    }).map(function(name) {
        return pre + "-" + name;
    }));
    // TODO Compatible with V4
    if (pre[pre.length - 1] === '-') return "" + pre + className;
    return pre + "-" + className;
}
var $ccc57d972485f17c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($102d560d26171c3c$exports)))($ccc57d972485f17c$export$82e9f45cca5ba907);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $a122465d88af89c7$export$a49f528ae1a4d0ed = /*#__PURE__*/ (0, $acw62.createContext)({});
var $a122465d88af89c7$export$2e2bcd8739ae039 = $a122465d88af89c7$export$a49f528ae1a4d0ed.Provider;




/** events */ 
/**
 * Unbind `target` event `eventName`'s callback `listener`.
 * @param target The DOM element
 * @param eventName The event name
 * @param listener  The event listener
 * @param options The event options
 */ function $bf848f5133bdc642$export$2e2bcd8739ae039(target, eventName, listener, options) {
    if (options === void 0) options = false;
    target.removeEventListener(eventName, listener, options);
}


var $f3e9d60b10878f57$var$_this = undefined;
function $f3e9d60b10878f57$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
function $f3e9d60b10878f57$var$emptyFunction() {}
$f3e9d60b10878f57$var$emptyFunction.thatReturns = $f3e9d60b10878f57$var$makeEmptyFunction;
$f3e9d60b10878f57$var$emptyFunction.thatReturnsFalse = $f3e9d60b10878f57$var$makeEmptyFunction(false);
$f3e9d60b10878f57$var$emptyFunction.thatReturnsTrue = $f3e9d60b10878f57$var$makeEmptyFunction(true);
$f3e9d60b10878f57$var$emptyFunction.thatReturnsNull = $f3e9d60b10878f57$var$makeEmptyFunction(null);
$f3e9d60b10878f57$var$emptyFunction.thatReturnsThis = function() {
    return $f3e9d60b10878f57$var$_this;
};
$f3e9d60b10878f57$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
var $f3e9d60b10878f57$export$2e2bcd8739ae039 = $f3e9d60b10878f57$var$emptyFunction;


var $bccd6aebc54f68c7$var$populated = false; // Browsers
var $bccd6aebc54f68c7$var$_ie;
var $bccd6aebc54f68c7$var$_firefox;
var $bccd6aebc54f68c7$var$_opera;
var $bccd6aebc54f68c7$var$_webkit;
var $bccd6aebc54f68c7$var$_chrome; // Actual IE browser for compatibility mode
var $bccd6aebc54f68c7$var$ieRealVersion; // Platforms
var $bccd6aebc54f68c7$var$_osx;
var $bccd6aebc54f68c7$var$_windows;
var $bccd6aebc54f68c7$var$_linux;
var $bccd6aebc54f68c7$var$_android; // Architectures
var $bccd6aebc54f68c7$var$win64; // Devices
var $bccd6aebc54f68c7$var$_iphone;
var $bccd6aebc54f68c7$var$_ipad;
var $bccd6aebc54f68c7$var$_native;
var $bccd6aebc54f68c7$var$_mobile;
function $bccd6aebc54f68c7$var$populate() {
    if ($bccd6aebc54f68c7$var$populated) return;
    $bccd6aebc54f68c7$var$populated = true; // To work around buggy JS libraries that can't handle multi-digit
    // version numbers, Opera 10's user agent string claims it's Opera
    // 9, then later includes a Version/X.Y field:
    //
    // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
    var uas = navigator.userAgent;
    var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
    var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);
    $bccd6aebc54f68c7$var$_iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
    $bccd6aebc54f68c7$var$_ipad = /\b(iP[ao]d)/.exec(uas);
    $bccd6aebc54f68c7$var$_android = /Android/i.exec(uas);
    $bccd6aebc54f68c7$var$_native = /FBAN\/\w+;/i.exec(uas);
    $bccd6aebc54f68c7$var$_mobile = /Mobile/i.exec(uas); // Note that the IE team blog would have you believe you should be checking
    // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
    // from either x64 or ia64;  so ultimately, you should just check for Win64
    // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
    // Windows will send 'WOW64' instead.
    $bccd6aebc54f68c7$var$win64 = !!/Win64/.exec(uas);
    if (agent) {
        if (agent[1]) $bccd6aebc54f68c7$var$_ie = parseFloat(agent[1]);
        else $bccd6aebc54f68c7$var$_ie = agent[5] ? parseFloat(agent[5]) : NaN;
         // IE compatibility mode
        // @ts-ignore
        if ($bccd6aebc54f68c7$var$_ie && document && document.documentMode) // @ts-ignore
        $bccd6aebc54f68c7$var$_ie = document.documentMode;
         // grab the "true" ie version from the trident token if available
        var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
        $bccd6aebc54f68c7$var$ieRealVersion = trident ? parseFloat(trident[1]) + 4 : $bccd6aebc54f68c7$var$_ie;
        $bccd6aebc54f68c7$var$_firefox = agent[2] ? parseFloat(agent[2]) : NaN;
        $bccd6aebc54f68c7$var$_opera = agent[3] ? parseFloat(agent[3]) : NaN;
        $bccd6aebc54f68c7$var$_webkit = agent[4] ? parseFloat(agent[4]) : NaN;
        if ($bccd6aebc54f68c7$var$_webkit) {
            // We do not add the regexp to the above test, because it will always
            // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
            // the userAgent string.
            agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
            $bccd6aebc54f68c7$var$_chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
        } else $bccd6aebc54f68c7$var$_chrome = NaN;
    } else {
        $bccd6aebc54f68c7$var$_ie = NaN;
        $bccd6aebc54f68c7$var$_firefox = NaN;
        $bccd6aebc54f68c7$var$_opera = NaN;
        $bccd6aebc54f68c7$var$_chrome = NaN;
        $bccd6aebc54f68c7$var$_webkit = NaN;
    }
    if (os) {
        if (os[1]) {
            // Detect OS X version.  If no version number matches, set osx to true.
            // Version examples:  10, 10_6_1, 10.7
            // Parses version number as a float, taking only first two sets of
            // digits.  If only one set of digits is found, returns just the major
            // version number.
            var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);
            $bccd6aebc54f68c7$var$_osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
        } else $bccd6aebc54f68c7$var$_osx = false;
        $bccd6aebc54f68c7$var$_windows = !!os[2];
        $bccd6aebc54f68c7$var$_linux = !!os[3];
    } else {
        $bccd6aebc54f68c7$var$_osx = false;
        $bccd6aebc54f68c7$var$_windows = false;
        $bccd6aebc54f68c7$var$_linux = false;
    }
}
/**
 * @deprecated
 */ var $bccd6aebc54f68c7$var$UserAgent = {
    /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ ie: function ie() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_ie;
    },
    /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */ ieCompatibilityMode: function ieCompatibilityMode() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$ieRealVersion > $bccd6aebc54f68c7$var$_ie;
    },
    /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */ ie64: function ie64() {
        return $bccd6aebc54f68c7$var$UserAgent.ie() && $bccd6aebc54f68c7$var$win64;
    },
    /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ firefox: function firefox() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_firefox;
    },
    /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ opera: function opera() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_opera;
    },
    /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ webkit: function webkit() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_webkit;
    },
    /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */ safari: function safari() {
        return $bccd6aebc54f68c7$var$UserAgent.webkit();
    },
    /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */ chrome: function chrome() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_chrome;
    },
    /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */ windows: function windows() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_windows;
    },
    /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */ osx: function osx() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_osx;
    },
    /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */ linux: function linux() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_linux;
    },
    /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */ iphone: function iphone() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_iphone;
    },
    mobile: function mobile() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_iphone || $bccd6aebc54f68c7$var$_ipad || $bccd6aebc54f68c7$var$_android || $bccd6aebc54f68c7$var$_mobile;
    },
    // webviews inside of the native apps
    nativeApp: function nativeApp() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_native;
    },
    android: function android() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_android;
    },
    ipad: function ipad() {
        return $bccd6aebc54f68c7$var$populate() || $bccd6aebc54f68c7$var$_ipad;
    }
};
var $bccd6aebc54f68c7$export$2e2bcd8739ae039 = $bccd6aebc54f68c7$var$UserAgent;



var $604a2b8efba85abb$var$useHasFeature;
if (0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) $604a2b8efba85abb$var$useHasFeature = document.implementation && document.implementation.hasFeature && // always returns true in newer browsers as per the standard.
// @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
document.implementation.hasFeature('', '') !== true;
function $604a2b8efba85abb$var$isEventSupported(eventNameSuffix, capture) {
    if (!(0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) || capture && !('addEventListener' in document)) return false;
    var eventName = "on" + eventNameSuffix;
    var isSupported = eventName in document;
    if (!isSupported) {
        var element = document.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
    }
    if (!isSupported && $604a2b8efba85abb$var$useHasFeature && eventNameSuffix === 'wheel') // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
    return isSupported;
}
var $604a2b8efba85abb$export$2e2bcd8739ae039 = $604a2b8efba85abb$var$isEventSupported;


var $3ea4560e244cb384$var$PIXEL_STEP = 10;
var $3ea4560e244cb384$var$LINE_HEIGHT = 40;
var $3ea4560e244cb384$var$PAGE_HEIGHT = 800;
function $3ea4560e244cb384$var$normalizeWheel(event) {
    var sX = 0;
    var sY = 0; // spinX, spinY
    var pX = 0;
    var pY = 0; // pixelX, pixelY
    // Legacy
    if ('detail' in event) sY = event.detail;
    if ('wheelDelta' in event) sY = -event.wheelDelta / 120;
    if ('wheelDeltaY' in event) sY = -event.wheelDeltaY / 120;
    if ('wheelDeltaX' in event) sX = -event.wheelDeltaX / 120;
     // side scrolling on FF with DOMMouseScroll
    if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
    }
    pX = sX * $3ea4560e244cb384$var$PIXEL_STEP;
    pY = sY * $3ea4560e244cb384$var$PIXEL_STEP;
    if ('deltaY' in event) pY = event.deltaY;
    if ('deltaX' in event) pX = event.deltaX;
    if ((pX || pY) && event.deltaMode) {
        if (event.deltaMode === 1) {
            // delta in LINE units
            pX *= $3ea4560e244cb384$var$LINE_HEIGHT;
            pY *= $3ea4560e244cb384$var$LINE_HEIGHT;
        } else {
            // delta in PAGE units
            pX *= $3ea4560e244cb384$var$PAGE_HEIGHT;
            pY *= $3ea4560e244cb384$var$PAGE_HEIGHT;
        }
    } // Fall-back if spin cannot be determined
    if (pX && !sX) sX = pX < 1 ? -1 : 1;
    if (pY && !sY) sY = pY < 1 ? -1 : 1;
    return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY
    };
}
/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */ $3ea4560e244cb384$var$normalizeWheel.getEventType = function() {
    if ((0, $bccd6aebc54f68c7$export$2e2bcd8739ae039).firefox()) return 'DOMMouseScroll';
    return (0, $604a2b8efba85abb$export$2e2bcd8739ae039)('wheel') ? 'wheel' : 'mousewheel';
};
var $3ea4560e244cb384$export$2e2bcd8739ae039 = $3ea4560e244cb384$var$normalizeWheel;


// the only reliable means to get the global object is
// `Function('return this')()`
// However, this causes CSP violations in Chrome apps.
// https://github.com/tc39/proposal-global
function $7ac84e095a0daffc$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    throw new Error('unable to locate global object');
}
var $7ac84e095a0daffc$export$2e2bcd8739ae039 = $7ac84e095a0daffc$var$getGlobal;


var $f73fe7bf3049700b$var$g = (0, $7ac84e095a0daffc$export$2e2bcd8739ae039)();
var $f73fe7bf3049700b$var$lastTime = 0;
function $f73fe7bf3049700b$var$_setTimeout(callback) {
    var currTime = Date.now();
    var timeDelay = Math.max(0, 16 - (currTime - $f73fe7bf3049700b$var$lastTime));
    $f73fe7bf3049700b$var$lastTime = currTime + timeDelay;
    return $f73fe7bf3049700b$var$g.setTimeout(function() {
        callback(Date.now());
    }, timeDelay);
}
/**
 * @deprecated Use `requestAnimationFrame` instead.
 */ var $f73fe7bf3049700b$var$requestAnimationFramePolyfill = $f73fe7bf3049700b$var$g.requestAnimationFrame || $f73fe7bf3049700b$var$_setTimeout;
var $f73fe7bf3049700b$export$2e2bcd8739ae039 = $f73fe7bf3049700b$var$requestAnimationFramePolyfill;


var $5a7a4989e8f41982$var$swapWheelAxis = function swapWheelAxis(normalizedEvent) {
    return {
        spinX: normalizedEvent.spinY,
        spinY: normalizedEvent.spinX,
        pixelX: normalizedEvent.pixelY,
        pixelY: normalizedEvent.pixelX
    };
};
/**
 * Used to handle scrolling trackpad and mouse wheel events.
 */ var $5a7a4989e8f41982$var$WheelHandler = /*#__PURE__*/ function() {
    function WheelHandler(onWheel, handleScrollX, handleScrollY, stopPropagation) {
        this.animationFrameID = null;
        this.deltaX = 0;
        this.deltaY = 0;
        this.handleScrollX = null;
        this.handleScrollY = null;
        this.stopPropagation = null;
        this.onWheelCallback = null;
        this.didWheel = this.didWheel.bind(this);
        if (typeof handleScrollX !== 'function') handleScrollX = handleScrollX ? (0, $f3e9d60b10878f57$export$2e2bcd8739ae039).thatReturnsTrue : (0, $f3e9d60b10878f57$export$2e2bcd8739ae039).thatReturnsFalse;
        if (typeof handleScrollY !== 'function') handleScrollY = handleScrollY ? (0, $f3e9d60b10878f57$export$2e2bcd8739ae039).thatReturnsTrue : (0, $f3e9d60b10878f57$export$2e2bcd8739ae039).thatReturnsFalse;
        if (typeof stopPropagation !== 'function') stopPropagation = stopPropagation ? (0, $f3e9d60b10878f57$export$2e2bcd8739ae039).thatReturnsTrue : (0, $f3e9d60b10878f57$export$2e2bcd8739ae039).thatReturnsFalse;
        this.handleScrollX = handleScrollX;
        this.handleScrollY = handleScrollY;
        this.stopPropagation = stopPropagation;
        this.onWheelCallback = onWheel;
        this.onWheel = this.onWheel.bind(this);
    }
    /**
   * Binds the wheel handler.
   * @param event The wheel event.
   */ var _proto = WheelHandler.prototype;
    _proto.onWheel = function onWheel(event) {
        var normalizedEvent = (0, $3ea4560e244cb384$export$2e2bcd8739ae039)(event); // on some platforms (e.g. Win10), browsers do not automatically swap deltas for horizontal scroll
        if (navigator.platform !== 'MacIntel' && event.shiftKey) normalizedEvent = $5a7a4989e8f41982$var$swapWheelAxis(normalizedEvent);
        var deltaX = this.deltaX + normalizedEvent.pixelX;
        var deltaY = this.deltaY + normalizedEvent.pixelY;
        var handleScrollX = this.handleScrollX(deltaX, deltaY);
        var handleScrollY = this.handleScrollY(deltaY, deltaX);
        if (!handleScrollX && !handleScrollY) return;
        this.deltaX += handleScrollX ? normalizedEvent.pixelX : 0;
        this.deltaY += handleScrollY ? normalizedEvent.pixelY : 0;
        event.preventDefault();
        var changed;
        if (this.deltaX !== 0 || this.deltaY !== 0) {
            if (this.stopPropagation()) event.stopPropagation();
            changed = true;
        }
        if (changed === true && this.animationFrameID === null) this.animationFrameID = (0, $f73fe7bf3049700b$export$2e2bcd8739ae039)(this.didWheel);
    } /**
   * Fires a callback if the wheel event has changed.
   */ ;
    _proto.didWheel = function didWheel() {
        this.animationFrameID = null;
        this.onWheelCallback(this.deltaX, this.deltaY);
        this.deltaX = 0;
        this.deltaY = 0;
    };
    return WheelHandler;
}();
var $5a7a4989e8f41982$export$2e2bcd8739ae039 = $5a7a4989e8f41982$var$WheelHandler;


/**
 * Source code reference from:
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/dom/DOMMouseMoveTracker.js
 */ 

var $145759dfcdc4fb8f$var$g = (0, $7ac84e095a0daffc$export$2e2bcd8739ae039)();
/**
 * @deprecated use `cancelAnimationFrame` instead
 */ var $145759dfcdc4fb8f$var$cancelAnimationFramePolyfill = $145759dfcdc4fb8f$var$g.cancelAnimationFrame || $145759dfcdc4fb8f$var$g.clearTimeout;
var $145759dfcdc4fb8f$export$2e2bcd8739ae039 = $145759dfcdc4fb8f$var$cancelAnimationFramePolyfill;



/**
 * Mouse drag tracker, get the coordinate value where the mouse moves in time.
 *
 * ```typescript
 * const tracker = new DOMMouseMoveTracker(
 *   onMove:(deltaX: number, deltaY: number, moveEvent: Object) => void,
 *   onMoveEnd:() => void,
 *   container: HTMLElement
 * );
 * ```
 */ var $8e457b2217606508$var$DOMMouseMoveTracker = /*#__PURE__*/ function() {
    /**
   * onMove is the callback that will be called on every mouse move.
   * onMoveEnd is called on mouse up when movement has ended.
   */ function DOMMouseMoveTracker(onMove, onMoveEnd, domNode) {
        var _this = this;
        this.isDraggingStatus = false;
        this.animationFrameID = null;
        this.domNode = void 0;
        this.onMove = null;
        this.onMoveEnd = null;
        this.eventMoveToken = null;
        this.eventUpToken = null;
        this.moveEvent = null;
        this.deltaX = 0;
        this.deltaY = 0;
        this.x = 0;
        this.y = 0;
        this.isDragging = function() {
            return _this.isDraggingStatus;
        };
        this.onMouseMove = function(event) {
            var x = event.clientX;
            var y = event.clientY;
            _this.deltaX += x - _this.x;
            _this.deltaY += y - _this.y;
            if (_this.animationFrameID === null) // The mouse may move faster then the animation frame does.
            // Use `requestAnimationFramePolyfill` to avoid over-updating.
            _this.animationFrameID = (0, $f73fe7bf3049700b$export$2e2bcd8739ae039)(_this.didMouseMove);
            _this.x = x;
            _this.y = y;
            _this.moveEvent = event;
            event.preventDefault();
        };
        this.didMouseMove = function() {
            _this.animationFrameID = null;
            _this.onMove(_this.deltaX, _this.deltaY, _this.moveEvent);
            _this.deltaX = 0;
            _this.deltaY = 0;
        };
        this.onMouseUp = function(event) {
            if (_this.animationFrameID) _this.didMouseMove();
            _this.onMoveEnd && _this.onMoveEnd(event);
        };
        this.domNode = domNode;
        this.onMove = onMove;
        this.onMoveEnd = onMoveEnd;
    }
    /**
   * This is to set up the listeners for listening to mouse move
   * and mouse up signaling the movement has ended. Please note that these
   * listeners are added at the document.body level. It takes in an event
   * in order to grab inital state.
   */ var _proto = DOMMouseMoveTracker.prototype;
    _proto.captureMouseMoves = function captureMouseMoves(event) {
        if (!this.eventMoveToken && !this.eventUpToken) {
            this.eventMoveToken = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(this.domNode, 'mousemove', this.onMouseMove);
            this.eventUpToken = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(this.domNode, 'mouseup', this.onMouseUp);
        }
        if (!this.isDraggingStatus) {
            this.deltaX = 0;
            this.deltaY = 0;
            this.isDraggingStatus = true;
            this.x = event.clientX;
            this.y = event.clientY;
        }
        event.preventDefault();
    } /**
   * These releases all of the listeners on document.body.
   */ ;
    _proto.releaseMouseMoves = function releaseMouseMoves() {
        if (this.eventMoveToken) {
            this.eventMoveToken.off();
            this.eventMoveToken = null;
        }
        if (this.eventUpToken) {
            this.eventUpToken.off();
            this.eventUpToken = null;
        }
        if (this.animationFrameID !== null) {
            (0, $145759dfcdc4fb8f$export$2e2bcd8739ae039)(this.animationFrameID);
            this.animationFrameID = null;
        }
        if (this.isDraggingStatus) {
            this.isDraggingStatus = false;
            this.x = 0;
            this.y = 0;
        }
    } /**
   * Returns whether or not if the mouse movement is being tracked.
   */ ;
    return DOMMouseMoveTracker;
}();
var $8e457b2217606508$export$2e2bcd8739ae039 = $8e457b2217606508$var$DOMMouseMoveTracker;




/**
 * Track mouse/touch events for a given element.
 */ var $3281f7fed5ffa985$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * onMove is the callback that will be called on every mouse move.
   * onMoveEnd is called on mouse up when movement has ended.
   */ function PointerMoveTracker(domNode, _ref) {
        var _this = this;
        var onMove = _ref.onMove, onMoveEnd = _ref.onMoveEnd, _ref$useTouchEvent = _ref.useTouchEvent, useTouchEvent = _ref$useTouchEvent === void 0 ? true : _ref$useTouchEvent;
        this.isDragStatus = false;
        this.useTouchEvent = true;
        this.animationFrameID = null;
        this.domNode = void 0;
        this.onMove = null;
        this.onMoveEnd = null;
        this.eventMoveToken = null;
        this.eventUpToken = null;
        this.moveEvent = null;
        this.deltaX = 0;
        this.deltaY = 0;
        this.x = 0;
        this.y = 0;
        this.isDragging = function() {
            return _this.isDragStatus;
        };
        this.onDragMove = function(event) {
            var x = _this.getClientX(event);
            var y = _this.getClientY(event);
            _this.deltaX += x - _this.x;
            _this.deltaY += x - _this.y;
            if (_this.animationFrameID === null) // The mouse may move faster then the animation frame does.
            // Use `requestAnimationFrame` to avoid over-updating.
            _this.animationFrameID = requestAnimationFrame(_this.didDragMove);
            _this.x = x;
            _this.y = y;
            _this.moveEvent = event;
            if (event.cancelable) event.preventDefault();
        };
        this.didDragMove = function() {
            _this.animationFrameID = null;
            _this.onMove(_this.deltaX, _this.deltaY, _this.moveEvent);
            _this.deltaX = 0;
            _this.deltaY = 0;
        };
        this.onDragUp = function(event) {
            var _this$onMoveEnd;
            if (_this.animationFrameID) _this.didDragMove();
            (_this$onMoveEnd = _this.onMoveEnd) === null || _this$onMoveEnd === void 0 || _this$onMoveEnd.call(_this, event);
        };
        this.domNode = domNode;
        this.onMove = onMove;
        this.onMoveEnd = onMoveEnd;
        this.useTouchEvent = useTouchEvent;
    }
    var _proto = PointerMoveTracker.prototype;
    _proto.isSupportTouchEvent = function isSupportTouchEvent() {
        return this.useTouchEvent && (0, $604a2b8efba85abb$export$2e2bcd8739ae039)('touchstart');
    };
    _proto.getClientX = function getClientX(event) {
        var _touches;
        return this.isSupportTouchEvent() ? (_touches = event.touches) === null || _touches === void 0 ? void 0 : _touches[0].clientX : event.clientX;
    };
    _proto.getClientY = function getClientY(event) {
        var _touches2;
        return this.isSupportTouchEvent() ? (_touches2 = event.touches) === null || _touches2 === void 0 ? void 0 : _touches2[0].clientY : event.clientY;
    } /**
   * This is to set up the listeners for listening to mouse move
   * and mouse up signaling the movement has ended. Please note that these
   * listeners are added at the document.body level. It takes in an event
   * in order to grab inital state.
   */ ;
    _proto.captureMoves = function captureMoves(event) {
        if (!this.eventMoveToken && !this.eventUpToken) {
            if (this.isSupportTouchEvent()) {
                this.eventMoveToken = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(this.domNode, 'touchmove', this.onDragMove, {
                    passive: false
                });
                this.eventUpToken = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(this.domNode, 'touchend', this.onDragUp, {
                    passive: false
                });
                (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(this.domNode, 'touchcancel', this.releaseMoves);
            } else {
                this.eventMoveToken = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(this.domNode, 'mousemove', this.onDragMove);
                this.eventUpToken = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(this.domNode, 'mouseup', this.onDragUp);
            }
        }
        if (!this.isDragStatus) {
            this.deltaX = 0;
            this.deltaY = 0;
            this.isDragStatus = true;
            this.x = this.getClientX(event);
            this.y = this.getClientY(event);
        }
        if (event.cancelable) event.preventDefault();
    } /**
   * These releases all of the listeners on document.body.
   */ ;
    _proto.releaseMoves = function releaseMoves() {
        if (this.eventMoveToken) {
            this.eventMoveToken.off();
            this.eventMoveToken = null;
        }
        if (this.eventUpToken) {
            this.eventUpToken.off();
            this.eventUpToken = null;
        }
        if (this.animationFrameID !== null) {
            cancelAnimationFrame(this.animationFrameID);
            this.animationFrameID = null;
        }
        if (this.isDragStatus) {
            this.isDragStatus = false;
            this.x = 0;
            this.y = 0;
        }
    } /**
   * Returns whether or not if the mouse movement is being tracked.
   */ ;
    return PointerMoveTracker;
}();








function $9296fc10daa44c26$export$2e2bcd8739ae039(target, className) {
    if ((0, $b96687a822e6b6b3$export$2e2bcd8739ae039)(target, className)) return (0, $1033df41708f516f$export$2e2bcd8739ae039)(target, className);
    return (0, $980d0a078c16379b$export$2e2bcd8739ae039)(target, className);
}







function $f32b1fce627c7f95$export$2e2bcd8739ae039(componentOrElement) {
    var doc = (0, $98436911cf31d997$export$2e2bcd8739ae039)(componentOrElement);
    return doc.defaultView;
}



/**
 * Get a DOM container
 * @param container
 * @param defaultContainer
 * @returns
 */ function $de4d4619469a9fb8$export$2e2bcd8739ae039(container, defaultContainer) {
    container = typeof container === 'function' ? container() : container;
    return container || defaultContainer;
}





/**
 * Gets the number of pixels that an element's content is scrolled vertically.
 * @param node The DOM element
 */ function $d75869c6ce45411c$var$scrollTop(node, val) {
    var win = (0, $7f32e46a43e58923$export$2e2bcd8739ae039)(node);
    var top = node.scrollTop;
    var left = 0;
    if (win) {
        top = win.pageYOffset;
        left = win.pageXOffset;
    }
    if (val !== undefined) {
        if (win) win.scrollTo(left, val);
        else node.scrollTop = val;
    }
    return top;
}
var $d75869c6ce45411c$export$2e2bcd8739ae039 = $d75869c6ce45411c$var$scrollTop;



/**
 * Gets the number of pixels to scroll the element's content from the left edge.
 * @param node The DOM element
 */ function $98acc14666fa7567$var$scrollLeft(node, val) {
    var win = (0, $7f32e46a43e58923$export$2e2bcd8739ae039)(node);
    var left = node.scrollLeft;
    var top = 0;
    if (win) {
        left = win.pageXOffset;
        top = win.pageYOffset;
    }
    if (val !== undefined) {
        if (win) win.scrollTo(val, top);
        else node.scrollLeft = val;
    }
    return left;
}
var $98acc14666fa7567$export$2e2bcd8739ae039 = $98acc14666fa7567$var$scrollLeft;





function $275f503e23b8ba49$export$2e2bcd8739ae039(node) {
    var doc = (0, $98436911cf31d997$export$2e2bcd8739ae039)(node);
    var win = (0, $7f32e46a43e58923$export$2e2bcd8739ae039)(doc);
    var docElem = doc && doc.documentElement;
    var box = {
        top: 0,
        left: 0,
        height: 0,
        width: 0
    };
    if (!doc) return null;
     // Make sure it's not a disconnected DOM node
    if (!(0, $d92de691e2831d3f$export$2e2bcd8739ae039)(docElem, node)) return box;
    if ((node === null || node === void 0 ? void 0 : node.getBoundingClientRect) !== undefined) box = node.getBoundingClientRect();
    if ((box.width || box.height) && docElem && win) box = {
        top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
        left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
        width: (box.width === null ? node.offsetWidth : box.width) || 0,
        height: (box.height === null ? node.offsetHeight : box.height) || 0
    };
    return box;
}


/**
 * Get the name of the DOM element
 * @param node The DOM element
 * @returns The name of the DOM element
 */ function $b7e2b9e117f52b35$export$2e2bcd8739ae039(node) {
    var _node$nodeName;
    return (node === null || node === void 0 ? void 0 : node.nodeName) && (node === null || node === void 0 ? void 0 : (_node$nodeName = node.nodeName) === null || _node$nodeName === void 0 ? void 0 : _node$nodeName.toLowerCase());
}





function $138c5e7c20d8fd56$export$2e2bcd8739ae039(node) {
    var doc = (0, $98436911cf31d997$export$2e2bcd8739ae039)(node);
    var offsetParent = node === null || node === void 0 ? void 0 : node.offsetParent;
    while(offsetParent && (0, $b7e2b9e117f52b35$export$2e2bcd8739ae039)(node) !== 'html' && (0, $9af53a4d95c8e25d$export$2e2bcd8739ae039)(offsetParent, 'position') === 'static')offsetParent = offsetParent.offsetParent;
    return offsetParent || doc.documentElement;
}



var $8nd05 = parcelRequire("8nd05");






function $54d5672b3c89e48e$export$2e2bcd8739ae039(node, offsetParent, calcMargin) {
    if (calcMargin === void 0) calcMargin = true;
    var parentOffset = {
        top: 0,
        left: 0
    };
    var offset = null; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
    // because it is its only offset parent
    if ((0, $9af53a4d95c8e25d$export$2e2bcd8739ae039)(node, 'position') === 'fixed') offset = node.getBoundingClientRect();
    else {
        offsetParent = offsetParent || (0, $138c5e7c20d8fd56$export$2e2bcd8739ae039)(node);
        offset = (0, $275f503e23b8ba49$export$2e2bcd8739ae039)(node);
        if ((0, $b7e2b9e117f52b35$export$2e2bcd8739ae039)(offsetParent) !== 'html') {
            var nextParentOffset = (0, $275f503e23b8ba49$export$2e2bcd8739ae039)(offsetParent);
            if (nextParentOffset) {
                parentOffset.top = nextParentOffset.top;
                parentOffset.left = nextParentOffset.left;
            }
        }
        parentOffset.top += parseInt((0, $9af53a4d95c8e25d$export$2e2bcd8739ae039)(offsetParent, 'borderTopWidth'), 10) - (0, $d75869c6ce45411c$export$2e2bcd8739ae039)(offsetParent) || 0;
        parentOffset.left += parseInt((0, $9af53a4d95c8e25d$export$2e2bcd8739ae039)(offsetParent, 'borderLeftWidth'), 10) - (0, $98acc14666fa7567$export$2e2bcd8739ae039)(offsetParent) || 0;
    } // Subtract parent offsets and node margins
    if (offset) {
        var marginTop = calcMargin ? parseInt((0, $9af53a4d95c8e25d$export$2e2bcd8739ae039)(node, 'marginTop'), 10) || 0 : 0;
        var marginLeft = calcMargin ? parseInt((0, $9af53a4d95c8e25d$export$2e2bcd8739ae039)(node, 'marginLeft'), 10) || 0 : 0;
        return (0, $8nd05.default)({}, offset, {
            top: offset.top - parentOffset.top - marginTop,
            left: offset.left - parentOffset.left - marginLeft
        });
    }
    return null;
}






function $5119eabf2459031c$export$2e2bcd8739ae039(node, client) {
    var win = (0, $7f32e46a43e58923$export$2e2bcd8739ae039)(node);
    if (win) return win.innerHeight;
    return client ? node.clientHeight : (0, $275f503e23b8ba49$export$2e2bcd8739ae039)(node).height;
}




function $37eda35fd9bc0d32$export$2e2bcd8739ae039(node, client) {
    var win = (0, $7f32e46a43e58923$export$2e2bcd8739ae039)(node);
    if (win) return win.innerWidth;
    if (client) return node.clientWidth;
    var offset = (0, $275f503e23b8ba49$export$2e2bcd8739ae039)(node);
    return offset ? offset.width : 0;
}


var $5336bb092e63b431$var$selector = "input:not([type='hidden']):not([disabled]), \nselect:not([disabled]), textarea:not([disabled]), a[href], \nbutton:not([disabled]),[tabindex],iframe,object, embed, area[href], \naudio[controls],video[controls],[contenteditable]:not([contenteditable='false'])";
function $5336bb092e63b431$var$isVisible(element) {
    var htmlElement = element;
    return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element.getClientRects().length > 0;
}
/**
 * Checks whether `element` is focusable or not.
 *
 * ```typescript
 * isFocusable(document.querySelector("input")); // true
 * isFocusable(document.querySelector("input[tabindex='-1']")); // true
 * isFocusable(document.querySelector("input[hidden]")); // false
 * isFocusable(document.querySelector("input:disabled")); // false
 * ```
 */ function $5336bb092e63b431$var$isFocusable(element) {
    return $5336bb092e63b431$var$isVisible(element) && (element === null || element === void 0 ? void 0 : element.matches($5336bb092e63b431$var$selector));
}
var $5336bb092e63b431$export$2e2bcd8739ae039 = $5336bb092e63b431$var$isFocusable;





/**
 * Source code reference from:
 * https://github.com/facebook/fbjs/blob/d308fa83c9/packages/fbjs/src/dom/translateDOMPositionXY.js
 */ 

var $5a762321281a9a26$var$memoized = {};
var $5a762321281a9a26$var$prefixes = [
    'Webkit',
    'ms',
    'Moz',
    'O'
];
var $5a762321281a9a26$var$prefixRegex = new RegExp("^(" + $5a762321281a9a26$var$prefixes.join('|') + ")");
var $5a762321281a9a26$var$testStyle = (0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) ? document.createElement('div').style : {};
function $5a762321281a9a26$var$getWithPrefix(name) {
    for(var i = 0; i < $5a762321281a9a26$var$prefixes.length; i += 1){
        var prefixedName = $5a762321281a9a26$var$prefixes[i] + name;
        if (prefixedName in $5a762321281a9a26$var$testStyle) return prefixedName;
    }
    return null;
}
/**
 * @param {string} property Name of a css property to check for.
 * @return {?string} property name supported in the browser, or null if not
 * supported.
 */ function $5a762321281a9a26$var$getVendorPrefixedName(property) {
    var name = (0, $13a1e5f9b9b042d0$export$161d051f5dd25de7)(property);
    if ($5a762321281a9a26$var$memoized[name] === undefined) {
        var capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
        if ($5a762321281a9a26$var$prefixRegex.test(capitalizedName)) throw new Error("getVendorPrefixedName must only be called with unprefixed\n          CSS property names. It was called with " + property);
        $5a762321281a9a26$var$memoized[name] = name in $5a762321281a9a26$var$testStyle ? name : $5a762321281a9a26$var$getWithPrefix(capitalizedName);
    }
    return $5a762321281a9a26$var$memoized[name] || name;
}
var $5a762321281a9a26$export$2e2bcd8739ae039 = $5a762321281a9a26$var$getVendorPrefixedName;


var $ab07a251e7fee3c0$export$2e2bcd8739ae039 = {
    /**
   * @return {bool} True if browser supports css animations.
   */ hasCSSAnimations: function hasCSSAnimations() {
        return !!(0, $5a762321281a9a26$export$2e2bcd8739ae039)('animationName');
    },
    /**
   * @return {bool} True if browser supports css transforms.
   */ hasCSSTransforms: function hasCSSTransforms() {
        return !!(0, $5a762321281a9a26$export$2e2bcd8739ae039)('transform');
    },
    /**
   * @return {bool} True if browser supports css 3d transforms.
   */ hasCSS3DTransforms: function hasCSS3DTransforms() {
        return !!(0, $5a762321281a9a26$export$2e2bcd8739ae039)('perspective');
    },
    /**
   * @return {bool} True if browser supports css transitions.
   */ hasCSSTransitions: function hasCSSTransitions() {
        return !!(0, $5a762321281a9a26$export$2e2bcd8739ae039)('transition');
    }
};




var $05d257c8cfe815c6$var$g = (0, $7ac84e095a0daffc$export$2e2bcd8739ae039)();
var $05d257c8cfe815c6$var$TRANSFORM = (0, $5a762321281a9a26$export$2e2bcd8739ae039)('transform');
var $05d257c8cfe815c6$var$BACKFACE_VISIBILITY = (0, $5a762321281a9a26$export$2e2bcd8739ae039)('backfaceVisibility');
var $05d257c8cfe815c6$var$appendLeftAndTop = function appendLeftAndTop(style, x, y) {
    if (x === void 0) x = 0;
    if (y === void 0) y = 0;
    style.left = x + "px";
    style.top = y + "px";
    return style;
};
var $05d257c8cfe815c6$var$appendTranslate = function appendTranslate(style, x, y) {
    if (x === void 0) x = 0;
    if (y === void 0) y = 0;
    style[$05d257c8cfe815c6$var$TRANSFORM] = "translate(" + x + "px," + y + "px)";
    return style;
};
var $05d257c8cfe815c6$var$appendTranslate3d = function appendTranslate3d(style, x, y) {
    if (x === void 0) x = 0;
    if (y === void 0) y = 0;
    style[$05d257c8cfe815c6$var$TRANSFORM] = "translate3d(" + x + "px," + y + "px,0)";
    style[$05d257c8cfe815c6$var$BACKFACE_VISIBILITY] = 'hidden';
    return style;
};
var $05d257c8cfe815c6$export$697de1ed3e72e94 = function getTranslateDOMPositionXY(conf) {
    var _ref = conf || {}, _ref$enableTransform = _ref.enableTransform, enableTransform = _ref$enableTransform === void 0 ? true : _ref$enableTransform, _ref$enable3DTransfor = _ref.enable3DTransform, enable3DTransform = _ref$enable3DTransfor === void 0 ? true : _ref$enable3DTransfor, forceUseTransform = _ref.forceUseTransform;
    if (forceUseTransform) return conf.enable3DTransform ? $05d257c8cfe815c6$var$appendTranslate3d : $05d257c8cfe815c6$var$appendTranslate;
    if ((0, $ab07a251e7fee3c0$export$2e2bcd8739ae039).hasCSSTransforms() && enableTransform) {
        var ua = $05d257c8cfe815c6$var$g.window ? $05d257c8cfe815c6$var$g.window.navigator.userAgent : 'UNKNOWN';
        var isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua); // It appears that Safari messes up the composition order
        // of GPU-accelerated layers
        // (see bug https://bugs.webkit.org/show_bug.cgi?id=61824).
        // Use 2D translation instead.
        if (!isSafari && (0, $ab07a251e7fee3c0$export$2e2bcd8739ae039).hasCSS3DTransforms() && enable3DTransform) return $05d257c8cfe815c6$var$appendTranslate3d;
        return $05d257c8cfe815c6$var$appendTranslate;
    }
    return $05d257c8cfe815c6$var$appendLeftAndTop;
};
var $05d257c8cfe815c6$var$translateDOMPositionXY = $05d257c8cfe815c6$export$697de1ed3e72e94();
var $05d257c8cfe815c6$export$2e2bcd8739ae039 = $05d257c8cfe815c6$var$translateDOMPositionXY;




function $4051039ece381ef4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4051039ece381ef4$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");
var $c6598bdb60f83fe0$exports = {};
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
$c6598bdb60f83fe0$exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $fa74499edcf324c6$exports = {};
var $0b2d21aee1d97729$exports = {};
var $1389b3710f5da9e8$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$1389b3710f5da9e8$exports = $1389b3710f5da9e8$var$arrayReduce;


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = '\\u0300-\\u036f', $ed80fa8833e2b532$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ed80fa8833e2b532$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = '[' + $ed80fa8833e2b532$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $f5d9385a9cc7e413$exports(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, '');
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $12f2ccb7e11b3895$exports = {};
var $7e165cbd28a9af51$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
$7e165cbd28a9af51$exports = $7e165cbd28a9af51$var$asciiWords;


var $8688e0b23f5a081b$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
$8688e0b23f5a081b$exports = $8688e0b23f5a081b$var$hasUnicodeWord;



var $325a565efdffbc96$exports = {};
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = '\\ud800-\\udfff', $325a565efdffbc96$var$rsComboMarksRange = '\\u0300-\\u036f', $325a565efdffbc96$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $325a565efdffbc96$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = '\\u2700-\\u27bf', $325a565efdffbc96$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $325a565efdffbc96$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $325a565efdffbc96$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $325a565efdffbc96$var$rsPunctuationRange = '\\u2000-\\u206f', $325a565efdffbc96$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $325a565efdffbc96$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $325a565efdffbc96$var$rsVarRange = '\\ufe0e\\ufe0f', $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['\u2019]", $325a565efdffbc96$var$rsBreak = '[' + $325a565efdffbc96$var$rsBreakRange + ']', $325a565efdffbc96$var$rsCombo = '[' + $325a565efdffbc96$var$rsComboRange + ']', $325a565efdffbc96$var$rsDigits = '\\d+', $325a565efdffbc96$var$rsDingbat = '[' + $325a565efdffbc96$var$rsDingbatRange + ']', $325a565efdffbc96$var$rsLower = '[' + $325a565efdffbc96$var$rsLowerRange + ']', $325a565efdffbc96$var$rsMisc = '[^' + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $325a565efdffbc96$var$rsModifier = '(?:' + $325a565efdffbc96$var$rsCombo + '|' + $325a565efdffbc96$var$rsFitz + ')', $325a565efdffbc96$var$rsNonAstral = '[^' + $325a565efdffbc96$var$rsAstralRange + ']', $325a565efdffbc96$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $325a565efdffbc96$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $325a565efdffbc96$var$rsUpper = '[' + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = '(?:' + $325a565efdffbc96$var$rsLower + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsMiscUpper = '(?:' + $325a565efdffbc96$var$rsUpper + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsOptContrLower = '(?:' + $325a565efdffbc96$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $325a565efdffbc96$var$rsOptContrUpper = '(?:' + $325a565efdffbc96$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + '?', $325a565efdffbc96$var$rsOptVar = '[' + $325a565efdffbc96$var$rsVarRange + ']?', $325a565efdffbc96$var$rsOptJoin = '(?:' + $325a565efdffbc96$var$rsZWJ + '(?:' + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ')*', $325a565efdffbc96$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $325a565efdffbc96$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = '(?:' + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsLower + '+' + $325a565efdffbc96$var$rsOptContrLower + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsMiscUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsMiscLower + '+' + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
$325a565efdffbc96$exports = $325a565efdffbc96$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $f5d9385a9cc7e413$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8688e0b23f5a081b$exports(string) ? $325a565efdffbc96$exports(string) : $7e165cbd28a9af51$exports(string);
    return string.match(pattern) || [];
}
$12f2ccb7e11b3895$exports = $12f2ccb7e11b3895$var$words;


/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1389b3710f5da9e8$exports($12f2ccb7e11b3895$exports($ed80fa8833e2b532$exports(string).replace($0b2d21aee1d97729$var$reApos, '')), callback, '');
    };
}
$0b2d21aee1d97729$exports = $0b2d21aee1d97729$var$createCompounder;


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $fa74499edcf324c6$var$kebabCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
$fa74499edcf324c6$exports = $fa74499edcf324c6$var$kebabCase;




var $acw62 = parcelRequire("acw62");
'use client';
var $592b0082d233bdc2$var$ToastContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    usedToaster: false
});
$592b0082d233bdc2$var$ToastContext.displayName = 'ToastContext';
var $592b0082d233bdc2$export$2e2bcd8739ae039 = $592b0082d233bdc2$var$ToastContext;




'use client';
function $958ab89b0f4db0de$export$46e8f25c7328f77e() {
    return '_' + Math.random().toString(36).substring(2, 12);
}
var $958ab89b0f4db0de$export$2e2bcd8739ae039 = $958ab89b0f4db0de$export$46e8f25c7328f77e;



var $acw62 = parcelRequire("acw62");


var $1u0KT = parcelRequire("1u0KT");
'use client';
var $62a34b269a7aace9$var$majorVersion = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version);
var $62a34b269a7aace9$var$SuperposedReactDOM = $1u0KT;
var $62a34b269a7aace9$export$ef978e30ebb4c0f9 = 'toasterId';
function $62a34b269a7aace9$export$b3890eb0ae9dca99(element, container) {
    var mountElement = document.createElement('div');
    mountElement.className = 'rs-toaster-mount-element';
    var containerElement = container;
    // Add the detached element to the root
    containerElement.appendChild(mountElement);
    var newContainerId = (0, $958ab89b0f4db0de$export$46e8f25c7328f77e)();
    if (!containerElement[$62a34b269a7aace9$export$ef978e30ebb4c0f9]) // attach the containerId to the containerElement
    containerElement[$62a34b269a7aace9$export$ef978e30ebb4c0f9] = newContainerId;
    if ($62a34b269a7aace9$var$majorVersion >= 18) {
        /**
     * ignore react 18 warnings
     * Warning: You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".
     */ $1u0KT['__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED'].usingClientEntryPoint = true;
        var createRoot = $62a34b269a7aace9$var$SuperposedReactDOM.createRoot;
        var root = createRoot(mountElement, {
            identifierPrefix: 'rs-root-'
        });
        root.render(element);
    } else $62a34b269a7aace9$var$SuperposedReactDOM.render(element, mountElement);
    return containerElement[$62a34b269a7aace9$export$ef978e30ebb4c0f9];
}


'use client';
var $c6bec90fcebfe7f5$var$_excluded = [
    "as",
    "className",
    "classPrefix",
    "placement"
], $c6bec90fcebfe7f5$var$_excluded2 = [
    "className"
], $c6bec90fcebfe7f5$var$_excluded3 = [
    "container"
];
var $c6bec90fcebfe7f5$export$55b135136dbc7882 = function defaultToasterContainer() {
    return (0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) ? document.body : null;
};
var $c6bec90fcebfe7f5$export$5fb2d74146fb7008 = [
    'topCenter',
    'bottomCenter',
    'topStart',
    'topEnd',
    'bottomStart',
    'bottomEnd'
];
var $c6bec90fcebfe7f5$var$useMessages = function useMessages() {
    var _useState = (0, $acw62.useState)([]), messages = _useState[0], setMessages = _useState[1];
    var getKey = (0, $acw62.useCallback)(function(key) {
        if (typeof key === 'undefined' && messages.length) return messages[messages.length - 1].key;
        return key;
    }, [
        messages
    ]);
    var push = (0, $acw62.useCallback)(function(message, options) {
        var _ref = options || {}, duration = _ref.duration, _ref$mouseReset = _ref.mouseReset, mouseReset = _ref$mouseReset === void 0 ? true : _ref$mouseReset, container = _ref.container;
        var key = (0, $958ab89b0f4db0de$export$46e8f25c7328f77e)();
        setMessages(function(prevMessages) {
            return [].concat(prevMessages, [
                {
                    key: key,
                    visible: true,
                    node: message,
                    duration: duration,
                    mouseReset: mouseReset,
                    container: container
                }
            ]);
        });
        return key;
    }, []);
    var clear = (0, $acw62.useCallback)(function() {
        // Set all existing messages to be invisible.
        setMessages(messages.map(function(msg) {
            return (0, $8nd05.default)({}, msg, {
                visible: false
            });
        }));
        // Remove all invisible messages after 400ms.
        // The delay removal here is to preserve the animation.
        setTimeout(function() {
            setMessages([]);
        }, 400);
    }, [
        messages
    ]);
    var remove = (0, $acw62.useCallback)(function(key) {
        // Set the message of the specified key to invisible.
        setMessages(messages.map(function(n) {
            if (n.key === getKey(key)) n.visible = false;
            return n;
        }));
        // Remove invisible messages after 400ms.
        setTimeout(function() {
            setMessages(messages.filter(function(msg) {
                return msg.visible;
            }));
        }, 400);
    }, [
        messages,
        getKey
    ]);
    return {
        messages: messages,
        push: push,
        clear: clear,
        remove: remove
    };
};
var $c6bec90fcebfe7f5$var$ToastContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$as = props.as, Component = _props$as === void 0 ? 'div' : _props$as, className = props.className, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? 'toast-container' : _props$classPrefix, _props$placement = props.placement, placement = _props$placement === void 0 ? 'topCenter' : _props$placement, rest = (0, $1En50.default)(props, $c6bec90fcebfe7f5$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), withClassPrefix = _useClassNames.withClassPrefix, merge = _useClassNames.merge, rootPrefix = _useClassNames.rootPrefix;
    var classes = merge(className, withClassPrefix((0, (/*@__PURE__*/$parcel$interopDefault($fa74499edcf324c6$exports)))(placement)));
    var _useMessages = $c6bec90fcebfe7f5$var$useMessages(), push = _useMessages.push, clear = _useMessages.clear, remove = _useMessages.remove, messages = _useMessages.messages;
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            push: push,
            clear: clear,
            remove: remove
        };
    });
    var elements = messages.map(function(item) {
        var mouseReset = item.mouseReset, duration = item.duration, node = item.node;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $592b0082d233bdc2$export$2e2bcd8739ae039).Provider, {
            value: {
                usedToaster: true,
                mouseReset: mouseReset,
                duration: duration
            },
            key: item.key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bd85cc44fa7d33b8$export$2e2bcd8739ae039), {
            in: item.visible,
            exitedClassName: rootPrefix('toast-fade-exited'),
            exitingClassName: rootPrefix('toast-fade-exiting'),
            enteringClassName: rootPrefix('toast-fade-entering'),
            enteredClassName: rootPrefix('toast-fade-entered'),
            timeout: 300
        }, function(transitionProps, ref) {
            var _node$props, _node$props2;
            var transitionClassName = transitionProps.className, rest = (0, $1En50.default)(transitionProps, $c6bec90fcebfe7f5$var$_excluded2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(node, (0, $8nd05.default)({}, rest, {
                ref: ref,
                duration: duration,
                onClose: (0, $2a7f3a886704e9aa$export$a34401a08725357c)((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.onClose, function() {
                    return remove(item.key);
                }),
                className: merge(rootPrefix('toast'), (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.className, transitionClassName)
            }));
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, rest, {
        className: classes
    }), elements);
});
$c6bec90fcebfe7f5$var$ToastContainer.getInstance = /*#__PURE__*/ function() {
    var _ref2 = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(props) {
        var container, rest, getRefResolve, getRefPromise, containerRef, containerId;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    container = props.container, rest = (0, $1En50.default)(props, $c6bec90fcebfe7f5$var$_excluded3);
                    getRefResolve = null;
                    getRefPromise = new Promise(function(res) {
                        getRefResolve = res;
                    });
                    containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(); // promise containerId & containerRef all have value
                    containerId = (0, $62a34b269a7aace9$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c6bec90fcebfe7f5$var$ToastContainer, (0, $8nd05.default)({}, rest, {
                        ref: function ref(_ref3) {
                            containerRef.current = _ref3;
                            getRefResolve && getRefResolve();
                        }
                    })), container);
                    _context.next = 7;
                    return getRefPromise;
                case 7:
                    return _context.abrupt("return", [
                        containerRef,
                        containerId
                    ]);
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function(_x) {
        return _ref2.apply(this, arguments);
    };
}();
$c6bec90fcebfe7f5$var$ToastContainer.displayName = 'ToastContainer';
$c6bec90fcebfe7f5$var$ToastContainer.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $c6bec90fcebfe7f5$export$2e2bcd8739ae039 = $c6bec90fcebfe7f5$var$ToastContainer;


'use client';
var $c80081b3ad878981$var$_excluded = [
    "children",
    "classPrefix",
    "components",
    "iconClassPrefix",
    "theme",
    "toastContainer",
    "disableRipple",
    "csp",
    "disableInlineStyles"
];
var $c80081b3ad878981$export$6edd797085f96e5b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
var $c80081b3ad878981$var$themes = [
    'light',
    'dark',
    'high-contrast'
];
function $c80081b3ad878981$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? (0, $ccc57d972485f17c$export$103f2b9564b2dd0a)() : _props$classPrefix, components = props.components, _props$iconClassPrefi = props.iconClassPrefix, iconClassPrefix = _props$iconClassPrefi === void 0 ? classPrefix : _props$iconClassPrefi, theme = props.theme, _props$toastContainer = props.toastContainer, toastContainer = _props$toastContainer === void 0 ? (0, $c6bec90fcebfe7f5$export$55b135136dbc7882) : _props$toastContainer, disableRipple = props.disableRipple, csp = props.csp, disableInlineStyles = props.disableInlineStyles, rest = (0, $1En50.default)(props, $c80081b3ad878981$var$_excluded);
    var toasters = (0, $acw62.useRef)(new Map());
    var _usePortal = (0, $511f343af0455e99$export$b1072f43c67b540c)({
        container: toastContainer,
        waitMount: true
    }), Portal = _usePortal.Portal;
    var value = (0, $acw62.useMemo)(function() {
        return (0, $8nd05.default)({
            classPrefix: classPrefix,
            theme: theme,
            toasters: toasters,
            disableRipple: disableRipple,
            components: components,
            toastContainer: toastContainer
        }, rest);
    }, [
        classPrefix,
        theme,
        disableRipple,
        components,
        toastContainer,
        rest
    ]);
    var iconContext = (0, $acw62.useMemo)(function() {
        return {
            classPrefix: iconClassPrefix,
            csp: csp,
            disableInlineStyles: disableInlineStyles
        };
    }, [
        iconClassPrefix,
        csp,
        disableInlineStyles
    ]);
    (0, $7f5c205b6c67eb69$export$700979bc83e7db82)(function() {
        if ((0, $811fd19a8e8dd84e$export$2e2bcd8739ae039) && theme) {
            (0, $980d0a078c16379b$export$2e2bcd8739ae039)(document.body, (0, $ccc57d972485f17c$export$82e9f45cca5ba907)(classPrefix, "theme-" + theme));
            // Remove the className that will cause style conflicts
            $c80081b3ad878981$var$themes.forEach(function(t) {
                if (t !== theme) (0, $1033df41708f516f$export$2e2bcd8739ae039)(document.body, (0, $ccc57d972485f17c$export$82e9f45cca5ba907)(classPrefix, "theme-" + t));
            });
        }
    }, [
        classPrefix,
        theme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c80081b3ad878981$export$6edd797085f96e5b.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a122465d88af89c7$export$2e2bcd8739ae039), {
        value: iconContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Portal, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classPrefix + "toast-provider"
    }, (0, $c6bec90fcebfe7f5$export$5fb2d74146fb7008).map(function(placement) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c6bec90fcebfe7f5$export$2e2bcd8739ae039), {
            key: placement,
            placement: placement,
            ref: function ref(_ref) {
                toasters.current.set(placement, _ref);
            }
        });
    })))));
}


'use client';
function $0f1ed170257520ec$export$b54202cc833d4188(str) {
    var _ref = (0, $acw62.useContext)((0, $c80081b3ad878981$export$6edd797085f96e5b)) || {}, _ref$classPrefix = _ref.classPrefix, classPrefix = _ref$classPrefix === void 0 ? 'rs' : _ref$classPrefix;
    var componentName = (0, $ccc57d972485f17c$export$82e9f45cca5ba907)(classPrefix, str);
    /**
   * @example
   *
   * if str = 'button':
   * prefix('red', { active: true }) => 'rs-button-red rs-button-active'
   */ var prefix = (0, $acw62.useCallback)(function() {
        var mergeClasses = arguments.length ? (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ))).apply(void 0, arguments).split(' ').map(function(item) {
            return (0, $ccc57d972485f17c$export$82e9f45cca5ba907)(componentName, item);
        }) : [];
        return mergeClasses.filter(function(cls) {
            return cls;
        }).join(' ');
    }, [
        componentName
    ]);
    /**
   * @example
   *
   * if str = 'button':
   * withClassPrefix('red', { active: true }) => 'rs-button rs-button-red rs-button-active'
   */ var withClassPrefix = (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++)classes[_key] = arguments[_key];
        var mergeClasses = prefix(classes);
        return mergeClasses ? componentName + " " + mergeClasses : componentName;
    }, [
        componentName,
        prefix
    ]);
    /**
   * @example
   * rootPrefix('btn') => 'rs-btn'
   * rootPrefix('btn', { active: true }) => 'rs-btn rs-active'
   */ var rootPrefix = function rootPrefix() {
        var mergeClasses = arguments.length ? (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ))).apply(void 0, arguments).split(' ').map(function(item) {
            return (0, $ccc57d972485f17c$export$82e9f45cca5ba907)(classPrefix, item);
        }) : [];
        return mergeClasses.filter(function(cls) {
            return cls;
        }).join(' ');
    };
    return {
        withClassPrefix: withClassPrefix,
        merge: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ))),
        prefix: prefix,
        rootPrefix: rootPrefix
    };
}
var $0f1ed170257520ec$export$2e2bcd8739ae039 = $0f1ed170257520ec$export$b54202cc833d4188;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
var $64ab06e3276f1fef$exports = {};


var $d1e75591f556b111$exports = {};
var $3db9ad8fe1351fef$exports = {};



/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $d9b21a2cad7f96c2$exports($81a5758ee0248452$exports(func, start, $37dff9aa04444f9c$exports), func + '');
}
$3db9ad8fe1351fef$exports = $3db9ad8fe1351fef$var$baseRest;


var $81b21e8b41d211e8$exports = {};

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $eMthh(object) && $iyUuu(index, object.length) : type == 'string' && index in object) return $6TC8i(object[index], value);
    return false;
}
$81b21e8b41d211e8$exports = $81b21e8b41d211e8$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $3db9ad8fe1351fef$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $81b21e8b41d211e8$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$d1e75591f556b111$exports = $d1e75591f556b111$var$createAssigner;



var $eMthh = parcelRequire("eMthh");

var $3wZFp = parcelRequire("3wZFp");

var $LAMcS = parcelRequire("LAMcS");
/** Used for built-in method references. */ var $64ab06e3276f1fef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64ab06e3276f1fef$var$hasOwnProperty = $64ab06e3276f1fef$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $64ab06e3276f1fef$var$assign = $d1e75591f556b111$exports(function(object, source) {
    if ($3wZFp(source) || $eMthh(source)) {
        $971be9a5edcd8d07$exports(source, $LAMcS(source), object);
        return;
    }
    for(var key in source)if ($64ab06e3276f1fef$var$hasOwnProperty.call(source, key)) $3da413f0b86c10df$exports(object, key, source[key]);
});
$64ab06e3276f1fef$exports = $64ab06e3276f1fef$var$assign;



var $8nd05 = parcelRequire("8nd05");
var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;


var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;


function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $9567ced935a3b497$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $eda89c8f88184c82$export$2e2bcd8739ae039)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;


function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $56621c36efca199b$export$2e2bcd8739ae039)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $c309fdccb9ef673a$export$2e2bcd8739ae039)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;


function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $57426dbaa8ce599d$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $57426dbaa8ce599d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $57426dbaa8ce599d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $57426dbaa8ce599d$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $57426dbaa8ce599d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $57426dbaa8ce599d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $57426dbaa8ce599d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $57426dbaa8ce599d$export$2e2bcd8739ae039 = $57426dbaa8ce599d$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $8c6443de4506cab4$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $1c4e78b8ee7f66d8$export$2e2bcd8739ae039),
    formatLong: (0, $57426dbaa8ce599d$export$2e2bcd8739ae039),
    formatRelative: (0, $117705cf2af2348d$export$2e2bcd8739ae039),
    localize: (0, $9567ced935a3b497$export$2e2bcd8739ae039),
    match: (0, $219397ebd8b56b11$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $8c6443de4506cab4$export$2e2bcd8739ae039 = $8c6443de4506cab4$var$locale;


'use client';
var $78e033c4c9fb9384$var$DateTimeFormats = {
    sunday: 'Su',
    monday: 'Mo',
    tuesday: 'Tu',
    wednesday: 'We',
    thursday: 'Th',
    friday: 'Fr',
    saturday: 'Sa',
    ok: 'OK',
    today: 'Today',
    yesterday: 'Yesterday',
    now: 'Now',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    /**
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   **/ formattedMonthPattern: 'MMM yyyy',
    formattedDayPattern: 'dd MMM yyyy',
    shortDateFormat: 'dd/MM/yyyy',
    shortTimeFormat: 'HH:mm',
    dateLocale: (0, $8c6443de4506cab4$export$2e2bcd8739ae039)
};
var $78e033c4c9fb9384$var$Combobox = {
    noResultsText: 'No results found',
    placeholder: 'Select',
    searchPlaceholder: 'Search',
    checkAll: 'All'
};
var $78e033c4c9fb9384$var$CreatableComboBox = (0, $8nd05.default)({}, $78e033c4c9fb9384$var$Combobox, {
    newItem: 'New item',
    createOption: 'Create option "{0}"'
});
var $78e033c4c9fb9384$export$2e2bcd8739ae039 = {
    code: 'en-GB',
    common: {
        loading: 'Loading...',
        emptyMessage: 'No data found',
        remove: 'Remove',
        clear: 'Clear'
    },
    Plaintext: {
        unfilled: 'Unfilled',
        notSelected: 'Not selected',
        notUploaded: 'Not uploaded'
    },
    Pagination: {
        more: 'More',
        prev: 'Previous',
        next: 'Next',
        first: 'First',
        last: 'Last',
        limit: '{0} / page',
        total: 'Total Rows: {0}',
        skip: 'Go to{0}'
    },
    DateTimeFormats: $78e033c4c9fb9384$var$DateTimeFormats,
    Calendar: $78e033c4c9fb9384$var$DateTimeFormats,
    DatePicker: $78e033c4c9fb9384$var$DateTimeFormats,
    DateRangePicker: (0, $8nd05.default)({}, $78e033c4c9fb9384$var$DateTimeFormats, {
        last7Days: 'Last 7 Days'
    }),
    Combobox: $78e033c4c9fb9384$var$Combobox,
    InputPicker: $78e033c4c9fb9384$var$CreatableComboBox,
    TagPicker: $78e033c4c9fb9384$var$CreatableComboBox,
    Uploader: {
        inited: 'Initial',
        progress: 'Uploading',
        error: 'Error',
        complete: 'Finished',
        emptyFile: 'Empty',
        upload: 'Upload',
        removeFile: 'Remove file'
    },
    CloseButton: {
        closeLabel: 'Close'
    },
    Breadcrumb: {
        expandText: 'Show path'
    },
    Toggle: {
        on: 'Open',
        off: 'Close'
    }
};



function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}





function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(date).getTime() - (0, $4e98b4d5a2488885$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}







var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}


function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options).getTime() - (0, $5b38b39a484f4993$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}



function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;


var $d91e238bf521c720$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $dbfee7256f9ba04c$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;


var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}







var $b99de2b03d4f39be$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $05b7040d79e43f9d$export$2e2bcd8739ae039)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: 'en-US',
    formatDistance: (0, $1c4e78b8ee7f66d8$export$2e2bcd8739ae039),
    formatLong: (0, $b99de2b03d4f39be$export$2e2bcd8739ae039),
    formatRelative: (0, $117705cf2af2348d$export$2e2bcd8739ae039),
    localize: (0, $9567ced935a3b497$export$2e2bcd8739ae039),
    match: (0, $219397ebd8b56b11$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;


var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $0ca880ce53ce49f9$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $98e3d5324cb7d94c$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $d91e238bf521c720$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a5375092e28b891e$export$c6cc36aa33304772)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $5158b23d1f990d5e$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $4c58fe0eb0761e95$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}









function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, e);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(t);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, e);
    };
}


function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



var $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY = 10;
var $98a897cde0f0abfd$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Setter);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $98a897cde0f0abfd$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);
var $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this2), "priority", $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);












var $a24c84ce3b2e818f$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Parser);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $98a897cde0f0abfd$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $52a6bcb88b20d48f$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4faa9cd956e257dc$export$dfd9b671c89acc8e = 7;
var $4faa9cd956e257dc$export$3913210603d8e9ae = 365.2425;
var $4faa9cd956e257dc$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4faa9cd956e257dc$export$91246f0b9bd9beff = 60000;
var $4faa9cd956e257dc$export$7f72910d6dfd237a = 3600000;
var $4faa9cd956e257dc$export$397c2d5776aa9055 = 1000;
var $4faa9cd956e257dc$export$4dec998e48f9c246 = -$4faa9cd956e257dc$export$81caae6e1cc7a622;
var $4faa9cd956e257dc$export$f2f5ae5a8e2d8f9f = 60;
var $4faa9cd956e257dc$export$3c58128db900d44e = 3;
var $4faa9cd956e257dc$export$80d7e435f744f319 = 12;
var $4faa9cd956e257dc$export$4db7641526e3241f = 4;
var $4faa9cd956e257dc$export$698aec755e92c695 = 3600;
var $4faa9cd956e257dc$export$a77c1a7ebebe2a5a = 60;
var $4faa9cd956e257dc$export$815a9362476d2fe3 = $4faa9cd956e257dc$export$698aec755e92c695 * 24;
var $4faa9cd956e257dc$export$34804a017b31e2fe = $4faa9cd956e257dc$export$815a9362476d2fe3 * 7;
var $4faa9cd956e257dc$export$7271e9e3478110d1 = $4faa9cd956e257dc$export$815a9362476d2fe3 * $4faa9cd956e257dc$export$3913210603d8e9ae;
var $4faa9cd956e257dc$export$8e6600bbdee7dabb = $4faa9cd956e257dc$export$7271e9e3478110d1 / 12;
var $4faa9cd956e257dc$export$be1dccf2de902d31 = $4faa9cd956e257dc$export$8e6600bbdee7dabb * 3;


var $464a0c2b40e7950e$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $464a0c2b40e7950e$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $0b232b0fb2037abb$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $4faa9cd956e257dc$export$7f72910d6dfd237a) + minutes * (0, $4faa9cd956e257dc$export$91246f0b9bd9beff) + seconds * (0, $4faa9cd956e257dc$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$d931c43c4608a164(dateString) {
    return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $0b232b0fb2037abb$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $0b232b0fb2037abb$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $464a0c2b40e7950e$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $0b232b0fb2037abb$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $0b232b0fb2037abb$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $0b232b0fb2037abb$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $760618bd8dde9a2e$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $0b232b0fb2037abb$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));












var $b249abf1c76e715b$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $0b232b0fb2037abb$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $2f79a8958a9b0819$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $0b232b0fb2037abb$export$2c9307b2e29c533c)(4, dateString);
                return (0, $0b232b0fb2037abb$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $0b232b0fb2037abb$export$2c9307b2e29c533c)(4, dateString);
                return (0, $0b232b0fb2037abb$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $9ce0307b40bcf431$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $a0fcb22d028fbb12$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $5610726e2a84c5bb$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $5faf133932f8fa0d$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));















function $78111b508c05f859$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $d0e82d5cf6f5412c$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)((0, $78111b508c05f859$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));















function $e5bdf6fda1ca18fd$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $01f34dcf5c011194$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)((0, $e5bdf6fda1ca18fd$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $8f6c3433250540ef$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f6c3433250540ef$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $0b232b0fb2037abb$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $0434465071b161c2$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $0b232b0fb2037abb$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));













function $cd47f247bdfd58ed$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $bf6ac2f87af55cf1$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $cd47f247bdfd58ed$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $a6235c79c7d2d223$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $cd47f247bdfd58ed$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $55264d63d00b69b4$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $cd47f247bdfd58ed$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));













function $7ae224ed93d5e7cb$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $587278c8279e961b$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $7ae224ed93d5e7cb$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $8abffc7926620950$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $0b232b0fb2037abb$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $e8b7014308632edf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $0b232b0fb2037abb$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $566f2b76640556a4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $0b232b0fb2037abb$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $1942733da4af1ace$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $1739347ee422fc25$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $65759b4c9622f058$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $782a6455ff67a7ae$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $6bc87bf726e3a9ef$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $0b232b0fb2037abb$export$cc7cc9e2a3ff9388)((0, $464a0c2b40e7950e$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $13f598d9d9f39eef$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $0b232b0fb2037abb$export$4f84e3a82c7b538)((0, $0b232b0fb2037abb$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $929b09a4780dfe0c$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));











var $eeba5969587208af$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $0b232b0fb2037abb$export$6497f4c0ecdfba8e)((0, $464a0c2b40e7950e$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $e0ac031eec4beddf$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $0b232b0fb2037abb$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));










var $c1c113b2a9b78e15$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $0b232b0fb2037abb$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $a24c84ce3b2e818f$export$7acfa6ed01010e37));


var $c1027c3b7f83f29d$export$19131010e7fd8373 = {
    G: new (0, $52a6bcb88b20d48f$export$8e5a1d3f85a9688)(),
    y: new (0, $760618bd8dde9a2e$export$48d352de7cd4a988)(),
    Y: new (0, $b249abf1c76e715b$export$b8ef38dfcf05d5db)(),
    R: new (0, $2f79a8958a9b0819$export$951d1df011fde06f)(),
    u: new (0, $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a)(),
    Q: new (0, $9ce0307b40bcf431$export$5cb0f701186dde1d)(),
    q: new (0, $a0fcb22d028fbb12$export$300c0c2990e20e6d)(),
    M: new (0, $5610726e2a84c5bb$export$400dd8b40ef138a3)(),
    L: new (0, $5faf133932f8fa0d$export$1d7eaa53eaa5deba)(),
    w: new (0, $d0e82d5cf6f5412c$export$c4005ffc174e07c0)(),
    I: new (0, $01f34dcf5c011194$export$6fc8dbedd560a6af)(),
    d: new (0, $8f6c3433250540ef$export$e8d4b28a20981dd2)(),
    D: new (0, $0434465071b161c2$export$6cfe0d613455f615)(),
    E: new (0, $bf6ac2f87af55cf1$export$1b03c8b76262f7bd)(),
    e: new (0, $a6235c79c7d2d223$export$44d1c127ab42c480)(),
    c: new (0, $55264d63d00b69b4$export$e447a647caaaec1d)(),
    i: new (0, $587278c8279e961b$export$693fb1e525095b2a)(),
    a: new (0, $8abffc7926620950$export$8d1e08492351df91)(),
    b: new (0, $e8b7014308632edf$export$73ca2bd0a17d273)(),
    B: new (0, $566f2b76640556a4$export$bb9212adf05373db)(),
    h: new (0, $1942733da4af1ace$export$8a04050a727a1756)(),
    H: new (0, $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd)(),
    K: new (0, $1739347ee422fc25$export$cbbe855312f87d77)(),
    k: new (0, $65759b4c9622f058$export$6008046d2b34b6a5)(),
    m: new (0, $782a6455ff67a7ae$export$2b52670d9e2be53)(),
    s: new (0, $6bc87bf726e3a9ef$export$94d46d540cf1366a)(),
    S: new (0, $13f598d9d9f39eef$export$b8e6f8b2d70893b1)(),
    X: new (0, $929b09a4780dfe0c$export$104d901d49fea29b)(),
    x: new (0, $eeba5969587208af$export$12910e5204b52b9)(),
    t: new (0, $e0ac031eec4beddf$export$2cd8bf877a05e96)(),
    T: new (0, $c1c113b2a9b78e15$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7a460707bf147158$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7a460707bf147158$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7a460707bf147158$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7a460707bf147158$var$doubleQuoteRegExp = /''/g;
var $7a460707bf147158$var$notWhitespaceRegExp = /\S/;
var $7a460707bf147158$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7a460707bf147158$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $98e3d5324cb7d94c$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($7a460707bf147158$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $4f085685fa15e740$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($7a460707bf147158$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $5158b23d1f990d5e$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(token)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a5375092e28b891e$export$c6cc36aa33304772)(token)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $c1027c3b7f83f29d$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($7a460707bf147158$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $7a460707bf147158$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $7a460707bf147158$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(date, (0, $6eb366e006a8b659$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $5158b23d1f990d5e$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $4c58fe0eb0761e95$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $7a460707bf147158$var$cleanEscapedString(input) {
    return input.match($7a460707bf147158$var$escapedStringRegExp)[1].replace($7a460707bf147158$var$doubleQuoteRegExp, "'");
}



'use client';
var $92807dc5bcf0ee15$var$_excluded = [
    "locale"
];
function $92807dc5bcf0ee15$var$getDefaultRTL() {
    return typeof document !== 'undefined' && (document.body.getAttribute('dir') || document.dir) === 'rtl';
}
function $92807dc5bcf0ee15$var$toLocaleKey(componentName) {
    var Picker = [
        'Cascader',
        'CheckTreePicker',
        'MultiCascader',
        'SelectPicker',
        'TreePicker',
        'CheckPicker',
        'CheckTreePicker'
    ];
    if (Picker.includes(componentName)) return 'Combobox';
    return componentName;
}
function $92807dc5bcf0ee15$export$9042589177add566(componentName, componentProps) {
    var _globalLocale$DateTim;
    var _useContext = (0, $acw62.useContext)((0, $c80081b3ad878981$export$6edd797085f96e5b)), _useContext$component = _useContext.components, components = _useContext$component === void 0 ? {} : _useContext$component, _useContext$locale = _useContext.locale, globalLocale = _useContext$locale === void 0 ? (0, $78e033c4c9fb9384$export$2e2bcd8739ae039) : _useContext$locale, _useContext$rtl = _useContext.rtl, rtl = _useContext$rtl === void 0 ? $92807dc5bcf0ee15$var$getDefaultRTL() : _useContext$rtl, formatDate = _useContext.formatDate, parseDate = _useContext.parseDate, classPrefix = _useContext.classPrefix, toasters = _useContext.toasters, disableRipple = _useContext.disableRipple;
    var _ref = componentProps || {}, componentLocale = _ref.locale, restProps = (0, $1En50.default)(_ref, $92807dc5bcf0ee15$var$_excluded);
    var dateLocale = globalLocale === null || globalLocale === void 0 || (_globalLocale$DateTim = globalLocale.DateTimeFormats) === null || _globalLocale$DateTim === void 0 ? void 0 : _globalLocale$DateTim.dateLocale;
    var code = globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale.code;
    var getLocale = (0, $acw62.useCallback)(function(key, overrideLocale) {
        // Initialize with common locale
        var publicLocale = (globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale.common) || {};
        // Merge component-specific locale(s) based on key type
        var specificLocale = typeof key === 'string' ? globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale[key] : Array.isArray(key) ? (0, (/*@__PURE__*/$parcel$interopDefault($64ab06e3276f1fef$exports))).apply(void 0, [
            {}
        ].concat(key.map(function(k) {
            return globalLocale === null || globalLocale === void 0 ? void 0 : globalLocale[k];
        }))) : {};
        // Merge all parts: public locale, specific locale, custom component locale
        return (0, (/*@__PURE__*/$parcel$interopDefault($64ab06e3276f1fef$exports)))({}, publicLocale, specificLocale, componentLocale, overrideLocale);
    }, [
        globalLocale,
        componentLocale
    ]);
    var propsWithDefaults = (0, $acw62.useMemo)(function() {
        var _components$component;
        if (!componentName) return;
        //Memoize the global default props based on component name
        var globalDefaultProps = ((_components$component = components[componentName]) === null || _components$component === void 0 ? void 0 : _components$component.defaultProps) || {};
        var mergedProps = (0, (/*@__PURE__*/$parcel$interopDefault($64ab06e3276f1fef$exports)))({}, globalDefaultProps, restProps);
        var localeKey = $92807dc5bcf0ee15$var$toLocaleKey(componentName);
        // If the default locale has the component name, then merge the locale.
        if (Object.keys((0, $78e033c4c9fb9384$export$2e2bcd8739ae039)).includes(localeKey)) return (0, $8nd05.default)({}, mergedProps, {
            locale: getLocale(localeKey)
        });
        return mergedProps;
    }, [
        componentName,
        components,
        getLocale,
        restProps
    ]);
    var _formatDate = (0, $acw62.useCallback)(function(date, formatStr, options) {
        try {
            if (formatDate) return formatDate(date, formatStr, options);
            return (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)((0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(date) ? date : new Date(), formatStr, (0, $8nd05.default)({
                locale: dateLocale
            }, options));
        } catch (error) {
            return 'Error: Invalid date format';
        }
    }, [
        dateLocale,
        formatDate
    ]);
    var _parseDate = (0, $acw62.useCallback)(function(dateString, formatString, referenceDate, options) {
        if (parseDate) return parseDate(dateString, formatString, referenceDate, options);
        return (0, $7a460707bf147158$export$2e2bcd8739ae039)(dateString, formatString, referenceDate || new Date(), (0, $8nd05.default)({
            locale: dateLocale
        }, options));
    }, [
        parseDate,
        dateLocale
    ]);
    return {
        code: code,
        rtl: rtl,
        toasters: toasters,
        disableRipple: disableRipple,
        classPrefix: classPrefix,
        propsWithDefaults: propsWithDefaults,
        getLocale: getLocale,
        formatDate: _formatDate,
        parseDate: _parseDate
    };
}
var $92807dc5bcf0ee15$export$2e2bcd8739ae039 = $92807dc5bcf0ee15$export$9042589177add566;


'use client';
var $8309e79abf53ab7a$var$_excluded = [
    "timeout",
    "className"
];
/**
 * Fade animation component
 * @see https://rsuitejs.com/components/animation/#fade
 */ var $8309e79abf53ab7a$var$Fade = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
    var _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? 300 : _ref$timeout, className = _ref.className, props = (0, $1En50.default)(_ref, $8309e79abf53ab7a$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)('anim'), prefix = _useClassNames.prefix, merge = _useClassNames.merge;
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)('Fade', props), propsWithDefaults = _useCustom.propsWithDefaults;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bd85cc44fa7d33b8$export$2e2bcd8739ae039), (0, $8nd05.default)({}, propsWithDefaults, {
        ref: ref,
        timeout: timeout,
        className: merge(className, prefix('fade')),
        enteredClassName: prefix('in'),
        enteringClassName: prefix('in')
    }));
});
$8309e79abf53ab7a$var$Fade.displayName = 'Fade';
var $8309e79abf53ab7a$export$2e2bcd8739ae039 = $8309e79abf53ab7a$var$Fade;




var $acw62 = parcelRequire("acw62");
'use client';
var $e3077f2d6e4c0351$var$OverlayContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
$e3077f2d6e4c0351$var$OverlayContext.displayName = 'OverlayContext';
var $e3077f2d6e4c0351$export$2e2bcd8739ae039 = $e3077f2d6e4c0351$var$OverlayContext;


'use client';
var $ed5e59ba008bd55e$var$_excluded = [
    "as",
    "children",
    "transition",
    "dialogTransitionTimeout",
    "style",
    "className",
    "container",
    "animationProps",
    "containerClassName",
    "keyboard",
    "enforceFocus",
    "backdrop",
    "backdropTransitionTimeout",
    "backdropStyle",
    "backdropClassName",
    "open",
    "autoFocus",
    "onEsc",
    "onExit",
    "onExiting",
    "onExited",
    "onEnter",
    "onEntering",
    "onEntered",
    "onClose",
    "onOpen"
], $ed5e59ba008bd55e$var$_excluded2 = [
    "className"
];
var $ed5e59ba008bd55e$var$manager;
function $ed5e59ba008bd55e$var$getManager() {
    if (!$ed5e59ba008bd55e$var$manager) $ed5e59ba008bd55e$var$manager = new (0, $d4b3bf816da24b42$export$2e2bcd8739ae039)();
    return $ed5e59ba008bd55e$var$manager;
}
var $ed5e59ba008bd55e$var$useModalManager = function useModalManager() {
    var modalManager = $ed5e59ba008bd55e$var$getManager();
    var modal = (0, $acw62.useRef)({
        dialog: null,
        backdrop: null
    });
    return {
        get dialog () {
            var _modal$current;
            return (_modal$current = modal.current) === null || _modal$current === void 0 ? void 0 : _modal$current.dialog;
        },
        add: function add(containerElement, containerClassName) {
            return modalManager.add(modal.current, containerElement, containerClassName);
        },
        remove: function remove() {
            return modalManager.remove(modal.current);
        },
        isTopModal: function isTopModal() {
            return modalManager.isTopModal(modal.current);
        },
        setDialogRef: (0, $acw62.useCallback)(function(ref) {
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $acw62.useCallback)(function(ref) {
            modal.current.backdrop = ref;
        }, [])
    };
};
var $ed5e59ba008bd55e$var$Modal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$as = props.as, Component = _props$as === void 0 ? 'div' : _props$as, children = props.children, Transition = props.transition, dialogTransitionTimeout = props.dialogTransitionTimeout, style = props.style, className = props.className, container = props.container, animationProps = props.animationProps, containerClassName = props.containerClassName, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$enforceFocus = props.enforceFocus, enforceFocus = _props$enforceFocus === void 0 ? true : _props$enforceFocus, _props$backdrop = props.backdrop, backdrop = _props$backdrop === void 0 ? true : _props$backdrop, backdropTransitionTimeout = props.backdropTransitionTimeout, backdropStyle = props.backdropStyle, backdropClassName = props.backdropClassName, open = props.open, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, onEsc = props.onEsc, onExit = props.onExit, onExiting = props.onExiting, onExited = props.onExited, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered, onClose = props.onClose, onOpen = props.onOpen, rest = (0, $1En50.default)(props, $ed5e59ba008bd55e$var$_excluded);
    var _useState = (0, $acw62.useState)(!open), exited = _useState[0], setExited = _useState[1];
    var _usePortal = (0, $511f343af0455e99$export$b1072f43c67b540c)({
        container: container
    }), Portal = _usePortal.Portal, containerElement = _usePortal.target;
    var modal = $ed5e59ba008bd55e$var$useModalManager();
    if (open) {
        if (exited) setExited(false);
    } else if (!Transition && !exited) setExited(true);
    var mountModal = open || Transition && !exited;
    var lastFocus = (0, $acw62.useRef)(null);
    var handleDocumentKeyDown = (0, $f59008c787bd7bc5$export$ee5b5d04074a389e)(function(event) {
        if (keyboard && event.key === (0, $f1801b0896212a0f$export$5e6a7bdea4157c1c).ESC && modal.isTopModal()) {
            onEsc === null || onEsc === void 0 || onEsc(event);
            onClose === null || onClose === void 0 || onClose(event);
        }
    });
    var restoreLastFocus = (0, $acw62.useCallback)(function() {
        if (lastFocus.current) {
            var _lastFocus$current$fo, _lastFocus$current;
            (_lastFocus$current$fo = (_lastFocus$current = lastFocus.current).focus) === null || _lastFocus$current$fo === void 0 || _lastFocus$current$fo.call(_lastFocus$current);
            lastFocus.current = null;
        }
    }, []);
    /**
   * Determines if the currently focused element is inside the dialog,
   * and if not, returns the focus to the dialog.
   *
   */ var handleFocusDialog = (0, $f59008c787bd7bc5$export$ee5b5d04074a389e)(function(onBeforeFocusCallback) {
        var currentActiveElement = document.activeElement;
        var dialog = modal.dialog;
        if (dialog && currentActiveElement && !(0, $d92de691e2831d3f$export$2e2bcd8739ae039)(dialog, currentActiveElement)) {
            onBeforeFocusCallback === null || onBeforeFocusCallback === void 0 || onBeforeFocusCallback();
            dialog.focus();
        }
    });
    var handleEnforceFocus = (0, $f59008c787bd7bc5$export$ee5b5d04074a389e)(function() {
        if (!enforceFocus || !modal.isTopModal()) return;
        handleFocusDialog();
    });
    var documentKeyDownListener = (0, $acw62.useRef)();
    var documentFocusListener = (0, $acw62.useRef)();
    var handleOpen = (0, $f59008c787bd7bc5$export$ee5b5d04074a389e)(function() {
        if (containerElement) modal.add(containerElement, containerClassName);
        if (!documentKeyDownListener.current) documentKeyDownListener.current = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        if (!documentFocusListener.current) documentFocusListener.current = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(document, 'focus', handleEnforceFocus, true);
        if (autoFocus) handleFocusDialog(function() {
            lastFocus.current = document.activeElement;
        });
        onOpen === null || onOpen === void 0 || onOpen();
    });
    var handleClose = (0, $f59008c787bd7bc5$export$ee5b5d04074a389e)(function() {
        var _documentKeyDownListe, _documentFocusListene;
        modal.remove();
        (_documentKeyDownListe = documentKeyDownListener.current) === null || _documentKeyDownListe === void 0 || _documentKeyDownListe.off();
        documentKeyDownListener.current = null;
        (_documentFocusListene = documentFocusListener.current) === null || _documentFocusListene === void 0 || _documentFocusListene.off();
        documentFocusListener.current = null;
        restoreLastFocus();
    });
    (0, $acw62.useEffect)(function() {
        if (!open) return;
        handleOpen();
    }, [
        open,
        handleOpen
    ]);
    (0, $acw62.useEffect)(function() {
        if (!exited) return;
        handleClose();
    }, [
        exited,
        handleClose
    ]);
    (0, $04ef43fe2810d94c$export$328d69a66df243d8)(function() {
        handleClose();
    });
    var handleExited = (0, $acw62.useCallback)(function() {
        setExited(true);
    }, []);
    var contextValue = (0, $acw62.useMemo)(function() {
        return {
            overlayContainer: function overlayContainer() {
                return modal.dialog;
            }
        };
    }, [
        modal.dialog
    ]);
    if (!mountModal) return null;
    var renderBackdrop = function renderBackdrop() {
        if (Transition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8309e79abf53ab7a$export$2e2bcd8739ae039), {
            transitionAppear: true,
            in: open,
            timeout: backdropTransitionTimeout
        }, function(fadeProps, ref) {
            var className = fadeProps.className, rest = (0, $1En50.default)(fadeProps, $ed5e59ba008bd55e$var$_excluded2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $8nd05.default)({
                "aria-hidden": true,
                "data-testid": "backdrop"
            }, rest, {
                style: backdropStyle,
                ref: (0, $7404c70a0717e9c1$export$c9058316764c140e)(modal.setBackdropRef, ref),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(backdropClassName, className)
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-hidden": true,
            style: backdropStyle,
            className: backdropClassName
        });
    };
    var dialogElement = Transition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Transition, (0, $8nd05.default)({}, animationProps, {
        transitionAppear: true,
        unmountOnExit: true,
        in: open,
        timeout: dialogTransitionTimeout,
        onExit: onExit,
        onExiting: onExiting,
        onExited: (0, $2a7f3a886704e9aa$export$a34401a08725357c)(handleExited, onExited),
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    }), children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e3077f2d6e4c0351$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Portal, null, backdrop && renderBackdrop(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, rest, {
        ref: (0, $7404c70a0717e9c1$export$c9058316764c140e)(modal.setDialogRef, ref),
        style: style,
        className: className,
        tabIndex: -1
    }), dialogElement)));
});
var $ed5e59ba008bd55e$export$cd730fbd5580a801 = {
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    backdropClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    backdropStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    keyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    enforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    animationProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
$ed5e59ba008bd55e$var$Modal.displayName = 'OverlayModal';
$ed5e59ba008bd55e$var$Modal.propTypes = (0, $8nd05.default)({}, (0, $a77f7e738cb2befc$export$6df8085e712d47be), $ed5e59ba008bd55e$export$cd730fbd5580a801, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    container: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dialogTransitionTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    backdropTransitionTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    onEsc: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
});
var $ed5e59ba008bd55e$export$2e2bcd8739ae039 = $ed5e59ba008bd55e$var$Modal;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



'use client';
var $f1f43f57705463aa$var$_excluded = [
    "timeout"
];
/**
 * Bounce animation component
 * @see https://rsuitejs.com/components/animation/#bounce
 */ var $f1f43f57705463aa$var$Bounce = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
    var _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? 300 : _ref$timeout, props = (0, $1En50.default)(_ref, $f1f43f57705463aa$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)('anim'), prefix = _useClassNames.prefix;
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)('Bounce', props), propsWithDefaults = _useCustom.propsWithDefaults;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bd85cc44fa7d33b8$export$2e2bcd8739ae039), (0, $8nd05.default)({}, propsWithDefaults, {
        ref: ref,
        animation: true,
        timeout: timeout,
        enteringClassName: prefix('bounce-in'),
        enteredClassName: prefix('bounce-in'),
        exitingClassName: prefix('bounce-out'),
        exitedClassName: prefix('bounce-out')
    }));
});
$f1f43f57705463aa$var$Bounce.displayName = 'Bounce';
var $f1f43f57705463aa$export$2e2bcd8739ae039 = $f1f43f57705463aa$var$Bounce;




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



var $c9Z8w = parcelRequire("c9Z8w");
'use client';
var $f87e1e1511bf033c$var$oneOf = function oneOf(arr) {
    var checkType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(arr);
    // for [storybook/utils/propTypesToArgType.ts]
    checkType._argType_ = {
        type: 'oneOf',
        value: arr
    };
    return checkType;
};
var $f87e1e1511bf033c$export$2e2bcd8739ae039 = $f87e1e1511bf033c$var$oneOf;


'use client';
var $db380399fa5395f6$var$_templateObject;
var $db380399fa5395f6$var$_excluded = [
    "as",
    "style",
    "children",
    "dialogClassName",
    "dialogStyle",
    "classPrefix",
    "className",
    "size"
];
var $db380399fa5395f6$export$df6e267eef8e211 = {
    size: (0, $f87e1e1511bf033c$export$2e2bcd8739ae039)((0, $f1801b0896212a0f$export$8d4e26484c874870)),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dialogClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    dialogStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $db380399fa5395f6$var$ModalDialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$as = props.as, Component = _props$as === void 0 ? 'div' : _props$as, style = props.style, children = props.children, dialogClassName = props.dialogClassName, dialogStyle = props.dialogStyle, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? 'modal' : _props$classPrefix, className = props.className, size = props.size, rest = (0, $1En50.default)(props, $db380399fa5395f6$var$_excluded);
    var modalStyle = (0, $8nd05.default)({
        display: 'block'
    }, style);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), merge = _useClassNames.merge, withClassPrefix = _useClassNames.withClassPrefix, prefix = _useClassNames.prefix;
    var classes = merge(className, withClassPrefix(size));
    var dialogClasses = merge(dialogClassName, prefix('dialog'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({
        role: "dialog",
        "aria-modal": true
    }, rest, {
        ref: ref,
        className: classes,
        style: modalStyle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "document",
        className: dialogClasses,
        style: dialogStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: prefix($db380399fa5395f6$var$_templateObject || ($db380399fa5395f6$var$_templateObject = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
            "content"
        ])))
    }, children)));
});
$db380399fa5395f6$var$ModalDialog.displayName = 'ModalDialog';
$db380399fa5395f6$var$ModalDialog.propTypes = $db380399fa5395f6$export$df6e267eef8e211;
var $db380399fa5395f6$export$2e2bcd8739ae039 = $db380399fa5395f6$var$ModalDialog;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $acw62 = parcelRequire("acw62");
'use client';
var $7555c5a64fb18b0c$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");


var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");






'use client';
var $fdfdcbe3e95dc684$var$_excluded = [
    "as",
    "className",
    "classPrefix",
    "onMouseDown"
], $fdfdcbe3e95dc684$var$_excluded2 = [
    "className"
];
var $fdfdcbe3e95dc684$var$getPosition = function getPosition(target, event) {
    var offset = (0, $275f503e23b8ba49$export$2e2bcd8739ae039)(target);
    var offsetX = (event.pageX || 0) - offset.left;
    var offsetY = (event.pageY || 0) - offset.top;
    var radiusX = Math.max(offset.width - offsetX, offsetX);
    var radiusY = Math.max(offset.height - offsetY, offsetY);
    var radius = Math.sqrt(Math.pow(radiusX, 2) + Math.pow(radiusY, 2));
    return {
        width: radius * 2,
        height: radius * 2,
        left: offsetX - radius,
        top: offsetY - radius
    };
};
/**
 * The `Ripple` component is used to implement the ripple effect.
 * @private
 */ var $fdfdcbe3e95dc684$var$Ripple = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)(), disableRipple = _useCustom.disableRipple;
    var _props$as = props.as, Component = _props$as === void 0 ? 'span' : _props$as, className = props.className, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? 'ripple' : _props$classPrefix, onMouseDown = props.onMouseDown, rest = (0, $1En50.default)(props, $fdfdcbe3e95dc684$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), merge = _useClassNames.merge, prefix = _useClassNames.prefix, withClassPrefix = _useClassNames.withClassPrefix;
    var classes = merge(className, prefix('pond'));
    var triggerRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(false), rippling = _useState[0], setRippling = _useState[1];
    var _useState2 = (0, $acw62.useState)(), position = _useState2[0], setPosition = _useState2[1];
    var handleRippled = function handleRippled() {
        setRippling(false);
    };
    var handleMouseDown = (0, $acw62.useCallback)(function(event) {
        if (triggerRef.current) {
            var _position = $fdfdcbe3e95dc684$var$getPosition(triggerRef.current, event);
            setRippling(true);
            setPosition(_position);
            onMouseDown === null || onMouseDown === void 0 || onMouseDown(_position, event);
        }
    }, [
        onMouseDown
    ]);
    (0, $acw62.useEffect)(function() {
        var _triggerRef$current;
        var parentNode = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.parentNode;
        if (parentNode) {
            var mousedownListener = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(parentNode, 'mousedown', handleMouseDown);
            return function() {
                mousedownListener === null || mousedownListener === void 0 || mousedownListener.off();
            };
        }
    }, [
        handleMouseDown
    ]);
    if (disableRipple) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, rest, {
        className: classes,
        ref: (0, $7404c70a0717e9c1$export$c9058316764c140e)(triggerRef, ref)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bd85cc44fa7d33b8$export$2e2bcd8739ae039), {
        in: rippling,
        enteringClassName: prefix('rippling'),
        onEntered: handleRippled
    }, function(props, ref) {
        var className = props.className, transitionRest = (0, $1En50.default)(props, $fdfdcbe3e95dc684$var$_excluded2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", (0, $8nd05.default)({}, transitionRest, {
            ref: ref,
            className: merge(withClassPrefix(), className),
            style: position
        }));
    }));
});
$fdfdcbe3e95dc684$var$Ripple.displayName = 'Ripple';
$fdfdcbe3e95dc684$var$Ripple.propTypes = {
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $fdfdcbe3e95dc684$export$2e2bcd8739ae039 = $fdfdcbe3e95dc684$var$Ripple;


'use client';
var $c2ffabe356e578bd$export$2e2bcd8739ae039 = (0, $fdfdcbe3e95dc684$export$2e2bcd8739ae039);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

'use client';
var $06b6ffdb9639fd19$var$_excluded = [
    "as",
    "href",
    "disabled",
    "onClick"
];
function $06b6ffdb9639fd19$var$isTrivialHref(href) {
    return !href || href.trim() === '#';
}
/**
 * A SafeAnchor is a wrapper around the `<a>` HTML element.
 * @private
 */ var $06b6ffdb9639fd19$var$SafeAnchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)('SafeAnchor', props), propsWithDefaults = _useCustom.propsWithDefaults;
    var _propsWithDefaults$as = propsWithDefaults.as, Component = _propsWithDefaults$as === void 0 ? 'a' : _propsWithDefaults$as, href = propsWithDefaults.href, disabled = propsWithDefaults.disabled, onClick = propsWithDefaults.onClick, restProps = (0, $1En50.default)(propsWithDefaults, $06b6ffdb9639fd19$var$_excluded);
    var handleClick = (0, $acw62.useCallback)(function(event) {
        if (disabled || $06b6ffdb9639fd19$var$isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick === null || onClick === void 0 || onClick(event);
    }, [
        disabled,
        href,
        onClick
    ]);
    // There are default role and href attributes on the node to ensure Focus management and keyboard interactions.
    var trivialProps = $06b6ffdb9639fd19$var$isTrivialHref(href) ? {
        role: 'button',
        href: '#'
    } : null;
    if (disabled) {
        restProps.tabIndex = -1;
        restProps['aria-disabled'] = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({
        ref: ref,
        href: href
    }, trivialProps, restProps, {
        onClick: handleClick
    }));
});
$06b6ffdb9639fd19$var$SafeAnchor.displayName = 'SafeAnchor';
$06b6ffdb9639fd19$var$SafeAnchor.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
};
var $06b6ffdb9639fd19$export$2e2bcd8739ae039 = $06b6ffdb9639fd19$var$SafeAnchor;


'use client';
var $9d90716655a3b2e4$export$2e2bcd8739ae039 = (0, $06b6ffdb9639fd19$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");
'use client';
var $b6d3db9d067e1850$var$ButtonGroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $b6d3db9d067e1850$export$2e2bcd8739ae039 = $b6d3db9d067e1850$var$ButtonGroupContext;


'use client';
function $3075cd91d47b47f1$export$532a90c0e5e8e48c(one, ofTarget) {
    if (Array.isArray(ofTarget)) return ofTarget.indexOf(one) >= 0;
    return one === ofTarget;
}
var $3075cd91d47b47f1$export$2e2bcd8739ae039 = $3075cd91d47b47f1$export$532a90c0e5e8e48c;




'use client';
var $e71c47171b4323e3$var$_templateObject, $e71c47171b4323e3$var$_templateObject2, $e71c47171b4323e3$var$_templateObject3;
var $e71c47171b4323e3$var$_excluded = [
    "as",
    "active",
    "appearance",
    "block",
    "className",
    "children",
    "classPrefix",
    "color",
    "disabled",
    "loading",
    "ripple",
    "size",
    "startIcon",
    "endIcon",
    "type"
];
/**
 * The Button component is used to trigger a custom action.
 * @see https://rsuitejs.com/components/button
 */ var $e71c47171b4323e3$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)('Button', props), propsWithDefaults = _useCustom.propsWithDefaults;
    var as = propsWithDefaults.as, active = propsWithDefaults.active, _propsWithDefaults$ap = propsWithDefaults.appearance, appearance = _propsWithDefaults$ap === void 0 ? 'default' : _propsWithDefaults$ap, block = propsWithDefaults.block, className = propsWithDefaults.className, children = propsWithDefaults.children, _propsWithDefaults$cl = propsWithDefaults.classPrefix, classPrefix = _propsWithDefaults$cl === void 0 ? 'btn' : _propsWithDefaults$cl, color = propsWithDefaults.color, disabled = propsWithDefaults.disabled, loading = propsWithDefaults.loading, _propsWithDefaults$ri = propsWithDefaults.ripple, ripple = _propsWithDefaults$ri === void 0 ? true : _propsWithDefaults$ri, sizeProp = propsWithDefaults.size, startIcon = propsWithDefaults.startIcon, endIcon = propsWithDefaults.endIcon, typeProp = propsWithDefaults.type, rest = (0, $1En50.default)(propsWithDefaults, $e71c47171b4323e3$var$_excluded);
    var buttonGroup = (0, $acw62.useContext)((0, $b6d3db9d067e1850$export$2e2bcd8739ae039));
    var size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : buttonGroup === null || buttonGroup === void 0 ? void 0 : buttonGroup.size;
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), withClassPrefix = _useClassNames.withClassPrefix, prefix = _useClassNames.prefix, merge = _useClassNames.merge;
    var classes = merge(className, withClassPrefix(appearance, color, size, {
        active: active,
        disabled: disabled,
        loading: loading,
        block: block
    }));
    var buttonContent = (0, $acw62.useMemo)(function() {
        var spin = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: prefix($e71c47171b4323e3$var$_templateObject || ($e71c47171b4323e3$var$_templateObject = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
                "spin"
            ])))
        });
        var rippleElement = ripple && !(0, $3075cd91d47b47f1$export$532a90c0e5e8e48c)(appearance, [
            'link',
            'ghost'
        ]) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c2ffabe356e578bd$export$2e2bcd8739ae039), null) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, loading && spin, startIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: prefix($e71c47171b4323e3$var$_templateObject2 || ($e71c47171b4323e3$var$_templateObject2 = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
                "start-icon"
            ])))
        }, startIcon) : null, children, endIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: prefix($e71c47171b4323e3$var$_templateObject3 || ($e71c47171b4323e3$var$_templateObject3 = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
                "end-icon"
            ])))
        }, endIcon) : null, rippleElement);
    }, [
        appearance,
        children,
        endIcon,
        loading,
        prefix,
        ripple,
        startIcon
    ]);
    if (rest.href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d90716655a3b2e4$export$2e2bcd8739ae039), (0, $8nd05.default)({}, rest, {
        as: as,
        ref: ref,
        "aria-disabled": disabled,
        disabled: disabled,
        className: classes
    }), buttonContent);
    var Component = as || 'button';
    var type = typeProp || (Component === 'button' ? 'button' : undefined);
    var role = rest.role || (Component !== 'button' ? 'button' : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, rest, {
        role: role,
        type: type,
        ref: ref,
        disabled: disabled,
        "aria-disabled": disabled,
        className: classes
    }), buttonContent);
});
$e71c47171b4323e3$var$Button.displayName = 'Button';
$e71c47171b4323e3$var$Button.propTypes = {
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    appearance: (0, $f87e1e1511bf033c$export$2e2bcd8739ae039)([
        'default',
        'primary',
        'link',
        'subtle',
        'ghost'
    ]),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    color: (0, $f87e1e1511bf033c$export$2e2bcd8739ae039)([
        'red',
        'orange',
        'yellow',
        'green',
        'cyan',
        'blue',
        'violet'
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    ripple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    size: (0, $f87e1e1511bf033c$export$2e2bcd8739ae039)([
        'lg',
        'md',
        'sm',
        'xs'
    ]),
    type: (0, $f87e1e1511bf033c$export$2e2bcd8739ae039)([
        'button',
        'reset',
        'submit'
    ])
};
var $e71c47171b4323e3$export$2e2bcd8739ae039 = $e71c47171b4323e3$var$Button;


'use client';
var $148c48de5ea287db$export$2e2bcd8739ae039 = (0, $e71c47171b4323e3$export$2e2bcd8739ae039);





'use client';
var $8972982a34334e5e$var$_excluded = [
    "icon",
    "placement",
    "children",
    "circle",
    "classPrefix",
    "className"
];
/**
 * The `IconButton` component is used to specify a button with icon.
 * @see https://rsuitejs.com/components/button
 */ var $8972982a34334e5e$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)('IconButton', props), propsWithDefaults = _useCustom.propsWithDefaults;
    var icon = propsWithDefaults.icon, _propsWithDefaults$pl = propsWithDefaults.placement, placement = _propsWithDefaults$pl === void 0 ? 'left' : _propsWithDefaults$pl, children = propsWithDefaults.children, circle = propsWithDefaults.circle, _propsWithDefaults$cl = propsWithDefaults.classPrefix, classPrefix = _propsWithDefaults$cl === void 0 ? 'btn-icon' : _propsWithDefaults$cl, className = propsWithDefaults.className, rest = (0, $1En50.default)(propsWithDefaults, $8972982a34334e5e$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), merge = _useClassNames.merge, withClassPrefix = _useClassNames.withClassPrefix;
    var classes = merge(className, withClassPrefix("placement-" + placement, {
        circle: circle,
        'with-text': typeof children !== 'undefined'
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $148c48de5ea287db$export$2e2bcd8739ae039), (0, $8nd05.default)({}, rest, {
        ref: ref,
        className: classes
    }), icon, children);
});
$8972982a34334e5e$var$IconButton.displayName = 'IconButton';
$8972982a34334e5e$var$IconButton.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    circle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    placement: (0, $f87e1e1511bf033c$export$2e2bcd8739ae039)([
        'left',
        'right'
    ])
};
var $8972982a34334e5e$export$2e2bcd8739ae039 = $8972982a34334e5e$var$IconButton;


'use client';
var $b3278ed422916f6d$export$2e2bcd8739ae039 = (0, $8972982a34334e5e$export$2e2bcd8739ae039);


// Generated by script, don't edit it please.

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $8g1PZ = parcelRequire("8g1PZ");
var $936b9393fe85a475$export$82e9f45cca5ba907 = function(pre) {
    return function(className) {
        if (!pre || !className) return '';
        if (Array.isArray(className)) return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className.filter(function(name) {
            return !!name;
        }).map(function(name) {
            return "".concat(pre, "-").concat(name);
        }));
        return "".concat(pre, "-").concat(className);
    };
};



var $acw62 = parcelRequire("acw62");

function $6c47ae5fa172b4f9$export$6bed2dfdd7bea160() {
    var _ref = (0, $acw62.useContext)((0, $a122465d88af89c7$export$a49f528ae1a4d0ed)) || {}, _ref_classPrefix = _ref.classPrefix, classPrefix = _ref_classPrefix === void 0 ? 'rs-' : _ref_classPrefix, csp = _ref.csp, _ref_disableInlineStyles = _ref.disableInlineStyles, disableInlineStyles = _ref_disableInlineStyles === void 0 ? false : _ref_disableInlineStyles;
    return {
        classPrefix: classPrefix,
        csp: csp,
        disableInlineStyles: disableInlineStyles
    };
}


function $0462580d0032c3d4$export$2e2bcd8739ae039() {
    var classPrefix = (0, $6c47ae5fa172b4f9$export$6bed2dfdd7bea160)().classPrefix;
    var className = "".concat(classPrefix, "icon");
    return [
        className,
        (0, $936b9393fe85a475$export$82e9f45cca5ba907)(className)
    ];
}


var $acw62 = parcelRequire("acw62");
var $5b23cdc980afa8e1$var$containers = []; // Store container HTMLElement references
var $5b23cdc980afa8e1$var$styleElements = []; // Store {prepend: HTMLElement, append: HTMLElement}
// Function to create a <style> element with an optional nonce value
function $5b23cdc980afa8e1$var$createStyleElement(nonce) {
    var styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    styleElement.setAttribute('data-insert-css', 'rsuite-icons'); // Mark the element as inserted by insertCss
    // If a nonce is provided, set it on the style element
    if (nonce) styleElement.setAttribute('nonce', nonce);
    return styleElement;
}
function $5b23cdc980afa8e1$export$8df72f333083e057(css) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Determine if the style should be prepended or appended
    var position = options.prepend === true ? 'prepend' : 'append';
    // Use the provided container or default to the document head
    var container = options.container || document.querySelector('head');
    if (!container) throw new Error('No container found to insert CSS.');
    // Find the index of the container in the containers array
    var containerId = $5b23cdc980afa8e1$var$containers.indexOf(container);
    // If it's the first time encountering this container, initialize it
    if (containerId === -1) {
        containerId = $5b23cdc980afa8e1$var$containers.push(container) - 1;
        $5b23cdc980afa8e1$var$styleElements[containerId] = {};
    }
    // Try to retrieve the existing style element, or create a new one
    var styleElement;
    if ($5b23cdc980afa8e1$var$styleElements[containerId][position]) styleElement = $5b23cdc980afa8e1$var$styleElements[containerId][position];
    else {
        // Create a new style element with an optional nonce
        styleElement = $5b23cdc980afa8e1$var$createStyleElement(options.nonce);
        $5b23cdc980afa8e1$var$styleElements[containerId][position] = styleElement;
        if (position === 'prepend') container.insertBefore(styleElement, container.firstChild);
        else container.appendChild(styleElement);
    }
    // Remove potential UTF-8 BOM if css was read from a file
    if (css.charCodeAt(0) === 0xfeff) css = css.slice(1);
    // Insert the CSS into the <style> element
    if (styleElement.styleSheet) styleElement.styleSheet.cssText += css; // IE-specific
    else styleElement.textContent += css; // Standard approach
    return styleElement;
}



// Generated with ../less/index.less
var $bc7f6cdbd6328d6c$var$getStyles = function() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'rs-';
    return ".".concat(prefix, "icon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  vertical-align: middle;\n}\n.").concat(prefix, "icon[tabindex] {\n  cursor: pointer;\n}\n.").concat(prefix, "icon-spin {\n  -webkit-animation: icon-spin 2s infinite linear;\n          animation: icon-spin 2s infinite linear;\n}\n.").concat(prefix, "icon-pulse {\n  -webkit-animation: icon-spin 1s infinite steps(8);\n          animation: icon-spin 1s infinite steps(8);\n}\n.").concat(prefix, "icon-flip-horizontal {\n  -webkit-transform: scaleX(-1);\n      -ms-transform: scaleX(-1);\n          transform: scaleX(-1);\n}\n.").concat(prefix, "icon-flip-vertical {\n  -webkit-transform: scaleY(-1);\n      -ms-transform: scaleY(-1);\n          transform: scaleY(-1);\n}\n@-webkit-keyframes icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n@keyframes icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}");
};
var $bc7f6cdbd6328d6c$var$cssInjected = false;
var $bc7f6cdbd6328d6c$var$useInsertStyles = function() {
    var _useIconContext = (0, $6c47ae5fa172b4f9$export$6bed2dfdd7bea160)(), csp = _useIconContext.csp, classPrefix = _useIconContext.classPrefix, disableInlineStyles = _useIconContext.disableInlineStyles;
    (0, $acw62.useEffect)(function() {
        // Make sure css injected once.
        if (!$bc7f6cdbd6328d6c$var$cssInjected && !disableInlineStyles) {
            (0, $5b23cdc980afa8e1$export$8df72f333083e057)($bc7f6cdbd6328d6c$var$getStyles(classPrefix), {
                prepend: true,
                nonce: csp === null || csp === void 0 ? void 0 : csp.nonce
            });
            $bc7f6cdbd6328d6c$var$cssInjected = true;
        }
    }, []);
};
var $bc7f6cdbd6328d6c$export$2e2bcd8739ae039 = $bc7f6cdbd6328d6c$var$useInsertStyles;


function $5135cbc11d351930$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5135cbc11d351930$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5135cbc11d351930$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5135cbc11d351930$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5135cbc11d351930$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5135cbc11d351930$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $5135cbc11d351930$var$_define_property(target, key, source[key]);
        });
    }
    return target;
}
function $5135cbc11d351930$var$_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = $5135cbc11d351930$var$_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5135cbc11d351930$var$_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5135cbc11d351930$var$_sliced_to_array(arr, i) {
    return $5135cbc11d351930$var$_array_with_holes(arr) || $5135cbc11d351930$var$_iterable_to_array_limit(arr, i) || $5135cbc11d351930$var$_unsupported_iterable_to_array(arr, i) || $5135cbc11d351930$var$_non_iterable_rest();
}
function $5135cbc11d351930$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5135cbc11d351930$var$_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5135cbc11d351930$var$_array_like_to_array(o, minLen);
}
function $5135cbc11d351930$var$filterProps(props) {
    var nextProps = {};
    Object.entries(props).forEach(function(param) {
        var _param = $5135cbc11d351930$var$_sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (typeof value !== 'undefined') nextProps[key] = value;
    });
    return nextProps;
}
var $5135cbc11d351930$var$Icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var tmp = props.as, Component = tmp === void 0 ? 'svg' : tmp, spin = props.spin, pulse = props.pulse, flip = props.flip, _props_fill = props.fill, fill = _props_fill === void 0 ? 'currentColor' : _props_fill, className = props.className, rotate = props.rotate, children = props.children, viewBox = props.viewBox, _props_width = props.width, width = _props_width === void 0 ? '1em' : _props_width, _props_height = props.height, height = _props_height === void 0 ? '1em' : _props_height, style = props.style, rest = $5135cbc11d351930$var$_object_without_properties(props, [
        "as",
        "spin",
        "pulse",
        "flip",
        "fill",
        "className",
        "rotate",
        "children",
        "viewBox",
        "width",
        "height",
        "style"
    ]);
    var _useClassNames = $5135cbc11d351930$var$_sliced_to_array((0, $0462580d0032c3d4$export$2e2bcd8739ae039)(), 2), componentClassName = _useClassNames[0], addPrefix = _useClassNames[1];
    var _obj;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, componentClassName, (_obj = {}, $5135cbc11d351930$var$_define_property(_obj, addPrefix('spin'), spin), $5135cbc11d351930$var$_define_property(_obj, addPrefix('pulse'), pulse), $5135cbc11d351930$var$_define_property(_obj, addPrefix("flip-".concat(flip)), !!flip), _obj));
    var rotateStyles = {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    };
    (0, $bc7f6cdbd6328d6c$export$2e2bcd8739ae039)();
    var svgProps = $5135cbc11d351930$var$filterProps({
        width: width,
        height: height,
        fill: fill,
        viewBox: viewBox,
        className: classes,
        style: rotate ? $5135cbc11d351930$var$_object_spread({}, rotateStyles, style) : style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $5135cbc11d351930$var$_object_spread({
        "aria-hidden": true,
        focusable: false,
        ref: ref
    }, svgProps, rest), children);
});
$5135cbc11d351930$var$Icon.displayName = 'Icon';
var $5135cbc11d351930$export$2e2bcd8739ae039 = $5135cbc11d351930$var$Icon;


function $c8dd3ee526e4dc0e$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c8dd3ee526e4dc0e$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $c8dd3ee526e4dc0e$var$_define_property(target, key, source[key]);
        });
    }
    return target;
}
function $c8dd3ee526e4dc0e$var$createSvgIcon(param) {
    var as = param.as, ariaLabel = param.ariaLabel, displayName = param.displayName, category = param.category;
    var IconComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5135cbc11d351930$export$2e2bcd8739ae039), $c8dd3ee526e4dc0e$var$_object_spread({
            "aria-label": ariaLabel,
            "data-category": category,
            ref: ref,
            as: as
        }, props));
    });
    IconComponent.displayName = displayName;
    return IconComponent;
}
var $c8dd3ee526e4dc0e$export$2e2bcd8739ae039 = $c8dd3ee526e4dc0e$var$createSvgIcon;


// Generated by script, please do not edit this file.

var $acw62 = parcelRequire("acw62");
function $d47549484aa53db9$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d47549484aa53db9$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $d47549484aa53db9$var$_define_property(target, key, source[key]);
        });
    }
    return target;
}
var $d47549484aa53db9$var$Close = function(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("svg", $d47549484aa53db9$var$_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m2.784 2.089.069.058 5.146 5.147 5.146-5.147a.5.5 0 0 1 .765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 0 1-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 0 1-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 0 1 .638-.765"
    }));
};
var $d47549484aa53db9$var$ForwardRef = /*#__PURE__*/ (0, $acw62.forwardRef)($d47549484aa53db9$var$Close);
var $d47549484aa53db9$export$2e2bcd8739ae039 = $d47549484aa53db9$var$ForwardRef;


var $1c8754c86021516b$var$Close = (0, $c8dd3ee526e4dc0e$export$2e2bcd8739ae039)({
    as: (0, $d47549484aa53db9$export$2e2bcd8739ae039),
    ariaLabel: 'close',
    category: 'application',
    displayName: 'Close'
});
var $1c8754c86021516b$export$2e2bcd8739ae039 = $1c8754c86021516b$var$Close;


'use client';
var $62fb641ff65d4c80$var$_excluded = [
    "as",
    "classPrefix",
    "className",
    "style",
    "children"
];
var $62fb641ff65d4c80$var$ModalBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$as = props.as, Component = _props$as === void 0 ? 'div' : _props$as, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? 'modal-body' : _props$classPrefix, className = props.className, style = props.style, children = props.children, rest = (0, $1En50.default)(props, $62fb641ff65d4c80$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), withClassPrefix = _useClassNames.withClassPrefix, merge = _useClassNames.merge, prefix = _useClassNames.prefix;
    var classes = merge(className, withClassPrefix());
    var context = (0, $acw62.useContext)((0, $7555c5a64fb18b0c$export$ab57792b9b6974a6));
    var _ref = context || {}, getBodyStyles = _ref.getBodyStyles, closeButton = _ref.closeButton, onModalClose = _ref.onModalClose;
    var bodyStyles = getBodyStyles === null || getBodyStyles === void 0 ? void 0 : getBodyStyles();
    var buttonElement = null;
    if (closeButton) buttonElement = typeof closeButton === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3278ed422916f6d$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1c8754c86021516b$export$2e2bcd8739ae039), null),
        appearance: "subtle",
        size: "sm",
        className: prefix('close'),
        onClick: onModalClose
    }) : closeButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, rest, {
        ref: ref,
        style: (0, $8nd05.default)({}, bodyStyles, style),
        className: classes
    }), buttonElement, children);
});
$62fb641ff65d4c80$var$ModalBody.displayName = 'ModalBody';
$62fb641ff65d4c80$var$ModalBody.propTypes = {
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $62fb641ff65d4c80$export$2e2bcd8739ae039 = $62fb641ff65d4c80$var$ModalBody;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



'use client';
var $55261ed15902eaa6$var$_excluded = [
    "as",
    "classPrefix",
    "className",
    "locale"
];
/**
 * Close button for components such as Message and Notification.
 */ var $55261ed15902eaa6$var$CloseButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$as = props.as, Component = _props$as === void 0 ? 'button' : _props$as, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? 'btn-close' : _props$classPrefix, className = props.className, overrideLocale = props.locale, rest = (0, $1En50.default)(props, $55261ed15902eaa6$var$_excluded);
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)(), getLocale = _useCustom.getLocale;
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), withClassPrefix = _useClassNames.withClassPrefix, merge = _useClassNames.merge;
    var _getLocale = getLocale('CloseButton', overrideLocale), closeLabel = _getLocale.closeLabel;
    var classes = merge(className, withClassPrefix());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({
        type: "button",
        ref: ref,
        className: classes,
        "aria-label": closeLabel
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1c8754c86021516b$export$2e2bcd8739ae039), null));
});
$55261ed15902eaa6$var$CloseButton.displayName = 'CloseButton';
var $55261ed15902eaa6$export$2e2bcd8739ae039 = $55261ed15902eaa6$var$CloseButton;


'use client';
var $98c9443cbeeeb1cd$export$2e2bcd8739ae039 = (0, $55261ed15902eaa6$export$2e2bcd8739ae039);




'use client';
var $23a7da312d57872f$var$_excluded = [
    "as",
    "classPrefix",
    "className",
    "closeButton",
    "children",
    "onClose"
];
var $23a7da312d57872f$var$ModalHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$as = props.as, Component = _props$as === void 0 ? 'div' : _props$as, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? 'modal-header' : _props$classPrefix, className = props.className, _props$closeButton = props.closeButton, closeButton = _props$closeButton === void 0 ? true : _props$closeButton, children = props.children, onClose = props.onClose, rest = (0, $1En50.default)(props, $23a7da312d57872f$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), merge = _useClassNames.merge, withClassPrefix = _useClassNames.withClassPrefix, prefix = _useClassNames.prefix;
    var classes = merge(className, withClassPrefix());
    var context = (0, $acw62.useContext)((0, $7555c5a64fb18b0c$export$ab57792b9b6974a6));
    var _ref = context || {}, isDrawer = _ref.isDrawer, onModalClose = _ref.onModalClose;
    var buttonElement = isDrawer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b3278ed422916f6d$export$2e2bcd8739ae039), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1c8754c86021516b$export$2e2bcd8739ae039), null),
        appearance: "subtle",
        size: "sm",
        className: prefix('close'),
        onClick: (0, $2a7f3a886704e9aa$export$a34401a08725357c)(onClose, onModalClose)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $98c9443cbeeeb1cd$export$2e2bcd8739ae039), {
        className: prefix('close'),
        onClick: (0, $2a7f3a886704e9aa$export$a34401a08725357c)(onClose, onModalClose)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, rest, {
        ref: ref,
        className: classes
    }), closeButton && buttonElement, children);
});
$23a7da312d57872f$var$ModalHeader.displayName = 'ModalHeader';
$23a7da312d57872f$var$ModalHeader.propTypes = {
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $23a7da312d57872f$export$2e2bcd8739ae039 = $23a7da312d57872f$var$ModalHeader;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


'use client';
var $bfc3be9e8cf0bb31$var$_excluded = [
    "as",
    "classPrefix",
    "className",
    "role"
];
var $bfc3be9e8cf0bb31$var$ModalTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _props$as = props.as, Component = _props$as === void 0 ? 'h4' : _props$as, _props$classPrefix = props.classPrefix, classPrefix = _props$classPrefix === void 0 ? 'modal-title' : _props$classPrefix, className = props.className, role = props.role, rest = (0, $1En50.default)(props, $bfc3be9e8cf0bb31$var$_excluded);
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), withClassPrefix = _useClassNames.withClassPrefix, merge = _useClassNames.merge;
    var classes = merge(className, withClassPrefix());
    var context = (0, $acw62.useContext)((0, $7555c5a64fb18b0c$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({
        id: context ? context.dialogId + "-title" : undefined
    }, rest, {
        role: role,
        ref: ref,
        className: classes
    }));
});
$bfc3be9e8cf0bb31$var$ModalTitle.displayName = 'Modal.Title';
$bfc3be9e8cf0bb31$var$ModalTitle.propTypes = {
    as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $bfc3be9e8cf0bb31$export$2e2bcd8739ae039 = $bfc3be9e8cf0bb31$var$ModalTitle;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $c9Z8w = parcelRequire("c9Z8w");


'use client';
var $88d6a42901308432$var$_excluded = [
    "name",
    "componentAs",
    "componentClassPrefix"
], $88d6a42901308432$var$_excluded2 = [
    "as",
    "classPrefix",
    "className",
    "role"
];
function $88d6a42901308432$export$60e54eaca7e7fb38(_ref) {
    var name = _ref.name, componentAs = _ref.componentAs, componentClassPrefix = _ref.componentClassPrefix, defaultProps = (0, $1En50.default)(_ref, $88d6a42901308432$var$_excluded);
    var Component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)(name, props), propsWithDefaults = _useCustom.propsWithDefaults;
        var _propsWithDefaults$as = propsWithDefaults.as, Component = _propsWithDefaults$as === void 0 ? componentAs || 'div' : _propsWithDefaults$as, _propsWithDefaults$cl = propsWithDefaults.classPrefix, classPrefix = _propsWithDefaults$cl === void 0 ? componentClassPrefix || (0, (/*@__PURE__*/$parcel$interopDefault($fa74499edcf324c6$exports)))(name) : _propsWithDefaults$cl, className = propsWithDefaults.className, role = propsWithDefaults.role, rest = (0, $1En50.default)(propsWithDefaults, $88d6a42901308432$var$_excluded2);
        var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), withClassPrefix = _useClassNames.withClassPrefix, merge = _useClassNames.merge;
        var classes = merge(className, withClassPrefix());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, defaultProps, rest, {
            role: role,
            ref: ref,
            className: classes
        }));
    });
    Component.displayName = name;
    Component.propTypes = {
        as: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    };
    return Component;
}
var $88d6a42901308432$export$2e2bcd8739ae039 = $88d6a42901308432$export$60e54eaca7e7fb38;


'use client';
var $0fb379426af41604$var$ModalFooter = (0, $88d6a42901308432$export$60e54eaca7e7fb38)({
    name: 'ModalFooter'
});
var $0fb379426af41604$export$2e2bcd8739ae039 = $0fb379426af41604$var$ModalFooter;



var $acw62 = parcelRequire("acw62");
var $ba6adedcdb459bac$exports = {};

/** Used to generate unique IDs. */ var $ba6adedcdb459bac$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $ba6adedcdb459bac$var$uniqueId(prefix) {
    var id = ++$ba6adedcdb459bac$var$idCounter;
    return $f5d9385a9cc7e413$exports(prefix) + id;
}
$ba6adedcdb459bac$exports = $ba6adedcdb459bac$var$uniqueId;


'use client';
var $44c0f5699091c425$var$reactUseId = $acw62['useId'.toString()];
function $44c0f5699091c425$export$c485849f2e393253(prefix, idProp) {
    var idRef = $acw62.useRef();
    if ($44c0f5699091c425$var$reactUseId !== undefined) return idProp !== null && idProp !== void 0 ? idProp : "" + prefix + $44c0f5699091c425$var$reactUseId();
    if (!idRef.current) idRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($ba6adedcdb459bac$exports)))(prefix);
    return idProp !== null && idProp !== void 0 ? idProp : idRef.current;
}
var $44c0f5699091c425$export$2e2bcd8739ae039 = $44c0f5699091c425$export$c485849f2e393253;





var $acw62 = parcelRequire("acw62");


var $5c7908f42ed9bb37$export$402e76927ebf6a24 = [];


var $08f51855f5aa1c67$export$63c81bd924f89474 = function() {
    return (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $16b09d5982f07c6f$export$8ca35300535e324d = function() {
    return (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $a94d1125331cd631$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $a94d1125331cd631$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $a94d1125331cd631$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $a94d1125331cd631$var$msg;
    }
    window.dispatchEvent(event);
};



var $eb9a41c17c565fb1$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($eb9a41c17c565fb1$export$416d111b83cd1483 || ($eb9a41c17c565fb1$export$416d111b83cd1483 = {}));


var $4aa2fd75c74ae252$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $ef95acc2cc2e837a$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $9347cb8a23412ffc$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $8243f40f6e04f737$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $8243f40f6e04f737$export$ee695c13482bb5dd = function(target) {
    if ($8243f40f6e04f737$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $8243f40f6e04f737$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $8243f40f6e04f737$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $5970d6d9ee6c5784$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $f202245796aa2855$var$cache = new WeakMap();
var $f202245796aa2855$var$scrollRegexp = /auto|scroll/;
var $f202245796aa2855$var$verticalRegexp = /^tb|vertical/;
var $f202245796aa2855$var$IE = /msie|trident/i.test((0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).navigator && (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).navigator.userAgent);
var $f202245796aa2855$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $f202245796aa2855$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $ef95acc2cc2e837a$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $f202245796aa2855$var$zeroBoxes = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $f202245796aa2855$var$size(),
    borderBoxSize: $f202245796aa2855$var$size(),
    contentBoxSize: $f202245796aa2855$var$size(),
    contentRect: new (0, $9347cb8a23412ffc$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $f202245796aa2855$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($f202245796aa2855$var$cache.has(target) && !forceRecalculation) return $f202245796aa2855$var$cache.get(target);
    if ((0, $8243f40f6e04f737$export$ee695c13482bb5dd)(target)) {
        $f202245796aa2855$var$cache.set(target, $f202245796aa2855$var$zeroBoxes);
        return $f202245796aa2855$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $8243f40f6e04f737$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$f202245796aa2855$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $f202245796aa2855$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $f202245796aa2855$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $f202245796aa2855$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $f202245796aa2855$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $f202245796aa2855$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $f202245796aa2855$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $f202245796aa2855$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $f202245796aa2855$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $f202245796aa2855$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $9347cb8a23412ffc$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $f202245796aa2855$var$cache.set(target, boxes);
    return boxes;
};
var $f202245796aa2855$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $f202245796aa2855$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $eb9a41c17c565fb1$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $eb9a41c17c565fb1$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $01e136febfef5919$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $f202245796aa2855$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $4aa2fd75c74ae252$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $8243f40f6e04f737$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $3f0a2fbc64f46fd3$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $01e136febfef5919$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $f202245796aa2855$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $638acb999774387d$export$9c17b8913a2a3572 = function(depth) {
    (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $df3e726c86d9d6ad$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $ecda2146b87bdeae$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $638acb999774387d$export$9c17b8913a2a3572)(depth);
    while((0, $08f51855f5aa1c67$export$63c81bd924f89474)()){
        depth = (0, $3f0a2fbc64f46fd3$export$9cac928141e5443b)();
        (0, $638acb999774387d$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $16b09d5982f07c6f$export$8ca35300535e324d)()) (0, $a94d1125331cd631$export$888cb69481582149)();
    return depth > 0;
};



var $4a6a87bff7ef9ac1$var$trigger;
var $4a6a87bff7ef9ac1$var$callbacks = [];
var $4a6a87bff7ef9ac1$var$notify = function() {
    return $4a6a87bff7ef9ac1$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $4a6a87bff7ef9ac1$export$4c995d4933c4abb = function(callback) {
    if (!$4a6a87bff7ef9ac1$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $4a6a87bff7ef9ac1$var$notify();
        }).observe(el_1, config);
        $4a6a87bff7ef9ac1$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $4a6a87bff7ef9ac1$var$callbacks.push(callback);
    $4a6a87bff7ef9ac1$var$trigger();
};


var $b7d7256b374777b1$export$5755c7b572e34c6 = function(cb) {
    (0, $4a6a87bff7ef9ac1$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $068e7d416abba7c5$var$watching = 0;
var $068e7d416abba7c5$var$isWatching = function() {
    return !!$068e7d416abba7c5$var$watching;
};
var $068e7d416abba7c5$var$CATCH_PERIOD = 250;
var $068e7d416abba7c5$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $068e7d416abba7c5$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $068e7d416abba7c5$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $068e7d416abba7c5$var$scheduled = false;
var $068e7d416abba7c5$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $068e7d416abba7c5$var$CATCH_PERIOD;
        if ($068e7d416abba7c5$var$scheduled) return;
        $068e7d416abba7c5$var$scheduled = true;
        var until = $068e7d416abba7c5$var$time(timeout);
        (0, $b7d7256b374777b1$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $ecda2146b87bdeae$export$e54fe5b0f43758f7)();
            } finally{
                $068e7d416abba7c5$var$scheduled = false;
                timeout = until - $068e7d416abba7c5$var$time();
                if (!$068e7d416abba7c5$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $068e7d416abba7c5$var$observerConfig);
        };
        document.body ? cb() : (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $068e7d416abba7c5$var$events.forEach(function(name) {
                return (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $068e7d416abba7c5$var$events.forEach(function(name) {
                return (0, $5970d6d9ee6c5784$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $068e7d416abba7c5$export$d30788f2c20241cd = new $068e7d416abba7c5$var$Scheduler();
var $068e7d416abba7c5$export$1f18a74d42722835 = function(n) {
    !$068e7d416abba7c5$var$watching && n > 0 && $068e7d416abba7c5$export$d30788f2c20241cd.start();
    $068e7d416abba7c5$var$watching += n;
    !$068e7d416abba7c5$var$watching && $068e7d416abba7c5$export$d30788f2c20241cd.stop();
};





var $4b08a70ac8b1df2b$var$skipNotifyOnElement = function(target) {
    return !(0, $8243f40f6e04f737$export$165b39ed277223c2)(target) && !(0, $8243f40f6e04f737$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $4b08a70ac8b1df2b$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $eb9a41c17c565fb1$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $f202245796aa2855$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($4b08a70ac8b1df2b$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $53daa9aad498b184$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $d48ceca8c6d96018$var$observerMap = new WeakMap();
var $d48ceca8c6d96018$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $d48ceca8c6d96018$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $53daa9aad498b184$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $d48ceca8c6d96018$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($d48ceca8c6d96018$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $4b08a70ac8b1df2b$export$fea412043713122)(target, options && options.box));
            (0, $068e7d416abba7c5$export$1f18a74d42722835)(1);
            (0, $068e7d416abba7c5$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        var index = $d48ceca8c6d96018$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $5c7908f42ed9bb37$export$402e76927ebf6a24).splice((0, $5c7908f42ed9bb37$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $068e7d416abba7c5$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $d48ceca8c6d96018$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $ba00521e8d0ae023$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $8243f40f6e04f737$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $8243f40f6e04f737$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $d48ceca8c6d96018$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






'use client';
var $ebb99b4a395e2859$export$416cce9da441f0ae = function useBodyStyles(ref, options) {
    var _useState = (0, $acw62.useState)({}), bodyStyles = _useState[0], setBodyStyles = _useState[1];
    var overflow = options.overflow, prefix = options.prefix, size = options.size;
    var windowResizeListener = (0, $acw62.useRef)();
    var contentElement = (0, $acw62.useRef)(null);
    var contentElementResizeObserver = (0, $acw62.useRef)();
    var updateBodyStyles = (0, $acw62.useCallback)(function(_event, entering) {
        var dialog = ref.current;
        var scrollHeight = dialog ? dialog.scrollHeight : 0;
        var styles = {
            overflow: 'auto'
        };
        if (dialog) {
            // default margin
            var headerHeight = 46;
            var footerHeight = 46;
            var headerDOM = dialog.querySelector("." + prefix('header'));
            var footerDOM = dialog.querySelector("." + prefix('footer'));
            headerHeight = headerDOM ? (0, $5119eabf2459031c$export$2e2bcd8739ae039)(headerDOM) + headerHeight : headerHeight;
            footerHeight = footerDOM ? (0, $5119eabf2459031c$export$2e2bcd8739ae039)(footerDOM) + footerHeight : footerHeight;
            /**
       * Header height + Footer height + Dialog margin
       */ var excludeHeight = headerHeight + footerHeight + (entering ? 70 : 60);
            var bodyHeight = (0, $5119eabf2459031c$export$2e2bcd8739ae039)(window) - excludeHeight;
            var maxHeight = scrollHeight >= bodyHeight ? bodyHeight : scrollHeight;
            styles.maxHeight = maxHeight;
        }
        setBodyStyles(styles);
    }, [
        prefix,
        ref
    ]);
    var onDestroyEvents = (0, $acw62.useCallback)(function() {
        var _windowResizeListener, _windowResizeListener2, _contentElementResize;
        (_windowResizeListener = windowResizeListener.current) === null || _windowResizeListener === void 0 || (_windowResizeListener2 = _windowResizeListener.off) === null || _windowResizeListener2 === void 0 || _windowResizeListener2.call(_windowResizeListener);
        (_contentElementResize = contentElementResizeObserver.current) === null || _contentElementResize === void 0 || _contentElementResize.disconnect();
        windowResizeListener.current = null;
        contentElementResizeObserver.current = null;
    }, []);
    var onChangeBodyStyles = (0, $acw62.useCallback)(function(entering) {
        if (!overflow || size === 'full') {
            setBodyStyles(null);
            return;
        }
        if (ref.current) {
            updateBodyStyles(undefined, entering);
            contentElement.current = ref.current.querySelector("." + prefix('content'));
            if (!windowResizeListener.current) windowResizeListener.current = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(window, 'resize', updateBodyStyles);
            if (contentElement.current && !contentElementResizeObserver.current) {
                contentElementResizeObserver.current = new (0, $ba00521e8d0ae023$export$9caf76241ca21a11)(function() {
                    return updateBodyStyles();
                });
                contentElementResizeObserver.current.observe(contentElement.current);
            }
        }
    }, [
        overflow,
        prefix,
        ref,
        size,
        updateBodyStyles
    ]);
    (0, $acw62.useEffect)(function() {
        return onDestroyEvents;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        overflow ? bodyStyles : null,
        onChangeBodyStyles,
        onDestroyEvents
    ];
};


'use client';
var $8849a8ce523422ce$var$warned = {};
function $8849a8ce523422ce$export$5b28268982f175ba(message) {
    if (!$8849a8ce523422ce$var$warned[message]) {
        console.warn(message);
        $8849a8ce523422ce$var$warned[message] = true;
    }
}
$8849a8ce523422ce$export$5b28268982f175ba._resetWarned = function() {
    for(var message in $8849a8ce523422ce$var$warned)delete $8849a8ce523422ce$var$warned[message];
};
var $8849a8ce523422ce$export$2e2bcd8739ae039 = $8849a8ce523422ce$export$5b28268982f175ba;


'use client';
function $292baa45c8f6260a$export$2e2bcd8739ae039(propType, explanation) {
    return function validate(props, propName, componentName) {
        // Note ...rest here
        if (props[propName] != null) {
            var message = "\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation;
            (0, $8849a8ce523422ce$export$5b28268982f175ba)(message);
        }
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
        return propType.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest)); // and here
    };
}
function $292baa45c8f6260a$export$e4beebb3c2dce806(propType, explanation) {
    return function validate(props, propName, componentName) {
        // Note ...rest here
        if (props[propName] != null) {
            var message = "[rsuite] \"" + propName + "\" property of " + componentName + " component has been deprecated.\n" + explanation;
            (0, $8849a8ce523422ce$export$5b28268982f175ba)(message);
        }
        for(var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)rest[_key2 - 3] = arguments[_key2];
        return propType.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest)); // and here
    };
}



'use client';
var $20472afd0f14757f$var$_templateObject, $20472afd0f14757f$var$_templateObject2, $20472afd0f14757f$var$_templateObject3;
var $20472afd0f14757f$var$_excluded = [
    "animation",
    "animationProps",
    "animationTimeout",
    "aria-labelledby",
    "aria-describedby",
    "backdropClassName",
    "backdrop",
    "className",
    "children",
    "classPrefix",
    "dialogClassName",
    "dialogStyle",
    "dialogAs",
    "enforceFocus",
    "full",
    "overflow",
    "open",
    "onClose",
    "onEntered",
    "onEntering",
    "onExited",
    "role",
    "size",
    "id",
    "isDrawer",
    "closeButton"
], $20472afd0f14757f$var$_excluded2 = [
    "className"
];
var $20472afd0f14757f$var$modalSizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'full'
];
/**
 * The `Modal` component is used to show content in a layer above the app.
 * @see https://rsuitejs.com/components/modal
 */ var $20472afd0f14757f$var$Modal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _prefix, _merge;
    var _useCustom = (0, $92807dc5bcf0ee15$export$9042589177add566)('Modal', props), propsWithDefaults = _useCustom.propsWithDefaults;
    var _propsWithDefaults$an = propsWithDefaults.animation, animation = _propsWithDefaults$an === void 0 ? (0, $f1f43f57705463aa$export$2e2bcd8739ae039) : _propsWithDefaults$an, animationProps = propsWithDefaults.animationProps, _propsWithDefaults$an2 = propsWithDefaults.animationTimeout, animationTimeout = _propsWithDefaults$an2 === void 0 ? 300 : _propsWithDefaults$an2, ariaLabelledby = propsWithDefaults['aria-labelledby'], ariaDescribedby = propsWithDefaults['aria-describedby'], backdropClassName = propsWithDefaults.backdropClassName, _propsWithDefaults$ba = propsWithDefaults.backdrop, backdrop = _propsWithDefaults$ba === void 0 ? true : _propsWithDefaults$ba, className = propsWithDefaults.className, children = propsWithDefaults.children, _propsWithDefaults$cl = propsWithDefaults.classPrefix, classPrefix = _propsWithDefaults$cl === void 0 ? 'modal' : _propsWithDefaults$cl, dialogClassName = propsWithDefaults.dialogClassName, dialogStyle = propsWithDefaults.dialogStyle, _propsWithDefaults$di = propsWithDefaults.dialogAs, Dialog = _propsWithDefaults$di === void 0 ? (0, $db380399fa5395f6$export$2e2bcd8739ae039) : _propsWithDefaults$di, enforceFocusProp = propsWithDefaults.enforceFocus, full = propsWithDefaults.full, _propsWithDefaults$ov = propsWithDefaults.overflow, overflow = _propsWithDefaults$ov === void 0 ? true : _propsWithDefaults$ov, open = propsWithDefaults.open, onClose = propsWithDefaults.onClose, onEntered = propsWithDefaults.onEntered, onEntering = propsWithDefaults.onEntering, onExited = propsWithDefaults.onExited, _propsWithDefaults$ro = propsWithDefaults.role, role = _propsWithDefaults$ro === void 0 ? 'dialog' : _propsWithDefaults$ro, _propsWithDefaults$si = propsWithDefaults.size, size = _propsWithDefaults$si === void 0 ? 'sm' : _propsWithDefaults$si, idProp = propsWithDefaults.id, _propsWithDefaults$is = propsWithDefaults.isDrawer, isDrawer = _propsWithDefaults$is === void 0 ? false : _propsWithDefaults$is, closeButton = propsWithDefaults.closeButton, rest = (0, $1En50.default)(propsWithDefaults, $20472afd0f14757f$var$_excluded);
    var inClass = {
        in: open && !animation
    };
    var _useClassNames = (0, $0f1ed170257520ec$export$b54202cc833d4188)(classPrefix), merge = _useClassNames.merge, prefix = _useClassNames.prefix;
    var _useState = (0, $acw62.useState)(false), shake = _useState[0], setShake = _useState[1];
    var classes = merge(className, prefix((_prefix = {
        full: full
    }, _prefix[size] = $20472afd0f14757f$var$modalSizes.includes(size), _prefix)));
    var dialogRef = (0, $acw62.useRef)(null);
    var transitionEndListener = (0, $acw62.useRef)();
    // The style of the Modal body will be updated with the size of the window or container.
    var _useBodyStyles = (0, $ebb99b4a395e2859$export$416cce9da441f0ae)(dialogRef, {
        overflow: overflow,
        prefix: prefix,
        size: size
    }), bodyStyles = _useBodyStyles[0], onChangeBodyStyles = _useBodyStyles[1], onDestroyEvents = _useBodyStyles[2];
    var dialogId = (0, $44c0f5699091c425$export$c485849f2e393253)('dialog-', idProp);
    var modalContextValue = (0, $acw62.useMemo)(function() {
        return {
            dialogId: dialogId,
            onModalClose: onClose,
            getBodyStyles: function getBodyStyles() {
                return bodyStyles;
            },
            closeButton: closeButton,
            isDrawer: isDrawer
        };
    }, [
        dialogId,
        onClose,
        closeButton,
        isDrawer,
        bodyStyles
    ]);
    var handleExited = (0, $acw62.useCallback)(function(node) {
        var _transitionEndListene;
        onExited === null || onExited === void 0 || onExited(node);
        onDestroyEvents();
        (_transitionEndListene = transitionEndListener.current) === null || _transitionEndListene === void 0 || _transitionEndListene.off();
        transitionEndListener.current = null;
    }, [
        onDestroyEvents,
        onExited
    ]);
    var handleEntered = (0, $acw62.useCallback)(function(node) {
        onEntered === null || onEntered === void 0 || onEntered(node);
        onChangeBodyStyles();
    }, [
        onChangeBodyStyles,
        onEntered
    ]);
    var handleEntering = (0, $acw62.useCallback)(function(node) {
        onEntering === null || onEntering === void 0 || onEntering(node);
        onChangeBodyStyles(true);
    }, [
        onChangeBodyStyles,
        onEntering
    ]);
    var backdropClick = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    var handleMouseDown = (0, $acw62.useCallback)(function(event) {
        backdropClick.current = event.target === event.currentTarget;
    }, []);
    var handleBackdropClick = (0, $acw62.useCallback)(function(event) {
        // Ignore click events from non-backdrop.
        // fix: https://github.com/rsuite/rsuite/issues/3394
        if (!backdropClick.current) return;
        // Ignore click events from dialog.
        if (event.target === dialogRef.current) return;
        // Ignore click events from dialog children.
        if (event.target !== event.currentTarget) return;
        // When the value of `backdrop` is `static`, a jitter animation will be added to the dialog when clicked.
        if (backdrop === 'static') {
            setShake(true);
            if (!transitionEndListener.current && dialogRef.current) //fix: https://github.com/rsuite/rsuite/blob/a93d13c14fb20cc58204babe3331d3c3da3fe1fd/src/Modal/styles/index.less#L59
            transitionEndListener.current = (0, $4b481efe1bd5818f$export$2e2bcd8739ae039)(dialogRef.current, (0, $32e2b5e693256d0e$export$2e2bcd8739ae039)(), function() {
                setShake(false);
            });
            return;
        }
        onClose === null || onClose === void 0 || onClose(event);
    }, [
        backdrop,
        onClose
    ]);
    (0, $04ef43fe2810d94c$export$328d69a66df243d8)(function() {
        var _transitionEndListene2;
        (_transitionEndListene2 = transitionEndListener.current) === null || _transitionEndListene2 === void 0 || _transitionEndListene2.off();
    });
    var sizeKey = 'width';
    if (isDrawer) {
        var _ref = animationProps || {}, placement = _ref.placement;
        // The width or height of the drawer depends on the placement.
        sizeKey = placement === 'top' || placement === 'bottom' ? 'height' : 'width';
    }
    var enforceFocus = (0, $acw62.useMemo)(function() {
        if (typeof enforceFocusProp === 'boolean') return enforceFocusProp;
        // When the Drawer is displayed and the backdrop is not displayed, the focus is not restricted.
        if (isDrawer && backdrop === false) return false;
    }, [
        backdrop,
        enforceFocusProp,
        isDrawer
    ]);
    var wrapperClassName = merge(prefix($20472afd0f14757f$var$_templateObject || ($20472afd0f14757f$var$_templateObject = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
        "wrapper"
    ]))), (_merge = {}, _merge[prefix($20472afd0f14757f$var$_templateObject2 || ($20472afd0f14757f$var$_templateObject2 = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
        "no-backdrop"
    ])))] = backdrop === false, _merge));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7555c5a64fb18b0c$export$ab57792b9b6974a6).Provider, {
        value: modalContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ed5e59ba008bd55e$export$2e2bcd8739ae039), (0, $8nd05.default)({
        "data-testid": isDrawer ? 'drawer-wrapper' : 'modal-wrapper'
    }, rest, {
        ref: ref,
        backdrop: backdrop,
        enforceFocus: enforceFocus,
        open: open,
        onClose: onClose,
        className: wrapperClassName,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExited: handleExited,
        backdropClassName: merge(prefix($20472afd0f14757f$var$_templateObject3 || ($20472afd0f14757f$var$_templateObject3 = (0, $c5db23e5823ab236$export$2e2bcd8739ae039)([
            "backdrop"
        ]))), backdropClassName, inClass),
        containerClassName: prefix({
            open: open,
            'has-backdrop': backdrop
        }),
        transition: animation ? animation : undefined,
        animationProps: animationProps,
        dialogTransitionTimeout: animationTimeout,
        backdropTransitionTimeout: 150,
        onClick: backdrop ? handleBackdropClick : undefined,
        onMouseDown: handleMouseDown
    }), function(transitionProps, transitionRef) {
        var _ref2;
        var transitionClassName = transitionProps.className, transitionRest = (0, $1En50.default)(transitionProps, $20472afd0f14757f$var$_excluded2);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Dialog, (0, $8nd05.default)({
            role: role,
            id: dialogId,
            "aria-labelledby": ariaLabelledby !== null && ariaLabelledby !== void 0 ? ariaLabelledby : dialogId + "-title",
            "aria-describedby": ariaDescribedby,
            style: (_ref2 = {}, _ref2[sizeKey] = $20472afd0f14757f$var$modalSizes.includes(size) ? undefined : size, _ref2)
        }, transitionRest, (0, (/*@__PURE__*/$parcel$interopDefault($0c11739df3ac35ad$exports)))(rest, Object.keys((0, $db380399fa5395f6$export$df6e267eef8e211))), {
            ref: (0, $7404c70a0717e9c1$export$c9058316764c140e)(dialogRef, transitionRef),
            classPrefix: classPrefix,
            className: merge(classes, transitionClassName, prefix({
                shake: shake
            })),
            dialogClassName: dialogClassName,
            dialogStyle: dialogStyle
        }), children);
    }));
});
$20472afd0f14757f$var$Modal.Body = (0, $62fb641ff65d4c80$export$2e2bcd8739ae039);
$20472afd0f14757f$var$Modal.Header = (0, $23a7da312d57872f$export$2e2bcd8739ae039);
$20472afd0f14757f$var$Modal.Title = (0, $bfc3be9e8cf0bb31$export$2e2bcd8739ae039);
$20472afd0f14757f$var$Modal.Footer = (0, $0fb379426af41604$export$2e2bcd8739ae039);
$20472afd0f14757f$var$Modal.Dialog = (0, $db380399fa5395f6$export$2e2bcd8739ae039);
$20472afd0f14757f$var$Modal.displayName = 'Modal';
$20472afd0f14757f$var$Modal.propTypes = (0, $8nd05.default)({}, (0, $ed5e59ba008bd55e$export$cd730fbd5580a801), {
    animation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    animationTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dialogClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, $f87e1e1511bf033c$export$2e2bcd8739ae039)($20472afd0f14757f$var$modalSizes),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    dialogStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    dialogAs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    full: (0, $292baa45c8f6260a$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool, 'Use size="full" instead.'),
    overflow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
});
var $20472afd0f14757f$export$2e2bcd8739ae039 = $20472afd0f14757f$var$Modal;


'use client';
var $9a6d1502d000f566$export$2e2bcd8739ae039 = (0, $20472afd0f14757f$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
const $1be75d49f257bf03$var$AccordionContext = (0, $acw62.createContext)({
    accordionRef: null,
    items: {},
    setItems: (data)=>{},
    transition: null,
    alwaysOpen: false
});
const $1be75d49f257bf03$export$a766cd26d0d69044 = ({ children: children, as: as = "div", className: className = "", transition: transition, alwaysOpen: alwaysOpen = false })=>{
    const accordionRef = (0, $acw62.useRef)(null);
    const [items, setItems] = (0, $acw62.useState)({});
    const TagName = (0, $acw62.useMemo)(()=>{
        if (as) return as;
        return "div";
    }, [
        as
    ]);
    const value = (0, $acw62.useMemo)(()=>{
        return {
            accordionRef: accordionRef,
            items: items,
            setItems: setItems,
            transition: transition,
            alwaysOpen: alwaysOpen
        };
    }, [
        alwaysOpen,
        items,
        transition
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1be75d49f257bf03$var$AccordionContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        className: className
    }, children));
};
const $1be75d49f257bf03$var$AccordionItemContext = (0, $acw62.createContext)({
    accordionRef: null,
    active: false,
    items: {},
    hash: "",
    transition: null,
    alwaysOpen: false,
    toggle: ()=>{},
    isActive: false
});
const $1be75d49f257bf03$export$d99097c13d4dac9f = ({ children: children, isActive: isActive = false })=>{
    const { accordionRef: accordionRef, items: items, setItems: setItems, transition: transition, alwaysOpen: alwaysOpen } = (0, $acw62.useContext)($1be75d49f257bf03$var$AccordionContext);
    const [active, setActive] = (0, $acw62.useState)(false);
    const hash = (0, $acw62.useMemo)(()=>{
        return Math.random().toString(36).substring(2, 9);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!(hash in items)) setItems({
            ...items,
            [hash]: setActive
        });
    }, [
        items
    ]);
    const value = (0, $acw62.useMemo)(()=>{
        return {
            accordionRef: accordionRef,
            active: active,
            toggle: ()=>setActive(!active),
            items: items,
            hash: hash,
            transition: transition,
            alwaysOpen: alwaysOpen,
            isActive: isActive
        };
    }, [
        accordionRef,
        active,
        alwaysOpen,
        hash,
        isActive,
        items,
        transition
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($1be75d49f257bf03$var$AccordionItemContext.Provider, {
        value: value
    }, typeof children === "function" ? children({
        open: active
    }) : children);
};
const $1be75d49f257bf03$export$5e3e5deaaf81ee41 = ({ children: children, as: as = "button", className: className = "", href: href = "", onClick: onClick })=>{
    const { hash: hash, toggle: toggle, items: items, alwaysOpen: alwaysOpen, isActive: isActive } = (0, $acw62.useContext)($1be75d49f257bf03$var$AccordionItemContext);
    const ref = (0, $acw62.useRef)(null);
    const TagName = (0, $acw62.useMemo)(()=>{
        if (as) return as;
        return "button";
    }, [
        as
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isActive && ref && ref.current) {
            toggle();
            const button = ref.current;
            button.setAttribute("aria-expanded", "true");
            const content = document.querySelector(`#${button.getAttribute('aria-controls')}`);
            if (content) content.style.maxHeight = "none";
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        const toggleButton = (button)=>{
            let ariaExpanded = button.getAttribute('aria-expanded');
            button.setAttribute('aria-expanded', ariaExpanded === "false" ? "true" : "false");
        };
        const toggleContent = (content)=>{
            if (content) {
                const transitionEnd = ()=>{
                    if (content.style.maxHeight !== "0px") content.style.maxHeight = "none";
                    content.removeEventListener('transitionend', transitionEnd);
                };
                content.addEventListener('transitionend', transitionEnd);
                if (content.style.maxHeight === "0px") content.style.maxHeight = content.scrollHeight + "px";
                else {
                    content.style.maxHeight = content.scrollHeight + "px";
                    content.style.maxHeight = content.scrollHeight + "px";
                    content.style.maxHeight = "0px";
                }
            }
        };
        if (ref && ref.current) {
            const button = ref?.current;
            const showAccordion = (e)=>{
                // Pervent default
                if (TagName === "a") e.preventDefault();
                toggle();
                if (!alwaysOpen) {
                    // Close content already open
                    const buttons = button.parentNode?.querySelectorAll(`:scope > ${TagName}[aria-expanded='true']`);
                    if (buttons) buttons.forEach((item)=>{
                        if (item && item !== button) {
                            const id = item.id.split("-")[1];
                            items[id](false);
                            toggleButton(item);
                            const content = document.querySelector(`#${item.getAttribute('aria-controls')}`);
                            if (content) toggleContent(content);
                        }
                    });
                }
                // Toggle Button
                toggleButton(button);
                // Toggle Content
                const content = document.querySelector(`#${button.getAttribute('aria-controls')}`);
                toggleContent(content);
                if (onClick) onClick(e);
            };
            if (button) button.addEventListener('click', showAccordion);
            return ()=>{
                if (button) button.removeEventListener('click', showAccordion);
            };
        }
        return ()=>{};
    }, [
        TagName,
        alwaysOpen,
        items,
        onClick,
        toggle
    ]);
    if (TagName === "a") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ref: ref,
        id: `button-${hash}`,
        href: href,
        "aria-expanded": "false",
        className: className,
        "aria-controls": `content-${hash}`
    }, children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        ref: ref,
        id: `button-${hash}`,
        "aria-expanded": "false",
        className: className,
        "aria-controls": `content-${hash}`
    }, children);
};
const $1be75d49f257bf03$export$4f68206c92b94e7b = ({ children: children, as: as = "div", className: className = "" })=>{
    const { hash: hash, transition: transition } = (0, $acw62.useContext)($1be75d49f257bf03$var$AccordionItemContext);
    const TagName = (0, $acw62.useMemo)(()=>{
        if (as) return as;
        return "div";
    }, [
        as
    ]);
    const transitionData = (0, $acw62.useMemo)(()=>{
        const defaultData = {
            duration: "300ms",
            timingFunction: "cubic-bezier(0, 0, 0.2, 1)"
        };
        if (transition && "duration" in transition && transition.duration) defaultData.duration = transition.duration;
        if (transition && "timingFunction" in transition && transition.timingFunction) defaultData.timingFunction = transition.timingFunction;
        return defaultData;
    }, [
        transition
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, {
        id: `content-${hash}`,
        "aria-labelledby": `button-${hash}`,
        className: className,
        style: {
            maxHeight: "0px",
            transitionProperty: "max-height",
            overflow: "hidden",
            transitionDuration: transitionData.duration,
            transitionTimingFunction: transitionData.timingFunction
        }
    }, children);
};




function $e0a7c253e2df808f$export$2e2bcd8739ae039() {
    const fileAllocateAndUnAllocate = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "FILES_ACTIONS",
        initialState: {
            unallocatedFiles: [],
            deduperReports: {},
            fileManageSection: {},
            filesMoving: []
        },
        reducers: {
            SET_UNALLOCATE_FILES: (state, action)=>{
                state.unallocatedFiles = action.payload;
            },
            SET_DEDUPER_FILES: (state, action)=>{
                state.deduperReports = action.payload;
            },
            SET_FILES_MANAGE_SECTION: (state, action)=>{
                state.fileManageSection = action.payload;
            },
            SET_WARRANTY_DISCLOSURE_FILES: (state, action)=>{
                state.filesMoving = action.payload;
            }
        }
    });
    return fileAllocateAndUnAllocate.reducer;
}
const $e0a7c253e2df808f$export$7f5872b9f0fc6312 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ACTIONS/SET_UNALLOCATE_FILES");
const $e0a7c253e2df808f$export$607aedf5e5b112cd = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ACTIONS/SET_DEDUPER_FILES");
const $e0a7c253e2df808f$export$6d5d8bd59e3ba7ac = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ACTIONS/SET_FILES_MANAGE_SECTION");
const $e0a7c253e2df808f$export$4d2b8177182ba5a1 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("FILES_ACTIONS/SET_WARRANTY_DISCLOSURE_FILES");




const $a10507f36b291885$var$OpenRModalComponent = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { company: company, tab: tab, rModalData: rModalData, openRModal: openRModal, fileReport: fileReport } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { unallocatedFiles: unallocatedFiles, deduperReports: deduperReports } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.files);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [selectedQuestion, setSelectedQuestion] = (0, $acw62.useState)(null);
    const [forwardData, setForwardData] = (0, $acw62.useState)(null);
    const [curQno, setCurQno] = (0, $acw62.useState)(null);
    // Yield to OpenRModalComponentNew on the temp-module route (/company/)
    if (location.pathname.startsWith('/company/')) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const Chevron = ({ className: className = "" })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: className,
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                clipRule: "evenodd"
            })
        });
    };
    const handleClose = ()=>{
        setSelectedQuestion(null);
        setForwardData(null);
        setCurQno(null);
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(false));
    };
    const handleConfirm = ()=>{
        if (rModalData?.from && rModalData?.from === "fileReport" && rModalData?.actionType === "move") dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(forwardData));
        else if (rModalData?.from && rModalData?.from === "deduper") dispatch((0, $e0a7c253e2df808f$export$607aedf5e5b112cd)(forwardData));
        else if (rModalData?.from && rModalData?.from === "section") dispatch((0, $e0a7c253e2df808f$export$6d5d8bd59e3ba7ac)(forwardData));
        else dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(forwardData));
        handleClose();
    };
    const selectTargetSection = async (fileKey, qNo, name, from, index)=>{
        setSelectedQuestion(qNo);
        if (from && from === "fileReport" && rModalData?.actionType === "move") {
            setCurQno(fileReport.importResult[fileKey].section[0]);
            setForwardData({
                ...fileReport,
                importResult: {
                    ...fileReport.importResult,
                    [fileKey]: {
                        ...fileReport.importResult[fileKey],
                        section: [
                            qNo
                        ],
                        originalSection: [
                            qNo
                        ],
                        isModified: true
                    }
                }
            });
        }
        if (from && from === "unallocated" && rModalData?.actionType === "reallocate") setForwardData([
            ...unallocatedFiles
        ].reduce((acc, current, _index)=>{
            if (`${_index}` === `${rModalData.index}`) acc.push({
                ...current,
                sectionNo: qNo,
                name: name
            });
            else acc.push(current);
            return acc;
        }, []));
        if (from && from === "deduper") {
            const selectedDeuper = deduperReports && deduperReports.selectedDeuper && deduperReports.selectedDeuper.length ? [
                ...deduperReports.selectedDeuper
            ] : [];
            const modifiedDeduperResult = {
                ...deduperReports.deduperResult,
                [rModalData.key]: deduperReports.deduperResult[rModalData.key].flatMap((item, index)=>{
                    if (index === rModalData.index) {
                        selectedDeuper.push({
                            ...item,
                            curQno: item.qNo,
                            qNo: qNo,
                            isModified: true,
                            actionType: rModalData.actionType,
                            key: item.file.key,
                            index: rModalData.index
                        });
                        if (rModalData?.actionType === "move") return [
                            {
                                ...item,
                                qNo: qNo,
                                isModified: true,
                                name: name,
                                actionType: rModalData.actionType
                            }
                        ];
                        else return [
                            {
                                ...item
                            },
                            {
                                ...item,
                                qNo: qNo,
                                isModified: true,
                                name: name,
                                actionType: rModalData.actionType
                            }
                        ];
                    }
                    return item;
                })
            };
            setForwardData({
                ...deduperReports,
                deduperResult: modifiedDeduperResult,
                selectedDeuper: selectedDeuper
            });
        }
        if (from && from === "section") {
            const selectedFile = [
                ...rModalData.section.files
            ].filter((_f, _i)=>_i === rModalData.index);
            const sectionData = {
                ...rModalData.section,
                files: rModalData.actionType === "move" ? [
                    ...rModalData.section.files
                ].filter((_f, _i)=>_i !== rModalData.index) : qNo === (rModalData.section.qNo ?? rModalData.section.qNo) ? [
                    ...rModalData.section.files,
                    ...selectedFile
                ] : rModalData.section.files
            };
            setForwardData({
                sectionData: sectionData,
                selectFile: selectedFile,
                actionType: rModalData.actionType,
                qNo: qNo
            });
        }
    };
    const getSectionDropDown = (section, fileKey, from, index)=>{
        const qNo = section.sectionNo || section.no; // Section number
        const name = section.sectionName || section.name; // Section name
        if (section.subFolders && !qNo.includes(".") && selectedCompany['subscription'] && selectedCompany['subscription'] === "Pro") // Main section with dropdown (only for top-level sections)
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$d99097c13d4dac9f), {
            children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lightBorder mb0-5rem w100 jcsb cp ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1be75d49f257bf03$export$5e3e5deaaf81ee41), {
                            className: "df aic jcsb bg1 w100 dropdown-section-header px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    className: "c15 fw400 tal",
                                    children: [
                                        qNo,
                                        ". ",
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)(Chevron, {
                                    className: `w2rem h2rem c3 td300 ml0-5rem ${!open ? "tr90deg" : "tr270deg"}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$4f68206c92b94e7b), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: Object.keys(section.subFolders).map((key)=>{
                                    const subFolder = section.subFolders[key];
                                    return getSectionDropDown(subFolder, fileKey, from, index);
                                })
                            })
                        })
                    ]
                })
        }, qNo);
        else if (section.subFolders && selectedCompany['subscription'] && selectedCompany['subscription'] === "Pro") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    onClick: ()=>selectTargetSection(fileKey, qNo, name, from, index),
                    className: "rs-dropdown-item",
                    children: [
                        qNo,
                        ". ",
                        name
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        paddingLeft: '36px'
                    },
                    children: Object.keys(section.subFolders).map((key)=>{
                        const subFolder = section.subFolders[key];
                        return getSectionDropDown(subFolder, fileKey, from, index);
                    })
                })
            ]
        }, `subfolder-${qNo}`);
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `rs-dropdown-item ${selectedQuestion && qNo === selectedQuestion ? 'selected' : ''}`,
            onClick: ()=>selectTargetSection(fileKey, qNo, name, from, index),
            children: [
                qNo,
                ". ",
                name
            ]
        }, qNo);
    };
    const getModuleDropdown = (module, key, from, index)=>{
        if (module?.sections?.length == 1) {
            console.log("216");
            const singleSection = module?.sections[0];
            if (singleSection.subFolders) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: Object.values(singleSection.subFolders).map((section)=>{
                    return getSectionDropDown(section, key, from, index);
                })
            });
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: module?.sections && Object.values(module?.sections).map((section)=>{
                return getSectionDropDown(section, key, from, index);
            })
        });
    };
    if (company && company['modules'] && openRModal || selectedCompany && selectedCompany['modules'] && openRModal) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9a6d1502d000f566$export$2e2bcd8739ae039), {
            overflow: true,
            open: openRModal,
            onClose: handleClose,
            style: {
                zIndex: '2000'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9a6d1502d000f566$export$2e2bcd8739ae039).Header, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic jcfs",
                            children: [
                                "move",
                                "reallocate"
                            ].includes(rModalData.actionType) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("3CMpU")),
                                        alt: "moveFileIcon",
                                        style: {
                                            width: '40px',
                                            height: '40px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15 fw600 ml0-5rem fs20px",
                                        children: "reallocate" === rModalData.actionType ? "Reallocate File" : "Move File"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("4aBsx")),
                                        alt: "moveFileImg",
                                        style: {
                                            width: '40px',
                                            height: '40px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15 fw600 ml0-5rem fs20px",
                                        children: "Copy File"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c3",
                            children: rModalData.fileName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a6d1502d000f566$export$2e2bcd8739ae039).Body, {
                    style: {
                        maxHeight: "550px",
                        paddingRight: "16px"
                    },
                    className: "lightScrollbar",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$a766cd26d0d69044), {
                        children: (()=>{
                            let module = company?.modules[tab] ?? selectedCompany?.modules[tab];
                            if (module) module = JSON.parse(JSON.stringify(module));
                            return getModuleDropdown(module, rModalData.key, rModalData.from, rModalData.index);
                        })()
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        text: rModalData.actionType === "copy" ? "Copy File" : "Move File",
                        btnType: "warning",
                        onClick: handleConfirm,
                        customClassName: "mla mra c1",
                        disabled: selectedQuestion === null
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
};
var $a10507f36b291885$export$2e2bcd8739ae039 = $a10507f36b291885$var$OpenRModalComponent;


const $16250bd714b02a14$export$a7c5707626fc90f = "/";
const $16250bd714b02a14$export$635fd87e6c3d3ece = "/homepage";
const $16250bd714b02a14$export$eed606b4351295d7 = "/login";
const $16250bd714b02a14$export$51e82cdd7353a0e1 = "/register";
const $16250bd714b02a14$export$e479859894f5f058 = "/forgot-password";
const $16250bd714b02a14$export$5ac24c51d0564925 = "/about-us";
const $16250bd714b02a14$export$11038cc09fdccb91 = "/contact-us";
const $16250bd714b02a14$export$c99881788c0caafd = "/testPage";
const $16250bd714b02a14$export$5a1672aaaff636c9 = "/investment-ready-companies";
const $16250bd714b02a14$export$eec6248d2d9b1ed5 = "/growth-ready-companies";
const $16250bd714b02a14$export$a31271cda3788ac2 = "/exit-ready-companies";
const $16250bd714b02a14$export$aa02a5bce6b6bc60 = "/accountants";
const $16250bd714b02a14$export$96427145056c985f = "/lawyers";
const $16250bd714b02a14$export$c43fdfcb733f4e5d = "/angel-networks";
const $16250bd714b02a14$export$ba754712644f810e = "/angel-investors";
const $16250bd714b02a14$export$dbad77b037a0a446 = "/venture-capital-firms";
const $16250bd714b02a14$export$e92271f784cbfcf3 = "/private-equity-firms";
const $16250bd714b02a14$export$7dc602c5018e66b9 = "/terms";
const $16250bd714b02a14$export$a9826d71ea65c977 = "/policies";
const $16250bd714b02a14$export$893498aa7359709f = "/billings";
const $16250bd714b02a14$export$3623221f872af69b = "/billing/:id";
const $16250bd714b02a14$export$6bdd9dea0e57de2f = "/billing/:id/:subscription/:role";
const $16250bd714b02a14$export$d90f8d6beb6e3252 = "/payment-success";
const $16250bd714b02a14$export$d7b8dff6af31ceb7 = "/payment-cancel";
const $16250bd714b02a14$export$25d3d6b2b16f29ee = "/expansionpack/:id";
const $16250bd714b02a14$export$a3b74c08fbf97cc = "/directorspack/:id";
const $16250bd714b02a14$export$dd6eb49e7cb5a5c0 = "/industrypack/:id";
const $16250bd714b02a14$export$17214b626e4a2996 = "/esgpack/:id";
const $16250bd714b02a14$export$a4cdcf96e9da6a11 = "/expansionreferencing";
const $16250bd714b02a14$export$240514314008da16 = "/company/:id"; // company ID
const $16250bd714b02a14$export$c1df9e7d4593f04c = "/company-old/:id"; // company ID
const $16250bd714b02a14$export$1b4f59059fb09cf3 = "/company/company-settings/:id"; // company ID
const $16250bd714b02a14$export$ad1b5946f5a165f = "/shareCode/:code/diligence-pack/:id";
const $16250bd714b02a14$export$4695c1a423ffe431 = "/dashboard";
const $16250bd714b02a14$export$fa573b5b2799a94a = "/advisor-dashboard";
const $16250bd714b02a14$export$c45d6aa39a7ae97c = "/investor-dashboard";
const $16250bd714b02a14$export$361fa494492daab9 = "/deal-management"; // Deal Management module (investor deal-flow toolset)
const $16250bd714b02a14$export$2b9b886dddb4ba32 = "/group"; // group ID
const $16250bd714b02a14$export$91c3232a793620f2 = "/profile";
const $16250bd714b02a14$export$5c5adc4f183023d2 = "/advisor-setting";
const $16250bd714b02a14$export$fec5a8397856135d = "/investor-setting";
const $16250bd714b02a14$export$e3d31417f21c1ce7 = "/report/:type/:id";
const $16250bd714b02a14$export$b2e11634d600f33e = "/support";
const $16250bd714b02a14$export$df7a117e66af0ef0 = "/admin";
const $16250bd714b02a14$export$56757f5d81f3b065 = "/admin/company/:id";
const $16250bd714b02a14$export$88e43bd5bf664bb = "/confirmEmailChange/:userId";
const $16250bd714b02a14$export$babdbb7ea7999cc6 = '/landing-page';
const $16250bd714b02a14$export$9c09018d5bb1154 = `${$16250bd714b02a14$export$babdbb7ea7999cc6}-fractional`;
const $16250bd714b02a14$export$7d34e7fbe54f4a80 = $16250bd714b02a14$export$babdbb7ea7999cc6;
const $16250bd714b02a14$export$5d923b12188e7414 = `${$16250bd714b02a14$export$babdbb7ea7999cc6}-accountants`;
const $16250bd714b02a14$export$20de159c79d2d5f2 = `${$16250bd714b02a14$export$babdbb7ea7999cc6}-pisces`;
const $16250bd714b02a14$export$2c56bebcf5dc2850 = `${$16250bd714b02a14$export$babdbb7ea7999cc6}-vcs`;
const $16250bd714b02a14$export$fa0d235fc547c669 = `${$16250bd714b02a14$export$babdbb7ea7999cc6}-pes`;
const $16250bd714b02a14$export$9eeeba16e1010f7f = `${$16250bd714b02a14$export$babdbb7ea7999cc6}-angel-networks`;
const $16250bd714b02a14$export$5236f07d836cb2a7 = `${$16250bd714b02a14$export$babdbb7ea7999cc6}-angels`;
const $16250bd714b02a14$export$575c5f34c66beb48 = `/climb`;
const $16250bd714b02a14$export$4cb4d3804cb0d2a2 = `/climb26`;
const $16250bd714b02a14$export$da8ab89231422547 = '/terms-conditions';
const $16250bd714b02a14$export$f43de61a26b1e3d1 = $16250bd714b02a14$export$da8ab89231422547;
const $16250bd714b02a14$export$8b41d37ee61ee20f = `${$16250bd714b02a14$export$da8ab89231422547}-acceptable-use`;
const $16250bd714b02a14$export$c221831e2ad64aae = `${$16250bd714b02a14$export$da8ab89231422547}-individuals-terms`;
const $16250bd714b02a14$export$3dad34f770fcb308 = '/about-us';
const $16250bd714b02a14$export$bcdbe1127ca0dc8c = '/pricing-plans';
const $16250bd714b02a14$export$f8b031824e68df83 = "/contact-us";
const $16250bd714b02a14$export$d37021401d41152 = "/partner-program";
const $16250bd714b02a14$export$8bb39b3eb744faa7 = '/community';
const $16250bd714b02a14$export$6e733a82d8c11460 = '/accelerator';
const $16250bd714b02a14$export$ce939e14da856e20 = '/resources';
const $16250bd714b02a14$export$2aac1f04473d9900 = '/resource/:slug';
const $16250bd714b02a14$export$6cf9ff2729b042bd = '/policy';
const $16250bd714b02a14$export$79ffb24037556cb1 = $16250bd714b02a14$export$6cf9ff2729b042bd;
const $16250bd714b02a14$export$21297016b65d8d06 = `${$16250bd714b02a14$export$6cf9ff2729b042bd}-dmca`;
const $16250bd714b02a14$export$e1ec66dfdd97ff54 = `${$16250bd714b02a14$export$6cf9ff2729b042bd}-privacy`;
const $16250bd714b02a14$export$721554a0ca024204 = `${$16250bd714b02a14$export$6cf9ff2729b042bd}-data-ethics`;
const $16250bd714b02a14$export$7cbd13c49e6bb251 = `${$16250bd714b02a14$export$6cf9ff2729b042bd}-all-use`;
const $16250bd714b02a14$export$db9cf68015d1273f = '/demoChecklist';
const $16250bd714b02a14$export$ff5ab0b53eba7ce1 = '/createChecklist';
const $16250bd714b02a14$export$8491d203699f4c89 = '/partnerChecklist/:id';
const $16250bd714b02a14$export$d0d710be9382ff47 = '/researchAid/:id';
const $16250bd714b02a14$export$c4819cf47a4ac914 = '/advisor-researchAid';
const $16250bd714b02a14$export$cb692c4d9fd12540 = '/investor-researchAid';
const $16250bd714b02a14$export$6cb6d7e1fbb020d5 = '/manualAdd';
const $16250bd714b02a14$export$e2f78a34a24c9f45 = '/superFlow/:id';
const $16250bd714b02a14$export$41835e10bef063e6 = '/investorMatchStats';
const $16250bd714b02a14$export$a97ee4ebdc82a34c = '/completeInvestment/:id';
const $16250bd714b02a14$export$f6a76601f46caf3c = '/investment-ready';
const $16250bd714b02a14$export$fa9c0935e7d8e746 = '/growth-ready';
const $16250bd714b02a14$export$91d019707a9c3d97 = '/exit-ready';
const $16250bd714b02a14$export$77c1af69987805fb = '/advisorToken/:hash';
const $16250bd714b02a14$export$3ef311402a6d1da9 = '/morsebridge';
const $16250bd714b02a14$export$37575e7e3c62bf69 = '/certifii/company';
const $16250bd714b02a14$export$bd37f69dd4d7c31e = '/certifii/advisor';
const $16250bd714b02a14$export$e571b1dcb5172d6f = '/certifii/investor';
const $16250bd714b02a14$export$f8d8776d8b70eb77 = '/vaultinum/company';
const $16250bd714b02a14$export$d8a91f63c9f7c142 = '/vaultinum/advisor';
const $16250bd714b02a14$export$8f15a807ba2937ff = '/vaultinum/investor';
const $16250bd714b02a14$export$1473cb2f5aa9c69d = '/top-ten-transaction-mistakes';
const $16250bd714b02a14$export$71ef1e7f4bfe9c77 = [
    $16250bd714b02a14$export$3ef311402a6d1da9,
    $16250bd714b02a14$export$37575e7e3c62bf69,
    $16250bd714b02a14$export$bd37f69dd4d7c31e,
    $16250bd714b02a14$export$e571b1dcb5172d6f,
    $16250bd714b02a14$export$f8d8776d8b70eb77,
    $16250bd714b02a14$export$d8a91f63c9f7c142,
    $16250bd714b02a14$export$8f15a807ba2937ff,
    $16250bd714b02a14$export$1473cb2f5aa9c69d
];
const $16250bd714b02a14$export$68d31c12ec503eb8 = [
    $16250bd714b02a14$export$eed606b4351295d7,
    $16250bd714b02a14$export$51e82cdd7353a0e1,
    $16250bd714b02a14$export$e479859894f5f058,
    $16250bd714b02a14$export$c99881788c0caafd,
    $16250bd714b02a14$export$ff5ab0b53eba7ce1,
    $16250bd714b02a14$export$db9cf68015d1273f,
    $16250bd714b02a14$export$8491d203699f4c89,
    $16250bd714b02a14$export$d0d710be9382ff47,
    $16250bd714b02a14$export$c4819cf47a4ac914,
    $16250bd714b02a14$export$cb692c4d9fd12540,
    $16250bd714b02a14$export$e2f78a34a24c9f45,
    $16250bd714b02a14$export$a97ee4ebdc82a34c,
    $16250bd714b02a14$export$6cb6d7e1fbb020d5,
    $16250bd714b02a14$export$41835e10bef063e6,
    $16250bd714b02a14$export$ad1b5946f5a165f
];
const $16250bd714b02a14$export$95d9d456783cd0b0 = [
    $16250bd714b02a14$export$4695c1a423ffe431,
    $16250bd714b02a14$export$fa573b5b2799a94a,
    $16250bd714b02a14$export$91c3232a793620f2,
    $16250bd714b02a14$export$e3d31417f21c1ce7,
    $16250bd714b02a14$export$893498aa7359709f,
    $16250bd714b02a14$export$3623221f872af69b,
    $16250bd714b02a14$export$25d3d6b2b16f29ee,
    $16250bd714b02a14$export$a3b74c08fbf97cc,
    $16250bd714b02a14$export$dd6eb49e7cb5a5c0,
    $16250bd714b02a14$export$17214b626e4a2996,
    $16250bd714b02a14$export$b2e11634d600f33e,
    $16250bd714b02a14$export$240514314008da16,
    $16250bd714b02a14$export$2b9b886dddb4ba32,
    $16250bd714b02a14$export$df7a117e66af0ef0,
    $16250bd714b02a14$export$c45d6aa39a7ae97c,
    $16250bd714b02a14$export$5c5adc4f183023d2,
    $16250bd714b02a14$export$fec5a8397856135d,
    $16250bd714b02a14$export$56757f5d81f3b065,
    $16250bd714b02a14$export$c1df9e7d4593f04c,
    $16250bd714b02a14$export$361fa494492daab9
];



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $90764116263f3afd$var$ProgressBar = ({ isFireWork: isFireWork })=>{
    const [progress, setProgress] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        setProgress(90);
        if (isFireWork) setProgress(100);
    }, [
        isFireWork
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "progressBarCustom",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "progress-value",
            style: {
                width: `${progress}%`,
                transition: `${isFireWork ? 'width 0.5s ease-out' : 'width 3s ease-out'}`
            }
        })
    });
};
var $90764116263f3afd$export$2e2bcd8739ae039 = $90764116263f3afd$var$ProgressBar;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");
function $414753394dff993c$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}



'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $0c8dae23e679323d$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $acw62.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $0c8dae23e679323d$var$maybeReactUseSyncExternalStore = $acw62.useSyncExternalStore;
function $0c8dae23e679323d$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $acw62.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $acw62.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $0c8dae23e679323d$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $0c8dae23e679323d$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $3c4de721067b1c27$export$2e2bcd8739ae039)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $414753394dff993c$export$2e2bcd8739ae039)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $0c8dae23e679323d$var$maybeReactUseSyncExternalStore !== undefined ? $0c8dae23e679323d$var$useMediaQueryNew : $0c8dae23e679323d$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}




'use client';
function $568aba12ccdf91ea$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $414753394dff993c$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $48eb684ebe9272b4$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $568aba12ccdf91ea$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $jR9F1.default,
        themeId: (0, $4jPsi.default)
    });
}




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $c9Z8w = parcelRequire("c9Z8w");
const $d29eef8283105e84$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
]);
var $d29eef8283105e84$export$2e2bcd8739ae039 = $d29eef8283105e84$var$refType;



var $1En50 = parcelRequire("1En50");
const $edf89d3e5f97447f$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $edf89d3e5f97447f$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $095e4de7afe66795$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    mergedDate = utils.setMilliseconds(mergedDate, utils.getMilliseconds(timeParam));
    return mergedDate;
};
const $095e4de7afe66795$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = $095e4de7afe66795$export$a98b123b8f29e004(utils, utils.date(undefined, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $095e4de7afe66795$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $095e4de7afe66795$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $095e4de7afe66795$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $095e4de7afe66795$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $095e4de7afe66795$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === 'date' ? utils.startOfDay(utils.date(undefined, timezone)) : utils.date(undefined, timezone);
const $095e4de7afe66795$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === 'am' ? 2 : 14);
    return utils.format(date, 'meridiem');
};
const $095e4de7afe66795$var$dateViews = [
    'year',
    'month',
    'day'
];
const $095e4de7afe66795$export$b32dfef9f07dea64 = (view)=>$095e4de7afe66795$var$dateViews.includes(view);
const $095e4de7afe66795$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $095e4de7afe66795$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};



const $9359fccca2daa962$var$timeViews = [
    'hours',
    'minutes',
    'seconds'
];
const $9359fccca2daa962$export$8f04d380cefd5a0d = (view)=>$9359fccca2daa962$var$timeViews.includes(view);
const $9359fccca2daa962$export$a3328136ac50623d = (view)=>$9359fccca2daa962$var$timeViews.includes(view) || view === 'meridiem';
const $9359fccca2daa962$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $9359fccca2daa962$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $9359fccca2daa962$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $9359fccca2daa962$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $9359fccca2daa962$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $9359fccca2daa962$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $9359fccca2daa962$export$888a1ce13aa61986(dateLeft, utils) > $9359fccca2daa962$export$888a1ce13aa61986(dateRight, utils);
    };
const $9359fccca2daa962$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $edf89d3e5f97447f$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $c4f6f2b8fcbb5fe9$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>$c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac[section.type] ?? 1));
const $c4f6f2b8fcbb5fe9$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $c4f6f2b8fcbb5fe9$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $c4f6f2b8fcbb5fe9$var$roundDate(utils, granularity, (0, $095e4de7afe66795$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $9359fccca2daa962$export$fb87c80b35a46b89)(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $095e4de7afe66795$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $c4f6f2b8fcbb5fe9$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $095e4de7afe66795$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



const $f652bdb72e319cb0$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $f652bdb72e319cb0$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
};
const $f652bdb72e319cb0$export$c65c7173f879039f = (utils, format)=>{
    const elements = [];
    const now = utils.date(undefined, 'default');
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $f652bdb72e319cb0$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $095e4de7afe66795$export$62591b96a734eacd)(utils, utils.date(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case 'weekDay':
            return $f652bdb72e319cb0$export$c65c7173f879039f(utils, format);
        case 'meridiem':
            {
                const now = utils.date(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $f652bdb72e319cb0$export$b918512475916205 = 's';
const $f652bdb72e319cb0$var$NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const $f652bdb72e319cb0$export$b42be9ae7016ef5d = (utils)=>{
    const today = utils.date(undefined);
    const formattedZero = utils.formatByString(utils.setSeconds(today, 0), $f652bdb72e319cb0$export$b918512475916205);
    if (formattedZero === '0') return $f652bdb72e319cb0$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>utils.formatByString(utils.setSeconds(today, index), $f652bdb72e319cb0$export$b918512475916205));
};
const $f652bdb72e319cb0$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
const $f652bdb72e319cb0$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
const $f652bdb72e319cb0$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $f652bdb72e319cb0$export$7dd321105a319e8(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
const $f652bdb72e319cb0$export$713c6d756c12fc27 = (valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $f652bdb72e319cb0$export$ef88db4bceade9fd = (utils, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $f652bdb72e319cb0$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $f652bdb72e319cb0$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $f652bdb72e319cb0$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes)=>{
    const delta = $f652bdb72e319cb0$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$f652bdb72e319cb0$export$ef88db4bceade9fd(utils, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt($f652bdb72e319cb0$export$7dd321105a319e8(section.value, localizedDigits), 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return utils.formatByString(utils.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $f652bdb72e319cb0$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
};
const $f652bdb72e319cb0$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($f652bdb72e319cb0$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $f652bdb72e319cb0$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $f652bdb72e319cb0$var$isFourDigitYearFormat = (utils, format)=>utils.formatByString(utils.date(undefined, 'system'), format).length === 4;
const $f652bdb72e319cb0$export$78b5830e2dd2de49 = (utils, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = utils.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            {
                if ($f652bdb72e319cb0$var$isFourDigitYearFormat(utils, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === '0001';
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === '01';
            }
        case 'month':
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case 'day':
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case 'hours':
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case 'minutes':
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $f652bdb72e319cb0$export$b0c1bfd065bfe742 = (utils, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($f652bdb72e319cb0$export$85daa91f6c6e875f(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $f652bdb72e319cb0$export$9e6af343db7dd2 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
const $f652bdb72e319cb0$export$7ffdf006c6dc825f = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $f652bdb72e319cb0$export$85daa91f6c6e875f(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $f652bdb72e319cb0$export$360600f456ea7d5f = (utils, localizedDigits, timezone)=>{
    const today = utils.date(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $095e4de7afe66795$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $f652bdb72e319cb0$var$isFourDigitYearFormat(utils, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $f652bdb72e319cb0$export$c65c7173f879039f(utils, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = $f652bdb72e319cb0$export$7dd321105a319e8(utils.formatByString(utils.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($f652bdb72e319cb0$export$7dd321105a319e8(utils.formatByString(utils.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $f652bdb72e319cb0$var$warnedOnceInvalidSection = false;
const $f652bdb72e319cb0$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $f652bdb72e319cb0$var$transferDateSectionValue = (utils, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case 'month':
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                const formattedDaysInWeek = $f652bdb72e319cb0$export$c65c7173f879039f(utils, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case 'minutes':
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case 'seconds':
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $f652bdb72e319cb0$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $f652bdb72e319cb0$export$6c6df982c77f60a9 = (utils, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$f652bdb72e319cb0$var$reliableSectionModificationOrder[a.type] - $f652bdb72e319cb0$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $f652bdb72e319cb0$var$transferDateSectionValue(utils, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $f652bdb72e319cb0$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().includes('android');
const $f652bdb72e319cb0$export$7725fd6fe0a2aadf = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const $f652bdb72e319cb0$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};
const $f652bdb72e319cb0$export$b5e30842500b6cab = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), 'month');
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            return section.contentType === 'digit' ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), 'dayOfMonthFull') : section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
};
const $f652bdb72e319cb0$export$b46fd324c5adcf31 = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
                if (parsedDate) return utils.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
};


const $14acbf5609fff29c$var$_excluded = [
    "value",
    "referenceDate"
];
const $14acbf5609fff29c$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $095e4de7afe66795$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $1En50.default)(_ref, $14acbf5609fff29c$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $c4f6f2b8fcbb5fe9$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $095e4de7afe66795$export$36ca889e039badd5),
    areValuesEqual: (0, $095e4de7afe66795$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $14acbf5609fff29c$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return getSectionsFromDate(date);
    },
    getV7HiddenInputValueFromSections: (0, $f652bdb72e319cb0$export$9e6af343db7dd2),
    getV6InputValueFromSections: (0, $f652bdb72e319cb0$export$7ffdf006c6dc825f),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fa5abcb204c6ca4b$var$_excluded = [
    "localeText"
];
const $fa5abcb204c6ca4b$export$544976378534cf9 = /*#__PURE__*/ $acw62.createContext(null);
const $fa5abcb204c6ca4b$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $1En50.default)(inProps, $fa5abcb204c6ca4b$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = $acw62.useContext($fa5abcb204c6ca4b$export$544976378534cf9) ?? {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $acw62.useMemo(()=>(0, $8nd05.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $acw62.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $acw62.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $acw62.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fa5abcb204c6ca4b$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



var $8nd05 = parcelRequire("8nd05");
const $c07a80e9c07fbe5a$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $8nd05.default)({}, pickersTranslations)
                }
            }
        }
    };
};
const $c07a80e9c07fbe5a$export$7eae96bf9dd7ca56 = (params)=>{
    const { utils: utils, formatKey: formatKey, contextTranslation: contextTranslation, propsTranslation: propsTranslation } = params;
    return (value)=>{
        const formattedValue = value !== null && utils.isValid(value) ? utils.format(value, formatKey) : null;
        const translation = propsTranslation ?? contextTranslation;
        return translation(value, utils, formattedValue);
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $ae54a135ca8b48bd$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, utils, formattedTime)=>`Select ${view}. ${!formattedTime && (time === null || !utils.isValid(time)) ? 'No time selected' : `Selected time is ${formattedTime ?? utils.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils, formattedDate)=>formattedDate || value !== null && utils.isValid(value) ? `Choose date, selected date is ${formattedDate ?? utils.format(value, 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (value, utils, formattedTime)=>formattedTime || value !== null && utils.isValid(value) ? `Choose time, selected time is ${formattedTime ?? utils.format(value, 'fullTime')}` : 'Choose time',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const $ae54a135ca8b48bd$export$1af4c7e47ad72f44 = $ae54a135ca8b48bd$var$enUSPickers;
const $ae54a135ca8b48bd$export$137380d9ce54f7f = (0, $c07a80e9c07fbe5a$export$67c96d35a1b010b3)($ae54a135ca8b48bd$var$enUSPickers);


const $28cc3a450bd9076f$export$4b5a24245de9f7f9 = ()=>{
    const localization = $acw62.useContext((0, $fa5abcb204c6ca4b$export$544976378534cf9));
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.utils === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $acw62.useMemo(()=>(0, $8nd05.default)({}, (0, $ae54a135ca8b48bd$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $acw62.useMemo(()=>(0, $8nd05.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $28cc3a450bd9076f$export$1163b47e39508a46 = ()=>$28cc3a450bd9076f$export$4b5a24245de9f7f9().utils;
const $28cc3a450bd9076f$export$7c38da3a2e90fa83 = ()=>$28cc3a450bd9076f$export$4b5a24245de9f7f9().defaultDates;
const $28cc3a450bd9076f$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $28cc3a450bd9076f$export$1163b47e39508a46();
    const now = $acw62.useRef(undefined);
    if (now.current === undefined) now.current = utils.date(undefined, timezone);
    return now.current;
};





var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");



var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $d4c96c197d3f31f2$export$b109c489973c3d80(slot) {
    return (0, $4Cod0.default)('MuiPickersToolbar', slot);
}
const $d4c96c197d3f31f2$export$59f09e5e2b3d9913 = (0, $beCSm.default)('MuiPickersToolbar', [
    'root',
    'content'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $16febb16e5b74478$var$_excluded = [
    "children",
    "className",
    "toolbarTitle",
    "hidden",
    "titleId",
    "isLandscape",
    "classes",
    "landscapeDirection"
];
const $16febb16e5b74478$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d4c96c197d3f31f2$export$b109c489973c3d80), classes);
};
const $16febb16e5b74478$var$PickersToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const $16febb16e5b74478$var$PickersToolbarContent = (0, $d8seH.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                isLandscape: true,
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const $16febb16e5b74478$export$eb3c4d84783d6feb = /*#__PURE__*/ $acw62.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props, other = (0, $1En50.default)(props, $16febb16e5b74478$var$_excluded);
    const ownerState = props;
    const classes = $16febb16e5b74478$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($16febb16e5b74478$var$PickersToolbarRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($16febb16e5b74478$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});



'use client';
const $b25b9764519b3af1$export$3cdcc56057891b44 = ()=>(0, $28cc3a450bd9076f$export$4b5a24245de9f7f9)().localeText;




var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $12fed230fa62a38e$export$a1c3879af2c3b694(slot) {
    return (0, $4Cod0.default)('MuiDatePickerToolbar', slot);
}
const $12fed230fa62a38e$export$2e35fa7d24ef4179 = (0, $beCSm.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ab147feda772f70e$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "className",
    "onViewChange",
    "view"
];
const $ab147feda772f70e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $12fed230fa62a38e$export$a1c3879af2c3b694), classes);
};
const $ab147feda772f70e$var$DatePickerToolbarRoot = (0, $d8seH.default)((0, $16febb16e5b74478$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $ab147feda772f70e$var$DatePickerToolbarTitle = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})({
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
const $ab147feda772f70e$export$21b7f8ea763109eb = /*#__PURE__*/ $acw62.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, className: className } = props, other = (0, $1En50.default)(props, $ab147feda772f70e$var$_excluded);
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const classes = $ab147feda772f70e$var$useUtilityClasses(props);
    const dateText = $acw62.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $095e4de7afe66795$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab147feda772f70e$var$DatePickerToolbarRoot, (0, $8nd05.default)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ab147feda772f70e$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});


function $cff128f6b922ac60$export$a552c17ed3587731(props, name) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const defaultDates = (0, $28cc3a450bd9076f$export$7c38da3a2e90fa83)();
    const themeProps = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const localeText = $acw62.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $8nd05.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $8nd05.default)({}, themeProps, {
        localeText: localeText
    }, (0, $edf89d3e5f97447f$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $8nd05.default)({
            toolbar: (0, $ab147feda772f70e$export$21b7f8ea763109eb)
        }, themeProps.slots)
    });
}




const $4be2a81b5d2111e4$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $4be2a81b5d2111e4$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $4be2a81b5d2111e4$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $4be2a81b5d2111e4$var$VALIDATION_PROP_NAMES = [
    ...$4be2a81b5d2111e4$export$430d9fc64cf058d6,
    ...$4be2a81b5d2111e4$export$fd5e0f8b4115a8c7,
    ...$4be2a81b5d2111e4$export$1df62d3ba2121371
];
const $4be2a81b5d2111e4$export$5890f750904acddb = (props)=>$4be2a81b5d2111e4$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});



const $8fe304ca4ba155e2$export$ffb3d0046ef3a2 = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.utils.date(undefined, timezone);
    const minDate = (0, $095e4de7afe66795$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $095e4de7afe66795$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
$8fe304ca4ba155e2$export$ffb3d0046ef3a2.valueManager = (0, $14acbf5609fff29c$export$2764b246aa3b75ba);



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");




var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;



var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f3e589c60baacdec$export$4b135a4b3a6c4550), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $f3e589c60baacdec$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $1En50.default)(props, $d0c64ff513a9933f$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8426ae8303951a73$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71c322247f7fbf93$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e40d2047b7c1e09d$export$5e8702d71474f093), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $8nd05.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $8nd05.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $8nd05.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $e40d2047b7c1e09d$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $1En50.default)(props, $71c322247f7fbf93$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;





var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");





var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
var $859006c2756f1ae2$exports = {};
"use strict";
'use client';
Object.defineProperty($859006c2756f1ae2$exports, "__esModule", {
    value: true
});
$859006c2756f1ae2$exports.default = void 0;

var $859006c2756f1ae2$var$React = $859006c2756f1ae2$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");
function $859006c2756f1ae2$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($859006c2756f1ae2$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $859006c2756f1ae2$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $859006c2756f1ae2$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $859006c2756f1ae2$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $859006c2756f1ae2$var$useTheme(defaultTheme = null) {
    const contextTheme = $859006c2756f1ae2$var$React.useContext($eP9YU.T);
    return !contextTheme || $859006c2756f1ae2$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $859006c2756f1ae2$var$_default = $859006c2756f1ae2$exports.default = $859006c2756f1ae2$var$useTheme;






var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $8Indx = parcelRequire("8Indx");



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5a1e9a841ed0d0fc$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $5a1e9a841ed0d0fc$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded);
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $8nd05.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $5a1e9a841ed0d0fc$var$_excluded2);
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2117883cc21a32b2$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, (0, $8nd05.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $8nd05.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a4669aa090d445bd$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $5a1e9a841ed0d0fc$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($859006c2756f1ae2$exports)))();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $a4669aa090d445bd$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $8nd05.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, (0, $8nd05.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;




var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $adc96af8448e5610$export$5519b4d4bf80ce6f(slot) {
    return (0, $4Cod0.default)('MuiPickersPopper', slot);
}
const $adc96af8448e5610$export$46e9184c9b1af0ce = (0, $beCSm.default)('MuiPickersPopper', [
    'root',
    'paper'
]);


/* Use it instead of .includes method for IE support */ function $f4ceb023c3ba7bf1$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $f4ceb023c3ba7bf1$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $f4ceb023c3ba7bf1$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $f4ceb023c3ba7bf1$export$4165ccf43f4d7767 = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($f4ceb023c3ba7bf1$export$cd4e5573fbe2b576(document));
};
const $f4ceb023c3ba7bf1$export$9ae5b19305db48ce = '@media (pointer: fine)';



const $e6d9e0a2a52efb89$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $e6d9e0a2a52efb89$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $e6d9e0a2a52efb89$var$androidVersion = $e6d9e0a2a52efb89$var$mobileVersionMatches && $e6d9e0a2a52efb89$var$mobileVersionMatches[1] ? parseInt($e6d9e0a2a52efb89$var$mobileVersionMatches[1], 10) : null;
const $e6d9e0a2a52efb89$var$iOSVersion = $e6d9e0a2a52efb89$var$mobileVersionMatches && $e6d9e0a2a52efb89$var$mobileVersionMatches[2] ? parseInt($e6d9e0a2a52efb89$var$mobileVersionMatches[2], 10) : null;
const $e6d9e0a2a52efb89$export$7e3b2a595fb375e5 = $e6d9e0a2a52efb89$var$androidVersion && $e6d9e0a2a52efb89$var$androidVersion < 10 || $e6d9e0a2a52efb89$var$iOSVersion && $e6d9e0a2a52efb89$var$iOSVersion < 13 || false;
const $e6d9e0a2a52efb89$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $0c8dae23e679323d$export$2e2bcd8739ae039)($e6d9e0a2a52efb89$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $e6d9e0a2a52efb89$export$7e3b2a595fb375e5;
};



var $ayMG0 = parcelRequire("ayMG0");
const $9e9d2dd7e32b7308$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $9e9d2dd7e32b7308$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $adc96af8448e5610$export$5519b4d4bf80ce6f), classes);
};
const $9e9d2dd7e32b7308$var$PickersPopperRoot = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $9e9d2dd7e32b7308$var$PickersPopperPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiPickersPopper',
    slot: 'Paper',
    overridesResolver: (_, styles)=>styles.paper
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ placement: placement })=>[
                    'top',
                    'top-start',
                    'top-end'
                ].includes(placement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function $9e9d2dd7e32b7308$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $9e9d2dd7e32b7308$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $9e9d2dd7e32b7308$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $acw62.useEffect(()=>{
        if (active) {
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $acw62.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $9e9d2dd7e32b7308$var$PickersPopperPaperWrapper = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $1En50.default)(props, $9e9d2dd7e32b7308$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(PaperComponent, (0, $8nd05.default)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $9e9d2dd7e32b7308$export$96ce8482474de8a5(inProps) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersPopper'
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $acw62.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') onDismiss();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (role === 'tooltip' || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $9e9d2dd7e32b7308$var$useClickAwayListener(open, onBlur ?? onDismiss);
    const paperRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $9e9d2dd7e32b7308$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $e6d9e0a2a52efb89$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations ?? defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039) : (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, $f30200a1e85b3f20$export$2e2bcd8739ae039);
    const Paper = slots?.desktopPaper ?? $9e9d2dd7e32b7308$var$PickersPopperPaper;
    const Popper = slots?.popper ?? $9e9d2dd7e32b7308$var$PickersPopperRoot;
    const popperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Popper, (0, $8nd05.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $ayMG0.jsx)(FocusTrap, (0, $8nd05.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === 'tooltip',
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Transition, (0, $8nd05.default)({}, TransitionProps, slotProps?.desktopTransition, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9e9d2dd7e32b7308$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $30c5bb4c5bc6ae14$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $acw62.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $acw62.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $acw62.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $acw62.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $acw62 = parcelRequire("acw62");


'use client';
function $01bcd2a693711309$export$87fe492f99f25a20(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $28cc3a450bd9076f$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $acw62.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $acw62.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}



var $acw62 = parcelRequire("acw62");



const $61302b639d1ef7ad$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, valueManager: valueManager })=>{
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const firstDefaultValue = $acw62.useRef(defaultValue);
    const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
    const inputTimezone = $acw62.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    let timezoneToRender;
    if (timezoneProp) timezoneToRender = timezoneProp;
    else if (inputTimezone) timezoneToRender = inputTimezone;
    else if (referenceDate) timezoneToRender = utils.getTimezone(referenceDate);
    else timezoneToRender = 'default';
    const valueWithTimezoneToRender = $acw62.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $61302b639d1ef7ad$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const onChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp?.(newValue, ...otherParams);
    });
    return $61302b639d1ef7ad$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $ac69f9306abec723$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === 'setValueFromField') return true;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState !== 'shallow') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === 'setValueFromShortcut') {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $ac69f9306abec723$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === 'setValueFromAction') {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            'accept',
            'today',
            'clear'
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromView' && action.selectionState === 'finish' && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept' && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $ac69f9306abec723$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === 'setValueFromAction') return true;
    if (action.name === 'setValueFromView') return action.selectionState === 'finish' && closeOnSelect;
    if (action.name === 'setValueFromShortcut') return action.changeImportance === 'accept';
    return false;
};
const $ac69f9306abec723$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValueWithoutRenderTimezone, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === 'desktop', timezone: timezoneProp, referenceDate: referenceDate } = props;
    const { current: defaultValue } = $acw62.useRef(inDefaultValue);
    const { current: isControlled } = $acw62.useRef(inValueWithoutRenderTimezone !== undefined);
    const [previousTimezoneProp, setPreviousTimezoneProp] = $acw62.useState(timezoneProp);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const adapter = (0, $28cc3a450bd9076f$export$4b5a24245de9f7f9)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $30c5bb4c5bc6ae14$export$7d3a09d5141ab1f4)(props);
    const { timezone: timezone, value: inValueWithTimezoneToRender, handleValueChange: handleValueChange } = (0, $61302b639d1ef7ad$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValueWithoutRenderTimezone,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
    const [dateState, setDateState] = $acw62.useState(()=>{
        let initialValue;
        if (inValueWithTimezoneToRender !== undefined) initialValue = inValueWithTimezoneToRender;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValueWithoutRenderTimezone,
            hasBeenModifiedSinceMount: false
        };
    });
    const timezoneFromDraftValue = valueManager.getTimezone(utils, dateState.draft);
    if (previousTimezoneProp !== timezoneProp) {
        setPreviousTimezoneProp(timezoneProp);
        if (timezoneProp && timezoneFromDraftValue && timezoneProp !== timezoneFromDraftValue) setDateState((prev)=>(0, $8nd05.default)({}, prev, {
                draft: valueManager.setTimezone(utils, timezoneProp, prev.draft)
            }));
    }
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $01bcd2a693711309$export$87fe492f99f25a20)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: dateState.draft,
        onError: props.onError
    });
    const updateDate = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $ac69f9306abec723$var$shouldPublishValue(updaterParams);
        const shouldCommit = $ac69f9306abec723$var$shouldCommitValue(updaterParams);
        const shouldClose = $ac69f9306abec723$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $8nd05.default)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                const validationError = action.name === 'setValueFromField' ? action.context.validationError : getValidationErrorForNewValue(action.value);
                cachedContext = {
                    validationError: validationError
                };
                if (action.name === 'setValueFromShortcut') cachedContext.shortcut = action.shortcut;
            }
            return cachedContext;
        };
        if (shouldPublish) handleValueChange(action.value, getContext());
        if (shouldCommit && onAccept) onAccept(action.value, getContext());
        if (shouldClose) setIsOpen(false);
    });
    if (dateState.lastControlledValue !== inValueWithoutRenderTimezone) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValueWithTimezoneToRender);
        setDateState((prev)=>(0, $8nd05.default)({}, prev, {
                lastControlledValue: inValueWithoutRenderTimezone
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValueWithTimezoneToRender,
                lastPublishedValue: inValueWithTimezoneToRender,
                draft: inValueWithTimezoneToRender,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: 'setValueFromAction',
            pickerAction: 'clear'
        });
    });
    const handleAccept = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'accept'
        });
    });
    const handleDismiss = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: 'setValueFromAction',
            pickerAction: 'dismiss'
        });
    });
    const handleCancel = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: 'setValueFromAction',
            pickerAction: 'cancel'
        });
    });
    const handleSetToday = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: 'setValueFromAction',
            pickerAction: 'today'
        });
    });
    const handleOpen = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        setIsOpen(true);
    });
    const handleClose = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        event?.preventDefault();
        setIsOpen(false);
    });
    const handleChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, selectionState = 'partial')=>updateDate({
            name: 'setValueFromView',
            value: newValue,
            selectionState: selectionState
        }));
    const handleSelectShortcut = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: 'setValueFromShortcut',
            value: newValue,
            changeImportance: changeImportance,
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: 'setValueFromField',
            value: newValue,
            context: context
        }));
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField
    };
    const viewValue = $acw62.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $8nd05.default)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    const contextValue = $acw62.useMemo(()=>({
            onOpen: handleOpen,
            onClose: handleClose,
            open: isOpen
        }), [
        isOpen,
        handleClose,
        handleOpen
    ]);
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions,
        contextValue: contextValue
    };
};



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


let $255f841782d21111$var$warnedOnceNotValidView = false;
function $255f841782d21111$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    const previousOpenTo = $acw62.useRef(openTo);
    const previousViews = $acw62.useRef(views);
    const defaultView = $acw62.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $acw62.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $acw62.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}



const $cd2755aca21a1bbe$var$_excluded = [
    "className",
    "sx"
];
const $cd2755aca21a1bbe$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const { onChange: onChange, open: open, onClose: onClose } = propsFromPickerValue;
    const { view: inView, views: views, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $1En50.default)(props, $cd2755aca21a1bbe$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $255f841782d21111$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $acw62.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (viewRenderers[viewForReduce] != null) viewMode = 'UI';
            else viewMode = 'field';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        viewRenderers,
        views
    ]);
    const timeViewsCount = $acw62.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $9359fccca2daa962$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>currentViewMode === 'UI');
    const [popperView, setPopperView] = $acw62.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === 'field' && open) {
            onClose();
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            const rendererProps = (0, $8nd05.default)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            });
            if (rendererInterceptor) return rendererInterceptor(viewRenderers, popperView, rendererProps);
            return renderer(rendererProps);
        }
    };
};



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value ?? false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;



var $acw62 = parcelRequire("acw62");


function $93daab4ee7e75ce0$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
const $93daab4ee7e75ce0$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $acw62.useState($93daab4ee7e75ce0$var$getOrientation);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($93daab4ee7e75ce0$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $f4ceb023c3ba7bf1$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
};


const $6f3c21605adb2d92$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $93daab4ee7e75ce0$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const layoutProps = (0, $8nd05.default)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        isRtl: isRtl,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};



var $acw62 = parcelRequire("acw62");
function $a20f01be389805b9$export$cfaabb8dcad411b(parameters) {
    const { props: props, pickerValueResponse: pickerValueResponse } = parameters;
    return $acw62.useMemo(()=>({
            value: pickerValueResponse.viewProps.value,
            open: pickerValueResponse.open,
            disabled: props.disabled ?? false,
            readOnly: props.readOnly ?? false
        }), [
        pickerValueResponse.viewProps.value,
        pickerValueResponse.open,
        props.disabled,
        props.readOnly
    ]);
}


const $72bb1f98949e4fd5$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const pickerValueResponse = (0, $ac69f9306abec723$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $cd2755aca21a1bbe$export$c0a71b697a2df210)({
        props: props,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        fieldRef: fieldRef,
        propsFromPickerValue: pickerValueResponse.viewProps,
        rendererInterceptor: rendererInterceptor
    });
    const pickerLayoutResponse = (0, $6f3c21605adb2d92$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    const pickerOwnerState = (0, $a20f01be389805b9$export$cfaabb8dcad411b)({
        props: props,
        pickerValueResponse: pickerValueResponse
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps,
        // Picker context
        contextValue: pickerValueResponse.contextValue,
        // Picker owner state
        ownerState: pickerOwnerState
    };
};



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $6c9b2087702d19e3$export$1671c31de798d429(slot) {
    return (0, $4Cod0.default)('MuiPickersLayout', slot);
}
const $6c9b2087702d19e3$export$7a6dac186703fe4c = (0, $beCSm.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);



var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");


var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a02bab8c70a697b$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $11f546081ba06ace$export$5a6f9035944c8119), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $4a02bab8c70a697b$var$commonIconStyles = (ownerState)=>(0, $8nd05.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $8nd05.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $8nd05.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: (0, $8nd05.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: (0, $8nd05.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $11f546081ba06ace$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $4a02bab8c70a697b$var$commonIconStyles(ownerState)));
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $8639dcef822d5d4c$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $25b1293270900846$export$2e2bcd8739ae039));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $4a02bab8c70a697b$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, (0, $8nd05.default)({
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $beCSm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $207bc6ab7c60f4b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3a31c1516a2c01e5$export$5e57a444791c63be), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $1En50.default)(props, $207bc6ab7c60f4b2$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d9db8f61ff28a432$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $d9db8f61ff28a432$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $1En50.default)(props, $d9db8f61ff28a432$var$_excluded);
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: translations.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $207bc6ab7c60f4b2$export$2e2bcd8739ae039), (0, $8nd05.default)({}, other, {
        children: buttons
    }));
}




var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $kTdcz = parcelRequire("kTdcz");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");






var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9924235485c5a222$var$_excluded = [
    "className"
];
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $558d665a4b71ad4c$export$ccdb26aeba48a86e), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $1En50.default)(props, $9924235485c5a222$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f92832698674c928$var$_excluded = [
    "className"
], $f92832698674c928$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b23cfd2067550897$export$5682c366c0c669d9), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $8nd05.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $a1fd72c2634274a8$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $b23cfd2067550897$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $1En50.default)(props.ContainerProps, $f92832698674c928$var$_excluded), other = (0, $1En50.default)(props, $f92832698674c928$var$_excluded2);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $90a633ad7a979daa$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $9QePP.default)((0, $b23cfd2067550897$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $4a35786d89db9dda$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, (0, $8nd05.default)({
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                        as: Component,
                        ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, (0, $8nd05.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
            ownerState: (0, $8nd05.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9924235485c5a222$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');





var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $47d4f79319086dc5$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $db0771a9e6a32b1d$export$31444911e4ee6fdd), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $8nd05.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: (0, $8nd05.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $8nd05.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: (0, $8nd05.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $kTdcz.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $kTdcz.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $db0771a9e6a32b1d$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $1En50.default)(props, $47d4f79319086dc5$var$_excluded);
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $4a35786d89db9dda$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $4a35786d89db9dda$export$2e2bcd8739ae039) ? (0, $8nd05.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62d1787512a69c15$export$2e2bcd8739ae039), {
        className: (0, $9QePP.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $9QePP.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;


const $6a907094a8780175$export$3f0060ce4cc8f4d0 = 36;
const $6a907094a8780175$export$dde58b009b497666 = 2;
const $6a907094a8780175$export$ee46b8a74d6c94d3 = 320;
const $6a907094a8780175$export$73724491020e90c7 = 280;
const $6a907094a8780175$export$f2fef360e2df0cb7 = 336;
const $6a907094a8780175$export$1c2eabda4acea0e4 = 232;
const $6a907094a8780175$export$a462ceb9cfdb5d71 = 48;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bc2c3fa74ca71715$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $bc2c3fa74ca71715$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $bc2c3fa74ca71715$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = 'accept', onChange: onChange, isValid: isValid } = props, other = (0, $1En50.default)(props, $bc2c3fa74ca71715$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $1En50.default)(_ref, $bc2c3fa74ca71715$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return (0, $8nd05.default)({}, item, {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $640cd381f5e8b3ea$export$2e2bcd8739ae039), (0, $8nd05.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $6a907094a8780175$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f92832698674c928$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), (0, $8nd05.default)({}, item))
            }, item.id ?? item.label);
        })
    }));
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $07a161bd56d089a9$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $07a161bd56d089a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6c9b2087702d19e3$export$1671c31de798d429), classes);
};
const $07a161bd56d089a9$var$usePickerLayout = (props)=>{
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, slots: slots, slotProps: slotProps } = props;
    const classes = $07a161bd56d089a9$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, $d9db8f61ff28a432$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === 'desktop' ? [] : [
                'cancel',
                'accept'
            ]
        },
        className: classes.actionBar,
        ownerState: (0, $8nd05.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $ayMG0.jsx)(ActionBar, (0, $8nd05.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly
        },
        className: classes.toolbar,
        ownerState: (0, $8nd05.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $07a161bd56d089a9$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $8nd05.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $ayMG0.jsx)(Tabs, (0, $8nd05.default)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, $bc2c3fa74ca71715$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut
        },
        className: classes.shortcuts,
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $ayMG0.jsx)(Shortcuts, (0, $8nd05.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $07a161bd56d089a9$export$2e2bcd8739ae039 = $07a161bd56d089a9$var$usePickerLayout;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8f5b3a99831a0c63$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            isLandscape && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6c9b2087702d19e3$export$1671c31de798d429), classes);
};
const $8f5b3a99831a0c63$export$9a9363506c13836 = (0, $d8seH.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${(0, $6c9b2087702d19e3$export$7a6dac186703fe4c).actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                [`& .${(0, $6c9b2087702d19e3$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                },
                [`.${(0, $6c9b2087702d19e3$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                }
            }
        },
        {
            props: {
                isLandscape: true,
                isRtl: true
            },
            style: {
                [`& .${(0, $6c9b2087702d19e3$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 3
                }
            }
        },
        {
            props: {
                isLandscape: false
            },
            style: {
                [`& .${(0, $6c9b2087702d19e3$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${(0, $6c9b2087702d19e3$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                isLandscape: false,
                isRtl: true
            },
            style: {
                [`& .${(0, $6c9b2087702d19e3$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 3
                }
            }
        }
    ]
});
const $8f5b3a99831a0c63$export$bc1494d918129235 = (0, $d8seH.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper',
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $8f5b3a99831a0c63$export$647f604ea2397c05 = /*#__PURE__*/ $acw62.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $07a161bd56d089a9$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, wrapperVariant: wrapperVariant } = props;
    const classes = $8f5b3a99831a0c63$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8f5b3a99831a0c63$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: props,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $ayMG0.jsx)($8f5b3a99831a0c63$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === 'desktop' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
const $e40f57ef1b045895$export$38de57b7f4a44eea = /*#__PURE__*/ $acw62.createContext(null);
function $e40f57ef1b045895$export$38e969d523d4d57f(props) {
    const { contextValue: contextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e40f57ef1b045895$export$38de57b7f4a44eea.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa5abcb204c6ca4b$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: children
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
const $4843bf1c616982ea$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $4843bf1c616982ea$var$_excluded2 = [
    "ownerState"
], $4843bf1c616982ea$var$_excluded3 = [
    "ownerState"
];
const $4843bf1c616982ea$export$b1b70bc56ac5be0e = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $1En50.default)(_ref, $4843bf1c616982ea$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const containerRef = $acw62.useRef(null);
    const fieldRef = $acw62.useRef(null);
    const labelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps, contextValue: contextValue, ownerState: ownerState } = (0, $72bb1f98949e4fd5$export$fc3313977ac596c4)((0, $8nd05.default)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'desktop'
    }));
    const InputAdornment = slots.inputAdornment ?? (0, $d0c64ff513a9933f$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps?.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: props
    }), inputAdornmentProps = (0, $1En50.default)(_useSlotProps, $4843bf1c616982ea$var$_excluded2);
    const OpenPickerButton = slots.openPickerButton ?? (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps?.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            'aria-label': getOpenDialogAriaText(pickerFieldProps.value),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $1En50.default)(_useSlotProps2, $4843bf1c616982ea$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const openPickerIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: OpenPickerIcon,
        externalSlotProps: innerSlotProps?.openPickerIcon,
        ownerState: ownerState
    });
    const Field = slots.field;
    const fieldProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $8nd05.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $8nd05.default)({}, fieldProps.InputProps, {
        ref: containerRef
    }, !props.disableOpenPicker && {
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $ayMG0.jsx)(InputAdornment, (0, $8nd05.default)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerButton, (0, $8nd05.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerIcon, (0, $8nd05.default)({}, openPickerIconProps))
            }))
        }))
    });
    const slotsForField = (0, $8nd05.default)({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $8f5b3a99831a0c63$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $8nd05.default)({}, innerSlotProps, {
        toolbar: (0, $8nd05.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $8nd05.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const handleFieldRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e40f57ef1b045895$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(Field, (0, $8nd05.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9e9d2dd7e32b7308$export$96ce8482474de8a5), (0, $8nd05.default)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $8nd05.default)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



var $bbT5Q = parcelRequire("bbT5Q");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $15f780f59fa32b0f$export$ed0fe318cc298673 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $15f780f59fa32b0f$export$8afed21ef5c2afa5 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $15f780f59fa32b0f$export$9ca09caa9c849d9c = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $15f780f59fa32b0f$export$5fda1783bb83f57b = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $15f780f59fa32b0f$export$8099ab97743c966c = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $15f780f59fa32b0f$export$90a8eab2a2411720 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $15f780f59fa32b0f$export$7e95adcf912503e3 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const $15f780f59fa32b0f$export$cefbac224a47f32 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");







var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");







var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");






var $8nd05 = parcelRequire("8nd05");

const $d68e490b4aa36330$var$expandFormat = ({ utils: utils, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.');
    }
    return nextFormat;
};
const $d68e490b4aa36330$var$getEscapedPartsFromFormat = ({ utils: utils, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $d68e490b4aa36330$var$getSectionPlaceholder = (utils, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $d68e490b4aa36330$var$createSection = ({ utils: utils, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, $f652bdb72e319cb0$export$2f3c5fac7a2a65f6)(utils, token);
    const hasLeadingZerosInFormat = (0, $f652bdb72e319cb0$export$78b5830e2dd2de49)(utils, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = date != null && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? utils.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $f652bdb72e319cb0$export$80dbbc19eba82070)((0, $f652bdb72e319cb0$export$713c6d756c12fc27)((0, $f652bdb72e319cb0$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $8nd05.default)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $d68e490b4aa36330$var$getSectionPlaceholder(utils, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
};
const $d68e490b4aa36330$var$buildSections = (params)=>{
    const { utils: utils, expandedFormat: expandedFormat, escapedParts: escapedParts } = params;
    const now = utils.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($d68e490b4aa36330$var$createSection((0, $8nd05.default)({}, params, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const $d68e490b4aa36330$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $d68e490b4aa36330$export$34084be60bfe3b3b = (params)=>{
    let expandedFormat = $d68e490b4aa36330$var$expandFormat(params);
    if (params.isRtl && params.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = $d68e490b4aa36330$var$getEscapedPartsFromFormat((0, $8nd05.default)({}, params, {
        expandedFormat: expandedFormat
    }));
    const sections = $d68e490b4aa36330$var$buildSections((0, $8nd05.default)({}, params, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $d68e490b4aa36330$var$postProcessSections((0, $8nd05.default)({}, params, {
        sections: sections
    }));
};




const $807ebdbb6685e382$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const adapter = (0, $28cc3a450bd9076f$export$4b5a24245de9f7f9)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $61302b639d1ef7ad$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: valueManager
    });
    const localizedDigits = $acw62.useMemo(()=>(0, $f652bdb72e319cb0$export$b42be9ae7016ef5d)(utils), [
        utils
    ]);
    const sectionsValueBoundaries = $acw62.useMemo(()=>(0, $f652bdb72e319cb0$export$360600f456ea7d5f)(utils, localizedDigits, timezone), [
        utils,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $acw62.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, (date)=>(0, $d68e490b4aa36330$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $f652bdb72e319cb0$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $c4f6f2b8fcbb5fe9$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $8nd05.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $acw62.useMemo(()=>(0, $f652bdb72e319cb0$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $8nd05.default)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                timezone: timezone,
                props: internalProps
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $8nd05.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== '').length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === '' ? 0 : 1);
        const newSections = setSectionValue(activeSectionIndex, '');
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        publishValue((0, $8nd05.default)({}, newValues, {
            sections: newSections
        }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $d68e490b4aa36330$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $f652bdb72e319cb0$export$6c6df982c77f60a9)(utils, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $f652bdb72e319cb0$export$b0c1bfd065bfe742)(utils, newActiveDateSections, localizedDigits);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $f652bdb72e319cb0$export$6c6df982c77f60a9)(utils, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $8nd05.default)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $8nd05.default)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $8nd05.default)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $acw62.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $f652bdb72e319cb0$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $8nd05.default)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale,
        isRtl
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $acw62.useEffect(()=>{
        let shouldUpdate;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $8nd05.default)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        activeSectionIndex: activeSectionIndex,
        parsedSelectedSections: parsedSelectedSections,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        getSectionsFromValue: getSectionsFromValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        timezone: timezone
    };
};



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $0903359c0c4ccba9$var$QUERY_LIFE_DURATION_MS = 5000;
const $0903359c0c4ccba9$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $0903359c0c4ccba9$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const [query, setQuery] = $acw62.useState(null);
    const resetQuery = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>setQuery(null));
    $acw62.useEffect(()=>{
        if (query != null && sections[query.sectionIndex]?.type !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $acw62.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $0903359c0c4ccba9$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $f652bdb72e319cb0$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $f652bdb72e319cb0$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $8nd05.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $f652bdb72e319cb0$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const cleanQueryValue = (0, $f652bdb72e319cb0$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $f652bdb72e319cb0$export$ef88db4bceade9fd)(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $f652bdb72e319cb0$export$78b5830e2dd2de49)(utils, 'digit', 'month', 'MM');
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: 'MM',
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: 'digit',
                    maxLength: 2
                });
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $f652bdb72e319cb0$export$2816862a602354ce)(utils, response.sectionValue, 'MM', activeSection.format);
                return (0, $8nd05.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($0903359c0c4ccba9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $f652bdb72e319cb0$export$c65c7173f879039f)(utils, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $8nd05.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $f652bdb72e319cb0$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    const applyCharacterEditing = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = (0, $f652bdb72e319cb0$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $8nd05.default)({}, params, {
            keyPressed: (0, $f652bdb72e319cb0$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



var $acw62 = parcelRequire("acw62");








const $b1c9aeef70035656$export$3b5f62b9baf9717e = (params)=>{
    const { internalProps: { disabled: disabled, readOnly: readOnly = false }, forwardedProps: { sectionListRef: inSectionListRef, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, focused: focusedProp, autoFocus: autoFocus = false }, fieldValueManager: fieldValueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, setSelectedSections: setSelectedSections, parsedSelectedSections: parsedSelectedSections, state: state, clearActiveSection: clearActiveSection, clearValue: clearValue, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, sectionOrder: sectionOrder, areAllSectionsEmpty: areAllSectionsEmpty, sectionsValueBoundaries: sectionsValueBoundaries } = params;
    const sectionListRef = $acw62.useRef(null);
    const handleSectionListRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(inSectionListRef, sectionListRef);
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const [focused, setFocused] = $acw62.useState(false);
    const interactions = $acw62.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!sectionListRef.current) return;
                const selection = document.getSelection();
                if (!selection) return;
                if (parsedSelectedSections == null) {
                    // If the selection contains an element inside the field, we reset it.
                    if (selection.rangeCount > 0 && sectionListRef.current.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
                    if (focused) sectionListRef.current.getRoot().blur();
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                if (!sectionListRef.current.getRoot().contains((0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document))) return;
                const range = new window.Range();
                let target;
                if (parsedSelectedSections === 'all') target = sectionListRef.current.getRoot();
                else {
                    const section = state.sections[parsedSelectedSections];
                    if (section.type === 'empty') target = sectionListRef.current.getSectionContainer(parsedSelectedSections);
                    else target = sectionListRef.current.getSectionContent(parsedSelectedSections);
                }
                range.selectNodeContents(target);
                target.focus();
                selection.removeAllRanges();
                selection.addRange(range);
            },
            getActiveSectionIndexFromDOM: ()=>{
                const activeElement = (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document);
                if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
                return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
            },
            focusField: (newSelectedSections = 0)=>{
                if (!sectionListRef.current || // if the field is already focused, we don't need to focus it again
                interactions.getActiveSectionIndexFromDOM() != null) return;
                const newParsedSelectedSections = (0, $f652bdb72e319cb0$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                setFocused(true);
                sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
            },
            setSelectedSections: (newSelectedSections)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $f652bdb72e319cb0$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            isFieldFocused: ()=>{
                const activeElement = (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document);
                return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
            }
        }), [
        parsedSelectedSections,
        setSelectedSections,
        state.sections,
        focused
    ]);
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((sectionIndex)=>{
        if (!sectionListRef.current) return;
        const section = state.sections[sectionIndex];
        sectionListRef.current.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        interactions.syncSelectionToDOM();
    });
    const handleContainerClick = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleContainerClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented() || !sectionListRef.current) return;
        setFocused(true);
        onClick?.(event, ...args);
        if (parsedSelectedSections === 'all') setTimeout(()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = sectionListRef.current.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleContainerInput = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onInput?.(event);
        if (!sectionListRef.current || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        sectionListRef.current.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        interactions.syncSelectionToDOM();
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            resetCharacterQuery();
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed: keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handleContainerPaste = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        if (focused || !sectionListRef.current) return;
        setFocused(true);
        const isFocusInsideASection = sectionListRef.current.getSectionIndexFromDOMElement((0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document)) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setTimeout(()=>{
            if (!sectionListRef.current) return;
            const activeElement = (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document);
            const shouldBlur = !sectionListRef.current.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    const getInputContainerClickHandler = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentMouseUp = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const getInputContentFocusHandler = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((sectionIndex)=>()=>{
            setSelectedSections(sectionIndex);
        });
    const handleInputContentPaste = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            resetCharacterQuery();
            updateSectionValue({
                activeSection: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            resetCharacterQuery();
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleInputContentDragOver = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const handleInputContentInput = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (!sectionListRef.current) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = sectionListRef.current.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly || !sectionListRef.current) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    const sectionBoundaries = $acw62.useMemo(()=>{
        return state.sections.reduce((acc, next)=>{
            acc[next.type] = sectionsValueBoundaries[next.type]({
                currentDate: null,
                contentType: next.contentType,
                format: next.format
            });
            return acc;
        }, {});
    }, [
        sectionsValueBoundaries,
        state.sections
    ]);
    const isContainerEditable = parsedSelectedSections === 'all';
    const elements = $acw62.useMemo(()=>{
        return state.sections.map((section, index)=>{
            const isEditable = !isContainerEditable && !disabled && !readOnly;
            return {
                container: {
                    'data-sectionindex': index,
                    onClick: getInputContainerClickHandler(index)
                },
                content: {
                    tabIndex: isContainerEditable || index > 0 ? -1 : 0,
                    contentEditable: !isContainerEditable && !disabled && !readOnly,
                    role: 'spinbutton',
                    id: `${id}-${section.type}`,
                    'aria-labelledby': `${id}-${section.type}`,
                    'aria-readonly': readOnly,
                    'aria-valuenow': (0, $f652bdb72e319cb0$export$b46fd324c5adcf31)(section, utils),
                    'aria-valuemin': sectionBoundaries[section.type].minimum,
                    'aria-valuemax': sectionBoundaries[section.type].maximum,
                    'aria-valuetext': section.value ? (0, $f652bdb72e319cb0$export$b5e30842500b6cab)(section, utils) : translations.empty,
                    'aria-label': translations[section.type],
                    'aria-disabled': disabled,
                    spellCheck: isEditable ? false : undefined,
                    autoCapitalize: isEditable ? 'off' : undefined,
                    autoCorrect: isEditable ? 'off' : undefined,
                    [parseInt($acw62.version, 10) >= 17 ? 'enterKeyHint' : 'enterkeyhint']: isEditable ? 'next' : undefined,
                    children: section.value || section.placeholder,
                    onInput: handleInputContentInput,
                    onPaste: handleInputContentPaste,
                    onFocus: getInputContentFocusHandler(index),
                    onDragOver: handleInputContentDragOver,
                    onMouseUp: handleInputContentMouseUp,
                    inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
                },
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator
                }
            };
        });
    }, [
        state.sections,
        getInputContentFocusHandler,
        handleInputContentPaste,
        handleInputContentDragOver,
        handleInputContentInput,
        getInputContainerClickHandler,
        handleInputContentMouseUp,
        disabled,
        readOnly,
        isContainerEditable,
        translations,
        utils,
        sectionBoundaries,
        id
    ]);
    const handleValueStrChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $acw62.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    $acw62.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:',
            '',
            '<DatePicker slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        interactions: interactions,
        returnedValue: {
            autoFocus: // Forwarded
            autoFocus,
            readOnly: readOnly,
            focused: focusedProp ?? focused,
            sectionListRef: handleSectionListRef,
            onBlur: handleContainerBlur,
            onClick: handleContainerClick,
            onFocus: handleContainerFocus,
            onInput: handleContainerInput,
            onPaste: handleContainerPaste,
            // Additional
            enableAccessibleFieldDOMStructure: true,
            elements: elements,
            // TODO v7: Try to set to undefined when there is a section selected.
            tabIndex: parsedSelectedSections === 0 ? -1 : 0,
            contentEditable: isContainerEditable,
            value: valueStr,
            onChange: handleValueStrChange,
            areAllSectionsEmpty: areAllSectionsEmpty
        }
    };
};



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");





const $2c908f051ecf8b71$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $2c908f051ecf8b71$export$8bb5d1c9951d10ca = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $f652bdb72e319cb0$export$85daa91f6c6e875f)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $2c908f051ecf8b71$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $2c908f051ecf8b71$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $8nd05.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $2c908f051ecf8b71$export$4995d3b7b56fcd3f = (params)=>{
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const focusTimeoutRef = $acw62.useRef(undefined);
    const selectionSyncTimeoutRef = $acw62.useRef(undefined);
    const { forwardedProps: { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, inputRef: inputRefProp, placeholder: inPlaceholder }, internalProps: { readOnly: readOnly = false, disabled: disabled = false }, parsedSelectedSections: parsedSelectedSections, activeSectionIndex: activeSectionIndex, state: state, fieldValueManager: fieldValueManager, valueManager: valueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, clearActiveSection: clearActiveSection, clearValue: clearValue, setTempAndroidValueStr: setTempAndroidValueStr, setSelectedSections: setSelectedSections, getSectionsFromValue: getSectionsFromValue, areAllSectionsEmpty: areAllSectionsEmpty, localizedDigits: localizedDigits } = params;
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const sections = $acw62.useMemo(()=>$2c908f051ecf8b71$export$8bb5d1c9951d10ca(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    const interactions = $acw62.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!inputRef.current) return;
                if (parsedSelectedSections == null) {
                    if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                    // setting selection range to 0 causes issues in Safari.
                    // https://bugs.webkit.org/show_bug.cgi?id=224425
                    inputRef.current.scrollLeft = 0;
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
                // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
                if (inputRef.current !== (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document)) return;
                // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
                const currentScrollTop = inputRef.current.scrollTop;
                if (parsedSelectedSections === 'all') inputRef.current.select();
                else {
                    const selectedSection = sections[parsedSelectedSections];
                    const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                    const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                    if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                        if (inputRef.current === (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    }
                    clearTimeout(selectionSyncTimeoutRef.current);
                    selectionSyncTimeoutRef.current = setTimeout(()=>{
                        // handle case when the selection is not updated correctly
                        // could happen on Android
                        if (inputRef.current && inputRef.current === (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
                        // https://github.com/mui/mui-x/pull/13652
                        inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) interactions.syncSelectionToDOM();
                    });
                }
                // Even reading this variable seems to do the trick, but also setting it just to make use of it
                inputRef.current.scrollTop = currentScrollTop;
            },
            getActiveSectionIndexFromDOM: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            focusField: (newSelectedSection = 0)=>{
                if ((0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document) === inputRef.current) return;
                inputRef.current?.focus();
                setSelectedSections(newSelectedSection);
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            isFieldFocused: ()=>inputRef.current === (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document)
        }), [
        inputRef,
        parsedSelectedSections,
        sections,
        setSelectedSections
    ]);
    const syncSelectionFromDOM = ()=>{
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $2c908f051ecf8b71$var$cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $2c908f051ecf8b71$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $2c908f051ecf8b71$var$cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + $2c908f051ecf8b71$var$cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $f652bdb72e319cb0$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const placeholder = $acw62.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $acw62.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $acw62.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document)) setSelectedSections('all');
        return ()=>{
            clearTimeout(focusTimeoutRef.current);
            clearTimeout(selectionSyncTimeoutRef.current);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const inputMode = $acw62.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $f4ceb023c3ba7bf1$export$cd4e5573fbe2b576)(document);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    return {
        interactions: interactions,
        returnedValue: {
            readOnly: // Forwarded
            readOnly,
            onBlur: handleContainerBlur,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            onPaste: handleInputPaste,
            inputRef: handleRef,
            // Additional
            enableAccessibleFieldDOMStructure: false,
            placeholder: placeholder,
            inputMode: inputMode,
            autoComplete: 'off',
            value: shouldShowPlaceholder ? '' : valueStr,
            onChange: handleInputChange
        }
    };
};


const $df0fbd014072b490$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const { internalProps: internalProps, internalProps: { unstableFieldRef: unstableFieldRef, minutesStep: minutesStep, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false, disabled: disabled = false, readOnly: readOnly = false }, forwardedProps: { onKeyDown: onKeyDown, error: error, clearable: clearable, onClear: onClear }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params;
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const stateResponse = (0, $807ebdbb6685e382$export$4e8d6353e50062e7)(params);
    const { state: state, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone } = stateResponse;
    const characterEditingResponse = (0, $0903359c0c4ccba9$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const { resetCharacterQuery: resetCharacterQuery } = characterEditingResponse;
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, $b1c9aeef70035656$export$3b5f62b9baf9717e) : (0, $2c908f051ecf8b71$export$4995d3b7b56fcd3f);
    const sectionOrder = $acw62.useMemo(()=>(0, $f652bdb72e319cb0$export$7725fd6fe0a2aadf)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const { returnedValue: returnedValue, interactions: interactions } = useFieldTextField((0, $8nd05.default)({}, params, stateResponse, characterEditingResponse, {
        areAllSectionsEmpty: areAllSectionsEmpty,
        sectionOrder: sectionOrder
    }));
    const handleContainerKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onKeyDown?.(event);
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $f652bdb72e319cb0$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        interactions.syncSelectionToDOM();
    });
    const { hasValidationError: hasValidationError } = (0, $01bcd2a693711309$export$87fe492f99f25a20)({
        props: internalProps,
        validator: validator,
        timezone: timezone,
        value: state.value,
        onError: internalProps.onError
    });
    const inputError = $acw62.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return hasValidationError;
    }, [
        hasValidationError,
        error
    ]);
    $acw62.useEffect(()=>{
        if (!inputError && activeSectionIndex == null) resetCharacterQuery();
    }, [
        state.referenceValue,
        activeSectionIndex,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $acw62.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $acw62.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: interactions.getActiveSectionIndexFromDOM,
            setSelectedSections: interactions.setSelectedSections,
            focusField: interactions.focusField,
            isFieldFocused: interactions.isFieldFocused
        }));
    const handleClearValue = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!interactions.isFieldFocused()) // setSelectedSections is called internally
        interactions.focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const commonForwardedProps = {
        onKeyDown: handleContainerKeyDown,
        onClear: handleClearValue,
        error: inputError,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    };
    const commonAdditionalProps = {
        disabled: disabled,
        readOnly: readOnly
    };
    return (0, $8nd05.default)({}, params.forwardedProps, commonForwardedProps, commonAdditionalProps, returnedValue);
};




var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

'use client';
const $3f156a3b21b74a46$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator'
];
const $3f156a3b21b74a46$export$be857fabf132acea = (props, valueType)=>{
    return $acw62.useMemo(()=>{
        const forwardedProps = (0, $8nd05.default)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $3f156a3b21b74a46$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') (0, $4be2a81b5d2111e4$export$430d9fc64cf058d6).forEach(extractProp);
        else if (valueType === 'time') (0, $4be2a81b5d2111e4$export$fd5e0f8b4115a8c7).forEach(extractProp);
        else if (valueType === 'date-time') {
            (0, $4be2a81b5d2111e4$export$430d9fc64cf058d6).forEach(extractProp);
            (0, $4be2a81b5d2111e4$export$fd5e0f8b4115a8c7).forEach(extractProp);
            (0, $4be2a81b5d2111e4$export$1df62d3ba2121371).forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
};



var $8nd05 = parcelRequire("8nd05");


const $b389285d7fc99057$export$c04f15aa68a6177a = (props)=>{
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const defaultDates = (0, $28cc3a450bd9076f$export$7c38da3a2e90fa83)();
    return (0, $8nd05.default)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? utils.formats.keyboardDate,
        minDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $b389285d7fc99057$export$e740b972b66c04cd = (props)=>{
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $8nd05.default)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat
    });
};
const $b389285d7fc99057$export$ae5b8d06aeae1db3 = (props)=>{
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const defaultDates = (0, $28cc3a450bd9076f$export$7c38da3a2e90fa83)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h;
    return (0, $8nd05.default)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat,
        disableIgnoringDatePartForTimeValidation: Boolean(props.minDateTime || props.maxDateTime),
        minDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, props.minDateTime ?? props.minDate, defaultDates.minDate),
        maxDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
        minTime: props.minDateTime ?? props.minTime,
        maxTime: props.maxDateTime ?? props.maxTime
    });
};


'use client';
const $662d5fca10440bd9$export$5591b0b878c1a989 = (inProps)=>{
    const props = (0, $b389285d7fc99057$export$c04f15aa68a6177a)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $3f156a3b21b74a46$export$be857fabf132acea)(props, 'date');
    return (0, $df0fbd014072b490$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $14acbf5609fff29c$export$2764b246aa3b75ba),
        fieldValueManager: (0, $14acbf5609fff29c$export$b602c94f557316b4),
        validator: (0, $8fe304ca4ba155e2$export$ffb3d0046ef3a2),
        valueType: 'date'
    });
};



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $299e129c3bfab876$var$_excluded = [
    "clearable",
    "onClear",
    "InputProps",
    "sx",
    "slots",
    "slotProps"
], $299e129c3bfab876$var$_excluded2 = [
    "ownerState"
];
const $299e129c3bfab876$export$db9644cdb7e3d432 = (props)=>{
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const { clearable: clearable, onClear: onClear, InputProps: InputProps, sx: sx, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $299e129c3bfab876$var$_excluded);
    const IconButton = slots?.clearButton ?? (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: IconButton,
        externalSlotProps: slotProps?.clearButton,
        ownerState: {},
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel
        }
    }), iconButtonProps = (0, $1En50.default)(_useSlotProps, $299e129c3bfab876$var$_excluded2);
    const EndClearIcon = slots?.clearIcon ?? (0, $15f780f59fa32b0f$export$cefbac224a47f32);
    const endClearIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: EndClearIcon,
        externalSlotProps: slotProps?.clearIcon,
        ownerState: {}
    });
    return (0, $8nd05.default)({}, other, {
        InputProps: (0, $8nd05.default)({}, InputProps, {
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    clearable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0c64ff513a9933f$export$2e2bcd8739ae039), {
                        position: "end",
                        sx: {
                            marginRight: InputProps?.endAdornment ? -1 : -1.5
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(IconButton, (0, $8nd05.default)({}, iconButtonProps, {
                            onClick: onClear,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(EndClearIcon, (0, $8nd05.default)({
                                fontSize: "small"
                            }, endClearIconProps))
                        }))
                    }),
                    InputProps?.endAdornment
                ]
            })
        }),
        sx: [
            {
                '& .clearButton': {
                    opacity: 1
                },
                '@media (pointer: fine)': {
                    '& .clearButton': {
                        opacity: 0
                    },
                    '&:hover, &:focus-within': {
                        '.clearButton': {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    });
};



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");



var $8Indx = parcelRequire("8Indx");





var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $3f6e178f64e28835$export$d99678ed7aad1677(slot) {
    return (0, $4Cod0.default)('MuiPickersTextField', slot);
}
const $3f6e178f64e28835$export$284739773a7ae972 = (0, $beCSm.default)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");


var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $76e7d735dfe68a88$export$3821cb625ac26962(slot) {
    return (0, $4Cod0.default)('MuiPickersInputBase', slot);
}
const $76e7d735dfe68a88$export$f20b5ba262568322 = (0, $beCSm.default)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input'
]);


function $0fab569a23858f12$export$c0dd951a3959ac7f(slot) {
    return (0, $4Cod0.default)('MuiPickersOutlinedInput', slot);
}
const $0fab569a23858f12$export$a7da60486bcc91df = (0, $8nd05.default)({}, (0, $76e7d735dfe68a88$export$f20b5ba262568322), (0, $beCSm.default)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
const $25c820f8a71a2e52$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $25c820f8a71a2e52$var$OutlineRoot = (0, $d8seH.default)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $25c820f8a71a2e52$var$OutlineLabel = (0, $d8seH.default)('span')(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const $25c820f8a71a2e52$var$OutlineLegend = (0, $d8seH.default)('legend')(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    withLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    withLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    withLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $25c820f8a71a2e52$export$2e2bcd8739ae039(props) {
    const { className: className, label: label } = props, other = (0, $1En50.default)(props, $25c820f8a71a2e52$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $8nd05.default)({}, props, {
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineRoot, (0, $8nd05.default)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $ayMG0.jsx)($25c820f8a71a2e52$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");



var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");

const $0acaed42692b8720$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $0acaed42692b8720$export$2e2bcd8739ae039 = $0acaed42692b8720$var$visuallyHidden;





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $117f0443ae3d158a$export$f891a98d04ce6513(slot) {
    return (0, $4Cod0.default)('MuiPickersSectionList', slot);
}
const $117f0443ae3d158a$export$8455939b33d2ee90 = (0, $beCSm.default)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $677e84dab89c4abd$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef"
];
const $677e84dab89c4abd$export$4ee86b293725486c = (0, $d8seH.default)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const $677e84dab89c4abd$export$30e7187e386feb4f = (0, $d8seH.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section',
    overridesResolver: (props, styles)=>styles.section
})({});
const $677e84dab89c4abd$export$c403b59604f63120 = (0, $d8seH.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator',
    overridesResolver: (props, styles)=>styles.sectionSeparator
})({
    whiteSpace: 'pre'
});
const $677e84dab89c4abd$export$1f2c61561fe3d6 = (0, $d8seH.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.sectionContent
})({
    outline: 'none'
});
const $677e84dab89c4abd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $117f0443ae3d158a$export$f891a98d04ce6513), classes);
};
function $677e84dab89c4abd$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const Section = slots?.section ?? $677e84dab89c4abd$export$30e7187e386feb4f;
    const sectionProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: {}
    });
    const SectionContent = slots?.sectionContent ?? $677e84dab89c4abd$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: {}
    });
    const SectionSeparator = slots?.sectionSeparator ?? $677e84dab89c4abd$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: {
            position: 'before'
        }
    });
    const sectionSeparatorAfterProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: {
            position: 'after'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(Section, (0, $8nd05.default)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $8nd05.default)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionContent, (0, $8nd05.default)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $8nd05.default)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $677e84dab89c4abd$export$847fd4b97819700 = /*#__PURE__*/ $acw62.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef } = props, other = (0, $1En50.default)(props, $677e84dab89c4abd$var$_excluded);
    const classes = $677e84dab89c4abd$var$useUtilityClasses(props);
    const rootRef = $acw62.useRef(null);
    const handleRootRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $acw62.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${(0, $117f0443ae3d158a$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${(0, $117f0443ae3d158a$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $117f0443ae3d158a$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $117f0443ae3d158a$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $117f0443ae3d158a$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $677e84dab89c4abd$export$4ee86b293725486c;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $8nd05.default)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($677e84dab89c4abd$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});



var $ayMG0 = parcelRequire("ayMG0");
const $b07bd25b455bc147$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef"
];
const $b07bd25b455bc147$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $b07bd25b455bc147$export$ddc18880178d980e = (0, $d8seH.default)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$b07bd25b455bc147$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $b07bd25b455bc147$export$52f3fbbfe9321824 = (0, $d8seH.default)((0, $677e84dab89c4abd$export$4ee86b293725486c), {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})(({ theme: theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    isRtl: true
                },
                style: {
                    textAlign: 'right /*! @noflip */'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    adornedStart: false,
                    focused: false,
                    filled: false
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                // Can't use the object notation because label can be null or undefined
                props: ({ adornedStart: adornedStart, focused: focused, filled: filled, label: label })=>!adornedStart && !focused && !filled && label == null,
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const $b07bd25b455bc147$var$PickersInputBaseSection = (0, $d8seH.default)((0, $677e84dab89c4abd$export$30e7187e386feb4f), {
    name: 'MuiPickersInputBase',
    slot: 'Section',
    overridesResolver: (props, styles)=>styles.section
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionContent = (0, $d8seH.default)((0, $677e84dab89c4abd$export$1f2c61561fe3d6), {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const $b07bd25b455bc147$var$PickersInputBaseSectionSeparator = (0, $d8seH.default)((0, $677e84dab89c4abd$export$c403b59604f63120), {
    name: 'MuiPickersInputBase',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const $b07bd25b455bc147$var$PickersInputBaseInput = (0, $d8seH.default)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput
})((0, $8nd05.default)({}, (0, $0acaed42692b8720$export$2e2bcd8739ae039)));
const $b07bd25b455bc147$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, error: error, classes: classes, fullWidth: fullWidth, readOnly: readOnly, color: color, size: size, endAdornment: endAdornment, startAdornment: startAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            focused && !disabled && 'focused',
            disabled && 'disabled',
            readOnly && 'readOnly',
            error && 'error',
            fullWidth && 'fullWidth',
            `color${(0, $gxvzd.default)(color)}`,
            size === 'small' && 'inputSizeSmall',
            Boolean(startAdornment) && 'adornedStart',
            Boolean(endAdornment) && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $76e7d735dfe68a88$export$3821cb625ac26962), classes);
};
/**
 * @ignore - internal component.
 */ const $b07bd25b455bc147$export$ff827734ba831074 = /*#__PURE__*/ $acw62.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef } = props, other = (0, $1En50.default)(props, $b07bd25b455bc147$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const handleRootRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, rootRef);
    const handleInputRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(inputProps?.ref, inputRef);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const handleInputFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (muiFormControl.disabled) {
            event.stopPropagation();
            return;
        }
        muiFormControl.onFocus?.(event);
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $acw62.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const ownerState = (0, $8nd05.default)({}, props, muiFormControl, {
        isRtl: isRtl
    });
    const classes = $b07bd25b455bc147$var$useUtilityClasses(ownerState);
    const InputRoot = slots?.root || $b07bd25b455bc147$export$ddc18880178d980e;
    const inputRootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $b07bd25b455bc147$export$52f3fbbfe9321824;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(InputRoot, (0, $8nd05.default)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $677e84dab89c4abd$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: muiFormControl.onBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $b07bd25b455bc147$var$PickersInputBaseSection,
                    sectionContent: $b07bd25b455bc147$var$PickersInputBaseSectionContent,
                    sectionSeparator: $b07bd25b455bc147$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: {
                        ownerState: ownerState
                    },
                    sectionContent: {
                        className: (0, $76e7d735dfe68a88$export$f20b5ba262568322).sectionContent
                    },
                    sectionSeparator: ({ position: position })=>({
                            className: position === 'before' ? (0, $76e7d735dfe68a88$export$f20b5ba262568322).sectionBefore : (0, $76e7d735dfe68a88$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $8nd05.default)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($b07bd25b455bc147$var$PickersInputBaseInput, (0, $8nd05.default)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled
            }, inputProps, {
                ref: handleInputRef
            }))
        ]
    }));
});




var $ayMG0 = parcelRequire("ayMG0");
const $20d706e29be2fff2$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "notched"
];
const $20d706e29be2fff2$var$PickersOutlinedInputRoot = (0, $d8seH.default)((0, $b07bd25b455bc147$export$ddc18880178d980e), {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $0fab569a23858f12$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $0fab569a23858f12$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $0fab569a23858f12$export$a7da60486bcc91df).focused} .${(0, $0fab569a23858f12$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${(0, $0fab569a23858f12$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $0fab569a23858f12$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, $0fab569a23858f12$export$a7da60486bcc91df).error} .${(0, $0fab569a23858f12$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    color: color
                },
                style: {
                    [`&.${(0, $0fab569a23858f12$export$a7da60486bcc91df).focused}:not(.${(0, $0fab569a23858f12$export$a7da60486bcc91df).error}) .${(0, $0fab569a23858f12$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $20d706e29be2fff2$var$PickersOutlinedInputSectionsContainer = (0, $d8seH.default)((0, $b07bd25b455bc147$export$52f3fbbfe9321824), {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const $20d706e29be2fff2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $0fab569a23858f12$export$c0dd951a3959ac7f), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $20d706e29be2fff2$export$44d4d00edb0c710f = /*#__PURE__*/ $acw62.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label: label, ownerState: ownerStateProp, notched: notched } = props, other = (0, $1En50.default)(props, $20d706e29be2fff2$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const ownerState = (0, $8nd05.default)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || 'primary'
    });
    const classes = $20d706e29be2fff2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b07bd25b455bc147$export$ff827734ba831074), (0, $8nd05.default)({
        slots: {
            root: $20d706e29be2fff2$var$PickersOutlinedInputRoot,
            input: $20d706e29be2fff2$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $25c820f8a71a2e52$export$2e2bcd8739ae039), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label,
                ownerState: ownerState
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$20d706e29be2fff2$export$44d4d00edb0c710f.muiName = 'Input';



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");
/**
 * @mui/styled-engine v6.4.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $5rflj = parcelRequire("5rflj");

var $8rteH = parcelRequire("8rteH");



function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $5rflj.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $89ab6b9e702438b4$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $89ab6b9e702438b4$var$wrapper = [];
function $89ab6b9e702438b4$export$13a2d3ef13012b32(styles) {
    $89ab6b9e702438b4$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($89ab6b9e702438b4$var$wrapper);
}



var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");
function $ab54d737c452cabc$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $ab54d737c452cabc$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $4jPKB.isValidElementType)(source) || !$ab54d737c452cabc$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $ab54d737c452cabc$var$deepClone(source[key]);
    });
    return output;
}
function $ab54d737c452cabc$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($ab54d737c452cabc$export$53b83ca8eaab0383(target) && $ab54d737c452cabc$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $4jPKB.isValidElementType)(source[key])) output[key] = source[key];
        else if ($ab54d737c452cabc$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $ab54d737c452cabc$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $ab54d737c452cabc$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $ab54d737c452cabc$export$53b83ca8eaab0383(source[key]) ? $ab54d737c452cabc$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $f27c6337b9d67c68$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $20407562937ae76e$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $f27c6337b9d67c68$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}



var $4jPKB = parcelRequire("4jPKB");
function $5210edc31c9006df$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $5210edc31c9006df$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $5210edc31c9006df$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $5210edc31c9006df$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $5210edc31c9006df$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $5210edc31c9006df$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jPKB.Memo:
            return $5210edc31c9006df$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $7c7a04bfefec7c88$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $7c7a04bfefec7c88$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $7c7a04bfefec7c88$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $7c7a04bfefec7c88$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



function $91bc4077911678f2$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $91bc4077911678f2$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $91bc4077911678f2$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $91bc4077911678f2$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;






function $e5a728ecb1a1c3c0$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $ab54d737c452cabc$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e5a728ecb1a1c3c0$export$2e2bcd8739ae039 = $e5a728ecb1a1c3c0$var$merge;



const $5d96decff5ccffcb$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $5d96decff5ccffcb$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$5d96decff5ccffcb$export$68c286be0e7e55b7[key]}px)`
};
const $5d96decff5ccffcb$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $5d96decff5ccffcb$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $5d96decff5ccffcb$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $91bc4077911678f2$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $91bc4077911678f2$export$10a9745dfa00d15)(theme.containerQueries ? theme : $5d96decff5ccffcb$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $5d96decff5ccffcb$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $5d96decff5ccffcb$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $5d96decff5ccffcb$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $5d96decff5ccffcb$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $ab54d737c452cabc$export$2e2bcd8739ae039)(prev, next), {});
    return $5d96decff5ccffcb$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $5d96decff5ccffcb$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $5d96decff5ccffcb$export$2e2bcd8739ae039 = $5d96decff5ccffcb$var$breakpoints;





function $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $d50fcf9a3ec00b94$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $20407562937ae76e$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $d50fcf9a3ec00b94$export$2e2bcd8739ae039 = $d50fcf9a3ec00b94$var$style;



function $c9a3e017c1fe4096$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $555e14aafbcd0190$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $555e14aafbcd0190$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $555e14aafbcd0190$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $555e14aafbcd0190$var$getCssProperties = (0, $c9a3e017c1fe4096$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($555e14aafbcd0190$var$aliases[prop]) prop = $555e14aafbcd0190$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $555e14aafbcd0190$var$properties[a];
    const direction = $555e14aafbcd0190$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $555e14aafbcd0190$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $555e14aafbcd0190$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $555e14aafbcd0190$var$spacingKeys = [
    ...$555e14aafbcd0190$export$aab52a0dde05ad8a,
    ...$555e14aafbcd0190$export$f8397d44f03ab6ad
];
function $555e14aafbcd0190$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $555e14aafbcd0190$export$1def6f833384e3d1(theme) {
    return $555e14aafbcd0190$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $555e14aafbcd0190$var$getCssProperties(prop);
    const styleFromPropValue = $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $555e14aafbcd0190$var$style(props, keys) {
    const transformer = $555e14aafbcd0190$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039), {});
}
function $555e14aafbcd0190$export$7ede87f9b603dd3c(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$aab52a0dde05ad8a);
}
$555e14aafbcd0190$export$7ede87f9b603dd3c.propTypes = {};
$555e14aafbcd0190$export$7ede87f9b603dd3c.filterProps = $555e14aafbcd0190$export$aab52a0dde05ad8a;
function $555e14aafbcd0190$export$6f98e8eaf0be1996(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$f8397d44f03ab6ad);
}
$555e14aafbcd0190$export$6f98e8eaf0be1996.propTypes = {};
$555e14aafbcd0190$export$6f98e8eaf0be1996.filterProps = $555e14aafbcd0190$export$f8397d44f03ab6ad;
function $555e14aafbcd0190$var$spacing(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$var$spacingKeys);
}
$555e14aafbcd0190$var$spacing.propTypes = {};
$555e14aafbcd0190$var$spacing.filterProps = $555e14aafbcd0190$var$spacingKeys;
var $555e14aafbcd0190$export$2e2bcd8739ae039 = $555e14aafbcd0190$var$spacing;


function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $555e14aafbcd0190$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}











function $ce5a4af256600fcc$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $ce5a4af256600fcc$export$2e2bcd8739ae039 = $ce5a4af256600fcc$var$compose;




function $c2b4d2c425fe2f29$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $c2b4d2c425fe2f29$var$createBorderStyle(prop, transform) {
    return (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $c2b4d2c425fe2f29$export$1edee58a52776cd9 = $c2b4d2c425fe2f29$var$createBorderStyle('border', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$f9a7b6bd24892946 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTop', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$5abca33e6be905d2 = $c2b4d2c425fe2f29$var$createBorderStyle('borderRight', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e2ce9f12a980a822 = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottom', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$47658cca1a909427 = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeft', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e7fb0694ba2404fc = $c2b4d2c425fe2f29$var$createBorderStyle('borderColor');
const $c2b4d2c425fe2f29$export$126a92c968acdb85 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTopColor');
const $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e = $c2b4d2c425fe2f29$var$createBorderStyle('borderRightColor');
const $c2b4d2c425fe2f29$export$340b0327727f6d1a = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottomColor');
const $c2b4d2c425fe2f29$export$60beef91a985b4bf = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeftColor');
const $c2b4d2c425fe2f29$export$f9258c55612cbed7 = $c2b4d2c425fe2f29$var$createBorderStyle('outline', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$621fe586efeb64b9 = $c2b4d2c425fe2f29$var$createBorderStyle('outlineColor');
const $c2b4d2c425fe2f29$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.propTypes = {};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $c2b4d2c425fe2f29$var$borders = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($c2b4d2c425fe2f29$export$1edee58a52776cd9, $c2b4d2c425fe2f29$export$f9a7b6bd24892946, $c2b4d2c425fe2f29$export$5abca33e6be905d2, $c2b4d2c425fe2f29$export$e2ce9f12a980a822, $c2b4d2c425fe2f29$export$47658cca1a909427, $c2b4d2c425fe2f29$export$e7fb0694ba2404fc, $c2b4d2c425fe2f29$export$126a92c968acdb85, $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e, $c2b4d2c425fe2f29$export$340b0327727f6d1a, $c2b4d2c425fe2f29$export$60beef91a985b4bf, $c2b4d2c425fe2f29$export$7a57f79000377ca2, $c2b4d2c425fe2f29$export$f9258c55612cbed7, $c2b4d2c425fe2f29$export$621fe586efeb64b9);
var $c2b4d2c425fe2f29$export$2e2bcd8739ae039 = $c2b4d2c425fe2f29$var$borders;







const $b007bd6739310ca0$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$5df9adcb0db95e1e.propTypes = {};
$b007bd6739310ca0$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $b007bd6739310ca0$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$ec60d70ff941a580.propTypes = {};
$b007bd6739310ca0$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $b007bd6739310ca0$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.propTypes = {};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $b007bd6739310ca0$export$baf44164ca3a34e8 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $b007bd6739310ca0$export$8f7213a1cd01e832 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $b007bd6739310ca0$export$b0e0abbc49ba668 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $b007bd6739310ca0$export$bcd8b929d4b4142 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $b007bd6739310ca0$export$e5039a674e14c828 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $b007bd6739310ca0$export$42bd9088661ffb03 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $b007bd6739310ca0$export$920682ae05b999bc = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $b007bd6739310ca0$export$1b88fbdd482fd33a = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $b007bd6739310ca0$export$bdb486e40d52d26f = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $b007bd6739310ca0$var$grid = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($b007bd6739310ca0$export$5df9adcb0db95e1e, $b007bd6739310ca0$export$ec60d70ff941a580, $b007bd6739310ca0$export$8a833ffa5f5dbeda, $b007bd6739310ca0$export$baf44164ca3a34e8, $b007bd6739310ca0$export$8f7213a1cd01e832, $b007bd6739310ca0$export$b0e0abbc49ba668, $b007bd6739310ca0$export$bcd8b929d4b4142, $b007bd6739310ca0$export$e5039a674e14c828, $b007bd6739310ca0$export$42bd9088661ffb03, $b007bd6739310ca0$export$920682ae05b999bc, $b007bd6739310ca0$export$1b88fbdd482fd33a, $b007bd6739310ca0$export$bdb486e40d52d26f);
var $b007bd6739310ca0$export$2e2bcd8739ae039 = $b007bd6739310ca0$var$grid;




function $b08badac1d124df3$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $b08badac1d124df3$export$35e9368ef982300f = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$2506f56c10355b33 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$8c5a050822fd698c = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$var$palette = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($b08badac1d124df3$export$35e9368ef982300f, $b08badac1d124df3$export$2506f56c10355b33, $b08badac1d124df3$export$8c5a050822fd698c);
var $b08badac1d124df3$export$2e2bcd8739ae039 = $b08badac1d124df3$var$palette;





function $60c239303eb89b20$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $60c239303eb89b20$export$7e3df82ee760448c = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $5d96decff5ccffcb$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $60c239303eb89b20$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$60c239303eb89b20$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $60c239303eb89b20$export$ee148fbbe8357dd2 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ac607276a8fe9f0a = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$dc0d8bd0b94f8570 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$a43cf604e12f3b17 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ffed9f14fb65e276 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$905076ed6620e671 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$6ccc93f785106a58 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $60c239303eb89b20$var$sizing = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($60c239303eb89b20$export$7e3df82ee760448c, $60c239303eb89b20$export$488fda99655ff65a, $60c239303eb89b20$export$ee148fbbe8357dd2, $60c239303eb89b20$export$ac607276a8fe9f0a, $60c239303eb89b20$export$dc0d8bd0b94f8570, $60c239303eb89b20$export$a43cf604e12f3b17, $60c239303eb89b20$export$6ccc93f785106a58);
var $60c239303eb89b20$export$2e2bcd8739ae039 = $60c239303eb89b20$var$sizing;


const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $c2b4d2c425fe2f29$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $b08badac1d124df3$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $b08badac1d124df3$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $b08badac1d124df3$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $b007bd6739310ca0$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $b007bd6739310ca0$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $b007bd6739310ca0$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $60c239303eb89b20$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    height: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;


function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $d50fcf9a3ec00b94$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $d50fcf9a3ec00b94$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $20407562937ae76e$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $f27f6a6c429b3415$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $5d96decff5ccffcb$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $5d96decff5ccffcb$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $91bc4077911678f2$export$456f6c1142f990db)(theme, (0, $5d96decff5ccffcb$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $7c7a04bfefec7c88$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $1f392ba2ebd18096$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $ab54d737c452cabc$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $8aecb04a157fa644$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $91bc4077911678f2$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $21efa8802134c535$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $ab54d737c452cabc$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $f27f6a6c429b3415$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6b750d631801d296$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;




function $7c4e0616915ca3a0$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $89ab6b9e702438b4$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $89ab6b9e702438b4$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $9a7e913a82f46e5c$export$35e57303dbd8a66 = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
function $9a7e913a82f46e5c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $9a7e913a82f46e5c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $9a7e913a82f46e5c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $9a7e913a82f46e5c$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$9a7e913a82f46e5c$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $9a7e913a82f46e5c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $9a7e913a82f46e5c$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $9a7e913a82f46e5c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9a7e913a82f46e5c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $89ab6b9e702438b4$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $6b750d631801d296$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9a7e913a82f46e5c$var$defaultOverridesResolver($9a7e913a82f46e5c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $9a7e913a82f46e5c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9a7e913a82f46e5c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $89ab6b9e702438b4$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === 'function' && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $9a7e913a82f46e5c$var$processStyle(props, style);
            };
            if ((0, $ab54d737c452cabc$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $7c4e0616915ca3a0$export$2e2bcd8739ae039)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $9a7e913a82f46e5c$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $9a7e913a82f46e5c$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $9a7e913a82f46e5c$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $6b750d631801d296$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $9a7e913a82f46e5c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $20407562937ae76e$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $5210edc31c9006df$export$2e2bcd8739ae039)(tag)})`;
}
function $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $9a7e913a82f46e5c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9a7e913a82f46e5c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9a7e913a82f46e5c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}




var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $bc51abfce30b7e59$export$6cb188bdacb35d0e(slot) {
    return (0, $4Cod0.default)('MuiPickersFilledInput', slot);
}
const $bc51abfce30b7e59$export$3964d3188824d772 = (0, $8nd05.default)({}, (0, $76e7d735dfe68a88$export$f20b5ba262568322), (0, $beCSm.default)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));





var $ayMG0 = parcelRequire("ayMG0");
const $487d12cb311e9418$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $487d12cb311e9418$var$PickersFilledInputRoot = (0, $d8seH.default)((0, $b07bd25b455bc147$export$ddc18880178d980e), {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $bc51abfce30b7e59$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $bc51abfce30b7e59$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $bc51abfce30b7e59$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $bc51abfce30b7e59$export$3964d3188824d772).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $bc51abfce30b7e59$export$3964d3188824d772).disabled}, .${(0, $bc51abfce30b7e59$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $bc51abfce30b7e59$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: ({ startAdornment: startAdornment })=>!!startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ endAdornment: endAdornment })=>!!endAdornment,
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $487d12cb311e9418$var$PickersFilledSectionsContainer = (0, $d8seH.default)((0, $b07bd25b455bc147$export$52f3fbbfe9321824), {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                size: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: ({ startAdornment: startAdornment })=>!!startAdornment,
            style: {
                paddingLeft: 0
            }
        },
        {
            props: ({ endAdornment: endAdornment })=>!!endAdornment,
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                size: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $487d12cb311e9418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $bc51abfce30b7e59$export$6cb188bdacb35d0e), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $487d12cb311e9418$export$8cc8c624890b5045 = /*#__PURE__*/ $acw62.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $1En50.default)(props, $487d12cb311e9418$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const ownerState = (0, $8nd05.default)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || 'primary'
    });
    const classes = $487d12cb311e9418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b07bd25b455bc147$export$ff827734ba831074), (0, $8nd05.default)({
        slots: {
            root: $487d12cb311e9418$var$PickersFilledInputRoot,
            input: $487d12cb311e9418$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$487d12cb311e9418$export$8cc8c624890b5045.muiName = 'Input';



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $d8seH = parcelRequire("d8seH");


var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $3cc275b483512649$export$defbb17803ff7cff(slot) {
    return (0, $4Cod0.default)('MuiPickersFilledInput', slot);
}
const $3cc275b483512649$export$f5c5ba079c8bb9dd = (0, $8nd05.default)({}, (0, $76e7d735dfe68a88$export$f20b5ba262568322), (0, $beCSm.default)('MuiPickersInput', [
    'root',
    'input'
]));





var $ayMG0 = parcelRequire("ayMG0");
const $a41ccb38ff41e328$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $a41ccb38ff41e328$var$PickersInputRoot = (0, $d8seH.default)((0, $b07bd25b455bc147$export$ddc18880178d980e), {
    name: 'MuiPickersInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $3cc275b483512649$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $3cc275b483512649$export$f5c5ba079c8bb9dd).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $3cc275b483512649$export$f5c5ba079c8bb9dd).disabled}, .${(0, $3cc275b483512649$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $3cc275b483512649$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const $a41ccb38ff41e328$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $3cc275b483512649$export$defbb17803ff7cff), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $a41ccb38ff41e328$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $acw62.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $1En50.default)(props, $a41ccb38ff41e328$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const ownerState = (0, $8nd05.default)({}, props, ownerStateProp, muiFormControl, {
        disableUnderline: disableUnderline,
        color: muiFormControl?.color || 'primary'
    });
    const classes = $a41ccb38ff41e328$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b07bd25b455bc147$export$ff827734ba831074), (0, $8nd05.default)({
        slots: {
            root: $a41ccb38ff41e328$var$PickersInputRoot
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$a41ccb38ff41e328$export$7c4ebb2cfaf4f474.muiName = 'Input';



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $06628201f2cc4505$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps"
];
const $06628201f2cc4505$var$VARIANT_COMPONENT = {
    standard: (0, $a41ccb38ff41e328$export$7c4ebb2cfaf4f474),
    filled: (0, $487d12cb311e9418$export$8cc8c624890b5045),
    outlined: (0, $20d706e29be2fff2$export$44d4d00edb0c710f)
};
const $06628201f2cc4505$var$PickersTextFieldRoot = (0, $d8seH.default)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
    name: 'MuiPickersTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $06628201f2cc4505$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, classes: classes, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            focused && !disabled && 'focused',
            disabled && 'disabled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3f6e178f64e28835$export$d99678ed7aad1677), classes);
};
const $06628201f2cc4505$export$b3e9b101d92e4d4d = /*#__PURE__*/ $acw62.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, color: color = 'primary', disabled: disabled = false, error: error = false, variant: variant = 'outlined', required: required = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps } = props, other = (0, $1En50.default)(props, $06628201f2cc4505$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const handleRootRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, rootRef);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disabled: disabled,
        error: error,
        focused: focused,
        required: required,
        variant: variant
    });
    const classes = $06628201f2cc4505$var$useUtilityClasses(ownerState);
    const PickersInputComponent = $06628201f2cc4505$var$VARIANT_COMPONENT[variant];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($06628201f2cc4505$var$PickersTextFieldRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: handleRootRef,
        focused: focused,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        variant: variant,
        error: error,
        color: color,
        fullWidth: fullWidth,
        required: required,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), (0, $8nd05.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PickersInputComponent, (0, $8nd05.default)({
                elements: elements,
                areAllSectionsEmpty: areAllSectionsEmpty,
                onClick: onClick,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                onInput: onInput,
                onPaste: onPaste,
                endAdornment: endAdornment,
                startAdornment: startAdornment,
                tabIndex: tabIndex,
                contentEditable: contentEditable,
                value: value,
                onChange: onChange,
                id: id,
                fullWidth: fullWidth,
                inputProps: inputProps,
                inputRef: inputRef,
                sectionListRef: sectionListRef,
                label: label,
                name: name,
                role: "group",
                "aria-labelledby": inputLabelId,
                "aria-describedby": helperTextId,
                "aria-live": helperTextId ? 'polite' : undefined
            }, InputProps)),
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), (0, $8nd05.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");
const $f13c5a2e79bc3202$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $f13c5a2e79bc3202$var$_excluded2 = [
    "InputProps",
    "readOnly"
], $f13c5a2e79bc3202$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef"
];
const $f13c5a2e79bc3202$export$20bf15d9b24b4dad = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $1En50.default)(_ref, $f13c5a2e79bc3202$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly } = fieldResponse, other = (0, $1En50.default)(fieldResponse, $f13c5a2e79bc3202$var$_excluded2);
        return (0, $8nd05.default)({}, other, {
            InputProps: (0, $8nd05.default)({}, InputProps ?? {}, {
                readOnly: readOnly
            })
        });
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef } = fieldResponse, other = (0, $1En50.default)(fieldResponse, $f13c5a2e79bc3202$var$_excluded3);
    return (0, $8nd05.default)({}, other, {
        InputProps: (0, $8nd05.default)({}, InputProps ?? {}, {
            readOnly: readOnly
        }),
        inputProps: (0, $8nd05.default)({}, inputProps ?? {}, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $adf011b558e75019$var$_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $adf011b558e75019$export$d9781c7894a82487 = /*#__PURE__*/ $acw62.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $1En50.default)(themeProps, $adf011b558e75019$var$_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $06628201f2cc4505$export$b3e9b101d92e4d4d) : (0, $d8826083c5af4ea7$export$2e2bcd8739ae039));
    const textFieldProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        additionalProps: {
            ref: inRef
        },
        ownerState: ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $8nd05.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $8nd05.default)({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = (0, $662d5fca10440bd9$export$5591b0b878c1a989)(textFieldProps);
    const convertedFieldResponse = (0, $f13c5a2e79bc3202$export$20bf15d9b24b4dad)(fieldResponse);
    const processedFieldProps = (0, $299e129c3bfab876$export$db9644cdb7e3d432)((0, $8nd05.default)({}, convertedFieldResponse, {
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TextField, (0, $8nd05.default)({}, processedFieldProps));
});


parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


'use client';
const $9937e1a8ba43913d$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $28cc3a450bd9076f$export$4b5a24245de9f7f9)();
    return $acw62.useCallback((day)=>(0, $8fe304ca4ba155e2$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





'use client';
const $3bbdedfd37de0fee$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $8nd05.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (utils.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = utils.setTimezone(state.currentMonth, newTimezone);
                    if (utils.getMonth(newCurrentMonth) !== utils.getMonth(state.currentMonth)) newCurrentMonth = utils.setMonth(newCurrentMonth, utils.getMonth(state.currentMonth));
                    return (0, $8nd05.default)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, $8nd05.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $8nd05.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const $3bbdedfd37de0fee$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const reducerFn = $acw62.useRef($3bbdedfd37de0fee$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $acw62.useMemo(()=>{
        return (0, $14acbf5609fff29c$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $acw62.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $acw62.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: utils.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        utils
    ]);
    const handleChangeMonth = $acw62.useCallback((payload)=>{
        dispatch((0, $8nd05.default)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $acw62.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $9937e1a8ba43913d$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $acw62.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");



var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
const $c995ebd7b0d30b08$export$5b0bb0174eb448ca = (slot)=>(0, $4Cod0.default)('MuiPickersFadeTransitionGroup', slot);
const $c995ebd7b0d30b08$export$1461f245817ac559 = (0, $beCSm.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $adf9960a2516beaf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c995ebd7b0d30b08$export$5b0bb0174eb448ca), classes);
};
const $adf9960a2516beaf$var$PickersFadeTransitionGroupRoot = (0, $d8seH.default)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function $adf9960a2516beaf$export$5262185daf493fee(inProps) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $adf9960a2516beaf$var$useUtilityClasses(props);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($adf9960a2516beaf$var$PickersFadeTransitionGroupRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");





var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $ef80a26abd5cc14c$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $ef80a26abd5cc14c$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $ef80a26abd5cc14c$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $ef80a26abd5cc14c$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $ef80a26abd5cc14c$export$677b39864803984e($ef80a26abd5cc14c$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $ef80a26abd5cc14c$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $ef80a26abd5cc14c$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $ef80a26abd5cc14c$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $ef80a26abd5cc14c$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $ef80a26abd5cc14c$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $ef80a26abd5cc14c$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$ef80a26abd5cc14c$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $ef80a26abd5cc14c$export$29fb7152bd3f781a(color) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $ef80a26abd5cc14c$export$c852d90bf7403b62(color) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $ef80a26abd5cc14c$export$677b39864803984e($ef80a26abd5cc14c$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $ef80a26abd5cc14c$export$d061e26956a60b0a(foreground, background) {
    const lumA = $ef80a26abd5cc14c$export$c852d90bf7403b62(foreground);
    const lumB = $ef80a26abd5cc14c$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $ef80a26abd5cc14c$export$58f0f39f63f3cf42(color, value) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    value = $ef80a26abd5cc14c$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $ef80a26abd5cc14c$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    coefficient = $ef80a26abd5cc14c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient) {
    color = $ef80a26abd5cc14c$export$677b39864803984e(color);
    coefficient = $ef80a26abd5cc14c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4(color);
}
function $ef80a26abd5cc14c$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $ef80a26abd5cc14c$export$c852d90bf7403b62(color) > 0.5 ? $ef80a26abd5cc14c$export$4b073707ff63303(color, coefficient) : $ef80a26abd5cc14c$export$c0816ed86df316af(color, coefficient);
}
function $ef80a26abd5cc14c$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $ef80a26abd5cc14c$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $ef80a26abd5cc14c$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $ef80a26abd5cc14c$export$677b39864803984e(background);
    const overlayColor = $ef80a26abd5cc14c$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $ef80a26abd5cc14c$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


var $d8seH = parcelRequire("d8seH");



var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $8208f360828d6fb0$export$4b25deb0350d3e53(slot) {
    return (0, $4Cod0.default)('MuiPickersDay', slot);
}
const $8208f360828d6fb0$export$68b221ad3c35e288 = (0, $beCSm.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a215abe4b2054e88$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $a215abe4b2054e88$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            selected && !isHiddenDaySpacingFiller && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8208f360828d6fb0$export$4b25deb0350d3e53), classes);
};
const $a215abe4b2054e88$var$styleArg = ({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.caption, {
        width: (0, $6a907094a8780175$export$3f0060ce4cc8f4d0),
        height: (0, $6a907094a8780175$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $8208f360828d6fb0$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $8208f360828d6fb0$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $8208f360828d6fb0$export$68b221ad3c35e288).disabled}:not(.${(0, $8208f360828d6fb0$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $8208f360828d6fb0$export$68b221ad3c35e288).disabled}&.${(0, $8208f360828d6fb0$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, $6a907094a8780175$export$dde58b009b497666)}px`
                }
            },
            {
                props: {
                    outsideCurrentMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    today: true
                },
                style: {
                    [`&:not(.${(0, $8208f360828d6fb0$export$68b221ad3c35e288).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $a215abe4b2054e88$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $a215abe4b2054e88$var$PickersDayRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a215abe4b2054e88$var$overridesResolver
})($a215abe4b2054e88$var$styleArg);
const $a215abe4b2054e88$var$PickersDayFiller = (0, $d8seH.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a215abe4b2054e88$var$overridesResolver
})(({ theme: theme })=>(0, $8nd05.default)({}, $a215abe4b2054e88$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $a215abe4b2054e88$var$noop = ()=>{};
const $a215abe4b2054e88$var$PickersDayRaw = /*#__PURE__*/ $acw62.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $a215abe4b2054e88$var$noop, onBlur: onBlur = $a215abe4b2054e88$var$noop, onKeyDown: onKeyDown = $a215abe4b2054e88$var$noop, onMouseDown: onMouseDown = $a215abe4b2054e88$var$noop, onMouseEnter: onMouseEnter = $a215abe4b2054e88$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $1En50.default)(props, $a215abe4b2054e88$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $a215abe4b2054e88$var$useUtilityClasses(ownerState);
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const ref = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $ayMG0.jsx)($a215abe4b2054e88$var$PickersDayFiller, {
        className: (0, $9QePP.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a215abe4b2054e88$var$PickersDayRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $a215abe4b2054e88$export$d7378e6e864346fa = /*#__PURE__*/ $acw62.memo($a215abe4b2054e88$var$PickersDayRaw);






var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $acw62 = parcelRequire("acw62");



var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $1En50.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0fef977f04119bf5$export$2e2bcd8739ae039), (0, $8nd05.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ''
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;



var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
const $c7e4576059c0fe7a$export$e98c1b6c3bbc3c59 = (slot)=>(0, $4Cod0.default)('MuiPickersSlideTransition', slot);
const $c7e4576059c0fe7a$export$d251a58673156a67 = (0, $beCSm.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $29082a754ce64855$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $29082a754ce64855$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c7e4576059c0fe7a$export$e98c1b6c3bbc3c59), classes);
};
const $29082a754ce64855$var$PickersSlideTransitionRoot = (0, $d8seH.default)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $c7e4576059c0fe7a$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $c7e4576059c0fe7a$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $c7e4576059c0fe7a$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $c7e4576059c0fe7a$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $c7e4576059c0fe7a$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $29082a754ce64855$export$e868fcc7557d3a06(inProps) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $1En50.default)(props, $29082a754ce64855$var$_excluded);
    const classes = $29082a754ce64855$var$useUtilityClasses(props);
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($29082a754ce64855$var$PickersSlideTransitionRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $acw62.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee2e736fe07a2c40$export$2e2bcd8739ae039), (0, $8nd05.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
const $01255dca2f143194$export$fbe827982a69894a = (slot)=>(0, $4Cod0.default)('MuiDayCalendar', slot);
const $01255dca2f143194$export$b3f91ee59da1294a = (0, $beCSm.default)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $2d7eb168b763dabb$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $2d7eb168b763dabb$var$_excluded2 = [
    "ownerState"
];
const $2d7eb168b763dabb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $01255dca2f143194$export$fbe827982a69894a), classes);
};
const $2d7eb168b763dabb$var$weeksContainerHeight = ((0, $6a907094a8780175$export$3f0060ce4cc8f4d0) + (0, $6a907094a8780175$export$dde58b009b497666) * 2) * 6;
const $2d7eb168b763dabb$var$PickersCalendarDayRoot = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $2d7eb168b763dabb$var$PickersCalendarDayHeader = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $2d7eb168b763dabb$var$PickersCalendarWeekDayLabel = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $2d7eb168b763dabb$var$PickersCalendarWeekNumberLabel = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel',
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.disabled
    }));
const $2d7eb168b763dabb$var$PickersCalendarWeekNumber = (0, $d8seH.default)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber',
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.caption, {
        width: (0, $6a907094a8780175$export$3f0060ce4cc8f4d0),
        height: (0, $6a907094a8780175$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $6a907094a8780175$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $2d7eb168b763dabb$var$PickersCalendarLoadingContainer = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $2d7eb168b763dabb$var$weeksContainerHeight
});
const $2d7eb168b763dabb$var$PickersCalendarSlideTransition = (0, $d8seH.default)((0, $29082a754ce64855$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $2d7eb168b763dabb$var$weeksContainerHeight
});
const $2d7eb168b763dabb$var$PickersCalendarWeekContainer = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const $2d7eb168b763dabb$var$PickersCalendarWeek = (0, $d8seH.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $6a907094a8780175$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $2d7eb168b763dabb$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $1En50.default)(_ref, $2d7eb168b763dabb$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const now = (0, $28cc3a450bd9076f$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = slots?.day ?? (0, $a215abe4b2054e88$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $8nd05.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $8nd05.default)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $1En50.default)(_useSlotProps, $2d7eb168b763dabb$var$_excluded2);
    const isDisabled = $acw62.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $acw62.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $acw62.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $acw62.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Day, (0, $8nd05.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $2d7eb168b763dabb$export$8fb56b32a5df6314(inProps) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>utils.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $28cc3a450bd9076f$export$3a404aece3dff2fa)(timezone);
    const classes = $2d7eb168b763dabb$var$useUtilityClasses(props);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const isDateDisabled = (0, $9937e1a8ba43913d$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const [internalHasFocus, setInternalHasFocus] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'DayCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $acw62.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange?.(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $095e4de7afe66795$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $095e4de7afe66795$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const currentYearNumber = utils.getYear(currentMonth);
    const validSelectedDays = $acw62.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $acw62.useMemo(()=>/*#__PURE__*/ $acw62.createRef(), [
        transitionKey
    ]);
    const focusableDay = $acw62.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $095e4de7afe66795$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $acw62.useMemo(()=>{
        const toDisplay = utils.getWeekArray(currentMonth);
        let nextMonth = utils.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $095e4de7afe66795$export$24c38139da66592d)(utils, now).map((weekday, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarSlideTransition, (0, $8nd05.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $9QePP.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($2d7eb168b763dabb$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2d7eb168b763dabb$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");


var $8Indx = parcelRequire("8Indx");


var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $83878f0e3dc1e802$export$db90a620ac957a73(slot) {
    return (0, $4Cod0.default)('MuiPickersMonth', slot);
}
const $83878f0e3dc1e802$export$911e3973fa70a12b = (0, $beCSm.default)('MuiPickersMonth', [
    'root',
    'monthButton',
    'disabled',
    'selected'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $4945e1e306315197$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow",
    "slots",
    "slotProps"
];
const $4945e1e306315197$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        monthButton: [
            'monthButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $83878f0e3dc1e802$export$db90a620ac957a73), classes);
};
const $4945e1e306315197$var$PickersMonthRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '33.3%',
    variants: [
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                flexBasis: '25%'
            }
        }
    ]
});
const $4945e1e306315197$var$MonthCalendarButton = (0, $d8seH.default)('button', {
    name: 'MuiPickersMonth',
    slot: 'MonthButton',
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $83878f0e3dc1e802$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $83878f0e3dc1e802$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $8nd05.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $83878f0e3dc1e802$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $83878f0e3dc1e802$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $4945e1e306315197$export$bc52fdb7f02f591a = /*#__PURE__*/ $acw62.memo(function PickersMonth(inProps) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersMonth'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent, 'aria-label': ariaLabel, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $4945e1e306315197$var$_excluded);
    const ref = $acw62.useRef(null);
    const classes = $4945e1e306315197$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $4945e1e306315197$var$MonthCalendarButton;
    const monthButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-current': ariaCurrent,
            'aria-checked': selected,
            'aria-label': ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.monthButton
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4945e1e306315197$var$PickersMonthRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(MonthButton, (0, $8nd05.default)({}, monthButtonProps))
    }));
});




var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $068ca5e81320aff6$export$da0c97315339ebd9(slot) {
    return (0, $4Cod0.default)('MuiMonthCalendar', slot);
}
const $068ca5e81320aff6$export$edf77d5566c7007c = (0, $beCSm.default)('MuiMonthCalendar', [
    'root'
]);








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5397f01707da67a7$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $5397f01707da67a7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $068ca5e81320aff6$export$da0c97315339ebd9), classes);
};
function $5397f01707da67a7$export$5b6e066572408095(props, name) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const defaultDates = (0, $28cc3a450bd9076f$export$7c38da3a2e90fa83)();
    const themeProps = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $8nd05.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $5397f01707da67a7$var$MonthCalendarRoot = (0, $d8seH.default)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    padding: '0 4px',
    width: (0, $6a907094a8780175$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: 'border-box'
});
const $5397f01707da67a7$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $acw62.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $5397f01707da67a7$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $5397f01707da67a7$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $61302b639d1ef7ad$export$174d749f3b4c0f49)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $14acbf5609fff29c$export$2764b246aa3b75ba)
    });
    const now = (0, $28cc3a450bd9076f$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const referenceDate = $acw62.useMemo(()=>(0, $14acbf5609fff29c$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $5397f01707da67a7$var$useUtilityClasses(ownerState);
    const todayMonth = $acw62.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $acw62.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedMonth, setFocusedMonth] = $acw62.useState(()=>selectedMonth || utils.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $acw62.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $acw62.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5397f01707da67a7$var$MonthCalendarRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $095e4de7afe66795$export$62591b96a734eacd)(utils, value ?? referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const monthLabel = utils.format(month, 'month');
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4945e1e306315197$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? 'date' : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: monthText
            }, monthText);
        })
    }));
});



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");


var $8Indx = parcelRequire("8Indx");


var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $9811e48ad81f53d5$export$183c9f339a61cd79(slot) {
    return (0, $4Cod0.default)('MuiPickersYear', slot);
}
const $9811e48ad81f53d5$export$4ef58a3d9c6f4296 = (0, $beCSm.default)('MuiPickersYear', [
    'root',
    'yearButton',
    'selected',
    'disabled'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $b3746a807be6b3ad$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow",
    "slots",
    "slotProps"
];
const $b3746a807be6b3ad$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9811e48ad81f53d5$export$183c9f339a61cd79), classes);
};
const $b3746a807be6b3ad$var$PickersYearRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: '33.3%',
    variants: [
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                flexBasis: '25%'
            }
        }
    ]
});
const $b3746a807be6b3ad$var$YearCalendarButton = (0, $d8seH.default)('button', {
    name: 'MuiPickersYear',
    slot: 'YearButton',
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $9811e48ad81f53d5$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $9811e48ad81f53d5$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $8nd05.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '6px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $9811e48ad81f53d5$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $9811e48ad81f53d5$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $b3746a807be6b3ad$export$261f3fbd5fd5814d = /*#__PURE__*/ $acw62.memo(function PickersYear(inProps) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersYear'
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, 'aria-current': ariaCurrent, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $b3746a807be6b3ad$var$_excluded);
    const ref = $acw62.useRef(null);
    const classes = $b3746a807be6b3ad$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $b3746a807be6b3ad$var$YearCalendarButton;
    const yearButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-current': ariaCurrent,
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.yearButton
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b3746a807be6b3ad$var$PickersYearRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(YearButton, (0, $8nd05.default)({}, yearButtonProps))
    }));
});




var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $5765652a82ee3360$export$4477acc520094dec(slot) {
    return (0, $4Cod0.default)('MuiYearCalendar', slot);
}
const $5765652a82ee3360$export$e42d427cd9fe5fd7 = (0, $beCSm.default)('MuiYearCalendar', [
    'root'
]);








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d55f68b977aee64$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $0d55f68b977aee64$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5765652a82ee3360$export$4477acc520094dec), classes);
};
function $0d55f68b977aee64$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const defaultDates = (0, $28cc3a450bd9076f$export$7c38da3a2e90fa83)();
    const themeProps = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $8nd05.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        minDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $0d55f68b977aee64$var$YearCalendarRoot = (0, $d8seH.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    width: (0, $6a907094a8780175$export$ee46b8a74d6c94d3),
    maxHeight: (0, $6a907094a8780175$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative'
});
const $0d55f68b977aee64$export$657f9200591b2b71 = /*#__PURE__*/ $acw62.forwardRef(function YearCalendar(inProps, ref) {
    const props = $0d55f68b977aee64$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder = 'asc', yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $1En50.default)(props, $0d55f68b977aee64$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $61302b639d1ef7ad$export$174d749f3b4c0f49)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $14acbf5609fff29c$export$2764b246aa3b75ba)
    });
    const now = (0, $28cc3a450bd9076f$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const referenceDate = $acw62.useMemo(()=>(0, $14acbf5609fff29c$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $c4f6f2b8fcbb5fe9$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $0d55f68b977aee64$var$useUtilityClasses(ownerState);
    const todayYear = $acw62.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $acw62.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedYear, setFocusedYear] = $acw62.useState(()=>selectedYear || utils.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $acw62.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $acw62.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, scrollerRef);
    $acw62.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = utils.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0d55f68b977aee64$var$YearCalendarRoot, (0, $8nd05.default)({
        ref: handleRef,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: yearRange.map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3746a807be6b3ad$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? 'date' : undefined,
                yearsPerRow: yearsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    }));
});




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $d8seH = parcelRequire("d8seH");


var $8Indx = parcelRequire("8Indx");






var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");



var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");




var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
function $015a7f86ee044f5d$export$cef978c25740de90(slot) {
    return (0, $4Cod0.default)('MuiPickersArrowSwitcher', slot);
}
const $015a7f86ee044f5d$export$f8819209558cd362 = (0, $beCSm.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $8071fd6781eab512$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId"
], $8071fd6781eab512$var$_excluded2 = [
    "ownerState"
], $8071fd6781eab512$var$_excluded3 = [
    "ownerState"
];
const $8071fd6781eab512$var$PickersArrowSwitcherRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $8071fd6781eab512$var$PickersArrowSwitcherSpacer = (0, $d8seH.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $8071fd6781eab512$var$PickersArrowSwitcherButton = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})({
    variants: [
        {
            props: {
                hidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const $8071fd6781eab512$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $015a7f86ee044f5d$export$cef978c25740de90), classes);
};
const $8071fd6781eab512$export$597b7cbdb7b2a24c = /*#__PURE__*/ $acw62.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId } = props, other = (0, $1En50.default)(props, $8071fd6781eab512$var$_excluded);
    const ownerState = props;
    const classes = $8071fd6781eab512$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $8071fd6781eab512$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $8nd05.default)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: (0, $9QePP.default)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $8071fd6781eab512$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $8nd05.default)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: (0, $9QePP.default)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, $15f780f59fa32b0f$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $1En50.default)(_useSlotProps, $8071fd6781eab512$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, $15f780f59fa32b0f$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $1En50.default)(_useSlotProps2, $8071fd6781eab512$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8071fd6781eab512$var$PickersArrowSwitcherRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousIconButton, (0, $8nd05.default)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $8nd05.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $8nd05.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($8071fd6781eab512$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextIconButton, (0, $8nd05.default)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $8nd05.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $8nd05.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $acw62 = parcelRequire("acw62");


function $f797697c3611afd3$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    return $acw62.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $f797697c3611afd3$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    return $acw62.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $f797697c3611afd3$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const meridiemMode = (0, $9359fccca2daa962$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $acw62.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $9359fccca2daa962$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
const $16f6df38d2155e06$export$457ac4d3a1ad92b4 = (slot)=>(0, $4Cod0.default)('MuiPickersCalendarHeader', slot);
const $16f6df38d2155e06$export$63db7afb9247cb91 = (0, $beCSm.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $692e54af110ba23d$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone",
    "format"
], $692e54af110ba23d$var$_excluded2 = [
    "ownerState"
];
const $692e54af110ba23d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $16f6df38d2155e06$export$457ac4d3a1ad92b4), classes);
};
const $692e54af110ba23d$var$PickersCalendarHeaderRoot = (0, $d8seH.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $692e54af110ba23d$var$PickersCalendarHeaderLabelContainer = (0, $d8seH.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $8nd05.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $692e54af110ba23d$var$PickersCalendarHeaderLabel = (0, $d8seH.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewButton = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${(0, $16f6df38d2155e06$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewIcon = (0, $d8seH.default)((0, $15f780f59fa32b0f$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $692e54af110ba23d$export$6801ffebb353f473 = /*#__PURE__*/ $acw62.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone, format: format = `${utils.formats.month} ${utils.formats.year}` } = props, other = (0, $1En50.default)(props, $692e54af110ba23d$var$_excluded);
    const ownerState = props;
    const classes = $692e54af110ba23d$var$useUtilityClasses(props);
    const SwitchViewButton = slots?.switchViewButton ?? $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $692e54af110ba23d$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $1En50.default)(_useSlotProps, $692e54af110ba23d$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), 'right');
    const isNextMonthDisabled = (0, $f797697c3611afd3$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $f797697c3611afd3$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = utils.formatByString(month, format);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($692e54af110ba23d$var$PickersCalendarHeaderRoot, (0, $8nd05.default)({}, other, {
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($692e54af110ba23d$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adf9960a2516beaf$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($692e54af110ba23d$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewButton, (0, $8nd05.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewIcon, (0, $8nd05.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8071fd6781eab512$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});




var $d8seH = parcelRequire("d8seH");

const $bdb2915bd58d0724$export$512b066b8abdfde4 = (0, $d8seH.default)('div')({
    overflow: 'hidden',
    width: (0, $6a907094a8780175$export$ee46b8a74d6c94d3),
    maxHeight: (0, $6a907094a8780175$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});




var $4Cod0 = parcelRequire("4Cod0");
var $beCSm = parcelRequire("beCSm");
const $a47758ea7aed0899$export$da8c2318897a6672 = (slot)=>(0, $4Cod0.default)('MuiDateCalendar', slot);
const $a47758ea7aed0899$export$d0237e2bb9598e8d = (0, $beCSm.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c041198f38a260e6$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $c041198f38a260e6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a47758ea7aed0899$export$da8c2318897a6672), classes);
};
function $c041198f38a260e6$var$useDateCalendarDefaultizedProps(props, name) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const defaultDates = (0, $28cc3a450bd9076f$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $e6d9e0a2a52efb89$export$ce40fb97be7f02d9)();
    const themeProps = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    return (0, $8nd05.default)({}, themeProps, {
        loading: themeProps.loading ?? false,
        disablePast: themeProps.disablePast ?? false,
        disableFuture: themeProps.disableFuture ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "..."
            })),
        minDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $095e4de7afe66795$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $c041198f38a260e6$var$DateCalendarRoot = (0, $d8seH.default)((0, $bdb2915bd58d0724$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, $6a907094a8780175$export$f2fef360e2df0cb7)
});
const $c041198f38a260e6$var$DateCalendarViewTransitionContainer = (0, $d8seH.default)((0, $adf9960a2516beaf$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $c041198f38a260e6$export$68078fe5d2bf8909 = /*#__PURE__*/ $acw62.forwardRef(function DateCalendar(inProps, ref) {
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const props = $c041198f38a260e6$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $1En50.default)(props, $c041198f38a260e6$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $61302b639d1ef7ad$export$174d749f3b4c0f49)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $14acbf5609fff29c$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $255f841782d21111$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $3bbdedfd37de0fee$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, $692e54af110ba23d$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $095e4de7afe66795$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onMonthChange?.(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $095e4de7afe66795$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            onYearChange?.(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $095e4de7afe66795$export$a98b123b8f29e004)(utils, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $acw62.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $c041198f38a260e6$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $acw62.useRef(view);
    $acw62.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $acw62.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c041198f38a260e6$var$DateCalendarRoot, (0, $8nd05.default)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(CalendarHeader, (0, $8nd05.default)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c041198f38a260e6$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d55f68b977aee64$export$657f9200591b2b71), (0, $8nd05.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5397f01707da67a7$export$d7a7c85c0f5afc4a), (0, $8nd05.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d7eb168b763dabb$export$8fb56b32a5df6314), (0, $8nd05.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $ayMG0 = parcelRequire("ayMG0");
const $62f723267dd87cd0$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $c041198f38a260e6$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $095e4de7afe66795$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $095e4de7afe66795$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });




'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $2d21d409b144aa2b$export$5a73641f0156e1e4 = /*#__PURE__*/ $acw62.forwardRef(function DesktopDatePicker(inProps, ref) {
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $cff128f6b922ac60$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $8nd05.default)({
        day: (0, $62f723267dd87cd0$export$69888ffe06193e5e),
        month: (0, $62f723267dd87cd0$export$69888ffe06193e5e),
        year: (0, $62f723267dd87cd0$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $8nd05.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $095e4de7afe66795$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: (0, $8nd05.default)({
            openPickerIcon: (0, $15f780f59fa32b0f$export$5fda1783bb83f57b),
            field: (0, $adf011b558e75019$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $8nd05.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $8nd05.default)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $4be2a81b5d2111e4$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $8nd05.default)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $4843bf1c616982ea$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $14acbf5609fff29c$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (0, $c07a80e9c07fbe5a$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: 'fullDate',
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $8fe304ca4ba155e2$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$2d21d409b144aa2b$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ])
};



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $8nd05 = parcelRequire("8nd05");
parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $beCSm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $beCSm.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4fa8e9c420cdee0a$var$_excluded = [
    "className",
    "dividers"
];
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c877f2cebcabf5cb$export$61b0ee1f05fb344e), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $f2e7257b2514744a$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $1En50.default)(props, $4fa8e9c420cdee0a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        dividers: dividers
    });
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");




var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $beCSm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4f13784bd714c44e$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $4838e5a14e330013$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c5762e789acf7dcc$export$2177af0aa15c34c2), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $4f13784bd714c44e$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $4f13784bd714c44e$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $8nd05.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogContainer, {
                className: (0, $9QePP.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($4f13784bd714c44e$var$DialogPaper, (0, $8nd05.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $9QePP.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68187f174395cd28$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;



var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");
const $b379d9b00a13e481$var$PickersModalDialogRoot = (0, $d8seH.default)((0, $4f13784bd714c44e$export$2e2bcd8739ae039))({
    [`& .${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $c5762e789acf7dcc$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $6a907094a8780175$export$ee46b8a74d6c94d3)
    }
});
const $b379d9b00a13e481$var$PickersModalDialogContent = (0, $d8seH.default)((0, $4fa8e9c420cdee0a$export$2e2bcd8739ae039))({
    '&:first-of-type': {
        padding: 0
    }
});
function $b379d9b00a13e481$export$99f83c99e1491f77(props) {
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = slots?.dialog ?? $b379d9b00a13e481$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, $5e5a92158e7d9bd4$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Dialog, (0, $8nd05.default)({
        open: open,
        onClose: onDismiss
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($b379d9b00a13e481$var$PickersModalDialogContent, {
            children: children
        })
    }));
}







var $ayMG0 = parcelRequire("ayMG0");
const $536c4c4d895120f2$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $536c4c4d895120f2$export$5ca0153a626a7dd7 = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $1En50.default)(_ref, $536c4c4d895120f2$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const fieldRef = $acw62.useRef(null);
    const labelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $72bb1f98949e4fd5$export$fc3313977ac596c4)((0, $8nd05.default)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: 'mobile'
    }));
    const Field = slots.field;
    const fieldProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $8nd05.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $f4ceb023c3ba7bf1$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly ?? true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $8nd05.default)({}, fieldProps.inputProps, {
        'aria-label': getOpenDialogAriaText(pickerFieldProps.value)
    });
    const slotsForField = (0, $8nd05.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $8f5b3a99831a0c63$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $8nd05.default)({}, innerSlotProps, {
        toolbar: (0, $8nd05.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $8nd05.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const handleFieldRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e40f57ef1b045895$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(Field, (0, $8nd05.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b379d9b00a13e481$export$99f83c99e1491f77), (0, $8nd05.default)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $8nd05.default)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};











'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $6ed5c3a439a123a2$export$97b476d7a92fee62 = /*#__PURE__*/ $acw62.forwardRef(function MobileDatePicker(inProps, ref) {
    const translations = (0, $b25b9764519b3af1$export$3cdcc56057891b44)();
    const utils = (0, $28cc3a450bd9076f$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $cff128f6b922ac60$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $8nd05.default)({
        day: (0, $62f723267dd87cd0$export$69888ffe06193e5e),
        month: (0, $62f723267dd87cd0$export$69888ffe06193e5e),
        year: (0, $62f723267dd87cd0$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $8nd05.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $095e4de7afe66795$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $8nd05.default)({
            field: (0, $adf011b558e75019$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $8nd05.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $8nd05.default)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $4be2a81b5d2111e4$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $8nd05.default)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $536c4c4d895120f2$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $14acbf5609fff29c$export$2764b246aa3b75ba),
        valueType: 'date',
        getOpenDialogAriaText: (0, $c07a80e9c07fbe5a$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: 'fullDate',
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $8fe304ca4ba155e2$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$6ed5c3a439a123a2$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'landscape',
        'portrait'
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ])
};




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5a464a2169acb6c$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $d5a464a2169acb6c$export$5109c6dd95d8fb00 = /*#__PURE__*/ $acw62.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $f4ceb023c3ba7bf1$export$9ae5b19305db48ce) } = props, other = (0, $1En50.default)(props, $d5a464a2169acb6c$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $0c8dae23e679323d$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d21d409b144aa2b$export$5a73641f0156e1e4), (0, $8nd05.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ed5c3a439a123a2$export$97b476d7a92fee62), (0, $8nd05.default)({
        ref: ref
    }, other));
});



var $8nd05 = parcelRequire("8nd05");

var $8e2e75cb547a7c44$exports = {};
!function(e, t) {
    $8e2e75cb547a7c44$exports = t();
}($8e2e75cb547a7c44$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $fcd8f60277f7fcfe$exports = {};
!function(e, t) {
    $fcd8f60277f7fcfe$exports = t();
}($fcd8f60277f7fcfe$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $02ae54ff18ff7cf5$exports = {};
!function(e, t) {
    $02ae54ff18ff7cf5$exports = t();
}($02ae54ff18ff7cf5$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $4e06fd583db725ab$exports = {};
!function(e, i) {
    $4e06fd583db725ab$exports = i();
}($4e06fd583db725ab$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


var $aff2d2459653663f$exports = {};
!function(e, t) {
    $aff2d2459653663f$exports = t();
}($aff2d2459653663f$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});



(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($02ae54ff18ff7cf5$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($8e2e75cb547a7c44$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4e06fd583db725ab$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($aff2d2459653663f$exports))));
const $9231773518718bc3$var$formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    DD: 'day',
    Do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    d: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 2
    },
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $9231773518718bc3$var$defaultFormats = {
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    dayOfMonth: 'D',
    dayOfMonthFull: 'Do',
    weekday: 'dddd',
    weekdayShort: 'dd',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'A',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'll',
    keyboardDate: 'L',
    shortDate: 'MMM D',
    normalDate: 'D MMMM',
    normalDateWithWeekday: 'ddd, MMM D',
    fullTime: 'LT',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    keyboardDateTime: 'L LT',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
const $9231773518718bc3$var$MISSING_UTC_PLUGIN = [
    'Missing UTC plugin',
    'To be able to use UTC or timezones, you have to enable the `utc` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc'
].join('\n');
const $9231773518718bc3$var$MISSING_TIMEZONE_PLUGIN = [
    'Missing timezone plugin',
    'To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone'
].join('\n');
const $9231773518718bc3$var$withLocale = (dayjs, locale)=>!locale ? dayjs : (...args)=>dayjs(...args).locale(locale);
class $9231773518718bc3$export$33545c6a80bae043 {
    constructor({ locale: _locale, formats: formats } = {}){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = 'dayjs';
        this.dayjs = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: '[',
            end: ']'
        };
        this.formatTokenMap = $9231773518718bc3$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale()) return value;
            return value.locale(expectedLocale);
        };
        this.hasUTCPlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).utc !== 'undefined';
        this.hasTimezonePlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz !== 'undefined';
        this.isSame = (value, comparing, comparisonTemplate)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
        };
        /**
     * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
     */ this.cleanTimezone = (timezone)=>{
            switch(timezone){
                case 'default':
                    return undefined;
                case 'system':
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz.guess();
                default:
                    return timezone;
            }
        };
        this.createSystemDate = (value)=>{
            if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
                const timezone = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz.guess();
                // We can't change the system timezone in the tests
                /* istanbul ignore next */ if (timezone !== 'UTC') return (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz(value, timezone);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value);
        };
        this.createUTCDate = (value)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($9231773518718bc3$var$MISSING_UTC_PLUGIN);
            return (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).utc(value);
        };
        this.createTZDate = (value, timezone)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($9231773518718bc3$var$MISSING_UTC_PLUGIN);
            /* istanbul ignore next */ if (!this.hasTimezonePlugin()) throw new Error($9231773518718bc3$var$MISSING_TIMEZONE_PLUGIN);
            const keepLocalTime = value !== undefined && !value.endsWith('Z');
            return (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value).tz(this.cleanTimezone(timezone), keepLocalTime);
        };
        this.getLocaleFormats = ()=>{
            const locales = (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).Ls;
            const locale = this.locale || 'en';
            let localeObject = locales[locale];
            if (localeObject === undefined) localeObject = locales.en;
            return localeObject.formats;
        };
        /**
     * If the new day does not have the same offset as the old one (when switching to summer day time for example),
     * Then dayjs will not automatically adjust the offset (moment does).
     * We have to parse again the value to make sure the `fixOffset` method is applied.
     * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
     */ this.adjustOffset = (value)=>{
            if (!this.hasTimezonePlugin()) return value;
            const timezone = this.getTimezone(value);
            if (timezone !== 'UTC') {
                const fixedValue = value.tz(this.cleanTimezone(timezone), true);
                // TODO: Simplify the case when we raise the `dayjs` peer dep to 1.11.12 (https://github.com/iamkun/dayjs/releases/tag/v1.11.12)
                /* istanbul ignore next */ // @ts-ignore
                if (fixedValue.$offset === (value.$offset ?? 0)) return value;
                // Change only what is needed to avoid creating a new object with unwanted data
                // Especially important when used in an environment where utc or timezone dates are used only in some places
                // Reference: https://github.com/mui/mui-x/issues/13290
                // @ts-ignore
                value.$offset = fixedValue.$offset;
            }
            return value;
        };
        this.date = (value, timezone = 'default')=>{
            if (value === null) return null;
            let parsedValue;
            if (timezone === 'UTC') parsedValue = this.createUTCDate(value);
            else if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) parsedValue = this.createSystemDate(value);
            else parsedValue = this.createTZDate(value, timezone);
            if (this.locale === undefined) return parsedValue;
            return parsedValue.locale(this.locale);
        };
        this.getInvalidDate = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(new Date('Invalid date'));
        this.getTimezone = (value)=>{
            if (this.hasTimezonePlugin()) {
                // @ts-ignore
                const zone = value.$x?.$timezone;
                if (zone) return zone;
            }
            if (this.hasUTCPlugin() && value.isUTC()) return 'UTC';
            return 'system';
        };
        this.setTimezone = (value, timezone)=>{
            if (this.getTimezone(value) === timezone) return value;
            if (timezone === 'UTC') {
                /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($9231773518718bc3$var$MISSING_UTC_PLUGIN);
                return value.utc();
            }
            // We know that we have the UTC plugin.
            // Otherwise, the value timezone would always equal "system".
            // And it would be caught by the first "if" of this method.
            if (timezone === 'system') return value.local();
            if (!this.hasTimezonePlugin()) {
                if (timezone === 'default') return value;
                /* istanbul ignore next */ throw new Error($9231773518718bc3$var$MISSING_TIMEZONE_PLUGIN);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).tz(value, this.cleanTimezone(timezone));
        };
        this.toJsDate = (value)=>{
            return value.toDate();
        };
        this.parse = (value, format)=>{
            if (value === '') return null;
            return this.dayjs(value, format, this.locale, true);
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale || 'en';
        };
        this.is12HourCycleInCurrentLocale = ()=>{
            /* istanbul ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
        };
        this.expandFormat = (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        };
        this.isValid = (value)=>{
            if (value == null) return false;
            return value.isValid();
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return this.dayjs(value).format(formatString);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return value.toDate().getTime() === comparing.toDate().getTime();
        };
        this.isSameYear = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY');
        };
        this.isSameMonth = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM');
        };
        this.isSameDay = (value, comparing)=>{
            return this.isSame(value, comparing, 'YYYY-MM-DD');
        };
        this.isSameHour = (value, comparing)=>{
            return value.isSame(comparing, 'hour');
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
        };
        this.isAfterDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'year');
            return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
        };
        this.isBeforeDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'day');
            return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
        };
        this.isWithinRange = (value, [start, end])=>{
            return value >= start && value <= end;
        };
        this.startOfYear = (value)=>{
            return this.adjustOffset(value.startOf('year'));
        };
        this.startOfMonth = (value)=>{
            return this.adjustOffset(value.startOf('month'));
        };
        this.startOfWeek = (value)=>{
            return this.adjustOffset(this.setLocaleToValue(value).startOf('week'));
        };
        this.startOfDay = (value)=>{
            return this.adjustOffset(value.startOf('day'));
        };
        this.endOfYear = (value)=>{
            return this.adjustOffset(value.endOf('year'));
        };
        this.endOfMonth = (value)=>{
            return this.adjustOffset(value.endOf('month'));
        };
        this.endOfWeek = (value)=>{
            return this.adjustOffset(this.setLocaleToValue(value).endOf('week'));
        };
        this.endOfDay = (value)=>{
            return this.adjustOffset(value.endOf('day'));
        };
        this.addYears = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'year') : value.add(amount, 'year'));
        };
        this.addMonths = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'month') : value.add(amount, 'month'));
        };
        this.addWeeks = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'week') : value.add(amount, 'week'));
        };
        this.addDays = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'day') : value.add(amount, 'day'));
        };
        this.addHours = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'hour') : value.add(amount, 'hour'));
        };
        this.addMinutes = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'minute') : value.add(amount, 'minute'));
        };
        this.addSeconds = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), 'second') : value.add(amount, 'second'));
        };
        this.getYear = (value)=>{
            return value.year();
        };
        this.getMonth = (value)=>{
            return value.month();
        };
        this.getDate = (value)=>{
            return value.date();
        };
        this.getHours = (value)=>{
            return value.hour();
        };
        this.getMinutes = (value)=>{
            return value.minute();
        };
        this.getSeconds = (value)=>{
            return value.second();
        };
        this.getMilliseconds = (value)=>{
            return value.millisecond();
        };
        this.setYear = (value, year)=>{
            return this.adjustOffset(value.set('year', year));
        };
        this.setMonth = (value, month)=>{
            return this.adjustOffset(value.set('month', month));
        };
        this.setDate = (value, date)=>{
            return this.adjustOffset(value.set('date', date));
        };
        this.setHours = (value, hours)=>{
            return this.adjustOffset(value.set('hour', hours));
        };
        this.setMinutes = (value, minutes)=>{
            return this.adjustOffset(value.set('minute', minutes));
        };
        this.setSeconds = (value, seconds)=>{
            return this.adjustOffset(value.set('second', seconds));
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return this.adjustOffset(value.set('millisecond', milliseconds));
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth();
        };
        this.getWeekArray = (value)=>{
            const start = this.startOfWeek(this.startOfMonth(value));
            const end = this.endOfWeek(this.endOfMonth(value));
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current < end){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return value.week();
        };
        this.getYearRange = ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
        this.dayjs = $9231773518718bc3$var$withLocale((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))), _locale);
        this.locale = _locale;
        this.formats = (0, $8nd05.default)({}, $9231773518718bc3$var$defaultFormats, formats);
        // Moved plugins to the constructor to allow for users to use options on the library
        // for reference: https://github.com/mui/mui-x/pull/11151
        (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($fcd8f60277f7fcfe$exports))));
    }
    getDayOfWeek(value) {
        return value.day() + 1;
    }
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $5C8IU = parcelRequire("5C8IU");

var $3z1Ay = parcelRequire("3z1Ay");



var $8NnpI = parcelRequire("8NnpI");

var $g91qR = parcelRequire("g91qR");
const $62f65c9151f4e6ef$var$_excluded = [
    "ownerState"
], $62f65c9151f4e6ef$var$_excluded2 = [
    "variants"
], $62f65c9151f4e6ef$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $62f65c9151f4e6ef$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $62f65c9151f4e6ef$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $62f65c9151f4e6ef$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const $62f65c9151f4e6ef$export$35e57303dbd8a66 = (0, $8NnpI.default)();
const $62f65c9151f4e6ef$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $62f65c9151f4e6ef$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $62f65c9151f4e6ef$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $62f65c9151f4e6ef$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $62f65c9151f4e6ef$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $1En50.default)(_ref, $62f65c9151f4e6ef$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $8nd05.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$62f65c9151f4e6ef$var$processStyleArg(resolvedStyle, (0, $8nd05.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $1En50.default)(resolvedStylesArg, $62f65c9151f4e6ef$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $8nd05.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, $8nd05.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $62f65c9151f4e6ef$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $62f65c9151f4e6ef$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $62f65c9151f4e6ef$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $62f65c9151f4e6ef$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $g91qR.default)((0, $8nd05.default)({}, props, {
            theme: $62f65c9151f4e6ef$var$resolveTheme((0, $8nd05.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $5C8IU.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $62f65c9151f4e6ef$var$defaultOverridesResolver($62f65c9151f4e6ef$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $1En50.default)(inputOptions, $62f65c9151f4e6ef$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $62f65c9151f4e6ef$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($62f65c9151f4e6ef$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5C8IU.default)(tag, (0, $8nd05.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3z1Ay.isPlainObject)(stylesArg)) return (props)=>$62f65c9151f4e6ef$var$processStyleArg(stylesArg, (0, $8nd05.default)({}, props, {
                    theme: $62f65c9151f4e6ef$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $62f65c9151f4e6ef$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $62f65c9151f4e6ef$var$processStyleArg(slotStyle, (0, $8nd05.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $62f65c9151f4e6ef$var$resolveTheme((0, $8nd05.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $62f65c9151f4e6ef$var$processStyleArg({
                    variants: themeVariants
                }, (0, $8nd05.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $10ae0b8a52224565$var$styled = (0, $62f65c9151f4e6ef$export$2e2bcd8739ae039)();
var $10ae0b8a52224565$export$2e2bcd8739ae039 = $10ae0b8a52224565$var$styled;




var $6hiu6 = parcelRequire("6hiu6");

var $8NnpI = parcelRequire("8NnpI");

var $lWAfe = parcelRequire("lWAfe");

var $fbH80 = parcelRequire("fbH80");

var $ayMG0 = parcelRequire("ayMG0");
const $18e20c6a989db8b9$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $18e20c6a989db8b9$var$defaultTheme = (0, $8NnpI.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $18e20c6a989db8b9$var$defaultCreateStyledComponent = (0, $10ae0b8a52224565$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $18e20c6a989db8b9$var$useThemePropsDefault(props) {
    return (0, $568aba12ccdf91ea$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $18e20c6a989db8b9$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $18e20c6a989db8b9$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $18e20c6a989db8b9$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $18e20c6a989db8b9$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $8nd05.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $lWAfe.handleBreakpoints)({
        theme: theme
    }, (0, $lWAfe.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $fbH80.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $lWAfe.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $fbH80.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$18e20c6a989db8b9$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $fbH80.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $lWAfe.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $18e20c6a989db8b9$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $18e20c6a989db8b9$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $18e20c6a989db8b9$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($18e20c6a989db8b9$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $6hiu6.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $1En50.default)(props, $18e20c6a989db8b9$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, (0, $8nd05.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            children: divider ? $18e20c6a989db8b9$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $231d58234d437bc0$var$Stack = (0, $18e20c6a989db8b9$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $7ac564dc7b213020$export$d667a7de734a892c(slot) {
    return (0, $4Cod0.default)('MuiStack', slot);
}
const $7ac564dc7b213020$var$stackClasses = (0, $beCSm.default)('MuiStack', [
    'root'
]);
var $7ac564dc7b213020$export$2e2bcd8739ae039 = $7ac564dc7b213020$var$stackClasses;






var $ayMG0 = parcelRequire("ayMG0");
const $515ce17556e5a613$var$getChildTypeFromChildName = (childName)=>{
    if (childName.match(/^([A-Za-z]+)Range(Calendar|Clock)$/)) return 'multi-panel-UI-view';
    if (childName.match(/^([A-Za-z]*)(DigitalClock)$/)) return 'Tall-UI-view';
    if (childName.match(/^Static([A-Za-z]+)/) || childName.match(/^([A-Za-z]+)(Calendar|Clock)$/)) return 'UI-view';
    if (childName.match(/^MultiInput([A-Za-z]+)RangeField$/) || childName.match(/^([A-Za-z]+)RangePicker$/)) return 'multi-input-range-field';
    if (childName.match(/^SingleInput([A-Za-z]+)RangeField$/)) return 'single-input-range-field';
    return 'single-input-field';
};
const $515ce17556e5a613$var$getSupportedSectionFromChildName = (childName)=>{
    if (childName.includes('DateTime')) return 'date-time';
    if (childName.includes('Date')) return 'date';
    return 'time';
};
function $515ce17556e5a613$export$54b3b8af2fea7f1a(props) {
    const { label: label, children: children, component: component, sx: sxProp } = props;
    let spacing;
    let sx = sxProp;
    if (component && $515ce17556e5a613$var$getChildTypeFromChildName(component) === 'multi-input-range-field') {
        spacing = 1.5;
        sx = (0, $8nd05.default)({}, sx, {
            [`& .${(0, $25a6b464d3ca38da$export$2e2bcd8739ae039).root}`]: {
                flexGrow: 1
            }
        });
    } else spacing = 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
        direction: "column",
        alignItems: "stretch",
        spacing: spacing,
        sx: sx,
        children: [
            label && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                variant: "body2",
                children: label
            }),
            children
        ]
    });
}
$515ce17556e5a613$export$54b3b8af2fea7f1a.displayName = 'DemoItem';
const $515ce17556e5a613$var$isDemoItem = (child)=>{
    if (/*#__PURE__*/ $acw62.isValidElement(child) && typeof child.type !== 'string') // @ts-ignore
    return child.type.displayName === 'DemoItem';
    return false;
};
function $515ce17556e5a613$export$55fa3227aec3be26(props) {
    const { children: children, components: components, sx: sxProp } = props;
    const childrenTypes = new Set();
    const childrenSupportedSections = new Set();
    components.forEach((childName)=>{
        childrenTypes.add($515ce17556e5a613$var$getChildTypeFromChildName(childName));
        childrenSupportedSections.add($515ce17556e5a613$var$getSupportedSectionFromChildName(childName));
    });
    const getSpacing = (direction)=>{
        if (direction === 'row') return childrenTypes.has('UI-view') || childrenTypes.has('Tall-UI-view') ? 3 : 2;
        return childrenTypes.has('UI-view') ? 4 : 3;
    };
    let direction;
    let spacing;
    let extraSx = {};
    let demoItemSx = {};
    const sx = (0, $8nd05.default)({
        overflow: 'auto',
        // Add padding as overflow can hide the outline text field label.
        pt: 1
    }, sxProp);
    if (components.length > 2 || childrenTypes.has('multi-input-range-field') || childrenTypes.has('single-input-range-field') || childrenTypes.has('multi-panel-UI-view') || childrenTypes.has('UI-view') || childrenSupportedSections.has('date-time')) {
        direction = 'column';
        spacing = getSpacing('column');
    } else {
        direction = {
            xs: 'column',
            lg: 'row'
        };
        spacing = {
            xs: getSpacing('column'),
            lg: getSpacing('row')
        };
    }
    if (childrenTypes.has('UI-view')) ;
    else if (childrenTypes.has('single-input-range-field')) {
        if (!childrenSupportedSections.has('date-time')) extraSx = {
            [`& > .${(0, $25a6b464d3ca38da$export$2e2bcd8739ae039).root}, & > .${(0, $3f6e178f64e28835$export$284739773a7ae972).root}`]: {
                minWidth: 300
            }
        };
        else extraSx = {
            [`& > .${(0, $25a6b464d3ca38da$export$2e2bcd8739ae039).root}, & > .${(0, $3f6e178f64e28835$export$284739773a7ae972).root}`]: {
                minWidth: {
                    xs: 300,
                    // If demo also contains MultiInputDateTimeRangeField, increase width to avoid cutting off the value.
                    md: childrenTypes.has('multi-input-range-field') ? 460 : 400
                }
            }
        };
    } else if (childrenSupportedSections.has('date-time')) {
        extraSx = {
            [`& > .${(0, $25a6b464d3ca38da$export$2e2bcd8739ae039).root}, & > .${(0, $3f6e178f64e28835$export$284739773a7ae972).root}`]: {
                minWidth: 270
            }
        };
        if (childrenTypes.has('multi-input-range-field')) // increase width for the multi input date time range fields
        demoItemSx = {
            [`& > .${(0, $7ac564dc7b213020$export$2e2bcd8739ae039).root} > .${(0, $25a6b464d3ca38da$export$2e2bcd8739ae039).root}, & > .${(0, $7ac564dc7b213020$export$2e2bcd8739ae039).root} > .${(0, $3f6e178f64e28835$export$284739773a7ae972).root}`]: {
                minWidth: 210
            }
        };
    } else extraSx = {
        [`& > .${(0, $25a6b464d3ca38da$export$2e2bcd8739ae039).root}, & > .${(0, $3f6e178f64e28835$export$284739773a7ae972).root}`]: {
            minWidth: 200
        }
    };
    const finalSx = (0, $8nd05.default)({}, sx, extraSx);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
        direction: direction,
        spacing: spacing,
        sx: finalSx,
        children: $acw62.Children.map(children, (child)=>{
            if (/*#__PURE__*/ $acw62.isValidElement(child) && $515ce17556e5a613$var$isDemoItem(child)) // Inject sx styles to the `DemoItem` if it is a direct child of `DemoContainer`.
            // @ts-ignore
            return /*#__PURE__*/ $acw62.cloneElement(child, {
                sx: (0, $8nd05.default)({}, extraSx, demoItemSx)
            });
            return child;
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $79cd9dc3d779c426$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), 'Info');



var $acw62 = parcelRequire("acw62");

const $ae6ea2ea41b88010$var$Toggler = ()=>{
    const [toggle, setToggle] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("uk");
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const isPartnerChecklist = location.pathname.startsWith('/partnerChecklist/');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `br50px df aic jcsb ${isPartnerChecklist && "smw100"}`,
            style: {
                padding: "4px",
                width: "350px",
                backgroundColor: '#D2D2D299',
                margin: "auto",
                marginBottom: "2rem"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `br50px fs0-75rem pl0-5rem pr0-5rem pt0-5rem pb0-5rem w50 tac cp ${toggle === "uk" && "bg1 shadow"}`,
                    style: {
                        color: "#151313B2"
                    },
                    onClick: ()=>setToggle("uk"),
                    children: "UK Company"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `br50px fs0-75rem pl0-5rem pr0-5rem pt0-5rem pb0-5rem w50 tac cnd df aic ${toggle === "non" && "bg1 shadow"}`,
                    style: {
                        color: "#1513134C"
                    },
                    disabled: true,
                    children: [
                        "Non-UK Company ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $79cd9dc3d779c426$export$2e2bcd8739ae039), {
                            className: "infoIcon fs1rem ml0-5rem"
                        })
                    ]
                })
            ]
        })
    });
};
var $ae6ea2ea41b88010$export$2e2bcd8739ae039 = $ae6ea2ea41b88010$var$Toggler;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $53714b4e84a3512c$var$SelectCompanyToggler = ({ isExistingCompany: isExistingCompany, setIsExistingCompany: setIsExistingCompany, setPartnerObj: setPartnerObj })=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const isPartnerChecklist = location.pathname.startsWith('/partnerChecklist/');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `br50px df aic jcsb ${isPartnerChecklist && "smw100"}`,
        style: {
            padding: "4px",
            width: "350px",
            backgroundColor: '#D2D2D299',
            margin: "auto",
            marginBottom: "2rem"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `br50px fs0-75rem pl0-5rem pr0-5rem pt0-5rem pb0-5rem w50 tac cp ${isExistingCompany ? "bg1 shadow" : ""}`,
                style: {
                    color: "#151313B2"
                },
                onClick: ()=>{
                    setIsExistingCompany(true);
                    setPartnerObj({
                        loanDate: new Date(),
                        companyEmail: '',
                        checklistPurpose: ''
                    });
                },
                children: "Select Existing"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `br50px fs0-75rem pl0-5rem pr0-5rem pt0-5rem pb0-5rem w50 tac tac cp ${!isExistingCompany ? "bg1 shadow" : ""}`,
                style: {
                    color: "#1513134C"
                },
                onClick: ()=>{
                    setIsExistingCompany(false);
                    setPartnerObj({
                        loanDate: new Date(),
                        companyEmail: '',
                        checklistPurpose: ''
                    });
                },
                children: "Add New"
            })
        ]
    });
};
var $53714b4e84a3512c$export$2e2bcd8739ae039 = $53714b4e84a3512c$var$SelectCompanyToggler;














const $950db95a2cf78b98$var$AddCompanyModal = ({ modalType: modalType, proceedCompany: proceedCompany, setIsFireWork: setIsFireWork, user: user, isURL: isURL, openWindow: openWindow, setCompany: setCompany, setConfirmedCompany: setConfirmedCompany, confirmedCompany: confirmedCompany, companyOptions: companyOptions, setCompanyOptions: setCompanyOptions, selectedCompany: selectedCompany, applicant: applicant, setSelectedCompany: setSelectedCompany, closeAddCompany: closeAddCompany, existingCompany: existingCompany, setExistingCompany: setExistingCompany, step: step, setStep: setStep, previousCompanyDeleted: previousCompanyDeleted })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const isDashboard = pathname.includes('dashboard');
    const isSuperflow = pathname.toLowerCase().includes('/superflow');
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    const pathSegments = window.location.pathname.split('/');
    const partnerId = pathSegments[pathSegments.length - 1];
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let reduxUser = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let { selectedCompany: ownCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let [isDisabled, setIsDisabled] = (0, $acw62.useState)(true);
    let [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    let [isFormLocked, setIsFormLocked] = (0, $acw62.useState)(false);
    let [isManualAdd, setIsManualAdd] = (0, $acw62.useState)(false);
    let [isDemoChecklist, setIsDemoChecklist] = (0, $acw62.useState)();
    let [websiteStatus, setWebsiteStatus] = (0, $acw62.useState)('Check');
    let [isPartnerChecklist, setIsPartnerChecklist] = (0, $acw62.useState)();
    let [isExistingCompany, setIsExistingCompany] = (0, $acw62.useState)(false);
    let [partnerObj, setPartnerObj] = (0, $acw62.useState)({
        loanDate: new Date(),
        companyEmail: '',
        checklistPurpose: ''
    });
    let [data, setData] = (0, $acw62.useState)({
        companyWebsite: '',
        company5Words: '',
        companyDevelopmentStage: '',
        testType: ''
    });
    (0, $acw62.useEffect)(()=>{
        if (loggedIn && user['role'] != 'Guest' && localStorage.getItem('isPartnerChecklist')) getCompanies();
    }, [
        loggedIn
    ]);
    const getCompanies = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/my-profile`);
        if (response['body']) {
            let { user: user, companies: companies } = response['body'];
            let groups = companies.filter(({ group: group })=>group == 'Parent');
            let standard = companies.filter(({ group: group })=>group != 'Parent');
            companies = groups.concat(standard);
            dispatch((0, $b9bcf9787e5ad456$export$2102c8f11f9a72ed)(companies));
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (localStorage.getItem('isDemoChecklist')) setIsDemoChecklist(true);
        else setIsDemoChecklist(false);
        if (localStorage.getItem('isPartnerChecklist')) setIsPartnerChecklist(true);
        else setIsPartnerChecklist(false);
        let testType = localStorage.getItem('testType');
        if (!partner['testType'] && testType && data['testType'] == '') setData({
            ...data,
            testType: testType
        });
    });
    (0, $acw62.useEffect)(()=>{
        if (user?.['role'] == 'Investor' && location.pathname == '/manualAdd') {
            setIsManualAdd(true);
            setData({
                ...data,
                testType: 'investment'
            });
        }
    }, [
        user
    ]);
    if (!setConfirmedCompany) handleBackToFirstStep();
    (0, $acw62.useEffect)(()=>{
        handleBackToFirstStep();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isFormLocked || isSubmitting) return;
        if (loggedIn) partnerObj['companyEmail'] = user?.email;
        let testType = localStorage.getItem('testType');
        if (!partner['testType'] && testType && data['testType'] == '') setData({
            ...data,
            testType: testType
        });
        if (data['companyWebsite'] == '' || data['company5Words'] == '' || data['companyDevelopmentStage'] == '' || data['testType'] == '' || websiteStatus != 'Confirmed') setIsDisabled(true);
        else if (localStorage.getItem('isPartnerChecklist') && (partnerObj['companyEmail'] == '' || partner['type'] == 'Business for Funding' && partnerObj['checklistPurpose'] == '')) setIsDisabled(true);
        else setIsDisabled(false);
    }, [
        data,
        websiteStatus,
        partnerObj,
        isFormLocked,
        isSubmitting
    ]);
    (0, $acw62.useEffect)(()=>{
        if (partner?.['testType'] && data['testType'] == '') setData({
            ...data,
            testType: partner['testType']
        });
    }, [
        partner
    ]);
    const formLocked = isSubmitting || isFormLocked;
    const submitDisabled = isDisabled || formLocked;
    const verifyWebsite = async ()=>{
        if (formLocked) return;
        try {
            let companyWebsite = document.querySelector(`#companyWebsite`).value;
            if (!companyWebsite) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide website link');
            if (!isURL(companyWebsite)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Invalid company url');
            if (companyWebsite.indexOf('http') < 0) companyWebsite = `http://${companyWebsite}`;
            openWindow(companyWebsite);
            setWebsiteStatus('Confirm');
        } catch (e) {
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e);
        }
    };
    const handleBackToFirstStep = ()=>{
        setStep(1);
        setExistingCompany('');
        setWebsiteStatus('Check');
        setCompanyOptions([]);
        setSelectedCompany({});
        setConfirmedCompany();
        setIsSubmitting(false);
        setIsFormLocked(false);
    };
    const submitCompany = async ()=>{
        if (isSubmitting || isFormLocked) return;
        let companyObj = {
            isDirectCompany: false
        };
        if (user['role'] != 'Advisor' && user['role'] != 'Investor') companyObj['isDirectCompany'] = true;
        let inputArray = [
            'companyWebsite',
            'testType',
            'companyDevelopmentStage',
            'company5Words'
        ];
        if ((user['role'] == 'Advisor' || user['role'] == 'Investor') && !isManualAdd) {
            inputArray.push('companyOwnerEmail');
            inputArray.push('companyOwnerName');
            confirmedCompany['userType'] = user['role'];
        }
        for (const id of inputArray){
            const el = document.querySelector(`#${id}, [name='${id}']:checked`);
            if (!el?.['dataset']?.['option'] && el?.['value'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please provide all inputs`);
            confirmedCompany[id] = el?.['dataset']?.['option'] || el?.['value'];
        }
        if (websiteStatus != 'Confirmed') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please check and confirm company website');
        if (confirmedCompany['company5Words'].split(' ').length < 5) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide 5 words that describe your company business activites');
        if (localStorage.getItem('isPartnerChecklist')) confirmedCompany = {
            ...confirmedCompany,
            ...partnerObj
        };
        if (isManualAdd && user['role'] == 'Investor') {
            if (applicant['email'] == '' || applicant['firstName'] == '' || applicant['lastName'] == '') {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'addApplicantPopup'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide all data for applicant');
                return;
            }
            companyObj = {
                ...companyObj,
                isManualMatch: true,
                companyOwnerEmail: applicant['email'],
                companyOwnerName: `${applicant['firstName']} ${applicant['lastName']}`
            };
        }
        setIsSubmitting(true);
        setIsDisabled(true);
        let response;
        try {
            response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/new', {
                company: {
                    ...confirmedCompany,
                    isParent: user['role'] == 'Advisor' ? true : false,
                    ...companyObj
                },
                user: {
                    ...reduxUser,
                    companyId: reduxUser['companyId'] || null
                }
            });
        } catch (err) {
            setIsSubmitting(false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(err?.message || 'Something went wrong, please try again');
            return;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        if (response['message'] == 'This user already exists on the platform') {
            setIsSubmitting(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            setTimeout(()=>navigation(`/login?redirect=partnerChecklist/${partnerId}&email=${partnerObj['companyEmail']}`), 1000);
            return;
        }
        if (response?.['code'] !== 200) {
            setIsSubmitting(false);
            return;
        }
        setIsFormLocked(true);
        setIsSubmitting(false);
        let { company: company } = response['body'];
        if (company?.['creatorId'] && company?.['_id']) {
            setWebsiteStatus('Check');
            (0, $bebe1cbb5a309c8c$export$7f5abdb7f5093137)(company['creatorId']);
            localStorage.removeItem('userId');
            localStorage.setItem('userId', company['creatorId']);
            document.cookie = `userId=${company['creatorId']};path=/`;
            await setCompany(company);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'generatingDescription'
            }));
        } else {
            setIsFormLocked(false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Something went wrong, please try again');
        }
    };
    const confirmCompany = async ()=>{
        if (isExistingCompany && partnerObj["checklistPurpose"]) {
            setIsDisabled(false);
            let company = partnerObj["checklistPurpose"];
            if (company?.['creatorId'] && company?.['_id']) {
                setWebsiteStatus('Check');
                (0, $bebe1cbb5a309c8c$export$7f5abdb7f5093137)(company['creatorId']);
                localStorage.removeItem('userId');
                localStorage.setItem('userId', company['creatorId']);
                document.cookie = `userId=${company['creatorId']};path=/`;
                await setCompany(company);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'generatingDescription'
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Something went wrong, please try again');
            return;
        }
        if (!selectedCompany || !selectedCompany['company_number']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select company');
        if (!selectedCompany?.['company_status'] || selectedCompany?.['company_status'] != 'active') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('This company is not active');
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/company/isCompanyAllowed/' + selectedCompany['company_number'] + `?userId=${user?.['_id']}`);
        if (!response || response['code'] != 200) return;
        if (response?.['body']?.['created'] == true) {
            existingCompany = response['body']['existingCompany'];
            setExistingCompany(existingCompany);
            if (isManualAdd) return addCompanyLead();
            setStep(4);
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        }
        setConfirmedCompany(selectedCompany);
        setStep(3);
    };
    const addCompanyLead = async ()=>{
        let company = {
            ...existingCompany,
            isManualMatch: true,
            companyWebsite: existingCompany['cWebsite'],
            companyDevelopmentStage: existingCompany['cStage'],
            company5Words: existingCompany['fiveWords'],
            company_number: existingCompany['ukRegNo']
        };
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/new', {
            company: company,
            user: {
                ...reduxUser,
                companyId: reduxUser['companyId'] || null
            }
        });
        if (response['code'] == 200) window.location.href = `/investor-dashboard#index?QualifiedLeads`;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
    };
    const requestAccess = async ()=>{
        if (!existingCompany['_id']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('No existing company is selected!');
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/requestAccess/${existingCompany['_id']}`);
        if (response['code'] == 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
    };
    let searchTimeout;
    const searchCompanyTimeout = (e)=>{
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(()=>searchCompany(e.target.value), 1000);
    };
    const searchCompany = async (input)=>{
        if (!input) return;
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/search/${input}`);
        if (!response || response['code'] != 200) return;
        setCompanyOptions(response['body']['items'].slice(0, 5));
    };
    const onCloseHandler = ()=>{
        closeAddCompany();
        setStep(1);
        setIsSubmitting(false);
        setIsFormLocked(false);
    };
    const handleCompanyOption = async (option)=>{
        setSelectedCompany(option);
        setStep(2);
    };
    const handleBlur = (e)=>{
        const inputId = e.target.id;
        const inputValue = e.target.value;
    // doSomething(inputId, inputValue);
    };
    const girlComponent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                position: 'relative',
                maxHeight: '90%'
            },
            children: step == 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    isDemoChecklist && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("kL3qx")),
                        alt: "messageLadie",
                        className: "girlImage"
                    }),
                    isPartnerChecklist && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("gqxg0")),
                        alt: "messageLadie",
                        className: "girlImage"
                    })
                ]
            }) : step == 3 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    isDemoChecklist && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("hePpl")),
                        alt: "messageLadie",
                        className: "girlImage"
                    }),
                    isPartnerChecklist && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("idbah")),
                        alt: "messageLadie",
                        className: "girlImage"
                    })
                ]
            }) : null
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            onCloseHandler: onCloseHandler,
            girlComponent: girlComponent(),
            children: [
                step === 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        previousCompanyDeleted ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c4 fw500 fs0-75rem mb1em fsi",
                            children: "Company removed, Let\u2019s try again!"
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: `c15 fs1-5rem lh1 tac mb2rem fw500 mb2rem smfs1.25rem w100`,
                            children: isManualAdd ? "Add Your Applicant\u2019s Company" : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "Add a UK",
                                    ' ',
                                    " ",
                                    user['role'] == 'Advisor' || user['role'] == 'Investor' ? 'client' : '',
                                    ' ',
                                    " company"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae6ea2ea41b88010$export$2e2bcd8739ae039), {}),
                        user['emailVerified'] && location.pathname.includes('partnerChecklist') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53714b4e84a3512c$export$2e2bcd8739ae039), {
                            isExistingCompany: isExistingCompany,
                            setIsExistingCompany: setIsExistingCompany,
                            setPartnerObj: setPartnerObj
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb1rem df aic jcs",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("oTBav")),
                                    className: "pa ml0-5rem miw2rem",
                                    alt: "searchIcon"
                                }),
                                isExistingCompany ? /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    name: "checklist-purpose",
                                    id: "checklist-purpose",
                                    onChange: (e)=>{
                                        const selectedCompany = companies.find((company)=>company._id === e.target.value);
                                        setPartnerObj({
                                            ...partnerObj,
                                            checklistPurpose: selectedCompany,
                                            companyEmail: selectedCompany.companyEmail
                                        });
                                    },
                                    className: "pl3rem bg1 bs1px brss bo42 w100 br8px py1rem xs-pr32px xs-pl42px xs-fs14px",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            className: "dn",
                                            selected: true,
                                            children: "Select Company"
                                        }),
                                        companies.map((company, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: company._id,
                                                children: company.cName
                                            }, index))
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    onKeyUp: searchCompanyTimeout,
                                    "data-testid": "searchForCompanies",
                                    placeholder: "Search for Company Name/Number",
                                    className: "pl3rem bg1 bs1px brss bo42 w100 br8px pt1rem pb1rem sm-pt0-5rem sm-pb0-5rem"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "shadow bg1 companyOptionCard",
                            children: companyOptions.map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    onClick: ()=>handleCompanyOption(option),
                                    className: "cp c36 df fww jcfs aic bg1 py0-5rem px1rem br5px",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600 c36 mr1rem sm-fs14px",
                                            children: option['title']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr1rem c36 sm-fs14px",
                                            children: option['company_number']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "ttu fw600 c36 sm-fs14px",
                                            children: [
                                                " ",
                                                option['company_status'],
                                                " "
                                            ]
                                        })
                                    ]
                                }, `companyOptionCard-${idx}-${idx}`))
                        })
                    ]
                }) : step === 2 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: selectedCompany && selectedCompany?.['title'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "br5px p1rem mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "c15 fs1-5rem ttc fw500 w100 tas",
                                    children: isManualAdd ? "Your Applicant\u2019s Company Information" : 'Company Information'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c3 mb1rem sm-fs14px fs1rem",
                                    children: selectedCompany?.['title']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dg gg0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs14px",
                                            children: [
                                                " Company Status:",
                                                ' ',
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                    children: [
                                                        selectedCompany?.['company_status'] && selectedCompany['company_status'].toUpperCase(),
                                                        ' '
                                                    ]
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs14px",
                                            children: [
                                                " Company Number:",
                                                ' ',
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                    children: [
                                                        selectedCompany?.['company_number'],
                                                        ' ',
                                                        " "
                                                    ]
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs14px",
                                            children: [
                                                " Company Title:",
                                                ' ',
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                    children: [
                                                        selectedCompany?.['title'],
                                                        ' ',
                                                        " "
                                                    ]
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs14px",
                                            children: [
                                                " Company Date of Creation:",
                                                ' ',
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                    children: [
                                                        selectedCompany?.['date_of_creation'],
                                                        ' ',
                                                        " "
                                                    ]
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs14px",
                                            children: [
                                                " Company Description:",
                                                ' ',
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                    children: [
                                                        selectedCompany?.['description'],
                                                        ' ',
                                                        " "
                                                    ]
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs14px",
                                            children: [
                                                " Company Address:",
                                                ' ',
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                    children: [
                                                        selectedCompany?.['address_snippet'],
                                                        ' ',
                                                        " "
                                                    ]
                                                }),
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }) : step === 3 && confirmedCompany ? /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                    disabled: formLocked,
                    className: `w100 m0 p0 ${formLocked ? 'op60 pen' : ''}`,
                    style: {
                        border: 'none',
                        margin: 0,
                        padding: 0,
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fs1-5rem ttc fw500 w100 tas",
                            children: isManualAdd ? "Add Your Applicant\u2019s Company Details" : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "Add Your",
                                    ' ',
                                    " ",
                                    user['role'] == 'Advisor' || user['role'] == 'Investor' ? 'client' : '',
                                    " Company Details"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "c3 mb1rem sm-fs14px fs1rem",
                            children: [
                                confirmedCompany['title'],
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb1rem df aic jcfs",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    id: "companyWebsite",
                                    name: "companyWebsite",
                                    type: "text",
                                    readOnly: formLocked,
                                    placeholder: `Website`,
                                    onChange: (e)=>{
                                        if (formLocked) return;
                                        setWebsiteStatus('Check'), setData({
                                            ...data,
                                            companyWebsite: e.target.value
                                        });
                                    },
                                    onBlur: (e)=>{
                                        if (formLocked) return;
                                        setWebsiteStatus('Check'), setData({
                                            ...data,
                                            companyWebsite: e.target.value
                                        });
                                    },
                                    className: "pl3rem bg1 bs1px brss bo42 w100 br8px pt1rem pb1rem xs-px32px xs-fs14px sm-pt0-5rem sm-pb0-5rem"
                                }),
                                websiteStatus == 'Check' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "button",
                                    disabled: formLocked,
                                    className: `verify-btn shadow bg3 c1 fs1rem sm-fs14px pt1rem pb1rem fw600 pl2rem pr2rem sm-px16px sm-py9px ${formLocked ? 'cna op60' : 'cp'}`,
                                    value: websiteStatus,
                                    onClick: ()=>verifyWebsite()
                                }) : websiteStatus == 'Confirm' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pa r0 df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "33",
                                            height: "34",
                                            viewBox: "0 0 33 34",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M29.9955 19.4373L27.3395 15.6863C26.9005 15.068 26.0437 14.9183 25.4221 15.3587L21.6718 18.0141C21.0527 18.4524 20.9051 19.3106 21.3441 19.9303C21.7831 20.5493 22.6399 20.6977 23.2615 20.2579L24.5176 19.3686C24.2478 20.2821 23.8355 21.151 23.2602 21.9364C21.6595 24.1218 19.1955 25.3746 16.4979 25.3746C14.0493 25.3746 11.7411 24.3091 10.166 22.4513C9.67599 21.874 8.8085 21.8028 8.2277 22.2923C7.64897 22.7837 7.57719 23.6512 8.06861 24.2306C10.1674 26.7053 13.2396 28.1246 16.4979 28.1246C20.0295 28.1246 23.3864 26.4186 25.4785 23.5612C26.2386 22.5237 26.7859 21.3769 27.1449 20.171L27.7504 21.0262C28.0189 21.4048 28.4432 21.607 28.8743 21.607C29.1482 21.607 29.4262 21.525 29.6678 21.3538C30.2868 20.9151 30.4345 20.0569 29.9955 19.4373Z",
                                                    fill: "#4A67FF",
                                                    stroke: "#4A67FF",
                                                    "stroke-width": "0.1"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M11.6539 14.0702C11.2142 13.4499 10.3561 13.3028 9.73704 13.7419L8.4807 14.6313C8.7502 13.7175 9.16242 12.8489 9.73704 12.0642C11.3377 9.87943 13.8024 8.62598 16.5 8.62598C18.9493 8.62598 21.2575 9.69146 22.8325 11.5492C23.324 12.1273 24.1914 12.1997 24.7702 11.7083C25.3503 11.2169 25.4214 10.3494 24.93 9.76998C22.8312 7.29525 19.7589 5.87598 16.5 5.87598C12.9691 5.87598 9.6115 7.58194 7.51889 10.4393C6.7592 11.4766 6.21209 12.6237 5.85321 13.8302L5.24752 12.9746C4.8078 12.3542 3.95035 12.2072 3.33077 12.6462C2.7112 13.0852 2.56407 13.9434 3.00242 14.563L5.65782 18.314C5.92636 18.6926 6.35069 18.8948 6.78175 18.8948C7.05634 18.8948 7.33367 18.8128 7.57471 18.6423L11.3257 15.9869C11.9453 15.5479 12.0923 14.6899 11.6539 14.0702Z",
                                                    fill: "#4A67FF",
                                                    stroke: "#4A67FF",
                                                    "stroke-width": "0.1"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            disabled: formLocked,
                                            className: `registerButtonAnimation br8px ml0-5rem shadow bg3 c1 pt1rem pb1rem pl1-5rem pr1-5rem sm-px16px fw600 ${formLocked ? 'cna op60' : 'cp'}`,
                                            value: websiteStatus,
                                            onClick: ()=>setWebsiteStatus('Confirmed'),
                                            children: websiteStatus
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pa SlitRight",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "31",
                                        height: "31",
                                        viewBox: "0 0 31 31",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M15.2143 0.5C6.84643 0.5 0 7.34643 0 15.7143C0 24.0821 6.84643 30.9286 15.2143 30.9286C23.5821 30.9286 30.4286 24.0821 30.4286 15.7143C30.4286 7.34643 23.5821 0.5 15.2143 0.5ZM21.7564 12.0629L14.7579 21.1914C14.4536 21.4957 13.9971 21.8 13.5407 21.8C13.0843 21.8 12.6279 21.6479 12.3236 21.1914L8.67214 16.475C8.21571 15.8664 8.21571 14.8014 8.97643 14.345C9.73714 13.8886 10.65 13.8886 11.1064 14.6493L13.5407 17.8443L19.3221 10.2371C19.7786 9.62857 20.8436 9.47643 21.4521 9.93286C22.2129 10.3893 22.2129 11.3021 21.7564 12.0629Z",
                                            fill: "#15D757"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ml1rem pa xs-mx8px",
                                    src: (parcelRequire("lHjlZ")),
                                    alt: "browserIcon"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb1rem df aic jcfs",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    id: "company5Words",
                                    type: "text",
                                    readOnly: formLocked,
                                    onChange: (e)=>{
                                        if (!formLocked) setData({
                                            ...data,
                                            company5Words: e.target.value
                                        });
                                    },
                                    placeholder: `Add 5 keywords which explain your ${isManualAdd ? "applicant\u2019s" : user['role'] == 'Advisor' || user['role'] == 'Investor' ? 'client' : ''} business activities\u{200B}`,
                                    className: "pl3rem bg1 bs1px brss bo42 w100 br8px pt1rem pb1rem sm-py8px xs-px32px xs-fs14px"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ml1rem pa xs-mx8px",
                                    src: (parcelRequire("9l2sz")),
                                    alt: "keywordIcon"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb1rem mt1rem c15 fs1-25rem fw500",
                            children: isManualAdd ? "Your applicant\u2019s company is" : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    " ",
                                    user['role'] == 'Advisor' || user['role'] == 'Investor' ? 'Client' : 'My',
                                    ' ',
                                    " company is"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic jcfs fww mt0-5rem mb1rem",
                            children: [
                                'Pre-Revenue',
                                'Post-Revenue Early Stage',
                                'Mature'
                            ].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    htmlFor: option,
                                    className: "df cp aic mb0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "radio pr df",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                disabled: formLocked,
                                                onClick: ()=>{
                                                    if (formLocked) return;
                                                    localStorage.setItem('cStage', option);
                                                    setData({
                                                        ...data,
                                                        companyDevelopmentStage: option
                                                    });
                                                },
                                                "data-testid": option.replace(/\s/g, ''),
                                                "data-option": option,
                                                name: "companyDevelopmentStage",
                                                id: option,
                                                className: `bg5 bo5 bw2px bss td250 w1rem h1rem br50pc ${formLocked ? 'cna op60' : 'cp'}`,
                                                type: "radio"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "w100 fs1rem lh3 ml0-5rem usn mr1rem c15 xs-fs12px",
                                            children: option
                                        })
                                    ]
                                }, `${idx}-radioCompany-type`))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb1rem fs1-25rem fw500",
                            children: isManualAdd ? "Applicant\u2019s company purpose" : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "I want to make",
                                    ' ',
                                    " ",
                                    user['role'] == 'Advisor' || user['role'] == 'Investor' ? 'client' : 'my',
                                    ' ',
                                    " company"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic jcfs mt0-5rem fww mb1rem",
                            children: [
                                'Investment Ready',
                                'Growth Ready',
                                'Exit Ready'
                            ].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    htmlFor: option,
                                    className: `df aic mb0-5rem ${localStorage.getItem('isPartnerChecklist') || isManualAdd || isSuperflow ? 'cna' : 'cp'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "radio pr df",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: option,
                                                type: "radio",
                                                name: "testType",
                                                "data-testid": option.replace(/\s/g, ''),
                                                disabled: formLocked || localStorage.getItem('isPartnerChecklist') || isManualAdd || isSuperflow,
                                                onClick: ()=>{
                                                    if (formLocked || localStorage.getItem('isPartnerChecklist') || isManualAdd || isSuperflow) return;
                                                    setData({
                                                        ...data,
                                                        testType: option.toLowerCase().replace(/ ready/, '')
                                                    });
                                                },
                                                "data-option": option.toLowerCase().replace(/ ready/, ''),
                                                checked: data['testType'] === option.toLowerCase().replace(/ ready/, ''),
                                                className: `bg5 bo5 bw2px bss td250 w1rem h1rem br50pc ${formLocked || localStorage.getItem('isPartnerChecklist') || isManualAdd || isSuperflow ? 'cna op50' : 'cp'}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `w100 fs1rem lh3 ml0-5rem usn mr1rem xs-fs12px ${localStorage.getItem('isPartnerChecklist') || isManualAdd || isSuperflow ? 'c12' : 'c15'}`,
                                            children: option
                                        })
                                    ]
                                }, `my-company-is${idx}`))
                        }),
                        localStorage.getItem('isPartnerChecklist') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "cp df fdc",
                            children: [
                                partner['type'] == 'Business for Funding' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w100 c15 fs1rem fw500",
                                            children: "Last loan application submitted"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            class: "df w100",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa5abcb204c6ca4b$export$dc45bdc734ce6f1e), {
                                                dateAdapter: (0, $9231773518718bc3$export$33545c6a80bae043),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $515ce17556e5a613$export$55fa3227aec3be26), {
                                                    components: [
                                                        'DatePicker'
                                                    ],
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a464a2169acb6c$export$5109c6dd95d8fb00), {
                                                        maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(),
                                                        value: (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(partnerObj['loanDate']),
                                                        onChange: (date)=>setPartnerObj({
                                                                ...partnerObj,
                                                                loanDate: new Date(date)
                                                            }),
                                                        views: [
                                                            'year',
                                                            'month'
                                                        ],
                                                        sx: {
                                                            minWidth: 550
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                !loggedIn && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "py0-5rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "email",
                                            value: partnerObj['companyEmail'],
                                            placeholder: "Your Company Email",
                                            className: "pl3rem lpins w100 br10px p1rem",
                                            onChange: (e)=>setPartnerObj({
                                                    ...partnerObj,
                                                    companyEmail: e['target']['value']
                                                }),
                                            onBlur: (e)=>setPartnerObj({
                                                    ...partnerObj,
                                                    companyEmail: e['target']['value']
                                                }),
                                            onInput: (e)=>setPartnerObj({
                                                    ...partnerObj,
                                                    companyEmail: e['target']['value']
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            style: {
                                                top: '25px',
                                                left: '20px'
                                            },
                                            className: "pa",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 16 12",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z",
                                                fill: "black"
                                            })
                                        })
                                    ]
                                }),
                                partner['type'] == 'Business for Funding' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr df aic jcfs mt0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                name: "checklist-purpose",
                                                id: "checklist-purpose",
                                                onChange: (e)=>setPartnerObj({
                                                        ...partnerObj,
                                                        checklistPurpose: e.target.value
                                                    }),
                                                className: "pl3rem bg1 bs1px brss bo42 w100 br8px py1rem xs-px32px xs-fs14px",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        class: "dn",
                                                        selected: true,
                                                        children: "What will your funding be used for?"
                                                    }),
                                                    [
                                                        'Property Purchase',
                                                        'Property Development',
                                                        'Asset Purchase',
                                                        'Stock Acquisition',
                                                        'Growth Capital',
                                                        'Pay Tax / Crown Debts',
                                                        'Purchase of Shares',
                                                        'Start-up Funding',
                                                        'Working Capital'
                                                    ].map((item)=>{
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: item,
                                                            children: item
                                                        });
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "ml1rem pa xs-mx8px",
                                                src: (parcelRequire("5as1I")),
                                                alt: "keywordIcon"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (user['role'] == 'Advisor' || user['role'] == 'Investor') && !isManualAdd && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr mt1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "companyOwnerName",
                                            type: "text",
                                            readOnly: formLocked,
                                            placeholder: "Please provide Client Contact Name",
                                            className: "pl4rem bg1 bs1px brss bo42 w100 br8px pt1rem pb1rem xs-px32px xs-fs14px",
                                            onBlur: handleBlur,
                                            onInput: handleBlur
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 640 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                className: "fa-secondary"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "companyOwnerEmail",
                                            type: "text",
                                            readOnly: formLocked,
                                            placeholder: "Please provide Client Contact Email",
                                            className: "pl4rem bg1 bs1px brss bo42 w100 br8px pt1rem pb1rem xs-px32px xs-fs14px",
                                            onBlur: handleBlur,
                                            onInput: handleBlur
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                    className: "fa-secondary"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                    className: "fa-primary"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : existingCompany ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc aic fdc w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "60",
                                        height: "60",
                                        viewBox: "0 0 82 82",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M40.9346 76C60.3018 76 76.002 60.2998 76.002 40.9326C76.002 21.5654 60.3018 5.86523 40.9346 5.86523C21.5674 5.86523 5.86719 21.5654 5.86719 40.9326C5.86719 60.2998 21.5674 76 40.9346 76Z",
                                                fill: "url(#paint0_linear_5984_47190)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M75.8262 44.4635L45.6436 14.2808C44.6406 12.9422 42.8694 12.8047 40.8963 12.8047C37.7014 12.8047 35.7969 13.9299 35.7969 16.9691C35.7969 26.2423 36.8879 39.5683 36.8879 48.8416C36.8879 50.0536 36.8291 50.9124 37.672 51.4674L57.8565 71.6519C67.6994 66.2184 74.6533 56.1932 75.8262 44.4635Z",
                                                fill: "url(#paint1_linear_5984_47190)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M57.5222 71.8347L45.3323 59.6447C44.2374 58.4271 42.6732 57.9434 40.9715 57.9434C37.5426 57.9434 35.2656 60.3763 35.2656 63.6493C35.2656 65.3942 35.7417 67.0187 36.9961 68.1378L44.6613 75.803C49.2741 75.3157 53.6198 73.9344 57.5222 71.8347Z",
                                                fill: "url(#paint2_linear_5984_47190)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M46.8997 63.6494C46.8997 66.8446 44.1724 69.65 40.9772 69.65C37.5482 69.65 34.9766 66.8446 34.9766 63.6494C34.9766 60.3765 37.5482 57.6488 40.9772 57.6488C44.1724 57.6488 46.8997 60.3765 46.8997 63.6494ZM45.4192 48.8431C45.4192 51.259 42.7695 52.272 40.8991 52.272C38.4055 52.272 36.3014 51.259 36.3014 48.8431C36.3014 39.5699 35.2103 26.2438 35.2103 16.9706C35.2103 13.9314 37.704 12.2168 40.8991 12.2168C43.9383 12.2168 46.51 13.9311 46.51 16.9706C46.5102 26.2438 45.4192 39.5696 45.4192 48.8431Z",
                                                fill: "url(#paint3_linear_5984_47190)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                        id: "paint0_linear_5984_47190",
                                                        x1: "24.6242",
                                                        y1: "24.6222",
                                                        x2: "58.4244",
                                                        y2: "58.4225",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                "stop-color": "#FF637B"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "1",
                                                                "stop-color": "#E63950"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                        id: "paint1_linear_5984_47190",
                                                        x1: "62.8505",
                                                        y1: "50.2933",
                                                        x2: "26.647",
                                                        y2: "26.0601",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                "stop-color": "#E63950",
                                                                "stop-opacity": "0"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "0.0467",
                                                                "stop-color": "#E4354B",
                                                                "stop-opacity": "0.047"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "0.4669",
                                                                "stop-color": "#D31822",
                                                                "stop-opacity": "0.467"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "0.7991",
                                                                "stop-color": "#C90709",
                                                                "stop-opacity": "0.799"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "1",
                                                                "stop-color": "#C50000"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                        id: "paint2_linear_5984_47190",
                                                        x1: "54.4907",
                                                        y1: "74.2011",
                                                        x2: "36.1085",
                                                        y2: "61.5086",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                "stop-color": "#E63950",
                                                                "stop-opacity": "0"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "0.0467",
                                                                "stop-color": "#E4354B",
                                                                "stop-opacity": "0.047"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "0.4669",
                                                                "stop-color": "#D31822",
                                                                "stop-opacity": "0.467"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "0.7991",
                                                                "stop-color": "#C90709",
                                                                "stop-opacity": "0.799"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "1",
                                                                "stop-color": "#C50000"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                        id: "paint3_linear_5984_47190",
                                                        x1: "34.9769",
                                                        y1: "40.9333",
                                                        x2: "46.8997",
                                                        y2: "40.9333",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                "stop-color": "#EDF5FF"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "1",
                                                                "stop-color": "#D5E8FE"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "c15 mt1rem fs20px",
                                        children: "Duplicate Company Detected"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "c15 op70 fs12px mt0-5rem",
                                        children: [
                                            "This company already exists on Diligentsia ",
                                            !loggedIn && "Contact support at support@diligentsia.co.uk"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df mt2rem jcc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        btnType: "warning",
                                        customClassName: "bg44 c4 mr1rem bss bs1px bo4",
                                        text: "Add different company",
                                        onClick: handleBackToFirstStep
                                    }),
                                    loggedIn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        btnType: "warning",
                                        text: "Ask company for access",
                                        onClick: requestAccess
                                    })
                                ]
                            })
                        ]
                    })
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc aic",
                    children: [
                        1,
                        2
                    ].includes(step) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc jcc aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                disabled: !Object.keys(selectedCompany).length || !partnerObj['checklistPurpose'],
                                "data-testid": "confirmCompany",
                                onClick: ()=>confirmCompany(),
                                className: `mt1rem ${!Object.keys(selectedCompany).length && !partnerObj['checklistPurpose'] ? "op60" : "op100"} bg4 bg4-hover c1 td250 br50px py0-75rem fw600 cp pl6rem pr6rem mla mra bsbb tac xs-px32px sm-fs14px`,
                                children: "Confirm Company"
                            }),
                            localStorage.getItem('isDemoChecklist') && step == 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "w80 tac fs0-75rem fw300 c12 mt1rem",
                                children: "This demo checklist and data will only be stored at the end of this process if you register an account"
                            }),
                            localStorage.getItem('isPartnerChecklist') && step == 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "w80 tac fs0-75rem fw300 c12 mt1rem sm-fs10px",
                                children: "This checklist and data will only be stored and sent to your email at the end of this process if you register an account"
                            })
                        ]
                    }) : step === 3 ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        disabled: submitDisabled,
                        "data-testid": "submitCompany",
                        onClick: ()=>submitCompany(),
                        className: `mt2rem c1 td250 br50px py0-75rem fw600 pl6rem pr6rem mla mra bsbb tac xs-px48px smfs1rem sm-fs14px ${submitDisabled ? ' bg16 cna' : ' bg4 bg4-hover cp'}`,
                        children: isSubmitting ? 'Submitting...' : 'Submit'
                    }) : null
                })
            ]
        })
    });
};
var $950db95a2cf78b98$export$2e2bcd8739ae039 = $950db95a2cf78b98$var$AddCompanyModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $01b4fe2088fac58b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $01b4fe2088fac58b$export$2e2bcd8739ae039(element, selector) {
    return $01b4fe2088fac58b$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
        window.addEventListener('test', $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener('test', $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7060bb66c8fa08f7$var$_toPropertyKey(arg) {
    var key = $7060bb66c8fa08f7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7060bb66c8fa08f7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7060bb66c8fa08f7$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $7060bb66c8fa08f7$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $acw62.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $7060bb66c8fa08f7$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $7060bb66c8fa08f7$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($7060bb66c8fa08f7$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $7060bb66c8fa08f7$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}



var $acw62 = parcelRequire("acw62");
function $27d585c6d75dcd23$export$2e2bcd8739ae039(value) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $e12c5402755aae29$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $acw62.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $cbe95659e68dd1dd$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $cbe95659e68dd1dd$export$2e2bcd8739ae039 = $cbe95659e68dd1dd$var$useCommittedRef;


function $838dd0f898428a09$export$2e2bcd8739ae039(fn) {
    const ref = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $f665bd0f5e0a2735$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(listener);
    (0, $acw62.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $acw62 = parcelRequire("acw62");
const $845df35e9a3b7033$var$DropdownContext = /*#__PURE__*/ $acw62.createContext(null);
var $845df35e9a3b7033$export$2e2bcd8739ae039 = $845df35e9a3b7033$var$DropdownContext;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $5251105f62ca120d$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}




var $acw62 = parcelRequire("acw62");
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $5bd0dc278db65a7f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $6d6e1f6e05803d7b$var$useSafeState(state) {
    const isMounted = (0, $5bd0dc278db65a7f$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $acw62.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $6d6e1f6e05803d7b$export$2e2bcd8739ae039 = $6d6e1f6e05803d7b$var$useSafeState;












const $aa2830a619d3769f$export$8f7491d57c8f97a9 = (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $69d8d7bda7717b01$export$2e2bcd8739ae039),
        (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
        (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
        (0, $e7d7845625089588$export$2e2bcd8739ae039),
        (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
        (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
        (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
        (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039)
    ]
});


const $3e96790ca7bcc44e$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $3e96790ca7bcc44e$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $3e96790ca7bcc44e$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $3e96790ca7bcc44e$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $3e96790ca7bcc44e$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $3e96790ca7bcc44e$var$EMPTY_MODIFIERS } = _ref, config = $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(_ref, $3e96790ca7bcc44e$var$_excluded);
    const prevModifiers = (0, $acw62.useRef)(modifiers);
    const popperInstanceRef = (0, $acw62.useRef)();
    const update = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $6d6e1f6e05803d7b$export$2e2bcd8739ae039)((0, $acw62.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $acw62.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $acw62.useMemo)(()=>{
        if (!(0, $371d31aa64efa655$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $3e96790ca7bcc44e$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $aa2830a619d3769f$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $3e96790ca7bcc44e$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $3e96790ca7bcc44e$export$2e2bcd8739ae039 = $3e96790ca7bcc44e$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;


function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $28419dce7921d430$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $acw62 = parcelRequire("acw62");

var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;


const $bfacdc492f374f5e$var$noop = ()=>{};
function $bfacdc492f374f5e$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $bfacdc492f374f5e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $bfacdc492f374f5e$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $bfacdc492f374f5e$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $bfacdc492f374f5e$var$useClickOutside(ref, onClickOutside = $bfacdc492f374f5e$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $acw62.useRef)(false);
    const waitingForTrigger = (0, $acw62.useRef)(false);
    const handleMouseCapture = (0, $acw62.useCallback)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $bfacdc492f374f5e$var$isModifiedEvent(e) || !$bfacdc492f374f5e$var$isLeftClickEvent(e) || !!(0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)($bfacdc492f374f5e$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, $bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(el, 'mousemove', $bfacdc492f374f5e$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $bfacdc492f374f5e$export$2e2bcd8739ae039 = $bfacdc492f374f5e$var$useClickOutside;


function $d29a438d14321507$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $d29a438d14321507$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $d29a438d14321507$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $d29a438d14321507$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $d29a438d14321507$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



var $ayMG0 = parcelRequire("ayMG0");
const $7b01c7ecb51f8572$var$_excluded = [
    "children",
    "usePopper"
];
function $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $7b01c7ecb51f8572$var$noop = ()=>{};
function $7b01c7ecb51f8572$export$133c4d08f3775d64(options = {}) {
    const context = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $5251105f62ca120d$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $acw62.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $3e96790ca7bcc44e$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $d29a438d14321507$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $7b01c7ecb51f8572$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $bfacdc492f374f5e$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $7b01c7ecb51f8572$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(_ref, $7b01c7ecb51f8572$var$_excluded);
    const [props, meta] = $7b01c7ecb51f8572$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children(props, meta)
    });
}
$7b01c7ecb51f8572$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $7b01c7ecb51f8572$export$2e2bcd8739ae039 = $7b01c7ecb51f8572$var$DropdownMenu;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $8afd3bdc2bd65163$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function') {
        if (!$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext && !$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($8afd3bdc2bd65163$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $8afd3bdc2bd65163$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useId'] === 'function' ? $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId : $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $8afd3bdc2bd65163$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))['useSyncExternalStore']($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext);
}




var $ayMG0 = parcelRequire("ayMG0");
const $02e50cfe922d2ca9$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $02e50cfe922d2ca9$var$noop = ()=>{};
function $02e50cfe922d2ca9$export$96df6c7c5036b9a2() {
    const id = (0, $8afd3bdc2bd65163$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $02e50cfe922d2ca9$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $acw62.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $02e50cfe922d2ca9$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $02e50cfe922d2ca9$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $02e50cfe922d2ca9$var$DropdownToggle({ children: children }) {
    const [props, meta] = $02e50cfe922d2ca9$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children(props, meta)
    });
}
$02e50cfe922d2ca9$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $02e50cfe922d2ca9$export$2e2bcd8739ae039 = $02e50cfe922d2ca9$var$DropdownToggle;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $9c8dd72e635c1db4$var$SelectableContext = /*#__PURE__*/ $acw62.createContext(null);
const $9c8dd72e635c1db4$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $9c8dd72e635c1db4$export$2e2bcd8739ae039 = $9c8dd72e635c1db4$var$SelectableContext;



var $acw62 = parcelRequire("acw62");
const $45c958b882f3532f$var$NavContext = /*#__PURE__*/ $acw62.createContext(null);
$45c958b882f3532f$var$NavContext.displayName = 'NavContext';
var $45c958b882f3532f$export$2e2bcd8739ae039 = $45c958b882f3532f$var$NavContext;



var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = 'Button';
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;


const $1123d3fd1f42218c$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1123d3fd1f42218c$export$635202801f9383a0 = `rrUi`;
function $1123d3fd1f42218c$export$5cc3b7b83e34ade7(property) {
    return `${$1123d3fd1f42218c$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1123d3fd1f42218c$export$7776c0a7cd2eb3e0(property) {
    return `${$1123d3fd1f42218c$export$635202801f9383a0}${property}`;
}



var $ayMG0 = parcelRequire("ayMG0");
const $e30823bf64a2218d$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e30823bf64a2218d$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const navContext = (0, $acw62.useContext)((0, $45c958b882f3532f$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $e30823bf64a2218d$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $0522fa2e4977c358$export$2e2bcd8739ae039) } = _ref, props = $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(_ref, $e30823bf64a2218d$var$_excluded);
    const [dropdownItemProps] = $e30823bf64a2218d$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$e30823bf64a2218d$var$DropdownItem.displayName = 'DropdownItem';
var $e30823bf64a2218d$export$2e2bcd8739ae039 = $e30823bf64a2218d$var$DropdownItem;





var $acw62 = parcelRequire("acw62");

const $0e151397e562aebc$var$Context = /*#__PURE__*/ (0, $acw62.createContext)((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) ? window : undefined);
const $0e151397e562aebc$export$f7d306aeb1cf5fbc = $0e151397e562aebc$var$Context.Provider;
function $0e151397e562aebc$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)($0e151397e562aebc$var$Context);
}



var $ayMG0 = parcelRequire("ayMG0");
function $583bd49bf9b8480b$var$useRefWithUpdate() {
    const forceUpdate = (0, $e12c5402755aae29$export$2e2bcd8739ae039)();
    const ref = (0, $acw62.useRef)(null);
    const attachRef = (0, $acw62.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $583bd49bf9b8480b$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $7060bb66c8fa08f7$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $27d585c6d75dcd23$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $acw62.useRef)(null);
    const focusInDropdown = (0, $acw62.useRef)(false);
    const onSelectCtx = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const toggle = (0, $acw62.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $acw62.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $838dd0f898428a09$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $02e50cfe922d2ca9$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $acw62.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $acw62.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $f665bd0f5e0a2735$export$2e2bcd8739ae039)((0, $acw62.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $28419dce7921d430$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $845df35e9a3b7033$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$583bd49bf9b8480b$var$Dropdown.displayName = 'Dropdown';
$583bd49bf9b8480b$var$Dropdown.Menu = (0, $7b01c7ecb51f8572$export$2e2bcd8739ae039);
$583bd49bf9b8480b$var$Dropdown.Toggle = (0, $02e50cfe922d2ca9$export$2e2bcd8739ae039);
$583bd49bf9b8480b$var$Dropdown.Item = (0, $e30823bf64a2218d$export$2e2bcd8739ae039);
var $583bd49bf9b8480b$export$2e2bcd8739ae039 = $583bd49bf9b8480b$var$Dropdown;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");
var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler;
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $1En50.default)(_ref, [
            $b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $8nd05.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");


var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $b7f5460541b42e0f$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($b7f5460541b42e0f$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $8nd05.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $8nd05.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, key) && $b7f5460541b42e0f$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $1En50.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $c8a186e1757974bb$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $8nd05.default)({
        innerRef: function innerRef() {}
    }, $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $8nd05.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $8nd05.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;


function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $acw62 = parcelRequire("acw62");
"use client";
const $dca786c6a99c4e45$var$DropdownContext = /*#__PURE__*/ $acw62.createContext({});
$dca786c6a99c4e45$var$DropdownContext.displayName = 'DropdownContext';
var $dca786c6a99c4e45$export$2e2bcd8739ae039 = $dca786c6a99c4e45$var$DropdownContext;



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $626bd95fa485b758$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $626bd95fa485b758$export$ff817e17bad2e091 = 'xs';
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f, Provider: $626bd95fa485b758$var$Provider } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === 'rtl';
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $5a4fb33eeda93525$var$DropdownDivider = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$5a4fb33eeda93525$var$DropdownDivider.displayName = 'DropdownDivider';
var $5a4fb33eeda93525$export$2e2bcd8739ae039 = $5a4fb33eeda93525$var$DropdownDivider;



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $ec852ac21aa53987$var$DropdownHeader = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$ec852ac21aa53987$var$DropdownHeader.displayName = 'DropdownHeader';
var $ec852ac21aa53987$export$2e2bcd8739ae039 = $ec852ac21aa53987$var$DropdownHeader;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
function $123822626b455986$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $acw62.useCallback)(()=>document, []);
    return (0, $f665bd0f5e0a2735$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $acw62 = parcelRequire("acw62");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $9b2e3fbaf6312caa$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $acw62.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $9b2e3fbaf6312caa$export$2e2bcd8739ae039 = $9b2e3fbaf6312caa$var$useInterval;



var $acw62 = parcelRequire("acw62");

function $a09c0dd7291b0177$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $cbe95659e68dd1dd$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $acw62.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $a09c0dd7291b0177$export$2e2bcd8739ae039 = $a09c0dd7291b0177$var$useRafInterval;



var $acw62 = parcelRequire("acw62");
function $3473f9615acd9416$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $acw62.useState)(initialState);
    const updater = (0, $acw62.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $a03001e30ff1047d$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $3473f9615acd9416$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $acw62 = parcelRequire("acw62");
function $f003183c755c096a$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $acw62.useState)({
        image: null,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $6b8eaefeef7398a7$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $6b8eaefeef7398a7$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $6b8eaefeef7398a7$export$2e2bcd8739ae039 = $6b8eaefeef7398a7$var$isDOM || $6b8eaefeef7398a7$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


const $584ddec03c2e34ed$var$targetMap = new WeakMap();
let $584ddec03c2e34ed$var$resizeObserver;
function $584ddec03c2e34ed$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $584ddec03c2e34ed$var$resizeObserver = $584ddec03c2e34ed$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $584ddec03c2e34ed$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $584ddec03c2e34ed$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $acw62.useState)(null);
    (0, $6b8eaefeef7398a7$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $584ddec03c2e34ed$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $584ddec03c2e34ed$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $584ddec03c2e34ed$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






var $ayMG0 = parcelRequire("ayMG0");
const $a02c1087963bbb34$var$_excluded = [
    "onKeyDown"
];
function $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a02c1087963bbb34$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a02c1087963bbb34$var$Anchor = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(_ref, $a02c1087963bbb34$var$_excluded);
    const [buttonProps] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $838dd0f898428a09$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a02c1087963bbb34$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $ayMG0.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a02c1087963bbb34$var$Anchor.displayName = 'Anchor';
var $a02c1087963bbb34$export$2e2bcd8739ae039 = $a02c1087963bbb34$var$Anchor;




var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c3418d2c4a03af95$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $a02c1087963bbb34$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $e30823bf64a2218d$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$c3418d2c4a03af95$var$DropdownItem.displayName = 'DropdownItem';
var $c3418d2c4a03af95$export$2e2bcd8739ae039 = $c3418d2c4a03af95$var$DropdownItem;



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $29dccf165986723f$var$DropdownItemText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        ...props
    });
});
$29dccf165986723f$var$DropdownItemText.displayName = 'DropdownItemText';
var $29dccf165986723f$export$2e2bcd8739ae039 = $29dccf165986723f$var$DropdownItemText;



var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $63565b817d447aae$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $63565b817d447aae$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $63565b817d447aae$export$2e2bcd8739ae039 = $63565b817d447aae$var$isDOM || $63565b817d447aae$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);



var $acw62 = parcelRequire("acw62");
const $9d58c39545e3cedc$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    const a = $9d58c39545e3cedc$var$toFnRef(refA);
    const b = $9d58c39545e3cedc$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$9d58c39545e3cedc$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;





var $acw62 = parcelRequire("acw62");
"use client";
const $dda4a7e32e3b00d2$var$context = /*#__PURE__*/ $acw62.createContext(null);
$dda4a7e32e3b00d2$var$context.displayName = 'InputGroupContext';
var $dda4a7e32e3b00d2$export$2e2bcd8739ae039 = $dda4a7e32e3b00d2$var$context;



var $acw62 = parcelRequire("acw62");
"use client";
// TODO: check
const $46425249d1e44fce$var$context = /*#__PURE__*/ $acw62.createContext(null);
$46425249d1e44fce$var$context.displayName = 'NavbarContext';
var $46425249d1e44fce$export$2e2bcd8739ae039 = $46425249d1e44fce$var$context;




parcelRequire("acw62");

function $66831c738b74ab47$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $5d9daf1899b89eeb$var$DropdownMenu = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $acw62.useContext)((0, $dca786c6a99c4e45$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $acw62.useContext)((0, $dda4a7e32e3b00d2$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $7b01c7ecb51f8572$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)((0, $66831c738b74ab47$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$5d9daf1899b89eeb$var$DropdownMenu.displayName = 'DropdownMenu';
var $5d9daf1899b89eeb$export$2e2bcd8739ae039 = $5d9daf1899b89eeb$var$DropdownMenu;






var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $4ed343d4b409b2f2$var$Button = /*#__PURE__*/ $acw62.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$4ed343d4b409b2f2$var$Button.displayName = 'Button';
var $4ed343d4b409b2f2$export$2e2bcd8739ae039 = $4ed343d4b409b2f2$var$Button;





var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $6b03788ed4f0962b$var$DropdownToggle = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $02e50cfe922d2ca9$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(toggleProps.ref, (0, $66831c738b74ab47$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$6b03788ed4f0962b$var$DropdownToggle.displayName = 'DropdownToggle';
var $6b03788ed4f0962b$export$2e2bcd8739ae039 = $6b03788ed4f0962b$var$DropdownToggle;






var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $c111d4db45b07888$var$Dropdown = /*#__PURE__*/ $acw62.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $acw62.useContext)((0, $dda4a7e32e3b00d2$export$2e2bcd8739ae039));
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $5d9daf1899b89eeb$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $acw62.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dca786c6a99c4e45$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $583bd49bf9b8480b$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$c111d4db45b07888$var$Dropdown.displayName = 'Dropdown';
var $c111d4db45b07888$export$2e2bcd8739ae039 = Object.assign($c111d4db45b07888$var$Dropdown, {
    Toggle: (0, $6b03788ed4f0962b$export$2e2bcd8739ae039),
    Menu: (0, $5d9daf1899b89eeb$export$2e2bcd8739ae039),
    Item: (0, $c3418d2c4a03af95$export$2e2bcd8739ae039),
    ItemText: (0, $29dccf165986723f$export$2e2bcd8739ae039),
    Divider: (0, $5a4fb33eeda93525$export$2e2bcd8739ae039),
    Header: (0, $ec852ac21aa53987$export$2e2bcd8739ae039)
});







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $854b67c8016e8896$var$Heading = ({ customClass: customClass, text: text })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
        className: `c15 tac mb1rem ${customClass}`,
        children: text
    });
};
var $854b67c8016e8896$export$2e2bcd8739ae039 = $854b67c8016e8896$var$Heading;



function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}



var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $acw62 = parcelRequire("acw62");
var $9d88f0746ba78f85$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $9d88f0746ba78f85$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9d88f0746ba78f85$var$_excluded);
    var _useState = (0, $acw62.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $acw62.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $acw62.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $acw62.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $acw62.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}



var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");






function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");


var $8nd05 = parcelRequire("8nd05");

var $jjlaj = parcelRequire("jjlaj");



function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, true) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== 'body' || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = (0, $acw62.useLayoutEffect);


var $e5db4f66b3bbccc3$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e5db4f66b3bbccc3$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e5db4f66b3bbccc3$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e5db4f66b3bbccc3$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($e5db4f66b3bbccc3$var$isArray(value)) return value.filter(Boolean);
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e5db4f66b3bbccc3$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $e5db4f66b3bbccc3$var$_excluded$4);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e5db4f66b3bbccc3$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e5db4f66b3bbccc3$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e5db4f66b3bbccc3$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e5db4f66b3bbccc3$var$normalizedHeight(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollTop(el) {
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e5db4f66b3bbccc3$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e5db4f66b3bbccc3$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e5db4f66b3bbccc3$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e5db4f66b3bbccc3$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e5db4f66b3bbccc3$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e5db4f66b3bbccc3$export$b4171a6734a65d42;
    var start = $e5db4f66b3bbccc3$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e5db4f66b3bbccc3$var$easeOutCubic(currentTime, start, change, duration);
        $e5db4f66b3bbccc3$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e5db4f66b3bbccc3$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e5db4f66b3bbccc3$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e5db4f66b3bbccc3$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e5db4f66b3bbccc3$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e5db4f66b3bbccc3$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e5db4f66b3bbccc3$var$passiveOptionAccessed = false;
var $e5db4f66b3bbccc3$var$options = {
    get passive () {
        return $e5db4f66b3bbccc3$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e5db4f66b3bbccc3$var$w = typeof window !== 'undefined' ? window : {};
if ($e5db4f66b3bbccc3$var$w.addEventListener && $e5db4f66b3bbccc3$var$w.removeEventListener) {
    $e5db4f66b3bbccc3$var$w.addEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, $e5db4f66b3bbccc3$var$options);
    $e5db4f66b3bbccc3$var$w.removeEventListener('p', $e5db4f66b3bbccc3$export$b4171a6734a65d42, false);
}
var $e5db4f66b3bbccc3$export$2408f22a0fab9ae5 = $e5db4f66b3bbccc3$var$passiveOptionAccessed;
function $e5db4f66b3bbccc3$export$3466f893ebf79586(item) {
    return item != null;
}
function $e5db4f66b3bbccc3$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e5db4f66b3bbccc3$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e5db4f66b3bbccc3$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e5db4f66b3bbccc3$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e5db4f66b3bbccc3$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $e5db4f66b3bbccc3$var$_excluded$3 = [
    "children",
    "innerProps"
], $e5db4f66b3bbccc3$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $e5db4f66b3bbccc3$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e5db4f66b3bbccc3$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e5db4f66b3bbccc3$var$normalizedHeight(scrollParent);
    var scrollTop = $e5db4f66b3bbccc3$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e5db4f66b3bbccc3$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e5db4f66b3bbccc3$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e5db4f66b3bbccc3$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e5db4f66b3bbccc3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e5db4f66b3bbccc3$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, $e5db4f66b3bbccc3$var$alignToControl(placement), '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e5db4f66b3bbccc3$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// NOTE: internal only
var $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $acw62.useContext)($e5db4f66b3bbccc3$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(maxMenuHeight), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e5db4f66b3bbccc3$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $e5db4f66b3bbccc3$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e5db4f66b3bbccc3$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Menu$1 = $e5db4f66b3bbccc3$var$Menu;
// ==============================
// Menu List
// ==============================
var $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e5db4f66b3bbccc3$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e5db4f66b3bbccc3$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e5db4f66b3bbccc3$export$3b14a55fb2447963 = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$export$342063e11d6c3cad = $e5db4f66b3bbccc3$var$noticeCSS;
var $e5db4f66b3bbccc3$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $e5db4f66b3bbccc3$var$_excluded$3);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2$1);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $e5db4f66b3bbccc3$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e5db4f66b3bbccc3$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $acw62.useRef)(null);
    var cleanupRef = (0, $acw62.useRef)(null);
    var _useState5 = (0, $acw62.useState)($e5db4f66b3bbccc3$var$coercePlacement(menuPlacement)), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $acw62.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $acw62.useState)(null), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $acw62.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e5db4f66b3bbccc3$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $acw62.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $461947879dcdbcd4$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $e62b4578a0a2b358$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $acw62.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $jjlaj.jsx)("div", (0, $8nd05.default)({
        ref: setMenuPortalElement
    }, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e5db4f66b3bbccc3$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e5db4f66b3bbccc3$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e5db4f66b3bbccc3$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e5db4f66b3bbccc3$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e5db4f66b3bbccc3$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e5db4f66b3bbccc3$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$_templateObject;
var $e5db4f66b3bbccc3$var$_excluded$2 = [
    "size"
], $e5db4f66b3bbccc3$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $e5db4f66b3bbccc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e5db4f66b3bbccc3$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e5db4f66b3bbccc3$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $e5db4f66b3bbccc3$var$_excluded$2);
    return (0, $jjlaj.jsx)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e5db4f66b3bbccc3$var$_ref2
    }, props));
};
var $e5db4f66b3bbccc3$var$CrossIcon = function CrossIcon(props) {
    return (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $jjlaj.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e5db4f66b3bbccc3$var$DownChevron = function DownChevron(props) {
    return (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $jjlaj.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e5db4f66b3bbccc3$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e5db4f66b3bbccc3$export$f1e1789686576879 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$DownChevron, null));
};
var $e5db4f66b3bbccc3$export$407448d2b89b1813 = $e5db4f66b3bbccc3$var$baseCSS;
var $e5db4f66b3bbccc3$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e5db4f66b3bbccc3$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("span", (0, $8nd05.default)({}, innerProps, $e5db4f66b3bbccc3$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e5db4f66b3bbccc3$var$loadingDotAnimations = (0, $jjlaj.keyframes)($e5db4f66b3bbccc3$var$_templateObject || ($e5db4f66b3bbccc3$var$_templateObject = (0, $cbe7edbf3ccb8828$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e5db4f66b3bbccc3$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e5db4f66b3bbccc3$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $jjlaj.jsx)("span", {
        css: /*#__PURE__*/ (0, $jjlaj.css)({
            animation: "".concat($e5db4f66b3bbccc3$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e5db4f66b3bbccc3$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref7, $e5db4f66b3bbccc3$var$_excluded2);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $e5db4f66b3bbccc3$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e5db4f66b3bbccc3$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({
        ref: innerRef
    }, $e5db4f66b3bbccc3$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $e5db4f66b3bbccc3$var$Control$1 = $e5db4f66b3bbccc3$var$Control;
var $e5db4f66b3bbccc3$var$_excluded$1 = [
    "data"
];
var $e5db4f66b3bbccc3$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e5db4f66b3bbccc3$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $jjlaj.jsx)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $jjlaj.jsx)("div", null, children));
};
var $e5db4f66b3bbccc3$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e5db4f66b3bbccc3$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded$1);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e5db4f66b3bbccc3$var$Group$1 = $e5db4f66b3bbccc3$var$Group;
var $e5db4f66b3bbccc3$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e5db4f66b3bbccc3$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e5db4f66b3bbccc3$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e5db4f66b3bbccc3$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e5db4f66b3bbccc3$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e5db4f66b3bbccc3$var$spacingStyle)
};
var $e5db4f66b3bbccc3$var$inputStyle = function inputStyle(isHidden) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e5db4f66b3bbccc3$var$spacingStyle);
};
var $e5db4f66b3bbccc3$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e5db4f66b3bbccc3$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_cleanCommonProps, $e5db4f66b3bbccc3$var$_excluded);
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $jjlaj.jsx)("input", (0, $8nd05.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e5db4f66b3bbccc3$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e5db4f66b3bbccc3$var$Input$1 = $e5db4f66b3bbccc3$var$Input;
var $e5db4f66b3bbccc3$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e5db4f66b3bbccc3$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e5db4f66b3bbccc3$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $jjlaj.jsx)("div", innerProps, children);
};
var $e5db4f66b3bbccc3$var$MultiValueContainer = $e5db4f66b3bbccc3$var$MultiValueGeneric;
var $e5db4f66b3bbccc3$var$MultiValueLabel = $e5db4f66b3bbccc3$var$MultiValueGeneric;
function $e5db4f66b3bbccc3$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({
        role: "button"
    }, innerProps), children || (0, $jjlaj.jsx)($e5db4f66b3bbccc3$var$CrossIcon, {
        size: 14
    }));
}
var $e5db4f66b3bbccc3$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $jjlaj.jsx)(Container, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $jjlaj.jsx)(Label, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $jjlaj.jsx)(Remove, {
        data: data,
        innerProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e5db4f66b3bbccc3$var$MultiValue$1 = $e5db4f66b3bbccc3$var$MultiValue;
var $e5db4f66b3bbccc3$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e5db4f66b3bbccc3$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e5db4f66b3bbccc3$var$Option$1 = $e5db4f66b3bbccc3$var$Option;
var $e5db4f66b3bbccc3$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$Placeholder$1 = $e5db4f66b3bbccc3$var$Placeholder;
var $e5db4f66b3bbccc3$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e5db4f66b3bbccc3$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $jjlaj.jsx)("div", (0, $8nd05.default)({}, $e5db4f66b3bbccc3$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e5db4f66b3bbccc3$var$SingleValue$1 = $e5db4f66b3bbccc3$var$SingleValue;
var $e5db4f66b3bbccc3$export$db3b6bfb95261072 = {
    ClearIndicator: $e5db4f66b3bbccc3$var$ClearIndicator,
    Control: $e5db4f66b3bbccc3$var$Control$1,
    DropdownIndicator: $e5db4f66b3bbccc3$var$DropdownIndicator,
    DownChevron: $e5db4f66b3bbccc3$var$DownChevron,
    CrossIcon: $e5db4f66b3bbccc3$var$CrossIcon,
    Group: $e5db4f66b3bbccc3$var$Group$1,
    GroupHeading: $e5db4f66b3bbccc3$var$GroupHeading,
    IndicatorsContainer: $e5db4f66b3bbccc3$var$IndicatorsContainer,
    IndicatorSeparator: $e5db4f66b3bbccc3$var$IndicatorSeparator,
    Input: $e5db4f66b3bbccc3$var$Input$1,
    LoadingIndicator: $e5db4f66b3bbccc3$var$LoadingIndicator,
    Menu: $e5db4f66b3bbccc3$var$Menu$1,
    MenuList: $e5db4f66b3bbccc3$var$MenuList,
    MenuPortal: $e5db4f66b3bbccc3$var$MenuPortal,
    LoadingMessage: $e5db4f66b3bbccc3$var$LoadingMessage,
    NoOptionsMessage: $e5db4f66b3bbccc3$var$NoOptionsMessage,
    MultiValue: $e5db4f66b3bbccc3$var$MultiValue$1,
    MultiValueContainer: $e5db4f66b3bbccc3$var$MultiValueContainer,
    MultiValueLabel: $e5db4f66b3bbccc3$var$MultiValueLabel,
    MultiValueRemove: $e5db4f66b3bbccc3$var$MultiValueRemove,
    Option: $e5db4f66b3bbccc3$var$Option$1,
    Placeholder: $e5db4f66b3bbccc3$var$Placeholder$1,
    SelectContainer: $e5db4f66b3bbccc3$var$SelectContainer,
    SingleValue: $e5db4f66b3bbccc3$var$SingleValue$1,
    ValueContainer: $e5db4f66b3bbccc3$var$ValueContainer
};
var $e5db4f66b3bbccc3$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $e5db4f66b3bbccc3$export$db3b6bfb95261072), props.components);
};



var $jjlaj = parcelRequire("jjlaj");
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $4b23e30940068c4c$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $4b23e30940068c4c$var$A11yText = function A11yText(props) {
    return (0, $jjlaj.jsx)("span", (0, $8nd05.default)({
        css: $4b23e30940068c4c$var$_ref
    }, props));
};
var $4b23e30940068c4c$var$A11yText$1 = $4b23e30940068c4c$var$A11yText;
var $4b23e30940068c4c$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $4b23e30940068c4c$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $4b23e30940068c4c$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $acw62.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $acw62.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $acw62.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $acw62.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $jjlaj.jsx)((0, $acw62.Fragment), null, (0, $jjlaj.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $jjlaj.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $jjlaj.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $jjlaj.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $jjlaj.jsx)((0, $acw62.Fragment), null, (0, $jjlaj.jsx)($4b23e30940068c4c$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $jjlaj.jsx)($4b23e30940068c4c$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $4b23e30940068c4c$var$LiveRegion$1 = $4b23e30940068c4c$var$LiveRegion;
var $4b23e30940068c4c$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $4b23e30940068c4c$var$anyDiacritic = new RegExp('[' + $4b23e30940068c4c$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $4b23e30940068c4c$var$diacriticToBase = {};
for(var $4b23e30940068c4c$var$i = 0; $4b23e30940068c4c$var$i < $4b23e30940068c4c$var$diacritics.length; $4b23e30940068c4c$var$i++){
    var $4b23e30940068c4c$var$diacritic = $4b23e30940068c4c$var$diacritics[$4b23e30940068c4c$var$i];
    for(var $4b23e30940068c4c$var$j = 0; $4b23e30940068c4c$var$j < $4b23e30940068c4c$var$diacritic.letters.length; $4b23e30940068c4c$var$j++)$4b23e30940068c4c$var$diacriticToBase[$4b23e30940068c4c$var$diacritic.letters[$4b23e30940068c4c$var$j]] = $4b23e30940068c4c$var$diacritic.base;
}
var $4b23e30940068c4c$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($4b23e30940068c4c$var$anyDiacritic, function(match) {
        return $4b23e30940068c4c$var$diacriticToBase[match];
    });
};
var $4b23e30940068c4c$var$memoizedStripDiacriticsForInput = (0, $e111773323c0bcc0$export$2e2bcd8739ae039)($4b23e30940068c4c$var$stripDiacritics);
var $4b23e30940068c4c$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $4b23e30940068c4c$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $4b23e30940068c4c$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $4b23e30940068c4c$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $4b23e30940068c4c$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $4b23e30940068c4c$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $4b23e30940068c4c$var$memoizedStripDiacriticsForInput(input);
            candidate = $4b23e30940068c4c$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $4b23e30940068c4c$var$_excluded = [
    "innerRef"
];
function $4b23e30940068c4c$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $4b23e30940068c4c$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $e5db4f66b3bbccc3$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $jjlaj.jsx)("input", (0, $8nd05.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $jjlaj.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $4b23e30940068c4c$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $4b23e30940068c4c$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $acw62.useRef)(false);
    var isTop = (0, $acw62.useRef)(false);
    var touchStart = (0, $acw62.useRef)(0);
    var scrollTarget = (0, $acw62.useRef)(null);
    var handleEventDelta = (0, $acw62.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $4b23e30940068c4c$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $acw62.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $acw62.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $acw62.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $e5db4f66b3bbccc3$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $acw62.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $4b23e30940068c4c$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $4b23e30940068c4c$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $4b23e30940068c4c$var$preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function $4b23e30940068c4c$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4b23e30940068c4c$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4b23e30940068c4c$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $4b23e30940068c4c$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $4b23e30940068c4c$var$activeScrollLocks = 0;
var $4b23e30940068c4c$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4b23e30940068c4c$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $acw62.useRef)({});
    var scrollTarget = (0, $acw62.useRef)(null);
    var addScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$4b23e30940068c4c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4b23e30940068c4c$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4b23e30940068c4c$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4b23e30940068c4c$var$LOCK_STYLES).forEach(function(key) {
                var val = $4b23e30940068c4c$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $4b23e30940068c4c$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $4b23e30940068c4c$var$preventTouchMove, $4b23e30940068c4c$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $4b23e30940068c4c$var$preventInertiaScroll, $4b23e30940068c4c$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $4b23e30940068c4c$var$allowTouchMove, $4b23e30940068c4c$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4b23e30940068c4c$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $acw62.useCallback)(function(touchScrollTarget) {
        if (!$4b23e30940068c4c$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4b23e30940068c4c$var$activeScrollLocks = Math.max($4b23e30940068c4c$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4b23e30940068c4c$var$activeScrollLocks < 1) $4b23e30940068c4c$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4b23e30940068c4c$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $4b23e30940068c4c$var$preventTouchMove, $4b23e30940068c4c$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $4b23e30940068c4c$var$preventInertiaScroll, $4b23e30940068c4c$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $4b23e30940068c4c$var$allowTouchMove, $4b23e30940068c4c$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $acw62.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b23e30940068c4c$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $4b23e30940068c4c$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $4b23e30940068c4c$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $4b23e30940068c4c$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $4b23e30940068c4c$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $jjlaj.jsx)((0, $acw62.Fragment), null, lockEnabled && (0, $jjlaj.jsx)("div", {
        onClick: $4b23e30940068c4c$var$blurSelectInput,
        css: $4b23e30940068c4c$var$_ref2$1
    }), children(targetRef));
}
function $4b23e30940068c4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b23e30940068c4c$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $4b23e30940068c4c$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $jjlaj.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $4b23e30940068c4c$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $4b23e30940068c4c$var$RequiredInput$1 = $4b23e30940068c4c$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $4b23e30940068c4c$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $4b23e30940068c4c$var$isIPhone() {
    return $4b23e30940068c4c$var$testPlatform(/^iPhone/i);
}
function $4b23e30940068c4c$var$isMac() {
    return $4b23e30940068c4c$var$testPlatform(/^Mac/i);
}
function $4b23e30940068c4c$var$isIPad() {
    return $4b23e30940068c4c$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $4b23e30940068c4c$var$isMac() && navigator.maxTouchPoints > 1;
}
function $4b23e30940068c4c$var$isIOS() {
    return $4b23e30940068c4c$var$isIPhone() || $4b23e30940068c4c$var$isIPad();
}
function $4b23e30940068c4c$var$isAppleDevice() {
    return $4b23e30940068c4c$var$isMac() || $4b23e30940068c4c$var$isIOS();
}
var $4b23e30940068c4c$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $4b23e30940068c4c$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $4b23e30940068c4c$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $4b23e30940068c4c$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $4b23e30940068c4c$var$defaultStyles = {
    clearIndicator: (0, $e5db4f66b3bbccc3$export$407448d2b89b1813),
    container: (0, $e5db4f66b3bbccc3$export$8b22cf2602fb60ce),
    control: (0, $e5db4f66b3bbccc3$export$4368d992c4eafac0),
    dropdownIndicator: (0, $e5db4f66b3bbccc3$export$f1e1789686576879),
    group: (0, $e5db4f66b3bbccc3$export$39b482c5e57630a8),
    groupHeading: (0, $e5db4f66b3bbccc3$export$2d1720544b23b823),
    indicatorsContainer: (0, $e5db4f66b3bbccc3$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $e5db4f66b3bbccc3$export$dda1d9f60106f0e9),
    input: (0, $e5db4f66b3bbccc3$export$35e795649ee09318),
    loadingIndicator: (0, $e5db4f66b3bbccc3$export$882b5998b3b9117c),
    loadingMessage: (0, $e5db4f66b3bbccc3$export$342063e11d6c3cad),
    menu: (0, $e5db4f66b3bbccc3$export$953cecd6e717a553),
    menuList: (0, $e5db4f66b3bbccc3$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $e5db4f66b3bbccc3$export$ae1af26003f05816),
    multiValue: (0, $e5db4f66b3bbccc3$export$ffb5f4729a158638),
    multiValueLabel: (0, $e5db4f66b3bbccc3$export$9e5f44173e64f162),
    multiValueRemove: (0, $e5db4f66b3bbccc3$export$625550452a3fa3ec),
    noOptionsMessage: (0, $e5db4f66b3bbccc3$export$3b14a55fb2447963),
    option: (0, $e5db4f66b3bbccc3$export$90a7f3efeed30595),
    placeholder: (0, $e5db4f66b3bbccc3$export$efccba1c4a2ef57b),
    singleValue: (0, $e5db4f66b3bbccc3$export$d141bba7fdc215a3),
    valueContainer: (0, $e5db4f66b3bbccc3$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $4b23e30940068c4c$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $4b23e30940068c4c$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $4b23e30940068c4c$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $4b23e30940068c4c$var$baseUnit = 4;
// The minimum height of the control
var $4b23e30940068c4c$var$controlHeight = 38;
// The amount of space between the control and menu */
var $4b23e30940068c4c$var$menuGutter = $4b23e30940068c4c$var$baseUnit * 2;
var $4b23e30940068c4c$var$spacing = {
    baseUnit: $4b23e30940068c4c$var$baseUnit,
    controlHeight: $4b23e30940068c4c$var$controlHeight,
    menuGutter: $4b23e30940068c4c$var$menuGutter
};
var $4b23e30940068c4c$export$4368d992c4eafac0 = {
    borderRadius: $4b23e30940068c4c$var$borderRadius,
    colors: $4b23e30940068c4c$var$colors,
    spacing: $4b23e30940068c4c$var$spacing
};
var $4b23e30940068c4c$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $e5db4f66b3bbccc3$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $4b23e30940068c4c$export$db3b6bfb95261072(),
    formatGroupLabel: $4b23e30940068c4c$var$formatGroupLabel,
    getOptionLabel: $4b23e30940068c4c$export$8b22cf2602fb60ce,
    getOptionValue: $4b23e30940068c4c$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $4b23e30940068c4c$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $e5db4f66b3bbccc3$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $4b23e30940068c4c$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $4b23e30940068c4c$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $4b23e30940068c4c$var$_isOptionSelected(props, option, selectValue);
    var label = $4b23e30940068c4c$var$getOptionLabel(props, option);
    var value = $4b23e30940068c4c$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $4b23e30940068c4c$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $4b23e30940068c4c$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $4b23e30940068c4c$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $4b23e30940068c4c$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $e5db4f66b3bbccc3$export$3466f893ebf79586));
}
function $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $4b23e30940068c4c$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $4b23e30940068c4c$var$buildFocusableOptions(props, selectValue) {
    return $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions($4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue));
}
function $4b23e30940068c4c$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$4b23e30940068c4c$var$shouldHideSelectedOptions(props) || !isSelected) && $4b23e30940068c4c$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $4b23e30940068c4c$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $4b23e30940068c4c$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $4b23e30940068c4c$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $4b23e30940068c4c$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $4b23e30940068c4c$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $4b23e30940068c4c$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $4b23e30940068c4c$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $4b23e30940068c4c$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $4b23e30940068c4c$var$getOptionValue(props, i) === candidate;
    });
}
function $4b23e30940068c4c$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $4b23e30940068c4c$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $4b23e30940068c4c$var$instanceId = 1;
var $4b23e30940068c4c$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $4b23e30940068c4c$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $e5db4f66b3bbccc3$export$ef35774e6d314e91)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $e5db4f66b3bbccc3$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $4b23e30940068c4c$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $4b23e30940068c4c$var$buildFocusableOptionsWithIds($4b23e30940068c4c$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $e5db4f66b3bbccc3$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $4b23e30940068c4c$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $4b23e30940068c4c$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $4b23e30940068c4c$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $e5db4f66b3bbccc3$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $4b23e30940068c4c$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $4b23e30940068c4c$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $e5db4f66b3bbccc3$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $4b23e30940068c4c$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$4b23e30940068c4c$var$instanceId);
        _this.state.selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $4b23e30940068c4c$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $e5db4f66b3bbccc3$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $4b23e30940068c4c$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($4b23e30940068c4c$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $4b23e30940068c4c$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $4b23e30940068c4c$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $4b23e30940068c4c$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $4b23e30940068c4c$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $e5db4f66b3bbccc3$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $acw62.createElement(Input, (0, $8nd05.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $acw62.createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $acw62.createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $acw62.createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $acw62.createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $acw62.createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $acw62.createElement(Option, (0, $8nd05.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $acw62.createElement(Group, (0, $8nd05.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $acw62.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $acw62.createElement((0, $e5db4f66b3bbccc3$export$3a1a48c8f6ef640e), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $acw62.createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $acw62.createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $acw62.createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $acw62.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $acw62.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $acw62.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $acw62.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $acw62.createElement($4b23e30940068c4c$var$LiveRegion$1, (0, $8nd05.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $acw62.createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $acw62.createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $acw62.createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $acw62.createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $e5db4f66b3bbccc3$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $4b23e30940068c4c$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $4b23e30940068c4c$var$buildFocusableOptionsWithIds($4b23e30940068c4c$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $4b23e30940068c4c$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $4b23e30940068c4c$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $4b23e30940068c4c$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $e5db4f66b3bbccc3$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$4b23e30940068c4c$export$25ce5a424b770e84.defaultProps = $4b23e30940068c4c$export$407448d2b89b1813;



var $eP9YU = parcelRequire("eP9YU");

var $a9M6v = parcelRequire("a9M6v");

var $8de12fa6a893dcd1$exports = {};

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$8de12fa6a893dcd1$exports = $8de12fa6a893dcd1$var$_objectSpread2, $8de12fa6a893dcd1$exports.__esModule = true, $8de12fa6a893dcd1$exports["default"] = $8de12fa6a893dcd1$exports;


var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;


var $51f08ebed50a2438$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1e0ecff44bad0ea1$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1e0ecff44bad0ea1$exports(r, a) : void 0;
    }
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $bf2dbd940d8d1ee7$exports(r) || $efa3fde0b6100532$exports(r, e) || $51f08ebed50a2438$exports(r, e) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


var $c5fdcdd8d5286ae7$exports = {};

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $b050fc8434f4a0e1$exports = {};
var $7b4ac2338b8e8f97$exports = {};
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return $7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
$7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;


function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7b4ac2338b8e8f97$exports(t, e);
}
$b050fc8434f4a0e1$exports = $b050fc8434f4a0e1$var$_inherits, $b050fc8434f4a0e1$exports.__esModule = true, $b050fc8434f4a0e1$exports["default"] = $b050fc8434f4a0e1$exports;


var $6c89cb228f797fa5$exports = {};
var $93d4339c80153a6a$exports = {};
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return $93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
$93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;


var $426f299ee58329c3$exports = {};
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports)();
}
$426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports;


var $ac4cd79166dac6e4$exports = {};

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;
var $4c93951af9bb8a88$exports = {};
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$4c93951af9bb8a88$exports = $4c93951af9bb8a88$var$_assertThisInitialized, $4c93951af9bb8a88$exports.__esModule = true, $4c93951af9bb8a88$exports["default"] = $4c93951af9bb8a88$exports;


function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c93951af9bb8a88$exports(t);
}
$ac4cd79166dac6e4$exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, $ac4cd79166dac6e4$exports.__esModule = true, $ac4cd79166dac6e4$exports["default"] = $ac4cd79166dac6e4$exports;


function $6c89cb228f797fa5$var$_createSuper(t) {
    var r = $426f299ee58329c3$exports();
    return function() {
        var e, o = $93d4339c80153a6a$exports(t);
        if (r) {
            var s = $93d4339c80153a6a$exports(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $ac4cd79166dac6e4$exports(this, e);
    };
}
$6c89cb228f797fa5$exports = $6c89cb228f797fa5$var$_createSuper, $6c89cb228f797fa5$exports.__esModule = true, $6c89cb228f797fa5$exports["default"] = $6c89cb228f797fa5$exports;


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};

function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $1e0ecff44bad0ea1$exports(r);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;



var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $41f5c206613f56c9$exports(r) || $cce79e023a3a67e7$exports(r) || $51f08ebed50a2438$exports(r) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;



parcelRequire("41YNz");
var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;


parcelRequire("g5Zhu");
parcelRequire("1u0KT");


var $7532f3e29d96fa2a$var$StateManagedSelect = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $9d88f0746ba78f85$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $4b23e30940068c4c$export$25ce5a424b770e84), (0, $8nd05.default)({
        ref: ref
    }, baseSelectProps));
});
var $7532f3e29d96fa2a$export$2e2bcd8739ae039 = $7532f3e29d96fa2a$var$StateManagedSelect;
var $7532f3e29d96fa2a$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $acw62.useMemo)(function() {
        return (0, $a9M6v.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $eP9YU.C), {
        value: emotionCache
    }, children);
};


// Custom react select 
const $1eef38cfda4b0c52$export$edf5b2501a573922 = {
    control: (provided, state)=>({
            ...provided,
            cursor: "pointer",
            border: 'none',
            boxShadow: 'none',
            minHeight: 'initial'
        }),
    valueContainer: (provided)=>({
            ...provided,
            padding: '0.5rem'
        }),
    input: (provided)=>({
            ...provided,
            margin: 0,
            padding: 0
        }),
    placeholder: (provided)=>({
            ...provided,
            margin: 0,
            padding: 0
        }),
    dropdownIndicator: (provided)=>({
            ...provided,
            padding: 0
        }),
    indicatorSeparator: ()=>({
            display: 'none'
        }),
    menu: (provided, state)=>({
            ...provided,
            width: "96%",
            marginTop: 0
        }),
    option: (provided, state)=>({
            ...provided,
            backgroundColor: state.isSelected ? "#fc7785" : state.isFocused ? "#fde3e6" : provided.backgroundColor,
            color: state.isSelected ? "white" : provided.color,
            ':active': {
                ...provided[':active'],
                backgroundColor: state.isSelected ? "#fc7785" : "#fde3e6"
            }
        })
};
const $1eef38cfda4b0c52$export$8bfd8e47310744e6 = {
    control: (provided, state)=>({
            ...provided,
            cursor: "pointer",
            border: '1px solid #DBDFEE',
            boxShadow: 'none',
            minHeight: 'initial',
            borderRadius: '50px',
            padding: '0px 2px'
        }),
    valueContainer: (provided)=>({
            ...provided,
            padding: '0.5rem'
        }),
    input: (provided)=>({
            ...provided,
            margin: 0,
            padding: 0,
            fontSize: '13px'
        }),
    placeholder: (provided)=>({
            ...provided,
            margin: 0,
            padding: 0,
            color: '#151313'
        }),
    dropdownIndicator: (provided)=>({
            ...provided,
            padding: 0,
            color: '#4A67FF',
            marginRight: '4px'
        }),
    indicatorSeparator: ()=>({
            display: 'none'
        }),
    menu: (provided, state)=>({
            ...provided,
            width: "96%",
            marginTop: 0,
            zIndex: 9999,
            top: "80%",
            boxShadow: "0px 8px 14px #07070729"
        }),
    menuPortal: (provided)=>({
            ...provided,
            zIndex: 99999
        }),
    option: (provided, state)=>({
            ...provided,
            backgroundColor: state.isSelected ? "#fc7785" : state.isFocused ? "#fde3e6" : provided.backgroundColor,
            color: state.isSelected ? "white" : "#151313B3",
            ':active': {
                ...provided[':active'],
                backgroundColor: state.isSelected ? "#fc7785" : "#fde3e6"
            },
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer"
        })
};
const $1eef38cfda4b0c52$export$70ef88cdd0c977d9 = (userPermissions)=>{
    if (!userPermissions) return false;
    return [
        "D001",
        "D002",
        "D003",
        "D004",
        "D005",
        "D006",
        "D007",
        "D008",
        "D009",
        "D010",
        "D011",
        "D012",
        "D013",
        "D014",
        "D015",
        "D016",
        "D017",
        "D018",
        "D019",
        "D020"
    ].every((key)=>userPermissions[key] === true);
};
const $1eef38cfda4b0c52$export$ea83aec15bf055d7 = (userPermissions)=>{
    if (userPermissions) {
        const allTheDataRepoSections = new Set([
            'D001',
            'D002',
            'D003',
            'D004',
            'D005',
            'D006',
            'D007',
            'D008',
            'D009',
            'D010',
            'D011',
            'D012',
            'D013',
            'D014',
            'D015',
            'D016',
            'D017',
            'D018',
            'D019',
            'D020'
        ]);
        for (const key of allTheDataRepoSections){
            if (userPermissions[key]) return false;
        }
    }
    return true;
};
const $1eef38cfda4b0c52$export$f5f94221ec047dbf = ({ company: company, user: user })=>{
    const createdByRole = company?.creatorId?.createdBy?.role?.toLowerCase();
    const hasPartner = !!company?.partnerId;
    const hasCFOService = !!company?.providesCFOServices;
    const isCreatedByAdvisorOrInvestor = !createdByRole || [
        'investor',
        'advisor'
    ].includes(createdByRole);
    if ((company?.creatorId && !isCreatedByAdvisorOrInvestor && !hasPartner || hasPartner && !hasCFOService) && !(user && user['email'].includes('@cfocentre.com') && user['role'].toLowerCase() === "advisor" || company['advisorData'] && company['advisorData'].length && company['advisorData'].filter((advisor)=>advisor['email'].includes('@cfocentre.com')).length) && ![
        'investor',
        'advisor'
    ].includes(user['role'].toLowerCase())) return true;
    return false;
};
const $1eef38cfda4b0c52$export$884def0ebe460136 = ({ company: company, user: user })=>{
    const createdByRole = company?.creatorId?.createdBy?.role?.toLowerCase();
    const hasPartner = !!company?.partnerId;
    const hasCFOService = !!company?.providesCFOServices;
    const isAffiliated = !!company?.advisorId || hasPartner && hasCFOService;
    if (isAffiliated) return true;
    const isUnaffiliated = company?.creatorId && (!createdByRole || [
        'investor',
        'advisor'
    ].includes(createdByRole)) && !hasPartner;
    const isPartnerRotation = hasPartner && !hasCFOService;
    if (isUnaffiliated || isPartnerRotation) return true;
    return false;
};


const $e5752a2a792eca99$var$options = [
    {
        value: 'Subsidiary',
        label: 'Subsidiary'
    },
    {
        value: 'Associate',
        label: 'Associate'
    }
];
const $e5752a2a792eca99$var$CreateGroupModal = ({ modalType: modalType, handleCreateGroup: handleCreateGroup, companiesGroup: companiesGroup, companies: companies, parentCompany: parentCompany, setParentCompany: setParentCompany, handleChildCompany: handleChildCompany, user: user, profileClass: profileClass })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [selectedCompany, setSelectedCompany] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const onCloseHandler = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        onCloseHandler: onCloseHandler,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $854b67c8016e8896$export$2e2bcd8739ae039), {
                    text: "Add a Group"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mra mla fs1rem w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mla mra",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr mt1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                                    className: "dropdown-add-group",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                                            variant: "success",
                                            id: "dropdown-basic",
                                            className: "dropdown-btn cp pl4rem w95 br5px p1rem pr bg1 bs1px brss bo42",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: `c15 op70 fw500 fsi`,
                                                    children: parentCompany?.['cName'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            "Parent: ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                className: "fw600 fsi",
                                                                children: `${parentCompany?.['cName']}`
                                                            })
                                                        ]
                                                    }) : "Please select Parent company"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "icon-right pa r0 mr1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            className: "ml0-5rem w1rem h1rem f6 f6-xl",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 448 512",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                className: "fa-secondary",
                                                                d: "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                    width: "24",
                                                    height: "24",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M5.5 14.5V16.5921C4.91925 16.7992 4.5 17.349 4.5 18C4.5 18.8271 5.17285 19.5 6 19.5C6.82715 19.5 7.5 18.8271 7.5 18C7.5 17.349 7.08075 16.7992 6.5 16.5921V15H7.5V14H6C5.72363 14 5.5 14.2236 5.5 14.5ZM6 18.5C5.72412 18.5 5.5 18.2759 5.5 18C5.5 17.7241 5.72412 17.5 6 17.5C6.27588 17.5 6.5 17.7241 6.5 18C6.5 18.2759 6.27588 18.5 6 18.5Z",
                                                            fill: "#151313"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M5.5 10V7.90787C4.91925 7.70081 4.5 7.15097 4.5 6.5C4.5 5.67285 5.17285 5 6 5C6.82715 5 7.5 5.67285 7.5 6.5C7.5 7.15097 7.08075 7.70081 6.5 7.90787V9.5H9V10.5L6 10.5C5.72363 10.5 5.5 10.2764 5.5 10ZM6 6C5.72412 6 5.5 6.22412 5.5 6.5C5.5 6.77588 5.72412 7 6 7C6.27588 7 6.5 6.77588 6.5 6.5C6.5 6.22412 6.27588 6 6 6Z",
                                                            fill: "#151313"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M18.5 14.5V16.5921C19.0807 16.7992 19.5 17.349 19.5 18C19.5 18.8271 18.8271 19.5 18 19.5C17.1729 19.5 16.5 18.8271 16.5 18C16.5 17.349 16.9193 16.7992 17.5 16.5921V15H16.5V14H18C18.2764 14 18.5 14.2236 18.5 14.5ZM18 18.5C18.2759 18.5 18.5 18.2759 18.5 18C18.5 17.7241 18.2759 17.5 18 17.5C17.7241 17.5 17.5 17.7241 17.5 18C17.5 18.2759 17.7241 18.5 18 18.5Z",
                                                            fill: "#151313"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M18.5 10V7.90787C19.0807 7.70081 19.5 7.15097 19.5 6.5C19.5 5.67285 18.8271 5 18 5C17.1729 5 16.5 5.67285 16.5 6.5C16.5 7.15097 16.9193 7.70081 17.5 7.90787V9.5H15V10.5L18 10.5C18.2764 10.5 18.5 10.2764 18.5 10ZM18 6C18.2759 6 18.5 6.22412 18.5 6.5C18.5 6.77588 18.2759 7 18 7C17.7241 7 17.5 6.77588 17.5 6.5C17.5 6.22412 17.7241 6 18 6Z",
                                                            fill: "#151313"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                            "clip-path": "url(#clip0_5984_43387)",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M15.5156 10.125H15.125V8.17188C15.125 7.5257 14.5993 7 13.9531 7H10.0469C9.4007 7 8.875 7.5257 8.875 8.17188V10.125H8.48438C7.8382 10.125 7.3125 10.6507 7.3125 11.2969V17H16.6875V11.2969C16.6875 10.6507 16.1618 10.125 15.5156 10.125ZM8.875 16.2188H8.09375V11.2969C8.09375 11.0815 8.26898 10.9062 8.48438 10.9062H8.875V16.2188ZM12.7812 16.2188H11.2188V15.5938H12.7812V16.2188ZM14.3438 16.2188H13.5625V14.8125H10.4375V16.2188H9.65625V8.17188C9.65625 7.95648 9.83148 7.78125 10.0469 7.78125H13.9531C14.1685 7.78125 14.3438 7.95648 14.3438 8.17188V16.2188ZM15.9062 16.2188H15.125V10.9062H15.5156C15.731 10.9062 15.9062 11.0815 15.9062 11.2969V16.2188ZM10.4375 9.34375H13.5625V8.5625H10.4375V9.34375ZM10.4375 10.9062H13.5625V10.125H10.4375V10.9062ZM10.4375 12.4688H13.5625V11.6875H10.4375V12.4688ZM10.4375 14.0312H13.5625V13.25H10.4375V14.0312Z",
                                                                fill: "#4A67FF"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                id: "clip0_5984_43387",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                    width: "10",
                                                                    height: "10",
                                                                    fill: "white",
                                                                    transform: "translate(7 7)"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                                            className: "dropdown-content cp shadow fww br10px btrr0px btlr0px pr pt1rem pb1rem",
                                            children: companies && companies.map((company, idx)=>{
                                                if (!company?.['childrenCompanies']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                                    onClick: ()=>setParentCompany(company),
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "item fs1rem p0rem mb1rem cp c36",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "deta-dropdown-company df jcsb aic",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                className: "fs1-25rem",
                                                                children: company['cName']
                                                            })
                                                        })
                                                    })
                                                }, `dropdown-company-selection-group${idx}`);
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                parentCompany != null && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bottom-company-area",
                    style: {
                        overflowY: 'scroll',
                        maxHeight: '360px'
                    },
                    children: companies && companies.map((company, idx)=>{
                        if (company['_id'] !== parentCompany['_id'] && company['group'] !== "Parent") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                backgroundColor: '#F0F2FD80'
                            },
                            className: "company-detail-box df aic w95 bg1 bs1px brss bo45 br20px px0-75rem mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "new-shadow checkbox active w2rem h2rem br10px pr mr0-75rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        onChange: (event)=>{
                                            handleChildCompany({
                                                event: event,
                                                companyId: company['_id'],
                                                group: companiesGroup[company['_id']]?.['group'],
                                                selected: 'true'
                                            });
                                            if (event.target.checked) setSelectedCompany((prev)=>[
                                                    ...prev,
                                                    company['_id']
                                                ]);
                                            else {
                                                const filtered = selectedCompany.filter((comp)=>comp !== company['_id']);
                                                setSelectedCompany(filtered);
                                            }
                                        },
                                        id: `childCompnay-${company['_id']}`,
                                        className: "bo16 bw1px bss cp td250 w2rem h2rem br5px",
                                        type: "checkbox"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "company-detail df fww br10px fs1rem mb1rem mt1rem w100 aic jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc jcfs aifs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "fs1rem mr1rem w11rem c15",
                                                    children: company['cName']
                                                }),
                                                company['subscription'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs11px c45 mra tal w2rem",
                                                    children: company['subscription']?.toUpperCase()
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs11px c45 mra tal mra w3rem",
                                                    children: "INACTIVE"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem df jsc w4rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df w4rem jcc",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df username-area",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            flexDirection: "column",
                                                            alignItems: "end"
                                                        },
                                                        children: [
                                                            user['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: `w2rem h2rem df jcc aic br100 mr0-5rem bs4px brss bo34 ${profileClass}`,
                                                                src: user['profile'],
                                                                "data-tooltip": user.firstName ? user.firstName + " " + user?.lastName : "Register to show your name here"
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                        open: 'userDetail'
                                                                    })),
                                                                "data-tooltip": user.firstName ? user.firstName + " " + user?.lastName : "Register to show your name here",
                                                                className: `w2rem h2rem df jcc aic br100 mr0-5rem fs0-75rem ${profileClass}`,
                                                                children: user.firstName ? user.firstName[0] + user?.lastName?.[0] : "?"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "ass fs0-75rem mt0-5rem c15",
                                                                children: company['role']
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "dropdown-company w8rem px0-5rem py0-5rem custom-dropdown-wrapper",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                defaultValue: $e5752a2a792eca99$var$options.find((opt)=>opt.value === companiesGroup[company['_id']]?.['group']),
                                                options: $e5752a2a792eca99$var$options,
                                                classNamePrefix: "custom-dropdown",
                                                placeholder: "Group",
                                                styles: (0, $1eef38cfda4b0c52$export$8bfd8e47310744e6),
                                                onChange: (selected)=>handleChildCompany({
                                                        companyId: company['_id'],
                                                        group: selected.value
                                                    }),
                                                id: `group-${company['_id']}`,
                                                menuPortalTarget: document.body
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "percentage-area ml1rem w5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "input-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultValue: companiesGroup[company['_id']]?.['percentage'],
                                                    onChange: (e)=>handleChildCompany({
                                                            companyId: company['_id'],
                                                            group: companiesGroup[company['_id']]?.['group'],
                                                            percentage: e.target.value
                                                        }),
                                                    placeholder: "0%",
                                                    id: `percentage-${company['_id']}`,
                                                    type: "text",
                                                    className: "fw600 bg1 bs1px brss bo31 br10px py0-5rem px1rem percentage",
                                                    min: "1",
                                                    max: "100"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, `${idx}-createGroup`);
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt1rem df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        "data-tooltip": !selectedCompany.length ? "Please select a company to create group" : "",
                        style: {
                            cursor: !selectedCompany.length ? 'not-allowed' : 'pointer'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            btnType: "warning",
                            text: "Create Group",
                            disabled: !selectedCompany.length,
                            onClick: handleCreateGroup,
                            style: {
                                pointerEvents: !selectedCompany.length ? 'none' : 'auto'
                            }
                        })
                    })
                })
            ]
        })
    });
};
var $e5752a2a792eca99$export$2e2bcd8739ae039 = $e5752a2a792eca99$var$CreateGroupModal;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $e84a498389ca6ed9$var$ALL_STEPS = [
    {
        key: 'select',
        label: 'Select Files'
    },
    {
        key: 'indexing',
        label: 'Indexing & Analyzing',
        keys: [
            'uploading',
            'indexing'
        ]
    },
    {
        key: 'allocation',
        label: 'Allocation',
        keys: [
            'allocation',
            'processing'
        ]
    },
    {
        key: 'filling',
        label: 'Filling Answers'
    },
    {
        key: 'result',
        label: 'Summary'
    }
];
const $e84a498389ca6ed9$var$ALL_STEPS_WITH_EXTRA = [
    {
        key: 'select',
        label: 'Select Files'
    },
    {
        key: 'indexing',
        label: 'Indexing & Analyzing',
        keys: [
            'uploading',
            'indexing'
        ]
    },
    {
        key: 'allocation',
        label: 'Allocation',
        keys: [
            'allocation',
            'processing'
        ]
    },
    {
        key: 'filling',
        label: 'Filling Answers'
    },
    {
        key: 'crossFileUpload',
        label: 'Other Module Files'
    },
    {
        key: 'otherModules',
        label: 'Other Module Answers'
    },
    {
        key: 'result',
        label: 'Summary'
    }
];
const $e84a498389ca6ed9$var$UPLOAD_ONLY_STEPS = $e84a498389ca6ed9$var$ALL_STEPS.slice(0, 3);
const $e84a498389ca6ed9$var$AutoFillStepper = ({ currentStep: currentStep, uploadOnly: uploadOnly = false, withOtherModules: withOtherModules = false })=>{
    const STEPS = uploadOnly ? $e84a498389ca6ed9$var$UPLOAD_ONLY_STEPS : withOtherModules ? $e84a498389ca6ed9$var$ALL_STEPS_WITH_EXTRA : $e84a498389ca6ed9$var$ALL_STEPS;
    const currentIndex = STEPS.findIndex((s)=>s.key === currentStep || s.keys && s.keys.includes(currentStep));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.25rem 1rem 0.75rem',
            gap: 0,
            width: '100%'
        },
        children: STEPS.map((step, i)=>{
            const isLastStep = i === STEPS.length - 1;
            const isDone = i < currentIndex || isLastStep && i === currentIndex;
            const isActive = i === currentIndex && !isDone;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            minWidth: '72px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: '28px',
                                    height: '28px',
                                    borderRadius: '50%',
                                    background: isDone ? '#22c55e' : isActive ? '#3B82F6' : '#E5E7EB',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                },
                                children: isDone ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M5 13l4 4L19 7",
                                        stroke: "#fff",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        color: isActive ? '#fff' : '#9CA3AF'
                                    },
                                    children: i + 1
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '10px',
                                    marginTop: '4px',
                                    fontWeight: isActive ? 700 : 400,
                                    color: isActive ? '#1D4ED8' : isDone ? '#059669' : '#9CA3AF',
                                    whiteSpace: 'nowrap'
                                },
                                children: step.label
                            })
                        ]
                    }),
                    i < STEPS.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            height: '2px',
                            flex: 1,
                            background: isDone ? '#22c55e' : '#E5E7EB',
                            marginBottom: '18px'
                        }
                    })
                ]
            }, step.key);
        })
    });
};
var $e84a498389ca6ed9$export$2e2bcd8739ae039 = $e84a498389ca6ed9$var$AutoFillStepper;


const $da3688aecc5696f3$var$FileUploadRepository = ({ percent: percent, gifFile: gifFile, from: from, to: to, fileName: fileName, filesUploaded: filesUploaded, totalFiles: totalFiles, heading: heading, onMinimize: onMinimize, onCancel: onCancel, stepperStep: stepperStep })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: "fileUploadRepository",
        className: "td500 zi4 pen df jcc aic fdc",
        style: {
            padding: "1rem",
            width: '100%',
            maxWidth: '1000px'
        },
        children: [
            stepperStep && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e84a498389ca6ed9$export$2e2bcd8739ae039), {
                currentStep: stepperStep
            }),
            gifFile,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb",
                style: {
                    width: "97%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fs12px c43",
                        children: [
                            " ",
                            from
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fs12px c43",
                        children: [
                            " ",
                            to
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "maw70 w700px df fdc jcc aic mt0rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                        className: "c15 fs24px w100 tac fw500",
                        children: [
                            " ",
                            heading || 'Uploading Files',
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 df jcc aic mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("progress", {
                            color: "green",
                            className: "maw90 w90 mr1rem",
                            style: {
                                border: 'none'
                            },
                            id: "upload-progress-bar",
                            value: percent,
                            max: "100"
                        })
                    }),
                    fileName ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "c15 fw500 fs13px my0-5rem",
                            children: [
                                " ",
                                fileName,
                                " | ",
                                filesUploaded,
                                " / ",
                                totalFiles
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs1rem w100 tac fw400 my2rem",
                        children: "Almost there"
                    }),
                    (onMinimize || onCancel) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcc",
                        style: {
                            gap: '1rem',
                            marginTop: '0.5rem'
                        },
                        children: [
                            onCancel && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onCancel,
                                style: {
                                    background: 'none',
                                    border: '1.5px solid #9CA3AF',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    color: '#6B7280',
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    padding: '0.3rem 1.2rem'
                                },
                                children: "Cancel"
                            }),
                            onMinimize && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onMinimize,
                                style: {
                                    background: 'none',
                                    border: '1.5px solid #3B82F6',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    color: '#3B82F6',
                                    fontSize: '13px',
                                    fontWeight: 500,
                                    padding: '0.3rem 1.2rem'
                                },
                                children: "Minimize"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $da3688aecc5696f3$export$2e2bcd8739ae039 = $da3688aecc5696f3$var$FileUploadRepository;









const $471542c2b606f48b$var$FileLoaderModal = ({ modalType: modalType })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const store = (0, $391671225302c365$export$6ccbb43953eebf8)();
    const { percent: percent = 20, fileName: fileName = null, totalFiles: totalFiles = null, filesUploaded: filesUploaded = null } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { autoFillContext: autoFillContext } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const autoFillContextRef = (0, $acw62.useRef)(autoFillContext);
    autoFillContextRef.current = autoFillContext;
    const selectedCompanyRef = (0, $acw62.useRef)(selectedCompany);
    selectedCompanyRef.current = selectedCompany;
    (0, $acw62.useEffect)(()=>{
        if (modalType !== 'fileUploadFilingAssistant') return;
        const onCompleted = async (data)=>{
            if (!data?.fromAutoFill) return;
            const ctx = autoFillContextRef.current;
            if (!ctx?.enabled) return;
            // Skip if autoFillStepper already triggered the fill (e.g. via onClickReallocationComplete)
            const stepperPhase = store.getState().modal.autoFillStepperPhase;
            if ([
                'filling',
                'otherModules',
                'result'
            ].includes(stepperPhase)) return;
            const company = selectedCompanyRef.current;
            const isMinimized = store.getState().modal.autoFillStatusBarVisible;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                ...isMinimized ? {} : {
                    open: 'autoFillStepper'
                },
                autoFillStepperPhase: 'filling',
                autoFillStatusBarPhase: 'filling',
                autoFillModuleName: ctx.scopeName || company?.modules?.[ctx.moduleType]?.heading || ctx.moduleType || '',
                autoFillTotal: 0,
                autoFillCurrent: 0,
                autoFillCurrentQuestion: '',
                autoFillQuestionText: '',
                autoFillSectionName: '',
                autoFillReadingFiles: [],
                autoFillStartTime: Date.now(),
                autoFillCompleted: false
            }));
            const payload = {
                companyId: ctx.companyId,
                moduleType: ctx.moduleType,
                minConfidence: 0.7,
                maxQuestions: 100
            };
            if (ctx.scope === 'section' && ctx.sectionCode) {
                payload.sectionCode = ctx.sectionCode;
                payload.maxQuestions = 50;
            }
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill', payload);
            if (response?.code === 200 && response?.body?.processed === 0) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarPhase: '',
                    autoFillStatusBarVisible: false
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('All questions are already answered');
            } else if (response?.code !== 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarPhase: 'error'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Auto-fill failed');
            }
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('processingFiles:completed', onCompleted);
        return ()=>(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('processingFiles:completed', onCompleted);
    }, [
        modalType
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            modalCardClasses: "maw1000px pr",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: {
                        position: "absolute",
                        right: "-1rem",
                        top: "-1rem"
                    },
                    src: (parcelRequire("a8Wtc")),
                    alt: "iconDiligentsia"
                }),
                modalType === "computerToDataRepository" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3688aecc5696f3$export$2e2bcd8739ae039), {
                    percent: percent,
                    fileName: fileName,
                    filesUploaded: filesUploaded,
                    totalFiles: totalFiles,
                    gifFile: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("2qpNL")),
                        alt: "fileUpload"
                    }),
                    from: "Your Computer",
                    to: "Data Repository"
                }) : modalType === "fileUploadFilingAssistant" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3688aecc5696f3$export$2e2bcd8739ae039), {
                    percent: percent,
                    gifFile: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("6bpyB")),
                        alt: "fileUpload"
                    }),
                    from: "Clarence",
                    to: "Data Repository",
                    heading: "Allocating files to sections and questions",
                    onMinimize: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: '',
                            autoFillStatusBarVisible: true,
                            autoFillStatusBarPhase: 'processingFiles'
                        })),
                    onCancel: async ()=>{
                        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/cancel', {});
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: '',
                            autoFillStatusBarVisible: false,
                            autoFillStatusBarPhase: ''
                        }));
                        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill cancelled');
                    },
                    stepperStep: "processing"
                }) : modalType === "computerToClarence" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da3688aecc5696f3$export$2e2bcd8739ae039), {
                    percent: percent,
                    fileName: fileName,
                    filesUploaded: filesUploaded,
                    totalFiles: totalFiles,
                    gifFile: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("lV6Oz")),
                        alt: "pc-to-data-clarence"
                    }),
                    from: "Your Computer",
                    to: "Clarence",
                    onMinimize: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: '',
                            autoFillStatusBarVisible: true,
                            autoFillStatusBarPhase: undefined
                        })),
                    onCancel: async ()=>{
                        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/cancel', {});
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: '',
                            autoFillStatusBarVisible: false,
                            autoFillStatusBarPhase: ''
                        }));
                        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill cancelled');
                    },
                    stepperStep: "uploading"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
            ]
        })
    });
};
var $471542c2b606f48b$export$2e2bcd8739ae039 = $471542c2b606f48b$var$FileLoaderModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





const $3152f26bbd79cc69$var$PasswordUpdated = ({ modalType: modalType, modalData: modalData, user: user })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const onCloseHandler = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "",
            historyData: null
        }));
    };
    const handleButtonClick = (modalData)=>{
        if (modalData && modalData['message']) onCloseHandler();
        else {
            navigate("/login");
            localStorage.clear("");
            sessionStorage.clear("");
            onCloseHandler();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        onCloseHandler: onCloseHandler,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc jcc aic",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "maw100px mb2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "96",
                        height: "96",
                        viewBox: "0 0 96 96",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                "clip-path": "url(#clip0_5984_45475)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M11.1204 48.0918C11.1204 60.425 17.2478 71.3271 26.6242 77.9196C28.2766 79.0819 28.3645 81.4953 26.7773 82.7448L26.7326 82.7799C25.6963 83.5959 24.2431 83.6501 23.1636 82.892C12.2175 75.2045 5.0625 62.4831 5.0625 48.0918C5.0625 24.7488 24.3845 5.79883 47.6806 5.59961V11.6589C27.728 11.8567 11.1204 28.093 11.1204 48.0918Z",
                                        fill: "#1ED688"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M48.7944 0.180886L59.9272 7.79587C60.5234 8.20383 60.5234 9.08346 59.9272 9.49142L48.7944 17.1064C48.1125 17.573 47.1875 17.0844 47.1875 16.259V1.02903C47.1875 0.202859 48.1125 -0.284934 48.7944 0.180886Z",
                                        fill: "#1AB975"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M84.8178 47.9084C84.8178 35.5751 78.6897 24.673 69.3132 18.0805C67.6609 16.9182 67.573 14.5048 69.1601 13.2553L69.2048 13.2202C70.2412 12.4043 71.6943 12.3501 72.7739 13.1081C83.7207 20.7956 90.875 33.517 90.875 47.9084C90.875 71.2514 71.5859 90.2013 48.2891 90.4005V84.3412C68.2417 84.1434 84.8178 67.9079 84.8178 47.9084Z",
                                        fill: "#1ED688"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M47.6766 11.0022C38.2598 11.1532 30.7734 19.0089 30.7734 28.4257V38.8832H34.8188V28.3418C34.8188 22.6514 42.003 15.165 47.6934 15.0307C53.5516 14.8964 61.0716 22.3157 61.0716 28.1571V38.8999H65.1169V28.1571C65.1169 18.6061 57.2612 10.8511 47.6766 11.0022Z",
                                        fill: "url(#paint0_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M47.7321 13.957C40.2624 14.0913 34.3203 21.1077 34.3203 29.5341V38.8837H37.5096V28.3423C37.5096 22.652 41.9914 17.8513 47.6817 17.717C53.5399 17.5827 58.3574 22.3163 58.3574 28.1409V38.8837H61.5466V29.2823C61.5634 20.7552 55.336 13.8227 47.7321 13.957Z",
                                        fill: "url(#paint1_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M47.9453 11.002V17.733C53.7028 17.733 58.3692 22.4162 58.3692 28.1569V38.8997H65.1003V28.1569C65.117 18.6898 57.4124 11.002 47.9453 11.002Z",
                                        fill: "url(#paint2_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M58.3708 28.1564V38.8993H65.1018V28.1564C65.1018 27.0654 65.0011 25.9911 64.7997 24.9336H57.8672C58.2029 25.9575 58.3708 27.0318 58.3708 28.1564Z",
                                        fill: "url(#paint3_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M37.5213 28.3587C37.5213 27.1669 37.7227 26.0255 38.0752 24.9512H31.1259C30.9077 26.0758 30.7734 27.234 30.7734 28.4258V38.8833H37.5045V28.3587H37.5213Z",
                                        fill: "url(#paint4_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M68.4317 79.745H28.497C25.461 79.745 23 77.2939 23 74.2707V43.8396C23 40.8161 25.4612 38.3652 28.497 38.3652H68.4319C71.4679 38.3652 73.9289 40.8163 73.9289 43.8396V74.2707C73.9289 77.2939 71.4677 79.745 68.4317 79.745Z",
                                        fill: "url(#paint5_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M23 65.9512V74.2567C23 77.2876 25.4612 79.7444 28.497 79.7444H68.4319C71.4679 79.7444 73.9289 77.2874 73.9289 74.2567V65.9512H23Z",
                                        fill: "url(#paint6_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M47.1503 95.8196L36.0175 88.2046C35.4213 87.7967 35.4213 86.917 36.0175 86.5091L47.1503 78.8941C47.8314 78.4276 48.7572 78.9161 48.7572 79.7415V94.9715C48.7572 95.7977 47.8314 96.2862 47.1503 95.8196Z",
                                        fill: "#1AB975"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M64.3224 54.2362L48.6355 66.998L44.2269 70.6677C43.1882 71.5312 41.8734 72 40.5361 72C40.3135 72 40.0908 71.9873 39.8661 71.9612C38.3062 71.7773 36.8706 70.0503 35.9288 68.7878L31.3501 62.1379C29.8148 60.0831 29.3029 56.5464 31.351 55.0026C32.7032 53.1724 36.8121 52.9471 38.3482 55.0026L42.0387 60.2493L42.0759 60.219L58.4038 47.0709C60.3753 45.4313 63.2984 45.7048 64.9327 47.6834C66.5671 49.6621 66.2939 52.5959 64.3224 54.2362Z",
                                        fill: "url(#paint7_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M65.1097 54.0345L48.4054 68C45.1829 66.428 42.3489 64.2553 40 61.5474L58.4406 46.1747C60.662 44.3761 63.9558 44.6761 65.7974 46.8466C67.639 49.017 67.3311 52.2352 65.1097 54.0345Z",
                                        fill: "url(#paint8_linear_5984_45475)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M63.5596 54.1122L48.5448 66.6807L44.7595 69.8496C43.8676 70.5952 42.7387 71 41.5905 71C41.3993 71 41.2081 70.989 41.0152 70.9665C39.6758 70.8077 38.4432 70.0906 37.6345 69.0004L31.7958 61.1445C30.4775 59.3701 30.8339 56.8513 32.5924 55.5183C34.3521 54.1877 36.8475 54.5474 38.1664 56.3224L42.1079 61.6272L42.1399 61.601L58.4777 47.9247C60.1704 46.5089 62.6803 46.7451 64.0836 48.4537C65.4869 50.1623 65.2523 52.6957 63.5596 54.1122Z",
                                        fill: "#1ED688"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M63.5508 54.2276L48.4442 67C45.9735 65.7424 43.8008 64.0042 42 61.838L58.4378 47.9397C60.1409 46.5009 62.6661 46.7409 64.078 48.4773C65.4899 50.2136 65.2539 52.7881 63.5508 54.2276Z",
                                        fill: "#35E298"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint0_linear_5984_45475",
                                        x1: "35.6453",
                                        y1: "9.68617",
                                        x2: "57.0012",
                                        y2: "47.1283",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EAF6FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.2729",
                                                "stop-color": "#E5F1FB"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5557",
                                                "stop-color": "#D9E6EF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8419",
                                                "stop-color": "#C4D2DC"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#B6C4CF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint1_linear_5984_45475",
                                        x1: "47.9503",
                                        y1: "46.208",
                                        x2: "47.9503",
                                        y2: "3.21418",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EAF6FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.2729",
                                                "stop-color": "#E5F1FB"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5557",
                                                "stop-color": "#D9E6EF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8419",
                                                "stop-color": "#C4D2DC"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#B6C4CF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint2_linear_5984_45475",
                                        x1: "60.8884",
                                        y1: "24.9433",
                                        x2: "67.0363",
                                        y2: "24.9433",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.179",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.035"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.3646",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.141"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5532",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.316"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.7438",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.563"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.9342",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.876"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#596C76"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint3_linear_5984_45475",
                                        x1: "61.4892",
                                        y1: "31.9683",
                                        x2: "61.4892",
                                        y2: "39.4629",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.179",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.035"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.3646",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.141"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5532",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.316"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.7438",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.563"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.9342",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.876"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#596C76"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint4_linear_5984_45475",
                                        x1: "34.4275",
                                        y1: "31.9691",
                                        x2: "34.4275",
                                        y2: "39.4637",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.179",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.035"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.3646",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.141"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5532",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.316"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.7438",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.563"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.9342",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.876"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#596C76"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint5_linear_5984_45475",
                                        x1: "35.0017",
                                        y1: "45.6481",
                                        x2: "57.4793",
                                        y2: "68.2189",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFDA2D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FDBF00"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint6_linear_5984_45475",
                                        x1: "48.4646",
                                        y1: "73.2078",
                                        x2: "48.4646",
                                        y2: "79.9944",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FF9100",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FF9100"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint7_linear_5984_45475",
                                        x1: "60.5",
                                        y1: "65.5",
                                        x2: "58.7171",
                                        y2: "51.1669",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFDA2D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FDBF00"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint8_linear_5984_45475",
                                        x1: "70.1608",
                                        y1: "63.4975",
                                        x2: "52.0826",
                                        y2: "33.1002",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFDA2D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FDBF00"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                        id: "clip0_5984_45475",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                            width: "96",
                                            height: "96",
                                            fill: "white"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 tac mb1rem",
                            children: "Password Updated"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 tac op70 mb1-5rem fs13px",
                            children: modalData && modalData.message ? modalData.message : "Your password has been reset successfully. You can now login to your account."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc mb2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                btnType: "warning",
                                style: {
                                    width: '210px'
                                },
                                text: modalData && modalData.message ? "Ok" : "Login",
                                onClick: ()=>handleButtonClick(modalData)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $3152f26bbd79cc69$export$2e2bcd8739ae039 = $3152f26bbd79cc69$var$PasswordUpdated;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");
// Generated by script, don't edit it please.

// Generated by script, please do not edit this file.

var $acw62 = parcelRequire("acw62");
function $d5578021b3b42b0f$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5578021b3b42b0f$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $d5578021b3b42b0f$var$_define_property(target, key, source[key]);
        });
    }
    return target;
}
var $d5578021b3b42b0f$var$Trash = function(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("svg", $d5578021b3b42b0f$var$_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5M7.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5M9.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5M1.5 3h12a.5.5 0 0 1 0 1h-12a.5.5 0 0 1 0-1"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M3 4v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V4zM2 3h11v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "m5.281 3 .311-1.243A1 1 0 0 1 6.562 1h1.877a1 1 0 0 1 .97.757L9.72 3H5.282zM4 4h7l-.621-2.485A2 2 0 0 0 8.439 0H6.562a2 2 0 0 0-1.94 1.515z"
    }));
};
var $d5578021b3b42b0f$var$ForwardRef = /*#__PURE__*/ (0, $acw62.forwardRef)($d5578021b3b42b0f$var$Trash);
var $d5578021b3b42b0f$export$2e2bcd8739ae039 = $d5578021b3b42b0f$var$ForwardRef;


var $1cee5c542a37a6fe$var$Trash = (0, $c8dd3ee526e4dc0e$export$2e2bcd8739ae039)({
    as: (0, $d5578021b3b42b0f$export$2e2bcd8739ae039),
    ariaLabel: 'trash',
    category: 'action',
    displayName: 'Trash'
});
var $1cee5c542a37a6fe$export$2e2bcd8739ae039 = $1cee5c542a37a6fe$var$Trash;


// Generated by script, don't edit it please.

// Generated by script, please do not edit this file.

var $acw62 = parcelRequire("acw62");
function $ed8f0a1404d563f0$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ed8f0a1404d563f0$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $ed8f0a1404d563f0$var$_define_property(target, key, source[key]);
        });
    }
    return target;
}
var $ed8f0a1404d563f0$var$Edit = function(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("svg", $ed8f0a1404d563f0$var$_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M14.5 15a.5.5 0 0 1 0 1h-13a.5.5 0 0 1 0-1zM13.253 1.061l.707.707c.586.586.554 1.567-.071 2.192l-1.872 1.872-.707-.707 1.872-1.873c.244-.244.255-.593.071-.778l-.707-.707c-.185-.185-.534-.173-.778.071L4.051 9.555l-.424 1.838 1.838-.424 4.323-4.324.707.707-4.526 4.527-3.677.849.849-3.677 7.92-7.92c.625-.625 1.606-.656 2.192-.071z"
    }));
};
var $ed8f0a1404d563f0$var$ForwardRef = /*#__PURE__*/ (0, $acw62.forwardRef)($ed8f0a1404d563f0$var$Edit);
var $ed8f0a1404d563f0$export$2e2bcd8739ae039 = $ed8f0a1404d563f0$var$ForwardRef;


var $42145ea066f6cec2$var$Edit = (0, $c8dd3ee526e4dc0e$export$2e2bcd8739ae039)({
    as: (0, $ed8f0a1404d563f0$export$2e2bcd8739ae039),
    ariaLabel: 'edit',
    category: 'action',
    displayName: 'Edit'
});
var $42145ea066f6cec2$export$2e2bcd8739ae039 = $42145ea066f6cec2$var$Edit;



// Generated by script, don't edit it please.

// Generated by script, please do not edit this file.

var $acw62 = parcelRequire("acw62");
function $2ae0c46b4d313c2e$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2ae0c46b4d313c2e$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $2ae0c46b4d313c2e$var$_define_property(target, key, source[key]);
        });
    }
    return target;
}
var $2ae0c46b4d313c2e$var$Visible = function(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("svg", $2ae0c46b4d313c2e$var$_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 4C5.581 4 3.338 5.303 1.247 8 3.339 10.697 5.581 12 8 12s4.662-1.303 6.753-4C12.661 5.303 10.419 4 8 4m0 9q-4.418 0-8-5 3.582-5 8-5c4.418 0 5.612 1.667 8 5q-3.581 5-8 5"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
    }));
};
var $2ae0c46b4d313c2e$var$ForwardRef = /*#__PURE__*/ (0, $acw62.forwardRef)($2ae0c46b4d313c2e$var$Visible);
var $2ae0c46b4d313c2e$export$2e2bcd8739ae039 = $2ae0c46b4d313c2e$var$ForwardRef;


var $42c665bd8834dbf3$var$Visible = (0, $c8dd3ee526e4dc0e$export$2e2bcd8739ae039)({
    as: (0, $2ae0c46b4d313c2e$export$2e2bcd8739ae039),
    ariaLabel: 'visible',
    category: 'status',
    displayName: 'Visible'
});
var $42c665bd8834dbf3$export$2e2bcd8739ae039 = $42c665bd8834dbf3$var$Visible;











var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f875d00b2138afe4$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $024a60f892d3fa61$export$46f01d01378ec5a2), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $kTdcz.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $1En50.default)(props, $f875d00b2138afe4$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2037fde3f2b67600$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');



var $1f9e6a63de7b308d$var$Send = function Send(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.493 5.031c-.358 0-.693-.175-.898-.468L9.81 3.437a2.406 2.406 0 0 0-1.974-1.03H3.5a2.406 2.406 0 0 0-2.406 2.405v11.375c0 .638.253 1.25.704 1.702a2.41 2.41 0 0 0 1.702.705h14a2.41 2.41 0 0 0 1.702-.705 2.41 2.41 0 0 0 .704-1.701v-8.75a2.41 2.41 0 0 0-.704-1.702A2.41 2.41 0 0 0 17.5 5.03h-6.007Zm0 1.313H17.5a1.096 1.096 0 0 1 1.094 1.093v8.75a1.095 1.095 0 0 1-1.094 1.094h-14a1.095 1.095 0 0 1-1.094-1.093V4.813c0-.604.49-1.094 1.094-1.094h4.337c.357 0 .693.175.897.468l.785 1.126a2.405 2.405 0 0 0 1.974 1.03Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.192 11.008H7.808a.808.808 0 0 0 0 1.615h5.384a.808.808 0 0 0 0-1.615Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m10.471 10.23 1.582 1.583-1.582 1.583a.807.807 0 1 0 1.142 1.141l2.153-2.153a.806.806 0 0 0 0-1.142l-2.153-2.154a.807.807 0 1 0-1.142 1.142Z",
                fill: "#4A67FF"
            })
        ]
    });
};
$1f9e6a63de7b308d$var$Send.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1f9e6a63de7b308d$var$Search = function Search(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#a)",
                fill: "#000",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M18.812 2.176c-2.901-2.901-7.622-2.901-10.524 0-2.76 2.76-2.894 7.169-.402 10.09l-.034.03-1.13 1.131-.78-.78a.613.613 0 0 0-.867 0L.697 17.025a2.332 2.332 0 0 0 0 3.294c.454.454 1.05.681 1.647.681.596 0 1.193-.227 1.647-.681l4.378-4.378a.613.613 0 0 0 0-.867l-.78-.78 1.13-1.13a.62.62 0 0 0 .033-.037 7.386 7.386 0 0 0 4.798 1.753 7.393 7.393 0 0 0 5.262-2.18 7.393 7.393 0 0 0 2.18-5.262 7.393 7.393 0 0 0-2.18-5.262ZM3.124 19.452a1.104 1.104 0 0 1-1.56-1.56l1.302-1.302 1.56 1.56-1.302 1.302Zm2.169-2.17-1.56-1.56 1.775-1.774 1.56 1.56-1.775 1.775Zm12.652-5.449a6.223 6.223 0 0 1-8.79 0 6.223 6.223 0 0 1 0-8.79 6.196 6.196 0 0 1 4.395-1.817c1.592 0 3.183.606 4.395 1.817a6.175 6.175 0 0 1 1.82 4.395c0 1.66-.646 3.221-1.82 4.395Z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m16.116 5.164-3.402 3.401-1.863-1.863a.613.613 0 1 0-.867.868l2.297 2.296a.611.611 0 0 0 .867 0l3.835-3.835a.613.613 0 1 0-.867-.867Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h21v21H0z"
                    })
                })
            })
        ]
    });
};
$1f9e6a63de7b308d$var$Search.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};





const $1f9e6a63de7b308d$var$ImportSummaryModal = ({ modalType: modalType })=>{
    // hooks and vars
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { fileReport: fileReport, currentScore: currentScore, reportHistories: reportHistories, profileClass: profileClass, tab: tab, autoFillContext: autoFillContext } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { selectedCompany: company } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const isModified = fileReport?.importResult && Object.entries(fileReport.importResult).some(([key, value])=>value.isModified === true);
    // File preview state
    const [previewFile, setPreviewFile] = (0, $acw62.useState)(null); // { name, url }
    const handleFilePreview = (file)=>{
        const url = file.location || file.url;
        if (!url) return;
        setPreviewFile({
            name: file.originalname || file.title,
            url: url
        });
    };
    // Auto-fill function to be called after allocation completes (if triggered from AutoFillButton)
    const runAutoFill = async (context)=>{
        if (!context?.enabled) return;
        const { companyId: companyId, moduleType: moduleType, sectionCode: sectionCode, scope: scope, scopeName: scopeName, onStart: onStart, onComplete: onComplete } = context;
        const payload = {
            companyId: companyId,
            moduleType: moduleType,
            minConfidence: 0.7
        };
        if (scope === 'section' && sectionCode) {
            payload.sectionCode = sectionCode;
            payload.maxQuestions = 50;
        } else payload.maxQuestions = 100;
        // Always start in minimized (status bar only) mode.
        // The user can maximize via the status bar if they want the full modal.
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            autoFillStatusBarVisible: true,
            autoFillModuleName: scopeName || company?.modules?.[moduleType]?.heading || moduleType || '',
            autoFillTotal: 0,
            autoFillCurrent: 0,
            autoFillCurrentQuestion: '',
            autoFillQuestionText: '',
            autoFillSectionName: '',
            autoFillReadingFiles: [],
            autoFillStartTime: Date.now(),
            autoFillCompleted: false,
            autoFillProcessed: 0,
            autoFillAnswered: 0,
            autoFillNeedsReview: 0,
            autoFillSkipped: 0,
            autoFillStatusBarPhase: 'filling'
        }));
        // Notify parent if callback provided
        onStart?.({
            scope: scope,
            moduleType: moduleType,
            sectionCode: sectionCode,
            total: payload.maxQuestions
        });
        // Progress updates are handled by AutoFillStatusBar via socket listeners (local state).
        // We do NOT dispatch progress to Redux here to avoid triggering Company/index.js re-renders.
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill', payload);
            if (response?.code === 200) {
                const { answered: answered, needsReview: needsReview, skipped: skipped, processed: processed } = response?.body || {};
                if (processed === 0) {
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: '',
                        autoFillStatusBarPhase: '',
                        autoFillStatusBarVisible: false
                    }));
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('All questions are already answered');
                    onComplete?.(response?.body);
                    return;
                }
            // AutoFillStatusBar handles completion via socket listener (local state).
            // Don't call onComplete here — it triggers reloadModule which navigates
            // to the module page even when the user is in minimized status bar view.
            // The reload will happen when the user closes the status bar or modal.
            } else {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarPhase: 'error',
                    autoFillError: response?.message || 'Auto-fill failed'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Auto-fill failed');
            }
        } catch (error) {
            console.error('Auto-fill error:', error);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                autoFillStatusBarPhase: 'error',
                autoFillError: 'Auto-fill failed. Please try again.'
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill failed. Please try again.');
        }
    };
    const [moduleContent] = (0, $acw62.useState)({
        'kpi': {
            heading: 'KPI',
            aiEnhanced: true,
            uploadFiles: false,
            subheading: 'Key Performance Indicators'
        },
        'repository': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Repository',
            subheading: 'Securely store all your important documents here'
        },
        'business-audit-investment': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'business-audit-growth': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'business-audit-exit': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'directors-questionnaire': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Directors Questionnaire',
            subheading: ''
        },
        'two-minute-test-exit': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Exit Ready Test',
            subheading: 'See How Exit Ready You Are'
        },
        'two-minute-test-growth': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Growth Ready Test',
            subheading: 'See How Growth Ready You Are'
        },
        'esg': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Environmental, Social & Governmental',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'software-development': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Software Development',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'warranty-disclosure': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Warranty Disclosure Schedule',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'two-minute-test-investment': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Investment Ready Test',
            subheading: 'How Investment Ready Are You'
        },
        'unaudited-certification': {
            sections: [],
            heading: 'Certification',
            subheading: 'This is your current certification'
        },
        'investor-lead': {
            uploadFiles: true,
            heading: 'Investor Match',
            subheading: 'Securely store all your important documents here'
        }
    });
    const onClickFileImportAuditLog = async (fileReportId)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportLogs/${fileReportId}`);
        (0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'fileReportAuditLog'
        }));
    };
    const onClickComplete = async ()=>{
        const moduleName = tab && tab !== "" ? tab : location.hash.includes("#") ? location.hash.replace("#", "") : location.hash;
        const moduleId = autoFillContext?.moduleId;
        let newFileReport = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };
        newFileReport = {
            ...newFileReport,
            importResult: Object.fromEntries(Object.entries(newFileReport.importResult).filter((item)=>item[1]['isModified']).map(([key, value])=>[
                    key,
                    {
                        file: value['file'],
                        section: value['section'],
                        originalSection: value['originalSection']
                    }
                ]))
        };
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        const allocateEndpoint = moduleId ? `/modules/allocateFiles` : `/company/allocateFiles`;
        const allocatePayload = moduleId ? {
            companyId: company._id,
            moduleId: moduleId,
            fileReport: newFileReport
        } : {
            companyId: company._id,
            tab: moduleName,
            fileReport: newFileReport
        };
        const resp = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(allocateEndpoint, allocatePayload);
        if (!resp || resp.code === 400) return;
        const updatedReport = resp.body['report'];
        const savedQuestions = resp.body?.savedQuestions;
        if (moduleId && savedQuestions?.length) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: {
                moduleId: String(moduleId),
                savedQuestions: savedQuestions
            }
        }));
        for(let i = 0; i < reportHistories.length; i++)if (reportHistories[i]['_id'] == updatedReport['_id']) {
            reportHistories[i] = updatedReport;
            break;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp['message']);
        if (!moduleId && location.pathname.includes(company._id)) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${company._id}?moduleName=${moduleName}`);
            if (res['code'] == 200) {
                res['body']['modules']['kpi'] = {
                    type: "kpi",
                    sections: []
                };
                for (let module of Object.values(res['body']['modules'])){
                    let content = module['type'].includes('directors-questionnaire') ? moduleContent['directors-questionnaire'] : moduleContent[module['type']];
                    if (content) {
                        module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
                        module['aiEnhanced'] = content['aiEnhanced'];
                        module['subheading'] = content['subHeading'];
                        module['uploadFiles'] = content['uploadFiles'];
                    }
                }
                res['body']['modules']['unaudited-certification'] = moduleContent['unaudited-certification'];
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(res['body']));
            }
        }
        dispatch((0, $12074930bd2c1829$export$4bdbd1eea6fc9500)(false));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            underProcessingTab: ''
        }));
    };
    const onClickReallocationComplete = async ()=>{
        const fileReportData = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };
        const moduleName = tab && tab !== "" ? tab : autoFillContext?.moduleType || (location.hash.includes("#") ? location.hash.replace("#", "") : location.hash);
        const companyId = company?._id || autoFillContext?.companyId;
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(fileReportData));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'processing',
            percent: 0
        }));
        const resp = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/allocateFiles`, {
            companyId: companyId,
            tab: moduleName,
            fileReport: fileReportData,
            fromAutoFill: !!autoFillContext?.enabled
        }, true);
        if (!resp || resp.code === 400) return;
        const updatedReport = resp.body['report'];
        for(let i = 0; i < reportHistories.length; i++)if (reportHistories[i]['_id'] == updatedReport['_id']) {
            reportHistories[i] = updatedReport;
            break;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp['message']);
        if (companyId && location.pathname.includes(companyId)) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}?moduleName=${moduleName}`);
            if (res['code'] == 200) {
                res['body']['modules']['kpi'] = {
                    type: "kpi",
                    sections: []
                };
                for (let module of Object.values(res['body']['modules'])){
                    let content = module['type'].includes('directors-questionnaire') ? moduleContent['directors-questionnaire'] : moduleContent[module['type']];
                    if (content) {
                        module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
                        module['aiEnhanced'] = content['aiEnhanced'];
                        module['subheading'] = content['subHeading'];
                        module['uploadFiles'] = content['uploadFiles'];
                    }
                }
                res['body']['modules']['unaudited-certification'] = moduleContent['unaudited-certification'];
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(res['body']));
            }
        }
        dispatch((0, $12074930bd2c1829$export$4bdbd1eea6fc9500)(false));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            underProcessingTab: ''
        }));
    // Modal stays open (fileUploadFilingAssistant) — processingFiles:completed socket event
    // will trigger runAutoFill and close the modal when backend processing finishes
    };
    const getSectionNameFromSection = (section, qNo)=>{
        if (section.sectionNo == qNo || section.no == qNo) {
            const name = section.sectionName || section.name || '';
            return {
                displayName: name,
                sectionOnly: name
            };
        }
        // Check questions inside this section/subfolder
        if (section.questions) {
            for (const question of Object.values(section.questions))if (question.qNo == qNo) {
                const sectionOnly = section.sectionName || section.name || '';
                return {
                    displayName: question.qDescription || sectionOnly,
                    sectionOnly: sectionOnly
                };
            }
        }
        if (section.subFolders) for (const subFolder of Object.values(section.subFolders)){
            const result = getSectionNameFromSection(subFolder, qNo);
            if (result) return result;
        }
        return null;
    };
    const getSectionName = (module, qNo, file, key)=>{
        if (qNo == "DXXX" || qNo == "SXXX") return {
            displayName: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onClick: ()=>handleEditDispatch({
                        key: key,
                        fileName: file.originalname,
                        from: 'fileReport',
                        actionType: "move",
                        fileData: file,
                        index: "0"
                    }),
                className: "bg62 br10px df aic p1rem jcsb fsi",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Please select section"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                        className: "c3"
                    })
                ]
            }),
            sectionOnly: ''
        };
        const sections = [
            ...module?.sections || []
        ];
        for (const section of sections){
            const result = getSectionNameFromSection(section, qNo);
            if (result) return {
                displayName: `${qNo} ${result.displayName}`,
                sectionOnly: result.sectionOnly
            };
        }
        // Fallback: use sectionName from backend allocation if available
        const entry = fileReport?.importResult && Object.values(fileReport.importResult).find((r)=>r.section?.includes(qNo) && r.sectionName);
        if (entry?.sectionName) return {
            displayName: `${qNo} ${entry.sectionName}`,
            sectionOnly: entry.sectionName
        };
        return {
            displayName: "Unknown",
            sectionOnly: ''
        };
    };
    const handleEditDispatch = (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(true));
    };
    function isSubarray(subarray, array) {
        const sortedSubarray = subarray.slice().sort();
        const sortedArray = array.slice().sort();
        let i = 0;
        return sortedArray.some((element)=>{
            if (element === sortedSubarray[i]) i++;
            return i === sortedSubarray.length;
        });
    }
    const calcAccuracyScore = (count)=>{
        let allocated = 0;
        for (const key of Object.keys(fileReport.importResult)){
            const currentSection = fileReport.importResult[key]['section'];
            const oldSection = fileReport.importResult[key]['originalSection'];
            if (oldSection.includes("DXXX") || oldSection.includes("SXXX")) continue;
            if (isSubarray(oldSection, currentSection)) allocated++;
        }
        const totalCount = count ?? Object.keys(fileReport.importResult).length;
        dispatch((0, $12074930bd2c1829$export$fb8d60304f3762b3)(!totalCount ? 0 : Math.round(allocated / totalCount * 100)));
        return !totalCount ? 0 : Math.round(allocated / totalCount * 100);
    };
    const removeSectionFromImport = async (fileKey, index1)=>{
        let sections = [
            ...fileReport.importResult[fileKey]['section']
        ];
        const _fileReport = {
            ...fileReport
        }; // Clone the fileReport object
        const qNo = sections[index1];
        sections.splice(index1, 1);
        // Get the file data
        const file = _fileReport.importResult[fileKey]['file'];
        if (sections.length === 0) {
            const { [fileKey]: removedFile, ...restOfFileReport } = _fileReport.importResult;
            _fileReport.importResult = restOfFileReport;
        } else _fileReport.importResult[fileKey] = {
            ..._fileReport.importResult[fileKey],
            section: sections
        };
        const score = calcAccuracyScore(Object.keys(_fileReport.importResult).length);
        // Send delete request
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteSection`, {
            companyId: company._id,
            fileReportId: _fileReport['_id'],
            fileKey: fileKey,
            index: index1,
            qNo: qNo,
            score: score,
            file: file
        });
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(_fileReport));
    };
    const getImportResultEntryHTML = (key)=>{
        const fileName = fileReport.importResult[key].file['originalname'];
        const file = fileReport.importResult[key].file;
        const section = fileReport.importResult[key]['section'];
        let module = {
            ...company.modules[tab || "repository"]
        };
        if (module) module = JSON.parse(JSON.stringify(module));
        if (Array.isArray(section)) {
            // Show one row per file (primary section) so the row count matches the file count.
            // Extra sections are shown as compact labels in the section cell.
            const primaryQNo = section[0];
            const extraQNos = section.slice(1).filter((q)=>q !== 'DXXX' && q !== 'SXXX');
            const { displayName: displayName, sectionOnly: sectionOnly } = getSectionName(module, primaryQNo, file, key);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                    className: "fis-tr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs14px fw600 tdu bg1 lightDot ${primaryQNo === 'DXXX' ? 'red' : fileReport['status'] == 'In Progress' ? 'orange' : 'green'}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "cp",
                                onClick: ()=>handleFilePreview(file),
                                "data-tooltip": "Click to preview file",
                                children: fileName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                            className: `tal mx1rem fs14px fw400 bg1 c15`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: sectionOnly
                                }),
                                extraQNos.map((q, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        "data-tooltip": q,
                                        style: {
                                            marginLeft: 4,
                                            background: '#E8EBF5',
                                            borderRadius: 50,
                                            padding: '2px 7px',
                                            fontSize: 10,
                                            fontWeight: 600,
                                            color: '#374151',
                                            display: 'inline-block'
                                        },
                                        children: [
                                            "+",
                                            q
                                        ]
                                    }, i))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal mx1rem fs14px fw400 bg1 c15`,
                            children: displayName
                        }),
                        fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdr jcc aic",
                                children: [
                                    primaryQNo !== "DXXX" ? /*#__PURE__*/ (0, $ayMG0.jsx)($1f9e6a63de7b308d$var$Send, {
                                        "data-tooltip": "Move",
                                        className: "mr1rem cp",
                                        onClick: ()=>handleEditDispatch({
                                                key: key,
                                                fileName: file.title,
                                                from: 'fileReport',
                                                actionType: "move",
                                                fileData: file,
                                                index: 0
                                            })
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cee5c542a37a6fe$export$2e2bcd8739ae039), {
                                        "data-tooltip": "Delete",
                                        onClick: ()=>removeSectionFromImport(key, 0),
                                        className: "cp f9 ml1rem"
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        } else {
            const { displayName: displayName, sectionOnly: sectionOnly } = getSectionName(module, section, file, key);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                    className: `${index == section.length - 1 ? 'fis-tr' : ''}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "cp tdu",
                                onClick: ()=>handleFilePreview(file),
                                "data-tooltip": "Click to preview file",
                                children: fileName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1 fis-td`,
                            children: sectionOnly
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1 fis-td`,
                            children: displayName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42145ea066f6cec2$export$2e2bcd8739ae039), {
                                onClick: handleEditDispatch({
                                    key: key,
                                    fileName: fileName
                                })
                            })
                        })
                    ]
                })
            });
        }
    };
    if (fileReport && Object.keys(company).length && modal['open'] == modalType) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            // onCloseHandler={() => dispatch(fetchCompanyData({ ...(tab && { moduleName: tab }), companyId: selectedCompany._id, selectedCompany }));}
            modalCardClasses: `mah80 p2rem`,
            customStyle: {
                maxWidth: '1400px',
                padding: '2rem',
                zIndex: 9,
                marginTop: '2rem',
                transition: 'max-width 0.3s ease'
            },
            girlComponent: !previewFile ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'relative'
                },
                children: fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX"))).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("f5cbi")),
                    alt: "messageLadie",
                    className: "animateRight"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("6mnJ3")),
                    alt: "messageLadie",
                    className: "animateRight"
                })
            }) : null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df",
                style: {
                    gap: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: previewFile ? '0 0 50%' : '1 1 100%',
                            minWidth: 0,
                            transition: 'flex 0.3s ease'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcfs aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("g1WEs")),
                                                alt: "fileManagement"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                className: "c15 fw600 fs20px mb0rem ml0-5rem",
                                                children: "Filing Assistant "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df aic",
                                        style: {
                                            gap: '0.5rem'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>onClickFileImportAuditLog(fileReport['_id']),
                                            className: "cp tac c1 bg5 c15 br20px px1-5rem py0-5rem fw500",
                                            children: "Log"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "w100 fw400 fs13px c37 df jcfs aic mt1-5rem",
                                children: fileReport?.['lastAllocatedBy'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem",
                                            children: "Reallocated by\xa0"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `w2rem h2rem jcc aic dib wsn mr0-5rem`,
                                            children: fileReport?.['lastAllocatedBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: fileReport?.['lastAllocatedBy']?.['profile'],
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
                                                "data-tooltip": fileReport?.['lastAllocatedBy']?.['firstName'] ? fileReport?.['lastAllocatedBy']?.['firstName'] + " " + fileReport?.['lastAllocatedBy']?.['lastName'] : "?"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("kBFDN")),
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                                "data-tooltip": fileReport?.['lastAllocatedBy']?.['firstName'] ? fileReport?.['lastAllocatedBy']?.['firstName'] + " " + fileReport?.['lastAllocatedBy']?.['lastName'] : "?"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `df jcc aic br100 fw500 mr0-5rem`,
                                            children: `${fileReport?.['lastAllocatedBy']?.['firstName'] ? `${fileReport?.['lastAllocatedBy']?.['firstName']} ${fileReport?.['lastAllocatedBy']?.['lastName'] ? fileReport?.['lastAllocatedBy']?.['lastName'] : ""}` : ""}`
                                        }),
                                        "\xa0",
                                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(fileReport['lastAllocatedOn']).format('lll')
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        "Imported by: \xa0",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `w2rem h2rem jcc aic dib wsn mr0-5rem`,
                                            children: fileReport?.['importBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: fileReport?.['importBy']?.['profile'],
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                                "data-tooltip": fileReport?.['importBy']?.['firstName'] ? fileReport?.['importBy']?.['firstName'] + " " + (fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : "") : "?"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("kBFDN")),
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                                "data-tooltip": fileReport?.['importBy']?.['firstName'] ? fileReport?.['importBy']?.['firstName'] + " " + (fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : "") : "?"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `df jcc aic ttc br100 fw600 c36`,
                                            children: `${fileReport?.['importBy']?.['firstName'] ? `${fileReport?.['importBy']?.['firstName']} ${fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : ""}` : ""}`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c36",
                                            children: [
                                                "\xa0",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(fileReport['importDate']).format('MMM DD, YYYY, HH:mm A')
                                            ]
                                        })
                                    ]
                                })
                            }),
                            autoFillContext?.enabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e84a498389ca6ed9$export$2e2bcd8739ae039), {
                                currentStep: "allocation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: "16px",
                                    marginBottom: "16px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dg gg0-5rem mb2rem fs1rem mah300px oya",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                        className: "fis bcc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "tal fs14px fw400 c37",
                                                            style: {
                                                                width: '45%'
                                                            },
                                                            children: "Files"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "tal fs14px fw400 c37",
                                                            style: {
                                                                width: '10%'
                                                            },
                                                            children: "Section Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "tal fs14px fw400 c37",
                                                            style: {
                                                                width: '35%'
                                                            },
                                                            children: "Allocated Section"
                                                        }),
                                                        fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "fs14px fw400 c37",
                                                            style: {
                                                                width: '10%'
                                                            },
                                                            children: "Actions"
                                                        })
                                                    ]
                                                })
                                            }),
                                            fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                                className: "c15 fs18px fw500 tal",
                                                                children: "Allocated files"
                                                            })
                                                        })
                                                    }),
                                                    fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).map(getImportResultEntryHTML)
                                                ]
                                            })
                                        ]
                                    }),
                                    fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                                className: "c15 fs18px fw500 tal mt1rem ml1rem",
                                                children: [
                                                    "Unallocated Bin: Please reallocate files ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c4",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                className: "fis bcc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                        className: "dn",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th w40 bbn"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th bbn"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th w60 bbn"
                                                                }),
                                                                fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th fis-th-action bbn"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                        children: fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX"))).map(getImportResultEntryHTML)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df w100 fdr jcc ",
                                children: modal['from'] == 'reportHistory' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        isModified ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                            onClick: onClickComplete,
                                            text: "Save Changes",
                                            btnType: "warning",
                                            customClassName: "maw300px mr0-5rem"
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'fileReportHistory'
                                                })),
                                            text: "Back to List",
                                            customClassName: "maw300px c1 mr0-5rem"
                                        })
                                    ]
                                }) : fileReport['status'] == 'In Progress' && fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                    onClick: onClickReallocationComplete,
                                    text: "Confirm Allocation",
                                    btnType: "warning",
                                    customClassName: "maw300px"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: "60%",
                                            height: "1px",
                                            backgroundColor: "#82828256",
                                            opacity: "64%",
                                            margin: "24px auto"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic jcc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($1f9e6a63de7b308d$var$Search, {
                                                className: "mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs13px c37 fw400 mr0-5rem",
                                                children: fileReport.importResult && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        "[",
                                                        Object.keys(fileReport.importResult).length,
                                                        "]imported files = [",
                                                        Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX") && !element.includes("SXXX"))).length,
                                                        "] allocated files + [",
                                                        Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX") || element.includes("SXXX"))).length,
                                                        "] unallocated bin files"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs13px c37 fw400",
                                                children: [
                                                    "Allocation accuracy ",
                                                    currentScore,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    autoFillContext?.enabled && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic jcc",
                                        style: {
                                            gap: '1rem',
                                            marginTop: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>{
                                                    (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/cancel', {}).catch(()=>{});
                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: '',
                                                        autoFillStatusBarVisible: false,
                                                        autoFillStatusBarPhase: ''
                                                    }));
                                                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill cancelled');
                                                },
                                                style: {
                                                    background: 'none',
                                                    border: '1.5px solid #9CA3AF',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    color: '#6B7280',
                                                    fontSize: '13px',
                                                    fontWeight: 500,
                                                    padding: '0.3rem 1.2rem'
                                                },
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: '',
                                                        autoFillStatusBarVisible: true,
                                                        autoFillStatusBarPhase: 'allocated'
                                                    })),
                                                style: {
                                                    background: 'none',
                                                    border: '1.5px solid #3B82F6',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    color: '#3B82F6',
                                                    fontSize: '13px',
                                                    fontWeight: 500,
                                                    padding: '0.3rem 1.2rem'
                                                },
                                                children: "Minimize"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    previewFile && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: '0 0 48%',
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            borderLeft: '1px solid #e0e0e0',
                            paddingLeft: '1rem',
                            transition: 'all 0.3s ease'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb aic",
                                style: {
                                    marginBottom: '0.75rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        style: {
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42c665bd8834dbf3$export$2e2bcd8739ae039), {
                                                style: {
                                                    marginRight: '0.5rem',
                                                    color: '#6B7280',
                                                    flexShrink: 0
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "c15 fw600 fs14px mb0rem",
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                },
                                                "data-tooltip": previewFile.name,
                                                children: previewFile.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        style: {
                                            flexShrink: 0,
                                            marginLeft: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: previewFile.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "cp mr0-5rem fs12px c36 fw500 tdu",
                                                "data-tooltip": "Open in new tab",
                                                children: "Open"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8754c86021516b$export$2e2bcd8739ae039), {
                                                className: "cp",
                                                style: {
                                                    fontSize: '1rem',
                                                    color: '#6B7280'
                                                },
                                                onClick: ()=>setPreviewFile(null),
                                                "data-tooltip": "Close preview"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flex: 1,
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#f9fafb',
                                    minHeight: '400px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                    src: previewFile.url,
                                    title: `Preview: ${previewFile.name}`,
                                    style: {
                                        width: '100%',
                                        height: '100%',
                                        border: 'none',
                                        minHeight: '400px'
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
};
var $1f9e6a63de7b308d$export$2e2bcd8739ae039 = $1f9e6a63de7b308d$var$ImportSummaryModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");











var $44e4a80c6bb2231a$var$Send = function Send(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.493 5.031c-.358 0-.693-.175-.898-.468L9.81 3.437a2.406 2.406 0 0 0-1.974-1.03H3.5a2.406 2.406 0 0 0-2.406 2.405v11.375c0 .638.253 1.25.704 1.702a2.41 2.41 0 0 0 1.702.705h14a2.41 2.41 0 0 0 1.702-.705 2.41 2.41 0 0 0 .704-1.701v-8.75a2.41 2.41 0 0 0-.704-1.702A2.41 2.41 0 0 0 17.5 5.03h-6.007Zm0 1.313H17.5a1.096 1.096 0 0 1 1.094 1.093v8.75a1.095 1.095 0 0 1-1.094 1.094h-14a1.095 1.095 0 0 1-1.094-1.093V4.813c0-.604.49-1.094 1.094-1.094h4.337c.357 0 .693.175.897.468l.785 1.126a2.405 2.405 0 0 0 1.974 1.03Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.192 11.008H7.808a.808.808 0 0 0 0 1.615h5.384a.808.808 0 0 0 0-1.615Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m10.471 10.23 1.582 1.583-1.582 1.583a.807.807 0 1 0 1.142 1.141l2.153-2.153a.806.806 0 0 0 0-1.142l-2.153-2.154a.807.807 0 1 0-1.142 1.142Z",
                fill: "#4A67FF"
            })
        ]
    });
};
$44e4a80c6bb2231a$var$Send.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $44e4a80c6bb2231a$var$Search = function Search(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#a)",
                fill: "#000",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M18.812 2.176c-2.901-2.901-7.622-2.901-10.524 0-2.76 2.76-2.894 7.169-.402 10.09l-.034.03-1.13 1.131-.78-.78a.613.613 0 0 0-.867 0L.697 17.025a2.332 2.332 0 0 0 0 3.294c.454.454 1.05.681 1.647.681.596 0 1.193-.227 1.647-.681l4.378-4.378a.613.613 0 0 0 0-.867l-.78-.78 1.13-1.13a.62.62 0 0 0 .033-.037 7.386 7.386 0 0 0 4.798 1.753 7.393 7.393 0 0 0 5.262-2.18 7.393 7.393 0 0 0 2.18-5.262 7.393 7.393 0 0 0-2.18-5.262ZM3.124 19.452a1.104 1.104 0 0 1-1.56-1.56l1.302-1.302 1.56 1.56-1.302 1.302Zm2.169-2.17-1.56-1.56 1.775-1.774 1.56 1.56-1.775 1.775Zm12.652-5.449a6.223 6.223 0 0 1-8.79 0 6.223 6.223 0 0 1 0-8.79 6.196 6.196 0 0 1 4.395-1.817c1.592 0 3.183.606 4.395 1.817a6.175 6.175 0 0 1 1.82 4.395c0 1.66-.646 3.221-1.82 4.395Z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m16.116 5.164-3.402 3.401-1.863-1.863a.613.613 0 1 0-.867.868l2.297 2.296a.611.611 0 0 0 .867 0l3.835-3.835a.613.613 0 1 0-.867-.867Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h21v21H0z"
                    })
                })
            })
        ]
    });
};
$44e4a80c6bb2231a$var$Search.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};





const $44e4a80c6bb2231a$var$TempImportSummaryModal = ({ modalType: modalType })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { fileReport: fileReport, currentScore: currentScore, reportHistories: reportHistories, profileClass: profileClass } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { selectedCompany: company } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const isModified = fileReport?.importResult && Object.entries(fileReport.importResult).some(([key, value])=>value.isModified === true);
    // TempModule state — fetched using fileReport.moduleName (ObjectId or slug)
    const [activeModule, setActiveModule] = (0, $acw62.useState)(null);
    // File preview state
    const [previewFile, setPreviewFile] = (0, $acw62.useState)(null);
    const { tempModule: cachedTempModule } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    (0, $acw62.useEffect)(()=>{
        if (modal['open'] !== modalType) return;
        if (!fileReport?.moduleName || !company?._id) return;
        const matchesCompany = !cachedTempModule?.companyId || String(cachedTempModule.companyId) === String(company._id);
        const matchesModule = cachedTempModule && [
            cachedTempModule.moduleKey,
            cachedTempModule.moduleSlug,
            cachedTempModule.slug,
            cachedTempModule.moduleName
        ].filter(Boolean).map((v)=>String(v).toLowerCase()).includes(String(fileReport.moduleName).toLowerCase());
        if (cachedTempModule && matchesCompany && matchesModule) {
            setActiveModule(cachedTempModule);
            return;
        }
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${fileReport.moduleName}?companyId=${company._id}`).then((res)=>{
            if (res?.code === 200 && res?.body) {
                setActiveModule(res.body);
                dispatch((0, $12074930bd2c1829$export$65113a50fb519714)({
                    ...res.body,
                    moduleName: res.body.moduleName || fileReport.moduleName,
                    moduleSlug: res.body.moduleSlug || fileReport.moduleName,
                    companyId: company._id
                }));
            }
        });
    }, [
        modal['open'],
        fileReport?.moduleName,
        company?._id,
        cachedTempModule,
        dispatch
    ]);
    const handleFilePreview = (file)=>{
        const url = file.location || file.url;
        if (!url) return;
        setPreviewFile({
            name: file.originalname || file.title,
            url: url
        });
    };
    const onClickFileImportAuditLog = async (fileReportId)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportLogs/${fileReportId}`);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'fileReportAuditLog'
        }));
    };
    const onClickComplete = async ()=>{
        const moduleId = activeModule?._id;
        let newFileReport = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };
        newFileReport = {
            ...newFileReport,
            importResult: Object.fromEntries(Object.entries(newFileReport.importResult).filter((item)=>item[1]['isModified']).map(([key, value])=>[
                    key,
                    {
                        file: value['file'],
                        section: value['section'],
                        originalSection: value['originalSection']
                    }
                ]))
        };
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        const resp = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/allocateFiles`, {
            companyId: company._id,
            moduleId: moduleId,
            fileReport: newFileReport
        });
        if (!resp || resp.code === 400) return;
        const updatedReport = resp.body['report'];
        const savedQuestions = resp.body?.savedQuestions;
        if (moduleId && savedQuestions?.length) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: {
                moduleId: String(moduleId),
                savedQuestions: savedQuestions
            }
        }));
        for(let i = 0; i < reportHistories.length; i++)if (reportHistories[i]['_id'] == updatedReport['_id']) {
            reportHistories[i] = updatedReport;
            break;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp['message']);
        dispatch((0, $12074930bd2c1829$export$4bdbd1eea6fc9500)(false));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            underProcessingTab: ''
        }));
    };
    const onClickReallocationComplete = async ()=>{
        const moduleId = activeModule?._id;
        const companyId = company?._id;
        const fileReportData = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(fileReportData));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        const resp = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/allocateFiles`, {
            companyId: companyId,
            moduleId: moduleId,
            fileReport: fileReportData
        });
        if (!resp || resp.code === 400) return;
        const updatedReport = resp.body['report'];
        const savedQuestions = resp.body?.savedQuestions;
        if (moduleId && savedQuestions?.length) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: {
                moduleId: String(moduleId),
                savedQuestions: savedQuestions
            }
        }));
        for(let i = 0; i < reportHistories.length; i++)if (reportHistories[i]['_id'] == updatedReport['_id']) {
            reportHistories[i] = updatedReport;
            break;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp['message']);
        dispatch((0, $12074930bd2c1829$export$4bdbd1eea6fc9500)(false));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            underProcessingTab: ''
        }));
    };
    const getSectionNameFromSection = (section, qNo)=>{
        if (section.sectionNo == qNo) {
            const name = section.sectionName || '';
            return {
                displayName: name,
                sectionOnly: name
            };
        }
        // TempModule sections have a flat questions array with qNo field
        if (section.questions) {
            const questions = Array.isArray(section.questions) ? section.questions : Object.values(section.questions);
            for (const question of questions)if (question.qNo == qNo) {
                const sectionOnly = section.sectionName || '';
                return {
                    displayName: question.qDescription || sectionOnly,
                    sectionOnly: sectionOnly
                };
            }
        }
        return null;
    };
    const getSectionName = (module, qNo, file, key)=>{
        if (qNo == "DXXX" || qNo == "SXXX") return {
            displayName: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onClick: ()=>handleEditDispatch({
                        key: key,
                        fileName: file.originalname,
                        from: 'fileReport',
                        actionType: "move",
                        fileData: file,
                        index: "0"
                    }),
                className: "bg62 br10px df aic p1rem jcsb fsi",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Please select section"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                        className: "c3"
                    })
                ]
            }),
            sectionOnly: ''
        };
        const sections = [
            ...module?.sections || []
        ];
        for (const section of sections){
            const result = getSectionNameFromSection(section, qNo);
            if (result) return {
                displayName: `${qNo} ${result.displayName}`,
                sectionOnly: result.sectionOnly
            };
        }
        // Fallback: use sectionName from backend allocation if available
        const entry = fileReport?.importResult && Object.values(fileReport.importResult).find((r)=>r.section?.includes(qNo) && r.sectionName);
        if (entry?.sectionName) return {
            displayName: `${qNo} ${entry.sectionName}`,
            sectionOnly: entry.sectionName
        };
        return {
            displayName: qNo,
            sectionOnly: ''
        };
    };
    const handleEditDispatch = (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(true));
    };
    function isSubarray(subarray, array) {
        const sortedSubarray = subarray.slice().sort();
        const sortedArray = array.slice().sort();
        let i = 0;
        return sortedArray.some((element)=>{
            if (element === sortedSubarray[i]) i++;
            return i === sortedSubarray.length;
        });
    }
    const calcAccuracyScore = (count)=>{
        let allocated = 0;
        for (const key of Object.keys(fileReport.importResult)){
            const currentSection = fileReport.importResult[key]['section'];
            const oldSection = fileReport.importResult[key]['originalSection'];
            if (oldSection.includes("DXXX") || oldSection.includes("SXXX")) continue;
            if (isSubarray(oldSection, currentSection)) allocated++;
        }
        const totalCount = count ?? Object.keys(fileReport.importResult).length;
        dispatch((0, $12074930bd2c1829$export$fb8d60304f3762b3)(!totalCount ? 0 : Math.round(allocated / totalCount * 100)));
        return !totalCount ? 0 : Math.round(allocated / totalCount * 100);
    };
    const removeSectionFromImport = async (fileKey, index)=>{
        let sections = [
            ...fileReport.importResult[fileKey]['section']
        ];
        const _fileReport = {
            ...fileReport
        };
        const qNo = sections[index];
        sections.splice(index, 1);
        const file = _fileReport.importResult[fileKey]['file'];
        if (sections.length === 0) {
            const { [fileKey]: removedFile, ...restOfFileReport } = _fileReport.importResult;
            _fileReport.importResult = restOfFileReport;
        } else _fileReport.importResult[fileKey] = {
            ..._fileReport.importResult[fileKey],
            section: sections
        };
        const score = calcAccuracyScore(Object.keys(_fileReport.importResult).length);
        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteSection`, {
            companyId: company._id,
            fileReportId: _fileReport['_id'],
            fileKey: fileKey,
            index: index,
            qNo: qNo,
            score: score,
            file: file
        });
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(_fileReport));
    };
    const getImportResultEntryHTML = (key)=>{
        const fileName = fileReport.importResult[key].file['originalname'];
        const file = fileReport.importResult[key].file;
        const section = fileReport.importResult[key]['section'];
        // Use fetched TempModule data instead of company.modules[tab]
        const module = activeModule;
        if (Array.isArray(section)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: section.map((qNo, index)=>{
                const { displayName: displayName, sectionOnly: sectionOnly } = getSectionName(module, qNo, file, key);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        className: `${index == section.length - 1 ? 'fis-tr' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `tal fis-td mx1rem fs14px fw600 tdu bg1 lightDot ${index != 0 ? 'vh' : ''} ${qNo == "DXXX" ? 'red' : fileReport['status'] == 'In Progress' ? 'orange' : 'green'}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cp",
                                    onClick: ()=>handleFilePreview(file),
                                    "data-tooltip": "Click to preview file",
                                    children: fileName
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `tal mx1rem fs14px fw400 bg1 c15`,
                                children: sectionOnly
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `tal mx1rem fs14px fw400 bg1 c15`,
                                children: displayName
                            }),
                            fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdr jcc aic",
                                    children: [
                                        qNo !== "DXXX" ? /*#__PURE__*/ (0, $ayMG0.jsx)($44e4a80c6bb2231a$var$Send, {
                                            "data-tooltip": "Move",
                                            className: "mr1rem cp",
                                            onClick: ()=>handleEditDispatch({
                                                    key: key,
                                                    fileName: file.title,
                                                    from: 'fileReport',
                                                    actionType: "move",
                                                    fileData: file,
                                                    index: index
                                                })
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cee5c542a37a6fe$export$2e2bcd8739ae039), {
                                            "data-tooltip": "Delete",
                                            onClick: ()=>removeSectionFromImport(key, index),
                                            className: "cp f9 ml1rem"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, `${index + section.length - 1}-section-allocate`);
            })
        });
        else {
            const { displayName: displayName, sectionOnly: sectionOnly } = getSectionName(module, section, file, key);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                    className: `fis-tr`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "cp tdu",
                                onClick: ()=>handleFilePreview(file),
                                "data-tooltip": "Click to preview file",
                                children: fileName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1 fis-td`,
                            children: sectionOnly
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1 fis-td`,
                            children: displayName
                        }),
                        fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdr jcc aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cee5c542a37a6fe$export$2e2bcd8739ae039), {
                                    "data-tooltip": "Delete",
                                    onClick: ()=>removeSectionFromImport(key, 0),
                                    className: "cp f9"
                                })
                            })
                        })
                    ]
                })
            });
        }
    };
    if (fileReport && Object.keys(company).length && modal['open'] == modalType) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            modalCardClasses: `mah80 p2rem`,
            customStyle: {
                maxWidth: '1400px',
                padding: '2rem',
                zIndex: 9,
                marginTop: '2rem',
                transition: 'max-width 0.3s ease'
            },
            girlComponent: !previewFile ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'relative'
                },
                children: fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX"))).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("f5cbi")),
                    alt: "messageLadie",
                    className: "animateRight"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("6mnJ3")),
                    alt: "messageLadie",
                    className: "animateRight"
                })
            }) : null,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df",
                style: {
                    gap: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: previewFile ? '0 0 50%' : '1 1 100%',
                            minWidth: 0,
                            transition: 'flex 0.3s ease'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcfs aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("g1WEs")),
                                                alt: "fileManagement"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                className: "c15 fw600 fs20px mb0rem ml0-5rem",
                                                children: "Filing Assistant"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df aic",
                                        style: {
                                            gap: '0.5rem'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>onClickFileImportAuditLog(fileReport['_id']),
                                            className: "cp tac c1 bg5 c15 br20px px1-5rem py0-5rem fw500",
                                            children: "Log"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "w100 fw400 fs13px c37 df jcfs aic mt1-5rem",
                                children: fileReport?.['lastAllocatedBy'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem",
                                            children: "Reallocated by\xa0"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `w2rem h2rem jcc aic dib wsn mr0-5rem`,
                                            children: fileReport?.['lastAllocatedBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: fileReport?.['lastAllocatedBy']?.['profile'],
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
                                                "data-tooltip": fileReport?.['lastAllocatedBy']?.['firstName'] ? fileReport?.['lastAllocatedBy']?.['firstName'] + " " + fileReport?.['lastAllocatedBy']?.['lastName'] : "?"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("kBFDN")),
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                                "data-tooltip": fileReport?.['lastAllocatedBy']?.['firstName'] ? fileReport?.['lastAllocatedBy']?.['firstName'] + " " + fileReport?.['lastAllocatedBy']?.['lastName'] : "?"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `df jcc aic br100 fw500 mr0-5rem`,
                                            children: `${fileReport?.['lastAllocatedBy']?.['firstName'] ? `${fileReport?.['lastAllocatedBy']?.['firstName']} ${fileReport?.['lastAllocatedBy']?.['lastName'] ? fileReport?.['lastAllocatedBy']?.['lastName'] : ""}` : ""}`
                                        }),
                                        "\xa0",
                                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(fileReport['lastAllocatedOn']).format('lll')
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        "Imported by: \xa0",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `w2rem h2rem jcc aic dib wsn mr0-5rem`,
                                            children: fileReport?.['importBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: fileReport?.['importBy']?.['profile'],
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                                "data-tooltip": fileReport?.['importBy']?.['firstName'] ? fileReport?.['importBy']?.['firstName'] + " " + (fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : "") : "?"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("kBFDN")),
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                                "data-tooltip": fileReport?.['importBy']?.['firstName'] ? fileReport?.['importBy']?.['firstName'] + " " + (fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : "") : "?"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: `df jcc aic ttc br100 fw600 c36`,
                                            children: `${fileReport?.['importBy']?.['firstName'] ? `${fileReport?.['importBy']?.['firstName']} ${fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : ""}` : ""}`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c36",
                                            children: [
                                                "\xa0",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(fileReport['importDate']).format('MMM DD, YYYY, HH:mm A')
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: "16px",
                                    marginBottom: "16px"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dg gg0-5rem mb2rem fs1rem mah300px oya",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                        className: "fis bcc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "tal fs14px fw400 c37",
                                                            style: {
                                                                width: '45%'
                                                            },
                                                            children: "Files"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "tal fs14px fw400 c37",
                                                            style: {
                                                                width: '10%'
                                                            },
                                                            children: "Section Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "tal fs14px fw400 c37",
                                                            style: {
                                                                width: '35%'
                                                            },
                                                            children: "Allocated Section"
                                                        }),
                                                        fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "fs14px fw400 c37",
                                                            style: {
                                                                width: '10%'
                                                            },
                                                            children: "Actions"
                                                        })
                                                    ]
                                                })
                                            }),
                                            fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                                className: "c15 fs18px fw500 tal",
                                                                children: "Allocated files"
                                                            })
                                                        })
                                                    }),
                                                    fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).map(getImportResultEntryHTML)
                                                ]
                                            })
                                        ]
                                    }),
                                    fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                                className: "c15 fs18px fw500 tal mt1rem ml1rem",
                                                children: [
                                                    "Unallocated Bin: Please reallocate files ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c4",
                                                        children: "*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                className: "fis bcc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                        className: "dn",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th w40 bbn"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th bbn"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th w60 bbn"
                                                                }),
                                                                fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                    className: "fis-th fis-th-action bbn"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                        children: fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX"))).map(getImportResultEntryHTML)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df w100 fdr jcc",
                                children: modal['from'] == 'reportHistory' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        isModified ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                            onClick: onClickComplete,
                                            text: "Save Changes",
                                            btnType: "warning",
                                            customClassName: "maw300px mr0-5rem"
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'fileReportHistory'
                                                })),
                                            text: "Back to List",
                                            customClassName: "maw300px c1 mr0-5rem"
                                        })
                                    ]
                                }) : fileReport['status'] == 'In Progress' && fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                    onClick: onClickReallocationComplete,
                                    text: "Confirm Allocation",
                                    btnType: "warning",
                                    customClassName: "maw300px"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: "60%",
                                            height: "1px",
                                            backgroundColor: "#82828256",
                                            opacity: "64%",
                                            margin: "24px auto"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic jcc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($44e4a80c6bb2231a$var$Search, {
                                                className: "mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs13px c37 fw400 mr0-5rem",
                                                children: fileReport.importResult && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        "[",
                                                        Object.keys(fileReport.importResult).length,
                                                        "]imported files = [",
                                                        Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).length,
                                                        "] allocated files + [",
                                                        Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((element)=>element.includes("DXXX") || element.includes("SXXX"))).length,
                                                        "] unallocated bin files"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs13px c37 fw400",
                                                children: [
                                                    "Allocation accuracy ",
                                                    currentScore,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    previewFile && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: '0 0 48%',
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            borderLeft: '1px solid #e0e0e0',
                            paddingLeft: '1rem',
                            transition: 'all 0.3s ease'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb aic",
                                style: {
                                    marginBottom: '0.75rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        style: {
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42c665bd8834dbf3$export$2e2bcd8739ae039), {
                                                style: {
                                                    marginRight: '0.5rem',
                                                    color: '#6B7280',
                                                    flexShrink: 0
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "c15 fw600 fs14px mb0rem",
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                },
                                                "data-tooltip": previewFile.name,
                                                children: previewFile.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        style: {
                                            flexShrink: 0,
                                            marginLeft: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: previewFile.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "cp mr0-5rem fs12px c36 fw500 tdu",
                                                "data-tooltip": "Open in new tab",
                                                children: "Open"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8754c86021516b$export$2e2bcd8739ae039), {
                                                className: "cp",
                                                style: {
                                                    fontSize: '1rem',
                                                    color: '#6B7280'
                                                },
                                                onClick: ()=>setPreviewFile(null),
                                                "data-tooltip": "Close preview"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    flex: 1,
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    border: '1px solid #e0e0e0',
                                    backgroundColor: '#f9fafb',
                                    minHeight: '400px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                    src: previewFile.url,
                                    title: `Preview: ${previewFile.name}`,
                                    style: {
                                        width: '100%',
                                        height: '100%',
                                        border: 'none',
                                        minHeight: '400px'
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
};
var $44e4a80c6bb2231a$export$2e2bcd8739ae039 = $44e4a80c6bb2231a$var$TempImportSummaryModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $073f657115610bce$var$ChooseAuthMethodModal = ({ modalType: modalType, smsEnabled: smsEnabled, loginWithSMS: loginWithSMS, twoFaEnabled: twoFaEnabled, loginWithTwoFA: loginWithTwoFA, emailEnabled: emailEnabled, loginWithEmail: loginWithEmail })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        modalCardClasses: "bg38",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "c15 fs2rem tac lh1 fw600 mb1rem",
                children: "Verify it's You"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "c15 op60 fs1rem ttu w100 tac mb2rem",
                children: "Choose a way to log in securely"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df gtcr3-md gg1rem tac jcc mb2rem",
                children: [
                    smsEnabled && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `bg1 px2rem py0-5rem br30px df fdc jcc aic pr cp`,
                        style: {
                            minHeight: '230px'
                        },
                        onClick: ()=>loginWithSMS(),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("hRmh8")),
                                alt: `google_authIcon`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fw800 tac",
                                        children: "SMS"
                                    }),
                                    "Authentication"
                                ]
                            })
                        ]
                    }),
                    twoFaEnabled && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `bg1 px2rem py0-5rem br30px df fdc jcc aic pr cp`,
                        style: {
                            minHeight: '230px'
                        },
                        onClick: ()=>loginWithTwoFA(),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("5hbJu")),
                                alt: `google_authIcon`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fw800 tac",
                                        children: "Google"
                                    }),
                                    "Authentication"
                                ]
                            })
                        ]
                    }),
                    emailEnabled && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `bg1 px2rem py0-5rem br30px df fdc jcc aic pr cp`,
                        style: {
                            minHeight: '230px'
                        },
                        onClick: ()=>loginWithEmail(),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("liVak")),
                                alt: `google_authIcon`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fw800 tac",
                                        children: "Email"
                                    }),
                                    "Authentication"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $073f657115610bce$export$2e2bcd8739ae039 = $073f657115610bce$var$ChooseAuthMethodModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $f9728b295b587bad$var$Paragraph = ({ customClass: customClass, text: text })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: `c15 tac op70 mb1-5rem fs13px ${customClass}`,
        style: {
            lineHeight: 1.8,
            maxWidth: "560px",
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        children: text
    });
};
var $f9728b295b587bad$export$2e2bcd8739ae039 = $f9728b295b587bad$var$Paragraph;


const $87d44cef365988d0$var$CreateGroupInfo = ({ modalType: modalType })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const onCloseHandler = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        onCloseHandler: onCloseHandler,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $854b67c8016e8896$export$2e2bcd8739ae039), {
                    text: "Create Group"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9728b295b587bad$export$2e2bcd8739ae039), {
                    text: "We recommend that prior to creating a group of companies (you will be asked to identify a parent, and then attach subsidiary and associated companies to it, with their corresponding % ownerships), you FIRST CREATE ALL THE COMPANIES in the group\u200B."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "maw180px mxa",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        btnType: "warning",
                        text: "Let's Go!",
                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'createGroup'
                            }))
                    })
                })
            ]
        })
    });
};
var $87d44cef365988d0$export$2e2bcd8739ae039 = $87d44cef365988d0$var$CreateGroupInfo;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $37538c30a4f4fd93$var$EditGroupModal = ({ modalType: modalType, companies: companies, parentCompany: parentCompany, setParentCompany: setParentCompany, setCompaniesGroup: setCompaniesGroup, setUpdateType: setUpdateType, user: user, profileClass: profileClass })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $acw62.useState)(false);
    const dropdownRef = (0, $acw62.useRef)(null);
    // Filter companies that are Parents (have groups)
    const parentCompanies = companies?.filter((c)=>c.group === 'Parent') || [];
    const onCloseHandler = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        setParentCompany(null);
        setCompaniesGroup({});
        setIsDropdownOpen(false);
    };
    const handleSelectCompany = (company)=>{
        setParentCompany(company);
        setIsDropdownOpen(false);
    };
    // Close dropdown when clicking outside
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsDropdownOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        onCloseHandler: onCloseHandler,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $854b67c8016e8896$export$2e2bcd8739ae039), {
                    text: "Edit Group"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mra mla fs1rem w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mla mra",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc aic",
                                ref: dropdownRef,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        onClick: ()=>setIsDropdownOpen(!isDropdownOpen),
                                        className: "df w80 cp pl4rem w95 br5px p1rem pr bg1 bw1px bss bo42",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `c15 op70 fw500 fsi`,
                                                children: parentCompany?.['cName'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        "Parent: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            className: "fw600 fsi",
                                                            children: `${parentCompany?.['cName']}`
                                                        })
                                                    ]
                                                }) : "Please Select Parent Company"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon-right pa r0 mr1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "ml0-5rem w1rem h1rem f6 f6-xl",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 448 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M5.5 14.5V16.5921C4.91925 16.7992 4.5 17.349 4.5 18C4.5 18.8271 5.17285 19.5 6 19.5C6.82715 19.5 7.5 18.8271 7.5 18C7.5 17.349 7.08075 16.7992 6.5 16.5921V15H7.5V14H6C5.72363 14 5.5 14.2236 5.5 14.5ZM6 18.5C5.72412 18.5 5.5 18.2759 5.5 18C5.5 17.7241 5.72412 17.5 6 17.5C6.27588 17.5 6.5 17.7241 6.5 18C6.5 18.2759 6.27588 18.5 6 18.5Z",
                                                        fill: "#151313"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M5.5 10V7.90787C4.91925 7.70081 4.5 7.15097 4.5 6.5C4.5 5.67285 5.17285 5 6 5C6.82715 5 7.5 5.67285 7.5 6.5C7.5 7.15097 7.08075 7.70081 6.5 7.90787V9.5H9V10.5L6 10.5C5.72363 10.5 5.5 10.2764 5.5 10ZM6 6C5.72412 6 5.5 6.22412 5.5 6.5C5.5 6.77588 5.72412 7 6 7C6.27588 7 6.5 6.77588 6.5 6.5C6.5 6.22412 6.27588 6 6 6Z",
                                                        fill: "#151313"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M18.5 14.5V16.5921C19.0807 16.7992 19.5 17.349 19.5 18C19.5 18.8271 18.8271 19.5 18 19.5C17.1729 19.5 16.5 18.8271 16.5 18C16.5 17.349 16.9193 16.7992 17.5 16.5921V15H16.5V14H18C18.2764 14 18.5 14.2236 18.5 14.5ZM18 18.5C18.2759 18.5 18.5 18.2759 18.5 18C18.5 17.7241 18.2759 17.5 18 17.5C17.7241 17.5 17.5 17.7241 17.5 18C17.5 18.2759 17.7241 18.5 18 18.5Z",
                                                        fill: "#151313"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M18.5 10V7.90787C19.0807 7.70081 19.5 7.15097 19.5 6.5C19.5 5.67285 18.8271 5 18 5C17.1729 5 16.5 5.67285 16.5 6.5C16.5 7.15097 16.9193 7.70081 17.5 7.90787V9.5H15V10.5L18 10.5C18.2764 10.5 18.5 10.2764 18.5 10ZM18 6C18.2759 6 18.5 6.22412 18.5 6.5C18.5 6.77588 18.2759 7 18 7C17.7241 7 17.5 6.77588 17.5 6.5C17.5 6.22412 17.7241 6 18 6Z",
                                                        fill: "#151313"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                        clipPath: "url(#clip0_5984_43388)",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M15.5156 10.125H15.125V8.17188C15.125 7.5257 14.5993 7 13.9531 7H10.0469C9.4007 7 8.875 7.5257 8.875 8.17188V10.125H8.48438C7.8382 10.125 7.3125 10.6507 7.3125 11.2969V17H16.6875V11.2969C16.6875 10.6507 16.1618 10.125 15.5156 10.125ZM8.875 16.2188H8.09375V11.2969C8.09375 11.0815 8.26898 10.9062 8.48438 10.9062H8.875V16.2188ZM12.7812 16.2188H11.2188V15.5938H12.7812V16.2188ZM14.3438 16.2188H13.5625V14.8125H10.4375V16.2188H9.65625V8.17188C9.65625 7.95648 9.83148 7.78125 10.0469 7.78125H13.9531C14.1685 7.78125 14.3438 7.95648 14.3438 8.17188V16.2188ZM15.9062 16.2188H15.125V10.9062H15.5156C15.731 10.9062 15.9062 11.0815 15.9062 11.2969V16.2188ZM10.4375 9.34375H13.5625V8.5625H10.4375V9.34375ZM10.4375 10.9062H13.5625V10.125H10.4375V10.9062ZM10.4375 12.4688H13.5625V11.6875H10.4375V12.4688ZM10.4375 14.0312H13.5625V13.25H10.4375V14.0312Z",
                                                            fill: "#4A67FF"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip0_5984_43388",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "10",
                                                                height: "10",
                                                                fill: "white",
                                                                transform: "translate(7 7)"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isDropdownOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w80 cp shadow fww br10px py1rem bg1",
                                        children: parentCompanies.length > 0 ? parentCompanies.map((company, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>handleSelectCompany(company),
                                                className: "cp fs1rem mb1rem cp c36 px1rem py0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcsb aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs1rem fw500",
                                                            children: company['cName']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fs0-75rem c7 ml1rem",
                                                            children: [
                                                                "(",
                                                                company.childrenCompanies?.length || 0,
                                                                " children)"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, `dropdown-edit-group-selection${idx}`)) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "px1rem py0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c7 fs0-875rem",
                                                children: "No parent companies found"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }),
                parentCompany != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bottom-company-area",
                    style: {
                        overflow: 'visible'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc gg1rem mt2rem mb2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        setUpdateType('Add');
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'editGroupAdd'
                                        }));
                                    },
                                    className: "shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu df jcc aic",
                                    children: "Add"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        setUpdateType('Edit');
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'editGroupUpdate'
                                        }));
                                    },
                                    className: "shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu df jcc aic",
                                    children: "Edit"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        setUpdateType('Delete');
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'editGroupUpdate'
                                        }));
                                    },
                                    className: "shadow bg4 bg3-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu df jcc aic",
                                    children: "Delete"
                                })
                            ]
                        }),
                        parentCompany.childrenCompanies?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "c15 mb1rem",
                                    children: "Current Group Members:"
                                }),
                                parentCompany.childrenCompanies.map((child, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            backgroundColor: '#F0F2FD80'
                                        },
                                        className: "company-detail-box df aic w95 bg1 bs1px brss bo45 br20px px0-75rem mb1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "company-detail df fww br10px fs1rem mb1rem mt1rem w100 aic jcsb",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc jcfs aifs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                            className: "fs1rem mr1rem w11rem c15",
                                                            children: child['cName']
                                                        }),
                                                        child['subscription'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs11px c45 mra tal w2rem",
                                                            children: child['subscription']?.toUpperCase()
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs11px c45 mra tal mra w3rem",
                                                            children: "INACTIVE"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "c7 fs0-75rem",
                                                    children: [
                                                        child['group'],
                                                        " - ",
                                                        child['percentage'] || 0,
                                                        "%"
                                                    ]
                                                })
                                            ]
                                        })
                                    }, `child-preview-${idx}`))
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac py1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c7 fs0-875rem",
                                children: 'No child companies in this group yet. Click "Add" to add companies.'
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $37538c30a4f4fd93$export$2e2bcd8739ae039 = $37538c30a4f4fd93$var$EditGroupModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $943e3a6487456388$var$EditGroupAddModal = ({ modalType: modalType, companies: companies, parentCompany: parentCompany, handleChildCompany: handleChildCompany, companiesGroup: companiesGroup, updateGroupCompany: updateGroupCompany, setCompaniesGroup: setCompaniesGroup, user: user, profileClass: profileClass })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [selectedCompanies, setSelectedCompanies] = (0, $acw62.useState)([]);
    const onCloseHandler = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        setSelectedCompanies([]);
        setCompaniesGroup({});
    };
    // Filter out parent and existing children - only show companies that can be added
    const existingChildIds = parentCompany?.childrenCompanies?.map((c)=>c._id) || [];
    const availableCompanies = companies?.filter((c)=>c._id !== parentCompany?._id && c.group !== 'Parent' && (c.group === 'Standard' || !c.group) && !existingChildIds.includes(c._id)) || [];
    const handleCheckboxChange = (event, companyId)=>{
        handleChildCompany({
            event: event,
            companyId: companyId,
            group: companiesGroup[companyId]?.['group'],
            selected: 'true'
        });
        if (event.target.checked) setSelectedCompanies((prev)=>[
                ...prev,
                companyId
            ]);
        else setSelectedCompanies((prev)=>prev.filter((id)=>id !== companyId));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        onCloseHandler: onCloseHandler,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $854b67c8016e8896$export$2e2bcd8739ae039), {
                    text: `Add to ${parentCompany?.cName || 'Group'}`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bottom-company-area",
                    style: {
                        maxHeight: '400px',
                        overflowY: 'auto'
                    },
                    children: availableCompanies.length > 0 ? availableCompanies.map((childCompany, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                backgroundColor: '#F0F2FD80'
                            },
                            className: "company-detail-box df aic w95 bg1 bs1px brss bo45 br20px px0-75rem mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "checkbox active w2rem h2rem pr mr0-75rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        onChange: (event)=>handleCheckboxChange(event, childCompany['_id']),
                                        id: `addChildCompany-${childCompany['_id']}`,
                                        className: "bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                        type: "checkbox"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "company-detail df fww br10px fs1rem mb1rem mt1rem w100 aic jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc jcfs aifs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "fs1rem mr1rem w11rem c15",
                                                    children: childCompany['cName']
                                                }),
                                                childCompany['subscription'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs11px c45 mra tal w2rem",
                                                    children: childCompany['subscription']?.toUpperCase()
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs11px c45 mra tal mra w3rem",
                                                    children: "INACTIVE"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem df jsc w4rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df w4rem jcc",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df username-area",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            flexDirection: "column",
                                                            alignItems: "end"
                                                        },
                                                        children: childCompany?.['creatorId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: `w2rem h2rem df jcc aic br100 mr0-5rem bs4px brss bo34 ${profileClass}`,
                                                            src: childCompany['creatorId']['profile'],
                                                            "data-tooltip": childCompany['creatorId']?.['firstName'] ? childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "") : ""
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            "data-tooltip": childCompany['creatorId']?.['firstName'] ? childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "") : "",
                                                            className: `w2rem h2rem df jcc aic br100 mr0-5rem fs0-75rem bg3 c1 ${profileClass}`,
                                                            children: childCompany['creatorId']?.['firstName'] ? childCompany['creatorId']['firstName'][0] + (childCompany['creatorId']?.['lastName']?.[0] || "") : "?"
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "dropdown-company w8rem px0-5rem py0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                defaultValue: "Subsidiary",
                                                name: "dropdown",
                                                className: "fs0-75rem w100 p0-5rem br5px",
                                                onChange: (e)=>handleChildCompany({
                                                        companyId: childCompany['_id'],
                                                        group: e.target.value
                                                    }),
                                                id: `group-${childCompany['_id']}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "Subsidiary",
                                                        children: "Subsidiary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "Associate",
                                                        children: "Associate"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "percentage-area ml1rem w5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "input-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultValue: companiesGroup[childCompany['_id']]?.['percentage'] || '',
                                                    onChange: (e)=>handleChildCompany({
                                                            companyId: childCompany['_id'],
                                                            group: companiesGroup[childCompany['_id']]?.['group'],
                                                            percentage: e.target.value
                                                        }),
                                                    placeholder: "0%",
                                                    id: `percentage-${childCompany['_id']}`,
                                                    type: "text",
                                                    className: "fw600 bg1 bs1px brss bo31 br10px py0-5rem px1rem percentage w100",
                                                    min: "1",
                                                    max: "100"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, `add-child-${idx}`)) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tac py2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c7 fs0-875rem",
                            children: "No available companies to add. All companies are either already in a group or are parent companies."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb2rem mt3rem df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        btnType: "warning",
                        text: "Add to Group",
                        disabled: selectedCompanies.length === 0,
                        onClick: ()=>updateGroupCompany('Add')
                    })
                })
            ]
        })
    });
};
var $943e3a6487456388$export$2e2bcd8739ae039 = $943e3a6487456388$var$EditGroupAddModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $5e16dee7e25efb09$var$EditGroupUpdateModal = ({ modalType: modalType, parentCompany: parentCompany, handleChildCompany: handleChildCompany, companiesGroup: companiesGroup, updateGroupCompany: updateGroupCompany, setCompaniesGroup: setCompaniesGroup, updateType: updateType, user: user, profileClass: profileClass })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [selectedCompanies, setSelectedCompanies] = (0, $acw62.useState)([]);
    const onCloseHandler = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        setSelectedCompanies([]);
        setCompaniesGroup({});
    };
    const childrenCompanies = parentCompany?.childrenCompanies || [];
    const handleCheckboxChange = (event, childCompany)=>{
        handleChildCompany({
            event: event,
            companyId: childCompany['_id'],
            group: childCompany['group'],
            percentage: childCompany['percentage'],
            selected: 'true'
        });
        if (event.target.checked) setSelectedCompanies((prev)=>[
                ...prev,
                childCompany['_id']
            ]);
        else setSelectedCompanies((prev)=>prev.filter((id)=>id !== childCompany['_id']));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        onCloseHandler: onCloseHandler,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $854b67c8016e8896$export$2e2bcd8739ae039), {
                    text: `${updateType} Group Companies`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bottom-company-area",
                    style: {
                        maxHeight: '400px',
                        overflowY: 'auto'
                    },
                    children: childrenCompanies.length > 0 ? childrenCompanies.map((childCompany, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                backgroundColor: '#F0F2FD80'
                            },
                            className: "company-detail-box df aic w95 bg1 bs1px brss bo45 br20px px0-75rem mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "checkbox active w2rem h2rem pr mr0-75rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        onChange: (event)=>handleCheckboxChange(event, childCompany),
                                        id: `updateChildCompany-${childCompany['_id']}`,
                                        className: "bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                        type: "checkbox"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "company-detail df fww br10px fs1rem mb1rem mt1rem w100 aic jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc jcfs aifs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "fs1rem mr1rem w11rem c15",
                                                    children: childCompany['cName']
                                                }),
                                                childCompany['subscription'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs11px c45 mra tal w2rem",
                                                    children: childCompany['subscription']?.toUpperCase()
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs11px c45 mra tal mra w3rem",
                                                    children: "INACTIVE"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem df jsc w4rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df w4rem jcc",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df username-area",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            flexDirection: "column",
                                                            alignItems: "end"
                                                        },
                                                        children: childCompany?.['creatorId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: `w2rem h2rem df jcc aic br100 mr0-5rem bs4px brss bo34 ${profileClass}`,
                                                            src: childCompany['creatorId']['profile'],
                                                            "data-tooltip": childCompany['creatorId']?.['firstName'] ? childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "") : ""
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            "data-tooltip": childCompany['creatorId']?.['firstName'] ? childCompany['creatorId']['firstName'] + " " + (childCompany['creatorId']?.['lastName'] || "") : "",
                                                            className: `w2rem h2rem df jcc aic br100 mr0-5rem fs0-75rem bg3 c1 ${profileClass}`,
                                                            children: childCompany['creatorId']?.['firstName'] ? childCompany['creatorId']['firstName'][0] + (childCompany['creatorId']?.['lastName']?.[0] || "") : "?"
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "dropdown-company w8rem px0-5rem py0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                defaultValue: childCompany['group'],
                                                disabled: updateType === "Delete",
                                                name: "dropdown",
                                                className: "fs0-75rem w100 p0-5rem br5px",
                                                style: {
                                                    color: updateType === 'Delete' ? '#aeacac' : undefined
                                                },
                                                onChange: (e)=>handleChildCompany({
                                                        companyId: childCompany['_id'],
                                                        group: e.target.value
                                                    }),
                                                id: `group-${childCompany['_id']}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "Subsidiary",
                                                        children: "Subsidiary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "Associate",
                                                        children: "Associate"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "percentage-area ml1rem w5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "input-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultValue: childCompany['percentage'] || '',
                                                    disabled: updateType === "Delete",
                                                    onChange: (e)=>handleChildCompany({
                                                            companyId: childCompany['_id'],
                                                            group: companiesGroup[childCompany['_id']]?.['group'] || childCompany['group'],
                                                            percentage: e.target.value
                                                        }),
                                                    placeholder: "0%",
                                                    id: `percentage-${childCompany['_id']}`,
                                                    type: "text",
                                                    className: "fw600 bg1 bs1px brss bo31 br10px py0-5rem px1rem percentage w100",
                                                    min: "1",
                                                    max: "100",
                                                    style: {
                                                        color: updateType === 'Delete' ? '#aeacac' : undefined
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, `update-child-${idx}`)) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tac py2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c7 fs0-875rem",
                            children: "No child companies in this group."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb2rem mt3rem df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        btnType: updateType === 'Delete' ? 'dark' : 'warning',
                        text: updateType,
                        disabled: selectedCompanies.length === 0,
                        onClick: ()=>updateGroupCompany(updateType)
                    })
                })
            ]
        })
    });
};
var $5e16dee7e25efb09$export$2e2bcd8739ae039 = $5e16dee7e25efb09$var$EditGroupUpdateModal;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $0c3ef04e6d3070d8$var$ResendForgotPasswordEmail = ({ modalType: modalType, modalData: modalData })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [counter, setCounter] = (0, $acw62.useState)(0); // Countdown for 60s
    (0, $acw62.useEffect)(()=>{
        let timer;
        if (counter > 0) timer = setTimeout(()=>setCounter(counter - 1), 1000);
        return ()=>clearTimeout(timer);
    }, [
        counter
    ]);
    const onCloseHandler = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "",
            historyData: null
        }));
    };
    const handleResendEmail = async ()=>{
        if (loading || counter) return;
        setLoading(true);
        try {
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/forgotPassword', {
                email: modalData?.email
            });
            if (response && response['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                setCounter(60);
            }
        } catch (err) {
            console.error(err);
        } finally{
            setLoading(false);
        }
    };
    // Memoize button text to avoid unnecessary computation
    const buttonText = (0, $acw62.useMemo)(()=>{
        return counter > 0 ? `Resend in ${counter}s` : 'Resend Email';
    }, [
        counter
    ]);
    // Memoize button disabled state
    const isButtonDisabled = (0, $acw62.useMemo)(()=>{
        return counter > 0 || loading;
    }, [
        counter,
        loading
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        onCloseHandler: onCloseHandler,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc jcc aic",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "maw100px mb2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "96",
                        height: "96",
                        viewBox: "0 0 96 96",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                "clip-path": "url(#clip0_5984_45269)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M82.1418 95.999H13.9043C11.5063 95.999 9.5625 94.0552 9.5625 91.6572V35.5655L44.2353 1.54742C46.3388 -0.515808 49.7073 -0.515808 51.8108 1.54742L86.4836 35.5655V91.6565C86.4836 94.0552 84.5398 95.999 82.1418 95.999Z",
                                        fill: "url(#paint0_linear_5984_45269)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M81.3381 91.6142C81.3381 94.0363 79.3745 96 76.9524 96H14.7031V12.3105H76.9524C79.3745 12.3105 81.3381 14.2742 81.3381 16.6963V91.6142Z",
                                        fill: "url(#paint1_linear_5984_45269)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M48.0234 70.7339L11.113 94.9807C11.0486 94.9272 10.9856 94.8723 10.9241 94.813C10.0862 94.0227 9.5625 92.9013 9.5625 91.657V35.5645L43.8596 66.9267L48.0234 70.7339Z",
                                        fill: "url(#paint2_linear_5984_45269)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M86.4914 35.5645V91.657C86.4914 92.9006 85.9678 94.0227 85.1299 94.813C85.0683 94.8723 85.0061 94.9272 84.9409 94.9807L48.0312 70.7339L52.1943 66.9267L86.4914 35.5645Z",
                                        fill: "url(#paint3_linear_5984_45269)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M85.1276 94.8136C85.0661 94.8729 85.0039 94.9278 84.9387 94.9813C84.1843 95.6171 83.2116 96.0001 82.1467 96.0001H13.9106C12.8457 96.0001 11.873 95.6171 11.1187 94.9813C11.0542 94.9278 10.9912 94.8729 10.9297 94.8136L40.7861 68.8243C41.7251 68.007 42.7666 67.3749 43.8652 66.9274C46.5298 65.8419 49.5276 65.8419 52.1921 66.9274C53.2915 67.3749 54.333 68.007 55.2719 68.8243L85.1276 94.8136Z",
                                        fill: "url(#paint4_linear_5984_45269)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9.5625 77.0117V91.6572C9.5625 92.9009 10.0862 94.0229 10.9241 94.8132C10.9856 94.8725 11.0486 94.9275 11.113 94.9809C11.8674 95.6167 12.8401 95.9997 13.905 95.9997H82.1411C83.206 95.9997 84.1794 95.6167 84.9331 94.9809C84.9983 94.9275 85.0612 94.8718 85.122 94.8132C85.9599 94.0229 86.4836 92.9009 86.4836 91.6572V77.0117H9.5625Z",
                                        fill: "url(#paint5_linear_5984_45269)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M85.2745 94.6662C85.2789 94.6618 85.2833 94.6574 85.2876 94.6523C85.3111 94.6281 85.3338 94.6025 85.3572 94.5768C85.377 94.5549 85.3975 94.5336 85.4173 94.5109C85.4239 94.5036 85.4297 94.4963 85.4363 94.4889C85.4429 94.4816 85.4488 94.4736 85.4554 94.4655C85.4883 94.4274 85.5206 94.3886 85.5521 94.349C85.5601 94.3395 85.5674 94.3293 85.5755 94.319C85.5989 94.2897 85.6209 94.259 85.6436 94.2282C85.6553 94.2128 85.6678 94.1967 85.6788 94.1806C85.6876 94.1681 85.6963 94.1557 85.7051 94.144C85.7374 94.0986 85.7681 94.0524 85.7981 94.0055C85.8069 93.9909 85.8165 93.977 85.826 93.9623C85.8545 93.9169 85.8816 93.8708 85.9087 93.8246C85.9183 93.8078 85.9271 93.7917 85.9366 93.7756C85.9622 93.7302 85.9864 93.684 86.0106 93.6379C86.0193 93.6196 86.0289 93.6012 86.0384 93.5829C86.0611 93.5375 86.0823 93.4921 86.1036 93.4452C86.1124 93.4255 86.1211 93.4057 86.1299 93.3859C86.1504 93.3405 86.1688 93.2936 86.1871 93.2468C86.1951 93.2262 86.2039 93.205 86.212 93.1845C86.2164 93.1728 86.22 93.1611 86.2244 93.1501C86.2369 93.1142 86.2493 93.079 86.2618 93.0431C86.2691 93.0219 86.2764 92.9999 86.2837 92.978C86.2918 92.9523 86.2991 92.9267 86.3064 92.9018C86.313 92.8791 86.3196 92.8571 86.3262 92.8351C86.3321 92.8117 86.3394 92.7897 86.3453 92.7663C86.3548 92.7289 86.3636 92.6916 86.3724 92.6535C86.3753 92.6425 86.3775 92.6315 86.3804 92.6205C86.3856 92.5978 86.3914 92.5751 86.3965 92.5517C86.4009 92.5297 86.4046 92.5085 86.4083 92.4865C86.4141 92.4572 86.42 92.4272 86.4251 92.3979C86.4288 92.3759 86.4332 92.3547 86.4361 92.3334C86.4441 92.2851 86.45 92.236 86.4559 92.1869C86.4566 92.1803 86.4573 92.1738 86.4588 92.1664C86.4603 92.1489 86.4632 92.1305 86.4654 92.1122C86.4683 92.0807 86.4705 92.0492 86.4727 92.0177C86.4756 91.9826 86.4793 91.9474 86.4815 91.9123C86.4815 91.9035 86.483 91.8954 86.483 91.8874C86.4874 91.8112 86.4888 91.7343 86.4888 91.6567V65L75 52.5L52.1917 66.9265C49.5272 65.841 46.5294 65.841 43.8648 66.9265L21.4999 52.5C21.0268 58.5864 22.4999 54 22.5007 66.9265L51.9192 95.9992H82.1463C82.2613 95.9992 82.3741 95.9926 82.4861 95.9838C82.514 95.9816 82.5425 95.9802 82.5704 95.978C82.659 95.9692 82.7469 95.956 82.834 95.9421C82.8487 95.9399 82.8641 95.9384 82.878 95.9362C82.908 95.9311 82.938 95.926 82.9681 95.9201C82.9761 95.9186 82.9842 95.9157 82.993 95.9142C83.0853 95.8959 83.1768 95.8761 83.2669 95.852C83.2933 95.8447 83.3189 95.8373 83.3453 95.83C83.4471 95.8007 83.5481 95.7685 83.647 95.7319C83.6609 95.7267 83.6741 95.7209 83.688 95.7157C83.7876 95.6777 83.8858 95.6366 83.9817 95.592C83.992 95.5868 84.0023 95.5824 84.0125 95.5773C84.1158 95.5282 84.2161 95.4748 84.3143 95.4177C84.3253 95.4118 84.3355 95.4059 84.3458 95.4001C84.4102 95.362 84.4717 95.3202 84.5333 95.2792C84.5684 95.2558 84.605 95.2345 84.6395 95.2104C84.6439 95.2074 84.6475 95.2045 84.6519 95.2016C84.7442 95.1357 84.835 95.0661 84.9214 94.9928C84.991 94.935 85.0599 94.8757 85.1258 94.8134L85.1272 94.8127L85.1294 94.8105C85.1785 94.7636 85.2276 94.716 85.2745 94.6662Z",
                                        fill: "url(#paint6_linear_5984_45269)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip1_5984_45269)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M74.3811 51.1895H20.6189C19.1725 51.1895 18 52.362 18 53.8084V74.0178C18 75.4641 19.1725 76.6367 20.6189 76.6367H74.3811C75.8275 76.6367 77 75.4643 77 74.0178V53.8084C77 52.362 75.8275 51.1895 74.3811 51.1895Z",
                                                fill: "url(#paint7_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M71.759 54.3438H23.2348C22.048 54.3438 21.0859 55.3058 21.0859 56.4926V71.3321C21.0859 72.5189 22.048 73.4809 23.2348 73.4809H71.7588C72.9457 73.4809 73.9077 72.5189 73.9077 71.3321V56.4926C73.9078 55.3058 72.9458 54.3438 71.759 54.3438Z",
                                                fill: "url(#paint8_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M36.5684 58.2634L54.9417 76.6367H74.3821C75.8285 76.6367 77.001 75.4643 77.001 74.0178V68.7227L59.4677 51.1895H35.7656V56.196C35.7656 57.0416 35.9404 57.7922 36.5684 58.2634Z",
                                                fill: "url(#paint9_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M32.4924 66.5029C32.6189 66.6545 32.6946 66.9581 32.6946 67.2362C32.6946 68.0454 31.8854 68.6018 31.1521 68.6018C30.874 68.6018 30.4694 68.5512 30.1912 68.1213L28.5474 65.5924L26.8784 68.1465C26.6508 68.5259 26.3474 68.6018 25.9933 68.6018C25.3863 68.6018 24.4002 68.1213 24.4002 67.2867C24.4002 66.9581 24.5266 66.6799 24.7036 66.4775L26.3726 64.1004L23.7427 63.3417C23.161 63.2153 22.8828 62.7095 22.8828 62.0521C22.8828 61.3945 23.4645 60.6612 24.2737 60.6612C24.3496 60.6612 24.476 60.6612 24.653 60.7371L27.3084 61.5968L27.1818 59.0175C27.2072 58.183 27.8394 57.8037 28.5474 57.8037C29.2555 57.8037 29.8624 58.183 29.8877 59.0175L29.7865 61.6475L32.4671 60.7371C32.5935 60.6865 32.72 60.6612 32.8464 60.6612C33.6304 60.6612 34.1614 61.4957 34.1614 62.2291C34.1614 62.7348 33.9085 63.2153 33.3016 63.3417L30.7222 63.9486L32.4924 66.5029Z",
                                                fill: "url(#paint10_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M45.1487 66.5029C45.2751 66.6545 45.3509 66.9581 45.3509 67.2362C45.3509 68.0454 44.5417 68.6018 43.8083 68.6018C43.5302 68.6018 43.1257 68.5512 42.8474 68.1213L41.2036 65.5924L39.5346 68.1465C39.3071 68.5259 39.0036 68.6018 38.6495 68.6018C38.0425 68.6018 37.0564 68.1213 37.0564 67.2867C37.0564 66.9581 37.1828 66.6799 37.3598 66.4775L39.0289 64.1004L36.399 63.3417C35.8173 63.2153 35.5391 62.7095 35.5391 62.0521C35.5391 61.3945 36.1207 60.6612 36.93 60.6612C37.0058 60.6612 37.1323 60.6612 37.3093 60.7371L39.9646 61.5968L39.8381 59.0175C39.8634 58.183 40.4956 57.8037 41.2036 57.8037C41.9118 57.8037 42.5186 58.183 42.544 59.0175L42.4428 61.6475L45.1233 60.7371C45.2498 60.6865 45.3762 60.6612 45.5027 60.6612C46.2867 60.6612 46.8177 61.4957 46.8177 62.2291C46.8177 62.7348 46.5648 63.2153 45.9579 63.3417L43.3784 63.9486L45.1487 66.5029Z",
                                                fill: "url(#paint11_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M57.8049 66.5029C57.9314 66.6545 58.0071 66.9581 58.0071 67.2362C58.0071 68.0454 57.1979 68.6018 56.4646 68.6018C56.1865 68.6018 55.7819 68.5512 55.5037 68.1213L53.8599 65.5924L52.1909 68.1465C51.9633 68.5259 51.6599 68.6018 51.3058 68.6018C50.6988 68.6018 49.7127 68.1213 49.7127 67.2867C49.7127 66.9581 49.8391 66.6799 50.0161 66.4775L51.6851 64.1004L49.0552 63.3417C48.4735 63.2153 48.1953 62.7095 48.1953 62.0521C48.1953 61.3945 48.777 60.6612 49.5862 60.6612C49.6621 60.6612 49.7885 60.6612 49.9655 60.7371L52.6209 61.5968L52.4943 59.0175C52.5197 58.183 53.1519 57.8037 53.8599 57.8037C54.568 57.8037 55.1749 58.183 55.2002 59.0175L55.099 61.6475L57.7796 60.7371C57.906 60.6865 58.0325 60.6612 58.1589 60.6612C58.9429 60.6612 59.4739 61.4957 59.4739 62.2291C59.4739 62.7348 59.221 63.2153 58.6141 63.3417L56.0347 63.9486L57.8049 66.5029Z",
                                                fill: "url(#paint12_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M70.4533 66.5029C70.5798 66.6545 70.6556 66.9581 70.6556 67.2362C70.6556 68.0454 69.8463 68.6018 69.113 68.6018C68.8349 68.6018 68.4303 68.5512 68.1521 68.1213L66.5083 65.5924L64.8393 68.1465C64.6118 68.5259 64.3083 68.6018 63.9542 68.6018C63.3472 68.6018 62.3611 68.1213 62.3611 67.2867C62.3611 66.9581 62.4875 66.6799 62.6645 66.4775L64.3335 64.1004L61.7036 63.3417C61.122 63.2153 60.8438 62.7095 60.8438 62.0521C60.8438 61.3945 61.4254 60.6612 62.2346 60.6612C62.3105 60.6612 62.437 60.6612 62.614 60.7371L65.2693 61.5968L65.1428 59.0175C65.1681 58.183 65.8003 57.8037 66.5083 57.8037C67.2164 57.8037 67.8233 58.183 67.8487 59.0175L67.7474 61.6475L70.428 60.7371C70.5545 60.6865 70.6809 60.6612 70.8073 60.6612C71.5914 60.6612 72.1224 61.4957 72.1224 62.2291C72.1224 62.7348 71.8695 63.2153 71.2626 63.3417L68.6831 63.9486L70.4533 66.5029Z",
                                                fill: "url(#paint13_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M54.9843 37.6089H54.9559C54.172 37.6089 53.4839 37.1076 53.2205 36.3693C52.3175 33.8381 49.8826 32.0282 47.0376 32.0613C43.4755 32.1028 40.6332 35.0573 40.6332 38.6198V40.104H36.9375V38.5416C36.9375 32.9303 41.5027 28.3652 47.1144 28.3652C51.5464 28.3652 55.3258 31.2131 56.7186 35.1749C57.1368 36.3642 56.245 37.6089 54.9843 37.6089Z",
                                                fill: "url(#paint14_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M55.4703 37.6091H54.9554C54.1715 37.6091 53.4834 37.1078 53.22 36.3695C52.3171 33.8383 49.8821 32.0284 47.0371 32.0615C43.4751 32.103 40.6328 35.0575 40.6328 38.62V40.1042H38.6719V38.8083C38.6719 34.1537 42.4587 30.3662 47.114 30.3662C51.3614 30.3662 54.8865 33.5204 55.4703 37.6091Z",
                                                fill: "url(#paint15_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M59.6954 36.5939C59.5353 36.1833 59.7382 35.7207 60.1488 35.5605L61.3074 35.1085C61.7179 34.9484 62.1806 35.1513 62.3408 35.5618C62.5009 35.9724 62.298 36.435 61.8874 36.5953L60.7288 37.0473C60.3182 37.2075 59.8555 37.0045 59.6954 36.5939Z",
                                                fill: "url(#paint16_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M59.5451 38.2481C59.7734 37.8711 60.264 37.7506 60.641 37.9787L61.7049 38.6227C62.0819 38.851 62.2025 39.3416 61.9743 39.7186C61.7461 40.0956 61.2554 40.2162 60.8784 39.988L59.8146 39.344C59.4376 39.1158 59.3169 38.625 59.5451 38.2481Z",
                                                fill: "url(#paint17_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M58.4663 35.4734C58.8895 35.5963 59.3322 35.3529 59.4551 34.9297L59.8019 33.7355C59.9248 33.3123 59.6814 32.8696 59.2581 32.7467C58.8349 32.6238 58.3922 32.8672 58.2693 33.2905L57.9225 34.4848C57.7996 34.9078 58.043 35.3506 58.4663 35.4734Z",
                                                fill: "url(#paint18_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M56.8814 58.7786H38.1145C36.6878 58.7786 35.5312 57.622 35.5312 56.1954V41.8352C35.5312 40.4085 36.6879 39.252 38.1145 39.252H56.8815C58.3083 39.252 59.4648 40.4086 59.4648 41.8352V56.1954C59.4648 57.622 58.3081 58.7786 56.8814 58.7786Z",
                                                fill: "url(#paint19_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M52.0894 47.1746C52.0894 44.6409 50.0354 42.5869 47.5017 42.5869C44.9681 42.5869 42.9141 44.6409 42.9141 47.1746C42.9141 48.9683 43.9441 50.5204 45.4444 51.2748V53.386C45.4444 54.5223 46.3654 55.4434 47.5017 55.4434C48.638 55.4434 49.5591 54.5223 49.5591 53.386V51.2748C51.0594 50.5204 52.0894 48.9683 52.0894 47.1746Z",
                                                fill: "url(#paint20_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M47.4965 54.2514C47.0197 54.2514 46.6317 53.8635 46.6317 53.3866V50.5402L45.9749 50.2099C44.8194 49.6289 44.1016 48.4661 44.1016 47.1752C44.1016 45.3032 45.6246 43.7803 47.4965 43.7803C49.3684 43.7803 50.8914 45.3033 50.8914 47.1752C50.8914 48.466 50.1736 49.6289 49.0181 50.2099L48.3612 50.5402V53.3866C48.3612 53.8634 47.9732 54.2514 47.4965 54.2514Z",
                                                fill: "url(#paint21_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M47.4965 54.2514C47.0197 54.2514 46.6317 53.8635 46.6317 53.3866V50.5402L45.9749 50.2099C44.8194 49.6289 44.1016 48.4661 44.1016 47.1752C44.1016 45.3032 45.6246 43.7803 47.4965 43.7803C49.3684 43.7803 50.8914 45.3033 50.8914 47.1752C50.8914 48.466 50.1736 49.6289 49.0181 50.2099L48.3612 50.5402V53.3866C48.3612 53.8634 47.9732 54.2514 47.4965 54.2514Z",
                                                fill: "url(#paint22_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M35.5312 52.2852V56.1949C35.5312 57.6216 36.6879 58.7782 38.1145 58.7782H56.8815C58.3083 58.7782 59.4648 57.6215 59.4648 56.1949V52.2852H35.5312Z",
                                                fill: "url(#paint23_linear_5984_45269)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M18 68.6016V74.0171C18 75.4635 19.1725 76.636 20.6189 76.636H74.3811C75.8275 76.636 77 75.4635 77 74.0171V68.6016H18Z",
                                                fill: "url(#paint24_linear_5984_45269)"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint0_linear_5984_45269",
                                        x1: "48.021",
                                        y1: "30.5049",
                                        x2: "48.021",
                                        y2: "107.443",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F58B5E"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#F89030"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint1_linear_5984_45269",
                                        x1: "-17.5",
                                        y1: "-2.49964",
                                        x2: "71.6394",
                                        y2: "16.5485",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EDF5FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint2_linear_5984_45269",
                                        x1: "1.79897",
                                        y1: "55.0999",
                                        x2: "31.7139",
                                        y2: "85.0148",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFD459"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.2296",
                                                "stop-color": "#FFD355"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4362",
                                                "stop-color": "#FFCF4A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.634",
                                                "stop-color": "#FFC838"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.825",
                                                "stop-color": "#FFBF1F"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FFB400"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint3_linear_5984_45269",
                                        x1: "85.5677",
                                        y1: "60.2976",
                                        x2: "62.9036",
                                        y2: "87.1517",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFD459"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.2296",
                                                "stop-color": "#FFD355"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4362",
                                                "stop-color": "#FFCF4A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.634",
                                                "stop-color": "#FFC838"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.825",
                                                "stop-color": "#FFBF1F"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FFB400"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint4_linear_5984_45269",
                                        x1: "48.0288",
                                        y1: "74.0015",
                                        x2: "48.0288",
                                        y2: "100.857",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFD459"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.2296",
                                                "stop-color": "#FFD355"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4362",
                                                "stop-color": "#FFCF4A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.634",
                                                "stop-color": "#FFC838"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.825",
                                                "stop-color": "#FFBF1F"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FFB400"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint5_linear_5984_45269",
                                        x1: "48.0231",
                                        y1: "89.0178",
                                        x2: "48.0231",
                                        y2: "102.933",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#E58200",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.0396",
                                                "stop-color": "#E27F04",
                                                "stop-opacity": "0.039216"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4671",
                                                "stop-color": "#C15D2F",
                                                "stop-opacity": "0.466667"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8016",
                                                "stop-color": "#AD4949",
                                                "stop-opacity": "0.8"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A64153"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint6_linear_5984_45269",
                                        x1: "75.4286",
                                        y1: "72.3783",
                                        x2: "32.529",
                                        y2: "29.4787",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#E58200",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.0396",
                                                "stop-color": "#E27F04",
                                                "stop-opacity": "0.039216"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4671",
                                                "stop-color": "#C15D2F",
                                                "stop-opacity": "0.466667"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8016",
                                                "stop-color": "#AD4949",
                                                "stop-opacity": "0.8"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A64153"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint7_linear_5984_45269",
                                        x1: "44.3848",
                                        y1: "55.6528",
                                        x2: "48.7191",
                                        y2: "79.3259",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#B3DAFE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.2145",
                                                "stop-color": "#AED8FE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4369",
                                                "stop-color": "#A2D2FE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.6628",
                                                "stop-color": "#8DCAFE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8897",
                                                "stop-color": "#70BEFE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#60B7FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint8_linear_5984_45269",
                                        x1: "33.3301",
                                        y1: "59.7192",
                                        x2: "39.981",
                                        y2: "77.2947",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EDF5FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#D5E8FE"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint9_linear_5984_45269",
                                        x1: "49.8478",
                                        y1: "69.2616",
                                        x2: "41.1319",
                                        y2: "51.1593",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.179",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.035"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.3646",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.141"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5532",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.316"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.7438",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.563"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.9342",
                                                "stop-color": "#596C76",
                                                "stop-opacity": "0.876"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#596C76"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint10_linear_5984_45269",
                                        x1: "28.5319",
                                        y1: "60.2685",
                                        x2: "28.5319",
                                        y2: "67.2039",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#5A5A5A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4248",
                                                "stop-color": "#555555"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8643",
                                                "stop-color": "#494949"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#444444"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint11_linear_5984_45269",
                                        x1: "41.1882",
                                        y1: "60.2685",
                                        x2: "41.1882",
                                        y2: "67.2039",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#5A5A5A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4248",
                                                "stop-color": "#555555"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8643",
                                                "stop-color": "#494949"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#444444"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint12_linear_5984_45269",
                                        x1: "53.8444",
                                        y1: "60.2685",
                                        x2: "53.8444",
                                        y2: "67.2039",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#5A5A5A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4248",
                                                "stop-color": "#555555"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8643",
                                                "stop-color": "#494949"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#444444"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint13_linear_5984_45269",
                                        x1: "66.4928",
                                        y1: "60.2685",
                                        x2: "66.4928",
                                        y2: "67.2039",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#5A5A5A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4248",
                                                "stop-color": "#555555"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8643",
                                                "stop-color": "#494949"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#444444"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint14_linear_5984_45269",
                                        x1: "41.1681",
                                        y1: "31.2725",
                                        x2: "49.2176",
                                        y2: "39.3219",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EDF5FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#B5DBFF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint15_linear_5984_45269",
                                        x1: "47.0712",
                                        y1: "38.2285",
                                        x2: "47.0712",
                                        y2: "15.3972",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#B5DBFF",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.2428",
                                                "stop-color": "#93CEF6",
                                                "stop-opacity": "0.243"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5763",
                                                "stop-color": "#6ABFEC",
                                                "stop-opacity": "0.576"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8403",
                                                "stop-color": "#51B5E5",
                                                "stop-opacity": "0.84"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#48B2E3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint16_linear_5984_45269",
                                        x1: "60.8733",
                                        y1: "35.9985",
                                        x2: "61.1947",
                                        y2: "36.8238",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FF637B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E63950"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint17_linear_5984_45269",
                                        x1: "60.8714",
                                        y1: "38.997",
                                        x2: "60.4126",
                                        y2: "39.7551",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FF637B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E63950"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint18_linear_5984_45269",
                                        x1: "59.0682",
                                        y1: "34.1264",
                                        x2: "58.2181",
                                        y2: "33.8793",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FF637B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E63950"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint19_linear_5984_45269",
                                        x1: "41.1713",
                                        y1: "42.6886",
                                        x2: "51.7783",
                                        y2: "53.2957",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFDA2D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FDBF00"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint20_linear_5984_45269",
                                        x1: "52.1385",
                                        y1: "53.1279",
                                        x2: "41.558",
                                        y2: "42.5473",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FFDA2D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FDBF00"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint21_linear_5984_45269",
                                        x1: "44.6396",
                                        y1: "46.4136",
                                        x2: "49.5702",
                                        y2: "49.8429",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#5A5A5A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4248",
                                                "stop-color": "#555555"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8643",
                                                "stop-color": "#494949"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#444444"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint22_linear_5984_45269",
                                        x1: "49.7946",
                                        y1: "51.2945",
                                        x2: "44.1445",
                                        y2: "45.1299",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#464646",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.6727",
                                                "stop-color": "#252529",
                                                "stop-opacity": "0.463"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#000009"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint23_linear_5984_45269",
                                        x1: "47.4981",
                                        y1: "55.7011",
                                        x2: "47.4981",
                                        y2: "58.8958",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#FF9100",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#FF9100"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint24_linear_5984_45269",
                                        x1: "33.4205",
                                        y1: "72.6138",
                                        x2: "33.521",
                                        y2: "77.7993",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#3692BC",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.1409",
                                                "stop-color": "#3692BC",
                                                "stop-opacity": "0.022"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.287",
                                                "stop-color": "#3692BC",
                                                "stop-opacity": "0.088"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.4355",
                                                "stop-color": "#3692BC",
                                                "stop-opacity": "0.199"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5856",
                                                "stop-color": "#3692BC",
                                                "stop-opacity": "0.354"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.7371",
                                                "stop-color": "#3692BC",
                                                "stop-opacity": "0.553"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8874",
                                                "stop-color": "#3692BC",
                                                "stop-opacity": "0.793"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#3692BC"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                        id: "clip0_5984_45269",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                            width: "96",
                                            height: "96",
                                            fill: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                        id: "clip1_5984_45269",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                            width: "59",
                                            height: "59",
                                            fill: "white",
                                            transform: "translate(18 23)"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 tac mb1rem",
                            children: "Check your Email"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 tac op70 mb1-5rem fs13px",
                            children: "Click on the button inside the email we have sent you."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "maw180px mxa mb2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                btnType: "warning",
                                loading: loading,
                                disabled: isButtonDisabled,
                                customClassName: "bg44 c4 bss bs1px bo4",
                                text: buttonText,
                                onClick: handleResendEmail
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $0c3ef04e6d3070d8$export$2e2bcd8739ae039 = $0c3ef04e6d3070d8$var$ResendForgotPasswordEmail;




var $ayMG0 = parcelRequire("ayMG0");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8975383ad1dea524$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $6e7dc83b503813b6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
    }, "1")
], 'KeyboardDoubleArrowDown');




var $acw62 = parcelRequire("acw62");




const $eea7011072ddb57e$var$SyncingProgress = ()=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(true);
    let { data: data, totalFile: totalFile, type: type } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileManagement);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            id: "syncing",
            className: "pf bg1 shadow",
            style: {
                zIndex: '9999',
                left: "10px",
                bottom: "0px",
                borderRadius: "16px 16px 0px 0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                width: '350px'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "syncingProgressHeader tal df aic jcsb w100 pl1rem",
                    style: {
                        height: '60px',
                        borderBottom: '1px solid #eaeaea'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c15 fs1rem",
                            children: type === "syncingFolders" ? "Please wait while we create sub folders in your data room..." : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    type === "syncing" ? data.filter(({ file: file })=>file['dbFileMetadata'] || file['gDriveFileId'] || file['spDriveItem']).length || "0" : data.filter((d)=>d['processed']).length || "0",
                                    " out of ",
                                    totalFile,
                                    " ",
                                    type === "syncing" ? 'files' : "answers",
                                    " are ",
                                    type === "syncing" ? type : "sync in reverse"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic jcfe",
                            children: type === "syncingFolders" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cp px1rem br50px c15 df aic",
                                onClick: ()=>setIsExpanded(!isExpanded),
                                style: {
                                    transition: 'transform 0.3s ease',
                                    transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e7dc83b503813b6$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 scrollbarWidth",
                    style: {
                        maxHeight: type === "syncingFolders" ? '0' : isExpanded ? '250px' : '0px',
                        overflowY: 'auto',
                        transition: 'max-height 0.3s ease, opacity 0.3s ease',
                        opacity: isExpanded ? 1 : 0
                    },
                    children: data && data.length ? type === "syncingFolders" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : type === "syncing" ? data.map(({ file: file, answer: answer }, ind)=>{
                        let image = (parcelRequire("hYCi0"));
                        const fileType = file.originalname.split('.').pop().toLowerCase();
                        if (fileType === 'pdf') image = (parcelRequire("8KwAi"));
                        if (fileType === 'pptx') image = (parcelRequire("hYCi0"));
                        if (fileType === 'xlsx') image = (parcelRequire("4CB20"));
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `df aic jcsb py1rem w100 px1rem ${!(file['dbFileMetadata'] || file['gDriveFileId'] || file['spDriveItem']) && "op60"}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            style: {
                                                marginRight: '8px'
                                            },
                                            src: image,
                                            alt: "fileType"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs14px",
                                            children: [
                                                answer.qNo,
                                                " - ",
                                                file.originalname
                                            ]
                                        })
                                    ]
                                }),
                                file['dbFileMetadata'] || file['gDriveFileId'] || file['spDriveItem'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                                    width: 20,
                                    height: 20,
                                    className: "green"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "br50px bw2px bss db",
                                        style: {
                                            height: '20px',
                                            width: '20px',
                                            borderColor: '#d0cfcfff'
                                        }
                                    })
                                })
                            ]
                        }, `syncing-file-${ind}-${answer.qNo}-${file.key || file.originalname}`);
                    }) : type === "reSyncing" ? data.map((answer, ind)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `df aic jcsb py1rem w100 px1rem ${!answer['processed'] && "op60"}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs10px bg4 br50px c1 p0-5rem df aic jcc",
                                            style: {
                                                height: '32px',
                                                width: '32px'
                                            },
                                            children: "SEC"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs14px ml1rem",
                                            children: [
                                                answer.qNo,
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                answer['processed'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                                    width: 20,
                                    height: 20,
                                    className: "green"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "br50px bw2px bss db",
                                        style: {
                                            height: '20px',
                                            width: '20px',
                                            borderColor: '#d0cfcfff'
                                        }
                                    })
                                })
                            ]
                        }, `syncing-file-${ind}-${answer.qNo}-${answer['_id']}`);
                    }) : null : null
                })
            ]
        })
    });
};
var $eea7011072ddb57e$export$2e2bcd8739ae039 = $eea7011072ddb57e$var$SyncingProgress;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f9b9596425583678$exports = {};
"use strict";
var $508f735703b01dcf$exports = {};
"use strict";
Object.defineProperty($508f735703b01dcf$exports, "__esModule", {
    value: true
});
Object.defineProperty($508f735703b01dcf$exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $508f735703b01dcf$var$_DraggableCore.default;
    }
});
$508f735703b01dcf$exports.default = void 0;

var $508f735703b01dcf$var$React = $508f735703b01dcf$var$_interopRequireWildcard((parcelRequire("acw62")));

var $508f735703b01dcf$var$_propTypes = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $508f735703b01dcf$var$_reactDom = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $9QePP = parcelRequire("9QePP");

var $hVGkP = parcelRequire("hVGkP");

var $jc5pr = parcelRequire("jc5pr");

var $7jnr7 = parcelRequire("7jnr7");

var $508f735703b01dcf$var$_DraggableCore = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("7eM6q")));

var $508f735703b01dcf$var$_log = $508f735703b01dcf$var$_interopRequireDefault((parcelRequire("ldVpK")));
function $508f735703b01dcf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $508f735703b01dcf$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($508f735703b01dcf$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $508f735703b01dcf$var$_extends() {
    return $508f735703b01dcf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $508f735703b01dcf$var$_extends.apply(null, arguments);
}
function $508f735703b01dcf$var$_defineProperty(e, r, t) {
    return (r = $508f735703b01dcf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $508f735703b01dcf$var$_toPropertyKey(t) {
    var i = $508f735703b01dcf$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $508f735703b01dcf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $508f735703b01dcf$var$Draggable extends $508f735703b01dcf$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $508f735703b01dcf$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $508f735703b01dcf$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $508f735703b01dcf$var$_log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $jc5pr.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $508f735703b01dcf$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $508f735703b01dcf$var$_log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, $jc5pr.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $jc5pr.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $508f735703b01dcf$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $jc5pr.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $508f735703b01dcf$var$_log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        return this.props?.nodeRef?.current ?? $508f735703b01dcf$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $jc5pr.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $jc5pr.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $hVGkP.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $hVGkP.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $9QePP.clsx)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $508f735703b01dcf$var$React.createElement($508f735703b01dcf$var$_DraggableCore.default, $508f735703b01dcf$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $508f735703b01dcf$var$React.cloneElement($508f735703b01dcf$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
$508f735703b01dcf$exports.default = $508f735703b01dcf$var$Draggable;
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "displayName", 'Draggable');
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$508f735703b01dcf$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $508f735703b01dcf$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $508f735703b01dcf$var$_propTypes.default.oneOfType([
        $508f735703b01dcf$var$_propTypes.default.shape({
            left: $508f735703b01dcf$var$_propTypes.default.number,
            right: $508f735703b01dcf$var$_propTypes.default.number,
            top: $508f735703b01dcf$var$_propTypes.default.number,
            bottom: $508f735703b01dcf$var$_propTypes.default.number
        }),
        $508f735703b01dcf$var$_propTypes.default.string,
        $508f735703b01dcf$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $508f735703b01dcf$var$_propTypes.default.string,
    defaultClassNameDragging: $508f735703b01dcf$var$_propTypes.default.string,
    defaultClassNameDragged: $508f735703b01dcf$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.number,
        y: $508f735703b01dcf$var$_propTypes.default.number
    }),
    positionOffset: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.oneOfType([
            $508f735703b01dcf$var$_propTypes.default.number,
            $508f735703b01dcf$var$_propTypes.default.string
        ]),
        y: $508f735703b01dcf$var$_propTypes.default.oneOfType([
            $508f735703b01dcf$var$_propTypes.default.number,
            $508f735703b01dcf$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $508f735703b01dcf$var$_propTypes.default.shape({
        x: $508f735703b01dcf$var$_propTypes.default.number,
        y: $508f735703b01dcf$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $7jnr7.dontSetMe,
    style: $7jnr7.dontSetMe,
    transform: $7jnr7.dontSetMe
});
$508f735703b01dcf$var$_defineProperty($508f735703b01dcf$var$Draggable, "defaultProps", {
    ...$508f735703b01dcf$var$_DraggableCore.default.defaultProps,
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});


var $f9b9596425583678$require$Draggable = $508f735703b01dcf$exports.default;
var $f9b9596425583678$require$DraggableCore = $508f735703b01dcf$exports.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
$f9b9596425583678$exports = $f9b9596425583678$require$Draggable;
$f9b9596425583678$exports.default = $f9b9596425583678$require$Draggable;
$f9b9596425583678$exports.DraggableCore = $f9b9596425583678$require$DraggableCore;



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ea4b29d6a58d8d93$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 18.96c-.39.39-.39 1.02 0 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05c.39-.39.39-1.02 0-1.41zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12z"
}), 'AutoFixHigh');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $af7008da7e6d6ab9$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), 'CloudUpload');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3fb6cdd207b8a1a5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'DragIndicator');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d5c032c9e71e53e0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $cf6866e33a4a25da$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');





const $980eb83ab9562f3a$var$barBg = {
    background: '#E5E7EB',
    borderRadius: '10px',
    height: '8px',
    overflow: 'hidden',
    marginBottom: '0.75rem'
};
const $980eb83ab9562f3a$var$barFill = (w)=>({
        background: 'linear-gradient(90deg, #4a67ff 0%, #3d56d9 100%)',
        height: '100%',
        borderRadius: '10px',
        width: `${w}%`,
        transition: 'width 0.3s ease'
    });
const $980eb83ab9562f3a$var$statBox = (bg)=>({
        background: bg,
        borderRadius: '8px',
        padding: '0.5rem',
        textAlign: 'center'
    });
const $980eb83ab9562f3a$var$ellipsis = {
    margin: 0,
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
const $980eb83ab9562f3a$var$ProgressBar = ({ percent: percent })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $980eb83ab9562f3a$var$barBg,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: $980eb83ab9562f3a$var$barFill(percent)
        })
    });
const $980eb83ab9562f3a$var$AutoFillStatusBar = ()=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(true);
    const [fetchingReport, setFetchingReport] = (0, $acw62.useState)(false);
    const nodeRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { fileReport: fileReport, autoFillContext: autoFillContext } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const lastSocketEvent = (0, $acw62.useRef)(0);
    const cancelledRef = (0, $acw62.useRef)(false);
    // Reason: the socket-listener effect below has an empty dep array (registers once), so handlers must read
    // autoFillContext via ref, not the destructured value, to avoid a stale closure on extraModules/generateReports
    const autoFillContextRef = (0, $acw62.useRef)(autoFillContext);
    autoFillContextRef.current = autoFillContext;
    // Use local state for all status bar data to avoid triggering re-renders in Company/index.js
    const [status, setStatus] = (0, $acw62.useState)({
        visible: false,
        phase: '',
        moduleName: '',
        total: 0,
        current: 0,
        currentQuestion: '',
        questionText: '',
        sectionNo: '',
        sectionName: '',
        readingFiles: [],
        startTime: null,
        uploadProgress: null,
        processed: 0,
        answered: 0,
        needsReview: 0,
        skipped: 0,
        error: '',
        indexingProgress: null,
        withFilling: false,
        crossFileModuleType: '',
        otherModuleType: ''
    });
    // Sync from Redux modal → local state (only for initial triggers from AutoFillButton/QuesAns)
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const prevPhaseRef = (0, $acw62.useRef)('');
    (0, $acw62.useEffect)(()=>{
        if (modal.autoFillStatusBarVisible && !status.visible) {
            cancelledRef.current = false;
            setStatus((s)=>({
                    ...s,
                    visible: true,
                    phase: modal.autoFillStatusBarPhase || s.phase,
                    moduleName: modal.autoFillModuleName || s.moduleName,
                    uploadProgress: modal.autoFillUploadProgress || s.uploadProgress,
                    withFilling: !!modal.autoFillWithFilling
                }));
        }
        // When Redux explicitly clears the status bar (full reset), hide local state too
        if (modal.autoFillStatusBarVisible === false && !modal.autoFillStatusBarPhase && status.visible) setStatus((s)=>({
                ...s,
                visible: false
            }));
        // Sync phase changes initiated externally (e.g., uploading→indexing→allocated from AutoFillButton)
        if (modal.autoFillStatusBarPhase && modal.autoFillStatusBarPhase !== prevPhaseRef.current && modal.autoFillStatusBarPhase !== status.phase) {
            prevPhaseRef.current = modal.autoFillStatusBarPhase;
            // Map stepper phases to status bar phases
            const mappedPhase = modal.autoFillStatusBarPhase === 'crossFileUpload' ? 'crossFileUpload' : modal.autoFillStatusBarPhase === 'otherModules' ? 'otherModulesAI' : modal.autoFillStatusBarPhase;
            setStatus((s)=>({
                    ...s,
                    phase: mappedPhase,
                    moduleName: modal.autoFillModuleName || s.moduleName,
                    uploadProgress: modal.autoFillUploadProgress ?? s.uploadProgress,
                    indexingProgress: modal.autoFillIndexingProgress ?? s.indexingProgress,
                    total: 0,
                    current: 0,
                    questionText: '',
                    readingFiles: []
                }));
        }
    }, [
        modal.autoFillStatusBarVisible,
        modal.autoFillStatusBarPhase,
        modal.autoFillModuleName,
        modal.autoFillUploadProgress,
        modal.autoFillIndexingProgress
    ]);
    // Fetch file report from server by ID (used on page refresh restore)
    const fetchFileReport = async (fileReportId)=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReport/${fileReportId}`);
            if (res?.code === 200 && res?.body) {
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    fileReport: res.body
                }));
                return res.body;
            }
        } catch (e) {
            console.error('Failed to fetch file report:', e);
        }
        return null;
    };
    // Restore state on page refresh via socket — backend re-emits 'autoFill:currentStatus'
    // automatically when the socket reconnects and re-registers (see sockets.js register handler)
    (0, $acw62.useEffect)(()=>{
        const handleCurrentStatus = (operation)=>{
            if (!operation || status.visible) return;
            const activePhases = [
                'indexing',
                'processingFiles',
                'filling'
            ];
            if (activePhases.includes(operation.phase)) {
                const withFilling = operation.withFilling !== undefined ? !!operation.withFilling : operation.source !== 'temp';
                setStatus({
                    visible: true,
                    phase: operation.phase,
                    moduleName: operation.moduleName || '',
                    total: operation.total || 0,
                    current: operation.current || 0,
                    currentQuestion: operation.currentQuestion || '',
                    uploadProgress: null,
                    processed: 0,
                    answered: 0,
                    needsReview: 0,
                    skipped: 0,
                    error: '',
                    indexingProgress: operation.indexingProgress || null,
                    source: operation.source || '',
                    withFilling: withFilling
                });
                // Restore autoFillContext so confirm-allocation uses the correct route/moduleId after refresh
                if (operation.companyId && operation.moduleType) // Reason: the live snapshot only knows the main module — keep what the app already knows (extra modules,
                // research-reports tick, resume pointer) instead of wiping it on every mount/reconnect
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    autoFillContext: {
                        ...autoFillContextRef.current || {},
                        enabled: true,
                        companyId: operation.companyId,
                        moduleType: operation.moduleType,
                        moduleId: operation.moduleId || null,
                        sectionCode: operation.sectionCode || null,
                        scope: operation.scope || 'module',
                        scopeName: operation.scopeName || '',
                        extraModules: operation.extraModules?.length ? operation.extraModules : autoFillContextRef.current?.extraModules || []
                    },
                    tab: operation.moduleType
                }));
                const restoreTime = Date.now();
                const staleTimer = setTimeout(()=>{
                    if (lastSocketEvent.current < restoreTime) setStatus((s)=>({
                            ...s,
                            phase: 'stale'
                        }));
                }, 15000);
                return ()=>clearTimeout(staleTimer);
            } else if (operation.phase === 'allocated') {
                // Always restore to status bar on refresh — user clicks maximize to open modal
                if (operation.companyId && operation.moduleType) // Reason: the live snapshot only knows the main module — keep what the app already knows (extra modules,
                // research-reports tick, resume pointer) instead of wiping it on every mount/reconnect
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    autoFillContext: {
                        ...autoFillContextRef.current || {},
                        enabled: true,
                        companyId: operation.companyId,
                        moduleType: operation.moduleType,
                        moduleId: operation.moduleId || null,
                        sectionCode: operation.sectionCode || null,
                        scope: operation.scope || 'module',
                        scopeName: operation.scopeName || '',
                        extraModules: operation.extraModules?.length ? operation.extraModules : autoFillContextRef.current?.extraModules || []
                    },
                    tab: operation.moduleType
                }));
                // Pre-fetch report into Redux so maximize opens instantly without loading
                if (operation.fileReportId) fetchFileReport(operation.fileReportId).then((report)=>{
                    if (report?.importResult) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                        fileReport: report,
                        currentScore: report.currentScore || 0
                    }));
                });
                setStatus({
                    visible: true,
                    phase: 'allocated',
                    moduleName: operation.moduleName || '',
                    total: 0,
                    current: 0,
                    currentQuestion: '',
                    uploadProgress: null,
                    processed: 0,
                    answered: 0,
                    needsReview: 0,
                    skipped: 0,
                    error: '',
                    indexingProgress: null,
                    withFilling: operation.withFilling !== false
                });
            } else if (operation.phase === 'otherModules') {
                if (operation.companyId && operation.moduleType) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    autoFillContext: {
                        ...autoFillContextRef.current || {},
                        enabled: true,
                        companyId: operation.companyId,
                        moduleType: operation.moduleType,
                        moduleId: operation.moduleId || null,
                        sectionCode: operation.sectionCode || null,
                        scope: operation.scope || 'module',
                        scopeName: operation.scopeName || '',
                        extraModules: operation.targetModules || []
                    },
                    tab: operation.moduleType
                }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'otherModules',
                    autoFillStatusBarPhase: 'otherModules',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: true
                }));
            }
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:currentStatus', handleCurrentStatus);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:currentStatus', handleCurrentStatus);
        // Pull the current status once the listener above is attached. On a page refresh the register handshake's
        // one-shot re-emit races ahead of this component mounting, so relying on it alone loses the event and the
        // minimized bar never restores. Emitting getStatus here (and on every reconnect) asks the server to push
        // the snapshot again, now that we're listening.
        const requestStatus = ()=>{
            const userId = user?.['_id'] || user?.['id'];
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).emit('autoFill:getStatus', userId ? {
                userId: String(userId)
            } : {});
        };
        if ((0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).connected) requestStatus();
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('connect', requestStatus);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:currentStatus', handleCurrentStatus);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:currentStatus', handleCurrentStatus);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('connect', requestStatus);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Socket events — update local state only, no Redux dispatches
    (0, $acw62.useEffect)(()=>{
        const handleProgress = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                const updates = {
                    total: data.total || 0,
                    current: data.current || 0,
                    currentQuestion: data.currentQuestion || '',
                    questionText: data.questionText || '',
                    sectionNo: data.sectionNo || '',
                    sectionName: data.sectionName || '',
                    readingFiles: []
                };
                if (s.phase === 'allocated') return {
                    ...s,
                    ...updates,
                    phase: 'filling',
                    startTime: Date.now()
                };
                if (s.phase !== 'filling') return s;
                return {
                    ...s,
                    ...updates,
                    startTime: s.startTime || Date.now()
                };
            });
        };
        const handleReading = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase !== 'filling') return s;
                return {
                    ...s,
                    readingFiles: data.files || []
                };
            });
        };
        const handleCompleted = (data)=>{
            lastSocketEvent.current = Date.now();
            // Reason: if extra modules or research reports are queued, handleSkipUpload's own flow (otherModules
            // screen, then live report progress) owns the transition to 'completed' — jumping here early would
            // let the user maximize straight into the Result screen before those steps actually finish
            const ctx = autoFillContextRef.current || {};
            const hasExtraModules = (ctx.extraModules || []).length > 0;
            if (hasExtraModules || ctx.generateReports) return;
            setStatus((s)=>({
                    ...s,
                    phase: 'completed',
                    processed: data.processed || 0,
                    answered: data.answered || 0,
                    needsReview: data.needsReview || 0,
                    skipped: data.skipped || 0
                }));
        };
        const handleIndexingProgress = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase !== 'indexing') return s;
                return {
                    ...s,
                    indexingProgress: {
                        total: data.total || 0,
                        current: data.current || 0,
                        currentFile: data.currentFile || ''
                    }
                };
            });
        };
        // Allocation runs as a second pass inside the 'indexing' phase — track it so the minimized
        // bar doesn't sit at 100% while the maximized view shows allocation progress
        const handleAllocationProgress = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase !== 'indexing') return s;
                return {
                    ...s,
                    allocationProgress: {
                        total: data.total || 0,
                        current: data.current || 0,
                        fileName: data.fileName || ''
                    }
                };
            });
        };
        const handleAllocationCompleted = (data)=>{
            // Ignore if user cancelled — don't re-show the status bar
            if (cancelledRef.current) return;
            lastSocketEvent.current = Date.now();
            // Always transition indexing → allocated, not just on page refresh
            setStatus((s)=>{
                if (s.phase !== 'indexing') return s;
                return {
                    ...s,
                    phase: 'allocated',
                    allocationProgress: null
                };
            });
            if (data?.fileReport) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: data.fileReport
            }));
        };
        const handleProcessingFilesStarted = (data)=>{
            lastSocketEvent.current = Date.now();
            // Don't force visible — user must click minimize to show status bar.
            // Just update state in background so it's ready if they minimize.
            setStatus((s)=>({
                    ...s,
                    phase: 'processingFiles',
                    total: data.total || 0,
                    current: 0
                }));
        };
        const handleProcessingFilesProgress = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase !== 'processingFiles') return s;
                return {
                    ...s,
                    current: data.current || 0,
                    total: data.total || 0
                };
            });
        };
        const handleProcessingFilesCompleted = ()=>{
            lastSocketEvent.current = Date.now();
        // Don't transition to 'filling' here — runAutoFill in importSummary handles it
        // via dispatch(toggleModal({ autoFillStatusBarPhase: 'filling' })).
        // Transitioning early would show the filling UI before autofill HTTP call is made.
        };
        const handleCancelled = ()=>{
            cancelledRef.current = true;
            setStatus({
                visible: false,
                phase: '',
                moduleName: '',
                total: 0,
                current: 0,
                currentQuestion: '',
                questionText: '',
                sectionNo: '',
                sectionName: '',
                readingFiles: [],
                startTime: null,
                uploadProgress: null,
                processed: 0,
                answered: 0,
                needsReview: 0,
                skipped: 0,
                error: '',
                indexingProgress: null,
                crossFileModuleType: '',
                otherModuleType: ''
            });
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                autoFillStatusBarVisible: false,
                autoFillStatusBarPhase: ''
            }));
        };
        // Cross File Upload step — otherModules:* events from fillOtherModules
        const handleCrossFileProgress = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase === 'otherModulesAI') return s;
                return {
                    ...s,
                    phase: 'crossFileUpload',
                    total: data.total || s.total,
                    current: data.current || s.current,
                    crossFileModuleType: data.moduleType || s.crossFileModuleType
                };
            });
        };
        const handleCrossFileModuleCompleted = ()=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase === 'otherModulesAI') return s;
                return {
                    ...s,
                    crossFileModuleType: ''
                };
            });
        };
        // AI Other Modules step — autoFill:* events per module call
        const handleAiOtherProgress = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase !== 'otherModulesAI') return s;
                return {
                    ...s,
                    total: data.total || s.total,
                    current: data.current || s.current,
                    questionText: data.questionText || s.questionText,
                    otherModuleType: data.moduleType || s.otherModuleType
                };
            });
        };
        const handleAiOtherReading = (data)=>{
            lastSocketEvent.current = Date.now();
            setStatus((s)=>{
                if (s.phase !== 'otherModulesAI') return s;
                return {
                    ...s,
                    readingFiles: data.files || []
                };
            });
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:progress', handleProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:progress', handleProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:reading', handleReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:reading', handleReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:completed', handleCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:completed', handleCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:cancelled', handleCancelled);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:cancelled', handleCancelled);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('indexing:progress', handleIndexingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempIndexing:progress', handleIndexingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('allocation:progress', handleAllocationProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:progress', handleAllocationProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('allocation:completed', handleAllocationCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:completed', handleAllocationCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('processingFiles:started', handleProcessingFilesStarted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempProcessingFiles:started', handleProcessingFilesStarted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('processingFiles:progress', handleProcessingFilesProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempProcessingFiles:progress', handleProcessingFilesProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('processingFiles:completed', handleProcessingFilesCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempProcessingFiles:completed', handleProcessingFilesCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('otherModules:progress', handleCrossFileProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('otherModules:moduleCompleted', handleCrossFileModuleCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:progress', handleAiOtherProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:progress', handleAiOtherProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:reading', handleAiOtherReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:reading', handleAiOtherReading);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:progress', handleProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:progress', handleProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:reading', handleReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:reading', handleReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:completed', handleCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:completed', handleCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:cancelled', handleCancelled);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:cancelled', handleCancelled);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('indexing:progress', handleIndexingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempIndexing:progress', handleIndexingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('allocation:progress', handleAllocationProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:progress', handleAllocationProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('allocation:completed', handleAllocationCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:completed', handleAllocationCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('processingFiles:started', handleProcessingFilesStarted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempProcessingFiles:started', handleProcessingFilesStarted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('processingFiles:progress', handleProcessingFilesProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempProcessingFiles:progress', handleProcessingFilesProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('processingFiles:completed', handleProcessingFilesCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempProcessingFiles:completed', handleProcessingFilesCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('otherModules:progress', handleCrossFileProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('otherModules:moduleCompleted', handleCrossFileModuleCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:progress', handleAiOtherProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:progress', handleAiOtherProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:reading', handleAiOtherReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:reading', handleAiOtherReading);
        };
    }, [
        dispatch
    ]);
    // Don't render status bar if it's not visible, or if a full modal is already showing
    const modalOpen = modal?.open;
    if (!status.visible || modalOpen === 'autoFillingQuestions' || modalOpen === 'computerToClarence' || modalOpen === 'allocatingFiles' || modalOpen === 'importSummary' || modalOpen === 'autoFillStepper') return null;
    const handleClose = ()=>{
        setStatus({
            visible: false,
            phase: '',
            moduleName: '',
            total: 0,
            current: 0,
            currentQuestion: '',
            questionText: '',
            sectionNo: '',
            sectionName: '',
            readingFiles: [],
            startTime: null,
            uploadProgress: null,
            processed: 0,
            answered: 0,
            needsReview: 0,
            skipped: 0,
            error: '',
            indexingProgress: null
        });
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            autoFillStatusBarVisible: false,
            autoFillStatusBarPhase: ''
        }));
    };
    const handleCancel = async ()=>{
        cancelledRef.current = true;
        try {
            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/cancel', {});
        } catch (e) {}
        setStatus({
            visible: false,
            phase: '',
            moduleName: '',
            total: 0,
            current: 0,
            currentQuestion: '',
            questionText: '',
            sectionNo: '',
            sectionName: '',
            readingFiles: [],
            startTime: null,
            uploadProgress: null,
            processed: 0,
            answered: 0,
            needsReview: 0,
            skipped: 0,
            error: '',
            indexingProgress: null
        });
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            autoFillStatusBarVisible: false,
            autoFillStatusBarPhase: ''
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill cancelled');
    };
    // Issue 32 — Resume the interrupted run straight from the status bar: find the newest resumable report,
    // rebuild the run context, and reopen the stepper at the step it died at (same flow as the history modal).
    const handleResumeRun = async ()=>{
        try {
            const ctx = autoFillContextRef.current || {};
            const companyId = ctx.companyId || fileReport?.companyId?._id || fileReport?.companyId;
            // Reason: the remembered pointer can be stale (left over from an earlier run's resume) — the server's newest resumable run is
            // the truth, so ask it first and only fall back to the pointer if that request fails
            let reportId = null;
            if (companyId) {
                const listRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportHistory/${companyId}`).catch(()=>null);
                const rows = Array.isArray(listRes?.body) ? listRes.body : [];
                // Rows come newest-first — pick the first resumable run
                const isFlagged = (r)=>[
                        'interrupted',
                        'cancelled'
                    ].includes(r.autoFillRun?.status) || r.autoFillRun?.status === 'allocating' && [
                        'allocated',
                        'attaching',
                        'attached'
                    ].includes(r.autoFillRun?.step);
                // Reason: this card shows the moment the request failed, often before the server has flagged the run 'interrupted' — a run
                // still labelled in-flight is the one that died. The server's live-operation guard refuses it if it really is still running.
                const isInFlight = (r)=>r.autoFillRun?.status === 'filling' || r.autoFillRun?.status === 'allocating' && [
                        'allocation',
                        'attaching'
                    ].includes(r.autoFillRun?.step);
                const resumable = rows.find((r)=>!r.rolledBack && isFlagged(r)) || rows.find((r)=>!r.rolledBack && isInFlight(r));
                reportId = resumable?._id || null;
            }
            if (!reportId) reportId = ctx.resume?.fileReportId || null;
            if (!reportId) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('No resumable run found', 'error');
                return;
            }
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReport/${reportId}`);
            const fullReport = res?.body;
            const scope = fullReport?.autoFillRun?.scope;
            if (!scope?.moduleType) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('This run cannot be resumed', 'error');
                return;
            }
            const step = fullReport.autoFillRun?.step || 'allocation';
            const entries = Object.values(fullReport?.importResult || {});
            const allocated = entries.filter((e)=>e?.section?.some?.((s)=>s && !String(s).includes('XXX'))).length;
            handleClose();
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: fullReport,
                tab: scope.moduleType,
                currentScore: entries.length ? Math.round(allocated / entries.length * 100) : 0,
                autoFillContext: {
                    enabled: !!scope.fromAutoFill,
                    companyId: String(companyId || fullReport.companyId || ''),
                    moduleType: scope.moduleType,
                    moduleId: scope.moduleId || null,
                    sectionCode: scope.sectionCode || null,
                    scope: scope.sectionCode ? 'section' : 'module',
                    scopeName: scope.moduleType,
                    extraModules: scope.extraModules || [],
                    generateReports: !!scope.generateReports,
                    resume: {
                        fileReportId: String(reportId),
                        step: step,
                        src: scope.src || 'company'
                    }
                }
            }));
            const phase = step === 'allocation' ? 'indexing' : [
                'allocated',
                'attaching'
            ].includes(step) ? 'allocation' : 'filling';
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: phase,
                autoFillModuleName: scope.moduleType === 'repository' ? 'Data Repository' : scope.moduleType,
                autoFillWithFilling: !!scope.fromAutoFill,
                autoFillTotal: 0,
                autoFillCurrent: 0,
                autoFillCurrentQuestion: '',
                autoFillCompleted: false,
                autoFillProcessed: 0,
                autoFillAnswered: 0,
                autoFillNeedsReview: 0,
                autoFillSkipped: 0,
                autoFillStatusBarVisible: false,
                autoFillStatusBarPhase: phase === 'allocation' ? 'allocated' : phase
            }));
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Resume failed \u2014 please try again", 'error');
        }
    };
    const getHeaderText = ()=>{
        switch(status.phase){
            case 'uploading':
                {
                    const p = status.uploadProgress || {};
                    return `Uploading ${p.current || 0} of ${p.total || 0} files`;
                }
            case 'indexing':
                {
                    const idx = status.indexingProgress || {};
                    const alloc = status.allocationProgress || {};
                    // Allocation is the second pass of this phase — mirror the maximized view once indexing finishes
                    if (alloc.total > 0 && (!idx.total || (idx.current || 0) >= idx.total)) return `Allocating ${alloc.current || 0} of ${alloc.total} files`;
                    return idx.total > 0 ? `Indexing ${idx.current || 0} of ${idx.total} files` : 'Indexing files...';
                }
            case 'processingFiles':
                return status.total > 0 ? `Processing ${status.current || 0} of ${status.total} files` : 'Processing files...';
            case 'allocated':
                return 'Files allocated - tap to review';
            case 'filling':
                return status.total > 0 ? `Auto-filling ${status.current || 0} of ${status.total} questions` : 'Analyzing questions...';
            case 'crossFileUpload':
                return status.total > 0 ? `Uploading ${status.current || 0} of ${status.total} files to other modules` : 'Uploading files to other modules...';
            case 'otherModulesAI':
                return status.total > 0 ? `Filling answers ${status.current || 0} of ${status.total} questions` : 'Filling answers in other modules...';
            case 'researchAid':
                return 'Generating research reports...';
            case 'completed':
                return 'Auto-Fill Complete!';
            case 'error':
                return 'Auto-Fill Interrupted';
            case 'stale':
                return 'Process may have completed';
            default:
                return 'Auto-Fill';
        }
    };
    const getPhaseIcon = ()=>{
        switch(status.phase){
            case 'uploading':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7008da7e6d6ab9$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '20px'
                    }
                });
            case 'indexing':
            case 'processingFiles':
            case 'filling':
            case 'crossFileUpload':
            case 'otherModulesAI':
            case 'researchAid':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea4b29d6a58d8d93$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '20px'
                    },
                    className: "auto-fill-status-spin"
                });
            case 'allocated':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '20px',
                        color: '#4a67ff'
                    }
                });
            case 'completed':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '20px',
                        color: '#059669'
                    }
                });
            case 'error':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5c032c9e71e53e0$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '20px',
                        color: '#DC2626'
                    }
                });
            case 'stale':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '20px',
                        color: '#D97706'
                    }
                });
            default:
                return null;
        }
    };
    const getProgressPercent = ()=>{
        if (status.phase === 'uploading') {
            const p = status.uploadProgress || {};
            return p.percent ?? (p.total > 0 ? Math.round(p.current / p.total * 100) : 0);
        }
        if (status.phase === 'processingFiles') return status.total > 0 ? Math.round(status.current / status.total * 100) : 0;
        if (status.phase === 'filling') return status.total > 0 ? Math.round(status.current / status.total * 100) : 0;
        if (status.phase === 'crossFileUpload') return status.total > 0 ? Math.round(status.current / status.total * 100) : 0;
        if (status.phase === 'otherModulesAI') return status.total > 0 ? Math.round(status.current / status.total * 100) : 0;
        if (status.phase === 'completed') return 100;
        return 0;
    };
    const canClose = [
        'completed',
        'error',
        'stale'
    ].includes(status.phase);
    const canCancel = [
        'uploading',
        'indexing',
        'processingFiles',
        'filling',
        'crossFileUpload',
        'otherModulesAI',
        'researchAid'
    ].includes(status.phase);
    const handleExpand = async ()=>{
        if (status.phase !== 'allocated') return;
        if (!fileReport?.importResult) {
            const reportId = fileReport?._id || fileReport?.id;
            if (reportId && !fetchingReport) {
                setFetchingReport(true);
                const report = await fetchFileReport(reportId);
                setFetchingReport(false);
                if (report?.importResult) {
                    setStatus((s)=>({
                            ...s,
                            visible: false
                        }));
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'autoFillStepper',
                        autoFillStepperPhase: 'allocation',
                        from: '',
                        autoFillStatusBarVisible: false,
                        autoFillWithFilling: status.withFilling
                    }));
                    return;
                }
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Allocation data is not available. Please try again.');
            return;
        }
        setStatus((s)=>({
                ...s,
                visible: false
            }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'allocation',
            from: '',
            autoFillStatusBarVisible: false,
            autoFillWithFilling: status.withFilling
        }));
    };
    const canMaximize = [
        'uploading',
        'indexing',
        'processingFiles',
        'allocated',
        'filling',
        'crossFileUpload',
        'otherModulesAI',
        'researchAid',
        'completed'
    ].includes(status.phase);
    const handleMaximize = ()=>{
        switch(status.phase){
            case 'uploading':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'uploading',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling,
                    percent: status.uploadProgress?.percent || 0,
                    fileName: status.uploadProgress?.fileName || '',
                    totalFiles: status.uploadProgress?.total || 0,
                    filesUploaded: status.uploadProgress?.current || 0
                }));
                break;
            case 'indexing':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'indexing',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling
                }));
                break;
            case 'processingFiles':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'processing',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling
                }));
                break;
            case 'allocated':
                handleExpand();
                break;
            case 'filling':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'filling',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling,
                    autoFillCompleted: false,
                    autoFillTotal: status.total,
                    autoFillCurrent: status.current,
                    autoFillCurrentQuestion: status.currentQuestion,
                    autoFillQuestionText: status.questionText,
                    autoFillSectionNo: status.sectionNo,
                    autoFillSectionName: status.sectionName,
                    autoFillReadingFiles: status.readingFiles,
                    autoFillStartTime: status.startTime,
                    autoFillModuleName: status.moduleName
                }));
                break;
            case 'crossFileUpload':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'crossFileUpload',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling
                }));
                break;
            case 'otherModulesAI':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'otherModules',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling
                }));
                break;
            case 'researchAid':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'researchAid',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling
                }));
                break;
            case 'completed':
                setStatus((s)=>({
                        ...s,
                        visible: false
                    }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'autoFillStepper',
                    autoFillStepperPhase: 'result',
                    autoFillStatusBarVisible: false,
                    autoFillWithFilling: status.withFilling,
                    autoFillCompleted: true,
                    autoFillProcessed: status.processed,
                    autoFillAnswered: status.answered,
                    autoFillNeedsReview: status.needsReview,
                    autoFillSkipped: status.skipped,
                    autoFillModuleName: status.moduleName
                }));
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f9b9596425583678$exports))), {
        nodeRef: nodeRef,
        handle: ".auto-fill-drag-handle",
        bounds: "parent",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: nodeRef,
            className: "pf bg1 shadow",
            style: {
                zIndex: '10000',
                right: '10px',
                bottom: '80px',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '380px'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcsb w100 pl1rem auto-fill-drag-handle",
                    style: {
                        height: '60px',
                        borderBottom: isExpanded ? '1px solid #eaeaea' : 'none',
                        cursor: 'grab'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic",
                            style: {
                                gap: '8px',
                                flex: 1,
                                overflow: 'hidden'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fb6cdd207b8a1a5$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '18px',
                                        color: '#9CA3AF',
                                        flexShrink: 0
                                    }
                                }),
                                getPhaseIcon(),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c15 fs14px",
                                    style: {
                                        margin: 0,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    },
                                    children: getHeaderText()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcfe",
                            children: [
                                canMaximize && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "cp px0-5rem c15 df aic",
                                    onClick: handleMaximize,
                                    title: "Restore to full modal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z",
                                            fill: "#374151"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "cp px0-5rem c15 df aic",
                                    onClick: ()=>setIsExpanded(!isExpanded),
                                    style: {
                                        transition: 'transform 0.3s ease',
                                        transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e7dc83b503813b6$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100",
                    style: {
                        maxHeight: isExpanded ? '300px' : '0px',
                        overflowY: 'auto',
                        transition: 'max-height 0.3s ease, opacity 0.3s ease',
                        opacity: isExpanded ? 1 : 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            padding: '1rem'
                        },
                        children: [
                            status.moduleName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 fw600 fs12px",
                                style: {
                                    margin: '0 0 0.75rem',
                                    textAlign: 'center'
                                },
                                children: status.moduleName === 'repository' ? 'Data Repository' : status.moduleName.charAt(0).toUpperCase() + status.moduleName.slice(1)
                            }),
                            status.phase === 'uploading' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($980eb83ab9562f3a$var$ProgressBar, {
                                        percent: getProgressPercent()
                                    }),
                                    status.uploadProgress?.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c27 fs12px",
                                        style: $980eb83ab9562f3a$var$ellipsis,
                                        children: status.uploadProgress.fileName
                                    })
                                ]
                            }),
                            status.phase === 'indexing' && (()=>{
                                const idx = status.indexingProgress || {};
                                const alloc = status.allocationProgress || {};
                                // Allocation is the second pass of this phase — mirror the maximized view once indexing finishes
                                const showAllocation = alloc.total > 0 && (!idx.total || (idx.current || 0) >= idx.total);
                                if (showAllocation) {
                                    const pct = Math.round((alloc.current || 0) / alloc.total * 100);
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($980eb83ab9562f3a$var$ProgressBar, {
                                                percent: pct
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c15 fw500 fs12px",
                                                style: {
                                                    margin: '0 0 0.25rem',
                                                    textAlign: 'center'
                                                },
                                                children: [
                                                    pct,
                                                    "% complete"
                                                ]
                                            }),
                                            alloc.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c27 fs12px",
                                                style: $980eb83ab9562f3a$var$ellipsis,
                                                children: alloc.fileName
                                            })
                                        ]
                                    });
                                }
                                const pct = idx.total > 0 ? Math.round(idx.current / idx.total * 100) : 0;
                                return idx.total > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($980eb83ab9562f3a$var$ProgressBar, {
                                            percent: pct
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fw500 fs12px",
                                            style: {
                                                margin: '0 0 0.25rem',
                                                textAlign: 'center'
                                            },
                                            children: [
                                                pct,
                                                "% complete"
                                            ]
                                        }),
                                        idx.currentFile && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c27 fs12px",
                                            style: $980eb83ab9562f3a$var$ellipsis,
                                            children: idx.currentFile
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("progress", {
                                            color: "green",
                                            style: {
                                                border: 'none',
                                                width: '90%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c27 fs12px",
                                            style: {
                                                margin: '0.5rem 0 0'
                                            },
                                            children: "Processing and indexing your files..."
                                        })
                                    ]
                                });
                            })(),
                            status.phase === 'processingFiles' && (()=>{
                                const pct = getProgressPercent();
                                return status.total > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($980eb83ab9562f3a$var$ProgressBar, {
                                            percent: pct
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fw500 fs12px",
                                            style: {
                                                margin: '0 0 0.25rem',
                                                textAlign: 'center'
                                            },
                                            children: [
                                                pct,
                                                "% complete"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c27 fs12px",
                                            style: {
                                                margin: 0,
                                                textAlign: 'center'
                                            },
                                            children: "Updating and indexing files..."
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("progress", {
                                            color: "green",
                                            style: {
                                                border: 'none',
                                                width: '90%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c27 fs12px",
                                            style: {
                                                margin: '0.5rem 0 0'
                                            },
                                            children: "Updating and indexing files..."
                                        })
                                    ]
                                });
                            })(),
                            status.phase === 'allocated' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    textAlign: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c15 fw500 fs12px",
                                        style: {
                                            margin: '0 0 0.75rem'
                                        },
                                        children: "Files have been allocated to sections."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: handleExpand,
                                        disabled: fetchingReport,
                                        className: "bg3 bg4-hover c1 br10px px2rem py0-5rem cp fw500 fs12px",
                                        children: fetchingReport ? 'Loading...' : 'Review Allocation'
                                    })
                                ]
                            }),
                            status.phase === 'filling' && (()=>{
                                const eta = status.startTime && status.current > 0 && status.total > 0 ? (()=>{
                                    const remaining = (Date.now() - status.startTime) / status.current * (status.total - status.current);
                                    return remaining > 60000 ? `~${Math.ceil(remaining / 60000)} min remaining` : `~${Math.ceil(remaining / 1000)} sec remaining`;
                                })() : null;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($980eb83ab9562f3a$var$ProgressBar, {
                                            percent: getProgressPercent()
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fw500 fs12px",
                                            style: {
                                                margin: '0 0 0.25rem',
                                                textAlign: 'center'
                                            },
                                            children: status.total > 0 ? `${getProgressPercent()}% complete` : 'Analyzing questions...'
                                        }),
                                        status.sectionName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c27 fs11px",
                                            style: $980eb83ab9562f3a$var$ellipsis,
                                            children: status.sectionNo ? `${status.sectionNo} - ${status.sectionName}` : status.sectionName
                                        }),
                                        status.questionText && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs11px",
                                            style: {
                                                ...$980eb83ab9562f3a$var$ellipsis,
                                                margin: '0.25rem 0'
                                            },
                                            children: status.questionText
                                        }),
                                        status.readingFiles?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c27 fs11px",
                                            style: $980eb83ab9562f3a$var$ellipsis,
                                            children: [
                                                "Reading: ",
                                                status.readingFiles[0]
                                            ]
                                        }),
                                        eta && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c27 fs11px",
                                            style: {
                                                margin: '0.25rem 0 0',
                                                textAlign: 'center'
                                            },
                                            children: eta
                                        })
                                    ]
                                });
                            })(),
                            status.phase === 'completed' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: $980eb83ab9562f3a$var$statBox('#F3F4F6'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '1.25rem',
                                                    fontWeight: '700',
                                                    color: '#1F2937'
                                                },
                                                children: status.processed || 0
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '0.65rem',
                                                    color: '#6B7280'
                                                },
                                                children: "Processed"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: $980eb83ab9562f3a$var$statBox('#D1FAE5'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '1.25rem',
                                                    fontWeight: '700',
                                                    color: '#059669'
                                                },
                                                children: status.answered || 0
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '0.65rem',
                                                    color: '#059669'
                                                },
                                                children: "Answered"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: $980eb83ab9562f3a$var$statBox('#FEF3C7'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '1.25rem',
                                                    fontWeight: '700',
                                                    color: '#D97706'
                                                },
                                                children: status.needsReview || 0
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '0.65rem',
                                                    color: '#D97706'
                                                },
                                                children: "Needs Review"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: $980eb83ab9562f3a$var$statBox('#F3F4F6'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '1.25rem',
                                                    fontWeight: '700',
                                                    color: '#6B7280'
                                                },
                                                children: status.skipped || 0
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: '0.65rem',
                                                    color: '#6B7280'
                                                },
                                                children: "Skipped"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            status.phase === 'crossFileUpload' && (()=>{
                                const pct = getProgressPercent();
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($980eb83ab9562f3a$var$ProgressBar, {
                                            percent: pct
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fw500 fs12px",
                                            style: {
                                                margin: '0 0 0.25rem',
                                                textAlign: 'center'
                                            },
                                            children: status.total > 0 ? `${pct}% complete` : 'Uploading files to modules...'
                                        }),
                                        status.crossFileModuleType && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c27 fs11px",
                                            style: $980eb83ab9562f3a$var$ellipsis,
                                            children: [
                                                "Module: ",
                                                status.crossFileModuleType
                                            ]
                                        })
                                    ]
                                });
                            })(),
                            status.phase === 'otherModulesAI' && (()=>{
                                const pct = getProgressPercent();
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($980eb83ab9562f3a$var$ProgressBar, {
                                            percent: pct
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fw500 fs12px",
                                            style: {
                                                margin: '0 0 0.25rem',
                                                textAlign: 'center'
                                            },
                                            children: status.total > 0 ? `${pct}% complete` : 'AI filling questions...'
                                        }),
                                        status.otherModuleType && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c27 fs11px",
                                            style: $980eb83ab9562f3a$var$ellipsis,
                                            children: [
                                                "Module: ",
                                                status.otherModuleType
                                            ]
                                        }),
                                        status.questionText && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs11px",
                                            style: {
                                                ...$980eb83ab9562f3a$var$ellipsis,
                                                margin: '0.25rem 0'
                                            },
                                            children: status.questionText
                                        }),
                                        status.readingFiles?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c27 fs11px",
                                            style: $980eb83ab9562f3a$var$ellipsis,
                                            children: [
                                                "Reading: ",
                                                status.readingFiles[0]
                                            ]
                                        })
                                    ]
                                });
                            })(),
                            status.phase === 'error' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    textAlign: 'center'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: {
                                            color: '#DC2626',
                                            fontSize: '0.85rem',
                                            margin: '0 0 0.35rem'
                                        },
                                        children: status.error || 'Something went wrong.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c27 fs12px",
                                        style: {
                                            margin: 0
                                        },
                                        children: "Don't worry \u2014 your progress is saved. Click Resume to continue from where it stopped or continue from Filing Assistant History."
                                    })
                                ]
                            }),
                            status.phase === 'stale' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c27 fs12px",
                                style: {
                                    textAlign: 'center',
                                    margin: 0
                                },
                                children: "The page was refreshed. Check your module for updates \u2014 if the run was interrupted, click Resume to continue it."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic jcc",
                                style: {
                                    gap: '0.75rem',
                                    marginTop: '0.75rem'
                                },
                                children: [
                                    canCancel && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: handleCancel,
                                        style: {
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#DC2626',
                                            fontSize: '12px',
                                            textDecoration: 'underline',
                                            padding: 0
                                        },
                                        children: "Cancel"
                                    }),
                                    [
                                        'error',
                                        'stale'
                                    ].includes(status.phase) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: handleResumeRun,
                                            style: {
                                                background: '#4A67FF',
                                                border: 'none',
                                                cursor: 'pointer',
                                                color: '#fff',
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                borderRadius: '50px',
                                                padding: '0.45rem 1.4rem',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                lineHeight: 1
                                            },
                                            children: "\u25B6\xa0Resume"
                                        })
                                    }),
                                    canClose && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: handleClose,
                                        style: {
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#6B7280',
                                            fontSize: '12px',
                                            textDecoration: 'underline',
                                            padding: 0
                                        },
                                        children: "Close"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $980eb83ab9562f3a$export$2e2bcd8739ae039 = $980eb83ab9562f3a$var$AutoFillStatusBar;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $dd7dfe5a585e9490$var$barBg = {
    background: '#E5E7EB',
    borderRadius: '10px',
    height: '8px',
    overflow: 'hidden',
    marginBottom: '0.75rem'
};
const $dd7dfe5a585e9490$var$barFill = (w)=>({
        background: 'linear-gradient(90deg, #4a67ff 0%, #3d56d9 100%)',
        height: '100%',
        borderRadius: '10px',
        width: `${w}%`,
        transition: 'width 0.3s ease'
    });
const $dd7dfe5a585e9490$var$ellipsis = {
    margin: 0,
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
// Minimized Auditor (diagnose) status pill — same visual pattern as AutoFillStatusBar but scoped to a single flow,
// since diagnose only has two states (running / completed) rather than autofill's many sequential phases
const $dd7dfe5a585e9490$var$DiagnoseStatusBar = ()=>{
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(true);
    const nodeRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [status, setStatus] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        correct: 0,
        incorrect: 0,
        qNo: '',
        questionText: ''
    });
    const visible = !!modal.diagnoseStatusBarVisible;
    const completed = !!modal.diagnoseStatusBarCompleted;
    (0, $acw62.useEffect)(()=>{
        const companyId = modal.diagnoseCompanyId;
        const onProgress = (data)=>{
            if (data.companyId === companyId) setStatus((s)=>({
                    ...s,
                    total: data.total || 0,
                    current: data.current || 0,
                    correct: data.correct || 0,
                    incorrect: data.incorrect || 0
                }));
        };
        const onReading = (data)=>{
            if (data.companyId === companyId) setStatus((s)=>({
                    ...s,
                    qNo: data.qNo || '',
                    questionText: data.questionText || ''
                }));
        };
        const onCompleted = (data)=>{
            if (data.companyId && data.companyId !== companyId) return;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                diagnoseStatusBarCompleted: true
            }));
        };
        const onCancelled = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                diagnoseStatusBarVisible: false,
                diagnoseStatusBarCompleted: false
            }));
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('diagnose:progress', onProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('diagnose:reading', onReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('diagnose:completed', onCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('diagnose:cancelled', onCancelled);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('diagnose:progress', onProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('diagnose:reading', onReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('diagnose:completed', onCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('diagnose:cancelled', onCancelled);
        };
    }, [
        modal.diagnoseCompanyId,
        dispatch
    ]);
    if (!visible || modal.open === 'diagnoseReport') return null;
    const pct = status.total > 0 ? Math.round(status.current / status.total * 100) : 0;
    const handleCancel = async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            diagnoseCancelled: true
        }));
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/diagnose/cancel', {}).catch(()=>{});
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            diagnoseLoading: false,
            diagnoseStatusBarVisible: false,
            diagnoseStatusBarCompleted: false
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auditor cancelled');
    };
    const handleReview = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'diagnoseReport',
            diagnoseStatusBarVisible: false,
            diagnoseStatusBarCompleted: false
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f9b9596425583678$exports))), {
        nodeRef: nodeRef,
        handle: ".diagnose-drag-handle",
        bounds: "parent",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: nodeRef,
            className: "pf bg1 shadow",
            style: {
                zIndex: '10000',
                right: '10px',
                bottom: '80px',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '340px'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcsb w100 pl1rem diagnose-drag-handle",
                    style: {
                        height: '60px',
                        borderBottom: isExpanded ? '1px solid #eaeaea' : 'none',
                        cursor: 'grab'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic",
                            style: {
                                gap: '8px',
                                flex: 1,
                                overflow: 'hidden'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fb6cdd207b8a1a5$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '18px',
                                        color: '#9CA3AF',
                                        flexShrink: 0
                                    }
                                }),
                                completed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '20px',
                                        color: '#059669'
                                    }
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea4b29d6a58d8d93$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '20px'
                                    },
                                    className: "auto-fill-status-spin"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c15 fs14px",
                                    style: {
                                        margin: 0,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    },
                                    children: completed ? 'Auditor completed' : status.total > 0 ? `Verifying ${status.current} of ${status.total} answers` : 'Auditor verifying answers'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcfe",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "cp px0-5rem c15 df aic",
                                    onClick: handleReview,
                                    title: completed ? 'Review results' : 'Restore to full modal',
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z",
                                            fill: "#374151"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "cp px0-5rem c15 df aic",
                                    onClick: ()=>setIsExpanded(!isExpanded),
                                    style: {
                                        transition: 'transform 0.3s ease',
                                        transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e7dc83b503813b6$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100",
                    style: {
                        maxHeight: isExpanded ? '220px' : '0px',
                        overflowY: 'auto',
                        transition: 'max-height 0.3s ease, opacity 0.3s ease',
                        opacity: isExpanded ? 1 : 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '1rem'
                        },
                        children: completed ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15 fw500 fs12px",
                                    style: {
                                        margin: '0 0 0.75rem'
                                    },
                                    children: status.total > 0 ? `${status.correct} correct \xb7 ${status.incorrect} need review` : 'Report ready to review.'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: handleReview,
                                    className: "bg3 bg4-hover c1 br10px px2rem py0-5rem cp fw500 fs12px",
                                    children: "Click to Review"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($dd7dfe5a585e9490$var$ProgressBar, {
                                    percent: pct
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15 fw500 fs12px",
                                    style: {
                                        margin: '0 0 0.25rem',
                                        textAlign: 'center'
                                    },
                                    children: status.total > 0 ? `${pct}% complete` : "Starting up\u2026"
                                }),
                                status.qNo && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "c27 fs11px",
                                    style: $dd7dfe5a585e9490$var$ellipsis,
                                    children: [
                                        "Checking: ",
                                        status.qNo
                                    ]
                                }),
                                status.questionText && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "c15 fs11px",
                                    style: {
                                        ...$dd7dfe5a585e9490$var$ellipsis,
                                        margin: '0.25rem 0'
                                    },
                                    children: [
                                        '"',
                                        status.questionText,
                                        '"'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcc",
                                    style: {
                                        marginTop: '0.75rem'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: handleCancel,
                                        style: {
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#DC2626',
                                            fontSize: '12px',
                                            textDecoration: 'underline',
                                            padding: 0
                                        },
                                        children: "Cancel"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
const $dd7dfe5a585e9490$var$ProgressBar = ({ percent: percent })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $dd7dfe5a585e9490$var$barBg,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: $dd7dfe5a585e9490$var$barFill(percent)
        })
    });
var $dd7dfe5a585e9490$export$2e2bcd8739ae039 = $dd7dfe5a585e9490$var$DiagnoseStatusBar;




var $ayMG0 = parcelRequire("ayMG0");







var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $d2a81c6b9c235e40$var$extendStatics = function(d, b) {
    $d2a81c6b9c235e40$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d2a81c6b9c235e40$var$extendStatics(d, b);
};
function $d2a81c6b9c235e40$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d2a81c6b9c235e40$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d2a81c6b9c235e40$export$18ce0697a983be9b = function() {
    $d2a81c6b9c235e40$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d2a81c6b9c235e40$export$18ce0697a983be9b.apply(this, arguments);
};
function $d2a81c6b9c235e40$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d2a81c6b9c235e40$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d2a81c6b9c235e40$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d2a81c6b9c235e40$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d2a81c6b9c235e40$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d2a81c6b9c235e40$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d2a81c6b9c235e40$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d2a81c6b9c235e40$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d2a81c6b9c235e40$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d2a81c6b9c235e40$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d2a81c6b9c235e40$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d2a81c6b9c235e40$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d2a81c6b9c235e40$export$45d3717a4c69092e(o, m, p);
}
function $d2a81c6b9c235e40$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d2a81c6b9c235e40$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d2a81c6b9c235e40$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d2a81c6b9c235e40$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d2a81c6b9c235e40$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d2a81c6b9c235e40$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d2a81c6b9c235e40$export$10c90e4f7922046c(v) {
    return this instanceof $d2a81c6b9c235e40$export$10c90e4f7922046c ? (this.v = v, this) : new $d2a81c6b9c235e40$export$10c90e4f7922046c(v);
}
function $d2a81c6b9c235e40$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d2a81c6b9c235e40$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d2a81c6b9c235e40$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d2a81c6b9c235e40$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d2a81c6b9c235e40$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d2a81c6b9c235e40$export$19a8beecd37a4c45 === "function" ? $d2a81c6b9c235e40$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d2a81c6b9c235e40$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d2a81c6b9c235e40$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $d2a81c6b9c235e40$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d2a81c6b9c235e40$export$45d3717a4c69092e(result, mod, k);
    }
    $d2a81c6b9c235e40$var$__setModuleDefault(result, mod);
    return result;
}
function $d2a81c6b9c235e40$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d2a81c6b9c235e40$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d2a81c6b9c235e40$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d2a81c6b9c235e40$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d2a81c6b9c235e40$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d2a81c6b9c235e40$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d2a81c6b9c235e40$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d2a81c6b9c235e40$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $d2a81c6b9c235e40$export$2e2bcd8739ae039 = {
    __extends: $d2a81c6b9c235e40$export$a8ba968b8961cb8a,
    __assign: $d2a81c6b9c235e40$export$18ce0697a983be9b,
    __rest: $d2a81c6b9c235e40$export$3c9a16f847548506,
    __decorate: $d2a81c6b9c235e40$export$29e00dfd3077644b,
    __param: $d2a81c6b9c235e40$export$d5ad3fd78186038f,
    __metadata: $d2a81c6b9c235e40$export$f1db080c865becb9,
    __awaiter: $d2a81c6b9c235e40$export$1050f835b63b671e,
    __generator: $d2a81c6b9c235e40$export$67ebef60e6f28a6,
    __createBinding: $d2a81c6b9c235e40$export$45d3717a4c69092e,
    __exportStar: $d2a81c6b9c235e40$export$f33643c0debef087,
    __values: $d2a81c6b9c235e40$export$19a8beecd37a4c45,
    __read: $d2a81c6b9c235e40$export$8d051b38c9118094,
    __spread: $d2a81c6b9c235e40$export$afc72e2116322959,
    __spreadArrays: $d2a81c6b9c235e40$export$6388937ca91ccae8,
    __spreadArray: $d2a81c6b9c235e40$export$1216008129fb82ed,
    __await: $d2a81c6b9c235e40$export$10c90e4f7922046c,
    __asyncGenerator: $d2a81c6b9c235e40$export$e427f37a30a4de9b,
    __asyncDelegator: $d2a81c6b9c235e40$export$bbd80228419bb833,
    __asyncValues: $d2a81c6b9c235e40$export$e3b29a3d6162315f,
    __makeTemplateObject: $d2a81c6b9c235e40$export$4fb47efe1390b86f,
    __importStar: $d2a81c6b9c235e40$export$c21735bcef00d192,
    __importDefault: $d2a81c6b9c235e40$export$da59b14a69baef04,
    __classPrivateFieldGet: $d2a81c6b9c235e40$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d2a81c6b9c235e40$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d2a81c6b9c235e40$export$81fdc39f203e4e04,
    __addDisposableResource: $d2a81c6b9c235e40$export$88ac25d8e944e405,
    __disposeResources: $d2a81c6b9c235e40$export$8f076105dc360e92
};


function $1ba09b777c2309a8$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $4a3f4fcffc4e4ba8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $4a3f4fcffc4e4ba8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $1ba09b777c2309a8$export$2e2bcd8739ae039)(function(prop) {
    return $4a3f4fcffc4e4ba8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 = "-ms-";
var $6f58f4f5a2b864a8$export$2c0f367103c8d01c = "-moz-";
var $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 = "-webkit-";
var $6f58f4f5a2b864a8$export$a29989082612d0d9 = "comm";
var $6f58f4f5a2b864a8$export$aa3a2e812ca8570d = "rule";
var $6f58f4f5a2b864a8$export$527d108ccf083c2b = "decl";
var $6f58f4f5a2b864a8$export$d3d35020fa5b54f0 = "@page";
var $6f58f4f5a2b864a8$export$500415a86c544f73 = "@media";
var $6f58f4f5a2b864a8$export$a763edbf796b780a = "@import";
var $6f58f4f5a2b864a8$export$2790aeb8b4e5c826 = "@charset";
var $6f58f4f5a2b864a8$export$1cc683e23b84b133 = "@viewport";
var $6f58f4f5a2b864a8$export$9447a5efea57e862 = "@supports";
var $6f58f4f5a2b864a8$export$ef011b4e114b1fba = "@document";
var $6f58f4f5a2b864a8$export$6aad947bda0f3f46 = "@namespace";
var $6f58f4f5a2b864a8$export$b44a8529a35fcb60 = "@keyframes";
var $6f58f4f5a2b864a8$export$2c16de31893252e6 = "@font-face";
var $6f58f4f5a2b864a8$export$3d846dd52e150c6f = "@counter-style";
var $6f58f4f5a2b864a8$export$22314bfbb57653fe = "@font-feature-values";
var $6f58f4f5a2b864a8$export$d773506282b3cfe6 = "@layer";
var $6f58f4f5a2b864a8$export$1c5a554c78c0cd12 = "@scope";
var $6f58f4f5a2b864a8$export$2335f513bbd82c6d = Math.abs;
var $6f58f4f5a2b864a8$export$6788812c4e6611e6 = String.fromCharCode;
var $6f58f4f5a2b864a8$export$e6e34fd1f2686227 = Object.assign;
function $6f58f4f5a2b864a8$export$d6af199866bfb566(e, r) {
    return $6f58f4f5a2b864a8$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $6f58f4f5a2b864a8$export$a9db5e087081082d(e, 0)) << 2 ^ $6f58f4f5a2b864a8$export$a9db5e087081082d(e, 1)) << 2 ^ $6f58f4f5a2b864a8$export$a9db5e087081082d(e, 2)) << 2 ^ $6f58f4f5a2b864a8$export$a9db5e087081082d(e, 3) : 0;
}
function $6f58f4f5a2b864a8$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $6f58f4f5a2b864a8$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $6f58f4f5a2b864a8$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $6f58f4f5a2b864a8$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $6f58f4f5a2b864a8$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $6f58f4f5a2b864a8$export$36776f635604f274(e) {
    return e.length;
}
function $6f58f4f5a2b864a8$export$f9084667e487ed46(e) {
    return e.length;
}
function $6f58f4f5a2b864a8$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $6f58f4f5a2b864a8$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $6f58f4f5a2b864a8$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$6f58f4f5a2b864a8$export$4659b591c19bdf3d(e, r);
    });
}
var $6f58f4f5a2b864a8$export$53f1d5ea8de3d7c = 1;
var $6f58f4f5a2b864a8$export$4e0c71f277ca26b3 = 1;
var $6f58f4f5a2b864a8$export$f24224f1c91d8156 = 0;
var $6f58f4f5a2b864a8$export$5880b8b5730aff45 = 0;
var $6f58f4f5a2b864a8$export$c0306caf338ac095 = 0;
var $6f58f4f5a2b864a8$export$30a86d91af8ff6e6 = "";
function $6f58f4f5a2b864a8$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $6f58f4f5a2b864a8$export$53f1d5ea8de3d7c,
        column: $6f58f4f5a2b864a8$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $6f58f4f5a2b864a8$export$784d13d8ee351f07(e, r) {
    return $6f58f4f5a2b864a8$export$e6e34fd1f2686227($6f58f4f5a2b864a8$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $6f58f4f5a2b864a8$export$590e8b2c435046d9(e) {
    while(e.root)e = $6f58f4f5a2b864a8$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $6f58f4f5a2b864a8$export$10d8903dec122b9d(e, e.siblings);
}
function $6f58f4f5a2b864a8$export$eba6f6f03b0a92e7() {
    return $6f58f4f5a2b864a8$export$c0306caf338ac095;
}
function $6f58f4f5a2b864a8$export$232faf9add678146() {
    $6f58f4f5a2b864a8$export$c0306caf338ac095 = $6f58f4f5a2b864a8$export$5880b8b5730aff45 > 0 ? $6f58f4f5a2b864a8$export$a9db5e087081082d($6f58f4f5a2b864a8$export$30a86d91af8ff6e6, --$6f58f4f5a2b864a8$export$5880b8b5730aff45) : 0;
    if ($6f58f4f5a2b864a8$export$4e0c71f277ca26b3--, $6f58f4f5a2b864a8$export$c0306caf338ac095 === 10) $6f58f4f5a2b864a8$export$4e0c71f277ca26b3 = 1, $6f58f4f5a2b864a8$export$53f1d5ea8de3d7c--;
    return $6f58f4f5a2b864a8$export$c0306caf338ac095;
}
function $6f58f4f5a2b864a8$export$48cfd1e771a65c4f() {
    $6f58f4f5a2b864a8$export$c0306caf338ac095 = $6f58f4f5a2b864a8$export$5880b8b5730aff45 < $6f58f4f5a2b864a8$export$f24224f1c91d8156 ? $6f58f4f5a2b864a8$export$a9db5e087081082d($6f58f4f5a2b864a8$export$30a86d91af8ff6e6, $6f58f4f5a2b864a8$export$5880b8b5730aff45++) : 0;
    if ($6f58f4f5a2b864a8$export$4e0c71f277ca26b3++, $6f58f4f5a2b864a8$export$c0306caf338ac095 === 10) $6f58f4f5a2b864a8$export$4e0c71f277ca26b3 = 1, $6f58f4f5a2b864a8$export$53f1d5ea8de3d7c++;
    return $6f58f4f5a2b864a8$export$c0306caf338ac095;
}
function $6f58f4f5a2b864a8$export$4d3fb11e950abb9e() {
    return $6f58f4f5a2b864a8$export$a9db5e087081082d($6f58f4f5a2b864a8$export$30a86d91af8ff6e6, $6f58f4f5a2b864a8$export$5880b8b5730aff45);
}
function $6f58f4f5a2b864a8$export$e88cb2efb12ae807() {
    return $6f58f4f5a2b864a8$export$5880b8b5730aff45;
}
function $6f58f4f5a2b864a8$export$58adb3bec8346d0f(e, r) {
    return $6f58f4f5a2b864a8$export$2f35ab04d2335697($6f58f4f5a2b864a8$export$30a86d91af8ff6e6, e, r);
}
function $6f58f4f5a2b864a8$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $6f58f4f5a2b864a8$export$2de70f21292aac9e(e) {
    return $6f58f4f5a2b864a8$export$53f1d5ea8de3d7c = $6f58f4f5a2b864a8$export$4e0c71f277ca26b3 = 1, $6f58f4f5a2b864a8$export$f24224f1c91d8156 = $6f58f4f5a2b864a8$export$36776f635604f274($6f58f4f5a2b864a8$export$30a86d91af8ff6e6 = e), $6f58f4f5a2b864a8$export$5880b8b5730aff45 = 0, [];
}
function $6f58f4f5a2b864a8$export$45918ac1574455b1(e) {
    return $6f58f4f5a2b864a8$export$30a86d91af8ff6e6 = "", e;
}
function $6f58f4f5a2b864a8$export$410ac95b9ec204b8(e) {
    return $6f58f4f5a2b864a8$export$87c2784dc9fc4ab($6f58f4f5a2b864a8$export$58adb3bec8346d0f($6f58f4f5a2b864a8$export$5880b8b5730aff45 - 1, $6f58f4f5a2b864a8$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $6f58f4f5a2b864a8$export$660b2ee2d4fb4eff(e) {
    return $6f58f4f5a2b864a8$export$45918ac1574455b1($6f58f4f5a2b864a8$export$5f8c09e3ae6f64e1($6f58f4f5a2b864a8$export$2de70f21292aac9e(e)));
}
function $6f58f4f5a2b864a8$export$7af1228ff777d175(e) {
    while($6f58f4f5a2b864a8$export$c0306caf338ac095 = $6f58f4f5a2b864a8$export$4d3fb11e950abb9e())if ($6f58f4f5a2b864a8$export$c0306caf338ac095 < 33) $6f58f4f5a2b864a8$export$48cfd1e771a65c4f();
    else break;
    return $6f58f4f5a2b864a8$export$9e1725a4cfeada27(e) > 2 || $6f58f4f5a2b864a8$export$9e1725a4cfeada27($6f58f4f5a2b864a8$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $6f58f4f5a2b864a8$export$5f8c09e3ae6f64e1(e) {
    while($6f58f4f5a2b864a8$export$48cfd1e771a65c4f())switch($6f58f4f5a2b864a8$export$9e1725a4cfeada27($6f58f4f5a2b864a8$export$c0306caf338ac095)){
        case 0:
            $6f58f4f5a2b864a8$export$10d8903dec122b9d($6f58f4f5a2b864a8$export$c2ab62c7bf24634($6f58f4f5a2b864a8$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $6f58f4f5a2b864a8$export$10d8903dec122b9d($6f58f4f5a2b864a8$export$410ac95b9ec204b8($6f58f4f5a2b864a8$export$c0306caf338ac095), e);
            break;
        default:
            $6f58f4f5a2b864a8$export$10d8903dec122b9d($6f58f4f5a2b864a8$export$6788812c4e6611e6($6f58f4f5a2b864a8$export$c0306caf338ac095), e);
    }
    return e;
}
function $6f58f4f5a2b864a8$export$955ba06d119e085e(e, r) {
    while(--r && $6f58f4f5a2b864a8$export$48cfd1e771a65c4f())if ($6f58f4f5a2b864a8$export$c0306caf338ac095 < 48 || $6f58f4f5a2b864a8$export$c0306caf338ac095 > 102 || $6f58f4f5a2b864a8$export$c0306caf338ac095 > 57 && $6f58f4f5a2b864a8$export$c0306caf338ac095 < 65 || $6f58f4f5a2b864a8$export$c0306caf338ac095 > 70 && $6f58f4f5a2b864a8$export$c0306caf338ac095 < 97) break;
    return $6f58f4f5a2b864a8$export$58adb3bec8346d0f(e, $6f58f4f5a2b864a8$export$e88cb2efb12ae807() + (r < 6 && $6f58f4f5a2b864a8$export$4d3fb11e950abb9e() == 32 && $6f58f4f5a2b864a8$export$48cfd1e771a65c4f() == 32));
}
function $6f58f4f5a2b864a8$export$c889f2fcc19dbf12(e) {
    while($6f58f4f5a2b864a8$export$48cfd1e771a65c4f())switch($6f58f4f5a2b864a8$export$c0306caf338ac095){
        case e:
            return $6f58f4f5a2b864a8$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $6f58f4f5a2b864a8$export$c889f2fcc19dbf12($6f58f4f5a2b864a8$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $6f58f4f5a2b864a8$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $6f58f4f5a2b864a8$export$48cfd1e771a65c4f();
            break;
    }
    return $6f58f4f5a2b864a8$export$5880b8b5730aff45;
}
function $6f58f4f5a2b864a8$export$4254d4e2b3745c4c(e, r) {
    while($6f58f4f5a2b864a8$export$48cfd1e771a65c4f())if (e + $6f58f4f5a2b864a8$export$c0306caf338ac095 === 57) break;
    else if (e + $6f58f4f5a2b864a8$export$c0306caf338ac095 === 84 && $6f58f4f5a2b864a8$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $6f58f4f5a2b864a8$export$58adb3bec8346d0f(r, $6f58f4f5a2b864a8$export$5880b8b5730aff45 - 1) + "*" + $6f58f4f5a2b864a8$export$6788812c4e6611e6(e === 47 ? e : $6f58f4f5a2b864a8$export$48cfd1e771a65c4f());
}
function $6f58f4f5a2b864a8$export$c2ab62c7bf24634(e) {
    while(!$6f58f4f5a2b864a8$export$9e1725a4cfeada27($6f58f4f5a2b864a8$export$4d3fb11e950abb9e()))$6f58f4f5a2b864a8$export$48cfd1e771a65c4f();
    return $6f58f4f5a2b864a8$export$58adb3bec8346d0f(e, $6f58f4f5a2b864a8$export$5880b8b5730aff45);
}
function $6f58f4f5a2b864a8$export$ef7acd7185315e22(e) {
    return $6f58f4f5a2b864a8$export$45918ac1574455b1($6f58f4f5a2b864a8$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $6f58f4f5a2b864a8$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $6f58f4f5a2b864a8$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $6f58f4f5a2b864a8$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $6f58f4f5a2b864a8$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($6f58f4f5a2b864a8$export$f8e21b1e77979a08(z += $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed($6f58f4f5a2b864a8$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $6f58f4f5a2b864a8$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $6f58f4f5a2b864a8$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $6f58f4f5a2b864a8$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $6f58f4f5a2b864a8$export$955ba06d119e085e($6f58f4f5a2b864a8$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($6f58f4f5a2b864a8$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $6f58f4f5a2b864a8$export$10d8903dec122b9d($6f58f4f5a2b864a8$export$4a34f930e789283c($6f58f4f5a2b864a8$export$4254d4e2b3745c4c($6f58f4f5a2b864a8$export$48cfd1e771a65c4f(), $6f58f4f5a2b864a8$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $6f58f4f5a2b864a8$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $6f58f4f5a2b864a8$export$36776f635604f274(z) - l) $6f58f4f5a2b864a8$export$10d8903dec122b9d(p > 32 ? $6f58f4f5a2b864a8$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $6f58f4f5a2b864a8$export$f8483753829ec8f3($6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $6f58f4f5a2b864a8$export$10d8903dec122b9d(j = $6f58f4f5a2b864a8$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $6f58f4f5a2b864a8$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $6f58f4f5a2b864a8$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $6f58f4f5a2b864a8$export$98e6a39c04603d36(e, j, j, n && $6f58f4f5a2b864a8$export$10d8903dec122b9d($6f58f4f5a2b864a8$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $6f58f4f5a2b864a8$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $6f58f4f5a2b864a8$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $6f58f4f5a2b864a8$export$232faf9add678146() == 125) continue;
            }
            switch(z += $6f58f4f5a2b864a8$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($6f58f4f5a2b864a8$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($6f58f4f5a2b864a8$export$4d3fb11e950abb9e() === 45) z += $6f58f4f5a2b864a8$export$410ac95b9ec204b8($6f58f4f5a2b864a8$export$48cfd1e771a65c4f());
                    v = $6f58f4f5a2b864a8$export$4d3fb11e950abb9e(), o = l = $6f58f4f5a2b864a8$export$36776f635604f274(k = z += $6f58f4f5a2b864a8$export$c2ab62c7bf24634($6f58f4f5a2b864a8$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $6f58f4f5a2b864a8$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $6f58f4f5a2b864a8$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $6f58f4f5a2b864a8$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $6f58f4f5a2b864a8$export$2f35ab04d2335697(e, p + 1, p = $6f58f4f5a2b864a8$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $6f58f4f5a2b864a8$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $6f58f4f5a2b864a8$export$35059013cd4a06db(e, r, a, s === 0 ? $6f58f4f5a2b864a8$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $6f58f4f5a2b864a8$export$4a34f930e789283c(e, r, a, c) {
    return $6f58f4f5a2b864a8$export$35059013cd4a06db(e, r, a, $6f58f4f5a2b864a8$export$a29989082612d0d9, $6f58f4f5a2b864a8$export$6788812c4e6611e6($6f58f4f5a2b864a8$export$eba6f6f03b0a92e7()), $6f58f4f5a2b864a8$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $6f58f4f5a2b864a8$export$f8483753829ec8f3(e, r, a, n, c) {
    return $6f58f4f5a2b864a8$export$35059013cd4a06db(e, r, a, $6f58f4f5a2b864a8$export$527d108ccf083c2b, $6f58f4f5a2b864a8$export$2f35ab04d2335697(e, 0, n), $6f58f4f5a2b864a8$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $6f58f4f5a2b864a8$export$82e9f45cca5ba907(n, c, s) {
    switch($6f58f4f5a2b864a8$export$d6af199866bfb566(n, c)){
        case 5103:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $6f58f4f5a2b864a8$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$2c0f367103c8d01c + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($6f58f4f5a2b864a8$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "box-$1$2" + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "flex-item-" + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$6f58f4f5a2b864a8$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "grid-row-" + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "flex-line-pack" + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "box-" + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "-grow", "") + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed($6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed($6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed($6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "box-pack:$3" + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$6f58f4f5a2b864a8$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "grid-column-align" + $6f58f4f5a2b864a8$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $6f58f4f5a2b864a8$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$6f58f4f5a2b864a8$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$6f58f4f5a2b864a8$export$f8e21b1e77979a08(s, "span", 0) ? $6f58f4f5a2b864a8$export$4659b591c19bdf3d(s, /\d+/) : +$6f58f4f5a2b864a8$export$4659b591c19bdf3d(s, /\d+/) - +$6f58f4f5a2b864a8$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $6f58f4f5a2b864a8$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed($6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($6f58f4f5a2b864a8$export$36776f635604f274(n) - 1 - c > 6) switch($6f58f4f5a2b864a8$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($6f58f4f5a2b864a8$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $6f58f4f5a2b864a8$export$2c0f367103c8d01c + ($6f58f4f5a2b864a8$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$6f58f4f5a2b864a8$export$f8e21b1e77979a08(n, "stretch", 0) ? $6f58f4f5a2b864a8$export$82e9f45cca5ba907($6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($6f58f4f5a2b864a8$export$a9db5e087081082d(n, c + 6) === 121) return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, ":", ":" + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($6f58f4f5a2b864a8$export$a9db5e087081082d(n, $6f58f4f5a2b864a8$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + ($6f58f4f5a2b864a8$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, ":", ":" + $6f58f4f5a2b864a8$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $6f58f4f5a2b864a8$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $6f58f4f5a2b864a8$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $6f58f4f5a2b864a8$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $6f58f4f5a2b864a8$export$a763edbf796b780a:
        case $6f58f4f5a2b864a8$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $6f58f4f5a2b864a8$export$a29989082612d0d9:
            return "";
        case $6f58f4f5a2b864a8$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $6f58f4f5a2b864a8$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $6f58f4f5a2b864a8$export$aa3a2e812ca8570d:
            if (!$6f58f4f5a2b864a8$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $6f58f4f5a2b864a8$export$36776f635604f274(a = $6f58f4f5a2b864a8$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $6f58f4f5a2b864a8$export$5a7767152ae0305f(e) {
    var r = $6f58f4f5a2b864a8$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $6f58f4f5a2b864a8$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $6f58f4f5a2b864a8$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $6f58f4f5a2b864a8$export$527d108ccf083c2b:
                n.return = $6f58f4f5a2b864a8$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $6f58f4f5a2b864a8$export$b44a8529a35fcb60:
                return $6f58f4f5a2b864a8$export$dfdc1655ccc5b9cb([
                    $6f58f4f5a2b864a8$export$784d13d8ee351f07(n, {
                        value: $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $6f58f4f5a2b864a8$export$aa3a2e812ca8570d:
                if (n.length) return $6f58f4f5a2b864a8$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($6f58f4f5a2b864a8$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $6f58f4f5a2b864a8$export$590e8b2c435046d9($6f58f4f5a2b864a8$export$784d13d8ee351f07(n, {
                                props: [
                                    $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $6f58f4f5a2b864a8$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $6f58f4f5a2b864a8$export$590e8b2c435046d9($6f58f4f5a2b864a8$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $6f58f4f5a2b864a8$export$e6e34fd1f2686227(n, {
                                props: $6f58f4f5a2b864a8$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $6f58f4f5a2b864a8$export$590e8b2c435046d9($6f58f4f5a2b864a8$export$784d13d8ee351f07(n, {
                                props: [
                                    $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $6f58f4f5a2b864a8$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $6f58f4f5a2b864a8$export$590e8b2c435046d9($6f58f4f5a2b864a8$export$784d13d8ee351f07(n, {
                                props: [
                                    $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $6f58f4f5a2b864a8$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $6f58f4f5a2b864a8$export$590e8b2c435046d9($6f58f4f5a2b864a8$export$784d13d8ee351f07(n, {
                                props: [
                                    $6f58f4f5a2b864a8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $6f58f4f5a2b864a8$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $6f58f4f5a2b864a8$export$590e8b2c435046d9($6f58f4f5a2b864a8$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $6f58f4f5a2b864a8$export$e6e34fd1f2686227(n, {
                                props: $6f58f4f5a2b864a8$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $6f58f4f5a2b864a8$export$76a88f7de6507443(e) {
    switch(e.type){
        case $6f58f4f5a2b864a8$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $6f58f4f5a2b864a8$export$1be1fc439b849fdf($6f58f4f5a2b864a8$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($6f58f4f5a2b864a8$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $6f58f4f5a2b864a8$export$2f35ab04d2335697(r, 1, $6f58f4f5a2b864a8$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $6f58f4f5a2b864a8$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $6f58f4f5a2b864a8$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $6f58f4f5a2b864a8$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $b905865641868929$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $hPtJY = parcelRequire("hPtJY");
var $f8dbcd8598db1f0b$var$f = ("undefined" != typeof $hPtJY && void 0 !== $hPtJY.env && undefined, "data-styled"), $f8dbcd8598db1f0b$var$m = "active", $f8dbcd8598db1f0b$var$y = "data-styled-version", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.1.19", $f8dbcd8598db1f0b$var$g = "/*!sc*/\n", $f8dbcd8598db1f0b$var$S = "undefined" != typeof window && "undefined" != typeof document, $f8dbcd8598db1f0b$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $hPtJY && $hPtJY.env, "undefined" != typeof $hPtJY && $hPtJY.env, false)), $f8dbcd8598db1f0b$var$b = {}, $f8dbcd8598db1f0b$var$E = /invalid hook call/i, $f8dbcd8598db1f0b$var$N = new Set, $f8dbcd8598db1f0b$var$P = function(t, n) {
    var o, s, i, a, e;
}, $f8dbcd8598db1f0b$var$_ = Object.freeze([]), $f8dbcd8598db1f0b$var$C = Object.freeze({});
function $f8dbcd8598db1f0b$var$I(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $f8dbcd8598db1f0b$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$D = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$R(e) {
    return e.replace($f8dbcd8598db1f0b$var$O, "-").replace($f8dbcd8598db1f0b$var$D, "");
}
var $f8dbcd8598db1f0b$var$T = /(a)(d)/gi, $f8dbcd8598db1f0b$var$k = 52, $f8dbcd8598db1f0b$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $f8dbcd8598db1f0b$var$k; t = t / $f8dbcd8598db1f0b$var$k | 0)n = $f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n;
    return ($f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n).replace($f8dbcd8598db1f0b$var$T, "$1-$2");
}
var $f8dbcd8598db1f0b$var$V, $f8dbcd8598db1f0b$var$F = 5381, $f8dbcd8598db1f0b$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$z = function(e) {
    return $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$F, e);
};
function $f8dbcd8598db1f0b$var$$(e) {
    return $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$z(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$L(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$G = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$Y = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$W = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$J = (($f8dbcd8598db1f0b$var$V = {})[$f8dbcd8598db1f0b$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$V[$f8dbcd8598db1f0b$var$Y] = $f8dbcd8598db1f0b$var$U, $f8dbcd8598db1f0b$var$V);
function $f8dbcd8598db1f0b$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$Y ? $f8dbcd8598db1f0b$var$U : "$$typeof" in e ? $f8dbcd8598db1f0b$var$J[e.$$typeof] : $f8dbcd8598db1f0b$var$q;
}
var $f8dbcd8598db1f0b$var$Z = Object.defineProperty, $f8dbcd8598db1f0b$var$K = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$Q = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$ee = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$te = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$ne = Object.prototype;
function $f8dbcd8598db1f0b$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$ne) {
            var o = $f8dbcd8598db1f0b$var$te(t);
            o && o !== $f8dbcd8598db1f0b$var$ne && $f8dbcd8598db1f0b$var$oe(e, o, n);
        }
        var r = $f8dbcd8598db1f0b$var$K(t);
        $f8dbcd8598db1f0b$var$Q && (r = r.concat($f8dbcd8598db1f0b$var$Q(t)));
        for(var s = $f8dbcd8598db1f0b$var$X(e), i = $f8dbcd8598db1f0b$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $f8dbcd8598db1f0b$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $f8dbcd8598db1f0b$var$ee(t, c);
                try {
                    $f8dbcd8598db1f0b$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$re(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $f8dbcd8598db1f0b$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    else if ($f8dbcd8598db1f0b$var$ce(t)) for(var o in t)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    return e;
}
function $f8dbcd8598db1f0b$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $f8dbcd8598db1f0b$var$pe = {};
function $f8dbcd8598db1f0b$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $f8dbcd8598db1f0b$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($f8dbcd8598db1f0b$var$g);
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$me = 1073741824, $f8dbcd8598db1f0b$var$ye = new Map, $f8dbcd8598db1f0b$var$ve = new Map, $f8dbcd8598db1f0b$var$ge = 1, $f8dbcd8598db1f0b$var$Se = function(e) {
    if ($f8dbcd8598db1f0b$var$ye.has(e)) return $f8dbcd8598db1f0b$var$ye.get(e);
    for(; $f8dbcd8598db1f0b$var$ve.has($f8dbcd8598db1f0b$var$ge);)$f8dbcd8598db1f0b$var$ge++;
    var t = $f8dbcd8598db1f0b$var$ge++;
    return $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e), t;
}, $f8dbcd8598db1f0b$var$we = function(e, t) {
    $f8dbcd8598db1f0b$var$ge = t + 1, $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e);
}, $f8dbcd8598db1f0b$var$be = "style[".concat($f8dbcd8598db1f0b$var$f, "][").concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"]'), $f8dbcd8598db1f0b$var$Ee = new RegExp("^".concat($f8dbcd8598db1f0b$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $f8dbcd8598db1f0b$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f8dbcd8598db1f0b$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($f8dbcd8598db1f0b$var$we(u, l), $f8dbcd8598db1f0b$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $f8dbcd8598db1f0b$var$_e = function(e) {
    for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($f8dbcd8598db1f0b$var$f) !== $f8dbcd8598db1f0b$var$m && ($f8dbcd8598db1f0b$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $f8dbcd8598db1f0b$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($f8dbcd8598db1f0b$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($f8dbcd8598db1f0b$var$f, $f8dbcd8598db1f0b$var$m), o.setAttribute($f8dbcd8598db1f0b$var$y, $f8dbcd8598db1f0b$export$83d89fbfd8236492);
    var i = $f8dbcd8598db1f0b$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $f8dbcd8598db1f0b$var$Ae = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $f8dbcd8598db1f0b$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Oe = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Re = $f8dbcd8598db1f0b$var$S, $f8dbcd8598db1f0b$var$Te = {
    isServer: !$f8dbcd8598db1f0b$var$S,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$w
}, $f8dbcd8598db1f0b$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$S && $f8dbcd8598db1f0b$var$Re && ($f8dbcd8598db1f0b$var$Re = !1, $f8dbcd8598db1f0b$var$_e(this)), $f8dbcd8598db1f0b$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $f8dbcd8598db1f0b$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($f8dbcd8598db1f0b$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($f8dbcd8598db1f0b$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $f8dbcd8598db1f0b$var$S && $f8dbcd8598db1f0b$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$De(n) : t ? new $f8dbcd8598db1f0b$var$Ae(n) : new $f8dbcd8598db1f0b$var$Oe(n);
        }(this.options), new $f8dbcd8598db1f0b$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $f8dbcd8598db1f0b$var$je = /&/g, $f8dbcd8598db1f0b$var$xe = /^\s*\/\/.*$/gm;
function $f8dbcd8598db1f0b$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$Ve(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $f8dbcd8598db1f0b$var$C : e, s = r.options, i = void 0 === s ? $f8dbcd8598db1f0b$var$C : s, a = r.plugins, c = void 0 === a ? $f8dbcd8598db1f0b$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $6f58f4f5a2b864a8$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$je, n).replace(o, l));
    }), i.prefix && u.push($6f58f4f5a2b864a8$export$e08c7d021b829b7a), u.push($6f58f4f5a2b864a8$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($f8dbcd8598db1f0b$var$xe, ""), l = $6f58f4f5a2b864a8$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $f8dbcd8598db1f0b$var$Ve(l, i.namespace));
        var p = [];
        return $6f58f4f5a2b864a8$export$dfdc1655ccc5b9cb(l, $6f58f4f5a2b864a8$export$5a7767152ae0305f(u.concat($6f58f4f5a2b864a8$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$he(15), $f8dbcd8598db1f0b$var$M(e, t.name);
    }, $f8dbcd8598db1f0b$var$F).toString() : "", p;
}
var $f8dbcd8598db1f0b$var$Me = new $f8dbcd8598db1f0b$var$ke, $f8dbcd8598db1f0b$var$ze = $f8dbcd8598db1f0b$var$Fe(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Me,
    stylis: $f8dbcd8598db1f0b$var$ze
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$Ge() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $f8dbcd8598db1f0b$var$Ge().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $acw62.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$Le.Provider, {
        value: u
    }, e.children));
}
var $f8dbcd8598db1f0b$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $f8dbcd8598db1f0b$var$ue(this, function() {
            throw $f8dbcd8598db1f0b$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$ze), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$f8dbcd8598db1f0b$var$Ue(i) && (Array.isArray(i) && i.isCss || $f8dbcd8598db1f0b$var$re(i) ? r.push("".concat($f8dbcd8598db1f0b$var$He(s), ":"), i, ";") : $f8dbcd8598db1f0b$var$ce(i) ? r.push.apply(r, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)((0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $f8dbcd8598db1f0b$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($f8dbcd8598db1f0b$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $b905865641868929$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $f8dbcd8598db1f0b$var$Xe(e, t, n, o) {
    if ($f8dbcd8598db1f0b$var$Ue(e)) return [];
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($f8dbcd8598db1f0b$var$re(e)) {
        if (!$f8dbcd8598db1f0b$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $f8dbcd8598db1f0b$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $f8dbcd8598db1f0b$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $f8dbcd8598db1f0b$var$ce(e) ? $f8dbcd8598db1f0b$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($f8dbcd8598db1f0b$var$_, e.map(function(e) {
        return $f8dbcd8598db1f0b$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $f8dbcd8598db1f0b$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$re(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$Ke = $f8dbcd8598db1f0b$var$z($f8dbcd8598db1f0b$export$83d89fbfd8236492), $f8dbcd8598db1f0b$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$Ze(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$Ke, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $f8dbcd8598db1f0b$var$ie(o, this.staticRulesId);
            else {
                var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $f8dbcd8598db1f0b$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(u, e, t, n));
                    a = $f8dbcd8598db1f0b$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $f8dbcd8598db1f0b$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $f8dbcd8598db1f0b$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    var e = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$he(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$he(14);
            if ($f8dbcd8598db1f0b$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$he(8);
            return n ? (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$rt = {}, $f8dbcd8598db1f0b$var$st = new Set;
function $f8dbcd8598db1f0b$var$it(e, r, s) {
    var i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), a = e, c = !$f8dbcd8598db1f0b$var$L(e), p = r.attrs, d = void 0 === p ? $f8dbcd8598db1f0b$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$R(e);
        $f8dbcd8598db1f0b$var$rt[n] = ($f8dbcd8598db1f0b$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$$($f8dbcd8598db1f0b$export$83d89fbfd8236492 + n + $f8dbcd8598db1f0b$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $f8dbcd8598db1f0b$var$L(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($f8dbcd8598db1f0b$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $f8dbcd8598db1f0b$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), m = $f8dbcd8598db1f0b$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $f8dbcd8598db1f0b$var$I(r, f, c) || $f8dbcd8598db1f0b$var$C, g = function(e, n, o) {
                for(var r, s = (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $f8dbcd8598db1f0b$var$ie(s[c], a[c]) : "style" === c ? (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $f8dbcd8598db1f0b$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $f8dbcd8598db1f0b$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $f8dbcd8598db1f0b$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$f8dbcd8598db1f0b$var$L(S) && !$f8dbcd8598db1f0b$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $acw62.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$f8dbcd8598db1f0b$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $f8dbcd8598db1f0b$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $f8dbcd8598db1f0b$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($f8dbcd8598db1f0b$var$re(t) || $f8dbcd8598db1f0b$var$ce(t)) return $f8dbcd8598db1f0b$var$ct($f8dbcd8598db1f0b$var$Xe($f8dbcd8598db1f0b$var$at($f8dbcd8598db1f0b$var$_, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $f8dbcd8598db1f0b$var$Xe(r) : $f8dbcd8598db1f0b$var$ct($f8dbcd8598db1f0b$var$Xe($f8dbcd8598db1f0b$var$at(r, n)));
}
function $f8dbcd8598db1f0b$var$ut(n, o, r) {
    if (void 0 === r && (r = $f8dbcd8598db1f0b$var$C), !o) throw $f8dbcd8598db1f0b$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$ut(n, o, (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$ut(n, o, (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $f8dbcd8598db1f0b$var$pt = function(e) {
    return $f8dbcd8598db1f0b$var$ut($f8dbcd8598db1f0b$var$it, e);
}, $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$pt;
$f8dbcd8598db1f0b$var$A.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$pt(e);
});
var $f8dbcd8598db1f0b$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$Ze(e), $f8dbcd8598db1f0b$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $f8dbcd8598db1f0b$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$$(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$ht(i, a);
    var l = function(e) {
        var t = $f8dbcd8598db1f0b$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$b, o, s);
        else {
            var i = (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$$(r);
    return new $f8dbcd8598db1f0b$var$We(s, r);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $f8dbcd8598db1f0b$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($f8dbcd8598db1f0b$var$B(e), ")"), $f8dbcd8598db1f0b$var$oe(n, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$Ce(), o = $f8dbcd8598db1f0b$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$f, '="true"'),
                "".concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$f8dbcd8598db1f0b$var$f] = "", n[$f8dbcd8598db1f0b$var$y] = $f8dbcd8598db1f0b$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $f8dbcd8598db1f0b$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$he(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$ke,
    mainSheet: $f8dbcd8598db1f0b$var$Me
};
var $f8dbcd8598db1f0b$var$St = "__sc-".concat($f8dbcd8598db1f0b$var$f, "__");


// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
const $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
const $b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
const $b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: ${(props)=>props.$visible ? "flex" : "none"};
`;
const $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
const $b074148cf394a24e$export$153755f98d9861de = ({ height: height = "100", width: width = "100", color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "audio-loading", wrapperStyle: wrapperStyle = {}, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            height: `${height}`,
            width: `${width}`,
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $ayMG0.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $ayMG0.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $ayMG0.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $ayMG0.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $ayMG0.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ayMG0.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $ayMG0.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ayMG0.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $ayMG0.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ayMG0.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $ayMG0.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    });
const $b074148cf394a24e$export$68949ad0373623af = ({ height: height = 100, width: width = 100, radius: radius = 5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "ball-triangle-loading", wrapperClass: wrapperClass, wrapperStyle: wrapperStyle, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: {
            ...wrapperStyle
        },
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $ayMG0.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $ayMG0.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $ayMG0.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $ayMG0.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $ayMG0.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $ayMG0.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $ayMG0.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $ayMG0.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $ayMG0.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $ayMG0.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $ayMG0.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $ayMG0.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $ayMG0.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$fbc7d6f7dd821b47 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "bars-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        $visible: visible,
        style: {
            ...wrapperStyle
        },
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $ayMG0.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ayMG0.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ayMG0.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ayMG0.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ayMG0.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $b074148cf394a24e$export$765808835a2dc0a2 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "circles-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $ayMG0.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $ayMG0.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $ayMG0.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$17c11650828d97e = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, barColor: barColor, ariaLabel: ariaLabel = "circles-with-bar-loading" })=>{
    return (0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $ayMG0.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: `${height}`,
            width: `${width}`,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $ayMG0.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $ayMG0.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $ayMG0.jsx)("circle", {
                    fill: "none",
                    stroke: `${outerCircleColor || color}`,
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    fill: "none",
                    stroke: `${innerCircleColor || color}`,
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsxs)("g", {
                    fill: `${barColor || color}`,
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $ayMG0.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $ayMG0.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $ayMG0.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $ayMG0.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $ayMG0.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$ef2184bd89960b14 = ({ height: height = 80, width: width = 80, radius: radius = 12.5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "grid-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $ayMG0.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: `${radius}`,
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$2da2f0c7403af3ce = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "hearts-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $ayMG0.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    });
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$len = 242.776657104492;
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$time = 1.6;
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$anim = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)`
12.5% {
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.14}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.11}px;
}
43.75% {
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.35}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.35}px;
}
100% {
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len}px;
  stroke-dashoffset: -${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.99}px;
}
`;
const $b074148cf394a24e$var$$ad60b992c945fdb5$var$Path = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).path`
  stroke-dasharray: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len * 0.01}px, ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$len};
  stroke-dashoffset: 0;
  animation: ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$anim} ${$b074148cf394a24e$var$$ad60b992c945fdb5$var$time}s linear infinite;
`;
const $b074148cf394a24e$export$8009d4483dfda42 = ({ color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "200" })=>{
    return (0, $ayMG0.jsxs)("svg", {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: `${width}`,
        height: `${Number(width) * 0.5}`,
        viewBox: `0 0 ${width} ${Number(100)}`,
        "data-testid": "infinity-spin",
        children: [
            (0, $ayMG0.jsx)($b074148cf394a24e$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $ayMG0.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
const $b074148cf394a24e$export$d2101d81f63866ab = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "line-wave-loading", firstLineColor: firstLineColor, middleLineColor: middleLineColor, lastLineColor: lastLineColor })=>{
    return (0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $ayMG0.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$64ea884904791f4 = ({ height: height = 90, width: width = 80, radius: radius = 12.5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "mutating-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $ayMG0.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $ayMG0.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $ayMG0.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $ayMG0.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $ayMG0.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $ayMG0.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $ayMG0.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $ayMG0.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $ayMG0.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ const $b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ const $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getPath = (radius)=>{
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ const $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getViewBoxSize = (strokeWidth, secondaryStrokeWidth, radius)=>{
    const maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    const startingPoint = -radius - maxStrokeWidth / 2 + 1;
    const endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
const $b074148cf394a24e$export$67ad50c48ca3ede4 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "oval-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true, strokeWidth: strokeWidth = 2, strokeWidthSecondary: strokeWidthSecondary })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $ayMG0.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $ayMG0.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $ayMG0.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $ayMG0.jsx)("path", {
                            d: $b074148cf394a24e$var$$a5fa864d4dd36deb$var$getPath($b074148cf394a24e$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
const $b074148cf394a24e$export$83d2259ec538613b = ({ height: height = 80, width: width = 80, radius: radius = 1, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "puff-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $ayMG0.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ayMG0.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    });
const $b074148cf394a24e$export$8e22e563e5362f75 = ({ radius: radius = 45, strokeWidth: strokeWidth = 5, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, secondaryColor: secondaryColor, ariaLabel: ariaLabel = "revolving-dot-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            version: "1.1",
            width: `calc(${radius} * 2.5)`,
            height: `calc(${radius} * 2.5)`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $ayMG0.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} * 1.28)`,
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $ayMG0.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: `calc(${radius} * 1.28)`,
                    cy: `calc(${radius} / 3.5)`,
                    r: `calc(${radius} / 5)`,
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$fdd9e2f491a77de7 = ({ height: height = 80, width: width = 80, radius: radius = 6, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "rings-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $ayMG0.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $ayMG0.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ayMG0.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ayMG0.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $ayMG0.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    });
const $b074148cf394a24e$export$bb511942ded86554 = ({ wrapperClass: wrapperClass = "", color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, height: height = 100, width: width = 100, strokeWidth: strokeWidth = 4, ariaLabel: ariaLabel = "rotating-square-loading", wrapperStyle: wrapperStyle = {}, visible: visible = true })=>{
    return (0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            version: "1.1",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: `${height}`,
            width: `${width}`,
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $ayMG0.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $ayMG0.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $ayMG0.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
const $b074148cf394a24e$var$$5819da83a926266a$var$spin = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)`
to {
   transform: rotate(360deg);
 }
`;
const $b074148cf394a24e$var$$5819da83a926266a$var$Svg = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg`
  animation: ${$b074148cf394a24e$var$$5819da83a926266a$var$spin} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
const $b074148cf394a24e$var$$5819da83a926266a$var$Polyline = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).polyline`
  stroke-width: ${(props)=>props.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const $b074148cf394a24e$export$d20df8773b6b77b5 = ({ strokeColor: strokeColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, strokeWidth: strokeWidth = "5", animationDuration: animationDuration = "0.75", width: width = "96", visible: visible = true, ariaLabel: ariaLabel = "rotating-lines-loading" })=>{
    const lines = (0, $acw62.useCallback)(()=>$b074148cf394a24e$var$$5819da83a926266a$var$POINTS.map((point)=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: `rotate(${point}, 24, 24)`
            }, point)), [
        strokeWidth
    ]);
    return !visible ? null : (0, $ayMG0.jsx)($b074148cf394a24e$var$$5819da83a926266a$var$Svg, {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: lines()
    });
};
const $b074148cf394a24e$export$f8e5ae7506d65b32 = ({ height: height = 80, width: width = 80, strokeWidth: strokeWidth = 2, radius: radius = 1, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "tail-spin-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    const strokeWidthNum = parseInt(String(strokeWidth));
    const viewBoxValue = strokeWidthNum + 36;
    const halfStrokeWidth = strokeWidthNum / 2;
    const processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: `0 0 ${viewBoxValue} ${viewBoxValue}`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $ayMG0.jsx)("defs", {
                    children: (0, $ayMG0.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $ayMG0.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $ayMG0.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $ayMG0.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $ayMG0.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $ayMG0.jsxs)("g", {
                        transform: `translate(${halfStrokeWidth} ${halfStrokeWidth})`,
                        children: [
                            (0, $ayMG0.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $ayMG0.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $ayMG0.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $ayMG0.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$e21573137ccb7f5d = ({ wrapperStyle: wrapperStyle = {}, visible: visible = true, wrapperClass: wrapperClass = "", height: height = 100, width: width = 100, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-circles-loading", outerCircleColor: outerCircleColor, innerCircleColor: innerCircleColor, middleCircleColor: middleCircleColor })=>{
    return (0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            version: "1.1",
            height: `${height}`,
            width: `${width}`,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $ayMG0.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$4bf83b24a11cff0b = ({ height: height = 80, width: width = 80, radius: radius = 9, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "three-dots-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $ayMG0.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ayMG0.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $ayMG0.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    });
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ const $b074148cf394a24e$var$$afa12dd3e98f740f$var$dash = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)`
to {
   stroke-dashoffset: 136;
 }
`;
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$Polygon = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).polygon`
  stroke-dasharray: 17;
  animation: ${$b074148cf394a24e$var$$afa12dd3e98f740f$var$dash} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
const $b074148cf394a24e$var$$afa12dd3e98f740f$var$SVG = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg`
  transform-origin: 50% 65%;
`;
const $b074148cf394a24e$export$5a465592bfe74b48 = ({ height: height = 80, width: width = 80, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "triangle-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>{
    return (0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: `${wrapperClass}`,
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsx)($b074148cf394a24e$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $b074148cf394a24e$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $ayMG0.jsx)($b074148cf394a24e$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $b074148cf394a24e$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    });
};
const $b074148cf394a24e$export$4c68f1a79f88778c = ({ height: height = 80, width: width = 80, radius: radius = 48, color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ariaLabel: ariaLabel = "watch-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, visible: visible = true })=>(0, $ayMG0.jsx)($b074148cf394a24e$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, {
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $ayMG0.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $ayMG0.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $ayMG0.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    });
const $b074148cf394a24e$export$1ed1943372cc63a9 = ({ color: color = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, width: width = "100", visible: visible = true })=>{
    return visible ? (0, $ayMG0.jsxs)("svg", {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ayMG0.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    }) : null;
};
const $b074148cf394a24e$export$d25f4198d7ad6c78 = ({ visible: visible = true, height: height = "80", width: width = "80", ariaLabel: ariaLabel = "vortex-loading", wrapperStyle: wrapperStyle, wrapperClass: wrapperClass, colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461",
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $ayMG0.jsx)("svg", {
        height: height,
        width: width,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass,
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $ayMG0.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $ayMG0.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $ayMG0.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $b074148cf394a24e$export$f64f16a115ce395d = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "rotating-triangle-loading", colors: colors = [
    "#1B5299",
    "#EF8354",
    "#DB5461"
] })=>{
    return !visible ? null : (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $ayMG0.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $ayMG0.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $ayMG0.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ayMG0.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $ayMG0.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $b074148cf394a24e$export$d7b12c4107be0d61 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "radio-loading", colors: colors = [
    $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
    $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
] })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ayMG0.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ayMG0.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$c17561cb55d4db30 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "progress-bar-loading", borderColor: borderColor = "#F4442E", barColor: barColor = "#51E5FF" })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsx)("defs", {
                children: (0, $ayMG0.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $ayMG0.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $ayMG0.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $ayMG0.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    });
};
const $b074148cf394a24e$export$bdf537af43a20db5 = ({ visible: visible = true, height: height = "80", width: width = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "magnifying-glass-loading", glassColor: glassColor = "#c0efff", color: color = "#e15b64" })=>{
    return !visible ? null : (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $ayMG0.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $ayMG0.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $ayMG0.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $ayMG0.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $ayMG0.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $ayMG0.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $b074148cf394a24e$export$8e3fad5cade57efa = ({ width: width = "80", height: height = "80", backgroundColor: backgroundColor = $b074148cf394a24e$var$$84fda1e7e33cfd28$export$37394b0fa44b998c, ballColors: ballColors = [
    "#fc636b",
    "#6a67ce",
    "#ffb900"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "fidget-spinner-loader", visible: visible = true })=>{
    return !visible ? null : (0, $ayMG0.jsx)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: (0, $ayMG0.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $ayMG0.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $ayMG0.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $ayMG0.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $ayMG0.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $ayMG0.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $ayMG0.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $ayMG0.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $ayMG0.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
};
const $b074148cf394a24e$export$bee07fdc425df572 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "dna-loading" })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $ayMG0.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $ayMG0.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    });
};
const $b074148cf394a24e$export$f93420b62a5bdffa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "discuss-loading", colors: colors = [
    "#ff727d",
    "#ff727d"
] })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $ayMG0.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $ayMG0.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$dc036a5afb9ca26f = ({ visible: visible = true, width: width = "80", height: height = "80", colors: colors = [
    "#e15b64",
    "#f47e60",
    "#f8b26a",
    "#abbd81",
    "#849b87"
], wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "color-ring-loading" })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsx)("defs", {
                children: (0, $ayMG0.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $ayMG0.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $ayMG0.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $ayMG0.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $ayMG0.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $ayMG0.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $ayMG0.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $ayMG0.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $ayMG0.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $ayMG0.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    });
};
const $b074148cf394a24e$export$4d299b491347818a = ({ visible: visible = true, width: width = "80", height: height = "80", backgroundColor: backgroundColor = "#ff6d00", color: color = "#fff", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "comment-loading" })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $ayMG0.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ayMG0.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $ayMG0.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$2ba1b65b747a57aa = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "blocks-loading" })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $b074148cf394a24e$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsx)("title", {
                children: "Blocks"
            }),
            (0, $ayMG0.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $ayMG0.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $ayMG0.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    });
};
const $b074148cf394a24e$export$f3c41beb83007357 = ({ visible: visible = true, width: width = "80", height: height = "80", wrapperClass: wrapperClass = "", wrapperStyle: wrapperStyle = {}, ariaLabel: ariaLabel = "hourglass-loading", colors: colors = [
    "#306cce",
    "#72a1ed"
] })=>{
    return !visible ? null : (0, $ayMG0.jsxs)("svg", {
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg",
        ...$b074148cf394a24e$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18,
        children: [
            (0, $ayMG0.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $ayMG0.jsxs)("g", {
                children: [
                    (0, $ayMG0.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $ayMG0.jsxs)("g", {
                        children: [
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $ayMG0.jsxs)("g", {
                        children: [
                            (0, $ayMG0.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $ayMG0.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $317086ac24816082$var$Send = function Send(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.493 5.031c-.358 0-.693-.175-.898-.468L9.81 3.437a2.406 2.406 0 0 0-1.974-1.03H3.5a2.406 2.406 0 0 0-2.406 2.405v11.375c0 .638.253 1.25.704 1.702a2.41 2.41 0 0 0 1.702.705h14a2.41 2.41 0 0 0 1.702-.705 2.41 2.41 0 0 0 .704-1.701v-8.75a2.41 2.41 0 0 0-.704-1.702A2.41 2.41 0 0 0 17.5 5.03h-6.007Zm0 1.313H17.5a1.096 1.096 0 0 1 1.094 1.093v8.75a1.095 1.095 0 0 1-1.094 1.094h-14a1.095 1.095 0 0 1-1.094-1.093V4.813c0-.604.49-1.094 1.094-1.094h4.337c.357 0 .693.175.897.468l.785 1.126a2.405 2.405 0 0 0 1.974 1.03Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.192 11.008H7.808a.808.808 0 0 0 0 1.615h5.384a.808.808 0 0 0 0-1.615Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m10.471 10.23 1.582 1.583-1.582 1.583a.807.807 0 1 0 1.142 1.141l2.153-2.153a.806.806 0 0 0 0-1.142l-2.153-2.154a.807.807 0 1 0-1.142 1.142Z",
                fill: "#4A67FF"
            })
        ]
    });
};
$317086ac24816082$var$Send.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $317086ac24816082$var$Search = function Search(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#a)",
                fill: "#000",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M18.812 2.176c-2.901-2.901-7.622-2.901-10.524 0-2.76 2.76-2.894 7.169-.402 10.09l-.034.03-1.13 1.131-.78-.78a.613.613 0 0 0-.867 0L.697 17.025a2.332 2.332 0 0 0 0 3.294c.454.454 1.05.681 1.647.681.596 0 1.193-.227 1.647-.681l4.378-4.378a.613.613 0 0 0 0-.867l-.78-.78 1.13-1.13a.62.62 0 0 0 .033-.037 7.386 7.386 0 0 0 4.798 1.753 7.393 7.393 0 0 0 5.262-2.18 7.393 7.393 0 0 0 2.18-5.262 7.393 7.393 0 0 0-2.18-5.262ZM3.124 19.452a1.104 1.104 0 0 1-1.56-1.56l1.302-1.302 1.56 1.56-1.302 1.302Zm2.169-2.17-1.56-1.56 1.775-1.774 1.56 1.56-1.775 1.775Zm12.652-5.449a6.223 6.223 0 0 1-8.79 0 6.223 6.223 0 0 1 0-8.79 6.196 6.196 0 0 1 4.395-1.817c1.592 0 3.183.606 4.395 1.817a6.175 6.175 0 0 1 1.82 4.395c0 1.66-.646 3.221-1.82 4.395Z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m16.116 5.164-3.402 3.401-1.863-1.863a.613.613 0 1 0-.867.868l2.297 2.296a.611.611 0 0 0 .867 0l3.835-3.835a.613.613 0 1 0-.867-.867Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h21v21H0z"
                    })
                })
            })
        ]
    });
};
$317086ac24816082$var$Search.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $317086ac24816082$var$btnCancel = {
    background: 'none',
    border: '1.5px solid #D1D5DB',
    borderRadius: '50px',
    cursor: 'pointer',
    color: '#6B7280',
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.4rem 1.5rem'
};
const $317086ac24816082$var$btnMinimize = {
    background: 'none',
    border: '1.5px solid #FC7785',
    borderRadius: '50px',
    cursor: 'pointer',
    color: '#FC7785',
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.4rem 1.5rem'
};
// Mirrors getResearchAidDisplayName in server/api/company/papermill.helper.js — canonical source of these labels
const $317086ac24816082$var$REPORT_TYPES = [
    'marketReport',
    'routeToMarketReport',
    'competitorReport',
    'TCAR3',
    'swotAnalysis'
];
const $317086ac24816082$var$REPORT_LABELS = {
    marketReport: 'Market Opportunity Report',
    competitorReport: 'Competitor Analysis Report',
    routeToMarketReport: 'Route to Market Report',
    TCAR3: 'Technology Competitive Advantage Report',
    swotAnalysis: 'SWOT Analysis Report'
};
const $317086ac24816082$var$REPORT_DESCRIPTIONS = {
    marketReport: "Sizes the opportunity \u2014 market size, growth, and demand signals",
    routeToMarketReport: "Maps how the product reaches customers \u2014 channels and go-to-market fit",
    competitorReport: "Benchmarks against key competitors \u2014 strengths, gaps, positioning",
    TCAR3: 'Assesses the technology edge versus alternatives in the market',
    swotAnalysis: 'Strengths, weaknesses, opportunities and threats at a glance'
};
// Font Awesome 4.7 icon names only (project's loaded FA version has no route/people-arrows/diagram-project glyphs)
const $317086ac24816082$var$REPORT_ICONS = {
    marketReport: 'fa-line-chart',
    routeToMarketReport: 'fa-map-signs',
    competitorReport: 'fa-users',
    TCAR3: 'fa-microchip',
    swotAnalysis: 'fa-th-large'
};
const $317086ac24816082$var$reportScoreColor = (score)=>!score ? '#9CA3AF' : score >= 4 ? '#16a34a' : score >= 2.5 ? '#d97706' : '#dc2626';
// Reason: coarse rounding stops the countdown flickering between near-identical values on every progress event
const $317086ac24816082$var$formatEtaSeconds = (secs)=>{
    if (secs < 20) return `~${Math.max(5 * Math.round(secs / 5), 5)} sec left`;
    if (secs < 90) return `~${10 * Math.round(secs / 10)} sec left`;
    const mins = Math.round(secs / 60);
    if (mins >= 60) return `~${Math.floor(mins / 60)} hr ${mins % 60 > 0 ? `${mins % 60} min ` : ''}left`;
    return `~${mins} min left`;
};
// ── Estimated time remaining ──────────────────────────────────────────────────────────────────────────────────
// The server does its work in parallel batches (indexing 20 files, allocation 30 files, filling 30 questions), so the
// only moment the true speed is known is when a whole batch completes. The rule, in four sentences:
//   1. Measure speed only at batch boundaries — every progress event carries batchSize for this.
//   2. Between boundaries, only count down.
//   3. If the in-flight batch is already slower than average, raise the estimate gradually — never sit too low.
//   4. Before a stage's first batch lands, project from the previous stage's measured speed × priorWeight
//      (allocation ≈ 3× indexing per file; each extra module ≈ the previous one per question).
// laterItems adds work that has not started yet (allocation while indexing; remaining modules) at laterWeight× this speed.
// countsStarted: the fill loop reports `current` when a question STARTS (all 30 of a batch at once), not when it completes.
const $317086ac24816082$var$useEta = ({ isActive: isActive, stageKey: stageKey, current: current, total: total, batchSize: batchSize, priorWeight: priorWeight = null, laterItems: laterItems = 0, laterWeight: laterWeight = 1, countsStarted: countsStarted = false })=>{
    const ref = (0, $acw62.useRef)({
        stage: null,
        lastMsPerItem: null,
        lastLabel: null
    });
    (0, $acw62.useEffect)(()=>{
        const st = ref.current;
        if (!isActive) {
            st.stage = null;
            st.lastLabel = null;
            return;
        }
        st.stage = {
            key: stageKey,
            startedAt: Date.now(),
            startCurrent: current || 0,
            startBatches: null,
            batchesDone: 0,
            lastBoundaryAt: null,
            avgBatchMs: null,
            priorMsPerItem: priorWeight && st.lastMsPerItem ? st.lastMsPerItem * priorWeight : null
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isActive,
        stageKey
    ]);
    const st = ref.current, s = st.stage;
    if (!isActive || !total) return null;
    if (!s || s.key !== stageKey) return st.lastLabel;
    const now = Date.now(), bs = batchSize > 0 ? batchSize : 0;
    // Reason: subtract one batch rather than rounding down — a resumed fill starts at an offset (e.g. 117 of 213) that is not a batch multiple
    const completed = countsStarted && bs ? Math.max((current || 0) - bs, 0) : current || 0;
    if (bs) {
        const doneBatches = Math.floor(completed / bs);
        if (s.startBatches == null) s.startBatches = doneBatches;
        const done = doneBatches - s.startBatches;
        if (done > s.batchesDone) {
            s.batchesDone = done;
            s.lastBoundaryAt = now;
            s.avgBatchMs = (now - s.startedAt) / done;
            st.lastMsPerItem = s.avgBatchMs / bs;
        }
    }
    const msPerItem = s.avgBatchMs ? s.avgBatchMs / bs : s.priorMsPerItem;
    if (!msPerItem) return st.lastLabel = "Estimating time\u2026";
    const inFlight = now - (s.lastBoundaryAt ?? s.startedAt);
    let stageMs;
    if (s.avgBatchMs) {
        const batchesLeft = Math.ceil((total - completed) / bs);
        stageMs = Math.max(batchesLeft - 1, 0) * Math.max(s.avgBatchMs, inFlight) + Math.max(s.avgBatchMs - inFlight, 0);
    } else {
        const floorMs = bs ? Math.max(Math.ceil(total / bs) - 1, 0) * inFlight : 0;
        stageMs = Math.max(msPerItem * (total - s.startCurrent) - (now - s.startedAt), floorMs);
    }
    const secs = (stageMs + laterItems * msPerItem * laterWeight) / 1000;
    return st.lastLabel = secs <= 0 ? "Finishing up\u2026" : $317086ac24816082$var$formatEtaSeconds(Math.round(secs));
};
const $317086ac24816082$var$uploadFileWithProgress = (endpoint, obj, onProgress, onXhr)=>new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        onXhr?.(xhr);
        const formData = new FormData();
        Object.entries(obj).forEach(([key, val])=>{
            if (key === 'attachment' && Array.isArray(val)) val.forEach((f)=>formData.append('attachment', f));
            else if (val !== null && typeof val === 'object') formData.append(key, JSON.stringify(val));
            else formData.append(key, val);
        });
        xhr.upload.onprogress = (e)=>{
            if (e.lengthComputable) onProgress(Math.round(e.loaded / e.total * 100));
        };
        xhr.onload = ()=>{
            try {
                resolve(JSON.parse(xhr.responseText));
            } catch (_) {
                reject(new Error('Parse error'));
            }
        };
        xhr.onerror = ()=>reject(new Error('Network error'));
        xhr.onabort = ()=>reject(new Error('Aborted'));
        xhr.open('POST', `${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api${endpoint}`);
        if (0, $bebe1cbb5a309c8c$export$9e1725a4cfeada27) xhr.setRequestHeader('Authorization', `Bearer ${(0, $bebe1cbb5a309c8c$export$9e1725a4cfeada27)}`);
        if (0, $bebe1cbb5a309c8c$export$d9aa71f96dda8d28) xhr.setRequestHeader('id', (0, $bebe1cbb5a309c8c$export$d9aa71f96dda8d28));
        xhr.send(formData);
    });























const $317086ac24816082$var$AutoFillStepperModal = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const store = (0, $391671225302c365$export$6ccbb43953eebf8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { fileReport: fileReport, currentScore: currentScore, tab: tab, autoFillContext: autoFillContext, company: reduxCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { selectedCompany: company } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [indexingProgress, setIndexingProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        currentFile: ''
    });
    const [allocationProgress, setAllocationProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        fileName: '',
        matchedQNo: '',
        matchedQuestion: ''
    });
    const [savingProgress, setSavingProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        fileName: '',
        qNo: ''
    });
    // Module selection state (moduleSelect phase)
    const [selectedModules, setSelectedModules] = (0, $acw62.useState)(null); // null = not yet initialized
    // "Generate Research Reports (complete set of 5)" tickbox — fires /company/generateAllReports after the fill completes
    const [generateReports, setGenerateReports] = (0, $acw62.useState)(false);
    const [reportsGenStatus, setReportsGenStatus] = (0, $acw62.useState)(''); // '' | 'generating' | 'done' | 'partial' | 'error'
    const [reportsGenCounts, setReportsGenCounts] = (0, $acw62.useState)({
        success: 0,
        total: 0
    });
    // Live per-report cards, keyed by reportType: { status: 'pending'|'generating'|'done'|'failed', score, reportId, error }
    const [reportCards, setReportCards] = (0, $acw62.useState)({});
    // Cross File Upload step (step 5) — rule-based file copy progress
    const [crossFileProgress, setCrossFileProgress] = (0, $acw62.useState)({
        moduleIndex: 0,
        totalModules: 0,
        moduleType: '',
        total: 0,
        current: 0,
        currentQuestionText: '',
        sourceFiles: [],
        drQNo: ''
    });
    const [crossFileCompleted, setCrossFileCompleted] = (0, $acw62.useState)({});
    // Other Modules AI step (step 6) — full AI autofill progress per module
    const [otherModulesProgress, setOtherModulesProgress] = (0, $acw62.useState)({
        moduleIndex: 0,
        totalModules: 0,
        moduleType: '',
        total: 0,
        current: 0,
        currentQuestionText: '',
        sourceFiles: [],
        currentQuestion: ''
    });
    const [otherModulesCompleted, setOtherModulesCompleted] = (0, $acw62.useState)({});
    // Upfront question counts per module, keyed by moduleType — powers the "N questions across M modules" subtitle on Cross File Upload / Other Modules
    const [moduleQuestionCounts, setModuleQuestionCounts] = (0, $acw62.useState)({});
    // Result phase — per-question fill results
    const [fillResults, setFillResults] = (0, $acw62.useState)([]);
    const [resultModuleFilter, setResultModuleFilter] = (0, $acw62.useState)({});
    const [expandedModules, setExpandedModules] = (0, $acw62.useState)({});
    // Indexing phase — accumulated file chips and unallocated count
    const [processedFileChips, setProcessedFileChips] = (0, $acw62.useState)([]);
    const [unallocatedCount, setUnallocatedCount] = (0, $acw62.useState)(0);
    // Allocation phase — table tab filter
    const [allocationTab, setAllocationTab] = (0, $acw62.useState)('all');
    const [upNextExpanded, setUpNextExpanded] = (0, $acw62.useState)(false);
    // File preview state (allocation step)
    const [previewFile, setPreviewFile] = (0, $acw62.useState)(null);
    const [aiPopover, setAiPopover] = (0, $acw62.useState)(null); // { key, qNo, x, y, pinned }
    const aiPopoverPinned = aiPopover?.pinned || false;
    // Hidden file input ref (select step)
    const fileInputRef = (0, $acw62.useRef)(null);
    const folderInputRef = (0, $acw62.useRef)(null);
    // Tracks in-flight upload XHRs so cancel can abort them immediately
    const activeXhrsRef = (0, $acw62.useRef)([]);
    // Issue 32 — guards the history-modal resume kick-off so it fires once per resumed report
    const resumeStartedRef = (0, $acw62.useRef)(null);
    // Indexing animation queue — drains at 700ms/event so browser has time to paint between updates
    const indexingQueueRef = (0, $acw62.useRef)([]);
    const indexingAnimatingRef = (0, $acw62.useRef)(false);
    const indexingAnimationTimerRef = (0, $acw62.useRef)(null);
    const phase = modal.autoFillStepperPhase || '';
    // const phase = 'result';
    const isOpen = modal.open === 'autoFillStepper';
    // Elapsed time on the Research Aid Reports step — purely a local display timer, ticks only while that phase is on screen
    const [researchElapsedSec, setResearchElapsedSec] = (0, $acw62.useState)(0);
    const researchStartRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (phase !== 'researchAid') {
            researchStartRef.current = null;
            return;
        }
        if (!researchStartRef.current) researchStartRef.current = Date.now();
        setResearchElapsedSec(Math.floor((Date.now() - researchStartRef.current) / 1000));
        const timer = setInterval(()=>setResearchElapsedSec(Math.floor((Date.now() - researchStartRef.current) / 1000)), 1000);
        return ()=>clearInterval(timer);
    }, [
        phase
    ]);
    // Build list of available fillable modules the company actually has.
    // New dashboard passes autoFillAvailableModules via modal state (already computed at call site).
    // Old dashboard falls back to deriving from company.modules + subscription + expensions.
    const availableModules = (()=>{
        const list = [
            {
                key: 'repository',
                label: 'Data Repository'
            }
        ];
        if (modal.autoFillAvailableModules?.length) {
            const passed = [
                ...modal.autoFillAvailableModules
            ];
            if (!passed.find((m)=>m.key === 'repository')) passed.unshift({
                key: 'repository',
                label: 'Data Repository'
            });
            return passed;
        }
        if (!company) return list;
        const mods = company.modules || {};
        const expensions = company.expensions || {};
        const subscription = company.subscription || '';
        const testType = company.testType || '';
        const baKey = Object.keys(mods).find((k)=>k.startsWith('business-audit')) || ([
            'Lite',
            'Pro',
            'Pro Plus'
        ].includes(subscription) && testType ? `business-audit-${testType}` : null);
        if (baKey) list.push({
            key: baKey,
            label: 'Business Audit'
        });
        if (mods['warranty-disclosure'] || expensions['DEPF006']) list.push({
            key: 'warranty-disclosure',
            label: 'Warranty Disclosures'
        });
        const dqKey = Object.keys(mods).find((k)=>k.startsWith('directors-questionnaire'));
        if (dqKey) list.push({
            key: dqKey,
            label: "Directors' Questionnaire"
        });
        if (mods['Investment Readiness'] || [
            'Pro',
            'Pro Plus'
        ].includes(subscription)) list.push({
            key: 'Investment Readiness',
            label: 'Investment Readiness'
        });
        return list;
    })();
    // Initialize selectedModules when select phase opens; reset on close
    (0, $acw62.useEffect)(()=>{
        if ((phase === 'select' || phase === 'uploadDocs') && selectedModules === null && autoFillContext?.moduleType) {
            setSelectedModules(new Set([
                autoFillContext.moduleType
            ]));
            setGenerateReports(!!autoFillContext?.generateReports);
            setReportsGenStatus('');
            setReportCards({});
            // Reason: clear any leftover status from a previous run so a new run's sidebar doesn't show a stale done/error badge
            if (autoFillContext?.reportsGenStatus) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                autoFillContext: {
                    ...autoFillContext,
                    reportsGenStatus: null
                }
            }));
        }
        if (!isOpen) {
            setSelectedModules(null);
            setGenerateReports(false);
            setReportCards({});
            setFillResults([]);
            setResultModuleFilter({});
            setExpandedModules({});
            setProcessedFileChips([]);
            setUnallocatedCount(0);
            setAllocationTab('all');
        }
    }, [
        phase,
        isOpen,
        autoFillContext?.moduleType
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const toggleModuleSelection = (key)=>{
        setSelectedModules((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) {
                if (next.size > 1) next.delete(key);
            } else next.add(key);
            return next;
        });
    };
    const handleModuleSelectContinue = ()=>{
        const modules = selectedModules ? [
            ...selectedModules
        ] : [
            'repository'
        ];
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                ...autoFillContext,
                extraModules: modules.filter((m)=>m !== autoFillContext?.moduleType)
            }
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'select'
        }));
    };
    const getModuleLabel = (moduleType)=>{
        if (!moduleType) return '';
        const mod = availableModules.find((m)=>m.key === moduleType);
        if (mod) return mod.label;
        if (moduleType.includes('business-audit')) return 'Business Audit';
        if (moduleType === 'warranty-disclosure') return 'Warranty Disclosures';
        if (moduleType.includes('directors-questionnaire')) return "Directors' Questionnaire";
        if (moduleType === 'Investment Readiness') return 'Investment Readiness';
        return moduleType;
    };
    // Scope display info
    const rawScopeName = modal.autoFillModuleName || autoFillContext?.scopeName || '';
    const scopeName = rawScopeName === 'repository' ? 'Data Repository' : rawScopeName;
    const scope = autoFillContext?.scope || 'module';
    // ── Socket listeners for indexing & allocation progress ──
    (0, $acw62.useEffect)(()=>{
        const drainIndexingQueue = ()=>{
            if (indexingQueueRef.current.length === 0) {
                indexingAnimatingRef.current = false;
                return;
            }
            // Reason: coalesce to the newest event instead of replaying the backlog one-by-one — events arrive
            // faster than the 700ms repaint cadence, so replaying made the modal lag far behind the minimized
            // status bar (which applies events instantly) and the two views showed different progress
            const next = indexingQueueRef.current[indexingQueueRef.current.length - 1];
            indexingQueueRef.current = [];
            setIndexingProgress(next);
            indexingAnimationTimerRef.current = setTimeout(drainIndexingQueue, 700);
        };
        const onIndexingProgress = (data)=>{
            indexingQueueRef.current.push({
                total: data.total || 0,
                current: data.current || 0,
                currentFile: data.currentFile || '',
                batchSize: data.batchSize || 0
            });
            if (!indexingAnimatingRef.current) {
                indexingAnimatingRef.current = true;
                drainIndexingQueue();
            }
        };
        const onAllocationProgress = (data)=>{
            setAllocationProgress({
                total: data.total || 0,
                current: data.current || 0,
                fileName: data.fileName || '',
                matchedQNo: data.matchedQNo || '',
                matchedQuestion: data.matchedQuestion || '',
                confidence: data.confidence || 0,
                reasoning: data.reasoning || '',
                batchSize: data.batchSize || 0
            });
            if (data.fileName) setProcessedFileChips((prev)=>{
                const name = data.fileName;
                return prev.includes(name) ? prev : [
                    ...prev,
                    name
                ];
            });
            if (data.matchedQNo === 'SXXX' || data.matchedQNo === 'DXXX') setUnallocatedCount((prev)=>prev + 1);
        };
        const onAllocationCompleted = (data)=>{
            setIndexingProgress({
                total: 0,
                current: 0,
                currentFile: ''
            });
            setAllocationProgress({
                total: 0,
                current: 0,
                fileName: '',
                matchedQNo: '',
                matchedQuestion: ''
            });
            setProcessedFileChips([]);
            setUnallocatedCount(0);
            const currentPhase = store.getState().modal.autoFillStepperPhase;
            const currentOpen = store.getState().modal.open;
            // Always store fileReport so handleExpand (maximize from status bar) can use it
            if (data?.fileReport) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: data.fileReport
            }));
            // Only advance the stepper if it's currently open at indexing phase
            if (data?.fileReport && currentPhase === 'indexing' && currentOpen === 'autoFillStepper') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: 'allocation',
                autoFillStatusBarPhase: 'allocated'
            }));
            else if (data?.fileReport && currentPhase === 'indexing') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                autoFillStepperPhase: 'allocation',
                autoFillStatusBarPhase: 'allocated',
                autoFillStatusBarVisible: true
            }));
        };
        // Reason: the upload request returns before allocation runs, so a server-side failure arrives over the socket instead of as an HTTP error
        const onAllocationFailed = (data)=>{
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                autoFillStatusBarPhase: 'error',
                autoFillError: data?.message || 'Allocation failed'
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(data?.message || 'Allocation failed', 'error');
        };
        const onSavingProgress = (data)=>{
            setSavingProgress({
                total: data.total || 0,
                current: data.current || 0,
                fileName: data.fileName || '',
                qNo: data.qNo || ''
            });
        };
        const onSavingCompleted = ()=>{
            // Snap to 100% so the progress bar fills completely before the phase changes
            setSavingProgress((prev)=>({
                    ...prev,
                    current: prev.total > 0 ? prev.total : 1,
                    total: prev.total > 0 ? prev.total : 1
                }));
            setTimeout(()=>{
                setSavingProgress({
                    total: 0,
                    current: 0,
                    fileName: '',
                    qNo: ''
                });
                // In Filing Assistant mode (no auto-fill), close the stepper cleanly after processing
                const state = store.getState();
                if (!state.modal.autoFillWithFilling) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarVisible: false,
                    autoFillStatusBarPhase: '',
                    autoFillJustCompleted: true
                }));
            }, 800);
        };
        // Cross file upload step — reuses otherModules:* socket events from fillOtherModules
        const onCrossFileStarted = (data)=>{
            setCrossFileProgress({
                moduleIndex: data.moduleIndex,
                totalModules: data.totalModules,
                moduleType: data.moduleType,
                total: 0,
                current: 0,
                currentQuestionText: '',
                sourceFiles: [],
                drQNo: ''
            });
        };
        const onCrossFileProgress = (data)=>{
            setCrossFileProgress((prev)=>({
                    ...prev,
                    ...data
                }));
        };
        const onCrossFileModuleCompleted = (data)=>{
            setCrossFileCompleted((prev)=>({
                    ...prev,
                    [data.moduleType]: {
                        uploaded: data.answered ?? data.uploaded ?? 0
                    }
                }));
        };
        // AI other modules step — listens to autoFill:* events emitted per module by /clarence/auto-fill
        const onAiModuleProgress = (data)=>{
            setOtherModulesProgress((prev)=>{
                // Backend strips _<objectId> suffix; match against both original and stripped key
                const incomingType = data.moduleType || '';
                const prevStripped = prev.moduleType.replace(/_[a-f0-9]{24}$/, '');
                if (incomingType && incomingType !== prev.moduleType && incomingType !== prevStripped) return prev;
                return {
                    ...prev,
                    total: data.total || prev.total,
                    current: data.current || prev.current,
                    batchSize: data.batchSize || prev.batchSize || 0,
                    currentQuestion: data.currentQuestion || prev.currentQuestion,
                    currentQuestionText: data.questionText || prev.currentQuestionText
                };
            });
        };
        const onAiModuleReading = (data)=>{
            setOtherModulesProgress((prev)=>({
                    ...prev,
                    sourceFiles: data.files || []
                }));
        };
        const onAiModuleCompleted = (data)=>{
            setOtherModulesCompleted((prev)=>({
                    ...prev,
                    [data.moduleType || '_current']: {
                        answered: data.answered || 0,
                        skipped: data.skipped || 0
                    }
                }));
        };
        const onReportProgress = (data)=>{
            setReportCards((prev)=>({
                    ...prev,
                    [data.reportType]: {
                        status: data.status === 'started' ? 'generating' : data.status === 'success' ? 'done' : 'failed',
                        score: data.score,
                        reportId: data.reportId,
                        error: data.error
                    }
                }));
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('indexing:progress', onIndexingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempIndexing:progress', onIndexingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('allocation:progress', onAllocationProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:progress', onAllocationProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('allocation:completed', onAllocationCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('allocation:failed', onAllocationFailed);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:failed', onAllocationFailed);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:completed', onAllocationCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('processingFiles:progress', onSavingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempProcessingFiles:progress', onSavingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('processingFiles:completed', onSavingCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempProcessingFiles:completed', onSavingCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('otherModules:moduleStarted', onCrossFileStarted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('otherModules:progress', onCrossFileProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('otherModules:moduleCompleted', onCrossFileModuleCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:progress', onAiModuleProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:progress', onAiModuleProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:reading', onAiModuleReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:reading', onAiModuleReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:completed', onAiModuleCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:completed', onAiModuleCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('reportsGeneration:reportProgress', onReportProgress);
        return ()=>{
            clearTimeout(indexingAnimationTimerRef.current);
            indexingQueueRef.current = [];
            indexingAnimatingRef.current = false;
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('indexing:progress', onIndexingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempIndexing:progress', onIndexingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('allocation:progress', onAllocationProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:progress', onAllocationProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('allocation:completed', onAllocationCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('allocation:failed', onAllocationFailed);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:failed', onAllocationFailed);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:completed', onAllocationCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('processingFiles:progress', onSavingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempProcessingFiles:progress', onSavingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('processingFiles:completed', onSavingCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempProcessingFiles:completed', onSavingCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('otherModules:moduleStarted', onCrossFileStarted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('otherModules:progress', onCrossFileProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('otherModules:moduleCompleted', onCrossFileModuleCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:progress', onAiModuleProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:progress', onAiModuleProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:reading', onAiModuleReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:reading', onAiModuleReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:completed', onAiModuleCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:completed', onAiModuleCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('reportsGeneration:reportProgress', onReportProgress);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // ── Allocation step helpers (copied from importSummary) ──
    const handleFilePreview = (file)=>{
        const url = file.location || file.url;
        if (!url) return;
        const name = file.originalname || file.title || '';
        const ext = (name.split('.').pop() || '').toLowerCase();
        // Reason: browsers natively render pdf/images/txt but download Office files — those need an embed viewer to display in the iframe
        const officeExts = [
            'doc',
            'docx',
            'xls',
            'xlsx',
            'ppt',
            'pptx'
        ];
        const nativeExts = [
            'pdf',
            'png',
            'jpg',
            'jpeg',
            'gif',
            'webp',
            'svg',
            'txt'
        ];
        let viewerUrl = url;
        if (officeExts.includes(ext)) viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
        else if (!nativeExts.includes(ext)) viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
        setPreviewFile({
            name: name,
            url: url,
            viewerUrl: viewerUrl
        });
    };
    const getSectionNameFromSection = (section, qNo)=>{
        if (section.sectionNo == qNo || section.no == qNo) {
            const name = section.sectionName || section.name || '';
            return {
                displayName: name,
                sectionOnly: name,
                questionDesc: ''
            };
        }
        if (section.questions) {
            for (const question of Object.values(section.questions))if (question.qNo == qNo) {
                const sectionOnly = section.sectionName || section.name || '';
                return {
                    displayName: question.qDescription || sectionOnly,
                    sectionOnly: sectionOnly,
                    questionDesc: question.qDescription || ''
                };
            }
        }
        if (section.subFolders) for (const subFolder of Object.values(section.subFolders)){
            const result = getSectionNameFromSection(subFolder, qNo);
            if (result) return result;
        }
        return null;
    };
    const getSectionName = (module, qNo, file, key)=>{
        if (qNo == "DXXX" || qNo == "SXXX") return {
            displayName: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onClick: ()=>handleEditDispatch({
                        key: key,
                        fileName: file.originalname,
                        from: 'fileReport',
                        actionType: "move",
                        fileData: file,
                        index: "0"
                    }),
                className: "bg62 br10px df aic p1rem jcsb fsi",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Please select section"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                        className: "c3"
                    })
                ]
            }),
            sectionOnly: ''
        };
        const effectiveCompany = company || reduxCompany;
        const module2 = module || (effectiveCompany?.modules ? {
            ...effectiveCompany.modules[tab || "repository"]
        } : null);
        const sections = [
            ...module2?.sections || []
        ];
        for (const section of sections){
            const result = getSectionNameFromSection(section, qNo);
            if (result) return {
                displayName: `${qNo} ${result.displayName}`,
                sectionOnly: result.sectionOnly,
                questionDesc: result.questionDesc
            };
        }
        // Fallback — use the importResult entry directly for this file (works for new dashboard where company.modules has no nested questions)
        const directEntry = fileReport?.importResult?.[key];
        if (directEntry?.allocatedSection) return {
            displayName: `${qNo} ${directEntry.sectionName || directEntry.allocatedSection}`,
            sectionOnly: directEntry.sectionName || '',
            questionDesc: directEntry.allocatedSection || ''
        };
        const entry = fileReport?.importResult && Object.values(fileReport.importResult).find((r)=>r.section?.includes(qNo) && r.sectionName);
        if (entry?.allocatedSection) return {
            displayName: `${qNo} ${entry.sectionName || entry.allocatedSection}`,
            sectionOnly: entry.sectionName || '',
            questionDesc: entry.allocatedSection || ''
        };
        if (entry?.sectionName) return {
            displayName: `${qNo} ${entry.sectionName}`,
            sectionOnly: entry.sectionName,
            questionDesc: ''
        };
        return {
            displayName: "Unknown",
            sectionOnly: '',
            questionDesc: ''
        };
    };
    const handleEditDispatch = (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(true));
    };
    function isSubarray(subarray, array) {
        const sortedSubarray = subarray.slice().sort();
        const sortedArray = array.slice().sort();
        let i = 0;
        return sortedArray.some((element)=>{
            if (element === sortedSubarray[i]) i++;
            return i === sortedSubarray.length;
        });
    }
    const calcAccuracyScore = (count)=>{
        let allocated = 0;
        for (const key of Object.keys(fileReport.importResult)){
            const currentSection = fileReport.importResult[key]['section'];
            const oldSection = fileReport.importResult[key]['originalSection'];
            if (oldSection.includes("DXXX") || oldSection.includes("SXXX")) continue;
            if (isSubarray(oldSection, currentSection)) allocated++;
        }
        const totalCount = count ?? Object.keys(fileReport.importResult).length;
        dispatch((0, $12074930bd2c1829$export$fb8d60304f3762b3)(!totalCount ? 0 : Math.round(allocated / totalCount * 100)));
        return !totalCount ? 0 : Math.round(allocated / totalCount * 100);
    };
    const removeSectionFromImport = async (fileKey, index)=>{
        const sections = [
            ...fileReport.importResult[fileKey]['section']
        ];
        const qNo = sections[index];
        sections.splice(index, 1);
        const file = fileReport.importResult[fileKey]['file'];
        let newImportResult;
        if (sections.length === 0) {
            const { [fileKey]: _removed, ...rest } = fileReport.importResult;
            newImportResult = rest;
        } else newImportResult = {
            ...fileReport.importResult,
            [fileKey]: {
                ...fileReport.importResult[fileKey],
                section: sections
            }
        };
        const _fileReport = {
            ...fileReport,
            importResult: newImportResult
        };
        const score = calcAccuracyScore(Object.keys(newImportResult).length);
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(_fileReport));
        const effectiveCompany = company || reduxCompany;
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteSection`, {
            companyId: effectiveCompany._id,
            fileReportId: _fileReport['_id'],
            fileKey: fileKey,
            index: index,
            qNo: qNo,
            score: score,
            file: file
        });
    };
    const getImportResultEntryHTML = (key)=>{
        if (!fileReport?.importResult?.[key]) return null;
        const fileName = fileReport.importResult[key].file['originalname'];
        const file = fileReport.importResult[key].file;
        const section = fileReport.importResult[key]['section'];
        const effectiveCompany = company || reduxCompany;
        let module = {
            ...effectiveCompany?.modules?.[tab || "repository"] || {}
        };
        if (module) module = JSON.parse(JSON.stringify(module));
        const matchScore = fileReport.importResult[key]?.matchScore;
        const reasoning = fileReport.importResult[key]?.reasoning || '';
        const suggestedQNo = fileReport.importResult[key]?.suggestedQNo || '';
        const suggestedSection = fileReport.importResult[key]?.suggestedSection || '';
        const suggestedQuestion = fileReport.importResult[key]?.suggestedQuestion || '';
        const allocatedSection = fileReport.importResult[key]?.allocatedSection || '';
        const isInProgress = fileReport['status'] == 'In Progress';
        const scoreVal = matchScore != null ? Math.round(matchScore * 10) : null;
        const sections = Array.isArray(section) ? section : [
            section
        ];
        // Filter by active tab — unallocated tab shows only DXXX/SXXX entries
        const entries = sections.map((qNo, idx)=>({
                qNo: qNo,
                idx: idx
            }));
        const filteredEntries = allocationTab === 'unallocated' ? entries.filter(({ qNo: qNo })=>qNo === 'DXXX' || qNo === 'SXXX') : entries;
        if (filteredEntries.length === 0) return null;
        // In 'all' tab: render one row per file (primary section only) to match the stat count.
        // Extra sections are shown as compact pills in the section cell.
        const entriesToRender = allocationTab === 'unallocated' ? filteredEntries : [
            filteredEntries[0]
        ];
        const extraSections = allocationTab === 'all' ? sections.slice(1).filter((q)=>q !== 'DXXX' && q !== 'SXXX') : [];
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: entriesToRender.map(({ qNo: qNo, idx: idx }, renderIndex)=>{
                const isUnallocated = qNo === 'DXXX' || qNo === 'SXXX';
                const { sectionOnly: sectionOnly, questionDesc: questionDesc } = isUnallocated ? {
                    sectionOnly: '',
                    questionDesc: ''
                } : getSectionName(module, qNo, file, key) || {
                    sectionOnly: '',
                    questionDesc: ''
                };
                const sectionDisplay = !isUnallocated && allocatedSection && allocatedSection !== 'Unknown' ? `${qNo} ${allocatedSection}` : `${qNo}${sectionOnly ? ' ' + sectionOnly : ''}`;
                const scoreColor = isUnallocated ? '#dc2626' : scoreVal == null ? '#9CA3AF' : scoreVal >= 8 ? '#16a34a' : scoreVal >= 6 ? '#d97706' : '#dc2626';
                const scoreLabel = isUnallocated ? 'Low confidence' : scoreVal == null ? 'Low' : scoreVal >= 8 ? 'High' : scoreVal >= 6 ? 'Medium' : 'Low';
                const showBadge = isUnallocated ? scoreVal != null || reasoning || suggestedQNo : true;
                const popoverData = {
                    key: key,
                    qNo: qNo,
                    fileName: fileName,
                    reasoning: reasoning,
                    scoreVal: scoreVal,
                    scoreColor: scoreColor,
                    scoreLabel: scoreLabel,
                    isUnallocated: isUnallocated,
                    suggestedQNo: suggestedQNo,
                    suggestedSection: suggestedSection,
                    suggestedQuestion: suggestedQuestion
                };
                const rowBg = isUnallocated ? '#FFF5F5' : 'white';
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                    style: {
                        borderBottom: '1px solid #F3F4F6',
                        background: rowBg
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            style: {
                                padding: '12px 16px',
                                verticalAlign: 'middle',
                                width: '22%'
                            },
                            children: renderIndex === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '8px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            background: '#40dda1',
                                            flexShrink: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        title: fileName,
                                        onClick: ()=>handleFilePreview(file),
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 500,
                                            color: '#4A67FF',
                                            cursor: 'pointer',
                                            textDecoration: 'underline',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            maxWidth: 185
                                        },
                                        children: fileName
                                    })
                                ]
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            style: {
                                padding: '12px 16px',
                                verticalAlign: 'middle',
                                textAlign: 'left',
                                width: '20%'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic fww",
                                style: {
                                    gap: 4
                                },
                                children: [
                                    isUnallocated ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>isInProgress && handleEditDispatch({
                                                key: key,
                                                fileName: file.originalname,
                                                from: 'fileReport',
                                                actionType: 'move',
                                                fileData: file,
                                                index: String(idx)
                                            }),
                                        style: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#F3F4F6',
                                            border: 'none',
                                            borderRadius: 50,
                                            padding: '5px 12px',
                                            cursor: isInProgress ? 'pointer' : 'default',
                                            fontSize: 12,
                                            fontWeight: 400,
                                            color: '#6B7280',
                                            maxWidth: 170
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: "Select section"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                                                style: {
                                                    fontSize: 16,
                                                    color: '#9CA3AF',
                                                    flexShrink: 0
                                                }
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        title: sectionDisplay || 'Unknown',
                                        onClick: ()=>isInProgress && handleEditDispatch({
                                                key: key,
                                                fileName: file.title || file.originalname,
                                                from: 'fileReport',
                                                actionType: 'move',
                                                fileData: file,
                                                index: idx
                                            }),
                                        style: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 4,
                                            background: '#E8EBF5',
                                            border: 'none',
                                            borderRadius: 50,
                                            padding: '5px 12px',
                                            cursor: isInProgress ? 'pointer' : 'default',
                                            fontSize: 12,
                                            fontWeight: 500,
                                            color: '#374151',
                                            maxWidth: 170
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: sectionDisplay || 'Unknown'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                                                style: {
                                                    fontSize: 16,
                                                    color: '#6B7280',
                                                    flexShrink: 0
                                                }
                                            })
                                        ]
                                    }),
                                    extraSections.map((extraQNo, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            "data-tooltip": extraQNo,
                                            style: {
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                background: '#E8EBF5',
                                                borderRadius: 50,
                                                padding: '3px 8px',
                                                fontSize: 10,
                                                fontWeight: 600,
                                                color: '#374151',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: [
                                                "+",
                                                extraQNo
                                            ]
                                        }, i))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            style: {
                                padding: '12px 16px',
                                verticalAlign: 'middle',
                                fontSize: 12,
                                width: '32%',
                                textAlign: 'left'
                            },
                            children: isUnallocated ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: '#9CA3AF'
                                },
                                children: "-"
                            }) : questionDesc ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    display: 'block',
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    lineHeight: 1.6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontWeight: 600,
                                            color: '#002D63',
                                            marginRight: 6
                                        },
                                        children: qNo
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontWeight: 400,
                                            color: '#4B5563'
                                        },
                                        children: questionDesc
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: '#9CA3AF'
                                },
                                children: "-"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            style: {
                                padding: '12px 16px',
                                verticalAlign: 'middle',
                                width: '14%'
                            },
                            children: showBadge ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                onMouseEnter: (e)=>{
                                    const r = e.currentTarget.getBoundingClientRect();
                                    setAiPopover((p)=>p?.pinned ? p : {
                                            ...popoverData,
                                            x: r.left,
                                            y: r.bottom,
                                            pinned: false
                                        });
                                },
                                onMouseLeave: ()=>setAiPopover((p)=>p?.pinned ? p : null),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    const r = e.currentTarget.getBoundingClientRect();
                                    setAiPopover((p)=>p?.pinned && p.key === key && p.qNo === qNo ? null : {
                                            ...popoverData,
                                            x: r.left,
                                            y: r.bottom,
                                            pinned: true
                                        });
                                },
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    background: scoreColor + '18',
                                    border: '1px solid ' + scoreColor + '40',
                                    borderRadius: 12,
                                    padding: '3px 9px',
                                    cursor: 'pointer'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("bi4Ns")),
                                        alt: "icon",
                                        style: {
                                            width: 20,
                                            height: 20
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: scoreColor
                                        },
                                        children: scoreVal || '?'
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: '#dc2626'
                                },
                                children: "?"
                            })
                        }),
                        isInProgress && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            style: {
                                padding: '12px 16px',
                                verticalAlign: 'middle',
                                width: '12%'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($317086ac24816082$var$Send, {
                                        "data-tooltip": "Move",
                                        className: "cp",
                                        onClick: ()=>handleEditDispatch({
                                                key: key,
                                                fileName: file.title || file.originalname,
                                                from: 'fileReport',
                                                actionType: 'move',
                                                fileData: file,
                                                index: idx
                                            }),
                                        style: {
                                            color: '#6B7280',
                                            fontSize: '1.1rem'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cee5c542a37a6fe$export$2e2bcd8739ae039), {
                                        "data-tooltip": "Delete",
                                        onClick: ()=>removeSectionFromImport(key, idx),
                                        className: "cp",
                                        style: {
                                            color: '#FC7785',
                                            fontSize: '1.1rem'
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }, `${key}-${idx}`);
            })
        });
    };
    const onClickReallocationComplete = async ()=>{
        if (!fileReport) return;
        const fileReportData = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };
        const moduleName = tab && tab !== "" ? tab : autoFillContext?.moduleType || '';
        const effectiveCompany = company || reduxCompany;
        const companyId = effectiveCompany?._id || autoFillContext?.companyId;
        const moduleId = autoFillContext?.moduleId;
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(fileReportData));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'processing',
            percent: 0
        }));
        const useModulesAllocate = !!moduleId;
        const resp = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(useModulesAllocate ? `/modules/allocateFiles` : `/company/allocateFiles`, useModulesAllocate ? {
            companyId: companyId,
            moduleId: moduleId,
            fileReport: fileReportData,
            fromAutoFill: !!autoFillContext?.enabled
        } : {
            companyId: companyId,
            tab: moduleName,
            fileReport: fileReportData,
            fromAutoFill: !!autoFillContext?.enabled,
            sectionCode: autoFillContext?.sectionCode || null
        }, true);
        if (!resp || resp.code === 400) return;
        if (resp.body?.report) dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(resp.body.report));
        const savedQuestions = resp.body?.savedQuestions;
        if (useModulesAllocate && savedQuestions?.length) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: {
                moduleId: String(moduleId),
                savedQuestions: savedQuestions
            }
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp['message']);
        if (modal.autoFillWithFilling) handleSkipUpload();
        else if (useModulesAllocate) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            autoFillStatusBarVisible: false,
            autoFillStatusBarPhase: '',
            autoFillJustCompleted: true
        }));
    };
    const onClickFileImportAuditLog = async (fileReportId)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportLogs/${fileReportId}`);
        (0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'fileReportAuditLog'
        }));
    };
    // ── Handlers ──
    const handleCancel = async ()=>{
        // Abort any in-flight file upload XHRs immediately
        activeXhrsRef.current.forEach((xhr)=>{
            try {
                xhr.abort();
            } catch (_) {}
        });
        activeXhrsRef.current = [];
        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/cancel', {}).catch(()=>{});
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            autoFillStatusBarVisible: false,
            autoFillStatusBarPhase: ''
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill cancelled');
    };
    const handleMinimize = ()=>{
        const phaseMap = {
            uploading: 'uploading',
            indexing: 'indexing',
            allocation: 'allocated',
            processing: 'processingFiles',
            filling: 'filling',
            researchAid: 'researchAid'
        };
        // Persist selectedModules into Redux so withOtherModules stays true after re-open
        if (selectedModules && selectedModules.size > 0) {
            const currentModuleType = autoFillContext?.moduleType;
            const extraMods = [
                ...selectedModules
            ].filter((m)=>m !== currentModuleType);
            if (extraMods.length > 0) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                autoFillContext: {
                    ...autoFillContext,
                    extraModules: extraMods
                }
            }));
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            autoFillStatusBarVisible: true,
            autoFillStatusBarPhase: phaseMap[phase] || phase
        }));
    };
    // ── File select step handlers ──
    const MAX_AUTOFILL_FILES = 300;
    const handleFileSelect = async (e)=>{
        const selectedFiles = Array.from(e.target.files);
        if (selectedFiles.length === 0) return;
        if (selectedFiles.length > MAX_AUTOFILL_FILES) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You can upload a maximum of ${MAX_AUTOFILL_FILES} files at once`, 'error');
            e.target.value = '';
            return;
        }
        // Sync module selection from local state into Redux before proceeding
        const currentModuleType = autoFillContext?.moduleType;
        const selectedExtraModules = selectedModules ? [
            ...selectedModules
        ].filter((m)=>m !== currentModuleType) : autoFillContext?.extraModules || [];
        // Reason: a brand-new run must not inherit an earlier run's resume pointer — it would make the status bar's Resume open the old run and could re-fire the resume effect
        if (autoFillContext?.resume || selectedExtraModules.length !== (autoFillContext?.extraModules || []).length || selectedExtraModules.some((m, i)=>m !== (autoFillContext?.extraModules || [])[i]) || generateReports !== !!autoFillContext?.generateReports) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                ...autoFillContext,
                extraModules: selectedExtraModules,
                generateReports: generateReports,
                resume: null
            }
        }));
        const totalFiles = selectedFiles.length;
        let filesInfo = [];
        let relPaths = [];
        try {
            // Reason: autoFillUploadProgress is the only upload state the minimized status bar reads (and what
            // its maximize handler restores totalFiles/filesUploaded from) — keep it in sync with the modal fields
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: 'uploading',
                percent: 0,
                fileName: '',
                totalFiles: totalFiles,
                filesUploaded: 0,
                filesFailed: 0,
                autoFillStatusBarPhase: 'uploading',
                autoFillUploadProgress: {
                    percent: 0,
                    fileName: '',
                    total: totalFiles,
                    current: 0
                }
            }));
            relPaths = selectedFiles.map((f)=>f.webkitRelativePath || '');
            const companyId = autoFillContext?.companyId;
            const moduleType = autoFillContext?.moduleType;
            const moduleId = autoFillContext?.moduleId || null;
            const sectionCode = autoFillContext?.sectionCode;
            const scope2 = autoFillContext?.scope;
            const scopeName2 = autoFillContext?.scopeName || '';
            const isTempModule = !!moduleId;
            const uploadFileUrl = isTempModule ? '/modules/uploadFile' : '/company/uploadFile';
            const uploadFilesUrl = isTempModule ? '/modules/uploadFiles' : '/company/uploadFiles';
            let uploaded = 0;
            let failed = 0;
            // Upload in batches of 20 concurrently — balances speed vs. progress bar clarity
            const BATCH_SIZE = 20;
            activeXhrsRef.current = [];
            for(let b = 0; b < selectedFiles.length; b += BATCH_SIZE){
                const batch = selectedFiles.slice(b, b + BATCH_SIZE);
                const batchStart = b;
                const slotProgress = new Array(batch.length).fill(0);
                // peakPercent ensures the bar never goes backwards when faster slots finish ahead of slower ones
                let peakPercent = Math.round(batchStart / totalFiles * 100);
                const results = await Promise.all(batch.map((file, slotIdx)=>{
                    const payload = isTempModule ? {
                        attachment: [
                            file
                        ],
                        companyId: companyId,
                        moduleId: moduleId,
                        moduleType: moduleType,
                        totalFiles: totalFiles,
                        sectionCode: sectionCode || '',
                        scope: scope2,
                        scopeName: scopeName2
                    } : {
                        attachment: [
                            file
                        ],
                        companyId: companyId,
                        moduleType: moduleType,
                        totalFiles: totalFiles,
                        sectionCode: sectionCode || '',
                        scope: scope2,
                        scopeName: scopeName2
                    };
                    return $317086ac24816082$var$uploadFileWithProgress(uploadFileUrl, payload, (pct)=>{
                        slotProgress[slotIdx] = pct;
                        const completedFiles = batchStart + slotProgress.reduce((sum, p)=>sum + p / 100, 0);
                        const next = Math.round(completedFiles / totalFiles * 100);
                        if (next > peakPercent) {
                            peakPercent = next;
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                percent: next,
                                fileName: file.name,
                                autoFillUploadProgress: {
                                    percent: next,
                                    fileName: file.name,
                                    total: totalFiles,
                                    current: uploaded
                                }
                            }));
                        }
                    }, (xhr)=>{
                        activeXhrsRef.current.push(xhr);
                    }).then((res)=>({
                            ok: true,
                            res: res
                        })).catch(()=>({
                            ok: false
                        }));
                }));
                results.forEach(({ ok: ok, res: res })=>{
                    if (ok) {
                        uploaded++;
                        if (res?.body?.reports) filesInfo.push(...res.body.reports);
                        else if (res?.body?.report) filesInfo.push(res.body.report);
                    } else failed++;
                });
                const batchPercent = Math.round((batchStart + batch.length) / totalFiles * 100);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    percent: batchPercent,
                    filesUploaded: uploaded,
                    filesFailed: failed,
                    autoFillUploadProgress: {
                        percent: batchPercent,
                        fileName: '',
                        total: totalFiles,
                        current: uploaded
                    }
                }));
            }
            // Hold at 100% for 5 seconds so the user can see the completed state
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                percent: 100,
                filesUploaded: uploaded,
                filesFailed: failed,
                autoFillUploadProgress: {
                    percent: 100,
                    fileName: '',
                    total: totalFiles,
                    current: uploaded
                }
            }));
            await new Promise((resolve)=>setTimeout(resolve, 2500));
            e.target.value = '';
            // Reset all indexing/allocation state + animation queue before entering indexing phase
            clearTimeout(indexingAnimationTimerRef.current);
            indexingQueueRef.current = [];
            indexingAnimatingRef.current = false;
            setIndexingProgress({
                total: 0,
                current: 0,
                currentFile: ''
            });
            setAllocationProgress({
                total: 0,
                current: 0,
                fileName: '',
                matchedQNo: '',
                matchedQuestion: ''
            });
            setProcessedFileChips([]);
            setUnallocatedCount(0);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: 'indexing',
                autoFillStatusBarPhase: 'indexing',
                autoFillStatusBarVisible: true
            }));
            const extraMods = selectedModules ? [
                ...selectedModules
            ].filter((m)=>m !== moduleType) : autoFillContext?.extraModules || [];
            // Reason: generateReports is persisted in the run's scope so a resume after a crash still knows the research-reports tick
            const uploadFilesRes = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(uploadFilesUrl, isTempModule ? {
                files: filesInfo,
                companyId: companyId,
                moduleId: moduleId,
                tab: moduleType,
                relPaths: relPaths,
                fromAutoFill: true,
                generateReports: !!generateReports,
                asyncResponse: true,
                ...scope2 === 'section' && sectionCode ? {
                    sectionCode: sectionCode
                } : {}
            } : {
                files: filesInfo,
                companyId: companyId,
                tab: moduleType,
                relPaths: relPaths,
                fromAutoFill: !!autoFillContext?.enabled,
                extraModules: extraMods,
                generateReports: !!generateReports,
                asyncResponse: true,
                ...scope2 === 'section' && sectionCode ? {
                    sectionCode: sectionCode
                } : {}
            }, true);
            if (uploadFilesRes?.body?.cancelled) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarVisible: false,
                    autoFillStatusBarPhase: ''
                }));
                return;
            }
            if (!uploadFilesRes?.body?.report) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarPhase: 'error'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('File upload failed');
                return;
            }
            // Reason: the server now replies as soon as processing starts; allocation:completed (socket) advances the stepper from here
            if (uploadFilesRes.body.async) return;
            const fileReportResult = uploadFilesRes.body.report;
            const allocated = Object.keys(fileReportResult.importResult || {}).filter((key)=>fileReportResult.importResult[key]?.section?.some((el)=>!el.includes("DXXX") && !el.includes("SXXX"))).length;
            const total = Object.keys(fileReportResult.importResult || {}).length;
            const score = total === 0 ? 0 : Math.round(allocated / total * 100);
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: fileReportResult,
                currentScore: score,
                tab: moduleType,
                autoFillContext: {
                    ...store.getState().fileAllocation.autoFillContext
                }
            }));
            const isMinimizedNow = store.getState().modal.autoFillStatusBarVisible;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                ...isMinimizedNow ? {} : {
                    open: 'autoFillStepper'
                },
                autoFillStepperPhase: 'allocation',
                autoFillStatusBarVisible: false,
                autoFillStatusBarPhase: 'allocated'
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(uploadFilesRes.message || 'Files allocated - tap to review');
        } catch (error) {
            console.error('Upload error:', error);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Upload failed. Please try again.');
            e.target.value = '';
        }
    };
    // Fire-and-forget: generates the complete set of 5 research reports (backend runs 4 in parallel + SWOT last).
    // fromAutoFill makes the backend generate from company description even when a report type has no files/focus
    // areas; the endpoint returns 200 regardless, so judge the outcome from body.results, not the status code.
    // onDone fires once the backend call resolves — used to advance past the Research Aid step once it's showing.
    // Ref used (not state) so the promise's completion handlers always see the latest onDone, since the caller can
    // attach it later (after Filling Answers/Other Modules finish) without re-triggering the HTTP call itself.
    const reportsGenDoneRef = (0, $acw62.useRef)(null);
    // Reason: fires the HTTP call only — no navigation — so it can run silently in the background from the very
    // start of Filling Answers, overlapping with the (typically much longer) auto-fill process instead of
    // waiting until after it. The dedicated Research Aid screen is only shown later if generation is still running.
    const startReportsGeneration = (companyId)=>{
        setReportsGenStatus('generating');
        const initialCards = {};
        $317086ac24816082$var$REPORT_TYPES.forEach((rt)=>{
            initialCards[rt] = {
                status: 'pending'
            };
        });
        setReportCards(initialCards);
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                ...autoFillContext,
                reportsGenStatus: 'generating'
            }
        }));
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/generateAllReports', {
            companyId: companyId,
            fromAutoFill: true
        }).then((res)=>{
            const results = res?.body?.results || [];
            const success = results.filter((r)=>r.status === 'success').length;
            setReportsGenCounts({
                success: success,
                total: results.length
            });
            // Reason: reconcile with the HTTP result as a safety net for any card whose socket event never arrived
            // (e.g. dropped while the modal was closed) — preserves any score already captured live via sockets
            setReportCards((prev)=>{
                const next = {
                    ...prev
                };
                results.forEach((r)=>{
                    next[r.reportType] = {
                        status: r.status === 'success' ? 'done' : 'failed',
                        score: prev[r.reportType]?.score,
                        reportId: r.reportId,
                        error: r.reason || r.error
                    };
                });
                return next;
            });
            const finalStatus = res?.code !== 200 || success === 0 ? 'error' : success === results.length ? 'done' : 'partial';
            setReportsGenStatus(finalStatus);
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                autoFillContext: {
                    ...store.getState().fileAllocation.autoFillContext,
                    reportsGenStatus: finalStatus
                }
            }));
            if (finalStatus === 'error') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Research report generation failed', 'error');
            else if (finalStatus === 'done') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Research reports generated');
            else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`${success} of ${results.length} research reports generated`);
            reportsGenDoneRef.current?.();
        }).catch(()=>{
            setReportsGenStatus('error');
            setReportCards((prev)=>{
                const next = {
                    ...prev
                };
                $317086ac24816082$var$REPORT_TYPES.forEach((rt)=>{
                    if (!next[rt] || next[rt].status === 'pending' || next[rt].status === 'generating') next[rt] = {
                        ...next[rt],
                        status: 'failed'
                    };
                });
                return next;
            });
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                autoFillContext: {
                    ...store.getState().fileAllocation.autoFillContext,
                    reportsGenStatus: 'error'
                }
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Research report generation failed', 'error');
            reportsGenDoneRef.current?.();
        });
    };
    // Reason: called once Filling Answers/Other Modules finish. If report generation (kicked off at the start of
    // Filling Answers) already finished, skip straight to Result. If it's still running, show the dedicated
    // Research Aid step with live progress and only advance to Result once it completes.
    const proceedToResultOrWaitForReports = (shouldGenerateReports, showResult)=>{
        const currentStatus = store.getState().fileAllocation.autoFillContext?.reportsGenStatus || reportsGenStatus;
        if (!shouldGenerateReports || currentStatus && currentStatus !== 'generating') {
            showResult();
            return;
        }
        reportsGenDoneRef.current = showResult;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'researchAid',
            autoFillStatusBarPhase: 'researchAid'
        }));
    };
    const handleSkipUpload = ()=>{
        // Capture the tickbox now — local state resets if the user minimizes while filling runs
        // Reason: on a resume the tickbox UI never renders, so the saved scope (restored into context) is the only record of the tick
        const shouldGenerateReports = generateReports || !!autoFillContext?.generateReports;
        setReportsGenStatus('');
        // Sync module selection from local state into Redux before proceeding
        const currentModuleType = autoFillContext?.moduleType;
        const selectedExtraModules = selectedModules ? [
            ...selectedModules
        ].filter((m)=>m !== currentModuleType) : autoFillContext?.extraModules || [];
        if (selectedExtraModules.length !== (autoFillContext?.extraModules || []).length || selectedExtraModules.some((m, i)=>m !== (autoFillContext?.extraModules || [])[i]) || shouldGenerateReports !== !!autoFillContext?.generateReports) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                ...autoFillContext,
                extraModules: selectedExtraModules,
                generateReports: shouldGenerateReports
            }
        }));
        const companyId = autoFillContext?.companyId;
        const moduleType = currentModuleType;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'filling',
            autoFillModuleName: modal.autoFillModuleName || '',
            autoFillTotal: 0,
            autoFillCurrent: 0,
            autoFillCurrentQuestion: '',
            autoFillCompleted: false,
            autoFillProcessed: 0,
            autoFillAnswered: 0,
            autoFillNeedsReview: 0,
            autoFillSkipped: 0,
            autoFillStatusBarPhase: 'filling'
        }));
        // Reason: kick off report generation in the background right as filling starts, instead of after Other
        // Modules finishes — overlaps the (much shorter) report generation with the rest of the autofill process
        if (shouldGenerateReports) startReportsGeneration(companyId);
        const moduleId = autoFillContext?.moduleId || null;
        // Issue 32 — resume:true makes the backend skip questions the interrupted run already attempted (and human-answered ones)
        const payload = {
            companyId: companyId,
            moduleType: moduleType,
            minConfidence: 0.7,
            extraModules: selectedExtraModules,
            ...moduleId ? {
                moduleId: moduleId
            } : {},
            ...fileReport?._id ? {
                fileReportId: fileReport._id
            } : {},
            ...autoFillContext?.resume ? {
                resume: true
            } : {}
        };
        const scope2 = autoFillContext?.scope;
        const sectionCode = autoFillContext?.sectionCode;
        if (scope2 === 'section' && sectionCode) payload.sectionCode = sectionCode;
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill', payload).then(async (response)=>{
            if (response?.code === 200) {
                const { answered: answered, needsReview: needsReview, skipped: skipped, processed: processed, results: results } = response?.body || {};
                setFillResults(results || []);
                const extraModules = selectedExtraModules;
                if (extraModules.length > 0) {
                    // Reason: the company payload never contains `tempModules` (server sends `checklistModules`),
                    // so resolve each extra module's TempModule id via the same by-name endpoint useModuleData uses.
                    // Without an id the backend silently fills the legacy Question/Answer models, which the new
                    // dashboard never reads. IR intentionally stays on the legacy collections (no moduleId).
                    const moduleIds = {};
                    if (moduleId) await Promise.all(extraModules.map(async (m)=>{
                        if (m === 'repository' || m === 'Investment Readiness') return;
                        let lookupName = m;
                        if (lookupName.includes('directors-questionnaire_')) lookupName = 'directors-questionnaire';
                        else if (lookupName.includes('business-audit')) lookupName = lookupName.replace(`-${company?.testType}`, '');
                        try {
                            const r = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${encodeURIComponent(lookupName)}`);
                            const mod = r?.body;
                            if (r?.code === 200 && mod?._id && !mod.isInvestmentReadiness && !mod.isInvestorMatch) moduleIds[m] = mod._id;
                            else console.warn("[autoFill] No TempModule resolved for extra module \u2014 falling back to legacy models:", m, r?.message || '');
                        } catch (err) {
                            console.warn('[autoFill] TempModule lookup failed for extra module:', m, err?.message || err);
                        }
                    }));
                    setCrossFileCompleted({});
                    setOtherModulesCompleted({});
                    // Fetch upfront question counts for the source module + every extra module, for the "N questions across M modules" subtitle
                    (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/module-question-counts', {
                        companyId: autoFillContext.companyId,
                        modules: [
                            {
                                moduleType: moduleType,
                                moduleId: moduleId
                            },
                            ...extraModules.map((m)=>({
                                    moduleType: m,
                                    moduleId: moduleIds[m] || null
                                }))
                        ]
                    }).then((res)=>{
                        const counts = res?.body?.counts || [];
                        setModuleQuestionCounts(Object.fromEntries(counts.map((c)=>[
                                c.moduleType,
                                c.totalQuestions
                            ])));
                    }).catch(()=>{});
                    // Step 5: Cross File Uploading — copy files into mapped questions
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'autoFillStepper',
                        autoFillStepperPhase: 'crossFileUpload',
                        autoFillStatusBarPhase: 'otherModules',
                        autoFillProcessed: processed || 0,
                        autoFillAnswered: answered || 0,
                        autoFillNeedsReview: needsReview || 0,
                        autoFillSkipped: skipped || 0
                    }));
                    (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/fill-other-modules', {
                        companyId: autoFillContext.companyId,
                        sourceModuleType: autoFillContext.moduleType,
                        targetModules: extraModules,
                        moduleIds: moduleIds
                    }).then(async ()=>{
                        // Step 6: Other Modules — full AI autofill on each selected module
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: 'autoFillStepper',
                            autoFillStepperPhase: 'otherModules',
                            autoFillStatusBarPhase: 'otherModules'
                        }));
                        const extraModuleResults = {};
                        for (const modKey of extraModules){
                            const modId = moduleIds[modKey] || null;
                            setOtherModulesProgress((prev)=>({
                                    ...prev,
                                    moduleType: modKey,
                                    total: 0,
                                    current: 0,
                                    currentQuestion: '',
                                    currentQuestionText: '',
                                    sourceFiles: []
                                }));
                            try {
                                const aiRes = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill', {
                                    companyId: autoFillContext.companyId,
                                    moduleType: modKey,
                                    minConfidence: 0.7,
                                    costPhase: 'otherModules',
                                    ...modId ? {
                                        moduleId: modId
                                    } : {},
                                    ...fileReport?._id ? {
                                        fileReportId: fileReport._id
                                    } : {},
                                    ...autoFillContext?.resume ? {
                                        resume: true
                                    } : {}
                                });
                                const body = aiRes?.body || {};
                                extraModuleResults[modKey] = body;
                                setOtherModulesCompleted((prev)=>({
                                        ...prev,
                                        [modKey]: {
                                            answered: body.answered || 0,
                                            skipped: body.skipped || 0,
                                            needsReview: body.needsReview || 0,
                                            results: body.results || []
                                        }
                                    }));
                            } catch (_) {
                                extraModuleResults[modKey] = {
                                    answered: 0,
                                    skipped: 0,
                                    needsReview: 0
                                };
                                setOtherModulesCompleted((prev)=>({
                                        ...prev,
                                        [modKey]: {
                                            answered: 0,
                                            skipped: 0,
                                            needsReview: 0,
                                            results: []
                                        }
                                    }));
                            }
                        }
                        const fileReportId = fileReport?._id;
                        if (fileReportId) {
                            const allModules = [
                                {
                                    moduleType: moduleType,
                                    answered: answered || 0,
                                    skipped: skipped || 0,
                                    needsReview: needsReview || 0
                                },
                                ...extraModules.map((m)=>({
                                        moduleType: m,
                                        answered: extraModuleResults[m]?.answered || 0,
                                        skipped: extraModuleResults[m]?.skipped || 0,
                                        needsReview: extraModuleResults[m]?.needsReview || 0
                                    }))
                            ];
                            const totalAnswered = allModules.reduce((s, m)=>s + m.answered, 0);
                            const totalSkipped = allModules.reduce((s, m)=>s + m.skipped, 0);
                            const totalNeedsReview = allModules.reduce((s, m)=>s + m.needsReview, 0);
                            (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/save-autofill-summary', {
                                fileReportId: fileReportId,
                                processed: totalAnswered + totalSkipped + totalNeedsReview,
                                answered: totalAnswered,
                                skipped: totalSkipped,
                                needsReview: totalNeedsReview,
                                modules: allModules
                            }).catch(()=>{});
                        }
                        // Reason: report generation was already kicked off in the background at the start of Filling
                        // Answers — only show the Research Aid step if it's still running by now; otherwise go straight to Result
                        const showResult = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'autoFillStepper',
                                autoFillStepperPhase: 'result',
                                autoFillCompleted: true,
                                autoFillProcessed: processed || 0,
                                autoFillAnswered: answered || 0,
                                autoFillNeedsReview: needsReview || 0,
                                autoFillSkipped: skipped || 0,
                                autoFillStatusBarPhase: 'completed'
                            }));
                        proceedToResultOrWaitForReports(shouldGenerateReports, showResult);
                    }).catch(()=>{
                        const showResult = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'autoFillStepper',
                                autoFillStepperPhase: 'result',
                                autoFillCompleted: true,
                                autoFillProcessed: processed || 0,
                                autoFillAnswered: answered || 0,
                                autoFillNeedsReview: needsReview || 0,
                                autoFillSkipped: skipped || 0,
                                autoFillStatusBarPhase: 'completed'
                            }));
                        proceedToResultOrWaitForReports(shouldGenerateReports, showResult);
                    });
                } else {
                    const fileReportId = fileReport?._id;
                    if (fileReportId) (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/save-autofill-summary', {
                        fileReportId: fileReportId,
                        processed: processed || 0,
                        answered: answered || 0,
                        skipped: skipped || 0,
                        needsReview: needsReview || 0,
                        modules: [
                            {
                                moduleType: moduleType,
                                answered: answered || 0,
                                skipped: skipped || 0,
                                needsReview: needsReview || 0
                            }
                        ]
                    }).catch(()=>{});
                    const showResult = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: 'autoFillStepper',
                            autoFillStepperPhase: 'result',
                            autoFillCompleted: true,
                            autoFillProcessed: processed || 0,
                            autoFillAnswered: answered || 0,
                            autoFillNeedsReview: needsReview || 0,
                            autoFillSkipped: skipped || 0,
                            autoFillStatusBarPhase: 'completed'
                        }));
                    proceedToResultOrWaitForReports(shouldGenerateReports, showResult);
                }
            } else {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarPhase: 'error'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Auto-fill failed');
            }
        }).catch(()=>{
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                autoFillStatusBarPhase: 'error'
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill failed. Please try again.');
        });
    };
    // Issue 32 — Resume from Filing Assistant History: the history modal opens this stepper with
    // autoFillContext.resume = { fileReportId, step, src } and the phase already set to where the run died.
    // This effect fires the right backend call ONCE; the existing socket listeners then drive the normal progress UI.
    // steps 'allocated'/'attaching' need no kick-off — the stepper opens straight at the Allocation Review screen.
    (0, $acw62.useEffect)(()=>{
        const resumeCtx = autoFillContext?.resume;
        if (!isOpen || !resumeCtx?.fileReportId || resumeStartedRef.current === resumeCtx.fileReportId) return;
        resumeStartedRef.current = resumeCtx.fileReportId;
        if (resumeCtx.step === 'allocation') (async ()=>{
            const isTempSrc = resumeCtx.src === 'modules';
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(isTempSrc ? '/modules/uploadFiles' : '/company/uploadFiles', {
                companyId: autoFillContext?.companyId,
                resume: true,
                fileReportId: resumeCtx.fileReportId,
                asyncResponse: true,
                ...isTempSrc ? {
                    moduleId: autoFillContext?.moduleId
                } : {
                    tab: autoFillContext?.moduleType,
                    ...autoFillContext?.moduleId ? {
                        moduleId: autoFillContext.moduleId
                    } : {}
                }
            }, true).catch(()=>null);
            if (res?.body?.cancelled) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarVisible: false,
                    autoFillStatusBarPhase: ''
                }));
                return;
            }
            if (res?.code !== 200 || !res?.body?.report) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarVisible: false,
                    autoFillStatusBarPhase: 'error'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Resume failed during allocation', 'error');
                return;
            }
            // The allocation:completed socket event advances indexing → review; fall back to the HTTP response if it was missed
            if (res.body.async) return; // server replied up front — allocation:completed (socket) advances the stepper
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: res.body.report
            }));
            const st = store.getState().modal;
            if (st.open === 'autoFillStepper' && st.autoFillStepperPhase === 'indexing') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: 'allocation',
                autoFillStatusBarPhase: 'allocated'
            }));
        })();
        else if ([
            'attached',
            'filing-answers',
            'other-modules'
        ].includes(resumeCtx.step)) handleSkipUpload();
    }, [
        isOpen,
        autoFillContext?.resume?.fileReportId
    ]);
    // ── Estimated time remaining (hooks — must run before the early return below) ──
    // Reason: progress events can be many seconds apart, so re-render on a timer to keep the countdown fresh between them
    const [, setEtaTick] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (![
            'indexing',
            'filling',
            'otherModules'
        ].includes(phase)) return;
        const id = setInterval(()=>setEtaTick((t)=>t + 1), 1000);
        return ()=>clearInterval(id);
    }, [
        phase
    ]);
    // Indexing & Analyzing is ONE step with two stages (read files, then AI-match them) — a single ETA over combined
    // work units stops it hitting "Almost done" at the end of indexing and restarting for allocation.
    // Reason: allocation units are weighted 3x — AI matching takes roughly 3x longer per file than reading, so the
    // estimate stays sane during indexing before any real allocation timings exist, then the rolling window corrects it.
    const ALLOC_UNIT_WEIGHT = 3;
    const idxTotal = indexingProgress.total || allocationProgress.total || 0;
    const allocTotal = allocationProgress.total || idxTotal;
    const stepUnitsTotal = idxTotal + ALLOC_UNIT_WEIGHT * allocTotal;
    // Once allocation has started, indexing is complete regardless of what its animated counter shows
    const idxDone = allocationProgress.total > 0 ? idxTotal : Math.min(indexingProgress.current || 0, idxTotal);
    const stepUnitsDone = idxDone + ALLOC_UNIT_WEIGHT * (allocationProgress.current || 0);
    const indexingStepPct = stepUnitsTotal > 0 ? Math.round(stepUnitsDone / stepUnitsTotal * 100) : 0;
    // One ETA hook for every stage — it is fed whichever stage is running (see useEta for the rule)
    const allocationStarted = allocationProgress.total > 0 || indexingProgress.total > 0 && (indexingProgress.current || 0) >= indexingProgress.total;
    const omStripped = (otherModulesProgress.moduleType || '').replace(/_[a-f0-9]{24}$/, '');
    const omLaterItems = (autoFillContext?.extraModules || []).reduce((s, m)=>otherModulesCompleted[m] || m === otherModulesProgress.moduleType || m === omStripped ? s : s + (moduleQuestionCounts[m] || 0), 0);
    const etaInput = phase === 'indexing' ? allocationStarted ? {
        stageKey: 'allocation',
        current: allocationProgress.current,
        total: allocTotal,
        batchSize: allocationProgress.batchSize,
        priorWeight: ALLOC_UNIT_WEIGHT
    } : {
        stageKey: 'indexing',
        current: indexingProgress.current,
        total: idxTotal,
        batchSize: indexingProgress.batchSize,
        laterItems: idxTotal,
        laterWeight: ALLOC_UNIT_WEIGHT
    } : phase === 'filling' ? {
        stageKey: 'filling',
        current: modal.autoFillCurrent,
        total: modal.autoFillTotal,
        batchSize: modal.autoFillBatchSize,
        countsStarted: true
    } : phase === 'otherModules' ? {
        stageKey: `otherModules:${otherModulesProgress.moduleType}`,
        current: otherModulesProgress.current,
        total: otherModulesProgress.total,
        batchSize: otherModulesProgress.batchSize,
        priorWeight: 1,
        laterItems: omLaterItems,
        countsStarted: true
    } : null;
    const stepEta = $317086ac24816082$var$useEta({
        isActive: !!etaInput && (etaInput.total || 0) > 0,
        ...etaInput || {}
    });
    const indexingStepEta = phase === 'indexing' ? stepEta : null;
    const fillingEta = phase === 'filling' ? stepEta : null;
    const otherModulesEta = phase === 'otherModules' ? stepEta : null;
    if (!isOpen) return null;
    const isFullScreen = [
        'uploadDocs',
        'uploading',
        'indexing',
        'allocation',
        'processing',
        'filling',
        'crossFileUpload',
        'otherModules',
        'researchAid',
        'result'
    ].includes(phase);
    // Only switch indexing display to allocation mode once the indexing queue has fully drained
    const showAllocationData = allocationProgress.total > 0 && (indexingProgress.total === 0 || indexingProgress.current >= indexingProgress.total);
    // Reports checkbox may be ticked locally (still on select/upload steps) or already persisted to autoFillContext (once filling has started)
    const willGenerateReports = !!(generateReports || autoFillContext?.generateReports || reportsGenStatus);
    // Import Files/Folders stops after allocation is saved — only the Auto-fill flow answers questions,
    // so the filling and reports steps are hidden for a plain import rather than shown and never reached.
    const sidebarSteps = [
        {
            key: 'uploadDocs',
            label: 'Upload Documents',
            badge: 'You'
        },
        {
            key: 'uploading',
            label: 'File Uploading',
            badge: 'AI'
        },
        {
            key: 'indexing',
            label: 'Indexing & Analyzing',
            badge: 'AI'
        },
        {
            key: 'allocation',
            label: 'Allocation Review',
            badge: 'You'
        },
        {
            key: 'processing',
            label: 'Saving & Indexing',
            badge: 'AI'
        },
        ...modal.autoFillWithFilling ? [
            {
                key: 'filling',
                label: 'Filing Answers',
                badge: 'AI'
            }
        ] : [],
        ...modal.autoFillWithFilling && willGenerateReports ? [
            {
                key: 'researchAid',
                label: 'Research Aid Reports',
                badge: 'AI'
            }
        ] : [],
        ...modal.autoFillWithFilling ? [
            {
                key: 'result',
                label: 'Result',
                badge: 'AI'
            }
        ] : []
    ].map((s, i)=>({
            ...s,
            num: i + 1
        })); // Reason: number sequentially so hidden steps don't leave gaps
    const totalSteps = sidebarSteps.length;
    const clarenceMessages = {
        uploadDocs: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Welcome,"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "You have hit the jackpot!",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "Let's see magic happen."
            ]
        }),
        uploading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "I'm uploading your documents to the Repository."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "This may take a moment..."
            ]
        }),
        indexing: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "I'm now reading through every document \u2014 extracting key data, spotting patterns, and matching content to the right questions across your module.",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "This is where the magic begins!"
                })
            ]
        }),
        allocation: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Here's how I've matched each document to your module questions. I've flagged anything I'm less confident about \u2014 please review those and use the reallocate icon if you'd like to move anything. ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Once you're happy, hit Confirm!"
                })
            ]
        }),
        processing: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Linking everything up..."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "I'm now saving all allocations and linking each document directly to the relevant answer fields across your module. Nearly there - this step sets the foundation for the auto-fill"
            ]
        }),
        filling: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Finding your answers..."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "I'm finding answers to your questions. Please wait while I do the magic - I'm reading each document carefully and crafting the best possible answers for every question."
            ]
        }),
        researchAid: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Generating your research reports..."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "I'm putting together your complete set of research reports using everything I've learned from your documents. Almost there!"
            ]
        }),
        result: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Auto-filing complete!"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "Your modules are filled and ready for review. Now that your documents are indexed, explore our other powerful tools - PolicyMaker, Analyzer and more awaits you!"
            ]
        })
    };
    const stepOrder = sidebarSteps.map((s)=>s.key);
    const currentStepIndex = stepOrder.indexOf(phase);
    // Cross File Upload / Other Modules run after Filing Answers but before Research Aid Reports/Result — they
    // aren't in sidebarSteps themselves, so pin the effective index to right after 'filling' rather than treating
    // every step (including ones still ahead, like Research Aid Reports/Result) as done
    const EXTRA_PHASES_AFTER_FILLING = [
        'crossFileUpload',
        'otherModules'
    ];
    const isInExtraModulesPass = EXTRA_PHASES_AFTER_FILLING.includes(phase);
    const effectiveStepIndex = isInExtraModulesPass ? stepOrder.indexOf('filling') + 1 : currentStepIndex;
    const renderSidebar = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc bg1 px1rem py2rem",
            style: {
                width: '320px',
                borderLeft: '1px solid #E5E7EB',
                overflowY: 'auto',
                flexShrink: 0
            },
            children: [
                clarenceMessages[phase] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc jcc mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic mb0-5rem",
                            style: {
                                gap: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("dmxYU")),
                                    alt: "Clarence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fw600 fs13px",
                                            children: "Clarence"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c12 fw400 fs11px",
                                            children: "Agent Manager"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg20 bw1px bss bo16 br10px p1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c18 fw400 fs12px poppins-font-style",
                                children: clarenceMessages[phase]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "w100 c15 fw600 fs15px mb1rem pl1rem",
                    children: "Progress"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df fdc",
                    style: {
                        gap: '0.25rem'
                    },
                    children: sidebarSteps.map((step)=>{
                        // selectedModules is component state and resets to null on close/minimize — fall back to the
                        // extraModules persisted in Redux (autoFillContext) so the dropdown survives re-open and resume
                        const ctxExtraMods = autoFillContext?.extraModules || [];
                        const extraMods = selectedModules && selectedModules.size > 1 ? [
                            ...selectedModules
                        ].filter((m)=>m !== (autoFillContext?.moduleType || 'repository')) : ctxExtraMods;
                        const hasExtraModules = step.key === 'filling' && extraMods.length > 0;
                        // The Filing Answers row is always expandable — with no extra modules the dropdown shows just the main module's status
                        const showFillingDropdown = step.key === 'filling';
                        // During Cross File Upload / Other Modules, reflect the same live per-module status already tracked for the main content panel.
                        // On Research Aid Reports / Result, Other Modules has already finished, so keep reading otherModulesCompleted rather than falling back to an empty map.
                        const activeModKey = phase === 'crossFileUpload' ? crossFileProgress.moduleType : phase === 'otherModules' ? otherModulesProgress.moduleType : null;
                        const completedMap = phase === 'crossFileUpload' ? crossFileCompleted : phase === 'otherModules' || phase === 'researchAid' || phase === 'result' ? otherModulesCompleted : {};
                        // Main module is "done" filling once the phase has moved past 'filling' into any later phase
                        const mainModuleDone = showFillingDropdown && stepOrder.indexOf('filling') < effectiveStepIndex;
                        const mainModuleActive = showFillingDropdown && phase === 'filling';
                        // Once the run has reached Research Aid / Result, the extras pass is over by definition — treat
                        // every extra as done even if its completion entry was lost to a minimize/re-open remount
                        const runPastExtras = phase === 'researchAid' || phase === 'result';
                        // Filing Answers only counts as fully complete once the main module AND every extra module has finished
                        const allExtrasDone = hasExtraModules && (runPastExtras || extraMods.every((m)=>!!completedMap[m]));
                        const isActive = hasExtraModules ? mainModuleActive || isInExtraModulesPass && !allExtrasDone : !isInExtraModulesPass && step.key === phase;
                        const isCompleted = hasExtraModules ? mainModuleDone && allExtrasDone : stepOrder.indexOf(step.key) < effectiveStepIndex;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `df aic jcsb p0-5rem br20px ${isActive ? 'bg5' : 'bg1'} ${showFillingDropdown ? 'cp' : ''}`,
                                    onClick: showFillingDropdown ? ()=>setUpNextExpanded((e)=>!e) : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic",
                                            style: {
                                                gap: '0.5rem'
                                            },
                                            children: [
                                                isCompleted ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic jcc br50px",
                                                    style: {
                                                        width: '24px',
                                                        height: '24px',
                                                        background: '#22c55e',
                                                        flexShrink: 0
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        width: "12",
                                                        height: "12",
                                                        viewBox: "0 0 12 12",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M2 6L5 9L10 3",
                                                            stroke: "white",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `df aic jcc br50px fs11px fw600 ${isActive ? 'bg3 c1' : 'bg16 c12'}`,
                                                    style: {
                                                        width: '24px',
                                                        height: '24px',
                                                        flexShrink: 0
                                                    },
                                                    children: step.num
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `fs13px ${isCompleted ? 'fw500 c30' : isActive ? 'fw600 c15' : 'fw400 c12'}`,
                                                    children: step.label
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic",
                                            style: {
                                                gap: '0.35rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `fs11px fw600 br10px bw1px bss ${step.badge === 'You' ? 'c8 bo8' : 'c3 bo3'}`,
                                                    style: {
                                                        padding: '2px 6px',
                                                        background: step.badge === 'You' ? '#FEF3C7' : '#F3F4F6'
                                                    },
                                                    children: step.badge === 'AI' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcc aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                style: {
                                                                    marginRight: '4px'
                                                                },
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 12 12",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                        clipPath: "url(#clip0_6440_13186)",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M3.02418 2.41933L4.0648 2.98886C4.1984 3.06151 4.24762 3.22792 4.17496 3.36151C4.14918 3.40839 4.11168 3.44589 4.0648 3.47167L3.02418 4.03886C2.9773 4.06464 2.9398 4.10214 2.91402 4.14901L2.34449 5.18964C2.27184 5.32323 2.10543 5.37245 1.97184 5.2998C1.92496 5.27401 1.88746 5.23651 1.86168 5.18964L1.29449 4.14901C1.26871 4.10214 1.23121 4.06464 1.18434 4.03886L0.14371 3.47167C0.0101167 3.39901 -0.039102 3.23261 0.0335542 3.09901C0.0593355 3.05214 0.0968355 3.01464 0.14371 2.98886L1.18434 2.41933C1.23121 2.39355 1.26871 2.35605 1.29449 2.30917L1.86402 1.27089C1.93668 1.1373 2.10543 1.08808 2.23902 1.16308C2.28355 1.18886 2.32105 1.22636 2.34684 1.27089L2.91637 2.30917C2.9398 2.35605 2.9773 2.39355 3.02418 2.41933Z",
                                                                                fill: "#4A67FF"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M10.7703 7.97359L11.8109 8.54312C11.9445 8.61578 11.9937 8.78219 11.9211 8.91578C11.8953 8.96266 11.8578 9.00016 11.8109 9.02594L10.7703 9.59547C10.7234 9.62125 10.6859 9.65875 10.6601 9.70562L10.0906 10.7462C10.0179 10.8798 9.84918 10.9291 9.71559 10.8564C9.66871 10.8306 9.63121 10.7931 9.60543 10.7462L9.04059 9.70328C9.0148 9.65641 8.9773 9.61891 8.93043 9.59312L7.8898 9.02359C7.75621 8.95094 7.70699 8.78219 7.77965 8.64859C7.80543 8.60172 7.84293 8.56422 7.8898 8.53844L8.93043 7.96891C8.9773 7.94312 9.0148 7.90562 9.04059 7.85875L9.61012 6.82047C9.68277 6.68687 9.85152 6.63766 9.98512 6.71031C10.032 6.73609 10.0695 6.77359 10.0953 6.82047L10.6648 7.86109C10.6859 7.91031 10.7234 7.94781 10.7703 7.97359Z",
                                                                                fill: "#4A67FF"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M6.26475 1.22861L6.94678 1.60127C7.0335 1.65049 7.06631 1.76065 7.01943 1.84736C7.00303 1.87783 6.97725 1.90127 6.94678 1.92002L6.26475 2.29268C6.23428 2.30908 6.2085 2.33486 6.19209 2.36533L5.81943 3.04736C5.77022 3.13408 5.66006 3.1669 5.57334 3.12002C5.54287 3.10361 5.51943 3.07783 5.50068 3.04736L5.12803 2.36533C5.11162 2.33486 5.08584 2.30908 5.05537 2.29268L4.37334 1.92002C4.28662 1.87315 4.25381 1.76299 4.30068 1.67393C4.31709 1.64346 4.34287 1.61768 4.37334 1.60127L5.05537 1.22861C5.08584 1.21221 5.11162 1.18643 5.12803 1.15596L5.50068 0.473927C5.5499 0.387208 5.66006 0.354396 5.74678 0.401271C5.77725 0.417677 5.80068 0.443458 5.81943 0.473927L6.19209 1.15596C6.2085 1.18643 6.23428 1.21221 6.26475 1.22861Z",
                                                                                fill: "#4A67FF"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M11.7341 1.54024L10.7708 0.576956C10.4146 0.220706 9.83564 0.218362 9.47705 0.574612C9.47705 0.574612 9.47705 0.574612 9.47471 0.576956L0.887208 9.1668C0.530958 9.52305 0.528614 10.102 0.887208 10.4606L1.85049 11.4238C2.20674 11.7801 2.78565 11.7824 3.14424 11.4238L11.7341 2.83399C12.0903 2.47774 12.0903 1.89883 11.7341 1.54024ZM8.38486 4.78868L7.52236 3.92618L10.0653 1.38086L10.9278 2.24336L8.38486 4.78868Z",
                                                                                fill: "#4A67FF"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                            id: "clip0_6440_13186",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                width: "12",
                                                                                height: "12",
                                                                                fill: "white"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            "AI"
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcc aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                style: {
                                                                    marginRight: '4px'
                                                                },
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 12 12",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                        clipPath: "url(#clip0_6440_13178)",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                fillRule: "evenodd",
                                                                                clipRule: "evenodd",
                                                                                d: "M5.99999 1C4.61928 1 3.5 2.11929 3.5 3.5C3.5 4.88071 4.61928 6 5.99999 6C7.38069 6 8.5 4.88071 8.5 3.5C8.5 2.11929 7.38069 1 5.99999 1Z",
                                                                                fill: "#D9B11C"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                fillRule: "evenodd",
                                                                                clipRule: "evenodd",
                                                                                d: "M4.50045 6.5C3.66907 6.5 2.86956 6.87925 2.40102 7.4502C2.16322 7.74 1.99605 8.09855 1.9815 8.49595C1.96663 8.9018 2.11313 9.2979 2.41524 9.64355C3.15152 10.4858 4.32708 11 6.00044 11C7.67379 11 8.84939 10.4858 9.58564 9.64355C9.88779 9.2979 10.0342 8.9018 10.0194 8.49595C10.0048 8.09855 9.83769 7.74 9.59989 7.4502C9.13134 6.87925 8.33184 6.5 7.50044 6.5H4.50045Z",
                                                                                fill: "#D9B11C"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                            id: "clip0_6440_13178",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                width: "12",
                                                                                height: "12",
                                                                                fill: "white"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            "You"
                                                        ]
                                                    })
                                                }),
                                                showFillingDropdown && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: `fa ${upNextExpanded ? 'fa-angle-up' : 'fa-angle-down'} c3`,
                                                    style: {
                                                        fontSize: '14px',
                                                        fontWeight: '600'
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                showFillingDropdown && upNextExpanded && (()=>{
                                    const mainStatusText = mainModuleDone ? `Completed \u{2014} ${modal.autoFillAnswered || 0} answered, ${modal.autoFillSkipped || 0} skipped` : mainModuleActive ? modal.autoFillTotal > 0 ? `In progress \u{2014} ${modal.autoFillCurrent || 0} of ${modal.autoFillTotal} questions` : "In progress\u2026" : 'Queued';
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc mt0-5rem",
                                        style: {
                                            gap: '0.5rem',
                                            paddingLeft: '0.75rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic bg1 br10px bw1px bss bo29",
                                                style: {
                                                    padding: '5px 10px',
                                                    gap: '0.75rem'
                                                },
                                                children: [
                                                    mainModuleDone ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic jcc bg30 br50px",
                                                        style: {
                                                            width: 28,
                                                            height: 28,
                                                            flexShrink: 0
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 12 12",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M2 6L5 9L10 3",
                                                                stroke: "white",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `df aic jcc br50px fs11px fw600 ${mainModuleActive ? 'bg3 c1' : 'bg16 c12'}`,
                                                        style: {
                                                            width: 28,
                                                            height: 28,
                                                            flexShrink: 0
                                                        },
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc",
                                                        style: {
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "w100 c15 fw600 fs13px",
                                                                children: getModuleLabel(autoFillContext?.moduleType || 'repository')
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: `w100 fs11px fw400 oh ${mainModuleDone ? 'c30' : mainModuleActive ? 'c3' : 'c12'}`,
                                                                style: {
                                                                    whiteSpace: 'nowrap',
                                                                    textOverflow: 'ellipsis'
                                                                },
                                                                title: mainStatusText,
                                                                children: mainStatusText
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            extraMods.map((modKey, idx)=>{
                                                const completedEntry = completedMap[modKey];
                                                // runPastExtras covers entries lost to a remount — completed, but counts unknown
                                                const done = !!completedEntry || runPastExtras;
                                                const isModActive = !done && activeModKey === modKey;
                                                const statusText = done ? phase === 'crossFileUpload' ? `Completed \u{2014} ${completedEntry?.uploaded ?? 0} files uploaded` : completedEntry ? `Completed \u{2014} ${completedEntry.answered ?? 0} answered, ${completedEntry.skipped ?? 0} skipped` : 'Completed' : isModActive ? "In progress\u2026" : "Queued \u2014 Uses same files";
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic bg1 br10px bw1px bss bo29",
                                                    style: {
                                                        padding: '5px 10px',
                                                        gap: '0.75rem'
                                                    },
                                                    children: [
                                                        done ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df aic jcc bg30 br50px",
                                                            style: {
                                                                width: 28,
                                                                height: 28,
                                                                flexShrink: 0
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 12 12",
                                                                fill: "none",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M2 6L5 9L10 3",
                                                                    stroke: "white",
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `df aic jcc br50px fs11px fw600 ${isModActive ? 'bg3 c1' : 'bg16 c12'}`,
                                                            style: {
                                                                width: 28,
                                                                height: 28,
                                                                flexShrink: 0
                                                            },
                                                            children: idx + 2
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc",
                                                            style: {
                                                                minWidth: 0
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "w100 c15 fw600 fs13px",
                                                                    children: getModuleLabel(modKey)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: `w100 fs11px fw400 oh ${done ? 'c30' : isModActive ? 'c3' : 'c12'}`,
                                                                    style: {
                                                                        whiteSpace: 'nowrap',
                                                                        textOverflow: 'ellipsis'
                                                                    },
                                                                    title: statusText,
                                                                    children: statusText
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, modKey);
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "tac c12 fs11px fw400 mt0-5rem mb0rem",
                                                children: "You can review at the end from dashboard"
                                            })
                                        ]
                                    });
                                })()
                            ]
                        }, step.key);
                    })
                })
            ]
        });
    const renderHeader = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic jcsb bg1 px2rem py1rem",
            style: {
                borderBottom: '1px solid #E5E7EB'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "w80",
                        src: (parcelRequire("b0Cmg")),
                        alt: "Diligentsia"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            class: "w30px h30px mr0-5rem",
                            src: (parcelRequire("6u6RT")),
                            alt: "autofill-icon"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c15 fw500 fs18px mr0-5rem",
                            children: "Filing Assistant"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3 fw500 fs18px",
                            children: modal.autoFillWithFilling ? 'Auto-fill' : 'Import'
                        })
                    ]
                })
            ]
        });
    const renderTopHead = (data, backTo, overrideScopeName)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic mb0-5rem",
                    children: [
                        !!backTo && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    autoFillStepperPhase: backTo
                                })),
                            class: "bg1 cp mr0-5rem mt0-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "22",
                                height: "16",
                                viewBox: "0 0 22 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                    fill: "#151313"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "c15 fs1-5rem fw600 mb0rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c14 fs1rem fw400 mr0-5rem",
                                    children: [
                                        data['num'],
                                        "/",
                                        totalSteps
                                    ]
                                }),
                                data['label']
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    class: "w100 c3 fs17px fw400 mb2rem ml2rem",
                    children: [
                        modal.autoFillWithFilling ? 'Auto filing' : modal.autoFillUploadMode === 'folders' ? 'Folder import' : 'File import',
                        " ",
                        (overrideScopeName || scopeName) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "c12 fs15px",
                            children: [
                                "(",
                                overrideScopeName || scopeName,
                                !overrideScopeName && scope == 'section' ? ` (${getModuleLabel(autoFillContext?.moduleType)})` : '',
                                ")"
                            ]
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: ()=>{
            if (phase === 'result') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                autoFillJustCompleted: true
            }));
        },
        className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: isFullScreen ? 'df fdc bg1 w100vw h100vh' : `pr shadow df fdc m1rem p2rem br10px ${phase == 'intro' || phase === 'select' ? 'bg5' : 'bg1'} maw100 mah90vh`,
                    style: isFullScreen ? {
                        overflow: 'hidden'
                    } : {},
                    children: [
                        phase === 'intro' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic w100 h100 px4rem py2rem mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            class: "mr1rem",
                                            src: (parcelRequire("1K8E2")),
                                            alt: "auto-fill"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "c15 fw500 mb0rem fs1-5rem",
                                            children: "How Autofill Works"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c3 fw500 fs16px tac mb0-5rem",
                                    children: modal.autoFillModuleName || getModuleLabel(autoFillContext?.moduleType)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "df fdc aic mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            class: "mb0-5rem",
                                            src: (parcelRequire("dmpf0")),
                                            alt: "auto-fill"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    class: "mr0-5rem",
                                                    src: (parcelRequire("jRkbT")),
                                                    alt: "step-1"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    class: "mr0-5rem",
                                                    src: (parcelRequire("9BSL1")),
                                                    alt: "step-2"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    class: "mr0-5rem",
                                                    src: (parcelRequire("lSMjL")),
                                                    alt: "step-3"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    class: "mr0-5rem mb0-5rem",
                                                    src: (parcelRequire("ftlOR")),
                                                    alt: "step-4"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            class: "w100 df",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("81qdF")),
                                                alt: "auto-fill"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df aic jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            class: "cp bg5 c14 fs14px",
                                            children: "\u2190 Back"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            open: ''
                                                        })),
                                                    class: "cp bg5 c14 fs14px bw1px bo14 bss br20px px2rem py0-5rem mr1rem",
                                                    children: "No, I'll populate manually"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            autoFillStepperPhase: 'select'
                                                        })),
                                                    class: "cp bg4 c1 fs15px px2rem py0-5rem br20px",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            class: "fs16px mr0-5rem",
                                                            children: "\u2726"
                                                        }),
                                                        "Next"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        phase === 'select' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df fdc bg5",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "tac fs1-5rem c15 fw500 my3rem",
                                    children: modal.autoFillWithFilling ? 'Choose Modules to Autofill' : modal.autoFillUploadMode === 'folders' ? 'Select Folders to Import' : 'Select Files to Import'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "new-shadow df bg1 br20px py2rem mx3rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc px2rem",
                                            children: modal.autoFillWithFilling && scope === 'module' && autoFillContext?.moduleType === 'repository' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 c15 fw500 fs16px mb0-5rem",
                                                        children: "You pick the modules"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "c14 fw300 fs13px mb1-5rem",
                                                        children: [
                                                            "You select which modules you would like data repository ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " files to cross populate where relevant"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc",
                                                        style: {
                                                            gap: '1rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "cp df aic",
                                                                style: {
                                                                    gap: '0.75rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "checkbox w20px h20px pr",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            checked: true,
                                                                            readOnly: true,
                                                                            type: "checkbox",
                                                                            className: " bg1 bo4 bw1px bss td250 w20px h20px br5px"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "c15 fw400 fs14px",
                                                                        children: [
                                                                            "Data Repository ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c12 fs12px",
                                                                                children: "(default)"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            availableModules.filter((m)=>m.key !== autoFillContext?.moduleType).map((mod)=>{
                                                                const isSelected = selectedModules?.has(mod.key) ?? false;
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    className: "df aic cp",
                                                                    style: {
                                                                        gap: '0.75rem'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "checkbox w20px h20px pr",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                checked: isSelected,
                                                                                onChange: ()=>toggleModuleSelection(mod.key),
                                                                                type: "checkbox",
                                                                                className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "c15 fw400 fs14px",
                                                                            children: mod.label
                                                                        })
                                                                    ]
                                                                }, mod.key);
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w100 fw400 c12 fs13px mt3rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                class: "c3",
                                                                children: selectedModules?.size || 0
                                                            }),
                                                            " of ",
                                                            availableModules.filter((m)=>m.key !== autoFillContext?.moduleType).length + 1,
                                                            " selected"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "mt1rem pt1rem bss bo29",
                                                        style: {
                                                            borderWidth: '1px 0 0 0'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            className: "df aic cp",
                                                            style: {
                                                                gap: '0.75rem'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "checkbox w20px h20px pr",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        checked: generateReports,
                                                                        onChange: ()=>setGenerateReports((v)=>!v),
                                                                        type: "checkbox",
                                                                        className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "c15 fw400 fs14px",
                                                                    children: [
                                                                        "Generate Research Reports ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "c12 fs12px",
                                                                            children: "(complete set of 5)"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c15 fw700 fs16px mb0-5rem",
                                                        children: modal.autoFillWithFilling ? 'Upload your documents' : modal.autoFillUploadMode === 'folders' ? 'Select your folders' : 'Select your files'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c14 fw400 fs13px mb1-5rem",
                                                        children: modal.autoFillWithFilling ? 'Uploading relevant documents improves auto-fill accuracy. Clarence will read and allocate your files automatically.' : modal.autoFillUploadMode === 'folders' ? 'Select one or more folders to import into your Data Repository.' : 'Select one or more files to import into your Data Repository.'
                                                    }),
                                                    modal.autoFillUploadMode !== 'folders' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs12px c12",
                                                        children: "Supported: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                class: "w80 ml4rem",
                                                src: (parcelRequire("11dP3")),
                                                alt: "select"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcsb my2rem px3rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            class: "cp bg5 c14 fs14px",
                                            children: "\u2190 Back"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    autoFillStepperPhase: 'uploadDocs'
                                                })),
                                            class: "cp bg4 c1 fs14px px2rem py0-5rem br20px",
                                            children: modal.autoFillWithFilling ? `Continue with ${selectedModules?.size || 0}` : modal.autoFillUploadMode === 'folders' ? 'Select Folders' : 'Upload Documents'
                                        })
                                    ]
                                })
                            ]
                        }),
                        phase === 'uploadDocs' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                renderHeader(),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df",
                                    style: {
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc p2-5rem",
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                renderTopHead(sidebarSteps[0], 'select'),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "w100 c15 fw400 fs14px mb1-5rem",
                                                    children: "Would you like to upload documents?"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w80 br10px mb2rem bw1px bss bo16",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "c15 fw500 fs14px pt1rem px1rem",
                                                            children: [
                                                                "Upload new files ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c12 fw400 fs12px",
                                                                    children: "(Optional)"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            onClick: ()=>fileInputRef.current?.click(),
                                                            className: "cp df fdc aic jcc br10px p3rem m1rem",
                                                            style: {
                                                                border: '1.5px dashed #93C5FD',
                                                                background: '#EFF6FF'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic jcc mb0-5rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: (parcelRequire("9YqvR")),
                                                                        alt: "uploading"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "c14 fw500 fs14px tac mb0-25rem",
                                                                    children: "Drop files here or browse"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "c12 fw400 fs12px tac",
                                                                    children: "PDF, DOC, DOCX, PPT (max 100MB)"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w80 br10px mb2rem bw1px bss bo16",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "c15 fw500 fs14px pt1rem px1rem",
                                                            children: [
                                                                "Upload folder ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c12 fw400 fs12px",
                                                                    children: "(Optional)"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            onClick: ()=>folderInputRef.current?.click(),
                                                            className: "cp df fdc aic jcc br10px p3rem m1rem",
                                                            style: {
                                                                border: '1.5px dashed #FCD34D',
                                                                background: '#FFFBEB'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic jcc br100 mb0-5rem",
                                                                    style: {
                                                                        width: '48px',
                                                                        height: '48px',
                                                                        background: '#F59E0B',
                                                                        flexShrink: 0
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: (parcelRequire("3ZIxk")),
                                                                        alt: "uploading"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "c15 fw500 fs14px tac",
                                                                    style: {
                                                                        marginBottom: '0.25rem'
                                                                    },
                                                                    children: "Drop folder here or browse"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "c12 fw400 fs12px tac",
                                                                    children: "PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT (max 100MB)"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w90 df aic jcfe",
                                                    children: [
                                                        modal.autoFillWithFilling && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: handleSkipUpload,
                                                            class: "bg1 c14 fs14px px1rem py0-5rem bw1px bss bo12 br20px mr1rem",
                                                            children: "Skip \u2014 use existing"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>fileInputRef.current?.click(),
                                                            className: "cp bg4 c1 fs14px px2-5rem py0-5rem br20px",
                                                            children: "Ok, next \u2192"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    ref: fileInputRef,
                                                    type: "file",
                                                    multiple: true,
                                                    onChange: handleFileSelect,
                                                    style: {
                                                        display: 'none'
                                                    },
                                                    accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    ref: folderInputRef,
                                                    type: "file",
                                                    multiple: true,
                                                    onChange: handleFileSelect,
                                                    style: {
                                                        display: 'none'
                                                    },
                                                    webkitdirectory: "",
                                                    directory: "",
                                                    mozdirectory: ""
                                                })
                                            ]
                                        }),
                                        renderSidebar()
                                    ]
                                })
                            ]
                        }),
                        phase === 'uploading' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                renderHeader(),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df",
                                    style: {
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc px3rem py2rem",
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                renderTopHead(sidebarSteps[1], 'uploadDocs'),
                                                (()=>{
                                                    const isUploadComplete = (modal.percent || 0) >= 100;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "w70 bg1 p1-5rem mb1rem bw1px bss bo16 br10px",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic jcsb mb1-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic",
                                                                                style: {
                                                                                    gap: '0.75rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                        width: "50",
                                                                                        height: "50",
                                                                                        viewBox: "0 0 58 58",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M1 11C1 5.47715 5.47715 1 11 1H45C50.5228 1 55 5.47715 55 11V45C55 50.5228 50.5228 55 45 55H11C5.47715 55 1 50.5228 1 45V11Z",
                                                                                                fill: "#4A67FF",
                                                                                                "fill-opacity": "0.1"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M27.9788 40.1803C25.934 40.1803 23.8895 40.1803 21.8453 40.1803C19.0416 40.1803 17.0184 38.1642 17.004 35.3614C16.9987 34.3831 16.9987 33.4045 17.004 32.4256C17.0094 31.4167 17.6209 30.7674 18.5561 30.7656C19.4912 30.7638 20.1108 31.4086 20.1171 32.4166C20.1234 33.4246 20.1171 34.4092 20.1171 35.4055C20.1243 36.4504 20.7384 37.0591 21.7869 37.06C25.9286 37.06 30.07 37.06 34.2111 37.06C35.2605 37.06 35.8756 36.4504 35.8836 35.4064C35.8908 34.4101 35.8836 33.4138 35.8836 32.4175C35.8836 31.4211 36.505 30.7638 37.4438 30.7656C38.3825 30.7674 39.003 31.4167 38.9949 32.4247C38.985 33.6988 39.056 34.9865 38.896 36.2436C38.6028 38.5437 36.6417 40.1677 34.3145 40.1785C32.2077 40.1848 30.0928 40.1803 27.9788 40.1803Z",
                                                                                                fill: "#4A67FF"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M26.4458 20.3709C26.2085 20.5921 26.0691 20.7135 25.9396 20.8439C24.9433 21.8501 23.9524 22.8626 22.9516 23.8652C22.2412 24.5774 21.2512 24.6295 20.6091 24.0064C19.9671 23.3832 19.9923 22.3609 20.691 21.6577C22.725 19.6111 24.7655 17.5717 26.8127 15.5395C27.5321 14.8202 28.4726 14.8202 29.192 15.5395C31.253 17.5837 33.3055 19.6366 35.3497 21.6981C36.0223 22.377 36.0259 23.3976 35.401 24.0073C34.776 24.6169 33.7824 24.59 33.0963 23.9093C32.0802 22.8977 31.0794 21.8699 30.0705 20.852C29.9401 20.7207 29.8008 20.5984 29.593 20.4024C29.5796 20.6847 29.5634 20.8673 29.5634 21.0498C29.5634 24.2681 29.5679 27.4854 29.5634 30.7036C29.5634 31.9113 28.5005 32.6297 27.3954 32.1999C26.7839 31.9616 26.4521 31.4311 26.4521 30.6542C26.4485 27.471 26.4485 24.2881 26.4521 21.1056L26.4458 20.3709Z",
                                                                                                fill: "#4A67FF"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "c15 fw500 fs15px mb0rem",
                                                                                                children: isUploadComplete ? 'All files uploaded successfully' : 'Uploading your documents'
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "c12 fw400 fs12px fsi",
                                                                                                children: isUploadComplete ? `${modal.filesUploaded || 0} files uploaded` : `${modal.filesUploaded || 0} of ${modal.totalFiles || 0} files uploaded`
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic",
                                                                                style: {
                                                                                    gap: '0.75rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df fdc aic",
                                                                                        style: {
                                                                                            minWidth: '48px'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "c15 fw600 fs1-5rem lh1",
                                                                                                children: modal.totalFiles || 0
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "c12 fw400 fs11px",
                                                                                                children: "Selected"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        style: {
                                                                                            width: '1px',
                                                                                            height: '36px',
                                                                                            background: '#E5E7EB'
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df fdc aic",
                                                                                        style: {
                                                                                            minWidth: '48px'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "c7 fw600 fs1-5rem lh1",
                                                                                                children: modal.filesUploaded || 0
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "c12 fw400 fs11px",
                                                                                                children: "Uploaded"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        style: {
                                                                                            width: '1px',
                                                                                            height: '36px',
                                                                                            background: '#E5E7EB'
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df fdc aic",
                                                                                        style: {
                                                                                            minWidth: '48px'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "c9 fw600 fs1-5rem lh1",
                                                                                                children: modal.filesFailed || 0
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "c12 fw400 fs11px",
                                                                                                children: "Failed"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bg24 br10px h10px mb0-5rem oh",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "h100 br10px",
                                                                            style: {
                                                                                background: isUploadComplete ? '#22c55e' : 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                                                width: `${modal.percent || 0}%`,
                                                                                transition: 'width 0.3s ease'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df jcsb",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: `fw400 fs12px ${isUploadComplete ? 'c30' : 'c12'}`,
                                                                                children: isUploadComplete ? 'Upload complete' : 'Progress'
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: `fw600 fs12px ${isUploadComplete ? 'c30' : 'c3'}`,
                                                                                children: [
                                                                                    modal.percent || 0,
                                                                                    "%"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            isUploadComplete && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "w70 df aic px1-5rem py1rem br10px mb1rem",
                                                                style: {
                                                                    background: '#e8ffee',
                                                                    border: '1px solid #BBF7D0',
                                                                    gap: '0.75rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df aic jcc bg30 br50px",
                                                                        style: {
                                                                            width: 24,
                                                                            height: 24,
                                                                            flexShrink: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                            width: "12",
                                                                            height: "12",
                                                                            viewBox: "0 0 12 12",
                                                                            fill: "none",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M2 6L5 9L10 3",
                                                                                stroke: "white",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "fs13px fw500",
                                                                        style: {
                                                                            color: '#15803d'
                                                                        },
                                                                        children: [
                                                                            modal.filesUploaded || 0,
                                                                            " files uploaded successfully"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            (modal.fileName || isUploadComplete) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w70 bg5 br10px p1-5rem mb2rem df aic",
                                                                style: {
                                                                    gap: '0.75rem'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    style: {
                                                                        minWidth: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c12 fw500 fs13px ml0-5rem mb0-25rem",
                                                                            children: "Currently working on"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "df aic c15 fw500 fs13px oh wsn",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                    className: "mr0-5rem",
                                                                                    width: "26",
                                                                                    height: "26",
                                                                                    viewBox: "0 0 26 26",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M13 0C5.83151 0 0 5.83151 0 13C0 20.1685 5.83151 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83151 20.1685 0 13 0Z",
                                                                                            fill: "#4A67FF"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M16.8571 4.83427L17.4107 6.36893C18.0248 8.07274 19.3667 9.41468 21.0705 10.0287L22.6052 10.5823C22.7436 10.6326 22.7436 10.8284 22.6052 10.8786L21.0705 11.4322C19.3667 12.0463 18.0248 13.3882 17.4107 15.092L16.8571 16.6267C16.8069 16.7651 16.6111 16.7651 16.5608 16.6267L16.0073 15.092C15.3932 13.3882 14.0513 12.0463 12.3474 11.4322L10.8128 10.8786C10.6744 10.8284 10.6744 10.6326 10.8128 10.5823L12.3474 10.0287C14.0513 9.41468 15.3932 8.07274 16.0073 6.36893L16.5608 4.83427C16.6111 4.69587 16.8069 4.69587 16.8571 4.83427Z",
                                                                                            fill: "white"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M8.82485 11.4753L9.25542 12.6689C9.73303 13.9941 10.7768 15.0378 12.1019 15.5154L13.2956 15.946C13.4032 15.9851 13.4032 16.1373 13.2956 16.1764L12.1019 16.607C10.7768 17.0846 9.73303 18.1283 9.25542 19.4535L8.82485 20.6471C8.78578 20.7548 8.63349 20.7548 8.59442 20.6471L8.16385 19.4535C7.68624 18.1283 6.64252 17.0846 5.31733 16.607L4.1237 16.1764C4.01606 16.1373 4.01606 15.9851 4.1237 15.946L5.31733 15.5154C6.64252 15.0378 7.68624 13.9941 8.16385 12.6689L8.59442 11.4753C8.63349 11.3676 8.78578 11.3676 8.82485 11.4753Z",
                                                                                            fill: "white"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                isUploadComplete ? 'Proceeding to the next step automatically...' : 'Uploading files...'
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    });
                                                })(),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcfe",
                                                    style: {
                                                        gap: '0.75rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: handleCancel,
                                                            style: $317086ac24816082$var$btnCancel,
                                                            children: "Cancel"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: handleMinimize,
                                                            style: $317086ac24816082$var$btnMinimize,
                                                            children: "Minimize"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        renderSidebar()
                                    ]
                                })
                            ]
                        }),
                        phase === 'indexing' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                renderHeader(),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df",
                                    style: {
                                        flex: 1,
                                        overflow: 'hidden'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc px3rem py2rem",
                                            style: {
                                                flex: 1,
                                                minHeight: 0
                                            },
                                            children: [
                                                renderTopHead(sidebarSteps[2]),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w70 bg1 br10px p1-5rem mb1-5rem bw1px bss bo16",
                                                    style: {
                                                        flexShrink: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic jcsb mb1-5rem",
                                                            style: {
                                                                gap: '1rem'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        gap: '0.5rem',
                                                                        flex: 1,
                                                                        minWidth: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w70px",
                                                                            src: (parcelRequire("hA45b")),
                                                                            alt: "indexing",
                                                                            style: {
                                                                                flexShrink: 0
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            style: {
                                                                                minWidth: 0
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c15 fw600 fs14px mb0-25rem",
                                                                                    children: showAllocationData ? 'Analyzing & allocating documents to sections' : 'Reading & indexing your documents...'
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c12 fw400 fs12px fsi",
                                                                                    style: {
                                                                                        overflowWrap: 'anywhere',
                                                                                        wordBreak: 'break-word'
                                                                                    },
                                                                                    title: !showAllocationData && indexingProgress.currentFile ? indexingProgress.currentFile : undefined,
                                                                                    children: showAllocationData ? `${allocationProgress.current || 0} of ${allocationProgress.total} files matched` : indexingProgress.total > 0 && indexingProgress.currentFile ? indexingProgress.current < indexingProgress.total ? `Reading:\xa0${indexingProgress.currentFile}` : "\u2713 All files indexed" : 'Preparing files...'
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        gap: '1.5rem',
                                                                        flexShrink: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fdc aic",
                                                                            style: {
                                                                                minWidth: '52px'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c15 fw600 fs1-5rem lh1",
                                                                                    children: allocationProgress.total || indexingProgress.total || 0
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c12 fw400 fs12px mt0-25rem",
                                                                                    children: "Imported"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            style: {
                                                                                width: '1px',
                                                                                height: '36px',
                                                                                background: '#E5E7EB'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fdc aic",
                                                                            style: {
                                                                                minWidth: '52px'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c7 fw600 fs1-5rem lh1",
                                                                                    children: allocationProgress.current || 0
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c12 fw400 fs12px mt0-25rem",
                                                                                    children: "Allocated"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            style: {
                                                                                width: '1px',
                                                                                height: '36px',
                                                                                background: '#E5E7EB'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fdc aic",
                                                                            style: {
                                                                                minWidth: '52px'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c9 fw600 fs1-5rem lh1",
                                                                                    children: unallocatedCount
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c12 fw400 fs12px mt0-25rem",
                                                                                    children: "Unallocated"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "bg24 br10px oh mb0-5rem h10px",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "h100 br10px",
                                                                style: {
                                                                    background: 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                                    width: `${indexingStepPct}%`,
                                                                    transition: 'width 0.3s ease'
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df jcsb",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c12 fw400 fs12px",
                                                                    children: "Progress"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        gap: '0.5rem'
                                                                    },
                                                                    children: [
                                                                        indexingStepEta && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "c12 fw400 fs12px",
                                                                            children: indexingStepEta
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "c3 fw600 fs12px",
                                                                            children: [
                                                                                indexingStepPct,
                                                                                "%"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcsb aife mb1-5rem",
                                                    style: {
                                                        gap: '1rem',
                                                        flexShrink: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "w70 bg5 br10px p1rem df aic",
                                                            style: {
                                                                gap: '0.75rem'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    style: {
                                                                        minWidth: 0,
                                                                        flex: 1
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c12 fw500 fs12px mb0-5rem",
                                                                            children: "Currently processing"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "df aic c15 fw500 fs13px oh wsn",
                                                                            style: {
                                                                                minWidth: 0
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                    className: "mr0-5rem",
                                                                                    style: {
                                                                                        flexShrink: 0
                                                                                    },
                                                                                    width: "26",
                                                                                    height: "26",
                                                                                    viewBox: "0 0 26 26",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                            "clip-path": "url(#clip0_6440_13108)",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M13 0C5.83151 0 0 5.83151 0 13C0 20.1685 5.83151 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83151 20.1685 0 13 0Z",
                                                                                                    fill: "#4A67FF"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M16.8571 4.83427L17.4107 6.36893C18.0248 8.07274 19.3667 9.41468 21.0705 10.0287L22.6052 10.5823C22.7436 10.6326 22.7436 10.8284 22.6052 10.8786L21.0705 11.4322C19.3667 12.0463 18.0248 13.3882 17.4107 15.092L16.8571 16.6267C16.8069 16.7651 16.6111 16.7651 16.5608 16.6267L16.0073 15.092C15.3932 13.3882 14.0513 12.0463 12.3474 11.4322L10.8128 10.8786C10.6744 10.8284 10.6744 10.6326 10.8128 10.5823L12.3474 10.0287C14.0513 9.41468 15.3932 8.07274 16.0073 6.36893L16.5608 4.83427C16.6111 4.69587 16.8069 4.69587 16.8571 4.83427Z",
                                                                                                    fill: "white"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M8.82485 11.4753L9.25542 12.6689C9.73303 13.9941 10.7768 15.0378 12.1019 15.5154L13.2956 15.946C13.4032 15.9851 13.4032 16.1373 13.2956 16.1764L12.1019 16.607C10.7768 17.0846 9.73303 18.1283 9.25542 19.4535L8.82485 20.6471C8.78578 20.7548 8.63349 20.7548 8.59442 20.6471L8.16385 19.4535C7.68624 18.1283 6.64252 17.0846 5.31733 16.607L4.1237 16.1764C4.01606 16.1373 4.01606 15.9851 4.1237 15.946L5.31733 15.5154C6.64252 15.0378 7.68624 13.9941 8.16385 12.6689L8.59442 11.4753C8.63349 11.3676 8.78578 11.3676 8.82485 11.4753Z",
                                                                                                    fill: "white"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                id: "clip0_6440_13108",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                    width: "26",
                                                                                                    height: "26",
                                                                                                    fill: "white"
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "oh",
                                                                                    style: {
                                                                                        textOverflow: 'ellipsis',
                                                                                        whiteSpace: 'nowrap',
                                                                                        minWidth: 0
                                                                                    },
                                                                                    title: allocationProgress.fileName || indexingProgress.currentFile,
                                                                                    children: allocationProgress.fileName || indexingProgress.currentFile
                                                                                })
                                                                            ]
                                                                        }),
                                                                        allocationProgress.matchedQNo && allocationProgress.matchedQNo !== 'SXXX' && allocationProgress.matchedQNo !== 'DXXX' && allocationProgress.matchedQuestion && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "c12 fw400 fs12px oh wsn",
                                                                            children: [
                                                                                allocationProgress.matchedQNo,
                                                                                " \u2014 \u201C",
                                                                                allocationProgress.matchedQuestion.length > 55 ? `${allocationProgress.matchedQuestion.slice(0, 52)}..` : allocationProgress.matchedQuestion,
                                                                                "\u201D"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "bg17 fw600 fs10px br50px px1rem py0-25rem c18 wsn",
                                                                    style: {
                                                                        flexShrink: 0
                                                                    },
                                                                    children: "Allocating..."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic",
                                                            style: {
                                                                gap: '0.75rem',
                                                                flexShrink: 0
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: handleCancel,
                                                                    style: $317086ac24816082$var$btnCancel,
                                                                    children: "Cancel"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: handleMinimize,
                                                                    style: $317086ac24816082$var$btnMinimize,
                                                                    children: "Minimize"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                processedFileChips.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc",
                                                    style: {
                                                        flex: 1,
                                                        minHeight: 0
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fww thin-scroll",
                                                        style: {
                                                            gap: '0.5rem',
                                                            flex: 1,
                                                            minHeight: 0,
                                                            overflowY: 'auto',
                                                            alignContent: 'flex-start',
                                                            paddingRight: '0.5rem'
                                                        },
                                                        children: processedFileChips.map((name, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "df aic fw500 fs11px br50px px0-75rem py0-25rem c30 bw1px bss bo30",
                                                                style: {
                                                                    background: '#DCFCE7',
                                                                    gap: '0.3rem',
                                                                    flexShrink: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "10",
                                                                        height: "10",
                                                                        viewBox: "0 0 12 12",
                                                                        fill: "none",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M2 6L5 9L10 3",
                                                                            stroke: "#09B255",
                                                                            strokeWidth: "2",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    }),
                                                                    name.length > 28 ? `${name.slice(0, 25)}...` : name
                                                                ]
                                                            }, i))
                                                    })
                                                })
                                            ]
                                        }),
                                        renderSidebar()
                                    ]
                                })
                            ]
                        }),
                        phase === 'allocation' && fileReport && (()=>{
                            const allKeys = fileReport.importResult ? Object.keys(fileReport.importResult) : [];
                            let statTotal = 0, statHigh = 0, statMedium = 0, statNeedAttention = 0, statUnallocated = 0;
                            allKeys.forEach((k)=>{
                                const entry = fileReport.importResult[k];
                                const score = entry.matchScore != null ? Math.round(entry.matchScore * 10) : null;
                                const secs = Array.isArray(entry.section) ? entry.section : [
                                    entry.section
                                ];
                                const primaryQNo = secs[0];
                                statTotal++;
                                if (primaryQNo === 'DXXX' || primaryQNo === 'SXXX') {
                                    statNeedAttention++;
                                    statUnallocated++;
                                } else if (score !== null && score >= 8) statHigh++;
                                else if (score !== null && score >= 6) statMedium++;
                                else statNeedAttention++;
                            });
                            const tabFilteredKeys = allocationTab === 'unallocated' ? allKeys.filter((k)=>{
                                const secs = Array.isArray(fileReport.importResult[k].section) ? fileReport.importResult[k].section : [
                                    fileReport.importResult[k].section
                                ];
                                return secs.some((q)=>q === 'DXXX' || q === 'SXXX');
                            }) : allKeys;
                            const hasAllocated = allKeys.some((k)=>{
                                const secs = Array.isArray(fileReport.importResult[k].section) ? fileReport.importResult[k].section : [
                                    fileReport.importResult[k].section
                                ];
                                return secs.some((q)=>q !== 'DXXX' && q !== 'SXXX');
                            });
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    renderHeader(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df oh w100",
                                        style: {
                                            minHeight: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                style: {
                                                    flex: 1,
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "px3rem pt2rem",
                                                        style: {
                                                            flexShrink: 0
                                                        },
                                                        children: [
                                                            renderTopHead(sidebarSteps[3]),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic jcsb fww bg1 br10px p1-5rem mb1rem bw1px bss bo29",
                                                                style: {
                                                                    gap: '1rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        style: {
                                                                            gap: '2rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c15 fw600 fs1-75rem lh1",
                                                                                        children: statTotal
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c12 fw400 fs12px mt0-25rem",
                                                                                        children: "Allocated"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                style: {
                                                                                    width: 1,
                                                                                    height: 36,
                                                                                    background: '#E5E7EB'
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fw600 fs1-75rem lh1",
                                                                                        style: {
                                                                                            color: '#16a34a'
                                                                                        },
                                                                                        children: statHigh
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c12 fw400 fs12px mt0-25rem",
                                                                                        children: "High confidence"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                style: {
                                                                                    width: 1,
                                                                                    height: 36,
                                                                                    background: '#E5E7EB'
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fw600 fs1-75rem lh1",
                                                                                        style: {
                                                                                            color: '#d97706'
                                                                                        },
                                                                                        children: statMedium
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c12 fw400 fs12px mt0-25rem",
                                                                                        children: "Medium"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                style: {
                                                                                    width: 1,
                                                                                    height: 36,
                                                                                    background: '#E5E7EB'
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fw600 fs1-75rem lh1",
                                                                                        style: {
                                                                                            color: '#dc2626'
                                                                                        },
                                                                                        children: statNeedAttention
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c12 fw400 fs12px mt0-25rem",
                                                                                        children: "Need attention"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        style: {
                                                                            gap: '0.5rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                onClick: ()=>setAllocationTab('all'),
                                                                                class: `cp br50px px1-5rem py0-5rem fs13px fw500 ${allocationTab === 'all' ? 'bg3 c1' : 'bg1 c14 bw1px bss bo16'}`,
                                                                                children: "All allocations"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                onClick: ()=>setAllocationTab('unallocated'),
                                                                                class: `cp br50px px1-5rem py0-5rem fs13px fw500 ${allocationTab === 'unallocated' ? 'bg3 c1' : 'bg1 c14 bw1px bss bo16'}`,
                                                                                children: [
                                                                                    "Unallocated (",
                                                                                    statUnallocated,
                                                                                    ")"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "px3rem",
                                                        style: {
                                                            flex: 1,
                                                            overflowY: 'auto'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "br10px oh bw1px bss bo29 bg1",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                                className: "w100",
                                                                style: {
                                                                    borderCollapse: 'collapse',
                                                                    tableLayout: 'fixed'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            className: "bg5",
                                                                            style: {
                                                                                borderBottom: '2px solid #DDE2F2'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                    className: "px1rem py0-75rem tal fs11px ttu fw600 c14 bg5",
                                                                                    style: {
                                                                                        width: '22%',
                                                                                        letterSpacing: '0.06em'
                                                                                    },
                                                                                    children: "File Name"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                    className: "px1rem py0-75rem tal fs11px ttu fw600 c14 bg5",
                                                                                    style: {
                                                                                        width: '20%',
                                                                                        letterSpacing: '0.06em'
                                                                                    },
                                                                                    children: "Section"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                    className: "px1rem py0-75rem tal fs11px ttu fw600 c14 bg5",
                                                                                    style: {
                                                                                        width: '32%',
                                                                                        letterSpacing: '0.06em'
                                                                                    },
                                                                                    children: "Question"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                    className: "px1rem py0-75rem tac fs11px ttu fw600 c14 bg5",
                                                                                    style: {
                                                                                        width: '14%',
                                                                                        letterSpacing: '0.06em'
                                                                                    },
                                                                                    children: "% Confidence"
                                                                                }),
                                                                                fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                    className: "px1rem py0-75rem tal fs11px ttu fw600 c14 bg5",
                                                                                    style: {
                                                                                        width: '12%',
                                                                                        letterSpacing: '0.06em'
                                                                                    },
                                                                                    children: "Action"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                        children: tabFilteredKeys.map((k)=>getImportResultEntryHTML(k))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic jcc px3rem py1rem mt1rem",
                                                        style: {
                                                            flexShrink: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: handleCancel,
                                                                class: "mr1rem",
                                                                style: $317086ac24816082$var$btnCancel,
                                                                children: "Cancel"
                                                            }),
                                                            fileReport['status'] == 'In Progress' && hasAllocated && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: onClickReallocationComplete,
                                                                className: "cp bg4 c1 fs14px px2rem py0-5rem br20px",
                                                                children: "Confirm Allocation"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            previewFile && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "w40 df fdc oh",
                                                style: {
                                                    minWidth: 0,
                                                    borderLeft: '1px solid #E5E7EB',
                                                    flexShrink: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb aic px1-5rem py1rem",
                                                        style: {
                                                            borderBottom: '1px solid #E5E7EB',
                                                            flexShrink: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    minWidth: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42c665bd8834dbf3$export$2e2bcd8739ae039), {
                                                                        className: "cp mr0-5rem c12",
                                                                        style: {
                                                                            flexShrink: 0
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "c15 fw600 fs14px mb0rem oh",
                                                                        title: previewFile.name,
                                                                        style: {
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: 'nowrap',
                                                                            minWidth: 0
                                                                        },
                                                                        children: previewFile.name
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic ml0-5rem",
                                                                style: {
                                                                    flexShrink: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                        href: previewFile.url,
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer",
                                                                        className: "cp mr0-5rem fs12px c3 fw500 tdu",
                                                                        children: "Open"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8754c86021516b$export$2e2bcd8739ae039), {
                                                                        className: "cp fs1rem c12",
                                                                        onClick: ()=>setPreviewFile(null)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: 1,
                                                            overflow: 'hidden'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                                            src: previewFile.viewerUrl || previewFile.url,
                                                            title: `Preview: ${previewFile.name}`,
                                                            style: {
                                                                width: '100%',
                                                                height: '100%',
                                                                border: 'none'
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            !previewFile && renderSidebar()
                                        ]
                                    })
                                ]
                            });
                        })(),
                        phase === 'processing' && (()=>{
                            const savingPct = savingProgress.total > 0 ? Math.round(savingProgress.current / savingProgress.total * 100) : 0;
                            const hasStarted = savingProgress.current > 0;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    renderHeader(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df oh",
                                        style: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc px3rem pt2rem pb2rem",
                                                style: {
                                                    flex: 1
                                                },
                                                children: [
                                                    renderTopHead(sidebarSteps[4]),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w70 df fdc px2rem py0-5rem br10px bg1 mb1rem bw1px bss bo16",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        className: "w80px",
                                                                        src: (parcelRequire("hA45b")),
                                                                        alt: "processing"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "w100 c15 fw600 fs15px mb0-25rem",
                                                                                children: "Saving & Indexing files"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "c27 fs12px fw300 fsi",
                                                                                children: "Linking documents to module answers"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bg24 br10px h10px mb0-5rem oh",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            class: "h100 br10px",
                                                                            style: {
                                                                                background: 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                                                width: `${savingPct}%`,
                                                                                transition: 'width 0.4s ease'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df jcsb aic mt0-5rem mb1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c14 fs12px fw400",
                                                                                children: "Progress"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c3 fs12px fw600",
                                                                                children: [
                                                                                    savingPct,
                                                                                    "%"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb aife",
                                                        style: {
                                                            gap: '1rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc",
                                                                style: {
                                                                    gap: '0.5rem',
                                                                    flex: 1
                                                                },
                                                                children: [
                                                                    hasStarted && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w50 df aic px1-5rem py1rem br10px",
                                                                        style: {
                                                                            background: '#e8ffee',
                                                                            gap: '0.75rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df aic jcc bg30 br50px",
                                                                                style: {
                                                                                    width: 24,
                                                                                    height: 24
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                    width: "12",
                                                                                    height: "12",
                                                                                    viewBox: "0 0 12 12",
                                                                                    fill: "none",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2 6L5 9L10 3",
                                                                                        stroke: "white",
                                                                                        strokeWidth: "2",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c14 fs13px fw500",
                                                                                children: "Preparing document links..."
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w70 df fdc p1rem br10px bg5 mb1-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "w100 fs13px fw500 c12 mb0-5rem",
                                                                                children: "Currently working on"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic",
                                                                                style: {
                                                                                    gap: '0.5rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                        width: "23",
                                                                                        height: "23",
                                                                                        viewBox: "0 0 26 26",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M13 0C5.83151 0 0 5.83151 0 13C0 20.1685 5.83151 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83151 20.1685 0 13 0Z",
                                                                                                fill: "#4A67FF"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M16.8571 4.83427L17.4107 6.36893C18.0248 8.07274 19.3667 9.41468 21.0705 10.0287L22.6052 10.5823C22.7436 10.6326 22.7436 10.8284 22.6052 10.8786L21.0705 11.4322C19.3667 12.0463 18.0248 13.3882 17.4107 15.092L16.8571 16.6267C16.8069 16.7651 16.6111 16.7651 16.5608 16.6267L16.0073 15.092C15.3932 13.3882 14.0513 12.0463 12.3474 11.4322L10.8128 10.8786C10.6744 10.8284 10.6744 10.6326 10.8128 10.5823L12.3474 10.0287C14.0513 9.41468 15.3932 8.07274 16.0073 6.36893L16.5608 4.83427C16.6111 4.69587 16.8069 4.69587 16.8571 4.83427Z",
                                                                                                fill: "white"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M8.82485 11.4753L9.25542 12.6689C9.73303 13.9941 10.7768 15.0378 12.1019 15.5154L13.2956 15.946C13.4032 15.9851 13.4032 16.1373 13.2956 16.1764L12.1019 16.607C10.7768 17.0846 9.73303 18.1283 9.25542 19.4535L8.82485 20.6471C8.78578 20.7548 8.63349 20.7548 8.59442 20.6471L8.16385 19.4535C7.68624 18.1283 6.64252 17.0846 5.31733 16.607L4.1237 16.1764C4.01606 16.1373 4.01606 15.9851 4.1237 15.946L5.31733 15.5154C6.64252 15.0378 7.68624 13.9941 8.16385 12.6689L8.59442 11.4753C8.63349 11.3676 8.78578 11.3676 8.82485 11.4753Z",
                                                                                                fill: "white"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fs13px fw400 c15",
                                                                                        children: savingProgress.fileName || 'Allocating document links to module answers...'
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: "Syncing with module database..."
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: "Completing index..."
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    gap: '0.75rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleCancel,
                                                                        style: $317086ac24816082$var$btnCancel,
                                                                        children: "Cancel"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleMinimize,
                                                                        style: $317086ac24816082$var$btnMinimize,
                                                                        children: "Minimize"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            renderSidebar()
                                        ]
                                    })
                                ]
                            });
                        })(),
                        phase === 'filling' && (()=>{
                            const fillingPct = modal.autoFillTotal > 0 ? Math.round((modal.autoFillCurrent || 0) / modal.autoFillTotal * 100) : 0;
                            const rawSection = modal.autoFillSectionName || null;
                            const sectionLabel = rawSection && rawSection.length > 30 ? rawSection.slice(0, 30) + "\u2026" : rawSection;
                            const questionText = modal.autoFillQuestionText || null;
                            const questionNo = modal.autoFillSectionNo || '';
                            const rawFiles = modal.autoFillReadingFiles || [];
                            const readingFiles = rawFiles.length > 0 ? (rawFiles[0].length > 40 ? rawFiles[0].slice(0, 40) + "\u2026" : rawFiles[0]) + (rawFiles.length > 1 ? ` +${rawFiles.length - 1} more` : '') : null;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    renderHeader(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df oh",
                                        style: {
                                            flex: 1,
                                            overflow: 'hidden'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc px3rem pt2rem pb2rem",
                                                style: {
                                                    flex: 1
                                                },
                                                children: [
                                                    renderTopHead(sidebarSteps[5]),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w70 df fdc px2rem py0-5rem br10px bg1 mb1rem bw1px bss bo16",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        className: "w80px",
                                                                        src: (parcelRequire("hA45b")),
                                                                        alt: "processing"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "w100 c15 fw600 fs15px mb0-25rem",
                                                                                children: [
                                                                                    "Finding answers to your questions",
                                                                                    modal.autoFillTotal > 0 && ` \u{2014} ${modal.autoFillTotal} questions`
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "c27 fs12px fw300 fsi",
                                                                                children: "We're using AI to find answers from your documents. Please wait while the magic happen!"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bg24 br10px h10px mb0-5rem oh",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            class: "h100 br10px",
                                                                            style: {
                                                                                background: 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                                                width: `${fillingPct}%`,
                                                                                transition: 'width 0.4s ease'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df jcsb aic mt0-5rem mb1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c14 fs12px fw400",
                                                                                children: "Progress"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "df aic",
                                                                                style: {
                                                                                    gap: '0.5rem'
                                                                                },
                                                                                children: [
                                                                                    fillingEta && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c14 fs12px fw400",
                                                                                        children: fillingEta
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "c3 fs12px fw600",
                                                                                        children: [
                                                                                            fillingPct,
                                                                                            "%"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb",
                                                        style: {
                                                            alignItems: 'flex-end',
                                                            gap: '1rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc",
                                                                style: {
                                                                    gap: '0.5rem',
                                                                    flex: 1
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w70 df fdc p1rem br10px bg5 mb1-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "w100 fs13px fw500 c12 mb0-5rem",
                                                                                children: "Currently working on"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df jcsb",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df fdc",
                                                                                        style: {
                                                                                            minWidth: 0
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "df aic",
                                                                                                style: {
                                                                                                    gap: '0.35rem'
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                        width: "25",
                                                                                                        height: "25",
                                                                                                        viewBox: "0 0 26 26",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M13 0C5.83151 0 0 5.83151 0 13C0 20.1685 5.83151 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83151 20.1685 0 13 0Z",
                                                                                                                fill: "#4A67FF"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M16.8571 4.83427L17.4107 6.36893C18.0248 8.07274 19.3667 9.41468 21.0705 10.0287L22.6052 10.5823C22.7436 10.6326 22.7436 10.8284 22.6052 10.8786L21.0705 11.4322C19.3667 12.0463 18.0248 13.3882 17.4107 15.092L16.8571 16.6267C16.8069 16.7651 16.6111 16.7651 16.5608 16.6267L16.0073 15.092C15.3932 13.3882 14.0513 12.0463 12.3474 11.4322L10.8128 10.8786C10.6744 10.8284 10.6744 10.6326 10.8128 10.5823L12.3474 10.0287C14.0513 9.41468 15.3932 8.07274 16.0073 6.36893L16.5608 4.83427C16.6111 4.69587 16.8069 4.69587 16.8571 4.83427Z",
                                                                                                                fill: "white"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M8.82485 11.4753L9.25542 12.6689C9.73303 13.9941 10.7768 15.0378 12.1019 15.5154L13.2956 15.946C13.4032 15.9851 13.4032 16.1373 13.2956 16.1764L12.1019 16.607C10.7768 17.0846 9.73303 18.1283 9.25542 19.4535L8.82485 20.6471C8.78578 20.7548 8.63349 20.7548 8.59442 20.6471L8.16385 19.4535C7.68624 18.1283 6.64252 17.0846 5.31733 16.607L4.1237 16.1764C4.01606 16.1373 4.01606 15.9851 4.1237 15.946L5.31733 15.5154C6.64252 15.0378 7.68624 13.9941 8.16385 12.6689L8.59442 11.4753C8.63349 11.3676 8.78578 11.3676 8.82485 11.4753Z",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "fs13px fw400 c15",
                                                                                                        children: [
                                                                                                            "Section: ",
                                                                                                            sectionLabel || 'Loading...'
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            questionText && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "db fs12px fw400 c14 ml1-5rem",
                                                                                                style: {
                                                                                                    whiteSpace: 'normal',
                                                                                                    wordBreak: 'break-word'
                                                                                                },
                                                                                                children: questionNo ? `Question ${questionNo} \u{2013} "${questionText}"` : `"${questionText}"`
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "bg17 fw600 fs10px br50px px1rem py0-25rem c18",
                                                                                        style: {
                                                                                            flexShrink: 0
                                                                                        },
                                                                                        children: "Analyzing question..."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: "Analyzing question..."
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: [
                                                                                    " ",
                                                                                    readingFiles ? `Reading: ${readingFiles}` : 'Reading files...'
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: questionNo ? `Answering Q ${questionNo}...` : 'Answering question...'
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    gap: '0.75rem',
                                                                    flexShrink: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleCancel,
                                                                        style: $317086ac24816082$var$btnCancel,
                                                                        children: "Cancel"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleMinimize,
                                                                        style: $317086ac24816082$var$btnMinimize,
                                                                        children: "Minimize"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            renderSidebar()
                                        ]
                                    })
                                ]
                            });
                        })(),
                        phase === 'crossFileUpload' && (()=>{
                            const extraModules = autoFillContext?.extraModules || [];
                            const activeModKey = crossFileProgress.moduleType;
                            const completedCount = extraModules.filter((m)=>!!crossFileCompleted[m]).length;
                            const crossPct = extraModules.length > 0 ? Math.round(completedCount / extraModules.length * 100) : 0;
                            const rawDest = crossFileProgress.currentQuestionText || null;
                            const destText = rawDest && rawDest.length > 60 ? rawDest.slice(0, 60) + "\u2026" : rawDest;
                            const rawSrc = crossFileProgress.sourceFiles?.[0] || null;
                            const sourceFile = rawSrc && rawSrc.length > 40 ? rawSrc.slice(0, 40) + "\u2026" : rawSrc;
                            const countedModules = Object.keys(moduleQuestionCounts).length;
                            const totalQuestionsAllModules = Object.values(moduleQuestionCounts).reduce((s, n)=>s + n, 0);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    renderHeader(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df oh",
                                        style: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc px3rem pt2rem pb2rem",
                                                style: {
                                                    flex: 1
                                                },
                                                children: [
                                                    renderTopHead({
                                                        num: 7,
                                                        label: 'Cross File Upload',
                                                        badge: 'AI'
                                                    }, 'filling', getModuleLabel(crossFileProgress.moduleType || extraModules[0])),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w70 df fdc px2rem py0-5rem br10px bg1 mb1rem bw1px bss bo16",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        className: "w80px",
                                                                        src: (parcelRequire("hA45b")),
                                                                        alt: "crossFileUpload"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "w100 c15 fw600 fs15px mb0-25rem",
                                                                                children: "Uploading Files to Other Modules"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c27 fs12px fw300 fsi",
                                                                                children: [
                                                                                    "Transferring documents from Data Repository to selected modules",
                                                                                    countedModules > 0 && ` \u{2014} ${totalQuestionsAllModules} questions across ${countedModules} modules`
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bg24 br10px h10px mb0-5rem oh",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "h100 br10px",
                                                                            style: {
                                                                                background: 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                                                width: `${crossPct}%`,
                                                                                transition: 'width 0.4s ease'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df jcsb aic mt0-5rem mb1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c14 fs12px fw400",
                                                                                children: "Progress"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c3 fs12px fw600",
                                                                                children: [
                                                                                    crossPct,
                                                                                    "%"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb aife mt1rem",
                                                        style: {
                                                            gap: '1rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fdc",
                                                                style: {
                                                                    gap: '0.5rem',
                                                                    flex: 1
                                                                },
                                                                children: extraModules.map((modKey)=>{
                                                                    const isDone = !!crossFileCompleted[modKey];
                                                                    const isActive = activeModKey === modKey && !isDone;
                                                                    const label = getModuleLabel(modKey);
                                                                    const qCount = moduleQuestionCounts[modKey];
                                                                    if (isDone) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w50 df aic px1-5rem py1rem br10px",
                                                                        style: {
                                                                            background: '#e8ffee',
                                                                            gap: '0.75rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df aic jcc bg30 br50px",
                                                                                style: {
                                                                                    width: 24,
                                                                                    height: 24
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                    width: "12",
                                                                                    height: "12",
                                                                                    viewBox: "0 0 12 12",
                                                                                    fill: "none",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2 6L5 9L10 3",
                                                                                        stroke: "white",
                                                                                        strokeWidth: "2",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c14 fs13px fw500",
                                                                                children: [
                                                                                    label,
                                                                                    " \u2014 ",
                                                                                    crossFileCompleted[modKey].uploaded ?? 0,
                                                                                    " files uploaded"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, modKey);
                                                                    if (isActive) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w70 df fdc p1rem br10px bg5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "w100 fs13px fw500 c12 mb0-5rem",
                                                                                children: "Currently working on"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic mb0-25rem",
                                                                                style: {
                                                                                    gap: '0.5rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                        width: "23",
                                                                                        height: "23",
                                                                                        viewBox: "0 0 26 26",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M13 0C5.83151 0 0 5.83151 0 13C0 20.1685 5.83151 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83151 20.1685 0 13 0Z",
                                                                                                fill: "#4A67FF"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M16.8571 4.83427L17.4107 6.36893C18.0248 8.07274 19.3667 9.41468 21.0705 10.0287L22.6052 10.5823C22.7436 10.6326 22.7436 10.8284 22.6052 10.8786L21.0705 11.4322C19.3667 12.0463 18.0248 13.3882 17.4107 15.092L16.8571 16.6267C16.8069 16.7651 16.6111 16.7651 16.5608 16.6267L16.0073 15.092C15.3932 13.3882 14.0513 12.0463 12.3474 11.4322L10.8128 10.8786C10.6744 10.8284 10.6744 10.6326 10.8128 10.5823L12.3474 10.0287C14.0513 9.41468 15.3932 8.07274 16.0073 6.36893L16.5608 4.83427C16.6111 4.69587 16.8069 4.69587 16.8571 4.83427Z",
                                                                                                fill: "white"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M8.82485 11.4753L9.25542 12.6689C9.73303 13.9941 10.7768 15.0378 12.1019 15.5154L13.2956 15.946C13.4032 15.9851 13.4032 16.1373 13.2956 16.1764L12.1019 16.607C10.7768 17.0846 9.73303 18.1283 9.25542 19.4535L8.82485 20.6471C8.78578 20.7548 8.63349 20.7548 8.59442 20.6471L8.16385 19.4535C7.68624 18.1283 6.64252 17.0846 5.31733 16.607L4.1237 16.1764C4.01606 16.1373 4.01606 15.9851 4.1237 15.946L5.31733 15.5154C6.64252 15.0378 7.68624 13.9941 8.16385 12.6689L8.59442 11.4753C8.63349 11.3676 8.78578 11.3676 8.82485 11.4753Z",
                                                                                                fill: "white"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        className: "fs13px fw400 c15",
                                                                                        children: [
                                                                                            label,
                                                                                            qCount != null && ` \u{2014} ${qCount} questions`
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            destText && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "w100 db oh fs12px fw400 c14 mt0-25rem",
                                                                                style: {
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap'
                                                                                },
                                                                                children: [
                                                                                    'Uploading to: "',
                                                                                    destText,
                                                                                    '"'
                                                                                ]
                                                                            }),
                                                                            sourceFile && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "w100 db oh fs12px fw400 c27 mt0-25rem",
                                                                                style: {
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap'
                                                                                },
                                                                                children: [
                                                                                    "Document: ",
                                                                                    sourceFile
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, modKey);
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: [
                                                                                    label,
                                                                                    qCount != null && ` \u{2014} ${qCount} questions`
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, modKey);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    gap: '0.75rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleCancel,
                                                                        style: $317086ac24816082$var$btnCancel,
                                                                        children: "Cancel"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleMinimize,
                                                                        style: $317086ac24816082$var$btnMinimize,
                                                                        children: "Minimize"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            renderSidebar()
                                        ]
                                    })
                                ]
                            });
                        })(),
                        phase === 'otherModules' && (()=>{
                            const extraModules = autoFillContext?.extraModules || [];
                            const activeModKey = otherModulesProgress.moduleType;
                            const completedCount = extraModules.filter((m)=>!!otherModulesCompleted[m]).length;
                            const otherPct = extraModules.length > 0 ? Math.round(completedCount / extraModules.length * 100) : 0;
                            const questionText = otherModulesProgress.currentQuestionText || null;
                            const rawSrc = otherModulesProgress.sourceFiles?.[0] || null;
                            const sourceFile = rawSrc && rawSrc.length > 40 ? rawSrc.slice(0, 40) + "\u2026" : rawSrc;
                            const countedModules = Object.keys(moduleQuestionCounts).length;
                            const totalQuestionsAllModules = Object.values(moduleQuestionCounts).reduce((s, n)=>s + n, 0);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    renderHeader(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df oh",
                                        style: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc px3rem pt2rem pb2rem",
                                                style: {
                                                    flex: 1
                                                },
                                                children: [
                                                    renderTopHead({
                                                        num: 8,
                                                        label: 'Other Modules',
                                                        badge: 'AI'
                                                    }, 'crossFileUpload', getModuleLabel(otherModulesProgress.moduleType || extraModules[0])),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w70 df fdc px2rem py0-5rem br10px bg1 mb1rem bw1px bss bo16",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        className: "w80px",
                                                                        src: (parcelRequire("hA45b")),
                                                                        alt: "otherModules"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "w100 c15 fw600 fs15px mb0-25rem",
                                                                                children: [
                                                                                    "Filling Answers in Other Modules",
                                                                                    countedModules > 0 && ` \u{2014} ${totalQuestionsAllModules} questions across ${countedModules} modules`
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "c27 fs12px fw300 fsi",
                                                                                children: "AI is filling answers in selected modules using your documents"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bg24 br10px h10px mb0-5rem oh",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "h100 br10px",
                                                                            style: {
                                                                                background: 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                                                width: `${otherPct}%`,
                                                                                transition: 'width 0.4s ease'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df jcsb aic mt0-5rem mb1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c14 fs12px fw400",
                                                                                children: "Progress"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "df aic",
                                                                                style: {
                                                                                    gap: '0.5rem'
                                                                                },
                                                                                children: [
                                                                                    otherModulesEta && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c14 fs12px fw400",
                                                                                        children: otherModulesEta
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "c3 fs12px fw600",
                                                                                        children: [
                                                                                            otherPct,
                                                                                            "%"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb aife",
                                                        style: {
                                                            gap: '1rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fdc",
                                                                style: {
                                                                    gap: '0.5rem',
                                                                    flex: 1
                                                                },
                                                                children: extraModules.map((modKey)=>{
                                                                    const isDone = !!otherModulesCompleted[modKey];
                                                                    const isActive = activeModKey === modKey && !isDone;
                                                                    const label = getModuleLabel(modKey);
                                                                    const completed = otherModulesCompleted[modKey];
                                                                    const qCount = moduleQuestionCounts[modKey];
                                                                    if (isDone) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w50 df aic px1-5rem py1rem br10px",
                                                                        style: {
                                                                            background: '#e8ffee',
                                                                            gap: '0.75rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df aic jcc bg30 br50px",
                                                                                style: {
                                                                                    width: 24,
                                                                                    height: 24
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                    width: "12",
                                                                                    height: "12",
                                                                                    viewBox: "0 0 12 12",
                                                                                    fill: "none",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2 6L5 9L10 3",
                                                                                        stroke: "white",
                                                                                        strokeWidth: "2",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c14 fs13px fw500",
                                                                                children: [
                                                                                    label,
                                                                                    " \u2014 ",
                                                                                    completed.answered,
                                                                                    " answered, ",
                                                                                    completed.skipped,
                                                                                    " skipped"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, modKey);
                                                                    if (isActive) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w70 df fdc p1rem br10px bg5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "w100 fs13px fw500 c12 mb0-5rem",
                                                                                children: "Currently working on"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic mb0-25rem",
                                                                                style: {
                                                                                    gap: '0.5rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                        width: "23",
                                                                                        height: "23",
                                                                                        viewBox: "0 0 26 26",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M13 0C5.83151 0 0 5.83151 0 13C0 20.1685 5.83151 26 13 26C20.1685 26 26 20.1685 26 13C26 5.83151 20.1685 0 13 0Z",
                                                                                                fill: "#4A67FF"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M16.8571 4.83427L17.4107 6.36893C18.0248 8.07274 19.3667 9.41468 21.0705 10.0287L22.6052 10.5823C22.7436 10.6326 22.7436 10.8284 22.6052 10.8786L21.0705 11.4322C19.3667 12.0463 18.0248 13.3882 17.4107 15.092L16.8571 16.6267C16.8069 16.7651 16.6111 16.7651 16.5608 16.6267L16.0073 15.092C15.3932 13.3882 14.0513 12.0463 12.3474 11.4322L10.8128 10.8786C10.6744 10.8284 10.6744 10.6326 10.8128 10.5823L12.3474 10.0287C14.0513 9.41468 15.3932 8.07274 16.0073 6.36893L16.5608 4.83427C16.6111 4.69587 16.8069 4.69587 16.8571 4.83427Z",
                                                                                                fill: "white"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M8.82485 11.4753L9.25542 12.6689C9.73303 13.9941 10.7768 15.0378 12.1019 15.5154L13.2956 15.946C13.4032 15.9851 13.4032 16.1373 13.2956 16.1764L12.1019 16.607C10.7768 17.0846 9.73303 18.1283 9.25542 19.4535L8.82485 20.6471C8.78578 20.7548 8.63349 20.7548 8.59442 20.6471L8.16385 19.4535C7.68624 18.1283 6.64252 17.0846 5.31733 16.607L4.1237 16.1764C4.01606 16.1373 4.01606 15.9851 4.1237 15.946L5.31733 15.5154C6.64252 15.0378 7.68624 13.9941 8.16385 12.6689L8.59442 11.4753C8.63349 11.3676 8.78578 11.3676 8.82485 11.4753Z",
                                                                                                fill: "white"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        className: "fs13px fw400 c15",
                                                                                        children: [
                                                                                            label,
                                                                                            qCount != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                                className: "fs14px fw600",
                                                                                                children: [
                                                                                                    " \u2014 ",
                                                                                                    qCount,
                                                                                                    " questions"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            questionText && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "w100 db fs12px fw400 c14 mt0-25rem",
                                                                                style: {
                                                                                    whiteSpace: 'normal',
                                                                                    wordBreak: 'break-word'
                                                                                },
                                                                                children: [
                                                                                    'Question: "',
                                                                                    questionText,
                                                                                    '"'
                                                                                ]
                                                                            }),
                                                                            sourceFile && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "w100 db oh fs12px fw400 c27 mt0-25rem",
                                                                                style: {
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap'
                                                                                },
                                                                                children: [
                                                                                    "Reading: ",
                                                                                    sourceFile
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, modKey);
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: [
                                                                                    label,
                                                                                    qCount != null && ` \u{2014} ${qCount} questions`
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, modKey);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    gap: '0.75rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleCancel,
                                                                        style: $317086ac24816082$var$btnCancel,
                                                                        children: "Cancel"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleMinimize,
                                                                        style: $317086ac24816082$var$btnMinimize,
                                                                        children: "Minimize"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            renderSidebar()
                                        ]
                                    })
                                ]
                            });
                        })(),
                        phase === 'researchAid' && (()=>{
                            const doneCount = $317086ac24816082$var$REPORT_TYPES.filter((rt)=>reportCards[rt]?.status === 'done' || reportCards[rt]?.status === 'failed').length;
                            const researchPct = Math.round(doneCount / $317086ac24816082$var$REPORT_TYPES.length * 100);
                            const elapsedLabel = researchElapsedSec >= 60 ? `${Math.floor(researchElapsedSec / 60)}m ${researchElapsedSec % 60}s` : `${researchElapsedSec}s`;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    renderHeader(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df oh",
                                        style: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc px3rem pt2rem pb2rem",
                                                style: {
                                                    flex: 1
                                                },
                                                children: [
                                                    renderTopHead({
                                                        num: sidebarSteps.find((s)=>s.key === 'researchAid')?.num || 7,
                                                        label: 'Research Aid Reports',
                                                        badge: 'AI'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w70 df fdc px2rem py0-5rem br10px bg1 mb1rem bw1px bss bo16",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic jcsb mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        style: {
                                                                            gap: '0.5rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                className: "w80px",
                                                                                src: (parcelRequire("hA45b")),
                                                                                alt: "researchAid"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "w100 c15 fw600 fs15px mb0-25rem",
                                                                                        children: "Generating Your Research Reports"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "c27 fs12px fw300 fsi",
                                                                                        children: "AI is generating your complete set of 5 research reports"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc aic",
                                                                        style: {
                                                                            minWidth: '60px'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c3 fw600 fs1-5rem lh1",
                                                                                children: [
                                                                                    doneCount,
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "c12 fw400 fs1rem",
                                                                                        children: [
                                                                                            "/",
                                                                                            $317086ac24816082$var$REPORT_TYPES.length
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c12 fw400 fs11px",
                                                                                children: researchPct === 100 ? 'Complete' : `${elapsedLabel} elapsed`
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bg24 br10px h10px mb0-5rem oh",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "h100 br10px",
                                                                            style: {
                                                                                background: 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                                                width: `${researchPct}%`,
                                                                                transition: 'width 0.4s ease'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df jcsb aic mt0-5rem mb1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c14 fs12px fw400",
                                                                                children: "Progress"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c3 fs12px fw600",
                                                                                children: [
                                                                                    researchPct,
                                                                                    "%"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb aife",
                                                        style: {
                                                            gap: '1rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fdc",
                                                                style: {
                                                                    gap: '0.5rem',
                                                                    flex: 1
                                                                },
                                                                children: $317086ac24816082$var$REPORT_TYPES.map((rt)=>{
                                                                    const card = reportCards[rt] || {
                                                                        status: 'pending'
                                                                    };
                                                                    const icon = $317086ac24816082$var$REPORT_ICONS[rt];
                                                                    if (card.status === 'done') {
                                                                        const color = $317086ac24816082$var$reportScoreColor(card.score);
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df aic px1-5rem py1rem br10px",
                                                                            style: {
                                                                                background: '#e8ffee',
                                                                                gap: '0.75rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "df aic jcc bg30 br50px",
                                                                                    style: {
                                                                                        width: 24,
                                                                                        height: 24,
                                                                                        flexShrink: 0
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                        width: "12",
                                                                                        height: "12",
                                                                                        viewBox: "0 0 12 12",
                                                                                        fill: "none",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M2 6L5 9L10 3",
                                                                                            stroke: "white",
                                                                                            strokeWidth: "2",
                                                                                            strokeLinecap: "round",
                                                                                            strokeLinejoin: "round"
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                    className: `fa ${icon} c14`,
                                                                                    style: {
                                                                                        fontSize: '13px',
                                                                                        flexShrink: 0
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "c14 fs13px fw500",
                                                                                    style: {
                                                                                        flex: 1
                                                                                    },
                                                                                    children: [
                                                                                        $317086ac24816082$var$REPORT_LABELS[rt],
                                                                                        " \u2014 generated"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "fw700 fs12px br10px px0-75rem py0-25rem",
                                                                                    style: {
                                                                                        color: color,
                                                                                        background: color + '18',
                                                                                        flexShrink: 0
                                                                                    },
                                                                                    children: [
                                                                                        card.score,
                                                                                        "/5"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }, rt);
                                                                    }
                                                                    if (card.status === 'failed') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc px1-5rem py1rem br10px",
                                                                        style: {
                                                                            background: '#FFF5F7',
                                                                            gap: '0.25rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic",
                                                                                style: {
                                                                                    gap: '0.75rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fs14px",
                                                                                        children: "\u26A0\uFE0F"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: `fa ${icon} c4`,
                                                                                        style: {
                                                                                            fontSize: '13px'
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "c4 fs13px fw500",
                                                                                        children: [
                                                                                            $317086ac24816082$var$REPORT_LABELS[rt],
                                                                                            " \u2014 failed"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c27 fs11px fw400",
                                                                                style: {
                                                                                    marginLeft: '2rem'
                                                                                },
                                                                                children: card.error || "Something went wrong \u2014 retry from the ResearchAid tab."
                                                                            })
                                                                        ]
                                                                    }, rt);
                                                                    if (card.status === 'generating') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w70 df fdc p1rem br10px bg5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic jcsb",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fs13px fw500 c12",
                                                                                        children: "Currently working on"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fs11px fw400 c12",
                                                                                        children: elapsedLabel
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic mt0-25rem",
                                                                                style: {
                                                                                    gap: '0.5rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: `fa ${icon} c3`,
                                                                                        style: {
                                                                                            fontSize: '15px'
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        className: "fs13px fw400 c15",
                                                                                        children: [
                                                                                            "Generating: ",
                                                                                            $317086ac24816082$var$REPORT_LABELS[rt],
                                                                                            "\u2026"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "db fs11px fw400 c27 mt0-25rem",
                                                                                style: {
                                                                                    marginLeft: '1.5rem'
                                                                                },
                                                                                children: $317086ac24816082$var$REPORT_DESCRIPTIONS[rt]
                                                                            })
                                                                        ]
                                                                    }, rt);
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w20px h20px br50px bw4px bss bo4 mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                className: `fa ${icon} c27 mr0-5rem`,
                                                                                style: {
                                                                                    fontSize: '12px'
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs14px fw300 c27",
                                                                                children: $317086ac24816082$var$REPORT_LABELS[rt]
                                                                            })
                                                                        ]
                                                                    }, rt);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    gap: '0.75rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleCancel,
                                                                        style: $317086ac24816082$var$btnCancel,
                                                                        children: "Cancel"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleMinimize,
                                                                        style: $317086ac24816082$var$btnMinimize,
                                                                        children: "Minimize"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            renderSidebar()
                                        ]
                                    })
                                ]
                            });
                        })(),
                        phase === 'result' && (()=>{
                            const extraModules = autoFillContext?.extraModules || [];
                            const rawMainModuleLabel = modal.autoFillModuleName || autoFillContext?.moduleType || 'Repository';
                            const mainModuleLabel = rawMainModuleLabel === 'repository' ? 'Data Repository' : rawMainModuleLabel;
                            const totalAnswered = (modal.autoFillAnswered || 0) + extraModules.reduce((sum, m)=>sum + (otherModulesCompleted[m]?.answered || 0), 0);
                            const totalSkipped = (modal.autoFillSkipped || 0) + extraModules.reduce((sum, m)=>sum + (otherModulesCompleted[m]?.skipped || 0), 0);
                            const totalNeedsReview = (modal.autoFillNeedsReview || 0) + extraModules.reduce((sum, m)=>sum + (otherModulesCompleted[m]?.needsReview || 0), 0);
                            const totalProcessed = totalAnswered + totalSkipped + totalNeedsReview;
                            // Per-module accordion state
                            const allModuleKeys = [
                                autoFillContext?.moduleType || 'repository',
                                ...extraModules
                            ];
                            // Single platform tone for every module — bg20 (#f0f2fd), the site's card background, same as the Clarence sidebar bubble
                            const MODULE_HEADER_COLOR = {
                                bg: '#f0f2fd',
                                border: '#B2BDFF',
                                text: '#4A67FF',
                                dot: '#4A67FF'
                            };
                            const getModuleHeaderColor = ()=>MODULE_HEADER_COLOR;
                            const ResultModulePanel = ({ modKey: modKey, label: label, results: modResults, answered: answered, skipped: skipped, needsReview: nr })=>{
                                const filterKey = modKey;
                                const activeFilter = resultModuleFilter[filterKey] || 'Answered';
                                const setFilter = (f)=>setResultModuleFilter((prev)=>({
                                            ...prev,
                                            [filterKey]: f
                                        }));
                                const expanded = !!expandedModules[modKey];
                                const setExpanded = (val)=>setExpandedModules((prev)=>({
                                            ...prev,
                                            [modKey]: typeof val === 'function' ? val(!!prev[modKey]) : val
                                        }));
                                const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
                                const noAllocation = !modResults || modResults.length === 0;
                                const headerColor = getModuleHeaderColor(modKey);
                                const filtered = (modResults || []).filter((r)=>{
                                    const matchFilter = activeFilter === 'All' || activeFilter === 'Answered' && r.status === 'answered' || activeFilter === 'Skipped' && r.status === 'skipped' || activeFilter === 'Needs review' && r.status === 'needs_review';
                                    const matchSearch = !search || r.question?.toLowerCase().includes(search.toLowerCase()) || r.qNo?.toLowerCase().includes(search.toLowerCase());
                                    return matchFilter && matchSearch;
                                });
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "br10px oh mb1rem new-shadow",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            onClick: ()=>setExpanded((e)=>!e),
                                            className: "df aic px1rem py0-5rem cp fww",
                                            style: {
                                                background: headerColor.bg,
                                                gap: '0.75rem',
                                                userSelect: 'none',
                                                borderLeft: `4px solid ${headerColor.dot}`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs13px fw700 mi5rem ",
                                                    style: {
                                                        color: headerColor.text,
                                                        flex: 1
                                                    },
                                                    children: label
                                                }),
                                                noAllocation ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs11px c12",
                                                    children: "No questions allocated"
                                                }) : (()=>{
                                                    const moduleKey = modKey?.replace(/_[a-f0-9]{24}$/, '');
                                                    const moduleStats = company?.modules?.[moduleKey]?.stats || company?.directorsStats || {};
                                                    const riskPct = moduleStats.riskPercent ?? null;
                                                    const total = answered + skipped + (nr || 0);
                                                    const aiAnsweredPct = total > 0 ? Math.round(answered / total * 100) : 0;
                                                    // Platform Traffic Light tokens (CLAUDE.md): Red #F0606C, Yellow #F5F0BC, Green #40C353
                                                    const riskLabel = riskPct === null ? null : riskPct > 67 ? {
                                                        label: 'High risk',
                                                        color: '#F0606C',
                                                        bg: '#FDE8EA'
                                                    } : riskPct > 33 ? {
                                                        label: 'Medium risk',
                                                        color: '#8A7B1F',
                                                        bg: '#F5F0BC'
                                                    } : {
                                                        label: 'Low risk',
                                                        color: '#40C353',
                                                        bg: '#E4F7E8'
                                                    };
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "fs11px c3",
                                                                style: {
                                                                    flexShrink: 0
                                                                },
                                                                children: [
                                                                    answered,
                                                                    " answered \xb7 ",
                                                                    skipped,
                                                                    " skipped"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc aic",
                                                                style: {
                                                                    flexShrink: 0,
                                                                    background: 'rgba(255,255,255,0.7)',
                                                                    borderRadius: '6px',
                                                                    padding: '2px 8px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "fs12px fw700 c3",
                                                                        children: [
                                                                            aiAnsweredPct,
                                                                            "%"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs10px c12",
                                                                        children: "AI answered"
                                                                    })
                                                                ]
                                                            }),
                                                            riskLabel && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc aic ",
                                                                style: {
                                                                    flexShrink: 0,
                                                                    background: riskLabel.bg,
                                                                    borderRadius: '6px',
                                                                    padding: '2px 8px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "fs12px fw700",
                                                                        style: {
                                                                            color: riskLabel.color
                                                                        },
                                                                        children: [
                                                                            riskLabel.label,
                                                                            " ",
                                                                            riskPct !== null ? `${riskPct}%` : ''
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs10px",
                                                                        style: {
                                                                            color: riskLabel.color,
                                                                            opacity: 0.7
                                                                        },
                                                                        children: "Module risk"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    });
                                                })(),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    width: "14",
                                                    height: "14",
                                                    viewBox: "0 0 20 20",
                                                    fill: "none",
                                                    style: {
                                                        transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.2s',
                                                        color: headerColor.dot,
                                                        flexShrink: 0
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M5 7.5L10 12.5L15 7.5",
                                                        stroke: "currentColor",
                                                        strokeWidth: "1.8",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            ]
                                        }),
                                        expanded && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                borderTop: '1px solid #F3F4F6',
                                                background: '#FAFAFA'
                                            },
                                            children: noAllocation ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    padding: '1.25rem',
                                                    textAlign: 'center',
                                                    color: '#9CA3AF',
                                                    fontSize: '13px'
                                                },
                                                children: "No questions were allocated to this module from the selected files."
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        onClick: (e)=>e.stopPropagation(),
                                                        style: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '0.5rem',
                                                            padding: '0.625rem 0.75rem',
                                                            flexWrap: 'wrap',
                                                            borderBottom: '1px solid #F3F4F6'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    position: 'relative',
                                                                    flex: 1,
                                                                    minWidth: '140px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "13",
                                                                        height: "13",
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        style: {
                                                                            position: 'absolute',
                                                                            left: '9px',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            color: '#9CA3AF'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                cx: "9",
                                                                                cy: "9",
                                                                                r: "6",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M13.5 13.5L17 17",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "1.8",
                                                                                strokeLinecap: "round"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        value: search,
                                                                        onChange: (e)=>setSearch(e.target.value),
                                                                        placeholder: "Search questions...",
                                                                        style: {
                                                                            width: '100%',
                                                                            paddingLeft: '28px',
                                                                            paddingRight: '8px',
                                                                            paddingTop: '6px',
                                                                            paddingBottom: '6px',
                                                                            border: '1px solid #E5E7EB',
                                                                            borderRadius: '8px',
                                                                            fontSize: '12px',
                                                                            background: '#fff',
                                                                            outline: 'none',
                                                                            boxSizing: 'border-box',
                                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    display: 'flex',
                                                                    gap: '4px',
                                                                    flexShrink: 0,
                                                                    background: '#F3F4F6',
                                                                    borderRadius: '20px',
                                                                    padding: '3px'
                                                                },
                                                                children: [
                                                                    'All',
                                                                    'Answered',
                                                                    'Skipped',
                                                                    'Needs review'
                                                                ].map((f)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: (e)=>{
                                                                            e.stopPropagation();
                                                                            setFilter(f);
                                                                        },
                                                                        style: {
                                                                            fontSize: '11px',
                                                                            fontWeight: 600,
                                                                            padding: '3px 10px',
                                                                            borderRadius: '20px',
                                                                            border: 'none',
                                                                            background: activeFilter === f ? '#fff' : 'transparent',
                                                                            color: activeFilter === f ? '#1F2937' : '#6B7280',
                                                                            cursor: 'pointer',
                                                                            whiteSpace: 'nowrap',
                                                                            boxShadow: activeFilter === f ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                                                                            transition: 'all 0.15s'
                                                                        },
                                                                        children: f
                                                                    }, f))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "oa",
                                                        style: {
                                                            height: '50vh',
                                                            padding: '0 0.75rem 0.75rem'
                                                        },
                                                        children: filtered.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                textAlign: 'center',
                                                                color: '#9CA3AF',
                                                                fontSize: '12px',
                                                                padding: '1.5rem'
                                                            },
                                                            children: "No questions match this filter."
                                                        }) : filtered.map((r, i)=>{
                                                            const isAnswered = r.status === 'answered';
                                                            const isReview = r.status === 'needs_review';
                                                            // Platform Traffic Light tokens (CLAUDE.md): Green #40C353, Yellow #F5F0BC, Gray 4/7 for skipped
                                                            const statusStyle = isAnswered ? {
                                                                bg: '#E4F7E8',
                                                                color: '#0BA26F',
                                                                border: '#9BE0C1',
                                                                dot: '#40C353'
                                                            } : isReview ? {
                                                                bg: '#F5F0BC',
                                                                color: '#8A7B1F',
                                                                border: '#EAD394',
                                                                dot: '#F0AE0D'
                                                            } : {
                                                                bg: '#F5F6F9',
                                                                color: '#AAACB5',
                                                                border: '#D9D9D9',
                                                                dot: '#C8C9C9'
                                                            };
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    background: '#fff',
                                                                    borderRadius: '10px',
                                                                    padding: '0.75rem 0.875rem',
                                                                    marginBottom: '0.5rem',
                                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
                                                                    borderLeft: '3px solid #B2BDFF'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        style: {
                                                                            display: 'flex',
                                                                            alignItems: 'flex-start',
                                                                            gap: '0.625rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                style: {
                                                                                    flex: 1,
                                                                                    lineHeight: '1.5'
                                                                                },
                                                                                children: [
                                                                                    r.qNo && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        style: {
                                                                                            fontSize: '10px',
                                                                                            fontWeight: 700,
                                                                                            color: '#9CA3AF',
                                                                                            marginRight: '6px',
                                                                                            letterSpacing: '0.03em',
                                                                                            textTransform: 'uppercase'
                                                                                        },
                                                                                        children: r.qNo
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        style: {
                                                                                            fontSize: '12.5px',
                                                                                            fontWeight: 600,
                                                                                            color: '#111827'
                                                                                        },
                                                                                        children: r.question
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    fontSize: '10px',
                                                                                    fontWeight: 600,
                                                                                    padding: '3px 9px',
                                                                                    borderRadius: '20px',
                                                                                    flexShrink: 0,
                                                                                    background: statusStyle.bg,
                                                                                    color: statusStyle.color,
                                                                                    border: `1px solid ${statusStyle.border}`
                                                                                },
                                                                                children: isAnswered ? 'Answered' : isReview ? 'Needs review' : 'Skipped'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    r.answer && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        style: {
                                                                            fontSize: '12px',
                                                                            color: '#374151',
                                                                            marginTop: '6px',
                                                                            lineHeight: '1.55',
                                                                            background: '#F9FAFB',
                                                                            borderRadius: '6px',
                                                                            padding: '7px 10px',
                                                                            borderLeft: '2px solid #4A67FF'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                style: {
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    gap: '4px',
                                                                                    marginBottom: '3px'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                        width: "10",
                                                                                        height: "10",
                                                                                        viewBox: "0 0 20 20",
                                                                                        fill: "none",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M10 2a8 8 0 100 16A8 8 0 0010 2zm0 3v5l3.5 3.5-1.1 1.1L8 10.5V5h2z",
                                                                                            fill: "#9CA3AF"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        style: {
                                                                                            fontSize: '10px',
                                                                                            fontWeight: 600,
                                                                                            color: '#9CA3AF',
                                                                                            textTransform: 'uppercase',
                                                                                            letterSpacing: '0.04em'
                                                                                        },
                                                                                        children: "AI answer"
                                                                                    }),
                                                                                    r.confidence != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        style: {
                                                                                            marginLeft: 'auto',
                                                                                            fontSize: '10px',
                                                                                            fontWeight: 500,
                                                                                            color: r.confidence >= 0.7 ? '#0BA26F' : r.confidence >= 0.4 ? '#8A7B1F' : '#9CA3AF',
                                                                                            background: r.confidence >= 0.7 ? '#E9F8F1' : r.confidence >= 0.4 ? '#F5F0BC' : '#F3F4F6',
                                                                                            padding: '1px 6px',
                                                                                            borderRadius: '10px'
                                                                                        },
                                                                                        children: [
                                                                                            Math.round(r.confidence * 100),
                                                                                            "% confidence"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                style: {
                                                                                    fontWeight: 600,
                                                                                    marginBottom: r.explanation ? '4px' : 0
                                                                                },
                                                                                children: r.answer
                                                                            }),
                                                                            r.explanation && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                style: {
                                                                                    fontSize: '11px',
                                                                                    color: '#6B7280',
                                                                                    lineHeight: '1.5'
                                                                                },
                                                                                children: r.explanation
                                                                            })
                                                                        ]
                                                                    }),
                                                                    !r.answer && r.reason && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        style: {
                                                                            fontSize: '11.5px',
                                                                            color: '#6B7280',
                                                                            marginTop: '6px',
                                                                            lineHeight: '1.5',
                                                                            background: '#F9FAFB',
                                                                            borderRadius: '6px',
                                                                            padding: '7px 10px',
                                                                            borderLeft: '2px solid #D1D5DB',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '6px'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                width: "11",
                                                                                height: "11",
                                                                                viewBox: "0 0 20 20",
                                                                                fill: "none",
                                                                                style: {
                                                                                    flexShrink: 0,
                                                                                    color: '#9CA3AF'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                        cx: "10",
                                                                                        cy: "10",
                                                                                        r: "8",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "2"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M10 6v5M10 14v.5",
                                                                                        stroke: "currentColor",
                                                                                        strokeWidth: "2",
                                                                                        strokeLinecap: "round"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                children: {
                                                                                    no_relevant_docs: 'No relevant documents found to answer this question.',
                                                                                    no_relevant_info: 'Documents were found but contained no relevant information.',
                                                                                    answer_is_no: 'AI determined the answer is No based on available documents.',
                                                                                    error: 'An error occurred while processing this question.'
                                                                                }[r.reason] || r.reason
                                                                            })
                                                                        ]
                                                                    }),
                                                                    (r.sourceFiles || []).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        style: {
                                                                            display: 'flex',
                                                                            flexWrap: 'wrap',
                                                                            gap: '4px',
                                                                            marginTop: '6px'
                                                                        },
                                                                        children: r.sourceFiles.map((s, si)=>{
                                                                            const url = r.sourceUrls?.[si];
                                                                            const inner = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                        width: "9",
                                                                                        height: "9",
                                                                                        viewBox: "0 0 20 20",
                                                                                        fill: "none",
                                                                                        style: {
                                                                                            flexShrink: 0
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M4 4h5v2H6v8h8v-3h2v5H4V4zm7-1h6v6h-2V6.414l-5.293 5.293-1.414-1.414L13.586 5H11V3z",
                                                                                            fill: "currentColor"
                                                                                        })
                                                                                    }),
                                                                                    s
                                                                                ]
                                                                            });
                                                                            const style = {
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                gap: '3px',
                                                                                fontSize: '10px',
                                                                                background: '#EFF6FF',
                                                                                color: '#2563EB',
                                                                                borderRadius: '5px',
                                                                                padding: '2px 7px',
                                                                                fontWeight: 500,
                                                                                border: '1px solid #BFDBFE',
                                                                                textDecoration: 'none',
                                                                                ...url ? {
                                                                                    cursor: 'pointer'
                                                                                } : {}
                                                                            };
                                                                            return url ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                                href: url,
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                style: style,
                                                                                children: inner
                                                                            }, si) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: style,
                                                                                children: inner
                                                                            }, si);
                                                                        })
                                                                    })
                                                                ]
                                                            }, i);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            };
                            const aiBadge = /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df aic fs11px fw600 br10px bw1px bss c3 bo3",
                                style: {
                                    padding: '2px 8px',
                                    background: '#F3F4F6'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        style: {
                                            marginRight: '5px'
                                        },
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 12 12",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M3.02418 2.11073L4.0648 2.68026C4.1984 2.75292 4.24762 2.91933 4.17496 3.05292C4.14918 3.0998 4.11168 3.1373 4.0648 3.16308L3.02418 3.73026C2.9773 3.75605 2.9398 3.79355 2.91402 3.84042L2.34449 4.88105C2.27184 5.01464 2.10543 5.06386 1.97184 4.9912C1.92496 4.96542 1.88746 4.92792 1.86168 4.88105L1.29449 3.84042C1.26871 3.79355 1.23121 3.75605 1.18434 3.73026L0.14371 3.16308C0.0101167 3.09042 -0.039102 2.92401 0.0335542 2.79042C0.0593355 2.74355 0.0968355 2.70605 0.14371 2.68026L1.18434 2.11073C1.23121 2.08495 1.26871 2.04745 1.29449 2.00058L1.86402 0.962295C1.93668 0.828702 2.10543 0.779483 2.23902 0.854483C2.28355 0.880264 2.32105 0.917764 2.34684 0.962295L2.91637 2.00058C2.9398 2.04745 2.9773 2.08495 3.02418 2.11073Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M10.7703 7.665L11.8109 8.23453C11.9445 8.30719 11.9937 8.47359 11.9211 8.60719C11.8953 8.65406 11.8578 8.69156 11.8109 8.71734L10.7703 9.28687C10.7234 9.31266 10.6859 9.35016 10.6601 9.39703L10.0906 10.4377C10.0179 10.5712 9.84918 10.6205 9.71559 10.5478C9.66871 10.522 9.63121 10.4845 9.60543 10.4377L9.04059 9.39469C9.0148 9.34781 8.9773 9.31031 8.93043 9.28453L7.8898 8.715C7.75621 8.64234 7.70699 8.47359 7.77965 8.34C7.80543 8.29312 7.84293 8.25562 7.8898 8.22984L8.93043 7.66031C8.9773 7.63453 9.0148 7.59703 9.04059 7.55016L9.61012 6.51187C9.68277 6.37828 9.85152 6.32906 9.98512 6.40172C10.032 6.4275 10.0695 6.465 10.0953 6.51187L10.6648 7.5525C10.6859 7.60172 10.7234 7.63922 10.7703 7.665Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M6.26475 0.920021L6.94678 1.29268C7.0335 1.3419 7.06631 1.45205 7.01943 1.53877C7.00303 1.56924 6.97725 1.59268 6.94678 1.61143L6.26475 1.98408C6.23428 2.00049 6.2085 2.02627 6.19209 2.05674L5.81943 2.73877C5.77022 2.82549 5.66006 2.8583 5.57334 2.81143C5.54287 2.79502 5.51943 2.76924 5.50068 2.73877L5.12803 2.05674C5.11162 2.02627 5.08584 2.00049 5.05537 1.98408L4.37334 1.61143C4.28662 1.56455 4.25381 1.4544 4.30068 1.36533C4.31709 1.33486 4.34287 1.30908 4.37334 1.29268L5.05537 0.920021C5.08584 0.903614 5.11162 0.877833 5.12803 0.847364L5.50068 0.165333C5.5499 0.0786145 5.66006 0.045802 5.74678 0.092677C5.77725 0.109083 5.80068 0.134864 5.81943 0.165333L6.19209 0.847364C6.2085 0.877833 6.23428 0.903614 6.26475 0.920021Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M11.7341 1.23164L10.7708 0.268362C10.4146 -0.0878877 9.83564 -0.0902315 9.47705 0.266019C9.47705 0.266019 9.47705 0.266019 9.47471 0.268362L0.887208 8.85821C0.530958 9.21446 0.528614 9.79336 0.887208 10.152L1.85049 11.1152C2.20674 11.4715 2.78565 11.4738 3.14424 11.1152L11.7341 2.52539C12.0903 2.16914 12.0903 1.59024 11.7341 1.23164ZM8.38486 4.48008L7.52236 3.61758L10.0653 1.07227L10.9278 1.93477L8.38486 4.48008Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    "AI"
                                ]
                            });
                            const youBadge = /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df aic fs11px fw600 br10px bw1px bss c8 bo8",
                                style: {
                                    padding: '2px 6px',
                                    background: '#FEF3C7'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        style: {
                                            marginRight: '5px'
                                        },
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 12 12",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M8 6C8 7.10457 7.1046 8 6 8C4.89543 8 4 7.10457 4 6C4 4.89543 4.89543 4 6 4C7.1046 4 8 4.89543 8 6Z",
                                                fill: "#D9B11C"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M11.9366 5.74445C10.6417 3.27791 8.34186 2 6 2C3.65812 2 1.35827 3.27791 0.0633438 5.74445C-0.0211146 5.90532 -0.0211146 6.09468 0.0633438 6.25555C1.35827 8.72211 3.65812 10 6 10C8.34186 10 10.6417 8.72211 11.9366 6.25555C12.0211 6.09468 12.0211 5.90532 11.9366 5.74445ZM6 8.85714C4.21873 8.85714 2.39884 7.93097 1.2778 6C2.39884 4.06902 4.21873 3.14286 6 3.14286C7.78128 3.14286 9.60114 4.06902 10.7222 6C9.60114 7.93097 7.78128 8.85714 6 8.85714Z",
                                                fill: "#D9B11C"
                                            })
                                        ]
                                    }),
                                    "You"
                                ]
                            });
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    renderHeader(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df oh",
                                        style: {
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc px3rem pt2rem pb2rem",
                                                style: {
                                                    flex: 1
                                                },
                                                children: [
                                                    renderTopHead({
                                                        num: sidebarSteps.find((s)=>s.key === 'result')?.num || 7,
                                                        label: 'Auto-fill Complete',
                                                        badge: 'AI'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w70 df aic px3rem py2rem br10px bg1 mb1rem bw1px bss bo16",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df aic jcc br50px bg1 w70px h70px",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "100",
                                                                    height: "100",
                                                                    viewBox: "0 0 100 100",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M50 2.5C23.875 2.5 2.5 23.875 2.5 50C2.5 76.125 23.875 97.5 50 97.5C76.125 97.5 97.5 76.125 97.5 50C97.5 23.875 76.125 2.5 50 2.5ZM48.8125 71.7708C47.625 72.9583 46.0417 73.75 44.4583 73.75H44.0625C42.4792 73.75 40.8958 72.9583 39.7083 72.1667L26.0521 58.5104C23.7567 56.215 23.7567 52.4934 26.0521 50.1979C28.3475 47.9025 32.0691 47.9025 34.3646 50.1979L43.2708 59.1042L64.8584 33.1317C66.9289 30.6405 70.6247 30.2941 73.1221 32.3572L73.2172 32.4358C75.7041 34.4901 76.0707 38.1648 74.0387 40.67L48.8125 71.7708Z",
                                                                            fill: "url(#paint0_linear_6440_13848)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                id: "paint0_linear_6440_13848",
                                                                                x1: "-0.0510007",
                                                                                y1: "-4.851",
                                                                                x2: "91.965",
                                                                                y2: "95.99",
                                                                                gradientUnits: "userSpaceOnUse",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                        "stop-color": "#15D757"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                        offset: "1",
                                                                                        "stop-color": "#0BBE48"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc ml1rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "w100 c15 fw600 fs17px mb0-25rem",
                                                                        children: "Processing Complete"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "w100 c27 fs14px fw400 mb0rem",
                                                                        children: "We have finished processing all questions. Review the summary below."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w50 df mb1rem",
                                                        style: {
                                                            gap: '0.75rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc pr br10px p1rem",
                                                                style: {
                                                                    flex: 1,
                                                                    background: '#ECFDF5'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df jcfe mb0-5rem",
                                                                        children: aiBadge
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic ml2rem",
                                                                        style: {
                                                                            gap: '0.5rem'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fw600 mb0rem lh1 c30",
                                                                                        style: {
                                                                                            fontSize: '1.9rem'
                                                                                        },
                                                                                        children: totalAnswered
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fs10px fw500 c12 ttu",
                                                                                        children: "Answered"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs12px fw500 c12 mb0rem",
                                                                                children: "out of"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fw600 mb0rem lh1 c12",
                                                                                        style: {
                                                                                            fontSize: '2.2rem'
                                                                                        },
                                                                                        children: totalProcessed
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fs10px fw500 c12 ttu",
                                                                                        children: "Processed"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc pr br10px p1rem",
                                                                style: {
                                                                    flex: 1,
                                                                    background: '#F3F4F6'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df jcfe mb0-5rem",
                                                                        children: youBadge
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "w100 ml2rem fw600 mb0-25rem fs2rem lh1 c28",
                                                                        children: totalNeedsReview
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "w100 ml2rem fs12px fw500 c12",
                                                                        children: [
                                                                            "Questions requiring human ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            " review"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc pr br10px p1rem",
                                                                style: {
                                                                    flex: 1,
                                                                    background: '#EFF6FF'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df jcfe mb0-5rem",
                                                                        children: youBadge
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "w100 ml2rem fw600 mb0-25rem fs2rem lh1 c3",
                                                                        children: fileReport?.importResult ? Object.keys(fileReport.importResult).length : 0
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "w100 ml2rem fs12px fw500 c12",
                                                                        children: "Files Uploaded"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "mb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)(ResultModulePanel, {
                                                                modKey: autoFillContext?.moduleType || 'repository',
                                                                label: mainModuleLabel,
                                                                results: fillResults,
                                                                answered: modal.autoFillAnswered || 0,
                                                                skipped: modal.autoFillSkipped || 0,
                                                                needsReview: modal.autoFillNeedsReview || 0
                                                            }),
                                                            extraModules.map((modKey)=>{
                                                                const stats = otherModulesCompleted[modKey] || {
                                                                    answered: 0,
                                                                    skipped: 0,
                                                                    needsReview: 0,
                                                                    results: []
                                                                };
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)(ResultModulePanel, {
                                                                    modKey: modKey,
                                                                    label: getModuleLabel(modKey),
                                                                    results: stats.results,
                                                                    answered: stats.answered,
                                                                    skipped: stats.skipped,
                                                                    needsReview: stats.needsReview || 0
                                                                }, modKey);
                                                            })
                                                        ]
                                                    }),
                                                    reportsGenStatus && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "mb1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "w100 c15 fw600 fs14px mb0-5rem",
                                                                children: [
                                                                    "Research Reports ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "c12 fw400",
                                                                        children: "(set of 5)"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fww mb1rem",
                                                                style: {
                                                                    gap: '0.75rem'
                                                                },
                                                                children: $317086ac24816082$var$REPORT_TYPES.map((rt)=>{
                                                                    const card = reportCards[rt] || {
                                                                        status: 'pending'
                                                                    };
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "bo7 bg1 new-shadow br15px p1rem pr bsbb",
                                                                        style: {
                                                                            flex: '1 1 18%',
                                                                            minWidth: '150px'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "c12 fs10px fw400 mb0-5rem ttu",
                                                                                children: "Diligentsia ResearchAid"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "c15 fs13px fw500 mb1rem",
                                                                                children: $317086ac24816082$var$REPORT_LABELS[rt]
                                                                            }),
                                                                            card.status === 'pending' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df aic jcc",
                                                                                style: {
                                                                                    minHeight: '32px'
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c12 fs12px fw400",
                                                                                    children: "Queued"
                                                                                })
                                                                            }),
                                                                            card.status === 'generating' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic jcc",
                                                                                style: {
                                                                                    minHeight: '32px',
                                                                                    gap: '0.5rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$67ad50c48ca3ede4), {
                                                                                        height: "16",
                                                                                        width: "16",
                                                                                        strokeWidth: "4",
                                                                                        secondaryColor: "#DDE2F2",
                                                                                        color: "#4A67FF",
                                                                                        ariaLabel: "oval-loading"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c3 fs12px fw500",
                                                                                        children: "Generating\u2026"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            card.status === 'done' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df jcsb aic",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c12 fs10px",
                                                                                        children: "Just now"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        className: `fs1-25rem fw600 mb0rem ${card.score >= 4 ? 'c34' : card.score >= 2 ? 'c39' : 'c4'}`,
                                                                                        children: [
                                                                                            card.score,
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "fs10px",
                                                                                                children: "/5"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            card.status === 'failed' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fs14px mb0-25rem",
                                                                                        children: "\u26A0\uFE0F"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c4 fs11px fw500",
                                                                                        children: "Failed \u2014 retry from the ResearchAid tab"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, rt);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic br10px px1rem py0-75rem",
                                                                style: {
                                                                    background: '#EFF6FF',
                                                                    border: '1px solid #BFDBFE',
                                                                    gap: '0.75rem'
                                                                },
                                                                children: [
                                                                    reportsGenStatus === 'generating' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs16px",
                                                                                children: "\u2726"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c15 fs13px fw500",
                                                                                children: "Generating your Research Reports (complete set of 5)\u2026 this can take a few minutes, reports will appear in the ResearchAid tab."
                                                                            })
                                                                        ]
                                                                    }),
                                                                    reportsGenStatus === 'done' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs16px",
                                                                                children: "\u2705"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c15 fs13px fw500",
                                                                                children: "Research Reports generated \u2014 view them in the ResearchAid tab."
                                                                            })
                                                                        ]
                                                                    }),
                                                                    reportsGenStatus === 'partial' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs16px",
                                                                                children: "\u2705"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c15 fs13px fw500",
                                                                                children: [
                                                                                    reportsGenCounts.success,
                                                                                    " of ",
                                                                                    reportsGenCounts.total,
                                                                                    " Research Reports generated \u2014 the rest can be retried from the ResearchAid tab."
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    reportsGenStatus === 'error' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs16px",
                                                                                children: "\u26A0\uFE0F"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c15 fs13px fw500",
                                                                                children: "Research Report generation failed \u2014 you can retry from the ResearchAid tab."
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc aife pt0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>{
                                                                if (reportsGenStatus !== 'generating') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: '',
                                                                    autoFillStatusBarVisible: false,
                                                                    autoFillStatusBarPhase: '',
                                                                    autoFillStepperPhase: '',
                                                                    autoFillJustCompleted: true
                                                                }));
                                                            },
                                                            disabled: reportsGenStatus === 'generating',
                                                            className: `bg4 c1 br50px px3rem py0-75rem fw500 fs14px mb0-25rem ${reportsGenStatus === 'generating' ? 'op60' : 'cp'}`,
                                                            children: "Save & Continue"
                                                        })
                                                    })
                                                ]
                                            }),
                                            renderSidebar()
                                        ]
                                    })
                                ]
                            });
                        })()
                    ]
                }),
                aiPopover && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    onClick: ()=>{
                        if (aiPopover.pinned) setAiPopover(null);
                    },
                    style: {
                        position: 'fixed',
                        inset: 0,
                        zIndex: 9999,
                        pointerEvents: aiPopover.pinned ? 'auto' : 'none'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        onClick: (e)=>e.stopPropagation(),
                        style: {
                            position: 'fixed',
                            top: Math.max(8, aiPopover.y - 280),
                            left: Math.min(Math.max(aiPopover.x - 260, 8), window.innerWidth - 296),
                            width: '280px',
                            background: '#fff',
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                            padding: '1rem',
                            zIndex: 10000,
                            border: '1px solid #E5E7EB'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginBottom: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("bi4Ns")),
                                                alt: "icon",
                                                className: "w20px h20px mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontWeight: 700,
                                                    fontSize: '13px',
                                                    color: '#111827'
                                                },
                                                children: aiPopover.isUnallocated ? 'Why Unallocated?' : 'AI Confidence'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>setAiPopover(null),
                                        style: {
                                            cursor: 'pointer',
                                            color: '#9CA3AF',
                                            fontSize: '14px',
                                            lineHeight: 1
                                        },
                                        children: "\u2715"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    height: '1px',
                                    background: '#F3F4F6',
                                    marginBottom: '0.75rem'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    marginBottom: '0.75rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '4px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '12px',
                                                    color: '#6B7280'
                                                },
                                                children: aiPopover.isUnallocated ? 'Confidence score' : 'Match score'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    fontSize: '13px',
                                                    fontWeight: 700,
                                                    color: aiPopover.scoreColor
                                                },
                                                children: [
                                                    aiPopover.scoreVal ? aiPopover.scoreVal : "\u2014",
                                                    aiPopover.scoreLabel ? " \u2014 " + aiPopover.scoreLabel : ''
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            height: '6px',
                                            borderRadius: '99px',
                                            background: '#F3F4F6',
                                            overflow: 'hidden'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                height: '100%',
                                                width: `${(aiPopover.scoreVal || 0) * 10}%`,
                                                background: aiPopover.scoreColor,
                                                borderRadius: '99px',
                                                transition: 'width 0.4s ease'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    height: '1px',
                                    background: '#F3F4F6',
                                    marginBottom: '0.75rem'
                                }
                            }),
                            aiPopover.isUnallocated ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: {
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            color: '#6B7280',
                                            marginBottom: '4px',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.05em'
                                        },
                                        children: "AI Reasoning"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        style: {
                                            fontSize: '12px',
                                            color: '#374151',
                                            lineHeight: 1.5,
                                            margin: aiPopover.suggestedQNo ? '0 0 8px' : 0
                                        },
                                        children: [
                                            aiPopover.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontWeight: 700,
                                                    wordBreak: 'break-all'
                                                },
                                                children: aiPopover.fileName
                                            }),
                                            aiPopover.fileName && ' - ',
                                            aiPopover.reasoning || 'Confidence too low to allocate automatically.'
                                        ]
                                    }),
                                    aiPopover.suggestedQNo && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            background: '#EFF6FF',
                                            border: '1px solid #BFDBFE',
                                            borderRadius: '7px',
                                            padding: '6px 10px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                style: {
                                                    fontSize: '11px',
                                                    fontWeight: 600,
                                                    color: '#1D4ED8',
                                                    marginBottom: '2px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.05em'
                                                },
                                                children: "Possible match"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                style: {
                                                    fontSize: '12px',
                                                    color: '#1E40AF',
                                                    lineHeight: 1.5,
                                                    margin: 0
                                                },
                                                children: [
                                                    aiPopover.suggestedQNo,
                                                    aiPopover.suggestedSection ? " \u2014 " + aiPopover.suggestedSection : '',
                                                    aiPopover.suggestedQuestion ? ': ' + aiPopover.suggestedQuestion : ''
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: {
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            color: '#6B7280',
                                            marginBottom: '4px',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.05em'
                                        },
                                        children: "Why this section?"
                                    }),
                                    (()=>{
                                        const r = aiPopover.reasoning || 'No reasoning provided.';
                                        const match = r.match(/Claude: (\d+\/10) \| GPT: (\d+\/10) \| Final: (\d+\/10)$/);
                                        const reasoningText = match ? r.replace(match[0], '').trim() : r;
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    style: {
                                                        fontSize: '12px',
                                                        color: '#374151',
                                                        lineHeight: 1.5,
                                                        margin: match ? '0 0 8px' : 0
                                                    },
                                                    children: [
                                                        aiPopover.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontWeight: 700,
                                                                wordBreak: 'break-all'
                                                            },
                                                            children: aiPopover.fileName
                                                        }),
                                                        aiPopover.fileName && ' - ',
                                                        reasoningText
                                                    ]
                                                }),
                                                match && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '6px',
                                                        alignItems: 'center'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px',
                                                                fontSize: '11px',
                                                                fontWeight: 700,
                                                                color: '#151313',
                                                                background: '#F3F4F6',
                                                                borderRadius: '10px',
                                                                padding: '3px 8px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: (parcelRequire("dANvg")),
                                                                    alt: "Claude",
                                                                    style: {
                                                                        height: 14,
                                                                        width: 'auto'
                                                                    }
                                                                }),
                                                                "Claude: ",
                                                                match[1]
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                gap: '4px',
                                                                fontSize: '11px',
                                                                fontWeight: 700,
                                                                color: '#151313',
                                                                background: '#F3F4F6',
                                                                borderRadius: '10px',
                                                                padding: '3px 8px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: (parcelRequire("4lWo1")),
                                                                    alt: "GPT",
                                                                    style: {
                                                                        height: 14,
                                                                        width: 'auto'
                                                                    }
                                                                }),
                                                                "GPT: ",
                                                                match[2]
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 700,
                                                                color: '#151313',
                                                                background: '#F3F4F6',
                                                                borderRadius: '10px',
                                                                padding: '3px 8px'
                                                            },
                                                            children: [
                                                                "Final: ",
                                                                match[3]
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    })()
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $317086ac24816082$export$2e2bcd8739ae039 = $317086ac24816082$var$AutoFillStepperModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");










var $c0471dc540182262$var$Send = function Send(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.493 5.031c-.358 0-.693-.175-.898-.468L9.81 3.437a2.406 2.406 0 0 0-1.974-1.03H3.5a2.406 2.406 0 0 0-2.406 2.405v11.375c0 .638.253 1.25.704 1.702a2.41 2.41 0 0 0 1.702.705h14a2.41 2.41 0 0 0 1.702-.705 2.41 2.41 0 0 0 .704-1.701v-8.75a2.41 2.41 0 0 0-.704-1.702A2.41 2.41 0 0 0 17.5 5.03h-6.007Zm0 1.313H17.5a1.096 1.096 0 0 1 1.094 1.093v8.75a1.095 1.095 0 0 1-1.094 1.094h-14a1.095 1.095 0 0 1-1.094-1.093V4.813c0-.604.49-1.094 1.094-1.094h4.337c.357 0 .693.175.897.468l.785 1.126a2.405 2.405 0 0 0 1.974 1.03Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.192 11.008H7.808a.808.808 0 0 0 0 1.615h5.384a.808.808 0 0 0 0-1.615Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m10.471 10.23 1.582 1.583-1.582 1.583a.807.807 0 1 0 1.142 1.141l2.153-2.153a.806.806 0 0 0 0-1.142l-2.153-2.154a.807.807 0 1 0-1.142 1.142Z",
                fill: "#4A67FF"
            })
        ]
    });
};
$c0471dc540182262$var$Send.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $c0471dc540182262$var$Search = function Search(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#a)",
                fill: "#000",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M18.812 2.176c-2.901-2.901-7.622-2.901-10.524 0-2.76 2.76-2.894 7.169-.402 10.09l-.034.03-1.13 1.131-.78-.78a.613.613 0 0 0-.867 0L.697 17.025a2.332 2.332 0 0 0 0 3.294c.454.454 1.05.681 1.647.681.596 0 1.193-.227 1.647-.681l4.378-4.378a.613.613 0 0 0 0-.867l-.78-.78 1.13-1.13a.62.62 0 0 0 .033-.037 7.386 7.386 0 0 0 4.798 1.753 7.393 7.393 0 0 0 5.262-2.18 7.393 7.393 0 0 0 2.18-5.262 7.393 7.393 0 0 0-2.18-5.262ZM3.124 19.452a1.104 1.104 0 0 1-1.56-1.56l1.302-1.302 1.56 1.56-1.302 1.302Zm2.169-2.17-1.56-1.56 1.775-1.774 1.56 1.56-1.775 1.775Zm12.652-5.449a6.223 6.223 0 0 1-8.79 0 6.223 6.223 0 0 1 0-8.79 6.196 6.196 0 0 1 4.395-1.817c1.592 0 3.183.606 4.395 1.817a6.175 6.175 0 0 1 1.82 4.395c0 1.66-.646 3.221-1.82 4.395Z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "m16.116 5.164-3.402 3.401-1.863-1.863a.613.613 0 1 0-.867.868l2.297 2.296a.611.611 0 0 0 .867 0l3.835-3.835a.613.613 0 1 0-.867-.867Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h21v21H0z"
                    })
                })
            })
        ]
    });
};
$c0471dc540182262$var$Search.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $c0471dc540182262$var$btnCancel = {
    background: 'none',
    border: '1.5px solid #9CA3AF',
    borderRadius: '6px',
    cursor: 'pointer',
    color: '#6B7280',
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.3rem 1.2rem'
};
const $c0471dc540182262$var$btnMinimize = {
    background: 'none',
    border: '1.5px solid #3B82F6',
    borderRadius: '6px',
    cursor: 'pointer',
    color: '#3B82F6',
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.3rem 1.2rem'
};







const $c0471dc540182262$var$TempAutoFillStepperModal = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const store = (0, $391671225302c365$export$6ccbb43953eebf8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { fileReport: fileReport, currentScore: currentScore, tab: tab, autoFillContext: autoFillContext, company: reduxCompany, tempModule: tempModule } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { selectedCompany: company } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [indexingProgress, setIndexingProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        currentFile: ''
    });
    const [allocationProgress, setAllocationProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        fileName: '',
        matchedQNo: '',
        matchedQuestion: ''
    });
    const [savingProgress, setSavingProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        fileName: '',
        qNo: ''
    });
    // File preview state (allocation step)
    const [previewFile, setPreviewFile] = (0, $acw62.useState)(null);
    // Hidden file input ref (select step)
    const fileInputRef = (0, $acw62.useRef)(null);
    const phase = modal.autoFillStepperPhase || '';
    const isOpen = modal.open === 'tempAutoFillStepper';
    // ── Socket listeners for indexing & allocation progress ──
    (0, $acw62.useEffect)(()=>{
        const onIndexingProgress = (data)=>{
            setIndexingProgress({
                total: data.total || 0,
                current: data.current || 0,
                currentFile: data.currentFile || ''
            });
        };
        const onAllocationProgress = (data)=>{
            setAllocationProgress({
                total: data.total || 0,
                current: data.current || 0,
                fileName: data.fileName || '',
                matchedQNo: data.matchedQNo || '',
                matchedQuestion: data.matchedQuestion || ''
            });
        };
        const onAllocationCompleted = (data)=>{
            setIndexingProgress({
                total: 0,
                current: 0,
                currentFile: ''
            });
            setAllocationProgress({
                total: 0,
                current: 0,
                fileName: '',
                matchedQNo: '',
                matchedQuestion: ''
            });
            // Reason: the upload request returns before allocation runs, so this event (not the HTTP response) carries the final report
            if (!data?.fileReport) return;
            const entries = Object.values(data.fileReport.importResult || {});
            const allocated = entries.filter((e)=>e?.section?.some((el)=>!String(el).includes('DXXX') && !String(el).includes('SXXX'))).length;
            const score = entries.length === 0 ? 0 : Math.round(allocated / entries.length * 100);
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: data.fileReport,
                currentScore: score
            }));
            const st = store.getState().modal;
            if (st.autoFillStepperPhase === 'indexing') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                ...st.open === 'tempAutoFillStepper' ? {
                    open: 'tempAutoFillStepper'
                } : {
                    autoFillStatusBarVisible: true
                },
                autoFillStepperPhase: 'allocation',
                autoFillStatusBarPhase: 'allocated'
            }));
        };
        const onAllocationFailed = (data)=>{
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                autoFillStatusBarPhase: 'error',
                autoFillError: data?.message || 'Allocation failed'
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(data?.message || 'Allocation failed', 'error');
        };
        const onSavingProgress = (data)=>{
            setSavingProgress({
                total: data.total || 0,
                current: data.current || 0,
                fileName: data.fileName || '',
                qNo: data.qNo || ''
            });
        };
        const onSavingCompleted = ()=>{
            setSavingProgress({
                total: 0,
                current: 0,
                fileName: '',
                qNo: ''
            });
            // Only close the modal in Filing Assistant mode (no auto-fill)
            const state = store.getState();
            if (!state.modal.autoFillWithFilling) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                autoFillStatusBarVisible: false,
                autoFillStatusBarPhase: '',
                autoFillJustCompleted: true
            }));
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempIndexing:progress', onIndexingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:progress', onAllocationProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:completed', onAllocationCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:failed', onAllocationFailed);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempProcessingFiles:progress', onSavingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempProcessingFiles:completed', onSavingCompleted);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempIndexing:progress', onIndexingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:progress', onAllocationProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:completed', onAllocationCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:failed', onAllocationFailed);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempProcessingFiles:progress', onSavingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempProcessingFiles:completed', onSavingCompleted);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // ── Allocation step helpers ──
    const handleFilePreview = (file)=>{
        const url = file.location || file.url;
        if (!url) return;
        setPreviewFile({
            name: file.originalname || file.title,
            url: url
        });
    };
    const getSectionNameFromSection = (section, qNo)=>{
        if (section.sectionNo == qNo || section.no == qNo) {
            const name = section.sectionName || section.name || '';
            return {
                displayName: name,
                sectionOnly: name
            };
        }
        if (section.questions) {
            for (const question of Object.values(section.questions))if (question.qNo == qNo) {
                const sectionOnly = section.sectionName || section.name || '';
                return {
                    displayName: question.qDescription || sectionOnly,
                    sectionOnly: sectionOnly
                };
            }
        }
        if (section.subFolders) for (const subFolder of Object.values(section.subFolders)){
            const result = getSectionNameFromSection(subFolder, qNo);
            if (result) return result;
        }
        return null;
    };
    const getSectionName = (module, qNo, file, key)=>{
        if (qNo == "DXXX" || qNo == "SXXX") return {
            displayName: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onClick: ()=>handleEditDispatch({
                        key: key,
                        fileName: file.originalname,
                        from: 'fileReport',
                        actionType: "move",
                        fileData: file,
                        index: "0"
                    }),
                className: "bg62 br10px df aic p1rem jcsb fsi",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Please select section"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                        className: "c3"
                    })
                ]
            }),
            sectionOnly: ''
        };
        const effectiveCompany = company || reduxCompany;
        // On /company/ route, sections live in tempModule (not company.modules[tab])
        let sections;
        if (tempModule?.sections?.length) sections = [
            ...tempModule.sections
        ];
        else {
            const module2 = module || (effectiveCompany?.modules ? {
                ...effectiveCompany.modules[tab || "repository"]
            } : null);
            sections = [
                ...module2?.sections || []
            ];
        }
        for (const section of sections){
            const result = getSectionNameFromSection(section, qNo);
            if (result) return {
                displayName: `${qNo} ${result.displayName}`,
                sectionOnly: result.sectionOnly
            };
        }
        const entry = fileReport?.importResult && Object.values(fileReport.importResult).find((r)=>r.section?.includes(qNo) && r.sectionName);
        if (entry?.sectionName) return {
            displayName: `${qNo} ${entry.sectionName}`,
            sectionOnly: entry.sectionName
        };
        return {
            displayName: "Unknown",
            sectionOnly: ''
        };
    };
    const handleEditDispatch = (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(true));
    };
    function isSubarray(subarray, array) {
        const sortedSubarray = subarray.slice().sort();
        const sortedArray = array.slice().sort();
        let i = 0;
        return sortedArray.some((element)=>{
            if (element === sortedSubarray[i]) i++;
            return i === sortedSubarray.length;
        });
    }
    const calcAccuracyScore = (count)=>{
        let allocated = 0;
        for (const key of Object.keys(fileReport.importResult)){
            const currentSection = fileReport.importResult[key]['section'];
            const oldSection = fileReport.importResult[key]['originalSection'];
            if (oldSection.includes("DXXX") || oldSection.includes("SXXX")) continue;
            if (isSubarray(oldSection, currentSection)) allocated++;
        }
        const totalCount = count ?? Object.keys(fileReport.importResult).length;
        dispatch((0, $12074930bd2c1829$export$fb8d60304f3762b3)(!totalCount ? 0 : Math.round(allocated / totalCount * 100)));
        return !totalCount ? 0 : Math.round(allocated / totalCount * 100);
    };
    const removeSectionFromImport = async (fileKey, index)=>{
        let sections = [
            ...fileReport.importResult[fileKey]['section']
        ];
        const _fileReport = {
            ...fileReport
        };
        const qNo = sections[index];
        sections.splice(index, 1);
        const file = _fileReport.importResult[fileKey]['file'];
        if (sections.length === 0) {
            const { [fileKey]: removedFile, ...restOfFileReport } = _fileReport.importResult;
            _fileReport.importResult = restOfFileReport;
        } else _fileReport.importResult[fileKey] = {
            ..._fileReport.importResult[fileKey],
            section: sections
        };
        const score = calcAccuracyScore(Object.keys(_fileReport.importResult).length);
        const effectiveCompany = company || reduxCompany;
        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteSection`, {
            companyId: effectiveCompany._id,
            fileReportId: _fileReport['_id'],
            fileKey: fileKey,
            index: index,
            qNo: qNo,
            score: score,
            file: file
        });
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(_fileReport));
    };
    const getImportResultEntryHTML = (key)=>{
        if (!fileReport?.importResult?.[key]) return null;
        const fileName = fileReport.importResult[key].file['originalname'];
        const file = fileReport.importResult[key].file;
        const section = fileReport.importResult[key]['section'];
        const effectiveCompany = company || reduxCompany;
        let module = {
            ...effectiveCompany?.modules?.[tab || "repository"] || {}
        };
        if (module) module = JSON.parse(JSON.stringify(module));
        if (Array.isArray(section)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: section.map((qNo, index)=>{
                const { displayName: displayName, sectionOnly: sectionOnly } = getSectionName(module, qNo, file, key);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        className: `${index == section.length - 1 ? 'fis-tr' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `tal fis-td mx1rem fs14px fw600 tdu bg1 lightDot ${index != 0 ? 'vh' : ''} ${qNo == "DXXX" ? 'red' : fileReport['status'] == 'In Progress' ? 'orange' : 'green'}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cp",
                                    onClick: ()=>handleFilePreview(file),
                                    "data-tooltip": "Click to preview file",
                                    children: fileName
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `tal mx1rem fs14px fw400 bg1 c15`,
                                children: sectionOnly ? `${qNo} ${sectionOnly}` : sectionOnly
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `tal mx1rem fs14px fw400 bg1 c15`,
                                children: displayName
                            }),
                            fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: `mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdr jcc aic",
                                    children: [
                                        qNo !== "DXXX" ? /*#__PURE__*/ (0, $ayMG0.jsx)($c0471dc540182262$var$Send, {
                                            "data-tooltip": "Move",
                                            className: "mr1rem cp",
                                            onClick: ()=>handleEditDispatch({
                                                    key: key,
                                                    fileName: file.title,
                                                    from: 'fileReport',
                                                    actionType: "move",
                                                    fileData: file,
                                                    index: index
                                                })
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cee5c542a37a6fe$export$2e2bcd8739ae039), {
                                            "data-tooltip": "Delete",
                                            onClick: ()=>removeSectionFromImport(key, index),
                                            className: "cp f9 ml1rem"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, `${index + section.length - 1}-section-allocate`);
            })
        });
        else {
            const { displayName: displayName, sectionOnly: sectionOnly } = getSectionName(module, section, file, key);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "cp tdu",
                                onClick: ()=>handleFilePreview(file),
                                "data-tooltip": "Click to preview file",
                                children: fileName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1 fis-td`,
                            children: sectionOnly
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `tal fis-td mx1rem fs1rem fw600 bg1 fis-td`,
                            children: displayName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cee5c542a37a6fe$export$2e2bcd8739ae039), {
                                onClick: ()=>removeSectionFromImport(key, 0),
                                className: "cp f9"
                            })
                        })
                    ]
                })
            });
        }
    };
    const onClickReallocationComplete = async ()=>{
        if (!fileReport) return;
        const fileReportData = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };
        const moduleName = tab && tab !== "" ? tab : autoFillContext?.moduleType || '';
        const effectiveCompany = company || reduxCompany;
        const companyId = effectiveCompany?._id || autoFillContext?.companyId;
        const moduleId = autoFillContext?.moduleId;
        if (!moduleId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Module is not loaded. Please refresh the page and try again.');
            return;
        }
        dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(fileReportData));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'tempAutoFillStepper',
            autoFillStepperPhase: 'processing',
            percent: 0
        }));
        const resp = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/allocateFiles`, {
            companyId: companyId,
            moduleId: moduleId,
            fileReport: fileReportData
        }, true);
        if (!resp || resp.code === 400) return;
        if (resp.body?.report) dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(resp.body.report));
        const savedQuestions = resp.body?.savedQuestions;
        if (savedQuestions?.length) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: {
                moduleId: String(moduleId),
                savedQuestions: savedQuestions
            }
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            autoFillStatusBarVisible: false,
            autoFillStatusBarPhase: '',
            autoFillJustCompleted: true
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp['message']);
    };
    const onClickFileImportAuditLog = async (fileReportId)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportLogs/${fileReportId}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'fileReportAuditLog'
        }));
    };
    // ── Handlers ──
    const handleCancel = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            autoFillStatusBarVisible: false,
            autoFillStatusBarPhase: ''
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Import cancelled');
    };
    const handleMinimize = ()=>{
        const phaseMap = {
            uploading: 'uploading',
            indexing: 'indexing',
            allocation: 'allocated',
            processing: 'processingFiles'
        };
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            autoFillStatusBarVisible: true,
            autoFillStatusBarPhase: phaseMap[phase] || phase
        }));
    };
    // ── File select step handlers ──
    const cloneFile = (file)=>new File([
            file
        ], file.name, {
            type: file.type
        });
    const MAX_AUTOFILL_FILES = 300;
    const handleFileSelect = async (e)=>{
        const selectedFiles = Array.from(e.target.files);
        if (selectedFiles.length === 0) return;
        if (selectedFiles.length > MAX_AUTOFILL_FILES) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You can upload a maximum of ${MAX_AUTOFILL_FILES} files at once`, 'error');
            e.target.value = '';
            return;
        }
        const totalFiles = selectedFiles.length;
        let filesInfo = [];
        let relPaths = [];
        try {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'tempAutoFillStepper',
                autoFillStepperPhase: 'uploading',
                percent: 0,
                fileName: `Uploading ${totalFiles} file${totalFiles > 1 ? 's' : ''}...`,
                totalFiles: totalFiles,
                filesUploaded: 0,
                autoFillStatusBarPhase: 'uploading',
                autoFillUploadProgress: {
                    current: 0,
                    total: totalFiles,
                    fileName: ''
                }
            }));
            relPaths = selectedFiles.map((f)=>f.webkitRelativePath || '');
            const attachment = selectedFiles.map((f)=>cloneFile(f));
            const companyId = autoFillContext?.companyId;
            const moduleType = autoFillContext?.moduleType;
            const moduleId = autoFillContext?.moduleId;
            const sectionCode = autoFillContext?.sectionCode;
            const scope2 = autoFillContext?.scope;
            const scopeName2 = autoFillContext?.scopeName || '';
            if (!moduleId) {
                e.target.value = '';
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarVisible: false,
                    autoFillStatusBarPhase: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Module is not loaded. Please refresh the page and try again.');
                return;
            }
            // Use /modules/uploadFile
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/uploadFile', {
                attachment: attachment,
                companyId: companyId,
                moduleId: moduleId,
                moduleType: moduleType,
                totalFiles: totalFiles,
                sectionCode: sectionCode || '',
                scope: scope2,
                scopeName: scopeName2
            }, true);
            if (res?.body?.reports?.length) filesInfo = res.body.reports;
            else if (res?.body?.report) filesInfo = [
                res.body.report
            ];
            e.target.value = '';
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'tempAutoFillStepper',
                autoFillStepperPhase: 'indexing',
                autoFillStatusBarPhase: 'indexing',
                autoFillStatusBarVisible: false
            }));
            // Use /modules/uploadFiles
            const uploadFilesRes = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/uploadFiles', {
                asyncResponse: true,
                files: filesInfo,
                companyId: companyId,
                moduleId: moduleId,
                tab: moduleType,
                relPaths: relPaths,
                fromAutoFill: true,
                ...scope2 === 'section' && sectionCode ? {
                    sectionCode: sectionCode
                } : {}
            }, true);
            if (uploadFilesRes?.body?.cancelled) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarVisible: false,
                    autoFillStatusBarPhase: ''
                }));
                return;
            }
            if (!uploadFilesRes?.body?.report) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarPhase: 'error'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('File upload failed');
                return;
            }
            // Reason: the server now replies as soon as processing starts; tempAllocation:completed (socket) advances the stepper from here
            if (uploadFilesRes.body.async) return;
            const fileReportResult = uploadFilesRes.body.report;
            const allocated = Object.keys(fileReportResult.importResult || {}).filter((key)=>fileReportResult.importResult[key]?.section?.some((el)=>!el.includes("DXXX") && !el.includes("SXXX"))).length;
            const total = Object.keys(fileReportResult.importResult || {}).length;
            const score = total === 0 ? 0 : Math.round(allocated / total * 100);
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: fileReportResult,
                currentScore: score,
                tab: moduleType,
                autoFillContext: {
                    ...autoFillContext
                }
            }));
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'tempAutoFillStepper',
                autoFillStepperPhase: 'allocation',
                autoFillStatusBarVisible: false,
                autoFillStatusBarPhase: 'allocated'
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(uploadFilesRes.message || 'Files allocated - tap to review');
        } catch (error) {
            console.error('Upload error:', error);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Upload failed. Please try again.');
            e.target.value = '';
        }
    };
    if (!isOpen) return null;
    const showCancelMinimize = ![
        'select',
        'allocation'
    ].includes(phase);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: ()=>{},
        className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr bg1 shadow w100 bsbb df fdc m1rem br5px",
                    style: {
                        maxWidth: '1350px',
                        maxHeight: '92vh',
                        overflowY: 'auto',
                        padding: '0 2rem 2rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                position: 'sticky',
                                top: 0,
                                background: '#fff',
                                zIndex: 2,
                                paddingTop: '1.5rem',
                                paddingBottom: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcsb mb0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic",
                                            style: {
                                                gap: '0.5rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("g1WEs")),
                                                    alt: "import",
                                                    style: {
                                                        width: '28px',
                                                        height: '28px'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "c15 fw600 fs18px mb0rem",
                                                    children: "Import Files"
                                                })
                                            ]
                                        }),
                                        phase === 'allocation' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: handleCancel,
                                            style: {
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                color: '#6B7280'
                                            },
                                            children: "\u2715"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e84a498389ca6ed9$export$2e2bcd8739ae039), {
                                    currentStep: phase,
                                    uploadOnly: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                    style: {
                                        marginTop: '8px'
                                    }
                                })
                            ]
                        }),
                        phase === 'select' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic jcc",
                            style: {
                                padding: '3rem 1rem',
                                gap: '1.5rem',
                                minHeight: '450px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        borderRadius: '50%',
                                        width: '64px',
                                        height: '64px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "28",
                                        height: "28",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z",
                                            fill: "white",
                                            stroke: "white",
                                            strokeWidth: "1.5",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "tac",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fw600 fs18px mb0-5rem",
                                            children: modal.autoFillUploadMode === 'folders' ? 'Select folders to import' : 'Select files to import'
                                        }),
                                        modal.autoFillUploadMode !== 'folders' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs12px",
                                            style: {
                                                color: '#9CA3AF'
                                            },
                                            children: "Supported: PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcc",
                                    style: {
                                        gap: '1rem',
                                        marginTop: '0.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: handleCancel,
                                            style: {
                                                background: 'none',
                                                border: '1.5px solid #E5E7EB',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                color: '#6B7280',
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                padding: '0.6rem 1.8rem'
                                            },
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>fileInputRef.current?.click(),
                                            style: {
                                                background: '#fc7785',
                                                border: 'none',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                color: '#fff',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                padding: '0.6rem 1.8rem'
                                            },
                                            children: modal.autoFillUploadMode === 'folders' ? 'Select Folders' : 'Upload Documents'
                                        })
                                    ]
                                }),
                                modal.autoFillUploadMode === 'folders' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    ref: fileInputRef,
                                    type: "file",
                                    multiple: true,
                                    onChange: handleFileSelect,
                                    style: {
                                        display: 'none'
                                    },
                                    webkitdirectory: "",
                                    directory: "",
                                    mozdirectory: ""
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    ref: fileInputRef,
                                    type: "file",
                                    multiple: true,
                                    onChange: handleFileSelect,
                                    style: {
                                        display: 'none'
                                    },
                                    accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                                })
                            ]
                        }),
                        phase === 'uploading' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic jcc",
                            style: {
                                padding: '1rem 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("lV6Oz")),
                                    alt: "uploading",
                                    style: {
                                        maxHeight: '180px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb",
                                    style: {
                                        width: '97%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs12px c43",
                                            children: "Your Computer"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs12px c43",
                                            children: "Clarence"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "maw70 w700px df fdc jcc aic mt0rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "c15 fs24px w100 tac fw500",
                                            children: "Uploading Files"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w100 df jcc aic mt1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("progress", {
                                                color: "green",
                                                className: "maw90 w90 mr1rem",
                                                style: {
                                                    border: 'none'
                                                },
                                                id: "temp-upload-progress-bar",
                                                value: modal.percent || 0,
                                                max: "100"
                                            })
                                        }),
                                        modal.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic jcc",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "c15 fw500 fs13px my0-5rem",
                                                children: [
                                                    modal.fileName,
                                                    " | ",
                                                    modal.filesUploaded,
                                                    " / ",
                                                    modal.totalFiles
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem w100 tac fw400 my2rem",
                                            children: "Almost there"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic jcc",
                                            style: {
                                                gap: '1rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: handleCancel,
                                                    style: $c0471dc540182262$var$btnCancel,
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: handleMinimize,
                                                    style: $c0471dc540182262$var$btnMinimize,
                                                    children: "Minimize"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        phase === 'indexing' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic",
                            style: {
                                padding: '1rem 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "AnimateWiz tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h15rem mla mra",
                                        src: (parcelRequire("hA45b")),
                                        alt: "animWiz"
                                    })
                                }),
                                allocationProgress.total > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "fs1-5rem-sm w100 tac mb1rem c15",
                                            children: "Allocating Files to Sections..."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                width: '100%',
                                                maxWidth: '520px',
                                                margin: '0 auto',
                                                textAlign: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-85rem c27 mb0-5rem",
                                                    children: [
                                                        allocationProgress.current,
                                                        " of ",
                                                        allocationProgress.total,
                                                        " files matched"
                                                    ]
                                                }),
                                                allocationProgress.fileName && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-85rem c27",
                                                    style: {
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        margin: '0 0 0.25rem'
                                                    },
                                                    children: [
                                                        "File: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c15 fw500",
                                                            children: allocationProgress.fileName
                                                        })
                                                    ]
                                                }),
                                                allocationProgress.matchedQNo && allocationProgress.matchedQNo !== 'SXXX' && allocationProgress.matchedQNo !== 'DXXX' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-85rem",
                                                    style: {
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        margin: 0,
                                                        color: '#fc7785'
                                                    },
                                                    children: [
                                                        "\u2192 ",
                                                        allocationProgress.matchedQNo,
                                                        " \u2014 ",
                                                        allocationProgress.matchedQuestion
                                                    ]
                                                }) : allocationProgress.matchedQNo && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs0-85rem c27",
                                                    style: {
                                                        margin: 0
                                                    },
                                                    children: "\u2192 Unallocated"
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "fs1-5rem-sm w100 tac mb1rem c15",
                                            children: "Indexing & Analysing Files..."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                width: '100%',
                                                maxWidth: '520px',
                                                margin: '0 auto'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        marginBottom: '0.35rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem c27",
                                                            style: {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '80%'
                                                            },
                                                            children: indexingProgress.currentFile ? indexingProgress.current < indexingProgress.total ? `Reading: ${indexingProgress.currentFile}` : "\u2713 All files indexed" : 'Preparing files...'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem c27",
                                                            children: indexingProgress.total > 0 ? `${indexingProgress.current || 0}/${indexingProgress.total}` : ''
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        background: '#E5E7EB',
                                                        borderRadius: '10px',
                                                        height: '8px',
                                                        overflow: 'hidden'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            background: '#22c55e',
                                                            height: '100%',
                                                            borderRadius: '10px',
                                                            width: indexingProgress.total > 0 ? `${Math.round((indexingProgress.current || 0) / indexingProgress.total * 100)}%` : '0%',
                                                            transition: 'width 0.3s ease'
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem c27 tac mt1rem",
                                    style: {
                                        opacity: 0.7
                                    },
                                    children: "You can minimise this window \u2014 processing will continue in the background."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcc",
                                    style: {
                                        gap: '1rem',
                                        marginTop: '0.75rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: handleCancel,
                                            style: $c0471dc540182262$var$btnCancel,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: handleMinimize,
                                            style: $c0471dc540182262$var$btnMinimize,
                                            children: "Minimize"
                                        })
                                    ]
                                })
                            ]
                        }),
                        phase === 'allocation' && fileReport && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df",
                            style: {
                                gap: '1.5rem',
                                marginTop: '1rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        flex: previewFile ? '0 0 50%' : '1 1 100%',
                                        minWidth: 0,
                                        transition: 'flex 0.3s ease'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcfs aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("g1WEs")),
                                                            alt: "fileManagement"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                            className: "c15 fw600 fs18px mb0rem ml0-5rem",
                                                            children: "Import Assistant"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>onClickFileImportAuditLog(fileReport['_id']),
                                                    className: "cp tac c1 bg5 c15 br20px px1-5rem py0-5rem fw500 fs13px",
                                                    children: "Log"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dg gg0-5rem mb2rem fs1rem mah300px oya",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                    className: "fis bcc",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        className: "tal fs14px fw400 c37",
                                                                        style: {
                                                                            width: '45%'
                                                                        },
                                                                        children: "Files"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        className: "tal fs14px fw400 c37",
                                                                        style: {
                                                                            width: '10%'
                                                                        },
                                                                        children: "Section Name"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        className: "tal fs14px fw400 c37",
                                                                        style: {
                                                                            width: '35%'
                                                                        },
                                                                        children: "Allocated Section"
                                                                    }),
                                                                    fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        className: "fs14px fw400 c37",
                                                                        style: {
                                                                            width: '10%'
                                                                        },
                                                                        children: "Actions"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>!el.includes("DXXX") && !el.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                                            className: "c15 fs18px fw500 tal",
                                                                            children: "Allocated files"
                                                                        })
                                                                    })
                                                                }),
                                                                Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>!el.includes("DXXX") && !el.includes("SXXX"))).map(getImportResultEntryHTML)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>el.includes("DXXX") || el.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                                            className: "c15 fs18px fw500 tal mt1rem ml1rem",
                                                            children: [
                                                                "Unallocated Bin: Please reallocate files ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c4",
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                                            className: "fis bcc",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                    className: "dn",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                className: "fis-th w40 bbn"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                className: "fis-th bbn"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                className: "fis-th w60 bbn"
                                                                            }),
                                                                            fileReport['status'] == 'In Progress' && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                className: "fis-th fis-th-action bbn"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                    children: Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>el.includes("DXXX") || el.includes("SXXX"))).map(getImportResultEntryHTML)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df w100 fdr jcc",
                                            children: fileReport['status'] == 'In Progress' && fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>!el.includes("DXXX") && !el.includes("SXXX"))).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: onClickReallocationComplete,
                                                className: "bg3 bg4-hover c1 br10px px3rem py0-75rem cp fw500 fs1rem",
                                                children: "Confirm Allocation"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        width: '60%',
                                                        height: '1px',
                                                        backgroundColor: '#82828256',
                                                        opacity: '64%',
                                                        margin: '24px auto'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcc",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($c0471dc540182262$var$Search, {
                                                            className: "mr0-5rem"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs13px c37 fw400 mr0-5rem",
                                                            children: fileReport.importResult && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    "[",
                                                                    Object.keys(fileReport.importResult).length,
                                                                    "] imported files = [",
                                                                    Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>!el.includes("DXXX") && !el.includes("SXXX"))).length,
                                                                    "] allocated files + [",
                                                                    Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>el.includes("DXXX") || el.includes("SXXX"))).length,
                                                                    "] unallocated bin files"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "fs13px c37 fw400",
                                                            children: [
                                                                "Allocation accuracy ",
                                                                currentScore,
                                                                "%"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcc",
                                                    style: {
                                                        gap: '1rem',
                                                        marginTop: '0.5rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: handleCancel,
                                                            style: $c0471dc540182262$var$btnCancel,
                                                            children: "Cancel"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: handleMinimize,
                                                            style: $c0471dc540182262$var$btnMinimize,
                                                            children: "Minimize"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                previewFile && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        flex: '0 0 48%',
                                        minWidth: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        borderLeft: '1px solid #e0e0e0',
                                        paddingLeft: '1rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb aic",
                                            style: {
                                                marginBottom: '0.75rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    style: {
                                                        minWidth: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42c665bd8834dbf3$export$2e2bcd8739ae039), {
                                                            style: {
                                                                marginRight: '0.5rem',
                                                                color: '#6B7280',
                                                                flexShrink: 0
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                            className: "c15 fw600 fs14px mb0rem",
                                                            style: {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            },
                                                            children: previewFile.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    style: {
                                                        flexShrink: 0,
                                                        marginLeft: '0.5rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: previewFile.url,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "cp mr0-5rem fs12px c36 fw500 tdu",
                                                            children: "Open"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8754c86021516b$export$2e2bcd8739ae039), {
                                                            className: "cp",
                                                            style: {
                                                                fontSize: '1rem',
                                                                color: '#6B7280'
                                                            },
                                                            onClick: ()=>setPreviewFile(null)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: 1,
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                border: '1px solid #e0e0e0',
                                                backgroundColor: '#f9fafb',
                                                minHeight: '400px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                                src: previewFile.url,
                                                title: `Preview: ${previewFile.name}`,
                                                style: {
                                                    width: '100%',
                                                    height: '100%',
                                                    border: 'none',
                                                    minHeight: '400px'
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        phase === 'processing' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic jcc",
                            style: {
                                padding: '1rem 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    style: {
                                        display: 'inline-block'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("6bpyB")),
                                            alt: "processing",
                                            style: {
                                                maxHeight: '180px',
                                                display: 'block'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb",
                                            style: {
                                                width: '100%',
                                                marginTop: '0.25rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px c43",
                                                    style: {
                                                        textAlign: 'left'
                                                    },
                                                    children: "Clarence"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px c43",
                                                    style: {
                                                        textAlign: 'right'
                                                    },
                                                    children: "Data Repository"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "maw70 w700px df fdc jcc aic mt0rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "c15 fs24px w100 tac fw500",
                                            children: "Saving files and linking them to your answers..."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100 mt1rem",
                                            style: {
                                                maxWidth: '520px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcsb mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem c27",
                                                            style: {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '75%'
                                                            },
                                                            children: savingProgress.fileName ? `Saving: ${savingProgress.fileName}` : 'Preparing...'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem c27",
                                                            children: savingProgress.total > 0 ? `${savingProgress.current}/${savingProgress.total}` : ''
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        background: '#E5E7EB',
                                                        borderRadius: '10px',
                                                        height: '8px',
                                                        overflow: 'hidden'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            background: '#22c55e',
                                                            height: '100%',
                                                            borderRadius: '10px',
                                                            width: savingProgress.total > 0 ? `${Math.round(savingProgress.current / savingProgress.total * 100)}%` : '0%',
                                                            transition: 'width 0.3s ease'
                                                        }
                                                    })
                                                }),
                                                savingProgress.qNo && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem tac mt0-5rem",
                                                    style: {
                                                        color: '#4a67ff'
                                                    },
                                                    children: [
                                                        "\u2192 Linked to: ",
                                                        savingProgress.qNo
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic jcc mt1-5rem",
                                            style: {
                                                gap: '1rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: handleCancel,
                                                    style: $c0471dc540182262$var$btnCancel,
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: handleMinimize,
                                                    style: $c0471dc540182262$var$btnMinimize,
                                                    children: "Minimize"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                phase === 'allocation' && fileReport && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        position: 'relative'
                    },
                    children: fileReport.importResult && Object.keys(fileReport.importResult).filter((key)=>fileReport.importResult[key]['section'].some((el)=>el.includes("DXXX") || el.includes("SXXX"))).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("f5cbi")),
                        alt: "messageLadie",
                        className: "animateRight"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("6mnJ3")),
                        alt: "messageLadie",
                        className: "animateRight"
                    })
                })
            ]
        })
    });
};
var $c0471dc540182262$export$2e2bcd8739ae039 = $c0471dc540182262$var$TempAutoFillStepperModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






const $86bb04e68ae2fbe5$var$VERDICT_STYLES = {
    correct: {
        bg: '#ECFDF5',
        border: '#A7F3D0',
        color: '#059669',
        label: 'Correct'
    },
    incorrect: {
        bg: '#FFF5F7',
        border: '#FCA5A5',
        color: '#DC2626',
        label: 'Incorrect'
    }
};
const $86bb04e68ae2fbe5$var$btnCancel = {
    background: 'none',
    border: '1.5px solid #D1D5DB',
    borderRadius: '50px',
    cursor: 'pointer',
    color: '#6B7280',
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.4rem 1.5rem'
};
const $86bb04e68ae2fbe5$var$btnMinimize = {
    background: 'none',
    border: '1.5px solid #FC7785',
    borderRadius: '50px',
    cursor: 'pointer',
    color: '#FC7785',
    fontSize: '13px',
    fontWeight: 500,
    padding: '0.4rem 1.5rem'
};
const $86bb04e68ae2fbe5$var$extractSuggestedQNo = (reason)=>{
    if (!reason) return null;
    const match = reason.match(/under\s+([A-Z0-9]+(?:\.[0-9]+(?:\.[0-9]+)*)?)\s*:/i) || reason.match(/belongs to\s+([A-Z0-9]+(?:\.[0-9]+(?:\.[0-9]+)*)?)\s*:/i);
    return match ? match[1] : null;
};



const $86bb04e68ae2fbe5$export$610235a922fc0715 = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const isOpen = modal.open === 'diagnoseReport';
    const loading = !!modal.diagnoseLoading;
    const results = modal.diagnoseResults || [];
    const summary = modal.diagnoseSummary || null;
    const moduleName = modal.diagnoseModuleName || '';
    const [filter, setFilter] = (0, $acw62.useState)('all');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [fixedCards, setFixedCards] = (0, $acw62.useState)(new Set());
    const [fixingCards, setFixingCards] = (0, $acw62.useState)(new Set());
    const [applyingAll, setApplyingAll] = (0, $acw62.useState)(false);
    const [rolledBackCards, setRolledBackCards] = (0, $acw62.useState)(new Set());
    const [rollingBackCards, setRollingBackCards] = (0, $acw62.useState)(new Set());
    // Live progress while diagnose runs — mirrors autofill's "Currently working on" card via matching diagnose:* socket events.
    // Each batch fires ~20 diagnose:reading events almost simultaneously (batch verification runs in parallel, not
    // sequentially) — queuing + draining them at a fixed cadence makes the card visibly rotate through real questions
    // instead of freezing on whichever one happened to arrive last, mirroring the autofill indexing queue pattern.
    const [diagnoseProgress, setDiagnoseProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        correct: 0,
        incorrect: 0
    });
    const [diagnoseReading, setDiagnoseReading] = (0, $acw62.useState)(null); // { qNo, questionText, files }
    const readingQueueRef = (0, $acw62.useRef)([]);
    const readingAnimatingRef = (0, $acw62.useRef)(false);
    const readingTimerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) {
            setFilter('all');
            setSearch('');
            setFixedCards(new Set());
            setFixingCards(new Set());
            setApplyingAll(false);
        }
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (loading) {
            setDiagnoseProgress({
                total: 0,
                current: 0,
                correct: 0,
                incorrect: 0
            });
            setDiagnoseReading(null);
            readingQueueRef.current = [];
            readingAnimatingRef.current = false;
            clearTimeout(readingTimerRef.current);
        }
    }, [
        loading
    ]);
    (0, $acw62.useEffect)(()=>{
        const companyId = modal.diagnoseCompanyId;
        const drainReadingQueue = ()=>{
            if (readingQueueRef.current.length === 0) {
                readingAnimatingRef.current = false;
                return;
            }
            const next = readingQueueRef.current.shift();
            setDiagnoseReading(next);
            readingTimerRef.current = setTimeout(drainReadingQueue, 1400);
        };
        const onStarted = (data)=>{
            if (data.companyId === companyId) setDiagnoseProgress({
                total: data.total || 0,
                current: 0,
                correct: 0,
                incorrect: 0
            });
        };
        const onReading = (data)=>{
            if (data.companyId !== companyId) return;
            readingQueueRef.current.push({
                qNo: data.qNo,
                questionText: data.questionText,
                files: data.files || []
            });
            if (!readingAnimatingRef.current) {
                readingAnimatingRef.current = true;
                drainReadingQueue();
            }
        };
        const onProgress = (data)=>{
            if (data.companyId === companyId) setDiagnoseProgress({
                total: data.total || 0,
                current: data.current || 0,
                correct: data.correct || 0,
                incorrect: data.incorrect || 0
            });
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('diagnose:started', onStarted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('diagnose:reading', onReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('diagnose:progress', onProgress);
        return ()=>{
            clearTimeout(readingTimerRef.current);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('diagnose:started', onStarted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('diagnose:reading', onReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('diagnose:progress', onProgress);
        };
    }, [
        modal.diagnoseCompanyId
    ]);
    // Minimize hides the modal but leaves the in-flight /clarence/diagnose request (owned by DiagnoseButton) running —
    // DiagnoseStatusBar picks up live progress independently via its own diagnose:* listeners, same pattern as autofill
    const handleMinimize = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            diagnoseStatusBarVisible: true
        }));
    const handleCancel = async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            diagnoseCancelled: true
        }));
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/diagnose/cancel', {}).catch(()=>{});
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            diagnoseLoading: false,
            diagnoseStatusBarVisible: false
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auditor cancelled');
    };
    const handleRollbackAnswer = async (r)=>{
        if (!r.answerId) return;
        setRollingBackCards((prev)=>new Set(prev).add(r.qNo));
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rollback-run', {
                answerId: r.answerId
            });
            if (response?.code === 200) {
                setRolledBackCards((prev)=>new Set(prev).add(r.qNo));
                // Reason: DiagnoseButton/DiagnoseReportModal are mounted outside the per-question render tree that
                // owns patchAnswerInModule, so there's no prop path to patch localModule directly — reuse the same
                // Redux flag handleApplyFix already dispatches, which QuestionAnswersPage watches to refetch the module
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    diagnoseFixJustApplied: true
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Answer rolled back successfully', 'success');
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Failed to roll back answer', 'error');
        } catch (_) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to roll back answer', 'error');
        }
        setRollingBackCards((prev)=>{
            const s = new Set(prev);
            s.delete(r.qNo);
            return s;
        });
    };
    const handleApplyFix = async (r, suggestedQNo)=>{
        setFixingCards((prev)=>new Set(prev).add(r.qNo));
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/apply-fix', {
                companyId: modal.diagnoseCompanyId,
                originalQNo: r.qNo,
                suggestedQNo: suggestedQNo,
                moduleType: modal.diagnoseModuleType,
                ...modal.diagnoseModuleId ? {
                    moduleId: modal.diagnoseModuleId
                } : {},
                reason: r.reason || ''
            });
            if (response?.code === 200) {
                setFixedCards((prev)=>new Set(prev).add(r.qNo));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    diagnoseFixJustApplied: true
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Could not apply fix. Please try again.');
        } catch (_) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Could not apply fix. Please try again.');
        }
        setFixingCards((prev)=>{
            const s = new Set(prev);
            s.delete(r.qNo);
            return s;
        });
    };
    const handleApplyAllFixes = async ()=>{
        const pending = results.filter((r)=>r.suggestedQNo && !fixedCards.has(r.qNo) && (r.files || []).length > 0);
        if (!pending.length) return;
        setApplyingAll(true);
        await Promise.all(pending.map((r)=>handleApplyFix(r, r.suggestedQNo)));
        setApplyingAll(false);
    };
    const filtered = results.filter((r)=>{
        const matchFilter = filter === 'all' || r.verdict === filter;
        const matchSearch = !search || r.question?.toLowerCase().includes(search.toLowerCase()) || r.qNo?.toLowerCase().includes(search.toLowerCase());
        return matchFilter && matchSearch;
    });
    const close = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: close,
        className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pr shadow df fdc bg1 br10px",
            style: {
                width: '95vw',
                maxWidth: '1450px',
                maxHeight: '90vh',
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcsb px2rem py1rem",
                    style: {
                        borderBottom: '1px solid #F3F4F6',
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic",
                            style: {
                                gap: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcc br10px",
                                    style: {
                                        width: 40,
                                        height: 40,
                                        background: '#EEF2FF'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
                                            stroke: "#4A67FF",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fw600 fs1-125rem mb0rem",
                                            children: "Auditor Report"
                                        }),
                                        moduleName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c12 fs13px fw400 mb0rem",
                                            children: moduleName
                                        })
                                    ]
                                })
                            ]
                        }),
                        !loading && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: close,
                            className: "cp bg5-hover br100 df aic jcc",
                            style: {
                                width: 32,
                                height: 32,
                                border: 'none',
                                background: 'none'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M18 6L6 18M6 6l12 12",
                                    stroke: "#9CA3AF",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            })
                        })
                    ]
                }),
                loading && (()=>{
                    const { total: total, current: current, correct: correct, incorrect: incorrect } = diagnoseProgress;
                    const pct = total > 0 ? Math.round(current / total * 100) : 0;
                    const filesLabel = diagnoseReading?.files?.length ? diagnoseReading.files.slice(0, 2).join(', ') + (diagnoseReading.files.length > 2 ? ` +${diagnoseReading.files.length - 2} more` : '') : null;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc",
                        style: {
                            flex: 1,
                            padding: '2.5rem 3rem',
                            overflow: 'hidden'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df fdc px2rem py1-5rem br10px bg1 mb1rem bw1px bss bo16",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w80px",
                                                src: (parcelRequire("hA45b")),
                                                alt: "processing"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                style: {
                                                    flex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w100 c15 fw600 fs15px mb0-25rem",
                                                        children: [
                                                            "Clarence is verifying answers",
                                                            total > 0 && ` \u{2014} ${total} answers`
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c27 fs12px fw300 fsi",
                                                        children: "Checking each answer against your uploaded documents \u2014 this may take a few minutes."
                                                    })
                                                ]
                                            }),
                                            (correct > 0 || incorrect > 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                style: {
                                                    gap: '0.5rem',
                                                    flexShrink: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs11px fw600 br50px px0-75rem py0-25rem",
                                                        style: {
                                                            background: '#ECFDF5',
                                                            color: '#059669',
                                                            border: '1px solid #A7F3D0'
                                                        },
                                                        children: [
                                                            correct,
                                                            " correct"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs11px fw600 br50px px0-75rem py0-25rem",
                                                        style: {
                                                            background: '#FFF5F7',
                                                            color: '#DC2626',
                                                            border: '1px solid #FCA5A5'
                                                        },
                                                        children: [
                                                            incorrect,
                                                            " need review"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "bg24 br10px h10px mb0-5rem oh",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "h100 br10px",
                                                    style: {
                                                        background: 'linear-gradient(90deg, #4A67FF, #818CF8)',
                                                        width: `${pct}%`,
                                                        transition: 'width 0.4s ease'
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df jcsb aic mt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c14 fs12px fw400",
                                                        children: "Progress"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "c3 fs12px fw600",
                                                        children: [
                                                            current,
                                                            "/",
                                                            total,
                                                            " \xb7 ",
                                                            pct,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df fdc p1rem br10px bg5",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w100 fs13px fw500 c12 mb0-5rem",
                                        children: "Currently working on"
                                    }),
                                    diagnoseReading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: '0.5rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: (parcelRequire("bi4Ns")),
                                                                alt: "icon",
                                                                style: {
                                                                    width: 22,
                                                                    height: 22,
                                                                    flexShrink: 0
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs13px fw400 c15",
                                                                children: diagnoseReading.qNo ? `Answer ${diagnoseReading.qNo}` : "Processing answer\u2026"
                                                            })
                                                        ]
                                                    }),
                                                    diagnoseReading.questionText && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "db fs12px fw400 c14 ml1-5rem mt0-25rem",
                                                        style: {
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word'
                                                        },
                                                        children: [
                                                            '"',
                                                            diagnoseReading.questionText,
                                                            '"'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bg17 fw600 fs10px br50px px1rem py0-25rem c18",
                                                style: {
                                                    flexShrink: 0,
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: filesLabel ? `Reading: ${filesLabel}` : "Checking documents\u2026"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs13px fw400 c12 mb0rem",
                                        children: "Starting up\u2026"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcfe",
                                style: {
                                    gap: '0.75rem',
                                    marginTop: '1.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: handleCancel,
                                        style: $86bb04e68ae2fbe5$var$btnCancel,
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: handleMinimize,
                                        style: $86bb04e68ae2fbe5$var$btnMinimize,
                                        children: "Minimize"
                                    })
                                ]
                            })
                        ]
                    });
                })(),
                !loading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc",
                    style: {
                        flex: 1,
                        overflow: 'hidden'
                    },
                    children: [
                        summary && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic px2rem py1rem",
                            style: {
                                gap: '1rem',
                                borderBottom: '1px solid #F3F4F6',
                                flexShrink: 0
                            },
                            children: [
                                {
                                    label: 'Module Section{s} reviewed',
                                    value: summary.total,
                                    bg: '#F9FAFB',
                                    color: '#374151',
                                    border: '#E5E7EB'
                                },
                                {
                                    label: 'Module Section{s} passed',
                                    value: summary.correct,
                                    bg: '#ECFDF5',
                                    color: '#059669',
                                    border: '#A7F3D0'
                                },
                                {
                                    label: 'Module Section{s} require further review',
                                    value: summary.incorrect,
                                    bg: '#FFF5F7',
                                    color: '#DC2626',
                                    border: '#FCA5A5'
                                }
                            ].map(({ label: label, value: value, bg: bg, color: color, border: border })=>{
                                const v = value ?? 0;
                                const text = label.replace('{s}', v === 1 ? '' : 's');
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc aic jcc br10px",
                                    style: {
                                        background: bg,
                                        border: `1px solid ${border}`,
                                        flex: 1,
                                        padding: '1rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '1.75rem',
                                                fontWeight: 700,
                                                color: color,
                                                lineHeight: 1.1
                                            },
                                            children: v
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '11px',
                                                fontWeight: 500,
                                                color: color,
                                                opacity: 0.75,
                                                marginTop: '4px',
                                                textAlign: 'center'
                                            },
                                            children: text
                                        })
                                    ]
                                }, label);
                            })
                        }),
                        results.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic px2rem py0-75rem",
                            style: {
                                gap: '0.5rem',
                                borderBottom: '1px solid #F3F4F6',
                                flexShrink: 0,
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    value: search,
                                    onChange: (e)=>setSearch(e.target.value),
                                    placeholder: "Search questions\u2026",
                                    className: "fs13px fw400 c15 br50px bss bw1px bo29 px1rem py0-5rem",
                                    style: {
                                        outline: 'none',
                                        flex: '1 1 200px',
                                        minWidth: 0
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic",
                                    style: {
                                        gap: '0.4rem',
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        {
                                            key: 'all',
                                            label: 'All'
                                        },
                                        {
                                            key: 'correct',
                                            label: 'Correct'
                                        },
                                        {
                                            key: 'incorrect',
                                            label: 'Incorrect'
                                        }
                                    ].map(({ key: key, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>setFilter(key),
                                            className: "br50px px1rem py0-375rem fs13px cp",
                                            style: {
                                                border: '1px solid #D1D5DB',
                                                background: filter === key ? '#fff' : '#F3F4F6',
                                                color: '#151313',
                                                fontWeight: filter === key ? 700 : 400,
                                                boxShadow: filter === key ? '0 1px 3px rgba(0,0,0,0.08)' : 'none'
                                            },
                                            children: label
                                        }, key))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "oya",
                            style: {
                                flex: 1,
                                padding: '1.5rem 2rem'
                            },
                            children: [
                                results.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc aic jcc p3rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c12 tac fs14px mb0rem",
                                        children: "No answers found for the selected sources."
                                    })
                                }),
                                filtered.length === 0 && results.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc aic jcc p2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c12 tac fs13px mb0rem",
                                        children: "No results match the current filter."
                                    })
                                }),
                                filtered.map((r, idx)=>{
                                    const vs = $86bb04e68ae2fbe5$var$VERDICT_STYLES[r.verdict] || $86bb04e68ae2fbe5$var$VERDICT_STYLES.needs_review;
                                    const conf = r.confidence ?? 0;
                                    // Score out of 10 with the same thresholds/colors as the file-allocation AI Confidence badge, for consistency
                                    const scoreVal = Math.round(conf * 10);
                                    const scoreColor = scoreVal >= 8 ? '#16a34a' : scoreVal >= 6 ? '#d97706' : '#dc2626';
                                    const suggestedQNo = r.suggestedQNo ?? null;
                                    const isFixed = fixedCards.has(r.qNo);
                                    const isFixing = fixingCards.has(r.qNo);
                                    const isRolledBack = rolledBackCards.has(r.qNo);
                                    const isRollingBack = rollingBackCards.has(r.qNo);
                                    const showRollback = r.source === 'clarence' && r.autoFilled && r.answerId && !isRolledBack;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            marginBottom: '1rem',
                                            borderRadius: '10px',
                                            background: '#fff',
                                            borderLeft: `4px solid ${vs.color}`,
                                            boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
                                            padding: '1rem 1.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcsb",
                                                style: {
                                                    gap: '0.75rem',
                                                    marginBottom: '0.75rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: '0.5rem',
                                                            flex: 1,
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            r.qNo && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '11px',
                                                                    fontWeight: 700,
                                                                    color: '#9CA3AF',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.05em',
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                children: r.qNo
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    color: '#151313',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                title: r.question,
                                                                children: r.question
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            background: vs.bg,
                                                            color: vs.color,
                                                            border: `1px solid ${vs.border}`,
                                                            padding: '4px 14px',
                                                            borderRadius: '50px',
                                                            whiteSpace: 'nowrap',
                                                            flexShrink: 0
                                                        },
                                                        children: vs.label
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    background: '#F8FAFC',
                                                    border: '1px solid #E2E8F0',
                                                    borderRadius: '8px',
                                                    padding: '10px 14px',
                                                    marginBottom: '0.75rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic jcsb",
                                                        style: {
                                                            marginBottom: '6px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    gap: '0.5rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: {
                                                                            fontSize: '10px',
                                                                            fontWeight: 700,
                                                                            color: '#94A3B8',
                                                                            textTransform: 'uppercase',
                                                                            letterSpacing: '0.08em'
                                                                        },
                                                                        children: "Answer"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: {
                                                                            fontSize: '11px',
                                                                            fontWeight: 600,
                                                                            padding: '2px 10px',
                                                                            borderRadius: '50px',
                                                                            ...r.source === 'clarence' ? {
                                                                                background: '#EEF2FF',
                                                                                color: '#4A67FF',
                                                                                border: '1px solid #C7D2FE'
                                                                            } : {
                                                                                background: '#FFF7ED',
                                                                                color: '#C2410C',
                                                                                border: '1px solid #FED7AA'
                                                                            }
                                                                        },
                                                                        children: r.source === 'clarence' ? 'Clarence' : 'Human'
                                                                    }),
                                                                    isRolledBack && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: {
                                                                            fontSize: '11px',
                                                                            fontWeight: 600,
                                                                            padding: '2px 10px',
                                                                            borderRadius: '50px',
                                                                            background: '#F3F4F6',
                                                                            color: '#6B7280',
                                                                            border: '1px solid #D1D5DB'
                                                                        },
                                                                        children: "Rolled back"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '10px',
                                                                    flexShrink: 0
                                                                },
                                                                children: [
                                                                    showRollback && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: ()=>handleRollbackAnswer(r),
                                                                        disabled: isRollingBack,
                                                                        "data-tooltip": "Undo this AI-filled answer and restore your previous answer, or reset to empty if none existed",
                                                                        style: {
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            width: 28,
                                                                            height: 28,
                                                                            borderRadius: '50%',
                                                                            background: '#fff',
                                                                            border: '1px solid #FCA5A5',
                                                                            cursor: isRollingBack ? 'default' : 'pointer',
                                                                            opacity: isRollingBack ? 0.5 : 1,
                                                                            flexShrink: 0,
                                                                            padding: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "14",
                                                                            height: "14",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M3 12C3 7.02944 7.02944 3 12 3C14.8273 3 17.35 4.30367 19 6.34267M21 12C21 16.9706 16.9706 21 12 21C9.1727 21 6.65 19.6963 5 17.6573",
                                                                                    stroke: "#DC2626",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M19 2V7H14",
                                                                                    stroke: "#DC2626",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M5 22V17H10",
                                                                                    stroke: "#DC2626",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        style: {
                                                                            display: 'inline-flex',
                                                                            alignItems: 'center',
                                                                            gap: 4,
                                                                            background: scoreColor + '18',
                                                                            border: '1px solid ' + scoreColor + '40',
                                                                            borderRadius: 12,
                                                                            padding: '3px 9px',
                                                                            flexShrink: 0
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                src: (parcelRequire("bi4Ns")),
                                                                                alt: "icon",
                                                                                style: {
                                                                                    width: 20,
                                                                                    height: 20
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    fontSize: 12,
                                                                                    fontWeight: 700,
                                                                                    color: scoreColor
                                                                                },
                                                                                children: scoreVal
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        style: {
                                                            fontSize: '15px',
                                                            fontWeight: 600,
                                                            color: '#151313',
                                                            margin: 0
                                                        },
                                                        children: r.answer || "\u2014"
                                                    })
                                                ]
                                            }),
                                            r.reason && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    marginBottom: '0.75rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontSize: '10px',
                                                            fontWeight: 700,
                                                            color: '#94A3B8',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.08em',
                                                            display: 'block',
                                                            marginBottom: '4px'
                                                        },
                                                        children: "Reasoning"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        style: {
                                                            fontSize: '13px',
                                                            fontWeight: 400,
                                                            color: '#5E5F66',
                                                            lineHeight: 1.65,
                                                            margin: 0
                                                        },
                                                        children: r.reason
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcsb",
                                                style: {
                                                    gap: '0.75rem',
                                                    flexWrap: 'wrap'
                                                },
                                                children: [
                                                    (r.files || []).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: '0.4rem',
                                                            flexWrap: 'wrap',
                                                            flex: 1
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '10px',
                                                                    fontWeight: 700,
                                                                    color: '#94A3B8',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.08em',
                                                                    marginRight: '2px'
                                                                },
                                                                children: "Sources"
                                                            }),
                                                            r.files.map((f, fi)=>{
                                                                const url = r.fileUrls?.[fi];
                                                                const chipStyle = {
                                                                    fontSize: '10px',
                                                                    fontWeight: 500,
                                                                    background: '#EFF6FF',
                                                                    color: '#2563EB',
                                                                    padding: '2px 7px',
                                                                    borderRadius: '5px',
                                                                    border: '1px solid #BFDBFE',
                                                                    textDecoration: 'none',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: '3px',
                                                                    ...url ? {
                                                                        cursor: 'pointer'
                                                                    } : {}
                                                                };
                                                                const inner = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        url && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                            width: "9",
                                                                            height: "9",
                                                                            viewBox: "0 0 20 20",
                                                                            fill: "none",
                                                                            style: {
                                                                                flexShrink: 0
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M4 4h5v2H6v8h8v-3h2v5H4V4zm7-1h6v6h-2V6.414l-5.293 5.293-1.414-1.414L13.586 5H11V3z",
                                                                                fill: "currentColor"
                                                                            })
                                                                        }),
                                                                        f
                                                                    ]
                                                                });
                                                                return url ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    href: url,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    style: chipStyle,
                                                                    title: f,
                                                                    children: inner
                                                                }, fi) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    style: chipStyle,
                                                                    title: f,
                                                                    children: inner
                                                                }, fi);
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: 1
                                                        }
                                                    }),
                                                    suggestedQNo && (r.files || []).length > 0 && (isFixed ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            color: '#059669',
                                                            background: '#ECFDF5',
                                                            border: '1px solid #A7F3D0',
                                                            borderRadius: '50px',
                                                            padding: '5px 14px',
                                                            whiteSpace: 'nowrap',
                                                            flexShrink: 0
                                                        },
                                                        children: [
                                                            "\u2713 Moved to ",
                                                            suggestedQNo
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        disabled: isFixing,
                                                        onClick: ()=>handleApplyFix(r, suggestedQNo),
                                                        style: {
                                                            fontSize: '12px',
                                                            fontWeight: 600,
                                                            background: '#4A67FF',
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: '50px',
                                                            padding: '5px 16px',
                                                            cursor: isFixing ? 'default' : 'pointer',
                                                            opacity: isFixing ? 0.6 : 1,
                                                            whiteSpace: 'nowrap',
                                                            flexShrink: 0
                                                        },
                                                        children: isFixing ? "Moving\u2026" : `Move to ${suggestedQNo}`
                                                    })),
                                                    !suggestedQNo && r.verdict === 'incorrect' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontSize: '11px',
                                                            fontWeight: 500,
                                                            color: '#94A3B8',
                                                            fontStyle: 'italic',
                                                            whiteSpace: 'nowrap',
                                                            flexShrink: 0
                                                        },
                                                        children: "No suggested fix \u2014 question doesn't match anywhere"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, idx);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcfe px2rem py1rem",
                            style: {
                                borderTop: '1px solid #F3F4F6',
                                flexShrink: 0,
                                gap: '0.75rem'
                            },
                            children: [
                                results.filter((r)=>r.suggestedQNo && !fixedCards.has(r.qNo) && (r.files || []).length > 0).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    disabled: applyingAll,
                                    onClick: handleApplyAllFixes,
                                    className: "br50px px2rem py0-75rem cp fw600 fs14px c1",
                                    style: {
                                        border: 'none',
                                        background: applyingAll ? '#6B8BFF' : '#4A67FF',
                                        opacity: applyingAll ? 0.7 : 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    },
                                    children: applyingAll ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                style: {
                                                    animation: 'spin 1s linear infinite'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "10",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2.5",
                                                    strokeDasharray: "40",
                                                    strokeDashoffset: "10",
                                                    strokeLinecap: "round"
                                                })
                                            }),
                                            "Applying\u2026"
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: "\u26A1 Apply All Fixes"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: close,
                                    className: "bg4 c1 br50px px3rem py0-75rem cp fw500 fs14px",
                                    style: {
                                        border: 'none'
                                    },
                                    children: "Done"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $86bb04e68ae2fbe5$var$DiagnoseButton = ({ companyId: companyId, moduleType: moduleType, moduleId: moduleId, tab: tab, activeModule: activeModule })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const store = (0, $391671225302c365$export$6ccbb43953eebf8)();
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [selection, setSelection] = (0, $acw62.useState)(new Set([
        'clarence',
        'human'
    ]));
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const panelRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const handleMouseDown = (e)=>{
            if (panelRef.current && !panelRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handleMouseDown);
        return ()=>document.removeEventListener('mousedown', handleMouseDown);
    }, []);
    const toggleSelection = (key)=>{
        setSelection((prev)=>{
            const next = new Set(prev);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    };
    const handleGenerateReport = async ()=>{
        setOpen(false);
        setLoading(true);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'diagnoseReport',
            diagnoseLoading: true,
            diagnoseCancelled: false,
            diagnoseResults: [],
            diagnoseSummary: null,
            diagnoseModuleName: activeModule?.heading || tab || '',
            diagnoseCompanyId: companyId,
            diagnoseModuleType: moduleType,
            diagnoseModuleId: moduleId || null
        }));
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/diagnose', {
                companyId: companyId,
                moduleType: moduleType,
                ...moduleId ? {
                    moduleId: moduleId
                } : {},
                sources: [
                    ...selection
                ]
            });
            // Reason: Cancel already reset modal/loading state locally and told the backend to stop between
            // batches — this promise still resolves once that in-flight request returns, so skip writing
            // results/reopening the modal for a run the user already dismissed
            if (store.getState().modal.diagnoseCancelled) return;
            if (response?.code === 200) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                diagnoseLoading: false,
                diagnoseResults: response.body.results || [],
                diagnoseSummary: response.body.summary || null,
                diagnoseStatusBarVisible: false,
                diagnoseStatusBarCompleted: true
            }));
            else {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    diagnoseLoading: false,
                    diagnoseStatusBarVisible: false
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Auditor failed. Please try again.');
            }
        } catch (_) {
            if (store.getState().modal.diagnoseCancelled) return;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                diagnoseLoading: false,
                diagnoseStatusBarVisible: false
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auditor failed. Please try again.');
        }
        setLoading(false);
    };
    if (!(0, $6a6b4b5ab5be324d$export$2908142509316f06)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "pr ml0-5rem",
        ref: panelRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "auto-fill-icon-wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>setOpen((o)=>!o),
                        disabled: loading,
                        className: "cp fs13px fw600 bg1 bg3-hover c3 c1-hover bw1px bo3 bss br50px px1rem py0-5rem df jcc aic",
                        children: [
                            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                style: {
                                    animation: 'spin 1s linear infinite',
                                    marginRight: '6px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                    cx: "12",
                                    cy: "12",
                                    r: "10",
                                    stroke: "currentColor",
                                    strokeWidth: "2.5",
                                    strokeDasharray: "40",
                                    strokeDashoffset: "10",
                                    strokeLinecap: "round"
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                style: {
                                    marginRight: '6px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            loading ? 'Analysing...' : 'Auditor'
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "auto-fill-hover-chip",
                        children: "Get an AI-powered quality check on your submitted answers"
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pa bg1 shadow br10px zi10",
                style: {
                    minWidth: '220px',
                    top: '110%',
                    right: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "df aic px1rem py0-5rem bg5-hover cp",
                        style: {
                            gap: '0.5rem',
                            borderTopLeftRadius: '10px',
                            borderTopRightRadius: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "checkbox w20px h20px pr",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "checkbox",
                                    className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                    checked: selection.has('clarence'),
                                    onChange: ()=>toggleSelection('clarence')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs13px fw400 c14",
                                children: "Clarence Answers"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs11px c12 mla wsn",
                                children: "(AI-filled)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "df aic px1rem py0-5rem bg5-hover cp",
                        style: {
                            gap: '0.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "checkbox w20px h20px pr",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "checkbox",
                                    className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                    checked: selection.has('human'),
                                    onChange: ()=>toggleSelection('human')
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs13px fw400 c14",
                                children: "Human Answers"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bss bs1px bo29 mx1rem"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        disabled: selection.size === 0,
                        onClick: handleGenerateReport,
                        className: "w100 bg3 c1 fw600 fs13px cp py0-75rem",
                        style: {
                            border: 'none',
                            borderBottomLeftRadius: '10px',
                            borderBottomRightRadius: '10px',
                            opacity: selection.size === 0 ? 0.5 : 1
                        },
                        children: "Generate Report"
                    })
                ]
            })
        ]
    });
};
var $86bb04e68ae2fbe5$export$2e2bcd8739ae039 = $86bb04e68ae2fbe5$var$DiagnoseButton;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");







const $0cbd065623d03bb9$var$isObjectId = (str)=>typeof str === 'string' && /^[0-9a-fA-F]{24}$/.test(str);


const $0cbd065623d03bb9$var$OpenRModalComponentNew = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { company: company, tab: tab, rModalData: rModalData, openRModal: openRModal, fileReport: fileReport, moduleId: moduleId, tempModule: tempModule } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { unallocatedFiles: unallocatedFiles, deduperReports: deduperReports } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.files);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [selectedQuestion, setSelectedQuestion] = (0, $acw62.useState)(null);
    const [forwardData, setForwardData] = (0, $acw62.useState)(null);
    const [curQno, setCurQno] = (0, $acw62.useState)(null);
    // Only active on the temp-module route (/company/)
    const isCompanyNewRoute = location.pathname.startsWith('/company/');
    // Resolve module identifier for by-name matching
    const effectiveModuleName = (0, $acw62.useMemo)(()=>{
        if (fileReport?.moduleKey) return fileReport.moduleKey;
        if (fileReport?.moduleSlug) return fileReport.moduleSlug;
        if (fileReport?.moduleName && !$0cbd065623d03bb9$var$isObjectId(fileReport.moduleName)) return fileReport.moduleName;
        if (tab) return tab;
        return null;
    }, [
        fileReport?.moduleKey,
        fileReport?.moduleSlug,
        fileReport?.moduleName,
        tab
    ]);
    const effectiveCompanyId = (0, $acw62.useMemo)(()=>{
        return company?._id || selectedCompany?._id || null;
    }, [
        company?._id,
        selectedCompany?._id
    ]);
    // Natural sort: IRZQR1 < IRZQR2 < IRZQR10 (instead of lexicographic IRZQR1 < IRZQR10 < IRZQR2).
    // Uses localeCompare with { numeric: true } which handles numeric runs inside strings correctly.
    const sortSectionsByNo = (sections)=>{
        if (!Array.isArray(sections)) return sections;
        return [
            ...sections
        ].sort((a, b)=>{
            const aKey = String(a?.sectionNo ?? a?.no ?? '');
            const bKey = String(b?.sectionNo ?? b?.no ?? '');
            return aKey.localeCompare(bKey, undefined, {
                numeric: true,
                sensitivity: 'base'
            });
        });
    };
    // Pull TempSections from Redux (populated by parent pages/hooks that fetch the active temp module).
    // This avoids re-fetching `/modules/temp-modules/by-name/...` every time the modal opens.
    const tempSections = (0, $acw62.useMemo)(()=>{
        if (!tempModule || !Array.isArray(tempModule.sections)) return [];
        if (!effectiveModuleName) return sortSectionsByNo(tempModule.sections);
        const candidates = [
            tempModule.moduleKey,
            tempModule.moduleSlug,
            tempModule.slug,
            tempModule.moduleName
        ].filter(Boolean).map((v)=>String(v).toLowerCase());
        const target = String(effectiveModuleName).toLowerCase();
        if (candidates.length && !candidates.includes(target)) return [];
        if (effectiveCompanyId && tempModule.companyId && String(tempModule.companyId) !== String(effectiveCompanyId)) return [];
        return sortSectionsByNo(tempModule.sections);
    }, [
        tempModule,
        effectiveModuleName,
        effectiveCompanyId
    ]);
    const Chevron = ({ className: className = "" })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: className,
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                clipRule: "evenodd"
            })
        });
    };
    const handleClose = ()=>{
        setSelectedQuestion(null);
        setForwardData(null);
        setCurQno(null);
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(false));
    };
    const handleConfirm = ()=>{
        if (rModalData?.from && rModalData?.from === "fileReport" && rModalData?.actionType === "move") dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(forwardData));
        else if (rModalData?.from && rModalData?.from === "deduper") dispatch((0, $e0a7c253e2df808f$export$607aedf5e5b112cd)(forwardData));
        else if (rModalData?.from && rModalData?.from === "section") dispatch((0, $e0a7c253e2df808f$export$6d5d8bd59e3ba7ac)(forwardData));
        else dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(forwardData));
        handleClose();
    };
    const selectTargetSection = async (fileKey, qNo, name, from, index)=>{
        setSelectedQuestion(qNo);
        if (from && from === "fileReport" && rModalData?.actionType === "move") {
            setCurQno(fileReport.importResult[fileKey].section[0]);
            setForwardData({
                ...fileReport,
                importResult: {
                    ...fileReport.importResult,
                    [fileKey]: {
                        ...fileReport.importResult[fileKey],
                        section: [
                            qNo
                        ],
                        originalSection: [
                            qNo
                        ],
                        isModified: true
                    }
                }
            });
        }
        if (from && from === "unallocated" && rModalData?.actionType === "reallocate") setForwardData([
            ...unallocatedFiles
        ].reduce((acc, current, _index)=>{
            if (`${_index}` === `${rModalData.index}`) acc.push({
                ...current,
                sectionNo: qNo,
                name: name
            });
            else acc.push(current);
            return acc;
        }, []));
        if (from && from === "deduper") {
            const selectedDeuper = deduperReports && deduperReports.selectedDeuper && deduperReports.selectedDeuper.length ? [
                ...deduperReports.selectedDeuper
            ] : [];
            const modifiedDeduperResult = {
                ...deduperReports.deduperResult,
                [rModalData.key]: deduperReports.deduperResult[rModalData.key].flatMap((item, index)=>{
                    if (index === rModalData.index) {
                        selectedDeuper.push({
                            ...item,
                            curQno: item.qNo,
                            qNo: qNo,
                            isModified: true,
                            actionType: rModalData.actionType,
                            key: item.file.key,
                            index: rModalData.index
                        });
                        if (rModalData?.actionType === "move") return [
                            {
                                ...item,
                                qNo: qNo,
                                isModified: true,
                                name: name,
                                actionType: rModalData.actionType
                            }
                        ];
                        else return [
                            {
                                ...item
                            },
                            {
                                ...item,
                                qNo: qNo,
                                isModified: true,
                                name: name,
                                actionType: rModalData.actionType
                            }
                        ];
                    }
                    return item;
                })
            };
            setForwardData({
                ...deduperReports,
                deduperResult: modifiedDeduperResult,
                selectedDeuper: selectedDeuper
            });
        }
        if (from && from === "section") {
            const selectedFile = [
                ...rModalData.section.files
            ].filter((_f, _i)=>_i === rModalData.index);
            const sectionData = {
                ...rModalData.section,
                files: rModalData.actionType === "move" ? [
                    ...rModalData.section.files
                ].filter((_f, _i)=>_i !== rModalData.index) : qNo === (rModalData.section.qNo ?? rModalData.section.qNo) ? [
                    ...rModalData.section.files,
                    ...selectedFile
                ] : rModalData.section.files
            };
            setForwardData({
                sectionData: sectionData,
                selectFile: selectedFile,
                actionType: rModalData.actionType,
                qNo: qNo
            });
        }
    };
    const getSectionDropDown = (section, fileKey, from, index)=>{
        const qNo = section.sectionNo || section.no; // Section number
        const name = section.sectionName || section.name; // Section name
        if (section.subFolders && !qNo.includes(".") && selectedCompany['subscription'] && selectedCompany['subscription'] === "Pro") // Main section with dropdown (only for top-level sections)
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$d99097c13d4dac9f), {
            children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lightBorder mb0-5rem w100 jcsb cp ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1be75d49f257bf03$export$5e3e5deaaf81ee41), {
                            className: "df aic jcsb bg1 w100 dropdown-section-header px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    className: "c15 fw400 tal",
                                    children: [
                                        qNo,
                                        ". ",
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)(Chevron, {
                                    className: `c3 td300 ml0-5rem ${!open ? "tr90deg" : "tr270deg"} mxw1rem`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$4f68206c92b94e7b), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: Object.keys(section.subFolders).sort((a, b)=>{
                                    const aKey = String(section.subFolders[a]?.sectionNo ?? section.subFolders[a]?.no ?? a);
                                    const bKey = String(section.subFolders[b]?.sectionNo ?? section.subFolders[b]?.no ?? b);
                                    return aKey.localeCompare(bKey, undefined, {
                                        numeric: true,
                                        sensitivity: 'base'
                                    });
                                }).map((key)=>{
                                    const subFolder = section.subFolders[key];
                                    return getSectionDropDown(subFolder, fileKey, from, index);
                                })
                            })
                        })
                    ]
                })
        }, qNo);
        else if (section.subFolders && selectedCompany['subscription'] && selectedCompany['subscription'] === "Pro") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    onClick: ()=>selectTargetSection(fileKey, qNo, name, from, index),
                    className: "rs-dropdown-item",
                    children: [
                        qNo,
                        ". ",
                        name
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        paddingLeft: '36px'
                    },
                    children: Object.keys(section.subFolders).sort((a, b)=>{
                        const aKey = String(section.subFolders[a]?.sectionNo ?? section.subFolders[a]?.no ?? a);
                        const bKey = String(section.subFolders[b]?.sectionNo ?? section.subFolders[b]?.no ?? b);
                        return aKey.localeCompare(bKey, undefined, {
                            numeric: true,
                            sensitivity: 'base'
                        });
                    }).map((key)=>{
                        const subFolder = section.subFolders[key];
                        return getSectionDropDown(subFolder, fileKey, from, index);
                    })
                })
            ]
        }, `subfolder-${qNo}`);
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `rs-dropdown-item ${selectedQuestion && qNo === selectedQuestion ? 'selected' : ''}`,
            onClick: ()=>selectTargetSection(fileKey, qNo, name, from, index),
            children: [
                qNo,
                ". ",
                name
            ]
        }, qNo);
    };
    const getTempSectionsAccordion = (key, from, index)=>{
        if (!tempSections?.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "c15 fs0-875rem tac op60 p1rem",
            children: "No sections available"
        });
        const hasSubFolders = (section)=>!!(section?.subFolders && typeof section.subFolders === 'object' && Object.keys(section.subFolders).length > 0);
        const renderTempSubFolders = (subFolders, level = 1)=>{
            if (!subFolders || typeof subFolders !== 'object') return null;
            const sortedKeys = Object.keys(subFolders).sort((a, b)=>{
                const aKey = String(subFolders[a]?.no ?? subFolders[a]?.sectionNo ?? a);
                const bKey = String(subFolders[b]?.no ?? subFolders[b]?.sectionNo ?? b);
                return aKey.localeCompare(bKey, undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
            });
            return sortedKeys.map((subKey)=>{
                const subFolder = subFolders[subKey];
                if (!subFolder) return null;
                const qNo = subFolder.no;
                const name = subFolder.name || subFolder.sectionName || 'Sub section';
                const nested = subFolder.subFolders && typeof subFolder.subFolders === 'object' ? subFolder.subFolders : null;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `rs-dropdown-item ${selectedQuestion && qNo === selectedQuestion ? 'selected' : ''}`,
                            style: {
                                paddingLeft: `${1 + level * 1.25}rem`
                            },
                            onClick: ()=>selectTargetSection(key, qNo, name, from, index),
                            children: [
                                qNo ? `${qNo}. ` : '',
                                name
                            ]
                        }),
                        nested && renderTempSubFolders(nested, level + 1)
                    ]
                }, `temp-sub-${qNo || subKey}`);
            });
        };
        // Render questions as a hierarchy when a section has no subFolders.
        // Used for modules like Investor Lead (DEPF008) where sub-items live in
        // section.questions rather than section.subFolders.
        const renderQuestionsHierarchy = (questions, parentQNo, level = 1)=>{
            const parentDepth = parentQNo.split('.').length;
            const directChildren = questions.filter((q)=>{
                if (!q.qNo) return false;
                const parts = q.qNo.split('.');
                return parts.length === parentDepth + 1 && q.qNo.startsWith(parentQNo + '.');
            }).sort((a, b)=>(a.qNo || '').localeCompare(b.qNo || '', undefined, {
                    numeric: true,
                    sensitivity: 'base'
                }));
            if (!directChildren.length) return null;
            return directChildren.map((q)=>{
                const childQNo = q.qNo;
                const childName = q.qDescription || q.uploadFolder || childQNo;
                const hasChildren = questions.some((sq)=>{
                    if (!sq.qNo) return false;
                    const parts = sq.qNo.split('.');
                    return parts.length === childQNo.split('.').length + 1 && sq.qNo.startsWith(childQNo + '.');
                });
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `rs-dropdown-item ${selectedQuestion && childQNo === selectedQuestion ? 'selected' : ''}`,
                            style: {
                                paddingLeft: `${1 + level * 1.25}rem`
                            },
                            onClick: ()=>selectTargetSection(key, childQNo, childName, from, index),
                            children: [
                                childQNo,
                                ". ",
                                childName
                            ]
                        }),
                        hasChildren && renderQuestionsHierarchy(questions, childQNo, level + 1)
                    ]
                }, `q-item-${childQNo}`);
            });
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: tempSections.map((section)=>{
                const qNo = section.sectionNo || section.no;
                const name = section.sectionName || section.name || 'Section';
                if (!hasSubFolders(section)) {
                    // Check if questions can serve as sub-items (e.g. Investor Lead / DEPF008)
                    const sectionQNo = qNo || '';
                    const hasQuestionChildren = Array.isArray(section.questions) && section.questions.some((q)=>{
                        if (!q.qNo || !sectionQNo) return false;
                        const parts = q.qNo.split('.');
                        return parts.length === sectionQNo.split('.').length + 1 && q.qNo.startsWith(sectionQNo + '.');
                    });
                    if (hasQuestionChildren) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$a766cd26d0d69044), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$d99097c13d4dac9f), {
                            children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lightBorder mb0-5rem w100 cp",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1be75d49f257bf03$export$5e3e5deaaf81ee41), {
                                            className: "df aic jcsb bg1 w100 dropdown-section-header px2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                    className: "c15 fw400 tal fs0-875rem",
                                                    children: [
                                                        qNo ? `${qNo}. ` : '',
                                                        name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)(Chevron, {
                                                    className: `c3 td300 ml0-5rem ${open ? 'tr270deg' : 'tr90deg'} mxw1rem`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$4f68206c92b94e7b), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "py0-25rem",
                                                children: renderQuestionsHierarchy(section.questions, sectionQNo, 1)
                                            })
                                        })
                                    ]
                                })
                        })
                    }, `temp-accordion-q-${section._id || qNo}`);
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `rs-dropdown-item ${selectedQuestion && qNo === selectedQuestion ? 'selected' : ''}`,
                        onClick: ()=>selectTargetSection(key, qNo, name, from, index),
                        children: [
                            qNo ? `${qNo}. ` : '',
                            name
                        ]
                    }, `temp-section-${section._id || qNo}`);
                }
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$a766cd26d0d69044), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$d99097c13d4dac9f), {
                        children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lightBorder mb0-5rem w100 cp",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1be75d49f257bf03$export$5e3e5deaaf81ee41), {
                                        className: "df aic jcsb bg1 w100 dropdown-section-header px2rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "c15 fw400 tal fs0-875rem",
                                                children: [
                                                    qNo ? `${qNo}. ` : '',
                                                    name
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)(Chevron, {
                                                className: `c3 td300 ml0-5rem ${open ? 'tr270deg' : 'tr90deg'} mxw1rem`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$4f68206c92b94e7b), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "py0-25rem",
                                            children: renderTempSubFolders(section.subFolders, 1)
                                        })
                                    })
                                ]
                            })
                    })
                }, `temp-accordion-${section._id || qNo}`);
            })
        });
    };
    if (!isCompanyNewRoute || !openRModal) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const isTempModule = !!moduleId;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9a6d1502d000f566$export$2e2bcd8739ae039), {
        overflow: true,
        open: openRModal,
        onClose: handleClose,
        style: {
            zIndex: '2000'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9a6d1502d000f566$export$2e2bcd8739ae039).Header, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic jcfs",
                        children: [
                            "move",
                            "reallocate"
                        ].includes(rModalData.actionType) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("3CMpU")),
                                    alt: "moveFileIcon",
                                    style: {
                                        width: '40px',
                                        height: '40px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c15 fw600 ml0-5rem fs20px",
                                    children: "reallocate" === rModalData.actionType ? "Reallocate File" : "Move File"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("4aBsx")),
                                    alt: "moveFileImg",
                                    style: {
                                        width: '40px',
                                        height: '40px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c15 fw600 ml0-5rem fs20px",
                                    children: "Copy File"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c3",
                        children: rModalData.fileName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs0-75rem op60 mt0-25rem",
                        children: "Select destination section"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a6d1502d000f566$export$2e2bcd8739ae039).Body, {
                style: {
                    maxHeight: '550px',
                    paddingRight: '16px'
                },
                className: "lightScrollbar",
                children: getTempSectionsAccordion(rModalData.key, rModalData.from, rModalData.index)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w100 tac",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    text: rModalData.actionType === "copy" ? "Copy File" : "Move File",
                    btnType: "warning",
                    onClick: handleConfirm,
                    customClassName: "mla mra c1",
                    disabled: selectedQuestion === null
                })
            })
        ]
    });
};
var $0cbd065623d03bb9$export$2e2bcd8739ae039 = $0cbd065623d03bb9$var$OpenRModalComponentNew;



var $6ZWSX = parcelRequire("6ZWSX");
var $0868b271c9ad66ad$require$Buffer = $6ZWSX.Buffer;
let $0868b271c9ad66ad$var$passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
const $0868b271c9ad66ad$var$INVALID_PASSWORD_MSG = 'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.';
// Steps shown in the "generatingDescription" live setup checklist, in display order.
const $0868b271c9ad66ad$var$SETUP_STEPS = [
    {
        key: 'verified',
        label: 'Company verified'
    },
    {
        key: 'filing',
        label: 'Filing history & officers loaded'
    },
    {
        key: 'description',
        label: 'Generating AI company summary'
    },
    {
        key: 'adCalculation',
        label: 'Finalizing account setup'
    }
];















function $0868b271c9ad66ad$export$2e2bcd8739ae039() {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let store = (0, $391671225302c365$export$6ccbb43953eebf8)();
    let navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let loginType = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.loginType);
    let { syncing: syncing, message: message } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.appData);
    let [hash, setHash] = (0, $acw62.useState)();
    let [step, setStep] = (0, $acw62.useState)(1);
    let [tooltip, setTooltip] = (0, $acw62.useState)();
    let [counter, setCounter] = (0, $acw62.useState)(0); // Countdown for 60s
    let [company, setCompany] = (0, $acw62.useState)({});
    let [creatingModule, setCreatingModule] = (0, $acw62.useState)(''); // Module name shown in the generatePartnerPopup loader (e.g. 'Investment Readiness')
    // Live status of each companySetup step shown in the "generatingDescription" checklist modal: 'pending' | 'done' | 'error'
    let [setupSteps, setSetupSteps] = (0, $acw62.useState)({
        verified: 'done',
        filing: 'done',
        description: 'pending',
        adCalculation: 'pending'
    });
    let [isPlay, setIsPlay] = (0, $acw62.useState)(false);
    let [loading, setLoading] = (0, $acw62.useState)(false);
    let [stepNo, setStepNo] = (0, $acw62.useState)('Step1'); // Step1, Step2, Step3, Step4
    let [loginFor, setLoginFor] = (0, $acw62.useState)(null);
    let [authMethod, setAuthMethod] = (0, $acw62.useState)();
    let [smsEnabled, setSmsEnabled] = (0, $acw62.useState)();
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [isBilling, setIsBilling] = (0, $acw62.useState)(false);
    let [accordion, setAccordion] = (0, $acw62.useState)('one');
    let [twoFaEnabled, setTwoFaEnabled] = (0, $acw62.useState)();
    let [emailEnabled, setEmailEnabled] = (0, $acw62.useState)();
    let [isFireWork, setIsFireWork] = (0, $acw62.useState)(false);
    let [resNewAdvisor, setResNewAdvisor] = (0, $acw62.useState)();
    let [bugDescription, setBugDescription] = (0, $acw62.useState)();
    let [passwordType, setPasswordType] = (0, $acw62.useState)(false);
    let [setPasswordError, setSetPasswordError] = (0, $acw62.useState)('');
    let [setPasswordFields, setSetPasswordFields] = (0, $acw62.useState)({
        newPassword: '',
        newPasswordType: true,
        confirmPassword: '',
        confirmPasswordType: true
    });
    const SET_PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
    let [parentCompany, setParentCompany] = (0, $acw62.useState)(null);
    let [companiesGroup, setCompaniesGroup] = (0, $acw62.useState)({}); // { companyId: '', group: '', percentage: '' }
    let [updateType, setUpdateType] = (0, $acw62.useState)('Edit'); // 'Add', 'Edit', 'Delete'
    let [editParentCompany, setEditParentCompany] = (0, $acw62.useState)(null);
    let [editCompaniesGroup, setEditCompaniesGroup] = (0, $acw62.useState)({});
    let [companyOptions, setCompanyOptions] = (0, $acw62.useState)([]);
    let [existingCompany, setExistingCompany] = (0, $acw62.useState)();
    let [selectedCompany, setSelectedCompany] = (0, $acw62.useState)({});
    let [confirmedCompany, setConfirmedCompany] = (0, $acw62.useState)();
    let [websiteStatus, setWebsiteStatus] = (0, $acw62.useState)('Check');
    let [existingInvestor, setExistingInvestor] = (0, $acw62.useState)({});
    let [editDescription, setEditDescription] = (0, $acw62.useState)(false);
    let [accessGrantedData, setAccessGrantedData] = (0, $acw62.useState)({});
    let [advisorAccessData, setAdvisorAccessData] = (0, $acw62.useState)(null);
    let [profileClass, setProfileClass] = (0, $acw62.useState)('client-profile');
    let [isDescriptionLogin, setIsDescriptionLogin] = (0, $acw62.useState)(false);
    let [previousCompanyDeleted, setPreviousCompanyDeleted] = (0, $acw62.useState)(false);
    let [applicant, setApplicant] = (0, $acw62.useState)({
        firstName: '',
        lastName: '',
        email: ''
    }); // Add Applicant Manual Investor Match
    let [formData, setFormData] = (0, $acw62.useState)({
        role: 'Advisor',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        designation: '',
        phone: '',
        firmName: '',
        firmAddress: '',
        website: '',
        firmLogo: ''
    });
    // Socket listeners for allocatingFiles modal — indexing + allocation progress
    const [indexingProgress, setIndexingProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        currentFile: ''
    });
    const [allocationProgress, setAllocationProgress] = (0, $acw62.useState)({
        total: 0,
        current: 0,
        fileName: '',
        matchedQNo: '',
        matchedQuestion: ''
    });
    const autoFillCancelledRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const onIndexingProgress = (data)=>{
            setIndexingProgress({
                total: data.total || 0,
                current: data.current || 0,
                currentFile: data.currentFile || ''
            });
        };
        const onAllocationProgress = (data)=>{
            setAllocationProgress({
                total: data.total || 0,
                current: data.current || 0,
                fileName: data.fileName || '',
                matchedQNo: data.matchedQNo || '',
                matchedQuestion: data.matchedQuestion || ''
            });
        };
        const onAllocationCompleted = (data)=>{
            // Don't re-show status bar if user cancelled
            if (autoFillCancelledRef.current) return;
            const currentPhase = store.getState().modal?.autoFillStatusBarPhase;
            if (!currentPhase) return;
            // Close any upload-related modal and open importSummary for review
            if ([
                'allocatingFiles',
                'computerToClarence'
            ].includes(modalOpenRef.current)) {
                if (data?.fileReport) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    fileReport: data.fileReport
                }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'importSummary',
                    autoFillStatusBarVisible: false,
                    autoFillStatusBarPhase: 'allocated'
                }));
            } else if (data?.fileReport) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: data.fileReport
            }));
        };
        const onAutoFillCancelled = ()=>{
            autoFillCancelledRef.current = true;
            // Reset after a short delay so future autofill operations work normally
            setTimeout(()=>{
                autoFillCancelledRef.current = false;
            }, 5000);
        };
        const onProcessingFilesProgress = (data)=>{
            if (modalOpenRef.current !== 'fileUploadFilingAssistant') return;
            const percent = data.total > 0 ? Math.round(data.current / data.total * 100) : 0;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                percent: percent
            }));
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('indexing:progress', onIndexingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('allocation:progress', onAllocationProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('allocation:completed', onAllocationCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:cancelled', onAutoFillCancelled);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempIndexing:progress', onIndexingProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:progress', onAllocationProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAllocation:completed', onAllocationCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:cancelled', onAutoFillCancelled);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('processingFiles:progress', onProcessingFilesProgress);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('indexing:progress', onIndexingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('allocation:progress', onAllocationProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('allocation:completed', onAllocationCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:cancelled', onAutoFillCancelled);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempIndexing:progress', onIndexingProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:progress', onAllocationProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAllocation:completed', onAllocationCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:cancelled', onAutoFillCancelled);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('processingFiles:progress', onProcessingFilesProgress);
        };
    }, []);
    // Socket listeners for autoFillingQuestions modal — only update Redux when modal is open
    const modalOpenRef = (0, $acw62.useRef)(modal['open']);
    modalOpenRef.current = modal['open'];
    // Reset the setup checklist each time the generatingDescription modal is (re)opened for a new company.
    (0, $acw62.useEffect)(()=>{
        if (modal['open'] === 'generatingDescription') setSetupSteps({
            verified: 'done',
            filing: 'done',
            description: 'pending',
            adCalculation: 'pending'
        });
    }, [
        modal['open']
    ]);
    (0, $acw62.useEffect)(()=>{
        const onProgress = (data)=>{
            if (modalOpenRef.current !== 'autoFillingQuestions' && modalOpenRef.current !== 'autoFillStepper' && modalOpenRef.current !== 'tempAutoFillStepper') return;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                autoFillTotal: data.total || 0,
                autoFillCurrent: data.current || 0,
                autoFillBatchSize: data.batchSize || 0,
                autoFillCurrentQuestion: data.currentQuestion || '',
                autoFillQuestionText: data.questionText || '',
                autoFillSectionNo: data.sectionNo || '',
                autoFillSectionName: data.sectionName || '',
                autoFillReadingFiles: [],
                autoFillCompleted: false
            }));
        };
        const onReading = (data)=>{
            if (modalOpenRef.current !== 'autoFillingQuestions' && modalOpenRef.current !== 'autoFillStepper' && modalOpenRef.current !== 'tempAutoFillStepper') return;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                autoFillReadingFiles: data.files || []
            }));
        };
        const onCompleted = (data)=>{
            // Show result immediately — don't wait for getModule
            const modalState = store.getState().modal;
            const isStepperFlow = modalState.open === 'autoFillStepper' || modalState.autoFillStepperPhase === 'filling';
            const isMinimized = modalState.autoFillStatusBarVisible === true;
            // Skip advancing to 'result' if extraModules are pending — handleSkipUpload's .then() will set 'otherModules'.
            // Also skip if research reports were requested — handleSkipUpload holds the user on the filling/otherModules
            // screen (showing live report progress) and only advances to 'result' once triggerReportsGeneration finishes.
            // Without this check, this socket-driven listener races handleSkipUpload's own HTTP response and wins,
            // jumping to Result before reports even start generating.
            const autoFillCtx = store.getState().fileAllocation?.autoFillContext || {};
            const extraModules = autoFillCtx.extraModules || [];
            const hasExtraModules = extraModules.length > 0;
            const hasReportsQueued = !!autoFillCtx.generateReports;
            const extraFields = isStepperFlow && !hasExtraModules && !hasReportsQueued ? {
                autoFillStepperPhase: 'result',
                autoFillStatusBarPhase: 'completed',
                ...isMinimized ? {} : {
                    open: 'autoFillStepper'
                }
            } : {};
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                autoFillCompleted: true,
                autoFillJustCompleted: true,
                autoFillProcessed: data.processed || 0,
                autoFillAnswered: data.answered || 0,
                autoFillNeedsReview: data.needsReview || 0,
                autoFillSkipped: data.skipped || 0,
                ...extraFields
            }));
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:progress', onProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:reading', onReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('autoFill:completed', onCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:progress', onProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:reading', onReading);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('tempAutoFill:completed', onCompleted);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:progress', onProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:reading', onReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('autoFill:completed', onCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:progress', onProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:reading', onReading);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('tempAutoFill:completed', onCompleted);
        };
    }, [
        dispatch
    ]);
    // Socket listeners for the async company-setup checklist (generatingDescription modal)
    const setupCompanyIdRef = (0, $acw62.useRef)(null);
    setupCompanyIdRef.current = company?.['_id'];
    const companyDescriptionRef = (0, $acw62.useRef)(null);
    companyDescriptionRef.current = company?.['companyDescription'];
    (0, $acw62.useEffect)(()=>{
        const isForSetupCompany = (data)=>data?.['companyId'] && setupCompanyIdRef.current && String(data['companyId']) === String(setupCompanyIdRef.current);
        const onSetupProgress = (data)=>{
            if (!isForSetupCompany(data)) return;
            if (data['step'] === 'adCalculation') setSetupSteps((prev)=>({
                    ...prev,
                    description: 'done',
                    adCalculation: 'pending'
                }));
        };
        const onDescriptionReady = (data)=>{
            if (!isForSetupCompany(data)) return;
            setSetupSteps((prev)=>({
                    ...prev,
                    description: 'done'
                }));
            setCompany((prev)=>({
                    ...prev,
                    companyDescription: data['companyDescription']
                }));
            companyDescriptionRef.current = data['companyDescription'];
            if (modalOpenRef.current !== 'generatingDescription') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Your AI company summary is ready \u2014 review it in Company Settings");
        };
        const onSetupCompleted = (data)=>{
            if (!isForSetupCompany(data)) return;
            setSetupSteps((prev)=>({
                    ...prev,
                    description: 'done',
                    adCalculation: 'done'
                }));
            // If the user is still on the setup checklist once everything finishes, take them
            // straight into the AI summary for review instead of making them look for a link.
            if (modalOpenRef.current === 'generatingDescription' && companyDescriptionRef.current) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'confirmDescription'
            }));
        };
        const onSetupError = (data)=>{
            if (!isForSetupCompany(data)) return;
            setSetupSteps((prev)=>({
                    ...prev,
                    [data['step']]: 'error'
                }));
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('companySetup:progress', onSetupProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('companySetup:descriptionReady', onDescriptionReady);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('companySetup:completed', onSetupCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('companySetup:error', onSetupError);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('companySetup:progress', onSetupProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('companySetup:descriptionReady', onDescriptionReady);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('companySetup:completed', onSetupCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('companySetup:error', onSetupError);
        };
    }, []);
    const buttonText = (0, $acw62.useMemo)(()=>{
        return counter > 0 ? `Resend in ${counter}s` : 'Resend Code';
    }, [
        counter
    ]);
    const handleToDashboard = (role)=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (user) role = user['role'];
        if (role) navigation(role.toLowerCase() === 'advisor' ? '/advisor-dashboard' : role.toLowerCase() === 'user' || role.toLowerCase() === 'member' ? '/dashboard' : '/investor-dashboard');
    };
    const isButtonDisabled = (0, $acw62.useMemo)(()=>{
        return counter > 0 || loading;
    }, [
        counter,
        loading
    ]);
    (0, $acw62.useEffect)(()=>{
        let timer;
        if (counter > 0) timer = setTimeout(()=>setCounter(counter - 1), 1000);
        return ()=>clearTimeout(timer);
    }, [
        counter
    ]);
    let tooltipRef = (0, $acw62.useRef)(tooltip);
    const redirectToInvestmentReadiness = async (companyId)=>{
        if (!companyId) companyId = new URLSearchParams(location?.search).get('companyId');
        // Show the loader immediately so there's no gap while we create the checklist
        setCreatingModule(partner?.['moduleName'] || 'Investment Readiness');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatePartnerPopup'
        }));
        // Fetch fresh company data to check if Investment Readiness module already exists (created in background)
        const companyRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getCompany/${companyId}`);
        const freshCompany = companyRes?.['body'];
        if (freshCompany?.['modules']?.['Investment Readiness']) {
            window.location.href = `/company/${freshCompany['_id']}#${partner['moduleName']}`;
            return;
        }
        if (user && partner?.['_id'] && Object.keys(freshCompany).length > 0) {
            let data = {
                partnerId: partner['_id'],
                category: 'partner',
                companies: {
                    [freshCompany['_id']]: freshCompany['cName']
                },
                memberPermissions: {
                    [user['_id']]: {
                        ...user,
                        company: {
                            [freshCompany['_id']]: freshCompany['cName']
                        }
                    }
                }
            };
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
            if (res?.['code'] == 200) return window.location.href = `/company/${freshCompany['_id']}#${partner['moduleName']}`;
        }
        // Failed to create — close the loader and let the user retry instead of hanging
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Could not create Investment Readiness. Please try again.');
    };
    const redirectToExitReadiness = async (companyId)=>{
        if (!companyId) companyId = new URLSearchParams(location?.search).get('companyId');
        // Show the loader immediately so there's no gap while we create the checklist
        setCreatingModule('Exit Readiness');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatePartnerPopup'
        }));
        const companyRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getCompany/${companyId}`);
        const freshCompany = companyRes?.['body'];
        if (freshCompany?.['modules']?.['Exit Readiness']) {
            window.location.href = `/company/${freshCompany['_id']}#Exit Readiness`;
            return;
        }
        const exitPartner = freshCompany?.['extraModules']?.find((m)=>m['moduleName'] === 'Exit Readiness');
        if (user && exitPartner?.['partnerId'] && Object.keys(freshCompany).length > 0) {
            let data = {
                partnerId: exitPartner['partnerId'],
                category: 'partner',
                companies: {
                    [freshCompany['_id']]: freshCompany['cName']
                },
                memberPermissions: {
                    [user['_id']]: {
                        ...user,
                        company: {
                            [freshCompany['_id']]: freshCompany['cName']
                        }
                    }
                }
            };
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
            if (res?.['code'] == 200) return window.location.href = `/company/${freshCompany['_id']}#Exit Readiness`;
        }
        // Failed to create — close the loader and let the user retry instead of hanging
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Could not create Exit Readiness. Please try again.');
    };
    const handleDisclaimer = async ()=>{
        let urlParams = new URLSearchParams(location?.search);
        let source = urlParams.get('source');
        if (user?.['type'] == 'Superflow' && user?.['partnerId'] && (source == 'externalApi' || source == 'climb26')) company?.['testType'] === 'exit' ? redirectToExitReadiness() : redirectToInvestmentReadiness();
        else if (user?.['type'] == 'Superflow' && user?.['partnerId']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addCompany'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'introVideo'
        }));
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/updateProfile`, {
                ...user,
                isAgreeWithDisclaimer: true
            });
            localStorage.setItem('isAgreeWithDisclaimer', true);
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)({
                ...user,
                isAgreeWithDisclaimer: true
            }));
        } catch (e) {
            console.error(e);
        }
    };
    const handleLogoutClose = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    function playVideo(e) {
        let video = document.getElementById("videoPaul");
        if (video.paused == true) {
            setIsPlay(true);
            video.play();
        }
        e.target.controls = true;
        if (e?.target?.nextElementSibling) e.target.nextElementSibling.remove();
    }
    let searchTimeout;
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            // Login with hash token
            if (location.pathname.includes('hashToken')) {
                const pathParts = location.pathname.split('/');
                const hashIndex = pathParts.indexOf('hashToken');
                const companyIndex = pathParts.indexOf('company');
                if (hashIndex !== -1 && companyIndex !== -1) {
                    const hash = pathParts[hashIndex + 1];
                    const companyId = pathParts[companyIndex + 1];
                    if (hash && companyId) {
                        (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(hash);
                        localStorage.setItem('token', hash);
                        const hashFragment = window.location.hash || '';
                        setTimeout(()=>navigation(`/company/${companyId}${hashFragment}`), 1000);
                    }
                }
            }
            // Grant investor access
            if (location.pathname.includes('investorToken')) {
                const hash = location.pathname.split('/').slice(-1)[0];
                let stringVersion = new $0868b271c9ad66ad$require$Buffer(hash, 'base64').toString();
                let data = stringVersion.split('&&&');
                let linkData = {
                    hash: data[1],
                    firmId: data[2],
                    firmName: data[3],
                    contactName: data[4],
                    userFirstName: data[5],
                    userLastName: data[6],
                    userEmail: data[7]
                };
                setAccessGrantedData({
                    investorName: linkData['firmName'],
                    contactName: linkData['contactName'],
                    userFirstName: linkData['userFirstName'],
                    userLastName: linkData['userLastName'],
                    userEmail: linkData['userEmail']
                });
                if (linkData['hash']) {
                    (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(linkData['hash']);
                    localStorage.setItem('token', linkData['hash']);
                    let res;
                    if (data[8] == 'Company') res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/companyAccess/${hash}`);
                    else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/investorAccess`, {
                        hash: hash
                    });
                    if (res && res['code'] == 200) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'accessGranted'
                    }));
                }
            }
            if (location.pathname.includes('advisorToken')) {
                const hash = location.pathname.split('/').slice(-1)[0];
                let stringVersion = new $0868b271c9ad66ad$require$Buffer(hash, 'base64').toString();
                let data = stringVersion.split('_');
                let linkData = {
                    companyOwnerId: data[1],
                    advisorId: data[2],
                    companyId: data[4],
                    userName: `${data[6]} ${data[7] ?? ""}`,
                    companyName: data[8]
                };
                setAdvisorAccessData(linkData);
                let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/advisorAccess/${hash}`, "return-response");
                console.log(res, "res");
                if (res && res['code'] == 200) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'advisorAccessGranted'
                }));
                else {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                    handleToDashboard(res['body']['role']);
                }
            }
            // Verify email addess
            if (location.pathname.includes('verifyEmail')) {
                const hash = location.pathname.split('/').slice(-1)[0];
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/verifyEmail/${hash}`);
                if (response && response['code'] == 200) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    loginWithToken(response.body);
                }
            }
            if (location.pathname.includes('newAdvisorCompany')) {
                // Logout if logged in
                if (0, $bebe1cbb5a309c8c$export$9e1725a4cfeada27) await (0, $bebe1cbb5a309c8c$export$5863150075eb9294)(false);
                const hash = location.pathname.split('/').slice(-1)[0];
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/access/${hash}`);
                if (response && response['code'] == 200) {
                    await setResNewAdvisor(response['body']);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'newAdvisorAdded'
                    }));
                }
            }
            if (location.pathname.includes('newInvestorCompany')) {
                // Logout if logged in
                if (0, $bebe1cbb5a309c8c$export$9e1725a4cfeada27) await (0, $bebe1cbb5a309c8c$export$5863150075eb9294)(false);
                const hash = location.pathname.split('/').slice(-1)[0];
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/access/${hash}`);
                if (response && response['code'] == 200) {
                    await setResNewAdvisor(response['body']);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'newInvestorCompany'
                    }));
                }
            }
            if (location.pathname.includes('verifyAdvisor')) {
                // Logout if logged in
                if (0, $bebe1cbb5a309c8c$export$9e1725a4cfeada27) (0, $bebe1cbb5a309c8c$export$5863150075eb9294)();
                const hash = location.pathname.split('/').slice(-1)[0];
                let stringVersion = new $0868b271c9ad66ad$require$Buffer(hash, 'base64').toString();
                let code = stringVersion.split('_')[2];
                if (code) window.location.href = `/reset_password/${code}`;
            }
        })();
        if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile' : 'client-profile');
        if (location.pathname.includes('newMember')) setTimeout(()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'newMember'
            })), 1000);
        // else if (location.pathname.includes('reset_password')) setTimeout(() => dispatch(toggleModal({ open: 'newPassword' })), 1000);
        const globalClickListeners = (e)=>{
            if (e.target.dataset.popup) console.log('********click-outside-hidePopup');
            else if (e.target.dataset.scrollTo) {
                const id = e.target.dataset.scrollTo;
                const el = document.getElementById(id);
                const isLoggedInPage = (0, $16250bd714b02a14$export$95d9d456783cd0b0).find((r)=>r.split('/').every((s, i)=>s === location.pathname.split('/')[i] || s[0] === ':'));
                if (el) {
                    const top = pageYOffset + el.getBoundingClientRect().top - (isLoggedInPage ? 0 : document.querySelector('header').offsetHeight) - 16;
                    scrollTo({
                        top: top,
                        behavior: 'smooth'
                    });
                }
            } else if (e.target.classList.contains('toggleHeight')) {
                const [textEl, el] = e.target.children;
                if (!el || !textEl) return;
                if (textEl.innerText.includes('Show') || textEl.innerText.includes('Hide')) {
                    const bg = window.getComputedStyle(textEl, null).getPropertyValue('background-color');
                    textEl.style.color = bg;
                    setTimeout(()=>{
                        if (textEl.innerText.includes('Show')) textEl.innerText = textEl.innerText.replace('Show', 'Hide');
                        else if (textEl.innerText.includes('Hide')) textEl.innerText = textEl.innerText.replace('Hide', 'Show');
                        textEl.style.color = '';
                    }, 250);
                }
                const height = el.scrollHeight;
                const ms = 250 + (height > 1500 ? 1500 : height) / 2;
                el.style.transitionDuration = ms + 'ms';
                if (el.style.height == '0px') {
                    el.style.height = height + 'px';
                    setTimeout(()=>{
                        el.style.transitionDuration = '';
                        el.style.height = '';
                    }, ms);
                } else {
                    el.style.height = height + 'px';
                    setTimeout(()=>el.style.height = '0px', 0);
                    setTimeout(()=>el.style.transitionDuration = '', ms);
                }
            }
        };
        //TODO: use framer motion to animate
        const globalMouseMoveListeners = (e)=>{
            if (tooltipRef.current && !e.target.dataset.tooltipId) {
                let tooltipId = tooltipRef.current.id.replace('tooltip-', '');
                const el = document.querySelector(`[data-tooltip-id='${tooltipId}']`);
                if (el) delete el.dataset.tooltipId;
                setTooltip(undefined);
            }
            if (e.target.dataset.tooltip && !e.target.dataset.tooltipId) {
                const tooltipId = Math.floor(Math.random() * 1000000);
                e.target.dataset.tooltipId = tooltipId;
                setTooltip({
                    id: 'tooltip-' + tooltipId,
                    y: e.clientY,
                    x: e.clientX,
                    html: e.target.dataset.tooltip
                });
            } else if (tooltipRef.current && e.target.dataset.tooltip && e.target.dataset.tooltipId) setTooltip({
                ...tooltipRef.current,
                y: e.clientY,
                x: e.clientX
            });
        };
        addEventListener('click', globalClickListeners);
        addEventListener('mousemove', globalMouseMoveListeners);
        return ()=>{
            removeEventListener('click', globalClickListeners);
            removeEventListener('mousemove', globalMouseMoveListeners);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        tooltipRef.current = tooltip;
        if (tooltip) {
            const tooltipEl = document.getElementById(tooltip.id);
            const newTooltip = {
                ...tooltip
            };
            let updateTooltip = false;
            if (tooltipEl?.offsetHeight + parseInt(tooltipEl?.style.top) > innerHeight) {
                newTooltip.y = innerHeight - tooltipEl?.offsetHeight;
                updateTooltip = true;
            }
            if (tooltipEl?.offsetWidth + parseInt(tooltipEl?.style.left) > innerWidth) {
                newTooltip.x = innerWidth - tooltipEl?.offsetWidth;
                updateTooltip = true;
            }
            if (updateTooltip) setTooltip(newTooltip);
        }
    }, [
        tooltip
    ]);
    (0, $acw62.useEffect)(()=>{
        setSmsEnabled(loginType.smsEnabled);
        setTwoFaEnabled(loginType.twoFaEnabled);
        setEmailEnabled(loginType.emailEnabled);
        setHash(loginType.hash);
    }, [
        loginType
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!hash) return;
        // Delay to ensure welcome email is delivered before login code email
        const delay = setTimeout(()=>{
            if (smsEnabled + twoFaEnabled + emailEnabled > 1) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'chooseAuthMethod'
            }));
            else if (smsEnabled) loginWithSMS();
            else if (twoFaEnabled) loginWithTwoFA();
            else if (emailEnabled) loginWithEmail();
        }, 1500);
        return ()=>clearTimeout(delay);
    }, [
        hash,
        smsEnabled,
        twoFaEnabled,
        emailEnabled
    ]);
    const searchCompanyTimeout = (e)=>{
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(()=>searchCompany(e.target.value), 1000);
    };
    const proceedCompany = async (company)=>{
        if (user?.['type'] == 'Superflow' && user?.['partnerId']) {
            // Partners flagged skipInvestorLead skip the InvestorMatch (investor-lead) step and go straight to their module.
            // redirectToInvestmentReadiness/redirectToExitReadiness create the partner checklist (awaited) and redirect, so we return early here.
            if (partner?.['skipInvestorLead'] && partner?.['moduleName']) return company?.['testType'] === 'exit' ? redirectToExitReadiness(company['_id']) : redirectToInvestmentReadiness(company['_id']);
            let data = {
                partnerId: user['partnerId'],
                category: 'partner',
                companies: {
                    [company['_id']]: company['cName']
                },
                memberPermissions: {
                    [user['_id']]: {
                        ...user,
                        company: {
                            [company['_id']]: company['cName']
                        }
                    }
                }
            };
            const res = (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
            if (res?.['code'] == 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        }
        const createInvestmentReadiness = user['_id'] && (user?.['emailVerified'] || user?.['role'] === 'Advisor' || user?.['role'] === 'Investor') && user?.['type'] != 'Superflow' && company?.['_id'] && company?.['cName'] && company?.['testType'] == 'investment';
        if (createInvestmentReadiness) {
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/KPMG`);
            if (res['code'] == 200 && res?.['body']?.['_id']) {
                let partnerId = res['body']['_id'];
                let data = {
                    partnerId: partnerId,
                    category: 'partner',
                    companies: {
                        [company['_id']]: company['cName']
                    },
                    memberPermissions: {
                        [user['_id']]: {
                            ...user,
                            company: {
                                [company['_id']]: company['cName']
                            }
                        }
                    }
                };
                // Not awaited — checklist question generation can take up to ~90s (AI + per-section DB writes).
                // Fire it in the background so the user isn't stuck on a frozen screen; it'll be ready next time they open the dashboard.
                (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
            }
        }
        const createExitReadiness = user['_id'] && (user?.['emailVerified'] || user?.['role'] === 'Advisor' || user?.['role'] === 'Investor') && user?.['type'] != 'Superflow' && company?.['_id'] && company?.['cName'] && company?.['testType'] == 'exit';
        if (createExitReadiness) {
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/ESFX`);
            if (res['code'] == 200 && res?.['body']?.['_id']) {
                let partnerId = res['body']['_id'];
                let data = {
                    partnerId: partnerId,
                    category: 'partner',
                    companies: {
                        [company['_id']]: company['cName']
                    },
                    memberPermissions: {
                        [user['_id']]: {
                            ...user,
                            company: {
                                [company['_id']]: company['cName']
                            }
                        }
                    }
                };
                // Not awaited — same reasoning as the Investment Readiness branch above.
                (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
            }
        }
        if (window.location.pathname.includes((0, $16250bd714b02a14$export$4695c1a423ffe431))) window.location.reload();
        else if (window.location.pathname.includes('advisor-dashboard') || window.location.pathname.includes('investor-dashboard')) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'checkAccessCompany'
        }));
        else if (window.location.pathname.includes('demoChecklist')) window.location.href = `/demoChecklist?companyId=${company['_id']}&cName=${company['cName']}`;
        else if (window.location.pathname.includes('partnerChecklist')) window.location.href = `${window.location.pathname}?companyId=${company['_id']}&cName=${company['cName']}`;
        else if (window.location.pathname.includes('superFlow') && user?.['type'] == 'Superflow') window.location.href = `/company/${company['_id']}#investor-lead`;
        else if (window.location.pathname.includes('manualAdd') && user?.['role'] == 'Investor') {
            localStorage.setItem('isManualAdd', true);
            window.location.href = `/company/${company['_id']}#investor-lead`;
        } else if (localStorage.getItem('testType')) window.location.href = (0, $16250bd714b02a14$export$240514314008da16).replace(':id', company['_id']) + '#two-minute-test-' + company['testType'];
        else window.location.href = (0, $16250bd714b02a14$export$3623221f872af69b).replace(':id', company['_id']);
    };
    const searchCompany = async (input)=>{
        if (!input) return;
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/search/${input}`);
        if (!response || response['code'] != 200) return;
        setCompanyOptions(response['body']['items'].slice(0, 5));
    };
    const login = async ()=>{
        const email = document.getElementById('loginEmail').value;
        const password = document.getElementById('loginPassword').value;
        if (email && password) {
            //TODO: add email validation
            setLoading(true);
            const postBody = {
                email: email,
                password: password
            };
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/auth', postBody);
            // TODO: if userId, code and authMethod aren't sent, server should send _id, smsEnabled, emailEnabled and twoFaEnabled
            if (response && response['code'] == 200) {
                if (response['body']['token']) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    loginWithToken(response['body']);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                } else if (response['body']['hash']) {
                    let data = response['body'];
                    setSmsEnabled(data.smsEnabled);
                    setTwoFaEnabled(data.twoFaEnabled);
                    setEmailEnabled(data.emailEnabled);
                    setHash(data.hash);
                }
                setLoading(false);
            } else setLoading(false);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Enter your email and password');
    };
    const resendCode = ()=>{
        if (authMethod === 'Email') loginWithEmail();
        else if (authMethod === 'Phone') loginWithSMS();
        setCounter(60);
    };
    const loginWithToken = async (data)=>{
        for (const key of [
            'token'
        ])//'role'
        document.cookie = `${key}=${data[key]};path=/`;
        (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(data['token']);
        localStorage.setItem('token', data['token']);
        if (loginType?.redirect && data['role']) {
            setTimeout(()=>window.location.replace(`/${loginType?.redirect}`), 100);
            return;
        }
        if (data['role'] !== 'Admin' && isBilling) window.location.href = (0, $16250bd714b02a14$export$3623221f872af69b).replace(':id', data?._id);
        if (data['type'] == 'Superflow' && data['partnerId']) {
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/my-profile`);
            if (res['code'] == 200) {
                let { companies: companies } = res['body'];
                if (companies.length > 0) navigation((0, $16250bd714b02a14$export$4695c1a423ffe431));
                else window.location.href = `/superFlow/${data['partnerId']}`;
            }
        } else if (data['role'] == 'Advisor') navigation((0, $16250bd714b02a14$export$fa573b5b2799a94a));
        else if (data['role'] == 'Admin') setTimeout(()=>navigation('/admin'), 100);
        else if (data['role'] == 'Investor') setTimeout(()=>navigation((0, $16250bd714b02a14$export$c45d6aa39a7ae97c)), 100);
        else setTimeout(()=>navigation((0, $16250bd714b02a14$export$4695c1a423ffe431)), 100);
    };
    const loginWithEmail = async ()=>{
        setLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/user/loginEmail/' + hash);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message);
        if (response['code'] != 200) return setLoading(false);
        setAuthMethod('Email');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'enterCode'
        }));
        setLoading(false);
    };
    const loginWithSMS = async ()=>{
        setLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/loginSms/${hash}`);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message);
        if (response['code'] != 200) return setLoading(false);
        setAuthMethod('Phone');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'enterCode'
        }));
        setLoading(false);
    };
    const loginWithTwoFA = ()=>{
        setLoginFor("google");
        setAuthMethod('App');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'enterCode'
        }));
    };
    const codeEntered = async (e)=>{
        try {
            const authKey = e.target.value;
            if (authKey.length < 6) return;
            setLoading(true);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/verifyAuthLogin/${hash}`, {
                authKey: authKey,
                authMethod: authMethod
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            if (response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                setTimeout(()=>loginWithToken(response['body']), 500);
            } else e.target.value = '';
        } catch (err) {
            console.log(err);
        } finally{
            setLoading(false);
        }
    };
    const register = async ()=>{
        const firstName = document.getElementById('registerFirstName').value;
        const lastName = document.getElementById('registerLastName').value;
        const email = document.getElementById('registerEmail').value;
        const password = document.getElementById('registerPassword').value;
        const agree = document.getElementById('registerTerms').checked;
        if (firstName && lastName && email && password) {
            if (!agree) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please accept the terms & conditions');
            setLoading(true);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user', {
                firstName: firstName,
                lastName: lastName,
                email: email,
                password: password
            });
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'registerVerification'
                }));
                setLoading(false);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            } else setLoading(false);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out all fields');
    };
    const confirmAdvisorCompany = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/checkExistingCompany`, {
            ukRegNo: selectedCompany['company_number']
        });
        if (response['code'] == 200) {
            if (Object.keys(response['body']).length > 0) {
                if (![
                    'client',
                    'advisor'
                ].includes(response['body']?.['cCategory'])) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    setExistingInvestor(response['body']);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'existingInvestor'
                    }));
                } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`This is ${response['body']?.['cCategory']} company. You can't add it.`);
            } else {
                setStepNo('Step3');
                setFormData({
                    ...formData,
                    cType: selectedCompany['type'],
                    firmName: selectedCompany['title'],
                    ukRegNo: selectedCompany['company_number'],
                    firmAddress: selectedCompany['address_snippet'],
                    doIncorporation: selectedCompany['date_of_creation']
                });
            }
        }
    };
    const requestInvestorAccess = async ()=>{
        let data = {
            firmId: existingInvestor['_id'],
            firmName: existingInvestor['cName'],
            contactId: existingInvestor['contactId'],
            contactName: existingInvestor['contactName'],
            contactEmail: existingInvestor['contactEmail'],
            userFirstName: formData['firstName'],
            userLastName: formData['lastName'],
            userEmail: formData['email']
        };
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/requestInvestorAccess`, data);
        if (response['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            setStepNo('Step1');
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        }
    };
    const handlePhoneChange = (value)=>setFormData({
            ...formData,
            phone: value
        });
    const handleChange = (event)=>{
        if (modal['open'] == 'registerInvestor') setFormData((prev)=>({
                ...prev,
                role: 'Investor'
            }));
        const { name: name, value: value } = event.target;
        setFormData((prevFormData)=>({
                ...prevFormData,
                [name]: value
            }));
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e)=>{
        e.preventDefault();
        const logo = e.dataTransfer.files[0];
        let maxSizeInBytes = 5242880;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement('img');
            img.src = logoUrl;
            img.onload = ()=>{
                // if (img.width > 160 || img.height > 160) {
                // 	showMessage('Image Dimensions Required (160 x 160)');
                // 	setFormData(prevFormData => ({ ...prevFormData, firmLogo: '' }));
                // 	return;
                // } else
                if (logo.size > maxSizeInBytes) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`File size must be less than 1MB`);
                else setFormData((prevFormData)=>({
                        ...prevFormData,
                        firmLogo: logoUrl
                    }));
            };
        }
    };
    const handleRegister = async ()=>{
        if (formData['firmName'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out Firm Name');
        else if (formData['firmAddress'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out the Firm Address');
        else if (formData['designation'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out your designation');
        else if (formData['phone'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out phone Number');
        else if (formData['website'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out the website');
        else if (!(0, (/*@__PURE__*/$parcel$interopDefault($bad1c3ae594eb6ef$exports))).isURL(formData['website'])) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter valid webiste URL');
        else {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/advisor', {
                attachment: attachment,
                ...formData
            }, false);
            if (response && response['code'] == 200) {
                await setCompany(response['body']);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                if (response['body']['companyDescription']) {
                    setIsDescriptionLogin(true);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'confirmDescription'
                    }));
                }
                setStepNo('Step1');
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                setFormData({
                    role: 'Advisor',
                    firstName: '',
                    lastName: '',
                    email: '',
                    password: '',
                    designation: '',
                    phone: '',
                    firmName: '',
                    firmAddress: '',
                    website: '',
                    firmLogo: ''
                });
            }
        }
    };
    const handleImageChange = async (event)=>{
        let logo = event.target.files[0];
        if (event.target.files) {
            const newAttachment = [];
            for (const file of event.target.files)newAttachment.push(file);
            setAttachment(newAttachment);
        }
        // let attachment = [];
        let maxSizeInBytes = 5242880;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement('img');
            img.src = logoUrl;
            img.onload = ()=>{
                if (logo.size > maxSizeInBytes) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`File size must be less than 5Mb`);
                else setFormData((prevFormData)=>({
                        ...prevFormData,
                        firmLogo: logoUrl
                    }));
            };
        }
    };
    const closePopup = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setFormData({
            role: 'Advisor',
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            designation: '',
            phone: '',
            firmName: '',
            firmAddress: '',
            website: '',
            firmLogo: ''
        });
        setStepNo('Step1');
    };
    const forgotPassword = async ()=>{
        const email = document.getElementById('forgotPasswordEmail').value;
        if (!email) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Enter your email');
            return;
        }
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/forgotPassword', {
            email: email
        });
        if (response && response['code'] == 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
    };
    const setMemberPassword = async ()=>{
        const password = document.getElementById('newMemberPassword').value;
        if (!location.pathname.includes('newMember')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Invalid request try link from email');
            return;
        }
        if ($0868b271c9ad66ad$var$passwordPattern.test(password) == false) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)($0868b271c9ad66ad$var$INVALID_PASSWORD_MSG);
            return;
        }
        let params = location.pathname.split('/');
        let hash = params[params.length - 1];
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/newMemberPwd`, {
            hash: hash,
            password: password
        });
        if (response && response['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            window.location.href = `/login`;
        }
    };
    const verifyWebsite = async ()=>{
        try {
            let companyWebsite = document.querySelector(`#companyWebsite`).value;
            if (!companyWebsite) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide website link');
            if (!isURL(companyWebsite)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Invalid company url');
            if (companyWebsite.indexOf('http') < 0) companyWebsite = `http://${companyWebsite}`;
            openWindow(companyWebsite);
            setWebsiteStatus('Confirm');
        } catch (e) {
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e);
        }
    };
    function isURL(str) {
        var pattern = new RegExp("^((ft|htt)ps?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%@_.~+&:]*)*(\\?[;&a-z\\d%@_.,~+&:=-]*)?(\\#[-a-z\\d_]*)?$", 'i'); // fragment locator
        return pattern.test(str);
    }
    const openWindow = (url)=>{
        if (window.innerWidth <= 640) // var a = document.createElement('a');
        // a.setAttribute('href', url);
        // a.setAttribute('target', '_blank');
        // var dispatch = document.createEvent('HTMLEvents');
        // dispatch.initEvent('click', true, true);
        // a.dispatchEvent(dispatch);
        window.open(url, '_blank');
        else {
            var width = window.innerWidth * 0.8;
            var height = width * window.innerHeight / window.innerWidth;
            window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + (window.innerHeight - height) / 2 + ', left=' + (window.innerWidth - width) / 2);
        }
        return false;
    };
    const updateDescription = async ()=>{
        const companyDescription = document.getElementById('companyDescription').value;
        if (!companyDescription) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please input update description');
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/description/${company['_id']}`, {
            companyDescription: companyDescription
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        if (response?.['code'] != 200) return;
        company['companyDescription'] = companyDescription;
        setCompany(company);
        setEditDescription(false);
    };
    const intercom = ()=>{
        window.intercomSettings = {
            app_id: 'qp54mmn4',
            api_base: 'https://api-iam.intercom.io',
            user_id: user['_id'] ? user['_id'] : null,
            name: user['firstName'] ? user['firstName'] + ' ' + user['lastName'] : null,
            email: user['email'] ? user['email'] : null,
            phone: user['phone'] ? user['phone'] : null,
            created_at: user['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(user['createdAt']).format('X') : null
        };
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        } else {
            var d = document;
            var i = ()=>i.c(arguments);
            i.q = [];
            i.c = (args)=>i.q.push(args);
            w.Intercom = i;
            var l = ()=>{
                var s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/qp54mmn4';
                var x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === 'complete') l();
            else if (w.attachEvent) w.attachEvent('onload', l);
            else w.addEventListener('load', l, false);
        }
    };
    const ADVISOR_FORM_CHECK = [
        'firstName',
        'lastName',
        'email',
        'password'
    ];
    const validateForm = (nextState)=>{
        let isError = false;
        const data = ADVISOR_FORM_CHECK?.map((field, i, arr)=>{
            if (formData?.[field] !== '') {
                if (field === 'password' && $0868b271c9ad66ad$var$passwordPattern.test(formData?.[field]) === false) {
                    isError = true;
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)($0868b271c9ad66ad$var$INVALID_PASSWORD_MSG);
                    return true;
                } else return false;
            }
            return true;
        });
        if (!isError) {
            if (data.includes(true)) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill all fields');
            else setStepNo(nextState);
        }
    };
    const closeDisclaimerModal = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const closeAddCompany = ()=>{
        setStep(1);
        setExistingCompany('');
        setWebsiteStatus('Check');
        setCompanyOptions([]);
        setSelectedCompany({});
        setConfirmedCompany();
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const handleNotYourCompany = async ()=>{
        let requestBody = {
            companyNumber: confirmedCompany['company_number']
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteGuestAddCompany`, requestBody);
        setStep(1);
        setCompanyOptions([]);
        setSelectedCompany({});
        setConfirmedCompany();
        await localStorage.removeItem('isDemoChecklist');
        await localStorage.removeItem('isPartnerChecklist');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addCompany'
        }));
        if (res && res['code'] == 200) {
            setPreviousCompanyDeleted(true);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        } else setPreviousCompanyDeleted(false);
    };
    const handleChildCompany = async (el)=>{
        if (!companiesGroup[el['companyId']]) companiesGroup[el['companyId']] = {
            companyId: el['companyId']
        };
        if (el['selected']) companiesGroup[el['companyId']]['selected'] = el['selected'];
        if (el['group']) {
            document.getElementById(`group-${el['companyId']}`).value = el['group'];
            companiesGroup[el['companyId']]['group'] = el['group'];
        }
        if (el['percentage']) {
            document.getElementById(`percentage-${el['companyId']}`).value = el['percentage'];
            companiesGroup[el['companyId']]['percentage'] = el['percentage'];
        }
        if (el['event']?.['target']?.['checked'] == false) delete companiesGroup[el['companyId']];
        setCompaniesGroup(companiesGroup);
    };
    const handleCreateGroup = async ()=>{
        let isValid = true;
        Object.keys(companiesGroup).map((key)=>{
            if (companiesGroup?.[key].percentage <= 100 && companiesGroup?.[key].percentage >= 0 && /^[a-zA-Z0-9\s]*$/.test(companiesGroup?.[key].percentage)) ;
            else isValid = false;
        });
        if (isValid) {
            companiesGroup[parentCompany['_id']] = {
                companyId: parentCompany['_id'],
                group: 'Parent',
                selected: 'true'
            };
            let data = await Object.values(companiesGroup).filter((company)=>{
                if (!company['group']) company['group'] = 'Subsidiary';
                if (!company['percentage']) company['percentage'] = '0';
                if (company['selected'] == 'true') return company;
            });
            if (data && data.length > 1) {
                const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/addGroup`, {
                    companiesGroup: data
                });
                if (res || res['code'] == 200) setTimeout(()=>window.location.reload(), 500);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please select a company for group");
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please enter valid percentage ");
    };
    // Edit Group Handler Functions
    const handleEditChildCompany = async (el)=>{
        if (!editCompaniesGroup[el['companyId']]) editCompaniesGroup[el['companyId']] = {
            companyId: el['companyId']
        };
        if (el['selected']) editCompaniesGroup[el['companyId']]['selected'] = el['selected'];
        if (el['group']) {
            const groupEl = document.getElementById(`group-${el['companyId']}`);
            if (groupEl) groupEl.value = el['group'];
            editCompaniesGroup[el['companyId']]['group'] = el['group'];
        }
        if (el['percentage']) {
            const percentEl = document.getElementById(`percentage-${el['companyId']}`);
            if (percentEl) percentEl.value = el['percentage'];
            editCompaniesGroup[el['companyId']]['percentage'] = el['percentage'];
        }
        if (el['event']?.['target']?.['checked'] === false) delete editCompaniesGroup[el['companyId']];
        setEditCompaniesGroup({
            ...editCompaniesGroup
        });
    };
    const updateGroupCompany = async (type)=>{
        let isValid = true;
        Object.keys(editCompaniesGroup).forEach((key)=>{
            const percent = editCompaniesGroup?.[key]?.percentage;
            if (percent && (percent > 100 || percent < 0 || !/^[0-9]*$/.test(percent))) isValid = false;
        });
        if (!isValid) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please enter valid percentage (0-100)");
            return;
        }
        let childUpdates = Object.values(editCompaniesGroup).filter((company)=>{
            if (type === "Delete") company['group'] = 'Standard';
            if (!company['group'] && type === "Add") company['group'] = 'Subsidiary';
            if (!company['percentage'] && type === "Add") company['percentage'] = '0';
            if (company['selected'] === 'true') return company;
        });
        let data = {
            parentId: editParentCompany['_id'],
            childUpdates: childUpdates,
            type: type
        };
        if (data && childUpdates.length > 0) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateChild`, {
                data: data,
                companyId: editParentCompany['_id']
            });
            if (res && res['code'] == 200) {
                setEditCompaniesGroup({});
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                setTimeout(()=>window.location.reload(), 500);
            }
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please select at least one company");
    };
    const handleBugAttachmentFile = (e)=>{
        if (e.target.files) {
            const newAttachment = Array.from(e.target.files);
            setAttachments((prev)=>[
                    ...prev,
                    ...newAttachment
                ]);
        }
    };
    const onDragOverBug = (e)=>e.preventDefault();
    const onDropBug = (e)=>{
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files && files.length) {
            const event = {
                target: {
                    files: files
                }
            };
            handleBugAttachmentFile(event);
        }
    };
    const hideBugPopup = ()=>{
        setBugDescription("");
        setAttachment([]);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
    };
    const deleteBugAttachment = async (targetFile)=>{
        let updateAttachments = await attachment.filter((file)=>file.name !== targetFile.name);
        setAttachment(updateAttachments);
    };
    const handleSetPassword = async ()=>{
        if (setPasswordFields['newPassword'] == '' || setPasswordFields['confirmPassword'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter both passwords!');
        if (setPasswordFields['newPassword'] != setPasswordFields['confirmPassword']) return setSetPasswordError('Passwords don\'t match!');
        if (!SET_PASSWORD_PATTERN.test(setPasswordFields['newPassword'])) {
            setSetPasswordError('Password must contain at least one capital letter, one special character and a number');
            return;
        }
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/setPassword', {
            key: user['email'],
            password: setPasswordFields['newPassword']
        });
        if (res && res['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Password set successfully');
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            setSetPasswordFields({
                newPassword: '',
                newPasswordType: true,
                confirmPassword: '',
                confirmPasswordType: true
            });
            setSetPasswordError('');
            if (window.location.pathname.includes('investor-dashboard')) window.location.hash = '#index?QualifiedLeads';
            else if (window.location.pathname.includes('/company/')) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                gotoInvestorMatch: true
            }));
        }
    };
    const handleSubmitBug = async ()=>{
        if (!bugDescription) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please add bug description!");
        const wordCount = bugDescription?.split(/\s+/).length;
        if (wordCount < 5) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please elaborate bug in minimum five words");
        let data;
        if (attachment) data = {
            attachment: attachment,
            bugDescription: bugDescription
        };
        else data = {
            bugDescription: bugDescription
        };
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/reportBug", data);
        hideBugPopup();
        if (res || res["code"] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        }
    };
    const loggedInPopups = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c3ef04e6d3070d8$export$2e2bcd8739ae039), {
                modalType: "resendForgotPasswordEmail",
                modalData: modal.historyData
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3152f26bbd79cc69$export$2e2bcd8739ae039), {
                modalType: "passwordUpdatedSuccessfully",
                userData: user,
                modalData: modal.historyData
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "newMemberPopUp",
                open: modal['open'] == 'newMember',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `mah70 oya bg1 shadow w100 bsbb df fdc m1rem maw700px br20px p2rem hideScrollbar`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "fs1-5rem w100 lh1 c15 fw500 tac my2rem",
                                    children: "Set New Password"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fdc jcc aic py1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcc w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: "newMemberPassword",
                                                    type: passwordType ? 'text' : 'password',
                                                    placeholder: "New Password",
                                                    className: "w80 shadow bg5 br5px p1rem"
                                                }),
                                                passwordType ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    className: "pr cp",
                                                    onClick: ()=>setPasswordType(false),
                                                    width: "27",
                                                    height: "21",
                                                    viewBox: "0 0 27 21",
                                                    fill: "none",
                                                    xmlns: "http:www.w3.org/2000/svg",
                                                    style: {
                                                        top: '25px',
                                                        transform: 'translateY(-50%)',
                                                        right: "35px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                                        fill: "#404040"
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "pr cp",
                                                    onClick: ()=>setPasswordType(true),
                                                    width: "27",
                                                    height: "21",
                                                    viewBox: "0 0 27 21",
                                                    fill: "none",
                                                    xmlns: "http:www.w3.org/2000/svg",
                                                    style: {
                                                        top: '25px',
                                                        transform: 'translateY(-50%)',
                                                        right: "35px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                                            fill: "#404040"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                                            fill: "#404040"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>setMemberPassword(),
                                            className: "new-shadow w50 br50px py0-75rem cp px2rem fw400 tac bg4 c1 my2rem",
                                            children: "Confirm"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '25%'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "confirmLogout",
                onCloseHandler: handleLogoutClose,
                modalCardClasses: "maw500",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "c15 fs2rem tac lh1 fw600 mb2rem",
                        children: "Confirmation"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "logoutConfirmModal",
                        children: "Are you sure you want to logout ?"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc gg1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                type: "button",
                                onClick: handleLogoutClose,
                                text: "Cancel",
                                btnType: "default",
                                textClassName: "c1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                type: "button",
                                btnType: "warning",
                                onClick: ()=>(0, $bebe1cbb5a309c8c$export$5863150075eb9294)(),
                                text: "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const popups = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'mobileDevicesPopup',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px2rem py3rem bsbb df fdc aic m1rem maw800px pr pt5rem br20px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "tac mb0-5rem c15 mb1rem",
                            children: "Sorry, you can\u2019t use Diligentsia from a mobile"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac c12",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb1rem c15 fs1rem px1rem op70",
                                children: "Diligentsia works with your diligence files and therefore is designed to only work on your desktop or laptop computer."
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            to: $16250bd714b02a14$export$a7c5707626fc90f,
                            className: `w200px df jcc aic fw500 px1rem py0-5rem c1 bg4 br19px cp`,
                            children: "Home"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "alertBuyNowPopUp",
                open: modal['open'] === 'alertLoginPopUp',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    style: {
                        outline: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "py0-5rem h2rem",
                                src: (parcelRequire("aR1CT")),
                                alt: "web-logo"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "logoutConfirmModal",
                            children: "To purchase a pack, please log in or register. Your account allows you to manage your purchases and access exclusive content. Thank you for choosing our service."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df gg1rem w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: $16250bd714b02a14$export$eed606b4351295d7,
                                    style: {
                                        height: '50px'
                                    },
                                    onClick: ()=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                        setIsBilling(true);
                                    },
                                    className: "bsbb jcc w60 df aic fw500 py0-5rem px1rem c1 bg3 br19px my1rem my0-xl cp mr1-5rem-xl",
                                    children: "Login"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    onClick: ()=>{
                                        localStorage.removeItem('registerAs'), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                    },
                                    className: "bsbb jcc w40 df fdc aic fw500  px1rem c1 bg4 br19px cp registerButtonAnimation",
                                    style: {
                                        height: '50px',
                                        width: '70%',
                                        paddingTop: '3px',
                                        paddingBottom: '3px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Register for FREE"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw400 c21 df fdc",
                                            style: {
                                                marginTop: '-2px',
                                                fontSize: '10px',
                                                lineHeight: '15px',
                                                fontStyle: 'italic'
                                            },
                                            children: "No credit card required"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc mt1-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    height: '50px'
                                },
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                className: "w40 br19px shadow td250 br5px p1rem fw600 cp ttu w50 bsbb tac mb1rem df jcc aic",
                                children: "Cancel"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'login',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 mb2rem",
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "loginEmail",
                                            type: "email",
                                            placeholder: "Email",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                    className: "fa-secondary"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                    className: "fa-primary"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "loginPassword",
                                            type: "password",
                                            placeholder: "Password",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 448 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M64 223.1h320c35.35 0 64 28.65 64 64v160c0 35.34-28.65 64-64 64H64c-35.35 0-64-28.66-64-64v-160C0 252.7 28.65 223.1 64 223.1z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M368 144V224h-64V144C304 99.88 268.1 64 224 64S144 99.88 144 144V224h-64V144c0-79.41 64.59-144 144-144S368 64.59 368 144z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    onClick: ()=>{
                                        if (!loading) login();
                                    },
                                    className: `shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic ${loading && 'button-disabled'}`,
                                    children: [
                                        "Login",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen ml0-5rem h1rem f1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M342.6 278.6l-128 128c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25L242.8 288H32C14.31 288 0 273.7 0 256s14.31-32 32-32h210.8L169.4 150.6c-12.5-12.5-12.5-32.75 0-45.25c12.49-12.49 32.74-12.51 45.25 0l128 128C355.1 245.9 355.1 266.1 342.6 278.6z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M416 32h-64c-17.67 0-32 14.33-32 32s14.33 32 32 32h64c17.67 0 32 14.33 32 32v256c0 17.67-14.33 32-32 32h-64c-17.67 0-32 14.33-32 32s14.33 32 32 32h64c53.02 0 96-42.98 96-96V128C512 74.98 469 32 416 32z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb fdc fdr-md aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3-hover my0-5rem td250 fs1-25rem cp",
                                            "data-scroll-to": "RegisterSection",
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            children: "Create New Account"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'forgotPassword'
                                                })),
                                            className: "c4-hover my0-5rem td250 fs1-25rem cp",
                                            children: "Forgotten password?"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'forgotPassword',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "Forgot Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "forgotPasswordEmail",
                                            type: "email",
                                            placeholder: "Email",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                    className: "fa-secondary"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                    className: "fa-primary"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    onClick: ()=>forgotPassword(),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                                    children: [
                                        "Reset Password",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen ml0-5rem h1rem f1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M336 0c-97.2 0-176 78.8-176 176c0 14.71 2.004 28.93 5.406 42.59l128 127.1C307.1 349.1 321.3 351.1 336 351.1c97.2 0 176-78.8 176-176S433.2 0 336 0zM376 176c-22.09 0-40-17.91-40-40S353.9 96 376 96S416 113.9 416 136S398.1 176 376 176z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M165.4 218.6l-156 156C3.371 380.6 0 388.8 0 397.3V496C0 504.8 7.164 512 16 512l96 0c8.836 0 16-7.164 16-16v-48h48c8.836 0 16-7.164 16-16v-48h57.37c4.242 0 8.312-1.688 11.31-4.688l32.72-32.72L165.4 218.6z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'login'
                                        })),
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Back to Login"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'register',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600",
                            children: "Register"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb0-5rem",
                            children: "Please register using your company email"
                        }),
                        user?.['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb2rem",
                            children: "To store your reports \u2013 no credit card"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "registerFirstName",
                                            type: "text",
                                            placeholder: "First Name",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 640 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                className: "fa-secondary"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "registerLastName",
                                            type: "text",
                                            placeholder: "Last Name",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 640 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                className: "fa-secondary"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "registerEmail",
                                            type: "email",
                                            placeholder: "Email \u2013 please use your company email address",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                    className: "fa-secondary"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                    className: "fa-primary"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "registerPassword",
                                            type: "password",
                                            placeholder: "Password",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 448 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M64 223.1h320c35.35 0 64 28.65 64 64v160c0 35.34-28.65 64-64 64H64c-35.35 0-64-28.66-64-64v-160C0 252.7 28.65 223.1 64 223.1z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M368 144V224h-64V144C304 99.88 268.1 64 224 64S144 99.88 144 144V224h-64V144c0-79.41 64.59-144 144-144S368 64.59 368 144z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "registerTerms",
                                    className: "py0-5rem df cp",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "checkbox w2rem h2rem pr",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "registerTerms",
                                                className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                type: "checkbox"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "w100 fs1rem lh3 ml1rem usn",
                                            children: [
                                                "I agree to the \xa0",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    className: "c3 c4-hover td250",
                                                    href: "/terms-conditions",
                                                    target: "_blank",
                                                    children: " terms and conditions \xa0 "
                                                }),
                                                " and \xa0",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    className: "c3 c4-hover td250",
                                                    href: "/policy",
                                                    target: "_blank",
                                                    children: " policies "
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    onClick: ()=>{
                                        if (!loading) register();
                                    },
                                    className: `shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic  ${loading && 'button-disabled'}`,
                                    children: [
                                        "Register",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen ml0-5rem h1rem f1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 640 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M616 200h-48v-48C568 138.8 557.3 128 544 128s-24 10.75-24 24v48h-48C458.8 200 448 210.8 448 224s10.75 24 24 24h48v48C520 309.3 530.8 320 544 320s24-10.75 24-24v-48h48C629.3 248 640 237.3 640 224S629.3 200 616 200z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'login'
                                        })),
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Already have an account? Login"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'registerVerification',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 p3rem shadow w100 bsbb df fdc maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-75rem ttu w100 tac mb1rem",
                            children: "Email Verification"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc fs1rem mb1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Security and protection of your data is is important to us. To assist in this we use 2-factor authentication. You will be required verification on every login. By clicking Next, you will be taken to your login screen where you will be asked to login. Later you can add alternative/additional methods of 2FA in your User Profile \u2013 SMS and/or your authenticator app."
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc fdc fdr-md aic fs1rem px1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "shadow my0-5rem bg3 bg4-hover c1 td250 br5px p0-5rem fw600 cp ttu w40 bsbb tac",
                                to: $16250bd714b02a14$export$eed606b4351295d7,
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: "Next"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'registerAdvisor' || modal['open'] == 'registerInvestor',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr oya",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>closePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac w100 mb0-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "investorHeading",
                                        children: [
                                            "Free ",
                                            modal['open'] == 'registerAdvisor' ? 'Advisor ' : 'Investor ',
                                            " Registration"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "cardText",
                                        children: "(No credit card required)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "mb0-5rem",
                            children: [
                                modal['open'] == 'registerAdvisor' ? 'Please register as Advisor using your professional email' : modal['open'] == 'registerInvestor' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: "Please provide your main fund/company name as registered at UK Companies House"
                                }) : '',
                                ' '
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem",
                            children: stepNo == 'Step1' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "firstName",
                                                name: "firstName",
                                                type: "text",
                                                value: formData.firstName,
                                                onChange: handleChange,
                                                placeholder: "First Name",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "lastName",
                                                name: "lastName",
                                                type: "text",
                                                value: formData.lastName,
                                                onChange: handleChange,
                                                placeholder: "Last Name",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "email",
                                                name: "email",
                                                type: "email",
                                                value: formData.email,
                                                onChange: handleChange,
                                                placeholder: "Email",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "password",
                                                name: "password",
                                                type: "password",
                                                value: formData.password,
                                                onChange: handleChange,
                                                placeholder: "Password",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 448 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H184L133.3 308.8zM314.7 308.8L264 512h149.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M176 288l32 56l-31.99 135.1L184 512h80l7.988-32.05L240 344l32-56H176zM224 0C153.3 0 96 57.25 96 128s57.25 128 128 128s128-57.25 128-128S294.8 0 224 0z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: (Step2)=>validateForm('Step2'),
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt2rem",
                                            children: "Next"
                                        })
                                    })
                                ]
                            }) : stepNo == 'Step2' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "searchCompany",
                                                name: "firmName",
                                                value: formData['firmName'],
                                                onChange: handleChange,
                                                onKeyUp: searchCompanyTimeout,
                                                type: "text",
                                                placeholder: "Search your Firm Name/Number",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-288C0 117.5 21.5 96 48 96h416C490.5 96 512 117.5 512 144z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M176 96H128V48C128 21.5 149.5 0 176 0h160C362.5 0 384 21.5 384 48V96h-48V48h-160V96z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    selectedCompany && selectedCompany['title'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "c4 fs1-5rem ttu w100 tac",
                                                        children: "Company Info"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Status:"
                                                            }),
                                                            ' ',
                                                            selectedCompany['company_status'].toUpperCase(),
                                                            ' '
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Number:"
                                                            }),
                                                            ' ',
                                                            selectedCompany['company_number'],
                                                            ' '
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Title:"
                                                            }),
                                                            " ",
                                                            selectedCompany['title'],
                                                            ' '
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Date of Creation:"
                                                            }),
                                                            ' ',
                                                            selectedCompany['date_of_creation'],
                                                            ' '
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Description:"
                                                            }),
                                                            ' ',
                                                            selectedCompany['description'],
                                                            ' '
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Address:"
                                                            }),
                                                            ' ',
                                                            selectedCompany['address_snippet'],
                                                            ' '
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                onClick: ()=>{
                                                    confirmAdvisorCompany();
                                                },
                                                className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                                children: "Confirm & Next"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                onClick: ()=>setSelectedCompany({}),
                                                className: "c3 c4-hover td250 fs1-25rem cp",
                                                children: "Back"
                                            })
                                        ]
                                    }) : companyOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            companyOptions.map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    onClick: ()=>setSelectedCompany(option),
                                                    className: "cp df fww jcfs aic bg5 py0-5rem px1rem shadow br5px",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600 mr1rem",
                                                            children: option['title']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mr1rem",
                                                            children: option['company_number']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "ttu fw600",
                                                            children: option['company_status']
                                                        })
                                                    ]
                                                }, `${idx}-random-new-${new Date().getTime()}`)),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcse",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    onClick: ()=>setStepNo('Step1'),
                                                    className: "c3 c4-hover td250 fs1-25rem cp",
                                                    children: "Back"
                                                })
                                            })
                                        ]
                                    }) : null
                                ]
                            }) : stepNo == 'Step3' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "firmName",
                                                name: "firmName",
                                                value: formData['firmName'],
                                                type: "text",
                                                onChange: handleChange,
                                                placeholder: "Firm Name",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                viewBox: "0 0 1024 1024",
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M564.2 138.8c0.1-10.3-10.5-17.4-20.6-13.9L212.7 243.6c-6 2.1-10 7.7-10 13.9v572.6h361.5V138.8zM359.8 716.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m135.8 357c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-87.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3V272zM838.2 338.3c0.1-5.5-3-10.5-7.9-13.1L613.4 211.6c-10.2-5.4-22.6 1.9-22.6 13.1v605.5h247.4V338.3z m-83.6 378c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z",
                                                        fill: "#66AFFF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M876 900.8H147.2c-8.4 0-15.2-8-15.2-17.7v-35.3c0-9.7 6.8-17.7 15.2-17.7H876c8.4 0 15.2 8 15.2 17.7v35.3c0 9.8-6.8 17.7-15.2 17.7z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "firmAddress",
                                                name: "firmAddress",
                                                value: formData['firmAddress'],
                                                type: "text",
                                                onChange: handleChange,
                                                placeholder: "Firm Address",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                viewBox: "0 0 256 256",
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                className: "fa-secondary",
                                                                d: "M42.1,122.7h37.7v8.9H42.1V122.7L42.1,122.7z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                className: "fa-primary",
                                                                d: "M42.1,147h37.7v8.9H42.1V147L42.1,147z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M42.1,172h37.7v8.9H42.1V172L42.1,172z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M42.1,197.1h37.7v8.9H42.1V197.1L42.1,197.1z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M107.1,74.6h60.3v8.9h-60.3V74.6z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M107.1,103.7h32.6v8.9h-32.6V103.7z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M107.1,132.8h18.7v8.9h-18.7V132.8z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M200.1,145.3c0-9.3-7.6-17-17-17s-16.9,7.6-16.9,17c0,9.3,7.6,17,16.9,17C192.5,162.2,200.1,154.6,200.1,145.3z M183.1,153.4c-4.5,0-8.1-3.6-8.1-8.1c0-4.5,3.6-8.1,8.1-8.1c4.5,0,8.1,3.6,8.1,8.1C191.3,149.7,187.6,153.4,183.1,153.4z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M190,223c4.2-5.3,11.6-15,18.9-25.9c15.1-22.6,22.8-39.7,22.8-50.7c0-26.8-21.8-48.6-48.6-48.6s-48.6,21.8-48.6,48.6c0,11,7.7,28.1,22.8,50.7c7.3,10.9,14.7,20.6,18.9,25.9h-25.1h-25.7v-26.3h18.8v-8.9h-27.6V223h-19V96.8V50.5h51.4h27.8v38.9h8.9V41.7h-36.7V24.1H88.8v17.6v8.9v28.6h-53v17.6H24.3V223H10v8.9h14.2h64.6h8.9h19h34.6h30.2H246V223H190z M97.7,32.9h42.6v8.7H97.7V32.9z M44.7,88h42.6v8.7H44.7V88z M33.1,223V105.6h2.7h53V223H33.1z M143.4,146.4c0-21.9,17.8-39.7,39.8-39.7c21.9,0,39.8,17.8,39.8,39.7c0,17.1-26.1,53.8-39.8,71.1C169.5,200.2,143.4,163.5,143.4,146.4z"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "designation",
                                                name: "designation",
                                                value: formData['designation'],
                                                type: "text",
                                                onChange: handleChange,
                                                placeholder: "Your Designation",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                viewBox: "0 0 367.004 367.004",
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M160.937,197.203c24.125,0,80.846-29.033,80.846-98.603c0-9.705-0.236-19.081-1.037-27.94             c-1.313-17.427-4.883-32.872-13.768-44.71C215.578,9.838,195.629,0,160.937,0c-34.68,0-54.628,9.833-66.029,25.937             C86.012,37.778,82.44,53.231,81.127,70.669c-0.799,8.856-1.035,18.229-1.035,27.932C80.092,168.17,136.812,197.203,160.937,197.203             z M187.328,36.123c-2.355,5.951-3.535,8.926-5.891,14.877c-15.209-4.297-25.791-4.297-41,0c-2.355-5.951-3.533-8.926-5.891-14.877             C153.566,30.365,168.308,30.365,187.328,36.123z M92.119,83.517c0.932,2.037,4.889,9.869,11.014,10.604             c7.041,0.844,18.729-24.936,57.805-24.998c39.076,0.063,50.764,25.842,57.805,24.998c6.125-0.735,10.082-8.567,11.014-10.604             c0.189,4.992,0.259,10.046,0.259,15.084c0,34.006-15.015,55.076-27.612,66.763c-15.871,14.726-33.492,20.071-41.465,20.071             c-7.973,0-25.594-5.345-41.465-20.071c-12.598-11.687-27.612-32.757-27.612-66.763C91.86,93.562,91.93,88.509,92.119,83.517z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M232.705,211.768c2.605-2.606,5.371-4.994,8.26-7.181c-11.223-6.117-22.109-11.933-29.153-15.697l-0.331-0.177             c-1.982-1.059-4.403-0.847-6.169,0.541c-9.085,7.132-19.035,11.938-29.574,14.283c-1.861,0.414-3.391,1.738-4.066,3.521             l-10.734,28.291l-10.734-28.291c-0.675-1.783-2.204-3.106-4.066-3.521c-10.539-2.346-20.489-7.152-29.573-14.283             c-1.769-1.388-4.188-1.601-6.17-0.541c-17.138,9.158-58.25,31.302-69.829,39.106c-19.621,13.219-28.199,61.053-29.72,70.508             c-0.15,0.938-0.064,1.898,0.253,2.793c0.703,1.982,18.709,48.548,149.84,48.548c5.933,0,11.627-0.098,17.105-0.28             c0.481-6.064,3.029-11.993,7.657-16.622l31.512-31.511C203.113,271.581,208.833,235.64,232.705,211.768z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M336.396,219.546c-12.79-12.79-29.821-19.834-47.957-19.834c-18.135,0-35.166,7.044-47.955,19.834             c-21.512,21.511-26.052,54.982-11.04,81.396l1.317,2.319l-37.284,37.284c-6.042,6.043-6.041,15.876,0.002,21.92             c2.927,2.927,6.819,4.539,10.958,4.539c4.142,0,8.033-1.612,10.96-4.54l37.285-37.283l2.317,1.315             c10.126,5.748,21.698,8.787,33.464,8.787c18.127,0,35.149-7.04,47.933-19.824c12.791-12.79,19.835-29.822,19.835-47.957             C356.231,249.367,349.187,232.336,336.396,219.546z M319.779,298.842c-8.357,8.358-19.488,12.962-31.339,12.962             c-11.851,0-22.982-4.603-31.341-12.962c-17.281-17.281-17.281-45.399,0-62.68c8.359-8.359,19.49-12.962,31.341-12.962             c11.851,0,22.981,4.604,31.339,12.963c8.359,8.358,12.963,19.488,12.963,31.339S328.138,290.483,319.779,298.842z"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $331000cdd042dde5$export$2e2bcd8739ae039), {
                                                className: "pl4rem shadow bg5 w100 br5px p1rem",
                                                name: "phone",
                                                country: "GB",
                                                international: true,
                                                placeholder: "Your Phone Number",
                                                withCountryCallingCode: true,
                                                value: formData['phone'],
                                                onChange: handlePhoneChange
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 384 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            websiteStatus == 'Check' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "button",
                                                className: "verify-btn shadow shadow bg9 c1 p1rem fw600 cp ttu",
                                                value: websiteStatus,
                                                onClick: ()=>verifyWebsite()
                                            }) : websiteStatus == 'Confirm' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "button",
                                                        className: "verify-btn shadow shadow bg9 c1 p1rem mr6rem fw600 cp ttu",
                                                        value: "Check",
                                                        onClick: ()=>verifyWebsite()
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "button",
                                                        className: "verify-btn shadow shadow bg8 c1 p1rem fw600 cp ttu",
                                                        value: websiteStatus,
                                                        onClick: ()=>setWebsiteStatus('Confirmed')
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "button",
                                                className: "verify-btn shadow shadow bg7 c1 p1rem fw600 ttu",
                                                value: websiteStatus
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "companyWebsite",
                                                name: "website",
                                                type: "text",
                                                value: formData['website'],
                                                onChange: (e)=>{
                                                    handleChange(e), setWebsiteStatus('Check');
                                                },
                                                placeholder: "Website",
                                                className: "pl4rem shadow bg5 w100 br5px p1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                viewBox: "0 0 512 512",
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256s256-114.62,256-256S397.38,0,256,0z M172.211,41.609              c-24.934,27.119-44.68,66.125-56.755,111.992H49.749C75.179,102.741,118.869,62.524,172.211,41.609z M25.6,256              c0-26.999,5.077-52.727,13.662-76.8h70.494c-4.608,24.294-7.356,49.963-7.356,76.8s2.748,52.506,7.347,76.8H39.262              C30.677,308.727,25.6,283,25.6,256z M49.749,358.4h65.707c12.083,45.867,31.821,84.872,56.755,111.991              C118.869,449.476,75.179,409.259,49.749,358.4z M243.2,485.188c-43.81-8.252-81.877-58.24-101.359-126.788H243.2V485.188z              M243.2,332.8H135.74c-4.924-24.166-7.74-49.997-7.74-76.8s2.816-52.634,7.74-76.8H243.2V332.8z M243.2,153.6H141.841              C161.323,85.052,199.39,35.063,243.2,26.812V153.6z M462.251,153.6h-65.707c-12.083-45.867-31.821-84.873-56.755-111.992              C393.131,62.524,436.821,102.741,462.251,153.6z M268.8,26.812c43.81,8.252,81.877,58.24,101.359,126.788H268.8V26.812z              M268.8,179.2h107.46c4.924,24.166,7.74,49.997,7.74,76.8s-2.816,52.634-7.74,76.8H268.8V179.2z M268.8,485.188V358.4h101.359              C350.677,426.948,312.61,476.937,268.8,485.188z M339.789,470.391c24.934-27.127,44.672-66.125,56.755-111.991h65.707              C436.821,409.259,393.131,449.476,339.789,470.391z M402.244,332.8c4.608-24.294,7.356-49.963,7.356-76.8              s-2.748-52.506-7.347-76.8h70.494c8.576,24.073,13.653,49.801,13.653,76.8c0,27-5.077,52.727-13.662,76.8H402.244z"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr mt0-5rem shadow p1rem bg5 ",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "df mb0-5rem",
                                                children: "Firm Logo"
                                            }),
                                            formData['firmLogo'] == '' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                onDragOver: onDragOver,
                                                onDrop: (e)=>onDrop(e),
                                                for: "fileUpload",
                                                className: "w100 bsbb bg5 br5px df jcc aic px2rem py5rem bsd bo6 bw2px cp mb0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "pen fs1rem fw500 tac",
                                                        children: "Click here or drag and drop files (Max 160x160)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        onChange: handleImageChange,
                                                        className: "dn",
                                                        id: "fileUpload",
                                                        type: "file",
                                                        accept: "image/*"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "close-popup c3",
                                                        onClick: ()=>setFormData((prevFormData)=>({
                                                                    ...prevFormData,
                                                                    firmLogo: ''
                                                                })),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            viewBox: "0 0 256 256",
                                                            style: {
                                                                position: 'relative',
                                                                top: '4px'
                                                            },
                                                            className: "pen fds h1rem f1 mr0-5rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                className: "pen fa-primary",
                                                                                d: "M94.6,3.6c-5.7,1.5-10.5,5.6-13.3,11.2l-1.7,3.4L79.5,28l-0.2,9.7H47.5c-30.4,0-32,0-33.7,0.9c-3.4,1.8-4.9,6.8-2.7,9.7c2.2,2.8,3.3,3.3,8.8,3.5c4.8,0.2,5.1,0.2,5.4,1.2c0.1,0.6,5.6,41.9,12.3,91.9c6.6,49.9,12.2,91.4,12.4,92c0.1,0.7,1,2.7,2,4.5c2.8,5.4,7.9,9.4,13.6,10.9c2.6,0.7,10.2,0.8,62.6,0.8c65.2,0,62.8,0.1,67.7-2.8c5.6-3.3,9.8-9.4,10.8-15.6c0.2-1.6,5.7-43,12.3-91.8c6.5-48.9,11.9-89.4,12-89.9c0.2-1,0.6-1,5.3-1.2c4.3-0.1,5.4-0.3,6.5-1.2c2.3-1.7,3.3-3.4,3.3-5.7c0-2.7-1.3-4.9-3.6-6.2c-1.8-1-2.3-1-33.8-1h-31.9l-0.2-9.7l-0.1-9.7l-1.7-3.4c-2.8-5.7-7.7-9.7-13.6-11.2C156.9,2.5,98.8,2.5,94.6,3.6z M159.3,18.1c2.8,1.7,3.1,2.9,3.1,11.8v7.9H128H93.7v-7.9c0-8.8,0.3-10.1,3.1-11.8c1.5-0.9,2.7-1,31.3-1C156.6,17.1,157.8,17.1,159.3,18.1z M216.3,55c-0.2,1.7-5.7,42.7-12.1,91.1c-9,67.4-11.9,88.3-12.6,89.4c-0.4,0.8-1.7,2-2.7,2.5c-1.9,1-1.9,1-60.9,1c-53.2,0-59.2-0.1-60.7-0.8c-3.6-1.7-2.6,4.2-15.7-93.9C45.1,95,39.6,54,39.5,53.3l-0.2-1.3H128h88.7L216.3,55z"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M78.2,70c-1.7,1-2.8,2.6-3.3,4.4c-0.1,0.6,1.8,32.8,4.4,71.4c3.9,57.9,4.8,70.5,5.5,72c2.6,5.3,9.9,5.2,12.5-0.1c0.9-1.8,0.8-3-3.8-72.7c-5.2-77.6-4.6-72.6-8.1-74.9C83.3,68.9,80.3,68.8,78.2,70z"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M124.7,69.9c-0.9,0.4-2.1,1.5-2.6,2.4c-1,1.6-1,2.4-1,73.1c0,70.9,0,71.6,1,73.1c2.6,4.2,9.2,4.2,11.8,0c1-1.6,1-2.3,1-73.1s0-71.6-1-73.1C132.1,69.4,128,68.3,124.7,69.9z"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M170.7,70.2c-3.5,2.3-2.9-2.7-8.1,74.8c-4.7,70-4.8,70.8-3.8,72.7c2.6,5.3,10,5.4,12.5,0.1c0.7-1.4,1.6-13.5,5.3-69.2c2.5-37.1,4.5-69.2,4.6-71.2c0.1-3.1,0-3.9-1-5.3C177.9,69,173.8,68.2,170.7,70.2z"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df jcc",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "poupup-img shadow brw5 tac",
                                                            src: formData['firmLogo'],
                                                            alt: "Firm Logo"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                onClick: ()=>setStepNo('Step2'),
                                                className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                                children: "Back"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                onClick: ()=>handleRegister(),
                                                className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                                children: "Register"
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $073f657115610bce$export$2e2bcd8739ae039), {
                modalType: "chooseAuthMethod",
                smsEnabled: smsEnabled,
                loginWithSMS: loginWithSMS,
                twoFaEnabled: twoFaEnabled,
                loginWithTwoFA: loginWithTwoFA,
                emailEnabled: emailEnabled,
                loginWithEmail: loginWithEmail
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1275acb5c60c38a5$export$2e2bcd8739ae039), {
                buttonText: buttonText,
                isButtonDisabled: isButtonDisabled,
                modalType: "enterCode",
                authMethod: authMethod,
                loading: loading,
                codeEntered: codeEntered,
                smsEnabled: smsEnabled,
                twoFaEnabled: twoFaEnabled,
                emailEnabled: emailEnabled,
                resendCode: resendCode,
                counter: counter,
                loginFor: loginFor
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $950db95a2cf78b98$export$2e2bcd8739ae039), {
                modalType: 'addCompany',
                proceedCompany: proceedCompany,
                setIsFireWork: setIsFireWork,
                user: user,
                isURL: isURL,
                applicant: applicant,
                openWindow: openWindow,
                setCompany: setCompany,
                setConfirmedCompany: setConfirmedCompany,
                confirmedCompany: confirmedCompany,
                companyOptions: companyOptions,
                setCompanyOptions: setCompanyOptions,
                selectedCompany: selectedCompany,
                setSelectedCompany: setSelectedCompany,
                closeAddCompany: closeAddCompany,
                existingCompany: existingCompany,
                setExistingCompany: setExistingCompany,
                step: step,
                setStep: setStep,
                setPreviousCompanyDeleted: setPreviousCompanyDeleted,
                previousCompanyDeleted: previousCompanyDeleted
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalCardClasses: "m0rem",
                modalType: "addApplicantPopup",
                girlComponent: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        position: "relative",
                        maxHeight: "90%",
                        left: "-20px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("8dxNU")),
                        alt: "inteligent-girl",
                        className: "girlImage"
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                        className: "tac c15 fs2rem fw400 mb2rem",
                        children: [
                            "Add Applicant To Your  ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "  Investor",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Match"
                            }),
                            " Index"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df fdc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df gg1rem mb0-5rem",
                                children: [
                                    'firstName',
                                    'lastName'
                                ].map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        type: "text",
                                        placeholder: `Applicant ${item == 'firstName' ? 'first name' : 'last name'}`,
                                        value: applicant[item] || '',
                                        onChange: (e)=>setApplicant({
                                                ...applicant,
                                                [item]: e.target.value
                                            }),
                                        className: "w100 bss bw2px bo5 br5px p1rem",
                                        InputProps: {
                                            style: {
                                                borderRadius: "10px",
                                                fontSize: '14px'
                                            },
                                            startAdornment: item == 'firstName' && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                style: {
                                                    marginRight: '10px'
                                                },
                                                width: "14",
                                                height: "16",
                                                viewBox: "0 0 14 16",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d: "M7 2C5.34314 2 4 3.34315 4 5C4 6.65683 5.34314 8 7 8C8.65683 8 10 6.65683 10 5C10 3.34315 8.65683 2 7 2ZM2.5 5C2.5 2.51472 4.51472 0.5 7 0.5C9.48528 0.5 11.5 2.51472 11.5 5C11.5 7.48528 9.48528 9.5 7 9.5C4.51472 9.5 2.5 7.48528 2.5 5ZM2.35986 11.4624C3.58257 10.6981 5.22507 10.25 7 10.25C8.77495 10.25 10.4174 10.6981 11.6402 11.4624C12.8522 12.22 13.75 13.3626 13.75 14.75C13.75 15.1642 13.4142 15.5 13 15.5C12.5858 15.5 12.25 15.1642 12.25 14.75C12.25 14.0664 11.8046 13.334 10.8452 12.7344C9.89627 12.1414 8.53878 11.75 7 11.75C5.46123 11.75 4.10372 12.1414 3.15485 12.7344C2.19543 13.334 1.75 14.0664 1.75 14.75C1.75 15.1642 1.41421 15.5 1 15.5C0.58579 15.5 0.25 15.1642 0.25 14.75C0.25 13.3626 1.14771 12.22 2.35986 11.4624Z",
                                                    fill: "black"
                                                })
                                            })
                                        }
                                    }))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df gg1rem mb0-5rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    type: "email",
                                    placeholder: "Applicant email",
                                    value: applicant['email'] || '',
                                    onChange: (e)=>setApplicant({
                                            ...applicant,
                                            email: e.target.value
                                        }),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            style: {
                                                marginRight: '10px'
                                            },
                                            width: "16",
                                            height: "12",
                                            viewBox: "0 0 16 12",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z",
                                                fill: "black"
                                            })
                                        })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 df jcc my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    disabled: applicant['firstName'] == '' || applicant['lastName'] == '' || applicant['email'] == '',
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'addCompany'
                                        })),
                                    className: `df jcc cp c1 fw400 fs1rem br38px w300px py0-5rem ${applicant['firstName'] == '' || applicant['lastName'] == '' || applicant['email'] == '' ? 'cna bg12' : 'cp bg4'}`,
                                    children: "Register Applicant"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'generatingDescription',
                onClose: (_, reason)=>{
                    if (reason !== 'backdropClick') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                },
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px pr br20px",
                    style: {
                        padding: '2.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac mb1-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h9rem",
                                    src: (parcelRequire("hA45b")),
                                    alt: "wizard"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "w100 c6 tac fw600 fs1-75rem mt1rem mb0-5rem",
                                    children: [
                                        "Setting up ",
                                        company['cName'] || 'your company'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15 op60 tac maw500px mla mra fs14px",
                                    children: "You're good to go \u2014 feel free to continue now. We'll keep working in the background and let you know when everything's ready."
                                })
                            ]
                        }),
                        (company['cAddress'] || company['cOfficers']?.length > 0 || company['sicCodes']?.length > 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg38 br10px mb1-5rem",
                            style: {
                                border: '1px solid #DDE2F2',
                                padding: '1rem 1.25rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c27 fs10px fw600 ttu",
                                    style: {
                                        letterSpacing: '0.06em',
                                        marginBottom: '0.6rem'
                                    },
                                    children: "Confirmed from Companies House"
                                }),
                                company['cAddress'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15 fs14px fw500",
                                    style: {
                                        marginBottom: '0.85rem'
                                    },
                                    children: company['cAddress'].replace(/^,\s*|,\s*$/g, '').replace(/,\s*,/g, ',')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fww",
                                    style: {
                                        gap: '0.5rem'
                                    },
                                    children: [
                                        company['cOfficers']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c26 fs11px fw500",
                                            style: {
                                                background: '#FFFFFF',
                                                border: '1px solid #DDE2F2',
                                                borderRadius: '50px',
                                                padding: '0.3rem 0.75rem'
                                            },
                                            children: [
                                                company['cOfficers'].length,
                                                " officer",
                                                company['cOfficers'].length === 1 ? '' : 's'
                                            ]
                                        }),
                                        company['sicCodes']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c26 fs11px fw500",
                                            style: {
                                                background: '#FFFFFF',
                                                border: '1px solid #DDE2F2',
                                                borderRadius: '50px',
                                                padding: '0.3rem 0.75rem'
                                            },
                                            children: [
                                                company['sicCodes'].length,
                                                " SIC code",
                                                company['sicCodes'].length === 1 ? '' : 's'
                                            ]
                                        }),
                                        company['cFiling']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c26 fs11px fw500",
                                            style: {
                                                background: '#FFFFFF',
                                                border: '1px solid #DDE2F2',
                                                borderRadius: '50px',
                                                padding: '0.3rem 0.75rem'
                                            },
                                            children: "Filing history loaded"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc",
                            style: {
                                gap: '0.75rem'
                            },
                            children: $0868b271c9ad66ad$var$SETUP_STEPS.map((setupStep)=>{
                                const state = setupSteps[setupStep.key];
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    style: {
                                        gap: '0.75rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic jcc br100",
                                            style: {
                                                width: '32px',
                                                height: '32px',
                                                minWidth: '32px',
                                                background: state === 'done' ? '#E7F8ED' : state === 'error' ? '#FDEBEC' : '#EEF1FE'
                                            },
                                            children: [
                                                state === 'done' && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-check",
                                                    style: {
                                                        fontSize: '14px',
                                                        color: '#09B255'
                                                    }
                                                }),
                                                state === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-exclamation-triangle",
                                                    style: {
                                                        fontSize: '14px',
                                                        color: '#F0606C'
                                                    }
                                                }),
                                                state === 'pending' && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-spinner fa-spin",
                                                    style: {
                                                        fontSize: '16px',
                                                        color: '#4A67FF'
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: `fs14px fw500 ${state === 'error' ? 'c9' : 'c15'}`,
                                                    children: setupStep.label
                                                }),
                                                state === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c28 fs11px",
                                                    children: "We'll keep this ready to add later from Company Settings."
                                                })
                                            ]
                                        })
                                    ]
                                }, setupStep.key);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: "Continue",
                                onClick: ()=>{
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    }));
                                    proceedCompany(company);
                                },
                                customClassName: "w100"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "confirmDescription",
                girlComponent: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lg-dn confirmDescription1",
                    style: {
                        position: 'relative'
                    },
                    children: !localStorage.getItem('isDemoChecklist') && !localStorage.getItem('isPartnerChecklist') && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/girl-1730109127115.webp",
                                alt: "messageLadie",
                                className: "girlImage"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                onClick: ()=>{
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'introVideo'
                                    }));
                                    dispatch((0, $ee5327cdf6cdce8c$export$25316803c042c1e3)({
                                        modalHistory: modal['open'],
                                        historyData: company
                                    }));
                                },
                                src: (parcelRequire("lp3wv")),
                                className: "pa cp",
                                alt: "clickToHearMe",
                                style: {
                                    maxWidth: "130px",
                                    zIndex: 99,
                                    top: "-210px",
                                    left: "15px"
                                }
                            })
                        ]
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "fs1-5rem tas w100 lh1 c15 fw600 mb0-5rem",
                        children: "Company Description"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c3 fs14px w100 tas mb1rem",
                        children: "AI Generated"
                    }),
                    editDescription ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc fs1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    defaultValue: company['companyDescription'],
                                    rows: "8",
                                    style: {
                                        resize: 'vertical'
                                    },
                                    name: "companyDescription",
                                    id: "companyDescription",
                                    type: "text",
                                    className: "pl4rem bss bw2px bo5 w100 br5px p1rem"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb fdc fdr-md aic fs1rem px2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>setEditDescription(false),
                                        className: "shadow my1rem bg4 bg3-hover c1 td250 br5px p1rem fw600 cp ttu w40 bsbb tac",
                                        children: "Back"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>updateDescription(),
                                        className: "shadow my1rem bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w40 bsbb tac",
                                        children: "Save"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc fs14px c43 oya",
                                style: {
                                    backgroundImage: `url(${(parcelRequire("dJEkK"))})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    backgroundSize: 'contain',
                                    lineHeight: '1.8',
                                    paddingRight: '16px',
                                    maxHeight: "300px"
                                },
                                children: company['companyDescription']
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 fs11px fw500 w100 tas pt1rem my1rem",
                                children: "You can later edit description in Company Settings"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc fdc aic fs1rem px2rem",
                                children: [
                                    isDescriptionLogin ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>{
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'login'
                                            })), setIsDescriptionLogin(false);
                                        },
                                        className: "my0-5rem bg4 bg4-hover c1 td250 br50px pt0-5rem pb0-5rem fw600 cp ttu pl6rem pr6rem mla mra bsbb tac df jcc aic",
                                        children: "Next"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>proceedCompany(company),
                                        className: "my0-5rem bg4 bg4-hover c1 td250 br50px pt0-5rem pb0-5rem fw600 cp ttu pl6rem pr6rem mla mra bsbb tac df jcc aic",
                                        children: "Next"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>handleNotYourCompany(),
                                        className: "cp bg1 c14 mt0-5rem",
                                        style: {
                                            fontSize: '12px'
                                        },
                                        children: [
                                            "Not your company? ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c3",
                                                children: "Try again!"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'noAiModal',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 p3rem shadow w100 bsbb df fdc maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb0-5rem",
                            children: "No AI"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb1rem",
                            children: "Data Protection: Your privacy is our ultimate quest! To maximize the power of your responses and enhance our services, we've allied with an AI-powered wizards, Microsoft\u2019s Bing and Chat GPT by OpenAI."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb1rem",
                            children: "This collaboration lets us wave the magic wand over some of the answers and information you provide us, transforming it into comprehensive reports. It's important to note that this adventure may involve sharing some of your responses to our questions (but NOT the contents of any files you upload if you later subscribe) with our AI comrade."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb1rem",
                            children: "While this means your responses may take a side-quest with this AI tool, rest assured, it doesn't wander off or change hands. It's solely to boost your reports\u2019 quality and the AI won't store or re-use it. Your information's journey with Chat GPT is for one purpose alone - to supercharge the reports we craft for you."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb1rem",
                            children: "Where AI has been used to enhance our reports, our report has an underlying digital watermark to make this clear."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb1rem",
                            children: "By tapping 'Accept', you're giving your consent for this noble quest of your data. If our data protection quest raises any questions or if you'd like to delve deeper into our data handling practices, our communication scrolls are always open for you!\u201C Click here for further information."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "btn-group df jsc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu mr2rem w100 bsbb tac mb1rem df jcc aic",
                                    children: "No AI"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    disabled: true,
                                    className: "shadow op20 bg3-hover c1 bg3 td250 br5px py0-5rem px1rem fw600 usn cp ttu w100 bsbb tac mb1rem df jcc aic",
                                    children: "No AI please"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'newAdvisorAdded' || modal['open'] == 'newInvestorCompany',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "fs1-5rem lh1 c15 fw600 mb0-5rem tac",
                            children: [
                                "Access Granted to ",
                                ' ',
                                location.pathname.includes('newAdvisorCompany') ? 'Advisor' : 'Investor',
                                ' '
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs14px c43 oya pt1rem",
                                    children: [
                                        "Many congratulations, ",
                                        resNewAdvisor && resNewAdvisor['userFirstName'],
                                        "! You have granted",
                                        resNewAdvisor && resNewAdvisor['permissionType'] == 'ALL' && ' all areas ',
                                        resNewAdvisor && resNewAdvisor['permissionType'] == 'DASHBOARD' && ' dashboard (only) ',
                                        resNewAdvisor && resNewAdvisor['permissionType'] == 'DASHBOARD & REPORT' && ' dashboard and reports ',
                                        "access to ",
                                        location.pathname.includes('newAdvisorCompany') ? 'advisor ' : 'investor ',
                                        resNewAdvisor && `${resNewAdvisor['advisorFirstName']} (${resNewAdvisor['advisorEmail']}) `,
                                        "for company ",
                                        resNewAdvisor && resNewAdvisor['companyName'],
                                        "."
                                    ]
                                }),
                                resNewAdvisor && resNewAdvisor['userType'] == 'newUser' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs14px c43 oya",
                                            children: "You now need to set a password for your own newly created account on the Diligentsia platform."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: `/reset_password/${resNewAdvisor['code']}`,
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "aic bg4 br19px bsbb c1 cp df fw500 jcc w200px mt1rem px1rem py0-5rem registerButtonAnimation",
                                            children: [
                                                "Set Password",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "pen ml0-5rem h1rem f1",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 512 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M336 0c-97.2 0-176 78.8-176 176c0 14.71 2.004 28.93 5.406 42.59l128 127.1C307.1 349.1 321.3 351.1 336 351.1c97.2 0 176-78.8 176-176S433.2 0 336 0zM376 176c-22.09 0-40-17.91-40-40S353.9 96 376 96S416 113.9 416 136S398.1 176 376 176z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M165.4 218.6l-156 156C3.371 380.6 0 388.8 0 397.3V496C0 504.8 7.164 512 16 512l96 0c8.836 0 16-7.164 16-16v-48h48c8.836 0 16-7.164 16-16v-48h57.37c4.242 0 8.312-1.688 11.31-4.688l32.72-32.72L165.4 218.6z"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                resNewAdvisor && resNewAdvisor['userType'] == 'oldUser' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs14px c43 oya",
                                            children: [
                                                "You can now login into your account to check the access to ",
                                                location.pathname.includes('newAdvisorCompany') ? 'advisor' : 'investor',
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "/login",
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "bsbb jcc w200px w9rem df aic fw500 px1rem py0-5rem mt1rem c1 bg4 br19px cp registerButtonAnimation",
                                            children: "Login Now!"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'existingInvestor',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px pr pt3rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                setExistingInvestor({}), setStepNo('Step2'), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'registerInvestor'
                                }));
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h3rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 mt2rem",
                            children: `Existing Investor - ${existingInvestor['cName']}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem oa",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs1rem taj px0-5rem",
                                children: [
                                    "Hi ",
                                    `${formData['firstName']} ${formData['lastName']}`,
                                    ", ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "We will notify ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            existingInvestor['contactName'],
                                            " "
                                        ]
                                    }),
                                    " of your wish to add your Diligentsia account and request that they grant you access. ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Please click below REQUEST to grant for access",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " Kind Regards "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>requestInvestorAccess(),
                                className: "bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "Request"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'advisorAccessGranted',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tac",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem m1rem ",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "c15 fw600 tac",
                        children: "Access Granted"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tac my1rem oa",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "fs1rem c15 px0-5rem",
                            children: [
                                "Hi ",
                                user['firstName'],
                                ", ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "You have successfully granted access to ",
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                    children: [
                                        `${advisorAccessData?.['userName']}`,
                                        " "
                                    ]
                                }),
                                " for ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: advisorAccessData?.['companyName']
                                }),
                                ". ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Kind Regards "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcse",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            onClick: handleToDashboard,
                            text: "Dashboard",
                            btnType: "warning"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'accessGranted',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw800px pr pt3rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            to: "/investor-dashboard",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600",
                            children: "Access Granted"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem oa",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs1rem taj px0-5rem",
                                children: [
                                    "Hi ",
                                    accessGrantedData['contactName'],
                                    ", ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "You have successfully granted access to ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            `${accessGrantedData['userFirstName']} ${accessGrantedData['userLastName']}`,
                                            " "
                                        ]
                                    }),
                                    " for ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: accessGrantedData['investorName']
                                    }),
                                    ". ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Kind Regards "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                to: !user || !user.role ? '/login' : user.role.toLowerCase() === 'advisor' ? '/advisor-dashboard' : user.role.toLowerCase() === 'user' ? '/dashboard' : '/investor-dashboard',
                                className: "c3 td250 fs1-5rem cp tdu",
                                children: "Dashboard"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "generatePartnerPopup",
                open: modal['open'] == 'generatePartnerPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: creatingModule ? `Creating ${creatingModule}...` : 'Performing checklist creation magic!'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar module-progress-bar`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: "This may take couple of minutes to generate checklist."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'checkAccessCompany',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "fs1-5rem lh1 c15 fw600 mb0-5rem tac",
                            children: "Company Created"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc fs14px c43 oya py2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: 'Well done! Your client company has been created with a Free subscription. You now have full access to the dashboard and can complete free modules. When you\'re ready to give your client access, click the "Activate Client Login" button on your client list.'
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>window.location.reload(),
                                className: "h100 mt0-5rem bg4 bg3-hover c1 td250 br35px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "Close"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'disclaimerModal',
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "poppins-font-style disclaimer-modal mah100 bg1 shadow w100 df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        maxWidth: '560px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "header-area w100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb w100 px2rem py0-5rem bsbb aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "icon-area df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    className: "back-btn-modal cp",
                                                    width: "22",
                                                    height: "16",
                                                    viewBox: "0 0 22 16",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    onClick: ()=>closeDisclaimerModal(),
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                                        fill: "#151313"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15 fs1-25rem fw500 ml2rem",
                                                    children: "Disclaimer"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "fa-secondary",
                                            width: "110",
                                            height: "100",
                                            viewBox: "0 0 137 105",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            style: {
                                                marginBottom: '-21px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M133.726 98.1522L82.8958 8.84552C79.7793 3.46246 74.2257 0.232422 67.9925 0.232422C61.7589 0.232422 56.2057 3.46246 53.1458 8.84552L2.25893 98.1522C-0.800945 103.536 -0.744224 109.882 2.31565 115.209C5.4326 120.536 10.9858 123.766 17.1623 123.766H118.879C125.056 123.766 130.552 120.536 133.669 115.209C136.786 109.882 136.786 103.536 133.726 98.1522ZM73.6591 88.689C73.6591 91.8056 71.1091 94.3557 67.9925 94.3557C64.8759 94.3557 62.3258 91.8056 62.3258 88.689V87.7825C62.3258 84.6655 64.8759 82.1158 67.9925 82.1158C71.1091 82.1158 73.6591 84.6655 73.6591 87.7825V88.689ZM73.6591 67.5524C73.6591 70.7258 71.1091 73.2191 67.9925 73.2191C64.8759 73.2191 62.3258 70.7258 62.3258 67.5524V42.2223C62.3258 39.1057 64.8759 36.5556 67.9925 36.5556C71.1091 36.5556 73.6591 39.1057 73.6591 42.2223V67.5524Z",
                                                fill: "white"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "disclaimer-box p2rem",
                                style: {
                                    height: '58vh',
                                    overflow: 'auto'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "accordian-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                expanded: accordion == 'one',
                                                onChange: ()=>setAccordion('one'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            className: "fw500",
                                                            children: "No investment advice"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "mah100 mya oya df fdc jcsb",
                                                            children: "Diligentsia does NOT give investment advice, nor do we generate revenue from successful introductions via our platform. Our model is to charge companies for tools and database access. Once introduced, it is the responsibility of the company and investors to proceed or not with any transaction."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                expanded: accordion == 'two',
                                                onChange: ()=>setAccordion('two'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            className: "fw500",
                                                            children: "No responsibility for unaudited self-certification"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "mah100 mya oya df fdc jcsb",
                                                            children: "Diligentsia does NOT take responsibility for the unaudited self-certification, which is indicative. Third parties should undertake their own diligence. We remind companies, however, that third parties may seek to rely on information provided by companies in completion of our modules and should do so accurately and honestly with this in mind."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                expanded: accordion == 'three',
                                                onChange: ()=>setAccordion('three'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            className: "fw500",
                                                            children: "No responsibility for diligence packs"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "mah100 mya oya df fdc jcsb",
                                                            children: "Diligentsia does NOT take responsibility for the contents of the self-audited diligence packs - we merely provide the tools for their generation and scoring. Parties looking for more assurance should take additional external professional advice, \u201Cprofessional advice, via, for example, Diligentsia Pro PLUS."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                expanded: accordion == 'four',
                                                onChange: ()=>setAccordion('four'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            className: "fw500",
                                                            children: "We don\u2019t take commissions from lawyers & accountants "
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "mah100 mya oya df fdc jcsb",
                                                            children: "Diligentsia does NOT take commissions from accountants and lawyers, nor do we ask for % of monies raised from investors. We generate our revenues from subscriptions and module charges on companies subscribing to our platform."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                expanded: accordion == 'five',
                                                onChange: ()=>setAccordion('five'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            className: "fw500",
                                                            children: "We don\u2019t share your data without your permission"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "mah100 mya oya df fdc jcsb",
                                                            children: "Diligentsia provides opportunities for companies to obtain professional assistance from third parties. However, introductions are only made, and your data is only shared with those third parties at your instigation."
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcc fdc w100 aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleDisclaimer(),
                                                className: "bg15 bg14-hover w50 py1rem mt2rem c1 br80px cp td250 mb1rem",
                                                children: "Understood"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "w100 tac c15",
                                                style: {
                                                    color: '#505050',
                                                    fontSize: '13px'
                                                },
                                                children: [
                                                    "See our full ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                        target: "_blank",
                                                        href: "/terms-conditions",
                                                        className: "c3",
                                                        children: "terms and conditions"
                                                    }),
                                                    ", and ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                        target: "_blank",
                                                        href: "/policy",
                                                        className: "c3",
                                                        children: "policies"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87d44cef365988d0$export$2e2bcd8739ae039), {
                modalType: "groupCompanies"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5752a2a792eca99$export$2e2bcd8739ae039), {
                modalType: "createGroup",
                handleCreateGroup: handleCreateGroup,
                setCompaniesGroup: setCompaniesGroup,
                companiesGroup: companiesGroup,
                companies: companies,
                parentCompany: parentCompany,
                setParentCompany: setParentCompany,
                handleChildCompany: handleChildCompany,
                user: user,
                profileClass: profileClass
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37538c30a4f4fd93$export$2e2bcd8739ae039), {
                modalType: "editGroupSelect",
                companies: companies,
                parentCompany: editParentCompany,
                setParentCompany: setEditParentCompany,
                setCompaniesGroup: setEditCompaniesGroup,
                setUpdateType: setUpdateType,
                user: user,
                profileClass: profileClass
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $943e3a6487456388$export$2e2bcd8739ae039), {
                modalType: "editGroupAdd",
                companies: companies,
                parentCompany: editParentCompany,
                handleChildCompany: handleEditChildCompany,
                companiesGroup: editCompaniesGroup,
                updateGroupCompany: updateGroupCompany,
                setCompaniesGroup: setEditCompaniesGroup,
                user: user,
                profileClass: profileClass
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e16dee7e25efb09$export$2e2bcd8739ae039), {
                modalType: "editGroupUpdate",
                parentCompany: editParentCompany,
                handleChildCompany: handleEditChildCompany,
                companiesGroup: editCompaniesGroup,
                updateGroupCompany: updateGroupCompany,
                setCompaniesGroup: setEditCompaniesGroup,
                updateType: updateType,
                user: user,
                profileClass: profileClass
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "report-bug",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>hideBugPopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: [
                                " ",
                                "Drop us a note"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "Send us a note or make a suggestions and we\u2019ll get back to you as soon as we can.  Add a file if you need to."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    rows: "4",
                                    value: bugDescription,
                                    onChange: (e)=>setBugDescription(e.target.value),
                                    placeholder: "Feel free to share your thoughts",
                                    className: "bss bw2px bo5 w100 br5px p1rem mt1rem"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            onDragOver: onDragOverBug,
                            onDrop: onDropBug,
                            htmlFor: "attachment",
                            className: "w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pen fs1rem fw500 tac",
                                    children: "Click here or drag and drop attachment (max 5MB)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "file",
                                    id: "attachment",
                                    multiple: true,
                                    className: "dn",
                                    onChange: handleBugAttachmentFile,
                                    // Remove accept to allow all file types, or customize
                                    accept: ".pdf,.txt,image/jpeg,image/png,application/pdf"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc aic my1rem",
                            children: attachment && attachment.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcc br25px lh1 bg3 c1 px1rem fw600 mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: item,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "py0-5rem pl0-5rem",
                                                children: item["name"].substring(0, 20) + "..."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            onClick: ()=>deleteBugAttachment(item),
                                            className: "p0-5rem f9 w1rem h1rem cp",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 320 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "pen fa-primary",
                                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32.0 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                            })
                                        })
                                    ]
                                }, item["name"]))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ""
                                        })),
                                    className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>handleSubmitBug(),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'introVideo',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc onone w60",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `mah90 w100 bsbb df fdc m1rem br20px pr`,
                            style: {
                                background: 'transparent'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb aic fdc step-box-modal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-box-box-1 tac w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr cp",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                                                id: "videoPaul",
                                                onClick: (e)=>setIsPlay(true),
                                                className: "w100 br20px",
                                                controls: "true",
                                                poster: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Intelligentsia, Video-1731405158175.webp",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("source", {
                                                    src: "https://d37hh65ee5l5bx.cloudfront.net/avatar/Intro+to+Intelligentsia.mp4",
                                                    type: "video/mp4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                onClick: (e)=>playVideo(e),
                                                className: `${isPlay && 'dn'}  pa center`,
                                                style: {
                                                    width: '80px',
                                                    height: '80px'
                                                },
                                                width: "146",
                                                height: "146",
                                                viewBox: "0 0 146 146",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M73.1295 0.384033C33.2267 0.384033 0.767578 32.8463 0.767578 72.7459C0.767578 112.646 33.2267 145.108 73.1295 145.108C113.032 145.108 145.491 112.646 145.491 72.7459C145.491 32.8463 113.032 0.384033 73.1295 0.384033ZM101.896 75.2811L59.6854 102.417C59.1908 102.738 58.6195 102.897 58.0542 102.897C57.5595 102.897 57.0589 102.773 56.6115 102.529C55.6397 101.999 55.039 100.986 55.039 99.8816V45.6102C55.039 44.5061 55.6397 43.4931 56.6115 42.9631C57.5654 42.439 58.7608 42.4712 59.6854 43.075L101.896 70.2107C102.756 70.7642 103.28 71.7213 103.28 72.7459C103.28 73.7706 102.756 74.7274 101.896 75.2811Z",
                                                    fill: "white"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: modal && modal.modalHistory ? modal.modalHistory : ''
                                }));
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '100px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
    // useEffect(() => {
    //   // Initialize Intercom on component mount
    //   intercom();
    //   const handleHashChange = () => {
    //     if (window.location.hash === '#chat') {
    //       setTimeout(() => {
    //         if (window.Intercom) {
    //           window.Intercom('show');
    //         }
    //       }, 1000);
    //     }
    //   };
    //   handleHashChange(); // Check hash on initial load
    //   window.addEventListener('hashchange', handleHashChange);
    //   return () => {
    //     window.removeEventListener('hashchange', handleHashChange);
    //   };
    // }, []);
    let { data: data, totalFile: totalFile, type: type } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileManagement);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            popups,
            loggedInPopups,
            modal['open'] == 'importSummary' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1f9e6a63de7b308d$export$2e2bcd8739ae039), {
                modalType: "importSummary"
            }),
            modal['open'] == 'tempImportSummary' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44e4a80c6bb2231a$export$2e2bcd8739ae039), {
                modalType: "tempImportSummary"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $317086ac24816082$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0471dc540182262$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86bb04e68ae2fbe5$export$610235a922fc0715), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $471542c2b606f48b$export$2e2bcd8739ae039), {
                modalType: "computerToDataRepository"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $471542c2b606f48b$export$2e2bcd8739ae039), {
                modalType: "computerToClarence"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $471542c2b606f48b$export$2e2bcd8739ae039), {
                modalType: "fileUploadFilingAssistant"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'allocatingFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr oya bg1 shadow w100 pl3rem pr3rem pb5rem pt0rem bsbb df fdc m1rem maw1000px br5px pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e84a498389ca6ed9$export$2e2bcd8739ae039), {
                                    currentStep: "indexing"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "AnimateWiz tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h15rem mla mra",
                                        src: (parcelRequire("hA45b")),
                                        alt: "animWiz"
                                    })
                                }),
                                allocationProgress.total > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "fs1-5rem-sm w100 tac mb1rem c15",
                                            children: "Allocating Files to Sections..."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                width: '100%',
                                                maxWidth: '520px',
                                                margin: '0 auto',
                                                textAlign: 'center'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-85rem c27 mb0-5rem",
                                                    children: [
                                                        allocationProgress.current,
                                                        " of ",
                                                        allocationProgress.total,
                                                        " files matched"
                                                    ]
                                                }),
                                                allocationProgress.fileName && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-85rem c27",
                                                    style: {
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        margin: '0 0 0.25rem'
                                                    },
                                                    children: [
                                                        "File: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c15 fw500",
                                                            children: allocationProgress.fileName
                                                        })
                                                    ]
                                                }),
                                                allocationProgress.matchedQNo && allocationProgress.matchedQNo !== 'SXXX' && allocationProgress.matchedQNo !== 'DXXX' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-85rem",
                                                    style: {
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        margin: 0,
                                                        color: '#fc7785'
                                                    },
                                                    children: [
                                                        "\u2192 ",
                                                        allocationProgress.matchedQNo,
                                                        " \u2014 ",
                                                        allocationProgress.matchedQuestion
                                                    ]
                                                }) : allocationProgress.matchedQNo && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs0-85rem c27",
                                                    style: {
                                                        margin: 0
                                                    },
                                                    children: "\u2192 Unallocated"
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "fs1-5rem-sm w100 tac mb1rem c15",
                                            children: "Indexing & Analysing Files..."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                width: '100%',
                                                maxWidth: '520px',
                                                margin: '0 auto'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        marginBottom: '0.35rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem c27",
                                                            style: {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '80%'
                                                            },
                                                            children: indexingProgress.currentFile ? indexingProgress.current < indexingProgress.total ? `Reading: ${indexingProgress.currentFile}` : `\u{2713} All files indexed` : 'Preparing files...'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem c27",
                                                            children: indexingProgress.total > 0 ? `${indexingProgress.current}/${indexingProgress.total}` : ''
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        background: '#E5E7EB',
                                                        borderRadius: '10px',
                                                        height: '8px',
                                                        overflow: 'hidden'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            background: '#22c55e',
                                                            height: '100%',
                                                            borderRadius: '10px',
                                                            width: indexingProgress.total > 0 ? `${Math.round(indexingProgress.current / indexingProgress.total * 100)}%` : '0%',
                                                            transition: 'width 0.3s ease'
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem c27 tac mt1rem",
                                    style: {
                                        opacity: 0.7
                                    },
                                    children: "You can minimise this window \u2014 processing will continue in the background."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcc",
                                    style: {
                                        gap: '1rem',
                                        marginTop: '0.75rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: async ()=>{
                                                await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/cancel', {});
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: '',
                                                    autoFillStatusBarVisible: false,
                                                    autoFillStatusBarPhase: ''
                                                }));
                                                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill cancelled');
                                            },
                                            style: {
                                                background: 'none',
                                                border: '1.5px solid #9CA3AF',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                color: '#6B7280',
                                                fontSize: '13px',
                                                fontWeight: 500,
                                                padding: '0.3rem 1.2rem'
                                            },
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: '',
                                                    autoFillStatusBarVisible: true
                                                })),
                                            style: {
                                                background: 'none',
                                                border: '1.5px solid #3B82F6',
                                                borderRadius: '6px',
                                                cursor: 'pointer',
                                                color: '#3B82F6',
                                                fontSize: '13px',
                                                fontWeight: 500,
                                                padding: '0.3rem 1.2rem'
                                            },
                                            children: "Minimize"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group 1000002103-1733923364928.png",
                                alt: "messageLadie",
                                className: "girlImage1"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'autoFillingQuestions',
                onClose: ()=>{
                    if (modal.autoFillCompleted) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                },
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr oya bg1 shadow w100 pl3rem pr3rem pb5rem pt0rem bsbb df fdc m1rem maw1000px br5px pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e84a498389ca6ed9$export$2e2bcd8739ae039), {
                                    currentStep: modal.autoFillCompleted ? 'result' : 'filling'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "AnimateWiz tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h15rem mla mra",
                                        src: (parcelRequire("hA45b")),
                                        alt: "animWiz"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-5rem-sm w100 tac mb2rem c15",
                                    children: modal.autoFillCompleted ? 'Auto-Fill Complete!' : 'Auto-Filling Questions...'
                                }),
                                modal.autoFillModuleName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac c4 fw600 fs1rem mb1rem",
                                    style: {
                                        marginTop: '-1rem'
                                    },
                                    children: modal.autoFillModuleName
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac",
                                    children: modal.autoFillCompleted ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    display: 'grid',
                                                    gridTemplateColumns: '1fr 1fr',
                                                    gap: '1rem',
                                                    maxWidth: '320px',
                                                    margin: '0 auto 2rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            background: '#F3F4F6',
                                                            borderRadius: '12px',
                                                            padding: '1rem',
                                                            textAlign: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '2rem',
                                                                    fontWeight: '700',
                                                                    color: '#1F2937'
                                                                },
                                                                children: modal.autoFillProcessed || 0
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '0.75rem',
                                                                    color: '#6B7280',
                                                                    marginTop: '0.25rem'
                                                                },
                                                                children: "Processed"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            background: '#D1FAE5',
                                                            borderRadius: '12px',
                                                            padding: '1rem',
                                                            textAlign: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '2rem',
                                                                    fontWeight: '700',
                                                                    color: '#059669'
                                                                },
                                                                children: modal.autoFillAnswered || 0
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '0.75rem',
                                                                    color: '#059669',
                                                                    marginTop: '0.25rem'
                                                                },
                                                                children: "Answered"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            background: '#FEF3C7',
                                                            borderRadius: '12px',
                                                            padding: '1rem',
                                                            textAlign: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '2rem',
                                                                    fontWeight: '700',
                                                                    color: '#D97706'
                                                                },
                                                                children: modal.autoFillNeedsReview || 0
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '0.75rem',
                                                                    color: '#D97706',
                                                                    marginTop: '0.25rem'
                                                                },
                                                                children: "Needs Review"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            background: '#F3F4F6',
                                                            borderRadius: '12px',
                                                            padding: '1rem',
                                                            textAlign: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '2rem',
                                                                    fontWeight: '700',
                                                                    color: '#6B7280'
                                                                },
                                                                children: modal.autoFillSkipped || 0
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    fontSize: '0.75rem',
                                                                    color: '#6B7280',
                                                                    marginTop: '0.25rem'
                                                                },
                                                                children: "Skipped"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>{
                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: ''
                                                    }));
                                                },
                                                className: "bg3 bg4-hover c1 br10px px3rem py0-75rem cp fw500 fs1rem",
                                                children: "Close"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "progress-area w60 mla mra mb1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w100 df jcc aic",
                                                    children: modal.autoFillTotal > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("progress", {
                                                        color: "green",
                                                        className: "maw90 w90",
                                                        style: {
                                                            border: 'none'
                                                        },
                                                        value: modal.autoFillCurrent || 0,
                                                        max: modal.autoFillTotal
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("progress", {
                                                        color: "green",
                                                        className: "maw90 w90",
                                                        style: {
                                                            border: 'none'
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c15 fw500 fs13px mb0-5rem",
                                                children: modal.autoFillTotal > 0 ? `Processing ${modal.autoFillCurrent || 0} of ${modal.autoFillTotal} questions (${Math.round((modal.autoFillCurrent || 0) / modal.autoFillTotal * 100)}%)` : 'Analyzing questions...'
                                            }),
                                            modal.autoFillSectionName && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c4 fw500 fs13px mb0-5rem",
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '500px',
                                                    margin: '0 auto 0.5rem'
                                                },
                                                children: [
                                                    "Section: ",
                                                    modal.autoFillSectionNo ? `${modal.autoFillSectionNo} - ${modal.autoFillSectionName}` : modal.autoFillSectionName
                                                ]
                                            }),
                                            modal.autoFillQuestionText && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c15 fs13px mb0-5rem",
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '500px',
                                                    margin: '0 auto 0.5rem'
                                                },
                                                children: modal.autoFillQuestionText
                                            }),
                                            modal.autoFillReadingFiles?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c27 fs12px mb0-5rem",
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '500px',
                                                    margin: '0 auto 0.5rem'
                                                },
                                                children: [
                                                    "Reading: ",
                                                    modal.autoFillReadingFiles.join(', ')
                                                ]
                                            }),
                                            modal.autoFillStartTime && modal.autoFillCurrent > 0 && modal.autoFillTotal > 0 && (()=>{
                                                const remaining = (Date.now() - modal.autoFillStartTime) / modal.autoFillCurrent * (modal.autoFillTotal - modal.autoFillCurrent);
                                                const eta = remaining > 60000 ? `~${Math.ceil(remaining / 60000)} min remaining` : `~${Math.ceil(remaining / 1000)} sec remaining`;
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c27 fs12px mb1rem",
                                                    children: eta
                                                });
                                            })(),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c27",
                                                children: [
                                                    "We're using AI to find answers from your documents.",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Please wait while the magic happens!"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcc",
                                                style: {
                                                    gap: '1rem',
                                                    marginTop: '1rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: async ()=>{
                                                            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/cancel', {});
                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: '',
                                                                autoFillStatusBarVisible: false,
                                                                autoFillStatusBarPhase: ''
                                                            }));
                                                            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill cancelled');
                                                        },
                                                        style: {
                                                            background: 'none',
                                                            border: '1.5px solid #9CA3AF',
                                                            borderRadius: '6px',
                                                            cursor: 'pointer',
                                                            color: '#6B7280',
                                                            fontSize: '13px',
                                                            fontWeight: 500,
                                                            padding: '0.3rem 1.2rem'
                                                        },
                                                        children: "Cancel"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: '',
                                                                autoFillStatusBarVisible: true,
                                                                autoFillStatusBarPhase: 'filling'
                                                            })),
                                                        style: {
                                                            background: 'none',
                                                            border: '1.5px solid #3B82F6',
                                                            borderRadius: '6px',
                                                            cursor: 'pointer',
                                                            color: '#3B82F6',
                                                            fontSize: '13px',
                                                            fontWeight: 500,
                                                            padding: '0.3rem 1.2rem'
                                                        },
                                                        children: "Minimize"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group 1000002103-1733923364928.png",
                                alt: "messageLadie",
                                className: "girlImage1"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a10507f36b291885$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0cbd065623d03bb9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "popup-message",
                style: {
                    zIndex: '10000'
                },
                className: "zi5 shadow hidden bg4 c1 td500 pf b0 l0 mb2rem btrr5px bbrr5px pt0-5rem pb0-5rem pl1rem pr1rem fs1-5rem fw600"
            }),
            tooltip && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: tooltip.id,
                className: "shadow pen td100 pf p0-5rem br5px c6 fw500 backdrop zi5 px0-5rem py0-5rem",
                style: {
                    zIndex: '1500',
                    top: tooltip.y + 'px',
                    left: tooltip.x + 'px',
                    background: '#fff'
                },
                dangerouslySetInnerHTML: {
                    __html: tooltip.html
                }
            }),
            totalFile > 0 || type == "syncingFolders" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eea7011072ddb57e$export$2e2bcd8739ae039), {
                data: data,
                totalFile: totalFile
            }) : '',
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $980eb83ab9562f3a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dd7dfe5a585e9490$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "setPasswordPopup",
                open: modal['open'] == 'setPasswordPopup',
                onClose: ()=>{},
                className: "backdrop td500 zi4 pf t0 l0 w100vw df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style bg1 shadow df fdc aic m1rem br20px",
                    style: {
                        outline: 'none',
                        padding: '2rem',
                        maxWidth: '480px',
                        width: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "mb1-5rem",
                            src: (parcelRequire("bJ68K")),
                            alt: "",
                            style: {
                                width: '60px',
                                height: '60px',
                                objectFit: 'contain'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-75rem fw600 c15 tac mb0-5rem",
                            children: "Set Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-875rem fw400 c28 tac mb1-5rem",
                            children: "Choose a strong password for your account"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 pr mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    id: "setNewPassword",
                                    className: "df w100",
                                    placeholder: "New Password",
                                    value: setPasswordFields['newPassword'],
                                    type: setPasswordFields['newPasswordType'] ? 'password' : 'text',
                                    onChange: (e)=>{
                                        setSetPasswordFields({
                                            ...setPasswordFields,
                                            newPassword: e['target']['value']
                                        });
                                        setSetPasswordError('');
                                    },
                                    helperText: setPasswordError,
                                    FormHelperTextProps: {
                                        sx: {
                                            width: '100%',
                                            color: 'red',
                                            fontStyle: 'italic'
                                        }
                                    }
                                }),
                                setPasswordFields['newPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    onClick: ()=>setSetPasswordFields({
                                            ...setPasswordFields,
                                            newPasswordType: !setPasswordFields['newPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-35%)',
                                        right: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                        fill: "#404040"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    onClick: ()=>setSetPasswordFields({
                                            ...setPasswordFields,
                                            newPasswordType: !setPasswordFields['newPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-50%)',
                                        right: '12px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                            fill: "#404040"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                            fill: "#404040"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 pr mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    id: "setConfirmPassword",
                                    className: "df w100",
                                    placeholder: "Confirm Password",
                                    value: setPasswordFields['confirmPassword'],
                                    type: setPasswordFields['confirmPasswordType'] ? 'password' : 'text',
                                    onChange: (e)=>{
                                        setSetPasswordFields({
                                            ...setPasswordFields,
                                            confirmPassword: e['target']['value']
                                        });
                                        setSetPasswordError('');
                                    },
                                    helperText: setPasswordError,
                                    FormHelperTextProps: {
                                        sx: {
                                            width: '100%',
                                            color: 'red',
                                            fontStyle: 'italic'
                                        }
                                    }
                                }),
                                setPasswordFields['confirmPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    onClick: ()=>setSetPasswordFields({
                                            ...setPasswordFields,
                                            confirmPasswordType: !setPasswordFields['confirmPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-35%)',
                                        right: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                        fill: "#404040"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    onClick: ()=>setSetPasswordFields({
                                            ...setPasswordFields,
                                            confirmPasswordType: !setPasswordFields['confirmPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-50%)',
                                        right: '12px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                            fill: "#404040"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                            fill: "#404040"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "w100 fs12px fw400 c28 mb1-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fas fa-info-circle mr0-5rem"
                                }),
                                "Must include uppercase, lowercase, number & special character"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>handleSetPassword(),
                            className: `w100 df aic jcc c1 fw500 fs14px br50px py0-75rem ${setPasswordFields['newPassword'] == '' || setPasswordFields['confirmPassword'] == '' ? 'bg12' : 'cp bg3'}`,
                            children: "Set Password"
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");







var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ab8dae130526a9ed$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $db36f493660c6a2d$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');


const $b2e7a02006d70e66$var$KOALENDAR = "https://koalendar.com/e/meet-with-mark-bernstein";
const $b2e7a02006d70e66$var$Chevron = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "6 9 12 15 18 9"
        })
    });



function $b2e7a02006d70e66$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const isPartnerChecklist = location.pathname.startsWith('/partnerChecklist/');
    const isCompleteInvestmentPage = location.pathname.startsWith('/completeInvestment');
    const isClimb26LandingPage = location.pathname.includes('climb26') || location.pathname.includes('climb');
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const [isScrolled, setIsScrolled] = (0, $acw62.useState)(false);
    const [mobileOpen, setMobileOpen] = (0, $acw62.useState)(false);
    const [openDD, setOpenDD] = (0, $acw62.useState)('');
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    (0, $acw62.useEffect)(()=>{
        if (localStorage.getItem("token")) {
            getUser();
            checkLogin();
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onScroll = ()=>setIsScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        onScroll();
        return ()=>window.removeEventListener("scroll", onScroll);
    }, []);
    // lock body scroll when the mobile drawer is open
    (0, $acw62.useEffect)(()=>{
        document.body.style.overflow = mobileOpen ? 'hidden' : '';
        return ()=>{
            document.body.style.overflow = '';
        };
    }, [
        mobileOpen
    ]);
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        if (response['code'] == 200 && response['body']) {
            user = response['body']['user'];
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
        }
    };
    const checkLogin = async ()=>await (0, $bebe1cbb5a309c8c$export$e17608451341e929)("/user/checkLogin");
    const handleLoginRegister = ()=>{
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        if (mobileRegex.test(userAgent)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You can Login/Register on Laptop");
    };
    const handleDashboardClick = (e)=>{
        if (isCompleteInvestmentPage) {
            e.preventDefault();
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'setPasswordPopup'
            }));
        }
        setMobileOpen(false);
    };
    const redirectDashbaord = ()=>{
        if (!user?.['_id']) return;
        const urlParams = new URLSearchParams(window.location.search);
        const pathname = window.location.pathname;
        let companyId = urlParams.get('companyId');
        if (companyId && companyId.includes(';')) companyId = companyId.split(';')[0];
        if (pathname.includes('createChecklist') && companyId) return `/company/${companyId}`;
        if (pathname.includes('researchAid/')) {
            const researchAidCompanyId = pathname.split('researchAid/')[1]?.split('?')[0];
            if (researchAidCompanyId) return `/company/${researchAidCompanyId}`;
        }
        if (user['role'] == 'Guest') return $16250bd714b02a14$export$51e82cdd7353a0e1;
        else if (user['role'] == 'Advisor') return $16250bd714b02a14$export$fa573b5b2799a94a;
        else if (user['role'] == 'Investor') return $16250bd714b02a14$export$c45d6aa39a7ae97c;
        else return $16250bd714b02a14$export$4695c1a423ffe431;
    };
    const isActive = (path)=>location.pathname === path;
    const closeAll = ()=>{
        setMobileOpen(false);
        setOpenDD('');
    };
    // Routes redesigned to the new landing system opt into the transparent-over-hero
    // navbar. Every other landing page keeps a solid bar + spacer so the fixed
    // header never overlaps content until that page is redesigned too.
    const REDESIGNED_ROUTES = [
        $16250bd714b02a14$export$a7c5707626fc90f,
        $16250bd714b02a14$export$635fd87e6c3d3ece,
        $16250bd714b02a14$export$babdbb7ea7999cc6,
        $16250bd714b02a14$export$9c09018d5bb1154,
        $16250bd714b02a14$export$9eeeba16e1010f7f,
        $16250bd714b02a14$export$5d923b12188e7414,
        $16250bd714b02a14$export$20de159c79d2d5f2
    ];
    const isRedesigned = REDESIGNED_ROUTES.includes(location.pathname);
    // ---- minimal in-flow bars for special contexts ----
    if (isPartnerChecklist) return /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
        className: "nav2 is-scrolled",
        style: {
            position: 'relative'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "nav2-inner",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "nav2-logo",
                to: $16250bd714b02a14$export$a7c5707626fc90f,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("lm8C6")),
                    alt: "Diligentsia"
                })
            })
        })
    });
    if (isClimb26LandingPage) return /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
        className: "nav2",
        style: {
            position: 'relative',
            background: '#151313',
            boxShadow: 'none'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "nav2-inner",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "nav2-logo",
                to: $16250bd714b02a14$export$a7c5707626fc90f,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("kIY17")),
                    alt: "Diligentsia"
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: `nav2 ${isScrolled || mobileOpen || !isRedesigned ? 'is-scrolled' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "nav2-inner",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "nav2-logo",
                                to: $16250bd714b02a14$export$a7c5707626fc90f,
                                onClick: closeAll,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("lm8C6")),
                                    alt: "Diligentsia"
                                })
                            }),
                            !isClimb26LandingPage && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "nav2-links",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: `nav2-link ${isActive($16250bd714b02a14$export$babdbb7ea7999cc6) ? 'is-active' : ''}`,
                                                to: $16250bd714b02a14$export$babdbb7ea7999cc6,
                                                children: "Companies"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "nav2-dd",
                                                onMouseEnter: ()=>setOpenDD('advisors'),
                                                onMouseLeave: ()=>setOpenDD(''),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "nav2-link",
                                                        children: [
                                                            "Advisors ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($b2e7a02006d70e66$var$Chevron, {})
                                                        ]
                                                    }),
                                                    openDD === 'advisors' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "nav2-dd-menu",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: isActive($16250bd714b02a14$export$9c09018d5bb1154) ? 'is-active' : '',
                                                                to: $16250bd714b02a14$export$9c09018d5bb1154,
                                                                children: "Fractional CFOs"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: isActive($16250bd714b02a14$export$5d923b12188e7414) ? 'is-active' : '',
                                                                to: $16250bd714b02a14$export$5d923b12188e7414,
                                                                children: "Accountants"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: isActive($16250bd714b02a14$export$20de159c79d2d5f2) ? 'is-active' : '',
                                                                to: $16250bd714b02a14$export$20de159c79d2d5f2,
                                                                children: "PISCES"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "nav2-dd",
                                                onMouseEnter: ()=>setOpenDD('investor'),
                                                onMouseLeave: ()=>setOpenDD(''),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "nav2-link",
                                                        children: [
                                                            "Investor ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($b2e7a02006d70e66$var$Chevron, {})
                                                        ]
                                                    }),
                                                    openDD === 'investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "nav2-dd-menu",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: isActive($16250bd714b02a14$export$2c56bebcf5dc2850) ? 'is-active' : '',
                                                                to: $16250bd714b02a14$export$2c56bebcf5dc2850,
                                                                children: "Venture Capital"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: isActive($16250bd714b02a14$export$fa0d235fc547c669) ? 'is-active' : '',
                                                                to: $16250bd714b02a14$export$fa0d235fc547c669,
                                                                children: "Private Equity"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: isActive($16250bd714b02a14$export$9eeeba16e1010f7f) ? 'is-active' : '',
                                                                to: $16250bd714b02a14$export$9eeeba16e1010f7f,
                                                                children: "Angel Networks"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: isActive($16250bd714b02a14$export$6e733a82d8c11460) ? 'is-active' : '',
                                                                to: $16250bd714b02a14$export$6e733a82d8c11460,
                                                                children: "Accelerators & Venture Studios"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: `nav2-link ${isActive($16250bd714b02a14$export$bcdbe1127ca0dc8c) ? 'is-active' : ''}`,
                                                to: $16250bd714b02a14$export$bcdbe1127ca0dc8c,
                                                children: "Pricing"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: `nav2-link ${isActive($16250bd714b02a14$export$3dad34f770fcb308) ? 'is-active' : ''}`,
                                                to: $16250bd714b02a14$export$3dad34f770fcb308,
                                                children: "About Us"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: `nav2-link ${isActive($16250bd714b02a14$export$d37021401d41152) ? 'is-active' : ''}`,
                                                to: $16250bd714b02a14$export$d37021401d41152,
                                                children: "Partners"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: `nav2-link ${isActive($16250bd714b02a14$export$8bb39b3eb744faa7) ? 'is-active' : ''}`,
                                                to: $16250bd714b02a14$export$8bb39b3eb744faa7,
                                                children: "Community"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: `nav2-link ${isActive($16250bd714b02a14$export$ce939e14da856e20) ? 'is-active' : ''}`,
                                                to: $16250bd714b02a14$export$ce939e14da856e20,
                                                children: "Resources"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "nav2-cta-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                className: "nav2-btn nav2-btn--primary",
                                                href: $b2e7a02006d70e66$var$KOALENDAR,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Book a call"
                                            }),
                                            loggedIn ? user['type'] == 'External' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "nav2-btn nav2-btn--outline",
                                                onClick: ()=>(0, $bebe1cbb5a309c8c$export$5863150075eb9294)(),
                                                children: "Logout"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        className: "nav2-btn nav2-btn--ghost",
                                                        onClick: handleDashboardClick,
                                                        to: isCompleteInvestmentPage ? '#' : redirectDashbaord(),
                                                        style: user['role'] == 'Guest' ? {
                                                            pointerEvents: 'none',
                                                            opacity: .5
                                                        } : {},
                                                        children: "Dashboard"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "nav2-btn nav2-btn--outline",
                                                        onClick: ()=>{
                                                            user['role'] != 'Guest' && (0, $bebe1cbb5a309c8c$export$5863150075eb9294)();
                                                        },
                                                        children: "Logout"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        className: "nav2-btn nav2-btn--ghost",
                                                        to: $16250bd714b02a14$export$eed606b4351295d7,
                                                        onClick: handleLoginRegister,
                                                        children: "Login"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        className: "nav2-btn nav2-btn--outline",
                                                        to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                                        onClick: ()=>{
                                                            localStorage.removeItem('registerAs');
                                                            handleLoginRegister();
                                                        },
                                                        children: "Register"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "nav2-hamburger",
                                        "aria-label": "Menu",
                                        onClick: ()=>setMobileOpen((o)=>!o),
                                        children: mobileOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab8dae130526a9ed$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db36f493660c6a2d$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    !isClimb26LandingPage && mobileOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "nav2-mobile",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: isActive($16250bd714b02a14$export$babdbb7ea7999cc6) ? 'is-active' : '',
                                to: $16250bd714b02a14$export$babdbb7ea7999cc6,
                                onClick: closeAll,
                                children: "Companies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: isActive($16250bd714b02a14$export$9c09018d5bb1154) ? 'is-active' : '',
                                to: $16250bd714b02a14$export$9c09018d5bb1154,
                                onClick: closeAll,
                                children: "Fractional"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$5d923b12188e7414,
                                onClick: closeAll,
                                children: "Accountants"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$20de159c79d2d5f2,
                                onClick: closeAll,
                                children: "PISCES"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$2c56bebcf5dc2850,
                                onClick: closeAll,
                                children: "Venture Capital"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$fa0d235fc547c669,
                                onClick: closeAll,
                                children: "Private Equity"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$9eeeba16e1010f7f,
                                onClick: closeAll,
                                children: "Angel Networks"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$6e733a82d8c11460,
                                onClick: closeAll,
                                children: "Accelerators & Venture Studios"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$bcdbe1127ca0dc8c,
                                onClick: closeAll,
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$3dad34f770fcb308,
                                onClick: closeAll,
                                children: "About Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$d37021401d41152,
                                onClick: closeAll,
                                children: "Partner"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$1473cb2f5aa9c69d,
                                onClick: closeAll,
                                children: "Webinar"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$8bb39b3eb744faa7,
                                onClick: closeAll,
                                children: "Community"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: $16250bd714b02a14$export$ce939e14da856e20,
                                onClick: closeAll,
                                children: "Resources"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "nav2-mobile-cta",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "p",
                                        href: $b2e7a02006d70e66$var$KOALENDAR,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Book a call"
                                    }),
                                    loggedIn ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "g",
                                        to: isCompleteInvestmentPage ? '#' : redirectDashbaord(),
                                        onClick: handleDashboardClick,
                                        children: "Dashboard"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "g",
                                        to: $16250bd714b02a14$export$eed606b4351295d7,
                                        onClick: ()=>{
                                            handleLoginRegister();
                                            closeAll();
                                        },
                                        children: "Login"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isRedesigned && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    height: 72
                },
                "aria-hidden": "true"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


// Landing pages rebuilt to the new design get the dark footer (matches the design system)
const $f5e6b7f8047c4b0f$var$DARK_FOOTER_ROUTES = [
    $16250bd714b02a14$export$a7c5707626fc90f,
    $16250bd714b02a14$export$635fd87e6c3d3ece,
    $16250bd714b02a14$export$babdbb7ea7999cc6,
    $16250bd714b02a14$export$9c09018d5bb1154,
    $16250bd714b02a14$export$9eeeba16e1010f7f,
    $16250bd714b02a14$export$5d923b12188e7414,
    $16250bd714b02a14$export$20de159c79d2d5f2,
    $16250bd714b02a14$export$2c56bebcf5dc2850,
    $16250bd714b02a14$export$fa0d235fc547c669,
    $16250bd714b02a14$export$bcdbe1127ca0dc8c,
    $16250bd714b02a14$export$3dad34f770fcb308,
    $16250bd714b02a14$export$ce939e14da856e20,
    $16250bd714b02a14$export$d37021401d41152,
    $16250bd714b02a14$export$8bb39b3eb744faa7,
    $16250bd714b02a14$export$6e733a82d8c11460
];
const $f5e6b7f8047c4b0f$var$SOCIAL_HANDLER = [
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 15 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    "clip-path": "url(#clip0_1105_22101)",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M13.2513 15H1.74885C0.782953 15 0 14.2171 0 13.2512V1.74883C0 0.782944 0.782953 0 1.74885 0H13.2511C14.217 0 15 0.782944 15 1.74883V13.251C15.0002 14.2171 14.2172 15 13.2513 15Z",
                            fill: "black",
                            stroke: "white",
                            "stroke-miterlimit": "10"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.40132 2.54297L6.5778 7.96445L2.375 12.3722H3.32096L7.00059 8.51306L9.97352 12.3722H13.1924L8.78086 6.64587L12.6928 2.54297H11.7469L8.35825 6.09707L5.62023 2.54297H2.40132ZM3.79239 3.21953H5.27114L11.8012 11.6958H10.3224L3.79239 3.21953Z",
                            fill: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_1105_22101",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "15",
                            height: "15",
                            fill: "white"
                        })
                    })
                })
            ]
        }),
        link: 'https://twitter.com/DiligentsiaDD'
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "cp",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    "clip-path": "url(#clip0_0_2199)",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7.63281 19V8.87953H4.20251V19H7.63281ZM5.9181 7.49692C7.11431 7.49692 7.85889 6.71978 7.85889 5.74862C7.8366 4.75556 7.11436 4 5.9408 4C4.76743 4 4.00012 4.75558 4.00012 5.74862C4.00012 6.71983 4.74452 7.49692 5.89571 7.49692H5.918H5.9181ZM9.53147 19H12.9618V13.3482C12.9618 13.0458 12.9841 12.7436 13.0746 12.5274C13.3226 11.923 13.8871 11.2971 14.8346 11.2971C16.0759 11.2971 16.5725 12.2252 16.5725 13.5857V18.9999H20.0026V13.1969C20.0026 10.0883 18.3103 8.64193 16.0533 8.64193C14.2028 8.64193 13.3903 9.65626 12.939 10.3471H12.9619V8.87932H9.53155C9.57657 9.82897 9.53155 18.9998 9.53155 18.9998L9.53147 19Z",
                        fill: "#0A66C2"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_0_2199",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "16",
                            height: "15",
                            fill: "white",
                            transform: "translate(4.00012 4)"
                        })
                    })
                })
            ]
        }),
        link: 'https://www.linkedin.com/company/98930154'
    }
];


const $f5e6b7f8047c4b0f$var$AddressLogo = ({ dark: dark })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "footer-column py1rem px2rem-md px2rem-xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: $16250bd714b02a14$export$a7c5707626fc90f,
                    children: dark ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "mb2rem h3rem",
                        src: (parcelRequire("kIY17")),
                        alt: "Diligentsia"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "mb2rem h3rem",
                        src: (parcelRequire("aR1CT")),
                        alt: "TODO"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "mb2rem w62 fw400 fs0-875rem lh3 c15",
                    children: [
                        "Diligentsia Limited is registered in England & Wales",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Company Number 14256673",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "VAT number: GB 426 4891 73"
                    ]
                })
            ]
        })
    });
};
function $f5e6b7f8047c4b0f$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const isDark = $f5e6b7f8047c4b0f$var$DARK_FOOTER_ROUTES.includes(location.pathname);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("footer", {
        className: `w100 zi-1 b0 l0 bg1 ${isDark ? 'lp-footer-dark' : ''}`,
        children: [
            window.innerWidth < 992 && /*#__PURE__*/ (0, $ayMG0.jsx)($f5e6b7f8047c4b0f$var$AddressLogo, {
                dark: isDark
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "container px5rem py2rem pt0rem-md dg footar-saf gtcr3a-md gtccr-xl",
                children: [
                    window.innerWidth > 992 && /*#__PURE__*/ (0, $ayMG0.jsx)($f5e6b7f8047c4b0f$var$AddressLogo, {
                        dark: isDark
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "footer-column p0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "p0-5rem fw600 fs1-25rem c15 lh3",
                                children: "Quick Links"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover w80 fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$3dad34f770fcb308,
                                children: "About Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover w80 fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$bcdbe1127ca0dc8c,
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover w80 fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$f8b031824e68df83,
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover w80 fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$f43de61a26b1e3d1,
                                children: "Terms & Conditions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover w80 fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$79ffb24037556cb1,
                                children: "Policies"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "footer-column p0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "p0-5rem fw600 fs1-25rem c15 lh3",
                                children: "Customers"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$7d34e7fbe54f4a80,
                                children: "Companies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$9c09018d5bb1154,
                                children: "Fractional CFOs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$5d923b12188e7414,
                                children: "Accountants"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$20de159c79d2d5f2,
                                children: "PISCES"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$9eeeba16e1010f7f,
                                children: "Angel Networks"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$2c56bebcf5dc2850,
                                children: "Venture Capital Firms"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$fa0d235fc547c669,
                                children: "Private Equity Firms"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "footer-column p0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "p0-5rem fw600 fs1-25rem c15 lh3",
                                children: "Partner Programmes"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                target: "_blank",
                                href: `https://diligentsia.mintlify.app/get-started`,
                                children: "Developer API"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$d37021401d41152,
                                children: "Co-branded Partner Modules"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$d37021401d41152,
                                children: "Joint Marketing Campaigns"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "db cpflp td250 c4-hover fw400 fs0-875rem lh3 c15",
                                to: $16250bd714b02a14$export$d37021401d41152,
                                children: "Targeted Partner Checklists"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "footer-column p0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "p0-5rem fw600 fs1-25rem c15 lh3",
                                children: "Social media"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df aic gg1rem pl1rem",
                                children: $f5e6b7f8047c4b0f$var$SOCIAL_HANDLER.map((obj, i, arr)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc",
                                        style: {
                                            width: '7%'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: obj?.link,
                                            target: "_blank",
                                            children: obj?.icon
                                        })
                                    });
                                })
                            })
                        ]
                    })
                ]
            }),
            isDark && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-footer-bottom container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "\xa9 Diligentsia 2026. All rights reserved."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Not FCA regulated. AI can make mistakes; all outputs are human-reviewed."
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/*
  Detect and load appropriate clock setting for the execution environment
 */ const $97767d026c4510a8$export$f8caf8121275292d = 1 / 60 * 1000;
const $97767d026c4510a8$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $97767d026c4510a8$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($97767d026c4510a8$var$getCurrentTime()), $97767d026c4510a8$export$f8caf8121275292d);


function $84275669f74db65a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */ let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $b54248de5cdf5520$export$fff89137e9e818ce = {
    delta: 0,
    timestamp: 0
};


const $b4999b8a0b43adc6$var$maxElapsed = 40;
let $b4999b8a0b43adc6$var$useDefaultElapsed = true;
let $b4999b8a0b43adc6$var$runNextFrame = false;
let $b4999b8a0b43adc6$var$isProcessing = false;
const $b4999b8a0b43adc6$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $b4999b8a0b43adc6$var$steps = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $84275669f74db65a$export$b995e5e85f5c8289)(()=>$b4999b8a0b43adc6$var$runNextFrame = true);
    return acc;
}, {});
const $b4999b8a0b43adc6$export$92d6409d68f0739a = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    const step = $b4999b8a0b43adc6$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$b4999b8a0b43adc6$var$runNextFrame) $b4999b8a0b43adc6$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $b4999b8a0b43adc6$export$d93e9c1fe0553512 = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $b4999b8a0b43adc6$var$steps[key].cancel;
    return acc;
}, {});
const $b4999b8a0b43adc6$export$cd75ccfd720a3cd4 = $b4999b8a0b43adc6$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$b4999b8a0b43adc6$var$steps[key].process((0, $b54248de5cdf5520$export$fff89137e9e818ce));
    return acc;
}, {});
const $b4999b8a0b43adc6$var$processStep = (stepId)=>$b4999b8a0b43adc6$var$steps[stepId].process((0, $b54248de5cdf5520$export$fff89137e9e818ce));
const $b4999b8a0b43adc6$var$processFrame = (timestamp)=>{
    $b4999b8a0b43adc6$var$runNextFrame = false;
    (0, $b54248de5cdf5520$export$fff89137e9e818ce).delta = $b4999b8a0b43adc6$var$useDefaultElapsed ? (0, $97767d026c4510a8$export$f8caf8121275292d) : Math.max(Math.min(timestamp - (0, $b54248de5cdf5520$export$fff89137e9e818ce).timestamp, $b4999b8a0b43adc6$var$maxElapsed), 1);
    (0, $b54248de5cdf5520$export$fff89137e9e818ce).timestamp = timestamp;
    $b4999b8a0b43adc6$var$isProcessing = true;
    $b4999b8a0b43adc6$var$stepsOrder.forEach($b4999b8a0b43adc6$var$processStep);
    $b4999b8a0b43adc6$var$isProcessing = false;
    if ($b4999b8a0b43adc6$var$runNextFrame) {
        $b4999b8a0b43adc6$var$useDefaultElapsed = false;
        (0, $97767d026c4510a8$export$4fdea63ab5513fd5)($b4999b8a0b43adc6$var$processFrame);
    }
};
const $b4999b8a0b43adc6$var$startLoop = ()=>{
    $b4999b8a0b43adc6$var$runNextFrame = true;
    $b4999b8a0b43adc6$var$useDefaultElapsed = true;
    if (!$b4999b8a0b43adc6$var$isProcessing) (0, $97767d026c4510a8$export$4fdea63ab5513fd5)($b4999b8a0b43adc6$var$processFrame);
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $9c674755a93db746$export$700979bc83e7db82 = (0, $784730508f12f72c$export$4e09c449d6c407f7) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


function $c0a2e592950340df$export$80c2a3957bcb42ea() {
    const isMounted = (0, $acw62.useRef)(false);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


function $0316e1262c81ebb4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $acw62.useState)(0);
    const forceRender = (0, $acw62.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $acw62.useCallback)(()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);



var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    const ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $6f8c626e496e1918$var$PopChildMeasure extends $acw62.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $6f8c626e496e1918$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $acw62.useId)();
    const ref = (0, $acw62.useRef)(null);
    const size = (0, $acw62.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $acw62.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $acw62.createElement($6f8c626e496e1918$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $acw62.cloneElement(children, {
        ref: ref
    }));
}


const $f57f9e9f321f3a7c$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $40f5fd83135889a9$export$fe4300aa8eebea86)($f57f9e9f321f3a7c$var$newChildrenMap);
    const id = (0, $acw62.useId)();
    const context = (0, $acw62.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $acw62.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $acw62.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $acw62.createElement((0, $6f8c626e496e1918$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $acw62.createElement((0, $dba5d94a982c4145$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $f57f9e9f321f3a7c$var$newChildrenMap() {
    return new Map();
}



var $acw62 = parcelRequire("acw62");
const $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});




var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(()=>()=>callback(), []);
}



const $06516233abcfeeff$var$getChildKey = (child)=>child.key || "";
function $06516233abcfeeff$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $06516233abcfeeff$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $06516233abcfeeff$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $acw62.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $06516233abcfeeff$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    // Support deprecated exitBeforeEnter prop
    if (exitBeforeEnter) mode = "wait";
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    let [forceRender] = (0, $0316e1262c81ebb4$export$91db9bc4f8ac944a)();
    const forceRenderLayoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    const isMounted = (0, $c0a2e592950340df$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $06516233abcfeeff$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $acw62.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $acw62.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $acw62.useRef)(true);
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $06516233abcfeeff$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $7bbbf777b15ef7cf$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) return $acw62.createElement($acw62.Fragment, null, childrenToRender.map((child)=>$acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($06516233abcfeeff$var$getChildKey);
    const targetKeys = filteredChildren.map($06516233abcfeeff$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach((key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        const onExit = ()=>{
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exiting.has(key) ? child : $acw62.createElement((0, $f57f9e9f321f3a7c$export$979daf65881a382a), {
            key: $06516233abcfeeff$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $acw62.createElement($acw62.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map((child)=>(0, $acw62.cloneElement)(child)));
};





var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ const $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $acw62 = parcelRequire("acw62");
const $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});
function $3ce32ada97cfc8f7$export$cd995842eb2ab956() {
    return (0, $acw62.useContext)($3ce32ada97cfc8f7$export$2285bbca2c666415).visualElement;
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});



function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const parent = (0, $3ce32ada97cfc8f7$export$cd995842eb2ab956)();
    const lazyContext = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171));
    const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $acw62.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $acw62.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    (0, $9c674755a93db746$export$700979bc83e7db82)(()=>{
        visualElement && visualElement.render();
    });
    (0, $acw62.useEffect)(()=>{
        visualElement && visualElement.updateFeatures();
    });
    /**
     * Ideally this function would always run in a useEffect.
     *
     * However, if we have optimised appear animations to handoff from,
     * it needs to happen synchronously to ensure there's no flash of
     * incorrect styles in the event of a hydration error.
     *
     * So if we detect a situtation where optimised appear animations
     * are running, we use useLayoutEffect to trigger animations.
     */ const useAnimateChangesEffect = window.HandoffAppearAnimations ? (0, $9c674755a93db746$export$700979bc83e7db82) : (0, $acw62.useEffect);
    useAnimateChangesEffect(()=>{
        if (visualElement && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    return visualElement;
}



var $acw62 = parcelRequire("acw62");
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d157673547c2a934$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $acw62 = parcelRequire("acw62");

/**
 * Decides if the supplied variable is variant label
 */ function $a35be4d5814e7c66$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $0172fb3d3512f551$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $0172fb3d3512f551$export$1405a65085f40b9 = [
    "initial",
    ...$0172fb3d3512f551$export$16e45afcc206d3a8
];


function $06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) {
    return (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(props.animate) || (0, $0172fb3d3512f551$export$1405a65085f40b9).some((name)=>(0, $a35be4d5814e7c66$export$720b90e312cea233)(props[name]));
}
function $06b1046bf0f33e63$export$ce46fa4165cdec40(props) {
    return Boolean($06b1046bf0f33e63$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $a35be4d5814e7c66$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $a35be4d5814e7c66$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e57028cf0cad086$export$12fc32fc096a04a3)(props, (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415)));
    return (0, $acw62.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $a8d82256030e9525$var$featureProps = {
    animation: [
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $a8d82256030e9525$export$65570e08d843624d = {};
for(const key in $a8d82256030e9525$var$featureProps)$a8d82256030e9525$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$a8d82256030e9525$var$featureProps[key].some((name)=>!!props[name])
};


function $b9879783068c1762$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $a8d82256030e9525$export$65570e08d843624d)[key] = {
        ...(0, $a8d82256030e9525$export$65570e08d843624d)[key],
        ...features[key]
    };
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};


let $050be86dbc9816d5$var$id = 1;
function $050be86dbc9816d5$export$5ed57b87c18af11a() {
    return (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(()=>{
        if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated) return $050be86dbc9816d5$var$id++;
    });
}





var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ const $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});


const $9b94ea54d3350cc1$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $b9879783068c1762$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $acw62.useContext)((0, $3bbbde5b328b4154$export$22a697fb29aac98d)),
            ...props,
            layoutId: $b40dad60036091a1$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $4cb87fa0b981df8c$export$c5638d843b37a176)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ const projectionId = isStatic ? undefined : (0, $050be86dbc9816d5$export$5ed57b87c18af11a)();
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $784730508f12f72c$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7fb0f4644b9cc8ad$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a));
            const isStrict = (0, $acw62.useContext)((0, $410b846e117db9e1$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, projectionId, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $3ce32ada97cfc8f7$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $acw62.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, projectionId, (0, $88efa764bb00537b$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $acw62.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $9b94ea54d3350cc1$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $b40dad60036091a1$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $1d85745fbdd79bfa$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $ac502869c4d3e65a$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ac502869c4d3e65a$export$7b42a0094fb00b6e = new Set($ac502869c4d3e65a$export$280dc01950909d86);


function $443c859766df5778$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $eced91e16bda42df$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $55c3387a92452647$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $1724c99b9b724858$var$numTransforms = (0, $ac502869c4d3e65a$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $1724c99b9b724858$var$numTransforms; i++){
        const key = (0, $ac502869c4d3e65a$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $1724c99b9b724858$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $f9c5e88311214d2a$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $f9c5e88311214d2a$export$9de1236619d9e756 = $f9c5e88311214d2a$var$checkStringStartsWith("--");
const $f9c5e88311214d2a$export$31f9caa2600b5723 = $f9c5e88311214d2a$var$checkStringStartsWith("var(--");



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $a19b1277e1098e3a$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $965bce4b5aab9d94$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $965bce4b5aab9d94$export$58f0f39f63f3cf42 = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    transform: (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $965bce4b5aab9d94$export$dcdf75081b88279d = {
    ...$965bce4b5aab9d94$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $9d068be114f1d873$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $9d068be114f1d873$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $9d068be114f1d873$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $9d068be114f1d873$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $9d068be114f1d873$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $25ca921ba8e55794$var$createUnitType = (unit)=>({
        test: (v)=>(0, $9d068be114f1d873$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $25ca921ba8e55794$export$41fc368e1a942b97 = $25ca921ba8e55794$var$createUnitType("deg");
const $25ca921ba8e55794$export$626336c2cd4b14de = $25ca921ba8e55794$var$createUnitType("%");
const $25ca921ba8e55794$export$91c0eda1d06bf008 = $25ca921ba8e55794$var$createUnitType("px");
const $25ca921ba8e55794$export$f91e8c45a95a32f2 = $25ca921ba8e55794$var$createUnitType("vh");
const $25ca921ba8e55794$export$aed3d7b7d206c196 = $25ca921ba8e55794$var$createUnitType("vw");
const $25ca921ba8e55794$export$44e2e1705876d7ed = {
    ...$25ca921ba8e55794$export$626336c2cd4b14de,
    parse: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$25ca921ba8e55794$export$626336c2cd4b14de.transform(v * 100)
};



const $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: Math.round
};


const $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRightWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    radius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxWidth: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    height: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    maxHeight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    size: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    top: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    right: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    bottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    left: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    paddingLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    margin: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginTop: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginRight: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginBottom: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    marginLeft: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    rotateZ: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    scale: $965bce4b5aab9d94$export$dcdf75081b88279d,
    scaleX: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleY: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    scaleZ: (0, $965bce4b5aab9d94$export$dcdf75081b88279d),
    skew: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewX: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    skewY: (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    distance: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateX: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateY: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    translateZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    x: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    y: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    z: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    perspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    transformPerspective: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    opacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    originX: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originY: (0, $25ca921ba8e55794$export$44e2e1705876d7ed),
    originZ: (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $965bce4b5aab9d94$export$58f0f39f63f3cf42),
    numOctaves: (0, $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e)
};


function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $a19b1277e1098e3a$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $1724c99b9b724858$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $57bb451bc3d87577$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $55c3387a92452647$export$605d60a2578142d3)(source[key]) && !(0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $acw62.useMemo)(()=>{
        const state = (0, $57bb451bc3d87577$export$8940b483cf52eeda)();
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $81d8dfeeb8038b0d$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $c4bee6acbf082b7d$var$validMotionProps.has(key);
}


let $05db6db4ebcdf5f1$var$shouldForward = (key)=>!(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key);
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("8RYFI")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || !isDom && !(0, $c4bee6acbf082b7d$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $acw62 = parcelRequire("acw62");



function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $25ca921ba8e55794$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2860344bf6c6c49f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f5fdba1fd96a9ba7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $b7a2547211637b3c$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $57bb451bc3d87577$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $c139bf35362d2174$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $acw62.useMemo)(()=>{
        const state = (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9)();
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $81d8dfeeb8038b0d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, projectionId, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $268dc116ac4d3a3d$export$84309c4f53cb1bd5) : (0, $81d8dfeeb8038b0d$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $05db6db4ebcdf5f1$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $acw62.useMemo)(()=>(0, $55c3387a92452647$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $acw62.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $9dc069bda924fd3f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $a8ee53e44f8c4ac8$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $55c3387a92452647$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps.style[key]) || (0, $443c859766df5778$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}


function $eac085b45c9e0925$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $55c3387a92452647$export$605d60a2578142d3)(props[key]) || (0, $55c3387a92452647$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $acw62 = parcelRequire("acw62");


function $abbf779fde460163$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



const $ef59b2359a289b82$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $21f654501c04362b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $21f654501c04362b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $55c3387a92452647$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $21f654501c04362b$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $5c26ebcca6422185$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $5c26ebcca6422185$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $acw62.useContext)((0, $3ce32ada97cfc8f7$export$2285bbca2c666415));
        const presenceContext = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
        const make = ()=>$5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $40f5fd83135889a9$export$fe4300aa8eebea86)(make);
    };
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $eac085b45c9e0925$export$16da615486abaa45),
        createRenderState: (0, $b7a2547211637b3c$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
            (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





const $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $5c26ebcca6422185$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $a8ee53e44f8c4ac8$export$16da615486abaa45,
        createRenderState: (0, $57bb451bc3d87577$export$8940b483cf52eeda)
    })
};


function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? (0, $fde6d634ecc7ed6c$export$44dabd3fae512e85) : (0, $dcb38e10dcfb6316$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dc80cb5954e76638$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $43ace1b5a11c3a40$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $6b2f8b101475710a$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $23ab615c547792c0$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event) && handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
};


function $7fd40e38993f1c69$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(target, eventName, (0, $23ab615c547792c0$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $21841eadb135946f$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $21841eadb135946f$export$a4627e546088548d = (...transformers)=>transformers.reduce($21841eadb135946f$var$combineFunctions);


function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
const $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        const openHorizontal = $df8cc4eab047d382$var$globalHorizontalLock();
        const openVertical = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $5b9241b1e863e695$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


function $dfb80d799aa36175$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $df8cc4eab047d382$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) props[callbackName](event, info);
    };
    return (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $dfb80d799aa36175$export$93a81ea037eac456 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)($dfb80d799aa36175$var$addHoverEvent(this.node, true), $dfb80d799aa36175$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $46d14c2f8ccf5da4$export$d4826db40d47595b extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $21841eadb135946f$export$a4627e546088548d)((0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $ae5289b89bf4fd95$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};


const $448ce039afb5ec07$export$8793edee2d425525 = (any)=>any;


function $b3902e3e20ea107a$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $23ab615c547792c0$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $b3902e3e20ea107a$export$f026abdbba7f0c9e extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeEndListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ !(0, $ae5289b89bf4fd95$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
            };
            const removePointerUpListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $b3902e3e20ea107a$var$fireSyntheticPointerEvent("up", this.node.getProps().onTap);
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $b3902e3e20ea107a$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        onTapStart && onTapStart(event, info);
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $df8cc4eab047d382$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        onTapCancel && onTapCancel(event, info);
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $21841eadb135946f$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $577133ec08d9e334$var$observers = new WeakMap();
const $577133ec08d9e334$var$fireObserverCallback = (entry)=>{
    const callback = $577133ec08d9e334$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $577133ec08d9e334$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    const rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $3926a5d0685d183c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $3926a5d0685d183c$export$150851c8cc2f0c72 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    /**
     * TODO: Remove this in 10.0
     */ viewportFallback() {
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         */ requestAnimationFrame(()=>{
            this.hasEnteredView = true;
            const { onViewportEnter: onViewportEnter } = this.node.getProps();
            onViewportEnter && onViewportEnter(null);
            if (this.node.animationState) this.node.animationState.setActive("whileInView", true);
        });
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once, fallback: fallback = true } = viewport;
        if (typeof IntersectionObserver === "undefined") {
            if (fallback) this.viewportFallback();
            return;
        }
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $3926a5d0685d183c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $577133ec08d9e334$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($3926a5d0685d183c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $3926a5d0685d183c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $3926a5d0685d183c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $b3902e3e20ea107a$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $46d14c2f8ccf5da4$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $dfb80d799aa36175$export$93a81ea037eac456)
    }
};





function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $d56714d1e4e43615$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $933209bc9c035719$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);





function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $ad746ac6e5aa4783$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $acbc43562ac6dbd8$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $e32104bb79321603$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $e32104bb79321603$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "9.1.7";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $b54248de5cdf5520$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve) || null;
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        this.animation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $e32104bb79321603$export$ce8bdc721e76545f(init, options) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init, options);
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ded99e01d9b518c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (0, $9d068be114f1d873$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ded99e01d9b518c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $9d068be114f1d873$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $c79d1e7d77418d04$var$clampRgbUnit = (v)=>(0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 255, v);
const $c79d1e7d77418d04$export$7a99c86b5b1f4c9e = {
    ...(0, $965bce4b5aab9d94$export$98e628dec113755e),
    transform: (v)=>Math.round($c79d1e7d77418d04$var$clampRgbUnit(v))
};
const $c79d1e7d77418d04$export$4e46ac54fc82cf3b = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(red) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(green) + ", " + $c79d1e7d77418d04$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $875e9bff470aaa65$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $875e9bff470aaa65$export$834dfc94dde4b3d8 = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("#"),
    parse: $875e9bff470aaa65$var$parseHex,
    transform: (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform
};






const $8bf8a43b3506d305$export$810b04175080204c = {
    test: (0, $ded99e01d9b518c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $ded99e01d9b518c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $25ca921ba8e55794$export$626336c2cd4b14de).transform((0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)((0, $965bce4b5aab9d94$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d8fe6ea9e8bd3d9c$export$35e9368ef982300f = {
    test: (v)=>(0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v) || (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).test(v) || (0, $8bf8a43b3506d305$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).test(v)) return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $8bf8a43b3506d305$export$810b04175080204c).test(v)) return (0, $8bf8a43b3506d305$export$810b04175080204c).parse(v);
        else return (0, $875e9bff470aaa65$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $9d068be114f1d873$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(v) : (0, $8bf8a43b3506d305$export$810b04175080204c).transform(v);
    }
};




const $b7b50ce2c2d54405$var$colorToken = "${c}";
const $b7b50ce2c2d54405$var$numberToken = "${n}";
function $b7b50ce2c2d54405$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $9d068be114f1d873$export$844ec244b1367d54)(v) && (((_a = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
function $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    let numNumbers = 0;
    const colors = v.match((0, $9d068be114f1d873$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        // Strip colors from input so they're not picked up by number regex.
        // There's a better way to combine these regex searches, but its beyond my regex skills
        v = v.replace((0, $9d068be114f1d873$export$740b69c5fad25dba), $b7b50ce2c2d54405$var$colorToken);
        values.push(...colors.map((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).parse));
    }
    const numbers = v.match((0, $9d068be114f1d873$export$2444ca58c08448e4));
    if (numbers) {
        numNumbers = numbers.length;
        v = v.replace((0, $9d068be114f1d873$export$2444ca58c08448e4), $b7b50ce2c2d54405$var$numberToken);
        values.push(...numbers.map((0, $965bce4b5aab9d94$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        numNumbers: numNumbers,
        tokenised: v
    };
}
function $b7b50ce2c2d54405$var$parse(v) {
    return $b7b50ce2c2d54405$export$b61fc7c44bf646d5(v).values;
}
function $b7b50ce2c2d54405$var$createTransformer(source) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $b7b50ce2c2d54405$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $b7b50ce2c2d54405$var$colorToken : $b7b50ce2c2d54405$var$numberToken, i < numColors ? (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).transform(v[i]) : (0, $9d068be114f1d873$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
const $b7b50ce2c2d54405$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $b7b50ce2c2d54405$var$getAnimatableNone(v) {
    const parsed = $b7b50ce2c2d54405$var$parse(v);
    const transformer = $b7b50ce2c2d54405$var$createTransformer(v);
    return transformer(parsed.map($b7b50ce2c2d54405$var$convertNumbersToZero));
}
const $b7b50ce2c2d54405$export$83a0e34f1302825b = {
    test: $b7b50ce2c2d54405$var$test,
    parse: $b7b50ce2c2d54405$var$parse,
    createTransformer: $b7b50ce2c2d54405$var$createTransformer,
    getAnimatableNone: $b7b50ce2c2d54405$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $c55938f2e5f09a1e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $c55938f2e5f09a1e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9d068be114f1d873$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $c55938f2e5f09a1e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $c55938f2e5f09a1e$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $c55938f2e5f09a1e$export$3dea766d36a8935f = {
    ...(0, $b7b50ce2c2d54405$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($c55938f2e5f09a1e$var$functionRegex);
        return functions ? functions.map($c55938f2e5f09a1e$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = {
    ...(0, $d5c56ef81d4ff9c2$export$eec14432cd1cb67b),
    color: // Color props
    $d8fe6ea9e8bd3d9c$export$35e9368ef982300f,
    backgroundColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    outlineColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    fill: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    stroke: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderTopColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderRightColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderBottomColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    borderLeftColor: (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    filter: $c55938f2e5f09a1e$export$3dea766d36a8935f,
    WebkitFilter: (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6da1de6e0a9a8c9d$export$67d1babe0338d23b = (key)=>$6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];


function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $c55938f2e5f09a1e$export$3dea766d36a8935f)) defaultValueType = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}






/**
 * Tests a provided value against a ValueType
 */ const $a1e2618328995be8$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $965bce4b5aab9d94$export$98e628dec113755e),
    (0, $25ca921ba8e55794$export$91c0eda1d06bf008),
    (0, $25ca921ba8e55794$export$626336c2cd4b14de),
    (0, $25ca921ba8e55794$export$41fc368e1a942b97),
    (0, $25ca921ba8e55794$export$aed3d7b7d206c196),
    (0, $25ca921ba8e55794$export$f91e8c45a95a32f2),
    (0, $c231a4375b038d3c$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a90ec5e4ad59372f$export$eefdd52e3ccae428 = (v)=>$a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $0bb49f6c51badae3$var$valueTypes = [
    ...(0, $a90ec5e4ad59372f$export$d176691c1998a1f5),
    (0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f),
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $0bb49f6c51badae3$export$950e7e59ea1ffed7 = (v)=>$0bb49f6c51badae3$var$valueTypes.find((0, $a1e2618328995be8$export$6eae4d0a6a7ca7cd)(v));



/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $58c1fda9d3891d8d$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $58c1fda9d3891d8d$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $abbf779fde460163$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $58c1fda9d3891d8d$var$getCurrent(visualElement), $58c1fda9d3891d8d$var$getVelocity(visualElement));
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $21f654501c04362b$export$5485128c47bd48bb)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $d56714d1e4e43615$export$65583ed5a868f2d9)(value) || (0, $933209bc9c035719$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $0bb49f6c51badae3$export$950e7e59ea1ffed7)(value) && (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(targetValue)) value = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $ea04fe669600292a$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}





function $d94f283b675f700d$export$98397f3adbf6259f(value) {
    return Boolean((0, $55c3387a92452647$export$605d60a2578142d3)(value) && value.add);
}



const $5fd2b57c27674a98$export$ed7b8fa9dbf0105d = "framerAppearId";
const $5fd2b57c27674a98$export$8592e1c077c890a6 = "data-" + (0, $9dc069bda924fd3f$export$9fd24a634729c672)($5fd2b57c27674a98$export$ed7b8fa9dbf0105d);



let $bf99d85f7a843912$export$491112666e282270 = (0, $448ce039afb5ec07$export$8793edee2d425525);
let $bf99d85f7a843912$export$f5708dca728d7177 = (0, $448ce039afb5ec07$export$8793edee2d425525);
var $bf99d85f7a843912$var$check, $bf99d85f7a843912$var$message, $bf99d85f7a843912$var$check1, $bf99d85f7a843912$var$message1;


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $083454c8244247d6$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;


const $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};



// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $6fc2fca13a5370f0$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $daf16ad73b68faf0$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $c24ef35c6cea05c0$export$929e5a82286172a6 = (p)=>p * p;
const $c24ef35c6cea05c0$export$57636bb43b1ccbb0 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($c24ef35c6cea05c0$export$929e5a82286172a6);
const $c24ef35c6cea05c0$export$c07234257a03d5e9 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($c24ef35c6cea05c0$export$929e5a82286172a6);





/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $70c54e935a247717$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $fd6f5ba04ea8bac3$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue + 1 / 3);
        green = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue);
        blue = $fd6f5ba04ea8bac3$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $7691d9e96675321f$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $7691d9e96675321f$var$colorTypes = [
    (0, $875e9bff470aaa65$export$834dfc94dde4b3d8),
    (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b),
    (0, $8bf8a43b3506d305$export$810b04175080204c)
];
const $7691d9e96675321f$var$getColorType = (v)=>$7691d9e96675321f$var$colorTypes.find((type)=>type.test(v));
function $7691d9e96675321f$var$asRGBA(color) {
    const type = $7691d9e96675321f$var$getColorType(color);
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $8bf8a43b3506d305$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $fd6f5ba04ea8bac3$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $7691d9e96675321f$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $7691d9e96675321f$var$asRGBA(from);
    const toRGBA = $7691d9e96675321f$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $7691d9e96675321f$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $c79d1e7d77418d04$export$4e46ac54fc82cf3b).transform(blended);
    };
};








function $6ec69123567a0d66$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(origin)) return (0, $7691d9e96675321f$export$51e568cf5c039bac)(origin, target);
    else return $6ec69123567a0d66$export$65516310a87d8205(origin, target);
}
const $6ec69123567a0d66$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6ec69123567a0d66$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6ec69123567a0d66$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6ec69123567a0d66$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6ec69123567a0d66$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $b7b50ce2c2d54405$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $21841eadb135946f$export$a4627e546088548d)($6ec69123567a0d66$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $bf99d85f7a843912$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $3a28fe0c82ae45f8$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $ec602dd05d6627bc$var$mixNumber = (from, to)=>(p)=>(0, $70c54e935a247717$export$2c9e8a9632a706b2)(from, to, p);
function $ec602dd05d6627bc$var$detectMixerFactory(v) {
    if (typeof v === "number") return $ec602dd05d6627bc$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $d8fe6ea9e8bd3d9c$export$35e9368ef982300f).test(v)) return 0, $7691d9e96675321f$export$51e568cf5c039bac;
        else return 0, $6ec69123567a0d66$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $6ec69123567a0d66$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6ec69123567a0d66$export$ebc23b6840c51ba1;
    return $ec602dd05d6627bc$var$mixNumber;
}
function $ec602dd05d6627bc$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $ec602dd05d6627bc$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $21841eadb135946f$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ec602dd05d6627bc$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ec602dd05d6627bc$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a4ecf42dec726852$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $481477152292f1a1$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a4ecf42dec726852$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $d61eba3ef0284b9c$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}




/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $cdee14e408821ec6$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $cdee14e408821ec6$var$subdivisionPrecision = 0.0000001;
const $cdee14e408821ec6$var$subdivisionMaxIterations = 12;
function $cdee14e408821ec6$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $cdee14e408821ec6$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $cdee14e408821ec6$var$subdivisionPrecision && ++i < $cdee14e408821ec6$var$subdivisionMaxIterations);
    return currentT;
}
function $cdee14e408821ec6$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $448ce039afb5ec07$export$8793edee2d425525;
    const getTForX = (aX)=>$cdee14e408821ec6$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $cdee14e408821ec6$var$calcBezier(getTForX(t), mY1, mY2);
}






const $66a2361fd99a4040$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $66a2361fd99a4040$export$c8d67a19199d1a50 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($66a2361fd99a4040$export$e444123e42d03385);
const $66a2361fd99a4040$export$30d3455eee55bed5 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($66a2361fd99a4040$export$c8d67a19199d1a50);





const $a7ddcde2a4282efd$export$77edfce482316a60 = (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $a7ddcde2a4282efd$export$b01116c84cdfe1a2 = (0, $daf16ad73b68faf0$export$2c07eeff45156d4d)($a7ddcde2a4282efd$export$77edfce482316a60);
const $a7ddcde2a4282efd$export$ddc5fd596f6c71b2 = (0, $6fc2fca13a5370f0$export$f946554fb8aeaf0d)($a7ddcde2a4282efd$export$b01116c84cdfe1a2);



const $5e5a5cfe1fa796ef$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $a7ddcde2a4282efd$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $09ac0b286989a3ae$var$easingLookup = {
    linear: (0, $448ce039afb5ec07$export$8793edee2d425525),
    easeIn: $c24ef35c6cea05c0$export$929e5a82286172a6,
    easeInOut: $c24ef35c6cea05c0$export$c07234257a03d5e9,
    easeOut: $c24ef35c6cea05c0$export$57636bb43b1ccbb0,
    circIn: $66a2361fd99a4040$export$e444123e42d03385,
    circInOut: $66a2361fd99a4040$export$30d3455eee55bed5,
    circOut: $66a2361fd99a4040$export$c8d67a19199d1a50,
    backIn: $a7ddcde2a4282efd$export$b01116c84cdfe1a2,
    backInOut: $a7ddcde2a4282efd$export$ddc5fd596f6c71b2,
    backOut: $a7ddcde2a4282efd$export$77edfce482316a60,
    anticipate: $5e5a5cfe1fa796ef$export$6b0af63b873d419e
};
const $09ac0b286989a3ae$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $cdee14e408821ec6$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bf99d85f7a843912$export$f5708dca728d7177)($09ac0b286989a3ae$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $09ac0b286989a3ae$var$easingLookup[definition];
    }
    return definition;
};
const $09ac0b286989a3ae$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


function $fec49c65f9f76c79$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $c24ef35c6cea05c0$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $fec49c65f9f76c79$export$d25ddfdf17c3ad3e({ keyframes: keyframeValues, ease: ease = (0, $c24ef35c6cea05c0$export$c07234257a03d5e9), times: times, duration: duration = 300 }) {
    keyframeValues = [
        ...keyframeValues
    ];
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $09ac0b286989a3ae$export$216948827bbdc797)(ease) ? ease.map((0, $09ac0b286989a3ae$export$ef97fe084f156ca4)) : (0, $09ac0b286989a3ae$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $d61eba3ef0284b9c$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $481477152292f1a1$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    function createInterpolator() {
        return (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
            ease: Array.isArray(easingFunctions) ? easingFunctions : $fec49c65f9f76c79$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            keyframeValues.reverse();
            interpolator = createInterpolator();
        }
    };
}




const $d4e4dd0fc1a7d755$var$safeMin = 0.001;
const $d4e4dd0fc1a7d755$export$a3cdb76e84ee608e = 0.01;
const $d4e4dd0fc1a7d755$export$1824b851fad8862b = 10.0;
const $d4e4dd0fc1a7d755$export$ff08f2d53484465 = 0.05;
const $d4e4dd0fc1a7d755$export$201ca48e54038115 = 1;
function $d4e4dd0fc1a7d755$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bf99d85f7a843912$export$491112666e282270)(duration <= $d4e4dd0fc1a7d755$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($d4e4dd0fc1a7d755$export$ff08f2d53484465, $d4e4dd0fc1a7d755$export$201ca48e54038115, dampingRatio);
    duration = (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)($d4e4dd0fc1a7d755$export$a3cdb76e84ee608e, $d4e4dd0fc1a7d755$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $d4e4dd0fc1a7d755$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $d4e4dd0fc1a7d755$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $d4e4dd0fc1a7d755$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $d4e4dd0fc1a7d755$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$d4e4dd0fc1a7d755$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $d4e4dd0fc1a7d755$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $d4e4dd0fc1a7d755$var$rootIterations = 12;
function $d4e4dd0fc1a7d755$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $d4e4dd0fc1a7d755$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $d4e4dd0fc1a7d755$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}



const $81759af2b3a28146$var$durationKeys = [
    "duration",
    "bounce"
];
const $81759af2b3a28146$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $81759af2b3a28146$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $81759af2b3a28146$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$81759af2b3a28146$var$isSpringType(options, $81759af2b3a28146$var$physicsKeys) && $81759af2b3a28146$var$isSpringType(options, $81759af2b3a28146$var$durationKeys)) {
        const derived = (0, $d4e4dd0fc1a7d755$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
const $81759af2b3a28146$var$velocitySampleDuration = 5;
/**
 * This is based on the spring implementation of Wobble https://github.com/skevy/wobble
 */ function $81759af2b3a28146$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    let origin = keyframes[0];
    let target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $81759af2b3a28146$var$getSpringOptions(options);
    let resolveSpring = $81759af2b3a28146$var$zero;
    let initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    function createSpring() {
        const initialDelta = target - origin;
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        /**
         * If we're working on a granular scale, use smaller defaults for determining
         * when the spring is finished.
         *
         * These defaults have been selected emprically based on what strikes a good
         * ratio between feeling good and finishing as soon as changes are imperceptible.
         */ const isGranularScale = Math.abs(initialDelta) < 5;
        restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
        restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
        if (dampingRatio < 1) {
            const angularFreq = (0, $d4e4dd0fc1a7d755$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
            // Underdamped spring
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
        } else if (dampingRatio === 1) // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            // Overdamped spring
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                // When performing sinh or cosh values can hit Infinity so we cap them here
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) {
                        const prevT = Math.max(0, t - $81759af2b3a28146$var$velocitySampleDuration);
                        currentVelocity = (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(current - resolveSpring(prevT), t - prevT);
                    } else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        flipTarget: ()=>{
            initialVelocity = -initialVelocity;
            [origin, target] = [
                target,
                origin
            ];
            createSpring();
        }
    };
}
$81759af2b3a28146$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $81759af2b3a28146$var$zero = (_t)=>0;


function $1f1a2d3e8d02242a$export$e9341ba102272ab9({ keyframes: /**
 * The decay animation dynamically calculates an end of the animation
 * based on the initial keyframe, so we only need to define a single keyframe
 * as default.
 */ keyframes = [
    0
], velocity: velocity = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const origin = keyframes[0];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}




const $1eaabe23cae0a8f9$var$types = {
    decay: $1f1a2d3e8d02242a$export$e9341ba102272ab9,
    keyframes: (0, $fec49c65f9f76c79$export$d25ddfdf17c3ad3e),
    tween: (0, $fec49c65f9f76c79$export$d25ddfdf17c3ad3e),
    spring: $81759af2b3a28146$export$b36281d89752ae66
};
function $1eaabe23cae0a8f9$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $1eaabe23cae0a8f9$export$ab9042754680126b(elapsed, duration = 0, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $1eaabe23cae0a8f9$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $1eaabe23cae0a8f9$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const $1eaabe23cae0a8f9$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(passTimestamp, true),
        stop: ()=>(0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(passTimestamp)
    };
};
function $1eaabe23cae0a8f9$export$ee9b76de7353d815({ duration: duration, driver: driver = $1eaabe23cae0a8f9$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, keyframes: keyframes$1, autoplay: autoplay = true, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate, type: type = "keyframes", ...options }) {
    const initialElapsed = elapsed;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = duration;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = $1eaabe23cae0a8f9$var$types[keyframes$1.length > 2 ? "keyframes" : type] || (0, $fec49c65f9f76c79$export$d25ddfdf17c3ad3e);
    const origin = keyframes$1[0];
    const target = keyframes$1[keyframes$1.length - 1];
    let state = {
        done: false,
        value: origin
    };
    /**
     * If this value needs interpolation (ie is non-numerical), set up an interpolator.
     * TODO: Keyframes animation also performs this step. This could be removed so it only happens here.
     */ const { needsInterpolation: needsInterpolation } = animator;
    if (needsInterpolation && needsInterpolation(origin, target)) {
        interpolateFromNumber = (0, $ec602dd05d6627bc$export$89e29e4ab65e70a9)([
            0,
            100
        ], [
            origin,
            target
        ], {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const animation = animator({
        ...options,
        duration: duration,
        keyframes: keyframes$1
    });
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = $1eaabe23cae0a8f9$export$ab9042754680126b(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = $1eaabe23cae0a8f9$export$7d0784e050d8e25f(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls && driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            state = animation.next(Math.max(0, elapsed));
            if (interpolateFromNumber) state.value = interpolateFromNumber(state.value);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate && onUpdate(state.value);
        if (isComplete) {
            if (repeatCount === 0) computedDuration = computedDuration !== undefined ? computedDuration : elapsed;
            if (repeatCount < repeatMax) $1eaabe23cae0a8f9$export$c9c9437f9b8733b5(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay && onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop && onStop();
            driverControls && driverControls.stop();
        },
        /**
         * Set the current time of the animation. This is purposefully
         * mirroring the WAAPI animation API to make them interchanagable.
         * Going forward this file should be ported more towards
         * https://github.com/motiondivision/motionone/blob/main/packages/animation/src/Animation.ts
         * Which behaviourally adheres to WAAPI as far as possible.
         *
         * WARNING: This is not safe to use for most animations. We currently
         * only use it for handoff from WAAPI within Framer.
         *
         * This animation function consumes time every frame rather than being sampled for time.
         * So the sample() method performs some headless frames to ensure
         * repeats are handled correctly. Ideally in the future we will replace
         * that method with this, once repeat calculations are pure.
         */ set currentTime (t){
            elapsed = initialElapsed;
            update(t);
        },
        /**
         * animate() can't yet be sampled for time, instead it
         * consumes time. So to sample it we have to run a low
         * temporal-resolution version.
         */ sample: (t1)=>{
            elapsed = initialElapsed;
            const sampleResolution = duration && typeof duration === "number" ? Math.max(duration * 0.5, 50) : 50;
            let sampleElapsed = 0;
            update(0);
            while(sampleElapsed <= t1){
                const remaining = t1 - sampleElapsed;
                update(Math.min(remaining, sampleResolution));
                sampleElapsed += sampleResolution;
            }
            return state;
        }
    };
}


function $2e4dc549f5b87e20$export$fcdd8f3f2160beda(easing) {
    return !easing || // Default easing
    Array.isArray(easing) || // Bezier curve
    typeof easing === "string" && $2e4dc549f5b87e20$export$2cf569f5e2221176[easing];
}
const $2e4dc549f5b87e20$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $2e4dc549f5b87e20$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $2e4dc549f5b87e20$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $2e4dc549f5b87e20$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return Array.isArray(easing) ? $2e4dc549f5b87e20$export$2523b8f0bd8f44cb(easing) : $2e4dc549f5b87e20$export$2cf569f5e2221176[easing];
}


function $65d6992f3988c2c3$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    return element.animate({
        [valueName]: keyframes,
        offset: times
    }, {
        delay: delay,
        duration: duration,
        easing: (0, $2e4dc549f5b87e20$export$916ea73bcd3a6030)(ease),
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



const $2e784339013f8329$var$featureTests = {
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate")
};
const $2e784339013f8329$var$results = {};
const $2e784339013f8329$export$cde6a56f9669daf6 = {};
/**
 * Generate features tests that cache their results.
 */ for(const key in $2e784339013f8329$var$featureTests)$2e784339013f8329$export$cde6a56f9669daf6[key] = ()=>{
    if ($2e784339013f8329$var$results[key] === undefined) $2e784339013f8329$var$results[key] = $2e784339013f8329$var$featureTests[key]();
    return $2e784339013f8329$var$results[key];
};


function $a81e6db259d5b16e$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $bfa4b4f99ad894bb$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $bfa4b4f99ad894bb$var$sampleDelta = 10; //ms
function $bfa4b4f99ad894bb$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = (0, $2e784339013f8329$export$cde6a56f9669daf6).waapi() && $bfa4b4f99ad894bb$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0;
    if (!canAccelerateAnimation) return false;
    let { keyframes: keyframes, duration: duration = 300, elapsed: elapsed = 0, ease: ease } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if (options.type === "spring" || !(0, $2e4dc549f5b87e20$export$fcdd8f3f2160beda)(options.ease)) {
        /**
         * If we need to pre-generate keyframes and repeat is infinite then
         * early return as this will lock the thread.
         */ if (options.repeat === Infinity) return;
        const sampleAnimation = (0, $1eaabe23cae0a8f9$export$ee9b76de7353d815)({
            ...options,
            elapsed: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t1 = 0;
        while(!state.done && t1 < 20000){
            state = sampleAnimation.sample(t1);
            pregeneratedKeyframes.push(state.value);
            t1 += $bfa4b4f99ad894bb$var$sampleDelta;
        }
        keyframes = pregeneratedKeyframes;
        duration = t1 - $bfa4b4f99ad894bb$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $65d6992f3988c2c3$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        delay: -elapsed,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease
    });
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $a81e6db259d5b16e$export$14de59408fad90b)(keyframes, options));
        (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(()=>animation.cancel());
        onComplete && onComplete();
    };
    /**
     * Animation interrupt callback.
     */ return {
        get currentTime () {
            return animation.currentTime || 0;
        },
        set currentTime (t){
            animation.currentTime = t;
        },
        stop: ()=>{
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $1eaabe23cae0a8f9$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $bfa4b4f99ad894bb$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $bfa4b4f99ad894bb$var$sampleDelta);
            }
            (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(()=>animation.cancel());
        }
    };
}



/**
 * Timeout defined in ms
 */ function $fab50a206e6cc096$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).read(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).read(checkElapsed, true);
    return ()=>(0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).read(checkElapsed);
}


function $0b4349754b713b18$export$6f34fc8ef6c42b70({ keyframes: keyframes, elapsed: elapsed, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
    };
    return elapsed ? {
        stop: (0, $fab50a206e6cc096$export$1391212d75b2ee65)(setValue, -elapsed)
    } : setValue();
}






function $23fab257a8b45cd7$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    const origin = keyframes[0];
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function findNearestBoundary(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation && currentAnimation.stop();
        currentAnimation = (0, $1eaabe23cae0a8f9$export$ee9b76de7353d815)({
            keyframes: [
                0,
                1
            ],
            velocity: 0,
            ...options,
            driver: driver,
            onUpdate: (v)=>{
                onUpdate && onUpdate(v);
                options.onUpdate && options.onUpdate(v);
            },
            onComplete: onComplete,
            onStop: onStop
        });
    }
    function startSpring(options) {
        startAnimation({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta,
            ...options
        });
    }
    if (isOutOfBounds(origin)) // Start the animation with spring if outside the defined boundaries
    startSpring({
        velocity: velocity,
        keyframes: [
            origin,
            findNearestBoundary(origin)
        ]
    });
    else {
        /**
         * Or if the value is out of bounds, simulate the inertia movement
         * with the decay animation.
         *
         * Pre-calculate the target so we can detect if it's out-of-bounds.
         * If it is, we want to check per frame when to switch to a spring
         * animation
         */ let target = power * velocity + origin;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = findNearestBoundary(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $acbc43562ac6dbd8$export$eab0632f7ad4f9d7)(v - prev, (0, $b54248de5cdf5520$export$fff89137e9e818ce).delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                keyframes: [
                    v,
                    boundary
                ],
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            keyframes: [
                origin,
                0
            ],
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation && currentAnimation.stop()
    };
}



const $5f1d5ca1d398e82d$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $5f1d5ca1d398e82d$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $5f1d5ca1d398e82d$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $5f1d5ca1d398e82d$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $5f1d5ca1d398e82d$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $5f1d5ca1d398e82d$var$keyframesTransition;
    else if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $5f1d5ca1d398e82d$var$criticallyDampedSpring(keyframes[1]) : $5f1d5ca1d398e82d$var$underDampedSpring;
    return $5f1d5ca1d398e82d$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $ef4086713d7b0bdb$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $ec9bae3b9c638c7a$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $ec9bae3b9c638c7a$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $ca0a3798777df465$export$cea0cedcb94873b5)("", potentialUnitType);
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}


function $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, target);
    let origin = transition.from !== undefined ? transition.from : value.get();
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $ca0a3798777df465$export$cea0cedcb94873b5)(valueName, target);
    else if ((0, $ec9bae3b9c638c7a$export$c46ec7d82fb1f602)(origin) && typeof target === "string") origin = (0, $ec9bae3b9c638c7a$export$36cd6032f9de8a48)(target);
    else if (!Array.isArray(target) && (0, $ec9bae3b9c638c7a$export$c46ec7d82fb1f602)(target) && typeof origin === "string") target = (0, $ec9bae3b9c638c7a$export$36cd6032f9de8a48)(origin);
    /**
     * If the target has been defined as a series of keyframes
     */ if (Array.isArray(target)) {
        /**
         * Ensure an initial wildcard keyframe is hydrated by the origin.
         * TODO: Support extra wildcard keyframes i.e [1, null, 0]
         */ if (target[0] === null) target[0] = origin;
        return target;
    } else return [
        origin,
        target
    ];
}



const $1e549d306124fdeb$export$208d7b28e5ce5514 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $ec9bae3b9c638c7a$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $cef4c9de9cdf8072$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $ef4086713d7b0bdb$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $bf99d85f7a843912$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ...valueTransition,
            elapsed: elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $77818709e1bb6833$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $0b4349754b713b18$export$6f34fc8ef6c42b70)(options);
        else if (valueTransition.type === "inertia") /**
             * If this is an inertia animation, we currently don't support pre-generating
             * keyframes for this as such it must always run on the main thread.
             */ return (0, $23fab257a8b45cd7$export$ee3ff3a17106998)(options);
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $5f1d5ca1d398e82d$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $bfa4b4f99ad894bb$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $1eaabe23cae0a8f9$export$ee9b76de7353d815)(options);
    };
};



function $66bcda5a48aeb596$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>$66bcda5a48aeb596$var$animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $66bcda5a48aeb596$var$animateVariant(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = $66bcda5a48aeb596$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}
function $66bcda5a48aeb596$var$animateVariant(visualElement, variant, options = {}) {
    const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>$66bcda5a48aeb596$var$animateTarget(visualElement, resolved, options) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $66bcda5a48aeb596$var$animateTarget(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $66bcda5a48aeb596$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $5fd2b57c27674a98$export$8592e1c077c890a6];
            if (appearId) valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $b4999b8a0b43adc6$export$92d6409d68f0739a));
        }
        let animation = value.start((0, $1e549d306124fdeb$export$208d7b28e5ce5514)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation = animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    return Promise.all(animations).then(()=>{
        transitionEnd && (0, $ea04fe669600292a$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
}
function $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($66bcda5a48aeb596$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($66bcda5a48aeb596$var$animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $66bcda5a48aeb596$export$3cc6f911ef1fd837(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
function $66bcda5a48aeb596$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $66bcda5a48aeb596$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}





const $351ff45a987b08cc$var$reversePriorityOrder = [
    ...(0, $0172fb3d3512f551$export$16e45afcc206d3a8)
].reverse();
const $351ff45a987b08cc$var$numAnimationTypes = (0, $0172fb3d3512f551$export$16e45afcc206d3a8).length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $66bcda5a48aeb596$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    let animate = $351ff45a987b08cc$var$animateList(visualElement);
    const state = $351ff45a987b08cc$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $58c1fda9d3891d8d$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++){
            const type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $a35be4d5814e7c66$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(next) && (0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $21ec58272207c53a$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    return {
        animate: $351ff45a987b08cc$var$createTypeState(true),
        whileInView: $351ff45a987b08cc$var$createTypeState(),
        whileHover: $351ff45a987b08cc$var$createTypeState(),
        whileTap: $351ff45a987b08cc$var$createTypeState(),
        whileDrag: $351ff45a987b08cc$var$createTypeState(),
        whileFocus: $351ff45a987b08cc$var$createTypeState(),
        exit: $351ff45a987b08cc$var$createTypeState()
    };
}



class $bfc36aed86970b83$export$b45b3fe5caabdca extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $351ff45a987b08cc$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $1e5344c7f0db9c8f$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $7ad505f20eee7073$var$id = 0;
class $7ad505f20eee7073$export$4989d1eb6104cc6c extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $7ad505f20eee7073$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bfc36aed86970b83$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $7ad505f20eee7073$export$4989d1eb6104cc6c)
    }
};










const $8eeaeb5692ba8175$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8eeaeb5692ba8175$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8eeaeb5692ba8175$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $2bb1a5b2e1002b2e$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $2bb1a5b2e1002b2e$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $8eeaeb5692ba8175$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $b54248de5cdf5520$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $2bb1a5b2e1002b2e$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $6b2f8b101475710a$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $23ab615c547792c0$export$12f84bb882d06e1a)(event);
        const initialInfo = $2bb1a5b2e1002b2e$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $b54248de5cdf5520$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $2bb1a5b2e1002b2e$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $21841eadb135946f$export$a4627e546088548d)((0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(this.updatePoint);
    }
}
function $2bb1a5b2e1002b2e$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $2bb1a5b2e1002b2e$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $2bb1a5b2e1002b2e$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$lastDevicePoint(history)),
        offset: $2bb1a5b2e1002b2e$var$subtractPoint(point, $2bb1a5b2e1002b2e$var$startDevicePoint(history)),
        velocity: $2bb1a5b2e1002b2e$var$getVelocity(history, 0.1)
    };
}
function $2bb1a5b2e1002b2e$var$startDevicePoint(history) {
    return history[0];
}
function $2bb1a5b2e1002b2e$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $2bb1a5b2e1002b2e$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $2bb1a5b2e1002b2e$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $083454c8244247d6$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $70c54e935a247717$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(source);
    const targetLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b6bea1244f8d9db5$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a3727e4e12b23353$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a3727e4e12b23353$export$3d227df54007d73a = ()=>({
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    });
const $a3727e4e12b23353$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a3727e4e12b23353$export$6459fc9e86be362e = ()=>({
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    });


function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f(values) {
    return $fe0ee806cd19fc1f$var$is2DTranslate(values.x) || $fe0ee806cd19fc1f$var$is2DTranslate(values.y);
}
function $fe0ee806cd19fc1f$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, { x: x, y: y }) {
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $d8332eb74969584e$var$snapToDefault(treeScale.x);
    treeScale.y = $d8332eb74969584e$var$snapToDefault(treeScale.y);
}
function $d8332eb74969584e$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}


function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)((0, $0e0401fe38bd0bd1$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









const $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $59924ee873defaad$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $23ab615c547792c0$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $df8cc4eab047d382$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart && onDragStart(event, info);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        onDragEnd && onDragEnd(event, info);
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $2df0cf7aa8fef8fc$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $d157673547c2a934$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bf99d85f7a843912$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $4ca2f8055771ddf4$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $2df0cf7aa8fef8fc$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0e0401fe38bd0bd1$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0e0401fe38bd0bd1$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $1e549d306124fdeb$export$208d7b28e5ce5514)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $2df0cf7aa8fef8fc$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $70c54e935a247717$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $2df0cf7aa8fef8fc$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $abae7830ca84eed8$export$5d97dc2872682820 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.removeListeners = (0, $448ce039afb5ec07$export$8793edee2d425525);
        this.controls = new (0, $59924ee873defaad$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}






class $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859 extends (0, $5b9241b1e863e695$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $448ce039afb5ec07$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $2bb1a5b2e1002b2e$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: onPanSessionStart,
            onStart: onPanStart,
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                onPanEnd && onPanEnd(event, info);
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7fd40e38993f1c69$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    const context = (0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $acw62.useId)();
    (0, $acw62.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $dba5d94a982c4145$export$f224e4635b6f8ce2)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}






function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $967b202c839557ef$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        const y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ac0e5a3978f40f61$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    const match = $ac0e5a3978f40f61$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth = 1) {
    (0, $bf99d85f7a843912$export$f5708dca728d7177)(depth <= $ac0e5a3978f40f61$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ((0, $f9c5e88311214d2a$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) return;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $f9c5e88311214d2a$export$31f9caa2600b5723)(current)) continue;
        const resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd && transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}




const $a42cd9e0ef50cb70$var$varToken = "_$css";
const $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ const containsCSSVariables = latest.includes("var(");
        const cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $ac0e5a3978f40f61$export$f7c0a352d8ef6313), (match)=>{
            cssVariables.push(match);
            return $a42cd9e0ef50cb70$var$varToken;
        });
        const shadow = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $b7b50ce2c2d54405$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        let output = template(shadow);
        if (containsCSSVariables) {
            let i = 0;
            output = output.replace($a42cd9e0ef50cb70$var$varToken, ()=>{
                const cssVariable = cssVariables[i];
                i++;
                return cssVariable;
            });
        }
        return output;
    }
};



class $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $eced91e16bda42df$export$de9e7791c71225fd)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $bc77fac60b5d77cc$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $acw62.useContext)((0, $4ae202aab5791dbc$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $c612a166b65a9c69$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $967b202c839557ef$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $967b202c839557ef$export$5eafb6257a5844c),
    boxShadow: (0, $a42cd9e0ef50cb70$export$eb0bc629e74dcf8)
};






/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $1ef13963bb19565a$export$e3607ec2d7a891c4(from, to, transition = {}) {
    const value = (0, $55c3387a92452647$export$605d60a2578142d3)(from) ? from : (0, $e32104bb79321603$export$ce8bdc721e76545f)(from);
    value.start((0, $1e549d306124fdeb$export$208d7b28e5ce5514)("", value, to, transition));
    return {
        stop: ()=>value.stop(),
        isAnimating: ()=>value.isAnimating()
    };
}








const $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
const $82b1c16a20b13fa0$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $82b1c16a20b13fa0$var$isPx = (value)=>typeof value === "number" || (0, $25ca921ba8e55794$export$91c0eda1d06bf008).test(value);
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        const borderLabel = `border${$82b1c16a20b13fa0$var$borders[i]}Radius`;
        let followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        let leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $70c54e935a247717$export$2c9e8a9632a706b2)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(leadRadius) || (0, $25ca921ba8e55794$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $66a2361fd99a4040$export$c8d67a19199d1a50));
const $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $448ce039afb5ec07$export$8793edee2d425525));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $3a28fe0c82ae45f8$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d8332eb74969584e$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $25ca921ba8e55794$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $b070f9c5f268d45c$export$c5706146bc63213(box) {
    return (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.x) / (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(box.y);
}



class $a040ab986103db06$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $8e214807702da081$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e21f5e6c9473a18c$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $f9c6cc6428ae273c$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $f9c6cc6428ae273c$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $8e214807702da081$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






function $0b58405220d0640d$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


const $d2ca41ba1b84bcfe$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $d2ca41ba1b84bcfe$var$animationTarget = 1000;
let $d2ca41ba1b84bcfe$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $d2ca41ba1b84bcfe$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(elementId, latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $d2ca41ba1b84bcfe$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes = $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas = $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($d2ca41ba1b84bcfe$export$131f2f0cc5fe9609);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
                this.nodes.forEach($d2ca41ba1b84bcfe$export$c2664f37bc951031);
                (0, $0b58405220d0640d$export$e5185e241753e543)($d2ca41ba1b84bcfe$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.elementId = elementId;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            elementId && this.root.registerPotentialNode(elementId, this);
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e21f5e6c9473a18c$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        registerPotentialNode(elementId, node) {
            this.potentialNodes.set(elementId, node);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = false) {
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            this.elementId && this.root.potentialNodes.delete(this.elementId);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $fab50a206e6cc096$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $ec9bae3b9c638c7a$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && this.animationProgress === 0) $d2ca41ba1b84bcfe$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).preRender(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($d2ca41ba1b84bcfe$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        // Note: Currently only running on root node
        didUpdate() {
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($d2ca41ba1b84bcfe$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $b4999b8a0b43adc6$export$cd75ccfd720a3cd4).update();
            (0, $b4999b8a0b43adc6$export$cd75ccfd720a3cd4).preRender();
            (0, $b4999b8a0b43adc6$export$cd75ccfd720a3cd4).render();
        }
        clearAllSnapshots() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $d2ca41ba1b84bcfe$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d8332eb74969584e$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $d8332eb74969584e$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) (0, $db628fcc785b8b87$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        /**
         * Frame calculations
         */ resolveTargetDelta() {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) (0, $b352f7cdd42c49d7$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d8332eb74969584e$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fe0ee806cd19fc1f$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fe0ee806cd19fc1f$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d8332eb74969584e$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            const { target: target } = lead;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $d2ca41ba1b84bcfe$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $82b1c16a20b13fa0$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(()=>{
                (0, $b29dc04080b74d0c$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $1ef13963bb19565a$export$e3607ec2d7a891c4)(0, $d2ca41ba1b84bcfe$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                const xLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $5960d81994414d5a$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d8332eb74969584e$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $a040ab986103db06$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $d2ca41ba1b84bcfe$var$transformAxes.length; i++){
                const key = "rotate" + $d2ca41ba1b84bcfe$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fe0ee806cd19fc1f$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $0214cdf9d4bb801d$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $eced91e16bda42df$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $eced91e16bda42df$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $18cbbcef55016eac$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $247f90d2510fbc55$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $b352f7cdd42c49d7$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        const layoutDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a3727e4e12b23353$export$3d227df54007d73a)();
        if (isShared) (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $b352f7cdd42c49d7$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $b070f9c5f268d45c$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
                    (0, $b352f7cdd42c49d7$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $b070f9c5f268d45c$export$8d5cf76bb7daff09)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $d2ca41ba1b84bcfe$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $d2ca41ba1b84bcfe$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $70c54e935a247717$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $d2ca41ba1b84bcfe$var$mountNodeEarly(node, elementId) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ let searchNode = node.root;
    for(let i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    const searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    const element = searchElement.querySelector(`[data-projection-id="${elementId}"]`);
    if (element) node.mount(element, true);
}
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}
function $d2ca41ba1b84bcfe$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $b352f7cdd42c49d7$export$28d0384c4b79bde2)((0, $b070f9c5f268d45c$export$c5706146bc63213)(snapshot), (0, $b070f9c5f268d45c$export$c5706146bc63213)(layout), 0.2);
}




const $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $43ace1b5a11c3a40$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
const $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $d2ca41ba1b84bcfe$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            const documentNode = new (0, $6e97f3a9a89d5fc1$export$2d029a49a09b6177)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $d43ff984f7bd7f1a$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $abae7830ca84eed8$export$5d97dc2872682820),
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};


















const $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
const $a731b8aa4fe311d9$var$isPositionalKey = (key)=>$a731b8aa4fe311d9$var$positionalKeys.has(key);
const $a731b8aa4fe311d9$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
const $a731b8aa4fe311d9$var$isNumOrPxType = (v)=>v === (0, $965bce4b5aab9d94$export$98e628dec113755e) || v === (0, $25ca921ba8e55794$export$91c0eda1d06bf008);
const $a731b8aa4fe311d9$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a731b8aa4fe311d9$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $ac502869c4d3e65a$export$280dc01950909d86).filter((key)=>!$a731b8aa4fe311d9$var$transformKeys.has(key));
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
const $a731b8aa4fe311d9$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ef59b2359a289b82$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]);
                (0, $bf99d85f7a843912$export$f5708dca728d7177)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $bf99d85f7a843912$export$f5708dca728d7177)((0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $a90ec5e4ad59372f$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $25ca921ba8e55794$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $784730508f12f72c$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $d9a589b84d5ec1d1$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $ac0e5a3978f40f61$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a731b8aa4fe311d9$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};







// Does this device prefer reduced motion? Returns `null` server-side.
const $5d1c3a7750a03ec7$export$ff7706047246b98b = {
    current: null
};
const $5d1c3a7750a03ec7$export$6476d16e2fd2d0db = {
    current: false
};


function $402b11b96c54cb2c$export$ca9f41fb23dded3d() {
    (0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current = true;
    if (!(0, $784730508f12f72c$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current = false;
}














function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $55c3387a92452647$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $e32104bb79321603$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $e66750f3fb0f96bb$var$featureNames = Object.keys((0, $a8d82256030e9525$export$65570e08d843624d));
const $e66750f3fb0f96bb$var$numFeatures = $e66750f3fb0f96bb$var$featureNames.length;
const $e66750f3fb0f96bb$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $e66750f3fb0f96bb$var$numVariantProps = (0, $0172fb3d3512f551$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $e66750f3fb0f96bb$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $b4999b8a0b43adc6$export$92d6409d68f0739a).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $06b1046bf0f33e63$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $06b1046bf0f33e63$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $55c3387a92452647$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $d94f283b675f700d$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        if (this.projection) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $5d1c3a7750a03ec7$export$6476d16e2fd2d0db).current) (0, $402b11b96c54cb2c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $5d1c3a7750a03ec7$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).update(this.notifyUpdate);
        (0, $b4999b8a0b43adc6$export$d93e9c1fe0553512).render(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $b4999b8a0b43adc6$export$92d6409d68f0739a).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, projectionId, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $e66750f3fb0f96bb$var$numFeatures; i++){
            const name = $e66750f3fb0f96bb$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $a8d82256030e9525$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(projectionId, this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $d157673547c2a934$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update(this.props, this.prevProps);
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $e66750f3fb0f96bb$var$propEventHandlers.length; i++){
            const key = $e66750f3fb0f96bb$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $69635cdb8982f9d2$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $e66750f3fb0f96bb$var$numVariantProps; i++){
            const name = (0, $0172fb3d3512f551$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $a35be4d5814e7c66$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $e32104bb79321603$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $abbf779fde460163$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $55c3387a92452647$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $ad746ac6e5aa4783$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $28a1ebc4c0bc036f$export$e49735c2a366bdc7 extends (0, $e66750f3fb0f96bb$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $ea04fe669600292a$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $ea04fe669600292a$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $d9a589b84d5ec1d1$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $bce82b8bf0dbf6b7$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $bce82b8bf0dbf6b7$export$23fea75b03ac16b3 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $bce82b8bf0dbf6b7$export$3735103072e4a80(instance);
            const value = ((0, $f9c5e88311214d2a$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $4ca2f8055771ddf4$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $a883e7c624291d03$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $a8ee53e44f8c4ac8$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $55c3387a92452647$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a52b6fc2f3af305f$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $a0798b9f9973cb35$export$86bcdffbaf733d84 extends (0, $28a1ebc4c0bc036f$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ac502869c4d3e65a$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6da1de6e0a9a8c9d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ea3ecc5fb2887a0f$export$28931db5d57958e5).has(key) ? (0, $9dc069bda924fd3f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $a3727e4e12b23353$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $eac085b45c9e0925$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $59f141cfaf6fcabb$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $9422342e44092cf6$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c139bf35362d2174$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $2f8881102ac6dde9$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $ca4ea6365adee72d$export$88f3fc2fd3766989)(Component) ? new (0, $a0798b9f9973cb35$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $bce82b8bf0dbf6b7$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $2c407ffdaf3c120a$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $a3289660bde9b219$export$b61a9eb3dbde8858),
        MeasureLayout: $cdf2a2ac04e7ce67$export$779f5fb01ad751cd
    }
};


const $a93b6401f922fd1e$var$preloadedFeatures = {
    ...(0, $03e8b675a1009b68$export$7f9953c70dacfd7f),
    ...(0, $5e115984cd871deb$export$e5b72898e5a201f1),
    ...(0, $fc1974bcfc4fde1a$export$d7d5d435647ed5a0),
    ...(0, $2c407ffdaf3c120a$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $16a09bb264d348bb$export$a28d6df673050e18)((Component, config)=>(0, $73e3a8d89278ed7b$export$732916c0e88175fb)(Component, config, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $b40dad60036091a1$export$46b7e4b9dc6110c3)((0, $73e3a8d89278ed7b$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$preloadedFeatures, (0, $2f8881102ac6dde9$export$56ba0183203348f5)));
}



var $acw62 = parcelRequire("acw62");
const $3c20332a4da57867$export$ac7604253a6f4d77 = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    },
    transition: {
        duration: 0.25
    }
};





function $115f4662e48b5c59$export$2e2bcd8739ae039({ children: children, isHomePage: isHomePage }) {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const isLoggedInPage = (0, $16250bd714b02a14$export$95d9d456783cd0b0).find((r)=>r.split("/").every((s, i)=>s === location.pathname.split("/")[i] || s[0] === ":"));
    (0, $acw62.useEffect)(()=>{
        (0, $6ee05925f8d16f34$export$92ab14d0aa42e41e)(location.pathname);
        scrollTo({
            top: 0,
            behavior: "smooth"
        });
        const handleResize = ()=>{
            const header = document.querySelector("header");
            if (!header) {
                console.error("Header element not found");
                return;
            }
            const offerBanner = document.getElementById("offerBanner");
            const offerBannerHeight = offerBanner ? offerBanner.offsetHeight : 0;
            const footer = document.querySelector("footer");
            const root = document.getElementById("root");
            if (isLoggedInPage && header && header.style) {
                root.style.marginTop = "";
                root.style.marginLeft = "4rem";
            } else {
                header.style.paddingTop = offerBannerHeight + "px";
                root.style.marginLeft = "";
                if (!location.pathname.includes("login")) ;
                else root.style.marginTop = "0px";
            }
            // if (footer?.offsetHeight > innerHeight) {
            // 	root.style.marginBottom = "";
            // 	footer?.classList.remove("pf");
            // } else {
            // 	root.style.marginBottom = footer?.offsetHeight + "px";
            // 	footer?.classList.add("pf");
            // }
            const hero = document.getElementById("hero");
            if (hero) hero.style.minHeight = innerHeight - (header?.offsetHeight || 0) + "px";
        };
        window.onresize = handleResize;
        handleResize(); // Call initially
    }, [
        isLoggedInPage,
        location.pathname
    ]);
    const motionClass = isLoggedInPage ? "bg1 mih100vh poppins-font-style *" : !isHomePage ? "bg1 bw0px bbw5px bss bo3" : "bg1";
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
        className: motionClass,
        variants: (0, $3c20332a4da57867$export$ac7604253a6f4d77),
        transition: (0, $3c20332a4da57867$export$ac7604253a6f4d77).transition,
        initial: "animate",
        animate: "animate",
        exit: "exit",
        children: children
    });
}






const $b7fc0f1ed201d442$var$IconMail = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "22,6 12,12 2,6"
            })
        ]
    });
const $b7fc0f1ed201d442$var$IconLock = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "3",
                y: "11",
                width: "18",
                height: "11",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7 11V7a5 5 0 0 1 10 0v4"
            })
        ]
    });
const $b7fc0f1ed201d442$var$IconEye = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
const $b7fc0f1ed201d442$var$IconEyeOff = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "1",
                y1: "1",
                x2: "23",
                y2: "23"
            })
        ]
    });
const $b7fc0f1ed201d442$var$Login = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const urlEmail = searchParams.get("email");
    const redirect = searchParams.get("redirect");
    const isBillingsearch = searchParams.get("billing");
    let [isLogin, setIsLogin] = (0, $acw62.useState)(false);
    let [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    let [operation, setOperation] = (0, $acw62.useState)('login');
    let [passwordType, setPasswordType] = (0, $acw62.useState)(true);
    let [isValidNewPassword, setIsValidNewPassword] = (0, $acw62.useState)(false);
    let [formData, setFormData] = (0, $acw62.useState)({
        email: '',
        password: ''
    });
    let [newPassword, setNewPassword] = (0, $acw62.useState)({
        password: '',
        confirmPassword: ''
    });
    let [passwordError, setPasswordError] = (0, $acw62.useState)({
        password: '',
        confirmPassword: ''
    });
    let [newPasswordType, setNewPasswordType] = (0, $acw62.useState)({
        passwordType: true,
        confirmPasswordType: true
    });
    let PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    (0, $acw62.useEffect)(()=>{
        const token = localStorage.getItem('token');
        if (token && user && !location?.hash) {
            if (user && [
                'Member',
                'User'
            ].includes(user?.role)) window.location.href = '/dashboard';
            else if (user && user?.role == 'Advisor') window.location.href = '/advisor-dashboard';
            else if (user && user?.role == 'Investor') window.location.href = '/investor-dashboard';
        }
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        let pathname = window.location.pathname;
        if (pathname.includes('login')) {
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            let mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            let isMobile = mobileRegex.test(userAgent);
            if (isMobile) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'mobileDevicesPopup'
            }));
        }
        let isManualAdd = localStorage.getItem('isManualAdd');
        if (isManualAdd) localStorage.removeItem('isManualAdd');
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (urlEmail) setFormData((prevData)=>({
                ...prevData,
                email: urlEmail
            }));
        window.scroll(0, 0);
        if (location.pathname.includes('reset_password')) setOperation('setPassword');
    }, []);
    (0, $acw62.useEffect)(()=>resetStates(), [
        operation
    ]);
    (0, $acw62.useEffect)(()=>{
        if (urlEmail) setFormData((prevData)=>({
                ...prevData,
                email: urlEmail
            }));
        if (formData['email'] !== '' && formData['password'] !== '') setIsLogin(true);
    }, [
        formData
    ]);
    const handleOperation = (link)=>{
        if (link == 'refresh') {
            (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('login_refresh');
            location.pathname = '/login';
        } else {
            (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)(`login_${link}`);
            setOperation(link);
        }
    };
    const resetStates = ()=>{
        setIsLogin(false);
        setIsLoading(false);
        setPasswordType(true);
        setFormData({
            email: '',
            password: ''
        });
        setNewPassword({
            password: '',
            confirmPassword: ''
        });
        setNewPasswordType({
            passwordType: true,
            confirmPasswordType: true
        });
    };
    const restrictedForDevices = ()=>{
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobile = mobileRegex.test(userAgent);
        return isMobile;
    };
    const login = async (e)=>{
        if (restrictedForDevices()) {
            (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('login_mobile_restricted');
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
        }
        if (formData['email'] && formData['password']) {
            setIsLoading(true);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/auth', formData);
            if (response && response['code'] == 200) {
                if (response['body']['token']) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    loginWithToken(response['body']);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    (0, $6ee05925f8d16f34$export$cdd110eef83fd2bd)('login');
                    (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('login_form', {
                        email: formData.email,
                        status: 'success',
                        user_type: response['body']['role']
                    });
                } else if (response['body']['hash']) {
                    let data = response['body'];
                    dispatch((0, $7fa194fc86099528$export$9b16b760c6b5c1ae)({
                        redirect: redirect,
                        smsEnabled: data.smsEnabled,
                        twoFaEnabled: data.twoFaEnabled,
                        emailEnabled: data.emailEnabled,
                        hash: data.hash,
                        isBillingRoute: isBillingsearch
                    }));
                    (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('login_form', {
                        email: formData.email,
                        status: 'requires_2fa',
                        auth_methods: {
                            sms: data.smsEnabled,
                            twoFa: data.twoFaEnabled,
                            email: data.emailEnabled
                        }
                    });
                }
                resetStates();
            } else {
                (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('login_form', {
                    email: formData.email,
                    status: 'failed',
                    error: response?.message
                });
                setIsLoading(false);
            }
        } else {
            (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('login_validation_error');
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Enter your email and password');
        }
    };
    const loginWithToken = async (data)=>{
        for (const key of [
            'token'
        ])//role
        document.cookie = `${key}=${data[key]};path=/`;
        (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(data['token']);
        localStorage.setItem('token', data['token']);
        localStorage.removeItem('anylistHowTo');
        if (data['role'] == 'Advisor') navigation($16250bd714b02a14$export$fa573b5b2799a94a);
        else if (data['role'] == 'Admin') setTimeout(()=>navigation('/admin'), 100);
        else if (data['role'] == 'Investor') setTimeout(()=>navigation($16250bd714b02a14$export$c45d6aa39a7ae97c), 100);
        else setTimeout(()=>navigation($16250bd714b02a14$export$4695c1a423ffe431), 100);
    };
    const handlePasswordBlur = (type)=>{
        let errors = {
            ...passwordError
        };
        const password = newPassword?.['password'];
        const confirmPassword = newPassword?.['confirmPassword'];
        if (type === 'password') {
            if (password === '' || password?.length < 8) errors['password'] = 'Password must be at least 8 characters long';
            else if (!PASSWORD_PATTERN.test(password)) errors['password'] = 'Password must contain atleast one capital letter, one special character and a number';
            else errors['password'] = '';
        }
        if (type === 'confirmPassword' || password && confirmPassword) {
            if (password === '' || password?.length < 8) errors['password'] = 'Password must be at least 8 characters long';
            else if (password !== confirmPassword) errors['confirmPassword'] = "Password and Confirm Password don't match";
            else if (!PASSWORD_PATTERN.test(password)) errors['password'] = 'Password must contain atleast one capital letter, one special character and a number';
            else errors['confirmPassword'] = '';
        }
        setPasswordError(errors);
        if (!errors['password'] && !errors['confirmPassword']) setIsValidNewPassword(true);
    };
    const handleSetPassword = async ()=>{
        if (passwordError['password'] == '' && passwordError['confirmPassword'] == '') {
            if (!location.pathname.includes('reset_password')) {
                (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('set_password_invalid_request');
                return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Invalid request try link from email');
            }
            setIsLoading(true);
            let params = location.pathname.split('/');
            let key = params[params.length - 1];
            (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('set_password_form', {
                status: 'attempting',
                has_errors: false
            });
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/setPassword`, {
                key: key,
                password: newPassword?.['password']
            });
            if (response && response['code'] == 200) {
                resetStates();
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: "passwordUpdatedSuccessfully"
                }));
                (0, $6ee05925f8d16f34$export$1deff90544a4c4e9)('passwordUpdatedSuccessfully');
                (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('set_password_form', {
                    status: 'success'
                });
            } else (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('set_password_form', {
                status: 'failed',
                error: response?.message
            });
            setIsLoading(false);
        } else (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('set_password_form', {
            status: 'validation_error',
            errors: passwordError
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-page",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-auth-main",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-auth-glow lp-auth-glow--tr",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-auth-glow lp-auth-glow--bl",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-auth-wrap lp-auth-wrap--narrow",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-auth-card",
                                children: operation == 'login' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "lp-auth-title",
                                            children: "Login to your"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "lp-auth-title pink",
                                            children: "Diligentsia account"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-auth-field lp-auth-field--icon-wide",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconMail, {})
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: "email",
                                                    type: "email",
                                                    value: formData?.['email'] || urlEmail || '',
                                                    placeholder: "Email address",
                                                    onChange: (e)=>{
                                                        if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                        setFormData({
                                                            ...formData,
                                                            email: e['target']['value']
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-auth-field lp-auth-field--icon-wide lp-auth-field--pw",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconLock, {})
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: "password",
                                                    type: passwordType ? 'password' : 'text',
                                                    placeholder: "Password",
                                                    value: formData?.['password'] || '',
                                                    onChange: (e)=>{
                                                        if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                        setFormData({
                                                            ...formData,
                                                            password: e['target']['value']
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    className: "toggle-pw",
                                                    onClick: ()=>setPasswordType(!passwordType),
                                                    children: passwordType ? /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconEye, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconEyeOff, {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-auth-actions mt2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                disabled: !isLogin,
                                                className: `lp-auth-submit ${!isLogin ? 'is-disabled' : ''}`,
                                                onClick: ()=>login(),
                                                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-spinner fa-spin"
                                                }) : 'Login'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-auth-links",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    className: "pink",
                                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                                    onClick: ()=>(0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('create_account_link'),
                                                    children: "Create new account"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    className: "blue",
                                                    to: $16250bd714b02a14$export$e479859894f5f058,
                                                    onClick: ()=>(0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('forgot_password_link'),
                                                    children: "Forgotten password?"
                                                })
                                            ]
                                        })
                                    ]
                                }) : operation == 'setPassword' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "lp-auth-title",
                                            children: "Set New"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "lp-auth-title pink",
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "lp-auth-field lp-auth-field--icon-wide lp-auth-field--pw",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconLock, {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "newPassword",
                                                            type: newPasswordType['passwordType'] ? 'password' : 'text',
                                                            placeholder: "New Password",
                                                            value: newPassword?.['password'] || '',
                                                            onChange: (e)=>{
                                                                setNewPassword({
                                                                    ...newPassword,
                                                                    password: e['target']['value']
                                                                });
                                                                setIsValidNewPassword(false);
                                                                setPasswordError({
                                                                    password: '',
                                                                    confirmPassword: ''
                                                                });
                                                            },
                                                            onBlur: (e)=>handlePasswordBlur('password'),
                                                            required: true
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "toggle-pw",
                                                            onClick: ()=>setNewPasswordType({
                                                                    ...newPasswordType,
                                                                    passwordType: !newPasswordType['passwordType']
                                                                }),
                                                            children: newPasswordType['passwordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconEye, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconEyeOff, {})
                                                        })
                                                    ]
                                                }),
                                                passwordError['password'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "lp-auth-error",
                                                    children: passwordError['password']
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "lp-auth-field lp-auth-field--icon-wide lp-auth-field--pw",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconLock, {})
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "confirmNewPassword",
                                                            type: newPasswordType['confirmPasswordType'] ? 'password' : 'text',
                                                            placeholder: "Confirm New Password",
                                                            value: newPassword?.['confirmPassword'] || '',
                                                            onChange: (e)=>{
                                                                setNewPassword({
                                                                    ...newPassword,
                                                                    confirmPassword: e['target']['value']
                                                                });
                                                                setIsValidNewPassword(false);
                                                                setPasswordError({
                                                                    password: '',
                                                                    confirmPassword: ''
                                                                });
                                                            },
                                                            onBlur: (e)=>handlePasswordBlur('confirmPassword'),
                                                            required: true
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            className: "toggle-pw",
                                                            onClick: ()=>setNewPasswordType({
                                                                    ...newPasswordType,
                                                                    confirmPasswordType: !newPasswordType['confirmPasswordType']
                                                                }),
                                                            children: newPasswordType['confirmPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconEye, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($b7fc0f1ed201d442$var$IconEyeOff, {})
                                                        })
                                                    ]
                                                }),
                                                passwordError['confirmPassword'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "lp-auth-error",
                                                    children: passwordError['confirmPassword']
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-auth-actions",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: `lp-auth-submit ${!isValidNewPassword ? 'is-disabled' : ''}`,
                                                onClick: ()=>handleSetPassword(),
                                                children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-spinner fa-spin"
                                                }) : 'Set Password'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-auth-links",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    className: "pink",
                                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                                    onClick: ()=>(0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('create_account_link'),
                                                    children: "Create new account"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "blue",
                                                    style: {
                                                        cursor: 'pointer'
                                                    },
                                                    onClick: ()=>handleOperation('refresh'),
                                                    children: "Login"
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-auth-trust",
                                children: "Trusted by 50+ investors, advisors & companies"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $b7fc0f1ed201d442$export$2e2bcd8739ae039 = $b7fc0f1ed201d442$var$Login;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $507eef80a3a0474f$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $507eef80a3a0474f$var$MILESTONES = [
    {
        year: '1999',
        title: "GeoCities \u2192 Yahoo!",
        sub: '$4.3bn exit',
        dot: '#FC7785'
    },
    {
        year: '2021',
        title: 'Wearable Technologies',
        sub: 'Sold to Blackline Safety (TSX)',
        dot: '#FC7785'
    },
    {
        year: '2022',
        title: 'Diligentsia founded',
        sub: 'Democratising transaction DD',
        dot: '#FC7785'
    },
    {
        year: 'Today',
        title: "40+ VCs \xb7 700+ investors",
        sub: "UK's leading readiness platform",
        dot: '#4A67FF'
    }
];

const $507eef80a3a0474f$var$AboutHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "Our Story"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: [
                                    "Built by people who've",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lp-h1",
                                        style: {
                                            color: '#FC7785'
                                        },
                                        children: "been in the room on both sides."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "As both serial founders and investors we spent decades raising capital, completing transactions, and advising growing businesses. We know what breaks deals \u2014 and we built Diligentsia to fix it."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--primary",
                                        href: $507eef80a3a0474f$var$KOALENDAR,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Book a call"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--pe-outline",
                                        href: "#team",
                                        children: "Meet the team \u2193"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-hero-social",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            background: '#FC7785',
                                            display: 'inline-block',
                                            flex: 'none'
                                        }
                                    }),
                                    "30+ years experience \xb7 4 IPOs \xb7 2 unicorns \xb7 25 M&A transactions"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w600px",
                            src: (parcelRequire("7CJbu")),
                            alt: "Diligentsia team"
                        })
                    })
                ]
            })
        ]
    });
var $507eef80a3a0474f$export$2e2bcd8739ae039 = $507eef80a3a0474f$var$AboutHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $db6c8f279f0bbd7a$var$CARDS = [
    {
        num: '01',
        title: 'Diligence is broken for SMEs',
        text: '70% of SME investment and exit transactions go undiligenced. Most companies arrive unprepared. Most early stage investors lose most of their money.'
    },
    {
        num: '02',
        title: "AI surfaces 10\xd7 more red flags",
        text: "New AI tools are surfacing 10\xd7 more due diligence red flags \u2014 creating more friction for unprepared companies. We are democratising the process by giving everyone the same tools."
    },
    {
        num: '03',
        title: 'Always-on readiness',
        text: "We are turning expensive, one-time transaction diligence into continuous readiness \u2014 so companies can raise or exit at any point in their lifecycle."
    }
];
const $db6c8f279f0bbd7a$var$AboutWhyExistSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-about-why",
        style: {
            marginBottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                className: "lp-about-why-glow lp-about-why-glow--1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                className: "lp-about-why-glow lp-about-why-glow--2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-quotes-eyebrow",
                        style: {
                            display: 'inline-flex'
                        },
                        "data-lp-reveal": true,
                        children: "Why we exist"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "lp-h2",
                        style: {
                            color: '#fff',
                            marginBottom: 56
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        children: [
                            "70% of SME transactions go undiligenced. ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lp-h2",
                                style: {
                                    color: '#FC7785'
                                },
                                children: "We're fixing that."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-about-why-cards",
                        children: $db6c8f279f0bbd7a$var$CARDS.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-about-why-card",
                                "data-lp-reveal": true,
                                "data-lp-delay": i * 100,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "num",
                                        children: c.num
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: c.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: c.text
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
var $db6c8f279f0bbd7a$export$2e2bcd8739ae039 = $db6c8f279f0bbd7a$var$AboutWhyExistSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $43c896d7c6cf64eb$var$LinkedInIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "9",
                width: "4",
                height: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "4",
                cy: "4",
                r: "2"
            })
        ]
    });


const $43c896d7c6cf64eb$var$TEAM = [
    {
        role: 'Founder & CEO',
        name: 'Mark Bernstein',
        linkedin: 'https://www.linkedin.com/in/markbernstein',
        img: (parcelRequire("9sq0N")),
        photoBg: '#EEF1FF',
        bullets: [
            'Chartered Accountant, 30+ years across startups, VC-backed and LSE/AIM-listed companies',
            "4 IPOs including two unicorns \u2014 GeoCities sold to Yahoo! for $4.3bn",
            '25 M&A transactions as founder, CFO, chair and NED',
            'Wearable Technologies sold to Blackline Safety Corp (TSX) 2021'
        ]
    },
    {
        role: 'Chief Technology Officer',
        name: 'Jon Bradshaw',
        linkedin: 'https://www.linkedin.com/in/jmbradshaw',
        img: (parcelRequire("gxwGu")),
        photoBg: '#EEF1FF',
        bullets: [
            'Fractional and full-time CTO across B2B SaaS, health, pharma, adtech, and web3',
            "Named inventor on multiple patents; built the world's first online Fantasy Football game",
            'VP Engineering, Elliptic (crypto AML); CTO, FITFILE (real-world health evidence)'
        ]
    }
];
const $43c896d7c6cf64eb$var$AboutTeamSlider = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "team",
        className: "lp-about-team",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-badge",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                        "The team"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-about-team-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-h2",
                            "data-lp-reveal": true,
                            children: "Meet the people behind Diligentsia."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-sub",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Operators, investors, and technologists who've done it before."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-about-team-list",
                    children: $43c896d7c6cf64eb$var$TEAM.map((p, i)=>// Reason: odd cards mirror to photo-left so the stacked pair reads as one composition.
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                            className: `lp-about-person-card${i % 2 ? ' lp-about-person-card--flip' : ''}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 120,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "copy",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "role",
                                            children: p.role
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: p.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            className: "li",
                                            href: p.linkedin,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($43c896d7c6cf64eb$var$LinkedInIcon, {}),
                                                "LinkedIn"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "bullets",
                                            children: p.bullets.map((b, j)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "\u2192"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: b
                                                        })
                                                    ]
                                                }, j))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "photo",
                                    style: {
                                        background: p.photoBg
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: p.img,
                                        alt: p.name
                                    })
                                })
                            ]
                        }, i))
                })
            ]
        })
    });
var $43c896d7c6cf64eb$export$2e2bcd8739ae039 = $43c896d7c6cf64eb$var$AboutTeamSlider;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $560d16798825a58a$export$145a783b8793b02 = (rootRef, dep)=>{
    (0, $acw62.useEffect)(()=>{
        const root = rootRef?.current;
        if (!root) return;
        const els = Array.from(root.querySelectorAll('[data-lp-reveal]'));
        const show = (el)=>{
            if (el._revealed) return;
            el._revealed = true;
            const d = parseFloat(el.getAttribute('data-lp-delay') || '0');
            setTimeout(()=>el.classList.add('is-in'), d);
        };
        let io;
        try {
            io = new IntersectionObserver((entries)=>{
                entries.forEach((e)=>{
                    if (e.isIntersecting) {
                        show(e.target);
                        io.unobserve(e.target);
                    }
                });
            }, {
                threshold: 0.12,
                rootMargin: '0px 0px -6% 0px'
            });
            els.forEach((el)=>io.observe(el));
        } catch (e) {
            els.forEach(show);
        }
        const safety = setTimeout(()=>els.forEach(show), 1200);
        return ()=>{
            if (io) io.disconnect();
            clearTimeout(safety);
        };
    }, [
        rootRef,
        dep
    ]);
};
const $560d16798825a58a$export$8bb697ee33fbba2b = (rootRef)=>{
    (0, $acw62.useEffect)(()=>{
        const root = rootRef?.current;
        if (!root) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const els = Array.from(root.querySelectorAll('[data-count]'));
        const run = (el)=>{
            if (el._counted) return;
            el._counted = true;
            const target = parseFloat(el.getAttribute('data-count'));
            const prefix = el.getAttribute('data-prefix') || '';
            const suffix = el.getAttribute('data-suffix') || '';
            if (reduce || isNaN(target)) {
                el.textContent = prefix + target + suffix;
                return;
            }
            const dur = 1300, start = performance.now();
            const step = (now)=>{
                const t = Math.min((now - start) / dur, 1);
                el.textContent = prefix + Math.round(target * (1 - Math.pow(1 - t, 3))) + suffix;
                if (t < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
        };
        let io;
        try {
            io = new IntersectionObserver((entries)=>entries.forEach((e)=>{
                    if (e.isIntersecting) run(e.target);
                }), {
                threshold: 0.4
            });
            els.forEach((el)=>io.observe(el));
        } catch (e) {
            els.forEach(run);
        }
        const safety = setTimeout(()=>els.forEach(run), 1600);
        return ()=>{
            if (io) io.disconnect();
            clearTimeout(safety);
        };
    }, [
        rootRef
    ]);
};
// Shared wrap timing — keep in sync with the 1.4s track transitions in _landing.sass.
const $560d16798825a58a$var$WRAP_ANIM_MS = 1450;
const $560d16798825a58a$export$2df8346413809f96 = (total, { autoplayMs: autoplayMs = 0 } = {})=>{
    const viewportRef = (0, $acw62.useRef)(null);
    const trackRef = (0, $acw62.useRef)(null);
    const pausedRef = (0, $acw62.useRef)(false);
    const wrappingRef = (0, $acw62.useRef)(false);
    const [page, setPage] = (0, $acw62.useState)(0);
    const [pages, setPages] = (0, $acw62.useState)(1);
    const pageRef = (0, $acw62.useRef)(0);
    pageRef.current = page;
    const visibleFor = (w)=>w >= 760 ? 3 : w >= 480 ? 2 : 1;
    // Append clones of the first `v` real cards so the wrap-around has something to slide onto.
    const ensureClones = (track, v)=>{
        const existing = track.querySelectorAll('[data-lp-clone]');
        if (existing.length === Math.min(v, total)) return;
        existing.forEach((n)=>n.remove());
        const real = Array.from(track.children);
        real.slice(0, Math.min(v, total)).forEach((c)=>{
            const k = c.cloneNode(true);
            k.setAttribute('data-lp-clone', '');
            k.setAttribute('aria-hidden', 'true');
            track.appendChild(k);
        });
    };
    const layout = (0, $acw62.useCallback)(()=>{
        const vp = viewportRef.current, track = trackRef.current;
        if (!vp || !track || !total) return;
        const gap = 24;
        const v = visibleFor(vp.clientWidth);
        ensureClones(track, v);
        const cardW = Math.max(0, (vp.clientWidth - (v - 1) * gap) / v);
        Array.from(track.children).forEach((c)=>{
            c.style.width = cardW + 'px';
        });
        const newPages = Math.max(1, Math.ceil(total / v));
        const p = Math.min(pageRef.current, newPages - 1);
        const maxOffset = Math.max(0, total - v);
        // While wrapping we slide past the last real card onto the clones (offset = total cards).
        const offset = wrappingRef.current ? total : Math.min(p * v, maxOffset);
        track.style.transform = `translateX(${-(offset * (cardW + gap))}px)`;
        setPages(newPages);
        if (!wrappingRef.current && p !== pageRef.current) setPage(p);
    }, [
        total
    ]);
    (0, $acw62.useEffect)(()=>{
        layout();
        const raf = requestAnimationFrame(layout);
        const t1 = setTimeout(layout, 350);
        const onResize = ()=>layout();
        window.addEventListener('resize', onResize, {
            passive: true
        });
        return ()=>{
            cancelAnimationFrame(raf);
            clearTimeout(t1);
            window.removeEventListener('resize', onResize);
        };
    }, [
        layout
    ]);
    (0, $acw62.useEffect)(()=>{
        layout();
    }, [
        page,
        layout
    ]);
    const goTo = (0, $acw62.useCallback)((p)=>{
        if (!wrappingRef.current) setPage(p);
    }, []);
    const next = (0, $acw62.useCallback)(()=>{
        if (wrappingRef.current || pages <= 1) return;
        if (pageRef.current >= pages - 1) {
            // Animate forward onto the cloned first cards, then snap (no transition) to the real start.
            wrappingRef.current = true;
            layout();
            setTimeout(()=>{
                const track = trackRef.current;
                if (track) track.style.transition = 'none';
                wrappingRef.current = false;
                setPage(0);
                requestAnimationFrame(()=>requestAnimationFrame(()=>{
                        if (track) track.style.transition = '';
                    }));
            }, $560d16798825a58a$var$WRAP_ANIM_MS);
        } else setPage((p)=>p + 1);
    }, [
        pages,
        layout
    ]);
    const prev = (0, $acw62.useCallback)(()=>{
        if (wrappingRef.current || pages <= 1) return;
        if (pageRef.current === 0) {
            // Jump (instantly) onto the clones, then animate one step back to the real last page.
            const track = trackRef.current;
            wrappingRef.current = true;
            if (track) track.style.transition = 'none';
            layout();
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
                    if (track) track.style.transition = '';
                    wrappingRef.current = false;
                    setPage(pages - 1);
                }));
        } else setPage((p)=>p - 1);
    }, [
        pages,
        layout
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!autoplayMs) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) return;
        // Reason: slides were rotating too quickly for users to read — enforce a comfortable minimum dwell time.
        const id = setInterval(()=>{
            if (!pausedRef.current) next();
        }, Math.max(autoplayMs, 9000));
        return ()=>clearInterval(id);
    }, [
        autoplayMs,
        next
    ]);
    const pause = ()=>{
        pausedRef.current = true;
    };
    const resume = ()=>{
        pausedRef.current = false;
    };
    return {
        viewportRef: viewportRef,
        trackRef: trackRef,
        page: page,
        pages: pages,
        next: next,
        prev: prev,
        goTo: goTo,
        pause: pause,
        resume: resume
    };
};
const $560d16798825a58a$export$b59e40b0379665c7 = (total, { autoplayMs: autoplayMs = 0 } = {})=>{
    const pausedRef = (0, $acw62.useRef)(false);
    const wrappingRef = (0, $acw62.useRef)(false);
    const rawRef = (0, $acw62.useRef)(0);
    const [rawIndex, setRawIndex] = (0, $acw62.useState)(0); // 0..total — `total` is the cloned first slide
    const [instant, setInstant] = (0, $acw62.useState)(false); // true while snapping back without animation
    const setRaw = (i)=>{
        rawRef.current = i;
        setRawIndex(i);
    };
    const goTo = (0, $acw62.useCallback)((i)=>{
        if (!wrappingRef.current) setRaw(Math.max(0, Math.min(i, total - 1)));
    }, [
        total
    ]);
    const next = (0, $acw62.useCallback)(()=>{
        if (wrappingRef.current || total <= 1) return;
        if (rawRef.current >= total - 1) {
            // Animate forward onto the clone of slide 0, then snap (no transition) to the real slide 0.
            wrappingRef.current = true;
            setRaw(total);
            setTimeout(()=>{
                setInstant(true);
                setRaw(0);
                requestAnimationFrame(()=>requestAnimationFrame(()=>{
                        setInstant(false);
                        wrappingRef.current = false;
                    }));
            }, $560d16798825a58a$var$WRAP_ANIM_MS);
        } else setRaw(rawRef.current + 1);
    }, [
        total
    ]);
    const prev = (0, $acw62.useCallback)(()=>{
        if (wrappingRef.current || total <= 1) return;
        if (rawRef.current === 0) {
            // Jump (instantly) onto the clone, then animate one slide back to the real last slide.
            wrappingRef.current = true;
            setInstant(true);
            setRaw(total);
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
                    setInstant(false);
                    setRaw(total - 1);
                    wrappingRef.current = false;
                }));
        } else setRaw(rawRef.current - 1);
    }, [
        total
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!autoplayMs) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) return;
        // Reason: slides were rotating too quickly for users to read — enforce a comfortable minimum dwell time.
        const id = setInterval(()=>{
            if (!pausedRef.current) next();
        }, Math.max(autoplayMs, 9000));
        return ()=>clearInterval(id);
    }, [
        autoplayMs,
        next
    ]);
    const pause = ()=>{
        pausedRef.current = true;
    };
    const resume = ()=>{
        pausedRef.current = false;
    };
    const index = rawIndex % total;
    const trackStyle = {
        transform: `translateX(-${rawIndex * 100}%)`,
        ...instant ? {
            transition: 'none'
        } : {}
    };
    return {
        index: index,
        trackStyle: trackStyle,
        total: total,
        next: next,
        prev: prev,
        goTo: goTo,
        pause: pause,
        resume: resume
    };
};


const $2ae05a8241e1ac5d$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $2ae05a8241e1ac5d$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $2ae05a8241e1ac5d$var$LinkedInIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "9",
                width: "4",
                height: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "4",
                cy: "4",
                r: "2"
            })
        ]
    });



const $2ae05a8241e1ac5d$var$ADVISORS = [
    {
        tag: 'Advisory Board',
        name: 'Paul Morris',
        role: 'Head of Growth Advisory',
        linkedin: 'https://www.linkedin.com/in/paul-morrisba884730',
        img: (parcelRequire("hntTQ")),
        bullets: [
            "Until July 2026 led BDOs Growth Advisory practice nationally",
            "Former Partner, Livingbridge VC \u2014 14+ years in tech-enabled businesses",
            "Director, Barclays Bank \u2014 18 years across credit and leveraged finance"
        ]
    },
    {
        tag: 'Advisory Board',
        name: 'Alex Faulconbridge',
        role: 'Investment Manager (FoF)',
        linkedin: 'https://www.linkedin.com/in/alexfaulconbridge',
        img: (parcelRequire("5bmwc")),
        bullets: [
            "Involved in British Business Bank\u2019s deployment of its funds into sector-specific venture and growth funds",
            "Supported \xa3200m+ across 10 funds spanning climate tech and fintech",
            'CFA Investment Foundations qualified; Bloomberg Market Concepts certified'
        ]
    },
    {
        tag: 'Advisory Board',
        name: 'Jim Tunstall',
        role: 'CEO & Scale-Up Expert',
        linkedin: 'https://www.linkedin.com/in/jamestunstall-3b7336341',
        img: (parcelRequire("g82aP")),
        bullets: [
            "Devised Innovate UK Scaleup Programme \u2014 300+ SMEs, \xa3789m+ capital raised",
            "Founded BPS Group \u2014 zero to \xa314m, 4 companies, 87 staff, successful trade sale",
            '35+ years as CEO, MD, and transformation leader across SMEs and large organisations'
        ]
    }
];
const $2ae05a8241e1ac5d$var$renderAdvisorSlide = (a, key, isClone = false)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-about-slide",
        "aria-hidden": isClone || undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-about-advisor-card",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "photo",
                    src: a.img,
                    alt: a.name
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "copy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tag",
                            children: a.tag
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "name",
                            children: a.name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "role",
                            children: a.role
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "li",
                            href: a.linkedin,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($2ae05a8241e1ac5d$var$LinkedInIcon, {}),
                                "LinkedIn"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bullets",
                            children: a.bullets.map((b, j)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "\u2192"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: b
                                        })
                                    ]
                                }, j))
                        })
                    ]
                })
            ]
        })
    }, key);
const $2ae05a8241e1ac5d$var$AboutAdvisorySlider = ()=>{
    const { index: index, trackStyle: trackStyle, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$b59e40b0379665c7)($2ae05a8241e1ac5d$var$ADVISORS.length, {
        autoplayMs: 5000
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-about-advisory",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-badge",
                        "data-lp-reveal": true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                            "Advisory board & investors"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-sec-head",
                        style: {
                            margin: '0 0 48px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "lp-h2",
                                        "data-lp-reveal": true,
                                        children: "Senior expertise, backing the mission."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "lp-sub",
                                        "data-lp-reveal": true,
                                        "data-lp-delay": "60",
                                        children: "People who understand both the problem and the opportunity."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-arrows",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "lp-arrow",
                                        "aria-label": "Previous advisor",
                                        onClick: prev,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ae05a8241e1ac5d$var$ChevronL, {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "lp-arrow",
                                        "aria-label": "Next advisor",
                                        onClick: next,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ae05a8241e1ac5d$var$ChevronR, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-about-slide-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-about-slide-track",
                    style: trackStyle,
                    children: [
                        $2ae05a8241e1ac5d$var$ADVISORS.map((a, i)=>$2ae05a8241e1ac5d$var$renderAdvisorSlide(a, i)),
                        $2ae05a8241e1ac5d$var$renderAdvisorSlide($2ae05a8241e1ac5d$var$ADVISORS[0], 'clone-first', true)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-container lp-about-slide-foot",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            index + 1,
                            " / ",
                            $2ae05a8241e1ac5d$var$ADVISORS.length
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-dots",
                        children: Array.from({
                            length: $2ae05a8241e1ac5d$var$ADVISORS.length
                        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `lp-dot ${i === index ? 'is-active' : ''}`,
                                "aria-label": `Go to slide ${i + 1}`,
                                onClick: ()=>goTo(i)
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $2ae05a8241e1ac5d$export$2e2bcd8739ae039 = $2ae05a8241e1ac5d$var$AboutAdvisorySlider;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $ce5909df1b890520$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $ce5909df1b890520$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $ce5909df1b890520$var$QUOTES = [
    {
        q: "Diligentsia is genuinely solving a problem that has plagued the SME investment ecosystem for decades. The platform makes investor readiness accessible to everyone \u2014 not just those who can afford \xa340k diligence.",
        a: "\u2014 Paul Morris, Head of Growth Advisory"
    },
    {
        q: 'The ability to help companies self-certify their readiness is a game-changer. It changes the quality of the deal flow coming through the ecosystem.',
        a: "\u2014 Alex Faulconbridge, Investment Manager"
    },
    {
        q: "Having worked with hundreds of growth businesses, I've seen the gap between investment-ready and investment-unready close deals time and again. Diligentsia finally bridges it systematically.",
        a: "\u2014 Jim Tunstall, formerly Innovate UK Scaleup Programme Director"
    }
];
const $ce5909df1b890520$var$GLOWS = [
    {
        top: 593,
        left: -182,
        size: 480,
        c: 'rgba(135,38,48,.42)'
    },
    {
        top: -230,
        right: -100,
        size: 540,
        c: 'rgba(20,36,119,.4)'
    },
    {
        top: 476,
        left: 67,
        size: 520,
        c: 'rgba(34,47,115,.34)'
    }
];
const $ce5909df1b890520$var$pos = (v)=>v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v;
const $ce5909df1b890520$var$AboutQuotesSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, page: page, pages: pages, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)($ce5909df1b890520$var$QUOTES.length, {
        autoplayMs: 5500
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-quotes",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-quotes-bg",
                "aria-hidden": "true",
                children: $ce5909df1b890520$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: $ce5909df1b890520$var$pos(g.top),
                            left: $ce5909df1b890520$var$pos(g.left),
                            right: $ce5909df1b890520$var$pos(g.right),
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(80px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        children: "Trusted by investors, advisors, and companies."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-arrows",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Previous quotes",
                                onClick: prev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ce5909df1b890520$var$ChevronL, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Next quotes",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ce5909df1b890520$var$ChevronR, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-slide-anim",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-track",
                            ref: trackRef,
                            children: $ce5909df1b890520$var$QUOTES.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                    className: "lp-qcard",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": i % 3 * 120,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("figcaption", {
                                            children: item.a
                                        })
                                    ]
                                }, i))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-foot",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        "data-lp-reveal": true,
                        children: "What they say."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-dots",
                        style: {
                            margin: 0,
                            padding: 0
                        },
                        children: Array.from({
                            length: pages
                        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `lp-dot ${i === page ? 'is-active' : ''}`,
                                "aria-label": `Go to slide ${i + 1}`,
                                onClick: ()=>goTo(i)
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $ce5909df1b890520$export$2e2bcd8739ae039 = $ce5909df1b890520$var$AboutQuotesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $ac17fae533e6fc40$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const $ac17fae533e6fc40$var$AboutCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cta-card",
            "data-lp-reveal": true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cta-glow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Ready to work with us?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "sub",
                            children: "Book a call with Mark \u2014 founder and CEO of Diligentsia."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "lp-cta-btn",
                            href: $ac17fae533e6fc40$var$KOALENDAR,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "av",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("7oN30")),
                                        alt: "Mark Bernstein"
                                    })
                                }),
                                "Book a call"
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $ac17fae533e6fc40$export$2e2bcd8739ae039 = $ac17fae533e6fc40$var$AboutCtaSection;



const $55e201de1e0213a0$var$AboutUs = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $507eef80a3a0474f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db6c8f279f0bbd7a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $43c896d7c6cf64eb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ae05a8241e1ac5d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac17fae533e6fc40$export$2e2bcd8739ae039), {})
        ]
    });
};
var $55e201de1e0213a0$export$2e2bcd8739ae039 = $55e201de1e0213a0$var$AboutUs;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

/**
 * Back arrow for the standalone partner pages (MorseBridge / Certifii / Vaultinum).
 *
 * These pages are reached from a dashboard tab in the same browser tab, so the visitor needs a way
 * back. Falls back to the home page when there is no history to pop — e.g. the URL was opened
 * directly or pasted — so the button is never a dead end.
 */ const $97a032079b4069a8$var$PageBackButton = ({ className: className = '' })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const goBack = ()=>{
        if (window.history.length > 1) navigate(-1);
        else navigate('/');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
        type: "button",
        onClick: goBack,
        className: `dlg-page-back ${className}`.trim(),
        "aria-label": "Go back",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2.2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M19 12H5"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 19l-7-7 7-7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "Back"
            })
        ]
    });
};
var $97a032079b4069a8$export$2e2bcd8739ae039 = $97a032079b4069a8$var$PageBackButton;


/**
 * Diligentsia × Morsebridge co-branded partnership landing page.
 *
 * Opened in a new browser tab from the Financial / Technology tabs on the company, advisor and
 * investor dashboards. Renders standalone — see STANDALONE_ROUTES in constants/routes.js — because
 * it ships its own header and footer rather than the site chrome.
 */ const $c258519ff7ca2636$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
var $70a70d8f8eea4b6a$exports = {};
$70a70d8f8eea4b6a$exports = new URL("diligentsia-icon.2d20d42a.png", import.meta.url).toString();


var $bcf230cc347ba2fb$exports = {};
$bcf230cc347ba2fb$exports = new URL("morsebridge-logo.a2616dc1.png", import.meta.url).toString();


var $70cfcaa4fef51a69$exports = {};
$70cfcaa4fef51a69$exports = new URL("morsebridge-icon.ebe35931.png", import.meta.url).toString();


var $ec1873b081335dfd$exports = {};
$ec1873b081335dfd$exports = new URL("morsebridge-hero.9f123c4a.png", import.meta.url).toString();


const $c258519ff7ca2636$var$RESOURCES = [
    {
        label: 'RESOURCE',
        title: 'Sample IC memo',
        desc: 'An anonymized investment committee memo produced from a live deal. Shows exactly what you receive and to what standard.',
        cta: 'Download PDF'
    },
    {
        label: 'RESOURCE',
        title: 'AI deal-sourcing guide',
        desc: 'How we build proprietary origination pipelines across web, filings and trade sources, and verify every signal before it reaches you.',
        cta: 'Download PDF'
    },
    {
        label: 'TOOL',
        title: 'LP Scouting Tool',
        desc: 'A basic version, free for PE and VC firms. Identify and shortlist limited partners that fit your fund profile, then take the shortlist straight into outreach.',
        cta: 'Open Tool'
    }
];
// Cards 1–6 are Morsebridge-attributed, 7–9 Diligentsia-attributed.
const $c258519ff7ca2636$var$SERVICES = [
    {
        brand: 'mb',
        title: 'Deal sourcing',
        desc: 'Proprietary origination and target identification, verified across multiple sources.'
    },
    {
        brand: 'mb',
        title: 'CIM and SIM screening',
        desc: 'Fast first-view screening of inbound opportunities with a clear go or pass read.'
    },
    {
        brand: 'mb',
        title: 'Commercial due diligence',
        desc: 'Market, customer and competitive assessment to test the investment thesis.'
    },
    {
        brand: 'mb',
        title: 'Financial due diligence and QoE',
        desc: 'Quality of earnings, addback validation and an adjusted EBITDA you can defend.'
    },
    {
        brand: 'mb',
        title: 'Management due diligence',
        desc: 'Owner dependence, team capability and key-person risk assessment.'
    },
    {
        brand: 'mb',
        title: 'IC memo preparation',
        desc: 'Decision-ready investment committee memos built from the diligence record.'
    },
    {
        brand: 'dg',
        title: 'Investment readiness and diligence packs',
        desc: 'Diligence-pack creation and reverse vendor diligence, financial and technical.'
    },
    {
        brand: 'dg',
        title: 'Portfolio monitoring',
        desc: 'Post-investment reporting roll-ups and performance monitoring across the portfolio.'
    },
    {
        brand: 'dg',
        title: 'Exit preparation',
        desc: 'Exit-readiness assessment and vendor diligence, viewed the way a buyer will.'
    }
];
const $c258519ff7ca2636$var$Lockup = ({ small: small })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `mb-lockup${small ? ' mb-lockup--sm' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "mb-lockup-mark",
                src: $70a70d8f8eea4b6a$exports,
                alt: "Diligentsia"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mb-lockup-word",
                children: "Diligentsia"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mb-lockup-x",
                children: "\xd7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "mb-lockup-mb",
                src: $bcf230cc347ba2fb$exports,
                alt: "Morsebridge"
            })
        ]
    });
const $c258519ff7ca2636$var$MorseBridge = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mb-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "mb-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97a032079b4069a8$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c258519ff7ca2636$var$Lockup, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        className: "mb-btn mb-btn--outline",
                        href: $c258519ff7ca2636$var$KOALENDAR,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Book A Call"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                className: "mb-hero",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-eyebrow",
                                children: "Happy to announce our partnership with Morsebridge, the agent layer for private equity deal teams"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: "One Partner For The Full PE Deal Journey"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-body",
                                children: "Sourcing, diligence, monitoring and exit preparation, built into a stack that fits how your firm works."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-body mb-body--strong",
                                children: "Morsebridge Ventures will provide support to private equity firms and portfolio companies for deal flow automation."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb-body",
                                children: "Morsebridge builds a custom AI stack around your deal process. We give you the tools and workflows to run sourcing in-house, configured to your firm and supported by qualified advisors. Diligentsia provides investment readiness and diligence services to the target company."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-hero-card",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: $ec1873b081335dfd$exports,
                            alt: "Diligentsia and Morsebridge partnership"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "mb-dark",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-dark-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Free Resources & Tools"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb-sub",
                            children: "Three resources showing how we source, screen and diligence deals."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mb-res-grid",
                            children: $c258519ff7ca2636$var$RESOURCES.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb-res-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mb-res-label",
                                            children: r.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: r.title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: r.desc
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "mb-btn mb-btn--solid",
                                            rel: "noopener noreferrer",
                                            children: r.cta
                                        })
                                    ]
                                }, r.title))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                className: "mb-services",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Combined Services"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mb-services-intro",
                        children: "Each engagement is scoped to your firm. We build the tools and workflows into your stack, configured to how you source, diligence and monitor."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-svc-grid",
                        children: $c258519ff7ca2636$var$SERVICES.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `mb-svc-card mb-svc-card--${s.brand}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb-svc-head",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "mb-svc-icon",
                                                src: s.brand === 'mb' ? $70cfcaa4fef51a69$exports : $70a70d8f8eea4b6a$exports,
                                                alt: "",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mb-svc-brand",
                                                        children: s.brand === 'mb' ? 'MORESEBRIDGE' : 'DILIGENTSIA'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        children: s.title
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: s.desc
                                    })
                                ]
                            }, s.title))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "mb-cta",
                id: "book",
                style: {
                    marginBottom: '0px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Talk to us about your next deal"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Tell us where you are in the process. We will tell you what we can deliver, the scope and the timeline."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "mb-btn mb-btn--cta",
                            href: $c258519ff7ca2636$var$KOALENDAR,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Book A Call"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("footer", {
                className: "mb-footer",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c258519ff7ca2636$var$Lockup, {
                        small: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "mb-footer-note",
                        children: [
                            "A DILIGENTSIA AND MORSEBRIDGE",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "PARTNERSHIP"
                        ]
                    })
                ]
            })
        ]
    });
var $c258519ff7ca2636$export$2e2bcd8739ae039 = $c258519ff7ca2636$var$MorseBridge;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

// Copy for the Diligentsia x Certifii pages — one entry per persona.
// Extracted from the three design handoffs; the markup lives in CertifiiSections.js.
// Each `tN` is a positional slot in that section's template: body text, a className variant, or an icon.

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $ad39d99d1e9d4075$export$ef3d0c0ebf284cb8 = {
    company: {
        CertifiiHero: {
            t1: "Build your financial model. Prove it stands up. Free, until you share it.",
            t2: "Certifii now being built into Diligentsia \u2014 a flexible model-building tool that turns a founder's numbers into a lender- and investor-ready case, scored against a standard both sides already trust.",
            t3: "Whether you're pre-seed and need a starter model, or Series A and building something sophisticated, the same tool builds it, stress-tests it, and scores it \u2014 ",
            t4: " anyone outside your business sees a number.",
            t5: "Free to build and self-diligence \xb7 Pay only when you share \xb7 20% off with your Diligentsia code"
        },
        CertifiiBenefits: {
            t1: "One tool, however far along you are",
            t2: "Certifii adapts to your stage \u2014 from a first set of numbers to a model that needs to survive investor or funder scrutiny.",
            t3: "Free",
            t4: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7 3.5h8.5L19 7v13.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.3 12.3l1.4 1.4L14 10.4"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.3 17l1.4 1.4L14 15.1"
                    }),
                    " "
                ]
            }),
            t5: "Answer 8 questions, get a starter model",
            t6: "Pre-seed? Skip the blank spreadsheet. Answer a short set of questions and Certifii builds your first working model.",
            t7: "Free",
            t8: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 20V14"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10 20V9"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M16 20V12.5"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.5 20V5"
                    }),
                    " "
                ]
            }),
            t9: "Build something more sophisticated",
            t10: "Series A companies get the full model-building toolkit \u2014 the same one fractional CFOs use for faster, standardised builds.",
            t11: "Free",
            t12: "Self-diligence with a CTI score",
            t13: "See your model the way a lender or investor will, before they do. Reverse-diligence it and fix what's weak first.",
            t14: "Shared tooling",
            t15: "The same platform your funders use",
            t16: "Investors and lenders on Diligentsia already assess models using Certifii. You're building in the language they read in."
        },
        CertifiiFlow: {
            t1: "Free to build. Free to check. Pay only to share.",
            t2: "Four steps from a blank page to a model your funding partner can act on.",
            t3: "Free",
            t4: "Build your model",
            t5: "Use Certifii's AI tools inside Diligentsia to build a model suited to your stage \u2014 starter or sophisticated.",
            t6: "Free",
            t7: "Self-diligence it",
            t8: "Run the same checks a diligence team would run, using the same tools we supply investors and lenders.",
            t9: "fc-price free",
            t10: "Free",
            t11: "Get your CTI score",
            t12: "A single, standardised Certifii Trust Index score across seven axes \u2014 the same score your funder will see.",
            t13: "fc-price paid",
            t14: "\xa359+VAT/mo",
            t15: "Share with your funder",
            t16: "When you're ready, share your model and diligence report \u2014 and it's added straight to your Diligence Pack.",
            t17: "Three free steps. ",
            t18: "One paid step, only when you're ready to raise."
        },
        CertifiiCti: {
            t1: "Instead of a lender or investor picking through your spreadsheet line by line, the CTI score gives everyone a common language \u2014 the same seven axes, every time.",
            t2: "Runs automatically as your model updates",
            t3: "Same scoring standard your funder already uses",
            t4: "cti-card cti-card-alt"
        },
        CertifiiPricing: {
            t1: "Nothing, until you're ready to put your model in front of someone else.",
            t2: "Model building, AI tooling and self-diligence. No card required, no time limit.",
            t3: "See exactly how your model would score with a funder \u2014 before you share it with one.",
            t4: "Only charged once you share your model and report \u2014 added to your Diligence Pack automatically.",
            t5: "Diligentsia companies get "
        },
        CertifiiFinal: {
            t1: "Talk to us about your model",
            t2: "Tell us your stage and what you're raising for. We'll show you what Certifii builds, what it costs to share, and how the CTI score works for your numbers.",
            t3: "Free to build and self-diligence \xb7 \xa359+VAT/month only when you share \xb7 20% off with code DG-20"
        }
    },
    advisor: {
        CertifiiHero: {
            t1: "Stop rebuilding the model from scratch. Build it with AI, prove it stands up, for every client.",
            t2: "Certifii now being built into Diligentsia \u2014 a model-building tool that replaces the ad hoc, error-prone spreadsheet you rebuild for every new engagement with AI tooling that builds a sophisticated, standardised model in a fraction of the time.",
            t3: "Whether it's a first forecast or a full three-statement build, the same tool builds it, stress-tests it, and scores it against the standard the investors and lenders on the other side of the table already use \u2014 ",
            t4: " you put a number in front of them.",
            t5: "Free to build for every client \xb7 Pay only when you share \xb7 Same CTI standard your funders already use"
        },
        CertifiiBenefits: {
            t1: "One tool. Every client. No more rebuilding from scratch.",
            t2: "Certifii replaces the ad hoc spreadsheet with an AI-built, standardised model \u2014 ready for whichever client and stage you're working on today.",
            t3: "AI-built",
            t4: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7 3.5h8.5L19 7v13.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.3 12.3l1.4 1.4L14 10.4"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.3 17l1.4 1.4L14 15.1"
                    }),
                    " "
                ]
            }),
            t5: "Build in hours, not days",
            t6: "Answer a short set of questions or bring your own data, and Certifii's AI tooling builds a full three-statement model \u2014 no more starting from a blank spreadsheet every time.",
            t7: "Standardised",
            t8: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 20V14"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10 20V9"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M16 20V12.5"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.5 20V5"
                    }),
                    " "
                ]
            }),
            t9: "The same build, every engagement",
            t10: "Stop reinventing the model each time you take on a client. One structure, one set of built-in analyses, applied consistently across your whole portfolio.",
            t11: "Free",
            t12: "Self-diligence with a CTI score",
            t13: "Run the same checks a lender or investor's diligence team would run \u2014 and see exactly how the model scores before anyone outside your client sees a number.",
            t14: "Shared tooling",
            t15: "The same platform your funders already use",
            t16: "Investors and lenders on Diligentsia already assess models using Certifii. Build in the language they read in, and skip the translation problem."
        },
        CertifiiFlow: {
            t1: "Free to build. Free to check. Pay only to share.",
            t2: "Four steps from a blank page \u2014 or a messy spreadsheet \u2014 to a model your client's funding partner can act on.",
            t3: "Free",
            t4: "Build with AI, not from scratch",
            t5: "Use Certifii's AI tools inside Diligentsia to build a sophisticated model for any client \u2014 a first forecast or a full three-statement build.",
            t6: "Free",
            t7: "Self-diligence it",
            t8: "Run the same checks a diligence team would run, using the same tools we supply investors and lenders \u2014 before anything leaves your desk.",
            t9: "fc-price free",
            t10: "Free",
            t11: "Get your CTI score",
            t12: "A single, standardised Certifii Trust Index score across seven axes \u2014 the same score your client's funder will see.",
            t13: "fc-price paid",
            t14: "\xa359+VAT/mo",
            t15: "Share with the funder",
            t16: "When the model's ready, share it and the diligence report \u2014 added straight to your client's Diligence Pack.",
            t17: "Three free steps. ",
            t18: "One paid step, only when a client is ready to raise."
        },
        CertifiiCti: {
            t1: "Instead of a lender or investor picking through the model line by line, the CTI score gives everyone a common language \u2014 the same seven axes, every time, for every client you work with.",
            t2: "Runs automatically as the model updates",
            t3: "Same scoring standard your clients' funders already use",
            t4: "cti-card cti-card-alt"
        },
        CertifiiScreens: {
            t1: "What you're actually building",
            t2: "No wireframes, no mockups \u2014 this is the real CTI dashboard the models you build are scored against.",
            t3: "The full CTI dashboard \u2014 score, axes and drivers, all in one view.",
            t4: "Drill into any metric \u2014 full analysis, not just a headline number.",
            t5: "See exactly what's driving the score \u2014 before your client's funder does."
        },
        CertifiiPricing: {
            t1: "Nothing, for any client, until a model is ready to go in front of someone else.",
            t2: "Model building, AI tooling and self-diligence \u2014 for every client. No card required, no time limit.",
            t3: "See exactly how any client's model would score with a funder \u2014 before you share it with one.",
            t4: "Only charged once you share a model and report \u2014 added to that client's Diligence Pack automatically.",
            t5: "Diligentsia advisors get "
        },
        CertifiiFinal: {
            t1: "Talk to us about your clients' models",
            t2: "Tell us how many clients you're building for and what stage they're at. We'll show you what Certifii builds, what it costs to share, and how the CTI score works across your portfolio.",
            t3: "Free to build and self-diligence \xb7 \xa359+VAT/month only when you share \xb7 20% off with code DG-20"
        }
    },
    investor: {
        CertifiiBenefits: {
            t1: "One standard for every company in your portfolio",
            t2: "Certifii gives you a common comparable for IC, and gives your portfolio companies the tooling to build a model that earns it.",
            t3: "Portfolio-wide",
            t4: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 20V14"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10 20V9"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M16 20V12.5"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.5 20V5"
                    }),
                    " "
                ]
            }),
            t5: "Compare every company, side by side",
            t6: "One CTI score, the same seven axes, run the same way for every business in your portfolio \u2014 no more re-learning each founder's spreadsheet from scratch.",
            t7: "IC-ready",
            t8: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7 3.5h8.5L19 7v13.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.3 12.3l1.4 1.4L14 10.4"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M9.3 17l1.4 1.4L14 15.1"
                    }),
                    " "
                ]
            }),
            t9: "A common comparable for Investment Committee",
            t10: "Bring the same standardised number to every IC paper \u2014 consistent methodology, drivers you can drill into, no house-by-house judgement calls.",
            t11: "Series A",
            t12: "Help your growth-stage companies build something sophisticated",
            t13: "Companies ready for a full three-statement model get the same AI-assisted toolkit \u2014 built to the standard your next round of diligence expects.",
            t14: "Fractional CFOs",
            t15: "A standardised toolkit for quick model building",
            t16: "Whoever builds the model \u2014 founder, in-house finance, or a fractional CFO \u2014 the same tool, the same structure, every time."
        },
        CertifiiFlow: {
            t1: "Free for your portfolio to build. Included for you to compare.",
            t2: "Four steps from a portfolio of disparate spreadsheets to one screen you can act on.",
            t3: "Free to companies",
            t4: "Invite your portfolio",
            t5: "Every company you invite gets free access to Certifii's AI model-building tools inside Diligentsia \u2014 no cost to them, no cost to you.",
            t6: "Free to companies",
            t7: "They build and self-diligence",
            t8: "A starter model or a sophisticated Series A build \u2014 either way, they run the same self-diligence checks before anything reaches you.",
            t9: "fc-price included",
            t10: "Included in your licence",
            t11: "It lands in your Deal Room",
            t12: "Once shared, the model, CTI score and diligence report drop straight into that company's Financial tab \u2014 automatically.",
            t13: "fc-price included",
            t14: "Included in your licence",
            t15: "You compare and decide",
            t16: "Every company on the same seven-axis standard, side by side \u2014 ready to take straight to Investment Committee.",
            t17: "Free for every portfolio company. ",
            t18: "One annual licence covers comparison across all of them."
        },
        CertifiiCti: {
            t1: "Instead of your team picking through each portfolio company's spreadsheet in a different way, the CTI score gives every business the same common language \u2014 the same seven axes, every time, across your whole portfolio.",
            t2: "Runs automatically as any portfolio company's model updates",
            t3: "The same standard, whichever company or fund stage you're looking at",
            t4: "cti-card"
        },
        CertifiiScreens: {
            t1: "What lands in your Deal Room",
            t2: "No wireframes, no mockups \u2014 this is the real CTI dashboard every portfolio company's model is scored against.",
            t3: "The full CTI dashboard \u2014 score, axes and drivers, all in one view, for every company you back.",
            t4: "Drill into any metric for any company \u2014 full analysis, not just a headline number.",
            t5: "See exactly what's driving the score \u2014 before it's ever raised at IC."
        },
        CertifiiFinal: {
            t1: "Talk to us about your portfolio",
            t2: "Tell us how many companies you back and where they're at. We'll show you what Certifii builds for them, what lands in your Deal Room, and how the CTI score works across your portfolio.",
            t3: "\xa37,500+VAT/year, 50 CTI assessments a year \xb7 Free for every company to build and self-diligence prior to sharing \xb7 CTI scoring built into your Deal Room"
        }
    }
};
var $ad39d99d1e9d4075$export$2e2bcd8739ae039 = $ad39d99d1e9d4075$export$ef3d0c0ebf284cb8;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $a8Wtc = parcelRequire("a8Wtc");
var $f75589df2eaeec15$exports = {};
$f75589df2eaeec15$exports = new URL("certifii.3c485a26.png", import.meta.url).toString();


var $dd2d3f74f690ce5b$exports = {};
$dd2d3f74f690ce5b$exports = new URL("where-to-start-1.349d250e.png", import.meta.url).toString();


var $c12aa6225e171ae9$exports = {};
$c12aa6225e171ae9$exports = new URL("where-to-start-2.ea1103a2.png", import.meta.url).toString();


var $560d7fdc23429da5$exports = {};
$560d7fdc23429da5$exports = new URL("CTI-dashboard-1.349d250e.png", import.meta.url).toString();


var $1a8b041ba29ba71d$exports = {};
$1a8b041ba29ba71d$exports = new URL("CTI-dashboard-2.ea1103a2.png", import.meta.url).toString();


var $3a414a1afbdbb08c$exports = {};
$3a414a1afbdbb08c$exports = new URL("CTI-dashboard-3.e4a70932.png", import.meta.url).toString();


// Every "Book a call" on these pages goes to the same booking link.
const $9744916bb28a58b3$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $9744916bb28a58b3$export$fe4cf4d97101f972 = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: "wrap cb-header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97a032079b4069a8$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "brands",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "dlg-mark",
                                src: $a8Wtc,
                                alt: "Diligentsia"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "x",
                                children: "\xd7"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "certifii-mark",
                                src: $f75589df2eaeec15$exports,
                                alt: "Certifii"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: $9744916bb28a58b3$var$KOALENDAR,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "btn btn-primary",
                children: "Book a call"
            })
        ]
    });
const $9744916bb28a58b3$export$ad4a145d2859edf6 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "cb-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "cb-hero-glow"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "wrap cb-hero-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "hero-eyebrow-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "eyebrow",
                                        children: "Partnership with Certifii"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "hero-eyebrow-logo",
                                        src: $f75589df2eaeec15$exports,
                                        alt: "Certifii"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: c.t1
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lead",
                                children: c.t2
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "lead",
                                children: [
                                    c.t3,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "before"
                                    }),
                                    c.t4
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cb-hero-ctas",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: $9744916bb28a58b3$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "btn btn-primary",
                                    style: {
                                        width: '150px'
                                    },
                                    children: "Book a call"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cb-hero-footnote",
                                children: c.t5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "cb-hero-visual",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cti-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-head",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            children: "Certifii Trust Index (CTI)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "illus",
                                            children: "Illustrative"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-ring-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-ring",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    viewBox: "0 0 120 120",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "60",
                                                            cy: "60",
                                                            r: "52",
                                                            fill: "none",
                                                            stroke: "#E7E9EF",
                                                            strokeWidth: "12"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "60",
                                                            cy: "60",
                                                            r: "52",
                                                            fill: "none",
                                                            stroke: "#0E2235",
                                                            strokeWidth: "12",
                                                            strokeDasharray: "326.7",
                                                            strokeDashoffset: "176.4",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "cti-num",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "n",
                                                            children: "46"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "d",
                                                            children: "/100"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-ring-label",
                                            children: [
                                                "Overall CTI score,",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "updated live as the model changes"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axes",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Free Cash"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '72%',
                                                            background: '#F87D38'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Liquidity"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '61%',
                                                            background: '#F87D38'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Profitability"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '39%',
                                                            background: '#F87D38'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Stress Resilience"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '75%',
                                                            background: '#F87D38'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Forecast Evidence"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '15%',
                                                            background: '#0E2235'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Forecast Discipline"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '82%',
                                                            background: '#0E2235'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Forecast Coherence"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '100%',
                                                            background: '#4E9F9A'
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
const $9744916bb28a58b3$export$c6a463642ad3b0bb = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "cb-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "cb-hero-glow"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "wrap cb-hero-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "hero-eyebrow-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "eyebrow",
                                        children: "Partnership with Certifii"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "hero-eyebrow-logo",
                                        src: $f75589df2eaeec15$exports,
                                        alt: "Certifii"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: "Stop reviewing every portfolio model by hand. See every company on one standard."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lead",
                                children: "Reviewing disparate financial models across a portfolio is time-consuming and doesn't scale \u2014 every founder builds differently, and every model needs re-learning before you can trust it. Certifii, now being built into Diligentsia, standardises, diligences and compares every portfolio company's model against the same seven-axis standard."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "lead",
                                children: [
                                    "Give your portfolio the same tooling \u2014 an AI-built starter model, a sophisticated Series A build, or the standardised toolkit fractional CFOs use \u2014 and what lands in your Deal Room is ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: " already "
                                    }),
                                    " in a shape you can compare, and take straight to IC."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cb-hero-ctas",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: $9744916bb28a58b3$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "btn btn-primary",
                                    style: {
                                        width: '150px'
                                    },
                                    children: "Book a call"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cb-hero-footnote",
                                children: "One licence, one portfolio \xb7 Free for every portfolio company to build and self-diligence prior to sharing \xb7 IC-ready comparables"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "cb-hero-visual",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pf-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pf-head",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            children: "Portfolio Index \u2014 Financial"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "illus",
                                            children: "Illustrative"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pf-sub",
                                    children: "CTI scores across your portfolio, one screen"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pf-tabs",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Portfolio"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Your Firm"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "InvestorMatch"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "AnyList"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "active",
                                            children: "Financial"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Technology"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pf-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pf-co",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pf-dot",
                                                    style: {
                                                        background: '#1EAD5C'
                                                    }
                                                }),
                                                "Solace Biotech Ltd"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '78%',
                                                    background: '#1EAD5C'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-score good",
                                            children: "78"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pf-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pf-co",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pf-dot",
                                                    style: {
                                                        background: '#F87D38'
                                                    }
                                                }),
                                                "Northbridge Foods"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '57%',
                                                    background: '#F87D38'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-score mid",
                                            children: "57"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pf-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pf-co",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pf-dot",
                                                    style: {
                                                        background: '#FB7785'
                                                    }
                                                }),
                                                "Vantage Robotics"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '39%',
                                                    background: '#FB7785'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-score watch",
                                            children: "39"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pf-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pf-co",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pf-dot",
                                                    style: {
                                                        background: '#1EAD5C'
                                                    }
                                                }),
                                                "Halo Diagnostics"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '82%',
                                                    background: '#1EAD5C'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pf-score good",
                                            children: "82"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
const $9744916bb28a58b3$export$d5e1361c750e61cb = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "benefits-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "benefits-grid",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: c.t4
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t5
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t6
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t7
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: c.t8
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t9
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t10
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t11
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M4 15.5a8 8 0 1 1 16 0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12 15.5l4.2-5.2"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "12",
                                                cy: "15.5",
                                                r: "1.15",
                                                fill: "currentColor",
                                                stroke: "none"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t12
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t13
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "7.5",
                                                cy: "7.5",
                                                r: "3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "16.5",
                                                cy: "16.5",
                                                r: "3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M9.8 9.8l4.4 4.4"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t15
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t16
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $9744916bb28a58b3$export$87f5b4b9f1e7c121 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "flow-section",
        id: "how-it-works",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "eyebrow",
                            children: "How it works"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flow-grid",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fc-price free",
                                    children: c.t3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: c.t4
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 2"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fc-price free",
                                    children: c.t6
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: c.t7
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t8
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 3"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: c.t9,
                                    children: c.t10
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: c.t11
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t12
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 4"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: c.t13,
                                    children: c.t14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: c.t15
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t16
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "flow-footnote",
                    children: [
                        c.t17,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: c.t18
                        })
                    ]
                })
            ]
        })
    });
const $9744916bb28a58b3$export$8909dae13f6ca924 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "cti-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cti-copy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "eyebrow",
                            children: "The Certifii Trust Index"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "A single score, built from seven things that actually predict trouble"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: c.t2
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: c.t3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Drill into any axis to see exactly what's driving the number"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: c.t4,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cti-head",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Certifii Trust Index (CTI)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "illus",
                                    children: "Illustrative"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cti-ring-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-ring",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            viewBox: "0 0 120 120",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "60",
                                                    cy: "60",
                                                    r: "52",
                                                    fill: "none",
                                                    stroke: "#E7E9EF",
                                                    strokeWidth: "12"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "60",
                                                    cy: "60",
                                                    r: "52",
                                                    fill: "none",
                                                    stroke: "#4A67FF",
                                                    strokeWidth: "12",
                                                    strokeDasharray: "326.7",
                                                    strokeDashoffset: "140.5",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cti-num",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "n",
                                                    children: "57"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "d",
                                                    children: "/100"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-ring-label",
                                    children: [
                                        "Overall CTI score,",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "updated live as the model changes"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cti-axes",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Free Cash"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '72%',
                                                    background: '#4A67FF'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "72"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Liquidity"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '61%',
                                                    background: '#4A67FF'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "61"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Profitability"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '39%',
                                                    background: '#FB7785'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val warn",
                                            children: "39"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Stress Resilience"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '75%',
                                                    background: '#4A67FF'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "75"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Forecast Evidence"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '15%',
                                                    background: '#FB7785'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val warn",
                                            children: "15"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Forecast Discipline"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '82%',
                                                    background: '#1EAD5C'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "82"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cti-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Forecast Coherence"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '100%',
                                                    background: '#1EAD5C'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "100"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $9744916bb28a58b3$export$83379335d26ec8f0 = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "tiers-section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "tiers-bg-1",
                src: $dd2d3f74f690ce5b$exports,
                alt: ""
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "tiers-bg-2",
                src: $c12aa6225e171ae9$exports,
                alt: ""
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "wrap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "section-head",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: "Choose where to start"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Choose the route that fits the business and the raise today. The CTI can be upgraded later as more evidence and financial detail become available."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tiers-grid",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tier-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tier-tag",
                                        children: "Baseline Forecast"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Make the case for your first raise"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tier-audience",
                                        children: "For pre-seed and seed businesses."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Set out what is being raised, what it unlocks and the milestones it needs to fund. Give potential backers a clear picture of the next stage of the business, even before there is a long trading history."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tier-note",
                                        children: "Start the funding conversation with a plan that makes sense."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tier-card highlight",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tier-tag",
                                        children: "Certifii Lite"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Turn trading progress into a case for more capital"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tier-audience",
                                        children: "For founders with trading history and a larger raise ahead."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Bring together revenue, costs, cash and plans so a capital provider can understand what the business has achieved, what comes next and why the funding is needed."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tier-note",
                                        children: "Help the right capital provider see the business being built, not just the fragments they happen to receive."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tier-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tier-tag",
                                        children: "Certifii Pro"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Give the people around the raise a model they can stand behind"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tier-audience",
                                        children: "For CFOs, accountants and advisers."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Build the detailed financial model behind the case, including the funding, tax and accounting treatment properly to explain the plan and answer the questions that follow."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tier-note",
                                        children: "Give the finance team one case they can explain, challenge and maintain."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "tiers-footnote",
                        children: "One plan. A clearer case for capital. Every route connects the plan to its cash consequences and highlights the questions that still need answering. As evidence and detail are added, it becomes easier for the people evaluating the business to act."
                    })
                ]
            })
        ]
    });
const $9744916bb28a58b3$export$168f424597f2f23c = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "screens-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "screens-lead",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: $560d7fdc23429da5$exports,
                            alt: "Full Certifii Trust Index dashboard with drivers panel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "screens-caption",
                            children: c.t3
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "screens-pair",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "screens-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: $1a8b041ba29ba71d$exports,
                                    alt: "Drill-down analysis on a single CTI axis"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "screens-caption",
                                    children: c.t4
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "screens-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: $3a414a1afbdbb08c$exports,
                                    alt: "Positive and watch drivers behind the CTI score"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "screens-caption",
                                    children: c.t5
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $9744916bb28a58b3$export$eda261c34c038e6f = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "pricing-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "What does it cost?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pricing-grid",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "price-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-tag",
                                    children: "Build"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Free"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-amount",
                                    children: "\xa30"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "p-desc",
                                    children: c.t2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "price-card highlight",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-tag",
                                    children: "Get your CTI score"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Free"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-amount",
                                    children: "\xa30"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "p-desc",
                                    children: c.t3
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "price-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-tag",
                                    children: "Share with a funder"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "\xa359+VAT/mo"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "p-amount",
                                    children: [
                                        "\xa359",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '14px',
                                                color: 'var(--body-text)',
                                                fontWeight: '500'
                                            },
                                            children: "+VAT/mo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "p-desc",
                                    children: c.t4
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "promo-box",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "promo-left",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "promo-label",
                                    children: "Promo code"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "pb-text",
                                    children: [
                                        c.t5,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "20% off"
                                        }),
                                        "all Certifii plans."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "promo-code-chip",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pcc-text",
                                    children: "DG-20"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pcc-hint",
                                    children: "Enter at checkout"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $9744916bb28a58b3$export$791e4a14810d6d00 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "pricing-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "What does it cost?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "One annual licence for your firm. Nothing extra for your portfolio companies to build and self-diligence prior to sharing."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pricing-single",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "p-tag",
                            children: "Diligentsia \xd7 Certifii for Investors"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            children: "Annual licence"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p-amount",
                            children: [
                                "\xa37,500",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "+VAT / year"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "p-desc",
                            children: "2 seats and 50 CTI assessments a year, plus public index access \u2014 for one price, for your whole firm."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pricing-included",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pi-item",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pi-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M4 20V14"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M10 20V9"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16 20V12.5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.5 20V5"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pi-label",
                                    children: "50 CTI assessments a year"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pi-item",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pi-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M7 3.5h8.5L19 7v13.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M9.3 12.3l1.4 1.4L14 10.4"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M9.3 17l1.4 1.4L14 15.1"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pi-label",
                                    children: "Free build & self-diligence prior to sharing"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pi-item",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pi-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "7.5",
                                                cy: "7.5",
                                                r: "3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "16.5",
                                                cy: "16.5",
                                                r: "3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M9.8 9.8l4.4 4.4"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pi-label",
                                    children: "Side-by-side portfolio comparison"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pi-item",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pi-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M4 15.5a8 8 0 1 1 16 0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12 15.5l4.2-5.2"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "12",
                                                cy: "15.5",
                                                r: "1.15",
                                                fill: "currentColor",
                                                stroke: "none"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pi-label",
                                    children: "IC-ready CTI reporting"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $9744916bb28a58b3$export$582e9cafc1ad1248 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "final-section",
        id: "book-a-call",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "wrap",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "final-cta",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: c.t1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: c.t2
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "final-cta-ctas",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                href: $9744916bb28a58b3$var$KOALENDAR,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "btn btn-white",
                                style: {
                                    gap: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w30px dlg-inline-mark",
                                        src: $a8Wtc,
                                        alt: "Diligentsia"
                                    }),
                                    "Book a call"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "#",
                                className: "btn btn-orange",
                                children: "View sample report"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "final-footnote",
                        children: c.t3
                    })
                ]
            })
        })
    });


/**
 * Diligentsia x Certifii — the Financial tab destination, opened in a new browser tab.
 *
 * One page serves all three personas. Six sections are shared and driven by CERTIFII_CONTENT;
 * the rest vary by audience:
 *   - hero / pricing — company and advisor share a layout, investor has its own
 *   - tiers          — company only ("Choose where to start")
 *   - screens        — advisor and investor only (CTI dashboard screenshots)
 *
 * @param {'company'|'advisor'|'investor'} persona - which audience this page addresses
 */ const $af4eea075ad440c5$var$CertifiiPage = ({ persona: persona = 'company' })=>{
    const c = (0, $ad39d99d1e9d4075$export$2e2bcd8739ae039)[persona] || (0, $ad39d99d1e9d4075$export$2e2bcd8739ae039)['company'];
    const isInvestor = persona === 'investor';
    return(// `is-investor` scopes the three CSS rules whose values differ from the other personas.
    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `dlg-certifii-module${isInvestor ? ' is-investor' : ''}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$fe4cf4d97101f972), {}),
            isInvestor ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$c6a463642ad3b0bb), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$ad4a145d2859edf6), {
                c: c['CertifiiHero']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$d5e1361c750e61cb), {
                c: c['CertifiiBenefits']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$87f5b4b9f1e7c121), {
                c: c['CertifiiFlow']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$8909dae13f6ca924), {
                c: c['CertifiiCti']
            }),
            persona === 'company' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$83379335d26ec8f0), {}),
            persona !== 'company' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$168f424597f2f23c), {
                c: c['CertifiiScreens']
            }),
            isInvestor ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$791e4a14810d6d00), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$eda261c34c038e6f), {
                c: c['CertifiiPricing']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9744916bb28a58b3$export$582e9cafc1ad1248), {
                c: c['CertifiiFinal']
            })
        ]
    }));
};
var $af4eea075ad440c5$export$2e2bcd8739ae039 = $af4eea075ad440c5$var$CertifiiPage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

// Copy for the Diligentsia x Vaultinum pages — one entry per persona.
// Extracted from the three design handoffs; the markup lives in VaultinumSections.js.
// Each `tN` is a positional slot in that section's template: body text, a className variant, or an icon.

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $5d50054c31600708$export$65ca217110912e41 = {
    company: {
        VltHero: {
            t1: "Know what a buyer will find in your codebase \u2014 before they go looking.",
            t2: "Vaultinum's technology due diligence is now being built into Diligentsia \u2014 the same code-scan and expert analysis investors run on a target, run on your own business first, without handing anyone the keys.",
            t3: "Technical debt, security gaps and licensing issues cost the most when a buyer finds them mid-deal. Find them yourself, fix what you can, and walk into the transaction with the story already written \u2014 ",
            t4: ".",
            t5: "Assessment in hours, not weeks \xb7 No source code leaves your servers \xb7 From \xa3750+VAT per transaction"
        },
        VltBenefits: {
            t1: "Fix it before they price it in",
            t2: "Investors and acquirers already run this analysis on you. Running it on yourself first turns their diligence process into confirmation, not discovery.",
            t3: "Protect valuation",
            t4: "Fix problems on your own timeline",
            t5: "Red flags found mid-transaction get discounted hard and fast. The same issues found early can be remediated or explained \u2014 before they touch your price.",
            t6: "No exposure",
            t7: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "5",
                        y: "10.5",
                        width: "14",
                        height: "9",
                        rx: "1.5"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7"
                    }),
                    " "
                ]
            }),
            t8: "Your code never leaves your servers",
            t9: "Vaultinum's Docker-based scan runs locally \u2014 no upload, no outside access. 4 in 10 companies refuse full code access to a buyer; this gets the same depth without asking.",
            t10: "Removes delay",
            t11: "No more surprise-driven delays",
            t12: "Issues discovered during buyer diligence mean re-negotiation and extended exclusivity. Self-diligence removes the biggest single cause of deals slipping.",
            t13: "From \xa3750",
            t14: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 15.5a8 8 0 1 1 16 0"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 15.5l4.2-5.2"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "12",
                        cy: "15.5",
                        r: "1.15",
                        fill: "currentColor",
                        stroke: "none"
                    }),
                    " "
                ]
            }),
            t15: "What used to cost tens of thousands, now costs hundreds",
            t16: "AI-assisted code scanning brings technical due diligence down from weeks and a five-figure fee to hours and a few hundred pounds \u2014 worth running before every raise, not just an exit."
        },
        VltDocker: {
            t1: "A full technical audit \u2014 without opening your source code to anyone",
            t2: "Technical due diligence tools ask you to upload your codebase to a third party's servers, or grant a buyer's advisors direct access to your repositories. Understandably, a lot of companies say no.",
            t3: "Vaultinum runs its code scan inside a Docker container on your own infrastructure. The analysis happens locally; only the findings \u2014 the report, the scores, the remediation plan \u2014 ever leave the building. And then you delete the docker.",
            t4: "of companies refuse to grant full source-code access during a transaction. The Docker approach gets you an investor-grade report without the risk."
        },
        VltFlow: {
            t1: "Four steps from a first look at your own tech to a report a buyer's advisors will actually accept.",
            t2: "Vaultinum's scanner runs inside a Docker container on your own infrastructure. Nothing is uploaded \u2014 only the results come out.",
            t3: "Get your Tech Trust report",
            t4: "Share it, or fix it first",
            t5: "Add the report straight to your Diligence Pack when you're ready, or use the remediation plan to clear issues before anyone outside your business sees a number."
        },
        VltScore: {
            t1: "A single score, plus what it will cost \u2014 and how long \u2014 to fix what's underneath it",
            t2: "Technical due diligence used to stop at a list of problems. Vaultinum's report now goes one step further: for each critical finding, an estimate of the remediation cost and the time it will take, so you know exactly what you're walking into.",
            t3: "Covers scalability, cybersecurity, technical debt, open-source risk, team stability and AI maturity",
            t4: "Every critical finding comes with an estimated cost and timeline to remediate"
        },
        VltScreens: {
            t1: "What the report actually looks like",
            t2: "Real screens from the Vaultinum platform \u2014 the same views your buyer's technical advisors would otherwise be building for themselves.",
            t3: "Scores benchmarked against industry averages, with critical issues and recommendations surfaced up front.",
            t4: "Knowledge distribution across the team \u2014 a key-person risk buyers always ask about, answered before they do."
        },
        VltPricing: {
            t1: "Two free steps to see where you stand. One clear fee for the full report.",
            t2: "Online questionnaire on Diligentsia platform. No card required, nothing leaves your infrastructure.",
            t3: "Investor-ready report with scores, drivers and remediation cost/timeline \u2014 added to your Diligence Pack when you're ready.",
            t4: "Historically this level of technical due diligence took weeks and cost tens of thousands of pounds \u2014 out of reach for anything but the largest deals. AI-assisted analysis brings it down to hours and a few hundred pounds, so it's worth running before every raise, not just an exit."
        },
        VltFinal: {
            t1: "Talk to us about your tech",
            t2: "Tell us what you're building towards \u2014 a raise, an exit, or just peace of mind \u2014 and we'll show you what the report covers, what it costs, and what a buyer would already see.",
            t3: "Free self-assessment, no code leaves your servers \xb7 \xa3750+VAT for the full report \xb7 Add straight to your Diligence Pack"
        }
    },
    advisor: {
        VltHero: {
            t1: "The technical due diligence your client's buyer is about to run anyway \u2014 now standard, in hours.",
            t2: "Falling cost and rising speed are turning technical due diligence into a routine part of every transaction, not just the largest ones. Vaultinum's code-scan and expert analysis \u2014 now being built into Diligentsia \u2014 let you offer your clients what investors and acquirers are increasingly going to expect as standard.",
            t3: "Run it on your client before their buyer does. Flag the red flags, cost and time to fix them, and walk into diligence with a defensible number \u2014 ",
            t4: " per transaction.",
            t5: "Add to any mandate in hours, not weeks \xb7 No source code leaves your client's servers \xb7 From \xa3750+VAT per transaction"
        },
        VltBenefits: {
            t1: "Do for your client what their buyer is about to do anyway",
            t2: "Investors and acquirers already run this analysis as standard on larger deals \u2014 and falling cost is bringing it to every deal size. Offer it yourself, and you're ahead of the process instead of reacting to it.",
            t3: "De-risk the deal",
            t4: "Flag the red flags before the buyer does",
            t5: "Technical debt, security gaps and licensing issues are one of the most common causes of price chips and delayed completion. Surfacing them early protects your client's outcome \u2014 and your credibility as the advisor.",
            t6: "Stays private",
            t7: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "5",
                        y: "10.5",
                        width: "14",
                        height: "9",
                        rx: "1.5"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7"
                    }),
                    " "
                ]
            }),
            t8: "A workstream, not an exposure risk",
            t9: "Vaultinum's Docker-based scan runs locally, on your client's own infrastructure. You can offer deep technical diligence without ever asking them to open their codebase to anyone.",
            t10: "Every mandate",
            t11: "One methodology, every engagement",
            t12: "The same consistent scoring on every mandate, so you can benchmark one client against another and against sector norms \u2014 instead of starting from scratch each time.",
            t13: "No fee friction",
            t14: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 15.5a8 8 0 1 1 16 0"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 15.5l4.2-5.2"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "12",
                        cy: "15.5",
                        r: "1.15",
                        fill: "currentColor",
                        stroke: "none"
                    }),
                    " "
                ]
            }),
            t15: "Extend your service without extra hours",
            t16: "At a few hundred pounds a transaction, it's easy to fold into scope or pass through \u2014 no specialist fee conversation, and no in-house technical expertise required."
        },
        VltDocker: {
            t1: "A full technical audit \u2014 without asking your client to open their source code",
            t2: "Most technical due diligence tools ask your client to upload their codebase to a third party's servers, or grant a buyer's advisors direct access to their repositories. Understandably, a lot of companies say no \u2014 and that reluctance can stall a deal you're trying to keep moving.",
            t3: "Vaultinum runs its code scan inside a Docker container on your client's own infrastructure. The analysis happens locally; only the findings \u2014 the report, the scores, the remediation plan \u2014 ever leave the building. And then you delete the docker.",
            t4: "of companies refuse to grant full source-code access during a transaction. The Docker approach gets your client an investor-grade report without the risk."
        },
        VltFlow: {
            t1: "Four steps from a first look at your client's tech to a report their buyer's advisors will actually accept.",
            t2: "Vaultinum's scanner runs inside a Docker container on your client's own infrastructure. Nothing is uploaded \u2014 only the results come out.",
            t3: "Get the Tech Trust report",
            t4: "Add it to the deal materials",
            t5: "Add the report straight to your client's Diligence Pack, or use the remediation plan to help them clear issues before their buyer's advisors see a number."
        },
        VltScore: {
            t1: "One methodology, every client, every deal",
            t2: "Running due diligence differently for every engagement makes it hard to compare risk across your client base. The Tech Trust Score gives you one consistent methodology \u2014 the same scoring their buyer will eventually see.",
            t3: "The same six axes on every engagement \u2014 scalability, cybersecurity, technical debt, open-source risk, team stability and AI maturity",
            t4: "Every critical finding comes with an estimated cost and timeline to remediate, so you can talk numbers with confidence"
        },
        VltScreens: {
            t1: "What lands in your client's Diligence Pack",
            t2: "Real screens from the Vaultinum platform \u2014 the same views their buyer's technical advisors would otherwise spend weeks building for themselves.",
            t3: "Scores benchmarked against industry averages, ready to sit alongside the rest of your deal materials.",
            t4: "Knowledge distribution across the team \u2014 a key-person risk every buyer asks about, answered before they do."
        },
        VltPricing: {
            t1: "Two free steps to see where your client stands. One clear fee for the full report.",
            t2: "Online questionnaire on Diligentsia platform. No card required, nothing leaves your client's infrastructure.",
            t3: "Investor-ready report with scores, drivers and remediation cost/timeline \u2014 easy to fold into your existing fee or pass straight through.",
            t4: "Historically this level of technical due diligence took weeks and cost tens of thousands of pounds \u2014 reserved for the largest deals. AI-assisted analysis brings it down to hours and a few hundred pounds, which is exactly why it's becoming standard practice on every transaction, not just the big ones."
        },
        VltFinal: {
            t1: "Talk to us about your practice",
            t2: "Tell us the kind of mandates you run, and we'll show you what the report covers, what it costs, and how it slots into the diligence you already do.",
            t3: "Free self-assessment, no code leaves your client's servers \xb7 \xa3750+VAT for the full report \xb7 Add straight to their Diligence Pack"
        }
    },
    investor: {
        VltHero: {
            t1: "With technical due diligence this fast and this cheap, why wouldn't you run it on every deal?",
            t2: "Technical due diligence used to be reserved for the largest transactions \u2014 it was too slow and too expensive to justify anywhere else. Vaultinum's code-scan and expert analysis, now being built into Diligentsia, bring it down to hours and a few hundred pounds, on any deal in your pipeline.",
            t3: "Uncover tech debt, security gaps and licensing exposure a financial read can't see, with an estimated cost and timeline to fix each one \u2014 ",
            t4: " per transaction, without slowing exclusivity.",
            t5: "Same-day technical read \xb7 No source code leaves the target's servers \xb7 From \xa3750+VAT per transaction"
        },
        VltBenefits: {
            t1: "Why wouldn't you run this on every deal?",
            t2: "Technical due diligence used to be reserved for the largest transactions because it was slow and expensive. AI-assisted analysis has removed both objections \u2014 so skipping it on a smaller deal is now a decision you have to defend, not the default.",
            t3: "Hidden risk",
            t4: "Uncover what a financial read can't see",
            t5: "Technical debt, cybersecurity gaps, obsolescence and open-source licensing exposure stay invisible until someone actually looks at the code \u2014 before then, you're pricing the deal on incomplete information.",
            t6: "Priced in",
            t7: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M4 15.5a8 8 0 1 1 16 0"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12 15.5l4.2-5.2"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "12",
                        cy: "15.5",
                        r: "1.15",
                        fill: "currentColor",
                        stroke: "none"
                    }),
                    " "
                ]
            }),
            t8: "Quantify remediation cost, not just risk",
            t9: "Every critical finding comes with an estimated cost and timeline to fix \u2014 so you can reflect it in price, or build it straight into the post-completion plan, instead of guessing.",
            t10: "Comparable",
            t11: "The same score across every deal in your pipeline",
            t12: "One consistent methodology means you can compare technical risk across your pipeline as easily as you already compare financials \u2014 and rank deals accordingly.",
            t13: "No excuse to skip",
            t14: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        x: "5",
                        y: "10.5",
                        width: "14",
                        height: "9",
                        rx: "1.5"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7"
                    }),
                    " "
                ]
            }),
            t15: "Affordable enough for every deal, not just the largest",
            t16: "Hours and a few hundred pounds, instead of weeks and tens of thousands. There's no longer a size of deal where this isn't worth running."
        },
        VltDocker: {
            t1: "A full technical read on the target \u2014 without a fight over code access",
            t2: "Asking a target's management team to upload their codebase to a third party's servers, or grant your advisors direct access to their repositories, is one of the most common points of friction in due diligence. A lot of targets say no \u2014 and that reluctance can stall exclusivity or push out your timeline.",
            t3: "Vaultinum runs its code scan inside a Docker container on the target's own infrastructure. The analysis happens locally; only the findings \u2014 the report, the scores, the remediation plan \u2014 ever leave the building. And then you delete the docker.",
            t4: "of companies refuse to grant full source-code access during a transaction. The Docker approach gets you an investor-grade report without the fight."
        },
        VltFlow: {
            t1: "Four steps from a first read on the target's tech to a report your investment committee will actually sign off on.",
            t2: "Vaultinum's scanner runs inside a Docker container on the target's own infrastructure. Nothing is uploaded \u2014 only the results come out.",
            t3: "Get the Tech Trust report",
            t4: "Add it to your IC paper",
            t5: "Add the report straight to your Diligence Pack, and use the remediation plan to inform price, terms or the post-completion value creation plan."
        },
        VltScore: {
            t1: "One score, comparable across your entire pipeline",
            t2: "Financial risk gets ranked and compared across every deal you look at. Technical risk usually doesn't \u2014 until now. The Tech Trust Score gives every target the same consistent methodology, so technical risk sits alongside the financials, not as an afterthought.",
            t3: "The same six axes on every target \u2014 scalability, cybersecurity, technical debt, open-source risk, team stability and AI maturity",
            t4: "Every critical finding comes with an estimated cost and timeline to remediate, ready for your IC paper"
        },
        VltScreens: {
            t1: "What lands in your IC pack",
            t2: "Real screens from the Vaultinum platform \u2014 the same independent, data-backed view that gives your investment committee a firmer basis to sign off.",
            t3: "Scores benchmarked against industry averages, with critical issues and recommendations surfaced up front for the committee.",
            t4: "Knowledge distribution across the team \u2014 a key-person risk that matters as much post-completion as it does at signing."
        },
        VltPricing: {
            t1: "Two free steps to get a first read. One clear fee for the full report.",
            t2: "Online questionnaire on Diligentsia platform. No card required, nothing leaves the target's infrastructure.",
            t3: "Investor-ready report with scores, drivers and remediation cost/timeline \u2014 added straight to your Diligence Pack.",
            t4: "Historically this level of technical due diligence took weeks and cost tens of thousands of pounds \u2014 reserved for the largest transactions. AI-assisted analysis brings it down to hours and a few hundred pounds. At that price and speed, the question isn't whether you can afford to run it \u2014 it's why you wouldn't."
        },
        VltFinal: {
            t1: "Talk to us about your pipeline",
            t2: "Tell us about the deals you're running diligence on, and we'll show you what the report covers, what it costs, and how fast it can land on your desk.",
            t3: "Free self-assessment, no code leaves the target's servers \xb7 \xa3750+VAT for the full report \xb7 Add straight to your Diligence Pack"
        }
    }
};
var $5d50054c31600708$export$2e2bcd8739ae039 = $5d50054c31600708$export$65ca217110912e41;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

// Section components for the Diligentsia x Vaultinum pages. Each receives `c` — its slice of
// VAULTINUM_CONTENT for the active persona — so one set of markup serves all three audiences.
// Every "Book a call" goes to the same booking link.
const $ee064a5363aae5ee$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
var $acd77ffbc5d86c40$exports = {};
$acd77ffbc5d86c40$exports = new URL("diligentsia-logo.7f301676.png", import.meta.url).toString();


var $59d727d8b4b6e0d4$exports = {};
$59d727d8b4b6e0d4$exports = new URL("vaultinum.00e7d68f.png", import.meta.url).toString();


var $815620902a106680$exports = {};
$815620902a106680$exports = new URL("docker-no-code-access.911f8ee9.png", import.meta.url).toString();


var $1f5a86e398133560$exports = {};
$1f5a86e398133560$exports = new URL("tech-dd-dashboard.26743be2.png", import.meta.url).toString();


var $ab6a685efb2fdb5c$exports = {};
$ab6a685efb2fdb5c$exports = new URL("team-knowledge-distribution.2dbb281c.png", import.meta.url).toString();


const $ee064a5363aae5ee$export$4a24952f3bf258b7 = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: "wrap cb-header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97a032079b4069a8$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "brands",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "dlg-mark",
                                src: $acd77ffbc5d86c40$exports,
                                alt: "Diligentsia"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "x",
                                children: "\xd7"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "vlt-mark",
                                src: $59d727d8b4b6e0d4$exports,
                                alt: "Vaultinum"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: $ee064a5363aae5ee$var$KOALENDAR,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "btn btn-primary",
                children: "Book a call"
            })
        ]
    });
const $ee064a5363aae5ee$export$60a2a3d9ea9b9b74 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "cb-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "cb-hero-glow"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "wrap cb-hero-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "hero-eyebrow-row",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "eyebrow",
                                    children: "Partnership with Vaultinum"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: c.t1
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lead",
                                children: c.t2
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "lead",
                                children: [
                                    c.t3,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "from as little as \xa3750"
                                    }),
                                    c.t4
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cb-hero-ctas",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: $ee064a5363aae5ee$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "btn btn-primary",
                                    children: "Book a call"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cb-hero-footnote",
                                children: c.t5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "cb-hero-visual",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "score-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "sc-head",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            children: "Tech Trust Score"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "illus",
                                            children: "Illustrative"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-ring-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "score-ring",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    viewBox: "0 0 120 120",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "60",
                                                            cy: "60",
                                                            r: "52",
                                                            fill: "none",
                                                            stroke: "#E7E9EF",
                                                            strokeWidth: "12"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "60",
                                                            cy: "60",
                                                            r: "52",
                                                            fill: "none",
                                                            stroke: "#2D6FE0",
                                                            strokeWidth: "12",
                                                            strokeDasharray: "326.7",
                                                            strokeDashoffset: "140.5",
                                                            strokeLinecap: "round"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "sc-num",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "n",
                                                            children: "57"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "d",
                                                            children: "/100"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "score-ring-label",
                                            children: [
                                                "Overall score,",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "benchmarked against industry norms"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-axes",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "score-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Scalability"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '72%',
                                                            background: '#2D6FE0'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-val",
                                                    children: "72"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "score-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Cybersecurity"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '39%',
                                                            background: '#FB7785'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-val warn",
                                                    children: "39"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "score-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Technical debt"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '46%',
                                                            background: '#FB7785'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-val warn",
                                                    children: "46"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "score-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Open source risk"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '61%',
                                                            background: '#2D6FE0'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-val",
                                                    children: "61"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "score-axis-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-name",
                                                    children: "Team stability"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "axis-bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            width: '80%',
                                                            background: '#1EAD5C'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "axis-val",
                                                    children: "80"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "remediation-strip",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "rs-icon",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "9"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M12 7v5l3.5 2"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "rs-text",
                                            children: [
                                                "Est. remediation:",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "\xa338k\u2013\xa354k, 6\u20138 weeks"
                                                }),
                                                "to clear the two critical findings."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
const $ee064a5363aae5ee$export$3d064503afc32f9f = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "benefits-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "benefits-grid",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6l7-3Z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M9.3 12.3l1.4 1.4L14 10.4"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t4
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t5
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t6
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: c.t7
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t8
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t9
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t10
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "12",
                                                cy: "12",
                                                r: "9"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12 7v5l3.5 2"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t11
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t12
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "benefit-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "b-tag",
                                    children: c.t13
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "b-icon",
                                    children: c.t14
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.t15
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t16
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $ee064a5363aae5ee$export$dba4b1e0421c3310 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "docker-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap docker-grid",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "docker-copy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "eyebrow",
                            children: "The Docker difference"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t2
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t3
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "docker-stat",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "stat-num",
                                    children: "40%"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "stat-text",
                                    children: c.t4
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "docker-visual",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: $815620902a106680$exports,
                        alt: "How to run a technical audit without opening access to source code \u2014 red flag report and Docker code analysis options"
                    })
                })
            ]
        })
    });
const $ee064a5363aae5ee$export$ae9f8808f977442 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "flow-section",
        id: "how-it-works",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "eyebrow",
                            children: "How it works"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Free to check. A few hundred pounds when you're ready to audit."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flow-grid",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fc-price free",
                                    children: "Free"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Run the online assessment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "A short Diligentsia governance and infrastructure questionnaire \u2014 cybersecurity posture, SDLC, third-party licensing, data privacy, AI maturity \u2014 benchmarked against industry norms in minutes."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 2"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fc-price free",
                                    children: "\xa3750+VAT"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Scan the code, locally"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 3"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fc-price free",
                                    children: "Included"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: c.t3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "A full report scoring scalability, cybersecurity, technical debt and open-source risk \u2014 with estimated cost and time to fix each critical finding."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flow-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fc-step",
                                    children: "Step 4"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fc-price free",
                                    children: "Sharing Included"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: c.t4
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.t5
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $ee064a5363aae5ee$export$bd3b8afa6289250b = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "score-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "score-copy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "eyebrow",
                            children: "The Tech Trust Score"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t2
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: "Benchmarked against industry-standard scoring, not a subjective judgement call"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: c.t3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    children: c.t4
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "score-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "sc-head",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Tech Trust Score"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "illus",
                                    children: "Illustrative"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "score-ring-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-ring",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            viewBox: "0 0 120 120",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "60",
                                                    cy: "60",
                                                    r: "52",
                                                    fill: "none",
                                                    stroke: "#E7E9EF",
                                                    strokeWidth: "12"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "60",
                                                    cy: "60",
                                                    r: "52",
                                                    fill: "none",
                                                    stroke: "#0B2E5C",
                                                    strokeWidth: "12",
                                                    strokeDasharray: "326.7",
                                                    strokeDashoffset: "176.4",
                                                    strokeLinecap: "round"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "sc-num",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "n",
                                                    children: "46"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "d",
                                                    children: "/100"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-ring-label",
                                    children: [
                                        "Overall score,",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "updated on every re-scan"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "score-axes",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Scalability"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '55%',
                                                    background: '#E8A83C'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "55"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Cybersecurity"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '31%',
                                                    background: '#FB7785'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val warn",
                                            children: "31"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Technical debt"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '28%',
                                                    background: '#FB7785'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val warn",
                                            children: "28"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Open source risk"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '64%',
                                                    background: '#0B2E5C'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "64"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "score-axis-row",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-name",
                                            children: "Team stability"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "axis-bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: '73%',
                                                    background: '#1EAD5C'
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "axis-val",
                                            children: "73"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "remediation-strip",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "rs-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M4 20V14"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M10 20V9"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16 20V12.5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.5 20V5"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "rs-text",
                                    children: [
                                        "Est. remediation:",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: "\xa365k\u2013\xa390k, 10\u201314 weeks"
                                        }),
                                        "to clear cybersecurity and technical debt findings."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $ee064a5363aae5ee$export$be399d811feae179 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "screens-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: c.t1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "screens-pair",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "screens-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: "Tech Due Diligence dashboard showing scalability score and category benchmarks against industry average"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "screens-caption",
                                    children: c.t3
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "screens-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: "Team member per technology knowledge distribution chart"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "screens-caption",
                                    children: c.t4
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
const $ee064a5363aae5ee$export$fe37c8456ccf6c72 = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "pricing-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "section-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "What does it cost?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: c.t1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pricing-grid",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "price-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-tag",
                                    children: "Self-assessment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Free"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-amount",
                                    children: "\xa30"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "p-desc",
                                    children: c.t2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "price-card highlight",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "p-tag",
                                    children: "Full Tech Trust report"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "\xa3750+VAT"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "p-amount",
                                    children: [
                                        "\xa3750",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '14px',
                                                color: '#B7BFCC',
                                                fontWeight: '500'
                                            },
                                            children: "+VAT"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "p-desc",
                                    children: c.t3
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "pricing-footnote",
                    children: c.t4
                })
            ]
        })
    });
const $ee064a5363aae5ee$export$19af84e72bffed9d = ({ c: c })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "final-section",
        id: "book-a-call",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "wrap",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "final-cta",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: c.t1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: c.t2
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "final-cta-ctas",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "final-cta-logo",
                                src: $59d727d8b4b6e0d4$exports,
                                alt: "Vaultinum"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: $ee064a5363aae5ee$var$KOALENDAR,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "btn btn-white",
                                children: "Book a call"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "#",
                                className: "btn btn-navy",
                                children: "View sample report"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "final-footnote",
                        children: c.t3
                    })
                ]
            })
        })
    });


/**
 * Diligentsia x Vaultinum — the Technology tab destination, opened in a new browser tab.
 *
 * All three personas share the same eight sections; only the copy differs, so every section is
 * driven by VAULTINUM_CONTENT rather than duplicated per audience.
 *
 * @param {'company'|'advisor'|'investor'} persona - which audience this page addresses
 */ const $41f44fb76c6a08f2$var$VaultinumPage = ({ persona: persona = 'company' })=>{
    const c = (0, $5d50054c31600708$export$2e2bcd8739ae039)[persona] || (0, $5d50054c31600708$export$2e2bcd8739ae039)['company'];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "dlg-vaultinum-module",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$4a24952f3bf258b7), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$60a2a3d9ea9b9b74), {
                c: c['VltHero']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$3d064503afc32f9f), {
                c: c['VltBenefits']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$dba4b1e0421c3310), {
                c: c['VltDocker']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$ae9f8808f977442), {
                c: c['VltFlow']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$bd3b8afa6289250b), {
                c: c['VltScore']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$be399d811feae179), {
                c: c['VltScreens']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$fe37c8456ccf6c72), {
                c: c['VltPricing']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee064a5363aae5ee$export$19af84e72bffed9d), {
                c: c['VltFinal']
            })
        ]
    });
};
var $41f44fb76c6a08f2$export$2e2bcd8739ae039 = $41f44fb76c6a08f2$var$VaultinumPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $803d4ad2316930d5$exports = {};
$803d4ad2316930d5$exports = new URL("logo.a781d4d3.png", import.meta.url).toString();


var $af090a66589d0be5$exports = {};
$af090a66589d0be5$exports = new URL("hero-graphic.bfe69b21.png", import.meta.url).toString();


var $deb7afb67ccacb4c$exports = {};
$deb7afb67ccacb4c$exports = new URL("foster-neil-bio.e334a4b1.png", import.meta.url).toString();


var $74477b50c530a9dc$exports = {};
$74477b50c530a9dc$exports = new URL("paul-morris.299a0bb9.jpg", import.meta.url).toString();


var $cc666c22c28562c3$exports = {};
$cc666c22c28562c3$exports = new URL("ollie-austen.5f28745a.jpg", import.meta.url).toString();


var $977c96deabac7c47$exports = {};
$977c96deabac7c47$exports = new URL("call-button-mark.88558b90.png", import.meta.url).toString();


// HubSpot passive capture. The account is on EU data hosting, so the loader must stay pointed at
// js-eu1 — the generic snippet from HubSpot's docs will not work. Portal id from the integration
// brief. Reason: no HubSpot tracking exists anywhere else in this app, but the id is checked
// before injecting anyway, because two loaders on one page break form detection.
const $556c68a6e221b21b$var$HUBSPOT_PORTAL_ID = '147324908';
const $556c68a6e221b21b$var$HUBSPOT_SCRIPT_ID = 'hs-script-loader';
// The four radio values are a BLOCKER in the developer brief: HubSpot segments the whole email
// sequence on them, and a casing or wording mismatch silently routes fifteen emails to nobody.
const $556c68a6e221b21b$var$ICP_OPTIONS = [
    {
        value: 'founder',
        label: "I'm raising for my own company"
    },
    {
        value: 'advisor',
        label: 'I advise companies through raises'
    },
    {
        value: 'investor',
        label: 'I invest in companies'
    },
    {
        value: 'other',
        label: 'Something else'
    }
];
// Session copy. Kept here rather than fetched, so the page is one file. The title and the three
// session names are still unconfirmed with the partner, so expect to edit these before go-live.
const $556c68a6e221b21b$var$SESSION = {
    // Split so the hand-drawn ring can wrap "Mistakes", and so the desktop line breaks are the
    // handoff's own <br>s. The mobile artboard lets the title flow, so those <br>s hide there.
    titleBefore: 'Top Ten Common ',
    titleRinged: 'Mistakes',
    titleAfter: [
        'That Can Stall Your',
        'Raise or Exit'
    ],
    eyebrow: 'Webinar Registration - Session 1 of 4',
    tagline: 'Eliminate predictable show stoppers prior to deals',
    // The mobile artboard abbreviates the date; both render and CSS picks one.
    date: 'Friday 11 September',
    dateShort: 'Fri 11 Sep',
    time: "12:00\u201312:45 BST",
    session2Title: "Series A Term Sheets: What's Negotiable and What Isn't",
    session3Title: 'What Changes When Investors Join Your Board',
    // The real Zoom/Teams link, once Jignesh supplies it. Empty hides the "Join on the day" button
    // on the confirmation rather than shipping a dead link.
    joiningLink: ''
};
// Plain-text title, for the session list and the closing CTA band.
const $556c68a6e221b21b$var$SESSION_TITLE = `${$556c68a6e221b21b$var$SESSION.titleBefore}${$556c68a6e221b21b$var$SESSION.titleRinged} ${$556c68a6e221b21b$var$SESSION.titleAfter.join(' ')}`;
// Hosted calendar file, linked from the confirmation. It has to stay a real hosted file rather than
// anything bundled: HubSpot's confirmation email links to the same URL, and it only opens as a
// calendar entry when the server sends Content-Type: text/calendar.
const $556c68a6e221b21b$var$CALENDAR_URL = '/downloads/founder-series-session-1.ics';
// The speakers section is three identically-shaped rows, each under its own label. Neil's carries a
// bio and the credential chips where the other two carry a quote and a closing note.
const $556c68a6e221b21b$var$SPEAKER_ROWS = [
    {
        label: 'Introduction',
        img: $74477b50c530a9dc$exports,
        name: 'Paul Morris',
        role: 'Ex-Head of Growth Advisory, BDO',
        quote: '"Not being prepared and a lack of data integrity can lead to price chipping, but actually more often causes deals to fail. Anything you can do to reduce this is immensely valuable."',
        note: 'Paul brings an investor and growth-advisory perspective, having worked with growth businesses as an investor, banker, non-executive director and adviser.'
    },
    {
        label: 'Main Speaker',
        img: $deb7afb67ccacb4c$exports,
        name: 'Neil Foster',
        role: "Global Co-Chair of Technology Sector \xb7 Brown Rudnick LLP",
        bio: 'Neil is a leading VC Lawyer, he co-chairs Brown Rudnick\u2019s Global Technology group and is a lead partner in Emerging Growth Companies & Venture Capital, with 25 years advising on cross-border transactions. He has written a chapter on the Top Ten Common Mistakes featured in the book "Masters of Raising Venture Capital" edited by Andrew Romans, Silicon Valley.',
        chips: [
            "Chambers UK \xb7 Corporate/M&A since 2010",
            "Legal 500 \xb7 Leading Partner, Venture Capital",
            "Author \xb7 Masters of Raising Venture Capital, 2024"
        ]
    },
    {
        label: 'Wrap up',
        img: $cc666c22c28562c3$exports,
        name: 'Ollie Austen',
        role: 'Founder, Startup 2 Standup',
        quote: '"Neil\u2019s advice on this topic will be invaluable to companies looking to close their investment rounds or sell their businesses quickly and with certainty."',
        note: "Ollie brings the founder perspective and his experience supporting entrepreneurs through Startup to Standup - one of the UK\u2019s leading founder communities."
    }
];
// How long the splash sits over the page before fading out.
const $556c68a6e221b21b$var$LOADER_MS = 2000;
const $556c68a6e221b21b$var$PRACTICE_STEPS = [
    'Learn what to look for.',
    'Sign in with Free Diligence Account.',
    "Use Diligentsia's free checklist to apply the learning."
];
/**
 * Injects the HubSpot tracking loader once, immediately before </body>.
 * Removing it on unmount would leave HubSpot's own globals behind, so the script is left in place
 * and re-mounts are guarded by the element id instead.
 */ const $556c68a6e221b21b$var$useHubspotTracking = ()=>{
    (0, $acw62.useEffect)(()=>{
        if (document.getElementById($556c68a6e221b21b$var$HUBSPOT_SCRIPT_ID)) return;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = $556c68a6e221b21b$var$HUBSPOT_SCRIPT_ID;
        script.async = true;
        script.defer = true;
        script.src = `//js-eu1.hs-scripts.com/${$556c68a6e221b21b$var$HUBSPOT_PORTAL_ID}.js`;
        document.body.appendChild(script);
    }, []);
};
/** Holds the splash over the page for LOADER_MS, then releases it. */ const $556c68a6e221b21b$var$useSplash = ()=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>setIsLoading(false), $556c68a6e221b21b$var$LOADER_MS);
        return ()=>clearTimeout(timer);
    }, []);
    return isLoading;
};
/** Shows the sticky mobile CTA once the hero has scrolled out of view. */ const $556c68a6e221b21b$var$useStickyCta = (heroRef)=>{
    const [isStuck, setIsStuck] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const hero = heroRef.current;
        if (!hero || typeof IntersectionObserver === 'undefined') return;
        const observer = new IntersectionObserver(([entry])=>setIsStuck(!entry.isIntersecting), {
            threshold: 0
        });
        observer.observe(hero);
        return ()=>observer.disconnect();
    }, [
        heroRef
    ]);
    return isStuck;
};
/** The hand-drawn ring around "Mistakes" — two overlapping, counter-rotated ellipses. */ const $556c68a6e221b21b$var$TitleRing = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        className: "web-ring",
        viewBox: "0 0 220 90",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "110",
                cy: "45",
                rx: "104",
                ry: "38",
                stroke: "#FF4F6D",
                strokeWidth: "5",
                transform: "rotate(-4 110 45)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "113",
                cy: "43",
                rx: "101",
                ry: "35",
                stroke: "#FF4F6D",
                strokeWidth: "3.5",
                opacity: "0.55",
                transform: "rotate(3 113 43)"
            })
        ]
    });
/** The date, long on desktop and abbreviated on the mobile artboard. */ const $556c68a6e221b21b$var$SessionDate = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "web-date-long",
                children: $556c68a6e221b21b$var$SESSION.date
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "web-date-short",
                children: $556c68a6e221b21b$var$SESSION.dateShort
            })
        ]
    });
const $556c68a6e221b21b$var$WebinarLanding = ()=>{
    const [isRegistered, setIsRegistered] = (0, $acw62.useState)(false);
    const heroRef = (0, $acw62.useRef)(null);
    const isStuck = $556c68a6e221b21b$var$useStickyCta(heroRef);
    const isLoading = $556c68a6e221b21b$var$useSplash();
    $556c68a6e221b21b$var$useHubspotTracking();
    // Reason: the developer brief marks this a BLOCKER — HubSpot's own listener is on the same
    // submit event, so preventDefault() alone is allowed and stopPropagation() is not. Without
    // preventDefault the page reloads; with stopPropagation the submission silently never lands.
    const handleSubmit = (e)=>{
        e.preventDefault();
        setIsRegistered(true);
    };
    const { time: sessionTime, session2Title: session2Title, session3Title: session3Title, joiningLink: joiningLink } = $556c68a6e221b21b$var$SESSION;
    const heroArtAlt = 'The Diligentsia investment-readiness checklist, with Brown Rudnick and Startup 2 Standup';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "dlg-webinar",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `web-loader${isLoading ? '' : ' is-done'}`,
                role: "status",
                "aria-live": "polite",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "web-loader-ring",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "web-loader-label",
                        children: "Webinar"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "web-sr-only",
                        children: "Loading"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                        className: "web-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "web-logo",
                                    src: $803d4ad2316930d5$exports,
                                    alt: "Diligentsia"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "web-series",
                                children: "WEBINAR SERIES"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        ref: heroRef,
                        className: "web-hero",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "wrap web-hero-inner",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "web-hero-grid",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "web-hero-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "web-eyebrow",
                                                children: $556c68a6e221b21b$var$SESSION.eyebrow
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                                className: "web-h1",
                                                children: [
                                                    $556c68a6e221b21b$var$SESSION.titleBefore,
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            position: 'relative',
                                                            display: 'inline-block'
                                                        },
                                                        children: [
                                                            $556c68a6e221b21b$var$SESSION.titleRinged,
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($556c68a6e221b21b$var$TitleRing, {})
                                                        ]
                                                    }),
                                                    $556c68a6e221b21b$var$SESSION.titleAfter.map((line)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {
                                                                    className: "web-h1-br"
                                                                }),
                                                                ' ',
                                                                line
                                                            ]
                                                        }, line))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "web-tagline",
                                                children: $556c68a6e221b21b$var$SESSION.tagline
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "web-hero-art-m",
                                                src: $af090a66589d0be5$exports,
                                                alt: heroArtAlt
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "web-hero-meta",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($556c68a6e221b21b$var$SessionDate, {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "web-dot",
                                                        children: "\xb7"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: sessionTime
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "web-dot",
                                                        children: "\xb7"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Online"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "web-dot web-date-long",
                                                        children: "\xb7"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "web-free",
                                                        children: "Free"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "web-cta-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                        className: "web-cta",
                                                        href: "#register",
                                                        children: "Reserve your place \u2192"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "web-cta-note",
                                                        children: "Takes under a minute"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "web-hero-art",
                                        src: $af090a66589d0be5$exports,
                                        alt: heroArtAlt
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        style: {
                            borderTop: '1px solid #e4e4e9',
                            backgroundColor: '#F5F6FF',
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "wrap web-sec web-issues",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "web-issues-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-issues-h",
                                            children: "Small issues can become big problems in a transaction."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-issues-body",
                                            children: "Share rights. Equity. IP. Pre-emption rights. Contracts. Veto rights."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-issues-rule",
                                            children: "Spot them early. Deal with them before they become blockers."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "web-quote-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "web-quote-avatar",
                                            src: $977c96deabac7c47$exports,
                                            alt: "Mark Bernstein"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-quote-text",
                                            children: "\"Neil is one of the UK's most active transaction lawyers. I've been doing deals for 30 years and still learn every time he speaks. So will you. He is a highly entertaining speaker and not to be missed.\""
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-quote-by",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: "Mark Bernstein"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "Founder & CEO, Diligentsia"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        style: {
                            background: '#fff',
                            borderTop: '1px solid #e4e4e9'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "wrap web-sec",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "web-h2 web-speakers-h",
                                    children: "Speakers"
                                }),
                                $556c68a6e221b21b$var$SPEAKER_ROWS.map(({ label: label, img: img, name: name, role: role, quote: quote, note: note, bio: bio, chips: chips })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "web-group-label",
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "web-spk-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "web-spk-id",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "web-spk-avatar",
                                                                src: img,
                                                                alt: name
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "web-spk-name",
                                                                        children: name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "web-spk-role",
                                                                        children: role
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "web-spk-body",
                                                        children: [
                                                            bio ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "web-spk-bio",
                                                                children: bio
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "web-spk-quote",
                                                                children: quote
                                                            }),
                                                            chips ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "web-chips",
                                                                children: chips.map((chip, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `web-chip${i === chips.length - 1 ? ' is-plain' : ''}`,
                                                                        children: chip
                                                                    }, chip))
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "web-spk-note",
                                                                children: note
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, name))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        id: "register",
                        className: "web-register",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "wrap web-sec web-register-grid",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-h2",
                                            children: "Reserve your place"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-ticks",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "web-tick",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            children: "\u2713"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "If there's something you'd like Neil to cover, feel free to submit a question."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "web-tick",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            children: "\u2713"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Can't make it live? Register anyway and tick the box for the recording."
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-reg-meta",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($556c68a6e221b21b$var$SessionDate, {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "web-dot-light",
                                                    children: "\xb7"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: sessionTime
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "web-dot-light",
                                                    children: "\xb7"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "Online"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "web-dot-light",
                                                    children: "\xb7"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "Free"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isRegistered ? // Reason: HubSpot's confirmation email can take minutes to arrive, so the on-page
                                // state has to carry the joining link and the calendar link itself — otherwise
                                // people assume the form failed and submit again.
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "web-confirm",
                                    role: "status",
                                    "aria-live": "polite",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-h2",
                                            children: "You're registered."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                color: '#c9c9d2'
                                            },
                                            children: [
                                                $556c68a6e221b21b$var$SESSION.date,
                                                ", ",
                                                sessionTime,
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '12px',
                                                marginTop: '4px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    className: "web-cta",
                                                    href: $556c68a6e221b21b$var$CALENDAR_URL,
                                                    children: "Add to your calendar"
                                                }),
                                                joiningLink ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    className: "web-cta",
                                                    style: {
                                                        background: 'transparent',
                                                        border: '1px solid #3a3a44'
                                                    },
                                                    href: joiningLink,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "Join on the day"
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-form-note",
                                            style: {
                                                textAlign: 'left'
                                            },
                                            children: "A confirmation email is on its way with the same links."
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                    id: "webinarRegisterForm",
                                    className: "web-form",
                                    onSubmit: handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-field-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "web-label",
                                                    children: [
                                                        "First name",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "text",
                                                            name: "firstname",
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "web-label",
                                                    children: [
                                                        "Last name",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "text",
                                                            name: "lastname",
                                                            required: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-field-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "web-label",
                                                    children: [
                                                        "Email",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "email",
                                                            name: "email",
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "web-label",
                                                    children: [
                                                        "Company",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "text",
                                                            name: "company",
                                                            required: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "web-label",
                                                    style: {
                                                        marginBottom: '10px'
                                                    },
                                                    children: "Which is closest to you?"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "web-radio-group",
                                                    children: $556c68a6e221b21b$var$ICP_OPTIONS.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            className: "web-radio",
                                                            htmlFor: `icp-${value}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "radio",
                                                                    id: `icp-${value}`,
                                                                    name: "series_icp",
                                                                    value: value,
                                                                    required: true
                                                                }),
                                                                label
                                                            ]
                                                        }, value))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "web-label",
                                            children: [
                                                "Anything you'd like Neil to cover? (optional)",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                    rows: "3",
                                                    name: "series_question",
                                                    style: {
                                                        resize: 'vertical'
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "web-check",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "checkbox",
                                                    name: "series_recording_only"
                                                }),
                                                "I can't make it live \u2014 send me the recording"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "web-submit",
                                            type: "submit",
                                            children: "Reserve your place \u2192"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-form-note",
                                            children: "Takes a minute. We'll send the joining link and the online checklist \u2014 nothing else."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        style: {
                            backgroundColor: '#F5F6FF',
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "wrap web-sec web-two-col web-practice",
                            style: {
                                padding: '80px 48px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-practice-h",
                                            children: "Put the session into practice with Diligentsia"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-practice-body",
                                            children: "The issues covered in the session are easier to address when you know what to look for. Diligentsia's free online checklist gives you a practical way to work through them against your own business."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: $556c68a6e221b21b$var$PRACTICE_STEPS.map((step, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-step",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "web-step-num",
                                                    children: `0${i + 1}`
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "web-step-text",
                                                    children: step
                                                })
                                            ]
                                        }, step))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        style: {
                            background: '#fff',
                            borderTop: '1px solid #e4e4e9',
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "wrap web-sec",
                            style: {
                                padding: '88px 48px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "web-two-col web-sessions-head",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-sessions-h",
                                            children: "More sessions are coming."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-sessions-body",
                                            children: "Session 1 is the first in a series of practical conversations for founders navigating growth, a raise or exit, and what happens beyond the pitch."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "web-sessions-list",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-session-card",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "web-session-when",
                                                    children: "01 \xb7 September"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "web-session-title-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "web-session-title",
                                                            children: $556c68a6e221b21b$var$SESSION_TITLE
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "web-here",
                                                            children: "You are here"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-session-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: "02 \xb7 October"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: session2Title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-session-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: "03 \xb7 November"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: session3Title
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "web-band",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "wrap web-band-inner",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        maxWidth: '56ch'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "web-band-title",
                                            children: $556c68a6e221b21b$var$SESSION_TITLE
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "web-band-meta",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($556c68a6e221b21b$var$SessionDate, {}),
                                                " \xb7 ",
                                                sessionTime,
                                                " \xb7 Online \xb7 Free"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "web-band-cta",
                                    href: "#register",
                                    children: "Reserve your place \u2192"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
                        className: "web-footer",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "wrap web-footer-inner",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: $803d4ad2316930d5$exports,
                                    alt: "Diligentsia",
                                    style: {
                                        height: '20px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Hosted by Diligentsia, in collaboration with Brown Rudnick and Startup 2 Standup"
                                })
                            ]
                        })
                    }),
                    !isRegistered && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "#register",
                        className: `web-sticky-cta${isStuck ? ' is-visible' : ''}`,
                        children: "Reserve your place \u2192"
                    })
                ]
            })
        ]
    });
};
var $556c68a6e221b21b$export$2e2bcd8739ae039 = $556c68a6e221b21b$var$WebinarLanding;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");






var $acw62 = parcelRequire("acw62");













const $defbea5c5b83142b$export$416ec9f5729de215 = (0, $74cf642ba7fa99c2$export$6abd22dc03e5063f)("COMMON_SETTINGS/fetchCategories", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const categoryResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/get/categorylist`);
        const catList = (categoryResponse?.body || []).map((obj)=>({
                ...obj,
                label: obj.name,
                value: obj._id
            }));
        return [
            ...catList
        ];
    } catch (error) {
        console.error("Error fetching categories:", error);
        return rejectWithValue(error.message);
    }
});
// Reducer slice
const $defbea5c5b83142b$var$commonSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
    name: "COMMON_SETTINGS",
    initialState: {
        categories: [],
        query: {
            column: "firReport",
            page: 1,
            limit: 20,
            totalPages: 1
        },
        loading: false,
        error: null
    },
    reducers: {
        UPDATE_CATEGORIES: (state, action)=>{
            return {
                ...state,
                categories: action.payload
            };
        },
        UPDATE_QUERY: (state, action)=>{
            return {
                ...state,
                query: {
                    ...state.query,
                    ...action.payload
                }
            };
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($defbea5c5b83142b$export$416ec9f5729de215.pending, (state)=>{
            state.loading = true;
            state.error = null;
        }).addCase($defbea5c5b83142b$export$416ec9f5729de215.fulfilled, (state, action)=>{
            state.loading = false;
            state.categories = action.payload;
        }).addCase($defbea5c5b83142b$export$416ec9f5729de215.rejected, (state, action)=>{
            state.loading = false;
            state.error = action.payload;
        });
    }
});
const { UPDATE_CATEGORIES: $defbea5c5b83142b$export$1ed4ec267b4d265c, UPDATE_QUERY: $defbea5c5b83142b$export$4833f4501cec619d } = $defbea5c5b83142b$var$commonSlice.actions;
var $defbea5c5b83142b$export$2e2bcd8739ae039 = $defbea5c5b83142b$var$commonSlice.reducer;


const $d4f6cac57672a71e$var$PlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "30px",
        height: "30px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fd6474",
                d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M21,14h6v20h-6V14z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M14,21h20v6H14V21z"
            })
        ]
    });
};
const $d4f6cac57672a71e$var$IconUser = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconMail = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "22,6 12,12 2,6"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconLock = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "3",
                y: "11",
                width: "18",
                height: "11",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7 11V7a5 5 0 0 1 10 0v4"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconEye = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconEyeOff = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "1",
                y1: "1",
                x2: "23",
                y2: "23"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconSearch = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "21",
                y1: "21",
                x2: "16.65",
                y2: "16.65"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconBuilding = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "4",
                y: "2",
                width: "16",
                height: "20",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "9",
                y1: "7",
                x2: "9",
                y2: "7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "15",
                y1: "7",
                x2: "15",
                y2: "7"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "9",
                y1: "12",
                x2: "9",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "15",
                y1: "12",
                x2: "15",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "9",
                y1: "17",
                x2: "15",
                y2: "17"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconMapPin = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconBriefcase = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "7",
                width: "20",
                height: "14",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconPhone = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"
        })
    });
const $d4f6cac57672a71e$var$IconGlobe = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "2",
                y1: "12",
                x2: "22",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconTag = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.2H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.42l9.58 9.58a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "7.5",
                cy: "7.5",
                r: "1",
                fill: "currentColor",
                stroke: "none"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconUpload = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "17 8 12 3 7 8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "3",
                x2: "12",
                y2: "15"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconX = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
const $d4f6cac57672a71e$var$IconArrowLeft = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });




const $d4f6cac57672a71e$var$RegisterTwoMinuteTest = ({ registerationType: registerationType, refs: refs, isAnimationVisible: isAnimationVisible, registerPage: registerPage })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    const { categories: categories } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.common);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const advisorsCategories = categories.filter((cat)=>cat?.for === "advisor");
    const investorsCategories = categories.filter((cat)=>cat?.for === "investor");
    let [type, setType] = (0, $acw62.useState)();
    let [stepNo, setStepNo] = (0, $acw62.useState)(1);
    let [company, setCompany] = (0, $acw62.useState)({});
    let [partnerId, setPartnerId] = (0, $acw62.useState)();
    let [animation, setAnimation] = (0, $acw62.useState)(1);
    let [isAgreed, setIsAgreed] = (0, $acw62.useState)(false);
    // Step-1 gates that are not plain text inputs, so they cannot rely on the field loop below.
    let [stepOneErrors, setStepOneErrors] = (0, $acw62.useState)({
        roleType: "",
        terms: ""
    });
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [isNotSure, setIsNotSure] = (0, $acw62.useState)(false);
    let [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    let [isBtnHover, setIsBtnHover] = (0, $acw62.useState)(false);
    let [registerAs, setRegisterAs] = (0, $acw62.useState)("User");
    let [isGuestUser, setIsGuestUser] = (0, $acw62.useState)(false);
    let [advisorType, setAdvisorType] = (0, $acw62.useState)(false);
    let [passwordType, setPasswordType] = (0, $acw62.useState)(true);
    let [companyOptions, setCompanyOptions] = (0, $acw62.useState)([]);
    let [companySelected, setCompanySelected] = (0, $acw62.useState)({});
    let [advisorHashData, setAdvisorHashData] = (0, $acw62.useState)("");
    let [existingAdvisor, setExistingAdvisor] = (0, $acw62.useState)({});
    let [websiteStatus, setWebsiteStatus] = (0, $acw62.useState)("Check");
    let [advisorTypeValue, setAdvisorTypeValue] = (0, $acw62.useState)("");
    let [selectedAdvisorType, setSelectedAdvisorType] = (0, $acw62.useState)(null);
    let [investorType, setInvestorType] = (0, $acw62.useState)(false);
    let [selectedInvestorType, setSelectedInvestorType] = (0, $acw62.useState)(null);
    let [isValidPassword, setIsValidPassword] = (0, $acw62.useState)(false);
    let [confirmPasswordType, setConfirmPasswordType] = (0, $acw62.useState)(true);
    let [passwordError, setPasswordError] = (0, $acw62.useState)({
        password: "",
        confirmPassword: ""
    });
    let [formData, setFormData] = (0, $acw62.useState)({
        role: "",
        firstName: "",
        lastName: "",
        email: selectedCompany["companyEmail"] || "",
        password: "",
        confirmPassword: "",
        title: "",
        phone: "",
        firmName: "",
        company5Words: "",
        firmAddress: "",
        website: "",
        firmLogo: "",
        testType: ""
    });
    let searchTimeout;
    let formCheck = [
        "firstName",
        "lastName",
        "email",
        "password",
        "confirmPassword"
    ];
    let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
    (0, $acw62.useEffect)(()=>{
        let pathname = window.location.pathname;
        if (pathname.includes('register')) {
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            let mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            let isMobile = mobileRegex.test(userAgent);
            if (isMobile) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'mobileDevicesPopup'
            }));
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (location?.hash) {
            partnerId = location?.hash.split('?')[0];
            partnerId = partnerId.replaceAll('#', '');
            if (partnerId) setPartnerId(partnerId);
            type = location?.hash.split('?')[1];
            if (type == 'Superflow') setType(type);
        }
        if (localStorage.getItem("companyId")) getUser();
        if (localStorage.getItem("isPartnerChecklist")) {
            setRegisterAs("User");
            if (!partner["referralCode"]) {
                let partnerId = localStorage.getItem("partnerId");
                if (partnerId) getPartner(partnerId);
            } else setFormData({
                ...formData,
                referralCode: partner["referralCode"]
            });
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        let companyId = localStorage.getItem("companyId");
        if (user?.['role'] == 'Guest' && companyId) setIsGuestUser(true);
        else setIsGuestUser(false);
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedCompany["companyEmail"]) setFormData({
            ...formData,
            email: selectedCompany["companyEmail"]
        });
    }, [
        selectedCompany
    ]);
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        if (response && response['code'] == 200) {
            let user = response?.['body']?.['user'];
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
        }
    };
    const getPartner = async (id)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/${id}`);
        if (res["code"] == 200) {
            dispatch((0, $3d3d7a2ee763f32a$export$6af6109222273956)(res["body"]));
            setFormData({
                ...formData,
                referralCode: res["body"]["referralCode"]
            });
        }
    };
    const CustomOption = (props)=>{
        const { data: data, innerRef: innerRef, innerProps: innerProps } = props;
        return data.hasAdd ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df jcsb aic",
            ref: innerRef,
            ...advisorTypeValue ? innerProps : {},
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginLeft: "11px",
                        color: advisorTypeValue === "" && "gray"
                    },
                    children: data.label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                    color: "primary",
                    "aria-label": "upload picture",
                    component: "span",
                    onClick: (event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: "advisorType"
                        }));
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$PlusIcon, {})
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
                ...props
            })
        });
    };
    // Custom react select
    const customStyles = {
        control: (provided, state)=>({
                ...provided,
                cursor: "pointer",
                border: "none",
                boxShadow: "none",
                minHeight: "initial",
                background: "transparent"
            }),
        valueContainer: (provided)=>({
                ...provided
            }),
        input: (provided)=>({
                ...provided,
                margin: 0,
                padding: 0
            }),
        placeholder: (provided)=>({
                ...provided,
                margin: 0,
                padding: 0,
                fontSize: "14px",
                color: "#9aa3b4"
            }),
        dropdownIndicator: (provided)=>({
                ...provided,
                padding: 0
            }),
        indicatorSeparator: ()=>({
                display: "none"
            }),
        menu: (provided, state)=>({
                ...provided,
                width: "100%",
                marginTop: 4,
                fontSize: "13px",
                zIndex: 20
            }),
        option: (provided, state)=>({
                ...provided,
                backgroundColor: state.isSelected ? "#fc7785" : state.isFocused ? "#fde3e6" : provided.backgroundColor,
                color: state.isSelected ? "white" : provided.color,
                fontSize: "13px",
                ":active": {
                    ...provided[":active"],
                    backgroundColor: state.isSelected ? "#fc7785" : "#fde3e6"
                }
            })
    };
    (0, $acw62.useEffect)(()=>{
        let pathname = window.location.pathname;
        if (pathname && pathname == "/register") setIsNotSure(false);
        else setIsNotSure(true);
        registerAs = localStorage.getItem('registerAs');
        if (registerAs) setRegisterAs(registerAs);
        if (registerAs == 'Advisor') setAdvisorType(true);
        if (registerAs == 'Investor') setInvestorType(true);
        const timeout = setTimeout(()=>{
            setAnimation(true);
        }, 2000);
        return ()=>clearTimeout(timeout);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (dispatch) dispatch((0, $defbea5c5b83142b$export$416ec9f5729de215)());
    }, [
        dispatch
    ]);
    //Reseting all advisor type select to intial if radio button change
    (0, $acw62.useEffect)(()=>{
        setSelectedAdvisorType(null);
        setAdvisorTypeValue("");
        setSelectedInvestorType(null);
    }, [
        registerAs
    ]);
    //Handle on advisor type added
    const onAdvisorTypeAdded = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/create/custom-category`, {
            name: advisorTypeValue
        });
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
            const newCategories = res?.body ? {
                ...res.body,
                label: res.body.name,
                value: res.body._id
            } : {};
            dispatch((0, $defbea5c5b83142b$export$1ed4ec267b4d265c)([
                newCategories,
                ...categories
            ]));
        }
    };
    //On advisor modal close
    const onAdvisorModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        setSelectedAdvisorType(null);
        setAdvisorTypeValue("");
    };
    (0, $acw62.useEffect)(()=>{
        setFormData({
            ...formData,
            role: registerationType
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!formData?.["firmName"] || formData?.["firmName"] == "") {
            setCompanyOptions([]);
            setCompanySelected({});
        }
    }, [
        formData?.["firmName"]
    ]);
    const resetStates = ()=>{
        setStepNo(1);
        setIsAgreed(false);
        setCompanyOptions([]);
        setCompanySelected({});
        setWebsiteStatus("Check");
        setIsValidPassword(false);
        setFormData({
            role: "",
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            title: "",
            phone: "",
            firmName: "",
            firmAddress: "",
            website: "",
            firmLogo: ""
        });
    };
    const handleRegisterAs = (value)=>{
        setAdvisorType(value === "Advisor");
        setInvestorType(value === "Investor");
        setRegisterAs(value);
        setFormData({
            ...formData,
            role: value
        });
        setStepNo(1);
        setIsAgreed(false);
        setStepOneErrors({
            roleType: "",
            terms: ""
        });
        setCompanyOptions([]);
        setCompanySelected({});
        setWebsiteStatus("Check");
        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('register_as_selection', {
            registration_type: value,
            step: stepNo
        });
    };
    const validatePasswords = (password, confirmPassword, showErrors = true)=>{
        let errors = {
            password: "",
            confirmPassword: ""
        };
        if (!password || password.length < 8) errors["password"] = "Password must be 8 characters long";
        else if (!passwordPattern.test(password)) errors["password"] = "Combination of uppercase, lowercase, digit & special character is required";
        if (!confirmPassword) errors["confirmPassword"] = showErrors ? "Please confirm your password" : "";
        else if (password !== confirmPassword) errors["confirmPassword"] = "Password and Confirm Password don't match";
        const isValid = !errors["password"] && password === confirmPassword && !!password && !!confirmPassword;
        if (showErrors) setPasswordError(errors);
        else setPasswordError({
            password: "",
            confirmPassword: ""
        });
        setIsValidPassword(isValid);
        return isValid;
    };
    const handlePasswordBlur = ()=>{
        // Reason: re-validate on blur so error messages show after the user leaves the field
        validatePasswords(formData?.["password"] || "", formData?.["confirmPassword"] || "", true);
    };
    const searchCompany = async (input)=>{
        if (!input) return;
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/search/${input}`);
        if (!response || response["code"] != 200) return;
        setCompanyOptions(response["body"]["items"].slice(0, 5));
    };
    const searchCompanyTimeout = (e)=>{
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(()=>searchCompany(e.target.value), 1000);
    };
    const requestAdvisorAccess = async ()=>{
        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('request_advisor_access');
        let data = {
            firmId: existingAdvisor["_id"],
            firmName: existingAdvisor["cName"],
            contactId: existingAdvisor["contactId"],
            contactName: existingAdvisor["contactName"],
            contactEmail: existingAdvisor["contactEmail"],
            userFirstName: formData["firstName"],
            userLastName: formData["lastName"],
            userEmail: formData["email"]
        };
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/requestInvestorAccess`, data);
        if (response["code"] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
            resetStates();
        }
    };
    const isURL = (str)=>{
        var pattern = new RegExp("^((ft|htt)ps?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%@_.~+&:]*)*(\\?[;&a-z\\d%@_.,~+&:=-]*)?(\\#[-a-z\\d_]*)?$", "i"); // fragment locator
        return pattern.test(str);
    };
    const openWindow = (url)=>{
        if (window.innerWidth <= 640) {
            var a = document.createElement("a");
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");
            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);
            a.dispatchEvent(dispatch);
        } else {
            var width = window.innerWidth * 0.8;
            var height = width * window.innerHeight / window.innerWidth;
            window.open(url, "newwindow", "width=" + width + ", height=" + height + ", top=" + (window.innerHeight - height) / 2 + ", left=" + (window.innerWidth - width) / 2);
        }
        return false;
    };
    const verifyWebsite = async ()=>{
        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('verify_website', {
            website: formData['website']
        });
        try {
            let companyWebsite = document.querySelector(`#companyWebsite`).value;
            if (!companyWebsite) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please provide website link");
            if (!isURL(companyWebsite)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Invalid company url");
            if (companyWebsite.indexOf("http") < 0) companyWebsite = `http://${companyWebsite}`;
            openWindow(companyWebsite);
            setWebsiteStatus("Confirm");
        } catch (e) {
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e);
        }
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e)=>{
        e.preventDefault();
        const logo = e.dataTransfer.files[0];
        let maxSizeInBytes = 5242880;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = ()=>{
                if (logo.size > maxSizeInBytes) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`File size must be less than 1MB`);
                else setFormData((prevFormData)=>({
                        ...prevFormData,
                        firmLogo: logoUrl
                    }));
            };
        }
        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('register_image_drop', {
            step: stepNo,
            file_type: e.dataTransfer.files[0]?.type
        });
    };
    const handleImageChange = async (event)=>{
        let logo = event.target.files[0];
        if (event.target.files) {
            const newAttachment = [];
            for (const file of event.target.files)newAttachment.push(file);
            setAttachment(newAttachment);
        }
        let maxSizeInBytes = 5242880;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = ()=>{
                if (logo.size > maxSizeInBytes) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`File size must be less than 5Mb`);
                else setFormData((prevFormData)=>({
                        ...prevFormData,
                        firmLogo: logoUrl
                    }));
            };
        }
        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('register_image_upload', {
            step: stepNo,
            file_type: event.target.files[0]?.type
        });
    };
    const restrictedForDevices = ()=>{
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobile = mobileRegex.test(userAgent);
        return isMobile;
    };
    const handleNextRegister = async ()=>{
        if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You can Login/Register on Laptop");
        if (registerAs == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please select Register as");
        let stage = localStorage.getItem("cStage");
        let testType = localStorage.getItem("testType");
        if (stepNo == 1) {
            let isError = false;
            const data = formCheck?.map((field, i, arr)=>{
                if (formData?.[field] !== "") return false;
                return true;
            });
            // Advisors and Investors must pick a type; everyone must accept the terms. Both are
            // reported inline against the control itself rather than as a toast, so it is clear
            // which one is blocking, and both are checked together so neither hides the other.
            const needsRoleType = registerAs == "Advisor" || registerAs == "Investor";
            const selectedRoleType = registerAs == "Advisor" ? selectedAdvisorType : selectedInvestorType;
            const gateErrors = {
                roleType: needsRoleType && !selectedRoleType ? `Please select the ${registerAs.toLowerCase()} type` : "",
                terms: !isAgreed ? "Please accept the terms and conditions" : ""
            };
            setStepOneErrors(gateErrors);
            if (gateErrors["roleType"] || gateErrors["terms"]) return;
            if (!isError && passwordError["password"] == "" && passwordError["confirmPassword"] == "") {
                if (data.includes(true)) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please fill out all fields");
                else {
                    if (isGuestUser && (registerAs == "Advisor" || registerAs == "Investor")) {
                        let companyId = localStorage.getItem("companyId");
                        setIsLoading(true);
                        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/advisor2MTFHP", {
                            firstName: formData?.["firstName"],
                            lastName: formData?.["lastName"],
                            email: formData?.["email"],
                            password: formData?.["password"],
                            role: registerAs,
                            companyId: companyId
                        });
                        if (response && response["code"] == 200) {
                            if (registerPage) {
                                const hash = response["body"];
                                dispatch((0, $7fa194fc86099528$export$9b16b760c6b5c1ae)({
                                    emailEnabled: true,
                                    hash: hash
                                }));
                            } else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: "registerVerification"
                            }));
                            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
                            resetStates();
                        }
                        setIsLoading(false);
                    } else if (registerAs == "User") {
                        setIsLoading(true);
                        let data = {
                            firstName: formData?.["firstName"],
                            lastName: formData?.["lastName"],
                            email: formData?.["email"],
                            password: formData?.["password"],
                            referralCode: formData?.["referralCode"]
                        };
                        if (type && partnerId) data = {
                            firstName: formData?.["firstName"],
                            lastName: formData?.["lastName"],
                            email: formData?.["email"],
                            password: formData?.["password"],
                            referralCode: formData?.["referralCode"],
                            type: type,
                            partnerId: partnerId
                        };
                        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user", data);
                        if (response && response["code"] == 200) {
                            if (registerPage) {
                                const hash = response["body"];
                                dispatch((0, $7fa194fc86099528$export$9b16b760c6b5c1ae)({
                                    emailEnabled: true,
                                    hash: hash
                                }));
                            } else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: "registerVerification"
                            }));
                            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
                            resetStates();
                        }
                        setIsLoading(false);
                    } else {
                        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/checkExistingUser", {
                            email: formData?.["email"]
                        });
                        if (response && response["code"] == 200) {
                            if ((registerAs == "Advisor" || registerAs == "Investor") && !isGuestUser && company?.["cName"] && company?.["cWebsite"]) {
                                setFormData({
                                    ...formData,
                                    role: registerAs,
                                    cType: company["cType"],
                                    firmName: company["cName"],
                                    website: company["cWebsite"],
                                    ukRegNo: company["ukRegNo"],
                                    firmAddress: company["cAddress"],
                                    doIncorporation: company["doIncorporation"],
                                    testType: testType ? testType : "investment",
                                    cStage: stage ? stage : "Mature"
                                });
                                setStepNo(3);
                                setWebsiteStatus("Confirmed");
                            } else setStepNo(2);
                        }
                    }
                }
            }
        } else if (stepNo == 2 && !isGuestUser) {
            if (companySelected && companySelected["title"]) {
                let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/checkExistingCompany`, {
                    ukRegNo: companySelected["company_number"]
                });
                if (response["code"] == 200) {
                    if (Object.keys(response["body"]).length > 0) {
                        if ([
                            formData['role']
                        ].includes(response["body"]?.["cCategory"])) {
                            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
                            setExistingAdvisor(response["body"]);
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: "existingAdvisor"
                            }));
                        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`${response["body"]?.["cName"]} is a ${response["body"]?.["cCategory"]} company. You can't add it.`);
                    } else {
                        setStepNo(3);
                        setFormData({
                            ...formData,
                            role: registerAs,
                            cType: companySelected["testType"],
                            firmName: companySelected["title"],
                            ukRegNo: companySelected["company_number"],
                            firmAddress: companySelected["address_snippet"],
                            doIncorporation: companySelected["date_of_creation"],
                            testType: testType ? testType : "investment",
                            cStage: stage ? stage : "Mature"
                        });
                    }
                }
            }
        } else if (stepNo == 3 && !isGuestUser) {
            if (formData["firmName"] === "") (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please fill out Firm Name");
            else if (formData["firmAddress"] === "") (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please fill out the Firm Address");
            else if (formData["title"] === "") (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please fill out your role or job Title");
            else if (formData["phone"] === "") (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please fill out phone Number");
            else if (formData["website"] === "") (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please fill out the website");
            else if (formData["company5Words"].split(" ").length < 5) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please provide 5 words that describe your ${registerAs == "Advisor" || registerAs == "Investor" ? "client" : ""} company business activites`);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($bad1c3ae594eb6ef$exports))).isURL(formData["website"])) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please enter valid webiste URL");
            else if (websiteStatus != "Confirmed") (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please check and confirm company website");
            else {
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/advisor", {
                    attachment: attachment,
                    ...formData,
                    isParent: true,
                    ...registerAs == "Investor" ? {
                        investorType: selectedInvestorType?.value
                    } : {
                        advisorType: selectedAdvisorType?.value
                    }
                }, false);
                if (response && response["code"] == 200) {
                    setCompany(response["body"]["newCompany"]);
                    setAdvisorHashData(response["body"]?.["hash"]);
                    setCompanySelected(response["body"]?.["newCompany"]);
                    dispatch((0, $b4397434d961d2b4$export$50f0ed8944cb1d90)({
                        companySelected: response["body"]?.["newCompany"],
                        company: response["body"]?.["newCompany"]
                    }));
                    if (response["body"]?.["newCompany"]?.["companyDescription"]) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: "descriptionPopup"
                    }));
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
                    resetStates();
                }
                setIsLoading(false);
            }
        }
    };
    const handleBack = ()=>{
        if (stepNo == 2) {
            if (companySelected && companySelected["title"]) setCompanySelected({});
            else setStepNo(1);
        } else setStepNo(stepNo - 1);
    };
    const handleLogin = ()=>{
        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('register_to_login_redirect');
        navigate('/login');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-auth-main",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-auth-glow lp-auth-glow--tr",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-auth-glow lp-auth-glow--bl",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-auth-wrap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-auth-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "lp-auth-title",
                                        children: "Register with"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "lp-auth-title pink",
                                        children: "Diligentsia for FREE"
                                    }),
                                    stepNo == 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "lp-auth-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "icon",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconUser, {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "firstName",
                                                                type: "text",
                                                                placeholder: "First Name",
                                                                value: formData?.["firstName"] || "",
                                                                onChange: (e)=>{
                                                                    if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You can Login/Register on Laptop");
                                                                    setFormData({
                                                                        ...formData,
                                                                        firstName: e["target"]["value"]
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "lp-auth-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "icon",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconUser, {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "lastName",
                                                                type: "text",
                                                                placeholder: "Last Name",
                                                                value: formData?.["lastName"] || "",
                                                                onChange: (e)=>{
                                                                    if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You can Login/Register on Laptop");
                                                                    setFormData({
                                                                        ...formData,
                                                                        lastName: e["target"]["value"]
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-field lp-auth-field--icon-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconMail, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "email",
                                                        type: "email",
                                                        placeholder: "Email - your company email address only please",
                                                        value: formData?.["email"] || "",
                                                        onChange: (e)=>{
                                                            if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You can Login/Register on Laptop");
                                                            setFormData({
                                                                ...formData,
                                                                email: e["target"]["value"]
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "lp-auth-field lp-auth-field--pw",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "icon",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconLock, {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        id: "password",
                                                                        type: passwordType ? "password" : "text",
                                                                        placeholder: "Password",
                                                                        value: formData?.["password"] || "",
                                                                        onChange: (e)=>{
                                                                            if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You can Login/Register on Laptop");
                                                                            const password = e["target"]["value"];
                                                                            setFormData({
                                                                                ...formData,
                                                                                password: password
                                                                            });
                                                                            // Reason: validate with the new value immediately — formData is still stale in this handler
                                                                            validatePasswords(password, formData?.["confirmPassword"] || "", false);
                                                                        },
                                                                        onBlur: handlePasswordBlur,
                                                                        required: true
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        type: "button",
                                                                        className: "toggle-pw",
                                                                        onClick: ()=>setPasswordType(!passwordType),
                                                                        children: passwordType ? /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconEye, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconEyeOff, {})
                                                                    })
                                                                ]
                                                            }),
                                                            passwordError["password"] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "lp-auth-error",
                                                                children: passwordError["password"]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "lp-auth-field lp-auth-field--pw",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "icon",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconLock, {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        id: "confirmPassword",
                                                                        type: confirmPasswordType ? "password" : "text",
                                                                        placeholder: "Confirm Password",
                                                                        value: formData?.["confirmPassword"] || "",
                                                                        onChange: (e)=>{
                                                                            if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You can Login/Register on Laptop");
                                                                            const confirmPassword = e["target"]["value"];
                                                                            setFormData({
                                                                                ...formData,
                                                                                confirmPassword: confirmPassword
                                                                            });
                                                                            // Reason: validate with the new value immediately — formData is still stale in this handler
                                                                            validatePasswords(formData?.["password"] || "", confirmPassword, false);
                                                                        },
                                                                        onBlur: handlePasswordBlur,
                                                                        required: true
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        type: "button",
                                                                        className: "toggle-pw",
                                                                        onClick: ()=>setConfirmPasswordType(!confirmPasswordType),
                                                                        children: confirmPasswordType ? /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconEye, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconEyeOff, {})
                                                                    })
                                                                ]
                                                            }),
                                                            passwordError["confirmPassword"] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "lp-auth-error",
                                                                children: passwordError["confirmPassword"]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-register-as",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "Register as"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "lp-register-as-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "lp-register-radio",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        id: "user",
                                                                        name: "registerAs",
                                                                        type: "radio",
                                                                        value: "User",
                                                                        checked: registerAs == "User",
                                                                        onChange: (e)=>{
                                                                            handleRegisterAs(e["target"]["value"]);
                                                                        }
                                                                    }),
                                                                    "Company"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: `lp-register-radio ${type == 'Superflow' ? 'is-disabled' : ''}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        id: "advisor",
                                                                        type: "radio",
                                                                        value: "Advisor",
                                                                        name: "registerAs",
                                                                        checked: registerAs == "Advisor",
                                                                        onChange: (e)=>{
                                                                            type !== 'Superflow' && handleRegisterAs(e["target"]["value"]);
                                                                        }
                                                                    }),
                                                                    "Advisor"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: `lp-register-radio ${type == 'Superflow' ? 'is-disabled' : ''}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        id: "investor",
                                                                        type: "radio",
                                                                        value: "Investor",
                                                                        name: "registerAs",
                                                                        checked: registerAs == "Investor",
                                                                        onChange: (e)=>{
                                                                            type !== 'Superflow' && handleRegisterAs(e["target"]["value"]);
                                                                        }
                                                                    }),
                                                                    "Investor"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    advisorType ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lp-register-select",
                                                        style: {
                                                            marginTop: 12
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                            placeholder: "Select Advisor Type",
                                                            styles: customStyles,
                                                            value: selectedAdvisorType,
                                                            className: "react-select-container",
                                                            components: {
                                                                Option: CustomOption
                                                            },
                                                            options: advisorsCategories,
                                                            onChange: (value)=>{
                                                                setSelectedAdvisorType(value);
                                                                setStepOneErrors({
                                                                    ...stepOneErrors,
                                                                    roleType: ""
                                                                });
                                                            }
                                                        })
                                                    }) : null,
                                                    investorType ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lp-register-select",
                                                        style: {
                                                            marginTop: 12
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                            placeholder: "Select Investor Type",
                                                            styles: customStyles,
                                                            value: selectedInvestorType,
                                                            className: "react-select-container",
                                                            components: {
                                                                Option: CustomOption
                                                            },
                                                            options: investorsCategories,
                                                            onChange: (value)=>{
                                                                setSelectedInvestorType(value);
                                                                setStepOneErrors({
                                                                    ...stepOneErrors,
                                                                    roleType: ""
                                                                });
                                                            }
                                                        })
                                                    }) : null,
                                                    stepOneErrors["roleType"] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lp-auth-error",
                                                        style: {
                                                            margin: '6px 0 0 4px'
                                                        },
                                                        children: stepOneErrors["roleType"]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-register-terms",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        htmlFor: "registerTerms",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "registerTerms",
                                                                type: "checkbox",
                                                                checked: isAgreed,
                                                                onChange: ()=>{
                                                                    setIsAgreed(!isAgreed);
                                                                    setStepOneErrors({
                                                                        ...stepOneErrors,
                                                                        terms: ""
                                                                    });
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                children: [
                                                                    "I agree to the ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: "/terms-conditions",
                                                                        target: "_blank",
                                                                        children: "terms and conditions"
                                                                    }),
                                                                    " and ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: "/policy",
                                                                        target: "_blank",
                                                                        children: "policies"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    stepOneErrors["terms"] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "lp-auth-error",
                                                        style: {
                                                            margin: '6px 0 0 4px'
                                                        },
                                                        children: stepOneErrors["terms"]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : stepNo == 2 && !isGuestUser ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            Object.keys(companySelected).length == 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-field lp-auth-field--icon-wide",
                                                style: {
                                                    marginBottom: 16
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconSearch, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "searchCompany",
                                                        name: "firmName",
                                                        type: "text",
                                                        placeholder: registerAs == "User" ? "Please add the name of your company" : "Please add the name of YOUR UK firm/company, NOT your client/investee company",
                                                        value: formData?.["firmName"] || "",
                                                        onChange: (e)=>setFormData({
                                                                ...formData,
                                                                firmName: e["target"]["value"]
                                                            }),
                                                        onKeyUp: searchCompanyTimeout
                                                    })
                                                ]
                                            }),
                                            companySelected && companySelected["title"] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-register-company-card",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        children: "Company Info"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Status:"
                                                            }),
                                                            " ",
                                                            companySelected["company_status"]?.toUpperCase()
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Number:"
                                                            }),
                                                            " ",
                                                            companySelected["company_number"]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Title:"
                                                            }),
                                                            " ",
                                                            companySelected["title"]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Date of Creation:"
                                                            }),
                                                            " ",
                                                            companySelected["date_of_creation"]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Description:"
                                                            }),
                                                            " ",
                                                            companySelected["description"]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Company Address:"
                                                            }),
                                                            " ",
                                                            companySelected["address_snippet"]
                                                        ]
                                                    })
                                                ]
                                            }) : formData?.["firmName"] != "" && companyOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "lp-register-search-results",
                                                children: companyOptions.map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        onClick: ()=>setCompanySelected(option),
                                                        className: "lp-register-search-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "name",
                                                                children: option["title"]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "num",
                                                                children: option["company_number"]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "status",
                                                                children: option["company_status"]
                                                            })
                                                        ]
                                                    }, idx))
                                            }) : null
                                        ]
                                    }) : stepNo == 3 && !isGuestUser ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-field lp-auth-field--icon-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconBuilding, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "firmName",
                                                        name: "firmName",
                                                        type: "text",
                                                        placeholder: "Firm Name",
                                                        value: formData?.["firmName"] || "",
                                                        onChange: (e)=>setFormData({
                                                                ...formData,
                                                                firmName: e["target"]["value"]
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-field lp-auth-field--icon-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconMapPin, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "firmAddress",
                                                        name: "firmAddress",
                                                        type: "text",
                                                        placeholder: "Firm Address",
                                                        value: formData?.["firmAddress"] || "",
                                                        onChange: (e)=>setFormData({
                                                                ...formData,
                                                                firmAddress: e["target"]["value"]
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-field lp-auth-field--icon-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconBriefcase, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "title",
                                                        name: "title",
                                                        type: "text",
                                                        placeholder: "Your Title",
                                                        value: formData?.["title"] || "",
                                                        onChange: (e)=>setFormData({
                                                                ...formData,
                                                                title: e["target"]["value"]
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-field lp-auth-field--icon-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconPhone, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $331000cdd042dde5$export$2e2bcd8739ae039), {
                                                        name: "phone",
                                                        country: "GB",
                                                        international: true,
                                                        placeholder: "Your Phone Number",
                                                        withCountryCallingCode: true,
                                                        value: formData?.["phone"],
                                                        onChange: (e)=>setFormData({
                                                                ...formData,
                                                                phone: e
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-register-verify-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "lp-auth-field lp-auth-field--icon-wide",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "icon",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconGlobe, {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "companyWebsite",
                                                                name: "website",
                                                                type: "text",
                                                                placeholder: "Website",
                                                                value: formData?.["website"] || "",
                                                                onChange: (e)=>{
                                                                    setFormData({
                                                                        ...formData,
                                                                        website: e["target"]["value"]
                                                                    });
                                                                    setWebsiteStatus("Check");
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    websiteStatus == "Check" ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "lp-register-verify-btn",
                                                        onClick: ()=>verifyWebsite(),
                                                        children: "Check"
                                                    }) : websiteStatus == "Confirm" ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "lp-register-verify-btn is-confirm",
                                                        onClick: ()=>setWebsiteStatus("Confirmed"),
                                                        children: "Confirm"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "lp-register-verify-btn is-confirmed",
                                                        children: "Confirmed"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-auth-field lp-auth-field--icon-wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconTag, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "company5Words",
                                                        name: "company5Keywords",
                                                        type: "text",
                                                        placeholder: `Add 5 keywords which define this company's activities`,
                                                        value: formData?.["company5Words"],
                                                        onChange: (e)=>setFormData({
                                                                ...formData,
                                                                company5Words: e["target"]["value"]
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-register-logo-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "lbl",
                                                        children: "Firm Logo"
                                                    }),
                                                    formData?.["firmLogo"] == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        onDragOver: onDragOver,
                                                        onDrop: (e)=>onDrop(e),
                                                        htmlFor: "fileUpload",
                                                        className: "dz",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconUpload, {}),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: "Click here or drag and drop files (Max 5MB)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                onChange: handleImageChange,
                                                                style: {
                                                                    display: 'none'
                                                                },
                                                                id: "fileUpload",
                                                                type: "file",
                                                                accept: "image/*"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "preview",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                className: "remove",
                                                                onClick: ()=>setFormData((prevFormData)=>({
                                                                            ...prevFormData,
                                                                            firmLogo: ""
                                                                        })),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconX, {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: formData["firmLogo"],
                                                                alt: "Firm Logo"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "lp-auth-actions",
                                        children: [
                                            registerAs != "User" && stepNo != 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                type: "button",
                                                className: "lp-auth-back",
                                                onClick: ()=>handleBack(),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d4f6cac57672a71e$var$IconArrowLeft, {}),
                                                    " Back"
                                                ]
                                            }),
                                            stepNo == 2 && !(companySelected && companySelected["title"]) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                style: {
                                                    padding: '10px'
                                                },
                                                className: `lp-auth-submit ${isLoading || stepNo == 1 && !isValidPassword ? 'is-disabled' : ''}`,
                                                disabled: isLoading || stepNo == 1 && !isValidPassword,
                                                onClick: ()=>{
                                                    if (!isLoading && !(stepNo == 1 && !isValidPassword)) handleNextRegister();
                                                },
                                                children: !isGuestUser && (registerAs == "Advisor" || registerAs == "Investor") ? stepNo === 1 || stepNo === 2 ? "Next" : "Register" : stepNo === 1 && registerAs === "User" ? "Register for free" : "Register"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "lp-auth-fine",
                                        children: "No credit card required"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "lp-auth-foot",
                                        children: [
                                            "Already registered? ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: $16250bd714b02a14$export$eed606b4351295d7,
                                                onClick: ()=>handleLogin(),
                                                children: "Log in"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-auth-trust",
                                children: "Trusted by 50+ investors, advisors & companies \xb7 No credit card required"
                            }),
                            isNotSure && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "not-sure-register w40",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr bg20 not-sure-container",
                                    style: {
                                        padding: "0px 160px",
                                        background: 'transparent',
                                        height: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            ref: refs?.current?.[8],
                                            className: `tslp op1 tty0`,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fw500 tac c15 pt3rem fs2rem",
                                                    style: {
                                                        lineHeight: "1"
                                                    },
                                                    children: [
                                                        "Not Sure ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c23",
                                                            children: "Yet?"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w100 df jcc",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fw400 tac c15 pt0-5rem fs1rem",
                                                        style: {
                                                            lineHeight: "24px",
                                                            width: "100%"
                                                        },
                                                        children: "Find out by taking our FREE 2-minute Diligentsia Test. No email or credit card required."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df jcc fdc w90 mt10rem bsbb smw100 mxa",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                ref: refs?.current?.[8],
                                                className: `bsflp bsbb bg1 br30px pr tslp pt1rem pb1rem pr1rem pl1rem df aic fdc mb3-5rem smw70 smmxa ${isAnimationVisible[8] && "scaleAnimation"}`,
                                                style: {
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "pa df jcc aic p2rem bg3 twoMinuteIcon",
                                                        style: {
                                                            top: "-49px",
                                                            left: "50%",
                                                            transform: "translateX(-50%)",
                                                            width: "15px",
                                                            height: "15px",
                                                            zoom: "0.8",
                                                            borderRadius: "50%"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("6lUjz")),
                                                            alt: "2-minute-test-icon"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                        className: "fw500 tac c15 fs1-25rem pr0-5rem pl0-5rem mt1rem df fdc",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                "How ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "fw700 fs1-25rem tac c15 fsi",
                                                                    children: "Investment, Growth or Exit Ready"
                                                                }),
                                                                " are you?"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df jcc my0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            to: `/testPage`,
                                                            onMouseEnter: ()=>setIsBtnHover(true),
                                                            onMouseLeave: ()=>setIsBtnHover(false),
                                                            className: `br35px pr cp c1-hover c4 df jcc aic bg1 bg4-hover`,
                                                            style: {
                                                                transition: "background-color 0.3s ease",
                                                                border: "1px solid #FC7785",
                                                                padding: "10px 26px"
                                                            },
                                                            children: [
                                                                "2-Minute Test",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    width: "21",
                                                                    height: "18",
                                                                    viewBox: "0 0 21 18",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    style: {
                                                                        marginLeft: "10px",
                                                                        stroke: isBtnHover ? "#ffff" : "#FC7785",
                                                                        height: "18px",
                                                                        width: "21px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M1.39612 10.331H15.818L11.43 14.7191C10.1696 15.9795 12.0602 17.87 13.3206 16.6096L17.3169 12.6071L19.9847 9.93519C20.5017 9.41507 20.5017 8.57507 19.9847 8.05496L13.3206 1.38311C13.0671 1.12258 12.7181 0.976392 12.3545 0.979416C11.1542 0.979567 10.5652 2.4415 11.43 3.2738L15.8284 7.66187H1.32711C-0.521408 7.75359 -0.383387 10.4231 1.39612 10.331Z",
                                                                        fill: isBtnHover ? "#ffff" : "#FC7785"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalCardClasses: "m0rem",
                modalType: "existingAdvisor",
                onCloseHandler: ()=>{
                    setExistingAdvisor({}), setStepNo(2), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    }));
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "h3rem t0 l0 m1rem",
                        src: (parcelRequire("aR1CT")),
                        alt: "TODO"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c15 fw600",
                        children: `Existing ${registerAs} - ${existingAdvisor["cName"]}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tac my1rem oa",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "fs1rem taj px0-5rem c43",
                            children: [
                                "Hi ",
                                `${formData["firstName"]} ${formData["lastName"]}`,
                                ", ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "We will notify ",
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                    children: [
                                        existingAdvisor["contactName"],
                                        " "
                                    ]
                                }),
                                " of your wish to add your Diligentsia account and request that they grant you access. ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Please click below REQUEST to grant for access",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Kind Regards",
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcse",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>requestAdvisorAccess(),
                            className: "bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                            children: "Request"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalCardClasses: "m0rem",
                modalType: "descriptionPopup",
                girlComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        position: "relative",
                        maxHeight: "90%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/girl-1730109127115.webp",
                            alt: "messageLadie",
                            className: "girlImage"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: "introVideo"
                                }));
                                dispatch((0, $ee5327cdf6cdce8c$export$25316803c042c1e3)({
                                    modalHistory: modal["open"]
                                }));
                            },
                            src: (parcelRequire("lp3wv")),
                            className: "pa cp",
                            alt: "clickToHearMe",
                            style: {
                                maxWidth: "130px",
                                zIndex: 99,
                                top: "-210px",
                                left: "15px"
                            }
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "fs1-5rem tas w100 lh1 c15 fw600 mb0-5rem",
                        children: "Company Description"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c3 fs14px w100 tas mb1rem",
                        children: "AI Generated"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc fs14px c43 oya h40vh",
                        style: {
                            lineHeight: "1.8",
                            overflow: "scroll",
                            paddingRight: "14px",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            backgroundImage: `url(${(parcelRequire("dJEkK"))})`
                        },
                        children: company["companyDescription"]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c4 fs11px fw500 w100 tas pt1rem mb0-5rem",
                        children: "You can later edit description in Company Settings"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: ()=>{
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: ""
                            }));
                        },
                        className: "df jcc fdc fdr-md aic fs1rem px2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            className: "cp bg4 c1 mt0-5rem br50px py0-75rem px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac",
                            to: $16250bd714b02a14$export$eed606b4351295d7,
                            children: "Next"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "advisorType",
                onClose: onAdvisorModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 p2rem shadow w30 bsbb df fdc maw600px br5px pr",
                    style: {
                        outline: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: onAdvisorModalClose,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc fs1-5rem",
                            children: "Add Advisor type"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "text",
                            id: "advisorType",
                            value: advisorTypeValue,
                            placeholder: "Advisor Type",
                            style: {
                                paddingLeft: "50px"
                            },
                            onChange: (e)=>setAdvisorTypeValue(e["target"]["value"]),
                            className: "mt1rem pl1rem lpins w100 br10px p1rem custom-input"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `shadow bg3 c1 td250 br5px p0-5rem fw600 cp ttu bsbb tac mt1rem df jcc aic w50 `,
                            style: {
                                backgroundColor: advisorTypeValue === "" && "lightgray",
                                cursor: advisorTypeValue === "" ? "not-allowed" : "pointer"
                            },
                            onClick: ()=>{
                                advisorTypeValue !== "" && onAdvisorTypeAdded();
                            },
                            children: "Add"
                        })
                    ]
                })
            })
        ]
    });
};
var $d4f6cac57672a71e$export$2e2bcd8739ae039 = $d4f6cac57672a71e$var$RegisterTwoMinuteTest;



const $ba5b94d95666305b$export$58cfd9be695cf66b = [
    'banner-title',
    'life-cycle-title',
    'clinet-review-title',
    'how-its-work-title',
    'work-block-scaling',
    'key-features',
    'video-section-title',
    "register-form-title",
    "not-sure",
    'pricing-title',
    'pricing-section'
];
const $ba5b94d95666305b$var$Register = ()=>{
    const refs = (0, $acw62.useRef)($ba5b94d95666305b$export$58cfd9be695cf66b.map(()=>/*#__PURE__*/ (0, $acw62.createRef)()));
    const [isAnimationVisible, setIsAnimationVisible] = (0, $acw62.useState)(false);
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    (0, $acw62.useEffect)(()=>{
        const token = localStorage.getItem('token');
        if (token && user && !location?.hash) {
            if (user && [
                'Member',
                'User'
            ].includes(user?.role)) window.location.href = '/dashboard';
            else if (user && user?.role == 'Advisor') window.location.href = '/advisor-dashboard';
            else if (user && user?.role == 'Investor') window.location.href = '/investor-dashboard';
        }
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        // Track page view when component mounts
        (0, $6ee05925f8d16f34$export$92ab14d0aa42e41e)('register_page');
        const observers = refs.current.map((ref, index)=>new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) {
                    setIsAnimationVisible((prev)=>({
                            ...prev,
                            [index]: true
                        }));
                    // Track when each section becomes visible
                    (0, $6ee05925f8d16f34$export$92ab14d0aa42e41e)(`register_section_${$ba5b94d95666305b$export$58cfd9be695cf66b[index]}`);
                }
            }, {
                threshold: 0.5
            }));
        refs.current.forEach((ref, index)=>{
            if (ref.current) observers[index].observe(ref.current);
        });
        return ()=>{
            refs.current.forEach((ref, index)=>{
                if (ref.current) observers[index].unobserve(ref.current);
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-page",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4f6cac57672a71e$export$2e2bcd8739ae039), {
                registerationType: "User",
                refs: refs,
                isAnimationVisible: isAnimationVisible,
                registerPage: true
            })
        })
    });
};
var $ba5b94d95666305b$export$2e2bcd8739ae039 = $ba5b94d95666305b$var$Register;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $b79a979012c7be98$var$ButtonCss = {
    right: '26px',
    bottom: '99px',
    width: '40px',
    zIndex: '999'
};
const $b79a979012c7be98$var$SmoothScrollingButton = ()=>{
    const [isVisible, setIsVisible] = (0, $acw62.useState)(false);
    const [isHover, setIsHover] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const toggleVisibility = ()=>{
            if (window.scrollY > 400) setIsVisible(true);
            else setIsVisible(false);
        };
        window.addEventListener('scroll', toggleVisibility);
        return ()=>window.removeEventListener('scroll', toggleVisibility);
    }, []);
    // Scroll to top when button is clicked
    const scrollToTop = ()=>window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `pf cp zi10 ${isVisible ? 'db' : 'dn'}`,
        onClick: scrollToTop,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: isHover ? /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            className: "pf top-arrow-btn",
            width: "69",
            height: "69",
            viewBox: "0 0 69 69",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                ...$b79a979012c7be98$var$ButtonCss
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    opacity: "0.8",
                    width: "69",
                    height: "69",
                    rx: "34.5",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M45.2266 33.1712C45.4061 33.3446 45.5493 33.552 45.6478 33.7814C45.7463 34.0107 45.7982 34.2574 45.8004 34.507C45.8025 34.7566 45.755 35.0041 45.6605 35.2351C45.5659 35.4662 45.4264 35.6761 45.2499 35.8526C45.0734 36.0291 44.8635 36.1686 44.6325 36.2632C44.4014 36.3577 44.1539 36.4052 43.9043 36.4031C43.6547 36.4009 43.408 36.349 43.1787 36.2505C42.9493 36.152 42.7419 36.0088 42.5685 35.8293L36.3783 29.639V51.4185C36.3783 51.9171 36.1803 52.3952 35.8277 52.7477C35.4752 53.1003 34.9971 53.2983 34.4985 53.2983C33.9999 53.2983 33.5218 53.1003 33.1693 52.7477C32.8167 52.3952 32.6187 51.9171 32.6187 51.4185V29.639L26.4285 35.8293C26.0739 36.1717 25.5991 36.3611 25.1062 36.3569C24.6133 36.3526 24.1419 36.1549 23.7933 35.8064C23.4448 35.4578 23.2471 34.9863 23.2428 34.4935C23.2385 34.0006 23.428 33.5257 23.7704 33.1712L33.1695 23.7722C33.3441 23.5971 33.5515 23.4582 33.7799 23.3634C34.0083 23.2687 34.2531 23.2199 34.5004 23.2199C34.7476 23.2199 34.9925 23.2687 35.2208 23.3634C35.4492 23.4582 35.6567 23.5971 35.8313 23.7722L45.2266 33.1712ZM45.7773 15.7021H23.2197C22.7211 15.7021 22.243 15.9002 21.8904 16.2527C21.5379 16.6053 21.3398 17.0834 21.3398 17.582C21.3398 18.0805 21.5379 18.5586 21.8904 18.9112C22.243 19.2637 22.7211 19.4618 23.2197 19.4618H45.7773C46.2759 19.4618 46.754 19.2637 47.1066 18.9112C47.4591 18.5586 47.6572 18.0805 47.6572 17.582C47.6572 17.0834 47.4591 16.6053 47.1066 16.2527C46.754 15.9002 46.2759 15.7021 45.7773 15.7021Z",
                    fill: "#F9F9F9"
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            className: "pf msg-btn sm-bottom4px",
            width: "69",
            height: "69",
            viewBox: "0 0 69 69",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                ...$b79a979012c7be98$var$ButtonCss
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    opacity: "0.8",
                    width: "69",
                    height: "69",
                    rx: "34.5",
                    fill: "#060606"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M45.2266 33.1712C45.4061 33.3446 45.5493 33.552 45.6478 33.7814C45.7463 34.0107 45.7982 34.2574 45.8004 34.507C45.8025 34.7566 45.755 35.0041 45.6605 35.2351C45.5659 35.4662 45.4264 35.6761 45.2499 35.8526C45.0734 36.0291 44.8635 36.1686 44.6325 36.2632C44.4014 36.3577 44.1539 36.4052 43.9043 36.4031C43.6547 36.4009 43.408 36.349 43.1787 36.2505C42.9493 36.152 42.7419 36.0088 42.5685 35.8293L36.3783 29.639V51.4185C36.3783 51.9171 36.1803 52.3952 35.8277 52.7477C35.4752 53.1003 34.9971 53.2983 34.4985 53.2983C33.9999 53.2983 33.5218 53.1003 33.1693 52.7477C32.8167 52.3952 32.6187 51.9171 32.6187 51.4185V29.639L26.4285 35.8293C26.0739 36.1717 25.5991 36.3611 25.1062 36.3569C24.6133 36.3526 24.1419 36.1549 23.7933 35.8064C23.4448 35.4578 23.2471 34.9863 23.2428 34.4935C23.2385 34.0006 23.428 33.5257 23.7704 33.1712L33.1695 23.7722C33.3441 23.5971 33.5515 23.4582 33.7799 23.3634C34.0083 23.2687 34.2531 23.2199 34.5004 23.2199C34.7476 23.2199 34.9925 23.2687 35.2208 23.3634C35.4492 23.4582 35.6567 23.5971 35.8313 23.7722L45.2266 33.1712ZM45.7773 15.7021H23.2197C22.7211 15.7021 22.243 15.9002 21.8904 16.2527C21.5379 16.6053 21.3398 17.0834 21.3398 17.582C21.3398 18.0805 21.5379 18.5586 21.8904 18.9112C22.243 19.2637 22.7211 19.4618 23.2197 19.4618H45.7773C46.2759 19.4618 46.754 19.2637 47.1066 18.9112C47.4591 18.5586 47.6572 18.0805 47.6572 17.582C47.6572 17.0834 47.4591 16.6053 47.1066 16.2527C46.754 15.9002 46.2759 15.7021 45.7773 15.7021Z",
                    fill: "#F9F9F9"
                })
            ]
        })
    });
};
var $b79a979012c7be98$export$2e2bcd8739ae039 = $b79a979012c7be98$var$SmoothScrollingButton;










const $a46bd5ef9aae83ce$var$OPTIONS_SECTION = [
    {
        icon: (parcelRequire("iFOmq")),
        identifier: 'support'
    },
    {
        icon: (parcelRequire("1aHMF")),
        identifier: 'sales'
    },
    {
        icon: (parcelRequire("3cMIH")),
        identifier: 'patner'
    },
    {
        icon: (parcelRequire("isiQT")),
        identifier: 'bugs'
    }
];




const $a46bd5ef9aae83ce$var$SECTION_CONTENT = [
    {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "fw500 c15",
            style: {
                fontSize: '39px',
                lineHeight: '48.52px'
            },
            children: [
                "I have a ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: "customer support"
                }),
                " issue ..."
            ]
        }),
        subTitle: 'Please first ask our customer support bot link, FAQs troubleshooting - ',
        subTitle1: 'you can ask support team at Diligentsia by asking a question in your own words',
        image: (parcelRequire("hKwh2")),
        imageStyle: {
            width: '50%'
        },
        arrowClass: 'bottom-arrow-support',
        email: 'Support@diligentsia.co.uk',
        identifier: 'support'
    },
    {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "fw500 c15",
            style: {
                fontSize: '39px',
                lineHeight: '48.52px'
            },
            children: [
                "I want to talk to someone in ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: "sales"
                }),
                " ..."
            ]
        }),
        subTitle: 'Please first ask our customer support bot link, FAQs, troubleshooting. If no joy, please feel free to call.',
        image: (parcelRequire("7LSyE")),
        imageStyle: {
            width: '50%'
        },
        arrowClass: 'bottom-arrow-sales',
        email: 'sales@diligentsia.co.uk',
        identifier: 'sales'
    },
    {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "fw500 c15",
            style: {
                fontSize: '39px',
                lineHeight: '48.52px'
            },
            children: [
                "I want to ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: "partner with Diligentsia"
                }),
                " ..."
            ]
        }),
        subTitle: 'If you are talking strategic partnering we would love to hear from you...',
        image: (parcelRequire("7LSyE")),
        imageStyle: {
            width: '50%'
        },
        arrowClass: 'bottom-arrow-patner',
        email: 'sales@diligentsia.co.uk',
        identifier: 'patner'
    },
    {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "fw500 c15",
            style: {
                fontSize: '39px',
                lineHeight: '48.52px'
            },
            children: [
                "Drop us a note ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: "about Diligentsia"
                }),
                " ..."
            ]
        }),
        subTitle: 'Our platform is new so please let us know your thoughts on what is does, how it works, what you want or any other topic. All suggestions and feedback are useful and appreciated.',
        // subTitle1: <>(and ideally a screenshot) using this form. Any suggestions for improvement/new features also gratefully received.<br />
        //     <div className="pt3rem">We appreciate your help as we create our ecosystem community.</div>
        // </>,
        image: (parcelRequire("dtHaj")),
        imageStyle: {
            width: '50%'
        },
        arrowClass: 'bottom-arrow-bugs',
        email: '',
        identifier: 'bugs'
    }
];

const $a46bd5ef9aae83ce$var$ContactUs = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [bugDescription, setBugDescription] = (0, $acw62.useState)();
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [onEmailHover, setOnEmailHover] = (0, $acw62.useState)(false);
    let [selectOption, setSelectOption] = (0, $acw62.useState)($a46bd5ef9aae83ce$var$SECTION_CONTENT?.[0]);
    const handleOptionSelect = (obj)=>{
        const selectedObj = $a46bd5ef9aae83ce$var$SECTION_CONTENT?.find((sectionObj, i, arr)=>sectionObj?.identifier === obj?.identifier);
        setSelectOption(selectedObj);
    };
    const onImageClick = (identifier)=>{
        if (identifier === "support") window.Intercom('show');
        else if (identifier === "bugs") dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "report-bug"
        }));
        else window.open('https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true', '_blank');
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e)=>{
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        e.target.querySelector("input").value = null;
        handleAttachmentFile(e);
    };
    const handleAttachmentFile = async (e)=>{
        if (e.target.files) {
            let newAttachment = [];
            for (const file of e.target.files)await newAttachment.push(file);
            setAttachment(newAttachment);
        }
    };
    //Delete image handler
    const handleDelete = async (targetFile)=>{
        let updateAttachments = await attachment.filter((file)=>file.name !== targetFile.name);
        setAttachment(updateAttachments);
    };
    //submit handler
    const handleSubmitBug = async ()=>{
        if (!bugDescription) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please add bug description!");
        const wordCount = bugDescription?.split(/\s+/).length;
        if (wordCount < 5) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please elaborate bug in minimum five words");
        let data;
        if (attachment) data = {
            attachment: attachment,
            bugDescription: bugDescription
        };
        else data = {
            bugDescription: bugDescription
        };
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/reportBug", data);
        if (res || res["code"] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style bg1 pr contact-us-page oh",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100 mih200px",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w60 fs2-5rem fw500 c15 df aic",
                                    style: {
                                        lineHeight: "3.45rem",
                                        paddingLeft: '11.5rem'
                                    },
                                    children: "How can we best help you?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w35 pr df ais bscon brnr pr8rem xs-dn"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "pl10rem pr10rem pb2rem w100 sm-p0rem sm-pb2rem",
                            style: {
                                maxWidth: '100%'
                            },
                            children: $a46bd5ef9aae83ce$var$OPTIONS_SECTION?.map((obj, i, arr)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: obj?.icon,
                                    className: `w20 cp pr`,
                                    onClick: ()=>handleOptionSelect(obj),
                                    style: {
                                        transform: selectOption?.identifier === obj?.identifier ? "scale(1.2)" : "scale(1)",
                                        transition: "transform 0.3s ease"
                                    }
                                });
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg20 pt3rem pb8rem px10rem w100 df pr",
                            style: {
                                minHeight: "40vh",
                                background: `url(${(parcelRequire("93zLg"))})`
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: selectOption?.arrowClass
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w60 df fdc jcc",
                                    children: [
                                        selectOption?.title,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "fw400 c14 mt2rem",
                                            style: {
                                                fontSize: '16px',
                                                lineHeight: '32px'
                                            },
                                            children: selectOption?.subTitle
                                        }),
                                        selectOption?.subTitle1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "fw400 c14",
                                            style: {
                                                fontSize: '16px',
                                                lineHeight: '32px'
                                            },
                                            children: selectOption?.subTitle1
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "fw400 c14",
                                            style: {
                                                fontSize: '16px',
                                                lineHeight: '32px',
                                                visibility: 'hidden'
                                            },
                                            children: "NO Text"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df aic mt5rem ${selectOption?.identifier === "bugs" && 'vh'}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "cp",
                                                onClick: ()=>window.location = `mailto:${selectOption?.email}`,
                                                onMouseLeave: ()=>setOnEmailHover(false),
                                                onMouseEnter: ()=>setOnEmailHover(true),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        width: "22",
                                                        height: "16",
                                                        viewBox: "0 0 22 16",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M19.25 0.5H2.75C2.15326 0.5 1.58097 0.737053 1.15901 1.15901C0.737053 1.58097 0.5 2.15326 0.5 2.75V13.25C0.5 13.8467 0.737053 14.419 1.15901 14.841C1.58097 15.2629 2.15326 15.5 2.75 15.5H19.25C19.8467 15.5 20.419 15.2629 20.841 14.841C21.2629 14.419 21.5 13.8467 21.5 13.25V2.75C21.5 2.15326 21.2629 1.58097 20.841 1.15901C20.419 0.737053 19.8467 0.5 19.25 0.5ZM18.9275 2L11.3225 8.06C11.105 8.2625 10.895 8.2625 10.6325 8.06L3.0725 2H18.9275ZM19.25 14H2.75C2.55109 14 2.36032 13.921 2.21967 13.7803C2.07902 13.6397 2 13.4489 2 13.25V3.065L9.6575 9.1625C10.0214 9.51576 10.5078 9.71462 11.015 9.7175C11.493 9.71548 11.952 9.53027 12.2975 9.2L20 3.065V13.25C20 13.4489 19.921 13.6397 19.7803 13.7803C19.6397 13.921 19.4489 14 19.25 14Z",
                                                            fill: onEmailHover ? "#FC7785" : "#505050"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `${onEmailHover ? "c4" : 'c14'} fw600 pl0-5rem`,
                                                        style: {
                                                            fontSize: '18px',
                                                            lineHeight: '32px'
                                                        },
                                                        children: selectOption?.email
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w40",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectOption?.image,
                                        className: "cp",
                                        style: {
                                            ...selectOption?.imageStyle
                                        },
                                        onClick: ()=>onImageClick(selectOption?.identifier)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "report-bug",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>hideBugPopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: [
                                " ",
                                "Report a Bug"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    children: [
                                        "Enter a description of the bug or suggested improvement below....",
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "It is always useful if you are able to attach a screenshot..."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setBugDescription(e.target.value),
                                    rows: "4",
                                    value: bugDescription,
                                    placeholder: "Please add bug description or suggestion for improvement here",
                                    className: "bss bw2px bo5 w100 br5px p1rem mt1rem"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            onDragOver: onDragOver,
                            onDrop: (e)=>onDrop(e),
                            for: "attachment",
                            className: "w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pen fs1rem fw500 tac",
                                    children: "Click here or drag and drop attachment (max 5MB)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onChange: (e)=>handleAttachmentFile(e),
                                    className: "dn",
                                    id: "attachment",
                                    type: "file",
                                    accept: "image/jpeg, image/jpg, image/png",
                                    multiple: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc aic my1rem",
                            children: attachment && attachment.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcc br25px lh1 bg3 c1 p1rem fw600 mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: item,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "py0-5rem pl0-5rem",
                                                children: item["name"].substring(0, 20) + "..."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            onClick: ()=>handleDelete(item),
                                            className: "p0-5rem f9 w1rem h1rem cp",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 320 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "pen fa-primary",
                                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32.0 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                            })
                                        })
                                    ]
                                }, item["name"]))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ""
                                        })),
                                    className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>handleSubmitBug(),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $a46bd5ef9aae83ce$export$2e2bcd8739ae039 = $a46bd5ef9aae83ce$var$ContactUs;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





const $8ddc29eaef537afb$var$PARTNER_PROGRAM = [
    {
        title: 'How can we together help our customers?',
        subTitle: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Are we offering services or a complementary platform to the same target",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " customer types?"
                ]
            }),
            "Let\u2019s discuss how we can together deliver more value to our customers."
        ],
        icon: (parcelRequire("6gL2z")),
        iconStyle: {
            width: '62%'
        }
    },
    {
        title: 'Create your own co-branded Expansion Pack?',
        subTitle: [
            'You develop with us (or sponsor) your own Expansion Pack',
            'Add it to Diligentsia AppStore',
            'Generate new clients',
            'Opportunity to upsell based upon reviews of automated report',
            'We agree the revenue share'
        ],
        icon: (parcelRequire("kdjt4")),
        hasPoints: true,
        iconStyle: {
            width: '100%'
        }
    },
    {
        title: 'Create your own internal bespoked checklists?',
        subTitle: [
            'Already a Diligentsia user?',
            'We can help you develop your own internal checklists'
        ],
        icon: (parcelRequire("cmxC8")),
        iconStyle: {
            width: '86%'
        }
    }
];


const $8ddc29eaef537afb$var$PartnerProgram = ()=>{
    const onClickHandler = ()=>{
        window.open('https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true', '_blank');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "poppins-font-style bg1 pr partners-page oh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df w100 mih300px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w60  fw500 c15 df aic",
                            style: {
                                fontSize: '32px',
                                lineHeight: "2.1rem",
                                paddingLeft: '9rem'
                            },
                            children: [
                                "Diligentsia ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c4 mx0-5rem",
                                    children: " Partnership"
                                }),
                                " opportunities"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w40 pr df jcc pr8rem bscov brnr bpc pt2-5rem pb2-5rem",
                            style: {
                                backgroundImage: `url(${(parcelRequire("VI0Xf"))})`
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100  df jcc fdc aic pr",
                    children: $8ddc29eaef537afb$var$PARTNER_PROGRAM?.map((obj, i, arr)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `mt2rem ${i === 2 ? "mb10rem" : 'mb2rem'} p2-5rem br15px df`,
                            style: {
                                width: '78%',
                                background: '#F0F2FD80'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w70 df fdc jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "fw500 fs2rem c15 mb1rem",
                                            style: {
                                                lineHeight: '39.81px'
                                            },
                                            children: obj?.title
                                        }),
                                        !obj?.hasPoints ? obj?.subTitle?.map((str, index, arr)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fw400 c14 mt0-5rem",
                                                style: {
                                                    fontSize: '15px',
                                                    lineHeight: '23px'
                                                },
                                                children: str
                                            });
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "pl1-5rem mt1rem",
                                            style: {
                                                listStyleType: 'disc'
                                            },
                                            children: obj?.subTitle?.map((str, index, arr)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "fw400 c14 mt0-5rem",
                                                    style: {
                                                        fontSize: '15px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: str
                                                    })
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            onClick: onClickHandler,
                                            className: "cp bg4 br40px df jcsb aic pl1rem pr1rem mt1-5rem",
                                            style: {
                                                width: '20%',
                                                paddingTop: '12px',
                                                paddingBottom: '12px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "27",
                                                            height: "27",
                                                            viewBox: "0 0 39 39",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    opacity: "0.9",
                                                                    d: "M33.3804 4.33135H30.3365C30.3365 4.06704 30.2812 3.80565 30.1742 3.56399C30.0671 3.32233 29.9106 3.10577 29.7148 2.92823C29.519 2.75069 29.2882 2.61612 29.0373 2.53317C28.7863 2.45022 28.5207 2.42072 28.2577 2.44659C27.7806 2.50563 27.3422 2.73901 27.0268 3.10184C26.7115 3.46466 26.5414 3.93129 26.5493 4.41196V5.27811C26.5493 5.7122 26.6983 6.13314 26.9716 6.47044C27.2448 6.80774 27.6256 7.04092 28.0503 7.13093C28.1718 7.15386 28.2795 7.22337 28.3505 7.32465C28.4215 7.42592 28.45 7.55091 28.4301 7.67296C28.4102 7.795 28.3433 7.90441 28.2438 7.97784C28.1443 8.05127 28.0201 8.0829 27.8976 8.06597C27.2514 7.93885 26.6694 7.59143 26.2509 7.083C25.8323 6.57457 25.6032 5.93665 25.6026 5.27811V4.33135H20.329C20.3267 4.08071 20.2747 3.83301 20.1759 3.60262C20.0772 3.37224 19.9337 3.16374 19.7537 2.98923C19.5738 2.81471 19.361 2.67764 19.1277 2.58597C18.8944 2.49429 18.6453 2.44983 18.3947 2.45517C18.1441 2.46051 17.897 2.51553 17.6678 2.61705C17.4387 2.71858 17.2319 2.86458 17.0596 3.04659C16.8872 3.22861 16.7527 3.44302 16.6639 3.67741C16.575 3.91179 16.5336 4.16147 16.5419 4.41199L16.5419 5.27811C16.5418 5.7122 16.6909 6.13313 16.9641 6.47043C17.2374 6.80773 17.6182 7.04091 18.0428 7.13093C18.1643 7.15388 18.272 7.2234 18.343 7.32467C18.4139 7.42593 18.4425 7.55091 18.4225 7.67293C18.4026 7.79496 18.3358 7.90436 18.2363 7.97779C18.1368 8.05121 18.0126 8.08285 17.8901 8.06595C17.244 7.93882 16.662 7.5914 16.2434 7.08297C15.8249 6.57455 15.5957 5.93663 15.5951 5.27809V4.33135H12.5512C11.7984 4.33275 11.0767 4.63244 10.5444 5.1648C10.012 5.69716 9.71233 6.41879 9.71094 7.17165V9.80842H36.2207V7.17165C36.2193 6.41878 35.9196 5.69715 35.3872 5.1648C34.8549 4.63244 34.1332 4.33275 33.3804 4.33135ZM17.4887 4.33135C17.4924 4.08268 17.5937 3.84544 17.7709 3.67089C17.9481 3.49634 18.1868 3.3985 18.4355 3.3985C18.6842 3.39851 18.9229 3.49636 19.1 3.67091C19.2772 3.84547 19.3786 4.08272 19.3822 4.33139L17.4887 4.33135ZM27.4961 4.33135C27.4998 4.08268 27.6012 3.84544 27.7784 3.67089C27.9555 3.49634 28.1942 3.3985 28.4429 3.3985C28.6916 3.39851 28.9303 3.49636 29.1075 3.67091C29.2846 3.84547 29.386 4.08272 29.3897 4.33139L27.4961 4.33135Z",
                                                                    fill: "#FEFEFE"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    opacity: "0.9",
                                                                    d: "M9.74219 17.1934C9.87852 17.459 10.8695 19.0329 10.954 19.27C11.2572 19.9563 11.3021 20.729 11.0806 21.4458C10.8591 22.1626 10.386 22.7752 9.74849 23.1707C9.7935 23.9237 10.1243 24.6311 10.6733 25.1485C11.2223 25.6658 11.9481 25.954 12.7024 25.9543H33.2286C34.0134 25.9531 34.7657 25.6409 35.3206 25.086C35.8755 24.5311 36.1877 23.7788 36.1888 22.994V11.0078H9.74219V17.1934ZM30.4261 13.3495C30.6717 13.3528 30.9061 13.4527 31.0786 13.6275C31.251 13.8023 31.3477 14.0381 31.3477 14.2837C31.3477 14.5292 31.251 14.765 31.0785 14.9398C30.906 15.1146 30.6717 15.2145 30.4261 15.2178C30.1805 15.2145 29.9461 15.1146 29.7736 14.9398C29.6012 14.7649 29.5045 14.5292 29.5045 14.2836C29.5045 14.038 29.6012 13.8023 29.7737 13.6275C29.9462 13.4527 30.1805 13.3528 30.4261 13.3495ZM30.4261 17.5469C30.6716 17.5503 30.9059 17.6502 31.0783 17.8251C31.2506 17.9999 31.3473 18.2355 31.3473 18.481C31.3473 18.7266 31.2506 18.9622 31.0782 19.137C30.9058 19.3118 30.6716 19.4117 30.4261 19.4152C30.1806 19.4117 29.9463 19.3118 29.7739 19.137C29.6016 18.9622 29.5049 18.7265 29.5049 18.481C29.5049 18.2355 29.6016 17.9999 29.774 17.825C29.9464 17.6502 30.1806 17.5503 30.4261 17.5469ZM30.4261 21.7442C30.6717 21.7475 30.9061 21.8474 31.0786 22.0223C31.251 22.1971 31.3477 22.4328 31.3477 22.6784C31.3477 22.924 31.251 23.1597 31.0785 23.3345C30.906 23.5094 30.6717 23.6092 30.4261 23.6126C30.1805 23.6092 29.9461 23.5093 29.7736 23.3345C29.6012 23.1597 29.5045 22.924 29.5045 22.6784C29.5045 22.4328 29.6012 22.1971 29.7737 22.0222C29.9462 21.8474 30.1805 21.7475 30.4261 21.7442ZM22.9655 13.3495C23.2111 13.3528 23.4455 13.4527 23.618 13.6275C23.7905 13.8023 23.8872 14.0381 23.8872 14.2837C23.8872 14.5292 23.7904 14.765 23.618 14.9398C23.4455 15.1146 23.2111 15.2145 22.9655 15.2178C22.7199 15.2145 22.4855 15.1146 22.3131 14.9398C22.1406 14.7649 22.0439 14.5292 22.0439 14.2836C22.0439 14.038 22.1406 13.8023 22.3131 13.6275C22.4856 13.4527 22.72 13.3528 22.9655 13.3495ZM22.9655 17.5469C23.211 17.5503 23.4453 17.6502 23.6177 17.8251C23.7901 17.9999 23.8867 18.2355 23.8867 18.481C23.8867 18.7266 23.79 18.9622 23.6177 19.137C23.4453 19.3118 23.211 19.4117 22.9655 19.4152C22.72 19.4117 22.4857 19.3118 22.3134 19.137C22.141 18.9622 22.0443 18.7265 22.0443 18.481C22.0443 18.2355 22.141 17.9999 22.3134 17.825C22.4858 17.6502 22.7201 17.5503 22.9655 17.5469ZM22.9655 21.7442C23.2111 21.7475 23.4455 21.8474 23.618 22.0223C23.7905 22.1971 23.8872 22.4328 23.8872 22.6784C23.8872 22.924 23.7904 23.1597 23.618 23.3345C23.4455 23.5094 23.2111 23.6092 22.9655 23.6126C22.7199 23.6092 22.4855 23.5094 22.3131 23.3345C22.1406 23.1597 22.0439 22.924 22.0439 22.6784C22.0439 22.4328 22.1406 22.1971 22.3131 22.0222C22.4856 21.8474 22.72 21.7475 22.9655 21.7442ZM15.505 13.3495C15.7493 13.3547 15.9818 13.4554 16.1527 13.63C16.3237 13.8047 16.4194 14.0393 16.4194 14.2837C16.4194 14.528 16.3236 14.7626 16.1527 14.9373C15.9818 15.1119 15.7492 15.2126 15.5049 15.2178C15.2606 15.2126 15.0281 15.1119 14.8572 14.9373C14.6862 14.7626 14.5905 14.528 14.5905 14.2836C14.5905 14.0393 14.6862 13.8046 14.8572 13.63C15.0281 13.4554 15.2607 13.3547 15.505 13.3495ZM15.505 17.5469C15.7493 17.552 15.9819 17.6527 16.1529 17.8273C16.3239 18.002 16.4196 18.2366 16.4196 18.481C16.4196 18.7254 16.3239 18.9601 16.1529 19.1347C15.9819 19.3094 15.7493 19.41 15.5049 19.4152C15.2606 19.41 15.028 19.3093 14.857 19.1347C14.686 18.9601 14.5902 18.7254 14.5902 18.481C14.5902 18.2366 14.686 18.002 14.857 17.8273C15.028 17.6527 15.2606 17.552 15.505 17.5469ZM15.505 21.7442C15.7493 21.7494 15.9819 21.8501 16.1529 22.0247C16.3239 22.1993 16.4197 22.434 16.4196 22.6784C16.4196 22.9228 16.3239 23.1575 16.1529 23.3321C15.9819 23.5067 15.7493 23.6074 15.5049 23.6126C15.2606 23.6074 15.028 23.5067 14.857 23.3321C14.686 23.1575 14.5902 22.9228 14.5902 22.6784C14.5902 22.434 14.686 22.1993 14.857 22.0247C15.028 21.85 15.2606 21.7494 15.505 21.7442Z",
                                                                    fill: "#FEFEFE"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M21.993 30.9786L19.7586 29.6342C19.5111 29.4866 19.2327 29.3987 18.9453 29.3775C18.6579 29.3563 18.3695 29.4024 18.1031 29.512C17.8366 29.6217 17.5993 29.7919 17.4101 30.0092C17.2209 30.2266 17.0849 30.485 17.013 30.7641C16.9356 30.9948 16.8076 31.2054 16.6383 31.3802C16.4689 31.5551 16.2626 31.6898 16.0344 31.7746C15.8062 31.8593 15.5619 31.8919 15.3195 31.8699C15.0771 31.848 14.8427 31.772 14.6334 31.6476C13.2117 30.7997 11.9014 29.7777 10.7327 28.6054C9.56324 27.4388 8.54149 26.133 7.69034 24.7173C7.56427 24.5008 7.48903 24.2585 7.47032 24.0087C7.4516 23.7589 7.4899 23.5081 7.58232 23.2753C7.67473 23.0424 7.81885 22.8336 8.00378 22.6646C8.18871 22.4957 8.40963 22.3709 8.64984 22.2998C8.89934 22.2223 9.12966 22.0929 9.32573 21.9202C9.52179 21.7475 9.67919 21.5353 9.78762 21.2976C9.89604 21.0599 9.95306 20.802 9.95494 20.5407C9.95681 20.2794 9.90351 20.0207 9.79851 19.7814C9.84927 19.8024 8.3863 17.4031 8.35944 17.345C8.10616 16.9272 7.69801 16.6264 7.22391 16.5081C6.74982 16.3899 6.24821 16.4639 5.8284 16.7139C4.45345 17.5364 3.44502 18.8536 3.00966 20.3955C2.57429 21.9374 2.74495 23.5875 3.48667 25.0076C5.89802 29.647 9.67986 33.431 14.3178 35.8451C15.738 36.5888 17.3888 36.7613 18.9321 36.3271C20.4753 35.8929 21.794 34.8849 22.6179 33.5097C22.8707 33.0912 22.9468 32.5894 22.8297 32.1147C22.7125 31.6401 22.4115 31.2314 21.993 30.9786Z",
                                                                    fill: "#FEFEFE"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "pl0-5rem fw600 c1",
                                                            style: {
                                                                fontSize: '12px',
                                                                lineHeight: '17px'
                                                            },
                                                            children: "Book a Call"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    width: "20",
                                                    height: "17",
                                                    viewBox: "0 0 28 25",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                                                        fill: "white"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w30 bscon brnr df jcc aic",
                                    style: {
                                        backgroundImage: `url(${(parcelRequire("jGXLu"))})`
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: obj?.icon,
                                        style: {
                                            ...obj?.iconStyle
                                        }
                                    })
                                })
                            ]
                        });
                    })
                })
            ]
        })
    });
};
var $8ddc29eaef537afb$export$2e2bcd8739ae039 = $8ddc29eaef537afb$var$PartnerProgram;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");







const $a44d10b55cf00889$var$HERO_CARDS = [
    {
        name: 'GenFinance',
        logo: (parcelRequire("jViIO"))
    },
    {
        name: 'ABF',
        logo: (parcelRequire("fkt5e"))
    },
    {
        name: 'JPJenkins',
        logo: (parcelRequire("02e9s"))
    },
    {
        name: 'Brown Rudnick',
        logo: (parcelRequire("4ghjp"))
    },
    {
        name: 'Fin-house',
        logo: (parcelRequire("9NBW9"))
    },
    {
        name: 'Kiss the fish',
        logo: (parcelRequire("iKoy8"))
    }
];

const $a44d10b55cf00889$var$PartnerHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-partner-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-partner-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-partner-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-partner-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-partner-eyebrow",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "Partner with Diligentsia"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "lp-partner-hero-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: [
                                    "Reach high-intent SMEs",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: " at exactly the right moment."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-partner-hero-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "Your solution, shown to companies, CFOs, and investors at exactly the moment they need it."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-partner-hero-cta",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "lp-btn lp-btn--primary",
                                    href: "#cta",
                                    children: "Become a partner"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-partner-hero-note",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "Free listing \xb7 No upfront cost \xb7 Live in hours"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-partner-hero-art",
                        "data-lp-reveal": true,
                        "data-lp-delay": "200",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-partner-hero-panel",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "lp-partner-hero-backdrop",
                                src: (parcelRequire("jJQSv")),
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-partner-appcard lp-float-anim",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bar",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "dot",
                                                style: {
                                                    background: '#FF5F57'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "dot",
                                                style: {
                                                    background: '#FEBC2E'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "dot",
                                                style: {
                                                    background: '#28C840'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "ttl",
                                                children: "Diligentsia AppStore"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "grid",
                                        children: $a44d10b55cf00889$var$HERO_CARDS.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "cell",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "tag",
                                                        children: "Partner"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: c.logo,
                                                        alt: c.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "nm",
                                                        children: c.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "more",
                                                        children: "More"
                                                    })
                                                ]
                                            }, i))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $a44d10b55cf00889$export$2e2bcd8739ae039 = $a44d10b55cf00889$var$PartnerHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $0d78d2cf6eb5990c$var$Check = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "20 6 9 17 4 12"
        })
    });
// colour cycle matches the design: green, pink, blue, green, pink, blue
const $0d78d2cf6eb5990c$var$PILLS = [
    {
        t: 'Growth SMEs',
        c: 'green'
    },
    {
        t: 'Fractional CFOs',
        c: 'pink'
    },
    {
        t: 'Investors & VCs',
        c: 'blue'
    },
    {
        t: 'Angel networks',
        c: 'green'
    },
    {
        t: 'PE firms',
        c: 'pink'
    },
    {
        t: 'Accountants',
        c: 'blue'
    }
];




// corner photos — positions + sizes taken verbatim from the design
const $0d78d2cf6eb5990c$var$PEOPLE = [
    {
        cls: 'p1',
        img: (parcelRequire("6Y8De")),
        alt: 'Growth SME founder'
    },
    {
        cls: 'p2',
        img: (parcelRequire("aVv03")),
        alt: 'Investor'
    },
    {
        cls: 'p3',
        img: (parcelRequire("ayLlv")),
        alt: 'Fractional CFO'
    },
    {
        cls: 'p4',
        img: (parcelRequire("5AIsY")),
        alt: 'Advisor'
    }
];
const $0d78d2cf6eb5990c$var$PartnerReachSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-partner-reach",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-partner-reach-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-partner-reach-copy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            "data-lp-reveal": true,
                            children: "Who can you reach?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Growth SMEs, fractional CFOs, and investors \u2014 every one of them mid-transaction, already looking for a solution like yours."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-partner-reach-art",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-partner-reach-pills",
                            children: $0d78d2cf6eb5990c$var$PILLS.map((p, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: `pill pill--${p.c}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($0d78d2cf6eb5990c$var$Check, {})
                                        }),
                                        p.t
                                    ]
                                }, i))
                        }),
                        $0d78d2cf6eb5990c$var$PEOPLE.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `lp-partner-reach-photo ${p.cls}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: p.img,
                                    alt: p.alt
                                })
                            }, p.cls))
                    ]
                })
            ]
        })
    });
var $0d78d2cf6eb5990c$export$2e2bcd8739ae039 = $0d78d2cf6eb5990c$var$PartnerReachSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// -- inline icons (lucide-equivalent) --
const $d057f6cd1b0172e1$var$S = (p, stroke = 'currentColor')=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: stroke,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: p
    });
const $d057f6cd1b0172e1$var$IcTarget = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "2"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcZap = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
        points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
    }));
const $d057f6cd1b0172e1$var$IcEye = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcFilter = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
        points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
    }));
const $d057f6cd1b0172e1$var$IcClock = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "12 6 12 12 16 14"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcBarChart = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "18",
                y1: "20",
                x2: "18",
                y2: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "20",
                x2: "12",
                y2: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "20",
                x2: "6",
                y2: "14"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcRefresh = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "23 4 23 10 17 10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "1 20 1 14 7 14"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcShieldCheck = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "9 12 11 14 15 10"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcPlugZap = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m2 22 3-3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.5 13.5 10 11"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.5 16.5 13 14"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m18 3-4 4h6l-4 4"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcAlert = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "8",
                x2: "12",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "16",
                x2: "12.01",
                y2: "16"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcCheck = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "22 4 12 14.01 9 11.01"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$IcBulb = ()=>$d057f6cd1b0172e1$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 18h6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10 22h4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2Z"
            })
        ]
    }));
const $d057f6cd1b0172e1$var$B1_BULLETS = [
    {
        Icon: $d057f6cd1b0172e1$var$IcTarget,
        t: 'Context-aware placement.',
        d: "Your listing appears in the modules where your service is most relevant \u2014 not on a generic marketplace page."
    },
    {
        Icon: $d057f6cd1b0172e1$var$IcZap,
        t: 'Zero cold outreach.',
        d: "Users discover you while they\u2019re already working. The introduction is warm because it\u2019s relevant."
    },
    {
        Icon: $d057f6cd1b0172e1$var$IcEye,
        t: 'Tracked click-throughs.',
        d: 'We track every click from your AppStore card so you know exactly what the platform is generating for you.'
    }
];
const $d057f6cd1b0172e1$var$B2_BULLETS = [
    {
        Icon: $d057f6cd1b0172e1$var$IcFilter,
        t: 'Pre-qualified by the platform.',
        d: "Level 2 partners receive fact-finding checklists completed by the company \u2014 so you know their situation, their stage, and their urgency before you pick up the phone."
    },
    {
        Icon: $d057f6cd1b0172e1$var$IcClock,
        t: 'Less time qualifying, more time converting.',
        d: 'The average B2B sales cycle starts with weeks of qualification. Ours starts with a brief call, because the qualification is already done.'
    }
];
const $d057f6cd1b0172e1$var$B3_BULLETS = [
    {
        Icon: $d057f6cd1b0172e1$var$IcRefresh,
        t: 'Live, not batch.',
        d: "Records update in real time as companies verify data on the platform \u2014 no overnight syncs."
    },
    {
        Icon: $d057f6cd1b0172e1$var$IcShieldCheck,
        t: 'Structured and verified.',
        d: 'Every field is checked against source documents, not scraped or self-reported.'
    },
    {
        Icon: $d057f6cd1b0172e1$var$IcPlugZap,
        t: 'One API, your product.',
        d: "Pull the fields you need directly into your own screens \u2014 no manual lookups."
    }
];
// Reason: class is `bullet` not `row` — a global `.row { display: flex; flex-wrap: wrap }` in rsuite.change.css
// leaked in and wrapped the icon onto its own line above the text.
const $d057f6cd1b0172e1$var$Bullets = ({ items: items })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-partner-bullets",
        children: items.map(({ Icon: Icon, t: t, d: d }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bullet",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "ic",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "tx",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "t",
                                children: t
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "d",
                                children: d
                            })
                        ]
                    })
                ]
            }, i))
    });

// -- benefit mock cards --
const $d057f6cd1b0172e1$var$MockPlacement = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-partner-mock lp-partner-mock--ip",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "chip",
                children: "Business Audit \xb7 IP Section"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flag",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "ic",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$IcAlert, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "IP not formally assigned to the company"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "rec",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "ic",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$IcBulb, {})
                    }),
                    "Recommended for this issue:"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "rec-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "top",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("7EAcl")),
                                alt: "SeedLegals"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tag",
                                children: "Partner"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "nm",
                        children: "SeedLegals"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "sub",
                        children: "Transaction documentation & legal services"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        className: "more",
                        href: "#cta",
                        children: "More \u2192"
                    })
                ]
            })
        ]
    });
const $d057f6cd1b0172e1$var$MockLead = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-partner-mock lp-partner-mock--lead",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hd",
                children: "Incoming lead"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "co",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "logo",
                        children: "acme"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "nm",
                                children: "Acme Tech Ltd"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                children: "Series A \xb7 \xa32M target"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "need",
                children: "What they need:"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "need-list",
                children: [
                    'IP assignment review',
                    'Employment contracts',
                    'Shareholder agreement'
                ].map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$IcCheck, {})
                            }),
                            t
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "meta",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Diligentsia score:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Silver \uD83C\uDFC5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Stage:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Growth Ready"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Urgency:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                children: [
                                    "High",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "dot"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $d057f6cd1b0172e1$var$MockEnrich = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-partner-mock lp-partner-mock--enrich",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "chip",
                children: "Auto-enriched profile"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "enrich-list",
                children: [
                    'Company registration',
                    'Directors & shareholders',
                    'Filing history',
                    'Funding rounds'
                ].map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$IcCheck, {})
                            }),
                            t
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "synced",
                children: [
                    "Synced via API",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        className: "dot"
                    })
                ]
            })
        ]
    });
const $d057f6cd1b0172e1$var$PartnerWhyChooseSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-partner-why",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-partner-why-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-partner-why-head",
                    "data-lp-reveal": true,
                    children: "Why choose Diligentsia"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-partner-benefit",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "copy",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "eyebrow",
                                    children: "Benefit 1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Not advertising. Placement."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "When a company flags an IP gap, they see your IP advisory service. The moment of need and the moment of introduction are the same moment."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$Bullets, {
                                    items: $d057f6cd1b0172e1$var$B1_BULLETS
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "art",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$MockPlacement, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-partner-benefit is-reverse",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "copy",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "eyebrow",
                                    children: "Benefit 2"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Leads that already know they need you."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "You know what a company needs before the first conversation \u2014 because they've already told the platform."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$Bullets, {
                                    items: $d057f6cd1b0172e1$var$B2_BULLETS
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "art",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$MockLead, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-partner-benefit",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "copy",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "eyebrow",
                                    children: "Benefit 3"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Your data gets smarter. Your product gets better."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Level 3 partners connect to Diligentsia's structured, verified company data \u2014 and auto-enrich their own product with it*."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$Bullets, {
                                    items: $d057f6cd1b0172e1$var$B3_BULLETS
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fsi",
                                    style: {
                                        marginTop: '15px',
                                        fontSize: '12px'
                                    },
                                    children: "=We do not share company's data without company's permission. The company connects with partner and authorizes access to its data"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "art",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($d057f6cd1b0172e1$var$MockEnrich, {})
                        })
                    ]
                })
            ]
        })
    });
var $d057f6cd1b0172e1$export$2e2bcd8739ae039 = $d057f6cd1b0172e1$var$PartnerWhyChooseSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $6f9afdaedd531752$var$IcDatabase = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
            })
        ]
    });




// Level 3 satellite nodes — cross (N/E/S/W) layout around the central data hub, per the design.
const $6f9afdaedd531752$var$NODES = [
    {
        cls: 'n-top',
        img: (parcelRequire("eHYLa")),
        alt: 'You'
    },
    {
        cls: 'n-right',
        img: (parcelRequire("12dQk")),
        alt: 'Partner 2'
    },
    {
        cls: 'n-bottom',
        img: (parcelRequire("7fWbC")),
        alt: 'Partner 3'
    },
    {
        cls: 'n-left',
        img: (parcelRequire("foBrN")),
        alt: 'Partner 1'
    }
];
// dashed connector line from the hub to a node, with an arrowhead at each end
const $6f9afdaedd531752$var$Line = ({ x2: x2, y2: y2 })=>/*#__PURE__*/ (0, $ayMG0.jsx)("line", {
        x1: "130",
        y1: "130",
        x2: x2,
        y2: y2,
        stroke: "rgba(74,103,255,0.5)",
        strokeWidth: "1.5",
        strokeDasharray: "4 4",
        markerStart: "url(#partnerArrow)",
        markerEnd: "url(#partnerArrow)",
        className: "lp-partner-node-line"
    });
const $6f9afdaedd531752$var$PartnerLevelsSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-partner-levels",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                className: "lp-partner-levels-glow lp-partner-levels-glow--1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                className: "lp-partner-levels-glow lp-partner-levels-glow--2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-partner-levels-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-partner-levels-head",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "eyebrow",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "Partner levels"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: "Three ways to partner, one platform."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                "data-lp-reveal": true,
                                "data-lp-delay": "100",
                                children: "Start with a listing, layer on qualified leads, or go deep with a live data connection \u2014 you choose the depth."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-partner-levels-grid",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-partner-level",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lvl",
                                        children: "Level 1"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Get listed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Your AppStore card goes live and surfaces to companies exactly when their flagged need matches your service."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-partner-level",
                                "data-lp-reveal": true,
                                "data-lp-delay": "80",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lvl",
                                        children: "Level 2"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Get qualified leads"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Everything in Level 1, plus a fact-finding checklist completed before you're introduced \u2014 so you know their stage and urgency upfront."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-partner-level lp-partner-level--wide",
                                "data-lp-reveal": true,
                                "data-lp-delay": "160",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "copy",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "lvl",
                                                children: "Level 3"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: "Full data integration"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Connect directly to Diligentsia's structured, verified company data. Your product auto-enriches in real time \u2014 no manual lookups, no stale records."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                style: {
                                                    marginTop: '10px',
                                                    fontSize: '12px',
                                                    fontStyle: 'italic'
                                                },
                                                children: "=We do not share company's data without company's permission. The company connects with partner and authorizes access to its data."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "lp-partner-nodes",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                width: "260",
                                                height: "260",
                                                viewBox: "0 0 260 260",
                                                className: "lp-partner-node-svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("marker", {
                                                            id: "partnerArrow",
                                                            viewBox: "0 0 10 10",
                                                            refX: "9",
                                                            refY: "5",
                                                            markerWidth: "6",
                                                            markerHeight: "6",
                                                            orient: "auto-start-reverse",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M0,0 L10,5 L0,10 Z",
                                                                fill: "rgba(74,103,255,0.75)"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6f9afdaedd531752$var$Line, {
                                                        x2: "130",
                                                        y2: "48"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6f9afdaedd531752$var$Line, {
                                                        x2: "212",
                                                        y2: "130"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6f9afdaedd531752$var$Line, {
                                                        x2: "130",
                                                        y2: "212"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6f9afdaedd531752$var$Line, {
                                                        x2: "48",
                                                        y2: "130"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "hub",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6f9afdaedd531752$var$IcDatabase, {})
                                            }),
                                            $6f9afdaedd531752$var$NODES.map((n)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `node ${n.cls}`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: n.img,
                                                        alt: n.alt
                                                    })
                                                }, n.cls))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $6f9afdaedd531752$export$2e2bcd8739ae039 = $6f9afdaedd531752$var$PartnerLevelsSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $bb5ec2bb391aedd4$var$STEPS = [
    {
        n: '1',
        t: 'Book a 20-minute call',
        d: 'Mark will confirm your fit for the AppStore and discuss your target audience on the platform.'
    },
    {
        n: '2',
        t: 'We build your listing',
        d: 'We create your AppStore card and partner page. You review and approve. No tech work required on your end.'
    },
    {
        n: '3',
        t: 'Go live and receive introductions',
        d: 'Your listing goes live in the AppStore. Contextual recommendations start surfacing your solution to relevant users immediately.'
    }
];
const $bb5ec2bb391aedd4$var$PartnerStepsSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-partner-steps",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-partner-steps-head",
                "data-lp-reveal": true,
                children: "How can I be a partner?"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-partner-steps-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-partner-steps-line",
                        "aria-hidden": "true"
                    }),
                    $bb5ec2bb391aedd4$var$STEPS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-partner-step",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 120,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "num",
                                    children: s.n
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: s.t
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: s.d
                                })
                            ]
                        }, i))
                ]
            })
        ]
    });
var $bb5ec2bb391aedd4$export$2e2bcd8739ae039 = $bb5ec2bb391aedd4$var$PartnerStepsSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");












const $ca176da786a53105$var$LOGOS = [
    {
        name: 'ABF',
        logo: (parcelRequire("l1ZKX"))
    },
    {
        name: 'BR',
        logo: (parcelRequire("2zIdh"))
    },
    {
        name: 'Cyber DueDil',
        logo: (parcelRequire("2SrE0"))
    },
    {
        name: 'Fin-house',
        logo: (parcelRequire("kvime"))
    },
    {
        name: 'Fractionality',
        logo: (parcelRequire("4BY23"))
    },
    {
        name: 'Freshbat',
        logo: (parcelRequire("5Nwjp"))
    },
    {
        name: 'GenFinance',
        logo: (parcelRequire("5OzpP"))
    },
    {
        name: 'Green Ripple',
        logo: (parcelRequire("72Xlx"))
    },
    {
        name: 'Intelect',
        logo: (parcelRequire("6XEUD"))
    },
    {
        name: 'Kiss the fish',
        logo: (parcelRequire("bOKxS"))
    },
    {
        name: 'Nume',
        logo: (parcelRequire("8B5WB"))
    },
    {
        name: 'SU2SU',
        logo: (parcelRequire("jJRlq"))
    }
];
const $ca176da786a53105$var$PartnerLogosSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-partner-logos-sec",
        style: {
            marginBottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-partner-logos-title",
                children: "Current AppStore Partners"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-partner-logos-strip",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-partner-logos-track",
                    children: [
                        ...$ca176da786a53105$var$LOGOS,
                        ...$ca176da786a53105$var$LOGOS
                    ].map((p, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-partner-logo-chip",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: p.logo,
                                alt: p.name
                            })
                        }, i))
                })
            })
        ]
    });
var $ca176da786a53105$export$2e2bcd8739ae039 = $ca176da786a53105$var$PartnerLogosSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $44af0669b1c283ac$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $44af0669b1c283ac$var$PartnerCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "cta",
        className: "lp-partner-cta",
        style: {
            marginBottom: '0'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-partner-cta-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    "data-lp-reveal": true,
                    children: "Ready to reach high-intent SMEs?"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "A 20-minute call gets you listed."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-partner-cta-btns",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        className: "lp-partner-cta-btn lp-partner-cta-btn--solid",
                        href: $44af0669b1c283ac$var$KOALENDAR,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Book a call"
                    })
                })
            ]
        })
    });
var $44af0669b1c283ac$export$2e2bcd8739ae039 = $44af0669b1c283ac$var$PartnerCtaSection;



const $9dfadbc8fab0c0d9$var$LandingHomePartner = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a44d10b55cf00889$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d78d2cf6eb5990c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d057f6cd1b0172e1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f9afdaedd531752$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb5ec2bb391aedd4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ca176da786a53105$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44af0669b1c283ac$export$2e2bcd8739ae039), {})
        ]
    });
};
var $9dfadbc8fab0c0d9$export$2e2bcd8739ae039 = $9dfadbc8fab0c0d9$var$LandingHomePartner;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Decorative network graphic: scattered "device" nodes wired to a central trio of people.
const $3c873aed8a5fb4c2$var$HeroNetwork = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 480 420",
        fill: "none",
        style: {
            width: '100%',
            height: '100%'
        },
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                opacity: "0.55",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        stroke: "#D7DCEC",
                        strokeWidth: "1.4",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "30",
                                y1: "40",
                                x2: "90",
                                y2: "40"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "90",
                                y1: "40",
                                x2: "90",
                                y2: "95"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "150",
                                y1: "40",
                                x2: "150",
                                y2: "90"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "30",
                                y1: "100",
                                x2: "90",
                                y2: "100"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "380",
                                y1: "50",
                                x2: "440",
                                y2: "50"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "380",
                                y1: "50",
                                x2: "380",
                                y2: "100"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "30",
                                y1: "330",
                                x2: "90",
                                y2: "330"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "30",
                                y1: "330",
                                x2: "30",
                                y2: "280"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "410",
                                y1: "330",
                                x2: "450",
                                y2: "330"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                x1: "410",
                                y1: "330",
                                x2: "410",
                                y2: "280"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        fill: "#E4E8F5",
                        stroke: "#C9CFE6",
                        strokeWidth: "1.2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "24",
                                y: "18",
                                width: "32",
                                height: "26",
                                rx: "6"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "34",
                                cy: "30",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "46",
                                cy: "30",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "130",
                                y: "18",
                                width: "32",
                                height: "26",
                                rx: "6"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "140",
                                cy: "30",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "152",
                                cy: "30",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "364",
                                y: "28",
                                width: "32",
                                height: "26",
                                rx: "6"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "374",
                                cy: "40",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "386",
                                cy: "40",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "14",
                                y: "308",
                                width: "32",
                                height: "26",
                                rx: "6"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "24",
                                cy: "320",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "36",
                                cy: "320",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "398",
                                y: "308",
                                width: "32",
                                height: "26",
                                rx: "6"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "408",
                                cy: "320",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "420",
                                cy: "320",
                                r: "2.6",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                x: "80",
                                y: "78",
                                width: "26",
                                height: "22",
                                rx: "5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "88",
                                cy: "88",
                                r: "2.2",
                                fill: "#AEB6D4"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "98",
                                cy: "88",
                                r: "2.2",
                                fill: "#AEB6D4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                stroke: "#FC7785",
                strokeWidth: "1.6",
                strokeDasharray: "3 5",
                opacity: "0.55",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "90",
                        y1: "95",
                        x2: "200",
                        y2: "190"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "150",
                        y1: "90",
                        x2: "220",
                        y2: "180"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "380",
                        y1: "100",
                        x2: "270",
                        y2: "190"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "30",
                        y1: "280",
                        x2: "190",
                        y2: "230"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                        x1: "410",
                        y1: "280",
                        x2: "290",
                        y2: "230"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "240",
                        cy: "210",
                        r: "92",
                        fill: "url(#lpCmHeroG1)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "195",
                        cy: "185",
                        r: "30",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "195",
                        cy: "175",
                        r: "12",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M170 210c6-16 20-22 25-22s19 6 25 22",
                        stroke: "#4A67FF",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "285",
                        cy: "185",
                        r: "30",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "285",
                        cy: "175",
                        r: "12",
                        fill: "#FC7785"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M260 210c6-16 20-22 25-22s19 6 25 22",
                        stroke: "#FC7785",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "240",
                        cy: "250",
                        r: "30",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        cx: "240",
                        cy: "240",
                        r: "12",
                        fill: "#2ED9A5"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M215 275c6-16 20-22 25-22s19 6 25 22",
                        stroke: "#2ED9A5",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        fill: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("radialGradient", {
                    id: "lpCmHeroG1",
                    cx: "0.4",
                    cy: "0.35",
                    r: "0.75",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                            offset: "0%",
                            stopColor: "#EDF0FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                            offset: "100%",
                            stopColor: "#DDE3FB"
                        })
                    ]
                })
            })
        ]
    });

const $3c873aed8a5fb4c2$var$CommunityHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-cm-hero",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cm-hero-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "lp-cm-eyebrow",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "dot"
                                }),
                                "Community"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "lp-cm-h1",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: [
                                "In an era of growing isolation, ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "lp-cm-h1",
                                    children: "deals still get done by people."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-cm-lead",
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Technology promised connection and gave us distance instead. Diligentsia is built the other way round: software does the grunt work, so the humans in your deal \u2014 founders, advisors and investors \u2014 can actually spend time and create value with each other."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-cm-hero-quote",
                            "data-lp-reveal": true,
                            "data-lp-delay": "180",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("lx758")),
                                    alt: "Maham Zupash"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-cm-hero-quote-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "\u201CIn the AI world of the future, software tools will be largely commoditised. The valuable businesses will be those with deep interconnected partner integrations and relationships\u201D"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Maham Zupash, Marketing Manager, Diligentsia"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cm-hero-art",
                    "data-lp-reveal": true,
                    "data-lp-delay": "140",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($3c873aed8a5fb4c2$var$HeroNetwork, {})
                })
            ]
        })
    });
var $3c873aed8a5fb4c2$export$2e2bcd8739ae039 = $3c873aed8a5fb4c2$var$CommunityHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $adba5527094817ba$var$MATCHES = [
    {
        code: 'IM',
        color: '#2ED9A5',
        title: 'InvestorMatch',
        body: 'Get in front of the right investors, introduced by people who know you both.'
    },
    {
        code: 'AM',
        color: '#F6C445',
        title: 'AdvisorMatch',
        body: "Find advisors who've actually sat where you're sitting."
    },
    {
        code: 'PM',
        color: '#4A67FF',
        title: 'PartnerMatch',
        body: 'Build the commercial relationships that make a deal, or a business, work.'
    }
];
// Floating labels over the photo. Percentages and translate values come straight from the design.
const $adba5527094817ba$var$PILLS = [
    {
        label: 'Investor',
        color: '#2ED9A5',
        style: {
            top: '20px',
            left: '3.7%',
            transform: 'translateX(-15%)'
        }
    },
    {
        label: 'Advisor',
        color: '#F6C445',
        style: {
            top: '20px',
            left: '92.7%',
            transform: 'translateX(-85%)'
        }
    },
    {
        label: 'Partner',
        color: '#4A67FF',
        style: {
            bottom: '20px',
            left: '41.2%',
            transform: 'translateX(-50%)'
        }
    },
    {
        label: 'Company',
        color: '#FC7785',
        style: {
            top: '20px',
            left: '64%',
            transform: 'translateX(-50%)'
        }
    }
];

const $adba5527094817ba$var$CommunityEcosystemSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-cm-eco",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cm-eco-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "lp-cm-eyebrow",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "dot"
                                }),
                                "Our ecosystem"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-cm-h2",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "An interdependent ecosystem for companies, advisors and investors."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-cm-lead",
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Qualified dealflow and opportunities in and out, to and from likeminded people already on our platform."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-cm-match-list",
                            children: $adba5527094817ba$var$MATCHES.map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-cm-match",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": 180 + i * 80,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-cm-match-badge",
                                            style: {
                                                background: m.color
                                            },
                                            children: m.code
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: m.title
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: m.body
                                                })
                                            ]
                                        })
                                    ]
                                }, m.code))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cm-eco-photo",
                    "data-lp-reveal": true,
                    "data-lp-delay": "140",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("86geU")),
                            alt: "Founders, advisors and investors together"
                        }),
                        $adba5527094817ba$var$PILLS.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "lp-cm-eco-pill",
                                style: p.style,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "dot",
                                        style: {
                                            background: p.color
                                        }
                                    }),
                                    p.label
                                ]
                            }, p.label))
                    ]
                })
            ]
        })
    });
var $adba5527094817ba$export$2e2bcd8739ae039 = $adba5527094817ba$var$CommunityEcosystemSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $dcc89b56db9f2794$var$SU2SU = 'https://www.startup2standup.com';
const $dcc89b56db9f2794$var$TESTIMONIALS = [
    {
        img: 'avatar-mark-bernstein.png',
        alt: 'Mark Bernstein',
        quote: "I've seen at first hand how this community delivers mutual support and cross fertilisation. It works.",
        name: 'Mark Bernstein',
        role: 'CEO, Diligentsia'
    },
    {
        img: 'avatar-ollie-austen.png',
        alt: 'Ollie Austen',
        quote: 'It gives me great pleasure to see not only the mutual support founders provide each other, but the concrete value we deliver through introductions. Over 80% of our members have established business relationships with at least three other members.',
        name: 'Ollie Austen',
        role: 'Founder, SU2SU'
    },
    {
        img: 'avatar-chris-enoh.png',
        alt: 'Chris Enoh, Co-Founder, Enbros',
        quote: 'Ollie and his team have made introductions that transformed my business. I simply could not have reached those opportunities without the supportive help of SU2SU.',
        name: 'Co-Founder',
        role: 'Enbros'
    }
];



// require() must take a literal, so the avatars are resolved through a static map.
const $dcc89b56db9f2794$var$AVATARS = {
    'avatar-mark-bernstein.png': (parcelRequire("gFaBl")),
    'avatar-ollie-austen.png': (parcelRequire("d3OBY")),
    'avatar-chris-enoh.png': (parcelRequire("8HilG"))
};

const $dcc89b56db9f2794$var$CommunityPeopleSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-cm-people",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cm-people-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "lp-cm-eyebrow lp-cm-eyebrow--dark",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "dot"
                                }),
                                "Our active community"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-cm-h2 lp-cm-h2--dark",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Business is still about people."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-cm-lead lp-cm-lead--dark",
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "That's why we're active partner of Startup 2 Standup, one of the UK's leading founder communities \u2014 because a platform is only as strong as the relationships behind it."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-cm-su2su",
                            "aria-label": "Startup 2 Standup community",
                            "data-lp-reveal": true,
                            "data-lp-delay": "180",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("9gLdu")),
                                alt: "Startup 2 Standup community"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "lp-cm-su2su-btn",
                            href: $dcc89b56db9f2794$var$SU2SU,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "data-lp-reveal": true,
                            "data-lp-delay": "220",
                            children: "Find out more"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cm-testi-list",
                    children: $dcc89b56db9f2794$var$TESTIMONIALS.map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-cm-testi",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 90,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: $dcc89b56db9f2794$var$AVATARS[t.img],
                                    alt: t.alt
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-cm-testi-mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: t.quote
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-cm-testi-name",
                                            children: t.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-cm-testi-role",
                                            children: t.role
                                        })
                                    ]
                                })
                            ]
                        }, t.name + i))
                })
            ]
        })
    });
var $dcc89b56db9f2794$export$2e2bcd8739ae039 = $dcc89b56db9f2794$var$CommunityPeopleSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $bfca74255c1b3ec3$var$STATS = [
    {
        num: '2,000+',
        label: 'Founders, investors & advisors'
    },
    {
        num: '80%+',
        label: 'Members with 3+ live relationships'
    },
    {
        num: '3',
        label: "Ways to connect \u2014 Investor, Advisor, Partner, Company"
    },
    {
        num: '1',
        label: 'Community that shows up in person'
    }
];

const $bfca74255c1b3ec3$var$CommunityStatsSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-cm-stats",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cm-stats-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cm-stats-head",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "lp-cm-stats-logo",
                            src: (parcelRequire("hDsbO")),
                            alt: "Startup 2 Standup"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-cm-stats-note",
                            children: "The numbers below reflect our partner community, Startup 2 Standup."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cm-stats-grid",
                    children: $bfca74255c1b3ec3$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: s.num
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: s.label
                                })
                            ]
                        }, s.num + i))
                })
            ]
        })
    });
var $bfca74255c1b3ec3$export$2e2bcd8739ae039 = $bfca74255c1b3ec3$var$CommunityStatsSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $0b22e400ffdafebe$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $0b22e400ffdafebe$var$CommunityCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-cm-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-cm-cta-inner",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-cm-cta-card",
                "data-lp-reveal": true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Technology gets you transaction-ready. People get you a deal."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Come and join the community behind the platform."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: $0b22e400ffdafebe$var$KOALENDAR,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Book a call with the team"
                    })
                ]
            })
        })
    });
var $0b22e400ffdafebe$export$2e2bcd8739ae039 = $0b22e400ffdafebe$var$CommunityCtaSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $aeeb2f9179e7bb42$var$SPEAKERS = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
            children: "Introduction:"
        }),
        " Paul Morris, Ex-Head of Growth Advisory, BDO \xb7 ",
        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
            children: "Main speaker:"
        }),
        " Neil Foster, Global Co-Chair of Technology Sector, Brown Rudnick LLP \u2014 Neil advises on around 100 VC deals a year."
    ]
});
const $aeeb2f9179e7bb42$var$EVENTS = [
    {
        day: '03',
        month: 'Sep',
        title: 'StartuptoStandup Founders Walk',
        body: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Join us for a walk around Serpentine Lake, Hyde Park. No agendas, no pitching \u2014 just founders walking, talking and connecting. Meet Ollie at the Lodge Cafe by the Hyde Park corner at 1pm. ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "https://luma.com/5ezics6h",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "Register here"
                }),
                "."
            ]
        }),
        meta: "Hyde Park, London \xb7 In person \xb7 1:00pm"
    },
    {
        day: '11',
        month: 'Sep',
        title: 'Webinar: The Top 10 Most Predictable Transaction Mistakes',
        to: $16250bd714b02a14$export$1473cb2f5aa9c69d,
        body: "A look at the recurring, avoidable mistakes that trip up deals \u2014 and how to spot them before they cost you.",
        speakers: $aeeb2f9179e7bb42$var$SPEAKERS,
        meta: "Online \xb7 Webinar \xb7 12:00pm"
    },
    {
        day: '16',
        month: 'Oct',
        title: "Webinar: Series A Termsheet \u2014 What VCs Really Want",
        body: "An honest look at term sheets from the investor side of the table, so you know what's negotiable and what isn't.",
        speakers: $aeeb2f9179e7bb42$var$SPEAKERS,
        meta: "Online \xb7 Webinar \xb7 12:00pm"
    },
    {
        day: '20',
        month: 'Nov',
        title: 'Webinar: Founder Mentors? The Good, the Bad and the Ugly',
        body: "What makes a mentor relationship actually work \u2014 and the warning signs to walk away from one that won't.",
        speakers: $aeeb2f9179e7bb42$var$SPEAKERS,
        meta: "Online \xb7 Webinar \xb7 12:00pm"
    }
];

const $aeeb2f9179e7bb42$var$CommunityEventsSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "lp-cm-events-hero",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cm-events-hero-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "lp-cm-eyebrow",
                                    "data-lp-reveal": true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "dot"
                                        }),
                                        "Events"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "lp-cm-events-h1",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "60",
                                    children: "Where the community meets, in person."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "lp-cm-lead",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "120",
                                    children: "Roundtables, demo nights and founder dinners \u2014 the same people from the ecosystem, just in the same room."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "lp-cm-events-art",
                            src: (parcelRequire("j42QG")),
                            alt: "Community event",
                            "data-lp-reveal": true,
                            "data-lp-delay": "160"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "lp-cm-events-list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cm-events-list-inner",
                    children: $aeeb2f9179e7bb42$var$EVENTS.map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-cm-event",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-cm-event-date",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "d",
                                            children: e.day
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "m",
                                            children: e.month
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: e.to ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: e.to,
                                                children: e.title
                                            }) : e.title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: e.body
                                        }),
                                        e.speakers && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "lp-cm-event-speakers",
                                            children: e.speakers
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "lp-cm-event-meta",
                                            children: e.to ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: e.to,
                                                children: e.meta
                                            }) : e.meta
                                        })
                                    ]
                                })
                            ]
                        }, e.title))
                })
            })
        ]
    });
var $aeeb2f9179e7bb42$export$2e2bcd8739ae039 = $aeeb2f9179e7bb42$var$CommunityEventsSection;



const $cfb095ef15aab9fd$var$TABS = [
    {
        id: 'community',
        label: 'Community'
    },
    {
        id: 'events',
        label: 'Events'
    }
];
const $cfb095ef15aab9fd$var$LandingHomeCommunity = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    const [tab, setTab] = (0, $acw62.useState)('community');
    // Reason: keyed on the active tab so useReveal re-runs and observes the newly mounted sections —
    // without it, switching tabs leaves the incoming content stuck at opacity 0.
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef, tab);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-cm-tabbar",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cm-tabbar-inner",
                    children: $cfb095ef15aab9fd$var$TABS.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            className: `lp-cm-tab${tab === t.id ? ' is-active' : ''}`,
                            onClick: ()=>setTab(t.id),
                            children: t.label
                        }, t.id))
                })
            }),
            tab === 'community' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c873aed8a5fb4c2$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adba5527094817ba$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcc89b56db9f2794$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfca74255c1b3ec3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b22e400ffdafebe$export$2e2bcd8739ae039), {})
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aeeb2f9179e7bb42$export$2e2bcd8739ae039), {})
        ]
    });
};
var $cfb095ef15aab9fd$export$2e2bcd8739ae039 = $cfb095ef15aab9fd$var$LandingHomeCommunity;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $bf5ab08cad327637$var$TC_MENU = [
    {
        title: 'Company Terms',
        indentifier: 'company-terms',
        link: $16250bd714b02a14$export$f43de61a26b1e3d1
    },
    // { title: 'Individuals Terms', indentifier: 'individual-terms', link: ROUTES.TERMS_CONDITION_INDIVIDUALS_TERMS },
    {
        title: 'Acceptable Use',
        indentifier: 'acceptable-use',
        link: $16250bd714b02a14$export$8b41d37ee61ee20f
    }
];
const $bf5ab08cad327637$var$POLICIES_MENU = [
    {
        title: 'Cookie Policy',
        indentifier: 'cookie-policy',
        link: $16250bd714b02a14$export$79ffb24037556cb1
    },
    {
        title: 'DMCA Policy',
        indentifier: 'dmca-Policy',
        link: $16250bd714b02a14$export$21297016b65d8d06
    },
    {
        title: 'Privacy Policy',
        indentifier: 'privacy-policy',
        link: $16250bd714b02a14$export$e1ec66dfdd97ff54
    },
    {
        title: 'Data Privacy & Ethics Policy',
        indentifier: 'data-ethics',
        link: $16250bd714b02a14$export$721554a0ca024204
    },
    {
        title: 'AI Use Policy',
        indentifier: 'all-use',
        link: $16250bd714b02a14$export$7cbd13c49e6bb251
    }
];

const $bf5ab08cad327637$var$CustomTab = ({ type: type, activeIdentifier: activeIdentifier, title: title, width: width })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [barMenus, setBarMenu] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (type === "terms-and-conditions") setBarMenu($bf5ab08cad327637$var$TC_MENU);
        else if (type === "policy") setBarMenu($bf5ab08cad327637$var$POLICIES_MENU);
    }, [
        type
    ]);
    // backgroundImage: `url(${require('../../../images/landingpage/terms-background.png')})`
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w100 df jcc",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `w60 df fdc jcc aic bscov brnr`,
            style: {
                gap: "90px",
                backgroundPosition: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    clasName: "pr",
                    src: (parcelRequire("2FyOx")),
                    style: {
                        width: '100%',
                        height: '300px',
                        objectFit: 'contain'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "dib fw500 fs2-125rem c15 tac mb1rem pa pageTitle",
                    style: {
                        lineHeight: '62.2px',
                        top: '180px'
                    },
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `pa br br35px df jcsa aic zi1 p0-5rem customTabs`,
                    style: {
                        top: '320px',
                        backgroundColor: 'rgba(103, 117, 185, 0.584)',
                        backdropFilter: 'blur(5px)',
                        width: width
                    },
                    children: barMenus.map((obj, index, arr)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            onClick: ()=>navigate(obj?.link),
                            className: `cp c1 ${activeIdentifier === obj?.indentifier ? "fs1-25rem-screen4 fw700 fs1rem-screen1" : 'fs1-125rem-screen4 fw400 fs1rem-screen1'}`,
                            style: {
                                lineHeight: "33px"
                            },
                            children: obj?.title
                        }, obj?.title))
                })
            ]
        })
    });
};
var $bf5ab08cad327637$export$2e2bcd8739ae039 = $bf5ab08cad327637$var$CustomTab;


const $e4804c4a670f053d$var$AllUse = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style privacy-policy-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "policy",
                        activeIdentifier: "all-use",
                        title: 'Policies',
                        width: "60%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw400 tal c14 fs1rem policy-box container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                children: "AI Use Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw400 tal c14 fs1rem",
                                children: "Effective: 1st January 2024"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem py1rem",
                                children: "Introduction"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: 'At Diligentsia Limited ("we," "us," or "our"), we are committed to delivering high-quality services to our corporate customers, mainly SMEs, their professional advisors, and investors ("Customers"). We utilize generative AI technologies, including those from OpenAI, Google Bard, Microsoft Bing, and others, to assist in the creation of bespoke reports and deliver valuable insights to our Customers. We take your privacy and data security seriously, and this AI Use Policy outlines our responsible approach to using AI technologies.'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Data Usage and Protection"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "includes information provided by our Customers and may include text, documents, and other relevant data. Data Security: We employ robust security measures to protect your data from unauthorized access, disclosure, or alteration. We use encryption, access controls, and industry best practices to safeguard your information. Data Usage: We use the data provided by our Customers exclusively for the purpose of generating bespoke reports and delivering our services. We do not sell, market, or otherwise use your data for any purpose other than fulfilling our obligations to you. Anonymization and Aggregation: We may aggregate and anonymize data to improve our AI models, conduct research, and enhance our services. This aggregated and anonymized data cannot be traced back to individual Customers."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Responsible AI Usage"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "AI Algorithms: We use AI algorithms to assist in the generation of reports, ensuring accuracy and efficiency. These algorithms are designed to provide valuable insights while maintaining a responsible and ethical approach. Transparency: We strive to be transparent about our AI usage. If you have any questions about how AI is used in our services, please feel free to contact us."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Customer Rights"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "Access and Control: Customers have the right to access, correct, or delete their data. If you have concerns or requests regarding your data, please contact us, and we will promptly address them. Opt-Out: If you no longer wish to use our services, you have the right to opt-out and have your data removed from our systems."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Compliance with Applicable Laws"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We are committed to complying with all applicable data protection and privacy laws, including but not limited to the General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA)."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "df aic",
                                children: [
                                    "If you have any questions, concerns, or requests related to our AI Use Policy or the use of AI in our services, please contact us at: ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "db p0-5rem td250 c4-hover",
                                        href: "mailto: support@diligentsia.co.uk",
                                        children: "support@diligentsia.co.uk"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem  pb1rem",
                                children: "Changes to the AI Use Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We may update this AI Use Policy from time to time to reflect changes in our business practices or legal requirements. The most current version will be posted on our website, and we will notify Customers of any significant changes."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "By using our services, you agree to this AI Use Policy and our Terms and Conditions."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem  pb1rem",
                                children: "Effective Date"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "This AI Use Policy is effective as of 1st January 2024."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e4804c4a670f053d$export$2e2bcd8739ae039 = $e4804c4a670f053d$var$AllUse;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $adcd4d700abdf82f$var$CookiePolicy = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style privacy-policy-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "policy",
                        activeIdentifier: "cookie-policy",
                        title: 'Policies',
                        width: "60%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw400 tal c14 fs1rem policy-box container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                children: "Cookie Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw400 tal c14 fs1rem",
                                children: "Effective: June 30th 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Use of cookies and similar technologies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Diligentsia uses cookies and similar technologies, such as pixels, to provide, improve, protect, and promote our services. For the purposes of this policy we will refer to all of these technologies as \u201Ccookies.\u201D This page includes information on the what, who, and how of these technologies in connection with the Diligentsia website and services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "What are cookies?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: 'A cookie is small data file sent to your browser when you visit a website. A pixel tag ("pixel") is a small piece of code belonging to a third-party that can be embedded on websites and in emails. We use both our own cookies as well as third-party cookies. See the \u201CHow does Diligentsia use cookies\u201D section below for further information on third-party cookies we use.'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "We also use local storage, including HTML5 local storage and browser cache. Local storage allows us to store information locally on your browser or device to improve your experience, such as to remember your settings for whether you prefer to view your folders in a list or as thumbnails.\xa0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "How does Diligentsia use cookies?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Diligentsia uses different categories of cookies to provide, protect, improve, and promote our website and services. Diligentsia only retains personal data for as long as is needed for the purposes for which it was collected. Information on these categories and their purposes are described below."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Strictly necessary cookies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "These are cookies that are essential in order to operate the website and services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Category"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Purpose"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Data elements"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Expiration"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Third parties"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Strictly necessary"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Cookies that are used to operate the website and services, such as to log you in and keep your account secure."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Categories of data collected for these purposes include authentication data, unique ID, browser information, and language settings."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "These cookies are set to expire after times ranging from 30 days to 4 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Third party providers used include Google."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Non-essential cookies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "These are all other cookies that are not considered strictly necessary but are used for a number of purposes when you interact with our website and services. These purposes include"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Category"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Purpose"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Data elements"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Expiration"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Third parties"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Analytics"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Cookies that help us and our partners understand how our websites are engaged with, such as usage statistics, in order to improve and customize our services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Categories of data collected for these purposes include website usage data, number of visits, browser and/or device information, and unique ID."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 2 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Third party providers used include Google, Salesforce, Coveo, and Tealium."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "General marketing and advertising"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Cookies that are used by Diligentsia and our partners to better understand the types of individuals who are interested in our products and services and how we can promote those services based on that information."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Categories of data collected for these purposes include cross website tracking data, browser information, version data, and advertisement conversion data."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 2 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Third party providers used include Adobe, Marketo, Yahoo, and Google."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Performance and functionality"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Cookies which help us remember your preferences and settings in order to improve your experience when interacting with our sites and services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Categories of data collected for these purposes include website usage data, previous help center or chat history, email address, and unique ID."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 3 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Third party providers used include SnapEngage."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Social media advertising"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Cookies that are used by Diligentsia and our partners to understand the effectiveness of our advertisements on social media services. These cookies also help them understand your advertising preferences so they can more effectively show you our advertisements which are relevant to your interests."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Categories of data collected for these purposes include social media account details, browser and/or device data, advertisement conversion data, website usage and/or activity data, and unique ID."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 2 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Third party providers used include Facebook, Twitter, and LinkedIn."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "How can I control the data collected through cookies?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Browser settings"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "You can set your browser to not accept cookies, but this may limit your ability to use our services. Due to a lack of an agreed upon standard for interpreting Do Not Track (DNT) signals, our systems currently don\u2019t respond to DNT:1 signals from browsers visiting our websites."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Cookie preferences"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "When you use Diligentsia\u2019s services, you can select which cookies you consent for Diligentsia to use in by clicking\xa0Cookies & CCPA Preferences\xa0in the footer of this page under\xa0Support."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Self-Regulatory"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: 'Diligentsia adheres to the Digital Advertising Alliance\u2019s Self-Regulatory Principles for Online Behavioral Advertising ("Principles"). You can opt out of collection of information by third-parties that adhere to the Principles, and that we use to help us promote our services, by visiting\xa0www.aboutads.info/choices.'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "Diligentsia also adheres to the European Interactive Digital Advertising Alliance\u2019s self-regulatory program for data-driven advertising. You can opt out of collection of information used for online behavior advertising by third-parties that adhere to the program by visiting\xa0http://www.youronlinechoices.eu/."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj pt1rem pb1rem",
                                children: "For more information on how to control and access your personal data, please see our Privacy Policy. If you\u2019d like to reach out to Diligentsia regarding the use of data collected from cookies, contact our Data Protection Officer at\xa0privacy@Diligentsia.co.uk ."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $adcd4d700abdf82f$export$2e2bcd8739ae039 = $adcd4d700abdf82f$var$CookiePolicy;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $ac1fa5dee7f1aa41$var$DataEthics = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style privacy-policy-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "policy",
                        activeIdentifier: "data-ethics",
                        title: 'Policies',
                        width: "60%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw400 tal c14 fs1rem policy-box container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                children: "Data Privacy and Ethics Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw400 tal c14 fs1rem",
                                children: "Effective: 30th June, 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Scope and Acceptance of Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "This Data Privacy and Ethics Policy ('Policy') applies to the use of your data by Diligentsia Limited ('Company', 'we', 'us', 'our') in relation to the use of an artificial intelligence tool, Chat GPT, developed by OpenAI. Your acceptance of this Policy, along with our Terms and Conditions, is indicated by your continued use of our services and/or by expressly clicking to accept where that option is presented to you."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Data Usage"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "We use your data for the sole purpose of enhancing the quality of reports we generate for you through the application of AI technology. Your data may be used to create comprehensive reports via Chat GPT, but will not be used for any other purpose unless we obtain your explicit permission.\u200B"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Data Protection"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "Your data is important and private to you, and we respect that. We ensure that your data is not shared with third parties, except with Chat GPT as outlined in this policy. We do not disseminate or transfer ownership of your data. Any reports we generate using your data and AI are digitally watermarked to ensure their authenticity and traceability."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Data Retention"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "We will not retain your data for longer than is necessary for our services or as required by law. The data you supply to us that is processed through Chat GPT is not stored or reused by the AI system."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Non-disclosure of Files"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "The contents of any data files you provide to us will not be shared with AI systems. We will not disclose the contents of these files outside our organisation unless we have obtained your prior express permission."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Your Rights"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: " \u200BYou have the right to access, rectify, delete or restrict the use of your personal data. You can exercise these rights at any time by contacting us using the contact details provided in our Terms and Conditions."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Changes to the Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "We reserve the right to update this Policy at any time to reflect changes in our practices, service offerings, or the latest laws and regulations. Any changes will be posted on this page, and we recommend that you check this page regularly to stay informed."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pb1rem",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "If you have any questions or require further information about our data handling practices, please don't hesitate to contact our Data Privacy Officer at dpo@diligentsia.co.uk. We're committed to working with you to obtain a fair resolution of any privacy concerns.\""
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ac1fa5dee7f1aa41$export$2e2bcd8739ae039 = $ac1fa5dee7f1aa41$var$DataEthics;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $5f46017e55c99f31$var$Privacy = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style privacy-policy-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "policy",
                        activeIdentifier: "privacy-policy",
                        title: 'Policies',
                        width: "60%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw400 tal c14 fs1rem policy-box container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                children: "Privacy Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw400 tal c14 fs1rem",
                                children: "Effective: 30th June, 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem",
                                children: "At Diligentsia Limited, we are committed to protecting the privacy and security of our clients' personal data. This Data Privacy Policy outlines how we collect, use, store, and protect your information when you use our platform. By using our services, you agree to the practices described in this policy."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Information We Collect"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We only collect personal data that is necessary for us to provide our services effectively. This may include: "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Contact information (name, email address, phone number). "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Account information (username, password). "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Transaction information related to your use of our platform. "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "How We Use Your Information"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We use the information we collect to: "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Provide, operate, and maintain our platform and services. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Communicate with you, including responding to inquiries and providing customer support. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Improve and personalize your experience on our platform. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Ensure compliance with legal and regulatory requirements. "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Data Security "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "Consistent with our size of business, we implement robust security measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction. These measures include encryption, access controls, and regular security assessments. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Data Sharing and Disclosure "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We do not share your personal data with third parties unless it is necessary to provide our services, comply with the law, or protect our rights. Where data sharing is necessary, we ensure that third parties adhere to strict data protection standards. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Data Retention "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected or as required by law. Once the data is no longer needed, it will be securely deleted or anonymized."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Your Rights "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "You have the right to access, correct, or delete your personal data that we hold. You may also object to or restrict certain types of data processing. To exercise these rights, please contact us using the information provided below. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Changes to This Policy "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We may update this Data Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any significant changes and post the updated policy on our website. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Contact Us "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "If you have any questions or concerns about this Data Privacy Policy or our data practices, please contact us at: "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Email: privacy@diligentsia.co.uk "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Address: Diligentsia Limited, The Old Rectory, Nock Verges, Stoney Stanton, Leicestershire LE9 4DA, UK "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "This Data Privacy Policy is designed to give you confidence in how we handle your personal data. Your privacy is important to us, and we are committed to maintaining your trust. "
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5f46017e55c99f31$export$2e2bcd8739ae039 = $5f46017e55c99f31$var$Privacy;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $d4ffab1c8e4b00da$var$DMCA = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style privacy-policy-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "policy",
                        activeIdentifier: "dmca-Policy",
                        title: 'Policies',
                        width: "60%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw400 tal c14 fs1rem policy-box container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                children: "DCMA Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw400 tal c14 fs1rem",
                                children: "Effective: June 30th 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "py1rem",
                                children: "Diligentsia Limited (\u201CDiligentsia\u201D) respects the intellectual property rights of others and expects its users to do the same. In accordance with the Digital Millennium Copyright Act of 1998, the text of which may be found on the U.S. Copyright Office website at\xa0https://www.copyright.gov/legislation/dmca.pdf, Diligentsia will respond expeditiously to claims of copyright infringement committed using the Diligentsia platform and/or the Diligentsia website (the \u201CSite\u201D) if such claims are reported to Diligentsia\u2019s Designated Copyright Agent identified in the sample notice below."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "If you are a copyright owner, authorized to act on behalf of one, or authorized to act under any exclusive right under copyright, please report alleged copyright infringements taking place on or through the Site by completing the following DMCA Notice of Alleged Infringement and delivering it to Diligentsia\u2019s designated Data Privacy Officer at privacy@diligentsia.co.uk . Upon receipt of Notice as described below, Diligentsia will take whatever action, in its sole discretion, it deems appropriate, including removal of the challenged content from the Site."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "DMCA Notice of Alleged Infringement (\u201CNotice\u201D)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Identify the copyrighted work that you claim has been infringed, or - if multiple copyrighted works are covered by this Notice - you may provide a representative list of the copyrighted works that you claim have been infringed."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Identify the material or link you claim is infringing (or the subject of infringing activity) and to which access is to be disabled, including at a minimum, if applicable, the URL of the link shown on the Site or the exact location where such material may be found."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Provide your company affiliation (if applicable), mailing address, telephone number, and, if available, email address."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Include both of the following statements in the body of the Notice"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "\u201CI hereby state that I have a good faith belief that the disputed use of the copyrighted material is not authorised by the copyright owner, its agent or the law (e.g. as a fair use)\u201D."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "\u201CI hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner, or authorized to act on behalf of, the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.\u201D"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Provide your full legal name and your electronic or physical signature."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1-5rem",
                                children: "Deliver this Notice, with all items completed, to Diligentsia\u2019s designated Data Privacy Officer at privacy@diligentsia.co.uk "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb0-5rem",
                                children: "Data Privacy Officer"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    fontStyle: 'italic'
                                },
                                children: "Diligentsia Limited"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    fontStyle: 'italic'
                                },
                                children: "The Old Rectory Nock Verges, Stoney Stanton,"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                style: {
                                    fontStyle: 'italic'
                                },
                                children: "Leicestershire, LE9 4LR, UK"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d4ffab1c8e4b00da$export$2e2bcd8739ae039 = $d4ffab1c8e4b00da$var$DMCA;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $48b84a93907f65b5$var$AcceptableUse = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: " poppins-font-style privacy-policy-page terms-and-conditions-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "terms-and-conditions",
                        className: "terms-and-conditions-tab",
                        activeIdentifier: "acceptable-use",
                        title: 'Terms & Conditions',
                        width: "41%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "policy-box container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "fw400 tal c14 fs1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                    children: "Acceptable Use"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "taj pb1rem",
                                    children: "Effective: June 30th 2022"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "taj pb1rem",
                                    children: "Diligentsia is proud of the trust placed in us. In exchange, we trust you to use our services responsibly."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "taj pb1rem",
                                    children: 'You agree not to misuse the Diligentsia services ("Services") or help anyone else to do so. For example, you must not even try to do any of the following in connection with the Services'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                    className: "pb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "probe, scan, or test the vulnerability of any system or network, "
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "breach or otherwise circumvent any security or authentication measures;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "access, tamper with, or use non-public areas or parts of the Services, or shared areas of the Services you haven't been invited to;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "interfere with or disrupt any user, host, or network, for example by sending a virus, overloading, flooding, spamming, or mail-bombing any part of the Services;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: 'access, search, or create accounts for the Services by any means other than our publicly supported interfaces (for example, "scraping" or creating accounts in bulk);'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "send unsolicited communications, promotions or advertisements, or spam;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: 'send altered, deceptive or false source-identifying information, including "spoofing" or "phishing";'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "promote or advertise products or services other than your own without appropriate authorization;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "abuse referrals or promotions to get more storage space than deserved or to sell storage space received from referrals or promotions;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "circumvent storage space limits;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "sell the Services unless specifically authorized to do so;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "publish, share, or store materials that constitute child sexually exploitative material (including material which may not be illegal child sexual abuse material but which nonetheless sexually exploits or promotes the sexual exploitation of minors), unlawful pornography, or are otherwise indecent;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "publish, share, or store content that contains or promotes extreme acts of violence or terrorist activity, including terror propaganda;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "advocate bigotry or hatred against any person or group of people based on their race, religion, ethnicity, sex, gender identity, sexual orientation, disability, or impairment;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "harass or abuse Diligentsia personnel or representatives or agents performing services on behalf of Diligentsia;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "violate the law in any way, including storing, publishing or sharing material that\u2019s fraudulent, defamatory, or misleading, or that violates the intellectual property rights of others;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "violate the privacy or infringe the rights of others;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "taj",
                                            children: "use the Services to back up, or as infrastructure for, your own cloud services;"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                                            className: "pt1rem ",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj",
                                                children: "use the storage space provided by the Services as the basis for cryptographic proof-of-space or proof-of-storage, or any similar proof system."
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "taj pb1rem",
                                    children: "We reserve the right to take appropriate action in response to violations of this policy, which could include removing or disabling access to content, suspending a user\u2019s access to the Services, or terminating an account."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $48b84a93907f65b5$export$2e2bcd8739ae039 = $48b84a93907f65b5$var$AcceptableUse;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $8d9b1817c81587b8$var$CompanyTerms = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style privacy-policy-page terms-and-conditions-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "terms-and-conditions",
                        className: "terms-and-conditions-tab ttc",
                        activeIdentifier: "company-terms",
                        title: 'Terms & Conditions',
                        width: "41%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "policy-box container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                children: "Company Terms"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw400 tal c14 fs1rem",
                                children: "Effective: Jan 2025 v1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                type: "A",
                                className: "fw500 tal c14 fs1-25rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "GENERAL TERMS"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Definitions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Interpretation"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "About Us (Legal Entity, Registration, Contact)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Platform Overview and Purpose"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Acceptance of Terms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Modifications to Terms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Eligibility and Access"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "SERVICES DESCRIPTION"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Service Features and Capabilities"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Beta Features and Experimental Tools"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Platform Availability and Uptime"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Support and Maintenance"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "USER ACCOUNTS & ACCESS"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "User Registration and Account Creation"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Access Credentials and Security"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Authorised Users and Team Management"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Responsibilities of the Account Holder"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DATA OWNERSHIP & USE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Ownership of Client Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Upload and Synchronisation"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Hosting, Processing, and Analytics"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Sharing With Trusted Third Parties"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Use of Anonymised and Aggregated Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "No Sale of Personal or Corporate Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Portability and Download"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "LEGAL & REGULATORY COMPLIANCE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Compliance with UK Law and FSMA"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Regulatory Disclaimers (e.g. FCA, FSMA Position)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Use by Regulated Advisors and Investors"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Audit Trails and Reporting Obligations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "SUBSCRIPTIONS & BILLING"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Service Plans and Pricing"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Billing Cycles and Payment Methods"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Free and Promotional Accounts"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Cancellations, Downgrades, and Refunds"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Suspension for Non-Payment"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "PLATFORM RULES & POLICIES"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Acceptable Use Policy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Intellectual Property Rights"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Third Party Services and Integrations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Confidentiality Obligations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Feedback and Suggestions"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DISCLAIMERS & RISK ALLOCATION"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "General Disclaimers and Warranty Exclusions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Disclaimer of Legal, Investment, or Tax Advice"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Automated Decision Making and Algorithmic Limitations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "No Endorsement or Certification of Users"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Limitations of Liability"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Indemnity and Hold Harmless"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DATA PRIVACY & SECURITY"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "GDPR Compliance"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Security Measures and 2FA"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Retention and Deletion Policies"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Breach Notification"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Residency and Hosting Jurisdiction"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "TERMINATION & CLOSURE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Termination by You"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Termination by Us"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Effects of Termination"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Retention After Termination"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DISPUTES & GOVERNANCE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Governing Law"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Jurisdiction"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Dispute Resolution Process"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Force Majeure"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "FINAL CLAUSES"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Entire Agreement"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Waiver and Severability"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Assignment and Subcontracting"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Notices"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Contact Information"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                type: "A",
                                className: "fw500 tal c14 fs1-25rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "GENERAL TERMS"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Definitions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "\u201CDiligentsia\u201D, \u201Cwe\u201D, \u201Cus\u201D, \u201Cour\u201D \u2013 Diligentsia Limited, a company registered in England and Wales under company number 14256673, with registered office at The Old Rectory, Nock Verges, Stoney Stanton, LE9 4LR, United Kingdom. \u201CPlatform\u201D or \u201CServices\u201D \u2013 The software, websites, modules, and functionality (including but not limited to the Diligentsia dashboard, InvestorMatch module, AnyList Checklist Builder, Business Audit tools, and related AI-driven features) provided by Diligentsia Limited. \u201CUser\u201D, \u201Cyou\u201D, \u201Cyour\u201D \u2013 Any individual or organisation (including companies, advisors, or investors) who accesses or uses the Platform, including any authorised user under an enterprise account. \u201CContent\u201D or \u201CYour Content\u201D \u2013 Any data, documentation, information, or responses submitted, uploaded, synchronised, or otherwise provided by the user or its agents into the Platform. \u201CFSMA\u201D \u2013 The Financial Services and Markets Act 2000 (UK), including the Regulated Activities Order (RAO). \u201CInvestorMatch\u201D \u2013 A feature of the Platform that algorithmically matches companies with investors based on self-declared, factual data inputs and stated preferences."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Interpretation"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Headings are for convenience only and do not affect interpretation. References to statutory provisions include any amendments. Terms in the singular include the plural and vice versa."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "About Us (Legal Entity, Registration, Contact)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia Limited provides a modular AI-driven SaaS platform for professional services that supports companies, advisors, and investors through diligence, investment readiness, growth acceleration, and exit planning processes. We are not FCA-regulated and do not undertake any regulated investment activities under FSMA."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Platform Overview and Purpose"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "The Platform helps users to: \u2022 Upload and structure corporate documentation, \u2022 Complete diligence checklists and audit modules, \u2022 Benchmark performance and risk, \u2022 Connect themselves with professional advisors or potential investors, \u2022 Receive AI-generated insights, recommendations, and Fit Scores."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "The Platform is not a legal, investment, or financial advisor, and is intended to supplement, not replace, professional judgment. Use of the Platform does not guarantee investment, funding, compliance, or successful transactions."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Acceptance of Terms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "By accessing or using our Platform, you agree to be legally bound by these Terms, our Privacy Policy, and our Acceptable Use Policy. If you do not agree to these terms, do not use the Platform. If you are using the Platform on behalf of an organisation, you confirm that you are authorised to bind that organisation to these Terms."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Modifications to Terms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "We may update these Terms periodically for legal, operational, or regulatory reasons. Where changes materially affect your rights or obligations, we will notify you by email and through the Platform. Continued use after such notice constitutes acceptance of the revised Terms."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Eligibility and Access"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You must be at least 18 years old and legally capable of entering into binding contracts to use our Services. The Platform is primarily designed for UK use. If you access it from another jurisdiction, you are responsible for compliance with local laws."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "SERVICES DESCRIPTION"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Service Features and Capabilities"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia provides a modular SaaS platform that supports value creation and due diligence for early-stage and growth companies, their advisors, and their investors. Core features include: \u2022 A Data Repository to organise and sync critical documents, \u2022 Business Audit tools that evaluate internal readiness across 20+ sections, \u2022 The AnyList Checklist Builder, which auto-generates bespoke diligence checklists using AI, \u2022 An unaudited self Certification Engine (Bronze, Silver, Gold) based on completeness and risk scoring, \u2022 A Benchmarking Module for comparing performance across clients or portfolios, \u2022 The InvestorMatch Tool, which algorithmically matches companies with investors using factual, self-declared input data. Additional features may include investor lead reports, automated warranty disclosures, and partner modules via the Diligentsia AppStore."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Beta Features and Experimental Tools"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: 'We may offer certain tools or modules marked as "beta", "pilot", "preview", or "early access". These are released for testing and feedback purposes only, and: \u2022 May contain bugs or errors, \u2022 Are subject to modification or removal without notice, \u2022 Must not be disclosed externally without written permission from Diligentsia. Your use of beta features is voluntary and at your own risk.'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Platform Availability and Uptime"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: 'We may offer certain tools or modules marked as "beta", "pilot", "preview", or "early access". These are released for testing and feedback purposes only, and: \u2022 May contain bugs or errors, \u2022 Are subject to modification or removal without notice, \u2022 Must not be disclosed externally without written permission from Diligentsia. Your use of beta features is voluntary and at your own risk.'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Support and Maintenance"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Support is provided via: \u2022 Email: support@diligentsia.co.uk \u2022 Live chat (during UK business hours) \u2022 FAQs and knowledge base \u2022 We aim to respond to 95% support requests within 1\u20132 UK business days. Support is generally available Monday to Friday, 9am\u20135pm UK time (excluding public holidays). We may update or modify the Platform from time to time to improve performance, introduce new features, or address security issues."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "USER ACCOUNTS & ACCESS"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "User Registration and Account Creation"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "To access most features of the Platform, you must create a user account. When registering, you agree to: \u2022 Provide accurate, complete, and current information, \u2022 Maintain and update your profile details as necessary, \u2022 Register only one account per individual per organisation, unless otherwise authorised. Organisational accounts (e.g. company, advisor, investor) may include multiple authorised users with individual logins and permissions."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Access Credentials and Security"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You are responsible for safeguarding your login credentials, including the use of two-factor authentication (2FA) if enabled or required. You must: \u2022 Keep credentials confidential and not share them, \u2022 Notify us immediately if you suspect unauthorised access or misuse, \u2022 Ensure your team members also follow security best practices. We are not liable for any loss or damage arising from unauthorised access due to your failure to secure account credentials."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Authorised Users and Team Management"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Where your organisation uses an enterprise or portfolio account, you may: \u2022 Authorise team members or third-party advisors to access selected modules, \u2022 Set permissions for specific users or restrict access to sensitive areas, \u2022 View audit logs of actions taken within your workspace. It is your responsibility to manage user access appropriately. You are liable for all activity under your organisation\u2019s account, whether performed by authorised users or not."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Responsibilities of the Account Holder"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "As the account holder (or administrative user), you represent and warrant that: \u2022 You have the necessary authority to bind your organisation to these Terms, \u2022 All data provided is truthful and lawfully collected, \u2022 You will not use the Platform in violation of applicable laws or to infringe third-party rights, \u2022 You will ensure any users under your account comply with these Terms and associated policies. You must also ensure compliance with all confidentiality, data protection, and contractual obligations applicable to your business or industry. You are expected to provide accurate, lawful information when using the Platform. You agree to cooperate reasonably with Diligentsia to facilitate service delivery and avoid any misuse or disruption of the Platform."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DATA OWNERSHIP & USE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Ownership of Client Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "All content, documents, inputs, responses, and information that you or your authorised users submit, upload, or synchronise into the Platform (\u201CYour Data\u201D or \u201CYour Content\u201D) remains the exclusive property of your organisation. Nothing in these Terms transfers ownership of Your Content to Diligentsia or any third party."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Upload and Synchronisation"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "When using the Platform, you may upload documents manually or connect to third-party cloud storage providers (e.g. SharePoint, Google Drive) to enable synchronisation. In doing so, you authorise Diligentsia to: \u2022 Create and update mirrored folders within its secure databases, \u2022 Store, scan, tag, and analyse your files for the purpose of delivering Services, \u2022 Log metadata (e.g. file name, type, timestamps) for operational traceability. Your organisation remains responsible for the legality and integrity of all data imported or synced."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Hosting, Processing, and Analytics"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Your data will be hosted securely within the UK or EEA by Diligentsia\u2019s cloud infrastructure providers. We take reasonable steps to: \u2022 Maintain platform and data security, \u2022 Protect data integrity and confidentiality, \u2022 Conduct routine back-ups and security updates. We may apply automated analysis (including natural language processing and risk scoring) to Your Data to deliver platform features such as Fit Scores, recommendations, and benchmarking."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Sharing With Trusted Third Parties"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "By using the Platform, you authorise Diligentsia to share Your Data with: \u2022 Designated third-party advisors (e.g. your accountants, lawyers, or investors), \u2022 Sub-processors and infrastructure providers who enable our Services, \u2022 Third-party artificial intelligence (AI) platforms (e.g. OpenAI, Google Gemini, Microsoft Azure AI) where required to deliver specific platform functionality including external processing of Your Data. \u2022 AppStore partners where you expressly engage the use of their module. Subscription, whether or not paid, to a module will provide explicit consent to allow Diligentsia to share relevant data with that provider. Such data sharing may in turn include the export of your information to AI platforms and processors for the generation of customised reports, analyses, and recommendations in accordance with the functionality of the Services."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Use of Anonymised and Aggregated Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You grant Diligentsia \u2022 Anonymise and aggregate Your Data for internal analytics, benchmarking, and continuous improvement, \u2022 Use anonymised data to train and calibrate AI tools, \u2022 Generate and share benchmarking comparisons and dashboards, \u2022 Incorporate anonymised outputs into investor, advisor, and industry-wide reports. This use is strictly non-identifiable, and your organisation will not be named or recognisable in any such output without express consent."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "No Sale of Personal or Corporate Data"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "We do not sell, lease, or trade your personal data or business information to any third party. Our commercial model is based solely on subscription fees, paid modules, and AppStore features \u2014 not through user data monetisation."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Risk Assessment Grid (RAG) and AI Export Consent"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You expressly authorise Diligentsia to: \u2022 Generate a Risk Assessment Grid (RAG) or equivalent analytical framework unique to your organisation, \u2022 Export Your Data to external AI platforms (including but not limited to OpenAI, Google Gemini, Microsoft Azure) as part of that RAG generation process, \u2022 Incorporate the RAG into internal platform modules, reports, dashboards, or investor packs. This export and use of your data will be undertaken in accordance with Diligentsia\u2019s internal security protocols and for the sole purpose of delivering personalised risk insights, recommendations, and compliance outputs to you."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "LEGAL & REGULATORY COMPLIANCE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Compliance with UK Law and FSMA"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia Limited is a UK-registered business providing digital infrastructure and software tools to help companies prepare for investment, growth, and exit. We are not authorised or regulated by the Financial Conduct Authority (FCA) and do not undertake regulated investment activities under the Financial Services and Markets Act 2000 (FSMA) or associated regulations. Our platform operates fully within the FCA\u2019s unregulated perimeter, consistent with Perimeter Guidance (PERG) and supported by legal review."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "InvestorMatch Module \u2013 FSMA Terms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "The following terms apply specifically to the use of the InvestorMatch feature of the Diligentsia platform. These terms replace and override any conflicting general terms to the extent of their application."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                                type: "a",
                                                className: "fw400 fs1rem c14 tal",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "taj mb0-5rem",
                                                        children: "InvestorMatch: FSMA Positioning and Terms of Use"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "Platform Role and Regulatory Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "Diligentsia Limited provides the InvestorMatch module as an optional feature within its broader software platform, which supports early-stage and growth companies in preparing and presenting information for commercial, investment, and strategic readiness. InvestorMatch is designed to allow companies to identify potential investors based on factual, user-declared data, and for investors to express interest or decline contact based on alignment with their stated preferences. The platform facilitates this connection but does not participate in any subsequent communication, diligence, negotiation, or transaction. Diligentsia Limited is not authorised or regulated by the Financial Conduct Authority (FCA). We do not carry out any regulated activities as defined in the Financial Services and Markets Act 2000 (FSMA) and the Regulated Activities Order (RAO), including: \u2022 Giving investment advice (Article 53 RAO) \u2022 Arranging deals in investments (Article 25(1) RAO) \u2022 Making arrangements with a view to transactions (Article 25(2) RAO) \u2022 Operating an investment exchange or collective investment scheme"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "taj mb0-5rem",
                                                        children: "Matching Engine and Fit Score"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "InvestorMatch generates potential matches between companies and investors using an algorithm that compares company-submitted attributes (such as sector, stage, revenue, and funding sought) with investor-stated preferences. Matches are based solely on declared information submitted by users. Diligentsia has no editorial involvement, recommendation engine, or filtering function. The matching process is fully automated and neutral. The platform may display a \"Fit Score\" to indicate how closely a company's declared data aligns with an investor's preferences. This score: \u2022 Is calculated automatically; \u2022 Reflects alignment of declared fields only; \u2022 Does not indicate quality, suitability, or credibility; \u2022 Does not constitute advice, opinion, recommendation, or assurance. Diligentsia does not assess, validate, or express a view on the merit of any company or investment opportunity."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "taj mb0-5rem",
                                                        children: "Communication and Contact Mechanism"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "Companies may use the platform to submit a self-completed OneForm to matched investors. All submissions are: \u2022 Solely user-initiated; \u2022 Not subject to review, curation, or moderation; \u2022 Sent with standardised investor response templates (accept/reject); \u2022 Fully outside Diligentsia\u2019s oversight or influence. Diligentsia does not facilitate deal-making, discussions, or negotiations, nor do we track outcomes or monetise introductions or investment success."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "taj mb0-5rem",
                                                        children: "Revenue Model"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "Diligentsia operates on a flat subscription model only. We do not: \u2022 Take a percentage of fundraising, \u2022 Earn commission on deal success, \u2022 Operate on a contingent or brokered basis. This ensures complete neutrality in the matching process and compliance with the unregulated FCA perimeter."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Use by Regulated Advisors and Investors"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "If you are an FCA-regulated entity (such as a VC fund, PE house, angel network, lawyer, or accountant), your use of the Platform remains subject to your professional and regulatory obligations. The Platform is intended to support \u2014 not replace \u2014 your internal compliance procedures and review standards. You must ensure that any material shared via the Platform complies with your legal duties under FSMA, the FCA Handbook, and applicable codes of conduct."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Audit Trails and Reporting Obligations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia provides automated audit logs of: \u2022 File uploads and deletions, \u2022 Module completions, \u2022 User permissions, \u2022 Certification progression. These logs are accessible within your dashboard and may support internal governance, compliance reviews, or investor readiness workflows. However, these do not constitute legal or regulatory audit output and must not be relied upon in isolation."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "SUBSCRIPTIONS & BILLING"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Service Plans and Pricing"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia offers a range of service tiers and add-ons designed for companies, advisors, and investors, including: \u2022 Free Accounts with limited access, \u2022 Pro and Portfolio Pro Subscriptions with full platform functionality, \u2022 Expansion Packs such as Warranty Disclosures, Directors\u2019 Questionnaires, and Investor Lead Reports, \u2022 Enterprise arrangements available on request. Current pricing, plan details, and feature comparisons are listed on our website and may be updated periodically. All fees are exclusive of VAT unless otherwise stated."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Billing Cycles and Payment Terms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Most subscriptions are billed annually in advance, unless otherwise specified. By purchasing a subscription, you agree to: \u2022 Pay the applicable fees for the full term (usually 12 months), \u2022 Authorise us to charge your selected payment method upon renewal, \u2022 Be responsible for all charges incurred under your account. \u2022 Self-service downgrades are currently unavailable. Downgrades must be requested manually via email. We aim to offer automated plan management features in future as our support capacity expands. Invoices and payment confirmations are available via your dashboard or on request. Auto-Renewal Notice: Your subscription will automatically renew at the end of each billing cycle unless cancelled before the renewal date. You are responsible for managing renewal settings in advance of each term."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "No Refunds for Annual Subscriptions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "All annual subscription fees are non-refundable, including in cases of: \u2022 Early cancellation by the user, \u2022 Unused modules or services, \u2022 Change of internal circumstances or business direction. You may cancel renewal at any time before the next billing date, but no partial refunds or prorated credits will be issued for the remainder of the billing period."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Downgrades and Plan Changes"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "If you wish to downgrade your plan (e.g., from Portfolio Pro to a Free or Pro subscription), the following rules apply: \u2022 Downgrades are permitted only at the end of the current subscription term, \u2022 You must notify Diligentsia in writing at least 14 days before the renewal date, \u2022 Downgrade requests must be submitted via email to support@diligentsia.co.uk and will not take effect mid-term. We do not offer pro-rata refunds or credits for downgrades during an active billing cycle."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Account Suspension and Grace Period for Non-Payment"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "If we are unable to collect payment when due, we reserve the right to: \u2022 Suspend access to paid modules or features, \u2022 Limit your ability to export data or invite team members, \u2022 Revoke certifications or Fit Score visibility. We will provide reasonable notice and a 30-day grace period for you to remedy the non-payment before deactivating your account or deleting data."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "PLATFORM RULES & POLICIES"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Acceptable Use Policy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You agree to use the Platform lawfully, responsibly, and in accordance with all applicable regulations. You must not: \u2022 Upload or share content that is illegal, abusive, defamatory, misleading, or infringes third-party rights; \u2022 Use the Platform to send spam, phishing links, or unauthorised marketing; \u2022 Attempt to gain unauthorised access to systems or data not intended for you; \u2022 Reverse engineer, decompile, or tamper with any part of the software or its algorithms; \u2022 Circumvent usage limits, bypass paywalls, or misuse freemium tiers; \u2022 Use automated tools (e.g. bots or scrapers) to access or extract Platform content. Violations may result in suspension, legal action, or permanent termination of access."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Intellectual Property Rights"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "The Platform, including all software, features, designs, source code, branding, and proprietary algorithms, is owned or licensed by Diligentsia Limited. Unless expressly authorised, you must not: \u2022 Reproduce or republish any part of the Platform; \u2022 Create derivative works based on our proprietary tools; \u2022 Misuse our trademarks, service marks, or branding elements; \u2022 Frame, mirror, or embed any part of the Platform in another service. You retain ownership of Your Content, but you grant Diligentsia a non-exclusive, royalty-free, worldwide licence to host, process, analyse, and display your data strictly for the purposes of providing the Services and delivering outputs."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Third-Party Services and Integrations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Certain features may allow you to connect or synchronise your account with third-party services (e.g., SharePoint, Google Drive, CRM tools, external AI engines such as OpenAI and Gemini). By enabling these integrations, you: \u2022 Consent to the transfer of Your Data to those third-party platforms, \u2022 Acknowledge that those platforms operate under their own terms and privacy policies, \u2022 Accept that Diligentsia is not liable for issues arising from those external services. We do not endorse or warrant any third-party service and reserve the right to suspend integrations that cause platform instability or legal risk."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Confidentiality Obligations"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Both parties agree to treat all non-public business, technical, or financial information received in connection with the Services as confidential, including data provided via the Platform. Confidentiality obligations do not apply to information that: \u2022 Was already lawfully in the recipient\u2019s possession; \u2022 Is publicly available through no breach; \u2022 Is required to be disclosed by law or regulation. Users must not disclose internal risk reports, audit trails, or platform logic unless required for due diligence or with our written approval."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Feedback and Suggestions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You are welcome to submit comments, feature requests, or suggestions for improvement. By doing so, you agree that: \u2022 Such feedback becomes the property of Diligentsia, \u2022 We may use it to enhance the Platform without obligation or attribution, \u2022 No confidential or proprietary rights are retained in submitted ideas."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DISCLAIMERS & LIMITATIONS OF LIABILITY"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "General Disclaimers and Warranty Exclusions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: 'The Platform is provided on an "as is" and "as available" basis without warranties of any kind, express or implied. Diligentsia does not warrant that: \u2022 The Platform will be uninterrupted, error-free, or fully secure; \u2022 The outputs (including Fit Scores, checklists, recommendations, and RAG assessments) will be accurate, complete, or appropriate for your specific circumstances; \u2022 The Services are fit for any particular purpose, including investment readiness or regulatory compliance. To the fullest extent permitted by law, we exclude all implied warranties, including those of merchantability, fitness for a particular purpose, and non-infringement.'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Disclaimer of Legal, Investment, or Tax Advice"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia is not a legal, financial, or tax advisor. The Platform and its outputs do not constitute: \u2022 Legal advice or compliance certification, \u2022 Investment advice, promotion, endorsement, or suitability recommendation, \u2022 Tax planning, valuation, or fund-raising guidance. You must seek independent, qualified professional advice before making decisions based on any aspect of the Platform."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "General Use and Responsibility Disclaimer"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "This report has been generated using the Diligentsia platform and is provided for general information purposes only. The content is based entirely on information, responses, and documentation submitted by the company, and Diligentsia Limited does not verify, audit, or validate the accuracy, completeness, or reliability of any such input. All outputs, including assessments, scores, and matches, are derived from algorithmic logic applied to self-declared data and do not constitute investment advice, endorsement, recommendation, or assurance of quality or suitability. Diligentsia Limited is not authorised or regulated by the Financial Conduct Authority and does not carry out any regulated activities as defined in the Financial Services and Markets Act 2000. The company remains solely responsible for the substance and accuracy of all information provided, and any party using this report \u2014 including prospective investors \u2014 must undertake their own due diligence and seek independent professional advice before making decisions based on its contents. Diligentsia accepts no liability for any loss or consequence arising from reliance on this report or any of its outputs."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Disclaimer \u2013 Platform Processes and Algorithms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "The outputs contained in this report are generated through automated processes and algorithms provided by the Diligentsia platform. While these tools are designed to assist with structuring and presenting company information, Diligentsia Limited makes no representation or warranty as to the accuracy, completeness, or reliability of any outcome produced by such processes. The Platform does not conduct contextual analysis, independent verification, or human review of user inputs, and no algorithmic result should be relied upon as a definitive statement of fact. Diligentsia accepts no responsibility for any inaccuracies, omissions, or misclassifications that may arise as a result of the operation of its tools, and disclaims all liability for any decisions made or actions taken in reliance on the outputs."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "No Endorsement or Certification of Users"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia does not vet, validate, or endorse any user, company, advisor, or investor. Any use of the Platform\u2019s certification tiers (e.g., Bronze, Silver, Gold) reflects internal process completion and automated risk scoring based on self-declared inputs. These designations are informational only and should not be treated as validation, recommendation, or assurance of legal, commercial, or financial readiness."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Limitations of Liability"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "To the maximum extent permitted by law, Diligentsia shall not be liable for: \u2022 Loss of profits, revenue, data, or business opportunity; \u2022 Indirect, incidental, special, consequential, or punitive damages; \u2022 Losses arising from errors, omissions, or decisions based on Platform outputs. In any case, Diligentsia\u2019s total aggregate liability arising out of or related to these Terms shall not exceed the total amount paid by you to Diligentsia in the 12 months preceding the event giving rise to the claim."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Indemnity and Hold Harmless"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You agree to indemnify, defend, and hold harmless Diligentsia, its directors, officers, and affiliates from and against any claims, liabilities, damages, losses, and expenses (including legal fees) arising from: \u2022 Your breach of these Terms, \u2022 Your misuse of the Platform, \u2022 Your Content infringing the rights of any third party, \u2022 Any reliance by you or others on Platform outputs without independent verification."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DATA PRIVACY & SECURITY"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "GDPR Compliance"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia is fully committed to protecting the privacy and rights of users in accordance with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018. As a data processor, we process Your Data only on your organisation\u2019s instructions and for the purpose of delivering Platform functionality. You are the data controller for all user-generated content and remain responsible for obtaining appropriate consents and lawful bases. Our Privacy Policy, available on our website, provides full details of: \u2022 What data we collect and how it is used, \u2022 The legal bases for processing, \u2022 Your rights (access, correction, deletion, objection), \u2022 How to contact us or lodge a complaint with the ICO."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Security Measures and 2FA"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Where feasible, Diligentsia uses industry-standard measures to protect the confidentiality, integrity, and availability of user data, including: \u2022 Role-based access control (RBAC), \u2022 ISO 27001-certified hosting partners, \u2022 Two-factor authentication (2FA) options for enhanced account security, \u2022 Regular third-party security testing. We encourage all users to enable 2FA to protect access credentials. "
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Retention and Deletion Policies"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "We retain your data only as long as necessary to fulfil our contractual obligations and legal requirements. Upon termination or cancellation of your account: \u2022 Your data will be retained for 30 days unless you request immediate deletion, \u2022 After that period, data may be permanently deleted or anonymised, \u2022 You may request an export of your data before termination. Some metadata (e.g. audit logs, activity history) may be retained for compliance or security audit purposes. "
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Breach Notification"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "In the event of a confirmed personal data breach affecting your account, Diligentsia will: \u2022 Notify your designated account contact without undue delay (within 72 hours of discovery), \u2022 Provide details of the breach scope, nature, and known or potential impact, \u2022 Describe the corrective measures taken or planned. We will cooperate with you in fulfilling your own regulatory obligations where applicable, including ICO notifications and affected data subject communications. "
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Residency and Hosting Jurisdiction"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "All client data is stored within the UK or European Economic Area (EEA), unless otherwise agreed. Where data is processed by third-party AI engines (e.g., OpenAI, Google Gemini) under clauses previously defined, such processing may occur outside the UK/EEA. Diligentsia ensures appropriate contractual protections are in place, including: \u2022 Standard Contractual Clauses (SCCs), \u2022 Processor Agreements under Article 28 GDPR, \u2022 AI platform selection based on compliance compatibility."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "TERMINATION & CLOSURE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Termination by You"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You may terminate your subscription or close your account at any time by: \u2022 Cancelling through the Platform (where supported), or \u2022 Sending written notice to support@diligentsia.co.uk. For paid subscriptions, termination will take effect at the end of the current billing period. No refunds or credits will be issued for early termination of annual plans (see Section F). Prior to termination, you may export your data or request assistance with data migration. Once terminated, access to modules, certifications, and audit trails will be permanently disabled."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Termination by Us"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "We may suspend or terminate your access immediately if: \u2022 You breach these Terms or misuse the Platform, \u2022 You fail to pay fees when due, \u2022 Required by legal, regulatory, or security concerns, \u2022 You engage in fraudulent or harmful conduct. We will normally provide reasonable notice of suspension or termination, but reserve the right to act without notice where urgent."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Effects of Termination"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Upon termination for any reason: \u2022 Your licences to access the Platform will end, \u2022 We may delete or archive your data after 30 days, \u2022 Your certifications (e.g., Bronze/Silver/Gold) and Fit Scores may be revoked or hidden from investor/advisor views. You remain responsible for: \u2022 Settling all outstanding fees, \u2022 Retaining your own copies of reports and data exports prior to closure, \u2022 Any liabilities or breaches that occurred before termination."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Data Retention After Termination"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "We retain your account data for up to 30 days after termination for contingency and reactivation purposes. After that: \u2022 Data may be deleted or anonymised at our discretion, \u2022 Restoration is not guaranteed, \u2022 You may request written confirmation of deletion for compliance purposes. Diligentsia has no obligation to retain or provide access to data beyond this period unless otherwise required by law or a separate agreement."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "DISPUTES & GOVERNANCE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Governing Law"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "These Terms, and any contractual or non-contractual dispute arising from or relating to them, are governed by and construed in accordance with the laws of England and Wales, without regard to conflict of law principles."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Jurisdiction"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You agree that the courts of England and Wales shall have exclusive jurisdiction to hear and resolve any dispute or claim arising under these Terms or in connection with your use of the Platform. Diligentsia retains the right to seek injunctive or equitable relief in any jurisdiction if necessary to protect its rights."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Dispute Resolution Process"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Before commencing legal action, the parties agree to attempt to resolve any dispute through good faith negotiations. Either party may initiate a formal escalation by delivering a written notice of dispute outlining: \u2022 The nature of the complaint, \u2022 The outcome sought, \u2022 Relevant supporting details. If no resolution is achieved within 30 days of such notice, either party may proceed with legal remedies. This informal process does not prevent either party from seeking urgent legal relief (e.g., injunctions) where required."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Force Majeure"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Diligentsia shall not be held liable for any failure or delay in performance due to causes beyond its reasonable control, including but not limited to acts of God, war, terrorism, cyberattacks, natural disasters, power outages, supply chain failures, changes in law, or pandemics. If such an event continues for more than 60 days, either party may terminate the affected Services by written notice without further liability (except for previously accrued obligations)."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "pt1rem pb0-5rem",
                                        children: "FINAL CLAUSES"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "1",
                                        className: "fw400 fs1rem c14 tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Entire Agreement"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "These Terms, along with our Privacy Policy, Acceptable Use Policy, and any specific service or subscription agreement entered into separately, constitute the entire agreement between you and Diligentsia regarding the use of the Platform. They supersede any prior agreements, understandings, or communications (oral or written) relating to the Services."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Waiver and Severability"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "No failure or delay by Diligentsia in exercising any right or remedy shall constitute a waiver. If any provision of these Terms is held to be unenforceable or invalid by a court of competent jurisdiction, the remaining provisions shall remain in full force and effect."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Assignment and Subcontracting"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "You may not assign, transfer, or sublicense your rights or obligations under these Terms without prior written consent. Diligentsia may assign or subcontract any part of the Services to trusted third parties or affiliates, provided that this does not materially affect your rights under these Terms."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Notices"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "All legal notices must be sent to: Diligentsia Limited The Old Rectory Nock Verges, Stoney Stanton LE9 4LR, United Kingdom Email: support@diligentsia.co.uk"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Notices are deemed received: \u2022 Immediately if delivered by email (provided no bounce-back), \u2022 Within 2 business days if sent by recorded post."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "No Partnership or Agency"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Nothing in these Terms creates a partnership, agency, or joint venture between you and Diligentsia. You are solely responsible for your business decisions and interactions with third parties."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Third Party Rights"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "No third party shall have any rights to enforce any of the provisions of these Terms under the Contracts (Rights of Third Parties) Act 1999."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "taj mb0-5rem",
                                                children: "Language and Accessibility"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "These Terms are provided in English only. Translations may be made available in future, but the English version shall prevail in the event of any inconsistency or dispute."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8d9b1817c81587b8$export$2e2bcd8739ae039 = $8d9b1817c81587b8$var$CompanyTerms;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
function $2f0c77e93f5c0874$export$2e2bcd8739ae039({ heading: heading, subheading: subheading, paragraph: paragraph, list: list, wrapperClass: wrapperClass, listClass: listClass, id: id }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: id,
        className: wrapperClass + " df fdc jcc aic",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "w100 c15 fs1-75rem lh2 fw600",
                children: heading
            }),
            subheading !== "Portfolio Status" && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "w100 fs1-5rem lh2 c4 fw500",
                children: subheading
            }),
            paragraph && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mt0-5rem fs0-75rem c3 maw300px tac fsi",
                children: paragraph
            }),
            list && list.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: listClass + " mt0-5rem fs1rem ass df w100 aifs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            className: "f9 w2rem h2rem mr1rem mr0-lg ml1rem-lg",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 320 512",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "w100",
                            children: item
                        })
                    ]
                }, idx))
        ]
    });
}


const $1adba59ff1f5733d$var$IndividualsTerms = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style privacy-policy-page terms-and-conditions-page *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf5ab08cad327637$export$2e2bcd8739ae039), {
                        type: "terms-and-conditions",
                        className: "terms-and-conditions-tab ttc",
                        activeIdentifier: "individual-terms",
                        title: 'Terms & Conditions',
                        width: "41%"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "policy-box container",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "pt1rem pb2rem fs1-5rem fw500 tal c15",
                                style: {
                                    fLineHeight: "39.81px"
                                },
                                children: "Diligentsia Terms & Conditions of Service"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "fw400 tal c14 fs1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Effective: 30th June 2022"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pt1rem",
                                        children: "Thanks for using Diligentsia! Our mission is to create a more enlightened way of working by providing an intuitive, unified platform to keep your content safe and accessible while helping you and those you work with stay coordinated and in sync. These terms of service (\u2018Terms\u2019) cover your use and access to our services, client software and websites (\u2018Services\u2019). Your agreement is with Diligentsia Limited, a UK company number registered in England & Wales under registration number 14256673. Our\xa0Privacy Policy\xa0explains how we collect and use your information while our\xa0Acceptable Use Policy\xa0outlines your responsibilities when using our Services. By using our Services, you\u2019re agreeing to be bound by these Terms, our\xa0Privacy Policy\xa0and\xa0Acceptable Use Policy."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Your Stuff & Your Permissions"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "When you use our Services, your organisation provide us with things like your files, content, messages, contacts and so on (\u201CYour Stuff\u201D). Your Stuff belongs to your business. These Terms don\u2019t give us any rights to Your Stuff except for the limited rights that enable us to offer the Services.  "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We need your permission to do things like hosting Your Stuff, backing it up and sharing it when you ask us to. It includes our setting up a Diligentsia corporate folder and sub-folders within one or more of your organisation\u2019s third party cloud repositories, such as Sharepoint, Google Drive or Diligentsia.  You authorise us to upload Our Services to our Diligentsia databases and platform more generally.  We may also provide you with features like commenting, sharing, searching, image thumbnails, document previews, optical character recognition (OCR), easy sorting and organisation and personalisation to help reduce busywork. To provide these and other features, Diligentsia accesses, uploads, stores and scans Your Stuff within its own databases. You give us permission to do those things, and this permission extends to our affiliates and trusted third parties we work with.  In particular, unless you opt out, we are free to share your information with your accountants, lawyers, investors where you have been introduced by one or more of those organisations as their client or portfolio company.  Where you enter additional information directly into the Diligentsia folder within your cloud storage, you authorise us to synch that folder with its corresponding copy held within the Diligentsia databases in your organisation\u2019s name."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "You authorise us to undertake data analytics on the information your organisation uploads to, and synch\u2019s with, the Diligentsia folder.  We may utilise that information on an anonymised basis both to improve our and to provide additional services to you, either directly or through trusted third parties we work with, provided that you will authorise those third parties."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Your Responsibilities"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Your organisation\u2019s use of our Services must comply with our\xa0Acceptable Use Policy. Content in the Services may be protected by others\u2019 intellectual property rights. Please don\u2019t copy, upload, download or share content unless you have the right to do so."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Diligentsia may review your organisation\u2019s conduct and content for compliance with these Terms and our\xa0Acceptable Use Policy. We are not responsible for the content people post and share via the Services."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Help us keep Your Stuff protected. Safeguard your organisation\u2019s employees\u2019 passwords to the Services, and keep your organisation\u2019s account information current. Don\u2019t share your account credentials or give others access to your account."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "You may use our Services only as permitted by applicable law, including export control laws and regulations. Finally, to use our Services you must be aged over 18. If the law where you reside requires that you must be older in order for Diligentsia to lawfully provide the Services to you without parental consent (including use of your personal data), then you must be that older age."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Software"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Some of our Services and those provided by our partners allow you to download client software (\u201CSoftware\u201D) which may be updated automatically. As long as you comply with these Terms, we and they give you a limited, non-exclusive, non-transferable, revocable licence to use the Software, solely to access the Services. To the extent any component of the Software may be offered under an open source licence, we\u2019ll make that licence available to you and the provisions of that licence may expressly override some of these Terms. Unless the following restrictions are prohibited by law, you agree not to reverse engineer or decompile the Services, attempt to do so or assist anyone to do so."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Beta Services"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We sometimes release products and features that we\u2019re still testing and evaluating (\u2018Beta Services\u2019). Beta Services are labelled \u2018alpha\u2019, \u2018beta\u2019, \u2018preview\u2019, \u2018early access\u2019, \u2018evaluation\u2019 or \u201CMVP\u201D (or with words or phrases with similar meanings) and may not be as reliable as Diligentsia\u2019s other services. Beta Services are made available so that we can collect user feedback, and by using our Beta Services, you agree that we may contact you to collect such feedback."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Beta Services are confidential until official launch. If you use any Beta Services, you agree not to disclose any information about those Services to anyone else without our permission."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: " Additional Features"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "From time to time, Diligentsia will add additional features to enhance the user experience of our services at no additional charge. However, these free features may be withdrawn without further notice."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Our Stuff"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "The Services are protected by copyright, trademark, and other UK and foreign laws. These Terms don\u2019t grant you any right, title or interest in the Services, others\u2019 content in the Services, Diligentsia trademarks, logos and other brand features. We welcome feedback, but please note that we may use comments or suggestions without any obligation to you."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Copyright"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We respond to notices of alleged copyright infringement if they comply with the law, and such notices should be reported using our\xa0Copyright Policy. We reserve the right to delete or disable content alleged to be infringing and terminate accounts of repeat infringers. Our designated agent for notice of alleged copyright infringement on the Services is"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "The CEO"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        style: {
                                            fontStyle: "italic"
                                        },
                                        children: "Diligentsia Limited"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        style: {
                                            fontStyle: "italic"
                                        },
                                        children: "The Old Rectory"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        style: {
                                            fontStyle: "italic"
                                        },
                                        children: "Nock Verges, Stoney Stanton LE9 $LR UK"
                                    }),
                                    "copyright@Diligentsia.com",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Paid Accounts"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Billing.\xa0You can change plans and/or add paid features to your account (turning your account into a \u2018Paid Account\u2019). We\u2019ll automatically bill you from the date you convert to a Paid Account and on each periodic renewal until cancellation. If you\u2019re on an annual plan, we\u2019ll send you a notice email reminding you that your plan is about to renew within a reasonable period of time prior to the renewal date. You\u2019re responsible for all applicable taxes, and we\u2019ll charge tax when required to do so. Some countries have mandatory local laws regarding your cancellation rights, and this paragraph doesn\u2019t override these laws."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Cancellation.\xa0You may cancel your\xa0account\xa0at any time. Refunds are only issued if required by law. For example, users living in the European Union have the right to cancel their Paid Account subscriptions within 14 days of signing up for, upgrading to or renewing a Paid Account by clicking\xa0here.  Upon your account being cancelled, Diligentsia has the right to suspend the provision of its Services with immediate effect.  This may mean that some or all of your Stuff may be unavailable within the Diligentsia platform or Diligentsia folder within your cloud platform.  You will be warned of this via an email prior to our taking such action. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Downgrades.\xa0Your Paid Account will remain in effect until cancelled or terminated under these Terms If you don\u2019t pay for your Paid Account on time, we reserve the right to suspend it or remove Paid Account features."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Changes.\xa0We may change the fees in effect on renewal of your subscription, to reflect factors such as changes to our product offerings, changes to our business or changes in economic conditions. We\u2019ll give you no less than 30 days\u2019 advance notice of these changes via a message to the email address associated with your account and you\u2019ll have the opportunity to cancel your subscription before the new fee comes into effect."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Diligentsia Business Teams"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Using Diligentsia Business Teams.\xa0If your organisation signs up to Diligentsia and uses our Services, you must use them in compliance with your organisation\u2019s terms and policies. Please note that Diligentsia accounts are subject to your organisation's control. Your administrators may be able to access, disclose, restrict or remove information in or from your Diligentsia account. They may also be able to restrict or terminate your access to a Diligentsia account. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Termination"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Your organisation is free to stop using our Services at any time. We reserve the right to suspend or terminate your access to the Services with notice to you if"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        className: "pb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Your organisation or any employee is in breach of these Terms,"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Your organisation\u2019s use of the Services would cause a real risk of harm or loss to us or other users, or"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Your organisation hasn't accessed our Services for 12 consecutive months."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Your organisation has ceased to pay for the relevant Services."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We\u2019ll provide you with reasonable advance notice via the email address associated with your account to remedy the activity that prompted us to contact you and give you the opportunity to export Your Stuff from our Services. If after such notice you fail to take the steps we ask of you, we\u2019ll terminate or suspend your access to the Services."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We won\u2019t provide notice or an opportunity to export Your Stuff before termination or suspension of access to the Services where"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        className: "pb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "you\u2019re in material breach of these Terms,"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "doing so would cause us legal liability or compromise our ability to provide the Services to our other users, or"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "we're prohibited from doing so by law."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Discontinuation of Services"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We may decide to discontinue the Services in response to exceptional unforeseen circumstances, events beyond Diligentsia\u2019s control (for example a natural disaster, fire or explosion) or to comply with a legal requirement. If we do so, we\u2019ll give you reasonable prior notice so that you can export Your Stuff from our systems (we will give you no less than 30 days\u2019 notice where possible under the circumstances). If we discontinue the Services in this way before the end of any fixed or minimum term you have paid us for, we\u2019ll refund the portion of the fees you have pre-paid but haven't received Services for."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Services \u201CAS IS\u201D"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We strive to provide great Services, but there are certain things that we can't guarantee. TO THE FULLEST EXTENT PERMITTED BY LAW, DILIGENTSIA AND ITS AFFILIATES, SUPPLIERS AND DISTRIBUTORS MAKE NO WARRANTIES, EITHER EXPRESS OR IMPLIED, ABOUT THE SERVICES. THE SERVICES ARE PROVIDED \u2018AS IS\u2019. WE ALSO DISCLAIM ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. Some places don\u2019t allow the disclaimers in this paragraph, so they may not apply to you. For example, these disclaimers do not override the legal protections, including statutory warranties granted to consumers by EU law."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Limitation of Liability"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "WE DON\u2019T EXCLUDE OR LIMIT OUR LIABILITY TO YOU WHERE IT WOULD BE ILLEGAL TO DO SO \u2013 THIS INCLUDES ANY LIABILITY FOR DILIGENTSIA\u2019S OR ITS AFFILIATES\u2019 FRAUD OR FRAUDULENT MISREPRESENTATION IN PROVIDING THE SERVICES. IN COUNTRIES WHERE THE FOLLOWING TYPES OF EXCLUSIONS AREN\u2019T ALLOWED, WE'RE RESPONSIBLE TO YOU ONLY FOR LOSSES AND DAMAGES THAT ARE A REASONABLY FORESEEABLE RESULT OF OUR FAILURE TO USE REASONABLE CARE AND SKILL OR OUR BREACH OF OUR CONTRACT WITH YOU. THIS PARAGRAPH DOESN\u2019T AFFECT CONSUMER RIGHTS THAT CAN'T BE WAIVED OR LIMITED BY ANY CONTRACT OR AGREEMENT. IF YOU ARE AN EU OR UK CONSUMER, THESE TERMS DO NOT EXCLUDE DILIGENTSIA\u2019S LIABILITY FOR LOSSES AND DAMAGES THAT ARE A RESULT OF OUR FAILURE TO USE REASONABLE CARE AND SKILL IN PROVIDING THE SERVICES OR OF OUR BREACH OF OUR CONTRACT WITH YOU, AS LONG AS THOSE LOSSES AND DAMAGES ARE REASONABLY FORESEEABLE."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "IN COUNTRIES WHERE EXCLUSIONS OR LIMITATIONS OF LIABILITY ARE ALLOWED, DILIGENTSIA, ITS AFFILIATES, SUPPLIERS OR DISTRIBUTORS WON\u2019T BE LIABLE FOR"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        className: "pb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY OR CONSEQUENTIAL DAMAGES, OR"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "ANY LOSS OF USE, DATA, BUSINESS OR PROFITS, REGARDLESS OF LEGAL THEORY."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "THESE EXCLUSIONS OR LIMITATIONS WILL APPLY REGARDLESS OF WHETHER OR NOT DILIGENTSIA OR ANY OF ITS AFFILIATES HAVE BEEN WARNED OF THE POSSIBILITY OF SUCH DAMAGES."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "IF YOU USE THE SERVICES FOR ANY COMMERCIAL, BUSINESS OR RE-SALE PURPOSE, DILIGENTSIA, ITS AFFILIATES, SUPPLIERS OR DISTRIBUTORS WILL HAVE NO LIABILITY TO YOU FOR ANY LOSS OF PROFIT, LOSS OF BUSINESS, BUSINESS INTERRUPTION OR LOSS OF BUSINESS OPPORTUNITY. DILIGENTSIA AND ITS AFFILIATES AREN\u2019T RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USERS OF THE SERVICES."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "OTHER THAN FOR THE TYPES OF LIABILITY WE CANNOT LIMIT BY LAW (AS DESCRIBED IN THIS SECTION), WE LIMIT OUR LIABILITY TO YOU TO THE GREATER OF \xa320 OR 100% OF ANY AMOUNT YOU'VE PAID UNDER YOUR CURRENT SERVICE PLAN WITH DILIGENTSIA. THIS PROVISION DOES NOT APPLY TO EU CONSUMERS WHERE PROHIBITED BY\xa0APPLICABLE LAW."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Resolving Disputes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Let\u2019s try to sort things out first.\xa0We want to address your concerns without needing a formal legal case. Before filing a claim against Diligentsia, you agree to try to resolve the dispute informally by sending us a written Notice of Dispute at dispute-notice@Diligentsia.co.uk that includes your name, a detailed description of the dispute and the relief you seek. We\u2019ll try to resolve the dispute informally by contacting you via email. If a dispute is not resolved within 60 days after submission, you or Diligentsia may bring a formal proceeding. If you reside in the EU, the European Commission provides for an online dispute resolution platform, which you can access here:\xa0https://ec.europa.eu/consumers/odr."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Judicial Forum for Disputes.\xa0You and Diligentsia agree that any judicial proceeding to resolve claims relating to these Terms or the Services will be brought in the UK courts of England and Wales, and will be subject to UK law, subject to the mandatory arbitration provisions below. Both your organsation and Diligentsia consent to venue and personal jurisdiction in such courts. If you reside in a country (for example, a member state of the European Union) with laws that give consumers the right to bring disputes in their local courts, this paragraph doesn\u2019t affect those requirements."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "IF YOUR ORGANISATION IS US RESIDENT, IT ALSO AGREES TO THE FOLLOWING MANDATORY ARBITRATION PROVISIONS"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We both agree to arbitrate.\xa0You and Diligentsia agree to resolve any claims relating to these Terms or the Services through final and binding individual arbitration by a single arbitrator, except as set forth under the \u2018Exceptions to Agreement to Arbitrate\u2019 below. This includes disputes arising out of or relating to the interpretation or application of this \u2018Mandatory Arbitration Provisions\u2019 section, including its scope, enforceability, revocability or validity. The arbitrator may award relief only individually and only to the extent necessary to redress your individual claim(s); the arbitrator may not award relief on behalf of others or the general public."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Opt out of Agreement to Arbitrate.\xa0You can decline this agreement to arbitrate by\xa0clicking here\xa0and submitting the opt-out form within 30 days of first registering your account or agreeing to these Terms. However, if you agreed to a previous version of these Terms that allowed you to opt out of arbitration, your previous choice to opt out or not opt out remains binding."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Arbitration Procedures.\xa0The American Arbitration Association (AAA) will administer the arbitration under its Consumer Arbitration Rules. The AAA\u2019s rules and filing instructions are available at\xa0www.adr.org\xa0or by calling 1-800-778-7879. The arbitration will be held in the United States county where you live or work, San Francisco (CA) or any other location we agree to."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Arbitration Fees and Incentives.\xa0The AAA rules will govern payment of all arbitration fees. For individual arbitration of non-frivolous claims less than US$75,000 for which you timely provided Diligentsia with a Notice of Dispute, Diligentsia will reimburse arbitration filing fees at the conclusion of the arbitration and will pay other arbitration fees. For all other claims, the costs and fees of arbitration shall be allocated in accordance with the arbitration provider\u2019s rules, including rules regarding frivolous or improper claims. If you receive an arbitration award that is more favourable than any offer we make to resolve the claim, we will pay you US$1,000 in addition to the award. Diligentsia will not seek its lawyers\u2019 fees and costs in arbitration unless the arbitrator determines that your claim is frivolous or brought for an improper purpose."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Exceptions to agreement to arbitrate. Either you or Diligentsia may assert claims, if they qualify, in a small claims court in San Francisco (CA) or any United States county where you live or work. Either party may bring a lawsuit solely for injunctive relief to stop unauthorised use or abuse of the Services, or intellectual property infringement (for example, trademark, trade secret, copyright or patent rights) without first engaging in arbitration or the informal dispute resolution process described above. If the agreement to arbitrate is found not to apply to you or your claim, you agree to the exclusive jurisdiction of the state and federal courts in San Francisco County, California, USA to resolve your claim."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "NO CLASS OR REPRESENTATIVE ACTIONS. You may only resolve disputes with us on an individual basis and may not bring a claim as a plaintiff or a class member in a class, consolidated or representative action. Class arbitrations, class actions, private lawyer general actions and consolidation with other arbitrations aren\u2019t allowed."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Severability. If any part of this \u2018Mandatory Arbitration Provisions\u2019 section is found to be illegal or unenforceable, the remainder will remain in effect, except that if a finding of partial illegality or unenforceability would allow class or representative arbitration, this \u2018Mandatory Arbitration Provisions\u2019 section will be unenforceable in its entirety. If you are found to have a non-waivable right to bring a particular claim or to request a particular form of relief that the arbitrator lacks authority to redress or award according to this \u2018Mandatory Arbitration Provisions\u2019 section, including public injunctive relief, then only that respective claim or request for relief may be brought in court, and you and we agree that litigation of any such claim or request for relief shall be stayed pending the resolution of any individual claim(s) or request(s) for relief in arbitration."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Controlling Law"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "These Terms will be governed by UK law. However, some countries (including those in the European Union) have laws that require agreements to be governed by the local laws of the consumer's country. This paragraph doesn\u2019t override those laws."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Entire Agreement"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "These Terms constitute the entire agreement between you and Diligentsia with respect to the subject matter of these Terms and supersede and replace any other prior or contemporaneous agreements or terms and conditions applicable to the subject matter of these Terms. Our past, present and future affiliates and agents can invoke our rights under this agreement in the event they become involved in a dispute with you. Otherwise, these Terms do not give rights to any third parties."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Waiver, Severability & Assignment"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "Diligentsia\u2019s failure to enforce a provision is not a waiver of its right to do so later. If a provision is found to be unenforceable, the remaining provisions of the Terms will remain in full effect and an enforceable term will be substituted reflecting our intent as closely as possible. You may not assign any of your rights under these Terms, and any such attempt will be void. Diligentsia may assign its rights to any of its affiliates or subsidiaries, or to any successor in the interest of any business associated with the Services."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 tal c14 fs1-5rem pb1rem pt1rem",
                                        children: "Modifications"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "We may revise these Terms from time to time to better reflect"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        className: "pb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "changes to the law,"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "new regulatory requirements, or"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "improvements or enhancements made to our Services."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "If an update affects your use of the Services or your legal rights as a user of our Services, we\u2019ll notify you prior to the update's effective date by sending an email to the email address associated with your organisation\u2019s account or via an in-product notification. These updated terms will be effective no less than 30 days from when we notify you."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "taj pb1rem",
                                        children: "If you do not agree to the updates we make, please cancel your account and stop using the Services before the updated Terms become effective. Where applicable, we\u2019ll offer you a pro-rata refund based on the amounts you have prepaid for Services and your account cancellation date. By continuing to use or access the Services after the updates come into effect, you agree to be bound by the revised Terms."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $1adba59ff1f5733d$export$2e2bcd8739ae039 = $1adba59ff1f5733d$var$IndividualsTerms;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $jTnBY = parcelRequire("jTnBY");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $beCSm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f3bdb1b636c81735$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $86603163591f910a$export$baa0faa0c7ad8085), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $8nd05.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (0, $8Uq77.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $1En50.default)(props, $f3bdb1b636c81735$var$_excluded);
    const [checked, setCheckedState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $8nd05.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3bdb1b636c81735$var$SwitchBaseRoot, (0, $8nd05.default)({
        component: "span",
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($f3bdb1b636c81735$var$SwitchBaseInput, (0, $8nd05.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $beCSm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $56ccc0421702a0be$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $jTnBY.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5f063e1b0f6d278b$export$39f6debbec19b3ba), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $kTdcz.lighten)(theme.palette[color].main, 0.62) : (0, $kTdcz.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $1En50.default)(props, $56ccc0421702a0be$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($56ccc0421702a0be$var$SwitchRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, (0, $8nd05.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $8nd05.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;







var $acw62 = parcelRequire("acw62");
function $b0700e714cfac258$export$12212e996914823f() {
    (0, $acw62.useEffect)(()=>{
        // Create a mutation observer to detect when the div is added
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.type === 'childList') {
                const didAgentRoot = document.querySelector('[data-testid="didagent_root"]');
                if (didAgentRoot && didAgentRoot.shadowRoot) {
                    // Add custom styles to the shadow DOM
                    const style = document.createElement('style');
                    style.textContent = `.didagent_target{height: 100%}
                        .didagent__fabio[data-position=right] {position: relative;z-index: 9;width: 424px;right:0;height: 700px;display: flex;align-items: center;}
                        .didagent__fabio .didagent__fabio__container[data-enabled=true]{height: 790px; top: 0 !important; width: 424px}
                        .didagent__fabio>button{height: 424px;}
                        @media(max-width:768px) {
                        .didagent__fabio[data-position=right] {width: 100%}
                        .didagent__fabio .didagent__fabio__container[data-enabled=true] {height: 700px; top: 30px !important; width: 100%; position: absolute;}
                        .didagent__background {scale: 100%}
                        }
                        `;
                    didAgentRoot.shadowRoot.appendChild(style);
                    observer.disconnect();
                }
            }
        });
        // Start observing the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return ()=>observer.disconnect();
    }, []);
}





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $2c7cf54903528136$var$COGS = [
    {
        key: 'investor',
        src: (parcelRequire("eWMdR")),
        alt: 'Investor',
        cls: 'investor',
        tooltip: 'Free application triaging in 3 minutes. Quaiffied, diligenced deal flow. AI Diligence tools.'
    },
    {
        key: 'company',
        src: (parcelRequire("ejUMZ")),
        alt: 'Company',
        cls: 'company',
        tooltip: 'Get transaction read. Create diligence pack. Funding? 1-click connect to 40 VCs'
    },
    {
        key: 'diligentsia',
        src: (parcelRequire("4lNiv")),
        alt: 'Diligentsia',
        cls: 'diligentsia',
        tooltip: 'Diligentsia'
    },
    {
        key: 'advisor',
        src: (parcelRequire("6SxPm")),
        alt: 'Advisor',
        cls: 'advisor',
        tooltip: 'Free tools to increase margins.  New services. New client introductions.'
    }
];
const $2c7cf54903528136$var$HomeCogGraphic = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-cog-graphic-wrap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-cog-graphic",
                children: $2c7cf54903528136$var$COGS.map((cog)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `lp-cog lp-cog--${cog.cls}`,
                        "data-tooltip": cog.tooltip,
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: cog.src,
                            alt: cog.alt
                        })
                    }, cog.key))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-cog-graphic__text",
                children: "Transaction readiness, Diligence, Investor & Advisor matching, Deal flow."
            })
        ]
    });
var $2c7cf54903528136$export$2e2bcd8739ae039 = $2c7cf54903528136$var$HomeCogGraphic;


const $2b9715f4dc907e04$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $2b9715f4dc907e04$var$HomeHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                style: {
                    maxWidth: '1300px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge lp-badge--up",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "AI-powered transaction readiness"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                style: {
                                    fontSize: 'clamp(40px, 6vw, 60px)',
                                    lineHeight: 1.08
                                },
                                children: [
                                    "The UK's leading low-cost platform for ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lp-accent",
                                        children: "automated SME transaction readiness and diligence"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                style: {
                                    fontSize: '19px'
                                },
                                children: "70% of SME investment/exit transactions historically not diligenced due to cost. Changing a process that used to take weeks and cost tens of thousands, into one which takes you days and costs from \xa3100 pa. Quicker deals. Less cost. Higher valuations. Saving you time and hassle."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "lp-btn lp-btn--primary",
                                        to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                        children: "Get started free"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--outline-blue",
                                        href: $2b9715f4dc907e04$var$KOALENDAR,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Book a call"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-hero-trust",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: "Trusted by 50+ investors, advisors, and growing companies \xb7 No credit card required"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-hero-art",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2c7cf54903528136$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
var $2b9715f4dc907e04$export$2e2bcd8739ae039 = $2b9715f4dc907e04$var$HomeHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



























const $9f3b76c12a708e2b$var$PARTNERS = [
    {
        name: 'SeedLegals',
        logo: (parcelRequire("d9qvr"))
    },
    {
        name: 'AI Forge',
        logo: (parcelRequire("1UKQy"))
    },
    {
        name: 'Acentis',
        logo: (parcelRequire("b0jPS"))
    },
    {
        name: 'Dignus Muneris',
        logo: (parcelRequire("cUzig"))
    },
    {
        name: 'EHE',
        logo: (parcelRequire("874BN"))
    },
    {
        name: 'Fractionality',
        logo: (parcelRequire("lt9td"))
    },
    {
        name: 'JPJ',
        logo: (parcelRequire("9yjEm"))
    },
    {
        name: 'SU2SU',
        logo: (parcelRequire("bw3Jr"))
    },
    {
        name: 'ACF Investors',
        logo: (parcelRequire("r7AxX"))
    },
    {
        name: 'AngelGroups',
        logo: (parcelRequire("cxe43"))
    },
    {
        name: 'British Business Bank',
        logo: (parcelRequire("9x0yD"))
    },
    {
        name: 'British Design Fund',
        logo: (parcelRequire("kgN6q"))
    },
    {
        name: 'Deepbridge',
        logo: (parcelRequire("bkJbN"))
    },
    {
        name: 'Foresight',
        logo: (parcelRequire("g4Quf"))
    },
    {
        name: 'Kero',
        logo: (parcelRequire("j8Ceg"))
    },
    {
        name: 'Key Capital',
        logo: (parcelRequire("8No4I"))
    },
    {
        name: 'Key Fund',
        logo: (parcelRequire("1kDTU"))
    },
    {
        name: 'Lifted',
        logo: (parcelRequire("2sCdN"))
    },
    {
        name: 'Mercia Fund',
        logo: (parcelRequire("8taOC"))
    },
    {
        name: 'Northern Gritstone',
        logo: (parcelRequire("2SEjH"))
    },
    {
        name: 'Northstar Ventures',
        logo: (parcelRequire("483jj"))
    },
    {
        name: 'Par Equity',
        logo: (parcelRequire("f8VOs"))
    },
    {
        name: 'Playfair',
        logo: (parcelRequire("eVMcj"))
    },
    {
        name: 'River Capital',
        logo: (parcelRequire("ko4JQ"))
    },
    {
        name: 'Science Angel',
        logo: (parcelRequire("kNkpn"))
    },
    {
        name: 'SolidBond',
        logo: (parcelRequire("gaJEH"))
    },
    {
        name: 'YFM Equity',
        logo: (parcelRequire("lxIRU"))
    }
];
const $9f3b76c12a708e2b$var$HomeLogoStrip = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-logos-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-logos-eyebrow",
                children: "Trusted by 50+"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-logos-title",
                children: "Our InvestorMatch Partners"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-logos-strip",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-logos-track",
                    children: [
                        ...$9f3b76c12a708e2b$var$PARTNERS,
                        ...$9f3b76c12a708e2b$var$PARTNERS
                    ].map((partner, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-logo-chip",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: partner.logo,
                                alt: partner.name
                            })
                        }, i))
                })
            })
        ]
    });
var $9f3b76c12a708e2b$export$2e2bcd8739ae039 = $9f3b76c12a708e2b$var$HomeLogoStrip;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Reason: every class is prefixed. The design's own names (.label, .figure, .cite, .stat-card) are
// exactly the kind that collide with the global utility stylesheets.
const $5c1ff867c550652f$var$STATS = [
    {
        tone: 'blue',
        label: "of VCs don't raise a second fund",
        figure: '>50%',
        cite: 'Pitchbook'
    },
    {
        tone: 'violet',
        label: 'of applications get no reply',
        figure: '70%',
        cite: 'Diligentsia'
    },
    {
        tone: 'coral',
        label: 'of startups get VC funding',
        figure: '0.05%',
        cite: 'CB Insights'
    },
    {
        tone: 'blue',
        label: "of VC-backed startups don't return money",
        figure: '75%',
        cite: 'Failory'
    },
    {
        tone: 'violet',
        label: 'of startups fail',
        figure: '90%',
        cite: 'Startup Genome'
    },
    {
        tone: 'coral',
        label: 'of UK exits suffer a price chip',
        figure: '60%',
        cite: 'Bizma'
    }
];
const $5c1ff867c550652f$var$HomeOddsSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-hstats",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-hstats-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-hstats-head",
                    "data-lp-reveal": true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "We all think we can outperform the market."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-hstats-grid",
                    children: $5c1ff867c550652f$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-hstat-card is-${s.tone}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 70,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-hstat-label",
                                    children: s.label
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-hstat-figure",
                                    children: s.figure
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-hstat-cite",
                                    children: s.cite
                                })
                            ]
                        }, s.cite + i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-hstats-foot",
                    "data-lp-reveal": true,
                    children: "Whoever you are, we give you the tools to beat these odds."
                })
            ]
        })
    });
var $5c1ff867c550652f$export$2e2bcd8739ae039 = $5c1ff867c550652f$var$HomeOddsSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


// One gradient card holding three stakeholder panels, a dashed "thread" joining them, and the
// shared payoff below. Classes are prefixed — the design uses .panel / .stage / .flow, which would
// collide with the global utility stylesheets.
const $b86ecd68481bf334$var$PANELS = [
    {
        num: '01',
        title: 'Companies',
        role: 'Get deal-ready',
        points: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Investment- or exit-ready in ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "days, not months"
                    }),
                    " \u2014 200 AI agents auto-fill up to 60% of your pack"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Self-certify ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Bronze, Silver or Gold"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Stay deal-ready for every follow-on round and exit"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Gold unlocks ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "InvestorMatch"
                    }),
                    " to 40+ investors"
                ]
            })
        ],
        foot: 'Free to start'
    },
    {
        num: '02',
        title: 'Advisors',
        role: 'Prove your value',
        points: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Free account \u2014 ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "no licence, no revenue share"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Every client starts at ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "60%, not zero"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Billable work surfaced automatically across your book"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Get discovered by companies and 40+ VCs via ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "AdvisorMatch"
                    })
                ]
            })
        ],
        foot: 'Free for advisors'
    },
    {
        num: '03',
        title: 'Investors & Purchasers',
        role: 'Get matched deals',
        points: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Free application triage in ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "3\u20134 minutes"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "FREE"
                    }),
                    " AI-driven deal management platform"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Automated diligence \u2014 corporate, legal, financial, tech \u2014 or connect your own tools"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Pre-qualified, pre-diligenced"
                    }),
                    " dealflow shared across 40+ investors"
                ]
            })
        ],
        foot: 'Free for investors'
    }
];
// Dashed rule with a marker centred under each panel.
const $b86ecd68481bf334$var$Thread = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-wwd-thread",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            viewBox: "0 0 1160 32",
            preserveAspectRatio: "none",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                    x1: "0",
                    y1: "16",
                    x2: "1160",
                    y2: "16",
                    stroke: "rgba(255,255,255,0.35)",
                    strokeWidth: "1.5",
                    strokeDasharray: "2 6",
                    strokeLinecap: "round"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "193",
                    cy: "16",
                    r: "4",
                    fill: "#F5A623"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "580",
                    cy: "16",
                    r: "4",
                    fill: "#F5A623"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "967",
                    cy: "16",
                    r: "4",
                    fill: "#F5A623"
                })
            ]
        })
    });
const $b86ecd68481bf334$var$HomeWhatWeDo = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-wwd",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-wwd-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-wwd-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "lp-wwd-eyebrow",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "dot"
                                }),
                                "What we do"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "One platform. Value for every side of the deal."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Companies get investment/exit ready, advisors add value more quickly, investors get inbound qualified dealflow."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-wwd-flow",
                    "data-lp-reveal": true,
                    "data-lp-delay": "160",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-wwd-panels",
                            children: $b86ecd68481bf334$var$PANELS.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-wwd-panel",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-wwd-stage",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "lp-wwd-stage-num",
                                                    children: p.num
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                            children: p.title
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "lp-wwd-role",
                                                            children: p.role
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            children: p.points.map((pt, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "lp-wwd-pdot"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: pt
                                                        })
                                                    ]
                                                }, i))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "lp-wwd-panel-foot",
                                            children: p.foot
                                        })
                                    ]
                                }, p.num))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($b86ecd68481bf334$var$Thread, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-wwd-payoff",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "lp-wwd-payoff-text",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "bolt",
                                            children: "\u26A1"
                                        }),
                                        "Our differentiator? A single integrated platform for all stakeholders over the company lifecycle \u2014 delivering quicker deals, less cost, expedited follow-on rounds, and ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "hl",
                                            children: "higher valuations"
                                        }),
                                        " for everyone."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    className: "lp-wwd-btn",
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    children: "Get started free"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $b86ecd68481bf334$export$2e2bcd8739ae039 = $b86ecd68481bf334$var$HomeWhatWeDo;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// "Built for every stage of your journey and every side of the deal" — who-it's-for section.
const $dd69a5dd57cd99e1$var$IconHome = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#4A67FF",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "9 22 9 12 15 12 15 22"
            })
        ]
    });
const $dd69a5dd57cd99e1$var$IconBriefcase = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#E8820C",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "7",
                width: "20",
                height: "14",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
            })
        ]
    });
const $dd69a5dd57cd99e1$var$IconTrend = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#1F8A5B",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "23 6 13.5 15.5 8.5 10.5 1 18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "17 6 23 6 23 12"
            })
        ]
    });
var $588bd574df73bce4$exports = {};
$588bd574df73bce4$exports = new URL("anthony.b26586ad.jpg", import.meta.url).toString();


var $d8f37bbabd2b7d0f$exports = {};
$d8f37bbabd2b7d0f$exports = new URL("mojee_wilson.8db5b3bd.jpg", import.meta.url).toString();


var $cdc8ac72dad0931d$exports = {};
$cdc8ac72dad0931d$exports = new URL("paul_morris.d45f7620.png", import.meta.url).toString();


var $8a8c7ec4d7857589$exports = {};
$8a8c7ec4d7857589$exports = new URL("foster_neil.15182d00.jpg", import.meta.url).toString();


var $69ad8b777d6c0abb$exports = {};
$69ad8b777d6c0abb$exports = new URL("kevin.c4a78c0a.jpg", import.meta.url).toString();


const $dd69a5dd57cd99e1$var$QuoteBar = ({ quote: quote, name: name, role: role, img: img, alt: alt })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-who-quotebar",
        "data-lp-reveal": true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-who-quotebar-c",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-who-mark",
                        children: "\u201C"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                        children: quote
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "w100 nm",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "w100 rl",
                        children: role
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-who-quotebar-img",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: img,
                    alt: alt
                })
            })
        ]
    });
const $dd69a5dd57cd99e1$var$PersonaRow = ({ reverse: reverse, Icon: Icon, iconClass: iconClass, title: title, desc: desc, img: img, alt: alt, quote: quote, name: name, role: role })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `lp-who-row ${reverse ? 'is-reverse' : ''}`,
        "data-lp-reveal": true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-who-copy",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `lp-who-ic ${iconClass}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-who-media",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-who-photo",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: img,
                            alt: alt
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-who-float",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-who-mark sm",
                                children: "\u201C"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                                children: quote
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "nm",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "rl",
                                children: role
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $dd69a5dd57cd99e1$var$HomeWhoItsFor = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-who",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-who-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-badge lp-badge--up lp-who-eyebrow",
                        "data-lp-reveal": true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                            "Hear from those who know"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        children: [
                            "Tools built for every stage of your journey and",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "every side of the deal"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-who-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($dd69a5dd57cd99e1$var$QuoteBar, {
                        quote: "The problem is, with VCs, you write to them, they never reply. So, what if there was somebody who would help you get connected with VCs? That's where Diligentsia comes in.",
                        name: "Anthony Rose",
                        role: "Founder, Seedlegals",
                        img: $588bd574df73bce4$exports,
                        alt: "Anthony Rose"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($dd69a5dd57cd99e1$var$PersonaRow, {
                        Icon: $dd69a5dd57cd99e1$var$IconHome,
                        iconClass: "lp-who-ic--blue",
                        title: "Companies.",
                        desc: "Get transaction ready. Create diligence pack. Funding? 1-click connect to 50+ VCs.",
                        img: $d8f37bbabd2b7d0f$exports,
                        alt: "Mojee Wilson",
                        quote: "It's brilliant, I could not recommend it enough! ...the platform works like a dream.",
                        name: "Mojee Wilson",
                        role: "Founder, Saat.WS"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($dd69a5dd57cd99e1$var$QuoteBar, {
                        quote: "In my experience, not being prepared and a lack of data integrity can lead to price chipping, but actually more often causes deals to fail. Anything you can do to reduce this is immensely valuable.",
                        name: "Paul Morris",
                        role: "Ex Head of Growth Advisory, BDO",
                        img: $cdc8ac72dad0931d$exports,
                        alt: "Paul Morris"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($dd69a5dd57cd99e1$var$PersonaRow, {
                        reverse: true,
                        Icon: $dd69a5dd57cd99e1$var$IconBriefcase,
                        iconClass: "lp-who-ic--amber",
                        title: "Advisors.",
                        desc: "Free tools to increase margins on existing services. New services. New client introductions.",
                        img: $8a8c7ec4d7857589$exports,
                        alt: "Neil Foster",
                        quote: "We do around 100 VC deals each year. Getting prepared for transactions is critical, but the traditional piecemeal approach is rarely effective. Systematic preparation will not only increase the chances of securing a term sheet, but also improve valuations.",
                        name: "Neil Foster",
                        role: "Global Co-Chair of Technology Sector, Brown Rudnick LLP"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($dd69a5dd57cd99e1$var$PersonaRow, {
                        Icon: $dd69a5dd57cd99e1$var$IconTrend,
                        iconClass: "lp-who-ic--green",
                        title: "Investors & Purchasers.",
                        desc: "Free application triaging in 3 minutes. Qualified, diligenced deal flow. AI Diligence tools.",
                        img: $69ad8b777d6c0abb$exports,
                        alt: "Kevin Jackson",
                        quote: "We want to monitor, add value and support our cohorts from first application to exit. Diligentsia helps us do this.",
                        name: "Kevin Jackson",
                        role: "Co-founder & Chairman, AI Forge"
                    })
                ]
            })
        ]
    });
var $dd69a5dd57cd99e1$export$2e2bcd8739ae039 = $dd69a5dd57cd99e1$var$HomeWhoItsFor;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $da5a36c4dfaa1455$var$PARAS = [
    'More information means better decisions. Better decisions create value.',
    "AI now lets us deliver fast, affordable diligence \u2014 corporate, legal, financial, technical \u2014 all on one platform, at a cost that was unthinkable even two years ago.",
    "But here's what we've learned: investors and buyers using our tools uncover ten times more red flags. That means slower deals and price chipping.",
    "The answer? Get investor-ready before the transaction starts. Use those same tools to self-diligence, fix the gaps, and present a clean house from day one. The result: quicker deals, lower costs, higher valuations \u2014 and far less chance of a deal falling apart. Then connect directly to investors through the platform.",
    "Curious? Try it for free or book a call \u2014 I'd love to hear from you."
];


const $da5a36c4dfaa1455$var$HomeFounderNote = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-founder",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-founder-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-founder-copy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            "data-lp-reveal": true,
                            children: "A note from our founder"
                        }),
                        $da5a36c4dfaa1455$var$PARAS.map((p, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                "data-lp-reveal": true,
                                "data-lp-delay": 60 + i * 40,
                                children: p
                            }, i)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "nm",
                            "data-lp-reveal": true,
                            "data-lp-delay": "260",
                            children: "Mark Bernstein ACA, CEO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "sig",
                            src: (parcelRequire("9MRy1")),
                            alt: "Mark Bernstein signature",
                            "data-lp-reveal": true,
                            "data-lp-delay": "300"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-founder-media",
                    "data-lp-reveal": true,
                    "data-lp-delay": "140",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("lLAnH")),
                        alt: "Mark Bernstein, CEO"
                    })
                })
            ]
        })
    });
var $da5a36c4dfaa1455$export$2e2bcd8739ae039 = $da5a36c4dfaa1455$var$HomeFounderNote;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $c1f88c03ee748f48$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
// --full: the homepage design fills the whole section with blue rather than floating a blue card
// on a light background. Scoped via the modifier — .lp-cta is shared by ten other pages.
const $c1f88c03ee748f48$var$HomeCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-cta lp-cta--full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-cta-card",
            "data-lp-reveal": true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-cta-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Let's discuss how we can help you beat the odds and create value"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "sub",
                        children: "Join 50+ investors, advisors, and companies already using the platform. Start free \u2014 no credit card required."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-cta-btns",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "lp-cta-btn",
                                to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                children: "Get started free"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "lp-cta-btn lp-cta-btn--outline",
                                href: $c1f88c03ee748f48$var$KOALENDAR,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Book a demo call"
                            })
                        ]
                    })
                ]
            })
        })
    });
var $c1f88c03ee748f48$export$2e2bcd8739ae039 = $c1f88c03ee748f48$var$HomeCtaSection;


const $c5daf7e3b2477c4e$var$HomePage = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const rootRef = (0, $acw62.useRef)(null);
    const [isAllServices, setIsAllServices] = (0, $acw62.useState)(true);
    const [isEssentialCookies, setIsEssentialCookies] = (0, $acw62.useState)(true);
    const [isFunctionalCookies, setIsFunctionalCookies] = (0, $acw62.useState)(true);
    const [isPerformanceCookies, setIsPerformanceCookies] = (0, $acw62.useState)(true);
    // Use the hook to apply styles to the shadow root
    (0, $b0700e714cfac258$export$12212e996914823f)();
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    (0, $acw62.useEffect)(()=>{
        let hash = location.hash;
        if (hash.includes('linkedIn')) dispatch((0, $c968c32a840f1f4e$export$69e58c86f065e022)({
            isFromLinkedIn: true
        }));
        let isCookies = localStorage.getItem("isCookies");
        if (isCookies == null) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'cookiesModal'
            }));
            (0, $6ee05925f8d16f34$export$1deff90544a4c4e9)('cookies_modal');
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        // Move the didAgent chatbot into the #chatbot container if both exist
        const targetElement = document.querySelector('.didagent_target');
        const chatbotElement = document.getElementById('chatbot');
        if (targetElement && chatbotElement) chatbotElement.appendChild(targetElement);
        return ()=>{
            if (targetElement && chatbotElement && targetElement.parentNode === chatbotElement) chatbotElement.removeChild(targetElement);
        };
    }, []);
    const handleSaveCookies = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        localStorage.setItem('isCookies', true);
        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('save_cookies', {
            essential_cookies: isEssentialCookies,
            functional_cookies: isFunctionalCookies,
            performance_cookies: isPerformanceCookies,
            accept_all: isAllServices
        });
        (0, $6ee05925f8d16f34$export$cdd110eef83fd2bd)('cookies_modal');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        isHomePage: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-page",
                ref: rootRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b9715f4dc907e04$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9f3b76c12a708e2b$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c1ff867c550652f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b86ecd68481bf334$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dd69a5dd57cd99e1$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da5a36c4dfaa1455$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1f88c03ee748f48$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "cookiesModal",
                open: modal['open'] == 'cookiesModal',
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "poppins-font-style cookies-modal mah100 bg1 shadow w100 df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        maxWidth: '630px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "header-area w100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb w100 pt1rem pb1rem pl2rem pr2rem bsbb aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "back-btn-modal cp",
                                            width: "22",
                                            height: "16",
                                            viewBox: "0 0 22 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 0 8.19043 0 8.01505C0 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                                fill: "#151313"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs1rem fw600",
                                            children: [
                                                "Powered by ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "tdu",
                                                    children: "Klaro"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "cookies-box py1rem px3rem",
                                style: {
                                    height: '60vh',
                                    overflow: 'auto'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "c15 fs1-5rem mb1rem",
                                        children: "Cookie usage"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "c14 pb1rem",
                                        children: [
                                            "In order to enhance your experience across our platforms and show you more relevant information, we use cookies and similar technologies. For more information, see our ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: "/policy",
                                                target: "_blank",
                                                className: "cookies-btn fsi c3 tdu cp",
                                                children: "Cookie Policy."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px",
                                        style: {
                                            backgroundColor: '#D1DFFF66'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "title-area df aic",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "c15 fs1rem",
                                                        children: "Essential cookies"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "required bg1 c7 bss bw1px bo7 br15px ml1rem w80px fs0-75rem tac",
                                                        children: "Required"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "radio-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    name: "essentialCookies",
                                                    className: "success w100",
                                                    checked: isEssentialCookies,
                                                    onChange: ()=>{
                                                        setIsEssentialCookies(!isEssentialCookies);
                                                        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('toggle_essential_cookies', {
                                                            enabled: !isEssentialCookies
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px",
                                        style: {
                                            backgroundColor: '#D1DFFF66'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "title-area df aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "c15 fs1rem",
                                                    children: "Functional cookies"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "radio-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    name: "functionalCookies",
                                                    className: "success w100",
                                                    checked: isFunctionalCookies,
                                                    onChange: ()=>{
                                                        setIsFunctionalCookies(!isFunctionalCookies);
                                                        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('toggle_functional_cookies', {
                                                            enabled: !isFunctionalCookies
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px",
                                        style: {
                                            backgroundColor: '#D1DFFF66'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "title-area df aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "c15 fs1rem",
                                                    children: "Performance cookies"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "radio-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    name: "performanceCookies",
                                                    className: "success w100",
                                                    checked: isPerformanceCookies,
                                                    onChange: ()=>{
                                                        setIsPerformanceCookies(!isPerformanceCookies);
                                                        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('toggle_performance_cookies', {
                                                            enabled: !isPerformanceCookies
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pt2rem pb1rem divedier",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px",
                                        style: {
                                            backgroundColor: '#D1DFFF66'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "title-area df aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "c15 fs1rem",
                                                    children: "Accept all services"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "radio-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    name: "allServices",
                                                    className: "success w100",
                                                    checked: isAllServices,
                                                    onChange: ()=>{
                                                        setIsAllServices(!isAllServices);
                                                        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('toggle_accept_all_services', {
                                                            enabled: !isAllServices
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc w100",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>handleSaveCookies(),
                                            className: "bg15 bg14-hover w200px p1rem mt2rem c1 br80px cp td250",
                                            children: "Save"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $c5daf7e3b2477c4e$export$2e2bcd8739ae039 = $c5daf7e3b2477c4e$var$HomePage;



var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");

function $e0b4e656350dc707$export$2e2bcd8739ae039({ heading: heading, callUsNow: callUsNow }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bg6 bss bw0px bo3 py3rem btw5px w100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container df jcsb aic fww c1",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "fw600 m1rem fs2rem",
                    children: heading
                }),
                callUsNow ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "tel:01234567890",
                    className: "fs1-5rem br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                    children: "Call us now for more information"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    href: "/register",
                    className: "fs1-5rem br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                    children: "Register Now"
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


function $b3225fee4c48dcf9$export$2e2bcd8739ae039({ buttonScrollTo: buttonScrollTo, dataShowPopup: dataShowPopup, h1Class: h1Class = "fs2rem fs3rem-sm", h1: h1, buttonText: buttonText, belowButtonText: belowButtonText, videoSrc: videoSrc, videoThumbnail: videoThumbnail }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [isPlay, setIsPlay] = (0, $acw62.useState)(false);
    function playVideo(e) {
        let video = document.getElementById("video");
        if (video.paused == true) {
            setIsPlay(true);
            video.play();
        }
        e.target.controls = true;
        if (e?.target?.nextElementSibling) e.target.nextElementSibling.remove();
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "hero",
        className: "bg1 mih100vh df",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py4rem w100 df fww aic gg5rem hero-saf",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "ma w60",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: h1Class + " text-gradient ass lh2",
                            children: h1.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb1rem",
                                    children: s
                                }, i))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            "data-scroll-to": buttonScrollTo,
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: dataShowPopup
                                })),
                            className: "dif jcc aic shadow fs1-5rem cp td250 bg1 c3 bss bw5px bo6 fw600 px1rem py0-5rem button-text",
                            children: [
                                buttonText,
                                belowButtonText && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        fontSize: '13px',
                                        color: '#000'
                                    },
                                    className: "fw400 mt1rem fs1-25rem px1rem py0-5rem bw0px blw5px bss bo6 button-below-text",
                                    children: belowButtonText
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "pen ml1rem h3rem f3",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 448 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M256 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L370.8 256l-137.4-137.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C272.4 444.9 264.2 448 256 448z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l32 32L338.8 288z"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr ma w40 gradient-shadow cp",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                            id: "video",
                            onClick: (e)=>playVideo(e),
                            className: "bg1 bsbb pr bss bw5px bo5 w100",
                            poster: "/images/thumbnails" + videoThumbnail,
                            preload: "none",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("source", {
                                src: `https://diligentsia-website-assets.s3.us-east-2.amazonaws.com/diligentsia_for_companies.mp4`,
                                type: "video/mp4"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: `${isPlay && 'dn'} pen br100 shadow bss bw5px bo4 w5rem h5rem f4 bg1 pa center`,
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 512 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary",
                                    d: "M216 368c-13.69 0-24-11.2-24-24V168C192 155.3 202.2 144 216 144c4.343 0 8.677 1.176 12.51 3.516l144 88C379.6 239.9 384 247.6 384 256c0 8.359-4.352 16.12-11.48 20.48l-144 88C224.7 366.8 220.3 368 216 368z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary",
                                    d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM372.5 276.5l-144 88C224.7 366.8 220.3 368 216 368c-13.69 0-24-11.2-24-24V168C192 155.3 202.2 144 216 144c4.344 0 8.678 1.176 12.51 3.516l144 88C379.6 239.9 384 247.6 384 256C384 264.4 379.6 272.1 372.5 276.5z"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
function $57a8a6dc08d5df26$export$2e2bcd8739ae039({ content: content, wrapperClass: wrapperClass }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: wrapperClass + " bw0px btw5px bss bo3 bg1 py5rem bg6",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container df fdc",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "dg gtcr" + content.length + "a-lg bg6 c1 cg3rem rg2rem rg5rem-lg",
                children: content.map((text, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: text.map((s, j)=>{
                            if (j === 0 && text.length > 1) {
                                if (i === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "mih3rem ass c3 fs1-25rem fs1-5rem-sm mb1rem c4 ttu lh2",
                                    children: s
                                });
                                else return /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "mih3rem ass c1 fs1-25rem fs1-5rem-sm mb1rem",
                                    children: s
                                });
                            }
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem",
                                children: s
                            });
                        })
                    }, i))
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
function $5abc57980b6445c2$export$2e2bcd8739ae039({ heading: heading, paragraph: paragraph, wrapperClass: wrapperClass }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: wrapperClass + " py1rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "ass c3 fs1-5rem fs1-75rem-sm mb1rem",
                children: heading
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1rem mb2rem fs1rem",
                children: paragraph
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");


function $e53a7d535d7f42b8$export$2e2bcd8739ae039({ readyFor: readyFor }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [test, setTest] = (0, $acw62.useState)();
    const array = readyFor ? [
        readyFor
    ] : [
        "Investment",
        "Growth",
        "Exit"
    ];
    (0, $acw62.useEffect)(()=>{
        let test = window.location.href.split('#')[1];
        if (test && !test.includes('fit-report')) {
            if (array.length > 0 && array.filter((item)=>item == test)) welcome2MinuteTest(test);
        }
    }, []);
    const handleLetsGo = ()=>{
        localStorage.setItem('testType', test.toLowerCase());
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addCompany'
        }));
    };
    const welcome2MinuteTest = async (test)=>{
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'welcome2MinuteTest'
        }));
        setTest(test);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "takeTheTest",
        className: "bg-gradient c1",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc gg2rem ftcr" + array.length,
                    children: array.map((test, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "h100 df fdc jcsb aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "fs1-5rem mb1rem tac lh1",
                                    children: [
                                        "How ",
                                        test,
                                        " ready are you?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "tac fs1-25rem mb1rem",
                                    children: [
                                        "Take the ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "FREE"
                                        }),
                                        " 2-minute Diligentsia test and let's see!",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `#${test}`,
                                    onClick: ()=>welcome2MinuteTest(test),
                                    className: "shadow fs1-25rem cp td250 bg5 c6 c1-hover bg3-hover fw600 br5px py0-5rem px1rem",
                                    children: [
                                        "To ",
                                        test,
                                        " Ready Test"
                                    ]
                                })
                            ]
                        }, idx))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt3rem df fdc jcc maw500px mxa",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "fs1-25rem fs1-5rem-sm mb2rem tac lh1",
                            children: "What You Get"
                        }),
                        [
                            "Answer a number of bespoke multiple choice questions",
                            "A report indicating how ready your company is, including risk score",
                            "Recommendations for improvement",
                            "An AI-enhanced set of KPIs specific to your business"
                        ].map((text, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic mb1rem fs1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        className: "h2rem fds ass f4 mr0-5rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 320 512",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w100",
                                        children: text
                                    })
                                ]
                            }, idx)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            onClick: ()=>localStorage.removeItem('registerAs'),
                            to: "/register",
                            className: "mt2rem tac c4-hover td250 fs1rem cp",
                            children: "Skip test, just sign me up please"
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");
function $4a4a72a1415192d1$export$2e2bcd8739ae039({ children: children, title: title, ticks: ticks, wrapperClass: wrapperClass }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: wrapperClass + " df pt5rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mla-lg pr shadow p1rem bg5 pt5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "f3 shadow bg6 pa t0 center p1rem w100px df jcc aic h100px br100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc aic w100 h100 mah3rem maw3rem",
                        children: children
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "mb1rem tac fs1-75rem",
                    children: title
                }),
                ticks.map((tick, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb1rem df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                className: "w1rem ha ass f4 mr1rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary",
                                    d: "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "w100 fs1rem",
                                children: tick
                            })
                        ]
                    }, idx))
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





function $90c4aa29e96205dc$export$2e2bcd8739ae039({ testimonials: testimonials }) {
    function changeTestimonial(e) {
        if (e?.target?.classList.contains("op100")) return;
        if (e?.target) {
            e.target.closest("[data-scroll-testimonials]").dataset.scrollTestimonials = "";
            setTestimonial(e.target);
        }
    }
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (document.querySelector("[data-scroll-testimonials]").dataset.scrollTestimonials) setTestimonial(document.querySelector(".testimonialDot.op100 + .testimonialDot.op20") || document.querySelector(".testimonialDot"));
        }, 10000);
        return ()=>clearInterval(interval);
    }, []);
    function setTestimonial(el) {
        const testimonialContainer = document.getElementById("testimonialContainer");
        const currentDot = document.querySelector(".testimonialDot.op100");
        const index = el.getAttribute("index");
        testimonialContainer.style.left = "calc(-" + index * 100 + "%)";
        currentDot.classList.remove("op100");
        currentDot.classList.add("op20");
        el.classList.add("op100");
        el.classList.remove("op20");
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bg5",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-scroll-testimonials": "true",
            className: "container df fdc jcc py5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-gradient fs2rem tac",
                    children: "Don't just take our word for it\u2026"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "testimonialWrapper",
                    className: "pr oxh w600px maw100 mxa",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: "testimonialContainer",
                        style: {
                            width: testimonials.length + "00%",
                            gridTemplateColumns: "repeat(" + testimonials.length + ", 1fr)"
                        },
                        className: "df pr t0 l0 td500",
                        children: testimonials.map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df fdc p2rem jcc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "c3 tac fs1-5rem mb1rem w100",
                                        children: i.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs1rem mb2rem lh3",
                                        children: [
                                            '"',
                                            i.text,
                                            '"'
                                        ]
                                    }),
                                    i.author == "Katy Davidson" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "mb0-5rem w4rem h4rem br100 obcov mla mra",
                                        src: (parcelRequire("5dTa9"))
                                    }) : i.author == "Louise Birritteri" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "mb0-5rem w4rem h4rem br100 obcov mla mra",
                                        src: (parcelRequire("hAmwK"))
                                    }) : i.author == "Rik Pancholi" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "mb0-5rem w4rem h4rem br100 obcov mla mra",
                                        src: (parcelRequire("4TxZa"))
                                    }) : i.author == "Richard Whitwell" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "mb0-5rem w4rem h4rem br100 obcov mla mra",
                                        src: (parcelRequire("3jD7H"))
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "mb0-5rem w4rem h4rem br100 obcov mla mra",
                                        src: (parcelRequire("cvZc5"))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tac w100 fw400 mb0-5rem",
                                        children: i.author
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tac w100 fw600",
                                        children: i.company
                                    })
                                ]
                            }))
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc mb2-5rem",
                    children: testimonials.map((i, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            index: index,
                            onClick: ()=>changeTestimonial(),
                            className: "f4 testimonialDot pl0-5rem pr0-5rem cp w1rem td300 op" + (index === 0 ? 100 : 20),
                            viewBox: "0 0 512 512",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "pen",
                                d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                            })
                        }, index))
                })
            ]
        })
    });
}


function $5b6eb2f7a73a2be0$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "The Early Stage CEO",
            text: "Having an investment ready data room and supporting documents has undoubtedly attracted more interested investors prepared to look at us seriously and accelerated our investment timetable.",
            author: "Louise Birritteri",
            company: "CEO Pikl Insurance Services Limited"
        },
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "Exit More Quickly,",
                    "At a Higher Valuation,",
                    "With More Certainty."
                ],
                buttonText: "Learn How",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_companies.mp4",
                videoThumbnail: "diligentsia-for-companies.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e53a7d535d7f42b8$export$2e2bcd8739ae039), {
                readyFor: "Exit"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "container df fww py5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "w50",
                            heading: "Is Your Company Exit Ready?",
                            subheading: "Meet Diligentsia",
                            paragraph: "Warranty disclosure schedules, Director\u2019s questionnaires, up to date key corporate data - legal, IP, key contracts, HR, constitutional - all in a single intuitive and easy to access repository. These are all things that give purchasers confidence in your business. But what else do you need and how do you know if you\u2019re ready to maximise the value of your business on exit?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a4a72a1415192d1$export$2e2bcd8739ae039), {
                            wrapperClass: "w50 jcfe",
                            title: "Exit Phase",
                            ticks: [
                                'We make you "exit ready"',
                                "More buyers will look at your company",
                                "Better chance of auction",
                                "Higher valuation",
                                "Better terms",
                                "Quicker transaction time",
                                "Reduced risk of late collapse of deal"
                            ],
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 512 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M502.6 278.6l-128 128c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25L402.8 288H192C174.3 288 160 273.7 160 256s14.31-32 32-32h210.8l-73.38-73.38c-12.5-12.5-12.5-32.75 0-45.25c12.49-12.49 32.74-12.51 45.25 0l128 128C515.1 245.9 515.1 266.1 502.6 278.6z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M160 416H96c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h64c17.67 0 32-14.33 32-32S177.7 32 160 32H96C42.98 32 0 74.98 0 128v256c0 53.02 42.98 96 96 96h64c17.67 0 32-14.33 32-32S177.7 416 160 416z"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fww container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            wrapperClass: "w45 mr2rem",
                            heading: "Does your repository deliver everything your purchasers expect and more?",
                            paragraph: "Have you self-diligenced through a business audit in advance of going out for funding? How do you benchmark yourselves? These are all questions that we can help you with. We help our business exit, more quickly, with more certainty, and at a higher valuation."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            wrapperClass: "w45 mr2rem",
                            heading: "So how do we do it?",
                            paragraph: "Our ultra-low-cost SaaS based platform helps you easily use tailored online forms and checklists to systematically help you create an easily accessible central \u201Cbrain\u201D, a living breathing data repository. Why waste valuable time every day looking for key documents when we can help you centralise your key documents within your existing cloud-based provider. We get you organized!"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Helping You Help Yourselves",
                        "You can pull together the repository yourself using our easy-to-use checklists, or we can assist you, or ask your lawyer or accountant to help \u2013 they also benefit from your key corporate data being better organised."
                    ],
                    [
                        "Already have a data room?",
                        "We\u2019re data room agnostic. If you already have a data room, such as Seed Legals, or iDeals or DataSite, we help you organise it better to create more value. Or we simply create one within your existing cloud-based solution \u2013 Sharepoint/Drive. You tell us"
                    ],
                    [
                        "Be Exit Ready",
                        "We make you exit ready. We work with a number of accoutants, law firms and banks, who gain confidence if you are working with us. They know their time will not be wasted."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                heading: "Ready to Maximise Your Exit Valuation for as Little as \xa3 5 a Month?"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");









function $c0e3557e009ae460$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "The Early Stage CEO",
            text: "Having an investment ready data room and supporting documents has undoubtedly attracted more interested investors prepared to look at us seriously and accelerated our investment timetable.",
            author: "Louise Birritteri",
            company: "CEO Pikl Insurance Services Limited"
        },
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "Grow More Value,",
                    "More Quickly,",
                    "With More Certainty."
                ],
                buttonText: "Learn How",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_companies.mp4",
                videoThumbnail: "diligentsia-for-companies.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e53a7d535d7f42b8$export$2e2bcd8739ae039), {
                readyFor: "Growth"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "container df fww py5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "w50",
                            heading: "Is Your Company Growth Ready?",
                            subheading: "Meet Diligentsia",
                            paragraph: "Warranty disclosure schedules, Director\u2019s questionnaires, up to date key corporate data - legal, IP, key contracts, HR, constitutional - all in a single intuitive and easy to access repository. These are all things that give your stakeholders confidence in your business. But what else do you need and how do you know if you\u2019re ready to maximise the continuing value of your business?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a4a72a1415192d1$export$2e2bcd8739ae039), {
                            wrapperClass: "w50 jcfe",
                            title: "Growth Phase",
                            ticks: [
                                "We make your processes more efficient",
                                "Spot problems earlier",
                                'Your company "grows up" faster',
                                "Reduced professional fees",
                                "Higher growth",
                                'More time to focus on the "fun stuff"'
                            ],
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 576 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M544 320c-17.69 0-32-14.33-32-32V160h-128c-17.69 0-32-14.33-32-32s14.31-32 32-32h160c17.69 0 32 14.33 32 32v160C576 305.7 561.7 320 544 320z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M512 205.3l-169.4 169.4C336.4 380.9 328.2 384 320 384s-16.38-3.125-22.62-9.375L192 269.3l-137.4 137.4C48.38 412.9 40.19 416 32 416c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62l160-160C175.6 195.1 183.8 192 192 192s16.38 3.125 22.62 9.375L320 306.8L466.8 160H512V205.3z"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fww container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            wrapperClass: "w45 mr2rem",
                            heading: "Does your repository deliver everything your purchasers expect and more?",
                            paragraph: "Have you self-diligenced through a business audit in advance of going out for funding? How do you benchmark yourselves? These are all questions that we can help you with. We help your business grow or raise investment or exit, more quickly, at a higher valuation, and with more certainty."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            wrapperClass: "w45 mr2rem",
                            heading: "So how do we do it?",
                            paragraph: "Our ultra-low-cost SaaS based platform helps you easily use tailored online forms and checklists to systematically help you create an easily accessible central \u201Cbrain\u201D, a living breathing data repository. Why waste valuable time every day looking for key documents when we can help you centralise your key documents within your existing cloud-based provider. We get you organized!"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Helping You Help Yourselves",
                        "As you grow, are you self-diligencing your business regularly?  How do you benchmark yourself against your competition?  These are questions we can help you with.  We can help you grow your business more quickly and present itself in a more sophisticated manner to those around you."
                    ],
                    [
                        "Already have a data room?",
                        "We\u2019re data room agnostic. If you already have a data room, such as Seed Legals, or iDeals or DataSite, we help you organise it better to create more value. Or we simply create one within your existing cloud-based solution \u2013 Sharepoint/Drive/Dropbox. You tell us"
                    ],
                    [
                        "Be Growth Ready",
                        "By enhancing your growth, we help you position your business better for either investment or exit, where you will be able to undertake transactions more quickly, at a higher valuation and with more certainty."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                heading: "Ready to Maximise Your Growth for as Little as \xa3 5 a Month?"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");









function $1abcaa77a9db32b9$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "The Early Stage CEO",
            text: "Having an investment ready data room and supporting documents has undoubtedly attracted more interested investors prepared to look at us seriously and accelerated our investment timetable.",
            author: "Louise Birritteri",
            company: "CEO Pikl Insurance Services Limited"
        },
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "Raise More Money,",
                    "More Quickly,",
                    "With More Certainty."
                ],
                buttonText: "Learn How",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_companies.mp4",
                videoThumbnail: "diligentsia-for-companies.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e53a7d535d7f42b8$export$2e2bcd8739ae039), {
                readyFor: "Investment"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "container df fww py5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "w50",
                            heading: "Is Your Company Investment Ready?",
                            subheading: "Meet Diligentsia",
                            paragraph: "Warranty disclosure schedules, Director\u2019s questionnaires, up to date key corporate data - legal, IP, key contracts, HR, constitutional - all in a single intuitive and easy to access repository. These are all things that give investors confidence in your business. But what else do you need and how do you know if you\u2019re investment ready?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a4a72a1415192d1$export$2e2bcd8739ae039), {
                            wrapperClass: "w50 jcfe",
                            title: "Investment Phase",
                            ticks: [
                                'We make you "investment ready"',
                                "More investors will look at your company",
                                "Better chance of auction",
                                "Higher valuation",
                                "Better terms",
                                "Quicker transaction time",
                                "Reduced risk of late collapse of deal",
                                "Lower professional fees"
                            ],
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M288 480H32c-12.41 0-23.72-7.188-28.97-18.44c-5.281-11.23-3.562-24.52 4.375-34.05c28.25-33.86 43.78-76.55 43.78-120.2V157.3C51.19 88.22 108.3 32 178.6 32c13.69 0 27.25 2.156 40.25 6.422l79.09 25.89c16.81 5.484 25.97 23.56 20.47 40.36c-5.469 16.77-23.62 25.98-40.34 20.45l-79.13-25.89C192.3 97.09 185.5 96 178.6 96C143.6 96 115.2 123.5 115.2 157.3v149.1c0 37.73-8.625 74.91-24.88 108.7H288c17.69 0 32 14.33 32 32S305.7 480 288 480z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M0 256c0 17.67 14.31 32 32 32h19.19V224H32C14.31 224 0 238.3 0 256zM224 224H115.2v64H224c17.69 0 32-14.33 32-32S241.7 224 224 224z"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fww container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            wrapperClass: "w45 mr2rem",
                            heading: "Does your repository deliver everything your investors expect and more?",
                            paragraph: "Have you self-diligenced through a business audit in advance of going out for funding? How do you benchmark yourselves? These are all questions that we can help you with. We help your business grow or raise investment or exit, more quickly, at a higher valuation, and with more certainty."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            wrapperClass: "w45 ml2rem",
                            heading: "So how do we do it?",
                            paragraph: "Our ultra-low-cost SaaS based platform helps you easily use tailored online forms and checklists to systematically help you create an easily accessible central \u201Cbrain\u201D, a living breathing data repository. Why waste valuable time every day looking for key documents when we can help you centralise your key documents within your existing cloud-based provider. We get you organized!"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Helping You Help Yourselves",
                        "You can pull together the repository yourself using our easy-to-use checklists, or we can assist you, or ask your lawyer or accountant to help \u2013 they also benefit from your key corporate data being better organised."
                    ],
                    [
                        "Already have a data room?",
                        "We\u2019re data room agnostic. If you already have a data room, such as Seed Legals, or iDeals or DataSite, we help you organise it better to create more value. Or we simply create one within your existing cloud-based solution \u2013 Sharepoint/Drive. You tell us"
                    ],
                    [
                        "Be Investment Ready",
                        "We make you investment ready. We work closely with a number of leading VCs, accountants and law firms, who gain confidence if you are working with us. They know their time will not be wasted"
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                heading: "Ready to Maximise Your Investability for as Little as \xa3 5 a Month?"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");







var $ayMG0 = parcelRequire("ayMG0");
function $09b448c31c7c9e44$export$2e2bcd8739ae039({ text: text, children: children }) {
    return (text || children) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: "offerBanner",
        className: "pf t0 l0 zi5 w100 bg6 df fww jcc aic py1rem",
        children: [
            text && /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "c1 fw600 fs1-25rem-sm",
                children: text
            }),
            children
        ]
    });
}



function $bd1f8ea7559652d0$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        },
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "The Early Stage CEO",
            text: "Having an investment ready data room and supporting documents has undoubtedly attracted more interested investors prepared to look at us seriously and accelerated our investment timetable.",
            author: "Louise Birritteri",
            company: "CEO Pikl Insurance Services Limited"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09b448c31c7c9e44$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem fs2-5rem-sm",
                text: "Three Additional Data Room Providers Coming Soon"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1: [
                    "Increased Margins,",
                    "New Revenue Streams,",
                    "Route to New Clients."
                ],
                buttonText: "Register as Advisor",
                id: "openRegisterPopup",
                dataShowPopup: "registerAdvisor",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_lawyers.mp4",
                videoThumbnail: "diligentsia-for-lawyers.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container dg gtcr1-lg gg2rem py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        heading: "Can We Help Your Clients?",
                        subheading: "Meet Diligentsia",
                        paragraph: "Warranty disclosure schedules, Director\u2019s Questionnaires, up to date key corporate data - legal, IP, key contracts, HR, constitutional  - all in a single intuitive and easy to access repository. These are all things that give investors confidence in your clients\u2019 businesses. But what else do they need and how do you know if your clients are are investment ready?"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2-lg gg2rem container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Does your client\u2019s repository deliver everything their investors and purchasers expect and more?",
                            paragraph: "Have they self-diligenced through a business audit in advance of going out for funding or prior to exit? How do they benchmark thmselves? Could you help? These are all questions that we can help you with. We help your clients grow or raise investment or exit, more quickly, at a higher valuation, and with more certainty."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "So how do we do it?",
                            paragraph: "Our ultra-low-cost SaaS based platform helps you easily use tailored online forms and checklists to systematically help your clients create an easily accessible central \u201Cbrain\u201D, a living breathing data repository. Why waste valuable time every day looking for key documents when we can help you centralise your clients\u2019 key documents within their existing cloud- based provider.  We get your clients organized!"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Helping You Help Yourselves",
                        "Your clients can pull together their repository themselves using our easy-to-use checklists, or you can charge to assist them with setup, business audits and maintenance. Quarterly reviews provide you opportunities to identify additional areas for you to assist.  If you introduce five mor more clients to us, we will provide you a FREE DASHBOARD  to monitor repository completeness, new additions, business audit risk, investment readiness etc.* across your client base."
                    ],
                    [
                        "Your Client Already has a Data Room?",
                        "We\u2019re data room agnostic. If your client  already has a data room, such as Seed Legals, or iDeals or DataSite, we help you organise it better to create more value.  Or we simply create one within our client\u2019s existing cloud-based solution \u2013 Dropbox, Sharepoint, Drive. You tell us."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                callUsNow: true,
                heading: "Ready to Maximise Your Client's Value for as Little as \xa3 5 a Month? (Payable by your clients)"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");







function $c35aff80e2c7af97$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        },
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "The Early Stage CEO",
            text: "Having an investment ready data room and supporting documents has undoubtedly attracted more interested investors prepared to look at us seriously and accelerated our investment timetable.",
            author: "Louise Birritteri",
            company: "CEO Pikl Insurance Services Limited"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "Increased Margins,",
                    "New Revenue Streams,",
                    "Route to New Clients."
                ],
                buttonText: "Register as Advisor",
                id: "openRegisterPopup",
                dataShowPopup: "registerAdvisor",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_accountants.mp4",
                videoThumbnail: "diligentsia-for-accountants.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container dg gtcr1-lg gg2rem py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        heading: "Can We Help Your Clients?",
                        subheading: "Meet Diligentsia",
                        paragraph: "Can we help your clients grow or raise investment or exit, more quickly, at a higher valuation, and with more certainty? Their key corporate data \u2013 financial, tax, IP, key contracts, HR, constitutional etc. is probably today held in many siloes in Sharepoint or Drive or Dropbox. They and you waste valuable time every day looking for key documents. We help your clients centralise their key documents within their existing cloud-based provider. We get your clients organized. Your life is made easier!"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2-lg gg2rem container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Does your repository deliver everything their investors expect and more?",
                            paragraph: "Have they self-diligenced through a business audit in advance of going out for funding? How do you benchmark yourselves? Could you help? These are all questions that we can help you with."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "So how do we do it?",
                            paragraph: "Our ultra-low-cost SaaS based platform helps you easily use tailored online forms and checklists to systematically help your clients create an easily accessible central \u201Cbrain\u201D, a living breathing data repository. Why waste valuable time every day looking for key documents when we can help you centralise your clients\u2019 key documents within their existing cloud- based provider. We get your clients organized!"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Helping You Help Your Clients",
                        "Your clients can pull together their repository themselves using our easy-to-use checklists, or you can charge to assist them with setup, business audits and maintenance. Chargeable quarterly reviews provide you additional fee-generating opportunities.  If you introduce five mor more clients to us, we will provide you a FREE DASHBOARD  to monitor repository completeness, new additions, business audit risk, investment readiness etc.* across your client base."
                    ],
                    [
                        "Your Client Already has a Data Room?",
                        "We\u2019re data room agnostic. If your client  already has a data room, such as Seed Legals, or iDeals or DataSite, we help you organise it better to create more value.  Or we simply create one within our client\u2019s existing cloud-based solution \u2013 Dropbox, Sharepoint, Drive. You tell us."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                callUsNow: true,
                heading: "Ready to Maximise Your Clients' Value for as Little as \xa3 5 a Month? (Payable by your clients)"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");







function $bcc62cc1bbeb4cc1$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "The Investment Manager",
            text: "Cost-effective diligencing of angel-stage investments, along with an associated kitemark validation would be of great benefit to the angel market \u2013 both the networks and prospective angel investors.",
            author: "[Need to get approval]",
            company: "Investment Manager, [xxx]"
        },
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "Better Quality Companies,",
                    "Happier Investors,",
                    "More Deals Closed."
                ],
                buttonText: "Register as Investor",
                id: "openRegisterPopup",
                dataShowPopup: "registerInvestor",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_angel_networks.mp4",
                videoThumbnail: "diligentsia-for-angel-networks.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container dg gtcr1-lg gg2rem py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        heading: "Can We Help Your Network?",
                        subheading: "Meet Diligentsia",
                        paragraph: "Would you like to demonstrably improve investor returns across your network? Earlier qualification? Quicker deals? Higher funding completion %?<br>Would you like to better assess investment risk? It is currently difficult for investors and you to truly assess risk and stage of development of the companies that are presented to you."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2-lg gg2rem container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Would you like to offer cost effective due diligence to your companies?",
                            paragraph: "Not currently cost effective for you to undertake thorough due diligence. The companies do not have the funds available to pay the networks."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Would you like to improve standards across across your portfolio companies?",
                            paragraph: "And save investors time when assessing investment opportunities?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Would you like to Increase interest amongst your investor base?",
                            paragraph: "Kitemarking will enable investors immediately to see which of your companies is investment ready."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Flywheel effect.",
                            paragraph: "Your network will gain competitive advantage through offering better quality companies that have been pre-vetted; your angels will make better returns, and more angels will flock to your platform."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Investment Ready Kitemarks",
                        "Data room already? Seed Legals, or iDeals or DataSite? We organise it better to create more value.  No data room?  We simply create one within their existing cloud-based solution \u2013 Sharepoint/Drive/Dropbox."
                    ],
                    [
                        "We are Data Room Agnostic",
                        "Diligentsia has developed an ultra low-cost SaaS solution to act as a filter for the angel network, and get the companies \u201Cinvestment ready\u201D, along with a kitemark (bronze, silver gold) to display to potential investors."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                callUsNow: true,
                heading: "Ready to make your portfolio companies more investable for as little as \xa3 5 per month, payable by the companies?"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");







function $d5bc3cd9adce0fa1$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "The Investment Manager",
            text: "Cost-effective diligencing of angel-stage investments, along with an associated kitemark validation would be of great benefit to the angel market \u2013 both the networks and prospective angel investors.",
            author: "[Need to get approval]",
            company: "Investment Manager, [xxx]"
        },
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "More Investible Companies",
                    "Easier Due Diligence",
                    "Higher Exit Valutations."
                ],
                buttonText: "Register as Investor",
                id: "openRegisterPopup",
                dataShowPopup: "registerInvestor",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_angel_networks.mp4",
                videoThumbnail: "diligentsia-for-angel-investors.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container dg gtcr1-lg gg2rem py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        heading: "Can We Help Your Investments?",
                        subheading: "Meet Diligentsia",
                        paragraph: "Would you like to demonstrably improve returns across your investments? Earlier qualification? Quicker deals? Higher funding completion %? Would you like to better assess investment risk? It is currently difficult for you to truly assess risk and stage of development of the companies that are presented to you."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2-lg gg2rem container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Would you like to offer cost effective due diligence to your target companies?",
                            paragraph: "Not currently cost effective for you to undertake thorough due diligence. The companies do not have the funds available to pay the networks."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Would you like to improve standards across across your portfolio companies?",
                            paragraph: "And save you time when assessing investment opportunities?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Would you like to Increase interest amongst you and your fellow investors?",
                            paragraph: "Kitemarking will enable investors immediately to see which of your target companies is investment ready."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Flywheel effect.",
                            paragraph: "Your network will gain competitive advantage through offering better quality companies that have been pre-vetted; you and your angels will make better returns, and more angels will flock to the platforms and networks which utilise the kitemarking."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Investment Ready Kitemarks",
                        "Data room already? Seed Legals, or iDeals or DataSite? We organise it better to create more value.  No data room?  We simply create one within their existing cloud-based solution \u2013 Sharepoint/Drive/Dropbox."
                    ],
                    [
                        "We are Data Room Agnostic",
                        "Diligentsia has developed an ultra low-cost SaaS solution to act as a filter for the angel network, and get the companies \u201Cinvestment ready\u201D, along with a kitemark (bronze, silver gold) to display to potential investors."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                heading: "Ready to Maximise Your Investment Returns for as Little as \xa3 5 a Month?"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");








function $d8139c82c7f40ced$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "[Need to get approval]",
            text: "I can see the benefit of setting up a standard data repository structure as part of an immediate post-investment 100-day plan for an investee company, to facilitate subsequent cross-portfolio monitoring and then exit.",
            author: "Richard Whitwell",
            company: "Ex-head of Lloyds Development Capital (Midlands)"
        },
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09b448c31c7c9e44$export$2e2bcd8739ae039), {
                text: "Three Additional Data Room Providers Coming Soon"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "Streamlined Deal Process,",
                    "More Efficient Portfolio Management,",
                    "Higher Exit Valuations."
                ],
                buttonText: "Register as Investor",
                id: "openRegisterPopup",
                dataShowPopup: "registerInvestor",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_pe_firms.mp4",
                videoThumbnail: "diligentsia-for-pe-firms.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container dg gtcr1-lg gg2rem py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        heading: "Investment Phase.",
                        subheading: "Meet Diligentsia",
                        paragraph: "Do you waste time seeing a company\u2019s impressive deck and then find that the company is not investment ready?  Warranty disclosure schedules, Director\u2019s Questionnaires, up to date key corporate data - legal, IP, key contracts, HR, constitutional  - all in a single intuitive and easy to access repository ready for your review?   Diligentsia makes this happen."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2-lg gg2rem container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Growth Phase.",
                            paragraph: "Do you look to add value during first 100 days post investment? Why not let us help them put in place a standard structure living breathing repository across your investee companies? Cross portfolio monitoring and analytics \u2013 assistance with monthly investment director reporting & portfolio monitoring with central dashboard.  Benchmarking &  sharing best practice.  Risk registers. ESG reporting."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Exit Phase.",
                            paragraph: "Your portfolio company, well organised in advance, with issues resolved, will exit at a higher valuation, more quickly, and with more certainty. Your own checklists? Not a problem.  We can automate them."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Helping You Help Your Portfolio",
                        "Our ultra-low-cost SaaS based platform has easy to use  tailored online forms and checklists to systematically help your portfolio  companies create an easily accessible central \u201Cbrain\u201D, a living breathing data repository. Why waste everyone\u2019s valuable time every day looking for key documents when we can help you centralise your clients\u2019 key documents.  We get your companies organized!"
                    ],
                    [
                        "We Are Data Room Agnostic",
                        "Data room already? Seed Legals, or iDeals or DataSite? We organise it better to create more value.  No data room?  We simply create one within their existing cloud-based solution \u2013 Sharepoint/Drive/Dropbox.  You tell us."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                heading: "Ready to Maximise Your Portfolio Exit Valuation for as Little as \xa3 5 a Month?"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");









function $4a013422192363c1$export$2e2bcd8739ae039() {
    const testimonials = [
        {
            title: "The Investor",
            text: "I can see the benefit of setting up a standard data repository structure as part of an immediate post-investment 100-day plan for an investee company, to facilitate subsequent cross-portfolio monitoring.",
            author: "Richard Whitwell",
            company: "Private Equity Investor"
        },
        {
            title: "The Growth Manager",
            text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
            author: "Katy Davidson",
            company: "CFO Wearable Technologies Limited"
        },
        {
            title: "[todo]",
            text: "As a corporate financier, when seeing a company with a comprehensive data room that is clearly up to date always gives us early confidence as a professional advisors that that the management are going to work with us in a time-efficient manner \u2013 saving everyone cost in the long run.",
            author: "[todo]",
            company: "[todo]"
        },
        {
            title: "The Professional",
            text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
            author: "Rik Pancholi",
            company: "Director, Pattersons Commercial Law"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b3225fee4c48dcf9$export$2e2bcd8739ae039), {
                h1Class: "fs2-5rem",
                h1: [
                    "Streamlined Deal Process",
                    "More Certain Outcomes,",
                    "Higher Exit Valuations."
                ],
                buttonText: "Register as Investor",
                id: "openRegisterPopup",
                dataShowPopup: "registerInvestor",
                buttonId: "scrollDown",
                videoSrc: "diligentsia_for_venture_capital_firms.mp4",
                videoThumbnail: "diligentsia-for-venture-capital-firms.jpg"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container dg gtcr1-lg gg2rem py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        heading: "Investment Phase",
                        subheading: "Meet Diligentsia",
                        paragraph: "Do you waste time seeing a company\u2019s impressive deck and then find that the company is not investment ready? Warranty disclosure schedules, Director\u2019s Questionnaires, up to date key corporate data - legal, IP, key contracts, HR, constitutional - all in a single intuitive and easy to access repository ready for your review? Diligentsia makes this happen."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2-lg gg2rem container pb5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Growth Phase",
                            paragraph: "Do you look to add value during first 100 days post investment? Why not let us help them put in place a standard structure living breathing repository across your investee companies? Would like time-saving tools to assist in investment monitoring? Would you like to benchmark companies across your portfolio?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5abc57980b6445c2$export$2e2bcd8739ae039), {
                            heading: "Exit Phase.",
                            paragraph: "Your portfolio company, well organised in advance, with issues resolved, will exit at a higher valuation, more quickly, and with more certainty. Your own checklists? Not a problem. We can automate them."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57a8a6dc08d5df26$export$2e2bcd8739ae039), {
                content: [
                    [
                        "Helping You Help Your Portfolio",
                        "Our ultra-low-cost SaaS based platform has easy to use  tailored online forms and checklists to systematically help your portfolio  companies create an easily accessible central \u201Cbrain\u201D, a living breathing data repository. Why waste everyone\u2019s valuable time every day looking for key documents when we can help you centralise your clients\u2019 key documents.  We get your companies organized!"
                    ],
                    [
                        "We are Data Room Agnostic",
                        "Data room already? Seed Legals, or iDeals or DataSite? We organise it better to create more value.  No data room?  We simply create one within their existing cloud-based solution \u2013 Sharepoint/Drive/Dropbox.  You tell us."
                    ]
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c4aa29e96205dc$export$2e2bcd8739ae039), {
                testimonials: testimonials
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b4e656350dc707$export$2e2bcd8739ae039), {
                heading: "Ready to Maximise Your Investability Portfolio Exit Valuation as Little as \xa3 5 a Month?"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



function $1918fdab20a82fe5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $09b448c31c7c9e44$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c1 cp px0-5rem",
                        "data-scroll-to": "forCompanies",
                        children: "Company Terms"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c1 cp px0-5rem",
                        "data-scroll-to": "acceptableUse",
                        children: "Acceptable Use"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "container mxa py5rem dg gg1rem lh3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        id: "forCompanies",
                        wrapperClass: "tac mb2rem",
                        heading: "Terms & Conditions"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "br5px bg5 w50 shadow p2rem table-of-content style-two",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1rem",
                                children: "List of Terms & Conditions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "list-table",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 cp px0-5rem",
                                                "data-scroll-to": "forCompanies",
                                                children: "Company Terms"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                children: "Page 1"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 cp px0-5rem",
                                                "data-scroll-to": "acceptableUse",
                                                children: "Acceptable Use"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                children: "Page 3"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "forCompanies",
                                wrapperClass: "tac",
                                subheading: "For Companies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Effective: October 25, 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "This agreement only applies to customers that purchase a Diligentsia service for corporate organisations and is not applicable for Diligentsia services purchased by consumers or individuals. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: 'This Diligentsia Services Agreement (the "DSA") is between the applicable Diligentsia entity set forth in Appendix 1 ("Diligentsia") and the organization agreeing to these terms ("Customer"). Diligentsia and Customer are each referred to as a \u201CParty\u201D and collectively as the \u201CParties.\u201D\xa0This DSA governs access to and use of the Services and any Beta Services. This DSA, any Service-Specific Terms, each applicable Order Form, the Data Processing Agreement and, if applicable, the HIPAA Business Associate Agreement are collectively referred to as the "Agreement." By clicking "I agree," signing your Order Form for the Services, or using the Services, you agree to the Agreement as a Customer.'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "If you are agreeing to this Agreement for use of the Services by an organization, you are agreeing on behalf of that organization. You must have the authority to bind that organization to these terms, otherwise you must not sign up for the Services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Services."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Provision. The Agreement governs access to, and use of the Services, and any associated Software. Customer may access and use the Services in accordance with the Agreement."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Service-Specific Terms. Certain Services, or portions thereof, may be subject to additional terms, including third party terms and conditions, that are specific to the particular Services and are set forth in the Service-Specific Terms. By accessing or using Services covered by any Service-Specific Terms, you agree to the applicable Service-Specific Terms. If there is a conflict between these Terms and the Service-Specific Terms, the Service-Specific Terms will control with respect to the applicable Services or portions thereof."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Modifications. Diligentsia may update the Services from time to time. If Diligentsia changes the Services in a manner that materially reduces their functionality, Diligentsia will notify Customer at the email address associated with the account, and Customer may provide notice within thirty days of the change to terminate the Agreement. This termination right will not apply to updates made to features provided on a beta or evaluation basis. Without limiting the foregoing, from time to time, Diligentsia may add additional features to enhance the user experience of the Services at no additional charge. However, these free features may be withdrawn without further notices."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Software."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Generally. Some of the Services may allow Customer and End Users to download Software that may update automatically. Diligentsia hereby grants to Customer during the Term a limited non-exclusive license to use the Software solely in connection with the Services and in accordance with the Agreement. This license is non-transferable (subject to Section 14.8), irrevocable (except as set forth in Section 9), non-sublicensable, and will be fully paid up upon Customer\u2019s payment of the Fees."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Open Source. If any component of the Software is offered under an open source license, Diligentsia will make the license available to Customer and to the extent the provisions of that license grant Customer additional rights, those provisions will expressly override some terms of the Agreement solely with respect to that component of the Software."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Add-Ons. Customer may purchase Add-Ons for use in conjunction with certain Services. Add-Ons may not be purchased on a standalone basis and must be purchased in connection with a new or existing subscription to the applicable Services for which they are offered. Add-Ons may be subject to additional Service-Specific Terms. Without limiting the foregoing, Add-Ons that are identified as being offered by third parties are not part of the Services and are subject to Section 3.9 of the Agreement."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Subscriptions."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Services Term. Unless otherwise set forth on the Order Form, the Services are sold on a subscription basis. Diligentsia will deliver the Services to Customer for the Services Term. Unless the parties agree otherwise in writing, any increases in quantities of Services purchased during any Services Term will have a prorated term ending on the last day of the pre-existing Services Term."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Automatic Renewals. Unless otherwise specified on the Order Form, following the Initial Services Term or a Renewal Term, Customer\u2019s subscription to the Services will automatically renew for a Renewal Term at the then-current quantity or subscription tier, unless either Party gives the other written notice of termination (including any partial termination to reduce quantities) at least thirty days prior to the expiration of the then-current Services term. If Customer has purchased the Services online via a self-serve mechanism and provided a payment method to Diligentsia for recurring charges, Customer may elect to terminate the Agreement via the Admin Console prior to the day a Renewal Term begins."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Additional Subscriptions. The Services may be configured to allow Administrators or End Users to purchase additional subscriptions or quantities of Services or Add-Ons. Customer is responsible for understanding the settings and controls of the Services for purchasing additional Services. Diligentsia will charge Customer the applicable pro-rated amount for additional Services or Add-Ons for the remainder of the then-current Services Term based on Customer\u2019s then-current price unless otherwise set forth on the Order Form."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Usage-based Subscriptions. If Customer elects to purchase any Services based on usage, Customer acknowledges that Diligentsia will charge Customer the Fees for the Services as set forth in the Order Form or Service-Specific Terms based on the usage calculated by Diligentsia."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Customer Obligations."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Registration. Customer and its End Users may need to register for an End User Account to place orders or to access or use the Services. Account information must be accurate, current, and complete, and Customer agrees to keep this information up-to-date."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Customer Administration of the Services. Customer may specify End Users as Administrators, including through multiple tiers of Administrators. Administrators may be able to: (a) access, disclose, restrict access to, or remove Customer Data; (b) purchase additional licenses, capacity, or other applicable quantity for the Services; and (c) provision, monitor, restrict, or terminate access to the Services by End Users. Customer is responsible for maintaining the confidentiality of passwords and Admin Accounts and managing access to Admin Accounts. Diligentsia\u2019s responsibilities do not extend to the internal management or administration of the Services for Customer."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Third Party Administration. Customer acknowledges that, if Customer purchases the Services through a reseller and designates any of the reseller's personnel as Administrators of Customer's Services account, the reseller may be able to control account information, including Customer Data, and access Customer's Services account as described above."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "End Users."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Provisioning. For services sold based on End User Licenses, Customer may provision End User Accounts up to the number of End User Licenses purchased through one or more Order Forms. Each End User Account requires a paid End User License, and End User Accounts may not be shared by multiple individuals. End User Accounts may only be provisioned to, registered for, and used by a single End User. End User Accounts that are set as suspended by Customer require a paid End User License. If Customer deletes an End User Account, the End User License may be reallocated to provision a new End User Account."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Responsibility. Customer is responsible for use of the Services by its End Users. Customer will obtain and maintain from End Users any consents necessary to allow Administrators to engage in the activities described in the Agreement and to allow Diligentsia to deliver the Services."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Unauthorized Use or Access. Customer will prevent unauthorized use of the Services by its End Users and terminate any unauthorized use of or access to the Services. The Services are not intended for End Users under the age of 18. If the law where the End User resides requires that the End User must be older in order for Diligentsia to lawfully provide the Services to the End User without parental consent, the End User must be that older age. Customer will ensure that it does not allow any person under 18 to use the Services. Customer will promptly notify Diligentsia of any unauthorized use of or access to the Services."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Restrictions. Customer will not: (a) sell, resell, or lease the Services, Software, or End User Licenses; (b) use the Services or Software for activities where use or failure of the Services or Software could lead to physical damage, death, or personal injury; (c) reverse engineer the Services or Software, or attempt or assist anyone else to do so, unless this restriction is prohibited by law; (d) use the Services or Software, including the export or re-export of Customer Data, in violation of Export Control Laws; (e) violate or circumvent any Service Limits of the Services or otherwise configure the Services to avoid Service Limits; (f) access the Services for the purpose of building a competitive product or service or copying its features or user interface; (g) use the Services for evaluation, benchmarking, or other comparative analysis intended for publication without Diligentsia\u2019s prior written consent; (h) remove or obscure any proprietary or other notices contained in the Services, including in any reports or output obtained from the Services; (i) use or permit the Services to be used for any illegal or misleading purpose; or (j) establish an account on the Services as an individual for personal, family, or household purposes."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Compliance. Customer and its End Users must use the Services in compliance with the Acceptable Use Policy. Customer will comply with laws and regulations applicable to Customer's use of the Services. Customer will not take any action that would cause Diligentsia to violate EU Data Protection Laws, the U.S. Foreign Corrupt Practices Act of 1977, as amended, the U.K. Bribery Act of 2010, or any other applicable data protection, anti-bribery, anti-corruption, or anti-money laundering law. Customer must satisfy itself that: (i) the Services are appropriate for its purposes, taking into account the nature of the Customer Data; and (ii) the technical and organizational requirements applicable to Diligentsia under EU Data Protection Laws or other data protection laws, if applicable, are satisfied by the Security Measures and the Agreement."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "HIPAA. If Customer will store, transmit or otherwise process any information via the Services that falls within the definition of \u201CProtected Health Information\u201D under the HIPAA Privacy Rule (45 C.F.R. Section 164.051), Customer must separately enter into a HIPAA Business Associate Agreement with Diligentsia prior to storing, transmitting, or otherwise processing this information. NOTWITHSTANDING THE FOREGOING, NOT ALL SERVICES OFFERED BY DILIGENTSIA ARE DESIGNED FOR PROCESSING PROTECTED HEALTH INFORMATION. IF CUSTOMER USES A SERVICE THAT IS NOT DESIGNED FOR PROCESSING PROTECTED HEALTH INFORMATION OR HAS NOT ENTERED INTO THE HIPAA BUSINESS ASSOCIATE AGREEMENT, CUSTOMER MAY NOT USE THE SERVICES TO STORE, TRANSMIT, OR PROCESS THIS INFORMATION."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Third-Party Apps and Integrations. If Customer uses any third-party service or applications, such as a service that uses a Diligentsia API, with the Services: (a) Diligentsia will not be responsible for any act or omission of the third-party, including the third-party\u2019s access to or use of Customer Data; and (b) Diligentsia does not warrant or support any service provided by the third-party. Customer will comply with any API limits associated with the Services plan purchased by Customer."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Customer Data."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Customer Data Use. This Agreement constitutes Customer\u2019s instructions to Diligentsia to Process Customer Data. Diligentsia, Diligentsia personnel and its Subcontractors will only Process, access, use, store, and transfer Customer Data as Customer instructs in order to deliver the Services and to fulfill Diligentsia\u2019s obligations in the Agreement. If Customer accesses or uses multiple Services, Customer acknowledges and agrees that Diligentsia may transfer Customer Data between those Services and third parties where the Customer has agreed to do so. The categories of Personal Data to be processed by Diligentsia and the processing activities to be performed under this Agreement are set out in the Data Processing Agreement. Diligentsia will inform Customer of any legal requirement which prevents it from complying with Customer\u2019s instructions, unless prohibited from doing so by applicable law or on important grounds of public interest. Any Diligentsia personnel who have access to Customer Data will be bound by appropriate confidentiality obligations."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Security Measures. Diligentsia will use industry standard technical and organizational Security Measures to transfer, store, and Process Customer Data. Customers can find additional information regarding Diligentsia\u2019s security practices for the applicable Services by reviewing any applicable Security Resources. Diligentsia may update the Security Measures from time to time. Diligentsia will provide Customer with at least thirty days prior notice if Diligentsia updates the Security Measures in a manner that materially diminishes the administrative, technical, or physical security features of the Services taken as a whole. Within five business days of receipt of this notice, Customer may elect to terminate the Agreement and associated Order Forms by providing written notice to Diligentsia."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Third-Party Requests."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Customer Responsibility. Customer is responsible for responding to Third-Party Requests via its own access to information. Customer will seek to obtain information required to respond to Third-Party Requests and will contact Diligentsia only if it cannot comply with the Third-Party Request despite diligent efforts."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Diligentsia Responsibility. If Diligentsia receives a Third-Party Request, Diligentsia will make commercially reasonable efforts, to the extent allowed by law and by the terms of the Third-Party Request, to: (i) promptly notify Customer of Diligentsia's receipt of a Third-Party Request; (ii) comply with Customer's commercially reasonable requests regarding its efforts to oppose a Third-Party Request; and (iii) provide Customer with information or tools required for Customer to respond to the Third-Party Request, if Customer is otherwise unable to respond to the Third-Party Request. If Diligentsia is prohibited from notifying Customer of a Third-Party Request or Customer fails to promptly respond to any Third-Party Request, then Diligentsia may, but will not be obligated to do so, to the extent permitted by applicable law."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Customer Data Sharing. The Services may enable End Users to share Customer Data, including to other Customer End Users and to third parties. Recipients of shared Customer Data may access, view, download, and share this Customer Data, including in and through their own Services accounts. Customer understands: (a) it is solely Customer\u2019s, and its End Users\u2019, choice to share Customer Data; (b) Diligentsia cannot control third parties with whom Customer has shared Customer Data; and (c) Customer and its End Users are solely responsible for their use of the Services, including any sharing of Customer Data through the Services. Certain Account Data such as End Users\u2019 names, profile pictures, or contact information may be viewable by other customers and users with whom End Users collaborate and by the entity that has authority to control a corporate email domain if you purchase the Services using an email address on that domain."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "We need Customer\u2019s permission to do things like hosting Customer Data, backing it up and sharing it when Customer asks us to. It includes our setting up a Diligentsia corporate folder and sub-folders within one or more of Customer\u2019s third party cloud repositories, such as Sharepoint, Google Drive or Diligentsia.  Customer authorises us to upload Customer Data to our Diligentsia databases and platform more generally.  Diligentsia may also provide Customer with features like commenting, sharing, searching, image thumbnails, document previews, optical character recognition (OCR), easy sorting and organisation and personalisation to help reduce busywork. To provide these and other features, Diligentsia accesses, uploads, stores and scans Customer Data within its own databases. Customer gives us permission to do those things, and this permission extends to Diligentsia affiliates and trusted third parties Diligentsia works with.  In particular, unless Customer opts out, Diligentsia is free to share Customer\u2019s Customer Data with Customer\u2019s accountants, lawyers, other advisors and investors where Customer has been introduced by one or more of those organisations as their client or portfolio company.  Where Customer enters additional information directly into the Diligentsia folder within Customer\u2019s cloud storage, Customer authorise us to synch that folder with its corresponding copy held within the Diligentsia databases in Customer\u2019s name."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Data Transfer. Customer agrees that Diligentsia and its Subcontractors may transfer Customer Data to and access, use, and store Customer Data in locations other than Customer\u2019s country."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Aggregate/Anonymous Data. Customer agrees that Diligentsia will have the right to generate aggregate and anonymous data based on End Users\u2019 use of the Services and this data is owned by Diligentsia. Diligentsia may use this data for its business purposes during or after the term of this Agreement (including without limitation to develop and improve Diligentsia\u2019s products and services and to create and distribute reports and other materials, including anonymised benchmarking). For clarity, Diligentsia will not disclose any aggregate or anonymous data externally in a manner that could reasonably identify Customer or its End Users. Customer is not responsible for Diligentsia\u2019s use of aggregate or anonymous data."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Takedown Requests. If Customer receives any take down requests or infringement notices related to Customer Data, it must promptly: (i) stop using the related item with the Services; and (ii) notify Diligentsia. If Diligentsia receives any take down requests or infringement notices related to Customer Data, Diligentsia may respond in accordance with its policies, and will notify and consult with the Customer on next steps."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Data Processing Agreement. To the extent Customer Data comprises Personal Data that is processed by Diligentsia on Customer\u2019s behalf, Customer and Diligentsia agree to the Data Processing Agreement. The Data Processing Agreement applies only to the Servic and does not apply to Beta Services."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Confidential Information."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Use and Non-Disclosure. Except as expressly authorized herein, the Receiving Party will hold in confidence and not use or disclose any Confidential Information. Each Party, as the Receiving Party, will: (i) take reasonable measures to protect the Disclosing Party\u2019s Confidential Information including at least those measures it takes to protect its own confidential information of a similar nature; and (ii) not disclose Confidential Information to any third parties. A Party may disclose Confidential Information to its employees, advisors and consultants who have a need to know the Confidential Information, if that employee, advisor or consultant is bound to restrictions at least as protective of the other Party\u2019s Confidential Information as those set forth in this Agreement."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Exceptions. Confidential Information does not include information that: (i) is or becomes generally known or available to the public, through no act or omission of the Receiving Party; (ii) was known, without restriction, prior to receiving it from the disclosing Party; (iii) is rightfully acquired from a third party who has the right to disclose it and who provides it without restriction as to use or disclosure; (iv) or is independently developed without access to any Confidential Information of the Disclosing Party."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Permitted Disclosure. A Party may disclose Confidential Information to the extent required by any law or regulation if it gives the other Party reasonable advance notice, to the extent permitted, so that the other Party can seek to prevent or limit such disclosure. Notwithstanding the foregoing, the Parties\u2019 obligations with respect to Third Party Requests are specifically addressed in Section 4.4."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Remedies. The Receiving Party acknowledges that a disclosure of Confidential Information in violation of these terms would cause substantial harm for which damages alone would not be a sufficient remedy, and therefore that upon any such disclosure by the Receiving Party the Disclosing Party will be entitled to seek appropriate equitable relief in addition to whatever other remedies it might have at law."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Payment."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Fees. Customer will pay Diligentsia or Customer's reseller or Diligentsia\u2019s partner all applicable Fees, in the currency and pursuant to the payment terms indicated on the Order Form, or in the applicable agreement between Customer and Customer\u2019s reseller/Diligentsia\u2019s partner. Customer authorizes Diligentsia, or Customer's reseller/Diligentsia\u2019s Partner, to charge Customer for all applicable Fees using Customer's selected payment method, and Customer will issue the required purchasing documentation. Fees are non-refundable except as required by law or as otherwise specifically permitted in the Agreement."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Payment. Customer will pay Diligentsia invoices on the payment interval set forth in the Order Form. Diligentsia may suspend or terminate the Services if Fees are past due. Customer will provide complete and accurate billing and contact information to Diligentsia or to Customer's reseller/Diligentsia partner."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Taxes. Fees are exclusive of taxes and Customer is responsible for all Taxes. Diligentsia, or Customer's reseller/Diligentsia partner, will charge Taxes when required to do so. If Customer provides Diligentsia or its reseller or Diligentsia partner with a valid exemption certificate, Diligentsia will not collect the taxes covered by that certificate."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Withholding Taxes. Customer will pay Diligentsia or its reseller/Diligentsia partner net of any applicable Withholding Taxes. Customer and Diligentsia, or Customer's reseller/Diligentsia partner if applicable, will work together to avoid any Withholding Tax if exemptions, or a reduced treaty withholding rate, are available. If Diligentsia or Customer's reseller/ Diligentsia partner qualifies for a tax exemption, or a reduced treaty withholding rate, Diligentsia or Customer's reseller/Diligentsia partner will provide Customer with reasonable documentary proof. Customer will provide Diligentsia or Customer's reseller/Diligentsia partner reasonable evidence that it has paid the relevant authority for the sum withheld or deducted."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Auto-renewals and Trials. IF CUSTOMER HAS ALREADY PROVIDED A PAYMENT METHOD TO DILIGENTSIA OR CUSTOMER\u2019S RESELLER/DILIGENTSIA PARTNER FOR RECURRING CHARGES AND CUSTOMER\u2019S ACCOUNT IS SET TO AUTO-RENEWAL OR IS IN A TRIAL PERIOD, DILIGENTSIA (OR CUSTOMER\u2019S RESELLER/DILIGENTSIA PARTNER) MAY CHARGE AUTOMATICALLY AT THE END OF THE TRIAL OR FOR THE RENEWAL, UNLESS CUSTOMER NOTIFIES DILIGENTSIA (OR CUSTOMER\u2019S RESELLER/DILIGENTSIA PARTNER, AS APPLICABLE) THAT CUSTOMER WANTS TO DISABLE AUTO-RENEWAL OR CANCEL THE SERVICES IN ACCORDANCE WITH SECTION 2.2. Diligentsia may revise Services rates by providing the Customer at least thirty days' notice prior to the next charge."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Purchase Orders. If Customer requires the use of a purchase order or purchase order number, Customer: (i) must provide the purchase order number at the time of purchase; and (ii) agrees that any terms and conditions on a Customer purchase order will not apply to this Agreement and are null and void. If the Customer is purchasing via a reseller/Diligentsia partner, any terms and conditions from the Customer's reseller/Diligentsia partner or in a purchase order between the Customer and its reseller/Diligentsia partner that conflict with the Agreement are null and void."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "No Refunds. Subscription and usage or overage Fees are non-refundable and non-creditable, except where required by law. Diligentsia subscriptions may be cancelled, and such cancellations take effect at the end of your then-current subscription term (for example, if Customer is on a paid monthly subscription the cancellation will take effect the following month, but if Customer is on a paid yearly subscription the cancellation will take effect the following year)."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Suspension."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Of End User Accounts by Diligentsia. If an End User: (a) violates the Agreement; or (b) uses the Services in a manner that Diligentsia reasonably believes will cause it liability, then Diligentsia may request that Customer suspend or terminate the applicable End User account. If Customer fails to promptly suspend or terminate the End User account, then Diligentsia may do so."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Of the Services. Diligentsia may suspend Customer\u2019s access to the Services if: (i) Customer\u2019s account is overdue; or (ii) Customer has exceeded any Service Limits. Diligentsia may also suspend Customer\u2019s access to the Services or remove Customer Data if it determines that: (a) Customer has breached any portion of this Agreement, or (b) suspension is necessary to prevent a Security Emergency, provided that Diligentsia will make commercially reasonable efforts to narrowly tailor the suspension as needed to prevent or terminate the Security Emergency. Diligentsia will have no liability for taking action as permitted above. For the avoidance of doubt, Customer will remain responsible for payment of fees during any suspension period under this Section 7.2. However, unless this Agreement has been terminated, Diligentsia will cooperate with Customer to promptly restore access to the Services once it verifies that Customer has resolved the condition requiring suspension."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Intellectual Property Rights."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Reservation of Rights. Except as expressly set forth herein, the Agreement does not grant: (a) Diligentsia any Intellectual Property Rights in Customer Data; or (b) Customer any Intellectual Property Rights in the Services or Diligentsia trademarks and brand features. Customer acknowledges that it is obtaining only a limited right to use the Services and that irrespective of any use of the words \u201Cpurchase\u201D, \u201Csale\u201D or similar terms, no ownership rights are transferred to Customer (or its End Users) under this Agreement."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Limited Permission. Customer grants Diligentsia only the limited rights that are reasonably necessary for Diligentsia to deliver the Services. This limited permission also extends to Subcontractors or Sub-processors and Diligentsia Partners."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Feedback. Diligentsia may use, modify, and incorporate into its products and services, license and sublicense, any Feedback that Customer or End Users may provide without any obligation to Customer. Customer agrees to: (i) and hereby does, assign to Diligentsia all right, title, and interest in any Feedback; and (ii) provide Diligentsia any reasonable assistance necessary to document and maintain Diligentsia\u2019s rights in the Feedback."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Term & Termination."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Agreement Term. The Agreement will remain in effect for the Term."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Termination. Either Party may terminate the Agreement, including all Order Forms, if: (i) the other Party is in material breach of the Agreement and fails to cure that breach within thirty days after receipt of written notice; or (ii) the other Party ceases its business operations or becomes subject to insolvency proceedings and the proceedings are not dismissed within ninety days. Diligentsia may terminate this Agreement and suspend Customer\u2019s access to the Services if required to do so by law or for an egregious violation by Customer of the Acceptable Use Policy."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Effects of Termination. If the Agreement terminates: (a) except as set forth in this Section, the rights and licenses granted by Diligentsia to Customer will cease immediately; (b) Customer will delete (or, at Diligentsia\u2019s request, return) any and all copies of any Diligentsia code, documentation, passwords or access codes, and any other Diligentsia Confidential Information in Customer\u2019s possession, custody, or control; (c) Customer may, prior to termination, request reasonable additional time to export its Stored Data, provided that Diligentsia may charge Customer for this extended access based on Diligentsia\u2019s then-current standard fees; and (d) Diligentsia will delete any End User Accounts and Stored Data in Customer\u2019s account in a commercially reasonable period of time following receipt of an Administrator\u2019s request to do so prior to termination of the Services. Diligentsia may make instructions available to Customer regarding how to submit the Administrator request described in clause (d) of the previous sentence and Customer is responsible for following these instructions to initiate a deletion."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Survival. The following sections will survive expiration or termination of the Agreement: 4.4 (Third Party Requests), 6.2 (Payment), 8 (Intellectual Property Rights), 9.3 (Effects of Termination), 9.4 (Survival), 10 (Indemnification), 11 (Disclaimers), 12 (Limitation of Liability), 13 (Disputes), and 14 (Miscellaneous). Notwithstanding the foregoing, Section 4.4 (Third-Party Requests) shall not survive termination if Diligentsia has exercised a right to terminate the Agreement."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Indemnification."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "By Customer. Customer will indemnify, defend, and hold harmless Diligentsia from and against all liabilities, damages, and costs (including settlement costs and reasonable attorneys\u2019 fees) arising out of any Claim against Diligentsia and its Affiliates regarding: (a) Customer Data; (b) Customer Domains; (c) Customer\u2019s or Customer\u2019s End Users\u2019 use of the Services in violation of the Agreement; (d) Customer\u2019s professional advisors or investors or similar third parties."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "By Diligentsia. Diligentsia will indemnify, defend, and hold harmless Customer from and against all liabilities, damages, and costs (including settlement costs and reasonable attorneys' fees) arising out of any Claim against Customer to the extent based on an allegation that Diligentsia's technology used to deliver the Services to the Customer infringes or misappropriates any copyright, trade secret, UK patent, or trademark right of the third party. In no event will Diligentsia have any obligations or liability under this section arising from: (a) use of any Services in a modified form or in combination with materials not furnished by Diligentsia; and (b) any content, information, or data provided by Customer, End Users, or other third parties."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Possible Infringement. If Diligentsia believes the Services or Software infringe or may be alleged to infringe a third party's Intellectual Property Rights, then Diligentsia may: (a) obtain the right for Customer, at Diligentsia's expense, to continue using the Services or Software; (b) provide a non-infringing functionally equivalent replacement; or (c) modify the Services or Software so that they no longer infringe. If Diligentsia does not believe the options described in this section are commercially reasonable, then Diligentsia may suspend or terminate Customer's use of the affected Services or Software, with a pro-rata refund of prepaid fees for the Services or Software."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "General. The Party seeking indemnification will promptly notify the other Party of the claim and cooperate with the other Party in defending the claim. The indemnifying Party will have full control and authority over the defence, except that: (a) any settlement requiring the Party seeking indemnification to admit liability requires prior written consent, not to be unreasonably withheld or delayed; and (b) the other Party may join in the defence with its own counsel at its own expense. THE INDEMNITIES ABOVE ARE DILIGENTSIA AND CUSTOMER'S ONLY REMEDY UNDER THE AGREEMENT FOR VIOLATION BY THE OTHER PARTY OF A THIRD PARTY'S INTELLECTUAL PROPERTY RIGHTS."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Disclaimers."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Generally. THE SERVICES, SOFTWARE, AND ANY RELATED DOCUMENTATION ARE PROVIDED \u201CAS IS\u201D AND ON AN \u201CAS AVAILABLE\u201D BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, EXCEPT AS EXPRESSLY STATED IN THE AGREEMENT, DILIGENTSIA AND ITS PARTNERS,AFFILIATES, SUPPLIERS, AND DISTRIBUTORS MAKE NO WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR USE, OR NON-INFRINGEMENT. DILIGENTSIA MAKES NO REPRESENTATION, WARRANTY OR GUARANTEE THAT SERVICES WILL MEET CUSTOMER\u2019S REQUIREMENTS OR EXPECTATIONS, THAT CUSTOMER DATA WILL BE ACCURATE, COMPLETE, OR PRESERVED WITHOUT LOSS, OR THAT THE SERVICES WILL BE TIMELY, UNINTERRUPTED OR ERROR-FREE. DILIGENTSIA WILL NOT BE RESPONSIBLE OR LIABLE IN ANY MANNER FOR ANY CUSTOMER PROPERTIES, CUSTOMER DATA, THIRD-PARTY PRODUCTS, THIRD-PARTY CONTENT, OR NON-DILIGENTSIA SERVICES (INCLUDING FOR ANY DELAYS, INTERRUPTIONS, TRANSMISSION ERRORS, SECURITY FAILURES, AND OTHER PROBLEMS CAUSED BY THESE ITEMS). CUSTOMER IS RESPONSIBLE FOR USING THE SERVICES OR SOFTWARE IN ACCORDANCE WITH THE TERMS SET FORTH HEREIN AND BACKING UP ANY STORED DATA ON THE SERVICES."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Beta Services."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Use In Customer's Discretion. Despite anything to the contrary in the Agreement: (a) Customer may choose to use Beta Services in its sole discretion; (b) Beta Services may not be supported and may be changed at any time without notice; (c) Beta Services may not be as reliable or available as the Services; (d) Beta Services have not been subjected to the same Security Measures and auditing to which the Services have been subjected; and (e) DILIGENTSIA WILL HAVE NO LIABILITY ARISING OUT OF OR IN CONNECTION WITH BETA SERVICES - USE AT YOUR OWN RISK."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Feedback. Diligentsia offers Beta Services in order to get user feedback. In exchange for using Beta Services, Customer agrees that Diligentsia may contact Customer and its End Users to obtain Feedback regarding Beta Services."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Confidential. Beta Services are confidential until officially launched by Diligentsia and Customer will treat the Beta Services, and any documentation, specifications, or instructions related the Beta Services, as Confidential Information of Diligentsia."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Limitation of Liability."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Limitation on Indirect Liability. TO THE FULLEST EXTENT PERMITTED BY LAW, EXCEPT FOR DILIGENTSIA OR CUSTOMER'S INDEMNIFICATION OBLIGATIONS, NEITHER CUSTOMER NOR DILIGENTSIA AND ITS AFFILIATES, SUPPLIERS, AND DISTRIBUTORS WILL BE LIABLE UNDER THE AGREEMENT FOR (I) INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR (II) LOSS OF USE, DATA, BUSINESS, REVENUES, OR PROFITS (IN EACH CASE WHETHER DIRECT OR INDIRECT), EVEN IF THE PARTY KNEW OR SHOULD HAVE KNOWN THAT SUCH DAMAGES WERE POSSIBLE AND EVEN IF A REMEDY FAILS OF ITS ESSENTIAL PURPOSE."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Limitation on Amount of Liability. TO THE FULLEST EXTENT PERMITTED BY LAW, DILIGENTSIA\u2019S AGGREGATE LIABILITY UNDER THE AGREEMENT WILL NOT EXCEED THE LESSER OF $100,000 OR THE AMOUNT PAID BY CUSTOMER TO DILIGENTSIA HEREUNDER DURING THE TWELVE MONTHS PRIOR TO THE EVENT GIVING RISE TO LIABILITY. FOR FREE ACCESS SUBSCRIPTIONS, TRIALS, OR BETA SERVICES, DILIGENTSIA\u2019S TOTAL LIABILITY WILL NOT EXCEED, IN AGGREGATE, FIFTY POUNDS STERLING (\xa350)."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Failure of Essential Purpose. EACH PARTY ACKNOWLEDGES AND AGREES THAT THIS SECTION 12 IS A FUNDAMENTAL BASIS OF THE BARGAIN AND A REASONABLE ALLOCATION OF RISK BETWEEN THE PARTIES AND WILL SURVIVE AND APPLY TO ANY CLAIMS ARISING OUT OF OR RELATED TO THIS AGREEMENT, ANY DILIGENTSIA SERVICES OR ANY RELATED SERVICES, REGARDLESS OF THE THEORY OF LIABILITY (CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE), EVEN IF ANY LIMITED REMEDY IN THIS AGREEMENT IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Disputes."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Informal Resolution. Before filing a claim, each Party agrees to try to resolve the dispute by contacting the other Party through the notice procedures in Section 14.6. If a dispute is not resolved within thirty days of notice, Customer or Diligentsia may bring a formal proceeding."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Arbitration. Customer and Diligentsia agree to resolve any claims relating to the Agreement or the Services through final and binding arbitration, except as set forth below. This includes disputes arising out of or relating to the interpretation or application of this \u201CArbitration\u201D subsection, including its scope, enforceability, revocability, or validity. The UK Chartered Institute of Arbitrators (CIArb) will administer the arbitration under its Commercial Arbitration Rules. The arbitration will be held in London, UK, or any other location both parties agree to in writing. The arbitrator may award relief only individually and only to the extent necessary to redress Customer\u2019s or Diligentsia\u2019s individual claim(s); the arbitrator may not award relief on behalf of others or the general public. Diligentsia\u2019s past, present and future affiliates, partners and agents may invoke their rights under this \u201CDisputes\u201D Section in the event they become involved in a dispute with Customer; otherwise, these Terms do not give rights to any third parties."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Exception to Arbitration. Either Party may bring a lawsuit in courts of England & Wales solely for injunctive relief to stop unauthorized use or abuse of the Services or infringement of Intellectual Property Rights without first engaging in the informal dispute notice process described above. Both Customer and Diligentsia consent to venue and personal jurisdiction in the UK."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "NO CLASS ACTIONS. Customer may only resolve disputes with Diligentsia on an individual basis and will not bring a claim in a class, consolidated or representative action. Class arbitrations, class actions, private attorney general actions and consolidation with other arbitrations are not allowed."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Severability. If any part of this \u201CDisputes\u201D section is found to be illegal or unenforceable, the remainder will remain in effect, except that if a finding of partial illegality or unenforceability would allow class or representative arbitration, this \u201CDisputes\u201D section will be unenforceable in its entirety. If Customer is found to have a non-waivable right to bring a particular claim or to request a particular form of relief that the arbitrator lacks authority to redress or award according to this \u201CDisputes\u201D section, then only that respective claim or request for relief may be brought in court, and Customer and Diligentsia agree that litigation of any such claim or request for relief shall be stayed pending the resolution of any individual claim(s) or request(s) for relief in arbitration."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Miscellaneous."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Terms Modification. Diligentsia may revise this Agreement from time to time and the most current version will always be posted on the Diligentsia website. If a revision, in Diligentsia's sole discretion, is material, Diligentsia will notify Customer (by, for example, sending an email to the email address associated with the applicable account). Other revisions may be posted to Diligentsia's blog or terms page, and Customer is responsible for checking these postings regularly. By continuing to access or use the Services after revisions become effective, Customer agrees to be bound by the revised Agreement. If Customer does not agree to the revised Agreement terms, Customer may terminate the Services within thirty days of receiving notice of the change."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Entire Agreement. The Agreement supersedes any prior agreements or understandings between the Parties and constitutes the entire agreement between the Parties related to this subject matter. The Service-Specific Terms, the Data Processing Agreement, Customer invoices, and the Order Forms executed by the Parties, are hereby incorporated into the Agreement by this reference."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Interpretation of Conflicting Terms. If there is a conflict between the documents that make up the Agreement, the documents will control in the following order: the invoice, the Service-Specific Terms, Order Form, the DSA. The terms and conditions of the Agreement will be considered Confidential Information of Diligentsia. Customer agrees that any terms and conditions on a Customer purchase order will not apply to the Agreement and are null and void. If End Users are required to click through terms of service in order to use the Services, those click through terms are subordinate to this Agreement and the Agreement will control if there is a conflict."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Governing Law. THE AGREEMENT WILL BE GOVERNED BY UK LAW."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Severability. Unenforceable provisions will be modified to reflect the parties' intention and only to the extent necessary to make them enforceable, and the remaining provisions of the Agreement will remain in full effect."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Notice. Notices must be sent via email, first class, airmail, or overnight courier and are deemed given when received. Notices to Customer may also be sent to the applicable account email address and are deemed given when sent. Notices to Diligentsia must be sent to Diligentsia Legal at\xa0privacy@Diligentsia.co.uk, with a copy to Diligentsia Limited, The Old Rectory, Nock Verges, Stoney Stanton, Leicestershire, LE9 4LR, UKP.O. Box 77767, attn.: Legal Department."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Waiver. A waiver of any default is not a waiver of any subsequent default."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Assignment. Customer may not assign or transfer the Agreement or any rights or obligations under the Agreement without the written consent of Diligentsia, except that Customer may assign the Agreement to the surviving entity in connection with a merger, acquisition, or sale of all or substantially all of its assets by providing written notice to Diligentsia. Diligentsia may not assign the Agreement without providing notice to Customer, except Diligentsia may assign the Agreement or any rights or obligations under the Agreement to an Affiliate or in connection with a merger, acquisition, corporate reorganization, or sale of all or substantially all of its assets without providing notice. Any other attempt to transfer or assign is void."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "No Agency. Diligentsia and Customer are not legal partners or agents but are independent contractors."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Subcontracting. Customer consents to Diligentsia\u2019s appointment of Subcontractors, including Sub-processors, to perform the Services. Diligentsia will remain liable for all acts or omissions of its Subcontractors or Sub-processors, and for any subcontracted obligations."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Force Majeure. Except for payment obligations, neither Diligentsia nor Customer will be liable for inadequate performance to the extent caused by a condition that was beyond the Party's reasonable control (for example, natural disaster, act of war or terrorism, riot, labour condition, governmental action, and Internet disturbance)."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "No Third-Party Beneficiaries. There are no third-party beneficiaries to the Agreement. Without limiting this section, a Customer's End Users are not third-party beneficiaries to Customer's rights under the Agreement."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Definitions."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Acceptable Use Policy" means the acceptable use policy set forth at the following link, or other link Diligentsia may provide:\xa0https://www.Diligentsia.co.uk/acceptable_use.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Account Data" means the account and contact information submitted to the Services by Customer or End Users.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Add-On(s)" means an additional feature, component, service, or functionality that can be separately purchased or provisioned for use with certain Services.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Administrator" means a Customer-designated technical End User who administers the Services to End Users on Customer\'s behalf, through multiple tiers.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Admin Account" means an administrative account provided to Customer by Diligentsia for the purpose of administering the Services.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Admin Console" means the online tool provided by Diligentsia to Customer for use in administering the Services.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Affiliate" means any entity that controls, is controlled by or is under common control with a Party, where "control" means the ability to direct the management and policies of an entity.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Agreement" means, collectively, this\xa0DSA, each applicable Order Form, the Data Processing Agreement and, if applicable, the HIPAA Business Associate Agreement and any Service-Specific Terms entered into by the Parties.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Audit Reports" means the audit reports for the applicable Services that are set forth in the Service-Specific Terms.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Beta Services" means services or features identified as alpha, beta, preview, early access, MVP, or evaluation, or words or phrases with similar meanings.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Claim" means a claim by a third party, including a regulatory penalty.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Confidential Information" means information disclosed by one Party to the other Party that is identified as confidential at the time of disclosure or should be reasonably known by the Receiving Party to be Confidential Information due to the nature of the information disclosed and the circumstances surrounding the disclosure. Any performance information relating to the Service and the terms and conditions of this Agreement shall be deemed Confidential Information of Diligentsia without any marking or further designation.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Customer Data" means Stored Data, Account Data, and messages, comments, structured data, images, and other content submitted to the Services by Customer or End Users.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Customer Domains" means Customer\'s Internet domain names.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Data Processing Agreement" means the data processing agreement set forth at the following link:\xa0https://assets.Diligentsia.co.uk/documents/en/legal/dfb-data-processing-agreement.pdf\xa0or other link that Diligentsia may provide.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Disclosing Party" means the Party disclosing Confidential Information to the other Party.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"EEA" means European Economic Area.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Effective Date" means the date this\xa0DSA\xa0is entered into by the Parties, either by acceptance online or by the signing of an Order Form.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"End Users" means users of Customer\u2019s Services account. End Users may include Customer\u2019s and its Affiliate\u2019s employees, consultants, agents, representatives, students or any other person authorized by Customer to use the Services through Customer\u2019s account.  This also includes the Customer\u2019s lawyers, accountants, investors and other similar advisors.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"End User Account" means a Diligentsia hosted account provisioned by Customer through the Services for an End User or advisor.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"End User License" means a user license purchased by Customer which enables Customer to provision an End User Account.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"EU Data Protection Laws" means, to the extent in force and applicable from time to time, those laws implementing the EU General Data Protection Regulation (2016/679) and any implementing laws in each EU member state.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Export Control Laws" means all applicable export and re-export control laws and regulations, including the Export Administration Regulations ("EAR") maintained by the U.S. Department of Commerce, trade and economic sanctions maintained by the Treasury Department\'s Office of Foreign Assets Control, and the International Traffic in Arms Regulations ("ITAR") maintained by the Department of State.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Feedback" means any feedback, comments, or suggestions on the Services or Beta Services that Customer or End Users may send Diligentsia or post in Diligentsia\u2019s forums. Feedback may include oral or written comments, suggestions, error reports, and analysis.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Fees" means the amounts invoiced to Customer by Diligentsia.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"HIPAA Business Associate Agreement" means an agreement between Customer and Diligentsia detailing each Party\'s obligations regarding "Protected Health Information" under the HIPAA Privacy Rule (45 C.F.R. Section 164.051).'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Initial Services Term" means the term for the applicable Services beginning on the Provisioning Date and continuing for the duration set forth on the Order Form.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Intellectual Property Rights" means current and future worldwide rights under patent, copyright, trade secret, trademark, moral rights, and other similar rights.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Order Form" means an ordering document, order page, or user interface through which Customer purchases a subscription to the Services or enables access to the Services.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Personal Data, "Process," and "Processing"" have the meaning given to those terms in the EU Data Protection Laws.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Provisioning Date" is the date upon which Diligentsia makes the Services available to Customer.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Receiving Party" means the Party receiving Confidential Information from the other Party.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Renewal Term" means, unless otherwise agreed to in writing by the Parties, the renewal term of the same duration as the Initial Services Term or preceding Renewal Term.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Security Emergency" means: (i) use of the Services that does or could disrupt the Services, other customers\' use of the Services, or the infrastructure used to deliver the Services; or (ii) unauthorized third-party access to the Services.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Security Measures" means the technical and organizational security measures implemented by Diligentsia for the applicable Services, as may be further described in the Service-Specific Terms.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Security Resources" means any webpages, resources, guides, and whitepapers regarding technical or organizational measures that Diligentsia has implemented for the applicable Services that are described in the Service-Specific Terms.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Services" means the services ordered by Customer on the Order Form, excluding any third-party Add-Ons (as indicated at the time of purchase or enablement).'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Service-Specific Terms" means additional terms that apply to certain Services or Add-Ons as set forth in Appendix 2 or otherwise attached to an Order Form.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Services Term" means the Initial Services Term and all Renewal Terms for the applicable Services.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Service Limits" means rate, storage, End User or other limits on Customers use of the Services as described in the applicable Order Form or product description page.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Software" means the client software provided as part of the Services, either directly by Diligentsia or through third party distribution channels such as app stores.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Stored Data" means the files uploaded to the Services by Customer or End Users.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Subcontractor" means an entity to whom Diligentsia subcontracts any of its obligations under the Agreement.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Sub-processor" means an entity who agrees to Process Customer Data on Diligentsia\'s behalf, or on behalf of another Diligentsia sub-processor, in order to deliver the Services.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Taxes" means any sales, use, value added, goods and services, consumption, excise, local stamp, or other tax, (including but not limited to ISS, CIDE, PIS, CONFINS), duty or other charge of any kind or nature excluding tax that is based on Diligentsia\'s net income, associated with the Services or Software, including any related penalties or interest.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: '"Term" means the term of the Agreement, which will begin on the Effective Date and continue until the earlier of: (i) the end of all applicable Services Terms; or (ii) the Agreement is terminated as set forth herein.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "\"Third-Party Request\" means a request from a third-party for records relating to an End User's use of the Services including information in or from an End User Account, or from Customer's Services account. Third-Party Requests may include valid search warrants, court orders, or subpoenas, or any other request for which there is written consent from End Users, or an End User's authorized representative, permitting a disclosure."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "\"Withholding Taxes\" mean any income taxes that are imposed on Diligentsia or Customer's reseller in which Customer is required by law to withhold or deduct on the payment to Diligentsia or Customer's reseller."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Appendix 1"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia Entities"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "The Agreement will be between Customer and the following Diligentsia entities, as applicable"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia Limited, a company registered in England & Wales under company number 14256673"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Appendix 2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Service Specific Terms"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Posted: October 25, 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Effective: October 25, 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "These Service-Specific Terms set forth additional terms and conditions that are specific to the Services listed below."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia may update these Service-Specific Terms from time to time, including to add additional Service-Specific Terms for new Services made available by Diligentsia, by posting an updated version. If an update materially changes any Service-Specific Terms for any Services already purchased by Customer, Diligentsia will notify Customer in accordance with Section 14.1 of the DSA."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia Free, Lite, Pro, Pro PLUS, Portfolio Pro & Expansion Packs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Service Description. The Diligentsia Free, Lite, Pro, Pro PLUS, Portfolio Pro & Expansion Packs services are described at\xa0https://www.Diligentsia.co.uk/plans\xa0or other link that Diligentsia may provide. The Diligentsia Education services are described at\xa0https://www.Diligentsia.com/education."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Security & Audits."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Security Measures. The Security Measures for these Services are described at\xa0https://assets.Diligentsia.co.uk/documents/en/legal/security-measures.pdf\xa0or other link that Diligentsia may provide."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Customer Domains. Prior to providing the Services, Diligentsia may require Customer to verify that Customer owns or controls the Customer Domains. If Customer does not own or control the Customer Domains, then Diligentsia will have no obligation to provide Customer with the Services."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "forIndividuals",
                                wrapperClass: "tac",
                                subheading: "For Individuals"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia Terms & Conditions of Service"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Effective: 30th June 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Thanks for using Diligentsia! Our mission is to create a more enlightened way of working by providing an intuitive, unified platform to keep your content safe and accessible while helping you and those you work with stay coordinated and in sync. These terms of service (\u2018Terms\u2019) cover your use and access to our services, client software and websites (\u2018Services\u2019). Your agreement is with Diligentsia Limited, a UK company number registered in England & Wales under registration number 14256673. Our\xa0Privacy Policy\xa0explains how we collect and use your information while our\xa0Acceptable Use Policy\xa0outlines your responsibilities when using our Services. By using our Services, you\u2019re agreeing to be bound by these Terms, our\xa0Privacy Policy\xa0and\xa0Acceptable Use Policy."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Your Stuff & Your Permissions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "When you use our Services, your organisation provide us with things like your files, content, messages, contacts and so on (\u201CYour Stuff\u201D). Your Stuff belongs to your business. These Terms don\u2019t give us any rights to Your Stuff except for the limited rights that enable us to offer the Services.  "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We need your permission to do things like hosting Your Stuff, backing it up and sharing it when you ask us to. It includes our setting up a Diligentsia corporate folder and sub-folders within one or more of your organisation\u2019s third party cloud repositories, such as Sharepoint, Google Drive or Diligentsia.  You authorise us to upload Our Services to our Diligentsia databases and platform more generally.  We may also provide you with features like commenting, sharing, searching, image thumbnails, document previews, optical character recognition (OCR), easy sorting and organisation and personalisation to help reduce busywork. To provide these and other features, Diligentsia accesses, uploads, stores and scans Your Stuff within its own databases. You give us permission to do those things, and this permission extends to our affiliates and trusted third parties we work with.  In particular, unless you opt out, we are free to share your information with your accountants, lawyers, investors where you have been introduced by one or more of those organisations as their client or portfolio company.  Where you enter additional information directly into the Diligentsia folder within your cloud storage, you authorise us to synch that folder with its corresponding copy held within the Diligentsia databases in your organisation\u2019s name."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "You authorise us to undertake data analytics on the information your organisation uploads to, and synch\u2019s with, the Diligentsia folder.  We may utilise that information on an anonymised basis both to improve our and to provide additional services to you, either directly or through trusted third parties we work with, provided that you will authorise those third parties."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Your Responsibilities"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Your organisation\u2019s use of our Services must comply with our\xa0Acceptable Use Policy. Content in the Services may be protected by others\u2019 intellectual property rights. Please don\u2019t copy, upload, download or share content unless you have the right to do so."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia may review your organisation\u2019s conduct and content for compliance with these Terms and our\xa0Acceptable Use Policy. We are not responsible for the content people post and share via the Services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Help us keep Your Stuff protected. Safeguard your organisation\u2019s employees\u2019 passwords to the Services, and keep your organisation\u2019s account information current. Don\u2019t share your account credentials or give others access to your account."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "You may use our Services only as permitted by applicable law, including export control laws and regulations. Finally, to use our Services you must be aged over 18. If the law where you reside requires that you must be older in order for Diligentsia to lawfully provide the Services to you without parental consent (including use of your personal data), then you must be that older age."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Software"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Some of our Services and those provided by our partners allow you to download client software (\u201CSoftware\u201D) which may be updated automatically. As long as you comply with these Terms, we and they give you a limited, non-exclusive, non-transferable, revocable licence to use the Software, solely to access the Services. To the extent any component of the Software may be offered under an open source licence, we\u2019ll make that licence available to you and the provisions of that licence may expressly override some of these Terms. Unless the following restrictions are prohibited by law, you agree not to reverse engineer or decompile the Services, attempt to do so or assist anyone to do so."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Beta Services"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We sometimes release products and features that we\u2019re still testing and evaluating (\u2018Beta Services\u2019). Beta Services are labelled \u2018alpha\u2019, \u2018beta\u2019, \u2018preview\u2019, \u2018early access\u2019, \u2018evaluation\u2019 or \u201CMVP\u201D (or with words or phrases with similar meanings) and may not be as reliable as Diligentsia\u2019s other services. Beta Services are made available so that we can collect user feedback, and by using our Beta Services, you agree that we may contact you to collect such feedback."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Beta Services are confidential until official launch. If you use any Beta Services, you agree not to disclose any information about those Services to anyone else without our permission."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Additional Features"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "From time to time, Diligentsia will add additional features to enhance the user experience of our services at no additional charge. However, these free features may be withdrawn without further notice."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Our Stuff"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "The Services are protected by copyright, trademark, and other UK and foreign laws. These Terms don\u2019t grant you any right, title or interest in the Services, others\u2019 content in the Services, Diligentsia trademarks, logos and other brand features. We welcome feedback, but please note that we may use comments or suggestions without any obligation to you."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Copyright"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We respond to notices of alleged copyright infringement if they comply with the law, and such notices should be reported using our\xa0Copyright Policy. We reserve the right to delete or disable content alleged to be infringing and terminate accounts of repeat infringers. Our designated agent for notice of alleged copyright infringement on the Services is"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "The CEO"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia Limited"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "The Old Rectory"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Nock Verges, Stoney Stanton LE9 $LR UK"
                            }),
                            "copyright@Diligentsia.com",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Paid Accounts"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Billing.\xa0You can change plans and/or add paid features to your account (turning your account into a \u2018Paid Account\u2019). We\u2019ll automatically bill you from the date you convert to a Paid Account and on each periodic renewal until cancellation. If you\u2019re on an annual plan, we\u2019ll send you a notice email reminding you that your plan is about to renew within a reasonable period of time prior to the renewal date. You\u2019re responsible for all applicable taxes, and we\u2019ll charge tax when required to do so. Some countries have mandatory local laws regarding your cancellation rights, and this paragraph doesn\u2019t override these laws."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Cancellation.\xa0You may cancel your\xa0account\xa0at any time. Refunds are only issued if required by law. For example, users living in the European Union have the right to cancel their Paid Account subscriptions within 14 days of signing up for, upgrading to or renewing a Paid Account by clicking\xa0here.  Upon your account being cancelled, Diligentsia has the right to suspend the provision of its Services with immediate effect.  This may mean that some or all of your Stuff may be unavailable within the Diligentsia platform or Diligentsia folder within your cloud platform.  You will be warned of this via an email prior to our taking such action. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Downgrades.\xa0Your Paid Account will remain in effect until cancelled or terminated under these Terms If you don\u2019t pay for your Paid Account on time, we reserve the right to suspend it or remove Paid Account features."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Changes.\xa0We may change the fees in effect on renewal of your subscription, to reflect factors such as changes to our product offerings, changes to our business or changes in economic conditions. We\u2019ll give you no less than 30 days\u2019 advance notice of these changes via a message to the email address associated with your account and you\u2019ll have the opportunity to cancel your subscription before the new fee comes into effect."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia Business Teams"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Using Diligentsia Business Teams.\xa0If your organisation signs up to Diligentsia and uses our Services, you must use them in compliance with your organisation\u2019s terms and policies. Please note that Diligentsia accounts are subject to your organisation's control. Your administrators may be able to access, disclose, restrict or remove information in or from your Diligentsia account. They may also be able to restrict or terminate your access to a Diligentsia account. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Termination"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Your organisation is free to stop using our Services at any time. We reserve the right to suspend or terminate your access to the Services with notice to you if"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Your organisation or any employee is in breach of these Terms,"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Your organisation\u2019s use of the Services would cause a real risk of harm or loss to us or other users, or"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Your organisation hasn't accessed our Services for 12 consecutive months."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Your organisation has ceased to pay for the relevant Services."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We\u2019ll provide you with reasonable advance notice via the email address associated with your account to remedy the activity that prompted us to contact you and give you the opportunity to export Your Stuff from our Services. If after such notice you fail to take the steps we ask of you, we\u2019ll terminate or suspend your access to the Services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We won\u2019t provide notice or an opportunity to export Your Stuff before termination or suspension of access to the Services where"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "you\u2019re in material breach of these Terms,"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "doing so would cause us legal liability or compromise our ability to provide the Services to our other users, or"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "we're prohibited from doing so by law."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Discontinuation of Services"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We may decide to discontinue the Services in response to exceptional unforeseen circumstances, events beyond Diligentsia\u2019s control (for example a natural disaster, fire or explosion) or to comply with a legal requirement. If we do so, we\u2019ll give you reasonable prior notice so that you can export Your Stuff from our systems (we will give you no less than 30 days\u2019 notice where possible under the circumstances). If we discontinue the Services in this way before the end of any fixed or minimum term you have paid us for, we\u2019ll refund the portion of the fees you have pre-paid but haven't received Services for."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Services \u201CAS IS\u201D"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We strive to provide great Services, but there are certain things that we can't guarantee. TO THE FULLEST EXTENT PERMITTED BY LAW, DILIGENTSIA AND ITS AFFILIATES, SUPPLIERS AND DISTRIBUTORS MAKE NO WARRANTIES, EITHER EXPRESS OR IMPLIED, ABOUT THE SERVICES. THE SERVICES ARE PROVIDED \u2018AS IS\u2019. WE ALSO DISCLAIM ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. Some places don\u2019t allow the disclaimers in this paragraph, so they may not apply to you. For example, these disclaimers do not override the legal protections, including statutory warranties granted to consumers by EU law."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Limitation of Liability"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "WE DON\u2019T EXCLUDE OR LIMIT OUR LIABILITY TO YOU WHERE IT WOULD BE ILLEGAL TO DO SO \u2013 THIS INCLUDES ANY LIABILITY FOR DILIGENTSIA\u2019S OR ITS AFFILIATES\u2019 FRAUD OR FRAUDULENT MISREPRESENTATION IN PROVIDING THE SERVICES. IN COUNTRIES WHERE THE FOLLOWING TYPES OF EXCLUSIONS AREN\u2019T ALLOWED, WE'RE RESPONSIBLE TO YOU ONLY FOR LOSSES AND DAMAGES THAT ARE A REASONABLY FORESEEABLE RESULT OF OUR FAILURE TO USE REASONABLE CARE AND SKILL OR OUR BREACH OF OUR CONTRACT WITH YOU. THIS PARAGRAPH DOESN\u2019T AFFECT CONSUMER RIGHTS THAT CAN'T BE WAIVED OR LIMITED BY ANY CONTRACT OR AGREEMENT. IF YOU ARE AN EU OR UK CONSUMER, THESE TERMS DO NOT EXCLUDE DILIGENTSIA\u2019S LIABILITY FOR LOSSES AND DAMAGES THAT ARE A RESULT OF OUR FAILURE TO USE REASONABLE CARE AND SKILL IN PROVIDING THE SERVICES OR OF OUR BREACH OF OUR CONTRACT WITH YOU, AS LONG AS THOSE LOSSES AND DAMAGES ARE REASONABLY FORESEEABLE."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "IN COUNTRIES WHERE EXCLUSIONS OR LIMITATIONS OF LIABILITY ARE ALLOWED, DILIGENTSIA, ITS AFFILIATES, SUPPLIERS OR DISTRIBUTORS WON\u2019T BE LIABLE FOR"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY OR CONSEQUENTIAL DAMAGES, OR"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "ANY LOSS OF USE, DATA, BUSINESS OR PROFITS, REGARDLESS OF LEGAL THEORY."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "THESE EXCLUSIONS OR LIMITATIONS WILL APPLY REGARDLESS OF WHETHER OR NOT DILIGENTSIA OR ANY OF ITS AFFILIATES HAVE BEEN WARNED OF THE POSSIBILITY OF SUCH DAMAGES."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "IF YOU USE THE SERVICES FOR ANY COMMERCIAL, BUSINESS OR RE-SALE PURPOSE, DILIGENTSIA, ITS AFFILIATES, SUPPLIERS OR DISTRIBUTORS WILL HAVE NO LIABILITY TO YOU FOR ANY LOSS OF PROFIT, LOSS OF BUSINESS, BUSINESS INTERRUPTION OR LOSS OF BUSINESS OPPORTUNITY. DILIGENTSIA AND ITS AFFILIATES AREN\u2019T RESPONSIBLE FOR THE CONDUCT, WHETHER ONLINE OR OFFLINE, OF ANY USERS OF THE SERVICES."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "OTHER THAN FOR THE TYPES OF LIABILITY WE CANNOT LIMIT BY LAW (AS DESCRIBED IN THIS SECTION), WE LIMIT OUR LIABILITY TO YOU TO THE GREATER OF \xa320 OR 100% OF ANY AMOUNT YOU'VE PAID UNDER YOUR CURRENT SERVICE PLAN WITH DILIGENTSIA. THIS PROVISION DOES NOT APPLY TO EU CONSUMERS WHERE PROHIBITED BY\xa0APPLICABLE LAW."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Resolving Disputes"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Let\u2019s try to sort things out first.\xa0We want to address your concerns without needing a formal legal case. Before filing a claim against Diligentsia, you agree to try to resolve the dispute informally by sending us a written Notice of Dispute at dispute-notice@Diligentsia.co.uk that includes your name, a detailed description of the dispute and the relief you seek. We\u2019ll try to resolve the dispute informally by contacting you via email. If a dispute is not resolved within 60 days after submission, you or Diligentsia may bring a formal proceeding. If you reside in the EU, the European Commission provides for an online dispute resolution platform, which you can access here:\xa0https://ec.europa.eu/consumers/odr."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Judicial Forum for Disputes.\xa0You and Diligentsia agree that any judicial proceeding to resolve claims relating to these Terms or the Services will be brought in the UK courts of England and Wales, and will be subject to UK law, subject to the mandatory arbitration provisions below. Both your organsation and Diligentsia consent to venue and personal jurisdiction in such courts. If you reside in a country (for example, a member state of the European Union) with laws that give consumers the right to bring disputes in their local courts, this paragraph doesn\u2019t affect those requirements."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "IF YOUR ORGANISATION IS US RESIDENT, IT ALSO AGREES TO THE FOLLOWING MANDATORY ARBITRATION PROVISIONS"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We both agree to arbitrate.\xa0You and Diligentsia agree to resolve any claims relating to these Terms or the Services through final and binding individual arbitration by a single arbitrator, except as set forth under the \u2018Exceptions to Agreement to Arbitrate\u2019 below. This includes disputes arising out of or relating to the interpretation or application of this \u2018Mandatory Arbitration Provisions\u2019 section, including its scope, enforceability, revocability or validity. The arbitrator may award relief only individually and only to the extent necessary to redress your individual claim(s); the arbitrator may not award relief on behalf of others or the general public."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Opt out of Agreement to Arbitrate.\xa0You can decline this agreement to arbitrate by\xa0clicking here\xa0and submitting the opt-out form within 30 days of first registering your account or agreeing to these Terms. However, if you agreed to a previous version of these Terms that allowed you to opt out of arbitration, your previous choice to opt out or not opt out remains binding."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Arbitration Procedures.\xa0The American Arbitration Association (AAA) will administer the arbitration under its Consumer Arbitration Rules. The AAA\u2019s rules and filing instructions are available at\xa0www.adr.org\xa0or by calling 1-800-778-7879. The arbitration will be held in the United States county where you live or work, San Francisco (CA) or any other location we agree to."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Arbitration Fees and Incentives.\xa0The AAA rules will govern payment of all arbitration fees. For individual arbitration of non-frivolous claims less than US$75,000 for which you timely provided Diligentsia with a Notice of Dispute, Diligentsia will reimburse arbitration filing fees at the conclusion of the arbitration and will pay other arbitration fees. For all other claims, the costs and fees of arbitration shall be allocated in accordance with the arbitration provider\u2019s rules, including rules regarding frivolous or improper claims. If you receive an arbitration award that is more favourable than any offer we make to resolve the claim, we will pay you US$1,000 in addition to the award. Diligentsia will not seek its lawyers\u2019 fees and costs in arbitration unless the arbitrator determines that your claim is frivolous or brought for an improper purpose."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Exceptions to agreement to arbitrate. Either you or Diligentsia may assert claims, if they qualify, in a small claims court in San Francisco (CA) or any United States county where you live or work. Either party may bring a lawsuit solely for injunctive relief to stop unauthorised use or abuse of the Services, or intellectual property infringement (for example, trademark, trade secret, copyright or patent rights) without first engaging in arbitration or the informal dispute resolution process described above. If the agreement to arbitrate is found not to apply to you or your claim, you agree to the exclusive jurisdiction of the state and federal courts in San Francisco County, California, USA to resolve your claim."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "NO CLASS OR REPRESENTATIVE ACTIONS. You may only resolve disputes with us on an individual basis and may not bring a claim as a plaintiff or a class member in a class, consolidated or representative action. Class arbitrations, class actions, private lawyer general actions and consolidation with other arbitrations aren\u2019t allowed."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Severability. If any part of this \u2018Mandatory Arbitration Provisions\u2019 section is found to be illegal or unenforceable, the remainder will remain in effect, except that if a finding of partial illegality or unenforceability would allow class or representative arbitration, this \u2018Mandatory Arbitration Provisions\u2019 section will be unenforceable in its entirety. If you are found to have a non-waivable right to bring a particular claim or to request a particular form of relief that the arbitrator lacks authority to redress or award according to this \u2018Mandatory Arbitration Provisions\u2019 section, including public injunctive relief, then only that respective claim or request for relief may be brought in court, and you and we agree that litigation of any such claim or request for relief shall be stayed pending the resolution of any individual claim(s) or request(s) for relief in arbitration."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Controlling Law"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "These Terms will be governed by UK law. However, some countries (including those in the European Union) have laws that require agreements to be governed by the local laws of the consumer's country. This paragraph doesn\u2019t override those laws."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Entire Agreement"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "These Terms constitute the entire agreement between you and Diligentsia with respect to the subject matter of these Terms and supersede and replace any other prior or contemporaneous agreements or terms and conditions applicable to the subject matter of these Terms. Our past, present and future affiliates and agents can invoke our rights under this agreement in the event they become involved in a dispute with you. Otherwise, these Terms do not give rights to any third parties."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Waiver, Severability & Assignment"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia\u2019s failure to enforce a provision is not a waiver of its right to do so later. If a provision is found to be unenforceable, the remaining provisions of the Terms will remain in full effect and an enforceable term will be substituted reflecting our intent as closely as possible. You may not assign any of your rights under these Terms, and any such attempt will be void. Diligentsia may assign its rights to any of its affiliates or subsidiaries, or to any successor in the interest of any business associated with the Services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Modifications"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We may revise these Terms from time to time to better reflect"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "changes to the law,"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "new regulatory requirements, or"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "improvements or enhancements made to our Services."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "If an update affects your use of the Services or your legal rights as a user of our Services, we\u2019ll notify you prior to the update's effective date by sending an email to the email address associated with your organisation\u2019s account or via an in-product notification. These updated terms will be effective no less than 30 days from when we notify you."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "If you do not agree to the updates we make, please cancel your account and stop using the Services before the updated Terms become effective. Where applicable, we\u2019ll offer you a pro-rata refund based on the amounts you have prepaid for Services and your account cancellation date. By continuing to use or access the Services after the updates come into effect, you agree to be bound by the revised Terms."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "acceptableUse",
                                wrapperClass: "tac",
                                subheading: "Acceptable Use"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Effective: June 30th 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Diligentsia is proud of the trust placed in us. In exchange, we trust you to use our services responsibly."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: 'You agree not to misuse the Diligentsia services ("Services") or help anyone else to do so. For example, you must not even try to do any of the following in connection with the Services'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "probe, scan, or test the vulnerability of any system or network, "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "breach or otherwise circumvent any security or authentication measures;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "access, tamper with, or use non-public areas or parts of the Services, or shared areas of the Services you haven't been invited to;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "interfere with or disrupt any user, host, or network, for example by sending a virus, overloading, flooding, spamming, or mail-bombing any part of the Services;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: 'access, search, or create accounts for the Services by any means other than our publicly supported interfaces (for example, "scraping" or creating accounts in bulk);'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "send unsolicited communications, promotions or advertisements, or spam;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: 'send altered, deceptive or false source-identifying information, including "spoofing" or "phishing";'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "promote or advertise products or services other than your own without appropriate authorization;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "abuse referrals or promotions to get more storage space than deserved or to sell storage space received from referrals or promotions;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "circumvent storage space limits;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "sell the Services unless specifically authorized to do so;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "publish, share, or store materials that constitute child sexually exploitative material (including material which may not be illegal child sexual abuse material but which nonetheless sexually exploits or promotes the sexual exploitation of minors), unlawful pornography, or are otherwise indecent;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "publish, share, or store content that contains or promotes extreme acts of violence or terrorist activity, including terror propaganda;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "advocate bigotry or hatred against any person or group of people based on their race, religion, ethnicity, sex, gender identity, sexual orientation, disability, or impairment;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "harass or abuse Diligentsia personnel or representatives or agents performing services on behalf of Diligentsia;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "violate the law in any way, including storing, publishing or sharing material that\u2019s fraudulent, defamatory, or misleading, or that violates the intellectual property rights of others;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "violate the privacy or infringe the rights of others;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "use the Services to back up, or as infrastructure for, your own cloud services;"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "use the storage space provided by the Services as the basis for cryptographic proof-of-space or proof-of-storage, or any similar proof system."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We reserve the right to take appropriate action in response to violations of this policy, which could include removing or disabling access to content, suspending a user\u2019s access to the Services, or terminating an account."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 3"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



function $789cb6667d9385ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $09b448c31c7c9e44$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c1 cp px0-5rem",
                        "data-scroll-to": "cookiePolicy",
                        children: "Cookie Policy"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c1 cp px0-5rem",
                        "data-scroll-to": "dmcaPolicy",
                        children: "DMCA Policy"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c1 cp px0-5rem",
                        "data-scroll-to": "privacyPolicy",
                        children: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c1 cp px0-5rem",
                        "data-scroll-to": "dataPrivacy/ethicsPolicy",
                        children: "Data Privacy & Ethics Policy"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c1 cp px0-5rem",
                        "data-scroll-to": "aiUsePolicy",
                        children: "AI Use Policy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "container mxa py5rem dg gg1rem lh3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        id: "forCompanies",
                        wrapperClass: "tac mb2rem",
                        heading: "Policies"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "br5px bg5 w50 shadow p2rem table-of-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1rem",
                                children: "List of Policies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "list-table",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 cp px0-5rem",
                                                "data-scroll-to": "cookiePolicy",
                                                children: "Cookie Policy "
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                children: " Page 1"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 cp px0-5rem",
                                                "data-scroll-to": "dmcaPolicy",
                                                children: "DMCA Policy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                children: " Page 2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 cp px0-5rem",
                                                "data-scroll-to": "privacyPolicy",
                                                children: "Privacy Policy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                children: " Page 3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 cp px0-5rem",
                                                "data-scroll-to": "dataPrivacy/ethicsPolicy",
                                                children: "Data Privacy & Ethics Policy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {}),
                                            " Page 4"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "df jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 cp px0-5rem",
                                                "data-scroll-to": "aiUsePolicy",
                                                children: "AI Use Policy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {}),
                                            " Page 5"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "cookiePolicy",
                                wrapperClass: "tac",
                                subheading: "Cookie Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Effective: June 30th 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Use of cookies and similar technologies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Diligentsia uses cookies and similar technologies, such as pixels, to provide, improve, protect, and promote our services. For the purposes of this policy we will refer to all of these technologies as \u201Ccookies.\u201D This page includes information on the what, who, and how of these technologies in connection with the Diligentsia website and services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "What are cookies?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: 'A cookie is small data file sent to your browser when you visit a website. A pixel tag ("pixel") is a small piece of code belonging to a third-party that can be embedded on websites and in emails. We use both our own cookies as well as third-party cookies. See the \u201CHow does Diligentsia use cookies\u201D section below for further information on third-party cookies we use.'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "We also use local storage, including HTML5 local storage and browser cache. Local storage allows us to store information locally on your browser or device to improve your experience, such as to remember your settings for whether you prefer to view your folders in a list or as thumbnails.\xa0"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "How does Diligentsia use cookies?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Diligentsia uses different categories of cookies to provide, protect, improve, and promote our website and services. Diligentsia only retains personal data for as long as is needed for the purposes for which it was collected. Information on these categories and their purposes are described below."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Strictly necessary cookies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "These are cookies that are essential in order to operate the website and services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Category"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Purpose"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Data elements"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Expiration"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Third parties"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Strictly necessary"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Cookies that are used to operate the website and services, such as to log you in and keep your account secure."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Categories of data collected for these purposes include authentication data, unique ID, browser information, and language settings."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "These cookies are set to expire after times ranging from 30 days to 4 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Third party providers used include Google."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Non-essential cookies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "These are all other cookies that are not considered strictly necessary but are used for a number of purposes when you interact with our website and services. These purposes include"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Category"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Purpose"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Data elements"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Expiration"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Third parties"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Analytics"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Cookies that help us and our partners understand how our websites are engaged with, such as usage statistics, in order to improve and customize our services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Categories of data collected for these purposes include website usage data, number of visits, browser and/or device information, and unique ID."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 2 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Third party providers used include Google, Salesforce, Coveo, and Tealium."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "General marketing and advertising"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Cookies that are used by Diligentsia and our partners to better understand the types of individuals who are interested in our products and services and how we can promote those services based on that information."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Categories of data collected for these purposes include cross website tracking data, browser information, version data, and advertisement conversion data."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 2 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Third party providers used include Adobe, Marketo, Yahoo, and Google."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Performance and functionality"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Cookies which help us remember your preferences and settings in order to improve your experience when interacting with our sites and services."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Categories of data collected for these purposes include website usage data, previous help center or chat history, email address, and unique ID."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 3 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Third party providers used include SnapEngage."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Social media advertising"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Cookies that are used by Diligentsia and our partners to understand the effectiveness of our advertisements on social media services. These cookies also help them understand your advertising preferences so they can more effectively show you our advertisements which are relevant to your interests."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Categories of data collected for these purposes include social media account details, browser and/or device data, advertisement conversion data, website usage and/or activity data, and unique ID."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "These cookies are set to expire after times ranging from session (~20 minutes) to 2 years."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Third party providers used include Facebook, Twitter, and LinkedIn."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "How can I control the data collected through cookies?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Browser settings"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "You can set your browser to not accept cookies, but this may limit your ability to use our services. Due to a lack of an agreed upon standard for interpreting Do Not Track (DNT) signals, our systems currently don\u2019t respond to DNT:1 signals from browsers visiting our websites."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Cookie preferences"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "When you use Diligentsia\u2019s services, you can select which cookies you consent for Diligentsia to use in by clicking\xa0Cookies & CCPA Preferences\xa0in the footer of this page under\xa0Support."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Self-Regulatory"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: 'Diligentsia adheres to the Digital Advertising Alliance\u2019s Self-Regulatory Principles for Online Behavioral Advertising ("Principles"). You can opt out of collection of information by third-parties that adhere to the Principles, and that we use to help us promote our services, by visiting\xa0www.aboutads.info/choices.'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Diligentsia also adheres to the European Interactive Digital Advertising Alliance\u2019s self-regulatory program for data-driven advertising. You can opt out of collection of information used for online behavior advertising by third-parties that adhere to the program by visiting\xa0http://www.youronlinechoices.eu/."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "For more information on how to control and access your personal data, please see our Privacy Policy. If you\u2019d like to reach out to Diligentsia regarding the use of data collected from cookies, contact our Data Protection Officer at\xa0privacy@Diligentsia.co.uk ."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "dmcaPolicy",
                                wrapperClass: "tac",
                                subheading: "DMCA Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Effective: June 30th 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Diligentsia Limited (\u201CDiligentsia\u201D) respects the intellectual property rights of others and expects its users to do the same. In accordance with the Digital Millennium Copyright Act of 1998, the text of which may be found on the U.S. Copyright Office website at\xa0https://www.copyright.gov/legislation/dmca.pdf, Diligentsia will respond expeditiously to claims of copyright infringement committed using the Diligentsia platform and/or the Diligentsia website (the \u201CSite\u201D) if such claims are reported to Diligentsia\u2019s Designated Copyright Agent identified in the sample notice below."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "If you are a copyright owner, authorized to act on behalf of one, or authorized to act under any exclusive right under copyright, please report alleged copyright infringements taking place on or through the Site by completing the following DMCA Notice of Alleged Infringement and delivering it to Diligentsia\u2019s designated Data Privacy Officer at privacy@diligentsia.co.uk . Upon receipt of Notice as described below, Diligentsia will take whatever action, in its sole discretion, it deems appropriate, including removal of the challenged content from the Site."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "DMCA Notice of Alleged Infringement (\u201CNotice\u201D)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Identify the copyrighted work that you claim has been infringed, or - if multiple copyrighted works are covered by this Notice - you may provide a representative list of the copyrighted works that you claim have been infringed."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Identify the material or link you claim is infringing (or the subject of infringing activity) and to which access is to be disabled, including at a minimum, if applicable, the URL of the link shown on the Site or the exact location where such material may be found."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Provide your company affiliation (if applicable), mailing address, telephone number, and, if available, email address."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Include both of the following statements in the body of the Notice"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "\u201CI hereby state that I have a good faith belief that the disputed use of the copyrighted material is not authorised by the copyright owner, its agent or the law (e.g. as a fair use)\u201D."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "\u201CI hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner, or authorized to act on behalf of, the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.\u201D"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Provide your full legal name and your electronic or physical signature."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Deliver this Notice, with all items completed, to Diligentsia\u2019s designated Data Privacy Officer at privacy@diligentsia.co.uk "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Data Privacy Officer"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Diligentsia Limited"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "The Old Rectory Nock Verges, Stoney Stanton,"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Leicestershire, LE9 4LR, UK"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "privacyPolicy",
                                wrapperClass: "tac",
                                subheading: "Privacy Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pt1rem pb1rem",
                                children: "Effective: 30th June, 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "At Diligentsia Limited, we are committed to protecting the privacy and security of our clients' personal data. This Data Privacy Policy outlines how we collect, use, store, and protect your information when you use our platform. By using our services, you agree to the practices described in this policy."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Information We Collect"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We only collect personal data that is necessary for us to provide our services effectively. This may include: "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Contact information (name, email address, phone number). "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Account information (username, password). "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Transaction information related to your use of our platform. "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "How We Use Your Information"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We use the information we collect to: "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Provide, operate, and maintain our platform and services. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Communicate with you, including responding to inquiries and providing customer support. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Improve and personalize your experience on our platform. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Ensure compliance with legal and regulatory requirements. "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Data Security "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "Consistent with our size of business, we implement robust security measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction. These measures include encryption, access controls, and regular security assessments. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Data Sharing and Disclosure "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We do not share your personal data with third parties unless it is necessary to provide our services, comply with the law, or protect our rights. Where data sharing is necessary, we ensure that third parties adhere to strict data protection standards. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Data Retention "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected or as required by law. Once the data is no longer needed, it will be securely deleted or anonymized."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Your Rights "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "You have the right to access, correct, or delete your personal data that we hold. You may also object to or restrict certain types of data processing. To exercise these rights, please contact us using the information provided below. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Changes to This Policy "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "We may update this Data Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any significant changes and post the updated policy on our website. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fw500 tal c14 fs1-5rem pt1rem pb1rem",
                                children: "Contact Us "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "If you have any questions or concerns about this Data Privacy Policy or our data practices, please contact us at: "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                className: "pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Email: privacy@diligentsia.co.uk "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Address: Diligentsia Limited, The Old Rectory, Nock Verges, Stoney Stanton, Leicestershire LE9 4DA, UK "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pb1rem",
                                children: "This Data Privacy Policy is designed to give you confidence in how we handle your personal data. Your privacy is important to us, and we are committed to maintaining your trust. "
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "dataPrivacy/ethicsPolicy",
                                wrapperClass: "tac",
                                subheading: "Data Privacy & Ethics Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Effective: June 30th 2022"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Scope and Acceptance of Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "This Data Privacy and Ethics Policy ('Policy') applies to the use of your data by Diligentsia Limited ('Company', 'we', 'us', 'our') in relation to the use of an artificial intelligence tool, Chat GPT, developed by OpenAI. Your acceptance of this Policy, along with our Terms and Conditions, is indicated by your continued use of our services and/or by expressly clicking to accept where that option is presented to you."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Data Usage"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "We use your data for the sole purpose of enhancing the quality of reports we generate for you through the application of AI technology. Your data may be used to create comprehensive reports via Chat GPT, but will not be used for any other purpose unless we obtain your explicit permission.\u200B"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Data Protection"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Your data is important and private to you, and we respect that. We ensure that your data is not shared with third parties, except with Chat GPT as outlined in this policy. We do not disseminate or transfer ownership of your data. Any reports we generate using your data and AI are digitally watermarked to ensure their authenticity and traceability."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Data Retention"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "We will not retain your data for longer than is necessary for our services or as required by law. The data you supply to us that is processed through Chat GPT is not stored or reused by the AI system."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Non-disclosure of Files"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "The contents of any data files you provide to us will not be shared with AI systems. We will not disclose the contents of these files outside our organisation unless we have obtained your prior express permission."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Your Rights"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "\u200BYou have the right to access, rectify, delete or restrict the use of your personal data. You can exercise these rights at any time by contacting us using the contact details provided in our Terms and Conditions."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Changes to the Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "We reserve the right to update this Policy at any time to reflect changes in our practices, service offerings, or the latest laws and regulations. Any changes will be posted on this page, and we recommend that you check this page regularly to stay informed."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "If you have any questions or require further information about our data handling practices, please don't hesitate to contact our Data Privacy Officer at dpo@diligentsia.co.uk. We're committed to working with you to obtain a fair resolution of any privacy concerns.\""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr bg1 p2rem shadow my2rem policy-page-data",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                id: "aiUsePolicy",
                                wrapperClass: "tac",
                                subheading: "AI Use Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Effective: 1st January 2024"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Introduction"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: 'At Diligentsia Limited ("we," "us," or "our"), we are committed to delivering high-quality services to our corporate customers, mainly SMEs, their professional advisors, and investors ("Customers"). We utilize generative AI technologies, including those from OpenAI, Google Bard, Microsoft Bing, and others, to assist in the creation of bespoke reports and deliver valuable insights to our Customers. We take your privacy and data security seriously, and this AI Use Policy outlines our responsible approach to using AI technologies.'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Data Usage and Protection"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "includes information provided by our Customers and may include text, documents, and other relevant data. Data Security: We employ robust security measures to protect your data from unauthorized access, disclosure, or alteration. We use encryption, access controls, and industry best practices to safeguard your information. Data Usage: We use the data provided by our Customers exclusively for the purpose of generating bespoke reports and delivering our services. We do not sell, market, or otherwise use your data for any purpose other than fulfilling our obligations to you. Anonymization and Aggregation: We may aggregate and anonymize data to improve our AI models, conduct research, and enhance our services. This aggregated and anonymized data cannot be traced back to individual Customers."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Responsible AI Usage"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "AI Algorithms: We use AI algorithms to assist in the generation of reports, ensuring accuracy and efficiency. These algorithms are designed to provide valuable insights while maintaining a responsible and ethical approach. Transparency: We strive to be transparent about our AI usage. If you have any questions about how AI is used in our services, please feel free to contact us."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Customer Rights"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Access and Control: Customers have the right to access, correct, or delete their data. If you have concerns or requests regarding your data, please contact us, and we will promptly address them. Opt-Out: If you no longer wish to use our services, you have the right to opt-out and have your data removed from our systems."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Compliance with Applicable Laws"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "We are committed to complying with all applicable data protection and privacy laws, including but not limited to the General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA)."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "df aic",
                                children: [
                                    "If you have any questions, concerns, or requests related to our AI Use Policy or the use of AI in our services, please contact us at: ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "db p0-5rem td250 c4-hover",
                                        href: "mailto: support@diligentsia.co.uk",
                                        children: "support@diligentsia.co.uk"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Changes to the AI Use Policy"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "We may update this AI Use Policy from time to time to reflect changes in our business practices or legal requirements. The most current version will be posted on our website, and we will notify Customers of any significant changes."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "By using our services, you agree to this AI Use Policy and our Terms and Conditions."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "Effective Date"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "taj",
                                children: "This AI Use Policy is effective as of 1st January 2024."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c4 df jcc mt1rem",
                                children: "Page 5"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




function $d02462af2757b484$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mih100vh df aic jcc bg5",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container df fdc aic tac",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                    initial: {
                        scale: 0.8,
                        opacity: 0
                    },
                    animate: {
                        scale: 1,
                        opacity: 1
                    },
                    transition: {
                        delay: 0.2,
                        duration: 0.5
                    },
                    className: "df fdc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "c4 fw700 mb2rem",
                            style: {
                                fontSize: '8rem',
                                lineHeight: '1'
                            },
                            children: "404"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c6 fw600 fs2rem mb1rem",
                            children: "Page Not Found"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c6 fs1-125rem mb3rem op75",
                            style: {
                                maxWidth: '500px'
                            },
                            children: "Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: (0, $16250bd714b02a14$export$a7c5707626fc90f),
                            className: "df aic px2rem py1rem c1 fw600 br25px td300 dib",
                            style: {
                                backgroundColor: '#FC7785',
                                boxShadow: '0 4px 14px 0 rgba(252, 119, 133, 0.3)',
                                textDecoration: 'none'
                            },
                            onMouseEnter: (e)=>{
                                e.target.style.backgroundColor = '#e66675';
                                e.target.style.boxShadow = '0 6px 20px 0 rgba(252, 119, 133, 0.4)';
                                e.target.style.transform = 'translateY(-2px)';
                            },
                            onMouseLeave: (e)=>{
                                e.target.style.backgroundColor = '#FC7785';
                                e.target.style.boxShadow = '0 4px 14px 0 rgba(252, 119, 133, 0.3)';
                                e.target.style.transform = 'translateY(0)';
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    className: "mr0-5rem",
                                    style: {
                                        width: '20px',
                                        height: '20px'
                                    },
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M10 19l-7-7m0 0l7-7m-7 7h18"
                                    })
                                }),
                                "Back to Home"
                            ]
                        })
                    ]
                })
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");



function $5ac049553753afae$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container py5rem df fdc",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                wrapperClass: "mb2rem tac",
                heading: "Group",
                subheading: "Manage a group"
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $45fvw = parcelRequire("45fvw");



const $0f57bfbc8f0b7a3b$var$Title = ({ lable: lable })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "c14 fw400 fs14px mr0-5rem",
        children: lable
    });
};
const $0f57bfbc8f0b7a3b$var$Subscription = ({ isExpansion: isExpansion, lable: lable, sub: sub, companyId: companyId })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "c14 fw400 fs14px mr0-5rem",
                children: [
                    lable,
                    " : "
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ttu fw400 fs14px c59",
                children: sub
            }),
            !isExpansion && (!sub || sub.toLowerCase() === "free") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: `/billing/${companyId}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "px1rem bg4 c1 py0-5rem fs12px br50px cp ml0-5rem",
                    children: "Upgrade"
                })
            }) : null
        ]
    });
};

const $0f57bfbc8f0b7a3b$var$BillingCard = ({ company: company, idx: idx })=>{
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const handleStripeInvoiceDownload = async (invoiceId, type)=>{
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/payment/invoice-download/${invoiceId}?type=${type}`, 'not-showMessage');
        if (response && response.code === 200 && response.body?.url) try {
            const link = document.createElement('a');
            link.href = response.body.url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.download = `invoice-${invoiceId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (err) {
            console.error('Invoice download error:', err);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Failed to download invoice PDF");
        }
        else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || "Failed to fetch invoice");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w100 py2rem px1rem br20px bg1 fs1-25rem my0-5rem billingCard",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aifs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        maxWidth: "42px"
                    },
                    className: "mr1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: company["logo"] || (parcelRequire("duLaW")),
                        alt: "companyLogo",
                        className: "w100 cp br10px"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "cp",
                                    onClick: ()=>{
                                        if (company && company?.['subscription'] && company?.['subscription'].toLowerCase() === "pro" && user && [
                                            'investor',
                                            'advisor'
                                        ].includes(user?.['role']?.toLowerCase())) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`${company['cName']} have already on Pro Plan`);
                                        const userRole = user?.role?.toLowerCase();
                                        const servicedRole = company?.servicedBy?.role?.toLowerCase();
                                        const companyId = company?._id;
                                        const isSpecialRole = [
                                            'advisor',
                                            'investor'
                                        ].includes(userRole) || [
                                            'advisor',
                                            'investor'
                                        ].includes(servicedRole);
                                        if (isSpecialRole) navigate(`/billing/${companyId}/pro/${servicedRole}`);
                                        else navigate((0, $16250bd714b02a14$export$3623221f872af69b).replace(':id', companyId));
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "w100 c15 fw500",
                                        children: company['cName']
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        lineHeight: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: 'Account Owner:'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: `${company['creator']['firstName']} ${company['creator']['lastName']}`
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "billingTable",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: 'Purchased'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: 'Status'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: 'Date'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: 'Renewal'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: 'Who'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                            lable: 'Billing'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: 'mt1rem',
                                    children: company['payments'] && company['payments'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: 'billingTable mt1rem',
                                        children: company['payments'].map((payment, idx)=>{
                                            const isExpansion = payment.purpose.startsWith('ExpensionPack-');
                                            let sub = isExpansion ? `${payment.purpose.split('=')[0].split('-')[1]} - ${payment.purpose.split('=')[1]}` : payment.purpose;
                                            if (sub.includes("undefined")) {
                                                let subId = sub.split('-')[0].trim();
                                                if ((0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[subId]['name']) sub = `${subId} - ${(0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[subId]['name']}`;
                                                else sub = "Unknown Product";
                                            }
                                            const formattedDate = payment['nextPaymentDate'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(payment['nextPaymentDate']).format('DD/MM/YYYY') : "-";
                                            const createdAt = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(payment['createdAt']).format('DD/MM/YYYY') ?? "-";
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Subscription, {
                                                        isExpansion: isExpansion,
                                                        lable: isExpansion ? 'Module' : 'Subscription',
                                                        sub: sub,
                                                        companyId: company['_id']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                                        lable: payment?.status
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c14 fw400 fs14px mr0-5rem",
                                                        children: createdAt
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($0f57bfbc8f0b7a3b$var$Title, {
                                                        lable: formattedDate
                                                    }),
                                                    payment['user'] ? payment['user']['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: payment['user']['profile'],
                                                        className: `w40px h40px df jcc aic br100 cp bo30 bss bw3px client-profile`,
                                                        "data-tooltip": payment['user']['firstName'] ? payment['user']['firstName'] + " " + (payment['user']['lastName'] ?? "") : "Register to show your name here"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30 fs1rem c1 client-profile`,
                                                        "data-tooltip": payment['user']['firstName'] ? payment['user']['firstName'] + " " + (payment['user']['lastName'] ? payment['user']['lastName'] : "") : "Register to show your name here",
                                                        children: payment['user']['firstName'] ? payment['user']['firstName'][0] + (payment['user']['lastName'] ? payment['user']['lastName']?.[0] : "") : "?"
                                                    }) : '-',
                                                    payment['invoiceId'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        onClick: ()=>handleStripeInvoiceDownload(payment['invoiceId'], 'subscription'),
                                                        className: "c3 cp fs1rem",
                                                        children: "[Invoice]"
                                                    }) : payment['paymentIntent'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        onClick: ()=>handleStripeInvoiceDownload(payment['paymentIntent'], 'feature'),
                                                        className: "c3 cp fs1rem",
                                                        children: "[Invoice]"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "pl1rem",
                                                        children: "-"
                                                    })
                                                ]
                                            }, `${payment['_id']}-${idx}`);
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w100 tac py2rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "c15 fs1-5rem",
                                            children: "No Payments"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, idx);
};
var $0f57bfbc8f0b7a3b$export$2e2bcd8739ae039 = $0f57bfbc8f0b7a3b$var$BillingCard;


function $aa31fe49377072f4$export$2e2bcd8739ae039() {
    const [companies, setCompanies] = (0, $acw62.useState)([]);
    let [loading, setLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (companies.length === 0) getBillings();
    }, []);
    const getBillings = async ()=>{
        setLoading(true);
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/payment/payment-history`, 'return-response');
        if (response['code'] == '200' && response['body']) setCompanies(response['body']);
        else setCompanies([]);
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "py3rem bg38 df aic fdc mih100vh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df fdc aic jcc w100 mb2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                        className: "w100 c15 fs2rem lh2 fw500 tac",
                        children: [
                            "Billing ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "History"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df fdc ais w90",
                    children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic jcc w100 h100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "tac c15 fs1-75rem pt1rem py3rem lh2",
                            children: "Loading..."
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: companies && companies.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: companies.map((company, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f57bfbc8f0b7a3b$export$2e2bcd8739ae039), {
                                        company: company,
                                        idx: idx
                                    })
                                }, `${company['_id']}-${idx}`);
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "tac c15 fs1-75rem pt1rem py3rem lh2",
                            children: "No Companies Added"
                        })
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");













function $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039({ plan: plan, component: component, handlePaymentPopup: handlePaymentPopup, isAdvisor: isAdvisor, isInvestor: isInvestor, company: company }) {
    let data = {
        'Free': {
            subTitle: "Let\u2019s get to know each other",
            points: [
                "FREE - no credit card required",
                'Entry level service',
                "Straightforward business value with practical recommendations",
                "See the power of our AI in action",
                "2-Minute Test to your company\xa0and its objectives",
                "Key Performance Indicator (\u201CKPI\u201D) Report tailored to your business and its industry"
            ],
            isButtonText: company?.['subscription'] == 'Free' || company?.['subscription'] == 'Lite' || company?.['subscription'] == 'Pro' ? false : true,
            buttonText: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcc fdc aic w100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            lineHeight: '13px'
                        },
                        children: "Try for FREE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fw400 c21",
                        style: {
                            lineHeight: '13px',
                            fontStyle: 'italic',
                            fontSize: '10px'
                        },
                        children: "No credit card required"
                    })
                ]
            }),
            buttonIdentifier: 'register',
            // titleRegisterBox: 'Direct?',
            // descriptionRegisterBox: 'Register for FREE. Use FREE modules. Upgrade from within your dashboard.',
            buttonRegisterBox: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: "w100 df jcsb aic",
                href: "/register",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw600 c1 tal",
                        children: [
                            "Register for FREE",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-5rem db fsi",
                                children: "Upgrade from your dashboard"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "20",
                        height: "17",
                        viewBox: "0 0 28 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                            fill: "white"
                        })
                    })
                ]
            })
        },
        'Lite': {
            subTitle: 'For micro businesses',
            points: [
                "Aimed at businesses <5 employees wanting to organise themselves better",
                '2-Minute Test to your company and its objectives',
                "Key Performance Indicators (\u201CKPI\u201D)Report tailored to your business and its industry",
                'Data Repository - 20 sections eg. contracts',
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic",
                    children: [
                        "Syncs with",
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "pl0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("gPTbN")),
                                    className: "w20 "
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("3zMud")),
                                    className: "w20 ",
                                    style: {
                                        marginLeft: '5px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("8BoXF")),
                                    className: "w20 ",
                                    style: {
                                        marginLeft: '5px'
                                    }
                                })
                            ]
                        })
                    ]
                }),
                'Customised Business Audit to your company and its objectives',
                'No certification',
                'No collaboration with Investors or Advisors',
                'No access to Diligentsia AppStore'
            ],
            isButtonText: company?.['subscription'] == 'Lite' || company?.['subscription'] == 'Pro' ? false : true,
            buttonText: company?.['subscription'] == "Free" ? "Upgrade" : 'Buy Now',
            buttonIdentifier: 'payment',
            // titleRegisterBox: 'Direct?',
            // descriptionRegisterBox: 'Register for FREE. Use FREE modules. Upgrade from within your dashboard.',
            buttonRegisterBox: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: "w100 df jcsb aic",
                href: "/register",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw600 c1 tal",
                        children: [
                            "Register for FREE",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-5rem db fsi",
                                children: "Upgrade from your dashboard"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "20",
                        height: "17",
                        viewBox: "0 0 28 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                            fill: "white"
                        })
                    })
                ]
            })
        },
        'Pro': {
            title: 'Pro',
            price: "\xa31000",
            perMonth: true,
            subTitle: 'For SMEs',
            points: [
                "Aimed at\xa0growth businesses >5 employees",
                '2-Minute Test',
                "Customised Key Performance Indicators (KPIs)",
                "Data Repository - 20 sections, 160 subsections,\xa0user-defined sections, AI Filing Manager",
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic",
                    children: [
                        "Syncs with",
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "pl0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("gPTbN")),
                                    className: "w20 "
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("3zMud")),
                                    className: "w20 ",
                                    style: {
                                        marginLeft: '5px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("8BoXF")),
                                    className: "w20 ",
                                    style: {
                                        marginLeft: '5px'
                                    }
                                })
                            ]
                        })
                    ]
                }),
                'Customised Business Audit',
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                width: "60%"
                            },
                            children: "Unaudited Certification"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "pl0-5rem",
                            style: {
                                width: '40%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("iQeGV")),
                                    style: {
                                        width: '24%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("l61of")),
                                    style: {
                                        marginLeft: '5px',
                                        width: '24%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("gI7Us")),
                                    style: {
                                        marginLeft: '5px',
                                        width: '24%'
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fw600",
                            children: "Diligentsia AppStore"
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        "Audited certification available via",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fw600",
                            children: " Diligentsia PLUS"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        "Collaborate and share with advisors and investors via ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fw600",
                            children: "Diligentsia Portfolio Pro"
                        })
                    ]
                })
            ],
            isButtonText: company?.['subscription'] == 'Pro' ? false : true,
            buttonText: company?.['subscription'] == 'Lite' || company?.['subscription'] == 'Free' ? "Upgrade" : 'Buy Now',
            hasPopular: true,
            buttonIdentifier: 'payment',
            // titleRegisterBox: isAdvisor ? 'Client Company' : isInvestor ? 'Portfolio Company' : 'Introduction from your advisor/investor?',
            // descriptionRegisterBox: `Await introductory email from ${isAdvisor ? 'your advisor' : isInvestor ? 'your investor' : 'them'}, or chase them!`,
            buttonRegisterBox: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: "w100 df jcsb aic",
                href: "/register",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw600 c1 tal",
                        children: [
                            "Register for FREE",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-5rem db fsi",
                                children: "Upgrade from your dashboard"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "20",
                        height: "17",
                        viewBox: "0 0 28 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                            fill: "white"
                        })
                    })
                ]
            })
        },
        'Pro PLUS': {
            contactSection: true,
            title: 'Pro PLUS',
            price: 'Contact Us',
            subTitle: 'AUDITED diligence certification',
            points: [
                `${isInvestor ? 'Investor' : 'Advisor'} supported diligence?\xa0 Don\u{2019}t want to?`,
                'Consultancy services',
                "Addition assurance from professional third-parties",
                'Have your own accountant or lawyer work through your diligence modules',
                'Inexpensive - designed to be quick and cost-effective.',
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                width: "60%"
                            },
                            children: "Audited certification"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "pl0-5rem",
                            style: {
                                width: '40%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("dDjqz")),
                                    style: {
                                        width: '24%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("6tYxP")),
                                    style: {
                                        marginLeft: '5px',
                                        width: '24%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("jndeQ")),
                                    style: {
                                        marginLeft: '5px',
                                        width: '24%'
                                    }
                                })
                            ]
                        })
                    ]
                })
            ],
            isButtonText: true,
            buttonText: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: "df",
                href: "https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true",
                target: "_blank",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "30",
                        height: "30",
                        viewBox: "0 0 39 39",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                opacity: "0.9",
                                d: "M33.3804 4.33135H30.3365C30.3365 4.06704 30.2812 3.80565 30.1742 3.56399C30.0671 3.32233 29.9106 3.10577 29.7148 2.92823C29.519 2.75069 29.2882 2.61612 29.0373 2.53317C28.7863 2.45022 28.5207 2.42072 28.2577 2.44659C27.7806 2.50563 27.3422 2.73901 27.0268 3.10184C26.7115 3.46466 26.5414 3.93129 26.5493 4.41196V5.27811C26.5493 5.7122 26.6983 6.13314 26.9716 6.47044C27.2448 6.80774 27.6256 7.04092 28.0503 7.13093C28.1718 7.15386 28.2795 7.22337 28.3505 7.32465C28.4215 7.42592 28.45 7.55091 28.4301 7.67296C28.4102 7.795 28.3433 7.90441 28.2438 7.97784C28.1443 8.05127 28.0201 8.0829 27.8976 8.06597C27.2514 7.93885 26.6694 7.59143 26.2509 7.083C25.8323 6.57457 25.6032 5.93665 25.6026 5.27811V4.33135H20.329C20.3267 4.08071 20.2747 3.83301 20.1759 3.60262C20.0772 3.37224 19.9337 3.16374 19.7537 2.98923C19.5738 2.81471 19.361 2.67764 19.1277 2.58597C18.8944 2.49429 18.6453 2.44983 18.3947 2.45517C18.1441 2.46051 17.897 2.51553 17.6678 2.61705C17.4387 2.71858 17.2319 2.86458 17.0596 3.04659C16.8872 3.22861 16.7527 3.44302 16.6639 3.67741C16.575 3.91179 16.5336 4.16147 16.5419 4.41199L16.5419 5.27811C16.5418 5.7122 16.6909 6.13313 16.9641 6.47043C17.2374 6.80773 17.6182 7.04091 18.0428 7.13093C18.1643 7.15388 18.272 7.2234 18.343 7.32467C18.4139 7.42593 18.4425 7.55091 18.4225 7.67293C18.4026 7.79496 18.3358 7.90436 18.2363 7.97779C18.1368 8.05121 18.0126 8.08285 17.8901 8.06595C17.244 7.93882 16.662 7.5914 16.2434 7.08297C15.8249 6.57455 15.5957 5.93663 15.5951 5.27809V4.33135H12.5512C11.7984 4.33275 11.0767 4.63244 10.5444 5.1648C10.012 5.69716 9.71233 6.41879 9.71094 7.17165V9.80842H36.2207V7.17165C36.2193 6.41878 35.9196 5.69715 35.3872 5.1648C34.8549 4.63244 34.1332 4.33275 33.3804 4.33135ZM17.4887 4.33135C17.4924 4.08268 17.5937 3.84544 17.7709 3.67089C17.9481 3.49634 18.1868 3.3985 18.4355 3.3985C18.6842 3.39851 18.9229 3.49636 19.1 3.67091C19.2772 3.84547 19.3786 4.08272 19.3822 4.33139L17.4887 4.33135ZM27.4961 4.33135C27.4998 4.08268 27.6012 3.84544 27.7784 3.67089C27.9555 3.49634 28.1942 3.3985 28.4429 3.3985C28.6916 3.39851 28.9303 3.49636 29.1075 3.67091C29.2846 3.84547 29.386 4.08272 29.3897 4.33139L27.4961 4.33135Z",
                                fill: "#FEFEFE"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                opacity: "0.9",
                                d: "M9.74219 17.1934C9.87852 17.459 10.8695 19.0329 10.954 19.27C11.2572 19.9563 11.3021 20.729 11.0806 21.4458C10.8591 22.1626 10.386 22.7752 9.74849 23.1707C9.7935 23.9237 10.1243 24.6311 10.6733 25.1485C11.2223 25.6658 11.9481 25.954 12.7024 25.9543H33.2286C34.0134 25.9531 34.7657 25.6409 35.3206 25.086C35.8755 24.5311 36.1877 23.7788 36.1888 22.994V11.0078H9.74219V17.1934ZM30.4261 13.3495C30.6717 13.3528 30.9061 13.4527 31.0786 13.6275C31.251 13.8023 31.3477 14.0381 31.3477 14.2837C31.3477 14.5292 31.251 14.765 31.0785 14.9398C30.906 15.1146 30.6717 15.2145 30.4261 15.2178C30.1805 15.2145 29.9461 15.1146 29.7736 14.9398C29.6012 14.7649 29.5045 14.5292 29.5045 14.2836C29.5045 14.038 29.6012 13.8023 29.7737 13.6275C29.9462 13.4527 30.1805 13.3528 30.4261 13.3495ZM30.4261 17.5469C30.6716 17.5503 30.9059 17.6502 31.0783 17.8251C31.2506 17.9999 31.3473 18.2355 31.3473 18.481C31.3473 18.7266 31.2506 18.9622 31.0782 19.137C30.9058 19.3118 30.6716 19.4117 30.4261 19.4152C30.1806 19.4117 29.9463 19.3118 29.7739 19.137C29.6016 18.9622 29.5049 18.7265 29.5049 18.481C29.5049 18.2355 29.6016 17.9999 29.774 17.825C29.9464 17.6502 30.1806 17.5503 30.4261 17.5469ZM30.4261 21.7442C30.6717 21.7475 30.9061 21.8474 31.0786 22.0223C31.251 22.1971 31.3477 22.4328 31.3477 22.6784C31.3477 22.924 31.251 23.1597 31.0785 23.3345C30.906 23.5094 30.6717 23.6092 30.4261 23.6126C30.1805 23.6092 29.9461 23.5093 29.7736 23.3345C29.6012 23.1597 29.5045 22.924 29.5045 22.6784C29.5045 22.4328 29.6012 22.1971 29.7737 22.0222C29.9462 21.8474 30.1805 21.7475 30.4261 21.7442ZM22.9655 13.3495C23.2111 13.3528 23.4455 13.4527 23.618 13.6275C23.7905 13.8023 23.8872 14.0381 23.8872 14.2837C23.8872 14.5292 23.7904 14.765 23.618 14.9398C23.4455 15.1146 23.2111 15.2145 22.9655 15.2178C22.7199 15.2145 22.4855 15.1146 22.3131 14.9398C22.1406 14.7649 22.0439 14.5292 22.0439 14.2836C22.0439 14.038 22.1406 13.8023 22.3131 13.6275C22.4856 13.4527 22.72 13.3528 22.9655 13.3495ZM22.9655 17.5469C23.211 17.5503 23.4453 17.6502 23.6177 17.8251C23.7901 17.9999 23.8867 18.2355 23.8867 18.481C23.8867 18.7266 23.79 18.9622 23.6177 19.137C23.4453 19.3118 23.211 19.4117 22.9655 19.4152C22.72 19.4117 22.4857 19.3118 22.3134 19.137C22.141 18.9622 22.0443 18.7265 22.0443 18.481C22.0443 18.2355 22.141 17.9999 22.3134 17.825C22.4858 17.6502 22.7201 17.5503 22.9655 17.5469ZM22.9655 21.7442C23.2111 21.7475 23.4455 21.8474 23.618 22.0223C23.7905 22.1971 23.8872 22.4328 23.8872 22.6784C23.8872 22.924 23.7904 23.1597 23.618 23.3345C23.4455 23.5094 23.2111 23.6092 22.9655 23.6126C22.7199 23.6092 22.4855 23.5094 22.3131 23.3345C22.1406 23.1597 22.0439 22.924 22.0439 22.6784C22.0439 22.4328 22.1406 22.1971 22.3131 22.0222C22.4856 21.8474 22.72 21.7475 22.9655 21.7442ZM15.505 13.3495C15.7493 13.3547 15.9818 13.4554 16.1527 13.63C16.3237 13.8047 16.4194 14.0393 16.4194 14.2837C16.4194 14.528 16.3236 14.7626 16.1527 14.9373C15.9818 15.1119 15.7492 15.2126 15.5049 15.2178C15.2606 15.2126 15.0281 15.1119 14.8572 14.9373C14.6862 14.7626 14.5905 14.528 14.5905 14.2836C14.5905 14.0393 14.6862 13.8046 14.8572 13.63C15.0281 13.4554 15.2607 13.3547 15.505 13.3495ZM15.505 17.5469C15.7493 17.552 15.9819 17.6527 16.1529 17.8273C16.3239 18.002 16.4196 18.2366 16.4196 18.481C16.4196 18.7254 16.3239 18.9601 16.1529 19.1347C15.9819 19.3094 15.7493 19.41 15.5049 19.4152C15.2606 19.41 15.028 19.3093 14.857 19.1347C14.686 18.9601 14.5902 18.7254 14.5902 18.481C14.5902 18.2366 14.686 18.002 14.857 17.8273C15.028 17.6527 15.2606 17.552 15.505 17.5469ZM15.505 21.7442C15.7493 21.7494 15.9819 21.8501 16.1529 22.0247C16.3239 22.1993 16.4197 22.434 16.4196 22.6784C16.4196 22.9228 16.3239 23.1575 16.1529 23.3321C15.9819 23.5067 15.7493 23.6074 15.5049 23.6126C15.2606 23.6074 15.028 23.5067 14.857 23.3321C14.686 23.1575 14.5902 22.9228 14.5902 22.6784C14.5902 22.434 14.686 22.1993 14.857 22.0247C15.028 21.85 15.2606 21.7494 15.505 21.7442Z",
                                fill: "#FEFEFE"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.993 30.9786L19.7586 29.6342C19.5111 29.4866 19.2327 29.3987 18.9453 29.3775C18.6579 29.3563 18.3695 29.4024 18.1031 29.512C17.8366 29.6217 17.5993 29.7919 17.4101 30.0092C17.2209 30.2266 17.0849 30.485 17.013 30.7641C16.9356 30.9948 16.8076 31.2054 16.6383 31.3802C16.4689 31.5551 16.2626 31.6898 16.0344 31.7746C15.8062 31.8593 15.5619 31.8919 15.3195 31.8699C15.0771 31.848 14.8427 31.772 14.6334 31.6476C13.2117 30.7997 11.9014 29.7777 10.7327 28.6054C9.56324 27.4388 8.54149 26.133 7.69034 24.7173C7.56427 24.5008 7.48903 24.2585 7.47032 24.0087C7.4516 23.7589 7.4899 23.5081 7.58232 23.2753C7.67473 23.0424 7.81885 22.8336 8.00378 22.6646C8.18871 22.4957 8.40963 22.3709 8.64984 22.2998C8.89934 22.2223 9.12966 22.0929 9.32573 21.9202C9.52179 21.7475 9.67919 21.5353 9.78762 21.2976C9.89604 21.0599 9.95306 20.802 9.95494 20.5407C9.95681 20.2794 9.90351 20.0207 9.79851 19.7814C9.84927 19.8024 8.3863 17.4031 8.35944 17.345C8.10616 16.9272 7.69801 16.6264 7.22391 16.5081C6.74982 16.3899 6.24821 16.4639 5.8284 16.7139C4.45345 17.5364 3.44502 18.8536 3.00966 20.3955C2.57429 21.9374 2.74495 23.5875 3.48667 25.0076C5.89802 29.647 9.67986 33.431 14.3178 35.8451C15.738 36.5888 17.3888 36.7613 18.9321 36.3271C20.4753 35.8929 21.794 34.8849 22.6179 33.5097C22.8707 33.0912 22.9468 32.5894 22.8297 32.1147C22.7125 31.6401 22.4115 31.2314 21.993 30.9786Z",
                                fill: "#FEFEFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            marginLeft: '7px'
                        },
                        children: "Book a Call"
                    })
                ]
            }),
            buttonIdentifier: 'book-call',
            buttonRegisterBox: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: "w100 df jcsb px0-5rem aic",
                href: "https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true",
                target: "_blank",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcfs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pl0-25rem fw600 c1 mr0-5rem",
                                    children: "Book a Call"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "34",
                                height: "34",
                                viewBox: "0 0 95 95",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M81.3165 10.5507H73.9019C73.902 9.9069 73.7673 9.27017 73.5065 8.68151C73.2457 8.09286 72.8646 7.56533 72.3876 7.13287C71.9106 6.70041 71.3484 6.3726 70.7371 6.17054C70.1258 5.96847 69.4789 5.89663 68.8382 5.95964C67.676 6.10346 66.6081 6.67196 65.8399 7.55576C65.0717 8.43956 64.6574 9.57622 64.6768 10.7471V12.8569C64.6766 13.9143 65.0397 14.9397 65.7053 15.7613C66.3708 16.5829 67.2985 17.151 68.3329 17.3702C68.6289 17.4261 68.8914 17.5954 69.0642 17.8421C69.2371 18.0888 69.3067 18.3933 69.2581 18.6905C69.2096 18.9878 69.0467 19.2543 68.8044 19.4332C68.562 19.6121 68.2593 19.6891 67.9609 19.6479C66.387 19.3382 64.9692 18.4919 63.9497 17.2535C62.9302 16.015 62.3721 14.4611 62.3706 12.8569V10.5507H49.5247C49.5191 9.94018 49.3923 9.33682 49.1518 8.77562C48.9112 8.21442 48.5617 7.70655 48.1234 7.28145C47.6851 6.85635 47.1668 6.52246 46.5985 6.29915C46.0302 6.07584 45.4233 5.96755 44.8128 5.98054C44.2024 5.99354 43.6006 6.12758 43.0423 6.37487C42.4841 6.62217 41.9805 6.97781 41.5607 7.42119C41.1409 7.86457 40.8133 8.38685 40.5968 8.95778C40.3804 9.52871 40.2794 10.1369 40.2998 10.7472L40.2997 12.8569C40.2995 13.9143 40.6626 14.9397 41.3281 15.7613C41.9937 16.5829 42.9214 17.1509 43.9558 17.3702C44.2517 17.4261 44.5141 17.5955 44.6869 17.8421C44.8597 18.0888 44.9293 18.3932 44.8807 18.6905C44.8322 18.9877 44.6694 19.2542 44.4271 19.4331C44.1848 19.6119 43.8821 19.689 43.5838 19.6478C42.0098 19.3382 40.5921 18.4919 39.5726 17.2534C38.5531 16.0149 37.995 14.461 37.9935 12.8569V10.5507H30.5788C28.7449 10.5541 26.9871 11.2842 25.6903 12.5809C24.3936 13.8777 23.6636 15.6355 23.6602 17.4694V23.8923H88.2353V17.4694C88.2318 15.6355 87.5018 13.8777 86.205 12.5809C84.9082 11.2842 83.1504 10.5541 81.3165 10.5507ZM42.6059 10.5507C42.6149 9.94499 42.8619 9.36709 43.2934 8.94191C43.7249 8.51672 44.3064 8.27839 44.9122 8.2784C45.518 8.27841 46.0995 8.51677 46.5311 8.94197C46.9626 9.36717 47.2095 9.94508 47.2184 10.5508L42.6059 10.5507ZM66.9831 10.5507C66.9921 9.94499 67.239 9.36709 67.6705 8.94191C68.1021 8.51672 68.6836 8.27839 69.2894 8.2784C69.8952 8.27841 70.4767 8.51677 70.9082 8.94197C71.3397 9.36717 71.5866 9.94508 71.5956 10.5508L66.9831 10.5507Z",
                                        fill: "#fff"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M23.7402 41.881C24.0723 42.528 26.4863 46.3619 26.6922 46.9393C27.4306 48.611 27.5401 50.4932 27.0005 52.2392C26.4609 53.9853 25.3085 55.4775 23.7556 56.4411C23.8652 58.2753 24.671 59.9985 26.0083 61.2587C27.3456 62.5188 29.1136 63.2209 30.9511 63.2215H80.9508C82.8624 63.2188 84.6949 62.4582 86.0466 61.1064C87.3983 59.7547 88.1589 57.9222 88.1616 56.0106V26.8135H23.7402V41.881ZM74.1242 32.5175C74.7224 32.5256 75.2933 32.7689 75.7134 33.1948C76.1336 33.6207 76.3691 34.1948 76.3691 34.7931C76.3691 35.3913 76.1335 35.9655 75.7134 36.3914C75.2932 36.8172 74.7223 37.0605 74.1241 37.0686C73.5259 37.0605 72.955 36.8172 72.5348 36.3913C72.1147 35.9654 71.8791 35.3912 71.8791 34.793C71.8791 34.1948 72.1147 33.6206 72.5349 33.1947C72.955 32.7689 73.526 32.5256 74.1242 32.5175ZM74.1242 42.742C74.7222 42.7503 75.2928 42.9938 75.7127 43.4196C76.1326 43.8454 76.368 44.4195 76.368 45.0175C76.368 45.6155 76.1326 46.1895 75.7127 46.6154C75.2927 47.0412 74.7221 47.2846 74.1241 47.2929C73.5261 47.2846 72.9555 47.0411 72.5355 46.6153C72.1156 46.1895 71.8802 45.6154 71.8803 45.0174C71.8803 44.4194 72.1157 43.8454 72.5356 43.4195C72.9555 42.9937 73.5262 42.7503 74.1242 42.742ZM74.1242 52.9662C74.7224 52.9743 75.2933 53.2177 75.7134 53.6435C76.1336 54.0694 76.3691 54.6436 76.3691 55.2418C76.3691 55.8401 76.1335 56.4143 75.7134 56.8401C75.2932 57.266 74.7223 57.5093 74.1241 57.5173C73.5259 57.5092 72.955 57.2659 72.5348 56.8401C72.1147 56.4142 71.8791 55.84 71.8791 55.2418C71.8791 54.6435 72.1147 54.0693 72.5349 53.6435C72.955 53.2176 73.526 52.9743 74.1242 52.9662ZM55.951 32.5175C56.5492 32.5256 57.1201 32.7689 57.5402 33.1948C57.9604 33.6207 58.1959 34.1948 58.1959 34.7931C58.1959 35.3913 57.9603 35.9655 57.5402 36.3914C57.12 36.8172 56.5491 37.0605 55.9509 37.0686C55.3527 37.0605 54.7818 36.8172 54.3616 36.3913C53.9415 35.9655 53.7059 35.3913 53.7059 34.793C53.7059 34.1948 53.9415 33.6206 54.3616 33.1947C54.7818 32.7689 55.3528 32.5256 55.951 32.5175ZM55.951 42.742C56.549 42.7503 57.1196 42.9938 57.5395 43.4196C57.9594 43.8454 58.1948 44.4195 58.1948 45.0175C58.1948 45.6155 57.9594 46.1895 57.5395 46.6154C57.1195 47.0412 56.5489 47.2846 55.9509 47.2929C55.3529 47.2846 54.7822 47.0411 54.3623 46.6153C53.9424 46.1895 53.707 45.6155 53.707 45.0174C53.707 44.4194 53.9424 43.8454 54.3624 43.4196C54.7823 42.9937 55.353 42.7503 55.951 42.742ZM55.951 52.9662C56.5492 52.9743 57.1201 53.2177 57.5402 53.6435C57.9604 54.0694 58.1959 54.6436 58.1959 55.2418C58.1959 55.8401 57.9603 56.4143 57.5402 56.8401C57.12 57.266 56.5491 57.5093 55.9509 57.5173C55.3527 57.5093 54.7818 57.2659 54.3616 56.8401C53.9415 56.4142 53.7059 55.84 53.7059 55.2418C53.7059 54.6435 53.9415 54.0694 54.3616 53.6435C54.7818 53.2176 55.3528 52.9743 55.951 52.9662ZM37.7778 32.5175C38.3729 32.5302 38.9393 32.7756 39.3557 33.2009C39.772 33.6263 40.0052 34.1979 40.0052 34.7931C40.0051 35.3883 39.772 35.9599 39.3556 36.3852C38.9392 36.8106 38.3728 37.0559 37.7777 37.0686C37.1826 37.0559 36.6161 36.8105 36.1998 36.3852C35.7834 35.9598 35.5502 35.3883 35.5502 34.7931C35.5502 34.1978 35.7834 33.6263 36.1998 33.2009C36.6161 32.7755 37.1827 32.5302 37.7778 32.5175ZM37.7778 42.742C38.373 42.7545 38.9396 42.9998 39.3561 43.4252C39.7726 43.8505 40.0058 44.4222 40.0058 45.0175C40.0058 45.6128 39.7725 46.1845 39.356 46.6098C38.9395 47.0352 38.3729 47.2804 37.7777 47.2929C37.1825 47.2804 36.6159 47.0352 36.1994 46.6098C35.7829 46.1844 35.5496 45.6128 35.5496 45.0175C35.5496 44.4221 35.7829 43.8505 36.1994 43.4251C36.6159 42.9998 37.1826 42.7545 37.7778 42.742ZM37.7778 52.9662C38.373 52.9788 38.9396 53.2241 39.3561 53.6495C39.7726 54.0748 40.0059 54.6465 40.0058 55.2418C40.0058 55.8372 39.7726 56.4088 39.356 56.8342C38.9395 57.2596 38.3729 57.5048 37.7777 57.5173C37.1825 57.5048 36.6158 57.2596 36.1993 56.8342C35.7828 56.4088 35.5495 55.8371 35.5495 55.2418C35.5495 54.6465 35.7828 54.0748 36.1993 53.6494C36.6158 53.224 37.1826 52.9788 37.7778 52.9662Z",
                                        fill: "#fff"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M53.5806 75.4594L48.1378 72.1845C47.535 71.825 46.8566 71.6109 46.1566 71.5592C45.4566 71.5076 44.7542 71.6198 44.1051 71.8869C43.456 72.154 42.878 72.5687 42.4171 73.0981C41.9562 73.6275 41.625 74.257 41.4498 74.9367C41.2614 75.4989 40.9494 76.0118 40.5369 76.4377C40.1244 76.8636 39.6218 77.1918 39.066 77.3982C38.5101 77.6046 37.9151 77.684 37.3246 77.6305C36.7341 77.577 36.1631 77.392 35.6533 77.0891C32.1903 75.0235 28.9984 72.5341 26.1516 69.6785C23.3029 66.8367 20.814 63.6559 18.7408 60.2074C18.4336 59.6801 18.2504 59.0899 18.2048 58.4814C18.1592 57.8729 18.2525 57.262 18.4776 56.6948C18.7027 56.1276 19.0538 55.619 19.5042 55.2074C19.9547 54.7958 20.4928 54.4919 21.078 54.3188C21.6857 54.1298 22.2468 53.8147 22.7244 53.394C23.202 52.9733 23.5854 52.4565 23.8495 51.8775C24.1136 51.2984 24.2525 50.6701 24.2571 50.0336C24.2616 49.3972 24.1318 48.767 23.876 48.1841C23.9997 48.2353 20.436 42.3909 20.3706 42.2493C19.7536 41.2315 18.7594 40.4988 17.6046 40.2108C16.4497 39.9228 15.2279 40.103 14.2053 40.712C10.856 42.7156 8.39958 45.924 7.33908 49.68C6.27858 53.4359 6.69428 57.4553 8.50103 60.9147C14.3748 72.2157 23.587 81.4332 34.8846 87.3135C38.344 89.1253 42.3653 89.5454 46.1244 88.4877C49.8835 87.43 53.0958 84.9747 55.1028 81.6248C55.7185 80.6054 55.904 79.3831 55.6186 78.2269C55.3331 77.0706 54.6 76.0751 53.5806 75.4594Z",
                                        fill: "#fff"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint0_linear_2144_3945",
                                                x1: "100.505",
                                                y1: "-6.84034",
                                                x2: "87.1291",
                                                y2: "48.007",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#A0B0FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#4A67FF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint1_linear_2144_3945",
                                                x1: "100.402",
                                                y1: "0.903071",
                                                x2: "53.5146",
                                                y2: "95.4935",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#A0B0FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#4A67FF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint2_linear_2144_3945",
                                                x1: "58.1988",
                                                y1: "-66.4606",
                                                x2: "-23.2711",
                                                y2: "329.322",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#FFACB0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#FF3F7A"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "20",
                        height: "17",
                        viewBox: "0 0 28 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                            fill: "white"
                        })
                    })
                ]
            })
        },
        'Portfolio Pro': {
            title: 'Portfolio Pro',
            price: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "c4",
                children: "FREE"
            }),
            subTitle: plan == "Portfolio Pro" && isAdvisor && !isInvestor ? 'For Advisors' : plan == "Portfolio Pro" && isInvestor && !isAdvisor ? 'For Investors' : 'For Advisors and Investors',
            points: [
                "Collaboration ecosystem",
                'FREE accounts for advisors and investors',
                'FREE Portfolio dashboard to monitor client/investee company progress',
                'FREE tools eg. bespoked anyList checklist  builder, client benchmarking, activity updates',
                'Advisors - FREE revenue generating services - context sensitive service leads, Diligentsia Pro Plus, ResearchAid report builder',
                'Investors - FREE curated leads with diligence packs, matching your investment criteria',
                'Investors - FREE investor match applicant company triage module.',
                'Either you subscribe your companies and recharge, OR your companies subscribe via an invitation from you via your dashboard'
            ],
            isButtonText: true,
            buttonText: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcc fdc aic w100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            lineHeight: '13px'
                        },
                        children: "Try for FREE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fw400 c21",
                        style: {
                            lineHeight: '13px',
                            fontStyle: 'italic',
                            fontSize: '10px'
                        },
                        children: "No credit card required"
                    })
                ]
            }),
            hasHightlightSection: true,
            buttonIdentifier: 'register',
            // titleRegisterBox: isAdvisor ? 'Advisor?' : 'Investor?',
            // descriptionRegisterBox: `Use Diligentsia Portfolio Pro for FREE. FREE modules. Add/invite your ${isAdvisor ? ' clients' : ' portfolio companies'}.`,
            buttonRegisterBox: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: "w100 df jcsb aic",
                href: "/register",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "fw600 c1 tal",
                        children: [
                            "Register for FREE",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-5rem db fsi",
                                children: "Upgrade from your dashboard"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "20",
                        height: "17",
                        viewBox: "0 0 28 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                            fill: "white"
                        })
                    })
                ]
            })
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${component == 'Pricing Plan' ? ' w20' : ' w100'} new-shadow bg1 df fdc jcsb br10px pricing-box pr pb4rem`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pr w100 bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "top-pricing-area pr",
                        children: [
                            plan == 'Pro' && !isAdvisor && !isInvestor ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pricingCardHeader bg4 c1",
                                children: "Most Popular"
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: `pr w100 ${component == 'Dashboard' && plan !== 'Pro' && ' small-img'}`,
                                src: (parcelRequire("jFPjW"))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pa df fdc jcfs w100 t0 h100",
                                style: {
                                    paddingTop: "10px"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr df aic jcc fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "fs2rem fw800 c24 ",
                                            style: {
                                                lineHeight: '40px'
                                            },
                                            children: plan
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                            className: "fs1rem fw400 c24",
                                            style: {
                                                fontSize: '13px',
                                                lineHeight: '15px'
                                            },
                                            children: data?.[plan]?.['subTitle']
                                        }),
                                        plan == "Lite" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "fs1-5rem c1 fw500",
                                                children: [
                                                    "\xa3",
                                                    8.25,
                                                    " per month"
                                                ]
                                            })
                                        }),
                                        plan == "Pro" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "fs1-5rem c1 fw500",
                                                children: [
                                                    "\xa3",
                                                    83.25,
                                                    " per year"
                                                ]
                                            })
                                        }),
                                        plan == "Portfolio Pro" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "c1 fs14px",
                                            children: "Free"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "pricing-inner",
                        children: data?.[plan]?.['points'].map((point, idx)=>{
                            if (plan == "Portfolio Pro" && idx == 4 && !isAdvisor || plan == "Portfolio Pro" && (idx == 5 || idx === 6) && !isInvestor) return;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `df p0-5rem aic`,
                                style: {
                                    backgroundColor: plan == "Portfolio Pro" && idx == 4 ? '#F9E84B' : plan == "Portfolio Pro" && idx == 5 ? '#91F5C5' : "#fff"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '30px',
                                            maxWidth: '30px',
                                            minWidth: '30px'
                                        },
                                        children: plan == 'Lite' && (idx == 6 || idx == 7 || idx == 8) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "14",
                                            height: "14",
                                            viewBox: "0 0 14 14",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                    "clip-path": "url(#clip0_1498_30535)",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M8.28261 7.00778L13.7339 1.55629C14.0887 1.20169 14.0887 0.628357 13.7339 0.27376C13.3793 -0.0808367 12.806 -0.0808367 12.4514 0.27376L6.99992 5.72525L1.5486 0.27376C1.19384 -0.0808367 0.620669 -0.0808367 0.266072 0.27376C-0.0886907 0.628357 -0.0886907 1.20169 0.266072 1.55629L5.71739 7.00778L0.266072 12.4593C-0.0886907 12.8139 -0.0886907 13.3872 0.266072 13.7418C0.442789 13.9187 0.675145 14.0075 0.907336 14.0075C1.13953 14.0075 1.37172 13.9187 1.5486 13.7418L6.99992 8.2903L12.4514 13.7418C12.6283 13.9187 12.8605 14.0075 13.0927 14.0075C13.3249 14.0075 13.5571 13.9187 13.7339 13.7418C14.0887 13.3872 14.0887 12.8139 13.7339 12.4593L8.28261 7.00778Z",
                                                        fill: "#ED1C24"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                        id: "clip0_1498_30535",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                            width: "14",
                                                            height: "14",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "21",
                                            height: "14",
                                            viewBox: "0 0 21 14",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M8.24482 13.3358C8.08872 13.339 7.93353 13.3112 7.78826 13.2541C7.64299 13.1969 7.51053 13.1116 7.39855 13.0029L1.2696 6.8569C1.05196 6.63957 0.929687 6.3448 0.929688 6.03744C0.929687 5.73008 1.05196 5.43531 1.2696 5.21797C1.48724 5.00064 1.78242 4.87853 2.09021 4.87853C2.398 4.87853 2.69318 5.00064 2.91082 5.21797L8.24482 10.5189L18.2204 0.531648C18.4476 0.322891 18.7451 0.207031 19.0538 0.207031C19.3626 0.207031 19.6601 0.322891 19.8873 0.531648C20.1081 0.752507 20.2321 1.05183 20.2321 1.36391C20.2321 1.67599 20.1081 1.97533 19.8873 2.19619L9.06543 13.0029C8.95734 13.1096 8.8292 13.194 8.68837 13.2511C8.54755 13.3082 8.39682 13.337 8.24482 13.3358Z",
                                                fill: "#42D342"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `fw400 c14 tal ml0-5rem`,
                                        style: {
                                            fontSize: '12px',
                                            lineHeight: '18px'
                                        },
                                        children: point
                                    })
                                ]
                            });
                        })
                    })
                ]
            }),
            component == 'Billing' && data?.[plan]?.['isButtonText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc mt2rem",
                style: {
                    marginBottom: '-25px'
                },
                onClick: ()=>handlePaymentPopup(plan),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "registerButtonAnimation bg4 fw700 fs0-75rem c1 py0-5rem px0-5rem df jcc aic br45px cp",
                    style: {
                        lineHeight: '25.5px',
                        width: '64%'
                    },
                    children: data?.[plan]?.['buttonText']
                })
            }),
            component == 'PricingPlan' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "booking-sec df jcsb aife mla mra pr",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 bg1 br15px pricing-bottom-box",
                    children: [
                        plan == "Pro PLUS" ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "p1rem bsbb w100 tac",
                            children: data?.[plan]?.['bookCallBox']
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "px1rem pt1rem pb0-5rem bsbb w100 tac",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c15 fs1rem fw600 mb0-5rem",
                                    children: data?.[plan]?.['titleRegisterBox']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c14 f1rem px2rem pb0-5rem",
                                    children: data?.[plan]?.['descriptionRegisterBox']
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>localStorage.removeItem('registerAs'),
                            className: `w100 df cp bg4 df jcsb aic pl1rem pr1rem fs1rem`,
                            children: data?.[plan]?.['buttonRegisterBox']
                        })
                    ]
                })
            })
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");





var $d9f195cb3938646c$exports = {};

var $lsJ54 = parcelRequire("lsJ54");
var $6d38303b9c8735ba$exports = {};

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
$6d38303b9c8735ba$exports = $6d38303b9c8735ba$var$now;



/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $dc614d828223dea6$exports(wait) || 0;
    if ($lsJ54(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($dc614d828223dea6$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d38303b9c8735ba$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d38303b9c8735ba$exports());
    }
    function debounced() {
        var time = $6d38303b9c8735ba$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$d9f195cb3938646c$exports = $d9f195cb3938646c$var$debounce;


const $ad3f4ba95a56a8c7$export$c42ffaf52eb2647 = {
    subscriptionUpgrade: {
        title: "Please confirm you wish to purchase this upgrade",
        subtitle: "Billed annually in advance"
    },
    discountCode: {
        title: "Do you have a discount code?",
        subtitle: "Your Advisor or Investor may have provided you with a discount code"
    },
    freeMembership: {
        title: "You have selected a FREE subscription",
        subtitle: "(and that's great, thanks)"
    },
    modulePurchase: {
        title: "Please confirm you wish to purchase this module",
        subtitle: "This is a one-time purchase, not an annual charge."
    },
    tempModulePurchase: {
        title: "Please confirm you wish to purchase this module",
        subtitle: "This is a one-time purchase, not an annual charge."
    },
    freeModule: {
        title: "Please confirm you wish to start using this module"
    }
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $95ea3a8d1d92a206$var$PurchaseInfo = ({ text: text })=>/*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
        className: "c15 op70 fs1rem my0-5rem tac fw500",
        style: {
            letterSpacing: '0.5px'
        },
        children: text
    });
var $95ea3a8d1d92a206$export$2e2bcd8739ae039 = $95ea3a8d1d92a206$var$PurchaseInfo;



var $ayMG0 = parcelRequire("ayMG0");

const $0bfdb01edfcd4501$var$ActionButtons = ({ onCancel: onCancel, onConfirm: onConfirm, confirmText: confirmText = "Purchase Subscription", plan: plan, disabled: disabled, step: step })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df aifs jcc mt2rem w100 px2rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                onClick: onCancel,
                btnType: "warningOutlined",
                customClassName: "mr0-5rem w100",
                text: "Cancel",
                style: {
                    width: '280px'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic jcc w100",
                style: {
                    width: '280px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        onClick: onConfirm,
                        disabled: disabled,
                        btnType: "warning",
                        customClassName: "w100",
                        text: confirmText
                    }),
                    step && !step.toLowerCase().includes('free') && !plan.toLowerCase().includes('free') && !plan.toLowerCase().includes('discount') ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op70 fs12px",
                        children: "A Stripe payment window will open"
                    }) : null
                ]
            })
        ]
    });
var $0bfdb01edfcd4501$export$2e2bcd8739ae039 = $0bfdb01edfcd4501$var$ActionButtons;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $f5b44d85b61a8772$var$PromoCodeInput = ({ promoCode: promoCode, setPromoCode: setPromoCode, isValid: isValid, isChecking: isChecking })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'relative',
            width: '300px'
        },
        className: "mt1rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                placeholder: "Enter a diligentsia discount code",
                className: `px1rem py0-75rem bo42 bss bw1px br10px fs14px w100 ${!isValid && promoCode ? 'border-red' : ''}`,
                value: promoCode,
                onKeyDown: (e)=>e.key === ' ' && e.preventDefault(),
                onChange: (e)=>setPromoCode(e.target.value.replace(/\s/g, ''))
            }),
            promoCode.trim() !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>setPromoCode(""),
                className: "clear-input-btn pa t10px r10px bg44",
                "aria-label": "Clear input",
                children: "\xd7"
            }),
            isChecking && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "c15 op70 fs12px mt1rem",
                children: "Checking code..."
            }),
            !isValid && promoCode && !isChecking && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "c15 op70 fs12px mt1rem text-red",
                children: "Invalid code"
            })
        ]
    });
var $f5b44d85b61a8772$export$2e2bcd8739ae039 = $f5b44d85b61a8772$var$PromoCodeInput;



const $da20b8fe5a9fd138$var$SubscriptionPaymentConfirm = ({ plan: plan, companyId: companyId, defaultStep: defaultStep, setShowExpension: setShowExpension, payload: payload, setModuleTab: setModuleTab, module: module, navigateTo: navigateTo, onCancel: onCancel })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modalState = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { open: open } = modalState;
    const effectivePlan = modalState.purchasePlan || plan;
    const effectiveModule = modalState.modulePurchase || module;
    const effectiveDefaultStep = modalState.purchaseDefaultStep || defaultStep;
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [promoCode, setPromoCode] = (0, $acw62.useState)("");
    const [promoCodeData, setPromoCodeData] = (0, $acw62.useState)(null);
    const [isValidCoupon, setIsValidCoupon] = (0, $acw62.useState)(true);
    const [isCheckingCoupon, setIsCheckingCoupon] = (0, $acw62.useState)(false);
    const [step, setStep] = (0, $acw62.useState)(defaultStep ?? "subscriptionUpgrade");
    const resolveCouponAmount = (0, $acw62.useCallback)(()=>{
        if (effectivePlan === 'tempModulePurchase' && effectiveModule?.price != null) {
            const n = parseFloat(String(effectiveModule.price).replace(/[^0-9.]/g, ''));
            return Number.isFinite(n) ? n : (0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[plan]?.price;
        }
        return (0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[plan]?.price;
    }, [
        effectivePlan,
        effectiveModule,
        plan
    ]);
    const checkCoupon = (0, $acw62.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(async (code)=>{
        if (!code) {
            setIsValidCoupon(true);
            setIsCheckingCoupon(false);
            return;
        }
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/checkCoupon/${code}`, {
                amount: resolveCouponAmount()
            });
            setPromoCodeData(response?.body);
            setIsValidCoupon(response?.code === 200);
        } catch (error) {
            setIsValidCoupon(false);
        } finally{
            setIsCheckingCoupon(false);
        }
    }, 1000), [
        plan,
        resolveCouponAmount
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsCheckingCoupon(true);
        checkCoupon(promoCode);
    }, [
        promoCode,
        checkCoupon
    ]);
    (0, $acw62.useEffect)(()=>{
        const stepDefault = modalState.purchaseDefaultStep || defaultStep;
        if (stepDefault) setStep(stepDefault);
        else {
            if (effectivePlan === "Free") setStep("freeMembership");
            else if (effectivePlan === "modulePurchase") setStep("modulePurchase");
            else if (effectivePlan === "tempModulePurchase") setStep("tempModulePurchase");
            else if (typeof effectivePlan === 'string' && (effectivePlan.startsWith('two-minute-') || effectivePlan.startsWith('investor-lead'))) setStep("freeModule");
            else setStep("subscriptionUpgrade");
        }
    }, [
        plan,
        open,
        effectivePlan,
        defaultStep,
        modalState.purchaseDefaultStep
    ]);
    const handleClose = ()=>{
        setPromoCodeData(null);
        setPromoCode("");
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: '',
            modulePurchase: undefined,
            purchasePlan: undefined,
            purchaseDefaultStep: undefined
        }));
        setStep("subscriptionUpgrade");
        window.history.replaceState(null, null, '');
        if (setShowExpension) setShowExpension(null);
        if (onCancel) onCancel();
    };
    const handlePurchase = async ()=>{
        setLoading(true);
        if (effectivePlan === "Free") {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/payment/freeSubscription/${companyId}`);
            if (response?.code === 200) {
                if (navigateTo) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                else setTimeout(()=>location.href = `/company/${companyId}`, 1000);
            }
        } else {
            const data = {
                endPoint: `/payment/upgrade-subscription/${companyId}`,
                payload: {
                    packageName: effectivePlan,
                    ...promoCodeData && {
                        promoCode: promoCodeData.stripePromotionCodeId
                    }
                }
            };
            if ([
                'Free',
                'Lite',
                'Pro'
            ].includes(effectivePlan) && promoCodeData && promoCodeData?.discountType === "percentage" && promoCodeData?.discountValue === 100) {
                data.endPoint = `/payment/subscriptionWithAccessCode/${companyId}`;
                data.payload = {
                    packageName: effectivePlan,
                    promoCode: promoCodeData.code
                };
            }
            if (effectivePlan === 'tempModulePurchase' || effectiveDefaultStep === 'tempModulePurchase') {
                data.endPoint = `/modules/purchase-temp-module/${companyId}`;
                data.payload = {
                    tempModuleId: effectiveModule?.tempModuleId,
                    ...promoCodeData && {
                        promoCode: promoCodeData.stripePromotionCodeId
                    }
                };
                if (promoCodeData && promoCodeData?.discountType === "percentage" && promoCodeData?.discountValue === 100) {
                    data.endPoint = `/modules/purchase-temp-module-with-access-code/${companyId}`;
                    data.payload = {
                        tempModuleId: effectiveModule?.tempModuleId,
                        promoCode: promoCodeData.code
                    };
                }
            } else if (effectiveDefaultStep === "modulePurchase") {
                data.endPoint = `/payment/purchase-expansion/${companyId}`;
                data.payload = {
                    expansionName: effectivePlan,
                    ...promoCodeData && {
                        promoCode: promoCodeData.stripePromotionCodeId
                    }
                };
                if (promoCodeData && promoCodeData?.discountType === "percentage" && promoCodeData?.discountValue === 100) {
                    data.endPoint = `/payment/addExpensionPackWithAccessCode/${companyId}`;
                    data.payload = {
                        expansionName: effectivePlan,
                        promoCode: promoCodeData.code
                    };
                }
            }
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${data?.endPoint}`, data?.payload);
            if (response?.code === 200) {
                if (response.body?.url) window.location.href = response.body.url;
                else window.location.href = `/company/${companyId}`;
                if (setShowExpension) setShowExpension(null);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    modulePurchase: undefined,
                    purchasePlan: undefined,
                    purchaseDefaultStep: undefined
                }));
                setPromoCode("");
            }
        }
        setLoading(false);
    };
    const { title: title, subtitle: subtitle } = (0, $ad3f4ba95a56a8c7$export$c42ffaf52eb2647)[step] ?? {};
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        onCloseHandler: handleClose,
        modalType: "subscriptionPaymentConfirm",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc jcc aic",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: {
                        width: '93px',
                        height: '75px'
                    },
                    src: (parcelRequire("jdo6l")),
                    alt: "logoDiligentsia"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "c15 tac mt1rem fw400 fs22px",
                    children: title
                }),
                navigateTo && step === "discountCode" ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c15 op60 fs10px my0-5rem tac fw500",
                    children: subtitle
                }),
                step === "subscriptionUpgrade" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95ea3a8d1d92a206$export$2e2bcd8739ae039), {
                            text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "You are buying the ",
                                    effectivePlan,
                                    " subscription at",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "\xa3",
                                    Number((0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[effectivePlan]?.price / 12).toFixed(2),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "fs0-75rem c14 fw300",
                                        children: "(plus VAT)"
                                    }),
                                    " per month for 12 months"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bfdb01edfcd4501$export$2e2bcd8739ae039), {
                            disabled: loading,
                            plan: effectivePlan,
                            onCancel: handleClose,
                            onConfirm: ()=>setStep("discountCode")
                        })
                    ]
                }),
                step === "discountCode" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5b44d85b61a8772$export$2e2bcd8739ae039), {
                            promoCode: promoCode,
                            setPromoCode: setPromoCode,
                            isValid: isValidCoupon,
                            isChecking: isCheckingCoupon
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc aic jcc w100 mt3rem mb1rem",
                            style: {
                                width: '280px'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                onClick: handlePurchase,
                                btnType: "warning",
                                customClassName: "w100",
                                text: "Continue to Purchase",
                                disabled: loading || isCheckingCoupon || !isValidCoupon && promoCode !== ''
                            })
                        })
                    ]
                }),
                step === "freeMembership" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95ea3a8d1d92a206$export$2e2bcd8739ae039), {
                            text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "The ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c59 op70 ttu",
                                        children: plan
                                    }),
                                    " subscription offers a great deal more and is ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " only \xa3",
                                    (0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[plan]?.price,
                                    " per year. No credit card required. Later you can upgrade to Lite or Pro from within your dashboard."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bfdb01edfcd4501$export$2e2bcd8739ae039), {
                            disabled: loading,
                            plan: plan,
                            step: step,
                            onCancel: handleClose,
                            onConfirm: handlePurchase,
                            confirmText: "Subscribe for Free"
                        })
                    ]
                }),
                step === "modulePurchase" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95ea3a8d1d92a206$export$2e2bcd8739ae039), {
                            text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "The module is ",
                                    module && typeof module !== "string" ? module['type'] : (0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[plan]?.name,
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "The module price is ",
                                    module && typeof module !== "string" ? module['price'] : `\xa3${(0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)[plan]?.price}`,
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "fs0-75rem c14 fw300",
                                        children: "(plus VAT)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bfdb01edfcd4501$export$2e2bcd8739ae039), {
                            disabled: loading,
                            plan: defaultStep,
                            onCancel: handleClose,
                            onConfirm: ()=>setStep("discountCode")
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
                step === "tempModulePurchase" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95ea3a8d1d92a206$export$2e2bcd8739ae039), {
                            text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "The module is ",
                                    effectiveModule?.moduleName || "\u2014",
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    effectiveModule?.subscriptionTier != null && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Subscription: ",
                                            String(effectiveModule.subscriptionTier),
                                            " \xb7 Objective: ",
                                            String(effectiveModule.companyObjective || "\u2014"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                        ]
                                    }),
                                    "The module price is \xa3",
                                    effectiveModule?.price != null ? effectiveModule.price : "\u2014",
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-75rem c14 fw300",
                                        children: "(plus VAT)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bfdb01edfcd4501$export$2e2bcd8739ae039), {
                            disabled: loading,
                            plan: effectiveDefaultStep,
                            onCancel: handleClose,
                            onConfirm: ()=>setStep("discountCode")
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
                step === "freeModule" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95ea3a8d1d92a206$export$2e2bcd8739ae039), {
                            text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "The module is ",
                                    payload.module.heading,
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "This module is free to use"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bfdb01edfcd4501$export$2e2bcd8739ae039), {
                            disabled: loading,
                            plan: plan,
                            onCancel: handleClose,
                            onConfirm: ()=>{
                                setModuleTab && setModuleTab(payload.setTab, payload.type, payload.module);
                            },
                            confirmText: "Start Module"
                        })
                    ]
                })
            ]
        })
    });
};
var $da20b8fe5a9fd138$export$2e2bcd8739ae039 = $da20b8fe5a9fd138$var$SubscriptionPaymentConfirm;



const $ad0085a37e9bcb7a$var$BillingDetail = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [plan, setPlan] = (0, $acw62.useState)();
    let [stripeHistory, setStripeHistory] = (0, $acw62.useState)();
    let [upcomingInvoice, setUpcomingInvoice] = (0, $acw62.useState)();
    let [company, setCompany] = (0, $acw62.useState)(null);
    const { id: companyId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const selectedPlan = searchParams.get('plan') || 'Free';
    (0, $acw62.useEffect)(()=>{
        if (!company) getCompany();
    }, []);
    const getCompany = async ()=>{
        let res1 = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}`);
        if (res1?.['code'] == 200) setCompany(res1?.['body']);
    };
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            if (companyId !== "all") {
                res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/payment/stripeHistory/${companyId}`, 'not-showMessage');
                if (res && res.code == 200 && res.body) setStripeHistory(res.body);
                res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/payment/upcomingInvoice/${companyId}`, 'not-showMessage');
                if (res && res.code == 200 && res.body) setUpcomingInvoice(res.body);
            }
        })();
    }, [
        companyId
    ]);
    const handlePaymentPopup = (paymentPlan)=>{
        if (paymentPlan == 'Portfolio Pro') paymentPlan = "Pro";
        let activePlans = [
            'Free',
            'Lite',
            'Pro'
        ];
        if (activePlans.includes(paymentPlan)) {
            setPlan(paymentPlan);
            // dispatch(toggleModal({ open: 'subscriptionPayment' }));
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'subscriptionPaymentConfirm'
            }));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "py3rem bg38 df aic fdc mih100vh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc aic jcc w100 mb2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "w100 c15 fs2rem lh2 fw500 tac",
                            children: [
                                "Subscription & ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c4",
                                    children: "Upgrade"
                                }),
                                " Plans"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w100 fs1rem mt0-5rem lh2 c2 fw400 tac",
                            children: "Choose the right Diligentsia Plan for you"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc ais w90",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg1",
                            style: {
                                minHeight: "70vh"
                            },
                            children: [
                                company && Object.keys(company).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: company?.['advisors']?.[user['_id']] || company?.['investors']?.[user['_id']] ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc fdc aic py3rem c1",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `pt10rem pb1-5rem c1 px8rem sm-px1rem pricing-table-saf pricing-advisor-table dg gtcr3-xl  gtcr2-md rg5rem cg2rem gg4rem-xl`,
                                            children: selectedPlan.toLowerCase() === "pro" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                        company: company,
                                                        plan: "Pro",
                                                        component: "Billing",
                                                        handlePaymentPopup: handlePaymentPopup,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            for: "proOption",
                                                            className: "df w100 jcc mt1rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                            open: 'payment'
                                                                        })),
                                                                    onChange: ()=>setPlan("Pro"),
                                                                    name: "pricingPlan",
                                                                    id: "proOption",
                                                                    className: "op0 pen",
                                                                    type: "radio"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    "data-testid": "purchasePro",
                                                                    className: "fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250",
                                                                    children: "Purchase Now"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                        company: company,
                                                        plan: "Portfolio Pro",
                                                        isAdvisor: true,
                                                        isInvestor: true,
                                                        component: "Billing",
                                                        handlePaymentPopup: handlePaymentPopup
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                        company: company,
                                                        plan: "Pro",
                                                        component: "Billing",
                                                        handlePaymentPopup: handlePaymentPopup,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            for: "proOption",
                                                            className: "df w100 jcc mt1rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                            open: 'payment'
                                                                        })),
                                                                    onChange: ()=>setPlan("Pro"),
                                                                    name: "pricingPlan",
                                                                    id: "proOption",
                                                                    className: "op0 pen",
                                                                    type: "radio"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    "data-testid": "purchasePro",
                                                                    className: "fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250",
                                                                    children: "Purchase Now"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                        company: company,
                                                        plan: "Pro PLUS",
                                                        component: "Billing",
                                                        handlePaymentPopup: handlePaymentPopup
                                                    })
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `gtcr4-xl mt5rem py5rem px2rem br8px c1 dg gtcr2-md rg5rem cg2rem gg1rem-xl pricing-table-saf`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                company: company,
                                                plan: "Free",
                                                component: "Billing",
                                                handlePaymentPopup: handlePaymentPopup,
                                                children: user['role'] !== 'Advisor' && user['role'] !== 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    for: "partnerOption",
                                                    className: "df w100 jcc mt1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onClick: handlePaymentPopup,
                                                            onChange: ()=>setPlan("Free"),
                                                            name: "pricingPlan",
                                                            id: "partnerOption",
                                                            className: "op0 pen",
                                                            type: "radio"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            "data-testid": "purchaseFree",
                                                            className: "fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250",
                                                            children: "Purchase Now"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                company: company,
                                                plan: "Lite",
                                                component: "Billing",
                                                handlePaymentPopup: handlePaymentPopup,
                                                children: user['role'] !== 'Advisor' && user['role'] !== 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    for: "liteOption",
                                                    className: "df w100 jcc mt1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: 'payment'
                                                                })),
                                                            onChange: ()=>setPlan("Lite"),
                                                            name: "pricingPlan",
                                                            id: "liteOption",
                                                            className: "op0 pen",
                                                            type: "radio"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            "data-testid": "purchaseLite",
                                                            className: "fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250",
                                                            children: "Purchase Now"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                company: company,
                                                plan: "Pro",
                                                component: "Billing",
                                                handlePaymentPopup: handlePaymentPopup,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    for: "proOption",
                                                    className: "df w100 jcc mt1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: 'payment'
                                                                })),
                                                            onChange: ()=>setPlan("Pro"),
                                                            name: "pricingPlan",
                                                            id: "proOption",
                                                            className: "op0 pen",
                                                            type: "radio"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            "data-testid": "purchasePro",
                                                            className: "fs1rem br5px shadow cp c1 py0-5rem px1rem fw550 bg4 bg3-hover td250",
                                                            children: "Purchase Now"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                company: company,
                                                plan: "Pro PLUS",
                                                component: "Billing",
                                                handlePaymentPopup: handlePaymentPopup
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da20b8fe5a9fd138$export$2e2bcd8739ae039), {
                                    plan: plan,
                                    defaultStep: plan === "Free" ? "freeMembership" : "subscriptionUpgrade",
                                    company: company,
                                    companyId: companyId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c15 fs14px mt0-5rem op60",
                                style: {
                                    letterSpacing: '1px'
                                },
                                children: "If you wish to cancel or downgrade your subscription, please contact support"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $ad0085a37e9bcb7a$export$2e2bcd8739ae039 = $ad0085a37e9bcb7a$var$BillingDetail;



var $ayMG0 = parcelRequire("ayMG0");




function $a2d3545d01b66bc9$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Support",
                    subheading: "Get assistance from our friendly team"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tac df jcc fww",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 fs1-25rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        "Email: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "c4-hover",
                                            href: "mailto:support@diligentsia.co.uk",
                                            children: "support@diligentsia.co.uk"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        "Telephone: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "c4-hover",
                                            href: "tel:+441455271121",
                                            children: "+44 (0)1455-271121"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "w100 fw500 text-gradient fs1-75rem lh2",
                                    children: "Found a Bug?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c4 fw500 fs1-25rem ttu",
                                    children: "Please help us by Reporting"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'report-bug'
                                })),
                            className: "w20 pr zi1 mt1rem shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu bsbb tac mb1rem df jcc aic",
                            children: "Report Bug"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "https://intercom.help/diligentsia-limited/en",
                            target: "_blank",
                            className: "w100 c4 fw500 fs1-75rem ttu mt2rem tdu",
                            children: "Help Centre"
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");





var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $c3f59868b54a22db$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11z"
}), 'Security');



var $ayMG0 = parcelRequire("ayMG0");



const $823d84dcf9a44b10$var$AdminPermissionGrant = ({ handleSwtichUser: handleSwtichUser, dispatch: dispatch })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: "permissionSwitchConfirmation",
            modalCardClasses: "maw500",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "c15 fs2rem tac lh1 fw600 mb2rem",
                    children: "Confirmation"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "c15 py1rem tac fs14px",
                    children: "You are about to transfer the Admin/Owner rights of this Company or Firm to a different user. You will lose Admin/Owner rights when you click Confirm' and a dropdown or table of standard Members is shown with the option to select the new Admin/Owner."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc gg1rem mt2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            type: "button",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            text: "Cancel",
                            btnType: "default",
                            textClassName: "c1"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            type: "button",
                            btnType: "warning",
                            onClick: handleSwtichUser,
                            text: "Confirm"
                        })
                    ]
                })
            ]
        })
    });
};
var $823d84dcf9a44b10$export$2e2bcd8739ae039 = $823d84dcf9a44b10$var$AdminPermissionGrant;



const $6df881de6b4bb83c$var$TeamMemberList = ({ team: team, user: user, profileClass: profileClass, setSelectedData: setSelectedData, hasValidAdvisor: hasValidAdvisor, showEditButton: showEditButton, handleEditRoute: handleEditRoute, handleAdvisor: handleAdvisor, setResendAdvisor: setResendAdvisor, userType: userType, handleCompanyMember: handleCompanyMember, company: company })=>{
    console.log(team, "team");
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [allTeamMember, setAllTeamMember] = (0, $acw62.useState)(team);
    const [selectedMember, setSelectedMember] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const owner = company?.creatorId;
        if (!owner) {
            setAllTeamMember(team);
            return;
        }
        const exist = team.find((tem)=>tem._id === owner._id);
        if (!exist) setAllTeamMember([
            ...team,
            owner
        ]);
        else setAllTeamMember(team);
    }, [
        team,
        company
    ]);
    const resendInviteAdvisor = async (advsiorId)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/resendAdvisorInvite/${advsiorId}`);
        if (!res || res["code"] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
    };
    const handleResendInvite = async (advisor)=>{
        if (!advisor["emailVerified"]) {
            setResendAdvisor(advisor);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "resendInviteMail"
            }));
        }
    };
    const handleSwtichUser = async ()=>{
        try {
            const payload = {
                ...selectedMember,
                'companyId': company['_id']
            };
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/memberToAdmin', payload);
            if (response['code'] === 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`${selectedMember['firstName']} is now admin owner`);
                setTimeout(()=>{
                    window.location.reload();
                }, 1000);
            }
        } catch (err) {
            console.log(err, "errors");
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            allTeamMember && allTeamMember.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                id: "table",
                className: "table-advisor",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        className: "ps t0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Role"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Title"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Business Card"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Added By"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Date Added"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    children: "Last Login"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "fs1-25rem c15",
                                    style: {
                                        width: '150px'
                                    },
                                    children: "Action"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: [
                            ...allTeamMember
                        ].sort((a, b)=>{
                            if (company?.['creatorId'] && company?.['creatorId']['_id'] && a._id === company?.['creatorId']['_id']) return -1;
                            if (company?.['creatorId'] && company?.['creatorId']['_id'] && b._id === company?.['creatorId']['_id']) return 1;
                            return 0;
                        }).map((item, index)=>{
                            console.log(item, "item");
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        className: "df jcs aic",
                                        children: [
                                            item?.["profile"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: item["profile"],
                                                className: `w3rem h3rem df jcc aic br100 cp mr1rem ${profileClass}`,
                                                "data-tooltip": item["firstName"] ? item["firstName"] + " " + item["lastName"] : "Register to show your name here"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("kBFDN")),
                                                className: `w3rem h3rem df jcc aic br100 cp mr1rem ${profileClass}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: `fs1rem ttc tas c15`,
                                                children: [
                                                    item["firstName"],
                                                    " ",
                                                    item["lastName"]
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c6 fs1rem tal",
                                        children: company && company['creatorId'] && item["_id"] === company['creatorId']['_id'] ? "Admin Owner" : "Member"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c6 fs1rem tal",
                                        children: item["email"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "c3",
                                            href: `mailto: ${item["email"]}`,
                                            children: item["email"]
                                        }) : "-"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c15 fs1rem ttc",
                                        children: item['designation'] ? item['designation'] : item['title'] ? item['title'] : item['job'] ? item['job'] : '-'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "businessCard",
                                        style: {
                                            textAlign: "center"
                                        },
                                        children: hasValidAdvisor(item) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$4202723ba73439f5), {
                                            color: '#008000',
                                            onClick: ()=>setSelectedData({
                                                    ...item,
                                                    hasEditButton: showEditButton(item),
                                                    editRoute: handleEditRoute(item)
                                                })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$6a73aa53e89cdaab), {
                                            color: '#F44336',
                                            onClick: ()=>setSelectedData({
                                                    ...item,
                                                    hasEditButton: showEditButton(item),
                                                    editRoute: handleEditRoute(item)
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c15 fs1rem ttc",
                                        children: item["createdBy"] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                item["createdBy"]["firstName"],
                                                item["createdBy"]["lastName"]
                                            ]
                                        }) : `Super ${user["role"]}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: `${item["emailVerified"] ? "c7 " : "c13 "} fs1rem cp`,
                                        onClick: ()=>handleResendInvite(item),
                                        children: item["emailVerified"] ? "Active" : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            "data-tooltip": "Resend Invite",
                                            children: "Inactive"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c15 fs1rem",
                                        children: item["updatedAt"] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(item["updatedAt"]).format("ll") : "-"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c15 fs1rem",
                                        style: {
                                            textAlign: "center"
                                        },
                                        children: item["lastLoginAt"] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(item["lastLoginAt"]).format("hh:mm A, Do MMMM YYYY") : "-"
                                    }),
                                    userType !== "company" ? /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c15 fs1rem df aic",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "row tac",
                                            children: [
                                                !item["emailVerified"] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "cp",
                                                    onClick: ()=>resendInviteAdvisor(item["_id"]),
                                                    title: "Resend Invite",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        "data-tooltip": "Resend Invite",
                                                        className: "fa fa-repeat c7",
                                                        style: {
                                                            fontSize: "20px"
                                                        }
                                                    })
                                                }),
                                                item?.['companyId']?.['creatorId'] && item?.['companyId']?.['creatorId']?.['_id'] != item?.['_id'] && (user['_id'] === item?.['companyId']?.['creatorId']?.['_id'] || item['_id'] === user['_id']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>handleAdvisor(item, "edit"),
                                                            className: "bg0",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                "data-tooltip": "Edit Advisor",
                                                                className: "c8 cp",
                                                                style: {
                                                                    fontSize: "20px"
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "28",
                                                                    height: "28",
                                                                    viewBox: "0 0 28 28",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M25.666 12.8327C25.3566 12.8327 25.0599 12.9556 24.8411 13.1744C24.6223 13.3932 24.4994 13.6899 24.4994 13.9993V20.9993C24.4993 21.9276 24.1306 22.8178 23.4742 23.4742C22.8178 24.1306 21.9276 24.4993 20.9993 24.4994H6.99935C6.07109 24.4993 5.18085 24.1306 4.52448 23.4742C3.8681 22.8178 3.49935 21.9276 3.49935 20.9993V6.99935C3.49935 6.07109 3.8681 5.18085 4.52448 4.52448C5.18085 3.8681 6.07109 3.49935 6.99935 3.49935H13.9993C14.3088 3.49935 14.6055 3.37643 14.8243 3.15764C15.0431 2.93885 15.166 2.6421 15.166 2.33268C15.166 2.02326 15.0431 1.72652 14.8243 1.50772C14.6055 1.28893 14.3088 1.16602 13.9993 1.16602H6.99935C6.2333 1.16602 5.47476 1.3169 4.76703 1.61005C4.0593 1.9032 3.41623 2.33288 2.87456 2.87456C1.7806 3.96852 1.16602 5.45225 1.16602 6.99935V20.9993C1.16602 21.7654 1.3169 22.5239 1.61005 23.2317C1.9032 23.9394 2.33288 24.5825 2.87456 25.1241C3.96852 26.2181 5.45225 26.8327 6.99935 26.8327H20.9993C21.7654 26.8327 22.5239 26.6818 23.2317 26.3886C23.9394 26.0955 24.5825 25.6658 25.1241 25.1241C25.6658 24.5825 26.0955 23.9394 26.3886 23.2317C26.6818 22.5239 26.8327 21.7654 26.8327 20.9993V13.9993C26.8327 13.6899 26.7098 13.3932 26.491 13.1744C26.2722 12.9556 25.9754 12.8327 25.666 12.8327Z",
                                                                            fill: "#4A67FF"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M9.19269 12.2035C8.8662 12.5296 8.60741 12.917 8.43122 13.3435C8.25502 13.7699 8.1649 14.2271 8.16603 14.6885V16.3335C8.16603 17.2617 8.53478 18.152 9.19115 18.8084C9.84753 19.4647 10.7378 19.8335 11.666 19.8335H13.311C13.7725 19.8346 14.2296 19.7445 14.656 19.5683C15.0825 19.3921 15.4699 19.1333 15.796 18.8068L25.806 8.79682C26.1323 8.47166 26.3912 8.08529 26.5679 7.65985C26.7445 7.23442 26.8355 6.7783 26.8355 6.31766C26.8355 5.85701 26.7445 5.40089 26.5679 4.97546C26.3912 4.55003 26.1323 4.16365 25.806 3.83849L24.161 2.19349C23.8359 1.8672 23.4495 1.6083 23.0241 1.43165C22.5986 1.255 22.1425 1.16406 21.6819 1.16406C21.2212 1.16406 20.7651 1.255 20.3397 1.43165C19.9142 1.6083 19.5279 1.8672 19.2027 2.19349L9.19269 12.2035ZM22.5044 3.83849L24.161 5.49516C24.3783 5.71375 24.5003 6.00944 24.5003 6.31766C24.5003 6.62587 24.3783 6.92157 24.161 7.14016L23.1577 8.16682L19.8327 4.84182L20.836 3.83849C20.9447 3.72737 21.0744 3.63908 21.2177 3.5788C21.3609 3.51852 21.5148 3.48747 21.6702 3.48747C21.8256 3.48747 21.9795 3.51852 22.1227 3.5788C22.2659 3.63908 22.3957 3.72737 22.5044 3.83849ZM10.4994 14.6885C10.4985 14.5349 10.5279 14.3827 10.586 14.2406C10.644 14.0985 10.7296 13.9692 10.8377 13.8602L18.1994 6.49849L21.501 9.80015L14.1394 17.1618C14.0303 17.27 13.9011 17.3555 13.7589 17.4136C13.6168 17.4716 13.4646 17.501 13.311 17.5002H11.666C11.3566 17.5002 11.0599 17.3772 10.8411 17.1584C10.6223 16.9397 10.4994 16.6429 10.4994 16.3335V14.6885Z",
                                                                            fill: "#4A67FF"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        item["_id"] != user["_id"] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>handleAdvisor(item, "delete"),
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        "data-tooltip": "Delete Advisor",
                                                                        className: "c9 cp",
                                                                        style: {
                                                                            fontSize: "20px"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "28",
                                                                            height: "28",
                                                                            viewBox: "0 0 28 28",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M22.1641 8.16602C21.8546 8.16602 21.5579 8.28893 21.3391 8.50772C21.1203 8.72652 20.9974 9.02326 20.9974 9.33268V22.3888C20.9639 22.9788 20.6987 23.5317 20.2595 23.927C19.8202 24.3223 19.2426 24.528 18.6524 24.4993H9.3424C8.75218 24.528 8.17454 24.3223 7.73532 23.927C7.2961 23.5317 7.03086 22.9788 6.9974 22.3888V9.33268C6.9974 9.02326 6.87448 8.72652 6.65569 8.50772C6.43689 8.28893 6.14015 8.16602 5.83073 8.16602C5.52131 8.16602 5.22456 8.28893 5.00577 8.50772C4.78698 8.72652 4.66406 9.02326 4.66406 9.33268V22.3888C4.69736 23.5978 5.20841 24.7442 6.08527 25.5772C6.96214 26.4101 8.13335 26.8615 9.3424 26.8327H18.6524C19.8614 26.8615 21.0327 26.4101 21.9095 25.5772C22.7864 24.7442 23.2974 23.5978 23.3307 22.3888V9.33268C23.3307 9.02326 23.2078 8.72652 22.989 8.50772C22.7702 8.28893 22.4735 8.16602 22.1641 8.16602Z",
                                                                                    fill: "#F14D4D"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M23.3333 4.66602H18.6667V2.33268C18.6667 2.02326 18.5437 1.72652 18.325 1.50772C18.1062 1.28893 17.8094 1.16602 17.5 1.16602H10.5C10.1906 1.16602 9.89383 1.28893 9.67504 1.50772C9.45625 1.72652 9.33333 2.02326 9.33333 2.33268V4.66602H4.66667C4.35725 4.66602 4.0605 4.78893 3.84171 5.00772C3.62292 5.22652 3.5 5.52326 3.5 5.83268C3.5 6.1421 3.62292 6.43885 3.84171 6.65764C4.0605 6.87643 4.35725 6.99935 4.66667 6.99935H23.3333C23.6428 6.99935 23.9395 6.87643 24.1583 6.65764C24.3771 6.43885 24.5 6.1421 24.5 5.83268C24.5 5.52326 24.3771 5.22652 24.1583 5.00772C23.9395 4.78893 23.6428 4.66602 23.3333 4.66602ZM11.6667 4.66602V3.49935H16.3333V4.66602H11.6667Z",
                                                                                    fill: "#F14D4D"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.8333 19.8333V11.6667C12.8333 11.3572 12.7104 11.0605 12.4916 10.8417C12.2728 10.6229 11.9761 10.5 11.6667 10.5C11.3572 10.5 11.0605 10.6229 10.8417 10.8417C10.6229 11.0605 10.5 11.3572 10.5 11.6667V19.8333C10.5 20.1428 10.6229 20.4395 10.8417 20.6583C11.0605 20.8771 11.3572 21 11.6667 21C11.9761 21 12.2728 20.8771 12.4916 20.6583C12.7104 20.4395 12.8333 20.1428 12.8333 19.8333Z",
                                                                                    fill: "#F14D4D"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M17.4974 19.8333V11.6667C17.4974 11.3572 17.3745 11.0605 17.1557 10.8417C16.9369 10.6229 16.6401 10.5 16.3307 10.5C16.0213 10.5 15.7246 10.6229 15.5058 10.8417C15.287 11.0605 15.1641 11.3572 15.1641 11.6667V19.8333C15.1641 20.1428 15.287 20.4395 15.5058 20.6583C15.7246 20.8771 16.0213 21 16.3307 21C16.6401 21 16.9369 20.8771 17.1557 20.6583C17.3745 20.4395 17.4974 20.1428 17.4974 19.8333Z",
                                                                                    fill: "#F14D4D"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                item?.['companyId']?.['creatorId']?.['_id'] === user["_id"] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3f59868b54a22db$export$2e2bcd8739ae039), {
                                                                    className: "c3 cp",
                                                                    onClick: ()=>{
                                                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                            open: 'permissionSwitchConfirmation'
                                                                        }));
                                                                        setSelectedMember(item);
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            className: "c15 fs1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "row tac",
                                                children: [
                                                    item['_id'] == user['_id'] || company?.['creatorId']?.['_id'] == user['_id'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>handleCompanyMember(item, "edit"),
                                                        className: "bg0",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            "data-tooltip": "Edit Member",
                                                            className: "c8 cp",
                                                            style: {
                                                                fontSize: "20px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                width: "28",
                                                                height: "28",
                                                                viewBox: "0 0 28 28",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M25.666 12.8327C25.3566 12.8327 25.0599 12.9556 24.8411 13.1744C24.6223 13.3932 24.4994 13.6899 24.4994 13.9993V20.9993C24.4993 21.9276 24.1306 22.8178 23.4742 23.4742C22.8178 24.1306 21.9276 24.4993 20.9993 24.4994H6.99935C6.07109 24.4993 5.18085 24.1306 4.52448 23.4742C3.8681 22.8178 3.49935 21.9276 3.49935 20.9993V6.99935C3.49935 6.07109 3.8681 5.18085 4.52448 4.52448C5.18085 3.8681 6.07109 3.49935 6.99935 3.49935H13.9993C14.3088 3.49935 14.6055 3.37643 14.8243 3.15764C15.0431 2.93885 15.166 2.6421 15.166 2.33268C15.166 2.02326 15.0431 1.72652 14.8243 1.50772C14.6055 1.28893 14.3088 1.16602 13.9993 1.16602H6.99935C6.2333 1.16602 5.47476 1.3169 4.76703 1.61005C4.0593 1.9032 3.41623 2.33288 2.87456 2.87456C1.7806 3.96852 1.16602 5.45225 1.16602 6.99935V20.9993C1.16602 21.7654 1.3169 22.5239 1.61005 23.2317C1.9032 23.9394 2.33288 24.5825 2.87456 25.1241C3.96852 26.2181 5.45225 26.8327 6.99935 26.8327H20.9993C21.7654 26.8327 22.5239 26.6818 23.2317 26.3886C23.9394 26.0955 24.5825 25.6658 25.1241 25.1241C25.6658 24.5825 26.0955 23.9394 26.3886 23.2317C26.6818 22.5239 26.8327 21.7654 26.8327 20.9993V13.9993C26.8327 13.6899 26.7098 13.3932 26.491 13.1744C26.2722 12.9556 25.9754 12.8327 25.666 12.8327Z",
                                                                        fill: "#4A67FF"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M9.19269 12.2035C8.8662 12.5296 8.60741 12.917 8.43122 13.3435C8.25502 13.7699 8.1649 14.2271 8.16603 14.6885V16.3335C8.16603 17.2617 8.53478 18.152 9.19115 18.8084C9.84753 19.4647 10.7378 19.8335 11.666 19.8335H13.311C13.7725 19.8346 14.2296 19.7445 14.656 19.5683C15.0825 19.3921 15.4699 19.1333 15.796 18.8068L25.806 8.79682C26.1323 8.47166 26.3912 8.08529 26.5679 7.65985C26.7445 7.23442 26.8355 6.7783 26.8355 6.31766C26.8355 5.85701 26.7445 5.40089 26.5679 4.97546C26.3912 4.55003 26.1323 4.16365 25.806 3.83849L24.161 2.19349C23.8359 1.8672 23.4495 1.6083 23.0241 1.43165C22.5986 1.255 22.1425 1.16406 21.6819 1.16406C21.2212 1.16406 20.7651 1.255 20.3397 1.43165C19.9142 1.6083 19.5279 1.8672 19.2027 2.19349L9.19269 12.2035ZM22.5044 3.83849L24.161 5.49516C24.3783 5.71375 24.5003 6.00944 24.5003 6.31766C24.5003 6.62587 24.3783 6.92157 24.161 7.14016L23.1577 8.16682L19.8327 4.84182L20.836 3.83849C20.9447 3.72737 21.0744 3.63908 21.2177 3.5788C21.3609 3.51852 21.5148 3.48747 21.6702 3.48747C21.8256 3.48747 21.9795 3.51852 22.1227 3.5788C22.2659 3.63908 22.3957 3.72737 22.5044 3.83849ZM10.4994 14.6885C10.4985 14.5349 10.5279 14.3827 10.586 14.2406C10.644 14.0985 10.7296 13.9692 10.8377 13.8602L18.1994 6.49849L21.501 9.80015L14.1394 17.1618C14.0303 17.27 13.9011 17.3555 13.7589 17.4136C13.6168 17.4716 13.4646 17.501 13.311 17.5002H11.666C11.3566 17.5002 11.0599 17.3772 10.8411 17.1584C10.6223 16.9397 10.4994 16.6429 10.4994 16.3335V14.6885Z",
                                                                        fill: "#4A67FF"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }) : null,
                                                    item['_id'] !== user['_id'] && company?.['creatorId']?.['_id'] == user['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleCompanyMember(item, "delete"),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    "data-tooltip": "Delete Member",
                                                                    className: "c9 cp",
                                                                    style: {
                                                                        fontSize: "20px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "28",
                                                                        height: "28",
                                                                        viewBox: "0 0 28 28",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M22.1641 8.16602C21.8546 8.16602 21.5579 8.28893 21.3391 8.50772C21.1203 8.72652 20.9974 9.02326 20.9974 9.33268V22.3888C20.9639 22.9788 20.6987 23.5317 20.2595 23.927C19.8202 24.3223 19.2426 24.528 18.6524 24.4993H9.3424C8.75218 24.528 8.17454 24.3223 7.73532 23.927C7.2961 23.5317 7.03086 22.9788 6.9974 22.3888V9.33268C6.9974 9.02326 6.87448 8.72652 6.65569 8.50772C6.43689 8.28893 6.14015 8.16602 5.83073 8.16602C5.52131 8.16602 5.22456 8.28893 5.00577 8.50772C4.78698 8.72652 4.66406 9.02326 4.66406 9.33268V22.3888C4.69736 23.5978 5.20841 24.7442 6.08527 25.5772C6.96214 26.4101 8.13335 26.8615 9.3424 26.8327H18.6524C19.8614 26.8615 21.0327 26.4101 21.9095 25.5772C22.7864 24.7442 23.2974 23.5978 23.3307 22.3888V9.33268C23.3307 9.02326 23.2078 8.72652 22.989 8.50772C22.7702 8.28893 22.4735 8.16602 22.1641 8.16602Z",
                                                                                fill: "#F14D4D"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M23.3333 4.66602H18.6667V2.33268C18.6667 2.02326 18.5437 1.72652 18.325 1.50772C18.1062 1.28893 17.8094 1.16602 17.5 1.16602H10.5C10.1906 1.16602 9.89383 1.28893 9.67504 1.50772C9.45625 1.72652 9.33333 2.02326 9.33333 2.33268V4.66602H4.66667C4.35725 4.66602 4.0605 4.78893 3.84171 5.00772C3.62292 5.22652 3.5 5.52326 3.5 5.83268C3.5 6.1421 3.62292 6.43885 3.84171 6.65764C4.0605 6.87643 4.35725 6.99935 4.66667 6.99935H23.3333C23.6428 6.99935 23.9395 6.87643 24.1583 6.65764C24.3771 6.43885 24.5 6.1421 24.5 5.83268C24.5 5.52326 24.3771 5.22652 24.1583 5.00772C23.9395 4.78893 23.6428 4.66602 23.3333 4.66602ZM11.6667 4.66602V3.49935H16.3333V4.66602H11.6667Z",
                                                                                fill: "#F14D4D"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M12.8333 19.8333V11.6667C12.8333 11.3572 12.7104 11.0605 12.4916 10.8417C12.2728 10.6229 11.9761 10.5 11.6667 10.5C11.3572 10.5 11.0605 10.6229 10.8417 10.8417C10.6229 11.0605 10.5 11.3572 10.5 11.6667V19.8333C10.5 20.1428 10.6229 20.4395 10.8417 20.6583C11.0605 20.8771 11.3572 21 11.6667 21C11.9761 21 12.2728 20.8771 12.4916 20.6583C12.7104 20.4395 12.8333 20.1428 12.8333 19.8333Z",
                                                                                fill: "#F14D4D"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M17.4974 19.8333V11.6667C17.4974 11.3572 17.3745 11.0605 17.1557 10.8417C16.9369 10.6229 16.6401 10.5 16.3307 10.5C16.0213 10.5 15.7246 10.6229 15.5058 10.8417C15.287 11.0605 15.1641 11.3572 15.1641 11.6667V19.8333C15.1641 20.1428 15.287 20.4395 15.5058 20.6583C15.7246 20.8771 16.0213 21 16.3307 21C16.6401 21 16.9369 20.8771 17.1557 20.6583C17.3745 20.4395 17.4974 20.1428 17.4974 19.8333Z",
                                                                                fill: "#F14D4D"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3f59868b54a22db$export$2e2bcd8739ae039), {
                                                                className: "c3 cp",
                                                                onClick: ()=>{
                                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                        open: 'permissionSwitchConfirmation'
                                                                    }));
                                                                    setSelectedMember(item);
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, `team-member-${index}`);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc c15 fs1-75rem fw500 lh2 mt2rem",
                children: "No team members added!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $823d84dcf9a44b10$export$2e2bcd8739ae039), {
                handleSwtichUser: handleSwtichUser,
                dispatch: dispatch
            })
        ]
    });
};
var $6df881de6b4bb83c$export$2e2bcd8739ae039 = $6df881de6b4bb83c$var$TeamMemberList;


const $6214114c8c7e1e11$export$4202723ba73439f5 = ({ color: color, onClick: onClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "48",
        height: "36",
        viewBox: "0 0 77 71",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "cp user-advisor-modal-icon",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M55.8372 3H14.1628C8.00093 3 3 7.992 3 14.1429V43.8571C3 50.008 8.00093 55 14.1628 55H55.8372C61.9991 55 67 50.008 67 43.8571V14.1429C67 7.992 61.9991 3 55.8372 3ZM62.5349 43.8571C62.5349 47.5417 59.5284 50.5429 55.8372 50.5429H14.1628C10.4716 50.5429 7.46512 47.5417 7.46512 43.8571V14.1429C7.46512 10.4583 10.4716 7.45714 14.1628 7.45714H55.8372C59.5284 7.45714 62.5349 10.4583 62.5349 14.1429V43.8571ZM32.0828 31.5257C33.4223 30.0697 34.2558 28.1383 34.2558 26.0286C34.2558 21.512 30.5944 17.8571 26.0698 17.8571C21.5451 17.8571 17.8837 21.512 17.8837 26.0286C17.8837 28.1383 18.7172 30.0697 20.0567 31.5257C18.0028 32.8331 16.3953 34.7943 15.5619 37.2011C15.1749 38.36 15.7702 39.6377 16.9609 40.024C18.1219 40.4103 19.4019 39.7863 19.7888 38.6274C20.7116 35.9829 23.2121 34.2 26.0698 34.2C28.9274 34.2 31.4577 35.9829 32.3507 38.6274C32.6781 39.5486 33.5414 40.1429 34.4642 40.1429C34.7023 40.1429 34.9405 40.1131 35.1786 40.024C36.3395 39.6377 36.9646 38.36 36.5777 37.2011C35.7442 34.7943 34.1367 32.8331 32.0828 31.5257ZM22.3488 26.0286C22.3488 23.9783 24.0158 22.3143 26.0698 22.3143C28.1237 22.3143 29.7907 23.9783 29.7907 26.0286C29.7907 28.0789 28.1237 29.7429 26.0698 29.7429C24.0158 29.7429 22.3488 28.0789 22.3488 26.0286ZM55.093 23.0571C55.093 24.2754 54.0809 25.2857 52.8605 25.2857H43.9302C42.7098 25.2857 41.6977 24.2754 41.6977 23.0571C41.6977 21.8389 42.7098 20.8286 43.9302 20.8286H52.8605C54.0809 20.8286 55.093 21.8389 55.093 23.0571ZM55.093 34.9429C55.093 36.1611 54.0809 37.1714 52.8605 37.1714H43.9302C42.7098 37.1714 41.6977 36.1611 41.6977 34.9429C41.6977 33.7246 42.7098 32.7143 43.9302 32.7143H52.8605C54.0809 32.7143 55.093 33.7246 55.093 34.9429Z",
                fill: "#151313"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "58",
                cy: "54",
                r: "14",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.7846 38.0391C50.4167 38.0391 43.5703 44.8855 43.5703 53.2533C43.5703 61.6212 50.4167 68.4676 58.7846 68.4676C67.1525 68.4676 73.9989 61.6212 73.9989 53.2533C73.9989 44.8855 67.1525 38.0391 58.7846 38.0391ZM65.3267 49.6019L58.3282 58.7305C58.0239 59.0348 57.5675 59.3391 57.111 59.3391C56.6546 59.3391 56.1982 59.1869 55.8939 58.7305L52.2425 54.0141C51.786 53.4055 51.786 52.3405 52.5467 51.8841C53.3075 51.4276 54.2203 51.4276 54.6767 52.1883L57.111 55.3833L62.8925 47.7762C63.3489 47.1676 64.4139 47.0155 65.0225 47.4719C65.7832 47.9283 65.7832 48.8412 65.3267 49.6019Z",
                fill: color ? color : "#505050"
            })
        ]
    });
};

const $6214114c8c7e1e11$export$6a73aa53e89cdaab = ({ color: color, onClick: onClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        onClick: onClick,
        src: (parcelRequire("iCPHM")),
        alt: "close",
        width: 66,
        height: 50,
        className: "ml1rem"
    });
};

function $6214114c8c7e1e11$export$2e2bcd8739ae039({ profileClass: profileClass, team: team, getAuditLogs: getAuditLogs, handleAddAdvisor: handleAddAdvisor, handleAdvisor: handleAdvisor, setSelectedData: setSelectedData, showEditButton: showEditButton, handleEditRoute: handleEditRoute, hasValidAdvisor: hasValidAdvisor, handleCompanyMember: handleCompanyMember }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { selectedCompany: company } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let [resendAdvisor, setResendAdvisor] = (0, $acw62.useState)({});
    const submitResendInvite = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/resendAdvisorInvite/${resendAdvisor["_id"]}`);
        if (res && res["code"] == 200) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
        }
    };
    const isTeamMember = user['createdBy'] && user['createdBy']['role'] === user['role'] ? true : false;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcc fdc pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb py1rem pl0rem pr0rem pr",
                        children: [
                            isTeamMember ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>handleAddAdvisor(),
                                className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "h30px w30px",
                                            width: "38",
                                            height: "38",
                                            viewBox: "0 0 38 38",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    "clip-path": "url(#clip0_2656_879)",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                            fill: "#4A67FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                                            fill: "#FAFAFA"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                        id: "clip0_2656_879",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                            width: "38",
                                                            height: "38",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c15",
                                        children: [
                                            "Add ",
                                            user["role"] == "Advisor" ? `Advisor` : "Investor"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                onClick: ()=>getAuditLogs(`/user/addAdvisor`, user["_id"], "advisors"),
                                className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard pa t0 r0 audit-log-btn",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "36",
                                            height: "36",
                                            viewBox: "0 0 36 36",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                                                fill: "#4A67FF"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15",
                                        children: "Audit Log"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6df881de6b4bb83c$export$2e2bcd8739ae039), {
                        userType: "nonCompany",
                        team: team,
                        user: user,
                        profileClass: profileClass,
                        setSelectedData: setSelectedData,
                        hasValidAdvisor: hasValidAdvisor,
                        showEditButton: showEditButton,
                        handleEditRoute: handleEditRoute,
                        handleAdvisor: handleAdvisor,
                        handleCompanyMember: handleCompanyMember,
                        setResendAdvisor: setResendAdvisor,
                        company: company
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "resendInviteMail",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: "15px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ""
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem py1rem",
                            children: "Resend Invite"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs1rem py1rem",
                                    children: [
                                        "Do you want to resend invite to the",
                                        " ",
                                        user["role"] == "Advisor" ? "Advisor" : "Investor",
                                        " (",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fw500",
                                            children: [
                                                resendAdvisor["firstName"],
                                                " ",
                                                resendAdvisor["lastName"]
                                            ]
                                        }),
                                        ")?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsa",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ""
                                                })),
                                            className: "w30 shadow bg4 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>submitResendInvite(),
                                            className: "w30 shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Send"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");



var $acw62 = parcelRequire("acw62");

var $80a053da314de61a$export$2e2bcd8739ae039 = {
    "ext": "ext.",
    "country": "Phone number country",
    "phone": "Phone",
    "AB": "Abkhazia",
    "AC": "Ascension Island",
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "\xc5land Islands",
    "AZ": "Azerbaijan",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barth\xe9lemy",
    "BM": "Bermuda",
    "BN": "Brunei Darussalam",
    "BO": "Bolivia",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos (Keeling) Islands",
    "CD": "Congo, Democratic Republic of the",
    "CF": "Central African Republic",
    "CG": "Congo",
    "CH": "Switzerland",
    "CI": "Cote d'Ivoire",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Cura\xe7ao",
    "CX": "Christmas Island",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Federated States of Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "French Guiana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GS": "South Georgia and the South Sandwich Islands",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong",
    "HM": "Heard Island and McDonald Islands",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "Saint Kitts and Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "Saint Martin (French Part)",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "North Macedonia",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolia",
    "MO": "Macao",
    "MP": "Northern Mariana Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "OS": "South Ossetia",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "Saint Pierre and Miquelon",
    "PN": "Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Palestine",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "Saint Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard and Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "Sao Tome and Principe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Swaziland",
    "TA": "Tristan da Cunha",
    "TC": "Turks and Caicos Islands",
    "TD": "Chad",
    "TF": "French Southern Territories",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad and Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "United States Minor Outlying Islands",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Holy See (Vatican City State)",
    "VC": "Saint Vincent and the Grenadines",
    "VE": "Venezuela",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.S.",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis and Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "ZZ": "International"
};




var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");
/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */ function $5b9ddc962ce49c4a$export$2e2bcd8739ae039(country) {
    return $5b9ddc962ce49c4a$var$getRegionalIndicatorSymbol(country[0]) + $5b9ddc962ce49c4a$var$getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */ function $5b9ddc962ce49c4a$var$getRegionalIndicatorSymbol(letter) {
    return String.fromCodePoint(127397 + letter.toUpperCase().charCodeAt(0));
}


var $5628cfb1236ba6bc$var$_excluded = [
    "value",
    "onChange",
    "options",
    "disabled",
    "readOnly"
], $5628cfb1236ba6bc$var$_excluded2 = [
    "value",
    "options",
    "className",
    "iconComponent",
    "getIconAspectRatio",
    "arrowComponent",
    "unicodeFlags"
];
function $5628cfb1236ba6bc$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5628cfb1236ba6bc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5628cfb1236ba6bc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5628cfb1236ba6bc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5628cfb1236ba6bc$var$_arrayLikeToArray(o, minLen);
}
function $5628cfb1236ba6bc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5628cfb1236ba6bc$var$_extends() {
    $5628cfb1236ba6bc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5628cfb1236ba6bc$var$_extends.apply(this, arguments);
}
function $5628cfb1236ba6bc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5628cfb1236ba6bc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5628cfb1236ba6bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5628cfb1236ba6bc$export$2e2bcd8739ae039(_ref) {
    var value = _ref.value, onChange = _ref.onChange, options = _ref.options, disabled = _ref.disabled, readOnly = _ref.readOnly, rest = $5628cfb1236ba6bc$var$_objectWithoutProperties(_ref, $5628cfb1236ba6bc$var$_excluded);
    var onChange_ = (0, $acw62.useCallback)(function(event) {
        var value = event.target.value;
        onChange(value === 'ZZ' ? undefined : value);
    }, [
        onChange
    ]);
    var selectedOption = (0, $acw62.useMemo)(function() {
        return $5628cfb1236ba6bc$var$getSelectedOption(options, value);
    }, [
        options,
        value
    ]);
    // "ZZ" means "International".
    // (HTML requires each `<option/>` have some string `value`).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", $5628cfb1236ba6bc$var$_extends({}, rest, {
        disabled: disabled || readOnly,
        readOnly: readOnly,
        value: value || 'ZZ',
        onChange: onChange_
    }), options.map(function(_ref2) {
        var value = _ref2.value, label = _ref2.label, divider = _ref2.divider;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: divider ? '|' : value || 'ZZ',
            value: divider ? '|' : value || 'ZZ',
            disabled: divider ? true : false,
            style: divider ? $5628cfb1236ba6bc$var$DIVIDER_STYLE : undefined
        }, label);
    }));
}
$5628cfb1236ba6bc$export$2e2bcd8739ae039.propTypes = {
    /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * A function of `value: string`.
   * Updates the `value` property.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    // `<select/>` options.
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    })).isRequired,
    // `readonly` attribute doesn't work on a `<select/>`.
    // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
    // https://www.delftstack.com/howto/html/html-select-readonly/
    // To work around that, if `readOnly: true` property is passed
    // to this component, it behaves analogous to `disabled: true`.
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $5628cfb1236ba6bc$var$DIVIDER_STYLE = {
    fontSize: '1px',
    backgroundColor: 'currentColor',
    color: 'inherit'
};
function $5628cfb1236ba6bc$export$2d95fe84e9746c91(_ref3) {
    var value = _ref3.value, options = _ref3.options, className = _ref3.className, Icon = _ref3.iconComponent, getIconAspectRatio = _ref3.getIconAspectRatio, _ref3$arrowComponent = _ref3.arrowComponent, Arrow = _ref3$arrowComponent === void 0 ? $5628cfb1236ba6bc$var$DefaultArrowComponent : _ref3$arrowComponent, unicodeFlags = _ref3.unicodeFlags, rest = $5628cfb1236ba6bc$var$_objectWithoutProperties(_ref3, $5628cfb1236ba6bc$var$_excluded2);
    var selectedOption = (0, $acw62.useMemo)(function() {
        return $5628cfb1236ba6bc$var$getSelectedOption(options, value);
    }, [
        options,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "PhoneInputCountry"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($5628cfb1236ba6bc$export$2e2bcd8739ae039, $5628cfb1236ba6bc$var$_extends({}, rest, {
        value: value,
        options: options,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('PhoneInputCountrySelect', className)
    })), selectedOption && (unicodeFlags && value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "PhoneInputCountryIconUnicode"
    }, (0, $5b9ddc962ce49c4a$export$2e2bcd8739ae039)(value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        "aria-hidden": true,
        country: value,
        label: selectedOption.label,
        aspectRatio: unicodeFlags ? 1 : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Arrow, null));
}
$5628cfb1236ba6bc$export$2d95fe84e9746c91.propTypes = {
    // Country flag component.
    iconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    // Select arrow component.
    arrowComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    // Set to `true` to render Unicode flag icons instead of SVG images.
    unicodeFlags: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
function $5628cfb1236ba6bc$var$DefaultArrowComponent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "PhoneInputCountrySelectArrow"
    });
}
function $5628cfb1236ba6bc$var$getSelectedOption(options, value) {
    for(var _iterator = $5628cfb1236ba6bc$var$_createForOfIteratorHelperLoose(options), _step; !(_step = _iterator()).done;){
        var option = _step.value;
        if (!option.divider) {
            if ($5628cfb1236ba6bc$var$isSameOptionValue(option.value, value)) return option;
        }
    }
}
function $5628cfb1236ba6bc$var$isSameOptionValue(value1, value2) {
    // `undefined` is identical to `null`: both mean "no country selected".
    if (value1 === undefined || value1 === null) return value2 === undefined || value2 === null;
    return value1 === value2;
}



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("8g1PZ");
var $c359dd94b1ef2bdc$var$_excluded = [
    "country",
    "countryName",
    "flags",
    "flagUrl"
];
function $c359dd94b1ef2bdc$var$_extends() {
    $c359dd94b1ef2bdc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c359dd94b1ef2bdc$var$_extends.apply(this, arguments);
}
function $c359dd94b1ef2bdc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c359dd94b1ef2bdc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c359dd94b1ef2bdc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c359dd94b1ef2bdc$export$2e2bcd8739ae039(_ref) {
    var country = _ref.country, countryName = _ref.countryName, flags = _ref.flags, flagUrl = _ref.flagUrl, rest = $c359dd94b1ef2bdc$var$_objectWithoutProperties(_ref, $c359dd94b1ef2bdc$var$_excluded);
    if (flags && flags[country]) return flags[country]({
        title: countryName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", $c359dd94b1ef2bdc$var$_extends({}, rest, {
        alt: countryName,
        role: countryName ? undefined : "presentation",
        src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
    }));
}
$c359dd94b1ef2bdc$export$2e2bcd8739ae039.propTypes = {
    // The country to be selected by default.
    // Two-letter country code ("ISO 3166-1 alpha-2").
    country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    // Will be HTML `title` attribute of the `<img/>`.
    countryName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    // Country flag icon components.
    // By default flag icons are inserted as `<img/>`s
    // with their `src` pointed to `country-flag-icons` gitlab pages website.
    // There might be cases (e.g. an offline application)
    // where having a large (3 megabyte) `<svg/>` flags
    // bundle is more appropriate.
    // `import flags from 'react-phone-number-input/flags'`.
    flags: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType),
    // A URL for a country flag icon.
    // By default it points to `country-flag-icons` gitlab pages website.
    flagUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $dbe281ed06c3f740$var$_excluded = [
    "aspectRatio"
], $dbe281ed06c3f740$var$_excluded2 = [
    "title"
], $dbe281ed06c3f740$var$_excluded3 = [
    "title"
];
function $dbe281ed06c3f740$var$_extends() {
    $dbe281ed06c3f740$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dbe281ed06c3f740$var$_extends.apply(this, arguments);
}
function $dbe281ed06c3f740$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dbe281ed06c3f740$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dbe281ed06c3f740$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dbe281ed06c3f740$export$2e2bcd8739ae039(_ref) {
    var aspectRatio = _ref.aspectRatio, rest = $dbe281ed06c3f740$var$_objectWithoutProperties(_ref, $dbe281ed06c3f740$var$_excluded);
    if (aspectRatio === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dbe281ed06c3f740$var$InternationalIcon1x1, rest);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dbe281ed06c3f740$var$InternationalIcon3x2, rest);
}
$dbe281ed06c3f740$export$2e2bcd8739ae039.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
};
// 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
function $dbe281ed06c3f740$var$InternationalIcon3x2(_ref2) {
    var title = _ref2.title, rest = $dbe281ed06c3f740$var$_objectWithoutProperties(_ref2, $dbe281ed06c3f740$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $dbe281ed06c3f740$var$_extends({}, rest, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 75 50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "PhoneInputInternationalIconGlobe",
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        strokeMiterlimit: "10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        strokeLinecap: "round",
        d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "26",
        y1: "25",
        x2: "74",
        y2: "25"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "50",
        y1: "1",
        x2: "50",
        y2: "49"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        strokeLinecap: "round",
        d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        strokeLinecap: "round",
        d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "PhoneInputInternationalIconPhone",
        stroke: "none",
        fill: "currentColor",
        d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
    }));
}
$dbe281ed06c3f740$var$InternationalIcon3x2.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};
// 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
function $dbe281ed06c3f740$var$InternationalIcon1x1(_ref3) {
    var title = _ref3.title, rest = $dbe281ed06c3f740$var$_objectWithoutProperties(_ref3, $dbe281ed06c3f740$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $dbe281ed06c3f740$var$_extends({}, rest, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        className: "PhoneInputInternationalIconGlobe",
        stroke: "currentColor",
        fill: "none",
        strokeWidth: "2",
        strokeLinecap: "round"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "27.8",
        y1: "0.85",
        x2: "27.8",
        y2: "34.61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "15.2",
        y1: "22.23",
        x2: "49.15",
        y2: "22.23"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        className: "PhoneInputInternationalIconPhone",
        stroke: "transparent",
        fill: "currentColor",
        d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
    }));
}
$dbe281ed06c3f740$var$InternationalIcon1x1.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};




function $b38d815d67cc63c6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b38d815d67cc63c6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b38d815d67cc63c6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b38d815d67cc63c6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b38d815d67cc63c6$var$_arrayLikeToArray(o, minLen);
}
function $b38d815d67cc63c6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b38d815d67cc63c6$export$5e75b0f0f43cd233(options, order) {
    if (!order) return options;
    var optionsOnTop = [];
    var optionsOnBottom = [];
    var appendTo = optionsOnTop;
    var _loop = function _loop() {
        var element = _step.value;
        if (element === '|') appendTo.push({
            divider: true
        });
        else if (element === '...' || element === "\u2026") appendTo = optionsOnBottom;
        else {
            var countryCode;
            if (element === "\uD83C\uDF10") countryCode = undefined;
            else countryCode = element;
            // Find the position of the option.
            var index = options.indexOf(options.filter(function(option) {
                return option.value === countryCode;
            })[0]);
            // Get the option.
            var option = options[index];
            // Remove the option from its default position.
            options.splice(index, 1);
            // Add the option on top.
            appendTo.push(option);
        }
    };
    for(var _iterator = $b38d815d67cc63c6$var$_createForOfIteratorHelperLoose(order), _step; !(_step = _iterator()).done;)_loop();
    return optionsOnTop.concat(options).concat(optionsOnBottom);
}
function $b38d815d67cc63c6$export$afcb8c072b7545af(countryOptions, metadata) {
    if (countryOptions) {
        countryOptions = countryOptions.filter(function(option) {
            switch(option){
                case "\uD83C\uDF10":
                case '|':
                case '...':
                case "\u2026":
                    return true;
                default:
                    return $b38d815d67cc63c6$export$92e6622a86b85d10(option, metadata);
            }
        });
        if (countryOptions.length > 0) return countryOptions;
    }
}
function $b38d815d67cc63c6$export$92e6622a86b85d10(country, metadata) {
    if ((0, $f80aac35004a54c3$export$bd9e113b8b17202a)(country, metadata)) return true;
    else {
        console.error("Country not found: ".concat(country));
        return false;
    }
}
function $b38d815d67cc63c6$export$823f1bbb8700cf79(countries, metadata) {
    if (countries) {
        countries = countries.filter(function(country) {
            return $b38d815d67cc63c6$export$92e6622a86b85d10(country, metadata);
        });
        if (countries.length === 0) countries = undefined;
    }
    return countries;
}



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");


var $52b5a828ead0404a$var$_excluded = [
    "country",
    "label",
    "aspectRatio"
];
function $52b5a828ead0404a$var$_extends() {
    $52b5a828ead0404a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $52b5a828ead0404a$var$_extends.apply(this, arguments);
}
function $52b5a828ead0404a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $52b5a828ead0404a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $52b5a828ead0404a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $52b5a828ead0404a$export$c8cd064d62c67fdc(_ref) {
    var flags = _ref.flags, flagUrl = _ref.flagUrl, FlagComponent = _ref.flagComponent, InternationalIcon = _ref.internationalIcon;
    function CountryIcon(_ref2) {
        var country = _ref2.country, label = _ref2.label, aspectRatio = _ref2.aspectRatio, rest = $52b5a828ead0404a$var$_objectWithoutProperties(_ref2, $52b5a828ead0404a$var$_excluded);
        // `aspectRatio` is currently a hack for the default "International" icon
        // to render it as a square when Unicode flag icons are used.
        // So `aspectRatio` property is only used with the default "International" icon.
        var _aspectRatio = InternationalIcon === (0, $dbe281ed06c3f740$export$2e2bcd8739ae039) ? aspectRatio : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $52b5a828ead0404a$var$_extends({}, rest, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('PhoneInputCountryIcon', {
                'PhoneInputCountryIcon--square': _aspectRatio === 1,
                'PhoneInputCountryIcon--border': country
            })
        }), country ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FlagComponent, {
            country: country,
            countryName: label,
            flags: flags,
            flagUrl: flagUrl,
            className: "PhoneInputCountryIconImg"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(InternationalIcon, {
            title: label,
            aspectRatio: _aspectRatio,
            className: "PhoneInputCountryIconImg"
        }));
    }
    CountryIcon.propTypes = {
        country: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
        aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    };
    return CountryIcon;
}
var $52b5a828ead0404a$export$2e2bcd8739ae039 = $52b5a828ead0404a$export$c8cd064d62c67fdc({
    // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
    flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    flagComponent: (0, $c359dd94b1ef2bdc$export$2e2bcd8739ae039),
    internationalIcon: (0, $dbe281ed06c3f740$export$2e2bcd8739ae039)
});



var $acw62 = parcelRequire("acw62");
function $592332343a63c613$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $592332343a63c613$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $592332343a63c613$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $592332343a63c613$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $592332343a63c613$var$_arrayLikeToArray(o, minLen);
}
function $592332343a63c613$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $592332343a63c613$export$2e2bcd8739ae039(externalRef) {
    // Create a copy of the original `ref` (which might not exist).
    // Both refs will point to the same value.
    var refCopy = (0, $acw62.useRef)();
    // Updates both `ref`s with the same `value`.
    var refSetter = (0, $acw62.useCallback)(function(value) {
        $592332343a63c613$export$790a9b88e8ebffab([
            externalRef,
            refCopy
        ], value);
    }, [
        externalRef,
        refCopy
    ]);
    return [
        refCopy,
        refSetter
    ];
}
function $592332343a63c613$export$790a9b88e8ebffab(refs, value) {
    for(var _iterator = $592332343a63c613$var$_createForOfIteratorHelperLoose(refs), _step; !(_step = _iterator()).done;){
        var ref = _step.value;
        if (ref) $592332343a63c613$var$setRefValue(ref, value);
    }
}
// Sets the value of a `ref`.
// Before React Hooks were introduced, `ref`s used to be functions.
// After React Hooks were introduces, `ref`s became objects with `.current` property.
// This function sets a `ref`'s value regardless of its internal implementation,
// so it supports both types of `ref`s.
function $592332343a63c613$var$setRefValue(ref, value) {
    if (typeof ref === 'function') ref(value);
    else ref.current = value;
}





function $a1ccb640610c5bae$export$5b746bf50fbb3c55(_ref) {
    var value = _ref.value, phoneNumber = _ref.phoneNumber, defaultCountry = _ref.defaultCountry, getAnyCountry = _ref.getAnyCountry, countries = _ref.countries, required = _ref.required, metadata = _ref.metadata;
    var country;
    // If can get country from E.164 phone number
    // then it overrides the `country` passed (or not passed).
    if (phoneNumber && phoneNumber.country) // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
    else if (defaultCountry) {
        if (!value || $a1ccb640610c5bae$export$c3b71c8ffbba4219(value, defaultCountry, metadata)) country = defaultCountry;
    }
    // Only pre-select a country if it's in the available `countries` list.
    if (countries && countries.indexOf(country) < 0) country = undefined;
    // If there will be no "International" option
    // then some `country` must be selected.
    // It will still be the wrong country though.
    // But still country `<select/>` can't be left in a broken state.
    if (!country && required && countries && countries.length > 0) country = getAnyCountry();
    return country;
}
function $a1ccb640610c5bae$export$85590f0e7cf668c8(_ref2) {
    var countries = _ref2.countries, countryNames = _ref2.countryNames, addInternationalOption = _ref2.addInternationalOption, compareStringsLocales = _ref2.compareStringsLocales, _compareStrings = _ref2.compareStrings;
    // Default country name comparator uses `String.localeCompare()`.
    if (!_compareStrings) _compareStrings = $a1ccb640610c5bae$export$633da1651c3bd3f9;
    // Generates a `<Select/>` option for each country.
    var countrySelectOptions = countries.map(function(country) {
        return {
            value: country,
            // All `locale` country names included in this library
            // include all countries (this is checked at build time).
            // The only case when a country name might be missing
            // is when a developer supplies their own `labels` property.
            // To guard against such cases, a missing country name
            // is substituted by country code.
            label: countryNames[country] || country
        };
    });
    // Sort the list of countries alphabetically.
    countrySelectOptions.sort(function(a, b) {
        return _compareStrings(a.label, b.label, compareStringsLocales);
    });
    // Add the "International" option to the country list (if suitable)
    if (addInternationalOption) countrySelectOptions.unshift({
        label: countryNames.ZZ
    });
    return countrySelectOptions;
}
function $a1ccb640610c5bae$export$da44e4eaa54bc82e(value, metadata) {
    return (0, $fe2783d9f9ccca74$export$2e2bcd8739ae039)(value || '', metadata);
}
function $a1ccb640610c5bae$export$3a77a656b43ad765(phoneNumber) {
    return phoneNumber.formatNational().replace(/\D/g, '');
}
function $a1ccb640610c5bae$export$4222dedf18d79e22(phoneDigits, _ref3) {
    var prevCountry = _ref3.prevCountry, newCountry = _ref3.newCountry, metadata = _ref3.metadata, useNationalFormat = _ref3.useNationalFormat;
    if (prevCountry === newCountry) return phoneDigits;
    // If `parsed_input` is empty
    // then no need to migrate anything.
    if (!phoneDigits) {
        if (useNationalFormat) return '';
        else {
            if (newCountry) // If `phoneDigits` is empty then set `phoneDigits` to
            // `+{getCountryCallingCode(newCountry)}`.
            return (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(newCountry, metadata);
            return '';
        }
    }
    // If switching to some country.
    // (from "International" or another country)
    // If switching from "International" then `phoneDigits` starts with a `+`.
    // Otherwise it may or may not start with a `+`.
    if (newCountry) // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    {
        if (phoneDigits[0] === '+') {
            // If the international phone number is for the new country
            // then convert it to local if required.
            if (useNationalFormat) {
                // // If a phone number is being input in international form
                // // and the country can already be derived from it,
                // // and if it is the new country, then format as a national number.
                // const derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(phoneDigits, metadata)
                // if (derived_country === newCountry) {
                // 	return stripCountryCallingCode(phoneDigits, derived_country, metadata)
                // }
                // Actually, the two countries don't necessarily need to match:
                // the condition could be looser here, because several countries
                // might share the same international phone number format
                // (for example, "NANPA" countries like US, Canada, etc).
                // The looser condition would be just "same nternational phone number format"
                // which would mean "same country calling code" in the context of `libphonenumber-js`.
                if (phoneDigits.indexOf('+' + (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(newCountry, metadata)) === 0) return $a1ccb640610c5bae$export$4d2c4a09d0258b4e(phoneDigits, newCountry, metadata);
                // Simply discard the previously entered international phone number,
                // because otherwise any "smart" transformation like getting the
                // "national (significant) number" part and then prepending the
                // newly selected country's "country calling code" to it
                // would just be confusing for a user without being actually useful.
                return '';
            // // Simply strip the leading `+` character
            // // therefore simply converting all digits into a "local" phone number.
            // // https://github.com/catamphetamine/react-phone-number-input/issues/287
            // return phoneDigits.slice(1)
            }
            if (prevCountry) {
                var newCountryPrefix = (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(newCountry, metadata);
                if (phoneDigits.indexOf(newCountryPrefix) === 0) return phoneDigits;
                else return newCountryPrefix;
            } else {
                var defaultValue = (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(newCountry, metadata);
                // If `phoneDigits`'s country calling code part is the same
                // as for the new `country`, then leave `phoneDigits` as is.
                if (phoneDigits.indexOf(defaultValue) === 0) return phoneDigits;
                // If `phoneDigits`'s country calling code part is not the same
                // as for the new `country`, then set `phoneDigits` to
                // `+{getCountryCallingCode(newCountry)}`.
                return defaultValue;
            }
        // // If the international phone number already contains
        // // any country calling code then trim the country calling code part.
        // // (that could also be the newly selected country phone code prefix as well)
        // // `phoneDigits` doesn't neccessarily belong to `prevCountry`.
        // // (e.g. if a user enters an international number
        // //  not belonging to any of the reduced `countries` list).
        // phoneDigits = stripCountryCallingCode(phoneDigits, prevCountry, metadata)
        // // Prepend country calling code prefix
        // // for the newly selected country.
        // return e164(phoneDigits, newCountry, metadata) || `+${getCountryCallingCode(newCountry, metadata)}`
        }
    } else {
        // If the phone number was entered in national format.
        if (phoneDigits[0] !== '+') // Format the national phone number as an international one.
        // The phone number entered not necessarily even starts with
        // the previously selected country phone prefix.
        // Even if the phone number belongs to whole another country
        // it will still be parsed into some national phone number.
        //
        // Ignore the now-uncovered `|| ''` code branch:
        // previously `e164()` function could return an empty string
        // even when `phoneDigits` were not empty.
        // Now it always returns some `value` when there're any `phoneDigits`.
        // Still, didn't remove the `|| ''` code branch just in case
        // that logic changes somehow in some future, so there're no
        // possible bugs related to that.
        //
        // (ignore the `|| ''` code branch)
        /* istanbul ignore next */ return $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, prevCountry, metadata) || '';
    }
    return phoneDigits;
}
function $a1ccb640610c5bae$export$2fa5ed24c9ef198e(number, country, metadata) {
    if (!number) return;
    // If the phone number is being input in international format.
    if (number[0] === '+') {
        // If it's just the `+` sign then return nothing.
        if (number === '+') return;
        // Return a E.164 phone number.
        //
        // Could return `number` "as is" here, but there's a possibility
        // that some user might incorrectly input an international number
        // with a "national prefix". Such numbers aren't considered valid,
        // but `libphonenumber-js` is "forgiving" when it comes to parsing
        // user's input, and this input component follows that behavior.
        //
        var asYouType = new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(country, metadata);
        asYouType.input(number);
        // This function would return `undefined` only when `number` is `"+"`,
        // but at this point it is known that `number` is not `"+"`.
        return asYouType.getNumberValue();
    }
    // For non-international phone numbers
    // an accompanying country code is required.
    // The situation when `country` is `undefined`
    // and a non-international phone number is passed
    // to this function shouldn't happen.
    if (!country) return;
    var partial_national_significant_number = $a1ccb640610c5bae$export$457f4dd428dea2cc(number, country, metadata);
    //
    // Even if no "national (significant) number" digits have been input,
    // still return a non-`undefined` value.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
    //
    // For example, if the user has selected country `US` and entered `"1"`
    // then that `"1"` is just a "national prefix" and no "national (significant) number"
    // digits have been input yet. Still, return `"+1"` as `value` in such cases,
    // because otherwise the app would think that the input is empty and mark it as such
    // while in reality it isn't empty, which might be thought of as a "bug", or just
    // a "weird" behavior.
    //
    // if (partial_national_significant_number) {
    return "+".concat((0, $f80aac35004a54c3$export$32876ca2f1919cf0)(country, metadata)).concat(partial_national_significant_number || '');
// }
}
function $a1ccb640610c5bae$export$5be79a0015c5ab12(number, country, metadata) {
    var nationalSignificantNumberPart = $a1ccb640610c5bae$export$457f4dd428dea2cc(number, country, metadata);
    if (nationalSignificantNumberPart) {
        var overflowDigitsCount = nationalSignificantNumberPart.length - $a1ccb640610c5bae$var$getMaxNumberLength(country, metadata);
        if (overflowDigitsCount > 0) return number.slice(0, number.length - overflowDigitsCount);
    }
    return number;
}
function $a1ccb640610c5bae$var$getMaxNumberLength(country, metadata) {
    // Get "possible lengths" for a phone number of the country.
    metadata = new (0, $f80aac35004a54c3$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(country);
    // Return the last "possible length".
    return metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
}
function $a1ccb640610c5bae$export$e7408f1ddc48b26e(partialE164Number, _ref4) {
    var country = _ref4.country, countries = _ref4.countries, defaultCountry = _ref4.defaultCountry, latestCountrySelectedByUser = _ref4.latestCountrySelectedByUser, required = _ref4.required, metadata = _ref4.metadata;
    // `partialE164Number` is supposed to be an E.164 phone number.
    // `partialE164Number` is supposed to be non-empty when calling this function
    // so it doesn't check for `if (!partialE164Number)`.
    if (partialE164Number === '+') // Don't change the currently selected country yet.
    return country;
    var derived_country = $a1ccb640610c5bae$export$848ed6f49dfa5296(partialE164Number, metadata);
    // If a phone number is being input in international form
    // and the country can already be derived from it,
    // then select that country.
    if (derived_country) {
        if (!countries || countries.indexOf(derived_country) >= 0) return derived_country;
        else return undefined;
    } else if (country) {
        // If the international phone number entered could still correspond to the previously selected country
        // and also to some other country or countries corresponding to the same calling code
        // then it should reset the currently selected country to reflect the ambiguity.
        if ($a1ccb640610c5bae$export$c3b71c8ffbba4219(partialE164Number, country, metadata)) {
            // Reset the country either to the latest one that was manually selected by the user
            // or to the default country or just reset the country selection.
            if (latestCountrySelectedByUser && $a1ccb640610c5bae$export$c3b71c8ffbba4219(partialE164Number, latestCountrySelectedByUser, metadata)) return latestCountrySelectedByUser;
            else if (defaultCountry && $a1ccb640610c5bae$export$c3b71c8ffbba4219(partialE164Number, defaultCountry, metadata)) return defaultCountry;
            else {
                if (!required) // Just reset the currently selected country.
                return undefined;
            }
        } else {
            // If "International" country option has not been disabled
            // and the international phone number entered doesn't necessarily correspond to
            // the currently selected country and it could not possibly correspond to it
            // then reset the currently selected country.
            if (!required) return undefined;
        }
    }
    // Don't change the currently selected country.
    return country;
}
function $a1ccb640610c5bae$export$b48270ccb996e66(phoneDigits, _ref5) {
    var prevPhoneDigits = _ref5.prevPhoneDigits, country = _ref5.country, defaultCountry = _ref5.defaultCountry, latestCountrySelectedByUser = _ref5.latestCountrySelectedByUser, countryRequired = _ref5.countryRequired, getAnyCountry = _ref5.getAnyCountry, countries = _ref5.countries, international = _ref5.international, limitMaxLength = _ref5.limitMaxLength, countryCallingCodeEditable = _ref5.countryCallingCodeEditable, metadata = _ref5.metadata;
    // When the input is in `international` and `countryCallingCodeEditable={false}` mode,
    // the `country` should not change. If the user attempted to overwrite the country callling code part,
    // the component should reset it back to the correct country calling code for the `country`.
    if (international && countryCallingCodeEditable === false) {
        if (country) {
            // For international phone numbers written with non-editable country calling code,
            // the `<input/>` value must always start with that non-editable country calling code.
            var prefix = (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(country, metadata);
            // If the input value doesn't start with the non-editable country calling code,
            // it should be fixed.
            if (phoneDigits.indexOf(prefix) !== 0) {
                var _value;
                // If a phone number input is declared as
                // `international: true` and `countryCallingCodeEditable: false`,
                // then the value of the `<input/>` is gonna be non-empty at all times,
                // even before the user has started to input any digits in the input field,
                // because the country calling code is always there by design.
                //
                // The fact that the input value is always non-empty results in a side effect:
                // whenever a user tabs into such input field, its value gets automatically selected.
                // If at that moment in time the user starts typing in the national digits of the phone number,
                // the selected `<input/>` value gets automatically replaced by those typed-in digits
                // so the value changes from `+xxx` to `y`, because inputting anything while having
                // the `<input/>` value selected results in erasing that `<input/>` value.
                //
                // This component handles such cases by restoring the `<input/>` value to what
                // it should be in such cases: `+xxxy`.
                // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
                //
                var hasStartedTypingInNationalNumberDigitsHavingInputValueSelected = phoneDigits && phoneDigits[0] !== '+';
                if (hasStartedTypingInNationalNumberDigitsHavingInputValueSelected) {
                    // Fix the input value to what it should be: `y` → `+xxxy`.
                    phoneDigits = prefix + phoneDigits;
                    _value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
                } else // In other cases, simply reset the `<input/>` value, because there're only two
                // possible cases:
                // * The user has selected the `<input/>` value and then hit Delete/Backspace to erase it.
                // * The user has pasted an international phone number for another country calling code,
                //   which is considered a non-valid value.
                phoneDigits = prefix;
                return {
                    phoneDigits: phoneDigits,
                    value: _value,
                    country: country
                };
            }
        }
    }
    // If `international` property is `false`, then it means
    // "enforce national-only format during input",
    // so, if that's the case, then remove all `+` characters,
    // but only if some country is currently selected.
    // (not if "International" country is selected).
    if (international === false && country && phoneDigits && phoneDigits[0] === '+') phoneDigits = $a1ccb640610c5bae$var$convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
    // Trim the input to not exceed the maximum possible number length.
    if (phoneDigits && country && limitMaxLength) phoneDigits = $a1ccb640610c5bae$export$5be79a0015c5ab12(phoneDigits, country, metadata);
    // If this `onChange()` event was triggered
    // as a result of selecting "International" country,
    // then force-prepend a `+` sign if the phone number
    // `<input/>` value isn't in international format.
    // Also, force-prepend a `+` sign if international
    // phone number input format is set.
    if (phoneDigits && phoneDigits[0] !== '+' && (!country || international)) phoneDigits = '+' + phoneDigits;
    // If the previously entered phone number
    // has been entered in international format
    // and the user decides to erase it,
    // then also reset the `country`
    // because it was most likely automatically selected
    // while the user was typing in the phone number
    // in international format.
    // This fixes the issue when a user is presented
    // with a phone number input with no country selected
    // and then types in their local phone number
    // then discovers that the input's messed up
    // (a `+` has been prepended at the start of their input
    //  and a random country has been selected),
    // decides to undo it all by erasing everything
    // and then types in their local phone number again
    // resulting in a seemingly correct phone number
    // but in reality that phone number has incorrect country.
    // https://github.com/catamphetamine/react-phone-number-input/issues/273
    if (!phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === '+') {
        if (international) country = undefined;
        else country = defaultCountry;
    }
    // Also resets such "randomly" selected country
    // as soon as the user erases the number
    // digit-by-digit up to the leading `+` sign.
    if (phoneDigits === '+' && prevPhoneDigits && prevPhoneDigits[0] === '+' && prevPhoneDigits.length > 1) country = undefined;
    // Generate the new `value` property.
    var value;
    if (phoneDigits) {
        if (phoneDigits[0] === '+') {
            if (phoneDigits === '+') value = undefined;
            else if (country && (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(country, metadata).indexOf(phoneDigits) === 0) // Selected a `country` and started inputting an
            // international phone number for this country
            // but hasn't input any "national (significant) number" digits yet.
            // In that case, assume `value` be `undefined`.
            //
            // For example, if selected `country` `"US"`
            // and started inputting phone number `"+1"`
            // then `value` `undefined` will be returned from this function.
            //
            value = undefined;
            else value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
        } else value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
    }
    // Derive the country from the phone number.
    // (regardless of whether there's any country currently selected,
    //  because there could be several countries corresponding to one country calling code)
    if (value) {
        country = $a1ccb640610c5bae$export$e7408f1ddc48b26e(value, {
            country: country,
            countries: countries,
            defaultCountry: defaultCountry,
            latestCountrySelectedByUser: latestCountrySelectedByUser,
            // `countryRequired` flag is not passed here.
            // Instead, it's explicitly checked a bit later in the code.
            required: false,
            metadata: metadata
        });
        // If `international` property is `false`, then it means
        // "enforce national-only format during input",
        // so, if that's the case, then remove all `+` characters,
        // but only if some country is currently selected.
        // (not if "International" country is selected).
        if (international === false && country && phoneDigits && phoneDigits[0] === '+') {
            phoneDigits = $a1ccb640610c5bae$var$convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata);
            // Re-calculate `value` because `phoneDigits` has changed.
            value = $a1ccb640610c5bae$export$2fa5ed24c9ef198e(phoneDigits, country, metadata);
        }
    }
    if (!country && countryRequired) country = defaultCountry || getAnyCountry();
    return {
        // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
        // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
        // `prevPhoneDigits` parameter to this same function on next input change event.
        phoneDigits: phoneDigits,
        country: country,
        value: value
    };
}
function $a1ccb640610c5bae$var$convertInternationalPhoneDigitsToNational(input, country, metadata) {
    // Handle the case when a user might have pasted
    // a phone number in international format.
    if (input.indexOf((0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(country, metadata)) === 0) {
        // Create "as you type" formatter.
        var formatter = new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(country, metadata);
        // Input partial national phone number.
        formatter.input(input);
        // Return the parsed partial national phone number.
        var phoneNumber = formatter.getNumber();
        if (phoneNumber) // Transform the number to a national one,
        // and remove all non-digits.
        return phoneNumber.formatNational().replace(/\D/g, '');
        else return '';
    } else // Just remove the `+` sign.
    return input.replace(/\D/g, '');
}
function $a1ccb640610c5bae$export$848ed6f49dfa5296(number, metadata) {
    var formatter = new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(null, metadata);
    formatter.input(number);
    // // `001` is a special "non-geograpical entity" code
    // // in Google's `libphonenumber` library.
    // if (formatter.getCountry() === '001') {
    // 	return
    // }
    return formatter.getCountry();
}
function $a1ccb640610c5bae$export$633da1651c3bd3f9(a, b, locales) {
    // Use `String.localeCompare` if it's available.
    // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
    // Which means everyone except IE <= 10 and Safari <= 10.
    // `localeCompare()` is available in latest Node.js versions.
    /* istanbul ignore else */ if (String.prototype.localeCompare) return a.localeCompare(b, locales);
    /* istanbul ignore next */ return a < b ? -1 : a > b ? 1 : 0;
}
function $a1ccb640610c5bae$export$4d2c4a09d0258b4e(number, country, metadata) {
    // Just an optimization, so that it
    // doesn't have to iterate through all country calling codes.
    if (country) {
        var countryCallingCodePrefix = '+' + (0, $f80aac35004a54c3$export$32876ca2f1919cf0)(country, metadata);
        // If `country` fits the actual `number`.
        if (number.length < countryCallingCodePrefix.length) {
            if (countryCallingCodePrefix.indexOf(number) === 0) return '';
        } else {
            if (number.indexOf(countryCallingCodePrefix) === 0) return number.slice(countryCallingCodePrefix.length);
        }
    }
    // If `country` doesn't fit the actual `number`.
    // Try all available country calling codes.
    for(var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++){
        var country_calling_code = _Object$keys[_i];
        if (number.indexOf(country_calling_code) === 1) return number.slice(1 + country_calling_code.length);
    }
    return '';
}
function $a1ccb640610c5bae$export$457f4dd428dea2cc(number, country, metadata) {
    // Create "as you type" formatter.
    var formatter = new (0, $db4ccf0f77fcc72f$export$2e2bcd8739ae039)(country, metadata);
    // Input partial national phone number.
    formatter.input(number);
    // Return the parsed partial national phone number.
    var phoneNumber = formatter.getNumber();
    return phoneNumber && phoneNumber.nationalNumber;
}
function $a1ccb640610c5bae$export$c3b71c8ffbba4219(number, country, metadata) {
    var intlPhoneNumberPrefix = (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(country, metadata);
    var i = 0;
    while(i < number.length && i < intlPhoneNumberPrefix.length){
        if (number[i] !== intlPhoneNumberPrefix[i]) return false;
        i++;
    }
    return true;
}
function $a1ccb640610c5bae$export$3b7f83419d3c9d9c(_ref6) {
    var value = _ref6.value, phoneNumber = _ref6.phoneNumber, defaultCountry = _ref6.defaultCountry, international = _ref6.international, useNationalFormat = _ref6.useNationalFormat, metadata = _ref6.metadata;
    // If the `value` (E.164 phone number)
    // belongs to the currently selected country
    // and `useNationalFormat` is `true`
    // then convert `value` (E.164 phone number)
    // to a local phone number digits.
    // E.g. '+78005553535' -> '88005553535'.
    if ((international === false || useNationalFormat) && phoneNumber && phoneNumber.country) return $a1ccb640610c5bae$export$3a77a656b43ad765(phoneNumber);
    // If `international` property is `true`,
    // meaning "enforce international phone number format",
    // then always show country calling code in the input field.
    if (!value && international && defaultCountry) return (0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(defaultCountry, metadata);
    return value;
} // function doesIncompletePhoneNumberCorrespondToASingleCountry(value, metadata) {
 // 	// Create "as you type" formatter.
 // 	const formatter = new AsYouType(undefined, metadata)
 // 	// Input partial national phone number.
 // 	formatter.input(value)
 // 	// Return the parsed partial national phone number.
 // 	const phoneNumber = formatter.getNumber()
 // 	if (phoneNumber) {
 // 		return phoneNumber.getPossibleCountries().length === 1
 // 	} else {
 // 		return false
 // 	}
 // }






function $b1a36d6ef1af5dce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b1a36d6ef1af5dce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b1a36d6ef1af5dce$var$_typeof(o);
}
function $b1a36d6ef1af5dce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1a36d6ef1af5dce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1a36d6ef1af5dce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b1a36d6ef1af5dce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1a36d6ef1af5dce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b1a36d6ef1af5dce$var$_defineProperty(obj, key, value) {
    key = $b1a36d6ef1af5dce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b1a36d6ef1af5dce$var$_toPropertyKey(t) {
    var i = $b1a36d6ef1af5dce$var$_toPrimitive(t, "string");
    return "symbol" == $b1a36d6ef1af5dce$var$_typeof(i) ? i : i + "";
}
function $b1a36d6ef1af5dce$var$_toPrimitive(t, r) {
    if ("object" != $b1a36d6ef1af5dce$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b1a36d6ef1af5dce$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b1a36d6ef1af5dce$export$2e2bcd8739ae039(props, prevProps, state) {
    var metadata = props.metadata, countries = props.countries, newDefaultCountry = props.defaultCountry, newValue = props.value, newReset = props.reset, international = props.international, displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber, initialValueFormat = props.initialValueFormat;
    var prevDefaultCountry = prevProps.defaultCountry, prevValue = prevProps.value, prevReset = prevProps.reset;
    var country = state.country, value = state.value, hasUserSelectedACountry = state.hasUserSelectedACountry, latestCountrySelectedByUser = state.latestCountrySelectedByUser;
    var _getInitialPhoneDigits = function _getInitialPhoneDigits(parameters) {
        return (0, $a1ccb640610c5bae$export$3b7f83419d3c9d9c)($b1a36d6ef1af5dce$var$_objectSpread($b1a36d6ef1af5dce$var$_objectSpread({}, parameters), {}, {
            international: international,
            useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
            metadata: metadata
        }));
    };
    // Some users requested a way to reset the component
    // (both number `<input/>` and country `<select/>`).
    // Whenever `reset` property changes both number `<input/>`
    // and country `<select/>` are reset.
    // It's not implemented as some instance `.reset()` method
    // because `ref` is forwarded to `<input/>`.
    // It's also not replaced with just resetting `country` on
    // external `value` reset, because a user could select a country
    // and then not input any `value`, and so the selected country
    // would be "stuck", if not using this `reset` property.
    // https://github.com/catamphetamine/react-phone-number-input/issues/300
    if (newReset !== prevReset) return {
        phoneDigits: _getInitialPhoneDigits({
            value: undefined,
            defaultCountry: newDefaultCountry
        }),
        value: undefined,
        country: newDefaultCountry,
        latestCountrySelectedByUser: undefined,
        hasUserSelectedACountry: undefined
    };
    // `value` is the value currently shown in the component:
    // it's stored in the component's `state`, and it's not the `value` property.
    // `prevValue` is "previous `value` property".
    // `newValue` is "new `value` property".
    // If the default country changed
    // (e.g. in case of ajax GeoIP detection after page loaded)
    // then select it, but only if the user hasn't already manually
    // selected a country, and no phone number has been manually entered so far.
    // Because if the user has already started inputting a phone number
    // then they're okay with no country being selected at all ("International")
    // and they don't want to be disturbed, don't want their input to be screwed, etc.
    if (newDefaultCountry !== prevDefaultCountry) {
        var isNewDefaultCountrySupported = !newDefaultCountry || (0, $b38d815d67cc63c6$export$92e6622a86b85d10)(newDefaultCountry, metadata);
        var noValueHasBeenEnteredByTheUser = // By default, "no value has been entered" means `value` is `undefined`.
        !value || // When `international` is `true`, and some country has been pre-selected,
        // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
        // so in case of `international` being `true`, "the user hasn't entered anything" situation
        // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
        international && value === _getInitialPhoneDigits({
            value: undefined,
            defaultCountry: prevDefaultCountry
        });
        // Only update the `defaultCountry` property if no phone number
        // has been entered by the user or pre-set by the application.
        var noValueHasBeenEntered = !newValue && noValueHasBeenEnteredByTheUser;
        if (!hasUserSelectedACountry && isNewDefaultCountrySupported && noValueHasBeenEntered) return {
            country: newDefaultCountry,
            // If `phoneDigits` is empty, then automatically select the new `country`
            // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
            // The code assumes that "no phone number has been entered by the user",
            // and no `value` property has been passed, so the `phoneNumber` parameter
            // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
            phoneDigits: _getInitialPhoneDigits({
                value: undefined,
                defaultCountry: newDefaultCountry
            }),
            // `value` is `undefined` and it stays so.
            value: undefined
        };
    }
    // If a new `value` is set externally.
    // (e.g. as a result of an ajax API request
    //  to get user's phone after page loaded)
    // The first part — `newValue !== prevValue` —
    // is basically `props.value !== prevProps.value`
    // so it means "if value property was changed externally".
    // The second part — `newValue !== value` —
    // is for ignoring the `getDerivedStateFromProps()` call
    // which happens in `this.onChange()` right after `this.setState()`.
    // If this `getDerivedStateFromProps()` call isn't ignored
    // then the country flag would reset on each input.
    if (!$b1a36d6ef1af5dce$export$45491dafa4524293(newValue, prevValue) && !$b1a36d6ef1af5dce$export$45491dafa4524293(newValue, value)) {
        var phoneNumber;
        var parsedCountry;
        if (newValue) {
            // Validate that the newly-supplied `value` is in `E.164` format.
            // Because sometimes people attempt to supply a `value` like "+1 (879) 490-8676".
            // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/231#note_2016334796
            if (newValue) (0, $0967a0ff85311523$export$a32cb4373414cedd)(newValue);
            phoneNumber = (0, $a1ccb640610c5bae$export$da44e4eaa54bc82e)(newValue, metadata);
            var supportedCountries = (0, $b38d815d67cc63c6$export$823f1bbb8700cf79)(countries, metadata);
            if (phoneNumber && phoneNumber.country) // Ignore `else` because all countries are supported in metadata.
            /* istanbul ignore next */ {
                if (!supportedCountries || supportedCountries.indexOf(phoneNumber.country) >= 0) parsedCountry = phoneNumber.country;
            } else {
                parsedCountry = (0, $a1ccb640610c5bae$export$e7408f1ddc48b26e)(newValue, {
                    country: undefined,
                    countries: supportedCountries,
                    metadata: metadata
                });
                // In cases when multiple countries correspond to the same country calling code,
                // the phone number digits of `newValue` have to be matched against country-specific
                // regular expressions in order to determine the exact country.
                // Sometimes, that algorithm can't decide for sure which country does the phone number belong to,
                // for example when the digits of `newValue` don't match any of those regular expressions.
                // and the country of the phone number couldn't be determined.
                // In those cases, people prefer the component to show the flag of the `defaultCountry`
                // if the phone number could potentially belong to that `defaultCountry`.
                // At least that's how the component behaves when a user pastes an international
                // phone number into the input field: for example, when `defaultCountry` is `"US"`
                // and the user pastes value "+1 555 555 5555" into the input field, it keep showing "US" flag.
                // So when setting new `value` property externally, the component should behave the same way:
                // it should select the `defaultCountry` when the new `value` could potentially belong
                // to that country in cases when the exact country can't be determined.
                // https://github.com/catamphetamine/react-phone-number-input/issues/413#issuecomment-1536219404
                if (!parsedCountry) {
                    if (newDefaultCountry) {
                        if (newValue.indexOf((0, $0dabc91bce1ee96e$export$2e2bcd8739ae039)(newDefaultCountry, metadata)) === 0) parsedCountry = newDefaultCountry;
                    }
                }
            }
        }
        var userCountrySelectionHistoryStateUpdate;
        if (newValue) // If the latest country that has been manually selected by the user
        // no longer corresponds to the new value then reset it.
        {
            if (latestCountrySelectedByUser) {
                var couldNewValueCorrespondToLatestCountrySelectedByUser = parsedCountry ? latestCountrySelectedByUser === parsedCountry : (0, $a1ccb640610c5bae$export$c3b71c8ffbba4219)(newValue, latestCountrySelectedByUser, metadata);
                if (couldNewValueCorrespondToLatestCountrySelectedByUser) {
                    if (!parsedCountry) parsedCountry = latestCountrySelectedByUser;
                } else userCountrySelectionHistoryStateUpdate = {
                    latestCountrySelectedByUser: undefined
                };
            }
        } else // When the `value` property is being reset "externally",
        // reset any tracking of the country that the user has previously selected.
        userCountrySelectionHistoryStateUpdate = {
            latestCountrySelectedByUser: undefined,
            hasUserSelectedACountry: undefined
        };
        return $b1a36d6ef1af5dce$var$_objectSpread($b1a36d6ef1af5dce$var$_objectSpread({}, userCountrySelectionHistoryStateUpdate), {}, {
            phoneDigits: _getInitialPhoneDigits({
                phoneNumber: phoneNumber,
                value: newValue,
                defaultCountry: newDefaultCountry
            }),
            value: newValue,
            country: newValue ? parsedCountry : newDefaultCountry
        });
    }
// `defaultCountry` didn't change.
// `value` didn't change.
// `phoneDigits` didn't change, because `value` didn't change.
//
// So no need to update state.
}
function $b1a36d6ef1af5dce$export$45491dafa4524293(value1, value2) {
    // If `value` has been set to `null` externally then convert it to `undefined`.
    //
    // For example, `react-hook-form` sets `value` to `null` when the user clears the input.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/164
    // In that case, without this conversion of `null` to `undefined`, it would reset
    // the selected country to `defaultCountry` because in that case `newValue !== value`
    // because `null !== undefined`.
    //
    // Historically, empty `value` is encoded as `undefined`.
    // Perhaps empty `value` would be better encoded as `null` instead.
    // But because that would be a potentially breaking change for some people,
    // it's left as is for the current "major" version of this library.
    //
    if (value1 === null) value1 = undefined;
    if (value2 === null) value2 = undefined;
    return value1 === value2;
}


var $14b7adcd5f72858f$var$_excluded = [
    "name",
    "disabled",
    "readOnly",
    "autoComplete",
    "style",
    "className",
    "inputRef",
    "inputComponent",
    "numberInputProps",
    "smartCaret",
    "countrySelectComponent",
    "countrySelectProps",
    "containerComponent",
    "containerComponentProps",
    "defaultCountry",
    "countries",
    "countryOptionsOrder",
    "labels",
    "flags",
    "flagComponent",
    "flagUrl",
    "addInternationalOption",
    "internationalIcon",
    "displayInitialValueAsLocalNumber",
    "initialValueFormat",
    "onCountryChange",
    "limitMaxLength",
    "countryCallingCodeEditable",
    "focusInputOnCountrySelection",
    "reset",
    "metadata",
    "international",
    "locales"
];
function $14b7adcd5f72858f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $14b7adcd5f72858f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $14b7adcd5f72858f$var$_typeof(o);
}
function $14b7adcd5f72858f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14b7adcd5f72858f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14b7adcd5f72858f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $14b7adcd5f72858f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14b7adcd5f72858f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14b7adcd5f72858f$var$_extends() {
    $14b7adcd5f72858f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $14b7adcd5f72858f$var$_extends.apply(this, arguments);
}
function $14b7adcd5f72858f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $14b7adcd5f72858f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $14b7adcd5f72858f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $14b7adcd5f72858f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $14b7adcd5f72858f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $14b7adcd5f72858f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $14b7adcd5f72858f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $14b7adcd5f72858f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $14b7adcd5f72858f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $14b7adcd5f72858f$var$_callSuper(t, o, e) {
    return o = $14b7adcd5f72858f$var$_getPrototypeOf(o), $14b7adcd5f72858f$var$_possibleConstructorReturn(t, $14b7adcd5f72858f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $14b7adcd5f72858f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $14b7adcd5f72858f$var$_possibleConstructorReturn(self, call) {
    if (call && ($14b7adcd5f72858f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $14b7adcd5f72858f$var$_assertThisInitialized(self);
}
function $14b7adcd5f72858f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $14b7adcd5f72858f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($14b7adcd5f72858f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $14b7adcd5f72858f$var$_getPrototypeOf(o) {
    $14b7adcd5f72858f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $14b7adcd5f72858f$var$_getPrototypeOf(o);
}
function $14b7adcd5f72858f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $14b7adcd5f72858f$var$_setPrototypeOf(subClass, superClass);
}
function $14b7adcd5f72858f$var$_setPrototypeOf(o, p) {
    $14b7adcd5f72858f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $14b7adcd5f72858f$var$_setPrototypeOf(o, p);
}
function $14b7adcd5f72858f$var$_defineProperty(obj, key, value) {
    key = $14b7adcd5f72858f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $14b7adcd5f72858f$var$_toPropertyKey(t) {
    var i = $14b7adcd5f72858f$var$_toPrimitive(t, "string");
    return "symbol" == $14b7adcd5f72858f$var$_typeof(i) ? i : i + "";
}
function $14b7adcd5f72858f$var$_toPrimitive(t, r) {
    if ("object" != $14b7adcd5f72858f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $14b7adcd5f72858f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $14b7adcd5f72858f$var$PhoneNumberInput_ = /*#__PURE__*/ function(_React$PureComponent) {
    function PhoneNumberInput_(props) {
        var _this;
        $14b7adcd5f72858f$var$_classCallCheck(this, PhoneNumberInput_);
        _this = $14b7adcd5f72858f$var$_callSuper(this, PhoneNumberInput_, [
            props
        ]);
        // This function mimicks `refSetter` function returned from `useExternalRef()` hook
        // because this class-like React component can't use the `useExternalRef()` hook.
        $14b7adcd5f72858f$var$_defineProperty(_this, "setInputRef", function(instance) {
            (0, $592332343a63c613$export$790a9b88e8ebffab)([
                _this.props.inputRef,
                _this.inputRef
            ], instance);
        });
        // A shorthand for not passing `metadata` as a second argument.
        $14b7adcd5f72858f$var$_defineProperty(_this, "isCountrySupportedWithError", function(country) {
            var metadata = _this.props.metadata;
            return (0, $b38d815d67cc63c6$export$92e6622a86b85d10)(country, metadata);
        });
        // Country `<select/>` `onChange` handler.
        $14b7adcd5f72858f$var$_defineProperty(_this, "onCountryChange", function(newCountry) {
            var _this$props = _this.props, international = _this$props.international, metadata = _this$props.metadata, onChange = _this$props.onChange, focusInputOnCountrySelection = _this$props.focusInputOnCountrySelection;
            var _this$state = _this.state, prevPhoneDigits = _this$state.phoneDigits, prevCountry = _this$state.country;
            // After the new `country` has been selected,
            // if the phone number `<input/>` holds any digits
            // then migrate those digits for the new `country`.
            var newPhoneDigits = (0, $a1ccb640610c5bae$export$4222dedf18d79e22)(prevPhoneDigits, {
                prevCountry: prevCountry,
                newCountry: newCountry,
                metadata: metadata,
                // Convert the phone number to "national" format
                // when the user changes the selected country by hand.
                useNationalFormat: !international
            });
            var newValue = (0, $a1ccb640610c5bae$export$2fa5ed24c9ef198e)(newPhoneDigits, newCountry, metadata);
            // Focus phone number `<input/>` upon country selection.
            if (focusInputOnCountrySelection) _this.inputRef.current.focus();
            // If the user has already manually selected a country
            // then don't override that already selected country
            // if the `defaultCountry` property changes.
            // That's what `hasUserSelectedACountry` flag is for.
            _this.setState({
                country: newCountry,
                latestCountrySelectedByUser: newCountry,
                hasUserSelectedACountry: true,
                phoneDigits: newPhoneDigits,
                value: newValue
            }, function() {
                // Update the new `value` property.
                // Doing it after the `state` has been updated
                // because `onChange()` will trigger `getDerivedStateFromProps()`
                // with the new `value` which will be compared to `state.value` there.
                onChange(newValue);
            });
        });
        /**
     * `<input/>` `onChange()` handler.
     * Updates `value` property accordingly (so that they are kept in sync).
     * @param {string?} input — Either a parsed phone number or an empty string. Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */ $14b7adcd5f72858f$var$_defineProperty(_this, "onChange", function(_phoneDigits) {
            var _this$props2 = _this.props, defaultCountry = _this$props2.defaultCountry, onChange = _this$props2.onChange, addInternationalOption = _this$props2.addInternationalOption, international = _this$props2.international, limitMaxLength = _this$props2.limitMaxLength, countryCallingCodeEditable = _this$props2.countryCallingCodeEditable, metadata = _this$props2.metadata;
            var _this$state2 = _this.state, countries = _this$state2.countries, prevPhoneDigits = _this$state2.phoneDigits, currentlySelectedCountry = _this$state2.country, latestCountrySelectedByUser = _this$state2.latestCountrySelectedByUser;
            var _onPhoneDigitsChange = (0, $a1ccb640610c5bae$export$b48270ccb996e66)(_phoneDigits, {
                prevPhoneDigits: prevPhoneDigits,
                country: currentlySelectedCountry,
                countryRequired: !addInternationalOption,
                defaultCountry: defaultCountry,
                latestCountrySelectedByUser: latestCountrySelectedByUser,
                getAnyCountry: function getAnyCountry() {
                    return _this.getFirstSupportedCountry({
                        countries: countries
                    });
                },
                countries: countries,
                international: international,
                limitMaxLength: limitMaxLength,
                countryCallingCodeEditable: countryCallingCodeEditable,
                metadata: metadata
            }), phoneDigits = _onPhoneDigitsChange.phoneDigits, country = _onPhoneDigitsChange.country, value = _onPhoneDigitsChange.value;
            var stateUpdate = {
                phoneDigits: phoneDigits,
                value: value,
                country: country
            };
            // Reset `latestCountrySelectedByUser` if it no longer fits the `value`.
            if (latestCountrySelectedByUser && value && !(0, $a1ccb640610c5bae$export$c3b71c8ffbba4219)(value, latestCountrySelectedByUser, metadata)) stateUpdate.latestCountrySelectedByUser = undefined;
            if (countryCallingCodeEditable === false) // If it simply did `setState({ phoneDigits: intlPrefix })` here,
            // then it would have no effect when erasing an inital international prefix
            // via Backspace, because `phoneDigits` in `state` wouldn't change
            // as a result, because it was `prefix` and it became `prefix`,
            // so the component wouldn't rerender, and the user would be able
            // to erase the country calling code part, and that part is
            // assumed to be non-eraseable. That's why the component is
            // forcefully rerendered here.
            // https://github.com/catamphetamine/react-phone-number-input/issues/367#issuecomment-721703501
            {
                if (!value && phoneDigits === _this.state.phoneDigits) // Force a re-render of the `<input/>` in order to reset its value.
                stateUpdate.forceRerender = {};
            }
            _this.setState(stateUpdate, // Update the new `value` property.
            // Doing it after the `state` has been updated
            // because `onChange()` will trigger `getDerivedStateFromProps()`
            // with the new `value` which will be compared to `state.value` there.
            function() {
                return onChange(value);
            });
        });
        // Toggles the `--focus` CSS class.
        $14b7adcd5f72858f$var$_defineProperty(_this, "_onFocus", function() {
            return _this.setState({
                isFocused: true
            });
        });
        // Toggles the `--focus` CSS class.
        $14b7adcd5f72858f$var$_defineProperty(_this, "_onBlur", function() {
            return _this.setState({
                isFocused: false
            });
        });
        $14b7adcd5f72858f$var$_defineProperty(_this, "onFocus", function(event) {
            _this._onFocus();
            var onFocus = _this.props.onFocus;
            if (onFocus) onFocus(event);
        });
        $14b7adcd5f72858f$var$_defineProperty(_this, "onBlur", function(event) {
            var onBlur = _this.props.onBlur;
            _this._onBlur();
            if (onBlur) onBlur(event);
        });
        $14b7adcd5f72858f$var$_defineProperty(_this, "onCountryFocus", function(event) {
            _this._onFocus();
            // this.setState({ countrySelectFocused: true })
            var countrySelectProps = _this.props.countrySelectProps;
            if (countrySelectProps) {
                var onFocus = countrySelectProps.onFocus;
                if (onFocus) onFocus(event);
            }
        });
        $14b7adcd5f72858f$var$_defineProperty(_this, "onCountryBlur", function(event) {
            _this._onBlur();
            // this.setState({ countrySelectFocused: false })
            var countrySelectProps = _this.props.countrySelectProps;
            if (countrySelectProps) {
                var onBlur = countrySelectProps.onBlur;
                if (onBlur) onBlur(event);
            }
        });
        _this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        var _this$props3 = _this.props, _value = _this$props3.value, labels = _this$props3.labels, _international = _this$props3.international, _addInternationalOption = _this$props3.addInternationalOption, displayInitialValueAsLocalNumber = _this$props3.displayInitialValueAsLocalNumber, initialValueFormat = _this$props3.initialValueFormat, _metadata = _this$props3.metadata;
        var _this$props4 = _this.props, _defaultCountry = _this$props4.defaultCountry, _countries = _this$props4.countries;
        // Validate `defaultCountry`.
        if (_defaultCountry) {
            if (!_this.isCountrySupportedWithError(_defaultCountry)) _defaultCountry = undefined;
        }
        // Validate that the initially-supplied `value` is in `E.164` format.
        // Because sometimes people attempt to supply a `value` like "+1 (879) 490-8676".
        // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/231#note_2016334796
        if (_value) (0, $0967a0ff85311523$export$a32cb4373414cedd)(_value);
        // Validate `countries`.
        _countries = (0, $b38d815d67cc63c6$export$823f1bbb8700cf79)(_countries, _metadata);
        var phoneNumber = (0, $a1ccb640610c5bae$export$da44e4eaa54bc82e)(_value, _metadata);
        _this.CountryIcon = (0, $52b5a828ead0404a$export$c8cd064d62c67fdc)(_this.props);
        var preSelectedCountry = (0, $a1ccb640610c5bae$export$5b746bf50fbb3c55)({
            value: _value,
            phoneNumber: phoneNumber,
            defaultCountry: _defaultCountry,
            required: !_addInternationalOption,
            countries: _countries || (0, $34c4bee83c07f6dd$export$2e2bcd8739ae039)(_metadata),
            getAnyCountry: function getAnyCountry() {
                return _this.getFirstSupportedCountry({
                    countries: _countries
                });
            },
            metadata: _metadata
        });
        _this.state = {
            // Workaround for `this.props` inside `getDerivedStateFromProps()`.
            props: _this.props,
            // The country selected.
            country: preSelectedCountry,
            // `countries` are stored in `this.state` because they're filtered.
            // For example, a developer might theoretically pass some unsupported
            // countries as part of the `countries` property, and because of that
            // the component uses `this.state.countries` (which are filtered)
            // instead of `this.props.countries`
            // (which could potentially contain unsupported countries).
            countries: _countries,
            // `phoneDigits` state property holds non-formatted user's input.
            // The reason is that there's no way of finding out
            // in which form should `value` be displayed: international or national.
            // E.g. if `value` is `+78005553535` then it could be input
            // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
            // Hence storing just `value` is not sufficient for correct formatting.
            // E.g. if a user entered `8 (800) 555-35-35`
            // then value is `+78005553535` and `phoneDigits` are `88005553535`
            // and if a user entered `+7 800 555 35 35`
            // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
            phoneDigits: (0, $a1ccb640610c5bae$export$3b7f83419d3c9d9c)({
                value: _value,
                phoneNumber: phoneNumber,
                defaultCountry: _defaultCountry,
                international: _international,
                useNationalFormat: displayInitialValueAsLocalNumber || initialValueFormat === 'national',
                metadata: _metadata
            }),
            // `value` property is duplicated in state.
            // The reason is that `getDerivedStateFromProps()`
            // needs this `value` to compare to the new `value` property
            // to find out if `phoneDigits` needs updating:
            // If the `value` property was changed externally
            // then it won't be equal to `state.value`
            // in which case `phoneDigits` and `country` should be updated.
            value: _value
        };
        return _this;
    }
    $14b7adcd5f72858f$var$_inherits(PhoneNumberInput_, _React$PureComponent);
    return $14b7adcd5f72858f$var$_createClass(PhoneNumberInput_, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var onCountryChange = this.props.onCountryChange;
                var defaultCountry = this.props.defaultCountry;
                var selectedCountry = this.state.country;
                if (onCountryChange) {
                    if (defaultCountry) {
                        if (!this.isCountrySupportedWithError(defaultCountry)) defaultCountry = undefined;
                    }
                    if (selectedCountry !== defaultCountry) onCountryChange(selectedCountry);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var onCountryChange = this.props.onCountryChange;
                var country = this.state.country;
                // Call `onCountryChange` when user selects another country.
                if (onCountryChange && country !== prevState.country) onCountryChange(country);
            }
        },
        {
            key: "getCountrySelectOptions",
            value: function getCountrySelectOptions(_ref) {
                var countries = _ref.countries;
                var _this$props5 = this.props, international = _this$props5.international, countryCallingCodeEditable = _this$props5.countryCallingCodeEditable, countryOptionsOrder = _this$props5.countryOptionsOrder, addInternationalOption = _this$props5.addInternationalOption, labels = _this$props5.labels, locales = _this$props5.locales, metadata = _this$props5.metadata;
                return this.useMemoCountrySelectOptions(function() {
                    return (0, $b38d815d67cc63c6$export$5e75b0f0f43cd233)((0, $a1ccb640610c5bae$export$85590f0e7cf668c8)({
                        countries: countries || (0, $34c4bee83c07f6dd$export$2e2bcd8739ae039)(metadata),
                        countryNames: labels,
                        addInternationalOption: international && countryCallingCodeEditable === false ? false : addInternationalOption,
                        compareStringsLocales: locales
                    }), (0, $b38d815d67cc63c6$export$afcb8c072b7545af)(countryOptionsOrder, metadata));
                }, [
                    countries,
                    countryOptionsOrder,
                    addInternationalOption,
                    labels,
                    metadata
                ]);
            }
        },
        {
            key: "useMemoCountrySelectOptions",
            value: function useMemoCountrySelectOptions(generator, dependencies) {
                if (!this.countrySelectOptionsMemoDependencies || !$14b7adcd5f72858f$var$areEqualArrays(dependencies, this.countrySelectOptionsMemoDependencies)) {
                    this.countrySelectOptionsMemo = generator();
                    this.countrySelectOptionsMemoDependencies = dependencies;
                }
                return this.countrySelectOptionsMemo;
            }
        },
        {
            key: "getFirstSupportedCountry",
            value: function getFirstSupportedCountry(_ref2) {
                var countries = _ref2.countries;
                var countryOptions = this.getCountrySelectOptions({
                    countries: countries
                });
                return countryOptions[0].value;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, name = _this$props6.name, disabled = _this$props6.disabled, readOnly = _this$props6.readOnly, autoComplete = _this$props6.autoComplete, style = _this$props6.style, className = _this$props6.className, inputRef = _this$props6.inputRef, inputComponent = _this$props6.inputComponent, numberInputProps = _this$props6.numberInputProps, smartCaret = _this$props6.smartCaret, CountrySelectComponent = _this$props6.countrySelectComponent, countrySelectProps = _this$props6.countrySelectProps, ContainerComponent = _this$props6.containerComponent, containerComponentProps = _this$props6.containerComponentProps, defaultCountry = _this$props6.defaultCountry, countriesProperty = _this$props6.countries, countryOptionsOrder = _this$props6.countryOptionsOrder, labels = _this$props6.labels, flags = _this$props6.flags, flagComponent = _this$props6.flagComponent, flagUrl = _this$props6.flagUrl, addInternationalOption = _this$props6.addInternationalOption, internationalIcon = _this$props6.internationalIcon, displayInitialValueAsLocalNumber = _this$props6.displayInitialValueAsLocalNumber, initialValueFormat = _this$props6.initialValueFormat, onCountryChange = _this$props6.onCountryChange, limitMaxLength = _this$props6.limitMaxLength, countryCallingCodeEditable = _this$props6.countryCallingCodeEditable, focusInputOnCountrySelection = _this$props6.focusInputOnCountrySelection, reset = _this$props6.reset, metadata = _this$props6.metadata, international = _this$props6.international, locales = _this$props6.locales, rest = $14b7adcd5f72858f$var$_objectWithoutProperties(_this$props6, $14b7adcd5f72858f$var$_excluded);
                var _this$state3 = this.state, country = _this$state3.country, countries = _this$state3.countries, phoneDigits = _this$state3.phoneDigits, isFocused = _this$state3.isFocused;
                var InputComponent = smartCaret ? (0, $513c28f3788e7bce$export$2e2bcd8739ae039) : (0, $d27e17e9551ae473$export$2e2bcd8739ae039);
                var countrySelectOptions = this.getCountrySelectOptions({
                    countries: countries
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContainerComponent, $14b7adcd5f72858f$var$_extends({
                    style: style,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, 'PhoneInput', {
                        'PhoneInput--focus': isFocused,
                        'PhoneInput--disabled': disabled,
                        'PhoneInput--readOnly': readOnly
                    })
                }, containerComponentProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CountrySelectComponent, $14b7adcd5f72858f$var$_extends({
                    name: name ? "".concat(name, "Country") : undefined,
                    "aria-label": labels.country
                }, countrySelectProps, {
                    value: country,
                    options: countrySelectOptions,
                    onChange: this.onCountryChange,
                    onFocus: this.onCountryFocus,
                    onBlur: this.onCountryBlur,
                    disabled: disabled || countrySelectProps && countrySelectProps.disabled,
                    readOnly: readOnly || countrySelectProps && countrySelectProps.readOnly,
                    iconComponent: this.CountryIcon
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(InputComponent, $14b7adcd5f72858f$var$_extends({
                    ref: this.setInputRef,
                    type: "tel",
                    autoComplete: autoComplete
                }, numberInputProps, rest, {
                    inputFormat: international === true ? 'INTERNATIONAL' : international === false ? 'NATIONAL' : 'INTERNATIONAL_OR_NATIONAL',
                    international: international ? true : undefined,
                    withCountryCallingCode: international ? true : undefined,
                    name: name,
                    metadata: metadata,
                    country: country,
                    value: phoneDigits || '',
                    onChange: this.onChange,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    disabled: disabled,
                    readOnly: readOnly,
                    inputComponent: inputComponent,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
                })));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: // `state` holds previous props as `props`, and also:
            // * `country` — The currently selected country, e.g. `"RU"`.
            // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
            // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
            // (and a couple of other less significant properties)
            function getDerivedStateFromProps(props, state) {
                return $14b7adcd5f72858f$var$_objectSpread({
                    // Emulate `prevProps` via `state.props`.
                    props: props
                }, (0, $b1a36d6ef1af5dce$export$2e2bcd8739ae039)(props, state.props, state));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.
var $14b7adcd5f72858f$var$PhoneNumberInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($14b7adcd5f72858f$var$PhoneNumberInput_, $14b7adcd5f72858f$var$_extends({}, $14b7adcd5f72858f$var$withDefaultProps(props), {
        inputRef: ref
    }));
});
$14b7adcd5f72858f$var$PhoneNumberInput.propTypes = {
    /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */ // (is `"tel"` by default)
    autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */ // (is `undefined` by default)
    initialValueFormat: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'national'
    ]),
    // `displayInitialValueAsLocalNumber` property has been
    // superceded by `initialValueFormat` property.
    displayInitialValueAsLocalNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */ // A two-letter country code ("ISO 3166-1 alpha-2").
    defaultCountry: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */ countries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */ labels: (0, $44b453c2a900e1fd$export$a238cb463698c900),
    /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */ locales: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */ /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */ flagUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */ flags: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType),
    /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */ flagComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */ addInternationalOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */ internationalIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */ countryOptionsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    /**
   * `<Phone/>` component CSS style object.
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * `<Phone/>` component CSS class.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */ countrySelectComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */ countrySelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Phone number `<input/>` component props.
   */ numberInputProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */ containerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    /**
   * Wrapping `<div/>` component props.
   */ containerComponentProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */ // Is `true` by default.
    smartCaret: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format:
   * the user can input their phone number in either "national" or "international" format.
   */ international: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */ limitMaxLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */ countryCallingCodeEditable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */ metadata: (0, $44b453c2a900e1fd$export$dbb5e893e736e4ee),
    /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */ // People have been asking for a way to get the selected country.
    // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
    // For some it's just a "business requirement".
    // I guess it's about gathering as much info on the user as a website can
    // without introducing any addional fields that would complicate the form
    // therefore reducing "conversion" (that's a marketing term).
    // Assuming that the phone number's country is the user's country
    // is not 100% correct but in most cases I guess it's valid.
    onCountryChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */ focusInputOnCountrySelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $14b7adcd5f72858f$var$defaultProps = {
    /**
   * Remember (and autofill) the value as a phone number.
   */ autoComplete: 'tel',
    /**
   * Country `<select/>` component.
   */ countrySelectComponent: (0, $5628cfb1236ba6bc$export$2d95fe84e9746c91),
    /**
   * Flag icon component.
   */ flagComponent: (0, $c359dd94b1ef2bdc$export$2e2bcd8739ae039),
    /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */ // Must be equal to `flagUrl` in `./CountryIcon.js`.
    flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
    /**
   * Default "International" country `<select/>` option icon.
   */ internationalIcon: (0, $dbe281ed06c3f740$export$2e2bcd8739ae039),
    /**
   * Phone number `<input/>` component.
   */ inputComponent: 'input',
    /**
   * Wrapping `<div/>` component.
   */ containerComponent: 'div',
    /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */ // https://github.com/catamphetamine/react-phone-number-input/issues/300
    reset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   *
   */ /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */ smartCaret: true,
    /**
   * Whether to add the "International" option
   * to the list of countries.
   */ addInternationalOption: true,
    /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */ countryCallingCodeEditable: true,
    /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */ focusInputOnCountrySelection: true
};
function $14b7adcd5f72858f$var$withDefaultProps(props) {
    props = $14b7adcd5f72858f$var$_objectSpread({}, props);
    for(var key in $14b7adcd5f72858f$var$defaultProps)if (props[key] === undefined) props[key] = $14b7adcd5f72858f$var$defaultProps[key];
    return props;
}
var $14b7adcd5f72858f$export$2e2bcd8739ae039 = $14b7adcd5f72858f$var$PhoneNumberInput;
function $14b7adcd5f72858f$var$areEqualArrays(a, b) {
    if (a.length !== b.length) return false;
    var i = 0;
    while(i < a.length){
        if (a[i] !== b[i]) return false;
        i++;
    }
    return true;
}


var $5217fd7be51b9855$var$_excluded = [
    "metadata",
    "labels"
];
function $5217fd7be51b9855$var$_extends() {
    $5217fd7be51b9855$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5217fd7be51b9855$var$_extends.apply(this, arguments);
}
function $5217fd7be51b9855$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5217fd7be51b9855$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5217fd7be51b9855$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5217fd7be51b9855$export$6b3f3b62761c8af5(defaultMetadata) {
    var PhoneInputDefault = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
        var _ref$metadata = _ref.metadata, metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata, _ref$labels = _ref.labels, labels = _ref$labels === void 0 ? (0, $80a053da314de61a$export$2e2bcd8739ae039) : _ref$labels, rest = $5217fd7be51b9855$var$_objectWithoutProperties(_ref, $5217fd7be51b9855$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $14b7adcd5f72858f$export$2e2bcd8739ae039), $5217fd7be51b9855$var$_extends({}, rest, {
            ref: ref,
            metadata: metadata,
            labels: labels
        }));
    });
    PhoneInputDefault.propTypes = {
        metadata: (0, $44b453c2a900e1fd$export$dbb5e893e736e4ee),
        labels: (0, $44b453c2a900e1fd$export$a238cb463698c900)
    };
    return PhoneInputDefault;
}
var $5217fd7be51b9855$export$2e2bcd8739ae039 = $5217fd7be51b9855$export$6b3f3b62761c8af5();


function $fae909b2a8c6cde8$var$call(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $3195bad5b20c0860$export$2e2bcd8739ae039));
    return func.apply(this, args);
}
var $fae909b2a8c6cde8$export$2e2bcd8739ae039 = (0, $5217fd7be51b9855$export$6b3f3b62761c8af5)((0, $3195bad5b20c0860$export$2e2bcd8739ae039));
function $fae909b2a8c6cde8$export$da44e4eaa54bc82e() {
    return $fae909b2a8c6cde8$var$call((0, $fe2783d9f9ccca74$export$2e2bcd8739ae039), arguments);
}
function $fae909b2a8c6cde8$export$842dcfa371c6bb83() {
    return $fae909b2a8c6cde8$var$call((0, $dfa9013f08ee2b8a$export$2e2bcd8739ae039), arguments);
}
function $fae909b2a8c6cde8$export$88012462592bc004() {
    return $fae909b2a8c6cde8$var$call((0, $dfa9013f08ee2b8a$export$88012462592bc004), arguments);
}
function $fae909b2a8c6cde8$export$992e2df24bec72ba() {
    return $fae909b2a8c6cde8$var$call((0, $bbd8ac01a56cfc98$export$2e2bcd8739ae039), arguments);
}
function $fae909b2a8c6cde8$export$e102acdf1aeb3167() {
    return $fae909b2a8c6cde8$var$call((0, $6451538427aaf2b0$export$2e2bcd8739ae039), arguments);
}
function $fae909b2a8c6cde8$export$44f7508c6c352cc6() {
    return $fae909b2a8c6cde8$var$call((0, $34c4bee83c07f6dd$export$2e2bcd8739ae039), arguments);
}
function $fae909b2a8c6cde8$export$32876ca2f1919cf0() {
    return $fae909b2a8c6cde8$var$call((0, $f80aac35004a54c3$export$32876ca2f1919cf0), arguments);
}
function $fae909b2a8c6cde8$export$bd9e113b8b17202a() {
    return $fae909b2a8c6cde8$var$call((0, $f80aac35004a54c3$export$bd9e113b8b17202a), arguments);
}


// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

function $15310a7fe3faeae2$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $3195bad5b20c0860$export$2e2bcd8739ae039));
    return func.apply(this, args);
}



function $4fce2d9c08e9c2d7$export$da44e4eaa54bc82e() {
    return (0, $15310a7fe3faeae2$export$2e2bcd8739ae039)((0, $fe2783d9f9ccca74$export$2e2bcd8739ae039), arguments);
}




var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e04b2be4f01b0598$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z"
}), 'Business');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $48243e3ec0f74b4e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0-8 5-8-5zm0 12H4V8l8 5 8-5z"
}), 'EmailOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $979a146dcf4c238a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56C4.61 15.07 4 16.1 4 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66M18 18H6v-.78c0-.38.2-.72.52-.88C7.71 15.73 9.63 15 12 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88zm-8.22-6h4.44c1.21 0 2.14-1.06 1.98-2.26l-.32-2.45C15.57 5.39 13.92 4 12 4S8.43 5.39 8.12 7.29L7.8 9.74c-.16 1.2.77 2.26 1.98 2.26m.32-4.41C10.26 6.67 11.06 6 12 6s1.74.67 1.9 1.59l.32 2.41H9.78z"
}), 'Person2Outlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $cdbaae095ceb82e8$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    fillRule: "evenodd",
    d: "M14 6V4h-4v2zM4 8v11h16V8zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2z"
}), 'WorkOutline');




var $ayMG0 = parcelRequire("ayMG0");
var $0a34a21cae127bf5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
$0a34a21cae127bf5$exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ''
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}


var $d2ed6e977f19f182$exports = {};
const $d2ed6e977f19f182$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $d2ed6e977f19f182$var$words = (str)=>str.match($d2ed6e977f19f182$var$reWords) || [];
const $d2ed6e977f19f182$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $d2ed6e977f19f182$var$join = (str, d)=>$d2ed6e977f19f182$var$words(str).join(d).toLowerCase();
const $d2ed6e977f19f182$var$camelCase = (str)=>$d2ed6e977f19f182$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $d2ed6e977f19f182$var$pascalCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$camelCase(str));
const $d2ed6e977f19f182$var$snakeCase = (str)=>$d2ed6e977f19f182$var$join(str, '_');
const $d2ed6e977f19f182$var$kebabCase = (str)=>$d2ed6e977f19f182$var$join(str, '-');
const $d2ed6e977f19f182$var$sentenceCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$join(str, ' '));
const $d2ed6e977f19f182$var$titleCase = (str)=>$d2ed6e977f19f182$var$words(str).map($d2ed6e977f19f182$var$upperFirst).join(' ');
$d2ed6e977f19f182$exports = {
    words: $d2ed6e977f19f182$var$words,
    upperFirst: $d2ed6e977f19f182$var$upperFirst,
    camelCase: $d2ed6e977f19f182$var$camelCase,
    pascalCase: $d2ed6e977f19f182$var$pascalCase,
    snakeCase: $d2ed6e977f19f182$var$snakeCase,
    kebabCase: $d2ed6e977f19f182$var$kebabCase,
    sentenceCase: $d2ed6e977f19f182$var$sentenceCase,
    titleCase: $d2ed6e977f19f182$var$titleCase
};


var $a2cee144eac47a21$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $a2cee144eac47a21$exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
$a2cee144eac47a21$exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $cda9d0e1103d595f$var$toString = Object.prototype.toString;
const $cda9d0e1103d595f$var$errorToString = Error.prototype.toString;
const $cda9d0e1103d595f$var$regExpToString = RegExp.prototype.toString;
const $cda9d0e1103d595f$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $cda9d0e1103d595f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $cda9d0e1103d595f$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $cda9d0e1103d595f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $cda9d0e1103d595f$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $cda9d0e1103d595f$var$symbolToString.call(val).replace($cda9d0e1103d595f$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $cda9d0e1103d595f$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $cda9d0e1103d595f$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $cda9d0e1103d595f$var$regExpToString.call(val);
    return null;
}
function $cda9d0e1103d595f$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $cda9d0e1103d595f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $cda9d0e1103d595f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $cda9d0e1103d595f$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $cda9d0e1103d595f$var$_Symbol$toStringTag, $cda9d0e1103d595f$var$_Symbol$hasInstance, $cda9d0e1103d595f$var$_Symbol$toStringTag2;
let $cda9d0e1103d595f$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$cda9d0e1103d595f$var$_Symbol$toStringTag = Symbol.toStringTag;
class $cda9d0e1103d595f$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $cda9d0e1103d595f$var$toArray(errorOrErrors).forEach((err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$cda9d0e1103d595f$var$_Symbol$hasInstance = Symbol.hasInstance;
$cda9d0e1103d595f$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $cda9d0e1103d595f$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($cda9d0e1103d595f$var$strReg, (_, key)=>$cda9d0e1103d595f$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $cda9d0e1103d595f$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cda9d0e1103d595f$export$2191b9da168c6cf0);
    }
    static [$cda9d0e1103d595f$var$_Symbol$hasInstance](inst) {
        return $cda9d0e1103d595f$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $cda9d0e1103d595f$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $cda9d0e1103d595f$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $cda9d0e1103d595f$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $cda9d0e1103d595f$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $cda9d0e1103d595f$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $cda9d0e1103d595f$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $cda9d0e1103d595f$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $cda9d0e1103d595f$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $cda9d0e1103d595f$export$2191b9da168c6cf0.formatError($cda9d0e1103d595f$var$mixed.notType, params);
    }
};
var $cda9d0e1103d595f$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $cda9d0e1103d595f$var$mixed,
    string: $cda9d0e1103d595f$var$string,
    number: $cda9d0e1103d595f$var$number,
    date: $cda9d0e1103d595f$var$date,
    object: $cda9d0e1103d595f$var$object,
    array: $cda9d0e1103d595f$var$array,
    boolean: $cda9d0e1103d595f$var$boolean,
    tuple: $cda9d0e1103d595f$var$tuple
});
const $cda9d0e1103d595f$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $cda9d0e1103d595f$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $cda9d0e1103d595f$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $cda9d0e1103d595f$var$prefixes = {
    context: '$',
    value: '.'
};
function $cda9d0e1103d595f$export$eff4d24c3ff7876e(key, options) {
    return new $cda9d0e1103d595f$var$Reference(key, options);
}
class $cda9d0e1103d595f$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $cda9d0e1103d595f$var$prefixes.context;
        this.isValue = this.key[0] === $cda9d0e1103d595f$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $cda9d0e1103d595f$var$prefixes.context : this.isValue ? $cda9d0e1103d595f$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $0a34a21cae127bf5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$cda9d0e1103d595f$var$Reference.prototype.__isYupRef = true;
const $cda9d0e1103d595f$var$isAbsent = (value)=>value == null;
function $cda9d0e1103d595f$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $cda9d0e1103d595f$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $cda9d0e1103d595f$export$2191b9da168c6cf0($cda9d0e1103d595f$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $cda9d0e1103d595f$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $cda9d0e1103d595f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $0a34a21cae127bf5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $cda9d0e1103d595f$export$cfedb76369cc7782(obj, path, value, context) {
    return $cda9d0e1103d595f$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $cda9d0e1103d595f$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($cda9d0e1103d595f$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $cda9d0e1103d595f$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $cda9d0e1103d595f$var$clone(src, seen = new Map()) {
    if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $cda9d0e1103d595f$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $cda9d0e1103d595f$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $cda9d0e1103d595f$var$ReferenceSet();
        this._blacklist = new $cda9d0e1103d595f$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $cda9d0e1103d595f$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $cda9d0e1103d595f$var$isAbsent(result)) return result;
            let formattedValue = $cda9d0e1103d595f$export$5790025c6e6c2ba6(value);
            let formattedResult = $cda9d0e1103d595f$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $cda9d0e1103d595f$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $cda9d0e1103d595f$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $cda9d0e1103d595f$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $cda9d0e1103d595f$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $cda9d0e1103d595f$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $cda9d0e1103d595f$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $cda9d0e1103d595f$var$toArray(keys).map((key)=>new $cda9d0e1103d595f$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $cda9d0e1103d595f$var$Condition(deps, options) : $cda9d0e1103d595f$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $cda9d0e1103d595f$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $cda9d0e1103d595f$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$cda9d0e1103d595f$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $cda9d0e1103d595f$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.notOneOf;
const $cda9d0e1103d595f$var$returnsTrue = ()=>true;
function $cda9d0e1103d595f$export$9b30b6294c1449a8(spec) {
    return new $cda9d0e1103d595f$export$1e88358c94ddec71(spec);
}
class $cda9d0e1103d595f$export$1e88358c94ddec71 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $cda9d0e1103d595f$var$returnsTrue
        }, spec));
    }
}
$cda9d0e1103d595f$export$9b30b6294c1449a8.prototype = $cda9d0e1103d595f$export$1e88358c94ddec71.prototype;
function $cda9d0e1103d595f$export$87b259aa03e3d267() {
    return new $cda9d0e1103d595f$export$c7980688f11e1f49();
}
class $cda9d0e1103d595f$export$c7980688f11e1f49 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$cda9d0e1103d595f$export$87b259aa03e3d267.prototype = $cda9d0e1103d595f$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $cda9d0e1103d595f$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $cda9d0e1103d595f$var$parseIsoDate(date) {
    const struct = $cda9d0e1103d595f$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $cda9d0e1103d595f$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $cda9d0e1103d595f$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $cda9d0e1103d595f$var$toNumber(regexResult[1]),
        month: $cda9d0e1103d595f$var$toNumber(regexResult[2], 1) - 1,
        day: $cda9d0e1103d595f$var$toNumber(regexResult[3], 1),
        hour: $cda9d0e1103d595f$var$toNumber(regexResult[4]),
        minute: $cda9d0e1103d595f$var$toNumber(regexResult[5]),
        second: $cda9d0e1103d595f$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $cda9d0e1103d595f$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $cda9d0e1103d595f$var$toNumber(regexResult[10]),
        minuteOffset: $cda9d0e1103d595f$var$toNumber(regexResult[11])
    };
}
function $cda9d0e1103d595f$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $cda9d0e1103d595f$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $cda9d0e1103d595f$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $cda9d0e1103d595f$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $cda9d0e1103d595f$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $cda9d0e1103d595f$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $cda9d0e1103d595f$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $cda9d0e1103d595f$var$rIsoDateTime = new RegExp(`${$cda9d0e1103d595f$var$yearMonthDay}T${$cda9d0e1103d595f$var$hourMinuteSecond}(\\.\\d+)?${$cda9d0e1103d595f$var$zOrOffset}$`);
let $cda9d0e1103d595f$var$isTrimmed = (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.trim();
let $cda9d0e1103d595f$var$objStringTag = ({}).toString();
function $cda9d0e1103d595f$export$22b082955e083ec3() {
    return new $cda9d0e1103d595f$export$49bf8b2ede5138eb();
}
class $cda9d0e1103d595f$export$49bf8b2ede5138eb extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $cda9d0e1103d595f$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $cda9d0e1103d595f$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $cda9d0e1103d595f$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $cda9d0e1103d595f$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $cda9d0e1103d595f$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $cda9d0e1103d595f$var$string.email) {
        return this.matches($cda9d0e1103d595f$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $cda9d0e1103d595f$var$string.url) {
        return this.matches($cda9d0e1103d595f$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $cda9d0e1103d595f$var$string.uuid) {
        return this.matches($cda9d0e1103d595f$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($cda9d0e1103d595f$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $cda9d0e1103d595f$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $cda9d0e1103d595f$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $cda9d0e1103d595f$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $cda9d0e1103d595f$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $cda9d0e1103d595f$var$isTrimmed
        });
    }
    lowercase(message = $cda9d0e1103d595f$var$string.lowercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $cda9d0e1103d595f$var$string.uppercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$cda9d0e1103d595f$export$22b082955e083ec3.prototype = $cda9d0e1103d595f$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $cda9d0e1103d595f$var$isNaN$1 = (value)=>value != +value;
function $cda9d0e1103d595f$export$98e628dec113755e() {
    return new $cda9d0e1103d595f$export$f192ec5e9228ab19();
}
class $cda9d0e1103d595f$export$f192ec5e9228ab19 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$cda9d0e1103d595f$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $cda9d0e1103d595f$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $cda9d0e1103d595f$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $cda9d0e1103d595f$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $cda9d0e1103d595f$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $cda9d0e1103d595f$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $cda9d0e1103d595f$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$cda9d0e1103d595f$export$98e628dec113755e.prototype = $cda9d0e1103d595f$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $cda9d0e1103d595f$var$invalidDate = new Date('');
let $cda9d0e1103d595f$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $cda9d0e1103d595f$export$324d90190a8b822a() {
    return new $cda9d0e1103d595f$export$18ec3cc5a157503f();
}
class $cda9d0e1103d595f$export$18ec3cc5a157503f extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $cda9d0e1103d595f$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $cda9d0e1103d595f$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$cda9d0e1103d595f$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $cda9d0e1103d595f$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
$cda9d0e1103d595f$export$324d90190a8b822a.prototype = $cda9d0e1103d595f$export$18ec3cc5a157503f.prototype;
$cda9d0e1103d595f$export$324d90190a8b822a.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
// @ts-expect-error
function $cda9d0e1103d595f$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $0a34a21cae127bf5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($cda9d0e1103d595f$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2cee144eac47a21$exports))).array(Array.from(nodes), edges).reverse();
}
function $cda9d0e1103d595f$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $cda9d0e1103d595f$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $cda9d0e1103d595f$var$findIndex(keys, a) - $cda9d0e1103d595f$var$findIndex(keys, b);
    };
}
const $cda9d0e1103d595f$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $cda9d0e1103d595f$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $cda9d0e1103d595f$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $cda9d0e1103d595f$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($cda9d0e1103d595f$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $cda9d0e1103d595f$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $0a34a21cae127bf5$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $0a34a21cae127bf5$exports.getter)((0, $0a34a21cae127bf5$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $cda9d0e1103d595f$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $cda9d0e1103d595f$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cda9d0e1103d595f$var$defaultSort = $cda9d0e1103d595f$var$sortByKeyOrder([]);
function $cda9d0e1103d595f$export$be5493f9613cbbe(spec) {
    return new $cda9d0e1103d595f$export$18b4fc70ec7eccf8(spec);
}
class $cda9d0e1103d595f$export$18b4fc70ec7eccf8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $cda9d0e1103d595f$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $cda9d0e1103d595f$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $cda9d0e1103d595f$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$cda9d0e1103d595f$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $cda9d0e1103d595f$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $cda9d0e1103d595f$var$sortFields(shape, excludedEdges);
        next._sortErrors = $cda9d0e1103d595f$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $cda9d0e1103d595f$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $0a34a21cae127bf5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($cda9d0e1103d595f$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $cda9d0e1103d595f$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $d2ed6e977f19f182$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$be5493f9613cbbe.prototype = $cda9d0e1103d595f$export$18b4fc70ec7eccf8.prototype;
function $cda9d0e1103d595f$export$2f23118c22fb2630(type) {
    return new $cda9d0e1103d595f$export$4347112b8447a7d(type);
}
class $cda9d0e1103d595f$export$4347112b8447a7d extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $cda9d0e1103d595f$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $cda9d0e1103d595f$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $cda9d0e1103d595f$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $cda9d0e1103d595f$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$2f23118c22fb2630.prototype = $cda9d0e1103d595f$export$4347112b8447a7d.prototype;
// @ts-ignore
function $cda9d0e1103d595f$export$65e3907585753458(schemas) {
    return new $cda9d0e1103d595f$export$411c3b3687e8ecc8(schemas);
}
class $cda9d0e1103d595f$export$411c3b3687e8ecc8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$cda9d0e1103d595f$export$65e3907585753458.prototype = $cda9d0e1103d595f$export$411c3b3687e8ecc8.prototype;
function $cda9d0e1103d595f$export$488013bae63b21da(builder) {
    return new $cda9d0e1103d595f$export$71117d144d3091c9(builder);
}
function $cda9d0e1103d595f$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $cda9d0e1103d595f$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $cda9d0e1103d595f$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $cda9d0e1103d595f$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $cda9d0e1103d595f$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $cda9d0e1103d595f$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $cda9d0e1103d595f$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $cda9d0e1103d595f$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$cda9d0e1103d595f$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}


parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === 'object';
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $0d70f179cf56e662$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(object)) return defaultValue;
    const result = $0d70f179cf56e662$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0d70f179cf56e662$var$isUndefined(result) || result === object ? $0d70f179cf56e662$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $0d70f179cf56e662$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0d70f179cf56e662$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $0d70f179cf56e662$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0d70f179cf56e662$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === 'string';
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($0d70f179cf56e662$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0d70f179cf56e662$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (event)=>_registerProps.current.onChange({
                    target: {
                        value: $0d70f179cf56e662$var$getEventValue(event),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.CHANGE
                }),
            onBlur: ()=>_registerProps.current.onBlur({
                    target: {
                        value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.BLUR
                }),
            ref: (elm)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        }), [
        name,
        control._formValues,
        disabled,
        formState.disabled,
        value1,
        control._fields
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($0d70f179cf56e662$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $0d70f179cf56e662$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $0d70f179cf56e662$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0d70f179cf56e662$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $0d70f179cf56e662$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$generateId = ()=>{
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($0d70f179cf56e662$var$isObject(currentField)) {
                if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === 'file';
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === 'function';
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMessage = (value1)=>$0d70f179cf56e662$var$isString(value1);
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === 'radio';
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === '' ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getValidateError(result, ref, type = 'validate') {
    if ($0d70f179cf56e662$var$isMessage(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isMessage) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $0d70f179cf56e662$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $0d70f179cf56e662$var$appendAt = (data, value1)=>[
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0d70f179cf56e662$var$prependAt = (data, value1)=>[
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    rules && control.register(name, rules);
    $0d70f179cf56e662$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$appendAt(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$appendAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prependAt(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prependAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) && $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit)) $0d70f179cf56e662$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $0d70f179cf56e662$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0d70f179cf56e662$var$markFieldsDirty(data[key], []) : {
                ...$0d70f179cf56e662$var$markFieldsDirty(data[key])
            };
            else $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $0d70f179cf56e662$var$getDirtyFields = (defaultValues, formValues)=>$0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0d70f179cf56e662$var$markFieldsDirty(formValues));
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $0d70f179cf56e662$var$ASYNC_FUNCTION = 'AsyncFunction';
var $0d70f179cf56e662$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($0d70f179cf56e662$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION || $0d70f179cf56e662$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION));
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$var$createFormControl(props = {}) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $0d70f179cf56e662$var$createSubject(),
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $0d70f179cf56e662$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$0d70f179cf56e662$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            const disabledField = !!($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name) && $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)._f && $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $0d70f179cf56e662$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                !$0d70f179cf56e662$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? '' : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $0d70f179cf56e662$var$isObject(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $0d70f179cf56e662$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $0d70f179cf56e662$var$deepEqual(fieldValue, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (_options.mode === 'onBlur' && isBlurEvent) _updateValid();
                    else if (!isBlurEvent) _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $0d70f179cf56e662$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            updateTouchAndDirty(name, $0d70f179cf56e662$var$getFieldValue(field ? field._f : $0d70f179cf56e662$export$3988ae62b71be9a3(fields, name)._f), false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled) || $0d70f179cf56e662$var$isBoolean(_options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: $0d70f179cf56e662$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            if (_names.disabled.size) for (const name of _names.disabled)$0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldValues, name, undefined);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $0d70f179cf56e662$var$unset(_formState.errors, 'root');
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, $0d70f179cf56e662$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const isEmptyResetValues = $0d70f179cf56e662$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $0d70f179cf56e662$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$0d70f179cf56e662$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($0d70f179cf56e662$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}




var $302743bfdc67c75e$var$t = function(e, t, i) {
    if (e && "reportValidity" in e) {
        var n = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(i, t);
        e.setCustomValidity(n && n.message || ""), e.reportValidity();
    }
}, $302743bfdc67c75e$export$6bd436d70894afff = function(r, e) {
    var i = function(i) {
        var n = e.fields[i];
        n && n.ref && "reportValidity" in n.ref ? $302743bfdc67c75e$var$t(n.ref, i, r) : n.refs && n.refs.forEach(function(e) {
            return $302743bfdc67c75e$var$t(e, i, r);
        });
    };
    for(var n in e.fields)i(n);
}, $302743bfdc67c75e$export$f0545b73a179e3a2 = function(t, n) {
    n.shouldUseNativeValidation && $302743bfdc67c75e$export$6bd436d70894afff(t, n);
    var f = {};
    for(var a in t){
        var s = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(n.fields, a), u = Object.assign(t[a] || {}, {
            ref: s && s.ref
        });
        if ($302743bfdc67c75e$var$o(n.names || Object.keys(t), a)) {
            var c = Object.assign({}, (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(f, a));
            (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(c, "root", u), (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(f, a, c);
        } else (0, $0d70f179cf56e662$export$adaa4cf7ef1b65be)(f, a, u);
    }
    return f;
}, $302743bfdc67c75e$var$o = function(r, e) {
    return r.some(function(r) {
        return r.startsWith(e + ".");
    });
};



function $0df32c3dd3ad0e0c$export$d55832dfcd4989a(o, n, a) {
    return void 0 === n && (n = {}), void 0 === a && (a = {}), function(s, i, c) {
        try {
            return Promise.resolve(function(t, r) {
                try {
                    var u = (n.context, Promise.resolve(o["sync" === a.mode ? "validateSync" : "validate"](s, Object.assign({
                        abortEarly: !1
                    }, n, {
                        context: i
                    }))).then(function(t) {
                        return c.shouldUseNativeValidation && (0, $302743bfdc67c75e$export$6bd436d70894afff)({}, c), {
                            values: a.raw ? s : t,
                            errors: {}
                        };
                    }));
                } catch (e) {
                    return r(e);
                }
                return u && u.then ? u.then(void 0, r) : u;
            }(0, function(e) {
                if (!e.inner) throw e;
                var o, n;
                return {
                    values: {},
                    errors: (0, $302743bfdc67c75e$export$f0545b73a179e3a2)((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function(e, t) {
                        if (e[t.path] || (e[t.path] = {
                            message: t.message,
                            type: t.type
                        }), n) {
                            var o = e[t.path].types, a = o && o[t.type];
                            e[t.path] = (0, $0d70f179cf56e662$export$b196c2a4f765bd30)(t.path, n, e, t.type, a ? [].concat(a, t.message) : t.message);
                        }
                        return e;
                    }, {})), c)
                };
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
}



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $6f6c3073d1def957$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6m-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14M2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45zm7.5 7.5 2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13m-3.4-3.4 1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53"
}), 'VisibilityOffOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $67c8996ddef93e6e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"
}), 'VisibilityOutlined');



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $db148f21bce47fcb$var$InputField = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixIcon: prefixIcon, afterIcon: afterIcon, error: error, customClassName: customClassName, ...rest } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic",
                children: [
                    prefixIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: prefixIcon
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: ref,
                        ...rest,
                        className: `w100 bg1 bs1px brss bo42 mt0-9rem py0-75rem br8px ${prefixIcon ? "pl3rem" : "pl1rem"} ${customClassName}`
                    }),
                    afterIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: afterIcon
                    }) : null
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "errorform",
                children: error.message
            })
        ]
    });
});
var $db148f21bce47fcb$export$2e2bcd8739ae039 = $db148f21bce47fcb$var$InputField;





const $23a6a3e44d8fe1b7$var$changePasswordSchema = $cda9d0e1103d595f$export$be5493f9613cbbe().shape({
    currentPassword: $cda9d0e1103d595f$export$22b082955e083ec3().required('Current password is required'),
    newPassword: $cda9d0e1103d595f$export$22b082955e083ec3().required('New password is required').min(6, 'Password must be at least 6 characters'),
    confirmPassword: $cda9d0e1103d595f$export$22b082955e083ec3().oneOf([
        $cda9d0e1103d595f$export$eff4d24c3ff7876e('newPassword'),
        null
    ], 'Passwords must match').required('Confirm password is required')
});
const $23a6a3e44d8fe1b7$var$ChangePassword = ({ onSubmitData: onSubmitData, userData: userData })=>{
    // Hooks and vars
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [passwordVisibility, setPasswordVisibility] = (0, $acw62.useState)({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false
    });
    const togglePasswordVisibility = (field)=>{
        setPasswordVisibility((prevState)=>({
                ...prevState,
                [field]: !prevState[field]
            }));
    };
    const { register: register, handleSubmit: handleSubmit, watch: watch, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($23a6a3e44d8fe1b7$var$changePasswordSchema)
    });
    const watchFields = watch([
        'currentPassword',
        'newPassword',
        'confirmPassword'
    ]);
    const onSubmit = async (data)=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/changePassword`, {
                oldPassword: data.currentPassword,
                newPassword: data.newPassword
            });
            if (!res || res["code"] != 200) return;
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            reset();
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'passwordUpdatedSuccessfully',
                historyData: {
                    message: 'Your password has been updated successfully.'
                }
            }));
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e["message"]);
        }
    };
    const renderPasswordField = (id, label, error, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $db148f21bce47fcb$export$2e2bcd8739ae039), {
            id: id,
            type: passwordVisibility[id] ? 'text' : 'password',
            ...register(id),
            error: error,
            placeholder: `Enter ${label}`,
            prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: "pa c2",
                style: {
                    left: '15px',
                    marginTop: '0.8rem',
                    color: watchFields[index] ? '#000' : '#505050'
                },
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M13.0078 12.8672C13.3961 12.8672 13.7109 12.5524 13.7109 12.1641C13.7109 11.7757 13.3961 11.4609 13.0078 11.4609C12.6195 11.4609 12.3047 11.7757 12.3047 12.1641C12.3047 12.5524 12.6195 12.8672 13.0078 12.8672Z",
                        fill: `${watchFields[index] ? '#000' : '#505050'}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M16.1719 12.7266C16.5602 12.7266 16.875 12.4118 16.875 12.0234V9.42188C16.875 7.87106 15.6133 6.60938 14.0625 6.60938H13.2174V4.12966C13.2174 1.85256 11.3249 0 8.9987 0C6.67248 0 4.77995 1.85256 4.77995 4.12966V6.60938H3.9375C2.38669 6.60938 1.125 7.87106 1.125 9.42188V15.1875C1.125 16.7383 2.38669 18 3.9375 18H14.0625C15.6133 18 16.875 16.7383 16.875 15.1875C16.875 14.7992 16.5602 14.4844 16.1719 14.4844C15.7835 14.4844 15.4688 14.7992 15.4688 15.1875C15.4688 15.9629 14.8379 16.5938 14.0625 16.5938H3.9375C3.16209 16.5938 2.53125 15.9629 2.53125 15.1875V9.42188C2.53125 8.64647 3.16209 8.01562 3.9375 8.01562H14.0625C14.8379 8.01562 15.4688 8.64647 15.4688 9.42188V12.0234C15.4688 12.4118 15.7835 12.7266 16.1719 12.7266ZM11.8112 6.60938H6.1862V4.12966C6.1862 2.62796 7.44789 1.40625 8.9987 1.40625C10.5495 1.40625 11.8112 2.62796 11.8112 4.12966V6.60938Z",
                        fill: `${watchFields[index] ? '#000' : '#505050'}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7.70312 12.8672C8.09145 12.8672 8.40625 12.5524 8.40625 12.1641C8.40625 11.7757 8.09145 11.4609 7.70312 11.4609C7.3148 11.4609 7 11.7757 7 12.1641C7 12.5524 7.3148 12.8672 7.70312 12.8672Z",
                        fill: `${watchFields[index] ? '#000' : '#505050'}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M5.0625 12.8672C5.45083 12.8672 5.76562 12.5524 5.76562 12.1641C5.76562 11.7757 5.45083 11.4609 5.0625 11.4609C4.67417 11.4609 4.35938 11.7757 4.35938 12.1641C4.35938 12.5524 4.67417 12.8672 5.0625 12.8672Z",
                        fill: `${watchFields[index] ? '#000' : '#505050'}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10.3359 12.8672C10.7243 12.8672 11.0391 12.5524 11.0391 12.1641C11.0391 11.7757 10.7243 11.4609 10.3359 11.4609C9.94761 11.4609 9.63281 11.7757 9.63281 12.1641C9.63281 12.5524 9.94761 12.8672 10.3359 12.8672Z",
                        fill: `${watchFields[index] ? '#000' : '#505050'}`
                    })
                ]
            }),
            afterIcon: passwordVisibility[id] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f6c3073d1def957$export$2e2bcd8739ae039), {
                className: "pa c2 cursor-pointer",
                style: {
                    right: '15px',
                    marginTop: '0.8rem',
                    color: watchFields[index] ? '#000' : '#505050'
                },
                onClick: ()=>togglePasswordVisibility(id)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67c8996ddef93e6e$export$2e2bcd8739ae039), {
                className: "pa c2 cursor-pointer",
                style: {
                    right: '15px',
                    marginTop: '0.8rem',
                    color: watchFields[index] ? '#000' : '#505050'
                },
                onClick: ()=>togglePasswordVisibility(id)
            })
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w100 pr",
                children: renderPasswordField('currentPassword', 'Current Password', errors.currentPassword, 0)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcsb mt0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w50 pr mr1rem",
                        children: renderPasswordField('newPassword', 'New Password', errors.newPassword, 1)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w50 pr",
                        children: renderPasswordField('confirmPassword', 'Confirm Password', errors.confirmPassword, 2)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt1rem df jcc",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    type: "submit",
                    style: {
                        width: '250px',
                        maxHeight: "45px"
                    },
                    customClassName: "c1",
                    btnType: 'warning',
                    text: "Confirm Password"
                })
            })
        ]
    });
};
var $23a6a3e44d8fe1b7$export$2e2bcd8739ae039 = $23a6a3e44d8fe1b7$var$ChangePassword;





const $276a43382856225f$var$ProfileForm = /*#__PURE__*/ (0, $acw62.forwardRef)(({ userData: userData, Button: Button }, ref)=>{
    // Hooks and vars 
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { smsEnabled: smsEnabled, twoFaEnabled: twoFaEnabled, emailEnabled: emailEnabled } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.loginType);
    const [counter, setCounter] = (0, $acw62.useState)(0); // Countdown for 60s
    const [verify, setVerify] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [email, setEmail] = (0, $acw62.useState)('');
    const [phone, setPhone] = (0, $acw62.useState)('');
    const [phoneCountry, setPhoneCountry] = (0, $acw62.useState)('GB'); // Selected/last-known country for the phone field; defaults to UK
    const [linkedIn, setLinkedIn] = (0, $acw62.useState)('');
    const [lastName, setLastName] = (0, $acw62.useState)('');
    const [firstName, setFirstName] = (0, $acw62.useState)('');
    const [designation, setDesignation] = (0, $acw62.useState)('');
    // Reason: normalise any national/trunk-zero/international phone format to E.164, resolving bare national numbers against the selected country
    const normalizePhone = (value, country = 'GB')=>{
        if (!value) return '';
        const parsed = (0, $4fce2d9c08e9c2d7$export$da44e4eaa54bc82e)(value, country);
        return parsed ? parsed.number : value;
    };
    const buttonText = (0, $acw62.useMemo)(()=>{
        return counter > 0 ? `Resend in ${counter}s` : 'Resend Code';
    }, [
        counter
    ]);
    const isButtonDisabled = (0, $acw62.useMemo)(()=>{
        return counter > 0 || loading;
    }, [
        counter,
        loading
    ]);
    (0, $acw62.useEffect)(()=>{
        let timer;
        if (counter > 0) timer = setTimeout(()=>setCounter(counter - 1), 1000);
        return ()=>clearTimeout(timer);
    }, [
        counter
    ]);
    (0, $acw62.useEffect)(()=>{
        if (firstName == '') setFirstName(userData['firstName']);
        if (lastName == '') setLastName(userData['lastName']);
        if (email == '') setEmail(userData['email']);
        if (phone == '') {
            const initialPhone = userData['phone'] || '';
            setPhone(initialPhone);
            // Reason: seed the country dropdown from the stored number so its flag matches on load
            const parsedInitial = initialPhone && (0, $4fce2d9c08e9c2d7$export$da44e4eaa54bc82e)(initialPhone);
            if (parsedInitial && parsedInitial.country) setPhoneCountry(parsedInitial.country);
        }
        if (linkedIn == '') setLinkedIn(userData['linkedIn'] || '');
        if (designation == '') setDesignation(userData['designation'] || userData['title'] || userData['job'] || '');
    }, [
        userData
    ]);
    const onSubmitData = async ()=>{
        if (firstName == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please enter the first name`);
        if (lastName == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please enter the last name`);
        if (email == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please enter the email`);
        // if (linkedIn == '') return showMessage(`Please enter the linkedIn`);
        setLoading(true);
        const normalizedPhone = normalizePhone(phone, phoneCountry);
        if (normalizedPhone !== phone) setPhone(normalizedPhone);
        try {
            // let regex = /^http(s)?:\/\/([\w]+\.)?linkedin\.com\/in|company\/[A-z0-9_-]+\/?/;
            // if (linkedIn && linkedIn.length > 0) {
            //   let isValid = regex.test(linkedIn)
            //   if (!isValid) {
            //     return showMessage("Please provide a valid linkedin profile url");
            //   }
            // }
            // if (phone && !userData['smsEnabled']) {
            //   return showMessage("Please verify phone number");
            // }
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/updateProfile`, {
                _id: userData['_id'],
                firstName: firstName,
                lastName: lastName,
                ...userData['email'] !== email && {
                    newEmail: email
                },
                phone: normalizedPhone,
                linkedIn: linkedIn,
                designation: designation
            });
            if (!res || res["code"] != 200) return;
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)({
                ...userData,
                firstName: firstName,
                lastName: lastName,
                phone: normalizedPhone,
                linkedIn: linkedIn,
                designation: designation,
                updatedAt: new Date(),
                ...normalizedPhone !== userData['phone'] && {
                    smsEnabled: false,
                    phoneVerified: false
                }
            }));
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while submitting the form');
        } finally{
            setLoading(false);
        }
    };
    const handleVerification = async ()=>{
        try {
            if (!phone || phone == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter a phone number');
            setLoading(true);
            const normalizedPhone = normalizePhone(phone, phoneCountry);
            if (normalizedPhone !== phone) setPhone(normalizedPhone);
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/sendSMS", {
                phone: normalizedPhone
            });
            if (res['code'] == 200) {
                setCounter(60);
                setVerify("Phone");
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: "verify"
                }));
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e["message"]);
        } finally{
            setLoading(false);
        }
    };
    const verifySMSCode = async (e)=>{
        const authKey = e.target.value;
        if (authKey.length < 6) return;
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/enableSMS", {
                authKey: authKey
            });
            if (response.code == 200) {
                dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)({
                    ...userData,
                    smsEnabled: true
                }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ""
                }));
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
        } catch (e) {
            console.log(e, "e");
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e["message"]);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w100 lg-w100 md-px1rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                className: "bg38 p2rem br20px sm1rem",
                style: {
                    borderRadius: '0 0 24px 24px',
                    paddingTop: '0',
                    marginTop: '-33px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c15 fw600 fs1rem",
                        children: "Personal Information"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic w50 mr0-5rem pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $979a146dcf4c238a$export$2e2bcd8739ae039), {
                                        className: "pa c2",
                                        style: {
                                            left: '15px',
                                            marginTop: '0.8rem',
                                            color: `${firstName && firstName.length > 0 ? '#000' : '#505050'}`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: `w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ${firstName && firstName.length > 0 ? 'bo42' : 'bo4'}`,
                                        value: firstName,
                                        onChange: (e)=>setFirstName(e.target.value),
                                        id: "firstName",
                                        placeholder: "First Name",
                                        type: "url"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w50",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    className: `w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl1rem ${lastName && lastName.length > 0 ? 'bo42' : 'bo4'}`,
                                    value: lastName,
                                    onChange: (e)=>setLastName(e.target.value),
                                    id: "lastName",
                                    placeholder: "Last Name",
                                    type: "url"
                                })
                            })
                        ]
                    }),
                    userData?.['companyId']?.['cName'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100 pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e04b2be4f01b0598$export$2e2bcd8739ae039), {
                                className: "pa c2",
                                style: {
                                    left: '15px',
                                    marginTop: '0.8rem',
                                    color: `#505050`
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: `w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem`,
                                value: userData?.['companyId']?.['cName'] ?? "",
                                disabled: true,
                                type: "text",
                                placeholder: "Company Name"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100 pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48243e3ec0f74b4e$export$2e2bcd8739ae039), {
                                className: "pa c2",
                                style: {
                                    left: '15px',
                                    marginTop: '0.8rem',
                                    color: `${email && email.length > 0 ? '#000' : '#505050'}`
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: `w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ${email && email.length > 0 ? 'bo42' : 'bo4'}`,
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                id: "email",
                                type: "url",
                                placeholder: "Email"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                className: "pa c2",
                                style: {
                                    right: '15px',
                                    marginTop: '0.8rem',
                                    display: `${userData?.emailVerified ? 'block' : 'none'}`
                                },
                                width: "31",
                                height: "31",
                                viewBox: "0 0 31 31",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.2143 0C6.84643 0 0 6.84643 0 15.2143C0 23.5821 6.84643 30.4286 15.2143 30.4286C23.5821 30.4286 30.4286 23.5821 30.4286 15.2143C30.4286 6.84643 23.5821 0 15.2143 0ZM21.7564 11.5629L14.7579 20.6914C14.4536 20.9957 13.9971 21.3 13.5407 21.3C13.0843 21.3 12.6279 21.1479 12.3236 20.6914L8.67214 15.975C8.21571 15.3664 8.21571 14.3014 8.97643 13.845C9.73714 13.3886 10.65 13.3886 11.1064 14.1493L13.5407 17.3443L19.3221 9.73714C19.7786 9.12857 20.8436 8.97643 21.4521 9.43286C22.2129 9.88929 22.2129 10.8021 21.7564 11.5629Z",
                                    fill: "#02BC7D"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100 pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fae909b2a8c6cde8$export$2e2bcd8739ae039), {
                                className: `w100 bg1 bs1px brss bo42 mt0-9rem py0-75rem br8px pl1rem c15`,
                                placeholder: "Phone",
                                defaultCountry: phoneCountry,
                                value: phone,
                                onChange: (e)=>setPhone(e || ''),
                                onCountryChange: (c)=>c && setPhoneCountry(c),
                                onBlur: ()=>setPhone((prev)=>normalizePhone(prev, phoneCountry))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(Button, {
                                btnType: "primary",
                                onClick: handleVerification,
                                text: userData?.smsEnabled ? "Verified" : 'Verify',
                                style: {
                                    right: "0",
                                    marginTop: "0.8rem",
                                    borderRadius: "8px",
                                    height: "calc(100% - 0.9rem)"
                                },
                                customClassName: `shadow pa ${userData?.smsEnabled ? "c1 bg3 bg3-hover" : 'c1 bg4 bg4-hover'}`
                            })
                        ]
                    }),
                    !userData['smsEnabled'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        class: "w100 tar fs0-75rem c3 mt0-5rem",
                        children: "Requires a verified phone number"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100 pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                style: {
                                    left: '15px',
                                    position: 'absolute',
                                    marginTop: '0.8rem',
                                    zIndex: 9
                                },
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_5984_38509)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M5 17H1V6H5V17ZM1.66663 16.2904H4.33337V6.70964H1.66663V16.2904Z",
                                                fill: `${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`,
                                                stroke: `${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`,
                                                "stroke-width": "0.5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M17 17H13V10.9677C13 10.3799 12.5522 9.90321 12 9.90321C11.4476 9.90321 11 10.3799 11 10.9677V17H7V6H11V6.71406C11.6038 6.24937 12.33 5.99948 13.075 6C15.2374 6 17 7.86734 17 10.1649V17ZM13.6666 16.2904H16.3333V10.1649C16.3287 8.25341 14.8706 6.70717 13.075 6.70964C12.2542 6.70964 11.4833 7.07778 10.9083 7.74311L10.3333 8.41285V6.70964H7.66663V16.2904H10.3333V10.9677C10.3333 9.98781 11.0795 9.19357 12 9.19357C12.9204 9.19357 13.6666 9.98781 13.6666 10.9677V16.2904Z",
                                                fill: `${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`,
                                                stroke: `${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`,
                                                "stroke-width": "0.5"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M3 5C1.89539 5 1 4.10461 1 3C1 1.89551 1.89539 1 3 1C4.10461 1 5 1.89551 5 3C4.99768 4.10364 4.10364 4.9978 3 5ZM3 1.66675C2.26367 1.66675 1.66663 2.26367 1.66663 3C1.66663 3.73645 2.26367 4.33337 3 4.33337C3.73633 4.33337 4.33337 3.73645 4.33337 3C4.33337 2.26367 3.73633 1.66675 3 1.66675Z",
                                                fill: `${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`,
                                                stroke: `${linkedIn && linkedIn.length > 0 ? "#000" : "#505050"}`,
                                                "stroke-width": "0.5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_5984_38509",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "18",
                                                height: "18",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: `w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ${linkedIn && linkedIn.length > 0 ? 'bo42' : 'bo4'}`,
                                value: linkedIn,
                                onChange: (e)=>setLinkedIn(e.target.value),
                                id: "linkedIn",
                                placeholder: "LinkedIn",
                                type: "url"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100 pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdbaae095ceb82e8$export$2e2bcd8739ae039), {
                                className: "pa c2",
                                style: {
                                    left: '15px',
                                    marginTop: '0.8rem',
                                    color: `${designation && designation.length > 0 ? '#000' : '#505050'}`
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: `w100 bg1 bs1px brss mt0-9rem py0-75rem br8px pl3rem ttc bo42`,
                                value: designation,
                                onChange: (e)=>setDesignation(e.target.value),
                                id: "designation",
                                placeholder: "Title",
                                type: "text"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem w100 tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)(Button, {
                                customClassName: "df aic mla mra",
                                btnType: "warning",
                                text: "Confirm User Details",
                                onClick: onSubmitData
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs12px c4 mt0-5rem",
                                children: [
                                    "Last edited ",
                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(userData?.updatedAt).format('DD MMMM, YYYY')
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg38 p2rem br20px sm1rem mt2rem pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c15 fw600 fs1-5rem tal w100 mb1rem",
                        children: "Change Password"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23a6a3e44d8fe1b7$export$2e2bcd8739ae039), {
                        userData: userData,
                        onSubmitData: onSubmitData
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1275acb5c60c38a5$export$2e2bcd8739ae039), {
                        modalType: "verify",
                        authMethod: verify,
                        codeEntered: verifySMSCode,
                        smsEnabled: smsEnabled,
                        twoFaEnabled: twoFaEnabled,
                        emailEnabled: emailEnabled,
                        resendCode: handleVerification,
                        loading: loading,
                        buttonText: buttonText,
                        isButtonDisabled: isButtonDisabled,
                        counter: counter
                    })
                ]
            })
        ]
    });
});
var $276a43382856225f$export$2e2bcd8739ae039 = $276a43382856225f$var$ProfileForm;



var $ayMG0 = parcelRequire("ayMG0");
const $8ec3d7e6915201e2$export$c760f1fe68383d8d = (advisorData)=>{
    if (advisorData?.profile && advisorData?.linkedIn && advisorData?.firstName && (advisorData?.title || advisorData?.designation) && advisorData?.phone && advisorData?.email && advisorData?.phone !== 'undefined') return true;
    return false;
};



function $8ec3d7e6915201e2$export$2e2bcd8739ae039({ setSelectedData: setSelectedData, selectedData: selectedData, onEditClick: onEditClick, profileClass: profileClass, user: user, company: company }) {
    const truncateString = (str)=>{
        if (str?.length > 0 && str !== undefined && str !== 'undefined') {
            if (str?.length <= 30) return str;
            return str?.slice(0, 30) + '...';
        } else return "N/A";
    };
    const liButtonStyle = {
        borderRadius: "2.5rem",
        padding: "5px 40px",
        color: "#FFFFFF",
        fontSize: "1rem",
        fontWeight: "700",
        lineHeight: "1.594rem"
    };
    const LiButton = ({ link: link })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            class: `${!link && 'bw2px bo4 bss br10px pt0-5rem'}`,
            style: {
                cursor: link ? "pointer" : 'text',
                backgroundColor: 'transparent'
            },
            onClick: ()=>link && window.open(link, '_blank'),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("lvxWB")),
                alt: "Linkedin Logo",
                style: {
                    height: '16px'
                }
            })
        });
    };
    const Placeholder = ({ text: text })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                fontStyle: "italic",
                marginLeft: "5px",
                color: 'gray'
            },
            children: text
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mah90 oya bg1 shadow w100 p1rem bsbb df fdc m1rem maw700px br30px pr pt3rem pb1rem",
        style: {
            border: `4px solid ${$8ec3d7e6915201e2$export$c760f1fe68383d8d(selectedData) ? '#008000' : '#F44336'}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "close-popup",
                onClick: ()=>setSelectedData(''),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    style: {
                        position: "relative",
                        top: "4px"
                    },
                    className: "pen fds h1rem f1 mr0-5rem",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 320 512",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "pen fa-primary",
                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df w100 jcsb aic",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "form-group df jsc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-upload-area pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "img-box pr shadow",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                style: {
                                                    height: "75px",
                                                    width: '75px',
                                                    padding: "0px",
                                                    border: `2px solid ${selectedData["profile"] ? '#008000' : '#F44336'}`
                                                },
                                                src: selectedData["profile"] || (parcelRequire("kBFDN")),
                                                alt: "Profile",
                                                "data-tooltip": selectedData["firstName"] ? selectedData["firstName"] + " " + selectedData["lastName"] : "Register to show your name here",
                                                className: `profile-img w7rem h7rem ${profileClass}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    bottom: "-6px",
                                                    left: "57px"
                                                },
                                                className: `input-file ${!selectedData?.hasEditButton && 'vh'}`,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "add-btn bg5",
                                                    onClick: ()=>onEditClick(selectedData),
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        viewBox: "0 0 487 487",
                                                        className: "zi3",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z              M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9              v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z              M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z              M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df ml1rem fdc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(LiButton, {
                                            link: selectedData["linkedIn"]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mt0-5rem c14 ml0-5rem",
                                        style: {
                                            lineHeight: '18px'
                                        },
                                        children: [
                                            'Need a "no-abligation" chat about your ',
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "requirements? I'd love to chat"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: company?.logo || selectedData?.companyId?.logo ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: company?.logo || selectedData?.companyId?.logo,
                            className: "w4rem cp c1 shadow p0-5rem br50px"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("cfmAr")),
                            className: "w4rem cp c1 shadow p0-5rem br50px",
                            style: {
                                backgroundColor: '#c9e4ff',
                                border: '1px solid #F44336'
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt2rem c2 df jcsb pl0-5rem pr1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pl0-5rem pt1rem pb1rem pr",
                        style: {
                            width: '46%',
                            borderRadius: '15px',
                            border: `2px solid ${selectedData["firstName"] ? '#008000' : '#F44336'}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    top: '20px'
                                },
                                className: "pa ml0-5rem",
                                width: "14",
                                height: "16",
                                viewBox: "0 0 14 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M7 2C5.34314 2 4 3.34315 4 5C4 6.65683 5.34314 8 7 8C8.65683 8 10 6.65683 10 5C10 3.34315 8.65683 2 7 2ZM2.5 5C2.5 2.51472 4.51472 0.5 7 0.5C9.48528 0.5 11.5 2.51472 11.5 5C11.5 7.48528 9.48528 9.5 7 9.5C4.51472 9.5 2.5 7.48528 2.5 5ZM2.35986 11.4624C3.58257 10.6981 5.22507 10.25 7 10.25C8.77495 10.25 10.4174 10.6981 11.6402 11.4624C12.8522 12.22 13.75 13.3626 13.75 14.75C13.75 15.1642 13.4142 15.5 13 15.5C12.5858 15.5 12.25 15.1642 12.25 14.75C12.25 14.0664 11.8046 13.334 10.8452 12.7344C9.89627 12.1414 8.53878 11.75 7 11.75C5.46123 11.75 4.10372 12.1414 3.15485 12.7344C2.19543 13.334 1.75 14.0664 1.75 14.75C1.75 15.1642 1.41421 15.5 1 15.5C0.58579 15.5 0.25 15.1642 0.25 14.75C0.25 13.3626 1.14771 12.22 2.35986 11.4624Z",
                                    fill: "#505050"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ml2rem",
                                children: selectedData?.["firstName"] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        textTransform: "capitalize"
                                    },
                                    children: [
                                        truncateString(`${selectedData?.["firstName"]} ${selectedData?.["lastName"]}`),
                                        " "
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(Placeholder, {
                                    text: "Name"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pl0-5rem pt1rem pb1rem pr",
                        style: {
                            width: '46%',
                            borderRadius: '15px',
                            border: `2px solid ${selectedData?.["designation"] || selectedData?.["title"] || selectedData?.["job"] ? '#008000' : '#F44336'}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                style: {
                                    top: '17px'
                                },
                                className: "pa ml0-5rem",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_1698_387)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M15.0019 17.3994H2.99813C2.20343 17.3979 1.44171 17.0815 0.879773 16.5196C0.317837 15.9577 0.00148681 15.1959 0 14.4013L0 7.20688C-1.39515e-06 6.41121 0.315692 5.64804 0.877788 5.08489C1.43988 4.52174 2.20246 4.20462 2.99813 4.20312H15.0019C15.7975 4.20462 16.5601 4.52174 17.1222 5.08489C17.6843 5.64804 18 6.41121 18 7.20688V14.4013C17.9985 15.1959 17.6822 15.9577 17.1202 16.5196C16.5583 17.0815 15.7966 17.3979 15.0019 17.3994ZM2.99813 5.40687C2.52074 5.40687 2.0629 5.59652 1.72533 5.93408C1.38777 6.27165 1.19813 6.72949 1.19813 7.20688V14.4013C1.19813 14.8786 1.38777 15.3365 1.72533 15.674C2.0629 16.0116 2.52074 16.2013 2.99813 16.2013H15.0019C15.4793 16.2013 15.9371 16.0116 16.2747 15.674C16.6122 15.3365 16.8019 14.8786 16.8019 14.4013V7.20688C16.8019 6.72949 16.6122 6.27165 16.2747 5.93408C15.9371 5.59652 15.4793 5.40687 15.0019 5.40687H2.99813Z",
                                                fill: "#505050"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M11.9994 3.59969C11.9203 3.59969 11.8421 3.58412 11.769 3.55387C11.696 3.52363 11.6297 3.47929 11.5738 3.4234C11.5179 3.36751 11.4736 3.30116 11.4433 3.22814C11.4131 3.15512 11.3975 3.07685 11.3975 2.99781V2.40156C11.3975 2.24291 11.3349 2.09066 11.2232 1.97795C11.1115 1.86524 10.9599 1.80117 10.8013 1.79969H7.20125C7.04162 1.79969 6.88853 1.8631 6.77566 1.97597C6.66279 2.08885 6.59937 2.24194 6.59937 2.40156V2.99781C6.60748 3.08136 6.59802 3.16568 6.5716 3.24535C6.54518 3.32503 6.50239 3.3983 6.44598 3.46045C6.38956 3.5226 6.32077 3.57227 6.24402 3.60626C6.16726 3.64025 6.08425 3.6578 6.00031 3.6578C5.91637 3.6578 5.83336 3.64025 5.75661 3.60626C5.67986 3.57227 5.61106 3.5226 5.55465 3.46045C5.49823 3.3983 5.45544 3.32503 5.42902 3.24535C5.4026 3.16568 5.39314 3.08136 5.40125 2.99781V2.40156C5.40125 1.92417 5.59089 1.46634 5.92846 1.12877C6.26602 0.791205 6.72386 0.601563 7.20125 0.601562H10.8013C11.2786 0.601563 11.7365 0.791205 12.074 1.12877C12.4116 1.46634 12.6012 1.92417 12.6012 2.40156V2.99781C12.6012 3.07685 12.5857 3.15512 12.5554 3.22814C12.5252 3.30116 12.4809 3.36751 12.425 3.4234C12.3691 3.47929 12.3027 3.52363 12.2297 3.55387C12.1567 3.58412 12.0784 3.59969 11.9994 3.59969Z",
                                                fill: "#505050"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M9.00154 11.0587C8.4194 11.0532 7.84475 10.9268 7.31404 10.6875L3.37654 8.94935C3.22736 8.88446 3.11006 8.76296 3.05046 8.61158C2.99086 8.4602 2.99383 8.29135 3.05873 8.14217C3.12362 7.99298 3.24512 7.87569 3.3965 7.81609C3.54788 7.75648 3.71673 7.75946 3.86592 7.82435L7.80341 9.57373C8.18689 9.7438 8.60173 9.83167 9.02123 9.83167C9.44072 9.83167 9.85557 9.7438 10.239 9.57373L14.1765 7.82435C14.2504 7.79222 14.3299 7.77495 14.4104 7.77353C14.491 7.77211 14.571 7.78657 14.646 7.81609C14.7209 7.8456 14.7893 7.88958 14.8473 7.94553C14.9052 8.00148 14.9516 8.0683 14.9837 8.14217C15.0159 8.21603 15.0331 8.29551 15.0345 8.37605C15.036 8.45659 15.0215 8.53663 14.992 8.61158C14.9625 8.68653 14.9185 8.75494 14.8625 8.8129C14.8066 8.87085 14.7398 8.91722 14.6659 8.94935L10.689 10.6875C10.1583 10.9268 9.58368 11.0532 9.00154 11.0587Z",
                                                fill: "#505050"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_1698_387",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "18",
                                                height: "18",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ml2rem",
                                children: selectedData?.["designation"] || selectedData?.["title"] || selectedData?.["job"] ? truncateString(selectedData?.["designation"] || selectedData?.["title"] || selectedData?.["job"]) : /*#__PURE__*/ (0, $ayMG0.jsx)(Placeholder, {
                                    text: "Title"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt2rem c2 df jcsb pl0-5rem pr1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pl0-5rem pt1rem pb1rem pr",
                        style: {
                            width: '46%',
                            borderRadius: '15px',
                            border: `2px solid ${selectedData?.["phone"] && selectedData?.["phone"] !== "+44" && selectedData?.["phone"] !== "undefined" ? '#008000' : '#F44336'}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                style: {
                                    top: '20px'
                                },
                                className: "pa ml0-5rem",
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                        "clip-path": "url(#clip0_1698_380)",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M3.66509 11.9652C5.44048 14.0874 7.57765 15.7584 10.0169 16.9407C10.9457 17.3809 12.1877 17.903 13.5714 17.9925C13.6572 17.9963 13.7393 18 13.8251 18C14.7538 18 15.4997 17.6792 16.1077 17.0191C16.1114 17.0153 16.1189 17.0079 16.1226 17.0004C16.3389 16.7393 16.5851 16.5044 16.8425 16.2545C17.0178 16.0866 17.1968 15.9113 17.3684 15.7323C18.1628 14.9043 18.1628 13.8525 17.3609 13.0506L15.1193 10.809C14.7389 10.4136 14.2838 10.2047 13.8064 10.2047C13.329 10.2047 12.8702 10.4136 12.4786 10.8052L11.1433 12.1405C11.0203 12.0696 10.8934 12.0062 10.7741 11.9465C10.6249 11.8719 10.4869 11.8011 10.3638 11.7228C9.14789 10.9507 8.04387 9.94364 6.98834 8.6494C6.45498 7.97431 6.09692 7.40738 5.84702 6.82926C6.19763 6.51223 6.52585 6.18027 6.84288 5.85578C6.95477 5.74016 7.0704 5.62453 7.18602 5.50891C7.58884 5.10609 7.80517 4.63987 7.80517 4.16618C7.80517 3.6925 7.59257 3.22627 7.18602 2.82346L6.07454 1.71198C5.944 1.58143 5.82092 1.45462 5.6941 1.32408C5.44794 1.07045 5.19058 0.809366 4.93695 0.574389C4.55279 0.197679 4.10148 0 3.62407 0C3.15038 0 2.69535 0.197679 2.29626 0.578119L0.901314 1.97306C0.394062 2.48031 0.106868 3.09573 0.0471908 3.80812C-0.0236753 4.69954 0.140436 5.64691 0.565633 6.79196C1.21835 8.56361 2.20301 10.2085 3.66509 11.9652ZM0.957261 3.88645C1.00202 3.39039 1.19224 2.97638 1.5503 2.61832L2.93778 1.23083C3.15411 1.02196 3.39282 0.9138 3.62407 0.9138C3.85158 0.9138 4.08283 1.02196 4.29543 1.23829C4.54533 1.46954 4.7803 1.71198 5.03393 1.96933C5.16074 2.09988 5.29129 2.23042 5.42183 2.36469L6.53331 3.47617C6.76455 3.70742 6.88391 3.9424 6.88391 4.17364C6.88391 4.40489 6.76455 4.63987 6.53331 4.87111C6.41768 4.98674 6.30206 5.10609 6.18644 5.22172C5.83957 5.57232 5.51507 5.90427 5.15701 6.2213C5.14955 6.22876 5.14582 6.23249 5.13836 6.23995C4.82879 6.54952 4.87728 6.84418 4.95187 7.06797C4.9556 7.07915 4.95933 7.08661 4.96306 7.0978C5.25026 7.78782 5.64935 8.44426 6.27222 9.22752C7.39116 10.6075 8.56978 11.678 9.86775 12.5023C10.0281 12.6067 10.1997 12.6888 10.3601 12.7708C10.5093 12.8454 10.6473 12.9163 10.7704 12.9946C10.7853 13.0021 10.7965 13.0095 10.8114 13.017C10.9345 13.0804 11.0538 13.1102 11.1732 13.1102C11.4716 13.1102 11.6655 12.92 11.7289 12.8566L13.1239 11.4617C13.3402 11.2453 13.5752 11.1297 13.8064 11.1297C14.0899 11.1297 14.3211 11.305 14.4666 11.4617L16.7157 13.707C17.1632 14.1546 17.1595 14.6395 16.7045 15.1131C16.5478 15.281 16.3837 15.4414 16.2084 15.6092C15.9473 15.8628 15.675 16.1239 15.4289 16.4186C14.9999 16.8811 14.489 17.0974 13.8288 17.0974C13.7654 17.0974 13.6982 17.0937 13.6348 17.0899C12.4115 17.0116 11.2739 16.5342 10.4198 16.1276C8.09982 15.005 6.06335 13.4123 4.37375 11.3908C2.98254 9.71612 2.04636 8.15707 1.42722 6.48612C1.04305 5.46042 0.897585 4.63614 0.957261 3.88645Z",
                                            fill: "#505050",
                                            stroke: "#505050",
                                            "stroke-width": "0.5"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_1698_380",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "18",
                                                height: "18",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ml2rem",
                                children: selectedData?.["phone"] !== undefined && selectedData?.["phone"] !== '' && selectedData?.["phone"] !== 'undefined' && selectedData?.["phone"] !== '+44' ? truncateString(selectedData?.["phone"]) : /*#__PURE__*/ (0, $ayMG0.jsx)(Placeholder, {
                                    text: "Tel"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pl0-5rem pt1rem pb1rem pr",
                        style: {
                            width: '46%',
                            borderRadius: '15px',
                            border: `2px solid ${selectedData?.["email"] ? '#008000' : '#F44336'}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    top: '23px'
                                },
                                className: "pa ml0-5rem",
                                width: "16",
                                height: "12",
                                viewBox: "0 0 16 12",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z",
                                    fill: "#505050"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ml2rem",
                                children: selectedData?.["email"] ? truncateString(selectedData?.["email"]) : /*#__PURE__*/ (0, $ayMG0.jsx)(Placeholder, {
                                    text: "Email"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt1rem df jce cp mb1rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    onClick: ()=>onEditClick(selectedData),
                    className: ` bg4 c1 br15px ${!selectedData?.hasEditButton && 'vh'}`,
                    style: {
                        padding: '10px 59px'
                    },
                    children: "Edit"
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $cf7e14040ecbb1be$exports = {};
"use strict";
Object.defineProperty($cf7e14040ecbb1be$exports, "__esModule", {
    value: true
});
$cf7e14040ecbb1be$exports.default = void 0;

var $cf7e14040ecbb1be$var$_react = $cf7e14040ecbb1be$var$_interopRequireWildcard((parcelRequire("acw62")));

var $cf7e14040ecbb1be$var$_propTypes = $cf7e14040ecbb1be$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $cf7e14040ecbb1be$var$_cropperjs = $cf7e14040ecbb1be$var$_interopRequireDefault((parcelRequire("avtRj")));
function $cf7e14040ecbb1be$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cf7e14040ecbb1be$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $cf7e14040ecbb1be$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cf7e14040ecbb1be$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cf7e14040ecbb1be$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cf7e14040ecbb1be$var$_typeof(obj);
}
function $cf7e14040ecbb1be$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf7e14040ecbb1be$var$_extends() {
    $cf7e14040ecbb1be$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf7e14040ecbb1be$var$_extends.apply(this, arguments);
}
function $cf7e14040ecbb1be$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cf7e14040ecbb1be$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cf7e14040ecbb1be$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cf7e14040ecbb1be$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cf7e14040ecbb1be$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cf7e14040ecbb1be$var$_possibleConstructorReturn(self, call) {
    if (call && ($cf7e14040ecbb1be$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cf7e14040ecbb1be$var$_assertThisInitialized(self);
}
function $cf7e14040ecbb1be$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cf7e14040ecbb1be$var$_getPrototypeOf(o) {
    $cf7e14040ecbb1be$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cf7e14040ecbb1be$var$_getPrototypeOf(o);
}
function $cf7e14040ecbb1be$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cf7e14040ecbb1be$var$_setPrototypeOf(subClass, superClass);
}
function $cf7e14040ecbb1be$var$_setPrototypeOf(o, p) {
    $cf7e14040ecbb1be$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cf7e14040ecbb1be$var$_setPrototypeOf(o, p);
}
var $cf7e14040ecbb1be$var$optionProps = [
    'dragMode',
    'aspectRatio',
    'data',
    'crop',
    'viewMode',
    'preview',
    'responsive',
    'restore',
    'checkCrossOrigin',
    'checkOrientation',
    'modal',
    'guides',
    'center',
    'highlight',
    'background',
    'autoCrop',
    'autoCropArea',
    'movable',
    'rotatable',
    'scalable',
    'zoomable',
    'zoomOnTouch',
    'zoomOnWheel',
    'wheelZoomRatio',
    'cropBoxMovable',
    'cropBoxResizable',
    'toggleDragModeOnDblclick',
    'minContainerWidth',
    'minContainerHeight',
    'minCanvasWidth',
    'minCanvasHeight',
    'minCropBoxWidth',
    'minCropBoxHeight',
    'ready',
    'cropstart',
    'cropmove',
    'cropend',
    'zoom'
];
var $cf7e14040ecbb1be$var$unchangeableProps = $cf7e14040ecbb1be$var$optionProps.slice(4);
var $cf7e14040ecbb1be$var$ReactCropper = /*#__PURE__*/ function(_Component) {
    $cf7e14040ecbb1be$var$_inherits(ReactCropper, _Component);
    function ReactCropper() {
        $cf7e14040ecbb1be$var$_classCallCheck(this, ReactCropper);
        return $cf7e14040ecbb1be$var$_possibleConstructorReturn(this, $cf7e14040ecbb1be$var$_getPrototypeOf(ReactCropper).apply(this, arguments));
    }
    $cf7e14040ecbb1be$var$_createClass(ReactCropper, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var options = Object.keys(this.props).filter(function(propKey) {
                    return $cf7e14040ecbb1be$var$optionProps.indexOf(propKey) !== -1;
                }).reduce(function(prevOptions, propKey) {
                    return $cf7e14040ecbb1be$var$_extends({}, prevOptions, $cf7e14040ecbb1be$var$_defineProperty({}, propKey, _this.props[propKey]));
                }, {});
                this.cropper = new $cf7e14040ecbb1be$var$_cropperjs.default(this.img, options);
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this2 = this;
                if (nextProps.src !== this.props.src) this.cropper.reset().clear().replace(nextProps.src);
                if (nextProps.aspectRatio !== this.props.aspectRatio) this.setAspectRatio(nextProps.aspectRatio);
                if (nextProps.data !== this.props.data) this.setData(nextProps.data);
                if (nextProps.dragMode !== this.props.dragMode) this.setDragMode(nextProps.dragMode);
                if (nextProps.cropBoxData !== this.props.cropBoxData) this.setCropBoxData(nextProps.cropBoxData);
                if (nextProps.canvasData !== this.props.canvasData) this.setCanvasData(nextProps.canvasData);
                if (nextProps.moveTo !== this.props.moveTo) {
                    if (nextProps.moveTo.length > 1) this.moveTo(nextProps.moveTo[0], nextProps.moveTo[1]);
                    else this.moveTo(nextProps.moveTo[0]);
                }
                if (nextProps.zoomTo !== this.props.zoomTo) this.zoomTo(nextProps.zoomTo);
                if (nextProps.rotateTo !== this.props.rotateTo) this.rotateTo(nextProps.rotateTo);
                if (nextProps.scaleX !== this.props.scaleX) this.scaleX(nextProps.scaleX);
                if (nextProps.scaleY !== this.props.scaleY) this.scaleY(nextProps.scaleY);
                if (nextProps.enable !== this.props.enable) {
                    if (nextProps.enable) this.enable();
                    else this.disable();
                }
                Object.keys(nextProps).forEach(function(propKey) {
                    var isDifferentVal = nextProps[propKey] !== _this2.props[propKey];
                    var isUnchangeableProps = $cf7e14040ecbb1be$var$unchangeableProps.indexOf(propKey) !== -1;
                    if (typeof nextProps[propKey] === 'function' && typeof _this2.props[propKey] === 'function') isDifferentVal = nextProps[propKey].toString() !== _this2.props[propKey].toString();
                    if (isDifferentVal && isUnchangeableProps) throw new Error("prop: ".concat(propKey, " can't be change after componentDidMount"));
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.img) {
                    // Destroy the cropper, this makes sure events such as resize are cleaned up and do not leak
                    this.cropper.destroy();
                    delete this.img;
                    delete this.cropper;
                }
            }
        },
        {
            key: "setDragMode",
            value: function setDragMode(mode) {
                return this.cropper.setDragMode(mode);
            }
        },
        {
            key: "setAspectRatio",
            value: function setAspectRatio(aspectRatio) {
                return this.cropper.setAspectRatio(aspectRatio);
            }
        },
        {
            key: "getCroppedCanvas",
            value: function getCroppedCanvas(options) {
                return this.cropper.getCroppedCanvas(options);
            }
        },
        {
            key: "setCropBoxData",
            value: function setCropBoxData(data) {
                return this.cropper.setCropBoxData(data);
            }
        },
        {
            key: "getCropBoxData",
            value: function getCropBoxData() {
                return this.cropper.getCropBoxData();
            }
        },
        {
            key: "setCanvasData",
            value: function setCanvasData(data) {
                return this.cropper.setCanvasData(data);
            }
        },
        {
            key: "getCanvasData",
            value: function getCanvasData() {
                return this.cropper.getCanvasData();
            }
        },
        {
            key: "getImageData",
            value: function getImageData() {
                return this.cropper.getImageData();
            }
        },
        {
            key: "getContainerData",
            value: function getContainerData() {
                return this.cropper.getContainerData();
            }
        },
        {
            key: "setData",
            value: function setData(data) {
                return this.cropper.setData(data);
            }
        },
        {
            key: "getData",
            value: function getData(rounded) {
                return this.cropper.getData(rounded);
            }
        },
        {
            key: "crop",
            value: function crop() {
                return this.cropper.crop();
            }
        },
        {
            key: "move",
            value: function move(offsetX, offsetY) {
                return this.cropper.move(offsetX, offsetY);
            }
        },
        {
            key: "moveTo",
            value: function moveTo(x, y) {
                return this.cropper.moveTo(x, y);
            }
        },
        {
            key: "zoom",
            value: function zoom(ratio) {
                return this.cropper.zoom(ratio);
            }
        },
        {
            key: "zoomTo",
            value: function zoomTo(ratio) {
                return this.cropper.zoomTo(ratio);
            }
        },
        {
            key: "rotate",
            value: function rotate(degree) {
                return this.cropper.rotate(degree);
            }
        },
        {
            key: "rotateTo",
            value: function rotateTo(degree) {
                return this.cropper.rotateTo(degree);
            }
        },
        {
            key: "enable",
            value: function enable() {
                return this.cropper.enable();
            }
        },
        {
            key: "disable",
            value: function disable() {
                return this.cropper.disable();
            }
        },
        {
            key: "reset",
            value: function reset() {
                return this.cropper.reset();
            }
        },
        {
            key: "clear",
            value: function clear() {
                return this.cropper.clear();
            }
        },
        {
            key: "replace",
            value: function replace(url, onlyColorChanged) {
                return this.cropper.replace(url, onlyColorChanged);
            }
        },
        {
            key: "scale",
            value: function scale(scaleX, scaleY) {
                return this.cropper.scale(scaleX, scaleY);
            }
        },
        {
            key: "scaleX",
            value: function scaleX(_scaleX) {
                return this.cropper.scaleX(_scaleX);
            }
        },
        {
            key: "scaleY",
            value: function scaleY(_scaleY) {
                return this.cropper.scaleY(_scaleY);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props = this.props, src = _this$props.src, alt = _this$props.alt, crossOrigin = _this$props.crossOrigin, style = _this$props.style, className = _this$props.className;
                return $cf7e14040ecbb1be$var$_react.default.createElement("div", {
                    style: style,
                    className: className
                }, $cf7e14040ecbb1be$var$_react.default.createElement("img", {
                    crossOrigin: crossOrigin,
                    ref: function ref(img) {
                        _this3.img = img;
                    },
                    src: src,
                    alt: alt === undefined ? 'picture' : alt,
                    style: {
                        opacity: 0
                    }
                }));
            }
        }
    ]);
    return ReactCropper;
}($cf7e14040ecbb1be$var$_react.Component);
$cf7e14040ecbb1be$var$ReactCropper.propTypes = {
    style: $cf7e14040ecbb1be$var$_propTypes.default.object,
    // eslint-disable-line react/forbid-prop-types
    className: $cf7e14040ecbb1be$var$_propTypes.default.string,
    // react cropper options
    crossOrigin: $cf7e14040ecbb1be$var$_propTypes.default.string,
    src: $cf7e14040ecbb1be$var$_propTypes.default.string,
    alt: $cf7e14040ecbb1be$var$_propTypes.default.string,
    // props of option can be changed after componentDidmount
    aspectRatio: $cf7e14040ecbb1be$var$_propTypes.default.number,
    dragMode: $cf7e14040ecbb1be$var$_propTypes.default.oneOf([
        'crop',
        'move',
        'none'
    ]),
    data: $cf7e14040ecbb1be$var$_propTypes.default.shape({
        x: $cf7e14040ecbb1be$var$_propTypes.default.number,
        y: $cf7e14040ecbb1be$var$_propTypes.default.number,
        width: $cf7e14040ecbb1be$var$_propTypes.default.number,
        height: $cf7e14040ecbb1be$var$_propTypes.default.number,
        rotate: $cf7e14040ecbb1be$var$_propTypes.default.number,
        scaleX: $cf7e14040ecbb1be$var$_propTypes.default.number,
        scaleY: $cf7e14040ecbb1be$var$_propTypes.default.number
    }),
    scaleX: $cf7e14040ecbb1be$var$_propTypes.default.number,
    scaleY: $cf7e14040ecbb1be$var$_propTypes.default.number,
    enable: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    cropBoxData: $cf7e14040ecbb1be$var$_propTypes.default.shape({
        left: $cf7e14040ecbb1be$var$_propTypes.default.number,
        top: $cf7e14040ecbb1be$var$_propTypes.default.number,
        width: $cf7e14040ecbb1be$var$_propTypes.default.number,
        height: $cf7e14040ecbb1be$var$_propTypes.default.number
    }),
    canvasData: $cf7e14040ecbb1be$var$_propTypes.default.shape({
        left: $cf7e14040ecbb1be$var$_propTypes.default.number,
        top: $cf7e14040ecbb1be$var$_propTypes.default.number,
        width: $cf7e14040ecbb1be$var$_propTypes.default.number,
        height: $cf7e14040ecbb1be$var$_propTypes.default.number
    }),
    zoomTo: $cf7e14040ecbb1be$var$_propTypes.default.number,
    moveTo: $cf7e14040ecbb1be$var$_propTypes.default.arrayOf($cf7e14040ecbb1be$var$_propTypes.default.number),
    rotateTo: $cf7e14040ecbb1be$var$_propTypes.default.number,
    // cropperjs options
    // https://github.com/fengyuanchen/cropperjs#options
    // aspectRatio, dragMode, data
    viewMode: $cf7e14040ecbb1be$var$_propTypes.default.oneOf([
        0,
        1,
        2,
        3
    ]),
    preview: $cf7e14040ecbb1be$var$_propTypes.default.string,
    responsive: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    restore: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    checkCrossOrigin: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    checkOrientation: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    modal: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    guides: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    center: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    highlight: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    background: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    autoCrop: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    autoCropArea: $cf7e14040ecbb1be$var$_propTypes.default.number,
    movable: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    rotatable: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    scalable: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    zoomable: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    zoomOnTouch: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    zoomOnWheel: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    wheelZoomRatio: $cf7e14040ecbb1be$var$_propTypes.default.number,
    cropBoxMovable: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    cropBoxResizable: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    toggleDragModeOnDblclick: $cf7e14040ecbb1be$var$_propTypes.default.bool,
    minContainerWidth: $cf7e14040ecbb1be$var$_propTypes.default.number,
    minContainerHeight: $cf7e14040ecbb1be$var$_propTypes.default.number,
    minCanvasWidth: $cf7e14040ecbb1be$var$_propTypes.default.number,
    minCanvasHeight: $cf7e14040ecbb1be$var$_propTypes.default.number,
    minCropBoxWidth: $cf7e14040ecbb1be$var$_propTypes.default.number,
    minCropBoxHeight: $cf7e14040ecbb1be$var$_propTypes.default.number,
    ready: $cf7e14040ecbb1be$var$_propTypes.default.func,
    cropstart: $cf7e14040ecbb1be$var$_propTypes.default.func,
    cropmove: $cf7e14040ecbb1be$var$_propTypes.default.func,
    cropend: $cf7e14040ecbb1be$var$_propTypes.default.func,
    crop: $cf7e14040ecbb1be$var$_propTypes.default.func,
    zoom: $cf7e14040ecbb1be$var$_propTypes.default.func
};
$cf7e14040ecbb1be$var$ReactCropper.defaultProps = {
    src: null,
    dragMode: 'crop',
    data: null,
    scaleX: 1,
    scaleY: 1,
    enable: true,
    zoomTo: 1,
    rotateTo: 0
};
var $cf7e14040ecbb1be$var$_default = $cf7e14040ecbb1be$var$ReactCropper;
$cf7e14040ecbb1be$exports.default = $cf7e14040ecbb1be$var$_default;









const $fc31dca2d04813a3$var$ProfileImageUploader = ({ profileClass: profileClass, Button: Button })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [userProfile, setUserProfile] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const handleProfile = async (e)=>{
        let profile = e.target.files[0];
        if (!profile) return;
        if (profile && profile.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        profile = await URL.createObjectURL(profile);
        setUserProfile(profile);
    };
    const updateProfile = async ()=>{
        console.log(cropper.current && userProfile, "cropper.current && userProfile");
        let attachment = [];
        if (cropper.current && userProfile) {
            setLoading(true);
            let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile-image.png", {
                type: "image/png"
            });
            attachment.push(coverFile);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/updateProfile`, {
                _id: user['_id'],
                attachment: attachment
            });
            if (response || response["code"] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ""
                }));
                dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)({
                    ...user,
                    profile: imageToUpload
                }));
                setUserProfile("");
            }
            setLoading(false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    const handleClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        setUserProfile("");
        dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "form-group mt0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c15 fs1rem mb1rem",
                        children: "Profile Picture"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-upload-area pr",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-box pr shadow",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: user["profile"] || (parcelRequire("cfmAr")),
                                    alt: "Profile",
                                    className: `profile-img w7rem h7rem ${profileClass}`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "input-file",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "add-btn bg5",
                                        onClick: ()=>{
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: "uploadProfile"
                                            }));
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            viewBox: "0 0 487 487",
                                            className: "zi3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z              M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9              v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z              M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z              M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "uploadProfile",
                onCloseHandler: handleClose,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: `c15 ${userProfile == "" ? "tac" : "tal"} lh1 fw600 mb2rem`,
                        children: " Upload Profile Picture "
                    }),
                    userProfile == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        for: "profile",
                        className: "w60 bsbb bg5 br5px tac bsd bo3 bw2px cp pr db upload-pic-area mxa px1rem py4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: "",
                                onChange: handleProfile,
                                onDrop: handleProfile,
                                id: "profile",
                                type: "file",
                                accept: "image/jpeg, image/jpg, image/png"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic jcc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("doQrw")),
                                        alt: "upLoading"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w60 mxa c15 op60 tac mt1rem",
                                        children: "Upload or drag and drop (max 5MB)"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-box pr maw300px mxa mah300px ",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                            style: {
                                maxHeight: "300px"
                            },
                            ref: cropper,
                            guides: false,
                            aspectRatio: 1,
                            className: "cropper-settings",
                            src: userProfile
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc w100",
                        children: [
                            userProfile !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    className: "c3 bg44 bo3 bss bw1px w20rem mr1rem br50px mt2rem pr cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac",
                                    children: [
                                        "Change Picture",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            className: "op0 w100 h100 pa l0 t0 cp",
                                            onChange: handleProfile,
                                            onDrop: handleProfile,
                                            id: "profile1",
                                            type: "file",
                                            accept: "image/jpeg, image/jpg, image/png"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)(Button, {
                                btnType: "warning",
                                text: "Save",
                                onClick: ()=>{
                                    if (!loading) updateProfile();
                                },
                                loading: loading,
                                customClassName: "mt2rem w20rem"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fc31dca2d04813a3$export$2e2bcd8739ae039 = $fc31dca2d04813a3$var$ProfileImageUploader;



var $ayMG0 = parcelRequire("ayMG0");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $8e2be54d3cb081bc$var$GoogleValidator = ({ modalType: modalType, authMethod: authMethod, twoFaEnabled: twoFaEnabled, codeEntered: codeEntered, loading: loading, qr: qr })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        headerBgIcon: "googleValidatior",
        headerType: "primary",
        heading: `${authMethod} Code`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "c15",
                children: "Authenticator Setup"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "c15 op60",
                children: "Scan the QR code in your authenticator app"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w100 tac",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: qr,
                    alt: "qr",
                    className: "w200px h200px mxa"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "c15 op60 fs12px mb0-5rem fw500",
                children: "Once scanned, enter the 6 digit code generated by the app"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df fdc gg1rem mxa",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "number",
                            placeholder: "Enter 6 Digit Code",
                            className: "bg1 pl4rem w100 bg1 bs1px brss bo42 br8px p1rem",
                            onChange: codeEntered
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                            width: "19",
                            height: "18",
                            viewBox: "0 0 19 18",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                    "clip-path": "url(#clip0_5984_45681)",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M16.8048 7.09079C17.1032 7.09079 17.3894 6.97226 17.6003 6.76128C17.8113 6.55031 17.9298 6.26416 17.9298 5.96579C17.9298 5.66742 17.8113 5.38127 17.6003 5.17029C17.3894 4.95932 17.1032 4.84079 16.8048 4.84079H14.8846L15.3817 2.98598C15.4209 2.84297 15.4315 2.69363 15.4128 2.54653C15.394 2.39944 15.3464 2.25749 15.2727 2.12886C15.1989 2.00024 15.1004 1.88746 14.9829 1.79702C14.8654 1.70658 14.7312 1.64026 14.5879 1.60188C14.4447 1.5635 14.2953 1.55382 14.1483 1.57338C14.0013 1.59294 13.8597 1.64137 13.7315 1.71588C13.6033 1.79039 13.491 1.88951 13.4013 2.00753C13.3115 2.12556 13.246 2.26017 13.2084 2.40362L12.5552 4.84079H8.60324L9.52117 1.41562C9.55996 1.27274 9.57017 1.12361 9.55121 0.976779C9.53225 0.829947 9.4845 0.688301 9.41068 0.559963C9.33687 0.431624 9.23845 0.319117 9.12107 0.228892C9.00369 0.138667 8.86965 0.0724993 8.72664 0.0341816C8.58364 -0.0041362 8.43447 -0.01385 8.2877 0.00559722C8.14093 0.0250444 7.99945 0.07327 7.87136 0.147509C7.74326 0.221748 7.63108 0.320541 7.54125 0.438222C7.45141 0.555904 7.38569 0.69016 7.34785 0.833293L6.27389 4.84079H2.125C1.82663 4.84079 1.54048 4.95932 1.3295 5.17029C1.11853 5.38127 1 5.66742 1 5.96579C1 6.26416 1.11853 6.55031 1.3295 6.76128C1.54048 6.97226 1.82663 7.09079 2.125 7.09079H5.67104L4.6482 10.9081H2.125C1.82663 10.9081 1.54048 11.0267 1.3295 11.2376C1.11853 11.4486 1 11.7348 1 12.0331C1 12.3315 1.11853 12.6176 1.3295 12.8286C1.54048 13.0396 1.82663 13.1581 2.125 13.1581H4.0453L3.5483 15.0129C3.5091 15.1559 3.49855 15.3053 3.51727 15.4524C3.53599 15.5995 3.5836 15.7414 3.65737 15.87C3.73114 15.9987 3.82961 16.1115 3.94712 16.2019C4.06463 16.2923 4.19885 16.3587 4.34208 16.397C4.48531 16.4354 4.63472 16.4451 4.7817 16.4255C4.92869 16.406 5.07035 16.3575 5.19856 16.283C5.32676 16.2085 5.43897 16.1094 5.52873 15.9914C5.61849 15.8734 5.68403 15.7387 5.72159 15.5953L6.37469 13.1581H10.3266L9.40867 16.5833C9.36988 16.7262 9.35967 16.8753 9.37863 17.0221C9.39759 17.169 9.44535 17.3106 9.51916 17.439C9.59297 17.5673 9.69139 17.6798 9.80877 17.77C9.92616 17.8602 10.0602 17.9264 10.2032 17.9647C10.3462 18.0031 10.4954 18.0128 10.6421 17.9933C10.7889 17.9739 10.9304 17.9256 11.0585 17.8514C11.1866 17.7772 11.2988 17.6784 11.3886 17.5607C11.4784 17.443 11.5442 17.3088 11.582 17.1656L12.6558 13.1581H16.8048C17.1032 13.1581 17.3894 13.0396 17.6003 12.8286C17.8113 12.6176 17.9298 12.3315 17.9298 12.0331C17.9298 11.7348 17.8113 11.4486 17.6003 11.2376C17.3894 11.0267 17.1032 10.9081 16.8048 10.9081H13.2588L14.2817 7.09079H16.8048ZM10.9295 10.9081H6.97755L8.00038 7.09079H11.9523L10.9295 10.9081Z",
                                        fill: "#151313"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                        id: "clip0_5984_45681",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                            width: "18",
                                            height: "18",
                                            fill: "white",
                                            transform: "translate(0.84375 -0.000244141)"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc w100",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    btnType: "warning",
                    text: "Activate",
                    onClick: codeEntered,
                    loading: loading,
                    customClassName: "mt2rem w20rem"
                })
            })
        ]
    });
};
var $8e2be54d3cb081bc$export$2e2bcd8739ae039 = $8e2be54d3cb081bc$var$GoogleValidator;



var $acw62 = parcelRequire("acw62");






const $b530b055e6be5c45$var$TwoFactorAuthentication = ({ userData: userData, Button: Button })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { smsEnabled: smsEnabled, twoFaEnabled: twoFaEnabled, emailEnabled: emailEnabled } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.loginType);
    const [focussed, setFocused] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [verify, setVerify] = (0, $acw62.useState)(null);
    const [counter, setCounter] = (0, $acw62.useState)(0);
    const [qr, setQr] = (0, $acw62.useState)(null);
    const [authenticationOptions, setAuthenticationOptions] = (0, $acw62.useState)([
        {
            name: 'SMS',
            action: 'smsEnabled',
            icon: (parcelRequire("hRmh8")),
            selected: false
        },
        {
            name: 'Google',
            action: 'twoFaEnabled',
            icon: (parcelRequire("5hbJu")),
            selected: false
        },
        {
            name: 'Email',
            action: 'emailEnabled',
            icon: (parcelRequire("liVak")),
            selected: false
        }
    ]);
    const buttonText = (0, $acw62.useMemo)(()=>{
        return counter > 0 ? `Resend in ${counter}s` : 'Resend Code';
    }, [
        counter
    ]);
    const isButtonDisabled = (0, $acw62.useMemo)(()=>{
        return counter > 0 || loading;
    }, [
        counter,
        loading
    ]);
    (0, $acw62.useEffect)(()=>{
        let timer;
        if (counter > 0) timer = setTimeout(()=>setCounter(counter - 1), 1000);
        return ()=>clearTimeout(timer);
    }, [
        counter
    ]);
    const handleVerification = async ()=>{
        try {
            if (!userData.phone) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter a phone number');
            setLoading(true);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/sendSMS", {
                phone: userData.phone
            });
            if (!response) return;
            setCounter(60);
            setVerify("Phone");
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "smsEnabled"
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e["message"]);
        } finally{
            setLoading(false);
        }
    };
    const verifySMSCode = async (e)=>{
        const authKey = e.target.value;
        if (authKey.length < 6) return;
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/enableSMS", {
                authKey: authKey
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e["message"]);
        } finally{
            setLoading(false);
        }
    };
    const verifyAuthenticatorCode = async (e)=>{
        const tokenCode = e.target.value;
        if (tokenCode.length < 6) return;
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/verify2Factor", {
            tokenCode: tokenCode
        });
        if (!response) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response["message"]);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (userData) {
            const updatedOptions = authenticationOptions.map((option)=>{
                if (option.name === 'SMS') return {
                    ...option,
                    selected: userData.smsEnabled
                };
                else if (option.name === 'Google') return {
                    ...option,
                    selected: userData.twoFaEnabled
                };
                else if (option.name === 'Email') return {
                    ...option,
                    selected: userData.emailEnabled
                };
                return option;
            });
            setAuthenticationOptions(updatedOptions);
        }
    }, [
        userData
    ]);
    const enableAuthenticator = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)("/user/enable2Factor");
        if (!res || res["code"] != 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
        const { qrData: qrData } = res.body;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "authenticator"
        }));
        setVerify("Qr");
        setQr(qrData);
    };
    const handleAuthenticate = (action)=>{
        setFocused(action);
        if (action === "twoFaEnabled" && !userData["twoFaEnabled"]) enableAuthenticator();
        else if (action === "smsEnabled" && !userData["smsEnabled"]) handleVerification();
    };
    const handleSubmit = async ()=>{};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df jcc aic w100 md-w100 mt2rem two-factor-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg38 px2rem br20px py2rem sm1rem df fdc aic w100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "c15 fw600 fs1-5rem",
                        children: "Multi-factor Authentication"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs14px",
                        children: "Choose alternative authentication methods"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dg gtcr1-sm gtcr3a-md gg1rem mt2rem md-w100",
                        children: authenticationOptions.map((option)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `bg1 px2rem py0-5rem br30px df fdc jcc aic pr cp ${option.action === focussed && 'bs1px brss bo3'}`,
                                style: {
                                    minHeight: '230px'
                                },
                                onClick: ()=>handleAuthenticate(option.action),
                                children: [
                                    option.selected ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pa twofaSelect",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr df aic jcfe",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "bg47 px1rem py0-25rem br20px c1 fs12px",
                                                    children: "Activated"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "pa r0",
                                                    src: (parcelRequire("da8Ul")),
                                                    alt: `green_tick`
                                                })
                                            ]
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: option.icon,
                                        alt: `${option.name}_authIcon`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "tac c15",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fw800 tac",
                                                children: option.name
                                            }),
                                            "Authentication",
                                            option.name === 'SMS' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-5rem db",
                                                children: "Requires a verified phone number"
                                            })
                                        ]
                                    })
                                ]
                            }, option.name);
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Button, {
                            btnType: "warning",
                            text: "Confirm MFA",
                            onClick: handleSubmit,
                            customClassName: "mt2rem w20rem"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1275acb5c60c38a5$export$2e2bcd8739ae039), {
                modalType: "smsEnabled",
                authMethod: verify,
                codeEntered: verifySMSCode,
                smsEnabled: smsEnabled,
                twoFaEnabled: twoFaEnabled,
                emailEnabled: emailEnabled,
                resendCode: handleVerification,
                loading: loading,
                buttonText: buttonText,
                isButtonDisabled: isButtonDisabled,
                counter: counter
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e2be54d3cb081bc$export$2e2bcd8739ae039), {
                modalType: "authenticator",
                authMethod: verify,
                twoFaEnabled: twoFaEnabled,
                codeEntered: verifyAuthenticatorCode,
                loading: loading,
                qr: qr
            })
        ]
    });
};
var $b530b055e6be5c45$export$2e2bcd8739ae039 = $b530b055e6be5c45$var$TwoFactorAuthentication;


const $805db674703862ea$export$5120f2d0b8d4cab8 = ()=>{
    const formRef = (0, $acw62.useRef)();
    const userData = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const company = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [selectedData, setSelectedData] = (0, $acw62.useState)('');
    const [profileClass, setProfileClass] = (0, $acw62.useState)("client-profile");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container py2rem df fdc pr",
                    children: Object.keys(userData).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcsb aifs md-fdc user-profile-sec",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg38 p2rem br20px sm1rem df fdc aic mt2rem jcfs w100 pr",
                                        style: {
                                            borderRadius: '24px 24px 0 0'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "c15 fw600 fs1-5rem",
                                                children: "User Profile"
                                            }),
                                            userData["role"] === "Advisor" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "pa",
                                                style: {
                                                    right: '1rem',
                                                    top: '1rem'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$4202723ba73439f5), {
                                                    onClick: ()=>setSelectedData({
                                                            ...userData
                                                        }),
                                                    color: (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(userData) ? '#008000' : '#F44336'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc31dca2d04813a3$export$2e2bcd8739ae039), {
                                                profileClass: profileClass,
                                                Button: (0, $f26e6702e19c1cff$export$2e2bcd8739ae039)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $276a43382856225f$export$2e2bcd8739ae039), {
                                        Button: (0, $f26e6702e19c1cff$export$2e2bcd8739ae039),
                                        userData: userData,
                                        ref: formRef
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b530b055e6be5c45$export$2e2bcd8739ae039), {
                                        Button: (0, $f26e6702e19c1cff$export$2e2bcd8739ae039),
                                        userData: userData
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: Object.keys(selectedData).length,
                    onClose: ()=>setSelectedData({}),
                    className: "td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ec3d7e6915201e2$export$2e2bcd8739ae039), {
                        user: userData,
                        company: company,
                        selectedData: selectedData,
                        profileClass: profileClass,
                        setSelectedData: setSelectedData
                    })
                })
            ]
        })
    });
};
var $805db674703862ea$export$2e2bcd8739ae039 = $805db674703862ea$export$5120f2d0b8d4cab8;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $26c5d94e8cfa4743$var$V3_URL = 'https://js.stripe.com/v3';
var $26c5d94e8cfa4743$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var $26c5d94e8cfa4743$var$findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat($26c5d94e8cfa4743$var$V3_URL, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$26c5d94e8cfa4743$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $26c5d94e8cfa4743$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat($26c5d94e8cfa4743$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var $26c5d94e8cfa4743$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "1.54.2",
        startTime: startTime
    });
};
var $26c5d94e8cfa4743$var$stripePromise = null;
var $26c5d94e8cfa4743$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($26c5d94e8cfa4743$var$stripePromise !== null) return $26c5d94e8cfa4743$var$stripePromise;
    $26c5d94e8cfa4743$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $26c5d94e8cfa4743$var$findScript();
            if (script && params) console.warn($26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $26c5d94e8cfa4743$var$injectScript(params);
            script.addEventListener('load', function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error('Stripe.js not available'));
            });
            script.addEventListener('error', function() {
                reject(new Error('Failed to load Stripe.js'));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $26c5d94e8cfa4743$var$stripePromise;
};
var $26c5d94e8cfa4743$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $26c5d94e8cfa4743$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $26c5d94e8cfa4743$var$stripePromise$1 = Promise.resolve().then(function() {
    return $26c5d94e8cfa4743$var$loadScript(null);
});
var $26c5d94e8cfa4743$var$loadCalled = false;
$26c5d94e8cfa4743$var$stripePromise$1["catch"](function(err) {
    if (!$26c5d94e8cfa4743$var$loadCalled) console.warn(err);
});
var $26c5d94e8cfa4743$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $26c5d94e8cfa4743$var$loadCalled = true;
    var startTime = Date.now();
    return $26c5d94e8cfa4743$var$stripePromise$1.then(function(maybeStripe) {
        return $26c5d94e8cfa4743$var$initStripe(maybeStripe, args, startTime);
    });
};



var $acw62 = parcelRequire("acw62");

var $7bf3b98cbc00db03$exports = {};

(function(global, factory) {
    factory($7bf3b98cbc00db03$exports, (parcelRequire("acw62")));
})($7bf3b98cbc00db03$exports, function(exports1, React) {
    'use strict';
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "2.8.1"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "2.8.1",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded = [
        "on",
        "session"
    ];
    var CustomCheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutSdkContext.displayName = 'CustomCheckoutSdkContext';
    var parseCustomCheckoutSdkContext = function parseCustomCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CustomCheckoutProvider> provider."));
        return ctx;
    };
    var CustomCheckoutContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutContext.displayName = 'CustomCheckoutContext';
    var extractCustomCheckoutContextValue = function extractCustomCheckoutContextValue(customCheckoutSdk, sessionState) {
        if (!customCheckoutSdk) return null;
        customCheckoutSdk.on;
        customCheckoutSdk.session;
        var actions = _objectWithoutProperties(customCheckoutSdk, _excluded);
        if (!sessionState) return _objectSpread2(_objectSpread2({}, actions), customCheckoutSdk.session());
        return _objectSpread2(_objectSpread2({}, actions), sessionState);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var CustomCheckoutProvider = function CustomCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                customCheckoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, customCheckoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.customCheckoutSdk) return ctx;
                return {
                    stripe: stripe,
                    customCheckoutSdk: customCheckoutSdk
                };
            });
        }; // Ref used to avoid calling initCustomCheckout multiple times when options changes
        var initCustomCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCustomCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCustomCheckoutCalledRef.current = true;
                    stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                        if (customCheckoutSdk) {
                            safeSetContext(stripe, customCheckoutSdk);
                            customCheckoutSdk.on('change', setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === 'sync' && parsed.stripe && !initCustomCheckoutCalledRef.current) {
                initCustomCheckoutCalledRef.current = true;
                parsed.stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                    if (customCheckoutSdk) {
                        safeSetContext(parsed.stripe, customCheckoutSdk);
                        customCheckoutSdk.on('change', setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.customCheckoutSdk) return;
            if (options.clientSecret && !isUnknownObject(prevOptions) && !isEqual(options.clientSecret, prevOptions.clientSecret)) console.warn('Unsupported prop change: options.client_secret is not a mutable property.');
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.customCheckoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.customCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var customCheckoutContextValue = React.useMemo(function() {
            return extractCustomCheckoutContextValue(ctx.customCheckoutSdk, session);
        }, [
            ctx.customCheckoutSdk,
            session
        ]);
        if (!ctx.customCheckoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CustomCheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CustomCheckoutContext.Provider, {
            value: customCheckoutContextValue
        }, children));
    };
    CustomCheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            clientSecret: PropTypes.string.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCustomCheckoutSdkContextWithUseCase = function useCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CustomCheckoutSdkContext);
        return parseCustomCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCustomCheckoutSdkContextWithUseCase = function useElementsOrCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var customCheckoutSdkContext = React.useContext(CustomCheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (customCheckoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CustomCheckoutProvider> and <Elements> providers."));
        if (customCheckoutSdkContext) return parseCustomCheckoutSdkContext(customCheckoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCustomCheckout = function useCustomCheckout() {
        // ensure it's in CustomCheckoutProvider
        useCustomCheckoutSdkContextWithUseCase('calls useCustomCheckout()');
        var ctx = React.useContext(CustomCheckoutContext);
        if (!ctx) throw new Error('Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.');
        return ctx;
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var customCheckoutSdk = 'customCheckoutSdk' in ctx ? ctx.customCheckoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || customCheckoutSdk)) {
                    var newElement = null;
                    if (customCheckoutSdk) newElement = customCheckoutSdk.createElement(type, options);
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                customCheckoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCustomC = useElementsOrCustomCheckoutSdkContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCustomC.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent('fpxBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent('idealBank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent('p24Bank', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent('epsBank', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent('affirmMessage', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent('afterpayClearpayMessage', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.CustomCheckoutProvider = CustomCheckoutProvider;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCustomCheckout = useCustomCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});











function $8434b9dd21e99392$export$2e2bcd8739ae039({ user: user, company: company, showExpension: showExpension }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [pack, setPack] = (0, $acw62.useState)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [stripePromise] = (0, $acw62.useState)((0, $26c5d94e8cfa4743$export$de80f7562c3fd6b1)((0, $6a6b4b5ab5be324d$export$bc0b79747356381c)));
    const [isRemoveCard, setIsRemoveCard] = (0, $acw62.useState)(false);
    const [removeCardDetails, setRemoveCardDetails] = (0, $acw62.useState)({});
    const expensionPacks = {
        DEPF007: {
            price: '0.3',
            no: 'DEPF007',
            type: 'Functional',
            name: 'Directors Questionnaire'
        },
        // DEPF007: { price: '250', no: 'DEPF007', type: 'Functional', name: 'Directors Questionnaire' },
        DEPF006: {
            price: '0.3',
            no: 'DEPF006',
            type: 'Functional',
            name: 'Warranty Disclosure Schedule'
        },
        // DEPF006: { price: '500', no: 'DEPF006', type: 'Functional', name: 'Warranty Disclosure Schedule' },
        DEPN004: {
            price: '0.3',
            no: 'DEPN004',
            type: 'Industrial',
            name: 'Software Development'
        },
        // DEPN004: { price: '0.3', no: 'DEPN004', type: 'Industrial', name: 'Software Development' },
        DEPF005: {
            price: '0.3',
            no: 'DEPF005',
            type: 'Functional',
            name: 'Environmental Social & Governmental (ESG)'
        },
        // DEPF005: { price: '500', no: 'DEPF005', type: 'Functional', name: 'Environmental Social & Governmental (ESG)' },
        DEPF008: {
            price: '0.3',
            no: 'DEPF008',
            type: 'Functional',
            name: 'Investor Lead Introduction'
        }
    };
    (0, $acw62.useEffect)(()=>{
        let expensionPack = expensionPacks[showExpension];
        if (expensionPack) setPack(expensionPack);
    }, [
        showExpension
    ]);
    const Checkout = ()=>{
        const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
        const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
        const handleRemoveCard = async ()=>{
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/payment/removeCard', {
                cardId: removeCardDetails?.['id']
            });
            if (response && response['code'] == 200) {
                let user = response?.['body']?.['user'];
                dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
                setIsRemoveCard(false);
                setRemoveCardDetails({});
            }
        };
        const handleSubmit = async (event)=>{
            try {
                // event.preventDefault();
                const { error: error, paymentMethod: paymentMethod } = await stripe.createPaymentMethod({
                    type: "card",
                    card: elements.getElement((0, $7bf3b98cbc00db03$exports.CardElement))
                });
                if (error) return console.log(error['message']);
                submitPayment(event, paymentMethod['id']);
            // TODO: Tell backend that is been successful
            } catch (e) {
                console.log('*******e = ', e);
            }
        };
        const submitPayment = async (event, paymentId)=>{
            try {
                setLoading(true);
                let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/addExpensionPack/${company._id}`, {
                    methodId: paymentId,
                    expansionName: pack['no']
                });
                if (!response) return;
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                let clientSecret = response['body']?.['clientSecret'];
                console.log("*********Stripe 43 | response!", response);
                if (clientSecret) {
                    let confirmPayment = await stripe?.confirmCardPayment(clientSecret);
                    if (confirmPayment?.error) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(confirmPayment['error']['message']);
                    response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/payment/paymentCompletion/${clientSecret}`);
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Success! Check your email for the invoice.");
                }
                setTimeout(()=>location.href = `/company/${company._id}`, 2500);
            } catch (e) {
                console.log('*******e = ', e);
            }
        };
        // ***************** APPROVED DEVELOPMENT PARTNER - Access Code *****************
        const addExpensionPackWithAccessCode = async ()=>{
            try {
                const accessCode = document.getElementById('access-code')?.['value'];
                if (!accessCode) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide a valid Access Code');
                setLoading(true);
                let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/addExpensionPackWithAccessCode/${company?.['_id']}`, {
                    expansionName: pack['no'],
                    accessCode: accessCode
                });
                if (!response) return;
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                if (response && response['code'] == 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Success! Check your email for the invoice.");
                setTimeout(()=>location.href = `/company/${company._id}`, 2500);
            } catch (e) {
                console.log('*******e = ', e);
            }
        };
        // ===================================================================================
        const CARD_ELEMENT_OPTIONS = {
            style: {
                base: {
                    color: "#32325d",
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "24px",
                    "::placeholder": {
                        color: "#aab7c4"
                    }
                },
                invalid: {
                    color: "#fa755a",
                    iconColor: "#fa755a"
                }
            }
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'payment',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore payment-modal",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "poppins-font-style mah100 bg20 shadow w100 px4rem py3rem df fdc m1rem pr br10px pr",
                                style: {
                                    outline: 'none',
                                    zoom: '0.9',
                                    maxWidth: '1350px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "w100 tac c15 fs1-75rem fw500",
                                        children: "Payment"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                        className: "w100 tac c3 fs1-25rem fw500 mb2rem",
                                        children: "2 Ways to Access This Module"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fww jcc w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "left-area w50 mr3rem bg1 new-shadow br45px",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "header-modal",
                                                        style: {
                                                            backgroundImage: `url(${(parcelRequire("ipdtS"))})`
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "number-header",
                                                            children: "1"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "body-modal pr px3rem py2rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                className: "c15 fs1-25rem fw600",
                                                                children: pack?.['name']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                className: "c15 fs1rem op0.2 mb1rem fw400",
                                                                style: {
                                                                    color: '#15131380'
                                                                },
                                                                children: "Purchase Expansion Plan"
                                                            }),
                                                            user?.['stripeMethods']?.length > 0 && user?.['stripeMethods']?.filter((method)=>!method['isExpired'])?.length > 0 ? user?.['stripeMethods']?.filter((method)=>!method['isExpired'])?.map(({ card: card, id: id })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "bg1 c6 br10px px1rem py0-5rem my0-5rem fw500 cp fs1-25rem bsbb df w50 new-shadow mb2rem",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "px1rem df aic",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        className: "h4rem",
                                                                                        src: (parcelRequire("fumV1")),
                                                                                        alt: card['brand']
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "w100",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df jcsb",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                    children: [
                                                                                                        "**** **** **** ",
                                                                                                        card['last4']
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    style: {
                                                                                                        backgroundColor: 'transparent'
                                                                                                    },
                                                                                                    onClick: ()=>{
                                                                                                        setIsRemoveCard(true), setRemoveCardDetails({
                                                                                                            card: card,
                                                                                                            id: id
                                                                                                        });
                                                                                                    },
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        "data-tooltip": "Remove Card",
                                                                                                        className: "fa fa-trash c9 cp",
                                                                                                        style: {
                                                                                                            fontSize: '20px'
                                                                                                        }
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df fdc",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                    className: "ass",
                                                                                                    children: [
                                                                                                        card['brand']?.toUpperCase(),
                                                                                                        " Card"
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                    className: "ass",
                                                                                                    children: [
                                                                                                        "Expiry: ",
                                                                                                        card['exp_month'],
                                                                                                        "/",
                                                                                                        card['exp_year']
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            disabled: loading,
                                                                            onClick: (event)=>submitPayment(event, id),
                                                                            className: "mt2rem shadow bg4 bg3-hover c1 td250 br35px p1rem fw600 cp ttu w70 bsbb tac df jcc aic mla mra",
                                                                            children: [
                                                                                "Buy \xa3 ",
                                                                                pack?.['price']
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c15 w100 tac mt1rem fs0-75rem",
                                                                            style: {
                                                                                color: '#15131360'
                                                                            },
                                                                            children: "Diligentsia does NOT store your credit card information"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c15 w100 tac mt1rem fs0-75rem",
                                                                            style: {
                                                                                color: '#151313'
                                                                            },
                                                                            children: "Powered by Stripe"
                                                                        })
                                                                    ]
                                                                }, id)) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.CardElement), {
                                                                        options: CARD_ELEMENT_OPTIONS
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                        disabled: !stripe || !elements || loading,
                                                                        onClick: ()=>handleSubmit(),
                                                                        className: "mt2rem shadow bg4 bg3-hover c1 td250 br35px p1rem fw600 cp ttu w70 bsbb tac df jcc aic mla mra",
                                                                        children: [
                                                                            "Buy \xa3 ",
                                                                            pack?.['price']
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 w100 tac mt1rem fs0-75rem",
                                                                        style: {
                                                                            color: '#15131360'
                                                                        },
                                                                        children: "Diligentsia does NOT store your credit card information"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 w100 tac mt1rem fs0-75rem",
                                                                        style: {
                                                                            color: '#151313'
                                                                        },
                                                                        children: "Powered by Stripe"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "right-area w40 ml2rem bg1 new-shadow br45px",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "header-modal",
                                                        style: {
                                                            backgroundImage: `url(${(parcelRequire("O2jJL"))})`
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "number-header",
                                                            children: "2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "body-modal pr px2rem py2rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "heading-area tal",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                        className: "c15 fs1-25rem fw600",
                                                                        children: "Need a discount code? Just ask."
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "c15 fs1rem op0.2 mb1rem fw400",
                                                                        style: {
                                                                            color: '#15131390'
                                                                        },
                                                                        children: "If you have a discount code for any Diligentsia subscription, enter it here"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "access-code",
                                                                placeholder: "Access Code",
                                                                className: "w100 br8px p1rem mt1rem access-code bg1",
                                                                type: "text"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                disabled: !stripe || !elements,
                                                                onClick: ()=>addExpensionPackWithAccessCode(),
                                                                className: "mt2rem shadow bg4 bg3-hover c1 td250 br35px p1rem fw600 cp ttu w70 bsbb tac df jcc aic mla mra",
                                                                children: "Use My Discount Code"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "c15 w100 tac mt1rem fs0-75rem",
                                                                style: {
                                                                    color: '#15131360'
                                                                },
                                                                children: "No credit card required"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                class: "df jcc",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    className: "df cp btn-call-book br35px px2rem py0-5rem tal mt2rem",
                                                                    onClick: ()=>window.open('https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true', '_blank'),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                "Want a discount code? ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                    children: "Book a Call"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "icon mx1rem mt0-5rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                width: "29",
                                                                                height: "29",
                                                                                viewBox: "0 0 29 29",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M26.001 1.60077H23.5012C23.5014 1.37729 23.456 1.15637 23.3681 0.952061C23.2802 0.747981 23.1516 0.564939 22.9908 0.414859C22.83 0.26478 22.6405 0.150934 22.4343 0.0808038C22.2282 0.0106732 22.0102 -0.0141053 21.7941 0.0076352C21.4023 0.0576617 21.0423 0.254961 20.7833 0.561432C20.5243 0.868136 20.3846 1.2625 20.3912 1.66879V2.40072C20.391 2.76774 20.5134 3.12354 20.7379 3.4085C20.9623 3.6937 21.2751 3.89077 21.6238 3.96674C21.7235 3.98614 21.8121 4.04482 21.8702 4.13038C21.9286 4.21617 21.952 4.3216 21.9357 4.42493C21.9193 4.52802 21.8643 4.62036 21.7828 4.68254C21.701 4.74449 21.599 4.77137 21.4984 4.75711C20.9678 4.64958 20.4898 4.35597 20.1459 3.9263C19.8022 3.49663 19.6141 2.95733 19.6137 2.40072V1.60077H15.2827C15.2807 1.38874 15.238 1.17952 15.1569 0.984788C15.0758 0.790059 14.9579 0.613797 14.8103 0.466289C14.6624 0.318781 14.4877 0.203065 14.2962 0.125454C14.1045 0.0480767 13.8998 0.01044 13.694 0.0148816C13.4882 0.019557 13.2854 0.0660766 13.0971 0.15187C12.909 0.237663 12.7391 0.361093 12.5975 0.514913C12.456 0.668732 12.3456 0.849903 12.2727 1.0479C12.1998 1.24614 12.1657 1.457 12.1725 1.66879V2.40072C12.1723 2.76774 12.2948 3.12354 12.5192 3.4085C12.7436 3.6937 13.0564 3.89077 13.4051 3.96674C13.5048 3.98614 13.5934 4.04482 13.6515 4.13038C13.7099 4.21617 13.7333 4.3216 13.717 4.42493C13.7006 4.52802 13.6456 4.62036 13.5641 4.68254C13.4823 4.74449 13.3803 4.77137 13.2797 4.75711C12.7491 4.64958 12.2711 4.35597 11.9274 3.9263C11.5835 3.49663 11.3954 2.95733 11.395 2.40072V1.60077H8.89515C8.27684 1.60194 7.68419 1.85511 7.24692 2.30511C6.80987 2.75488 6.56364 3.36478 6.5625 4.0011V6.22962H28.3337V4.0011C28.3326 3.36478 28.0866 2.75488 27.6493 2.30511C27.212 1.85511 26.6194 1.60194 26.001 1.60077ZM12.9501 1.60077C12.953 1.39038 13.0364 1.19004 13.1818 1.04253C13.3274 0.895021 13.5234 0.812267 13.7276 0.812267C13.9319 0.812267 14.1279 0.895021 14.2733 1.04253C14.4189 1.19004 14.502 1.39061 14.5052 1.60077H12.9501ZM21.1688 1.60077C21.1717 1.39038 21.2549 1.19004 21.4005 1.04253C21.5459 0.895021 21.7419 0.812267 21.9463 0.812267C22.1505 0.812267 22.3466 0.895021 22.492 1.04253C22.6376 1.19004 22.7207 1.39061 22.7237 1.60077H21.1688Z",
                                                                                        fill: "url(#paint0_linear_3405_45)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M6.5625 12.6308C6.67475 12.8524 7.49059 14.1643 7.56027 14.3619C7.80982 14.934 7.84671 15.5782 7.66432 16.1756C7.48194 16.7732 7.09258 17.2837 6.56774 17.6134C6.60485 18.2412 6.87718 18.8308 7.32915 19.2622C7.78113 19.6934 8.37861 19.9336 8.99954 19.9338H25.8969C26.5429 19.9329 27.1622 19.6726 27.619 19.2101C28.0757 18.7476 28.3328 18.1204 28.3337 17.4663V7.47461H6.5625V12.6308ZM23.5899 9.4266C23.7921 9.42937 23.9849 9.51261 24.127 9.65833C24.2689 9.80405 24.3486 10.0005 24.3486 10.2052C24.3486 10.41 24.2689 10.6064 24.1268 10.7521C23.9849 10.8981 23.7918 10.9813 23.5899 10.9841C23.3877 10.9813 23.1946 10.8979 23.0527 10.7521C22.9107 10.6064 22.8312 10.41 22.8312 10.2052C22.8312 10.0005 22.9107 9.80405 23.0527 9.65833C23.1948 9.51261 23.3877 9.42937 23.5899 9.4266ZM23.5899 12.9255C23.7918 12.9285 23.9847 13.0117 24.1266 13.1574C24.2686 13.3032 24.3481 13.4996 24.3481 13.7041C24.3481 13.9089 24.2686 14.1053 24.1266 14.251C23.9847 14.3967 23.7918 14.48 23.5899 14.483C23.3877 14.48 23.1948 14.3967 23.053 14.251C22.9111 14.1053 22.8314 13.9089 22.8314 13.7041C22.8314 13.4996 22.9111 13.3032 23.053 13.1574C23.1948 13.0117 23.3877 12.9285 23.5899 12.9255ZM23.5899 16.4244C23.7921 16.4271 23.9849 16.5104 24.127 16.6561C24.2689 16.8018 24.3486 16.9985 24.3486 17.2032C24.3486 17.4077 24.2689 17.6044 24.1268 17.7501C23.9849 17.8959 23.7918 17.9791 23.5899 17.9819C23.3877 17.9791 23.1946 17.8959 23.0527 17.7501C22.9107 17.6044 22.8312 17.4077 22.8312 17.203C22.8312 16.9985 22.9107 16.8018 23.0527 16.6561C23.1948 16.5104 23.3877 16.4271 23.5899 16.4244ZM17.4482 9.4266C17.6504 9.42937 17.8433 9.51261 17.9854 9.65833C18.1272 9.80405 18.2069 10.0005 18.2069 10.2052C18.2069 10.41 18.1272 10.6064 17.9854 10.7521C17.8433 10.8981 17.6504 10.9813 17.4482 10.9841C17.246 10.9813 17.0532 10.8981 16.9111 10.7521C16.769 10.6064 16.6895 10.41 16.6895 10.2052C16.6895 10.0005 16.769 9.80405 16.9111 9.65833C17.0532 9.51261 17.246 9.42937 17.4482 9.4266ZM17.4482 12.9255C17.6502 12.9285 17.843 13.0117 17.9851 13.1574C18.127 13.3032 18.2064 13.4996 18.2064 13.7041C18.2064 13.9089 18.127 14.1053 17.9851 14.251C17.843 14.3967 17.6502 14.48 17.4482 14.483C17.246 14.48 17.0532 14.3967 16.9113 14.251C16.7695 14.1053 16.6898 13.9089 16.6898 13.7041C16.6898 13.4996 16.7695 13.3032 16.9113 13.1574C17.0532 13.0117 17.246 12.9285 17.4482 12.9255ZM17.4482 16.4244C17.6504 16.4271 17.8433 16.5104 17.9854 16.6561C18.1272 16.8018 18.2069 16.9985 18.2069 17.2032C18.2069 17.4077 18.1272 17.6044 17.9854 17.7501C17.8433 17.8959 17.6504 17.9791 17.4482 17.9819C17.246 17.9791 17.0532 17.8959 16.9111 17.7501C16.769 17.6044 16.6895 17.4077 16.6895 17.203C16.6895 16.9985 16.769 16.8018 16.9111 16.6561C17.0532 16.5104 17.246 16.4271 17.4482 16.4244ZM11.3066 9.4266C11.5076 9.43099 11.6991 9.51491 11.8398 9.6604C11.9805 9.80612 12.0593 10.0016 12.0593 10.2052C12.0593 10.4091 11.9805 10.6046 11.8398 10.7501C11.6991 10.8958 11.5076 10.9797 11.3066 10.9841C11.1055 10.9797 10.914 10.8958 10.7733 10.7501C10.6326 10.6046 10.5538 10.4091 10.5538 10.2052C10.5538 10.0016 10.6326 9.80612 10.7733 9.6604C10.914 9.51491 11.1055 9.43099 11.3066 9.4266ZM11.3066 12.9255C11.5076 12.9299 11.6991 13.0138 11.8401 13.1593C11.9808 13.3048 12.0596 13.5005 12.0596 13.7041C12.0596 13.9079 11.9808 14.1035 11.8398 14.2492C11.6991 14.3947 11.5076 14.4786 11.3066 14.483C11.1053 14.4786 10.914 14.3947 10.7731 14.2492C10.6323 14.1035 10.5536 13.9079 10.5536 13.7041C10.5536 13.5005 10.6323 13.3048 10.7731 13.1593C10.914 13.0138 11.1055 12.9299 11.3066 12.9255ZM11.3066 16.4244C11.5076 16.4287 11.6991 16.5127 11.8401 16.6582C11.9808 16.8036 12.0596 16.9994 12.0596 17.2032C12.0596 17.4068 11.9808 17.6026 11.8398 17.7481C11.6991 17.8935 11.5076 17.9775 11.3066 17.9819C11.1053 17.9775 10.9138 17.8935 10.7731 17.7481C10.6323 17.6026 10.5536 17.4068 10.5536 17.203C10.5536 16.9994 10.6323 16.8036 10.7731 16.6582C10.9138 16.5127 11.1055 16.4287 11.3066 16.4244Z",
                                                                                        fill: "url(#paint1_linear_3405_45)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M16.0676 24.159L14.2179 23.076C14.0129 22.957 13.7823 22.8864 13.5444 22.8693C13.3067 22.8521 13.0679 22.8893 12.8474 22.9775C12.6266 23.066 12.4302 23.203 12.2735 23.3781C12.1169 23.5532 12.0045 23.7613 11.9449 23.9861C11.8808 24.1719 11.7748 24.3415 11.6347 24.4825C11.4943 24.6233 11.3237 24.7318 11.1348 24.8C10.9459 24.8684 10.7434 24.8944 10.5429 24.8768C10.342 24.8592 10.1481 24.798 9.97474 24.6977C8.79798 24.0148 7.71304 23.1916 6.74557 22.2474C5.77741 21.3077 4.93153 20.2559 4.22694 19.1155C4.12252 18.9412 4.06024 18.7461 4.04467 18.5449C4.0291 18.3437 4.06093 18.1416 4.13741 17.9541C4.21389 17.7665 4.33319 17.5983 4.48639 17.4621C4.63935 17.326 4.82231 17.2255 5.02107 17.1683C5.22784 17.1059 5.41836 17.0016 5.58071 16.8626C5.74306 16.7236 5.87336 16.5527 5.96312 16.3611C6.05288 16.1697 6.10006 15.9619 6.10166 15.7513C6.10326 15.541 6.05906 15.3325 5.97205 15.1398C6.01418 15.1567 4.80307 13.2242 4.78086 13.1774C4.57111 12.8408 4.23313 12.5986 3.84064 12.5033C3.44816 12.4081 3.03301 12.4676 2.68541 12.669C1.54711 13.3316 0.712229 14.3925 0.351804 15.6346C-0.00862084 16.8764 0.132662 18.2056 0.746804 19.3494C2.74311 23.0863 5.87381 26.1342 9.71369 28.0788C10.8893 28.6778 12.2559 28.8166 13.5336 28.4669C14.8112 28.1173 15.903 27.3052 16.5851 26.1975C16.7942 25.8604 16.8574 25.4563 16.7603 25.074C16.6632 24.6917 16.4141 24.3626 16.0676 24.159Z",
                                                                                        fill: "url(#paint2_linear_3405_45)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint0_linear_3405_45",
                                                                                                x1: "32.4702",
                                                                                                y1: "-4.43338",
                                                                                                x2: "27.7101",
                                                                                                y2: "14.5338",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#A0B0FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#4A67FF"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint1_linear_3405_45",
                                                                                                x1: "32.4703",
                                                                                                y1: "-1.39237",
                                                                                                x2: "16.3035",
                                                                                                y2: "30.8163",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#A0B0FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#4A67FF"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint2_linear_3405_45",
                                                                                                x1: "17.6373",
                                                                                                y1: "-22.7695",
                                                                                                x2: "-8.63029",
                                                                                                y2: "108.388",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#FFACB0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#FF3F7A"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "c4 fa fa-arrow-right",
                                                                            style: {
                                                                                fontSize: '20px'
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "pa cp",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                style: {
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    bottom: '22px'
                                },
                                width: "60",
                                height: "60",
                                viewBox: "0 0 60 60",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                        opacity: "0.8",
                                        x: "4",
                                        y: "4",
                                        width: "52",
                                        height: "52",
                                        rx: "26",
                                        fill: "#151313"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                        fill: "white"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: isRemoveCard,
                    onClose: ()=>{
                        setIsRemoveCard(false), setRemoveCardDetails({});
                    },
                    className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w60 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                "data-scroll-to": "actions",
                                className: "close-popup",
                                onClick: ()=>{
                                    setIsRemoveCard(false), setRemoveCardDetails({});
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                                children: "Remove Card"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem px2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mb1rem",
                                        children: "Are you sure you want to remove this card?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg5 c6 br10px px1rem py0-5rem fw500 cp fs1-25rem bsbb df asc w50 shadow mb2rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "px1rem df aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "h4rem",
                                                    src: (parcelRequire("fumV1")),
                                                    alt: removeCardDetails?.['card']?.['brand']
                                                })
                                            }),
                                            "**** **** **** ",
                                            removeCardDetails?.['card']?.['last4'],
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            removeCardDetails?.['card']?.['brand']?.toUpperCase(),
                                            " Card",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Expiry: ",
                                            removeCardDetails?.['card']?.['exp_month'],
                                            "/",
                                            removeCardDetails?.['card']?.['exp_year'],
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": "actions",
                                        onClick: ()=>handleRemoveCard(),
                                        className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w60 bsbb tac df jcc asc aic",
                                        children: "Yes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": "actions",
                                        onClick: ()=>{
                                            setIsRemoveCard(false), setRemoveCardDetails({});
                                        },
                                        className: "bg1 c3-hover td250 fs1-25rem cp",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
        stripe: stripePromise,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Checkout, {})
    });
}



















function $57ddb9eef2997aee$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let [company, setCompany] = (0, $acw62.useState)(companies[location.pathname.split("/").slice(-1)[0]] || {});
    (0, $acw62.useEffect)(()=>{
        getCompany();
    }, []);
    const getCompany = async ()=>{
        const companyId = location.pathname.split("/").slice(-1)[0];
        if (companyId) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}`);
            setCompany(res['body']);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "expansionpack-page py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Function Expansion Pack",
                            subheading: "ESG\u200B\u200B"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ma lef-img-area",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("l1H8g")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ma w100 right-text-area",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Any company needing to demonstrate that they  are well-prepared and score highly on an ESG \u200B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "number-sec",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                            className: "bg5 br5px shadow",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Sections: "
                                                        }),
                                                        " 20"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Questions: "
                                                        }),
                                                        " 100"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "AI Generated Company Specific Questions included? "
                                                        }),
                                                        " Yes/No"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Benefit: "
                                                        }),
                                                        " Working though these questions will strengthen the business, identify weaknesses, and giving you an opportunity to plug them prior to being subject to due diligence if you have stressed your ESG credentials "
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "about-img",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-box bg5 br5px shadow",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "\u201CNot having clear ESG credentials is today seen as a weakness.  How can we demonstrate that we are a responsible company in this complex area?\u201D  Graham Jones,, Non-Exec Chair\u200B"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "boost-sec bg-gradient c1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg2rem gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("5g3Sv")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb py4rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "fds c1 fs2rem tac",
                                    children: [
                                        "Highlight your responsible credentials\u2026",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fds ",
                                            children: "more clearly identify your company\u2019s weaknesses\u200B"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic py4rem",
                                children: loggedIn ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: !company?.['expensions']?.['DEPF005'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'payment'
                                            })),
                                        style: {
                                            padding: '15px',
                                            position: 'relative'
                                        },
                                        className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                        children: [
                                            "One off purchase \u2013 BUY NOW!",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "tooltip-btn",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa3 500"
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("LogIn to - BUY NOW!"),
                                    style: {
                                        padding: '15px',
                                        position: 'relative'
                                    },
                                    className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                    children: [
                                        "One off purchase \u2013 BUY NOW!",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tooltip-btn",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\xa3 500"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "benfits-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Benefits"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("5k6Ll")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Enhanced reputation and brand value:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "By completing a comprehensive ESG (Environmental, Social, and Governance) evaluation checklist, a company can showcase its commitment to responsible business practices. This can lead to a stronger reputation and increased brand value, helping the company attract customers, partners, and investors who prioritize sustainability and ethical practices."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("82L9j")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Improved risk management:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "A thorough ESG evaluation can help a company identify and address potential risks related to environmental, social, and governance factors. Proactively managing these risks can reduce the likelihood of regulatory fines, reputational damage, or other negative consequences.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("8F1Ms")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Increased operational efficiency:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Evaluating and optimizing ESG processes and procedures can lead to more efficient use of resources, such as energy and water, and a reduction in waste generation. This can result in cost savings and improved profitability for the company."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("jTIek")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Attractiveness to investors:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Companies that demonstrate strong ESG performance are increasingly attractive to investors who prioritize responsible investment strategies. By completing a 100-question ESG evaluation checklist, a company can signal its commitment to ESG best practices and potentially access a wider pool of investors.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("cRc7X")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Employee engagement and retention:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "A strong ESG focus can help a company attract and retain top talent. Employees who feel that their company is committed to positive environmental, social, and governance practices are more likely to be engaged, motivated, and loyal, leading to a more productive and stable workforce.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("4YzyZ")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Competitive advantage:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Companies that prioritize ESG factors can differentiate themselves from competitors and position themselves as leaders in their industry. By proactively addressing ESG issues and implementing responsible practices, a company can gain a competitive edge in the market and enhance its long-term growth prospects.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modal-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h5rem",
                                src: (parcelRequire("eHMrP")),
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Share Capital and Authority"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Business Plan"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Management Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Properties"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Assets,Debt & Stock"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Employment and Consultancy Arrangements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Records & Registers"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Group Structure"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Borrowings & Facilities"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Information"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Events Since The Accounts Date"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Litigation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Intellectual Property"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Contracts with Connected Persons"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Statutory & Legal Requirements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Insurance"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Agreements & Captial Commitments"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Social Obligations"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8434b9dd21e99392$export$2e2bcd8739ae039), {
                user: user,
                company: company,
                showExpension: 'DEPF005'
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
var $253cfbf17185cb27$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $253cfbf17185cb27$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var //
$253cfbf17185cb27$export$2e2bcd8739ae039 = {
    get: $253cfbf17185cb27$var$get,
    set: $253cfbf17185cb27$var$set,
    takeRight: $253cfbf17185cb27$var$takeRight,
    last: $253cfbf17185cb27$var$last,
    orderBy: $253cfbf17185cb27$var$orderBy,
    range: $253cfbf17185cb27$var$range,
    remove: $253cfbf17185cb27$var$remove,
    clone: $253cfbf17185cb27$var$clone,
    getFirstDefined: $253cfbf17185cb27$var$getFirstDefined,
    sum: $253cfbf17185cb27$var$sum,
    makeTemplateComponent: $253cfbf17185cb27$var$makeTemplateComponent,
    groupBy: $253cfbf17185cb27$var$groupBy,
    isArray: $253cfbf17185cb27$var$isArray,
    splitProps: $253cfbf17185cb27$var$splitProps,
    compactObject: $253cfbf17185cb27$var$compactObject,
    isSortingDesc: $253cfbf17185cb27$var$isSortingDesc,
    normalizeComponent: $253cfbf17185cb27$var$normalizeComponent,
    asPx: $253cfbf17185cb27$var$asPx
};
function $253cfbf17185cb27$var$get(obj, path, def) {
    if (!path) return obj;
    var pathObj = $253cfbf17185cb27$var$makePathArray(path);
    var val = void 0;
    try {
        val = pathObj.reduce(function(current, pathPart) {
            return current[pathPart];
        }, obj);
    } catch (e) {
    // continue regardless of error
    }
    return typeof val !== 'undefined' ? val : def;
}
function $253cfbf17185cb27$var$set() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var path = arguments[1];
    var value = arguments[2];
    var keys = $253cfbf17185cb27$var$makePathArray(path);
    var keyPart = void 0;
    var cursor = obj;
    while((keyPart = keys.shift()) && keys.length){
        if (!cursor[keyPart]) cursor[keyPart] = {};
        cursor = cursor[keyPart];
    }
    cursor[keyPart] = value;
    return obj;
}
function $253cfbf17185cb27$var$takeRight(arr, n) {
    var start = n > arr.length ? 0 : arr.length - n;
    return arr.slice(start);
}
function $253cfbf17185cb27$var$last(arr) {
    return arr[arr.length - 1];
}
function $253cfbf17185cb27$var$range(n) {
    var arr = [];
    for(var i = 0; i < n; i += 1)arr.push(n);
    return arr;
}
function $253cfbf17185cb27$var$orderBy(arr, funcs, dirs, indexKey) {
    return arr.sort(function(rowA, rowB) {
        for(var i = 0; i < funcs.length; i += 1){
            var comp = funcs[i];
            var desc = dirs[i] === false || dirs[i] === 'desc';
            var sortInt = comp(rowA, rowB);
            if (sortInt) return desc ? -sortInt : sortInt;
        }
        // Use the row index for tie breakers
        return dirs[0] ? rowA[indexKey] - rowB[indexKey] : rowB[indexKey] - rowA[indexKey];
    });
}
function $253cfbf17185cb27$var$remove(a, b) {
    return a.filter(function(o, i) {
        var r = b(o);
        if (r) {
            a.splice(i, 1);
            return true;
        }
        return false;
    });
}
function $253cfbf17185cb27$var$clone(a) {
    try {
        return JSON.parse(JSON.stringify(a, function(key, value) {
            if (typeof value === 'function') return value.toString();
            return value;
        }));
    } catch (e) {
        return a;
    }
}
function $253cfbf17185cb27$var$getFirstDefined() {
    for(var i = 0; i < arguments.length; i += 1){
        if (typeof (arguments.length <= i ? undefined : arguments[i]) !== 'undefined') return arguments.length <= i ? undefined : arguments[i];
    }
}
function $253cfbf17185cb27$var$sum(arr) {
    return arr.reduce(function(a, b) {
        return a + b;
    }, 0);
}
function $253cfbf17185cb27$var$makeTemplateComponent(compClass, displayName) {
    if (!displayName) throw new Error('No displayName found for template component:', compClass);
    var cmp = function cmp(_ref) {
        var children = _ref.children, className = _ref.className, rest = $253cfbf17185cb27$var$_objectWithoutProperties(_ref, [
            'children',
            'className'
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $253cfbf17185cb27$var$_extends({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(compClass, className)
        }, rest), children);
    };
    cmp.displayName = displayName;
    return cmp;
}
function $253cfbf17185cb27$var$groupBy(xs, key) {
    return xs.reduce(function(rv, x, i) {
        var resKey = typeof key === 'function' ? key(x, i) : x[key];
        rv[resKey] = $253cfbf17185cb27$var$isArray(rv[resKey]) ? rv[resKey] : [];
        rv[resKey].push(x);
        return rv;
    }, {});
}
function $253cfbf17185cb27$var$asPx(value) {
    value = Number(value);
    return Number.isNaN(value) ? null : value + 'px';
}
function $253cfbf17185cb27$var$isArray(a) {
    return Array.isArray(a);
}
// ########################################################################
// Non-exported Helpers
// ########################################################################
function $253cfbf17185cb27$var$makePathArray(obj) {
    return $253cfbf17185cb27$var$flattenDeep(obj).join('.').replace(/\[/g, '.').replace(/\]/g, '').split('.');
}
function $253cfbf17185cb27$var$flattenDeep(arr) {
    var newArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!$253cfbf17185cb27$var$isArray(arr)) newArr.push(arr);
    else for(var i = 0; i < arr.length; i += 1)$253cfbf17185cb27$var$flattenDeep(arr[i], newArr);
    return newArr;
}
function $253cfbf17185cb27$var$splitProps(_ref2) {
    var className = _ref2.className, style = _ref2.style, rest = $253cfbf17185cb27$var$_objectWithoutProperties(_ref2, [
        'className',
        'style'
    ]);
    return {
        className: className,
        style: style,
        rest: rest || {}
    };
}
function $253cfbf17185cb27$var$compactObject(obj) {
    var newObj = {};
    if (obj) Object.keys(obj).map(function(key) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && typeof obj[key] !== 'undefined') newObj[key] = obj[key];
        return true;
    });
    return newObj;
}
function $253cfbf17185cb27$var$isSortingDesc(d) {
    return !!(d.sort === 'desc' || d.desc === true || d.asc === false);
}
function $253cfbf17185cb27$var$normalizeComponent(Comp, props) {
    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Comp;
    return $253cfbf17185cb27$var$isReactComponent(Comp) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, props) : typeof Comp === 'function' ? Comp(props) : fallback;
}
function $253cfbf17185cb27$var$isClassComponent(component) {
    return typeof component === 'function' && !!Object.getPrototypeOf(component).isReactComponent;
}
function $253cfbf17185cb27$var$isFunctionComponent(component) {
    return typeof component === 'function' && String(component).includes('.createElement');
}
function $253cfbf17185cb27$var$isReactComponent(component) {
    return $253cfbf17185cb27$var$isClassComponent(component) || $253cfbf17185cb27$var$isFunctionComponent(component);
}


var $9810eebc1eba59e2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $9810eebc1eba59e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9810eebc1eba59e2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9810eebc1eba59e2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9810eebc1eba59e2$export$2e2bcd8739ae039 = function(Base) {
    return function(_Base) {
        $9810eebc1eba59e2$var$_inherits(_class, _Base);
        function _class() {
            $9810eebc1eba59e2$var$_classCallCheck(this, _class);
            return $9810eebc1eba59e2$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }
        $9810eebc1eba59e2$var$_createClass(_class, [
            {
                key: 'UNSAFE_componentWillMount',
                value: function UNSAFE_componentWillMount() {
                    this.setStateWithData(this.getDataModel(this.getResolvedState(), true));
                }
            },
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.fireFetchData();
                }
            },
            {
                key: 'UNSAFE_componentWillReceiveProps',
                value: function UNSAFE_componentWillReceiveProps(nextProps, nextState) {
                    var oldState = this.getResolvedState();
                    var newState = this.getResolvedState(nextProps, nextState);
                    // Do a deep compare of new and old `defaultOption` and
                    // if they are different reset `option = defaultOption`
                    var defaultableOptions = [
                        'sorted',
                        'filtered',
                        'resized',
                        'expanded'
                    ];
                    defaultableOptions.forEach(function(x) {
                        var defaultName = 'default' + (x.charAt(0).toUpperCase() + x.slice(1));
                        if (JSON.stringify(oldState[defaultName]) !== JSON.stringify(newState[defaultName])) newState[x] = newState[defaultName];
                    });
                    // If they change these table options, we need to reset defaults
                    // or else we could get into a state where the user has changed the UI
                    // and then disabled the ability to change it back.
                    // e.g. If `filterable` has changed, set `filtered = defaultFiltered`
                    var resettableOptions = [
                        'sortable',
                        'filterable',
                        'resizable'
                    ];
                    resettableOptions.forEach(function(x) {
                        if (oldState[x] !== newState[x]) {
                            var baseName = x.replace('able', '');
                            var optionName = baseName + 'ed';
                            var defaultName = 'default' + (optionName.charAt(0).toUpperCase() + optionName.slice(1));
                            newState[optionName] = newState[defaultName];
                        }
                    });
                    // Props that trigger a data update
                    if (oldState.data !== newState.data || oldState.columns !== newState.columns || oldState.pivotBy !== newState.pivotBy || oldState.sorted !== newState.sorted || oldState.filtered !== newState.filtered) this.setStateWithData(this.getDataModel(newState, oldState.data !== newState.data));
                }
            },
            {
                key: 'setStateWithData',
                value: function setStateWithData(newState, cb) {
                    var _this2 = this;
                    var oldState = this.getResolvedState();
                    var newResolvedState = this.getResolvedState({}, newState);
                    var freezeWhenExpanded = newResolvedState.freezeWhenExpanded;
                    // Default to unfrozen state
                    newResolvedState.frozen = false;
                    // If freezeWhenExpanded is set, check for frozen conditions
                    if (freezeWhenExpanded) {
                        // if any rows are expanded, freeze the existing data and sorting
                        var keys = Object.keys(newResolvedState.expanded);
                        for(var i = 0; i < keys.length; i += 1)if (newResolvedState.expanded[keys[i]]) {
                            newResolvedState.frozen = true;
                            break;
                        }
                    }
                    // If the data isn't frozen and either the data or
                    // sorting model has changed, update the data
                    if (oldState.frozen && !newResolvedState.frozen || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData) {
                        // Handle collapseOnsortedChange & collapseOnDataChange
                        if (oldState.sorted !== newResolvedState.sorted && this.props.collapseOnSortingChange || oldState.filtered !== newResolvedState.filtered || oldState.showFilters !== newResolvedState.showFilters || oldState.sortedData && !newResolvedState.frozen && oldState.resolvedData !== newResolvedState.resolvedData && this.props.collapseOnDataChange) newResolvedState.expanded = {};
                        Object.assign(newResolvedState, this.getSortedData(newResolvedState));
                    }
                    // Set page to 0 if filters change
                    if (oldState.filtered !== newResolvedState.filtered) newResolvedState.page = 0;
                    // Calculate pageSize all the time
                    if (newResolvedState.sortedData) {
                        newResolvedState.pages = newResolvedState.manual ? newResolvedState.pages : Math.ceil(newResolvedState.sortedData.length / newResolvedState.pageSize);
                        newResolvedState.page = newResolvedState.manual ? newResolvedState.page : Math.max(newResolvedState.page >= newResolvedState.pages ? newResolvedState.pages - 1 : newResolvedState.page, 0);
                    }
                    return this.setState(newResolvedState, function() {
                        if (cb) cb();
                        if (oldState.page !== newResolvedState.page || oldState.pageSize !== newResolvedState.pageSize || oldState.sorted !== newResolvedState.sorted || oldState.filtered !== newResolvedState.filtered) _this2.fireFetchData();
                    });
                }
            }
        ]);
        return _class;
    }(Base);
};



var $acw62 = parcelRequire("acw62");

var $e244feba76b06f6b$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $e244feba76b06f6b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e244feba76b06f6b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $e244feba76b06f6b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e244feba76b06f6b$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $e244feba76b06f6b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e244feba76b06f6b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e244feba76b06f6b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e244feba76b06f6b$export$2e2bcd8739ae039 = function(Base) {
    return function(_Base) {
        $e244feba76b06f6b$var$_inherits(_class, _Base);
        function _class() {
            $e244feba76b06f6b$var$_classCallCheck(this, _class);
            return $e244feba76b06f6b$var$_possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }
        $e244feba76b06f6b$var$_createClass(_class, [
            {
                key: 'getResolvedState',
                value: function getResolvedState(props, state) {
                    var resolvedState = $e244feba76b06f6b$var$_extends({}, (0, $253cfbf17185cb27$export$2e2bcd8739ae039).compactObject(this.state), (0, $253cfbf17185cb27$export$2e2bcd8739ae039).compactObject(this.props), (0, $253cfbf17185cb27$export$2e2bcd8739ae039).compactObject(state), (0, $253cfbf17185cb27$export$2e2bcd8739ae039).compactObject(props));
                    return resolvedState;
                }
            },
            {
                key: 'getDataModel',
                value: function getDataModel(newState, dataChanged) {
                    var _this2 = this;
                    var columns = newState.columns, _newState$pivotBy = newState.pivotBy, pivotBy = _newState$pivotBy === undefined ? [] : _newState$pivotBy, data = newState.data, resolveData = newState.resolveData, pivotIDKey = newState.pivotIDKey, pivotValKey = newState.pivotValKey, subRowsKey = newState.subRowsKey, aggregatedKey = newState.aggregatedKey, nestingLevelKey = newState.nestingLevelKey, originalKey = newState.originalKey, indexKey = newState.indexKey, groupedByPivotKey = newState.groupedByPivotKey, SubComponent = newState.SubComponent;
                    // Determine Header Groups
                    var hasHeaderGroups = false;
                    columns.forEach(function(column) {
                        if (column.columns) hasHeaderGroups = true;
                    });
                    var columnsWithExpander = [].concat($e244feba76b06f6b$var$_toConsumableArray(columns));
                    var expanderColumn = columns.find(function(col) {
                        return col.expander || col.columns && col.columns.some(function(col2) {
                            return col2.expander;
                        });
                    });
                    // The actual expander might be in the columns field of a group column
                    if (expanderColumn && !expanderColumn.expander) expanderColumn = expanderColumn.columns.find(function(col) {
                        return col.expander;
                    });
                    // If we have SubComponent's we need to make sure we have an expander column
                    if (SubComponent && !expanderColumn) {
                        expanderColumn = {
                            expander: true
                        };
                        columnsWithExpander = [
                            expanderColumn
                        ].concat($e244feba76b06f6b$var$_toConsumableArray(columnsWithExpander));
                    }
                    var makeDecoratedColumn = function makeDecoratedColumn(column, parentColumn) {
                        var dcol = void 0;
                        if (column.expander) dcol = $e244feba76b06f6b$var$_extends({}, _this2.props.column, _this2.props.expanderDefaults, column);
                        else dcol = $e244feba76b06f6b$var$_extends({}, _this2.props.column, column);
                        // Ensure minWidth is not greater than maxWidth if set
                        if (dcol.maxWidth < dcol.minWidth) dcol.minWidth = dcol.maxWidth;
                        if (parentColumn) dcol.parentColumn = parentColumn;
                        // First check for string accessor
                        if (typeof dcol.accessor === 'string') {
                            dcol.id = dcol.id || dcol.accessor;
                            var accessorString = dcol.accessor;
                            dcol.accessor = function(row) {
                                return (0, $253cfbf17185cb27$export$2e2bcd8739ae039).get(row, accessorString);
                            };
                            return dcol;
                        }
                        // Fall back to functional accessor (but require an ID)
                        if (dcol.accessor && !dcol.id) {
                            console.warn(dcol);
                            throw new Error('A column id is required if using a non-string accessor for column above.');
                        }
                        // Fall back to an undefined accessor
                        if (!dcol.accessor) dcol.accessor = function() {
                            return undefined;
                        };
                        return dcol;
                    };
                    var allDecoratedColumns = [];
                    // Decorate the columns
                    var decorateAndAddToAll = function decorateAndAddToAll(column, parentColumn) {
                        var decoratedColumn = makeDecoratedColumn(column, parentColumn);
                        allDecoratedColumns.push(decoratedColumn);
                        return decoratedColumn;
                    };
                    var decoratedColumns = columnsWithExpander.map(function(column) {
                        if (column.columns) return $e244feba76b06f6b$var$_extends({}, column, {
                            columns: column.columns.map(function(d) {
                                return decorateAndAddToAll(d, column);
                            })
                        });
                        return decorateAndAddToAll(column);
                    });
                    // Build the visible columns, headers and flat column list
                    var visibleColumns = decoratedColumns.slice();
                    var allVisibleColumns = [];
                    visibleColumns = visibleColumns.map(function(column) {
                        if (column.columns) {
                            var visibleSubColumns = column.columns.filter(function(d) {
                                return pivotBy.indexOf(d.id) > -1 ? false : (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(d.show, true);
                            });
                            return $e244feba76b06f6b$var$_extends({}, column, {
                                columns: visibleSubColumns
                            });
                        }
                        return column;
                    });
                    visibleColumns = visibleColumns.filter(function(column) {
                        return column.columns ? column.columns.length : pivotBy.indexOf(column.id) > -1 ? false : (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(column.show, true);
                    });
                    // Find any custom pivot location
                    var pivotIndex = visibleColumns.findIndex(function(col) {
                        return col.pivot;
                    });
                    // Handle Pivot Columns
                    if (pivotBy.length) {
                        // Retrieve the pivot columns in the correct pivot order
                        var pivotColumns = [];
                        pivotBy.forEach(function(pivotID) {
                            var found = allDecoratedColumns.find(function(d) {
                                return d.id === pivotID;
                            });
                            if (found) pivotColumns.push(found);
                        });
                        var PivotParentColumn = pivotColumns.reduce(function(prev, current) {
                            return prev && prev === current.parentColumn && current.parentColumn;
                        }, pivotColumns[0].parentColumn);
                        var PivotGroupHeader = hasHeaderGroups && PivotParentColumn.Header;
                        PivotGroupHeader = PivotGroupHeader || function() {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('strong', null, 'Pivoted');
                        };
                        var pivotColumnGroup = {
                            Header: PivotGroupHeader,
                            columns: pivotColumns.map(function(col) {
                                return $e244feba76b06f6b$var$_extends({}, _this2.props.pivotDefaults, col, {
                                    pivoted: true
                                });
                            })
                        };
                        if (pivotIndex >= 0) {
                            pivotColumnGroup = $e244feba76b06f6b$var$_extends({}, visibleColumns[pivotIndex], pivotColumnGroup);
                            visibleColumns.splice(pivotIndex, 1, pivotColumnGroup);
                        } else visibleColumns.unshift(pivotColumnGroup);
                    }
                    // Build Header Groups
                    var headerGroups = [];
                    var currentSpan = [];
                    // A convenience function to add a header and reset the currentSpan
                    var addHeader = function addHeader(columns, column) {
                        headerGroups.push($e244feba76b06f6b$var$_extends({}, _this2.props.column, column, {
                            columns: columns
                        }));
                        currentSpan = [];
                    };
                    // Build flast list of allVisibleColumns and HeaderGroups
                    visibleColumns.forEach(function(column) {
                        if (column.columns) {
                            allVisibleColumns = allVisibleColumns.concat(column.columns);
                            if (currentSpan.length > 0) addHeader(currentSpan);
                            addHeader(column.columns, column);
                            return;
                        }
                        allVisibleColumns.push(column);
                        currentSpan.push(column);
                    });
                    if (hasHeaderGroups && currentSpan.length > 0) addHeader(currentSpan);
                    // Access the data
                    var accessRow = function accessRow(d, i) {
                        var _row;
                        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        var row = (_row = {}, $e244feba76b06f6b$var$_defineProperty(_row, originalKey, d), $e244feba76b06f6b$var$_defineProperty(_row, indexKey, i), $e244feba76b06f6b$var$_defineProperty(_row, subRowsKey, d[subRowsKey]), $e244feba76b06f6b$var$_defineProperty(_row, nestingLevelKey, level), _row);
                        allDecoratedColumns.forEach(function(column) {
                            if (column.expander) return;
                            row[column.id] = column.accessor(d);
                        });
                        if (row[subRowsKey]) row[subRowsKey] = row[subRowsKey].map(function(d, i) {
                            return accessRow(d, i, level + 1);
                        });
                        return row;
                    };
                    // // If the data hasn't changed, just use the cached data
                    var resolvedData = this.resolvedData;
                    // If the data has changed, run the data resolver and cache the result
                    if (!this.resolvedData || dataChanged) {
                        resolvedData = resolveData(data);
                        this.resolvedData = resolvedData;
                    }
                    // Use the resolved data
                    resolvedData = resolvedData.map(function(d, i) {
                        return accessRow(d, i);
                    });
                    // TODO: Make it possible to fabricate nested rows without pivoting
                    var aggregatingColumns = allVisibleColumns.filter(function(d) {
                        return !d.expander && d.aggregate;
                    });
                    // If pivoting, recursively group the data
                    var aggregate = function aggregate(rows) {
                        var aggregationValues = {};
                        aggregatingColumns.forEach(function(column) {
                            var values = rows.map(function(d) {
                                return d[column.id];
                            });
                            aggregationValues[column.id] = column.aggregate(values, rows);
                        });
                        return aggregationValues;
                    };
                    if (pivotBy.length) {
                        var groupRecursively = function groupRecursively(rows, keys) {
                            var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                            // This is the last level, just return the rows
                            if (i === keys.length) return rows;
                            // Group the rows together for this level
                            var groupedRows = Object.entries((0, $253cfbf17185cb27$export$2e2bcd8739ae039).groupBy(rows, keys[i])).map(function(_ref) {
                                var _ref3;
                                var _ref2 = $e244feba76b06f6b$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                                return _ref3 = {}, $e244feba76b06f6b$var$_defineProperty(_ref3, pivotIDKey, keys[i]), $e244feba76b06f6b$var$_defineProperty(_ref3, pivotValKey, key), $e244feba76b06f6b$var$_defineProperty(_ref3, keys[i], key), $e244feba76b06f6b$var$_defineProperty(_ref3, subRowsKey, value), $e244feba76b06f6b$var$_defineProperty(_ref3, nestingLevelKey, i), $e244feba76b06f6b$var$_defineProperty(_ref3, groupedByPivotKey, true), _ref3;
                            });
                            // Recurse into the subRows
                            groupedRows = groupedRows.map(function(rowGroup) {
                                var _extends2;
                                var subRows = groupRecursively(rowGroup[subRowsKey], keys, i + 1);
                                return $e244feba76b06f6b$var$_extends({}, rowGroup, (_extends2 = {}, $e244feba76b06f6b$var$_defineProperty(_extends2, subRowsKey, subRows), $e244feba76b06f6b$var$_defineProperty(_extends2, aggregatedKey, true), _extends2), aggregate(subRows));
                            });
                            return groupedRows;
                        };
                        resolvedData = groupRecursively(resolvedData, pivotBy);
                    }
                    return $e244feba76b06f6b$var$_extends({}, newState, {
                        resolvedData: resolvedData,
                        allVisibleColumns: allVisibleColumns,
                        headerGroups: headerGroups,
                        allDecoratedColumns: allDecoratedColumns,
                        hasHeaderGroups: hasHeaderGroups
                    });
                }
            },
            {
                key: 'getSortedData',
                value: function getSortedData(resolvedState) {
                    var manual = resolvedState.manual, sorted = resolvedState.sorted, filtered = resolvedState.filtered, defaultFilterMethod = resolvedState.defaultFilterMethod, resolvedData = resolvedState.resolvedData, allDecoratedColumns = resolvedState.allDecoratedColumns;
                    var sortMethodsByColumnID = {};
                    allDecoratedColumns.filter(function(col) {
                        return col.sortMethod;
                    }).forEach(function(col) {
                        sortMethodsByColumnID[col.id] = col.sortMethod;
                    });
                    // Resolve the data from either manual data or sorted data
                    return {
                        sortedData: manual ? resolvedData : this.sortData(this.filterData(resolvedData, filtered, defaultFilterMethod, allDecoratedColumns), sorted, sortMethodsByColumnID)
                    };
                }
            },
            {
                key: 'fireFetchData',
                value: function fireFetchData() {
                    // determine the current state, preferring certain state values over props
                    var currentState = $e244feba76b06f6b$var$_extends({}, this.getResolvedState(), {
                        page: this.getStateOrProp('page'),
                        pageSize: this.getStateOrProp('pageSize'),
                        filtered: this.getStateOrProp('filtered')
                    });
                    this.props.onFetchData(currentState, this);
                }
            },
            {
                key: 'getPropOrState',
                value: function getPropOrState(key) {
                    return (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(this.props[key], this.state[key]);
                }
            },
            {
                key: 'getStateOrProp',
                value: function getStateOrProp(key) {
                    return (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(this.state[key], this.props[key]);
                }
            },
            {
                key: 'filterData',
                value: function filterData(data, filtered, defaultFilterMethod, allVisibleColumns) {
                    var _this3 = this;
                    var filteredData = data;
                    if (filtered.length) {
                        filteredData = filtered.reduce(function(filteredSoFar, nextFilter) {
                            var column = allVisibleColumns.find(function(x) {
                                return x.id === nextFilter.id;
                            });
                            // Don't filter hidden columns or columns that have had their filters disabled
                            if (!column || column.filterable === false) return filteredSoFar;
                            var filterMethod = column.filterMethod || defaultFilterMethod;
                            // If 'filterAll' is set to true, pass the entire dataset to the filter method
                            if (column.filterAll) return filterMethod(nextFilter, filteredSoFar, column);
                            return filteredSoFar.filter(function(row) {
                                return filterMethod(nextFilter, row, column);
                            });
                        }, filteredData);
                        // Apply the filter to the subrows if we are pivoting, and then
                        // filter any rows without subcolumns because it would be strange to show
                        filteredData = filteredData.map(function(row) {
                            if (!row[_this3.props.subRowsKey]) return row;
                            return $e244feba76b06f6b$var$_extends({}, row, $e244feba76b06f6b$var$_defineProperty({}, _this3.props.subRowsKey, _this3.filterData(row[_this3.props.subRowsKey], filtered, defaultFilterMethod, allVisibleColumns)));
                        }).filter(function(row) {
                            if (!row[_this3.props.subRowsKey]) return true;
                            return row[_this3.props.subRowsKey].length > 0;
                        });
                    }
                    return filteredData;
                }
            },
            {
                key: 'sortData',
                value: function sortData(data, sorted) {
                    var _this4 = this;
                    var sortMethodsByColumnID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    if (!sorted.length) return data;
                    var sortedData = (this.props.orderByMethod || (0, $253cfbf17185cb27$export$2e2bcd8739ae039).orderBy)(data, sorted.map(function(sort) {
                        // Support custom sorting methods for each column
                        if (sortMethodsByColumnID[sort.id]) return function(a, b) {
                            return sortMethodsByColumnID[sort.id](a[sort.id], b[sort.id], sort.desc);
                        };
                        return function(a, b) {
                            return _this4.props.defaultSortMethod(a[sort.id], b[sort.id], sort.desc);
                        };
                    }), sorted.map(function(d) {
                        return !d.desc;
                    }), this.props.indexKey);
                    sortedData.forEach(function(row) {
                        if (!row[_this4.props.subRowsKey]) return;
                        row[_this4.props.subRowsKey] = _this4.sortData(row[_this4.props.subRowsKey], sorted, sortMethodsByColumnID);
                    });
                    return sortedData;
                }
            },
            {
                key: 'getMinRows',
                value: function getMinRows() {
                    return (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(this.props.minRows, this.getStateOrProp('pageSize'));
                }
            },
            {
                key: 'onPageChange',
                value: function onPageChange(page) {
                    var _props = this.props, onPageChange = _props.onPageChange, collapseOnPageChange = _props.collapseOnPageChange;
                    var newState = {
                        page: page
                    };
                    if (collapseOnPageChange) newState.expanded = {};
                    this.setStateWithData(newState, function() {
                        return onPageChange && onPageChange(page);
                    });
                }
            },
            {
                key: 'onPageSizeChange',
                value: function onPageSizeChange(newPageSize) {
                    var onPageSizeChange = this.props.onPageSizeChange;
                    var _getResolvedState = this.getResolvedState(), pageSize = _getResolvedState.pageSize, page = _getResolvedState.page;
                    // Normalize the page to display
                    var currentRow = pageSize * page;
                    var newPage = Math.floor(currentRow / newPageSize);
                    this.setStateWithData({
                        pageSize: newPageSize,
                        page: newPage
                    }, function() {
                        return onPageSizeChange && onPageSizeChange(newPageSize, newPage);
                    });
                }
            },
            {
                key: 'sortColumn',
                value: function sortColumn(column, additive) {
                    var _getResolvedState2 = this.getResolvedState(), sorted = _getResolvedState2.sorted, skipNextSort = _getResolvedState2.skipNextSort, defaultSortDesc = _getResolvedState2.defaultSortDesc;
                    var firstSortDirection = Object.prototype.hasOwnProperty.call(column, 'defaultSortDesc') ? column.defaultSortDesc : defaultSortDesc;
                    var secondSortDirection = !firstSortDirection;
                    // we can't stop event propagation from the column resize move handlers
                    // attached to the document because of react's synthetic events
                    // so we have to prevent the sort function from actually sorting
                    // if we click on the column resize element within a header.
                    if (skipNextSort) {
                        this.setStateWithData({
                            skipNextSort: false
                        });
                        return;
                    }
                    var onSortedChange = this.props.onSortedChange;
                    var newSorted = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).clone(sorted || []).map(function(d) {
                        d.desc = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).isSortingDesc(d);
                        return d;
                    });
                    if (!(0, $253cfbf17185cb27$export$2e2bcd8739ae039).isArray(column)) {
                        // Single-Sort
                        var existingIndex = newSorted.findIndex(function(d) {
                            return d.id === column.id;
                        });
                        if (existingIndex > -1) {
                            var existing = newSorted[existingIndex];
                            if (existing.desc === secondSortDirection) {
                                if (additive) newSorted.splice(existingIndex, 1);
                                else {
                                    existing.desc = firstSortDirection;
                                    newSorted = [
                                        existing
                                    ];
                                }
                            } else {
                                existing.desc = secondSortDirection;
                                if (!additive) newSorted = [
                                    existing
                                ];
                            }
                        } else if (additive) newSorted.push({
                            id: column.id,
                            desc: firstSortDirection
                        });
                        else newSorted = [
                            {
                                id: column.id,
                                desc: firstSortDirection
                            }
                        ];
                    } else {
                        // Multi-Sort
                        var _existingIndex = newSorted.findIndex(function(d) {
                            return d.id === column[0].id;
                        });
                        // Existing Sorted Column
                        if (_existingIndex > -1) {
                            var _existing = newSorted[_existingIndex];
                            if (_existing.desc === secondSortDirection) {
                                if (additive) newSorted.splice(_existingIndex, column.length);
                                else column.forEach(function(d, i) {
                                    newSorted[_existingIndex + i].desc = firstSortDirection;
                                });
                            } else column.forEach(function(d, i) {
                                newSorted[_existingIndex + i].desc = secondSortDirection;
                            });
                            if (!additive) newSorted = newSorted.slice(_existingIndex, column.length);
                        // New Sort Column
                        } else if (additive) newSorted = newSorted.concat(column.map(function(d) {
                            return {
                                id: d.id,
                                desc: firstSortDirection
                            };
                        }));
                        else newSorted = column.map(function(d) {
                            return {
                                id: d.id,
                                desc: firstSortDirection
                            };
                        });
                    }
                    this.setStateWithData({
                        page: !sorted.length && newSorted.length || !additive ? 0 : this.state.page,
                        sorted: newSorted
                    }, function() {
                        return onSortedChange && onSortedChange(newSorted, column, additive);
                    });
                }
            },
            {
                key: 'filterColumn',
                value: function filterColumn(column, value) {
                    var _getResolvedState3 = this.getResolvedState(), filtered = _getResolvedState3.filtered;
                    var onFilteredChange = this.props.onFilteredChange;
                    // Remove old filter first if it exists
                    var newFiltering = (filtered || []).filter(function(x) {
                        return x.id !== column.id;
                    });
                    if (value !== '') newFiltering.push({
                        id: column.id,
                        value: value
                    });
                    this.setStateWithData({
                        filtered: newFiltering
                    }, function() {
                        return onFilteredChange && onFilteredChange(newFiltering, column, value);
                    });
                }
            },
            {
                key: 'resizeColumnStart',
                value: function resizeColumnStart(event, column, isTouch) {
                    var _this5 = this;
                    event.stopPropagation();
                    var parentWidth = event.target.parentElement.getBoundingClientRect().width;
                    var pageX = void 0;
                    if (isTouch) pageX = event.changedTouches[0].pageX;
                    else pageX = event.pageX;
                    this.trapEvents = true;
                    this.setStateWithData({
                        currentlyResizing: {
                            id: column.id,
                            startX: pageX,
                            parentWidth: parentWidth
                        }
                    }, function() {
                        if (isTouch) {
                            document.addEventListener('touchmove', _this5.resizeColumnMoving);
                            document.addEventListener('touchcancel', _this5.resizeColumnEnd);
                            document.addEventListener('touchend', _this5.resizeColumnEnd);
                        } else {
                            document.addEventListener('mousemove', _this5.resizeColumnMoving);
                            document.addEventListener('mouseup', _this5.resizeColumnEnd);
                            document.addEventListener('mouseleave', _this5.resizeColumnEnd);
                        }
                    });
                }
            },
            {
                key: 'resizeColumnMoving',
                value: function resizeColumnMoving(event) {
                    event.stopPropagation();
                    var _props2 = this.props, onResizedChange = _props2.onResizedChange, column = _props2.column;
                    var _getResolvedState4 = this.getResolvedState(), resized = _getResolvedState4.resized, currentlyResizing = _getResolvedState4.currentlyResizing, columns = _getResolvedState4.columns;
                    var currentColumn = columns.find(function(c) {
                        return c.accessor === currentlyResizing.id || c.id === currentlyResizing.id;
                    });
                    var minResizeWidth = currentColumn && currentColumn.minResizeWidth != null ? currentColumn.minResizeWidth : column.minResizeWidth;
                    // Delete old value
                    var newResized = resized.filter(function(x) {
                        return x.id !== currentlyResizing.id;
                    });
                    var pageX = void 0;
                    if (event.type === 'touchmove') pageX = event.changedTouches[0].pageX;
                    else if (event.type === 'mousemove') pageX = event.pageX;
                    var newWidth = Math.max(currentlyResizing.parentWidth + pageX - currentlyResizing.startX, minResizeWidth);
                    newResized.push({
                        id: currentlyResizing.id,
                        value: newWidth
                    });
                    this.setStateWithData({
                        resized: newResized
                    }, function() {
                        return onResizedChange && onResizedChange(newResized, event);
                    });
                }
            },
            {
                key: 'resizeColumnEnd',
                value: function resizeColumnEnd(event) {
                    event.stopPropagation();
                    var isTouch = event.type === 'touchend' || event.type === 'touchcancel';
                    if (isTouch) {
                        document.removeEventListener('touchmove', this.resizeColumnMoving);
                        document.removeEventListener('touchcancel', this.resizeColumnEnd);
                        document.removeEventListener('touchend', this.resizeColumnEnd);
                    }
                    // If its a touch event clear the mouse one's as well because sometimes
                    // the mouseDown event gets called as well, but the mouseUp event doesn't
                    document.removeEventListener('mousemove', this.resizeColumnMoving);
                    document.removeEventListener('mouseup', this.resizeColumnEnd);
                    document.removeEventListener('mouseleave', this.resizeColumnEnd);
                    // The touch events don't propagate up to the sorting's onMouseDown event so
                    // no need to prevent it from happening or else the first click after a touch
                    // event resize will not sort the column.
                    if (!isTouch) this.setStateWithData({
                        skipNextSort: true,
                        currentlyResizing: false
                    });
                }
            }
        ]);
        return _class;
    }(Base);
};



var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");


var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
var $e93005e79deca477$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $e93005e79deca477$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e93005e79deca477$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e93005e79deca477$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e93005e79deca477$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e93005e79deca477$var$defaultButton = function defaultButton(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('button', $e93005e79deca477$var$_extends({
        type: 'button'
    }, props, {
        className: '-btn'
    }), props.children);
};
var $e93005e79deca477$var$ReactTablePagination = function(_Component) {
    $e93005e79deca477$var$_inherits(ReactTablePagination, _Component);
    function ReactTablePagination(props) {
        $e93005e79deca477$var$_classCallCheck(this, ReactTablePagination);
        var _this = $e93005e79deca477$var$_possibleConstructorReturn(this, (ReactTablePagination.__proto__ || Object.getPrototypeOf(ReactTablePagination)).call(this, props));
        _this.getSafePage = _this.getSafePage.bind(_this);
        _this.changePage = _this.changePage.bind(_this);
        _this.applyPage = _this.applyPage.bind(_this);
        _this.state = {
            page: props.page
        };
        return _this;
    }
    $e93005e79deca477$var$_createClass(ReactTablePagination, [
        {
            key: 'UNSAFE_componentWillReceiveProps',
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (this.props.page !== nextProps.page) this.setState({
                    page: nextProps.page
                });
            }
        },
        {
            key: 'getSafePage',
            value: function getSafePage(page) {
                if (Number.isNaN(page)) page = this.props.page;
                return Math.min(Math.max(page, 0), this.props.pages - 1);
            }
        },
        {
            key: 'changePage',
            value: function changePage(page) {
                page = this.getSafePage(page);
                this.setState({
                    page: page
                });
                if (this.props.page !== page) this.props.onPageChange(page);
            }
        },
        {
            key: 'applyPage',
            value: function applyPage(e) {
                if (e) e.preventDefault();
                var page = this.state.page;
                this.changePage(page === '' ? this.props.page : page);
            }
        },
        {
            key: 'getPageJumpProperties',
            value: function getPageJumpProperties() {
                var _this2 = this;
                return {
                    onKeyPress: function onKeyPress(e) {
                        if (e.which === 13 || e.keyCode === 13) _this2.applyPage();
                    },
                    onBlur: this.applyPage,
                    value: this.state.page === '' ? '' : this.state.page + 1,
                    onChange: function onChange(e) {
                        var val = e.target.value;
                        var page = val - 1;
                        if (val === '') return _this2.setState({
                            page: val
                        });
                        _this2.setState({
                            page: _this2.getSafePage(page)
                        });
                    },
                    inputType: this.state.page === '' ? 'text' : 'number',
                    pageJumpText: this.props.pageJumpText
                };
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this3 = this;
                var _props = this.props, pages = _props.pages, page = _props.page, showPageSizeOptions = _props.showPageSizeOptions, pageSizeOptions = _props.pageSizeOptions, pageSize = _props.pageSize, showPageJump = _props.showPageJump, canPrevious = _props.canPrevious, canNext = _props.canNext, onPageSizeChange = _props.onPageSizeChange, className = _props.className, PreviousComponent = _props.PreviousComponent, NextComponent = _props.NextComponent, renderPageJump = _props.renderPageJump, renderCurrentPage = _props.renderCurrentPage, renderTotalPagesCount = _props.renderTotalPagesCount, renderPageSizeOptions = _props.renderPageSizeOptions;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, '-pagination'),
                    style: this.props.style
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
                    className: '-previous'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PreviousComponent, {
                    onClick: function onClick() {
                        if (!canPrevious) return;
                        _this3.changePage(page - 1);
                    },
                    disabled: !canPrevious
                }, this.props.previousText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
                    className: '-center'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', {
                    className: '-pageInfo'
                }, this.props.pageText, ' ', showPageJump ? renderPageJump(this.getPageJumpProperties()) : renderCurrentPage(page), ' ', this.props.ofText, ' ', renderTotalPagesCount(pages)), showPageSizeOptions && renderPageSizeOptions({
                    pageSize: pageSize,
                    rowsSelectorText: this.props.rowsSelectorText,
                    pageSizeOptions: pageSizeOptions,
                    onPageSizeChange: onPageSizeChange,
                    rowsText: this.props.rowsText
                })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
                    className: '-next'
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NextComponent, {
                    onClick: function onClick() {
                        if (!canNext) return;
                        _this3.changePage(page + 1);
                    },
                    disabled: !canNext
                }, this.props.nextText)));
            }
        }
    ]);
    return ReactTablePagination;
}((0, $acw62.Component));
$e93005e79deca477$var$ReactTablePagination.defaultProps = {
    PreviousComponent: $e93005e79deca477$var$defaultButton,
    NextComponent: $e93005e79deca477$var$defaultButton,
    renderPageJump: function renderPageJump(_ref) {
        var onChange = _ref.onChange, value = _ref.value, onBlur = _ref.onBlur, onKeyPress = _ref.onKeyPress, inputType = _ref.inputType, pageJumpText = _ref.pageJumpText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
            className: '-pageJump'
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('input', {
            'aria-label': pageJumpText,
            type: inputType,
            onChange: onChange,
            value: value,
            onBlur: onBlur,
            onKeyPress: onKeyPress
        }));
    },
    renderCurrentPage: function renderCurrentPage(page) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', {
            className: '-currentPage'
        }, page + 1);
    },
    renderTotalPagesCount: function renderTotalPagesCount(pages) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', {
            className: '-totalPages'
        }, pages || 1);
    },
    renderPageSizeOptions: function renderPageSizeOptions(_ref2) {
        var pageSize = _ref2.pageSize, pageSizeOptions = _ref2.pageSizeOptions, rowsSelectorText = _ref2.rowsSelectorText, onPageSizeChange = _ref2.onPageSizeChange, rowsText = _ref2.rowsText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', {
            className: 'select-wrap -pageSizeOptions'
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('select', {
            'aria-label': rowsSelectorText,
            onChange: function onChange(e) {
                return onPageSizeChange(Number(e.target.value));
            },
            value: pageSize
        }, pageSizeOptions.map(function(option, i) {
            return(// eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('option', {
                key: i,
                value: option
            }, option + ' ' + rowsText));
        })));
    }
};
var $e93005e79deca477$export$2e2bcd8739ae039 = $e93005e79deca477$var$ReactTablePagination;


var $456b023efd8a4a72$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $456b023efd8a4a72$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $456b023efd8a4a72$var$emptyObj = function emptyObj() {
    return {};
};
var $456b023efd8a4a72$export$2e2bcd8739ae039 = {
    // General
    data: [],
    resolveData: function resolveData(data) {
        return data;
    },
    loading: false,
    showPagination: true,
    showPaginationTop: false,
    showPaginationBottom: true,
    showPageSizeOptions: true,
    pageSizeOptions: [
        5,
        10,
        20,
        25,
        50,
        100
    ],
    defaultPage: 0,
    defaultPageSize: 20,
    showPageJump: true,
    collapseOnSortingChange: true,
    collapseOnPageChange: true,
    collapseOnDataChange: true,
    freezeWhenExpanded: false,
    sortable: true,
    multiSort: true,
    resizable: true,
    filterable: false,
    defaultSortDesc: false,
    defaultSorted: [],
    defaultFiltered: [],
    defaultResized: [],
    defaultExpanded: {},
    // eslint-disable-next-line no-unused-vars
    defaultFilterMethod: function defaultFilterMethod(filter, row, column) {
        var id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).startsWith(filter.value) : true;
    },
    // eslint-disable-next-line no-unused-vars
    defaultSortMethod: function defaultSortMethod(a, b, desc) {
        // force null and undefined to the bottom
        a = a === null || a === undefined ? '' : a;
        b = b === null || b === undefined ? '' : b;
        // force any string values to lowercase
        a = typeof a === 'string' ? a.toLowerCase() : a;
        b = typeof b === 'string' ? b.toLowerCase() : b;
        // Return either 1 or -1 to indicate a sort priority
        if (a > b) return 1;
        if (a < b) return -1;
        // returning 0, undefined or any falsey value will use subsequent sorts or
        // the index as a tiebreaker
        return 0;
    },
    // Controlled State Props
    // page: undefined,
    // pageSize: undefined,
    // sorted: [],
    // filtered: [],
    // resized: [],
    // expanded: {},
    // Controlled State Callbacks
    onPageChange: undefined,
    onPageSizeChange: undefined,
    onSortedChange: undefined,
    onFilteredChange: undefined,
    onResizedChange: undefined,
    onExpandedChange: undefined,
    // Pivoting
    pivotBy: undefined,
    // Key Constants
    pivotValKey: '_pivotVal',
    pivotIDKey: '_pivotID',
    subRowsKey: '_subRows',
    aggregatedKey: '_aggregated',
    nestingLevelKey: '_nestingLevel',
    originalKey: '_original',
    indexKey: '_index',
    groupedByPivotKey: '_groupedByPivot',
    // Server-side Callbacks
    onFetchData: function onFetchData() {
        return null;
    },
    // Classes
    className: '',
    style: {},
    // Component decorators
    getProps: $456b023efd8a4a72$var$emptyObj,
    getTableProps: $456b023efd8a4a72$var$emptyObj,
    getTheadGroupProps: $456b023efd8a4a72$var$emptyObj,
    getTheadGroupTrProps: $456b023efd8a4a72$var$emptyObj,
    getTheadGroupThProps: $456b023efd8a4a72$var$emptyObj,
    getTheadProps: $456b023efd8a4a72$var$emptyObj,
    getTheadTrProps: $456b023efd8a4a72$var$emptyObj,
    getTheadThProps: $456b023efd8a4a72$var$emptyObj,
    getTheadFilterProps: $456b023efd8a4a72$var$emptyObj,
    getTheadFilterTrProps: $456b023efd8a4a72$var$emptyObj,
    getTheadFilterThProps: $456b023efd8a4a72$var$emptyObj,
    getTbodyProps: $456b023efd8a4a72$var$emptyObj,
    getTrGroupProps: $456b023efd8a4a72$var$emptyObj,
    getTrProps: $456b023efd8a4a72$var$emptyObj,
    getTdProps: $456b023efd8a4a72$var$emptyObj,
    getTfootProps: $456b023efd8a4a72$var$emptyObj,
    getTfootTrProps: $456b023efd8a4a72$var$emptyObj,
    getTfootTdProps: $456b023efd8a4a72$var$emptyObj,
    getPaginationProps: $456b023efd8a4a72$var$emptyObj,
    getLoadingProps: $456b023efd8a4a72$var$emptyObj,
    getNoDataProps: $456b023efd8a4a72$var$emptyObj,
    getResizerProps: $456b023efd8a4a72$var$emptyObj,
    // Global Column Defaults
    column: {
        // Renderers
        Cell: undefined,
        Header: undefined,
        Footer: undefined,
        Aggregated: undefined,
        Pivot: undefined,
        PivotValue: undefined,
        Expander: undefined,
        Filter: undefined,
        Placeholder: undefined,
        // All Columns
        sortable: undefined,
        resizable: undefined,
        filterable: undefined,
        show: true,
        minWidth: 100,
        minResizeWidth: 11,
        // Cells only
        className: '',
        style: {},
        getProps: $456b023efd8a4a72$var$emptyObj,
        // Pivot only
        aggregate: undefined,
        // Headers only
        headerClassName: '',
        headerStyle: {},
        getHeaderProps: $456b023efd8a4a72$var$emptyObj,
        // Footers only
        footerClassName: '',
        footerStyle: {},
        getFooterProps: $456b023efd8a4a72$var$emptyObj,
        filterMethod: undefined,
        filterAll: false,
        sortMethod: undefined
    },
    // Global Expander Column Defaults
    expanderDefaults: {
        sortable: false,
        resizable: false,
        filterable: false,
        width: 35
    },
    pivotDefaults: {
    },
    // Text
    previousText: 'Previous',
    nextText: 'Next',
    loadingText: 'Loading...',
    noDataText: 'No rows found',
    pageText: 'Page',
    ofText: 'of',
    rowsText: 'rows',
    pageJumpText: 'jump to page',
    rowsSelectorText: 'rows per page',
    // Components
    TableComponent: function TableComponent(_ref) {
        var children = _ref.children, className = _ref.className, rest = $456b023efd8a4a72$var$_objectWithoutProperties(_ref, [
            'children',
            'className'
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $456b023efd8a4a72$var$_extends({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('rt-table', className),
            role: 'grid'
        }, rest), children);
    },
    TheadComponent: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).makeTemplateComponent('rt-thead', 'Thead'),
    TbodyComponent: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).makeTemplateComponent('rt-tbody', 'Tbody'),
    TrGroupComponent: function TrGroupComponent(_ref2) {
        var children = _ref2.children, className = _ref2.className, rest = $456b023efd8a4a72$var$_objectWithoutProperties(_ref2, [
            'children',
            'className'
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $456b023efd8a4a72$var$_extends({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('rt-tr-group', className),
            role: 'rowgroup'
        }, rest), children);
    },
    TrComponent: function TrComponent(_ref3) {
        var children = _ref3.children, className = _ref3.className, rest = $456b023efd8a4a72$var$_objectWithoutProperties(_ref3, [
            'children',
            'className'
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $456b023efd8a4a72$var$_extends({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('rt-tr', className),
            role: 'row'
        }, rest), children);
    },
    ThComponent: function ThComponent(_ref4) {
        var toggleSort = _ref4.toggleSort, className = _ref4.className, children = _ref4.children, rest = $456b023efd8a4a72$var$_objectWithoutProperties(_ref4, [
            'toggleSort',
            'className',
            'children'
        ]);
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $456b023efd8a4a72$var$_extends({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('rt-th', className),
            onClick: function onClick(e) {
                return toggleSort && toggleSort(e);
            },
            role: 'columnheader',
            tabIndex: '-1' // Resolves eslint issues without implementing keyboard navigation incorrectly
        }, rest), children));
    },
    TdComponent: function TdComponent(_ref5) {
        var toggleSort = _ref5.toggleSort, className = _ref5.className, children = _ref5.children, rest = $456b023efd8a4a72$var$_objectWithoutProperties(_ref5, [
            'toggleSort',
            'className',
            'children'
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $456b023efd8a4a72$var$_extends({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('rt-td', className),
            role: 'gridcell'
        }, rest), children);
    },
    TfootComponent: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).makeTemplateComponent('rt-tfoot', 'Tfoot'),
    FilterComponent: function FilterComponent(_ref6) {
        var filter = _ref6.filter, _onChange = _ref6.onChange, column = _ref6.column;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('input', {
            type: 'text',
            style: {
                width: '100%'
            },
            placeholder: column.Placeholder,
            value: filter ? filter.value : '',
            onChange: function onChange(event) {
                return _onChange(event.target.value);
            }
        });
    },
    ExpanderComponent: function ExpanderComponent(_ref7) {
        var isExpanded = _ref7.isExpanded;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('rt-expander', isExpanded && '-open')
        }, '\u2022');
    },
    PivotValueComponent: function PivotValueComponent(_ref8) {
        var subRows = _ref8.subRows, value = _ref8.value;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', null, value, ' ', subRows && '(' + subRows.length + ')');
    },
    AggregatedComponent: function AggregatedComponent(_ref9) {
        var subRows = _ref9.subRows, column = _ref9.column;
        var previewValues = subRows.filter(function(d) {
            return typeof d[column.id] !== 'undefined';
        }).map(function(row, i) {
            return(// eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', {
                key: i
            }, row[column.id], i < subRows.length - 1 ? ', ' : ''));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', null, previewValues);
    },
    PivotComponent: undefined,
    // the ExpanderComponent and PivotValueComponent at run-time in methods.js
    PaginationComponent: (0, $e93005e79deca477$export$2e2bcd8739ae039),
    PreviousComponent: undefined,
    NextComponent: undefined,
    LoadingComponent: function LoadingComponent(_ref10) {
        var className = _ref10.className, loading = _ref10.loading, loadingText = _ref10.loadingText, rest = $456b023efd8a4a72$var$_objectWithoutProperties(_ref10, [
            'className',
            'loading',
            'loadingText'
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $456b023efd8a4a72$var$_extends({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('-loading', {
                '-active': loading
            }, className)
        }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
            className: '-loading-inner'
        }, loadingText));
    },
    NoDataComponent: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).makeTemplateComponent('rt-noData', 'NoData'),
    ResizerComponent: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).makeTemplateComponent('rt-resizer', 'Resizer'),
    PadRowComponent: function PadRowComponent() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('span', null, '\xA0');
    }
};



var $c9Z8w = parcelRequire("c9Z8w");
var $6677a5f81c7b6899$export$2e2bcd8739ae039 = {
    // General
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showPagination: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showPaginationTop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showPaginationBottom: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showPageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    pageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultPageSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    showPageJump: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    collapseOnSortingChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    collapseOnPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    collapseOnDataChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    freezeWhenExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    sortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    resizable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    filterable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    defaultSortDesc: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    defaultSorted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultFiltered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultResized: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    defaultFilterMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    defaultSortMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    // Controlled State Callbacks
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onPageSizeChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSortedChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFilteredChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onResizedChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onExpandedChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    // Pivoting
    pivotBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    // Key Constants
    pivotValKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    pivotIDKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    subRowsKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    aggregatedKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    nestingLevelKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    originalKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    indexKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    groupedByPivotKey: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    // Server-side Callbacks
    onFetchData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    // Classes
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    // Component decorators
    getProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTableProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadGroupProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadGroupTrProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadGroupThProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadTrProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadThProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadFilterProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadFilterTrProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTheadFilterThProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTbodyProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTrGroupProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTrProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTdProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTfootProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTfootTrProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getTfootTdProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getPaginationProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getLoadingProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getNoDataProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getResizerProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    // Global Column Defaults
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        // Renderers
        Cell: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        Header: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        Footer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        Aggregated: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        Pivot: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        PivotValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        Expander: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        Filter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        ]),
        // All Columns
        sortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        resizable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        filterable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        show: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        minResizeWidth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        // Cells only
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        getProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        // Pivot only
        aggregate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        // Headers only
        headerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        headerStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        getHeaderProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        // Footers only
        footerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        footerStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        getFooterProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        filterMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        filterAll: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        sortMethod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    })),
    // Global Expander Column Defaults
    expanderDefaults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        sortable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        resizable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        filterable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    }),
    pivotDefaults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    // Text
    previousText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    nextText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    loadingText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    noDataText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    pageText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    ofText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    rowsText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    pageJumpText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    rowsSelectorText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    // Components
    TableComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    TheadComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    TbodyComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    TrGroupComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    TrComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    ThComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    TdComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    TfootComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    FilterComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    ExpanderComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    PivotValueComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    AggregatedComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    // this is a computed default generated using
    PivotComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    // the ExpanderComponent and PivotValueComponent at run-time in methods.js
    PaginationComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    PreviousComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    NextComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    LoadingComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    NoDataComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    ResizerComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    PadRowComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType
};


var $04496bc9ad49b9c9$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $04496bc9ad49b9c9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $04496bc9ad49b9c9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $04496bc9ad49b9c9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $04496bc9ad49b9c9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $04496bc9ad49b9c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $04496bc9ad49b9c9$export$a6e7b04760517360 = (0, $456b023efd8a4a72$export$2e2bcd8739ae039);
var $04496bc9ad49b9c9$var$ReactTable = function(_Methods) {
    $04496bc9ad49b9c9$var$_inherits(ReactTable, _Methods);
    function ReactTable(props) {
        $04496bc9ad49b9c9$var$_classCallCheck(this, ReactTable);
        var _this = $04496bc9ad49b9c9$var$_possibleConstructorReturn(this, (ReactTable.__proto__ || Object.getPrototypeOf(ReactTable)).call(this));
        _this.getResolvedState = _this.getResolvedState.bind(_this);
        _this.getDataModel = _this.getDataModel.bind(_this);
        _this.getSortedData = _this.getSortedData.bind(_this);
        _this.fireFetchData = _this.fireFetchData.bind(_this);
        _this.getPropOrState = _this.getPropOrState.bind(_this);
        _this.getStateOrProp = _this.getStateOrProp.bind(_this);
        _this.filterData = _this.filterData.bind(_this);
        _this.sortData = _this.sortData.bind(_this);
        _this.getMinRows = _this.getMinRows.bind(_this);
        _this.onPageChange = _this.onPageChange.bind(_this);
        _this.onPageSizeChange = _this.onPageSizeChange.bind(_this);
        _this.sortColumn = _this.sortColumn.bind(_this);
        _this.filterColumn = _this.filterColumn.bind(_this);
        _this.resizeColumnStart = _this.resizeColumnStart.bind(_this);
        _this.resizeColumnEnd = _this.resizeColumnEnd.bind(_this);
        _this.resizeColumnMoving = _this.resizeColumnMoving.bind(_this);
        _this.state = {
            page: props.defaultPage,
            pageSize: props.defaultPageSize,
            sorted: props.defaultSorted,
            expanded: props.defaultExpanded,
            filtered: props.defaultFiltered,
            resized: props.defaultResized,
            currentlyResizing: false,
            skipNextSort: false
        };
        return _this;
    }
    $04496bc9ad49b9c9$var$_createClass(ReactTable, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var resolvedState = this.getResolvedState();
                var children = resolvedState.children, className = resolvedState.className, style = resolvedState.style, getProps = resolvedState.getProps, getTableProps = resolvedState.getTableProps, getTheadGroupProps = resolvedState.getTheadGroupProps, getTheadGroupTrProps = resolvedState.getTheadGroupTrProps, getTheadGroupThProps = resolvedState.getTheadGroupThProps, getTheadProps = resolvedState.getTheadProps, getTheadTrProps = resolvedState.getTheadTrProps, getTheadThProps = resolvedState.getTheadThProps, getTheadFilterProps = resolvedState.getTheadFilterProps, getTheadFilterTrProps = resolvedState.getTheadFilterTrProps, getTheadFilterThProps = resolvedState.getTheadFilterThProps, getTbodyProps = resolvedState.getTbodyProps, getTrGroupProps = resolvedState.getTrGroupProps, getTrProps = resolvedState.getTrProps, getTdProps = resolvedState.getTdProps, getTfootProps = resolvedState.getTfootProps, getTfootTrProps = resolvedState.getTfootTrProps, getTfootTdProps = resolvedState.getTfootTdProps, getPaginationProps = resolvedState.getPaginationProps, getLoadingProps = resolvedState.getLoadingProps, getNoDataProps = resolvedState.getNoDataProps, getResizerProps = resolvedState.getResizerProps, showPagination = resolvedState.showPagination, showPaginationTop = resolvedState.showPaginationTop, showPaginationBottom = resolvedState.showPaginationBottom, manual = resolvedState.manual, loadingText = resolvedState.loadingText, noDataText = resolvedState.noDataText, sortable = resolvedState.sortable, multiSort = resolvedState.multiSort, resizable = resolvedState.resizable, filterable = resolvedState.filterable, pivotIDKey = resolvedState.pivotIDKey, pivotValKey = resolvedState.pivotValKey, pivotBy = resolvedState.pivotBy, subRowsKey = resolvedState.subRowsKey, aggregatedKey = resolvedState.aggregatedKey, originalKey = resolvedState.originalKey, indexKey = resolvedState.indexKey, groupedByPivotKey = resolvedState.groupedByPivotKey, loading = resolvedState.loading, pageSize = resolvedState.pageSize, page = resolvedState.page, sorted = resolvedState.sorted, filtered = resolvedState.filtered, resized = resolvedState.resized, expanded = resolvedState.expanded, pages = resolvedState.pages, onExpandedChange = resolvedState.onExpandedChange, TableComponent = resolvedState.TableComponent, TheadComponent = resolvedState.TheadComponent, TbodyComponent = resolvedState.TbodyComponent, TrGroupComponent = resolvedState.TrGroupComponent, TrComponent = resolvedState.TrComponent, ThComponent = resolvedState.ThComponent, TdComponent = resolvedState.TdComponent, TfootComponent = resolvedState.TfootComponent, PaginationComponent = resolvedState.PaginationComponent, LoadingComponent = resolvedState.LoadingComponent, SubComponent = resolvedState.SubComponent, NoDataComponent = resolvedState.NoDataComponent, ResizerComponent = resolvedState.ResizerComponent, ExpanderComponent = resolvedState.ExpanderComponent, PivotValueComponent = resolvedState.PivotValueComponent, PivotComponent = resolvedState.PivotComponent, AggregatedComponent = resolvedState.AggregatedComponent, FilterComponent = resolvedState.FilterComponent, PadRowComponent = resolvedState.PadRowComponent, resolvedData = resolvedState.resolvedData, allVisibleColumns = resolvedState.allVisibleColumns, headerGroups = resolvedState.headerGroups, hasHeaderGroups = resolvedState.hasHeaderGroups, sortedData = resolvedState.sortedData, currentlyResizing = resolvedState.currentlyResizing;
                // Pagination
                var startRow = pageSize * page;
                var endRow = startRow + pageSize;
                var pageRows = manual ? resolvedData : sortedData.slice(startRow, endRow);
                var minRows = this.getMinRows();
                var padRows = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).range(Math.max(minRows - pageRows.length, 0));
                var hasColumnFooter = allVisibleColumns.some(function(d) {
                    return d.Footer;
                });
                var hasFilters = filterable || allVisibleColumns.some(function(d) {
                    return d.filterable;
                });
                var recurseRowsViewIndex = function recurseRowsViewIndex(rows) {
                    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
                    return [
                        rows.map(function(row, i) {
                            index += 1;
                            var rowWithViewIndex = $04496bc9ad49b9c9$var$_extends({}, row, {
                                _viewIndex: index
                            });
                            var newPath = path.concat([
                                i
                            ]);
                            if (rowWithViewIndex[subRowsKey] && (0, $253cfbf17185cb27$export$2e2bcd8739ae039).get(expanded, newPath)) {
                                var _recurseRowsViewIndex = recurseRowsViewIndex(rowWithViewIndex[subRowsKey], newPath, index);
                                var _recurseRowsViewIndex2 = $04496bc9ad49b9c9$var$_slicedToArray(_recurseRowsViewIndex, 2);
                                rowWithViewIndex[subRowsKey] = _recurseRowsViewIndex2[0];
                                index = _recurseRowsViewIndex2[1];
                            }
                            return rowWithViewIndex;
                        }),
                        index
                    ];
                };
                var _recurseRowsViewIndex3 = recurseRowsViewIndex(pageRows);
                var _recurseRowsViewIndex4 = $04496bc9ad49b9c9$var$_slicedToArray(_recurseRowsViewIndex3, 1);
                pageRows = _recurseRowsViewIndex4[0];
                var canPrevious = page > 0;
                var canNext = page + 1 < pages;
                var rowMinWidth = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).sum(allVisibleColumns.map(function(d) {
                    var resizedColumn = resized.find(function(x) {
                        return x.id === d.id;
                    }) || {};
                    return (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedColumn.value, d.width, d.minWidth);
                }));
                var rowIndex = -1;
                var finalState = $04496bc9ad49b9c9$var$_extends({}, resolvedState, {
                    startRow: startRow,
                    endRow: endRow,
                    pageRows: pageRows,
                    minRows: minRows,
                    padRows: padRows,
                    hasColumnFooter: hasColumnFooter,
                    canPrevious: canPrevious,
                    canNext: canNext,
                    rowMinWidth: rowMinWidth
                });
                var rootProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getProps(finalState, undefined, undefined, this));
                var tableProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTableProps(finalState, undefined, undefined, this));
                var tBodyProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTbodyProps(finalState, undefined, undefined, this));
                var loadingProps = getLoadingProps(finalState, undefined, undefined, this);
                var noDataProps = getNoDataProps(finalState, undefined, undefined, this);
                // Visual Components
                var makeHeaderGroup = function makeHeaderGroup(column, i) {
                    var resizedValue = function resizedValue(col) {
                        return (resized.find(function(x) {
                            return x.id === col.id;
                        }) || {}).value;
                    };
                    var flex = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).sum(column.columns.map(function(col) {
                        return col.width || resizedValue(col) ? 0 : col.minWidth;
                    }));
                    var width = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).sum(column.columns.map(function(col) {
                        return (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedValue(col), col.width, col.minWidth);
                    }));
                    var maxWidth = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).sum(column.columns.map(function(col) {
                        return (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedValue(col), col.width, col.maxWidth);
                    }));
                    var theadGroupThProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadGroupThProps(finalState, undefined, column, _this2));
                    var columnHeaderProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
                    var classes = [
                        column.headerClassName,
                        theadGroupThProps.className,
                        columnHeaderProps.className
                    ];
                    var styles = $04496bc9ad49b9c9$var$_extends({}, column.headerStyle, theadGroupThProps.style, columnHeaderProps.style);
                    var rest = $04496bc9ad49b9c9$var$_extends({}, theadGroupThProps.rest, columnHeaderProps.rest);
                    var flexStyles = {
                        flex: flex + ' 0 auto',
                        width: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(width),
                        maxWidth: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(maxWidth)
                    };
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ThComponent, $04496bc9ad49b9c9$var$_extends({
                        key: i + '-' + column.id,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes),
                        style: $04496bc9ad49b9c9$var$_extends({}, styles, flexStyles)
                    }, rest), (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(column.Header, {
                        data: sortedData,
                        column: column
                    }));
                };
                var makeHeaderGroups = function makeHeaderGroups() {
                    var theadGroupProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadGroupProps(finalState, undefined, undefined, _this2));
                    var theadGroupTrProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadGroupTrProps(finalState, undefined, undefined, _this2));
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TheadComponent, $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('-headerGroups', theadGroupProps.className),
                        style: $04496bc9ad49b9c9$var$_extends({}, theadGroupProps.style, {
                            minWidth: rowMinWidth + 'px'
                        })
                    }, theadGroupProps.rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrComponent, $04496bc9ad49b9c9$var$_extends({
                        className: theadGroupTrProps.className,
                        style: theadGroupTrProps.style
                    }, theadGroupTrProps.rest), headerGroups.map(makeHeaderGroup)));
                };
                var makeHeader = function makeHeader(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var sort = sorted.find(function(d) {
                        return d.id === column.id;
                    });
                    var show = typeof column.show === 'function' ? column.show() : column.show;
                    var width = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var maxWidth = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var theadThProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadThProps(finalState, undefined, column, _this2));
                    var columnHeaderProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
                    var classes = [
                        column.headerClassName,
                        theadThProps.className,
                        columnHeaderProps.className
                    ];
                    var styles = $04496bc9ad49b9c9$var$_extends({}, column.headerStyle, theadThProps.style, columnHeaderProps.style);
                    var rest = $04496bc9ad49b9c9$var$_extends({}, theadThProps.rest, columnHeaderProps.rest);
                    var isResizable = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(column.resizable, resizable, false);
                    var resizer = isResizable ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ResizerComponent, $04496bc9ad49b9c9$var$_extends({
                        onMouseDown: function onMouseDown(e) {
                            return _this2.resizeColumnStart(e, column, false);
                        },
                        onTouchStart: function onTouchStart(e) {
                            return _this2.resizeColumnStart(e, column, true);
                        }
                    }, getResizerProps('finalState', undefined, column, _this2))) : null;
                    var isSortable = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(column.sortable, sortable, false);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ThComponent, $04496bc9ad49b9c9$var$_extends({
                        key: i + '-' + column.id,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes, isResizable && 'rt-resizable-header', sort ? sort.desc ? '-sort-desc' : '-sort-asc' : '', isSortable && '-cursor-pointer', !show && '-hidden', pivotBy && pivotBy.slice(0, -1).includes(column.id) && 'rt-header-pivot'),
                        style: $04496bc9ad49b9c9$var$_extends({}, styles, {
                            flex: width + ' 0 auto',
                            width: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(width),
                            maxWidth: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(maxWidth)
                        }),
                        toggleSort: function toggleSort(e) {
                            if (isSortable) _this2.sortColumn(column, multiSort ? e.shiftKey : false);
                        }
                    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(isResizable && 'rt-resizable-header-content')
                    }, (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(column.Header, {
                        data: sortedData,
                        column: column
                    })), resizer);
                };
                var makeHeaders = function makeHeaders() {
                    var theadProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadProps(finalState, undefined, undefined, _this2));
                    var theadTrProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadTrProps(finalState, undefined, undefined, _this2));
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TheadComponent, $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('-header', theadProps.className),
                        style: $04496bc9ad49b9c9$var$_extends({}, theadProps.style, {
                            minWidth: rowMinWidth + 'px'
                        })
                    }, theadProps.rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrComponent, $04496bc9ad49b9c9$var$_extends({
                        className: theadTrProps.className,
                        style: theadTrProps.style
                    }, theadTrProps.rest), allVisibleColumns.map(makeHeader)));
                };
                var makeFilter = function makeFilter(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var width = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var maxWidth = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var theadFilterThProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadFilterThProps(finalState, undefined, column, _this2));
                    var columnHeaderProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(column.getHeaderProps(finalState, undefined, column, _this2));
                    var classes = [
                        column.headerClassName,
                        theadFilterThProps.className,
                        columnHeaderProps.className
                    ];
                    var styles = $04496bc9ad49b9c9$var$_extends({}, column.headerStyle, theadFilterThProps.style, columnHeaderProps.style);
                    var rest = $04496bc9ad49b9c9$var$_extends({}, theadFilterThProps.rest, columnHeaderProps.rest);
                    var filter = filtered.find(function(filter) {
                        return filter.id === column.id;
                    });
                    var ResolvedFilterComponent = column.Filter || FilterComponent;
                    var isFilterable = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(column.filterable, filterable, false);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ThComponent, $04496bc9ad49b9c9$var$_extends({
                        key: i + '-' + column.id,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes),
                        style: $04496bc9ad49b9c9$var$_extends({}, styles, {
                            flex: width + ' 0 auto',
                            width: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(width),
                            maxWidth: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(maxWidth)
                        })
                    }, rest), isFilterable ? (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(ResolvedFilterComponent, {
                        column: column,
                        filter: filter,
                        onChange: function onChange(value) {
                            return _this2.filterColumn(column, value);
                        }
                    }, (0, $456b023efd8a4a72$export$2e2bcd8739ae039).column.Filter) : null);
                };
                var makeFilters = function makeFilters() {
                    var theadFilterProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadFilterProps(finalState, undefined, undefined, _this2));
                    var theadFilterTrProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTheadFilterTrProps(finalState, undefined, undefined, _this2));
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TheadComponent, $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('-filters', theadFilterProps.className),
                        style: $04496bc9ad49b9c9$var$_extends({}, theadFilterProps.style, {
                            minWidth: rowMinWidth + 'px'
                        })
                    }, theadFilterProps.rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrComponent, $04496bc9ad49b9c9$var$_extends({
                        className: theadFilterTrProps.className,
                        style: theadFilterTrProps.style
                    }, theadFilterTrProps.rest), allVisibleColumns.map(makeFilter)));
                };
                var makePageRow = function makePageRow(row, i) {
                    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                    var rowInfo = {
                        original: row[originalKey],
                        row: row,
                        index: row[indexKey],
                        viewIndex: rowIndex += 1,
                        pageSize: pageSize,
                        page: page,
                        level: path.length,
                        nestingPath: path.concat([
                            i
                        ]),
                        aggregated: row[aggregatedKey],
                        groupedByPivot: row[groupedByPivotKey],
                        subRows: row[subRowsKey]
                    };
                    var isExpanded = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).get(expanded, rowInfo.nestingPath);
                    var trGroupProps = getTrGroupProps(finalState, rowInfo, undefined, _this2);
                    var trProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTrProps(finalState, rowInfo, undefined, _this2));
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrGroupComponent, $04496bc9ad49b9c9$var$_extends({
                        key: rowInfo.nestingPath.join('_')
                    }, trGroupProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrComponent, $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(trProps.className, row._viewIndex % 2 ? '-even' : '-odd'),
                        style: trProps.style
                    }, trProps.rest), allVisibleColumns.map(function(column, i2) {
                        var resizedCol = resized.find(function(x) {
                            return x.id === column.id;
                        }) || {};
                        var show = typeof column.show === 'function' ? column.show() : column.show;
                        var width = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                        var maxWidth = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                        var tdProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTdProps(finalState, rowInfo, column, _this2));
                        var columnProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(column.getProps(finalState, rowInfo, column, _this2));
                        var classes = [
                            tdProps.className,
                            column.className,
                            columnProps.className
                        ];
                        var styles = $04496bc9ad49b9c9$var$_extends({}, tdProps.style, column.style, columnProps.style);
                        var cellInfo = $04496bc9ad49b9c9$var$_extends({}, rowInfo, {
                            isExpanded: isExpanded,
                            column: $04496bc9ad49b9c9$var$_extends({}, column),
                            value: rowInfo.row[column.id],
                            pivoted: column.pivoted,
                            expander: column.expander,
                            resized: resized,
                            show: show,
                            width: width,
                            maxWidth: maxWidth,
                            tdProps: tdProps,
                            columnProps: columnProps,
                            classes: classes,
                            styles: styles
                        });
                        var value = cellInfo.value;
                        var useOnExpanderClick = void 0;
                        var isBranch = void 0;
                        var isPreview = void 0;
                        var onExpanderClick = function onExpanderClick(e) {
                            var newExpanded = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).clone(expanded);
                            if (isExpanded) newExpanded = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).set(newExpanded, cellInfo.nestingPath, false);
                            else newExpanded = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).set(newExpanded, cellInfo.nestingPath, {});
                            return _this2.setStateWithData({
                                expanded: newExpanded
                            }, function() {
                                return onExpandedChange && onExpandedChange(newExpanded, cellInfo.nestingPath, e, cellInfo);
                            });
                        };
                        // Default to a standard cell
                        var resolvedCell = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(column.Cell, cellInfo, value);
                        // Resolve Renderers
                        var ResolvedAggregatedComponent = column.Aggregated || (!column.aggregate ? AggregatedComponent : column.Cell);
                        var ResolvedExpanderComponent = column.Expander || ExpanderComponent;
                        var ResolvedPivotValueComponent = column.PivotValue || PivotValueComponent;
                        var DefaultResolvedPivotComponent = PivotComponent || function(props) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ResolvedExpanderComponent, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ResolvedPivotValueComponent, props));
                        };
                        var ResolvedPivotComponent = column.Pivot || DefaultResolvedPivotComponent;
                        // Is this cell expandable?
                        if (cellInfo.pivoted || cellInfo.expander) {
                            // Make it expandable by defualt
                            cellInfo.expandable = true;
                            useOnExpanderClick = true;
                            // If pivoted, has no subRows, and does not have a subComponent,
                            // do not make expandable
                            if (cellInfo.pivoted && !cellInfo.subRows && !SubComponent) cellInfo.expandable = false;
                        }
                        if (cellInfo.pivoted) {
                            // Is this column a branch?
                            isBranch = rowInfo.row[pivotIDKey] === column.id && cellInfo.subRows;
                            // Should this column be blank?
                            isPreview = pivotBy.indexOf(column.id) > pivotBy.indexOf(rowInfo.row[pivotIDKey]) && cellInfo.subRows;
                            // Pivot Cell Render Override
                            if (isBranch) // isPivot
                            resolvedCell = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(ResolvedPivotComponent, $04496bc9ad49b9c9$var$_extends({}, cellInfo, {
                                value: row[pivotValKey]
                            }), row[pivotValKey]);
                            else if (isPreview) // Show the pivot preview
                            resolvedCell = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
                            else resolvedCell = null;
                        } else if (cellInfo.aggregated) resolvedCell = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(ResolvedAggregatedComponent, cellInfo, value);
                        if (cellInfo.expander) {
                            resolvedCell = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(ResolvedExpanderComponent, cellInfo, row[pivotValKey]);
                            if (pivotBy) {
                                if (cellInfo.groupedByPivot) resolvedCell = null;
                                if (!cellInfo.subRows && !SubComponent) resolvedCell = null;
                            }
                        }
                        var resolvedOnExpanderClick = useOnExpanderClick ? onExpanderClick : function() {};
                        // If there are multiple onClick events, make sure they don't
                        // override eachother. This should maybe be expanded to handle all
                        // function attributes
                        var interactionProps = {
                            onClick: resolvedOnExpanderClick
                        };
                        if (tdProps.rest.onClick) interactionProps.onClick = function(e) {
                            tdProps.rest.onClick(e, function() {
                                return resolvedOnExpanderClick(e);
                            });
                        };
                        if (columnProps.rest.onClick) interactionProps.onClick = function(e) {
                            columnProps.rest.onClick(e, function() {
                                return resolvedOnExpanderClick(e);
                            });
                        };
                        // Return the cell
                        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TdComponent, $04496bc9ad49b9c9$var$_extends({
                            key: i2 + '-' + column.id,
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes, !cellInfo.expandable && !show && 'hidden', cellInfo.expandable && 'rt-expandable', (isBranch || isPreview) && 'rt-pivot'),
                            style: $04496bc9ad49b9c9$var$_extends({}, styles, {
                                flex: width + ' 0 auto',
                                width: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(width),
                                maxWidth: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(maxWidth)
                            })
                        }, tdProps.rest, columnProps.rest, interactionProps), resolvedCell);
                    })), rowInfo.subRows && isExpanded && rowInfo.subRows.map(function(d, i) {
                        return makePageRow(d, i, rowInfo.nestingPath);
                    }), SubComponent && !rowInfo.subRows && isExpanded && SubComponent(rowInfo, function() {
                        var newExpanded = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).clone(expanded);
                        (0, $253cfbf17185cb27$export$2e2bcd8739ae039).set(newExpanded, rowInfo.nestingPath, false);
                    }));
                };
                var makePadColumn = function makePadColumn(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var show = typeof column.show === 'function' ? column.show() : column.show;
                    var width = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var flex = width;
                    var maxWidth = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var tdProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTdProps(finalState, undefined, column, _this2));
                    var columnProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(column.getProps(finalState, undefined, column, _this2));
                    var classes = [
                        tdProps.className,
                        column.className,
                        columnProps.className
                    ];
                    var styles = $04496bc9ad49b9c9$var$_extends({}, tdProps.style, column.style, columnProps.style);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TdComponent, $04496bc9ad49b9c9$var$_extends({
                        key: i + '-' + column.id,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes, !show && 'hidden'),
                        style: $04496bc9ad49b9c9$var$_extends({}, styles, {
                            flex: flex + ' 0 auto',
                            width: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(width),
                            maxWidth: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(maxWidth)
                        })
                    }, tdProps.rest), (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(PadRowComponent));
                };
                var makePadRow = function makePadRow(row, i) {
                    var trGroupProps = getTrGroupProps(finalState, undefined, undefined, _this2);
                    var trProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTrProps(finalState, undefined, undefined, _this2));
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrGroupComponent, $04496bc9ad49b9c9$var$_extends({
                        key: 'pad-' + i
                    }, trGroupProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrComponent, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('-padRow', (pageRows.length + i) % 2 ? '-even' : '-odd', trProps.className),
                        style: trProps.style || {}
                    }, allVisibleColumns.map(makePadColumn)));
                };
                var makeColumnFooter = function makeColumnFooter(column, i) {
                    var resizedCol = resized.find(function(x) {
                        return x.id === column.id;
                    }) || {};
                    var show = typeof column.show === 'function' ? column.show() : column.show;
                    var width = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.minWidth);
                    var maxWidth = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).getFirstDefined(resizedCol.value, column.width, column.maxWidth);
                    var tFootTdProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTfootTdProps(finalState, undefined, column, _this2));
                    var columnProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(column.getProps(finalState, undefined, column, _this2));
                    var columnFooterProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(column.getFooterProps(finalState, undefined, column, _this2));
                    var classes = [
                        tFootTdProps.className,
                        column.className,
                        columnProps.className,
                        columnFooterProps.className
                    ];
                    var styles = $04496bc9ad49b9c9$var$_extends({}, tFootTdProps.style, column.style, columnProps.style, columnFooterProps.style);
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TdComponent, $04496bc9ad49b9c9$var$_extends({
                        key: i + '-' + column.id,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(classes, !show && 'hidden'),
                        style: $04496bc9ad49b9c9$var$_extends({}, styles, {
                            flex: width + ' 0 auto',
                            width: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(width),
                            maxWidth: (0, $253cfbf17185cb27$export$2e2bcd8739ae039).asPx(maxWidth)
                        })
                    }, columnProps.rest, tFootTdProps.rest, columnFooterProps.rest), (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(column.Footer, {
                        data: sortedData,
                        column: column
                    }));
                };
                var makeColumnFooters = function makeColumnFooters() {
                    var tFootProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTfootProps(finalState, undefined, undefined, _this2));
                    var tFootTrProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getTfootTrProps(finalState, undefined, undefined, _this2));
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TfootComponent, $04496bc9ad49b9c9$var$_extends({
                        className: tFootProps.className,
                        style: $04496bc9ad49b9c9$var$_extends({}, tFootProps.style, {
                            minWidth: rowMinWidth + 'px'
                        })
                    }, tFootProps.rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TrComponent, $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(tFootTrProps.className),
                        style: tFootTrProps.style
                    }, tFootTrProps.rest), allVisibleColumns.map(makeColumnFooter)));
                };
                var makePagination = function makePagination(isTop) {
                    var paginationProps = (0, $253cfbf17185cb27$export$2e2bcd8739ae039).splitProps(getPaginationProps(finalState, undefined, undefined, _this2));
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PaginationComponent, $04496bc9ad49b9c9$var$_extends({}, resolvedState, {
                        pages: pages,
                        canPrevious: canPrevious,
                        canNext: canNext,
                        onPageChange: _this2.onPageChange,
                        onPageSizeChange: _this2.onPageSizeChange,
                        className: paginationProps.className,
                        style: paginationProps.style,
                        isTop: isTop
                    }, paginationProps.rest));
                };
                var makeTable = function makeTable() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('ReactTable', className, rootProps.className),
                        style: $04496bc9ad49b9c9$var$_extends({}, style, rootProps.style)
                    }, rootProps.rest), showPagination && showPaginationTop ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
                        className: 'pagination-top'
                    }, makePagination(true)) : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TableComponent, $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(tableProps.className, currentlyResizing ? 'rt-resizing' : ''),
                        style: tableProps.style
                    }, tableProps.rest), hasHeaderGroups ? makeHeaderGroups() : null, makeHeaders(), hasFilters ? makeFilters() : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TbodyComponent, $04496bc9ad49b9c9$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(tBodyProps.className),
                        style: $04496bc9ad49b9c9$var$_extends({}, tBodyProps.style, {
                            minWidth: rowMinWidth + 'px'
                        })
                    }, tBodyProps.rest), pageRows.map(function(d, i) {
                        return makePageRow(d, i);
                    }), padRows.map(makePadRow)), hasColumnFooter ? makeColumnFooters() : null), showPagination && showPaginationBottom ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement('div', {
                        className: 'pagination-bottom'
                    }, makePagination(false)) : null, !pageRows.length && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NoDataComponent, noDataProps, (0, $253cfbf17185cb27$export$2e2bcd8739ae039).normalizeComponent(noDataText)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingComponent, $04496bc9ad49b9c9$var$_extends({
                        loading: loading,
                        loadingText: loadingText
                    }, loadingProps)));
                };
                // childProps are optionally passed to a function-as-a-child
                return children ? children(finalState, makeTable, this) : makeTable();
            }
        }
    ]);
    return ReactTable;
}((0, $e244feba76b06f6b$export$2e2bcd8739ae039)((0, $9810eebc1eba59e2$export$2e2bcd8739ae039)((0, $acw62.Component))));
$04496bc9ad49b9c9$var$ReactTable.propTypes = (0, $6677a5f81c7b6899$export$2e2bcd8739ae039);
$04496bc9ad49b9c9$var$ReactTable.defaultProps = (0, $456b023efd8a4a72$export$2e2bcd8739ae039);
var $04496bc9ad49b9c9$export$2e2bcd8739ae039 = $04496bc9ad49b9c9$var$ReactTable;





const $0df9b3ab7364c6d6$export$604d3285d0026214 = {
    CATEGORY: 'category',
    SECTION: 'section',
    MODULE: 'module'
};



var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $beCSm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e6a3a0c577f6eee9$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e56e43dd06ac0faa$export$72aef224d6115253), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).iconWrapper}`]: (0, $8nd05.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $e56e43dd06ac0faa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $1En50.default)(props, $e6a3a0c577f6eee9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, (0, $8nd05.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $5929c7187933e9a1$var$cachedType;
function $5929c7187933e9a1$export$a10970ffb6510128() {
    if ($5929c7187933e9a1$var$cachedType) return $5929c7187933e9a1$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $5929c7187933e9a1$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $5929c7187933e9a1$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $5929c7187933e9a1$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $5929c7187933e9a1$var$cachedType;
}
function $5929c7187933e9a1$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $5929c7187933e9a1$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f4c90fbbf54d23af$var$_excluded = [
    "onChange"
];
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $1En50.default)(props, $f4c90fbbf54d23af$var$_excluded);
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", (0, $8nd05.default)({
        style: $f4c90fbbf54d23af$var$styles
    }, other, {
        ref: nodeRef
    }));
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $beCSm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9e031514df70ea8e$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $35c7816ebadb07c9$export$34861783d3c2eef8), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $35c7816ebadb07c9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $1En50.default)(props, $9e031514df70ea8e$var$_excluded);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const ownerState = (0, $8nd05.default)({
        isRtl: isRtl
    }, props);
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $b3ef3be5c947a70a$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $02d495bb1a743bb2$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, (0, $8nd05.default)({
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, (0, $8nd05.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, (0, $8nd05.default)({}, endButtonIconProps))
    }));
});
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;




var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $beCSm.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7be483edbed3b474$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8a85ee70c626268d$export$cdd93bd054dec359), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $8a85ee70c626268d$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $7be483edbed3b474$var$FlexContainer = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $f4c90fbbf54d23af$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $9e031514df70ea8e$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $1En50.default)(props, $7be483edbed3b474$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $5929c7187933e9a1$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $f2ff3c73ed46b37c$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $5929c7187933e9a1$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonComponent, (0, $8nd05.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $331f3746e6346411$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$TabsIndicator, (0, $8nd05.default)({}, TabIndicatorProps, {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $8nd05.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, (0, $8nd05.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $c10afe25107351d9$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)($7be483edbed3b474$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($7be483edbed3b474$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c89acdb493330259$var$Context = /*#__PURE__*/ $acw62.createContext(null);
function $c89acdb493330259$var$useUniquePrefix() {
    const [id, setId] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $c89acdb493330259$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $c89acdb493330259$var$useUniquePrefix();
    const context = $acw62.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c89acdb493330259$var$Context.Provider, {
        value: context,
        children: children
    });
}
function $c89acdb493330259$export$5a3bad273ac578e0() {
    return $acw62.useContext($c89acdb493330259$var$Context);
}
function $c89acdb493330259$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $c89acdb493330259$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4de90d51946fb4d3$var$_excluded = [
    "children"
];
const $4de90d51946fb4d3$var$TabList = /*#__PURE__*/ $acw62.forwardRef(function TabList(props, ref) {
    const { children: childrenProp } = props, other = (0, $1En50.default)(props, $4de90d51946fb4d3$var$_excluded);
    const context = (0, $c89acdb493330259$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            'aria-controls': (0, $c89acdb493330259$export$629f80328afcade5)(context, child.props.value),
            id: (0, $c89acdb493330259$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), (0, $8nd05.default)({}, other, {
        ref: ref,
        value: context.value,
        children: children
    }));
});
var $4de90d51946fb4d3$export$2e2bcd8739ae039 = $4de90d51946fb4d3$var$TabList;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $d8seH = parcelRequire("d8seH");

var $8Indx = parcelRequire("8Indx");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $80496f361a41bf8f$export$cfb3da2e74936ec(slot) {
    return (0, $4Cod0.default)('MuiTabPanel', slot);
}
const $80496f361a41bf8f$var$tabPanelClasses = (0, $beCSm.default)('MuiTabPanel', [
    'root'
]);
var $80496f361a41bf8f$export$2e2bcd8739ae039 = $80496f361a41bf8f$var$tabPanelClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $74c67866e4db07b8$var$_excluded = [
    "children",
    "className",
    "value"
];
const $74c67866e4db07b8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $80496f361a41bf8f$export$cfb3da2e74936ec), classes);
};
const $74c67866e4db07b8$var$TabPanelRoot = (0, $d8seH.default)('div', {
    name: 'MuiTabPanel',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $74c67866e4db07b8$var$TabPanel = /*#__PURE__*/ $acw62.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTabPanel'
    });
    const { children: children, className: className, value: value } = props, other = (0, $1En50.default)(props, $74c67866e4db07b8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props);
    const classes = $74c67866e4db07b8$var$useUtilityClasses(ownerState);
    const context = (0, $c89acdb493330259$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError('No TabContext provided');
    const id = (0, $c89acdb493330259$export$629f80328afcade5)(context, value);
    const tabId = (0, $c89acdb493330259$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($74c67866e4db07b8$var$TabPanelRoot, (0, $8nd05.default)({
        "aria-labelledby": tabId,
        className: (0, $9QePP.default)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState
    }, other, {
        children: value === context.value && children
    }));
});
var $74c67866e4db07b8$export$2e2bcd8739ae039 = $74c67866e4db07b8$var$TabPanel;



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ed7b2b659b749647$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $1iOpW = parcelRequire("1iOpW");






var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ac984bce84b2164$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $adff06ac3b11e066$export$515f8c67b5305377), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $adff06ac3b11e066$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $024a60f892d3fa61$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $8nd05.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $9c1b7b40cd19f5fe$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $1En50.default)(props, $1ac984bce84b2164$var$_excluded);
    const context = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $ec346974df496fc5$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ddba918a398c481$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, (0, $8nd05.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $jTnBY = parcelRequire("jTnBY");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;



var $acw62 = parcelRequire("acw62");
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a71dfe9e22152ea2$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            padding !== 'normal' && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $kTdcz.lighten)((0, $kTdcz.alpha)(theme.palette.divider, 1), 0.88) : (0, $kTdcz.darken)((0, $kTdcz.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $a8eb3ce62ab46dc7$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $1En50.default)(props, $a71dfe9e22152ea2$var$_excluded);
    const table = $acw62.useContext((0, $e848e543ed3bf349$export$2e2bcd8739ae039));
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $8nd05.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef8072c26f712b4c$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d3b4e1a115786e57$export$b12cb262231eef32), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $1En50.default)(props, $ef8072c26f712b4c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $3dba169293b5f5f0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $17a626ba35acf52f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a0648bcf9b9d5e9c$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $a0648bcf9b9d5e9c$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $a0648bcf9b9d5e9c$var$_excluded);
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $71c322247f7fbf93$export$2e2bcd8739ae039);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $17a626ba35acf52f$export$2e2bcd8739ae039);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $3dba169293b5f5f0$export$2e2bcd8739ae039);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $02d495bb1a743bb2$export$2e2bcd8739ae039);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $b3ef3be5c947a70a$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", (0, $8nd05.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, (0, $8nd05.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, (0, $8nd05.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, (0, $8nd05.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, (0, $8nd05.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, (0, $8nd05.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, (0, $8nd05.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, (0, $8nd05.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, (0, $8nd05.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $a0648bcf9b9d5e9c$export$2e2bcd8739ae039 = $a0648bcf9b9d5e9c$var$TablePaginationActions;



'use client';
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $7a3a319e7e555608$export$2e2bcd8739ae039);



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d6175477fd255470$export$909e637b22246f4c(slot) {
    return (0, $4Cod0.default)('MuiTablePagination', slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $beCSm.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $d6175477fd255470$export$2e2bcd8739ae039 = $d6175477fd255470$var$tablePaginationClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $d8seH.default)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $d8seH.default)((0, $ef8072c26f712b4c$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $d8seH.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $d8seH.default)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>(0, $8nd05.default)({
            [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $d6175477fd255470$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $d8seH.default)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d6175477fd255470$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $a0648bcf9b9d5e9c$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $1En50.default)(props, $effe3c7e7b91170d$var$_excluded);
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $a71dfe9e22152ea2$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationRoot, (0, $8nd05.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($effe3c7e7b91170d$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationSelect, (0, $8nd05.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69d1b2c99a8dc649$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $8nd05.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $9QePP.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $9QePP.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $9QePP.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemComponent, (0, $8nd05.default)({}, !(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($effe3c7e7b91170d$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $effe3c7e7b91170d$export$2e2bcd8739ae039 = $effe3c7e7b91170d$var$TablePagination;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");





var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");












var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4dba6b402693f5d6$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $4dba6b402693f5d6$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $4dba6b402693f5d6$var$resolveContainer(containerProp);
    const transform = $4dba6b402693f5d6$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4dba6b402693f5d6$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039) } = props, other = (0, $1En50.default)(props, $4dba6b402693f5d6$var$_excluded);
    const childrenRef = $acw62.useRef(null);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $cc10aae84e3e4b9c$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $8nd05.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $8nd05.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $cc10aae84e3e4b9c$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $acw62.useCallback(()=>{
        if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $0f2866359d6621f3$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $4dba6b402693f5d6$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $707049eb9639aeac$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
                ref: handleRef,
                style: (0, $8nd05.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $4dba6b402693f5d6$export$2e2bcd8739ae039 = $4dba6b402693f5d6$var$Slide;




var $jTnBY = parcelRequire("jTnBY");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $367f15b5d414b8d7$export$b801318a856c9cd2(slot) {
    return (0, $4Cod0.default)('MuiDrawer', slot);
}
const $367f15b5d414b8d7$var$drawerClasses = (0, $beCSm.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $367f15b5d414b8d7$export$2e2bcd8739ae039 = $367f15b5d414b8d7$var$drawerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ed9758f3bc045cc$var$_excluded = [
    "BackdropProps"
], $1ed9758f3bc045cc$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $1ed9758f3bc045cc$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $1ed9758f3bc045cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $jTnBY.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $jTnBY.default)(anchor)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $367f15b5d414b8d7$export$b801318a856c9cd2), classes);
};
const $1ed9758f3bc045cc$var$DrawerRoot = (0, $d8seH.default)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $1ed9758f3bc045cc$var$DrawerDockedRoot = (0, $d8seH.default)('div', {
    shouldForwardProp: (0, $8Uq77.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $1ed9758f3bc045cc$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $1ed9758f3bc045cc$var$DrawerPaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $jTnBY.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $jTnBY.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === 'left' && {
        left: 0
    }, ownerState.anchor === 'top' && {
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        left: 0,
        bottom: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $1ed9758f3bc045cc$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $1ed9758f3bc045cc$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $1ed9758f3bc045cc$export$2a62b49acb270576(anchor) ? $1ed9758f3bc045cc$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $1ed9758f3bc045cc$var$Drawer = /*#__PURE__*/ $acw62.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $4dba6b402693f5d6$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary' } = props, ModalProps = (0, $1En50.default)(props.ModalProps, $1ed9758f3bc045cc$var$_excluded), other = (0, $1En50.default)(props, $1ed9758f3bc045cc$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $1ed9758f3bc045cc$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $1ed9758f3bc045cc$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerPaper, (0, $8nd05.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $9QePP.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerDockedRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
        in: open,
        direction: $1ed9758f3bc045cc$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerDockedRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9758f3bc045cc$var$DrawerRoot, (0, $8nd05.default)({
        BackdropProps: (0, $8nd05.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $9QePP.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $1ed9758f3bc045cc$export$2e2bcd8739ae039 = $1ed9758f3bc045cc$var$Drawer;










function $cc81d7c2616eb3f6$export$2e2bcd8739ae039({}) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [query, setQuery] = (0, $acw62.useState)({});
    let [askAI, setAskAI] = (0, $acw62.useState)({});
    let [tab, setTab] = (0, $acw62.useState)('200-words');
    let [isDrawer, setIsDrawer] = (0, $acw62.useState)(false);
    let [cName, setCName] = (0, $acw62.useState)('');
    let [cWebsite, setCWebsite] = (0, $acw62.useState)('');
    let [newQuery, setNewQuery] = (0, $acw62.useState)('');
    let [fiveWords, setFiveWords] = (0, $acw62.useState)('');
    let [type, setType] = (0, $acw62.useState)('test');
    let [auditLogs, setAuditLogs] = (0, $acw62.useState)([]);
    let [action, setAction] = (0, $acw62.useState)('');
    let [selectedQuery, setSelectedQuery] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        getAIQuery();
    }, [
        tab
    ]);
    const getAIQuery = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/aiquery/${tab}`);
        if (res['code'] == '200') setQuery(res['body']);
    };
    const getAuditLogs = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', {
            endpoint: `/admin/updateAiQuery`
        });
        if (res['code'] == 200) {
            await setAuditLogs(res['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '200WordsAuditLog'
            }));
        }
    };
    const handleCreateQuery = async ()=>{
        if (newQuery == '' && !query?.['activeQuery']?.['query']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter the query');
        let data = {
            isActive: true,
            type: tab,
            query: newQuery == '' ? query?.['activeQuery']?.['query'] : newQuery
        };
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/aiquery`, data);
        if (res['code'] == '200') {
            await getAIQuery();
            setIsDrawer(true);
        }
    };
    const handleAskAI = async ()=>{
        if (cName == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter the company name');
        if (cWebsite == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter the company website');
        if (fiveWords == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter the company description');
        if (fiveWords == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter the five keywords');
        let count = fiveWords.match(/\S+/g);
        if (count.length < 5) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Keywords are less then five!');
        let data = {
            isActive: true,
            type: tab,
            query: newQuery == '' ? query?.['activeQuery']?.['query'] : newQuery,
            cName: cName,
            cWebsite: cWebsite,
            fiveWords: fiveWords
        };
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/testQuery`, data);
        if (res['code'] == '200') {
            await setAskAI(res['body']);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        }
    };
    const handleSelectQuery = async (item, action)=>{
        if (item) await setSelectedQuery(item);
        if (item) await setAction(action);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'queryActionPopup'
        }));
    };
    const submitQueryAction = async ()=>{
        if (Object.keys(selectedQuery).length > 0) {
            let res;
            if (action == 'edit') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/updateAiQuery/${selectedQuery['_id']}`, {
                query: selectedQuery['query']
            });
            if (action == 'active') res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/activateQuery/${selectedQuery['_id']}`);
            if (action == 'delete') res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/deleteaiquery/${selectedQuery['_id']}`);
            if (res?.['code'] == '200') {
                await getAIQuery();
                setSelectedQuery({});
                setAction('');
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
            }
        }
    };
    const showAIQuery = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mx1rem p1rem bss bw2px bo5 br10px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb px2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "fs2rem ttu tac c7 mb1rem",
                            children: [
                                tab.replaceAll('-', ' '),
                                " ChatGPT"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df",
                            children: [
                                query?.['allQuery'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>setIsDrawer(true),
                                    className: "new-shadow h60 cp c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px2rem",
                                    children: [
                                        "Versions ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-history ml0-5rem"
                                        })
                                    ]
                                }),
                                type == 'test' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>setType('add'),
                                    className: "new-shadow h60 cp c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px2rem mx0-5rem",
                                    children: [
                                        "Add Query ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-plus ml0-5rem"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>setType('test'),
                                    className: "new-shadow h60 cp c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px2rem mx0-5rem",
                                    children: [
                                        "Test Query ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-search ml0-5rem"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>getAuditLogs(),
                                    className: "new-shadow df aic h60 cp bg1 bss bw2px bo4 br30px px1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c15 fw500 fs0-75rem mr0-5rem",
                                            children: "Audit Log"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "30",
                                            height: "30",
                                            viewBox: "0 0 36 36",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                                                fill: "#4A67FF"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc px2rem",
                    children: [
                        type == 'test' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "fs1-25rem mb0-5rem",
                                    children: "Company Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onChange: (e)=>setCName(e.target.value),
                                    rows: "1",
                                    placeholder: "Enter company name...",
                                    className: "bss bw2px bo5 px1rem py0-5rem bg1 w100 br5px"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "fs1-25rem mb0-5rem",
                                    children: "Company Webiste"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onChange: (e)=>setCWebsite(e.target.value),
                                    rows: "1",
                                    placeholder: "Enter company website...",
                                    className: "bss bw2px bo5 px1rem py0-5rem bg1 w100 br5px"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "fs1-25rem mb0-5rem",
                                    children: "Five Keywords"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onChange: (e)=>setFiveWords(e.target.value),
                                    rows: "1",
                                    placeholder: "Enter five keywords...",
                                    className: "bss bw2px bo5 px1rem py0-5rem bg1 w100 br5px"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            className: "fs1-25rem mb0-5rem",
                            children: "Query"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                            defaultValue: query?.['activeQuery']?.['query'] || '',
                            onChange: (e)=>setNewQuery(e.target.value),
                            rows: "8",
                            placeholder: "Create your query here...",
                            className: "bss bw2px bo5 px2rem py1rem bg1 w100 br5px mb0-5rem"
                        }),
                        type == 'test' && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "df fdc ml1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "w100 tas c28 fs0-75rem",
                                    children: [
                                        "You can add Company Name instead of ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "##NAME##"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "w100 tas c28 fs0-75rem",
                                    children: [
                                        "You can add Company Website instead of ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "##WEBSITE##"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "w100 tas c28 fs0-75rem",
                                    children: [
                                        "You can add Five Keywords instead of ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "##FIVEWORDS##"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic mb1rem",
                            children: type == 'test' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleAskAI(),
                                className: "new-shadow cp c1 bg4 bg-gradient-hover br30px fs1rem fw500 px3rem py0-5rem",
                                children: "Ask AI"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleCreateQuery(),
                                className: "new-shadow cp c1 bg4 bg-gradient-hover br30px fs1rem fw500 px3rem py0-5rem ml1rem",
                                children: "Create Query"
                            })
                        }),
                        type == 'test' && askAI && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df my0-5rem",
                            children: [
                                askAI?.['gptResponse'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50 mx0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            className: "fs1-25rem",
                                            children: "ChatGPT Response"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "taj fs1rem fw300 c15 p1rem lh3 bss bw2px bo5 br10px mt0-5rem",
                                            style: {
                                                backgroundImage: `url(${(parcelRequire("b93sb"))})`,
                                                backgroundSize: '70%',
                                                backgroundPosition: 'center',
                                                backgroundRepeat: 'no-repeat'
                                            },
                                            children: askAI['gptResponse']
                                        })
                                    ]
                                }),
                                askAI?.['geminiResponse'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50 mx0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            className: "fs1-25rem",
                                            children: "Gemini Response"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "taj fs1rem lh3 fw300 c15 p1rem bss bw2px bo5 br10px mt0-5rem",
                                            style: {
                                                backgroundImage: `url(${(parcelRequire("lmMaG"))})`,
                                                backgroundSize: '70%',
                                                backgroundPosition: 'center',
                                                backgroundRepeat: 'no-repeat'
                                            },
                                            children: askAI['geminiResponse']
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic advisor-index zi2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ed9758f3bc045cc$export$2e2bcd8739ae039), {
                        className: "chat-gpt-drawer",
                        anchor: "left",
                        open: isDrawer,
                        onClose: ()=>setIsDrawer(false),
                        style: {
                            width: '60%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>setIsDrawer(false),
                                className: "df jcc pa new-shadow w100px cp c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px1rem py0-5rem",
                                style: {
                                    top: '30px',
                                    left: '30px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon mr1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "14",
                                            height: "14",
                                            viewBox: "0 0 21 21",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z",
                                                    fill: "white",
                                                    stroke: "white",
                                                    "stroke-width": "0.5"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z",
                                                    fill: "white",
                                                    stroke: "white",
                                                    "stroke-width": "0.5"
                                                })
                                            ]
                                        })
                                    }),
                                    "Back"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "fs1-5rem ttu tac c7 mt2rem mb1rem",
                                children: "Query Versions"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "px2rem py1rem",
                                children: query?.['allQuery'] && query['allQuery'].length > 0 && query['allQuery'].map((item)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100 fs1rem fw500 ml1rem",
                                                children: "Query:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w100 df",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w80 taj fs0-75rem fw300 c15 mx1rem p1rem bss bw2px bo5 br10px",
                                                        children: item['query']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "w20 df jcc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                onClick: ()=>{
                                                                    !item['isActive'] && handleSelectQuery(item, 'active');
                                                                },
                                                                className: `${item['isActive'] ? 'c15 ' : 'cp c28 '} bg1 fs0-75rem`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        style: {
                                                                            marginRight: '4px'
                                                                        },
                                                                        className: `fa fa-circle ${item['isActive'] ? ' c7' : ' c28'}`
                                                                    }),
                                                                    item['isActive'] ? 'Active' : 'Not Active'
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleSelectQuery(item, 'edit'),
                                                                className: "cp bg1 mx0-5rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    "data-tooltip": "Edit",
                                                                    className: "fa fa-edit c3"
                                                                })
                                                            }),
                                                            !item['isActive'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleSelectQuery(item, 'delete'),
                                                                className: "cp bg1",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    "data-tooltip": "Delete",
                                                                    className: "fa fa-trash-o c4"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                        value: tab,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                                onChange: (e, value)=>setTab(value),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                        className: "fs1rem fw600",
                                        label: "200 Words Test",
                                        value: "200-words"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                        className: "fs1rem fw600",
                                        label: "Business Audit",
                                        value: "business-audit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                        className: "fs1rem fw600",
                                        label: "DeDuper",
                                        value: "de-duper"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                        className: "fs1rem fw600",
                                        label: "Filing Assistant",
                                        value: "filling-assistant"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                        className: "fs1rem fw600",
                                        label: "Two Minute Audit",
                                        value: "two-minute-test"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                        className: "fs1rem fw600",
                                        label: "Checklist",
                                        value: "checklist"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                className: "w100",
                                value: "200-words",
                                children: showAIQuery()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] === 'queryActionPopup',
                onClose: ()=>{
                    setSelectedQuery({}), setAction(''), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                },
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 bg1 shadow w100 bsbb df fdc m1rem maw800px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                    className: "text-gradient fs1-5rem ttu tac lh1 fw600",
                                    children: [
                                        action,
                                        " Query"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: [
                                action == 'edit' ? /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    defaultValue: selectedQuery['query'],
                                    onChange: (e)=>setSelectedQuery((st)=>({
                                                ...st,
                                                query: e.target.value
                                            })),
                                    rows: "10",
                                    className: "bss bw2px bo5 px2rem py2rem bg1 w100 br5px rv"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "tac fs1-25rem c15 fw400 my1rem",
                                    children: [
                                        "Are you sure you want to ",
                                        action,
                                        " this query?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>{
                                                setSelectedQuery({}), setAction(''), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                }));
                                            },
                                            className: "new-shadow bg4 bg3-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>submitQueryAction(),
                                            className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                            children: "Submit"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                setSelectedQuery({}), setAction(''), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] === '200WordsAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 bg1 shadow w100 bsbb df fdc m1rem maw800px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-gradient fs1-5rem ttu tac lh1 fw600",
                                    children: "Audit Logs"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: auditLogs && auditLogs.length > 0 ? auditLogs.map((log)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df my0-5rem",
                                    children: [
                                        log?.['userId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: `ass ml0-5rem br100 w2rem h2rem bg28`,
                                            src: log?.['userId']?.['profile'],
                                            "data-tooltip": log?.['userId']?.['firstName'] && log?.['userId']?.['firstName'] + " " + log?.['userId']?.['lastName']
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `ass w2rem h2rem bg28 fw600 mr0-5rem df jcc aic br100 fs0-75rem`,
                                            "data-tooltip": log?.['userId']?.['firstName'] && log?.['userId']?.['firstName'] + " " + log?.['userId']?.['lastName'],
                                            children: [
                                                log?.['userId']?.['firstName']?.[0] || "?",
                                                log?.['userId']?.['lastName']?.[0] || "?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem ml1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: log['message'] || 'AI Query of 200-words is updated'
                                                        }),
                                                        " at ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: new Date(log.timestamp).toLocaleString()
                                                        }),
                                                        " by ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: log?.['userId']?.['firstName'] && log?.['userId']?.['firstName'] + " " + log?.['userId']?.['lastName']
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fw500",
                                                            children: "Query Updated:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs0-75rem ttc",
                                                            children: log?.['payload']?.['query'] ? log['payload']['query'] : '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-gradient fs1-75rem ttu w100 tac mb1rem",
                                children: "No Logs Found!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



function $63cac72dc17bd39b$export$2e2bcd8739ae039(props) {
    const { section: section, onBack: onBack } = props;
    const [answers, setAnswers] = (0, $acw62.useState)([]);
    const defaultIntro = "I am writing a business audit report to the directors of ";
    const defaultInstructions = `I will give you report text, Please rephrase the standard report wording to make it more specific and tailored/bespoked, particularly to the company's activities and the specific industry in which it operates. Please also use the company's name (omitting the suffix "Limited") periodically and interchangeably with "the company". Please apply the instructions above to the generic report to make that content more relevant to the company and industry. Please do not change the text of line that start and end with ----- keep them as they are and do not move them.`;
    const defaultCompanyName = "ASTRAZENECA PLC";
    const defaultDescription = `The company AstraZeneca PLC is a global biopharmaceutical company that discovers, develops, and commercializes prescription medicines for a wide range of therapy areas, including oncology, cardiovascular, renal and metabolic diseases, infection, respiratory, and rare diseases.**
	AstraZeneca's business model is based on the research and development of innovative new medicines, which it then sells through its own commercial organization and through partners. The company is regulated by a number of different authorities, including the UK Medicines and Healthcare products Regulatory Agency (MHRA) and the US Food and Drug Administration (FDA).
	**AstraZeneca's main business activity is the development and commercialization of prescription medicines.** The company has a portfolio of over 50 marketed medicines, and a pipeline of over 100 new drugs in development. AstraZeneca's medicines are used to treat a wide range of diseases, including cancer, heart disease, stroke, diabetes, asthma, and arthritis.
	**AstraZeneca's business model is based on the following key activities:**
	* **Research and development:** AstraZeneca invests heavily in research and development, with the aim of discovering new medicines that can improve the lives of patients. The company has a global network of research and development centers, and employs over 16,000 scientists and researchers.
	* **Manufacturing:** AstraZeneca manufactures its own medicines at its own facilities around the world. The company also has a number of partnerships with other manufacturers.
	* **Commercialization:** AstraZeneca sells its medicines through its own commercial organization and through partners. The company has a global sales and marketing team, and operates in over 100 countries.
	**AstraZeneca is a major player in the global pharmaceutical industry. The company's medicines are used by millions of people around the world. AstraZeneca is committed to developing new medicines that can improve the lives of patients and transform the future of healthcare.**`;
    const [intro, setIntro] = (0, $acw62.useState)('');
    const [instructions, setInstructions] = (0, $acw62.useState)('');
    const [companyName, setCompanyName] = (0, $acw62.useState)("");
    const [description, setDescription] = (0, $acw62.useState)('');
    const [aiResp, setAiResp] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/audit/currentAuditInfo`);
            if (res?.code === 200) {
                let [intro, instructions, companyName, description] = res.body;
                setIntro(res.body[0]) ? setIntro(res.body[0]) : defaultIntro;
                setInstructions(res.body[1]) ? setInstructions(res.body[1]) : defaultInstructions;
                setCompanyName(res.body[2]) ? setCompanyName(res.body[2]) : defaultCompanyName;
                setDescription(res.body[3]) ? setDescription(res.body[3]) : defaultDescription;
            }
        };
        fetch();
    }, []);
    const getAIResponse = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/ai_test`, {
            intro: intro,
            instructions: instructions,
            companyName: companyName,
            description: description,
            section: section,
            answers: answers
        });
        if (!res || res['code'] != 200) return;
        let { questions: questions, risks: risks, recommendations: recommendations } = res['body'];
        if (!questions || !risks || !recommendations) return;
        let aiResp = {
            risks: [],
            recommendations: []
        };
        for(let qi = 0; qi < section['questions'].length; qi++){
            aiResp.risks[qi] = '';
            aiResp.recommendations[qi] = '';
            for(let i = 0; i < questions.length; i++)if (section['questions'][qi]['qDescription'] == questions[i]) {
                aiResp.risks[qi] = risks[i];
                aiResp.recommendations[qi] = recommendations[i];
            }
        }
        setAiResp(aiResp);
    };
    const radioButtonChanged = (e, index)=>{
        const option = e.target.dataset.option;
        const wrapper = e.target.closest("[data-id]");
        if (!answers[index]) answers[index] = {
            _id: index,
            status: '',
            radioOption: '',
            qNo: section['questions'][index]['qNo']
        };
        for (const showOrHideEl of wrapper.querySelectorAll(".showOrHide"))if (option === "Yes") {
            showOrHideEl.classList.remove("dn");
            setTimeout(()=>showOrHideEl.classList.remove("op0", "h0"), 100);
        } else {
            showOrHideEl.classList.add("op0", "h0");
            setTimeout(()=>showOrHideEl.classList.add("dn"), 300);
        }
        answers[index]['radioOption'] = option;
        if (option == 'N/A') answers[index]['status'] = 'Not Applicable';
        else answers[index]['status'] = 'Completed';
        setAnswers(answers);
    };
    const updateAnswer = async (answer)=>{};
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - AI Test",
                    subheading: section['sectionNo'] + " - " + section['sectionName']
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: onBack,
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fs1rem bss bw2px bo5 br10px p1rem jcsb",
                    id: `${section['sectionNo']}_Audit`,
                    children: section['questions'].map((question, questionIndex)=>{
                        const answer = answers[questionIndex] || {
                            _id: questionIndex,
                            status: '',
                            radioOption: ''
                        };
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df jcsb",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs1rem fw600 auditSectionTitle",
                                                children: [
                                                    question['qNo'],
                                                    " \xa0 - \xa0",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: answer['status'] === 'Completed' ? 'c7' : answer['status'] === 'Not Applicable' ? 'c8' : 'c9',
                                                        children: answer['status']
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            "data-id": answer['_id'],
                                            className: (!answer || (answer.editPermission ?? true) ? "" : "op20 pen ") + "dg gtcr2-lg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fw500 fs1rem",
                                                    children: question['qDescription']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic fww ml3rem",
                                                    children: [
                                                        "Yes",
                                                        "No",
                                                        "N/A"
                                                    ].map((option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            for: question['_id'] + option,
                                                            className: "py0-5rem df cp",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "checkbox w2rem h2rem pr",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        defaultChecked: answer['radioOption'] == option,
                                                                        "data-option": option,
                                                                        onChange: (e)=>radioButtonChanged(e, questionIndex),
                                                                        name: answer['_id'],
                                                                        id: answer['_id'] + option,
                                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                                        type: "radio"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "w100 fs1rem lh3 ml0-5rem usn mr2rem",
                                                                    children: option
                                                                })
                                                            ]
                                                        }))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                aiResp && aiResp.risks && aiResp.risks[questionIndex] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcsb",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs1rem ",
                                            children: [
                                                "Risk : ",
                                                aiResp.risks[questionIndex],
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "Recommendation : ",
                                                aiResp.recommendations[questionIndex],
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                            ]
                                        })
                                    })
                                })
                            ]
                        });
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg1rem mx1rem p1rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "usn pen fs1-25rem fw600",
                            children: "AI Test Phase"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setCompanyName(e.target.value),
                                    defaultValue: companyName,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setDescription(e.target.value),
                                    defaultValue: description,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Intro"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setIntro(e.target.value),
                                    defaultValue: intro,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Instructions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setInstructions(e.target.value),
                                    defaultValue: instructions,
                                    className: "bss bw2px bo5 px4rem pt2rem bg1 w100 br5px"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>getAIResponse(),
                            className: "bg5 c6 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic",
                            children: "Ask ChatGPT"
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $94a0b690fd9978ec$var$extendStatics = function(d, b) {
    $94a0b690fd9978ec$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $94a0b690fd9978ec$var$extendStatics(d, b);
};
function $94a0b690fd9978ec$var$__extends(d, b) {
    $94a0b690fd9978ec$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $94a0b690fd9978ec$var$__assign = function() {
    $94a0b690fd9978ec$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $94a0b690fd9978ec$var$__assign.apply(this, arguments);
};
function $94a0b690fd9978ec$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
var $94a0b690fd9978ec$var$VIEWBOX_WIDTH = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT = 100;
var $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_X = 50;
var $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y = 50;
function $94a0b690fd9978ec$var$Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (0, $acw62.createElement)("path", {
        className: className,
        style: Object.assign({}, style, $94a0b690fd9978ec$var$getDashStyle({
            pathRadius: pathRadius,
            dashRatio: dashRatio,
            counterClockwise: counterClockwise
        })),
        d: $94a0b690fd9978ec$var$getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise
        }),
        strokeWidth: strokeWidth,
        fillOpacity: 0
    });
}
function $94a0b690fd9978ec$var$getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + $94a0b690fd9978ec$var$VIEWBOX_CENTER_X + "," + $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function $94a0b690fd9978ec$var$getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px"
    };
}
var $94a0b690fd9978ec$export$14082143029b37c8 = function(_super) {
    $94a0b690fd9978ec$var$__extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function() {
        if (!this.props.background) return 0;
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function() {
        return $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function() {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function() {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (0, $acw62.createElement)("svg", {
            className: classes.root + " " + className,
            style: styles.root,
            viewBox: "0 0 " + $94a0b690fd9978ec$var$VIEWBOX_WIDTH + " " + $94a0b690fd9978ec$var$VIEWBOX_HEIGHT,
            "data-test-id": "CircularProgressbar"
        }, this.props.background ? (0, $acw62.createElement)("circle", {
            className: classes.background,
            style: styles.background,
            cx: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            cy: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y,
            r: $94a0b690fd9978ec$var$VIEWBOX_HEIGHT_HALF
        }) : null, (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.trail,
            counterClockwise: counterClockwise,
            dashRatio: circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.trail
        }), (0, $acw62.createElement)($94a0b690fd9978ec$var$Path, {
            className: classes.path,
            counterClockwise: counterClockwise,
            dashRatio: pathRatio * circleRatio,
            pathRadius: pathRadius,
            strokeWidth: strokeWidth,
            style: styles.path
        }), text ? (0, $acw62.createElement)("text", {
            className: classes.text,
            style: styles.text,
            x: $94a0b690fd9978ec$var$VIEWBOX_CENTER_X,
            y: $94a0b690fd9978ec$var$VIEWBOX_CENTER_Y
        }, text) : null);
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background'
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {}
        },
        text: ''
    };
    return CircularProgressbar;
}((0, $acw62.Component));
function $94a0b690fd9978ec$export$5ab97151efedb8c6(props) {
    var children = props.children, circularProgressbarProps = $94a0b690fd9978ec$var$__rest(props, [
        "children"
    ]);
    return (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren"
    }, (0, $acw62.createElement)("div", {
        style: {
            position: 'relative',
            width: '100%',
            height: '100%'
        }
    }, (0, $acw62.createElement)($94a0b690fd9978ec$export$14082143029b37c8, $94a0b690fd9978ec$var$__assign({}, circularProgressbarProps)), props.children ? (0, $acw62.createElement)("div", {
        "data-test-id": "CircularProgressbarWithChildren__children",
        style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            marginTop: '-100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, props.children) : null));
}
function $94a0b690fd9978ec$export$5115a192ad9bf57f(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
    return {
        root: {},
        path: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s"
        }),
        trail: $94a0b690fd9978ec$var$removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin
        }),
        text: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: textColor,
            fontSize: textSize
        }),
        background: $94a0b690fd9978ec$var$removeUndefinedValues({
            fill: backgroundColor
        })
    };
}
function $94a0b690fd9978ec$var$removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function(key) {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");
var $8Uq77 = parcelRequire("8Uq77");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $beCSm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12775c00f473d955$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6e1cd6b997bc70d3$export$6c57c6e16b4063b), classes);
    return (0, $8nd05.default)({}, classes, composedClasses);
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $f3bdb1b636c81735$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $kTdcz.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).checked}, &.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $6e1cd6b997bc70d3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8b10b2b5aaa8e54$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $122b08a8ae2faae5$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8b21cdbf539e4f$export$2e2bcd8739ae039), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $1En50.default)(props, $12775c00f473d955$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($12775c00f473d955$var$CheckboxRoot, (0, $8nd05.default)({
        type: "checkbox",
        inputProps: (0, $8nd05.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d696835f9b43a35$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c01aa6ddbe5e68bd$export$1061006a0db3aeb5), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $c01aa6ddbe5e68bd$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $1En50.default)(props, $0d696835f9b43a35$var$_excluded);
    const { dense: dense } = $acw62.useContext((0, $2ddba918a398c481$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $8nd05.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d696835f9b43a35$var$ListItemTextRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;







const $fe054d9f3cf9a466$var$cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);




function $fe054d9f3cf9a466$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let ref1 = (0, $acw62.useRef)(null);
    let ref2 = (0, $acw62.useRef)(null);
    let ref3 = (0, $acw62.useRef)(null);
    let ref4 = (0, $acw62.useRef)(null);
    let [isDPP, setIsDPP] = (0, $acw62.useState)(false);
    let [editInput, setEditInput] = (0, $acw62.useState)('');
    let [uploadType, setUploadType] = (0, $acw62.useState)('');
    let [currentImage, setCurrentImage] = (0, $acw62.useState)('');
    let [isImageModal, setIsImageModal] = (0, $acw62.useState)(false);
    let [selectedStages, setSelectedStages] = (0, $acw62.useState)([]);
    let [selectedSectors, setSelectedSectors] = (0, $acw62.useState)([]);
    let [selectedUKRegions, setSelectedUKRegions] = (0, $acw62.useState)({});
    let [isUKRegistered, setIsUKRegistered] = (0, $acw62.useState)(false);
    let [investorContact, setInvestorContact] = (0, $acw62.useState)({
        bio: '',
        job: '',
        phone: '',
        email: '',
        firstName: '',
        lastName: '',
        profilePicture: '',
        officeLocation: '',
        isRegistered: false
    });
    let ukRegions = [
        'UK',
        'East Midlands',
        'West Midlands',
        'East of England',
        'South East England',
        'South West England',
        'North West England',
        'North East England',
        'Yorkshire and the Humber',
        'Greater London',
        'Scotland',
        'Wales',
        'Northern Ireland',
        'Channel Islands (Jersey & Guernsey)',
        'Isle of Man'
    ];
    let { onBack: onBack, setInvestorCompleted: setInvestorCompleted, action: action, investorId: investorId, investorFirm: investorFirm, setInvestorFirm: setInvestorFirm } = props;
    let sectionTabs = [
        {
            name: 'Investor Details',
            ref: ref1
        },
        {
            name: 'Investor Investment Criteria - Objective',
            ref: ref2
        },
        {
            name: 'Investor Investment Criteria - Subjective',
            ref: ref3
        },
        {
            name: 'Investor Lead Contact Details',
            ref: ref4
        }
    ];
    let dropdownOptions = {
        empty: [
            '',
            'not known',
            'not selected',
            'none selected',
            'nil'
        ],
        cStages: [
            "Pre-Revenue",
            "Post-Revenue Early Stage",
            "Mature"
        ],
        fundSizes: [
            "<\xa35m",
            "\xa35m-\xa3100m",
            "\xa3100m-\xa3500m",
            "\xa3500m-\xa31bn",
            ">\xa31bn",
            'Not known'
        ],
        sweetSpots: [
            "<\xa3100,000",
            "\xa3100,001-\xa31,000,000",
            "\xa31,000,001-\xa35,000,000",
            "\xa35,000,001-\xa320,000,000",
            "\xa320,000,001-\xa3100,000,000",
            ">\xa3100,000,001",
            'Not known'
        ],
        revenues: [
            'Nil',
            "<\xa3100,000",
            "\xa3100,000-\xa3500,000",
            "\xa3500,001-\xa31m",
            ">\xa31m ARR",
            "\xa31m-\xa35m",
            "\xa35m-\xa310m",
            "\xa310m-\xa320m",
            "\xa320m-\xa3100m",
            "\xa3100m+",
            'Not known'
        ],
        profits: [
            'Nil',
            "<\xa3100,000",
            "\xa3100,000-\xa3500,000",
            "\xa3500,001-\xa31m",
            ">\xa31m ARR",
            "\xa31m-\xa35m",
            "\xa35m-\xa310m",
            "\xa310m-\xa320m",
            "\xa320m-\xa3100m",
            "\xa3100m+",
            'Not known'
        ],
        stages: [
            'Angel',
            'Pre-Seed',
            'Seed',
            'Venture Capital - Series A',
            'Venture Capital - Series B+',
            'Private Equity',
            'Accelerator',
            'Angel Group',
            'Convertible Note',
            'Corporate Centure Capital',
            'Co-working Space',
            'Crowdfunding',
            'Debt',
            'Early Stage Venture',
            'Entrepreneurship Program',
            'Family Investment Office',
            'Fund of Funds',
            'Government Office',
            'Grant',
            'Hedge Fund',
            'Incubator',
            'Initial Coin Offering',
            'Investment Bank',
            'IPO',
            'Late Stage Venture',
            'Non-Equity Assistance',
            'Pension Funds',
            'Pre-IPO',
            'Post-IPO',
            'Secondary Market',
            'Secondary Purchaser',
            'Startup Competition',
            'Syndicate',
            'University Program',
            'Venture Debt',
            'Other',
            'Not Selected'
        ],
        sectors: [
            'General',
            'Accounting',
            'Advertising',
            'Advice',
            'Aerospace',
            'Ag Tech',
            'Analytics',
            'Angel Investment',
            'Apps',
            'Artificial Intelligence',
            'Asset Management',
            'Banking',
            'Big Data',
            'Biotechnology',
            'Blockchain',
            'Business Development',
            'Business Information Systems',
            'CleanTech',
            'Cloud Infrastructure',
            'Commerce & Shopping',
            'Commercial Real Estate',
            'Community & Lifestyle',
            'Consumer',
            'Consumer Electronics',
            'Consumer Goods',
            'Consulting',
            'Credit',
            'Cryptocurrency',
            'Customer Service',
            'Cybersecurity',
            'Data & Analytics',
            'Data Management',
            'Database',
            'Delivery',
            'Developer APIs',
            'Developer Platform',
            'Document Management',
            'E-Commerce',
            'Education',
            'Energy',
            'Enterprise Software',
            'Environmental Engineering',
            'Events',
            'Female Focus',
            'Finance',
            'Financial Services',
            'FinTech',
            'Food & Beverage',
            'Gaming',
            'Genetics',
            'Government',
            'Gov Tech',
            'GreenTech',
            'Hardware',
            'Healthcare',
            'Higher Education',
            'Impact Investing',
            'Information Technology',
            'Infrastructure',
            'Intellectual Property',
            'Internet',
            'Internet Services',
            'Insurance',
            'Insurtech',
            'Incubators',
            'Law Enforcement',
            'Legal',
            'Legal Tech',
            'Lending & Investments',
            'Life Science',
            'Machine Learning',
            'Management Consulting',
            'Manufacturing',
            'Marketplace',
            'Media & Entertainment',
            'Medical',
            'Medical Device',
            'Mobile',
            'Mobile Apps',
            'Oil & Gas',
            'Payments',
            'Privacy & Security',
            'Productivity Tools',
            'Professional Services',
            'Prop Tech',
            'Real Estate',
            'Retail',
            'Risk Management',
            'SaaS',
            'Sales & Marketing',
            'Science & Engineering',
            'Smart Cities',
            'Software',
            'Stock Exchanges',
            'Sustainability',
            'Tax Consulting',
            'Transportation',
            'Venture Capital',
            'Video',
            'Wealth Management',
            'Web3',
            'Web Development',
            'Web Hosting',
            'Wellness',
            'Wholesale',
            'Other',
            'Not Selected'
        ],
        investmentNo: [
            '<10',
            '10-20',
            '20-100',
            '>100',
            'Not known'
        ],
        lastInvestmentDates: [
            'Within 6 months',
            'Within 12 months',
            'More than 12 months',
            'Not known'
        ]
    };
    // useEffect(() => {
    //     if (investorId && investorId !== '') getInvestorFirm(investorId);
    // }, []);
    (0, $acw62.useEffect)(()=>{
        if (investorFirm) {
            if (investorFirm['contactInfo']) setInvestorContact(investorFirm['contactInfo']);
            if (investorFirm['ukRegNo'] && investorFirm['ukRegNo'] !== '') setIsUKRegistered(true);
            if (investorFirm['subscription'] && investorFirm['subscription'] === 'Pro') setIsDPP(true);
            let tempSectors = [];
            if (investorFirm['preferredSectors'] && !dropdownOptions['empty'].includes(investorFirm['preferredSectors']['sector1']?.toLowerCase()) && !tempSectors.includes(investorFirm['preferredSectors']['sector1'])) tempSectors.push(investorFirm['preferredSectors']['sector1']);
            if (investorFirm['preferredSectors'] && !dropdownOptions['empty'].includes(investorFirm['preferredSectors']['sector2']?.toLowerCase()) && !tempSectors.includes(investorFirm['preferredSectors']['sector2'])) tempSectors.push(investorFirm['preferredSectors']['sector2']);
            if (investorFirm['preferredSectors'] && !dropdownOptions['empty'].includes(investorFirm['preferredSectors']['sector3']?.toLowerCase()) && !tempSectors.includes(investorFirm['preferredSectors']['sector3'])) tempSectors.push(investorFirm['preferredSectors']['sector3']);
            if (investorFirm['preferredSectors'] && !dropdownOptions['empty'].includes(investorFirm['preferredSectors']['sector4']?.toLowerCase()) && !tempSectors.includes(investorFirm['preferredSectors']['sector4'])) tempSectors.push(investorFirm['preferredSectors']['sector4']);
            if (investorFirm['preferredSectors'] && !dropdownOptions['empty'].includes(investorFirm['preferredSectors']['sector5']?.toLowerCase()) && !tempSectors.includes(investorFirm['preferredSectors']['sector5'])) tempSectors.push(investorFirm['preferredSectors']['sector5']);
            setSelectedSectors(tempSectors);
            let tempStages = [];
            if (investorFirm['stageFocus'] && !dropdownOptions['empty'].includes(investorFirm['stageFocus']['stage1']?.toLowerCase()) && !tempStages.includes(investorFirm['stageFocus']['stage1'])) tempStages.push(investorFirm['stageFocus']['stage1']);
            if (investorFirm['stageFocus'] && !dropdownOptions['empty'].includes(investorFirm['stageFocus']['stage2']?.toLowerCase()) && !tempStages.includes(investorFirm['stageFocus']['stage2'])) tempStages.push(investorFirm['stageFocus']['stage2']);
            if (investorFirm['stageFocus'] && !dropdownOptions['empty'].includes(investorFirm['stageFocus']['stage3']?.toLowerCase()) && !tempStages.includes(investorFirm['stageFocus']['stage3'])) tempStages.push(investorFirm['stageFocus']['stage3']);
            setSelectedStages(tempStages);
            if (investorFirm?.['ukRegions'] && Object.keys(investorFirm['ukRegions']).length > 0) setSelectedUKRegions(investorFirm['ukRegions']);
        }
    }, [
        investorFirm
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isUKRegistered) setInvestorFirm({
            ...investorFirm,
            ukRegNo: '',
            isUKRegistered: isUKRegistered
        });
    }, [
        isUKRegistered
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDPP) setInvestorFirm({
            ...investorFirm,
            subscription: 'Pro'
        });
        else setInvestorFirm({
            ...investorFirm,
            subscription: 'Free'
        });
    }, [
        isDPP
    ]);
    const scrollToContent = (ref)=>{
        ref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    // const getInvestorFirm = async (investorId) => {
    //     let response = await getRequest(`/company/getInvestorFirm/${investorId}`);
    //     if (response['code'] == 200) setInvestorFirm(response['body']);
    // };
    const uploadImage = async ()=>{
        let attachment = [];
        if ($fe054d9f3cf9a466$var$cropper.current && currentImage) {
            let imageToUpload = $fe054d9f3cf9a466$var$cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile image", {
                type: "image/png"
            });
            attachment.push(coverFile);
            setCurrentImage(imageToUpload);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/uploadFile`, {
                attachment: attachment
            }, true);
            if (response || response['code'] == 200) {
                if (uploadType === 'logo') setInvestorFirm({
                    ...investorFirm,
                    logo: response?.['body']?.['report']?.['location']
                });
                else if (uploadType === 'contactImage') setInvestorContact({
                    ...investorContact,
                    profilePicture: response?.['body']?.['report']?.['location'],
                    profile: response?.['body']?.['report']?.['location']
                });
                setIsImageModal(false);
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message);
        }
    };
    const handleImage = async (e)=>{
        let image = e.target.files[0];
        if (image && image.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        image = await URL.createObjectURL(image);
        setCurrentImage(image);
    };
    const handleInvestorChange = (event)=>{
        const { name: name, value: value } = event['target'];
        if (name === 'ukEmployees' || name === 'globalEmployees') setInvestorFirm({
            ...investorFirm,
            employees: {
                ...investorFirm['employees'],
                [name]: value
            }
        });
        else if (name === 'isActive') setInvestorFirm({
            ...investorFirm,
            [name]: !investorFirm[name]
        });
        else if (name === 'sector') {
            if (value.length <= 5) {
                setSelectedSectors(value);
                setInvestorFirm({
                    ...investorFirm,
                    preferredSectors: {
                        ...investorFirm['preferredSectors'],
                        sector1: value[0] ? value[0] : 'Not Selected',
                        sector2: value[1] ? value[1] : 'Not Selected',
                        sector3: value[2] ? value[2] : 'Not Selected',
                        sector4: value[3] ? value[3] : 'Not Selected',
                        sector5: value[4] ? value[4] : 'Not Selected'
                    }
                });
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select up to 5 sectors');
        } else if (name === 'stage') {
            if (value.length <= 3) {
                setSelectedStages(value);
                setInvestorFirm({
                    ...investorFirm,
                    stageFocus: {
                        ...investorFirm['stageFocus'],
                        stage1: value[0] ? value[0] : 'Not Selected',
                        stage2: value[1] ? value[1] : 'Not Selected',
                        stage3: value[2] ? value[2] : 'Not Selected'
                    }
                });
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select up to 3 stages');
        } else if (name === 'ukRegions') {
            let ukRegions = {};
            if (value.length > 0) value.map((region)=>{
                ukRegions = {
                    ...ukRegions,
                    [region]: true
                };
            });
            setSelectedUKRegions(ukRegions);
            setInvestorFirm({
                ...investorFirm,
                ukRegions: ukRegions
            });
        } else if (name === 'noOfInvestments' || name === 'lastInvestmentDate') setInvestorFirm({
            ...investorFirm,
            investment: {
                ...investorFirm['investment'],
                [name]: value
            }
        });
        else setInvestorFirm({
            ...investorFirm,
            [name]: value
        });
    };
    const handleContactChange = (event)=>{
        const { name: name, value: value } = event['target'];
        if (name === 'isRegistered') setInvestorContact({
            ...investorContact,
            [name]: !investorContact[name]
        });
        else setInvestorContact({
            ...investorContact,
            [name]: value
        });
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/adminAddEditInvestor`, {
            action: action,
            investorId: investorId,
            investorData: investorFirm,
            contactData: investorContact
        });
        if (response['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            setInvestorCompleted(true);
        }
    };
    const getOverviewContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "minh100vh bg1 shadow p2rem br5px mb3rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt0-5rem mr1rem dg gg1rem minh100vh-report",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "h100 df jcsb aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    onClick: onBack,
                                    className: "w200px shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic fs0-75rem mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen f1 h1rem mr0-5rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 448 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary pen",
                                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary pen",
                                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                                })
                                            ]
                                        }),
                                        "Back to Menu"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "logo-report w60",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h2rem",
                                        src: (parcelRequire("b0Cmg")),
                                        alt: "TODO"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "report-start",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "w100 tac c6 lh2 fs1-75rem mb2rem",
                                children: action === 'add' ? 'Add Investor' : 'Edit Investor'
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "btn-group fit-btn-group",
                    children: sectionTabs.map((tab, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            id: `content-btn-${idx}`,
                            value: tab['name'],
                            onClick: ()=>scrollToContent(tab['ref']),
                            className: `df c6 jcc ttc td250 c3-hover px1rem py0-5rem cp new-report-btn reports-btn-area mb0-75rem`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "pen usn ass mr0-5rem tac fs1rem",
                                children: tab['name']
                            })
                        });
                    })
                })
            ]
        });
    };
    //********** Investor Details **********//
    const investorDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "Investor Details",
                    ref: ref1,
                    className: "sectionWrapper fs0-75rem bg1 shadow p2rem pb3rem br5px mb3rem investor-modal-admin",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df fdc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "w200 tac c6 lh2 fs1-75rem mb2rem",
                                children: "Investor Details"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                autoComplete: "off",
                                className: "df fdc gg1rem investor-details-form",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "form-group df jsc",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-upload-area pr",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "img-box pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: investorFirm?.['logo'] || (parcelRequire("cfmAr")),
                                                        alt: "Profile",
                                                        className: "profile-img w7rem h7rem advisor-profile"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "input-file",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "add-btn bg5",
                                                            onClick: ()=>{
                                                                setIsImageModal(true), setUploadType('logo'), setCurrentImage('');
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                viewBox: "0 0 487 487",
                                                                className: "zi3",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9 v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("lable", {
                                                        className: "ml2rem",
                                                        children: "Upload investor company logo here"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                name: "cName",
                                                type: "text",
                                                placeholder: "Investor Company Name",
                                                defaultValue: investorFirm?.['cName'] || '',
                                                className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                onChange: (event)=>handleInvestorChange(event)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "bg5 pl4rem shadow br5px p1rem",
                                                        children: "UK Registered? (Companies House)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "switch-box pa r0",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                            name: "isUKRegistered",
                                                            checked: isUKRegistered || investorFirm?.['ukRegNo'] !== '',
                                                            className: "success w100",
                                                            onChange: ()=>setIsUKRegistered(!isUKRegistered)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "ukRegNo",
                                                        type: "text",
                                                        placeholder: "If Yes - Companies House Registration Number",
                                                        value: investorFirm?.['ukRegNo'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "cWebsite",
                                                        type: "text",
                                                        placeholder: "Website URL",
                                                        value: investorFirm?.['cWebsite'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        viewBox: "0 0 512 512",
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256s256-114.62,256-256S397.38,0,256,0z M172.211,41.609 c-24.934,27.119-44.68,66.125-56.755,111.992H49.749C75.179,102.741,118.869,62.524,172.211,41.609z M25.6,256 c0-26.999,5.077-52.727,13.662-76.8h70.494c-4.608,24.294-7.356,49.963-7.356,76.8s2.748,52.506,7.347,76.8H39.262 C30.677,308.727,25.6,283,25.6,256z M49.749,358.4h65.707c12.083,45.867,31.821,84.872,56.755,111.991 C118.869,449.476,75.179,409.259,49.749,358.4z M243.2,485.188c-43.81-8.252-81.877-58.24-101.359-126.788H243.2V485.188z M243.2,332.8H135.74c-4.924-24.166-7.74-49.997-7.74-76.8s2.816-52.634,7.74-76.8H243.2V332.8z M243.2,153.6H141.841 C161.323,85.052,199.39,35.063,243.2,26.812V153.6z M462.251,153.6h-65.707c-12.083-45.867-31.821-84.873-56.755-111.992 C393.131,62.524,436.821,102.741,462.251,153.6z M268.8,26.812c43.81,8.252,81.877,58.24,101.359,126.788H268.8V26.812z M268.8,179.2h107.46c4.924,24.166,7.74,49.997,7.74,76.8s-2.816,52.634-7.74,76.8H268.8V179.2z M268.8,485.188V358.4h101.359 C350.677,426.948,312.61,476.937,268.8,485.188z M339.789,470.391c24.934-27.127,44.672-66.125,56.755-111.991h65.707 C436.821,409.259,393.131,449.476,339.789,470.391z M402.244,332.8c4.608-24.294,7.356-49.963,7.356-76.8 s-2.748-52.506-7.347-76.8h70.494c8.576,24.073,13.653,49.801,13.653,76.8c0,27-5.077,52.727-13.662,76.8H402.244z"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "cPhone",
                                                        type: "text",
                                                        placeholder: "Telephone Number",
                                                        value: investorFirm?.['cPhone'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 384 512",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                className: "fa-primary",
                                                                d: "M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                className: "fa-secondary",
                                                                d: "M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "cAddress",
                                                        type: "text",
                                                        placeholder: "Address",
                                                        value: investorFirm?.['cAddress'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "contactEmail",
                                                        type: "email",
                                                        placeholder: "Company Email for Pitches etc e.g. info@...",
                                                        value: investorFirm?.['contactEmail'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 512 512",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                                className: "fa-secondary"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                                className: "fa-primary"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "ukEmployees",
                                                        type: "number",
                                                        placeholder: "Number of Staff in London",
                                                        value: investorFirm?.['employees']?.['ukEmployees'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "globalEmployees",
                                                        type: "number",
                                                        placeholder: "Number of Staff Globally",
                                                        value: investorFirm?.['employees']?.['globalEmployees'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs1rem",
                                                        style: {
                                                            color: '#7a7a7a'
                                                        },
                                                        children: "Funds Available For Investment"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                        name: "fundSize",
                                                        placeholder: "As required",
                                                        value: investorFirm?.['fundSize'] || 'Not known',
                                                        className: "bg5 shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event),
                                                        children: dropdownOptions.fundSizes.map((fund)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: fund,
                                                                children: fund
                                                            }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs1rem",
                                                        style: {
                                                            color: '#7a7a7a'
                                                        },
                                                        children: "Number Of Investments Made"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                        name: "noOfInvestments",
                                                        placeholder: "No of Investments",
                                                        value: investorFirm?.['investment']?.['noOfInvestments'] || 'Not known',
                                                        className: "bg5 shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event),
                                                        children: dropdownOptions.investmentNo.map((no)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: no,
                                                                children: no
                                                            }))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr mr1rem w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem",
                                                    style: {
                                                        color: '#7a7a7a'
                                                    },
                                                    children: "Date Of Last Investment"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                    name: "lastInvestmentDate",
                                                    placeholder: "Last Investment Date",
                                                    value: investorFirm?.['investment']?.['lastInvestmentDate'] || 'Not known',
                                                    className: "bg5 shadow w100 br5px p1rem",
                                                    onChange: (event)=>handleInvestorChange(event),
                                                    children: dropdownOptions.lastInvestmentDates.map((date)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: date,
                                                            children: date
                                                        }))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    //********** Investor Investment Criteria - Objective **********//
    const investmentCriteriaObjective = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "Investor Investment Criteria - Objective",
                    ref: ref2,
                    className: "sectionWrapper fs0-75rem bg1 shadow p2rem pb3rem br5px mb3rem investor-modal-admin",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df fdc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "w200 tac c6 lh2 fs1-75rem mb2rem",
                                children: "Investor Investment Criteria - Objective"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                autoComplete: "off",
                                className: "df fdc gg1rem investor-details-form",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem",
                                                    style: {
                                                        color: '#7a7a7a'
                                                    },
                                                    children: "Preferred Regions"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                    multiple: true,
                                                    className: "w100 bg5 shadow w100 br5px multiselect-invest",
                                                    placeholder: "Sectors",
                                                    name: "ukRegions",
                                                    id: "preferred-sectors",
                                                    labelId: "preferred-sectors-label",
                                                    onChange: (event)=>handleInvestorChange(event),
                                                    renderValue: (selected)=>selected.join(', '),
                                                    value: Object.keys(selectedUKRegions) || [],
                                                    children: ukRegions.map((region)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                            value: region,
                                                            className: "multi-dropdown-list",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                    checked: selectedUKRegions[region]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                    primary: region
                                                                })
                                                            ]
                                                        }))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem",
                                                    style: {
                                                        color: '#7a7a7a'
                                                    },
                                                    children: "Preferred Sectors"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                    multiple: true,
                                                    className: "w100 bg5 shadow w100 br5px multiselect-invest",
                                                    placeholder: "Sectors",
                                                    name: "sector",
                                                    id: "preferred-sectors",
                                                    labelId: "preferred-sectors-label",
                                                    onChange: (event)=>handleInvestorChange(event),
                                                    renderValue: (selected)=>selected.join(', '),
                                                    value: selectedSectors || [],
                                                    children: dropdownOptions.sectors.map((sector)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                            value: sector,
                                                            className: "multi-dropdown-list",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                    checked: selectedSectors.includes(sector)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                    primary: sector
                                                                })
                                                            ]
                                                        }))
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "ml0-5rem mt0-3rem fs0-75rem tal df jcfs w100",
                                                    children: "Note: You can select up to 5 sectors."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem",
                                                    style: {
                                                        color: '#7a7a7a'
                                                    },
                                                    children: "Preferred Investment Stage"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                    multiple: true,
                                                    className: "w100 bg5 shadow w100 br5px multiselect-invest",
                                                    placeholder: "Stage",
                                                    name: "stage",
                                                    id: "stage-focus",
                                                    labelId: "stage-focus-label",
                                                    onChange: (event)=>handleInvestorChange(event),
                                                    renderValue: (selected)=>selected.join(', '),
                                                    value: selectedStages || [],
                                                    children: dropdownOptions.stages.map((stage)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                            value: stage,
                                                            className: "multi-dropdown-list",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                    checked: selectedStages.includes(stage)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                    primary: stage
                                                                })
                                                            ]
                                                        }))
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "ml0-5rem mt0-3rem fs0-75rem tal df jcfs w100",
                                                    children: "Note: You can select up to 3 stages."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem",
                                                    style: {
                                                        color: '#7a7a7a'
                                                    },
                                                    children: "Sweet Spot"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                    name: "sweetSpot",
                                                    placeholder: "Sweet Spot",
                                                    value: investorFirm?.['sweetSpot'] || 'Not known',
                                                    className: "bg5 shadow w100 br5px p1rem",
                                                    onChange: (event)=>handleInvestorChange(event),
                                                    children: dropdownOptions.sweetSpots.map((spot)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: spot,
                                                            children: spot
                                                        }))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs1rem",
                                                        style: {
                                                            color: '#7a7a7a'
                                                        },
                                                        children: "Minimum Annual Profit Current Year"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                        name: "annualProfits",
                                                        placeholder: "Annual Profit",
                                                        value: investorFirm?.['annualProfits'] || 'Not known',
                                                        className: "bg5 shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event),
                                                        children: dropdownOptions.profits.map((profit)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: profit,
                                                                children: profit
                                                            }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs1rem",
                                                        style: {
                                                            color: '#7a7a7a'
                                                        },
                                                        children: "Minimum Annual Revenues Current Year"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                        name: "annualRevenues",
                                                        placeholder: "Annual Revenue",
                                                        value: investorFirm?.['annualRevenues'] || 'Not known',
                                                        className: "bg5 shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleInvestorChange(event),
                                                        children: dropdownOptions.revenues.map((revenue)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: revenue,
                                                                children: revenue
                                                            }))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Please note:"
                                                }),
                                                " completion of ALL fields counts towards your Investor Completeness Score, which influences our algorithm which determines the priority in which Diligentsia qualified leads are allocated to our investor partners."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    //********** Investor Investment Criteria - Subjective **********//
    const investmentSubjective = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "Investor Investment Criteria - Subjective",
                    ref: ref3,
                    className: "sectionWrapper fs0-75rem bg1 shadow p2rem pb3rem br5px mb3rem investor-modal-admin",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df fdc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "w200 tac c6 lh2 fs1-75rem mb2rem",
                                children: "Investor Investment Criteria - Subjective"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem investor-details-form",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1-25rem mb1rem",
                                                children: "Company Description"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "bg1 shadow br5px p1rem pr",
                                                children: [
                                                    action === 'add' || editInput === 'companyDescription' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "df tac p0rem w100 background-des",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                            name: "companyDescription",
                                                            rows: 10,
                                                            className: "c2 w100",
                                                            placeholder: "Enter Description",
                                                            defaultValue: investorFirm?.['companyDescription'] || '',
                                                            onBlur: (event)=>{
                                                                handleInvestorChange(event), setEditInput(null);
                                                            },
                                                            onChange: (event)=>handleInvestorChange(event)
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        children: [
                                                            investorFirm?.['companyDescription'],
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "edit-btn",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>setEditInput('companyDescription'),
                                                                    className: "edit-pencil",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        width: "30.72",
                                                                        height: "32.887",
                                                                        viewBox: "0 0 30.72 32.887",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            id: "Union_4",
                                                                            "data-name": "Union 4",
                                                                            d: "M.7,32.887a.68.68,0,1,1,0-1.36h28.42a.68.68,0,0,1,0,1.36ZM.269,30.463a.91.91,0,0,1-.221-.937l.16-1.28,2.26,2.25-1.26.16v.02a.911.911,0,0,1-.939-.213ZM.5,27.207l.58-4.42a.378.378,0,0,1,0-.1,2.431,2.431,0,0,0,.55.831,2.524,2.524,0,0,0,2.1.72,2.518,2.518,0,0,0,2.849,2.81,2.523,2.523,0,0,0,.71,2.13v.049a2.814,2.814,0,0,0,.83.55h-.09l-4.28.68Zm7.55,1.239-.04-.04a1.471,1.471,0,0,1,0-2.09l14.9-14.791,2,2L9.627,28.777a1.458,1.458,0,0,1-1.58-.33Zm-2.93-2.92A1.48,1.48,0,0,1,5,23.586l.149-.13L20.008,8.6l2.07,2.06L7.2,25.527a1.489,1.489,0,0,1-2.08,0Zm-2.81-2.82-.04-.041a1.489,1.489,0,0,1-.339-1.58l15.3-15.27,2,2L4.368,22.676c-.05.05-.08.111-.13.16a1.47,1.47,0,0,1-1.93-.13ZM17.924,5.065,19.791,3.2l7.693,7.693-1.867,1.867Zm2.583-2.539L22.417,.6a2,2,0,0,1,2.85,0l4.85,4.85a2,2,0,0,1,0,2.86l-1.92,1.91Z",
                                                                            transform: "translate(0)"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "tooltip-area-company-settings pa cp zi2",
                                                        "data-tooltip": "These descriptions have been generated by our<br /> AI system and are used for \u201Csoft\u201D<br /> fit analysis with our applicant company\u2019s<br /> own description, and appears in the Diligentsia<br /> \u201CFit Report\u201D, including \u201CFit Score\u201D<br /> that is circulated to both parties.<br /><br />We generate this since we have found that some<br /> investors\u2019 web sites are fairly imprecise as<br /> to what they are looking for.<br />  (Apologies if this is not you!)",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon",
                                                            "data-tooltip": "These descriptions have been generated by our<br /> AI system and are used for \u201Csoft\u201D<br /> fit analysis with our applicant company\u2019s<br /> own description, and appears in the Diligentsia<br /> \u201CFit Report\u201D, including \u201CFit Score\u201D<br /> that is circulated to both parties.<br /><br />We generate this since we have found that some<br /> investors\u2019 web sites are fairly imprecise as<br /> to what they are looking for.<br />  (Apologies if this is not you!)",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: (parcelRequire("24u8s")),
                                                                alt: "",
                                                                "data-tooltip": "These descriptions have been generated by our<br /> AI system and are used for \u201Csoft\u201D<br /> fit analysis with our applicant company\u2019s<br /> own description, and appears in the Diligentsia<br /> \u201CFit Report\u201D, including \u201CFit Score\u201D<br /> that is circulated to both parties.<br /><br />We generate this since we have found that some<br /> investors\u2019 web sites are fairly imprecise as<br /> to what they are looking for.<br />  (Apologies if this is not you!)"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1-25rem mb1rem",
                                                children: "Investment Criteria"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "bg1 shadow br5px p1rem pr",
                                                children: action === 'add' || editInput === 'investmentCriteria' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "df tac p0rem w100 background-des",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        name: "investmentCriteria",
                                                        rows: 10,
                                                        className: "c2 w100",
                                                        placeholder: "Enter Investment Criteria",
                                                        defaultValue: investorFirm?.['investmentCriteria'] || '',
                                                        onBlur: (event)=>{
                                                            handleInvestorChange(event), setEditInput(null);
                                                        },
                                                        onChange: (event)=>handleInvestorChange(event)
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        investorFirm?.['investmentCriteria'],
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "edit-btn",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>setEditInput('investmentCriteria'),
                                                                className: "edit-pencil",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "30.72",
                                                                    height: "32.887",
                                                                    viewBox: "0 0 30.72 32.887",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        id: "Union_4",
                                                                        "data-name": "Union 4",
                                                                        d: "M.7,32.887a.68.68,0,1,1,0-1.36h28.42a.68.68,0,0,1,0,1.36ZM.269,30.463a.91.91,0,0,1-.221-.937l.16-1.28,2.26,2.25-1.26.16v.02a.911.911,0,0,1-.939-.213ZM.5,27.207l.58-4.42a.378.378,0,0,1,0-.1,2.431,2.431,0,0,0,.55.831,2.524,2.524,0,0,0,2.1.72,2.518,2.518,0,0,0,2.849,2.81,2.523,2.523,0,0,0,.71,2.13v.049a2.814,2.814,0,0,0,.83.55h-.09l-4.28.68Zm7.55,1.239-.04-.04a1.471,1.471,0,0,1,0-2.09l14.9-14.791,2,2L9.627,28.777a1.458,1.458,0,0,1-1.58-.33Zm-2.93-2.92A1.48,1.48,0,0,1,5,23.586l.149-.13L20.008,8.6l2.07,2.06L7.2,25.527a1.489,1.489,0,0,1-2.08,0Zm-2.81-2.82-.04-.041a1.489,1.489,0,0,1-.339-1.58l15.3-15.27,2,2L4.368,22.676c-.05.05-.08.111-.13.16a1.47,1.47,0,0,1-1.93-.13ZM17.924,5.065,19.791,3.2l7.693,7.693-1.867,1.867Zm2.583-2.539L22.417,.6a2,2,0,0,1,2.85,0l4.85,4.85a2,2,0,0,1,0,2.86l-1.92,1.91Z",
                                                                        transform: "translate(0)"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Please note:"
                                                }),
                                                " Completion of all fields counts towards your Investor Completeness Score, which influences our algorithm which determines the priority in which Diligentsia qualified leads are allocated to our investor partners."
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    //********** Lead Contact Details **********//
    const leadContactDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "Investor Lead Contact Details",
                    ref: ref4,
                    className: "sectionWrapper fs0-75rem bg1 shadow p2rem pb3rem br5px mb3rem investor-modal-admin",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df fdc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "w200 tac c6 lh2 fs1-75rem mb2rem",
                                children: "Investor Lead Contact Details"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                onSubmit: (event)=>handleSubmit(event),
                                autoComplete: "off",
                                className: "w100 df fdc gg1rem investor-details-form",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "form-group df jsc",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-upload-area pr",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "img-box pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: investorContact?.['profile'] || (parcelRequire("cfmAr")),
                                                        alt: "Profile",
                                                        className: "profile-img w7rem h7rem advisor-profile"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "input-file",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "add-btn bg5",
                                                            onClick: ()=>{
                                                                setIsImageModal(true), setUploadType('contactImage'), setCurrentImage('');
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                viewBox: "0 0 487 487",
                                                                className: "zi3",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9 v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("lable", {
                                                        className: "ml2rem",
                                                        children: "Upload investor contact image pic here"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-75rem",
                                        children: "Diligentsia prides itself on only forwarding applicant company leads to your firm which have received Diligentsia Gold certification and scored highly on our automated \u201CFit Test\u201D.  We ask that in return for being provided good quality leads (for FREE!), that includes a Fit Report and a Diligence Report, that if you are not the correct person in your organisation to receive them, that you reallocate this contact to a suitable named alternative colleague.  Each investor receives a \u201CPrompt Response\u201D score."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "firstName",
                                                        placeholder: "Contact First Name",
                                                        value: investorContact?.['firstName'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleContactChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "lastName",
                                                        type: "text",
                                                        placeholder: "Contact Last Name",
                                                        value: investorContact?.['lastName'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleContactChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mr1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "job",
                                                        type: "text",
                                                        placeholder: "Job Title",
                                                        value: investorContact?.['job'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleContactChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr ml1rem w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "officeLocation",
                                                        type: "text",
                                                        placeholder: "Location Base e.g. London",
                                                        value: investorContact?.['officeLocation'] || '',
                                                        className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                        onChange: (event)=>handleContactChange(event)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "fs1rem mb1rem",
                                                style: {
                                                    color: '#7a7a7a'
                                                },
                                                children: "Office Telephone Number"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "text",
                                                name: "phone",
                                                placeholder: "Telephone Number",
                                                value: investorContact?.['phone'] || '',
                                                className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                onChange: (event)=>handleContactChange(event)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem mt1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 384 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                name: "email",
                                                type: "email",
                                                value: investorContact?.['email'] || '',
                                                className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                onChange: (event)=>handleContactChange(event),
                                                placeholder: "Contact\u2019s Company Email address \u2013 e.g. john.smith@investor.vc"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-75rem",
                                        children: "Please do not put generic enquiries@email address here.  Having qualified the lead, we ask that it be provided to a named individual within your organisation "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "text",
                                                name: "newPassword",
                                                placeholder: "Set/Update Contact Password",
                                                value: investorContact?.['newPassword'] || '',
                                                className: "bg5 pl4rem shadow w100 br5px p1rem",
                                                onChange: (event)=>handleContactChange(event)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 448 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M64 223.1h320c35.35 0 64 28.65 64 64v160c0 35.34-28.65 64-64 64H64c-35.35 0-64-28.66-64-64v-160C0 252.7 28.65 223.1 64 223.1z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M368 144V224h-64V144C304 99.88 268.1 64 224 64S144 99.88 144 144V224h-64V144c0-79.41 64.59-144 144-144S368 64.59 368 144z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1-25rem mb1rem",
                                                children: "Contact Bio (Provided to our qualified leads)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "bg1 shadow br5px p1rem pr",
                                                children: action === 'add' || editInput === 'bio' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "df tac p0rem w100 background-des",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        name: "bio",
                                                        rows: 10,
                                                        className: "c2 w100",
                                                        placeholder: "Enter Contact Bio",
                                                        defaultValue: investorContact?.['bio'] || '',
                                                        onBlur: (event)=>{
                                                            handleContactChange(event), setEditInput(null);
                                                        },
                                                        onChange: (event)=>handleContactChange(event)
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        investorContact?.['bio'],
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "edit-btn",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>setEditInput('bio'),
                                                                className: "edit-pencil",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "30.72",
                                                                    height: "32.887",
                                                                    viewBox: "0 0 30.72 32.887",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        id: "Union_4",
                                                                        "data-name": "Union 4",
                                                                        d: "M.7,32.887a.68.68,0,1,1,0-1.36h28.42a.68.68,0,0,1,0,1.36ZM.269,30.463a.91.91,0,0,1-.221-.937l.16-1.28,2.26,2.25-1.26.16v.02a.911.911,0,0,1-.939-.213ZM.5,27.207l.58-4.42a.378.378,0,0,1,0-.1,2.431,2.431,0,0,0,.55.831,2.524,2.524,0,0,0,2.1.72,2.518,2.518,0,0,0,2.849,2.81,2.523,2.523,0,0,0,.71,2.13v.049a2.814,2.814,0,0,0,.83.55h-.09l-4.28.68Zm7.55,1.239-.04-.04a1.471,1.471,0,0,1,0-2.09l14.9-14.791,2,2L9.627,28.777a1.458,1.458,0,0,1-1.58-.33Zm-2.93-2.92A1.48,1.48,0,0,1,5,23.586l.149-.13L20.008,8.6l2.07,2.06L7.2,25.527a1.489,1.489,0,0,1-2.08,0Zm-2.81-2.82-.04-.041a1.489,1.489,0,0,1-.339-1.58l15.3-15.27,2,2L4.368,22.676c-.05.05-.08.111-.13.16a1.47,1.47,0,0,1-1.93-.13ZM17.924,5.065,19.791,3.2l7.693,7.693-1.867,1.867Zm2.583-2.539L22.417,.6a2,2,0,0,1,2.85,0l4.85,4.85a2,2,0,0,1,0,2.86l-1.92,1.91Z",
                                                                        transform: "translate(0)"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "bg5 pl4rem shadow br5px p1rem",
                                                children: "Is Active ? (If Active it will be used during investor match)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "switch-box pa r0",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    name: "isActive",
                                                    value: "isActive",
                                                    className: "success w100",
                                                    checked: investorFirm?.['isActive'],
                                                    onChange: (event)=>handleInvestorChange(event)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "w50 shadow my1rem bg3 bg4-hover c1 td250 br5px p0-5rem fw600 cp ttu bsbb tac",
                                                type: "submit",
                                                children: action === 'add' ? 'Add Investor' : 'Update Investor'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "w50 shadow bg4 bg4-hover c1 td250 br5px p0-5rem fw600 cp ttu bsbb tac",
                                                type: "button",
                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: ''
                                                    })),
                                                children: "Back to Menu"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "td250 container w60 df",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 gg1rem mt4rem",
                    children: [
                        getOverviewContent(),
                        investorDetails(),
                        investmentCriteriaObjective(),
                        investmentSubjective(),
                        leadContactDetails()
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: isImageModal,
                onClose: ()=>setIsImageModal(false),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                setIsImageModal(false), setUploadType(''), setCurrentImage('');
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "Upload Logo"
                        }),
                        currentImage == '' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            for: "profile",
                            className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pen fs1rem fw500 tac",
                                    children: "Upload picture"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "input-btn pa t0 w100 op0 l0 cp",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: "w100 l0 h5rem cp",
                                        onChange: (e)=>handleImage(e),
                                        id: "currentImage",
                                        type: "file",
                                        accept: "image/jpeg, image/jpg, image/png"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "Max file size 5MB"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-box pr",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                ref: $fe054d9f3cf9a466$var$cropper,
                                guides: false,
                                aspectRatio: 1,
                                className: "cropper-settings",
                                src: currentImage
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>setIsImageModal(false),
                                    className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>uploadImage(),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: Object.keys(currentImage).length == 0 ? 'Upload' : 'Crop & Upload'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}









function $ffe9e51cdfaaecec$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let { onBack: onBack, setSelectedFirm: setSelectedFirm, setTab: setTab, selectedFirm: selectedFirm } = props;
    let [action, setAction] = (0, $acw62.useState)('');
    let [stages, setStages] = (0, $acw62.useState)([]);
    let [sectors, setSectors] = (0, $acw62.useState)([]);
    let [allFirms, setAllFirms] = (0, $acw62.useState)([]);
    let [auditLogs, setAuditLogs] = (0, $acw62.useState)([]);
    let [tagFilter, setTagFilter] = (0, $acw62.useState)('');
    let [showTagDropdown, setShowTagDropdown] = (0, $acw62.useState)(false);
    let [tagSearchTerm, setTagSearchTerm] = (0, $acw62.useState)('');
    let [investorId, setInvestorId] = (0, $acw62.useState)('');
    let [investorFirm, setInvestorFirm] = (0, $acw62.useState)({
        cName: '',
        logo: '',
        ukRegNo: '',
        cWebsite: '',
        cPhone: '',
        cAddress: '',
        contactEmail: '',
        description: '',
        investmentCriteria: '',
        subscription: 'Free',
        employees: {
            ukEmployees: '',
            globalEmployees: ''
        },
        preferredSectors: {
            sector1: 'Not Selected',
            sector2: 'Not Selected',
            sector3: 'Not Selected',
            sector4: 'Not Selected',
            sector5: 'Not Selected'
        },
        stageFocus: {
            stage1: 'Not Selected',
            stage2: 'Not Selected',
            stage3: 'Not Selected'
        },
        ukRegions: {},
        fundSize: 'Not known',
        sweetSpot: 'Not known',
        annualRevenues: 'Not known',
        annualProfits: 'Not known',
        investment: {
            noOfInvestments: '',
            lastInvestmentDate: ''
        },
        isValidated: false
    });
    let [investorCompleted, setInvestorCompleted] = (0, $acw62.useState)(false);
    let [profileClass, setProfileClass] = (0, $acw62.useState)('client-profile');
    (0, $acw62.useEffect)(()=>{
        getFirms();
        if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile' : 'client-profile');
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (investorCompleted) {
            getFirms();
            setInvestorCompleted(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        }
    }, [
        investorCompleted
    ]);
    const getFirms = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFirms`);
        if (response['code'] == 200 && response['body']) // response['body'] = response['body'].slice();
        setAllFirms(response['body']);
    };
    const openSummaryPopup = (firm)=>{
        setSelectedFirm(firm);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'summaryPopup'
        }));
    };
    const openInvestmentCriteriaPopup = (firm)=>{
        setSelectedFirm(firm);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'investmentCriteriaPopup'
        }));
    };
    const submitDeleteFirm = async (id, firm)=>{
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/adminAddEditInvestor`, {
            action: 'delete',
            investorId: id
        });
        if (response && response['code'] == 200) {
            await getFirms();
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        }
    };
    const openDeletePopup = async (firm)=>{
        await setSelectedFirm(firm);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'firmPopup'
        }));
    };
    const openViewFirmPopup = async (firm)=>{
        let emptyArray = [
            '',
            'not known',
            'not selected',
            'none selected',
            'nil'
        ];
        let tempSectors = [];
        if (firm['preferredSectors'] && !emptyArray.includes(firm['preferredSectors']['sector1']?.toLowerCase()) && !tempSectors.includes(firm['preferredSectors']['sector1'])) tempSectors.push(firm['preferredSectors']['sector1']);
        if (firm['preferredSectors'] && !emptyArray.includes(firm['preferredSectors']['sector2']?.toLowerCase()) && !tempSectors.includes(firm['preferredSectors']['sector2'])) tempSectors.push(firm['preferredSectors']['sector2']);
        if (firm['preferredSectors'] && !emptyArray.includes(firm['preferredSectors']['sector3']?.toLowerCase()) && !tempSectors.includes(firm['preferredSectors']['sector3'])) tempSectors.push(firm['preferredSectors']['sector3']);
        if (firm['preferredSectors'] && !emptyArray.includes(firm['preferredSectors']['sector4']?.toLowerCase()) && !tempSectors.includes(firm['preferredSectors']['sector4'])) tempSectors.push(firm['preferredSectors']['sector4']);
        if (firm['preferredSectors'] && !emptyArray.includes(firm['preferredSectors']['sector5']?.toLowerCase()) && !tempSectors.includes(firm['preferredSectors']['sector5'])) tempSectors.push(firm['preferredSectors']['sector5']);
        setSectors(tempSectors);
        let tempStages = [];
        if (firm['stageFocus'] && !emptyArray.includes(firm['stageFocus']['stage1']?.toLowerCase()) && !tempStages.includes(firm['stageFocus']['stage1'])) tempStages.push(firm['stageFocus']['stage1']);
        if (firm['stageFocus'] && !emptyArray.includes(firm['stageFocus']['stage2']?.toLowerCase()) && !tempStages.includes(firm['stageFocus']['stage2'])) tempStages.push(firm['stageFocus']['stage2']);
        if (firm['stageFocus'] && !emptyArray.includes(firm['stageFocus']['stage3']?.toLowerCase()) && !tempStages.includes(firm['stageFocus']['stage3'])) tempStages.push(firm['stageFocus']['stage3']);
        setStages(tempStages);
        await setSelectedFirm(firm);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'viewFirmPopup'
        }));
    };
    const openInvestorForm = (action, firmId, firm)=>{
        setAction(action);
        setInvestorId(firmId);
        if (firm) setInvestorFirm(firm);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'sidebar-investor'
        }));
    };
    const firmsColumns = [
        {
            id: 'cName',
            Header: 'Company Name',
            accessor: (firm)=>firm['cName'] ? firm['cName'] : '-',
            filterMethod: (filter, firm)=>{
                let cName = firm['cName'].toLowerCase();
                return cName.includes(filter.value.toLowerCase());
            }
        },
        {
            id: 'sweetSpot',
            Header: 'Investment Sweet Spot',
            accessor: (firm)=>firm['sweetSpot'] ? firm['sweetSpot'] : '-',
            filterMethod: (filter, firm)=>{
                let sweetSpot = firm['sweetSpot'].toLowerCase();
                return sweetSpot.includes(filter.value.toLowerCase());
            }
        },
        {
            id: 'isActive',
            Header: 'Active',
            accessor: (firm)=>firm['isActive'] ? 'Yes' : 'No',
            filterMethod: (filter, firm)=>{
                let isActive = firm['isActive'].toLowerCase();
                return isActive.includes(filter.value.toLowerCase());
            }
        },
        {
            id: 'view',
            Header: 'View',
            accessor: (firm)=>firm ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '5px'
                    },
                    children: [
                        firm.description && firm.description !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            style: {
                                backgroundColor: '#007bff',
                                color: '#fff',
                                padding: '3px 3px',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                Width: '92px',
                                fontSize: '13px'
                            },
                            onClick: ()=>openSummaryPopup(firm),
                            children: "Description"
                        }),
                        firm.investmentCriteria && firm.investmentCriteria !== "" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            style: {
                                backgroundColor: '#28a745',
                                color: '#fff',
                                padding: '3px 3px',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                Width: '92px',
                                fontSize: '13px'
                            },
                            onClick: ()=>openInvestmentCriteriaPopup(firm),
                            children: "Invest Criteria"
                        })
                    ]
                }) : '-'
        },
        {
            id: 'tags',
            Header: 'Tags',
            accessor: (firm)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc fww gg0-25rem",
                    children: firm['tags'] && firm['tags'].length > 0 ? firm['tags'].map((tag, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                backgroundColor: '#e0e7ff',
                                color: '#3730a3',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: '500'
                            },
                            children: tag
                        }, i)) : '-'
                }),
            sortable: false,
            width: 150
        },
        {
            id: 'actions',
            Header: 'actions',
            accessor: (firm)=>firm ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>{
                                openViewFirmPopup(firm);
                            },
                            style: {
                                backgroundColor: "transparent"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                "data-tooltip": "View Investor",
                                className: "fa fa-eye c8 cp",
                                style: {
                                    fontSize: '20px',
                                    color: "green"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>{
                                setSelectedFirm(firm);
                                openInvestorForm('edit', firm['_id'], firm);
                            },
                            style: {
                                backgroundColor: "transparent"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                "data-tooltip": "Edit Investor",
                                className: "fa fa-edit c8 cp",
                                style: {
                                    fontSize: '20px'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>openDeletePopup(firm),
                            style: {
                                backgroundColor: "transparent"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                "data-tooltip": "Delete Investor",
                                className: "fa fa-trash c9 cp",
                                style: {
                                    fontSize: '20px'
                                }
                            })
                        }),
                        firm['loginLink'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>{
                                navigator.clipboard.writeText(firm['loginLink']);
                                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Login link copied!', 'success');
                            },
                            style: {
                                backgroundColor: "transparent"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                "data-tooltip": "Copy Login Link",
                                className: "fa fa-copy cp",
                                style: {
                                    fontSize: '20px',
                                    color: "#4A67FF"
                                }
                            })
                        })
                    ]
                }) : '-'
        }
    ];
    const getAuditLogs = async (endpoint, id)=>{
        let data;
        data = {
            endpoint: endpoint,
            userId: id
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', data);
        if (res['code'] == 200) {
            await setAuditLogs(res['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'firmAuditLogs'
            }));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container df fdc",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc aic bss bw2px bo5 br10px p2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem fs2rem-sm ttu tac c4",
                            children: "BVCA Investors Database"
                        }),
                        allFirms.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                "Compiled: ",
                                new Date(allFirms[0].createdAt).toLocaleString()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb w100 aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic gg1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>openInvestorForm('add', '', {}),
                                            className: "w200px tac shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb fs0-75rem",
                                            children: "Add Investor"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>setShowTagDropdown(!showTagDropdown),
                                                    className: "cp tac br5px shadow px1rem py0-5rem fw500 df aic",
                                                    style: {
                                                        backgroundColor: tagFilter ? '#e0e7ff' : '#f3f4f6',
                                                        color: tagFilter ? '#3730a3' : '#374151',
                                                        border: tagFilter ? '1px solid #c7d2fe' : '1px solid #d1d5db'
                                                    },
                                                    children: [
                                                        "Filter by Tags",
                                                        tagFilter && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginLeft: '6px',
                                                                backgroundColor: '#3730a3',
                                                                color: 'white',
                                                                padding: '2px 6px',
                                                                borderRadius: '10px',
                                                                fontSize: '11px'
                                                            },
                                                            children: "1"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginLeft: '8px',
                                                                fontSize: '10px'
                                                            },
                                                            children: showTagDropdown ? "\u25B2" : "\u25BC"
                                                        })
                                                    ]
                                                }),
                                                showTagDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        marginTop: '8px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                                                        minWidth: '220px',
                                                        zIndex: 1000,
                                                        border: '1px solid #e5e7eb'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            style: {
                                                                padding: '12px 16px',
                                                                borderBottom: '1px solid #e5e7eb',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    style: {
                                                                        fontWeight: 600,
                                                                        color: '#374151'
                                                                    },
                                                                    children: "Filter by Tags"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        setShowTagDropdown(false);
                                                                        setTagSearchTerm('');
                                                                    },
                                                                    style: {
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        cursor: 'pointer',
                                                                        color: '#374151',
                                                                        fontSize: '16px'
                                                                    },
                                                                    children: "\u2715"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                padding: '8px 16px',
                                                                borderBottom: '1px solid #e5e7eb'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "text",
                                                                placeholder: "Search tags...",
                                                                value: tagSearchTerm,
                                                                onChange: (e)=>setTagSearchTerm(e.target.value),
                                                                style: {
                                                                    width: '100%',
                                                                    padding: '8px 12px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '6px',
                                                                    fontSize: '14px',
                                                                    outline: 'none'
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                maxHeight: '200px',
                                                                overflowY: 'auto',
                                                                padding: '8px 0'
                                                            },
                                                            children: (()=>{
                                                                const allTagsList = Array.from(new Set(allFirms.flatMap((f)=>f['tags'] || [])));
                                                                const filtered = allTagsList.filter((t)=>t.toLowerCase().includes(tagSearchTerm.toLowerCase()));
                                                                if (allTagsList.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    style: {
                                                                        padding: '16px',
                                                                        textAlign: 'center',
                                                                        color: '#9ca3af',
                                                                        fontSize: '14px'
                                                                    },
                                                                    children: "No tags available"
                                                                });
                                                                if (filtered.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    style: {
                                                                        padding: '16px',
                                                                        textAlign: 'center',
                                                                        color: '#9ca3af',
                                                                        fontSize: '14px'
                                                                    },
                                                                    children: "No tags found"
                                                                });
                                                                return filtered.map((tag, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        onClick: ()=>{
                                                                            setTagFilter(tagFilter === tag ? '' : tag);
                                                                            setShowTagDropdown(false);
                                                                            setTagSearchTerm('');
                                                                        },
                                                                        style: {
                                                                            padding: '8px 16px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            cursor: 'pointer',
                                                                            backgroundColor: tagFilter === tag ? '#f0f9ff' : 'transparent'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                style: {
                                                                                    width: '18px',
                                                                                    height: '18px',
                                                                                    borderRadius: '4px',
                                                                                    border: `2px solid ${tagFilter === tag ? '#3b82f6' : '#d1d5db'}`,
                                                                                    backgroundColor: tagFilter === tag ? '#3b82f6' : 'transparent',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginRight: '12px'
                                                                                },
                                                                                children: tagFilter === tag && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    style: {
                                                                                        color: 'white',
                                                                                        fontSize: '12px',
                                                                                        fontWeight: 'bold',
                                                                                        lineHeight: 1
                                                                                    },
                                                                                    children: "\u2713"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    color: '#374151',
                                                                                    fontSize: '14px'
                                                                                },
                                                                                children: tag
                                                                            })
                                                                        ]
                                                                    }, i));
                                                            })()
                                                        }),
                                                        tagFilter && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                padding: '8px 16px',
                                                                borderTop: '1px solid #e5e7eb'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>{
                                                                    setTagFilter('');
                                                                    setTagSearchTerm('');
                                                                },
                                                                style: {
                                                                    width: '100%',
                                                                    padding: '8px',
                                                                    backgroundColor: '#fee2e2',
                                                                    color: '#dc2626',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '13px',
                                                                    fontWeight: 500
                                                                },
                                                                children: "Clear Filters"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>getAuditLogs(`/company/addEditDeleteInvestor`, user['_id']),
                                    className: "w200px tac shadow bg3 bg4-hover c1 td250 br5px py0-5rem fs0-75rem fw600 cp ttu bsbb tac",
                                    children: "Audit Log"
                                })
                            ]
                        }),
                        allFirms && allFirms.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "admin-table mt1rem w100 ttc tac bg1 p2rem br10px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                minRows: 20,
                                className: "table",
                                data: tagFilter ? allFirms.filter((f)=>f['tags'] && f['tags'].includes(tagFilter)) : allFirms,
                                resolveData: (company)=>company.map((row)=>row),
                                columns: firmsColumns,
                                filterable: true
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "No BVCA Investor added in the Database"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'sidebar-investor',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic sidebar-investor",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dba6b402693f5d6$export$2e2bcd8739ae039), {
                    direction: "left",
                    in: modal['open'] == 'sidebar-investor',
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya w100 bsbb df fdc m1rem br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        style: {
                                            position: 'relative',
                                            top: '4px'
                                        },
                                        className: "pen f1 h1rem mr1rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 448 512",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-primary pen",
                                                d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-secondary pen",
                                                d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                            })
                                        ]
                                    }),
                                    "Back to Menu"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe054d9f3cf9a466$export$2e2bcd8739ae039), {
                                    setInvestorCompleted: setInvestorCompleted,
                                    action: action,
                                    investorId: investorId,
                                    investorFirm: investorFirm,
                                    setInvestorFirm: setInvestorFirm,
                                    onBack: onBack
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'firmAuditLogs',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac ttu",
                            children: "Audit Logs"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of VC Firms"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: auditLogs && auditLogs.length > 0 ? auditLogs.map((log)=>{
                                return log['message'] != 'Firm found!' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df my0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem ${profileClass}`,
                                            "data-tooltip": log?.['userId']?.['firstName'] ? log?.['userId']?.['firstName'] + " " + log?.['userId']?.['lastName'] : "Register to show your name here",
                                            children: [
                                                log?.['userId']?.['firstName'][0] || "?",
                                                " ",
                                                log?.['userId']?.['lastName'][0] || "?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem ml1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: log['message']
                                                        }),
                                                        " at ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: new Date(log.timestamp).toLocaleString()
                                                        }),
                                                        " by ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                            children: [
                                                                log?.['userId']?.['firstName'],
                                                                " ",
                                                                log?.['userId']?.['lastName']
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                log['payload'] && log['message'] != 'Firm found!' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "df fw500 fs1rem ttc",
                                                            children: [
                                                                "Firm ",
                                                                log['payload']['action'],
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "df fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "fw500 mr0-5rem",
                                                                    children: "Name : "
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['cName'] ? log?.['payload']?.['cName'] : log['payload']?.['investorData']?.['cName'] ? log['payload']?.['investorData']?.['cName'] : '-'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "df fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "fw500 mr0-5rem",
                                                                    children: "Email : "
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['cEmail'] ? log['payload']?.['cEmail'] : log['payload']?.['investorData']?.['contactEmail'] ? log['payload']?.['investorData']?.['contactEmail'] : '-'
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "df fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "fw500 mr0-5rem",
                                                                    children: "Address : "
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['cAddress'] ? log['payload']?.['cAddress'] : log['payload']?.['investorData']?.['cAddress'] ? log['payload']?.['investorData']?.['cAddress'] : '-'
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "text-gradient fs1-75rem ttu w100 tac mb1rem",
                                children: "No Logs Found!"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'firmPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                            children: "Delete Investor "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem",
                                    children: [
                                        "Are you sure you want to delete the investor (",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: selectedFirm?.['cName']
                                        }),
                                        ")?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>submitDeleteFirm(selectedFirm._id, selectedFirm),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic",
                                    children: "Delete"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'viewFirmPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                            children: "Investor Details"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Name:"
                                            }),
                                            " ",
                                            selectedFirm?.['cName'].toUpperCase(),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "UK House No:"
                                            }),
                                            " ",
                                            selectedFirm?.['ukRegNo'] && selectedFirm?.['ukRegNo'] !== '' ? selectedFirm?.['ukRegNo'] : '--',
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Website:"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                className: "cp c3 tdu",
                                                target: "_blank",
                                                href: selectedFirm?.['cWebsite'],
                                                children: selectedFirm?.['cWebsite']
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Phone No:"
                                            }),
                                            " ",
                                            selectedFirm?.['cPhone'] && selectedFirm?.['cPhone'] !== '' ? selectedFirm?.['cPhone'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Address:"
                                            }),
                                            " ",
                                            selectedFirm?.['cAddress'],
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Contact Email:"
                                            }),
                                            " ",
                                            selectedFirm?.['contactEmail'] ? selectedFirm?.['contactEmail'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Number of UK Employees:"
                                            }),
                                            " ",
                                            selectedFirm?.['employees']?.['ukEmployees'] && selectedFirm?.['employees']?.['ukEmployees'] !== '' ? selectedFirm?.['employees']?.['ukEmployees'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Number of Global Employees:"
                                            }),
                                            " ",
                                            selectedFirm?.['employees']?.['globalEmployees'] && selectedFirm?.['employees']?.['globalEmployees'] !== '' ? selectedFirm?.['employees']?.['globalEmployees'] : '--',
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Preferred Sectors:"
                                            }),
                                            " ",
                                            sectors.length > 0 ? sectors.join(', ') : '--',
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Stage Focus:"
                                            }),
                                            " ",
                                            stages.length > 0 ? stages.join(', ') : '--',
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Sweet Spot:"
                                            }),
                                            " ",
                                            selectedFirm?.['sweetSpot'] ? selectedFirm?.['sweetSpot'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Funds Available:"
                                            }),
                                            " ",
                                            selectedFirm?.['fundSize'] ? selectedFirm?.['fundSize'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Annual Revenue:"
                                            }),
                                            " ",
                                            selectedFirm?.['annualRevenues'] ? selectedFirm?.['annualRevenues'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Annual Profit:"
                                            }),
                                            " ",
                                            selectedFirm?.['annualProfits'] ? selectedFirm?.['annualProfits'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Number of Investments Made:"
                                            }),
                                            " ",
                                            selectedFirm?.['investment']?.['noOfInvestments'] && selectedFirm?.['investment']?.['noOfInvestments'] !== '' ? selectedFirm?.['investment']?.['noOfInvestments'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Date of Last Investment:"
                                            }),
                                            " ",
                                            selectedFirm?.['investment']?.['lastInvestmentDate'] && selectedFirm?.['investment']?.['lastInvestmentDate'] !== '' ? selectedFirm?.['investment']?.['lastInvestmentDate'] : "--",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Description:"
                                            }),
                                            " ",
                                            selectedFirm?.['description'] && selectedFirm?.['description'] !== '' ? selectedFirm?.['description'] : "--",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] === 'summaryPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                            children: "Investor Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shadow bg1 br5px p1rem dg gg0-5rem mb1rem background-des",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Firm Name:"
                                            }),
                                            " ",
                                            selectedFirm?.['cName'].toUpperCase(),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Description:"
                                            }),
                                            " ",
                                            selectedFirm?.['description'] ? selectedFirm?.['description'] : "--",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] === 'investmentCriteriaPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                            children: "Investor Investment Criteria"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shadow bg1 br5px p1rem dg gg0-5rem mb1rem background-des",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Firm Name:"
                                            }),
                                            " ",
                                            selectedFirm?.['cName'].toUpperCase(),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Investment Criteria:"
                                            }),
                                            " ",
                                            selectedFirm?.['investmentCriteria'] ? selectedFirm?.['investmentCriteria'] : "--",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");
function $84548291bce9e0c3$export$2e2bcd8739ae039(props) {
    const { onBack: onBack } = props;
    const [auditTestLogs, setAuditTestLogs] = (0, $acw62.useState)([]);
    const [selectedLog, setSelectedLog] = (0, $acw62.useState)();
    const fetch = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/audit/audittestlogs`);
        console.log("res: ", res['body']);
        if (res?.code === 200) setAuditTestLogs(res['body']);
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const selectCurrentAuditLog = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (!selectedLog) return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/audit/selectaudit`, {
            auditTestLogId: selectedLog._id
        });
        if (!res || res['code'] != 200) return;
        // await fetch();
        let currentLogs = auditTestLogs;
        for (const currentLog of currentLogs){
            currentLog.isSelected = false;
            if (currentLog['_id'] == selectedLog['_id']) currentLog.isSelected = true;
        }
        setAuditTestLogs(currentLogs);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - AI Test History"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: ()=>{
                        selectedLog ? setSelectedLog(null) : onBack();
                    },
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                !selectedLog ? auditTestLogs.map((auditTestLog, logIndex)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "shadow mt1rem py1rem px2rem br5px cp bss bw2px bo5 " + (auditTestLog.isSelected ? "bg7" : "bg1"),
                        onClick: ()=>{
                            setSelectedLog(auditTestLog);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "usn pen fs1-5rem",
                            children: [
                                "Tested by ",
                                auditTestLog?.['tester']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ass mx0-5rem br100 w2rem h2rem",
                                    src: auditTestLog?.['tester']?.['profile']
                                }),
                                " ",
                                auditTestLog?.['tester']?.['firstName'],
                                ",\xa0\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(auditTestLog['createdAt']).format('lll'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                auditTestLog.intro,
                                " [COPMANY] ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                auditTestLog.instruction.substr(0, 100) + "  ... "
                            ]
                        })
                    });
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "fs1rem bss bw2px bo5 br10px p1rem jcsb",
                    children: [
                        selectedLog.questions.map((question, questionIndex)=>{
                            const risk = selectedLog.risks[questionIndex];
                            const recommendation = selectedLog.recommendations[questionIndex];
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "op20 pen dg gtcr2-lg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fw500 fs1rem",
                                                children: question
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df jcsb",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs1rem ",
                                                children: [
                                                    "Risk : ",
                                                    risk,
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Recommendation : ",
                                                    recommendation,
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                                ]
                                            })
                                        })
                                    })
                                ]
                            });
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fs1rem ",
                                    children: [
                                        "Company Name : ",
                                        selectedLog.companyName,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "Company Description : ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.companyDescription
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "Intro : ",
                                        selectedLog.intro,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "Instructions : ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.instruction
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>selectCurrentAuditLog(),
                                className: "bg4 c6 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic",
                                children: selectedLog.isSelected ? 'This instruction is currently used' : 'Go Live this instruction'
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








function $ecdc1bc084089079$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { onBack: onBack } = props;
    const [answers, setAnswers] = (0, $acw62.useState)([]);
    const [companyURL, setCompanyURL] = (0, $acw62.useState)('');
    const [companyName, setCompanyName] = (0, $acw62.useState)('');
    const defaultCompanyURL = "https://www.rolls-royce.com/";
    const defaultCompanyName = "ROLLS-ROYCE HOLDINGS PLC";
    const defaultInstruction = `This is company name and website. Please provide a summary of a minimum of 200 words for the business activities of this company. Please focus on describing what it does in terms of goods or services provided; please do not include Companies House information; if it is a regulated entity it would be useful to identify which regulator; please try to ignore including fluffy marketing adjectives in your answer - we want to focus on understanding what the company actually does as its main business activity, its business model etc. Reply only with the summary and nothing else. Do not add links to sources. Please start your answer with 'the company...'. Please provide answers only instead of asking followup questions and return response in plain text. Please ensure your answer contains a minimum of 200 words.`;
    // `Please provide a summary of a minimum of 200 word for the business activities of a company, ${newCompanyName} whose web site is ${newCompany['cWebsite'].replace(/'/g, "\\'")} also please search the internet to get additional information about ${newCompanyName}. Please focus on describing what it does in terms of goods or services provided; please do not include Companies House information; if it is a regulated entity it would be useful to identify which regulator; please try to ignore including fluffy marketing adjectives in your answer - we want to focus on understanding what the company actually does as its main business activity, its business model etc. ${newCompany['fiveWords'] && `We have been provided a further up to five words to describe the company - these are ${newCompany['fiveWords'].replace(/'/g, "\\'")}.`} Reply only with the summary and nothing else. Do not add links to sources. Please start your answer with 'the company...'. Please provide answers only instead of asking followup questions and return response in plain text. Please ensure your answer contains a minimum of 200 words.`
    const [instructions, setInstructions] = (0, $acw62.useState)("");
    const [aiResp, setAiResp] = (0, $acw62.useState)({});
    const [thwId, setTHWId] = (0, $acw62.useState)("");
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/getCurrentTHWordInfo`);
            if (res?.code === 200) {
                console.log("res", res.body);
                if (res.body) {
                    setTHWId(res.body['_id']);
                    setInstructions(res.body['instructions']);
                    setCompanyURL(res.body['companyURL']);
                    setCompanyName(res.body['companyName']);
                    setAiResp(res.body['companyDescription']);
                } else {
                    setInstructions(defaultInstruction);
                    setCompanyURL(defaultCompanyURL);
                    setCompanyName(defaultCompanyName);
                    setAiResp("");
                }
            }
        };
        fetch();
    }, []);
    const getAIResponse = async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'TwoHundredsWords'
        }));
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/testTwoHundredWords`, {
            instructions: instructions,
            companyName: companyName,
            companyURL: companyURL
        });
        if (!res || res['code'] != 200) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            return;
        }
        let { aiResponse: aiResponse, id: id } = res['body'];
        console.log(":aiResponse: ", aiResponse);
        setTHWId(id);
        setAiResp(aiResponse);
        setRefresh(!refresh);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const selectTH = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (thwId == "") return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectTwoHundredWords`, {
            thwId: thwId
        });
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - 200 Words Test",
                    subheading: "200 words"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: onBack,
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg1rem mx1rem p1rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "usn pen fs1-25rem fw600",
                            children: "AI 200 Words Test"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setCompanyName(e.target.value),
                                    defaultValue: companyName,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company URL"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setCompanyURL(e.target.value),
                                    defaultValue: companyURL,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Instructions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setInstructions(e.target.value),
                                    defaultValue: instructions,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "AI Response"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    defaultValue: aiResp,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>getAIResponse(),
                                    className: "bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic mr1rem",
                                    children: "Ask ChatGPT"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>selectTH(),
                                    className: "bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic",
                                    children: "Go Live"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'TwoHundredsWords',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                                children: "PRO"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: companyName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                children: "Diligentsia Admin 200 Words Test"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            "\uD83D\uDD2E ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "200 Words Testing Magic:"
                                            }),
                                            " We're now summoning the power of AI to get 200 words about this company! ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Please stay with us during this magical incantation\u2026"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h9rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








function $26f9cd65f3c9984a$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const defaultFileNames = `CFO Job Description V2 2022.docx, Consultancy Agreement - FINAL - MB Signed 24.01.21.docx, \
	Consultancy Agreement - Final Redline MB edits 24.01.21.docx, Consultancy Agreement - Final Redline MB Signed 24.01.21.docx, \
	Consultancy Agreement - MB edits 14.01.21.docx, Consultancy Agreement - redline.docx, Electric Rider_Investor_Deck (1).pdf, \
	Electric  Rider_Investor_Deck (1).pptx, Electric  Rider_Investor_Deck MB.pptx, Electric Rider - MB Chairman  Consultancy Agreement - draft 1 - 14.12.21 (1).docx, \
	Electric Rider - MB Chairman  Consultancy Agreement - draft 1 - 14.12.21 (2).docx, Electric Rider - MB Chairman  Consultancy Agreement - draft 1 - 14.12.21.docx, \
	Electric Rider - MB Chairman Consultancy Agreement - draft 1 - 14.12.21.docx, Electric Rider - MB Chairman Consultancy Agreement - draft 2 - 23.12.21.docx, \
	Electric Rider Logo .png, ER CD Terms - MB Suggested Edits 25.01.22.docx, ER MC Propoded Terms - 25.01.22.docx, \
	ERCDtermsv2210122 - MB proposed Edits.docx, EV Product Manager Job Description V1 2022.docx, EV Product Manager Job Description V2 2022.docx, \
	Growthink Capabilities, Electric Rider.pdf, MarkedAmendedSettlementAgreementMB10Jan-V1 (1).doc, MB - Consultancy Agreement -  (HJS 13.01.22) (1).pdf, \
	MB - Consultancy Agreement -  (HJS 13.01.22).pdf, MB Electric Rider Proposal V1 09.12.21.docx, MB Slides.pptx, \
	MB Subscription &  Option Agreement FINAL - MB Signed 24.01.21.docx, MB Subscription & Buyback Agreement - draft 1 - 14.12.21.doc, \
	MB Subscription & Buyback Agreement - draft 2 - 23.12.21.doc, MB Subscription & Option  Agreement (HJS 13.01.22) (1).pdf, \
	MB Subscription & Option  Agreement (HJS 13.01.22) (2).pdf, MB Subscription & Option  Agreement (HJS 13.01.22).pdf, \
	MB Subscription & Option Agreement MB Edits 14.01.21.docx, NED Job Description V2 2022.docx, Passport Letter 11.12.21.docx, \
	Platform Manager Job Description 2022.docx, Platform Manager Job Description V1 2022.docx, Proposed Agreements & Side Letter - CD 26.01.2022.docx, \
	Proposed Agreements & Side Letter - MC 26.01.2022.docx, Screenshot Motorpoint 1.png, ServiceAgreement - MC 25.01.2022.docx, \
	Subscription Agreement Redline - MB Edits14.01.21.docx, Subscription Agreement Redline 14.01.21.docx, teamsp-2.webp, Teamsport2.jfif, \
	Teamsport3.jfif, Teamsport4.png, Teamsport5.png`;
    const defaultInstruction = `Identify duplicated files based on filenames excluding extension. Generate the output in JSON data. The key is summarized filename and value is array of duplicated files.`;
    const { onBack: onBack } = props;
    const [answers, setAnswers] = (0, $acw62.useState)([]);
    const [fileNames, setFileNames] = (0, $acw62.useState)('');
    const [instructions, setInstructions] = (0, $acw62.useState)('');
    const [companyName, setCompanyName] = (0, $acw62.useState)("ASTRAZENECA PLC");
    const [description, setDescription] = (0, $acw62.useState)(`The company AstraZeneca PLC is a global biopharmaceutical company that discovers, develops, and commercializes prescription medicines for a wide range of therapy areas, including oncology, cardiovascular, renal and metabolic diseases, infection, respiratory, and rare diseases.**
	AstraZeneca's business model is based on the research and development of innovative new medicines, which it then sells through its own commercial organization and through partners. The company is regulated by a number of different authorities, including the UK Medicines and Healthcare products Regulatory Agency (MHRA) and the US Food and Drug Administration (FDA).
	**AstraZeneca's main business activity is the development and commercialization of prescription medicines.** The company has a portfolio of over 50 marketed medicines, and a pipeline of over 100 new drugs in development. AstraZeneca's medicines are used to treat a wide range of diseases, including cancer, heart disease, stroke, diabetes, asthma, and arthritis.
	**AstraZeneca's business model is based on the following key activities:**
	* **Research and development:** AstraZeneca invests heavily in research and development, with the aim of discovering new medicines that can improve the lives of patients. The company has a global network of research and development centers, and employs over 16,000 scientists and researchers.
	* **Manufacturing:** AstraZeneca manufactures its own medicines at its own facilities around the world. The company also has a number of partnerships with other manufacturers.
	* **Commercialization:** AstraZeneca sells its medicines through its own commercial organization and through partners. The company has a global sales and marketing team, and operates in over 100 countries.
	**AstraZeneca is a major player in the global pharmaceutical industry. The company's medicines are used by millions of people around the world. AstraZeneca is committed to developing new medicines that can improve the lives of patients and transform the future of healthcare.**`);
    const [aiResp, setAiResp] = (0, $acw62.useState)([]);
    const [deDuperId, setDeduperId] = (0, $acw62.useState)("");
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/currentDeduperInfo`);
            if (res?.code === 200) {
                let fileNames = res.body['fileNames'];
                let instructions = res.body['instructions'];
                let companyName = res.body['companyName'];
                let companyDescription = res.body['companyDescription'];
                let response = res.body['response'];
                let id = res.body['_id'];
                if (id) setDeduperId(id);
                if (fileNames) setFileNames(fileNames);
                else setFileNames(defaultFileNames);
                if (instructions) setInstructions(instructions);
                else setInstructions(defaultInstruction);
                companyName && setCompanyName(companyName);
                companyDescription && setDescription(companyDescription);
                response && setAiResp(response);
            }
        };
        fetch();
    }, []);
    const getAiResponseString = ()=>{
        if (!aiResp || aiResp.length == 0) return "";
        let stringResult = "";
        for (const dup of aiResp)if (Array.isArray(dup)) {
            stringResult += "- " + dup.join(", ");
            stringResult += "\n";
        }
        return stringResult;
    };
    const getAIResponse = async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'checkingDuplication'
        }));
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/testDeduper`, {
            fileNames: fileNames,
            instructions: instructions,
            companyName: companyName,
            description: description
        });
        if (!res || res['code'] != 200) return;
        let { aiResponse: aiResponse, id: id } = res['body'];
        setDeduperId(id);
        setAiResp(aiResponse);
        setRefresh(!refresh);
        if (!aiResponse) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("No duplicated files");
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const selectDeduper = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (deDuperId == "") return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectDeduper`, {
            deDuperId: deDuperId
        });
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - AI Test",
                    subheading: "DeDuper"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: onBack,
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg1rem mx1rem p1rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "usn pen fs1-25rem fw600",
                            children: "Ai Deduper Test"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setCompanyName(e.target.value),
                                    defaultValue: companyName,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setDescription(e.target.value),
                                    defaultValue: description,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Filenames"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setFileNames(e.target.value),
                                    defaultValue: fileNames,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Instructions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setInstructions(e.target.value),
                                    defaultValue: instructions,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "AI Response"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    defaultValue: getAiResponseString(aiResp),
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>getAIResponse(),
                                    className: `bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic mr1rem ${fileNames == "" || instructions == "" ? "c12 disabled" : "c6"}`,
                                    children: "Ask ChatGPT"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>selectDeduper(),
                                    className: `bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic ${deDuperId == "" ? "disabled c12" : "c6"}`,
                                    children: "Go Live"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'checkingDuplication',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                                children: "PRO"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: companyName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                children: "Diligentsia Admin Deduper Assistant"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            "\uD83D\uDD2E ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Deduper Magic:"
                                            }),
                                            " We're now summoning the power of AI to checking duplication of files! ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Please stay with us during this magical incantation\u2026"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h9rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");

function $c95d9ffe511f19d2$export$2e2bcd8739ae039(props) {
    const { onBack: onBack } = props;
    const [checklistTestLogs, setChecklistTestLogs] = (0, $acw62.useState)([]);
    const [selectedLog, setSelectedLog] = (0, $acw62.useState)();
    const [tData, setTData] = (0, $acw62.useState)([]);
    //     {
    //         no: "S001",
    //         questions: "T collaborations with industry experts for innovation?	",
    //         space: "",
    //         risk: "Lack of external input can limit innovation.",
    //         recommendation: "Establish a dedicated product development team.",
    //     },
    const tColumns = [
        {
            Header: 'Section',
            accessor: 'section',
            minWidth: 100,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'No',
            accessor: 'no',
            width: 80
        },
        {
            Header: 'Questions',
            accessor: 'questions',
            minWidth: 200,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'Space for Answer',
            accessor: 'space',
            width: 50,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'Risk/Rationale',
            accessor: 'risk',
            minWidth: 200,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'Recommendation',
            accessor: 'recommendation',
            minWidth: 200,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        }
    ];
    const parseData = (text)=>{
        const lines = text.split('\n');
        const data = [];
        let currentSection = '';
        let sectionNo = 0;
        let showSection = true;
        lines.forEach((line)=>{
            if (line.startsWith('**Section') || line.startsWith('Section')) {
                // currentSection = line.replace('**', '').trim();
                currentSection = line.split(':')[1].replace('**', '').trim();
                sectionNo++;
                showSection = true;
            } else if (line.startsWith('|') && !line.startsWith('| ---') && !line.startsWith('| No')) {
                const [, no, questions, space, risk, recommendation] = line.split('|').map((item)=>item.trim());
                data.push({
                    section: showSection ? `S${padNumber(sectionNo, 3)}. ` + currentSection : "",
                    no: `S${padNumber(sectionNo, 3)}.${no}`,
                    questions: questions,
                    space: space,
                    risk: risk !== "-" ? risk : "",
                    recommendation: recommendation !== "-" ? recommendation : ""
                });
                showSection = false;
            }
        });
        setTData(data);
    };
    const fetch = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/getChecklistLogs`);
        console.log(res);
        if (res?.code === 200) setChecklistTestLogs(res['body']);
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const padNumber = (num, size)=>String(num).padStart(size, '0');
    const processResponse = (response)=>{
        const data = JSON.parse(response);
        let formattedString = '';
        data.module.forEach((section, sectionIndex)=>{
            const sectionNumber = padNumber(sectionIndex + 1, 3);
            formattedString += `S${sectionNumber}. "${section.sectionName}"\n`;
            section.questions.forEach((q, questionIndex)=>{
                formattedString += `S${sectionNumber}.${questionIndex + 1}: "${q.question}"\n`;
            });
            formattedString += '\n'; // Add an extra newline between sections
        });
        // setAiResp(formattedString);
        return formattedString;
    };
    const getAiResponseString = (aiResp)=>{
        if (!aiResp || aiResp.length == 0) return "";
        let stringResult = "";
        for (const dup of aiResp)if (Array.isArray(dup)) stringResult += "<p>- " + dup.join(", ") + "</p>";
        return stringResult;
    };
    const selectCurrentChecklistLog = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (!selectedLog) return;
        if (selectedLog.isSelected) return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectChecklists`, {
            chId: selectedLog['_id']
        });
        if (!res || res['code'] != 200) return;
        let currentLogs = checklistTestLogs;
        for (const currentLog of currentLogs){
            currentLog.isSelected = false;
            if (currentLog['_id'] == selectedLog['_id']) currentLog.isSelected = true;
        }
        setChecklistTestLogs(currentLogs);
        // parseData(currentLogs.checklistDescription);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - Ai Checklist Module Test History"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: ()=>{
                        selectedLog ? setSelectedLog(null) : onBack();
                    },
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                !selectedLog ? checklistTestLogs.map((checklistTestLog, logIndex)=>{
                    console.log("checklistTestLog; ", checklistTestLog);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `shadow mt1rem py1rem px2rem br5px cp bss bw2px bo5 ${checklistTestLog.isSelected ? "bg7" : "bg1"}`,
                        onClick: ()=>{
                            setSelectedLog(checklistTestLog);
                            parseData(checklistTestLog.checklistDescription);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "usn pen fs1-5rem",
                            children: [
                                "Tested by ",
                                checklistTestLog?.['tester']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ass mx0-5rem br100 w2rem h2rem",
                                    src: checklistTestLog?.['tester']?.['profile']
                                }),
                                " ",
                                checklistTestLog?.['tester']?.['firstName'],
                                ",\xa0\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(checklistTestLog['createdAt']).format('lll'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Instructions:"
                                }),
                                " ",
                                checklistTestLog.instructions.substr(0, 100) + "  ... "
                            ]
                        })
                    });
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "fs1rem bss bw2px bo5 br10px p1rem jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fs1rem ",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Name :"
                                        }),
                                        " ",
                                        selectedLog.moduleName,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Description :"
                                        }),
                                        " ",
                                        selectedLog.moduleDescription,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Instructions :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.instructions
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Answers :"
                                        }),
                                        tData && tData.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                            data: tData,
                                            columns: tColumns,
                                            defaultPageSize: 10,
                                            className: "-striped -highlight"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>selectCurrentChecklistLog(),
                                className: `c6 br5px px1rem py0-5rem fw600 fs1-25rem bsbb tac df jcc aic ${selectedLog.isSelected ? "bg7" : "cp bg4"}`,
                                children: selectedLog.isSelected ? 'This instruction is currently used' : 'Go Live this instruction'
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");












function $c9adf80c2d079327$export$2e2bcd8739ae039(props) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { onEdit: onEdit, selectedModule: selectedModule, onBack: onBack } = props;
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state['modal']);
    const [sections, setSections] = (0, $acw62.useState)([]);
    const [option, setOption] = (0, $acw62.useState)("Empty");
    const [questions, setQuestions] = (0, $acw62.useState)([]);
    const [getDone, setDoneSignal] = (0, $acw62.useState)(false);
    const [addOption, setAddOption] = (0, $acw62.useState)("Growth Ready");
    const [creatingSectionOption, setCreatingSectionOption] = (0, $acw62.useState)("Manually");
    const [module, setModule] = (0, $acw62.useState)(null);
    let [moduleKey, setModuleKey] = (0, $acw62.useState)();
    let [moduleName, setModuleName] = (0, $acw62.useState)();
    let [deleteFile, setDeleteFile] = (0, $acw62.useState)();
    let [moduleCreator, setModuleCreator] = (0, $acw62.useState)();
    let [moduleDescription, setModuleDescription] = (0, $acw62.useState)();
    let [deleteFileQuestionId, setDeleteFileQuestionId] = (0, $acw62.useState)();
    let [additionalSections, setAdditionalSections] = (0, $acw62.useState)([
        '',
        ''
    ]);
    let [moduleId, setModuleId] = (0, $acw62.useState)();
    // Add refs to prevent multiple simultaneous calls
    const isLoadingModuleInfo = (0, $acw62.useRef)(false);
    const hasModuleInfoLoaded = (0, $acw62.useRef)(false);
    // Memoize the initial module ID to prevent excessive URL hash reading
    const initialModuleId = (0, $acw62.useMemo)(()=>{
        const hashId = new URL(window.location)?.hash?.split('#')[1];
        return hashId || selectedModule?._id || selectedModule;
    }, [
        selectedModule
    ]);
    // Initialize moduleId only once
    (0, $acw62.useEffect)(()=>{
        if (initialModuleId) setModuleId(initialModuleId);
    }, [
        initialModuleId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (onEdit) onNextToCreator();
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'selectchecklistmodal'
        }));
    }, [
        onEdit
    ]); // Add onEdit as dependency to prevent unnecessary calls
    const confirmDeleteFile = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteTemplate', {
            file: deleteFile,
            questionId: deleteFileQuestionId
        });
        if (!res || res['code'] != 200) return;
        await getQuestions();
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const getQuestions = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/getNewMouduleQuestions`, {
            moduleName: moduleName,
            moduleId: moduleId
        });
        if (res['code'] === 200) setQuestions(res['body']);
        return res['body'];
    };
    const [price, setPrice] = (0, $acw62.useState)('Free');
    const [isPaid, setIsPaid] = (0, $acw62.useState)(false);
    const [stripeProductId, setStripeProductId] = (0, $acw62.useState)('');
    const [isModuleKeyManuallyEdited, setIsModuleKeyManuallyEdited] = (0, $acw62.useState)(false);
    // Function to generate module key from module name
    const generateModuleKey = (name)=>{
        if (!name || name.trim() === '') return '';
        return name.trim().replace(/[^a-zA-Z0-9\s]/g, '').split(/\s+/).map((word)=>word.charAt(0).toUpperCase()).join('');
    };
    // Debounced function to auto-generate module key
    const autoGenerateModuleKey = (0, $acw62.useCallback)((name)=>{
        if (!isModuleKeyManuallyEdited) {
            const generatedKey = generateModuleKey(name);
            setModuleKey(generatedKey);
        }
    }, [
        isModuleKeyManuallyEdited
    ]);
    // Debounce the auto-generation to prevent excessive updates
    (0, $acw62.useEffect)(()=>{
        if (!moduleName || isModuleKeyManuallyEdited) return;
        const timer = setTimeout(()=>{
            autoGenerateModuleKey(moduleName);
        }, 300); // 300ms debounce
        return ()=>clearTimeout(timer);
    }, [
        moduleName,
        isModuleKeyManuallyEdited,
        autoGenerateModuleKey
    ]);
    const handlePriceChange = (price_t)=>{
        setPrice(price_t);
    };
    const handleIsPaidChange = (checked)=>{
        setIsPaid(checked);
        if (!checked) {
            setPrice('Free'); // Auto-set to Free when isPaid is false
            setStripeProductId(''); // Clear stripe product ID
        } else // Set a default paid price when switching to paid mode
        if (price === 'Free') setPrice("\xa399"); // Default to first paid option
    };
    // Handler for module name changes
    const handleModuleNameChange = (value)=>{
        setModuleName(value);
    // Auto-generation will be handled by useEffect with debouncing
    };
    // Handler for module key changes (manual editing)
    const handleModuleKeyChange = (value)=>{
        setModuleKey(value);
        setIsModuleKeyManuallyEdited(true); // Mark as manually edited
    };
    const onOptionChange = (e)=>{
        setOption(e['target']['value']);
    };
    const onAddOptionChange = (e)=>{
        setAddOption(e['target']['value']);
    };
    const onCreatingSectionOption = (e)=>{
        setCreatingSectionOption(e['target']['value']);
    };
    function editSectionName(strVal, index) {
        let newArray = [
            ...additionalSections
        ];
        newArray[index] = strVal;
        setAdditionalSections(newArray);
    }
    // Optimize getmoduleinfo to prevent excessive calls
    const getmoduleinfo = (0, $acw62.useCallback)(async ()=>{
        // Prevent multiple simultaneous calls
        if (isLoadingModuleInfo.current) {
            console.log('getmoduleinfo already in progress, skipping...');
            return hasModuleInfoLoaded.current;
        }
        // Use the current moduleId state or fallback to selectedModule
        let currentModuleId = moduleId;
        if (!currentModuleId && selectedModule) currentModuleId = selectedModule._id || selectedModule;
        // If still no moduleId, try URL hash as last resort
        if (!currentModuleId) currentModuleId = new URL(window.location)?.hash?.split('#')[1];
        // Check if moduleId exists
        if (!currentModuleId || currentModuleId === '') return false;
        // Set loading state
        isLoadingModuleInfo.current = true;
        try {
            console.log('Calling getModuleInfo API with moduleId:', currentModuleId);
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/getModuleInfo`, {
                moduleId: currentModuleId
            });
            if (res?.code === 200 && res?.body && typeof res.body === 'object' && !Array.isArray(res.body)) {
                // Check if we got actual module data (not empty array)
                setModule(res['body']);
                if (res.body._id) {
                    setModuleId(res['body']['_id']);
                    if (res['body']['moduleKey']) {
                        setModuleKey(res['body']['moduleKey']);
                        setIsModuleKeyManuallyEdited(false);
                    } else {
                        setModuleKey('');
                        setIsModuleKeyManuallyEdited(false);
                    }
                    setModuleName(res['body']['moduleName']);
                    setModuleCreator(res['body']['moduleCreator']);
                    setModuleDescription(res['body']['moduleDescription']);
                    // Set new fields if they exist
                    if (res['body']['isPaid'] !== undefined) setIsPaid(res['body']['isPaid']);
                    if (res['body']['stripeProductId']) setStripeProductId(res['body']['stripeProductId']);
                    if (res['body']['price']) setPrice(res['body']['price']);
                    hasModuleInfoLoaded.current = true;
                    return true;
                } else {
                    hasModuleInfoLoaded.current = false;
                    return false;
                }
            } else {
                hasModuleInfoLoaded.current = false;
                return false;
            }
        } catch (error) {
            console.error('Error fetching module info:', error);
            hasModuleInfoLoaded.current = false;
            return false;
        } finally{
            // Reset loading state
            isLoadingModuleInfo.current = false;
        }
    }, [
        moduleId,
        selectedModule
    ]);
    const onNextToCreator = (0, $acw62.useCallback)(async ()=>{
        // Try to get module info if editing an existing module
        await getmoduleinfo();
        // Always proceed to create modal (works for both new and existing modules)
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'createchecklistmodal'
        }));
    }, [
        getmoduleinfo,
        dispatch
    ]);
    const alphanumericSort = (a, b)=>{
        const regex = /(\d+|\D+)/g;
        const aParts = a.match(regex);
        const bParts = b.match(regex);
        for(let i = 0; i < Math.max(aParts.length, bParts.length); i++){
            const aPart = aParts[i];
            const bPart = bParts[i];
            if (aPart === undefined) return -1;
            if (bPart === undefined) return 1;
            if (!isNaN(aPart) && !isNaN(bPart)) {
                const diff = parseInt(aPart) - parseInt(bPart);
                if (diff !== 0) return diff;
            } else {
                const comparison = aPart.localeCompare(bPart);
                if (comparison !== 0) return comparison;
            }
        }
        return 0;
    };
    const sortSectionsAndQuestions = (sections)=>{
        const sortedSections = sections.sort((a, b)=>alphanumericSort(a?.['sectionNo'], b?.['sectionNo']));
        sortedSections.forEach((section)=>{
            if (section?.['questions'] && Array.isArray(section?.['questions'])) section?.['questions'].sort((a, b)=>alphanumericSort(a?.['qNo'], b?.['qNo']));
        });
        return sortedSections;
    };
    const onNextToAddSubsections = async ()=>{
        for(let i = 0; i < additionalSections.length + 1; i++)if (additionalSections[i] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please Input Section ${i + 1} Name!`);
        if (creatingSectionOption === "Automatically") dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'ChecklistModal2'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/addDDSection`, {
            moduleId: moduleId,
            sections: additionalSections,
            moduleName: moduleName,
            moduleDescription: moduleDescription,
            option: option,
            addOption: addOption,
            moduleCreator: moduleCreator,
            price: price,
            creatingSectionOption: creatingSectionOption
        });
        if (!res || res.code != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (creatingSectionOption === "Automatically") dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/getDDSection`, {
            moduleName: moduleName,
            moduleKey: moduleKey
        });
        if (!res || res.code != 200) return;
        await getQuestions();
        setDoneSignal(true);
        setSections(sortSectionsAndQuestions(res['body']));
    };
    const onNextToAddSection = async ()=>{
        // Basic validation
        if (moduleName == "" || moduleName == undefined) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please Input Module Name!");
        else if (moduleDescription == "" || moduleDescription == undefined) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please Input Module Description!");
        else if (moduleCreator == "" || moduleCreator == undefined) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please Input Module Creator Name!");
        // Conditional validation for paid modules
        if (isPaid) {
            if (stripeProductId == "" || stripeProductId == undefined) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please Input Stripe Product ID for paid modules!");
            if (price == "Free" || price == "" || price == undefined) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please select a valid price for paid modules!");
        }
        if (creatingSectionOption === "Automatically") dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "ChecklistModal"
        }));
        // Include new fields in the request payload
        let payload = {
            moduleId: moduleId,
            moduleName: moduleName,
            ...module && module['isHealthBoost'] && {
                moduleKey: moduleKey
            },
            moduleDescription: moduleDescription,
            option: option,
            addOption: addOption,
            moduleCreator: moduleCreator,
            price: price,
            creatingSectionOption: creatingSectionOption,
            category: 'all',
            isPaid: isPaid,
            stripeProductId: isPaid ? stripeProductId : null
        };
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/addModule`, payload);
        if (!res || res.code != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        setModuleId(res['body']['_id']);
        setModuleName(res['body']['moduleName']);
        if (res['body']['price'] && res['body']['stripeProductId']) {
            setPrice(res['body']['price']);
            setStripeProductId(res['body']['stripeProductId']);
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addsectionmodal'
        }));
        res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/getDDSection`, {
            moduleId: moduleId,
            moduleName: moduleName,
            moduleKey: moduleKey,
            creatingSectionOption: creatingSectionOption
        });
        if (!res || res.code != 200) return;
        let newArray = [
            ...additionalSections
        ];
        for(let i = 0; i < res['body'].length; i++)newArray[i] = res['body'][i]['sectionName'];
        setAdditionalSections(newArray);
    };
    let iconClasses = "center-vertically f3 pa l0 ml1rem br5px mah2rem maw2rem";
    let inputValues = {
        "qDescription": {
            title: 'Question Description',
            placeholder: 'Please add you question description',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M256 336c-18 0-32 14-32 32c0 18 13.1 32 32 32c17.1 0 32-13.1 32-32C288 350 273.1 336 256 336zM289.1 128h-51.1C198.1 128 168 158.1 168 198c0 12.1 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 158.1 328.1 128 289.1 128z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 400c-18 0-32-14-32-32s13.1-32 32-32c17.1 0 32 14 32 32S273.1 400 256 400zM325.1 258L280 286V288c0 13-11 24-24 24S232 301 232 288V272c0-8 4-16 12-21l57-34C308 213 312 206 312 198C312 186 301.1 176 289.1 176h-51.1C225.1 176 216 186 216 198c0 13-11 24-24 24s-24-11-24-24C168 159 199 128 237.1 128h51.1C329 128 360 159 360 198C360 222 347 245 325.1 258z"
                    })
                ]
            })
        },
        "topTip": {
            title: 'Tool Tip',
            placeholder: 'Please provide tooltip for help',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 640 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z"
                    })
                ]
            })
        },
        "toolboxOffer": {
            title: 'Tool Box Offer',
            placeholder: 'Please provide toolbox offer for help',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M512 205.3V320h-128V272C384 263.1 376.9 256 368 256h-32C327.1 256 320 263.1 320 272V320H192V272C192 263.1 184.9 256 176 256h-32C135.1 256 128 263.1 128 272V320H0V205.3c0-8.5 3.375-16.62 9.375-22.62l45.25-45.25C60.63 131.4 68.75 128 77.25 128h357.5c8.5 0 16.62 3.375 22.62 9.375l45.25 45.25C508.6 188.6 512 196.8 512 205.3z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M384 320v48c0 8.875-7.125 16-16 16h-32c-8.875 0-16-7.125-16-16V320H192v48C192 376.9 184.9 384 176 384h-32C135.1 384 128 376.9 128 368V320H0v128c0 17.62 14.38 32 32 32h448c17.62 0 32-14.38 32-32v-128H384zM176 80h160V128H384V80C384 53.5 362.5 32 336 32h-160C149.5 32 128 53.5 128 80V128h48V80z"
                    })
                ]
            })
        },
        "templateFiles": {
            title: 'Template File',
            placeholder: 'Please provide template file to help company understand how they can format this document before uploading (optional)',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z"
                    })
                ]
            })
        },
        "riskDescription": {
            title: 'Risk Description',
            placeholder: 'Please provide Risk Description if answer is negative (NO)',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
                    })
                ]
            })
        },
        "recommendDescription": {
            title: 'Recommendation Description',
            placeholder: 'Please provide Recommendation if answer is negative (NO)',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 640 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z"
                    })
                ]
            })
        },
        "noPoints": {
            title: 'Points on No',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M384 64.01v384c0 13.47-8.438 25.5-21.09 30.09C359.3 479.4 355.7 480 352 480c-9.312 0-18.38-4.078-24.59-11.52L64 152.4v295.6c0 17.67-14.31 32-32 32s-32-14.33-32-32v-384c0-13.47 8.438-25.5 21.09-30.09c12.62-4.516 26.84-.75 35.5 9.609L320 359.6v-295.6c0-17.67 14.31-32 32-32S384 46.34 384 64.01z"
                })
            })
        },
        "yesPoints": {
            title: 'Points on Yes',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z"
                })
            })
        },
        "completionScore": {
            title: 'Points on Completion',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 576 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M335.9 371c-9.715 8.604-15.9 20.65-15.9 33.62C319.1 428.7 339.3 448 363.4 448h4.644c26.51 0 47.99 21.49 47.99 48c0 8.836-7.162 16-15.1 16H176c-8.836 0-15.1-7.164-15.1-16c0-26.51 21.48-48 47.99-48h4.644c24.03 0 43.36-19.33 43.36-43.35c0-12.98-6.184-25.02-15.9-33.62C128 271.7 128 96 128 96L128 32c0-17.67 14.5-32 32.17-32h255.7C433.5 0 448 14.33 448 32l-.0059 64C447.1 96 447.1 271.7 335.9 371z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M193.7 316.9C189.8 311.1 186.2 305.3 182.8 299.4c-47.14-19.35-82.56-45.83-105.4-79.52C49.47 178.6 47.01 135.7 48.38 112h80.39C128.1 101.9 128 96 128 96L128.1 64H27.26C16.16 64 6.537 71.59 3.912 82.38C3.1 85.78-15.71 167.2 37.07 245.9c37.45 55.82 100.6 95.03 187.5 117.4c8.828 2.268 17.76 9.74 15.51 7.75C211.9 346 194.2 317.4 193.7 316.9zM572.1 82.38C569.5 71.59 559.8 64 548.7 64h-100.8l.0811 32c0 0-.0953 5.926-.7652 16h80.39c1.375 23.66-1.093 66.63-29.03 107.8c-22.82 33.69-58.25 60.17-105.4 79.52c-3.402 5.91-7.023 11.73-10.86 17.5c-.5352 .5352-18.2 29.14-46.45 54.16c-2.248 1.99 6.687-5.482 15.51-7.75c86.96-22.34 150.1-61.55 187.5-117.4C591.7 167.2 572.9 85.78 572.1 82.38z"
                    })
                ]
            })
        },
        "filePoints": {
            title: 'Points on File Upload',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 640 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M640 352c0 70.7-57.31 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9C96.11 197.4 96 194.7 96 192c0-88.41 71.59-160 160-160c59.31 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.312 23.91-6.406 34.59C596 238.4 640 290.1 640 352z"
                })
            })
        },
        "commentPoints": {
            title: 'Points on Comment',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M256 32C114.6 32 .0272 125.1 .0272 240c0 49.63 21.35 94.98 56.97 130.7c-12.5 50.37-54.27 95.27-54.77 95.77c-2.25 2.25-2.875 5.734-1.5 8.734C1.979 478.2 4.75 480 8 480c66.25 0 115.1-31.76 140.6-51.39C181.2 440.9 217.6 448 256 448c141.4 0 255.1-93.13 255.1-208S397.4 32 256 32z"
                })
            })
        },
        "ifYes": {
            title: 'Yes Recommendation',
            placeholder: 'Recommendation if Yes',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z"
                })
            })
        },
        "ifNo": {
            title: 'No Recommendation',
            placeholder: 'Recommendation if No',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M384 64.01v384c0 13.47-8.438 25.5-21.09 30.09C359.3 479.4 355.7 480 352 480c-9.312 0-18.38-4.078-24.59-11.52L64 152.4v295.6c0 17.67-14.31 32-32 32s-32-14.33-32-32v-384c0-13.47 8.438-25.5 21.09-30.09c12.62-4.516 26.84-.75 35.5 9.609L320 359.6v-295.6c0-17.67 14.31-32 32-32S384 46.34 384 64.01z"
                })
            })
        },
        "if1": {
            title: 'Option 1 Recommendation',
            placeholder: 'Recommendation if selected option is 1',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 256 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M256 448c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h64V123.8L49.75 154.6C35.02 164.5 15.19 160.4 5.375 145.8C-4.422 131.1-.4531 111.2 14.25 101.4l96-64c9.828-6.547 22.45-7.187 32.84-1.594C153.5 41.37 160 52.22 160 64.01v352h64C241.7 416 256 430.3 256 448z"
                })
            })
        },
        "if2": {
            title: 'Option 2 Recommendation',
            placeholder: 'Recommendation if selected option is 2',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 448c0 17.67-14.33 32-32 32H32c-13.08 0-24.83-7.953-29.7-20.09c-4.859-12.12-1.859-26 7.594-35.03l193.6-185.1c31.36-30.17 33.95-80 5.812-113.4c-14.91-17.69-35.86-28.12-58.97-29.38C127.4 95.83 105.3 103.9 88.53 119.9L53.52 151.7c-13.08 11.91-33.33 10.89-45.2-2.172C-3.563 136.5-2.594 116.2 10.48 104.3l34.45-31.3c28.67-27.34 68.39-42.11 108.9-39.88c40.33 2.188 78.39 21.16 104.4 52.03c49.8 59.05 45.2 147.3-10.45 200.8l-136 130H288C305.7 416 320 430.3 320 448z"
                })
            })
        },
        "if3": {
            title: 'Option 3 Recommendation',
            placeholder: 'Recommendation if selected option is 3',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 344c0 74.98-61.02 136-136 136H103.6c-46.34 0-87.31-29.53-101.1-73.48c-5.594-16.77 3.484-34.88 20.25-40.47c16.75-5.609 34.89 3.484 40.47 20.25c5.922 17.77 22.48 29.7 41.23 29.7H184c39.7 0 72-32.3 72-72s-32.3-72-72-72H80c-13.2 0-25.05-8.094-29.83-20.41C45.39 239.3 48.66 225.3 58.38 216.4l131.4-120.4H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h240c13.2 0 25.05 8.094 29.83 20.41c4.781 12.3 1.516 26.27-8.203 35.19l-131.4 120.4H184C258.1 208 320 269 320 344z"
                })
            })
        },
        "if4": {
            title: 'Option 4 Recommendation',
            placeholder: 'Recommendation if selected option is 4',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M384 334.2c0 17.67-14.33 32-32 32h-32v81.78c0 17.67-14.33 32-32 32s-32-14.33-32-32v-81.78H32c-10.97 0-21.17-5.625-27.05-14.89c-5.859-9.266-6.562-20.89-1.875-30.81l128-270.2C138.6 34.33 157.8 27.56 173.7 35.09c15.97 7.562 22.78 26.66 15.22 42.63L82.56 302.2H256V160c0-17.67 14.33-32 32-32s32 14.33 32 32v142.2h32C369.7 302.2 384 316.6 384 334.2z"
                })
            })
        },
        "if5": {
            title: 'Option 5 Recommendation',
            placeholder: 'Recommendation if selected option is 5',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 344.6c0 74.66-60.73 135.4-135.4 135.4H104.7c-46.81 0-88.22-29.83-103-74.23c-5.594-16.77 3.469-34.89 20.23-40.48c16.83-5.625 34.91 3.469 40.48 20.23c6.078 18.23 23.08 30.48 42.3 30.48h79.95c39.36 0 71.39-32.03 71.39-71.39s-32.03-71.38-71.39-71.38H32c-9.484 0-18.47-4.203-24.56-11.48C1.359 254.5-1.172 244.9 .5156 235.6l32-177.2C35.27 43.09 48.52 32.01 64 32.01l192 .0049c17.67 0 32 14.33 32 32s-14.33 32-32 32H90.73L70.3 209.2h114.3C259.3 209.2 320 269.1 320 344.6z"
                })
            })
        },
        "ifD": {
            title: 'Disclosure Recommendation',
            placeholder: 'Recommendation if selected option is Disclosure',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 256 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M256 448c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h64V123.8L49.75 154.6C35.02 164.5 15.19 160.4 5.375 145.8C-4.422 131.1-.4531 111.2 14.25 101.4l96-64c9.828-6.547 22.45-7.187 32.84-1.594C153.5 41.37 160 52.22 160 64.01v352h64C241.7 416 256 430.3 256 448z"
                })
            })
        },
        "ifND": {
            title: 'Non-Disclosure Recommendation',
            placeholder: 'Recommendation if selected option is Non Disclosure',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 448c0 17.67-14.33 32-32 32H32c-13.08 0-24.83-7.953-29.7-20.09c-4.859-12.12-1.859-26 7.594-35.03l193.6-185.1c31.36-30.17 33.95-80 5.812-113.4c-14.91-17.69-35.86-28.12-58.97-29.38C127.4 95.83 105.3 103.9 88.53 119.9L53.52 151.7c-13.08 11.91-33.33 10.89-45.2-2.172C-3.563 136.5-2.594 116.2 10.48 104.3l34.45-31.3c28.67-27.34 68.39-42.11 108.9-39.88c40.33 2.188 78.39 21.16 104.4 52.03c49.8 59.05 45.2 147.3-10.45 200.8l-136 130H288C305.7 416 320 430.3 320 448z"
                })
            })
        },
        "ifNS": {
            title: 'Not Selected Recommendation',
            placeholder: 'Recommendation if selected option is Not Selected',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 344c0 74.98-61.02 136-136 136H103.6c-46.34 0-87.31-29.53-101.1-73.48c-5.594-16.77 3.484-34.88 20.25-40.47c16.75-5.609 34.89 3.484 40.47 20.25c5.922 17.77 22.48 29.7 41.23 29.7H184c39.7 0 72-32.3 72-72s-32.3-72-72-72H80c-13.2 0-25.05-8.094-29.83-20.41C45.39 239.3 48.66 225.3 58.38 216.4l131.4-120.4H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h240c13.2 0 25.05 8.094 29.83 20.41c4.781 12.3 1.516 26.27-8.203 35.19l-131.4 120.4H184C258.1 208 320 269 320 344z"
                })
            })
        }
    };
    function getQuestionKeys(question) {
        let keys = [
            'qDescription',
            'riskDescription',
            'recommendDescription',
            'templateFiles',
            'topTip'
        ]; // 'commentPoints', 'filePoints', 'completionScore'], //TODO: maybe use later
        // if (question['questionType']?.includes('YN') && question['type'] != 'repository')
        //     keys = keys.concat(['ifYes', 'riskIfYes', 'ifNo', 'riskIfNo']);
        if (question['questionType']?.includes('1to5')) keys = keys.concat([
            'if1',
            'riskIf1',
            'if2',
            'riskIf2',
            'if3',
            'riskIf3',
            'if4',
            'riskIf4',
            'if5',
            'riskIf5'
        ]);
        if (question['questionType']?.includes('D/ND')) keys = keys.concat([
            'ifD',
            'riskIfD',
            'ifNS',
            'riskIfNS',
            'ifND',
            'riskIfND'
        ]);
        return [
            ...keys
        ];
    }
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e, question)=>{
        e.preventDefault();
        e['target']['files'] = e['dataTransfer']['files'];
        e['target'].querySelector("input").value = null;
        saveQuestion(e, question);
    };
    let saveQuestion = async (e, question)=>{
        let attachment = [];
        if (e['target']['files']) for (const file of e['target']['files'])attachment.push(file);
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/update`, {
            attachment: attachment,
            questionId: question['_id'],
            [e['target']['name']]: e['target']['value']
        });
        if (!res || res['code'] != 200) return;
        if (e['target']['files']) getQuestions();
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    let addDeleteQuestion = async (section, type)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/addDeleteQuestion`, {
            type: type,
            sectionId: section['_id']
        });
        if (!res || res['code'] != 200) return;
        await getQuestions();
        setSections(res['body']);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    const getSectionHTML = (sections, type)=>{
        return Object.values(sections).map((section, idx)=>{
            // if (section.sectionNo === "Q001") return;
            const qNo = section['sectionNo'] || section['no']; //S001
            const question = questions.find((q)=>q['qNo'] == qNo); //q.qNo S001.1
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: (section['sectionNo'] ? "shadow " : "") + "mt1rem toggleHeight bg1 py1rem px2rem br5px cp bss bw2px bo5",
                children: [
                    section['sectionName'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "usn pen fs1-5rem fw600",
                        children: [
                            qNo,
                            " - ",
                            section['sectionName']
                        ]
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "usn pen fs1-25rem fw600",
                        children: [
                            qNo,
                            " - ",
                            section['name']
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            cursor: "auto",
                            height: "0px"
                        },
                        className: "oh",
                        children: [
                            question && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                "data-id": question['_id'],
                                className: "dg gg0-5rem mt1rem",
                                children: (()=>{
                                    let maxRisk = 5, minRisk = -5;
                                    let questionKeys = getQuestionKeys(question);
                                    let riskKeys = questionKeys.filter((k)=>k.startsWith("riskIf") || [
                                            'toolboxOffer'
                                        ].includes(k));
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            questionKeys.filter((k)=>!k.startsWith("riskIf")).map((key, idx)=>{
                                                let placeholder = key.replace(/^q/, "").replace(/([A-Z])/g, " $1").replace(/^./, (s)=>s.toUpperCase());
                                                return key == "templateFiles" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            onDragOver: onDragOver,
                                                            onDrop: (e)=>onDrop(e, question),
                                                            for: "fileUpload" + question._id,
                                                            className: "w100 bsbb bg5 br5px df jcc aic px2rem py5rem bsd bo6 bw2px cp mb0-5rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "pen fs0-75rem tac",
                                                                    children: [
                                                                        inputValues[key]['placeholder'],
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                        "Click here or drag and drop template files (max 100MB)"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    onChange: (e)=>saveQuestion(e, question),
                                                                    className: "dn",
                                                                    id: "fileUpload" + question._id,
                                                                    type: "file",
                                                                    multiple: true
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df fww",
                                                            children: question['templateFiles'] && question['templateFiles'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                    className: "df jcc aic br25px lh1 bg3 c1 px0-5rem fw600 mr0-5rem mb0-5rem",
                                                                    target: "_blank",
                                                                    to: file['location'],
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "py0-5rem pl0-5rem",
                                                                            children: file['originalname']
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                            onClick: (e)=>{
                                                                                e.preventDefault();
                                                                                setDeleteFileQuestionId(question['_id']);
                                                                                setDeleteFile(file);
                                                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                    open: 'deleteFileOnChecklist'
                                                                                }));
                                                                            },
                                                                            className: "p0-5rem f9 w1rem h1rem",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            viewBox: "0 0 320 512",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                className: "pen fa-primary",
                                                                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                                            })
                                                                        })
                                                                    ]
                                                                }, `${file['location']}-${idx}`))
                                                        })
                                                    ]
                                                }, idx) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pr",
                                                    children: [
                                                        inputValues[key]?.['title'] && /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "fw500",
                                                            children: inputValues[key]?.['title']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                            onBlur: (e)=>saveQuestion(e, question),
                                                            defaultValue: question[key],
                                                            name: key,
                                                            type: "text",
                                                            placeholder: inputValues[key]?.['placeholder'] || placeholder,
                                                            className: "bss bw2px bo5 pl4rem pt1rem bg1 w100 br5px"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            "data-tooltip": inputValues[key]?.['placeholder'] || placeholder,
                                                            children: inputValues[key]['icon']
                                                        })
                                                    ]
                                                });
                                            }),
                                            riskKeys.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        className: "w100 tac fs1-25rem",
                                                        children: "Assign Risk Scores"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "riskSlider bsbb pr w100 tac",
                                                        children: riskKeys.map((key, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                "data-id": key,
                                                                name: key,
                                                                onChange: (e)=>saveQuestion(e, question),
                                                                type: "range",
                                                                className: key + " pen pa oyv l0 w100",
                                                                min: minRisk,
                                                                max: maxRisk,
                                                                defaultValue: question[key]
                                                            }, idx))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df jcsb w100",
                                                        children: Array(Math.abs(minRisk) + Math.abs(maxRisk) + 1).fill(1).map((j, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "w1rem tac",
                                                                children: minRisk + i
                                                            }, i))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb w100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Low Risk"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "High Risk"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })()
                            }),
                            section['subFolders'] && getSectionHTML(section['subFolders'], 'subFolders')
                        ]
                    }),
                    type == 'sections' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>addDeleteQuestion(section, 'add'),
                                className: "shadow mxa bg3 bg4-hover c1 td250 br5px fs0-5rem px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic mt0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-plus pr0-25rem"
                                    }),
                                    "\xa0 Add Question"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>addDeleteQuestion(section, 'delete'),
                                className: "shadow mxa bg4 bg3-hover c1 td250 br5px fs0-5rem px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic mt0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-trash pr0-25rem"
                                    }),
                                    "\xa0 Delete Question"
                                ]
                            })
                        ]
                    })
                ]
            }, idx);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "container py5rem df fdc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                onClick: ()=>{
                                    onBack();
                                    window.history.replaceState(null, null, window.location.pathname + window.location.search);
                                },
                                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb df jcc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        className: "pen f1 h2rem mr0-5rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 448 512",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-primary pen",
                                                d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-secondary pen",
                                                d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                            })
                                        ]
                                    }),
                                    "Back to Menu"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: onBack,
                                className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem fw600 cp ttu bsbb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-save pr1rem"
                                    }),
                                    "Save"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: getDone && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                getSectionHTML(sections, 'sections'),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: onBack,
                                    className: "shadow mxa bg3 bg4-hover c1 td250 br5px px2rem my2rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-save pr1rem"
                                        }),
                                        "Save"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'selectchecklistmodal',
                onClose: ()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    window.history.replaceState(null, null, window.location.pathname + window.location.search);
                },
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                window.history.replaceState(null, null, window.location.pathname + window.location.search);
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: "New Checklist Module"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc fs1-25rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "radio",
                                                    name: "option",
                                                    value: "Empty",
                                                    id: "empty",
                                                    checked: option === "Empty",
                                                    onChange: onOptionChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "ml1rem",
                                                    htmlFor: "empty",
                                                    children: "Set up a new empty Diligentsia Expansion Pack\u200B\u20131-click"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "radio",
                                                    name: "option",
                                                    value: "Empty_Partner",
                                                    id: "empty_partner",
                                                    checked: option === "Empty_Partner",
                                                    onChange: onOptionChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "ml1rem",
                                                    htmlFor: "empty_partner",
                                                    children: "Set up a new empty Partner Expansion Pack for\u200B specialist partner to populate\u200B\u200B"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "radio",
                                                    name: "option",
                                                    value: "Specific_company\u200B",
                                                    id: "specific_company\u200B",
                                                    checked: option === "Specific_company\u200B",
                                                    onChange: onOptionChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "ml1rem",
                                                    htmlFor: "specific_company\u200B",
                                                    children: "Set up a DD pack to do DD on a specific target\u200B company\u200B"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "radio",
                                                    name: "option",
                                                    value: "Specific_business",
                                                    id: "specific_business",
                                                    checked: option === "Specific_business",
                                                    onChange: onOptionChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "ml1rem",
                                                    htmlFor: "specific_business",
                                                    children: "Set up a DD pack to do DD on a specific business"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: (e)=>{
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }));
                                            onNextToCreator();
                                        },
                                        className: "shadow mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                        children: "\uD83D\uDC49 Next"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "createchecklistmodal",
                onClose: ()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    window.history.replaceState(null, null, window.location.pathname + window.location.search);
                    if (onEdit) onBack();
                    else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'selectchecklistmodal'
                    }));
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tac",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "c15 fs1-5rem fw600 tac",
                            children: moduleName ? moduleName : "Diligentsia Expansion Pack Module\u200B Checklist Creator\u200B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ma dg gg0-5rem w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc fs1-25rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem df fdr",
                                            style: {
                                                gap: '1rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: `df fdc  ${module && module['isHealthBoost'] ? 'w50' : 'w100'}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "tal c15 fs1rem",
                                                            htmlFor: "module_name",
                                                            children: "Module Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "module_name",
                                                            onChange: (e)=>{
                                                                handleModuleNameChange(e.target.value);
                                                            },
                                                            type: "text",
                                                            placeholder: "Add module name. e.g. cybersecurity",
                                                            className: "pl1rem bss bw2px bo5 w100 br5px p0-5rem",
                                                            value: moduleName
                                                        })
                                                    ]
                                                }),
                                                module && module['isHealthBoost'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc w50",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fdr jcsb aic",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    className: "tal c15 fs1rem",
                                                                    htmlFor: "module_key",
                                                                    children: "Module Key"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "module_key",
                                                                onChange: (e)=>{
                                                                    handleModuleKeyChange(e.target.value);
                                                                },
                                                                type: "text",
                                                                placeholder: "e.g. EYBP",
                                                                className: "pl1rem bss bw2px bo5 w100 br5px p0-5rem",
                                                                value: moduleKey
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                className: "c6 tal fs0-75rem mt0-25rem c15",
                                                                children: isModuleKeyManuallyEdited ? "Manual mode: Click 'Auto' to re-enable auto-generation" : "Auto-generated from module name (first letters). Edit to switch to manual mode."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem df fdc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "tal fs1rem c15",
                                                    htmlFor: "module_description",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                    id: "module_description",
                                                    onChange: (e)=>setModuleDescription(e.target.value),
                                                    className: "bss bw2px bo5 px1rem py1rem bg1 w100 br5px rv",
                                                    placeholder: "Add module description e.g. In-depth audit of a company's cybersecurity protections",
                                                    rows: 5,
                                                    value: moduleDescription
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem df fdc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "tal df aic fw500 fs1rem c15",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: isPaid,
                                                            onChange: (e)=>handleIsPaidChange(e.target.checked),
                                                            className: "mr0-5rem",
                                                            style: {
                                                                width: '18px',
                                                                height: '18px'
                                                            }
                                                        }),
                                                        "Is Paid Module"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                    className: "c6 tal c15 fs0-75rem mt0-25rem",
                                                    children: "Check this if the module requires payment"
                                                })
                                            ]
                                        }),
                                        isPaid && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem df fdr",
                                            style: {
                                                gap: '1rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc w50",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "tal fw500 fs1rem c15",
                                                            htmlFor: "stripeProductId",
                                                            children: "Stripe Price ID *"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "stripeProductId",
                                                            type: "text",
                                                            placeholder: "prod_xxxxxxxxxxxxxxxx",
                                                            className: "pl1rem w100 br5px p0-5rem bss bw2px bo5",
                                                            value: stripeProductId,
                                                            onChange: (e)=>setStripeProductId(e.target.value)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                            className: "c6 tal fs0-75rem mt0-25rem c15",
                                                            children: "Enter the Stripe Product ID for this paid module"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc w50",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "tal fs1rem c15",
                                                            htmlFor: "module_price",
                                                            children: "Module Price"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                            id: "module_price",
                                                            name: "price",
                                                            value: price,
                                                            onChange: (event)=>handlePriceChange(event.target.value),
                                                            className: "pl1rem w100 br5px p0-5rem bss bw2px bo5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "\xa399",
                                                                    children: "\xa399"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "\xa3250",
                                                                    children: "\xa3250"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "\xa3500",
                                                                    children: "\xa3500"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: "\xa3999",
                                                                    children: "\xa3999"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isPaid && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mt1rem df fdc jcfs aifs",
                                            style: {
                                                width: '150px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "tal fs1rem c15",
                                                    children: "Module Price"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "py1rem fs1rem c7 fw600 bg5 br5px",
                                                    style: {
                                                        display: 'inline-block',
                                                        width: '150px',
                                                        textAlign: 'center'
                                                    },
                                                    children: "Free"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                            className: "df fdc mt2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "tal fs1rem c15",
                                                    htmlFor: "empty_partner",
                                                    children: "Add to:\u200B"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mt1rem tal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "radio",
                                                            name: "option",
                                                            value: "Growth Ready",
                                                            id: "growth_ready",
                                                            checked: addOption === "Growth Ready",
                                                            onChange: onAddOptionChange
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "ml1rem fs1rem c15",
                                                            htmlFor: "growth_ready",
                                                            children: "Growth Ready dashboard section\u200B"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "tal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "radio",
                                                            name: "option",
                                                            value: "Investment/Exit Ready",
                                                            id: "investment_exit_ready",
                                                            checked: addOption === "Investment/Exit Ready",
                                                            onChange: onAddOptionChange
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "ml1rem fs1rem c15",
                                                            htmlFor: "investment_exit_ready",
                                                            children: "Investment/Exit Ready dashboard section\u200B"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("fieldset", {
                                            className: "df fdc mt2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "tal fs1rem c15",
                                                    htmlFor: "create_mode",
                                                    children: "Module Create Mode:\u200B"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mt1rem tal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "radio",
                                                            name: "option1",
                                                            value: "Manually",
                                                            id: "manual",
                                                            checked: creatingSectionOption === "Manually",
                                                            onChange: onCreatingSectionOption
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "ml1rem fs1rem c15",
                                                            htmlFor: "manual",
                                                            children: "Manually"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "tal",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "radio",
                                                            name: "option1",
                                                            value: "Automatically",
                                                            id: "auto",
                                                            checked: creatingSectionOption === "Automatically",
                                                            onChange: onCreatingSectionOption
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "ml1rem fs1rem c15",
                                                            htmlFor: "auto",
                                                            children: "Automatically from ChatGPT\u200B"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc mt2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "tal fs1rem c15",
                                                    htmlFor: "module_creator",
                                                    children: "Module Creator"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: "module_creator",
                                                    onChange: (e)=>{
                                                        setModuleCreator(e.target.value);
                                                    },
                                                    type: "text",
                                                    placeholder: "Input Module Creator Name. e.g. Mark Bernstein",
                                                    className: "pl1rem shadow w100 br5px p1rem",
                                                    value: moduleCreator
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: (e)=>onNextToAddSection(),
                                        className: "shadow mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                        children: "\uD83D\uDC49 Next"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'addsectionmodal',
                onClose: ()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                },
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic ",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw1000px pr px5rem br5px pr ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h1rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'createchecklistmodal'
                                }));
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                moduleName,
                                "\u200B"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-1rem ttu w100 tac mb1rem",
                            children: "Add/Edit Proposed Sections"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc fs1-25rem",
                                children: [
                                    additionalSections.map((item, index)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr mb1rem df fdr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mr0-5rem w20",
                                                    children: [
                                                        "Section ",
                                                        index + 1
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: "index",
                                                    value: item,
                                                    onChange: (e)=>{
                                                        editSectionName(e.target.value, index);
                                                    },
                                                    type: "text",
                                                    placeholder: `Add Section${index + 1} here...`,
                                                    className: "pl1rem shadow bg5 w80 br5px p1rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-trash pl1rem",
                                                    style: {
                                                        "cursor": "pointer"
                                                    },
                                                    onClick: ()=>{
                                                        let clone = [
                                                            ...additionalSections
                                                        ];
                                                        clone.splice(index, 1);
                                                        setAdditionalSections(clone);
                                                    }
                                                })
                                            ]
                                        }, `${item}-${index}`);
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        className: "text-center py1rem",
                                        style: {
                                            "cursor": "pointer"
                                        },
                                        onClick: ()=>setAdditionalSections([
                                                ...additionalSections,
                                                ''
                                            ]),
                                        children: [
                                            " Add New Section ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "fa fa-plus"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: (e)=>onNextToAddSubsections(),
                                className: "shadow mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "\uD83D\uDC49 Next"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mr0-5rem",
                            children: "To edit any section, simply click on section text and update"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteFileOnChecklist',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs3rem fw600",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem",
                            children: "Are you sure you want to delete this file?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-25rem fw500 mb1rem",
                            children: deleteFile && deleteFile.originalname
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>confirmDeleteFile(),
                            className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            className: "c3-hover td250 fs1-25rem cp",
                            children: "Cancel"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'ChecklistModal',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: "PRO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 tac mb1rem fs1-5em",
                            children: moduleName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                            children: "Diligentsia Admin Checklist Module"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "\uD83D\uDD2E ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Checklist Module Magic:"
                                        }),
                                        " Please wait whilst we create the list section headings around which your checklist questions will be created. ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "In this step, you will have the chance to edit the proposed section headings, before we move on to create the questions themselves"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h9rem",
                                    src: (parcelRequire("hA45b")),
                                    alt: ""
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'ChecklistModal2',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: "PRO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 tac mb1rem fs1-5em",
                            children: moduleName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                            children: "Diligentsia Admin Checklist Module"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "\uD83D\uDD2E ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Checklist Module Magic:"
                                        }),
                                        " Please wait whilst we create the list questions for your new checklist. ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " In this step, you will have the chance to edit the proposed questions and risks and recommendation for your own checklist."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h9rem",
                                    src: (parcelRequire("hA45b")),
                                    alt: ""
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");
function $df460a1f1cccdf24$export$2e2bcd8739ae039(props) {
    const { onBack: onBack } = props;
    const [deduperTestLogs, setDeduperTestLogs] = (0, $acw62.useState)([]);
    const [selectedLog, setSelectedLog] = (0, $acw62.useState)();
    const fetch = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/deduperTestLogs`);
        if (res?.code === 200) setDeduperTestLogs(res['body']);
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const getAiResponseString = (aiResp)=>{
        if (!aiResp || aiResp.length == 0) return "";
        let stringResult = "";
        for (const dup of aiResp)if (Array.isArray(dup)) stringResult += "<p>- " + dup.join(", ") + "</p>";
        return stringResult;
    };
    const selectCurrentDeduperLog = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (!selectedLog) return;
        if (selectedLog.isSelected) return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectDeduper`, {
            deDuperId: selectedLog['_id']
        });
        if (!res || res['code'] != 200) return;
        let currentLogs = deduperTestLogs;
        for (const duperTestLog of currentLogs){
            duperTestLog.isSelected = false;
            if (duperTestLog['_id'] == selectedLog['_id']) duperTestLog.isSelected = true;
        }
        setDeduperTestLogs(currentLogs);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - Ai Deduper Test History"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: ()=>{
                        selectedLog ? setSelectedLog(null) : onBack();
                    },
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                !selectedLog ? deduperTestLogs.map((deduperTestLog, logIndex)=>{
                    console.log("deduperTestLog; ", deduperTestLog);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `shadow mt1rem py1rem px2rem br5px cp bss bw2px bo5 ${deduperTestLog.isSelected ? "bg7" : "bg1"}`,
                        onClick: ()=>{
                            setSelectedLog(deduperTestLog);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "usn pen fs1-5rem",
                            children: [
                                "Tested by ",
                                deduperTestLog?.['tester']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ass mx0-5rem br100 w2rem h2rem",
                                    src: deduperTestLog?.['tester']?.['profile']
                                }),
                                " ",
                                deduperTestLog?.['tester']?.['firstName'],
                                ",\xa0\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(deduperTestLog['createdAt']).format('lll'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "FileNames:"
                                }),
                                " ",
                                deduperTestLog.fileNames,
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Instructions:"
                                }),
                                " ",
                                deduperTestLog.instructions.substr(0, 100) + "  ... "
                            ]
                        })
                    });
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "fs1rem bss bw2px bo5 br10px p1rem jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fs1rem ",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company Name :"
                                        }),
                                        " ",
                                        selectedLog.companyName,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company Description :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.companyDescription
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "FileNames :"
                                        }),
                                        " ",
                                        selectedLog.fileNames,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Instructions :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.instructions
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "AI Response:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: selectedLog.response && selectedLog.response.length > 0 && selectedLog.response.map((resp)=>{
                                                let respString = "";
                                                if (Array.isArray(resp)) respString = "- " + resp.join(", ");
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: respString
                                                });
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>selectCurrentDeduperLog(),
                                className: `c6 br5px px1rem py0-5rem fw600 fs1-25rem bsbb tac df jcc aic ${selectedLog.isSelected ? "bg7" : "cp bg4"}`,
                                children: selectedLog.isSelected ? 'This instruction is currently used' : 'Use this instruction'
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");
function $ea6efe6b7f4ce364$export$2e2bcd8739ae039(props) {
    const { onBack: onBack } = props;
    const [auditTestLogs, setAuditTestLogs] = (0, $acw62.useState)([]);
    const [selectedLog, setSelectedLog] = (0, $acw62.useState)();
    const fetch = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/audit/audittestlogs`);
        console.log("res: ", res['body']);
        if (res?.code === 200) setAuditTestLogs(res['body']);
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const selectCurrentAuditLog = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (!selectedLog) return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/audit/selectaudit`, {
            auditTestLogId: selectedLog._id
        });
        if (!res || res['code'] != 200) return;
        // await fetch();
        let currentLogs = auditTestLogs;
        for (const currentLog of currentLogs){
            currentLog.isSelected = false;
            if (currentLog['_id'] == selectedLog['_id']) currentLog.isSelected = true;
        }
        setAuditTestLogs(currentLogs);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - AI Test History"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: ()=>{
                        selectedLog ? setSelectedLog(null) : onBack();
                    },
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                !selectedLog ? auditTestLogs.map((auditTestLog, logIndex)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "shadow mt1rem py1rem px2rem br5px cp bss bw2px bo5 " + (auditTestLog.isSelected ? "bg7" : "bg1"),
                        onClick: ()=>{
                            setSelectedLog(auditTestLog);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "usn pen fs1-5rem",
                            children: [
                                "Tested by ",
                                auditTestLog?.['tester']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ass mx0-5rem br100 w2rem h2rem",
                                    src: auditTestLog?.['tester']?.['profile']
                                }),
                                " ",
                                auditTestLog?.['tester']?.['firstName'],
                                ",\xa0\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(auditTestLog['createdAt']).format('lll'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                auditTestLog.intro,
                                " [COPMANY] ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                auditTestLog.instruction.substr(0, 100) + "  ... "
                            ]
                        })
                    });
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "fs1rem bss bw2px bo5 br10px p1rem jcsb",
                    children: [
                        selectedLog.questions.map((question, questionIndex)=>{
                            const risk = selectedLog.risks[questionIndex];
                            const recommendation = selectedLog.recommendations[questionIndex];
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "op20 pen dg gtcr2-lg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fw500 fs1rem",
                                                children: question
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df jcsb",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs1rem ",
                                                children: [
                                                    "Risk : ",
                                                    risk,
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Recommendation : ",
                                                    recommendation,
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                                ]
                                            })
                                        })
                                    })
                                ]
                            });
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fs1rem ",
                                    children: [
                                        "Company Name : ",
                                        selectedLog.companyName,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "Company Description : ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.companyDescription
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "Intro : ",
                                        selectedLog.intro,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "Instructions : ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.instruction
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>selectCurrentAuditLog(),
                                className: "bg4 c6 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic",
                                children: selectedLog.isSelected ? 'This instruction is currently used' : 'Go Live this instruction'
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");
function $bd6e03d3c25b3a9c$export$2e2bcd8739ae039(props) {
    const { onBack: onBack } = props;
    const [twoHundredWordsTestLogs, setTwoHundredWordsTestLogs] = (0, $acw62.useState)([]);
    const [selectedLog, setSelectedLog] = (0, $acw62.useState)();
    const fetch = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/getTHWTestLogs`);
        console.log(res);
        if (res?.code === 200) setTwoHundredWordsTestLogs(res['body']);
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const getAiResponseString = (aiResp)=>{
        if (!aiResp || aiResp.length == 0) return "";
        let stringResult = "";
        for (const dup of aiResp)if (Array.isArray(dup)) stringResult += "<p>- " + dup.join(", ") + "</p>";
        return stringResult;
    };
    const selectCurrentTwoHundredWordsLog = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (!selectedLog) return;
        if (selectedLog.isSelected) return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectTwoHundredWords`, {
            thwId: selectedLog['_id']
        });
        if (!res || res['code'] != 200) return;
        let currentLogs = twoHundredWordsTestLogs;
        for (const currentLog of currentLogs){
            currentLog.isSelected = false;
            if (currentLog['_id'] == selectedLog['_id']) currentLog.isSelected = true;
        }
        setTwoHundredWordsTestLogs(currentLogs);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - Ai 200 Words Test History"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: ()=>{
                        selectedLog ? setSelectedLog(null) : onBack();
                    },
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                !selectedLog ? twoHundredWordsTestLogs.map((twoHundredWordsTestLog, logIndex)=>{
                    console.log("twoHundredWordsTestLog; ", twoHundredWordsTestLog);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `shadow mt1rem py1rem px2rem br5px cp bss bw2px bo5 ${twoHundredWordsTestLog.isSelected ? "bg7" : "bg1"}`,
                        onClick: ()=>{
                            setSelectedLog(twoHundredWordsTestLog);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "usn pen fs1-5rem",
                            children: [
                                "Tested by ",
                                twoHundredWordsTestLog?.['tester']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ass mx0-5rem br100 w2rem h2rem",
                                    src: twoHundredWordsTestLog?.['tester']?.['profile']
                                }),
                                " ",
                                twoHundredWordsTestLog?.['tester']?.['firstName'],
                                ",\xa0\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(twoHundredWordsTestLog['createdAt']).format('lll'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Instructions:"
                                }),
                                " ",
                                twoHundredWordsTestLog.instructions.substr(0, 100) + "  ... "
                            ]
                        })
                    });
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "fs1rem bss bw2px bo5 br10px p1rem jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fs1rem ",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company Name :"
                                        }),
                                        " ",
                                        selectedLog.companyName,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company URL :"
                                        }),
                                        " ",
                                        selectedLog.companyURL,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Instructions :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.instructions
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company Description :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.companyDescription
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: selectedLog.response && selectedLog.response.length > 0 && selectedLog.response.map((resp)=>{
                                                let respString = "";
                                                if (Array.isArray(resp)) respString = "- " + resp.join(", ");
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: respString
                                                });
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>selectCurrentTwoHundredWordsLog(),
                                className: `c6 br5px px1rem py0-5rem fw600 fs1-25rem bsbb tac df jcc aic ${selectedLog.isSelected ? "bg7" : "cp bg4"}`,
                                children: selectedLog.isSelected ? 'This instruction is currently used' : 'Go Live this instruction'
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");









function $eaa72c92771749f8$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { onBack: onBack } = props;
    const [answers, setAnswers] = (0, $acw62.useState)([]);
    let [aiReplyTable, setAiReplyTable] = (0, $acw62.useState)([]);
    const [tData, setTData] = (0, $acw62.useState)([]);
    //     {
    //         no: "S001",
    //         questions: "T collaborations with industry experts for innovation?	",
    //         space: "",
    //         risk: "Lack of external input can limit innovation.",
    //         recommendation: "Establish a dedicated product development team.",
    //     },
    const tColumns = [
        {
            Header: 'Section',
            accessor: 'section',
            minWidth: 100,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'No',
            accessor: 'no',
            width: 80
        },
        {
            Header: 'Questions',
            accessor: 'questions',
            minWidth: 200,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'Space for Answer',
            accessor: 'space',
            width: 50,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'Risk/Rationale',
            accessor: 'risk',
            minWidth: 200,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        },
        {
            Header: 'Recommendation',
            accessor: 'recommendation',
            minWidth: 200,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }
        }
    ];
    const [moduleDescription, setModuleDescription] = (0, $acw62.useState)('');
    const [moduleName, setModuleName] = (0, $acw62.useState)('');
    const defaultModuleName = "Book";
    const defaultModuleDescription = "This module is for book sellers";
    const defaultInstruction = `Generate a detailed due diligence checklist titled '{Checklist Title}' for a company based in 'United Kingdom'. The checklist is designed to evaluate '{Checklist Description/Purpose}'. The checklist should have {10} sections, each containing {10} questions. Each section should address different aspects of the due diligence topic. Each question should be structured in a table with columns for 'No.', 'Questions', 'Space for Answer', 'Risk/Rationale', and 'Recommendation'. Provide a recommendation for each question where a 'No' answer would indicate a potential risk.`;
    const [instructions, setInstructions] = (0, $acw62.useState)("");
    const [aiResp, setAiResp] = (0, $acw62.useState)({});
    const [chId, setChId] = (0, $acw62.useState)("");
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/getCurrentChecklist`);
            if (res?.code === 200) {
                console.log("res", res.body);
                if (res.body) {
                    setChId(res.body['_id']);
                    setInstructions(res.body['instructions']);
                    setModuleDescription(res.body['moduleDescription']);
                    setModuleName(res.body['moduleName']);
                    // setAiResp(res.body['checklistDescription']);
                    // processResponse(res.body['checklistDescription']);
                    parseData(res.body['checklistDescription']);
                } else {
                    setInstructions(defaultInstruction);
                    setModuleDescription(defaultModuleDescription);
                    setModuleName(defaultModuleName);
                    setAiResp("");
                }
            }
        };
        fetch();
    }, []);
    const padNumber = (num, size)=>String(num).padStart(size, '0');
    const parseData = (text)=>{
        const lines = text.split('\n');
        const data = [];
        let currentSection = '';
        let sectionNo = 0;
        let showSection = true;
        lines.forEach((line)=>{
            if (line.startsWith('**Section') || line.startsWith('Section')) {
                // currentSection = line.replace('**', '').trim();
                currentSection = line.split(':')[1].replace('**', '').trim();
                sectionNo++;
                showSection = true;
            } else if (line.startsWith('|') && !line.startsWith('| ---') && !line.startsWith('| No')) {
                const [, no, questions, space, risk, recommendation] = line.split('|').map((item)=>item.trim());
                data.push({
                    section: showSection ? `S${padNumber(sectionNo, 3)}. ` + currentSection : "",
                    no: `S${padNumber(sectionNo, 3)}.${no}`,
                    questions: questions,
                    space: space,
                    risk: risk !== "-" ? risk : "",
                    recommendation: recommendation !== "-" ? recommendation : ""
                });
                showSection = false;
            }
        });
        setTData(data);
    };
    const processResponse = async (response)=>{
        const data = JSON.parse(response);
        let formattedString = '';
        data.module.forEach((section, sectionIndex)=>{
            const sectionNumber = padNumber(sectionIndex + 1, 3);
            formattedString += `S${sectionNumber}. "${section.sectionName}"\n`;
            section.questions.forEach((q, questionIndex)=>{
                formattedString += `S${sectionNumber}.${questionIndex + 1}: "${q.question}"\n`;
            });
            formattedString += '\n'; // Add an extra newline between sections
        });
        setAiResp(formattedString);
    };
    const getAIResponse = async ()=>{
        setTData("");
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'ChecklistModal'
        }));
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/testChecklist`, {
            instructions: instructions,
            moduleName: moduleName,
            moduleDescription: moduleDescription
        });
        if (!res || res['code'] != 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Sever is not responding\n");
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            return;
        }
        let { aiResponse: aiResponse, id: id } = res['body'];
        console.log(":aiResponse: ", aiResponse);
        setChId(id);
        setAiResp(aiResponse);
        // processResponse(aiResponse);
        parseData(aiResponse);
        setRefresh(!refresh);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const selectCH = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (chId == "") return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectChecklists`, {
            chId: chId
        });
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - Checklist Module Test",
                    subheading: "Checklist Modules"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: onBack,
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg1rem mx1rem p1rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "usn pen fs1-25rem fw600",
                            children: "AI Checklist Module Test"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setModuleName(e.target.value),
                                    defaultValue: moduleName,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setModuleDescription(e.target.value),
                                    defaultValue: moduleDescription,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Instructions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setInstructions(e.target.value),
                                    defaultValue: instructions,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "AI Response"
                                }),
                                tData && tData.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                    data: tData,
                                    columns: tColumns,
                                    defaultPageSize: 10,
                                    className: "-striped -highlight"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>getAIResponse(),
                                    className: "bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic mr1rem",
                                    children: "Ask ChatGPT"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>selectCH(),
                                    className: "bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic",
                                    children: "Go Live"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'ChecklistModal',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                                children: "PRO"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: moduleName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                children: "Diligentsia Admin Checklist Test"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            "\uD83D\uDD2E ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Checklist Module Testing Magic:"
                                            }),
                                            " We're now summoning the power of AI to get sections about this module! ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Please stay with us during this magical incantation\u2026"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h9rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








function $43d87d709b6f9172$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const defaultInstruction = `Please use the list of filenames provided below and match each filename to the most relevant specific section of "Index" based on the filename text. For each file, output the file's name along with the allocated Index Lite section(s) based on the filename match. If the filename description is unclear, please allocate it to the section labeled "DXXX - Unallocated Bin" within the Index. In cases where you believe a filename could be applicable to more than one section, allocate multiple sections, but do so sparingly. Generate the output in JSON data with key is filename and value is index.`;
    const { onBack: onBack } = props;
    const [answers, setAnswers] = (0, $acw62.useState)([]);
    const [fileNames, setFileNames] = (0, $acw62.useState)('');
    const [filesSelected, setSelectedFiles] = (0, $acw62.useState)([]);
    const [instructions, setInstructions] = (0, $acw62.useState)('');
    const [companyName, setCompanyName] = (0, $acw62.useState)("ASTRAZENECA PLC");
    const [description, setDescription] = (0, $acw62.useState)(`The company AstraZeneca PLC is a global biopharmaceutical company that discovers, develops, and commercializes prescription medicines for a wide range of therapy areas, including oncology, cardiovascular, renal and metabolic diseases, infection, respiratory, and rare diseases.**
	AstraZeneca's business model is based on the research and development of innovative new medicines, which it then sells through its own commercial organization and through partners. The company is regulated by a number of different authorities, including the UK Medicines and Healthcare products Regulatory Agency (MHRA) and the US Food and Drug Administration (FDA).
	**AstraZeneca's main business activity is the development and commercialization of prescription medicines.** The company has a portfolio of over 50 marketed medicines, and a pipeline of over 100 new drugs in development. AstraZeneca's medicines are used to treat a wide range of diseases, including cancer, heart disease, stroke, diabetes, asthma, and arthritis.
	**AstraZeneca's business model is based on the following key activities:**
	* **Research and development:** AstraZeneca invests heavily in research and development, with the aim of discovering new medicines that can improve the lives of patients. The company has a global network of research and development centers, and employs over 16,000 scientists and researchers.
	* **Manufacturing:** AstraZeneca manufactures its own medicines at its own facilities around the world. The company also has a number of partnerships with other manufacturers.
	* **Commercialization:** AstraZeneca sells its medicines through its own commercial organization and through partners. The company has a global sales and marketing team, and operates in over 100 countries.
	**AstraZeneca is a major player in the global pharmaceutical industry. The company's medicines are used by millions of people around the world. AstraZeneca is committed to developing new medicines that can improve the lives of patients and transform the future of healthcare.**`);
    const [aiResp, setAiResp] = (0, $acw62.useState)({});
    const [faId, setFaId] = (0, $acw62.useState)("");
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const fetch = async ()=>{
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/currentFaInfo`);
            if (res?.code === 200) {
                let fileNames = res.body['fileNames'];
                let instructions = res.body['instructions'];
                let companyName = res.body['companyName'];
                let companyDescription = res.body['companyDescription'];
                let response = res.body['response'];
                let id = res.body['_id'];
                if (id) setFaId(id);
                if (fileNames) {
                    setSelectedFiles(fileNames);
                    setFileNames(getFilenameString(fileNames));
                }
                if (instructions) setInstructions(instructions);
                else setInstructions(defaultInstruction);
                companyName && setCompanyName(companyName);
                companyDescription && setDescription(companyDescription);
                response && setAiResp(response);
            }
        };
        fetch();
    }, []);
    const getAiResponseString = ()=>{
        if (!aiResp || aiResp.length == 0) return "";
        let stringResult = "";
        for (const key of Object.keys(aiResp)){
            const fileItem = aiResp[key];
            stringResult += "- " + fileItem.file + "\n";
            if (Array.isArray(fileItem.section)) stringResult += fileItem.section.join(", ");
            else stringResult += fileItem.section;
            stringResult += "\n\n";
        }
        return stringResult;
    };
    const getFilenameString = (fileNames)=>{
        let stringResult = '';
        for (const file of fileNames)stringResult += "- " + file + "\n";
        return stringResult;
    };
    const getAIResponse = async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'FilingAssistant'
        }));
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/testFa`, {
            fileNames: filesSelected,
            instructions: instructions,
            companyName: companyName,
            description: description
        });
        if (!res || res['code'] != 200) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            return;
        }
        let { aiResponse: aiResponse, id: id } = res['body'];
        setFaId(id);
        setAiResp(aiResponse);
        setRefresh(!refresh);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const selectFa = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (faId == "") return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectFa`, {
            faId: faId
        });
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    const handleFileChange = async (e)=>{
        let selectedFiles = [];
        let fileNames = '';
        for (const file of e.target.files)if (file.webkitRelativePath == "") {
            selectedFiles.push(file.name);
            fileNames = fileNames + "- " + file.name + "\n";
        } else {
            selectedFiles.push(file.webkitRelativePath);
            fileNames = fileNames + "- " + file.webkitRelativePath + "\n";
        }
        setFileNames(fileNames);
        setSelectedFiles(selectedFiles);
        e.target.value = null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - AI Test",
                    subheading: "Filing Assistant"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: onBack,
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg1rem mx1rem p1rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "usn pen fs1-25rem fw600",
                            children: "AI Filing Manager Test"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setCompanyName(e.target.value),
                                    defaultValue: companyName,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Company Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setDescription(e.target.value),
                                    defaultValue: description,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem mr1rem",
                                    children: "Filenames"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdr ",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "fileSelect",
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp miw10 ttu bsbb tac mb1rem df jcc aic mr1rem",
                                            children: [
                                                "Select Files",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    onChange: handleFileChange,
                                                    id: "fileSelect",
                                                    className: "dn",
                                                    type: "file",
                                                    multiple: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "folderSelect",
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp miw10 ttu bsbb tac mb1rem df jcc aic",
                                            children: [
                                                "Select Folders",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    onChange: handleFileChange,
                                                    directory: "",
                                                    webkitdirectory: "",
                                                    mozdirectory: "",
                                                    className: "dn",
                                                    id: "folderSelect",
                                                    type: "file",
                                                    multiple: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    defaultValue: fileNames,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px mih200px rv",
                                    disabled: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "Instructions"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    onChange: (e)=>setInstructions(e.target.value),
                                    defaultValue: instructions,
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "w100 tac fs1-25rem",
                                    children: "AI Response"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    defaultValue: getAiResponseString(aiResp),
                                    className: "bss bw2px bo5 px4rem py2rem bg1 w100 br5px rv"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>getAIResponse(),
                                    className: `bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic mr1rem ${fileNames == "" || instructions == "" ? "c12 disabled" : "c6"}`,
                                    children: "Ask ChatGPT"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>selectFa(),
                                    className: `bg5 br5px px1rem py0-5rem fw600 cp fs1-25rem bsbb tac df jcc aic ${faId == "" ? "disabled c12" : "c6"}`,
                                    children: "Go Live"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'FilingAssistant',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                                children: "PRO"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: companyName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                children: "Diligentsia Admin Filing Assistant"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            "\uD83D\uDD2E ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Filing Assistant Magic:"
                                            }),
                                            " We're now summoning the power of AI to allocationg files to appropriate sections! ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Please stay with us during this magical incantation\u2026"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h9rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $45fvw = parcelRequire("45fvw");
function $a33cef13a9940aa2$export$2e2bcd8739ae039(props) {
    const { onBack: onBack } = props;
    const [faTestLogs, setFaTestLogs] = (0, $acw62.useState)([]);
    const [selectedLog, setSelectedLog] = (0, $acw62.useState)();
    const [refresh, setRefresh] = (0, $acw62.useState)(false);
    const fetch = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/aiTest/faTestLogs`);
        if (res?.code === 200) setFaTestLogs(res['body']);
    };
    (0, $acw62.useEffect)(()=>{
        fetch();
    }, []);
    const getAiResponseString = ()=>{
        if (!aiResp || Object.keys(aiResp).length == 0) return "";
        let stringResult = "";
        for (const key of Object.keys(aiResp)){
            const fileItem = aiResp[key];
            stringResult += "- " + fileItem.file + "\n";
            if (Array.isArray(fileItem.section)) {
                stringResult += fileItem.section.join(", ");
                stringResult += "\n\n";
            }
        }
        return stringResult;
    };
    const selectCurrentFaLog = async ()=>{
        let result = confirm("Do you want to update this instruction as default?");
        if (result === false) return;
        if (!selectedLog) return;
        if (selectedLog.isSelected) return;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/aiTest/selectFa`, {
            faId: selectedLog['_id']
        });
        if (!res || res['code'] != 200) return;
        let currentLogs = faTestLogs;
        for (const faLog of currentLogs){
            faLog.isSelected = false;
            if (faLog['_id'] == selectedLog['_id']) faLog.isSelected = true;
        }
        setFaTestLogs(currentLogs);
        selectedLog.isSelected = true;
        setSelectedLog(selectedLog);
        setRefresh(!refresh);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Instruction is selected as default");
    };
    const getFilenameString = (fileNames)=>{
        let stringResult = '';
        for (const file of fileNames)stringResult += "- " + file + "\n";
        return stringResult;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container py5rem df fdc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                    wrapperClass: "mb2rem tac",
                    heading: "Admin Panel - AI Filing Manager Test History"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    onClick: ()=>{
                        selectedLog ? setSelectedLog(null) : onBack();
                    },
                    className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pen f1 h2rem mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 448 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary pen",
                                    d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary pen",
                                    d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                })
                            ]
                        }),
                        "Back to Menu"
                    ]
                }),
                !selectedLog ? faTestLogs.map((faTestLog, logIndex)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `shadow mt1rem py1rem px2rem br5px cp bss bw2px bo5 ${faTestLog.isSelected ? "bg7" : "bg1"}`,
                        onClick: ()=>{
                            setSelectedLog(faTestLog);
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "usn pen fs1-5rem",
                            children: [
                                "Tested by ",
                                faTestLog?.['tester']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ass mx0-5rem br100 w2rem h2rem",
                                    src: faTestLog?.['tester']?.['profile']
                                }),
                                " ",
                                faTestLog?.['tester']?.['firstName'],
                                ",\xa0\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(faTestLog['createdAt']).format('lll'),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "FileNames:"
                                }),
                                " ",
                                faTestLog.fileNames.join(", ").substr(0, 300),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Instructions:"
                                }),
                                " ",
                                faTestLog.instructions.substr(0, 100) + "  ... "
                            ]
                        })
                    });
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "fs1rem bss bw2px bo5 br10px p1rem jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sectionWrapper jcsb px2rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fs1rem ",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company Name :"
                                        }),
                                        " ",
                                        selectedLog.companyName,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company Description :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.companyDescription
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Instructions :"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: selectedLog.instructions
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "AI Response:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: selectedLog.response && Object.values(selectedLog.response).length > 0 && Object.values(selectedLog.response).map((resp)=>{
                                                const respFile = "- " + resp.file;
                                                let respSections = '';
                                                if (Array.isArray(resp.section)) respSections = resp.section.join("\n");
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        respFile,
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        respSections
                                                    ]
                                                });
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>selectCurrentFaLog(),
                                className: `c6 br5px px1rem py0-5rem fw600 fs1-25rem bsbb tac df jcc aic ${selectedLog.isSelected ? "bg7" : "cp bg4"}`,
                                children: selectedLog.isSelected ? 'This instruction is currently used' : 'Use this instruction'
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $689927f0df05e8fa$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');



const $fbf0b2bd525d1d97$var$DeleteSection = ({ modal: modal, dispatch: dispatch, toggleModal: toggleModal, selectedData: selectedData })=>{
    // Hooks and vars
    const [loading, setLoading] = (0, $acw62.useState)(false);
    // Handle Submit
    const handleSubmit = async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/delete/section`, {
                id: selectedData?._id
            });
            if (response['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                dispatch(toggleModal({
                    open: ''
                }));
            }
        } catch (err) {
            console.log(err, "error");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            open: modal['open'] == '123deleteSection',
            onClose: ()=>dispatch(toggleModal({
                    open: ''
                })),
            className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "h2rem pa t0 center-horizontally",
                        src: (parcelRequire("aR1CT")),
                        alt: "TODO",
                        style: {
                            top: '15px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "close-popup",
                        onClick: ()=>dispatch(toggleModal({
                                open: ''
                            })),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            style: {
                                position: 'relative',
                                top: '4px'
                            },
                            className: "pen fds h1rem f1 mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 320 512",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "pen fa-primary",
                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row fdc tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                sx: {
                                    fontSize: '8rem',
                                    margin: '20px auto'
                                }
                            }),
                            "Are you sure to delete ",
                            selectedData?.name,
                            " section?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcse",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: ()=>{
                                    if (loading) return;
                                    dispatch(toggleModal({
                                        open: ""
                                    }));
                                },
                                className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: handleSubmit,
                                className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Delete"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $fbf0b2bd525d1d97$export$2e2bcd8739ae039 = $fbf0b2bd525d1d97$var$DeleteSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $74fc0c9160d7b378$var$DeleteCategory = ({ modal: modal, dispatch: dispatch, toggleModal: toggleModal, getCategorys: getCategorys, selectedData: selectedData })=>{
    // Hooks and vars
    const [loading, setLoading] = (0, $acw62.useState)(false);
    // Handle Submit
    const handleSubmit = async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/delete/category`, {
                id: selectedData?._id,
                name: selectedData?.name
            });
            if (response['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                getCategorys();
                dispatch(toggleModal({
                    open: ''
                }));
            }
        } catch (err) {
            console.log(err, "error");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            open: modal['open'] == 'deleteModal',
            onClose: ()=>dispatch(toggleModal({
                    open: ''
                })),
            className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "h2rem pa t0 center-horizontally",
                        src: (parcelRequire("aR1CT")),
                        alt: "TODO",
                        style: {
                            top: '15px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "close-popup",
                        onClick: ()=>dispatch(toggleModal({
                                open: ''
                            })),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            style: {
                                position: 'relative',
                                top: '4px'
                            },
                            className: "pen fds h1rem f1 mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 320 512",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "pen fa-primary",
                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row fdc tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                sx: {
                                    fontSize: '8rem',
                                    margin: '20px auto'
                                }
                            }),
                            "Are you sure to delete ",
                            selectedData?.name,
                            " category?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcse",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: ()=>{
                                    if (loading) return;
                                    dispatch(toggleModal({
                                        open: ""
                                    }));
                                },
                                className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: handleSubmit,
                                className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Delete"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $74fc0c9160d7b378$export$2e2bcd8739ae039 = $74fc0c9160d7b378$var$DeleteCategory;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $c336ba93aa6c356e$var$CreateEditCategory = ({ modal: modal, dispatch: dispatch, toggleModal: toggleModal, selectedData: selectedData, getCategorys: getCategorys })=>{
    // Hooks and vars
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)({
        name: ''
    });
    (0, $acw62.useEffect)(()=>{
        if (selectedData) setData({
            name: selectedData.name,
            ...selectedData?._id && {
                id: selectedData._id
            }
        });
    }, [
        selectedData
    ]);
    const handleClose = ()=>{
        dispatch(toggleModal({
            open: ''
        }));
    };
    // Handle Submit
    const handleSubmit = async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            const endpoint = selectedData?.title.toLowerCase().trim().includes('edit') ? '/admin/update/category' : '/admin/create/category';
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(endpoint, data);
            if (response['code'] == 200) {
                handleClose();
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                getCategorys();
            }
        } catch (err) {
            console.log(err, "error");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            open: modal['open'] == 'addEditCategory',
            onClose: handleClose,
            className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "h2rem pa t0 center-horizontally",
                        src: (parcelRequire("aR1CT")),
                        alt: "TODO",
                        style: {
                            top: '15px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "close-popup",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            style: {
                                position: 'relative',
                                top: '4px'
                            },
                            className: "pen fds h1rem f1 mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 320 512",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "pen fa-primary",
                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "text-gradient fs1-5rem fw600 tac",
                        children: selectedData && selectedData?.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "row mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `p1rem w100`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "",
                                    for: "empty",
                                    children: "Category Name"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    id: "categoryName",
                                    type: "text",
                                    name: "name",
                                    placeholder: "Add category name. e.g. cybersecurity",
                                    className: "pl1rem shadow w100 br5px p1rem",
                                    onChange: (e)=>setData((prev)=>({
                                                ...prev,
                                                [e.target.name]: e.target.value
                                            })),
                                    value: data.name
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcse",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: ()=>{
                                    if (loading) return;
                                    dispatch(toggleModal({
                                        open: ""
                                    }));
                                },
                                className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: handleSubmit,
                                className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Submit"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $c336ba93aa6c356e$export$2e2bcd8739ae039 = $c336ba93aa6c356e$var$CreateEditCategory;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $80f3c4b280641386$var$CreateEditSection = ({ modal: modal, dispatch: dispatch, toggleModal: toggleModal, sectionList: sectionList, selectedData: selectedData })=>{
    // Hooks and vars
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)({
        sectionNo: '',
        sectionName: ''
    });
    const allSections = (0, $acw62.useMemo)(()=>{
        return sectionList.map((section)=>({
                label: section.sectionName,
                value: section._id
            }));
    }, [
        sectionList
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedData) setData({
            sectionName: selectedData.sectionName
        });
    }, [
        selectedData
    ]);
    const handleClose = ()=>{
        dispatch(toggleModal({
            open: ''
        }));
    };
    // Handle Submit
    const handleSubmit = async ()=>{
        if (loading) return;
        setLoading(true);
        try {
            const endpoint = selectedData?.title.toLowerCase().trim().includes('edit') ? '/admin/update/section' : '/admin/create/section';
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(endpoint, data);
            if (response['code'] == 200) {
                handleClose();
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            }
        } catch (err) {
            console.log(err, "error");
        } finally{
            setLoading(false);
        }
    };
    const findDefaultValue = ()=>{
        const selectedSection = allSections.filter((cat)=>cat.value === data?.categoryId);
        if (selectedSection.length) return selectedSection[0];
        return null;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            open: modal['open'] == '123addEditSection',
            onClose: handleClose,
            className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "h2rem pa t0 center-horizontally",
                        src: (parcelRequire("aR1CT")),
                        alt: "TODO",
                        style: {
                            top: '15px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "close-popup",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            style: {
                                position: 'relative',
                                top: '4px'
                            },
                            className: "pen fds h1rem f1 mr0-5rem",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 320 512",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "pen fa-primary",
                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "text-gradient fs1-5rem fw600 tac",
                        children: selectedData && selectedData?.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row mt1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `w50 p1rem`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "",
                                        for: "empty",
                                        children: "Section Name"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "sectionName",
                                        type: "text",
                                        name: "sectionName",
                                        placeholder: "Add category name. e.g. cybersecurity",
                                        className: "pl1rem shadow w100 br5px p1rem",
                                        onChange: (e)=>setData((prev)=>({
                                                    ...prev,
                                                    [e.target.name]: e.target.value
                                                })),
                                        value: data.sectionName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `w50 p1rem`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "",
                                        for: "empty",
                                        children: "Section Number"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "sectionNo",
                                        type: "text",
                                        name: "sectionNo",
                                        placeholder: "Add category name. e.g. cybersecurity",
                                        className: "pl1rem shadow w100 br5px p1rem",
                                        onChange: (e)=>setData((prev)=>({
                                                    ...prev,
                                                    [e.target.name]: e.target.value
                                                })),
                                        value: data.sectionNo
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcse",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: ()=>{
                                    if (loading) return;
                                    dispatch(toggleModal({
                                        open: ""
                                    }));
                                },
                                className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: handleSubmit,
                                className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                children: "Submit"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $80f3c4b280641386$export$2e2bcd8739ae039 = $80f3c4b280641386$var$CreateEditSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9a402a389bd8b499$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $478fe5b437ab8d6f$export$ffd560f22c0ecf04(slot) {
    return (0, $4Cod0.default)('MuiAvatar', slot);
}
const $478fe5b437ab8d6f$var$avatarClasses = (0, $beCSm.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $478fe5b437ab8d6f$export$2e2bcd8739ae039 = $478fe5b437ab8d6f$var$avatarClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1894f4268467302e$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $1894f4268467302e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $478fe5b437ab8d6f$export$ffd560f22c0ecf04), classes);
};
const $1894f4268467302e$var$AvatarRoot = (0, $d8seH.default)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $8nd05.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $8nd05.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $1894f4268467302e$var$AvatarImg = (0, $d8seH.default)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $1894f4268467302e$var$AvatarFallback = (0, $d8seH.default)((0, $9a402a389bd8b499$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function $1894f4268467302e$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $1894f4268467302e$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular' } = props, other = (0, $1En50.default)(props, $1894f4268467302e$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $1894f4268467302e$var$useLoaded((0, $8nd05.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, $8nd05.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $1894f4268467302e$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $49e8399bd2388464$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $1894f4268467302e$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $8nd05.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $ayMG0.jsx)(ImgSlot, (0, $8nd05.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1894f4268467302e$var$AvatarRoot, (0, $8nd05.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $1894f4268467302e$export$2e2bcd8739ae039 = $1894f4268467302e$var$Avatar;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $jjlaj = parcelRequire("jjlaj");

var $8Indx = parcelRequire("8Indx");
function $0d35ef8a52a98e99$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $0d35ef8a52a98e99$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $0d35ef8a52a98e99$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $0d35ef8a52a98e99$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $0d35ef8a52a98e99$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8b1da808c4852549$export$c987db9fc844f86(slot) {
    return (0, $4Cod0.default)('MuiSkeleton', slot);
}
const $8b1da808c4852549$var$skeletonClasses = (0, $beCSm.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $8b1da808c4852549$export$2e2bcd8739ae039 = $8b1da808c4852549$var$skeletonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $445470756a9ff70a$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $445470756a9ff70a$var$_ = (t)=>t, $445470756a9ff70a$var$_t, $445470756a9ff70a$var$_t2, $445470756a9ff70a$var$_t3, $445470756a9ff70a$var$_t4;
const $445470756a9ff70a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8b1da808c4852549$export$c987db9fc844f86), classes);
};
const $445470756a9ff70a$var$pulseKeyframe = (0, $jjlaj.keyframes)($445470756a9ff70a$var$_t || ($445470756a9ff70a$var$_t = $445470756a9ff70a$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $445470756a9ff70a$var$waveKeyframe = (0, $jjlaj.keyframes)($445470756a9ff70a$var$_t2 || ($445470756a9ff70a$var$_t2 = $445470756a9ff70a$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $445470756a9ff70a$var$SkeletonRoot = (0, $d8seH.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $0d35ef8a52a98e99$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $0d35ef8a52a98e99$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $8nd05.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $ef80a26abd5cc14c$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState: ownerState })=>ownerState.animation === 'pulse' && (0, $jjlaj.css)($445470756a9ff70a$var$_t3 || ($445470756a9ff70a$var$_t3 = $445470756a9ff70a$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $445470756a9ff70a$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === 'wave' && (0, $jjlaj.css)($445470756a9ff70a$var$_t4 || ($445470756a9ff70a$var$_t4 = $445470756a9ff70a$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $445470756a9ff70a$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $445470756a9ff70a$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width } = props, other = (0, $1En50.default)(props, $445470756a9ff70a$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $445470756a9ff70a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($445470756a9ff70a$var$SkeletonRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $8nd05.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $445470756a9ff70a$export$2e2bcd8739ae039 = $445470756a9ff70a$var$Skeleton;




const $e36985890d0dc5d3$var$CategoryLogsModal = ({ dispatch: dispatch, toggleModal: toggleModal, modal: modal, subPanel: subPanel })=>{
    const [data, setData] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    // Using useCallback to memoize the API call function
    const handleFetchData = (0, $acw62.useCallback)(async ()=>{
        if (modal.open === 'allocationManagementLogs') {
            setLoading(true);
            let data = {
                endpoint: '/category'
            };
            if (subPanel !== "Category Management") data = {
                ...data,
                endpoint: subPanel !== "Featured Business Card" ? "/api/admin/assign/category/section" : "/userAllocation/section",
                ...subPanel !== "Featured Business Card" ? {
                    allocationType: subPanel === "Allocation Section Management" ? "section" : "expension"
                } : {
                    message: 'User allocated!'
                }
            };
            try {
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', data);
                if (response && response.code === 200) setData(response.body);
            } catch (error) {
                console.error('Error fetching created categories:', error);
            } finally{
                setLoading(false);
            }
        }
    }, [
        dispatch,
        toggleModal,
        modal.open
    ]);
    // Effect to fetch created categories
    (0, $acw62.useEffect)(()=>{
        handleFetchData();
    }, [
        handleFetchData,
        modal.open
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: modal.open === 'allocationManagementLogs',
        onClose: ()=>dispatch(toggleModal({
                open: ''
            })),
        className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "h2rem pa t0 center-horizontally",
                    src: (parcelRequire("aR1CT")),
                    alt: "Logo",
                    style: {
                        top: '15px'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "close-popup",
                    onClick: ()=>dispatch(toggleModal({
                            open: ''
                        })),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        style: {
                            position: 'relative',
                            top: '4px'
                        },
                        className: "pen fds h1rem f1 mr0-5rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            className: "pen fa-primary",
                            d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                    className: "text-gradient fs1-5rem fw600 tac",
                    children: [
                        subPanel,
                        " Logs"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "c4 fs0-75rem ttu w100 tac mb1rem",
                    children: [
                        "See the history of ",
                        subPanel,
                        " Categories"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ma oya dg gg0-5rem mb2rem w100",
                    children: data.length > 0 && !loading ? data.map((log, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df my0-5rem",
                            children: [
                                log.userId?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ass ml0-5rem br100 w2rem h2rem client-profile",
                                    src: log.userId.profile,
                                    alt: log.userId.name || `${log.userId.firstName} ${log.userId.lastName}`,
                                    "data-tooltip": log.userId.name || `${log.userId.firstName} ${log.userId.lastName}`
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem client-profile",
                                    "data-tooltip": log.userId.name || `${log.userId.firstName} ${log.userId.lastName}`,
                                    children: log.userId.name ? `${log.userId.name.split(' ')[0][0] || '?'}${log.userId.name.split(' ')[1]?.[0] || '?'}` : `${log.userId.firstName[0] || '?'}${log.userId.lastName[0] || '?'}`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs0-75rem ml1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: log.message
                                                }),
                                                " at ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: new Date(log.timestamp).toLocaleString()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                            children: subPanel === "Category Management" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Category Name:"
                                                    }),
                                                    " ",
                                                    log?.['payload']?.['name']
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Section Name:"
                                                            }),
                                                            " ",
                                                            log?.['payload']?.['sectionNo']
                                                        ]
                                                    }),
                                                    log?.['payload']?.['categoryName'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Assigned Category:"
                                                            }),
                                                            " ",
                                                            log?.['payload']?.['categoryName']
                                                        ]
                                                    }),
                                                    log?.['payload']?.['advisorName'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Advisor Name:"
                                                            }),
                                                            " ",
                                                            log?.['payload']?.['advisorName']
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index)) : !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c4 fs1-50rem ttu w100 tac mb1rem",
                        children: "No Logs Found!"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        variant: "circular",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        width: "100%",
                                        sx: {
                                            marginLeft: '12px',
                                            height: '70px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            children: "."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        variant: "circular",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        width: "100%",
                                        sx: {
                                            marginLeft: '12px',
                                            height: '70px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            children: "."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        variant: "circular",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        width: "100%",
                                        sx: {
                                            marginLeft: '12px',
                                            height: '70px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            children: "."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        variant: "circular",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        width: "100%",
                                        sx: {
                                            marginLeft: '12px',
                                            height: '70px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            children: "."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        variant: "circular",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1894f4268467302e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                        width: "100%",
                                        sx: {
                                            marginLeft: '12px',
                                            height: '70px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            children: "."
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $e36985890d0dc5d3$export$2e2bcd8739ae039 = $e36985890d0dc5d3$var$CategoryLogsModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $0efbd31c0706668d$var$mainAdvisorsData = ()=>{
    const [data, setData] = (0, $acw62.useState)([]);
    const [advisorsData, setAdvisorsData] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/getAllMainAdvisors`, {}, setAdvisorsData);
            const _data = response.body.map((advisor)=>({
                    ...advisor,
                    label: `${advisor?.firstName ?? advisor?.firstName} ${advisor?.lastName ?? advisor?.lastName}`,
                    value: `${advisor?._id}`,
                    ...advisor?.advisorType && advisor?.advisorType?.name && {
                        advisorTypeName: `(${advisor?.advisorType?.name})`
                    }
                }));
            setAdvisorsData(_data);
        } catch (error) {
            setAdvisorsData({});
            console.error('Error fetching data:', error);
        } finally{
            setLoading(false);
        }
    }, []);
    const fetchDefaultData = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/userAllocation/section`, {}, setData);
            setData(response.body);
        } catch (error) {
            setData({});
            console.error('Error fetching data:', error);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchDefaultData();
        fetchData();
    }, []);
    return {
        data: data,
        advisorsData: advisorsData,
        setData: setData
    };
};
var $0efbd31c0706668d$export$2e2bcd8739ae039 = $0efbd31c0706668d$var$mainAdvisorsData;



const $1a3cba70e2956a20$var$UserAllocationManagement = ({ sectionList: sectionList, TablePagination: TablePagination, rowsPerPage: rowsPerPage, currentPage: currentPage, handleChangePage: handleChangePage, handleChangeRowsPerPage: handleChangeRowsPerPage })=>{
    const { advisorsData: advisorsData, data: data, setData: setData } = (0, $0efbd31c0706668d$export$2e2bcd8739ae039)();
    const paginatedData = sectionList?.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage);
    const handleAllocation = async ({ advisorId: advisorId, sectionId: sectionId, advisorName: advisorName, sectionNo: sectionNo })=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/userAllocation/section`, {
                advisorId: advisorId,
                sectionId: sectionId,
                advisorName: advisorName,
                sectionNo: sectionNo
            });
            setData(response?.['body']);
        } catch (err) {
            console.log(err);
        }
    };
    const getSelectedValue = ({ sectionId: sectionId })=>{
        const section = data?.filter((ad)=>ad['sectionId'] === sectionId);
        if (section.length) return advisorsData?.filter((i)=>i._id === section[0]['advisorId'])[0];
        return {};
    };
    // Custom function to format the option label
    const formatOptionLabel = ({ label: label, advisorTypeName: advisorTypeName })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        fontWeight: 'normal',
                        textTransform: 'capitalize'
                    },
                    children: label
                }),
                ' ',
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        fontWeight: 'bold',
                        color: '#555'
                    },
                    children: advisorTypeName
                })
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem allocationSectionAdmin",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "fs1-5rem fs2rem-sm ttu tac c4",
                        children: "Featured Business Cards Management"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt2rem",
                        style: {
                            overflowX: 'scroll',
                            width: '1300px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "tal p1rem",
                                            style: {
                                                fontSize: '16px'
                                            },
                                            children: "Section Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "tal p1rem",
                                            style: {
                                                fontSize: '16px'
                                            },
                                            children: "Main Advisors"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: paginatedData?.map((sec_obj, sec_i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "df fdc jcs ais w100",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df als jcs ases",
                                                        style: {
                                                            textAlign: 'left !important',
                                                            fontWeight: 400,
                                                            fontSize: '11px'
                                                        },
                                                        children: [
                                                            sec_obj?.sectionNo,
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "fw600 ml0-5rem",
                                                                children: [
                                                                    "(",
                                                                    sec_obj?.sectionName,
                                                                    ") "
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "p1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                        placeholder: "Select Advisors",
                                                        styles: (0, $1eef38cfda4b0c52$export$edf5b2501a573922),
                                                        formatOptionLabel: formatOptionLabel,
                                                        value: getSelectedValue({
                                                            sectionId: sec_obj._id
                                                        }),
                                                        className: "p0-5rem lpins w100 br10px  custom-input cp bg1",
                                                        options: advisorsData,
                                                        onChange: (advisor)=>handleAllocation({
                                                                advisorId: advisor._id,
                                                                sectionId: sec_obj._id,
                                                                advisorName: advisor.label,
                                                                sectionNo: sec_obj?.sectionNo
                                                            })
                                                    })
                                                })
                                            ]
                                        }, sec_i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 df jce",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TablePagination, {
                            rowsPerPageOptions: [
                                5,
                                10,
                                25
                            ],
                            component: "div",
                            count: sectionList?.length || 0,
                            rowsPerPage: rowsPerPage,
                            page: currentPage,
                            onPageChange: handleChangePage,
                            onRowsPerPageChange: handleChangeRowsPerPage
                        })
                    })
                ]
            })
        })
    });
};
var $1a3cba70e2956a20$export$2e2bcd8739ae039 = $1a3cba70e2956a20$var$UserAllocationManagement;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ebdec3d621c029d6$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($ebdec3d621c029d6$exports, "__esModule", {
    value: true
});
$ebdec3d621c029d6$exports.default = void 0;

var $ebdec3d621c029d6$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ebdec3d621c029d6$var$_default = $ebdec3d621c029d6$exports.default = (0, $ebdec3d621c029d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');


var $8e6a1f3d36d8c3d3$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8e6a1f3d36d8c3d3$exports, "__esModule", {
    value: true
});
$8e6a1f3d36d8c3d3$exports.default = void 0;

var $8e6a1f3d36d8c3d3$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8e6a1f3d36d8c3d3$var$_default = $8e6a1f3d36d8c3d3$exports.default = (0, $8e6a1f3d36d8c3d3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');


const $99670e8ba4de8a78$var$S = {
    wrap: {
        padding: '1.5rem',
        background: '#f5f6fa',
        minHeight: 120
    },
    card: {
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e4e8f5',
        boxShadow: '0 2px 8px rgba(74,103,255,0.06)',
        overflow: 'hidden'
    },
    cardHead: {
        padding: '18px 24px 14px',
        borderBottom: '1px solid #f0f2ff'
    },
    title: {
        fontSize: '1.05rem',
        fontWeight: 700,
        color: '#1a1d2e',
        margin: 0
    },
    subtitle: {
        fontSize: '0.8rem',
        color: '#7c83a0',
        marginTop: 4
    },
    tableWrap: {
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '70vh',
        width: '100%',
        WebkitOverflowScrolling: 'touch'
    },
    thead: {
        background: '#f8f9ff'
    },
    th: {
        padding: '10px 14px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'left',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    thCenter: {
        padding: '10px 14px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'center',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    modRow: {
        background: 'linear-gradient(90deg,#f0f3ff 0%,#f8f9ff 100%)',
        cursor: 'pointer',
        borderTop: '2px solid #e8eaf5',
        userSelect: 'none'
    },
    modTd: {
        padding: '10px 16px'
    },
    modAccent: {
        width: 3,
        height: 34,
        background: '#4A67FF',
        borderRadius: 2,
        flexShrink: 0
    },
    modName: {
        fontSize: '0.88rem',
        fontWeight: 700,
        color: '#1a1d2e'
    },
    modKey: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        flexShrink: 0
    },
    modMeta: {
        fontSize: '0.72rem',
        color: '#9aa0b8'
    },
    secRow: {
        borderBottom: '1px solid #f0f2ff',
        background: '#fff',
        transition: 'background .1s'
    },
    secTd: {
        padding: '8px 12px 8px 32px'
    },
    secNo: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        whiteSpace: 'nowrap',
        flexShrink: 0
    },
    secName: {
        fontSize: '0.82rem',
        color: '#374151'
    },
    catTd: {
        textAlign: 'center',
        padding: '8px 14px'
    },
    cb: {
        width: 15,
        height: 15,
        accentColor: '#4A67FF',
        cursor: 'pointer'
    }
};
const $99670e8ba4de8a78$var$TempAllocationSection = ({ categoryList: categoryList })=>{
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchTempModules = async ()=>{
        setLoading(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/admin/temp-modules-admin', 'not-showMessage');
            if (res?.code === 200) setTempModules(res.body || []);
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchTempModules();
    }, []);
    const toggleAccordion = (moduleId)=>setOpenAccordions((prev)=>({
                [moduleId]: !prev[moduleId]
            }));
    const handleAssign = async ({ moduleId: moduleId, sectionNo: sectionNo, category: category, valueAssign: valueAssign })=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/admin/assign/category/temp-section', {
                moduleId: moduleId,
                sectionNo: sectionNo,
                categoryId: category._id,
                type: valueAssign
            });
            if (res?.code === 200) {
                setTempModules((prev)=>prev.map((mod)=>{
                        if (String(mod._id) !== String(moduleId)) return mod;
                        return {
                            ...mod,
                            sections: mod.sections.map((sec)=>{
                                if (sec.sectionNo !== sectionNo) return sec;
                                return {
                                    ...sec,
                                    categoryId: valueAssign ? category._id : null
                                };
                            })
                        };
                    }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message || 'Updated.');
            }
        } catch (err) {
            console.error(err);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic p2rem",
        style: {
            color: '#7c83a0'
        },
        children: "Loading\u2026"
    });
    const SECTION_COL_PX = 260;
    const CATEGORY_COL_PX = 100;
    const tableWidth = Math.max(SECTION_COL_PX + (categoryList?.length ?? 0) * CATEGORY_COL_PX, 480);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $99670e8ba4de8a78$var$S.wrap,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: $99670e8ba4de8a78$var$S.card,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $99670e8ba4de8a78$var$S.cardHead,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $99670e8ba4de8a78$var$S.title,
                            children: "Allocation Section Management"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $99670e8ba4de8a78$var$S.subtitle,
                            children: "Assign a category to each section within a module. Expand a module to see its sections."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: $99670e8ba4de8a78$var$S.tableWrap,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        style: {
                            width: tableWidth,
                            minWidth: '100%',
                            borderCollapse: 'separate',
                            borderSpacing: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("colgroup", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                        style: {
                                            width: SECTION_COL_PX
                                        }
                                    }),
                                    categoryList.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                            style: {
                                                width: CATEGORY_COL_PX
                                            }
                                        }, cat._id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                style: $99670e8ba4de8a78$var$S.thead,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$99670e8ba4de8a78$var$S.th,
                                                position: 'sticky',
                                                left: 0,
                                                top: 0,
                                                zIndex: 4,
                                                backgroundColor: '#f8f9ff',
                                                boxShadow: '4px 0 10px -2px rgba(26, 29, 46, 0.12)'
                                            },
                                            children: "Section"
                                        }),
                                        categoryList.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                style: {
                                                    ...$99670e8ba4de8a78$var$S.thCenter,
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 3,
                                                    backgroundColor: '#f8f9ff'
                                                },
                                                children: cat.name
                                            }, cat._id))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: tempModules.filter((mod)=>mod.sections?.length > 0).map((mod)=>{
                                    const isOpen = !!openAccordions[mod._id];
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                style: $99670e8ba4de8a78$var$S.modRow,
                                                onClick: ()=>toggleAccordion(mod._id),
                                                role: "button",
                                                tabIndex: 0,
                                                onKeyDown: (e)=>(e.key === 'Enter' || e.key === ' ') && toggleAccordion(mod._id),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            ...$99670e8ba4de8a78$var$S.modTd,
                                                            position: 'sticky',
                                                            left: 0,
                                                            zIndex: 2,
                                                            background: 'linear-gradient(90deg,#f0f3ff 0%,#f8f9ff 100%)',
                                                            boxShadow: '4px 0 10px -2px rgba(26, 29, 46, 0.08)'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    style: $99670e8ba4de8a78$var$S.modAccent
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    style: {
                                                                        flex: 1,
                                                                        minWidth: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            style: $99670e8ba4de8a78$var$S.modName,
                                                                            children: mod.moduleName
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            style: {
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: 6,
                                                                                marginTop: 3
                                                                            },
                                                                            children: [
                                                                                mod.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    style: $99670e8ba4de8a78$var$S.modKey,
                                                                                    children: mod.moduleKey
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    style: $99670e8ba4de8a78$var$S.modMeta,
                                                                                    children: [
                                                                                        mod.sections?.length || 0,
                                                                                        " section",
                                                                                        mod.sections?.length !== 1 ? 's' : ''
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e6a1f3d36d8c3d3$exports))), {
                                                                    style: {
                                                                        color: '#4A67FF',
                                                                        fontSize: 20,
                                                                        flexShrink: 0
                                                                    }
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                                                                    style: {
                                                                        color: '#4A67FF',
                                                                        fontSize: 20,
                                                                        flexShrink: 0
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        colSpan: categoryList.length,
                                                        style: {
                                                            background: 'inherit'
                                                        },
                                                        "aria-hidden": true
                                                    })
                                                ]
                                            }),
                                            isOpen && (mod.sections || []).map((sec)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    style: $99670e8ba4de8a78$var$S.secRow,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            style: {
                                                                ...$99670e8ba4de8a78$var$S.secTd,
                                                                position: 'sticky',
                                                                left: 0,
                                                                zIndex: 2,
                                                                backgroundColor: '#fff',
                                                                boxShadow: '4px 0 10px -2px rgba(26, 29, 46, 0.08)'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $99670e8ba4de8a78$var$S.secNo,
                                                                        children: sec.sectionNo
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $99670e8ba4de8a78$var$S.secName,
                                                                        children: sec.sectionName
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        categoryList.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                style: $99670e8ba4de8a78$var$S.catTd,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "checkbox",
                                                                    style: $99670e8ba4de8a78$var$S.cb,
                                                                    checked: String(sec.categoryId) === String(cat._id),
                                                                    onChange: (e)=>handleAssign({
                                                                            moduleId: mod._id,
                                                                            sectionNo: sec.sectionNo,
                                                                            category: cat,
                                                                            valueAssign: e.target.checked
                                                                        })
                                                                })
                                                            }, cat._id))
                                                    ]
                                                }, `${mod._id}-${sec.sectionNo}`))
                                        ]
                                    }, mod._id);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $99670e8ba4de8a78$export$2e2bcd8739ae039 = $99670e8ba4de8a78$var$TempAllocationSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $6fc4429f0781aa53$var$S = {
    wrap: {
        padding: '1.5rem',
        background: '#f5f6fa',
        minHeight: 120
    },
    card: {
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e4e8f5',
        boxShadow: '0 2px 8px rgba(74,103,255,0.06)',
        overflow: 'hidden'
    },
    cardHead: {
        padding: '18px 24px 14px',
        borderBottom: '1px solid #f0f2ff'
    },
    title: {
        fontSize: '1.05rem',
        fontWeight: 700,
        color: '#1a1d2e',
        margin: 0
    },
    subtitle: {
        fontSize: '0.8rem',
        color: '#7c83a0',
        marginTop: 4
    },
    tableWrap: {
        overflowX: 'auto',
        width: '100%'
    },
    thead: {
        background: '#f8f9ff'
    },
    th: {
        padding: '10px 16px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'left',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    thCenter: {
        padding: '10px 14px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'center',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    row: (i)=>({
            borderBottom: '1px solid #f0f2ff',
            background: i % 2 === 0 ? '#fff' : '#fafbfe'
        }),
    modTd: {
        padding: '11px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 10
    },
    modAccent: {
        width: 3,
        height: 30,
        background: '#4A67FF',
        borderRadius: 2,
        flexShrink: 0
    },
    modName: {
        fontSize: '0.85rem',
        fontWeight: 600,
        color: '#1a1d2e'
    },
    modKey: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        flexShrink: 0
    },
    catTd: {
        textAlign: 'center',
        padding: '8px 14px'
    },
    cb: {
        width: 15,
        height: 15,
        accentColor: '#4A67FF',
        cursor: 'pointer'
    }
};
const $6fc4429f0781aa53$var$TempAllocationModule = ({ categoryList: categoryList })=>{
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchTempModules = async ()=>{
        setLoading(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/admin/temp-modules-admin', 'not-showMessage');
            if (res?.code === 200) setTempModules(res.body || []);
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchTempModules();
    }, []);
    const handleAssign = async ({ moduleId: moduleId, category: category, valueAssign: valueAssign })=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/admin/assign/category/temp-module', {
                moduleId: moduleId,
                categoryId: category._id,
                type: valueAssign
            });
            if (res?.code === 200) {
                setTempModules((prev)=>prev.map((mod)=>{
                        if (String(mod._id) !== String(moduleId)) return mod;
                        return {
                            ...mod,
                            categoryId: valueAssign ? category._id : null
                        };
                    }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message || 'Updated.');
            }
        } catch (err) {
            console.error(err);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic p2rem",
        style: {
            color: '#7c83a0'
        },
        children: "Loading\u2026"
    });
    const MODULE_COL_PX = 300;
    const CATEGORY_COL_PX = 100;
    const tableWidth = Math.max(MODULE_COL_PX + (categoryList?.length ?? 0) * CATEGORY_COL_PX, 520);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $6fc4429f0781aa53$var$S.wrap,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: $6fc4429f0781aa53$var$S.card,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $6fc4429f0781aa53$var$S.cardHead,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $6fc4429f0781aa53$var$S.title,
                            children: "Temp Allocation Module Management"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $6fc4429f0781aa53$var$S.subtitle,
                            children: "Assign a category to each temp module. Only one category can be active per module."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: $6fc4429f0781aa53$var$S.tableWrap,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        style: {
                            width: tableWidth,
                            minWidth: '100%',
                            borderCollapse: 'collapse'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("colgroup", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                        style: {
                                            width: MODULE_COL_PX
                                        }
                                    }),
                                    categoryList.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                            style: {
                                                width: CATEGORY_COL_PX
                                            }
                                        }, cat._id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                style: $6fc4429f0781aa53$var$S.thead,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: $6fc4429f0781aa53$var$S.th,
                                            children: "Module"
                                        }),
                                        categoryList.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                style: $6fc4429f0781aa53$var$S.thCenter,
                                                children: cat.name
                                            }, cat._id))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: tempModules.map((mod, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: $6fc4429f0781aa53$var$S.row(i),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: $6fc4429f0781aa53$var$S.modTd,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: $6fc4429f0781aa53$var$S.modAccent
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                flex: 1,
                                                                minWidth: 0
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: $6fc4429f0781aa53$var$S.modName,
                                                                children: mod.moduleName
                                                            })
                                                        }),
                                                        mod.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: $6fc4429f0781aa53$var$S.modKey,
                                                            children: mod.moduleKey
                                                        })
                                                    ]
                                                })
                                            }),
                                            categoryList.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: $6fc4429f0781aa53$var$S.catTd,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        style: $6fc4429f0781aa53$var$S.cb,
                                                        checked: String(mod.categoryId) === String(cat._id),
                                                        onChange: (e)=>handleAssign({
                                                                moduleId: mod._id,
                                                                category: cat,
                                                                valueAssign: e.target.checked
                                                            })
                                                    })
                                                }, cat._id))
                                        ]
                                    }, mod._id))
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $6fc4429f0781aa53$export$2e2bcd8739ae039 = $6fc4429f0781aa53$var$TempAllocationModule;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $913a399376c17482$var$S = {
    wrap: {
        padding: '1.5rem',
        background: '#f5f6fa',
        minHeight: 120
    },
    card: {
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e4e8f5',
        boxShadow: '0 2px 8px rgba(74,103,255,0.06)',
        overflow: 'hidden'
    },
    cardHead: {
        padding: '18px 24px 14px',
        borderBottom: '1px solid #f0f2ff'
    },
    title: {
        fontSize: '1.05rem',
        fontWeight: 700,
        color: '#1a1d2e',
        margin: 0
    },
    subtitle: {
        fontSize: '0.8rem',
        color: '#7c83a0',
        marginTop: 4
    },
    tableWrap: {
        overflowX: 'auto',
        width: '100%'
    },
    thead: {
        background: '#f8f9ff'
    },
    th: {
        padding: '10px 16px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'left',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    modRow: {
        cursor: 'pointer',
        borderTop: '2px solid #e8eaf5',
        background: 'linear-gradient(90deg,#f0f3ff 0%,#f8f9ff 100%)',
        userSelect: 'none'
    },
    modTd: {
        padding: '10px 16px'
    },
    modAccent: {
        width: 3,
        height: 34,
        background: '#4A67FF',
        borderRadius: 2,
        flexShrink: 0
    },
    modName: {
        fontSize: '0.88rem',
        fontWeight: 700,
        color: '#1a1d2e'
    },
    modKey: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        flexShrink: 0
    },
    modMeta: {
        fontSize: '0.72rem',
        color: '#9aa0b8'
    },
    secRow: {
        borderBottom: '1px solid #f0f2ff',
        background: '#fff'
    },
    secTd: {
        padding: '9px 12px 9px 32px',
        width: '40%'
    },
    secNo: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        whiteSpace: 'nowrap',
        flexShrink: 0
    },
    secName: {
        fontSize: '0.82rem',
        color: '#374151'
    },
    advisorTd: {
        padding: '7px 16px 7px 12px',
        width: '60%'
    }
};
const $913a399376c17482$var$useFeaturedSelectStyles = ()=>(0, $acw62.useMemo)(()=>({
            ...(0, $1eef38cfda4b0c52$export$edf5b2501a573922),
            control: (p, s)=>({
                    ...(0, $1eef38cfda4b0c52$export$edf5b2501a573922).control(p, s),
                    minHeight: 34,
                    fontSize: '13px',
                    border: '1px solid #e2e5ef',
                    borderRadius: 8,
                    backgroundColor: '#fff',
                    boxShadow: s.isFocused ? '0 0 0 2px rgba(74,103,255,0.18)' : 'none'
                }),
            valueContainer: (p)=>({
                    ...(0, $1eef38cfda4b0c52$export$edf5b2501a573922).valueContainer(p),
                    padding: '3px 10px'
                }),
            indicatorsContainer: (p)=>({
                    ...p,
                    height: 32
                }),
            menu: (p, s)=>({
                    ...(0, $1eef38cfda4b0c52$export$edf5b2501a573922).menu(p, s),
                    width: 'max(100%,220px)',
                    zIndex: 10021
                }),
            menuPortal: (b)=>({
                    ...b,
                    zIndex: 10021
                }),
            singleValue: (p)=>({
                    ...p,
                    fontSize: '13px',
                    color: '#1a1d2e'
                }),
            placeholder: (p)=>({
                    ...(0, $1eef38cfda4b0c52$export$edf5b2501a573922).placeholder(p),
                    fontSize: '13px',
                    color: '#b0b7cc'
                })
        }), []);
const $913a399376c17482$var$TempFeaturedBusinessCards = ()=>{
    const selectStyles = $913a399376c17482$var$useFeaturedSelectStyles();
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [advisorsData, setAdvisorsData] = (0, $acw62.useState)([]);
    const [allocations, setAllocations] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchAll = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const [modulesRes, advisorsRes, allocRes] = await Promise.all([
                (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/admin/temp-modules-admin', 'not-showMessage'),
                (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/user/getAllMainAdvisors', 'not-showMessage'),
                (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/userAllocation/temp-section', 'not-showMessage')
            ]);
            if (modulesRes?.code === 200) setTempModules(modulesRes.body || []);
            if (advisorsRes?.code === 200) setAdvisorsData((advisorsRes.body || []).map((a)=>({
                    ...a,
                    label: `${a.firstName ?? ''} ${a.lastName ?? ''}`.trim(),
                    value: String(a._id),
                    advisorTypeName: a.advisorType?.name ? `(${a.advisorType.name})` : ''
                })));
            if (allocRes?.code === 200) setAllocations(allocRes.body || []);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchAll();
    }, [
        fetchAll
    ]);
    const toggleAccordion = (moduleId)=>setOpenAccordions((prev)=>({
                ...prev,
                [moduleId]: !prev[moduleId]
            }));
    const getSelectedAdvisor = (sectionNo, moduleId)=>{
        const alloc = allocations.find((a)=>a.sectionNo === sectionNo && String(a.moduleId) === String(moduleId));
        if (!alloc) return null;
        return advisorsData.find((a)=>String(a._id) === String(alloc.advisorId)) || null;
    };
    const handleAllocation = async ({ advisorId: advisorId, sectionNo: sectionNo, moduleId: moduleId })=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/userAllocation/temp-section', {
                advisorId: advisorId || null,
                sectionNo: sectionNo,
                moduleId: moduleId
            });
            if (res?.code === 200) setAllocations(res.body || []);
        } catch (err) {
            console.error(err);
        }
    };
    const formatOptionLabel = ({ label: label, advisorTypeName: advisorTypeName })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        textTransform: 'capitalize',
                        color: '#1a1d2e'
                    },
                    children: label
                }),
                advisorTypeName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        fontSize: '0.75rem',
                        color: '#7c83a0'
                    },
                    children: advisorTypeName
                })
            ]
        });
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic p2rem",
        style: {
            color: '#7c83a0'
        },
        children: "Loading\u2026"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $913a399376c17482$var$S.wrap,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: $913a399376c17482$var$S.card,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $913a399376c17482$var$S.cardHead,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $913a399376c17482$var$S.title,
                            children: "Featured Business Cards Management"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $913a399376c17482$var$S.subtitle,
                            children: "Assign a featured advisor to each module section. Expand a module to configure its sections."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: $913a399376c17482$var$S.tableWrap,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        style: {
                            width: '100%',
                            borderCollapse: 'collapse'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                style: $913a399376c17482$var$S.thead,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$913a399376c17482$var$S.th,
                                                width: '40%'
                                            },
                                            children: "Section"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$913a399376c17482$var$S.th,
                                                width: '60%'
                                            },
                                            children: "Featured Advisor"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: tempModules.filter((mod)=>mod.sections?.length > 0).map((mod)=>{
                                    const isOpen = !!openAccordions[mod._id];
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                style: $913a399376c17482$var$S.modRow,
                                                onClick: ()=>toggleAccordion(mod._id),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    colSpan: 2,
                                                    style: $913a399376c17482$var$S.modTd,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: $913a399376c17482$var$S.modAccent
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    flex: 1,
                                                                    minWidth: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        style: $913a399376c17482$var$S.modName,
                                                                        children: mod.moduleName
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        style: {
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: 6,
                                                                            marginTop: 3
                                                                        },
                                                                        children: [
                                                                            mod.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: $913a399376c17482$var$S.modKey,
                                                                                children: mod.moduleKey
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                style: $913a399376c17482$var$S.modMeta,
                                                                                children: [
                                                                                    mod.sections?.length || 0,
                                                                                    " section",
                                                                                    mod.sections?.length !== 1 ? 's' : ''
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e6a1f3d36d8c3d3$exports))), {
                                                                style: {
                                                                    color: '#4A67FF',
                                                                    fontSize: 20,
                                                                    flexShrink: 0
                                                                }
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                                                                style: {
                                                                    color: '#4A67FF',
                                                                    fontSize: 20,
                                                                    flexShrink: 0
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            isOpen && (mod.sections || []).map((sec)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    style: $913a399376c17482$var$S.secRow,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            style: $913a399376c17482$var$S.secTd,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $913a399376c17482$var$S.secNo,
                                                                        children: sec.sectionNo
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $913a399376c17482$var$S.secName,
                                                                        children: sec.sectionName
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            style: $913a399376c17482$var$S.advisorTd,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                                placeholder: "Select advisor\u2026",
                                                                isClearable: true,
                                                                styles: selectStyles,
                                                                formatOptionLabel: formatOptionLabel,
                                                                value: getSelectedAdvisor(sec.sectionNo, mod._id),
                                                                options: advisorsData,
                                                                menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
                                                                menuPosition: "fixed",
                                                                onChange: (advisor)=>handleAllocation({
                                                                        advisorId: advisor ? advisor._id : null,
                                                                        sectionNo: sec.sectionNo,
                                                                        moduleId: mod._id
                                                                    })
                                                            })
                                                        })
                                                    ]
                                                }, `${mod._id}-${sec.sectionNo}`))
                                        ]
                                    }, mod._id);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $913a399376c17482$export$2e2bcd8739ae039 = $913a399376c17482$var$TempFeaturedBusinessCards;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $3d3dcf0caacf496c$var$QUESTION_TYPES = [
    {
        value: 'D/ND',
        label: 'D / ND'
    },
    {
        value: '1to5',
        label: '1 to 5'
    },
    {
        value: 'YN/F/T',
        label: 'Yes | No | N/A'
    },
    {
        value: 'Multi',
        label: 'Multi'
    },
    {
        value: 'textarea',
        label: 'Textarea'
    }
];
// isGroup = parent checkbox that drives both toolboxPolicyMaker + toolboxAnalyser together.
const $3d3dcf0caacf496c$var$CHECKBOX_ROWS = [
    {
        field: 'files',
        label: 'Files'
    },
    {
        field: 'collaborate',
        label: 'Collaborate'
    },
    {
        field: 'toolboxGroup',
        label: 'Toolbox',
        isGroup: true
    },
    {
        field: 'toolboxPolicyMaker',
        label: 'Policy Maker',
        indent: true
    },
    {
        field: 'toolboxAnalyser',
        label: 'Analyser',
        indent: true
    },
    {
        field: 'showTooltip',
        label: 'Show Tooltip',
        defaultTrue: true
    },
    {
        field: 'showToolbox',
        label: 'Show Toolbox',
        defaultTrue: true
    }
];
const $3d3dcf0caacf496c$var$S = {
    wrap: {
        padding: '1.5rem',
        background: '#f5f6fa',
        minHeight: 120
    },
    card: {
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e4e8f5',
        boxShadow: '0 2px 8px rgba(74,103,255,0.06)',
        overflow: 'hidden'
    },
    cardHead: {
        padding: '18px 24px 14px',
        borderBottom: '1px solid #f0f2ff'
    },
    title: {
        fontSize: '1.05rem',
        fontWeight: 700,
        color: '#1a1d2e',
        margin: 0
    },
    subtitle: {
        fontSize: '0.8rem',
        color: '#7c83a0',
        marginTop: 4
    },
    tableWrap: {
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '70vh',
        width: '100%',
        WebkitOverflowScrolling: 'touch'
    },
    thead: {
        background: '#f8f9ff'
    },
    th: {
        padding: '10px 14px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'left',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    thCenter: {
        padding: '10px 14px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'center',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    modRow: {
        background: 'linear-gradient(90deg,#f0f3ff 0%,#f8f9ff 100%)',
        cursor: 'pointer',
        borderTop: '2px solid rgb(36, 62, 207)',
        userSelect: 'none'
    },
    modTd: {
        padding: '10px 16px'
    },
    modColTd: {
        padding: '6px 14px',
        textAlign: 'center',
        verticalAlign: 'middle',
        borderLeft: '1px solid #e0e4f0'
    },
    modAccent: {
        width: 3,
        height: 34,
        background: '#4A67FF',
        borderRadius: 2,
        flexShrink: 0
    },
    modName: {
        fontSize: '0.88rem',
        fontWeight: 700,
        color: '#1a1d2e'
    },
    modKey: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        flexShrink: 0
    },
    modMeta: {
        fontSize: '0.72rem',
        color: '#9aa0b8'
    },
    selectAllLabel: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        cursor: 'pointer',
        fontSize: 11,
        color: '#4A67FF',
        fontWeight: 600,
        userSelect: 'none'
    },
    secRow: {
        background: '#fff',
        transition: 'background .1s'
    },
    secTd: {
        padding: '10px 12px 10px 32px',
        borderBottom: '1px solid #d0d5e8'
    },
    secNo: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        whiteSpace: 'nowrap',
        flexShrink: 0
    },
    secName: {
        fontSize: '0.82rem',
        color: '#374151'
    },
    qtTd: {
        textAlign: 'left',
        padding: '10px 14px',
        verticalAlign: 'top',
        borderLeft: '1px solid #eaecf5',
        borderBottom: '1px solid #d0d5e8'
    },
    cb: {
        width: 13,
        height: 13,
        accentColor: '#4A67FF',
        cursor: 'pointer',
        flexShrink: 0,
        marginTop: 1
    },
    cbLabel: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 5,
        cursor: 'pointer',
        fontSize: 11,
        color: '#374151',
        lineHeight: '16px',
        userSelect: 'none'
    },
    cbLabelGroup: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 5,
        cursor: 'pointer',
        fontSize: 11,
        color: '#4A67FF',
        fontWeight: 600,
        lineHeight: '16px',
        userSelect: 'none',
        marginTop: 4
    }
};
const $3d3dcf0caacf496c$var$ToolboxManagement = ()=>{
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchModules = async ()=>{
        setLoading(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/toolbox/temp-modules', 'not-showMessage');
            if (res?.code === 200) setTempModules(res.body || []);
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchModules();
    }, []);
    const toggleAccordion = (moduleId)=>setOpenAccordions((prev)=>({
                [moduleId]: !prev[moduleId]
            }));
    // Single-field toggle.
    const handleAssign = async ({ moduleId: moduleId, sectionNo: sectionNo, questionType: questionType, field: field, assign: assign })=>{
        setTempModules((prev)=>prev.map((mod)=>{
                if (String(mod._id) !== String(moduleId)) return mod;
                return {
                    ...mod,
                    sections: mod.sections.map((sec)=>{
                        if (sec.sectionNo !== sectionNo) return sec;
                        const cfg = {
                            ...sec.toolboxConfig || {}
                        };
                        cfg[questionType] = {
                            ...cfg[questionType] || {},
                            [field]: assign
                        };
                        return {
                            ...sec,
                            toolboxConfig: cfg
                        };
                    })
                };
            }));
        try {
            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/toolbox/assign', {
                moduleId: moduleId,
                sectionNo: sectionNo,
                questionType: questionType,
                field: field,
                assign: assign
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Updated.');
        } catch (err) {
            console.error(err);
        }
    };
    // Toolbox group — sets both children.
    const handleToolboxGroup = async ({ moduleId: moduleId, sectionNo: sectionNo, questionType: questionType, assign: assign })=>{
        setTempModules((prev)=>prev.map((mod)=>{
                if (String(mod._id) !== String(moduleId)) return mod;
                return {
                    ...mod,
                    sections: mod.sections.map((sec)=>{
                        if (sec.sectionNo !== sectionNo) return sec;
                        const cfg = {
                            ...sec.toolboxConfig || {}
                        };
                        cfg[questionType] = {
                            ...cfg[questionType] || {},
                            toolboxPolicyMaker: assign,
                            toolboxAnalyser: assign
                        };
                        return {
                            ...sec,
                            toolboxConfig: cfg
                        };
                    })
                };
            }));
        try {
            await Promise.all([
                (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/toolbox/assign', {
                    moduleId: moduleId,
                    sectionNo: sectionNo,
                    questionType: questionType,
                    field: 'toolboxPolicyMaker',
                    assign: assign
                }),
                (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/toolbox/assign', {
                    moduleId: moduleId,
                    sectionNo: sectionNo,
                    questionType: questionType,
                    field: 'toolboxAnalyser',
                    assign: assign
                })
            ]);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Toolbox updated.');
        } catch (err) {
            console.error(err);
        }
    };
    // Module-level column Select All — sets/clears all fields for every section in that column.
    const handleSelectAll = async ({ moduleId: moduleId, questionType: questionType, assign: assign })=>{
        setTempModules((prev)=>prev.map((mod)=>{
                if (String(mod._id) !== String(moduleId)) return mod;
                return {
                    ...mod,
                    sections: mod.sections.map((sec)=>{
                        const cfg = {
                            ...sec.toolboxConfig || {}
                        };
                        const prev = cfg[questionType] || {};
                        cfg[questionType] = {
                            ...prev,
                            files: assign,
                            collaborate: assign,
                            toolboxPolicyMaker: assign,
                            toolboxAnalyser: assign,
                            showTooltip: assign,
                            showToolbox: assign
                        };
                        return {
                            ...sec,
                            toolboxConfig: cfg
                        };
                    })
                };
            }));
        try {
            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/toolbox/assign-column', {
                moduleId: moduleId,
                questionType: questionType,
                assign: assign
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(assign ? 'All sections selected.' : 'All sections cleared.');
        } catch (err) {
            console.error(err);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic p2rem",
        style: {
            color: '#7c83a0'
        },
        children: "Loading\u2026"
    });
    const SECTION_COL_PX = 260;
    const QT_COL_PX = 120;
    const tableWidth = Math.max(SECTION_COL_PX + $3d3dcf0caacf496c$var$QUESTION_TYPES.length * QT_COL_PX, 600);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $3d3dcf0caacf496c$var$S.wrap,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: $3d3dcf0caacf496c$var$S.card,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $3d3dcf0caacf496c$var$S.cardHead,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $3d3dcf0caacf496c$var$S.title,
                            children: "Toolbox Management"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $3d3dcf0caacf496c$var$S.subtitle,
                            children: "Configure toolbox options per question type for each section. "
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: $3d3dcf0caacf496c$var$S.tableWrap,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        style: {
                            width: tableWidth,
                            minWidth: '100%',
                            borderCollapse: 'separate',
                            borderSpacing: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("colgroup", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                        style: {
                                            width: SECTION_COL_PX
                                        }
                                    }),
                                    $3d3dcf0caacf496c$var$QUESTION_TYPES.map((qt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                            style: {
                                                width: QT_COL_PX
                                            }
                                        }, qt.value))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                style: $3d3dcf0caacf496c$var$S.thead,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$3d3dcf0caacf496c$var$S.th,
                                                position: 'sticky',
                                                left: 0,
                                                top: 0,
                                                zIndex: 4,
                                                backgroundColor: '#f8f9ff',
                                                boxShadow: '4px 0 10px -2px rgba(26,29,46,0.12)'
                                            },
                                            children: "Section"
                                        }),
                                        $3d3dcf0caacf496c$var$QUESTION_TYPES.map((qt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                style: {
                                                    ...$3d3dcf0caacf496c$var$S.thCenter,
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 3,
                                                    backgroundColor: '#f8f9ff'
                                                },
                                                children: qt.label
                                            }, qt.value))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: tempModules.map((mod)=>{
                                    const isOpen = !!openAccordions[mod._id];
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                style: $3d3dcf0caacf496c$var$S.modRow,
                                                onClick: ()=>toggleAccordion(mod._id),
                                                role: "button",
                                                tabIndex: 0,
                                                onKeyDown: (e)=>(e.key === 'Enter' || e.key === ' ') && toggleAccordion(mod._id),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            ...$3d3dcf0caacf496c$var$S.modTd,
                                                            position: 'sticky',
                                                            left: 0,
                                                            zIndex: 2,
                                                            background: 'linear-gradient(90deg,#f0f3ff 0%,#f8f9ff 100%)',
                                                            boxShadow: '4px 0 10px -2px rgba(26,29,46,0.08)'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    style: $3d3dcf0caacf496c$var$S.modAccent
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    style: {
                                                                        flex: 1,
                                                                        minWidth: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            style: $3d3dcf0caacf496c$var$S.modName,
                                                                            children: mod.moduleName
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            style: {
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: 6,
                                                                                marginTop: 3
                                                                            },
                                                                            children: [
                                                                                mod.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    style: $3d3dcf0caacf496c$var$S.modKey,
                                                                                    children: mod.moduleKey
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    style: $3d3dcf0caacf496c$var$S.modMeta,
                                                                                    children: [
                                                                                        mod.sections?.length || 0,
                                                                                        " section",
                                                                                        mod.sections?.length !== 1 ? 's' : ''
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e6a1f3d36d8c3d3$exports))), {
                                                                    style: {
                                                                        color: '#4A67FF',
                                                                        fontSize: 20,
                                                                        flexShrink: 0
                                                                    }
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                                                                    style: {
                                                                        color: '#4A67FF',
                                                                        fontSize: 20,
                                                                        flexShrink: 0
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    $3d3dcf0caacf496c$var$QUESTION_TYPES.map((qt)=>{
                                                        const sections = mod.sections || [];
                                                        const allSel = sections.length > 0 && sections.every((sec)=>{
                                                            const cfg = (sec.toolboxConfig || {})[qt.value] || {};
                                                            return cfg.files && cfg.collaborate && cfg.toolboxPolicyMaker && cfg.toolboxAnalyser && cfg.showTooltip !== false && cfg.showToolbox !== false;
                                                        });
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            style: $3d3dcf0caacf496c$var$S.modColTd,
                                                            onClick: (e)=>e.stopPropagation(),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                style: $3d3dcf0caacf496c$var$S.selectAllLabel,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "checkbox",
                                                                        style: $3d3dcf0caacf496c$var$S.cb,
                                                                        checked: allSel,
                                                                        onChange: (e)=>handleSelectAll({
                                                                                moduleId: mod._id,
                                                                                questionType: qt.value,
                                                                                assign: e.target.checked
                                                                            })
                                                                    }),
                                                                    "Select All"
                                                                ]
                                                            })
                                                        }, qt.value);
                                                    })
                                                ]
                                            }),
                                            isOpen && (mod.sections || []).map((sec)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    style: $3d3dcf0caacf496c$var$S.secRow,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            style: {
                                                                ...$3d3dcf0caacf496c$var$S.secTd,
                                                                position: 'sticky',
                                                                left: 0,
                                                                zIndex: 2,
                                                                backgroundColor: '#fff',
                                                                boxShadow: '4px 0 10px -2px rgba(26,29,46,0.08)'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 8
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $3d3dcf0caacf496c$var$S.secNo,
                                                                        children: sec.sectionNo
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $3d3dcf0caacf496c$var$S.secName,
                                                                        children: sec.sectionName
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        $3d3dcf0caacf496c$var$QUESTION_TYPES.map((qt)=>{
                                                            const cfg = (sec.toolboxConfig || {})[qt.value] || {};
                                                            const toolboxGroupChecked = !!(cfg.toolboxPolicyMaker && cfg.toolboxAnalyser);
                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                style: $3d3dcf0caacf496c$var$S.qtTd,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    style: {
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        gap: 4
                                                                    },
                                                                    children: $3d3dcf0caacf496c$var$CHECKBOX_ROWS.map((row, ri)=>{
                                                                        const id = `cb-${mod._id}-${sec.sectionNo}-${qt.value}-${row.field || ri}`;
                                                                        if (row.isGroup) return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            htmlFor: id,
                                                                            style: $3d3dcf0caacf496c$var$S.cbLabelGroup,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    id: id,
                                                                                    type: "checkbox",
                                                                                    style: $3d3dcf0caacf496c$var$S.cb,
                                                                                    checked: toolboxGroupChecked,
                                                                                    onChange: (e)=>handleToolboxGroup({
                                                                                            moduleId: mod._id,
                                                                                            sectionNo: sec.sectionNo,
                                                                                            questionType: qt.value,
                                                                                            assign: e.target.checked
                                                                                        })
                                                                                }),
                                                                                row.label
                                                                            ]
                                                                        }, "toolboxGroup");
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            htmlFor: id,
                                                                            style: {
                                                                                ...$3d3dcf0caacf496c$var$S.cbLabel,
                                                                                paddingLeft: row.indent ? 10 : 0
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    id: id,
                                                                                    type: "checkbox",
                                                                                    style: $3d3dcf0caacf496c$var$S.cb,
                                                                                    checked: row.defaultTrue ? cfg[row.field] !== false : !!cfg[row.field],
                                                                                    onChange: (e)=>handleAssign({
                                                                                            moduleId: mod._id,
                                                                                            sectionNo: sec.sectionNo,
                                                                                            questionType: qt.value,
                                                                                            field: row.field,
                                                                                            assign: e.target.checked
                                                                                        })
                                                                                }),
                                                                                row.label
                                                                            ]
                                                                        }, row.field);
                                                                    })
                                                                })
                                                            }, qt.value);
                                                        })
                                                    ]
                                                }, `${mod._id}-${sec.sectionNo}`))
                                        ]
                                    }, mod._id);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $3d3dcf0caacf496c$export$2e2bcd8739ae039 = $3d3dcf0caacf496c$var$ToolboxManagement;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $ccc37b720d59461a$var$S = {
    wrap: {
        padding: '1.5rem',
        background: '#f5f6fa',
        minHeight: 120
    },
    card: {
        background: '#fff',
        borderRadius: 12,
        border: '1px solid #e4e8f5',
        boxShadow: '0 2px 8px rgba(74,103,255,0.06)',
        overflow: 'hidden'
    },
    cardHead: {
        padding: '18px 24px 14px',
        borderBottom: '1px solid #f0f2ff'
    },
    title: {
        fontSize: '1.05rem',
        fontWeight: 700,
        color: '#1a1d2e',
        margin: 0
    },
    subtitle: {
        fontSize: '0.8rem',
        color: '#7c83a0',
        marginTop: 4
    },
    tableWrap: {
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '70vh',
        width: '100%',
        WebkitOverflowScrolling: 'touch'
    },
    thead: {
        background: '#f8f9ff'
    },
    th: {
        padding: '10px 14px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'left',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    thCenter: {
        padding: '10px 14px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        color: '#7c83a0',
        textAlign: 'center',
        borderBottom: '2px solid #e8eaf5',
        whiteSpace: 'nowrap'
    },
    modRow: {
        background: 'linear-gradient(90deg,#f0f3ff 0%,#f8f9ff 100%)',
        cursor: 'pointer',
        borderTop: '2px solid rgb(36, 62, 207)',
        userSelect: 'none'
    },
    modTd: {
        padding: '10px 16px'
    },
    modAccent: {
        width: 3,
        height: 34,
        background: '#4A67FF',
        borderRadius: 2,
        flexShrink: 0
    },
    modName: {
        fontSize: '0.88rem',
        fontWeight: 700,
        color: '#1a1d2e'
    },
    modKey: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        flexShrink: 0
    },
    modMeta: {
        fontSize: '0.72rem',
        color: '#9aa0b8'
    },
    secRow: {
        background: '#fff'
    },
    sfRow: {
        background: '#fafbff'
    },
    secTd: {
        padding: '10px 12px 10px 32px',
        borderBottom: '1px solid #d0d5e8'
    },
    sfTd: {
        padding: '8px 12px 8px 52px',
        borderBottom: '1px solid #eaecf5'
    },
    secNo: {
        fontSize: '0.68rem',
        fontWeight: 700,
        color: '#4A67FF',
        background: '#eef0ff',
        padding: '2px 8px',
        borderRadius: 10,
        whiteSpace: 'nowrap',
        flexShrink: 0
    },
    sfNo: {
        fontSize: '0.65rem',
        fontWeight: 600,
        color: '#7c83a0',
        background: '#f5f6fa',
        padding: '2px 6px',
        borderRadius: 8,
        whiteSpace: 'nowrap',
        flexShrink: 0
    },
    secName: {
        fontSize: '0.82rem',
        color: '#374151'
    },
    sfName: {
        fontSize: '0.78rem',
        color: '#6b7280'
    },
    fieldTd: {
        padding: '10px 14px',
        verticalAlign: 'top',
        borderLeft: '1px solid #eaecf5',
        borderBottom: '1px solid #d0d5e8'
    },
    sfFieldTd: {
        padding: '8px 14px',
        verticalAlign: 'top',
        borderLeft: '1px solid #eaecf5',
        borderBottom: '1px solid #eaecf5'
    },
    statusTd: {
        padding: '10px 14px',
        verticalAlign: 'middle',
        textAlign: 'center',
        borderLeft: '1px solid #eaecf5',
        borderBottom: '1px solid #d0d5e8'
    },
    sfStatusTd: {
        padding: '8px 14px',
        verticalAlign: 'middle',
        textAlign: 'center',
        borderLeft: '1px solid #eaecf5',
        borderBottom: '1px solid #eaecf5'
    },
    savingLabel: {
        fontSize: '0.68rem',
        color: '#9aa0b8',
        marginTop: 4
    },
    textInput: {
        width: '100%',
        borderRadius: 6,
        border: '1px solid #d0d5e8',
        padding: '6px 10px',
        fontSize: '0.8rem',
        color: '#374151',
        outline: 'none',
        fontFamily: 'inherit',
        background: '#fff',
        boxSizing: 'border-box'
    }
};
const $ccc37b720d59461a$var$SECTION_COL_PX = 260;
const $ccc37b720d59461a$var$STATUS_COL_PX = 80;
const $ccc37b720d59461a$var$QTV_COL_PX = 200;
const $ccc37b720d59461a$var$PROMPT_COL_PX = 480;
// Key for section-level entries
const $ccc37b720d59461a$var$mkKey = (moduleId, sectionNo)=>`${moduleId}-${sectionNo}`;
// Key for subfolder-level entries
const $ccc37b720d59461a$var$mkSfKey = (moduleId, sectionNo, sfKey)=>`${moduleId}-${sectionNo}-sf-${sfKey}`;
// Returns sorted subfolder entries from a subFolders object
const $ccc37b720d59461a$var$getSortedSubFolders = (subFolders)=>{
    if (!subFolders || typeof subFolders !== 'object') return [];
    return Object.keys(subFolders).sort((a, b)=>parseInt(a) - parseInt(b)).map((key)=>({
            sfKey: key,
            ...subFolders[key]
        }));
};
// Checkbox label component (shared between sections and subfolders)
const $ccc37b720d59461a$var$StatusCheckbox = ({ checked: checked, onChange: onChange, disabled: disabled })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            cursor: 'pointer',
            fontSize: 11,
            color: checked ? '#09B255' : '#9aa0b8',
            fontWeight: 600,
            userSelect: 'none'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: onChange,
                disabled: disabled,
                style: {
                    width: 14,
                    height: 14,
                    accentColor: '#4A67FF',
                    cursor: 'pointer'
                }
            }),
            checked ? 'Active' : 'Inactive'
        ]
    });
const $ccc37b720d59461a$var$TempAnalyser = ()=>{
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)({}); // { [key]: { prompt, queryToVector, isActive } }
    const [saving, setSaving] = (0, $acw62.useState)({});
    const fetchModules = async ()=>{
        setLoading(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/toolbox/temp-modules', 'not-showMessage');
            if (res?.code === 200) {
                const modules = res.body || [];
                setTempModules(modules);
                const initial = {};
                modules.forEach((mod)=>{
                    (mod.sections || []).forEach((sec)=>{
                        initial[$ccc37b720d59461a$var$mkKey(mod._id, sec.sectionNo)] = {
                            prompt: sec.analyserPrompt || '',
                            queryToVector: sec.analyserQueryToVector || '',
                            isActive: sec.analyserIsActive || false
                        };
                        // Init subfolder state
                        $ccc37b720d59461a$var$getSortedSubFolders(sec.subFolders).forEach(({ sfKey: sfKey })=>{
                            const sfCfg = (sec.analyserSubFolderConfig || {})[sfKey] || {};
                            initial[$ccc37b720d59461a$var$mkSfKey(mod._id, sec.sectionNo, sfKey)] = {
                                prompt: sfCfg.prompt || '',
                                queryToVector: sfCfg.queryToVector || '',
                                isActive: sfCfg.isActive || false
                            };
                        });
                    });
                });
                setData(initial);
            }
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchModules();
    }, []);
    const toggleAccordion = (moduleId)=>setOpenAccordions((prev)=>({
                [moduleId]: !prev[moduleId]
            }));
    const handleField = (key, field, value)=>setData((prev)=>({
                ...prev,
                [key]: {
                    ...prev[key],
                    [field]: value
                }
            }));
    // Get the original values for a section from tempModules (for dirty check)
    const getOriginalSection = (moduleId, sectionNo)=>{
        const mod = tempModules.find((m)=>String(m._id) === String(moduleId));
        const sec = mod?.sections?.find((s)=>s.sectionNo === sectionNo);
        return {
            prompt: sec?.analyserPrompt || '',
            queryToVector: sec?.analyserQueryToVector || '',
            isActive: sec?.analyserIsActive || false
        };
    };
    // Get the original values for a subfolder
    const getOriginalSubFolder = (moduleId, sectionNo, sfKey)=>{
        const mod = tempModules.find((m)=>String(m._id) === String(moduleId));
        const sec = mod?.sections?.find((s)=>s.sectionNo === sectionNo);
        const sfCfg = (sec?.analyserSubFolderConfig || {})[sfKey] || {};
        return {
            prompt: sfCfg.prompt || '',
            queryToVector: sfCfg.queryToVector || '',
            isActive: sfCfg.isActive || false
        };
    };
    const saveSection = async (moduleId, sectionNo, overrideData)=>{
        const key = $ccc37b720d59461a$var$mkKey(moduleId, sectionNo);
        const current = overrideData || data[key] || {};
        const orig = getOriginalSection(moduleId, sectionNo);
        if (current.prompt === orig.prompt && current.queryToVector === orig.queryToVector && current.isActive === orig.isActive) return;
        setSaving((prev)=>({
                ...prev,
                [key]: true
            }));
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/toolbox/save-section-prompt', {
                moduleId: moduleId,
                sectionNo: sectionNo,
                prompt: current.prompt || '',
                queryToVector: current.queryToVector || '',
                isActive: current.isActive || false
            });
            if (res?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Saved.');
                setTempModules((prev)=>prev.map((m)=>{
                        if (String(m._id) !== String(moduleId)) return m;
                        return {
                            ...m,
                            sections: m.sections.map((s)=>s.sectionNo === sectionNo ? {
                                    ...s,
                                    analyserPrompt: current.prompt || '',
                                    analyserQueryToVector: current.queryToVector || '',
                                    analyserIsActive: current.isActive || false
                                } : s)
                        };
                    }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to save.');
        } catch (err) {
            console.error(err);
        } finally{
            setSaving((prev)=>({
                    ...prev,
                    [key]: false
                }));
        }
    };
    const saveSubFolder = async (moduleId, sectionNo, sfKey, overrideData)=>{
        const key = $ccc37b720d59461a$var$mkSfKey(moduleId, sectionNo, sfKey);
        const current = overrideData || data[key] || {};
        const orig = getOriginalSubFolder(moduleId, sectionNo, sfKey);
        if (current.prompt === orig.prompt && current.queryToVector === orig.queryToVector && current.isActive === orig.isActive) return;
        setSaving((prev)=>({
                ...prev,
                [key]: true
            }));
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/toolbox/save-subfolder-prompt', {
                moduleId: moduleId,
                sectionNo: sectionNo,
                subFolderKey: sfKey,
                prompt: current.prompt || '',
                queryToVector: current.queryToVector || '',
                isActive: current.isActive || false
            });
            if (res?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Saved.');
                setTempModules((prev)=>prev.map((m)=>{
                        if (String(m._id) !== String(moduleId)) return m;
                        return {
                            ...m,
                            sections: m.sections.map((s)=>{
                                if (s.sectionNo !== sectionNo) return s;
                                const prevCfg = s.analyserSubFolderConfig || {};
                                return {
                                    ...s,
                                    analyserSubFolderConfig: {
                                        ...prevCfg,
                                        [sfKey]: {
                                            prompt: current.prompt || '',
                                            queryToVector: current.queryToVector || '',
                                            isActive: current.isActive || false
                                        }
                                    }
                                };
                            })
                        };
                    }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to save.');
        } catch (err) {
            console.error(err);
        } finally{
            setSaving((prev)=>({
                    ...prev,
                    [key]: false
                }));
        }
    };
    const handleSectionCheckbox = (moduleId, sectionNo, checked)=>{
        const key = $ccc37b720d59461a$var$mkKey(moduleId, sectionNo);
        const updated = {
            ...data[key],
            isActive: checked
        };
        handleField(key, 'isActive', checked);
        saveSection(moduleId, sectionNo, updated);
    };
    const handleSfCheckbox = (moduleId, sectionNo, sfKey, checked)=>{
        const key = $ccc37b720d59461a$var$mkSfKey(moduleId, sectionNo, sfKey);
        const updated = {
            ...data[key],
            isActive: checked
        };
        handleField(key, 'isActive', checked);
        saveSubFolder(moduleId, sectionNo, sfKey, updated);
    };
    const renderFields = (key, onBlur, isSaving, tdStyle, statusTdStyle)=>{
        const d = data[key] || {
            prompt: '',
            queryToVector: '',
            isActive: false
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                    style: statusTdStyle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($ccc37b720d59461a$var$StatusCheckbox, {
                        checked: d.isActive,
                        onChange: (e)=>{
                            const updated = {
                                ...d,
                                isActive: e.target.checked
                            };
                            handleField(key, 'isActive', e.target.checked);
                            onBlur(updated);
                        },
                        disabled: isSaving
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                    style: tdStyle,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                            value: d.queryToVector,
                            onChange: (e)=>handleField(key, 'queryToVector', e.target.value),
                            onBlur: ()=>onBlur(),
                            disabled: isSaving,
                            placeholder: "Enter query to vector\u2026",
                            rows: 3,
                            style: {
                                ...$ccc37b720d59461a$var$S.textInput,
                                resize: 'vertical',
                                background: isSaving ? '#f8f9ff' : '#fff'
                            }
                        }),
                        isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: $ccc37b720d59461a$var$S.savingLabel,
                            children: "Saving\u2026"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                    style: tdStyle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        value: d.prompt,
                        onChange: (e)=>handleField(key, 'prompt', e.target.value),
                        onBlur: ()=>onBlur(),
                        disabled: isSaving,
                        placeholder: "Enter prompt\u2026",
                        rows: 3,
                        style: {
                            ...$ccc37b720d59461a$var$S.textInput,
                            resize: 'vertical',
                            background: isSaving ? '#f8f9ff' : '#fff'
                        }
                    })
                })
            ]
        });
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic p2rem",
        style: {
            color: '#7c83a0'
        },
        children: "Loading\u2026"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $ccc37b720d59461a$var$S.wrap,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: $ccc37b720d59461a$var$S.card,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: $ccc37b720d59461a$var$S.cardHead,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $ccc37b720d59461a$var$S.title,
                            children: "Analyser"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: $ccc37b720d59461a$var$S.subtitle,
                            children: "Configure analyser prompts per section and subfolder for each module."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: $ccc37b720d59461a$var$S.tableWrap,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        style: {
                            width: $ccc37b720d59461a$var$SECTION_COL_PX + $ccc37b720d59461a$var$STATUS_COL_PX + $ccc37b720d59461a$var$QTV_COL_PX + $ccc37b720d59461a$var$PROMPT_COL_PX,
                            minWidth: '100%',
                            borderCollapse: 'separate',
                            borderSpacing: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("colgroup", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                        style: {
                                            width: $ccc37b720d59461a$var$SECTION_COL_PX
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                        style: {
                                            width: $ccc37b720d59461a$var$STATUS_COL_PX
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                        style: {
                                            width: $ccc37b720d59461a$var$QTV_COL_PX
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("col", {
                                        style: {
                                            width: $ccc37b720d59461a$var$PROMPT_COL_PX
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                style: $ccc37b720d59461a$var$S.thead,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$ccc37b720d59461a$var$S.th,
                                                position: 'sticky',
                                                left: 0,
                                                top: 0,
                                                zIndex: 4,
                                                backgroundColor: '#f8f9ff',
                                                boxShadow: '4px 0 10px -2px rgba(26,29,46,0.12)'
                                            },
                                            children: "Section"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$ccc37b720d59461a$var$S.thCenter,
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 3,
                                                backgroundColor: '#f8f9ff'
                                            },
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$ccc37b720d59461a$var$S.th,
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 3,
                                                backgroundColor: '#f8f9ff'
                                            },
                                            children: "Query to Vector"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            style: {
                                                ...$ccc37b720d59461a$var$S.th,
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 3,
                                                backgroundColor: '#f8f9ff'
                                            },
                                            children: "Prompt"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: tempModules.map((mod)=>{
                                    const isOpen = !!openAccordions[mod._id];
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                style: $ccc37b720d59461a$var$S.modRow,
                                                onClick: ()=>toggleAccordion(mod._id),
                                                role: "button",
                                                tabIndex: 0,
                                                onKeyDown: (e)=>(e.key === 'Enter' || e.key === ' ') && toggleAccordion(mod._id),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            ...$ccc37b720d59461a$var$S.modTd,
                                                            position: 'sticky',
                                                            left: 0,
                                                            zIndex: 2,
                                                            background: 'linear-gradient(90deg,#f0f3ff 0%,#f8f9ff 100%)',
                                                            boxShadow: '4px 0 10px -2px rgba(26,29,46,0.08)'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    style: $ccc37b720d59461a$var$S.modAccent
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    style: {
                                                                        flex: 1,
                                                                        minWidth: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            style: $ccc37b720d59461a$var$S.modName,
                                                                            children: mod.moduleName
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            style: {
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: 6,
                                                                                marginTop: 3
                                                                            },
                                                                            children: [
                                                                                mod.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    style: $ccc37b720d59461a$var$S.modKey,
                                                                                    children: mod.moduleKey
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    style: $ccc37b720d59461a$var$S.modMeta,
                                                                                    children: [
                                                                                        mod.sections?.length || 0,
                                                                                        " section",
                                                                                        mod.sections?.length !== 1 ? 's' : ''
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e6a1f3d36d8c3d3$exports))), {
                                                                    style: {
                                                                        color: '#4A67FF',
                                                                        fontSize: 20,
                                                                        flexShrink: 0
                                                                    }
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                                                                    style: {
                                                                        color: '#4A67FF',
                                                                        fontSize: 20,
                                                                        flexShrink: 0
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            ...$ccc37b720d59461a$var$S.modTd,
                                                            borderLeft: '1px solid #e0e4f0'
                                                        },
                                                        onClick: (e)=>e.stopPropagation()
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            ...$ccc37b720d59461a$var$S.modTd,
                                                            borderLeft: '1px solid #e0e4f0'
                                                        },
                                                        onClick: (e)=>e.stopPropagation()
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            ...$ccc37b720d59461a$var$S.modTd,
                                                            borderLeft: '1px solid #e0e4f0'
                                                        },
                                                        onClick: (e)=>e.stopPropagation()
                                                    })
                                                ]
                                            }),
                                            isOpen && (mod.sections || []).map((sec)=>{
                                                const secKey = $ccc37b720d59461a$var$mkKey(mod._id, sec.sectionNo);
                                                const isSavingSec = !!saving[secKey];
                                                const subFolders = $ccc37b720d59461a$var$getSortedSubFolders(sec.subFolders);
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            style: $ccc37b720d59461a$var$S.secRow,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    style: {
                                                                        ...$ccc37b720d59461a$var$S.secTd,
                                                                        position: 'sticky',
                                                                        left: 0,
                                                                        zIndex: 2,
                                                                        backgroundColor: '#fff',
                                                                        boxShadow: '4px 0 10px -2px rgba(26,29,46,0.08)'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        style: {
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: 8
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: $ccc37b720d59461a$var$S.secNo,
                                                                                children: sec.sectionNo
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: $ccc37b720d59461a$var$S.secName,
                                                                                children: sec.sectionName
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                renderFields(secKey, (override)=>saveSection(mod._id, sec.sectionNo, override), isSavingSec, $ccc37b720d59461a$var$S.fieldTd, $ccc37b720d59461a$var$S.statusTd)
                                                            ]
                                                        }),
                                                        subFolders.map(({ sfKey: sfKey, name: name, no: no })=>{
                                                            const sfStateKey = $ccc37b720d59461a$var$mkSfKey(mod._id, sec.sectionNo, sfKey);
                                                            const isSavingSf = !!saving[sfStateKey];
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                style: $ccc37b720d59461a$var$S.sfRow,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            ...$ccc37b720d59461a$var$S.sfTd,
                                                                            position: 'sticky',
                                                                            left: 0,
                                                                            zIndex: 2,
                                                                            backgroundColor: '#fafbff',
                                                                            boxShadow: '4px 0 10px -2px rgba(26,29,46,0.05)'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            style: {
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: 6
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    style: {
                                                                                        color: '#d0d5e8',
                                                                                        fontSize: 12,
                                                                                        flexShrink: 0
                                                                                    },
                                                                                    children: "\u2514"
                                                                                }),
                                                                                no && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    style: $ccc37b720d59461a$var$S.sfNo,
                                                                                    children: no
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    style: $ccc37b720d59461a$var$S.sfName,
                                                                                    children: name
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    renderFields(sfStateKey, (override)=>saveSubFolder(mod._id, sec.sectionNo, sfKey, override), isSavingSf, $ccc37b720d59461a$var$S.sfFieldTd, $ccc37b720d59461a$var$S.sfStatusTd)
                                                                ]
                                                            }, sfStateKey);
                                                        })
                                                    ]
                                                }, secKey);
                                            })
                                        ]
                                    }, mod._id);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $ccc37b720d59461a$export$2e2bcd8739ae039 = $ccc37b720d59461a$var$TempAnalyser;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;


'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $23a03a376a300fc5$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $23a03a376a300fc5$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $23a03a376a300fc5$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $23a03a376a300fc5$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $23a03a376a300fc5$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $8nd05.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $8nd05.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5408b2039b9d572c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d7f4cf29715b69dd$export$6816d4fc0981ec7), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $1En50.default)(props, $5408b2039b9d572c$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;









parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;



var $jTnBY = parcelRequire("jTnBY");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $9396253983985262$var$_excluded2 = [
    "ref"
], $9396253983985262$var$_excluded3 = [
    "key"
], $9396253983985262$var$_excluded4 = [
    "key"
];
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $723a67e53eb4dc4c$export$8ee01529667e66d9), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused} .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $80c774dd7f29b734$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $6a1dc6d1d7e1816a$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $b0b42157daacd8b1$export$2e2bcd8739ae039).root}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).hiddenLabel}.${(0, $9b9dde6aa920e08c$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $8nd05.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $8nd05.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $5408b2039b9d572c$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $723a67e53eb4dc4c$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7280bbf95507cba$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $595185d0d7275c3b$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $a4669aa090d445bd$export$2e2bcd8739ae039), popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a863bd9b12ca76b$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $9396253983985262$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $23a03a376a300fc5$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $1En50.default)(_getListboxProps, $9396253983985262$var$_excluded2);
    const combinedListboxRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $8nd05.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $8nd05.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $1En50.default)(_getCustomizedTagProp, $9396253983985262$var$_excluded3);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), (0, $8nd05.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $1En50.default)(props2, $9396253983985262$var$_excluded4);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", (0, $8nd05.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $8nd05.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, (0, $8nd05.default)({
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $8nd05.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, (0, $8nd05.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, (0, $8nd05.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $8nd05.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, (0, $8nd05.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $9QePP.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, (0, $8nd05.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $9QePP.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteListbox, (0, $8nd05.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jjlaj = parcelRequire("jjlaj");

var $jTnBY = parcelRequire("jTnBY");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $19b4ac261663afa8$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $19b4ac261663afa8$var$_ = (t)=>t, $19b4ac261663afa8$var$_t, $19b4ac261663afa8$var$_t2, $19b4ac261663afa8$var$_t3, $19b4ac261663afa8$var$_t4;
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t || ($19b4ac261663afa8$var$_t = $19b4ac261663afa8$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $jjlaj.keyframes)($19b4ac261663afa8$var$_t2 || ($19b4ac261663afa8$var$_t2 = $19b4ac261663afa8$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b86eb8364bb4993c$export$29cad1383b3f235d), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $jjlaj.css)($19b4ac261663afa8$var$_t3 || ($19b4ac261663afa8$var$_t3 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $19b4ac261663afa8$var$circularRotateKeyframe));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $8nd05.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $jjlaj.css)($19b4ac261663afa8$var$_t4 || ($19b4ac261663afa8$var$_t4 = $19b4ac261663afa8$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $19b4ac261663afa8$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $1En50.default)(props, $19b4ac261663afa8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        style: (0, $8nd05.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;






const $1b195c31f21e75fc$var$SOCKET_EVENT = 'permissionMigration:event';
const $1b195c31f21e75fc$var$PAGE_SIZE = 20;
const $1b195c31f21e75fc$var$STATUS_COLORS = {
    updated: '#09B255',
    skipped: '#AAACB5',
    error: '#F0606C',
    running: '#4A67FF'
};
const $1b195c31f21e75fc$var$LEVEL_COLORS = {
    info: '#5E5F66',
    success: '#09B255',
    warn: '#F0AE0D',
    error: '#F0606C',
    running: '#4A67FF'
};
const $1b195c31f21e75fc$var$StatTile = ({ label: label, value: value, color: color })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df fdc aic jcc br10px",
        style: {
            background: '#F7F8FE',
            border: '1px solid #DDE2F2',
            padding: '10px 14px',
            minWidth: 70,
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "fs1-25rem fw600",
                style: {
                    color: color
                },
                children: value ?? '-'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "fs11px fw400 c28 tac wsn",
                children: label
            })
        ]
    });
const $1b195c31f21e75fc$var$ProgressBar = ({ current: current, total: total })=>{
    const pct = total > 0 ? Math.min(100, Math.round(current / total * 100)) : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcsb mb0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fs12px fw500 c15",
                        children: [
                            current,
                            " / ",
                            total,
                            " companies"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fs12px fw500",
                        style: {
                            color: '#4A67FF'
                        },
                        children: [
                            pct,
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    height: 8,
                    background: '#E8EBF5',
                    borderRadius: 99,
                    overflow: 'hidden'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        height: '100%',
                        width: `${pct}%`,
                        background: '#4A67FF',
                        borderRadius: 99,
                        transition: 'width 400ms ease'
                    }
                })
            })
        ]
    });
};
const $1b195c31f21e75fc$var$formatTime = (ts)=>new Date(ts || Date.now()).toLocaleTimeString('en-GB', {
        hour12: false
    });
function $1b195c31f21e75fc$export$2e2bcd8739ae039() {
    const [companies, setCompanies] = (0, $acw62.useState)([]);
    const [total, setTotal] = (0, $acw62.useState)(0);
    const [hasMore, setHasMore] = (0, $acw62.useState)(false);
    const [search, setSearch] = (0, $acw62.useState)('');
    const [selected, setSelected] = (0, $acw62.useState)([]);
    const [loadingCompanies, setLoadingCompanies] = (0, $acw62.useState)(false);
    const [loadingMore, setLoadingMore] = (0, $acw62.useState)(false);
    const [running, setRunning] = (0, $acw62.useState)(false);
    const [logs, setLogs] = (0, $acw62.useState)([]);
    const [rows, setRows] = (0, $acw62.useState)([]);
    const [progress, setProgress] = (0, $acw62.useState)({
        current: 0,
        total: 0
    });
    const [summary, setSummary] = (0, $acw62.useState)(null);
    const [socketConnected, setSocketConnected] = (0, $acw62.useState)(()=>(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)?.connected ?? true);
    const runIdRef = (0, $acw62.useRef)(null);
    const logEndRef = (0, $acw62.useRef)(null);
    const searchRef = (0, $acw62.useRef)('');
    const loadedCountRef = (0, $acw62.useRef)(0);
    const runningRef = (0, $acw62.useRef)(false);
    // Reason: holds the latest poll function so interval/reconnect effects always call the fresh closure.
    const pollStatusFnRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        runningRef.current = running;
    }, [
        running
    ]);
    // Reason: the picker is server-driven — already-migrated companies must never reach the client,
    // so both the initial list and every search hit the API instead of filtering in memory.
    const loadCompanies = async (term = '', skip = 0)=>{
        const isFirstPage = skip === 0;
        if (isFirstPage) setLoadingCompanies(true);
        else setLoadingMore(true);
        const params = new URLSearchParams({
            limit: String($1b195c31f21e75fc$var$PAGE_SIZE),
            skip: String(skip)
        });
        if (term) params.set('search', term);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/permission-migration/companies?${params.toString()}`);
        // Drop responses for a search term the user has already typed past
        if (searchRef.current === term && res?.code === 200) {
            const body = res['body'] || {};
            const list = body['companies'] || [];
            setCompanies((prev)=>{
                const next = isFirstPage ? list : [
                    ...prev,
                    ...list
                ];
                loadedCountRef.current = next.length;
                return next;
            });
            setTotal(body['total'] || 0);
            setHasMore(!!body['hasMore']);
        }
        if (isFirstPage) setLoadingCompanies(false);
        else setLoadingMore(false);
    };
    (0, $acw62.useEffect)(()=>{
        searchRef.current = search;
        const timer = setTimeout(()=>loadCompanies(search, 0), 350);
        return ()=>clearTimeout(timer);
    }, [
        search
    ]);
    const handleListboxScroll = (event)=>{
        const node = event.currentTarget;
        if (loadingMore || loadingCompanies || !hasMore) return;
        if (node.scrollTop + node.clientHeight >= node.scrollHeight - 24) loadCompanies(searchRef.current, loadedCountRef.current);
    };
    const appendLog = (level, text)=>setLogs((prev)=>[
                ...prev,
                {
                    at: Date.now(),
                    level: level,
                    text: text
                }
            ]);
    // Reason: assigned each render so interval/reconnect effects always call the fresh closure without stale state.
    pollStatusFnRef.current = async ()=>{
        const runId = runIdRef.current;
        if (!runId) return;
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/permission-migration-status/${runId}`);
        if (res?.code !== 200 || !res['body']) return;
        const snap = res['body'];
        if (snap['rows'] && Object.keys(snap['rows']).length) setRows((prev)=>{
            const byId = {};
            prev.forEach((r)=>{
                byId[r['companyId']] = r;
            });
            Object.values(snap['rows']).forEach((r)=>{
                byId[r['companyId']] = {
                    ...byId[r['companyId']],
                    ...r
                };
            });
            return Object.values(byId);
        });
        if (snap['progress'] && snap['progress']['current'] !== undefined) setProgress((prev)=>snap['progress']['current'] > prev['current'] ? snap['progress'] : prev);
        if (snap['status'] === 'complete' && runningRef.current) {
            if (snap['summary']) setSummary(snap['summary']);
            setRunning(false);
            runIdRef.current = null;
            appendLog('success', 'Migration completed.');
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Permission migration completed.');
            setSelected([]);
            loadCompanies(searchRef.current, 0);
        } else if (snap['status'] === 'failed' && runningRef.current) {
            setRunning(false);
            runIdRef.current = null;
            appendLog('error', `Migration failed: ${snap['error'] || 'Unknown error'}`);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(snap['error'] || 'Permission migration failed.', 'error');
        }
    };
    // Polling fallback — catches progress missed during a socket disconnect.
    (0, $acw62.useEffect)(()=>{
        if (!running) return;
        const id = setInterval(()=>{
            pollStatusFnRef.current?.();
        }, 5000);
        return ()=>clearInterval(id);
    }, [
        running
    ]);
    // Socket connect/disconnect tracking — logs a warning and polls immediately on reconnect.
    (0, $acw62.useEffect)(()=>{
        if (!(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)) return;
        const onDisconnect = ()=>{
            if (runningRef.current) {
                setSocketConnected(false);
                appendLog('warn', "Socket disconnected \u2014 progress syncing via polling every 5 s\u2026");
            }
        };
        const onConnect = ()=>{
            setSocketConnected(true);
            if (runIdRef.current) {
                appendLog('info', "Socket reconnected \u2014 syncing missed progress\u2026");
                pollStatusFnRef.current?.();
            }
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('disconnect', onDisconnect);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('connect', onConnect);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('disconnect', onDisconnect);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('connect', onConnect);
        };
    }, []);
    // Reason: the migration runs in the background on the server — all progress arrives over this socket event.
    (0, $acw62.useEffect)(()=>{
        if (!(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)) return;
        const onEvent = (payload)=>{
            if (!payload || payload['runId'] !== runIdRef.current) return;
            const type = payload['type'];
            if (type === 'init') appendLog('info', payload['message']);
            if (type === 'modules-loaded') appendLog('info', `Loaded ${payload['moduleCount']} active modules and ${payload['sectionCount']} sections (${payload['uniqueSectionNos']} unique section numbers)`);
            if (type === 'companies-loaded') {
                setProgress({
                    current: 0,
                    total: payload['totalCompanies']
                });
                appendLog('info', `${payload['totalCompanies']} companies queued for migration`);
            }
            if (type === 'company-start') {
                setProgress({
                    current: payload['index'] - 1,
                    total: payload['total']
                });
                setRows((prev)=>{
                    const next = prev.filter((r)=>r['companyId'] !== payload['companyId']);
                    return [
                        ...next,
                        {
                            companyId: payload['companyId'],
                            cName: payload['cName'],
                            index: payload['index'],
                            status: 'running'
                        }
                    ];
                });
                appendLog('running', `[${payload['index']}/${payload['total']}] Processing ${payload['cName'] || payload['companyId']}\u{2026}`);
            }
            if (type === 'company-done') {
                setProgress({
                    current: payload['index'],
                    total: payload['total']
                });
                setRows((prev)=>prev.map((r)=>r['companyId'] === payload['companyId'] ? {
                            ...r,
                            status: payload['status'],
                            message: payload['message'],
                            stats: payload['stats'],
                            testType: payload['testType'],
                            subscription: payload['subscription']
                        } : r));
                const stats = payload['stats'];
                const detail = stats ? ` \u{2014} advisors ${stats['advisors']}, revenue lead ${stats['revenuelead']}, investors ${stats['investors']}, members ${stats['members']}` : '';
                const level = payload['status'] === 'error' ? 'error' : payload['status'] === 'skipped' ? 'warn' : 'success';
                appendLog(level, `[${payload['index']}/${payload['total']}] ${payload['cName'] || payload['companyId']} \u{2014} ${payload['message']}${detail}`);
            }
            if (type === 'complete') {
                setSummary(payload['summary']);
                setRunning(false);
                runIdRef.current = null;
                appendLog('success', `Migration finished in ${Math.round((payload['durationMs'] || 0) / 1000)}s`);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Permission migration completed.');
                setSelected([]);
                loadCompanies(searchRef.current, 0);
            }
            if (type === 'failed') {
                setRunning(false);
                runIdRef.current = null;
                appendLog('error', `Migration failed: ${payload['message']}`);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(payload['message'] || 'Permission migration failed.', 'error');
            }
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on($1b195c31f21e75fc$var$SOCKET_EVENT, onEvent);
        return ()=>(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off($1b195c31f21e75fc$var$SOCKET_EVENT, onEvent);
    }, []);
    (0, $acw62.useEffect)(()=>{
        logEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        logs
    ]);
    const handleRun = async ()=>{
        if (!selected.length) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select at least one company.', 'error');
        setLogs([]);
        setRows([]);
        setSummary(null);
        setProgress({
            current: 0,
            total: selected.length
        });
        setRunning(true);
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/run-permission-migration', {
            companyIds: selected.map((c)=>c['_id']),
            stream: true
        }, true);
        if (res?.code === 200) {
            runIdRef.current = res['body']?.['runId'];
            appendLog('info', `Run ${runIdRef.current} started for ${selected.length} compan${selected.length === 1 ? 'y' : 'ies'}`);
        } else {
            setRunning(false);
            appendLog('error', res?.message || 'Failed to start migration.');
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to start migration.', 'error');
        }
    };
    // Reason: MUI warns when a selected value is missing from options — searching swaps the page out,
    // so already-picked companies are appended back in.
    const options = (0, $acw62.useMemo)(()=>{
        const loadedIds = new Set(companies.map((c)=>c['_id']));
        return [
            ...companies,
            ...selected.filter((c)=>!loadedIds.has(c['_id']))
        ];
    }, [
        companies,
        selected
    ]);
    const counts = (0, $acw62.useMemo)(()=>({
            updated: rows.filter((r)=>r['status'] === 'updated').length,
            skipped: rows.filter((r)=>r['status'] === 'skipped').length,
            errors: rows.filter((r)=>r['status'] === 'error').length
        }), [
        rows
    ]);
    const sortedRows = (0, $acw62.useMemo)(()=>[
            ...rows
        ].sort((a, b)=>a['index'] - b['index']), [
        rows
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "p2rem w100 df",
        style: {
            gap: 32,
            alignItems: 'flex-start'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: '0 0 440px',
                    maxWidth: 440
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c6 fs1-5rem fw600 mb0-5rem",
                        children: "Company Wise Migration"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c28 fs14px fw400 mb1-5rem",
                        children: "Search and select the companies whose advisor, investor, revenue lead and member permissions should be rebuilt against the current TempModules and TempSections."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "db c15 fs14px fw500 mb0-5rem",
                        children: "Companies"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9396253983985262$export$2e2bcd8739ae039), {
                        multiple: true,
                        disableCloseOnSelect: true,
                        limitTags: 3,
                        options: options,
                        filterOptions: (x)=>x,
                        value: selected,
                        disabled: running,
                        loading: loadingCompanies,
                        inputValue: search,
                        onInputChange: (e, value, reason)=>{
                            if (reason === 'input') setSearch(value);
                        },
                        onChange: (e, value)=>setSelected(value),
                        getOptionLabel: (option)=>option['cName'] || option['_id'],
                        isOptionEqualToValue: (option, value)=>option['_id'] === value['_id'],
                        noOptionsText: loadingCompanies ? "Searching\u2026" : 'No pending companies found',
                        ListboxProps: {
                            onScroll: handleListboxScroll,
                            style: {
                                maxHeight: 320
                            }
                        },
                        renderOption: (props, option, { selected: isSelected })=>/*#__PURE__*/ (0, $acw62.createElement)("li", {
                                ...props,
                                key: option['_id'],
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                        size: "small",
                                        checked: isSelected,
                                        style: {
                                            marginRight: 8,
                                            color: '#4A67FF'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs14px fw500 c15",
                                                children: option['cName'] || 'Untitled company'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs11px c28",
                                                children: [
                                                    option['testType'] || 'investment',
                                                    " \xb7 ",
                                                    option['subscription'] || 'Free'
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                        renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $acw62.createElement)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                    size: "small",
                                    label: option['cName'] || option['_id'],
                                    ...getTagProps({
                                        index: index
                                    }),
                                    key: option['_id']
                                })),
                        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                ...params,
                                size: "small",
                                placeholder: "Search companies\u2026",
                                InputProps: {
                                    ...params.InputProps,
                                    endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            (loadingCompanies || loadingMore) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                                                size: 16,
                                                style: {
                                                    color: '#4A67FF'
                                                }
                                            }),
                                            params.InputProps.endAdornment
                                        ]
                                    })
                                }
                            }),
                        sx: {
                            '& .MuiOutlinedInput-root': {
                                background: '#F7F8FE',
                                borderRadius: '10px'
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsb mt0-75rem mb1-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs12px c28",
                                children: [
                                    selected.length,
                                    " selected \xb7 ",
                                    companies.length,
                                    " of ",
                                    total,
                                    " pending loaded"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setSelected(options),
                                        disabled: running || !companies.length,
                                        style: {
                                            background: 'none',
                                            border: 'none',
                                            padding: 0,
                                            cursor: running ? 'not-allowed' : 'pointer',
                                            color: '#4A67FF',
                                            fontSize: 13,
                                            fontWeight: 500
                                        },
                                        children: "Select Loaded"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setSelected([]),
                                        disabled: running || !selected.length,
                                        style: {
                                            background: 'none',
                                            border: 'none',
                                            padding: 0,
                                            cursor: running ? 'not-allowed' : 'pointer',
                                            color: '#FC7785',
                                            fontSize: 13,
                                            fontWeight: 500
                                        },
                                        children: "Clear"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: handleRun,
                        disabled: running || !selected.length,
                        style: {
                            padding: '12px 32px',
                            borderRadius: 50,
                            border: 'none',
                            background: running || !selected.length ? '#AAACB5' : '#4A67FF',
                            color: '#fff',
                            fontSize: 14,
                            fontWeight: 500,
                            cursor: running || !selected.length ? 'not-allowed' : 'pointer',
                            minWidth: 220,
                            transition: 'background 200ms'
                        },
                        children: running ? "Migration Running\u2026" : `Run Migration${selected.length ? ` (${selected.length})` : ''}`
                    }),
                    (running || progress.total > 0) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1-5rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$ProgressBar, {
                            current: progress.current,
                            total: progress.total
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: logs.length === 0 && !running ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df fdc aic jcc br10px",
                    style: {
                        background: '#F7F8FE',
                        border: '1px dashed #DDE2F2',
                        padding: '3rem 2rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs14px fw500 c28 tac",
                        children: "Select companies and run the migration to see live progress here."
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        running && !socketConnected && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic mb0-75rem br8px",
                            style: {
                                background: '#FFFBEB',
                                border: '1px solid #F0AE0D',
                                padding: '8px 12px',
                                gap: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        color: '#F0AE0D',
                                        fontSize: 16
                                    },
                                    children: "\u26A0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs12px fw500",
                                    style: {
                                        color: '#92400E'
                                    },
                                    children: "Socket disconnected \u2014 polling for progress every 5 s"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcsb mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c15 fs1rem fw600 m0",
                                    children: "Live Migration Log"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    style: {
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs11px fw600",
                                            style: {
                                                background: '#F0FFF6',
                                                color: '#09B255',
                                                borderRadius: 50,
                                                padding: '3px 10px'
                                            },
                                            children: [
                                                counts.updated,
                                                " updated"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs11px fw600",
                                            style: {
                                                background: '#F0F2FD',
                                                color: '#5E5F66',
                                                borderRadius: 50,
                                                padding: '3px 10px'
                                            },
                                            children: [
                                                counts.skipped,
                                                " skipped"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs11px fw600",
                                            style: {
                                                background: '#FFF5F5',
                                                color: '#F0606C',
                                                borderRadius: 50,
                                                padding: '3px 10px'
                                            },
                                            children: [
                                                counts.errors,
                                                " errors"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "br10px mb1-5rem",
                            style: {
                                background: '#0F1424',
                                padding: '14px 16px',
                                maxHeight: 280,
                                overflowY: 'auto',
                                fontFamily: 'monospace',
                                fontSize: 12.5,
                                lineHeight: 1.7
                            },
                            children: [
                                logs.map((log, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            color: $1b195c31f21e75fc$var$LEVEL_COLORS[log['level']] === '#5E5F66' ? '#AAACB5' : $1b195c31f21e75fc$var$LEVEL_COLORS[log['level']]
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    color: '#5E5F66'
                                                },
                                                children: [
                                                    $1b195c31f21e75fc$var$formatTime(log['at']),
                                                    "  "
                                                ]
                                            }),
                                            log['text']
                                        ]
                                    }, i)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    ref: logEndRef
                                })
                            ]
                        }),
                        summary && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww mb1-5rem",
                            style: {
                                gap: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Total Cos.",
                                    value: summary['totalCompanies'],
                                    color: "#002D63"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Updated",
                                    value: summary['companiesWithChanges'],
                                    color: "#09B255"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Skipped",
                                    value: summary['companiesSkipped'],
                                    color: "#AAACB5"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Advisors",
                                    value: summary['totalAdvisorUsersUpdated'],
                                    color: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Revenue Lead",
                                    value: summary['totalRevenueLeadUsersUpdated'],
                                    color: "#038589"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Investors",
                                    value: summary['totalInvestorUsersUpdated'],
                                    color: "#fb7a27"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Members",
                                    value: summary['totalMembersUpdated'],
                                    color: "#0BA26F"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($1b195c31f21e75fc$var$StatTile, {
                                    label: "Errors",
                                    value: summary['errors']?.length ?? 0,
                                    color: "#F0606C"
                                })
                            ]
                        }),
                        sortedRows.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                borderRadius: 8,
                                overflow: 'hidden',
                                border: '1px solid #DDE2F2'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                style: {
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    fontSize: 13
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            style: {
                                                background: '#F0F2FD'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    style: {
                                                        padding: '8px 12px',
                                                        textAlign: 'left',
                                                        fontWeight: 600,
                                                        color: '#002D63',
                                                        borderBottom: '1px solid #DDE2F2'
                                                    },
                                                    children: "Company"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    style: {
                                                        padding: '8px 12px',
                                                        textAlign: 'center',
                                                        fontWeight: 600,
                                                        color: '#4A67FF',
                                                        borderBottom: '1px solid #DDE2F2',
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: "Advisors"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    style: {
                                                        padding: '8px 12px',
                                                        textAlign: 'center',
                                                        fontWeight: 600,
                                                        color: '#038589',
                                                        borderBottom: '1px solid #DDE2F2',
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: "Rev. Lead"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    style: {
                                                        padding: '8px 12px',
                                                        textAlign: 'center',
                                                        fontWeight: 600,
                                                        color: '#fb7a27',
                                                        borderBottom: '1px solid #DDE2F2',
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: "Investors"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    style: {
                                                        padding: '8px 12px',
                                                        textAlign: 'center',
                                                        fontWeight: 600,
                                                        color: '#0BA26F',
                                                        borderBottom: '1px solid #DDE2F2',
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: "Members"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    style: {
                                                        padding: '8px 12px',
                                                        textAlign: 'center',
                                                        fontWeight: 600,
                                                        color: '#AAACB5',
                                                        borderBottom: '1px solid #DDE2F2',
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: "Status"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                        children: sortedRows.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                style: {
                                                    background: i % 2 === 0 ? '#fff' : '#F7F8FE',
                                                    borderBottom: i < sortedRows.length - 1 ? '1px solid #DDE2F2' : 'none'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                        style: {
                                                            padding: '8px 12px',
                                                            color: '#151313',
                                                            fontWeight: 500
                                                        },
                                                        children: [
                                                            r['cName'] || r['companyId'],
                                                            r['testType'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "fs11px c28",
                                                                children: [
                                                                    " \xb7 ",
                                                                    r['testType'],
                                                                    " \xb7 ",
                                                                    r['subscription']
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            padding: '8px 12px',
                                                            textAlign: 'center',
                                                            fontWeight: 600,
                                                            color: '#5E5F66'
                                                        },
                                                        children: r['stats']?.['advisors'] ?? '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            padding: '8px 12px',
                                                            textAlign: 'center',
                                                            fontWeight: 600,
                                                            color: '#5E5F66'
                                                        },
                                                        children: r['stats']?.['revenuelead'] ?? '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            padding: '8px 12px',
                                                            textAlign: 'center',
                                                            fontWeight: 600,
                                                            color: '#5E5F66'
                                                        },
                                                        children: r['stats']?.['investors'] ?? '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            padding: '8px 12px',
                                                            textAlign: 'center',
                                                            fontWeight: 600,
                                                            color: '#5E5F66'
                                                        },
                                                        children: r['stats']?.['members'] ?? '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            padding: '8px 12px',
                                                            textAlign: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                background: `${$1b195c31f21e75fc$var$STATUS_COLORS[r['status']]}1A`,
                                                                color: $1b195c31f21e75fc$var$STATUS_COLORS[r['status']],
                                                                borderRadius: 50,
                                                                padding: '2px 10px',
                                                                fontSize: 11,
                                                                fontWeight: 600,
                                                                textTransform: 'capitalize'
                                                            },
                                                            children: r['status'] === 'running' ? 'Processing' : r['status']
                                                        })
                                                    })
                                                ]
                                            }, r['companyId']))
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $5C8IU = parcelRequire("5C8IU");

var $g91qR = parcelRequire("g91qR");
var $6hiu6 = parcelRequire("6hiu6");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6f004ebeb2f93e73$var$_excluded = [
    "className",
    "component"
];
function $6f004ebeb2f93e73$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5C8IU.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $g91qR.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $fd286b02fb568257$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $6hiu6.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $1En50.default)(_extendSxProp, $6f004ebeb2f93e73$var$_excluded);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, (0, $8nd05.default)({
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;


'use client';
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $6f004ebeb2f93e73$export$2e2bcd8739ae039)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $cf808af3a1d339c9$export$2e2bcd8739ae039).root,
    generateClassName: (0, $bnost.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;


var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $beCSm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22fefd5f207422b3$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3e2d01fd3f88b8c8$export$315cb19215f77ce0), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $8nd05.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $1En50.default)(props, $22fefd5f207422b3$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e848e543ed3bf349$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, (0, $8nd05.default)({
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $beCSm.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09d8a23708c3ccc9$var$_excluded = [
    "className",
    "component"
];
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9a6742b7048414d1$export$98bd2a9b566ec665), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent } = props, other = (0, $1En50.default)(props, $09d8a23708c3ccc9$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, (0, $8nd05.default)({
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fdf044e88b1c9ad4$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $beCSm.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$export$2e2bcd8739ae039 = $fdf044e88b1c9ad4$var$tableContainerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5d7964a6269b66c8$var$_excluded = [
    "className",
    "component"
];
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fdf044e88b1c9ad4$export$eed427986a7abdf9), classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $d8seH.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $1En50.default)(props, $5d7964a6269b66c8$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, (0, $8nd05.default)({
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $5d7964a6269b66c8$export$2e2bcd8739ae039 = $5d7964a6269b66c8$var$TableContainer;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $4Cod0.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $beCSm.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c9c28a8e795911dc$var$_excluded = [
    "className",
    "component"
];
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cf1017f12785ebe4$export$2e731cea2d1c2392), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent } = props, other = (0, $1En50.default)(props, $c9c28a8e795911dc$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component
    });
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09fe163f52c859c8$export$2e2bcd8739ae039).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, (0, $8nd05.default)({
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");


var $1iOpW = parcelRequire("1iOpW");

var $d8seH = parcelRequire("d8seH");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $beCSm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22705465ad6920f8$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $321d86e199abda5b$export$ba0a6d6c28940107), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $321d86e199abda5b$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $1En50.default)(props, $22705465ad6920f8$var$_excluded);
    const tablelvl2 = $acw62.useContext((0, $09fe163f52c859c8$export$2e2bcd8739ae039));
    const ownerState = (0, $8nd05.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, (0, $8nd05.default)({
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ccd4473bf517ef36$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $297fb5ec09626165$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), 'KeyboardArrowLeft');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $742ce4f34134d568$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'RemoveRedEye');










var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $lWAfe = parcelRequire("lWAfe");

var $6hiu6 = parcelRequire("6hiu6");

var $8Indx = parcelRequire("8Indx");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");


var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e1c9164ec15102c7$var$GridContext = /*#__PURE__*/ $acw62.createContext();
var $e1c9164ec15102c7$export$2e2bcd8739ae039 = $e1c9164ec15102c7$var$GridContext;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f35b8acab3fc2f62$export$9973ac5fd0181f33(slot) {
    return (0, $4Cod0.default)('MuiGrid', slot);
}
const $f35b8acab3fc2f62$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $f35b8acab3fc2f62$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $f35b8acab3fc2f62$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $f35b8acab3fc2f62$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $f35b8acab3fc2f62$var$gridClasses = (0, $beCSm.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$f35b8acab3fc2f62$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$f35b8acab3fc2f62$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$f35b8acab3fc2f62$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$f35b8acab3fc2f62$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $f35b8acab3fc2f62$export$2e2bcd8739ae039 = $f35b8acab3fc2f62$var$gridClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9450fbc34cc5b2ea$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $9450fbc34cc5b2ea$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $9450fbc34cc5b2ea$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $lWAfe.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $8nd05.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $9450fbc34cc5b2ea$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $lWAfe.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $lWAfe.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $9450fbc34cc5b2ea$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $lWAfe.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $9450fbc34cc5b2ea$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $lWAfe.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$9450fbc34cc5b2ea$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $9450fbc34cc5b2ea$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $f35b8acab3fc2f62$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $9450fbc34cc5b2ea$var$GridRoot = (0, $d8seH.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $9450fbc34cc5b2ea$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $8nd05.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $9450fbc34cc5b2ea$export$71d4225eeb1bc13e, $9450fbc34cc5b2ea$export$380604d7c79f9e8f, $9450fbc34cc5b2ea$export$4315fba5128fb4a1, $9450fbc34cc5b2ea$export$ca2a698f6020fda);
function $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $9450fbc34cc5b2ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $9450fbc34cc5b2ea$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f35b8acab3fc2f62$export$9973ac5fd0181f33), classes);
};
const $9450fbc34cc5b2ea$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const props = (0, $6hiu6.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $1En50.default)(props, $9450fbc34cc5b2ea$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $acw62.useContext((0, $e1c9164ec15102c7$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $8nd05.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $9450fbc34cc5b2ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1c9164ec15102c7$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9450fbc34cc5b2ea$var$GridRoot, (0, $8nd05.default)({
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $9450fbc34cc5b2ea$export$2e2bcd8739ae039 = $9450fbc34cc5b2ea$var$Grid;




/* eslint-disable class-methods-use-this */ 


function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $30a94a667184fb38$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}





var $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE = 60000;
function $8a9f3e7be35784f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, amount * $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE);
}





var $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR = 3600000;
function $eba2848fce1475e9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, amount * $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR);
}





function $207b05f27970aaba$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $4f754377033842c6$export$2e2bcd8739ae039)(dirtyDate, days);
}





function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




function $4ba07667a7282b10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $52a761315a8e3e9c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $5a7a122bf592ddcb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}





function $aeae26b52a87faed$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}




function $95706a37c0d7d1b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}




function $ecaa46b9ba4a249b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $7b5a89b8f9188b81$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}




function $3927eb6a31e1659f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}




function $48c184a62f8d0eb5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $f6d7a02300a12946$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = date.getMilliseconds();
    return milliseconds;
}






function $5808e7e2a5fbbc4c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var weekStartsOn = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}







function $73038cccee83d214$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $5808e7e2a5fbbc4c$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $5808e7e2a5fbbc4c$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $a6379a6e1c52ffad$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $1f47e002602f8387$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $a874c42e2166676d$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $73038cccee83d214$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $5808e7e2a5fbbc4c$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $9e53948deed625c0$var$MILLISECONDS_IN_WEEK = 604800000;
function $9e53948deed625c0$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $5808e7e2a5fbbc4c$export$2e2bcd8739ae039)(date, options).getTime() - (0, $a6379a6e1c52ffad$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $9e53948deed625c0$var$MILLISECONDS_IN_WEEK) + 1;
}




function $ed626c0821295496$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    return (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $821d7431eba4c146$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $3a082e1cb0a32433$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $bcd268c28ce3da9c$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $09f87854553a6255$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $8085a298e92e1718$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $af6ff563afc12374$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $1218e6c057836baf$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $af6ff563afc12374$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $af6ff563afc12374$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}







function $cc7a0667c81ab698$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}





function $bf2a1543848c0a73$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $4a0f96fdddaa35da$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $973cfe686ae8d1d7$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $95706a37c0d7d1b0$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $979847221b6d59d4$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $45326eb2c36db6a4$export$2e2bcd8739ae039(dirtyDate, dirtyMilliseconds) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var milliseconds = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyMilliseconds);
    date.setMilliseconds(milliseconds);
    return date;
}





function $2707890d0f47c3ba$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}





function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $c1c9a216d559c39d$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $377d1ce359384586$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $bce2d00733a79246$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}



var $9565c34afda93dca$exports = {};
"use strict";
Object.defineProperty($9565c34afda93dca$exports, "__esModule", {
    value: true
});
$9565c34afda93dca$exports.default = void 0;
var $9565c34afda93dca$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $9565c34afda93dca$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $9565c34afda93dca$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9565c34afda93dca$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $9565c34afda93dca$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $9565c34afda93dca$var$timeLongFormatter(timePattern, formatLong));
};
var $9565c34afda93dca$var$longFormatters = {
    p: $9565c34afda93dca$var$timeLongFormatter,
    P: $9565c34afda93dca$var$dateTimeLongFormatter
};
var $9565c34afda93dca$var$_default = $9565c34afda93dca$var$longFormatters;
$9565c34afda93dca$exports.default = $9565c34afda93dca$var$_default;
$9565c34afda93dca$exports = $9565c34afda93dca$exports.default;



var $8nd05 = parcelRequire("8nd05");
/* eslint-disable class-methods-use-this */ const $8730025af2ed6349$var$formatTokenMap = {
    // Year
    y: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yy: 'year',
    yyy: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yyyy: 'year',
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    L: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    LL: 'month',
    LLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    LLLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    d: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    dd: 'day',
    do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    E: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    i: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ii: 'weekDay',
    iii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    iiii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // eslint-disable-next-line id-denylist
    e: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ee: 'weekDay',
    eee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    c: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    cc: 'weekDay',
    ccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    a: 'meridiem',
    aa: 'meridiem',
    aaa: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $8730025af2ed6349$var$defaultFormats = {
    year: 'yyyy',
    month: 'LLLL',
    monthShort: 'MMM',
    dayOfMonth: 'd',
    dayOfMonthFull: 'do',
    weekday: 'EEEE',
    weekdayShort: 'EEEEEE',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'aa',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'PP',
    keyboardDate: 'P',
    shortDate: 'MMM d',
    normalDate: 'd MMMM',
    normalDateWithWeekday: 'EEE, MMM d',
    fullTime: 'p',
    fullTime12h: 'hh:mm aa',
    fullTime24h: 'HH:mm',
    keyboardDateTime: 'P p',
    keyboardDateTime12h: 'P hh:mm aa',
    keyboardDateTime24h: 'P HH:mm'
};
class $8730025af2ed6349$export$e330e9acbbe873f1 {
    constructor(props){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = false;
        this.lib = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.formatTokenMap = $8730025af2ed6349$var$formatTokenMap;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.longFormatters = void 0;
        this.date = (value)=>{
            if (typeof value === 'undefined') return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.getInvalidDate = ()=>new Date('Invalid Date');
        this.getTimezone = ()=>{
            return 'default';
        };
        this.setTimezone = (value)=>{
            return value;
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.getCurrentLocaleCode = ()=>{
            // `code` is undefined only in `date-fns` types, but all locales have it
            return this.locale.code;
        };
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            return /a/.test(this.locale.formatLong.time({
                width: 'short'
            }));
        };
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === 'p' || firstCharacter === 'P') {
                    const longFormatter = this.longFormatters[firstCharacter];
                    return longFormatter(token, this.locale.formatLong);
                }
                return token;
            }).join('');
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDayOfWeek = (value)=>{
            return value.getDay() + 1;
        };
        const { locale: locale, formats: formats, longFormatters: longFormatters, lib: lib } = props;
        this.locale = locale;
        this.formats = (0, $8nd05.default)({}, $8730025af2ed6349$var$defaultFormats, formats);
        this.longFormatters = longFormatters;
        this.lib = lib || 'date-fns';
    }
}


class $a2f3a2e6b4ef1860$export$81f56c0329a1921d extends (0, $8730025af2ed6349$export$e330e9acbbe873f1) {
    constructor({ locale: locale, formats: formats } = {}){
        super({
            locale: locale ?? (0, $0ca880ce53ce49f9$export$2e2bcd8739ae039),
            formats: formats,
            longFormatters: (/*@__PURE__*/$parcel$interopDefault($9565c34afda93dca$exports))
        });
        this.parse = (value, format)=>{
            if (value === '') return null;
            return (0, $7a460707bf147158$export$2e2bcd8739ae039)(value, format, new Date(), {
                locale: this.locale
            });
        };
        this.isValid = (value)=>{
            if (value == null) return false;
            return (0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(value);
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(value, formatString, {
                locale: this.locale
            });
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return (0, $bcd268c28ce3da9c$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $09f87854553a6255$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $8085a298e92e1718$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $c9ad0c9b51445ea3$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $1218e6c057836baf$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfter = (value, comparing)=>{
            return (0, $821d7431eba4c146$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isAfterYear = (value, comparing)=>{
            return (0, $821d7431eba4c146$export$2e2bcd8739ae039)(value, (0, $5a7a122bf592ddcb$export$2e2bcd8739ae039)(comparing));
        };
        this.isAfterDay = (value, comparing)=>{
            return (0, $821d7431eba4c146$export$2e2bcd8739ae039)(value, (0, $4ba07667a7282b10$export$2e2bcd8739ae039)(comparing));
        };
        this.isBefore = (value, comparing)=>{
            return (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(value, comparing);
        };
        this.isBeforeYear = (value, comparing)=>{
            return (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(value, this.startOfYear(comparing));
        };
        this.isBeforeDay = (value, comparing)=>{
            return (0, $3a082e1cb0a32433$export$2e2bcd8739ae039)(value, this.startOfDay(comparing));
        };
        this.isWithinRange = (value, [start, end])=>{
            return (0, $c1c9a216d559c39d$export$2e2bcd8739ae039)(value, {
                start: start,
                end: end
            });
        };
        this.startOfYear = (value)=>{
            return (0, $48a662f07bb27222$export$2e2bcd8739ae039)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $41c3cc0836893904$export$2e2bcd8739ae039)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $5808e7e2a5fbbc4c$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.startOfDay = (value)=>{
            return (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $5a7a122bf592ddcb$export$2e2bcd8739ae039)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $f5125f9e9edab43e$export$2e2bcd8739ae039)(value);
        };
        this.endOfWeek = (value)=>{
            return (0, $52a761315a8e3e9c$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.endOfDay = (value)=>{
            return (0, $4ba07667a7282b10$export$2e2bcd8739ae039)(value);
        };
        this.addYears = (value, amount)=>{
            return (0, $eb237db400049a40$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMonths = (value, amount)=>{
            return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(value, amount);
        };
        this.addWeeks = (value, amount)=>{
            return (0, $207b05f27970aaba$export$2e2bcd8739ae039)(value, amount);
        };
        this.addDays = (value, amount)=>{
            return (0, $4f754377033842c6$export$2e2bcd8739ae039)(value, amount);
        };
        this.addHours = (value, amount)=>{
            return (0, $eba2848fce1475e9$export$2e2bcd8739ae039)(value, amount);
        };
        this.addMinutes = (value, amount)=>{
            return (0, $8a9f3e7be35784f5$export$2e2bcd8739ae039)(value, amount);
        };
        this.addSeconds = (value, amount)=>{
            return (0, $30a94a667184fb38$export$2e2bcd8739ae039)(value, amount);
        };
        this.getYear = (value)=>{
            return (0, $ed626c0821295496$export$2e2bcd8739ae039)(value);
        };
        this.getMonth = (value)=>{
            return (0, $3927eb6a31e1659f$export$2e2bcd8739ae039)(value);
        };
        this.getDate = (value)=>{
            return (0, $aeae26b52a87faed$export$2e2bcd8739ae039)(value);
        };
        this.getHours = (value)=>{
            return (0, $ecaa46b9ba4a249b$export$2e2bcd8739ae039)(value);
        };
        this.getMinutes = (value)=>{
            return (0, $7b5a89b8f9188b81$export$2e2bcd8739ae039)(value);
        };
        this.getSeconds = (value)=>{
            return (0, $48c184a62f8d0eb5$export$2e2bcd8739ae039)(value);
        };
        this.getMilliseconds = (value)=>{
            return (0, $f6d7a02300a12946$export$2e2bcd8739ae039)(value);
        };
        this.setYear = (value, year)=>{
            return (0, $2707890d0f47c3ba$export$2e2bcd8739ae039)(value, year);
        };
        this.setMonth = (value, month)=>{
            return (0, $973cfe686ae8d1d7$export$2e2bcd8739ae039)(value, month);
        };
        this.setDate = (value, date)=>{
            return (0, $cc7a0667c81ab698$export$2e2bcd8739ae039)(value, date);
        };
        this.setHours = (value, hours)=>{
            return (0, $bf2a1543848c0a73$export$2e2bcd8739ae039)(value, hours);
        };
        this.setMinutes = (value, minutes)=>{
            return (0, $4a0f96fdddaa35da$export$2e2bcd8739ae039)(value, minutes);
        };
        this.setSeconds = (value, seconds)=>{
            return (0, $979847221b6d59d4$export$2e2bcd8739ae039)(value, seconds);
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return (0, $45326eb2c36db6a4$export$2e2bcd8739ae039)(value, milliseconds);
        };
        this.getDaysInMonth = (value)=>{
            return (0, $95706a37c0d7d1b0$export$2e2bcd8739ae039)(value);
        };
        this.getWeekArray = (value)=>{
            const start = this.startOfWeek(this.startOfMonth(value));
            const end = this.endOfWeek(this.endOfMonth(value));
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(this.isBefore(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return (0, $9e53948deed625c0$export$2e2bcd8739ae039)(value, {
                locale: this.locale
            });
        };
        this.getYearRange = ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
    }
}







const $3622247cddf607a6$var$schema = $cda9d0e1103d595f$export$be5493f9613cbbe().shape({
    code: $cda9d0e1103d595f$export$22b082955e083ec3().required('Please enter a coupon code').matches(/^[A-Z0-9]+$/, 'Coupon code can only contain capital letters and numbers').min(3, 'Coupon code must be at least 3 characters').max(20, 'Coupon code cannot exceed 20 characters'),
    discountType: $cda9d0e1103d595f$export$22b082955e083ec3().required('Please select a discount type'),
    discountValue: $cda9d0e1103d595f$export$98e628dec113755e().transform((value)=>isNaN(value) ? undefined : value).required('Please enter a discount value').min(0, 'Discount value cannot be negative').when('discountType', {
        is: 'percentage',
        then: (schema)=>schema.max(100, 'Percentage cannot be more than 100%')
    }),
    duration: $cda9d0e1103d595f$export$22b082955e083ec3().required('Please select a duration'),
    validFrom: $cda9d0e1103d595f$export$324d90190a8b822a().required('Please select a valid from date').nullable(),
    validUntil: $cda9d0e1103d595f$export$324d90190a8b822a().required('Please select a valid until date').nullable().min($cda9d0e1103d595f$export$eff4d24c3ff7876e('validFrom'), 'Valid until date must be after valid from date'),
    isActive: $cda9d0e1103d595f$export$87b259aa03e3d267().required('Please select a status')
});
const $3622247cddf607a6$var$CreateDiscountCoupon = ({ fetchCoupons: fetchCoupons, selectedCoupon: selectedCoupon })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors }, reset: reset, setValue: setValue, watch: watch } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($3622247cddf607a6$var$schema),
        mode: 'onChange',
        defaultValues: {
            code: '',
            discountType: 'percentage',
            discountValue: '',
            duration: 'once',
            validFrom: null,
            validUntil: null,
            isActive: true
        }
    });
    (0, $acw62.useEffect)(()=>{
        // Track popup open
        (0, $6ee05925f8d16f34$export$1deff90544a4c4e9)('create_discount_coupon');
        if (selectedCoupon) {
            // Set all form values individually
            setValue('code', selectedCoupon.code);
            setValue('discountType', selectedCoupon.discountType);
            setValue('discountValue', selectedCoupon.discountValue);
            setValue('duration', selectedCoupon.duration);
            if (selectedCoupon.durationInMonths !== undefined) setValue('durationInMonths', selectedCoupon.durationInMonths);
            setValue('isActive', selectedCoupon.isActive);
            setValue('validFrom', new Date(selectedCoupon.validFrom));
            setValue('validUntil', new Date(selectedCoupon.expiresAt));
        } else reset({
            code: '',
            discountType: 'percentage',
            discountValue: '',
            duration: 'forever',
            validFrom: null,
            validUntil: null,
            isActive: true
        }); // Reset form to default values if no coupon is selected
        return ()=>{
            // Track popup close
            (0, $6ee05925f8d16f34$export$cdd110eef83fd2bd)('create_discount_coupon');
        };
    }, [
        selectedCoupon,
        setValue,
        reset
    ]);
    const onSubmit = async (data)=>{
        try {
            const formData = {
                ...data,
                expiresAt: data.validUntil,
                validFrom: data.validFrom
            };
            let endpoint = '/payment/createCoupon';
            if (selectedCoupon) endpoint = `/payment/updateCoupon/${selectedCoupon._id}`;
            // Track form submission
            (0, $6ee05925f8d16f34$export$d33a5bb646105e4c)('discount_coupon_form', {
                action: selectedCoupon ? 'update' : 'create',
                coupon_code: data.code,
                discount_type: data.discountType,
                discount_value: data.discountValue
            });
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(endpoint, formData);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message);
        } catch (error) {
            console.log(error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(error.message);
        } finally{
            fetchCoupons();
            reset({
                code: '',
                discountType: 'percentage',
                discountValue: '',
                duration: 'forever',
                validFrom: null,
                validUntil: null,
                isActive: true
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        id: "createCoupon",
        modalType: "createCoupon",
        headerType: "primary",
        heading: "Create Discount Coupon",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            component: "form",
            onSubmit: handleSubmit(onSubmit),
            noValidate: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: "Coupon Code",
                            ...register('code'),
                            error: !!errors.code,
                            helperText: errors.code?.message
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            error: !!errors.discountType,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                    children: "Discount Type"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                    value: watch('discountType'),
                                    onChange: (e)=>setValue('discountType', e.target.value),
                                    label: "Discount Type",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: "percentage",
                                            children: "Percentage"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: "fixed",
                                            children: "Fixed Amount"
                                        })
                                    ]
                                }),
                                errors.discountType && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                                    children: errors.discountType.message
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: `Discount Value ${watch('discountType') === 'percentage' ? '(%)' : "(\xa3)"}`,
                            type: "number",
                            ...register('discountValue'),
                            error: !!errors.discountValue,
                            helperText: errors.discountValue?.message
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            error: !!errors.duration,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                    children: "Duration"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                    value: watch('duration'),
                                    onChange: (e)=>setValue('duration', e.target.value),
                                    label: "Duration",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: "once",
                                            children: "One-time use"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: "forever",
                                            children: "Unlimited use"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: "repeating",
                                            children: "Repeating"
                                        })
                                    ]
                                }),
                                errors.duration && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                                    children: errors.duration.message
                                })
                            ]
                        })
                    }),
                    watch('duration') === 'repeating' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: "Duration in Months",
                            type: "number",
                            ...register('durationInMonths'),
                            error: !!errors.durationInMonths,
                            helperText: errors.durationInMonths?.message,
                            inputProps: {
                                min: 1,
                                max: 12
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa5abcb204c6ca4b$export$dc45bdc734ce6f1e), {
                            dateAdapter: (0, $a2f3a2e6b4ef1860$export$81f56c0329a1921d),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a464a2169acb6c$export$5109c6dd95d8fb00), {
                                label: "Valid From",
                                value: watch('validFrom'),
                                onChange: (date)=>setValue('validFrom', date),
                                className: "w100",
                                format: "dd/MM/yyyy",
                                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                        ...params,
                                        fullWidth: true,
                                        error: !!errors.validFrom,
                                        helperText: errors.validFrom?.message
                                    })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa5abcb204c6ca4b$export$dc45bdc734ce6f1e), {
                            dateAdapter: (0, $a2f3a2e6b4ef1860$export$81f56c0329a1921d),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5a464a2169acb6c$export$5109c6dd95d8fb00), {
                                label: "Valid Until",
                                value: watch('validUntil'),
                                onChange: (date)=>setValue('validUntil', date),
                                className: "w100",
                                format: "dd/MM/yyyy",
                                minDate: watch('validFrom'),
                                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                        ...params,
                                        fullWidth: true,
                                        error: !!errors.validUntil,
                                        helperText: errors.validUntil?.message
                                    })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            error: !!errors.isActive,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                    value: watch('isActive'),
                                    onChange: (e)=>setValue('isActive', e.target.value),
                                    label: "Status",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: true,
                                            children: "Active"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: false,
                                            children: "Inactive"
                                        })
                                    ]
                                }),
                                errors.isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d23aa5c3ca6913fb$export$2e2bcd8739ae039), {
                                    children: errors.isActive.message
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                gap: 2,
                                justifyContent: 'flex-end'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    onClick: ()=>{
                                        (0, $6ee05925f8d16f34$export$32da4af7ebb91d8c)('cancel_button');
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ""
                                        }));
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    type: "submit",
                                    variant: "contained",
                                    color: "primary",
                                    children: selectedCoupon ? "Update Coupon" : "Create Coupon"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $3622247cddf607a6$export$2e2bcd8739ae039 = $3622247cddf607a6$var$CreateDiscountCoupon;



var $ayMG0 = parcelRequire("ayMG0");



const $82cae2c5318337e4$var$DeleteCouponModal = ({ deleteCoupon: deleteCoupon, loading: loading, onConfirm: onConfirm, onCancel: onCancel, modalType: modalType })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        style: {
                            backgroundColor: "rgba(252, 119, 133, 0.2)",
                            padding: "20px",
                            borderRadius: "50px",
                            height: "110px",
                            width: "110px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("kt5GL")),
                            alt: "deleteIcon",
                            style: {
                                height: "70px",
                                width: "70px"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "c15 fs1-75rem fw600 tac mt1-5rem",
                    children: "Delete Coupon"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fs1rem fw400 c3 mb1rem tac",
                    children: deleteCoupon && deleteCoupon.code
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "c15 fs1-25rem fs1rem-sm fw400 op70 w100 tac mb1rem",
                    children: [
                        "Are you sure you want to permanently delete the coupon?",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "This action can\u2019t be undone."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        btnType: "warning",
                        onClick: onConfirm,
                        loading: loading,
                        disabled: loading,
                        customClassName: "miw200px mla mra",
                        text: "Delete"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    onClick: onCancel,
                    className: "w100 tac mt0-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs14px cp",
                        style: {
                            color: "#15131380"
                        },
                        children: "Cancel"
                    })
                })
            ]
        })
    });
};
var $82cae2c5318337e4$export$2e2bcd8739ae039 = $82cae2c5318337e4$var$DeleteCouponModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");




var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a034abd43bd8eee$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5cff6b4166fff27c$export$717666c39ec07e12), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $5cff6b4166fff27c$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $1En50.default)(props, $1a034abd43bd8eee$var$_excluded);
    const muiFormControl = (0, $946238fa82894619$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $766e740713576b8d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $8nd05.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $2531239e3a525689$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), (0, $8nd05.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $9QePP.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, (0, $8nd05.default)({
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;





const $b580e6d7bf44b60d$var$CreateSubscriptionPlan = ({ selectedPlan: selectedPlan, fetchPlans: fetchPlans, modalType: modalType })=>{
    const [formData, setFormData] = (0, $acw62.useState)({
        name: '',
        price: '',
        description: '',
        interval: 'year',
        isActive: true
    });
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    (0, $acw62.useEffect)(()=>{
        if (selectedPlan) setFormData({
            name: selectedPlan.name || '',
            price: selectedPlan.price || '',
            description: selectedPlan.description || '',
            interval: selectedPlan.interval || 'year',
            isActive: selectedPlan.isActive !== false
        });
        else setFormData({
            name: '',
            price: '',
            description: '',
            interval: 'year',
            isActive: true
        });
    }, [
        selectedPlan
    ]);
    const handleChange = (e)=>{
        const { name: name, value: value, type: type, checked: checked } = e.target;
        let processedValue = value;
        // Convert plan name to uppercase
        if (name === 'name' && value) processedValue = value.toUpperCase();
        setFormData((prev)=>({
                ...prev,
                [name]: type === 'checkbox' ? checked : processedValue
            }));
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        try {
            if (selectedPlan) {
                // Update existing plan
                await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/update-subscription-plan/${selectedPlan._id}`, formData);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Subscription plan updated successfully');
            } else {
                // Create new plan
                await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/payment/subscription-plan', formData);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Subscription plan created successfully');
            }
            fetchPlans();
            setFormData({
                name: '',
                price: '',
                description: '',
                interval: 'year',
                isActive: true
            });
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        } catch (error) {
            console.error('Error saving subscription plan:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error saving subscription plan');
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: modalType === 'createSubscriptionPlan',
        onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            })),
        "aria-labelledby": "create-subscription-plan-modal",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 500,
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                maxHeight: '80vh',
                overflowY: 'auto'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "h6",
                    component: "h2",
                    gutterBottom: true,
                    children: selectedPlan ? 'Edit Subscription Plan' : 'Create New Subscription Plan'
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: "Plan Name",
                            name: "name",
                            value: formData.name,
                            onChange: handleChange,
                            margin: "normal",
                            required: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: "Price",
                            name: "price",
                            type: "number",
                            value: formData.price,
                            onChange: handleChange,
                            margin: "normal",
                            required: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: "Description",
                            name: "description",
                            value: formData.description,
                            onChange: handleChange,
                            margin: "normal",
                            multiline: true,
                            rows: 3
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            margin: "normal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                    children: "Interval"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                    name: "interval",
                                    value: formData.interval,
                                    onChange: handleChange,
                                    label: "Interval",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: "month",
                                            children: "Monthly"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                            value: "year",
                                            children: "Yearly"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                checked: formData.isActive,
                                onChange: handleChange,
                                name: "isActive"
                            }),
                            label: "Active",
                            sx: {
                                mt: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            sx: {
                                mt: 3,
                                display: 'flex',
                                gap: 2,
                                justifyContent: 'flex-end'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    disabled: loading,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                    type: "submit",
                                    variant: "contained",
                                    disabled: loading,
                                    children: loading ? 'Saving...' : selectedPlan ? 'Update' : 'Create'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $b580e6d7bf44b60d$export$2e2bcd8739ae039 = $b580e6d7bf44b60d$var$CreateSubscriptionPlan;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $3cf27b0deda0e2c5$var$DeleteSubscriptionPlan = ({ deletePlan: deletePlan, onConfirm: onConfirm, onCancel: onCancel, loading: loading, modalType: modalType })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: modalType === 'deleteSubscriptionPlan',
        onClose: onCancel,
        "aria-labelledby": "delete-subscription-plan-modal",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                borderRadius: 2
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "h6",
                    component: "h2",
                    gutterBottom: true,
                    children: "Delete Subscription Plan"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    sx: {
                        mt: 2,
                        mb: 3
                    },
                    children: [
                        'Are you sure you want to delete the subscription plan "',
                        deletePlan?.name,
                        '"? This action cannot be undone.'
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        gap: 2,
                        justifyContent: 'flex-end'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            onClick: onCancel,
                            disabled: loading,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                            variant: "contained",
                            color: "error",
                            onClick: onConfirm,
                            disabled: loading,
                            children: loading ? 'Deleting...' : 'Delete'
                        })
                    ]
                })
            ]
        })
    });
};
var $3cf27b0deda0e2c5$export$2e2bcd8739ae039 = $3cf27b0deda0e2c5$var$DeleteSubscriptionPlan;



var $45fvw = parcelRequire("45fvw");

const $d8a66b60e9fa741d$var$TransactionSettings = ()=>{
    const [coupons, setCoupons] = (0, $acw62.useState)([]);
    const [selectedCoupon, setSelectedCoupon] = (0, $acw62.useState)(null);
    const [completeData, setCompleteData] = (0, $acw62.useState)(null);
    const [step, setStep] = (0, $acw62.useState)('coupons');
    const [tab, setTab] = (0, $acw62.useState)('coupons');
    const [subscriptionPlans, setSubscriptionPlans] = (0, $acw62.useState)([]);
    const [selectedPlan, setSelectedPlan] = (0, $acw62.useState)(null);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    (0, $acw62.useEffect)(()=>{
        fetchCoupons();
        fetchSubscriptionPlans();
    }, []);
    const handleEdit = (coupon)=>{
        setSelectedCoupon(coupon);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'createCoupon'
        }));
    };
    const handleView = (coupon)=>{
        handleFetchCoupon(coupon?.code);
        setSelectedCoupon(coupon);
        setStep('viewCoupon');
    };
    const fetchCoupons = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/payment/getCoupons');
            setCoupons(response.body.coupons);
        } catch (error) {
            console.error('Error fetching coupons:', error);
        } finally{
            setSelectedCoupon(null);
        }
    };
    const handleFetchCoupon = async (code)=>{
        setLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/payment/getCoupon/${code}`);
        if (response.code === 200) setCompleteData(response.body);
        else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Coupon not found');
        setLoading(false);
    };
    const handleDelete = async (coupon)=>{
        console.log('Deleting coupon:', coupon);
        if (!coupon) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('No coupon selected for deletion');
            return;
        }
        if (!coupon._id) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Coupon ID is missing:', coupon);
            return;
        }
        setLoading(true);
        try {
            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/deleteCoupon/${coupon._id}`, {});
            fetchCoupons();
        } catch (error) {
            console.error('Error deleting coupon:', error);
        } finally{
            setLoading(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            setSelectedCoupon(null);
        }
    };
    const fetchSubscriptionPlans = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/payment/subscription-plans');
            setSubscriptionPlans(response.body.plans || []);
        } catch (error) {
            console.error('Error fetching subscription plans:', error);
            // For now, show sample data if API fails
            setSubscriptionPlans([
                {
                    _id: '1',
                    name: 'Lite',
                    price: 99,
                    currency: 'gbp',
                    priceId: 'price_lite_123',
                    isActive: true
                },
                {
                    _id: '2',
                    name: 'Pro',
                    price: 999,
                    currency: 'gbp',
                    priceId: 'price_pro_456',
                    isActive: true
                }
            ]);
        }
    };
    const handleEditPlan = (plan)=>{
        setSelectedPlan(plan);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'createSubscriptionPlan'
        }));
    };
    const handleDeletePlan = async (plan)=>{
        console.log('Deleting plan:', plan);
        if (!plan) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('No plan selected for deletion');
            return;
        }
        if (!plan._id) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Plan ID is missing:', plan);
            return;
        }
        setLoading(true);
        try {
            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/delete-subscription-plan/${plan._id}`, {});
            fetchSubscriptionPlans();
        } catch (error) {
            console.error('Error deleting plan:', error);
        } finally{
            setLoading(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            setSelectedPlan(null);
        }
    };
    const renderCouponsTab = ()=>{
        if (step === 'viewCoupon') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                p: 3
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>{
                        setStep('coupons');
                        setSelectedCoupon(null);
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        }));
                        setCompleteData(null);
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $297fb5ec09626165$export$2e2bcd8739ae039), {}),
                        " Back"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "h6",
                    className: "tac c15 mt1rem mb2rem",
                    children: [
                        "Coupon Code: ",
                        selectedCoupon?.code
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
                    component: (0, $595185d0d7275c3b$export$2e2bcd8739ae039),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Coupon Code"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Amount"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Purpose"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "User"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Company"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Transaction Date"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Status"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        colSpan: 7,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic jcc w100 h100",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                className: "tac c15 fs1-75rem pt1rem py3rem lh2",
                                                children: "Loading..."
                                            })
                                        })
                                    })
                                }) : completeData && completeData?.payments && completeData?.payments.length ? completeData?.payments.map((payment)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: completeData?.coupon?.code
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                className: "ttc",
                                                children: payment.amount
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                className: "ttc",
                                                children: payment.purpose.includes('=') ? `${payment.purpose.split('=')[0].split('-')[1]} - ${payment.purpose.split('=')[1].includes('HealthBoost') ? payment.purpose.split('=')[1].split('-')[1] : payment.purpose.split('=')[1]}` : payment.purpose
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: [
                                                    payment?.userId?.firstName,
                                                    " ",
                                                    payment?.userId?.lastName ? payment?.userId?.lastName : ""
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: payment?.companyId?.cName
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(payment.createdAt).format('DD-MM-YYYY HH:mm A')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: payment.status
                                            })
                                        ]
                                    }, payment._id)) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                        colSpan: 7,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mih50vh w100 df aic jcc",
                                            children: "No Transactions"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 3
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        variant: "contained",
                        color: "primary",
                        onClick: ()=>{
                            setSelectedCoupon(null);
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'createCoupon'
                            }));
                        },
                        children: "Create New Coupon"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
                    component: (0, $595185d0d7275c3b$export$2e2bcd8739ae039),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Coupon Code"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Discount Type"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Discount Value"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Valid From"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Valid Until"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                children: coupons.map((coupon)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: coupon.code
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                className: "ttc",
                                                children: coupon.discountType
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: coupon.discountType === 'percentage' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        coupon.discountValue,
                                                        "%",
                                                        ' ',
                                                        coupon.discountValue === 100 && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("jdo6l")),
                                                            alt: "dglogo",
                                                            className: "ml0-5rem",
                                                            width: 20,
                                                            height: 16
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        "\xa3",
                                                        coupon.discountValue
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: new Date(coupon.validFrom).toLocaleDateString()
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: new Date(coupon.expiresAt).toLocaleDateString()
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                    color: coupon.isActive ? 'success.main' : 'error.main',
                                                    children: coupon.isActive ? 'Active' : 'Inactive'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                        color: "primary",
                                                        onClick: ()=>handleView(coupon),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $742ce4f34134d568$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                        color: "primary",
                                                        onClick: ()=>handleEdit(coupon),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccd4473bf517ef36$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                        color: "error",
                                                        onClick: ()=>{
                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: 'deleteCoupon'
                                                            }));
                                                            setSelectedCoupon(coupon);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }, coupon._id))
                            })
                        ]
                    })
                })
            ]
        });
    };
    const renderSubscriptionPlansTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 3
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                        variant: "contained",
                        color: "primary",
                        onClick: ()=>{
                            setSelectedPlan(null);
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'createSubscriptionPlan'
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {}),
                            " Create New Plan"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d7964a6269b66c8$export$2e2bcd8739ae039), {
                    component: (0, $595185d0d7275c3b$export$2e2bcd8739ae039),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22fefd5f207422b3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9c28a8e795911dc$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Plan Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Price"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Currency"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Stripe Price ID"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                            children: "Actions"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d8a23708c3ccc9$export$2e2bcd8739ae039), {
                                children: subscriptionPlans.map((plan)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $22705465ad6920f8$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: plan.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: [
                                                    "\xa3",
                                                    plan.price
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                className: "ttc",
                                                children: plan.currency
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: plan.priceId
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                    color: plan.isActive !== false ? 'success.main' : 'error.main',
                                                    children: plan.isActive !== false ? 'Active' : 'Inactive'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a71dfe9e22152ea2$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                        color: "primary",
                                                        onClick: ()=>handleEditPlan(plan),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccd4473bf517ef36$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                                        color: "error",
                                                        onClick: ()=>{
                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: 'deleteSubscriptionPlan'
                                                            }));
                                                            setSelectedPlan(plan);
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }, plan._id || plan.name))
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                value: tab,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                        onChange: (e, value)=>setTab(value),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Coupons",
                                value: "coupons"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Subscription Plans",
                                value: "subscription-plans"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "coupons",
                        children: renderCouponsTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "subscription-plans",
                        children: renderSubscriptionPlansTab()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3622247cddf607a6$export$2e2bcd8739ae039), {
                selectedCoupon: selectedCoupon,
                fetchCoupons: fetchCoupons
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82cae2c5318337e4$export$2e2bcd8739ae039), {
                deleteCoupon: selectedCoupon,
                onConfirm: ()=>{
                    handleDelete(selectedCoupon);
                    setSelectedCoupon(null);
                },
                loading: loading,
                onCancel: ()=>setSelectedCoupon(null),
                modalType: "deleteCoupon"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b580e6d7bf44b60d$export$2e2bcd8739ae039), {
                selectedPlan: selectedPlan,
                fetchPlans: fetchSubscriptionPlans,
                modalType: modal.open
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3cf27b0deda0e2c5$export$2e2bcd8739ae039), {
                deletePlan: selectedPlan,
                onConfirm: ()=>{
                    handleDeletePlan(selectedPlan);
                    setSelectedPlan(null);
                },
                loading: loading,
                onCancel: ()=>{
                    setSelectedPlan(null);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                },
                modalType: modal.open
            })
        ]
    });
};
var $d8a66b60e9fa741d$export$2e2bcd8739ae039 = $d8a66b60e9fa741d$var$TransactionSettings;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");

const $90c3e5fa6c498a0b$var$FEATURE_LABELS = {
    'filing-assistant-allocation': "Allocation \u2013 Filing Assistant",
    'filing-assistant-autofill': "Auto-fill \u2013 Filing Assistant",
    'filing-assistant-other-modules': "Other Modules \u2013 Filing Assistant"
};
const $90c3e5fa6c498a0b$var$PROVIDER_META = {
    claude: {
        label: 'Claude',
        color: '#4A67FF',
        bg: '#EEF1FF'
    },
    gpt: {
        label: 'GPT',
        color: '#0BA26F',
        bg: '#E7F8F1'
    },
    embedding: {
        label: 'Embeddings',
        color: '#F0AE0D',
        bg: '#FDF5E3'
    }
};
const $90c3e5fa6c498a0b$var$formatCost = (v)=>v == null ? "\u2014" : v > 0 && v < 0.01 ? '<$0.01' : `$${Number(v).toFixed(2)}`;
const $90c3e5fa6c498a0b$var$formatTokens = (v)=>(v || 0).toLocaleString();
// Mirrors autoFillStepper's getModuleLabel so the same moduleType key reads the same way here
const $90c3e5fa6c498a0b$var$getModuleLabel = (moduleType)=>{
    if (!moduleType) return '';
    if (moduleType === 'repository') return 'Data Repository';
    if (moduleType.includes('business-audit')) return 'Business Audit';
    if (moduleType === 'warranty-disclosure') return 'Warranty Disclosures';
    if (moduleType.includes('directors-questionnaire')) return "Directors' Questionnaire";
    if (moduleType === 'Investment Readiness') return 'Investment Readiness';
    return moduleType;
};
// "Data Repository +1", "Data Repository +2" — primary module filled plus a count of any extra modules
// bundled into the same run (mirrors the Filing Assistant's multi-module select step).
const $90c3e5fa6c498a0b$var$formatModulesFilled = (moduleType, extraModules)=>{
    if (!moduleType) return '';
    const label = $90c3e5fa6c498a0b$var$getModuleLabel(moduleType);
    const extraCount = (extraModules || []).filter((m)=>m && m !== moduleType).length;
    return extraCount > 0 ? `${label} +${extraCount}` : label;
};
// Full module list for the hover tooltip, e.g. "Data Repository, Investment Readiness"
const $90c3e5fa6c498a0b$var$formatModulesFilledTooltip = (moduleType, extraModules)=>{
    if (!moduleType) return '';
    const all = [
        moduleType,
        ...extraModules || []
    ].filter((m, i, arr)=>m && arr.indexOf(m) === i);
    return all.map($90c3e5fa6c498a0b$var$getModuleLabel).join(', ');
};
// One phase's provider breakdown (Claude / GPT / Embeddings — calls, tokens, cost, and actual model ids used)
const $90c3e5fa6c498a0b$var$ProviderBreakdown = ({ phase: phase })=>{
    const providerRows = [
        'claude',
        'gpt',
        'embedding'
    ].map((key)=>({
            key: key,
            ...$90c3e5fa6c498a0b$var$PROVIDER_META[key],
            ...phase[key]
        })).filter((p)=>p.calls > 0);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df fdc",
        style: {
            gap: '0.5rem'
        },
        children: providerRows.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 br10px px1rem py0-75rem bw1px bss bo29",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        style: {
                            gap: '0.75rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    background: p.color,
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-8rem fw600 c15",
                                style: {
                                    flex: '0 0 110px'
                                },
                                children: p.label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem fw400 c28",
                                style: {
                                    flex: 1
                                },
                                children: [
                                    p.calls,
                                    " call",
                                    p.calls !== 1 ? 's' : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-8rem fw500 c14",
                                style: {
                                    flex: '0 0 100px',
                                    textAlign: 'right'
                                },
                                children: [
                                    $90c3e5fa6c498a0b$var$formatTokens(p.tokens),
                                    " tok"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-8rem fw600 c6",
                                style: {
                                    flex: '0 0 80px',
                                    textAlign: 'right'
                                },
                                children: $90c3e5fa6c498a0b$var$formatCost(p.cost)
                            })
                        ]
                    }),
                    p.models?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fww",
                        style: {
                            gap: '0.4rem',
                            marginTop: '0.5rem',
                            marginLeft: '1.15rem'
                        },
                        children: p.models.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-7rem fw500 c14",
                                style: {
                                    background: '#F0F2F5',
                                    borderRadius: '999px',
                                    padding: '0.15rem 0.6rem',
                                    lineHeight: 1.4
                                },
                                children: m
                            }, m))
                    })
                ]
            }, p.key))
    });
};
// One phase (Allocation / Auto-fill / Other Modules) within a run — its own files/questions/cost + providers
const $90c3e5fa6c498a0b$var$PhaseRow = ({ phase: phase })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg1 br10px px1rem py1rem mb0-75rem",
        style: {
            border: '1px solid #E8EBF5'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcsb mb0-75rem",
                style: {
                    gap: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-8rem fw600 c15",
                        children: $90c3e5fa6c498a0b$var$FEATURE_LABELS[phase.feature] || phase.feature
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-75rem fw400 c28",
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(phase.createdAt).format('MMM D, YYYY h:mm A')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic mb0-75rem",
                style: {
                    gap: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-75rem fw400 c28",
                        title: $90c3e5fa6c498a0b$var$formatModulesFilledTooltip(phase.moduleType, phase.extraModules),
                        children: $90c3e5fa6c498a0b$var$formatModulesFilled(phase.moduleType, phase.extraModules) || "\u2014"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fs0-75rem fw400 c28",
                        children: [
                            phase.filesUploaded || 0,
                            " files uploaded"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fs0-75rem fw400 c28",
                        children: [
                            phase.questionsProcessed || 0,
                            " questions answered"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fs0-75rem fw400 c28",
                        children: [
                            phase.totalCalls,
                            " AI action",
                            phase.totalCalls !== 1 ? 's' : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fs0-75rem fw400 c28",
                        children: [
                            $90c3e5fa6c498a0b$var$formatTokens(phase.totalTokens),
                            " tokens"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-8rem fw600 c6",
                        children: $90c3e5fa6c498a0b$var$formatCost(phase.totalCost)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($90c3e5fa6c498a0b$var$ProviderBreakdown, {
                phase: phase
            })
        ]
    });
// One run's summary row (files uploaded, questions processed, cost — combined across phases) + an expandable
// list of each phase (Allocation, Auto-fill, Other Modules) that shares this run's fileReportId.
const $90c3e5fa6c498a0b$var$RunRow = ({ run: run })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const featureLabel = run.phases.length > 1 ? run.phases.map((p)=>$90c3e5fa6c498a0b$var$FEATURE_LABELS[p.feature] || p.feature).join(" \u2192 ") : $90c3e5fa6c498a0b$var$FEATURE_LABELS[run.phases[0]?.feature] || run.phases[0]?.feature;
    const providerKeys = new Set();
    run.phases.forEach((p)=>[
            'claude',
            'gpt',
            'embedding'
        ].forEach((key)=>{
            if (p[key]?.calls > 0) providerKeys.add(key);
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg1 br10px bw1px bss bo29 mb1rem oh",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onClick: ()=>setOpen((o)=>!o),
                className: "df aic px1-5rem py1-5rem cp bg5-hover td250",
                style: {
                    gap: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        style: {
                            transition: 'transform 200ms',
                            transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M9 6l6 6-6 6",
                            stroke: "#9CA3AF",
                            strokeWidth: "2.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc",
                        style: {
                            flex: '1 1 160px',
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-875rem fw500 c15 oh",
                                style: {
                                    display: 'block',
                                    width: '100%',
                                    minWidth: 0,
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: run.userId ? `${run.userId.firstName || ''} ${run.userId.lastName || ''}`.trim() || "\u2014" : "\u2014"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem fw400 c28 oh",
                                style: {
                                    display: 'block',
                                    width: '100%',
                                    minWidth: 0,
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: run.userId?.email || "\u2014"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem fw400 c28",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(run.latestAt).format('MMM D, YYYY h:mm A')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc",
                        style: {
                            flex: '1 1 180px',
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fs0-875rem fw600 c6 oh",
                            style: {
                                display: 'block',
                                width: '100%',
                                minWidth: 0,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            children: run.companyId?.cName || "\u2014"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc",
                        style: {
                            flex: '1 1 180px',
                            minWidth: 0
                        },
                        title: featureLabel,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fs0-8rem fw500 c14 oh",
                            style: {
                                display: 'block',
                                width: '100%',
                                minWidth: 0,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            children: featureLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc",
                        style: {
                            flex: '1 1 160px',
                            minWidth: 0
                        },
                        title: $90c3e5fa6c498a0b$var$formatModulesFilledTooltip(run.moduleType, run.extraModules),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fs0-8rem fw500 c15 oh",
                            style: {
                                display: 'block',
                                width: '100%',
                                minWidth: 0,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            children: $90c3e5fa6c498a0b$var$formatModulesFilled(run.moduleType, run.extraModules) || "\u2014"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic",
                        style: {
                            flex: '1 1 220px',
                            gap: '0.4rem'
                        },
                        children: [
                            ...providerKeys
                        ].map((key)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem fw600 br50px px0-75rem py0-25rem",
                                style: {
                                    background: $90c3e5fa6c498a0b$var$PROVIDER_META[key].bg,
                                    color: $90c3e5fa6c498a0b$var$PROVIDER_META[key].color
                                },
                                children: $90c3e5fa6c498a0b$var$PROVIDER_META[key].label
                            }, key))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc tar",
                        style: {
                            flex: '0 0 100px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-875rem fw500 c15",
                                children: run.filesUploaded || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem fw400 c28",
                                children: "files"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc tar",
                        style: {
                            flex: '0 0 110px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-875rem fw500 c15",
                                children: run.questionsProcessed || 0
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem fw400 c28",
                                children: "answered"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc tar",
                        style: {
                            flex: '0 0 90px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fs1rem fw600 c40",
                            children: $90c3e5fa6c498a0b$var$formatCost(run.totalCost)
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg54 px1-5rem py1rem",
                style: {
                    borderTop: '1px solid #E8EBF5'
                },
                children: run.phases.map((phase)=>/*#__PURE__*/ (0, $ayMG0.jsx)($90c3e5fa6c498a0b$var$PhaseRow, {
                        phase: phase
                    }, phase._id))
            })
        ]
    });
};
const $90c3e5fa6c498a0b$var$StatTile = ({ label: label, value: value, color: color })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg38 br10px p1-5rem",
        style: {
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1-75rem fw600 mb0-25rem",
                style: {
                    color: color
                },
                children: value
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs0-8rem fw400 c28 mb0rem",
                children: label
            })
        ]
    });
const $90c3e5fa6c498a0b$var$AiCosting = ()=>{
    const [logs, setLogs] = (0, $acw62.useState)([]);
    const [total, setTotal] = (0, $acw62.useState)(0);
    const [page, setPage] = (0, $acw62.useState)(0);
    const [limit, setLimit] = (0, $acw62.useState)(50);
    const [feature, setFeature] = (0, $acw62.useState)('');
    const [provider, setProvider] = (0, $acw62.useState)('');
    const [search, setSearch] = (0, $acw62.useState)('');
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchLogs = async ()=>{
        setLoading(true);
        try {
            const params = new URLSearchParams({
                page: page + 1,
                limit: limit
            });
            if (feature) params.append('feature', feature);
            if (provider) params.append('provider', provider);
            if (search.trim()) params.append('search', search.trim());
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/ai-usage-logs?${params.toString()}`);
            if (response?.code === 200) {
                setLogs(response.body.logs || []);
                setTotal(response.body.total || 0);
            }
        } catch (error) {
            console.error('Error fetching AI usage logs:', error);
        } finally{
            setLoading(false);
        }
    };
    // Debounce the free-text search so we don't fire a request on every keystroke
    (0, $acw62.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setPage(0);
            fetchLogs();
        }, 350);
        return ()=>clearTimeout(timer);
    }, [
        search
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>{
        fetchLogs();
    }, [
        page,
        limit,
        feature,
        provider
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const pageStats = (0, $acw62.useMemo)(()=>({
            cost: logs.reduce((sum, r)=>sum + (r.totalCost || 0), 0),
            files: logs.reduce((sum, r)=>sum + (r.filesUploaded || 0), 0),
            questions: logs.reduce((sum, r)=>sum + (r.questionsProcessed || 0), 0)
        }), [
        logs
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic mb1-5rem",
                style: {
                    gap: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($90c3e5fa6c498a0b$var$StatTile, {
                        label: "Total runs (this page)",
                        value: total,
                        color: "#151313"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($90c3e5fa6c498a0b$var$StatTile, {
                        label: "Files uploaded (this page)",
                        value: pageStats.files,
                        color: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($90c3e5fa6c498a0b$var$StatTile, {
                        label: "Questions Answered (this page)",
                        value: pageStats.questions,
                        color: "#0BA26F"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($90c3e5fa6c498a0b$var$StatTile, {
                        label: "Total cost (this page)",
                        value: $90c3e5fa6c498a0b$var$formatCost(pageStats.cost),
                        color: "#40C353"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcsb mb1-5rem",
                style: {
                    gap: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        style: {
                            gap: '0.75rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: feature,
                                onChange: (e)=>{
                                    setPage(0);
                                    setFeature(e.target.value);
                                },
                                className: "br50px px1-5rem py0-5rem bw1px bss bo29 bg1 fs0-875rem fw500 c15 cp",
                                style: {
                                    minWidth: 260,
                                    appearance: 'none',
                                    outline: 'none'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "All Features"
                                    }),
                                    Object.entries($90c3e5fa6c498a0b$var$FEATURE_LABELS).map(([key, label])=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: key,
                                            children: label
                                        }, key))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: provider,
                                onChange: (e)=>{
                                    setPage(0);
                                    setProvider(e.target.value);
                                },
                                className: "br50px px1-5rem py0-5rem bw1px bss bo29 bg1 fs0-875rem fw500 c15 cp",
                                style: {
                                    minWidth: 180,
                                    appearance: 'none',
                                    outline: 'none'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: "",
                                        children: "All Providers"
                                    }),
                                    Object.entries($90c3e5fa6c498a0b$var$PROVIDER_META).map(([key, meta])=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: key,
                                            children: meta.label
                                        }, key))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        value: search,
                        onChange: (e)=>setSearch(e.target.value),
                        placeholder: "Search by company or user\u2026",
                        className: "br50px px1-5rem py0-5rem bw1px bss bo29 bg1 fs0-875rem fw400 c15",
                        style: {
                            minWidth: 260,
                            outline: 'none'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic px1-5rem py0-5rem mb0-5rem",
                style: {
                    gap: '1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            width: 14,
                            flexShrink: 0
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu",
                        style: {
                            flex: '1 1 160px',
                            letterSpacing: '0.05em'
                        },
                        children: "Run By"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu",
                        style: {
                            flex: '1 1 180px',
                            letterSpacing: '0.05em'
                        },
                        children: "Company"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu",
                        style: {
                            flex: '1 1 180px',
                            letterSpacing: '0.05em'
                        },
                        children: "Feature"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu",
                        style: {
                            flex: '1 1 160px',
                            letterSpacing: '0.05em'
                        },
                        children: "Modules Filled"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu",
                        style: {
                            flex: '1 1 220px',
                            letterSpacing: '0.05em'
                        },
                        children: "Providers Used"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu tar",
                        style: {
                            flex: '0 0 100px',
                            letterSpacing: '0.05em'
                        },
                        children: "Files Uploaded"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu tar",
                        style: {
                            flex: '0 0 110px',
                            letterSpacing: '0.05em'
                        },
                        children: "Questions Answered"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-7rem fw600 c28 ttu tar",
                        style: {
                            flex: '0 0 90px',
                            letterSpacing: '0.05em'
                        },
                        children: "Cost"
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df aic jcc bg38 br10px",
                style: {
                    minHeight: '30vh'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fs1rem fw500 c28",
                    children: "Loading\u2026"
                })
            }) : logs.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    logs.map((run)=>/*#__PURE__*/ (0, $ayMG0.jsx)($90c3e5fa6c498a0b$var$RunRow, {
                            run: run
                        }, run._id)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcfe mt0-5rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $effe3c7e7b91170d$export$2e2bcd8739ae039), {
                            component: "div",
                            count: total,
                            page: page,
                            onPageChange: (_, newPage)=>setPage(newPage),
                            rowsPerPage: limit,
                            onRowsPerPageChange: (e)=>{
                                setLimit(parseInt(e.target.value, 10));
                                setPage(0);
                            },
                            rowsPerPageOptions: [
                                25,
                                50,
                                100
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcc fdc bg38 br10px",
                style: {
                    minHeight: '30vh'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs1rem fw500 c15 mb0-25rem",
                        children: "No AI usage recorded yet"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-8rem fw400 c28",
                        children: "Costs will appear here after a Filing Assistant run completes."
                    })
                ]
            })
        ]
    });
};
var $90c3e5fa6c498a0b$export$2e2bcd8739ae039 = $90c3e5fa6c498a0b$var$AiCosting;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $45fvw = parcelRequire("45fvw");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $f7b3699fc8690eef$var$AdminCompanyDetails = ({ id: id, setPlan: setPlan })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [company, setCompany] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [openDropdowns, setOpenDropdowns] = (0, $acw62.useState)({});
    const [providesCFOServices, setProvidesCFOServices] = (0, $acw62.useState)(false);
    const dropdownRefs = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(()=>{
        if (id) fetchCompanyDetails();
    }, [
        id
    ]);
    const fetchCompanyDetails = async ()=>{
        try {
            setLoading(true);
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/company/${id}`);
            if (response && response.code === 200) {
                setCompany(response.body);
                setProvidesCFOServices(response.body.providesCFOServices || false);
            } else setError("Company not found");
        } catch (err) {
            setError("Failed to load company details");
        } finally{
            setLoading(false);
        }
    };
    const handleBackToAdmin = ()=>{
        navigate("/admin");
    };
    const handleCFOServicesToggle = async (e)=>{
        const newValue = e.target.checked;
        setProvidesCFOServices(newValue);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/company/${id}`, {
                providesCFOServices: newValue
            });
            if (response && response.code === 200) setCompany((prev)=>({
                    ...prev,
                    providesCFOServices: newValue
                }));
        } catch (err) {
            setProvidesCFOServices(!newValue);
            setError("Failed to update CFO services status");
        }
    };
    const toggleDropdown = (companyId)=>{
        setOpenDropdowns((prev)=>({
                ...prev,
                [companyId]: !prev[companyId]
            }));
    };
    const getAvailablePlans = (company)=>{
        // If company has servicedBy, only show Pro
        console.log(company.servicedBy && company.servicedBy['role'] !== "User" && company.servicedBy['role'] !== "Member");
        if (company.servicedBy && company.servicedBy['role'] !== "User" && company.servicedBy['role'] !== "Member") return [
            'Pro'
        ];
        // If subscription is Free, show Lite and Pro
        if (company.subscription === 'Free') return [
            'Lite',
            'Pro'
        ];
        // If subscription is Lite, only show Pro
        if (company.subscription === 'Lite') return [
            'Pro'
        ];
        // For any other case (undefined, null, etc.), show Lite and Pro
        return [
            'Lite',
            'Pro'
        ];
    };
    const handleUpgrade = (company, plan)=>{
        setPlan(plan);
        setOpenDropdowns((prev)=>({
                ...prev,
                [company._id]: false
            }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'subscriptionPaymentConfirm'
        }));
    };
    // Close dropdown when clicking outside
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            Object.keys(dropdownRefs.current).forEach((companyId)=>{
                if (dropdownRefs.current[companyId] && !dropdownRefs.current[companyId].contains(event.target)) setOpenDropdowns((prev)=>({
                        ...prev,
                        [companyId]: false
                    }));
            });
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // Create a function to render the subscription upgrade cell
    const renderSubscriptionCell = (company)=>{
        const companyId = company._id;
        const isDropdownOpen = openDropdowns[companyId] || false;
        const availablePlans = getAvailablePlans(company);
        // If subscription is Pro, show disabled badge
        if (company.subscription === "Pro") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "adminCompanyDetailPage-subscription-badge adminCompanyDetailPage-pro",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                    className: "fa fa-crown"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: "Pro"
                })
            ]
        });
        // For all other cases, show interactive dropdown
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: (el)=>dropdownRefs.current[companyId] = el,
            className: "adminCompanyDetailPage-subscription-dropdown",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "adminCompanyDetailPage-subscription-upgrade-btn",
                    onClick: ()=>toggleDropdown(companyId),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "fa fa-arrow-up"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "Upgrade"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: `fa fa-chevron-${isDropdownOpen ? 'up' : 'down'}`
                        })
                    ]
                }),
                isDropdownOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "adminCompanyDetailPage-subscription-dropdown-menu",
                    children: availablePlans.map((plan, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "adminCompanyDetailPage-subscription-option",
                            onClick: ()=>handleUpgrade(company, plan),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: plan
                            })
                        }, plan))
                })
            ]
        });
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df fdc aic jcc",
        style: {
            minHeight: "50vh"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "fs1-5rem c4",
            children: "Loading company details..."
        })
    });
    if (error || !company) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df fdc aic jcc",
        style: {
            minHeight: "50vh"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fs1-5rem c9 mb2rem",
                children: error || "Company not found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: handleBackToAdmin,
                className: "bg4 c1 px2rem py1rem br5px cp",
                children: "Back to Admin"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "adminCompanyDetailPage-company-details-modal",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "adminCompanyDetailPage-modal-header",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "adminCompanyDetailPage-header-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "adminCompanyDetailPage-company-avatar",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "adminCompanyDetailPage-avatar-circle",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "adminCompanyDetailPage-avatar-text",
                                        children: company.cName?.[0]?.toUpperCase() || 'C'
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "adminCompanyDetailPage-header-info",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "adminCompanyDetailPage-company-title",
                                        children: company.cName || 'Unknown Company'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "adminCompanyDetailPage-company-subtitle",
                                        children: "Company Details"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "adminCompanyDetailPage-modal-content",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "adminCompanyDetailPage-cfo-services-card",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "adminCompanyDetailPage-cfo-card-content",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "adminCompanyDetailPage-cfo-icon-wrapper",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "adminCompanyDetailPage-cfo-icon",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "fa fa-briefcase"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "adminCompanyDetailPage-cfo-info",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "adminCompanyDetailPage-cfo-title",
                                                children: "CFO Services"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "adminCompanyDetailPage-cfo-description",
                                                children: "Enable if this company provides Chief Financial Officer services"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "adminCompanyDetailPage-toggle-switch",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                checked: providesCFOServices,
                                                onChange: handleCFOServicesToggle
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "adminCompanyDetailPage-toggle-slider"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "adminCompanyDetailPage-info-grid",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "adminCompanyDetailPage-info-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "adminCompanyDetailPage-card-header",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "adminCompanyDetailPage-card-icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "fa fa-building"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "adminCompanyDetailPage-card-title",
                                                    children: "Company Information"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "adminCompanyDetailPage-card-content",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "adminCompanyDetailPage-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-info-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-hashtag"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Company Number"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "adminCompanyDetailPage-info-value",
                                                            children: company['ukRegNo'] || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "adminCompanyDetailPage-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-info-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-bullseye"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Company Objective"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "adminCompanyDetailPage-info-value",
                                                            children: company.cType || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "adminCompanyDetailPage-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-info-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-building"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Company Stage"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "adminCompanyDetailPage-info-value adminCompanyDetailPage-stage-badge",
                                                            children: company.cStage || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "adminCompanyDetailPage-info-card",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "adminCompanyDetailPage-card-header",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "adminCompanyDetailPage-card-icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "fa fa-users"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "adminCompanyDetailPage-card-title",
                                                    children: "Team & Subscription"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "adminCompanyDetailPage-card-content",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "adminCompanyDetailPage-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-info-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-user-plus"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Created By"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-creator-info",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "adminCompanyDetailPage-creator-avatar",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "adminCompanyDetailPage-creator-initials",
                                                                        children: [
                                                                            company.creatorId?.firstName?.[0],
                                                                            company.creatorId?.lastName?.[0]
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "adminCompanyDetailPage-creator-name",
                                                                    children: [
                                                                        company.creatorId?.firstName,
                                                                        " ",
                                                                        company.creatorId?.lastName
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "adminCompanyDetailPage-info-item adminCompanyDetailPage-subscription-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-info-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-credit-card"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Subscription"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "adminCompanyDetailPage-subscription-wrapper",
                                                            children: renderSubscriptionCell(company)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "adminCompanyDetailPage-info-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-info-label",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-certificate"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Certificate"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "adminCompanyDetailPage-data-room-status",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "adminCompanyDetailPage-status-indicator adminCompanyDetailPage-disconnected"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "adminCompanyDetailPage-status-text",
                                                                    children: company['certificateNext'] || "-"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $f7b3699fc8690eef$export$2e2bcd8739ae039 = $f7b3699fc8690eef$var$AdminCompanyDetails;


const $639eb6379d0e6bda$var$AdminCompanyDetailsModal = ({ id: id, setPlan: setPlan })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: 'AdminCompanyDetails',
        modalCardClasses: "adminCompanyDetailPage-modal-container",
        customStyle: {
            maxHeight: 'calc(90vh)',
            maxWidth: '800px',
            width: '90vw',
            padding: '0',
            borderRadius: '16px',
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7b3699fc8690eef$export$2e2bcd8739ae039), {
            id: id,
            setPlan: setPlan
        })
    });
};
var $639eb6379d0e6bda$export$2e2bcd8739ae039 = $639eb6379d0e6bda$var$AdminCompanyDetailsModal;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $dcbdda2424310929$var$TagDropdown = ({ allTags: allTags, selectedCompanies: selectedCompanies, companiesData: companiesData, onAddTags: onAddTags, onRemoveTags: onRemoveTags, onClose: onClose, onTagCreated: onTagCreated })=>{
    const [selectedTags, setSelectedTags] = (0, $acw62.useState)([]);
    const [showCreateTag, setShowCreateTag] = (0, $acw62.useState)(false);
    const [newTagName, setNewTagName] = (0, $acw62.useState)("");
    const [isCreating, setIsCreating] = (0, $acw62.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const dropdownRef = (0, $acw62.useRef)(null);
    const filteredTags = allTags.filter((tag)=>tag.toLowerCase().includes(searchTerm.toLowerCase()));
    const getCommonTags = ()=>{
        if (companiesData.length === 0) return [];
        const firstCompanyTags = companiesData[0]?.tags || [];
        return firstCompanyTags.filter((tag)=>companiesData.every((company)=>company.tags?.includes(tag)));
    };
    const commonTags = getCommonTags();
    (0, $acw62.useEffect)(()=>{
        setSelectedTags(commonTags);
    }, [
        companiesData
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) onClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, [
        onClose
    ]);
    const handleTagToggle = (tag)=>{
        setSelectedTags((prev)=>{
            if (prev.includes(tag)) return prev.filter((t)=>t !== tag);
            return [
                ...prev,
                tag
            ];
        });
    };
    const handleCreateTag = async ()=>{
        if (!newTagName.trim()) return;
        setIsCreating(true);
        try {
            await onAddTags([
                newTagName.trim()
            ], true);
            setNewTagName("");
            setShowCreateTag(false);
            onTagCreated();
        } catch (error) {
            console.error("Error creating tag:", error);
        }
        setIsCreating(false);
    };
    const handleApply = ()=>{
        const tagsToAdd = selectedTags.filter((tag)=>!commonTags.includes(tag));
        const tagsToRemove = commonTags.filter((tag)=>!selectedTags.includes(tag));
        if (tagsToAdd.length > 0) onAddTags(tagsToAdd);
        if (tagsToRemove.length > 0) onRemoveTags(tagsToRemove);
        if (tagsToAdd.length === 0 && tagsToRemove.length === 0) onClose();
    };
    if (showCreateTag) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: dropdownRef,
        style: {
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: "8px",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            minWidth: "280px",
            zIndex: 1000,
            border: "1px solid #e5e7eb"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: "12px 16px",
                    borderBottom: "1px solid #e5e7eb",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setShowCreateTag(false),
                        style: {
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            color: "#6b7280",
                            display: "flex",
                            alignItems: "center"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontWeight: 600,
                            color: "#374151"
                        },
                        children: "Create New Tag"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: "16px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        placeholder: "Enter tag name...",
                        value: newTagName,
                        onChange: (e)=>setNewTagName(e.target.value),
                        onKeyPress: (e)=>e.key === "Enter" && handleCreateTag(),
                        autoFocus: true,
                        style: {
                            width: "100%",
                            padding: "10px 12px",
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            fontSize: "14px",
                            outline: "none",
                            marginBottom: "12px"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "8px",
                            justifyContent: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>{
                                    setShowCreateTag(false);
                                    setNewTagName("");
                                },
                                style: {
                                    padding: "8px 16px",
                                    backgroundColor: "#f3f4f6",
                                    color: "#374151",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    fontWeight: 500
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: handleCreateTag,
                                disabled: !newTagName.trim() || isCreating,
                                style: {
                                    padding: "8px 16px",
                                    backgroundColor: newTagName.trim() ? "#fc7785" : "#e5e7eb",
                                    color: newTagName.trim() ? "white" : "#9ca3af",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: newTagName.trim() ? "pointer" : "not-allowed",
                                    fontSize: "14px",
                                    fontWeight: 500
                                },
                                children: isCreating ? "Creating..." : "Create Tag"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: dropdownRef,
        style: {
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: "8px",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            minWidth: "280px",
            zIndex: 1000,
            border: "1px solid #e5e7eb"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: "12px 16px",
                    borderBottom: "1px solid #e5e7eb",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontWeight: 600,
                            color: "#374151"
                        },
                        children: "Manage Tags"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: onClose,
                        style: {
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            color: "#374151",
                            fontSize: "16px"
                        },
                        children: "\u2715"
                    })
                ]
            }),
            allTags.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: "8px 16px",
                    borderBottom: "1px solid #e5e7eb"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "text",
                    placeholder: "Search tags...",
                    value: searchTerm,
                    onChange: (e)=>setSearchTerm(e.target.value),
                    style: {
                        width: "100%",
                        padding: "8px 12px",
                        border: "1px solid #d1d5db",
                        borderRadius: "6px",
                        fontSize: "14px",
                        outline: "none"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    maxHeight: "200px",
                    overflowY: "auto",
                    padding: "8px 0"
                },
                children: allTags.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: "16px",
                        textAlign: "center",
                        color: "#9ca3af",
                        fontSize: "14px"
                    },
                    children: "No tags yet. Create one below."
                }) : filteredTags.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: "16px",
                        textAlign: "center",
                        color: "#9ca3af",
                        fontSize: "14px"
                    },
                    children: "No tags found."
                }) : filteredTags.map((tag, index)=>{
                    const isSelected = selectedTags.includes(tag);
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        onClick: ()=>handleTagToggle(tag),
                        style: {
                            padding: "8px 16px",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            backgroundColor: isSelected ? "#f0f9ff" : "transparent",
                            transition: "background-color 0.15s"
                        },
                        onMouseEnter: (e)=>e.currentTarget.style.backgroundColor = isSelected ? "#f0f9ff" : "#f9fafb",
                        onMouseLeave: (e)=>e.currentTarget.style.backgroundColor = isSelected ? "#f0f9ff" : "transparent",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: "18px",
                                    height: "18px",
                                    borderRadius: "4px",
                                    border: `2px solid ${isSelected ? "#3b82f6" : "#d1d5db"}`,
                                    backgroundColor: isSelected ? "#3b82f6" : "transparent",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: "12px",
                                    transition: "all 0.15s"
                                },
                                children: isSelected && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        color: "white",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        lineHeight: 1
                                    },
                                    children: "\u2713"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: "#374151",
                                    fontSize: "14px"
                                },
                                children: tag
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    padding: "8px 16px",
                    borderTop: "1px solid #e5e7eb"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: ()=>setShowCreateTag(true),
                    style: {
                        width: "100%",
                        padding: "10px 12px",
                        backgroundColor: "#fc7785",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        transition: "all 0.15s"
                    },
                    onMouseEnter: (e)=>{
                        e.currentTarget.style.backgroundColor = "#e5636f";
                    },
                    onMouseLeave: (e)=>{
                        e.currentTarget.style.backgroundColor = "#fc7785";
                    },
                    children: "Add New Tag"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: "12px 16px",
                    borderTop: "1px solid #e5e7eb",
                    display: "flex",
                    gap: "8px",
                    justifyContent: "flex-end"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: onClose,
                        style: {
                            padding: "8px 16px",
                            backgroundColor: "#f3f4f6",
                            color: "#374151",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: 500
                        },
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: handleApply,
                        style: {
                            padding: "8px 16px",
                            backgroundColor: "#fc7785",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: 500
                        },
                        children: "Apply"
                    })
                ]
            })
        ]
    });
};
var $dcbdda2424310929$export$2e2bcd8739ae039 = $dcbdda2424310929$var$TagDropdown;


const $fe21d3c4e4f6d27e$var$LoginHistoryCell = ({ company: company })=>{
    const [pos, setPos] = (0, $acw62.useState)(null);
    const ref = (0, $acw62.useRef)(null);
    const history = company['creatorId']?.['loginHistory'] || [];
    const lastLogin = company['creatorId']?.['lastLogin'] || company['creatorId']?.['lastLoginAt'];
    const label = lastLogin ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(lastLogin).format('DD/MMM/YY') : '-';
    (0, $acw62.useEffect)(()=>{
        if (!pos) return;
        const handleClick = (e)=>{
            if (ref.current && !ref.current.contains(e.target)) setPos(null);
        };
        document.addEventListener('mousedown', handleClick);
        return ()=>document.removeEventListener('mousedown', handleClick);
    }, [
        pos
    ]);
    const handleOpen = (e)=>{
        if (!history.length) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setPos(pos ? null : {
            top: rect.bottom + 4,
            left: rect.left
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df jcc aic",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: handleOpen,
                "data-tooltip": "See Login History",
                style: {
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: history.length > 0 ? "pointer" : "default",
                    opacity: history.length > 0 ? 1 : 0.3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                    className: "fa fa-clock-o",
                    style: {
                        fontSize: '20px',
                        color: "#038589"
                    }
                })
            }),
            pos && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 shadow br10px",
                style: {
                    position: 'fixed',
                    top: pos.top,
                    left: pos.left,
                    zIndex: 99999,
                    minWidth: '180px',
                    padding: '10px 0',
                    border: '1px solid #DDE2F2'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs12px fw600 c15 tac",
                        style: {
                            padding: '4px 16px 8px',
                            borderBottom: '1px solid #DDE2F2',
                            margin: '0 0 4px'
                        },
                        children: "Login History"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            maxHeight: '260px',
                            overflowY: 'auto'
                        },
                        children: [
                            ...history
                        ].reverse().map((entry, i)=>{
                            const date = entry?.['date'] || entry;
                            const user = entry?.['userId'];
                            const name = user?.['firstName'] ? `${user['firstName']} ${user['lastName'] || ''}`.trim() : 'Unknown';
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: '6px 16px',
                                    borderBottom: i < history.length - 1 ? '1px solid #f0f0f8' : 'none'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs12px fw600 c15",
                                        style: {
                                            margin: '0 0 2px'
                                        },
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs11px c12",
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format('DD MMM YY, hh:mm A'),
                                            " \xa0\xb7\xa0 ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).fromNow()
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
const $fe21d3c4e4f6d27e$var$SubscribedCompaniesTab = ({ isArchived: isArchived, isYopmail: isYopmail, setDeleteCompany: setDeleteCompany, handleRevenueLeadMode: handleRevenueLeadMode })=>{
    const [data, setData] = (0, $acw62.useState)([]);
    const [pages, setPages] = (0, $acw62.useState)(0);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)("");
    const searchTermRef = (0, $acw62.useRef)("");
    const fetchIdRef = (0, $acw62.useRef)(0);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [plan, setPlan] = (0, $acw62.useState)('Pro');
    const [selectedCompany, setSelectedCompany] = (0, $acw62.useState)(null);
    // Tag-related state
    const [selectedCompanies, setSelectedCompanies] = (0, $acw62.useState)([]);
    const [showTagDropdown, setShowTagDropdown] = (0, $acw62.useState)(false);
    const [allTags, setAllTags] = (0, $acw62.useState)([]);
    const [tableState, setTableState] = (0, $acw62.useState)({
        page: 0,
        pageSize: 20,
        filtered: [],
        sorted: []
    });
    // Tag filter state
    const [filterTags, setFilterTags] = (0, $acw62.useState)([]);
    const [showFilterDropdown, setShowFilterDropdown] = (0, $acw62.useState)(false);
    const [filterSearchTerm, setFilterSearchTerm] = (0, $acw62.useState)("");
    // Partner filter state
    const [filterPartners, setFilterPartners] = (0, $acw62.useState)([]);
    const [showPartnerFilterDropdown, setShowPartnerFilterDropdown] = (0, $acw62.useState)(false);
    const [partnerSearchTerm, setPartnerSearchTerm] = (0, $acw62.useState)("");
    const [allPartners, setAllPartners] = (0, $acw62.useState)([]);
    // Filter tags based on search term
    const filteredFilterTags = allTags.filter((tag)=>tag.toLowerCase().includes(filterSearchTerm.toLowerCase()));
    // Filter partners based on search term
    const filteredFilterPartners = allPartners.filter((partner)=>(partner.name || '').toLowerCase().includes(partnerSearchTerm.toLowerCase()));
    // Fetch all tags and partners on mount
    (0, $acw62.useEffect)(()=>{
        fetchAllTags();
        fetchAllPartners();
    }, []);
    const fetchAllTags = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/manageTags', {
                action: 'list'
            });
            if (response?.code === 200) setAllTags(response.body?.tags || []);
        } catch (error) {
            console.error('Error fetching tags:', error);
        }
    };
    const fetchAllPartners = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/company/getCompanyPartners');
            if (response?.code === 200) setAllPartners(response.body?.partners || []);
        } catch (error) {
            console.error('Error fetching partners:', error);
        }
    };
    // Handle select all checkbox
    const handleSelectAll = (e)=>{
        if (e.target.checked) setSelectedCompanies(data.map((company)=>company._id));
        else setSelectedCompanies([]);
    };
    // Handle individual checkbox
    const handleSelectCompany = (companyId)=>{
        setSelectedCompanies((prev)=>{
            if (prev.includes(companyId)) return prev.filter((id)=>id !== companyId);
            else return [
                ...prev,
                companyId
            ];
        });
    };
    // Handle tag operations
    const handleTagAction = async (action, tags, keepOpen = false)=>{
        if (selectedCompanies.length === 0) return;
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/manageTags', {
                action: action,
                companyIds: selectedCompanies,
                tags: tags
            });
            if (response?.code === 200) {
                // Refresh data
                fetchData(tableState);
                fetchAllTags();
                // Only close if not keepOpen
                if (!keepOpen) setShowTagDropdown(false);
            }
        } catch (error) {
            console.error('Error managing tags:', error);
        }
    };
    const companiesColumns = [
        // Checkbox column
        {
            id: 'select',
            Header: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "checkbox",
                    checked: data.length > 0 && selectedCompanies.length === data.length,
                    onChange: handleSelectAll
                }),
            accessor: (company)=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "checkbox",
                    checked: selectedCompanies.includes(company._id),
                    onChange: ()=>handleSelectCompany(company._id)
                }),
            sortable: false,
            filterable: false,
            width: 50
        },
        {
            id: 'cName',
            Header: 'Name',
            accessor: (company)=>company['cName'] ? company['cName'] : '-'
        },
        {
            id: 'creatorId',
            Header: 'Owner',
            accessor: (company)=>company['creatorId']?.['firstName'] ? company['creatorId']?.['firstName'] + " " + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : '') : '-'
        },
        {
            id: 'partnerId',
            Header: 'Partner',
            accessor: (company)=>company['partnerId']?.['name'] ? company['partnerId']?.['name'] : '-'
        },
        {
            id: 'pitchDeck',
            Header: 'Pitch Deck',
            accessor: (company)=>company['pitchDeckFiles']?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic jcc",
                    style: {
                        gap: '6px'
                    },
                    children: company['pitchDeckFiles'].map((file, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: file['location'],
                            target: "_blank",
                            rel: "noreferrer",
                            "data-tooltip": file['originalname'] || 'Download Pitch Deck',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "fa fa-file-pdf-o cp",
                                style: {
                                    fontSize: '18px',
                                    color: '#4A67FF'
                                }
                            })
                        }, index))
                }) : '-',
            sortable: false,
            width: 100
        },
        {
            id: 'members',
            Header: 'Members',
            accessor: (company)=>company['members']?.length > 0 ? company['members']?.map((obj, i, arr)=>{
                    return `${obj?.firstName ? obj?.firstName : ""} ${obj?.lastName ? obj?.lastName : ""}`;
                }) : '-'
        },
        {
            id: 'createdAt',
            Header: 'Created At',
            accessor: (company)=>company['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['createdAt']).format('DD/MMM/YY') : '-'
        },
        {
            id: 'subscription',
            Header: 'Subscription',
            accessor: (company)=>company['subscription'] ? company['subscription'] : '-'
        },
        {
            id: 'cType',
            Header: 'Type',
            accessor: (company)=>company['cType'] ? company['cType'] : '-'
        },
        {
            id: 'cStage',
            Header: 'Stage',
            accessor: (company)=>company['cStage'] ? company['cStage'] : '-'
        },
        {
            id: 'cLevel',
            Header: 'Certification',
            accessor: (company)=>company['cLevel'] && company['cLevel'] !== 'None' ? company['cLevel'] : 'Uncertified'
        },
        {
            id: 'paymentSource',
            Header: 'Source',
            accessor: (company)=>{
                return company['isParent'] ? "In-Direct" : 'Direct';
            }
        },
        {
            id: 'testType',
            Header: 'Test Type',
            accessor: (company)=>company['testType'] ? company['testType'] : '-'
        },
        // Tags column
        {
            id: 'tags',
            Header: 'Tags',
            accessor: (company)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc fww gg0-25rem",
                    children: company.tags && company.tags.length > 0 ? company.tags.map((tag, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                backgroundColor: '#e0e7ff',
                                color: '#3730a3',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '11px',
                                fontWeight: '500'
                            },
                            children: tag
                        }, index)) : '-'
                }),
            sortable: false,
            width: 150
        },
        {
            id: 'action',
            Header: 'Revenue Lead',
            accessor: (company)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                    type: "checkbox",
                    checked: company?.revenueLeadMode ?? false,
                    onChange: (e)=>handleRevenueLeadMode(company, {
                            revenueLeadMode: e.target.checked
                        }, 'company')
                });
            }
        },
        {
            id: 'view',
            Header: 'View',
            accessor: (company)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'AdminCompanyDetails'
                            }));
                            setSelectedCompany(company);
                        },
                        style: {
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            "data-tooltip": "View Company Details",
                            className: "fa fa-eye c4 cp",
                            style: {
                                fontSize: '20px'
                            }
                        })
                    })
                });
            }
        },
        {
            id: 'delete',
            Header: 'Actions',
            accessor: (company)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcc",
                    style: {
                        gap: '4px'
                    },
                    children: [
                        company['loginLink'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>{
                                navigator.clipboard.writeText(company['loginLink']);
                                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Login link copied!', 'success');
                            },
                            style: {
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                "data-tooltip": "Copy Login Link",
                                className: "fa fa-copy cp",
                                style: {
                                    fontSize: '20px',
                                    color: "#4A67FF"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($fe21d3c4e4f6d27e$var$LoginHistoryCell, {
                            company: company
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>{
                                setDeleteCompany(company);
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'deleteCompanyPopup'
                                }));
                            },
                            style: {
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                "data-tooltip": "Delete Company",
                                className: "fa fa-trash c9 cp",
                                style: {
                                    fontSize: '20px'
                                }
                            })
                        })
                    ]
                }),
            sortable: false,
            width: 130
        }
    ];
    // Fetch data from server when table changes
    // NOTE: ReactTable calls onFetchData(state, instance) — second arg is the table instance, NOT search
    const fetchData = async (state, searchOverride)=>{
        const fetchId = ++fetchIdRef.current;
        setLoading(true);
        setTableState(state);
        // Only use searchOverride if it's explicitly a string (manual calls pass a string)
        const searchValue = typeof searchOverride === 'string' ? searchOverride : searchTermRef.current;
        try {
            const params = {
                page: Math.max(1, (state.page || 0) + 1),
                limit: state.pageSize,
                search: String(searchValue || ""),
                sortField: state.sorted?.[0]?.id || "createdAt",
                sortOrder: state.sorted?.[0]?.asc ? "asc" : "desc"
            };
            // Add tags filter to URL if tags are selected
            const tagsParam = filterTags.length > 0 ? `&tags=${encodeURIComponent(filterTags.join(','))}` : '';
            // Add partners filter to URL if partners are selected
            const partnersParam = filterPartners.length > 0 ? `&partners=${encodeURIComponent(filterPartners.join(','))}` : '';
            const companiesResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getAllCompanies?page=${params.page}&limit=${params.limit}&search=${encodeURIComponent(params.search)}&sortField=${params.sortField}&sortOrder=${params.sortOrder}&isArchived=${isArchived}&yopmailOnly=${isYopmail || false}${tagsParam}${partnersParam}`);
            // Ignore stale responses from older requests
            if (fetchId !== fetchIdRef.current) return;
            if (companiesResponse && companiesResponse.code === 200) {
                const { allCompanies: allCompanies, pagination: pagination } = companiesResponse.body;
                setData(allCompanies || []);
                setPages(pagination?.totalPages || 0);
                // Clear selection when data changes
                setSelectedCompanies([]);
            }
        } catch (error) {
            console.error("Error fetching companies:", error);
            if (fetchId !== fetchIdRef.current) return;
        }
        setLoading(false);
    };
    // Handle tag filter change
    const handleFilterTagToggle = (tag)=>{
        setFilterTags((prev)=>{
            if (prev.includes(tag)) return prev.filter((t)=>t !== tag);
            else return [
                ...prev,
                tag
            ];
        });
    };
    // Handle partner filter change
    const handleFilterPartnerToggle = (partnerId)=>{
        setFilterPartners((prev)=>{
            if (prev.includes(partnerId)) return prev.filter((p)=>p !== partnerId);
            else return [
                ...prev,
                partnerId
            ];
        });
    };
    // Apply tag/partner filters
    (0, $acw62.useEffect)(()=>{
        fetchData(tableState);
    }, [
        filterTags,
        filterPartners
    ]);
    const handleSearchChange = (e)=>{
        const value = e.target.value;
        setSearchTerm(value);
        searchTermRef.current = value;
        if (value === '') fetchData({
            page: 0,
            pageSize: 20,
            filtered: [],
            sorted: []
        }, '');
    };
    const handleSearchSubmit = (e)=>{
        e.preventDefault();
        fetchData({
            page: 0,
            pageSize: 20,
            filtered: [],
            sorted: []
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1 shadow p2rem dg gg2rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc aic bss bw2px bo5 br10px p2rem w100 oa",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "fs1-5rem fs2rem-sm ttu tac c4",
                            children: [
                                isYopmail ? 'Yopmail' : isArchived ? 'Archived' : 'Subscribed',
                                " Companies Database"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcsb aic mt1rem fww gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic gg1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                                            onSubmit: handleSearchSubmit,
                                            className: "df",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df",
                                                style: {
                                                    borderRadius: '12px',
                                                    overflow: 'hidden'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "Search companies by name, type, or stage...",
                                                    value: searchTerm,
                                                    onChange: handleSearchChange,
                                                    className: "py1rem px1-5rem bss bw2px bo5",
                                                    style: {
                                                        fontSize: '1rem',
                                                        outline: 'none',
                                                        backgroundColor: '#f8f9fa',
                                                        transition: 'all 0.3s ease',
                                                        width: '350px',
                                                        borderRadius: '12px'
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>setShowFilterDropdown(!showFilterDropdown),
                                                    className: "cp tac br5px shadow px1rem py0-5rem fw500 df aic",
                                                    style: {
                                                        backgroundColor: filterTags.length > 0 ? '#e0e7ff' : '#f3f4f6',
                                                        color: filterTags.length > 0 ? '#3730a3' : '#374151',
                                                        border: filterTags.length > 0 ? '1px solid #c7d2fe' : '1px solid #d1d5db'
                                                    },
                                                    children: [
                                                        "Filter by Tags",
                                                        filterTags.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginLeft: '6px',
                                                                backgroundColor: '#3730a3',
                                                                color: 'white',
                                                                padding: '2px 6px',
                                                                borderRadius: '10px',
                                                                fontSize: '11px'
                                                            },
                                                            children: filterTags.length
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginLeft: '8px',
                                                                fontSize: '10px'
                                                            },
                                                            children: showFilterDropdown ? "\u25B2" : "\u25BC"
                                                        })
                                                    ]
                                                }),
                                                showFilterDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        marginTop: '8px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                                                        minWidth: '220px',
                                                        zIndex: 1000,
                                                        border: '1px solid #e5e7eb'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            style: {
                                                                padding: '12px 16px',
                                                                borderBottom: '1px solid #e5e7eb',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    style: {
                                                                        fontWeight: 600,
                                                                        color: '#374151'
                                                                    },
                                                                    children: "Filter by Tags"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        setShowFilterDropdown(false);
                                                                        setFilterSearchTerm("");
                                                                    },
                                                                    style: {
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        cursor: 'pointer',
                                                                        color: '#374151',
                                                                        fontSize: '16px'
                                                                    },
                                                                    children: "\u2715"
                                                                })
                                                            ]
                                                        }),
                                                        allTags.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                padding: '8px 16px',
                                                                borderBottom: '1px solid #e5e7eb'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "text",
                                                                placeholder: "Search tags...",
                                                                value: filterSearchTerm,
                                                                onChange: (e)=>setFilterSearchTerm(e.target.value),
                                                                style: {
                                                                    width: '100%',
                                                                    padding: '8px 12px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '6px',
                                                                    fontSize: '14px',
                                                                    outline: 'none'
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                maxHeight: '200px',
                                                                overflowY: 'auto',
                                                                padding: '8px 0'
                                                            },
                                                            children: allTags.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    padding: '16px',
                                                                    textAlign: 'center',
                                                                    color: '#9ca3af',
                                                                    fontSize: '14px'
                                                                },
                                                                children: "No tags available"
                                                            }) : filteredFilterTags.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    padding: '16px',
                                                                    textAlign: 'center',
                                                                    color: '#9ca3af',
                                                                    fontSize: '14px'
                                                                },
                                                                children: "No tags found"
                                                            }) : filteredFilterTags.map((tag, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    onClick: ()=>handleFilterTagToggle(tag),
                                                                    style: {
                                                                        padding: '8px 16px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        backgroundColor: filterTags.includes(tag) ? '#f0f9ff' : 'transparent'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            style: {
                                                                                width: '18px',
                                                                                height: '18px',
                                                                                borderRadius: '4px',
                                                                                border: `2px solid ${filterTags.includes(tag) ? '#3b82f6' : '#d1d5db'}`,
                                                                                backgroundColor: filterTags.includes(tag) ? '#3b82f6' : 'transparent',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                marginRight: '12px'
                                                                            },
                                                                            children: filterTags.includes(tag) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    color: 'white',
                                                                                    fontSize: '12px',
                                                                                    fontWeight: 'bold',
                                                                                    lineHeight: 1
                                                                                },
                                                                                children: "\u2713"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            style: {
                                                                                color: '#374151',
                                                                                fontSize: '14px'
                                                                            },
                                                                            children: tag
                                                                        })
                                                                    ]
                                                                }, index))
                                                        }),
                                                        filterTags.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                padding: '8px 16px',
                                                                borderTop: '1px solid #e5e7eb'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>setFilterTags([]),
                                                                style: {
                                                                    width: '100%',
                                                                    padding: '8px',
                                                                    backgroundColor: '#fee2e2',
                                                                    color: '#dc2626',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '13px',
                                                                    fontWeight: 500
                                                                },
                                                                children: "Clear Filters"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>setShowPartnerFilterDropdown(!showPartnerFilterDropdown),
                                                    className: "cp tac br5px shadow px1rem py0-5rem fw500 df aic",
                                                    style: {
                                                        backgroundColor: filterPartners.length > 0 ? '#e0e7ff' : '#f3f4f6',
                                                        color: filterPartners.length > 0 ? '#3730a3' : '#374151',
                                                        border: filterPartners.length > 0 ? '1px solid #c7d2fe' : '1px solid #d1d5db'
                                                    },
                                                    children: [
                                                        "Filter by Partner",
                                                        filterPartners.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginLeft: '6px',
                                                                backgroundColor: '#3730a3',
                                                                color: 'white',
                                                                padding: '2px 6px',
                                                                borderRadius: '10px',
                                                                fontSize: '11px'
                                                            },
                                                            children: filterPartners.length
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginLeft: '8px',
                                                                fontSize: '10px'
                                                            },
                                                            children: showPartnerFilterDropdown ? "\u25B2" : "\u25BC"
                                                        })
                                                    ]
                                                }),
                                                showPartnerFilterDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        marginTop: '8px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '8px',
                                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                                                        minWidth: '260px',
                                                        zIndex: 1000,
                                                        border: '1px solid #e5e7eb'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            style: {
                                                                padding: '12px 16px',
                                                                borderBottom: '1px solid #e5e7eb',
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    style: {
                                                                        fontWeight: 600,
                                                                        color: '#374151'
                                                                    },
                                                                    children: "Filter by Partner"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        setShowPartnerFilterDropdown(false);
                                                                        setPartnerSearchTerm("");
                                                                    },
                                                                    style: {
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        cursor: 'pointer',
                                                                        color: '#374151',
                                                                        fontSize: '16px'
                                                                    },
                                                                    children: "\u2715"
                                                                })
                                                            ]
                                                        }),
                                                        allPartners.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                padding: '8px 16px',
                                                                borderBottom: '1px solid #e5e7eb'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "text",
                                                                placeholder: "Search partners...",
                                                                value: partnerSearchTerm,
                                                                onChange: (e)=>setPartnerSearchTerm(e.target.value),
                                                                style: {
                                                                    width: '100%',
                                                                    padding: '8px 12px',
                                                                    border: '1px solid #d1d5db',
                                                                    borderRadius: '6px',
                                                                    fontSize: '14px',
                                                                    outline: 'none'
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "thin-scroll",
                                                            style: {
                                                                maxHeight: '200px',
                                                                overflowY: 'auto',
                                                                padding: '8px 0'
                                                            },
                                                            children: allPartners.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    padding: '16px',
                                                                    textAlign: 'center',
                                                                    color: '#9ca3af',
                                                                    fontSize: '14px'
                                                                },
                                                                children: "No partners available"
                                                            }) : filteredFilterPartners.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    padding: '16px',
                                                                    textAlign: 'center',
                                                                    color: '#9ca3af',
                                                                    fontSize: '14px'
                                                                },
                                                                children: "No partners found"
                                                            }) : filteredFilterPartners.map((partner)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    onClick: ()=>handleFilterPartnerToggle(partner._id),
                                                                    style: {
                                                                        padding: '8px 16px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        backgroundColor: filterPartners.includes(partner._id) ? '#f0f9ff' : 'transparent'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            style: {
                                                                                width: '18px',
                                                                                height: '18px',
                                                                                borderRadius: '4px',
                                                                                border: `2px solid ${filterPartners.includes(partner._id) ? '#3b82f6' : '#d1d5db'}`,
                                                                                backgroundColor: filterPartners.includes(partner._id) ? '#3b82f6' : 'transparent',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                marginRight: '12px',
                                                                                flexShrink: 0
                                                                            },
                                                                            children: filterPartners.includes(partner._id) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    color: 'white',
                                                                                    fontSize: '12px',
                                                                                    fontWeight: 'bold',
                                                                                    lineHeight: 1
                                                                                },
                                                                                children: "\u2713"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            style: {
                                                                                color: '#374151',
                                                                                fontSize: '14px',
                                                                                whiteSpace: 'nowrap',
                                                                                paddingRight: '20px'
                                                                            },
                                                                            children: partner.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            style: {
                                                                                marginLeft: 'auto',
                                                                                backgroundColor: filterPartners.includes(partner._id) ? '#3b82f6' : '#e5e7eb',
                                                                                color: filterPartners.includes(partner._id) ? 'white' : '#4b5563',
                                                                                padding: '2px 9px',
                                                                                borderRadius: '10px',
                                                                                fontSize: '11px',
                                                                                fontWeight: 600,
                                                                                flexShrink: 0,
                                                                                minWidth: '28px',
                                                                                textAlign: 'center'
                                                                            },
                                                                            children: partner.count ?? 0
                                                                        })
                                                                    ]
                                                                }, partner._id))
                                                        }),
                                                        filterPartners.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                padding: '8px 16px',
                                                                borderTop: '1px solid #e5e7eb'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>setFilterPartners([]),
                                                                style: {
                                                                    width: '100%',
                                                                    padding: '8px',
                                                                    backgroundColor: '#fee2e2',
                                                                    color: '#dc2626',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '13px',
                                                                    fontWeight: 500
                                                                },
                                                                children: "Clear Filters"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic gg1rem pr",
                                    children: [
                                        selectedCompanies.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs0-875rem c4",
                                            children: [
                                                selectedCompanies.length,
                                                " selected"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>setShowTagDropdown(!showTagDropdown),
                                            disabled: selectedCompanies.length === 0,
                                            className: `cp tac br5px shadow px1rem py0-5rem fw500 ${selectedCompanies.length > 0 ? 'bg4 c1' : 'bg5 c6'}`,
                                            style: {
                                                cursor: selectedCompanies.length > 0 ? 'pointer' : 'not-allowed',
                                                opacity: selectedCompanies.length > 0 ? 1 : 0.5
                                            },
                                            children: "Add Tag"
                                        }),
                                        showTagDropdown && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcbdda2424310929$export$2e2bcd8739ae039), {
                                            allTags: allTags,
                                            selectedCompanies: selectedCompanies,
                                            companiesData: data.filter((c)=>selectedCompanies.includes(c._id)),
                                            onAddTags: (tags, keepOpen)=>handleTagAction('add', tags, keepOpen),
                                            onRemoveTags: (tags)=>handleTagAction('remove', tags),
                                            onClose: ()=>setShowTagDropdown(false),
                                            onTagCreated: fetchAllTags
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "admin-table mt1rem w100 ttc tac",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                manual: true,
                                data: data,
                                pages: pages,
                                loading: loading,
                                columns: companiesColumns,
                                defaultPageSize: 20,
                                page: Math.max(0, tableState.page || 0),
                                onFetchData: fetchData,
                                minRows: 0,
                                className: "-striped -highlight"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $639eb6379d0e6bda$export$2e2bcd8739ae039), {
                id: selectedCompany?._id,
                setPlan: setPlan
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da20b8fe5a9fd138$export$2e2bcd8739ae039), {
                plan: plan,
                defaultStep: plan === "Free" ? "freeMembership" : "subscriptionUpgrade",
                company: selectedCompany,
                companyId: selectedCompany?._id,
                navigateTo: 'AdminCompanyDetails',
                onCancel: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'AdminCompanyDetails'
                    }))
            })
        ]
    });
};
var $fe21d3c4e4f6d27e$export$2e2bcd8739ae039 = $fe21d3c4e4f6d27e$var$SubscribedCompaniesTab;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8947d533b453a142$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M13 8.57c-.79 0-1.43.64-1.43 1.43s.64 1.43 1.43 1.43 1.43-.64 1.43-1.43-.64-1.43-1.43-1.43"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M13 3C9.25 3 6.2 5.94 6.02 9.64L4.1 12.2c-.25.33-.01.8.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.68c2.36-1.12 4-3.53 4-6.32 0-3.87-3.13-7-7-7m3 7c0 .13-.01.26-.02.39l.83.66c.08.06.1.16.05.25l-.8 1.39c-.05.09-.16.12-.24.09l-.99-.4c-.21.16-.43.29-.67.39L14 13.83c-.01.1-.1.17-.2.17h-1.6c-.1 0-.18-.07-.2-.17l-.15-1.06c-.25-.1-.47-.23-.68-.39l-.99.4c-.09.03-.2 0-.25-.09l-.8-1.39c-.05-.08-.03-.19.05-.25l.84-.66c-.01-.13-.02-.26-.02-.39s.02-.27.04-.39l-.85-.66c-.08-.06-.1-.16-.05-.26l.8-1.38c.05-.09.15-.12.24-.09l1 .4c.2-.15.43-.29.67-.39L12 6.17c.02-.1.1-.17.2-.17h1.6c.1 0 .18.07.2.17l.15 1.06c.24.1.46.23.67.39l1-.4c.09-.03.2 0 .24.09l.8 1.38c.05.09.03.2-.05.26l-.85.66c.03.12.04.25.04.39"
    }, "1")
], 'Psychology');




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");








var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96a8b4f445fd9172$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $jTnBY.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $add5737403c6a16a$export$837848f5f6cee923), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $a4669aa090d445bd$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $8nd05.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $add5737403c6a16a$export$2e2bcd8739ae039).arrow}`]: (0, $8nd05.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kTdcz.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $8nd05.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $8nd05.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $8nd05.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $8nd05.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $add5737403c6a16a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $8nd05.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $kTdcz.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $1En50.default)(props, $96a8b4f445fd9172$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $0c87a2f38cd49c7a$export$2e2bcd8739ae039)();
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const enterTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const touchTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $295ecbe78b5bad73$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $4105219ee6538ed1$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $331f3746e6346411$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $331f3746e6346411$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $8fc8239a3939454e$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $72d5a979b2ad8bc9$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $8nd05.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $acw62.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $8nd05.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $8nd05.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $96a8b4f445fd9172$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $d6f4882a3b1c59f2$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $96a8b4f445fd9172$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $96a8b4f445fd9172$var$TooltipArrow;
    const popperProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(PopperComponent, (0, $8nd05.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $9QePP.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TransitionComponent, (0, $8nd05.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(TooltipComponent, (0, $8nd05.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $9QePP.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(ArrowComponent, (0, $8nd05.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $9QePP.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperComponent, (0, $8nd05.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $a4669aa090d445bd$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, (0, $8nd05.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipComponent, (0, $8nd05.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowComponent, (0, $8nd05.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b8d976dd8c0b005c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0953557707017bc5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');


const $08eccc949869af21$var$SectionAccordion = ({ section: section, prompts: prompts, level: level = 0, onSavePrompt: onSavePrompt, onDeletePrompt: onDeletePrompt, getPromptForSection: getPromptForSection, sections: sections, isLoading: isLoading })=>{
    // Use ref to persist expanded state across re-renders
    const expandedRef = (0, $acw62.useRef)(level === 0);
    const [expanded, setExpanded] = (0, $acw62.useState)(expandedRef.current);
    const [promptText, setPromptText] = (0, $acw62.useState)('');
    const [queryToVector, setQueryToVector] = (0, $acw62.useState)('');
    const [isActive, setIsActive] = (0, $acw62.useState)(false);
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const handleChange = (event, isExpanded)=>{
        expandedRef.current = isExpanded;
        setExpanded(isExpanded);
    };
    // Get section number - could be sectionNo (for top level) or no (for subsections)
    const sectionNo = section.sectionNo || section.no || '';
    const sectionName = section.sectionName || section.name || '';
    const prompt = getPromptForSection(sectionNo);
    // Initialize prompt text, queryToVector, and active status
    (0, $acw62.useEffect)(()=>{
        if (prompt) {
            setPromptText(prompt.promptText || '');
            setQueryToVector(prompt.queryToVector || '');
            setIsActive(prompt.isActive || false);
        } else {
            setPromptText('');
            setQueryToVector('');
            setIsActive(false);
        }
    }, [
        prompt
    ]);
    const handleDeleteClick = (e)=>{
        e.stopPropagation();
        if (window.confirm('Are you sure you want to delete this prompt?')) onDeletePrompt(prompt._id);
    };
    const handlePromptTextBlur = async ()=>{
        // Only save if text has changed or if creating new prompt
        const textToSave = promptText.trim();
        // Don't save if text is empty and no prompt exists
        if (!textToSave && !prompt) return;
        // Don't save if nothing changed
        if (prompt && prompt.promptText === textToSave && prompt.isActive === isActive && prompt.queryToVector === queryToVector.trim()) return;
        setIsSaving(true);
        try {
            const formData = {
                module: 'Data Repository',
                section: sectionNo,
                promptText: textToSave,
                queryToVector: queryToVector.trim(),
                isActive: isActive
            };
            await onSavePrompt(formData, prompt?._id);
        } catch (error) {
            console.error('Error saving prompt:', error);
        } finally{
            setIsSaving(false);
        }
    };
    const handleActiveToggle = async (event)=>{
        const newActiveState = event.target.checked;
        setIsActive(newActiveState);
        // Only save immediately if prompt exists and has text
        // Otherwise, the state will be saved when user types text and blurs
        if (prompt && promptText.trim()) {
            setIsSaving(true);
            try {
                const formData = {
                    module: 'Data Repository',
                    section: sectionNo,
                    promptText: promptText.trim(),
                    queryToVector: queryToVector.trim(),
                    isActive: newActiveState
                };
                await onSavePrompt(formData, prompt._id);
            } catch (error) {
                console.error('Error updating prompt status:', error);
                // Revert on error
                setIsActive(prompt.isActive);
            } finally{
                setIsSaving(false);
            }
        }
    // If no prompt exists yet, the active state will be saved when text is entered and blurred
    };
    // Get subfolders as array, sorted by key
    const getSubfolders = (subFolders)=>{
        if (!subFolders) return [];
        return Object.keys(subFolders).sort((a, b)=>parseInt(a) - parseInt(b)).map((key)=>({
                key: key,
                ...subFolders[key]
            }));
    };
    const subfolders = getSubfolders(section.subFolders);
    const indentLevel = level * 2;
    const backgroundColor = level === 0 ? '#f8f9fa' : level === 1 ? '#ffffff' : '#fafafa';
    const borderColor = level === 0 ? '#4A67FF' : level === 1 ? '#e0e0e0' : '#f0f0f0';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
        expanded: expanded,
        onChange: handleChange,
        sx: {
            mb: 1,
            boxShadow: level === 0 ? '0 2px 8px rgba(0,0,0,0.1)' : '0 1px 4px rgba(0,0,0,0.05)',
            borderRadius: '8px',
            overflow: 'hidden',
            '&:before': {
                display: 'none'
            },
            backgroundColor: backgroundColor,
            borderLeft: level > 0 ? `4px solid ${borderColor}` : 'none',
            marginLeft: `${indentLevel}px`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {
                    sx: {
                        color: level === 0 ? '#4A67FF' : '#666'
                    }
                }),
                sx: {
                    minHeight: 64,
                    '&.Mui-expanded': {
                        minHeight: 64
                    },
                    backgroundColor: level === 0 ? 'linear-gradient(135deg, #4A67FF 0%, #3956F0 100%)' : 'transparent',
                    color: level === 0 ? 'white' : '#002d63',
                    '&:hover': {
                        backgroundColor: level === 0 ? 'linear-gradient(135deg, #3956F0 0%, #2d45d0 100%)' : '#f5f5f5'
                    },
                    transition: 'all 0.2s ease'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "df jcsb aic",
                    sx: {
                        width: '100%',
                        pr: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            className: "df aic",
                            sx: {
                                gap: 2,
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8947d533b453a142$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontSize: level === 0 ? 28 : 20,
                                        color: level === 0 ? '#4A67FF' : '#4A67FF'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                            className: "df aic",
                                            sx: {
                                                gap: 1,
                                                mb: 0.5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                    variant: level === 0 ? 'h6' : 'subtitle1',
                                                    sx: {
                                                        fontWeight: 600,
                                                        color: level === 0 ? '#002d63' : '#002d63'
                                                    },
                                                    children: [
                                                        sectionNo,
                                                        " - ",
                                                        sectionName
                                                    ]
                                                }),
                                                prompt && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                                    icon: prompt.isActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            fontSize: 16,
                                                            color: 'white'
                                                        }
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            fontSize: 16,
                                                            color: 'white'
                                                        }
                                                    }),
                                                    label: prompt.isActive ? 'Active' : 'Inactive',
                                                    size: "small",
                                                    sx: {
                                                        backgroundColor: prompt.isActive ? '#4caf50' : '#9e9e9e',
                                                        color: 'white',
                                                        fontWeight: 600,
                                                        fontSize: '0.7rem',
                                                        height: '20px',
                                                        ml: 1
                                                    }
                                                })
                                            ]
                                        }),
                                        prompt && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            sx: {
                                                color: level === 0 ? 'rgba(255,255,255,0.8)' : '#666',
                                                display: 'block',
                                                maxWidth: '600px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: [
                                                prompt.promptText.substring(0, 100),
                                                "..."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                            className: "df aic",
                            sx: {
                                gap: 1
                            },
                            children: [
                                prompt && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                    title: "Delete Prompt",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                                        size: "small",
                                        onClick: handleDeleteClick,
                                        sx: {
                                            color: level === 0 ? 'white' : '#f44336',
                                            '&:hover': {
                                                backgroundColor: level === 0 ? 'rgba(255,255,255,0.2)' : 'rgba(244, 67, 54, 0.1)'
                                            }
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                            fontSize: "small"
                                        })
                                    })
                                }),
                                isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    sx: {
                                        color: level === 0 ? 'rgba(255,255,255,0.8)' : '#666'
                                    },
                                    children: "Saving..."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                sx: {
                    p: 2,
                    pt: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                        elevation: 0,
                        sx: {
                            p: 2,
                            mt: 1,
                            mb: 2,
                            borderRadius: '8px',
                            backgroundColor: '#f8f9fa',
                            border: '1px solid #e0e0e0'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                className: "df jcsb aic",
                                sx: {
                                    mb: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        variant: "subtitle1",
                                        sx: {
                                            fontWeight: 600,
                                            color: '#002d63'
                                        },
                                        children: [
                                            "Prompt ",
                                            prompt ? '(Click to edit)' : '(Enter prompt text)'
                                        ]
                                    }),
                                    prompt && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                        icon: prompt.isActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                                            sx: {
                                                fontSize: 16,
                                                color: 'white'
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
                                            sx: {
                                                fontSize: 16,
                                                color: 'white'
                                            }
                                        }),
                                        label: prompt.isActive ? 'Active' : 'Inactive',
                                        size: "small",
                                        sx: {
                                            backgroundColor: prompt.isActive ? '#4caf50' : '#9e9e9e',
                                            color: 'white',
                                            fontWeight: 600
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                sx: {
                                    mb: 2
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a034abd43bd8eee$export$2e2bcd8739ae039), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                        checked: isActive,
                                        onChange: handleActiveToggle,
                                        disabled: isSaving || isLoading,
                                        sx: {
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#4caf50'
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#4caf50'
                                            }
                                        }
                                    }),
                                    label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                sx: {
                                                    fontWeight: 600,
                                                    color: '#333'
                                                },
                                                children: isActive ? 'Active' : 'Inactive'
                                            }),
                                            !promptText.trim() && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                color: "textSecondary",
                                                children: "Enter text to save prompt"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                sx: {
                                    mb: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                value: queryToVector,
                                onChange: (e)=>setQueryToVector(e.target.value),
                                onBlur: handlePromptTextBlur,
                                placeholder: "Enter query to vector string...",
                                label: "Query to Vector",
                                disabled: isSaving || isLoading,
                                variant: "outlined",
                                sx: {
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        backgroundColor: '#ffffff',
                                        '&:hover': {
                                            backgroundColor: '#fafafa'
                                        },
                                        '&.Mui-focused': {
                                            backgroundColor: '#fff'
                                        },
                                        '& fieldset': {
                                            borderColor: '#e0e0e0'
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#4A67FF'
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#4A67FF'
                                        }
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                sx: {
                                    my: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                multiline: true,
                                rows: 8,
                                value: promptText,
                                onChange: (e)=>setPromptText(e.target.value),
                                onBlur: handlePromptTextBlur,
                                placeholder: "Enter your prompt text here... The prompt will be saved automatically when you click outside this field.",
                                disabled: isSaving || isLoading,
                                variant: "outlined",
                                sx: {
                                    mb: 2,
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        backgroundColor: '#ffffff',
                                        '&:hover': {
                                            backgroundColor: '#fafafa'
                                        },
                                        '&.Mui-focused': {
                                            backgroundColor: '#fff'
                                        },
                                        '& fieldset': {
                                            borderColor: '#e0e0e0'
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#4A67FF'
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#4A67FF'
                                        }
                                    }
                                }
                            }),
                            isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                variant: "caption",
                                color: "textSecondary",
                                sx: {
                                    mt: 1,
                                    display: 'block'
                                },
                                children: "Saving..."
                            })
                        ]
                    }),
                    subfolders.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: "df fdc",
                        sx: {
                            gap: 1,
                            mt: 1
                        },
                        children: subfolders.map((subfolder)=>/*#__PURE__*/ (0, $ayMG0.jsx)($08eccc949869af21$var$SectionAccordion, {
                                section: subfolder,
                                prompts: prompts,
                                level: level + 1,
                                onSavePrompt: onSavePrompt,
                                onDeletePrompt: onDeletePrompt,
                                getPromptForSection: getPromptForSection,
                                sections: sections,
                                isLoading: isLoading
                            }, subfolder.no || subfolder.key))
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        sx: {
                            p: 2,
                            textAlign: 'center',
                            color: '#999'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: "No subsections"
                        })
                    })
                ]
            })
        ]
    });
};
var $08eccc949869af21$export$2e2bcd8739ae039 = $08eccc949869af21$var$SectionAccordion;



const $544f4672900c6477$var$AIPrompts = ()=>{
    const [prompts, setPrompts] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isLoadingList, setIsLoadingList] = (0, $acw62.useState)(true);
    const [sections, setSections] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        fetchSections();
    }, []);
    const fetchSections = async ()=>{
        try {
            setIsLoadingList(true);
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/admin/repository/sections');
            if (response.code === 200) setSections(response.body || []);
            else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to fetch sections');
        } catch (error) {
            console.error('Error fetching sections:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error fetching sections');
        } finally{
            setIsLoadingList(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchPrompts();
    }, []);
    const fetchPrompts = async ()=>{
        try {
            setIsLoadingList(true);
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/prompts');
            if (response.code === 200) setPrompts(response.body || []);
            else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to fetch prompts');
        } catch (error) {
            console.error('Error fetching prompts:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error fetching prompts');
        } finally{
            setIsLoadingList(false);
        }
    };
    // Helper function to get prompt for a specific section
    const getPromptForSection = (sectionNo)=>{
        return prompts.find((p)=>p.section === sectionNo);
    };
    // Handle saving a prompt (create or update)
    const handleSavePrompt = async (formData, promptId)=>{
        try {
            setIsLoading(true);
            let response;
            if (promptId) // Update existing prompt
            response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/prompts/${promptId}`, formData);
            else // Create new prompt
            response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/prompts', formData);
            if (response.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || (promptId ? 'Prompt updated successfully' : 'Prompt created successfully'));
                // Update local state instead of refetching to preserve accordion states
                const savedPrompt = response.body;
                if (promptId) // Update existing prompt in array
                setPrompts((prevPrompts)=>prevPrompts.map((p)=>p._id === promptId ? savedPrompt : p));
                else // Add new prompt to array
                setPrompts((prevPrompts)=>[
                        ...prevPrompts,
                        savedPrompt
                    ]);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to save prompt');
        } catch (error) {
            console.error('Error saving prompt:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error saving prompt');
        } finally{
            setIsLoading(false);
        }
    };
    // Handle deleting a prompt
    const handleDeletePrompt = async (promptId)=>{
        try {
            setIsLoading(true);
            // Using GET request for delete as per codebase pattern
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/prompts/delete/${promptId}`);
            if (response.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Prompt deleted successfully');
                // Update local state instead of refetching to preserve accordion states
                setPrompts((prevPrompts)=>prevPrompts.filter((p)=>p._id !== promptId));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to delete prompt');
        } catch (error) {
            console.error('Error deleting prompt:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error deleting prompt');
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            className: "df fdc",
            sx: {
                padding: {
                    xs: '16px',
                    sm: '24px',
                    md: '32px'
                },
                minHeight: '100vh',
                background: 'linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%)'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                    elevation: 0,
                    sx: {
                        p: 3,
                        mb: 3,
                        background: 'linear-gradient(135deg, #4A67FF 0%, #3956F0 100%)',
                        borderRadius: '16px',
                        color: 'white'
                    },
                    className: "df jcsb aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: "df aic",
                        sx: {
                            gap: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8947d533b453a142$export$2e2bcd8739ae039), {
                                sx: {
                                    fontSize: 40
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        variant: "h4",
                                        sx: {
                                            fontWeight: 600,
                                            mb: 0.5,
                                            color: 'white'
                                        },
                                        children: "AI Prompt Management"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        sx: {
                                            opacity: 0.9,
                                            color: 'white'
                                        },
                                        children: "Manage and configure AI prompts for your system"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                isLoadingList ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                    elevation: 0,
                    sx: {
                        p: 6,
                        textAlign: 'center',
                        borderRadius: '16px',
                        background: 'white'
                    },
                    className: "df fdc jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                            sx: {
                                color: '#4A67FF',
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                            variant: "body1",
                            color: "textSecondary",
                            children: "Loading prompts..."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "df fdc",
                    sx: {
                        gap: 2
                    },
                    children: sections.length > 0 ? sections.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $08eccc949869af21$export$2e2bcd8739ae039), {
                            section: section,
                            prompts: prompts,
                            level: 0,
                            onSavePrompt: handleSavePrompt,
                            onDeletePrompt: handleDeletePrompt,
                            getPromptForSection: getPromptForSection,
                            sections: sections,
                            isLoading: isLoading
                        }, section._id || section.sectionNo)) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                        elevation: 0,
                        sx: {
                            p: 6,
                            textAlign: 'center',
                            borderRadius: '16px',
                            background: 'white'
                        },
                        className: "df fdc jcc aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8947d533b453a142$export$2e2bcd8739ae039), {
                                sx: {
                                    fontSize: 64,
                                    color: '#e0e0e0',
                                    mb: 2
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                variant: "h6",
                                color: "textSecondary",
                                gutterBottom: true,
                                children: "No Sections Found"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                variant: "body2",
                                color: "textSecondary",
                                children: "Sections will appear here once they are loaded"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $544f4672900c6477$export$2e2bcd8739ae039 = $544f4672900c6477$var$AIPrompts;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $dea70e103436b307$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"
}), 'Description');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $248f84fdae68a4c6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), 'Save');




const $33da756a25c84fe4$var$PROMPT_TYPE = 'consolidated-diligence-report';
const $33da756a25c84fe4$var$PROMPT_SECTIONS = [
    {
        key: 'system-prompt',
        label: 'System Prompt',
        description: 'Shared system prompt used for all section summaries (Fit, Directors, Research, etc.)'
    },
    {
        key: 'fit-assessment',
        label: 'Fit Assessment',
        description: 'Instructions for generating the Fit Assessment section (300-400 words)'
    },
    {
        key: 'director-profiles',
        label: 'Director Profiles',
        description: 'Instructions for generating each director profile (80-120 words each, max 10 directors)'
    },
    {
        key: 'research-reports',
        label: 'Research Reports',
        description: 'Instructions for summarizing each research report (300-400 words each). Use {{reportName}} as placeholder.'
    },
    {
        key: 'investment-readiness',
        label: 'Investment Readiness',
        description: 'Instructions for generating the Investment Readiness section (300-400 words)'
    },
    {
        key: 'data-repository',
        label: 'Data Repository',
        description: 'Instructions for generating the Data Repository summary (500-600 words)'
    },
    {
        key: 'business-audit',
        label: 'Business Audit',
        description: 'Instructions for generating the Business Audit summary (500-600 words)'
    },
    {
        key: 'warranty-disclosures',
        label: 'Warranty Disclosures',
        description: 'Instructions for generating the Warranty Disclosures summary (500-600 words)'
    },
    {
        key: 'executive-summary',
        label: 'Executive Summary',
        description: 'Instructions for generating the Executive Summary (300-400 words). Use {{companyName}} as placeholder.'
    }
];
const $33da756a25c84fe4$var$DiligenceReportPrompts = ()=>{
    const [prompts, setPrompts] = (0, $acw62.useState)({});
    const [editedPrompts, setEditedPrompts] = (0, $acw62.useState)({});
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [savingKey, setSavingKey] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        fetchPrompts();
    }, []);
    const fetchPrompts = async ()=>{
        try {
            setIsLoading(true);
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/prompts');
            if (response.code === 200) {
                const allPrompts = response.body || [];
                const diligencePrompts = {};
                allPrompts.filter((p)=>p.promptType === $33da756a25c84fe4$var$PROMPT_TYPE).forEach((p)=>{
                    diligencePrompts[p.promptName] = p;
                });
                setPrompts(diligencePrompts);
                // Initialize edited state with DB values
                const edited = {};
                $33da756a25c84fe4$var$PROMPT_SECTIONS.forEach((s)=>{
                    edited[s.key] = diligencePrompts[s.key]?.promptText || '';
                });
                setEditedPrompts(edited);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to fetch prompts');
        } catch (error) {
            console.error('Error fetching prompts:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error fetching prompts');
        } finally{
            setIsLoading(false);
        }
    };
    const handleChange = (key, value)=>{
        setEditedPrompts((prev)=>({
                ...prev,
                [key]: value
            }));
    };
    const handleSave = async (sectionDef)=>{
        const { key: key } = sectionDef;
        const promptText = editedPrompts[key];
        if (!promptText || !promptText.trim()) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Prompt text cannot be empty');
            return;
        }
        try {
            setSavingKey(key);
            const existing = prompts[key];
            const formData = {
                promptName: key,
                promptType: $33da756a25c84fe4$var$PROMPT_TYPE,
                promptText: promptText.trim(),
                isActive: true
            };
            let response;
            if (existing?._id) response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/prompts/${existing._id}`, formData);
            else response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/prompts', formData);
            if (response.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Prompt saved successfully');
                setPrompts((prev)=>({
                        ...prev,
                        [key]: response.body
                    }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to save prompt');
        } catch (error) {
            console.error('Error saving prompt:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error saving prompt');
        } finally{
            setSavingKey(null);
        }
    };
    const hasChanges = (key)=>{
        const dbText = prompts[key]?.promptText || '';
        const current = editedPrompts[key] || '';
        return current !== dbText;
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            className: "df fdc jcc aic",
            sx: {
                minHeight: '50vh'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                    sx: {
                        color: '#4A67FF',
                        mb: 2
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "body1",
                    color: "textSecondary",
                    children: "Loading prompts..."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            className: "df fdc",
            sx: {
                padding: {
                    xs: '16px',
                    sm: '24px',
                    md: '32px'
                },
                minHeight: '100vh',
                background: 'linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%)'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                    elevation: 0,
                    sx: {
                        p: 3,
                        mb: 3,
                        background: 'linear-gradient(135deg, #4A67FF 0%, #3956F0 100%)',
                        borderRadius: '16px',
                        color: 'white'
                    },
                    className: "df jcsb aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                        className: "df aic",
                        sx: {
                            gap: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dea70e103436b307$export$2e2bcd8739ae039), {
                                sx: {
                                    fontSize: 40
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        variant: "h4",
                                        sx: {
                                            fontWeight: 600,
                                            mb: 0.5,
                                            color: 'white'
                                        },
                                        children: "Diligence Report Prompts"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        sx: {
                                            opacity: 0.9,
                                            color: 'white'
                                        },
                                        children: "Manage AI prompts used to generate the Consolidated Diligence Report"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                    className: "df fdc",
                    sx: {
                        gap: 3
                    },
                    children: $33da756a25c84fe4$var$PROMPT_SECTIONS.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                            elevation: 0,
                            sx: {
                                p: 3,
                                borderRadius: '12px',
                                border: '1px solid #e0e0e0',
                                background: 'white'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    className: "df jcsb aic",
                                    sx: {
                                        mb: 2
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                className: "df aic",
                                                sx: {
                                                    gap: 1,
                                                    mb: 0.5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                        variant: "h6",
                                                        sx: {
                                                            fontWeight: 600
                                                        },
                                                        children: section.label
                                                    }),
                                                    hasChanges(section.key) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47d4f79319086dc5$export$2e2bcd8739ae039), {
                                                        label: "Unsaved Changes",
                                                        size: "small",
                                                        color: "info",
                                                        variant: "filled"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                color: "textSecondary",
                                                children: section.description
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    multiline: true,
                                    minRows: 4,
                                    maxRows: 12,
                                    value: editedPrompts[section.key] || '',
                                    onChange: (e)=>handleChange(section.key, e.target.value),
                                    variant: "outlined",
                                    placeholder: `Please add a prompt for ${section.label}.`,
                                    sx: {
                                        mb: 2,
                                        '& .MuiOutlinedInput-root': {
                                            fontFamily: 'monospace',
                                            fontSize: '0.875rem',
                                            lineHeight: 1.6
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                    className: "df",
                                    sx: {
                                        gap: 1,
                                        justifyContent: 'flex-end'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a02bab8c70a697b$export$2e2bcd8739ae039), {
                                        variant: "contained",
                                        size: "small",
                                        startIcon: savingKey === section.key ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19b4ac261663afa8$export$2e2bcd8739ae039), {
                                            size: 16,
                                            color: "inherit"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $248f84fdae68a4c6$export$2e2bcd8739ae039), {}),
                                        onClick: ()=>handleSave(section),
                                        disabled: savingKey === section.key || !hasChanges(section.key),
                                        sx: {
                                            textTransform: 'none',
                                            background: '#4A67FF',
                                            '&:hover': {
                                                background: '#3956F0'
                                            }
                                        },
                                        children: savingKey === section.key ? 'Saving...' : 'Save'
                                    })
                                })
                            ]
                        }, section.key))
                })
            ]
        })
    });
};
var $33da756a25c84fe4$export$2e2bcd8739ae039 = $33da756a25c84fe4$var$DiligenceReportPrompts;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $570fd50501d08ed5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($570fd50501d08ed5$exports, "__esModule", {
    value: true
});
$570fd50501d08ed5$exports.default = void 0;

var $570fd50501d08ed5$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $570fd50501d08ed5$var$_default = $570fd50501d08ed5$exports.default = (0, $570fd50501d08ed5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


var $797bfd41c3873478$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($797bfd41c3873478$exports, "__esModule", {
    value: true
});
$797bfd41c3873478$exports.default = void 0;

var $797bfd41c3873478$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $797bfd41c3873478$var$_default = $797bfd41c3873478$exports.default = (0, $797bfd41c3873478$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24z"
}), 'FolderSpecial');


var $e64b66a0287a27e1$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($e64b66a0287a27e1$exports, "__esModule", {
    value: true
});
$e64b66a0287a27e1$exports.default = void 0;

var $e64b66a0287a27e1$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e64b66a0287a27e1$var$_default = $e64b66a0287a27e1$exports.default = (0, $e64b66a0287a27e1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');



var $a4623a154accf113$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($a4623a154accf113$exports, "__esModule", {
    value: true
});
$a4623a154accf113$exports.default = void 0;

var $a4623a154accf113$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a4623a154accf113$var$_default = $a4623a154accf113$exports.default = (0, $a4623a154accf113$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');


var $4058c14ce7beee6d$exports = {};
"use strict";
/*
React-Quill
https://github.com/zenoamaro/react-quill
*/ var $4058c14ce7beee6d$var$__extends = $4058c14ce7beee6d$exports && $4058c14ce7beee6d$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4058c14ce7beee6d$var$__assign = $4058c14ce7beee6d$exports && $4058c14ce7beee6d$exports.__assign || function() {
    $4058c14ce7beee6d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4058c14ce7beee6d$var$__assign.apply(this, arguments);
};
var $4058c14ce7beee6d$var$__spreadArrays = $4058c14ce7beee6d$exports && $4058c14ce7beee6d$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $4058c14ce7beee6d$var$__importDefault = $4058c14ce7beee6d$exports && $4058c14ce7beee6d$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $4058c14ce7beee6d$var$react_1 = $4058c14ce7beee6d$var$__importDefault((parcelRequire("acw62")));

var $4058c14ce7beee6d$var$react_dom_1 = $4058c14ce7beee6d$var$__importDefault((parcelRequire("1u0KT")));

var $4058c14ce7beee6d$var$isEqual_1 = $4058c14ce7beee6d$var$__importDefault((parcelRequire("4UXHD")));

var $4058c14ce7beee6d$var$quill_1 = $4058c14ce7beee6d$var$__importDefault((parcelRequire("jVfJ9")));
var $4058c14ce7beee6d$var$ReactQuill = /** @class */ function(_super) {
    $4058c14ce7beee6d$var$__extends(ReactQuill, _super);
    function ReactQuill(props) {
        var _this = _super.call(this, props) || this;
        /*
        Changing one of these props should cause a full re-render and a
        re-instantiation of the Quill editor.
        */ _this.dirtyProps = [
            'modules',
            'formats',
            'bounds',
            'theme',
            'children'
        ];
        /*
        Changing one of these props should cause a regular update. These are mostly
        props that act on the container, rather than the quillized editing area.
        */ _this.cleanProps = [
            'id',
            'className',
            'style',
            'placeholder',
            'tabIndex',
            'onChange',
            'onChangeSelection',
            'onFocus',
            'onBlur',
            'onKeyPress',
            'onKeyDown',
            'onKeyUp'
        ];
        _this.state = {
            generation: 0
        };
        /*
        Tracks the internal selection of the Quill editor
        */ _this.selection = null;
        _this.onEditorChange = function(eventName, rangeOrDelta, oldRangeOrDelta, source) {
            var _a, _b, _c, _d;
            if (eventName === 'text-change') (_b = (_a = _this).onEditorChangeText) === null || _b === void 0 || _b.call(_a, _this.editor.root.innerHTML, rangeOrDelta, source, _this.unprivilegedEditor);
            else if (eventName === 'selection-change') (_d = (_c = _this).onEditorChangeSelection) === null || _d === void 0 || _d.call(_c, rangeOrDelta, source, _this.unprivilegedEditor);
        };
        var value = _this.isControlled() ? props.value : props.defaultValue;
        _this.value = value !== null && value !== void 0 ? value : '';
        return _this;
    }
    ReactQuill.prototype.validateProps = function(props) {
        var _a;
        if ($4058c14ce7beee6d$var$react_1.default.Children.count(props.children) > 1) throw new Error('The Quill editing area can only be composed of a single React element.');
        if ($4058c14ce7beee6d$var$react_1.default.Children.count(props.children)) {
            var child = $4058c14ce7beee6d$var$react_1.default.Children.only(props.children);
            if (((_a = child) === null || _a === void 0 ? void 0 : _a.type) === 'textarea') throw new Error('Quill does not support editing on a <textarea>. Use a <div> instead.');
        }
        if (this.lastDeltaChangeSet && props.value === this.lastDeltaChangeSet) throw new Error("You are passing the `delta` object from the `onChange` event back as `value`. You most probably want `editor.getContents()` instead. See: https://github.com/zenoamaro/react-quill#using-deltas");
    };
    ReactQuill.prototype.shouldComponentUpdate = function(nextProps, nextState) {
        var _this = this;
        var _a;
        this.validateProps(nextProps);
        // If the editor hasn't been instantiated yet, or the component has been
        // regenerated, we already know we should update.
        if (!this.editor || this.state.generation !== nextState.generation) return true;
        // Handle value changes in-place
        if ('value' in nextProps) {
            var prevContents = this.getEditorContents();
            var nextContents = (_a = nextProps.value, _a !== null && _a !== void 0 ? _a : '');
            // NOTE: Seeing that Quill is missing a way to prevent edits, we have to
            //       settle for a hybrid between controlled and uncontrolled mode. We
            //       can't prevent the change, but we'll still override content
            //       whenever `value` differs from current state.
            // NOTE: Comparing an HTML string and a Quill Delta will always trigger a
            //       change, regardless of whether they represent the same document.
            if (!this.isEqualValue(nextContents, prevContents)) this.setEditorContents(this.editor, nextContents);
        }
        // Handle read-only changes in-place
        if (nextProps.readOnly !== this.props.readOnly) this.setEditorReadOnly(this.editor, nextProps.readOnly);
        // Clean and Dirty props require a render
        return $4058c14ce7beee6d$var$__spreadArrays(this.cleanProps, this.dirtyProps).some(function(prop) {
            return !$4058c14ce7beee6d$var$isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.shouldComponentRegenerate = function(nextProps) {
        var _this = this;
        // Whenever a `dirtyProp` changes, the editor needs reinstantiation.
        return this.dirtyProps.some(function(prop) {
            return !$4058c14ce7beee6d$var$isEqual_1.default(nextProps[prop], _this.props[prop]);
        });
    };
    ReactQuill.prototype.componentDidMount = function() {
        this.instantiateEditor();
        this.setEditorContents(this.editor, this.getEditorContents());
    };
    ReactQuill.prototype.componentWillUnmount = function() {
        this.destroyEditor();
    };
    ReactQuill.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _this = this;
        // If we're changing one of the `dirtyProps`, the entire Quill Editor needs
        // to be re-instantiated. Regenerating the editor will cause the whole tree,
        // including the container, to be cleaned up and re-rendered from scratch.
        // Store the contents so they can be restored later.
        if (this.editor && this.shouldComponentRegenerate(prevProps)) {
            var delta = this.editor.getContents();
            var selection = this.editor.getSelection();
            this.regenerationSnapshot = {
                delta: delta,
                selection: selection
            };
            this.setState({
                generation: this.state.generation + 1
            });
            this.destroyEditor();
        }
        // The component has been regenerated, so it must be re-instantiated, and
        // its content must be restored to the previous values from the snapshot.
        if (this.state.generation !== prevState.generation) {
            var _a = this.regenerationSnapshot, delta = _a.delta, selection_1 = _a.selection;
            delete this.regenerationSnapshot;
            this.instantiateEditor();
            var editor_1 = this.editor;
            editor_1.setContents(delta);
            $4058c14ce7beee6d$var$postpone(function() {
                return _this.setEditorSelection(editor_1, selection_1);
            });
        }
    };
    ReactQuill.prototype.instantiateEditor = function() {
        if (this.editor) this.hookEditor(this.editor);
        else this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
    };
    ReactQuill.prototype.destroyEditor = function() {
        if (!this.editor) return;
        this.unhookEditor(this.editor);
    };
    /*
    We consider the component to be controlled if `value` is being sent in props.
    */ ReactQuill.prototype.isControlled = function() {
        return 'value' in this.props;
    };
    ReactQuill.prototype.getEditorConfig = function() {
        return {
            bounds: this.props.bounds,
            formats: this.props.formats,
            modules: this.props.modules,
            placeholder: this.props.placeholder,
            readOnly: this.props.readOnly,
            scrollingContainer: this.props.scrollingContainer,
            tabIndex: this.props.tabIndex,
            theme: this.props.theme
        };
    };
    ReactQuill.prototype.getEditor = function() {
        if (!this.editor) throw new Error('Accessing non-instantiated editor');
        return this.editor;
    };
    /**
    Creates an editor on the given element. The editor will be passed the
    configuration, have its events bound,
    */ ReactQuill.prototype.createEditor = function(element, config) {
        var editor = new $4058c14ce7beee6d$var$quill_1.default(element, config);
        if (config.tabIndex != null) this.setEditorTabIndex(editor, config.tabIndex);
        this.hookEditor(editor);
        return editor;
    };
    ReactQuill.prototype.hookEditor = function(editor) {
        // Expose the editor on change events via a weaker, unprivileged proxy
        // object that does not allow accidentally modifying editor state.
        this.unprivilegedEditor = this.makeUnprivilegedEditor(editor);
        // Using `editor-change` allows picking up silent updates, like selection
        // changes on typing.
        editor.on('editor-change', this.onEditorChange);
    };
    ReactQuill.prototype.unhookEditor = function(editor) {
        editor.off('editor-change', this.onEditorChange);
    };
    ReactQuill.prototype.getEditorContents = function() {
        return this.value;
    };
    ReactQuill.prototype.getEditorSelection = function() {
        return this.selection;
    };
    /*
    True if the value is a Delta instance or a Delta look-alike.
    */ ReactQuill.prototype.isDelta = function(value) {
        return value && value.ops;
    };
    /*
    Special comparison function that knows how to compare Deltas.
    */ ReactQuill.prototype.isEqualValue = function(value, nextValue) {
        if (this.isDelta(value) && this.isDelta(nextValue)) return $4058c14ce7beee6d$var$isEqual_1.default(value.ops, nextValue.ops);
        else return $4058c14ce7beee6d$var$isEqual_1.default(value, nextValue);
    };
    /*
    Replace the contents of the editor, but keep the previous selection hanging
    around so that the cursor won't move.
    */ ReactQuill.prototype.setEditorContents = function(editor, value) {
        var _this = this;
        this.value = value;
        var sel = this.getEditorSelection();
        if (typeof value === 'string') editor.setContents(editor.clipboard.convert(value));
        else editor.setContents(value);
        $4058c14ce7beee6d$var$postpone(function() {
            return _this.setEditorSelection(editor, sel);
        });
    };
    ReactQuill.prototype.setEditorSelection = function(editor, range) {
        this.selection = range;
        if (range) {
            // Validate bounds before applying.
            var length_1 = editor.getLength();
            range.index = Math.max(0, Math.min(range.index, length_1 - 1));
            range.length = Math.max(0, Math.min(range.length, length_1 - 1 - range.index));
            editor.setSelection(range);
        }
    };
    ReactQuill.prototype.setEditorTabIndex = function(editor, tabIndex) {
        var _a, _b;
        if ((_b = (_a = editor) === null || _a === void 0 ? void 0 : _a.scroll) === null || _b === void 0 ? void 0 : _b.domNode) editor.scroll.domNode.tabIndex = tabIndex;
    };
    ReactQuill.prototype.setEditorReadOnly = function(editor, value) {
        if (value) editor.disable();
        else editor.enable();
    };
    /*
    Returns a weaker, unprivileged proxy object that only exposes read-only
    accessors found on the editor instance, without any state-modifying methods.
    */ ReactQuill.prototype.makeUnprivilegedEditor = function(editor) {
        var e = editor;
        return {
            getHTML: function() {
                return e.root.innerHTML;
            },
            getLength: e.getLength.bind(e),
            getText: e.getText.bind(e),
            getContents: e.getContents.bind(e),
            getSelection: e.getSelection.bind(e),
            getBounds: e.getBounds.bind(e)
        };
    };
    ReactQuill.prototype.getEditingArea = function() {
        if (!this.editingArea) throw new Error('Instantiating on missing editing area');
        var element = $4058c14ce7beee6d$var$react_dom_1.default.findDOMNode(this.editingArea);
        if (!element) throw new Error('Cannot find element for editing area');
        if (element.nodeType === 3) throw new Error('Editing area cannot be a text node');
        return element;
    };
    /*
    Renders an editor area, unless it has been provided one to clone.
    */ ReactQuill.prototype.renderEditingArea = function() {
        var _this = this;
        var _a = this.props, children = _a.children, preserveWhitespace = _a.preserveWhitespace;
        var generation = this.state.generation;
        var properties = {
            key: generation,
            ref: function(instance) {
                _this.editingArea = instance;
            }
        };
        if ($4058c14ce7beee6d$var$react_1.default.Children.count(children)) return $4058c14ce7beee6d$var$react_1.default.cloneElement($4058c14ce7beee6d$var$react_1.default.Children.only(children), properties);
        return preserveWhitespace ? $4058c14ce7beee6d$var$react_1.default.createElement("pre", $4058c14ce7beee6d$var$__assign({}, properties)) : $4058c14ce7beee6d$var$react_1.default.createElement("div", $4058c14ce7beee6d$var$__assign({}, properties));
    };
    ReactQuill.prototype.render = function() {
        var _a;
        return $4058c14ce7beee6d$var$react_1.default.createElement("div", {
            id: this.props.id,
            style: this.props.style,
            key: this.state.generation,
            className: "quill " + (_a = this.props.className, _a !== null && _a !== void 0 ? _a : ''),
            onKeyPress: this.props.onKeyPress,
            onKeyDown: this.props.onKeyDown,
            onKeyUp: this.props.onKeyUp
        }, this.renderEditingArea());
    };
    ReactQuill.prototype.onEditorChangeText = function(value, delta, source, editor) {
        var _a, _b;
        if (!this.editor) return;
        // We keep storing the same type of value as what the user gives us,
        // so that value comparisons will be more stable and predictable.
        var nextContents = this.isDelta(this.value) ? editor.getContents() : editor.getHTML();
        if (nextContents !== this.getEditorContents()) {
            // Taint this `delta` object, so we can recognize whether the user
            // is trying to send it back as `value`, preventing a likely loop.
            this.lastDeltaChangeSet = delta;
            this.value = nextContents;
            (_b = (_a = this.props).onChange) === null || _b === void 0 || _b.call(_a, value, delta, source, editor);
        }
    };
    ReactQuill.prototype.onEditorChangeSelection = function(nextSelection, source, editor) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.editor) return;
        var currentSelection = this.getEditorSelection();
        var hasGainedFocus = !currentSelection && nextSelection;
        var hasLostFocus = currentSelection && !nextSelection;
        if ($4058c14ce7beee6d$var$isEqual_1.default(nextSelection, currentSelection)) return;
        this.selection = nextSelection;
        (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 || _b.call(_a, nextSelection, source, editor);
        if (hasGainedFocus) (_d = (_c = this.props).onFocus) === null || _d === void 0 || _d.call(_c, nextSelection, source, editor);
        else if (hasLostFocus) (_f = (_e = this.props).onBlur) === null || _f === void 0 || _f.call(_e, currentSelection, source, editor);
    };
    ReactQuill.prototype.focus = function() {
        if (!this.editor) return;
        this.editor.focus();
    };
    ReactQuill.prototype.blur = function() {
        if (!this.editor) return;
        this.selection = null;
        this.editor.blur();
    };
    ReactQuill.displayName = 'React Quill';
    /*
    Export Quill to be able to call `register`
    */ ReactQuill.Quill = $4058c14ce7beee6d$var$quill_1.default;
    ReactQuill.defaultProps = {
        theme: 'snow',
        modules: {},
        readOnly: false
    };
    return ReactQuill;
}($4058c14ce7beee6d$var$react_1.default.Component);
/*
Small helper to execute a function in the next micro-tick.
*/ function $4058c14ce7beee6d$var$postpone(fn) {
    Promise.resolve().then(fn);
}
$4058c14ce7beee6d$exports = $4058c14ce7beee6d$var$ReactQuill;




var $lwfqC = parcelRequire("lwfqC");

var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $ac8fd7b02f1c6431$var$ShowModulePercentage = ({ value: value, type: type })=>{
    let color;
    if (value > 0) {
        if (type == 'Module Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
        else if (type == 'Module Complete') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
    } else color = 'c28';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
        className: `${color} fs2rem lh1 mr2rem`,
        children: [
            value || 0,
            "%",
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: `${value > 0 ? 'c15 ' : 'c28 '} fs0-75rem w4rem db fw300`,
                children: type
            })
        ]
    });
};
var $ac8fd7b02f1c6431$export$2e2bcd8739ae039 = $ac8fd7b02f1c6431$var$ShowModulePercentage;



var $ayMG0 = parcelRequire("ayMG0");



const $f8b51cf619c26ee5$var$ModuleCardActions = ({ durationLabel: durationLabel, isPaid: isPaid, onBuyClick: onBuyClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df fdc aic jcfe",
        style: {
            flexShrink: 0,
            gap: '6px',
            marginLeft: '0.5rem'
        },
        children: [
            durationLabel ? durationLabel === 'Is Ready' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "br50px c1 pa",
                style: {
                    background: '#15D757',
                    right: '15px',
                    bottom: '15px',
                    padding: '2px 10px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "mr0-5rem",
                        src: (parcelRequire("bqkT1")),
                        alt: "Ready"
                    }),
                    "Ready"
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic",
                style: {
                    gap: '4px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("jJgJl")),
                        style: {
                            width: '14px',
                            height: '14px'
                        },
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs12px fw500 c15",
                        children: durationLabel
                    })
                ]
            }) : null,
            isPaid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                text: "Buy Now",
                onClick: ()=>onBuyClick && onBuyClick(),
                btnType: "warning",
                style: {
                    padding: '0.25rem 1rem',
                    marginBottom: '4px'
                }
            })
        ]
    });
};
var $f8b51cf619c26ee5$export$2e2bcd8739ae039 = $f8b51cf619c26ee5$var$ModuleCardActions;


const $a400058e46cbe608$var$DURATION_LABELS = {
    'isReady': 'Is Ready',
    '1 mins': '1 Min',
    '2 mins': '2 Mins',
    '3mins': '3 Mins',
    '5mins': '5 Mins',
    '10mins': '10 Mins',
    '15mins': '15 Mins',
    '30mins': '30 Mins',
    '2 days': '2 Days'
};

const $a400058e46cbe608$var$ModuleCardPreview = ({ moduleData: moduleData })=>{
    const defaultLogo = (parcelRequire("a8Wtc"));
    const tagHex = typeof moduleData?.moduleTagColor === 'string' ? moduleData.moduleTagColor.trim() : '';
    const hasValidTagHex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(tagHex);
    const getModuleImage = ()=>{
        if (moduleData?.imageURL) return moduleData.imageURL;
        return defaultLogo;
    };
    // Create a mock module object for ShowModulePercentage
    const mockModule = {
        stats: {
            completionPercent: 0,
            riskPercent: 0
        }
    };
    // Determine if we should show risk percentage (exclude certain modules)
    const shouldShowRisk = ![
        'Data Repository',
        'InvestorMatch'
    ].includes(moduleData?.moduleName);
    // For preview, use the module name directly or a default
    const moduleName = moduleData?.moduleName || 'Module Name';
    const logoAlt = moduleData?.moduleName || 'Module Logo';
    const durationLabel = moduleData?.duration && moduleData.duration !== 'NIL' ? $a400058e46cbe608$var$DURATION_LABELS[moduleData.duration] || null : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "br20px bg1 p1-5rem new-shadow df fdc aisb jcsb pr",
        style: {
            height: '200px',
            maxWidth: '350px',
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ds-module-menu",
                style: {
                    opacity: 0.5,
                    pointerEvents: 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ds-module-card__menu",
                    children: "\u2022\u2022\u2022"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aisb jcsb h100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "br10px bg1 p0-5rem bo77 bss bw1px df aic jcc",
                                style: {
                                    width: '64px',
                                    height: '64px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: getModuleImage(),
                                    alt: logoAlt,
                                    width: 52,
                                    height: 47,
                                    onError: (e)=>{
                                        e.target.src = defaultLogo;
                                    },
                                    style: {
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic jcfs pr",
                                children: [
                                    moduleData?.moduleSubTitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `fs12px fw400 pa ${hasValidTagHex ? '' : 'c15 op70'}`,
                                        style: {
                                            left: '1rem',
                                            top: '-14px',
                                            ...hasValidTagHex ? {
                                                color: tagHex
                                            } : {}
                                        },
                                        children: moduleData.moduleSubTitle.length > 30 ? moduleData.moduleSubTitle.substring(0, 30) + '...' : moduleData.moduleSubTitle
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs15px fw500 c15 ml1rem",
                                        children: moduleName
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df aife jcsb",
                        style: {
                            gap: '0.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcfs aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac8fd7b02f1c6431$export$2e2bcd8739ae039), {
                                        value: mockModule?.stats?.completionPercent || 0,
                                        type: "Module Complete"
                                    }),
                                    shouldShowRisk && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac8fd7b02f1c6431$export$2e2bcd8739ae039), {
                                        value: mockModule?.stats?.riskPercent || 0,
                                        type: "Module Risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8b51cf619c26ee5$export$2e2bcd8739ae039), {
                                durationLabel: durationLabel,
                                isPaid: !!moduleData?.isPaid,
                                onBuyClick: ()=>{}
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a400058e46cbe608$export$2e2bcd8739ae039 = $a400058e46cbe608$var$ModuleCardPreview;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bf57dccd1789595f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3fed6bc25c5eb7cb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $29775a9ad9a7bded$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13H5v-2h14z"
}), 'Remove');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f73180ca99f7d37e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m16 18 2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
}), 'TrendingDown');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $4f230e8d99ab8bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
}), 'TrendingUp');


/**
 * Primary label for a custom dropdown/radio/multi option.
 * DB/API may use `value` (module builder) or `name` (e.g. investor-lead DEPF008).
 */ function $39a623eb929ce528$export$82fc61b46dd11008(opt) {
    if (!opt || typeof opt !== 'object') return '';
    const v = opt.value;
    if (v != null && String(v).trim() !== '') return String(v).trim();
    const n = opt.name;
    if (n != null && String(n).trim() !== '') return String(n).trim();
    const lbl = opt.label;
    if (lbl != null && String(lbl).trim() !== '') return String(lbl).trim();
    return '';
}
function $39a623eb929ce528$export$1633f32801e6dcb0(opt) {
    if (!opt || typeof opt !== 'object') return '';
    const info = opt.info ?? opt.description;
    return info != null ? String(info) : '';
}


const $ae3c753ed9e10b31$var$RiskScoreSlider = ({ questionType: questionType, customOptions: customOptions = [], predefinedOptionsInfo: predefinedOptionsInfo = {}, riskScores: riskScores = {}, onRiskScoreChange: onRiskScoreChange })=>{
    const [scores, setScores] = (0, $acw62.useState)(riskScores || {});
    const [draggingOption, setDraggingOption] = (0, $acw62.useState)(null);
    const sliderRef = (0, $acw62.useRef)(null);
    // Get options based on question type
    const getOptions = ()=>{
        const predefinedTypes = {
            'yesNo': [
                'Yes',
                'No',
                'N/A'
            ],
            'YN/F/T': [
                'Yes',
                'No',
                'N/A'
            ],
            'D/ND': [
                'Disclosure',
                'No Disclosure',
                'Not Sure'
            ],
            '1to5': [
                '1',
                '2',
                '3',
                '4',
                '5'
            ]
        };
        if (predefinedTypes[questionType]) return predefinedTypes[questionType];
        if ([
            'DropDown',
            'Radio',
            'Multi'
        ].includes(questionType)) return customOptions.map((0, $39a623eb929ce528$export$82fc61b46dd11008)).filter((v)=>v && v.trim());
        return [];
    };
    const options = getOptions();
    // Sync and initialize scores - merged into one effect to prevent race conditions
    (0, $acw62.useEffect)(()=>{
        // Start with riskScores prop values (from backend in edit mode)
        const initialScores = {
            ...riskScores
        };
        // Fill in any missing options with 0
        options.forEach((option)=>{
            if (initialScores[option] === undefined || initialScores[option] === null) initialScores[option] = 0;
        });
        // Remove any scores for options that no longer exist
        Object.keys(initialScores).forEach((key)=>{
            if (!options.includes(key)) delete initialScores[key];
        });
        // Only update if scores actually changed
        const scoresChanged = JSON.stringify(scores) !== JSON.stringify(initialScores);
        if (scoresChanged) setScores(initialScores);
    }, [
        riskScores,
        options.length,
        questionType
    ]);
    const getRiskColor = (value)=>{
        if (value <= -3) return '#d32f2f';
        if (value <= -1) return '#f57c00';
        if (value === 0) return '#757575';
        if (value <= 2) return '#fbc02d';
        return '#388e3c';
    };
    const getRiskLabel = (value)=>{
        if (value <= -4) return 'Very High Risk';
        if (value <= -2) return 'High Risk';
        if (value < 0) return 'Medium Risk';
        if (value === 0) return 'Neutral';
        if (value <= 2) return 'Low Risk';
        return 'Very Low Risk';
    };
    const valueToPosition = (value)=>{
        // Convert value (-5 to 5) to percentage (0 to 100)
        return (value + 5) / 10 * 100;
    };
    const positionToValue = (position)=>{
        // Convert percentage (0 to 100) to value (-5 to 5)
        const value = position / 100 * 10 - 5;
        return Math.round(value);
    };
    const handleMouseDown = (option)=>{
        setDraggingOption(option);
    };
    const handleMouseMove = (e)=>{
        if (!draggingOption || !sliderRef.current) return;
        const rect = sliderRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const position = Math.max(0, Math.min(100, x / rect.width * 100));
        const newValue = positionToValue(position);
        const newScores = {
            ...scores,
            [draggingOption]: newValue
        };
        setScores(newScores);
        onRiskScoreChange(newScores);
    };
    const handleMouseUp = ()=>{
        setDraggingOption(null);
    };
    const handleTouchStart = (option)=>{
        setDraggingOption(option);
    };
    const handleTouchMove = (e)=>{
        if (!draggingOption || !sliderRef.current) return;
        const touch = e.touches[0];
        const rect = sliderRef.current.getBoundingClientRect();
        const x = touch.clientX - rect.left;
        const position = Math.max(0, Math.min(100, x / rect.width * 100));
        const newValue = positionToValue(position);
        const newScores = {
            ...scores,
            [draggingOption]: newValue
        };
        setScores(newScores);
        onRiskScoreChange(newScores);
    };
    const handleTouchEnd = ()=>{
        setDraggingOption(null);
    };
    (0, $acw62.useEffect)(()=>{
        if (draggingOption) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.addEventListener('touchmove', handleTouchMove);
            document.addEventListener('touchend', handleTouchEnd);
            return ()=>{
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
                document.removeEventListener('touchmove', handleTouchMove);
                document.removeEventListener('touchend', handleTouchEnd);
            };
        }
    }, [
        draggingOption,
        scores
    ]);
    if (options.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "br12px p1-5rem mt1-5rem",
        style: {
            background: 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)',
            border: '1px solid #e0e0e0'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic mb1-5rem",
                style: {
                    gap: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic jcc",
                        style: {
                            width: '40px',
                            height: '40px',
                            borderRadius: '10px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f230e8d99ab8bb2$export$2e2bcd8739ae039), {
                            style: {
                                fontSize: '24px',
                                color: 'white'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1rem fw600 mb0-25rem",
                                style: {
                                    color: '#333',
                                    margin: '0 0 0.25rem 0'
                                },
                                children: "Assign Risk Scores"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-8rem",
                                style: {
                                    color: '#666',
                                    margin: 0
                                },
                                children: "Drag each option along the slider to assign risk values (-5 to +5)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb mb1rem",
                        style: {
                            paddingLeft: '10px',
                            paddingRight: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f73180ca99f7d37e$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: '18px',
                                            color: '#d32f2f'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.85rem',
                                            color: '#d32f2f',
                                            fontWeight: '600'
                                        },
                                        children: "-5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29775a9ad9a7bded$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: '18px',
                                            color: '#757575'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.85rem',
                                            color: '#757575',
                                            fontWeight: '600'
                                        },
                                        children: "0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f230e8d99ab8bb2$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: '18px',
                                            color: '#388e3c'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.85rem',
                                            color: '#388e3c',
                                            fontWeight: '600'
                                        },
                                        children: "+5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: sliderRef,
                        style: {
                            position: 'relative',
                            height: '60px',
                            margin: '0 10px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: '50%',
                                    left: 0,
                                    right: 0,
                                    height: '12px',
                                    borderRadius: '6px',
                                    background: 'linear-gradient(to right, #d32f2f 0%, #f57c00 25%, #757575 50%, #fbc02d 75%, #388e3c 100%)',
                                    transform: 'translateY(-50%)',
                                    boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.15)',
                                    zIndex: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    width: '4px',
                                    height: '28px',
                                    background: 'white',
                                    transform: 'translate(-50%, -50%)',
                                    borderRadius: '2px',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                                    zIndex: 2
                                }
                            }),
                            [
                                -5,
                                -4,
                                -3,
                                -2,
                                -1,
                                0,
                                1,
                                2,
                                3,
                                4,
                                5
                            ].map((tick)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        position: 'absolute',
                                        top: '50%',
                                        left: `${valueToPosition(tick)}%`,
                                        width: '2px',
                                        height: tick === 0 ? '20px' : '12px',
                                        background: tick === 0 ? 'white' : 'rgba(255,255,255,0.4)',
                                        transform: 'translate(-50%, -50%)',
                                        borderRadius: '1px',
                                        zIndex: tick === 0 ? 2 : 1
                                    }
                                }, tick)),
                            options.map((option, idx)=>{
                                const value = scores[option] || 0;
                                const position = valueToPosition(value);
                                const color = getRiskColor(value);
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            onMouseDown: ()=>handleMouseDown(option),
                                            onTouchStart: ()=>handleTouchStart(option),
                                            style: {
                                                position: 'absolute',
                                                top: '50%',
                                                left: `${position}%`,
                                                width: '32px',
                                                height: '32px',
                                                borderRadius: '50%',
                                                background: 'white',
                                                border: `4px solid ${color}`,
                                                transform: 'translate(-50%, -50%)',
                                                cursor: 'grab',
                                                boxShadow: draggingOption === option ? '0 6px 20px rgba(0,0,0,0.3)' : '0 4px 12px rgba(0,0,0,0.2)',
                                                transition: draggingOption === option ? 'none' : 'all 0.2s ease',
                                                zIndex: draggingOption === option ? 20 : 10 + idx,
                                                userSelect: 'none'
                                            },
                                            onMouseEnter: (e)=>{
                                                if (!draggingOption) e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.15)';
                                            },
                                            onMouseLeave: (e)=>{
                                                if (!draggingOption) e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1)';
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    fontSize: '0.7rem',
                                                    fontWeight: '700',
                                                    color: color,
                                                    pointerEvents: 'none'
                                                },
                                                children: value
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                position: 'absolute',
                                                top: '-35px',
                                                left: `${position}%`,
                                                transform: 'translateX(-50%)',
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                color: 'white',
                                                padding: '4px 10px',
                                                borderRadius: '6px',
                                                fontSize: '0.75rem',
                                                fontWeight: '600',
                                                whiteSpace: 'nowrap',
                                                boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                                                zIndex: 5,
                                                pointerEvents: 'none',
                                                opacity: draggingOption === option ? 1 : 0.9,
                                                transition: 'opacity 0.2s ease'
                                            },
                                            children: option
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                position: 'absolute',
                                                top: '42px',
                                                left: `${position}%`,
                                                transform: 'translateX(-50%)',
                                                background: color,
                                                color: 'white',
                                                padding: '3px 8px',
                                                borderRadius: '4px',
                                                fontSize: '0.65rem',
                                                fontWeight: '600',
                                                whiteSpace: 'nowrap',
                                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                                                zIndex: 5,
                                                pointerEvents: 'none',
                                                transition: 'all 0.3s ease'
                                            },
                                            children: getRiskLabel(value)
                                        })
                                    ]
                                }, idx);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcsb mt3rem",
                        style: {
                            paddingLeft: '10px',
                            paddingRight: '10px',
                            fontSize: '0.7rem',
                            color: '#999'
                        },
                        children: [
                            -5,
                            -4,
                            -3,
                            -2,
                            -1,
                            0,
                            1,
                            2,
                            3,
                            4,
                            5
                        ].map((num)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: num === 0 ? '700' : '400',
                                    color: num === 0 ? '#757575' : '#999',
                                    minWidth: '20px',
                                    textAlign: 'center'
                                },
                                children: num
                            }, num))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df fdc",
                style: {
                    gap: '0.75rem',
                    marginBottom: '1.5rem'
                },
                children: options.map((option, idx)=>{
                    const value = scores[option] || 0;
                    const color = getRiskColor(value);
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsb br8px p0-75rem",
                        style: {
                            background: 'white',
                            border: `2px solid ${color}20`,
                            transition: 'all 0.3s ease'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '12px',
                                            height: '12px',
                                            borderRadius: '50%',
                                            background: color,
                                            boxShadow: `0 0 8px ${color}40`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-875rem fw600",
                                        style: {
                                            color: '#333'
                                        },
                                        children: option
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '12px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-75rem fw600",
                                        style: {
                                            background: `${color}20`,
                                            color: color,
                                            padding: '4px 10px',
                                            borderRadius: '6px'
                                        },
                                        children: getRiskLabel(value)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "fs1-1rem fw700",
                                        style: {
                                            color: color,
                                            minWidth: '35px',
                                            textAlign: 'right'
                                        },
                                        children: [
                                            value > 0 ? '+' : '',
                                            value
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb mb1-5rem",
                style: {
                    paddingLeft: '10px',
                    paddingRight: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f73180ca99f7d37e$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '16px',
                                    color: '#d32f2f',
                                    marginBottom: '4px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.7rem',
                                    color: '#d32f2f',
                                    fontWeight: '600'
                                },
                                children: "High Risk"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29775a9ad9a7bded$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '16px',
                                    color: '#757575',
                                    marginBottom: '4px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.7rem',
                                    color: '#757575',
                                    fontWeight: '600'
                                },
                                children: "Neutral"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f230e8d99ab8bb2$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '16px',
                                    color: '#388e3c',
                                    marginBottom: '4px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '0.7rem',
                                    color: '#388e3c',
                                    fontWeight: '600'
                                },
                                children: "Low Risk"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "br8px p1rem",
                style: {
                    background: 'white',
                    border: '1px solid #e0e0e0'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-75rem fw600 mb0-75rem",
                        style: {
                            color: '#666',
                            margin: '0 0 0.75rem 0'
                        },
                        children: "Risk Score Guide:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsb",
                        style: {
                            gap: '1rem',
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '4px',
                                            background: '#d32f2f'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: '#666'
                                        },
                                        children: "-5 to -3: Very High Risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '4px',
                                            background: '#f57c00'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: '#666'
                                        },
                                        children: "-2 to -1: Medium Risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '4px',
                                            background: '#757575'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: '#666'
                                        },
                                        children: "0: Neutral"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '4px',
                                            background: '#fbc02d'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: '#666'
                                        },
                                        children: "+1 to +2: Low Risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '4px',
                                            background: '#388e3c'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: '#666'
                                        },
                                        children: "+3 to +5: Very Low Risk"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ae3c753ed9e10b31$export$2e2bcd8739ae039 = $ae3c753ed9e10b31$var$RiskScoreSlider;




// Question types with display labels (aligned with TempQuestion enum)
const $e1084e8829099501$var$QUESTION_TYPES = [
    {
        value: 'D/ND',
        label: 'Disclosure / No Disclosure'
    },
    {
        value: '1to5',
        label: '1 to 5'
    },
    {
        value: 'Date',
        label: 'Date Picker'
    },
    {
        value: 'YN/F/T',
        label: 'Yes | No | N/A'
    },
    {
        value: 'YN/TA',
        label: 'Yes | No | N/A + Text Area'
    },
    {
        value: 'YN/IMG',
        label: 'Yes | No | N/A + Image'
    },
    {
        value: 'FILE',
        label: 'File Upload Only'
    },
    {
        value: 'TA',
        label: 'Only Textarea'
    },
    {
        value: 'DropDown',
        label: 'DropDown'
    },
    {
        value: 'Multi',
        label: 'Multi'
    }
];
// Legacy DB values mapped to a select option value (YN stored as yesNo in UI)
const $e1084e8829099501$var$QUESTION_TYPE_SELECT_ALIASES = {
    YN: 'yesNo'
};
const $e1084e8829099501$var$normalizeQuestionTypeForSelect = (questionType)=>{
    const raw = String(questionType || '').trim();
    if (!raw || raw === 'null') return '';
    return $e1084e8829099501$var$QUESTION_TYPE_SELECT_ALIASES[raw] || raw;
};
const $e1084e8829099501$var$getQuestionTypeSelectOptions = (questionType)=>{
    const normalized = $e1084e8829099501$var$normalizeQuestionTypeForSelect(questionType);
    if (normalized && !$e1084e8829099501$var$QUESTION_TYPES.some((t)=>t.value === normalized)) return [
        ...$e1084e8829099501$var$QUESTION_TYPES,
        {
            value: normalized,
            label: normalized
        }
    ];
    return $e1084e8829099501$var$QUESTION_TYPES;
};
const $e1084e8829099501$var$getQuestionTypeLabel = (questionType)=>{
    const normalized = $e1084e8829099501$var$normalizeQuestionTypeForSelect(questionType);
    return $e1084e8829099501$var$QUESTION_TYPES.find((t)=>t.value === normalized)?.label || questionType || '';
};
// Predefined options for specific question types
const $e1084e8829099501$var$PREDEFINED_OPTIONS = {
    'yesNo': [
        'Yes',
        'No',
        'N/A'
    ],
    'YN/F/T': [
        'Yes',
        'No',
        'N/A'
    ],
    'D/ND': [
        'Disclosure',
        'No Disclosure'
    ],
    '1to5': [
        '1',
        '2',
        '3',
        '4',
        '5'
    ]
};
const $e1084e8829099501$var$QuestionForm = ({ question: question, index: index, moduleKey: moduleKey, sectionIndex: sectionIndex, subfolderPath: subfolderPath = [], isExpanded: isExpanded = false, onToggleExpand: onToggleExpand, onUpdate: onUpdate, onRemove: onRemove, errors: errors = {}, hideBorder: hideBorder = false, hideExpand: hideExpand = false, hideDelete: hideDelete = false })=>{
    const [customOptions, setCustomOptions] = (0, $acw62.useState)(question.customOptions || [
        {
            value: '',
            info: ''
        }
    ]);
    const [predefinedOptionsInfo, setPredefinedOptionsInfo] = (0, $acw62.useState)(question.predefinedOptionsInfo || {});
    const [priority, setPriority] = (0, $acw62.useState)(question.priority || '');
    const [dateInfo, setDateInfo] = (0, $acw62.useState)(question.dateInfo || '');
    const [tooltip, setTooltip] = (0, $acw62.useState)(question.tooltip || '');
    const [toolboxOffer, setToolboxOffer] = (0, $acw62.useState)(question.toolboxOffer || '');
    const [riskDescription, setRiskDescription] = (0, $acw62.useState)(question.riskDescription || '');
    const [recommendDescription, setRecommendDescription] = (0, $acw62.useState)(question.recommendDescription || '');
    const [riskScores, setRiskScores] = (0, $acw62.useState)(question.riskScores || {});
    const [templateFiles, setTemplateFiles] = (0, $acw62.useState)(question.templateFiles || []);
    const [isUploadingFiles, setIsUploadingFiles] = (0, $acw62.useState)(false);
    const [isSavingPriority, setIsSavingPriority] = (0, $acw62.useState)(false);
    const fileInputRef = (0, $acw62.useRef)(null);
    const handleTemplateFileUpload = async (e)=>{
        const files = Array.from(e.target.files);
        if (!files.length || !question._id) return;
        setIsUploadingFiles(true);
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/temp-questions/${question._id}/upload-template-files`, {
            attachment: files,
            questions: 'true'
        });
        setIsUploadingFiles(false);
        if (fileInputRef.current) fileInputRef.current.value = '';
        if (!res || res.code !== 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Upload failed');
        const updated = res.body?.templateFiles || [];
        setTemplateFiles(updated);
        onUpdate({
            ...question,
            templateFiles: updated
        });
    };
    const handleTemplateFileDelete = async (key)=>{
        if (!question._id) return;
        const res = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/temp-questions/${question._id}/template-files`, {
            key: key
        });
        if (!res || res.code !== 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Delete failed');
        const updated = res.body?.templateFiles || [];
        setTemplateFiles(updated);
        onUpdate({
            ...question,
            templateFiles: updated
        });
    };
    const generateQuestionNumber = ()=>{
        // Prefer stored question number if available so display always matches persisted qNo
        if (question.qNo) return question.qNo;
        if (!moduleKey) return `Q${question.questionNumber || index + 1}`;
        // Format section number as 3 digits (001, 002, etc.)
        const formattedSectionNumber = String(sectionIndex + 1).padStart(3, '0');
        const questionNum = question.questionNumber || index + 1;
        // Build the question number with subfolder path
        let qNo = `${moduleKey}${formattedSectionNumber}`;
        // Add subfolder path if exists (e.g., .1.2 for nested subfolders)
        if (subfolderPath && subfolderPath.length > 0) qNo += '.' + subfolderPath.join('.');
        // Add question number
        qNo += `.${questionNum}`;
        return qNo;
    };
    const effectiveQuestionType = $e1084e8829099501$var$normalizeQuestionTypeForSelect(question.questionType) || question.questionType;
    (0, $acw62.useEffect)(()=>{
        if ([
            'DropDown',
            'Radio',
            'Multi'
        ].includes(effectiveQuestionType)) setCustomOptions(question.customOptions || [
            {
                value: '',
                info: ''
            }
        ]);
        // Always update these fields when question changes
        setPredefinedOptionsInfo(question.predefinedOptionsInfo || {});
        setPriority(question.priority || '');
        setDateInfo(question.dateInfo || '');
        console.log('136', question);
        setTooltip(question.tooltip || '');
        setToolboxOffer(question.toolboxOffer || '');
        setRiskDescription(question.riskDescription || '');
        setRecommendDescription(question.recommendDescription || '');
        setRiskScores(question.riskScores || {});
        setTemplateFiles(question.templateFiles || []);
    }, [
        question,
        effectiveQuestionType
    ]);
    const handleQuestionChange = (field, value)=>{
        const updatedQuestion = {
            ...question,
            [field]: value
        };
        // Reset options when question type changes
        if (field === 'questionType') {
            updatedQuestion.customOptions = [
                {
                    value: '',
                    info: ''
                }
            ];
            updatedQuestion.predefinedOptionsInfo = {};
            updatedQuestion.dateInfo = '';
            updatedQuestion.riskScores = {};
            setCustomOptions([
                {
                    value: '',
                    info: ''
                }
            ]);
            setPredefinedOptionsInfo({});
            setDateInfo('');
            setRiskScores({});
        }
        onUpdate(updatedQuestion);
    };
    const handleTooltipChange = (value)=>{
        setTooltip(value);
        handleQuestionChange('tooltip', value);
    };
    const handleToolboxOfferChange = (value)=>{
        setToolboxOffer(value);
        handleQuestionChange('toolboxOffer', value);
    };
    const handleRiskDescriptionChange = (value)=>{
        setRiskDescription(value);
        handleQuestionChange('riskDescription', value);
    };
    const handleRecommendDescriptionChange = (value)=>{
        setRecommendDescription(value);
        handleQuestionChange('recommendDescription', value);
    };
    const handleRiskScoreChange = (scores)=>{
        setRiskScores(scores);
        handleQuestionChange('riskScores', scores);
    };
    const handlePriorityChange = async (value)=>{
        const previous = priority;
        setPriority(value);
        handleQuestionChange('priority', value);
        if (!question._id) return;
        setIsSavingPriority(true);
        const res = await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)(`/modules/question-priority/${question._id}`, {
            priority: value || ''
        }, true, true);
        setIsSavingPriority(false);
        if (!res || res.code !== 200) {
            setPriority(previous);
            handleQuestionChange('priority', previous);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to update priority', 'error');
            return;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Priority updated', 'success');
    };
    const handleCustomOptionChange = (optionIndex, field, value)=>{
        const newOptions = [
            ...customOptions
        ];
        newOptions[optionIndex][field] = value;
        setCustomOptions(newOptions);
        handleQuestionChange('customOptions', newOptions);
    };
    /** Sync value + name so APIs that store either shape stay consistent (e.g. investor-lead). */ const handleCustomOptionPrimaryChange = (optionIndex, newLabel)=>{
        const newOptions = [
            ...customOptions
        ];
        const prev = {
            ...newOptions[optionIndex] || {}
        };
        prev.value = newLabel;
        prev.name = newLabel;
        newOptions[optionIndex] = prev;
        setCustomOptions(newOptions);
        handleQuestionChange('customOptions', newOptions);
    };
    const handleCustomOptionSecondaryChange = (optionIndex, newText)=>{
        const newOptions = [
            ...customOptions
        ];
        const prev = {
            ...newOptions[optionIndex] || {}
        };
        prev.info = newText;
        prev.description = newText;
        newOptions[optionIndex] = prev;
        setCustomOptions(newOptions);
        handleQuestionChange('customOptions', newOptions);
    };
    const addCustomOption = ()=>{
        const newOptions = [
            ...customOptions,
            {
                value: '',
                info: ''
            }
        ];
        setCustomOptions(newOptions);
        handleQuestionChange('customOptions', newOptions);
    };
    const removeCustomOption = (optionIndex)=>{
        const newOptions = customOptions.filter((_, idx)=>idx !== optionIndex);
        setCustomOptions(newOptions);
        handleQuestionChange('customOptions', newOptions);
    };
    const handlePredefinedOptionInfo = (optionValue, info)=>{
        const newInfo = {
            ...predefinedOptionsInfo,
            [optionValue]: info
        };
        setPredefinedOptionsInfo(newInfo);
        handleQuestionChange('predefinedOptionsInfo', newInfo);
    };
    const handleDateInfoChange = (info)=>{
        setDateInfo(info);
        handleQuestionChange('dateInfo', info);
    };
    // Check if question type has predefined options
    const hasPredefinedOptions = ()=>$e1084e8829099501$var$PREDEFINED_OPTIONS.hasOwnProperty(effectiveQuestionType);
    // Check if question type needs custom options
    const needsCustomOptions = ()=>[
            'DropDown',
            'Radio',
            'Multi'
        ].includes(effectiveQuestionType);
    // Check if question type is Date
    const isDateType = ()=>effectiveQuestionType === 'Date';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "br10px mb1rem",
        style: {
            background: '#fafafa',
            border: hideBorder ? 'none' : '1px solid #e0e0e0',
            transition: 'all 0.3s ease',
            overflow: 'hidden',
            minWidth: 0,
            maxWidth: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcsb aic",
                style: {
                    padding: '1rem 1.5rem',
                    background: isExpanded ? 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)' : 'white',
                    borderBottom: isExpanded ? '1px solid #e0e0e0' : 'none',
                    transition: 'all 0.3s ease'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic flex-1",
                    style: {
                        gap: '12px'
                    },
                    children: [
                        !hideExpand && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: (e)=>{
                                e.stopPropagation();
                                onToggleExpand();
                            },
                            className: "df aic jcc cp",
                            style: {
                                border: 'none',
                                background: isExpanded ? '#667eea' : '#e0e0e0',
                                color: 'white',
                                padding: '6px',
                                borderRadius: '6px',
                                transition: 'all 0.2s ease',
                                minWidth: '32px',
                                minHeight: '32px'
                            },
                            onMouseOver: (e)=>{
                                e.currentTarget.style.background = isExpanded ? '#5568d3' : '#d0d0d0';
                                e.currentTarget.style.transform = 'scale(1.05)';
                            },
                            onMouseOut: (e)=>{
                                e.currentTarget.style.background = isExpanded ? '#667eea' : '#e0e0e0';
                                e.currentTarget.style.transform = 'scale(1)';
                            },
                            children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fed6bc25c5eb7cb$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '20px'
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '20px'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex-1",
                            style: {
                                minWidth: 0
                            },
                            children: !isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '8px',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-85rem fw600",
                                        style: {
                                            color: '#667eea',
                                            fontFamily: 'monospace',
                                            background: '#667eea20',
                                            padding: '4px 10px',
                                            borderRadius: '6px',
                                            whiteSpace: 'nowrap'
                                        },
                                        children: generateQuestionNumber()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: '#999',
                                            margin: '0 4px'
                                        },
                                        children: "\u2013"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-9rem",
                                        style: {
                                            color: '#333',
                                            fontWeight: '500',
                                            flex: 1,
                                            minWidth: 0,
                                            wordBreak: 'break-word'
                                        },
                                        children: question.qDescription || 'New Question - Click to edit'
                                    }),
                                    question.questionType && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-75rem",
                                        style: {
                                            background: '#4CAF50',
                                            color: 'white',
                                            padding: '3px 8px',
                                            borderRadius: '4px',
                                            fontWeight: '500',
                                            whiteSpace: 'nowrap'
                                        },
                                        children: $e1084e8829099501$var$getQuestionTypeLabel(question.questionType)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                className: "fs0-95rem fw600",
                                style: {
                                    color: '#667eea',
                                    margin: 0
                                },
                                children: [
                                    "Question ",
                                    index + 1
                                ]
                            })
                        }),
                        !hideDelete && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: (e)=>{
                                e.stopPropagation();
                                onRemove();
                            },
                            className: "df aic jcc cp",
                            style: {
                                border: 'none',
                                background: 'transparent',
                                color: '#dc3545',
                                padding: '6px',
                                borderRadius: '6px',
                                transition: 'all 0.2s ease'
                            },
                            onMouseOver: (e)=>{
                                e.currentTarget.style.background = '#fee';
                                e.currentTarget.style.color = '#c82333';
                            },
                            onMouseOut: (e)=>{
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = '#dc3545';
                            },
                            title: "Remove Question",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '18px'
                                }
                            })
                        })
                    ]
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p1-5rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg1rem module-form-grid",
                    style: {
                        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: [
                                        "Question Number ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: '#4CAF50'
                                            },
                                            children: "(Auto-generated)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    value: generateQuestionNumber(),
                                    readOnly: true,
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.95rem',
                                        outline: 'none',
                                        background: '#f5f5f5',
                                        color: '#333',
                                        cursor: 'not-allowed',
                                        fontFamily: 'monospace',
                                        fontWeight: '500'
                                    },
                                    placeholder: "Will be generated"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#999'
                                    },
                                    children: subfolderPath && subfolderPath.length > 0 ? `Format: MODULEKEY + SECTION# + SUBFOLDER# + QUESTION# (e.g., UMS001.1.1)` : `Format: MODULEKEY + SECTION# + QUESTION# (e.g., UMS001.1)`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: [
                                        "Question Type ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: '#dc3545'
                                            },
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    value: $e1084e8829099501$var$normalizeQuestionTypeForSelect(question.questionType),
                                    onChange: (e)=>handleQuestionChange('questionType', e.target.value),
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: errors.questionType ? '1px solid #dc3545' : '1px solid #ddd',
                                        fontSize: '0.95rem',
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        background: 'white',
                                        color: '#333',
                                        cursor: 'pointer'
                                    },
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = errors.questionType ? '#dc3545' : '#ddd',
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "",
                                            children: "Select Type"
                                        }),
                                        $e1084e8829099501$var$getQuestionTypeSelectOptions(question.questionType).map((type)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: type.value,
                                                children: type.label
                                            }, type.value))
                                    ]
                                }),
                                errors.questionType && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#dc3545'
                                    },
                                    children: errors.questionType
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: "Priority"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    value: priority,
                                    onChange: (e)=>handlePriorityChange(e.target.value),
                                    disabled: isSavingPriority,
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.95rem',
                                        outline: 'none',
                                        background: 'white',
                                        color: '#333',
                                        cursor: isSavingPriority ? 'not-allowed' : 'pointer',
                                        opacity: isSavingPriority ? 0.7 : 1
                                    },
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = '#ddd',
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "",
                                            children: "Not Set"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "High",
                                            children: "High"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "Medium",
                                            children: "Medium"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "Low",
                                            children: "Low"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#999'
                                    },
                                    children: "Override AI-generated priority for this question"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: [
                                        "Question ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                color: '#dc3545'
                                            },
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: question.qDescription || '',
                                    onChange: (e)=>handleQuestionChange('qDescription', e.target.value),
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: errors.qDescription ? '1px solid #dc3545' : '1px solid #ddd',
                                        fontSize: '0.95rem',
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        background: 'white',
                                        fontFamily: 'inherit',
                                        resize: 'vertical',
                                        minHeight: '60px'
                                    },
                                    placeholder: "e.g., Do you have Investor Deck documents ready for review/diligence?",
                                    rows: "2",
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = errors.qDescription ? '#dc3545' : '#ddd'
                                }),
                                errors.qDescription && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#dc3545'
                                    },
                                    children: errors.qDescription
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: "Tooltip"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: tooltip,
                                    onChange: (e)=>handleTooltipChange(e.target.value),
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        background: 'white',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    },
                                    placeholder: "e.g., This document helps investors understand your business model",
                                    rows: "2",
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#999'
                                    },
                                    children: "Helpful information shown when users hover over this question"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: "Toolbox Offer"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: toolboxOffer,
                                    onChange: (e)=>handleToolboxOfferChange(e.target.value),
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        background: 'white',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    },
                                    placeholder: "e.g., We can help you create an investor deck - Contact us for templates and guidance",
                                    rows: "2",
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#999'
                                    },
                                    children: "Offer additional resources or services related to this question"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: "Risk Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: riskDescription,
                                    onChange: (e)=>handleRiskDescriptionChange(e.target.value),
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        background: 'white',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    },
                                    placeholder: "e.g., Failure to address this may expose the company to significant risk",
                                    rows: "2",
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#999'
                                    },
                                    children: "Describe the risk associated with a negative or incomplete answer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "fs0-875rem fw400 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: "Recommend Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: recommendDescription,
                                    onChange: (e)=>handleRecommendDescriptionChange(e.target.value),
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.875rem',
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        background: 'white',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    },
                                    placeholder: "e.g., We recommend preparing a comprehensive investor deck with key metrics",
                                    rows: "2",
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-375rem",
                                    style: {
                                        color: '#999'
                                    },
                                    children: "Provide a recommendation or suggested action for this question"
                                })
                            ]
                        }),
                        hasPredefinedOptions() && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1',
                                marginTop: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic mb1rem",
                                    style: {
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "fs0-875rem fw400",
                                            style: {
                                                color: '#555'
                                            },
                                            children: [
                                                "Answer Options ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        color: '#dc3545'
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                                            style: {
                                                fontSize: '16px',
                                                color: '#999'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                            style: {
                                                color: '#999',
                                                fontSize: '0.8rem'
                                            },
                                            children: "Add info/description for each option"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc",
                                    style: {
                                        gap: '12px'
                                    },
                                    children: $e1084e8829099501$var$PREDEFINED_OPTIONS[effectiveQuestionType].map((option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "br8px p1rem",
                                            style: {
                                                background: 'white',
                                                border: '1px solid #e0e0e0'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic mb0-5rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic jcc",
                                                        style: {
                                                            background: '#4CAF50',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '0.875rem',
                                                            fontWeight: '500',
                                                            minWidth: '80px'
                                                        },
                                                        children: option
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        value: predefinedOptionsInfo[option] || '',
                                                        onChange: (e)=>handlePredefinedOptionInfo(option, e.target.value),
                                                        className: "bss bw1px w100",
                                                        style: {
                                                            padding: '8px 10px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ddd',
                                                            fontSize: '0.875rem',
                                                            outline: 'none',
                                                            background: 'white',
                                                            fontFamily: 'inherit',
                                                            resize: 'vertical'
                                                        },
                                                        placeholder: `e.g., This option indicates ${option.toLowerCase()}`,
                                                        rows: "2",
                                                        onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                                        onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                                    })
                                                })
                                            ]
                                        }, option))
                                })
                            ]
                        }),
                        isDateType() && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1',
                                marginTop: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic mb0-75rem",
                                    style: {
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "fs0-875rem fw400",
                                            style: {
                                                color: '#555'
                                            },
                                            children: "Date Field Guidelines"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                                            style: {
                                                fontSize: '16px',
                                                color: '#999'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                            style: {
                                                color: '#999',
                                                fontSize: '0.8rem'
                                            },
                                            children: "Add instructions for the date field"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: dateInfo,
                                    onChange: (e)=>handleDateInfoChange(e.target.value),
                                    className: "bss bw1px w100",
                                    style: {
                                        padding: '10px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.95rem',
                                        outline: 'none',
                                        background: 'white',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    },
                                    placeholder: "e.g., Please select the expected completion date in DD/MM/YYYY format.",
                                    rows: "3",
                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                    onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                })
                            ]
                        }),
                        needsCustomOptions() && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1',
                                marginTop: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic mb1rem",
                                    style: {
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "fs0-875rem fw400",
                                            style: {
                                                color: '#555'
                                            },
                                            children: [
                                                effectiveQuestionType,
                                                " Options ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        color: '#dc3545'
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                                            style: {
                                                fontSize: '16px',
                                                color: '#999'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                            style: {
                                                color: '#999',
                                                fontSize: '0.8rem'
                                            },
                                            children: "Add value and info for each option"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    style: {
                                        gap: '12px'
                                    },
                                    children: [
                                        customOptions.map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "br8px p1rem",
                                                style: {
                                                    background: 'white',
                                                    border: '1px solid #e0e0e0'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic jcsb mb0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "fs0-85rem fw500",
                                                                style: {
                                                                    color: '#333'
                                                                },
                                                                children: [
                                                                    "Option ",
                                                                    optIdx + 1
                                                                ]
                                                            }),
                                                            customOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>removeCustomOption(optIdx),
                                                                className: "df aic jcc cp",
                                                                style: {
                                                                    border: 'none',
                                                                    background: 'transparent',
                                                                    color: '#dc3545',
                                                                    padding: '4px',
                                                                    borderRadius: '6px',
                                                                    transition: 'all 0.2s ease'
                                                                },
                                                                onMouseOver: (e)=>{
                                                                    e.currentTarget.style.background = '#fee';
                                                                    e.currentTarget.style.color = '#c82333';
                                                                },
                                                                onMouseOut: (e)=>{
                                                                    e.currentTarget.style.background = 'transparent';
                                                                    e.currentTarget.style.color = '#dc3545';
                                                                },
                                                                title: "Remove Option",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        fontSize: '16px'
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "dg gg0-75rem mb0-75rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    className: "fs0-8rem fw400 mb0-5rem",
                                                                    style: {
                                                                        color: '#666'
                                                                    },
                                                                    children: [
                                                                        "Option Value ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            style: {
                                                                                color: '#dc3545'
                                                                            },
                                                                            children: "*"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "text",
                                                                    value: (0, $39a623eb929ce528$export$82fc61b46dd11008)(option),
                                                                    onChange: (e)=>handleCustomOptionPrimaryChange(optIdx, e.target.value),
                                                                    className: "bss bw1px w100 mb0-5rem",
                                                                    style: {
                                                                        padding: '8px 10px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ddd',
                                                                        fontSize: '0.875rem',
                                                                        outline: 'none',
                                                                        background: 'white'
                                                                    },
                                                                    placeholder: `e.g., Option ${optIdx + 1}`,
                                                                    onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                                                    onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                            value: (0, $39a623eb929ce528$export$1633f32801e6dcb0)(option),
                                                            onChange: (e)=>handleCustomOptionSecondaryChange(optIdx, e.target.value),
                                                            className: "bss bw1px w100",
                                                            style: {
                                                                padding: '8px 10px',
                                                                borderRadius: '6px',
                                                                border: '1px solid #ddd',
                                                                fontSize: '0.875rem',
                                                                outline: 'none',
                                                                background: 'white',
                                                                fontFamily: 'inherit',
                                                                resize: 'vertical'
                                                            },
                                                            placeholder: "e.g., Select this option if...",
                                                            rows: "2",
                                                            onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                                            onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                                        })
                                                    })
                                                ]
                                            }, optIdx)),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            type: "button",
                                            onClick: addCustomOption,
                                            className: "df aic jcc cp",
                                            style: {
                                                border: 'none',
                                                background: '#4CAF50',
                                                color: 'white',
                                                padding: '10px 16px',
                                                borderRadius: '8px',
                                                fontSize: '0.875rem',
                                                fontWeight: '500',
                                                gap: '6px',
                                                transition: 'all 0.2s ease',
                                                alignSelf: 'flex-start'
                                            },
                                            onMouseOver: (e)=>e.currentTarget.style.background = '#45a049',
                                            onMouseOut: (e)=>e.currentTarget.style.background = '#4CAF50',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontSize: '18px'
                                                    }
                                                }),
                                                "Add Option"
                                            ]
                                        })
                                    ]
                                }),
                                errors.customOptions && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mt0-75rem",
                                    style: {
                                        color: '#dc3545',
                                        display: 'block'
                                    },
                                    children: errors.customOptions
                                })
                            ]
                        }),
                        question.questionType && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                gridColumn: '1 / -1'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae3c753ed9e10b31$export$2e2bcd8739ae039), {
                                questionType: effectiveQuestionType,
                                customOptions: customOptions,
                                predefinedOptionsInfo: predefinedOptionsInfo,
                                riskScores: riskScores,
                                onRiskScoreChange: handleRiskScoreChange
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            style: {
                                gridColumn: '1 / -1',
                                marginTop: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "fs0-875rem fw500 mb0-625rem",
                                    style: {
                                        color: '#555'
                                    },
                                    children: "Template Files"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "fs11px mb0-75rem",
                                    style: {
                                        color: '#999'
                                    },
                                    children: "Upload reference documents that will be shown to users alongside this question"
                                }),
                                question._id ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "df fdc aic jcc cp br10px bss bw1px bo16 p1-5rem",
                                            style: {
                                                border: '2px dashed #d0d5e8',
                                                cursor: isUploadingFiles ? 'not-allowed' : 'pointer',
                                                opacity: isUploadingFiles ? 0.6 : 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fas fa-cloud-upload-alt fs1-5rem c3 mb0-5rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs12px fw400 c12",
                                                    children: isUploadingFiles ? 'Uploading...' : 'Click to upload template files'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    ref: fileInputRef,
                                                    type: "file",
                                                    multiple: true,
                                                    className: "dn",
                                                    disabled: isUploadingFiles,
                                                    onChange: handleTemplateFileUpload
                                                })
                                            ]
                                        }),
                                        templateFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fww gg0-5rem mt0-75rem",
                                            children: templateFiles.map((file, fi)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic br5px bg5 px0-75rem py0-25rem",
                                                    style: {
                                                        maxWidth: '100%'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: file.location,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            className: "fs12px c3 fw500 mr0-5rem",
                                                            style: {
                                                                wordBreak: 'break-all'
                                                            },
                                                            children: file.originalname
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleTemplateFileDelete(file.key),
                                                            className: "df aic jcc cp bg44",
                                                            style: {
                                                                border: 'none',
                                                                padding: 0
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    fontSize: '14px',
                                                                    color: '#dc3545'
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }, fi))
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs12px c12 fsi",
                                    children: "Save the question first to enable template file uploads."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $e1084e8829099501$export$2e2bcd8739ae039 = $e1084e8829099501$var$QuestionForm;



const $a13b03ac67792126$var$SectionForm = ({ section: section, index: index, moduleKey: moduleKey, isExpanded: isExpanded = false, isDeletePending: isDeletePending = false, onToggleExpand: onToggleExpand, onUpdate: onUpdate, onRemove: onRemove, onDeleteQuestion: onDeleteQuestion, onClone: onClone, errors: errors = {} })=>{
    const [expandedSubFolderKey, setExpandedSubFolderKey] = (0, $acw62.useState)(null);
    const [isSectionQuestionExpanded, setIsSectionQuestionExpanded] = (0, $acw62.useState)(false);
    const [expandedSubFolderQuestions, setExpandedSubFolderQuestions] = (0, $acw62.useState)({});
    const [expandedSubSubQuestions, setExpandedSubSubQuestions] = (0, $acw62.useState)({});
    const [expandedSubFolderExtraQuestions, setExpandedSubFolderExtraQuestions] = (0, $acw62.useState)({});
    const [expandedSubSubSectionKey, setExpandedSubSubSectionKey] = (0, $acw62.useState)({});
    const [expandedL4SectionKey, setExpandedL4SectionKey] = (0, $acw62.useState)({});
    const [expandedL4Questions, setExpandedL4Questions] = (0, $acw62.useState)({});
    const handleSectionChange = (field, value)=>{
        onUpdate({
            ...section,
            [field]: value
        });
    };
    const handleQuestionUpdate = (updatedQuestion)=>{
        handleSectionChange('question', updatedQuestion);
    };
    const removeQuestionWithApi = async (question, applyLocalClear)=>{
        const questionId = question?._id;
        if (onDeleteQuestion) {
            const ok = await onDeleteQuestion(questionId);
            if (!ok) return;
        }
        applyLocalClear(null);
    };
    const addSubFolder = ()=>{
        const subFolders = section.subFolders || {};
        const subFolderKeys = Object.keys(subFolders);
        const nextKey = String(subFolderKeys.length + 1);
        const subFolderNo = `${section.sectionNo}.${nextKey}`;
        const newSubFolder = {
            name: '',
            no: subFolderNo,
            question: {
                qNo: subFolderNo,
                // Question number matches sub-folder number (e.g., UMS1.1)
                qDescription: '',
                questionType: '',
                customOptions: [
                    {
                        value: '',
                        info: ''
                    }
                ],
                predefinedOptionsInfo: {},
                dateInfo: '',
                tooltip: '',
                toolboxOffer: '',
                riskDescription: '',
                recommendDescription: '',
                riskScores: {}
            }
        };
        const updatedSubFolders = {
            ...subFolders,
            [nextKey]: newSubFolder
        };
        handleSectionChange('subFolders', updatedSubFolders);
        setExpandedSubFolderKey(nextKey); // Expand the new sub-folder
    };
    const updateSubFolder = (key, updatedSubFolder)=>{
        const updatedSubFolders = {
            ...section.subFolders,
            [key]: updatedSubFolder
        };
        handleSectionChange('subFolders', updatedSubFolders);
    };
    const addSubSubFolder = (parentKey)=>{
        const subFolders = section.subFolders || {};
        const parent = subFolders[parentKey];
        if (!parent) return;
        const existingSubSubFolders = parent.subFolders || {};
        const subSubKeys = Object.keys(existingSubSubFolders);
        const nextKey = String(subSubKeys.length + 1);
        const subSubNo = `${parent.no}.${nextKey}`;
        const newSubSubFolder = {
            name: '',
            no: subSubNo,
            question: {
                qNo: subSubNo,
                qDescription: '',
                questionType: '',
                customOptions: [
                    {
                        value: '',
                        info: ''
                    }
                ],
                predefinedOptionsInfo: {},
                dateInfo: '',
                tooltip: '',
                toolboxOffer: '',
                riskDescription: '',
                recommendDescription: '',
                riskScores: {}
            }
        };
        const updatedParent = {
            ...parent,
            subFolders: {
                ...existingSubSubFolders,
                [nextKey]: newSubSubFolder
            }
        };
        updateSubFolder(parentKey, updatedParent);
        setExpandedSubSubSectionKey((prev)=>({
                ...prev,
                [parentKey]: nextKey
            }));
    };
    const updateSubSubFolder = (parentKey, subKey, updatedSubSubFolder)=>{
        const subFolders = section.subFolders || {};
        const parent = subFolders[parentKey];
        if (!parent) return;
        const existingSubSubFolders = parent.subFolders || {};
        const updatedSubSubFolders = {
            ...existingSubSubFolders,
            [subKey]: updatedSubSubFolder
        };
        const updatedParent = {
            ...parent,
            subFolders: updatedSubSubFolders
        };
        updateSubFolder(parentKey, updatedParent);
    };
    const removeSubSubFolder = (parentKey, subKey)=>{
        const subFolders = section.subFolders || {};
        const parent = subFolders[parentKey];
        if (!parent || !parent.subFolders) return;
        const updatedSubSubFolders = {
            ...parent.subFolders
        };
        delete updatedSubSubFolders[subKey];
        const reindexedSubSubFolders = {};
        const oldSubSubKeys = Object.keys(updatedSubSubFolders).sort((a, b)=>Number(a) - Number(b));
        oldSubSubKeys.forEach((oldKey, newIdx)=>{
            const newKey = String(newIdx + 1);
            const subFolder = updatedSubSubFolders[oldKey];
            const newNo = `${parent.no}.${newKey}`;
            reindexedSubSubFolders[newKey] = {
                ...subFolder,
                no: newNo,
                question: subFolder.question ? {
                    ...subFolder.question,
                    qNo: newNo
                } : subFolder.question
            };
        });
        const updatedParent = {
            ...parent,
            subFolders: reindexedSubSubFolders
        };
        updateSubFolder(parentKey, updatedParent);
        // Re-key expanded sub-sub question state so it stays in sync after reindex
        const newExpandedSubSub = {
            ...expandedSubSubQuestions
        };
        oldSubSubKeys.forEach((oldKey)=>{
            delete newExpandedSubSub[`${parentKey}-${oldKey}`];
        });
        oldSubSubKeys.forEach((oldKey, idx)=>{
            const newKey = String(idx + 1);
            newExpandedSubSub[`${parentKey}-${newKey}`] = expandedSubSubQuestions[`${parentKey}-${oldKey}`] ?? false;
        });
        setExpandedSubSubQuestions(newExpandedSubSub);
        // Update expanded sub-sub-section key: if we removed the expanded one, clear it; else map to new key
        const currentExpanded = expandedSubSubSectionKey[parentKey];
        if (currentExpanded === subKey) setExpandedSubSubSectionKey((prev)=>({
                ...prev,
                [parentKey]: undefined
            }));
        else if (currentExpanded) {
            const idx = oldSubSubKeys.indexOf(currentExpanded);
            if (idx !== -1) {
                const newKey = String(idx + 1);
                setExpandedSubSubSectionKey((prev)=>({
                        ...prev,
                        [parentKey]: newKey
                    }));
            }
        }
    };
    const addL4Folder = (parentKey, subKey)=>{
        const subSub = section.subFolders?.[parentKey]?.subFolders?.[subKey];
        if (!subSub) return;
        const existing = subSub.subFolders || {};
        const nextKey = String(Object.keys(existing).length + 1);
        const l4No = `${subSub.no}.${nextKey}`;
        const updated = {
            ...subSub,
            subFolders: {
                ...existing,
                [nextKey]: {
                    name: '',
                    no: l4No,
                    question: {
                        qNo: l4No,
                        qDescription: '',
                        questionType: '',
                        customOptions: [
                            {
                                value: '',
                                info: ''
                            }
                        ],
                        predefinedOptionsInfo: {},
                        dateInfo: '',
                        tooltip: '',
                        toolboxOffer: '',
                        riskDescription: '',
                        recommendDescription: '',
                        riskScores: {}
                    }
                }
            }
        };
        updateSubSubFolder(parentKey, subKey, updated);
        setExpandedL4SectionKey((prev)=>({
                ...prev,
                [`${parentKey}-${subKey}`]: nextKey
            }));
    };
    const updateL4Folder = (parentKey, subKey, l4Key, updatedL4)=>{
        const subSub = section.subFolders?.[parentKey]?.subFolders?.[subKey];
        if (!subSub) return;
        updateSubSubFolder(parentKey, subKey, {
            ...subSub,
            subFolders: {
                ...subSub.subFolders || {},
                [l4Key]: updatedL4
            }
        });
    };
    const removeL4Folder = (parentKey, subKey, l4Key)=>{
        const subSub = section.subFolders?.[parentKey]?.subFolders?.[subKey];
        if (!subSub?.subFolders) return;
        const remaining = {
            ...subSub.subFolders
        };
        delete remaining[l4Key];
        const oldKeys = Object.keys(remaining).sort((a, b)=>Number(a) - Number(b));
        const reindexed = {};
        oldKeys.forEach((oldKey, idx)=>{
            const newKey = String(idx + 1);
            const newNo = `${subSub.no}.${newKey}`;
            reindexed[newKey] = {
                ...remaining[oldKey],
                no: newNo,
                question: remaining[oldKey].question ? {
                    ...remaining[oldKey].question,
                    qNo: newNo
                } : remaining[oldKey].question
            };
        });
        updateSubSubFolder(parentKey, subKey, {
            ...subSub,
            subFolders: reindexed
        });
        const pathKey = `${parentKey}-${subKey}`;
        if (expandedL4SectionKey[pathKey] === l4Key) setExpandedL4SectionKey((prev)=>({
                ...prev,
                [pathKey]: undefined
            }));
    };
    const collectQuestionIdsFromSubFolderTree = (subFolderNode)=>{
        const ids = [];
        if (!subFolderNode || typeof subFolderNode !== 'object') return ids;
        if (subFolderNode.question && subFolderNode.question._id) ids.push(String(subFolderNode.question._id));
        if (Array.isArray(subFolderNode.questions)) subFolderNode.questions.forEach((q)=>{
            if (q && q._id) ids.push(String(q._id));
        });
        const nested = subFolderNode.subFolders;
        if (nested && typeof nested === 'object') Object.values(nested).forEach((child)=>{
            ids.push(...collectQuestionIdsFromSubFolderTree(child));
        });
        return ids;
    };
    const removeSubFolder = async (key)=>{
        const currentSubFolders = section.subFolders || {};
        const subFolderToDelete = currentSubFolders[key];
        if (!subFolderToDelete) return;
        const subFolderNo = subFolderToDelete.no;
        const sectionId = section._id;
        // If the section is already persisted, use the dedicated API which atomically
        // removes the subFolder from the section document and deletes all related
        // TempQuestion (and TempAnswer) records scoped to this exact section variant.
        if (sectionId && subFolderNo) {
            const response = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/temp-sections/${sectionId}/subfolder`, {
                subFolderNo: subFolderNo
            });
            if (response?.code !== 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to delete sub-folder. Please try again.');
                return;
            }
        } else {
            // Section not yet saved — delete questions individually via the existing callback
            const questionIds = [
                ...new Set(collectQuestionIdsFromSubFolderTree(subFolderToDelete).filter(Boolean))
            ];
            if (onDeleteQuestion && questionIds.length > 0) {
                const results = await Promise.all(questionIds.map((questionId)=>onDeleteQuestion(questionId)));
                if (results.some((ok)=>!ok)) return;
            }
        }
        const updatedSubFolders = {
            ...currentSubFolders
        };
        delete updatedSubFolders[key];
        handleSectionChange('subFolders', updatedSubFolders);
        // Drop deleted key from expanded state
        const nextExpandedQuestions = {
            ...expandedSubFolderQuestions
        };
        delete nextExpandedQuestions[key];
        setExpandedSubFolderQuestions(nextExpandedQuestions);
        if (expandedSubFolderKey === key) setExpandedSubFolderKey(null);
    };
    const sectionDisplay = `Section ${section.sectionNo || `${moduleKey}${index + 1}`}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg1 br12px mb1-5rem",
        style: {
            border: '1px solid #e8e8e8',
            transition: 'all 0.3s ease',
            minWidth: 0,
            maxWidth: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb aic",
                style: {
                    padding: '1.5rem 2rem',
                    background: isExpanded ? 'linear-gradient(135deg, #4CAF5015 0%, #2196F315 100%)' : 'white',
                    borderBottom: isExpanded ? '1px solid #e8e8e8' : 'none',
                    transition: 'all 0.3s ease'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic flex-1",
                        style: {
                            gap: '12px',
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onToggleExpand,
                                className: "df aic jcc cp",
                                style: {
                                    border: 'none',
                                    background: isExpanded ? '#4CAF50' : '#f5f5f5',
                                    color: isExpanded ? 'white' : '#666',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '8px',
                                    transition: 'all 0.2s ease',
                                    padding: 0
                                },
                                onMouseOver: (e)=>{
                                    e.currentTarget.style.background = isExpanded ? '#45a049' : '#e8e8e8';
                                },
                                onMouseOut: (e)=>{
                                    e.currentTarget.style.background = isExpanded ? '#4CAF50' : '#f5f5f5';
                                },
                                children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fed6bc25c5eb7cb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex-1",
                                style: {
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "fs1rem fw600 mb0-25rem",
                                        style: {
                                            color: '#2c3e50',
                                            margin: 0,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        },
                                        children: section.sectionName || `Section ${index + 1}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-85rem",
                                        style: {
                                            color: '#999',
                                            margin: 0
                                        },
                                        children: sectionDisplay
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcfe",
                        children: [
                            onClone && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onClone,
                                className: "df aic jcc cp ml0-5rem",
                                style: {
                                    border: 'none',
                                    background: '#fff',
                                    color: '#2196F3',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '8px',
                                    transition: 'all 0.2s ease'
                                },
                                onMouseOver: (e)=>{
                                    e.currentTarget.style.background = '#2196F315';
                                },
                                onMouseOut: (e)=>{
                                    e.currentTarget.style.background = '#fff';
                                },
                                title: "Clone section to another tier",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf57dccd1789595f$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '20px'
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onRemove,
                                disabled: isDeletePending,
                                className: "df aic jcc cp ml0-5rem",
                                style: {
                                    border: 'none',
                                    background: isDeletePending ? '#f3f3f3' : '#fff',
                                    color: '#dc3545',
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '8px',
                                    transition: 'all 0.2s ease',
                                    opacity: isDeletePending ? 0.6 : 1,
                                    cursor: isDeletePending ? 'not-allowed' : 'pointer'
                                },
                                onMouseOver: (e)=>{
                                    if (isDeletePending) return;
                                    e.currentTarget.style.background = '#dc3545';
                                    e.currentTarget.style.color = 'white';
                                },
                                onMouseOut: (e)=>{
                                    e.currentTarget.style.background = isDeletePending ? '#f3f3f3' : '#fff';
                                    e.currentTarget.style.color = '#dc3545';
                                },
                                title: isDeletePending ? 'Delete queued (3s)' : 'Delete section',
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '20px'
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p2rem",
                style: {
                    background: '#fafafa'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb1-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "fs0-875rem fw600 mb0-75rem",
                                style: {
                                    color: '#555',
                                    display: 'block'
                                },
                                children: [
                                    "Section Name ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: '#dc3545'
                                        },
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                value: section.sectionName || '',
                                onChange: (e)=>handleSectionChange('sectionName', e.target.value),
                                placeholder: "Enter section name...",
                                className: "w100",
                                style: {
                                    boxSizing: 'border-box',
                                    border: errors.sectionName ? '2px solid #dc3545' : '1px solid #ddd',
                                    borderRadius: '8px',
                                    padding: '10px 12px',
                                    fontSize: '0.95rem',
                                    outline: 'none',
                                    transition: 'all 0.2s ease',
                                    background: 'white'
                                },
                                onFocus: (e)=>e.target.style.borderColor = '#4CAF50',
                                onBlur: (e)=>e.target.style.borderColor = errors.sectionName ? '#dc3545' : '#ddd'
                            }),
                            errors.sectionName && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                className: "fs11px mt0-5rem",
                                style: {
                                    color: '#dc3545',
                                    display: 'block'
                                },
                                children: errors.sectionName
                            })
                        ]
                    }),
                    section.question && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb1-5rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                            question: section.question || {},
                            index: 0,
                            moduleKey: moduleKey,
                            sectionIndex: index,
                            subfolderPath: [],
                            isExpanded: isSectionQuestionExpanded,
                            onToggleExpand: ()=>setIsSectionQuestionExpanded((prev)=>!prev),
                            onUpdate: handleQuestionUpdate,
                            onRemove: ()=>removeQuestionWithApi(section.question, (clearedQuestion)=>handleSectionChange('question', clearedQuestion)),
                            errors: errors.question || {},
                            hideBorder: true,
                            hideExpand: false,
                            hideDelete: false
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: addSubFolder,
                        className: "df aic jcc cp w100 mb1-5rem",
                        style: {
                            border: '2px dashed #2196F3',
                            background: 'white',
                            color: '#2196F3',
                            padding: '12px',
                            borderRadius: '8px',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            gap: '8px',
                            transition: 'all 0.2s ease'
                        },
                        onMouseOver: (e)=>{
                            e.currentTarget.style.background = '#2196F315';
                            e.currentTarget.style.borderColor = '#1976D2';
                        },
                        onMouseOut: (e)=>{
                            e.currentTarget.style.background = 'white';
                            e.currentTarget.style.borderColor = '#2196F3';
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '20px'
                                }
                            }),
                            "Add Sub-Section"
                        ]
                    }),
                    section.subFolders && Object.keys(section.subFolders).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc",
                        style: {
                            gap: '1rem'
                        },
                        children: Object.keys(section.subFolders).sort((a, b)=>Number(a) - Number(b)).map((key)=>{
                            const subFolder = section.subFolders[key];
                            const isSubFolderExpanded = expandedSubFolderKey === key;
                            const isSubFolderQuestionExpanded = expandedSubFolderQuestions[key] ?? false;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg1 br10px",
                                style: {
                                    border: '1px solid #e0e0e0',
                                    marginLeft: '1.5rem',
                                    marginRight: '1.5rem',
                                    transition: 'all 0.3s ease'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic",
                                        style: {
                                            padding: '1rem 1.5rem',
                                            background: isSubFolderExpanded ? '#f8f9fa' : 'white',
                                            borderBottom: isSubFolderExpanded ? '1px solid #e0e0e0' : 'none',
                                            transition: 'all 0.3s ease'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic flex-1",
                                                style: {
                                                    gap: '12px',
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setExpandedSubFolderKey(isSubFolderExpanded ? null : key),
                                                        className: "df aic jcc cp",
                                                        style: {
                                                            border: 'none',
                                                            background: isSubFolderExpanded ? '#2196F3' : '#f5f5f5',
                                                            color: isSubFolderExpanded ? 'white' : '#666',
                                                            width: '32px',
                                                            height: '32px',
                                                            borderRadius: '6px',
                                                            transition: 'all 0.2s ease',
                                                            padding: 0
                                                        },
                                                        children: isSubFolderExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fed6bc25c5eb7cb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "flex-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                                className: "fs0-95rem fw600",
                                                                style: {
                                                                    color: '#2c3e50',
                                                                    margin: 0
                                                                },
                                                                children: subFolder.name || `Sub-Folder ${key}`
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs0-8rem",
                                                                style: {
                                                                    color: '#999',
                                                                    margin: 0
                                                                },
                                                                children: subFolder.no
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>removeSubFolder(key),
                                                className: "df aic jcc cp ml1rem",
                                                style: {
                                                    border: 'none',
                                                    background: '#fff',
                                                    color: '#dc3545',
                                                    width: '32px',
                                                    height: '32px',
                                                    borderRadius: '6px',
                                                    transition: 'all 0.2s ease'
                                                },
                                                onMouseOver: (e)=>{
                                                    e.currentTarget.style.background = '#dc3545';
                                                    e.currentTarget.style.color = 'white';
                                                },
                                                onMouseOut: (e)=>{
                                                    e.currentTarget.style.background = '#fff';
                                                    e.currentTarget.style.color = '#dc3545';
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontSize: '18px'
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    isSubFolderExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "p1-5rem",
                                        style: {
                                            background: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mb1-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-875rem fw500 mb0-5rem",
                                                        style: {
                                                            color: '#555',
                                                            display: 'block'
                                                        },
                                                        children: "Sub-Folder Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        value: subFolder.name || '',
                                                        onChange: (e)=>updateSubFolder(key, {
                                                                ...subFolder,
                                                                name: e.target.value
                                                            }),
                                                        placeholder: "Enter sub-folder name...",
                                                        className: "w100",
                                                        style: {
                                                            border: errors.subFolders?.[key]?.name ? '2px solid #dc3545' : '1px solid #ddd',
                                                            borderRadius: '8px',
                                                            padding: '10px 12px',
                                                            fontSize: '0.95rem',
                                                            outline: 'none',
                                                            transition: 'all 0.2s ease',
                                                            background: 'white'
                                                        },
                                                        onFocus: (e)=>e.target.style.borderColor = '#2196F3',
                                                        onBlur: (e)=>e.target.style.borderColor = errors.subFolders?.[key]?.name ? '#dc3545' : '#ddd'
                                                    }),
                                                    errors.subFolders?.[key]?.name && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px mt0-5rem",
                                                        style: {
                                                            color: '#dc3545',
                                                            display: 'block'
                                                        },
                                                        children: errors.subFolders[key].name
                                                    })
                                                ]
                                            }),
                                            subFolder.question && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                                                question: subFolder.question || {},
                                                index: 0,
                                                moduleKey: moduleKey,
                                                sectionIndex: index,
                                                subfolderPath: [],
                                                isExpanded: isSubFolderQuestionExpanded,
                                                onToggleExpand: ()=>setExpandedSubFolderQuestions((prev)=>({
                                                            ...prev,
                                                            [key]: !prev[key]
                                                        })),
                                                onUpdate: (updatedQuestion)=>updateSubFolder(key, {
                                                        ...subFolder,
                                                        question: updatedQuestion
                                                    }),
                                                onRemove: ()=>removeQuestionWithApi(subFolder.question, (clearedQuestion)=>updateSubFolder(key, {
                                                            ...subFolder,
                                                            question: clearedQuestion
                                                        })),
                                                errors: errors.subFolders?.[key]?.question || {},
                                                hideBorder: true,
                                                hideExpand: false,
                                                hideDelete: false
                                            }),
                                            Array.isArray(subFolder.questions) && subFolder.questions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fdc",
                                                style: {
                                                    gap: '1rem',
                                                    marginTop: '1rem'
                                                },
                                                children: subFolder.questions.map((extraQ, qIdx)=>{
                                                    const expKey = `${key}-extra-${qIdx}`;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                                                        question: extraQ || {},
                                                        index: qIdx + 1,
                                                        moduleKey: moduleKey,
                                                        sectionIndex: index,
                                                        subfolderPath: [],
                                                        isExpanded: expandedSubFolderExtraQuestions[expKey] ?? true,
                                                        onToggleExpand: ()=>setExpandedSubFolderExtraQuestions((prev)=>({
                                                                    ...prev,
                                                                    [expKey]: !(prev[expKey] ?? true)
                                                                })),
                                                        onUpdate: (updatedQuestion)=>{
                                                            const next = [
                                                                ...subFolder.questions || []
                                                            ];
                                                            next[qIdx] = updatedQuestion;
                                                            updateSubFolder(key, {
                                                                ...subFolder,
                                                                questions: next
                                                            });
                                                        },
                                                        onRemove: ()=>removeQuestionWithApi(extraQ, ()=>{
                                                                const next = (subFolder.questions || []).filter((_, i)=>i !== qIdx);
                                                                updateSubFolder(key, {
                                                                    ...subFolder,
                                                                    questions: next
                                                                });
                                                            }),
                                                        errors: errors.subFolders?.[key]?.questions?.[qIdx] || {},
                                                        hideBorder: true,
                                                        hideExpand: false,
                                                        hideDelete: false
                                                    }, extraQ._id || expKey);
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mt1rem",
                                                style: {
                                                    marginLeft: '1.5rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>addSubSubFolder(key),
                                                        className: "df aic jcc cp w100 mb1rem",
                                                        style: {
                                                            border: '2px dashed #9c27b0',
                                                            background: 'white',
                                                            color: '#9c27b0',
                                                            padding: '10px',
                                                            borderRadius: '8px',
                                                            fontSize: '0.85rem',
                                                            fontWeight: '600',
                                                            gap: '8px',
                                                            transition: 'all 0.2s ease'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    fontSize: '18px'
                                                                }
                                                            }),
                                                            "Add Sub-Sub-Section"
                                                        ]
                                                    }),
                                                    subFolder.subFolders && Object.keys(subFolder.subFolders).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc",
                                                        style: {
                                                            gap: '0.75rem'
                                                        },
                                                        children: Object.keys(subFolder.subFolders).sort((a, b)=>Number(a) - Number(b)).map((subKey)=>{
                                                            const subSub = subFolder.subFolders[subKey];
                                                            const isSubSubExpanded = expandedSubSubSectionKey[key] === subKey;
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "bg1 br10px",
                                                                style: {
                                                                    border: '1px solid #e0e0e0',
                                                                    marginLeft: '1.5rem',
                                                                    marginRight: '1.5rem',
                                                                    transition: 'all 0.3s ease'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df jcsb aic",
                                                                        style: {
                                                                            padding: '0.875rem 1.25rem',
                                                                            background: isSubSubExpanded ? '#f5f0f8' : 'white',
                                                                            borderBottom: isSubSubExpanded ? '1px solid #e0e0e0' : 'none',
                                                                            transition: 'all 0.3s ease'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic flex-1",
                                                                                style: {
                                                                                    gap: '10px'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        type: "button",
                                                                                        onClick: ()=>setExpandedSubSubSectionKey((prev)=>({
                                                                                                    ...prev,
                                                                                                    [key]: prev[key] === subKey ? undefined : subKey
                                                                                                })),
                                                                                        className: "df aic jcc cp",
                                                                                        style: {
                                                                                            border: 'none',
                                                                                            background: isSubSubExpanded ? '#9c27b0' : '#f5f5f5',
                                                                                            color: isSubSubExpanded ? 'white' : '#666',
                                                                                            width: '30px',
                                                                                            height: '30px',
                                                                                            borderRadius: '6px',
                                                                                            transition: 'all 0.2s ease',
                                                                                            padding: 0
                                                                                        },
                                                                                        children: isSubSubExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fed6bc25c5eb7cb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {})
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "flex-1",
                                                                                        style: {
                                                                                            minWidth: 0
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                                                                                className: "fs0-9rem fw600",
                                                                                                style: {
                                                                                                    color: '#2c3e50',
                                                                                                    margin: 0
                                                                                                },
                                                                                                children: subSub.name || `Sub-Sub-Section ${subKey}`
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "fs0-75rem",
                                                                                                style: {
                                                                                                    color: '#999',
                                                                                                    margin: 0
                                                                                                },
                                                                                                children: subSub.no
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>removeSubSubFolder(key, subKey),
                                                                                className: "df aic jcc cp ml0-75rem",
                                                                                style: {
                                                                                    border: 'none',
                                                                                    background: '#fff',
                                                                                    color: '#dc3545',
                                                                                    width: '30px',
                                                                                    height: '30px',
                                                                                    borderRadius: '6px',
                                                                                    transition: 'all 0.2s ease'
                                                                                },
                                                                                onMouseOver: (e)=>{
                                                                                    e.currentTarget.style.background = '#dc3545';
                                                                                    e.currentTarget.style.color = 'white';
                                                                                },
                                                                                onMouseOut: (e)=>{
                                                                                    e.currentTarget.style.background = '#fff';
                                                                                    e.currentTarget.style.color = '#dc3545';
                                                                                },
                                                                                title: "Remove sub-sub-section",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                                    style: {
                                                                                        fontSize: '16px'
                                                                                    }
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isSubSubExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "p1-25rem",
                                                                        style: {
                                                                            background: '#fafafa'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "mb1-5rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                        className: "fs0-875rem fw500 mb0-5rem",
                                                                                        style: {
                                                                                            color: '#555',
                                                                                            display: 'block'
                                                                                        },
                                                                                        children: [
                                                                                            "Sub-Sub-Section Name ",
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                style: {
                                                                                                    color: '#dc3545'
                                                                                                },
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        type: "text",
                                                                                        value: subSub.name || '',
                                                                                        onChange: (e)=>updateSubSubFolder(key, subKey, {
                                                                                                ...subSub,
                                                                                                name: e.target.value
                                                                                            }),
                                                                                        placeholder: "Enter sub-sub-section name...",
                                                                                        className: "w100",
                                                                                        style: {
                                                                                            border: errors.subFolders?.[key]?.subFolders?.[subKey]?.name ? '2px solid #dc3545' : '1px solid #ddd',
                                                                                            borderRadius: '8px',
                                                                                            padding: '10px 12px',
                                                                                            fontSize: '0.95rem',
                                                                                            outline: 'none',
                                                                                            transition: 'all 0.2s ease',
                                                                                            background: 'white'
                                                                                        },
                                                                                        onFocus: (e)=>e.target.style.borderColor = '#9c27b0',
                                                                                        onBlur: (e)=>e.target.style.borderColor = errors.subFolders?.[key]?.subFolders?.[subKey]?.name ? '#dc3545' : '#ddd'
                                                                                    }),
                                                                                    errors.subFolders?.[key]?.subFolders?.[subKey]?.name && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                        className: "fs11px mt0-5rem",
                                                                                        style: {
                                                                                            color: '#dc3545',
                                                                                            display: 'block'
                                                                                        },
                                                                                        children: errors.subFolders[key].subFolders[subKey].name
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            subSub.question && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                                                                                question: subSub.question || {},
                                                                                index: 0,
                                                                                moduleKey: moduleKey,
                                                                                sectionIndex: index,
                                                                                subfolderPath: [],
                                                                                isExpanded: expandedSubSubQuestions[`${key}-${subKey}`] ?? false,
                                                                                onToggleExpand: ()=>setExpandedSubSubQuestions((prev)=>({
                                                                                            ...prev,
                                                                                            [`${key}-${subKey}`]: !(prev[`${key}-${subKey}`] ?? false)
                                                                                        })),
                                                                                onUpdate: (updatedQuestion)=>updateSubSubFolder(key, subKey, {
                                                                                        ...subSub,
                                                                                        question: updatedQuestion
                                                                                    }),
                                                                                onRemove: ()=>removeQuestionWithApi(subSub.question, (clearedQuestion)=>updateSubSubFolder(key, subKey, {
                                                                                            ...subSub,
                                                                                            question: clearedQuestion
                                                                                        })),
                                                                                errors: errors.subFolders?.[key]?.subFolders?.[subKey]?.question || {},
                                                                                hideBorder: true,
                                                                                hideExpand: false,
                                                                                hideDelete: false
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "mt1rem",
                                                                                style: {
                                                                                    marginLeft: '1rem'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        type: "button",
                                                                                        onClick: ()=>addL4Folder(key, subKey),
                                                                                        className: "df aic jcc cp w100 mb0-75rem",
                                                                                        style: {
                                                                                            border: '2px dashed #ff9800',
                                                                                            background: 'white',
                                                                                            color: '#ff9800',
                                                                                            padding: '8px',
                                                                                            borderRadius: '8px',
                                                                                            fontSize: '0.8rem',
                                                                                            fontWeight: '600',
                                                                                            gap: '8px',
                                                                                            transition: 'all 0.2s ease'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                                                                                style: {
                                                                                                    fontSize: '16px'
                                                                                                }
                                                                                            }),
                                                                                            "Add Sub-Sub-Sub-Section"
                                                                                        ]
                                                                                    }),
                                                                                    subSub.subFolders && Object.keys(subSub.subFolders).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df fdc",
                                                                                        style: {
                                                                                            gap: '0.5rem'
                                                                                        },
                                                                                        children: Object.keys(subSub.subFolders).sort((a, b)=>Number(a) - Number(b)).map((l4Key)=>{
                                                                                            const l4Folder = subSub.subFolders[l4Key];
                                                                                            const l4PathKey = `${key}-${subKey}`;
                                                                                            const isL4Expanded = expandedL4SectionKey[l4PathKey] === l4Key;
                                                                                            const isL4QExpanded = expandedL4Questions[`${key}-${subKey}-${l4Key}`] ?? false;
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "bg1 br10px",
                                                                                                style: {
                                                                                                    border: '1px solid #ffe0b2',
                                                                                                    transition: 'all 0.3s ease'
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "df jcsb aic",
                                                                                                        style: {
                                                                                                            padding: '0.75rem 1rem',
                                                                                                            background: isL4Expanded ? '#fff8f0' : 'white',
                                                                                                            borderBottom: isL4Expanded ? '1px solid #ffe0b2' : 'none',
                                                                                                            transition: 'all 0.3s ease'
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                                className: "df aic flex-1",
                                                                                                                style: {
                                                                                                                    gap: '8px',
                                                                                                                    minWidth: 0
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                                        type: "button",
                                                                                                                        onClick: ()=>setExpandedL4SectionKey((prev)=>({
                                                                                                                                    ...prev,
                                                                                                                                    [l4PathKey]: prev[l4PathKey] === l4Key ? undefined : l4Key
                                                                                                                                })),
                                                                                                                        className: "df aic jcc cp",
                                                                                                                        style: {
                                                                                                                            border: 'none',
                                                                                                                            background: isL4Expanded ? '#ff9800' : '#f5f5f5',
                                                                                                                            color: isL4Expanded ? 'white' : '#666',
                                                                                                                            width: '26px',
                                                                                                                            height: '26px',
                                                                                                                            borderRadius: '6px',
                                                                                                                            transition: 'all 0.2s ease',
                                                                                                                            padding: 0
                                                                                                                        },
                                                                                                                        children: isL4Expanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fed6bc25c5eb7cb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {})
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                                        className: "flex-1",
                                                                                                                        style: {
                                                                                                                            minWidth: 0
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                                                className: "fs0-85rem fw600",
                                                                                                                                style: {
                                                                                                                                    color: '#2c3e50',
                                                                                                                                    margin: 0
                                                                                                                                },
                                                                                                                                children: l4Folder.name || `Sub-Section ${l4Folder.no}`
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                                                className: "fs0-75rem",
                                                                                                                                style: {
                                                                                                                                    color: '#999',
                                                                                                                                    margin: 0
                                                                                                                                },
                                                                                                                                children: l4Folder.no
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                                type: "button",
                                                                                                                onClick: ()=>removeL4Folder(key, subKey, l4Key),
                                                                                                                className: "df aic jcc cp",
                                                                                                                style: {
                                                                                                                    border: 'none',
                                                                                                                    background: '#fff',
                                                                                                                    color: '#dc3545',
                                                                                                                    width: '26px',
                                                                                                                    height: '26px',
                                                                                                                    borderRadius: '6px',
                                                                                                                    transition: 'all 0.2s ease'
                                                                                                                },
                                                                                                                onMouseOver: (e)=>{
                                                                                                                    e.currentTarget.style.background = '#dc3545';
                                                                                                                    e.currentTarget.style.color = 'white';
                                                                                                                },
                                                                                                                onMouseOut: (e)=>{
                                                                                                                    e.currentTarget.style.background = '#fff';
                                                                                                                    e.currentTarget.style.color = '#dc3545';
                                                                                                                },
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                                                                    style: {
                                                                                                                        fontSize: '14px'
                                                                                                                    }
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    isL4Expanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "p1rem",
                                                                                                        style: {
                                                                                                            background: '#fafafa'
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                                className: "mb1rem",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                                                        className: "fs0-875rem fw500 mb0-5rem",
                                                                                                                        style: {
                                                                                                                            color: '#555',
                                                                                                                            display: 'block'
                                                                                                                        },
                                                                                                                        children: "Name"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                                        type: "text",
                                                                                                                        value: l4Folder.name || '',
                                                                                                                        onChange: (e)=>updateL4Folder(key, subKey, l4Key, {
                                                                                                                                ...l4Folder,
                                                                                                                                name: e.target.value
                                                                                                                            }),
                                                                                                                        placeholder: "Enter name...",
                                                                                                                        className: "w100",
                                                                                                                        style: {
                                                                                                                            border: '1px solid #ddd',
                                                                                                                            borderRadius: '8px',
                                                                                                                            padding: '8px 12px',
                                                                                                                            fontSize: '0.9rem',
                                                                                                                            outline: 'none',
                                                                                                                            background: 'white',
                                                                                                                            boxSizing: 'border-box'
                                                                                                                        },
                                                                                                                        onFocus: (e)=>e.target.style.borderColor = '#ff9800',
                                                                                                                        onBlur: (e)=>e.target.style.borderColor = '#ddd'
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            l4Folder.question && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                                                                                                                question: l4Folder.question || {},
                                                                                                                index: 0,
                                                                                                                moduleKey: moduleKey,
                                                                                                                sectionIndex: index,
                                                                                                                subfolderPath: [],
                                                                                                                isExpanded: isL4QExpanded,
                                                                                                                onToggleExpand: ()=>setExpandedL4Questions((prev)=>({
                                                                                                                            ...prev,
                                                                                                                            [`${key}-${subKey}-${l4Key}`]: !prev[`${key}-${subKey}-${l4Key}`]
                                                                                                                        })),
                                                                                                                onUpdate: (updatedQ)=>updateL4Folder(key, subKey, l4Key, {
                                                                                                                        ...l4Folder,
                                                                                                                        question: updatedQ
                                                                                                                    }),
                                                                                                                onRemove: ()=>removeQuestionWithApi(l4Folder.question, (clearedQ)=>updateL4Folder(key, subKey, l4Key, {
                                                                                                                            ...l4Folder,
                                                                                                                            question: clearedQ
                                                                                                                        })),
                                                                                                                errors: {},
                                                                                                                hideBorder: true,
                                                                                                                hideExpand: false,
                                                                                                                hideDelete: false
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }, l4Key);
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, subKey);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
};
var $a13b03ac67792126$export$2e2bcd8739ae039 = $a13b03ac67792126$var$SectionForm;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $3b8b88ae8fdee83e$var$InvestmentReadinessQuestions = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const [questions, setQuestions] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [expandedIndex, setExpandedIndex] = (0, $acw62.useState)(null);
    const [savingIds, setSavingIds] = (0, $acw62.useState)(new Set());
    const [dirtyIds, setDirtyIds] = (0, $acw62.useState)(new Set());
    (0, $acw62.useEffect)(()=>{
        fetchQuestions();
    }, []);
    const fetchQuestions = async ()=>{
        setLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/investment-readiness/questions');
        if (response?.body?.questions) setQuestions(response.body.questions);
        setLoading(false);
    };
    const handleUpdate = (index, updatedQuestion)=>{
        setQuestions((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = updatedQuestion;
            return next;
        });
        if (updatedQuestion._id) setDirtyIds((prev)=>new Set(prev).add(String(updatedQuestion._id)));
    };
    const handleSave = async (index, silent = false)=>{
        const question = questions[index];
        if (!question._id) return null;
        setSavingIds((prev)=>new Set(prev).add(question._id));
        const payload = {
            _id: question._id,
            qDescription: question.qDescription,
            questionType: question.questionType,
            customOptions: question.customOptions,
            predefinedOptionsInfo: question.predefinedOptionsInfo,
            dateInfo: question.dateInfo,
            tooltip: question.tooltip,
            toolboxOffer: question.toolboxOffer,
            riskScores: question.riskScores,
            riskDescription: question.riskDescription,
            recommendDescription: question.recommendDescription,
            attachmentRequired: question.attachmentRequired,
            tags: question.tags
        };
        const response = await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)('/modules/investment-readiness/questions', payload);
        setSavingIds((prev)=>{
            const next = new Set(prev);
            next.delete(question._id);
            return next;
        });
        if (response?.code === 200 && response.body) {
            setQuestions((prev)=>{
                const next = [
                    ...prev
                ];
                next[index] = response.body;
                return next;
            });
            setDirtyIds((prev)=>{
                const next = new Set(prev);
                next.delete(String(question._id));
                return next;
            });
            if (!silent) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Question updated successfully', 'success');
        } else if (!silent) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Failed to update question', 'error');
        return response;
    };
    // Only saves questions that were actually modified since last fetch/save.
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            saveAll: async ()=>{
                const dirty = questions.map((q, i)=>({
                        q: q,
                        i: i
                    })).filter(({ q: q })=>q._id && dirtyIds.has(String(q._id)));
                if (!dirty.length) return;
                const results = await Promise.all(dirty.map(({ i: i })=>handleSave(i, true)));
                const failed = results.filter((r)=>r && r.code !== 200).length;
                if (failed > 0) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`${failed} question(s) failed to save`, 'error');
            }
        }), [
        questions,
        dirtyIds
    ]);
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "tac p3rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "fs0-9rem c15 op60",
            children: "Loading Investment Readiness questions..."
        })
    });
    if (!questions.length) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "br12px p3rem tac",
        style: {
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            border: '2px dashed #dee2e6'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1-1rem fw500",
                style: {
                    color: '#495057',
                    margin: '0 0 0.5rem 0'
                },
                children: "No Investment Readiness questions found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs0-9rem",
                style: {
                    color: '#6c757d',
                    margin: 0
                },
                children: 'Questions with qNo matching "EHE" will appear here'
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df fdc",
        style: {
            gap: '0.5rem'
        },
        children: questions.map((question, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                        question: question,
                        index: index,
                        moduleKey: "EHE",
                        sectionIndex: 0,
                        isExpanded: expandedIndex === index,
                        onToggleExpand: ()=>setExpandedIndex(expandedIndex === index ? null : index),
                        onUpdate: (updated)=>handleUpdate(index, updated),
                        onRemove: ()=>{},
                        hideDelete: true
                    }),
                    expandedIndex === index && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcfe",
                        style: {
                            marginTop: '0.5rem',
                            marginBottom: '1rem'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>handleSave(index),
                            disabled: savingIds.has(question._id),
                            style: {
                                border: 'none',
                                background: savingIds.has(question._id) ? '#aaa' : dirtyIds.has(String(question._id)) ? '#e67e22' : '#667eea',
                                color: 'white',
                                padding: '10px 24px',
                                borderRadius: '8px',
                                fontSize: '0.9rem',
                                fontWeight: '500',
                                cursor: savingIds.has(question._id) ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s ease'
                            },
                            children: savingIds.has(question._id) ? 'Saving...' : dirtyIds.has(String(question._id)) ? 'Save Changes' : 'Saved'
                        })
                    })
                ]
            }, question._id || index))
    });
});
var $3b8b88ae8fdee83e$export$2e2bcd8739ae039 = $3b8b88ae8fdee83e$var$InvestmentReadinessQuestions;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $e9bc8d0d510833d0$var$ExitReadinessQuestions = ()=>{
    const [questions, setQuestions] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [expandedIndex, setExpandedIndex] = (0, $acw62.useState)(null);
    const [savingIds, setSavingIds] = (0, $acw62.useState)(new Set());
    (0, $acw62.useEffect)(()=>{
        fetchQuestions();
    }, []);
    const fetchQuestions = async ()=>{
        setLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/exit-readiness/questions');
        if (response?.body?.questions) setQuestions(response.body.questions);
        setLoading(false);
    };
    const handleUpdate = (index, updatedQuestion)=>{
        setQuestions((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = updatedQuestion;
            return next;
        });
    };
    const handleSave = async (index)=>{
        const question = questions[index];
        if (!question._id) return;
        setSavingIds((prev)=>new Set(prev).add(question._id));
        const payload = {
            _id: question._id,
            qDescription: question.qDescription,
            questionType: question.questionType,
            customOptions: question.customOptions,
            predefinedOptionsInfo: question.predefinedOptionsInfo,
            dateInfo: question.dateInfo,
            tooltip: question.tooltip,
            toolboxOffer: question.toolboxOffer,
            riskScores: question.riskScores,
            riskDescription: question.riskDescription,
            recommendDescription: question.recommendDescription,
            attachmentRequired: question.attachmentRequired,
            tags: question.tags
        };
        const response = await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)('/modules/exit-readiness/questions', payload);
        setSavingIds((prev)=>{
            const next = new Set(prev);
            next.delete(question._id);
            return next;
        });
        if (response?.code === 200 && response.body) setQuestions((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = response.body;
            return next;
        });
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "tac p3rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "fs0-9rem c15 op60",
            children: "Loading Exit Readiness questions..."
        })
    });
    if (!questions.length) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "br12px p3rem tac",
        style: {
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            border: '2px dashed #dee2e6'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1-1rem fw500",
                style: {
                    color: '#495057',
                    margin: '0 0 0.5rem 0'
                },
                children: "No Exit Readiness questions found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs0-9rem",
                style: {
                    color: '#6c757d',
                    margin: 0
                },
                children: "Questions belonging to the Exit Readiness module will appear here"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df fdc",
        style: {
            gap: '0.5rem'
        },
        children: questions.map((question, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                        question: question,
                        index: index,
                        sectionIndex: 0,
                        isExpanded: expandedIndex === index,
                        onToggleExpand: ()=>setExpandedIndex(expandedIndex === index ? null : index),
                        onUpdate: (updated)=>handleUpdate(index, updated),
                        onRemove: ()=>{},
                        hideDelete: true
                    }),
                    expandedIndex === index && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcfe",
                        style: {
                            marginTop: '0.5rem',
                            marginBottom: '1rem'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>handleSave(index),
                            disabled: savingIds.has(question._id),
                            style: {
                                border: 'none',
                                background: savingIds.has(question._id) ? '#aaa' : '#667eea',
                                color: 'white',
                                padding: '10px 24px',
                                borderRadius: '8px',
                                fontSize: '0.9rem',
                                fontWeight: '500',
                                cursor: savingIds.has(question._id) ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s ease'
                            },
                            children: savingIds.has(question._id) ? 'Saving...' : 'Save Question'
                        })
                    })
                ]
            }, question._id || index))
    });
};
var $e9bc8d0d510833d0$export$2e2bcd8739ae039 = $e9bc8d0d510833d0$var$ExitReadinessQuestions;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $d42fd2067c31d9d2$var$InvestorLeadSection = ()=>{
    const [section, setSection] = (0, $acw62.useState)(null);
    const [questions, setQuestions] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [expandedIndex, setExpandedIndex] = (0, $acw62.useState)(null);
    const [savingIds, setSavingIds] = (0, $acw62.useState)(new Set());
    const [isSectionExpanded, setIsSectionExpanded] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        fetchSectionData();
    }, []);
    const fetchSectionData = async ()=>{
        setLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/investor-lead/section');
        if (response?.body) {
            setSection(response.body.section || null);
            setQuestions(response.body.questions || []);
        }
        setLoading(false);
    };
    const handleUpdate = (index, updatedQuestion)=>{
        setQuestions((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = updatedQuestion;
            return next;
        });
    };
    const handleSave = async (index)=>{
        const question = questions[index];
        if (!question._id) return;
        setSavingIds((prev)=>new Set(prev).add(question._id));
        const payload = {
            _id: question._id,
            qDescription: question.qDescription,
            questionType: question.questionType,
            customOptions: question.customOptions,
            predefinedOptionsInfo: question.predefinedOptionsInfo,
            dateInfo: question.dateInfo,
            tooltip: question.tooltip,
            toolboxOffer: question.toolboxOffer,
            riskScores: question.riskScores,
            riskDescription: question.riskDescription,
            recommendDescription: question.recommendDescription,
            attachmentRequired: question.attachmentRequired,
            tags: question.tags
        };
        const response = await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)('/modules/investor-lead/questions', payload);
        setSavingIds((prev)=>{
            const next = new Set(prev);
            next.delete(question._id);
            return next;
        });
        if (response?.code === 200 && response.body) setQuestions((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = response.body;
            return next;
        });
    };
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "tac p3rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "fs0-9rem c15 op60",
            children: "Loading Investor Lead section..."
        })
    });
    if (!section) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "br12px p3rem tac",
        style: {
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            border: '2px dashed #dee2e6'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1-1rem fw500",
                style: {
                    color: '#495057',
                    margin: '0 0 0.5rem 0'
                },
                children: "Section DEPF008 not found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs0-9rem",
                style: {
                    color: '#6c757d',
                    margin: 0
                },
                children: 'No section with sectionNo "DEPF008" exists in the database'
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg1 br12px mb1-5rem",
        style: {
            border: '1px solid #e8e8e8',
            minWidth: 0,
            maxWidth: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcsb aic cp",
                style: {
                    padding: '1.5rem 2rem',
                    background: isSectionExpanded ? 'linear-gradient(135deg, #4CAF5015 0%, #2196F315 100%)' : 'white',
                    borderBottom: isSectionExpanded ? '1px solid #e8e8e8' : 'none',
                    borderRadius: isSectionExpanded ? '12px 12px 0 0' : '12px',
                    transition: 'all 0.3s ease'
                },
                onClick: ()=>setIsSectionExpanded((prev)=>!prev),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic",
                    style: {
                        gap: '12px',
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            className: "df aic jcc cp",
                            style: {
                                border: 'none',
                                background: isSectionExpanded ? '#4CAF50' : '#e0e0e0',
                                color: 'white',
                                padding: '8px',
                                borderRadius: '8px',
                                minWidth: '36px',
                                minHeight: '36px',
                                transition: 'all 0.2s ease',
                                flexShrink: 0
                            },
                            children: isSectionExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fed6bc25c5eb7cb$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '20px'
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '20px'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    style: {
                                        gap: '8px',
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-8rem fw600",
                                            style: {
                                                background: '#4CAF5020',
                                                color: '#2e7d32',
                                                padding: '3px 10px',
                                                borderRadius: '6px',
                                                fontFamily: 'monospace'
                                            },
                                            children: section.sectionNo
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem fw600 c15",
                                            children: section.sectionName || 'Investor Lead Introduction'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-8rem c15 op60 m0 mt0-25rem",
                                    children: [
                                        questions.length,
                                        " question",
                                        questions.length !== 1 ? 's' : ''
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            isSectionExpanded && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p1-5rem",
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                },
                children: questions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "tac p2rem",
                    style: {
                        color: '#6c757d'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-9rem m0",
                        children: "No questions found for this section."
                    })
                }) : questions.map((question, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1084e8829099501$export$2e2bcd8739ae039), {
                                question: question,
                                index: index,
                                moduleKey: "DEPF",
                                sectionIndex: 0,
                                isExpanded: expandedIndex === index,
                                onToggleExpand: ()=>setExpandedIndex(expandedIndex === index ? null : index),
                                onUpdate: (updated)=>handleUpdate(index, updated),
                                onRemove: ()=>{},
                                hideDelete: true
                            }),
                            expandedIndex === index && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcfe",
                                style: {
                                    marginTop: '0.5rem',
                                    marginBottom: '1rem'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>handleSave(index),
                                    disabled: savingIds.has(question._id),
                                    style: {
                                        border: 'none',
                                        background: savingIds.has(question._id) ? '#aaa' : '#4CAF50',
                                        color: 'white',
                                        padding: '10px 24px',
                                        borderRadius: '8px',
                                        fontSize: '0.9rem',
                                        fontWeight: '500',
                                        cursor: savingIds.has(question._id) ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease'
                                    },
                                    children: savingIds.has(question._id) ? 'Saving...' : 'Save Question'
                                })
                            })
                        ]
                    }, question._id || index))
            })
        ]
    });
};
var $d42fd2067c31d9d2$export$2e2bcd8739ae039 = $d42fd2067c31d9d2$var$InvestorLeadSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5cf95f1a8b1eba96$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), 'Image');



let $da798e28ced8c022$var$_imgUploaderCounter = 0;
const $da798e28ced8c022$var$ImageUploader = ({ imageURL: imageURL, onImageChange: onImageChange, label: label = "Module Image" })=>{
    const idRef = (0, $acw62.useRef)(`img-uploader-${++$da798e28ced8c022$var$_imgUploaderCounter}`);
    const inputId = idRef.current;
    const changeId = `${inputId}-change`;
    const [preview, setPreview] = (0, $acw62.useState)(imageURL || '');
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const [isUploading, setIsUploading] = (0, $acw62.useState)(false);
    const [uploadProgress, setUploadProgress] = (0, $acw62.useState)(0);
    // Sync preview with imageURL prop changes
    (0, $acw62.useEffect)(()=>{
        setPreview(imageURL || '');
    }, [
        imageURL
    ]);
    const handleFileSelect = async (file)=>{
        if (!file) return;
        // Validate file size (max 5MB)
        if (file.size > 5242880) {
            alert('Image size must be less than 5MB');
            return;
        }
        // Validate file type
        if (!file.type.startsWith('image/')) {
            alert('Please upload an image file');
            return;
        }
        try {
            setIsUploading(true);
            setUploadProgress(0);
            // Create preview for immediate feedback
            const reader = new FileReader();
            reader.onloadend = ()=>{
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            // Upload file to server
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/newUploadFile', {
                attachment: [
                    file
                ]
            }, true);
            if (!res || res.code !== 200) throw new Error('Upload failed');
            const uploadedFile = res.body?.result;
            if (!uploadedFile || !uploadedFile.location) throw new Error('Invalid upload response');
            // Get the file URL from the response (S3 location)
            const fileUrl = uploadedFile.location;
            // Update preview and notify parent
            setPreview(fileUrl);
            onImageChange(fileUrl);
            setUploadProgress(100);
        } catch (error) {
            console.error('Upload error:', error);
            alert('Failed to upload image. Please try again.');
            setPreview('');
            onImageChange('');
        } finally{
            setIsUploading(false);
            setTimeout(()=>setUploadProgress(0), 1000);
        }
    };
    const handleChange = (e)=>{
        const file = e.target.files[0];
        handleFileSelect(file);
    };
    const handleDragOver = (e)=>{
        e.preventDefault();
        setIsDragging(true);
    };
    const handleDragLeave = (e)=>{
        e.preventDefault();
        setIsDragging(false);
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        handleFileSelect(file);
    };
    const handleClear = ()=>{
        setPreview('');
        onImageChange('');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df fdc",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                className: "fs0-9rem fw600 c15 mb0-75rem",
                children: label
            }),
            !preview ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onDragOver: handleDragOver,
                onDragLeave: handleDragLeave,
                onDrop: handleDrop,
                className: "br10px bss bw2px cp",
                style: {
                    border: isDragging ? '2px dashed #4CAF50' : '2px dashed #ddd',
                    background: isDragging ? '#f1f8f4' : '#fafafa',
                    padding: '2rem',
                    transition: 'all 0.3s ease',
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "file",
                        accept: "image/*",
                        onChange: handleChange,
                        style: {
                            display: 'none'
                        },
                        id: inputId,
                        disabled: isUploading
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        htmlFor: inputId,
                        className: "df fdc aic jcc cp",
                        style: {
                            cursor: isUploading ? 'not-allowed' : 'pointer',
                            opacity: isUploading ? 0.6 : 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df aic jcc",
                                style: {
                                    width: '64px',
                                    height: '64px',
                                    borderRadius: '50%',
                                    background: isUploading ? 'linear-gradient(135deg, #999 0%, #666 100%)' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    marginBottom: '1rem',
                                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
                                    position: 'relative'
                                },
                                children: isUploading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc aic jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            width: '24px',
                                            height: '24px',
                                            border: '3px solid rgba(255,255,255,0.3)',
                                            borderTop: '3px solid white',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite'
                                        }
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af7008da7e6d6ab9$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '32px',
                                        color: 'white'
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem fw600 mb0-5rem",
                                style: {
                                    color: '#333',
                                    margin: '0 0 0.5rem 0'
                                },
                                children: isUploading ? 'Uploading...' : 'Upload Module Image'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-875rem mb0-75rem",
                                style: {
                                    color: '#666',
                                    margin: '0 0 0.75rem 0'
                                },
                                children: isUploading ? 'Please wait...' : 'Drag and drop or click to browse'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-8rem",
                                style: {
                                    color: '#999',
                                    margin: 0
                                },
                                children: "PNG, JPG up to 5MB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                        children: `
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "br10px p1rem",
                style: {
                    border: '1px solid #e0e0e0',
                    background: '#fafafa',
                    position: 'relative'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100",
                            style: {
                                height: '200px',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                background: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: preview,
                                alt: "Module preview",
                                style: {
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                },
                                onError: (e)=>{
                                    e.target.style.display = 'none';
                                    e.target.parentElement.innerHTML = '<div style="color: #999; font-size: 3rem;">\uD83D\uDDBC\uFE0F</div>';
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic mt1rem",
                            style: {
                                gap: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    htmlFor: changeId,
                                    className: "df aic jcc cp",
                                    style: {
                                        padding: '8px 16px',
                                        borderRadius: '8px',
                                        background: isUploading ? '#999' : '#4CAF50',
                                        color: 'white',
                                        fontSize: '0.875rem',
                                        fontWeight: '500',
                                        border: 'none',
                                        cursor: isUploading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        boxShadow: '0 2px 6px rgba(76, 175, 80, 0.3)',
                                        opacity: isUploading ? 0.6 : 1
                                    },
                                    onMouseOver: (e)=>!isUploading && (e.currentTarget.style.background = '#45a049'),
                                    onMouseOut: (e)=>!isUploading && (e.currentTarget.style.background = '#4CAF50'),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5cf95f1a8b1eba96$export$2e2bcd8739ae039), {
                                            style: {
                                                fontSize: '16px',
                                                marginRight: '6px'
                                            }
                                        }),
                                        isUploading ? 'Uploading...' : 'Change Image'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "file",
                                    accept: "image/*",
                                    onChange: handleChange,
                                    style: {
                                        display: 'none'
                                    },
                                    id: changeId,
                                    disabled: isUploading
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    onClick: handleClear,
                                    disabled: isUploading,
                                    className: "df aic jcc cp",
                                    style: {
                                        padding: '8px 16px',
                                        borderRadius: '8px',
                                        background: 'transparent',
                                        color: '#dc3545',
                                        fontSize: '0.875rem',
                                        fontWeight: '500',
                                        border: '1px solid #dc3545',
                                        cursor: isUploading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s ease',
                                        opacity: isUploading ? 0.6 : 1
                                    },
                                    onMouseOver: (e)=>{
                                        if (!isUploading) {
                                            e.currentTarget.style.background = '#dc3545';
                                            e.currentTarget.style.color = 'white';
                                        }
                                    },
                                    onMouseOut: (e)=>{
                                        if (!isUploading) {
                                            e.currentTarget.style.background = 'transparent';
                                            e.currentTarget.style.color = '#dc3545';
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab8dae130526a9ed$export$2e2bcd8739ae039), {
                                            style: {
                                                fontSize: '16px',
                                                marginRight: '6px'
                                            }
                                        }),
                                        "Remove"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                className: "fs11px c15 op60 mt0-5rem",
                style: {
                    color: '#999'
                },
                children: "Upload an image file for the module icon/logo"
            })
        ]
    });
};
var $da798e28ced8c022$export$2e2bcd8739ae039 = $da798e28ced8c022$var$ImageUploader;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $14b4fcb0e549e7b0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($14b4fcb0e549e7b0$exports, "__esModule", {
    value: true
});
$14b4fcb0e549e7b0$exports.default = void 0;

var $14b4fcb0e549e7b0$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $14b4fcb0e549e7b0$var$_default = $14b4fcb0e549e7b0$exports.default = (0, $14b4fcb0e549e7b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');




var $9cdce5dd83bbf328$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($9cdce5dd83bbf328$exports, "__esModule", {
    value: true
});
$9cdce5dd83bbf328$exports.default = void 0;

var $9cdce5dd83bbf328$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9cdce5dd83bbf328$var$_default = $9cdce5dd83bbf328$exports.default = (0, $9cdce5dd83bbf328$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2M5 8V7h2v3.82C5.84 10.4 5 9.3 5 8m14 0c0 1.3-.84 2.4-2 2.82V7h2z"
}), 'EmojiEvents');


var $a949128807fcb708$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($a949128807fcb708$exports, "__esModule", {
    value: true
});
$a949128807fcb708$exports.default = void 0;

var $a949128807fcb708$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a949128807fcb708$var$_default = $a949128807fcb708$exports.default = (0, $a949128807fcb708$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), 'Info');


var $5e547598bb808d2b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($5e547598bb808d2b$exports, "__esModule", {
    value: true
});
$5e547598bb808d2b$exports.default = void 0;

var $5e547598bb808d2b$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $5e547598bb808d2b$var$_default = $5e547598bb808d2b$exports.default = (0, $5e547598bb808d2b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'DragIndicator');


// ─── Design tokens ──────────────────────────────────────────────────────────
const $b11d3f88abc513b5$var$CERT = {
    none: {
        label: 'None',
        bg: '#F9FAFB',
        border: '#E5E7EB',
        text: '#6B7280',
        badge: '#E5E7EB',
        badgeText: '#374151',
        dot: '#9CA3AF'
    },
    bronze: {
        label: 'Bronze',
        bg: '#FFFBEB',
        border: '#FCD34D',
        text: '#92400E',
        badge: '#FCD34D',
        badgeText: '#78350F',
        dot: '#F59E0B'
    },
    silver: {
        label: 'Silver',
        bg: '#F8FAFC',
        border: '#94A3B8',
        text: '#1E293B',
        badge: '#CBD5E1',
        badgeText: '#1E293B',
        dot: '#94A3B8'
    },
    gold: {
        label: 'Gold',
        bg: '#FFFDF0',
        border: '#FBBF24',
        text: '#78350F',
        badge: '#FDE68A',
        badgeText: '#78350F',
        dot: '#F59E0B'
    }
};
const $b11d3f88abc513b5$var$OPERATORS = [
    {
        value: 'lt',
        label: '< less than'
    },
    {
        value: 'lte',
        label: "\u2264 less than or equal"
    },
    {
        value: 'gt',
        label: '> greater than'
    },
    {
        value: 'gte',
        label: "\u2265 greater than or equal"
    },
    {
        value: 'eq',
        label: '= equals exactly'
    }
];
const $b11d3f88abc513b5$var$OP_SYMBOL = {
    lt: '<',
    lte: "\u2264",
    gt: '>',
    gte: "\u2265",
    eq: '='
};
// ─── Condition helpers ──────────────────────────────────────────────────────
function $b11d3f88abc513b5$var$emptyClause() {
    return {
        op: 'gte',
        value: ''
    };
}
function $b11d3f88abc513b5$var$conditionToEntries(cond) {
    if (!cond || typeof cond !== 'object') return [
        $b11d3f88abc513b5$var$emptyClause()
    ];
    const entries = Object.entries(cond).map(([op, v])=>({
            op: op,
            value: String(v)
        }));
    return entries.length ? entries : [
        $b11d3f88abc513b5$var$emptyClause()
    ];
}
function $b11d3f88abc513b5$var$entriesToCondition(entries) {
    const out = {};
    for (const { op: op, value: value } of entries){
        const n = parseFloat(value);
        if (op && value !== '' && !isNaN(n)) out[op] = n;
    }
    return Object.keys(out).length ? out : null;
}
function $b11d3f88abc513b5$var$ruleToState(rule) {
    return {
        completenessEntries: $b11d3f88abc513b5$var$conditionToEntries(rule?.completeness),
        includeRisk: !!rule?.riskScore,
        riskEntries: rule?.riskScore ? $b11d3f88abc513b5$var$conditionToEntries(rule.riskScore) : [
            $b11d3f88abc513b5$var$emptyClause()
        ],
        certification: rule?.certification || 'none'
    };
}
function $b11d3f88abc513b5$var$stateToRule(s) {
    const completeness = $b11d3f88abc513b5$var$entriesToCondition(s.completenessEntries);
    const riskScore = s.includeRisk ? $b11d3f88abc513b5$var$entriesToCondition(s.riskEntries) : undefined;
    return {
        completeness: completeness,
        ...riskScore ? {
            riskScore: riskScore
        } : {},
        certification: s.certification
    };
}
// ─── Preview evaluator (mirrors backend) ───────────────────────────────────
function $b11d3f88abc513b5$var$evalCond(cond, v) {
    if (!cond) return false;
    for (const [op, t] of Object.entries(cond)){
        const n = Number(t);
        if (op === 'lt' && !(v < n)) return false;
        if (op === 'lte' && !(v <= n)) return false;
        if (op === 'gt' && !(v > n)) return false;
        if (op === 'gte' && !(v >= n)) return false;
        if (op === 'eq' && !(v === n)) return false;
    }
    return true;
}
function $b11d3f88abc513b5$var$evalRules(rules, risk, comp) {
    for (const r of rules){
        if (!r?.completeness) continue;
        if (!$b11d3f88abc513b5$var$evalCond(r.completeness, comp)) continue;
        if (r.riskScore && !$b11d3f88abc513b5$var$evalCond(r.riskScore, risk)) continue;
        return r.certification || 'none';
    }
    return 'none';
}
// ─── Shared small components ────────────────────────────────────────────────
function $b11d3f88abc513b5$var$Badge({ cert: cert }) {
    const t = $b11d3f88abc513b5$var$CERT[cert] || $b11d3f88abc513b5$var$CERT.none;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: '2px 10px',
            borderRadius: '20px',
            background: t.badge,
            color: t.badgeText,
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            border: `1px solid ${t.border}`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    width: 7,
                    height: 7,
                    borderRadius: '50%',
                    background: t.dot,
                    flexShrink: 0
                }
            }),
            t.label
        ]
    });
}
function $b11d3f88abc513b5$var$SectionLabel({ children: children, required: required }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            fontSize: '11px',
            fontWeight: 600,
            color: '#6B7280',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        },
        children: [
            children,
            required && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    color: '#EF4444'
                },
                children: "*"
            })
        ]
    });
}
// ─── ConditionBuilder ───────────────────────────────────────────────────────
function $b11d3f88abc513b5$var$ConditionBuilder({ entries: entries, onChange: onChange }) {
    const update = (i, field, val)=>onChange(entries.map((e, idx)=>idx === i ? {
                ...e,
                [field]: val
            } : e));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '6px'
        },
        children: [
            entries.map((entry, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                            value: entry.op,
                            onChange: (e)=>update(i, 'op', e.target.value),
                            style: {
                                flex: '0 0 auto',
                                height: '34px',
                                padding: '0 8px',
                                border: '1.5px solid #E5E7EB',
                                borderRadius: '6px',
                                fontSize: '13px',
                                background: '#fff',
                                color: '#374151',
                                cursor: 'pointer',
                                outline: 'none'
                            },
                            children: $b11d3f88abc513b5$var$OPERATORS.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: o.value,
                                    children: o.label
                                }, o.value))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                position: 'relative',
                                flex: '1'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "number",
                                    min: "0",
                                    max: "100",
                                    placeholder: "0 \u2013 100",
                                    value: entry.value,
                                    onChange: (e)=>update(i, 'value', e.target.value),
                                    style: {
                                        width: '100%',
                                        height: '34px',
                                        padding: '0 32px 0 10px',
                                        border: '1.5px solid #E5E7EB',
                                        borderRadius: '6px',
                                        fontSize: '13px',
                                        background: '#fff',
                                        color: '#374151',
                                        outline: 'none',
                                        boxSizing: 'border-box'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        fontSize: '11px',
                                        color: '#9CA3AF',
                                        pointerEvents: 'none'
                                    },
                                    children: "%"
                                })
                            ]
                        }),
                        entries.length > 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>onChange(entries.filter((_, idx)=>idx !== i)),
                            title: "Remove clause",
                            style: {
                                border: 'none',
                                background: 'none',
                                cursor: 'pointer',
                                padding: '4px',
                                color: '#F87171',
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: '4px',
                                flexShrink: 0
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                style: {
                                    fontSize: '15px'
                                }
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                width: '23px',
                                flexShrink: 0
                            }
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                type: "button",
                onClick: ()=>onChange([
                        ...entries,
                        $b11d3f88abc513b5$var$emptyClause()
                    ]),
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '4px 10px',
                    border: '1.5px dashed #D1D5DB',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#6B7280',
                    background: 'none',
                    cursor: 'pointer',
                    alignSelf: 'flex-start',
                    marginTop: '2px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                        style: {
                            fontSize: '13px'
                        }
                    }),
                    " AND clause"
                ]
            })
        ]
    });
}
// ─── RuleRow ─────────────────────────────────────────────────────────────────
function $b11d3f88abc513b5$var$RuleRow({ state: state, index: index, total: total, onChange: onChange, onRemove: onRemove, onMoveUp: onMoveUp, onMoveDown: onMoveDown }) {
    const t = $b11d3f88abc513b5$var$CERT[state.certification] || $b11d3f88abc513b5$var$CERT.none;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            border: `1.5px solid ${t.border}`,
            borderRadius: '12px',
            background: t.bg,
            overflow: 'hidden',
            transition: 'box-shadow 0.15s'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px 16px',
                    borderBottom: `1px solid ${t.border}`,
                    background: `${t.bg}`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5e547598bb808d2b$exports))), {
                                style: {
                                    fontSize: '18px',
                                    color: '#D1D5DB',
                                    cursor: 'grab'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    color: '#9CA3AF',
                                    letterSpacing: '0.04em'
                                },
                                children: [
                                    "RULE ",
                                    index + 1
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$Badge, {
                                cert: state.certification
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                disabled: index === 0,
                                onClick: onMoveUp,
                                title: "Move up",
                                style: {
                                    border: 'none',
                                    background: 'none',
                                    cursor: index === 0 ? 'default' : 'pointer',
                                    padding: '4px',
                                    borderRadius: '6px',
                                    opacity: index === 0 ? 0.3 : 0.7,
                                    color: '#374151',
                                    display: 'flex'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e6a1f3d36d8c3d3$exports))), {
                                    style: {
                                        fontSize: '18px'
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                disabled: index === total - 1,
                                onClick: onMoveDown,
                                title: "Move down",
                                style: {
                                    border: 'none',
                                    background: 'none',
                                    cursor: index === total - 1 ? 'default' : 'pointer',
                                    padding: '4px',
                                    borderRadius: '6px',
                                    opacity: index === total - 1 ? 0.3 : 0.7,
                                    color: '#374151',
                                    display: 'flex'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                                    style: {
                                        fontSize: '18px'
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: '1px',
                                    height: '18px',
                                    background: '#E5E7EB',
                                    margin: '0 6px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onRemove,
                                title: "Delete rule",
                                style: {
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '6px',
                                    color: '#F87171',
                                    display: 'flex'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                    style: {
                                        fontSize: '18px'
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '16px',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '16px',
                    alignItems: 'start'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1.5px solid #E5E7EB',
                            borderRadius: '8px',
                            padding: '14px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$SectionLabel, {
                                required: true,
                                children: "Completeness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$ConditionBuilder, {
                                entries: state.completenessEntries,
                                onChange: (entries)=>onChange({
                                        ...state,
                                        completenessEntries: entries
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1.5px solid #E5E7EB',
                            borderRadius: '8px',
                            padding: '14px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '8px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$SectionLabel, {
                                        children: "Risk Score"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            cursor: 'pointer',
                                            userSelect: 'none'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>onChange({
                                                        ...state,
                                                        includeRisk: !state.includeRisk
                                                    }),
                                                style: {
                                                    width: '32px',
                                                    height: '18px',
                                                    borderRadius: '9px',
                                                    position: 'relative',
                                                    background: state.includeRisk ? '#6366F1' : '#D1D5DB',
                                                    cursor: 'pointer',
                                                    transition: 'background 0.2s',
                                                    flexShrink: 0
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        position: 'absolute',
                                                        top: '2px',
                                                        left: state.includeRisk ? '16px' : '2px',
                                                        width: '14px',
                                                        height: '14px',
                                                        borderRadius: '50%',
                                                        background: '#fff',
                                                        transition: 'left 0.2s',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '12px',
                                                    color: '#6B7280'
                                                },
                                                children: state.includeRisk ? 'On' : 'Off'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            state.includeRisk ? /*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$ConditionBuilder, {
                                entries: state.riskEntries,
                                onChange: (entries)=>onChange({
                                        ...state,
                                        riskEntries: entries
                                    })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                style: {
                                    fontSize: '12px',
                                    color: '#9CA3AF',
                                    margin: '4px 0 0',
                                    lineHeight: 1.5
                                },
                                children: "Risk score is not considered for this rule."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            background: '#fff',
                            border: '1.5px solid #E5E7EB',
                            borderRadius: '8px',
                            padding: '14px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$SectionLabel, {
                                required: true,
                                children: "Award Certification"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: '8px'
                                },
                                children: Object.entries($b11d3f88abc513b5$var$CERT).map(([key, tok])=>{
                                    const selected = state.certification === key;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>onChange({
                                                ...state,
                                                certification: key
                                            }),
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            padding: '8px 12px',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            border: selected ? `2px solid ${tok.dot}` : '1.5px solid #E5E7EB',
                                            background: selected ? tok.bg : '#fff',
                                            transition: 'all 0.15s',
                                            boxShadow: selected ? `0 0 0 3px ${tok.badge}` : 'none'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: 10,
                                                    height: 10,
                                                    borderRadius: '50%',
                                                    background: tok.dot,
                                                    flexShrink: 0
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '13px',
                                                    fontWeight: selected ? 700 : 500,
                                                    color: tok.text
                                                },
                                                children: tok.label
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '0 16px 12px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '6px'
                },
                children: [
                    state.completenessEntries.filter((e)=>e.value !== '').map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                fontSize: '11px',
                                padding: '3px 9px',
                                borderRadius: '20px',
                                background: '#EFF6FF',
                                color: '#1D4ED8',
                                border: '1px solid #BFDBFE'
                            },
                            children: [
                                "completeness ",
                                $b11d3f88abc513b5$var$OP_SYMBOL[e.op] || e.op,
                                " ",
                                e.value,
                                "%"
                            ]
                        }, i)),
                    state.includeRisk && state.riskEntries.filter((e)=>e.value !== '').map((e, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            style: {
                                fontSize: '11px',
                                padding: '3px 9px',
                                borderRadius: '20px',
                                background: '#FFF7ED',
                                color: '#C2410C',
                                border: '1px solid #FED7AA'
                            },
                            children: [
                                "risk ",
                                $b11d3f88abc513b5$var$OP_SYMBOL[e.op] || e.op,
                                " ",
                                e.value,
                                "%"
                            ]
                        }, i))
                ]
            })
        ]
    });
}
// ─── Preview table ───────────────────────────────────────────────────────────
const $b11d3f88abc513b5$var$SAMPLES = [
    {
        comp: 0,
        risk: 0,
        label: '0%'
    },
    {
        comp: 25,
        risk: 30,
        label: '25%'
    },
    {
        comp: 50,
        risk: 30,
        label: '50%'
    },
    {
        comp: 67,
        risk: 30,
        label: '67%'
    },
    {
        comp: 75,
        risk: 30,
        label: '75%'
    },
    {
        comp: 75,
        risk: 70,
        label: '75% / high risk'
    },
    {
        comp: 85,
        risk: 20,
        label: '85%'
    },
    {
        comp: 100,
        risk: 20,
        label: '100%'
    },
    {
        comp: 100,
        risk: 70,
        label: '100% / high risk'
    }
];
function $b11d3f88abc513b5$var$PreviewTable({ rules: rules }) {
    const activeRules = rules.filter((r)=>r.completeness !== null);
    if (activeRules.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginTop: '20px',
            border: '1.5px solid #E5E7EB',
            borderRadius: '12px',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    padding: '12px 16px',
                    borderBottom: '1px solid #E5E7EB',
                    background: '#F9FAFB',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a949128807fcb708$exports))), {
                        style: {
                            fontSize: '16px',
                            color: '#6B7280'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '13px',
                            fontWeight: 600,
                            color: '#374151'
                        },
                        children: "Live Preview"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '12px',
                            color: '#9CA3AF'
                        },
                        children: "\u2014 how rules evaluate at sample values"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))'
                },
                children: $b11d3f88abc513b5$var$SAMPLES.map((s, i)=>{
                    const cert = $b11d3f88abc513b5$var$evalRules(activeRules, s.risk, s.comp);
                    const tok = $b11d3f88abc513b5$var$CERT[cert] || $b11d3f88abc513b5$var$CERT.none;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            padding: '10px 14px',
                            borderRight: '1px solid #E5E7EB',
                            borderBottom: '1px solid #E5E7EB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            background: tok.bg
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: '12px',
                                    color: '#6B7280'
                                },
                                children: s.label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$Badge, {
                                cert: cert
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
}
function $b11d3f88abc513b5$export$2e2bcd8739ae039({ rules: rules = [], onChange: onChange }) {
    const [states, setStates] = (0, $acw62.useState)(()=>(rules || []).map($b11d3f88abc513b5$var$ruleToState));
    const [lastKey, setLastKey] = (0, $acw62.useState)(()=>JSON.stringify(rules || []));
    // Sync when parent re-initialises (e.g. module load on edit)
    const nextKey = JSON.stringify(rules || []);
    if (nextKey !== lastKey) {
        setLastKey(nextKey);
        setStates((rules || []).map($b11d3f88abc513b5$var$ruleToState));
    }
    const push = (next)=>{
        setStates(next);
        onChange(next.map($b11d3f88abc513b5$var$stateToRule).filter((r)=>r.completeness !== null));
    };
    const add = ()=>push([
            ...states,
            $b11d3f88abc513b5$var$ruleToState({})
        ]);
    const remove = (i)=>push(states.filter((_, idx)=>idx !== i));
    const update = (i, s)=>push(states.map((x, idx)=>idx === i ? s : x));
    const move = (i, dir)=>{
        const j = i + dir;
        if (j < 0 || j >= states.length) return;
        const next = [
            ...states
        ];
        [next[i], next[j]] = [
            next[j],
            next[i]
        ];
        push(next);
    };
    const builtRules = states.map($b11d3f88abc513b5$var$stateToRule).filter((r)=>r.completeness !== null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '20px',
                    flexWrap: 'wrap',
                    gap: '12px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginBottom: '4px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cdce5dd83bbf328$exports))), {
                                        style: {
                                            fontSize: '20px',
                                            color: '#F59E0B'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        style: {
                                            margin: 0,
                                            fontSize: '15px',
                                            fontWeight: 700,
                                            color: '#111827'
                                        },
                                        children: "Certification Rules"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            fontSize: '11px',
                                            padding: '2px 8px',
                                            background: '#EFF6FF',
                                            color: '#3B82F6',
                                            borderRadius: '20px',
                                            border: '1px solid #BFDBFE',
                                            fontWeight: 600
                                        },
                                        children: [
                                            states.length,
                                            " ",
                                            states.length === 1 ? 'rule' : 'rules'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                style: {
                                    margin: 0,
                                    fontSize: '13px',
                                    color: '#6B7280',
                                    lineHeight: 1.5
                                },
                                children: [
                                    "Rules are evaluated ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "top-to-bottom"
                                    }),
                                    ". First matching rule wins. Completeness is required; risk score is optional per rule."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: add,
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '9px 18px',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            background: '#111827',
                            color: '#fff',
                            border: 'none',
                            fontSize: '13px',
                            fontWeight: 600,
                            whiteSpace: 'nowrap',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                                style: {
                                    fontSize: '16px'
                                }
                            }),
                            " Add Rule"
                        ]
                    })
                ]
            }),
            states.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 14px',
                    borderRadius: '8px',
                    background: '#FFFBEB',
                    border: '1px solid #FCD34D',
                    marginBottom: '16px',
                    fontSize: '12px',
                    color: '#92400E'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a949128807fcb708$exports))), {
                        style: {
                            fontSize: '15px',
                            flexShrink: 0
                        }
                    }),
                    "Rules are checked in order \u2014 place more specific conditions first to avoid them being shadowed by broader ones."
                ]
            }),
            states.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    textAlign: 'center',
                    padding: '48px 24px',
                    border: '2px dashed #E5E7EB',
                    borderRadius: '12px',
                    background: '#FAFAFA'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cdce5dd83bbf328$exports))), {
                        style: {
                            fontSize: '40px',
                            color: '#D1D5DB',
                            display: 'block',
                            margin: '0 auto 12px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            margin: '0 0 4px',
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#6B7280'
                        },
                        children: "No certification rules yet"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            margin: 0,
                            fontSize: '13px',
                            color: '#9CA3AF'
                        },
                        children: [
                            "Click ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "Add Rule"
                            }),
                            " to define when a module earns bronze, silver, or gold."
                        ]
                    })
                ]
            }) : /* ── Rule list ─────────────────────────────────────────── */ /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                },
                children: states.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($b11d3f88abc513b5$var$RuleRow, {
                        index: i,
                        total: states.length,
                        state: s,
                        onChange: (next)=>update(i, next),
                        onRemove: ()=>remove(i),
                        onMoveUp: ()=>move(i, -1),
                        onMoveDown: ()=>move(i, 1)
                    }, i))
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $e633b11a091cb1ab$var$ACCEPTED_EXTS = [
    '.xlsx',
    '.xls',
    '.csv'
];
const $e633b11a091cb1ab$var$OBJECTIVE_LABELS = {
    Investment: 'Inv',
    Growth: 'Gro',
    Exit: 'Exi'
};
const $e633b11a091cb1ab$var$TIER_COLORS = {
    Free: '#4A67FF',
    Lite: '#038589',
    Pro: '#FC7785'
};
/**
 * ExcelUpload
 *
 * Props:
 *   moduleKey        {string}    — current module key
 *   parsedData       {object}    — result from /modules/parse-excel
 *   importedVariants {string[]}  — variant keys that have been applied to state
 *   onParsed         {fn}        — called with parsed body after successful upload
 *   onApply          {fn}        — opens the variant selection modal (first import)
 *   onReselect       {fn}        — opens modal again to change selection
 */ const $e633b11a091cb1ab$var$ExcelUpload = ({ moduleKey: moduleKey, onParsed: onParsed, onApply: onApply, onReselect: onReselect, parsedData: parsedData, importedVariants: importedVariants = [] })=>{
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const [isUploading, setIsUploading] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)('');
    const [fileName, setFileName] = (0, $acw62.useState)('');
    const inputRef = (0, $acw62.useRef)(null);
    const uploadFile = async (file)=>{
        const ext = file.name.split('.').pop().toLowerCase();
        if (!$e633b11a091cb1ab$var$ACCEPTED_EXTS.includes('.' + ext)) {
            setError(`Unsupported file type ".${ext}". Please upload an xlsx, xls, or csv file.`);
            return;
        }
        setIsUploading(true);
        setError('');
        setFileName(file.name);
        try {
            // Read as base64 to avoid conflicts with the global multer middleware
            const base64 = await new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = (e)=>{
                    // result is "data:<mime>;base64,<data>" — strip the prefix
                    const raw = e.target.result;
                    resolve(raw.split(',')[1] || raw);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
            const result = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/parse-excel', {
                fileContent: base64,
                fileName: file.name
            }, true, undefined, true);
            if (result && result['code'] === 200) onParsed(result['body']);
            else setError(result?.['message'] || 'Failed to parse file. Please check the format and try again.');
        } catch (e) {
            setError('Upload failed. Please check your connection and try again.');
        } finally{
            setIsUploading(false);
        }
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer?.files?.[0];
        if (file) uploadFile(file);
    };
    const handleFileInput = (e)=>{
        const file = e.target?.files?.[0];
        if (file) uploadFile(file);
        e.target.value = '';
    };
    const colLabel = {
        section: 'Section',
        subsection: 'Sub-section',
        question: 'Question',
        questionType: 'Question Type',
        tooltip: 'Tool Tip',
        toolbox: 'Tool Box',
        risk: 'Risk Description',
        recommendation: 'Recommendation',
        riskScore: 'Risk Score',
        attachmentRequired: 'Attachment Required',
        options: 'Options',
        ifYes: 'Info if Yes',
        ifNo: 'Info if No',
        riskIfYes: 'Risk if Yes',
        riskIfNo: 'Risk if No',
        reference: 'Reference'
    };
    const handleDownloadTemplate = async ()=>{
        try {
            const authToken = localStorage.getItem('token') || '';
            const authUserId = localStorage.getItem('userId') || '';
            const res = await fetch(`${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api/modules/sample-template`, {
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'id': authUserId
                }
            });
            if (!res.ok) {
                setError('Failed to download template. Please try again.');
                return;
            }
            const blob = await res.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = 'module_import_template.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        } catch (e) {
            setError('Failed to download template. Please try again.');
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df fdc",
        style: {
            gap: '1rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcfe",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    type: "button",
                    onClick: handleDownloadTemplate,
                    className: "df aic br50px px1-25rem py0-5rem fw600 fs0-8rem td300 cp",
                    style: {
                        background: '#fff',
                        border: '1px solid #4A67FF',
                        color: '#4A67FF',
                        gap: '0.4rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                    points: "7 10 12 15 17 10"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                    x1: "12",
                                    y1: "15",
                                    x2: "12",
                                    y2: "3"
                                })
                            ]
                        }),
                        "Download Sample"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onClick: ()=>!isUploading && inputRef.current?.click(),
                onDragOver: (e)=>{
                    e.preventDefault();
                    setIsDragging(true);
                },
                onDragLeave: ()=>setIsDragging(false),
                onDrop: handleDrop,
                className: "df fdc aic jcc br10px bss bw2px cp td300",
                style: {
                    borderColor: isDragging ? '#4A67FF' : '#DDE2F2',
                    background: isDragging ? '#f0f2fd' : '#F5F6F9',
                    minHeight: '160px',
                    gap: '0.75rem',
                    padding: '2rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        ref: inputRef,
                        type: "file",
                        accept: ".xlsx,.xls,.csv",
                        className: "pa",
                        style: {
                            opacity: 0,
                            width: 0,
                            height: 0
                        },
                        onChange: handleFileInput
                    }),
                    isUploading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: 36,
                                    height: 36,
                                    border: '3px solid #4A67FF',
                                    borderTopColor: 'transparent',
                                    borderRadius: '50%',
                                    animation: 'spin 0.8s linear infinite'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs0-9rem fw500 c15 m0",
                                style: {
                                    opacity: 0.7
                                },
                                children: [
                                    "Parsing ",
                                    fileName,
                                    "\u2026"
                                ]
                            })
                        ]
                    }) : parsedData ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "fas fa-check-circle",
                                style: {
                                    fontSize: '2rem',
                                    color: '#40dda1'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-9rem fw600 c15 m0",
                                children: fileName || 'File parsed'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-8rem c15 m0",
                                style: {
                                    opacity: 0.6
                                },
                                children: "Click to replace with a different file"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "fas fa-file-excel",
                                style: {
                                    fontSize: '2.5rem',
                                    color: '#40dda1'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-95rem fw600 c15 m0",
                                        children: "Drop your Excel file here"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-8rem c15 m0 mt0-25rem",
                                        style: {
                                            opacity: 0.6
                                        },
                                        children: "or click to browse \u2014 xlsx, xls, csv"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic br8px p0-75rem",
                style: {
                    background: '#fff0f0',
                    border: '1px solid #FC7785',
                    gap: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        className: "fas fa-exclamation-circle c4"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-85rem c15 m0",
                        children: error
                    })
                ]
            }),
            parsedData && !isUploading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc br10px bss bw1px",
                style: {
                    borderColor: '#DDE2F2',
                    overflow: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb aic px1-5rem py1rem",
                        style: {
                            background: '#f0f2fd',
                            borderBottom: '1px solid #DDE2F2',
                            flexWrap: 'wrap',
                            gap: '0.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '1.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs1-25rem fw600 c3",
                                                children: parsedData['totalSections']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs11px fw500 c15",
                                                style: {
                                                    opacity: 0.6
                                                },
                                                children: "Sections"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs1-25rem fw600 c3",
                                                children: parsedData['totalQuestions']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs11px fw500 c15",
                                                style: {
                                                    opacity: 0.6
                                                },
                                                children: "Questions"
                                            })
                                        ]
                                    }),
                                    parsedData['errors']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs1-25rem fw600 c4",
                                                children: parsedData['errors'].length
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs11px fw500 c15",
                                                style: {
                                                    opacity: 0.6
                                                },
                                                children: "Skipped rows"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            importedVariants.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onApply,
                                className: "br50px px1-5rem py0-5rem fw600 fs0-85rem c1 td250 cp bss bw0px",
                                style: {
                                    background: '#4A67FF'
                                },
                                children: "Select Combinations \u2192"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: onReselect,
                                className: "br50px px1-5rem py0-5rem fw600 fs0-85rem td250 cp",
                                style: {
                                    background: '#fff',
                                    border: '1px solid #4A67FF',
                                    color: '#4A67FF'
                                },
                                children: "Change Selection"
                            })
                        ]
                    }),
                    importedVariants.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px1-5rem py1rem df fdc",
                        style: {
                            gap: '0.75rem',
                            borderBottom: '1px solid #DDE2F2',
                            background: '#e8fdf3'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fas fa-check-circle",
                                        style: {
                                            color: '#09B255',
                                            fontSize: '1rem'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs0-875rem fw600 m0",
                                        style: {
                                            color: '#09B255'
                                        },
                                        children: [
                                            "Ready to save \u2014 ",
                                            parsedData['totalSections'],
                                            " sections \xb7 ",
                                            parsedData['totalQuestions'],
                                            " questions loaded into ",
                                            importedVariants.length,
                                            " combination",
                                            importedVariants.length > 1 ? 's' : ''
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fww",
                                style: {
                                    gap: '0.4rem'
                                },
                                children: importedVariants.map((vk)=>{
                                    const [obj, tier] = vk.split('-');
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "br20px px0-75rem py0-25rem fs11px fw600",
                                        style: {
                                            background: $e633b11a091cb1ab$var$TIER_COLORS[tier] + '20',
                                            border: `1px solid ${$e633b11a091cb1ab$var$TIER_COLORS[tier]}`,
                                            color: $e633b11a091cb1ab$var$TIER_COLORS[tier]
                                        },
                                        children: [
                                            obj,
                                            " \xb7 ",
                                            tier
                                        ]
                                    }, vk);
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs0-8rem c15 m0",
                                style: {
                                    opacity: 0.6
                                },
                                children: [
                                    "Click ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Save Module"
                                    }),
                                    " below to persist these sections to the database."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px1-5rem py1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-8rem fw600 c15 mb0-5rem",
                                style: {
                                    opacity: 0.5,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em'
                                },
                                children: "Detected columns"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fww",
                                style: {
                                    gap: '0.4rem'
                                },
                                children: Object.entries(parsedData['columnMapping'] || {}).map(([key, val])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "br20px px0-75rem py0-25rem fs11px fw500",
                                        style: {
                                            background: val ? '#e8f5e9' : '#fafafa',
                                            border: `1px solid ${val ? '#a5d6a7' : '#e0e0e0'}`,
                                            color: val ? '#2e7d32' : '#bdbdbd'
                                        },
                                        children: [
                                            colLabel[key] || key,
                                            ": ",
                                            val ? `"${val}"` : "\u2014"
                                        ]
                                    }, key))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px1-5rem pb1rem",
                        style: {
                            maxHeight: '220px',
                            overflowY: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-8rem fw600 c15 mb0-5rem",
                                style: {
                                    opacity: 0.5,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em'
                                },
                                children: "Sections"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc",
                                style: {
                                    gap: '0.35rem'
                                },
                                children: (parsedData['sections'] || []).map((sec, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic",
                                        style: {
                                            padding: '0.3rem 0',
                                            borderBottom: '1px solid #f0f0f0'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-85rem c15",
                                                style: {
                                                    opacity: 0.85
                                                },
                                                children: sec['sectionName']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs11px fw600 br20px px0-5rem py0-15rem",
                                                style: {
                                                    background: '#e8eaf6',
                                                    color: '#3949ab'
                                                },
                                                children: sec['questions']?.length || 0
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    parsedData['errors']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px1-5rem pb1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-8rem fw600 c4 mb0-5rem",
                                children: "Skipped rows"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc",
                                style: {
                                    gap: '0.25rem',
                                    maxHeight: '80px',
                                    overflowY: 'auto'
                                },
                                children: parsedData['errors'].map((err, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs11px c15 m0",
                                        style: {
                                            opacity: 0.65
                                        },
                                        children: [
                                            "Line ",
                                            err['line'],
                                            ": ",
                                            err['message']
                                        ]
                                    }, i))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e633b11a091cb1ab$export$2e2bcd8739ae039 = $e633b11a091cb1ab$var$ExcelUpload;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $af3346b9c959d0b3$var$OBJECTIVES = [
    'Investment',
    'Growth',
    'Exit'
];
const $af3346b9c959d0b3$var$TIERS = [
    'Free',
    'Lite',
    'Pro'
];
const $af3346b9c959d0b3$var$variantKey = (obj, tier)=>`${obj}-${tier}`;
const $af3346b9c959d0b3$var$ALL_VARIANTS = $af3346b9c959d0b3$var$OBJECTIVES.flatMap((obj)=>$af3346b9c959d0b3$var$TIERS.map((tier)=>$af3346b9c959d0b3$var$variantKey(obj, tier)));
const $af3346b9c959d0b3$var$TIER_COLORS = {
    Free: '#4A67FF',
    Lite: '#038589',
    Pro: '#FC7785'
};
const $af3346b9c959d0b3$var$ExcelVariantModal = ({ open: open, parsedData: parsedData, moduleKey: moduleKey, onConfirm: onConfirm, onClose: onClose })=>{
    // All unchecked by default
    const [selected, setSelected] = (0, $acw62.useState)(new Set());
    if (!open) return null;
    const toggle = (key)=>{
        setSelected((prev)=>{
            const next = new Set(prev);
            if (next.has(key)) next.delete(key);
            else next.add(key);
            return next;
        });
    };
    const toggleAll = ()=>{
        if (selected.size === $af3346b9c959d0b3$var$ALL_VARIANTS.length) setSelected(new Set());
        else setSelected(new Set($af3346b9c959d0b3$var$ALL_VARIANTS));
    };
    const toggleObjective = (obj)=>{
        const objKeys = $af3346b9c959d0b3$var$TIERS.map((t)=>$af3346b9c959d0b3$var$variantKey(obj, t));
        const allSelected = objKeys.every((k)=>selected.has(k));
        setSelected((prev)=>{
            const next = new Set(prev);
            if (allSelected) objKeys.forEach((k)=>next.delete(k));
            else objKeys.forEach((k)=>next.add(k));
            return next;
        });
    };
    const toggleTier = (tier)=>{
        const tierKeys = $af3346b9c959d0b3$var$OBJECTIVES.map((o)=>$af3346b9c959d0b3$var$variantKey(o, tier));
        const allSelected = tierKeys.every((k)=>selected.has(k));
        setSelected((prev)=>{
            const next = new Set(prev);
            if (allSelected) tierKeys.forEach((k)=>next.delete(k));
            else tierKeys.forEach((k)=>next.add(k));
            return next;
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "pf t0 l0 w100 h100 df aic jcc",
        style: {
            background: 'rgba(0,0,0,0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 9999
        },
        onClick: (e)=>{
            if (e.target === e.currentTarget) onClose();
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg1 df fdc br20px shadow",
            style: {
                width: '90%',
                maxWidth: '600px',
                maxHeight: '90vh',
                overflowY: 'auto'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px2rem pt2rem pb1-5rem",
                    style: {
                        borderBottom: '1px solid #DDE2F2'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "fs1-25rem fw600 c15 m0",
                            children: "Apply to Combinations"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "fs0-85rem c15 m0 mt0-25rem",
                            style: {
                                opacity: 0.6
                            },
                            children: [
                                "Select which objective \xd7 subscription tier combinations will receive the ",
                                parsedData?.['totalSections'] || 0,
                                " sections and ",
                                parsedData?.['totalQuestions'] || 0,
                                " questions."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px2rem py1-5rem df fdc",
                    style: {
                        gap: '1.25rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fs0-85rem fw500 c15",
                                    style: {
                                        opacity: 0.65
                                    },
                                    children: [
                                        selected.size,
                                        " of ",
                                        $af3346b9c959d0b3$var$ALL_VARIANTS.length,
                                        " selected"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: toggleAll,
                                    className: "fs0-8rem fw600 cp br20px px1rem py0-35rem td300",
                                    style: {
                                        border: '1px solid #DDE2F2',
                                        background: '#fff',
                                        color: '#4A67FF'
                                    },
                                    children: selected.size === $af3346b9c959d0b3$var$ALL_VARIANTS.length ? 'Deselect all' : 'Select all'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: '130px 1fr 1fr 1fr',
                                gap: '8px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                $af3346b9c959d0b3$var$TIERS.map((tier)=>{
                                    const allTierSelected = $af3346b9c959d0b3$var$OBJECTIVES.every((o)=>selected.has($af3346b9c959d0b3$var$variantKey(o, tier)));
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>toggleTier(tier),
                                        className: "tac fw600 fs0-85rem br8px py0-5rem td300 cp",
                                        style: {
                                            border: `2px solid ${allTierSelected ? $af3346b9c959d0b3$var$TIER_COLORS[tier] : '#DDE2F2'}`,
                                            background: allTierSelected ? $af3346b9c959d0b3$var$TIER_COLORS[tier] : '#fafafa',
                                            color: allTierSelected ? '#fff' : '#505050'
                                        },
                                        children: tier
                                    }, tier);
                                }),
                                $af3346b9c959d0b3$var$OBJECTIVES.map((obj)=>{
                                    const allObjSelected = $af3346b9c959d0b3$var$TIERS.every((t)=>selected.has($af3346b9c959d0b3$var$variantKey(obj, t)));
                                    return [
                                        /* Objective label button */ /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>toggleObjective(obj),
                                            className: "fw600 fs0-85rem br8px px0-75rem tal td300 cp",
                                            style: {
                                                border: `2px solid ${allObjSelected ? '#002D63' : '#DDE2F2'}`,
                                                background: allObjSelected ? '#002D63' : '#fafafa',
                                                color: allObjSelected ? '#fff' : '#505050',
                                                height: '52px'
                                            },
                                            children: obj
                                        }, `obj-${obj}`),
                                        /* Checkbox cell per tier */ ...$af3346b9c959d0b3$var$TIERS.map((tier)=>{
                                            const key = $af3346b9c959d0b3$var$variantKey(obj, tier);
                                            const isChecked = selected.has(key);
                                            const color = $af3346b9c959d0b3$var$TIER_COLORS[tier];
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>toggle(key),
                                                className: "df aic jcc br8px td300 cp",
                                                style: {
                                                    height: '52px',
                                                    border: `2px solid ${isChecked ? color : '#DDE2F2'}`,
                                                    background: isChecked ? color + '18' : '#fafafa'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df aic jcc",
                                                    style: {
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: 4,
                                                        border: `2px solid ${isChecked ? color : '#AAACB5'}`,
                                                        background: isChecked ? color : '#fff',
                                                        flexShrink: 0
                                                    },
                                                    children: isChecked && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        width: "11",
                                                        height: "9",
                                                        viewBox: "0 0 11 9",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M1 4L4 7.5L10 1",
                                                            stroke: "#fff",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                })
                                            }, key);
                                        })
                                    ];
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic br8px p0-75rem",
                            style: {
                                background: '#f0f2fd',
                                border: '1px solid #c7d2fe',
                                gap: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fas fa-info-circle",
                                    style: {
                                        color: '#4A67FF',
                                        flexShrink: 0
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-8rem fw500 m0",
                                    style: {
                                        color: '#3730a3'
                                    },
                                    children: [
                                        "Sections will be numbered using module key ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: moduleKey || 'KEY'
                                        }),
                                        ' ',
                                        "(e.g. ",
                                        moduleKey || 'KEY',
                                        "001, ",
                                        moduleKey || 'KEY',
                                        "001.1). Each selected combination gets the full set of sections."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px2rem pb2rem df jcfe aic",
                    style: {
                        gap: '0.75rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            className: "br50px px1-5rem py0-75rem fw500 fs0-9rem cp td300",
                            style: {
                                border: '1px solid #DDE2F2',
                                background: '#fff',
                                color: '#505050'
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            disabled: selected.size === 0,
                            onClick: ()=>onConfirm([
                                    ...selected
                                ]),
                            className: "br50px px2rem py0-75rem fw600 fs0-9rem c1 td300",
                            style: {
                                background: selected.size === 0 ? '#D9D9D9' : '#4A67FF',
                                border: 'none',
                                cursor: selected.size === 0 ? 'not-allowed' : 'pointer'
                            },
                            children: selected.size === 0 ? 'Select combinations to continue' : `Import to ${selected.size} combination${selected.size > 1 ? 's' : ''}`
                        })
                    ]
                })
            ]
        })
    });
};
var $af3346b9c959d0b3$export$2e2bcd8739ae039 = $af3346b9c959d0b3$var$ExcelVariantModal;



var $acw62 = parcelRequire("acw62");

const $d01221ba05bed299$export$7699c3c70698af94 = ()=>{
    const [cards, setCards] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const fetchCards = (0, $acw62.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/dashboard-cards');
            if (response && response.code === 200) {
                const body = response.body || {};
                setCards(Array.isArray(body.cards) ? body.cards : []);
            } else setCards([]);
        } catch (error) {
            console.error('Error fetching dashboard cards:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to load dashboard cards');
            setCards([]);
        } finally{
            setIsLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchCards();
    }, [
        fetchCards
    ]);
    const createCard = async (data)=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/dashboard-cards', data);
            if (res && res.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message || 'Dashboard card created successfully');
                await fetchCards();
                return {
                    success: true,
                    data: res.body
                };
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to create dashboard card');
            return {
                success: false
            };
        } catch (error) {
            console.error('Error creating dashboard card:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create dashboard card');
            return {
                success: false
            };
        }
    };
    const updateCard = async (data)=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)('/modules/dashboard-cards', data);
            if (res && res.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message || 'Dashboard card updated successfully');
                await fetchCards();
                return {
                    success: true,
                    data: res.body
                };
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to update dashboard card');
            return {
                success: false
            };
        } catch (error) {
            console.error('Error updating dashboard card:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to update dashboard card');
            return {
                success: false
            };
        }
    };
    const deleteCard = async (id)=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/dashboard-cards/${id}`);
            if (res && res.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message || 'Dashboard card deleted successfully');
                await fetchCards();
                return true;
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to delete dashboard card');
            return false;
        } catch (error) {
            console.error('Error deleting dashboard card:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to delete dashboard card');
            return false;
        }
    };
    return {
        cards: cards,
        isLoading: isLoading,
        fetchCards: fetchCards,
        createCard: createCard,
        updateCard: updateCard,
        deleteCard: deleteCard
    };
};






/** Company objectives (tabs) – same as Company Objective in company settings */ const $7cde4a2f681457f4$var$COMPANY_OBJECTIVES = [
    'Investment',
    'Growth',
    'Exit'
];
/** Subscription tiers for section tabs (Free, Lite, Pro; All for "all tiers") */ const $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS = [
    'Free',
    'Lite',
    'Pro'
];
const $7cde4a2f681457f4$var$OBJECTIVE_ALL = 'All';
const $7cde4a2f681457f4$var$TIER_ALL = 'All';
const $7cde4a2f681457f4$var$getVariantKey = (objective, tier)=>`${objective}-${tier}`;
/** Resolve variant key string back to objective + tier (for sectionAccessRestrictions payload). */ function $7cde4a2f681457f4$var$parseVariantKey(variantKey) {
    for (const obj of $7cde4a2f681457f4$var$COMPANY_OBJECTIVES)for (const tier of $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS){
        if ($7cde4a2f681457f4$var$getVariantKey(obj, tier) === variantKey) return {
            objective: obj,
            tier: tier
        };
    }
    if (variantKey === $7cde4a2f681457f4$var$getVariantKey($7cde4a2f681457f4$var$OBJECTIVE_ALL, $7cde4a2f681457f4$var$TIER_ALL)) return {
        objective: $7cde4a2f681457f4$var$OBJECTIVE_ALL,
        tier: $7cde4a2f681457f4$var$TIER_ALL
    };
    return null;
}
const $7cde4a2f681457f4$var$emptySectionRestrictions = ()=>{
    const o = {};
    $7cde4a2f681457f4$var$COMPANY_OBJECTIVES.forEach((obj)=>{
        $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS.forEach((tier)=>{
            o[$7cde4a2f681457f4$var$getVariantKey(obj, tier)] = false;
        });
    });
    o[$7cde4a2f681457f4$var$getVariantKey($7cde4a2f681457f4$var$OBJECTIVE_ALL, $7cde4a2f681457f4$var$TIER_ALL)] = false;
    return o;
};
const $7cde4a2f681457f4$var$moduleFormSchema = $cda9d0e1103d595f$export$be5493f9613cbbe().shape({
    moduleName: $cda9d0e1103d595f$export$22b082955e083ec3().required('Module name is required').min(3, 'Module name must be at least 3 characters').max(100, 'Module name cannot exceed 100 characters'),
    moduleKey: $cda9d0e1103d595f$export$22b082955e083ec3().required('Module key is required').min(2, 'Module key must be at least 2 characters').max(16, 'Module key cannot exceed 16 characters').matches(/^[A-Z0-9]+$/, 'Module key can only contain uppercase letters and numbers'),
    slug: $cda9d0e1103d595f$export$22b082955e083ec3(),
    moduleSubTitle: $cda9d0e1103d595f$export$22b082955e083ec3().max(100, 'Subtitle cannot exceed 100 characters'),
    moduleTagColor: $cda9d0e1103d595f$export$22b082955e083ec3().transform((v)=>v == null ? '' : String(v).trim()).max(7, 'Colour value is too long').matches(/^$|^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/, 'Use a hex colour like #4A67FF or leave blank'),
    moduleDescription: $cda9d0e1103d595f$export$22b082955e083ec3().max(500, 'Description cannot exceed 500 characters'),
    imageURL: $cda9d0e1103d595f$export$22b082955e083ec3().nullable(),
    type: $cda9d0e1103d595f$export$22b082955e083ec3().required('Module type is required').oneOf([
        'common',
        'unique',
        'admin',
        'partner',
        'internal',
        'external'
    ], 'Invalid module type'),
    dashboardCardId: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().transform((value)=>value === '' ? null : value),
    isActive: $cda9d0e1103d595f$export$87b259aa03e3d267().required('Active status is required'),
    isReportModule: $cda9d0e1103d595f$export$87b259aa03e3d267(),
    isCustomSection: $cda9d0e1103d595f$export$87b259aa03e3d267(),
    isDirectorsModule: $cda9d0e1103d595f$export$87b259aa03e3d267(),
    isPaid: $cda9d0e1103d595f$export$87b259aa03e3d267(),
    price: $cda9d0e1103d595f$export$22b082955e083ec3().nullable().when('isPaid', {
        is: true,
        then: (schema)=>schema.required('Price amount is required when module is paid'),
        otherwise: (schema)=>schema.optional().nullable()
    })
});
const $7cde4a2f681457f4$var$ModuleForm = ({ moduleData: moduleData, onFormChange: onFormChange, onSubmit: onSubmit, onCancel: onCancel, isEdit: isEdit = false, onPriorityComplete: onPriorityComplete })=>{
    const DELETE_DEBOUNCE_MS = 3000;
    const deleteLocksRef = (0, $acw62.useRef)(new Map());
    const deleteUnlockersRef = (0, $acw62.useRef)(new Map());
    const sectionDeleteQueueRef = (0, $acw62.useRef)(new Map());
    // Track which existing sections (by _id) have been modified
    const dirtySectionIdsRef = (0, $acw62.useRef)(new Set());
    // When moduleKey changes, all section numbers update so every section must be saved
    const allSectionsDirtyRef = (0, $acw62.useRef)(false);
    const [pendingSectionDeleteKeys, setPendingSectionDeleteKeys] = (0, $acw62.useState)(new Set());
    // Sections grouped by Company Objective + Subscription Tier (e.g. "Investment-Free")
    const emptySectionsByVariant = ()=>{
        const o = {};
        $7cde4a2f681457f4$var$COMPANY_OBJECTIVES.forEach((obj)=>{
            $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS.forEach((tier)=>{
                o[$7cde4a2f681457f4$var$getVariantKey(obj, tier)] = [];
            });
        });
        o[$7cde4a2f681457f4$var$getVariantKey($7cde4a2f681457f4$var$OBJECTIVE_ALL, $7cde4a2f681457f4$var$TIER_ALL)] = []; // Sections that apply to all
        return o;
    };
    const [sectionsByVariant, setSectionsByVariant] = (0, $acw62.useState)(emptySectionsByVariant());
    // Per-objective/per-tier dashboard card placement
    const [placementsByVariant, setPlacementsByVariant] = (0, $acw62.useState)({});
    /** Per objective+tier: when true, sections for that combo are not exposed to end users */ const [sectionRestrictionsByVariant, setSectionRestrictionsByVariant] = (0, $acw62.useState)($7cde4a2f681457f4$var$emptySectionRestrictions());
    const [sectionErrors, setSectionErrors] = (0, $acw62.useState)({}); // key: variantKey-sectionIndex
    const [expandedSectionIndex, setExpandedSectionIndex] = (0, $acw62.useState)(0);
    const [isModuleKeyManuallyEdited, setIsModuleKeyManuallyEdited] = (0, $acw62.useState)(false);
    const [tab, setTab] = (0, $acw62.useState)('Repository');
    const [selectedObjective, setSelectedObjective] = (0, $acw62.useState)('Investment');
    const [selectedTier, setSelectedTier] = (0, $acw62.useState)('Free');
    const [cloneModalOpen, setCloneModalOpen] = (0, $acw62.useState)(false);
    const [cloneMode, setCloneMode] = (0, $acw62.useState)('bulk'); // 'bulk' | 'single'
    const [cloneSection, setCloneSection] = (0, $acw62.useState)(null); // for single section clone
    const [cloneTargets, setCloneTargets] = (0, $acw62.useState)([]); // selected variant keys to clone into
    const [cloneView, setCloneView] = (0, $acw62.useState)('select'); // 'select' | 'conflict'
    const [cloneConflictConflicts, setCloneConflictConflicts] = (0, $acw62.useState)([]); // [{ sectionNo, objective, tier }]
    const { cards: dashboardCards } = (0, $d01221ba05bed299$export$7699c3c70698af94)();
    const [certificationRules, setCertificationRules] = (0, $acw62.useState)(Array.isArray(moduleData?.certificationRules) ? moduleData.certificationRules : []);
    const [isPriorityLoading, setIsPriorityLoading] = (0, $acw62.useState)(false);
    const [hasPrioritiesAlreadySet, setHasPrioritiesAlreadySet] = (0, $acw62.useState)(false);
    const [showPriorityConfirm, setShowPriorityConfirm] = (0, $acw62.useState)(false);
    const [jobSummary, setJobSummary] = (0, $acw62.useState)(null);
    const [sectionProgress, setSectionProgress] = (0, $acw62.useState)({});
    const [sectionOrder, setSectionOrder] = (0, $acw62.useState)([]);
    const moduleIdRef = (0, $acw62.useRef)(moduleData?.['_id']);
    moduleIdRef.current = moduleData?.['_id'];
    const toastedPriorityRef = (0, $acw62.useRef)(false);
    const onPriorityCompleteRef = (0, $acw62.useRef)(onPriorityComplete);
    onPriorityCompleteRef.current = onPriorityComplete;
    const [isSocketConnected, setIsSocketConnected] = (0, $acw62.useState)(()=>!!((0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039) && (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).connected));
    (0, $acw62.useEffect)(()=>{
        if (!(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)) return;
        const isThisModule = (payload)=>{
            if (!payload?.['moduleId'] || !moduleIdRef.current) return true;
            return String(payload['moduleId']) === String(moduleIdRef.current);
        };
        const applySections = (sections)=>{
            if (!Array.isArray(sections) || !sections.length) return;
            const next = {};
            const order = [];
            const seen = new Set();
            sections.forEach((s)=>{
                if (!s || !s['sectionId']) return;
                if (seen.has(s['sectionId'])) return;
                seen.add(s['sectionId']);
                const total = s['total'] || 0;
                const assigned = s['assigned'] || 0;
                next[s['sectionId']] = {
                    ...s,
                    total: total,
                    assigned: assigned,
                    percentage: s['percentage'] ?? (total > 0 ? Math.round(assigned / total * 100) : 0)
                };
                order.push(s['sectionId']);
            });
            setSectionProgress(next);
            setSectionOrder(order);
        };
        const applySnapshot = (payload)=>{
            if (!payload || !isThisModule(payload)) return;
            applySections(payload['sections']);
            const status = payload['status'] || payload['phase'] || 'running';
            setJobSummary({
                moduleName: payload['moduleName'] || 'Module',
                total: payload['total'] || 0,
                totalBatches: payload['totalBatches'] || 0,
                updated: payload['updated'] || 0,
                status: status === 'complete' ? 'complete' : status === 'error' ? 'error' : 'running'
            });
            if (status === 'complete') {
                setIsPriorityLoading(false);
                setHasPrioritiesAlreadySet(true);
            } else if (status === 'error') setIsPriorityLoading(false);
            else setIsPriorityLoading(true);
        };
        const onStart = (payload)=>{
            if (!isThisModule(payload)) return;
            toastedPriorityRef.current = false;
            applySections(payload['sections']);
            setJobSummary({
                moduleName: payload['moduleName'],
                total: payload['total'] || 0,
                totalBatches: payload['totalBatches'],
                updated: 0,
                status: 'running'
            });
            setIsPriorityLoading(true);
        };
        const onSectionProgress = (payload)=>{
            if (!payload || !isThisModule(payload)) return;
            const sid = payload['sectionId'];
            if (sid) {
                setSectionProgress((prev)=>({
                        ...prev,
                        [sid]: {
                            sectionId: sid,
                            sectionName: payload['sectionName'],
                            objective: payload['objective'],
                            tier: payload['tier'],
                            total: payload['total'] || 0,
                            assigned: payload['assigned'] || 0,
                            percentage: payload['percentage'] || 0
                        }
                    }));
                setSectionOrder((prev)=>prev.includes(sid) ? prev : [
                        ...prev,
                        sid
                    ]);
            }
            setJobSummary((prev)=>({
                    ...prev || {},
                    moduleName: payload['moduleName'] || prev?.['moduleName'] || 'Module',
                    total: payload['jobTotal'] != null ? payload['jobTotal'] : prev?.['total'] || 0,
                    updated: payload['jobUpdated'] != null ? payload['jobUpdated'] : prev?.['updated'] || 0,
                    status: 'running'
                }));
            setIsPriorityLoading(true);
        };
        const onComplete = (payload)=>{
            if (payload && !isThisModule(payload)) return;
            setJobSummary((prev)=>({
                    ...prev || {},
                    status: 'complete',
                    updated: payload?.['updated'],
                    total: payload?.['total'] != null ? payload['total'] : prev?.['total']
                }));
            setIsPriorityLoading(false);
            setHasPrioritiesAlreadySet(true);
            if (!toastedPriorityRef.current) {
                toastedPriorityRef.current = true;
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Priorities set for ${payload?.['updated'] || 0} of ${payload?.['total'] || 0} questions`, 'success');
            }
            // Reload module data so question priority dropdowns reflect the newly-set values.
            if (onPriorityCompleteRef.current) onPriorityCompleteRef.current();
        };
        const onError = (payload)=>{
            if (payload && !isThisModule(payload)) return;
            setJobSummary((prev)=>({
                    ...prev || {},
                    status: 'error',
                    errorMsg: payload?.['error']
                }));
            setIsPriorityLoading(false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Priority setting failed', 'error');
        };
        const requestStatus = ()=>(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).emit('priorityGeneration:getStatus', {
                userId: (0, $bebe1cbb5a309c8c$export$d9aa71f96dda8d28) || localStorage.getItem('userId')
            });
        const onConnect = ()=>{
            setIsSocketConnected(true);
            requestStatus();
        };
        const onDisconnect = ()=>setIsSocketConnected(false);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('priorityGeneration:start', onStart);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('priorityGeneration:sectionProgress', onSectionProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('priorityGeneration:complete', onComplete);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('priorityGeneration:error', onError);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('priorityGeneration:currentStatus', applySnapshot);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('connect', onConnect);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('disconnect', onDisconnect);
        if ((0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).connected) requestStatus();
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('priorityGeneration:start', onStart);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('priorityGeneration:sectionProgress', onSectionProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('priorityGeneration:complete', onComplete);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('priorityGeneration:error', onError);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('priorityGeneration:currentStatus', applySnapshot);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('connect', onConnect);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('disconnect', onDisconnect);
        };
    }, []);
    // Initialise hasPrioritiesAlreadySet from the DB on form open so the confirm modal
    // shows even if the admin hasn't triggered a priority run in this browser session.
    (0, $acw62.useEffect)(()=>{
        if (!isEdit || !moduleData?.['_id']) return;
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/${moduleData['_id']}/priority-status`, 'not-showMessage').then((res)=>{
            if (res?.['body']?.['hasPrioritiesSet']) setHasPrioritiesAlreadySet(true);
        }).catch(()=>{});
    }, []);
    const doSetPriorities = async ()=>{
        if (!moduleData?.['_id'] || isPriorityLoading) return;
        toastedPriorityRef.current = false;
        setSectionProgress({});
        setSectionOrder([]);
        setJobSummary({
            moduleName: moduleData['moduleName'] || 'Module',
            total: 0,
            updated: 0,
            status: 'starting'
        });
        setIsPriorityLoading(true);
        try {
            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/set-question-priorities', {
                moduleId: moduleData['_id']
            }, true);
        // isPriorityLoading cleared by priorityGeneration:complete / priorityGeneration:error socket events
        } catch  {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to start priority setting', 'error');
            setIsPriorityLoading(false);
        }
    };
    const handleSetPriorities = ()=>{
        if (!moduleData?.['_id'] || isPriorityLoading) return;
        if (hasPrioritiesAlreadySet) {
            setShowPriorityConfirm(true);
            return;
        }
        doSetPriorities();
    };
    const handleConfirmPriorityRegen = ()=>{
        setShowPriorityConfirm(false);
        doSetPriorities();
    };
    // Reason: only dismiss the progress card — never reset the module form.
    const handleClearPriorityProgress = (e)=>{
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setJobSummary(null);
        setSectionProgress({});
        setSectionOrder([]);
    };
    // ── AI generation mode (create-only) ──────────────────────────────────────
    // 'manual' = existing flow (sections entered by admin)
    // 'ai'     = GPT generates all sections/questions after module is saved
    const [generationMode, setGenerationMode] = (0, $acw62.useState)('manual');
    const [aiConfig, setAiConfig] = (0, $acw62.useState)({
        sectionsPerCombo: 5,
        questionsPerSection: 10
    });
    const [excelParsedData, setExcelParsedData] = (0, $acw62.useState)(null);
    const [excelVariantModalOpen, setExcelVariantModalOpen] = (0, $acw62.useState)(false);
    const [excelImportedVariants, setExcelImportedVariants] = (0, $acw62.useState)([]);
    const currentVariantKey = $7cde4a2f681457f4$var$getVariantKey(selectedObjective, selectedTier);
    // Investment Readiness modules (moduleKey === 'EHE') skip sections/objectives entirely
    // and render the 25 EHE questions directly for inline editing.
    const isInvestmentReadiness = isEdit && moduleData?.slug === 'Investment Readiness';
    const irQuestionsRef = (0, $acw62.useRef)(null);
    // Exit Readiness module skips sections/objectives and renders questions from the
    // production Module + Section + Question tables directly for inline editing.
    const isExitReadiness = isEdit && moduleData?.moduleName === 'Exit Readiness';
    // Investor Lead module (slug === 'investor-lead') renders the DEPF008 section
    // and its questions from the production Section + Question tables directly.
    const isInvestorLead = isEdit && moduleData?.slug === 'investor-lead';
    // Clone targets include all objective+tier variants except current source variant.
    const getCloneTargetOptions = ()=>{
        const options = [];
        $7cde4a2f681457f4$var$COMPANY_OBJECTIVES.forEach((objective)=>{
            $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS.forEach((tier)=>{
                const key = $7cde4a2f681457f4$var$getVariantKey(objective, tier);
                if (key !== currentVariantKey) options.push({
                    key: key,
                    objective: objective,
                    tier: tier,
                    label: `${objective} \u{2192} ${tier}`
                });
            });
        });
        if (currentVariantKey !== $7cde4a2f681457f4$var$getVariantKey($7cde4a2f681457f4$var$OBJECTIVE_ALL, $7cde4a2f681457f4$var$TIER_ALL)) options.push({
            key: $7cde4a2f681457f4$var$getVariantKey($7cde4a2f681457f4$var$OBJECTIVE_ALL, $7cde4a2f681457f4$var$TIER_ALL),
            objective: $7cde4a2f681457f4$var$OBJECTIVE_ALL,
            tier: $7cde4a2f681457f4$var$TIER_ALL,
            label: `${$7cde4a2f681457f4$var$OBJECTIVE_ALL} \u{2192} ${$7cde4a2f681457f4$var$TIER_ALL}`
        });
        return options;
    };
    const cloneTargetOptions = getCloneTargetOptions();
    // Fall back to {objective}-All then All-All when the exact variant has no sections.
    // BA and similar modules store sections with subscriptionTier='All', so their keys
    // are Investment-All / Growth-All / Exit-All rather than the 9 standard combos.
    const effectiveVariantKey = sectionsByVariant[currentVariantKey]?.length ? currentVariantKey : sectionsByVariant[$7cde4a2f681457f4$var$getVariantKey(selectedObjective, $7cde4a2f681457f4$var$TIER_ALL)]?.length ? $7cde4a2f681457f4$var$getVariantKey(selectedObjective, $7cde4a2f681457f4$var$TIER_ALL) : sectionsByVariant[$7cde4a2f681457f4$var$getVariantKey($7cde4a2f681457f4$var$OBJECTIVE_ALL, $7cde4a2f681457f4$var$TIER_ALL)]?.length ? $7cde4a2f681457f4$var$getVariantKey($7cde4a2f681457f4$var$OBJECTIVE_ALL, $7cde4a2f681457f4$var$TIER_ALL) : currentVariantKey;
    const currentSections = sectionsByVariant[effectiveVariantKey] || [];
    const defaultValues = {
        moduleName: '',
        moduleKey: '',
        slug: '',
        moduleSubTitle: '',
        moduleTagColor: '',
        moduleDescription: '',
        imageURL: '',
        type: 'common',
        dashboardCardId: '',
        isActive: true,
        isReportModule: false,
        isCustomSection: false,
        isPaid: false,
        price: '',
        menusConfig: [],
        duration: 'NIL',
        completeness: 'No',
        risks: 'No',
        passFail: 'No',
        certification: 'No',
        report: 'No',
        workflowReport: 'No'
    };
    const { register: register, handleSubmit: handleSubmit, watch: watch, setValue: setValue, reset: reset, formState: { errors: errors } } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        resolver: (0, $0df32c3dd3ad0e0c$export$d55832dfcd4989a)($7cde4a2f681457f4$var$moduleFormSchema),
        mode: 'onChange',
        defaultValues: moduleData && isEdit ? {
            moduleName: moduleData.moduleName || '',
            moduleKey: moduleData.moduleKey || '',
            slug: (moduleData.slug || '').replace(/^#/, ''),
            moduleSubTitle: moduleData.moduleSubTitle || '',
            moduleTagColor: moduleData.moduleTagColor || '',
            moduleDescription: moduleData.moduleDescription || '',
            imageURL: moduleData.imageURL || '',
            type: moduleData.type || 'common',
            dashboardCardId: moduleData.dashboardCardId ? String(moduleData.dashboardCardId) : '',
            isActive: moduleData.isActive !== undefined ? moduleData.isActive : true,
            isReportModule: moduleData.isReportModule !== undefined ? moduleData.isReportModule : false,
            isCustomSection: moduleData.isCustomSection !== undefined ? moduleData.isCustomSection : false,
            isDirectorsModule: moduleData.isDirectorsModule !== undefined ? moduleData.isDirectorsModule : false,
            isPaid: moduleData.isPaid || false,
            price: moduleData.price || '',
            menusConfig: moduleData.menusConfig || [],
            duration: moduleData.duration || 'NIL',
            completeness: moduleData.completeness || 'No',
            risks: moduleData.risks || 'No',
            passFail: moduleData.passFail || 'No',
            certification: moduleData.certification || 'No',
            report: moduleData.report || 'No',
            workflowReport: moduleData.workflowReport || 'No'
        } : defaultValues
    });
    console.log(errors);
    // Watch all form values for preview
    const watchedValues = watch();
    const moduleName = watch('moduleName');
    // ------------------------------------------------------------
    // Dynamic module menus (How it works?, Help, What is it?, etc.)
    // ------------------------------------------------------------
    const [menusConfig, setMenusConfig] = (0, $acw62.useState)(moduleData && isEdit && Array.isArray(moduleData.menusConfig) ? moduleData.menusConfig : []);
    const [expandedMenuKey, setExpandedMenuKey] = (0, $acw62.useState)(null);
    // Keep RHF value in sync with local state (one-way) to avoid loops
    (0, $acw62.useEffect)(()=>{
        setValue('menusConfig', menusConfig);
    }, [
        menusConfig,
        setValue
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            deleteUnlockersRef.current.forEach((unlocker)=>{
                if (unlocker && typeof unlocker.cancel === 'function') unlocker.cancel();
            });
            if (debouncedFlushSectionDeletesRef.current && typeof debouncedFlushSectionDeletesRef.current.cancel === 'function') debouncedFlushSectionDeletesRef.current.cancel();
        };
    }, []);
    const flushQueuedSectionDeletes = async ()=>{
        const queuedItems = [
            ...sectionDeleteQueueRef.current.values()
        ];
        if (!queuedItems.length) return;
        sectionDeleteQueueRef.current.clear();
        const persistedSectionIds = [
            ...new Set(queuedItems.map((item)=>item.sectionId).filter(Boolean))
        ];
        let successfullyDeletedIdSet = new Set();
        if (persistedSectionIds.length > 0) {
            const response = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)('/modules/temp-sections/bulk', {
                sectionIds: persistedSectionIds
            });
            if (response?.code !== 200) {
                setPendingSectionDeleteKeys(new Set());
                return;
            }
            const deletedSectionIds = response?.body?.deletedSectionIds || [];
            successfullyDeletedIdSet = new Set((deletedSectionIds || []).map((id)=>String(id)));
        }
        setSectionsByVariant((prev)=>{
            const next = {
                ...prev
            };
            const pendingUnsavedKeySet = new Set(queuedItems.filter((item)=>!item.sectionId).map((item)=>item.queueKey));
            Object.keys(next).forEach((variantKey)=>{
                next[variantKey] = (next[variantKey] || []).filter((section)=>{
                    const sectionId = section?._id ? String(section._id) : null;
                    if (sectionId) // Hide only backend-confirmed deletions for persisted sections.
                    return !successfullyDeletedIdSet.has(sectionId);
                    const sectionQueueKey = `variant:${variantKey}:sectionNo:${String(section?.sectionNo || '').trim()}`;
                    // Unsaved queued sections are local-only and can be removed immediately after debounce flush.
                    return !pendingUnsavedKeySet.has(sectionQueueKey);
                });
            });
            return next;
        });
        setPendingSectionDeleteKeys(new Set());
    };
    const debouncedFlushSectionDeletesRef = (0, $acw62.useRef)(null);
    if (!debouncedFlushSectionDeletesRef.current) debouncedFlushSectionDeletesRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($lwfqC)))(()=>{
        flushQueuedSectionDeletes();
    }, DELETE_DEBOUNCE_MS);
    const createEmptyMenu = ()=>{
        const idx = (menusConfig || []).length + 1;
        return {
            key: `menu-${idx}`,
            label: '',
            iconURL: '',
            isActive: true,
            actionType: 'navigate',
            navigateUrl: '',
            modalTitle: '',
            modalImageURL: '',
            modalContent: '',
            modalImagePosition: 'right'
        };
    };
    const handleAddMenu = ()=>{
        const next = [
            ...menusConfig || [],
            createEmptyMenu()
        ];
        setMenusConfig(next);
        if (next.length > 0) setExpandedMenuKey(next[next.length - 1].key);
    };
    const handleRemoveMenu = (key)=>{
        setMenusConfig((prev)=>(prev || []).filter((m)=>m.key !== key));
        if (expandedMenuKey === key) setExpandedMenuKey(null);
    };
    const handleMenuChange = (key, field, value)=>{
        setMenusConfig((prev)=>(prev || []).map((m)=>m.key === key ? {
                    ...m,
                    [field]: value
                } : m));
    };
    // Generate module key from module name
    const generateModuleKey = (name)=>{
        if (!name || !name.trim()) return '';
        // Extract first letter of each word and make uppercase
        const words = name.trim().split(/\s+/);
        const initials = words.map((word)=>word.charAt(0).toUpperCase()).join('');
        return initials;
    };
    // Auto-generate module key when module name changes (only for new modules and if not manually edited)
    (0, $acw62.useEffect)(()=>{
        if (moduleName && !isEdit && !isModuleKeyManuallyEdited) {
            const generatedKey = generateModuleKey(moduleName);
            setValue('moduleKey', generatedKey);
        }
    }, [
        moduleName,
        isEdit,
        isModuleKeyManuallyEdited,
        setValue
    ]);
    // Handle module key input - only allow alphanumeric characters and capitalize letters
    const handleModuleKeyChange = (e)=>{
        const value = e.target.value;
        // Remove non-alphanumeric characters and capitalize letters
        const sanitizedValue = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        setValue('moduleKey', sanitizedValue);
        // Mark as manually edited if user types something
        if (!isModuleKeyManuallyEdited) setIsModuleKeyManuallyEdited(true);
    };
    // Auto-update all section and question numbers when module key changes (per variant)
    (0, $acw62.useEffect)(()=>{
        const moduleKey = watchedValues.moduleKey;
        if (!moduleKey) return;
        const updateSectionNumbers = (sectionsList)=>{
            return sectionsList.map((section, idx)=>{
                const sectionNum = idx + 1;
                const paddedSectionNum = String(sectionNum).padStart(3, '0');
                const sectionNo = `${moduleKey}${paddedSectionNum}`;
                const updatedQuestion = section.question ? {
                    ...section.question,
                    qNo: sectionNo,
                    questionNumber: sectionNum
                } : section.question;
                let updatedSubFolders = {};
                if (section.subFolders && typeof section.subFolders === 'object') Object.keys(section.subFolders).forEach((key)=>{
                    const subFolder = section.subFolders[key];
                    const subFolderNo = `${sectionNo}.${key}`;
                    updatedSubFolders[key] = {
                        ...subFolder,
                        no: subFolderNo,
                        question: subFolder.question ? {
                            ...subFolder.question,
                            qNo: subFolderNo
                        } : subFolder.question
                    };
                });
                return {
                    ...section,
                    sectionNo: sectionNo,
                    question: updatedQuestion,
                    subFolders: updatedSubFolders
                };
            });
        };
        let hasChange = false;
        const updated = {
            ...sectionsByVariant
        };
        Object.keys(updated).forEach((variantKey)=>{
            const list = updated[variantKey] || [];
            if (list.length === 0) return;
            const next = updateSectionNumbers(list);
            if (JSON.stringify(next) !== JSON.stringify(list)) {
                updated[variantKey] = next;
                hasChange = true;
            }
        });
        if (hasChange) {
            setSectionsByVariant(updated);
            // All section numbers changed — every section needs to be saved
            if (isEdit) allSectionsDirtyRef.current = true;
        }
    }, [
        watchedValues.moduleKey
    ]);
    // Update sections when moduleData changes (edit mode) – group by companyObjective and subscriptionTier
    (0, $acw62.useEffect)(()=>{
        if (moduleData?.sections && isEdit) {
            const buildSubFoldersFromSubSections = (subSections)=>{
                if (!Array.isArray(subSections)) return {};
                const result = {};
                subSections.forEach((sf, index)=>{
                    const key = String(index + 1);
                    result[key] = {
                        name: sf.name || '',
                        no: sf.no || '',
                        question: sf.question || {},
                        subFolders: buildSubFoldersFromSubSections(sf.subSections || [])
                    };
                });
                return result;
            };
            const transformedSections = moduleData.sections.map((section, idx)=>{
                const sectionNo = section.sectionNo || `${moduleData.moduleKey}${(idx + 1).toString().padStart(3, '0')}`;
                let question = section.question || {
                    qNo: sectionNo,
                    questionNumber: idx + 1,
                    qDescription: '',
                    questionType: '',
                    customOptions: [
                        {
                            value: '',
                            info: ''
                        }
                    ],
                    predefinedOptionsInfo: {},
                    dateInfo: '',
                    tooltip: '',
                    toolboxOffer: '',
                    riskDescription: '',
                    recommendDescription: '',
                    riskScores: {}
                };
                let subFolders = {};
                if (Array.isArray(section.subSections)) subFolders = buildSubFoldersFromSubSections(section.subSections);
                else if (section.subFolders && typeof section.subFolders === 'object') subFolders = section.subFolders;
                return {
                    ...section,
                    sectionNo: sectionNo,
                    question: question,
                    subFolders: subFolders,
                    companyObjective: section.companyObjective || 'All',
                    subscriptionTier: section.subscriptionTier || 'All'
                };
            });
            const groupedSingle = emptySectionsByVariant();
            transformedSections.forEach((sec)=>{
                const obj = sec.companyObjective === 'All' ? $7cde4a2f681457f4$var$OBJECTIVE_ALL : sec.companyObjective;
                const tier = sec.subscriptionTier === 'All' ? $7cde4a2f681457f4$var$TIER_ALL : sec.subscriptionTier;
                const key = $7cde4a2f681457f4$var$getVariantKey(obj, tier);
                if (!groupedSingle[key]) groupedSingle[key] = [];
                groupedSingle[key].push(sec);
            });
            setSectionsByVariant(groupedSingle);
            if (transformedSections.length > 0) setExpandedSectionIndex(0);
        }
    }, [
        moduleData,
        isEdit
    ]);
    // Flatten sections from all variants for parent and submit
    const flattenedSections = ()=>{
        const out = [];
        Object.keys(sectionsByVariant).forEach((variantKey)=>{
            const [objective, tier] = variantKey.split('-');
            (sectionsByVariant[variantKey] || []).forEach((sec)=>{
                out.push({
                    ...sec,
                    companyObjective: sec.companyObjective ?? objective,
                    subscriptionTier: sec.subscriptionTier ?? tier
                });
            });
        });
        return out;
    };
    // Update parent component when form changes
    (0, $acw62.useEffect)(()=>{
        if (onFormChange) onFormChange({
            ...watchedValues,
            sections: flattenedSections(),
            dashboardPlacements: Object.keys(placementsByVariant).reduce((acc, key)=>{
                const cardId = placementsByVariant[key];
                if (!cardId) return acc;
                const [objective, tier] = key.split('-');
                acc.push({
                    companyObjective: objective,
                    subscriptionTier: tier,
                    dashboardCardId: cardId
                });
                return acc;
            }, []),
            sectionAccessRestrictions: Object.keys(sectionRestrictionsByVariant).map((key)=>{
                const parsed = $7cde4a2f681457f4$var$parseVariantKey(key);
                if (!parsed) return null;
                return {
                    companyObjective: parsed.objective,
                    subscriptionTier: parsed.tier,
                    isRestricted: sectionRestrictionsByVariant[key] === true
                };
            }).filter(Boolean)
        });
    }, [
        watchedValues,
        sectionsByVariant,
        placementsByVariant,
        sectionRestrictionsByVariant,
        onFormChange
    ]);
    // Reset form when moduleData changes in edit mode
    (0, $acw62.useEffect)(()=>{
        if (moduleData && isEdit) {
            reset({
                moduleName: moduleData.moduleName || '',
                moduleKey: moduleData.moduleKey || '',
                slug: (moduleData.slug || '').replace(/^#/, ''),
                moduleSubTitle: moduleData.moduleSubTitle || '',
                moduleTagColor: moduleData.moduleTagColor || '',
                moduleDescription: moduleData.moduleDescription || '',
                imageURL: moduleData.imageURL || '',
                type: moduleData.type || 'common',
                dashboardCardId: moduleData.dashboardCardId ? String(moduleData.dashboardCardId) : '',
                isActive: moduleData.isActive !== undefined ? moduleData.isActive : true,
                isReportModule: moduleData.isReportModule !== undefined ? moduleData.isReportModule : false,
                isDirectorsModule: moduleData.isDirectorsModule !== undefined ? moduleData.isDirectorsModule : false,
                isPaid: moduleData.isPaid || false,
                price: moduleData.price || '',
                stripeProductPriceId: moduleData.stripeProductPriceId || '',
                duration: moduleData.duration || 'NIL',
                completeness: moduleData.completeness || 'No',
                risks: moduleData.risks || 'No',
                passFail: moduleData.passFail || 'No',
                certification: moduleData.certification || 'No',
                report: moduleData.report || 'No',
                workflowReport: moduleData.workflowReport || 'No'
            });
            // Prime certificationRules
            setCertificationRules(Array.isArray(moduleData.certificationRules) ? moduleData.certificationRules : []);
            // Prime placements from moduleData.dashboardPlacements if present
            if (Array.isArray(moduleData.dashboardPlacements)) {
                const initialPlacements = {};
                moduleData.dashboardPlacements.forEach((p)=>{
                    if (!p || !p.dashboardCardId) return;
                    const obj = p.companyObjective || $7cde4a2f681457f4$var$OBJECTIVE_ALL;
                    const tier = p.subscriptionTier || $7cde4a2f681457f4$var$TIER_ALL;
                    const key = $7cde4a2f681457f4$var$getVariantKey(obj, tier);
                    initialPlacements[key] = String(p.dashboardCardId);
                });
                setPlacementsByVariant(initialPlacements);
            }
            if (Array.isArray(moduleData.sectionAccessRestrictions)) {
                const next = $7cde4a2f681457f4$var$emptySectionRestrictions();
                moduleData.sectionAccessRestrictions.forEach((r)=>{
                    if (!r) return;
                    const obj = r.companyObjective != null ? r.companyObjective : $7cde4a2f681457f4$var$OBJECTIVE_ALL;
                    const tier = r.subscriptionTier != null ? r.subscriptionTier : $7cde4a2f681457f4$var$TIER_ALL;
                    const key = $7cde4a2f681457f4$var$getVariantKey(obj, tier);
                    if (Object.prototype.hasOwnProperty.call(next, key)) next[key] = r.isRestricted === true;
                });
                setSectionRestrictionsByVariant(next);
            } else setSectionRestrictionsByVariant($7cde4a2f681457f4$var$emptySectionRestrictions());
        }
    }, [
        moduleData,
        isEdit,
        reset
    ]);
    // Helper function to validate a single question
    // NOTE: Questions and their options are optional. If a question is left empty,
    // we skip validation entirely. If the user starts filling a question, we only
    // require description and type – options are not mandatory.
    const validateQuestion = (question)=>{
        const errors = {};
        let isValid = true;
        if (!question) return {
            errors: errors,
            isValid: true
        }; // No question is okay
        const hasCustomOptions = question.customOptions && question.customOptions.length > 0 && question.customOptions.some((opt)=>(0, $39a623eb929ce528$export$82fc61b46dd11008)(opt));
        const hasPredefinedOptions = question.predefinedOptionsInfo && Object.keys(question.predefinedOptionsInfo).length > 0 && Object.values(question.predefinedOptionsInfo).some((val)=>val?.trim && val.trim());
        // If the whole question is effectively empty, allow it
        const isEmptyQuestion = !question.qDescription?.trim() && !question.questionType && !hasCustomOptions && !hasPredefinedOptions && !question.dateInfo?.trim() && !question.tooltip?.trim() && !question.toolboxOffer?.trim() && !question.riskDescription?.trim() && !question.recommendDescription?.trim();
        if (isEmptyQuestion) return {
            errors: errors,
            isValid: true
        };
        // If the author started a question, require at least description and type
        if (!question.qDescription?.trim()) {
            errors.qDescription = 'Question is required';
            isValid = false;
        }
        if (!question.questionType) {
            errors.questionType = 'Question type is required';
            isValid = false;
        }
        // Options (customOptions / predefinedOptionsInfo) are allowed to be empty now
        return {
            errors: errors,
            isValid: isValid
        };
    };
    // Helper function to validate sub-folders (object with numbered keys)
    // NOTE: Sub-folder name is optional. We only validate nested questions, not the label.
    const validateSubFolders = (subFolders, parentPath = 'Sub-Folder')=>{
        const errors = {};
        let isValid = true;
        if (subFolders && typeof subFolders === 'object') Object.keys(subFolders).forEach((key)=>{
            const subFolder = subFolders[key];
            errors[key] = {};
            // Validate question in sub-folder
            const questionValidation = validateQuestion(subFolder.question);
            if (Object.keys(questionValidation.errors).length > 0) errors[key].question = questionValidation.errors;
            if (!questionValidation.isValid) isValid = false;
        });
        return {
            errors: errors,
            isValid: isValid
        };
    };
    const validateSections = ()=>{
        const allSections = flattenedSections();
        console.log('  - Total sections:', allSections.length);
        const errors = {};
        let isValid = true;
        Object.keys(sectionsByVariant).forEach((variantKey)=>{
            const list = sectionsByVariant[variantKey] || [];
            list.forEach((section, sIdx)=>{
                const errKey = `${variantKey}-${sIdx}`;
                errors[errKey] = {};
                // Section name is now optional – no validation here
                // Validate main question using relaxed rules (optional when empty)
                const questionValidation = validateQuestion(section.question);
                if (Object.keys(questionValidation.errors).length > 0) errors[errKey].question = questionValidation.errors;
                if (!questionValidation.isValid) isValid = false;
                // Validate sub-folder questions (names optional)
                const hasSubFolders = section.subFolders && Object.keys(section.subFolders).length > 0;
                if (hasSubFolders) {
                    const subFolderValidation = validateSubFolders(section.subFolders, `Section ${sIdx + 1}`);
                    if (Object.keys(subFolderValidation.errors).length > 0) errors[errKey].subFolders = subFolderValidation.errors;
                    if (!subFolderValidation.isValid) isValid = false;
                }
            });
        });
        setSectionErrors(errors);
        return isValid;
    };
    // Helper function to clean sections data
    const cleanSectionsData = (sections)=>{
        return sections.map((section)=>{
            // Return section as is - subFolders are already in correct format
            return {
                ...section
            };
        });
    };
    /**
   * Convert parsed Excel dataset into sectionsByVariant and merge into state.
   * Called after the user confirms their objective×tier selection in ExcelVariantModal.
   *
   * @param {string[]} selectedVariants — e.g. ['Investment-Free', 'Growth-Pro']
   * @param {object}   parsedData       — body returned by /modules/parse-excel
   */ const handleExcelImport = (selectedVariants, parsedData)=>{
        const currentModuleKey = (watchedValues.moduleKey || '').toUpperCase();
        if (!currentModuleKey) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please set the Module Key before importing from Excel.');
            return;
        }
        const buildSectionsForVariant = (variantKey)=>{
            const [objective, tier] = variantKey.split('-');
            return (parsedData['sections'] || []).map((sec, sectionIdx)=>{
                const sectionNum = String(sectionIdx + 1).padStart(3, '0');
                const sectionNo = `${currentModuleKey}${sectionNum}`;
                const subFolders = {};
                let sfCounter = 0;
                (sec['questions'] || []).forEach((q)=>{
                    const qDescription = (q['question'] || '').trim();
                    if (!qDescription) return; // skip questions with no content
                    sfCounter++;
                    const sfKey = String(sfCounter);
                    const qNo = `${sectionNo}.${sfKey}`;
                    // Build riskScores from imported per-answer risk values
                    const riskScores = {};
                    if (q['riskIfYes'] !== null && q['riskIfYes'] !== undefined) riskScores['Yes'] = q['riskIfYes'];
                    if (q['riskIfNo'] !== null && q['riskIfNo'] !== undefined) riskScores['No'] = q['riskIfNo'];
                    // Build predefinedOptionsInfo from imported ifYes / ifNo
                    const predefinedOptionsInfo = {};
                    if (q['ifYes']) predefinedOptionsInfo['Yes'] = q['ifYes'];
                    if (q['ifNo']) predefinedOptionsInfo['No'] = q['ifNo'];
                    // Build customOptions for Multi/DropDown types
                    const customOptions = Array.isArray(q['options']) && q['options'].length > 0 ? q['options'].map((o)=>({
                            value: o,
                            info: ''
                        })) : [
                        {
                            value: '',
                            info: ''
                        }
                    ];
                    subFolders[sfKey] = {
                        name: q['subsection'] || `${sectionNo}.${sfKey}`,
                        no: qNo,
                        question: {
                            qNo: qNo,
                            questionNumber: sfCounter,
                            qDescription: qDescription,
                            riskDescription: q['risk'] || '',
                            recommendDescription: q['recommendation'] || '',
                            tooltip: q['tooltip'] || '',
                            toolboxOffer: q['toolbox'] || '',
                            questionType: q['questionType'] || 'YN/F/T',
                            riskScore: q['riskScore'] ?? 1,
                            attachmentRequired: q['attachmentRequired'] ?? false,
                            customOptions: customOptions,
                            predefinedOptionsInfo: predefinedOptionsInfo,
                            dateInfo: '',
                            riskScores: riskScores
                        },
                        subFolders: {}
                    };
                });
                return {
                    sectionName: sec['sectionName'],
                    sectionNo: sectionNo,
                    companyObjective: objective,
                    subscriptionTier: tier,
                    subFolders: subFolders
                };
            });
        };
        setSectionsByVariant((prev)=>{
            const next = {
                ...prev
            };
            for (const vk of selectedVariants)next[vk] = buildSectionsForVariant(vk);
            return next;
        });
        allSectionsDirtyRef.current = true;
        setExcelImportedVariants(selectedVariants);
        setExcelVariantModalOpen(false);
    // Stay in 'upload' mode — sections are loaded into state and will be submitted on Save.
    };
    const onSubmitForm = async (data)=>{
        // AI mode (create-only): skip section validation — GPT will generate content after save
        if (generationMode === 'ai' && !isEdit) {
            if (onSubmit) onSubmit({
                ...data,
                sections: [],
                changedSectionsOnly: false,
                dashboardPlacements: [],
                sectionAccessRestrictions: [],
                certificationRules: certificationRules,
                generationMode: 'ai',
                aiConfig: aiConfig
            });
            return;
        }
        const sectionsValid = validateSections();
        if (!sectionsValid) {
            window.scrollTo({
                top: document.querySelector('.section-container')?.offsetTop || 0,
                behavior: 'smooth'
            });
            return;
        }
        const allSections = flattenedSections();
        const cleanedSections = cleanSectionsData(allSections);
        // In edit mode, only send sections that were actually modified to avoid
        // redundant DB writes for every section in large modules.
        // New sections (no _id) are always included.
        // changedSectionsOnly tells the backend to skip its deletion pass since
        // section deletes are already handled in real-time via /temp-sections/bulk.
        const changedSectionsOnly = isEdit && !allSectionsDirtyRef.current;
        const sectionsToSubmit = changedSectionsOnly ? cleanedSections.filter((s)=>!s._id || dirtySectionIdsRef.current.has(String(s._id))) : cleanedSections;
        const dashboardPlacements = Object.keys(placementsByVariant).reduce((acc, key)=>{
            const cardId = placementsByVariant[key];
            if (!cardId) return acc;
            const [objective, tier] = key.split('-');
            acc.push({
                companyObjective: objective,
                subscriptionTier: tier,
                dashboardCardId: cardId
            });
            return acc;
        }, []);
        const sectionAccessRestrictions = Object.keys(sectionRestrictionsByVariant).map((key)=>{
            const parsed = $7cde4a2f681457f4$var$parseVariantKey(key);
            if (!parsed) return null;
            return {
                companyObjective: parsed.objective,
                subscriptionTier: parsed.tier,
                isRestricted: sectionRestrictionsByVariant[key] === true
            };
        }).filter(Boolean);
        // For IR modules, save all questions before updating module metadata
        if (isInvestmentReadiness && irQuestionsRef.current) await irQuestionsRef.current.saveAll();
        if (onSubmit) onSubmit({
            ...data,
            sections: sectionsToSubmit,
            changedSectionsOnly: changedSectionsOnly,
            dashboardPlacements: dashboardPlacements,
            sectionAccessRestrictions: sectionAccessRestrictions,
            certificationRules: certificationRules
        });
        else console.error("\u26A0\uFE0F onSubmit callback missing!");
    };
    const addSection = ()=>{
        const sectionNumber = currentSections.length + 1;
        const paddedSectionNumber = String(sectionNumber).padStart(3, '0');
        const sectionNo = `${watchedValues.moduleKey}${paddedSectionNumber}`;
        const newSection = {
            sectionName: '',
            sectionNo: sectionNo,
            companyObjective: selectedObjective,
            subscriptionTier: selectedTier,
            question: {
                qNo: sectionNo,
                questionNumber: sectionNumber,
                qDescription: '',
                questionType: '',
                customOptions: [
                    {
                        value: '',
                        info: ''
                    }
                ],
                predefinedOptionsInfo: {},
                dateInfo: '',
                tooltip: '',
                toolboxOffer: '',
                riskDescription: '',
                recommendDescription: '',
                riskScores: {}
            },
            subFolders: {}
        };
        setSectionsByVariant((prev)=>({
                ...prev,
                [currentVariantKey]: [
                    ...prev[currentVariantKey] || [],
                    newSection
                ]
            }));
        setExpandedSectionIndex(currentSections.length);
    };
    const updateSection = (variantKey, index, updatedSection)=>{
        // Mark this section as dirty so we only save changed sections on submit
        if (updatedSection._id) dirtySectionIdsRef.current.add(String(updatedSection._id));
        setSectionsByVariant((prev)=>{
            const list = [
                ...prev[variantKey] || []
            ];
            list[index] = {
                ...updatedSection,
                companyObjective: updatedSection.companyObjective ?? selectedObjective,
                subscriptionTier: updatedSection.subscriptionTier ?? selectedTier
            };
            return {
                ...prev,
                [variantKey]: list
            };
        });
    };
    const acquireDeleteLock = (key)=>{
        if (deleteLocksRef.current.get(key)) return true;
        deleteLocksRef.current.set(key, true);
        let unlocker = deleteUnlockersRef.current.get(key);
        if (!unlocker) {
            unlocker = (0, (/*@__PURE__*/$parcel$interopDefault($lwfqC)))((lockKey)=>{
                deleteLocksRef.current.delete(lockKey);
            }, DELETE_DEBOUNCE_MS);
            deleteUnlockersRef.current.set(key, unlocker);
        }
        unlocker(key);
        return false;
    };
    const removeSection = async (variantKey, index)=>{
        const sectionToDelete = (sectionsByVariant[variantKey] || [])[index];
        if (!sectionToDelete) return;
        const sectionId = sectionToDelete?._id;
        const queueKey = sectionId ? `id:${String(sectionId)}` : `variant:${variantKey}:sectionNo:${String(sectionToDelete?.sectionNo || '').trim()}`;
        if (sectionDeleteQueueRef.current.has(queueKey)) return;
        sectionDeleteQueueRef.current.set(queueKey, {
            queueKey: queueKey,
            sectionId: sectionId ? String(sectionId) : null,
            variantKey: variantKey
        });
        setPendingSectionDeleteKeys((prev)=>{
            const next = new Set(prev);
            next.add(queueKey);
            return next;
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Delete queued. Will execute in 3 seconds.');
        debouncedFlushSectionDeletesRef.current();
    };
    // Deep clone section with new sectionNo and qNo for target objective+tier
    const cloneSectionForTarget = (section, targetObjective, targetTier, startSectionNo)=>{
        const newSectionNo = startSectionNo;
        const updateQNoInQuestion = (q, baseNo)=>{
            if (!q) return q;
            return {
                ...q,
                qNo: baseNo,
                _id: undefined
            };
        };
        const updateSubFolders = (subFolders, parentNo)=>{
            if (!subFolders || typeof subFolders !== 'object') return {};
            const result = {};
            Object.keys(subFolders).forEach((key)=>{
                const sf = subFolders[key];
                const subNo = `${parentNo}.${key}`;
                result[key] = {
                    ...sf,
                    no: subNo,
                    question: sf.question ? updateQNoInQuestion(sf.question, subNo) : sf.question,
                    subFolders: updateSubFolders(sf.subFolders || {}, subNo)
                };
            });
            return result;
        };
        const newQuestion = section.question ? updateQNoInQuestion(section.question, newSectionNo) : section.question;
        const newSubFolders = updateSubFolders(section.subFolders || {}, newSectionNo);
        return {
            ...section,
            _id: undefined,
            sectionNo: newSectionNo,
            companyObjective: targetObjective,
            subscriptionTier: targetTier,
            question: newQuestion,
            subFolders: newSubFolders
        };
    };
    const openBulkCloneModal = ()=>{
        if (currentSections.length === 0) return;
        setCloneMode('bulk');
        setCloneSection(null);
        setCloneTargets([]);
        setCloneView('select');
        setCloneConflictConflicts([]);
        setCloneModalOpen(true);
    };
    const openSingleCloneModal = (section)=>{
        setCloneMode('single');
        setCloneSection(section);
        setCloneTargets([]);
        setCloneView('select');
        setCloneConflictConflicts([]);
        setCloneModalOpen(true);
    };
    // Detect conflicts: sections with same sectionNo already exist in target tier(s)
    const getCloneConflicts = ()=>{
        const sectionsToClone = cloneMode === 'bulk' ? currentSections : cloneSection ? [
            cloneSection
        ] : [];
        const conflicts = [];
        cloneTargets.forEach((targetKey)=>{
            const [targetObjective, targetTier] = targetKey.split('-');
            const existing = sectionsByVariant[targetKey] || [];
            const existingSectionNos = new Set(existing.map((s)=>s.sectionNo).filter(Boolean));
            sectionsToClone.forEach((sec)=>{
                const sectionNo = sec.sectionNo;
                if (sectionNo && existingSectionNos.has(sectionNo)) conflicts.push({
                    sectionNo: sectionNo,
                    objective: targetObjective,
                    tier: targetTier
                });
            });
        });
        return conflicts;
    };
    const handleCloneConfirm = (forceOverwrite = false)=>{
        if (cloneTargets.length === 0) return;
        const sectionsToClone = cloneMode === 'bulk' ? currentSections : cloneSection ? [
            cloneSection
        ] : [];
        if (sectionsToClone.length === 0) {
            setCloneModalOpen(false);
            return;
        }
        const conflicts = getCloneConflicts();
        if (conflicts.length > 0 && !forceOverwrite) {
            setCloneConflictConflicts(conflicts);
            setCloneView('conflict');
            return;
        }
        const moduleKey = watchedValues.moduleKey || 'XX';
        setSectionsByVariant((prev)=>{
            const next = {
                ...prev
            };
            cloneTargets.forEach((targetKey)=>{
                const [targetObjective, targetTier] = targetKey.split('-');
                const existing = next[targetKey] || [];
                const cloned = sectionsToClone.map((sec)=>{
                    const sectionNo = sec.sectionNo || `${moduleKey}${String(existing.length + 1).padStart(3, '0')}`;
                    return cloneSectionForTarget(sec, targetObjective, targetTier, sectionNo);
                });
                if (forceOverwrite && conflicts.length > 0) {
                    const clonedByNo = Object.fromEntries(cloned.map((c)=>[
                            c.sectionNo,
                            c
                        ]));
                    const existingSectionNos = new Set(existing.map((s)=>s.sectionNo).filter(Boolean));
                    const replaced = existing.map((s)=>clonedByNo[s.sectionNo] ?? s);
                    const added = cloned.filter((c)=>!existingSectionNos.has(c.sectionNo));
                    next[targetKey] = [
                        ...replaced,
                        ...added
                    ];
                } else next[targetKey] = [
                    ...existing,
                    ...cloned
                ];
            });
            return next;
        });
        setCloneModalOpen(false);
        setCloneTargets([]);
        setCloneSection(null);
        setCloneView('select');
        setCloneConflictConflicts([]);
    };
    const handleCloneOverwrite = ()=>{
        handleCloneConfirm(true);
    };
    const handleCloneCancel = ()=>{
        setCloneModalOpen(false);
        setCloneTargets([]);
        setCloneSection(null);
        setCloneView('select');
        setCloneConflictConflicts([]);
    };
    const toggleCloneTarget = (targetKey)=>{
        setCloneTargets((prev)=>prev.includes(targetKey) ? prev.filter((t)=>t !== targetKey) : [
                ...prev,
                targetKey
            ]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w100",
        style: {
            minWidth: 0,
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 shadow br10px p2rem",
                style: {
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsb mb1-5rem",
                        style: {
                            gap: '0.75rem',
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                style: {
                                    gap: '0.75rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: onCancel,
                                        className: "df aic jcc cp bg3 c1",
                                        style: {
                                            width: '42px',
                                            height: '42px',
                                            borderRadius: '50%',
                                            border: '1px solid #d6ddff',
                                            boxShadow: '0 4px 12px rgba(76, 110, 245, 0.16)',
                                            flexShrink: 0,
                                            transition: 'all 0.22s ease'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M15 19l-7-7 7-7",
                                                stroke: "#fff",
                                                strokeWidth: "2.3",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-5rem fw600 c15",
                                        children: isEdit ? 'Edit Module' : 'Create New Module'
                                    })
                                ]
                            }),
                            console.log(moduleData),
                            isEdit && !moduleName?.includes('KPI Report') && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: handleSetPriorities,
                                disabled: isPriorityLoading,
                                className: "df aic br50px py0-5rem px1-5rem fs0-875rem fw500 cp",
                                style: {
                                    backgroundColor: isPriorityLoading ? '#D9D9D9' : '#4A67FF',
                                    color: '#fff',
                                    border: 'none',
                                    opacity: isPriorityLoading ? 0.7 : 1,
                                    gap: '6px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: "\u2726"
                                    }),
                                    isPriorityLoading ? "Setting Priorities\u2026" : 'Set Priorities as per Questions'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: jobSummary ? (()=>{
                            const isDone = jobSummary['status'] === 'complete';
                            const isStarting = jobSummary['status'] === 'starting';
                            const totalAssigned = jobSummary['updated'] != null ? jobSummary['updated'] : Object.values(sectionProgress).reduce((s, sec)=>s + (sec['assigned'] || 0), 0);
                            // When done, always show total/total 100% — partial GPT failures are surfaced via the toast, not here
                            const displayAssigned = isDone ? jobSummary['total'] || 0 : totalAssigned;
                            const overallPct = isDone ? 100 : jobSummary['total'] > 0 ? Math.round(totalAssigned / jobSummary['total'] * 100) : 0;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bw1px mb1rem oh",
                                style: {
                                    borderColor: '#DDE2F2',
                                    background: '#fff'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic px1-5rem py0-75rem",
                                        style: {
                                            borderBottom: '1px solid #DDE2F2',
                                            background: '#F0F2FD'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                style: {
                                                    gap: '10px'
                                                },
                                                children: [
                                                    isPriorityLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            display: 'inline-block',
                                                            width: '9px',
                                                            height: '9px',
                                                            borderRadius: '50%',
                                                            background: '#4A67FF',
                                                            animation: 'pulse 1.2s ease-in-out infinite',
                                                            flexShrink: 0
                                                        }
                                                    }),
                                                    isDone && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs14px",
                                                        style: {
                                                            color: '#09B255'
                                                        },
                                                        children: "\u2713"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs14px fw600",
                                                        style: {
                                                            color: isDone ? '#09B255' : '#4A67FF'
                                                        },
                                                        children: [
                                                            jobSummary['moduleName'],
                                                            " \u2014 Priority Analysis"
                                                        ]
                                                    }),
                                                    isPriorityLoading && !isSocketConnected && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs12px fw500",
                                                        style: {
                                                            color: '#FC7785'
                                                        },
                                                        children: "Reconnecting\u2026"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                style: {
                                                    gap: '12px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs13px fw500",
                                                        style: {
                                                            color: '#505050'
                                                        },
                                                        children: isStarting ? "Starting\u2026" : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                displayAssigned,
                                                                " / ",
                                                                jobSummary['total'],
                                                                " questions \xa0",
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "fw600",
                                                                    style: {
                                                                        color: isDone ? '#09B255' : '#4A67FF'
                                                                    },
                                                                    children: [
                                                                        overallPct,
                                                                        "%"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    !isPriorityLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        onClick: handleClearPriorityProgress,
                                                        className: "fs12px cp",
                                                        style: {
                                                            color: '#AAACB5',
                                                            background: 'none',
                                                            border: 'none',
                                                            padding: 0
                                                        },
                                                        children: "Clear"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            height: '6px',
                                            background: '#E8EBF5'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                width: `${overallPct}%`,
                                                height: '100%',
                                                background: isDone ? '#09B255' : '#4A67FF',
                                                transition: 'width 0.4s ease',
                                                borderRadius: '0 3px 3px 0'
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            maxHeight: '320px',
                                            overflowY: 'auto',
                                            padding: '0.75rem 1.25rem'
                                        },
                                        children: sectionOrder.map((sid)=>{
                                            const sec = sectionProgress[sid];
                                            if (!sec) return null;
                                            // When done, clamp every section to 100% — stale partial counts from GPT misses shouldn't linger
                                            const pct = isDone ? 100 : sec['percentage'] || 0;
                                            const barFill = pct === 100 ? '#09B255' : '#4A67FF';
                                            const pctColor = pct === 100 ? '#09B255' : pct > 0 ? '#4A67FF' : '#AAACB5';
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic mb0-5rem",
                                                style: {
                                                    gap: '12px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs13px",
                                                        style: {
                                                            color: '#151313',
                                                            flex: 1,
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        },
                                                        children: sec['sectionName']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs12px",
                                                        style: {
                                                            color: '#AAACB5',
                                                            whiteSpace: 'nowrap',
                                                            minWidth: '90px',
                                                            textAlign: 'right'
                                                        },
                                                        children: [
                                                            sec['objective'],
                                                            " / ",
                                                            sec['tier']
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 140px',
                                                            height: '8px',
                                                            background: '#E8EBF5',
                                                            borderRadius: '4px',
                                                            overflow: 'hidden'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            style: {
                                                                width: `${pct}%`,
                                                                height: '100%',
                                                                background: barFill,
                                                                borderRadius: '4px',
                                                                transition: 'width 0.3s ease'
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs13px fw600",
                                                        style: {
                                                            color: pctColor,
                                                            minWidth: '36px',
                                                            textAlign: 'right'
                                                        },
                                                        children: [
                                                            pct,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }, sid);
                                        })
                                    })
                                ]
                            });
                        })() : null
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: handleSubmit(onSubmitForm),
                        className: "dg fdc gg2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bo5 bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-1rem fw600 c15 m0",
                                                children: "Basic details"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-8rem c15 op60",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: "Name, key and routing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "dg gg1rem module-form-grid",
                                        style: {
                                            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc jcfs aifs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Module Name *"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        ...register('moduleName'),
                                                        className: `br5px p0-5rem bss bw1px w100 ${errors.moduleName ? 'bo12' : 'bo5'}`,
                                                        placeholder: "Enter module name"
                                                    }),
                                                    errors.moduleName && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c12 mt0-25rem",
                                                        children: errors.moduleName.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: [
                                                            "Module Key ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    color: '#dc3545'
                                                                },
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        value: watchedValues.moduleKey || '',
                                                        onChange: handleModuleKeyChange,
                                                        className: `br5px p0-5rem bss bw1px w100 ${errors.moduleKey ? 'bo12' : 'bo5'}`,
                                                        style: {
                                                            textTransform: 'uppercase',
                                                            fontFamily: 'monospace',
                                                            fontWeight: '500',
                                                            color: '#333'
                                                        },
                                                        placeholder: "Enter module key (A-Z, 0-9)",
                                                        maxLength: 16
                                                    }),
                                                    errors.moduleKey ? /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c12 mt0-25rem",
                                                        children: errors.moduleKey.message
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c15 op60 mt0-25rem",
                                                        style: {
                                                            color: '#666'
                                                        },
                                                        children: "Only letters and numbers allowed (A-Z, 0-9). Max 16 characters."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Module Slug"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        ...register('slug'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            fontFamily: 'monospace',
                                                            fontWeight: '400',
                                                            color: '#333'
                                                        },
                                                        placeholder: "enter-module-slug"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c15 op60 mt0-25rem",
                                                        style: {
                                                            color: '#666'
                                                        },
                                                        children: 'URL-friendly identifier. E.g., "repository" or "data-repository"'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Tag"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        ...register('moduleSubTitle'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        placeholder: "Enter module tag"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Tag colour"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: '0.5rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "color",
                                                                "aria-label": "Pick tag colour",
                                                                value: typeof watchedValues.moduleTagColor === 'string' && /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(watchedValues.moduleTagColor.trim()) ? watchedValues.moduleTagColor.trim() : '#AAACB5',
                                                                onChange: (e)=>setValue('moduleTagColor', e.target.value, {
                                                                        shouldValidate: true
                                                                    }),
                                                                className: "br5px oh cp bss bw1px bo5",
                                                                style: {
                                                                    width: '2.75rem',
                                                                    height: '2.25rem',
                                                                    padding: 0,
                                                                    backgroundColor: '#fff'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "text",
                                                                ...register('moduleTagColor'),
                                                                className: `br5px p0-5rem bss bw1px w100 ${errors.moduleTagColor ? 'bo12' : 'bo5'}`,
                                                                placeholder: "#4A67FF (optional)"
                                                            })
                                                        ]
                                                    }),
                                                    errors.moduleTagColor ? /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c12 mt0-25rem",
                                                        children: errors.moduleTagColor.message
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c15 op60 mt0-25rem",
                                                        style: {
                                                            color: '#666'
                                                        },
                                                        children: "Leave blank for default tag styling on the dashboard."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        className: "fs11px fw500 c3 cp td300 tal mt0-25rem",
                                                        style: {
                                                            background: 'none',
                                                            border: 'none',
                                                            padding: 0
                                                        },
                                                        onClick: ()=>setValue('moduleTagColor', '', {
                                                                shouldValidate: true
                                                            }),
                                                        children: "Reset to default colour"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bo5 bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-1rem fw600 c15 m0",
                                                children: "Content & visuals"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-8rem c15 op60",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: "What this module looks like and says"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "dg gg1rem module-form-grid",
                                        style: {
                                            gridTemplateColumns: 'minmax(0, 1.2fr) minmax(0, 0.8fr)'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Module Description"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        ...register('moduleDescription'),
                                                        className: `br5px p0-5rem bss bw1px w100 ${errors.moduleDescription ? 'bo12' : 'bo5'}`,
                                                        placeholder: "Enter module description",
                                                        rows: 4
                                                    }),
                                                    errors.moduleDescription && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c12 mt0-25rem",
                                                        children: errors.moduleDescription.message
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fdc",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                                    imageURL: watchedValues.imageURL,
                                                    onImageChange: (url)=>setValue('imageURL', url),
                                                    label: "Module Image"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bo5 bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-1rem fw600 c15 m0",
                                                children: "Behaviour & placement"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-8rem c15 op60",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: "Where this module appears in the product"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Module Type *"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('type'),
                                                        className: `br5px p0-5rem bss bw1px w100 ${errors.type ? 'bo12' : 'bo5'}`,
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "common",
                                                                children: "Common (Available for all companies)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "unique",
                                                                children: "Dashboard"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                disabled: true,
                                                                value: "partner",
                                                                children: "Partner"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                disabled: true,
                                                                value: "internal",
                                                                children: "Internal"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                disabled: true,
                                                                value: "external",
                                                                children: "External"
                                                            })
                                                        ]
                                                    }),
                                                    errors.type ? /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c12 mt0-25rem",
                                                        children: errors.type.message
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c15 op60 mt0-25rem",
                                                        children: "Determines module availability scope"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fww gg0-75rem br8px bss bo5 bw1px p0-75rem",
                                                style: {
                                                    minHeight: "42px",
                                                    alignContent: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic bg1 br5px p0-5rem",
                                                        style: {
                                                            minHeight: "32px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                ...register('isActive'),
                                                                className: "mr0-5rem",
                                                                id: "isActive"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                htmlFor: "isActive",
                                                                className: "fs0-9rem fw500 c15 cp",
                                                                children: "Active Module"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic bg1 br5px p0-5rem",
                                                        style: {
                                                            minHeight: "32px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                ...register('isReportModule'),
                                                                className: "mr0-5rem",
                                                                id: "isReportModule"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                htmlFor: "isReportModule",
                                                                className: "fs0-9rem fw500 c15 cp",
                                                                children: "Is Report Module?"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic bg1 br5px p0-5rem",
                                                        style: {
                                                            minHeight: "32px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                ...register('isCustomSection'),
                                                                className: "mr0-5rem",
                                                                id: "isCustomSection"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                htmlFor: "isCustomSection",
                                                                className: "fs0-9rem fw500 c15 cp",
                                                                children: "Allow Custom Sections"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic bg1 br5px p0-5rem",
                                                        style: {
                                                            minHeight: "32px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                ...register('isDirectorsModule'),
                                                                className: "mr0-5rem",
                                                                id: "isDirectorsModule"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                htmlFor: "isDirectorsModule",
                                                                className: "fs0-9rem fw500 c15 cp",
                                                                children: "Directors Module (per-director answers)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bo5 bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-1rem fw600 c15 m0",
                                                children: "Module menus"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-8rem c15 op60",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: 'Configure dynamic menu items such as "How it works?", "Help" or "What is it?" for this module.'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        style: {
                                            gap: '0.75rem'
                                        },
                                        children: [
                                            (menusConfig || []).length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-85rem c15 op70 m0",
                                                children: 'No custom menus configured yet. Use "Add menu" to create one.'
                                            }),
                                            (menusConfig || []).map((menu)=>{
                                                const isExpanded = expandedMenuKey === menu.key;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "br8px bss bo5 bw1px p0-75rem bg1",
                                                    style: {
                                                        transition: 'all 0.2s ease'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            type: "button",
                                                            className: "df jcsb aic w100 cp",
                                                            onClick: ()=>setExpandedMenuKey(isExpanded ? null : menu.key),
                                                            style: {
                                                                background: 'transparent',
                                                                border: 'none',
                                                                padding: '0.5rem',
                                                                borderRadius: '6px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        gap: '0.5rem'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 fs0-95rem c15",
                                                                            children: menu.label || 'Untitled menu'
                                                                        }),
                                                                        menu.isActive === false && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fs0-7rem br10px px0-5rem py0-15rem",
                                                                            style: {
                                                                                background: '#ffecec',
                                                                                color: '#c62828'
                                                                            },
                                                                            children: "Inactive"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        gap: '0.5rem'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>handleRemoveMenu(menu.key),
                                                                            className: "fs0-8rem cp df aic jcc",
                                                                            style: {
                                                                                border: 'none',
                                                                                background: 'transparent',
                                                                                color: '#c62828',
                                                                                alignSelf: 'flex-start'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                                color: "error"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "df aic jcc",
                                                                            style: {
                                                                                color: '#666'
                                                                            },
                                                                            children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4623a154accf113$exports))), {
                                                                                fontSize: "small"
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                                                                                fontSize: "small"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        isExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "mt0-75rem dg px1rem",
                                                            style: {
                                                                gap: '1.25rem',
                                                                gridTemplateColumns: 'minmax(0, 1.4fr) minmax(0, 1fr)'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df fdc",
                                                                    style: {
                                                                        gap: '0.75rem'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fdc",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                    className: "fs0-85rem fw600 c15 mb0-25rem",
                                                                                    children: "Menu label"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "text",
                                                                                    value: menu.label || '',
                                                                                    onChange: (e)=>handleMenuChange(menu.key, 'label', e.target.value),
                                                                                    className: "br5px p0-5rem bo5 bss bw1px w100",
                                                                                    placeholder: "e.g. How It Works?"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df aic jcfs",
                                                                            style: {
                                                                                gap: '0.5rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: menu.isActive !== false,
                                                                                    onChange: (e)=>handleMenuChange(menu.key, 'isActive', e.target.checked),
                                                                                    id: `menu-active-${menu.key}`
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                    htmlFor: `menu-active-${menu.key}`,
                                                                                    className: "fs0-85rem fw500 c15 cp",
                                                                                    children: "Active menu"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df gg1rem",
                                                                            style: {
                                                                                gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "df fdc",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                            className: "fs0-85rem fw600 c15 mb0-25rem",
                                                                                            children: "Action type"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                                                            value: menu.actionType || 'navigate',
                                                                                            onChange: (e)=>handleMenuChange(menu.key, 'actionType', e.target.value),
                                                                                            className: "br5px p0-5rem bo5 bss bw1px w100",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                    value: "navigate",
                                                                                                    children: "Navigate (open URL)"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                    value: "modal",
                                                                                                    children: "Open modal"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                menu.actionType === 'modal' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "df fdc",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                            className: "fs0-85rem fw600 c15 mb0-25rem",
                                                                                            children: "Modal display type"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                                                            value: menu.modalDisplayType || 'contentAndImage',
                                                                                            onChange: (e)=>handleMenuChange(menu.key, 'modalDisplayType', e.target.value),
                                                                                            className: "br5px p0-5rem bo5 bss bw1px w100",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                value: "imageOnly",
                                                                                                children: "Image Only"
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        menu.actionType === 'navigate' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fdc",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                    className: "fs0-85rem fw600 c15 mb0-25rem",
                                                                                    children: "Target URL"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "text",
                                                                                    value: menu.navigateUrl || '',
                                                                                    onChange: (e)=>handleMenuChange(menu.key, 'navigateUrl', e.target.value),
                                                                                    className: "br5px p0-5rem bo5 bss bw1px w100",
                                                                                    placeholder: "https://example.com/help"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                    className: "fs0-75rem c15 op60 mt0-25rem",
                                                                                    children: "Must be a full URL (including https://). The link will open in a new tab."
                                                                                })
                                                                            ]
                                                                        }),
                                                                        menu.actionType === 'modal' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fdc",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                    className: "fs0-85rem fw600 c15 mb0-25rem",
                                                                                    children: "Modal title"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "text",
                                                                                    value: menu.modalTitle || '',
                                                                                    onChange: (e)=>handleMenuChange(menu.key, 'modalTitle', e.target.value),
                                                                                    className: "br5px p0-5rem bo5 bss bw1px w100",
                                                                                    placeholder: "Enter modal title"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        menu.actionType === 'modal' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "mt1rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                                                                imageURL: menu.modalImageURL,
                                                                                onImageChange: (url)=>handleMenuChange(menu.key, 'modalImageURL', url),
                                                                                label: "Modal image"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df fdc",
                                                                    style: {
                                                                        gap: '0.75rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                                                        imageURL: menu.iconURL,
                                                                        onImageChange: (url)=>handleMenuChange(menu.key, 'iconURL', url),
                                                                        label: "Menu icon"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, menu.key);
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic jcfe",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    type: "button",
                                                    onClick: handleAddMenu,
                                                    className: "df aic jcc cp mt0-5rem",
                                                    style: {
                                                        border: 'none',
                                                        background: '#4CAF50',
                                                        color: 'white',
                                                        padding: '10px 20px',
                                                        borderRadius: '8px',
                                                        fontSize: '0.95rem',
                                                        fontWeight: 500,
                                                        gap: '8px',
                                                        transition: 'all 0.2s ease',
                                                        boxShadow: '0 2px 6px rgba(76, 175, 80, 0.25)'
                                                    },
                                                    onMouseOver: (e)=>{
                                                        e.currentTarget.style.background = '#45a049';
                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(76, 175, 80, 0.35)';
                                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                                    },
                                                    onMouseOut: (e)=>{
                                                        e.currentTarget.style.background = '#4CAF50';
                                                        e.currentTarget.style.boxShadow = '0 2px 6px rgba(76, 175, 80, 0.25)';
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                                                            style: {
                                                                fontSize: '20px'
                                                            }
                                                        }),
                                                        "Add menu"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bo5 bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-1rem fw600 c15 m0",
                                                children: "Subscription & pricing"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-8rem c15 op60",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: "Per-tier pricing for this module"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "dg gg1rem module-form-grid",
                                        style: {
                                            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                style: {
                                                    gridColumn: '1 / -1'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "checkbox",
                                                        ...register('isPaid'),
                                                        className: "mr0-5rem",
                                                        id: "isPaid"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        htmlFor: "isPaid",
                                                        className: "fs0-9rem fw500 c15 cp",
                                                        children: "Paid module"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c15 op60 ml0-5rem",
                                                        children: "When enabled, this module requires payment"
                                                    })
                                                ]
                                            }),
                                            watchedValues.isPaid && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "fs0-9rem fw600 c15 mb0-5rem",
                                                                children: "Price Amount (\xa3) *"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: isEdit ? 'text' : 'number',
                                                                min: "0.01",
                                                                step: "0.01",
                                                                ...register('price'),
                                                                className: `br5px p0-5rem bss bw1px w100 ${errors.price ? 'bo12' : 'bo5'}`,
                                                                placeholder: "e.g. 99",
                                                                readOnly: isEdit,
                                                                style: isEdit ? {
                                                                    background: '#f5f5f5',
                                                                    cursor: 'not-allowed'
                                                                } : {}
                                                            }),
                                                            errors.price ? /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                className: "fs11px c12 mt0-25rem",
                                                                children: errors.price.message
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                className: "fs11px c15 op60 mt0-25rem",
                                                                children: isEdit ? "Price is set at creation \u2014 change via Stripe dashboard." : 'Amount in GBP. A Stripe product will be created automatically.'
                                                            })
                                                        ]
                                                    }),
                                                    isEdit && moduleData?.stripeProductPriceId && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "fs0-9rem fw600 c15 mb0-5rem",
                                                                children: "Stripe Price ID"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "text",
                                                                readOnly: true,
                                                                value: moduleData.stripeProductPriceId,
                                                                className: "br5px p0-5rem bss bw1px w100 bo5",
                                                                style: {
                                                                    background: '#f5f5f5',
                                                                    cursor: 'not-allowed',
                                                                    fontFamily: 'monospace',
                                                                    fontSize: '0.8rem'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                className: "fs11px c15 op60 mt0-25rem",
                                                                children: "Auto-generated Stripe price reference"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bo5 bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-1rem fw600 c15 m0",
                                                children: "Categories"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-8rem c15 op60",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: "Module behaviour and output configuration"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "dg gg1rem",
                                        style: {
                                            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Duration"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('duration'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "isReady",
                                                                children: "Is Ready"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "1 mins",
                                                                children: "1 mins"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "2 mins",
                                                                children: "2 mins"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "3mins",
                                                                children: "3 mins"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "5mins",
                                                                children: "5 mins"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "10mins",
                                                                children: "10 mins"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "15mins",
                                                                children: "15 mins"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "30mins",
                                                                children: "30 mins"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "2 days",
                                                                children: "2 days"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "NIL",
                                                                children: "NIL"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c15 op60 mt0-25rem",
                                                        children: "Estimated time to complete"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Completeness"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('completeness'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Yes",
                                                                children: "Yes"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "No",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Risks"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('risks'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Yes",
                                                                children: "Yes"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "No",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Pass / Fail"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('passFail'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Yes",
                                                                children: "Yes"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "No",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Certification"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('certification'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Yes",
                                                                children: "Yes"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "No",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('report'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Yes",
                                                                children: "Yes"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "No",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "fs0-9rem fw600 c15 mb0-5rem",
                                                        children: "Workflow Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        ...register('workflowReport'),
                                                        className: "br5px p0-5rem bss bw1px w100 bo5",
                                                        style: {
                                                            padding: '0.5rem',
                                                            fontSize: '0.95rem',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Yes",
                                                                children: "Yes"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "No",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            watch('certification') === 'Yes' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bss bw1px br8px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1',
                                    borderColor: '#e5e7eb',
                                    marginTop: '0.5rem'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b11d3f88abc513b5$export$2e2bcd8739ae039), {
                                    rules: certificationRules,
                                    onChange: setCertificationRules
                                })
                            }),
                            !watchedValues.isReportModule && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1',
                                    borderColor: generationMode === 'ai' ? '#4c6ef5' : generationMode === 'upload' ? '#40dda1' : '#e2e8f0'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.75rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        className: "fs1rem fw600 c15 m0",
                                                        children: "Content Generation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs0-8rem c15 m0 mt0-25rem",
                                                        style: {
                                                            opacity: 0.6
                                                        },
                                                        children: "Choose how sections and questions are created for this module."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df bg1 br999 bss bo5 bw1px p0-25rem",
                                                style: {
                                                    gap: '0.25rem',
                                                    alignSelf: 'flex-start'
                                                },
                                                children: [
                                                    {
                                                        key: 'manual',
                                                        label: 'Manual'
                                                    },
                                                    {
                                                        key: 'ai',
                                                        label: 'AI Generate'
                                                    },
                                                    {
                                                        key: 'upload',
                                                        label: 'File Upload'
                                                    }
                                                ].map(({ key: key, label: label })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        type: "button",
                                                        onClick: ()=>setGenerationMode(key),
                                                        className: `br20px px0-75rem py0-5rem fs0-8rem fw600 td250 cp ${generationMode === key ? 'bg3 c1' : 'bg1 c15'}`,
                                                        style: {
                                                            border: 'none',
                                                            minWidth: '100px'
                                                        },
                                                        children: [
                                                            key === 'ai' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    marginRight: '0.3rem'
                                                                },
                                                                children: "\u2726"
                                                            }),
                                                            key === 'upload' && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: "fas fa-file-upload",
                                                                style: {
                                                                    marginRight: '0.35rem',
                                                                    fontSize: '0.75rem'
                                                                }
                                                            }),
                                                            label
                                                        ]
                                                    }, key))
                                            })
                                        ]
                                    }),
                                    generationMode === 'upload' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p1rem br8px mb1rem",
                                                style: {
                                                    background: '#e8fdf3',
                                                    border: '1px solid #a5d6a7'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-85rem fw500 m0",
                                                    style: {
                                                        color: '#1b5e20'
                                                    },
                                                    children: [
                                                        "Upload an xlsx, xls, or csv file. Required columns: Section, Question. Supported columns: Sub-section, Question Type, Tool Tip, Tool Box, Risk Description, Recommendation, Risk Score, Attachment Required, Options, Info if Yes, Info if No, Risk if Yes, Risk if No, Reference. Click ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Download Sample"
                                                        }),
                                                        " above to get the template. After parsing, select which objective \xd7 tier combinations to populate."
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e633b11a091cb1ab$export$2e2bcd8739ae039), {
                                                moduleKey: watchedValues.moduleKey,
                                                parsedData: excelParsedData,
                                                importedVariants: excelImportedVariants,
                                                onParsed: (data)=>{
                                                    setExcelParsedData(data);
                                                    setExcelImportedVariants([]);
                                                    setExcelVariantModalOpen(true);
                                                },
                                                onApply: ()=>setExcelVariantModalOpen(true),
                                                onReselect: ()=>setExcelVariantModalOpen(true)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af3346b9c959d0b3$export$2e2bcd8739ae039), {
                                                open: excelVariantModalOpen,
                                                parsedData: excelParsedData,
                                                moduleKey: watchedValues.moduleKey,
                                                onConfirm: (selectedVariants)=>handleExcelImport(selectedVariants, excelParsedData),
                                                onClose: ()=>setExcelVariantModalOpen(false)
                                            })
                                        ]
                                    }),
                                    generationMode === 'ai' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "p1rem br8px mb1rem",
                                                style: {
                                                    background: '#eef2ff',
                                                    border: '1px solid #c7d2fe'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs0-85rem fw500 m0",
                                                    style: {
                                                        color: '#3730a3'
                                                    },
                                                    children: "\u2726 AI will automatically generate sections and questions for all 9 combinations (3 objectives \xd7 3 tiers) using GPT-4. You can edit the content after generation completes."
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "dg gg1rem",
                                                style: {
                                                    gridTemplateColumns: '1fr 1fr'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "fs0-85rem fw600 c15 mb0-5rem",
                                                                children: "Sections per combination"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "number",
                                                                min: 1,
                                                                max: 15,
                                                                value: aiConfig.sectionsPerCombo,
                                                                onChange: (e)=>setAiConfig((prev)=>({
                                                                            ...prev,
                                                                            sectionsPerCombo: Math.min(15, Math.max(1, parseInt(e.target.value) || 5))
                                                                        })),
                                                                className: "br5px p0-5rem bss bw1px bo5 w100"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                className: "fs11px c15 op60 mt0-25rem",
                                                                children: "1\u201315 sections per objective \xd7 tier combo (default 5)"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "fs0-85rem fw600 c15 mb0-5rem",
                                                                children: "Questions per section"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "number",
                                                                min: 5,
                                                                max: 15,
                                                                value: aiConfig.questionsPerSection,
                                                                onChange: (e)=>setAiConfig((prev)=>({
                                                                            ...prev,
                                                                            questionsPerSection: Math.min(15, Math.max(5, parseInt(e.target.value) || 10))
                                                                        })),
                                                                className: "br5px p0-5rem bss bw1px bo5 w100"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                className: "fs11px c15 op60 mt0-25rem",
                                                                children: "5\u201315 questions per section (default 10)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs0-78rem c15 mt1rem m0",
                                                style: {
                                                    opacity: 0.5
                                                },
                                                children: [
                                                    "Estimated output: ",
                                                    9 * aiConfig.sectionsPerCombo,
                                                    " sections and ",
                                                    9 * aiConfig.sectionsPerCombo * aiConfig.questionsPerSection,
                                                    " questions. Generation runs in the background (~5\u201315 minutes)."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isInvestorLead ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "section-container",
                                style: {
                                    marginTop: '3rem',
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-4rem fw600 c15 mb1rem",
                                        style: {
                                            letterSpacing: '-0.02em',
                                            margin: 0
                                        },
                                        children: "Investment Objective"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-85rem c15 op70 mb1-5rem",
                                        children: "Edit the Investor Lead section (DEPF008) and its questions directly. Each question is saved individually."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d42fd2067c31d9d2$export$2e2bcd8739ae039), {})
                                ]
                            }) : isInvestmentReadiness ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "section-container",
                                style: {
                                    marginTop: '3rem',
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-4rem fw600 c15 mb1rem",
                                        style: {
                                            letterSpacing: '-0.02em',
                                            margin: 0
                                        },
                                        children: "Investment Readiness Questions"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-85rem c15 op70 mb1-5rem",
                                        children: "Edit the 25 Investment Readiness questions directly. Each question is saved individually."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b8b88ae8fdee83e$export$2e2bcd8739ae039), {
                                        ref: irQuestionsRef
                                    })
                                ]
                            }) : isExitReadiness ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "section-container",
                                style: {
                                    marginTop: '3rem',
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-4rem fw600 c15 mb1rem",
                                        style: {
                                            letterSpacing: '-0.02em',
                                            margin: 0
                                        },
                                        children: "Exit Readiness Questions"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-85rem c15 op70 mb1-5rem",
                                        children: "Edit Exit Readiness questions directly. Each question is saved individually."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9bc8d0d510833d0$export$2e2bcd8739ae039), {})
                                ]
                            }) : watchedValues.isReportModule ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "section-container",
                                style: {
                                    marginTop: '3rem',
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-4rem fw600 c15 mb1rem",
                                        style: {
                                            letterSpacing: '-0.02em',
                                            margin: 0
                                        },
                                        children: "Report Module \u2014 Card Assignment"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-85rem c15 op70 mb1-5rem",
                                        children: 'Assign a dashboard card per Company Objective and Subscription Tier, or select "No card" to hide this module for that combination.'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcsb aic mb0-5rem",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.5rem'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-85rem fw600 c15",
                                                    children: "Company objective"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df bg1 br999 bss bo5 bw1px p0-25rem",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.25rem'
                                                },
                                                children: [
                                                    ...$7cde4a2f681457f4$var$COMPANY_OBJECTIVES
                                                ].map((obj)=>{
                                                    const isActive = selectedObjective === obj;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            setSelectedObjective(obj);
                                                            setSelectedTier(obj === $7cde4a2f681457f4$var$OBJECTIVE_ALL ? $7cde4a2f681457f4$var$TIER_ALL : $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS[0]);
                                                        },
                                                        className: `br20px px0-75rem py0-75rem fs0-75rem fw500 td250 cp ${isActive ? 'bg3 c1' : 'bg1 c15'}`,
                                                        style: {
                                                            border: 'none',
                                                            minWidth: '90px',
                                                            textTransform: 'capitalize'
                                                        },
                                                        children: obj === $7cde4a2f681457f4$var$OBJECTIVE_ALL ? 'All objectives' : obj
                                                    }, obj);
                                                })
                                            })
                                        ]
                                    }),
                                    selectedObjective !== $7cde4a2f681457f4$var$OBJECTIVE_ALL ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcsb aic mb0-5rem",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.5rem'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem fw600 c15",
                                                    children: "Subscription tier"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.5rem'
                                                },
                                                children: $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS.map((tier)=>{
                                                    const isActive = selectedTier === tier;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setSelectedTier(tier),
                                                        className: `br20px px1-5rem py0-75rem fs0-75rem fw500 td250 cp ${isActive ? 'bg7 c1' : 'bg1 c15'}`,
                                                        style: {
                                                            border: '1px solid var(--border, #e0e0e0)'
                                                        },
                                                        children: tier
                                                    }, tier);
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-85rem fw600 c15",
                                                children: "Subscription tier"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs0-75rem c15 op70 mt0-25rem mb0",
                                                children: [
                                                    "Applies to ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: "all tiers"
                                                    }),
                                                    ' because "All objectives" is selected.'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        style: {
                                            gap: '0.75rem',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs0-9rem fw600 c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: selectedObjective
                                                    }),
                                                    " \u2192 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: selectedTier
                                                    }),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                value: placementsByVariant[currentVariantKey] || '',
                                                onChange: (e)=>{
                                                    const value = e.target.value;
                                                    setPlacementsByVariant((prev)=>({
                                                            ...prev,
                                                            [currentVariantKey]: value
                                                        }));
                                                },
                                                className: "br5px p0-5rem bss bw1px",
                                                style: {
                                                    cursor: 'pointer',
                                                    minWidth: '220px',
                                                    maxWidth: '100%'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "",
                                                        children: "No card"
                                                    }),
                                                    (dashboardCards || []).map((card)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: card._id,
                                                            children: card.title || card.subTitle || card._id
                                                        }, card._id))
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "section-container",
                                style: {
                                    marginTop: '3rem',
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-4rem fw600 c15 mb1rem",
                                        style: {
                                            letterSpacing: '-0.02em',
                                            margin: 0
                                        },
                                        children: "Module Sections"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs0-85rem c15 op70 mb1-5rem",
                                        children: "Add sections per Company Objective and Subscription Tier. Each combination (e.g. Investment \u2192 Pro) can have its own sections."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df jcsb aic mb0-5rem",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.5rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-85rem fw600 c15",
                                                        children: "Company objective"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem c15 op60",
                                                        style: {
                                                            minWidth: 0,
                                                            maxWidth: '100%'
                                                        },
                                                        children: "Choose the high\u2013level goal this set of sections targets."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df bg1 br999 bss bo5 bw1px p0-25rem",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.25rem'
                                                },
                                                children: [
                                                    ...$7cde4a2f681457f4$var$COMPANY_OBJECTIVES
                                                ].map((obj)=>{
                                                    const isActive = selectedObjective === obj;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>{
                                                            setSelectedObjective(obj);
                                                            setSelectedTier(obj === $7cde4a2f681457f4$var$OBJECTIVE_ALL ? $7cde4a2f681457f4$var$TIER_ALL : $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS[0]);
                                                        },
                                                        className: `br20px px0-75rem py0-75rem fs0-75rem fw500 td250 cp ${isActive ? 'bg3 c1' : 'bg1 c15'}`,
                                                        style: {
                                                            border: 'none',
                                                            minWidth: '90px',
                                                            textTransform: 'capitalize'
                                                        },
                                                        children: obj === $7cde4a2f681457f4$var$OBJECTIVE_ALL ? 'All objectives' : obj
                                                    }, obj);
                                                })
                                            })
                                        ]
                                    }),
                                    selectedObjective !== $7cde4a2f681457f4$var$OBJECTIVE_ALL ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df jcsb aic mb0-5rem",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.5rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem fw600 c15",
                                                        children: "Subscription tier"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem c15 op60",
                                                        style: {
                                                            minWidth: 0
                                                        },
                                                        children: "Sections will only appear for companies on the selected tier."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df",
                                                style: {
                                                    flexWrap: 'wrap',
                                                    gap: '0.5rem'
                                                },
                                                children: $7cde4a2f681457f4$var$SUBSCRIPTION_TIERS.map((tier)=>{
                                                    const isActive = selectedTier === tier;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setSelectedTier(tier),
                                                        className: `br20px px1-5rem py0-75rem fs0-75rem fw500 td250 cp  ${isActive ? 'bg7 c1' : 'bg1 c15'}`,
                                                        style: {
                                                            border: '1px solid var(--border, #e0e0e0)'
                                                        },
                                                        children: tier
                                                    }, tier);
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-85rem fw600 c15",
                                                children: "Subscription tier"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs0-75rem c15 op70 mt0-25rem mb0",
                                                children: [
                                                    "Applies to ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                        children: "all tiers"
                                                    }),
                                                    ' because "All objectives" is selected.'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1-5rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.75rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc aifs jcfs tal",
                                                style: {
                                                    minWidth: 0,
                                                    flex: '1 1 200px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs1rem c15 w100 tal",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: selectedObjective
                                                            }),
                                                            " \u2192 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                children: selectedTier
                                                            }),
                                                            currentSections.length > 0 && ` (${currentSections.length} section${currentSections.length !== 1 ? 's' : ''})`
                                                        ]
                                                    }),
                                                    sectionErrors._form && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                        className: "fs11px c12 mt0-25rem",
                                                        children: sectionErrors._form
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcfe",
                                                style: {
                                                    gap: '0.75rem',
                                                    flexWrap: 'wrap',
                                                    flex: '1 1 auto',
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        className: "df aic cp",
                                                        style: {
                                                            gap: '8px',
                                                            userSelect: 'none'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: !!sectionRestrictionsByVariant[currentVariantKey],
                                                                onChange: (e)=>{
                                                                    setSectionRestrictionsByVariant((prev)=>({
                                                                            ...prev,
                                                                            [currentVariantKey]: e.target.checked
                                                                        }));
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "fs0-85rem c15",
                                                                children: [
                                                                    "Is Restricted for ",
                                                                    selectedTier,
                                                                    "?"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        value: placementsByVariant[currentVariantKey] || '',
                                                        onChange: (e)=>{
                                                            const value = e.target.value;
                                                            setPlacementsByVariant((prev)=>({
                                                                    ...prev,
                                                                    [currentVariantKey]: value
                                                                }));
                                                        },
                                                        className: "br5px p0-5rem bss bw1px",
                                                        style: {
                                                            cursor: 'pointer',
                                                            minWidth: '180px',
                                                            maxWidth: '100%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "",
                                                                children: "No card (hidden for this combo)"
                                                            }),
                                                            (dashboardCards || []).map((card)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: card._id,
                                                                    children: card.title || card.subTitle || card._id
                                                                }, card._id))
                                                        ]
                                                    }),
                                                    cloneTargetOptions.length > 0 && currentSections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        type: "button",
                                                        onClick: openBulkCloneModal,
                                                        className: "df aic jcc cp",
                                                        style: {
                                                            border: '1px solid #2196F3',
                                                            background: 'white',
                                                            color: '#2196F3',
                                                            padding: '10px 16px',
                                                            borderRadius: '8px',
                                                            fontSize: '0.9rem',
                                                            fontWeight: '500',
                                                            gap: '6px',
                                                            transition: 'all 0.2s ease'
                                                        },
                                                        onMouseOver: (e)=>{
                                                            e.currentTarget.style.background = '#2196F315';
                                                        },
                                                        onMouseOut: (e)=>{
                                                            e.currentTarget.style.background = 'white';
                                                        },
                                                        title: "Clone all sections to objective/tier targets",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e64b66a0287a27e1$exports))), {
                                                                style: {
                                                                    fontSize: '18px'
                                                                }
                                                            }),
                                                            "Clone sections"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        type: "button",
                                                        onClick: addSection,
                                                        className: "df aic jcc cp",
                                                        style: {
                                                            border: 'none',
                                                            background: '#4CAF50',
                                                            color: 'white',
                                                            padding: '10px 20px',
                                                            borderRadius: '8px',
                                                            fontSize: '0.95rem',
                                                            fontWeight: '500',
                                                            gap: '8px',
                                                            transition: 'all 0.2s ease',
                                                            boxShadow: '0 2px 6px rgba(76, 175, 80, 0.25)'
                                                        },
                                                        onMouseOver: (e)=>{
                                                            e.currentTarget.style.background = '#45a049';
                                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(76, 175, 80, 0.35)';
                                                            e.currentTarget.style.transform = 'translateY(-1px)';
                                                        },
                                                        onMouseOut: (e)=>{
                                                            e.currentTarget.style.background = '#4CAF50';
                                                            e.currentTarget.style.boxShadow = '0 2px 6px rgba(76, 175, 80, 0.25)';
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                                                                style: {
                                                                    fontSize: '20px'
                                                                }
                                                            }),
                                                            "Add Section"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    cloneModalOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            position: 'fixed',
                                            inset: 0,
                                            background: 'rgba(0,0,0,0.4)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 9999
                                        },
                                        onClick: handleCloneCancel,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "bg1 br12px p2rem",
                                            style: {
                                                maxWidth: '480px',
                                                width: '90%',
                                                boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
                                            },
                                            onClick: (e)=>e.stopPropagation(),
                                            children: cloneView === 'select' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "fs1-1rem fw600 c15 mb1rem",
                                                        style: {
                                                            margin: 0
                                                        },
                                                        children: cloneMode === 'bulk' ? 'Clone sections to objective/tier' : 'Clone section to objective/tier'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs0-9rem c15 op70 mb1-5rem",
                                                        children: cloneMode === 'bulk' ? `Clone all ${currentSections.length} section(s) from ${selectedObjective} \u{2192} ${selectedTier} into:` : `Clone this section into which objective/tier target(s)?`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc",
                                                        style: {
                                                            gap: '0.75rem',
                                                            marginBottom: '1.5rem'
                                                        },
                                                        children: cloneTargetOptions.map((target)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "df aic cp",
                                                                style: {
                                                                    gap: '0.5rem'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        type: "checkbox",
                                                                        checked: cloneTargets.includes(target.key),
                                                                        onChange: ()=>toggleCloneTarget(target.key)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs0-95rem fw500",
                                                                        children: target.label
                                                                    })
                                                                ]
                                                            }, target.key))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcfe",
                                                        style: {
                                                            gap: '0.75rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                onClick: handleCloneCancel,
                                                                className: "br5px px1rem py0-5rem fw500",
                                                                style: {
                                                                    border: '1px solid #ddd',
                                                                    background: 'white',
                                                                    color: '#333'
                                                                },
                                                                children: "Cancel"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                onClick: ()=>handleCloneConfirm(false),
                                                                disabled: cloneTargets.length === 0,
                                                                className: "br5px px1rem py0-5rem fw500",
                                                                style: {
                                                                    border: 'none',
                                                                    background: cloneTargets.length === 0 ? '#ccc' : '#2196F3',
                                                                    color: 'white',
                                                                    cursor: cloneTargets.length === 0 ? 'not-allowed' : 'pointer'
                                                                },
                                                                children: "Clone"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "fs1-1rem fw600 c15 mb1rem",
                                                        style: {
                                                            margin: 0
                                                        },
                                                        children: "Section number conflict"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "br8px p1rem mb1-5rem",
                                                        style: {
                                                            background: '#fff8e6',
                                                            border: '1px solid #ffc107',
                                                            color: '#856404'
                                                        },
                                                        children: [
                                                            cloneConflictConflicts.length === 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "fs0-9rem m0",
                                                                style: {
                                                                    lineHeight: 1.5
                                                                },
                                                                children: [
                                                                    "You are trying to clone ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                        children: cloneConflictConflicts[0].sectionNo
                                                                    }),
                                                                    " into",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                                        children: [
                                                                            cloneConflictConflicts[0].objective,
                                                                            " \u2013 ",
                                                                            cloneConflictConflicts[0].tier
                                                                        ]
                                                                    }),
                                                                    ", but a section with the same number (",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                        children: cloneConflictConflicts[0].sectionNo
                                                                    }),
                                                                    ") already exists in",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                                                        children: [
                                                                            cloneConflictConflicts[0].objective,
                                                                            " \u2013 ",
                                                                            cloneConflictConflicts[0].tier
                                                                        ]
                                                                    }),
                                                                    "."
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs0-9rem m0",
                                                                style: {
                                                                    lineHeight: 1.5
                                                                },
                                                                children: "The following sections already exist in the target tier(s):"
                                                            }),
                                                            cloneConflictConflicts.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                className: "fs0-9rem mt0-5rem mb0",
                                                                style: {
                                                                    paddingLeft: '1.25rem',
                                                                    lineHeight: 1.6
                                                                },
                                                                children: cloneConflictConflicts.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                                                children: c.sectionNo
                                                                            }),
                                                                            " in ",
                                                                            c.objective,
                                                                            " \u2013 ",
                                                                            c.tier
                                                                        ]
                                                                    }, i))
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "fs0-9rem mt1rem mb0",
                                                                style: {
                                                                    lineHeight: 1.5
                                                                },
                                                                children: [
                                                                    "Do you want to overwrite the existing section",
                                                                    cloneConflictConflicts.length !== 1 ? 's' : '',
                                                                    ", or cancel this operation?"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcfe",
                                                        style: {
                                                            gap: '0.75rem'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                onClick: handleCloneCancel,
                                                                className: "br5px px1rem py0-5rem fw500",
                                                                style: {
                                                                    border: '1px solid #ddd',
                                                                    background: 'white',
                                                                    color: '#333'
                                                                },
                                                                children: "Cancel"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                type: "button",
                                                                onClick: handleCloneOverwrite,
                                                                className: "br5px px1rem py0-5rem fw500",
                                                                style: {
                                                                    border: 'none',
                                                                    background: '#2196F3',
                                                                    color: 'white',
                                                                    cursor: 'pointer'
                                                                },
                                                                children: "Overwrite"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    currentSections.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "br12px p3rem tac",
                                        style: {
                                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            border: '2px dashed #dee2e6'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic jcc",
                                                style: {
                                                    marginBottom: '1rem'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($797bfd41c3873478$exports))), {
                                                    style: {
                                                        fontSize: '64px',
                                                        color: '#dee2e6'
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs1-1rem fw500 mb0-75rem",
                                                style: {
                                                    color: '#495057',
                                                    margin: '0 0 0.5rem 0'
                                                },
                                                children: [
                                                    "No sections for ",
                                                    selectedObjective,
                                                    " \u2192 ",
                                                    selectedTier
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-9rem",
                                                style: {
                                                    color: '#6c757d',
                                                    margin: 0
                                                },
                                                children: 'Click "Add Section" to add a section for this objective and tier'
                                            })
                                        ]
                                    }),
                                    currentSections.map((section, sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a13b03ac67792126$export$2e2bcd8739ae039), {
                                            section: section,
                                            index: sIdx,
                                            moduleKey: watchedValues.moduleKey,
                                            isExpanded: expandedSectionIndex === sIdx,
                                            onToggleExpand: ()=>setExpandedSectionIndex(expandedSectionIndex === sIdx ? null : sIdx),
                                            onUpdate: (updatedSection)=>updateSection(effectiveVariantKey, sIdx, updatedSection),
                                            onRemove: ()=>removeSection(effectiveVariantKey, sIdx),
                                            isDeletePending: pendingSectionDeleteKeys.has(section?._id ? `id:${String(section._id)}` : `variant:${effectiveVariantKey}:sectionNo:${String(section?.sectionNo || '').trim()}`),
                                            onDeleteQuestion: async (questionId)=>{
                                                const debounceKey = `question-${questionId || `${effectiveVariantKey}-${sIdx}`}`;
                                                if (acquireDeleteLock(debounceKey)) return false;
                                                if (!isEdit || !questionId) return true;
                                                const response = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/temp-questions/${questionId}`);
                                                return response?.code === 200;
                                            },
                                            onClone: cloneTargetOptions.length > 0 ? ()=>openSingleCloneModal(section) : undefined,
                                            errors: sectionErrors[`${effectiveVariantKey}-${sIdx}`] || {}
                                        }, `${effectiveVariantKey}-${sIdx}`))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcfe gg1rem mt1rem",
                                style: {
                                    gap: '1rem',
                                    gridColumn: '1 / -1',
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: onCancel,
                                        className: "bg1 bo4 bss bw1px br5px px1rem py0-5rem fw600 c4 td250 cp",
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "submit",
                                        className: "bg3 bo3 bss bw1px br5px px1rem py0-5rem fw600 c1 td250 cp",
                                        children: isEdit ? 'Update Module' : 'Create Module'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px bss bo5 bw1px p1-5rem",
                                style: {
                                    gridColumn: '1 / -1'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic mb1rem",
                                        style: {
                                            flexWrap: 'wrap',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-1rem fw600 c15 m0",
                                                children: "Module card preview"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-8rem c15 op60",
                                                style: {
                                                    minWidth: 0
                                                },
                                                children: "Updates live as you edit"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a400058e46cbe608$export$2e2bcd8739ae039), {
                                        moduleData: watchedValues
                                    })
                                ]
                            })
                        ]
                    }, "module-form")
                ]
            }),
            showPriorityConfirm && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pf t0 l0 w100 h100vh df aic jcc",
                style: {
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 10000
                },
                onClick: ()=>setShowPriorityConfirm(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow br20px p2rem df fdc",
                    style: {
                        maxWidth: '500px',
                        width: '90%'
                    },
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "c15 fs1-75rem fw600 tac mb1rem",
                            children: "Priorities Already Set"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1rem fw400 c15 op70 tac mb1-5rem",
                            children: "AI priorities have already been generated for this module. Do you want to regenerate them?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            text: "Yes, Regenerate",
                            onClick: handleConfirmPriorityRegen,
                            btnType: "default",
                            customClassName: "w100"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            onClick: ()=>setShowPriorityConfirm(false),
                            className: "w100 tac mt0-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs14px cp",
                                style: {
                                    color: '#15131380'
                                },
                                children: "Cancel"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $7cde4a2f681457f4$export$2e2bcd8739ae039 = $7cde4a2f681457f4$var$ModuleForm;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $a8Wtc = parcelRequire("a8Wtc");
const $138620d196adaf4d$var$STATUS_LABELS = {
    pending: "Initializing\u2026",
    running: "Generating\u2026",
    completed: 'Completed',
    partial: 'Completed with warnings',
    failed: 'Failed'
};
const $138620d196adaf4d$var$STATUS_COLORS = {
    pending: '#f59e0b',
    running: '#4c6ef5',
    completed: '#10b981',
    partial: '#f59e0b',
    failed: '#ef4444'
};
const $138620d196adaf4d$var$isTerminal = (s)=>s === 'completed' || s === 'partial' || s === 'failed';
const $138620d196adaf4d$var$ProgressBar = ({ value: value, max: max, color: color })=>{
    const pct = max > 0 ? Math.min(100, Math.round(value / max * 100)) : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            height: 8,
            background: '#e9ecef',
            borderRadius: 99,
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                height: '100%',
                width: `${pct}%`,
                background: color,
                borderRadius: 99,
                transition: 'width 0.6s ease'
            }
        })
    });
};
const $138620d196adaf4d$var$AIGenerationProgress = ({ jobId: jobId, moduleId: moduleId, moduleName: moduleName, moduleImageUrl: moduleImageUrl, estimatedSections: estimatedSections = 0, estimatedQuestions: estimatedQuestions = 0, onComplete: onComplete, onViewModule: onViewModule })=>{
    const [job, setJob] = (0, $acw62.useState)(null);
    const [avatarLoadFailed, setAvatarLoadFailed] = (0, $acw62.useState)(false);
    const completedFiredRef = (0, $acw62.useRef)(false);
    const trimmedImageUrl = moduleImageUrl && String(moduleImageUrl).trim();
    const avatarSrc = !trimmedImageUrl || avatarLoadFailed ? $a8Wtc : trimmedImageUrl;
    // ── Merge incoming data into job state ──────────────────────────────────
    const mergeJob = (patch)=>setJob((prev)=>({
                ...prev || {},
                ...patch
            }));
    // ── Socket.io listeners ─────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!jobId || !(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)) return;
        const onProgress = (data)=>{
            if (data.jobId !== jobId) return;
            mergeJob({
                status: 'running',
                progress: data
            });
        };
        const onDone = (data)=>{
            if (data.jobId !== jobId) return;
            mergeJob({
                ...data
            });
        };
        const onError = (data)=>{
            if (data.jobId !== jobId) return;
            mergeJob({
                status: 'failed',
                error: data.error
            });
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('aiGeneration:progress', onProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('aiGeneration:complete', onDone);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('aiGeneration:error', onError);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('aiGeneration:progress', onProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('aiGeneration:complete', onDone);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('aiGeneration:error', onError);
        };
    }, [
        jobId
    ]);
    (0, $acw62.useEffect)(()=>{
        setAvatarLoadFailed(false);
    }, [
        trimmedImageUrl
    ]);
    // ── Fire onComplete callback once on terminal state ─────────────────────
    (0, $acw62.useEffect)(()=>{
        if (job && $138620d196adaf4d$var$isTerminal(job.status) && !completedFiredRef.current) {
            completedFiredRef.current = true;
            if (onComplete) onComplete(job);
        }
    }, [
        job?.status
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // ── Derived values ──────────────────────────────────────────────────────
    const status = job?.status || 'pending';
    const progress = job?.progress || {};
    const result = job?.result || {};
    const sectionsCreated = progress.sectionsCreated ?? result.sectionsCreated ?? 0;
    const questionsCreated = progress.questionsCreated ?? result.questionsCreated ?? 0;
    const completedCombos = progress.completedCombos ?? 0;
    const totalCombos = progress.totalCombos ?? 9;
    const statusColor = $138620d196adaf4d$var$STATUS_COLORS[status];
    // ── Render ──────────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            padding: '2rem',
            maxWidth: '680px',
            margin: '0 auto'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg1 shadow br10px p2rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic mb2rem",
                    style: {
                        gap: '1rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                position: 'relative',
                                width: 48,
                                height: 48,
                                borderRadius: '50%',
                                flexShrink: 0,
                                overflow: 'hidden',
                                boxShadow: `0 0 0 2px ${statusColor}33`
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    alt: "",
                                    src: avatarSrc,
                                    onError: ()=>setAvatarLoadFailed(true),
                                    style: {
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        display: 'block',
                                        background: statusColor + '18'
                                    }
                                }),
                                (status === 'running' || status === 'pending') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        position: 'absolute',
                                        inset: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: 'rgba(0,0,0,0.4)'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "loader",
                                        style: {
                                            width: 22,
                                            height: 22
                                        }
                                    })
                                }),
                                status === 'completed' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "aria-hidden": true,
                                    style: {
                                        position: 'absolute',
                                        right: -1,
                                        bottom: -1,
                                        width: 18,
                                        height: 18,
                                        borderRadius: '50%',
                                        background: '#10b981',
                                        color: '#fff',
                                        fontSize: '0.65rem',
                                        fontWeight: 800,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.25)'
                                    },
                                    children: "\u2713"
                                }),
                                status === 'partial' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "aria-hidden": true,
                                    style: {
                                        position: 'absolute',
                                        right: -1,
                                        bottom: -1,
                                        width: 18,
                                        height: 18,
                                        borderRadius: '50%',
                                        background: '#f59e0b',
                                        color: '#fff',
                                        fontSize: '0.65rem',
                                        fontWeight: 800,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.25)'
                                    },
                                    children: "\u26A0"
                                }),
                                status === 'failed' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "aria-hidden": true,
                                    style: {
                                        position: 'absolute',
                                        right: -1,
                                        bottom: -1,
                                        width: 18,
                                        height: 18,
                                        borderRadius: '50%',
                                        background: '#ef4444',
                                        color: '#fff',
                                        fontSize: '0.65rem',
                                        fontWeight: 800,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.25)'
                                    },
                                    children: "\u2717"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                flex: 1,
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-25rem fw600 c15 m0",
                                    children: "AI Content Generation"
                                }),
                                moduleName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-85rem c15 m0",
                                    style: {
                                        opacity: 0.6
                                    },
                                    children: moduleName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                background: statusColor + '18',
                                color: statusColor,
                                padding: '0.3rem 0.9rem',
                                borderRadius: '99px',
                                fontSize: '0.78rem',
                                fontWeight: 600,
                                whiteSpace: 'nowrap'
                            },
                            children: $138620d196adaf4d$var$STATUS_LABELS[status]
                        })
                    ]
                }),
                (status === 'running' || status === 'pending') && progress.currentCombo && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb1-5rem p0-75rem br8px",
                    style: {
                        background: '#eef2ff',
                        border: '1px solid #c7d2fe'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fs0-85rem fw500 m0",
                        style: {
                            color: '#4c6ef5'
                        },
                        children: [
                            progress.step === 'section_generation' ? 'Generating sections for' : 'Generating questions for',
                            ' ',
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: progress.currentCombo
                            }),
                            progress.currentSection && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    color: '#374151',
                                    fontWeight: 400
                                },
                                children: [
                                    ' ',
                                    "\u203A ",
                                    progress.currentSection
                                ]
                            })
                        ]
                    })
                }),
                status === 'failed' && job?.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb1-5rem p0-75rem br8px",
                    style: {
                        background: '#fef2f2',
                        border: '1px solid #fca5a5'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-85rem m0",
                        style: {
                            color: '#dc2626'
                        },
                        children: job.error
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                        marginBottom: '1.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb aic mb0-25rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-8rem fw600 c15",
                                            children: "Objective \xd7 Tier combinations"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs0-8rem c15",
                                            style: {
                                                opacity: 0.55
                                            },
                                            children: [
                                                completedCombos,
                                                " / ",
                                                totalCombos
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($138620d196adaf4d$var$ProgressBar, {
                                    value: completedCombos,
                                    max: totalCombos,
                                    color: statusColor
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb aic mb0-25rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-8rem fw600 c15",
                                            children: "Sections created"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs0-8rem c15",
                                            style: {
                                                opacity: 0.55
                                            },
                                            children: [
                                                sectionsCreated,
                                                estimatedSections ? ` / ~${estimatedSections}` : ''
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($138620d196adaf4d$var$ProgressBar, {
                                    value: sectionsCreated,
                                    max: estimatedSections || sectionsCreated || 1,
                                    color: "#8b5cf6"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb aic mb0-25rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-8rem fw600 c15",
                                            children: "Questions created"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs0-8rem c15",
                                            style: {
                                                opacity: 0.55
                                            },
                                            children: [
                                                questionsCreated,
                                                estimatedQuestions ? ` / ~${estimatedQuestions}` : ''
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($138620d196adaf4d$var$ProgressBar, {
                                    value: questionsCreated,
                                    max: estimatedQuestions || questionsCreated || 1,
                                    color: "#10b981"
                                })
                            ]
                        })
                    ]
                }),
                status === 'partial' && (result.partialFailures || 0) > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p0-75rem br8px mb1-5rem",
                    style: {
                        background: '#fffbeb',
                        border: '1px solid #fde68a'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fs0-85rem m0",
                        style: {
                            color: '#92400e'
                        },
                        children: [
                            result.partialFailures,
                            " combination(s) had GPT errors and were skipped. You can manually add sections for those combinations in the module editor."
                        ]
                    })
                }),
                (status === 'completed' || status === 'partial') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "p0-75rem br8px mb1-5rem",
                    style: {
                        background: '#f0fdf4',
                        border: '1px solid #bbf7d0'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fs0-85rem m0 fw500",
                        style: {
                            color: '#15803d'
                        },
                        children: [
                            "Generated ",
                            sectionsCreated,
                            " sections and ",
                            questionsCreated,
                            " questions successfully."
                        ]
                    })
                }),
                $138620d196adaf4d$var$isTerminal(status) && onViewModule && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic",
                    style: {
                        gap: '1rem',
                        marginTop: '0.5rem'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: onViewModule,
                        style: {
                            background: '#4c6ef5',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            padding: '0.6rem 1.5rem',
                            fontWeight: 600,
                            fontSize: '0.9rem',
                            cursor: 'pointer'
                        },
                        children: "Go to Modules List"
                    })
                }),
                !$138620d196adaf4d$var$isTerminal(status) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fs0-78rem c15 m0 mt1rem",
                    style: {
                        opacity: 0.5
                    },
                    children: "Generation runs in the background \u2014 you can safely navigate away and return later."
                })
            ]
        })
    });
};
var $138620d196adaf4d$export$2e2bcd8739ae039 = $138620d196adaf4d$var$AIGenerationProgress;


/**
 * ModuleCreate
 *
 * Handles two flows transparently:
 *
 *   Manual (generationMode === 'manual' or undefined):
 *     POST /modules/temp-modules  (with sections)  ← existing flow, unchanged
 *
 *   AI (generationMode === 'ai'):
 *     1. POST /modules/temp-modules  (empty sections) → get moduleId
 *     2. POST /modules/generate-ai-module              → get jobId
 *     3. Render <AIGenerationProgress> with socket + polling
 */ const $d89bc8d00027b50e$var$ModuleCreate = ({ onSuccess: onSuccess, onCancel: onCancel })=>{
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    // AI progress state
    const [aiJob, setAiJob] = (0, $acw62.useState)(null); // { jobId, moduleId, moduleName, estimatedSections, estimatedQuestions }
    const [showProgress, setShowProgress] = (0, $acw62.useState)(false);
    // ── Manual submit (unchanged) ───────────────────────────────────────────
    const handleManualSubmit = async (formData)=>{
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/temp-modules', formData);
        if (response?.code === 200) {
            const result = response.body || response;
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Module created successfully!');
            console.log(`Created: ${result.sectionsCreated || 0} sections, ${result.questionsCreated || 0} questions`);
            if (onSuccess) onSuccess(result);
            if (onCancel) onCancel();
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to create module');
    };
    // ── AI submit ───────────────────────────────────────────────────────────
    const handleAISubmit = async (formData)=>{
        const { generationMode: generationMode, aiConfig: aiConfig, ...modulePayload } = formData;
        // Step 1 — Create the module skeleton (no sections)
        const createRes = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/temp-modules', {
            ...modulePayload,
            sections: []
        });
        if (createRes?.code !== 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(createRes?.message || 'Failed to create module');
            return;
        }
        const moduleId = createRes.body?.module?._id || createRes.body?._id;
        const moduleName = createRes.body?.module?.moduleName || formData.moduleName;
        if (!moduleId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Module created but ID not returned. Please try manual mode.');
            return;
        }
        // Step 2 — Trigger AI generation
        const aiRes = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/generate-ai-module', {
            moduleId: moduleId,
            generationMode: 'ai',
            sectionsPerCombo: aiConfig?.sectionsPerCombo ?? 5,
            questionsPerSection: aiConfig?.questionsPerSection ?? 10
        });
        if (aiRes?.code !== 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(aiRes?.message || 'Failed to start AI generation. You can trigger it from the module editor.');
        const jobData = aiRes?.body || {};
        // Step 3 — Show progress UI
        setAiJob({
            jobId: jobData.jobId,
            moduleId: moduleId,
            moduleName: moduleName,
            moduleImageUrl: modulePayload.imageURL || '',
            estimatedSections: jobData.estimatedSections || 0,
            estimatedQuestions: jobData.estimatedQuestions || 0
        });
        setShowProgress(true);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Module created! AI generation started in the background.');
    };
    // ── Unified submit handler ──────────────────────────────────────────────
    const handleSubmit = async (formData)=>{
        setIsSubmitting(true);
        try {
            if (formData.generationMode === 'ai') await handleAISubmit(formData);
            else // 'manual' and 'upload' both submit sections directly
            await handleManualSubmit(formData);
        } catch (error) {
            console.error('Error creating module:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create module. Please try again.');
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleCancel = ()=>{
        if (onCancel) onCancel();
        else window.history.back();
    };
    // ── AI progress view ────────────────────────────────────────────────────
    if (showProgress && aiJob) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modules-container",
        style: {
            padding: '2rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $138620d196adaf4d$export$2e2bcd8739ae039), {
            jobId: aiJob.jobId,
            moduleId: aiJob.moduleId,
            moduleName: aiJob.moduleName,
            moduleImageUrl: aiJob.moduleImageUrl,
            estimatedSections: aiJob.estimatedSections,
            estimatedQuestions: aiJob.estimatedQuestions,
            onComplete: (job)=>{
                // Fired once on terminal status — do NOT navigate away automatically;
                // let the admin click "View / Edit Module" deliberately.
                console.log('AI generation finished:', job?.status);
            },
            onViewModule: ()=>{
                if (onSuccess) onSuccess({
                    module: {
                        _id: aiJob.moduleId
                    }
                });
                if (onCancel) onCancel();
            }
        })
    });
    // ── Form view ───────────────────────────────────────────────────────────
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modules-container",
        style: {
            padding: '2rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cde4a2f681457f4$export$2e2bcd8739ae039), {
            moduleData: null,
            onFormChange: ()=>{},
            onSubmit: handleSubmit,
            onCancel: handleCancel,
            isEdit: false,
            isSubmitting: isSubmitting
        })
    });
};
var $d89bc8d00027b50e$export$2e2bcd8739ae039 = $d89bc8d00027b50e$var$ModuleCreate;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $2cbf539ca32cf2f5$var$ModuleEdit = ({ moduleId: moduleId, moduleName: moduleName, onSuccess: onSuccess, onCancel: onCancel })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [moduleData, setModuleData] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        fetchModuleData();
    }, [
        moduleId,
        moduleName
    ]);
    const fetchModuleData = async (silent = false)=>{
        if (!silent) setIsLoading(true);
        try {
            // Use the new temp-modules endpoint - it returns module with sections and questions
            let response;
            if (moduleId) response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/${moduleId}`);
            else if (moduleName) response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${moduleName}`);
            if (response?.code === 200) {
                // The API returns module with populated sections and questions
                const moduleData = response.body || response.body?.module || response.body?.data;
                setModuleData(moduleData);
                console.log('Loaded module with sections:', moduleData.sections?.length || 0);
            } else if (!silent) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to load module data');
        } catch (error) {
            console.error('Error fetching module:', error);
            if (!silent) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to load module data');
        } finally{
            if (!silent) setIsLoading(false);
        }
    };
    const handleFormChange = (formData)=>{
    // Form data changes are handled internally by ModuleForm
    };
    const handleSubmit = async (formData)=>{
        setIsSubmitting(true);
        try {
            // Use the new temp-modules update endpoint (PUT method)
            // This will update module and replace all sections/questions
            const updateData = {
                ...formData,
                _id: moduleId
            };
            // Use PUT request for update
            const response = await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)('/modules/update-temp-module', updateData);
            if (response?.code === 200) {
                const result = response.body || response;
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Module updated successfully!');
                // Log update summary
                console.log(`Updated: ${result.sectionsUpdated || 0} sections, ${result.questionsUpdated || 0} questions`);
                if (onSuccess) onSuccess(result);
                if (onCancel) onCancel();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || 'Failed to update module');
        } catch (error) {
            console.error('Error updating module:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to update module. Please try again.');
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleCancel = ()=>{
        if (onCancel) onCancel();
        else // Default behavior: navigate back
        window.history.back();
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df jcc aic p4rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loader"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ml1rem fs1rem c15",
                children: "Loading module data..."
            })
        ]
    });
    if (!moduleData) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df fdc aic jcc p4rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1-25rem c15 fw500 mb1rem",
                children: "Module not found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: handleCancel,
                className: "bg1 bo4 bss bw1px br5px p1rem fw600 c4 td250 cp",
                children: "Go Back"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "modules-container",
        style: {
            padding: '2rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cde4a2f681457f4$export$2e2bcd8739ae039), {
            moduleData: moduleData,
            onFormChange: handleFormChange,
            onSubmit: handleSubmit,
            onCancel: handleCancel,
            isEdit: true,
            onPriorityComplete: ()=>fetchModuleData(true)
        })
    });
};
var $2cbf539ca32cf2f5$export$2e2bcd8739ae039 = $2cbf539ca32cf2f5$var$ModuleEdit;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

const $e35c309e2bac54bc$var$ModuleHeader = ({ onCreateModule: onCreateModule })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "modules-title",
                        children: "Modules"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "modules-subtitle",
                        children: "Manage modules and checklists"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                onClick: onCreateModule,
                className: "modules-create-btn df aic jcc cp",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                        style: {
                            fontSize: '18px',
                            marginRight: '8px'
                        }
                    }),
                    "Create Module"
                ]
            })
        ]
    });
};
var $e35c309e2bac54bc$export$2e2bcd8739ae039 = $e35c309e2bac54bc$var$ModuleHeader;



var $ayMG0 = parcelRequire("ayMG0");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $95f6704f80233608$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');


const $fa7e1d3cc3340efc$var$ModuleFilters = ({ onSearchChange: onSearchChange, statusFilter: statusFilter, onStatusFilterChange: onStatusFilterChange, categoryFilter: categoryFilter, onCategoryFilterChange: onCategoryFilterChange, typeFilter: typeFilter, onTypeFilterChange: onTypeFilterChange })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-filters-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-search-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {
                        className: "modules-search-icon"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        placeholder: "Search modules...",
                        onChange: onSearchChange,
                        className: "modules-search-input"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modules-filters-group",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                    value: statusFilter,
                    onChange: onStatusFilterChange,
                    className: "modules-filter-select",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                            value: "all",
                            children: "Filter by status"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                            value: "active",
                            children: "Active"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                            value: "inactive",
                            children: "Inactive"
                        })
                    ]
                })
            })
        ]
    });
};
var $fa7e1d3cc3340efc$export$2e2bcd8739ae039 = $fa7e1d3cc3340efc$var$ModuleFilters;



var $ayMG0 = parcelRequire("ayMG0");
const $8a43cf2324a25e6a$var$ModulePagination = ({ currentPage: currentPage, totalPages: totalPages, totalModules: totalModules, pageSize: pageSize, onPageChange: onPageChange, onPageSizeChange: onPageSizeChange })=>{
    if (totalPages <= 1) return null;
    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage < maxVisible - 1) startPage = Math.max(1, endPage - maxVisible + 1);
    for(let i = startPage; i <= endPage; i++)pages.push(i);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-pagination df jcsb aic mt2rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs0-85rem c15 mr1rem",
                        children: "Rows per page:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                        value: pageSize,
                        onChange: onPageSizeChange,
                        className: "modules-page-select br5px p0-5rem bss bw1px",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: 5,
                                children: "5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: 10,
                                children: "10"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: 20,
                                children: "20"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: 25,
                                children: "25"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: 50,
                                children: "50"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: 100,
                                children: "100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fs0-85rem c15 ml1rem",
                        children: [
                            (currentPage - 1) * pageSize + 1,
                            "-",
                            Math.min(currentPage * pageSize, totalModules),
                            " of ",
                            totalModules
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>onPageChange(1),
                        disabled: currentPage === 1,
                        className: "modules-page-btn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "fa fa-angle-double-left"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>onPageChange(currentPage - 1),
                        disabled: currentPage === 1,
                        className: "modules-page-btn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "fa fa-angle-left"
                        })
                    }),
                    pages.map((page)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>onPageChange(page),
                            className: `modules-page-btn ${currentPage === page ? 'modules-page-active' : ''}`,
                            children: page
                        }, page)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>onPageChange(currentPage + 1),
                        disabled: currentPage === totalPages,
                        className: "modules-page-btn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "fa fa-angle-right"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>onPageChange(totalPages),
                        disabled: currentPage === totalPages,
                        className: "modules-page-btn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "fa fa-angle-double-right"
                        })
                    })
                ]
            })
        ]
    });
};
var $8a43cf2324a25e6a$export$2e2bcd8739ae039 = $8a43cf2324a25e6a$var$ModulePagination;



var $ayMG0 = parcelRequire("ayMG0");

const $5eb03311b866621d$var$DeleteModuleModal = ({ moduleName: moduleName, onConfirm: onConfirm, onClose: onClose })=>{
    const handleConfirm = ()=>{
        onConfirm();
        if (typeof onClose === 'function') onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: "confirmDeleteModuleSection",
        onCloseHandler: onClose,
        modalCardClasses: "m1rem maw600px",
        customStyle: {
            padding: '2rem',
            zIndex: 9,
            marginTop: '2rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "c15 fs2rem tac lh1 fw600 mb2rem",
                children: "Confirm Deletion"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic mb2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs1-25rem c15 fw400 tac mb1rem",
                        children: "Are you sure you want to delete this module?"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs1rem c4 fw600",
                        children: moduleName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-75rem c15",
                        children: "This action cannot be undone."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcc gg1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        onClick: onClose,
                        className: "bo4 bss bg1 bg4-hover c4 c1-hover td250 br20px p1rem fw600 cp w30 ttu bsbb tac df jcc aic mr0-5rem",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        onClick: handleConfirm,
                        className: "bg3 bo3 bss bo4-hover bg4-hover c1 td250 br20px p1rem fw600 w30 cp ttu bsbb tac df jcc aic ml0-5rem",
                        children: "Delete Module"
                    })
                ]
            })
        ]
    });
};
var $5eb03311b866621d$export$2e2bcd8739ae039 = $5eb03311b866621d$var$DeleteModuleModal;



var $acw62 = parcelRequire("acw62");


var $lwfqC = parcelRequire("lwfqC");
const $d296432a35ea24f1$export$24d4246a16d73084 = ()=>{
    const [moduleList, setModuleList] = (0, $acw62.useState)([]);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [pageSize, setPageSize] = (0, $acw62.useState)(10);
    const [totalModules, setTotalModules] = (0, $acw62.useState)(0);
    const [totalPages, setTotalPages] = (0, $acw62.useState)(0);
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)('');
    const [sortField, setSortField] = (0, $acw62.useState)('createdAt');
    const [sortOrder, setSortOrder] = (0, $acw62.useState)('desc');
    const [statusFilter, setStatusFilter] = (0, $acw62.useState)('all');
    const [categoryFilter, setCategoryFilter] = (0, $acw62.useState)('all');
    const [typeFilter, setTypeFilter] = (0, $acw62.useState)('all');
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const getModules = (0, $acw62.useCallback)(async (page = currentPage, limit = pageSize, search = searchQuery, sort = sortField, order = sortOrder)=>{
        setIsLoading(true);
        try {
            const params = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                sortField: sort,
                sortOrder: order
            });
            if (search && search.trim()) params.append('search', search.trim());
            // Add filters
            if (statusFilter !== 'all') params.append('isActive', statusFilter === 'active' ? 'true' : 'false');
            if (typeFilter !== 'all') params.append('type', typeFilter);
            let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules?${params.toString()}`);
            if (response && response['code'] === 200) {
                const body = response['body'] || {};
                setModuleList(body.modules || []);
                const pagination = body.pagination || {};
                setTotalModules(pagination.total || 0);
                setTotalPages(pagination.totalPages || 0);
                setCurrentPage(pagination.page || 1);
            } else {
                setModuleList([]);
                setTotalModules(0);
                setTotalPages(0);
            }
        } catch (error) {
            console.error('Error fetching modules:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to load modules');
            setModuleList([]);
        } finally{
            setIsLoading(false);
        }
    }, [
        currentPage,
        pageSize,
        searchQuery,
        sortField,
        sortOrder,
        statusFilter,
        typeFilter
    ]);
    (0, $acw62.useEffect)(()=>{
        getModules(currentPage, pageSize, searchQuery, sortField, sortOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentPage,
        pageSize,
        searchQuery,
        sortField,
        sortOrder,
        statusFilter,
        categoryFilter,
        typeFilter
    ]);
    // Debounced search function
    const debouncedSearch = (0, $acw62.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lwfqC)))((query)=>{
        setSearchQuery(query);
        setCurrentPage(1);
    }, 500), []);
    const handleSearchChange = (e)=>{
        const value = e.target.value;
        debouncedSearch(value);
    };
    const handleSort = (field)=>{
        if (sortField === field) setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        else {
            setSortField(field);
            setSortOrder('desc');
        }
        setCurrentPage(1);
    };
    const handlePageChange = (page)=>{
        setCurrentPage(page);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const handlePageSizeChange = (e)=>{
        setPageSize(parseInt(e.target.value));
        setCurrentPage(1);
    };
    const handleStatusFilterChange = (e)=>{
        setStatusFilter(e.target.value);
        setCurrentPage(1);
    };
    const handleCategoryFilterChange = (e)=>{
        setCategoryFilter(e.target.value);
        setCurrentPage(1);
    };
    const handleTypeFilterChange = (e)=>{
        setTypeFilter(e.target.value);
        setCurrentPage(1);
    };
    // Filter modules client-side for status, category, type
    const filteredModules = moduleList.filter((module)=>{
        if (statusFilter !== 'all' && (statusFilter === 'active' && !module.isActive || statusFilter === 'inactive' && module.isActive)) return false;
        if (categoryFilter !== 'all' && module.category !== categoryFilter) return false;
        if (typeFilter !== 'all' && module.type !== typeFilter) return false;
        return true;
    });
    const activeModule = async (moduleId, moduleName, isActive)=>{
        try {
            // Use the new temp-modules toggle-status endpoint
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/temp-modules/toggle-status`, {
                moduleId: moduleId,
                isActive: isActive
            });
            if (res?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || `Module ${isActive ? 'activated' : 'deactivated'} successfully`);
                await getModules(currentPage, pageSize, searchQuery, sortField, sortOrder);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to update module status');
        } catch (error) {
            console.error('Error updating module status:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to update module status');
        }
    };
    const deleteModule = async (moduleId)=>{
        try {
            // Use the new temp-modules delete endpoint with DELETE method
            let res = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/temp-modules/${moduleId}`);
            if (res?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Module deleted successfully');
                await getModules(currentPage, pageSize, searchQuery, sortField, sortOrder);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to delete module');
        } catch (error) {
            console.error('Error deleting module:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to delete module');
        }
    };
    return {
        moduleList: filteredModules,
        totalModules: totalModules,
        totalPages: totalPages,
        currentPage: currentPage,
        pageSize: pageSize,
        isLoading: isLoading,
        sortField: sortField,
        sortOrder: sortOrder,
        searchQuery: searchQuery,
        statusFilter: statusFilter,
        categoryFilter: categoryFilter,
        typeFilter: typeFilter,
        handleSearchChange: handleSearchChange,
        handleSort: handleSort,
        handlePageChange: handlePageChange,
        handlePageSizeChange: handlePageSizeChange,
        handleStatusFilterChange: handleStatusFilterChange,
        handleCategoryFilterChange: handleCategoryFilterChange,
        handleTypeFilterChange: handleTypeFilterChange,
        activeModule: activeModule,
        deleteModule: deleteModule,
        getModules: getModules
    };
};



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ac989a1e618ed6bb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');


const $841142bbceceb639$var$ModuleActionsMenu = ({ module: module, onView: onView, onEdit: onEdit, onActivate: onActivate, onDelete: onDelete, onGenerateAI: onGenerateAI })=>{
    const [showMenu, setShowMenu] = (0, $acw62.useState)(false);
    const [menuPosition, setMenuPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const buttonRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const calculateMenuPosition = (0, $acw62.useCallback)(()=>{
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const menuWidth = 160;
            const top = rect.bottom + 8;
            let left = rect.right - menuWidth;
            if (left < 8) left = rect.left;
            else if (rect.right > window.innerWidth - 8) left = window.innerWidth - menuWidth - 8;
            setMenuPosition({
                top: top,
                left: left
            });
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!showMenu) return;
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) setShowMenu(false);
        };
        const handleResize = ()=>{
            calculateMenuPosition();
        };
        calculateMenuPosition();
        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handleResize, true);
        window.addEventListener('resize', handleResize);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handleResize, true);
            window.removeEventListener('resize', handleResize);
        };
    }, [
        showMenu,
        calculateMenuPosition
    ]);
    const handleButtonClick = (e)=>{
        e.stopPropagation();
        if (!showMenu) {
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                const menuWidth = 160;
                const top = rect.bottom + 8;
                let left = rect.right - menuWidth;
                if (left < 8) left = rect.left;
                else if (rect.right > window.innerWidth - 8) left = window.innerWidth - menuWidth - 8;
                setMenuPosition({
                    top: top,
                    left: left
                });
            }
            setShowMenu(true);
        } else setShowMenu(false);
    };
    const handleView = (e)=>{
        e.stopPropagation();
        onView(module);
        setShowMenu(false);
    };
    const handleEdit = (e)=>{
        e.stopPropagation();
        onEdit(module);
        setShowMenu(false);
    };
    const handleActivate = (e)=>{
        e.stopPropagation();
        onActivate(module);
        setShowMenu(false);
    };
    const handleDelete = (e)=>{
        e.stopPropagation();
        onDelete(module);
        setShowMenu(false);
    };
    const handleGenerateAI = (e)=>{
        e.stopPropagation();
        if (onGenerateAI) onGenerateAI(module);
        setShowMenu(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-actions-container pr",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                ref: buttonRef,
                onClick: handleButtonClick,
                className: "modules-actions-btn df jcc aic cp",
                "data-tooltip": "Actions",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac989a1e618ed6bb$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '20px',
                        color: '#666'
                    }
                })
            }),
            showMenu && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modules-actions-backdrop",
                        onClick: ()=>setShowMenu(false)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: menuRef,
                        className: "modules-actions-menu zi100",
                        style: {
                            top: `${menuPosition.top - 30}px`,
                            left: `${menuPosition.left - 30}px`
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: handleView,
                                className: "modules-action-item",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-eye mr0-5rem"
                                    }),
                                    " View"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: handleEdit,
                                className: "modules-action-item",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-pencil mr0-5rem"
                                    }),
                                    " Edit"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: handleDelete,
                                className: "modules-action-item modules-action-danger",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-trash mr0-5rem"
                                    }),
                                    " Delete"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $841142bbceceb639$export$2e2bcd8739ae039 = $841142bbceceb639$var$ModuleActionsMenu;


const $cbc3ab4a2f8f6fc6$export$af03abc87396e05d = (sortField, sortOrder, handleSort, onView, onEdit, handleActivate, handleDelete, onGenerateAI)=>[
        {
            id: 'moduleName',
            Header: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-header df jcs aic cp",
                onClick: ()=>handleSort('moduleName'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fw600 fs0-9rem c15",
                        children: "Module"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modules-sort-icons ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-up ${sortField === 'moduleName' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-down ${sortField === 'moduleName' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`
                            })
                        ]
                    })
                ]
            }),
            accessor: (module)=>{
                // Encode URL to handle spaces and special characters
                const encodedImageURL = module['imageURL'] ? encodeURI(module['imageURL']) : null;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcs aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "modules-avatar w3rem h3rem br100 df jcc aic mr1rem",
                            style: {
                                backgroundColor: encodedImageURL ? 'transparent' : '#4a67ff',
                                backgroundImage: encodedImageURL ? `url("${encodedImageURL}")` : 'none',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                width: '42px',
                                height: '42px',
                                padding: '4px',
                                marginLeft: '8px'
                            },
                            children: !encodedImageURL && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fw600 c1 fs1rem",
                                children: (module['moduleName'] || 'M')[0].toUpperCase()
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aifs jcfs",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fw600 c15 fs0-95rem w100 tal",
                                    children: module['moduleName'].length > 30 ? module['moduleName'].substring(0, 30) + '...' : module['moduleName'] || '-'
                                }),
                                module['moduleDescription'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs0-75rem c15 mt0-25rem w100 tal",
                                    style: {
                                        maxWidth: '300px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: module['moduleDescription']
                                })
                            ]
                        })
                    ]
                });
            },
            minWidth: 280
        },
        {
            id: 'companyStage',
            Header: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-header df jcs aic cp",
                onClick: ()=>handleSort('companyStage'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fw600 fs0-9rem c15",
                        children: "Objective"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modules-sort-icons ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-up ${sortField === 'companyStage' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-down ${sortField === 'companyStage' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`
                            })
                        ]
                    })
                ]
            }),
            accessor: (module)=>{
                const OBJECTIVE_STYLES = {
                    Investment: {
                        bg: '#e3f2fd',
                        color: '#1976d2'
                    },
                    Exit: {
                        bg: '#fce4ec',
                        color: '#c62828'
                    },
                    Growth: {
                        bg: '#e8f5e9',
                        color: '#388e3c'
                    }
                };
                const canonicalObjectives = Array.isArray(module['companyObjectives']) ? module['companyObjectives'] : [];
                const activeObjectives = Array.isArray(module['activeObjective']) ? module['activeObjective'] : [];
                const objectives = Array.from(new Set((canonicalObjectives.length > 0 ? canonicalObjectives : activeObjectives).filter(Boolean)));
                if (objectives.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 fs0-85rem",
                        children: "-"
                    })
                });
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df fww",
                    style: {
                        gap: '4px'
                    },
                    children: objectives.sort((a, b)=>a < b ? -1 : a > b ? 1 : 0).map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "modules-type-badge fs0-75rem px0-75rem py0-25rem br15px fw500",
                            style: {
                                backgroundColor: OBJECTIVE_STYLES[name]?.bg || '#f5f5f5',
                                color: OBJECTIVE_STYLES[name]?.color || '#757575'
                            },
                            children: name
                        }, name))
                });
            },
            minWidth: 150
        },
        {
            id: 'companySubscription',
            Header: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-header df jcs aic cp",
                onClick: ()=>handleSort('companySubscription'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fw600 fs0-9rem c15",
                        children: "Subscription"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modules-sort-icons ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-up ${sortField === 'companySubscription' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-down ${sortField === 'companySubscription' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`
                            })
                        ]
                    })
                ]
            }),
            accessor: (module)=>{
                const SUB_STYLES = {
                    Free: {
                        bg: '#e8f5e9',
                        color: '#388e3c'
                    },
                    Lite: {
                        bg: '#fff3e0',
                        color: '#f57c00'
                    },
                    Pro: {
                        bg: '#e3f2fd',
                        color: '#1976d2'
                    },
                    'Pro Portfolio': {
                        bg: '#f3e5f5',
                        color: '#7b1fa2'
                    }
                };
                const canonicalTiers = Array.isArray(module['subscriptionTier']) ? module['subscriptionTier'] : [];
                const activeSubs = Array.isArray(module['activeSubscription']) ? module['activeSubscription'] : [];
                const subs = Array.from(new Set((canonicalTiers.length > 0 ? canonicalTiers : activeSubs).filter(Boolean)));
                if (subs.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 fs0-85rem",
                        children: "-"
                    })
                });
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df fww",
                    style: {
                        gap: '4px'
                    },
                    children: subs.sort((a, b)=>a < b ? -1 : a > b ? 1 : 0).map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "modules-type-badge fs0-75rem px0-75rem py0-25rem br15px fw500",
                            style: {
                                backgroundColor: SUB_STYLES[name]?.bg || '#f5f5f5',
                                color: SUB_STYLES[name]?.color || '#757575'
                            },
                            children: name
                        }, name))
                });
            },
            minWidth: 150
        },
        {
            id: 'isActive',
            Header: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-header df jcc aic cp",
                onClick: ()=>handleSort('isActive'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fw600 fs0-9rem c15",
                        children: "Status"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modules-sort-icons ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-up ${sortField === 'isActive' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-down ${sortField === 'isActive' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`
                            })
                        ]
                    })
                ]
            }),
            accessor: (module)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `modules-status-badge fs0-8rem px1rem py0-5rem br25px fw500 ${module['isActive'] ? 'modules-status-active' : 'modules-status-inactive'}`,
                        children: module['isActive'] ? 'Active' : 'Inactive'
                    })
                }),
            minWidth: 100
        },
        {
            id: 'totalQuestions',
            Header: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-header df jcc aic cp",
                onClick: ()=>handleSort('totalQuestions'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fw600 fs0-9rem c15",
                        children: "Questions"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modules-sort-icons ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-up ${sortField === 'totalQuestions' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-down ${sortField === 'totalQuestions' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`
                            })
                        ]
                    })
                ]
            }),
            accessor: (module)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 fw500 fs0-9rem",
                        children: module['totalQuestions'] || module['sections']?.length || 0
                    })
                }),
            minWidth: 100
        },
        {
            id: 'createdAt',
            Header: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-header df jcs aic cp",
                onClick: ()=>handleSort('createdAt'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fw600 fs0-9rem c15",
                        children: "Created"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modules-sort-icons ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-up ${sortField === 'createdAt' && sortOrder === 'asc' ? 'modules-sort-active' : ''}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: `fa fa-arrow-down ${sortField === 'createdAt' && sortOrder === 'desc' ? 'modules-sort-active' : ''}`
                            })
                        ]
                    })
                ]
            }),
            accessor: (module)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 fs0-85rem",
                        children: module['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module['createdAt']).format('MMM DD, YYYY') : module['createdDate'] || '-'
                    })
                }),
            minWidth: 130
        },
        {
            Header: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc fw600 fs0-9rem c15",
                children: "Actions"
            }),
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $841142bbceceb639$export$2e2bcd8739ae039), {
                    module: props.original,
                    onView: onView,
                    onEdit: onEdit,
                    onActivate: handleActivate,
                    onDelete: handleDelete,
                    onGenerateAI: onGenerateAI
                }),
            minWidth: 80,
            sortable: false
        }
    ];



const $3e37449cbb613ef9$var$ModuleList = ({ onCreate: onCreate, onView: onView, onEdit: onEdit, onGenerateAI: onGenerateAI })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [deleteModule, setDeleteModule] = (0, $acw62.useState)(null);
    const { moduleList: moduleList, totalModules: totalModules, totalPages: totalPages, currentPage: currentPage, pageSize: pageSize, isLoading: isLoading, sortField: sortField, sortOrder: sortOrder, statusFilter: statusFilter, categoryFilter: categoryFilter, typeFilter: typeFilter, handleSearchChange: handleSearchChange, handleSort: handleSort, handlePageChange: handlePageChange, handlePageSizeChange: handlePageSizeChange, handleStatusFilterChange: handleStatusFilterChange, handleCategoryFilterChange: handleCategoryFilterChange, handleTypeFilterChange: handleTypeFilterChange, activeModule: activeModule, deleteModule: deleteModuleAPI } = (0, $d296432a35ea24f1$export$24d4246a16d73084)();
    const handleActivate = (module)=>{
        activeModule(module['_id'], module['moduleName'], !module['isActive']);
    };
    const handleDelete = (module)=>{
        setDeleteModule(module);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'confirmDeleteModuleSection'
        }));
    };
    const handleDeleteConfirm = ()=>{
        if (deleteModule && deleteModule._id) {
            deleteModuleAPI(deleteModule._id);
            setDeleteModule(null);
        }
    };
    const handleDeleteModalClose = ()=>{
        setDeleteModule(null);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const columns = (0, $cbc3ab4a2f8f6fc6$export$af03abc87396e05d)(sortField, sortOrder, handleSort, onView, onEdit, handleActivate, handleDelete, onGenerateAI);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e35c309e2bac54bc$export$2e2bcd8739ae039), {
                onCreateModule: onCreate
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa7e1d3cc3340efc$export$2e2bcd8739ae039), {
                onSearchChange: handleSearchChange,
                statusFilter: statusFilter,
                onStatusFilterChange: handleStatusFilterChange,
                categoryFilter: categoryFilter,
                onCategoryFilterChange: handleCategoryFilterChange,
                typeFilter: typeFilter,
                onTypeFilterChange: handleTypeFilterChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modules-table-header-row df jcsb aic mb1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "modules-table-title",
                            children: [
                                "Modules (",
                                totalModules,
                                ")"
                            ]
                        })
                    }),
                    isLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc aic p4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "loader"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml1rem fs1rem c15",
                                children: "Loading modules..."
                            })
                        ]
                    }) : moduleList && moduleList.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "modules-table-wrapper",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                    minRows: 0,
                                    className: "modules-table",
                                    data: moduleList,
                                    resolveData: (module)=>module.map((row)=>row),
                                    columns: columns,
                                    showPagination: false,
                                    resizable: false
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a43cf2324a25e6a$export$2e2bcd8739ae039), {
                                currentPage: currentPage,
                                totalPages: totalPages,
                                totalModules: totalModules,
                                pageSize: pageSize,
                                onPageChange: handlePageChange,
                                onPageSizeChange: handlePageSizeChange
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic jcc p4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1-25rem c15 fw500 mb1rem",
                                children: "No modules found"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: onCreate,
                                className: "modules-create-btn df aic jcc cp",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: '18px',
                                            marginRight: '8px'
                                        }
                                    }),
                                    "Create Your First Module"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5eb03311b866621d$export$2e2bcd8739ae039), {
                moduleName: deleteModule?.moduleName || '',
                onConfirm: handleDeleteConfirm,
                onClose: handleDeleteModalClose
            })
        ]
    });
};
var $3e37449cbb613ef9$export$2e2bcd8739ae039 = $3e37449cbb613ef9$var$ModuleList;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");

const $3303cdf06a05e7df$var$OBJECTIVE_STYLES = {
    Investment: {
        bg: "#e3f2fd",
        color: "#1976d2"
    },
    Exit: {
        bg: "#fce4ec",
        color: "#c62828"
    },
    Growth: {
        bg: "#e8f5e9",
        color: "#388e3c"
    },
    All: {
        bg: "#f1f3f5",
        color: "#495057"
    }
};
const $3303cdf06a05e7df$var$SUBSCRIPTION_STYLES = {
    Free: {
        bg: "#e8f5e9",
        color: "#388e3c"
    },
    Lite: {
        bg: "#fff3e0",
        color: "#f57c00"
    },
    Pro: {
        bg: "#e3f2fd",
        color: "#1976d2"
    },
    "Pro Portfolio": {
        bg: "#f3e5f5",
        color: "#7b1fa2"
    },
    All: {
        bg: "#f1f3f5",
        color: "#495057"
    }
};
const $3303cdf06a05e7df$var$badgeStyle = (palette)=>({
        backgroundColor: palette?.bg || "#f5f5f5",
        color: palette?.color || "#757575",
        padding: "4px 10px",
        borderRadius: "999px",
        fontSize: "0.75rem",
        fontWeight: 600
    });
const $3303cdf06a05e7df$var$statCardStyle = {
    background: "linear-gradient(180deg, #ffffff 0%, #f8faff 100%)",
    border: "1px solid #e8edff",
    borderRadius: "12px",
    padding: "0.85rem 1rem",
    boxShadow: "0 4px 14px rgba(74, 103, 255, 0.08)"
};
const $3303cdf06a05e7df$var$countQuestionsInSubFolders = (subFolders)=>{
    if (!subFolders || typeof subFolders !== "object") return 0;
    return Object.values(subFolders).reduce((acc, subFolder)=>{
        const ownQuestion = subFolder?.question ? 1 : 0;
        const extraQuestions = Array.isArray(subFolder?.questions) ? subFolder.questions.length : 0;
        const nestedCount = $3303cdf06a05e7df$var$countQuestionsInSubFolders(subFolder?.subFolders);
        return acc + ownQuestion + extraQuestions + nestedCount;
    }, 0);
};
const $3303cdf06a05e7df$var$countQuestionsInSection = (section)=>{
    const mainQuestion = section?.question ? 1 : 0;
    return mainQuestion + $3303cdf06a05e7df$var$countQuestionsInSubFolders(section?.subFolders);
};
const $3303cdf06a05e7df$var$renderQuestionCard = (question, fallbackNo)=>{
    if (!question) return null;
    const optionCount = Array.isArray(question?.options) ? question.options.length : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg1 br10px bss bw1px bo5 p0-75rem",
        style: {
            marginTop: "0.75rem",
            paddingTop: "0.65rem",
            paddingBottom: "0.65rem"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcsb",
                style: {
                    gap: "0.75rem",
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fw600 c15 fs0-85rem",
                        children: question.qNo || fallbackNo || "-"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        style: {
                            gap: "0.4rem",
                            flexWrap: "wrap"
                        },
                        children: [
                            question.answerType && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-7rem fw600",
                                style: $3303cdf06a05e7df$var$badgeStyle({
                                    bg: "#edf2ff",
                                    color: "#3b5bdb"
                                }),
                                children: question.answerType
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-7rem fw600",
                                style: $3303cdf06a05e7df$var$badgeStyle({
                                    bg: "#f8f9fa",
                                    color: "#495057"
                                }),
                                children: [
                                    "Options: ",
                                    optionCount
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m0 mt0-5rem c15 fs0-85rem",
                style: {
                    lineHeight: 1.5
                },
                children: question.qDescription || "-"
            })
        ]
    }, question._id || fallbackNo);
};
const $3303cdf06a05e7df$var$renderSubFolders = (subFolders, level = 1)=>{
    if (!subFolders || typeof subFolders !== "object" || Object.keys(subFolders).length === 0) return null;
    const sortedKeys = Object.keys(subFolders).sort((a, b)=>Number(a) - Number(b));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df fdc",
        style: {
            gap: "0.75rem",
            marginTop: "0.75rem",
            paddingLeft: level > 1 ? "0.75rem" : 0,
            borderLeft: level > 1 ? "2px dashed #edf1ff" : "none"
        },
        children: sortedKeys.map((key)=>{
            const sf = subFolders[key];
            const hasNested = sf?.subFolders && typeof sf.subFolders === "object" && Object.keys(sf.subFolders).length > 0;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 br10px bss bw1px bo5 p0-75rem",
                style: {
                    paddingTop: "0.7rem",
                    paddingBottom: "0.7rem"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic jcsb",
                        style: {
                            gap: "0.75rem",
                            flexWrap: "wrap",
                            marginBottom: "0.15rem"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "fw600 c15 fs0-8rem",
                            style: {
                                lineHeight: 1.4
                            },
                            children: [
                                sf?.no || "-",
                                " - ",
                                sf?.name || "Sub section"
                            ]
                        })
                    }),
                    $3303cdf06a05e7df$var$renderQuestionCard(sf?.question, sf?.no),
                    Array.isArray(sf?.questions) && sf.questions.map((q)=>$3303cdf06a05e7df$var$renderQuestionCard(q, q?.qNo || sf?.no)),
                    hasNested && $3303cdf06a05e7df$var$renderSubFolders(sf?.subFolders, level + 1)
                ]
            }, sf?.no || key);
        })
    });
};
const $3303cdf06a05e7df$var$ModuleView = ({ moduleId: moduleId, onCancel: onCancel })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [moduleData, setModuleData] = (0, $acw62.useState)(null);
    const [selectedObjective, setSelectedObjective] = (0, $acw62.useState)("All");
    const [selectedSubscription, setSelectedSubscription] = (0, $acw62.useState)("All");
    (0, $acw62.useEffect)(()=>{
        const fetchModuleData = async ()=>{
            setIsLoading(true);
            try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/${moduleId}`);
                if (response?.code === 200) setModuleData(response.body || response.body?.module || null);
                else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || "Failed to load module details");
            } catch (error) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Failed to load module details");
            } finally{
                setIsLoading(false);
            }
        };
        if (moduleId) fetchModuleData();
        else setIsLoading(false);
    }, [
        moduleId
    ]);
    const sections = moduleData?.sections || [];
    const objectiveOptions = (0, $acw62.useMemo)(()=>{
        const uniqueObjectives = Array.from(new Set(sections.map((s)=>s?.companyObjective).filter(Boolean)));
        return [
            "All",
            ...uniqueObjectives
        ];
    }, [
        sections
    ]);
    const subscriptionOptions = (0, $acw62.useMemo)(()=>{
        const uniqueSubscriptions = Array.from(new Set(sections.map((s)=>s?.subscriptionTier).filter(Boolean)));
        return [
            "All",
            ...uniqueSubscriptions
        ];
    }, [
        sections
    ]);
    const sectionsToDisplay = (0, $acw62.useMemo)(()=>{
        return sections.filter((section)=>{
            const sectionObjective = section?.companyObjective || "All";
            const sectionSubscription = section?.subscriptionTier || "All";
            const objectiveMatches = selectedObjective === "All" || sectionObjective === "All" || sectionObjective === selectedObjective;
            const subscriptionMatches = selectedSubscription === "All" || sectionSubscription === "All" || sectionSubscription === selectedSubscription;
            return objectiveMatches && subscriptionMatches;
        });
    }, [
        sections,
        selectedObjective,
        selectedSubscription
    ]);
    const groupedSections = (0, $acw62.useMemo)(()=>{
        const groups = sectionsToDisplay.reduce((acc, section)=>{
            const objective = section?.companyObjective || "All";
            const subscription = section?.subscriptionTier || "All";
            const key = `${objective}__${subscription}`;
            if (!acc[key]) acc[key] = {
                key: key,
                objective: objective,
                subscription: subscription,
                sections: []
            };
            acc[key].sections.push(section);
            return acc;
        }, {});
        return Object.values(groups).sort((a, b)=>{
            if (a.objective !== b.objective) return a.objective.localeCompare(b.objective);
            return a.subscription.localeCompare(b.subscription);
        });
    }, [
        sectionsToDisplay
    ]);
    const totalQuestionCount = (0, $acw62.useMemo)(()=>sectionsToDisplay.reduce((acc, section)=>acc + $3303cdf06a05e7df$var$countQuestionsInSection(section), 0), [
        sectionsToDisplay
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df jcc aic p4rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loader"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ml1rem fs1rem c15",
                children: "Loading module details..."
            })
        ]
    });
    if (!moduleData) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df fdc aic jcc p4rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1-25rem c15 fw500 mb1rem",
                children: "Module not found"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: onCancel,
                className: "bg1 bo4 bss bw1px br5px p1rem fw600 c4 td250 cp",
                children: "Go Back"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-container",
        style: {
            padding: "2rem"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "br10px p1-5rem",
                style: {
                    background: "linear-gradient(135deg, #f9fbff 0%, #eef3ff 100%)",
                    border: "1px solid #dde6ff",
                    boxShadow: "0 10px 26px rgba(74, 103, 255, 0.14)"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb aic",
                        style: {
                            gap: "0.75rem",
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "modules-title m0",
                                        style: {
                                            fontSize: "1.65rem"
                                        },
                                        children: moduleData.moduleName || "Module Details"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "modules-subtitle m0 mt0-25rem",
                                        children: "Complete module view with sections and questions"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: onCancel,
                                className: "modules-create-btn df aic jcc cp",
                                style: {
                                    minWidth: "140px",
                                    background: "#fff",
                                    color: "#4a67ff",
                                    border: "1px solid #ccd7ff"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "fa fa-arrow-left mr0-5rem"
                                    }),
                                    " Back to list"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg0-75rem mt1rem",
                        style: {
                            gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $3303cdf06a05e7df$var$statCardStyle,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-75rem fw600 c15 op70",
                                        children: "Module Key"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-95rem fw600 c15 mt0-25rem",
                                        children: moduleData.moduleKey || "-"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $3303cdf06a05e7df$var$statCardStyle,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-75rem fw600 c15 op70",
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-95rem fw600 mt0-25rem",
                                        style: {
                                            color: moduleData.isActive ? "#2e7d32" : "#c62828"
                                        },
                                        children: moduleData.isActive ? "Active" : "Inactive"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $3303cdf06a05e7df$var$statCardStyle,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-75rem fw600 c15 op70",
                                        children: "Sections"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-95rem fw600 c15 mt0-25rem",
                                        children: sectionsToDisplay.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $3303cdf06a05e7df$var$statCardStyle,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-75rem fw600 c15 op70",
                                        children: "Questions"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-95rem fw600 c15 mt0-25rem",
                                        children: totalQuestionCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: $3303cdf06a05e7df$var$statCardStyle,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-75rem fw600 c15 op70",
                                        children: "Created"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fs0-95rem fw600 c15 mt0-25rem",
                                        children: moduleData.createdAt ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(moduleData.createdAt).format("MMM DD, YYYY") : "-"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs0-9rem mt1rem mb0",
                        style: {
                            lineHeight: 1.55
                        },
                        children: moduleData.moduleDescription || "No description available."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-filters-card mt1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcsb aic w100",
                        style: {
                            gap: "0.75rem",
                            flexWrap: "wrap"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-1rem fw600 c15 m0",
                            children: "Filter by Objective and Subscription"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df aic jcsb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df",
                                        style: {
                                            gap: "0.35rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-75rem fw600 c15 op70 mr1rem",
                                                children: "Objective"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                className: "modules-filter-select",
                                                value: selectedObjective,
                                                onChange: (e)=>setSelectedObjective(e.target.value),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: objectiveOptions.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: name,
                                                        children: name
                                                    }, name))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df",
                                        style: {
                                            gap: "0.35rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-75rem fw600 c15 op70 mx1rem",
                                                children: "Subscription"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                className: "modules-filter-select",
                                                value: selectedSubscription,
                                                onChange: (e)=>setSelectedSubscription(e.target.value),
                                                style: {
                                                    width: "100%"
                                                },
                                                children: subscriptionOptions.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: name,
                                                        children: name
                                                    }, name))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: "cp bss bw1px br5px bg1 c15 fw600 fs0-8rem",
                                style: {
                                    padding: "0.45rem 0.75rem",
                                    borderColor: "#d9e1ff"
                                },
                                onClick: ()=>{
                                    setSelectedObjective("All");
                                    setSelectedSubscription("All");
                                },
                                children: "Reset"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-card mt1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "fs1-1rem fw600 c15 m0 mb1rem",
                        children: [
                            "Sections (",
                            sectionsToDisplay.length,
                            ")"
                        ]
                    }),
                    sectionsToDisplay.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs0-9rem op70 m0",
                        children: "No sections for the selected objective/subscription."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc",
                        style: {
                            gap: "1rem"
                        },
                        children: groupedSections.map((group)=>{
                            const groupQuestionCount = group.sections.reduce((acc, section)=>acc + $3303cdf06a05e7df$var$countQuestionsInSection(section), 0);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px p1rem",
                                style: {
                                    background: "linear-gradient(180deg, #fbfcff 0%, #f2f6ff 100%)",
                                    border: "1px solid #dfe8ff",
                                    boxShadow: "0 6px 16px rgba(74, 103, 255, 0.1)"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic",
                                        style: {
                                            gap: "0.75rem",
                                            flexWrap: "wrap",
                                            paddingBottom: "0.75rem",
                                            borderBottom: "1px solid #e5ecff"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "fw600 c15 fs1rem",
                                                        children: [
                                                            group.objective,
                                                            " + ",
                                                            group.subscription
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "fs0-75rem c15 op70 mt0-25rem",
                                                        children: [
                                                            "Sections: ",
                                                            group.sections.length,
                                                            " | Questions: ",
                                                            groupQuestionCount
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                style: {
                                                    gap: "0.4rem",
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: $3303cdf06a05e7df$var$badgeStyle($3303cdf06a05e7df$var$OBJECTIVE_STYLES[group.objective]),
                                                        children: group.objective
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: $3303cdf06a05e7df$var$badgeStyle($3303cdf06a05e7df$var$SUBSCRIPTION_STYLES[group.subscription]),
                                                        children: group.subscription
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc",
                                        style: {
                                            gap: "0.85rem",
                                            marginTop: "0.85rem"
                                        },
                                        children: group.sections.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "br10px p1rem",
                                                style: {
                                                    background: "linear-gradient(180deg, #ffffff 0%, #f8faff 100%)",
                                                    border: "1px solid #e7edff",
                                                    boxShadow: "0 4px 12px rgba(74, 103, 255, 0.08)"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcsb aic",
                                                        style: {
                                                            gap: "0.75rem",
                                                            flexWrap: "wrap",
                                                            paddingBottom: "0.65rem",
                                                            borderBottom: "1px solid #edf1ff"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "fw600 c15 fs0-95rem",
                                                                        children: [
                                                                            section.sectionNo || "-",
                                                                            " - ",
                                                                            section.sectionName || "-"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "fs0-75rem c15 op70 mt0-25rem",
                                                                        children: [
                                                                            "Questions: ",
                                                                            $3303cdf06a05e7df$var$countQuestionsInSection(section)
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                style: {
                                                                    gap: "0.4rem",
                                                                    flexWrap: "wrap"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $3303cdf06a05e7df$var$badgeStyle($3303cdf06a05e7df$var$OBJECTIVE_STYLES[section.companyObjective]),
                                                                        children: section.companyObjective || "All"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        style: $3303cdf06a05e7df$var$badgeStyle($3303cdf06a05e7df$var$SUBSCRIPTION_STYLES[section.subscriptionTier]),
                                                                        children: section.subscriptionTier || "All"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            marginTop: "0.35rem"
                                                        },
                                                        children: [
                                                            $3303cdf06a05e7df$var$renderQuestionCard(section.question, section.sectionNo),
                                                            $3303cdf06a05e7df$var$renderSubFolders(section.subFolders)
                                                        ]
                                                    })
                                                ]
                                            }, section._id || section.sectionNo))
                                    })
                                ]
                            }, group.key);
                        })
                    })
                ]
            })
        ]
    });
};
var $3303cdf06a05e7df$export$2e2bcd8739ae039 = $3303cdf06a05e7df$var$ModuleView;




const $77f79b46d2ce0bbb$var$ModulePage = ()=>{
    const [moduleState, setModuleState] = (0, $acw62.useState)("list");
    const [moduleId, setModuleId] = (0, $acw62.useState)();
    // Tracks an AI generation job triggered from the module actions menu
    const [aiJob, setAiJob] = (0, $acw62.useState)(null);
    const handleCreate = ()=>{
        setModuleState("create");
    };
    const handleEdit = (module)=>{
        setModuleId(module._id);
        setModuleState("edit");
    };
    const handleView = (module)=>{
        setModuleId(module._id);
        setModuleState("view");
    };
    const handleActivate = (module)=>{
        setModuleState("activate");
    };
    const handleDelete = (module)=>{
        setModuleState("delete");
    };
    // Called from ModuleActionsMenu → "Generate AI Content" for an existing module
    const handleGenerateAI = async (module)=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/generate-ai-module', {
                moduleId: module._id,
                generationMode: 'ai',
                sectionsPerCombo: 5,
                questionsPerSection: 10
            });
            if (res?.code === 200) {
                const jobData = res.body || {};
                setAiJob({
                    jobId: jobData.jobId,
                    moduleId: module._id,
                    moduleName: module.moduleName,
                    moduleImageUrl: module.imageURL || '',
                    estimatedSections: jobData.estimatedSections || 0,
                    estimatedQuestions: jobData.estimatedQuestions || 0
                });
                setModuleState("generate-ai");
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('AI generation started!');
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to start AI generation.');
        } catch (e) {
            console.error('Error triggering AI generation:', e);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to start AI generation.');
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            moduleState === "create" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d89bc8d00027b50e$export$2e2bcd8739ae039), {
                onSuccess: ()=>setModuleState("list"),
                onCancel: ()=>setModuleState("list")
            }),
            moduleState === "edit" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cbf539ca32cf2f5$export$2e2bcd8739ae039), {
                onSuccess: ()=>setModuleState("list"),
                onCancel: ()=>setModuleState("list"),
                moduleId: moduleId
            }),
            moduleState === "view" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3303cdf06a05e7df$export$2e2bcd8739ae039), {
                onCancel: ()=>setModuleState("list"),
                moduleId: moduleId
            }),
            moduleState === "generate-ai" && aiJob && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modules-container",
                style: {
                    padding: '2rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $138620d196adaf4d$export$2e2bcd8739ae039), {
                    jobId: aiJob.jobId,
                    moduleId: aiJob.moduleId,
                    moduleName: aiJob.moduleName,
                    moduleImageUrl: aiJob.moduleImageUrl,
                    estimatedSections: aiJob.estimatedSections,
                    estimatedQuestions: aiJob.estimatedQuestions,
                    onComplete: (job)=>{
                        console.log('AI generation finished:', job?.status);
                    },
                    onViewModule: ()=>{
                        setModuleId(aiJob.moduleId);
                        setAiJob(null);
                        setModuleState("edit");
                    }
                })
            }),
            moduleState === "list" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e37449cbb613ef9$export$2e2bcd8739ae039), {
                onCreate: handleCreate,
                onView: handleView,
                onEdit: handleEdit,
                handleActivate: handleActivate,
                handleDelete: handleDelete,
                onGenerateAI: handleGenerateAI
            })
        ]
    });
};
var $77f79b46d2ce0bbb$export$2e2bcd8739ae039 = $77f79b46d2ce0bbb$var$ModulePage;



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $ff14899ad9aeb5bc$var$CreateDashboardCardModal = ({ open: open, onClose: onClose, onSubmit: onSubmit, card: editingCard })=>{
    const [title, setTitle] = (0, $acw62.useState)('');
    const [subTitle, setSubTitle] = (0, $acw62.useState)('');
    const [grid, setGrid] = (0, $acw62.useState)('Grid');
    const [subscription, setSubscription] = (0, $acw62.useState)('Free');
    const [position, setPosition] = (0, $acw62.useState)(0);
    const [imageURL, setImageURL] = (0, $acw62.useState)('');
    const isEditMode = Boolean(editingCard?._id);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            if (editingCard) {
                setTitle(editingCard.title ?? '');
                setSubTitle(editingCard.subTitle ?? '');
                setGrid(editingCard.grid === 'Slider' ? 'Slider' : 'Grid');
                setSubscription([
                    'Free',
                    'Lite',
                    'Pro'
                ].includes(editingCard.subscription) ? editingCard.subscription : 'Free');
                setPosition(Number.isFinite(Number(editingCard.position)) ? Number(editingCard.position) : 0);
                setImageURL(editingCard.imageURL ?? '');
            } else {
                setTitle('');
                setSubTitle('');
                setGrid('Grid');
                setSubscription('Free');
                setPosition(0);
                setImageURL('');
            }
        }
    }, [
        open,
        editingCard
    ]);
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!title || !title.trim()) return;
        const payload = {
            title: title.trim(),
            subTitle: (subTitle ?? '').trim(),
            grid: grid,
            subscription: subscription,
            position: Number.isFinite(Number(position)) ? Number(position) : 0,
            imageURL: imageURL || ''
        };
        if (isEditMode) payload._id = editingCard._id;
        onSubmit(payload);
        setTitle('');
        setSubTitle('');
        setGrid('Grid');
        setSubscription('Free');
        setPosition(0);
        setImageURL('');
        onClose();
    };
    const handleClose = ()=>{
        setTitle('');
        setSubTitle('');
        setGrid('Grid');
        setSubscription('Free');
        setPosition(0);
        setImageURL('');
        onClose();
    };
    const inputStyle = {
        width: '100%',
        padding: '12px 14px',
        fontSize: '0.95rem',
        border: '1px solid #e0e0e0',
        borderRadius: '10px',
        outline: 'none',
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
        boxSizing: 'border-box'
    };
    const labelStyle = {
        display: 'block',
        fontSize: '0.875rem',
        fontWeight: 600,
        color: '#374151',
        marginBottom: '8px'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                maxWidth: '520px',
                maxHeight: '90vh',
                overflow: 'auto',
                background: '#fff',
                borderRadius: '16px',
                boxShadow: '0 24px 48px rgba(0,0,0,0.12), 0 12px 24px rgba(0,0,0,0.08)',
                outline: 'none'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: '24px 28px 20px',
                        borderBottom: '1px solid #f0f0f0',
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        gap: '16px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            style: {
                                margin: 0,
                                fontSize: '1.375rem',
                                fontWeight: 700,
                                color: '#1a1a2e',
                                letterSpacing: '-0.02em',
                                lineHeight: 1.3
                            },
                            children: isEditMode ? 'Edit Dashboard Card' : 'Create Dashboard Card'
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: handleClose,
                            "aria-label": "Close",
                            style: {
                                padding: '8px',
                                border: 'none',
                                background: '#f5f5f5',
                                borderRadius: '10px',
                                cursor: 'pointer',
                                color: '#666',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background 0.2s ease, color 0.2s ease'
                            },
                            onMouseOver: (e)=>{
                                e.currentTarget.style.background = '#eee';
                                e.currentTarget.style.color = '#333';
                            },
                            onMouseOut: (e)=>{
                                e.currentTarget.style.background = '#f5f5f5';
                                e.currentTarget.style.color = '#666';
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab8dae130526a9ed$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '22px'
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    style: {
                        padding: '28px 28px 32px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '24px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            style: labelStyle,
                                            children: [
                                                "Title ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        color: '#dc3545',
                                                        fontWeight: 600
                                                    },
                                                    children: "*"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: title,
                                            onChange: (e)=>setTitle(e.target.value),
                                            placeholder: "e.g. Key Documents",
                                            required: true,
                                            style: inputStyle,
                                            onFocus: (e)=>{
                                                e.target.style.borderColor = '#4CAF50';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(76, 175, 80, 0.15)';
                                            },
                                            onBlur: (e)=>{
                                                e.target.style.borderColor = '#e0e0e0';
                                                e.target.style.boxShadow = 'none';
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Position"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "number",
                                            value: position,
                                            onChange: (e)=>setPosition(e.target.value),
                                            placeholder: "e.g. 1",
                                            min: "0",
                                            style: inputStyle,
                                            onFocus: (e)=>{
                                                e.target.style.borderColor = '#4CAF50';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(76, 175, 80, 0.15)';
                                            },
                                            onBlur: (e)=>{
                                                e.target.style.borderColor = '#e0e0e0';
                                                e.target.style.boxShadow = 'none';
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Sub Title"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: subTitle,
                                            onChange: (e)=>setSubTitle(e.target.value),
                                            placeholder: "e.g. Upload and manage your files",
                                            style: inputStyle,
                                            onFocus: (e)=>{
                                                e.target.style.borderColor = '#4CAF50';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(76, 175, 80, 0.15)';
                                            },
                                            onBlur: (e)=>{
                                                e.target.style.borderColor = '#e0e0e0';
                                                e.target.style.boxShadow = 'none';
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Layout"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: grid,
                                            onChange: (e)=>setGrid(e.target.value),
                                            style: {
                                                ...inputStyle,
                                                cursor: 'pointer',
                                                appearance: 'none',
                                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'right 14px center',
                                                paddingRight: '36px'
                                            },
                                            onFocus: (e)=>{
                                                e.target.style.borderColor = '#4CAF50';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(76, 175, 80, 0.15)';
                                            },
                                            onBlur: (e)=>{
                                                e.target.style.borderColor = '#e0e0e0';
                                                e.target.style.boxShadow = 'none';
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "Grid",
                                                    children: "Grid"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "Slider",
                                                    children: "Slider"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Subscription"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: subscription,
                                            onChange: (e)=>setSubscription(e.target.value),
                                            style: {
                                                ...inputStyle,
                                                cursor: 'pointer',
                                                appearance: 'none',
                                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'right 14px center',
                                                paddingRight: '36px'
                                            },
                                            onFocus: (e)=>{
                                                e.target.style.borderColor = '#4CAF50';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(76, 175, 80, 0.15)';
                                            },
                                            onBlur: (e)=>{
                                                e.target.style.borderColor = '#e0e0e0';
                                                e.target.style.boxShadow = 'none';
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "Free",
                                                    children: "Free"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "Lite",
                                                    children: "Lite"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "Pro",
                                                    children: "Pro"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        marginTop: '4px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                        imageURL: imageURL,
                                        onImageChange: setImageURL,
                                        label: "Image"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                marginTop: '32px',
                                paddingTop: '24px',
                                borderTop: '1px solid #f0f0f0',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: handleClose,
                                    style: {
                                        padding: '12px 24px',
                                        fontSize: '0.9375rem',
                                        fontWeight: 600,
                                        color: '#555',
                                        background: '#fff',
                                        border: '1px solid #ddd',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease'
                                    },
                                    onMouseOver: (e)=>{
                                        e.currentTarget.style.background = '#f9f9f9';
                                        e.currentTarget.style.borderColor = '#ccc';
                                    },
                                    onMouseOut: (e)=>{
                                        e.currentTarget.style.background = '#fff';
                                        e.currentTarget.style.borderColor = '#ddd';
                                    },
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    style: {
                                        padding: '12px 24px',
                                        fontSize: '0.9375rem',
                                        fontWeight: 600,
                                        color: '#fff',
                                        background: '#4CAF50',
                                        border: 'none',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        boxShadow: '0 2px 8px rgba(76, 175, 80, 0.35)',
                                        transition: 'all 0.2s ease'
                                    },
                                    onMouseOver: (e)=>{
                                        e.currentTarget.style.background = '#45a049';
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(76, 175, 80, 0.4)';
                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                    },
                                    onMouseOut: (e)=>{
                                        e.currentTarget.style.background = '#4CAF50';
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(76, 175, 80, 0.35)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    },
                                    children: isEditMode ? 'Update Card' : 'Create Card'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $ff14899ad9aeb5bc$export$2e2bcd8739ae039 = $ff14899ad9aeb5bc$var$CreateDashboardCardModal;



const $790d7ed3643819e8$var$DashboardCardList = ()=>{
    const [modalOpen, setModalOpen] = (0, $acw62.useState)(false);
    const [editingCard, setEditingCard] = (0, $acw62.useState)(null);
    const { cards: cards, isLoading: isLoading, createCard: createCard, updateCard: updateCard, deleteCard: deleteCard } = (0, $d01221ba05bed299$export$7699c3c70698af94)();
    const handleCreateClick = ()=>{
        setEditingCard(null);
        setModalOpen(true);
    };
    const handleEditClick = (card)=>{
        setEditingCard(card);
        setModalOpen(true);
    };
    const handleModalClose = ()=>{
        setModalOpen(false);
        setEditingCard(null);
    };
    const handleSubmit = async (data)=>{
        if (data._id) {
            const result = await updateCard(data);
            if (result?.success) handleModalClose();
        } else {
            const result = await createCard(data);
            if (result?.success) handleModalClose();
        }
    };
    const handleDelete = (card)=>{
        if (window.confirm(`Delete "${card.title}"?`)) deleteCard(card._id);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "modules-title",
                                children: "Dashboard Cards"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "modules-subtitle",
                                children: "Manage dashboard cards"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: handleCreateClick,
                        className: "modules-create-btn df aic jcc cp",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '18px',
                                    marginRight: '8px'
                                }
                            }),
                            "Create Dashboard Card"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modules-table-header-row df jcsb aic mb1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "modules-table-title",
                            children: [
                                "Cards (",
                                cards.length,
                                ")"
                            ]
                        })
                    }),
                    isLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc aic p4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "loader"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml1rem fs0-75rem c15",
                                children: "Loading dashboard cards..."
                            })
                        ]
                    }) : cards.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modules-table-wrapper",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100 fs0-75rem c15",
                            style: {
                                borderCollapse: 'collapse'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        className: "fs0-75rem c15",
                                        style: {
                                            borderBottom: '2px solid #e0e0e0',
                                            background: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem",
                                                style: {
                                                    padding: '12px 16px',
                                                    textAlign: 'left',
                                                    fontWeight: 600
                                                },
                                                children: "Position"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem",
                                                style: {
                                                    padding: '12px 16px',
                                                    textAlign: 'left',
                                                    fontWeight: 600
                                                },
                                                children: "Title"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem",
                                                style: {
                                                    padding: '12px 16px',
                                                    textAlign: 'left',
                                                    fontWeight: 600
                                                },
                                                children: "Sub Title"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem",
                                                style: {
                                                    padding: '12px 16px',
                                                    textAlign: 'left',
                                                    fontWeight: 600
                                                },
                                                children: "Grid"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem",
                                                style: {
                                                    padding: '12px 16px',
                                                    textAlign: 'left',
                                                    fontWeight: 600
                                                },
                                                children: "Subscription"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem",
                                                style: {
                                                    padding: '12px 16px',
                                                    textAlign: 'left',
                                                    fontWeight: 600
                                                },
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: cards.map((card)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: "fs0-75rem c15",
                                            style: {
                                                borderBottom: '1px solid #eee'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "tal",
                                                    style: {
                                                        padding: '12px 16px'
                                                    },
                                                    children: Number.isFinite(Number(card.position)) ? Number(card.position) : 0
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "tal",
                                                    style: {
                                                        padding: '12px 16px'
                                                    },
                                                    children: card.title || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "tal",
                                                    style: {
                                                        padding: '12px 16px'
                                                    },
                                                    children: card.subTitle || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "tal",
                                                    style: {
                                                        padding: '12px 16px'
                                                    },
                                                    children: card.grid || 'Grid'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "tal",
                                                    style: {
                                                        padding: '12px 16px'
                                                    },
                                                    children: card.subscription || 'Free'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "df jcfs aic",
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'right'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleEditClick(card),
                                                            className: "df aic jcc cp bg44 c12",
                                                            style: {
                                                                padding: 6,
                                                                marginRight: 8
                                                            },
                                                            title: "Edit",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccd4473bf517ef36$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    fontSize: 20
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleDelete(card),
                                                            className: "df aic jcc cp bg44 c12",
                                                            style: {
                                                                padding: 6
                                                            },
                                                            title: "Delete",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                style: {
                                                                    fontSize: 20
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, card._id))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic jcc p4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-75rem c15 fw500 mb1rem",
                                children: "No dashboard cards yet"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: handleCreateClick,
                                className: "modules-create-btn df aic jcc cp",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: '18px',
                                            marginRight: '8px'
                                        }
                                    }),
                                    "Create Dashboard Card"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff14899ad9aeb5bc$export$2e2bcd8739ae039), {
                open: modalOpen,
                onClose: handleModalClose,
                onSubmit: handleSubmit,
                card: editingCard
            })
        ]
    });
};
var $790d7ed3643819e8$export$2e2bcd8739ae039 = $790d7ed3643819e8$var$DashboardCardList;


const $ded331993a2ed1be$var$DashboardCardPage = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $790d7ed3643819e8$export$2e2bcd8739ae039), {});
};
var $ded331993a2ed1be$export$2e2bcd8739ae039 = $ded331993a2ed1be$var$DashboardCardPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $9c5eb05f9740712a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($9c5eb05f9740712a$exports, "__esModule", {
    value: true
});
$9c5eb05f9740712a$exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = $9c5eb05f9740712a$exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $8c6ad197f63b3f3e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($8c6ad197f63b3f3e$exports, "__esModule", {
    value: true
});
$8c6ad197f63b3f3e$exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = $8c6ad197f63b3f3e$exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');






const $ecd97bcc85a49f9b$var$STAGE_OPTS = [
    'Investment',
    'Growth',
    'Exit'
];
const $ecd97bcc85a49f9b$var$SUB_OPTS = [
    'Free',
    'Lite',
    'Pro'
];
const $ecd97bcc85a49f9b$var$TARGET_TAB_OPTS = [
    'Dashboard',
    'AnyLists',
    'ResearchAid',
    'Workflows',
    'InvestorMatch'
];
const $ecd97bcc85a49f9b$var$NAVIGATION_TYPE_OPTS = [
    'Switch Tab',
    'Navigation'
];
const $ecd97bcc85a49f9b$var$createStageSubscriptionConfig = ()=>{
    const list = [];
    $ecd97bcc85a49f9b$var$STAGE_OPTS.forEach((stage)=>{
        $ecd97bcc85a49f9b$var$SUB_OPTS.forEach((sub)=>{
            list.push({
                companyStage: stage,
                companySubscription: sub,
                isVisible: true,
                isRestricted: false
            });
        });
    });
    return list;
};
const $ecd97bcc85a49f9b$var$normalizeStageSubscriptionConfig = (raw)=>{
    const source = Array.isArray(raw) ? raw : [];
    if (!source.length) return $ecd97bcc85a49f9b$var$createStageSubscriptionConfig();
    const map = new Map();
    source.forEach((item)=>{
        if (!item) return;
        const key = `${item.companyStage}__${item.companySubscription}`;
        map.set(key, {
            companyStage: item.companyStage,
            companySubscription: item.companySubscription,
            isVisible: item.isVisible !== false,
            isRestricted: item.isRestricted === true
        });
    });
    return $ecd97bcc85a49f9b$var$createStageSubscriptionConfig().map((entry)=>{
        const key = `${entry.companyStage}__${entry.companySubscription}`;
        return map.get(key) || entry;
    });
};
const $ecd97bcc85a49f9b$var$emptyForm = ()=>({
        dashboardCardId: '',
        title: '',
        subTitle: '',
        description: '',
        imageURL: '',
        companyStage: 'All',
        companySubscription: 'All',
        stageSubscriptionConfig: $ecd97bcc85a49f9b$var$createStageSubscriptionConfig(),
        navigationType: 'Switch Tab',
        targetTab: '',
        externalUrl: '',
        isResearchAid: false,
        menusConfig: [],
        isActive: true
    });
const $ecd97bcc85a49f9b$var$NavigationModulePage = ()=>{
    const [items, setItems] = (0, $acw62.useState)([]);
    const [dashboardCards, setDashboardCards] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [modalOpen, setModalOpen] = (0, $acw62.useState)(false);
    const [editing, setEditing] = (0, $acw62.useState)(null);
    const [form, setForm] = (0, $acw62.useState)($ecd97bcc85a49f9b$var$emptyForm());
    const [expandedMenuKey, setExpandedMenuKey] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const [navRes, dashRes] = await Promise.all([
                (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/navigation-module-cards'),
                (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/dashboard-cards')
            ]);
            if (navRes?.code === 200 && navRes?.body?.items) setItems(navRes.body.items);
            else setItems([]);
            if (dashRes?.code === 200 && dashRes?.body?.cards) setDashboardCards(dashRes.body.cards);
            else setDashboardCards([]);
        } catch (e) {
            console.error(e);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Could not load navigation modules.');
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const openCreate = ()=>{
        setEditing(null);
        setForm($ecd97bcc85a49f9b$var$emptyForm());
        setModalOpen(true);
    };
    const openEdit = (row)=>{
        setEditing(row);
        setForm({
            dashboardCardId: row.dashboardCardId?._id || row.dashboardCardId || '',
            title: row.title || '',
            subTitle: row.subTitle || '',
            description: row.description || '',
            imageURL: row.imageURL || '',
            companyStage: row.companyStage || 'All',
            companySubscription: row.companySubscription || 'All',
            navigationType: row.navigationType || (row.externalUrl ? 'Navigation' : 'Switch Tab'),
            targetTab: row.targetTab || '',
            externalUrl: row.externalUrl || '',
            isResearchAid: row.isResearchAid === true,
            stageSubscriptionConfig: $ecd97bcc85a49f9b$var$normalizeStageSubscriptionConfig(row.stageSubscriptionConfig),
            menusConfig: Array.isArray(row.menusConfig) ? row.menusConfig : [],
            isActive: row.isActive !== false
        });
        setModalOpen(true);
    };
    const handleClose = ()=>{
        setModalOpen(false);
        setEditing(null);
        setForm($ecd97bcc85a49f9b$var$emptyForm());
        setExpandedMenuKey(null);
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!form.title?.trim()) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Title is required.');
            return;
        }
        if (form.navigationType === 'Switch Tab' && !form.targetTab?.trim()) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Target tab is required for Switch Tab.');
            return;
        }
        if (form.navigationType === 'Navigation' && !form.externalUrl?.trim()) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('External URL is required for Navigation.');
            return;
        }
        const payload = {
            dashboardCardId: form.dashboardCardId || null,
            title: form.title.trim(),
            subTitle: (form.subTitle || '').trim(),
            description: (form.description || '').trim(),
            imageURL: (form.imageURL || '').trim(),
            companyStage: 'All',
            companySubscription: 'All',
            stageSubscriptionConfig: $ecd97bcc85a49f9b$var$normalizeStageSubscriptionConfig(form.stageSubscriptionConfig),
            navigationType: form.navigationType === 'Navigation' ? 'Navigation' : 'Switch Tab',
            targetTab: form.navigationType === 'Switch Tab' ? form.targetTab.trim() : '',
            externalUrl: form.navigationType === 'Navigation' ? (form.externalUrl || '').trim() : '',
            isResearchAid: form.navigationType === 'Navigation' ? form.isResearchAid === true : false,
            menusConfig: Array.isArray(form.menusConfig) ? form.menusConfig : [],
            isActive: form.isActive
        };
        if (editing?._id) payload._id = editing._id;
        try {
            const res = editing?._id ? await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)('/modules/navigation-module-cards', payload) : await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/navigation-module-cards', payload);
            if (res?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(editing ? 'Navigation entry updated.' : 'Navigation entry created.');
                handleClose();
                load();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Save failed');
        } catch (err) {
            console.error(err);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Save failed.');
        }
    };
    const handleDelete = async (row)=>{
        if (!window.confirm(`Delete "${row.title}"?`)) return;
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/navigation-module-cards/${row._id}`);
            if (res?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Deleted.');
                load();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Delete failed');
        } catch (e) {
            console.error(e);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Delete failed.');
        }
    };
    const dashTitle = (id)=>{
        if (!id) return 'None';
        const c = dashboardCards.find((x)=>String(x._id) === String(id));
        return c?.title || "\u2014";
    };
    const getVariantCell = (stage, sub)=>{
        const list = Array.isArray(form.stageSubscriptionConfig) ? form.stageSubscriptionConfig : [];
        return list.find((x)=>x.companyStage === stage && x.companySubscription === sub) || {
            companyStage: stage,
            companySubscription: sub,
            isVisible: false,
            isRestricted: false
        };
    };
    const updateVariantCell = (stage, sub, patch)=>{
        setForm((prev)=>{
            const next = $ecd97bcc85a49f9b$var$normalizeStageSubscriptionConfig(prev.stageSubscriptionConfig).map((x)=>{
                if (x.companyStage !== stage || x.companySubscription !== sub) return x;
                return {
                    ...x,
                    ...patch
                };
            });
            return {
                ...prev,
                stageSubscriptionConfig: next
            };
        });
    };
    const updateAllCells = (patch)=>{
        setForm((prev)=>({
                ...prev,
                stageSubscriptionConfig: $ecd97bcc85a49f9b$var$normalizeStageSubscriptionConfig(prev.stageSubscriptionConfig).map((x)=>({
                        ...x,
                        ...patch
                    }))
            }));
    };
    const createEmptyMenu = ()=>{
        const idx = (form.menusConfig || []).length + 1;
        return {
            key: `menu-${Date.now()}-${idx}`,
            label: '',
            iconURL: '',
            isActive: true,
            actionType: 'navigate',
            navigateUrl: '',
            modalDisplayType: 'contentAndImage',
            modalTitle: '',
            modalImageURL: '',
            modalContent: '',
            modalImagePosition: 'right'
        };
    };
    const handleAddMenu = ()=>{
        const newMenu = createEmptyMenu();
        setForm((f)=>({
                ...f,
                menusConfig: [
                    ...f.menusConfig || [],
                    newMenu
                ]
            }));
        setExpandedMenuKey(newMenu.key);
    };
    const handleRemoveMenu = (key)=>{
        setForm((f)=>({
                ...f,
                menusConfig: (f.menusConfig || []).filter((m)=>m.key !== key)
            }));
        if (expandedMenuKey === key) setExpandedMenuKey(null);
    };
    const handleMenuChange = (key, field, value)=>{
        setForm((f)=>({
                ...f,
                menusConfig: (f.menusConfig || []).map((m)=>m.key === key ? {
                        ...m,
                        [field]: value
                    } : m)
            }));
    };
    const inputStyle = {
        width: '100%',
        padding: '12px 14px',
        fontSize: '0.95rem',
        border: '1px solid #e0e0e0',
        borderRadius: '10px',
        outline: 'none',
        boxSizing: 'border-box',
        background: '#fff'
    };
    const labelStyle = {
        display: 'block',
        marginBottom: '6px',
        fontWeight: 600,
        fontSize: '0.8rem',
        color: '#1a2744'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-container navigation-cards-table",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "modules-title",
                                children: "Navigation Module"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "modules-subtitle",
                                children: "Curate shortcut tiles that appear on the company dashboard."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: openCreate,
                        className: "modules-create-btn df aic jcc cp",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                                style: {
                                    fontSize: 18,
                                    marginRight: 8
                                }
                            }),
                            "Create Navigation Card"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-card",
                style: {
                    borderRadius: '16px',
                    border: '1px solid #e8edf5',
                    background: '#fafbfd',
                    padding: '1.25rem 1.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcsb aic mb1rem",
                        style: {
                            flexWrap: 'wrap',
                            gap: '8px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "modules-table-title",
                            style: {
                                margin: 0
                            },
                            children: [
                                "Entries (",
                                items.length,
                                ")"
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc aic p4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "loader"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml1rem fs0-75rem c15",
                                children: "Loading\u2026"
                            })
                        ]
                    }) : items.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tac py4rem",
                        style: {
                            borderRadius: '12px',
                            border: '1px dashed #c7d2fe',
                            background: '#fff',
                            color: '#64748b'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                margin: 0,
                                fontSize: '1rem'
                            },
                            children: "No navigation cards yet. Create one to show it on the dashboard."
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modules-table-wrapper",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100 fs0-75rem c15",
                            style: {
                                borderCollapse: 'collapse'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            borderBottom: '2px solid #e0e0e0',
                                            background: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px',
                                                    width: 72
                                                },
                                                children: "Image"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Title"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Dashboard"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Behavior"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Destination"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Research Aid"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: items.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            style: {
                                                borderBottom: '1px solid #eee'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: row.imageURL ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: row.imageURL,
                                                        alt: row.title || 'Navigation',
                                                        style: {
                                                            width: 34,
                                                            height: 34,
                                                            borderRadius: 6,
                                                            objectFit: 'cover',
                                                            border: '1px solid #e2e8f0'
                                                        }
                                                    }) : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "fw600",
                                                            children: row.title || "\u2014"
                                                        }),
                                                        row.subTitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "op70",
                                                            children: row.subTitle
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: dashTitle(row.dashboardCardId?._id || row.dashboardCardId)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: row.navigationType === 'Navigation' ? 'Navigation' : 'Switch Tab'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left',
                                                        maxWidth: 280,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    },
                                                    children: row.navigationType === 'Navigation' ? row.externalUrl || "\u2014" : row.targetTab || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: row.isResearchAid ? 'Yes' : 'No'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "df aic",
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>openEdit(row),
                                                            className: "df aic jcc cp bg44 c12",
                                                            style: {
                                                                padding: 6,
                                                                marginRight: 8
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {
                                                                style: {
                                                                    fontSize: 20
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleDelete(row),
                                                            className: "df aic jcc cp bg44 c12",
                                                            style: {
                                                                padding: 6
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                                                style: {
                                                                    fontSize: 20
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, row._id))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modalOpen,
                onClose: handleClose,
                className: "backdrop td500 zi4 df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow br15px bsbb",
                    style: {
                        outline: 'none',
                        maxWidth: '720px',
                        width: '92%',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        padding: '1.75rem',
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: handleClose,
                            className: "pa cp",
                            style: {
                                top: 12,
                                right: 12,
                                border: 'none',
                                background: 'transparent'
                            },
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "fs1-25rem fw600 c15 mb1rem",
                            style: {
                                paddingRight: 32
                            },
                            children: editing ? 'Edit navigation card' : 'Create navigation card'
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    style: labelStyle,
                                    children: "Dashboard card"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    style: {
                                        ...inputStyle,
                                        marginBottom: 14
                                    },
                                    value: form.dashboardCardId,
                                    onChange: (e)=>setForm((f)=>({
                                                ...f,
                                                dashboardCardId: e.target.value
                                            })),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "",
                                            children: "None (unassigned)"
                                        }),
                                        dashboardCards.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: c._id,
                                                children: c.title || c._id
                                            }, c._id))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    style: labelStyle,
                                    children: "Title"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    style: {
                                        ...inputStyle,
                                        marginBottom: 14
                                    },
                                    value: form.title,
                                    onChange: (e)=>setForm((f)=>({
                                                ...f,
                                                title: e.target.value
                                            })),
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    style: labelStyle,
                                    children: "Subtitle"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    style: {
                                        ...inputStyle,
                                        marginBottom: 14
                                    },
                                    value: form.subTitle,
                                    onChange: (e)=>setForm((f)=>({
                                                ...f,
                                                subTitle: e.target.value
                                            }))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    style: labelStyle,
                                    children: "Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    style: {
                                        ...inputStyle,
                                        minHeight: 72,
                                        resize: 'vertical',
                                        marginBottom: 14
                                    },
                                    value: form.description,
                                    onChange: (e)=>setForm((f)=>({
                                                ...f,
                                                description: e.target.value
                                            }))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        marginBottom: 14
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                        imageURL: form.imageURL,
                                        onImageChange: (url)=>setForm((f)=>({
                                                    ...f,
                                                    imageURL: url
                                                })),
                                        label: "Navigation card image"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        marginBottom: 14
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Active"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            style: inputStyle,
                                            value: form.isActive ? 'yes' : 'no',
                                            onChange: (e)=>setForm((f)=>({
                                                        ...f,
                                                        isActive: e.target.value === 'yes'
                                                    })),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "yes",
                                                    children: "Yes"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "no",
                                                    children: "No"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        marginBottom: 18
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Visibility Matrix (easy mode)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc",
                                            style: {
                                                gap: 10
                                            },
                                            children: $ecd97bcc85a49f9b$var$STAGE_OPTS.map((stage)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        border: '1px solid #e6edf6',
                                                        borderRadius: 10,
                                                        padding: 10,
                                                        background: '#fbfdff'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "fw600 fs0-85rem mb0-5rem",
                                                            style: {
                                                                color: '#334155'
                                                            },
                                                            children: stage
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "dg",
                                                            style: {
                                                                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                                                                gap: 8
                                                            },
                                                            children: $ecd97bcc85a49f9b$var$SUB_OPTS.map((sub)=>{
                                                                const cell = getVariantCell(stage, sub);
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    style: {
                                                                        border: '1px solid #e2e8f0',
                                                                        borderRadius: 8,
                                                                        padding: 8,
                                                                        background: '#fff'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "fw600 fs0-75rem mb0-5rem",
                                                                            children: sub
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "df aic",
                                                                            style: {
                                                                                gap: 6,
                                                                                marginBottom: 6
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: cell.isVisible === true,
                                                                                    onChange: (e)=>updateVariantCell(stage, sub, {
                                                                                            isVisible: e.target.checked
                                                                                        })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-75rem",
                                                                                    children: "is Visible?"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "df aic",
                                                                            style: {
                                                                                gap: 6
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: cell.isRestricted === true,
                                                                                    onChange: (e)=>updateVariantCell(stage, sub, {
                                                                                            isRestricted: e.target.checked
                                                                                        })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-75rem",
                                                                                    children: "is Restricted?"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, `${stage}-${sub}`);
                                                            })
                                                        })
                                                    ]
                                                }, stage))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                            className: "fs11px c15 op60 mt0-5rem",
                                            children: "Turn visibility on/off and mark combinations as restricted."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    style: labelStyle,
                                    children: "Navigation behavior"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                    style: {
                                        ...inputStyle,
                                        marginBottom: 14
                                    },
                                    value: form.navigationType,
                                    onChange: (e)=>{
                                        const nextType = e.target.value === 'Navigation' ? 'Navigation' : 'Switch Tab';
                                        setForm((f)=>({
                                                ...f,
                                                navigationType: nextType,
                                                targetTab: nextType === 'Switch Tab' ? f.targetTab : '',
                                                externalUrl: nextType === 'Navigation' ? f.externalUrl : ''
                                            }));
                                    },
                                    children: $ecd97bcc85a49f9b$var$NAVIGATION_TYPE_OPTS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: opt,
                                            children: opt
                                        }, opt))
                                }),
                                form.navigationType === 'Switch Tab' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Target tab"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            style: {
                                                ...inputStyle,
                                                marginBottom: 20
                                            },
                                            value: form.targetTab,
                                            onChange: (e)=>setForm((f)=>({
                                                        ...f,
                                                        targetTab: e.target.value
                                                    })),
                                            required: true,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "",
                                                    children: "Select target tab..."
                                                }),
                                                $ecd97bcc85a49f9b$var$TARGET_TAB_OPTS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: opt,
                                                        children: opt
                                                    }, opt))
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "External URL"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            style: {
                                                ...inputStyle,
                                                marginBottom: 20
                                            },
                                            value: form.externalUrl,
                                            onChange: (e)=>setForm((f)=>({
                                                        ...f,
                                                        externalUrl: e.target.value
                                                    })),
                                            placeholder: "https://\u2026",
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            className: "df aic",
                                            style: {
                                                gap: 8,
                                                marginBottom: 20
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: form.isResearchAid === true,
                                                    onChange: (e)=>setForm((f)=>({
                                                                ...f,
                                                                isResearchAid: e.target.checked
                                                            }))
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-8rem",
                                                    children: "isResearchAid"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        marginBottom: 18,
                                        border: '1px solid #e6edf6',
                                        borderRadius: 10,
                                        padding: 14,
                                        background: '#fbfdff'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb aic mb1rem",
                                            style: {
                                                flexWrap: 'wrap',
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "fw600 fs0-9rem",
                                                            style: {
                                                                color: '#1a2744'
                                                            },
                                                            children: "Menu list"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "fs0-75rem op60",
                                                            children: 'Configure dynamic menu items (e.g. "How it works?", "Help") for this navigation card.'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    type: "button",
                                                    onClick: handleAddMenu,
                                                    className: "cp df aic jcc",
                                                    style: {
                                                        background: 'linear-gradient(135deg, #0d9488, #0f766e)',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: 8,
                                                        padding: '6px 14px',
                                                        fontSize: '0.8rem',
                                                        fontWeight: 600,
                                                        gap: 4
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                                                            style: {
                                                                fontSize: 15
                                                            }
                                                        }),
                                                        " Add menu"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc",
                                            style: {
                                                gap: 10
                                            },
                                            children: [
                                                (form.menusConfig || []).length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs0-85rem c15 op70 m0",
                                                    children: 'No menus configured yet. Use "Add menu" to create one.'
                                                }),
                                                (form.menusConfig || []).map((menu)=>{
                                                    const isExpanded = expandedMenuKey === menu.key;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            border: '1px solid #e2e8f0',
                                                            borderRadius: 8,
                                                            padding: 10,
                                                            background: '#fff'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                type: "button",
                                                                className: "df jcsb aic w100 cp",
                                                                onClick: ()=>setExpandedMenuKey(isExpanded ? null : menu.key),
                                                                style: {
                                                                    background: 'transparent',
                                                                    border: 'none',
                                                                    padding: '4px 0'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        style: {
                                                                            gap: 8
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fw500 fs0-9rem c15",
                                                                                children: menu.label || 'Untitled menu'
                                                                            }),
                                                                            menu.isActive === false && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-7rem br10px px0-5rem py0-15rem",
                                                                                style: {
                                                                                    background: '#ffecec',
                                                                                    color: '#c62828'
                                                                                },
                                                                                children: "Inactive"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        style: {
                                                                            gap: 6
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: (e)=>{
                                                                                    e.stopPropagation();
                                                                                    handleRemoveMenu(menu.key);
                                                                                },
                                                                                className: "cp df aic jcc",
                                                                                style: {
                                                                                    border: 'none',
                                                                                    background: 'transparent',
                                                                                    color: '#c62828'
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                                                                    style: {
                                                                                        fontSize: 18
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    color: '#666'
                                                                                },
                                                                                children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4623a154accf113$exports))), {
                                                                                    fontSize: "small"
                                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                                                                                    fontSize: "small"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            isExpanded && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                style: {
                                                                    marginTop: 12,
                                                                    display: 'grid',
                                                                    gridTemplateColumns: '1fr 1fr',
                                                                    gap: 12
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc",
                                                                        style: {
                                                                            gap: 10
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                        style: labelStyle,
                                                                                        children: "Menu label"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        style: inputStyle,
                                                                                        value: menu.label || '',
                                                                                        onChange: (e)=>handleMenuChange(menu.key, 'label', e.target.value),
                                                                                        placeholder: "e.g. How It Works?"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                className: "df aic",
                                                                                style: {
                                                                                    gap: 6
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        type: "checkbox",
                                                                                        checked: menu.isActive !== false,
                                                                                        onChange: (e)=>handleMenuChange(menu.key, 'isActive', e.target.checked)
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fs0-8rem fw500",
                                                                                        children: "Active menu"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                        style: labelStyle,
                                                                                        children: "Action type"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                                                        style: inputStyle,
                                                                                        value: menu.actionType || 'navigate',
                                                                                        onChange: (e)=>handleMenuChange(menu.key, 'actionType', e.target.value),
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                value: "navigate",
                                                                                                children: "Navigate (open URL)"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                value: "modal",
                                                                                                children: "Open modal"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            menu.actionType === 'navigate' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                        style: labelStyle,
                                                                                        children: "Target URL"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        style: inputStyle,
                                                                                        value: menu.navigateUrl || '',
                                                                                        onChange: (e)=>handleMenuChange(menu.key, 'navigateUrl', e.target.value),
                                                                                        placeholder: "https://example.com/help"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                                        className: "fs11px op60",
                                                                                        children: "Opens in a new tab."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            menu.actionType === 'modal' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                                style: labelStyle,
                                                                                                children: "Modal display type"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                                                                style: inputStyle,
                                                                                                value: menu.modalDisplayType || 'contentAndImage',
                                                                                                onChange: (e)=>handleMenuChange(menu.key, 'modalDisplayType', e.target.value),
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                    value: "imageOnly",
                                                                                                    children: "Image Only"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                                style: labelStyle,
                                                                                                children: "Modal title"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                style: inputStyle,
                                                                                                value: menu.modalTitle || '',
                                                                                                onChange: (e)=>handleMenuChange(menu.key, 'modalTitle', e.target.value),
                                                                                                placeholder: "Enter modal title"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        style: {
                                                                                            marginTop: 4
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                                                                            imageURL: menu.modalImageURL,
                                                                                            onImageChange: (url)=>handleMenuChange(menu.key, 'modalImageURL', url),
                                                                                            label: "Modal image"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                                                            imageURL: menu.iconURL,
                                                                            onImageChange: (url)=>handleMenuChange(menu.key, 'iconURL', url),
                                                                            label: "Menu icon"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, menu.key);
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcfe",
                                    style: {
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "button",
                                            className: "cp p1rem br8px bg44",
                                            onClick: handleClose,
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            type: "submit",
                                            className: "cp p1rem br8px c1 fw600",
                                            style: {
                                                background: 'linear-gradient(135deg, #0d9488, #0f766e)',
                                                border: 'none'
                                            },
                                            children: editing ? 'Save changes' : 'Create'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $ecd97bcc85a49f9b$export$2e2bcd8739ae039 = $ecd97bcc85a49f9b$var$NavigationModulePage;


var $0831abacdddbb745$export$2e2bcd8739ae039 = (0, $ecd97bcc85a49f9b$export$2e2bcd8739ae039);



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $d812595be82c5518$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($d812595be82c5518$exports, "__esModule", {
    value: true
});
$d812595be82c5518$exports.default = void 0;

var $d812595be82c5518$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d812595be82c5518$var$_default = $d812595be82c5518$exports.default = (0, $d812595be82c5518$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z"
}), 'Image');


var $70f3b6c121fb5d84$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($70f3b6c121fb5d84$exports, "__esModule", {
    value: true
});
$70f3b6c121fb5d84$exports.default = void 0;

var $70f3b6c121fb5d84$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $70f3b6c121fb5d84$var$_default = $70f3b6c121fb5d84$exports.default = (0, $70f3b6c121fb5d84$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2.5 4v3h5v12h3V7h5V4zm19 5h-9v3h3v7h3v-7h3z"
}), 'TextFields');




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $cf655ff2c68ce0fe$var$emptyForm = {
    type: 'Text',
    topText: '',
    imageURL: '',
    title: '',
    description: '',
    buttonText: '',
    buttonLink: '',
    isActive: true,
    sequence: ''
};
const $cf655ff2c68ce0fe$var$AssistanceCardModal = ({ open: open, onClose: onClose, onSubmit: onSubmit, card: card })=>{
    const [form, setForm] = (0, $acw62.useState)($cf655ff2c68ce0fe$var$emptyForm);
    const isEdit = Boolean(card?._id);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        if (card) setForm({
            type: card.type || 'Text',
            topText: card.topText || '',
            imageURL: card.imageURL || '',
            title: card.title || '',
            description: card.description || '',
            buttonText: card.buttonText || '',
            buttonLink: card.buttonLink || '',
            isActive: card.isActive !== false,
            sequence: card.sequence != null ? String(card.sequence) : ''
        });
        else setForm($cf655ff2c68ce0fe$var$emptyForm);
    }, [
        open,
        card
    ]);
    const handleSubmit = (e)=>{
        e.preventDefault();
        const seqRaw = String(form.sequence ?? '').trim();
        const seqNum = seqRaw === '' ? undefined : Number(seqRaw);
        const { sequence: _omitSeq, ...formRest } = form;
        const payload = {
            ...formRest,
            title: String(form.title || '').trim(),
            description: String(form.description || '').trim(),
            buttonText: String(form.buttonText || '').trim(),
            buttonLink: String(form.buttonLink || '').trim(),
            topText: form.type === 'Text' ? String(form.topText || '').trim() : '',
            imageURL: form.type === 'Image' ? String(form.imageURL || '').trim() : '',
            ...seqRaw !== '' && Number.isFinite(seqNum) ? {
                sequence: seqNum
            } : {}
        };
        if (isEdit) payload._id = card._id;
        onSubmit(payload);
    };
    const inputStyle = {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #dbe3f0',
        borderRadius: 10,
        fontSize: '0.9rem',
        outline: 'none',
        boxSizing: 'border-box'
    };
    const labelStyle = {
        display: 'block',
        marginBottom: 6,
        fontWeight: 600,
        fontSize: '0.8rem',
        color: '#1a2744'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        className: "backdrop td500 zi4 df jcc aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg1 shadow br15px bsbb",
            style: {
                width: '92%',
                maxWidth: 560,
                maxHeight: '90vh',
                overflow: 'auto',
                padding: '1.5rem',
                position: 'relative',
                outline: 'none'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    type: "button",
                    onClick: onClose,
                    className: "pa cp",
                    style: {
                        top: 12,
                        right: 12,
                        border: 'none',
                        background: 'transparent'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c5eb05f9740712a$exports))), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "fs1-25rem fw600 c15 mb1rem",
                    style: {
                        paddingRight: 32
                    },
                    children: isEdit ? 'Edit Assistance Card' : 'Create Assistance Card'
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            style: labelStyle,
                            children: "Sequence"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "number",
                            style: {
                                ...inputStyle,
                                marginBottom: 12
                            },
                            value: form.sequence,
                            onChange: (e)=>setForm((f)=>({
                                        ...f,
                                        sequence: e.target.value
                                    })),
                            placeholder: "Leave empty for auto (append after highest)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            style: labelStyle,
                            children: "Type"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                            style: {
                                ...inputStyle,
                                marginBottom: 12
                            },
                            value: form.type,
                            onChange: (e)=>setForm((f)=>({
                                        ...f,
                                        type: e.target.value
                                    })),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "Text",
                                    children: "Text"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                    value: "Image",
                                    children: "Image"
                                })
                            ]
                        }),
                        form.type === 'Text' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    style: labelStyle,
                                    children: "Top Text"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    style: {
                                        ...inputStyle,
                                        marginBottom: 12
                                    },
                                    value: form.topText,
                                    onChange: (e)=>setForm((f)=>({
                                                ...f,
                                                topText: e.target.value
                                            })),
                                    placeholder: "Category / top text"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                marginBottom: 12
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da798e28ced8c022$export$2e2bcd8739ae039), {
                                imageURL: form.imageURL,
                                onImageChange: (url)=>setForm((f)=>({
                                            ...f,
                                            imageURL: url
                                        })),
                                label: "Image"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            style: labelStyle,
                            children: "Title"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            required: true,
                            style: {
                                ...inputStyle,
                                marginBottom: 12
                            },
                            value: form.title,
                            onChange: (e)=>setForm((f)=>({
                                        ...f,
                                        title: e.target.value
                                    }))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            style: labelStyle,
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                            style: {
                                ...inputStyle,
                                minHeight: 80,
                                resize: 'vertical',
                                marginBottom: 12
                            },
                            value: form.description,
                            onChange: (e)=>setForm((f)=>({
                                        ...f,
                                        description: e.target.value
                                    }))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df",
                            style: {
                                gap: 10,
                                marginBottom: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Button Text"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            style: inputStyle,
                                            value: form.buttonText,
                                            onChange: (e)=>setForm((f)=>({
                                                        ...f,
                                                        buttonText: e.target.value
                                                    }))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            style: labelStyle,
                                            children: "Active"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            style: inputStyle,
                                            value: form.isActive ? 'yes' : 'no',
                                            onChange: (e)=>setForm((f)=>({
                                                        ...f,
                                                        isActive: e.target.value === 'yes'
                                                    })),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "yes",
                                                    children: "Yes"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "no",
                                                    children: "No"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            style: labelStyle,
                            children: "Button Link"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            style: {
                                ...inputStyle,
                                marginBottom: 18
                            },
                            value: form.buttonLink,
                            onChange: (e)=>setForm((f)=>({
                                        ...f,
                                        buttonLink: e.target.value
                                    })),
                            placeholder: "https://..."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcfe",
                            style: {
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "cp p1rem br8px bg44",
                                    onClick: onClose,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "submit",
                                    className: "cp p1rem br8px c1 fw600",
                                    style: {
                                        background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                                        border: 'none'
                                    },
                                    children: isEdit ? 'Save changes' : 'Create'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $cf655ff2c68ce0fe$export$2e2bcd8739ae039 = $cf655ff2c68ce0fe$var$AssistanceCardModal;


const $b50385a3fa5d4c3b$var$AssistanceCardsPage = ()=>{
    const [items, setItems] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [modalOpen, setModalOpen] = (0, $acw62.useState)(false);
    const [editing, setEditing] = (0, $acw62.useState)(null);
    const load = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/assistance-cards');
            if (res?.code === 200 && res?.body?.items) setItems(res.body.items);
            else setItems([]);
        } catch (e) {
            console.error(e);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Could not load assistance cards.');
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const handleSubmit = async (data)=>{
        try {
            const res = data._id ? await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)('/modules/assistance-cards', data) : await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/assistance-cards', data);
            if (res?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(data._id ? 'Assistance card updated.' : 'Assistance card created.');
                setModalOpen(false);
                setEditing(null);
                load();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Save failed');
        } catch (e) {
            console.error(e);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Save failed.');
        }
    };
    const handleDelete = async (row)=>{
        if (!window.confirm(`Delete "${row.title}"?`)) return;
        const res = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/assistance-cards/${row._id}`);
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Deleted.');
            load();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modules-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "modules-title",
                                children: "Assistance Cards"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "modules-subtitle",
                                children: "Manage helper cards with image/text variants"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>{
                            setEditing(null);
                            setModalOpen(true);
                        },
                        className: "modules-create-btn df aic jcc cp",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                                style: {
                                    fontSize: 18,
                                    marginRight: 8
                                }
                            }),
                            "Create Assistance Card"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modules-table-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modules-table-header-row df jcsb aic mb1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "modules-table-title",
                            children: [
                                "Cards (",
                                items.length,
                                ")"
                            ]
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc aic p4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "loader"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml1rem fs0-75rem c15",
                                children: "Loading..."
                            })
                        ]
                    }) : items.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modules-table-wrapper assistance-cards-table",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100 fs0-75rem c15",
                            style: {
                                borderCollapse: 'collapse'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            borderBottom: '2px solid #e0e0e0',
                                            background: '#fafafa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Seq"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Title"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Button"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1rem tal",
                                                style: {
                                                    padding: '12px 16px'
                                                },
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: items.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            style: {
                                                borderBottom: '1px solid #eee'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: row.sequence != null ? row.sequence : "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: 6
                                                        },
                                                        children: [
                                                            row.type === 'Image' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d812595be82c5518$exports))), {
                                                                style: {
                                                                    fontSize: 16
                                                                }
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($70f3b6c121fb5d84$exports))), {
                                                                style: {
                                                                    fontSize: 16
                                                                }
                                                            }),
                                                            " ",
                                                            row.type || 'Text'
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: row.title || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left',
                                                        maxWidth: 280,
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    },
                                                    children: row.description || row.topText || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: row.buttonText || "\u2014"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: row.isActive ? 'Active' : 'Inactive'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "df aic",
                                                    style: {
                                                        padding: '12px 16px',
                                                        textAlign: 'left'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>{
                                                                setEditing(row);
                                                                setModalOpen(true);
                                                            },
                                                            className: "df aic jcc cp bg44 c12",
                                                            style: {
                                                                padding: 6,
                                                                marginRight: 8
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {
                                                                style: {
                                                                    fontSize: 20
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>handleDelete(row),
                                                            className: "df aic jcc cp bg44 c12",
                                                            style: {
                                                                padding: 6
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($14b4fcb0e549e7b0$exports))), {
                                                                style: {
                                                                    fontSize: 20
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, row._id))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic jcc p4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-95rem c15 fw500 mb1rem",
                                children: "No assistance cards yet"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setEditing(null);
                                    setModalOpen(true);
                                },
                                className: "modules-create-btn df aic jcc cp",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($570fd50501d08ed5$exports))), {
                                        style: {
                                            fontSize: 18,
                                            marginRight: 8
                                        }
                                    }),
                                    "Create Assistance Card"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf655ff2c68ce0fe$export$2e2bcd8739ae039), {
                open: modalOpen,
                onClose: ()=>{
                    setModalOpen(false);
                    setEditing(null);
                },
                onSubmit: handleSubmit,
                card: editing
            })
        ]
    });
};
var $b50385a3fa5d4c3b$export$2e2bcd8739ae039 = $b50385a3fa5d4c3b$var$AssistanceCardsPage;


var $e2fd1dcc4a02aa67$export$2e2bcd8739ae039 = (0, $b50385a3fa5d4c3b$export$2e2bcd8739ae039);


const $1f609915e12f5806$export$682261bb742f7b6d = (question)=>{
    let keys = [
        'qDescription'
    ]; // 'commentPoints', 'filePoints', 'completionScore'], //TODO: maybe use later
    if (question['questionType'].includes('F')) keys.push('templateFiles');
    if ([
        'esg',
        'software-development',
        'directors-questionnaire',
        'warranty-disclosure',
        'repository'
    ].includes(question['type'])) keys = keys.concat([
        'topTip',
        'toolboxOffer'
    ]);
    if ([
        'esg',
        'software-development',
        'business-audit-investment',
        'business-audit-growth',
        'business-audit-exit'
    ].includes(question['type'])) keys = keys.concat([
        'riskDescription',
        'recommendDescription'
    ]);
    else if (question['questionType'].includes('YN') && question['type'] != 'repository') keys = keys.concat([
        'ifYes',
        'riskIfYes',
        'ifNo',
        'riskIfNo'
    ]);
    if (question['questionType'].includes('1to5')) keys = keys.concat([
        'if1',
        'riskIf1',
        'if2',
        'riskIf2',
        'if3',
        'riskIf3',
        'if4',
        'riskIf4',
        'if5',
        'riskIf5'
    ]);
    if (question['questionType'].includes('D/ND')) keys = keys.concat([
        'ifD',
        'riskIfD',
        'ifNS',
        'riskIfNS',
        'ifND',
        'riskIfND'
    ]);
    return [
        ...keys
    ];
};





function $1f609915e12f5806$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [allUsers, setAllUsers] = (0, $acw62.useState)([]);
    let [category, setCategory] = (0, $acw62.useState)('');
    let [panel, setPanel] = (0, $acw62.useState)('Modules');
    let [action, setAction] = (0, $acw62.useState)('create');
    let [deleteFile, setDeleteFile] = (0, $acw62.useState)();
    let [deleteUser, setDeleteUser] = (0, $acw62.useState)();
    let [sectionNo, setSectionNo] = (0, $acw62.useState)('');
    let [moduleList, setModuleList] = (0, $acw62.useState)([]);
    let [moduleName, setModuleName] = (0, $acw62.useState)('');
    let [allPartners, setAllPartners] = (0, $acw62.useState)([]);
    let [sectionList, setSectionList] = (0, $acw62.useState)([]);
    let [sectionName, setSectionName] = (0, $acw62.useState)('');
    let [selectedFirm, setSelectedFirm] = (0, $acw62.useState)();
    let [deleteCompany, setDeleteCompany] = (0, $acw62.useState)();
    let [categoryList, setCategoryList] = (0, $acw62.useState)([]);
    let [currentSection, setCurrentSection] = (0, $acw62.useState)();
    let [selectedData, setSelectedData] = (0, $acw62.useState)(null);
    let [archivedCompanies, setArchivedCompanies] = (0, $acw62.useState)([]);
    let [subPanel, setSubPanel] = (0, $acw62.useState)('Subscribed Companies');
    let [usersSubPanel, setUsersSubPanel] = (0, $acw62.useState)('Users');
    let [superUserFilter, setSuperUserFilter] = (0, $acw62.useState)('All');
    let [superUserOptions, setSuperUserOptions] = (0, $acw62.useState)([]);
    let [deleteFileQuestionId, setDeleteFileQuestionId] = (0, $acw62.useState)();
    let [aiTest, setAiTest] = (0, $acw62.useState)(location.hash.includes('#AI'));
    let [partner, setPartner] = (0, $acw62.useState)({
        name: '',
        type: 'Business for Funding',
        testType: 'exit',
        moduleName: '',
        moduleKey: '',
        moduleDescription: '',
        focusArea: {
            focus1: '',
            focus2: '',
            focus3: ''
        }
    });
    //Pagigantion 
    let [currentPage, setCurrentPage] = (0, $acw62.useState)(0);
    let [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(10);
    let [deleteModuleName, setDeleteModuleName] = (0, $acw62.useState)('');
    let [expensionPackList, setExpensionPackList] = (0, $acw62.useState)([]);
    let [deletedCompaniesLogs, setDeletedCompaniesLogs] = (0, $acw62.useState)([]);
    let [sectionsAndQuestions, setSectionsAndQuestions] = (0, $acw62.useState)({});
    let [tabsAndKeysForChecklist, setTabsAndKeysForChecklist] = (0, $acw62.useState)([]);
    let [tab, setTab] = (0, $acw62.useState)(location.hash.replace("#", "").replace(/_/g, " ").replace("AI ", ""));
    let [modulesNewSubTab, setModulesNewSubTab] = (0, $acw62.useState)('DashboardCards');
    const handleRevenueLeadMode = async (selectedData, data, type)=>{
        try {
            const path = type === "company" ? `/company/updatecompany/${selectedData?._id}` : `/user/updateuser/${selectedData?._id}`;
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(path, data);
            if (response['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                const newArr = allUsers.reduce((acc, current)=>{
                    if (current._id === selectedData?._id) current = {
                        ...current,
                        ...data
                    };
                    acc.push(current);
                    return acc;
                }, []);
                setAllUsers(newArr);
            }
        } catch (err) {
            console.log(err);
        } finally{
        // setIsLoading(false)
        }
    };
    const ActionColumn = ({ onDeleteClick: onDeleteClick, onEditClick: onEditClick, props: props })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "number df jcc",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    style: {
                        backgroundColor: "transparent"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        "data-tooltip": `Edit  ${subPanel.replace("Management", "").trim()}`,
                        style: {
                            color: props?.original?.isDefault ? '#E6E6E6' : '#fc7785 ',
                            fontSize: '20px',
                            cursor: props?.original?.isDefault ? "not-allowed" : 'pointer'
                        },
                        className: `fa fa-pencil`,
                        onClick: onEditClick
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    style: {
                        backgroundColor: "transparent"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        "data-tooltip": `Delete  ${subPanel.replace("Management", "").trim()}`,
                        className: "fa fa-trash c9 cp",
                        style: {
                            fontSize: '20px',
                            color: props?.original?.isDefault ? '#E6E6E6' : '#fc7785 ',
                            cursor: props?.original?.isDefault ? "not-allowed" : 'pointer'
                        },
                        onClick: onDeleteClick
                    })
                })
            ]
        });
    };
    // Category Table Columns
    const CATEGORY_TABLE_COLUMNS = [
        {
            id: 'name',
            Header: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcs",
                children: "Category Name"
            }),
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcs",
                    children: props?.original?.name
                })
        },
        {
            Header: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc",
                children: "Action"
            }),
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)(ActionColumn, {
                    onDeleteClick: ()=>{
                        if (!props?.original?.isDefault) {
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'deleteModal'
                            }));
                            setSelectedData({
                                title: 'Category',
                                ...props?.original,
                                identifier: (0, $0df9b3ab7364c6d6$export$604d3285d0026214).CATEGORY
                            });
                        }
                    },
                    onEditClick: ()=>{
                        if (!props?.original?.isDefault) {
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'addEditCategory'
                            }));
                            setSelectedData({
                                title: 'Edit Category',
                                ...props?.original
                            });
                            setCategory(props?.original?.name);
                        }
                    },
                    props: props
                })
        }
    ];
    // Section Table Columns
    const SECTION_TABLE_COLUMNS = [
        {
            id: 'sectionNo',
            Header: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcs",
                children: "Section No"
            }),
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "fw600 df jcs",
                    children: props?.original?.sectionNo
                })
        },
        {
            id: "sectionName",
            Header: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcs",
                children: "Section Name"
            }),
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcs",
                    children: props?.original?.sectionName
                })
        },
        {
            Header: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc",
                children: "Action"
            }),
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)(ActionColumn, {
                    onDeleteClick: ()=>{
                        if (!props?.original?.isDefault) {
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'deleteSection'
                            }));
                            setSelectedData({
                                title: 'Section',
                                ...props?.original,
                                name: props?.original?.sectionName,
                                identifier: (0, $0df9b3ab7364c6d6$export$604d3285d0026214).SECTION
                            });
                        }
                    },
                    onEditClick: ()=>{
                        if (!props?.original?.isDefault) {
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'addEditSection'
                            }));
                            setSelectedData({
                                title: 'Edit Section',
                                ...props?.original
                            });
                            setSectionNo(props?.original?.sectionNo);
                            setSectionName(props?.original?.sectionName);
                        }
                    },
                    props: props
                })
        }
    ];
    // Module Table Columns
    const MODULE_TABLE_COLUMNS = [
        {
            id: 'moduleName',
            Header: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcs",
                children: "Module Name"
            }),
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcs",
                    children: props?.original?.moduleName
                })
        },
        {
            Header: 'Action',
            Cell: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)(ActionColumn, {
                    onDeleteClick: ()=>{
                        if (!props?.original?.isDefault) {
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'deleteModal'
                            }));
                            setSelectedData({
                                title: 'Module',
                                ...props?.original,
                                name: props?.original?.moduleName,
                                identifier: (0, $0df9b3ab7364c6d6$export$604d3285d0026214).MODULE
                            });
                        }
                    },
                    onEditClick: ()=>{
                        if (!props?.original?.isDefault) {
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'addEditModule'
                            }));
                            setSelectedData({
                                title: 'Edit Module',
                                ...props?.original
                            });
                            setModuleName(props?.original?.moduleName);
                        }
                    },
                    props: props
                })
        }
    ];
    let tabsAndKeys = {
        "Two Minute Audit - Investment": {
            title: 'Two Minute Audit - Investment',
            name: "two-minute-test-investment"
        },
        "Two Minute Audit - Growth": {
            title: 'Two Minute Audit - Growth',
            name: "two-minute-test-growth"
        },
        "Two Minute Audit - Exit": {
            title: 'Two Minute Audit - Exit',
            name: "two-minute-test-exit"
        },
        "Repository": {
            name: "repository",
            title: 'Repository'
        },
        "Business Audit - Investment": {
            name: "business-audit-investment",
            title: "Business Audit - Investment"
        },
        "Business Audit - Growth": {
            name: "business-audit-growth",
            title: "Business Audit - Growth"
        },
        "Business Audit - Exit": {
            name: "business-audit-exit",
            title: "Business Audit - Exit"
        },
        "Warranty Disclosure": {
            expansionPack: true,
            name: "warranty-disclosure",
            title: 'Warranty Disclosure'
        },
        "Directors Questionnaire": {
            expansionPack: true,
            name: "directors-questionnaire",
            title: 'Directors Questionnaire'
        },
        "Software Development": {
            expansionPack: true,
            name: "software-development",
            title: 'Software Development'
        },
        "ESG": {
            name: "esg",
            title: 'ESG',
            expansionPack: true
        },
        "Investor Lead Introduction": {
            name: "investor-lead",
            title: 'Investor Lead Introduction',
            expansionPack: true
        }
    };
    (0, $acw62.useEffect)(()=>{
        const newTab = location.hash.replace("#", "").replace(/_/g, " ").replace("AI ", "");
        setTab(newTab);
    }, [
        location.hash
    ]);
    // Getting all allocation tab's table data adn calling it again when some action perform
    (0, $acw62.useEffect)(()=>{
        getAllPartners();
        getAllCompaniesUsers('User');
        getQuestions();
        getSections();
        getCategorys();
        getModules();
        getModule();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (panel == 'Companies') setSubPanel('Subscribed Companies');
        else if (panel == 'ChatGPT') setSubPanel('Business Audit');
        else if (panel === "Allocation Management") setSubPanel('Category Management');
    }, [
        panel
    ]);
    (0, $acw62.useEffect)(()=>{
        location.hash = ((aiTest ? "AI " : "") + tab).replace(/\s/g, "_");
    }, [
        tab,
        aiTest
    ]);
    const getModule = async ()=>{
        let moduleResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/view/module`);
        setModuleList(moduleResponse['body']);
    };
    const getCategorys = async ()=>{
        let categoryResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/view/category`);
        setCategoryList(categoryResponse['body']);
    };
    const getSections = async ()=>{
        let sectionResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/view/section/existingsections`);
        setSectionList(sectionResponse['body']);
        let expensionPackResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/admin/view/section/expensionpack`);
        setExpensionPackList(expensionPackResponse['body']);
    };
    const getModules = async ()=>{
        let usersResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/repository/getModule`);
        setTabsAndKeysForChecklist(usersResponse['body']);
    };
    const activeModule = async (moduleId, moduleName, isActive)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/activeModule`, {
            moduleId: moduleId,
            moduleName: moduleName,
            isActive: isActive
        });
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            await getModules();
        }
    };
    const deleteModule = async (moduleName)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/deleteModule`, {
            moduleName: moduleName
        });
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            await getModules();
        }
    };
    const getAllCompaniesUsers = async (role = null, superUser = null, yopmailOnly = false)=>{
        let url = '/user/getAllUsers';
        if (role) url += `?role=${role}`;
        if (superUser && superUser !== 'All') url += `&superUser=${superUser}`;
        if (yopmailOnly) url += (url.includes('?') ? '&' : '?') + `yopmailOnly=true`;
        let usersResponse = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(url);
        if (usersResponse && usersResponse?.code === 200) {
            // For Advisors, response is { users, superUsers }
            // For Users, response is just the array
            if (role === 'Advisor' && usersResponse['body']?.users) {
                setAllUsers(usersResponse['body'].users);
                setSuperUserOptions(usersResponse['body'].superUsers || []);
            } else setAllUsers(usersResponse['body']);
        }
    };
    const getQuestions = async ()=>{
        // setSectionsAndQuestions({});
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/getAllQuestions`);
        if (res?.code === 200) setSectionsAndQuestions(res.body);
    };
    let iconClasses = "center-vertically f3 pa l0 ml1rem br5px mah2rem maw2rem";
    let inputValues = {
        "qDescription": {
            title: 'Question Description',
            placeholder: 'Please add you question description',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M256 336c-18 0-32 14-32 32c0 18 13.1 32 32 32c17.1 0 32-13.1 32-32C288 350 273.1 336 256 336zM289.1 128h-51.1C198.1 128 168 158.1 168 198c0 12.1 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 158.1 328.1 128 289.1 128z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 400c-18 0-32-14-32-32s13.1-32 32-32c17.1 0 32 14 32 32S273.1 400 256 400zM325.1 258L280 286V288c0 13-11 24-24 24S232 301 232 288V272c0-8 4-16 12-21l57-34C308 213 312 206 312 198C312 186 301.1 176 289.1 176h-51.1C225.1 176 216 186 216 198c0 13-11 24-24 24s-24-11-24-24C168 159 199 128 237.1 128h51.1C329 128 360 159 360 198C360 222 347 245 325.1 258z"
                    })
                ]
            })
        },
        "topTip": {
            title: 'Tool Tip',
            placeholder: 'Please provide tooltip for help',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 640 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z"
                    })
                ]
            })
        },
        "toolboxOffer": {
            title: 'Tool Box Offer',
            placeholder: 'Please provide toolbox offer for help',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M512 205.3V320h-128V272C384 263.1 376.9 256 368 256h-32C327.1 256 320 263.1 320 272V320H192V272C192 263.1 184.9 256 176 256h-32C135.1 256 128 263.1 128 272V320H0V205.3c0-8.5 3.375-16.62 9.375-22.62l45.25-45.25C60.63 131.4 68.75 128 77.25 128h357.5c8.5 0 16.62 3.375 22.62 9.375l45.25 45.25C508.6 188.6 512 196.8 512 205.3z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M384 320v48c0 8.875-7.125 16-16 16h-32c-8.875 0-16-7.125-16-16V320H192v48C192 376.9 184.9 384 176 384h-32C135.1 384 128 376.9 128 368V320H0v128c0 17.62 14.38 32 32 32h448c17.62 0 32-14.38 32-32v-128H384zM176 80h160V128H384V80C384 53.5 362.5 32 336 32h-160C149.5 32 128 53.5 128 80V128h48V80z"
                    })
                ]
            })
        },
        "templateFiles": {
            title: 'Template File',
            placeholder: 'Please provide template file to help company understand how they can format this document before uploading (optional)',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z"
                    })
                ]
            })
        },
        "riskDescription": {
            title: 'Risk Description',
            placeholder: 'Please provide Risk Description if answer is negative (NO)',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
                    })
                ]
            })
        },
        "recommendDescription": {
            title: 'Recommendation Description',
            placeholder: 'Please provide Recommendation if answer is negative (NO)',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 640 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z"
                    })
                ]
            })
        },
        "noPoints": {
            title: 'Points on No',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M384 64.01v384c0 13.47-8.438 25.5-21.09 30.09C359.3 479.4 355.7 480 352 480c-9.312 0-18.38-4.078-24.59-11.52L64 152.4v295.6c0 17.67-14.31 32-32 32s-32-14.33-32-32v-384c0-13.47 8.438-25.5 21.09-30.09c12.62-4.516 26.84-.75 35.5 9.609L320 359.6v-295.6c0-17.67 14.31-32 32-32S384 46.34 384 64.01z"
                })
            })
        },
        "yesPoints": {
            title: 'Points on Yes',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z"
                })
            })
        },
        "completionScore": {
            title: 'Points on Completion',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 576 512",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        d: "M335.9 371c-9.715 8.604-15.9 20.65-15.9 33.62C319.1 428.7 339.3 448 363.4 448h4.644c26.51 0 47.99 21.49 47.99 48c0 8.836-7.162 16-15.1 16H176c-8.836 0-15.1-7.164-15.1-16c0-26.51 21.48-48 47.99-48h4.644c24.03 0 43.36-19.33 43.36-43.35c0-12.98-6.184-25.02-15.9-33.62C128 271.7 128 96 128 96L128 32c0-17.67 14.5-32 32.17-32h255.7C433.5 0 448 14.33 448 32l-.0059 64C447.1 96 447.1 271.7 335.9 371z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        d: "M193.7 316.9C189.8 311.1 186.2 305.3 182.8 299.4c-47.14-19.35-82.56-45.83-105.4-79.52C49.47 178.6 47.01 135.7 48.38 112h80.39C128.1 101.9 128 96 128 96L128.1 64H27.26C16.16 64 6.537 71.59 3.912 82.38C3.1 85.78-15.71 167.2 37.07 245.9c37.45 55.82 100.6 95.03 187.5 117.4c8.828 2.268 17.76 9.74 15.51 7.75C211.9 346 194.2 317.4 193.7 316.9zM572.1 82.38C569.5 71.59 559.8 64 548.7 64h-100.8l.0811 32c0 0-.0953 5.926-.7652 16h80.39c1.375 23.66-1.093 66.63-29.03 107.8c-22.82 33.69-58.25 60.17-105.4 79.52c-3.402 5.91-7.023 11.73-10.86 17.5c-.5352 .5352-18.2 29.14-46.45 54.16c-2.248 1.99 6.687-5.482 15.51-7.75c86.96-22.34 150.1-61.55 187.5-117.4C591.7 167.2 572.9 85.78 572.1 82.38z"
                    })
                ]
            })
        },
        "filePoints": {
            title: 'Points on File Upload',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 640 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M640 352c0 70.7-57.31 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9C96.11 197.4 96 194.7 96 192c0-88.41 71.59-160 160-160c59.31 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.312 23.91-6.406 34.59C596 238.4 640 290.1 640 352z"
                })
            })
        },
        "commentPoints": {
            title: 'Points on Comment',
            placeholder: '',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 512 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M256 32C114.6 32 .0272 125.1 .0272 240c0 49.63 21.35 94.98 56.97 130.7c-12.5 50.37-54.27 95.27-54.77 95.77c-2.25 2.25-2.875 5.734-1.5 8.734C1.979 478.2 4.75 480 8 480c66.25 0 115.1-31.76 140.6-51.39C181.2 440.9 217.6 448 256 448c141.4 0 255.1-93.13 255.1-208S397.4 32 256 32z"
                })
            })
        },
        "ifYes": {
            title: 'Yes Recommendation',
            placeholder: 'Recommendation if Yes',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z"
                })
            })
        },
        "ifNo": {
            title: 'No Recommendation',
            placeholder: 'Recommendation if No',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M384 64.01v384c0 13.47-8.438 25.5-21.09 30.09C359.3 479.4 355.7 480 352 480c-9.312 0-18.38-4.078-24.59-11.52L64 152.4v295.6c0 17.67-14.31 32-32 32s-32-14.33-32-32v-384c0-13.47 8.438-25.5 21.09-30.09c12.62-4.516 26.84-.75 35.5 9.609L320 359.6v-295.6c0-17.67 14.31-32 32-32S384 46.34 384 64.01z"
                })
            })
        },
        "if1": {
            title: 'Option 1 Recommendation',
            placeholder: 'Recommendation if selected option is 1',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 256 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M256 448c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h64V123.8L49.75 154.6C35.02 164.5 15.19 160.4 5.375 145.8C-4.422 131.1-.4531 111.2 14.25 101.4l96-64c9.828-6.547 22.45-7.187 32.84-1.594C153.5 41.37 160 52.22 160 64.01v352h64C241.7 416 256 430.3 256 448z"
                })
            })
        },
        "if2": {
            title: 'Option 2 Recommendation',
            placeholder: 'Recommendation if selected option is 2',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 448c0 17.67-14.33 32-32 32H32c-13.08 0-24.83-7.953-29.7-20.09c-4.859-12.12-1.859-26 7.594-35.03l193.6-185.1c31.36-30.17 33.95-80 5.812-113.4c-14.91-17.69-35.86-28.12-58.97-29.38C127.4 95.83 105.3 103.9 88.53 119.9L53.52 151.7c-13.08 11.91-33.33 10.89-45.2-2.172C-3.563 136.5-2.594 116.2 10.48 104.3l34.45-31.3c28.67-27.34 68.39-42.11 108.9-39.88c40.33 2.188 78.39 21.16 104.4 52.03c49.8 59.05 45.2 147.3-10.45 200.8l-136 130H288C305.7 416 320 430.3 320 448z"
                })
            })
        },
        "if3": {
            title: 'Option 3 Recommendation',
            placeholder: 'Recommendation if selected option is 3',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 344c0 74.98-61.02 136-136 136H103.6c-46.34 0-87.31-29.53-101.1-73.48c-5.594-16.77 3.484-34.88 20.25-40.47c16.75-5.609 34.89 3.484 40.47 20.25c5.922 17.77 22.48 29.7 41.23 29.7H184c39.7 0 72-32.3 72-72s-32.3-72-72-72H80c-13.2 0-25.05-8.094-29.83-20.41C45.39 239.3 48.66 225.3 58.38 216.4l131.4-120.4H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h240c13.2 0 25.05 8.094 29.83 20.41c4.781 12.3 1.516 26.27-8.203 35.19l-131.4 120.4H184C258.1 208 320 269 320 344z"
                })
            })
        },
        "if4": {
            title: 'Option 4 Recommendation',
            placeholder: 'Recommendation if selected option is 4',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 384 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M384 334.2c0 17.67-14.33 32-32 32h-32v81.78c0 17.67-14.33 32-32 32s-32-14.33-32-32v-81.78H32c-10.97 0-21.17-5.625-27.05-14.89c-5.859-9.266-6.562-20.89-1.875-30.81l128-270.2C138.6 34.33 157.8 27.56 173.7 35.09c15.97 7.562 22.78 26.66 15.22 42.63L82.56 302.2H256V160c0-17.67 14.33-32 32-32s32 14.33 32 32v142.2h32C369.7 302.2 384 316.6 384 334.2z"
                })
            })
        },
        "if5": {
            title: 'Option 5 Recommendation',
            placeholder: 'Recommendation if selected option is 5',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 344.6c0 74.66-60.73 135.4-135.4 135.4H104.7c-46.81 0-88.22-29.83-103-74.23c-5.594-16.77 3.469-34.89 20.23-40.48c16.83-5.625 34.91 3.469 40.48 20.23c6.078 18.23 23.08 30.48 42.3 30.48h79.95c39.36 0 71.39-32.03 71.39-71.39s-32.03-71.38-71.39-71.38H32c-9.484 0-18.47-4.203-24.56-11.48C1.359 254.5-1.172 244.9 .5156 235.6l32-177.2C35.27 43.09 48.52 32.01 64 32.01l192 .0049c17.67 0 32 14.33 32 32s-14.33 32-32 32H90.73L70.3 209.2h114.3C259.3 209.2 320 269.1 320 344.6z"
                })
            })
        },
        "ifD": {
            title: 'Disclosure Recommendation',
            placeholder: 'Recommendation if selected option is Disclosure',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 256 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M256 448c0 17.67-14.33 32-32 32H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h64V123.8L49.75 154.6C35.02 164.5 15.19 160.4 5.375 145.8C-4.422 131.1-.4531 111.2 14.25 101.4l96-64c9.828-6.547 22.45-7.187 32.84-1.594C153.5 41.37 160 52.22 160 64.01v352h64C241.7 416 256 430.3 256 448z"
                })
            })
        },
        "ifND": {
            title: 'Non-Disclosure Recommendation',
            placeholder: 'Recommendation if selected option is Non Disclosure',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 448c0 17.67-14.33 32-32 32H32c-13.08 0-24.83-7.953-29.7-20.09c-4.859-12.12-1.859-26 7.594-35.03l193.6-185.1c31.36-30.17 33.95-80 5.812-113.4c-14.91-17.69-35.86-28.12-58.97-29.38C127.4 95.83 105.3 103.9 88.53 119.9L53.52 151.7c-13.08 11.91-33.33 10.89-45.2-2.172C-3.563 136.5-2.594 116.2 10.48 104.3l34.45-31.3c28.67-27.34 68.39-42.11 108.9-39.88c40.33 2.188 78.39 21.16 104.4 52.03c49.8 59.05 45.2 147.3-10.45 200.8l-136 130H288C305.7 416 320 430.3 320 448z"
                })
            })
        },
        "ifNS": {
            title: 'Not Selected Recommendation',
            placeholder: 'Recommendation if selected option is Not Selected',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                className: iconClasses,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 320 512",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M320 344c0 74.98-61.02 136-136 136H103.6c-46.34 0-87.31-29.53-101.1-73.48c-5.594-16.77 3.484-34.88 20.25-40.47c16.75-5.609 34.89 3.484 40.47 20.25c5.922 17.77 22.48 29.7 41.23 29.7H184c39.7 0 72-32.3 72-72s-32.3-72-72-72H80c-13.2 0-25.05-8.094-29.83-20.41C45.39 239.3 48.66 225.3 58.38 216.4l131.4-120.4H32c-17.67 0-32-14.33-32-32s14.33-32 32-32h240c13.2 0 25.05 8.094 29.83 20.41c4.781 12.3 1.516 26.27-8.203 35.19l-131.4 120.4H184C258.1 208 320 269 320 344z"
                })
            })
        }
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e, question, sectionIndex, questionIndex, module)=>{
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        e.target.querySelector("input").value = null;
        saveQuestion(e, question, sectionIndex, questionIndex, module);
    };
    const confirmDeleteFile = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteTemplate', {
            file: deleteFile,
            questionId: deleteFileQuestionId
        });
        if (!res || res['code'] != 200) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        getQuestions();
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    const saveQuestion = async (e, question, sectionIndex, questionIndex, module)=>{
        let attachment = [];
        if (e.target.files) for (const file of e.target.files)attachment.push(file);
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/update`, {
            attachment: attachment,
            questionId: question['_id'],
            [e.target.name]: e.target.value
        });
        if (!res || res['code'] != 200) return;
        if (e.target.files) getQuestions();
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    //setSectionsAndQuestions(); //TODO: update this
    };
    const getDeletedCompaniesLogs = async ()=>{
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', {
            endpoint: '/company/adminDeleteCompany'
        });
        if (response && response['code'] == 200) {
            setDeletedCompaniesLogs(response['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'deletedCompaniesLogs'
            }));
        }
    };
    const submitDeleteCompany = async (companyId)=>{
        let requestBody = {
            companyId: deleteCompany?.['_id'],
            companyName: deleteCompany?.['cName'],
            creatorId: deleteCompany?.['creatorId']?.['_id'],
            creatorEmail: deleteCompany?.['creatorId']?.['email'],
            creatorName: `${deleteCompany?.['creatorId']?.['firstName']} ${deleteCompany?.['creatorId']?.['lastName']}`
        };
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/adminDeleteCompany`, requestBody);
        if (response && response['code'] == 200) {
            await getAllCompaniesUsers();
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        }
    };
    // Filtering the data into table using case-in-sensitive
    const filterCaseInsensitive = (filter, row)=>{
        const id = filter['pivotId'] || filter['id'];
        const content = row[id];
        if (typeof content !== 'undefined') {
            if (typeof content === 'object' && content !== null && content.key) return String(content['key']).toLowerCase().includes(filter['value'].toLowerCase());
            else return String(content).toLowerCase().includes(filter['value'].toLowerCase());
        }
        return true;
    };
    const submitDeleteUser = async (userId)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/deleteUser/${userId}`);
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        window.location.reload();
    };
    const modulesTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr5-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Modules"
                    }),
                    Object.keys(tabsAndKeys).map((s, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>setTab(s),
                            className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss mih4rem",
                            children: s
                        }, idx))
                ]
            })
        });
    };
    const companiesTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df fdc aic advisor-index zi2 pr",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                value: subPanel,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                        onChange: (e, value)=>setSubPanel(value),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Subscribed Companies",
                                value: "Subscribed Companies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Archived Companies",
                                value: "Archived Companies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Yopmail Companies",
                                value: "Yopmail Companies"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>getDeletedCompaniesLogs(),
                        className: "cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem fw500 pa r0",
                        children: "Audit Log"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Subscribed Companies",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe21d3c4e4f6d27e$export$2e2bcd8739ae039), {
                            isArchived: false,
                            setDeleteCompany: setDeleteCompany,
                            handleRevenueLeadMode: handleRevenueLeadMode
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Archived Companies",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe21d3c4e4f6d27e$export$2e2bcd8739ae039), {
                            isArchived: true,
                            setDeleteCompany: setDeleteCompany,
                            handleRevenueLeadMode: handleRevenueLeadMode
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Yopmail Companies",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe21d3c4e4f6d27e$export$2e2bcd8739ae039), {
                            isArchived: false,
                            isYopmail: true,
                            setDeleteCompany: setDeleteCompany,
                            handleRevenueLeadMode: handleRevenueLeadMode
                        })
                    })
                ]
            })
        });
    };
    const usersColumns = [
        {
            id: 'name',
            Header: 'Name',
            accessor: (user)=>user['firstName'] || user['lastName'] ? (user['firstName'] || '-') + " " + (user['lastName'] || '-') : '-'
        },
        {
            id: 'email',
            Header: 'Email',
            width: 200,
            accessor: (user)=>user['email'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "ttl",
                    children: user['email']
                }) : '-'
        },
        {
            id: 'companyId',
            Header: 'Company',
            width: 100,
            accessor: (user)=>user['companyId'] ? user['companyId']['cName'] : '-'
        },
        {
            id: 'createdAt',
            Header: 'Created At',
            accessor: (user)=>user['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(user['createdAt']).format('DD/MMM/YY') : '-'
        },
        {
            id: 'role',
            Header: 'Role',
            accessor: (user)=>user['role'] ? user['role'] : '-'
        },
        {
            id: 'advisorType',
            Header: 'Advisor Type',
            accessor: (user)=>user['advisorType'] && user['advisorType']['name'] ? user['advisorType']['name'] : '-'
        },
        {
            id: 'lastLoginAt',
            Header: 'Last Login',
            accessor: (user)=>user['lastLoginAt']
        },
        {
            id: 'timezone',
            Header: 'Time Zone',
            accessor: (user)=>user['timezone'] ? user['timezone'] : '-'
        },
        {
            id: 'action',
            Header: 'Revenue Lead',
            accessor: (user)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "checkbox",
                        checked: user?.revenueLeadMode ?? false,
                        onChange: (e)=>handleRevenueLeadMode(user, {
                                revenueLeadMode: e.target.checked
                            }, 'user')
                    })
                });
            }
        },
        {
            id: 'delete',
            Header: 'Delete',
            accessor: (user)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: ()=>{
                        setDeleteUser(user), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: 'deleteUserPopup'
                        }));
                    },
                    style: {
                        backgroundColor: "transparent"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        "data-tooltip": "Delete User",
                        className: "fa fa-trash c9 cp",
                        style: {
                            fontSize: '20px'
                        }
                    })
                })
        }
    ];
    const advisorsColumns = [
        {
            id: 'name',
            Header: 'Name',
            accessor: (user)=>user['firstName'] || user['lastName'] ? (user['firstName'] || '-') + " " + (user['lastName'] || '-') : '-'
        },
        {
            id: 'email',
            Header: 'Email',
            width: 200,
            accessor: (user)=>user['email'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "ttl",
                    children: user['email']
                }) : '-'
        },
        {
            id: 'title',
            Header: 'Title',
            accessor: (user)=>user['title'] ? user['title'] : '-'
        },
        {
            id: 'companyId',
            Header: 'Company',
            width: 100,
            accessor: (user)=>user['companyId'] ? user['companyId']['cName'] : '-'
        },
        {
            id: 'country',
            Header: 'Country',
            accessor: (user)=>user['country'] ? user['country'] : '-'
        },
        {
            id: 'officeLocation',
            Header: 'Office Location',
            accessor: (user)=>user['officeLocation'] ? user['officeLocation'] : '-'
        },
        {
            id: 'superUser',
            Header: 'SuperUser',
            accessor: (user)=>user['superUser'] ? user['superUser'] : '-'
        },
        {
            id: 'accountStatus',
            Header: 'Account Status',
            accessor: (user)=>user['accountStatus'] ? user['accountStatus'] : '-'
        },
        {
            id: 'isRegistered',
            Header: 'Registration Status',
            accessor: (user)=>user['isRegistered'] ? 'Registered' : 'Not Registered'
        },
        {
            id: 'createdAt',
            Header: 'Created At',
            accessor: (user)=>user['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(user['createdAt']).format('DD/MMM/YY') : '-'
        },
        {
            id: 'delete',
            Header: 'Delete',
            accessor: (user)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: ()=>{
                        setDeleteUser(user), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: 'deleteUserPopup'
                        }));
                    },
                    style: {
                        backgroundColor: "transparent"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        "data-tooltip": "Delete User",
                        className: "fa fa-trash c9 cp",
                        style: {
                            fontSize: '20px'
                        }
                    })
                })
        }
    ];
    const usersTab = ()=>{
        // Fetch data when subtab changes
        const handleUsersSubPanelChange = async (e, value)=>{
            setUsersSubPanel(value);
            setSuperUserFilter('All'); // Reset filter when switching tabs
            if (value === 'Users') await getAllCompaniesUsers('User');
            else if (value === 'Advisors') await getAllCompaniesUsers('Advisor', 'All');
            else if (value === 'Yopmail Users') await getAllCompaniesUsers(null, null, true);
        };
        // Handle superUser filter change
        const handleSuperUserFilterChange = async (e)=>{
            const value = e.target.value;
            setSuperUserFilter(value);
            await getAllCompaniesUsers('Advisor', value);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df fdc aic advisor-index zi2 pr",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                value: usersSubPanel,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                        onChange: handleUsersSubPanelChange,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Users",
                                value: "Users"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Advisors",
                                value: "Advisors"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Yopmail Users",
                                value: "Yopmail Users"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Users",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg1 shadow p2rem dg gg2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                                        children: "Users Database"
                                    }),
                                    allUsers && allUsers.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "admin-table mt1rem w100 ttc tac",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                            minRows: 20,
                                            className: "table",
                                            data: allUsers,
                                            resolveData: (user)=>user.map((row)=>row),
                                            columns: usersColumns,
                                            filterable: true,
                                            defaultFilterMethod: filterCaseInsensitive
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "View Data About All Users"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Advisors",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg1 shadow p2rem dg gg2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr w100 mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                                                children: "Advisors Database"
                                            }),
                                            superUserOptions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                value: superUserFilter,
                                                onChange: handleSuperUserFilterChange,
                                                className: "p0-5rem br5px pa r0 t0",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: "All",
                                                        children: "All"
                                                    }),
                                                    superUserOptions.map((su)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: su,
                                                            children: su
                                                        }, su))
                                                ]
                                            })
                                        ]
                                    }),
                                    allUsers && allUsers.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "admin-table mt1rem w100 ttc tac",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                            minRows: 20,
                                            className: "table",
                                            data: allUsers,
                                            resolveData: (user)=>user.map((row)=>row),
                                            columns: advisorsColumns,
                                            filterable: true,
                                            defaultFilterMethod: filterCaseInsensitive
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "No Advisors Found"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Yopmail Users",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bg1 shadow p2rem dg gg2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                                        children: "Yopmail Users Database"
                                    }),
                                    allUsers && allUsers.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "admin-table mt1rem w100 ttc tac",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                                            minRows: 20,
                                            className: "table",
                                            data: allUsers,
                                            resolveData: (user)=>user.map((row)=>row),
                                            columns: usersColumns,
                                            filterable: true,
                                            defaultFilterMethod: filterCaseInsensitive
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "No Yopmail Users Found"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        });
    };
    const partnersColumns = [
        {
            id: 'name',
            Header: 'Name',
            accessor: (partner)=>partner['name'] ? partner['name'] : '-'
        },
        {
            id: 'moduleKey',
            Header: 'Module Key',
            accessor: (partner)=>partner['moduleKey'] ? partner['moduleKey'] : '-'
        },
        {
            id: 'type',
            Header: 'Type',
            accessor: (partner)=>partner['type'] ? partner['type'] : '-'
        },
        {
            id: 'testType',
            Header: 'Company Type',
            accessor: (partner)=>partner['testType'] ? partner['testType'] : '-'
        },
        {
            id: 'totalChecklists',
            Header: 'Checklist Created',
            accessor: (partner)=>partner['totalChecklists'] ? partner['totalChecklists'] : '-'
        },
        {
            id: 'totalUsers',
            Header: 'User Registered',
            accessor: (partner)=>partner['totalUsers'] ? partner['totalUsers'] : '-'
        },
        {
            id: 'link',
            Header: 'Link',
            accessor: (partner)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    class: "c3 c4-hover",
                    href: partner['link'],
                    target: "_blank",
                    children: "LINK"
                })
        },
        {
            id: 'referralCode',
            Header: 'Referral Code',
            accessor: (partner)=>partner['referralCode'] ? partner['referralCode'] : '-'
        },
        {
            id: 'action',
            Header: 'Action',
            accessor: (partner)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    class: "df jcc px1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "df cp bg1",
                        onClick: ()=>handleActionPartner(partner, 'edit'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "fa fa-edit c3"
                        })
                    })
                })
        }
    ];
    const getAllPartners = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner`);
        if (res['code'] == 200) setAllPartners(res['body']);
    };
    const handleActivationPartner = async (partner)=>{
        setPartner({
            ...partner,
            isActive: !partner['isActive']
        });
        setAction('edit');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'partnerActivationPopup'
        }));
    };
    const handleActionPartner = async (partner, action)=>{
        setPartner(partner);
        await setAction(action);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'partnerPopup'
        }));
    };
    const handleAreaFocus = async (e)=>{
        let focusArea = {
            ...partner['focusArea'],
            [e.target.name]: e.target.value
        };
        setPartner({
            ...partner,
            focusArea: focusArea
        });
    };
    const handleSubmitPartner = async ()=>{
        let res;
        if (action == 'delete') res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/deletePartner/${partner['_id']}`);
        else {
            if (partner['name'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please enter name!`);
            partner = {
                ...partner,
                action: action
            };
            res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/partner`, partner);
        }
        if (res['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            await getAllPartners();
            setPartner({
                name: '',
                type: 'Business for Funding',
                testType: 'exit',
                moduleName: '',
                moduleKey: '',
                moduleDescription: '',
                focusArea: {
                    focus1: '',
                    focus2: '',
                    focus3: ''
                }
            });
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        }
    };
    const handleCreatePartner = async ()=>{
        await setPartner({
            name: '',
            type: 'Business for Funding',
            testType: 'exit',
            moduleName: '',
            moduleKey: '',
            moduleDescription: '',
            focusArea: {
                focus1: '',
                focus2: '',
                focus3: ''
            }
        });
        await setAction('create');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'partnerPopup'
        }));
    };
    const partnersTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        class: "w100 df jcsb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                                children: "Partners Database"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleCreatePartner(),
                                className: "df aic jcc cp c1 fw400 fs1rem br38px w200px py0-5rem bg4 bg3-hover",
                                children: "Create Partner"
                            })
                        ]
                    }),
                    allPartners && allPartners.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "admin-table mt1rem w100 ttc tac",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                            minRows: 20,
                            className: "table",
                            filterable: true,
                            data: allPartners,
                            columns: partnersColumns,
                            defaultFilterMethod: filterCaseInsensitive,
                            resolveData: (partner)=>partner.map((row)=>row)
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "No Partners Created Yet!"
                    })
                ]
            })
        });
    };
    const chatGPTTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df fdc aic advisor-index zi2",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                value: subPanel,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                        onChange: (e, value)=>setSubPanel(value),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Business Audit",
                                value: "Business Audit"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "DeDuper",
                                value: "DeDuper"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Filing Assistant",
                                value: "Filing Assistant"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Two Minute Audit",
                                value: "Two Minute Audit"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "200 Words Test",
                                value: "200 Words Test"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                className: "fs1rem fw600",
                                label: "Checklist",
                                value: "Checklist"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Business Audit",
                        children: businessAuditTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "DeDuper",
                        children: deDuperTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Filing Assistant",
                        children: filingAssistantTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Two Minute Audit",
                        children: twoMinAuditTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "200 Words Test",
                        children: WordsAuditTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100",
                        value: "Checklist",
                        children: ChecklistTab()
                    })
                ]
            })
        });
    };
    const kpiTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "fs1-5rem fs2rem-sm ttu tac c7",
                        children: "KPIs Database"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Allow viewing and editing of the default KPIs and questions"
                    })
                ]
            })
        });
    };
    const auditLogTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Diligentsia Internal Audit Trail Log"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Log page showing all changes made by admins"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Allow custom logs for development changes"
                    })
                ]
            })
        });
    };
    const moduleTab = (tabsAndKeysForChecklist)=>{
        return Object.values(tabsAndKeysForChecklist).map((module, idx)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `df fdc aic advisor-index zi2 pr ha bss br5px ${module.isActive ? 'bo7' : 'bo28'}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "gcs1 gce6 fs1rem ttu tac c7",
                        children: module.moduleName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setTab(module['_id']),
                                className: "shadow h2rem bg5 c6 b1px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo28 bss mih1rem",
                                children: "Save"
                            }, `module-edit-${idx}`),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>activeModule(module['moduleName'], module['moduleName'], module['isActive']),
                                className: "shadow h2rem ml1rem bg5 c6 br1px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo28 bss mih1rem",
                                children: module.isActive ? "Deactivate" : "Activate"
                            }, `module-activate-${idx}`)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "Creator: ",
                            module.moduleCreator
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "Created Date: ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module['createdAt']).format('l')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setDeleteModuleName(module.moduleName);
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'confirmDeleteModule'
                            }));
                        },
                        className: "shadow h2rem ml1rem bg5 c6 br1px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo28 bss mih1rem",
                        children: "Delete"
                    }, `module-delete-${idx}`)
                ]
            }, `module-${idx}`);
        });
    };
    const checklistModuleBuilder = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr5-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Modules"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setTab("Checklist builder"),
                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                        children: "Create New Module"
                    }),
                    tabsAndKeysForChecklist && moduleTab(tabsAndKeysForChecklist)
                ]
            })
        });
    };
    const businessAuditTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr3-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Business Audit ChatGPT"
                    }),
                    Object.keys(tabsAndKeys).filter((s)=>s.includes('Business')).map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>{
                                setTab(s);
                                setAiTest(true);
                            },
                            className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss ",
                            children: s
                        })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('ChatGPT-History');
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss ",
                        children: "History"
                    })
                ]
            })
        });
    };
    const deDuperTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Deduper ChatGPT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('Deduper');
                            setAiTest(true);
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs2",
                        children: "Deduper AI"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('Deduper-History');
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs3",
                        children: "History"
                    })
                ]
            })
        });
    };
    const filingAssistantTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Filing Assistant ChatGPT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('FA');
                            setAiTest(true);
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs2",
                        children: "Filing Assistant AI"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('FA-History');
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs3",
                        children: "History"
                    })
                ]
            })
        });
    };
    const WordsAuditTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "200 Words ChatGPT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('TH');
                            setAiTest(true);
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs2",
                        children: "200 Words AI"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('TH-History');
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs3",
                        children: "History"
                    })
                ]
            })
        });
    };
    const ChecklistTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr4-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Checklist ChatGPT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('CH');
                            setAiTest(true);
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss  gcs2",
                        children: "Checklist AI"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('CH-History');
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss gcs3",
                        children: "History"
                    })
                ]
            })
        });
    };
    const twoMinAuditTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw2px bo5 br10px p2rem dg gtcr3-md gg2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "gcs1 gce6 fs1-5rem fs2rem-sm ttu tac c7",
                        children: "Two Minute Audit"
                    }),
                    Object.keys(tabsAndKeys).filter((s)=>s.includes('Minute')).map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>{
                                setTab(s);
                                console.log(s);
                                setAiTest(true);
                            },
                            className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss",
                            children: s
                        })),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            setTab('TM-History');
                        },
                        className: "shadow bg5 c6 br5px px1rem py0-5rem fw600 cp fs1rem bsbb tac df jcc aic bw2px bo7 bss ",
                        children: "History"
                    })
                ]
            })
        });
    };
    /// Advisor Allocation Tab
    const advisorAllocationTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df fdc advisor-index zi2 pr w100 bsbb",
            style: {
                minWidth: 0,
                alignItems: 'stretch'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                value: subPanel,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 bsbb pr",
                        style: {
                            paddingRight: '112px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                            onChange: (e, value)=>setSubPanel(value),
                            variant: "scrollable",
                            scrollButtons: "auto",
                            allowScrollButtonsMobile: true,
                            sx: {
                                width: '100%',
                                maxWidth: '100%',
                                '& .MuiTabs-scrollButtons.Mui-disabled': {
                                    opacity: 0.35
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                    className: "fs1rem fw600",
                                    label: "Category Management",
                                    value: "Category Management"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                    className: "fs1rem fw600",
                                    label: "Allocation Section Management",
                                    value: "Allocation Section Management"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                    className: "fs1rem fw600",
                                    label: "Featured Business Cards",
                                    value: "Featured Business Card"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'allocationManagementLogs'
                            }));
                        },
                        className: "cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem fw500 pa r0 t0",
                        style: {
                            zIndex: 2
                        },
                        children: "Audit Log"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100 bsbb admin-allocation-tabpanel",
                        value: "Category Management",
                        children: categoryTab()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100 bsbb admin-allocation-tabpanel",
                        value: "Allocation Section Management",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99670e8ba4de8a78$export$2e2bcd8739ae039), {
                            categoryList: categoryList
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                        className: "w100 bsbb admin-allocation-tabpanel",
                        value: "Featured Business Card",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $913a399376c17482$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        });
    };
    const categoryTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "fs1-5rem fs2rem-sm ttu tac c4 df jcsb",
                                children: "Category Management"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                                className: "cp",
                                onClick: ()=>{
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'addEditCategory'
                                    }));
                                    setSelectedData({
                                        title: 'Add Category'
                                    });
                                },
                                title: 'Add Category'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "admin-table mt1rem w100 ttc tac",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04496bc9ad49b9c9$export$2e2bcd8739ae039), {
                            minRows: 15,
                            className: "table",
                            resolveData: (categoryList)=>categoryList.map((row)=>row),
                            data: categoryList,
                            columns: CATEGORY_TABLE_COLUMNS,
                            filterable: true,
                            defaultFilterMethod: filterCaseInsensitive
                        })
                    })
                ]
            })
        });
    };
    // Pagination
    const handleChangePage = (event, newPage)=>setCurrentPage(newPage);
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0);
    };
    const handleAssignCategory = async ({ section: section, category: category, valueAssign: valueAssign, type: type })=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/admin/assign/category/section', {
                id: section._id,
                sectionNo: section.sectionNo,
                categoryName: category.name,
                categoryId: category._id,
                allocationType: type,
                type: valueAssign
            });
            if (response['code'] === 200) {
                if (type === "section") setSectionList((prev)=>{
                    const index = prev.findIndex((item)=>item._id === section._id);
                    if (index === -1) return prev;
                    const updatedItem = {
                        ...prev[index]
                    };
                    if (valueAssign === true) updatedItem.categoryId = category._id;
                    else delete updatedItem.categoryId;
                    return [
                        ...prev.slice(0, index),
                        updatedItem,
                        ...prev.slice(index + 1)
                    ];
                });
                else setExpensionPackList((prev)=>{
                    const index = prev.findIndex((item)=>item._id === section._id);
                    if (index === -1) return prev;
                    const updatedItem = {
                        ...prev[index]
                    };
                    if (valueAssign === true) updatedItem.categoryId = category._id;
                    else delete updatedItem.categoryId;
                    return [
                        ...prev.slice(0, index),
                        updatedItem,
                        ...prev.slice(index + 1)
                    ];
                });
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            }
        } catch (err) {
            console.log(err, "error");
        }
    };
    const paginatedData = sectionList?.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage);
    const allocationSectionTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem allocationSectionAdmin",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "fs1-5rem fs2rem-sm ttu tac c4",
                        children: "Allocation Section Management"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Allocation Section Management"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcfs w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "checkbox",
                                checked: true,
                                className: "mr1rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Business Audit, Data Repository, 2 Minute Test"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt2rem",
                        style: {
                            overflowX: 'scroll',
                            width: '1300px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Section Name"
                                        }),
                                        categoryList.map((cat_obj, car_i)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: cat_obj.name
                                            }, car_i);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: paginatedData?.map((sec_obj, sec_i, sec_arr)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "df fdc jcs aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            fontWeight: 400,
                                                            fontSize: '10px',
                                                            children: sec_obj?.sectionNo
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            fontWeight: 600,
                                                            fontSize: '10px',
                                                            children: sec_obj?.sectionName
                                                        })
                                                    ]
                                                }),
                                                categoryList.map((cat_obj, car_i, car_arr)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                m: 1,
                                                                width: 80
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: sec_obj?.categoryId === cat_obj?._id,
                                                                onChange: (e)=>handleAssignCategory({
                                                                        section: sec_obj,
                                                                        category: cat_obj,
                                                                        valueAssign: e.target.checked,
                                                                        type: 'section'
                                                                    })
                                                            })
                                                        })
                                                    }, car_i))
                                            ]
                                        }, sec_i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 df jce",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $effe3c7e7b91170d$export$2e2bcd8739ae039), {
                            rowsPerPageOptions: [
                                5,
                                10,
                                25
                            ],
                            component: "div",
                            count: sectionList?.length || 0,
                            rowsPerPage: rowsPerPage,
                            page: currentPage,
                            onPageChange: handleChangePage,
                            onRowsPerPageChange: handleChangeRowsPerPage
                        })
                    })
                ]
            })
        });
    };
    const expensionPackData = expensionPackList?.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage);
    const allocationModuleTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg1 shadow p2rem dg gg2rem allocationSectionAdmin",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic bss bw2px bo5 br10px p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "fs1-5rem fs2rem-sm ttu tac c4",
                        children: "Allocation Module Management"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Allocation Module Management"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt2rem",
                        style: {
                            overflowX: 'scroll',
                            width: '1300px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Module Name"
                                        }),
                                        categoryList.map((cat_obj, car_i)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: cat_obj.name
                                            }, car_i);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: expensionPackData?.map((sec_obj, sec_i, sec_arr)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "df fdc jcs aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            fontWeight: 400,
                                                            fontSize: '10px',
                                                            children: sec_obj?.sectionNo
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            fontWeight: 600,
                                                            fontSize: '10px',
                                                            children: sec_obj?.sectionName
                                                        })
                                                    ]
                                                }),
                                                categoryList.map((cat_obj, car_i, car_arr)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                m: 1,
                                                                width: 80
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: sec_obj?.categoryId === cat_obj?._id,
                                                                onChange: (e)=>handleAssignCategory({
                                                                        section: sec_obj,
                                                                        category: cat_obj,
                                                                        valueAssign: e.target.checked,
                                                                        type: 'expension'
                                                                    })
                                                            })
                                                        })
                                                    }, car_i))
                                            ]
                                        }, sec_i))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 df jce",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $effe3c7e7b91170d$export$2e2bcd8739ae039), {
                            rowsPerPageOptions: [
                                5,
                                10,
                                25
                            ],
                            component: "div",
                            count: expensionPackData?.length || 0,
                            rowsPerPage: rowsPerPage,
                            page: currentPage,
                            onPageChange: handleChangePage,
                            onRowsPerPageChange: handleChangeRowsPerPage
                        })
                    })
                ]
            })
        });
    };
    const onAddEditModalClosed = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setCategory('');
        setSectionName('');
        setSectionNo('');
        setSelectedData(null);
    };
    const sortQuestions = (a, b)=>{
        return (a?.['qNo'] || '').localeCompare(b?.['qNo'] || '', undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    };
    const sortQuestionsByQNo = (questions)=>{
        return questions.sort((a, b)=>{
            const aParts = a['qNo'].match(/\d+/g)?.map(Number);
            const bParts = b['qNo'].match(/\d+/g)?.map(Number);
            for(let i = 0; i < Math.max(aParts.length, bParts.length); i++)if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
            return 0;
        });
    };
    return aiTest && tab == "Deduper" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26f9cd65f3c9984a$export$2e2bcd8739ae039), {
        onBack: ()=>{
            setTab("");
            setAiTest(false);
        }
    }) : aiTest && tab == "FA" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $43d87d709b6f9172$export$2e2bcd8739ae039), {
        onBack: ()=>{
            setTab("");
            setAiTest(false);
        }
    }) : aiTest && currentSection ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63cac72dc17bd39b$export$2e2bcd8739ae039), {
        section: currentSection,
        onBack: ()=>{
            setCurrentSection(null);
        }
    }) : tab == "view-firms" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffe9e51cdfaaecec$export$2e2bcd8739ae039), {
        setSelectedFirm: setSelectedFirm,
        selectedFirm: selectedFirm,
        setTab: setTab,
        onBack: ()=>setTab("")
    }) : tab == "add-firm" || tab.includes('edit-firm') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe054d9f3cf9a466$export$2e2bcd8739ae039), {
        setTab: setTab,
        onBack: ()=>{
            setTab("");
        },
        tab: tab
    }) : tab == "TH" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ecdc1bc084089079$export$2e2bcd8739ae039), {
        onBack: ()=>{
            setTab("");
            setAiTest(false);
        }
    }) : tab == "CH" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eaa72c92771749f8$export$2e2bcd8739ae039), {
        onBack: ()=>{
            setTab("");
            setAiTest(false);
        }
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px4rem py2rem df fdc",
                children: [
                    tab != 'ChatGPT-History' && tab != 'Deduper-History' && tab != 'FA-History' && tab != 'TH-History' && tab != 'CH-History' && tab != 'TM-History' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        wrapperClass: "mb2rem tac",
                        heading: aiTest ? `Admin Panel - AI Test` : `Admin Panel`,
                        subheading: aiTest ? tab : `${tab} Sections`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc aic advisor-index",
                        children: tab === '' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                            value: panel,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                                    onChange: (e, value)=>setPanel(value),
                                    variant: "scrollable",
                                    scrollButtons: "auto",
                                    sx: {
                                        '& .MuiTab-root': {
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            minWidth: 'auto',
                                            padding: '0px',
                                            margin: '0px 15px'
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Modules",
                                            value: "Modules"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Modules (new)",
                                            value: "ModulesNew"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Companies",
                                            value: "Companies"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Users",
                                            value: "Users"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Partners",
                                            value: "Partners"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Investors",
                                            value: "Investors"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "ChatGPT",
                                            value: "ChatGPT"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Diligence Report",
                                            value: "diligence-report-prompts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Analyser",
                                            value: "analyser"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "KPIs",
                                            value: "KPIs"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Audit Log",
                                            value: "Audit Log"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Checklist",
                                            value: "Checklist Module Builder"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Allocation Management",
                                            value: "Allocation Management"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "Transaction Settings",
                                            value: "Transaction Settings"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            label: "AI Costing",
                                            value: "AI Costing"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Modules",
                                    children: modulesTab()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "ModulesNew",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                                        value: modulesNewSubTab,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                                                onChange: (e, value)=>setModulesNewSubTab(value),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                        className: "fs0-95rem fw600",
                                                        label: "Dashboard Cards",
                                                        value: "DashboardCards"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                        className: "fs0-95rem fw600",
                                                        label: "Module",
                                                        value: "Module"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                        className: "fs0-95rem fw600",
                                                        label: "Navigation Module",
                                                        value: "NavigationModule"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                        className: "fs0-95rem fw600",
                                                        label: "Assistance Cards",
                                                        value: "AssistanceCards"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                        className: "fs0-95rem fw600",
                                                        label: "Toolbox Management",
                                                        value: "ToolboxManagement"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                        className: "fs0-95rem fw600",
                                                        label: "Company Wise Migration",
                                                        value: "CompanyWiseMigration"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                value: "DashboardCards",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ded331993a2ed1be$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                value: "Module",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77f79b46d2ce0bbb$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                value: "NavigationModule",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0831abacdddbb745$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                value: "AssistanceCards",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2fd1dcc4a02aa67$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                value: "ToolboxManagement",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d3dcf0caacf496c$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                value: "CompanyWiseMigration",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b195c31f21e75fc$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Companies",
                                    children: companiesTab()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Users",
                                    children: usersTab()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Partners",
                                    children: partnersTab()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Investors",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffe9e51cdfaaecec$export$2e2bcd8739ae039), {
                                        setSelectedFirm: setSelectedFirm,
                                        selectedFirm: selectedFirm,
                                        setTab: setTab,
                                        onBack: ()=>setTab("")
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "ChatGPT",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cc81d7c2616eb3f6$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "diligence-report-prompts",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33da756a25c84fe4$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "analyser",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccc37b720d59461a$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "KPIs",
                                    children: kpiTab()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Audit Log",
                                    children: auditLogTab()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Checklist Module Builder",
                                    children: checklistModuleBuilder()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Allocation Management",
                                    children: advisorAllocationTab()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Transaction Settings",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8a66b60e9fa741d$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "AI Costing",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90c3e5fa6c498a0b$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    tab && tab != 'ChatGPT-History' && tab != 'Deduper-History' && tab != 'FA-History' && tab != 'TH-History' && tab != 'CH-History' && tab != 'TM-History' && tab != 'checklist-builder' && tab == "" && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        onClick: ()=>{
                            setTab("");
                            setAiTest(false);
                            getQuestions();
                        },
                        className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "pen f1 h2rem mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 448 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary pen",
                                        d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary pen",
                                        d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                    })
                                ]
                            }),
                            "Back to Menu"
                        ]
                    }),
                    tab && tabsAndKeys[tab] && sectionsAndQuestions[tabsAndKeys[tab]['name']] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                onClick: ()=>{
                                    setTab("");
                                    getQuestions();
                                },
                                to: "/admin",
                                className: "mra shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        className: "pen f1 h2rem mr0-5rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 448 512",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-primary pen",
                                                d: "M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-secondary pen",
                                                d: "M447.1 256C447.1 273.7 433.7 288 416 288H109.3l-32-32l32-32H416C433.7 224 447.1 238.3 447.1 256z"
                                            })
                                        ]
                                    }),
                                    "Back to Menu"
                                ]
                            }),
                            sectionsAndQuestions[tabsAndKeys[tab]['name']]['sections']?.map((section, sectionIndex)=>{
                                const sortedQuestions = section['questions'].sort(sortQuestions);
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: aiTest ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: (section.sectionNo ? "shadow " : "") + "mt1rem bg1 py1rem px2rem br5px cp bss bw2px bo5",
                                        onClick: ()=>{
                                            setCurrentSection(section);
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            className: "usn pen fs1-5rem fw600",
                                            children: [
                                                section['sectionNo'],
                                                " - ",
                                                section['sectionName']
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: (section.sectionNo ? "shadow " : "") + "mt1rem toggleHeight bg1 py1rem px2rem br5px cp bss bw2px bo5",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "usn pen fs1-5rem fw600",
                                                children: [
                                                    section['sectionNo'],
                                                    " - ",
                                                    section['sectionName']
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    cursor: "auto",
                                                    height: "0px"
                                                },
                                                className: "oh",
                                                children: sortedQuestions.map((question, questionIndex)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        "data-id": question._id,
                                                        className: "dg gg1rem mx1rem p1rem py0-5rem my0-5rem bss bw2px bo5 br10px",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                                className: "usn pen fs1-25rem fw600",
                                                                children: [
                                                                    "Question No: ",
                                                                    question['qNo']
                                                                ]
                                                            }),
                                                            (()=>{
                                                                let maxRisk = 5;
                                                                let minRisk = -5;
                                                                let questionKeys = $1f609915e12f5806$export$682261bb742f7b6d(question);
                                                                let riskKeys = questionKeys.filter((k)=>k.startsWith("riskIf"));
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        questionKeys.filter((k)=>!k.startsWith("riskIf")).map((key, idx)=>{
                                                                            let placeholder = key.replace(/^q/, "").replace(/([A-Z])/g, " $1").replace(/^./, (s)=>s.toUpperCase());
                                                                            return key == "templateFiles" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                        onDragOver: onDragOver,
                                                                                        onDrop: (e)=>onDrop(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name']),
                                                                                        for: "fileUpload" + question._id,
                                                                                        className: "w100 bsbb bg5 br5px df jcc aic px2rem py5rem bsd bo6 bw2px cp mb0-5rem",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "pen fs1rem fw500 tac",
                                                                                                children: "Click here or drag and drop template files (max 100MB)"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                onChange: (e)=>saveQuestion(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name']),
                                                                                                className: "dn",
                                                                                                id: "fileUpload" + question._id,
                                                                                                type: "file",
                                                                                                multiple: true
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df fww",
                                                                                        children: question['templateFiles'] && question['templateFiles'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                                                className: "df jcc aic br25px lh1 bg3 c1 px0-5rem fw600 mr0-5rem mb0-5rem",
                                                                                                target: "_blank",
                                                                                                to: file['location'],
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "py0-5rem pl0-5rem",
                                                                                                        children: file['originalname']
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                        onClick: (e)=>{
                                                                                                            e.preventDefault();
                                                                                                            setDeleteFileQuestionId(question['_id']);
                                                                                                            setDeleteFile(file);
                                                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                                                open: 'deleteFile'
                                                                                                            }));
                                                                                                        },
                                                                                                        className: "p0-5rem f9 w1rem h1rem",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        viewBox: "0 0 320 512",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            className: "pen fa-primary",
                                                                                                            d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }, file['originalname'] + file['etag']))
                                                                                    })
                                                                                ]
                                                                            }, idx) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "pr",
                                                                                children: [
                                                                                    inputValues[key]?.['title'] && /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                                        className: "fw500",
                                                                                        children: inputValues[key]?.['title']
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                        onBlur: (e)=>saveQuestion(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name']),
                                                                                        defaultValue: question[key],
                                                                                        name: key,
                                                                                        type: "text",
                                                                                        placeholder: inputValues[key]?.['placeholder'] || placeholder,
                                                                                        className: "bss bw2px bo5 pl4rem pt1rem bg1 w100 br5px"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        "data-tooltip": inputValues[key]?.['placeholder'] || placeholder,
                                                                                        children: inputValues[key]['icon']
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }),
                                                                        riskKeys.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                    className: "w100 tac fs1-25rem",
                                                                                    children: "Assign Risk Scores"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "riskSlider bsbb pr w100 tac",
                                                                                    children: riskKeys.map((key, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                            "data-id": key,
                                                                                            name: key,
                                                                                            onChange: (e)=>saveQuestion(e, question, sectionIndex, questionIndex, tabsAndKeys[tab]['name']),
                                                                                            type: "range",
                                                                                            className: key + " pen pa oyv l0 w100",
                                                                                            min: minRisk,
                                                                                            max: maxRisk,
                                                                                            defaultValue: question[key]
                                                                                        }, idx))
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "df jcsb w100",
                                                                                    children: Array(Math.abs(minRisk) + Math.abs(maxRisk) + 1).fill(1).map((j, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "w1rem tac",
                                                                                            children: minRisk + i
                                                                                        }, i))
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "df jcsb w100",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                            children: "Low Risk"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                            children: "High Risk"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                });
                                                            })()
                                                        ]
                                                    }, question._id))
                                            })
                                        ]
                                    })
                                });
                            })
                        ]
                    }) : tab == 'ChatGPT-History' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84548291bce9e0c3$export$2e2bcd8739ae039), {
                        onBack: ()=>{
                            setTab("");
                            setAiTest(false);
                            getQuestions();
                        }
                    }) : tab == 'Deduper-History' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df460a1f1cccdf24$export$2e2bcd8739ae039), {
                        onBack: ()=>{
                            setTab("");
                            setAiTest(false);
                        }
                    }) : tab == 'FA-History' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a33cef13a9940aa2$export$2e2bcd8739ae039), {
                        onBack: ()=>{
                            setTab("");
                            setAiTest(false);
                        }
                    }) : tab == 'TH-History' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd6e03d3c25b3a9c$export$2e2bcd8739ae039), {
                        onBack: ()=>{
                            setTab("");
                            setAiTest(false);
                        }
                    }) : tab == 'CH-History' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c95d9ffe511f19d2$export$2e2bcd8739ae039), {
                        onBack: ()=>{
                            setTab("");
                            setAiTest(false);
                        }
                    }) : tab == 'TM-History' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea6efe6b7f4ce364$export$2e2bcd8739ae039), {
                        onBack: ()=>{
                            setTab("");
                            setAiTest(false);
                        }
                    }) : tab === 'Checklist builder' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9adf80c2d079327$export$2e2bcd8739ae039), {
                        onEdit: false,
                        onBack: ()=>setTab("")
                    }) : tab && tab !== "" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9adf80c2d079327$export$2e2bcd8739ae039), {
                        onEdit: true,
                        selectedModule: tab,
                        onBack: ()=>setTab("")
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "partnerPopup",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic bg3",
                            style: {
                                background: '#4a67ff94',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "fs1rem c15 fw500 ttc",
                                    children: [
                                        action,
                                        " Partner"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w40px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: [
                                action == 'delete' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "df jcc my2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        class: "fs1rem c15",
                                        children: [
                                            "Are you sure you want to delete partner ",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                children: [
                                                    "(",
                                                    partner['name'],
                                                    ")"
                                                ]
                                            }),
                                            "?"
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "advisor-modal-form",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    class: "fw500 fsi c6 ml0-5rem",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: "Name *"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    name: "name",
                                                    placeholder: "Please enter the name",
                                                    onChange: (e)=>setPartner({
                                                            ...partner,
                                                            name: e.target.value
                                                        }),
                                                    value: partner["name"],
                                                    className: "bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
                                                })
                                            ]
                                        }),
                                        action == 'create' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    class: "fw500 fsi c6 ml0-5rem",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: "Type *"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                                    name: "type",
                                                    onChange: (e)=>setPartner({
                                                            ...partner,
                                                            type: e.target.value
                                                        }),
                                                    className: "bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem",
                                                    children: [
                                                        'Business for Funding',
                                                        'Business for Sale',
                                                        'Cyber DueDil',
                                                        'Business is Investment Ready',
                                                        'Super Flow'
                                                    ].map((item)=>{
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: item,
                                                            children: item
                                                        });
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    class: "fw500 fsi c6 ml0-5rem",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: "Company Type *"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    name: "testType",
                                                    onChange: (e)=>setPartner({
                                                            ...partner,
                                                            testType: e.target.value
                                                        }),
                                                    className: "bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: partner['testType'],
                                                            selected: true,
                                                            disabled: true,
                                                            hidden: true,
                                                            children: partner['testType']
                                                        }),
                                                        [
                                                            'investment',
                                                            'growth',
                                                            'exit'
                                                        ].map((item)=>{
                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: item,
                                                                children: item
                                                            });
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    class: "fw500 fsi c6 ml0-5rem",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: "Module Name"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    name: "moduleName",
                                                    placeholder: "Please enter the module name",
                                                    onChange: (e)=>setPartner({
                                                            ...partner,
                                                            moduleName: e.target.value
                                                        }),
                                                    value: partner["moduleName"],
                                                    className: "bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    class: "fw500 fsi c6 ml0-5rem",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: "Module Key"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    name: "moduleKey",
                                                    placeholder: "Please enter the module key",
                                                    onChange: (e)=>setPartner({
                                                            ...partner,
                                                            moduleKey: e.target.value
                                                        }),
                                                    value: partner["moduleKey"],
                                                    className: "bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    class: "fw500 fsi c6 ml0-5rem",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: "Module Description"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    name: "moduleDescription",
                                                    placeholder: "Please enter the module description",
                                                    onChange: (e)=>setPartner({
                                                            ...partner,
                                                            moduleDescription: e.target.value
                                                        }),
                                                    value: partner["moduleDescription"],
                                                    className: "bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    class: "fw500 fsi c6 cp df aic gg0-5rem mb1rem",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            name: "skipInvestorLead",
                                                            className: "cp",
                                                            checked: !!partner['skipInvestorLead'],
                                                            onChange: (e)=>setPartner({
                                                                    ...partner,
                                                                    skipInvestorLead: e.target.checked
                                                                })
                                                        }),
                                                        "Skip InvestorMatch (go straight to module for Superflow)"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    class: "fw500 fsi c6",
                                                    style: {
                                                        fontSize: '18px'
                                                    },
                                                    children: "Focus of Area:"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "px1rem mt0-5rem",
                                                    children: [
                                                        'first',
                                                        'second',
                                                        'third'
                                                    ].map((item, idx)=>{
                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    className: "c15 db w100",
                                                                    children: [
                                                                        idx + 1,
                                                                        " - Area of focus"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "text",
                                                                    name: `focus${idx + 1}`,
                                                                    onChange: (e)=>handleAreaFocus(e),
                                                                    placeholder: `Write your ${item} objective focus in your own words`,
                                                                    value: partner['focusArea']?.[`focus${idx + 1}`] || '',
                                                                    className: "bg1 w100 br10px px1rem py0-5rem bss bo16 bw1px c15 fs1rem mt0-5rem"
                                                                })
                                                            ]
                                                        });
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>handleSubmitPartner(),
                                    style: {
                                        padding: '7px'
                                    },
                                    className: "new-shadow df jcc bg4 bg3-hover c1 td250 br30px fw500 cp ttu bsbb w200px",
                                    children: action
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ""
                                        })),
                                    className: "c3-hover td250 fs1rem cp",
                                    children: "Cancel"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ""
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "partnerActivationPopup",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic bg3",
                            style: {
                                background: '#4a67ff94',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: [
                                        action,
                                        " Partner"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "df jcc my2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        class: "fs1rem c15",
                                        children: [
                                            "Do you want to ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: partner['isActive'] ? 'Deactivate' : 'Activate'
                                            }),
                                            " partner?"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>handleSubmitPartner(),
                                    style: {
                                        padding: '7px'
                                    },
                                    className: "new-shadow df jcc bg4 bg3-hover c1 td250 br30px fw500 cp ttu bsbb w200px",
                                    children: partner['isActive'] ? 'Deactivate' : 'Activate'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ""
                                        })),
                                    className: "c3-hover td250 fs1rem cp",
                                    children: "Cancel"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ""
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteFile',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs3rem fw600",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem",
                            children: "Are you sure you want to delete this file?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-25rem fw500 mb1rem",
                            children: deleteFile && deleteFile.originalname
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>confirmDeleteFile(),
                            className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            className: "c3-hover td250 fs1-25rem cp",
                            children: "Cancel"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteCompanyPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                            children: "Delete Company "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem",
                                    children: [
                                        "Are you sure you want to delete the company (",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: deleteCompany?.['cName']
                                        }),
                                        ")?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>submitDeleteCompany(deleteCompany?.['_id']),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic",
                                    children: "Delete"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteUserPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                            children: "Delete User "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem",
                                    children: [
                                        "Are you sure you want to delete the user (",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: deleteUser?.['email']
                                        }),
                                        ")?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>submitDeleteUser(deleteUser?.['_id']),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic",
                                    children: "Delete"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deletedCompaniesLogs',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: "Deleted Companies Logs"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of Deleted Companies"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: deletedCompaniesLogs && deletedCompaniesLogs.length > 0 ? deletedCompaniesLogs.map((log)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df my0-5rem",
                                    children: [
                                        log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: `ass ml0-5rem br100 w2rem h2rem client-profile`,
                                            src: log['userId']['profile'],
                                            "data-tooltip": log?.['userId']?.['name'] ? log?.['userId']?.['name'] : `${log?.['userId']?.['firstName']} ${log?.['userId']?.['lastName']}`
                                        }) || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem client-profile`,
                                            "data-tooltip": log?.['userId']?.['name'] ? log?.['userId']?.['name'] : `${log?.['userId']?.['firstName']} ${log?.['userId']?.['lastName']}`,
                                            children: log?.['userId']?.['name'] ? `${log?.['userId']?.['name']?.split(' ')?.[0]?.[0] || '?'}${log?.['userId']?.['name']?.split(' ')?.[1]?.[0] || '?'}` : `${log?.['userId']?.['firstName']?.[0] || '?'}${log?.['userId']?.['lastName']?.[0] || '?'}`
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem ml1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: log['message']
                                                        }),
                                                        " at ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: new Date(log.timestamp).toLocaleString()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Company:"
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['companyName']
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Owner Name:"
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['creatorName']
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Owner Email:"
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['creatorEmail']
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttu w100 tac mb1rem",
                                children: "No Logs Found!"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "confirmLogoutPopUp",
                open: modal['open'] === 'confirmDeleteModule',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "Confirmation"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "logoutConfirmModal",
                            children: "Are you sure you want to delete this module?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    className: "shadow bo4 bss bg1 bg4-hover c4 c1-hover td250 br5px p1rem fw600 cp w30 ttu  bsbb tac mb1rem df jcc aic",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        deleteModule(deleteModuleName);
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                    },
                                    className: "shadow bg3 bo3 bss bo4-hover bg4-hover c1 td250 br5px p1rem fw600 w50 cp ttu  bsbb tac mb1rem df jcc aic",
                                    children: "Confirm"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c336ba93aa6c356e$export$2e2bcd8739ae039), {
                modal: modal,
                selectedData: selectedData,
                dispatch: dispatch,
                toggleModal: (0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e),
                categoryList: categoryList,
                getCategorys: getCategorys
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74fc0c9160d7b378$export$2e2bcd8739ae039), {
                modal: modal,
                selectedData: selectedData,
                dispatch: dispatch,
                toggleModal: (0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e),
                getCategorys: getCategorys
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $80f3c4b280641386$export$2e2bcd8739ae039), {
                modal: modal,
                selectedData: selectedData,
                dispatch: dispatch,
                toggleModal: (0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e),
                sectionList: sectionList,
                getCategorys: getCategorys
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e36985890d0dc5d3$export$2e2bcd8739ae039), {
                subPanel: subPanel,
                modal: modal,
                toggleModal: (0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e),
                dispatch: dispatch
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $77678b3dc83ba14b$var$NotYetCertifiedCard = ({ large: large })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            border: '2px solid #131313',
            borderRadius: '0.75rem',
            padding: large ? '12px 8px' : '2px 8px',
            backgroundColor: '#FEFEFE',
            width: large ? '105px' : '70px',
            height: large ? '125px' : '80px',
            marginTop: large ? '3px' : '0px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df aic jcc mt0-25rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("jdo6l")),
                    style: {
                        width: large ? "22px" : "20px",
                        height: large ? "18px" : "17px"
                    },
                    alt: "none"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "w100 tac mb0-5rem",
                style: {
                    lineHeight: '1.2',
                    color: '#2D2D2D',
                    marginTop: large ? '.85rem' : '12px',
                    fontSize: large ? '14px' : '9px'
                },
                children: "None"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "w100 tac mb0-25rem",
                style: {
                    color: '#1C1A1AB2',
                    fontSize: '7px',
                    marginTop: large ? '1.23rem' : '0px'
                },
                children: "Unaudited"
            })
        ]
    });
};
var $77678b3dc83ba14b$export$2e2bcd8739ae039 = $77678b3dc83ba14b$var$NotYetCertifiedCard;





function $54119cc183dc6bdf$export$2e2bcd8739ae039({ className: className, level: level, expiryTimestamp: expiryTimestamp, subscription: subscription, company: company, component: component, large: large }) {
    let certificates = {
        None: {
            title: "Not Yet Certified"
        },
        Bronze: {
            title: "Bronze - Basic"
        },
        Silver: {
            title: "Silver - Investible"
        },
        Gold: {
            title: "Gold - Sophisticated"
        }
    };
    const [cLevel, setCLevel] = (0, $acw62.useState)(level || 'None'); // Bronze, Silver, Gold, For 2 Minute Test (Pass, Fail)
    const [title, setTitle] = (0, $acw62.useState)(certificates[level || 'None']['title']);
    (0, $acw62.useEffect)(()=>{
        if (subscription !== 'Pro') {
            setTitle('PRO ONLY');
            return;
        }
        setCLevel(level);
        setTitle(certificates[level]['title']);
    }, [
        company
    ]);
    let expires = "";
    if (expiryTimestamp && cLevel !== 'None') {
        let date = new Date(expiryTimestamp);
        expires = date.setMonth(date.getMonth() + 3);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: cLevel && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: className + ` pr df aic ${cLevel == "None" ? 'c6' : 'c1'}`,
            children: [
                level == 'None' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77678b3dc83ba14b$export$2e2bcd8739ae039), {
                    large: large || false
                }),
                level == 'Bronze' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: level == "None" ? {
                        filter: "",
                        width: large ? '108px' : '70px',
                        height: large ? '129px' : '80px'
                    } : {
                        width: large ? '108px' : '70px',
                        height: large ? '129px' : '80px'
                    },
                    src: (parcelRequire("bYbOr")),
                    alt: title
                }),
                level == 'Silver' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: level == "None" ? {
                        filter: "",
                        width: large ? '108px' : '70px',
                        height: large ? '129px' : '80px'
                    } : {
                        width: large ? '108px' : '70px',
                        height: large ? '129px' : '80px'
                    },
                    src: (parcelRequire("f4EyH")),
                    alt: title
                }),
                level == 'Gold' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: level == "None" ? {
                        filter: "",
                        width: large ? '108px' : '70px',
                        height: large ? '129px' : '80px'
                    } : {
                        width: large ? '108px' : '70px',
                        height: large ? '129px' : '80px'
                    },
                    src: (parcelRequire("ibdCR")),
                    alt: title
                })
            ]
        })
    });
}









function $b373ac8016a3b01b$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    const [noCompanies, setNoCompanies] = (0, $acw62.useState)(false);
    const [profileClass, setProfileClass] = (0, $acw62.useState)('client-profile');
    const SEE_MORE = {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "83",
            height: "83",
            viewBox: "0 0 84 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z",
                    fill: "#4A67FF"
                })
            ]
        }),
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Your Company",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                " Dashboard"
            ]
        }),
        points: [
            'All your modules in one place',
            'Overall completeness and risk scores',
            'Overall certification (broze/silver/gold)',
            'At-a-glance module progress and status',
            'Access to reports for each module',
            'Easy one-stop shop for your clients and Investors to work collaboratively with you'
        ],
        image: (parcelRequire("7B6TB")),
        imageStyle: {
            height: '90%',
            width: '94%'
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (dispatch) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({}));
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        let isAgreeWithDisclaimer = localStorage.getItem('isAgreeWithDisclaimer');
        if (Object.keys(user).length && user.isAgreeWithDisclaimer === false && !isAgreeWithDisclaimer) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'disclaimerModal'
        }));
        if (user && user['type'] == 'Superflow') updateUserType();
    }, [
        user
    ]);
    const updateUserType = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
            type: 'User'
        });
        if (res['code'] != '200') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    (0, $acw62.useEffect)(()=>{
        getCompanies();
        if (location.pathname.includes('gDriveCallBack')) connectGDrive();
        else if (location.pathname.includes('dropBoxCallBack')) connectDropBox();
        else if (location.pathname.includes('sharePointCallBack')) connectSharePoint();
        if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile' : 'client-profile');
        let isWorkflowTab = localStorage.getItem('isWorkflowTab');
        if (isWorkflowTab) localStorage.removeItem('isWorkflowTab');
        let isManualAdd = localStorage.getItem('isManualAdd');
        if (isManualAdd) localStorage.removeItem('isManualAdd');
    }, []);
    const getCompanies = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/my-profile`);
        if (response['body']) {
            let { user: user, companies: companies } = response['body'];
            let groups = companies.filter(({ group: group })=>group == 'Parent');
            let standard = companies.filter(({ group: group })=>group != 'Parent');
            companies = groups.concat(standard);
            if (companies.length == 0) setNoCompanies(true);
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
            dispatch((0, $b9bcf9787e5ad456$export$2102c8f11f9a72ed)(companies));
        }
    };
    const connectGDrive = async ()=>{
        let { code: code, state: companyId } = urlSearchData(location['search']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectDataRoom'
        }));
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectGDrive`, {
            code: code,
            companyId: companyId
        });
        if (response) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            setTimeout(()=>navigation(`/company/${companyId}#repository`), 1000);
        }
    };
    const connectDropBox = async ()=>{
        let { code: code, state: companyId } = urlSearchData(location['search']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectDataRoom'
        }));
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectDropBox`, {
            code: code,
            companyId: companyId
        });
        if (response) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            setTimeout(()=>navigation(`/company/${companyId}`), 1000);
        }
    };
    const connectSharePoint = async ()=>{
        let { code: code, state: companyId, client_info: client_info } = urlSearchData(location['search']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectDataRoom'
        }));
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectSharePoint`, {
            code: code,
            companyId: companyId,
            client_info: client_info
        });
        if (response) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            setTimeout(()=>navigation(`/company/${companyId}`), 1000);
        }
    };
    const urlSearchData = (searchString)=>{
        if (!searchString) return {};
        return searchString.substring(1).split('&').reduce((result, next)=>{
            let pair = next.split('=');
            result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            return result;
        }, {});
    };
    const handleAddCompany = async ()=>{
        await localStorage.removeItem('isDemoChecklist');
        await localStorage.removeItem('isPartnerChecklist');
        localStorage.removeItem('testType');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addCompany'
        }));
    };
    const showCompanyDetails = (company)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df w400px",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc jcfs tal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1-25rem c15 mb1rem w300px",
                                children: company['cName']
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df w300px",
                                children: [
                                    company['subscription'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-25rem c7 mra tal mr1rem ttu",
                                        children: (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && (company['advisors'] || company['investors']) && company['subscription'] == 'Pro' ? 'PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: company['subscription']
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "fs1-25rem c8 mr1rem tal",
                                        children: "INACTIVE"
                                    }),
                                    company['subscription'] ? [
                                        "Free",
                                        "Lite"
                                    ].includes(company['subscription']) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: (0, $16250bd714b02a14$export$3623221f872af69b).replace(":id", company['_id']),
                                        className: `${user['role'] == 'Guest' && 'op20 pen '} df aic bg4 br50px px1-5rem py0-5rem jcc cp c1 mr0-5rem fs0-75rem fw500 w100px`,
                                        children: "Upgrade"
                                    }) : null : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                "data-testid": "subscribeNow",
                                                to: company?.['creatorId']?.['createdBy']?.['role'] && [
                                                    'advisor',
                                                    'investor'
                                                ].includes(company?.['creatorId']?.['createdBy']?.['role'].toLowerCase()) ? `${(0, $16250bd714b02a14$export$3623221f872af69b).replace(":id", company['_id'])}/pro/${company?.['creatorId']?.['createdBy']?.['role'].toLowerCase()}` : (0, $16250bd714b02a14$export$3623221f872af69b).replace(":id", company['_id']),
                                                className: "tac bg4 br50px bw2px bss py0-5rem px1rem bsbb aic cp bo4 c1 fs0-75rem mr0-5rem",
                                                children: "Subscribe"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        "data-tooltip": "Company Settings",
                                        to: `/company/${company['_id']}#company-settings`,
                                        className: `tac dashboard-btn c1 bg-gradient2 bg-gradient-hover br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100px td250 ${!company["subscription"] && "pen"}`,
                                        children: "Settings"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df m1rem jcc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse w60px mr2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "w20 df jcc username-area tac mr2rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc aic",
                                    children: [
                                        company?.['creatorId'] && company?.['creatorId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: company['creatorId']['profile'],
                                            className: `w40px h40px df jcc aic br100 cp bo30 bss bw3px ${profileClass}`,
                                            "data-tooltip": company['creatorId']['firstName'] ? company['creatorId']['firstName'] + " " + (company['creatorId']?.['lastName'] ?? "") : "Register to show your name here"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `w40px h40px df jcc aic br100 bg3 c0 bw3px bss bo30 c1 ${profileClass}`,
                                            "data-tooltip": company['creatorId']['firstName'] ? company['creatorId']['firstName'] + " " + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : "") : "Register to show your name here",
                                            children: company['creatorId']['firstName'] ? company['creatorId']['firstName'][0] + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName']?.[0] : "") : "?"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "ass mt0-5rem fs0-75rem c15",
                                            children: [
                                                "Company ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "Admin"
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        company?.['advisorsData'] && company['advisorsData'].length > 0 && company['advisorsData'].filter((adv)=>!adv?.['createdBy']).map((advs, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcse w60px mr1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w20 df jcc username-area tac",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aic",
                                            children: company?.["creatorId"] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    advs["profile"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: advs["profile"],
                                                        className: `w40px h40px df jcc aic br100 cp mr0 - 5rem client - profile`,
                                                        "data-tooltip": (advs?.['firstName'] && advs['firstName']) + " " + (advs?.['lastName'] ? advs?.['lastName'] : "")
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        "data-tooltip": (advs?.['firstName'] && advs['firstName']) + " " + (advs?.['lastName'] ? advs?.['lastName'] : ""),
                                                        className: `w40px h40px df jcc aic br100 c0  bw3px bss bo29 client - profile`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                advs?.['firstName'] && advs['firstName'][0],
                                                                advs?.['lastName']?.[0] ? advs['lastName'][0] : ""
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "ass mt0-5rem fs0-75rem c15",
                                                        children: [
                                                            "Company ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "Advisor"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }, `${advs['_id']}-${index}`);
                        }),
                        company?.['investorData'] && company['investorData'].length > 0 && company['investorData'].filter((adv)=>!adv?.['createdBy']).map((investor, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcse w60px mr1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w20 df jcc username-area tac",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aic",
                                            children: company?.["creatorId"] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    investor["profile"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: investor["profile"],
                                                        className: `w40px h40px df jcc aic br100 cp mr0 - 5rem client - profile`,
                                                        "data-tooltip": (investor?.['firstName'] && investor['firstName']) + " " + (investor?.['lastName'] ? investor?.['lastName'] : "")
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        "data-tooltip": (investor?.['firstName'] && investor['firstName']) + " " + (investor?.['lastName'] ? investor?.['lastName'] : ""),
                                                        className: `w40px h40px df jcc aic br100 c0 bw3px bss bo29 client - profile`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                investor?.['firstName'] && investor['firstName'][0],
                                                                investor?.['lastName']?.[0] ? investor['lastName'][0] : ""
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "ass mt0-5rem fs0-75rem c15",
                                                        children: [
                                                            "Company ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "Investor"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }, `${investor['_id']}-${index}`);
                        }),
                        company['group'] && company['group'] !== "Standard" ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse w60px mr2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "w20 df username-area type-user mr2rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'userDetail'
                                                })),
                                            "data-tooltip": company['group'] && company['group'] !== "Standard" ? company['group'] : 'No group',
                                            className: `w40px h40px df jcc aic br100 bg4 c1 bo4 bss bw3px mb1rem ${company['group'] ? 'fs1rem' : 'fs0-75rem'}`,
                                            children: company['group'] && company['group'] !== "Standard" ? company['group'][0] : 'N/A'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ass mt0-5rem fs0-75rem c15",
                                            children: "Group"
                                        })
                                    ]
                                })
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcse aic fdc reprot-btn-dropdowns",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: (0, $16250bd714b02a14$export$240514314008da16).replace(":id", company['_id']),
                        className: `${!company['subscription'] && 'op20 pen '} tac dashboard-btn c1 bg-gradient2 bg-gradient-hover br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100 td250`,
                        children: "Company Dashboard"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "progress-area progress-dashboard",
                    style: {
                        display: "flex",
                        position: "relative",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box ml2rem mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: 100,
                                        height: 100
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${company.stats.completionPercent > 67 ? 'green' : company.stats.completionPercent > 33 ? 'orange' : 'red'}`,
                                        value: company.stats.completionPercent || 0,
                                        text: (company.stats.completionPercent || 0) + "%",
                                        strokeWidth: 18,
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: 'round',
                                            strokeWidth: '5px',
                                            textSize: '20px',
                                            pathTransitionDuration: 0.5,
                                            trailColor: '#d6d6d6',
                                            backgroundColor: '#fc7785',
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bottom-text df fdc tac jcc mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem fw300 c15",
                                            children: "Overall"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: "0"
                                            },
                                            className: "text-center-area c15 fs1rem fw400",
                                            children: "Completeness"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box ml2rem mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: 100,
                                        height: 100
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${company.stats.riskPercent > 67 ? 'red' : company.stats.riskPercent > 33 ? 'orange' : 'green'}`,
                                        value: company.stats.riskPercent || 0,
                                        text: company.stats.completionPercent ? `${company.stats.riskPercent || 0}%` : "0%",
                                        strokeWidth: 18,
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: 'butt',
                                            strokeWidth: '5px',
                                            textSize: '20px',
                                            pathTransitionDuration: 0.5,
                                            trailColor: '#d6d6d6',
                                            backgroundColor: '#fc7785',
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bottom-text df fdc tac jcc mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem fw300 c15",
                                            children: "Overall"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: "0"
                                            },
                                            className: "text-center-area c15 fs1rem fw400",
                                            children: "Risk"
                                        })
                                    ]
                                })
                            ]
                        }),
                        company['subscription'] == 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            onClick: ()=>localStorage.setItem('isWorkflowTab', true),
                            to: `/company/${company['_id']}`,
                            className: "cp progress-box ml2rem mr1rem df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `progress-bar workflow-report-progress ${company?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : company?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : company?.stats?.workflowCompletionPercent > 1 ? ' workflow-progress-pink' : '  workflow-progress-grey'}`,
                                    style: {
                                        width: 80,
                                        height: 80,
                                        borderRadius: '50%',
                                        margin: 0,
                                        border: '2px solid #F1F1F1'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        text: (company?.stats?.workflowCompletionPercent || 0) + "%",
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeWidth: '0',
                                            textSize: '20px',
                                            trailColor: '#FBFBFB',
                                            stroke: 'transparent',
                                            strokeLinecap: 'butt',
                                            backgroundColor: '#FBFBFB',
                                            pathTransitionDuration: 0.5,
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bottom-text df fdc tac jcc mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem fw300 c15",
                                            children: "Overall"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: "0"
                                            },
                                            className: "text-center-area c15 fs1rem fw400",
                                            children: "Workflow Completeness"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcse mt0-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "certificate-area-dashboard",
                        children: company['cLevel'] && (company['subscription'] == "Pro" || company['subscription'] == "Pro Plus") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            "data-tooltip": "Certification",
                            to: `/company/${company['_id']}#unaudited-certification`,
                            className: "cp",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54119cc183dc6bdf$export$2e2bcd8739ae039), {
                                className: 'op100',
                                level: company['subscription'] == "Lite" ? 'None' : company['cLevel'],
                                expiryTimestamp: company['createdAt'],
                                company: company,
                                subscription: company['subscription']
                            })
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dashboard-container company-dashboard pt1rem pb1rem df fdc poppins-font-style * ",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `pr w100 mb1rem company-bg`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb w100 aic top-admin-area",
                                        style: {
                                            backgroundColor: '#c5cfff80',
                                            borderRadius: '1rem 1rem 0 0',
                                            padding: '0.5rem 1rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    className: "df aic lisn",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "fs14px c15",
                                                        children: "Company Index"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "right-area df",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "ass df",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fs1rem aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "mr1rem tar df fdc",
                                                                children: [
                                                                    user?.['firstName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "c15 ase",
                                                                        children: user?.['firstName'] + " " + (user?.['lastName'] ?? "")
                                                                    }),
                                                                    user?.['companyId']?.['creatorId']?.['_id'] == user['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `c3 ase fs0-75rem`,
                                                                        children: "Company Admin"
                                                                    })
                                                                ]
                                                            }),
                                                            user?.['firstName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`,
                                                                children: user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: user?.['profile'],
                                                                    className: `w40px h40px df jcc aic br100`,
                                                                    "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ?? "")
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: `w30px h30px df jcc aic br100`,
                                                                    "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ?? ""),
                                                                    children: user?.['firstName'] ? user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "") : "?"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: ` bg1 new-shadow py2rem px3rem mb2rem pr`,
                                        style: {
                                            borderRadius: '0 0 1rem 1rem'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fww company-details-area mt2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "center-logo-area w100 df jcc fww pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "c15 fs2rem mt1rem tac w100 fw500 pr df aifs jcc",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                                        wrapperClass: "tac",
                                                        heading: "Company Index"
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dahboard-tabs",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "MuiTabPanel-root",
                                    style: {
                                        width: '100%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aic advisor-index mt1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcsb pt1rem pr3rem w100 aic",
                                                children: user['email'] != 'temp' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                onClick: ()=>handleAddCompany(),
                                                                className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            className: "h30px w30px",
                                                                            width: "38",
                                                                            height: "38",
                                                                            viewBox: "0 0 38 38",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                    "clip-path": "url(#clip0_2656_879)",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                                                            fill: "#4A67FF"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                                                                            fill: "#FAFAFA"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                        id: "clip0_2656_879",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                            width: "38",
                                                                                            height: "38",
                                                                                            fill: "white"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "c15",
                                                                        children: "Add Company"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                        open: 'groupCompanies'
                                                                    })),
                                                                className: `${companies && companies.length <= 1 && 'op20 pen '} df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            className: "h30px w30px",
                                                                            width: "38",
                                                                            height: "38",
                                                                            viewBox: "0 0 38 38",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                    "clip-path": "url(#clip0_2656_879)",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                                                            fill: "#4A67FF"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                                                                            fill: "#FAFAFA"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                        id: "clip0_2656_879",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                            width: "38",
                                                                                            height: "38",
                                                                                            fill: "white"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "c15",
                                                                        children: "Create Group"
                                                                    })
                                                                ]
                                                            }),
                                                            companies && companies.some((c)=>c.group === 'Parent') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                        open: 'editGroupSelect'
                                                                    })),
                                                                className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            className: "h30px w30px",
                                                                            width: "38",
                                                                            height: "38",
                                                                            viewBox: "0 0 38 38",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                    clipPath: "url(#clip0_edit_group_btn)",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                                                            fill: "#4A67FF"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M25.5 12.5L23.5 10.5L13 21V23H15L25.5 12.5Z",
                                                                                            fill: "#FAFAFA"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M27 11L26 10C25.4 9.4 24.6 9.4 24 10L22.5 11.5L26.5 15.5L28 14C28.6 13.4 28.6 12.6 28 12L27 11Z",
                                                                                            fill: "#FAFAFA"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M10 25H28V27H10V25Z",
                                                                                            fill: "#FAFAFA"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                        id: "clip0_edit_group_btn",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                            width: "38",
                                                                                            height: "38",
                                                                                            fill: "white"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "c15",
                                                                        children: "Edit Group"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dahboard-tabs",
                        style: {
                            width: '93%',
                            margin: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "MuiTabPanel-root",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pb2rem df fdc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc aic advisor-index",
                                    children: companies && companies.length > 0 ? companies.map((company, idx)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dropdown-company-dahboard",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "dg gtcr5-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf",
                                                    style: {
                                                        border: '1px solid #7385BE50',
                                                        backgroundColor: '#F0F2FD50'
                                                    },
                                                    children: showCompanyDetails(company)
                                                }),
                                                company['childrenCompanies'] && company['childrenCompanies'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "dropdown-content",
                                                        children: company['childrenCompanies'] && company['childrenCompanies'].map((childrenCompany, idx)=>{
                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "dg gtcr5-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf",
                                                                style: {
                                                                    border: '1px solid #7385BE50',
                                                                    backgroundColor: '#F0F2FD50'
                                                                },
                                                                children: showCompanyDetails(childrenCompany)
                                                            }, idx);
                                                        })
                                                    })
                                                })
                                            ]
                                        }, idx);
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: noCompanies && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: (parcelRequire("eoVin"))
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "pa b0 r0 mr2rem mb1rem",
                                                    src: (parcelRequire("nGQfQ"))
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'userDetail',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs3rem tac lh1 fw600 mb2rem",
                            children: "Owner Detail"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc iic mxa gg0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Name: \xa0"
                                        }),
                                        " ",
                                        user?.firstName + (user?.lastName ?? ""),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Email: \xa0"
                                        }),
                                        " ",
                                        user?.email,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Role: \xa0"
                                        }),
                                        " ",
                                        user?.role,
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "keyFeatureSeeMore",
                open: modal['open'] == 'openSeeMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 p4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        maxWidth: '1350px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        width: "55%",
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 df aic",
                                                    children: SEE_MORE?.icon
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w90 fw500 c15 pl1rem df aic",
                                                    style: {
                                                        fontSize: '26px',
                                                        lineHeight: '37.32px'
                                                    },
                                                    children: SEE_MORE?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: " mt0-5rem",
                                            style: {
                                                paddingLeft: '22px'
                                            },
                                            children: SEE_MORE?.points?.map((objpoints, index)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    style: {
                                                        lineHeight: '25px',
                                                        paddingBottom: "3px",
                                                        paddingTop: "3px",
                                                        paddingLeft: "20px",
                                                        borderLeft: '2px solid #D3D9FC',
                                                        ...SEE_MORE?.liStyle
                                                    },
                                                    className: "df fdc fs1rem c14 fs1rem fw400",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "circle"
                                                            }),
                                                            objpoints
                                                        ]
                                                    })
                                                }, `${objpoints}-${index}`);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jce",
                                    style: {
                                        width: '45%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: SEE_MORE?.image,
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $6u4NZ = parcelRequire("6u4NZ");
var $8994635913a5668f$exports = {};

var $hPtJY = parcelRequire("hPtJY");


/**
 * html2pdf.js v0.9.3
 * Copyright (c) 2021 Erik Koopmans
 * Released under the MIT License.
 */ (function(global1, factory) {
    $8994635913a5668f$exports = factory((parcelRequire("1wHuh")), (parcelRequire("7JB23")));
})($8994635913a5668f$exports, function(jsPDF, html2canvas) {
    'use strict';
    jsPDF = jsPDF && jsPDF.hasOwnProperty('default') ? jsPDF['default'] : jsPDF;
    html2canvas = html2canvas && html2canvas.hasOwnProperty('default') ? html2canvas['default'] : html2canvas;
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    // Determine the type of a variable/object.
    var objType = function objType(obj) {
        var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
        if (type === 'undefined') return 'undefined';
        else if (type === 'string' || obj instanceof String) return 'string';
        else if (type === 'number' || obj instanceof Number) return 'number';
        else if (type === 'function' || obj instanceof Function) return 'function';
        else if (!!obj && obj.constructor === Array) return 'array';
        else if (obj && obj.nodeType === 1) return 'element';
        else if (type === 'object') return 'object';
        else return 'unknown';
    };
    // Create an HTML element with optional className, innerHTML, and style.
    var createElement = function createElement(tagName, opt) {
        var el = document.createElement(tagName);
        if (opt.className) el.className = opt.className;
        if (opt.innerHTML) {
            el.innerHTML = opt.innerHTML;
            var scripts = el.getElementsByTagName('script');
            for(var i = scripts.length; i-- > 0;)scripts[i].parentNode.removeChild(scripts[i]);
        }
        for(var key in opt.style)el.style[key] = opt.style[key];
        return el;
    };
    // Deep-clone a node and preserve contents/properties.
    var cloneNode = function cloneNode(node, javascriptEnabled) {
        // Recursively clone the node.
        var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);
        for(var child = node.firstChild; child; child = child.nextSibling)if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT') clone.appendChild(cloneNode(child, javascriptEnabled));
        if (node.nodeType === 1) {
            // Preserve contents/properties of special nodes.
            if (node.nodeName === 'CANVAS') {
                clone.width = node.width;
                clone.height = node.height;
                clone.getContext('2d').drawImage(node, 0, 0);
            } else if (node.nodeName === 'TEXTAREA' || node.nodeName === 'SELECT') clone.value = node.value;
            // Preserve the node's scroll position when it loads.
            clone.addEventListener('load', function() {
                clone.scrollTop = node.scrollTop;
                clone.scrollLeft = node.scrollLeft;
            }, true);
        }
        // Return the cloned node.
        return clone;
    };
    // Convert units from px using the conversion value 'k' from jsPDF.
    var unitConvert = function unitConvert(obj, k) {
        if (objType(obj) === 'number') return obj * 72 / 96 / k;
        else {
            var newObj = {};
            for(var key in obj)newObj[key] = obj[key] * 72 / 96 / k;
            return newObj;
        }
    };
    // Convert units to px using the conversion value 'k' from jsPDF.
    var toPx = function toPx(val, k) {
        return Math.floor(val * k / 72 * 96);
    };
    var commonjsGlobal = typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    function commonjsRequire() {
        throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
    }
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var es6Promise = createCommonjsModule(function(module1, exports) {
        /*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.5+7f2b526d
 */ (function(global1, factory) {
            module1.exports = factory();
        })(commonjsGlobal, function() {
            function objectOrFunction(x) {
                var type = typeof x;
                return x !== null && (type === 'object' || type === 'function');
            }
            function isFunction(x) {
                return typeof x === 'function';
            }
            var _isArray = void 0;
            if (Array.isArray) _isArray = Array.isArray;
            else _isArray = function(x) {
                return Object.prototype.toString.call(x) === '[object Array]';
            };
            var isArray = _isArray;
            var len = 0;
            var vertxNext = void 0;
            var customSchedulerFn = void 0;
            var asap = function asap(callback, arg) {
                queue[len] = callback;
                queue[len + 1] = arg;
                len += 2;
                if (len === 2) {
                    // If len is 2, that means that we need to schedule an async flush.
                    // If additional callbacks are queued before the queue is flushed, they
                    // will be processed by this flush that we are scheduling.
                    if (customSchedulerFn) customSchedulerFn(flush);
                    else scheduleFlush();
                }
            };
            function setScheduler(scheduleFn) {
                customSchedulerFn = scheduleFn;
            }
            function setAsap(asapFn) {
                asap = asapFn;
            }
            var browserWindow = typeof window !== 'undefined' ? window : undefined;
            var browserGlobal = browserWindow || {};
            var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
            var isNode = typeof self === 'undefined' && typeof $hPtJY !== 'undefined' && ({}).toString.call($hPtJY) === '[object process]';
            // test for web worker but not in IE10
            var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
            // node
            function useNextTick() {
                // node version 0.10.x displays a deprecation warning when nextTick is used recursively
                // see https://github.com/cujojs/when/issues/410 for details
                return function() {
                    return $hPtJY.nextTick(flush);
                };
            }
            // vertx
            function useVertxTimer() {
                if (typeof vertxNext !== 'undefined') return function() {
                    vertxNext(flush);
                };
                return useSetTimeout();
            }
            function useMutationObserver() {
                var iterations = 0;
                var observer = new BrowserMutationObserver(flush);
                var node = document.createTextNode('');
                observer.observe(node, {
                    characterData: true
                });
                return function() {
                    node.data = iterations = ++iterations % 2;
                };
            }
            // web worker
            function useMessageChannel() {
                var channel = new MessageChannel();
                channel.port1.onmessage = flush;
                return function() {
                    return channel.port2.postMessage(0);
                };
            }
            function useSetTimeout() {
                // Store setTimeout reference so es6-promise will be unaffected by
                // other code modifying setTimeout (like sinon.useFakeTimers())
                var globalSetTimeout = setTimeout;
                return function() {
                    return globalSetTimeout(flush, 1);
                };
            }
            var queue = new Array(1000);
            function flush() {
                for(var i = 0; i < len; i += 2){
                    var callback = queue[i];
                    var arg = queue[i + 1];
                    callback(arg);
                    queue[i] = undefined;
                    queue[i + 1] = undefined;
                }
                len = 0;
            }
            function attemptVertx() {
                try {
                    var vertx = Function('return this')().require('vertx');
                    vertxNext = vertx.runOnLoop || vertx.runOnContext;
                    return useVertxTimer();
                } catch (e) {
                    return useSetTimeout();
                }
            }
            var scheduleFlush = void 0;
            // Decide what async method to use to triggering processing of queued callbacks:
            if (isNode) scheduleFlush = useNextTick();
            else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
            else if (isWorker) scheduleFlush = useMessageChannel();
            else if (browserWindow === undefined && typeof commonjsRequire === 'function') scheduleFlush = attemptVertx();
            else scheduleFlush = useSetTimeout();
            function then(onFulfillment, onRejection) {
                var parent = this;
                var child = new this.constructor(noop);
                if (child[PROMISE_ID] === undefined) makePromise(child);
                var _state = parent._state;
                if (_state) {
                    var callback = arguments[_state - 1];
                    asap(function() {
                        return invokeCallback(_state, child, callback, parent._result);
                    });
                } else subscribe(parent, child, onFulfillment, onRejection);
                return child;
            }
            /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
                /*jshint validthis:true */ var Constructor = this;
                if (object && typeof object === 'object' && object.constructor === Constructor) return object;
                var promise = new Constructor(noop);
                resolve(promise, object);
                return promise;
            }
            var PROMISE_ID = Math.random().toString(36).substring(2);
            function noop() {}
            var PENDING = void 0;
            var FULFILLED = 1;
            var REJECTED = 2;
            var TRY_CATCH_ERROR = {
                error: null
            };
            function selfFulfillment() {
                return new TypeError("You cannot resolve a promise with itself");
            }
            function cannotReturnOwn() {
                return new TypeError('A promises callback cannot return that same promise.');
            }
            function getThen(promise) {
                try {
                    return promise.then;
                } catch (error) {
                    TRY_CATCH_ERROR.error = error;
                    return TRY_CATCH_ERROR;
                }
            }
            function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
                try {
                    then$$1.call(value, fulfillmentHandler, rejectionHandler);
                } catch (e) {
                    return e;
                }
            }
            function handleForeignThenable(promise, thenable, then$$1) {
                asap(function(promise) {
                    var sealed = false;
                    var error = tryThen(then$$1, thenable, function(value) {
                        if (sealed) return;
                        sealed = true;
                        if (thenable !== value) resolve(promise, value);
                        else fulfill(promise, value);
                    }, function(reason) {
                        if (sealed) return;
                        sealed = true;
                        reject(promise, reason);
                    }, 'Settle: ' + (promise._label || ' unknown promise'));
                    if (!sealed && error) {
                        sealed = true;
                        reject(promise, error);
                    }
                }, promise);
            }
            function handleOwnThenable(promise, thenable) {
                if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
                else if (thenable._state === REJECTED) reject(promise, thenable._result);
                else subscribe(thenable, undefined, function(value) {
                    return resolve(promise, value);
                }, function(reason) {
                    return reject(promise, reason);
                });
            }
            function handleMaybeThenable(promise, maybeThenable, then$$1) {
                if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
                else {
                    if (then$$1 === TRY_CATCH_ERROR) {
                        reject(promise, TRY_CATCH_ERROR.error);
                        TRY_CATCH_ERROR.error = null;
                    } else if (then$$1 === undefined) fulfill(promise, maybeThenable);
                    else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
                    else fulfill(promise, maybeThenable);
                }
            }
            function resolve(promise, value) {
                if (promise === value) reject(promise, selfFulfillment());
                else if (objectOrFunction(value)) handleMaybeThenable(promise, value, getThen(value));
                else fulfill(promise, value);
            }
            function publishRejection(promise) {
                if (promise._onerror) promise._onerror(promise._result);
                publish(promise);
            }
            function fulfill(promise, value) {
                if (promise._state !== PENDING) return;
                promise._result = value;
                promise._state = FULFILLED;
                if (promise._subscribers.length !== 0) asap(publish, promise);
            }
            function reject(promise, reason) {
                if (promise._state !== PENDING) return;
                promise._state = REJECTED;
                promise._result = reason;
                asap(publishRejection, promise);
            }
            function subscribe(parent, child, onFulfillment, onRejection) {
                var _subscribers = parent._subscribers;
                var length = _subscribers.length;
                parent._onerror = null;
                _subscribers[length] = child;
                _subscribers[length + FULFILLED] = onFulfillment;
                _subscribers[length + REJECTED] = onRejection;
                if (length === 0 && parent._state) asap(publish, parent);
            }
            function publish(promise) {
                var subscribers = promise._subscribers;
                var settled = promise._state;
                if (subscribers.length === 0) return;
                var child = void 0, callback = void 0, detail = promise._result;
                for(var i = 0; i < subscribers.length; i += 3){
                    child = subscribers[i];
                    callback = subscribers[i + settled];
                    if (child) invokeCallback(settled, child, callback, detail);
                    else callback(detail);
                }
                promise._subscribers.length = 0;
            }
            function tryCatch(callback, detail) {
                try {
                    return callback(detail);
                } catch (e) {
                    TRY_CATCH_ERROR.error = e;
                    return TRY_CATCH_ERROR;
                }
            }
            function invokeCallback(settled, promise, callback, detail) {
                var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = void 0, failed = void 0;
                if (hasCallback) {
                    value = tryCatch(callback, detail);
                    if (value === TRY_CATCH_ERROR) {
                        failed = true;
                        error = value.error;
                        value.error = null;
                    } else succeeded = true;
                    if (promise === value) {
                        reject(promise, cannotReturnOwn());
                        return;
                    }
                } else {
                    value = detail;
                    succeeded = true;
                }
                if (promise._state !== PENDING) ;
                else if (hasCallback && succeeded) resolve(promise, value);
                else if (failed) reject(promise, error);
                else if (settled === FULFILLED) fulfill(promise, value);
                else if (settled === REJECTED) reject(promise, value);
            }
            function initializePromise(promise, resolver) {
                try {
                    resolver(function resolvePromise(value) {
                        resolve(promise, value);
                    }, function rejectPromise(reason) {
                        reject(promise, reason);
                    });
                } catch (e) {
                    reject(promise, e);
                }
            }
            var id = 0;
            function nextId() {
                return id++;
            }
            function makePromise(promise) {
                promise[PROMISE_ID] = id++;
                promise._state = undefined;
                promise._result = undefined;
                promise._subscribers = [];
            }
            function validationError() {
                return new Error('Array Methods must be provided an Array');
            }
            var Enumerator = function() {
                function Enumerator(Constructor, input) {
                    this._instanceConstructor = Constructor;
                    this.promise = new Constructor(noop);
                    if (!this.promise[PROMISE_ID]) makePromise(this.promise);
                    if (isArray(input)) {
                        this.length = input.length;
                        this._remaining = input.length;
                        this._result = new Array(this.length);
                        if (this.length === 0) fulfill(this.promise, this._result);
                        else {
                            this.length = this.length || 0;
                            this._enumerate(input);
                            if (this._remaining === 0) fulfill(this.promise, this._result);
                        }
                    } else reject(this.promise, validationError());
                }
                Enumerator.prototype._enumerate = function _enumerate(input) {
                    for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
                };
                Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
                    var c = this._instanceConstructor;
                    var resolve$$1 = c.resolve;
                    if (resolve$$1 === resolve$1) {
                        var _then = getThen(entry);
                        if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                        else if (typeof _then !== 'function') {
                            this._remaining--;
                            this._result[i] = entry;
                        } else if (c === Promise$1) {
                            var promise = new c(noop);
                            handleMaybeThenable(promise, entry, _then);
                            this._willSettleAt(promise, i);
                        } else this._willSettleAt(new c(function(resolve$$1) {
                            return resolve$$1(entry);
                        }), i);
                    } else this._willSettleAt(resolve$$1(entry), i);
                };
                Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
                    var promise = this.promise;
                    if (promise._state === PENDING) {
                        this._remaining--;
                        if (state === REJECTED) reject(promise, value);
                        else this._result[i] = value;
                    }
                    if (this._remaining === 0) fulfill(promise, this._result);
                };
                Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
                    var enumerator = this;
                    subscribe(promise, undefined, function(value) {
                        return enumerator._settledAt(FULFILLED, i, value);
                    }, function(reason) {
                        return enumerator._settledAt(REJECTED, i, reason);
                    });
                };
                return Enumerator;
            }();
            /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
                return new Enumerator(this, entries).promise;
            }
            /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
                /*jshint validthis:true */ var Constructor = this;
                if (!isArray(entries)) return new Constructor(function(_, reject) {
                    return reject(new TypeError('You must pass an array to race.'));
                });
                else return new Constructor(function(resolve, reject) {
                    var length = entries.length;
                    for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
                });
            }
            /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
                /*jshint validthis:true */ var Constructor = this;
                var promise = new Constructor(noop);
                reject(promise, reason);
                return promise;
            }
            function needsResolver() {
                throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
            }
            function needsNew() {
                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            }
            /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
                function Promise(resolver) {
                    this[PROMISE_ID] = nextId();
                    this._result = this._state = undefined;
                    this._subscribers = [];
                    if (noop !== resolver) {
                        typeof resolver !== 'function' && needsResolver();
                        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
                    }
                }
                /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
                    return this.then(null, onRejection);
                };
                /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
                    var promise = this;
                    var constructor = promise.constructor;
                    if (isFunction(callback)) return promise.then(function(value) {
                        return constructor.resolve(callback()).then(function() {
                            return value;
                        });
                    }, function(reason) {
                        return constructor.resolve(callback()).then(function() {
                            throw reason;
                        });
                    });
                    return promise.then(callback, callback);
                };
                return Promise;
            }();
            Promise$1.prototype.then = then;
            Promise$1.all = all;
            Promise$1.race = race;
            Promise$1.resolve = resolve$1;
            Promise$1.reject = reject$1;
            Promise$1._setScheduler = setScheduler;
            Promise$1._setAsap = setAsap;
            Promise$1._asap = asap;
            /*global self*/ function polyfill() {
                var local = void 0;
                if (typeof commonjsGlobal !== 'undefined') local = commonjsGlobal;
                else if (typeof self !== 'undefined') local = self;
                else try {
                    local = Function('return this')();
                } catch (e) {
                    throw new Error('polyfill failed because global object is unavailable in this environment');
                }
                var P = local.Promise;
                if (P) {
                    var promiseToString = null;
                    try {
                        promiseToString = Object.prototype.toString.call(P.resolve());
                    } catch (e) {
                    // silently ignored
                    }
                    if (promiseToString === '[object Promise]' && !P.cast) return;
                }
                local.Promise = Promise$1;
            }
            // Strange compat..
            Promise$1.polyfill = polyfill;
            Promise$1.Promise = Promise$1;
            return Promise$1;
        });
    });
    var Promise$1 = es6Promise.Promise;
    /* ----- CONSTRUCTOR ----- */ var Worker = function Worker(opt) {
        // Create the root parent for the proto chain, and the starting Worker.
        var root = _extends(Worker.convert(Promise$1.resolve()), JSON.parse(JSON.stringify(Worker.template)));
        var self1 = Worker.convert(Promise$1.resolve(), root);
        // Set progress, optional settings, and return.
        self1 = self1.setProgress(1, Worker, 1, [
            Worker
        ]);
        self1 = self1.set(opt);
        return self1;
    };
    // Boilerplate for subclassing Promise.
    Worker.prototype = Object.create(Promise$1.prototype);
    Worker.prototype.constructor = Worker;
    // Converts/casts promises into Workers.
    Worker.convert = function convert(promise, inherit) {
        // Uses prototypal inheritance to receive changes made to ancestors' properties.
        promise.__proto__ = inherit || Worker.prototype;
        return promise;
    };
    Worker.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: 'file.pdf',
            margin: [
                0,
                0,
                0,
                0
            ],
            image: {
                type: 'jpeg',
                quality: 0.95
            },
            enableLinks: true,
            html2canvas: {},
            jsPDF: {}
        }
    };
    /* ----- FROM / TO ----- */ Worker.prototype.from = function from(src, type) {
        function getType(src) {
            switch(objType(src)){
                case 'string':
                    return 'string';
                case 'element':
                    return src.nodeName.toLowerCase === 'canvas' ? 'canvas' : 'element';
                default:
                    return 'unknown';
            }
        }
        return this.then(function from_main() {
            type = type || getType(src);
            switch(type){
                case 'string':
                    return this.set({
                        src: createElement('div', {
                            innerHTML: src
                        })
                    });
                case 'element':
                    return this.set({
                        src: src
                    });
                case 'canvas':
                    return this.set({
                        canvas: src
                    });
                case 'img':
                    return this.set({
                        img: src
                    });
                default:
                    return this.error('Unknown source type.');
            }
        });
    };
    Worker.prototype.to = function to(target) {
        // Route the 'to' request to the appropriate method.
        switch(target){
            case 'container':
                return this.toContainer();
            case 'canvas':
                return this.toCanvas();
            case 'img':
                return this.toImg();
            case 'pdf':
                return this.toPdf();
            default:
                return this.error('Invalid target.');
        }
    };
    Worker.prototype.toContainer = function toContainer() {
        // Set up function prerequisites.
        var prereqs = [
            function checkSrc() {
                return this.prop.src || this.error('Cannot duplicate - no source HTML.');
            },
            function checkPageSize() {
                return this.prop.pageSize || this.setPageSize();
            }
        ];
        return this.thenList(prereqs).then(function toContainer_main() {
            // Define the CSS styles for the container and its overlay parent.
            var overlayCSS = {
                position: 'fixed',
                overflow: 'hidden',
                zIndex: 1000,
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                backgroundColor: 'rgba(0,0,0,0.8)'
            };
            var containerCSS = {
                position: 'absolute',
                width: this.prop.pageSize.inner.width + this.prop.pageSize.unit,
                left: 0,
                right: 0,
                top: 0,
                height: 'auto',
                margin: 'auto',
                backgroundColor: 'white'
            };
            // Set the overlay to hidden (could be changed in the future to provide a print preview).
            overlayCSS.opacity = 0;
            // Create and attach the elements.
            var source = cloneNode(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            this.prop.overlay = createElement('div', {
                className: 'html2pdf__overlay',
                style: overlayCSS
            });
            this.prop.container = createElement('div', {
                className: 'html2pdf__container',
                style: containerCSS
            });
            this.prop.container.appendChild(source);
            this.prop.overlay.appendChild(this.prop.container);
            document.body.appendChild(this.prop.overlay);
        });
    };
    Worker.prototype.toCanvas = function toCanvas() {
        // Set up function prerequisites.
        var prereqs = [
            function checkContainer() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        // Fulfill prereqs then create the canvas.
        return this.thenList(prereqs).then(function toCanvas_main() {
            // Handle old-fashioned 'onrendered' argument.
            var options = _extends({}, this.opt.html2canvas);
            delete options.onrendered;
            return html2canvas(this.prop.container, options);
        }).then(function toCanvas_post(canvas) {
            // Handle old-fashioned 'onrendered' argument.
            var onRendered = this.opt.html2canvas.onrendered || function() {};
            onRendered(canvas);
            this.prop.canvas = canvas;
            document.body.removeChild(this.prop.overlay);
        });
    };
    Worker.prototype.toImg = function toImg() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toImg_main() {
            var imgData = this.prop.canvas.toDataURL('image/' + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement('img');
            this.prop.img.src = imgData;
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toPdf_main() {
            // Create local copies of frequently used properties.
            var canvas = this.prop.canvas;
            var opt = this.opt;
            // Calculate the number of pages.
            var pxFullHeight = canvas.height;
            var pxPageHeight = Math.floor(canvas.width * this.prop.pageSize.inner.ratio);
            var nPages = Math.ceil(pxFullHeight / pxPageHeight);
            // Define pageHeight separately so it can be trimmed on the final page.
            var pageHeight = this.prop.pageSize.inner.height;
            // Create a one-page canvas to split up the full image.
            var pageCanvas = document.createElement('canvas');
            var pageCtx = pageCanvas.getContext('2d');
            pageCanvas.width = canvas.width;
            pageCanvas.height = pxPageHeight;
            // Initialize the PDF.
            this.prop.pdf = this.prop.pdf || new jsPDF(opt.jsPDF);
            for(var page = 0; page < nPages; page++){
                // Trim the final page to reduce file size.
                if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
                    pageCanvas.height = pxFullHeight % pxPageHeight;
                    pageHeight = pageCanvas.height * this.prop.pageSize.inner.width / pageCanvas.width;
                }
                // Display the page.
                var w = pageCanvas.width;
                var h = pageCanvas.height;
                pageCtx.fillStyle = 'white';
                pageCtx.fillRect(0, 0, w, h);
                pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
                // Add the page to the PDF.
                if (page) this.prop.pdf.addPage();
                var imgData = pageCanvas.toDataURL('image/' + opt.image.type, opt.image.quality);
                this.prop.pdf.addImage(imgData, opt.image.type, opt.margin[1], opt.margin[0], this.prop.pageSize.inner.width, pageHeight);
            }
        });
    };
    /* ----- OUTPUT / SAVE ----- */ Worker.prototype.output = function output(type, options, src) {
        // Redirect requests to the correct function (outputPdf / outputImg).
        src = src || 'pdf';
        if (src.toLowerCase() === 'img' || src.toLowerCase() === 'image') return this.outputImg(type, options);
        else return this.outputPdf(type, options);
    };
    Worker.prototype.outputPdf = function outputPdf(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputPdf_main() {
            /* Currently implemented output types:
     *    https://rawgit.com/MrRio/jsPDF/master/docs/jspdf.js.html#line992
     *  save(options), arraybuffer, blob, bloburi/bloburl,
     *  datauristring/dataurlstring, dataurlnewwindow, datauri/dataurl
     */ return this.prop.pdf.output(type, options);
        });
    };
    Worker.prototype.outputImg = function outputImg(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkImg() {
                return this.prop.img || this.toImg();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputImg_main() {
            switch(type){
                case undefined:
                case 'img':
                    return this.prop.img;
                case 'datauristring':
                case 'dataurlstring':
                    return this.prop.img.src;
                case 'datauri':
                case 'dataurl':
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + type + '" is not supported.';
            }
        });
    };
    Worker.prototype.save = function save(filename) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs, update the filename (if provided), and save the PDF.
        return this.thenList(prereqs).set(filename ? {
            filename: filename
        } : null).then(function save_main() {
            this.prop.pdf.save(this.opt.filename);
        });
    };
    /* ----- SET / GET ----- */ Worker.prototype.set = function set$$1(opt) {
        // TODO: Implement ordered pairs?
        // Silently ignore invalid or empty input.
        if (objType(opt) !== 'object') return this;
        // Build an array of setter functions to queue.
        var fns = Object.keys(opt || {}).map(function(key) {
            if (key in Worker.template.prop) // Set pre-defined properties.
            return function set_prop() {
                this.prop[key] = opt[key];
            };
            else switch(key){
                case 'margin':
                    return this.setMargin.bind(this, opt.margin);
                case 'jsPDF':
                    return function set_jsPDF() {
                        this.opt.jsPDF = opt.jsPDF;
                        return this.setPageSize();
                    };
                case 'pageSize':
                    return this.setPageSize.bind(this, opt.pageSize);
                default:
                    // Set any other properties in opt.
                    return function set_opt() {
                        this.opt[key] = opt[key];
                    };
            }
        }, this);
        // Set properties within the promise chain.
        return this.then(function set_main() {
            return this.thenList(fns);
        });
    };
    Worker.prototype.get = function get$$1(key, cbk) {
        return this.then(function get_main() {
            // Fetch the requested property, either as a predefined prop or in opt.
            var val = key in Worker.template.prop ? this.prop[key] : this.opt[key];
            return cbk ? cbk(val) : val;
        });
    };
    Worker.prototype.setMargin = function setMargin(margin) {
        return this.then(function setMargin_main() {
            // Parse the margin property: [top, left, bottom, right].
            switch(objType(margin)){
                case 'number':
                    margin = [
                        margin,
                        margin,
                        margin,
                        margin
                    ];
                case 'array':
                    if (margin.length === 2) margin = [
                        margin[0],
                        margin[1],
                        margin[0],
                        margin[1]
                    ];
                    if (margin.length === 4) break;
                default:
                    return this.error('Invalid margin array.');
            }
            // Set the margin property, then update pageSize.
            this.opt.margin = margin;
        }).then(this.setPageSize);
    };
    Worker.prototype.setPageSize = function setPageSize(pageSize) {
        return this.then(function setPageSize_main() {
            // Retrieve page-size based on jsPDF settings, if not explicitly provided.
            pageSize = pageSize || jsPDF.getPageSize(this.opt.jsPDF);
            // Add 'inner' field if not present.
            if (!pageSize.hasOwnProperty('inner')) {
                pageSize.inner = {
                    width: pageSize.width - this.opt.margin[1] - this.opt.margin[3],
                    height: pageSize.height - this.opt.margin[0] - this.opt.margin[2]
                };
                pageSize.inner.px = {
                    width: toPx(pageSize.inner.width, pageSize.k),
                    height: toPx(pageSize.inner.height, pageSize.k)
                };
                pageSize.inner.ratio = pageSize.inner.height / pageSize.inner.width;
            }
            // Attach pageSize to this.
            this.prop.pageSize = pageSize;
        });
    };
    Worker.prototype.setProgress = function setProgress(val, state, n, stack) {
        // Immediately update all progress values.
        if (val != null) this.progress.val = val;
        if (state != null) this.progress.state = state;
        if (n != null) this.progress.n = n;
        if (stack != null) this.progress.stack = stack;
        this.progress.ratio = this.progress.val / this.progress.state;
        // Return this for command chaining.
        return this;
    };
    Worker.prototype.updateProgress = function updateProgress(val, state, n, stack) {
        // Immediately update all progress values, using setProgress.
        return this.setProgress(val ? this.progress.val + val : null, state ? state : null, n ? this.progress.n + n : null, stack ? this.progress.stack.concat(stack) : null);
    };
    /* ----- PROMISE MAPPING ----- */ Worker.prototype.then = function then(onFulfilled, onRejected) {
        // Wrap `this` for encapsulation.
        var self1 = this;
        return this.thenCore(onFulfilled, onRejected, function then_main(onFulfilled, onRejected) {
            // Update progress while queuing, calling, and resolving `then`.
            self1.updateProgress(null, null, 1, [
                onFulfilled
            ]);
            return Promise$1.prototype.then.call(this, function then_pre(val) {
                self1.updateProgress(null, onFulfilled);
                return val;
            }).then(onFulfilled, onRejected).then(function then_post(val) {
                self1.updateProgress(1);
                return val;
            });
        });
    };
    Worker.prototype.thenCore = function thenCore(onFulfilled, onRejected, thenBase) {
        // Handle optional thenBase parameter.
        thenBase = thenBase || Promise$1.prototype.then;
        // Wrap `this` for encapsulation and bind it to the promise handlers.
        var self1 = this;
        if (onFulfilled) onFulfilled = onFulfilled.bind(self1);
        if (onRejected) onRejected = onRejected.bind(self1);
        // Cast self into a Promise to avoid polyfills recursively defining `then`.
        var isNative = Promise$1.toString().indexOf('[native code]') !== -1 && Promise$1.name === 'Promise';
        var selfPromise = isNative ? self1 : Worker.convert(_extends({}, self1), Promise$1.prototype);
        // Return the promise, after casting it into a Worker and preserving props.
        var returnVal = thenBase.call(selfPromise, onFulfilled, onRejected);
        return Worker.convert(returnVal, self1.__proto__);
    };
    Worker.prototype.thenExternal = function thenExternal(onFulfilled, onRejected) {
        // Call `then` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype.then.call(this, onFulfilled, onRejected);
    };
    Worker.prototype.thenList = function thenList(fns) {
        // Queue a series of promise 'factories' into the promise chain.
        var self1 = this;
        fns.forEach(function thenList_forEach(fn) {
            self1 = self1.thenCore(fn);
        });
        return self1;
    };
    Worker.prototype['catch'] = function(onRejected) {
        // Bind `this` to the promise handler, call `catch`, and return a Worker.
        if (onRejected) onRejected = onRejected.bind(this);
        var returnVal = Promise$1.prototype['catch'].call(this, onRejected);
        return Worker.convert(returnVal, this);
    };
    Worker.prototype.catchExternal = function catchExternal(onRejected) {
        // Call `catch` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype['catch'].call(this, onRejected);
    };
    Worker.prototype.error = function error(msg) {
        // Throw the error in the Promise chain.
        return this.then(function error_main() {
            throw new Error(msg);
        });
    };
    /* ----- ALIASES ----- */ Worker.prototype.using = Worker.prototype.set;
    Worker.prototype.saveAs = Worker.prototype.save;
    Worker.prototype.export = Worker.prototype.output;
    Worker.prototype.run = Worker.prototype.then;
    // Import dependencies.
    // Get dimensions of a PDF page, as determined by jsPDF.
    jsPDF.getPageSize = function(orientation, unit, format) {
        // Decode options object
        if ((typeof orientation === 'undefined' ? 'undefined' : _typeof(orientation)) === 'object') {
            var options = orientation;
            orientation = options.orientation;
            unit = options.unit || unit;
            format = options.format || format;
        }
        // Default options
        unit = unit || 'mm';
        format = format || 'a4';
        orientation = ('' + (orientation || 'P')).toLowerCase();
        var format_as_string = ('' + format).toLowerCase();
        // Size in pt of various paper formats
        var pageFormats = {
            'a0': [
                2383.94,
                3370.39
            ],
            'a1': [
                1683.78,
                2383.94
            ],
            'a2': [
                1190.55,
                1683.78
            ],
            'a3': [
                841.89,
                1190.55
            ],
            'a4': [
                595.28,
                841.89
            ],
            'a5': [
                419.53,
                595.28
            ],
            'a6': [
                297.64,
                419.53
            ],
            'a7': [
                209.76,
                297.64
            ],
            'a8': [
                147.40,
                209.76
            ],
            'a9': [
                104.88,
                147.40
            ],
            'a10': [
                73.70,
                104.88
            ],
            'b0': [
                2834.65,
                4008.19
            ],
            'b1': [
                2004.09,
                2834.65
            ],
            'b2': [
                1417.32,
                2004.09
            ],
            'b3': [
                1000.63,
                1417.32
            ],
            'b4': [
                708.66,
                1000.63
            ],
            'b5': [
                498.90,
                708.66
            ],
            'b6': [
                354.33,
                498.90
            ],
            'b7': [
                249.45,
                354.33
            ],
            'b8': [
                175.75,
                249.45
            ],
            'b9': [
                124.72,
                175.75
            ],
            'b10': [
                87.87,
                124.72
            ],
            'c0': [
                2599.37,
                3676.54
            ],
            'c1': [
                1836.85,
                2599.37
            ],
            'c2': [
                1298.27,
                1836.85
            ],
            'c3': [
                918.43,
                1298.27
            ],
            'c4': [
                649.13,
                918.43
            ],
            'c5': [
                459.21,
                649.13
            ],
            'c6': [
                323.15,
                459.21
            ],
            'c7': [
                229.61,
                323.15
            ],
            'c8': [
                161.57,
                229.61
            ],
            'c9': [
                113.39,
                161.57
            ],
            'c10': [
                79.37,
                113.39
            ],
            'dl': [
                311.81,
                623.62
            ],
            'letter': [
                612,
                792
            ],
            'government-letter': [
                576,
                756
            ],
            'legal': [
                612,
                1008
            ],
            'junior-legal': [
                576,
                360
            ],
            'ledger': [
                1224,
                792
            ],
            'tabloid': [
                792,
                1224
            ],
            'credit-card': [
                153,
                243
            ]
        };
        // Unit conversion
        switch(unit){
            case 'pt':
                var k = 1;
                break;
            case 'mm':
                var k = 72 / 25.4;
                break;
            case 'cm':
                var k = 72 / 2.54;
                break;
            case 'in':
                var k = 72;
                break;
            case 'px':
                var k = 0.75;
                break;
            case 'pc':
                var k = 12;
                break;
            case 'em':
                var k = 12;
                break;
            case 'ex':
                var k = 6;
                break;
            default:
                throw 'Invalid unit: ' + unit;
        }
        // Dimensions are stored as user units and converted to points on output
        if (pageFormats.hasOwnProperty(format_as_string)) {
            var pageHeight = pageFormats[format_as_string][1] / k;
            var pageWidth = pageFormats[format_as_string][0] / k;
        } else try {
            var pageHeight = format[1];
            var pageWidth = format[0];
        } catch (err) {
            throw new Error('Invalid format: ' + format);
        }
        // Handle page orientation
        if (orientation === 'p' || orientation === 'portrait') {
            orientation = 'p';
            if (pageWidth > pageHeight) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else if (orientation === 'l' || orientation === 'landscape') {
            orientation = 'l';
            if (pageHeight > pageWidth) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else throw 'Invalid orientation: ' + orientation;
        // Return information (k is the unit conversion ratio from pts)
        var info = {
            'width': pageWidth,
            'height': pageHeight,
            'unit': unit,
            'k': k
        };
        return info;
    };
    /* Pagebreak plugin:

    Adds page-break functionality to the html2pdf library. Page-breaks can be
    enabled by CSS styles, set on individual elements using selectors, or
    avoided from breaking inside all elements.

    Options on the `opt.pagebreak` object:

    mode:   String or array of strings: 'avoid-all', 'css', and/or 'legacy'
            Default: ['css', 'legacy']

    before: String or array of CSS selectors for which to add page-breaks
            before each element. Can be a specific element with an ID
            ('#myID'), all elements of a type (e.g. 'img'), all of a class
            ('.myClass'), or even '*' to match every element.

    after:  Like 'before', but adds a page-break immediately after the element.

    avoid:  Like 'before', but avoids page-breaks on these elements. You can
            enable this feature on every element using the 'avoid-all' mode.
*/ // Refs to original functions.
    var orig = {
        toContainer: Worker.prototype.toContainer
    };
    // Add pagebreak default options to the Worker template.
    Worker.template.opt.pagebreak = {
        mode: [
            'css',
            'legacy'
        ],
        before: [],
        after: [],
        avoid: []
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig.toContainer.call(this).then(function toContainer_pagebreak() {
            // Setup root element and inner page height.
            var root = this.prop.container;
            var pxPageHeight = this.prop.pageSize.inner.px.height;
            // Check all requested modes.
            var modeSrc = [].concat(this.opt.pagebreak.mode);
            var mode = {
                avoidAll: modeSrc.indexOf('avoid-all') !== -1,
                css: modeSrc.indexOf('css') !== -1,
                legacy: modeSrc.indexOf('legacy') !== -1
            };
            // Get arrays of all explicitly requested elements.
            var select = {};
            var self1 = this;
            [
                'before',
                'after',
                'avoid'
            ].forEach(function(key) {
                var all = mode.avoidAll && key === 'avoid';
                select[key] = all ? [] : [].concat(self1.opt.pagebreak[key] || []);
                if (select[key].length > 0) select[key] = Array.prototype.slice.call(root.querySelectorAll(select[key].join(', ')));
            });
            // Get all legacy page-break elements.
            var legacyEls = root.querySelectorAll('.html2pdf__page-break');
            legacyEls = Array.prototype.slice.call(legacyEls);
            // Loop through all elements.
            var els = root.querySelectorAll('*');
            Array.prototype.forEach.call(els, function pagebreak_loop(el) {
                // Setup pagebreak rules based on legacy and avoidAll modes.
                var rules = {
                    before: false,
                    after: mode.legacy && legacyEls.indexOf(el) !== -1,
                    avoid: mode.avoidAll
                };
                // Add rules for css mode.
                if (mode.css) {
                    // TODO: Check if this is valid with iFrames.
                    var style = window.getComputedStyle(el);
                    // TODO: Handle 'left' and 'right' correctly.
                    // TODO: Add support for 'avoid' on breakBefore/After.
                    var breakOpt = [
                        'always',
                        'page',
                        'left',
                        'right'
                    ];
                    var avoidOpt = [
                        'avoid',
                        'avoid-page'
                    ];
                    rules = {
                        before: rules.before || breakOpt.indexOf(style.breakBefore || style.pageBreakBefore) !== -1,
                        after: rules.after || breakOpt.indexOf(style.breakAfter || style.pageBreakAfter) !== -1,
                        avoid: rules.avoid || avoidOpt.indexOf(style.breakInside || style.pageBreakInside) !== -1
                    };
                }
                // Add rules for explicit requests.
                Object.keys(rules).forEach(function(key) {
                    rules[key] = rules[key] || select[key].indexOf(el) !== -1;
                });
                // Get element position on the screen.
                // TODO: Subtract the top of the container from clientRect.top/bottom?
                var clientRect = el.getBoundingClientRect();
                // Avoid: Check if a break happens mid-element.
                if (rules.avoid && !rules.before) {
                    var startPage = Math.floor(clientRect.top / pxPageHeight);
                    var endPage = Math.floor(clientRect.bottom / pxPageHeight);
                    var nPages = Math.abs(clientRect.bottom - clientRect.top) / pxPageHeight;
                    // Turn on rules.before if the el is broken and is at most one page long.
                    if (endPage !== startPage && nPages <= 1) rules.before = true;
                }
                // Before: Create a padding div to push the element to the next page.
                if (rules.before) {
                    var pad = createElement('div', {
                        style: {
                            display: 'block',
                            height: pxPageHeight - clientRect.top % pxPageHeight + 'px'
                        }
                    });
                    el.parentNode.insertBefore(pad, el);
                }
                // After: Create a padding div to fill the remaining page.
                if (rules.after) {
                    var pad = createElement('div', {
                        style: {
                            display: 'block',
                            height: pxPageHeight - clientRect.bottom % pxPageHeight + 'px'
                        }
                    });
                    el.parentNode.insertBefore(pad, el.nextSibling);
                }
            });
        });
    };
    // Add hyperlink functionality to the PDF creation.
    // Main link array, and refs to original functions.
    var linkInfo = [];
    var orig$1 = {
        toContainer: Worker.prototype.toContainer,
        toPdf: Worker.prototype.toPdf
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig$1.toContainer.call(this).then(function toContainer_hyperlink() {
            // Retrieve hyperlink info if the option is enabled.
            if (this.opt.enableLinks) {
                // Find all anchor tags and get the container's bounds for reference.
                var container = this.prop.container;
                var links = container.querySelectorAll('a');
                var containerRect = unitConvert(container.getBoundingClientRect(), this.prop.pageSize.k);
                linkInfo = [];
                // Loop through each anchor tag.
                Array.prototype.forEach.call(links, function(link) {
                    // Treat each client rect as a separate link (for text-wrapping).
                    var clientRects = link.getClientRects();
                    for(var i = 0; i < clientRects.length; i++){
                        var clientRect = unitConvert(clientRects[i], this.prop.pageSize.k);
                        clientRect.left -= containerRect.left;
                        clientRect.top -= containerRect.top;
                        var page = Math.floor(clientRect.top / this.prop.pageSize.inner.height) + 1;
                        var top = this.opt.margin[0] + clientRect.top % this.prop.pageSize.inner.height;
                        var left = this.opt.margin[1] + clientRect.left;
                        linkInfo.push({
                            page: page,
                            top: top,
                            left: left,
                            clientRect: clientRect,
                            link: link
                        });
                    }
                }, this);
            }
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        return orig$1.toPdf.call(this).then(function toPdf_hyperlink() {
            // Add hyperlinks if the option is enabled.
            if (this.opt.enableLinks) {
                // Attach each anchor tag based on info from toContainer().
                linkInfo.forEach(function(l) {
                    this.prop.pdf.setPage(l.page);
                    this.prop.pdf.link(l.left, l.top, l.clientRect.width, l.clientRect.height, {
                        url: l.link.href
                    });
                }, this);
                // Reset the active page of the PDF to the final page.
                var nPages = this.prop.pdf.internal.getNumberOfPages();
                this.prop.pdf.setPage(nPages);
            }
        });
    };
    /**
 * Generate a PDF from an HTML element or string using html2canvas and jsPDF.
 *
 * @param {Element|string} source The source element or HTML string.
 * @param {Object=} opt An object of optional settings: 'margin', 'filename',
 *    'image' ('type' and 'quality'), and 'html2canvas' / 'jspdf', which are
 *    sent as settings to their corresponding functions.
 */ var html2pdf = function html2pdf(src, opt) {
        // Create a new worker with the given options.
        var worker = new html2pdf.Worker(opt);
        if (src) // If src is specified, perform the traditional 'simple' operation.
        return worker.from(src).save();
        else // Otherwise, return the worker for new Promise-based operation.
        return worker;
    };
    html2pdf.Worker = Worker;
    return html2pdf;
});










var $acw62 = parcelRequire("acw62");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a195f2587f794494$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"
}), 'LockOutlined');



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $067517aabc6d84f7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), 'KeyboardArrowRight');







var $ayMG0 = parcelRequire("ayMG0");
function $182b9a3f1701449a$export$2e2bcd8739ae039({ className: className = "w2rem ma" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        className: className,
        viewBox: "0 0 95 73",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                fill: "#0066da"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                fill: "#00ac47"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                fill: "#ea4335"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                fill: "#00832d"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                fill: "#2684fc"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                fill: "#ffba00"
            })
        ]
    });
}












function $33a9b39b88c46765$export$2e2bcd8739ae039({ getCompany: getCompany, sectionRefs: sectionRefs, user: user, company: company, moduleCertification: moduleCertification, module: module, tab: tab, setTab: setTab, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, twoMinuteTestAIReport: twoMinuteTestAIReport, sortSections: sortSections }) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [checklistModule, setChecklistModule] = (0, $acw62.useState)(false);
    let [directorCertification, setDirectorCertification] = (0, $acw62.useState)('None');
    // OPTIMIZATION: Lazy load KPIs when not available (excluded in lightweight mode)
    let [kpis, setKpis] = (0, $acw62.useState)(company?.['keyPerformanceIndicators'] || []);
    // const sanitiseTab = t => decodeURIComponent(t).replace(/(-sync)?-report$/, "")
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    // Fetch KPIs if not available (excluded in lightweight mode)
    (0, $acw62.useEffect)(()=>{
        const fetchKPIs = async ()=>{
            if (company?.['kpiCount'] !== undefined && !company?.['keyPerformanceIndicators'] && tab === 'kpi-report') try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/kpis`);
                if (response['code'] === 200 && response['body']) setKpis(response['body']['kpis'] || []);
            } catch (e) {
                console.error('Failed to fetch KPIs:', e);
            }
            else if (company?.['keyPerformanceIndicators']) setKpis(company['keyPerformanceIndicators']);
        };
        fetchKPIs();
    }, [
        company?._id,
        company?.['keyPerformanceIndicators'],
        company?.['kpiCount'],
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array
        const hasNoKPIs = company?.['kpiCount'] !== undefined ? company['kpiCount'] === 0 : !company['keyPerformanceIndicators'] || Object.values(company['keyPerformanceIndicators']).length === 0;
        if (tab == 'kpi-report' && hasNoKPIs) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'generatingKPI'
            }));
            generateKPI();
        }
    }, []);
    const generateKPI = async ()=>{
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Generating your KPI report, please wait!');
        let res = (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/generateKPI/${company['_id']}`);
        if (res['code'] == '200') await getCompany(company['_id']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (!module) setTab(tab);
        if (tab && module && tab.includes(`directors-questionnaire_${module?.['director']?.['_id']}-report`)) {
            if (module?.stats?.completionPercent >= 90 && module?.stats?.riskPercent <= 50) setDirectorCertification('Gold');
            else if (module?.stats?.completionPercent >= 75 && module?.stats?.riskPercent <= 50) setDirectorCertification('Silver');
            else setDirectorCertification('None');
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array
        const hasNoKPIs = company?.['kpiCount'] !== undefined ? company['kpiCount'] === 0 : company?.['keyPerformanceIndicators']?.length === 0;
        if (user['role'] == 'Guest' && hasNoKPIs) getCompany();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (module?.['type']) {
            if (![
                'kpi',
                `two-minute-test-${company['testType']}`,
                'repository',
                'software-development',
                'esg',
                'warranty-disclosure',
                `business-audit-${company['testType']}`,
                `directors-questionnaire_${module?.['director']?.['_id']}`
            ].includes(module['type'])) setChecklistModule(true);
        }
    }, [
        module
    ]);
    (0, $acw62.useEffect)(()=>{
        // Skip PDF DOM manipulation if using Papermill PDF iframe
        if (module?.reportUrl) return;
        document.getElementById("pdfContent").classList.add("a4-pdf", "p3rem");
        let wrapper = document.getElementById("pdf");
        wrapper.innerHTML = "";
        let children = Array.from(document.getElementById("pdfContent").children);
        let i = 0;
        let _pageNumber = 1;
        let page = document.createElement("div");
        page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        wrapper.appendChild(page); // Append the first page directly
        let usedPageHeight = 96; // Initial height used on the page
        let pageHeight = getHeight(page);
        let footerHeight = 8;
        // Create watermark
        let watermark = document.createElement("img");
        watermark.classList.add("op20", "pa");
        watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
        watermark.style.top = "50%";
        watermark.style.left = "50%";
        watermark.style.width = "297mm";
        page.appendChild(watermark);
        let section = document.querySelector('#pdfContent .section-break');
        while(children.length && i < 250){
            // Process children for table and other content
            for (let child of children){
                i++;
                // Create footerLogo
                let footer = document.createElement("div");
                footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
                let footerLogo = document.createElement("img");
                footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
                footerLogo.alt = "miniicon";
                footerLogo.classList.add("h40px", "w40px", "tal");
                // Create trademark
                let trademark = document.createElement("p");
                trademark.innerText = `\xa9 Diligentsia Limited ${new Date().getFullYear()}`;
                trademark.classList.add("tac", "c37", "fs12px", "fw400");
                // Create pageNumber
                let pageNumber = document.createElement("h3");
                pageNumber.innerText = "Page " + _pageNumber;
                pageNumber.classList.add("fw600", "c36", "fs14px");
                // Append footerLogo and trademark to footer
                footer.appendChild(footerLogo);
                footer.appendChild(trademark);
                footer.appendChild(pageNumber);
                let childHeight = getHeight(child);
                if (usedPageHeight + childHeight + footerHeight > pageHeight || child?.className == section?.className && usedPageHeight + childHeight + footerHeight > pageHeight / 2) {
                    page.classList.add("df", "fdc");
                    if (i > 1) {
                        _pageNumber++;
                        page = createNewPage(wrapper);
                        page.appendChild(footer);
                    }
                    usedPageHeight = 96;
                }
                page.appendChild(child.cloneNode(true));
                usedPageHeight += childHeight;
            }
            // Remove processed children
            children.splice(0, children.length);
        }
        // Clean up after processing
        wrapper.classList.remove("op0", "pen");
        document.getElementById("pdfContent").classList.remove("a4", "p3rem");
        // Set up event listeners for inputs and textareas
        setupEventListeners(wrapper);
    });
    function createNewPage(wrapper) {
        let newPage = document.createElement("div");
        newPage.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        let header = document.createElement("img");
        header.classList.add("db", "ma", "h1rem");
        titleHeading(newPage);
        // Add additional headers based on the module type
        addHeadersBasedOnModule(newPage);
        wrapper.appendChild(newPage);
        return newPage;
    }
    function addHeadersBasedOnModule(page) {
        if (module?.['type'].includes("repository")) repositoryHeaders(page);
        if (module?.['type'].includes("warranty-disclosure")) warrantyDisclosureHeaders(page);
        if ([
            "software-development",
            "esg"
        ].includes(module?.['type']) || checklistModule) riskRecommendationHeaders(page);
        if (module?.['type'].includes(`directors-questionnaire_${module?.['director']?.['_id']}`)) directorsQuestionnaireHeaders(page);
    }
    function setupEventListeners(wrapper) {
        let pdfInputs = wrapper.querySelectorAll("#pdf input");
        pdfInputs.forEach((input)=>input.addEventListener('click', (e)=>saveAnswerInput(e)));
        let pdfTextareas = wrapper.querySelectorAll("#pdf textarea");
        pdfTextareas.forEach((textarea)=>textarea.addEventListener('change', (e)=>saveAnswerInput(e)));
    }
    const titleHeading = (page)=>{
        const title = document.createElement("span");
        let div = null;
        let quesAnsHead = null;
        title.classList.add("db", "fw700", "fs1-25rem", "c15", 'ttu');
        if (tab.match(/two-minute-test-.*-report/)) {
            title.classList.add("tal", "w100");
            title.innerText = `2 Minute ${module?.heading} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb0-5rem");
            div.innerText = `${company['cName']}`;
            quesAnsHead = document.createElement("div");
            quesAnsHead.classList.add("w100", "br10px", "p0-5rem", "fs1rem", "bg52", "df", "aic", "c1");
            let leftBar = document.createElement("div");
            leftBar.innerText = "Question";
            leftBar.classList.add("w80", "pl1rem");
            let rightBar = document.createElement("div");
            rightBar.innerText = "Answer";
            rightBar.classList.add("w20");
            quesAnsHead.appendChild(leftBar);
            quesAnsHead.appendChild(rightBar);
            page.appendChild(title);
            page.appendChild(div);
            page.appendChild(quesAnsHead);
            return page;
        } else if (checklistModule) {
            title.classList.add("tac", "mb1-75rem");
            title.innerText = module['type'] + ' Report' + ' - ' + company['cName'];
        } else {
            title.classList.add("tal", "w100");
            title.innerText = `${tab.includes('kpi-report') ? 'KPI' : module?.heading} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb1rem");
            div.innerText = `${company['cName']}`;
            let warpElement = document.createElement('div');
            let warpElement2 = document.createElement('div');
            let logoTag = document.createElement('img');
            logoTag.classList.add("sad");
            logoTag.src = company['logo'];
            logoTag.alt = "companyLogo";
            logoTag.style.maxWidth = "150px";
            logoTag.style.maxHeight = "60px";
            warpElement2.appendChild(title);
            warpElement2.appendChild(div);
            warpElement.classList.add("df", "aic", "jcsb");
            warpElement.appendChild(warpElement2);
            if (company['logo']) warpElement.appendChild(logoTag);
            page.appendChild(warpElement);
            return page;
        }
        page.appendChild(title);
        return page;
    };
    const repositoryHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg52", "c1", "tac", "br10px");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const riskRecommendationHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Risk</h3><h3>Recommendation</h3>";
        page.appendChild(headings);
    };
    const warrantyDisclosureHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Disclosure</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const directorsQuestionnaireHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Text</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const sortQuestions = (a, b)=>{
        let valueA = a.qNo.split('.')[a.qNo.split('.').length - 1];
        let valueB = b.qNo.split('.')[a.qNo.split('.').length - 1];
        return valueA - valueB;
    };
    const sortLogs = (a, b)=>new Date(b.timestamp) - new Date(a.timestamp);
    const getAuditContent = ()=>{
        const sectionAnswers = answers.filter((a)=>!Object.values(module?.sections).filter((s)=>s.isHidden).find((s)=>a.qNo.includes(s.sectionNo)));
        const logs = sectionAnswers.filter((a)=>(a?.logs || []).length).reduce((arr, a)=>[
                ...arr,
                ...a?.logs || []
            ], []).sort(sortLogs);
        return logs.map((log, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 p1rem br5px df my0-5rem",
                children: [
                    log.userId.profilePicture && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "ass ml0-5rem br100 w2rem h2rem",
                        src: log.userId.profilePicture
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem bg3 c1",
                        children: [
                            log.userId.firstName[0],
                            log.userId.lastName[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: log.message
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log.files.map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: file.location,
                                    target: "_blank",
                                    className: "db c3-hover fw600",
                                    children: file.originalname
                                }, idx)),
                            (log.payload.answers || [
                                log.payload
                            ]).map((answer, idx)=>{
                                const question = answer.questionId ? questions.find((q)=>q._id == answer.questionId) : "";
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        question && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: question.qNo
                                                }),
                                                " - ",
                                                question.qDescription
                                            ]
                                        }),
                                        answer.file && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Filename"
                                                }),
                                                ": ",
                                                answer.file.originalname
                                            ]
                                        }),
                                        answer.status && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Changed Status"
                                                }),
                                                ": ",
                                                answer.status
                                            ]
                                        }),
                                        answer.radioOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Selected Option"
                                                }),
                                                ": ",
                                                answer.radioOption
                                            ]
                                        }),
                                        answer.comment && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Entered Comment"
                                                }),
                                                ": ",
                                                answer.comment
                                            ]
                                        })
                                    ]
                                });
                            })
                        ]
                    })
                ]
            }, idx));
    };
    const getSyncContent = ()=>{
        const records = module?.sections.flatMap((section)=>section?.questions?.flatMap((question)=>question?.answer?.logs || [])).sort(sortLogs);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "df jcc aic mb1-3rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                            className: "w2rem mr0-5rem"
                        }),
                        "Google Drive Synchronization Report"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr3 bg6 c1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Date Synced"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Synced By "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Files Synced"
                        })
                    ]
                }),
                records.map((record, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg tableRow gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(record['timestamp']).format('lll')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: `${record['userId']['firstName']} ${record['userId']['lastName']}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    record['userId']['email']
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                style: {
                                    textAlign: 'left'
                                },
                                children: record['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        href: file['location'],
                                        target: "'_blank",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "File"
                                            }),
                                            ": ",
                                            file['originalname']
                                        ]
                                    }, idx))
                            })
                        ]
                    }, `record-${idx}`))
            ]
        });
    };
    const getOverviewContent = ()=>{
        let hideRisk = false;
        if (module?.['riskScoring'] == false || tab == 'repository-report') hideRisk = true;
        else hideRisk = false;
        let array = [];
        if ([
            'warranty-disclosure',
            `directors-questionnaire_${module?.['director']?.['_id']}`,
            'software-development',
            'esg'
        ].includes(module?.['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections.filter((s)=>!s.isHidden);
        if (array?.length) sectionRefs.current.length = array.length;
        // array = array.filter((section) => section.isSection);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb aic",
                    children: [
                        checklistModule ? /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "w100 tal c15 lh2 fs1-25rem ttc",
                            children: (module?.['type'] && module['type']) + ' Report'
                        }) : tab.match(/two-minute-test-.*-report/) ? /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "w100 tal c15 lh2 fs1-25rem ttc",
                            children: '2 Minute ' + module?.heading + ' Report'
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "w100 tal c15 lh2 fs1-25rem ttc",
                            children: module?.['heading'] || (module?.['type'].includes('directors-questionnaire') ? 'Directors Questionnaire' : module?.['type']) + ' Report'
                        }),
                        company['logo'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: company['logo'],
                            style: {
                                maxHeight: "70px",
                                maxWidth: "150px"
                            },
                            alt: "companyLogo"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt0-5rem dg gg0-5rem minh100vh-report",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "fs1rem fsi fw400 lh1 ttu usn c15",
                            children: company['cName']
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "report-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dg gtcr2a gg2rem mb1-3rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "h100 df fdc aifs ",
                                            children: [
                                                [
                                                    "Company Reg:",
                                                    company['ukRegNo']
                                                ],
                                                [
                                                    "Subscription:",
                                                    (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: company['subscription']?.toUpperCase()
                                                    })
                                                ],
                                                [
                                                    "Objective :",
                                                    company['testType']
                                                ]
                                            ].map((arr, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "ass fs12px mt0-25rem mb0-25rem c15",
                                                            children: arr[0]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs12px fw700 lh1 ttu usn c15 ml0-5rem",
                                                            children: arr[1]
                                                        })
                                                    ]
                                                }, `reportLeft-Head-${idx}`))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aife",
                                            children: [
                                                [
                                                    "Generated By",
                                                    user.email
                                                ],
                                                [
                                                    "Report Date",
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("MMM Do YYYY, h:mm A")
                                                ]
                                            ].map((arr, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "ass fs12px mt0-25rem mb0-25rem c15",
                                                            children: [
                                                                arr[0],
                                                                ": "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs12px fw700 lh1 ttu usn c15 ml0-5rem",
                                                            children: arr[1]
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `progress-area-report bo31 bss br20px bw1px mb1rem px1rem py0-5rem`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "progress-area",
                                        style: {
                                            display: 'flex',
                                            position: 'relative',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "progress-box p1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "progress-bar",
                                                        style: {
                                                            width: 80,
                                                            height: 80,
                                                            backgroundColor: '#FBFBFB',
                                                            borderRadius: '50%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `${module?.stats?.completionPercent > 67 ? 'bg-green' : module?.stats?.completionPercent > 33 ? 'bg-orange' : 'bg-red'} c2 df jcc aic`,
                                                            style: {
                                                                width: "68px",
                                                                height: "68px",
                                                                borderRadius: '50%'
                                                            },
                                                            children: (module?.stats?.completionPercent || 0) + "%"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "text-center-area mt1rem c37 mb0rem fs1rem tac",
                                                        children: [
                                                            "Module ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "Completeness"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            tab.match(/two-minute-test-.*-report/) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic jcc fdc ",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "c15",
                                                    children: "Your Overall Result"
                                                })
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcc mb1rem",
                                                children: tab && module && tab.includes(`directors-questionnaire_${module?.['director']?.['_id']}`) && directorCertification ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        directorCertification == 'None' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w50",
                                                            src: (parcelRequire("9pBV1")),
                                                            alt: "Label"
                                                        }),
                                                        directorCertification == 'Silver' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w30",
                                                            src: (parcelRequire("7YoCF")),
                                                            alt: "Trophy"
                                                        }),
                                                        directorCertification == 'Gold' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w30",
                                                            src: (parcelRequire("gr5qi")),
                                                            alt: "Trophy"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: moduleCertification && moduleCertification == 'Bronze' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w30 ${module?.['type'] == "repository" && 'mr7rem'}`,
                                                        src: (parcelRequire("cXyX2")),
                                                        alt: "Trophy"
                                                    }) : moduleCertification && moduleCertification == 'Silver' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w30 ${module?.['type'] == "repository" && 'mr7rem'}`,
                                                        src: (parcelRequire("7YoCF")),
                                                        alt: "Trophy"
                                                    }) : moduleCertification && moduleCertification == 'Gold' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w30 ${module?.['type'] == "repository" && 'mr7rem'}`,
                                                        src: (parcelRequire("gr5qi")),
                                                        alt: "Trophy"
                                                    }) : moduleCertification && moduleCertification == 'None' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w50 ${module?.['type'] == "repository" && 'mr7rem'}`,
                                                        src: (parcelRequire("9pBV1")),
                                                        alt: "Label"
                                                    }) : null
                                                })
                                            }),
                                            hideRisk ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "progress-box-hidden"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "progress-box p1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "progress-bar",
                                                        style: {
                                                            width: 80,
                                                            height: 80,
                                                            backgroundColor: '#FBFBFB',
                                                            borderRadius: '50%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `${module?.stats?.riskPercent > 67 ? 'bg-red' : module?.stats?.riskPercent > 33 ? 'bg-orange' : 'bg-green'} c2 df jcc aic`,
                                                            style: {
                                                                width: "66px",
                                                                height: "66px",
                                                                borderRadius: '50%'
                                                            },
                                                            children: (module?.stats?.riskPercent || 0) + "%"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "text-center-area mt1rem c37 mb0rem fs1rem tac",
                                                        children: [
                                                            "Module ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "Risk"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "oscy h60vh",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "c37 headingReport fs14px tac",
                                                    children: "Section"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "c37 fs14px pl2rem",
                                                    children: "Name"
                                                })
                                            ]
                                        }),
                                        array && array.length > 0 && array.sort(sortSections).map((section, idx)=>{
                                            let completeness = section.stats.completionPercent;
                                            if (module['type'] == 'repository' && company['subscription'] == 'Lite') {
                                                if (section.questions) completeness = section.questions.filter((q)=>q.qNo == section.sectionNo)[0]?.['answer']?.['status'] == 'Completed' ? 100 : 0;
                                            } else completeness = section.stats.completionPercent;
                                            let riskColour;
                                            if (module?.type === "repository" || section.stats.riskPercent < 38) riskColour = 7;
                                            else if (section.stats.riskPercent > 62) riskColour = 9;
                                            else riskColour = 8;
                                            let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                                            let colorChange = false;
                                            if (module?.['type'] == "warranty-disclosure") section?.questions.map((question)=>{
                                                if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
                                                    colorChange = true;
                                                    return;
                                                }
                                            });
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                "data-scroll-to": section.sectionNo,
                                                className: "df c15 td250 px1rem py0-5rem cp new-report-btn bg54",
                                                style: {
                                                    opacity: `${section.isDisabled ? 0.5 : 1}`
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "pen usn ass mr0-5rem tac left-heading df aic jcc c15",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $067517aabc6d84f7$export$2e2bcd8739ae039), {
                                                                className: "pa l10 c3"
                                                            }),
                                                            section.sectionNo
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            background: `${section.isDisabled ? "#fff" : `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`}`,
                                                            opacity: `${section.isDisabled ? 0.5 : 1}`
                                                        },
                                                        className: "pen uss ass fw600 tal right-detail fs14px c15 df aic jcsb",
                                                        children: [
                                                            section.sectionName,
                                                            section.isDisabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                                className: "c15 fw400 fs1rem"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, `${idx}-report`);
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const saveAnswerInput = async (event)=>{
    // let answerId = event.target.id.split('_')[1];
    // const res = await postRequest(`/question/addNote/${answerId}`, { done: true });
    // showMessage(res?.['message']);
    };
    const sortQuestionsByQNo = (questions1)=>{
        if (questions1 && questions1.length > 0) return questions1 && questions1.slice().sort((a, b)=>{
            const aParts = a['qNo'].match(/\d+/g).map(Number);
            const bParts = b['qNo'].match(/\d+/g).map(Number);
            for(let i = 0; i < Math.max(aParts.length, bParts.length); i++)if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
            return 0;
        });
    };
    const getAuditReportContent = ()=>{
        let array = [];
        if ([
            'warranty-disclosure',
            `directors-questionnaire_${module?.['director']?.['_id']}`,
            'software-development',
            'esg'
        ].includes(module?.['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections.filter((s)=>!s.isHidden);
        if (array && array.length > 0) {
            sectionRefs.current.length = array.length;
            // array = array.filter((section) => section.isSection);
            array = array.slice().sort(sortSections);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: array && array.length > 0 && array.map((section, index)=>{
                let questions1;
                let completionPercent, riskPercent;
                const qNo = section.sectionNo || section.no;
                if (module['type'] == 'repository' && company['subscription'] == 'Lite') questions1 = section.questions && section.questions.filter((q)=>q.qNo == qNo) || [];
                else questions1 = section?.questions;
                // questions = questions.sort(sortQuestions);
                questions1 = sortQuestionsByQNo(questions1);
                if (section?.stats?.completionPercent) completionPercent = section.stats.completionPercent;
                if (section?.stats?.riskPercent) riskPercent = section.stats.riskPercent;
                if (module['type'] == 'repository' && company['subscription'] == 'Lite') {
                    if (section.questions) completionPercent = section.questions.filter((q)=>q.qNo == section.sectionNo)[0]?.['answer']?.['status'] == 'Completed' ? 100 : 0;
                }
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "section-break"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                className: "df jcc aic tac mb1rem fs1rem",
                                children: [
                                    section['sectionNo'],
                                    " - ",
                                    section['sectionName'],
                                    " Report \xa0-\xa0",
                                    completionPercent && completionPercent > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: completionPercent < 34 ? "c9" : completionPercent < 67 ? 'c8' : 'c7',
                                                children: [
                                                    "Completed ",
                                                    completionPercent || 0,
                                                    "%"
                                                ]
                                            }),
                                            riskPercent > 0 && module['type'] != "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: riskPercent < 38 ? "c7" : riskPercent < 62 ? 'c8' : 'c9',
                                                        children: [
                                                            riskPercent || 0,
                                                            "% Risk"
                                                        ]
                                                    }),
                                                    " "
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c12",
                                                children: "Not Started"
                                            }),
                                            module['type'] != "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c12",
                                                        children: "No Risk Score"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        questions1 && questions1.length > 0 && questions1.filter((q)=>q.answer)?.map((question, idx)=>{
                            if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                            let isRisky = question?.['answer']?.['radioOption'] == "No";
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    id: qNo,
                                    className: `mah40vh dg tableRow fs0-75rem my0-5rem ${[
                                        "repository",
                                        `directors-questionnaire_${module?.['director']?.['_id']}`
                                    ].includes(module?.['type']) ? 'gtcr-audit' : 'gtcr-audit-two'}`,
                                    style: {
                                        overflow: 'auto'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc jcfs pt0-25rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fw600",
                                                        children: [
                                                            question['qNo'],
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c2 db fw500",
                                                        children: question?.['qDescription']
                                                    })
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes(`directors-questionnaire_${module?.['director']?.['_id']}`) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aic tac jcfs pt1rem br5px",
                                            children: question?.questionType.includes("YN") ? question.answer['radioOption'] || question.answer['status'] : "-"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc aic tac jcfs pt1rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `${[
                                                    "Disclosure",
                                                    "No Disclosure"
                                                ].includes(question?.answer?.['radioOption']) ? ' px0-5rem ' : ' px1rem '} br10px c1 ${[
                                                    'Yes',
                                                    'No Disclosure'
                                                ].includes(question?.answer?.['radioOption']) ? ' bg34' : question?.answer?.['radioOption']?.includes('No') ? ' bg4' : question?.answer?.['radioOption']?.includes('Disclosure') ? ' bg39' : ' bg16'}`,
                                                style: {
                                                    paddingTop: "4px",
                                                    paddingBottom: "4px"
                                                },
                                                children: question.answer['radioOption'] || question.answer['status'] || 'N/A'
                                            })
                                        }),
                                        module?.['type'].includes(`directors-questionnaire_${module?.['director']?.['_id']}`) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question?.questionType.includes("Date") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.answer && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(question?.answer?.date).format('ll')
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: question['answer'] ? question['answer']['comment'] || question['answer']['dropdown'] : '-'
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question?.answer?.files?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "File"
                                                                    }),
                                                                    ": ",
                                                                    file['originalname']
                                                                ]
                                                            }, idx))
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "-"
                                                    })
                                                })
                                            ]
                                        }),
                                        module?.['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "db pt1rem br5px",
                                                style: {
                                                    marginLeft: "30px"
                                                },
                                                children: [
                                                    question?.answer?.files?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            question?.['answer']?.['files'] && question['answer']['files'].slice(0, 20).map((file, idxI)=>{
                                                                let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: `${fileColor} fileManageFileName pr mb0-5rem px1rem`,
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: file['originalname']
                                                                }, `laal-${idx}-${idxI}`);
                                                            }),
                                                            question?.['answer']?.['files']?.length > 20 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                className: "cp",
                                                                target: "_blank",
                                                                href: `/company/${company['_id']}#${location.href.split('#')[1]}`,
                                                                style: {
                                                                    marginTop: "12px",
                                                                    fontWeight: 700
                                                                },
                                                                children: [
                                                                    "for more information click here ",
                                                                    location.href.split('#')[1]
                                                                ]
                                                            }, `question-${idx}-sd`) : null
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "op30 c15",
                                                        children: "No Files Uploaded"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc aic tac jcfs pt1rem br5px c37 pl2rem",
                                                        children: [
                                                            "Notes - ",
                                                            question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                children: question['answer']['comment']
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes(`business-audit-${company['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: question?.['answer']?.['status'] == 'Completed' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fdc tal jcfs pt0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df pb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: question?.['answer']?.['aiResponse']?.['ifriskDescription'] ? question?.['answer']['aiResponse']['ifriskDescription'] : question['riskDescription'] ? question['riskDescription'] : '-'
                                                            }) : "Well done"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] ? question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] : question['recommendDescription'] ? question['recommendDescription'] : '-'
                                                            }) : "No recommendation at this time"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        checklistModule && question?.['answer']?.['radioOption'] != 'N/A' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc tal jcs pt0-5rem ",
                                                children: [
                                                    question?.['answer']?.['radioOption'] != 'Yes' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df pb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['riskDescription'] || question?.['ifNo']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['recommendDescription'] || question?.['toptip'] || question.answer.radioOption == "Yes" && question?.['ifYes']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w90 p1rem my0-5rem",
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: [
                                                            "Files:",
                                                            question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 ? question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: "ml0-5rem tdu",
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: file['originalname']
                                                                }, idx)) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "ml0-5rem fs0-75rem fw500",
                                                                children: "No files uploaded"
                                                            })
                                                        ]
                                                    }),
                                                    question?.['answer']?.['comment'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w90 p1rem my0-5rem",
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: [
                                                            "Note: ",
                                                            question?.['answer']?.['comment']
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        [
                                            "warranty-disclosure",
                                            "software-development",
                                            "esg"
                                        ].includes(module?.['type']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc tal jcfs pt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df pb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' && question['answer']['radioOption'] == 'Disclosure' ? question?.['answer']?.['comment'] && question?.['answer']?.['comment'] : module?.['type'] == 'warranty-disclosure' ? '-' : question?.['answer']?.['aiResponse']?.['ifriskDescription'] ? question?.['answer']['aiResponse']['ifriskDescription'] : question['riskDescription'] ? question['riskDescription'] : '-'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' ? question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                            children: "File"
                                                                        }),
                                                                        ": ",
                                                                        file['originalname']
                                                                    ]
                                                                }, idx)) : question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] ? question?.['answer']['aiResponse']['ifrecommendDescription'] : question['recommendDescription'] ? question['recommendDescription'] : '-'
                                                        })
                                                    ]
                                                }),
                                                [
                                                    "software-development",
                                                    "esg"
                                                ].includes(module?.['type']) && question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "w90 p1rem my0-5rem",
                                                    style: {
                                                        background: '#e1e1f155'
                                                    },
                                                    children: [
                                                        "Files: ",
                                                        question['answer']['files'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                className: "ml0-5rem tdu",
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: file['originalname']
                                                            }))
                                                    ]
                                                }),
                                                [
                                                    "software-development",
                                                    "esg"
                                                ].includes(module?.['type']) && question?.['answer']?.['comment'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "w90 fs0-75rem p1rem my0-5rem",
                                                    style: {
                                                        background: '#e1e1f155'
                                                    },
                                                    children: [
                                                        "Note: ",
                                                        question['answer']['comment']
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, `pdf-report-${idx}-${index}`)
                            });
                        })
                    ]
                });
            })
        });
    };
    const getTwoMinuteTestContent = ()=>{
        const writeSections = (sections)=>Object.values(sections).filter((s)=>!s.isHidden).map((section, index)=>{
                const questionsAndAnswers = section?.questions?.slice().sort(sortQuestions).filter((q)=>q?.answer?.radioOption);
                if (questionsAndAnswers && questionsAndAnswers.length) sectionRefs.current.length = questionsAndAnswers.length;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: questionsAndAnswers && questionsAndAnswers.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                id: section.sectionNo,
                                ref: (el)=>{
                                    if (section['sectionNo']) sectionRefs.current[index] = el;
                                },
                                className: "usn pen fs1rem fw400 mt1rem tal c15 w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: `fw600`,
                                        children: [
                                            "Section ",
                                            index + 1
                                        ]
                                    }),
                                    " - ",
                                    section.sectionName
                                ]
                            }),
                            questionsAndAnswers.map((question, idx)=>{
                                const { answer: answer } = question;
                                if (!aiEnhanced && Object.values(answer?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "question-box c1 mt0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "c15 fs1rem",
                                                children: question['qNo']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aifs lg-fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c15 fs14px w80",
                                                        children: question['qDescription']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w20",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `${question['answer']['radioOption'] == 'Yes' || question['answer']['radioOption'] < 3 ? 'bg-green' : 'bg-red'} c1 br50px px1rem ml1rem fs14px py0-5rem`,
                                                            children: question['answer']['radioOption']
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "recomended-box mt1rem",
                                                children: (()=>{
                                                    const recommendationKey = [
                                                        "ifYes",
                                                        "ifNo",
                                                        "",
                                                        "if1",
                                                        "if2",
                                                        "if3",
                                                        "if4",
                                                        "if5"
                                                    ].find((key)=>key.includes("if" + answer.radioOption));
                                                    return recommendationKey && question[recommendationKey] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "bg53 br10px p1rem mt1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "c15 fsi df aic fs14px mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "21",
                                                                        height: "22",
                                                                        viewBox: "0 0 21 22",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                "clip-path": "url(#clip0_5984_54722)",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M16.2103 16.9044C15.9637 16.2436 15.2247 15.9077 14.5645 16.1561L11.8761 17.1671C11.1253 17.4497 10.3345 17.5799 9.54688 17.562L10.2036 20.0462C11.202 19.9596 12.1924 19.7419 13.148 19.3895L15.4626 18.5354C16.1217 18.2924 16.4563 17.5624 16.2103 16.9044Z",
                                                                                        fill: "url(#paint0_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M17.8688 16.6819C17.5837 16.0519 16.8394 15.7745 16.2112 16.0639L13.6529 17.2414C12.6572 17.6999 11.5662 17.8758 10.4942 17.7678L9.5 20.2757C11.3823 20.4392 13.2926 20.1219 15.0438 19.3293L17.2476 18.3315C17.8751 18.0475 18.1531 17.3091 17.8688 16.6819Z",
                                                                                        fill: "url(#paint1_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M19.0177 16.731C18.6862 16.1084 17.9094 15.8728 17.2877 16.206L14.7559 17.5622C13.7705 18.0903 12.6696 18.337 11.5697 18.2939L10.7188 20.9049C12.6483 20.9539 14.5753 20.5125 16.3093 19.5978L18.4913 18.4463C19.1127 18.1186 19.3482 17.3508 19.0177 16.731Z",
                                                                                        fill: "url(#paint2_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M10.5037 0.5C10.1392 0.5 9.84375 0.795482 9.84375 1.15998V2.53235C9.84375 2.89684 10.1392 3.19232 10.5037 3.19232C10.8682 3.19232 11.1637 2.89684 11.1637 2.53235V1.15998C11.1637 0.795482 10.8682 0.5 10.5037 0.5Z",
                                                                                        fill: "url(#paint3_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M20.087 10.0898H18.7147C18.3502 10.0898 18.0547 10.3853 18.0547 10.7498C18.0547 11.1143 18.3502 11.4098 18.7147 11.4098H20.087C20.4515 11.4098 20.747 11.1143 20.747 10.7498C20.747 10.3853 20.4515 10.0898 20.087 10.0898Z",
                                                                                        fill: "url(#paint4_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2.28235 10.0898H0.909976C0.545482 10.0898 0.25 10.3853 0.25 10.7498C0.25 11.1143 0.545482 11.4098 0.909976 11.4098H2.28235C2.64684 11.4098 2.94232 11.1143 2.94232 10.7498C2.94228 10.3853 2.6468 10.0898 2.28235 10.0898Z",
                                                                                        fill: "url(#paint5_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M4.18133 3.50189C3.9236 3.24416 3.5057 3.24416 3.24798 3.50189C2.99026 3.75961 2.99026 4.17747 3.24798 4.43519L4.21839 5.4056C4.47611 5.66332 4.89397 5.66332 5.15173 5.4056C5.40946 5.14787 5.40946 4.73002 5.15173 4.47225L4.18133 3.50189Z",
                                                                                        fill: "url(#paint6_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M17.7454 3.50189C17.4877 3.24416 17.0699 3.24416 16.8121 3.50189L15.8417 4.47229C15.584 4.73002 15.584 5.14787 15.8417 5.40564C16.0995 5.66336 16.5173 5.66336 16.7751 5.40564L17.7455 4.43523C18.0032 4.17751 18.0032 3.75961 17.7454 3.50189Z",
                                                                                        fill: "url(#paint7_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M5.3953 5.6453C2.57657 8.46404 2.57657 13.0341 5.3953 15.8529C8.21404 18.6716 12.7841 18.6716 15.6029 15.8529C18.4216 13.0341 18.4216 8.46404 15.6029 5.6453C12.7841 2.82657 8.21404 2.82657 5.3953 5.6453Z",
                                                                                        fill: "url(#paint8_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M10.5021 5.31641C7.5022 5.31641 5.07031 7.74829 5.07031 10.7482C5.07031 13.7481 7.5022 16.18 10.5021 16.18C13.502 16.18 15.9339 13.7481 15.9339 10.7482C15.9339 7.74829 13.502 5.31641 10.5021 5.31641Z",
                                                                                        fill: "url(#paint9_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M5.39529 15.8538C8.21403 18.6725 12.7841 18.6725 15.6029 15.8538C17.0122 14.4444 17.7169 12.5972 17.7169 10.75H3.28125C3.28125 12.5972 3.98594 14.4444 5.39529 15.8538Z",
                                                                                        fill: "url(#paint10_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M15.9311 10.9057L14.4537 9.42832C14.2973 9.23492 14.0699 9.09294 13.7863 9.05172L13.1477 8.95891C13.1226 8.934 11.3645 7.18305 11.3645 7.18305C10.899 6.60753 9.94828 6.67526 9.59729 7.38642L8.99031 8.61628C8.92689 8.74479 8.80427 8.83386 8.66246 8.85444L7.30524 9.05168C6.43765 9.17776 6.09124 10.2439 6.71901 10.8559C6.71901 10.8559 7.7672 11.9023 7.77572 11.9113C7.82439 11.9975 7.84346 12.0986 7.82633 12.1986L7.59446 13.5503C7.52438 13.959 7.69049 14.3216 7.96699 14.5473L9.50979 16.0902C9.83142 16.1495 10.1629 16.1809 10.5017 16.1809C13.4492 16.1808 15.8482 13.8331 15.9311 10.9057Z",
                                                                                        fill: "url(#paint11_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M11.4474 7.34351L12.0544 8.57337C12.1178 8.70188 12.2404 8.79095 12.3822 8.81154L13.7395 9.00877C14.607 9.13485 14.9535 10.201 14.3257 10.813L13.3436 11.7703C13.241 11.8703 13.1942 12.0144 13.2184 12.1556L13.4502 13.5074C13.5984 14.3715 12.6914 15.0304 11.9155 14.6224L10.7015 13.9842C10.5746 13.9175 10.4231 13.9175 10.2963 13.9842L9.08232 14.6224C8.30635 15.0304 7.3994 14.3715 7.54759 13.5074L7.77945 12.1556C7.80367 12.0144 7.75685 11.8703 7.65424 11.7703L6.67214 10.813C6.04436 10.201 6.39078 9.13485 7.25837 9.00877L8.61558 8.81154C8.7574 8.79095 8.87998 8.70188 8.94343 8.57337L9.55041 7.34351C9.93838 6.55737 11.0594 6.55737 11.4474 7.34351Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M11.9154 14.6222L10.7015 13.9839C10.5746 13.9172 10.4232 13.9172 10.2963 13.9839L9.08245 14.6222C8.30647 15.0302 7.3994 14.3713 7.54755 13.507L7.77954 12.1555C7.80363 12.0141 7.75693 11.8699 7.65416 11.77L6.6721 10.8127C6.33457 10.4836 6.2787 10.0233 6.43402 9.64844L13.2221 11.9893C13.2103 12.0431 13.2087 12.0996 13.2183 12.1555L13.4502 13.507C13.5985 14.3713 12.6914 15.0302 11.9154 14.6222Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M10.7026 13.9842L11.9166 14.6224C12.6925 15.0304 13.5995 14.3715 13.4513 13.5074L13.2195 12.1556C13.1952 12.0144 13.2421 11.8703 13.3447 11.7703L14.3268 10.813C14.9546 10.201 14.6081 9.13485 13.7405 9.00877L12.3833 8.81154C12.2415 8.79095 12.1189 8.70188 12.0555 8.57337L11.4485 7.34351C11.2545 6.95044 10.8773 6.75391 10.5 6.75391V13.9343C10.5695 13.9342 10.6391 13.9509 10.7026 13.9842Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M9.08216 14.6222L10.296 13.9839C10.4229 13.9172 10.5744 13.9172 10.7012 13.9839L11.9151 14.6222C12.6911 15.0302 13.5981 14.3713 13.45 13.507L13.218 12.1555C13.1939 12.0141 13.2406 11.8699 13.3434 11.77L14.3254 10.8127C14.663 10.4836 14.7188 10.0233 14.5635 9.64844L7.77542 11.9893C7.7872 12.0431 7.78885 12.0996 7.77929 12.1555L7.5473 13.507C7.39907 14.3713 8.30615 15.0302 9.08216 14.6222Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M13.8107 12.6094L12.791 13.629C11.9672 14.4528 10.8499 14.9156 9.6849 14.9156H8.70312V17.7429C11.0926 18.355 13.7344 17.7263 15.6049 15.8557C15.8514 15.6092 16.0759 15.349 16.2793 15.078L13.8107 12.6094Z",
                                                                                        fill: "url(#paint12_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M18.7047 16.3155L17.6513 17.1043C17.605 17.1368 17.5584 17.1687 17.5114 17.2C16.2467 18.0426 14.7191 18.3939 13.2064 18.2481C11.9413 18.1262 11.435 18.0371 9.80568 17.1574C9.52157 17.004 9.48241 16.6971 9.71806 16.4764L9.78262 16.4159C11.0463 15.9079 12.2593 15.2847 13.4067 14.5547C14.0655 14.1356 14.2454 13.2532 13.8069 12.6072C13.4077 12.0191 12.6294 11.8297 12.0029 12.1652C10.9272 12.7414 9.74231 13.0926 8.52143 13.1933C8.28817 13.2126 8.0535 13.2062 7.82073 13.182C7.08738 13.1056 5.31185 12.9331 4.71722 12.9872C4.71174 12.9877 4.70622 12.9882 4.70071 12.9888C3.14419 13.1328 1.86925 14.2862 1.56524 15.8197L1.54716 15.911C1.15409 17.8917 2.44197 19.8165 4.42318 20.2092L7.84428 20.8874L9.99917 21.2936C13.3815 21.9036 16.868 21.1507 19.6889 19.201L20.3735 18.6911C21.0329 18.2355 21.1955 17.3331 20.7368 16.675C20.2764 16.0146 19.3639 15.8533 18.7047 16.3155Z",
                                                                                        fill: "url(#paint13_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M3.06724 13.5703C2.30646 14.0795 1.75218 14.8782 1.56524 15.8211L1.54716 15.9123C1.15409 17.8931 2.44197 19.8179 4.42318 20.2106L7.84428 20.8888L9.99917 21.2951C10.3069 21.3506 10.6155 21.3945 10.9244 21.4275L3.06724 13.5703Z",
                                                                                        fill: "url(#paint14_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M13.809 12.6071C13.4098 12.0191 12.6315 11.8297 12.005 12.1652C10.8185 12.8007 9.49912 13.1626 8.14516 13.2165C8.12481 13.2173 8.10447 13.2182 8.08417 13.2192C5.79563 13.3338 5.5645 16.6262 7.81434 17.0607C7.97604 17.0919 8.1433 17.0758 8.29611 17.0144L9.78476 16.416C11.0484 15.908 12.2615 15.2848 13.4089 14.5548C14.0677 14.1356 14.2475 13.2532 13.809 12.6071Z",
                                                                                        fill: "url(#paint15_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2.17638 20.4957H0.894394C0.400441 20.4957 0 20.0953 0 19.6014V13.6171C0 13.1231 0.400441 12.7227 0.894394 12.7227H2.17638C2.67034 12.7227 3.07078 13.1231 3.07078 13.6171V19.6014C3.07078 20.0953 2.67038 20.4957 2.17638 20.4957Z",
                                                                                        fill: "url(#paint16_linear_5984_54722)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint0_linear_5984_54722",
                                                                                        x1: "12.7258",
                                                                                        y1: "16.173",
                                                                                        x2: "12.968",
                                                                                        y2: "17.3652",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint1_linear_5984_54722",
                                                                                        x1: "13.1515",
                                                                                        y1: "16.3163",
                                                                                        x2: "13.4902",
                                                                                        y2: "17.7781",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint2_linear_5984_54722",
                                                                                        x1: "14.1626",
                                                                                        y1: "17.2462",
                                                                                        x2: "14.6066",
                                                                                        y2: "18.2972",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint3_linear_5984_54722",
                                                                                        x1: "9.84916",
                                                                                        y1: "3.32692",
                                                                                        x2: "8.53655",
                                                                                        y2: "1.74127",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint4_linear_5984_54722",
                                                                                        x1: "18.1698",
                                                                                        y1: "10.5962",
                                                                                        x2: "19.8938",
                                                                                        y2: "11.8426",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint5_linear_5984_54722",
                                                                                        x1: "2.8261",
                                                                                        y1: "10.1657",
                                                                                        x2: "1.14153",
                                                                                        y2: "8.94779",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint6_linear_5984_54722",
                                                                                        x1: "4.93266",
                                                                                        y1: "5.38776",
                                                                                        x2: "2.98674",
                                                                                        y2: "3.52078",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint7_linear_5984_54722",
                                                                                        x1: "15.5459",
                                                                                        y1: "5.14404",
                                                                                        x2: "17.2932",
                                                                                        y2: "3.45622",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint8_linear_5984_54722",
                                                                                        x1: "3.23077",
                                                                                        y1: "9.78771",
                                                                                        x2: "19.2211",
                                                                                        y2: "15.5866",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint9_linear_5984_54722",
                                                                                        x1: "13.9779",
                                                                                        y1: "15.1785",
                                                                                        x2: "4.74789",
                                                                                        y2: "6.32304",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint10_linear_5984_54722",
                                                                                        x1: "12.5334",
                                                                                        y1: "14.8492",
                                                                                        x2: "14.0698",
                                                                                        y2: "16.7511",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FE9738",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FE9738"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint11_linear_5984_54722",
                                                                                        x1: "14.1378",
                                                                                        y1: "15.8456",
                                                                                        x2: "8.44981",
                                                                                        y2: "6.47689",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#BE3F45",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#BE3F45"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint12_linear_5984_54722",
                                                                                        x1: "12.4912",
                                                                                        y1: "15.1923",
                                                                                        x2: "12.4912",
                                                                                        y2: "17.7678",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FE9738",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FE9738"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint13_linear_5984_54722",
                                                                                        x1: "9.73667",
                                                                                        y1: "13.0482",
                                                                                        x2: "13.3397",
                                                                                        y2: "23.1475",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint14_linear_5984_54722",
                                                                                        x1: "7.34016",
                                                                                        y1: "17.4989",
                                                                                        x2: "1.15368",
                                                                                        y2: "17.4989",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFB09E",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#EC806B"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint15_linear_5984_54722",
                                                                                        x1: "10.1034",
                                                                                        y1: "14.3586",
                                                                                        x2: "12.3963",
                                                                                        y2: "16.6514",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFB09E",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#EC806B"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint16_linear_5984_54722",
                                                                                        x1: "0.418887",
                                                                                        y1: "16.6092",
                                                                                        x2: "2.90439",
                                                                                        y2: "16.6092",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#B3DAFE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#0182FC"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                        id: "clip0_5984_54722",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                            width: "21",
                                                                                            height: "21",
                                                                                            fill: "white",
                                                                                            transform: "translate(0 0.5)"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        className: "ml0-5rem",
                                                                        children: "Recommendation:"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs14px c15 lh1-5",
                                                                children: answer?.['aiResponse']?.[recommendationKey] || question[recommendationKey]
                                                            })
                                                        ]
                                                    });
                                                })()
                                            })
                                        ]
                                    })
                                }, `section-random-${idx}`);
                            }),
                            " "
                        ]
                    })
                });
            });
        return writeSections(module?.sections);
    };
    const getKPIContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg52 br5px py0-5rem df aic jcsb mb1rem mt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1 ml1rem",
                            children: "#KPI Name"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1",
                            children: "KPI Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1",
                            children: "KPI Calculation"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1",
                            children: "KPI Metric"
                        })
                    ]
                }),
                kpis && kpis.map((kpi, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px fw500 fsi",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: kpi['title'] || '-'
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px",
                                children: kpi['name'] || '-'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px",
                                children: kpi['calculation'] || '-'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px",
                                children: kpi['metric'] || '-'
                            })
                        ]
                    }, `${idx}-kpi`))
            ]
        });
    };
    // If module has a reportUrl (Papermill PDF), show it in an iframe
    if (module?.reportUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w100 h100",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
            src: module.reportUrl,
            className: "w100 br10px",
            style: {
                height: '100vh',
                border: 'none'
            },
            title: "Module Report PDF"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            company && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                        id: "pdf",
                        className: `op0 pen ma td250 dg gg2rem ${tab}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "hideOnDownload mt2rem aic df",
                        children: [
                            !user.firstName && tab == 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df jcc aic fdc ",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem mb1rem tac c15",
                                        children: "Now let's view your 2-minute test report..."
                                    }),
                                    user['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>twoMinuteTestAIReport(module),
                                            className: "shadow bsbb jcc w100px w9rem df fdc aic fw500  px1rem c1 bg4 br19px cp registerButtonAnimation",
                                            style: {
                                                width: '25%',
                                                paddingTop: '7px',
                                                paddingBottom: '7px'
                                            },
                                            children: "View 2-Minute Test Report"
                                        })
                                    })
                                ]
                            }),
                            tab.match(/two-minute-test-.*-report/) && user?.['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 df jcc aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: `/company/${company['_id']}`,
                                    style: {
                                        width: '15%',
                                        paddingTop: '7px',
                                        paddingBottom: '7px'
                                    },
                                    className: `shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                                    children: "Next"
                                })
                            }),
                            module && module?.['type'] && module?.['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(""),
                                    className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Dashboard"
                                })
                            }),
                            module && module?.['type'] && module?.['type'].includes(`business-audit-${company?.['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc aic w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setTab(module['type']),
                                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                        children: "Business Audit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setTab(""),
                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                        children: "Dashboard"
                                    })
                                ]
                            }),
                            module && module?.['type'] && module?.['type'] == "warranty-disclosure" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(""),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Dashboard"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                        id: "pdfContent",
                        className: "bsbb w0 h0 oh op0 pen db pr",
                        style: {
                            width: "210mm"
                        },
                        children: tab === "kpi-report" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df aic jcsb pdfHeaderCustom",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "tal c15 lh1 mt1rem fs1-25rem ",
                                                    children: "KPI Report"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "fsi tal c15 fs1rem fw400 mb1rem",
                                                    children: company['cName']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mt3rem c15",
                                                    children: [
                                                        "Report Date: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600 c15",
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date()).format('MMM DD, YYYY')
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 df fdc jcsb aife",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w80px h80px mb2rem",
                                                    src: (parcelRequire("hiMCQ")),
                                                    alt: "bonusIcon"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15 fs12px fw500 w100 tar",
                                                    children: "Bespoke KPI report for your company"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                getKPIContent()
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                getOverviewContent(),
                                [
                                    'repository-report',
                                    `business-audit-${company?.['testType']}-report`,
                                    'warranty-disclosure-report',
                                    'software-development-report',
                                    'esg-report',
                                    `directors-questionnaire_${module?.['director']?.['_id']}`
                                ].includes(tab) ? getAuditReportContent() : tab.includes("repository-sync-report") ? getSyncContent() : tab.includes("repository-audit-report") ? getAuditContent() : tab.match(/two-minute-test-.*-report/) ? getTwoMinuteTestContent() : getAuditReportContent()
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'generatingKPI',
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tac",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h9rem",
                            src: (parcelRequire("hA45b")),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mb0-5rem c15",
                            children: "Generating KPI Report"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fs0-75rem mb1rem",
                            children: "This may take few seconds."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "mb1-5rem c15 fs12px px1rem op70",
                            children: [
                                "We are prepare your ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "fsi",
                                    children: "BONUS KPI Report"
                                }),
                                ", which suggests 10 useful business metrics for your business, how to calculate them, and your industry comparables."
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $lwfqC = parcelRequire("lwfqC");



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $7JB23 = parcelRequire("7JB23");
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.2 Built on 2024-09-17T13:29:57.859Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ 
var $41YNz = parcelRequire("41YNz");
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$i32 = Int32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a.b, $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b.b, $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $461bf5d8bd29e0d8$var$u8(v.subarray(s, e));
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $461bf5d8bd29e0d8$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $461bf5d8bd29e0d8$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $461bf5d8bd29e0d8$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $461bf5d8bd29e0d8$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, sym >> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
            var dst = sym & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, sym >> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
        } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $461bf5d8bd29e0d8$var$u16(32768), head = st.h || new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $461bf5d8bd29e0d8$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1);
        $461bf5d8bd29e0d8$var$ch[id] = {
            c: $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id].e);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gopt
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zls
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $461bf5d8bd29e0d8$var$gopt = function(o) {
    return o && {
        out: o.size && new $461bf5d8bd29e0d8$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $461bf5d8bd29e0d8$var$adler();
        h.p(o.dictionary);
        $461bf5d8bd29e0d8$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $461bf5d8bd29e0d8$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $461bf5d8bd29e0d8$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $461bf5d8bd29e0d8$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $461bf5d8bd29e0d8$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $461bf5d8bd29e0d8$var$u8(32768);
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.s, this.o);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $461bf5d8bd29e0d8$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $461bf5d8bd29e0d8$var$u8(0);
            this.push(new $461bf5d8bd29e0d8$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) {
    var st = $461bf5d8bd29e0d8$var$gzs(data);
    if (st + 8 > data.length) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    return $461bf5d8bd29e0d8$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($461bf5d8bd29e0d8$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $461bf5d8bd29e0d8$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $461bf5d8bd29e0d8$var$err(8);
        return s;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
                o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, {
                            out: new $461bf5d8bd29e0d8$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $461bf5d8bd29e0d8$var$u8(su)
            });
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


var $15d064020a078dff$var$n = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $15d064020a078dff$var$i() {
    $15d064020a078dff$var$n.console && "function" == typeof $15d064020a078dff$var$n.console.log && $15d064020a078dff$var$n.console.log.apply($15d064020a078dff$var$n.console, arguments);
}
var $15d064020a078dff$var$a = {
    log: $15d064020a078dff$var$i,
    warn: function(t) {
        $15d064020a078dff$var$n.console && ("function" == typeof $15d064020a078dff$var$n.console.warn ? $15d064020a078dff$var$n.console.warn.apply($15d064020a078dff$var$n.console, arguments) : $15d064020a078dff$var$i.call(null, arguments));
    },
    error: function(t) {
        $15d064020a078dff$var$n.console && ("function" == typeof $15d064020a078dff$var$n.console.error ? $15d064020a078dff$var$n.console.error.apply($15d064020a078dff$var$n.console, arguments) : $15d064020a078dff$var$i(t));
    }
};
function $15d064020a078dff$var$o(t, e, r) {
    var n = new XMLHttpRequest;
    n.open("GET", t), n.responseType = "blob", n.onload = function() {
        $15d064020a078dff$var$l(n.response, e, r);
    }, n.onerror = function() {
        $15d064020a078dff$var$a.error("could not download file");
    }, n.send();
}
function $15d064020a078dff$var$s(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
}
function $15d064020a078dff$var$c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $15d064020a078dff$var$u, $15d064020a078dff$var$h, $15d064020a078dff$var$l = $15d064020a078dff$var$n.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(window)) || window !== $15d064020a078dff$var$n ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, r) {
    var i = $15d064020a078dff$var$n.URL || $15d064020a078dff$var$n.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? $15d064020a078dff$var$s(a.href) ? $15d064020a078dff$var$o(t, e, r) : $15d064020a078dff$var$c(a, a.target = "_blank") : $15d064020a078dff$var$c(a)) : (a.href = i.createObjectURL(t), setTimeout(function() {
        i.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        $15d064020a078dff$var$c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, r, n) {
    if (r = r || e.name || "download", "string" == typeof e) {
        if ($15d064020a078dff$var$s(e)) $15d064020a078dff$var$o(e, r, n);
        else {
            var i = document.createElement("a");
            i.href = e, i.target = "_blank", setTimeout(function() {
                $15d064020a078dff$var$c(i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, r) {
        return void 0 === r ? r = {
            autoBom: !1
        } : "object" !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r) && ($15d064020a078dff$var$a.warn("Deprecated: Expected third argument to be a object"), r = {
            autoBom: !r
        }), r.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, n), r);
} : function(e, r, i, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $15d064020a078dff$var$o(e, r, i);
    var s = "application/octet-stream" === e.type, c = /constructor/i.test($15d064020a078dff$var$n.HTMLElement) || $15d064020a078dff$var$n.safari, u = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((u || s && c) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(FileReader))) {
        var h = new FileReader;
        h.onloadend = function() {
            var t = h.result;
            t = u ? t : t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = t : location = t, a = null;
        }, h.readAsDataURL(e);
    } else {
        var l = $15d064020a078dff$var$n.URL || $15d064020a078dff$var$n.webkitURL, f = l.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            l.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $15d064020a078dff$var$f(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6));
    t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var r = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], n = 0; n < r.length; n++){
        var i = r[n].re, a = r[n].process, o = i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var t = this.r.toString(16), e = this.g.toString(16), r = this.b.toString(16);
        return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == r.length && (r = "0" + r), "#" + t + e + r;
    };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function $15d064020a078dff$var$d(t, e) {
    var r = t[0], n = t[1], i = t[2], a = t[3];
    r = $15d064020a078dff$var$g(r, n, i, a, e[0], 7, -680876936), a = $15d064020a078dff$var$g(a, r, n, i, e[1], 12, -389564586), i = $15d064020a078dff$var$g(i, a, r, n, e[2], 17, 606105819), n = $15d064020a078dff$var$g(n, i, a, r, e[3], 22, -1044525330), r = $15d064020a078dff$var$g(r, n, i, a, e[4], 7, -176418897), a = $15d064020a078dff$var$g(a, r, n, i, e[5], 12, 1200080426), i = $15d064020a078dff$var$g(i, a, r, n, e[6], 17, -1473231341), n = $15d064020a078dff$var$g(n, i, a, r, e[7], 22, -45705983), r = $15d064020a078dff$var$g(r, n, i, a, e[8], 7, 1770035416), a = $15d064020a078dff$var$g(a, r, n, i, e[9], 12, -1958414417), i = $15d064020a078dff$var$g(i, a, r, n, e[10], 17, -42063), n = $15d064020a078dff$var$g(n, i, a, r, e[11], 22, -1990404162), r = $15d064020a078dff$var$g(r, n, i, a, e[12], 7, 1804603682), a = $15d064020a078dff$var$g(a, r, n, i, e[13], 12, -40341101), i = $15d064020a078dff$var$g(i, a, r, n, e[14], 17, -1502002290), r = $15d064020a078dff$var$m(r, n = $15d064020a078dff$var$g(n, i, a, r, e[15], 22, 1236535329), i, a, e[1], 5, -165796510), a = $15d064020a078dff$var$m(a, r, n, i, e[6], 9, -1069501632), i = $15d064020a078dff$var$m(i, a, r, n, e[11], 14, 643717713), n = $15d064020a078dff$var$m(n, i, a, r, e[0], 20, -373897302), r = $15d064020a078dff$var$m(r, n, i, a, e[5], 5, -701558691), a = $15d064020a078dff$var$m(a, r, n, i, e[10], 9, 38016083), i = $15d064020a078dff$var$m(i, a, r, n, e[15], 14, -660478335), n = $15d064020a078dff$var$m(n, i, a, r, e[4], 20, -405537848), r = $15d064020a078dff$var$m(r, n, i, a, e[9], 5, 568446438), a = $15d064020a078dff$var$m(a, r, n, i, e[14], 9, -1019803690), i = $15d064020a078dff$var$m(i, a, r, n, e[3], 14, -187363961), n = $15d064020a078dff$var$m(n, i, a, r, e[8], 20, 1163531501), r = $15d064020a078dff$var$m(r, n, i, a, e[13], 5, -1444681467), a = $15d064020a078dff$var$m(a, r, n, i, e[2], 9, -51403784), i = $15d064020a078dff$var$m(i, a, r, n, e[7], 14, 1735328473), r = $15d064020a078dff$var$v(r, n = $15d064020a078dff$var$m(n, i, a, r, e[12], 20, -1926607734), i, a, e[5], 4, -378558), a = $15d064020a078dff$var$v(a, r, n, i, e[8], 11, -2022574463), i = $15d064020a078dff$var$v(i, a, r, n, e[11], 16, 1839030562), n = $15d064020a078dff$var$v(n, i, a, r, e[14], 23, -35309556), r = $15d064020a078dff$var$v(r, n, i, a, e[1], 4, -1530992060), a = $15d064020a078dff$var$v(a, r, n, i, e[4], 11, 1272893353), i = $15d064020a078dff$var$v(i, a, r, n, e[7], 16, -155497632), n = $15d064020a078dff$var$v(n, i, a, r, e[10], 23, -1094730640), r = $15d064020a078dff$var$v(r, n, i, a, e[13], 4, 681279174), a = $15d064020a078dff$var$v(a, r, n, i, e[0], 11, -358537222), i = $15d064020a078dff$var$v(i, a, r, n, e[3], 16, -722521979), n = $15d064020a078dff$var$v(n, i, a, r, e[6], 23, 76029189), r = $15d064020a078dff$var$v(r, n, i, a, e[9], 4, -640364487), a = $15d064020a078dff$var$v(a, r, n, i, e[12], 11, -421815835), i = $15d064020a078dff$var$v(i, a, r, n, e[15], 16, 530742520), r = $15d064020a078dff$var$b(r, n = $15d064020a078dff$var$v(n, i, a, r, e[2], 23, -995338651), i, a, e[0], 6, -198630844), a = $15d064020a078dff$var$b(a, r, n, i, e[7], 10, 1126891415), i = $15d064020a078dff$var$b(i, a, r, n, e[14], 15, -1416354905), n = $15d064020a078dff$var$b(n, i, a, r, e[5], 21, -57434055), r = $15d064020a078dff$var$b(r, n, i, a, e[12], 6, 1700485571), a = $15d064020a078dff$var$b(a, r, n, i, e[3], 10, -1894986606), i = $15d064020a078dff$var$b(i, a, r, n, e[10], 15, -1051523), n = $15d064020a078dff$var$b(n, i, a, r, e[1], 21, -2054922799), r = $15d064020a078dff$var$b(r, n, i, a, e[8], 6, 1873313359), a = $15d064020a078dff$var$b(a, r, n, i, e[15], 10, -30611744), i = $15d064020a078dff$var$b(i, a, r, n, e[6], 15, -1560198380), n = $15d064020a078dff$var$b(n, i, a, r, e[13], 21, 1309151649), r = $15d064020a078dff$var$b(r, n, i, a, e[4], 6, -145523070), a = $15d064020a078dff$var$b(a, r, n, i, e[11], 10, -1120210379), i = $15d064020a078dff$var$b(i, a, r, n, e[2], 15, 718787259), n = $15d064020a078dff$var$b(n, i, a, r, e[9], 21, -343485551), t[0] = $15d064020a078dff$var$_(r, t[0]), t[1] = $15d064020a078dff$var$_(n, t[1]), t[2] = $15d064020a078dff$var$_(i, t[2]), t[3] = $15d064020a078dff$var$_(a, t[3]);
}
function $15d064020a078dff$var$p(t, e, r, n, i, a) {
    return e = $15d064020a078dff$var$_($15d064020a078dff$var$_(e, t), $15d064020a078dff$var$_(n, a)), $15d064020a078dff$var$_(e << i | e >>> 32 - i, r);
}
function $15d064020a078dff$var$g(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(e & r | ~e & n, t, e, i, a, o);
}
function $15d064020a078dff$var$m(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(e & n | r & ~n, t, e, i, a, o);
}
function $15d064020a078dff$var$v(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(e ^ r ^ n, t, e, i, a, o);
}
function $15d064020a078dff$var$b(t, e, r, n, i, a, o) {
    return $15d064020a078dff$var$p(r ^ (e | ~n), t, e, i, a, o);
}
function $15d064020a078dff$var$y(t) {
    var e, r = t.length, n = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)$15d064020a078dff$var$d(n, $15d064020a078dff$var$w(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for($15d064020a078dff$var$d(n, i), e = 0; e < 16; e++)i[e] = 0;
    return i[14] = 8 * r, $15d064020a078dff$var$d(n, i), n;
}
function $15d064020a078dff$var$w(t) {
    var e, r = [];
    for(e = 0; e < 64; e += 4)r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return r;
}
$15d064020a078dff$var$u = $15d064020a078dff$var$n.atob.bind($15d064020a078dff$var$n), $15d064020a078dff$var$h = $15d064020a078dff$var$n.btoa.bind($15d064020a078dff$var$n);
var $15d064020a078dff$var$N = "0123456789abcdef".split("");
function $15d064020a078dff$var$L(t) {
    for(var e = "", r = 0; r < 4; r++)e += $15d064020a078dff$var$N[t >> 8 * r + 4 & 15] + $15d064020a078dff$var$N[t >> 8 * r & 15];
    return e;
}
function $15d064020a078dff$var$A(t) {
    return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function $15d064020a078dff$var$x(t) {
    return $15d064020a078dff$var$y(t).map($15d064020a078dff$var$A).join("");
}
var $15d064020a078dff$var$S = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = $15d064020a078dff$var$L(t[e]);
    return t.join("");
}($15d064020a078dff$var$y("hello"));
function $15d064020a078dff$var$_(t, e) {
    if ($15d064020a078dff$var$S) {
        var r = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function $15d064020a078dff$var$P(t, e) {
    var r, n, i, a;
    if (t !== r) {
        for(var o = (i = t, a = 1 + (256 / t.length >> 0), new Array(a + 1).join(i)), s = [], c = 0; c < 256; c++)s[c] = c;
        var u = 0;
        for(c = 0; c < 256; c++){
            var h = s[c];
            u = (u + h + o.charCodeAt(c)) % 256, s[c] = s[u], s[u] = h;
        }
        r = t, n = s;
    } else s = n;
    var l = e.length, f = 0, d = 0, p = "";
    for(c = 0; c < l; c++)d = (d + (h = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = h, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(c) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var $15d064020a078dff$var$k = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function $15d064020a078dff$var$I(t, e, r, n) {
    this.v = 1, this.r = 2;
    var i = 192;
    t.forEach(function(t) {
        if (void 0 !== $15d064020a078dff$var$k.perm) throw new Error("Invalid permission: " + t);
        i += $15d064020a078dff$var$k[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\0NV\xff\xfa\x01\b..\0\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (r + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = $15d064020a078dff$var$x(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = $15d064020a078dff$var$P(this.encryptionKey, this.padding);
}
function $15d064020a078dff$var$F(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", r = t.length, n = 0; n < r; n++){
        var i = t.charCodeAt(n);
        if (i < 33 || 35 === i || 37 === i || 40 === i || 41 === i || 47 === i || 60 === i || 62 === i || 91 === i || 93 === i || 123 === i || 125 === i || i > 126) e += "#" + ("0" + i.toString(16)).slice(-2);
        else e += t[n];
    }
    return e;
}
function $15d064020a078dff$var$C(e) {
    if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r = {};
    this.subscribe = function(t, e, n) {
        if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        r.hasOwnProperty(t) || (r[t] = {});
        var i = Math.random().toString(35);
        return r[t][i] = [
            e,
            !!n
        ], i;
    }, this.unsubscribe = function(t) {
        for(var e in r)if (r[e][t]) return delete r[e][t], 0 === Object.keys(r[e]).length && delete r[e], !0;
        return !1;
    }, this.publish = function(t) {
        if (r.hasOwnProperty(t)) {
            var i = Array.prototype.slice.call(arguments, 1), o = [];
            for(var s in r[t]){
                var c = r[t][s];
                try {
                    c[0].apply(e, i);
                } catch (t) {
                    $15d064020a078dff$var$n.console && $15d064020a078dff$var$a.error("jsPDF PubSub Error", t.message, t);
                }
                c[1] && o.push(s);
            }
            o.length && o.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return r;
    };
}
function $15d064020a078dff$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $15d064020a078dff$export$1bc649ab427a02ba)) return new $15d064020a078dff$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var r in t)t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    this.id = "", this.objectNumber = -1;
}
function $15d064020a078dff$var$O(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $15d064020a078dff$export$7235f0ad083cb4c6(t, e, r, n, i) {
    if (!(this instanceof $15d064020a078dff$export$7235f0ad083cb4c6)) return new $15d064020a078dff$export$7235f0ad083cb4c6(t, e, r, n, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = r, $15d064020a078dff$var$O.call(this, n, i);
}
function $15d064020a078dff$export$549f717800d2b57f(t, e, r, n, i) {
    if (!(this instanceof $15d064020a078dff$export$549f717800d2b57f)) return new $15d064020a078dff$export$549f717800d2b57f(t, e, r, n, i);
    this.boundingBox = t, this.xStep = e, this.yStep = r, this.stream = "", this.cloneIndex = 0, $15d064020a078dff$var$O.call(this, n, i);
}
function $15d064020a078dff$export$ba1e2ffc633a60f5(e) {
    var r, i = "string" == typeof arguments[0] ? arguments[0] : "p", o = arguments[1], s = arguments[2], c = arguments[3], u = [], d = 1, p = 16, g = "S", m = null;
    "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e = e || {}) && (i = e.orientation, o = e.unit || o, s = e.format || s, c = e.compress || e.compressPdf || c, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), d = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (r = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), u = e.filters || (!0 === c ? [
        "FlateEncode"
    ] : u), o = o || "mm", i = ("" + (i || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, y = {
        internal: {},
        __private__: {}
    };
    y.__private__.PubSub = $15d064020a078dff$var$C;
    var w = "1.3", N = y.__private__.getPdfVersion = function() {
        return w;
    };
    y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    y.__private__.getPageFormats = function() {
        return L;
    };
    var A = y.__private__.getPageFormat = function(t) {
        return L[t];
    };
    s = s || "a4";
    var x = {
        COMPAT: "compat",
        ADVANCED: "advanced"
    }, S = x.COMPAT;
    function _() {
        this.saveGraphicsState(), lt(new Vt(_t, 0, 0, -_t, 0, Rr() * _t).toString() + " cm"), this.setFontSize(this.getFontSize() / _t), g = "n", S = x.ADVANCED;
    }
    function P() {
        this.restoreGraphicsState(), g = "S", S = x.COMPAT;
    }
    var k = y.__private__.combineFontStyleAndFontWeight = function(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    y.advancedAPI = function(t) {
        var e = S === x.COMPAT;
        return e && _.call(this), "function" != typeof t || (t(this), e && P.call(this)), this;
    }, y.compatAPI = function(t) {
        var e = S === x.ADVANCED;
        return e && P.call(this), "function" != typeof t || (t(this), e && _.call(this)), this;
    }, y.isAdvancedAPI = function() {
        return S === x.ADVANCED;
    };
    var O, q = function(t) {
        if (S !== x.ADVANCED) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = y.roundToPrecision = y.__private__.roundToPrecision = function(t, e) {
        var n = r || e;
        if (isNaN(t) || isNaN(n)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(n).replace(/0+$/, "");
    };
    O = y.hpf = y.__private__.hpf = "number" == typeof p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var R = y.f2 = y.__private__.f2 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, T = y.__private__.f3 = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = y.scale = y.__private__.scale = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return S === x.COMPAT ? t * _t : S === x.ADVANCED ? t : void 0;
    }, z = function(t) {
        return S === x.COMPAT ? Rr() - t : S === x.ADVANCED ? t : void 0;
    }, H = function(t) {
        return U(z(t));
    };
    y.__private__.setPrecision = y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = y.__private__.getFileId = function() {
        return V;
    }, Y = y.__private__.setFileId = function(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (Ye = new $15d064020a078dff$var$I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    y.setFileId = function(t) {
        return Y(t), this;
    }, y.getFileId = function() {
        return G();
    };
    var J = y.__private__.convertDateToPDFDate = function(t) {
        var e = t.getTimezoneOffset(), r = e < 0 ? "+" : "-", n = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), a = [
            r,
            Q(n),
            "'",
            Q(i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = y.__private__.convertPDFDateToDate = function(t) {
        var e = parseInt(t.substr(2, 4), 10), r = parseInt(t.substr(6, 2), 10) - 1, n = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(e, r, n, i, a, o, 0);
    }, K = y.__private__.setCreationDate = function(t) {
        var e;
        if (void 0 === t && (t = new Date), t instanceof Date) e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            e = t;
        }
        return W = e;
    }, Z = y.__private__.getCreationDate = function(t) {
        var e = W;
        return "jsDate" === t && (e = X(W)), e;
    };
    y.setCreationDate = function(t) {
        return K(t), this;
    }, y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = y.__private__.padd2 = function(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = y.__private__.padd2Hex = function(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, rt = [], nt = [], it = 0, at = [], ot = [], st = !1, ct = nt, ut = function() {
        et = 0, it = 0, nt = [], rt = [], at = [], Qt = Kt(), te = Kt();
    };
    y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ct = t;
    };
    var ht = function(t) {
        st || (ct = t);
    };
    y.__private__.resetCustomOutputDestination = function() {
        st = !1, ct = nt;
    };
    var lt = y.__private__.out = function(t) {
        return t = t.toString(), it += t.length + 1, ct.push(t), ct;
    }, ft = y.__private__.write = function(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, dt = y.__private__.getArrayBuffer = function(t) {
        for(var e = t.length, r = new ArrayBuffer(e), n = new Uint8Array(r); e--;)n[e] = t.charCodeAt(e);
        return r;
    }, pt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    y.__private__.getStandardFonts = function() {
        return pt;
    };
    var gt = e.fontSize || 16;
    y.__private__.setFontSize = y.setFontSize = function(t) {
        return gt = S === x.ADVANCED ? t / _t : t, this;
    };
    var mt, vt = y.__private__.getFontSize = y.getFontSize = function() {
        return S === x.COMPAT ? gt : gt * _t;
    }, bt = e.R2L || !1;
    y.__private__.setR2L = y.setR2L = function(t) {
        return bt = t, this;
    }, y.__private__.getR2L = y.getR2L = function() {
        return bt;
    };
    var yt, wt = y.__private__.setZoomMode = function(t) {
        var e = [
            void 0,
            null,
            "fullwidth",
            "fullheight",
            "fullpage",
            "original"
        ];
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) mt = t;
        else if (isNaN(t)) {
            if (-1 === e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            mt = t;
        } else mt = parseInt(t, 10);
    };
    y.__private__.getZoomMode = function() {
        return mt;
    };
    var Nt, Lt = y.__private__.setPageMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        yt = t;
    };
    y.__private__.getPageMode = function() {
        return yt;
    };
    var At = y.__private__.setLayoutMode = function(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        Nt = t;
    };
    y.__private__.getLayoutMode = function() {
        return Nt;
    }, y.__private__.setDisplayMode = y.setDisplayMode = function(t, e, r) {
        return wt(t), At(e), Lt(r), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, y.__private__.getDocumentProperties = function() {
        return xt;
    }, y.__private__.setDocumentProperties = y.setProperties = y.setDocumentProperties = function(t) {
        for(var e in xt)xt.hasOwnProperty(e) && t[e] && (xt[e] = t[e]);
        return this;
    }, y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var St, _t, Pt, kt, It, Ft = {}, Ct = {}, jt = [], Ot = {}, Bt = {}, Mt = {}, Et = {}, qt = null, Dt = 0, Rt = [], Tt = new $15d064020a078dff$var$C(y), Ut = e.hotfixes || [], zt = {}, Ht = {}, Wt = [], Vt = function t(e, r, n, i, a, o) {
        if (!(this instanceof t)) return new t(e, r, n, i, a, o);
        isNaN(e) && (e = 1), isNaN(r) && (r = 0), isNaN(n) && (n = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            r,
            n,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Vt.prototype, "sx", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shy", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shx", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "sy", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "tx", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "ty", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "a", {
        get: function() {
            return this._matrix[0];
        },
        set: function(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "b", {
        get: function() {
            return this._matrix[1];
        },
        set: function(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "c", {
        get: function() {
            return this._matrix[2];
        },
        set: function(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "d", {
        get: function() {
            return this._matrix[3];
        },
        set: function(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "e", {
        get: function() {
            return this._matrix[4];
        },
        set: function(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "f", {
        get: function() {
            return this._matrix[5];
        },
        set: function(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "rotation", {
        get: function() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Vt.prototype, "scaleX", {
        get: function() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Vt.prototype, "scaleY", {
        get: function() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Vt.prototype, "isIdentity", {
        get: function() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Vt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(O).join(t);
    }, Vt.prototype.multiply = function(t) {
        var e = t.sx * this.sx + t.shy * this.shx, r = t.sx * this.shy + t.shy * this.sy, n = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Vt(e, r, n, i, a, o);
    }, Vt.prototype.decompose = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(t * t + e * e), s = (t /= o) * r + (e /= o) * n;
        r -= t * s, n -= e * s;
        var c = Math.sqrt(r * r + n * n);
        return s /= c, t * (n /= c) < e * (r /= c) && (t = -t, e = -e, s = -s, o = -o), {
            scale: new Vt(o, 0, 0, c, 0, 0),
            translate: new Vt(1, 0, 0, 1, i, a),
            rotate: new Vt(t, e, -e, t, 0, 0),
            skew: new Vt(1, 0, s, 1, 0, 0)
        };
    }, Vt.prototype.toString = function(t) {
        return this.join(" ");
    }, Vt.prototype.inversed = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty, o = 1 / (t * n - e * r), s = n * o, c = -e * o, u = -r * o, h = t * o;
        return new Vt(s, c, u, h, -s * i - u * a, -c * i - h * a);
    }, Vt.prototype.applyToPoint = function(t) {
        var e = t.x * this.sx + t.y * this.shx + this.tx, r = t.x * this.shy + t.y * this.sy + this.ty;
        return new Cr(e, r);
    }, Vt.prototype.applyToRectangle = function(t) {
        var e = this.applyToPoint(t), r = this.applyToPoint(new Cr(t.x + t.w, t.y + t.h));
        return new jr(e.x, e.y, r.x - e.x, r.y - e.y);
    }, Vt.prototype.clone = function() {
        var t = this.sx, e = this.shy, r = this.shx, n = this.sy, i = this.tx, a = this.ty;
        return new Vt(t, e, r, n, i, a);
    }, y.Matrix = Vt;
    var Gt = y.matrixMult = function(t, e) {
        return e.multiply(t);
    }, Yt = new Vt(1, 0, 0, 1, 0, 0);
    y.unitMatrix = y.identityMatrix = Yt;
    var Jt = function(t, e) {
        if (!Bt[t]) {
            var r = (e instanceof $15d064020a078dff$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(Ot).length + 1).toString(10);
            e.id = r, Bt[t] = r, Ot[r] = e, Tt.publish("addPattern", e);
        }
    };
    y.ShadingPattern = $15d064020a078dff$export$7235f0ad083cb4c6, y.TilingPattern = $15d064020a078dff$export$549f717800d2b57f, y.addShadingPattern = function(t, e) {
        return q("addShadingPattern()"), Jt(t, e), this;
    }, y.beginTilingPattern = function(t) {
        q("beginTilingPattern()"), Br(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, y.endTilingPattern = function(t, e) {
        q("endTilingPattern()"), e.stream = ot[$].join("\n"), Jt(t, e), Tt.publish("endTilingPattern", e), Wt.pop().restore();
    };
    var Xt = y.__private__.newObject = function() {
        var t = Kt();
        return Zt(t, !0), t;
    }, Kt = y.__private__.newObjectDeferred = function() {
        return et++, rt[et] = function() {
            return it;
        }, et;
    }, Zt = function(t, e) {
        return e = "boolean" == typeof e && e, rt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = y.__private__.newAdditionalObject = function() {
        var t = {
            objId: Kt(),
            content: ""
        };
        return at.push(t), t;
    }, Qt = Kt(), te = Kt(), ee = y.__private__.decodeColorString = function(t) {
        var e = t.split(" ");
        if (2 !== e.length || "g" !== e[1] && "G" !== e[1]) {
            if (5 === e.length && ("k" === e[4] || "K" === e[4])) e = [
                (1 - e[0]) * (1 - e[3]),
                (1 - e[1]) * (1 - e[3]),
                (1 - e[2]) * (1 - e[3]),
                "r"
            ];
        } else {
            var r = parseFloat(e[0]);
            e = [
                r,
                r,
                r,
                "r"
            ];
        }
        for(var n = "#", i = 0; i < 3; i++)n += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
        return n;
    }, re = y.__private__.encodeColorString = function(e) {
        var r;
        "string" == typeof e && (e = {
            ch1: e
        });
        var n = e.ch1, i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
            var c = new $15d064020a078dff$var$f(n);
            if (c.ok) n = c.toHex();
            else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
            var u = parseInt(n.substr(1), 16);
            n = u >> 16 & 255, i = u >> 8 & 255, a = 255 & u;
        }
        if (void 0 === i || void 0 === o && n === i && i === a) {
            if ("string" == typeof n) r = n + " " + s[0];
            else switch(e.precision){
                case 2:
                    r = R(n / 255) + " " + s[0];
                    break;
                case 3:
                default:
                    r = T(n / 255) + " " + s[0];
            }
        } else if (void 0 === o || "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return r = [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            if ("string" == typeof n) r = [
                n,
                i,
                a,
                s[1]
            ].join(" ");
            else switch(e.precision){
                case 2:
                    r = [
                        R(n / 255),
                        R(i / 255),
                        R(a / 255),
                        s[1]
                    ].join(" ");
                    break;
                default:
                case 3:
                    r = [
                        T(n / 255),
                        T(i / 255),
                        T(a / 255),
                        s[1]
                    ].join(" ");
            }
        } else if ("string" == typeof n) r = [
            n,
            i,
            a,
            o,
            s[2]
        ].join(" ");
        else switch(e.precision){
            case 2:
                r = [
                    R(n),
                    R(i),
                    R(a),
                    R(o),
                    s[2]
                ].join(" ");
                break;
            case 3:
            default:
                r = [
                    T(n),
                    T(i),
                    T(a),
                    T(o),
                    s[2]
                ].join(" ");
        }
        return r;
    }, ne = y.__private__.getFilters = function() {
        return u;
    }, ie = y.__private__.putStream = function(t) {
        var e = (t = t || {}).data || "", r = t.filters || ne(), n = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, a = e.length, o = t.objectId, s = function(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = Ye.encryptor(o, 0));
        var c = {};
        !0 === r && (r = [
            "FlateEncode"
        ]);
        var u = t.additionalKeyValues || [], h = (c = void 0 !== $15d064020a078dff$export$ba1e2ffc633a60f5.API.processDataByFilters ? $15d064020a078dff$export$ba1e2ffc633a60f5.API.processDataByFilters(e, r) : {
            data: e,
            reverseChain: []
        }).reverseChain + (Array.isArray(n) ? n.join(" ") : n.toString());
        if (0 !== c.data.length && (u.push({
            key: "Length",
            value: c.data.length
        }), !0 === i && u.push({
            key: "Length1",
            value: a
        })), 0 != h.length) {
            if (h.split("/").length - 1 == 1) u.push({
                key: "Filter",
                value: h
            });
            else {
                u.push({
                    key: "Filter",
                    value: "[" + h + "]"
                });
                for(var l = 0; l < u.length; l += 1)if ("DecodeParms" === u[l].key) {
                    for(var f = [], d = 0; d < c.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(u[l].value), u[l].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < u.length; p++)lt("/" + u[p].key + " " + u[p].value);
        lt(">>"), 0 !== c.data.length && (lt("stream"), lt(s(c.data)), lt("endstream"));
    }, ae = y.__private__.putPage = function(t) {
        var e = t.number, r = t.data, n = t.objId, i = t.contentsObjId;
        Zt(n, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(O(t.mediaBox.bottomLeftX)) + " " + parseFloat(O(t.mediaBox.bottomLeftY)) + " " + O(t.mediaBox.topRightX) + " " + O(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + O(t.cropBox.bottomLeftX) + " " + O(t.cropBox.bottomLeftY) + " " + O(t.cropBox.topRightX) + " " + O(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + O(t.bleedBox.bottomLeftX) + " " + O(t.bleedBox.bottomLeftY) + " " + O(t.bleedBox.topRightX) + " " + O(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + O(t.trimBox.bottomLeftX) + " " + O(t.trimBox.bottomLeftY) + " " + O(t.trimBox.topRightX) + " " + O(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + O(t.artBox.bottomLeftX) + " " + O(t.artBox.bottomLeftY) + " " + O(t.artBox.topRightX) + " " + O(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Tt.publish("putPage", {
            objId: n,
            pageContext: Rt[e],
            pageNumber: e,
            page: r
        }), lt("/Contents " + i + " 0 R"), lt(">>"), lt("endobj");
        var a = r.join("\n");
        return S === x.ADVANCED && (a += "\nQ"), Zt(i, !0), ie({
            data: a,
            filters: ne(),
            objectId: i
        }), lt("endobj"), n;
    }, oe = y.__private__.putPages = function() {
        var t, e, r = [];
        for(t = 1; t <= Dt; t++)Rt[t].objId = Kt(), Rt[t].contentsObjId = Kt();
        for(t = 1; t <= Dt; t++)r.push(ae({
            number: t,
            data: ot[t],
            objId: Rt[t].objId,
            contentsObjId: Rt[t].contentsObjId,
            mediaBox: Rt[t].mediaBox,
            cropBox: Rt[t].cropBox,
            bleedBox: Rt[t].bleedBox,
            trimBox: Rt[t].trimBox,
            artBox: Rt[t].artBox,
            userUnit: Rt[t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var n = "/Kids [";
        for(e = 0; e < Dt; e++)n += r[e] + " 0 R ";
        lt(n + "]"), lt("/Count " + Dt), lt(">>"), lt("endobj"), Tt.publish("postPutPages");
    }, se = function(t) {
        Tt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + $15d064020a078dff$var$F(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ce = function() {
        for(var t in Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && se(Ft[t]);
    }, ue = function(t) {
        t.objectNumber = Xt();
        var e = [];
        e.push({
            key: "Type",
            value: "/XObject"
        }), e.push({
            key: "Subtype",
            value: "/Form"
        }), e.push({
            key: "BBox",
            value: "[" + [
                O(t.x),
                O(t.y),
                O(t.x + t.width),
                O(t.y + t.height)
            ].join(" ") + "]"
        }), e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var r = t.pages[1].join("\n");
        ie({
            data: r,
            additionalKeyValues: e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function() {
        for(var t in zt)zt.hasOwnProperty(t) && ue(zt[t]);
    }, le = function(t, e) {
        var r, n = [], i = 1 / (e - 1);
        for(r = 0; r < 1; r += i)n.push(r);
        if (n.push(1), 0 != t[0].offset) {
            var a = {
                offset: 0,
                color: t[0].color
            };
            t.unshift(a);
        }
        if (1 != t[t.length - 1].offset) {
            var o = {
                offset: 1,
                color: t[t.length - 1].color
            };
            t.push(o);
        }
        for(var s = "", c = 0, u = 0; u < n.length; u++){
            for(r = n[u]; r > t[c + 1].offset;)c++;
            var h = t[c].offset, l = (r - h) / (t[c + 1].offset - h), f = t[c].color, d = t[c + 1].color;
            s += tt(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) + tt(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) + tt(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
        }
        return s.trim();
    }, fe = function(t, e) {
        e || (e = 21);
        var r = Xt(), n = le(t.colors, e), i = [];
        i.push({
            key: "FunctionType",
            value: "0"
        }), i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), i.push({
            key: "Size",
            value: "[" + e + "]"
        }), i.push({
            key: "BitsPerSample",
            value: "8"
        }), i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: n,
            additionalKeyValues: i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: r
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + O(parseFloat(t.coords[0])) + " " + O(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) : a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) + " " + O(parseFloat(t.coords[4])) + " " + O(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + r + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, de = function(t, e) {
        var r = Kt(), n = Xt();
        e.push({
            resourcesOid: r,
            objectOid: n
        }), t.objectNumber = n;
        var i = [];
        i.push({
            key: "Type",
            value: "/Pattern"
        }), i.push({
            key: "PatternType",
            value: "1"
        }), i.push({
            key: "PaintType",
            value: "1"
        }), i.push({
            key: "TilingType",
            value: "1"
        }), i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(O).join(" ") + "]"
        }), i.push({
            key: "XStep",
            value: O(t.xStep)
        }), i.push({
            key: "YStep",
            value: O(t.yStep)
        }), i.push({
            key: "Resources",
            value: r + " 0 R"
        }), t.matrix && i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, pe = function(t) {
        var e;
        for(e in Ot)Ot.hasOwnProperty(e) && (Ot[e] instanceof $15d064020a078dff$export$7235f0ad083cb4c6 ? fe(Ot[e]) : Ot[e] instanceof $15d064020a078dff$export$549f717800d2b57f && de(Ot[e], t));
    }, ge = function(t) {
        for(var e in t.objectNumber = Xt(), lt("<<"), t)switch(e){
            case "opacity":
                lt("/ca " + R(t[e]));
                break;
            case "stroke-opacity":
                lt("/CA " + R(t[e]));
        }
        lt(">>"), lt("endobj");
    }, me = function() {
        var t;
        for(t in Mt)Mt.hasOwnProperty(t) && ge(Mt[t]);
    }, ve = function() {
        for(var t in lt("/XObject <<"), zt)zt.hasOwnProperty(t) && zt[t].objectNumber >= 0 && lt("/" + t + " " + zt[t].objectNumber + " 0 R");
        Tt.publish("putXobjectDict"), lt(">>");
    }, be = function() {
        Ye.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + Ye.v), lt("/R " + Ye.r), lt("/U <" + Ye.toHexString(Ye.U) + ">"), lt("/O <" + Ye.toHexString(Ye.O) + ">"), lt("/P " + Ye.P), lt(">>"), lt("endobj");
    }, ye = function() {
        for(var t in lt("/Font <<"), Ft)Ft.hasOwnProperty(t) && (!1 === v || !0 === v && b.hasOwnProperty(t)) && lt("/" + t + " " + Ft[t].objectNumber + " 0 R");
        lt(">>");
    }, we = function() {
        if (Object.keys(Ot).length > 0) {
            for(var t in lt("/Shading <<"), Ot)Ot.hasOwnProperty(t) && Ot[t] instanceof $15d064020a078dff$export$7235f0ad083cb4c6 && Ot[t].objectNumber >= 0 && lt("/" + t + " " + Ot[t].objectNumber + " 0 R");
            Tt.publish("putShadingPatternDict"), lt(">>");
        }
    }, Ne = function(t) {
        if (Object.keys(Ot).length > 0) {
            for(var e in lt("/Pattern <<"), Ot)Ot.hasOwnProperty(e) && Ot[e] instanceof y.TilingPattern && Ot[e].objectNumber >= 0 && Ot[e].objectNumber < t && lt("/" + e + " " + Ot[e].objectNumber + " 0 R");
            Tt.publish("putTilingPatternDict"), lt(">>");
        }
    }, Le = function() {
        if (Object.keys(Mt).length > 0) {
            var t;
            for(t in lt("/ExtGState <<"), Mt)Mt.hasOwnProperty(t) && Mt[t].objectNumber >= 0 && lt("/" + t + " " + Mt[t].objectNumber + " 0 R");
            Tt.publish("putGStateDict"), lt(">>");
        }
    }, Ae = function(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ye(), we(), Ne(t.objectOid), Le(), ve(), lt(">>"), lt("endobj");
    }, xe = function() {
        var t = [];
        ce(), me(), he(), pe(t), Tt.publish("putResources"), t.forEach(Ae), Ae({
            resourcesOid: te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Tt.publish("postPutResources");
    }, Se = function() {
        Tt.publish("putAdditionalObjects");
        for(var t = 0; t < at.length; t++){
            var e = at[t];
            Zt(e.objId, !0), lt(e.content), lt("endobj");
        }
        Tt.publish("postPutAdditionalObjects");
    }, _e = function(t) {
        Ct[t.fontName] = Ct[t.fontName] || {}, Ct[t.fontName][t.fontStyle] = t.id;
    }, Pe = function(t, e, r, n, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: r,
            encoding: n,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Tt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, _e(a), a.id;
    }, ke = function(t) {
        for(var e = 0, r = pt.length; e < r; e++){
            var n = Pe.call(this, t[e][0], t[e][1], t[e][2], pt[e][3], !0);
            !1 === v && (b[n] = !0);
            var i = t[e][0].split("-");
            _e({
                id: n,
                fontName: i[0],
                fontStyle: i[1] || ""
            });
        }
        Tt.publish("addFonts", {
            fonts: Ft,
            dictionary: Ct
        });
    }, Ie = function(t) {
        return t.foo = function() {
            try {
                return t.apply(this, arguments);
            } catch (t) {
                var e = t.stack || "";
                ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                var r = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                if (!$15d064020a078dff$var$n.console) throw new Error(r);
                $15d064020a078dff$var$n.console.error(r, t), $15d064020a078dff$var$n.alert && alert(r);
            }
        }, t.foo.bar = t, t.foo;
    }, Fe = function(t, e) {
        var r, n, i, a, o, s, c, u, h;
        if (i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[St].metadata && Ft[St].metadata[i] && Ft[St].metadata[i].encoding && (a = Ft[St].metadata[i].encoding, !o && Ft[St].encoding && (o = Ft[St].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
            for(c = !1, s = [], r = 0, n = t.length; r < n; r++)(u = o[t.charCodeAt(r)]) ? s.push(String.fromCharCode(u)) : s.push(t[r]), s[r].charCodeAt(0) >> 8 && (c = !0);
            t = s.join("");
        }
        for(r = t.length; void 0 === c && 0 !== r;)t.charCodeAt(r - 1) >> 8 && (c = !0), r--;
        if (!c) return t;
        for(s = e.noBOM ? [] : [
            254,
            255
        ], r = 0, n = t.length; r < n; r++){
            if ((h = (u = t.charCodeAt(r)) >> 8) >> 8) throw new Error("Character at position " + r + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
            s.push(h), s.push(u - (h << 8));
        }
        return String.fromCharCode.apply(void 0, s);
    }, Ce = y.__private__.pdfEscape = y.pdfEscape = function(t, e) {
        return Fe(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, je = y.__private__.beginPage = function(t) {
        ot[++Dt] = [], Rt[Dt] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(d),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, Me(Dt), ht(ot[$]);
    }, Oe = function(t, e) {
        var r, n, o;
        switch(i = e || i, "string" == typeof t && (r = A(t.toLowerCase()), Array.isArray(r) && (n = r[0], o = r[1])), Array.isArray(t) && (n = t[0] * _t, o = t[1] * _t), isNaN(n) && (n = s[0], o = s[1]), (n > 14400 || o > 14400) && ($15d064020a078dff$var$a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), n = Math.min(14400, n), o = Math.min(14400, o)), s = [
            n,
            o
        ], i.substr(0, 1)){
            case "l":
                o > n && (s = [
                    o,
                    n
                ]);
                break;
            case "p":
                n > o && (s = [
                    o,
                    n
                ]);
        }
        je(s), pr(fr), lt(Lr), 0 !== kr && lt(kr + " J"), 0 !== Ir && lt(Ir + " j"), Tt.publish("addPage", {
            pageNumber: Dt
        });
    }, Be = function(t) {
        t > 0 && t <= Dt && (ot.splice(t, 1), Rt.splice(t, 1), Dt--, $ > Dt && ($ = Dt), this.setPage($));
    }, Me = function(t) {
        t > 0 && t <= Dt && ($ = t);
    }, Ee = y.__private__.getNumberOfPages = y.getNumberOfPages = function() {
        return ot.length - 1;
    }, qe = function(t, e, r) {
        var n, i = void 0;
        return r = r || {}, t = void 0 !== t ? t : Ft[St].fontName, e = void 0 !== e ? e : Ft[St].fontStyle, n = t.toLowerCase(), void 0 !== Ct[n] && void 0 !== Ct[n][e] ? i = Ct[n][e] : void 0 !== Ct[t] && void 0 !== Ct[t][e] ? i = Ct[t][e] : !1 === r.disableWarning && $15d064020a078dff$var$a.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || r.noFallback || null == (i = Ct.times[e]) && (i = Ct.times.normal), i;
    }, De = y.__private__.putInfo = function() {
        var t = Xt(), e = function(t) {
            return t;
        };
        for(var r in null !== m && (e = Ye.encryptor(t, 0)), lt("<<"), lt("/Producer (" + Ce(e("jsPDF " + $15d064020a078dff$export$ba1e2ffc633a60f5.version)) + ")"), xt)xt.hasOwnProperty(r) && xt[r] && lt("/" + r.substr(0, 1).toUpperCase() + r.substr(1) + " (" + Ce(e(xt[r])) + ")");
        lt("/CreationDate (" + Ce(e(W)) + ")"), lt(">>"), lt("endobj");
    }, Re = y.__private__.putCatalog = function(t) {
        var e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + e + " 0 R"), mt || (mt = "fullwidth"), mt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var r = "" + mt;
                "%" === r.substr(r.length - 1) && (mt = parseInt(mt) / 100), "number" == typeof mt && lt("/OpenAction [3 0 R /XYZ null null " + R(mt) + "]");
        }
        switch(Nt || (Nt = "continuous"), Nt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        yt && lt("/PageMode /" + yt), Tt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Te = y.__private__.putTrailer = function() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + Ye.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Ue = y.__private__.putHeader = function() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, ze = y.__private__.putXRef = function() {
        var t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var e = 1; e <= et; e++)"function" == typeof rt[e] ? lt((t + rt[e]()).slice(-10) + " 00000 n ") : void 0 !== rt[e] ? lt((t + rt[e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, He = y.__private__.buildDocument = function() {
        ut(), ht(nt), Tt.publish("buildDocument"), Ue(), oe(), Se(), xe(), null !== m && be(), De(), Re();
        var t = it;
        return ze(), Te(), lt("startxref"), lt("" + t), lt("%%EOF"), ht(ot[$]), nt.join("\n");
    }, We = y.__private__.getBlob = function(t) {
        return new Blob([
            dt(t)
        ], {
            type: "application/pdf"
        });
    }, Ve = y.output = y.__private__.output = Ie(function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return He();
            case "save":
                y.save(e.filename);
                break;
            case "arraybuffer":
                return dt(He());
            case "blob":
                return We(He());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $15d064020a078dff$var$n.URL && "function" == typeof $15d064020a078dff$var$n.URL.createObjectURL) return $15d064020a078dff$var$n.URL && $15d064020a078dff$var$n.URL.createObjectURL(We(He())) || void 0;
                $15d064020a078dff$var$a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var r = "", i = He();
                try {
                    r = $15d064020a078dff$var$h(i);
                } catch (t) {
                    r = $15d064020a078dff$var$h(unescape(encodeURIComponent(i)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + r;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($15d064020a078dff$var$n)) {
                    var o = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (o = e.pdfObjectUrl, s = "");
                    var c = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + o + '"' + s + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");<\/script></body></html>", u = $15d064020a078dff$var$n.open();
                    return null !== u && u.document.write(c), u;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($15d064020a078dff$var$n)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', f = $15d064020a078dff$var$n.open();
                    if (null !== f) {
                        f.document.write(l);
                        var d = this;
                        f.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            f.document.title = e.filename, f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"));
                        };
                    }
                    return f;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($15d064020a078dff$var$n)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = $15d064020a078dff$var$n.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return $15d064020a078dff$var$n.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }), Ge = function(t) {
        return !0 === Array.isArray(Ut) && Ut.indexOf(t) > -1;
    };
    switch(o){
        case "pt":
            _t = 1;
            break;
        case "mm":
            _t = 72 / 25.4;
            break;
        case "cm":
            _t = 72 / 2.54;
            break;
        case "in":
            _t = 72;
            break;
        case "px":
            _t = 1 == Ge("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            _t = 12;
            break;
        case "ex":
            _t = 6;
            break;
        default:
            if ("number" != typeof o) throw new Error("Invalid unit: " + o);
            _t = o;
    }
    var Ye = null;
    K(), Y();
    var Je = function(t) {
        return null !== m ? Ye.encryptor(t, 0) : function(t) {
            return t;
        };
    }, Xe = y.__private__.getPageInfo = y.getPageInfo = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Ke = y.__private__.getPageInfoByObjId = function(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var e in Rt)if (Rt[e].objId === t) break;
        return Xe(e);
    }, Ze = y.__private__.getCurrentPageInfo = y.getCurrentPageInfo = function() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    y.addPage = function() {
        return Oe.apply(this, arguments), this;
    }, y.setPage = function() {
        return Me.apply(this, arguments), ht.call(this, ot[$]), this;
    }, y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, y.movePage = function(t, e) {
        var r, n;
        if (t > e) {
            r = ot[t], n = Rt[t];
            for(var i = t; i > e; i--)ot[i] = ot[i - 1], Rt[i] = Rt[i - 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        } else if (t < e) {
            r = ot[t], n = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        }
        return this;
    }, y.deletePage = function() {
        return Be.apply(this, arguments), this;
    }, y.__private__.text = y.text = function(e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof r && ("string" == typeof n || Array.isArray(n))) {
            var m = n;
            n = r, r = e, e = m;
        }
        if (arguments[3] instanceof Vt == !1 ? (c = arguments[4], u = arguments[5], "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(f = arguments[3]) && null !== f || ("string" == typeof c && (u = c, c = null), "string" == typeof f && (u = f, f = null), "number" == typeof f && (c = f, f = null), i = {
            flags: f,
            angle: c,
            align: u
        })) : (q("The transform parameter of text() with a Matrix value"), p = a), isNaN(r) || isNaN(n) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v = "", y = !1, w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : lr, N = g.internal.scaleFactor;
        function L(t) {
            return t = t.split("\t").join(Array(i.TabLen || 9).join(" ")), Ce(t, f);
        }
        function A(t) {
            for(var e, r = t.concat(), n = [], i = r.length; i--;)"string" == typeof (e = r.shift()) ? n.push(e) : Array.isArray(t) && (1 === e.length || void 0 === e[1] && void 0 === e[2]) ? n.push(e[0]) : n.push([
                e[0],
                e[1],
                e[2]
            ]);
            return n;
        }
        function _(t, e) {
            var r;
            if ("string" == typeof t) r = e(t)[0];
            else if (Array.isArray(t)) {
                for(var n, i, a = t.concat(), o = [], s = a.length; s--;)"string" == typeof (n = a.shift()) ? o.push(e(n)[0]) : Array.isArray(n) && "string" == typeof n[0] && (i = e(n[0], n[1], n[2]), o.push([
                    i[0],
                    i[1],
                    i[2]
                ]));
                r = o;
            }
            return r;
        }
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var I = e.concat();
            s = [];
            for(var F, C = I.length; C--;)("string" != typeof (F = I.shift()) || Array.isArray(F) && "string" != typeof F[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var j = gt / g.internal.scaleFactor, B = j * (w - 1);
        switch(i.baseline){
            case "bottom":
                n -= B;
                break;
            case "top":
                n += j - B;
                break;
            case "hanging":
                n += j - 2 * B;
                break;
            case "middle":
                n += j / 2 - B;
        }
        if ((l = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, l) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, l));
        }, []))), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("preProcessText", o), e = o.text, c = (i = o.options).angle, p instanceof Vt == !1 && c && "number" == typeof c) {
            c *= Math.PI / 180, 0 === i.rotationDirection && (c = -c), S === x.ADVANCED && (c = -c);
            var M = Math.cos(c), E = Math.sin(c);
            p = new Vt(M, E, -E, M, 0, 0);
        } else c && c instanceof Vt && (p = c);
        S !== x.ADVANCED || p || (p = Yt), void 0 !== (h = i.charSpace || _r) && (v += O(U(h)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (v += O(100 * d) + " Tz\n");
        i.lang;
        var D = -1, R = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(R){
            case 0:
            case !1:
            case "fill":
                D = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                D = 1;
                break;
            case 2:
            case "fillThenStroke":
                D = 2;
                break;
            case 3:
            case "invisible":
                D = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                D = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                D = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                D = 6;
                break;
            case 7:
            case "addToPathForClipping":
                D = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== D ? v += D + " Tr\n" : -1 !== z && (v += "0 Tr\n"), -1 !== D && (T.usedRenderingMode = D), u = i.align || "left";
        var H, W = gt * w, V = g.internal.pageSize.getWidth(), G = Ft[St];
        h = i.charSpace || _r, l = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [], J = function(t) {
            return g.getStringUnitWidth(t, {
                font: G,
                charSpace: h,
                fontSize: gt,
                doKerning: !1
            }) * gt / N;
        };
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var X;
            s = A(e), "left" !== u && (H = s.map(J));
            var K, Z = 0;
            if ("right" === u) {
                r -= H[0], e = [], C = s.length;
                for(var $ = 0; $ < C; $++)0 === $ ? (K = br(r), X = yr(n)) : (K = U(Z - H[$]), X = -W), e.push([
                    s[$],
                    K,
                    X
                ]), Z = H[$];
            } else if ("center" === u) {
                r -= H[0] / 2, e = [], C = s.length;
                for(var Q = 0; Q < C; Q++)0 === Q ? (K = br(r), X = yr(n)) : (K = U((Z - H[Q]) / 2), X = -W), e.push([
                    s[Q],
                    K,
                    X
                ]), Z = H[Q];
            } else if ("left" === u) {
                e = [], C = s.length;
                for(var tt = 0; tt < C; tt++)e.push(s[tt]);
            } else if ("justify" === u && "Identity-H" === G.encoding) {
                e = [], C = s.length, l = 0 !== l ? l : V;
                for(var et = 0, rt = 0; rt < C; rt++)if (X = 0 === rt ? yr(n) : -W, K = 0 === rt ? br(r) : et, rt < C - 1) {
                    var nt = U((l - H[rt]) / (s[rt].split(" ").length - 1)), it = s[rt].split(" ");
                    e.push([
                        it[0] + " ",
                        K,
                        X
                    ]), et = 0;
                    for(var at = 1; at < it.length; at++){
                        var ot = (J(it[at - 1] + " " + it[at]) - J(it[at])) * N + nt;
                        at == it.length - 1 ? e.push([
                            it[at],
                            ot,
                            0
                        ]) : e.push([
                            it[at] + " ",
                            ot,
                            0
                        ]), et -= ot;
                    }
                } else e.push([
                    s[rt],
                    K,
                    X
                ]);
                e.push([
                    "",
                    et,
                    0
                ]);
            } else {
                if ("justify" !== u) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                e = [], C = s.length, l = 0 !== l ? l : V;
                for(rt = 0; rt < C; rt++)X = 0 === rt ? yr(n) : -W, K = 0 === rt ? br(r) : 0, rt < C - 1 ? Y.push(O(U((l - H[rt]) / (s[rt].split(" ").length - 1)))) : Y.push(0), e.push([
                    s[rt],
                    K,
                    X
                ]);
            }
        }
        var st = "boolean" == typeof i.R2L ? i.R2L : bt;
        !0 === st && (e = _(e, function(t, e, r) {
            return [
                t.split("").reverse().join(""),
                e,
                r
            ];
        })), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("postProcessText", o), e = o.text, y = o.mutex.isHex || !1;
        var ct = Ft[St].encoding;
        "WinAnsiEncoding" !== ct && "StandardEncoding" !== ct || (e = _(e, function(t, e, r) {
            return [
                L(t),
                e,
                r
            ];
        })), s = A(e), e = [];
        for(var ut, ht, ft, dt = 0, pt = 1, mt = Array.isArray(s[0]) ? pt : dt, vt = "", yt = function(t, e, r) {
            var n = "";
            return r instanceof Vt ? (r = "number" == typeof i.angle ? Gt(r, new Vt(1, 0, 0, 1, t, e)) : Gt(new Vt(1, 0, 0, 1, t, e), r), S === x.ADVANCED && (r = Gt(new Vt(1, 0, 0, -1, 0, 0), r)), n = r.join(" ") + " Tm\n") : n = O(t) + " " + O(e) + " Td\n", n;
        }, wt = 0; wt < s.length; wt++){
            switch(vt = "", mt){
                case pt:
                    ft = (y ? "<" : "(") + s[wt][0] + (y ? ">" : ")"), ut = parseFloat(s[wt][1]), ht = parseFloat(s[wt][2]);
                    break;
                case dt:
                    ft = (y ? "<" : "(") + s[wt] + (y ? ">" : ")"), ut = br(r), ht = yr(n);
            }
            void 0 !== Y && void 0 !== Y[wt] && (vt = Y[wt] + " Tw\n"), 0 === wt ? e.push(vt + yt(ut, ht, p) + ft) : mt === dt ? e.push(vt + ft) : mt === pt && e.push(vt + yt(ut, ht, p) + ft);
        }
        e = mt === dt ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var Nt = "BT\n/";
        return Nt += St + " " + gt + " Tf\n", Nt += O(gt * w) + " TL\n", Nt += xr + "\n", Nt += v, Nt += e, lt(Nt += "ET"), b[St] = !0, g;
    };
    var $e = y.__private__.clip = y.clip = function(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    y.clipEvenOdd = function() {
        return $e("evenodd");
    }, y.__private__.discardPath = y.discardPath = function() {
        return lt("n"), this;
    };
    var Qe = y.__private__.isValidStyle = function(t) {
        var e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (e = !0), e;
    };
    y.__private__.setDefaultPathOperation = y.setDefaultPathOperation = function(t) {
        return Qe(t) && (g = t), this;
    };
    var tr = y.__private__.getStyle = y.getStyle = function(t) {
        var e = g;
        switch(t){
            case "D":
            case "S":
                e = "S";
                break;
            case "F":
                e = "f";
                break;
            case "FD":
            case "DF":
                e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                e = t;
        }
        return e;
    }, er = y.close = function() {
        return lt("h"), this;
    };
    y.stroke = function() {
        return lt("S"), this;
    }, y.fill = function(t) {
        return rr("f", t), this;
    }, y.fillEvenOdd = function(t) {
        return rr("f*", t), this;
    }, y.fillStroke = function(t) {
        return rr("B", t), this;
    }, y.fillStrokeEvenOdd = function(t) {
        return rr("B*", t), this;
    };
    var rr = function(e, r) {
        "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r) ? ar(r, e) : lt(e);
    }, nr = function(t) {
        null === t || S === x.ADVANCED && void 0 === t || (t = tr(t), lt(t));
    };
    function ir(t, e, r, n, i) {
        var a = new $15d064020a078dff$export$549f717800d2b57f(e || this.boundingBox, r || this.xStep, n || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Jt(o, a), a;
    }
    var ar = function(t, e) {
        var r = Bt[t.key], n = Ot[r];
        if (n instanceof $15d064020a078dff$export$7235f0ad083cb4c6) lt("q"), lt(or(e)), n.gState && y.setGState(n.gState), lt(t.matrix.toString() + " cm"), lt("/" + r + " sh"), lt("Q");
        else if (n instanceof $15d064020a078dff$export$549f717800d2b57f) {
            var i = new Vt(1, 0, 0, -1, 0, Rr());
            t.matrix && (i = i.multiply(t.matrix || Yt), r = ir.call(n, t.key, t.boundingBox, t.xStep, t.yStep, i).id), lt("q"), lt("/Pattern cs"), lt("/" + r + " scn"), n.gState && y.setGState(n.gState), lt(e), lt("Q");
        }
    }, or = function(t) {
        switch(t){
            case "f":
            case "F":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
                return "W S";
            case "B*":
                return "W* S";
            case "S":
                return "W S";
            case "n":
                return "W n";
        }
    }, sr = y.moveTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " m"), this;
    }, cr = y.lineTo = function(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " l"), this;
    }, ur = y.curveTo = function(t, e, r, n, i, a) {
        return lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(H(n)),
            O(U(i)),
            O(H(a)),
            "c"
        ].join(" ")), this;
    };
    y.__private__.line = y.line = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return S === x.COMPAT ? this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, y.__private__.lines = y.lines = function(t, e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g, m, v;
        if ("number" == typeof t && (v = r, r = e, e = t, t = v), n = n || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(r) || !Array.isArray(t) || !Array.isArray(n) || !Qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(sr(e, r), o = n[0], s = n[1], u = t.length, g = e, m = r, c = 0; c < u; c++)2 === (h = t[c]).length ? (g = h[0] * o + g, m = h[1] * s + m, cr(g, m)) : (l = h[0] * o + g, f = h[1] * s + m, d = h[2] * o + g, p = h[3] * s + m, g = h[4] * o + g, m = h[5] * s + m, ur(l, f, d, p, g, m));
        return a && er(), nr(i), this;
    }, y.path = function(t) {
        for(var e = 0; e < t.length; e++){
            var r = t[e], n = r.c;
            switch(r.op){
                case "m":
                    sr(n[0], n[1]);
                    break;
                case "l":
                    cr(n[0], n[1]);
                    break;
                case "c":
                    ur.apply(this, n);
                    break;
                case "h":
                    er();
            }
        }
        return this;
    }, y.__private__.rect = y.rect = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return S === x.COMPAT && (n = -n), lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(U(n)),
            "re"
        ].join(" ")), nr(i), this;
    }, y.__private__.triangle = y.triangle = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                r - t,
                n - e
            ],
            [
                i - r,
                a - n
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.roundedRect = y.roundedRect = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * r), a = Math.min(a, .5 * n), this.lines([
            [
                r - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                n - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - r,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - n
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, y.__private__.ellipse = y.ellipse = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * r, o = 4 / 3 * (Math.SQRT2 - 1) * n;
        return sr(t + r, e), ur(t + r, e - o, t + a, e - n, t, e - n), ur(t - a, e - n, t - r, e - o, t - r, e), ur(t - r, e + o, t - a, e + n, t, e + n), ur(t + a, e + n, t + r, e + o, t + r, e), nr(i), this;
    }, y.__private__.circle = y.circle = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || !Qe(n)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, r, r, n);
    }, y.setFont = function(t, e, r) {
        return r && (e = k(e, r)), St = qe(t, e, {
            disableWarning: !1
        }), this;
    };
    var hr = y.__private__.getFont = y.getFont = function() {
        return Ft[qe.apply(y, arguments)];
    };
    y.__private__.getFontList = y.getFontList = function() {
        var t, e, r = {};
        for(t in Ct)if (Ct.hasOwnProperty(t)) for(e in r[t] = [], Ct[t])Ct[t].hasOwnProperty(e) && r[t].push(e);
        return r;
    }, y.addFont = function(t, e, r, n, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (r = k(r, n)), i = i || "Identity-H", Pe.call(this, t, e, r, i);
    };
    var lr, fr = e.lineWidth || .200025, dr = y.__private__.getLineWidth = y.getLineWidth = function() {
        return fr;
    }, pr = y.__private__.setLineWidth = y.setLineWidth = function(t) {
        return fr = t, lt(O(U(t)) + " w"), this;
    };
    y.__private__.setLineDash = $15d064020a078dff$export$ba1e2ffc633a60f5.API.setLineDash = $15d064020a078dff$export$ba1e2ffc633a60f5.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return O(U(t));
        }).join(" "), e = O(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var gr = y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    y.__private__.getLineHeight = y.getLineHeight = function() {
        return gt * lr;
    };
    var mr = y.__private__.setLineHeightFactor = y.setLineHeightFactor = function(t) {
        return "number" == typeof (t = t || 1.15) && (lr = t), this;
    }, vr = y.__private__.getLineHeightFactor = y.getLineHeightFactor = function() {
        return lr;
    };
    mr(e.lineHeight);
    var br = y.__private__.getHorizontalCoordinate = function(t) {
        return U(t);
    }, yr = y.__private__.getVerticalCoordinate = function(t) {
        return S === x.ADVANCED ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, wr = y.__private__.getHorizontalCoordinateString = y.getHorizontalCoordinateString = function(t) {
        return O(br(t));
    }, Nr = y.__private__.getVerticalCoordinateString = y.getVerticalCoordinateString = function(t) {
        return O(yr(t));
    }, Lr = e.strokeColor || "0 G";
    y.__private__.getStrokeColor = y.getDrawColor = function() {
        return ee(Lr);
    }, y.__private__.setStrokeColor = y.setDrawColor = function(t, e, r, n) {
        return Lr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "draw",
            precision: 2
        }), lt(Lr), this;
    };
    var Ar = e.fillColor || "0 g";
    y.__private__.getFillColor = y.getFillColor = function() {
        return ee(Ar);
    }, y.__private__.setFillColor = y.setFillColor = function(t, e, r, n) {
        return Ar = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "fill",
            precision: 2
        }), lt(Ar), this;
    };
    var xr = e.textColor || "0 g", Sr = y.__private__.getTextColor = y.getTextColor = function() {
        return ee(xr);
    };
    y.__private__.setTextColor = y.setTextColor = function(t, e, r, n) {
        return xr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var _r = e.charSpace, Pr = y.__private__.getCharSpace = y.getCharSpace = function() {
        return parseFloat(_r || 0);
    };
    y.__private__.setCharSpace = y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return _r = t, this;
    };
    var kr = 0;
    y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, y.__private__.setLineCap = y.setLineCap = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return kr = e, lt(e + " J"), this;
    };
    var Ir = 0;
    y.__private__.setLineJoin = y.setLineJoin = function(t) {
        var e = y.CapJoinStyles[t];
        if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return Ir = e, lt(e + " j"), this;
    }, y.__private__.setLineMiterLimit = y.__private__.setMiterLimit = y.setLineMiterLimit = y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(O(U(t)) + " M"), this;
    }, y.GState = $15d064020a078dff$export$1bc649ab427a02ba, y.setGState = function(t) {
        (t = "string" == typeof t ? Mt[Et[t]] : Fr(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var Fr = function(t, e) {
        if (!t || !Et[t]) {
            var r = !1;
            for(var n in Mt)if (Mt.hasOwnProperty(n) && Mt[n].equals(e)) {
                r = !0;
                break;
            }
            if (r) e = Mt[n];
            else {
                var i = "GS" + (Object.keys(Mt).length + 1).toString(10);
                Mt[i] = e, e.id = i;
            }
            return t && (Et[t] = e.id), Tt.publish("addGState", e), e;
        }
    };
    y.addGState = function(t, e) {
        return Fr(t, e), this;
    }, y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: St,
            size: gt,
            color: xr
        }), this;
    }, y.restoreGraphicsState = function() {
        lt("Q");
        var t = jt.pop();
        return St = t.key, gt = t.size, xr = t.color, qt = null, this;
    }, y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, y.comment = function(t) {
        return lt("#" + t), this;
    };
    var Cr = function(t, e) {
        var r = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var n = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t.toString();
            }
        }), this;
    }, jr = function(t, e, r, n) {
        Cr.call(this, t, e), this.type = "rect";
        var i = r || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = parseFloat(t));
            }
        });
        var a = n || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, Or = function() {
        this.page = Dt, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = Pt, this.y = kt, this.matrix = It, this.width = qr($), this.height = Rr($), this.outputDestination = ct, this.id = "", this.objectNumber = -1;
    };
    Or.prototype.restore = function() {
        Dt = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, Pt = this.x, kt = this.y, It = this.matrix, Dr($, this.width), Tr($, this.height), ct = this.outputDestination;
    };
    var Br = function(t, e, r, n, i) {
        Wt.push(new Or), Dt = $ = 0, ot = [], Pt = t, kt = e, It = i, je([
            r,
            n
        ]);
    }, Mr = function(t) {
        if (Ht[t]) Wt.pop().restore();
        else {
            var e = new Or, r = "Xo" + (Object.keys(zt).length + 1).toString(10);
            e.id = r, Ht[t] = r, zt[r] = e, Tt.publish("addFormObject", e), Wt.pop().restore();
        }
    };
    for(var Er in y.beginFormObject = function(t, e, r, n, i) {
        return Br(t, e, r, n, i), this;
    }, y.endFormObject = function(t) {
        return Mr(t), this;
    }, y.doFormObject = function(t, e) {
        var r = zt[Ht[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + r.id + " Do"), lt("Q"), this;
    }, y.getFormObject = function(t) {
        var e = zt[Ht[t]];
        return {
            x: e.x,
            y: e.y,
            width: e.width,
            height: e.height,
            matrix: e.matrix
        };
    }, y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? ($15d064020a078dff$var$l(We(He()), t), "function" == typeof $15d064020a078dff$var$l.unload && $15d064020a078dff$var$n.setTimeout && setTimeout($15d064020a078dff$var$l.unload, 911), this) : new Promise(function(e, r) {
            try {
                var i = $15d064020a078dff$var$l(We(He()), t);
                "function" == typeof $15d064020a078dff$var$l.unload && $15d064020a078dff$var$n.setTimeout && setTimeout($15d064020a078dff$var$l.unload, 911), e(i);
            } catch (t) {
                r(t.message);
            }
        });
    }, $15d064020a078dff$export$ba1e2ffc633a60f5.API)$15d064020a078dff$export$ba1e2ffc633a60f5.API.hasOwnProperty(Er) && ("events" === Er && $15d064020a078dff$export$ba1e2ffc633a60f5.API.events.length ? function(t, e) {
        var r, n, i;
        for(i = e.length - 1; -1 !== i; i--)r = e[i][0], n = e[i][1], t.subscribe.apply(t, [
            r
        ].concat("function" == typeof n ? [
            n
        ] : n));
    }(Tt, $15d064020a078dff$export$ba1e2ffc633a60f5.API.events) : y[Er] = $15d064020a078dff$export$ba1e2ffc633a60f5.API[Er]);
    var qr = y.getPageWidth = function(t) {
        return (Rt[t = t || $].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX) / _t;
    }, Dr = y.setPageWidth = function(t, e) {
        Rt[t].mediaBox.topRightX = e * _t + Rt[t].mediaBox.bottomLeftX;
    }, Rr = y.getPageHeight = function(t) {
        return (Rt[t = t || $].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY) / _t;
    }, Tr = y.setPageHeight = function(t, e) {
        Rt[t].mediaBox.topRightY = e * _t + Rt[t].mediaBox.bottomLeftY;
    };
    return y.internal = {
        pdfEscape: Ce,
        getStyle: tr,
        getFont: hr,
        getFontSize: vt,
        getCharSpace: Pr,
        getTextColor: Sr,
        getLineHeight: gr,
        getLineHeightFactor: vr,
        getLineWidth: dr,
        write: ft,
        getHorizontalCoordinate: br,
        getVerticalCoordinate: yr,
        getCoordinateString: wr,
        getVerticalCoordinateString: Nr,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: ne,
        putStream: ie,
        events: Tt,
        scaleFactor: _t,
        pageSize: {
            getWidth: function() {
                return qr($);
            },
            setWidth: function(t) {
                Dr($, t);
            },
            getHeight: function() {
                return Rr($);
            },
            setHeight: function(t) {
                Tr($, t);
            }
        },
        encryptionOptions: m,
        encryption: Ye,
        getEncryptor: Je,
        output: Ve,
        getNumberOfPages: Ee,
        pages: ot,
        out: lt,
        f2: R,
        f3: T,
        getPageInfo: Xe,
        getPageInfoByObjId: Ke,
        getCurrentPageInfo: Ze,
        getPDFVersion: N,
        Point: Cr,
        Rectangle: jr,
        Matrix: Vt,
        hasHotfix: Ge
    }, Object.defineProperty(y.internal.pageSize, "width", {
        get: function() {
            return qr($);
        },
        set: function(t) {
            Dr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(y.internal.pageSize, "height", {
        get: function() {
            return Rr($);
        },
        set: function(t) {
            Tr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), ke.call(y, pt), St = "F1", Oe(s, i), Tt.publish("initialized"), y;
}
$15d064020a078dff$var$I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, $15d064020a078dff$var$I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, $15d064020a078dff$var$I.prototype.hexToBytes = function(t) {
    for(var e = [], r = 0; r < t.length; r += 2)e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
    return e.join("");
}, $15d064020a078dff$var$I.prototype.processOwnerPassword = function(t, e) {
    return $15d064020a078dff$var$P($15d064020a078dff$var$x(e).substr(0, 5), t);
}, $15d064020a078dff$var$I.prototype.encryptor = function(t, e) {
    var r = $15d064020a078dff$var$x(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return $15d064020a078dff$var$P(r, t);
    };
}, $15d064020a078dff$export$1bc649ab427a02ba.prototype.equals = function(e) {
    var r, n = "id,objectNumber,equals";
    if (!e || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(this)) return !1;
    var i = 0;
    for(r in this)if (!(n.indexOf(r) >= 0)) {
        if (this.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
        if (this[r] !== e[r]) return !1;
        i++;
    }
    for(r in e)e.hasOwnProperty(r) && n.indexOf(r) < 0 && i--;
    return 0 === i;
}, $15d064020a078dff$export$ba1e2ffc633a60f5.API = {
    events: []
}, $15d064020a078dff$export$ba1e2ffc633a60f5.version = "2.5.2";
var $15d064020a078dff$var$q = $15d064020a078dff$export$ba1e2ffc633a60f5.API, $15d064020a078dff$var$D = 1, $15d064020a078dff$var$R = function(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $15d064020a078dff$var$T = function(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $15d064020a078dff$var$U = function(t) {
    return t.toFixed(2);
}, $15d064020a078dff$var$z = function(t) {
    return t.toFixed(5);
};
$15d064020a078dff$var$q.__acroform__ = {};
var $15d064020a078dff$var$H = function(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $15d064020a078dff$var$W = function(t) {
    return t * $15d064020a078dff$var$D;
}, $15d064020a078dff$var$V = function(t) {
    var e = new $15d064020a078dff$var$ut, r = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) || 0, n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($15d064020a078dff$var$U(n)),
        Number($15d064020a078dff$var$U(r))
    ], e;
}, $15d064020a078dff$var$G = $15d064020a078dff$var$q.__acroform__.setBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t |= 1 << e;
}, $15d064020a078dff$var$Y = $15d064020a078dff$var$q.__acroform__.clearBit = function(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t &= ~(1 << e);
}, $15d064020a078dff$var$J = $15d064020a078dff$var$q.__acroform__.getBit = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return 0 == (t & 1 << e) ? 0 : 1;
}, $15d064020a078dff$var$X = $15d064020a078dff$var$q.__acroform__.getBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $15d064020a078dff$var$J(t, e - 1);
}, $15d064020a078dff$var$K = $15d064020a078dff$var$q.__acroform__.setBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $15d064020a078dff$var$G(t, e - 1);
}, $15d064020a078dff$var$Z = $15d064020a078dff$var$q.__acroform__.clearBitForPdf = function(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $15d064020a078dff$var$Y(t, e - 1);
}, $15d064020a078dff$var$$ = $15d064020a078dff$var$q.__acroform__.calculateCoordinates = function(t, e) {
    var r = e.internal.getHorizontalCoordinate, n = e.internal.getVerticalCoordinate, i = t[0], a = t[1], o = t[2], s = t[3], c = {};
    return c.lowerLeft_X = r(i) || 0, c.lowerLeft_Y = n(a + s) || 0, c.upperRight_X = r(i + o) || 0, c.upperRight_Y = n(a) || 0, [
        Number($15d064020a078dff$var$U(c.lowerLeft_X)),
        Number($15d064020a078dff$var$U(c.lowerLeft_Y)),
        Number($15d064020a078dff$var$U(c.upperRight_X)),
        Number($15d064020a078dff$var$U(c.upperRight_Y))
    ];
}, $15d064020a078dff$var$Q = function(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], r = t._V || t.DV, n = $15d064020a078dff$var$tt(t, r), i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + i + " " + $15d064020a078dff$var$U(n.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(n.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = $15d064020a078dff$var$V(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, $15d064020a078dff$var$tt = function(t, e) {
    var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize, n = {
        text: "",
        fontSize: ""
    }, i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    i = t.multiline ? i.map(function(t) {
        return t.split("\n");
    }) : i.map(function(t) {
        return [
            t
        ];
    });
    var a = r, o = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var c = function(e, r, n) {
        if (e + 1 < i.length) {
            var a = r + " " + i[e + 1][0];
            return $15d064020a078dff$var$et(a, t, n).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var u, h, l = $15d064020a078dff$var$et("3", t, a).height, f = t.multiline ? o - a : (o - l) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $15d064020a078dff$var$et(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, y = 0; y < i.length; y++)if (i.hasOwnProperty(y)) {
            var w = !1;
            if (1 !== i[y].length && m !== i[y].length - 1) {
                if ((l + 2) * (b + 2) + 2 > o) continue t;
                v += i[y][m], w = !0, g = y, y--;
            } else {
                v = " " == (v += i[y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(y), L = c(N, v, a), A = y >= i.length - 1;
                if (L && !A) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || A) {
                    if (A) g = N;
                    else if (t.multiline && (l + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((l + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var x = "", S = p; S <= g; S++){
                var _ = i[S];
                if (t.multiline) {
                    if (S === g) {
                        x += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        x += _[_.length - 1] + " ";
                        continue;
                    }
                }
                x += _[0] + " ";
            }
            switch(x = " " == x.substr(x.length - 1) ? x.substr(0, x.length - 1) : x, h = $15d064020a078dff$var$et(x, t, a).width, t.textAlign){
                case "right":
                    u = s - h - 2;
                    break;
                case "center":
                    u = (s - h) / 2;
                    break;
                case "left":
                default:
                    u = 2;
            }
            e += $15d064020a078dff$var$U(u) + " " + $15d064020a078dff$var$U(d) + " Td\n", e += "(" + $15d064020a078dff$var$R(x) + ") Tj\n", e += -$15d064020a078dff$var$U(u) + " 0 Td\n", d = -(a + 2), h = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return n.text = e, n.fontSize = a, n;
}, $15d064020a078dff$var$et = function(t, e, r) {
    var n = e.scope.internal.getFont(e.fontName, e.fontStyle), i = e.scope.getStringUnitWidth(t, {
        font: n,
        fontSize: parseFloat(r),
        charSpace: 0
    }) * parseFloat(r);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: n,
            fontSize: parseFloat(r),
            charSpace: 0
        }) * parseFloat(r) * 1.5,
        width: i
    };
}, $15d064020a078dff$var$rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $15d064020a078dff$var$nt = function(t, e) {
    var r = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === r.type && t.object === r.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
}, $15d064020a078dff$var$it = function(e, r) {
    for(var n in e)if (e.hasOwnProperty(n)) {
        var i = n, a = e[n];
        r.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(a) && "function" == typeof a.putStream && a.putStream(), delete e[i];
    }
}, $15d064020a078dff$var$at = function(e, r) {
    if (r.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if ($15d064020a078dff$var$lt.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify($15d064020a078dff$var$rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $15d064020a078dff$var$D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new $15d064020a078dff$var$ht, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var r in e)if (e.hasOwnProperty(r)) {
                    var n = e[r];
                    n.objId = void 0, n.hasAnnotation && $15d064020a078dff$var$nt(n, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(r) {
            !function(e, r) {
                var n = !e;
                for(var i in e || (r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(i)) {
                    var a = e[i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $15d064020a078dff$var$$(a.Rect, r)), r.internal.newObjectDeferredBegin(a.objId, !0), a.DA = $15d064020a078dff$export$7d753ad993606f45.createDefaultAppearanceStream(a), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var c = $15d064020a078dff$var$Q(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + c + ">>"
                        }), r.internal.acroformPlugin.xForms.push(c);
                    }
                    if (a.appearanceStreamContent) {
                        var u = "";
                        for(var h in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(h)) {
                            var l = a.appearanceStreamContent[h];
                            if (u += "/" + h + " ", u += "<<", Object.keys(l).length >= 1 || Array.isArray(l)) {
                                for(var i in l)if (l.hasOwnProperty(i)) {
                                    var f = l[i];
                                    "function" == typeof f && (f = f.call(r, a)), u += "/" + i + " " + f + " ", r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = l) && (f = f.call(r, a)), u += "/" + i + " " + f, r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                            u += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + u + ">>"
                        });
                    }
                    r.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), r.internal.out("endobj");
                }
                n && $15d064020a078dff$var$it(r.internal.acroformPlugin.xForms, r);
            }(r, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, $15d064020a078dff$var$ot = $15d064020a078dff$var$q.__acroform__.arrayToPdfArray = function(e, r, n) {
    var i = function(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== r && n && (i = n.internal.getEncryptor(r)), a += "(" + $15d064020a078dff$var$R(i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a += "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
};
var $15d064020a078dff$var$st = function(t, e, r) {
    var n = function(t) {
        return t;
    };
    return void 0 !== e && r && (n = r.internal.getEncryptor(e)), (t = t || "").toString(), t = "(" + $15d064020a078dff$var$R(n(t)) + ")";
}, $15d064020a078dff$var$ct = function() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
$15d064020a078dff$var$ct.prototype.toString = function() {
    return this.objId + " 0 R";
}, $15d064020a078dff$var$ct.prototype.putStream = function() {
    var t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, $15d064020a078dff$var$ct.prototype.getKeyValueListForStream = function() {
    var t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var r in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable) {
        var n = e[r], i = this[n];
        i && (Array.isArray(i) ? t.push({
            key: n,
            value: $15d064020a078dff$var$ot(i, this.objId, this.scope)
        }) : i instanceof $15d064020a078dff$var$ct ? (i.scope = this.scope, t.push({
            key: n,
            value: i.objId + " 0 R"
        })) : "function" != typeof i && t.push({
            key: n,
            value: i
        }));
    }
    return t;
};
var $15d064020a078dff$var$ut = function() {
    $15d064020a078dff$var$ct.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function(e) {
            t = e.trim();
        },
        get: function() {
            return t || null;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$var$ut, $15d064020a078dff$var$ct);
var $15d064020a078dff$var$ht = function() {
    $15d064020a078dff$var$ct.call(this);
    var t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (t) {
                var e = function(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $15d064020a078dff$var$R(e(t)) + ")";
            }
        },
        set: function(e) {
            t = e;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$var$ht, $15d064020a078dff$var$ct);
var $15d064020a078dff$var$lt = function t() {
    $15d064020a078dff$var$ct.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(e, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.F = $15d064020a078dff$var$K(e, 3) : this.F = $15d064020a078dff$var$Z(e, 3);
        }
    });
    var r = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return r;
        },
        set: function(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            r = t;
        }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (0 !== n.length) return n;
        },
        set: function(t) {
            n = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[0]) ? 0 : n[0];
        },
        set: function(t) {
            n[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[1]) ? 0 : n[1];
        },
        set: function(t) {
            n[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[2]) ? 0 : n[2];
        },
        set: function(t) {
            n[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return !n || isNaN(n[3]) ? 0 : n[3];
        },
        set: function(t) {
            n[3] = t;
        }
    });
    var i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return i;
        },
        set: function(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!a || a.length < 1) {
                if (this instanceof $15d064020a078dff$var$yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $15d064020a078dff$var$R(e(a)) + ")";
        },
        set: function(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            return a;
        },
        set: function(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return o;
        },
        set: function(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return s;
        },
        set: function(t) {
            s = t;
        }
    });
    var c = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return c;
        },
        set: function(t) {
            c = t;
        }
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return void 0 === u ? 50 / $15d064020a078dff$var$D : u;
        },
        set: function(t) {
            u = t;
        }
    });
    var h = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return h;
        },
        set: function(t) {
            h = t;
        }
    });
    var l = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (!(!l || this instanceof $15d064020a078dff$var$yt || this instanceof $15d064020a078dff$export$9d1b52e7fab50c84)) return $15d064020a078dff$var$st(l, this.objId, this.scope);
        },
        set: function(t) {
            t = t.toString(), l = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (f) return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? $15d064020a078dff$var$st(f, this.objId, this.scope) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $15d064020a078dff$var$T(t.substr(1, t.length - 2)) : $15d064020a078dff$var$T(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? $15d064020a078dff$var$T(f.substr(1, f.length - 1)) : f;
        },
        set: function(t) {
            t = t.toString(), f = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return d;
        },
        set: function(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            if (d) return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? $15d064020a078dff$var$st(d, this.objId, this.scope) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $15d064020a078dff$var$T(t.substr(1, t.length - 2)) : $15d064020a078dff$var$T(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? $15d064020a078dff$var$T(d.substr(1, d.length - 1)) : d;
        },
        set: function(t) {
            t = t.toString(), d = this instanceof $15d064020a078dff$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return g;
        },
        set: function(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            if (p) return p;
        },
        set: function(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 1));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 1) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 2));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 2) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 3));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 3) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            if (null !== m) return m;
        },
        set: function(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function() {
            var t;
            switch(m){
                case 0:
                default:
                    t = "left";
                    break;
                case 1:
                    t = "center";
                    break;
                case 2:
                    t = "right";
            }
            return t;
        },
        configurable: !0,
        enumerable: !0,
        set: function(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                case "left":
                case 0:
                default:
                    m = 0;
            }
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$var$lt, $15d064020a078dff$var$ct);
var $15d064020a078dff$export$a47202eb3f827bb2 = function() {
    $15d064020a078dff$var$lt.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return $15d064020a078dff$var$ot(e, this.objId, this.scope);
        },
        set: function(t) {
            var r, n;
            n = [], "string" == typeof (r = t) && (n = function(t, e, r) {
                r || (r = 1);
                for(var n, i = []; n = e.exec(t);)i.push(n[r]);
                return i;
            }(r, /\((.*?)\)/g)), e = n;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, r) {
        for(r = r || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 18));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 18) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 19));
        },
        set: function(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 19) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 20));
        },
        set: function(t) {
            !0 === Boolean(t) ? (this.Ff = $15d064020a078dff$var$K(this.Ff, 20), e.sort()) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 22));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 22) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 23) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 27));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 27) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$15d064020a078dff$var$H($15d064020a078dff$export$a47202eb3f827bb2, $15d064020a078dff$var$lt);
var $15d064020a078dff$export$9e021dd9568dc486 = function() {
    $15d064020a078dff$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$15d064020a078dff$var$H($15d064020a078dff$export$9e021dd9568dc486, $15d064020a078dff$export$a47202eb3f827bb2);
var $15d064020a078dff$export$f2239d28df5f43bd = function() {
    $15d064020a078dff$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$f2239d28df5f43bd, $15d064020a078dff$export$9e021dd9568dc486);
var $15d064020a078dff$export$4af052e7e598ad1a = function() {
    $15d064020a078dff$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$4af052e7e598ad1a, $15d064020a078dff$export$f2239d28df5f43bd);
var $15d064020a078dff$export$6aae594af76bbb7b = function() {
    $15d064020a078dff$var$lt.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 15));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 15) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 16));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 16) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 17));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 17) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 26) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 26);
        }
    });
    var e, r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            if (this.scope && (t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(r).length) {
                var e, n = [];
                for(e in n.push("<<"), r)n.push("/" + e + " (" + $15d064020a078dff$var$R(t(r[e])) + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (r = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return r.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (r.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return e.substr(1, e.length - 1);
        },
        set: function(t) {
            e = "/" + t;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$export$6aae594af76bbb7b, $15d064020a078dff$var$lt);
var $15d064020a078dff$export$98b7c3ef37465410 = function() {
    $15d064020a078dff$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$98b7c3ef37465410, $15d064020a078dff$export$6aae594af76bbb7b);
var $15d064020a078dff$export$bc1318bc7e5f1315 = function() {
    $15d064020a078dff$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = void 0 !== e ? e : [];
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$export$bc1318bc7e5f1315, $15d064020a078dff$export$6aae594af76bbb7b);
var $15d064020a078dff$var$yt = function() {
    var e, r;
    $15d064020a078dff$var$lt.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return e;
        },
        set: function(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function() {
            return r;
        },
        set: function(t) {
            r = t;
        }
    });
    var n, i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            var t = function(t) {
                return t;
            };
            this.scope && (t = this.scope.internal.getEncryptor(this.objId));
            var e, r = [];
            for(e in r.push("<<"), i)r.push("/" + e + " (" + $15d064020a078dff$var$R(t(i[e])) + ")");
            return r.push(">>"), r.join("\n");
        },
        set: function(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return i.CA || "";
        },
        set: function(t) {
            "string" == typeof t && (i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function() {
            return n;
        },
        set: function(t) {
            n = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return n.substr(1, n.length - 1);
        },
        set: function(t) {
            n = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$15d064020a078dff$var$H($15d064020a078dff$var$yt, $15d064020a078dff$var$lt), $15d064020a078dff$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var r = this.Kids[e];
        r.appearanceStreamContent = t.createAppearanceStream(r.optionName), r.caption = t.getCA();
    }
}, $15d064020a078dff$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $15d064020a078dff$var$yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $15d064020a078dff$var$xt.call(this.scope, e), e;
};
var $15d064020a078dff$export$5fd5db01c4615478 = function() {
    $15d064020a078dff$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $15d064020a078dff$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$15d064020a078dff$var$H($15d064020a078dff$export$5fd5db01c4615478, $15d064020a078dff$export$6aae594af76bbb7b);
var $15d064020a078dff$export$9d1b52e7fab50c84 = function() {
    $15d064020a078dff$var$lt.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 13));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 13) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 21));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 21) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 23));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 23) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 24));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 24) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 25));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 25) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 26));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 26) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 26);
        }
    });
    var t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function() {
            return t;
        },
        set: function(e) {
            t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return t;
        },
        set: function(e) {
            Number.isInteger(e) && (t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return this.V || this.DV;
        }
    });
};
$15d064020a078dff$var$H($15d064020a078dff$export$9d1b52e7fab50c84, $15d064020a078dff$var$lt);
var $15d064020a078dff$export$c48d8668f8cea64d = function() {
    $15d064020a078dff$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function() {
            return Boolean($15d064020a078dff$var$X(this.Ff, 14));
        },
        set: function(t) {
            !0 === Boolean(t) ? this.Ff = $15d064020a078dff$var$K(this.Ff, 14) : this.Ff = $15d064020a078dff$var$Z(this.Ff, 14);
        }
    }), this.password = !0;
};
$15d064020a078dff$var$H($15d064020a078dff$export$c48d8668f8cea64d, $15d064020a078dff$export$9d1b52e7fab50c84);
var $15d064020a078dff$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function() {
            return {
                N: {
                    On: $15d064020a078dff$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $15d064020a078dff$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $15d064020a078dff$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function(t) {
            var e = $15d064020a078dff$var$V(t);
            e.scope = t.scope;
            var r = [], n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, i = t.scope.__private__.encodeColorString(t.color), a = $15d064020a078dff$var$tt(t, t.caption);
            return r.push("0.749023 g"), r.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("BMC"), r.push("q"), r.push("0 0 1 rg"), r.push("/" + n + " " + $15d064020a078dff$var$U(a.fontSize) + " Tf " + i), r.push("BT"), r.push(a.text), r.push("ET"), r.push("Q"), r.push("EMC"), e.stream = r.join("\n"), e;
        },
        YesNormal: function(t) {
            var e = $15d064020a078dff$var$V(t);
            e.scope = t.scope;
            var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), i = [], a = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t), o = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t), s = $15d064020a078dff$var$tt(t, t.caption);
            return i.push("1 g"), i.push("0 0 " + $15d064020a078dff$var$U(o) + " " + $15d064020a078dff$var$U(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + $15d064020a078dff$var$U(o - 1) + " " + $15d064020a078dff$var$U(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + r + " " + $15d064020a078dff$var$U(s.fontSize) + " Tf " + n), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
        },
        OffPushDown: function(t) {
            var e = $15d064020a078dff$var$V(t);
            e.scope = t.scope;
            var r = [];
            return r.push("0.749023 g"), r.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function() {
                return "l";
            },
            YesNormal: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) <= $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) ? $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 4 : $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C, a = Number((n * i).toFixed(5));
                return r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"), r.push("-" + a + " " + n + " -" + n + " " + a + " -" + n + " 0 c"), r.push("-" + n + " -" + a + " -" + a + " -" + n + " 0 -" + n + " c"), r.push(a + " -" + n + " " + n + " -" + a + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) <= $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) ? $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 4 : $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((n * $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), r.push("0 g"), r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"), r.push("-" + o + " " + n + " -" + n + " " + o + " -" + n + " 0 c"), r.push("-" + n + " -" + o + " -" + o + " -" + n + " 0 -" + n + " c"), r.push(o + " -" + n + " " + n + " -" + o + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) <= $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) ? $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 4 : $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var i = Number((2 * n).toFixed(5)), a = Number((i * $15d064020a078dff$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $15d064020a078dff$var$z($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(i + " 0 m"), r.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), r.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), r.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), r.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function(t) {
                var e = {
                    D: {
                        Off: $15d064020a078dff$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $15d064020a078dff$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function() {
                return "8";
            },
            YesNormal: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [], n = $15d064020a078dff$export$7d753ad993606f45.internal.calculateCross(t);
                return r.push("q"), r.push("1 1 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($15d064020a078dff$var$U(n.x1.x) + " " + $15d064020a078dff$var$U(n.x1.y) + " m"), r.push($15d064020a078dff$var$U(n.x2.x) + " " + $15d064020a078dff$var$U(n.x2.y) + " l"), r.push($15d064020a078dff$var$U(n.x4.x) + " " + $15d064020a078dff$var$U(n.x4.y) + " m"), r.push($15d064020a078dff$var$U(n.x3.x) + " " + $15d064020a078dff$var$U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = $15d064020a078dff$export$7d753ad993606f45.internal.calculateCross(t), n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($15d064020a078dff$var$U(r.x1.x) + " " + $15d064020a078dff$var$U(r.x1.y) + " m"), n.push($15d064020a078dff$var$U(r.x2.x) + " " + $15d064020a078dff$var$U(r.x2.y) + " l"), n.push($15d064020a078dff$var$U(r.x4.x) + " " + $15d064020a078dff$var$U(r.x4.y) + " m"), n.push($15d064020a078dff$var$U(r.x3.x) + " " + $15d064020a078dff$var$U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function(t) {
                var e = $15d064020a078dff$var$V(t);
                e.scope = t.scope;
                var r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t)) + " " + $15d064020a078dff$var$U($15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + r;
    }
};
$15d064020a078dff$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function(t) {
        var e = $15d064020a078dff$export$7d753ad993606f45.internal.getWidth(t), r = $15d064020a078dff$export$7d753ad993606f45.internal.getHeight(t), n = Math.min(e, r);
        return {
            x1: {
                x: (e - n) / 2,
                y: (r - n) / 2 + n
            },
            x2: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2
            },
            x3: {
                x: (e - n) / 2,
                y: (r - n) / 2
            },
            x4: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2 + n
            }
        };
    }
}, $15d064020a078dff$export$7d753ad993606f45.internal.getWidth = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (r = $15d064020a078dff$var$W(e.Rect[2])), r;
}, $15d064020a078dff$export$7d753ad993606f45.internal.getHeight = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && (r = $15d064020a078dff$var$W(e.Rect[3])), r;
};
var $15d064020a078dff$var$xt = $15d064020a078dff$var$q.addField = function(t) {
    if ($15d064020a078dff$var$at(this, t), !(t instanceof $15d064020a078dff$var$lt)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
$15d064020a078dff$var$q.AcroFormChoiceField = $15d064020a078dff$export$a47202eb3f827bb2, $15d064020a078dff$var$q.AcroFormListBox = $15d064020a078dff$export$9e021dd9568dc486, $15d064020a078dff$var$q.AcroFormComboBox = $15d064020a078dff$export$f2239d28df5f43bd, $15d064020a078dff$var$q.AcroFormEditBox = $15d064020a078dff$export$4af052e7e598ad1a, $15d064020a078dff$var$q.AcroFormButton = $15d064020a078dff$export$6aae594af76bbb7b, $15d064020a078dff$var$q.AcroFormPushButton = $15d064020a078dff$export$98b7c3ef37465410, $15d064020a078dff$var$q.AcroFormRadioButton = $15d064020a078dff$export$bc1318bc7e5f1315, $15d064020a078dff$var$q.AcroFormCheckBox = $15d064020a078dff$export$5fd5db01c4615478, $15d064020a078dff$var$q.AcroFormTextField = $15d064020a078dff$export$9d1b52e7fab50c84, $15d064020a078dff$var$q.AcroFormPasswordField = $15d064020a078dff$export$c48d8668f8cea64d, $15d064020a078dff$var$q.AcroFormAppearance = $15d064020a078dff$export$7d753ad993606f45, $15d064020a078dff$var$q.AcroForm = {
    ChoiceField: $15d064020a078dff$export$a47202eb3f827bb2,
    ListBox: $15d064020a078dff$export$9e021dd9568dc486,
    ComboBox: $15d064020a078dff$export$f2239d28df5f43bd,
    EditBox: $15d064020a078dff$export$4af052e7e598ad1a,
    Button: $15d064020a078dff$export$6aae594af76bbb7b,
    PushButton: $15d064020a078dff$export$98b7c3ef37465410,
    RadioButton: $15d064020a078dff$export$bc1318bc7e5f1315,
    CheckBox: $15d064020a078dff$export$5fd5db01c4615478,
    TextField: $15d064020a078dff$export$9d1b52e7fab50c84,
    PasswordField: $15d064020a078dff$export$c48d8668f8cea64d,
    Appearance: $15d064020a078dff$export$7d753ad993606f45
}, $15d064020a078dff$export$ba1e2ffc633a60f5.AcroForm = {
    ChoiceField: $15d064020a078dff$export$a47202eb3f827bb2,
    ListBox: $15d064020a078dff$export$9e021dd9568dc486,
    ComboBox: $15d064020a078dff$export$f2239d28df5f43bd,
    EditBox: $15d064020a078dff$export$4af052e7e598ad1a,
    Button: $15d064020a078dff$export$6aae594af76bbb7b,
    PushButton: $15d064020a078dff$export$98b7c3ef37465410,
    RadioButton: $15d064020a078dff$export$bc1318bc7e5f1315,
    CheckBox: $15d064020a078dff$export$5fd5db01c4615478,
    TextField: $15d064020a078dff$export$9d1b52e7fab50c84,
    PasswordField: $15d064020a078dff$export$c48d8668f8cea64d,
    Appearance: $15d064020a078dff$export$7d753ad993606f45
};
var $15d064020a078dff$export$9cf40f67b77f45f4 = $15d064020a078dff$export$ba1e2ffc633a60f5.AcroForm;
function $15d064020a078dff$var$_t(t) {
    return t.reduce(function(t, e, r) {
        return t[e] = r, t;
    }, {});
}
!function(e) {
    e.__addimage__ = {};
    var r = "UNKNOWN", n = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, i = e.__addimage__.getImageFileTypeByImageData = function(t, e) {
        var i, a, o, s, c, u = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (x(t)) for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        else for(c in n)for(o = n[c], i = 0; i < o.length; i += 1){
            for(s = !0, a = 0; a < o[i].length; a += 1)if (void 0 !== o[i][a] && o[i][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        return u === r && e !== r && (u = e), u;
    }, a = function t(e) {
        for(var r = this.internal.write, n = this.internal.putStream, i = (0, this.internal.getFilters)(); -1 !== i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === b.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === b.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency)) {
            for(var o = "", s = 0, c = e.transparency.length; s < c; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var u = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (n({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: u,
            objectId: e.objectId
        }), r("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var h = "/Predictor " + e.predictor + " /Colors 1 /BitsPerComponent " + e.bitsPerComponent + " /Columns " + e.width, l = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: e.bitsPerComponent,
                decodeParameters: h,
                data: e.sMask
            };
            "filter" in e && (l.filter = e.filter), t.call(this, l);
        }
        if (e.colorSpace === b.INDEXED) {
            var f = this.internal.newObject();
            n({
                data: _(new Uint8Array(e.palette)),
                objectId: f
            }), r("endobj");
        }
    }, o = function() {
        var t = this.internal.collections.addImage_images;
        for(var e in t)a.call(this, t[e]);
    }, s = function() {
        var t, e = this.internal.collections.addImage_images, r = this.internal.write;
        for(var n in e)r("/I" + (t = e[n]).index, t.objectId, "0", "R");
    }, c = function() {
        this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", s));
    }, h = function() {
        var t = this.internal.collections.addImage_images;
        return c.call(this), t;
    }, l = function() {
        return Object.keys(this.internal.collections.addImage_images).length;
    }, f = function(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, d = function(e) {
        return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e) && 1 === e.nodeType;
    }, p = function(t, r) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var n = "" + t.getAttribute("src");
            if (0 === n.indexOf("data:image/")) return $15d064020a078dff$var$u(unescape(n).split("base64,").pop());
            var i = e.loadFile(n, !0);
            if (void 0 !== i) return i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(r){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                case "JPEG":
                case "JPG":
                default:
                    a = "image/jpeg";
            }
            return $15d064020a078dff$var$u(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, g = function(t) {
        var e = this.internal.collections.addImage_images;
        if (e) {
            for(var r in e)if (t === e[r].alias) return e[r];
        }
    }, m = function(t, e, r) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * r.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * r.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * r.width / r.height), 0 === e && (e = t * r.height / r.width), [
            t,
            e
        ];
    }, v = function(t, e, r, n, i, a) {
        var o = m.call(this, r, n, i), s = this.internal.getCoordinateString, c = this.internal.getVerticalCoordinateString, u = h.call(this);
        if (r = o[0], n = o[1], u[i.index] = i, a) {
            a *= Math.PI / 180;
            var l = Math.cos(a), f = Math.sin(a), d = function(t) {
                return t.toFixed(4);
            }, p = [
                d(l),
                d(f),
                d(-1 * f),
                d(l),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, b = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var y = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, w = e.__addimage__.sHashCode = function(t) {
        var e, r, n = 0;
        if ("string" == typeof t) for(r = t.length, e = 0; e < r; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
        else if (x(t)) for(r = t.byteLength / 2, e = 0; e < r; e++)n = (n << 5) - n + t[e], n |= 0;
        return n;
    }, N = e.__addimage__.validateStringAsBase64 = function(t) {
        (t = t || "").toString().trim();
        var e = !0;
        return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (e = !1), e;
    }, L = e.__addimage__.extractImageFromDataUrl = function(t) {
        var e = (t = t || "").split("base64,"), r = null;
        if (2 === e.length) {
            var n = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);
            Array.isArray(n) && (r = {
                mimeType: n[1],
                charset: n[2],
                data: e[1]
            });
        }
        return r;
    }, A = e.__addimage__.supportsArrayBuffer = function() {
        return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return A() && t instanceof ArrayBuffer;
    };
    var x = e.__addimage__.isArrayBufferView = function(t) {
        return A() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
    }, S = e.__addimage__.binaryStringToUint8Array = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function(t) {
        for(var e = "", r = x(t) ? t : new Uint8Array(t), n = 0; n < r.length; n += 8192)e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
        return e;
    };
    e.addImage = function() {
        var e, n, i, a, o, s, u, h, l;
        if ("number" == typeof arguments[1] ? (n = r, i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], h = arguments[6], l = arguments[7]) : (n = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], h = arguments[7], l = arguments[8]), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e = arguments[0]) && !d(e) && "imageData" in e) {
            var f = e;
            e = f.imageData, n = f.format || n || r, i = f.x || i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, h = f.compression || h, l = f.rotation || f.angle || l;
        }
        var p = this.internal.getFilters();
        if (void 0 === h && -1 !== p.indexOf("FlateEncode") && (h = "SLOW"), isNaN(i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, e, n, u, h);
        return v.call(this, i, a, o, s, g, l), this;
    };
    var P = function(t, n, a, o) {
        var s, c, u;
        if ("string" == typeof t && i(t) === r) {
            t = unescape(t);
            var h = k(t, !1);
            ("" !== h || void 0 !== (h = e.loadFile(t, !0))) && (t = h);
        }
        if (d(t) && (t = p(t, n)), n = i(t, n), !f(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (u = a) || 0 === u.length) && (a = function(t) {
            return "string" == typeof t || x(t) ? w(t) : x(t.data) ? w(t.data) : null;
        }(t)), (s = g.call(this, a)) || (A() && (t instanceof Uint8Array || "RGBA" === n || (c = t, t = S(t))), s = this["process" + n.toUpperCase()](t, l.call(this), a, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : y.NONE;
        }(o), c)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function(t, e) {
        var r;
        e = "boolean" != typeof e || e;
        var n, i = "";
        if ("string" == typeof t) {
            n = null !== (r = L(t)) ? r.data : t;
            try {
                i = $15d064020a078dff$var$u(n);
            } catch (t) {
                if (e) throw N(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return i;
    };
    e.getImageProperties = function(t) {
        var n, a, o = "";
        if (d(t) && (t = p(t)), "string" == typeof t && i(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), a = i(t), !f(a)) throw new Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
        if (!A() || t instanceof Uint8Array || (t = S(t)), !(n = this["process" + a.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = a, n;
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $15d064020a078dff$export$ba1e2ffc633a60f5.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var r, n, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), c = t.pageContext.annotations, u = !1, h = 0; h < c.length && !u; h++)switch((r = c[h]).type){
                case "link":
                    (e(r.options.url) || e(r.options.pageNumber)) && (u = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    u = !0;
            }
            if (0 != u) {
                this.internal.write("/Annots [");
                for(var l = 0; l < c.length; l++){
                    r = c[l];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(r.type){
                        case "reference":
                            this.internal.write(" " + r.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = r.title || "Note";
                            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y) + "] ") + "/Contents (" + f(m(r.contents)) + ")", i += " /Popup " + g.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(m(v)) + ") >>", p.content = i;
                            var b = p.objId + " 0 R";
                            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + a(r.bounds.x + 30) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w + 30) + " " + o(r.bounds.y) + "] ") + " /Parent " + b, r.open && (i += " /Open true"), i += " >>", g.content = i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y + r.bounds.h) + "] ";
                            var y = r.color || "#000000";
                            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + f(d(r.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
                            break;
                        case "link":
                            if (r.options.name) {
                                var w = this.annotations._nameMap[r.options.name];
                                r.options.pageNumber = w.page, r.options.top = w.y;
                            } else r.options.top || (r.options.top = 0);
                            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(r.options.url)) + ") >>";
                            else if (r.options.pageNumber) switch(i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor){
                                case "Fit":
                                    i += " /Fit]";
                                    break;
                                case "FitH":
                                    i += " /FitH " + r.options.top + "]";
                                    break;
                                case "FitV":
                                    r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var N = o(r.options.top);
                                    r.options.left = r.options.left || 0, void 0 === r.options.zoom && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + N + " " + r.options.zoom + "]";
                            }
                            "" != i && (i += " >>", this.internal.write(i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, r, n, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + r),
                h: s(e + n)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, r, n) {
        var i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== n.maxWidth) {
            a = n.maxWidth;
            var c = this.splitTextToSize(t, a).length;
            i = Math.ceil(s * c);
        } else a = o, i = s;
        return this.text(t, e, r, n), r += .2 * s, "center" === n.align && (e -= o / 2), "right" === n.align && (e -= o), this.link(e, r - s, a, i, n), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, r = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, n = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, c = t.__arabicParser__.isArabicAlfLetter = function(t) {
        return o(t) && i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var u = t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var h = t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, l = t.__arabicParser__.resolveLigatures = function(t) {
        var e = 0, n = r, i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== n[t.charCodeAt(e)] ? (a++, "number" == typeof (n = n[t.charCodeAt(e)]) && (i += String.fromCharCode(n), n = r, a = 0), e === t.length - 1 && (n = r, i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (n = r, i += t.charAt(e - a), e -= a, a = 0);
        return i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function(t, e, r) {
        return o(t) ? !1 === a(t) ? -1 : !u(t) || !o(e) && !o(r) || !o(r) && s(e) || s(t) && !o(e) || s(t) && c(e) || s(t) && s(e) ? 0 : h(t) && o(e) && !s(e) && o(r) && u(r) ? 3 : s(t) || !o(r) ? 1 : 2 : -1;
    }, d = function(t) {
        var r = 0, n = 0, i = 0, a = "", s = "", c = "", u = (t = t || "").split("\\s+"), h = [];
        for(r = 0; r < u.length; r += 1){
            for(h.push(""), n = 0; n < u[r].length; n += 1)a = u[r][n], s = u[r][n - 1], c = u[r][n + 1], o(a) ? (i = f(a, s, c), h[r] += -1 !== i ? String.fromCharCode(e[a.charCodeAt(0)][i]) : a) : h[r] += a;
            h[r] = l(h[r]);
        }
        return h.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function() {
        var t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, r = [];
        if (Array.isArray(e)) {
            var n = 0;
            for(r = [], n = 0; n < e.length; n += 1)Array.isArray(e[n]) ? r.push([
                d(e[n][0]),
                e[n][1],
                e[n][2]
            ]) : r.push([
                d(e[n])
            ]);
            t = r;
        } else t = d(e);
        return "string" == typeof arguments[0] ? t : (arguments[0].text = t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), $15d064020a078dff$export$ba1e2ffc633a60f5.API.autoPrint = function(t) {
    var e;
    switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
        case "javascript":
            this.addJS("print({});");
            break;
        case "non-conform":
        default:
            this.internal.events.subscribe("postPutResources", function() {
                e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
            }), this.internal.events.subscribe("putCatalog", function() {
                this.internal.out("/OpenAction " + e + " 0 R");
            });
    }
    return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        var t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var r = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
            }
        });
        var n = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var r;
        if ("2d" !== (t = t || "2d")) return null;
        for(r in e)this.pdf.context2d.hasOwnProperty(r) && (this.pdf.context2d[r] = e[r]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), function(e) {
    var r = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, n = !1, i = function() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function() {
        var t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function() {
                return t;
            },
            set: function(e) {
                t = e;
            }
        });
        var e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var r = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function() {
                return r;
            },
            set: function(t) {
                r = t;
            }
        });
        var n = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function() {
                return n;
            },
            set: function(t) {
                n = t;
            }
        });
        var i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function() {
                return a;
            },
            set: function(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        i.call(this);
        var r = (e = e || {}).fontSize || this.getFontSize(), n = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, c = 0, u = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var h = e.maxWidth;
        h > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, h) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(u.splitTextToSize(e, h));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var l = 0; l < t.length; l++)o < (c = this.getStringUnitWidth(t[l], {
            font: n
        }) * r) && (o = c);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * r * this.getLineHeightFactor() - r * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        i.call(this), this.addPage();
        var t = this.internal.__cell__.margins || r;
        return this.internal.__cell__.lastCell = new o(t.left, t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function() {
        var t;
        t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), i.call(this);
        var e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || r, c = this.internal.__cell__.tableHeaderRow, u = this.internal.__cell__.printHeaders;
        return void 0 !== e.lineNumber && (e.lineNumber === t.lineNumber ? (t.x = (e.x || 0) + (e.width || 0), t.y = e.y || 0) : e.y + e.height + t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), t.y = s.top, u && c && (this.printHeaderRow(t.lineNumber, !0), t.y += c[0].height)) : t.y = e.y + e.height || t.y), void 0 !== t.text[0] && (this.rect(t.x, t.y, t.width, t.height, !0 === n ? "FD" : void 0), "right" === t.align ? this.text(t.text, t.x + t.width - a, t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === t.align ? this.text(t.text, t.x + t.width / 2, t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: t.width - a - a
        }) : this.text(t.text, t.x + a, t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: t.width - a - a
        })), this.internal.__cell__.lastCell = t, this;
    };
    e.table = function(e, n, u, h, l) {
        if (i.call(this), !u) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], y = {}, w = {}, N = [], L = [], A = (l = l || {}).autoSize || !1, x = !1 !== l.printHeaders, S = l.css && void 0 !== l.css["font-size"] ? 16 * l.css["font-size"] : l.fontSize || 12, _ = l.margins || Object.assign({
            width: this.getPageWidth()
        }, r), P = "number" == typeof l.padding ? l.padding : 3, k = l.headerBackgroundColor || "#c8c8c8", I = l.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = x, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = I, this.setFontSize(S), null == h) v = m = Object.keys(u[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(h) && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(h[0])) for(m = h.map(function(t) {
            return t.name;
        }), v = h.map(function(t) {
            return t.prompt || t.name || "";
        }), b = h.map(function(t) {
            return t.align || "left";
        }), f = 0; f < h.length; f += 1)w[h[f].name] = h[f].width * (19.049976 / 25.4);
        else Array.isArray(h) && "string" == typeof h[0] && (v = m = h, b = m.map(function() {
            return "left";
        }));
        if (A || Array.isArray(h) && "string" == typeof h[0]) for(f = 0; f < m.length; f += 1){
            for(y[g = m[f]] = u.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (x) {
            var F = {};
            for(f = 0; f < m.length; f += 1)F[m[f]] = {}, F[m[f]].text = v[f], F[m[f]].align = b[f];
            var C = c.call(this, F, w);
            L = m.map(function(t) {
                return new o(e, n, w[t], C, F[t].text, void 0, F[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var j = h.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < u.length; f += 1){
            "rowStart" in l && l.rowStart instanceof Function && l.rowStart({
                row: f,
                data: u[f]
            }, this);
            var O = c.call(this, u[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = u[f][m[p]];
                "cellStart" in l && l.cellStart instanceof Function && l.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, n, w[m[p]], O, B, f + 2, j[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = n, this;
    };
    var c = function(t, e) {
        var r = this.internal.__cell__.padding, n = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
        return Object.keys(t).map(function(n) {
            var i = t[n];
            return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, e[n] - r - r);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * n / i + r + r;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var r;
        if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var c = [], u = 0; u < this.internal.__cell__.tableHeaderRow.length; u += 1){
            r = this.internal.__cell__.tableHeaderRow[u].clone(), e && (r.y = this.internal.__cell__.margins.top || 0, c.push(r)), r.lineNumber = t;
            var h = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, r), this.setTextColor(h);
        }
        c.length > 0 && this.setTableHeaderRow(c), this.setFont(void 0, "normal"), n = !1;
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API);
var $15d064020a078dff$var$Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, $15d064020a078dff$var$kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], $15d064020a078dff$var$It = $15d064020a078dff$var$_t($15d064020a078dff$var$kt), $15d064020a078dff$var$Ft = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], $15d064020a078dff$var$Ct = $15d064020a078dff$var$_t($15d064020a078dff$var$Ft);
function $15d064020a078dff$var$jt(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), r = function(t) {
        return $15d064020a078dff$var$Pt[t = t || "normal"] ? t : "normal";
    }(t.style), n = function(t) {
        if (!t) return 400;
        if ("number" == typeof t) return t >= 100 && t <= 900 && t % 100 == 0 ? t : 400;
        if (/^\d00$/.test(t)) return parseInt(t);
        switch(t){
            case "bold":
                return 700;
            case "normal":
            default:
                return 400;
        }
    }(t.weight), i = function(t) {
        return "number" == typeof $15d064020a078dff$var$It[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: r,
        weight: n,
        stretch: i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                i,
                r,
                n
            ].join(" ")
        }
    };
}
function $15d064020a078dff$var$Ot(t, e, r, n) {
    var i;
    for(i = r; i >= 0 && i < e.length; i += n)if (t[e[i]]) return t[e[i]];
    for(i = r; i >= 0 && i < e.length; i -= n)if (t[e[i]]) return t[e[i]];
}
var $15d064020a078dff$var$Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, $15d064020a078dff$var$Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function $15d064020a078dff$var$Et(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function $15d064020a078dff$var$qt(t, e, r) {
    for(var n = (r = r || {}).defaultFontFamily || "times", i = Object.assign({}, $15d064020a078dff$var$Bt, r.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (i[(a = $15d064020a078dff$var$jt(e[s])).family] && (a.family = i[a.family]), t.hasOwnProperty(a.family)) {
        o = t[a.family];
        break;
    }
    if (!(o = o || t[n])) throw new Error("Could not find a font-family for the rule '" + $15d064020a078dff$var$Et(a) + "' and default family '" + n + "'.");
    if (o = function(t, e) {
        if (e[t]) return e[t];
        var r = $15d064020a078dff$var$It[t], n = r <= $15d064020a078dff$var$It.normal ? -1 : 1, i = $15d064020a078dff$var$Ot(e, $15d064020a078dff$var$kt, r, n);
        if (!i) throw new Error("Could not find a matching font-stretch value for " + t);
        return i;
    }(a.stretch, o), o = function(t, e) {
        if (e[t]) return e[t];
        for(var r = $15d064020a078dff$var$Pt[t], n = 0; n < r.length; ++n)if (e[r[n]]) return e[r[n]];
        throw new Error("Could not find a matching font-style for " + t);
    }(a.style, o), !(o = function(t, e) {
        if (e[t]) return e[t];
        if (400 === t && e[500]) return e[500];
        if (500 === t && e[400]) return e[400];
        var r = $15d064020a078dff$var$Ct[t], n = $15d064020a078dff$var$Ot(e, $15d064020a078dff$var$Ft, r, t < 400 ? -1 : 1);
        if (!n) throw new Error("Could not find a matching font-weight for value " + t);
        return n;
    }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + $15d064020a078dff$var$Et(a) + "'.");
    return o;
}
function $15d064020a078dff$var$Dt(t) {
    return t.trimLeft();
}
function $15d064020a078dff$var$Rt(t, e) {
    for(var r = 0; r < t.length;){
        if (t.charAt(r) === e) return [
            t.substring(0, r),
            t.substring(r + 1)
        ];
        r += 1;
    }
    return null;
}
function $15d064020a078dff$var$Tt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var $15d064020a078dff$var$Ut, $15d064020a078dff$var$zt, $15d064020a078dff$var$Ht, $15d064020a078dff$var$Wt = [
    "times"
];


!function(e) {
    var r, n, i, o, s, c, u, h, l, d = function(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new h, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new c, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new c, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), r = this.internal.f2, n = this.internal.getCoordinateString, i = this.internal.getVerticalCoordinateString, o = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, c = this.internal.Point, u = this.internal.Rectangle, h = this.internal.Matrix, l = new d;
        }
    ]);
    var p = function(t) {
        Object.defineProperty(this, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var e = t;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = Boolean(t);
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = Boolean(t);
            }
        });
        var i = 0;
        Object.defineProperty(this, "posX", {
            get: function() {
                return i;
            },
            set: function(t) {
                isNaN(t) || (i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function() {
                return a;
            },
            set: function(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function() {
                return l.margin;
            },
            set: function(t) {
                var e;
                "number" == typeof t ? e = [
                    t,
                    t,
                    t,
                    t
                ] : ((e = new Array(4))[0] = t[0], e[1] = t.length >= 2 ? t[1] : e[0], e[2] = t.length >= 3 ? t[2] : e[0], e[3] = t.length >= 4 ? t[3] : e[1]), l.margin = e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function() {
                return s;
            },
            set: function(t) {
                s = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function() {
                return c;
            },
            set: function(t) {
                c = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function() {
                return l;
            },
            set: function(t) {
                t instanceof d && (l = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function() {
                return l.path;
            },
            set: function(t) {
                l.path = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "ctxStack", {
            get: function() {
                return u;
            },
            set: function(t) {
                u = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function() {
                return this.ctx.fillStyle;
            },
            set: function(t) {
                var e;
                e = g(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function() {
                return this.ctx.strokeStyle;
            },
            set: function(t) {
                var e = g(t);
                this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function() {
                return this.ctx.lineCap;
            },
            set: function(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function() {
                return this.ctx.lineWidth;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function() {
                return this.ctx.lineJoin;
            },
            set: function(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function() {
                return this.ctx.miterLimit;
            },
            set: function(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function() {
                return this.ctx.textBaseline;
            },
            set: function(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function() {
                return this.ctx.textAlign;
            },
            set: function(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var h = null;
        function f(t, e) {
            if (null === h) {
                var r = function(t) {
                    var e = [];
                    return Object.keys(t).forEach(function(r) {
                        t[r].forEach(function(t) {
                            var n = null;
                            switch(t){
                                case "bold":
                                    n = {
                                        family: r,
                                        weight: "bold"
                                    };
                                    break;
                                case "italic":
                                    n = {
                                        family: r,
                                        style: "italic"
                                    };
                                    break;
                                case "bolditalic":
                                    n = {
                                        family: r,
                                        weight: "bold",
                                        style: "italic"
                                    };
                                    break;
                                case "":
                                case "normal":
                                    n = {
                                        family: r
                                    };
                            }
                            null !== n && (n.ref = {
                                name: r,
                                style: t
                            }, e.push(n));
                        });
                    }), e;
                }(t.getFontList());
                h = function(t) {
                    for(var e = {}, r = 0; r < t.length; ++r){
                        var n = $15d064020a078dff$var$jt(t[r]), i = n.family, a = n.stretch, o = n.style, s = n.weight;
                        e[i] = e[i] || {}, e[i][a] = e[i][a] || {}, e[i][a][o] = e[i][a][o] || {}, e[i][a][o][s] = n;
                    }
                    return e;
                }(r.concat(e));
            }
            return h;
        }
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function() {
                return p;
            },
            set: function(t) {
                h = null, p = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function() {
                return this.ctx.font;
            },
            set: function(t) {
                var e;
                if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var r = e[1], n = (e[2], e[3]), i = e[4], a = (e[5], e[6]), o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
                    i = "px" === o ? Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
                    var s = function(t) {
                        var e, r, n = [], i = t.trim();
                        if ("" === i) return $15d064020a078dff$var$Wt;
                        if (i in $15d064020a078dff$var$Mt) return [
                            $15d064020a078dff$var$Mt[i]
                        ];
                        for(; "" !== i;){
                            switch(r = null, e = (i = $15d064020a078dff$var$Dt(i)).charAt(0)){
                                case '"':
                                case "'":
                                    r = $15d064020a078dff$var$Rt(i.substring(1), e);
                                    break;
                                default:
                                    r = $15d064020a078dff$var$Tt(i);
                            }
                            if (null === r) return $15d064020a078dff$var$Wt;
                            if (n.push(r[0]), "" !== (i = $15d064020a078dff$var$Dt(r[1])) && "," !== i.charAt(0)) return $15d064020a078dff$var$Wt;
                            i = i.replace(/^,/, "");
                        }
                        return n;
                    }(a);
                    if (this.fontFaces) {
                        var c = $15d064020a078dff$var$qt(f(this.pdf, this.fontFaces), s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: n,
                                style: r
                            };
                        }));
                        this.pdf.setFont(c.ref.name, c.ref.style);
                    } else {
                        var u = "";
                        ("bold" === n || parseInt(n, 10) >= 700 || "bold" === r) && (u = "bold"), "italic" === r && (u += "italic"), 0 === u.length && (u = "normal");
                        for(var h = "", l = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, d = 0; d < s.length; d++){
                            if (void 0 !== this.pdf.internal.getFont(s[d], u, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d];
                                break;
                            }
                            if ("bolditalic" === u && void 0 !== this.pdf.internal.getFont(s[d], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) h = s[d], u = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[d], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d], u = "normal";
                                break;
                            }
                        }
                        if ("" === h) {
                            for(var p = 0; p < s.length; p++)if (l[s[p]]) {
                                h = l[s[p]];
                                break;
                            }
                        }
                        h = "" === h ? "Times" : h, this.pdf.setFont(h, u);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function() {
                return this.ctx.globalCompositeOperation;
            },
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function() {
                return this.ctx.globalAlpha;
            },
            set: function(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function() {
                return this.ctx.lineDashOffset;
            },
            set: function(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function() {
                return this.ctx.lineDash;
            },
            set: function(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function() {
                return this.ctx.ignoreClearRect;
            },
            set: function(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        A.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        A.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "mt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(t, e);
    }, p.prototype.closePath = function() {
        var e = new c(0, 0), r = 0;
        for(r = this.path.length - 1; -1 !== r; r--)if ("begin" === this.path[r].type && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(this.path[r + 1]) && "number" == typeof this.path[r + 1].x) {
            e = new c(this.path[r + 1].x, this.path[r + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new c(e.x, e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "lt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(r.x, r.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), A.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, r, n) {
        if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var i = this.ctx.transform.applyToPoint(new c(r, n)), o = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "qct",
            x1: o.x,
            y1: o.y,
            x: i.x,
            y: i.y
        }), this.ctx.lastPoint = new c(i.x, i.y);
    }, p.prototype.bezierCurveTo = function(t, e, r, n, i, o) {
        if (isNaN(i) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new c(i, o)), u = this.ctx.transform.applyToPoint(new c(t, e)), h = this.ctx.transform.applyToPoint(new c(r, n));
        this.path.push({
            type: "bct",
            x1: u.x,
            y1: u.y,
            x2: h.x,
            y2: h.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new c(s.x, s.y);
    }, p.prototype.arc = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (o = Boolean(o), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new c(t, e));
            t = s.x, e = s.y;
            var u = this.ctx.transform.applyToPoint(new c(0, r)), h = this.ctx.transform.applyToPoint(new c(0, 0));
            r = Math.sqrt(Math.pow(u.x - h.x, 2) + Math.pow(u.y - h.y, 2));
        }
        Math.abs(i - n) >= 2 * Math.PI && (n = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: r,
            startAngle: n,
            endAngle: i,
            counterclockwise: o
        });
    }, p.prototype.arcTo = function(t, e, r, n, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + n), this.lineTo(t, e + n), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var i = {};
            "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, n), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, r, n), this.stroke());
    }, p.prototype.clearRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, n));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var n = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = n;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function(t) {
        var e, r, n, i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) e = 0, r = 0, n = 0, i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), i = parseFloat(a[4]);
            else {
                if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $15d064020a078dff$var$f(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (e = t.substring(1, 2), e += e, r = t.substring(2, 3), r += r, n = t.substring(3, 4), n += n) : (e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7)), e = parseInt(e, 16), r = parseInt(r, 16), n = parseInt(n, 16);
            }
        }
        return {
            r: e,
            g: r,
            b: n,
            a: i,
            style: t
        };
    }, m = function() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $15d064020a078dff$var$a.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (n = isNaN(n) ? void 0 : n, !m.call(this)) {
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.strokeText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $15d064020a078dff$var$a.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            n = isNaN(n) ? void 0 : n;
            var i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                renderingMode: "stroke",
                angle: i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $15d064020a078dff$var$a.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var e = this.pdf, r = this.pdf.internal.scaleFactor, n = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * n / e.internal.scaleFactor, o = function(t) {
            var e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function() {
                    return e;
                }
            }), this;
        };
        return new o({
            width: i *= Math.round(96 * r / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var r = new h(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var e = new h(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var r = new h(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.transform = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(o)) throw $15d064020a078dff$var$a.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new h(t, e, r, n, i, o);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, r, n, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 1 : n, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new h(t, e, r, n, i, a);
    };
    var b = function() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, r, n, i, a, o, s, c) {
        var l = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== n && void 0 !== s && (p = s / n, g = c / i, f = l.width / n * s / n, d = l.height / i * c / i), void 0 === a && (a = e, o = r, e = 0, r = 0), void 0 !== n && void 0 === s && (s = n, c = i), void 0 === n && void 0 === s && (s = l.width, c = l.height);
        for(var m, v = this.ctx.transform.decompose(), w = q(v.rotate.shx), A = new h, S = (A = (A = (A = A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a - e * p, o - r * g, n * f, i * d)), _ = y.call(this, S), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
        if (L(P), this.autoPaging) for(var I = P[0], F = P[P.length - 1], C = I; C < F + 1; C++){
            this.pdf.setPage(C);
            var j = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === C ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], E = 1 === C ? 0 : B + (C - 2) * M;
            if (0 !== this.ctx.clip_path.length) {
                var D = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = D;
            }
            var R = JSON.parse(JSON.stringify(S));
            R = N([
                R
            ], this.posX + this.margin[3], -E + O + this.ctx.prevPageLastElemOffset)[0];
            var T = (C > I || C < F) && b.call(this);
            T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], j, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", R.x, R.y, R.w, R.h, null, null, w), T && this.pdf.restoreGraphicsState();
        }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var y = function(t, e, r) {
        var n = [];
        e = e || this.pdf.internal.pageSize.width, r = r || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                n.push(Math.floor((t.y + i) / r) + 1);
                break;
            case "arc":
                n.push(Math.floor((t.y + i - t.radius) / r) + 1), n.push(Math.floor((t.y + i + t.radius) / r) + 1);
                break;
            case "qct":
                var a = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                n.push(Math.floor((a.y + i) / r) + 1), n.push(Math.floor((a.y + a.h + i) / r) + 1);
                break;
            case "bct":
                var o = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                n.push(Math.floor((o.y + i) / r) + 1), n.push(Math.floor((o.y + o.h + i) / r) + 1);
                break;
            case "rect":
                n.push(Math.floor((t.y + i) / r) + 1), n.push(Math.floor((t.y + t.h + i) / r) + 1);
        }
        for(var s = 0; s < n.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < n[s];)w.call(this);
        return n;
    }, w = function() {
        var t = this.fillStyle, e = this.strokeStyle, r = this.font, n = this.lineCap, i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = r, this.lineCap = n, this.lineWidth = i, this.lineJoin = a;
    }, N = function(t, e, r) {
        for(var n = 0; n < t.length; n++)switch(t[n].type){
            case "bct":
                t[n].x2 += e, t[n].y2 += r;
            case "qct":
                t[n].x1 += e, t[n].y1 += r;
            case "mt":
            case "lt":
            case "arc":
            default:
                t[n].x += e, t[n].y += r;
        }
        return t;
    }, L = function(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, A = function(t, e) {
        for(var r, n, i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, c = Math.abs(s * this.ctx.transform.scaleX), u = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), l = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < l.length; d++)if (void 0 !== l[d].x) for(var p = y.call(this, l[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
        if (L(f), this.autoPaging) for(var v = f[0], A = f[f.length - 1], S = v; S < A + 1; S++){
            this.pdf.setPage(S), this.fillStyle = i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = c, this.lineJoin = u;
            var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], I = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], F = 1 === S ? 0 : k + (S - 2) * I;
            if (0 !== this.ctx.clip_path.length) {
                var C = this.path;
                r = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(r, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), x.call(this, t, !0), this.path = C;
            }
            if (n = JSON.parse(JSON.stringify(h)), this.path = N(n, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                var j = (S > v || S < A) && b.call(this);
                j && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, I, null).clip().discardPath()), x.call(this, t, e), j && this.pdf.restoreGraphicsState();
            }
            this.lineWidth = s;
        }
        else this.lineWidth = c, x.call(this, t, e), this.lineWidth = s;
        this.path = h;
    }, x = function(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var r, n, i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var c = i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (r = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], c > 0)) {
                            for(; c >= 0; c--)if (!0 !== i[c - 1].close && !0 !== i[c - 1].begin) {
                                i[c - 1].deltas.push(r), i[c - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        r = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "qct":
                        var u = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), h = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), l = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        r = [
                            u - a[o - 1].x,
                            h - a[o - 1].y,
                            l - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], i[i.length - 1].deltas.push(r);
                        break;
                    case "arc":
                        i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
                }
            }
            n = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < i.length; b++)if (i[b].arc) for(var y = i[b].abs, w = 0; w < y.length; w++){
                var N = y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : j.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== i[b].begin) {
                var L = i[b].start.x, A = i[b].start.y;
                O.call(this, i[b].deltas, L, A), g = !0;
            }
            n && k.call(this, n), e && I.call(this);
        }
    }, S = function(t) {
        var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, r = e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - r;
            case "top":
                return t + e - r;
            case "hanging":
                return t + e - 2 * r;
            case "middle":
                return t + e / 2 - r;
            case "ideographic":
                return t;
            case "alphabetic":
            default:
                return t;
        }
    }, _ = function(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var t = function() {};
        return t.colorStops = [], t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, t.isCanvasGradient = !0, t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function(t, e, r, n, i, a, o, s, c) {
        for(var u = M.call(this, r, n, i, a), h = 0; h < u.length; h++){
            var l = u[h];
            0 === h && (c ? F.call(this, l.x1 + t, l.y1 + e) : j.call(this, l.x1 + t, l.y1 + e)), B.call(this, t, e, l.x2, l.y2, l.x3, l.y3, l.x4, l.y4);
        }
        s ? I.call(this) : k.call(this, o);
    }, k = function(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, I = function() {
        this.pdf.clip(), this.pdf.discardPath();
    }, F = function(t, e) {
        this.pdf.internal.out(n(t) + " " + i(e) + " m");
    }, C = function(t) {
        var e;
        switch(t.align){
            case "right":
            case "end":
                e = "right";
                break;
            case "center":
                e = "center";
                break;
            case "left":
            case "start":
            default:
                e = "left";
        }
        var r = this.pdf.getTextDimensions(t.text), n = S.call(this, t.y), i = _.call(this, n) - r.h, a = this.ctx.transform.applyToPoint(new c(t.x, n)), o = this.ctx.transform.decompose(), s = new h;
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for(var l, f, d, p = this.ctx.transform.applyToRectangle(new u(t.x, n, r.w, r.h)), g = s.applyToRectangle(new u(t.x, i, r.w, r.h)), m = y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for(var A = v[0], P = v[v.length - 1], k = A; k < P + 1; k++){
            this.pdf.setPage(k);
            var I = 1 === k ? this.posY + this.margin[0] : this.margin[0], F = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], C = this.pdf.internal.pageSize.height - this.margin[2], j = C - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : F + (k - 2) * j;
            if (0 !== this.ctx.clip_path.length) {
                var E = this.path;
                l = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(l, this.posX + this.margin[3], -1 * M + I), x.call(this, "fill", !0), this.path = E;
            }
            var q = N([
                JSON.parse(JSON.stringify(g))
            ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0];
            t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
            var D = "text" !== this.autoPaging;
            if (D || q.y + q.h <= C) {
                if (D || q.y >= I && q.x <= O) {
                    var R = D ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - q.x)[0], T = N([
                        JSON.parse(JSON.stringify(p))
                    ], this.posX + this.margin[3], -M + I + this.ctx.prevPageLastElemOffset)[0], U = D && (k > A || k < P) && b.call(this);
                    U && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, j, null).clip().discardPath()), this.pdf.text(R, T.x, T.y, {
                        angle: t.angle,
                        align: e,
                        renderingMode: t.renderingMode
                    }), U && this.pdf.restoreGraphicsState();
                }
            } else q.y < C && (this.ctx.prevPageLastElemOffset += C - q.y);
            t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        }
        else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
            angle: t.angle,
            align: e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
    }, j = function(t, e, r, a) {
        r = r || 0, a = a || 0, this.pdf.internal.out(n(t + r) + " " + i(e + a) + " l");
    }, O = function(t, e, r) {
        return this.pdf.lines(t, e, r, null, null);
    }, B = function(t, e, n, i, a, c, u, h) {
        this.pdf.internal.out([
            r(o(n + t)),
            r(s(i + e)),
            r(o(a + t)),
            r(s(c + e)),
            r(o(u + t)),
            r(s(h + e)),
            "c"
        ].join(" "));
    }, M = function(t, e, r, n) {
        for(var i = 2 * Math.PI, a = Math.PI / 2; e > r;)e -= i;
        var o = Math.abs(r - e);
        o < i && n && (o = i - o);
        for(var s = [], c = n ? -1 : 1, u = e; o > 1e-5;){
            var h = u + c * Math.min(o, a);
            s.push(E.call(this, t, u, h)), o -= Math.abs(h - u), u = h;
        }
        return s;
    }, E = function(t, e, r) {
        var n = (r - e) / 2, i = t * Math.cos(n), a = t * Math.sin(n), o = i, s = -a, c = o * o + s * s, u = c + o * i + s * a, h = 4 / 3 * (Math.sqrt(2 * c * u) - u) / (o * a - s * i), l = o - h * s, f = s + h * o, d = l, p = -f, g = n + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: l * m - f * v,
            y2: l * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(r),
            y4: t * Math.sin(r)
        };
    }, q = function(t) {
        return 180 * t / Math.PI;
    }, D = function(t, e, r, n, i, a) {
        var o = t + .5 * (r - t), s = e + .5 * (n - e), c = i + .5 * (r - i), h = a + .5 * (n - a), l = Math.min(t, i, o, c), f = Math.max(t, i, o, c), d = Math.min(e, a, s, h), p = Math.max(e, a, s, h);
        return new u(l, d, f - l, p - d);
    }, R = function(t, e, r, n, i, a, o, s) {
        var c, h, l, f, d, p, g, m, v, b, y, w, N, L, A = r - t, x = n - e, S = i - r, _ = a - n, P = o - i, k = s - a;
        for(h = 0; h < 41; h++)v = (g = (l = t + (c = h / 40) * A) + c * ((d = r + c * S) - l)) + c * (d + c * (i + c * P - d) - g), b = (m = (f = e + c * x) + c * ((p = n + c * _) - f)) + c * (p + c * (a + c * k - p) - m), 0 == h ? (y = v, w = b, N = v, L = b) : (y = Math.min(y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new u(Math.round(y), Math.round(w), Math.round(N - y), Math.round(L - w));
    }, T = function() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var t, e, r = (t = this.ctx.lineDash, e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: t,
                lineDashOffset: e
            }));
            this.prevLineDash !== r && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r);
        }
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var r = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        for(/[^\x00-\xFF]/.test(t), r = [], n = 0, i = (t += e = "\0\0\0\0".slice(t.length % 4 || 4)).length; i > n; n += 4)0 !== (a = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (o = (a = ((a = ((a = ((a = (a - (h = a % 85)) / 85) - (u = a % 85)) / 85) - (c = a % 85)) / 85) - (s = a % 85)) / 85) % 85, r.push(o + 33, s + 33, c + 33, u + 33, h + 33)) : r.push(122);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(r, e.length), String.fromCharCode.apply(String, r) + "~>";
    }, n = function(t) {
        var e, r, n, i, a, o = String, s = "length", c = 255, u = "charCodeAt", h = "slice", l = "replace";
        for(t[h](-2), t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"), n = [], i = 0, a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s]; a > i; i += 5)r = 52200625 * (t[u](i) - 33) + 614125 * (t[u](i + 1) - 33) + 7225 * (t[u](i + 2) - 33) + 85 * (t[u](i + 3) - 33) + (t[u](i + 4) - 33), n.push(c & r >> 24, c & r >> 16, c & r >> 8, c & r);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(n, e[s]), o.fromCharCode.apply(o, n);
    }, i = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var r = "", n = 0; n < t.length; n += 2)r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
        return r;
    }, a = function(t) {
        for(var r = new Uint8Array(t.length), n = t.length; n--;)r[n] = t.charCodeAt(n);
        return t = (r = (0, $461bf5d8bd29e0d8$export$f87121a6d50aff25)(r)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var o = 0, s = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), o = 0; o < e.length; o += 1)switch(e[o]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                s = n(s), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                s = r(s), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                s = i(s), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                s = s.split("").map(function(t) {
                    return ("0" + t.charCodeAt().toString(16)).slice(-2);
                }).join("") + ">", c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                s = a(s), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[o] + '" is not implemented');
        }
        return {
            data: s,
            reverseChain: c.reverse().join(" ")
        };
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, r) {
        return function(t, e, r) {
            e = !1 !== e, r = "function" == typeof r ? r : function() {};
            var n = void 0;
            try {
                n = function(t, e, r) {
                    var n = new XMLHttpRequest, i = 0, a = function(t) {
                        var e = t.length, r = [], n = String.fromCharCode;
                        for(i = 0; i < e; i += 1)r.push(n(255 & t.charCodeAt(i)));
                        return r.join("");
                    };
                    if (n.open("GET", t, !e), n.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (n.onload = function() {
                        200 === n.status ? r(a(this.responseText)) : r(void 0);
                    }), n.send(null), e && 200 === n.status) return a(n.responseText);
                }(t, e, r);
            } catch (t) {}
            return n;
        }(t, e, r);
    }, t.loadImageFile = t.loadFile;
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), function(e) {
    function r() {
        return ($15d064020a078dff$var$n.html2canvas ? Promise.resolve($15d064020a078dff$var$n.html2canvas) : Promise.resolve((parcelRequire("7JB23")))).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    function i() {
        return ($15d064020a078dff$var$n.DOMPurify ? Promise.resolve($15d064020a078dff$var$n.DOMPurify) : (parcelRequire("lbArK"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    var a = function(e) {
        var r = (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e);
        return "undefined" === r ? "undefined" : "string" === r || e instanceof String ? "string" : "number" === r || e instanceof Number ? "number" : "function" === r || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === r ? "object" : "unknown";
    }, o = function(t, e) {
        var r = document.createElement(t);
        for(var n in e.className && (r.className = e.className), e.innerHTML && e.dompurify && (r.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)r.style[n] = e.style[n];
        return r;
    }, s = function t(e) {
        var r = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), n = t.convert(Promise.resolve(), r);
        return n = (n = n.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(t, e) {
        return t.__proto__ = e || s.prototype, t;
    }, s.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, s.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t)){
                case "string":
                    return this.then(i).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, s.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, s.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, e = function t(e, r) {
                for(var n = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== r && 1 === i.nodeType && "SCRIPT" === i.nodeName || n.appendChild(t(i, r));
                return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (n.width = e.width, n.height = e.height, n.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (n.value = e.value), n.addEventListener("load", function() {
                    n.scrollTop = e.scrollTop, n.scrollLeft = e.scrollLeft;
                }, !0)), n;
            }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, s.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = Object.assign({}, this.opt.html2canvas);
            return delete e.onrendered, t(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(r).then(function(t) {
            var e = this.opt.jsPDF, r = this.opt.fontFaces, n = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: n,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete i.onrendered, e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, e.context2d.posX = this.opt.x, e.context2d.posY = this.opt.y, e.context2d.margin = this.opt.margin, e.context2d.fontFaces = r, r) for(var a = 0; a < r.length; ++a){
                var o = r[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return i.windowHeight = i.windowHeight || 0, i.windowHeight = 0 == i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, e.context2d.save(!0), t(this.prop.container, i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, s.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, s.prototype.output = function(t, e, r) {
        return "img" === (r = r || "pdf").toLowerCase() || "image" === r.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, s.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, s.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, s.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, s.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, s.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var e = Object.keys(t || {}).map(function(e) {
            if (e in s.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(e);
        });
    }, s.prototype.get = function(t, e) {
        return this.then(function() {
            var r = t in s.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(r) : r;
        });
    }, s.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, s.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || $15d064020a078dff$export$ba1e2ffc633a60f5.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, s.prototype.setProgress = function(t, e, r, n) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != r && (this.progress.n = r), null != n && (this.progress.stack = n), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, s.prototype.updateProgress = function(t, e, r, n) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, r ? this.progress.n + r : null, n ? this.progress.stack.concat(n) : null);
    }, s.prototype.then = function(t, e) {
        var r = this;
        return this.thenCore(t, e, function(t, e) {
            return r.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return r.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return r.updateProgress(1), t;
            });
        });
    }, s.prototype.thenCore = function(t, e, r) {
        r = r || Promise.prototype.then;
        t && (t = t.bind(this)), e && (e = e.bind(this));
        var n = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? this : s.convert(Object.assign({}, this), Promise.prototype), i = r.call(n, t, e);
        return s.convert(i, this.__proto__);
    }, s.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, s.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, s.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return s.convert(e, this);
    }, s.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, s.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, $15d064020a078dff$export$ba1e2ffc633a60f5.getPageSize = function(e, r, n) {
        if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e)) {
            var i = e;
            e = i.orientation, r = i.unit || r, n = i.format || n;
        }
        r = r || "mm", n = n || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + n).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(r){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + r;
        }
        var c, u = 0, h = 0;
        if (s.hasOwnProperty(o)) u = s[o][1] / a, h = s[o][0] / a;
        else try {
            u = n[1], h = n[0];
        } catch (t) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === e || "portrait" === e) e = "p", h > u && (c = h, h = u, u = c);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", u > h && (c = h, h = u, u = c);
        }
        return {
            width: h,
            height: u,
            unit: r,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map($15d064020a078dff$var$jt) : null;
        var r = new s(e);
        return e.worker ? r : r.from(t).doCallback();
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), $15d064020a078dff$export$ba1e2ffc633a60f5.API.addJS = function(t) {
    return $15d064020a078dff$var$Ht = t, this.internal.events.subscribe("postPutResources", function() {
        $15d064020a078dff$var$Ut = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($15d064020a078dff$var$Ut + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), $15d064020a078dff$var$zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + $15d064020a078dff$var$Ht + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== $15d064020a078dff$var$Ut && void 0 !== $15d064020a078dff$var$zt && this.internal.out("/Names <</JavaScript " + $15d064020a078dff$var$Ut + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var t = this, r = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var n = t.outline.render().split(/\r\n/), i = 0; i < n.length; i++){
                var a = n[i], o = r.exec(a);
                if (null != o) {
                    var s = o[1];
                    t.internal.newObjectDeferredBegin(s, !1);
                }
                t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var c = this.internal.pages.length, u = [];
                for(i = 0; i < c; i++){
                    var h = t.internal.newObject();
                    u.push(h);
                    var l = t.internal.getPageInfo(i + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = t.internal.newObject();
                t.internal.write("<< /Names [ ");
                for(i = 0; i < u.length; i++)t.internal.write("(page_" + (i + 1) + ")" + u[i] + " 0 R");
                t.internal.write(" ] >>", "endobj"), e = t.internal.newObject(), t.internal.write("<< /Dests " + f + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var t = this;
            t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, t.outline.add = function(t, e, r) {
                var n = {
                    title: e,
                    options: r,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(n), n;
            }, t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, t.outline.genIds_r = function(e) {
                e.id = t.internal.newObjectDeferred();
                for(var r = 0; r < e.children.length; r++)this.genIds_r(e.children[r]);
            }, t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, t.outline.renderItems = function(e) {
                for(var r = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < e.children.length; n++){
                    var i = e.children[n];
                    this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(e)), n > 0 && this.line("/Prev " + this.makeRef(e.children[n - 1])), n < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[n + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, i);
                    if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
                        var o = t.internal.getPageInfo(i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + r(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, t.outline.makeString = function(e) {
                return "(" + t.internal.pdfEscape(e) + ")";
            }, t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, t.outline.count_r = function(t, e) {
                for(var r = 0; r < e.children.length; r++)t.count++, this.count_r(t, e.children[r]);
                return t.count;
            };
        }
    ]);
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, r, n, i, a, o) {
        var s, c = this.decode.DCT_DECODE, u = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, (s = function(t) {
                for(var r, n = 256 * t.charCodeAt(4) + t.charCodeAt(5), i = t.length, a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, o = 4; o < i; o += 2){
                    if (o += n, -1 !== e.indexOf(t.charCodeAt(o + 1))) {
                        r = 256 * t.charCodeAt(o + 5) + t.charCodeAt(o + 6), a = {
                            width: 256 * t.charCodeAt(o + 7) + t.charCodeAt(o + 8),
                            height: r,
                            numcomponents: t.charCodeAt(o + 9)
                        };
                        break;
                    }
                    n = 256 * t.charCodeAt(o + 2) + t.charCodeAt(o + 3);
                }
                return a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t)).numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            u = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: c,
                index: r,
                alias: n
            };
        }
        return u;
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API);
var $15d064020a078dff$var$Vt, $15d064020a078dff$var$Gt, $15d064020a078dff$var$Yt, $15d064020a078dff$var$Jt, $15d064020a078dff$var$Xt, $15d064020a078dff$var$Kt = function() {
    var t, e, i;
    function a(t) {
        var e, r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o = null;;){
            switch(e = this.readUInt32(), u = (function() {
                var t, e;
                for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                return e;
            }).call(this).join("")){
                case "IHDR":
                    this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                    break;
                case "acTL":
                    this.animation = {
                        numFrames: this.readUInt32(),
                        numPlays: this.readUInt32() || 1 / 0,
                        frames: []
                    };
                    break;
                case "PLTE":
                    this.palette = this.read(e);
                    break;
                case "fcTL":
                    o && this.animation.frames.push(o), this.pos += 4, o = {
                        width: this.readUInt32(),
                        height: this.readUInt32(),
                        xOffset: this.readUInt32(),
                        yOffset: this.readUInt32()
                    }, a = this.readUInt16(), i = this.readUInt16() || 100, o.delay = 1e3 * a / i, o.disposeOp = this.data[this.pos++], o.blendOp = this.data[this.pos++], o.data = [];
                    break;
                case "IDAT":
                case "fdAT":
                    for("fdAT" === u && (this.pos += 4, e -= 4), t = (null != o ? o.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : f > e; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    switch(this.transparency = {}, this.colorType){
                        case 3:
                            if (n = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > n) throw new Error("More transparent colors than palette size");
                            if ((h = n - this.transparency.indexed.length) > 0) for(d = 0; 0 <= h ? d < h : d > h; 0 <= h ? ++d : --d)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            this.transparency.grayscale = this.read(e)[0];
                            break;
                        case 2:
                            this.transparency.rgb = this.read(e);
                    }
                    break;
                case "tEXt":
                    s = (l = this.read(e)).indexOf(0), c = String.fromCharCode.apply(String, l.slice(0, s)), this.text[c] = String.fromCharCode.apply(String, l.slice(s + 1));
                    break;
                case "IEND":
                    return o && this.animation.frames.push(o), this.colors = (function() {
                        switch(this.colorType){
                            case 0:
                            case 3:
                            case 4:
                                return 1;
                            case 2:
                            case 6:
                                return 3;
                        }
                    }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, r = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * r, this.colorSpace = (function() {
                        switch(this.colors){
                            case 1:
                                return "DeviceGray";
                            case 3:
                                return "DeviceRGB";
                        }
                    }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                default:
                    this.pos += e;
            }
            if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    a.prototype.read = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e)r.push(this.data[this.pos++]);
        return r;
    }, a.prototype.readUInt32 = function() {
        return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.readUInt16 = function() {
        return this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.decodePixels = function(t) {
        var e = this.pixelBitlength / 8, n = new Uint8Array(this.width * this.height * e), i = 0, a = this;
        if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
        function o(r, o, s, c) {
            var u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F = Math.ceil((a.width - r) / s), C = Math.ceil((a.height - o) / c), j = a.width == F && a.height == C;
            for(L = e * F, w = j ? n : new Uint8Array(L * C), p = t.length, N = 0, h = 0; N < C && i < p;){
                switch(t[i++]){
                    case 0:
                        for(f = S = 0; S < L; f = S += 1)w[h++] = t[i++];
                        break;
                    case 1:
                        for(f = _ = 0; _ < L; f = _ += 1)u = t[i++], d = f < e ? 0 : w[h - e], w[h++] = (u + d) % 256;
                        break;
                    case 2:
                        for(f = P = 0; P < L; f = P += 1)u = t[i++], l = (f - f % e) / e, A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (A + u) % 256;
                        break;
                    case 3:
                        for(f = k = 0; k < L; f = k += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (u + Math.floor((d + A) / 2)) % 256;
                        break;
                    case 4:
                        for(f = I = 0; I < L; f = I += 1)u = t[i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], 0 === N ? A = x = 0 : (A = w[(N - 1) * L + l * e + f % e], x = l && w[(N - 1) * L + (l - 1) * e + f % e]), g = d + A - x, m = Math.abs(g - d), b = Math.abs(g - A), y = Math.abs(g - x), v = m <= b && m <= y ? d : b <= y ? A : x, w[h++] = (u + v) % 256;
                        break;
                    default:
                        throw new Error("Invalid filter algorithm: " + t[i - 1]);
                }
                if (!j) {
                    var O = ((o + N * c) * a.width + r) * e, B = N * L;
                    for(f = 0; f < F; f += 1){
                        for(var M = 0; M < e; M += 1)n[O++] = w[B++];
                        O += (s - 1) * e;
                    }
                }
                N++;
            }
        }
        return t = (0, $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6)(t), 1 == a.interlaceMethod ? (o(0, 0, 8, 8), o(4, 0, 8, 8), o(0, 4, 4, 8), o(2, 0, 4, 4), o(0, 2, 2, 4), o(1, 0, 2, 2), o(0, 1, 1, 2)) : o(0, 0, 1, 1), n;
    }, a.prototype.decodePalette = function() {
        var t, e, r, n, i, a, o, s, c;
        for(r = this.palette, a = this.transparency.indexed || [], i = new Uint8Array((a.length || 0) + r.length), n = 0, t = 0, e = o = 0, s = r.length; o < s; e = o += 3)i[n++] = r[e], i[n++] = r[e + 1], i[n++] = r[e + 2], i[n++] = null != (c = a[t++]) ? c : 255;
        return i;
    }, a.prototype.copyToImageData = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f;
        if (n = this.colors, h = null, r = this.hasAlphaChannel, this.palette.length && (h = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), n = 4, r = !0), u = (i = t.data || t).length, o = h || e, a = s = 0, 1 === n) for(; a < u;)c = h ? 4 * e[a / 4] : s, l = o[c++], i[a++] = l, i[a++] = l, i[a++] = l, i[a++] = r ? o[c++] : 255, s = c;
        else for(; a < u;)c = h ? 4 * e[a / 4] : s, i[a++] = o[c++], i[a++] = o[c++], i[a++] = o[c++], i[a++] = r ? o[c++] : 255, s = c;
    }, a.prototype.decode = function() {
        var t;
        return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
    };
    var o = function() {
        if ("[object Window]" === Object.prototype.toString.call($15d064020a078dff$var$n)) {
            try {
                e = $15d064020a078dff$var$n.document.createElement("canvas"), i = e.getContext("2d");
            } catch (t) {
                return !1;
            }
            return !0;
        }
        return !1;
    };
    return o(), t = function(t) {
        var r;
        if (!0 === o()) return i.width = t.width, i.height = t.height, i.clearRect(0, 0, t.width, t.height), i.putImageData(t, 0, 0), (r = new Image).src = e.toDataURL(), r;
        throw new Error("This method requires a Browser with Canvas-capability.");
    }, a.prototype.decodeFrames = function(e) {
        var r, n, i, a, o, s, c, u;
        if (this.animation) {
            for(u = [], n = o = 0, s = (c = this.animation.frames).length; o < s; n = ++o)r = c[n], i = e.createImageData(r.width, r.height), a = this.decodePixels(new Uint8Array(r.data)), this.copyToImageData(i, a), r.imageData = i, u.push(r.image = t(i));
            return u;
        }
    }, a.prototype.renderFrame = function(t, e) {
        var r, n, i;
        return r = (n = this.animation.frames)[e], i = n[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === r.blendOp && t.clearRect(r.xOffset, r.yOffset, r.width, r.height), t.drawImage(r.image, r.xOffset, r.yOffset);
    }, a.prototype.animate = function(t) {
        var e, r, n, i, a, o, s = this;
        return r = 0, o = this.animation, i = o.numFrames, n = o.frames, a = o.numPlays, (e = function() {
            var o, c;
            if (o = r++ % i, c = n[o], s.renderFrame(t, o), i > 1 && r / i < a) return s.animation._timeout = setTimeout(e, c.delay);
        })();
    }, a.prototype.stopAnimation = function() {
        var t;
        return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
    }, a.prototype.render = function(t) {
        var e, r;
        return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (r = e.createImageData(this.width, this.height), this.copyToImageData(r, this.decodePixels()), e.putImageData(r, 0, 0));
    }, a;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ /**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */ function $15d064020a078dff$var$Zt(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | t[e++] << 8, n = t[e++] | t[e++] << 8, i = t[e++], a = i >> 7, o = 1 << (7 & i) + 1;
    t[e++];
    t[e++];
    var s = null, c = null;
    a && (s = e, c = o, e += 3 * o);
    var u = !0, h = [], l = 0, f = null, d = 0, p = null;
    for(this.width = r, this.height = n; u && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    l = t[e++] | t[e++] << 8, f = t[e++], 0 == (1 & g) && (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << (7 & w) + 1, A = s, x = c, S = !1;
            if (w >> 7) {
                S = !0;
                A = e, x = L, e += 3 * L;
            }
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            h.push({
                x: m,
                y: v,
                width: b,
                height: y,
                has_local_palette: S,
                palette_offset: A,
                palette_size: x,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: l,
                disposal: d
            });
            break;
        case 59:
            u = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return h.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= h.length) throw new Error("Frame index out of range.");
        return h[t];
    }, this.decodeAndBlitFrameBGRA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $15d064020a078dff$var$$t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = L, n[p++] = N, n[p++] = w, n[p++] = 255;
            }
            --l;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, n) {
        var i = this.frameInfo(e), a = i.width * i.height, o = new Uint8Array(a);
        $15d064020a078dff$var$$t(t, i.data_offset, o, a);
        var s = i.palette_offset, c = i.transparent_index;
        null === c && (c = 256);
        var u = i.width, h = r - u, l = u, f = 4 * (i.y * r + i.x), d = 4 * ((i.y + i.height) * r + i.x), p = f, g = 4 * h;
        !0 === i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), y === c) p += 4;
            else {
                var w = t[s + 3 * y], N = t[s + 3 * y + 1], L = t[s + 3 * y + 2];
                n[p++] = w, n[p++] = N, n[p++] = L, n[p++] = 255;
            }
            --l;
        }
    };
}
function $15d064020a078dff$var$$t(t, e, r, n) {
    for(var i = t[e++], o = 1 << i, s = o + 1, c = s + 1, u = i + 1, h = (1 << u) - 1, l = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; l < 16 && 0 !== p;)f |= t[e++] << l, l += 8, 1 === p ? p = t[e++] : --p;
        if (l < u) break;
        var v = f & h;
        if (f >>= u, l -= u, v !== o) {
            if (v === s) break;
            for(var b = v < c ? v : m, y = 0, w = b; w > o;)w = g[w] >> 8, ++y;
            var N = w;
            if (d + y + (b !== v ? 1 : 0) > n) return void $15d064020a078dff$var$a.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = d += y;
            for(b !== v && (r[d++] = N), w = b; y--;)w = g[w], r[--L] = 255 & w, w >>= 8;
            null !== m && c < 4096 && (g[c++] = m << 8 | N, c >= h + 1 && u < 12 && (++u, h = h << 1 | 1)), m = v;
        } else c = s + 1, h = (1 << (u = i + 1)) - 1, m = null;
    }
    return d !== n && $15d064020a078dff$var$a.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $15d064020a078dff$var$Qt(t) {
    var e, r, n, i, a, o = Math.floor, s = new Array(64), c = new Array(64), u = new Array(64), h = new Array(64), l = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), A = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], x = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], I = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], F = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], C = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    function j(t, e) {
        for(var r = 0, n = 0, i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)i[e[n]] = [], i[e[n]][0] = r, i[e[n]][1] = a, n++, r++;
            r *= 2;
        }
        return i;
    }
    function O(t) {
        for(var e = t[0], r = t[1] - 1; r >= 0;)e & 1 << r && (m |= 1 << v), r--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    }
    function B(t) {
        g.push(t);
    }
    function M(t) {
        B(t >> 8 & 255), B(255 & t);
    }
    function E(t, e, r, n, i) {
        for(var a, o = i[0], s = i[240], c = function(t, e) {
            var r, n, i, a, o, s, c, u, h, l, f = 0;
            for(h = 0; h < 8; ++h){
                r = t[f], n = t[f + 1], i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], c = t[f + 6];
                var p = r + (u = t[f + 7]), g = r - u, m = n + c, v = n - c, b = i + s, y = i - s, w = a + o, N = a - o, L = p + w, A = p - w, x = m + b, S = m - b;
                t[f] = L + x, t[f + 4] = L - x;
                var _ = .707106781 * (S + A);
                t[f + 2] = A + _, t[f + 6] = A - _;
                var P = .382683433 * ((L = N + y) - (S = v + g)), k = .5411961 * L + P, I = 1.306562965 * S + P, F = .707106781 * (x = y + v), C = g + F, j = g - F;
                t[f + 5] = j + k, t[f + 3] = j - k, t[f + 1] = C + I, t[f + 7] = C - I, f += 8;
            }
            for(f = 0, h = 0; h < 8; ++h){
                r = t[f], n = t[f + 8], i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], c = t[f + 48];
                var O = r + (u = t[f + 56]), B = r - u, M = n + c, E = n - c, q = i + s, D = i - s, R = a + o, T = a - o, U = O + R, z = O - R, H = M + q, W = M - q;
                t[f] = U + H, t[f + 32] = U - H;
                var V = .707106781 * (W + z);
                t[f + 16] = z + V, t[f + 48] = z - V;
                var G = .382683433 * ((U = T + D) - (W = E + B)), Y = .5411961 * U + G, J = 1.306562965 * W + G, X = .707106781 * (H = D + E), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(h = 0; h < 64; ++h)l = t[h] * e[h], d[h] = l > 0 ? l + .5 | 0 : l - .5 | 0;
            return d;
        }(t, e), u = 0; u < 64; ++u)p[A[u]] = c[u];
        var h = p[0] - r;
        r = p[0], 0 == h ? O(n[0]) : (O(n[f[a = 32767 + h]]), O(l[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), r;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var y = v - b;
            if (y >= 16) {
                m = y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                y &= 15;
            }
            a = 32767 + p[v], O(i[(y << 4) + f[a]]), O(l[a]), v++;
        }
        return 63 != g && O(o), r;
    }
    function q(t) {
        (t = Math.min(Math.max(t, 1), 100), a != t) && (!function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], r = 0; r < 64; r++){
                var n = o((e[r] * t + 50) / 100);
                n = Math.min(Math.max(n, 1), 255), s[A[r]] = n;
            }
            for(var i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var l = o((i[a] * t + 50) / 100);
                l = Math.min(Math.max(l, 1), 255), c[A[a]] = l;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)u[d] = 1 / (s[A[d]] * f[p] * f[g] * 8), h[d] = 1 / (c[A[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    }
    this.encode = function(t, a) {
        a && q(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var t = 0; t < 64; t++)B(s[t]);
            B(1);
            for(var e = 0; e < 64; e++)B(c[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var t = 0; t < 16; t++)B(x[t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var r = 0; r < 16; r++)B(_[r + 1]);
            for(var n = 0; n <= 161; n++)B(P[n]);
            B(1);
            for(var i = 0; i < 16; i++)B(k[i + 1]);
            for(var a = 0; a <= 11; a++)B(I[a]);
            B(17);
            for(var o = 0; o < 16; o++)B(F[o + 1]);
            for(var s = 0; s <= 161; s++)B(C[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, l = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, A, j, D, R, T, U, z = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(j = V * G + d, R = -1, T = 0, U = 0; U < 64; U++)D = j + (T = U >> 3) * V + (R = 4 * (7 & U)), G + T >= W && (D -= V * (G + 1 + T - W)), d + R >= V && (D -= d + R - V + 4), p = z[D++], N = z[D++], A = z[D++], b[U] = (L[p] + L[N + 256 >> 0] + L[A + 512 >> 0] >> 16) - 128, y[U] = (L[p + 768 >> 0] + L[N + 1024 >> 0] + L[A + 1280 >> 0] >> 16) - 128, w[U] = (L[p + 1280 >> 0] + L[N + 1536 >> 0] + L[A + 1792 >> 0] >> 16) - 128;
                o = E(b, u, o, e, n), l = E(y, h, l, r, i), f = E(w, h, f, r, i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var t = String.fromCharCode, e = 0; e < 256; e++)N[e] = t(e);
    }(), e = j(x, S), r = j(k, I), n = j(_, P), i = j(F, C), function() {
        for(var t = 1, e = 2, r = 1; r <= 15; r++){
            for(var n = t; n < e; n++)f[32767 + n] = r, l[32767 + n] = [], l[32767 + n][1] = r, l[32767 + n][0] = n;
            for(var i = -(e - 1); i <= -t; i++)f[32767 + i] = r, l[32767 + i] = [], l[32767 + i][1] = r, l[32767 + i][0] = e - 1 + i;
            t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var t = 0; t < 256; t++)L[t] = 19595 * t, L[t + 256 >> 0] = 38470 * t, L[t + 512 >> 0] = 7471 * t + 32768, L[t + 768 >> 0] = -11059 * t, L[t + 1024 >> 0] = -21709 * t, L[t + 1280 >> 0] = 32768 * t + 8421375, L[t + 1536 >> 0] = -27439 * t, L[t + 1792 >> 0] = -5329 * t;
    }(), q(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $15d064020a078dff$var$te(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $15d064020a078dff$var$ee(t) {
    function e(t) {
        if (!t) throw Error("assert :P");
    }
    function r(t, e, r) {
        for(var n = 0; 4 > n; n++)if (t[e + n] != r.charCodeAt(n)) return !0;
        return !1;
    }
    function n(t, e, r, n, i) {
        for(var a = 0; a < i; a++)t[e + a] = r[n + a];
    }
    function i(t, e, r, n) {
        for(var i = 0; i < n; i++)t[e + i] = r;
    }
    function a(t) {
        return new Int32Array(t);
    }
    function o(t, e) {
        for(var r = [], n = 0; n < t; n++)r.push(new e);
        return r;
    }
    function s(t, e) {
        var r = [];
        return function t(r, n, i) {
            for(var a = i[n], o = 0; o < a && (r.push(i.length > n + 1 ? [] : new e), !(i.length < n + 1)); o++)t(r[o], n + 1, i);
        }(r, 0, t), r;
    }
    var c = function() {
        var t = this;
        function c(t, e) {
            for(var r = 1 << e - 1 >>> 0; t & r;)r >>>= 1;
            return r ? (t & r - 1) + r : t;
        }
        function u(t, r, n, i, a) {
            e(!(i % n));
            do t[r + (i -= n)] = a;
            while (0 < i);
        }
        function h(t, r, n, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, r, n, i, o, s) {
                var h, f, d = r, p = 1 << n, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, h = 1; 15 > h; ++h){
                    if (g[h] > 1 << h) return 0;
                    m[h + 1] = m[h] + g[h];
                }
                for(f = 0; f < o; ++f)h = i[f], 0 < i[f] && (s[m[h]++] = f);
                if (1 == m[15]) return (i = new l).g = 0, i.value = s[0], u(t, d, 1, p, i), p;
                var v, b = -1, y = p - 1, w = 0, N = 1, L = 1, A = 1 << n;
                for(f = 0, h = 1, o = 2; h <= n; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h])(i = new l).g = h, i.value = s[f++], u(t, d + w, o, A, i), w = c(w, h);
                }
                for(h = n + 1, o = 2; 15 >= h; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h]){
                        if (i = new l, (w & y) != b) {
                            for(d += A, v = 1 << (b = h) - n; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += A = 1 << (v = b - n), t[r + (b = w & y)].g = v + n, t[r + b].value = d - r - b;
                        }
                        i.g = h - n, i.value = s[f++], u(t, d + (w >> n), o, A, i), w = c(w, h);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, r, n, i, o, s);
        }
        function l() {
            this.value = this.g = 0;
        }
        function f() {
            this.value = this.g = 0;
        }
        function d() {
            this.G = o(5, l), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Dr, f);
        }
        function p(t, r, n, i) {
            e(null != t), e(null != r), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = n, t.Jd = r, t.Yc = n + i, t.Zc = 4 <= i ? n + i - 4 + 1 : n, _(t);
        }
        function g(t, e) {
            for(var r = 0; 0 < e--;)r |= k(t, 128) << e;
            return r;
        }
        function m(t, e) {
            var r = g(t, e);
            return P(t) ? -r : r;
        }
        function v(t, r, n, i) {
            var a, o = 0;
            for(e(null != t), e(null != r), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += r[n + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = r, t.pa = n;
        }
        function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << Ur - 8 >>> 0, ++t.bb, t.u -= 8;
            A(t) && (t.h = 1, t.u = 0);
        }
        function y(t, r) {
            if (e(0 <= r), !t.h && r <= Tr) {
                var n = L(t) & Rr[r];
                return t.u += r, b(t), n;
            }
            return t.h = 1, t.u = 0;
        }
        function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        }
        function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        }
        function L(t) {
            return t.Ra >>> (t.u & Ur - 1) >>> 0;
        }
        function A(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > Ur;
        }
        function x(t, e) {
            t.u = e, t.h = A(t);
        }
        function S(t) {
            t.u >= zr && (e(t.u >= zr), b(t));
        }
        function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        }
        function P(t) {
            return g(t, 1);
        }
        function k(t, e) {
            var r = t.Ca;
            0 > t.b && _(t);
            var n = t.b, i = r * e >>> 8, a = (t.I >>> n > i) + 0;
            for(a ? (r -= i, t.I -= i + 1 << n >>> 0) : r = i + 1, n = r, i = 0; 256 <= n;)i += 8, n >>= 8;
            return n = 7 ^ i + Hr[n], t.b -= n, t.Ca = (r << n) - 1, a;
        }
        function I(t, e, r) {
            t[e + 0] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r >> 0 & 255;
        }
        function F(t, e) {
            return t[e + 0] << 0 | t[e + 1] << 8;
        }
        function C(t, e) {
            return F(t, e) | t[e + 2] << 16;
        }
        function j(t, e) {
            return F(t, e) | F(t, e + 2) << 16;
        }
        function O(t, r) {
            var n = 1 << r;
            return e(null != t), e(0 < r), t.X = a(n), null == t.X ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
        }
        function B(t, r) {
            e(null != t), e(null != r), e(t.Xa == r.Xa), n(r.X, 0, t.X, 0, 1 << r.Xa);
        }
        function M() {
            this.X = [], this.Xa = this.Mb = 0;
        }
        function E(t, r, n, i) {
            e(null != n), e(null != i);
            var a = n[0], o = i[0];
            return 0 == a && (a = (t * o + r / 2) / r), 0 == o && (o = (r * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (n[0] = a, i[0] = o, 1);
        }
        function q(t, e) {
            return t + (1 << e) - 1 >>> e;
        }
        function D(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        }
        function R(e, r) {
            t[r] = function(r, n, i, a, o, s, c) {
                var u;
                for(u = 0; u < o; ++u){
                    var h = t[e](s[c + u - 1], i, a + u);
                    s[c + u] = D(r[n + u], h);
                }
            };
        }
        function T() {
            this.ud = this.hd = this.jd = 0;
        }
        function U(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        }
        function z(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        }
        function H(t, e) {
            return z(t + (t - e + .5 >> 1));
        }
        function W(t, e, r) {
            return Math.abs(e - r) - Math.abs(t - r);
        }
        function V(t, e, r, n, i, a, o) {
            for(n = a[o - 1], r = 0; r < i; ++r)a[o + r] = n = D(t[e + r], n);
        }
        function G(t, e, r, n, i) {
            var a;
            for(a = 0; a < r; ++a){
                var o = t[e + a], s = o >> 8 & 255, c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
                n[i + a] = (4278255360 & o) + c >>> 0;
            }
        }
        function Y(t, e) {
            e.jd = t >> 0 & 255, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        }
        function J(t, e, r, n, i, a) {
            var o;
            for(o = 0; o < n; ++o){
                var s = e[r + o], c = s >>> 8, u = s, h = 255 & (h = (h = s >>> 16) + ((t.jd << 24 >> 24) * (c << 24 >> 24) >>> 5));
                u = 255 & (u = (u = u + ((t.hd << 24 >> 24) * (c << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (h << 24 >> 24) >>> 5));
                i[a + o] = (4278255360 & s) + (h << 16) + u;
            }
        }
        function X(e, r, n, i, a) {
            t[r] = function(t, e, r, n, o, s, c, u, h) {
                for(n = c; n < u; ++n)for(c = 0; c < h; ++c)o[s++] = a(r[i(t[e++])]);
            }, t[e] = function(e, r, o, s, c, u, h) {
                var l = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > l) for(e = (1 << e.b) - 1, p = (1 << l) - 1; r < o; ++r){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[c++])), u[h++] = a(d[m & p]), m >>= l;
                }
                else t["VP8LMapColor" + n](s, c, d, p, u, h, r, o, f);
            };
        }
        function K(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255;
            }
        }
        function Z(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255, n[i++] = a >> 24 & 255;
            }
        }
        function $(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = o >> 0 & 240 | o >> 28 & 15;
                n[i++] = a, n[i++] = o;
            }
        }
        function Q(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                n[i++] = a, n[i++] = o;
            }
        }
        function tt(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 0 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 16 & 255;
            }
        }
        function et(t, e, r, i, a, o) {
            if (0 == o) for(r = e + r; e < r;)I(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else n(i, a, t, e, r);
        }
        function rt(e, r) {
            t[r][0] = t[e + "0"], t[r][1] = t[e + "1"], t[r][2] = t[e + "2"], t[r][3] = t[e + "3"], t[r][4] = t[e + "4"], t[r][5] = t[e + "5"], t[r][6] = t[e + "6"], t[r][7] = t[e + "7"], t[r][8] = t[e + "8"], t[r][9] = t[e + "9"], t[r][10] = t[e + "10"], t[r][11] = t[e + "11"], t[r][12] = t[e + "12"], t[r][13] = t[e + "13"], t[r][14] = t[e + "0"], t[r][15] = t[e + "0"];
        }
        function nt(t) {
            return t == Hn || t == Wn || t == Vn || t == Gn;
        }
        function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        }
        function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        }
        function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        }
        function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        }
        function ct() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        }
        function ut(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        }
        function ht(t, e) {
            var r = t.T, i = e.ba.f.RGBA, a = i.eb, o = i.fb + t.ka * i.A, s = vi[e.ba.S], c = t.y, u = t.O, h = t.f, l = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(c, u, null, null, h, l, f, d, h, l, f, d, a, o, null, null, w) : (s(e.ec, e.fc, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w), ++r); b + 2 < y; b += 2)p = h, g = l, m = f, v = d, l += t.Rc, d += t.Rc, o += 2 * i.A, s(c, (u += 2 * t.fa) - t.fa, c, u, p, g, m, v, h, l, f, d, a, o - i.A, a, o, w);
            return u += t.fa, t.j + y < t.o ? (n(e.ec, e.fc, c, u, w), n(e.cc, e.dc, h, l, N), n(e.Mc, e.Nc, f, d, N), r--) : 1 & y || s(c, u, null, null, h, l, f, d, h, l, f, d, a, o + i.A, null, null, w), r;
        }
        function lt(t, r, n) {
            var i = t.F, a = [
                t.J
            ];
            if (null != i) {
                var o = t.U, s = r.ba.S, c = s == Tn || s == Vn;
                r = r.ba.f.RGBA;
                var u = [
                    0
                ], h = t.ka;
                u[0] = t.T, t.Kb && (0 == h ? --u[0] : (--h, a[0] -= t.width), t.j + t.ka + t.T == t.o && (u[0] = t.o - t.j - h));
                var l = r.eb;
                h = r.fb + h * r.A;
                t = Sn(i, a[0], t.width, o, u, l, h + (c ? 0 : 3), r.A), e(n == u), t && nt(s) && An(l, h, c, o, u, r.A);
            }
            return 0;
        }
        function ft(t) {
            var e = t.ma, r = e.ba.S, n = 11 > r, i = r == qn || r == Rn || r == Tn || r == Un || 12 == r || nt(r);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mr(e.Oa, t, i ? 11 : 12)) return 0;
            if (i && nt(r) && br(), t.da) alert("todo:use_scaling");
            else {
                if (n) {
                    if (e.Ib = ut, t.Kb) {
                        if (r = t.U + 1 >> 1, e.memory = a(t.U + 2 * r), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + r, e.Ib = ht, br();
                    }
                } else alert("todo:EmitYUV");
                i && (e.Jb = lt, n && mr());
            }
            if (n && !Ci) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + _i >> Si, Mi[t] = -22014 * (t - 128) + _i, Bi[t] = -45773 * (t - 128), Oi[t] = 113618 * (t - 128) + _i >> Si;
                for(t = Pi; t < ki; ++t)e = 76283 * (t - 16) + _i >> Si, Ei[t - Pi] = Vt(e, 255), qi[t - Pi] = Vt(e + 8 >> 4, 15);
                Ci = 1;
            }
            return 1;
        }
        function dt(t) {
            var r = t.ma, n = t.U, i = t.T;
            return e(!(1 & t.ka)), 0 >= n || 0 >= i ? 0 : (n = r.Ib(t, r), null != r.Jb && r.Jb(t, r, n), r.Dc += n, 1);
        }
        function pt(t) {
            t.ma.memory = null;
        }
        function gt(t, e, r, n) {
            return 47 != y(t, 8) ? 0 : (e[0] = y(t, 14) + 1, r[0] = y(t, 14) + 1, n[0] = y(t, 1), 0 != y(t, 3) ? 0 : !t.h);
        }
        function mt(t, e) {
            if (4 > t) return t + 1;
            var r = t - 2 >> 1;
            return (2 + (1 & t) << r) + y(e, r) + 1;
        }
        function vt(t, e) {
            var r;
            return 120 < e ? e - 120 : 1 <= (r = ((r = $n[e - 1]) >> 4) * t + (8 - (15 & r))) ? r : 1;
        }
        function bt(t, e, r) {
            var n = L(r), i = t[e += 255 & n].g - 8;
            return 0 < i && (x(r, r.u + 8), n = L(r), e += t[e].value, e += n & (1 << i) - 1), x(r, r.u + t[e].g), t[e].value;
        }
        function yt(t, r, n) {
            return n.g += t.g, n.value += t.value << r >>> 0, e(8 >= n.g), t.g;
        }
        function wt(t, r, n) {
            var i = t.xc;
            return e((r = 0 == i ? 0 : t.vc[t.md * (n >> i) + (r >> i)]) < t.Wb), t.Ya[r];
        }
        function Nt(t, r, i, a) {
            var o = t.ab, s = t.c * r, c = t.C;
            r = c + r;
            var u = i, h = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var l = t.gc[o], f = c, d = r, p = u, g = h, m = (h = a, u = i, l.Ea);
                switch(e(f < d), e(d <= l.nc), l.hc){
                    case 2:
                        Gr(p, g, (d - f) * m, h, u);
                        break;
                    case 0:
                        var v = f, b = d, y = h, w = u, N = (_ = l).Ea;
                        0 == v && (Wr(p, g, null, null, 1, y, w), V(p, g + 1, 0, 0, N - 1, y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, A = L - 1, x = q(N, _.b), S = _.K, _ = _.w + (v >> _.b) * x; v < b;){
                            var P = S, k = _, I = 1;
                            for(Vr(p, g, y, w - N, 1, y, w); I < N;){
                                var F = (I & ~A) + L;
                                F > N && (F = N), (0, Zr[P[k++] >> 8 & 15])(p, g + +I, y, w + I - N, F - I, y, w + I), I = F;
                            }
                            g += N, w += N, ++v & A || (_ += x);
                        }
                        d != l.nc && n(h, u - m, h, u + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = l.Ea) - (w = p & ~(y = (g = 1 << l.b) - 1)), v = q(p, l.b), L = l.K, l = l.w + (f >> l.b) * v; f < d;){
                            for(A = L, x = l, S = new T, _ = b + w, P = b + p; b < _;)Y(A[x++], S), $r(S, m, b, g, h, u), b += g, u += g;
                            b < P && (Y(A[x++], S), $r(S, m, b, N, h, u), b += N, u += N), ++f & y || (l += v);
                        }
                        break;
                    case 3:
                        if (p == h && g == u && 0 < l.b) {
                            for(b = h, p = m = u + (d - f) * m - (w = (d - f) * q(l.Ea, l.b)), g = h, y = u, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yr(l, f, d, h, m, h, u);
                        } else Yr(l, f, d, p, g, h, u);
                }
                u = a, h = i;
            }
            h != i && n(a, i, u, h, s);
        }
        function Lt(t, r) {
            var n = t.V, i = t.Ba + t.c * t.C, a = r - t.C;
            if (e(r <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, c = t.Ua, u = o.width;
                if (Nt(t, a, n, i), a = c = [
                    c
                ], e((n = t.C) < (i = r)), e(o.v < o.va), i > o.o && (i = o.o), n < o.j) {
                    var h = o.j - n;
                    n = o.j;
                    a[0] += h * u;
                }
                if (n >= i ? n = 0 : (a[0] += 4 * o.v, o.ka = n - o.j, o.U = o.va - o.v, o.T = i - n, n = 1), n) {
                    if (c = c[0], 11 > (n = t.ca).S) {
                        var l = n.f.RGBA, f = (i = n.S, a = o.U, o = o.T, h = l.eb, l.A), d = o;
                        for(l = l.fb + t.Ma * l.A; 0 < d--;){
                            var p = s, g = c, m = a, v = h, b = l;
                            switch(i){
                                case En:
                                    Qr(p, g, m, v, b);
                                    break;
                                case qn:
                                    tn(p, g, m, v, b);
                                    break;
                                case Hn:
                                    tn(p, g, m, v, b), An(v, b, 0, m, 1, 0);
                                    break;
                                case Dn:
                                    nn(p, g, m, v, b);
                                    break;
                                case Rn:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Wn:
                                    et(p, g, m, v, b, 1), An(v, b, 0, m, 1, 0);
                                    break;
                                case Tn:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Vn:
                                    et(p, g, m, v, b, 0), An(v, b, 1, m, 1, 0);
                                    break;
                                case Un:
                                    en(p, g, m, v, b);
                                    break;
                                case Gn:
                                    en(p, g, m, v, b), xn(v, b, m, 1, 0);
                                    break;
                                case zn:
                                    rn(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            c += u, l += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= n.height);
                }
            }
            t.C = r, e(t.C <= t.i);
        }
        function At(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var r = t.Ya[e].G, n = t.Ya[e].H;
                if (0 < r[1][n[1] + 0].g || 0 < r[2][n[2] + 0].g || 0 < r[3][n[3] + 0].g) return 0;
            }
            return 1;
        }
        function xt(t, r, n, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, c = t.rd;
                for(e(null != mi[t.Z]); r < n; ++r)mi[t.Z](s, c, i, a, i, a, o), s = i, c = a, a += o;
                t.qd = s, t.rd = c;
            }
        }
        function St(t, r) {
            var n = t.l.ma, i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
            i = t.C < i ? i : t.C;
            if (e(r <= t.l.o), r > i) {
                var a = t.l.width, o = n.ca, s = n.tb + a * i, c = t.V, u = t.Ba + t.c * i, h = t.gc;
                e(1 == t.ab), e(3 == h[0].hc), Xr(h[0], i, r, c, u, o, s), xt(n, i, r, o, s, a);
            }
            t.C = t.Ma = r;
        }
        function _t(t, r, n, i, a, o, s) {
            var c = t.$ / i, u = t.$ % i, h = t.m, l = t.s, f = n + t.$, d = f;
            a = n + i * a;
            var p = n + i * o, g = 280 + l.ua, m = t.Pb ? c : 16777216, v = 0 < l.ua ? l.Wa : null, b = l.wc, y = f < p ? wt(l, u, c) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (c >= m) {
                        var _ = f - n;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = c + ti;
                    }
                    if (u & b || (y = wt(l, u, c)), e(null != y), y.Qb && (r[f] = y.qb, w = !0), !w) {
                        if (S(h), y.jc) {
                            N = h, _ = r;
                            var P = f, k = y.pd[L(N) & Dr - 1];
                            e(y.jc), 256 > k.g ? (x(N, N.u + k.g), _[P] = k.value, N = 0) : (x(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(y.G[0], y.H[0], h);
                    }
                    if (h.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (y.nd) r[f] = (y.qb | N << 8) >>> 0;
                            else {
                                if (S(h), w = bt(y.G[1], y.H[1], h), S(h), _ = bt(y.G[2], y.H[2], h), P = bt(y.G[3], y.H[3], h), h.h) break;
                                r[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++u >= i && (u = 0, ++c, null != s && c <= o && !(c % 16) && s(t, c), null != v)) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, h), _ = bt(y.G[4], y.H[4], h), S(h), _ = vt(i, _ = mt(_, h)), h.h) break;
                        if (f - n < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)r[f + P] = r[f + P - _];
                        for(f += N, u += N; u >= i;)u -= i, ++c, null != s && c <= o && !(c % 16) && s(t, c);
                        if (e(f <= a), u & b && (y = wt(l, u, c)), null != v) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), r[N] = _.X[w], w = !0;
                    }
                    w || e(h.h == A(h));
                }
                if (t.Pb && h.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (h.h) break t;
                    null != s && s(t, c > o ? o : c), t.a = 0, t.$ = f - n;
                }
                return 1;
            }
            return t.a = 3, 0;
        }
        function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var r = t.Wa;
            null != r && (r.X = null), t.vb = null, e(null != t);
        }
        function kt() {
            var e = new or;
            return null == e ? null : (e.a = 0, e.xb = gi, rt("Predictor", "VP8LPredictors"), rt("Predictor", "VP8LPredictors_C"), rt("PredictorAdd", "VP8LPredictorsAdd"), rt("PredictorAdd", "VP8LPredictorsAdd_C"), Gr = G, $r = J, Qr = K, tn = Z, en = $, rn = Q, nn = tt, t.VP8LMapColor32b = Jr, t.VP8LMapColor8b = Kr, e);
        }
        function It(t, r, n, s, c) {
            var u = 1, f = [
                t
            ], p = [
                r
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (n) for(; u && y(g, 1);){
                    var w = f, N = p, A = s, _ = 1, P = A.m, k = A.gc[A.ab], I = y(P, 2);
                    if (A.Oc & 1 << I) u = 0;
                    else {
                        switch(A.Oc |= 1 << I, k.hc = I, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++A.ab, e(4 >= A.ab), I){
                            case 0:
                            case 1:
                                k.b = y(P, 3) + 2, _ = It(q(k.Ea, k.b), q(k.nc, k.b), 0, A, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var F, C = y(P, 8) + 1, j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                                if (w[0] = q(k.Ea, j), k.b = j, F = _ = It(C, 1, 0, A, k.K)) {
                                    var B, M = C, E = k, R = 1 << (8 >> E.b), T = a(R);
                                    if (null == T) F = 0;
                                    else {
                                        var U = E.K[0], z = E.w;
                                        for(T[0] = E.K[0][0], B = 1; B < 1 * M; ++B)T[B] = D(U[z + B], T[B - 1]);
                                        for(; B < 4 * R; ++B)T[B] = 0;
                                        E.K[0] = null, E.K[0] = T, F = 1;
                                    }
                                }
                                _ = F;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        u = _;
                    }
                }
                if (f = f[0], p = p[0], u && y(g, 1) && !(u = 1 <= (b = y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = u) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = n, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, rt = 0, nt = Qn[K];
                    r: for(;;){
                        if (Z && y($, 1)) {
                            var it = y($, 3) + 2, at = q(J, it), ot = q(X, it), st = at * ot;
                            if (!It(at, ot, 0, Y, tt)) break r;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ct = tt[W] >> 8 & 65535;
                                tt[W] = ct, ct >= et && (et = ct + 1);
                            }
                        }
                        if ($.h) break r;
                        for(V = 0; 5 > V; ++V){
                            var ut = Xn[V];
                            !V && 0 < K && (ut += 1 << K), rt < ut && (rt = ut);
                        }
                        var ht = o(et * nt, l), lt = et, ft = o(lt, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= lt), dt = ft;
                        var pt = a(rt);
                        if (null == dt || null == pt || null == ht) {
                            Y.a = 1;
                            break r;
                        }
                        var gt = ht;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ut = Xn[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ut += 1 << K);
                                n: {
                                    var At, xt = ut, St = Y, kt = pt, Ft = gt, Ct = G, jt = 0, Ot = St.m, Bt = y(Ot, 1);
                                    if (i(kt, 0, 0, xt), Bt) {
                                        var Mt = y(Ot, 1) + 1, Et = y(Ot, 1), qt = y(Ot, 0 == Et ? 1 : 8);
                                        kt[qt] = 1, 2 == Mt && (kt[qt = y(Ot, 8)] = 1);
                                        var Dt = 1;
                                    } else {
                                        var Rt = a(19), Tt = y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var Ut = 0;
                                            break n;
                                        }
                                        for(At = 0; At < Tt; ++At)Rt[Zn[At]] = y(Ot, 3);
                                        var zt = void 0, Ht = void 0, Wt = St, Vt = Rt, Gt = xt, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, l);
                                        i: for(; h(Zt, 0, 7, Vt, 19);){
                                            if (y(Xt, 1)) {
                                                var $t = 2 + 2 * y(Xt, 3);
                                                if ((zt = 2 + y(Xt, $t)) > Gt) break i;
                                            } else zt = Gt;
                                            for(Ht = 0; Ht < Gt && zt--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                x(Xt, Xt.u + Qt.g);
                                                var te = Qt.value;
                                                if (16 > te) Yt[Ht++] = te, 0 != te && (Kt = te);
                                                else {
                                                    var ee = 16 == te, re = te - 16, ne = Jn[re], ie = y(Xt, Yn[re]) + ne;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Dt = Jt;
                                    }
                                    (Dt = Dt && !Ot.h) && (jt = h(Ft, Ct, 8, kt, xt)), Dt && 0 != jt ? Ut = jt : (St.a = 3, Ut = 0);
                                }
                                if (0 == Ut) break r;
                                if (Nt && 1 == Kn[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += Ut, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ut; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ce, ue = mt;
                                for(ce = 0; ce < Dr; ++ce){
                                    var he = ce, le = ue.pd[he], fe = ue.G[0][ue.H[0] + he];
                                    256 <= fe.value ? (le.g = fe.g + 256, le.value = fe.value) : (le.g = 0, le.value = 0, he >>= yt(fe, 8, le), he >>= yt(ue.G[1][ue.H[1] + he], 16, le), he >>= yt(ue.G[2][ue.H[2] + he], 0, le), yt(ue.G[3][ue.H[3] + he], 24, le));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = ht, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(u = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, u = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = q(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, n) {
                    s.xb = pi;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, u = 0;
                    break t;
                }
                u = (u = _t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return u ? (null != c ? c[0] = v : (e(null == v), e(n)), s.$ = 0, n || Pt(m)) : Pt(m), u;
        }
        function Ft(t, r) {
            var n = t.c * t.i, i = n + r + 16 * r;
            return e(t.c <= r), t.V = a(i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + n + r, 1);
        }
        function Ct(t, r) {
            var n = t.C, i = r - n, a = t.V, o = t.Ba + t.c * n;
            for(e(r <= t.l.o); 0 < i;){
                var s = 16 < i ? 16 : i, c = t.l.ma, u = t.l.width, h = u * s, l = c.ca, f = c.tb + u * n, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), _n(d, p, l, f, h), xt(c, n, n + s, l, f, u), i -= s, a += s * t.c, n += s;
            }
            e(n == r), t.C = t.Ma = r;
        }
        function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        }
        function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        }
        function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        }
        function Mt() {
            this.Yb = function() {
                var t = [];
                return function t(e, r, n) {
                    for(var i = n[r], a = 0; a < i && (e.push(n.length > r + 1 ? [] : 0), !(n.length < r + 1)); a++)t(e[a], r + 1, n);
                }(t, 0, [
                    3,
                    11
                ]), t;
            }();
        }
        function Et() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        }
        function qt() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        }
        function Dt() {
            this.ld = this.La = this.dd = this.tc = 0;
        }
        function Rt() {
            this.Na = this.la = 0;
        }
        function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        }
        function Ut() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        }
        function zt() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Dt), this.Y = 0, this.ya = Array(new Ut), this.aa = 0, this.l = new Gt;
        }
        function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        }
        function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new jt, this.Kc = new Ot, this.ed = new qt, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new zt, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new Et, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Rt), this.sb = 0, this.wa = Array(new Dt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Dt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        }
        function Yt() {
            var t = new Wt;
            return null != t && (t.a = 0, t.sc = "OK", t.cb = 0, t.Xb = 0, ni || (ni = Zt)), t;
        }
        function Jt(t, e, r) {
            return 0 == t.a && (t.a = e, t.sc = r, t.cb = 0), 0;
        }
        function Xt(t, e, r) {
            return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        }
        function Kt(t, r) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == r) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var n = r.data, a = r.w, o = r.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = n[a + 0] | n[a + 1] << 8 | n[a + 2] << 16, c = t.Od;
            if (c.Rb = !(1 & s), c.td = s >> 1 & 7, c.yd = s >> 4 & 1, c.ub = s >> 5, 3 < c.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!c.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var u = t.Kc;
            if (c.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
                u.c = 16383 & (n[a + 4] << 8 | n[a + 3]), u.Td = n[a + 4] >> 6, u.i = 16383 & (n[a + 6] << 8 | n[a + 5]), u.Ud = n[a + 6] >> 6, a += 7, o -= 7, t.za = u.c + 15 >> 4, t.Ub = u.i + 15 >> 4, r.width = u.c, r.height = u.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
            }
            if (c.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, n, a, c.ub), a += c.ub, o -= c.ub, c.Rb && (u.Ld = P(s), u.Kd = P(s)), u = t.Qa;
            var h, l = t.Pa;
            if (e(null != s), e(null != u), u.Cb = P(s), u.Cb) {
                if (u.Bb = P(s), P(s)) {
                    for(u.Fb = P(s), h = 0; 4 > h; ++h)u.Zb[h] = P(s) ? m(s, 7) : 0;
                    for(h = 0; 4 > h; ++h)u.Lb[h] = P(s) ? m(s, 6) : 0;
                }
                if (u.Bb) for(h = 0; 3 > h; ++h)l.jb[h] = P(s) ? g(s, 8) : 255;
            } else u.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((u = t.ed).zd = P(s), u.Tb = g(s, 6), u.wb = g(s, 3), u.Pc = P(s), u.Pc && P(s)) {
                for(l = 0; 4 > l; ++l)P(s) && (u.vd[l] = m(s, 6));
                for(l = 0; 4 > l; ++l)P(s) && (u.od[l] = m(s, 6));
            }
            if (t.L = 0 == u.Tb ? 0 : u.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = h = a, a = h + f, u = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (l = t.Xb)) n = 7;
            else {
                for(h += 3 * l, u -= 3 * l, f = 0; f < l; ++f){
                    var d = n[o + 0] | n[o + 1] << 8 | n[o + 2] << 16;
                    d > u && (d = u), p(t.Jc[+f], n, h, d), h += d, u -= d, o += 3;
                }
                p(t.Jc[+l], n, h, u), n = h < a ? 0 : 5;
            }
            if (0 != n) return Jt(t, n, "cannot parse partitions");
            for(n = g(h = t.m, 7), o = P(h) ? m(h, 4) : 0, a = P(h) ? m(h, 4) : 0, u = P(h) ? m(h, 4) : 0, l = P(h) ? m(h, 4) : 0, h = P(h) ? m(h, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += n);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = n;
                }
                var b = t.pb[d];
                b.Sc[0] = ei[Vt(v + o, 127)], b.Sc[1] = ri[Vt(v + 0, 127)], b.Eb[0] = 2 * ei[Vt(v + a, 127)], b.Eb[1] = 101581 * ri[Vt(v + u, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ei[Vt(v + l, 117)], b.Qc[1] = ri[Vt(v + h, 127)], b.lc = v + h;
            }
            if (!c.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), c = t.Pa, n = 0; 4 > n; ++n){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(u = 0; 11 > u; ++u)l = k(s, ui[n][o][a][u]) ? g(s, 8) : si[n][o][a][u], c.Wc[n][o].Yb[a][u] = l;
                for(o = 0; 17 > o; ++o)c.Xc[n][o] = c.Wc[n][hi[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        }
        function Zt(t, e, r, n, i, a, o) {
            var s = e[i].Yb[r];
            for(r = 0; 16 > i; ++i){
                if (!k(t, s[r + 0])) return i;
                for(; !k(t, s[r + 1]);)if (s = e[++i].Yb[0], r = 0, 16 == i) return 16;
                var c = e[i + 1].Yb;
                if (k(t, s[r + 2])) {
                    var u = t, h = 0;
                    if (k(u, (f = s)[(l = r) + 3])) {
                        if (k(u, f[l + 6])) {
                            for(s = 0, l = 2 * (h = k(u, f[l + 8])) + (f = k(u, f[l + 9 + h])), h = 0, f = ii[l]; f[s]; ++s)h += h + k(u, f[s]);
                            h += 3 + (8 << l);
                        } else k(u, f[l + 7]) ? (h = 7 + 2 * k(u, 165), h += k(u, 145)) : h = 5 + k(u, 159);
                    } else h = k(u, f[l + 4]) ? 3 + k(u, f[l + 5]) : 2;
                    s = c[2];
                } else h = 1, s = c[1];
                c = o + ai[i], 0 > (u = t).b && _(u);
                var l, f = u.b, d = (l = u.Ca >> 1) - (u.I >> f) >> 31;
                --u.b, u.Ca += d, u.Ca |= 1, u.I -= (l + 1 & d) << f, a[c] = ((h ^ d) - d) * n[(0 < i) + 0];
            }
            return 16;
        }
        function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        }
        function Qt(t, r) {
            if (null == t) return 0;
            if (null == r) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
            if (!t.cb && !Kt(t, r)) return 0;
            if (e(t.cb), null == r.ac || r.ac(r)) {
                r.ob && (t.L = 0);
                var s = Ri[t.L];
                if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - s >> 4, t.zb = r.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + s >> 4, t.Hb = r.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                    var c = t.ed;
                    for(s = 0; 4 > s; ++s){
                        var u;
                        if (t.Qa.Cb) {
                            var h = t.Qa.Lb[s];
                            t.Qa.Fb || (h += c.Tb);
                        } else h = c.Tb;
                        for(u = 0; 1 >= u; ++u){
                            var l = t.gd[s][u], f = h;
                            if (c.Pc && (f += c.vd[0], u && (f += c.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                var d = f;
                                0 < c.wb && (d = 4 < c.wb ? d >> 2 : d >> 1) > 9 - c.wb && (d = 9 - c.wb), 1 > d && (d = 1), l.dd = d, l.tc = 2 * f + d, l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                            } else l.tc = 0;
                            l.La = u;
                        }
                    }
                }
                s = 0;
            } else Jt(t, 6, "Frame setup failed"), s = t.a;
            if (s = 0 == s) {
                if (s) {
                    t.$c = 0, 0 < t.Aa || (t.Ic = Ui);
                    t: {
                        s = t.Ic;
                        c = 4 * (d = t.za);
                        var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                        if ((l = c + 832 + (u = 3 * (16 * s + Ri[t.L]) / 2 * p) + (h = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != l) s = 0;
                        else {
                            if (l > t.Vb) {
                                if (t.Vb = 0, t.Ec = a(l), t.Fc = 0, null == t.Ec) {
                                    s = Jt(t, 1, "no memory during frame initialization.");
                                    break t;
                                }
                                t.Vb = l;
                            }
                            l = t.Ec, f = t.Fc, t.Ac = l, t.Bc = f, f += c, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Rt), t.sb = 1, t.wa = m ? o(m, Dt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = l, t.pc = f, f += 832, t.ya = o(v, Ut), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = l, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += u, t.mb = h ? l : null, t.nb = h ? f : null, e(f + h <= t.Fc + t.Vb), $t(t), i(t.Ac, t.Bc, 0, c), s = 1;
                        }
                    }
                    if (s) {
                        if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !Cn) {
                            for(s = -255; 255 >= s; ++s)Pn[255 + s] = 0 > s ? -s : s;
                            for(s = -1020; 1020 >= s; ++s)kn[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                            for(s = -112; 112 >= s; ++s)In[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                            for(s = -255; 510 >= s; ++s)Fn[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                            Cn = 1;
                        }
                        an = ue, on = ae, cn = oe, un = se, hn = ce, sn = ie, ln = Je, fn = Xe, dn = $e, pn = Qe, gn = Ke, mn = Ze, vn = tr, bn = er, yn = ze, wn = He, Nn = We, Ln = Ve, fi[0] = xe, fi[1] = le, fi[2] = Le, fi[3] = Ae, fi[4] = Se, fi[5] = Pe, fi[6] = _e, fi[7] = ke, fi[8] = Fe, fi[9] = Ie, li[0] = ve, li[1] = de, li[2] = pe, li[3] = ge, li[4] = be, li[5] = ye, li[6] = we, di[0] = Be, di[1] = fe, di[2] = Ce, di[3] = je, di[4] = Ee, di[5] = Me, di[6] = qe, s = 1;
                    } else s = 0;
                }
                s && (s = function(t, r) {
                    for(t.M = 0; t.M < t.Va; ++t.M){
                        var o, s = t.Jc[t.M & t.Xb], c = t.m, u = t;
                        for(o = 0; o < u.za; ++o){
                            var h = c, l = u, f = l.Ac, d = l.Bc + 4 * o, p = l.zc, g = l.ya[l.aa + o];
                            if (l.Qa.Bb ? g.$b = k(h, l.Pa.jb[0]) ? 2 + k(h, l.Pa.jb[2]) : k(h, l.Pa.jb[1]) : g.$b = 0, l.kc && (g.Ad = k(h, l.Bd)), g.Za = !k(h, 145) + 0, g.Za) {
                                var m = g.Ob, v = 0;
                                for(l = 0; 4 > l; ++l){
                                    var b, y = p[0 + l];
                                    for(b = 0; 4 > b; ++b){
                                        y = ci[f[d + b]][y];
                                        for(var w = oi[k(h, y[0])]; 0 < w;)w = oi[2 * w + k(h, y[w])];
                                        y = -w, f[d + b] = y;
                                    }
                                    n(m, v, f, d, 4), v += 4, p[0 + l] = y;
                                }
                            } else y = k(h, 156) ? k(h, 128) ? 1 : 3 : k(h, 163) ? 2 : 0, g.Ob[0] = y, i(f, d, y, 4), i(p, 0, y, 4);
                            g.Dd = k(h, 142) ? k(h, 114) ? k(h, 183) ? 1 : 3 : 2 : 0;
                        }
                        if (u.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                        for(; t.ja < t.za; ++t.ja){
                            if (u = s, h = (c = t).rb[c.sb - 1], f = c.rb[c.sb + c.ja], o = c.ya[c.aa + c.ja], d = c.kc ? o.Ad : 0) h.la = f.la = 0, o.Za || (h.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                            else {
                                var N, L;
                                h = f, f = u, d = c.Pa.Xc, p = c.ya[c.aa + c.ja], g = c.pb[p.$b];
                                if (l = p.ad, m = 0, v = c.rb[c.sb - 1], y = b = 0, i(l, m, 0, 384), p.Za) var A = 0, x = d[3];
                                else {
                                    w = a(16);
                                    var S = h.Na + v.Na;
                                    if (S = ni(f, d[1], S, g.Eb, 0, w, 0), h.Na = v.Na = (0 < S) + 0, 1 < S) an(w, 0, l, m);
                                    else {
                                        var _ = w[0] + 3 >> 3;
                                        for(w = 0; 256 > w; w += 16)l[m + w] = _;
                                    }
                                    A = 1, x = d[0];
                                }
                                var P = 15 & h.la, I = 15 & v.la;
                                for(w = 0; 4 > w; ++w){
                                    var F = 1 & I;
                                    for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (F = (S = ni(f, x, S = F + (1 & P), g.Sc, A, l, m)) > A) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                    P >>= 4, I = I >> 1 | F << 7, b = (b << 8 | L) >>> 0;
                                }
                                for(x = P, A = I >> 4, N = 0; 4 > N; N += 2){
                                    for(L = 0, P = h.la >> 4 + N, I = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                        for(F = 1 & I, _ = 0; 2 > _; ++_)S = F + (1 & P), P = P >> 1 | (F = 0 < (S = ni(f, d[2], S, g.Qc, 0, l, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                        P >>= 2, I = I >> 1 | F << 5;
                                    }
                                    y |= L << 4 * N, x |= P << 4 << N, A |= (240 & I) << N;
                                }
                                h.la = x, v.la = A, p.Hc = b, p.Gc = y, p.ia = 43690 & y ? 0 : g.ia, d = !(b | y);
                            }
                            if (0 < c.L && (c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za], c.wa[c.Y + c.ja].La |= !d), u.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                        }
                        if ($t(t), c = r, u = 1, o = (s = t).D, h = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) t: {
                            if (o.M = s.M, o.uc = h, Or(s, o), u = 1, o = (L = s.D).Nb, h = (y = Ri[s.L]) * s.R, f = y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - h + w, g = s.qa, l = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, I = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && Or(s, L), L.uc) for(F = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                A = L, x = F;
                                var C = (j = (U = S).D).Nb;
                                N = U.R;
                                var j = j.wa[j.Y + A], O = U.sa, B = U.ta + 16 * C * N + 16 * A, M = j.dd, E = j.tc;
                                if (0 != E) {
                                    if (e(3 <= E), 1 == U.L) 0 < A && wn(O, B, N, E + 4), j.La && Ln(O, B, N, E), 0 < x && yn(O, B, N, E + 4), j.La && Nn(O, B, N, E);
                                    else {
                                        var q = U.B, D = U.qa, R = U.ra + 8 * C * q + 8 * A, T = U.Ha, U = U.Ia + 8 * C * q + 8 * A;
                                        C = j.ld;
                                        0 < A && (fn(O, B, N, E + 4, M, C), pn(D, R, T, U, q, E + 4, M, C)), j.La && (mn(O, B, N, E, M, C), bn(D, R, T, U, q, E, M, C)), 0 < x && (ln(O, B, N, E + 4, M, C), dn(D, R, T, U, q, E + 4, M, C)), j.La && (gn(O, B, N, E, M, C), vn(D, R, T, U, q, E, M, C));
                                    }
                                }
                            }
                            if (s.ia && alert("todo:DitherRow"), null != c.put) {
                                if (L = 16 * P, P = 16 * (P + 1), I ? (c.y = s.sa, c.O = s.ta + w, c.f = s.qa, c.N = s.ra + _, c.ea = s.Ha, c.W = s.Ia + _) : (L -= y, c.y = d, c.O = p, c.f = g, c.N = l, c.ea = m, c.W = v), b || (P -= y), P > c.o && (P = c.o), c.F = null, c.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (c.J = lr(s, c, L, P - L), c.F = s.mb, null == c.F && 0 == c.F.length)) {
                                    u = Jt(s, 3, "Could not decode alpha data.");
                                    break t;
                                }
                                L < c.j && (y = c.j - L, L = c.j, e(!(1 & y)), c.O += s.R * y, c.N += s.B * (y >> 1), c.W += s.B * (y >> 1), null != c.F && (c.J += c.width * y)), L < P && (c.O += c.v, c.N += c.v >> 1, c.W += c.v >> 1, null != c.F && (c.J += c.v), c.ka = L - c.j, c.U = c.va - c.v, c.T = P - L, u = c.put(c));
                            }
                            o + 1 != s.Ic || b || (n(s.sa, s.ta - h, d, p + 16 * s.R, h), n(s.qa, s.ra - f, g, l + 8 * s.B, f), n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                        }
                        if (!u) return Jt(t, 6, "Output aborted.");
                    }
                    return 1;
                }(t, r)), null != r.bc && r.bc(r), s &= 1;
            }
            return s ? (t.cb = 0, s) : 0;
        }
        function te(t, e, r, n, i) {
            i = t[e + r + 32 * n] + (i >> 3), t[e + r + 32 * n] = -256 & i ? 0 > i ? 0 : 255 : i;
        }
        function ee(t, e, r, n, i, a) {
            te(t, e, 0, r, n + i), te(t, e, 1, r, n + a), te(t, e, 2, r, n - a), te(t, e, 3, r, n - i);
        }
        function re(t) {
            return (20091 * t >> 16) + t;
        }
        function ne(t, e, r, n) {
            var i, o = 0, s = a(16);
            for(i = 0; 4 > i; ++i){
                var c = t[e + 0] + t[e + 8], u = t[e + 0] - t[e + 8], h = (35468 * t[e + 4] >> 16) - re(t[e + 12]), l = re(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = c + l, s[o + 1] = u + h, s[o + 2] = u - h, s[o + 3] = c - l, o += 4, e++;
            }
            for(i = o = 0; 4 > i; ++i)c = (t = s[o + 0] + 4) + s[o + 8], u = t - s[o + 8], h = (35468 * s[o + 4] >> 16) - re(s[o + 12]), te(r, n, 0, 0, c + (l = re(s[o + 4]) + (35468 * s[o + 12] >> 16))), te(r, n, 1, 0, u + h), te(r, n, 2, 0, u - h), te(r, n, 3, 0, c - l), o++, n += 32;
        }
        function ie(t, e, r, n) {
            var i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = re(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            ee(r, n, 0, i + o, t = re(t[e + 1]), s), ee(r, n, 1, i + a, t, s), ee(r, n, 2, i - a, t, s), ee(r, n, 3, i - o, t, s);
        }
        function ae(t, e, r, n, i) {
            ne(t, e, r, n), i && ne(t, e + 16, r, n + 4);
        }
        function oe(t, e, r, n) {
            on(t, e + 0, r, n, 1), on(t, e + 32, r, n + 128, 1);
        }
        function se(t, e, r, n) {
            var i;
            for(t = t[e + 0] + 4, i = 0; 4 > i; ++i)for(e = 0; 4 > e; ++e)te(r, n, e, i, t);
        }
        function ce(t, e, r, n) {
            t[e + 0] && un(t, e + 0, r, n), t[e + 16] && un(t, e + 16, r, n + 4), t[e + 32] && un(t, e + 32, r, n + 128), t[e + 48] && un(t, e + 48, r, n + 128 + 4);
        }
        function ue(t, e, r, n) {
            var i, o = a(16);
            for(i = 0; 4 > i; ++i){
                var s = t[e + 0 + i] + t[e + 12 + i], c = t[e + 4 + i] + t[e + 8 + i], u = t[e + 4 + i] - t[e + 8 + i], h = t[e + 0 + i] - t[e + 12 + i];
                o[0 + i] = s + c, o[8 + i] = s - c, o[4 + i] = h + u, o[12 + i] = h - u;
            }
            for(i = 0; 4 > i; ++i)s = (t = o[0 + 4 * i] + 3) + o[3 + 4 * i], c = o[1 + 4 * i] + o[2 + 4 * i], u = o[1 + 4 * i] - o[2 + 4 * i], h = t - o[3 + 4 * i], r[n + 0] = s + c >> 3, r[n + 16] = h + u >> 3, r[n + 32] = s - c >> 3, r[n + 48] = h - u >> 3, n += 64;
        }
        function he(t, e, r) {
            var n, i = e - 32, a = Bn, o = 255 - t[i - 1];
            for(n = 0; n < r; ++n){
                var s, c = a, u = o + t[e - 1];
                for(s = 0; s < r; ++s)t[e + s] = c[u + t[i + s]];
                e += 32;
            }
        }
        function le(t, e) {
            he(t, e, 4);
        }
        function fe(t, e) {
            he(t, e, 8);
        }
        function de(t, e) {
            he(t, e, 16);
        }
        function pe(t, e) {
            var r;
            for(r = 0; 16 > r; ++r)n(t, e + 32 * r, t, e - 32, 16);
        }
        function ge(t, e) {
            var r;
            for(r = 16; 0 < r; --r)i(t, e, t[e - 1], 16), e += 32;
        }
        function me(t, e, r) {
            var n;
            for(n = 0; 16 > n; ++n)i(e, r + 32 * n, t, 16);
        }
        function ve(t, e) {
            var r, n = 16;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r] + t[e + r - 32];
            me(n >> 5, t, e);
        }
        function be(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r];
            me(n >> 4, t, e);
        }
        function ye(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e + r - 32];
            me(n >> 4, t, e);
        }
        function we(t, e) {
            me(128, t, e);
        }
        function Ne(t, e, r) {
            return t + 2 * e + r + 2 >> 2;
        }
        function Le(t, e) {
            var r, i = e - 32;
            i = new Uint8Array([
                Ne(t[i - 1], t[i + 0], t[i + 1]),
                Ne(t[i + 0], t[i + 1], t[i + 2]),
                Ne(t[i + 1], t[i + 2], t[i + 3]),
                Ne(t[i + 2], t[i + 3], t[i + 4])
            ]);
            for(r = 0; 4 > r; ++r)n(t, e + 32 * r, i, 0, i.length);
        }
        function Ae(t, e) {
            var r = t[e - 1], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            I(t, e + 0, 16843009 * Ne(t[e - 1 - 32], r, n)), I(t, e + 32, 16843009 * Ne(r, n, i)), I(t, e + 64, 16843009 * Ne(n, i, a)), I(t, e + 96, 16843009 * Ne(i, a, a));
        }
        function xe(t, e) {
            var r, n = 4;
            for(r = 0; 4 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            for(n >>= 3, r = 0; 4 > r; ++r)i(t, e + 32 * r, n, 4);
        }
        function Se(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 96] = Ne(n, i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = Ne(r, n, i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, r, n), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = Ne(o, a, r), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = Ne(c, s, o), t[e + 3 + 0] = Ne(u, c, s);
        }
        function _e(t, e) {
            var r = t[e + 1 - 32], n = t[e + 2 - 32], i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = Ne(t[e + 0 - 32], r, n), t[e + 1 + 0] = t[e + 0 + 32] = Ne(r, n, i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(n, i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, c);
        }
        function Pe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + c + 1 >> 1, t[e + 3 + 0] = c + u + 1 >> 1, t[e + 0 + 96] = Ne(i, n, r), t[e + 0 + 64] = Ne(n, r, a), t[e + 0 + 32] = t[e + 1 + 96] = Ne(r, a, o), t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, c), t[e + 3 + 32] = Ne(s, c, u);
        }
        function ke(t, e) {
            var r = t[e + 0 - 32], n = t[e + 1 - 32], i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], c = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = n + i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = Ne(r, n, i), t[e + 1 + 32] = t[e + 0 + 96] = Ne(n, i, a), t[e + 2 + 32] = t[e + 1 + 96] = Ne(i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 3 + 64] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, u);
        }
        function Ie(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = n + i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = i + a + 1 >> 1, t[e + 1 + 0] = Ne(r, n, i), t[e + 3 + 0] = t[e + 1 + 32] = Ne(n, i, a), t[e + 3 + 32] = t[e + 1 + 64] = Ne(i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        }
        function Fe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], c = t[e + 1 - 32], u = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = r + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = n + r + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = i + n + 1 >> 1, t[e + 0 + 96] = a + i + 1 >> 1, t[e + 3 + 0] = Ne(s, c, u), t[e + 2 + 0] = Ne(o, s, c), t[e + 1 + 0] = t[e + 3 + 32] = Ne(r, o, s), t[e + 1 + 32] = t[e + 3 + 64] = Ne(n, r, o), t[e + 1 + 64] = t[e + 3 + 96] = Ne(i, n, r), t[e + 1 + 96] = Ne(a, i, n);
        }
        function Ce(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)n(t, e + 32 * r, t, e - 32, 8);
        }
        function je(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)i(t, e, t[e - 1], 8), e += 32;
        }
        function Oe(t, e, r) {
            var n;
            for(n = 0; 8 > n; ++n)i(e, r + 32 * n, t, 8);
        }
        function Be(t, e) {
            var r, n = 8;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            Oe(n >> 4, t, e);
        }
        function Me(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32];
            Oe(n >> 3, t, e);
        }
        function Ee(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e - 1 + 32 * r];
            Oe(n >> 3, t, e);
        }
        function qe(t, e) {
            Oe(128, t, e);
        }
        function De(t, e, r) {
            var n = t[e - r], i = t[e + 0], a = 3 * (i - n) + jn[1020 + t[e - 2 * r] - t[e + r]], o = On[112 + (a + 4 >> 3)];
            t[e - r] = Bn[255 + n + On[112 + (a + 3 >> 3)]], t[e + 0] = Bn[255 + i - o];
        }
        function Re(t, e, r, n) {
            var i = t[e + 0], a = t[e + r];
            return Mn[255 + t[e - 2 * r] - t[e - r]] > n || Mn[255 + a - i] > n;
        }
        function Te(t, e, r, n) {
            return 4 * Mn[255 + t[e - r] - t[e + 0]] + Mn[255 + t[e - 2 * r] - t[e + r]] <= n;
        }
        function Ue(t, e, r, n, i) {
            var a = t[e - 3 * r], o = t[e - 2 * r], s = t[e - r], c = t[e + 0], u = t[e + r], h = t[e + 2 * r], l = t[e + 3 * r];
            return 4 * Mn[255 + s - c] + Mn[255 + o - u] > n ? 0 : Mn[255 + t[e - 4 * r] - a] <= i && Mn[255 + a - o] <= i && Mn[255 + o - s] <= i && Mn[255 + l - h] <= i && Mn[255 + h - u] <= i && Mn[255 + u - c] <= i;
        }
        function ze(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n, r, i) && De(t, e + n, r);
        }
        function He(t, e, r, n) {
            var i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n * r, 1, i) && De(t, e + n * r, 1);
        }
        function We(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)ze(t, e += 4 * r, r, n);
        }
        function Ve(t, e, r, n) {
            var i;
            for(i = 3; 0 < i; --i)He(t, e += 4, r, n);
        }
        function Ge(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - 2 * h], f = c[u - h], d = c[u + 0], p = c[u + h], g = c[u + 2 * h], m = 27 * (b = jn[1020 + 3 * (d - f) + jn[1020 + l - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        c[u - 3 * h] = Bn[255 + c[u - 3 * h] + b], c[u - 2 * h] = Bn[255 + l + v], c[u - h] = Bn[255 + f + m], c[u + 0] = Bn[255 + d - m], c[u + h] = Bn[255 + p - v], c[u + 2 * h] = Bn[255 + g - b];
                    }
                }
                e += n;
            }
        }
        function Ye(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - h], f = c[u + 0], d = c[u + h], p = On[112 + ((g = 3 * (f - l)) + 4 >> 3)], g = On[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        c[u - 2 * h] = Bn[255 + c[u - 2 * h] + m], c[u - h] = Bn[255 + l + g], c[u + 0] = Bn[255 + f - p], c[u + h] = Bn[255 + d - m];
                    }
                }
                e += n;
            }
        }
        function Je(t, e, r, n, i, a) {
            Ge(t, e, r, 1, 16, n, i, a);
        }
        function Xe(t, e, r, n, i, a) {
            Ge(t, e, 1, r, 16, n, i, a);
        }
        function Ke(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4 * r, r, 1, 16, n, i, a);
        }
        function Ze(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4, 1, r, 16, n, i, a);
        }
        function $e(t, e, r, n, i, a, o, s) {
            Ge(t, e, i, 1, 8, a, o, s), Ge(r, n, i, 1, 8, a, o, s);
        }
        function Qe(t, e, r, n, i, a, o, s) {
            Ge(t, e, 1, i, 8, a, o, s), Ge(r, n, 1, i, 8, a, o, s);
        }
        function tr(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4 * i, i, 1, 8, a, o, s), Ye(r, n + 4 * i, i, 1, 8, a, o, s);
        }
        function er(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4, 1, i, 8, a, o, s), Ye(r, n + 4, 1, i, 8, a, o, s);
        }
        function rr() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ct, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        }
        function nr() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        }
        function ir() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        }
        function ar() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new l;
        }
        function or() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ar, this.ab = 0, this.gc = o(4, ir), this.Oc = 0;
        }
        function sr() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        }
        function cr(t, e, r, n, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + r[n + e] & 255, t = i[a + e];
        }
        function ur(t, e, r, n, i, a, o) {
            var s;
            if (null == t) cr(null, null, r, n, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + r[n + s] & 255;
        }
        function hr(t, e, r, n, i, a, o) {
            if (null == t) cr(null, null, r, n, i, a, o);
            else {
                var s, c = t[e + 0], u = c, h = c;
                for(s = 0; s < o; ++s)u = h + (c = t[e + s]) - u, h = r[n + s] + (-256 & u ? 0 > u ? 0 : 255 : u) & 255, u = c, i[a + s] = h;
            }
        }
        function lr(t, r, i, o) {
            var s = r.width, c = r.o;
            if (e(null != t && null != r), 0 > i || 0 >= o || i + o > c) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var u;
                    if (t.ga = new sr, (u = null == t.ga) || (u = r.width * r.o, e(0 == t.Gb.length), t.Gb = a(u), t.Uc = 0, null == t.Gb ? u = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, u = 1), u = !u), !u) {
                        u = t.ga;
                        var h = t.Fa, l = t.P, f = t.qc, d = t.mb, p = t.nb, g = l + 1, m = f - 1, b = u.l;
                        if (e(null != h && null != d && null != r), mi[0] = null, mi[1] = cr, mi[2] = ur, mi[3] = hr, u.ca = d, u.tb = p, u.c = r.width, u.i = r.height, e(0 < u.c && 0 < u.i), 1 >= f) r = 0;
                        else if (u.$a = h[l + 0] >> 0 & 3, u.Z = h[l + 0] >> 2 & 3, u.Lc = h[l + 0] >> 4 & 3, l = h[l + 0] >> 6 & 3, 0 > u.$a || 1 < u.$a || 4 <= u.Z || 1 < u.Lc || l) r = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = u, b.width = r.width, b.height = r.height, b.Da = r.Da, b.v = r.v, b.va = r.va, b.j = r.j, b.o = r.o, u.$a) t: {
                            e(1 == u.$a), r = kt();
                            e: for(;;){
                                if (null == r) {
                                    r = 0;
                                    break t;
                                }
                                if (e(null != u), u.mc = r, r.c = u.c, r.i = u.i, r.l = u.l, r.l.ma = u, r.l.width = u.c, r.l.height = u.i, r.a = 0, v(r.m, h, g, m), !It(u.c, u.i, 1, r, null)) break e;
                                if (1 == r.ab && 3 == r.gc[0].hc && At(r.s) ? (u.ic = 1, h = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = a(h), r.Ba = 0, null == r.V ? (r.a = 1, r = 0) : r = 1) : (u.ic = 0, r = Ft(r, u.c)), !r) break e;
                                r = 1;
                                break t;
                            }
                            u.mc = null, r = 0;
                        }
                        else r = m >= u.c * u.i;
                        u = !r;
                    }
                    if (u) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = c - i;
                }
                e(null != t.ga), e(i + o <= c);
                t: {
                    if (r = (h = t.ga).c, c = h.l.o, 0 == h.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, l = t.P + 1 + i * r, f = t.mb, d = t.nb + i * r, e(l <= t.P + t.qc), 0 != h.Z) for(e(null != mi[h.Z]), u = 0; u < o; ++u)mi[h.Z](g, m, b, l, f, d, r), g = f, m = d, d += r, l += r;
                        else for(u = 0; u < o; ++u)n(f, d, b, l, r), g = f, m = d, d += r, l += r;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != h.mc), r = i + o, e(null != (u = h.mc)), e(r <= u.i), u.C >= r) r = 1;
                        else if (h.ic || mr(), h.ic) {
                            h = u.V, g = u.Ba, m = u.c;
                            var y = u.i, w = (b = 1, l = u.$ / m, f = u.$ % m, d = u.m, p = u.s, u.$), N = m * y, L = m * r, x = p.wc, _ = w < L ? wt(p, f, l) : null;
                            e(w <= N), e(r <= y), e(At(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & x || (_ = wt(p, f, l)), e(null != _), S(d), 256 > (y = bt(_.G[0], _.H[0], d))) h[g + w] = y, ++w, ++f >= m && (f = 0, ++l <= r && !(l % 16) && St(u, l));
                                    else {
                                        if (!(280 > y)) {
                                            b = 0;
                                            break e;
                                        }
                                        y = mt(y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < y; ++P)h[g + w + P] = h[g + w + P - k];
                                        for(w += y, f += y; f >= m;)f -= m, ++l <= r && !(l % 16) && St(u, l);
                                        w < L && f & x && (_ = wt(p, f, l));
                                    }
                                    e(d.h == A(d));
                                }
                                St(u, l > r ? r : l);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, u.a = d.h ? 5 : 3) : u.$ = w, r = b;
                        } else r = _t(u, u.V, u.Ba, u.c, u.i, r, Ct);
                        if (!r) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= c && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        }
        function fr(t, e, r, n, i, a) {
            for(; 0 < i--;){
                var o, s = t, c = e + (r ? 1 : 0), u = t, h = e + (r ? 0 : 3);
                for(o = 0; o < n; ++o){
                    var l = u[h + 4 * o];
                    255 != l && (l *= 32897, s[c + 4 * o + 0] = s[c + 4 * o + 0] * l >> 23, s[c + 4 * o + 1] = s[c + 4 * o + 1] * l >> 23, s[c + 4 * o + 2] = s[c + 4 * o + 2] * l >> 23);
                }
                e += a;
            }
        }
        function dr(t, e, r, n, i) {
            for(; 0 < n--;){
                var a;
                for(a = 0; a < r; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (u = t[e + 2 * a + 1]), c = 4369 * s, u = (240 & u | u >> 4) * c >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * c >> 16 & 240 | (15 & o | o << 4) * c >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & u | s;
                }
                e += i;
            }
        }
        function pr(t, e, r, n, i, a, o, s) {
            var c, u, h = 255;
            for(u = 0; u < i; ++u){
                for(c = 0; c < n; ++c){
                    var l = t[e + c];
                    a[o + 4 * c] = l, h &= l;
                }
                e += r, o += s;
            }
            return 255 != h;
        }
        function gr(t, e, r, n, i) {
            var a;
            for(a = 0; a < i; ++a)r[n + a] = t[e + a] >> 8;
        }
        function mr() {
            An = fr, xn = dr, Sn = pr, _n = gr;
        }
        function vr(r, n, i) {
            t[r] = function(t, r, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[c + 0] | u[h + 0] << 16, A = l[f + 0] | d[p + 0] << 16;
                e(null != t);
                var x = 3 * L + A + 131074 >> 2;
                for(n(t[r + 0], 255 & x, x >> 16, g, m), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + 0], 255 & x, x >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[c + w] | u[h + w] << 16, _ = l[f + w] | d[p + w] << 16, P = L + S + A + _ + 524296, k = P + 2 * (S + A) >> 3;
                    x = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, n(t[r + 2 * w - 1], 255 & x, x >> 16, g, m + (2 * w - 1) * i), n(t[r + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (x = P + A >> 1, L = k + _ >> 1, n(a[o + 2 * w - 1], 255 & x, x >> 16, v, b + (2 * w - 1) * i), n(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, A = _;
                }
                1 & y || (x = 3 * L + A + 131074 >> 2, n(t[r + y - 1], 255 & x, x >> 16, g, m + (y - 1) * i), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + y - 1], 255 & x, x >> 16, v, b + (y - 1) * i)));
            };
        }
        function br() {
            vi[En] = bi, vi[qn] = wi, vi[Dn] = yi, vi[Rn] = Ni, vi[Tn] = Li, vi[Un] = Ai, vi[zn] = xi, vi[Hn] = wi, vi[Wn] = Ni, vi[Vn] = Li, vi[Gn] = Ai;
        }
        function yr(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> Ii;
        }
        function wr(t, e) {
            return yr((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        }
        function Nr(t, e, r) {
            return yr((19077 * t >> 8) - (6419 * e >> 8) - (13320 * r >> 8) + 8708);
        }
        function Lr(t, e) {
            return yr((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        }
        function Ar(t, e, r, n, i) {
            n[i + 0] = wr(t, r), n[i + 1] = Nr(t, e, r), n[i + 2] = Lr(t, e);
        }
        function xr(t, e, r, n, i) {
            n[i + 0] = Lr(t, e), n[i + 1] = Nr(t, e, r), n[i + 2] = wr(t, r);
        }
        function Sr(t, e, r, n, i) {
            var a = Nr(t, e, r);
            e = a << 3 & 224 | Lr(t, e) >> 3, n[i + 0] = 248 & wr(t, r) | a >> 5, n[i + 1] = e;
        }
        function _r(t, e, r, n, i) {
            var a = 240 & Lr(t, e) | 15;
            n[i + 0] = 240 & wr(t, r) | Nr(t, e, r) >> 4, n[i + 1] = a;
        }
        function Pr(t, e, r, n, i) {
            n[i + 0] = 255, Ar(t, e, r, n, i + 1);
        }
        function kr(t, e, r, n, i) {
            xr(t, e, r, n, i), n[i + 3] = 255;
        }
        function Ir(t, e, r, n, i) {
            Ar(t, e, r, n, i), n[i + 3] = 255;
        }
        function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        }
        function Fr(e, r, n) {
            t[e] = function(t, e, i, a, o, s, c, u, h) {
                for(var l = u + (-2 & h) * n; u != l;)r(t[e + 0], i[a + 0], o[s + 0], c, u), r(t[e + 1], i[a + 0], o[s + 0], c, u + n), e += 2, ++a, ++s, u += 2 * n;
                1 & h && r(t[e + 0], i[a + 0], o[s + 0], c, u);
            };
        }
        function Cr(t, e, r) {
            return 0 == r ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : r;
        }
        function jr(t, e, r, n, i) {
            switch(t >>> 30){
                case 3:
                    on(e, r, n, i, 0);
                    break;
                case 2:
                    sn(e, r, n, i);
                    break;
                case 1:
                    un(e, r, n, i);
            }
        }
        function Or(t, e) {
            var r, a, o = e.M, s = e.Nb, c = t.oc, u = t.pc + 40, h = t.oc, l = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(r = 0; 16 > r; ++r)c[u + 32 * r - 1] = 129;
            for(r = 0; 8 > r; ++r)h[l + 32 * r - 1] = 129, f[d + 32 * r - 1] = 129;
            for(0 < o ? c[u - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129 : (i(c, u - 32 - 1, 127, 21), i(h, l - 32 - 1, 127, 9), i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(r = -1; 16 > r; ++r)n(c, u + 32 * r - 4, c, u + 32 * r + 12, 4);
                    for(r = -1; 8 > r; ++r)n(h, l + 32 * r - 4, h, l + 32 * r + 4, 4), n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (n(c, u - 32, g[m].y, 0, 16), n(h, l - 32, g[m].f, 0, 8), n(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var y = c, w = u - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? i(y, w, g[m].y[15], 4) : n(y, w, g[m + 1].y, 0, 4)), r = 0; 4 > r; r++)y[w + 128 + r] = y[w + 256 + r] = y[w + 384 + r] = y[w + 0 + r];
                    for(r = 0; 16 > r; ++r, b <<= 2)y = c, w = u + Di[r], fi[p.Ob[r]](y, w), jr(b, v, 16 * +r, y, w);
                } else if (y = Cr(a, o, p.Ob[0]), li[y](c, u), 0 != b) for(r = 0; 16 > r; ++r, b <<= 2)jr(b, v, 16 * +r, c, u + Di[r]);
                for(r = p.Gc, y = Cr(a, o, p.Dd), di[y](h, l), di[y](f, d), b = v, y = h, w = l, 255 & (p = r >> 0) && (170 & p ? cn(b, 256, y, w) : hn(b, 256, y, w)), p = f, b = d, 255 & (r >>= 8) && (170 & r ? cn(v, 320, p, b) : hn(v, 320, p, b)), o < t.Ub - 1 && (n(g[m].y, 0, c, u + 480, 16), n(g[m].f, 0, h, l + 224, 8), n(g[m].ea, 0, f, d + 224, 8)), r = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + r, b = t.Ha, y = t.Ia + 8 * a + r, r = 0; 16 > r; ++r)n(g, m + r * t.R, c, u + 32 * r, 16);
                for(r = 0; 8 > r; ++r)n(v, p + r * t.B, h, l + 32 * r, 8), n(b, y + r * t.B, f, d + 32 * r, 8);
            }
        }
        function Br(t, n, i, a, o, s, c, u, h) {
            var l = [
                0
            ], f = [
                0
            ], d = 0, p = null != h ? h.kd : 0, g = null != h ? h : new nr;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = n, g.ha = i, n = [
                n
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = n, b = i, y = g.gb;
                if (e(null != t), e(null != b), e(null != y), y[0] = 0, 12 <= b[0] && !r(t, m[0], "RIFF")) {
                    if (r(t, m[0] + 8, "WEBP")) {
                        y = 3;
                        break t;
                    }
                    var w = j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        y = 7;
                        break t;
                    }
                    y[0] = w, m[0] += 12, b[0] -= 12;
                }
                y = 0;
            }
            if (0 != y) return y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = n, y = i;
                    var A = l, x = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > y[0]) y = 7;
                    else {
                        if (!r(L, b[0], "VP8X")) {
                            if (10 != j(L, b[0] + 4)) {
                                y = 3;
                                break t;
                            }
                            if (18 > y[0]) {
                                y = 7;
                                break t;
                            }
                            var _ = j(L, b[0] + 8), P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != A && (A[0] = P), null != x && (x[0] = L), b[0] += 18, y[0] -= 18, k[0] = 1;
                        }
                        y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != y) return y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != c && (c[0] = b), null != u && (u[0] = 0), c = l[0], m = f[0], d && b && null == h) {
                    y = 0;
                    break;
                }
                if (4 > i) {
                    y = 7;
                    break;
                }
                if (w && d || !w && !d && !r(t, n[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, y = n, w = i;
                        var k = g.gb;
                        A = g.na, x = g.P, S = g.Sa;
                        P = 22, e(null != _), e(null != w), L = y[0];
                        var I = w[0];
                        for(e(null != A), e(null != S), A[0] = null, x[0] = null, S[0] = 0;;){
                            if (y[0] = L, w[0] = I, 8 > I) {
                                y = 7;
                                break t;
                            }
                            var F = j(_, L + 4);
                            if (4294967286 < F) {
                                y = 3;
                                break t;
                            }
                            var O = 8 + F + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                y = 3;
                                break t;
                            }
                            if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                                y = 0;
                                break t;
                            }
                            if (I[0] < O) {
                                y = 7;
                                break t;
                            }
                            r(_, L, "ALPH") || (A[0] = _, x[0] = L + 8, S[0] = F), L += O, I -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, y = n, w = i, A = g.gb[0], x = g.Ja, S = g.xa, _ = y[0], L = !r(k, _, "VP8 "), P = !r(k, _, "VP8L"), e(null != k), e(null != w), e(null != x), e(null != S), 8 > w[0]) y = 7;
                else {
                    if (L || P) {
                        if (k = j(k, _ + 4), 12 <= A && k > A - 12) {
                            y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            y = 7;
                            break t;
                        }
                        x[0] = k, y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), x[0] = w[0];
                    y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], n = n[0], 0 != y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == u || b || (u[0] = g.xa ? 2 : 1), c = [
                    c
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        y = 7;
                        break;
                    }
                    u = c, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], A = [
                        0
                    ], v(x = new N, t, n, i), gt(x, w, k, A) ? (null != u && (u[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = A[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        y = 7;
                        break;
                    }
                    u = m, null == t || 10 > i || !Xt(t, n + 3, i - 3) ? t = 0 : (p = t[n + 0] | t[n + 1] << 8 | t[n + 2] << 16, b = 16383 & (t[n + 7] << 8 | t[n + 6]), t = 16383 & (t[n + 9] << 8 | t[n + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (c && (c[0] = b), u && (u[0] = t), t = 1));
                }
                if (!t) return 3;
                if (c = c[0], m = m[0], d && (l[0] != c || f[0] != m)) return 3;
                null != h && (h[0] = g, h.offset = n - h.w, e(4294967286 > n - h.w), e(h.offset == h.ha - i));
                break;
            }
            return 0 == y || 7 == y && d && null == h ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = c), null != o && (o[0] = m), 0) : y;
        }
        function Mr(t, e, r) {
            var n = e.width, i = e.height, a = 0, o = 0, s = n, c = i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, c = t.bd, a = t.v, o = t.j, 11 > r || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= c || a + s > n || o + c > i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + c, e.U = s, e.T = c, e.da = null != t && 0 < t.da, e.da) {
                if (!E(s, c, r = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = r[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * n / 4 && e.hb < 3 * i / 4, e.Kb = 0), 1;
        }
        function Er(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        }
        function qr(t, e, r, n) {
            if (null == n || 0 >= t || 0 >= e) return 2;
            if (null != r) {
                if (r.Da) {
                    var i = r.cd, o = r.bd, s = -2 & r.v, c = -2 & r.j;
                    if (0 > s || 0 > c || 0 >= i || 0 >= o || s + i > t || c + o > e) return 2;
                    t = i, e = o;
                }
                if (r.da) {
                    if (!E(t, e, i = [
                        r.ib
                    ], o = [
                        r.hb
                    ])) return 2;
                    t = i[0], e = o[0];
                }
            }
            n.width = t, n.height = e;
            t: {
                var u = n.width, h = n.height;
                if (t = n.S, 0 >= u || 0 >= h || !(t >= En && 13 > t)) t = 2;
                else {
                    if (0 >= n.Rd && null == n.sd) {
                        s = o = i = e = 0;
                        var l = (c = u * zi[t]) * h;
                        if (11 > t || (o = (h + 1) / 2 * (e = (u + 1) / 2), 12 == t && (s = (i = u) * h)), null == (h = a(l + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        n.sd = h, 11 > t ? ((u = n.f.RGBA).eb = h, u.fb = 0, u.A = c, u.size = l) : ((u = n.f.kb).y = h, u.O = 0, u.fa = c, u.Fd = l, u.f = h, u.N = 0 + l, u.Ab = e, u.Cd = o, u.ea = h, u.W = 0 + l + o, u.Db = e, u.Ed = o, 12 == t && (u.F = h, u.J = 0 + l + 2 * o), u.Tc = s, u.lb = i);
                    }
                    if (e = 1, i = n.S, o = n.width, s = n.height, i >= En && 13 > i) {
                        if (11 > i) t = n.f.RGBA, e &= (c = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= c >= o * zi[i], e &= null != t.eb;
                        else {
                            t = n.f.kb, c = (o + 1) / 2, l = (s + 1) / 2, u = Math.abs(t.fa);
                            h = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= u * (s - 1) + o <= t.Fd, e &= h * (l - 1) + c <= t.Cd, e = (e &= f * (l - 1) + c <= t.Ed) & u >= o & h >= c & f >= c, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != r && r.fd && (t = Er(n)), t;
        }
        var Dr = 64, Rr = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tr = 24, Ur = 32, zr = 8, Hr = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        R("Predictor0", "PredictorAdd0"), t.Predictor0 = function() {
            return 4278190080;
        }, t.Predictor1 = function(t) {
            return t;
        }, t.Predictor2 = function(t, e, r) {
            return e[r + 0];
        }, t.Predictor3 = function(t, e, r) {
            return e[r + 1];
        }, t.Predictor4 = function(t, e, r) {
            return e[r - 1];
        }, t.Predictor5 = function(t, e, r) {
            return U(U(t, e[r + 1]), e[r + 0]);
        }, t.Predictor6 = function(t, e, r) {
            return U(t, e[r - 1]);
        }, t.Predictor7 = function(t, e, r) {
            return U(t, e[r + 0]);
        }, t.Predictor8 = function(t, e, r) {
            return U(e[r - 1], e[r + 0]);
        }, t.Predictor9 = function(t, e, r) {
            return U(e[r + 0], e[r + 1]);
        }, t.Predictor10 = function(t, e, r) {
            return U(U(t, e[r - 1]), U(e[r + 0], e[r + 1]));
        }, t.Predictor11 = function(t, e, r) {
            var n = e[r + 0];
            return 0 >= W(n >> 24 & 255, t >> 24 & 255, (e = e[r - 1]) >> 24 & 255) + W(n >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(n >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & n, 255 & t, 255 & e) ? n : t;
        }, t.Predictor12 = function(t, e, r) {
            var n = e[r + 0];
            return (z((t >> 24 & 255) + (n >> 24 & 255) - ((e = e[r - 1]) >> 24 & 255)) << 24 | z((t >> 16 & 255) + (n >> 16 & 255) - (e >> 16 & 255)) << 16 | z((t >> 8 & 255) + (n >> 8 & 255) - (e >> 8 & 255)) << 8 | z((255 & t) + (255 & n) - (255 & e))) >>> 0;
        }, t.Predictor13 = function(t, e, r) {
            var n = e[r - 1];
            return (H((t = U(t, e[r + 0])) >> 24 & 255, n >> 24 & 255) << 24 | H(t >> 16 & 255, n >> 16 & 255) << 16 | H(t >> 8 & 255, n >> 8 & 255) << 8 | H(t >> 0 & 255, n >> 0 & 255)) >>> 0;
        };
        var Wr = t.PredictorAdd0;
        t.PredictorAdd1 = V, R("Predictor2", "PredictorAdd2"), R("Predictor3", "PredictorAdd3"), R("Predictor4", "PredictorAdd4"), R("Predictor5", "PredictorAdd5"), R("Predictor6", "PredictorAdd6"), R("Predictor7", "PredictorAdd7"), R("Predictor8", "PredictorAdd8"), R("Predictor9", "PredictorAdd9"), R("Predictor10", "PredictorAdd10"), R("Predictor11", "PredictorAdd11"), R("Predictor12", "PredictorAdd12"), R("Predictor13", "PredictorAdd13");
        var Vr = t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gr, Yr = t.ColorIndexInverseTransform, Jr = t.MapARGB, Xr = t.VP8LColorIndexInverseTransformAlpha, Kr = t.MapAlpha, Zr = t.VP8LPredictorsAdd = [];
        Zr.length = 16, (t.VP8LPredictors = []).length = 16, (t.VP8LPredictorsAdd_C = []).length = 16, (t.VP8LPredictors_C = []).length = 16;
        var $r, Qr, tn, en, rn, nn, an, on, sn, cn, un, hn, ln, fn, dn, pn, gn, mn, vn, bn, yn, wn, Nn, Ln, An, xn, Sn, _n, Pn = a(511), kn = a(2041), In = a(225), Fn = a(767), Cn = 0, jn = kn, On = In, Bn = Fn, Mn = Pn, En = 0, qn = 1, Dn = 2, Rn = 3, Tn = 4, Un = 5, zn = 6, Hn = 7, Wn = 8, Vn = 9, Gn = 10, Yn = [
            2,
            3,
            7
        ], Jn = [
            3,
            3,
            11
        ], Xn = [
            280,
            256,
            256,
            256,
            40
        ], Kn = [
            0,
            1,
            1,
            1,
            0
        ], Zn = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], $n = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], Qn = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], ti = 8, ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ri = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ii = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ai = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], oi = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], si = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], ci = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], hi = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], fi = [], di = [], pi = 1, gi = 2, mi = [], vi = [];
        vr("UpsampleRgbLinePair", Ar, 3), vr("UpsampleBgrLinePair", xr, 3), vr("UpsampleRgbaLinePair", Ir, 4), vr("UpsampleBgraLinePair", kr, 4), vr("UpsampleArgbLinePair", Pr, 4), vr("UpsampleRgba4444LinePair", _r, 2), vr("UpsampleRgb565LinePair", Sr, 2);
        var bi = t.UpsampleRgbLinePair, yi = t.UpsampleBgrLinePair, wi = t.UpsampleRgbaLinePair, Ni = t.UpsampleBgraLinePair, Li = t.UpsampleArgbLinePair, Ai = t.UpsampleRgba4444LinePair, xi = t.UpsampleRgb565LinePair, Si = 16, _i = 1 << Si - 1, Pi = -227, ki = 482, Ii = 6, Fi = (256 << Ii) - 1, Ci = 0, ji = a(256), Oi = a(256), Bi = a(256), Mi = a(256), Ei = a(ki - Pi), qi = a(ki - Pi);
        Fr("YuvToRgbRow", Ar, 3), Fr("YuvToBgrRow", xr, 3), Fr("YuvToRgbaRow", Ir, 4), Fr("YuvToBgraRow", kr, 4), Fr("YuvToArgbRow", Pr, 4), Fr("YuvToRgba4444Row", _r, 2), Fr("YuvToRgb565Row", Sr, 2);
        var Di = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Ti = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ui = 1;
        this.WebPDecodeRGBA = function(t, r, n, i, a) {
            var o = qn, s = new rr, c = new ot;
            s.ba = c, c.S = o, c.width = [
                c.width
            ], c.height = [
                c.height
            ];
            var u = c.width, h = c.height, l = new st;
            if (null == l || null == t) var f = 2;
            else e(null != l), f = Br(t, r, n, l.width, l.height, l.Pd, l.Qd, l.format, null);
            if (0 != f ? u = 0 : (null != u && (u[0] = l.width[0]), null != h && (h[0] = l.height[0]), u = 1), u) {
                c.width = c.width[0], c.height = c.height[0], null != i && (i[0] = c.width), null != a && (a[0] = c.height);
                t: {
                    if (i = new Gt, (a = new nr).data = t, a.w = r, a.ha = n, a.kd = 1, r = [
                        0
                    ], e(null != a), (0 == (t = Br(a.data, a.w, a.ha, null, null, null, r, null, a)) || 7 == t) && r[0] && (t = 4), 0 == (r = t)) {
                        if (e(null != s), i.data = a.data, i.w = a.w + a.offset, i.ha = a.ha - a.offset, i.put = dt, i.ac = ft, i.bc = pt, i.ma = s, a.xa) {
                            if (null == (t = kt())) {
                                s = 1;
                                break t;
                            }
                            if (function(t, r) {
                                var n = [
                                    0
                                ], i = [
                                    0
                                ], a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == r) return t.a = 2, 0;
                                    if (t.l = r, t.a = 0, v(t.m, r.data, r.w, r.ha), !gt(t.m, n, i, a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = gi, r.width = n[0], r.height = i[0], !It(n[0], i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, i)) {
                                if (i = 0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    e: {
                                        i = t;
                                        r: for(;;){
                                            if (null == i) {
                                                i = 0;
                                                break e;
                                            }
                                            if (e(null != i.s.yc), e(null != i.s.Ya), e(0 < i.s.Wb), e(null != (n = i.l)), e(null != (a = n.ma)), 0 != i.xb) {
                                                if (i.ca = a.ba, i.tb = a.tb, e(null != i.ca), !Mr(a.Oa, n, Rn)) {
                                                    i.a = 2;
                                                    break r;
                                                }
                                                if (!Ft(i, n.width)) break r;
                                                if (n.da) break r;
                                                if ((n.da || nt(i.ca.S)) && mr(), 11 > i.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != i.ca.f.kb.F && mr()), i.Pb && 0 < i.s.ua && null == i.s.vb.X && !O(i.s.vb, i.s.Wa.Xa)) {
                                                    i.a = 1;
                                                    break r;
                                                }
                                                i.xb = 0;
                                            }
                                            if (!_t(i, i.V, i.Ba, i.c, i.i, n.o, Lt)) break r;
                                            a.Dc = i.Ma, i = 1;
                                            break e;
                                        }
                                        e(0 != i.a), i = 0;
                                    }
                                    i = !i;
                                }
                                i && (r = t.a);
                            } else r = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = a.na, t.P = a.P, t.qc = a.Sa, Kt(t, i)) {
                                if (0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    if (t.Aa = 0, n = s.Oa, e(null != (a = t)), null != n) {
                                        if (0 < (u = 0 > (u = n.Md) ? 0 : 100 < u ? 255 : 255 * u / 100)) {
                                            for(h = l = 0; 4 > h; ++h)12 > (f = a.pb[h]).lc && (f.ia = u * Ti[0 > f.lc ? 0 : f.lc] >> 3), l |= f.ia;
                                            l && (alert("todo:VP8InitRandom"), a.ia = 1);
                                        }
                                        a.Ga = n.Id, 100 < a.Ga ? a.Ga = 100 : 0 > a.Ga && (a.Ga = 0);
                                    }
                                    Qt(t, i) || (r = t.a);
                                }
                            } else r = t.a;
                        }
                        0 == r && null != s.Oa && s.Oa.fd && (r = Er(s.ba));
                    }
                    s = r;
                }
                o = 0 != s ? null : 11 > o ? c.f.RGBA.eb : c.f.kb.y;
            } else o = null;
            return o;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    function u(t, e) {
        for(var r = "", n = 0; n < 4; n++)r += String.fromCharCode(t[e++]);
        return r;
    }
    function h(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    }
    function l(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    }
    new c;
    var f = [
        0
    ], d = [
        0
    ], p = [], g = new c, m = t, v = function(t, e) {
        var r = {}, n = 0, i = !1, a = 0, o = 0;
        if (r.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e, r, n) {
            for(var i = 0; i < n; i++)if (t[e + i] != r.charCodeAt(i)) return !0;
            return !1;
        }(t, e, "RIFF", 4)) {
            var s, c;
            l(t, e += 4);
            for(e += 8; e < t.length;){
                var f = u(t, e), d = l(t, e += 4);
                e += 4;
                var p = d + (1 & d);
                switch(f){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === r.frames[n] && (r.frames[n] = {});
                        (v = r.frames[n]).src_off = i ? o : e - 8, v.src_size = a + d + 8, n++, i && (i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (v = r.header = {}).feature_flags = t[e];
                        var g = e + 4;
                        v.canvas_width = 1 + h(t, g);
                        g += 3;
                        v.canvas_height = 1 + h(t, g);
                        g += 3;
                        break;
                    case "ALPH":
                        i = !0, a = p + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (v = r.header).bgcolor = l(t, e);
                        g = e + 4;
                        v.loop_count = (s = t)[(c = g) + 0] << 0 | s[c + 1] << 8;
                        g += 2;
                        break;
                    case "ANMF":
                        var m, v;
                        (v = r.frames[n] = {}).offset_x = 2 * h(t, e), e += 3, v.offset_y = 2 * h(t, e), e += 3, v.width = 1 + h(t, e), e += 3, v.height = 1 + h(t, e), e += 3, v.duration = h(t, e), e += 3, m = t[e++], v.dispose = 1 & m, v.blend = m >> 1 & 1;
                }
                "ANMF" != f && (e += p);
            }
            return r;
        }
    }(m, 0);
    v.response = m, v.rgbaoutput = !0, v.dataurl = !1;
    var b = v.header ? v.header : null, y = v.frames ? v.frames : null;
    if (b) {
        b.loop_counter = b.loop_count, f = [
            b.canvas_height
        ], d = [
            b.canvas_width
        ];
        for(var w = 0; w < y.length && 0 != y[w].blend; w++);
    }
    var N = y[0], L = g.WebPDecodeRGBA(m, N.src_off, N.src_size, d, f);
    N.rgba = L, N.imgwidth = d[0], N.imgheight = f[0];
    for(var A = 0; A < d[0] * f[0] * 4; A++)p[A] = L[A];
    return this.width = d, this.height = f, this.data = p, this;
}

!function(t) {
    var r = function() {
        return "function" == typeof (0, $461bf5d8bd29e0d8$export$f87121a6d50aff25);
    }, n = function(r, n, a, h) {
        var l = 4, f = s;
        switch(h){
            case t.image_compression.FAST:
                l = 1, f = o;
                break;
            case t.image_compression.MEDIUM:
                l = 6, f = c;
                break;
            case t.image_compression.SLOW:
                l = 9, f = u;
        }
        r = i(r, n, a, f);
        var d = (0, $461bf5d8bd29e0d8$export$f87121a6d50aff25)(r, {
            level: l
        });
        return t.__addimage__.arrayBufferToBinaryString(d);
    }, i = function(t, e, r, n) {
        for(var i, a, o, s = t.length / e, c = new Uint8Array(t.length + s), u = l(), h = 0; h < s; h += 1){
            if (o = h * e, i = t.subarray(o, o + e), n) c.set(n(i, r, a), o + h);
            else {
                for(var d, p = u.length, g = []; d < p; d += 1)g[d] = u[d](i, r, a);
                var m = f(g.concat());
                c.set(g[m], o + h);
            }
            a = i;
        }
        return c;
    }, a = function(t) {
        var e = Array.apply([], t);
        return e.unshift(0), e;
    }, o = function(t, e) {
        var r, n = [], i = t.length;
        n[0] = 1;
        for(var a = 0; a < i; a += 1)r = t[a - e] || 0, n[a + 1] = t[a] - r + 256 & 255;
        return n;
    }, s = function(t, e, r) {
        var n, i = [], a = t.length;
        i[0] = 2;
        for(var o = 0; o < a; o += 1)n = r && r[o] || 0, i[o + 1] = t[o] - n + 256 & 255;
        return i;
    }, c = function(t, e, r) {
        var n, i, a = [], o = t.length;
        a[0] = 3;
        for(var s = 0; s < o; s += 1)n = t[s - e] || 0, i = r && r[s] || 0, a[s + 1] = t[s] + 256 - (n + i >>> 1) & 255;
        return a;
    }, u = function(t, e, r) {
        var n, i, a, o, s = [], c = t.length;
        s[0] = 4;
        for(var u = 0; u < c; u += 1)n = t[u - e] || 0, i = r && r[u] || 0, a = r && r[u - e] || 0, o = h(n, i, a), s[u + 1] = t[u] - o + 256 & 255;
        return s;
    }, h = function(t, e, r) {
        if (t === e && e === r) return t;
        var n = Math.abs(e - r), i = Math.abs(t - r), a = Math.abs(t + e - r - r);
        return n <= i && n <= a ? t : i <= a ? e : r;
    }, l = function() {
        return [
            a,
            o,
            s,
            c,
            u
        ];
    }, f = function(t) {
        var e = t.map(function(t) {
            return t.reduce(function(t, e) {
                return t + Math.abs(e);
            }, 0);
        });
        return e.indexOf(Math.min.apply(null, e));
    };
    t.processPNG = function(e, i, a, o) {
        var s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L = this.decode.FLATE_DECODE, A = "";
        if (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)), this.__addimage__.isArrayBufferView(e)) {
            if (e = (u = new $15d064020a078dff$var$Kt(e)).imgData, c = u.bits, s = u.colorSpace, l = u.colors, -1 !== [
                4,
                6
            ].indexOf(u.colorType)) {
                if (8 === u.bits) {
                    g = (p = 32 == u.pixelBitlength ? new Uint32Array(u.decodePixels().buffer) : 16 == u.pixelBitlength ? new Uint16Array(u.decodePixels().buffer) : new Uint8Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * u.colors), m = new Uint8Array(g);
                    var x, S = u.pixelBitlength - u.bits;
                    for(w = 0, N = 0; w < g; w++){
                        for(y = p[w], x = 0; x < S;)v[N++] = y >>> x & 255, x += u.bits;
                        m[w] = y >>> x & 255;
                    }
                }
                if (16 === u.bits) {
                    g = (p = new Uint32Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * (32 / u.pixelBitlength) * u.colors), m = new Uint8Array(g * (32 / u.pixelBitlength)), b = u.colors > 1, w = 0, N = 0;
                    for(var _ = 0; w < g;)y = p[w++], v[N++] = y >>> 0 & 255, b && (v[N++] = y >>> 16 & 255, y = p[w++], v[N++] = y >>> 0 & 255), m[_++] = y >>> 16 & 255;
                    c = 8;
                }
                o !== t.image_compression.NONE && r() ? (e = n(v, u.width * u.colors, u.colors, o), d = n(m, u.width, 1, o)) : (e = v, d = m, L = void 0);
            }
            if (3 === u.colorType && (s = this.color_spaces.INDEXED, f = u.palette, u.transparency.indexed)) {
                var P = u.transparency.indexed, k = 0;
                for(w = 0, g = P.length; w < g; ++w)k += P[w];
                if ((k /= 255) === g - 1 && -1 !== P.indexOf(0)) h = [
                    P.indexOf(0)
                ];
                else if (k !== g) {
                    for(p = u.decodePixels(), m = new Uint8Array(p.length), w = 0, g = p.length; w < g; w++)m[w] = P[p[w]];
                    d = n(m, u.width, 1);
                }
            }
            var I = function(e) {
                var r;
                switch(e){
                    case t.image_compression.FAST:
                        r = 11;
                        break;
                    case t.image_compression.MEDIUM:
                        r = 13;
                        break;
                    case t.image_compression.SLOW:
                        r = 14;
                        break;
                    default:
                        r = 12;
                }
                return r;
            }(o);
            return L === this.decode.FLATE_DECODE && (A = "/Predictor " + I + " "), A += "/Colors " + l + " /BitsPerComponent " + c + " /Columns " + u.width, (this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) && (e = this.__addimage__.arrayBufferToBinaryString(e)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), {
                alias: a,
                data: e,
                index: i,
                filter: L,
                decodeParameters: A,
                transparency: h,
                palette: f,
                sMask: d,
                predictor: I,
                width: u.width,
                height: u.height,
                bitsPerComponent: c,
                colorSpace: s
            };
        }
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), function(t) {
    t.processGIF89A = function(e, r, n, i) {
        var a = new $15d064020a078dff$var$Zt(e), o = a.width, s = a.height, c = [];
        a.decodeAndBlitFrameRGBA(0, c);
        var u = {
            data: c,
            width: o,
            height: s
        }, h = new $15d064020a078dff$var$Qt(100).encode(u, 100);
        return t.processJPEG.call(this, h, r, n, i);
    }, t.processGIF87A = t.processGIF89A;
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), $15d064020a078dff$var$te.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(t);
        for(var e = 0; e < t; e++){
            var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: i,
                green: n,
                blue: r,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $15d064020a078dff$var$te.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[t]();
    } catch (t) {
        $15d064020a078dff$var$a.log("bit decode error:" + t);
    }
}, $15d064020a078dff$var$te.prototype.bit1 = function() {
    var t, e = Math.ceil(this.width / 8), r = e % 4;
    for(t = this.height - 1; t >= 0; t--){
        for(var n = this.bottom_up ? t : this.height - 1 - t, i = 0; i < e; i++)for(var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
            var c = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== r && (this.pos += 4 - r);
    }
}, $15d064020a078dff$var$te.prototype.bit4 = function() {
    for(var t = Math.ceil(this.width / 2), e = t % 4, r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < t; i++){
            var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 2 * i * 4, s = a >> 4, c = 15 & a, u = this.palette[s];
            if (this.data[o] = u.blue, this.data[o + 1] = u.green, this.data[o + 2] = u.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
            u = this.palette[c], this.data[o + 4] = u.blue, this.data[o + 4 + 1] = u.green, this.data[o + 4 + 2] = u.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $15d064020a078dff$var$te.prototype.bit8 = function() {
    for(var t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++){
            var i = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 4 * n;
            if (i < this.palette.length) {
                var o = this.palette[i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== t && (this.pos += 4 - t);
    }
}, $15d064020a078dff$var$te.prototype.bit15 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, c = (a >> 10 & e) / e * 255 | 0, u = a >> 15 ? 255 : 0, h = n * this.width * 4 + 4 * i;
            this.data[h] = c, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = u;
        }
        this.pos += t;
    }
}, $15d064020a078dff$var$te.prototype.bit16 = function() {
    for(var t = this.width % 3, e = parseInt("11111", 2), r = parseInt("111111", 2), n = this.height - 1; n >= 0; n--){
        for(var i = this.bottom_up ? n : this.height - 1 - n, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, c = (o >> 5 & r) / r * 255 | 0, u = (o >> 11) / e * 255 | 0, h = i * this.width * 4 + 4 * a;
            this.data[h] = u, this.data[h + 1] = c, this.data[h + 2] = s, this.data[h + 3] = 255;
        }
        this.pos += t;
    }
}, $15d064020a078dff$var$te.prototype.bit24 = function() {
    for(var t = this.height - 1; t >= 0; t--){
        for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
            var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * r;
            this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = n, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $15d064020a078dff$var$te.prototype.bit32 = function() {
    for(var t = this.height - 1; t >= 0; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++){
        var n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * r;
        this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = n, this.data[s + 3] = o;
    }
}, $15d064020a078dff$var$te.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, r, n, i) {
        var a = new $15d064020a078dff$var$te(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $15d064020a078dff$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), $15d064020a078dff$var$ee.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, r, n, i) {
        var a = new $15d064020a078dff$var$ee(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $15d064020a078dff$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), $15d064020a078dff$export$ba1e2ffc633a60f5.API.processRGBA = function(t, e, r) {
    for(var n = t.data, i = n.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, c = 0, u = 0; u < i; u += 4){
        var h = n[u], l = n[u + 1], f = n[u + 2], d = n[u + 3];
        a[s++] = h, a[s++] = l, a[s++] = f, o[c++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: r,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, $15d064020a078dff$export$ba1e2ffc633a60f5.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, $15d064020a078dff$var$Vt = $15d064020a078dff$export$ba1e2ffc633a60f5.API, $15d064020a078dff$var$Gt = $15d064020a078dff$var$Vt.getCharWidthsArray = function(e, r) {
    var n, i, a = (r = r || {}).font || this.internal.getFont(), o = r.fontSize || this.internal.getFontSize(), s = r.charSpace || this.internal.getCharSpace(), c = r.widths ? r.widths : a.metadata.Unicode.widths, u = c.fof ? c.fof : 1, h = r.kerning ? r.kerning : a.metadata.Unicode.kerning, l = h.fof ? h.fof : 1, f = !1 !== r.doKerning, d = 0, p = e.length, g = 0, m = c[0] || u, v = [];
    for(n = 0; n < p; n++)i = e.charCodeAt(n), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(h[i]) && !isNaN(parseInt(h[i][g], 10)) ? h[i][g] / l : 0, v.push((c[i] || m) / u + d)), g = i;
    return v;
}, $15d064020a078dff$var$Yt = $15d064020a078dff$var$Vt.getStringUnitWidth = function(t, e) {
    var r = (e = e || {}).fontSize || this.internal.getFontSize(), n = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
    return $15d064020a078dff$var$Vt.processArabic && (t = $15d064020a078dff$var$Vt.processArabic(t)), "function" == typeof n.metadata.widthOfString ? n.metadata.widthOfString(t, r, i) / r : $15d064020a078dff$var$Gt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $15d064020a078dff$var$Jt = function(t, e, r, n) {
    for(var i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r;)s += e[a], a++;
    i.push(t.slice(0, a));
    var c = a;
    for(s = 0; a !== o;)s + e[a] > n && (i.push(t.slice(c, a)), s = 0, c = a), s += e[a], a++;
    return c !== a && i.push(t.slice(c, a)), i;
}, $15d064020a078dff$var$Xt = function(t, e, r) {
    r || (r = {});
    var n, i, a, o, s, c, u, h = [], l = [
        h
    ], f = r.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $15d064020a078dff$var$Gt.apply(this, [
        " ",
        r
    ])[0];
    if (c = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0) {
        var v = Array(c).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, c = $15d064020a078dff$var$Yt.apply(this, [
            v,
            r
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var y = 0;
        if (n = g[a], c && "\n" == n[0] && (n = n.substr(1), y = 1), f + d + (p = (i = $15d064020a078dff$var$Gt.apply(this, [
            n,
            r
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || y) {
            if (p > e) {
                for(s = $15d064020a078dff$var$Jt.apply(this, [
                    n,
                    i,
                    e - (f + d),
                    e
                ]), h.push(s.shift()), h = [
                    s.pop()
                ]; s.length;)l.push([
                    s.shift()
                ]);
                p = i.slice(n.length - (h[0] ? h[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else h = [
                n
            ];
            l.push(h), f = p + c, d = m;
        } else h.push(n), f += d + p, d = m;
    }
    return u = c ? function(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, l.map(u);
}, $15d064020a078dff$var$Vt.splitTextToSize = function(t, e, r) {
    var n, i = (r = r || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var e = this.internal.getFont(t.fontName, t.fontStyle);
        return e.metadata.Unicode ? {
            widths: e.metadata.Unicode.widths || {
                0: 1
            },
            kerning: e.metadata.Unicode.kerning || {}
        } : {
            font: e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, r);
    n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / i;
    a.textIndent = r.textIndent ? 1 * r.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = r.lineIndent;
    var s, c, u = [];
    for(s = 0, c = n.length; s < c; s++)u = u.concat($15d064020a078dff$var$Xt.apply(this, [
        n[s],
        o,
        a
    ]));
    return u;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var r = "klmnopqrstuvwxyz", n = {}, i = {}, a = 0; a < r.length; a++)n[r[a]] = "0123456789abcdef"[a], i["0123456789abcdef"[a]] = r[a];
    var o = function(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, s = e.__fontmetrics__.compress = function(e) {
        var r, n, a, c, u = [
            "{"
        ];
        for(var h in e){
            if (r = e[h], isNaN(parseInt(h, 10)) ? n = "'" + h + "'" : (h = parseInt(h, 10), n = (n = o(h).slice(2)).slice(0, -1) + i[n.slice(-1)]), "number" == typeof r) r < 0 ? (a = o(r).slice(3), c = "-") : (a = o(r).slice(2), c = ""), a = c + a.slice(0, -1) + i[a.slice(-1)];
            else {
                if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r)) throw new Error("Don't know what to do with value type " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(r) + ".");
                a = s(r);
            }
            u.push(n + a);
        }
        return u.push("}"), u.join("");
    }, c = e.__fontmetrics__.uncompress = function(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var e, r, i, a, o = {}, s = 1, c = o, u = [], h = "", l = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? e ? (i = e.join(""), e = void 0) : e = [] : e ? e.push(a) : "{" == a ? (u.push([
            c,
            i
        ]), c = {}, i = void 0) : "}" == a ? ((r = u.pop())[0][r[1]] = c, i = void 0, c = r[0]) : "-" == a ? s = -1 : void 0 === i ? n.hasOwnProperty(a) ? (h += n[a], i = parseInt(h, 16) * s, s = 1, h = "") : h += a : n.hasOwnProperty(a) ? (l += n[a], c[i] = parseInt(l, 16) * s, s = 1, i = void 0, l = "") : l += a;
        return o;
    }, u = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: u,
            "Courier-Bold": u,
            "Courier-BoldOblique": u,
            "Courier-Oblique": u,
            Helvetica: u,
            "Helvetica-Bold": u,
            "Helvetica-BoldOblique": u,
            "Helvetica-Oblique": u,
            "Times-Roman": u,
            "Times-Bold": u,
            "Times-BoldItalic": u,
            "Times-Italic": u
        }
    }, l = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var e = t.font, r = l.Unicode[e.postScriptName];
            r && (e.metadata.Unicode = {}, e.metadata.Unicode.widths = r.widths, e.metadata.Unicode.kerning = r.kerning);
            var n = h.Unicode[e.postScriptName];
            n && (e.metadata.Unicode.encoding = n, e.encoding = n.codePages[0]);
        }
    ]);
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    };
    t.API.events.push([
        "addFont",
        function(r) {
            var n = void 0, i = r.font, a = r.instance;
            if (!i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                if ("string" != typeof (n = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
                !function(r, n) {
                    n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e($15d064020a078dff$var$u(n)), r.metadata = t.API.TTFFont.open(n), r.metadata.Unicode = r.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, r.metadata.glyIdsUsed = [
                        0
                    ];
                }(i, n);
            }
        }
    ]);
}($15d064020a078dff$export$ba1e2ffc633a60f5), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    function e() {
        return ($15d064020a078dff$var$n.canvg ? Promise.resolve($15d064020a078dff$var$n.canvg) : (parcelRequire("l3dTC"))).catch(function(t) {
            return Promise.reject(new Error("Could not load canvg: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    }
    $15d064020a078dff$export$ba1e2ffc633a60f5.API.addSvgAsImage = function(t, r, n, i, o, s, c, u) {
        if (isNaN(r) || isNaN(n)) throw $15d064020a078dff$var$a.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(i) || isNaN(o)) throw $15d064020a078dff$var$a.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = i, h.height = o;
        var l = h.getContext("2d");
        l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height);
        var f = {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0
        }, d = this;
        return e().then(function(e) {
            return e.fromString(l, t, f);
        }, function() {
            return Promise.reject(new Error("Could not load canvg."));
        }).then(function(t) {
            return t.render(f);
        }).then(function() {
            d.addImage(h.toDataURL("image/jpeg", 1), r, n, i, o, c, u);
        });
    };
}(), $15d064020a078dff$export$ba1e2ffc633a60f5.API.putTotalPages = function(t) {
    var e, r = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), r = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), r = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var n = 1; n <= this.internal.getNumberOfPages(); n++)for(var i = 0; i < this.internal.pages[n].length; i++)this.internal.pages[n][i] = this.internal.pages[n][i].replace(e, r);
    return this;
}, $15d064020a078dff$export$ba1e2ffc633a60f5.API.viewerPreferences = function(e, r) {
    var n;
    e = e || {}, r = r || !1;
    var i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, c = Object.keys(s), u = [], h = 0, l = 0, f = 0;
    function d(t, e) {
        var r, n = !1;
        for(r = 0; r < t.length; r += 1)t[r] === e && (n = !0);
        return n;
    }
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === e || !0 === r) {
        var p = c.length;
        for(f = 0; f < p; f += 1)n[c[f]].value = n[c[f]].defaultValue, n[c[f]].explicitSet = !1;
    }
    if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(e)) {
        for(a in e)if (o = e[a], d(c, a) && void 0 !== o) {
            if ("boolean" === n[a].type && "boolean" == typeof o) n[a].value = o;
            else if ("name" === n[a].type && d(n[a].valueSet, o)) n[a].value = o;
            else if ("integer" === n[a].type && Number.isInteger(o)) n[a].value = o;
            else if ("array" === n[a].type) {
                for(h = 0; h < o.length; h += 1)if (i = !0, 1 === o[h].length && "number" == typeof o[h][0]) u.push(String(o[h] - 1));
                else if (o[h].length > 1) {
                    for(l = 0; l < o[h].length; l += 1)"number" != typeof o[h][l] && (i = !1);
                    !0 === i && u.push([
                        o[h][0] - 1,
                        o[h][1] - 1
                    ].join(" "));
                }
                n[a].value = "[" + u.join(" ") + "]";
            } else n[a].value = n[a].defaultValue;
            n[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var t, e = [];
        for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
        0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function() {
        var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), r = unescape(encodeURIComponent(t)), n = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = r.length + n.length + i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + r + n + i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, r = function() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, n) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: n || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", r), this.internal.events.subscribe("postPutResources", e)), this;
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), function(t) {
    var e = t.API, r = e.pdfEscape16 = function(t, e) {
        for(var r, n = e.metadata.Unicode.widths, i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (r = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(r), e.metadata.toUnicode[r] = t.charCodeAt(o), -1 == n.indexOf(r) && (n.push(r), n.push([
                parseInt(e.metadata.widthOfGlyph(r), 10)
            ])), "0" == r) return a.join("");
            r = r.toString(16), a.push(i[4 - r.length], r);
        }
        return a.join("");
    }, n = function(t) {
        var e, r, n, i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n = [], o = 0, s = (r = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = r[o], n.length >= 100 && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar", n = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), n.push("<" + e + "><" + i + ">"));
        return n.length && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar\n"), a += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "Identity-H" === r.encoding) {
                    for(var s = r.metadata.Unicode.widths, c = r.metadata.subset.encode(r.metadata.glyIdsUsed, 1), u = "", h = 0; h < c.length; h++)u += String.fromCharCode(c[h]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), i("endobj");
                    var d = a();
                    i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + $15d064020a078dff$var$F(r.fontName)), i("/FontFile2 " + l + " 0 R"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/Flags " + r.metadata.flags), i("/StemV " + r.metadata.stemV), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i(">>"), i("endobj");
                    var p = a();
                    i("<<"), i("/Type /Font"), i("/BaseFont /" + $15d064020a078dff$var$F(r.fontName)), i("/FontDescriptor " + d + " 0 R"), i("/W " + t.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + r.encoding + ")"), i(">>"), i(">>"), i("endobj"), r.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + $15d064020a078dff$var$F(r.fontName)), i("/Encoding /" + r.encoding), i("/DescendantFonts [" + p + " 0 R]"), i(">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === r.encoding) {
                    for(var s = r.metadata.rawData, c = "", u = 0; u < s.length; u++)c += String.fromCharCode(s[u]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), i("endobj");
                    var l = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: l
                    }), i("endobj");
                    var f = a();
                    i("<<"), i("/Descent " + r.metadata.decender), i("/CapHeight " + r.metadata.capHeight), i("/StemV " + r.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + h + " 0 R"), i("/Flags 96"), i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), i("/FontName /" + $15d064020a078dff$var$F(r.fontName)), i("/ItalicAngle " + r.metadata.italicAngle), i("/Ascent " + r.metadata.ascender), i(">>"), i("endobj"), r.objectNumber = a();
                    for(var d = 0; d < r.metadata.hmtx.widths.length; d++)r.metadata.hmtx.widths[d] = parseInt(r.metadata.hmtx.widths[d] * (1e3 / r.metadata.head.unitsPerEm));
                    i("<</Subtype/TrueType/Type/Font/ToUnicode " + l + " 0 R/BaseFont/" + $15d064020a078dff$var$F(r.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + r.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(r.metadata.hmtx.widths) + ">>"), i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var i = function(t) {
        var e, n = t.text || "", i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, c = s.pdfEscape, u = s.activeFontKey, h = s.fonts, l = u, f = "", d = 0, p = "", g = h[l].encoding;
        if ("Identity-H" !== h[l].encoding) return {
            text: n,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = n, l = u, Array.isArray(n) && (p = n[0]), d = 0; d < p.length; d += 1)h[l].metadata.hasOwnProperty("cmap") && (e = h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && h[l].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = c(f, l).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = r(f, h[l])), s.isHex = !0, {
            text: m,
            x: i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", r = [], n = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? r.push([
                    i(Object.assign({}, n, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : r.push(i(Object.assign({}, n, {
                    text: e[a]
                })).text);
                t.text = r;
            } else t.text = i(Object.assign({}, n, {
                text: e
            })).text;
        }
    ]);
}($15d064020a078dff$export$ba1e2ffc633a60f5), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, r) {
        return e.call(this), this.internal.vFS[t] = r, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($15d064020a078dff$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var r, n, i, a, o, s, c, u = e, h = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], l = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "\u2039",
            "\u203A",
            "\u2039",
            "\u2045",
            "\u2046",
            "\u2045",
            "\u207D",
            "\u207E",
            "\u207D",
            "\u208D",
            "\u208E",
            "\u208D",
            "\u2264",
            "\u2265",
            "\u2264",
            "\u2329",
            "\u232A",
            "\u2329",
            "\uFE59",
            "\uFE5A",
            "\uFE59",
            "\uFE5B",
            "\uFE5C",
            "\uFE5B",
            "\uFE5D",
            "\uFE5E",
            "\uFE5D",
            "\uFE64",
            "\uFE65",
            "\uFE64"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function(t) {
            var e = t.charCodeAt(), r = e >> 8, n = d[r];
            return void 0 !== n ? u[256 * n + (255 & e)] : 252 === r || 253 === r ? "AL" : g.test(r) ? "L" : 8 === r ? "R" : "N";
        }, y = function(t) {
            for(var e, r = 0; r < t.length; r++){
                if ("L" === (e = b(t.charAt(r)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function(t, e, o, s) {
            var c, u, h, l, f = e[s];
            switch(f){
                case "L":
                case "R":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (c = o[s - 1]) && "AN" !== c || "EN" !== (u = e[s + 1]) && "AN" !== u ? f = "N" : m && (u = "AN"), f = u === c ? u : "N";
                    break;
                case "ES":
                    f = "EN" === (c = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(h = s + 1, l = e.length; h < l && "ET" === e[h];)h++;
                    f = h < l && "EN" === e[h] ? "EN" : "N";
                    break;
                case "NSM":
                    if (i && !a) {
                        for(l = e.length, h = s + 1; h < l && "NSM" === e[h];)h++;
                        if (h < l) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (c = e[h], p && ("R" === c || "AL" === c)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (c = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, r = !0, f = v;
                    break;
                case "S":
                    n = !0, f = "N";
                    break;
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "BN":
                    f = "N";
            }
            return f;
        }, N = function(t, e, r) {
            var n = t.split("");
            return r && L(n, r, {
                hiLevel: v
            }), n.reverse(), e && e.reverse(), n.join("");
        }, L = function(t, e, i) {
            var a, o, s, c, u, d = -1, p = t.length, g = 0, y = [], N = v ? l : h, L = [];
            for(m = !1, r = !1, n = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (u = g, y[s] = w(t, L, y, s), a = 240 & (g = N[u][f[y[s]]]), g &= 15, e[s] = c = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = c;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= c;
            }
            n && function(t, e, r) {
                for(var n = 0; n < r; n++)if ("S" === t[n]) {
                    e[n] = v;
                    for(var i = n - 1; i >= 0 && "WS" === t[i]; i--)e[i] = v;
                }
            }(L, e, p);
        }, A = function(t, e, n, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !r) return e.reverse(), void (n && n.reverse());
                for(var o, s, c, u, h = e.length, l = 0; l < h;){
                    if (i[l] >= t) {
                        for(c = l + 1; c < h && i[c] >= t;)c++;
                        for(u = l, s = c - 1; u < s; u++, s--)o = e[u], e[u] = e[s], e[s] = o, n && (o = n[u], n[u] = n[s], n[s] = o);
                        l = c;
                    }
                    l++;
                }
            }
        }, x = function(t, e, r) {
            var n = t.split(""), i = {
                hiLevel: v
            };
            return r || (r = []), L(n, r, i), function(t, e, r) {
                if (0 !== r.hiLevel && c) for(var n, i = 0; i < t.length; i++)1 === e[i] && (n = p.indexOf(t[i])) >= 0 && (t[i] = p[n + 1]);
            }(n, r, i), A(2, n, e, r, i), A(1, n, e, r, i), n.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, r) {
            if (function(t, e) {
                if (e) for(var r = 0; r < t.length; r++)e[r] = r;
                void 0 === a && (a = y(t)), void 0 === s && (s = y(t));
            }(t, e), i || !o || s) {
                if (i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, r);
                else if (!i && o && s) v = a ? 1 : 0, t = x(t, e, r), t = N(t, e);
                else if (!i || a || o || s) {
                    if (i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = x(t, e, r)) : (v = 1, t = x(t, e, r), t = N(t, e));
                    else if (i && a && !o && s) v = 1, t = x(t, e, r), t = N(t, e);
                    else if (!i && !o && a ^ s) {
                        var n = c;
                        a ? (v = 1, t = x(t, e, r), v = 0, c = !1, t = x(t, e, r), c = n) : (v = 0, t = x(t, e, r), t = N(t, e), v = 1, c = !1, t = x(t, e, r), c = n, t = N(t, e));
                    }
                } else v = 0, t = x(t, e, r);
            } else v = a ? 1 : 0, t = x(t, e, r);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, c = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], r = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text, n = (t.x, t.y, t.options || {}), i = (t.mutex, n.lang, []);
            if (n.isInputVisual = "boolean" != typeof n.isInputVisual || n.isInputVisual, r.setOptions(n), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? i.push([
                    r.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : i.push([
                    r.doBidiReorder(e[a])
                ]);
                t.text = i;
            } else t.text = r.doBidiReorder(e);
            r.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($15d064020a078dff$export$ba1e2ffc633a60f5), $15d064020a078dff$export$ba1e2ffc633a60f5.API.TTFFont = function() {
    function t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $15d064020a078dff$var$ne(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $15d064020a078dff$var$Le(this), this.registerTTF();
    }
    return t.open = function(e) {
        return new t(e);
    }, t.prototype.parse = function() {
        return this.directory = new $15d064020a078dff$var$ie(this.contents), this.head = new $15d064020a078dff$var$se(this), this.name = new $15d064020a078dff$var$pe(this), this.cmap = new $15d064020a078dff$var$ue(this), this.toUnicode = {}, this.hhea = new $15d064020a078dff$var$he(this), this.maxp = new $15d064020a078dff$var$ge(this), this.hmtx = new $15d064020a078dff$var$me(this), this.post = new $15d064020a078dff$var$fe(this), this.os2 = new $15d064020a078dff$var$le(this), this.loca = new $15d064020a078dff$var$Ne(this), this.glyf = new $15d064020a078dff$var$be(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, t.prototype.registerTTF = function() {
        var t, e, r, n, i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, r, n, i;
            for(i = [], e = 0, r = (n = this.bbox).length; e < r; e++)t = n[e], i.push(Math.round(t * this.scaleFactor));
            return i;
        }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 0 != (32768 & (e = n >> 16)) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (i = this.familyClass) || 2 === i || 3 === i || 4 === i || 5 === i || 7 === i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, t.prototype.widthOfString = function(t, e, r) {
        var n, i, a, o;
        for(a = 0, i = 0, o = (t = "" + t).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i)n = t.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, t.prototype.lineHeight = function(t, e) {
        var r;
        return null == e && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
    }, t;
}();
var $15d064020a078dff$var$re, $15d064020a078dff$var$ne = function() {
    function t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    }
    return t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt32 = function() {
        var t;
        return (t = this.readUInt32()) >= 2147483648 ? t - 4294967296 : t;
    }, t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, t.prototype.readInt16 = function() {
        var t;
        return (t = this.readUInt16()) >= 32768 ? t - 65536 : t;
    }, t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, t.prototype.readString = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)r[e] = String.fromCharCode(this.readByte());
        return r.join("");
    }, t.prototype.writeString = function(t) {
        var e, r, n;
        for(n = [], e = 0, r = t.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e)n.push(this.writeByte(t.charCodeAt(e)));
        return n;
    }, t.prototype.readShort = function() {
        return this.readInt16();
    }, t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, t.prototype.readLongLong = function() {
        var t, e, r, n, i, a, o, s;
        return t = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * a + 256 * o + s;
    }, t.prototype.writeLongLong = function(t) {
        var e, r;
        return e = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
    }, t.prototype.readInt = function() {
        return this.readInt32();
    }, t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, t.prototype.read = function(t) {
        var e, r;
        for(e = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r)e.push(this.readByte());
        return e;
    }, t.prototype.write = function(t) {
        var e, r, n, i;
        for(i = [], r = 0, n = t.length; r < n; r++)e = t[r], i.push(this.writeByte(e));
        return i;
    }, t;
}(), $15d064020a078dff$var$ie = function() {
    var t;
    function e(t) {
        var e, r, n;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, r = 0, n = this.tableCount; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    }
    return e.prototype.encode = function(e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), h = 16 * Math.floor(Math.log(f) / s), a = Math.floor(h / s), u = 16 * f - h, (n = new $15d064020a078dff$var$ne).writeInt(this.scalarType), n.writeShort(f), n.writeShort(h), n.writeShort(a), n.writeShort(u), i = 16 * f, c = n.pos + i, o = null, d = [], e)for(l = e[p], n.writeString(p), n.writeInt(t(l)), n.writeInt(c), n.writeInt(l.length), d = d.concat(l), "head" === p && (o = c), c += l.length; c % 4;)d.push(0), c++;
        return n.write(d), r = 2981146554 - t(n.data), n.pos = o + 8, n.writeUInt32(r), n.data;
    }, t = function(t) {
        var e, r, n, i;
        for(t = $15d064020a078dff$var$ve.call(t); t.length % 4;)t.push(0);
        for(n = new $15d064020a078dff$var$ne(t), r = 0, e = 0, i = t.length; e < i; e = e += 4)r += n.readUInt32();
        return 4294967295 & r;
    }, e;
}(), $15d064020a078dff$var$ae = {}.hasOwnProperty, $15d064020a078dff$var$oe = function(t, e) {
    for(var r in e)$15d064020a078dff$var$ae.call(e, r) && (t[r] = e[r]);
    function n() {
        this.constructor = t;
    }
    return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t;
};
$15d064020a078dff$var$re = function() {
    function t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    }
    return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, t;
}();
var $15d064020a078dff$var$se = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "head", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, e.prototype.encode = function(t) {
        var e;
        return (e = new $15d064020a078dff$var$ne).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
    }, e;
}(), $15d064020a078dff$var$ce = function() {
    function t(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), h = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), l = f / 2, t.pos += 6, i = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), t.pos += 2, p = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), c = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), u = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= l ? e < l : e > l; s = 0 <= l ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), n = (this.length - t.pos + this.offset) / 2, o = function() {
                    var e, r;
                    for(r = [], s = e = 0; 0 <= n ? e < n : e > n; s = 0 <= n ? ++e : --e)r.push(t.readUInt16());
                    return r;
                }(), s = m = 0, b = i.length; m < b; s = ++m)for(g = i[s], r = v = d = p[s]; d <= g ? v <= g : v >= g; r = d <= g ? ++v : --v)0 === u[s] ? a = r + c[s] : 0 !== (a = o[u[s] / 2 + (r - d) - (l - s)] || 0) && (a += c[s]), this.codeMap[r] = 65535 & a;
        }
        t.pos = h;
    }
    return t.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y, w, N, L, A, x, S, _, P, k, I, F, C, j, O, B, M, E, q, D, R, T, U, z, H, W, V, G, Y;
        switch(I = new $15d064020a078dff$var$ne, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var t = [];
                    for(d = 0; d < 256; ++d)t.push(0);
                    return t;
                }(), v = {
                    0: 0
                }, i = {}, F = 0, B = a.length; F < B; F++)null == v[W = t[n = a[F]]] && (v[W] = ++p), i[n] = {
                    old: t[n],
                    new: v[t[n]]
                }, g[n] = v[t[n]];
                return I.writeUInt16(1), I.writeUInt16(0), I.writeUInt32(12), I.writeUInt16(0), I.writeUInt16(262), I.writeUInt16(0), I.write(g), {
                    charMap: i,
                    subtable: I.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], h = [], b = 0, v = {}, r = {}, m = c = null, C = 0, M = a.length; C < M; C++)null == v[w = t[n = a[C]]] && (v[w] = ++b), r[n] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - n, null != m && o === c || (m && h.push(m), P.push(n), c = o), m = n;
                for(m && h.push(m), h.push(65535), P.push(65535), S = 2 * (x = P.length), A = 2 * Math.pow(Math.log(x) / Math.LN2, 2), l = Math.log(A / 2) / Math.LN2, L = 2 * x - A, s = [], N = [], f = [], d = j = 0, E = P.length; j < E; d = ++j){
                    if (_ = P[d], u = h[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = r[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + x - d)), n = O = _; _ <= u ? O <= u : O >= u; n = _ <= u ? ++O : --O)f.push(r[n].new);
                    else s.push(k - _), N.push(0);
                }
                for(I.writeUInt16(3), I.writeUInt16(1), I.writeUInt32(12), I.writeUInt16(4), I.writeUInt16(16 + 8 * x + 2 * f.length), I.writeUInt16(0), I.writeUInt16(S), I.writeUInt16(A), I.writeUInt16(l), I.writeUInt16(L), z = 0, q = h.length; z < q; z++)n = h[z], I.writeUInt16(n);
                for(I.writeUInt16(0), H = 0, D = P.length; H < D; H++)n = P[H], I.writeUInt16(n);
                for(V = 0, R = s.length; V < R; V++)o = s[V], I.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)y = N[G], I.writeUInt16(y);
                for(Y = 0, U = f.length; Y < U; Y++)p = f[Y], I.writeUInt16(p);
                return {
                    charMap: r,
                    subtable: I.data,
                    maxGlyphID: b + 1
                };
        }
    }, t;
}(), $15d064020a078dff$var$ue = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
        var e, r, n;
        for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = new $15d064020a078dff$var$ce(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
        return !0;
    }, e.encode = function(t, e) {
        var r, n;
        return null == e && (e = "macroman"), r = $15d064020a078dff$var$ce.encode(t, e), (n = new $15d064020a078dff$var$ne).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
    }, e;
}(), $15d064020a078dff$var$he = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, e;
}(), $15d064020a078dff$var$le = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "OS/2", e.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var e, r;
            for(r = [], e = 0; e < 10; ++e)r.push(t.readByte());
            return r;
        }(), this.charRange = function() {
            var e, r;
            for(r = [], e = 0; e < 4; ++e)r.push(t.readInt());
            return r;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var e, r;
            for(r = [], e = 0; e < 2; e = ++e)r.push(t.readInt());
            return r;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, e;
}(), $15d064020a078dff$var$fe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "post", e.prototype.parse = function(t) {
        var e, r, n;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
                break;
            case 131072:
                var i;
                for(r = t.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= r ? i < r : i > r; i = 0 <= r ? ++i : --i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], n = []; t.pos < this.offset + this.length;)e = t.readByte(), n.push(this.names.push(t.readString(e)));
                return n;
            case 151552:
                return r = t.readUInt16(), this.offsets = t.read(r);
            case 196608:
                break;
            case 262144:
                return this.map = (function() {
                    var e, r, n;
                    for(n = [], i = e = 0, r = this.file.maxp.numGlyphs; 0 <= r ? e < r : e > r; i = 0 <= r ? ++e : --e)n.push(t.readUInt32());
                    return n;
                }).call(this);
        }
    }, e;
}(), $15d064020a078dff$var$de = function(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $15d064020a078dff$var$pe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "name", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s, c, u, h, l;
        for(t.pos = this.offset, t.readShort(), e = t.readShort(), o = t.readShort(), r = [], i = 0; 0 <= e ? i < e : i > e; i = 0 <= e ? ++i : --i)r.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, i = u = 0, h = r.length; u < h; i = ++u)n = r[i], t.pos = n.offset, c = t.readString(n.length), a = new $15d064020a078dff$var$de(c, n), null == s[l = n.nameID] && (s[l] = []), s[n.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (t) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, e;
}(), $15d064020a078dff$var$ge = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, e;
}(), $15d064020a078dff$var$me = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "hmtx", e.prototype.parse = function(t) {
        var e, r, n, i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? e < o : e > o; e = 0 <= o ? ++e : --e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var r, i;
            for(i = [], e = r = 0; 0 <= n ? r < n : r > n; e = 0 <= n ? ++r : --r)i.push(t.readInt16());
            return i;
        }(), this.widths = (function() {
            var t, e, r, n;
            for(n = [], t = 0, e = (r = this.metrics).length; t < e; t++)i = r[t], n.push(i.advance);
            return n;
        }).call(this), r = this.widths[this.widths.length - 1], s = [], e = a = 0; 0 <= n ? a < n : a > n; e = 0 <= n ? ++a : --a)s.push(this.widths.push(r));
        return s;
    }, e.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, e;
}(), $15d064020a078dff$var$ve = [].slice, $15d064020a078dff$var$be = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "glyf", e.prototype.parse = function() {
        return this.cache = {};
    }, e.prototype.glyphFor = function(t) {
        var e, r, n, i, a, o, s, c, u, h;
        return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, r = i.indexOf(t), 0 === (n = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + r, a = (o = new $15d064020a078dff$var$ne(e.read(n))).readShort(), c = o.readShort(), h = o.readShort(), s = o.readShort(), u = o.readShort(), this.cache[t] = -1 === a ? new $15d064020a078dff$var$we(o, c, h, s, u) : new $15d064020a078dff$var$ye(o, a, c, h, s, u), this.cache[t]));
    }, e.prototype.encode = function(t, e, r) {
        var n, i, a, o, s;
        for(a = [], i = [], o = 0, s = e.length; o < s; o++)n = t[e[o]], i.push(a.length), n && (a = a.concat(n.encode(r)));
        return i.push(a.length), {
            table: a,
            offsets: i
        };
    }, e;
}(), $15d064020a078dff$var$ye = function() {
    function t(t, e, r, n, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = a, this.compound = !1;
    }
    return t.prototype.encode = function() {
        return this.raw.data;
    }, t;
}(), $15d064020a078dff$var$we = function() {
    function t(t, e, r, n, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    }
    return t.prototype.encode = function() {
        var t, e, r;
        for(e = new $15d064020a078dff$var$ne($15d064020a078dff$var$ve.call(this.raw.data)), t = 0, r = this.glyphIDs.length; t < r; ++t)e.pos = this.glyphOffsets[t];
        return e.data;
    }, t;
}(), $15d064020a078dff$var$Ne = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $15d064020a078dff$var$oe(e, $15d064020a078dff$var$re), e.prototype.tag = "loca", e.prototype.parse = function(t) {
        var e, r;
        return t.pos = this.offset, e = this.file.head.indexToLocFormat, this.offsets = 0 === e ? (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 2)n.push(2 * t.readUInt16());
            return n;
        }).call(this) : (function() {
            var e, n;
            for(n = [], r = 0, e = this.length; r < e; r += 4)n.push(t.readUInt32());
            return n;
        }).call(this);
    }, e.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, e.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, e.prototype.encode = function(t, e) {
        for(var r = new Uint32Array(this.offsets.length), n = 0, i = 0, a = 0; a < r.length; ++a)if (r[a] = n, i < e.length && e[i] == a) {
            ++i, r[a] = n;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (n += s);
        }
        for(var c = new Array(4 * r.length), u = 0; u < r.length; ++u)c[4 * u + 3] = 255 & r[u], c[4 * u + 2] = (65280 & r[u]) >> 8, c[4 * u + 1] = (16711680 & r[u]) >> 16, c[4 * u] = (4278190080 & r[u]) >> 24;
        return c;
    }, e;
}(), $15d064020a078dff$var$Le = function() {
    function t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    }
    return t.prototype.generateCmap = function() {
        var t, e, r, n, i;
        for(e in n = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)r = i[e], t[e] = n[r];
        return t;
    }, t.prototype.glyphsFor = function(t) {
        var e, r, n, i, a, o, s;
        for(n = {}, a = 0, o = t.length; a < o; a++)n[i = t[a]] = this.font.glyf.glyphFor(i);
        for(i in e = [], n)(null != (r = n[i]) ? r.compound : void 0) && e.push.apply(e, r.glyphIDs);
        if (e.length > 0) for(i in s = this.glyphsFor(e))r = s[i], n[i] = r;
        return n;
    }, t.prototype.encode = function(t, e) {
        var r, n, i, a, o, s, c, u, h, l, f, d, p, g, m;
        for(n in r = $15d064020a078dff$var$ue.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = r.charMap)f[(s = m[n]).old] = s.new;
        for(d in l = r.maxGlyphID, a)d in f || (f[d] = l++);
        return u = function(t) {
            var e, r;
            for(e in r = {}, t)r[t[e]] = e;
            return r;
        }(f), h = Object.keys(u).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var t, e, r;
            for(r = [], t = 0, e = h.length; t < e; t++)o = h[t], r.push(u[o]);
            return r;
        }(), i = this.font.glyf.encode(a, p, f), c = this.font.loca.encode(i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: i.table,
            loca: c,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, t;
}();
$15d064020a078dff$export$ba1e2ffc633a60f5.API.PDFObject = function() {
    var t;
    function e() {}
    return t = function(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(r) {
        var n, i, a, o;
        if (Array.isArray(r)) return "[" + (function() {
            var t, i, a;
            for(a = [], t = 0, i = r.length; t < i; t++)n = r[t], a.push(e.convert(n));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof r) return "/" + r;
        if (null != r ? r.isString : void 0) return "(" + r + ")";
        if (r instanceof Date) return "(D:" + t(r.getUTCFullYear(), 4) + t(r.getUTCMonth(), 2) + t(r.getUTCDate(), 2) + t(r.getUTCHours(), 2) + t(r.getUTCMinutes(), 2) + t(r.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(r)) {
            for(i in a = [
                "<<"
            ], r)o = r[i], a.push("/" + i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + r;
    }, e;
}();
var $15d064020a078dff$export$2e2bcd8739ae039 = $15d064020a078dff$export$ba1e2ffc633a60f5;




var $acw62 = parcelRequire("acw62");
var $f46ed4009cb9c1cd$exports = {};

$parcel$export($f46ed4009cb9c1cd$exports, "version", () => $f46ed4009cb9c1cd$export$83d89fbfd8236492, (v) => $f46ed4009cb9c1cd$export$83d89fbfd8236492 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToString", () => $f46ed4009cb9c1cd$export$80e7718417253a51, (v) => $f46ed4009cb9c1cd$export$80e7718417253a51 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToStaticMarkup", () => $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51, (v) => $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToNodeStream", () => $f46ed4009cb9c1cd$export$307591e98609eddd, (v) => $f46ed4009cb9c1cd$export$307591e98609eddd = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToStaticNodeStream", () => $f46ed4009cb9c1cd$export$b23711c915539651, (v) => $f46ed4009cb9c1cd$export$b23711c915539651 = v);
$parcel$export($f46ed4009cb9c1cd$exports, "renderToReadableStream", () => $f46ed4009cb9c1cd$export$7020a3240b287705, (v) => $f46ed4009cb9c1cd$export$7020a3240b287705 = v);
var $f46ed4009cb9c1cd$export$83d89fbfd8236492;
var $f46ed4009cb9c1cd$export$80e7718417253a51;
var $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51;
var $f46ed4009cb9c1cd$export$307591e98609eddd;
var $f46ed4009cb9c1cd$export$b23711c915539651;
var $f46ed4009cb9c1cd$export$7020a3240b287705;
'use strict';
var $f46ed4009cb9c1cd$var$l, $f46ed4009cb9c1cd$var$s;

$f46ed4009cb9c1cd$var$l = (parcelRequire("sBxfj"));

$f46ed4009cb9c1cd$var$s = (parcelRequire("3odmW"));
$f46ed4009cb9c1cd$export$83d89fbfd8236492 = $f46ed4009cb9c1cd$var$l.version;
$f46ed4009cb9c1cd$export$80e7718417253a51 = $f46ed4009cb9c1cd$var$l.renderToString;
$f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = $f46ed4009cb9c1cd$var$l.renderToStaticMarkup;
$f46ed4009cb9c1cd$export$307591e98609eddd = $f46ed4009cb9c1cd$var$l.renderToNodeStream;
$f46ed4009cb9c1cd$export$b23711c915539651 = $f46ed4009cb9c1cd$var$l.renderToStaticNodeStream;
$f46ed4009cb9c1cd$export$7020a3240b287705 = $f46ed4009cb9c1cd$var$s.renderToReadableStream;








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $860e16288c9eb719$var$useAdCardData = (sectionNo = "D002")=>{
    const [data, setData] = (0, $acw62.useState)({});
    const [adId, setAdId] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [fetchedSectionNo, setFetchedSectionNo] = (0, $acw62.useState)(null);
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-sections/${sectionNo}/ads`, {}, setData);
            // Reason: empty ads list must clear previous section card so UserAdCard does not keep showing stale/default data.
            if (response.body && response.body.length) {
                setData({
                    ...response.body[0].advisor,
                    isDefault: response.body[0]?.isDefault ?? false,
                    company: {
                        logo: response.body[0]['company']?.['logo'] ?? null
                    },
                    _id: response.body[0]['advisorId']
                });
                setAdId(response.body[0]._id);
            } else {
                setData({});
                setAdId(null);
            }
            setFetchedSectionNo(sectionNo);
        } catch (error) {
            setData({});
            console.error('Error fetching data:', error);
        } finally{
            setLoading(false);
        }
    }, [
        sectionNo
    ]);
    (0, $acw62.useEffect)(()=>{
        if (sectionNo) fetchData();
    }, [
        sectionNo
    ]);
    return {
        data: data,
        adId: adId,
        loading: loading,
        fetchedSectionNo: fetchedSectionNo
    };
};
var $860e16288c9eb719$export$2e2bcd8739ae039 = $860e16288c9eb719$var$useAdCardData;



const $8615c75609e057bd$var$UserAdCard = ({ onCardLog: onCardLog, LiButton: LiButton, user: user, company: company, truncateText: truncateText, getSectionName: getSectionName, visibleSection: visibleSection, getCompanyById: getCompanyById })=>{
    const { data: data, adId: adId, loading: loading, fetchedSectionNo: fetchedSectionNo } = (0, $860e16288c9eb719$export$2e2bcd8739ae039)(visibleSection);
    const lastCalledSectionRef = (0, $acw62.useRef)(null);
    const handleHistoryGenerate = (0, $acw62.useCallback)(()=>{
        const advisorId = data?._id;
        if (!advisorId || !visibleSection) return;
        if (fetchedSectionNo !== visibleSection) return;
        if (lastCalledSectionRef.current === visibleSection) return;
        const isUserRole = /^user$/i.test(user?.role);
        if (!isUserRole) return;
        lastCalledSectionRef.current = visibleSection;
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/history/generate', {
            sectionNo: visibleSection.includes('.') ? visibleSection.split('.')[0] : visibleSection,
            advisorId: advisorId,
            isDirectcompany: true
        }).catch(()=>{});
    }, [
        data?._id,
        visibleSection,
        fetchedSectionNo,
        user?.role
    ]);
    (0, $acw62.useEffect)(()=>{
        handleHistoryGenerate();
    }, [
        handleHistoryGenerate,
        visibleSection
    ]);
    if (data && Object.keys(data).length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "user-info-sidebar rj mt12 cp df jcc py0-5rem px0-5rem aic fdc mt0-5rem bg38 bo45 bss bw1px br8px",
            style: {
                width: "100%",
                paddingLeft: '0.5rem'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df w100 jcsb mt0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc w70",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "br100",
                                                style: {
                                                    width: '40px',
                                                    height: '40px',
                                                    border: '1px solid #15D757'
                                                },
                                                src: data?.profile ? data?.profile : (parcelRequire("kBFDN")),
                                                alt: "alloctaed-Advisor-Image"
                                            }),
                                            data && data.linkedIn && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "pt0-5rem pb0-5rem df fdc ml0-5rem jcc",
                                                style: {
                                                    marginBottom: "7px"
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(LiButton, {
                                                    link: data.linkedIn,
                                                    withoutLog: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        onClick: ()=>onCardLog(company, user, data, 'title', {
                                                visibleSection: visibleSection,
                                                adId: adId,
                                                isDefault: data?.isDefault
                                            }),
                                        className: "w90 df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mt0-5rem fw500 c15",
                                                style: {
                                                    fontSize: '11px',
                                                    textTransform: 'capitalize'
                                                },
                                                children: `${data?.firstName ?? ""} ${data?.lastName ?? ""}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fw500 c51 op80",
                                                style: {
                                                    fontSize: '9px',
                                                    textTransform: 'capitalize'
                                                },
                                                children: "Chief Executive Officer"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            data?.company['logo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "bg1 br100 ofcov",
                                style: {
                                    width: '44px',
                                    height: '40px'
                                },
                                src: data?.company['logo'],
                                alt: "company_logo",
                                onClick: ()=>getCompanyById(typeof data?.companyId === "string" ? data?.companyId : data?.companyId?._id)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fw500 px0-5rem mt0-5rem mb0-5rem",
                        style: {
                            paddingLeft: '0px',
                            fontSize: '11px',
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "fw500",
                            style: {
                                fontSize: '11px',
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c14",
                                    style: {
                                        fontSize: '10px'
                                    },
                                    children: truncateText(`Need to chat about your ${getSectionName(company, visibleSection)} requirements?  No obligation call...`, 100)
                                }),
                                data?.phone ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mt0-5rem c14",
                                    onClick: ()=>onCardLog(company, user, data, 'phoneNumber', {
                                            visibleSection: visibleSection,
                                            adId: adId
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw300 c14",
                                            children: "Tel:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "c14",
                                            href: `tel:${data?.phone}`,
                                            children: data?.phone
                                        })
                                    ]
                                }) : null,
                                data?.email ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "c14",
                                    onClick: ()=>onCardLog(company, user, data, "email", {
                                            visibleSection: visibleSection,
                                            adId: adId
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw300 c14",
                                            children: "Email:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "c14",
                                            href: `mailto:${data?.email ?? ""}`,
                                            children: truncateText(data?.email, 30) ?? ""
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    })
                ]
            })
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
};
var $8615c75609e057bd$export$2e2bcd8739ae039 = $8615c75609e057bd$var$UserAdCard;




var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $41b252a7376cfacd$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $59010cfc8b663697$var$IndirectCompanyUserAdCard = ({ onCardLog: onCardLog, LiButton: LiButton, user: user, company: company, truncateText: truncateText, activePoint: activePoint, allocatedAdvisor: allocatedAdvisor, visibleSection: visibleSection, getCompanyById: getCompanyById })=>{
    const handleHistoryGenerate = (0, $acw62.useCallback)(async ()=>{
        const isUserRole = /^user$/i.test(user['role']);
        if (visibleSection && isUserRole && company?.advisorData?.find((obj)=>!obj?.createdBy) && (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(allocatedAdvisor)) try {
            await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/history/generate', {
                sectionNo: visibleSection.includes('.') ? visibleSection.split('.')[0] : visibleSection,
                advisorId: company?.advisorData?.find((obj)=>!obj?.createdBy)?._id,
                isDirectcompany: false
            });
        } catch (err) {
            console.log(err);
        }
    }, [
        visibleSection,
        user,
        company
    ]); // Dependencies for useCallback
    (0, $acw62.useEffect)(()=>{
        handleHistoryGenerate();
    }, [
        handleHistoryGenerate,
        visibleSection
    ]); // Trigger on component load and when visibleSection changes
    if ((0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(allocatedAdvisor)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "user-info-sidebar 12 check mt12 br8px cp df py0-5rem px0-5rem aic mt0-5rem fdc bg38 bo45 bss bw1px",
            style: {
                width: "100%",
                paddingLeft: '0.5rem'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "px0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df w100 jcsb mt0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "br100",
                                            style: {
                                                width: '40px',
                                                height: '40px'
                                            },
                                            src: allocatedAdvisor?.profile ? allocatedAdvisor?.profile : (parcelRequire("kBFDN")),
                                            alt: "allocated-Advisor-Image"
                                        }),
                                        allocatedAdvisor && allocatedAdvisor.linkedIn && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pt0-5rem pb0-5rem df fdc ml0-5rem jcc",
                                            style: {
                                                marginBottom: "7px"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(LiButton, {
                                                link: allocatedAdvisor?.linkedIn,
                                                company: company,
                                                user: user,
                                                allocatedAdvisor: allocatedAdvisor
                                            })
                                        })
                                    ]
                                })
                            }),
                            allocatedAdvisor?.companyId?.['logo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "bg1 ofcov br100",
                                style: {
                                    height: "35px",
                                    width: '40px',
                                    borderRadius: '50%',
                                    padding: '2px',
                                    backgroundColor: "#c9e4ff"
                                },
                                src: allocatedAdvisor?.companyId?.['logo'],
                                alt: "image",
                                onClick: ()=>getCompanyById(typeof allocatedAdvisor?.companyId === "string" ? allocatedAdvisor?.companyId : allocatedAdvisor?.companyId?._id)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt0-5rem fw500 w100 businessCardText c15",
                        style: {
                            textTransform: 'capitalize'
                        },
                        onClick: ()=>onCardLog(company, user, allocatedAdvisor, 'name', {
                                visibleSection: visibleSection
                            }),
                        children: `${allocatedAdvisor?.firstName} ${allocatedAdvisor?.lastName ?? ""}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fw500 w100 businessCardText c14 op80",
                        style: {
                            textTransform: 'capitalize'
                        },
                        onClick: ()=>onCardLog(company, user, allocatedAdvisor, 'title', {
                                visibleSection: visibleSection
                            }),
                        children: allocatedAdvisor?.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "fw500 px0-5rem mt0-5rem mb0-5rem",
                        style: {
                            paddingLeft: '0px',
                            fontSize: '11px',
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "fw500",
                            style: {
                                fontSize: '11px',
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "businessCardText c14",
                                    children: truncateText(`Need to chat about your ${allocatedAdvisor?.sectionName} requirements?  No obligation call...`, 100)
                                }),
                                allocatedAdvisor?.phone ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mt0-5rem",
                                    onClick: ()=>onCardLog(company, user, allocatedAdvisor, 'phone number', {
                                            visibleSection: visibleSection
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw300 businessCardText c14",
                                            children: "Tel:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "businessCardText c14",
                                            href: `tel:${allocatedAdvisor?.phone}`,
                                            children: allocatedAdvisor?.phone
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    onClick: ()=>onCardLog(company, user, allocatedAdvisor, "email", {
                                            visibleSection: visibleSection
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw300 businessCardText c14",
                                            children: "Email:"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "businessCardText c14",
                                            href: `mailto:${allocatedAdvisor?.email}`,
                                            children: truncateText(allocatedAdvisor?.email, 30)
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
};
var $59010cfc8b663697$export$2e2bcd8739ae039 = $59010cfc8b663697$var$IndirectCompanyUserAdCard;



var $ayMG0 = parcelRequire("ayMG0");




const $af33af4f3eed7fb8$var$ReferOffer = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "user-info-sidebar 12 check mt12 br8px cp df py1rem px0-5rem aic mt0-5rem fdc bg1 shadow bo45 bss bw1px",
        style: {
            width: "100%",
            paddingLeft: '0.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                width: 230,
                src: (parcelRequire("4dikp")),
                alt: "refer"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "tac c4 fs14px",
                children: " We will refund 100% of this client\u2019s subscription "
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "tac c14 fs13px my0-5rem",
                children: "For each CFO colleague you introduce to us*\xa0\u200B"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                style: {
                    width: '120px',
                    height: '34px',
                    padding: '4px',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase'
                },
                btnType: "warning",
                text: "Learn More",
                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'referCfoOffer'
                    }))
            })
        ]
    });
};
var $af33af4f3eed7fb8$export$2e2bcd8739ae039 = $af33af4f3eed7fb8$var$ReferOffer;



var $ayMG0 = parcelRequire("ayMG0");








const $810fd00e44870152$var$ReferCfoOfferModal = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: 'referCfoOffer',
        modalCardClasses: 'maw90',
        customStyle: {
            padding: '0rem',
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pt2rem pb2rem pr2rem w70 pl4rem",
                    style: {
                        backgroundColor: '#F5F7FF'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aifs p2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("dsCVd")),
                                    alt: "referCfoOffer",
                                    style: {
                                        maxWidth: '150px',
                                        width: '100%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    style: {
                                        color: '#F71873'
                                    },
                                    className: "c4 fs1rem mb0-5rem tal w100 tal",
                                    children: "Refer A Colleague CFO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c4 fw400 mt2rem fs15px",
                                    children: "For each new CFO Centre fractional CFO you introduce to us*"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs2rem c15 fw500 mt0-5rem",
                                    children: "We will refund you 100% the first year Portfolio Pro subscription on your own first client"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs1rem c15 fw400 my0-5rem",
                                    children: "- your CFO colleague will receive the same offer"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c49 fs1rem mt4rem mb2rem fw400",
                                    children: "To get things rolling, please contact us or email this offer to your CFO colleague."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcfs",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            style: {
                                                maxHeight: "40px"
                                            },
                                            onClick: ()=>window.open('https://koalendar.com/e/meet-with-mark-bernstein', '_blank'),
                                            className: "df jcsb px1rem new-shadow cp c1 bg4 fw400 fs1rem br38px w200px py0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "mr0-5rem",
                                                            src: (parcelRequire("eR6rP")),
                                                            alt: "telephone"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "pl0-5rem fw400 c1 fs14px",
                                                            children: "Book a Call"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("9UKFK")),
                                                    alt: "rightArrow"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "df jcc new-shadow cp c1 bg3 fw400 fs14px br38px w200px py0-5rem ml1rem",
                                            href: `mailto:?cc=mark.bernstein@diligentisia.co.uk&subject=Recommendation%20to%20use%20Diligentsia%20Platform&body=Dear%0D%0A%0D%0AFollowing%20the%20CFO%20Centre%E2%80%99s%207th%20October%20webinar%20introducing%20Diligentsia,%20I%E2%80%99ve%20started%20exploring%20their%20platform%20to%20streamline%20my%20CFO%20services%20and%20add%20value%20to%20clients.%20My%20advisor%20account%20is%20free,%20while%20clients%20can%20subscribe%20to%20Diligentsia%20Pro%20at%20%C2%A366/month%20(billed%20annually,%20%C2%A3799).%20They%20already%20have%20a%20number%20of%20CFOC%20CFOs/clients%20on%20the%20platform.%0D%0A%0D%0ATo%20encourage%20adoption,%20Diligentsia%20has%20launched%20a%20referral%20scheme:%0D%0A1.%20If%20you%20register%20your%20own%20account%20and%20then%20subscribe%20YOUR%20first%20client%20to%20Pro,%20MY%20first%20client%E2%80%99s%20subscription%20will%20be%20refunded%20(giving%20them%20their%20first%20year%20free).%0D%0A2.%20Likewise,%20if%20you%20subsequently%20refer%20Diligentsia%E2%80%99s%20platform%20to%20another%20new%20colleague,%20your%20first%20client%20will%20also%20be%20similarly%20reimbursed.%0D%0A3.%20Their%20website%20is%20www.diligentsia.co.uk/fractionalCFO%0D%0A%0D%0AIf%20you%E2%80%99d%20like%20to%20explore%20how%20Diligentsia%20can%20help%20you%20and%20your%20clients,%20book%20a%20call%20with%20CEO%20Mark%20Bernstein%20ACA:%0D%0A%0D%0AMeet%20with%20Mark%20Bernstein%20%7C%20Koalendar%20-%20https://koalendar.com/e/meet-with-mark-bernstein%0D%0A%0D%0ALet%20me%20know%20how%20you%20get%20on!%0D%0A%0D%0ABest,`,
                                            children: "Invite by Email"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c49 fs11px mt2rem",
                                    children: "*= who signs up one of their own existing CFO Centre clients by end of October 2025"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w30 pt1rem",
                    style: {
                        backgroundImage: "linear-gradient(to right, #B9D9F9, #7FBDFA)"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "br8px p2rem df aic jcc fdc w80 mxa",
                            style: {
                                backgroundImage: "linear-gradient(to right, #FFFFFF33, #ffffff39)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb0-5rem df fdc aic jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "mb0-5rem",
                                            style: {
                                                width: '32px',
                                                height: '32px'
                                            },
                                            src: (parcelRequire("hagGi")),
                                            alt: "cfoCenterRefer"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs14px",
                                            children: "Refer"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c49 fs11px tac",
                                            children: [
                                                " Refer a new CFO Centre fractional ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " CFO colleague to us* "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb0-5rem df fdc aic jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "mb0-5rem",
                                            style: {
                                                width: '32px',
                                                height: '32px'
                                            },
                                            src: (parcelRequire("bkYBb")),
                                            alt: "cfoCenterFraction"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs14px",
                                            children: "Fractional CFO Joins"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c49 fs11px tac",
                                            children: [
                                                "The CFO joins our platform and on-boards THEIR first ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " CFO Centre client on a Portfolio Pro subscription\u200B"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb0-5rem df fdc aic jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "mb0-5rem",
                                            style: {
                                                width: '32px',
                                                height: '32px'
                                            },
                                            src: (parcelRequire("44sQT")),
                                            alt: "cfoCenterRefund"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs14px",
                                            children: "100% Refund"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c49 fs11px tac",
                                            children: "We will refund 100% of the Portfolio Pro subscription you or your client paid on their first year subscription "
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c49 fs11px tac mt1rem",
                                            children: [
                                                "Your referral can a repeat the process for their own",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " CFO Centre colleagues"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: "c49 fs10px tac w80 mxa mt0-5rem op90",
                                style: {
                                    listStyleType: 'disc'
                                },
                                children: "can\u2019t be used in conjunction with any other discount or offer. If you subscribe on behalf of your client, we will promptly reimburse you"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("dqNS6")),
                                alt: "referOfferRightIcon"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $810fd00e44870152$export$2e2bcd8739ae039 = $810fd00e44870152$var$ReferCfoOfferModal;



var $ayMG0 = parcelRequire("ayMG0");





const $f95fdf0c9db68ad9$var$CompanyReferOffer = ({ company: company })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "user-info-sidebar 12 check mt12 br8px cp df py1rem px0-5rem aic mt0-5rem fdc bg1 shadow bo45 bss bw1px",
        style: {
            width: "100%",
            paddingLeft: '0.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb1rem",
                style: {
                    border: '1px solid #A8EFAB',
                    padding: '0.3rem 1rem',
                    borderRadius: '8px',
                    backgroundColor: '#E4FFEB'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "fs1rem fw500 c59",
                    children: [
                        "DILIGENTSIA ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fw700 fs1-25rem",
                            children: "PLUS"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                width: 150,
                src: (parcelRequire("9FAif")),
                alt: "refer"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                className: "tac c4 fs1rem mt1rem",
                children: [
                    "Get help from an ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " experienced CFO"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "tac c14 fs13px mt0-5rem df aic",
                children: "Fixed price 4 quarterly reviews of"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "tac c14 fs13px mb1rem df aic",
                children: [
                    " your preparedness ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        width: 40,
                        src: (parcelRequire("8zFJt")),
                        alt: "refer"
                    }),
                    " advice\xa0\u200B"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                style: {
                    width: '120px',
                    height: '34px',
                    padding: '4px',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase'
                },
                btnType: "warning",
                text: "Learn More",
                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'companyReferCfoOfferModa'
                    }))
            })
        ]
    });
};
var $f95fdf0c9db68ad9$export$2e2bcd8739ae039 = $f95fdf0c9db68ad9$var$CompanyReferOffer;



var $ayMG0 = parcelRequire("ayMG0");








const $0f057e242d303909$var$CompanyReferCfoOfferModal = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: 'companyReferCfoOfferModa',
        modalCardClasses: 'maw90',
        customStyle: {
            padding: '0rem',
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pt2rem pb0rem pr2rem w70 pl4rem",
                    style: {
                        backgroundColor: '#F5F7FF'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aifs p2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("c45dO")),
                                    alt: "referCfoOffer",
                                    style: {
                                        maxWidth: '150px',
                                        width: '100%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "c15 fs14px mb0-5rem tal w100 tal fw500",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c34",
                                            children: "Diligentsia Plus"
                                        }),
                                        " Offer"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pt0rem pl1rem pr2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c4 fw400 mt2rem fs20px",
                                    children: "Want to benefit from some loss-leading services? "
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    className: "fs2rem c15 fw500 mt0-5rem",
                                    children: [
                                        "We will match you with an experienced ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " fractional CFO for a fixed price package"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mt4rem ml1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                className: "c15",
                                                children: "Fixed price of only \xa3500 plus VAT - all goes to the CFO*"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fw600",
                                                        children: "Why will they do this?"
                                                    }),
                                                    "To build a pipeline of exciting companies who will return to them as they grow and can afford top commercial advice"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                className: "c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fw600",
                                                        children: " Why should you do this? "
                                                    }),
                                                    " To build an early relationship with someone who in the years ahead will turboboost your business with their experience and contacts"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c49 fs1rem mt4rem mb1rem fw400",
                                    children: "To get things rolling, please contact us to find out more and be matched..."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcfs",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        style: {
                                            maxHeight: "40px"
                                        },
                                        onClick: ()=>window.open('https://koalendar.com/e/meet-with-mark-bernstein', '_blank'),
                                        className: "df jcsb px1rem new-shadow cp c1 bg4 fw400 fs1rem br38px w200px py0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "mr0-5rem",
                                                        src: (parcelRequire("eR6rP")),
                                                        alt: "telephone"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "pl0-5rem fw400 c1 fs14px",
                                                        children: "Book a Call"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("9UKFK")),
                                                alt: "rightArrow"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c49 fs11px tac mt3rem",
                                    children: "*= Diligentsia does not take commission from the introduction, and takes no responsibility for advice provided or ommitted by the CFO"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w30 pt1rem",
                    style: {
                        backgroundImage: "linear-gradient(to right, #B9D9F9, #7FBDFA)"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "br8px p2rem df aic jcc fdc w80 mxa",
                            style: {
                                backgroundImage: "linear-gradient(to right, #FFFFFF33, #ffffff39)"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb0-5rem df fdc aic jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "mb0-5rem",
                                            style: {
                                                width: '32px',
                                                height: '32px'
                                            },
                                            src: (parcelRequire("hagGi")),
                                            alt: "cfoCenterRefer"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs14px",
                                            children: "Quarterly Check-ins"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c49 fs11px tac",
                                            children: " First meeting - one hour review of your business and Diligentsia modules then 3 x quarterly reviews over the rest of the year"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb0-5rem df fdc aic jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "mb0-5rem",
                                            style: {
                                                width: '32px',
                                                height: '32px'
                                            },
                                            src: (parcelRequire("bkYBb")),
                                            alt: "cfoCenterFraction"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs14px",
                                            children: "Platform Experts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c49 fs11px tac",
                                            children: "The CFOs we match you with are already experts in the Diligentsia platform\u200B"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb0-5rem df fdc aic jcc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "mb0-5rem",
                                            style: {
                                                width: '32px',
                                                height: '32px'
                                            },
                                            src: (parcelRequire("44sQT")),
                                            alt: "cfoCenterRefund"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs14px",
                                            children: "High-Value Guidance"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c49 fs11px tac",
                                            children: "The matched CFOs will give you bags of advice - vast amounts of value"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("dqNS6")),
                                alt: "referOfferRightIcon"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $0f057e242d303909$export$2e2bcd8739ae039 = $0f057e242d303909$var$CompanyReferCfoOfferModal;



























function $73a5f3cb80d8115d$export$2e2bcd8739ae039({ visibleSection: visibleSection = '', isManualAdd: isManualAdd, getUser: getUser, isWorkflowReport: isWorkflowReport, setIsWorkflowReport: setIsWorkflowReport, company: company, advisors: advisors, permissionLevel: permissionLevel, setCompany: setCompany, tab: tab, setTab: setTab, sanitiseTab: sanitiseTab, toggleReport: toggleReport, handleSuperflowNext: handleSuperflowNext, setCompanyDashboardTab: setCompanyDashboardTab, getCompletenessAndRiskHTML: getCompletenessAndRiskHTML, isExternalPage: isExternalPage, setSection: setSection, getViewableURL: getViewableURL, isViewTwoMinuteReport: isViewTwoMinuteReport, twoMinuteTestAIReport: twoMinuteTestAIReport, isTwoMinuteTesHomePage: isTwoMinuteTesHomePage, setOpenTabs: setOpenTabs, openTabs: openTabs, sortSections: sortSections, handlePartnerChecklistNext: handlePartnerChecklistNext, handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness, updateUserType: updateUserType, setTabName: setTabName, closeTab: closeTab, isBackFitReport: isBackFitReport, setIsBackFitReport: setIsBackFitReport, isLoader: isLoader, setIsLoader: setIsLoader }) {
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let [folderNo, setFolderNo] = (0, $acw62.useState)('');
    let [folderName, setFolderName] = (0, $acw62.useState)('');
    let [folderFiles, setFolderFiles] = (0, $acw62.useState)([]);
    let [activePoint, setActivePoint] = (0, $acw62.useState)('');
    let [sectionExpand, setSectionExpand] = (0, $acw62.useState)({});
    let [sidebarFixed, setSidebarFixed] = (0, $acw62.useState)(false);
    let [allocatedAdvisor, setAllocatedAdvisor] = (0, $acw62.useState)({});
    let [allSectionsExpand, setAllSectionsExpand] = (0, $acw62.useState)(false);
    let [isDemoPartnerChecklist, setIsDemoPartnerChecklist] = (0, $acw62.useState)(false);
    let coreInfoResearchAid = {
        'marketOpportunity': {
            name: 'Market Opportunity',
            path: 'S1 Q1 & S1 Q2',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        },
        'routeToMarket': {
            name: 'Route to Market',
            path: 'S1 Q1',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        },
        'competitorAnalysis': {
            name: 'Competitor Analysis',
            path: 'S5 Q1 & S5 Q5',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        },
        'technologyAdvantage': {
            name: 'Technology Advantage',
            path: 'S4 Q1 & S4 Q4',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        }
    };
    const handleScroll = (scrollTo)=>{
        const targetElement = document.getElementById(scrollTo);
        if (targetElement) targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (localStorage.getItem('isDemoChecklist') || localStorage.getItem('isPartnerChecklist')) setIsDemoPartnerChecklist(true);
        else setIsDemoPartnerChecklist(false);
        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const handleSidebarStick = ()=>{
            if (isSafari && window.scrollY > 925) setSidebarFixed(true);
            else setSidebarFixed(false);
        };
        window.addEventListener('scroll', handleSidebarStick);
        return ()=>window.removeEventListener('scroll', handleSidebarStick);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (tab === 'repository') setActivePoint(company?.modules?.[tab]?.sections?.[1]?.sectionNo);
        else {
            if (tab.includes('-report')) tab = tab.replace(/-report$/, "");
            setActivePoint(company?.modules?.[tab]?.sections?.[0]?.sectionNo);
        }
    }, [
        tab
    ]);
    //Get company by Id
    const getCompanyById = async (companyId)=>{
        if (companyId) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/company-data/${companyId}`);
            window.open(res['body']?.cWebsite, "_blank");
        }
    };
    const getAllocatedAdvisorId = (data, activePoint)=>{
        if (data) {
            for (let [key, value] of Object.entries(data)){
                if (value.modules && value.modules[activePoint] === true) return key;
            }
            return null;
        }
    };
    (0, $acw62.useEffect)(()=>{
        const advisorId = getAllocatedAdvisorId(company?.revenuelead, activePoint);
        if (advisorId) setAllocatedAdvisor({
            ...company?.advisorData?.find((obj, i, arr)=>obj?._id === advisorId),
            sectionName: getSectionName(company, activePoint) ?? tab
        });
        else setAllocatedAdvisor({
            ...company?.advisorData?.find((obj, i, arr)=>!obj?.createdBy),
            sectionName: getSectionName(company, activePoint) ?? tab
        });
    }, [
        activePoint
    ]);
    (0, $acw62.useEffect)(()=>{
        const advisorId = getAllocatedAdvisorId(company?.revenuelead, visibleSection);
        if (advisorId) setAllocatedAdvisor({
            ...company?.advisorData?.find((obj, i, arr)=>obj?._id === advisorId),
            sectionName: getSectionName(company, visibleSection) ?? tab
        });
        else setAllocatedAdvisor({
            ...company?.advisorData?.find((obj, i, arr)=>!obj?.createdBy),
            sectionName: getSectionName(company, visibleSection) ?? tab
        });
    }, [
        visibleSection
    ]);
    const truncateText = (text, maxLength)=>{
        if (!text || text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };
    const getSectionName = (data, sectionNo)=>{
        let moduleName = null;
        for(const moduleKey in data?.modules){
            const module = data?.modules[moduleKey];
            // Check if module has sections before trying to access them
            if (module?.sections) {
                const matchingSection = module.sections.find((section)=>section.sectionNo === sectionNo);
                if (matchingSection) {
                    moduleName = matchingSection.sectionName;
                    break;
                }
            }
        }
        if (moduleName) return moduleName;
        else return "N/A";
    };
    const onCardLog = async (company, user, allocatedAdvisor, clickedOn, adsData)=>{
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/log/card/log`, {
            firmId: allocatedAdvisor?.companyId,
            advisor: allocatedAdvisor,
            hasBusinessCard: true,
            routeName: location.pathname,
            clickedOn: clickedOn,
            company: company,
            ...adsData && adsData?.adId ? {
                adId: adsData?.adId
            } : {},
            ...adsData && adsData?.visibleSection ? {
                sectionNo: adsData?.visibleSection.includes('.') ? adsData?.visibleSection.split('.')[0] : adsData?.visibleSection
            } : {},
            ...adsData && adsData?.isDefault && {
                isDefault: adsData?.isDefault
            }
        });
    };
    const LiButton = ({ link: link, company: company, user: user, allocatedAdvisor: allocatedAdvisor, withoutLog: withoutLog })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                borderRadius: "2.5rem",
                padding: "0px 12px",
                color: "#ffffff",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "1rem",
                cursor: link ? "pointer" : 'text',
                background: link ? "linear-gradient(120.13deg, #4A67FF -3.15%, #3956F0 8.51%, #798EFF 71.07%, #8496F4 102.88%)" : '#999'
            },
            onClick: ()=>{
                if (link) window.open(link.startsWith("https://") ? link : `https://${link}`, '_blank');
                if (withoutLog === false) onCardLog(company, user, allocatedAdvisor, "linkedIn");
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("dnTAO")),
                alt: "Linkedin Logo",
                style: {
                    height: '10px'
                }
            })
        });
    };
    const getFilesFromQuestions = (questions)=>questions && questions.filter((q)=>q.answer?.files?.length).reduce((arr, q)=>[
                ...arr,
                ...q.answer.files.map((file)=>({
                        ...file,
                        questionId: q._id,
                        questionNo: q.qNo,
                        answerId: q.answer._id,
                        drLastSync: q?.answer?.drLastSync ? q?.answer?.drLastSync : '',
                        dbLastSync: q?.answer?.dbLastSync ? q?.answer?.dbLastSync : '',
                        title: file.originalname,
                        url: file.location,
                        ext: file.originalname.split(".").slice(-1)[0]
                    }))
            ], []);
    const toggleSectionExpand = (sectionId)=>setSectionExpand((prevState)=>({
                ...prevState,
                [sectionId]: !prevState[sectionId]
            }));
    const toggleAllSectionsExpand = ()=>setAllSectionsExpand(!allSectionsExpand);
    const handleReport = async (e, module)=>{
        if (user['role'] == 'Investor' && user?.['companyId']?.['_id'] && isBackFitReport) {
            window.location.href = `/company/${company['_id']}#fit-report:${user?.['companyId']?.['_id']}`;
            setIsBackFitReport(false);
            setTab(`fit-report:${user?.['companyId']?.['_id']}`);
            setOpenTabs(new Set([
                `fit-report:${user?.['companyId']?.['_id']}`
            ]));
            return;
        }
        if (localStorage.getItem('isDiligencePack') && !isBackFitReport || user?.['type'] == 'External') {
            window.location.href = `/company/${company['_id']}#diligence-pack`;
            setTab('diligence-pack');
            setOpenTabs(new Set([
                `diligence-pack`
            ]));
            localStorage.removeItem('isDiligencePack');
            return;
        }
        if (user['role'] == 'User' && isBackFitReport) {
            setIsBackFitReport(false);
            setTabName('');
            setCompanyDashboardTab('InvestorMatch');
            return;
        }
        if (isWorkflowReport) setIsWorkflowReport(false);
        let isDiligenceReport = localStorage.getItem('isDiligenceReport');
        if (isDiligenceReport) {
            // close all tabs
            Array.from(openTabs).map(async (openTab)=>{
                await openTabs.delete(openTab);
                setOpenTabs(new Set(Array.from(openTabs)));
            });
            let redirectTab = location.href.split('#')[1];
            setTab(redirectTab);
            return;
        }
        if (tab.includes('two-minute-test') && !tab.endsWith("-report")) twoMinuteTestAIReport(module);
        else if (tab.includes('investor-lead')) {
            window.history.replaceState(null, '', window.location.pathname);
            setCompanyDashboardTab('InvestorMatch');
            setTabName('');
            closeTab(e, tab);
        } else toggleReport(e);
    };
    const showSection = (section, sectionFiles, subSection)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: isTwoMinuteTesHomePage ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: "df fww w100 cna",
                style: {
                    width: '96%',
                    padding: '5px 0px 0px 7px'
                },
                disabled: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fw500 w70 asc pen uss ass tal pr1-5rem",
                        children: [
                            `${subSection?.no} ${subSection?.name}`,
                            " "
                        ]
                    }),
                    sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "df jcc aic pa r0 cp mr0-5rem fs10px bg1 br10px h20px",
                        onClick: ()=>{
                            setSection(section);
                            setFolderNo(subSection?.no);
                            setFolderName(subSection?.name);
                            setFolderFiles(sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no));
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'manageIndexFiles'
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "mr0-25rem",
                                width: "10",
                                height: "10",
                                viewBox: "0 0 10 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                        clipPath: "url(#clipSidebarAttach)",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                            fill: "#4A67FF"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clipSidebarAttach",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "10",
                                                height: "10",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-scroll-to": subSection?.no,
                onClick: ()=>handleScroll(subSection?.no),
                className: "df fww w100",
                style: {
                    width: '96%',
                    padding: '5px 0px 0px 7px',
                    background: subSection?.stats?.completionPercent > 0 ? '#bbeadb' : 'transparent'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fw500 w70 asc pen uss ass tal pr1-5rem c2 c6-hover",
                        children: [
                            `${subSection?.no} ${subSection?.name}`,
                            " "
                        ]
                    }),
                    subSection?.['updatedAt'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df jcc fs10px mt0-5rem cp c6-hover",
                        children: [
                            "(Last Updated: ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(subSection?.['updatedAt']).format('DD/MMM/YY'),
                            ")"
                        ]
                    }),
                    sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "df jcc aic pa r0 cp mr0-5rem fs10px bg1 br10px h20px",
                        onClick: ()=>{
                            setSection(section);
                            setFolderNo(subSection?.no);
                            setFolderName(subSection?.name);
                            setFolderFiles(sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no));
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'manageIndexFiles'
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "mr0-25rem",
                                width: "10",
                                height: "10",
                                viewBox: "0 0 10 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                        clipPath: "url(#clipSidebarAttach)",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                            fill: "#4A67FF"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clipSidebarAttach",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "10",
                                                height: "10",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length
                        ]
                    })
                ]
            })
        });
    };
    function getSectionUpdatedAt(company, section) {
        // Case 1: No questions
        if (!section.questions || section.questions.length === 0) return company.updatedAt;
        // Collect all answer.updatedAt values
        const answerDates = section.questions.map((q)=>q.answer?.updatedAt) // answer exist kare to uska updatedAt
        .filter(Boolean); // null/undefined remove kar do
        // Case 2: If no answers available in any question
        if (answerDates.length === 0) return company.updatedAt;
        // Case 3: Return the latest answer.updatedAt
        return answerDates.reduce((latest, date)=>{
            return new Date(date) > new Date(latest) ? date : latest;
        });
    }
    const getSidebarHTML = (module, showInTooltip = false)=>{
        let array = [];
        let isViewWorkflow = false;
        if (module?.['category']) isViewWorkflow = true;
        // if (module) calculateStats(company, tab, "check1");
        if (module && module.sections && module?.['expansionPack']) array = Object.values(module['sections'][0]['subFolders']);
        else array = module?.sections;
        if (array?.length > 0) {
            for(let i = 0; i < array.length; i++)if (array[i].type == "Additional Sections" && array[i].sectionName === '') {
                array.splice(i, 1);
                i -= 1;
            }
        }
        const style = showInTooltip ? {} : {
            width: "calc((100% - 4rem) / 5)"
        };
        const jsx = module && module.sections && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            id: "sidebar",
            style: style,
            className: (showInTooltip ? "" : tab == 'esg' || tab == 'business-audit' || tab.includes("two-minute-test") ? "esg-sidebar " : "h100vh ") + (tab && tab.match(/directors-questionnaire/) && " questionnaire-sidebar ") + (module.type === 'repository' && " repository-sidebar ") + ` w100 bsbb dg gg1rem t0 sidebar-report ${sidebarFixed ? 'sidebar-fixed' : 'ps'}`,
            children: [
                isManualAdd ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("931hv")),
                        alt: "inteligent-girl"
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bo45 bss bw1px br8px bg38",
                    children: [
                        !showInTooltip && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic fdc p0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c3 fs1-25rem ttu w100 tac",
                                    children: tab == 'investor-lead' || module?.['heading'] == 'Investor Match' || module?.['type'] == 'investor-lead' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c15",
                                        children: [
                                            "Investor",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "Match"
                                            })
                                        ]
                                    }) : module?.['heading'] ? module?.['heading'] : module?.['type'].includes('directors-questionnaire') ? 'Directors Questionnaire' : module?.['type'] || company.modules[sanitiseTab(tab)]?.['heading'] + " Report"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "c3 ttu lh1 fs1-25rem mt0-5rem tac pr w100",
                                    children: [
                                        " Index",
                                        module['type'] === 'repository' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository",
                                            target: "_blank",
                                            className: "help-icon pa cp",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "question-button",
                                                    src: (parcelRequire("1ScrU")),
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                }),
                                (permissionLevel == "ALL" || permissionLevel == "DASHBOARD & REPORT") && user?.['type'] !== 'Superflow' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        tab.includes("kpi-report") && isViewTwoMinuteReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("7hMZV"))
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: isDemoPartnerChecklist,
                                            onClick: (e)=>handleReport(e, module),
                                            className: `${!isDemoPartnerChecklist && module?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} mt1rem mxa ${isDemoPartnerChecklist ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br50px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac ${tab.endsWith("-report") && 'close-report'}`,
                                            "data-tooltip": isDemoPartnerChecklist ? 'You must register to access it' : '',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    style: {
                                                        position: 'relative',
                                                        top: '4px'
                                                    },
                                                    className: "pen fds h1rem f1 mr0-5rem close-svg",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "pen fa-primary",
                                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                    })
                                                }),
                                                tab == 'investor-lead' ? 'Investor Leads' : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        tab.endsWith("-report") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: isViewWorkflow && isWorkflowReport ? "Close Workflow" : 'Close'
                                                        }) : "View",
                                                        tab == 'warranty-disclosure' ? ' Disclosure Schedule' : ' Reports'
                                                    ]
                                                })
                                            ]
                                        }),
                                        isViewWorkflow && !isWorkflowReport && !tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: isDemoPartnerChecklist,
                                            onClick: async (e)=>{
                                                await setIsWorkflowReport(true);
                                                handleReport(e, module);
                                            },
                                            className: `${!isDemoPartnerChecklist && module?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} mt1rem mxa ${isDemoPartnerChecklist ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br50px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac ${tab.endsWith("-report") && 'close-report'}`,
                                            "data-tooltip": isDemoPartnerChecklist ? 'You must register to access it' : '',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    style: {
                                                        position: 'relative',
                                                        top: '4px'
                                                    },
                                                    className: "pen fds h1rem f1 mr0-5rem close-svg",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "pen fa-primary",
                                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                    })
                                                }),
                                                "View Workflow Report"
                                            ]
                                        })
                                    ]
                                }),
                                tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: (isDemoPartnerChecklist || user['role'] == 'Guest') && user['type'] !== 'External',
                                            onClick: ()=>downloadPDF(),
                                            className: `h100 my0-5rem mxa shadow ${(isDemoPartnerChecklist || user['role'] == 'Guest') && user['type'] !== 'External' ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac df jcc aic`,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "pen fds h1rem f1 mr0-5rem",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 640 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                        })
                                                    ]
                                                }),
                                                "Download PDF"
                                            ]
                                        }),
                                        tab == "kpi-report" && isViewTwoMinuteReport && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>twoMinuteTestAIReport(module),
                                            style: {
                                                padding: '6px 25px'
                                            },
                                            className: `${module?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                                            children: "View 2-Minute Test Report"
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        getCompletenessAndRiskHTML("sidebar-" + tab, company.modules[sanitiseTab(tab)].stats),
                                        (company?.['subscription'] === 'Pro' && module['type'] === 'repository' || isTwoMinuteTesHomePage) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>toggleAllSectionsExpand(),
                                            className: "pa r0 cp c6 bg5 tac lh1 fs2rem sideBarAllCollapse",
                                            style: {
                                                top: '150px',
                                                transform: 'translate(-50%, -60%)',
                                                userSelect: 'none'
                                            },
                                            children: allSectionsExpand ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41b252a7376cfacd$export$2e2bcd8739ae039), {
                                                className: "c51 bg5"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                                                className: "c51 bg5"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `mah100 mya oya df fdc jcsb bbrr5px bblr5px ${module['type'].includes('business-audit') && "businessAuditSidebar"}`,
                            children: tab !== "kpi-report" && array.length > 0 && array.slice().sort(sortSections).map((section)=>{
                                let sectionFiles = getFilesFromQuestions(section?.questions);
                                // TODO: Calculate Stats for Expansion Packs
                                if (!section.stats) section.stats = module['sections'][0]['stats'];
                                let completeness;
                                if (isWorkflowReport && section?.stats?.workflowCompletionPercent) completeness = section.stats.workflowCompletionPercent;
                                else if (module['type'] == 'repository' && company['subscription'] == 'Lite') {
                                    if (section.questions) completeness = section.questions.filter((q)=>q.qNo == section.sectionNo)[0]?.['answer']?.['status'] == 'Completed' ? 100 : 0;
                                } else completeness = section.stats.completionPercent ?? 0;
                                let riskColour;
                                if (module['type'] === "repository" || module['type'] === "investor-lead" || section.stats.riskPercent < 38) riskColour = 7;
                                else if (section.stats.riskPercent > 62) riskColour = 9;
                                else riskColour = 8;
                                let hexColour;
                                if (isWorkflowReport && section?.stats?.workflowCompletionPercent) hexColour = section?.stats?.workflowCompletionPercent > 75 ? '#d8fcc7' : section?.stats?.workflowCompletionPercent > 26 ? '#fff4c9' : section?.stats?.workflowCompletionPercent > 1 ? '#ffcecc' : '#dbdbdb';
                                else hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                                let tooltip;
                                if (isWorkflowReport) {
                                    if (completeness) tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tac maw200px",
                                        children: `This section has ${completeness}% workflow completeness`
                                    }));
                                } else tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac maw200px",
                                    children: `This section is ${completeness}% complete` + (module['type'] !== "repository" || module['type'] !== "investor-lead" ? ` ${section.stats.completionPercent === 0 ? module['type'] === "repository" ? "" : " with no risk score." : module['type'] === "repository" ? "" : `with a risk score of ${section?.stats?.riskPercent ? section?.stats?.riskPercent : '0'}%.`}` : "")
                                }));
                                if (section['disabled']) tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac maw200px",
                                    children: `Please request admin to access ${section['sectionNo']}`
                                }));
                                let colorChange = false;
                                if (module['type'] == "warranty-disclosure") section?.questions.map((question)=>{
                                    if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
                                        colorChange = true;
                                        return;
                                    }
                                });
                                let disabledSection = false;
                                if ((module['type'] == 'repository' || module['type'] == `business-audit-${company['testType']}`) && (user['role'] == "Advisor" || user['role'] == "Investor" || user['role'] == 'Member') && user?.['companyId'] && user?.['companyId']?.['_id'] != company?.['_id'] && (company['advisors'] || company['investors'] || company['memberPermissions'])) {
                                    // if (user['role'] == 'Advisor' && company?.['advisors']?.[user['_id']]?.['modules'] && !company?.['advisors']?.[user['_id']]?.['modules']?.[section['sectionNo']] && user?.['companyId']?.['_id'] !== company['_id']) disabledSection = true;
                                    if (user['role'] == 'Investor' && !company?.['investors']?.[user['_id']]?.['modules']?.[section['sectionNo']]) disabledSection = true;
                                    if (user['role'] == 'Member' && !company?.owners.includes(user['_id']) && !company?.['memberPermissions']?.[user['_id']]?.[section['sectionNo']]) disabledSection = true;
                                }
                                if (tab == 'Investment Readiness') {
                                    let answers = {};
                                    section?.questions && section?.questions.forEach((ques)=>{
                                        const qNo = ques['qNo'];
                                        answers[qNo] = {
                                            radioOption: ques?.['answer']?.['radioOption'],
                                            hasContent: ques?.['answer'] && (ques?.['answer']?.['files']?.length > 0 || ques?.['answer']?.['comment'])
                                        };
                                    });
                                    const isYesWithContent = (qNo)=>{
                                        return answers[qNo]?.radioOption === 'Yes' && answers[qNo]?.hasContent;
                                    };
                                    const isNoOrNA = (qNo)=>{
                                        return answers[qNo]?.radioOption === 'No' || answers[qNo]?.radioOption === 'N/A';
                                    };
                                    // marketOpportunity (requires both 1.1 AND 1.2)
                                    if (section['sectionNo'] == `${module['moduleKey']}1`) {
                                        coreInfoResearchAid['marketOpportunity']['sectionNo'] = section['sectionNo'];
                                        const q11 = `${module['moduleKey']}1.1`;
                                        const q12 = `${module['moduleKey']}1.2`;
                                        if (isYesWithContent(q11) && isYesWithContent(q12)) {
                                            coreInfoResearchAid['marketOpportunity']['uploaded'] = true;
                                            coreInfoResearchAid['marketOpportunity']['notUploaded'] = false;
                                        } else if (isNoOrNA(q11) || isNoOrNA(q12)) {
                                            coreInfoResearchAid['marketOpportunity']['uploaded'] = false;
                                            coreInfoResearchAid['marketOpportunity']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['marketOpportunity']['uploaded'] = false;
                                            coreInfoResearchAid['marketOpportunity']['notUploaded'] = false;
                                        }
                                    }
                                    // routeToMarket (requires only 1.1)
                                    if (section['sectionNo'] == `${module['moduleKey']}1`) {
                                        coreInfoResearchAid['routeToMarket']['sectionNo'] = section['sectionNo'];
                                        const q11 = `${module['moduleKey']}1.1`;
                                        if (isYesWithContent(q11)) {
                                            coreInfoResearchAid['routeToMarket']['uploaded'] = true;
                                            coreInfoResearchAid['routeToMarket']['notUploaded'] = false;
                                        } else if (isNoOrNA(q11)) {
                                            coreInfoResearchAid['routeToMarket']['uploaded'] = false;
                                            coreInfoResearchAid['routeToMarket']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['routeToMarket']['uploaded'] = false;
                                            coreInfoResearchAid['routeToMarket']['notUploaded'] = false;
                                        }
                                    }
                                    // competitorAnalysis (requires both 5.1 AND 5.5)
                                    if (section['sectionNo'] == `${module['moduleKey']}5`) {
                                        coreInfoResearchAid['competitorAnalysis']['sectionNo'] = section['sectionNo'];
                                        const q51 = `${module['moduleKey']}5.1`;
                                        const q55 = `${module['moduleKey']}5.5`;
                                        if (isYesWithContent(q51) && isYesWithContent(q55)) {
                                            coreInfoResearchAid['competitorAnalysis']['uploaded'] = true;
                                            coreInfoResearchAid['competitorAnalysis']['notUploaded'] = false;
                                        } else if (isNoOrNA(q51) || isNoOrNA(q55)) {
                                            coreInfoResearchAid['competitorAnalysis']['uploaded'] = false;
                                            coreInfoResearchAid['competitorAnalysis']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['competitorAnalysis']['uploaded'] = false;
                                            coreInfoResearchAid['competitorAnalysis']['notUploaded'] = false;
                                        }
                                    }
                                    // technologyAdvantage (requires both 4.1 AND 4.4)
                                    if (section['sectionNo'] == `${module['moduleKey']}4`) {
                                        coreInfoResearchAid['technologyAdvantage']['sectionNo'] = section['sectionNo'];
                                        const q41 = `${module['moduleKey']}4.1`;
                                        const q44 = `${module['moduleKey']}4.4`;
                                        if (isYesWithContent(q41) && isYesWithContent(q44)) {
                                            coreInfoResearchAid['technologyAdvantage']['uploaded'] = true;
                                            coreInfoResearchAid['technologyAdvantage']['notUploaded'] = false;
                                        } else if (isNoOrNA(q41) || isNoOrNA(q44)) {
                                            coreInfoResearchAid['technologyAdvantage']['uploaded'] = false;
                                            coreInfoResearchAid['technologyAdvantage']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['technologyAdvantage']['uploaded'] = false;
                                            coreInfoResearchAid['technologyAdvantage']['notUploaded'] = false;
                                        }
                                    }
                                }
                                const lastUpdateSection = getSectionUpdatedAt(company, section);
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: [
                                        'repository',
                                        'warranty-disclosure',
                                        'software-development',
                                        'esg',
                                        'directors-questionnaire'
                                    ].includes(module?.['type']) || isTwoMinuteTesHomePage ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                disabled: section['disabled'] || disabledSection,
                                                "data-tooltip": !section['isDisabled'] ? tooltip : '',
                                                className: `c3-hover c51 bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`,
                                                style: {
                                                    background: section['disabled'] || disabledSection ? 'transparent' : `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                                },
                                                onClick: ()=>handleScroll(section['sectionNo']),
                                                children: [
                                                    tab.endsWith("-report") && !isExternalPage && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `asc checkbox w30px h30px pr mr1rem ${section['disabled'] || section['isDisabled'] || disabledSection ? 'op40' : 'op100 c3-hover'}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onChange: ()=>{
                                                                section['isHidden'] = !section['isHidden'];
                                                                dispatch(setCompany({
                                                                    ...company
                                                                }));
                                                            },
                                                            checked: !section['isHidden'],
                                                            type: "checkbox",
                                                            className: "bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        "data-tooltip": !section['isDisabled'] ? tooltip : '',
                                                        onClick: ()=>handleScroll(section['sectionNo']),
                                                        className: "df fdc w100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                class: "df aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `${showInTooltip ? 'fs0-5rem ' : 'fs0-75rem'} ${section['disabled'] || section['isDisabled'] || disabledSection ? 'op40' : 'op100 c3-hover'} sidemenu fw500 asc pen uss ass tal pr1rem`,
                                                                        children: section['sectionName']
                                                                    }),
                                                                    sectionFiles && sectionFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                        className: "df jcc aic cp bg1 fs10px br10px h20px",
                                                                        onClick: ()=>{
                                                                            setSection(section);
                                                                            setFolderNo(section?.sectionNo);
                                                                            setFolderFiles(sectionFiles);
                                                                            setFolderName(section?.sectionName);
                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                open: 'manageIndexFiles'
                                                                            }));
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                className: "mr0-25rem",
                                                                                width: "10",
                                                                                height: "10",
                                                                                viewBox: "0 0 10 10",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                        clipPath: "url(#clipSidebarAttach)",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                                                                            fill: "#4A67FF"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                            id: "clipSidebarAttach",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                width: "10",
                                                                                                height: "10",
                                                                                                fill: "white"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            sectionFiles.length > 0 && sectionFiles.length
                                                                        ]
                                                                    }),
                                                                    (company?.['subscription'] === 'Pro' || isTwoMinuteTesHomePage) && !allSectionsExpand && section?.subFolders && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        disabled: section['disabled'] || disabledSection,
                                                                        className: `c3-hover expand-button cp`,
                                                                        onClick: ()=>toggleSectionExpand(section['_id']),
                                                                        children: section['disabled'] || section['isDisabled'] || disabledSection ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                                            className: "op40",
                                                                            style: {
                                                                                fontSize: "18px",
                                                                                fontWeight: 300
                                                                            }
                                                                        }) : sectionExpand[section['_id']] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41b252a7376cfacd$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {})
                                                                    })
                                                                ]
                                                            }),
                                                            !isTwoMinuteTesHomePage && lastUpdateSection && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: `w100 df jcc fs10px mt0-5rem cp c6-hover ${section['disabled'] || disabledSection ? 'c12 c12-hover' : 'c14'}`,
                                                                children: [
                                                                    "(Last Updated: ",
                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(lastUpdateSection).format('DD/MMM/YY'),
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (sectionExpand[section['_id']] || allSectionsExpand) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "sub-folders cp",
                                                children: section?.subFolders && Object.keys(section?.subFolders).map((subFolder)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            showSection(section, sectionFiles, section?.subFolders[subFolder]),
                                                            section?.subFolders[subFolder]?.subFolders && Object.keys(section?.subFolders[subFolder]?.subFolders).map((subSubFolder)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        showSection(section, sectionFiles, section?.subFolders[subFolder]?.subFolders[subSubFolder]),
                                                                        section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders && Object.keys(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders).map((subSubSubFolder)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                children: isTwoMinuteTesHomePage ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                    className: "df fww w100",
                                                                                    disabled: true,
                                                                                    style: {
                                                                                        width: '96%',
                                                                                        padding: '5px 0px 0px 7px',
                                                                                        cursor: 'not-allowed'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "w70 asc pen uss ass tal pr1-5rem pl1rem",
                                                                                        children: [
                                                                                            section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no,
                                                                                            " ",
                                                                                            section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name
                                                                                        ]
                                                                                    })
                                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    onClick: ()=>handleScroll(section['sectionNo']),
                                                                                    className: "df fww w100",
                                                                                    style: {
                                                                                        width: '92%',
                                                                                        padding: '5px 0px 0px 15px',
                                                                                        background: section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.stats?.completionPercent > 0 ? '#bbeadb' : 'transparent'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                            className: "w70 asc pen uss ass tal pr1-5rem pl1rem c2 c6-hover",
                                                                                            children: [
                                                                                                section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no,
                                                                                                " ",
                                                                                                section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name
                                                                                            ]
                                                                                        }),
                                                                                        sectionFiles && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                            className: "df jcc aic pa r0 cp mr0-5rem fs10px bg1 br10px h20px",
                                                                                            onClick: ()=>{
                                                                                                setSection(section);
                                                                                                setFolderNo(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no);
                                                                                                setFolderName(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name);
                                                                                                setFolderFiles(sectionFiles && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no));
                                                                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                                    open: 'manageIndexFiles'
                                                                                                }));
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    className: "mr0-25rem",
                                                                                                    width: "10",
                                                                                                    height: "10",
                                                                                                    viewBox: "0 0 10 10",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                                            clipPath: "url(#clipSidebarAttach)",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                                                                                                fill: "#4A67FF"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                                id: "clipSidebarAttach",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                                    width: "10",
                                                                                                                    height: "10",
                                                                                                                    fill: "white"
                                                                                                                })
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                sectionFiles && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length > 0 && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            });
                                                                        })
                                                                    ]
                                                                });
                                                            })
                                                        ]
                                                    });
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>{
                                            setActivePoint(section['sectionNo']);
                                            handleScroll(section['sectionNo']);
                                        },
                                        disabled: disabledSection,
                                        "data-tooltip": tooltip,
                                        className: `${disabledSection ? 'c12' : 'c2 c3-hover'} bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`,
                                        style: {
                                            background: isWorkflowReport ? `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)` : disabledSection ? 'transparent' : `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                        },
                                        children: [
                                            tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "asc checkbox w30px h30px pr mr1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    onChange: (e)=>{
                                                        section['isHidden'] = !section['isHidden'];
                                                        dispatch(setCompany({
                                                            ...company
                                                        }));
                                                    },
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                    type: "checkbox",
                                                    checked: !section['isHidden']
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: (showInTooltip ? 'fs0-5rem ' : 'fs0-75rem ') + "fw500 asc pen uss ass tal",
                                                children: [
                                                    section['sectionName'],
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        tab === "repository" && company.subscription == "Pro" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "hf df aic jcc mt1 mb4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "additional-sections-button",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'proaddsection'
                                        })),
                                    className: "btn-packge shadow bg3 bg4-hover c1 td250 br50px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic fs0-75rem",
                                    children: [
                                        "Add/Edit User Defined Sections",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area",
                                            style: {
                                                color: 'black',
                                                left: '-8px',
                                                right: 'auto'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                className: "icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "h4rem",
                                                        src: (parcelRequire("24u8s")),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        style: {
                                                            top: 'auto',
                                                            bottom: '130%',
                                                            left: '-8px',
                                                            transform: 'none',
                                                            minWidth: '270px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Diligentsia Pro allows users to add up to 5 user-defined sections to the Data Repository Index structure.  These are then replicated in your Data Room (Drive/Sharepoint/Dropbox )"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                user['role'] == 'Guest' && localStorage.getItem('isPartnerChecklist') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df fdc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>handlePartnerChecklistNext(module),
                            className: `w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem mt1rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                            children: "Next"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: module?.['stats']['completionPercent'] > 0 && "/register",
                            className: `w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem mt0-5rem df aic jcc ${module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                            children: "Save for later"
                        }),
                        !tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w100 mb1rem",
                            src: (parcelRequire("gDTQF")),
                            alt: ""
                        }),
                        tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w100 mb1rem",
                            src: (parcelRequire("40qsd")),
                            alt: ""
                        })
                    ]
                }),
                user['type'] == 'Superflow' && tab == `investor-lead` && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        class: "df fdc aic mt1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df w100 mb1rem",
                                src: (parcelRequire("4VhrM")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleSuperflowNext(),
                                "data-tooltip": company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] != 100 ? 'Please complete the module 100%' : '',
                                className: `w50 shadow fw500 fs0-75rem br50px px1rem py0-5rem df aic jcc ${company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100 ? 'bg4 cp c1' : 'bg16 cna c14'} `,
                                children: "Next"
                            })
                        ]
                    })
                }),
                tab == 'Investment Readiness' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "superflow-section mah40 oscy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "bo45 bss bw1px br10px bg1 p0-5rem mt0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    class: "c14 fs1rem lh2 tac",
                                    children: [
                                        "Core Information For ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ResearchAid Reports"
                                    ]
                                }),
                                Object.values(coreInfoResearchAid).map((item)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>{
                                            setActivePoint(item['sectionNo']);
                                            handleScroll(item['sectionNo']);
                                        },
                                        class: "cp w100 df bo45 bss bw1px br20px bg1 p0-5rem mt0-5rem",
                                        style: {
                                            backgroundColor: item['uploaded'] ? '#deffe9' : item['notUploaded'] ? '#ffdddd' : '#ffffff'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "w10 mr0-5rem",
                                                children: [
                                                    item['uploaded'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "w20px h20px",
                                                        src: (parcelRequire("2M7mC")),
                                                        alt: "check-icon"
                                                    }),
                                                    item['notUploaded'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "w20px h20px",
                                                        src: (parcelRequire("aHhy4")),
                                                        alt: "cross-icon"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "w80 df fdc mx0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "w100 fs0-75rem c14 lh1",
                                                        children: [
                                                            item['name'],
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                class: "c4",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "w100 fs0-75rem c12 lh2",
                                                        children: [
                                                            "(",
                                                            item['path'],
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                class: "w10 ml0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w20px h20px",
                                                    src: (parcelRequire("e7RTg")),
                                                    alt: "file-icon"
                                                })
                                            })
                                        ]
                                    });
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "df fdc aic mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df w100 mb1rem",
                                src: (parcelRequire("1avjd")),
                                alt: ""
                            })
                        }),
                        user['type'] == 'Superflow' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df fdc aic mb2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>handleCompleteInvestmentReadiness(),
                                        className: `w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                        children: "Next"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>updateUserType(),
                                        className: `w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                        children: "Save for later"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df fdc aic mb2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleCompleteInvestmentReadiness(),
                                className: `w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                children: "Generate"
                            })
                        })
                    ]
                }),
                user?.['type'] == 'Superflow' && tab == 'Investment Readiness-report' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "df fdc aic mt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w100 mb1rem",
                            src: (parcelRequire("jhDfB")),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>module?.['stats']['completionPercent'] > 0 && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'superFlowCompletedPopup'
                                })),
                            className: `w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem my1rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                            children: "Next"
                        })
                    ]
                }),
                tab.match(/two-minute-test-.*-report/) && user?.role.toLowerCase() === "guest" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("lkR4C")),
                            alt: "2minutesTestSidebarDiligentsia"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: `/company/${company['_id']}`,
                            style: {
                                width: '75%',
                                paddingTop: '12px',
                                paddingBottom: '12px',
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            className: `shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                            children: "Next"
                        })
                    ]
                }) : (!localStorage.getItem('isDemoChecklist') || !localStorage.getItem('isPartneChecklist')) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        (0, $1eef38cfda4b0c52$export$884def0ebe460136)({
                            company: company
                        }) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: company?.isParent ? tab !== 'investor-lead' && tab !== 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59010cfc8b663697$export$2e2bcd8739ae039), {
                                onCardLog: onCardLog,
                                user: user,
                                LiButton: LiButton,
                                company: company,
                                truncateText: truncateText,
                                activePoint: activePoint,
                                visibleSection: visibleSection,
                                getCompanyById: getCompanyById,
                                allocatedAdvisor: allocatedAdvisor?.email ? allocatedAdvisor : {
                                    ...user,
                                    sectionName: getSectionName(company, visibleSection)
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8615c75609e057bd$export$2e2bcd8739ae039), {
                                onCardLog: onCardLog,
                                user: user,
                                LiButton: LiButton,
                                company: company,
                                truncateText: truncateText,
                                getSectionName: getSectionName,
                                activePoint: activePoint,
                                visibleSection: visibleSection,
                                getCompanyById: getCompanyById
                            })
                        }),
                        shouldRenderReferOffer ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af33af4f3eed7fb8$export$2e2bcd8739ae039), {}) : null,
                        (0, $1eef38cfda4b0c52$export$f5f94221ec047dbf)({
                            company: company,
                            user: user
                        }) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f95fdf0c9db68ad9$export$2e2bcd8739ae039), {
                            company: company
                        }) : null
                    ]
                }),
                user['role'] == 'Guest' && tab == `two-minute-test-${company['testType']}` && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    class: "df fdc aic mt1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "df w100 mb1rem",
                        src: (parcelRequire("aSPAr")),
                        alt: ""
                    })
                })
            ]
        });
        return showInTooltip ? (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(jsx) : jsx;
    };
    const convertImageToBase64 = async (imgUrl)=>{
        try {
            const proxyUrl = `${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api/company/pdf-proxy?url=${encodeURIComponent(imgUrl)}`;
            const response = await fetch(proxyUrl);
            const blob = await response.blob();
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error converting image to base64:', error);
            return imgUrl;
        }
    };
    const convertAllImagesToBase64 = async (element)=>{
        const images = element.querySelectorAll('img');
        const imagePromises = [];
        for (const img of images){
            const src = img.src;
            if (src && (src.includes('s3') || src.includes('amazonaws') || src.includes('cloudfront'))) imagePromises.push(convertImageToBase64(src).then((base64)=>{
                img.setAttribute('data-original-src', src);
                img.src = base64;
            }).catch(()=>{}));
        }
        await Promise.all(imagePromises);
    };
    const restoreOriginalImages = (element)=>{
        const images = element.querySelectorAll('img[data-original-src]');
        for (const img of images){
            img.src = img.getAttribute('data-original-src');
            img.removeAttribute('data-original-src');
        }
    };
    const downloadPDF = async ()=>{
        try {
            // If Papermill PDF exists (reportUrl), download from S3 directly
            const moduleName = sanitiseTab(tab);
            const currentModule = company?.modules?.[moduleName];
            if (currentModule?.reportUrl) {
                setIsLoader({
                    show: true,
                    message: 'Downloading PDF...'
                });
                // Create a temporary link to trigger download
                const link = document.createElement('a');
                link.href = currentModule.reportUrl;
                link.target = '_blank';
                link.download = `${company.cName || 'Report'} - ${moduleName}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsLoader({
                    show: false,
                    message: 'Loading...'
                });
                return;
            }
            setIsLoader({
                show: true,
                message: 'PDF Downloading...'
            });
            const wrapper = document.getElementById("pdf");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.remove("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah100vh"));
            wrapper.classList.remove("gg2rem");
            let tempWrapper = wrapper;
            for (const hideEl of tempWrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.add("op0");
            // Convert S3 images to base64 before generating PDF
            await convertAllImagesToBase64(tempWrapper);
            const filename = [
                company.cName,
                company.subscription,
                tab
            ].join(" - ");
            // Generate PDF page by page to avoid page break issues
            const pages = tempWrapper.querySelectorAll('.a4-pdf');
            const pdf = new (0, $15d064020a078dff$export$ba1e2ffc633a60f5)({
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait'
            });
            const pdfWidth = 210;
            const pdfHeight = 297;
            for(let i = 0; i < pages.length; i++){
                const page = pages[i];
                const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(page, {
                    useCORS: true,
                    allowTaint: true,
                    logging: false,
                    scale: 1.2,
                    backgroundColor: '#ffffff'
                });
                const imgData = canvas.toDataURL('image/jpeg', 0.6);
                if (i > 0) pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
            }
            pdf.save(filename + '.pdf');
            // Restore original image URLs after PDF generation
            restoreOriginalImages(tempWrapper);
            wrapper.classList.add("gg2rem");
            for (const page of wrapper.children)page.classList.add("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.remove("op0");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.add("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah100vh"));
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
        } catch (e) {
            console.error(e);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
        }
    };
    const getFileHTML = (file)=>{
        let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
        const key = file.key;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcfs aic w100 px1rem py0-5rem td250 bsbb",
                children: [
                    [
                        "pdf"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z"
                            })
                        ]
                    }) || [
                        "mp4",
                        "webm",
                        "mkv",
                        "ogg",
                        "avi",
                        "mov"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM192 256H96C78.33 256 64 270.3 64 288v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288C224 270.3 209.7 256 192 256zM295.5 271.3L256 296v80l39.52 24.7C306.2 407.4 320 399.7 320 387.1V284.9C320 272.3 306.2 264.6 295.5 271.3z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM224 384c0 17.67-14.33 32-32 32H96c-17.67 0-32-14.33-32-32V288c0-17.67 14.33-32 32-32h96c17.67 0 32 14.33 32 32V384zM320 387.1c0 12.57-13.82 20.23-24.48 13.57L256 376v-80l39.52-24.7C306.2 264.6 320 272.3 320 284.9V387.1z"
                            })
                        ]
                    }) || [
                        "sheet",
                        "xlsx",
                        "xls",
                        "xlsm",
                        "ots",
                        "csv"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM312 224h-240c-8.875 0-16 7.125-16 16v192c0 8.875 7.125 16 16 16h240c8.875 0 16-7.125 16-16v-192C328 231.1 320.9 224 312 224zM136 416h-48v-48h48V416zM136 336h-48V288h48V336zM216 416h-48v-48h48V416zM216 336h-48V288h48V336zM296 416h-48v-48h48V416zM296 336h-48V288h48V336z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM328 432c0 8.875-7.125 16-16 16h-240c-8.875 0-16-7.125-16-16v-192c0-8.875 7.125-16 16-16h240c8.875 0 16 7.125 16 16V432z"
                            })
                        ]
                    }) || [
                        "png",
                        "jpg",
                        "jpeg",
                        "gif",
                        "bmp",
                        "svg",
                        "webp"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM231.1 295.1C229 290.7 224 288 218.7 288s-10.35 2.674-13.31 7.125L160 363.2l-13.35-20.03C143.7 338.7 138.7 336 133.3 336s-10.35 2.674-13.31 7.125l-53.33 80c-3.273 4.908-3.578 11.22-.7949 16.42C68.68 444.8 74.1 448 80 448h224c5.9 0 11.32-3.248 14.11-8.451c2.783-5.201 2.479-11.52-.7949-16.42L231.1 295.1z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 224c17.67 0 32 14.33 32 32S113.7 288 96 288S64 273.7 64 256S78.33 224 96 224zM318.1 439.5C315.3 444.8 309.9 448 304 448h-224c-5.9 0-11.32-3.248-14.11-8.451c-2.783-5.201-2.479-11.52 .7949-16.42l53.33-80C122.1 338.7 127.1 336 133.3 336s10.35 2.674 13.31 7.125L160 363.2l45.35-68.03C208.3 290.7 213.3 288 218.7 288s10.35 2.674 13.31 7.125l85.33 128C320.6 428 320.9 434.3 318.1 439.5z"
                            })
                        ]
                    }) || [
                        "zip",
                        "7z",
                        "gz",
                        "tar.gz"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M160 32H96v32h64V32zM160 160H96v32h64V160zM160 96H96v32h64V96zM256 0v128h128L256 0zM160 224H96l-30.56 116.5c-7.93 39 22.26 75.45 62.83 75.45c40.26 0 70.45-36.3 62.68-75.15L160 224zM144 368h-32C103.2 368 96 360.8 96 352s7.164-16 16-16h32C152.8 336 160 343.2 160 352S152.8 368 144 368z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 32h64v32H96V32zM96 96h64v32H96V96zM96 160h64v32H96V160zM128.3 415.1c-40.56 0-70.76-36.45-62.83-75.45L96 224h64l30.94 116.9C198.7 379.7 168.5 415.1 128.3 415.1z"
                            })
                        ]
                    }) || [
                        "doc",
                        "docx",
                        "docm",
                        "rtf",
                        "odt",
                        "dot",
                        "dotx"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM304.9 240h-23.37c-5.588 0-10.44 3.859-11.69 9.301L246.2 352L218.4 248.9C216.1 243.6 212.2 240 206.8 240H177.2c-5.426 0-10.18 3.641-11.59 8.883L137.8 352L114.1 249.3C112.9 243.9 108 240 102.5 240H79.08c-7.717 0-13.43 7.18-11.69 14.7l42.46 184C111.1 444.1 115.1 448 121.5 448h29.26c5.428 0 10.18-3.641 11.59-8.883L192 329.1l29.61 109.1C223 444.4 227.8 448 233.2 448h29.26c5.588 0 10.44-3.859 11.69-9.305l42.46-184C318.3 247.2 312.6 240 304.9 240z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM274.1 438.7C272.9 444.1 268 448 262.5 448h-29.26c-5.426 0-10.18-3.641-11.59-8.883L192 329.1l-29.61 109.1C160.1 444.4 156.2 448 150.8 448H121.5c-5.588 0-10.44-3.859-11.69-9.305l-42.46-184C65.66 247.2 71.37 240 79.08 240h23.37c5.588 0 10.44 3.859 11.69 9.301L137.8 352L165.6 248.9C167 243.6 171.8 240 177.2 240h29.61c5.426 0 10.18 3.641 11.59 8.883L246.2 352l23.7-102.7C271.1 243.9 275.1 240 281.5 240h23.37c7.717 0 13.43 7.18 11.69 14.7L274.1 438.7z"
                            })
                        ]
                    }) || [
                        "pptx",
                        "pttm",
                        "ppt"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M199.5 240H128C119.2 240 112 247.2 112 256v176C112 440.8 119.2 448 128 448h16C152.8 448 160 440.8 160 432v-40h44c44.53 0 80.23-38.49 75.59-83.95C275.6 268.5 239.3 240 199.5 240zM204 344H160V288h44c15.44 0 28 12.56 28 28S219.4 344 204 344zM256 0v128h128L256 0z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M204 288H160v56h44c15.44 0 28-12.56 28-28S219.4 288 204 288zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM204 392H160v40C160 440.8 152.8 448 144 448H128c-8.836 0-16-7.164-16-16V256c0-8.836 7.164-16 16-16h71.51c39.75 0 76.05 28.52 80.08 68.05C284.2 353.5 248.5 392 204 392z"
                            })
                        ]
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM272 384h-160C103.2 384 96 391.2 96 400S103.2 416 112 416h160c8.836 0 16-7.164 16-16S280.8 384 272 384zM272 320h-160C103.2 320 96 327.2 96 336S103.2 352 112 352h160c8.836 0 16-7.164 16-16S280.8 320 272 320zM272 256h-160C103.2 256 96 263.2 96 272S103.2 288 112 288h160C280.8 288 288 280.8 288 272S280.8 256 272 256z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM272 416h-160C103.2 416 96 408.8 96 400S103.2 384 112 384h160c8.836 0 16 7.164 16 16S280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336S103.2 320 112 320h160c8.836 0 16 7.164 16 16S280.8 352 272 352zM272 288h-160C103.2 288 96 280.8 96 272S103.2 256 112 256h160C280.8 256 288 263.2 288 272S280.8 288 272 288z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: ()=>getViewableURL(file.url),
                        rel: "noopener noreferrer",
                        style: {
                            flex: 1
                        },
                        className: `mx1rem fs1rem cp fw600 bg1 ${fileColor}`,
                        children: file.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        target: "_blank",
                        to: file.url,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            "data-tooltip": "Download",
                            className: `f3 h1rem cp mr1rem ${tab == 'repository' ? '' : 'mla'}`,
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 512 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary",
                                    d: "M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary",
                                    d: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    const handleRedirectDashboard = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
            type: 'User'
        });
        if (res['code'] == '200') {
            await getUser();
            setTabName('');
            setOpenTabs(new Set());
            navigate(`/company/${company['_id']}`);
        }
    };
    const userRoleLower = typeof user?.role === 'string' ? user.role.toLowerCase() : '';
    const createdByRoleLower = typeof user?.createdBy?.role === 'string' ? user.createdBy.role.toLowerCase() : '';
    const userEmailHasCfoDomain = typeof user?.email === 'string' && user.email.includes('@cfocentre.com');
    const companyHasCfoAdvisor = Array.isArray(company?.advisorData) && company.advisorData.some((advisor)=>typeof advisor?.email === 'string' && advisor.email.includes('@cfocentre.com'));
    const createdByRole = company?.creatorId?.createdBy?.role?.toLowerCase();
    const isCreatedByAdvisorOrInvestor = !createdByRole || [
        'investor',
        'advisor'
    ].includes(createdByRole);
    const shouldRenderReferOffer = (userEmailHasCfoDomain && userRoleLower === 'advisor' || companyHasCfoAdvisor || userRoleLower === 'advisor' || createdByRoleLower === 'advisor') && !isCreatedByAdvisorOrInvestor;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            getSidebarHTML(company.modules[sanitiseTab(tab)]),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'manageIndexFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "text-gradient fw600 tac mb1rem fs1-25em",
                            children: [
                                company.cName,
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Section File Manager"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                            children: `${folderNo} ${folderName}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg gg1rem mb2rem fs1rem",
                            children: folderFiles && folderFiles.length > 0 && folderFiles.map((file)=>{
                                return getFileHTML(file);
                            }) || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs1-25rem fw500 gcs1 gce5-md tac",
                                children: "No files have been added yet"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "completeInvestmentReadiness",
                open: modal['open'] == 'completeInvestmentReadiness',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w800px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df my2rem",
                                src: (parcelRequire("iGe5G")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c15 fs1-25rem fw400 tac mb1rem",
                                children: [
                                    "Thank you for completing your Investment Readiness ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " assessment."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1rem fw400 tac mb3rem",
                                children: "We are creating your ResearchAid Reports now. It will be ready in few minutes meantime you can view your Investment Readiness Report."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tac w100 db",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    onClick: (e)=>handleReport(e, company?.['modules']?.[sanitiseTab(tab)]),
                                    to: `#${tab}-report`,
                                    className: "cp w300px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                    children: "View Report"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "superFlowCompletedPopup",
                open: modal['open'] == 'superFlowCompletedPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg5 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w20",
                                src: (parcelRequire("dNazT")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1-5rem fw500 mb3rem",
                                children: "Congratulations. You now have access to the following reports"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df jcc w50",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("blGti")),
                                        alt: "step-1"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("dloz2")),
                                        alt: "step-2"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("1QZ0E")),
                                        alt: "step-3"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("jh3BR")),
                                        alt: "step-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tac w100 db mt1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>handleRedirectDashboard(),
                                    className: "cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                    children: "Let's Go!"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "notGeneratedResearchAidReports",
                open: modal['open'] == 'notGeneratedResearchAidReports',
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr my1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-25rem fw600 c4 my2rem mb2rem tac",
                                    children: "ResearchAid Reports Not Generated!"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("6Ycgy")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mxa",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem fw400 c15 mt3rem mb1rem",
                                            children: [
                                                "We are sorry due to some technical issues ResearchAid Reports are not generated automatically!",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "You can go to ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Dashboard"
                                                }),
                                                " and generate them manually."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tac w100 db",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>window.location.href = `/company/${company['_id']}`,
                                                className: "cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                                children: "Dashboard"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810fd00e44870152$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f057e242d303909$export$2e2bcd8739ae039), {})
        ]
    });
}










var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
function $1720bb8dd8ef814a$export$2e2bcd8739ae039({ className: className = "w2rem ma" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        className: className,
        viewBox: "0 0 30 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.70076 0.320312L0.478516 4.91332L7.70076 9.50633L14.9242 4.91332L22.1465 9.50633L29.3687 4.91332L22.1465 0.320312L14.9242 4.91332L7.70076 0.320312Z",
                fill: "#26BCFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.70076 18.6925L0.478516 14.0994L7.70076 9.50633L14.9242 14.0994L7.70076 18.6925Z",
                fill: "#26BCFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.9242 14.0994L22.1465 9.50633L29.3687 14.0994L22.1465 18.6925L14.9242 14.0994Z",
                fill: "#26BCFC"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.9242 24.8164L7.70077 20.2234L14.9242 15.6304L22.1465 20.2234L14.9242 24.8164Z",
                fill: "#26BCFC"
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




// AI Confidence badge + popover for answer file chips — exact copy of the Allocation Review (autoFillStepper) badge/popover, driven by file.aiMatch saved during auto-fill
const $99875422f9004601$var$AiConfidenceBadge = ({ aiMatch: aiMatch, fileName: fileName })=>{
    const [aiPopover, setAiPopover] = (0, $acw62.useState)(null);
    if (!aiMatch || !aiMatch.matchScore) return null;
    const matchScore = aiMatch.matchScore;
    const reasoning = aiMatch.reasoning || '';
    const scoreVal = matchScore ? Math.round(matchScore * 10) : null;
    const scoreColor = !scoreVal ? '#9CA3AF' : scoreVal >= 8 ? '#16a34a' : scoreVal >= 6 ? '#d97706' : '#dc2626';
    const scoreLabel = !scoreVal ? '' : scoreVal >= 8 ? 'High' : scoreVal >= 6 ? 'Medium' : 'Low';
    const popoverData = {
        fileName: fileName,
        reasoning: reasoning,
        scoreVal: scoreVal,
        scoreColor: scoreColor,
        scoreLabel: scoreLabel,
        isUnallocated: false
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                onMouseEnter: (e)=>{
                    const r = e.currentTarget.getBoundingClientRect();
                    setAiPopover((p)=>p?.pinned ? p : {
                            ...popoverData,
                            x: r.left,
                            y: r.bottom,
                            pinned: false
                        });
                },
                onMouseLeave: ()=>setAiPopover((p)=>p?.pinned ? p : null),
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const r = e.currentTarget.getBoundingClientRect();
                    setAiPopover((p)=>p?.pinned ? null : {
                            ...popoverData,
                            x: r.left,
                            y: r.bottom,
                            pinned: true
                        });
                },
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4,
                    background: scoreColor + '18',
                    border: '1px solid ' + scoreColor + '40',
                    borderRadius: 12,
                    padding: '3px 9px',
                    cursor: 'pointer',
                    flexShrink: 0,
                    marginLeft: '0.5rem',
                    marginRight: '0.25rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("bi4Ns")),
                        alt: "icon",
                        style: {
                            width: 20,
                            height: 20
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 12,
                            fontWeight: 700,
                            color: scoreColor
                        },
                        children: scoreVal || '?'
                    })
                ]
            }),
            aiPopover && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                onClick: ()=>{
                    if (aiPopover.pinned) setAiPopover(null);
                },
                style: {
                    position: 'fixed',
                    inset: 0,
                    zIndex: 9999,
                    pointerEvents: aiPopover.pinned ? 'auto' : 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    onClick: (e)=>e.stopPropagation(),
                    style: {
                        position: 'fixed',
                        top: Math.max(8, aiPopover.y - 280),
                        left: Math.min(Math.max(aiPopover.x - 260, 8), window.innerWidth - 296),
                        width: '280px',
                        background: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                        padding: '1rem',
                        zIndex: 10000,
                        border: '1px solid #E5E7EB'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("bi4Ns")),
                                            alt: "icon",
                                            className: "w20px h20px mr0-5rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontWeight: 700,
                                                fontSize: '13px',
                                                color: '#111827'
                                            },
                                            children: aiPopover.isUnallocated ? 'Why Unallocated?' : 'AI Confidence'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>setAiPopover(null),
                                    style: {
                                        cursor: 'pointer',
                                        color: '#9CA3AF',
                                        fontSize: '14px',
                                        lineHeight: 1
                                    },
                                    children: "\u2715"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                height: '1px',
                                background: '#F3F4F6',
                                marginBottom: '0.75rem'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                marginBottom: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '4px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '12px',
                                                color: '#6B7280'
                                            },
                                            children: aiPopover.isUnallocated ? 'Confidence score' : 'Match score'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                fontSize: '13px',
                                                fontWeight: 700,
                                                color: aiPopover.scoreColor
                                            },
                                            children: [
                                                aiPopover.scoreVal ? aiPopover.scoreVal : "\u2014",
                                                aiPopover.scoreLabel ? " \u2014 " + aiPopover.scoreLabel : ''
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        height: '6px',
                                        borderRadius: '99px',
                                        background: '#F3F4F6',
                                        overflow: 'hidden'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            height: '100%',
                                            width: `${(aiPopover.scoreVal || 0) * 10}%`,
                                            background: aiPopover.scoreColor,
                                            borderRadius: '99px',
                                            transition: 'width 0.4s ease'
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                height: '1px',
                                background: '#F3F4F6',
                                marginBottom: '0.75rem'
                            }
                        }),
                        aiPopover.isUnallocated ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        color: '#6B7280',
                                        marginBottom: '4px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    },
                                    children: "AI Reasoning"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    style: {
                                        fontSize: '12px',
                                        color: '#374151',
                                        lineHeight: 1.5,
                                        margin: aiPopover.suggestedQNo ? '0 0 8px' : 0
                                    },
                                    children: [
                                        aiPopover.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontWeight: 700,
                                                wordBreak: 'break-all'
                                            },
                                            children: aiPopover.fileName
                                        }),
                                        aiPopover.fileName && ' - ',
                                        aiPopover.reasoning || 'Confidence too low to allocate automatically.'
                                    ]
                                }),
                                aiPopover.suggestedQNo && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        background: '#EFF6FF',
                                        border: '1px solid #BFDBFE',
                                        borderRadius: '7px',
                                        padding: '6px 10px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            style: {
                                                fontSize: '11px',
                                                fontWeight: 600,
                                                color: '#1D4ED8',
                                                marginBottom: '2px',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em'
                                            },
                                            children: "Possible match"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            style: {
                                                fontSize: '12px',
                                                color: '#1E40AF',
                                                lineHeight: 1.5,
                                                margin: 0
                                            },
                                            children: [
                                                aiPopover.suggestedQNo,
                                                aiPopover.suggestedSection ? " \u2014 " + aiPopover.suggestedSection : '',
                                                aiPopover.suggestedQuestion ? ': ' + aiPopover.suggestedQuestion : ''
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        color: '#6B7280',
                                        marginBottom: '4px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    },
                                    children: "Why this section?"
                                }),
                                (()=>{
                                    const r = aiPopover.reasoning || 'No reasoning provided.';
                                    const match = r.match(/Claude: (\d+\/10) \| GPT: (\d+\/10) \| Final: (\d+\/10)$/);
                                    const reasoningText = match ? r.replace(match[0], '').trim() : r;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                style: {
                                                    fontSize: '12px',
                                                    color: '#374151',
                                                    lineHeight: 1.5,
                                                    margin: match ? '0 0 8px' : 0
                                                },
                                                children: [
                                                    aiPopover.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontWeight: 700,
                                                            wordBreak: 'break-all'
                                                        },
                                                        children: aiPopover.fileName
                                                    }),
                                                    aiPopover.fileName && ' - ',
                                                    reasoningText
                                                ]
                                            }),
                                            match && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '6px',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            fontSize: '11px',
                                                            fontWeight: 700,
                                                            color: '#151313',
                                                            background: '#F3F4F6',
                                                            borderRadius: '10px',
                                                            padding: '3px 8px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: (parcelRequire("dANvg")),
                                                                alt: "Claude",
                                                                style: {
                                                                    height: 14,
                                                                    width: 'auto'
                                                                }
                                                            }),
                                                            "Claude: ",
                                                            match[1]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            fontSize: '11px',
                                                            fontWeight: 700,
                                                            color: '#151313',
                                                            background: '#F3F4F6',
                                                            borderRadius: '10px',
                                                            padding: '3px 8px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: (parcelRequire("4lWo1")),
                                                                alt: "GPT",
                                                                style: {
                                                                    height: 14,
                                                                    width: 'auto'
                                                                }
                                                            }),
                                                            "GPT: ",
                                                            match[2]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            fontSize: '11px',
                                                            fontWeight: 700,
                                                            color: '#151313',
                                                            background: '#F3F4F6',
                                                            borderRadius: '10px',
                                                            padding: '3px 8px'
                                                        },
                                                        children: [
                                                            "Final: ",
                                                            match[3]
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })()
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $99875422f9004601$export$2e2bcd8739ae039 = $99875422f9004601$var$AiConfidenceBadge;






var $ayMG0 = parcelRequire("ayMG0");
function $a3374f3d4d67b8b1$export$2e2bcd8739ae039({ className: className = "w2rem ma" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        className: className,
        version: "1.1",
        id: "Livello_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 1992.333 1946",
        enableBackground: "new 0 0 1992.333 1946",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("metadata", {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("sfw", {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("slices", {}),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("sliceSourceBounds", {
                                bottomleftorigin: "true",
                                height: "1946",
                                width: "1992.333",
                                x: "-995.333",
                                y: "-949"
                            }),
                            " "
                        ]
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                fill: "#036C70",
                cx: "1019.333",
                cy: "556",
                r: "556"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                fill: "#1A9BA1",
                cx: "1482.667",
                cy: "1065.667",
                r: "509.667"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                fill: "#37C6D0",
                cx: "1088.833",
                cy: "1552.167",
                r: "393.833"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                opacity: "0.1",
                enableBackground: "new",
                d: "M1112,501.79v988.753c-0.23,34.357-21.05,65.222-52.82,78.303 c-10.116,4.279-20.987,6.484-31.97,6.487H695.463c-0.463-7.877-0.463-15.29-0.463-23.167c-0.154-7.734,0.155-15.47,0.927-23.167 c8.48-148.106,99.721-278.782,235.837-337.77v-86.18c-302.932-48.005-509.592-332.495-461.587-635.427 c0.333-2.098,0.677-4.195,1.034-6.289c2.306-15.626,5.556-31.099,9.73-46.333h546.27C1073.964,417.178,1111.822,455.036,1112,501.79 z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                opacity: "0.2",
                enableBackground: "new",
                d: "M980.877,463.333H471.21c-51.486,302.386,151.908,589.256,454.293,640.742 c9.156,1.559,18.35,2.888,27.573,3.986c-143.633,68.11-248.3,261.552-257.196,420.938c-0.771,7.697-1.081,15.433-0.927,23.167 c0,7.877,0,15.29,0.463,23.167c0.836,15.574,2.85,31.063,6.023,46.333h279.39c34.357-0.23,65.222-21.05,78.303-52.82 c4.279-10.115,6.485-20.987,6.487-31.97V548.123C1065.443,501.387,1027.613,463.537,980.877,463.333z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                opacity: "0.2",
                enableBackground: "new",
                d: "M980.877,463.333H471.21c-51.475,302.414,151.95,589.297,454.364,640.773 c6.186,1.053,12.389,2.001,18.607,2.844c-139,73.021-239.543,266-248.254,422.05h284.95c46.681-0.353,84.437-38.109,84.79-84.79 V548.123C1065.489,501.369,1027.631,463.511,980.877,463.333z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                opacity: "0.2",
                enableBackground: "new",
                d: "M934.543,463.333H471.21c-48.606,285.482,130.279,560.404,410.977,631.616 C775.901,1216.384,710.711,1368.301,695.927,1529h238.617c46.754-0.178,84.612-38.036,84.79-84.79V548.123 C1019.308,501.306,981.361,463.359,934.543,463.333z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                id: "SVGID_1_",
                gradientUnits: "userSpaceOnUse",
                x1: "177.0788",
                y1: "1551.0284",
                x2: "842.2545",
                y2: "398.9716",
                gradientTransform: "matrix(1 0 0 -1 0 1948)",
                children: [
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                        offset: "0",
                        style: {
                            stopColor: "#058F92"
                        }
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                        offset: "0.5",
                        style: {
                            stopColor: "#038489"
                        }
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                        offset: "1",
                        style: {
                            stopColor: "#026D71"
                        }
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "url(#SVGID_1_)",
                d: "M84.929,463.333h849.475c46.905,0,84.929,38.024,84.929,84.929v849.475 c0,46.905-38.024,84.929-84.929,84.929H84.929c-46.905,0-84.929-38.024-84.929-84.929V548.262 C0,501.357,38.024,463.333,84.929,463.333z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#FFFFFF",
                d: "M379.331,962.621c-19.903-13.202-36.528-30.777-48.604-51.384c-11.701-21.542-17.533-45.781-16.912-70.288 c-1.042-33.181,10.155-65.586,31.46-91.045c22.388-25.49,51.326-44.366,83.678-54.581c36.871-12.136,75.49-18.116,114.304-17.699 c51.043-1.865,102.015,5.272,150.583,21.082v106.567c-21.103-12.784-44.088-22.166-68.11-27.8 c-26.065-6.392-52.81-9.597-79.647-9.545c-28.3-1.039-56.419,4.913-81.871,17.329c-19.65,8.475-32.392,27.807-32.433,49.206 c-0.08,12.981,4.907,25.481,13.9,34.843c10.622,11.037,23.187,20.021,37.067,26.503c15.444,7.691,38.611,17.916,69.5,30.673 c3.401,1.075,6.716,2.407,9.915,3.985c30.401,11.881,59.729,26.344,87.663,43.229c21.154,13.043,38.908,30.924,51.801,52.171 c13.218,24.085,19.625,51.315,18.533,78.767c1.509,34.066-8.913,67.591-29.468,94.798c-20.488,25.012-47.88,43.446-78.767,53.005 c-36.329,11.387-74.245,16.892-112.312,16.309c-34.154,0.155-68.258-2.635-101.933-8.34c-28.434-4.653-56.182-12.807-82.612-24.279 v-112.358c25.264,18.043,53.489,31.529,83.4,39.847c29.81,9.289,60.798,14.251,92.018,14.734c28.895,1.83,57.739-4.291,83.4-17.699 c17.976-10.144,28.909-29.358,28.449-49.994c0.12-14.359-5.56-28.158-15.753-38.271c-12.676-12.444-27.352-22.671-43.414-30.256 c-18.533-9.267-45.824-21.483-81.871-36.65C432.618,993.951,405.161,979.594,379.331,962.621z"
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






/**
 * AutoFillButton - Triggers auto-fill for a single question, section, or module
 *
 * Props:
 * - companyId: Company ID
 * - moduleType: Module type (e.g., 'repository')
 * - sectionCode: Optional section code (e.g., 'D001')
 * - questionId: Optional question ID for single question fill
 * - qNo: Optional question number
 * - scope: 'question' | 'section' | 'module'
 * - scopeName: Display name for scope (e.g., 'Investor Materials', 'Investment Readiness')
 * - onStart: Callback when auto-fill starts (for progress modal)
 * - onComplete: Callback when auto-fill completes
 * - disabled: Disable the button
 * - size: 'small' | 'medium' - Button size
 */ const $83364f35f447dab2$var$AutoFillButton = ({ companyId: companyId, moduleType: moduleType, moduleId: moduleId = null, sectionCode: sectionCode, questionId: questionId, qNo: qNo, scope: scope = 'question', scopeName: scopeName = '', onStart: onStart, onComplete: onComplete, disabled: disabled = false, size: size = 'small' })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const isAutoFilling = (0, $acw62.useRef)(false);
    const { selectedCompany: company } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const isMinimized = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>!!state.modal.autoFillStatusBarVisible);
    const isMinimizedRef = (0, $acw62.useRef)(false);
    const activePhase = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal.autoFillStatusBarPhase);
    const isAutoFillActive = [
        'uploading',
        'indexing',
        'allocated',
        'filling'
    ].includes(activePhase);
    const progressEvent = 'autoFill:progress';
    // Keep ref in sync so async functions always see latest value
    (0, $acw62.useEffect)(()=>{
        isMinimizedRef.current = isMinimized;
    }, [
        isMinimized
    ]);
    // Listen for socket progress updates (for modal only - not when minimized to status bar)
    (0, $acw62.useEffect)(()=>{
        const handleProgress = (data)=>{
            if (!isAutoFilling.current) return;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                autoFillTotal: data.total || 0,
                autoFillCurrent: data.current || 0,
                autoFillCurrentQuestion: data.currentQuestion || '',
                autoFillCompleted: false
            }));
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on(progressEvent, handleProgress);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off(progressEvent, handleProgress);
        };
    }, [
        dispatch,
        progressEvent
    ]);
    const handleClick = ()=>{
        if (loading || disabled) return;
        if (isAutoFillActive) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill is already running. Please wait for it to complete.');
            return;
        }
        // For single question, auto-fill immediately
        // For section/module, open stepper modal at 'select' step
        if (scope === 'question') startAutoFill();
        else {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: 'intro',
                autoFillModuleName: scope === 'section' ? `${sectionCode || ''}${sectionCode && scopeName ? ' ' : ''}${scopeName || ''}`.trim() || sectionCode || '' : company?.modules?.[moduleType]?.heading || scopeName || moduleType || '',
                autoFillStatusBarPhase: 'select',
                autoFillWithFilling: true,
                autoFillUploadMode: 'files'
            }));
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                autoFillContext: {
                    enabled: true,
                    companyId: companyId,
                    moduleType: moduleType,
                    moduleId: moduleId || null,
                    sectionCode: sectionCode,
                    scope: scope,
                    scopeName: scopeName
                },
                tab: moduleType
            }));
        }
    };
    // File upload and skip logic moved to AutoFillStepperModal (select step)
    const startAutoFill = async ()=>{
        setLoading(true);
        const payload = {
            companyId: companyId,
            moduleType: moduleType,
            ...moduleId ? {
                moduleId: moduleId
            } : {},
            minConfidence: 0.7
        };
        if (scope === 'question' && (questionId || qNo)) {
            payload.questionId = questionId;
            payload.qNo = qNo;
            payload.maxQuestions = 1;
        } else if (scope === 'section' && sectionCode) {
            payload.sectionCode = sectionCode;
            payload.maxQuestions = 50;
        } else payload.maxQuestions = 100;
        // Show progress modal for section/module scope using stepper modal
        if (scope !== 'question') {
            // Only enable socket listener for section/module scope
            isAutoFilling.current = true;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: 'filling',
                autoFillModuleName: company?.modules?.[moduleType]?.heading || moduleType || '',
                autoFillTotal: 0,
                autoFillCurrent: 0,
                autoFillCurrentQuestion: '',
                autoFillCompleted: false,
                autoFillProcessed: 0,
                autoFillAnswered: 0,
                autoFillNeedsReview: 0,
                autoFillSkipped: 0,
                autoFillStatusBarPhase: 'filling'
            }));
            // Also notify parent if callback provided
            onStart?.({
                scope: scope,
                moduleType: moduleType,
                sectionCode: sectionCode,
                total: payload.maxQuestions
            });
            // Small delay to ensure modal is rendered before API call
            await new Promise((resolve)=>setTimeout(resolve, 100));
        }
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill', payload);
            if (response?.code === 200) {
                const { answered: answered, needsReview: needsReview, skipped: skipped, results: results, processed: processed } = response?.body || {};
                // Handle case where question is already answered
                if (processed === 0) {
                    if (scope !== 'question') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Question is already answered');
                    onComplete?.(response?.body);
                    return;
                }
                if (scope === 'question') {
                    // For single question, show toast message
                    const result = results?.[0];
                    let message = '';
                    if (result?.status === 'answered') message = `Answered: ${result.answer} (${Math.round(result.confidence * 100)}% confidence)`;
                    else if (result?.status === 'needs_review') message = `Needs review: ${result.answer} (${Math.round(result.confidence * 100)}% confidence)`;
                    else message = result?.reason === 'no_relevant_docs' ? 'No relevant documents found' : 'Could not auto-fill';
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                } else // For section/module, show results in stepper modal (result step)
                // Don't force-open if user minimized the modal
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    ...isMinimizedRef.current ? {} : {
                        open: 'autoFillStepper'
                    },
                    autoFillStepperPhase: 'result',
                    autoFillCompleted: true,
                    autoFillProcessed: processed || 0,
                    autoFillAnswered: answered || 0,
                    autoFillNeedsReview: needsReview || 0,
                    autoFillSkipped: skipped || 0,
                    autoFillStatusBarPhase: 'completed'
                }));
                onComplete?.(response?.body);
            } else {
                if (scope !== 'question') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    autoFillStatusBarPhase: 'error',
                    autoFillError: response?.message || 'Auto-fill failed'
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Auto-fill failed');
            }
        } catch (error) {
            console.error('Auto-fill error:', error);
            // Close modal on error + set status bar error
            if (scope !== 'question') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: '',
                autoFillStatusBarPhase: 'error',
                autoFillError: 'Auto-fill failed. Please try again.'
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill failed. Please try again.');
        } finally{
            setLoading(false);
            isAutoFilling.current = false;
        }
    };
    const buttonClass = size === 'small' ? 'auto-fill-btn auto-fill-btn-small' : 'auto-fill-btn auto-fill-btn-medium';
    const icon = loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            animation: 'spin 1s linear infinite'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "2.5",
            strokeDasharray: "40",
            strokeDashoffset: "10",
            strokeLinecap: "round"
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 66 56",
        version: "1.1",
        width: "50",
        height: "50",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M 31.233 11.238 C 30.508 12.124, 30.592 12.860, 31.513 13.708 C 32.541 14.654, 33.063 14.629, 33.925 13.590 C 34.738 12.611, 34.665 11.967, 33.645 11.120 C 32.601 10.254, 32.014 10.283, 31.233 11.238 M 32.063 23.474 C 19.120 36.545, 18.766 37.015, 20.225 39.224 C 23.176 43.690, 24.949 42.712, 38.791 28.982 C 46.056 21.775, 52 15.301, 52 14.595 C 52 12.915, 48.748 10, 46.874 10 C 46.066 10, 39.401 16.063, 32.063 23.474 M 43.196 15.298 C 37.400 21.278, 40.114 24.247, 46.065 18.437 C 49.043 15.529, 49.693 14.335, 48.852 13.322 C 47.284 11.433, 46.767 11.614, 43.196 15.298 M 23 15.383 C 23 16.144, 22.055 17.014, 20.899 17.316 C 18.648 17.905, 19.163 20, 21.559 20 C 22.352 20, 23 20.648, 23 21.441 C 23 23.837, 25.095 24.352, 25.684 22.101 C 25.986 20.945, 26.856 20, 27.617 20 C 28.377 20, 29 19.325, 29 18.500 C 29 17.675, 28.325 17, 27.500 17 C 26.675 17, 26 16.325, 26 15.500 C 26 14.675, 25.325 14, 24.500 14 C 23.675 14, 23 14.623, 23 15.383 M 29.005 29.495 C 22.390 36.155, 21.728 37.156, 23.060 38.488 C 24.392 39.821, 25.432 39.109, 32.403 32.098 C 39.568 24.890, 41.075 22, 37.666 22 C 36.997 22, 33.100 25.373, 29.005 29.495 M 46 32 C 46 33.333, 45.333 34, 44 34 C 42.900 34, 42 34.450, 42 35 C 42 35.550, 42.900 36, 44 36 C 45.333 36, 46 36.667, 46 38 C 46 39.100, 46.450 40, 47 40 C 47.550 40, 48 39.283, 48 38.406 C 48 37.530, 48.900 36.577, 50 36.290 C 52.381 35.667, 52.677 34, 50.406 34 C 49.530 34, 48.577 33.100, 48.290 32 C 48.002 30.900, 47.369 30, 46.883 30 C 46.398 30, 46 30.900, 46 32",
            stroke: "none",
            fill: "#6d5cf0",
            "fill-rule": "evenodd"
        })
    });
    const badgeLabel = loading ? 'Filling...' : scope === 'section' ? 'Auto Fill Section' : scope === 'module' ? 'Auto Fill Module' : 'Auto Fill';
    const getScopeName = ()=>{
        if (scopeName) return scopeName;
        if (scope === 'section') return sectionCode || 'this section';
        if (scope === 'module') return moduleType || 'this module';
        return 'this question';
    };
    if (!(0, $6a6b4b5ab5be324d$export$2908142509316f06)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: moduleType == "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `auto-fill-icon-wrap ${disabled || isAutoFillActive ? 'auto-fill-btn-disabled' : ''}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: handleClick,
                    disabled: loading || disabled || isAutoFillActive,
                    className: `auto-fill-btn ${loading ? 'auto-fill-btn-loading' : ''}`,
                    style: {
                        padding: '0.2rem',
                        minWidth: 'unset',
                        background: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    children: icon
                }),
                badgeLabel && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "auto-fill-hover-chip",
                    children: badgeLabel
                })
            ]
        })
    });
};
var $83364f35f447dab2$export$2e2bcd8739ae039 = $83364f35f447dab2$var$AutoFillButton;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/**
 * ReviewQueue - Shows low-confidence auto-filled answers for review
 *
 * Props:
 * - companyId: Company ID
 * - moduleType: Optional module type filter
 * - onReviewComplete: Callback when review actions are taken
 * - isOpen: Whether the modal/panel is open
 * - onClose: Callback to close
 */ const $b7422b5e09e0bec0$var$ReviewQueue = ({ companyId: companyId, moduleType: moduleType, onReviewComplete: onReviewComplete, isOpen: isOpen, onClose: onClose })=>{
    const [items, setItems] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [actionLoading, setActionLoading] = (0, $acw62.useState)(null);
    const fetchReviewQueue = async ()=>{
        if (!companyId) return;
        setLoading(true);
        try {
            let url = `/clarence/auto-fill/review-queue/${companyId}`;
            if (moduleType) url += `?moduleType=${moduleType}`;
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(url);
            if (response?.code === 200) setItems(response?.body?.items || []);
        } catch (error) {
            console.error('Failed to fetch review queue:', error);
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (isOpen) fetchReviewQueue();
    }, [
        isOpen,
        companyId,
        moduleType
    ]);
    const handleReview = async (answerId, action, modifiedAnswer = null)=>{
        setActionLoading(answerId);
        try {
            const payload = {
                answerId: answerId,
                action: action
            };
            if (modifiedAnswer) payload.modifiedAnswer = modifiedAnswer;
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/auto-fill/review', payload);
            if (response?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Answer ${action}d successfully`);
                // Remove item from list
                setItems((prev)=>prev.filter((item)=>item._id !== answerId));
                onReviewComplete?.(response?.body);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Review action failed');
        } catch (error) {
            console.error('Review action failed:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Review action failed');
        } finally{
            setActionLoading(null);
        }
    };
    const getConfidenceClass = (confidence)=>{
        if (confidence < 0.4) return 'low';
        return 'medium';
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "auto-fill-progress-overlay",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "auto-fill-progress-modal",
            style: {
                maxWidth: '600px',
                maxHeight: '80vh',
                overflow: 'auto'
            },
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "review-queue-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Review Queue"
                        }),
                        items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "review-queue-count",
                            children: [
                                items.length,
                                " pending"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: onClose,
                            style: {
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '1.5rem',
                                color: '#6B7280',
                                marginLeft: 'auto'
                            },
                            children: "\xd7"
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "review-queue-empty",
                    children: "Loading..."
                }) : items.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "review-queue-empty",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "No items pending review"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                fontSize: '0.85rem',
                                marginTop: '0.5rem'
                            },
                            children: "All auto-filled answers have been reviewed or had high confidence."
                        })
                    ]
                }) : items.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "review-queue-item",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "review-queue-item-header",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "review-queue-item-qno",
                                        children: item.qNo
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "review-queue-item-confidence",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `confidence-badge ${getConfidenceClass(item.confidence)}`,
                                            children: [
                                                Math.round(item.confidence * 100),
                                                "% confidence"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "review-queue-item-question",
                                children: item.question
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "review-queue-item-answer",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "review-queue-item-answer-label",
                                        children: "Suggested Answer:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "review-queue-item-answer-value",
                                        children: item.suggestedAnswer
                                    })
                                ]
                            }),
                            item.comment && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "review-queue-item-explanation",
                                children: item.comment.replace('[Auto-filled by Clarence] ', '')
                            }),
                            item.sources && item.sources.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "review-queue-item-sources",
                                children: item.sources.map((source, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "review-queue-item-source",
                                        children: source
                                    }, idx))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "review-queue-item-actions",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "review-queue-btn review-queue-btn-reject",
                                        onClick: ()=>handleReview(item._id, 'reject'),
                                        disabled: actionLoading === item._id,
                                        children: "Reject"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "review-queue-btn review-queue-btn-approve",
                                        onClick: ()=>handleReview(item._id, 'approve'),
                                        disabled: actionLoading === item._id,
                                        children: actionLoading === item._id ? 'Processing...' : 'Approve'
                                    })
                                ]
                            })
                        ]
                    }, item._id))
            ]
        })
    });
};
var $b7422b5e09e0bec0$export$2e2bcd8739ae039 = $b7422b5e09e0bec0$var$ReviewQueue;







var $ayMG0 = parcelRequire("ayMG0");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ec7420bd56d3fe49$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
}), 'KeyboardBackspace');






const $9689410d708ead36$var$DisclaimerModal = ({ handleClose: handleClose, subTitle: subTitle = "This report is for guidance only.", content: content = "This Report has been prepared by Diligensia for the exclusive use of the named client. It is based on information provided as at the date of issue and is intended solely to assist in identifying risks and opportunities. This report was generated by AI and may be inaccurate.  You are urged to check all report content. Diligentsia accepts no responsibility or liability for any errors, omissions, or delays, nor for any actions taken in reliance on this report. The contents do not constitute legal or financial advice, and professional advice should always be sought. This report may not be relied upon by any third party to whom the report is shown and Diligensia accepts no duty of care or liability to any third party who may obtain access to it.", modalType: modalType = 'DisclaimerAIReportModal' })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        customStyle: {
            padding: '0px 0rem 2rem',
            maxWidth: '500px !important'
        },
        onCloseHandler: handleClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    onClick: handleClose,
                    style: {
                        backgroundImage: `url(${(parcelRequire("hgL6Y"))})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        height: '90px',
                        marginBottom: '1rem'
                    },
                    className: "df aic jcfs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "c15 tal fs1-5rem df aic jcfs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ec7420bd56d3fe49$export$2e2bcd8739ae039), {
                                className: "c2 ml4rem mr1rem"
                            }),
                            "Disclaimer"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px4rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c15 tal mt3rem",
                            children: subTitle
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs11px ttj my1rem",
                            style: {
                                color: '#505050'
                            },
                            children: content
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                style: {
                                    width: '250px'
                                },
                                customClassName: "mt1rem bg2",
                                text: 'Understood',
                                onClick: handleClose,
                                btnType: "dark"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "tac mt1rem",
                            style: {
                                color: '#505050',
                                fontSize: '13px'
                            },
                            children: [
                                "See our full",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    clas: true,
                                    style: {
                                        color: '#4A67FF',
                                        fontSize: '13px',
                                        marginLeft: '2px'
                                    },
                                    to: "/terms-conditions",
                                    children: "terms and conditions"
                                }),
                                ", and",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    clas: true,
                                    style: {
                                        color: '#4A67FF',
                                        fontSize: '13px',
                                        marginLeft: '2px'
                                    },
                                    to: "/policy",
                                    children: "policies"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $9689410d708ead36$export$2e2bcd8739ae039 = $9689410d708ead36$var$DisclaimerModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");









var $e893be82a1a3691c$var$FileManager = function FileManager(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#a)",
                fill: "#4A67FF",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#b)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M27.458 7.237a.749.749 0 0 0-.748-.748h-9.122V5.132h2.433a.749.749 0 0 0 .748-.749V3.207A3.21 3.21 0 0 0 17.562 0H7.746c-.857 0-1.662.334-2.268.94a3.185 3.185 0 0 0-.939 2.267v13.494c0 .413.335.748.749.748h9.12v1.419h-2.431a.748.748 0 0 0-.75.748l.22.384c5.053 1 7.829 3.5 9.597 3.5l3.207.5c.857 0 1.663-.334 2.268-.94.606-.605.94-1.41.94-2.267V7.237Zm-9.896-5.74c.943 0 1.71.767 1.71 1.71v.428H10.953v-.428c0-.628-.181-1.215-.495-1.71h7.104ZM6.036 15.952V3.207c0-.457.178-.886.501-1.209a1.712 1.712 0 0 1 2.919 1.21v1.175c0 .414.335.749.748.749h5.887v1.357h-.934a.749.749 0 0 0-.748.748v4.604h-1.195a.749.749 0 0 0 0 1.498h1.195v2.613H6.036ZM18 21.5c-.943 0-2.094 0-3.565-.707l-1.71-.428h8.32v.428c0 .628.18 1.215.494 1.71L18 21.5Zm7.46.502a1.712 1.712 0 0 1-2.92-1.21v-1.175a.749.749 0 0 0-.747-.75h-5.887V13.34h3.237l-.593.593a.749.749 0 0 0 1.059 1.059l1.871-1.872a.749.749 0 0 0 0-1.059l-1.871-1.87a.748.748 0 1 0-1.059 1.058l.593.593h-3.237V7.986h10.055v12.807a1.7 1.7 0 0 1-.5 1.209Z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M11.239 11.844h-1.123a.749.749 0 1 0 0 1.497h1.123a.749.749 0 1 0 0-1.497ZM7.186 12.06a.755.755 0 0 0 0 1.06c.142.137.333.22.531.22.195 0 .39-.083.528-.221a.743.743 0 0 0 0-1.06c-.277-.277-.778-.277-1.06 0Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M31.045 21.778c-.37-.752-1.274-1.152-2.303-1.019-.62.08-1.213.376-1.735.637l-.268.133a160.185 160.185 0 0 0-4.701 2.381c-.352-1.032-1.737-1.98-4.128-2.822-.77-.271-1.594-.581-2.466-.91-2.73-1.026-5.31-1.997-6.585-1.924-3.258.186-6.077 2.294-7.762 3.554a.75.75 0 0 0-.275.795l1.962 7.319a.75.75 0 0 0 1.148.425l.009-.006c.962-.659 1.543-1.057 2.547-1.076 1.876-.037 4.722.825 7.231 1.586 2.318.702 3.852 1.15 4.854 1.15.211.003.422-.023.626-.079 1.794-.522 9.162-5.722 11.19-7.74 1.113-1.107.83-2.05.656-2.404Zm-1.714 1.341c-2.097 2.086-9.258 6.986-10.552 7.363-.078.023-.42.075-1.578-.2-.858-.204-1.921-.526-3.047-.867-2.557-.775-5.448-1.651-7.551-1.651l-.145.001c-1.033.02-1.78.333-2.495.765l-1.56-5.824c1.574-1.165 3.967-2.808 6.541-2.955.96-.051 3.738.991 5.972 1.832.84.316 1.71.643 2.495.92 2.192.772 3.2 1.596 3.216 1.935.004.088-.177.403-1.047.81-.447.166-.9.2-1.58.055-.699-.15-1.438-.468-2.152-.777-1.045-.451-2.032-.878-3.023-.878a.75.75 0 1 0 0 1.5c.68 0 1.53.367 2.429.755.78.338 1.589.687 2.433.867 1.028.22 1.768.125 2.417-.117a.725.725 0 0 0 .063-.024c.438-.171.837-.408 1.258-.659.23-.136.468-.278.732-.421 1.526-.83 3.784-1.966 5.236-2.67.093-.045.188-.093.286-.142.415-.207.885-.443 1.254-.49.43-.056.71.081.765.191.042.086-.022.338-.367.681Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h32v32H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(4)",
                            d: "M0 0h24v24H0z"
                        })
                    })
                ]
            })
        ]
    });
};
$e893be82a1a3691c$var$FileManager.defaultProps = {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $e893be82a1a3691c$var$Delete = function Delete(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.552 6.89a.722.722 0 0 0-.722.723v8.082a1.387 1.387 0 0 1-1.452 1.307H7.615a1.386 1.386 0 0 1-1.452-1.307V7.613a.722.722 0 1 0-1.444 0v8.082a2.83 2.83 0 0 0 2.896 2.751h5.763a2.83 2.83 0 0 0 2.896-2.75V7.612a.722.722 0 0 0-.722-.722ZM16.278 4.721h-2.89V3.277a.722.722 0 0 0-.721-.722H8.333a.722.722 0 0 0-.722.722V4.72H4.722a.722.722 0 0 0 0 1.445h11.556a.722.722 0 0 0 0-1.445Zm-7.222 0V4h2.888v.722H9.056Z",
                fill: "#F14D4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.78 14.114V9.058a.722.722 0 1 0-1.444 0v5.056a.722.722 0 1 0 1.444 0ZM12.663 14.114V9.058a.722.722 0 0 0-1.444 0v5.056a.722.722 0 1 0 1.444 0Z",
                fill: "#F14D4D"
            })
        ]
    });
};
$e893be82a1a3691c$var$Delete.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $e893be82a1a3691c$var$Copy = function Copy(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M5.59 18h6.82a2.585 2.585 0 0 0 2.556-2.25h.445A2.592 2.592 0 0 0 18 13.16V5.59A2.592 2.592 0 0 0 15.41 3H8.59A2.592 2.592 0 0 0 6 5.59V6h-.41A2.592 2.592 0 0 0 3 8.59v6.82A2.592 2.592 0 0 0 5.59 18ZM7.5 5.59c0-.601.489-1.09 1.09-1.09h6.82c.601 0 1.09.489 1.09 1.09v7.57c0 .601-.489 1.09-1.09 1.09H15V8.59A2.592 2.592 0 0 0 12.41 6H7.5v-.41Zm-3 3c0-.601.489-1.09 1.09-1.09h6.82c.601 0 1.09.489 1.09 1.09v6.82c0 .601-.489 1.09-1.09 1.09H5.59c-.601 0-1.09-.489-1.09-1.09V8.59Z",
            fill: "#4A67FF"
        })
    });
};
$e893be82a1a3691c$var$Copy.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $e893be82a1a3691c$var$Downloads = function Downloads(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14.667 18H6.333c-.89 0-1.727-.347-2.357-.976A3.311 3.311 0 0 1 3 14.667v-.834a.833.833 0 1 1 1.667 0v.834c0 .445.173.863.488 1.178.315.315.733.488 1.178.488h8.334c.445 0 .863-.173 1.178-.488.315-.315.488-.733.488-1.178v-.834a.833.833 0 1 1 1.667 0v.834c0 .89-.347 1.727-.976 2.357-.63.63-1.467.976-2.357.976ZM10.5 14.667a.831.831 0 0 1-.582-.237l-.002-.002-.002-.002-.001-.002-.002-.001-3.334-3.334a.833.833 0 0 1 1.179-1.178l1.91 1.91V3.833a.833.833 0 1 1 1.667 0v7.988l1.911-1.91a.833.833 0 0 1 1.179 1.178l-3.334 3.334-.002.001v.001l-.001.001-.002.001-.002.003a.827.827 0 0 1-.258.172h-.001a.828.828 0 0 1-.323.065Z",
            fill: "#4A67FF"
        })
    });
};
$e893be82a1a3691c$var$Downloads.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $e893be82a1a3691c$var$Send = function Send(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.493 5.031c-.358 0-.693-.175-.898-.468L9.81 3.437a2.406 2.406 0 0 0-1.974-1.03H3.5a2.406 2.406 0 0 0-2.406 2.405v11.375c0 .638.253 1.25.704 1.702a2.41 2.41 0 0 0 1.702.705h14a2.41 2.41 0 0 0 1.702-.705 2.41 2.41 0 0 0 .704-1.701v-8.75a2.41 2.41 0 0 0-.704-1.702A2.41 2.41 0 0 0 17.5 5.03h-6.007Zm0 1.313H17.5a1.096 1.096 0 0 1 1.094 1.093v8.75a1.095 1.095 0 0 1-1.094 1.094h-14a1.095 1.095 0 0 1-1.094-1.093V4.813c0-.604.49-1.094 1.094-1.094h4.337c.357 0 .693.175.897.468l.785 1.126a2.405 2.405 0 0 0 1.974 1.03Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.192 11.008H7.808a.808.808 0 0 0 0 1.615h5.384a.808.808 0 0 0 0-1.615Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m10.471 10.23 1.582 1.583-1.582 1.583a.807.807 0 1 0 1.142 1.141l2.153-2.153a.806.806 0 0 0 0-1.142l-2.153-2.154a.807.807 0 1 0-1.142 1.142Z",
                fill: "#4A67FF"
            })
        ]
    });
};
$e893be82a1a3691c$var$Send.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};



const $e893be82a1a3691c$var$DeduperReport = ({ moveDeduperFile: moveDeduperFile, modalType: modalType, profileClass: profileClass, dupCheck: dupCheck, modal: modal, onClickDeduperAuditLog: onClickDeduperAuditLog, tab: tab, company: company, getViewableURL: getViewableURL, handleEditDispatch: handleEditDispatch, reloadModule: reloadModule })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const removeDuplicate = (key, index)=>{
        if (!dupCheck?.deduperResult?.[key]) return;
        const updatedDeduperResult = {
            ...dupCheck.deduperResult
        };
        updatedDeduperResult[key] = [
            ...updatedDeduperResult[key]
        ];
        updatedDeduperResult[key].splice(index, 1);
        if (updatedDeduperResult[key].length === 0) delete updatedDeduperResult[key];
        dispatch((0, $e0a7c253e2df808f$export$607aedf5e5b112cd)({
            ...dupCheck,
            deduperResult: updatedDeduperResult
        }));
    };
    const deleteDeduperFile = async (key, questionId, file, index)=>{
        let directorId = undefined;
        if (tab.includes('directors-questionnaire')) {
            const dqs = tab.split('_');
            if (dqs.length > 1) directorId = dqs[1];
        }
        let res = {};
        if (tab.includes('directors-questionnaire')) res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: file,
            questionId: questionId,
            companyId: company._id,
            directorId: directorId
        });
        else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: file,
            questionId: questionId,
            companyId: company._id
        });
        if (!res || res['code'] != 200) return;
        if (tab) await reloadModule(tab);
        removeDuplicate(key, index);
    };
    const handleConfirm = async ()=>{
        setLoading(true);
        await moveDeduperFile({
            payload: dupCheck.selectedDeuper
        });
        setLoading(false);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const getDuplicationCheckEntryHTML = (key)=>{
        const files = dupCheck.deduperResult[key];
        let module = company.modules[tab];
        if (module) module = JSON.parse(JSON.stringify(module));
        if (Array.isArray(files)) {
            const filteredData = files.filter((f)=>f != null && f != undefined);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: filteredData && filteredData.length > 1 && filteredData.map((checkFile, index)=>{
                    console.log('checkFile', checkFile);
                    let file = checkFile.file;
                    let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                    const url = file.location;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                className: "df aifs jcfs",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "fs1rem fw600 bg1 df aifs jcfs",
                                        style: {
                                            width: "25%"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            onClick: ()=>getViewableURL(url),
                                            className: `pl2rem cp tdu fs12rem pr bg44 fw500 ${fileColor} fileManageFileName w100 tal`,
                                            children: file.originalname
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "frs-td fs1rem fw400 bg1 df aifs jcfs",
                                        style: {
                                            width: "25%"
                                        },
                                        children: tab == 'repository' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mr1rem w100",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "c2 tal fw400",
                                                        children: checkFile.qNo && checkFile.qNo
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "fs1rem fw400 bg1",
                                        style: {
                                            width: "25%",
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "c2 tal fw400",
                                            children: `${checkFile?.qNo || ""} ${checkFile?.questionId?.qDescription ? ` - ${checkFile.questionId.qDescription}` : ""}`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        className: "fs1rem fw600 df aic w100 jcc",
                                        style: {
                                            width: "25%",
                                            minHeight: "54px"
                                        },
                                        children: [
                                            tab == 'repository' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($e893be82a1a3691c$var$Send, {
                                                        "data-tooltip": "Cut",
                                                        className: "mr1rem cp",
                                                        onClick: ()=>handleEditDispatch({
                                                                key: key,
                                                                fileName: file.title,
                                                                from: "deduper",
                                                                actionType: "move",
                                                                fileData: file,
                                                                index: index
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($e893be82a1a3691c$var$Copy, {
                                                        "data-tooltip": "Copy",
                                                        className: "mr1rem cp",
                                                        onClick: ()=>handleEditDispatch({
                                                                key: key,
                                                                fileName: file.title,
                                                                from: "deduper",
                                                                actionType: "copy",
                                                                fileData: file,
                                                                index: index
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: "df",
                                                target: "_blank",
                                                to: url,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e893be82a1a3691c$var$Downloads, {
                                                    "data-tooltip": "Download",
                                                    className: `f3 cp mr1rem ${tab == 'repository' ? '' : 'mla'}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($e893be82a1a3691c$var$Delete, {
                                                className: "cp",
                                                "data-tooltip": "Delete",
                                                onClick: ()=>deleteDeduperFile(key, checkFile.questionId, file, index)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            filteredData.length === index + 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: "2rem",
                                    marginBottom: "2rem"
                                }
                            }) : null
                        ]
                    }, `getDuplicationCheckEntryHTML-${index}${checkFile.file.key}`);
                })
            });
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            modalCardClasses: "maw1000px mah80",
            girlComponent: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    position: 'relative'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("4bpAo")),
                    alt: "deduper",
                    className: "animateRight"
                })
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcfs aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                className: "c15 fw600 tal df aic mb0-5rem fs1-25em",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($e893be82a1a3691c$var$FileManager, {
                                        className: "mr1rem"
                                    }),
                                    " Deduper Report"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: onClickDeduperAuditLog,
                            className: "cp tac c1 bg5 c15 br20px px1-5rem py0-5rem fw500",
                            children: "Log"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                    className: "w100 fw400 fs13px c37 df jcfs aic mt1-5rem",
                    children: [
                        "Checked by: \xa0",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: `w2rem h2rem jcc aic dib wsn mr0-5rem`,
                            children: dupCheck?.['checkBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: dupCheck?.['checkBy']?.['profile'],
                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                "data-tooltip": dupCheck?.['checkBy']?.['firstName'] ? dupCheck?.['checkBy']?.['firstName'] + " " + (dupCheck?.['checkBy']?.['lastName'] ? dupCheck?.['checkBy']?.['lastName'] : "") : "?"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("kBFDN")),
                                className: `w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`,
                                "data-tooltip": dupCheck?.['checkBy']?.['firstName'] ? dupCheck?.['checkBy']?.['firstName'] + " " + (dupCheck?.['checkBy']?.['lastName'] ? dupCheck?.['checkBy']?.['lastName'] : "") : "?"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: `df jcc ttc aic br100 fw600 c36`,
                            children: `${dupCheck?.['checkBy']?.['firstName'] ? `${dupCheck?.['checkBy']?.['firstName']} ${dupCheck?.['checkBy']?.['lastName'] ? dupCheck?.['checkBy']?.['lastName'] : ""}` : ""}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "c36",
                            children: [
                                "\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dupCheck?.['checkAt']).format('lll')
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: "16px",
                        marginBottom: "16px"
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg0-5rem mb2rem fs1rem w100 oxh",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "fis bcc w100",
                            style: {
                                tableLayout: "fixed",
                                maxWidth: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "db",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "tal fs14px fw400 c37",
                                                style: {
                                                    width: "25%",
                                                    minWidth: '232px',
                                                    wordBreak: "break-word",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: "File Name"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "tal fs14px fw400 c37",
                                                style: {
                                                    width: "25%",
                                                    minWidth: '232px',
                                                    wordBreak: "break-word",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: "Section"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "tal fs14px fw400 c37",
                                                style: {
                                                    width: "25%",
                                                    minWidth: '232px',
                                                    wordBreak: "break-word",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: "Allocate Section"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs14px fw400 c37",
                                                style: {
                                                    width: "25%",
                                                    minWidth: '232px',
                                                    wordBreak: "break-word",
                                                    overflowWrap: "anywhere"
                                                },
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    className: "mah300px oya db w100 oxh lightScrollbar",
                                    children: dupCheck?.deduperResult && Object.keys(dupCheck.deduperResult).map(getDuplicationCheckEntryHTML)
                                })
                            ]
                        }),
                        (!dupCheck.deduperResult || Object.keys(dupCheck.deduperResult).length == 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc jcc aic m2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("8S7PI")),
                                    alt: "fileManagement"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw600 mt1rem tac c15 op80",
                                    children: "No files found"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df w100 fdr jcc ",
                    children: [
                        modal['from'] == 'deduperHistory' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'deduperReportHistory'
                                })),
                            className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttu bsbb tac mb1rem df jcc aic mr1rem",
                            children: "Back to List"
                        }),
                        dupCheck.selectedDeuper && dupCheck.selectedDeuper.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            loading: loading,
                            onClick: handleConfirm,
                            text: "Confirm Allocation",
                            btnType: "warning",
                            customClassName: "maw300px"
                        }) : null
                    ]
                })
            ]
        })
    });
};
var $e893be82a1a3691c$export$2e2bcd8739ae039 = $e893be82a1a3691c$var$DeduperReport;



function $22a1fae7337b63c9$export$2e2bcd8739ae039() {
    const dataRoomSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "DATAROOM",
        initialState: {
            syncing: false,
            message: null
        },
        reducers: {
            SET_DATAROOM: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            },
            SET_SYNC_DATAROOM_STATUS: (state, action)=>{
                return {
                    ...state,
                    syncing: action.payload.syncing
                };
            }
        }
    });
    return dataRoomSlice.reducer;
}
const $22a1fae7337b63c9$export$96f23038668b4320 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("DATAROOM/SET_DATAROOM");
const $22a1fae7337b63c9$export$7a71beeecbd46cbc = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("DATAROOM/SET_SYNC_DATAROOM_STATUS");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");






const $7f5e4159f4b2fdb7$var$isObjectId = (str)=>typeof str === 'string' && /^[0-9a-fA-F]{24}$/.test(str);
const $7f5e4159f4b2fdb7$var$FILE_TYPE_COLORS = {
    pdf: '#DD4040',
    docx: '#4A67FF',
    doc: '#4A67FF',
    xlsx: '#09B255',
    xls: '#09B255',
    pptx: '#FB7A27',
    ppt: '#FB7A27'
};
const $7f5e4159f4b2fdb7$var$getExt = (name = '')=>(name.split('.').pop() || '').toLowerCase();
const $7f5e4159f4b2fdb7$var$FileTypeBadge = ({ name: name })=>{
    const ext = $7f5e4159f4b2fdb7$var$getExt(name).toUpperCase();
    const color = $7f5e4159f4b2fdb7$var$FILE_TYPE_COLORS[ext.toLowerCase()] || '#5E5F66';
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        style: {
            fontSize: '10px',
            fontWeight: 700,
            color: '#fff',
            background: color,
            padding: '2px 5px',
            borderRadius: '3px',
            flexShrink: 0
        },
        children: ext || 'FILE'
    });
};
const $7f5e4159f4b2fdb7$var$UserAvatar = ({ user: user, profileClass: profileClass })=>{
    if (!user) return null;
    const initials = user.firstName ? user.firstName[0] + (user.lastName?.[0] || '') : '?';
    const tooltip = user.firstName ? `${user.firstName} ${user.lastName || ''}`.trim() : '?';
    return user.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: user.profile,
        className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
        "data-tooltip": tooltip,
        alt: tooltip
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `wsn w2rem h2rem df jcc aic br100 ${profileClass}`,
        "data-tooltip": tooltip,
        children: initials
    });
};
// Build { qNo: questionText } from company.modules (old dashboard) + tempModule (new dashboard)
const $7f5e4159f4b2fdb7$var$buildQNoMap = (company, tempModule)=>{
    const map = {};
    const allSections = [
        ...Object.values(company?.modules || {}).flatMap((mod)=>mod.sections || []),
        ...tempModule?.sections || []
    ];
    for (const sec of allSections){
        for (const q of sec.questions || [])if (q.qNo && q.qDescription) map[q.qNo.toUpperCase()] = q.qDescription;
        for (const sub of Object.values(sec.subFolders || {})){
            for (const q of sub.questions || [])if (q.qNo && q.qDescription) map[q.qNo.toUpperCase()] = q.qDescription;
            for (const nested of Object.values(sub.subFolders || {})){
                for (const q of nested.questions || [])if (q.qNo && q.qDescription) map[q.qNo.toUpperCase()] = q.qDescription;
            }
        }
    }
    return map;
};


const $7f5e4159f4b2fdb7$var$FileReportHistory = ({ modalType: modalType, reportHistories: reportHistories, setReportHistories: setReportHistories, setFileReport: setFileReport, setCloneImportResult: setCloneImportResult, setCurrentScore: setCurrentScore, company: company, profileClass: profileClass, onRollbackComplete: onRollbackComplete, moduleType: moduleType, moduleId: moduleId, moduleName: moduleName })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const tempModule = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation?.tempModule);
    const reduxModal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const qNoMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$7f5e4159f4b2fdb7$var$buildQNoMap(company, tempModule), [
        company,
        tempModule
    ]);
    const [expandedIds, setExpandedIds] = (0, $acw62.useState)(new Set());
    const [selectedIds, setSelectedIds] = (0, $acw62.useState)(new Set());
    const [expandedData, setExpandedData] = (0, $acw62.useState)({}); // { [reportId]: { report, aiAnswers } }
    const [loadingIds, setLoadingIds] = (0, $acw62.useState)(new Set());
    const [rollingBack, setRollingBack] = (0, $acw62.useState)(false);
    const markRolledBack = (reportIds)=>{
        if (setReportHistories) setReportHistories((prev)=>prev.map((r)=>reportIds.includes(String(r._id)) ? {
                    ...r,
                    rolledBack: true
                } : r));
        setExpandedData((prev)=>{
            const next = {
                ...prev
            };
            reportIds.forEach((id)=>{
                if (next[id]) next[id] = {
                    ...next[id],
                    report: {
                        ...next[id].report,
                        rolledBack: true
                    }
                };
            });
            return next;
        });
    };
    const removeAnswerFromLogs = (reportId, answerId)=>{
        setExpandedData((prev)=>{
            if (!prev[reportId]) return prev;
            const updatedAnswers = prev[reportId].aiAnswers.map((a)=>String(a._id) === String(answerId) ? {
                    ...a,
                    rolledBack: true
                } : a);
            return {
                ...prev,
                [reportId]: {
                    ...prev[reportId],
                    aiAnswers: updatedAnswers
                }
            };
        });
    };
    const markModuleAnswersRolledBack = (reportId, moduleType)=>{
        setExpandedData((prev)=>{
            if (!prev[reportId]) return prev;
            const updatedAnswers = prev[reportId].aiAnswers.map((a)=>a.moduleType === moduleType ? {
                    ...a,
                    rolledBack: true
                } : a);
            return {
                ...prev,
                [reportId]: {
                    ...prev[reportId],
                    aiAnswers: updatedAnswers
                }
            };
        });
    };
    const toggleExpand = async (report)=>{
        const id = report._id;
        const next = new Set(expandedIds);
        if (next.has(id)) {
            next.delete(id);
            setExpandedIds(next);
            return;
        }
        next.add(id);
        setExpandedIds(next);
        if (expandedData[id]) return;
        setLoadingIds((prev)=>new Set(prev).add(id));
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReport/${id}`);
            const fullReport = res?.body || report;
            let aiAnswers = [];
            if (fullReport.runType === 'autoFill') {
                const logsRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/clarence/auto-fill/logs/${id}`);
                if (logsRes?.body?.items) aiAnswers = logsRes.body.items;
            }
            setExpandedData((prev)=>({
                    ...prev,
                    [id]: {
                        report: fullReport,
                        aiAnswers: aiAnswers
                    }
                }));
        } finally{
            setLoadingIds((prev)=>{
                const s = new Set(prev);
                s.delete(id);
                return s;
            });
        }
    };
    const toggleSelect = (id)=>{
        const next = new Set(selectedIds);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        setSelectedIds(next);
    };
    const handleRollback = async (reportIds)=>{
        setRollingBack(true);
        try {
            for (const reportId of reportIds)await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rollback-run', {
                fileReportId: reportId
            });
            markRolledBack(reportIds.map(String));
            setSelectedIds(new Set());
            if (onRollbackComplete) onRollbackComplete();
        } finally{
            setRollingBack(false);
        }
    };
    // Issue 32 — resume an interrupted run from whatever step it died at, INSIDE the normal autofill stepper UI:
    // rebuild the same Redux context a live run would have, then open the stepper at the failed step. The stepper's
    // resume driver (autoFillContext.resume) fires the right backend call and its progress bars take over —
    // allocation resumes only pending files; the fill skips questions already attempted (and human-answered ones).
    const [resumingIds, setResumingIds] = (0, $acw62.useState)(new Set());
    const resumeRun = async (report)=>{
        const id = String(report._id);
        setResumingIds((prev)=>new Set(prev).add(id));
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReport/${id}`);
            const fullReport = res?.body;
            const run = fullReport?.autoFillRun;
            const scope = run?.scope;
            if (!scope?.moduleType) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("This run cannot be resumed \u2014 no saved scope", 'error');
                return;
            }
            const companyId = String(report.companyId || company?._id || '');
            const step = run?.step || 'allocation';
            const entries = Object.values(fullReport?.importResult || {});
            const allocated = entries.filter((e)=>e?.section?.some?.((s)=>s && !String(s).includes('XXX'))).length;
            const currentScore = entries.length ? Math.round(allocated / entries.length * 100) : 0;
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: fullReport,
                tab: scope.moduleType,
                currentScore: currentScore,
                autoFillContext: {
                    enabled: !!scope.fromAutoFill,
                    companyId: companyId,
                    moduleType: scope.moduleType,
                    moduleId: scope.moduleId || null,
                    sectionCode: scope.sectionCode || null,
                    scope: scope.sectionCode ? 'section' : 'module',
                    scopeName: scope.moduleType,
                    extraModules: scope.extraModules || [],
                    generateReports: !!scope.generateReports,
                    resume: {
                        fileReportId: id,
                        step: step,
                        src: scope.src || 'company'
                    }
                }
            }));
            // Map the run's step to the stepper phase it died at: allocation progress bar, allocation review, or filling
            const phase = step === 'allocation' ? 'indexing' : [
                'allocated',
                'attaching'
            ].includes(step) ? 'allocation' : 'filling';
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: phase,
                autoFillModuleName: scope.moduleType === 'repository' ? 'Data Repository' : scope.moduleType,
                autoFillWithFilling: !!scope.fromAutoFill,
                autoFillTotal: 0,
                autoFillCurrent: 0,
                autoFillCurrentQuestion: '',
                autoFillCompleted: false,
                autoFillProcessed: 0,
                autoFillAnswered: 0,
                autoFillNeedsReview: 0,
                autoFillSkipped: 0,
                autoFillStatusBarVisible: false,
                autoFillStatusBarPhase: phase === 'allocation' ? 'allocated' : phase
            }));
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Resume failed \u2014 please try again", 'error');
        } finally{
            setResumingIds((prev)=>{
                const next = new Set(prev);
                next.delete(id);
                return next;
            });
        }
    };
    // A run that is still live (Allocating…/Filling…) doesn't need resuming — the backend job is already running and
    // emitting socket progress. Continue just reopens the stepper at the current phase and lets the stepper's global
    // socket listeners pick the live progress back up — the same thing maximizing the minimized bar does. Crucially it
    // must NOT set autoFillContext.resume, or the stepper's resume driver would fire a duplicate backend fill call.
    const continueRun = async (report)=>{
        const id = String(report._id);
        setResumingIds((prev)=>new Set(prev).add(id));
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReport/${id}`);
            const fullReport = res?.body;
            const run = fullReport?.autoFillRun;
            const scope = run?.scope;
            if (!scope?.moduleType) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("This run cannot be reopened \u2014 no saved scope", 'error');
                return;
            }
            const companyId = String(report.companyId || company?._id || '');
            const step = run?.step || 'allocation';
            const entries = Object.values(fullReport?.importResult || {});
            const allocated = entries.filter((e)=>e?.section?.some?.((s)=>s && !String(s).includes('XXX'))).length;
            const currentScore = entries.length ? Math.round(allocated / entries.length * 100) : 0;
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                fileReport: fullReport,
                tab: scope.moduleType,
                currentScore: currentScore,
                autoFillContext: {
                    enabled: !!scope.fromAutoFill,
                    companyId: companyId,
                    moduleType: scope.moduleType,
                    moduleId: scope.moduleId || null,
                    sectionCode: scope.sectionCode || null,
                    scope: scope.sectionCode ? 'section' : 'module',
                    scopeName: scope.moduleType,
                    extraModules: scope.extraModules || [],
                    generateReports: !!scope.generateReports
                }
            }));
            // Map the live run's step to the stepper phase it is currently in
            const phase = step === 'allocation' ? 'indexing' : [
                'allocated',
                'attaching'
            ].includes(step) ? 'allocation' : 'filling';
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'autoFillStepper',
                autoFillStepperPhase: phase,
                autoFillModuleName: scope.moduleType === 'repository' ? 'Data Repository' : scope.moduleType,
                autoFillWithFilling: !!scope.fromAutoFill,
                autoFillCompleted: false,
                autoFillStatusBarVisible: false,
                autoFillStatusBarPhase: phase === 'allocation' ? 'allocated' : phase
            }));
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Could not reopen this run \u2014 please try again", 'error');
        } finally{
            setResumingIds((prev)=>{
                const next = new Set(prev);
                next.delete(id);
                return next;
            });
        }
    };
    // ── Expanded: File Import ──────────────────────────────────────
    const renderFileImportExpanded = (report, isRolledBack)=>{
        const importResult = report.importResult || {};
        const entries = Object.values(importResult);
        const files = entries.map((e)=>e.file).filter(Boolean);
        // Invert: build question-centric map { qNo -> [file, ...] }
        // Each entry has file + section (array of qNos like ['D001.1', 'D001.5'])
        const qNoToFiles = {};
        entries.forEach((entry)=>{
            const qNos = entry.section?.filter((s)=>s && !s.includes('XXX')) || [];
            if (qNos.length === 0) {
                // unallocated file
                if (!qNoToFiles['__unallocated__']) qNoToFiles['__unallocated__'] = [];
                qNoToFiles['__unallocated__'].push({
                    file: entry.file,
                    matchScore: entry.matchScore
                });
            } else qNos.forEach((qNo)=>{
                if (!qNoToFiles[qNo]) qNoToFiles[qNo] = [];
                qNoToFiles[qNo].push({
                    file: entry.file,
                    matchScore: entry.matchScore
                });
            });
        });
        const allocatedQNos = Object.keys(qNoToFiles).filter((k)=>k !== '__unallocated__').sort();
        const unallocatedFiles = qNoToFiles['__unallocated__'] || [];
        // Count FILES that got a question (not questions) — a file counts once even when allocated to multiple questions
        const allocatedCount = entries.filter((e)=>e.file && (e.section || []).some((s)=>s && !s.includes('XXX'))).length;
        const unallocatedCount = unallocatedFiles.length;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                padding: '1rem',
                borderTop: '1px solid #DDE2F2',
                background: '#F5F6F9'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: '0.5rem',
                        marginBottom: '1rem'
                    },
                    children: [
                        {
                            label: 'Questions',
                            value: allocatedQNos.length,
                            color: '#002D63',
                            bg: '#F0F2FD'
                        },
                        {
                            label: 'Files allocated',
                            value: allocatedCount,
                            color: '#09B255',
                            bg: '#F0F2FD'
                        },
                        {
                            label: 'Unallocated',
                            value: unallocatedCount,
                            color: '#F0AE0D',
                            bg: '#F0F2FD'
                        },
                        {
                            label: 'Files imported',
                            value: files.length,
                            color: '#4A67FF',
                            bg: '#F0F2FD'
                        }
                    ].map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                background: s.bg,
                                borderRadius: '8px',
                                padding: '0.5rem',
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '1.25rem',
                                        fontWeight: 700,
                                        color: s.color
                                    },
                                    children: s.value
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '10px',
                                        color: s.color,
                                        opacity: 0.8
                                    },
                                    children: s.label
                                })
                            ]
                        }, s.label))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($7f5e4159f4b2fdb7$var$ModuleAccordion, {
                    title: report.moduleName || 'Repository',
                    subtitle: `${allocatedCount} allocated \xb7 ${unallocatedCount} unallocated`,
                    onRollback: isRolledBack ? null : ()=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rollback-run', {
                            fileReportId: report._id
                        }).then(()=>{
                            markRolledBack([
                                String(report._id)
                            ]);
                            if (onRollbackComplete) onRollbackComplete();
                        }),
                    rollingBack: rollingBack,
                    children: [
                        allocatedQNos.map((qNo)=>{
                            const qFiles = qNoToFiles[qNo];
                            const questionName = qNoMap[qNo.toUpperCase()];
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: '0.65rem 0.75rem',
                                    borderBottom: '1px solid #DDE2F2'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '0.5rem',
                                            marginBottom: '6px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    flex: 1,
                                                    display: 'flex',
                                                    alignItems: 'flex-start'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontSize: '11px',
                                                            fontWeight: 700,
                                                            color: '#5E5F66'
                                                        },
                                                        children: qNo
                                                    }),
                                                    questionName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontSize: '12px',
                                                            fontWeight: 700,
                                                            color: '#151313',
                                                            marginLeft: '6px'
                                                        },
                                                        children: questionName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '10px',
                                                    fontWeight: 600,
                                                    padding: '2px 8px',
                                                    borderRadius: '20px',
                                                    background: 'rgba(9,178,85,0.12)',
                                                    color: '#09B255',
                                                    flexShrink: 0
                                                },
                                                children: isRolledBack ? 'Rolled back' : 'Allocated'
                                            }),
                                            !isRolledBack && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rollback-run', {
                                                        fileReportId: report._id,
                                                        answerId: qFiles[0]?.answerId,
                                                        qNo: qNo
                                                    }).then(()=>{
                                                        markRolledBack([
                                                            String(report._id)
                                                        ]);
                                                        if (onRollbackComplete) onRollbackComplete();
                                                    }),
                                                disabled: rollingBack,
                                                title: "Rollback this question",
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '26px',
                                                    height: '26px',
                                                    fontSize: '14px',
                                                    color: '#FC7785',
                                                    background: 'rgba(252,119,133,0.12)',
                                                    border: '1px solid rgba(252,119,133,0.35)',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    flexShrink: 0,
                                                    marginLeft: '4px'
                                                },
                                                children: "\u21BA"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            padding: '0.4rem 0.6rem',
                                            background: '#F0F2FD',
                                            borderRadius: '6px',
                                            border: '1px solid #DDE2F2'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    marginBottom: '4px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontSize: '10px',
                                                            fontWeight: 700,
                                                            color: '#4A67FF'
                                                        },
                                                        children: "\u2191 FILES ALLOCATED"
                                                    }),
                                                    qFiles[0]?.matchScore && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            fontSize: '10px',
                                                            color: '#4A67FF'
                                                        },
                                                        children: [
                                                            Math.round(qFiles[0].matchScore * 100),
                                                            "% match"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            qFiles.map((f, fi)=>f.file && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        marginTop: fi > 0 ? '3px' : 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($7f5e4159f4b2fdb7$var$FileTypeBadge, {
                                                            name: f.file.originalname
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                color: '#505050'
                                                            },
                                                            children: f.file.originalname
                                                        })
                                                    ]
                                                }, fi))
                                        ]
                                    })
                                ]
                            }, qNo);
                        }),
                        unallocatedFiles.map((f, i)=>f.file && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: '0.65rem 0.75rem',
                                    borderBottom: '1px solid #DDE2F2'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7f5e4159f4b2fdb7$var$FileTypeBadge, {
                                                name: f.file.originalname
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '12px',
                                                    color: '#5E5F66',
                                                    flex: 1
                                                },
                                                children: f.file.originalname
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '10px',
                                                    fontWeight: 600,
                                                    padding: '2px 8px',
                                                    borderRadius: '20px',
                                                    background: 'rgba(240,174,13,0.15)',
                                                    color: '#F0AE0D',
                                                    flexShrink: 0
                                                },
                                                children: "Unallocated"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: '11px',
                                            color: '#AAACB5',
                                            marginTop: '4px'
                                        },
                                        children: "No matching questions found for this file"
                                    })
                                ]
                            }, `unalloc-${i}`))
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($7f5e4159f4b2fdb7$var$ImportedFilesList, {
                    files: files
                })
            ]
        });
    };
    // ── Expanded: AutoFill ─────────────────────────────────────────
    const renderAutoFillExpanded = (report, aiAnswers, isRolledBack)=>{
        const summary = report.autoFillSummary || {};
        const modules = summary.modules || [];
        const aiPct = summary.processed > 0 ? Math.round(summary.answered / summary.processed * 100) : 0;
        const importedFiles = Object.values(report.importResult || {}).map((e)=>e.file).filter(Boolean);
        const fileUrlMap = {};
        importedFiles.forEach((f)=>{
            if (f.originalname && f.location) fileUrlMap[f.originalname] = f.location;
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                padding: '1rem',
                borderTop: '1px solid #DDE2F2',
                background: '#F5F6F9'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: '0.5rem',
                        marginBottom: '1rem'
                    },
                    children: [
                        {
                            label: 'Processed',
                            value: summary.processed || 0,
                            color: '#002D63',
                            bg: '#F0F2FD'
                        },
                        {
                            label: 'Answered',
                            value: summary.answered || 0,
                            color: '#09B255',
                            bg: '#F0F2FD'
                        },
                        {
                            label: 'AI answered',
                            value: `${aiPct}%`,
                            color: '#4A67FF',
                            bg: '#F0F2FD'
                        },
                        {
                            label: 'Skipped',
                            value: summary.skipped || 0,
                            color: '#5E5F66',
                            bg: '#F0F2FD'
                        }
                    ].map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                background: s.bg,
                                borderRadius: '8px',
                                padding: '0.5rem',
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '1.25rem',
                                        fontWeight: 700,
                                        color: s.color
                                    },
                                    children: s.value
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '10px',
                                        color: s.color,
                                        opacity: 0.8
                                    },
                                    children: s.label
                                })
                            ]
                        }, s.label))
                }),
                modules.map((mod)=>{
                    const modAnswers = aiAnswers.filter((a)=>a.moduleType === mod.moduleType);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)($7f5e4159f4b2fdb7$var$ModuleAccordion, {
                        title: mod.moduleType,
                        subtitle: `${mod.answered} answered \xb7 ${mod.skipped} skipped`,
                        onRollback: isRolledBack ? null : ()=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rollback-run', {
                                fileReportId: report._id,
                                moduleTypes: [
                                    mod.moduleType
                                ]
                            }).then(()=>{
                                markModuleAnswersRolledBack(String(report._id), mod.moduleType);
                                if (onRollbackComplete) onRollbackComplete();
                            }),
                        rollingBack: rollingBack,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                padding: '0 0.75rem 0.75rem'
                            },
                            children: modAnswers.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    textAlign: 'center',
                                    color: '#AAACB5',
                                    fontSize: '12px',
                                    padding: '1.5rem'
                                },
                                children: "No AI answers found for this module."
                            }) : modAnswers.map((a, i)=>{
                                const isAnswered = a.status === 'answered' || !!a.suggestedAnswer;
                                const conf = a.confidence;
                                const statusStyle = isAnswered ? {
                                    bg: 'rgba(9,178,85,0.08)',
                                    color: '#09B255',
                                    border: 'rgba(9,178,85,0.3)',
                                    dot: '#15D757'
                                } : {
                                    bg: '#F7F8FE',
                                    color: '#AAACB5',
                                    border: '#DDE2F2',
                                    dot: '#D9D9D9'
                                };
                                const confStyle = conf >= 0.7 ? {
                                    color: '#09B255',
                                    bg: 'rgba(9,178,85,0.08)'
                                } : conf >= 0.4 ? {
                                    color: '#F0AE0D',
                                    bg: 'rgba(240,174,13,0.1)'
                                } : {
                                    color: '#AAACB5',
                                    bg: '#F0F2FD'
                                };
                                const isAnswerRolledBack = isRolledBack || !!a.rolledBack;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        background: '#fff',
                                        borderRadius: '10px',
                                        padding: '0.75rem 0.875rem',
                                        marginBottom: '0.5rem',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
                                        borderLeft: `3px solid ${isAnswerRolledBack ? '#D9D9D9' : statusStyle.dot}`
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '0.625rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        flex: 1,
                                                        lineHeight: '1.5'
                                                    },
                                                    children: [
                                                        a.qNo && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '10px',
                                                                fontWeight: 700,
                                                                color: '#AAACB5',
                                                                marginRight: '6px',
                                                                letterSpacing: '0.03em',
                                                                textTransform: 'uppercase'
                                                            },
                                                            children: a.qNo
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '12.5px',
                                                                fontWeight: 600,
                                                                color: '#151313'
                                                            },
                                                            children: a.question
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        fontSize: '10px',
                                                        fontWeight: 600,
                                                        padding: '3px 9px',
                                                        borderRadius: '20px',
                                                        flexShrink: 0,
                                                        background: isAnswerRolledBack ? '#F0F2FD' : statusStyle.bg,
                                                        color: isAnswerRolledBack ? '#5E5F66' : statusStyle.color,
                                                        border: `1px solid ${isAnswerRolledBack ? '#DDE2F2' : statusStyle.border}`
                                                    },
                                                    children: isAnswerRolledBack ? 'Rolled back' : isAnswered ? 'Answered' : 'Skipped'
                                                }),
                                                a._id && !isAnswerRolledBack && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rollback-run', {
                                                            fileReportId: report._id,
                                                            answerId: a._id
                                                        }).then(()=>{
                                                            removeAnswerFromLogs(String(report._id), a._id);
                                                            if (onRollbackComplete) onRollbackComplete();
                                                        }),
                                                    disabled: rollingBack,
                                                    title: "Rollback this answer",
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '26px',
                                                        height: '26px',
                                                        fontSize: '14px',
                                                        color: '#FC7785',
                                                        background: 'rgba(252,119,133,0.12)',
                                                        border: '1px solid rgba(252,119,133,0.35)',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        flexShrink: 0
                                                    },
                                                    children: "\u21BA"
                                                })
                                            ]
                                        }),
                                        (a.suggestedAnswer || a.comment) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                fontSize: '12px',
                                                color: '#505050',
                                                marginTop: '6px',
                                                lineHeight: '1.55',
                                                background: '#F7F8FE',
                                                borderRadius: '6px',
                                                padding: '7px 10px',
                                                borderLeft: `2px solid ${statusStyle.dot}`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        marginBottom: '3px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "10",
                                                            height: "10",
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M10 2a8 8 0 100 16A8 8 0 0010 2zm0 3v5l3.5 3.5-1.1 1.1L8 10.5V5h2z",
                                                                fill: "#AAACB5"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '10px',
                                                                fontWeight: 600,
                                                                color: '#AAACB5',
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.04em'
                                                            },
                                                            children: "AI answer"
                                                        }),
                                                        conf != null && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                marginLeft: 'auto',
                                                                fontSize: '10px',
                                                                fontWeight: 500,
                                                                color: confStyle.color,
                                                                background: confStyle.bg,
                                                                padding: '1px 6px',
                                                                borderRadius: '10px'
                                                            },
                                                            children: [
                                                                Math.round(conf * 100),
                                                                "% confidence"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                a.suggestedAnswer && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontWeight: 600,
                                                        marginBottom: a.comment ? '4px' : 0
                                                    },
                                                    children: a.suggestedAnswer
                                                }),
                                                a.comment && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        fontSize: '11px',
                                                        color: '#5E5F66',
                                                        lineHeight: '1.5'
                                                    },
                                                    children: a.comment
                                                })
                                            ]
                                        }),
                                        a.sources?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '4px',
                                                marginTop: '6px'
                                            },
                                            children: a.sources.map((src, si)=>{
                                                const url = fileUrlMap[src];
                                                const chipStyle = {
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '3px',
                                                    fontSize: '10px',
                                                    background: '#F0F2FD',
                                                    color: '#4A67FF',
                                                    borderRadius: '5px',
                                                    padding: '2px 7px',
                                                    fontWeight: 500,
                                                    border: '1px solid #DDE2F2',
                                                    cursor: 'pointer',
                                                    textDecoration: 'none'
                                                };
                                                const inner = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "9",
                                                            height: "9",
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            style: {
                                                                flexShrink: 0
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M4 4h5v2H6v8h8v-3h2v5H4V4zm7-1h6v6h-2V6.414l-5.293 5.293-1.414-1.414L13.586 5H11V3z",
                                                                fill: "currentColor"
                                                            })
                                                        }),
                                                        src
                                                    ]
                                                });
                                                return url ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: url,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    style: chipStyle,
                                                    children: inner
                                                }, si) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        ...chipStyle,
                                                        cursor: 'default'
                                                    },
                                                    children: inner
                                                }, si);
                                            })
                                        })
                                    ]
                                }, i);
                            })
                        })
                    }, mod.moduleType);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($7f5e4159f4b2fdb7$var$ImportedFilesList, {
                    files: importedFiles
                })
            ]
        });
    };
    const selectedCount = selectedIds.size;
    const handleCloseModal = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    // Header quick actions — launch a new import / auto-fill straight from the history page.
    // Same context + stepper dispatches the module pages use (Filing Manager menu / AutoFillButton).
    const isRunActive = [
        'uploading',
        'indexing',
        'allocated',
        'filling'
    ].includes(reduxModal?.autoFillStatusBarPhase);
    const launchImport = (mode)=>{
        if (isRunActive) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill is already running. Please wait for it to complete.');
            return;
        }
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                enabled: false,
                companyId: company?._id,
                moduleType: moduleType,
                moduleId: moduleId || null,
                sectionCode: null,
                scope: 'module',
                scopeName: ''
            },
            tab: moduleType
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'select',
            autoFillStatusBarPhase: 'select',
            autoFillWithFilling: false,
            autoFillUploadMode: mode
        }));
    };
    const launchAutoFill = ()=>{
        if (isRunActive) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill is already running. Please wait for it to complete.');
            return;
        }
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                enabled: true,
                companyId: company?._id,
                moduleType: moduleType,
                moduleId: moduleId || null,
                scope: 'module',
                scopeName: moduleName || moduleType
            },
            tab: moduleType
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'intro',
            autoFillModuleName: moduleName || moduleType || '',
            autoFillStatusBarPhase: 'select',
            autoFillWithFilling: true,
            autoFillUploadMode: 'files'
        }));
    };
    // Full-page overlay (same pattern as the autofill stepper) — header bar with close at top right, scrollable body
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: reduxModal?.open === modalType,
        onClose: handleCloseModal,
        className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc bg1 w100vw h100vh bsbb",
            style: {
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcsb w100 bsbb bg1",
                    style: {
                        padding: '0.65rem 2rem',
                        borderBottom: '1px solid #DDE2F2',
                        flexShrink: 0,
                        boxShadow: '0 1px 3px rgba(21,19,19,0.04)'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcc",
                                    style: {
                                        width: '46px',
                                        height: '46px',
                                        background: '#F0F2FD',
                                        borderRadius: '12px',
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "#4A67FF",
                                        strokeWidth: "1.8",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M3 12a9 9 0 1 0 2.64-6.36L3 8"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                points: "3 3 3 8 8 8"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                points: "12 7 12 12 15.5 14"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc ml1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "c15 fw600 fs20px mb0rem tal",
                                            style: {
                                                lineHeight: 1.25,
                                                textAlign: 'left',
                                                alignSelf: 'flex-start'
                                            },
                                            children: "Filing Assistant History"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c28 fs13px fw400",
                                            style: {
                                                alignSelf: 'flex-start'
                                            },
                                            children: "Every import and auto-fill run for this module \u2014 expand a row for details, resume or roll back"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic",
                            style: {
                                gap: '0.65rem',
                                flexShrink: 0
                            },
                            children: [
                                moduleType && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("bx0Zp")),
                                            alt: "Clarence",
                                            className: "pen",
                                            style: {
                                                height: '88px',
                                                flexShrink: 0,
                                                marginRight: '0.25rem'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr menuHover",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    className: "cp fs13px fw600 bg1 bg3-hover c3 c1-hover bw1px bo3 bss br50px px1rem df jcc aic td300",
                                                    style: {
                                                        height: '40px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("6zDJh")),
                                                            alt: "filing-assistant-icon",
                                                            className: "mr0-5rem"
                                                        }),
                                                        "Filing Manager"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "menu op0 pen zi10 bg1 br10px shadow pa r0 df fdc",
                                                    style: {
                                                        minWidth: '240px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            onClick: launchAutoFill,
                                                            className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic mb0rem",
                                                            style: {
                                                                borderTopLeftRadius: '10px',
                                                                borderTopRightRadius: '10px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    viewBox: "0 0 14 14",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                            clipPath: "url(#clip0_frh_autofill)",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M3.52723 2.82108L4.74129 3.48554C4.89715 3.5703 4.95458 3.76444 4.86981 3.9203C4.83973 3.97499 4.79598 4.01874 4.74129 4.04882L3.52723 4.71054C3.47254 4.74061 3.42879 4.78436 3.39872 4.83905L2.73426 6.05311C2.6495 6.20897 2.45536 6.2664 2.2995 6.18163C2.24481 6.15155 2.20106 6.1078 2.17098 6.05311L1.50926 4.83905C1.47919 4.78436 1.43544 4.74061 1.38075 4.71054L0.166686 4.04882C0.0108263 3.96405 -0.0465956 3.76991 0.03817 3.61405C0.0682482 3.55936 0.111998 3.51561 0.166686 3.48554L1.38075 2.82108C1.43544 2.791 1.47919 2.74725 1.50926 2.69257L2.17372 1.48124C2.25848 1.32538 2.45536 1.26796 2.61122 1.35546C2.66317 1.38554 2.70692 1.42929 2.737 1.48124L3.40145 2.69257C3.42879 2.74725 3.47254 2.791 3.52723 2.82108Z",
                                                                                    fill: "#4A67FF"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.5643 9.30204L13.7784 9.96649C13.9343 10.0513 13.9917 10.2454 13.9069 10.4013C13.8768 10.4559 13.8331 10.4997 13.7784 10.5298L12.5643 11.1942C12.5097 11.2243 12.4659 11.2681 12.4358 11.3227L11.7714 12.5368C11.6866 12.6927 11.4897 12.7501 11.3339 12.6653C11.2792 12.6352 11.2354 12.5915 11.2054 12.5368L10.5464 11.32C10.5163 11.2653 10.4725 11.2216 10.4179 11.1915L9.2038 10.527C9.04794 10.4423 8.99051 10.2454 9.07528 10.0895C9.10536 10.0348 9.14911 9.9911 9.2038 9.96102L10.4179 9.29657C10.4725 9.26649 10.5163 9.22274 10.5464 9.16805L11.2108 7.95672C11.2956 7.80087 11.4925 7.74344 11.6483 7.82821C11.703 7.85829 11.7468 7.90204 11.7768 7.95672L12.4413 9.17079C12.4659 9.22821 12.5097 9.27196 12.5643 9.30204Z",
                                                                                    fill: "#4A67FF"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M7.30855 1.43355L8.10425 1.86831C8.20542 1.92573 8.2437 2.05425 8.18901 2.15542C8.16987 2.19097 8.1398 2.21831 8.10425 2.24019L7.30855 2.67495C7.273 2.69409 7.24292 2.72417 7.22378 2.75972L6.78902 3.55542C6.73159 3.65659 6.60308 3.69487 6.50191 3.64019C6.46636 3.62105 6.43901 3.59097 6.41714 3.55542L5.98237 2.75972C5.96323 2.72417 5.93316 2.69409 5.89761 2.67495L5.10191 2.24019C5.00073 2.1855 4.96245 2.05698 5.01714 1.95308C5.03628 1.91753 5.06636 1.88745 5.10191 1.86831L5.89761 1.43355C5.93316 1.41441 5.96323 1.38433 5.98237 1.34878L6.41714 0.553078C6.47456 0.451906 6.60308 0.413624 6.70425 0.468312C6.7398 0.487453 6.76714 0.517531 6.78902 0.553078L7.22378 1.34878C7.24292 1.38433 7.273 1.41441 7.30855 1.43355Z",
                                                                                    fill: "#4A67FF"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M13.6881 1.79629L12.5643 0.672464C12.1487 0.256839 11.4733 0.254105 11.0549 0.66973C11.0549 0.66973 11.0549 0.66973 11.0522 0.672464L1.03345 10.6939C0.617823 11.1096 0.615089 11.785 1.03345 12.2033L2.15728 13.3272C2.5729 13.7428 3.24829 13.7455 3.66665 13.3272L13.6881 3.30567C14.1038 2.89004 14.1038 2.21465 13.6881 1.79629ZM9.78071 5.58614L8.77446 4.57989L11.7413 1.61036L12.7475 2.61661L9.78071 5.58614Z",
                                                                                    fill: "#4A67FF"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                id: "clip0_frh_autofill",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                    width: "14",
                                                                                    height: "14",
                                                                                    fill: "white"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "c3 ml0-5rem",
                                                                    children: [
                                                                        "Auto Fill",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fs10px c12 ml0-5rem",
                                                                            children: "All Questions"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            onClick: ()=>launchImport('files'),
                                                            className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic mb0rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "#4A67FF",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                                            points: "14 2 14 8 20 8"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                                                            x1: "12",
                                                                            y1: "18",
                                                                            x2: "12",
                                                                            y2: "12"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                                            points: "9 15 12 12 15 15"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "ml0-5rem",
                                                                    children: "Import Files"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            onClick: ()=>launchImport('folders'),
                                                            className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic mb0rem",
                                                            style: {
                                                                borderBottomLeftRadius: '10px',
                                                                borderBottomRightRadius: '10px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "#4A67FF",
                                                                    strokeWidth: "1.8",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                                                                            x1: "12",
                                                                            y1: "17",
                                                                            x2: "12",
                                                                            y2: "11"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                                            points: "9 14 12 11 15 14"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "ml0-5rem",
                                                                    children: "Import Folders"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                width: '1px',
                                                height: '26px',
                                                background: '#DDE2F2',
                                                margin: '0 0.25rem'
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    onClick: handleCloseModal,
                                    className: "df aic jcc cp br100 td300 bg19 bg16-hover",
                                    title: "Close",
                                    style: {
                                        width: '40px',
                                        height: '40px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8754c86021516b$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: '1.05rem',
                                            color: '#151313'
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 bsbb bg1",
                    style: {
                        flex: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        padding: '1.5rem 2rem'
                    },
                    children: [
                        reportHistories.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic jcc",
                            style: {
                                padding: '5rem 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcc br100",
                                    style: {
                                        width: '84px',
                                        height: '84px',
                                        background: '#F0F2FD'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "36",
                                        height: "36",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "#4A67FF",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        opacity: "0.7",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M3 12a9 9 0 1 0 2.64-6.36L3 8"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                points: "3 3 3 8 8 8"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                points: "12 7 12 12 15.5 14"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15 fs1-25rem fw500 mt1-5rem mb0-5rem",
                                    children: "No runs yet"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c28 fs14px tac",
                                    style: {
                                        maxWidth: '380px'
                                    },
                                    children: "Import files or run Auto-Fill on this module and every run will show up here \u2014 with its results, resume and rollback options."
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '0.4rem 1rem',
                                        marginBottom: '0.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 28px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 13%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Run By"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 13%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 9%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 11%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Module"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 5%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Files"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 9%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Answered"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 8%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Allocated"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 8%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Unallocated"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 9%',
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600
                                            },
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: 1,
                                                fontSize: '12px',
                                                color: '#151313',
                                                fontWeight: 600,
                                                textAlign: 'center'
                                            },
                                            children: "Actions"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                flex: '0 0 32px'
                                            }
                                        })
                                    ]
                                }),
                                reportHistories.map((report)=>{
                                    const id = report._id;
                                    const isExpanded = expandedIds.has(id);
                                    const isSelected = selectedIds.has(id);
                                    const isLoading = loadingIds.has(id);
                                    const data = expandedData[id];
                                    const isAutoFill = report.runType === 'autoFill';
                                    // Module chips
                                    const mods = report.autoFillSummary?.modules || [];
                                    const moduleChips = mods.length === 0 ? report.moduleName ? [
                                        report.moduleName
                                    ] : [] : mods.length === 1 ? [
                                        mods[0].moduleType
                                    ] : [
                                        `${mods[0].moduleType} +${mods.length - 1}`
                                    ];
                                    // Files count
                                    const filesCount = report.importResultCount || 0;
                                    // Answered/Questions count
                                    const answeredLabel = isAutoFill ? report.autoFillSummary?.answered != null ? `${report.autoFillSummary.answered} answered` : "\u2014" : report.allocatedQuestionCount != null ? `${report.allocatedQuestionCount} questions` : "\u2014";
                                    // Status
                                    const isRolledBack = !!report.rolledBack;
                                    const isComplete = report.status === 'Complete';
                                    const isInProgress = report.status === 'In Progress';
                                    // Issue 32 — 'interrupted' = run died midway (crash/restart/cancel), resumable; 'allocating'/'filling' = live right now.
                                    // 'allocating' + a post-allocation step means allocation finished but fill never ran — also resumable.
                                    const runStatus = report.autoFillRun?.status;
                                    const runStep = report.autoFillRun?.step;
                                    const isResuming = resumingIds.has(String(id));
                                    const isAwaitingFill = runStatus === 'allocating' && [
                                        'allocated',
                                        'attaching',
                                        'attached'
                                    ].includes(runStep);
                                    // A run still executing on the server (Allocating…/Filling…) — offer Continue (reopen the live
                                    // stepper), not Resume (which re-derives remaining work for a dead run).
                                    const isLive = !isRolledBack && (runStatus === 'filling' || runStatus === 'allocating' && runStep === 'allocation');
                                    const canResume = !isRolledBack && !isResuming && !isLive && (runStatus === 'interrupted' || runStatus === 'cancelled' || isAwaitingFill);
                                    const stepLabel = runStep === 'allocation' ? 'File Allocation' : runStep === 'attaching' || runStep === 'attached' ? 'Attaching Files' : runStep === 'other-modules' ? 'Other Modules' : 'Filing Answers';
                                    // Run by user
                                    const runByUser = report.importBy;
                                    const runByName = runByUser?.firstName ? `${runByUser.firstName} ${runByUser.lastName || ''}`.trim() : null;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            boxShadow: '0 0 13px #32325d20',
                                            borderRadius: '10px',
                                            marginBottom: '0.65rem',
                                            overflow: 'hidden',
                                            background: isSelected ? '#F0F2FD' : '#fff'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                onClick: ()=>toggleExpand(report),
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '0.65rem 1rem',
                                                    cursor: 'pointer'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 28px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        },
                                                        onClick: (e)=>e.stopPropagation(),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: isSelected,
                                                            onChange: ()=>toggleSelect(id),
                                                            style: {
                                                                accentColor: '#4A67FF',
                                                                width: '15px',
                                                                height: '15px',
                                                                cursor: 'pointer'
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            flex: '0 0 13%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px',
                                                            minWidth: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($7f5e4159f4b2fdb7$var$UserAvatar, {
                                                                user: runByUser,
                                                                profileClass: profileClass
                                                            }),
                                                            runByName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '12px',
                                                                    color: '#151313',
                                                                    fontWeight: 500,
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                children: runByName
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            flex: '0 0 13%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '12px',
                                                                    color: '#151313',
                                                                    fontWeight: 500
                                                                },
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report.importDate).format('MMM D, YYYY h:mm A')
                                                            }),
                                                            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '11px',
                                                                    color: '#AAACB5',
                                                                    marginLeft: '6px'
                                                                },
                                                                children: "Loading..."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 9%'
                                                        },
                                                        children: isAutoFill ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                color: '#09B255',
                                                                background: 'rgba(9,178,85,0.12)',
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap'
                                                            },
                                                            children: "\u272A Auto-fill"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                color: '#4A67FF',
                                                                background: '#F0F2FD',
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap'
                                                            },
                                                            children: "\u2191 File Import"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 11%',
                                                            minWidth: 0,
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                            gap: '4px'
                                                        },
                                                        children: moduleChips.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '12px',
                                                                color: '#AAACB5'
                                                            },
                                                            children: "\u2014"
                                                        }) : moduleChips.map((chip, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '10px',
                                                                    fontWeight: 700,
                                                                    color: '#4A67FF',
                                                                    background: '#F0F2FD',
                                                                    border: '1px solid #DDE2F2',
                                                                    padding: '2px 7px',
                                                                    borderRadius: '20px',
                                                                    whiteSpace: 'nowrap',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.3px'
                                                                },
                                                                children: chip
                                                            }, i))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 5%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '12px',
                                                                color: '#5E5F66'
                                                            },
                                                            children: filesCount > 0 ? `${filesCount}` : "\u2014"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 9%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '12px',
                                                                color: '#09B255',
                                                                fontWeight: 500
                                                            },
                                                            children: answeredLabel
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 8%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '12px',
                                                                color: '#09B255',
                                                                fontWeight: 500
                                                            },
                                                            children: report.allocatedFileCount != null ? report.allocatedFileCount : "\u2014"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 8%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '12px',
                                                                color: '#F0AE0D',
                                                                fontWeight: 500
                                                            },
                                                            children: report.allocatedFileCount != null && report.importResultCount != null ? report.importResultCount - report.allocatedFileCount : "\u2014"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 9%'
                                                        },
                                                        children: isRolledBack ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap',
                                                                background: '#F0F2FD',
                                                                color: '#5E5F66'
                                                            },
                                                            children: "Rolled back"
                                                        }) : isResuming || runStatus === 'filling' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap',
                                                                background: '#F0F2FD',
                                                                color: '#4A67FF'
                                                            },
                                                            children: isResuming ? "Resuming\u2026" : "Filling\u2026"
                                                        }) : runStatus === 'allocating' && runStep === 'allocation' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap',
                                                                background: '#F0F2FD',
                                                                color: '#4A67FF'
                                                            },
                                                            children: "Allocating\u2026"
                                                        }) : isAwaitingFill ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            title: "Allocation finished \u2014 auto-fill has not run yet",
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap',
                                                                background: 'rgba(240,174,13,0.15)',
                                                                color: '#F0AE0D'
                                                            },
                                                            children: "Awaiting fill"
                                                        }) : runStatus === 'interrupted' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            title: `Interrupted at ${stepLabel}`,
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap',
                                                                background: 'rgba(240,174,13,0.15)',
                                                                color: '#F0AE0D'
                                                            },
                                                            children: "Interrupted"
                                                        }) : runStatus === 'cancelled' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            title: `Cancelled at ${stepLabel} \u{2014} resumable`,
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap',
                                                                background: '#F0F2FD',
                                                                color: '#5E5F66'
                                                            },
                                                            children: "Cancelled"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontSize: '11px',
                                                                fontWeight: 600,
                                                                padding: '2px 8px',
                                                                borderRadius: '20px',
                                                                whiteSpace: 'nowrap',
                                                                background: isComplete ? 'rgba(9,178,85,0.12)' : isInProgress ? 'rgba(240,174,13,0.15)' : '#F0F2FD',
                                                                color: isComplete ? '#09B255' : isInProgress ? '#F0AE0D' : '#5E5F66'
                                                            },
                                                            children: isComplete ? 'Completed' : isInProgress ? 'In Progress' : "\u2014"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        style: {
                                                            flex: 1,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '6px'
                                                        },
                                                        onClick: (e)=>e.stopPropagation(),
                                                        children: [
                                                            isLive && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>continueRun(report),
                                                                disabled: isResuming,
                                                                title: `This run is still ${runStatus === 'filling' ? 'filling answers' : 'allocating files'} \u{2014} reopen it to watch live progress`,
                                                                style: {
                                                                    background: '#4A67FF',
                                                                    border: '1px solid #4A67FF',
                                                                    cursor: 'pointer',
                                                                    height: '28px',
                                                                    borderRadius: '6px',
                                                                    color: '#fff',
                                                                    fontSize: '11px',
                                                                    fontWeight: 600,
                                                                    padding: '0 10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                children: isResuming ? "Opening\u2026" : "\u25B6 Continue"
                                                            }),
                                                            canResume && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>resumeRun(report),
                                                                disabled: isResuming || rollingBack,
                                                                title: `Resume this run from ${stepLabel} \u{2014} continues only the remaining work`,
                                                                style: {
                                                                    background: '#F0F2FD',
                                                                    border: '1px solid #DDE2F2',
                                                                    cursor: 'pointer',
                                                                    height: '28px',
                                                                    borderRadius: '6px',
                                                                    color: '#4A67FF',
                                                                    fontSize: '11px',
                                                                    fontWeight: 600,
                                                                    padding: '0 10px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                children: isResuming ? "Resuming\u2026" : "\u25B6 Resume"
                                                            }),
                                                            !isRolledBack && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleRollback([
                                                                        id
                                                                    ]),
                                                                disabled: rollingBack,
                                                                title: "Rollback this run \u2014 removes all answers and file allocations",
                                                                style: {
                                                                    background: 'rgba(252,119,133,0.12)',
                                                                    border: '1px solid rgba(252,119,133,0.35)',
                                                                    cursor: 'pointer',
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    borderRadius: '6px',
                                                                    color: '#FC7785',
                                                                    fontSize: '15px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                },
                                                                children: "\u21BA"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            flex: '0 0 32px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "14",
                                                            height: "14",
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            style: {
                                                                transform: isExpanded ? 'rotate(180deg)' : 'none',
                                                                transition: 'transform 0.2s',
                                                                color: '#AAACB5'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M5 7.5L10 12.5L15 7.5",
                                                                stroke: "currentColor",
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            isExpanded && data && (isAutoFill ? renderAutoFillExpanded(data.report, data.aiAnswers, isRolledBack) : renderFileImportExpanded(data.report, isRolledBack)),
                                            isExpanded && isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    padding: '1.5rem',
                                                    textAlign: 'center',
                                                    color: '#AAACB5',
                                                    fontSize: '12px',
                                                    borderTop: '1px solid #DDE2F2'
                                                },
                                                children: "Loading details..."
                                            })
                                        ]
                                    }, id);
                                })
                            ]
                        }),
                        selectedCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                marginTop: '1rem',
                                padding: '0.65rem 0.75rem',
                                background: 'rgba(252,119,133,0.12)',
                                borderRadius: '8px',
                                border: '1px solid rgba(252,119,133,0.35)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    style: {
                                        fontSize: '13px',
                                        color: '#FC7785',
                                        fontWeight: 500
                                    },
                                    children: [
                                        selectedCount,
                                        " run",
                                        selectedCount > 1 ? 's' : '',
                                        " selected for rollback"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>handleRollback([
                                            ...selectedIds
                                        ]),
                                    disabled: rollingBack,
                                    style: {
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        padding: '5px 16px',
                                        borderRadius: '6px',
                                        background: '#FC7785',
                                        color: '#fff',
                                        border: 'none',
                                        cursor: 'pointer'
                                    },
                                    children: rollingBack ? 'Rolling back...' : 'Rollback'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
// ── Shared sub-components ──────────────────────────────────────────
const $7f5e4159f4b2fdb7$var$ModuleAccordion = ({ title: title, subtitle: subtitle, children: children, onRollback: onRollback, rollingBack: rollingBack })=>{
    const [open, setOpen] = (0, $acw62.useState)(true);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            border: '1px solid #DDE2F2',
            borderRadius: '8px',
            marginBottom: '0.5rem',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.55rem 0.75rem',
                    background: '#fff',
                    borderLeft: '3px solid #4A67FF'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        onClick: ()=>setOpen((o)=>!o),
                        style: {
                            fontSize: '13px',
                            fontWeight: 600,
                            color: '#151313',
                            flex: 1,
                            cursor: 'pointer'
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: '11px',
                            color: '#5E5F66'
                        },
                        children: subtitle
                    }),
                    onRollback && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: (e)=>{
                            e.stopPropagation();
                            onRollback();
                        },
                        disabled: rollingBack,
                        title: "Rollback this module",
                        style: {
                            fontSize: '11px',
                            fontWeight: 600,
                            color: '#FC7785',
                            background: 'rgba(252,119,133,0.12)',
                            border: '1px solid rgba(252,119,133,0.35)',
                            borderRadius: '6px',
                            padding: '2px 8px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap'
                        },
                        children: "\u21BA Rollback"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        onClick: ()=>setOpen((o)=>!o),
                        width: "12",
                        height: "12",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        style: {
                            transform: open ? 'rotate(180deg)' : 'none',
                            transition: 'transform 0.2s',
                            color: '#AAACB5',
                            cursor: 'pointer',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M5 7.5L10 12.5L15 7.5",
                            stroke: "currentColor",
                            strokeWidth: "1.8",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    maxHeight: '280px',
                    overflowY: 'auto',
                    paddingTop: '0.5rem'
                },
                children: children
            })
        ]
    });
};
const $7f5e4159f4b2fdb7$var$ImportedFilesList = ({ files: files })=>{
    if (!files?.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginTop: '0.75rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: '11px',
                    fontWeight: 600,
                    color: '#5E5F66',
                    marginBottom: '0.4rem'
                },
                children: [
                    "IMPORTED FILES (",
                    files.length,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.4rem'
                },
                children: files.map((file, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '0.4rem 0.6rem',
                            background: '#fff',
                            border: '1px solid #DDE2F2',
                            borderRadius: '6px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($7f5e4159f4b2fdb7$var$FileTypeBadge, {
                                name: file.originalname
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    flex: 1,
                                    fontSize: '12px',
                                    color: '#151313'
                                },
                                children: file.originalname
                            }),
                            file.pages && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    fontSize: '10px',
                                    color: '#AAACB5'
                                },
                                children: [
                                    file.pages,
                                    " pages"
                                ]
                            }),
                            file.location && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: file.location,
                                target: "_blank",
                                rel: "noreferrer",
                                style: {
                                    fontSize: '11px',
                                    color: '#4A67FF',
                                    textDecoration: 'none',
                                    flexShrink: 0
                                },
                                children: "View \u2192"
                            })
                        ]
                    }, i))
            })
        ]
    });
};
var $7f5e4159f4b2fdb7$export$2e2bcd8739ae039 = $7f5e4159f4b2fdb7$var$FileReportHistory;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");


var $ayMG0 = parcelRequire("ayMG0");
const $38c7af07c1ff98c7$var$Pill = ({ text: text, customClass: customClass })=>{
    const color = text === "Completed" ? "34" : "61";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `pill bg${color} br50px px1rem fs12px c1 ${customClass}`,
        style: {
            width: "120px",
            textAlign: "center"
        },
        children: text
    });
};
var $38c7af07c1ff98c7$export$2e2bcd8739ae039 = $38c7af07c1ff98c7$var$Pill;


var $4def4a546b6daa3e$var$AuditLogIcon = function AuditLogIcon(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.418 23.138a7.204 7.204 0 0 1-11.89-5.472 7.204 7.204 0 0 1 7.204-7.205A7.204 7.204 0 0 1 23.64 21.79l2.248 2.205.088-.09a.658.658 0 0 1 .926-.015l3.957 3.84c.258.25.264.665.012.926l-1.428 1.47a.658.658 0 0 1-.926.015l-3.955-3.84a.654.654 0 0 1-.014-.926l.074-.076-2.203-2.161ZM17.732 12.14a5.524 5.524 0 1 0 0 11.048 5.524 5.524 0 0 0 0-11.048Zm0 8.103a.628.628 0 1 1 0 1.256.628.628 0 0 1 0-1.256Zm-.918-4.238a.629.629 0 0 1-1.257 0c0-.6.243-1.144.637-1.538a2.167 2.167 0 0 1 1.538-.637c.601 0 1.145.243 1.538.637.394.394.637.937.637 1.538a2.177 2.177 0 0 1-1.25 1.968.506.506 0 0 0-.22.19.522.522 0 0 0-.076.28v.31a.628.628 0 1 1-1.257 0v-.31c0-.348.097-.674.273-.953.175-.277.43-.502.746-.65a.932.932 0 0 0 .528-.835.915.915 0 0 0-.919-.918.909.909 0 0 0-.649.27.909.909 0 0 0-.269.648Zm-.128 9.801a12.521 12.521 0 0 1-4.504 1.726l-.395.07-.394-.07C5.382 26.486.937 21.211.937 15.103V6.333l10.85-4.652L22.64 6.332v4.753a8.185 8.185 0 0 0-2.117-1.141v-1.97c0-.2-.12-.382-.305-.461l-8.233-3.528a.502.502 0 0 0-.395 0L3.36 7.513a.502.502 0 0 0-.305.461v7.152c0 5.079 3.668 9.484 8.639 10.43a.502.502 0 0 0 .187 0c.713-.136 1.4-.343 2.053-.613.842.44 1.77.74 2.752.864Zm-3.828-1.536a9.53 9.53 0 0 1-1.07.28c-4.454-.894-7.729-4.859-7.729-9.425v-6.82l7.728-3.313 7.732 3.312v1.347a8.208 8.208 0 0 0-6.66 14.618Z",
            fill: "#4A67FF"
        })
    });
};
$4def4a546b6daa3e$var$AuditLogIcon.defaultProps = {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4def4a546b6daa3e$var$Delete = function Delete(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.552 6.89a.722.722 0 0 0-.722.723v8.082a1.387 1.387 0 0 1-1.452 1.307H7.615a1.386 1.386 0 0 1-1.452-1.307V7.613a.722.722 0 1 0-1.444 0v8.082a2.83 2.83 0 0 0 2.896 2.751h5.763a2.83 2.83 0 0 0 2.896-2.75V7.612a.722.722 0 0 0-.722-.722ZM16.278 4.721h-2.89V3.277a.722.722 0 0 0-.721-.722H8.333a.722.722 0 0 0-.722.722V4.72H4.722a.722.722 0 0 0 0 1.445h11.556a.722.722 0 0 0 0-1.445Zm-7.222 0V4h2.888v.722H9.056Z",
                fill: "#F14D4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.78 14.114V9.058a.722.722 0 1 0-1.444 0v5.056a.722.722 0 1 0 1.444 0ZM12.663 14.114V9.058a.722.722 0 0 0-1.444 0v5.056a.722.722 0 1 0 1.444 0Z",
                fill: "#F14D4D"
            })
        ]
    });
};
$4def4a546b6daa3e$var$Delete.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $4def4a546b6daa3e$var$AuditLogModal = ({ modalType: modalType, logList: logList, logModule: logModule, profileClass: profileClass, getViewableURL: getViewableURL, tab: tab })=>{
    const getLogsHTML = (logs, showDetails = false)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc my0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                                src: log['userId']['profile'],
                                "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                            }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                                children: [
                                    log?.['userId']?.['firstName']?.[0] || "?",
                                    log?.['userId']?.['lastName']?.[0] || "?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs0-75rem c15 ml0-5rem df aic",
                                children: [
                                    log['message'],
                                    " at",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c36 op70",
                                        style: {
                                            marginLeft: "6px"
                                        },
                                        children: [
                                            " ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(log.timestamp).format("MMM D, YYYY, h:mmA")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 mt1rem",
                        children: log['message'].includes("Removed") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "br10px p1rem dg gtcr2 mb0-5rem fs0-75rem",
                                style: {
                                    backgroundColor: "#FC778533",
                                    "grid-template-columns": "25% 75%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($4def4a546b6daa3e$var$Delete, {}),
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "ml0-5rem c37",
                                                children: "File Deleted"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "c2",
                                        children: [
                                            "The file ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: log['change']['files'][0]['title']
                                            }),
                                            " was permanently deleted."
                                        ]
                                    })
                                ]
                            })
                        }) : log?.['payload']?.['source']?.includes('rollback') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "br10px p1rem mb0-5rem fs0-75rem",
                                        style: {
                                            backgroundColor: "#F0F2FDB3",
                                            display: 'grid',
                                            gridTemplateColumns: '140px 100px 1fr',
                                            gap: '1rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc aifs jcfs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c37 ases",
                                                        style: {
                                                            marginBottom: "12px"
                                                        },
                                                        children: "Changed Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "br100 px0-5rem py0-25rem fw600",
                                                        style: {
                                                            backgroundColor: "#E5E5E5",
                                                            color: "#929090"
                                                        },
                                                        children: "Not Started"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc aifs jcfs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c37 ases",
                                                        style: {
                                                            marginBottom: "12px"
                                                        },
                                                        children: "Selected Option"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "c15",
                                                        children: "Cleared"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc aifs jcfs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c37 ases",
                                                        style: {
                                                            marginBottom: "12px"
                                                        },
                                                        children: log?.['payload']?.['source'] === 'module-rollback' ? 'Module' : log?.['payload']?.['source'] === 'full-run-rollback' ? 'Scope' : 'Question'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "c15",
                                                        children: [
                                                            log?.['payload']?.['source'] === 'module-rollback' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    textTransform: 'capitalize'
                                                                },
                                                                children: log?.['change']?.moduleType?.replaceAll('-', ' ') || '-'
                                                            }),
                                                            log?.['payload']?.['source'] === 'full-run-rollback' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: "Full filing run"
                                                            }),
                                                            log?.['payload']?.['source'] === 'single-answer-rollback' && (()=>{
                                                                const q = log?.['questionId'] || log?.['tempQuestionId'];
                                                                const qNo = log?.['change']?.qNo || q?.['qNo'] || '-';
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    children: [
                                                                        qNo,
                                                                        q?.['qDescription'] ? ` ${q['qDescription']}` : ''
                                                                    ]
                                                                });
                                                            })()
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "br10px px1rem py0-75rem mb0-5rem fs0-75rem",
                                        style: {
                                            backgroundColor: "#F0F2FDB3"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c37 ases",
                                                style: {
                                                    marginBottom: "8px"
                                                },
                                                children: "Update Notes"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic gg0-5rem",
                                                style: {
                                                    color: '#FC7785'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        style: {
                                                            flexShrink: 0
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M3 12C3 7.02944 7.02944 3 12 3C14.8273 3 17.35 4.30367 19 6.34267M21 12C21 16.9706 16.9706 21 12 21C9.1727 21 6.65 19.6963 5 17.6573",
                                                                stroke: "#FC7785",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M19 2V7H14",
                                                                stroke: "#FC7785",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M5 22V17H10",
                                                                stroke: "#FC7785",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fw500",
                                                        children: "AI-filled answer rolled back. All auto-filled content cleared."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }) : showDetails && log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "br10px p1rem mb0-5rem fs0-75rem",
                                    style: {
                                        backgroundColor: "#F0F2FDB3",
                                        display: 'grid',
                                        gridTemplateColumns: '140px 100px 1fr 180px',
                                        gap: '1rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc aifs jcfs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c37 ases",
                                                    style: {
                                                        marginBottom: "12px"
                                                    },
                                                    children: "Changed Status"
                                                }),
                                                log?.['change']?.status ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38c7af07c1ff98c7$export$2e2bcd8739ae039), {
                                                    text: log?.['change']?.status
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc aifs jcfs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c37 ases",
                                                    style: {
                                                        marginBottom: "12px"
                                                    },
                                                    children: "Selected Option"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "c15",
                                                    children: (()=>{
                                                        const v = log?.['change']?.radioOption;
                                                        if (v && v !== '[object Object]' && typeof v !== 'object') return v;
                                                        const liveAnswer = log?.['answerId'] || log?.['tempAnswerId'];
                                                        return liveAnswer?.radioOption || liveAnswer?.dropdown || '-';
                                                    })()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc aifs jcfs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c37 ases",
                                                    style: {
                                                        marginBottom: "12px"
                                                    },
                                                    children: "Updated Comment"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "c15",
                                                    style: {
                                                        wordBreak: 'break-word'
                                                    },
                                                    children: log?.['change']?.comment ? log?.['change']?.comment : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc aifs jcfs oh",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c37 ases",
                                                    style: {
                                                        marginBottom: "12px"
                                                    },
                                                    children: "File"
                                                }),
                                                showDetails && log['files'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: log['files'].map((file, idx)=>{
                                                        let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            title: file['originalname'],
                                                            className: `pl2rem fs12rem pr bg44 fw500 ${fileColor} fileManageFileName w100`,
                                                            style: {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '100%'
                                                            },
                                                            children: file['originalname']
                                                        }, `getViewUrlForLog${idx}-${file.key}`);
                                                    })
                                                }) : "-"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "br10px px1rem py0-75rem mb0-5rem fs0-75rem",
                                    style: {
                                        backgroundColor: "#F0F2FDB3"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c37 ases",
                                            style: {
                                                marginBottom: "8px"
                                            },
                                            children: "Update Notes"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "c2",
                                            children: log?.['message'] ? log?.['message'] : "-"
                                        })
                                    ]
                                }),
                                log?.['payload']?.['autoFilled'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc gg0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "br10px p1rem dg gtcr3 fs0-75rem",
                                            style: {
                                                backgroundColor: "#EEF4FFB3",
                                                border: "1px solid #C7D9FF"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc aifs jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c37 ases",
                                                            style: {
                                                                marginBottom: "12px"
                                                            },
                                                            children: "AI Confidence"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df aic gg0-5rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "br100 px0-5rem py0-25rem fw600",
                                                                style: {
                                                                    backgroundColor: log?.['change']?.confidence >= 0.85 ? "#D1FAE5" : "#FEF3C7",
                                                                    color: log?.['change']?.confidence >= 0.85 ? "#065F46" : "#92400E"
                                                                },
                                                                children: log?.['change']?.confidence ? `${Math.round(log['change']['confidence'] * 100)}%` : "-"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc aifs jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c37 ases",
                                                            style: {
                                                                marginBottom: "12px"
                                                            },
                                                            children: "Needs Review"
                                                        }),
                                                        log?.['change']?.needsReview ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "br100 px0-5rem py0-25rem fw600 df aic gg0-25rem",
                                                            style: {
                                                                backgroundColor: "#FEE2E2",
                                                                color: "#991B1B"
                                                            },
                                                            children: "\u26A0 Yes"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "br100 px0-5rem py0-25rem fw600 df aic gg0-25rem",
                                                            style: {
                                                                backgroundColor: "#D1FAE5",
                                                                color: "#065F46"
                                                            },
                                                            children: "\u2713 No"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc aifs jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c37 ases",
                                                            style: {
                                                                marginBottom: "12px"
                                                            },
                                                            children: "AI Reasoning"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "c15",
                                                            children: log?.['change']?.explanation || "-"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc aifs jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c37 ases",
                                                            style: {
                                                                marginBottom: "12px"
                                                            },
                                                            children: "Module"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "c15",
                                                            style: {
                                                                textTransform: "capitalize"
                                                            },
                                                            children: log?.['change']?.moduleType?.replaceAll('-', ' ') || "-"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        log?.['payload']?.['sourceUrls']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "br10px p1rem fs0-75rem mt0-5rem",
                                            style: {
                                                backgroundColor: "#EEF4FFB3",
                                                border: "1px solid #C7D9FF"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c37 fw600",
                                                    style: {
                                                        marginBottom: "12px"
                                                    },
                                                    children: "Source Documents Used by AI"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc gg0-5rem",
                                                    children: log['payload']['sourceUrls'].map((url, idx)=>{
                                                        const fileName = decodeURIComponent(url.split('/').pop() || '').replace(/-\d{10,}\./g, '.');
                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            onClick: ()=>getViewableURL(url),
                                                            className: "df aic gg0-5rem cp tdu c36 fw500",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "\uD83D\uDCC4"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: fileName
                                                                })
                                                            ]
                                                        }, idx);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }, `logSection${idx}`);
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            modalCardClasses: "maw1100px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                    className: "c15 fs1-75rem fw600 tal df aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4def4a546b6daa3e$var$AuditLogIcon, {
                            className: "mr1rem"
                        }),
                        "Audit Log"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "c3 fs0-75rem ttu w100 fw400 tal mb1rem mt0-5rem",
                    children: [
                        tab.replaceAll('-', ' '),
                        " ",
                        logModule,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ma oya dg gg0-5rem mb2rem w100 lightScrollbar pr1rem",
                    style: {
                        maxHeight: "400px"
                    },
                    children: logList.length > 0 ? getLogsHTML(logList, true) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c4 fs1-5rem ttu w100 tac mb1rem",
                        children: "No Logs Found!!"
                    })
                })
            ]
        })
    });
};
var $4def4a546b6daa3e$export$2e2bcd8739ae039 = $4def4a546b6daa3e$var$AuditLogModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");











const $40a2fdbd500b75ca$var$UnallocatedFilesModal = ({ company: company, tab: tab, onClickUnallocatedBinAuditLog: onClickUnallocatedBinAuditLog, unallocatedFiles: unallocatedFiles, modalType: modalType, handleEditDispatch: handleEditDispatch, setDeleteUnallocatedFile: setDeleteUnallocatedFile, loading: loading, moveUnallocatedFile: moveUnallocatedFile, setUnallocatedFiles: setUnallocatedFiles })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { rModalData: rModalData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const [aiPopover, setAiPopover] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (rModalData.newQNo) {
            const data = [
                ...unallocatedFiles
            ].reduce((acc, cur)=>{
                if (cur.id === rModalData.fileData.id) acc.push({
                    ...cur,
                    "sectionNo": rModalData.newQNo,
                    "name": rModalData.newQName
                });
                else acc.push({
                    ...cur
                });
                return acc;
            }, []);
            return console.log(data, "data after reallocation");
        }
    }, [
        rModalData
    ]);
    const onClickReallocationComplete = async ()=>{
        const unallocate = unallocatedFiles.filter((un)=>un.sectionNo);
        moveUnallocatedFile({
            payload: unallocate
        });
        console.log(unallocate, "unallocatedFiles after reallocation complete");
    };
    const getUnallocatedFileHTML = (unallocatedFile, index)=>{
        const file = unallocatedFile.file;
        const fileUrl = file.location;
        const title = file.originalname;
        const key = file.key;
        const reasoning = unallocatedFile.reasoning || '';
        const suggestedQNo = unallocatedFile.suggestedQNo || '';
        const suggestedSection = unallocatedFile.suggestedSection || '';
        const suggestedQuestion = unallocatedFile.suggestedQuestion || '';
        let module = company.modules[tab];
        if (module) module = JSON.parse(JSON.stringify(module));
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "fs1rem fw600 bg1",
                        style: {
                            overflow: 'hidden',
                            maxWidth: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            onClick: ()=>getViewableURL(fileUrl),
                            className: `tal fs14px fw600 tdu bg1 lightDot red`,
                            style: {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                paddingLeft: '0.5rem'
                            },
                            "data-tooltip": title,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "frs-td mx1rem fs1rem fw600 bg1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdr aic jcfs",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "rs-nav rs-nav-default",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    onClick: ()=>handleEditDispatch({
                                            key: key,
                                            fileName: title,
                                            from: "unallocated",
                                            actionType: "reallocate",
                                            fileData: unallocatedFile,
                                            index: index,
                                            module: module
                                        }),
                                    className: "bg62 br10px fw400 fs13px df aic p0-5rem jcsb c49 fsi cp",
                                    children: [
                                        unallocatedFile.sectionNo && `${unallocatedFile.sectionNo}. ${unallocatedFile['name']}` || 'Please select section',
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {
                                            className: "c3"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "frs-td fs1rem fw600 bg1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdr aic jcc",
                            style: {
                                gap: '0.5rem'
                            },
                            children: [
                                (reasoning || suggestedQNo) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onMouseEnter: (e)=>{
                                        const r = e.currentTarget.getBoundingClientRect();
                                        setAiPopover((p)=>p?.pinned ? p : {
                                                reasoning: reasoning,
                                                suggestedQNo: suggestedQNo,
                                                suggestedSection: suggestedSection,
                                                suggestedQuestion: suggestedQuestion,
                                                fileName: title,
                                                x: r.left,
                                                y: r.bottom,
                                                pinned: false
                                            });
                                    },
                                    onMouseLeave: ()=>setAiPopover((p)=>p?.pinned ? p : null),
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        const r = e.currentTarget.getBoundingClientRect();
                                        setAiPopover((p)=>p?.pinned ? null : {
                                                reasoning: reasoning,
                                                suggestedQNo: suggestedQNo,
                                                suggestedSection: suggestedSection,
                                                suggestedQuestion: suggestedQuestion,
                                                fileName: title,
                                                x: r.left,
                                                y: r.bottom,
                                                pinned: true
                                            });
                                    },
                                    style: {
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '3px',
                                        background: '#dc262618',
                                        border: '1px solid #dc262640',
                                        borderRadius: '12px',
                                        padding: '3px 8px',
                                        cursor: 'pointer',
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("bi4Ns")),
                                        alt: "icon",
                                        className: "w20px h20px mr0-5rem"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cee5c542a37a6fe$export$2e2bcd8739ae039), {
                                    "data-tooltip": "Delete",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        setDeleteUnallocatedFile(unallocatedFile);
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'deleteUnallocatedFile',
                                            from: 'unallocated'
                                        }));
                                    },
                                    className: "cp f9 h1rem"
                                })
                            ]
                        })
                    })
                ]
            })
        }, `unallocateFile-${index}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: modalType,
                modalCardClasses: "maw1200px mah80 p2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcfs aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("f3vPa")),
                                        alt: "fileManagement"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "c15 fw600 fs20px mb0rem ml0-5rem",
                                        children: "Unallocated Files Bin"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: onClickUnallocatedBinAuditLog,
                                className: "cp tac c1 bg5 c15 br20px px1-5rem py0-5rem fw500",
                                children: "Log"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f875d00b2138afe4$export$2e2bcd8739ae039), {
                        style: {
                            marginTop: "16px",
                            marginBottom: "16px"
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg0-5rem mb2rem fs1rem mah300px oya",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                className: "fis bcc",
                                style: {
                                    tableLayout: 'fixed',
                                    width: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "w50 tal fs14px fw400 c37",
                                                    style: {
                                                        width: '55%'
                                                    },
                                                    children: "Unallocated File"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "w40 tal fs14px fw400 c37",
                                                    style: {
                                                        width: '35%'
                                                    },
                                                    children: "Allocation Section"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "w10 fs14px fw400 c37",
                                                    style: {
                                                        width: '10%'
                                                    },
                                                    children: "Actions"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                        children: unallocatedFiles && unallocatedFiles.length > 0 && unallocatedFiles.map(getUnallocatedFileHTML)
                                    })
                                ]
                            }),
                            unallocatedFiles && unallocatedFiles.length == 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc aic m2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("8S7PI")),
                                        alt: "fileManagement"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem fw600 mt1rem tac c15 op80",
                                        children: "No files found"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    unallocatedFiles.filter((un)=>un.sectionNo).length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df w100 fdr jcc mt2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            onClick: onClickReallocationComplete,
                            text: "Confirm Allocation",
                            disabled: loading,
                            btnType: "warning",
                            customClassName: "maw300px"
                        })
                    }) : null
                ]
            }),
            aiPopover && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                onClick: ()=>{
                    if (aiPopover.pinned) setAiPopover(null);
                },
                style: {
                    position: 'fixed',
                    inset: 0,
                    zIndex: 9999,
                    pointerEvents: aiPopover.pinned ? 'auto' : 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    onClick: (e)=>e.stopPropagation(),
                    style: {
                        position: 'fixed',
                        top: Math.max(8, aiPopover.y - 280),
                        left: Math.min(Math.max(aiPopover.x - 260, 8), window.innerWidth - 296),
                        width: '280px',
                        background: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                        padding: '1rem',
                        zIndex: 10000,
                        border: '1px solid #E5E7EB'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '0.5rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("bi4Ns")),
                                            alt: "icon",
                                            className: "w20px h20px mr0-5rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontWeight: 700,
                                                fontSize: '13px',
                                                color: '#111827'
                                            },
                                            children: "Why Unallocated?"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>setAiPopover(null),
                                    style: {
                                        cursor: 'pointer',
                                        color: '#9CA3AF',
                                        fontSize: '14px',
                                        lineHeight: 1
                                    },
                                    children: "\u2715"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                height: '1px',
                                background: '#F3F4F6',
                                marginBottom: '0.75rem'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    style: {
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        color: '#6B7280',
                                        marginBottom: '4px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.05em'
                                    },
                                    children: "AI Reasoning"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    style: {
                                        fontSize: '12px',
                                        color: '#374151',
                                        lineHeight: 1.5,
                                        margin: aiPopover.suggestedQNo ? '0 0 8px' : 0
                                    },
                                    children: [
                                        aiPopover.fileName && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontWeight: 700,
                                                wordBreak: 'break-all'
                                            },
                                            children: aiPopover.fileName
                                        }),
                                        aiPopover.fileName && ' - ',
                                        aiPopover.reasoning || 'Confidence too low to allocate automatically.'
                                    ]
                                }),
                                aiPopover.suggestedQNo && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        background: '#EFF6FF',
                                        border: '1px solid #BFDBFE',
                                        borderRadius: '7px',
                                        padding: '6px 10px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            style: {
                                                fontSize: '11px',
                                                fontWeight: 600,
                                                color: '#1D4ED8',
                                                marginBottom: '2px',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.05em'
                                            },
                                            children: "Possible match"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            style: {
                                                fontSize: '12px',
                                                color: '#1E40AF',
                                                lineHeight: 1.5,
                                                margin: 0
                                            },
                                            children: [
                                                aiPopover.suggestedQNo,
                                                aiPopover.suggestedSection ? " \u2014 " + aiPopover.suggestedSection : '',
                                                aiPopover.suggestedQuestion ? ': ' + aiPopover.suggestedQuestion : ''
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $40a2fdbd500b75ca$export$2e2bcd8739ae039 = $40a2fdbd500b75ca$var$UnallocatedFilesModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");







const $c13dd2b2ad7b7b79$var$DisconnectDataroom = ({ modalType: modalType, companyId: companyId, tab: tab })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const modalState = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const selectedCompany = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company.selectedCompany);
    const handleDisconnect = async ()=>{
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/disconnect/${companyId}/${modalState?.modalHistory}/${tab}`, {});
            if (response?.code === 200) {
                const dataroom = modalState?.modalHistory;
                const updatedCompany = {
                    ...selectedCompany
                };
                const patchMap = {
                    gdrive: {
                        unset: [
                            'gDriveLink',
                            'folderId'
                        ],
                        setFalse: [
                            'foldersPopulated'
                        ]
                    },
                    dropbox: {
                        unset: [
                            'dropBoxLink',
                            'dropBoxFolderMetadata'
                        ],
                        setFalse: [
                            'dropBoxFoldersPopulated'
                        ]
                    },
                    sharepoint: {
                        unset: [
                            'sharePointLink',
                            'sharePointFolderId',
                            'sharePointFolderDriveItem'
                        ],
                        setFalse: [
                            'sharePointFoldersPopulated'
                        ]
                    }
                };
                const patch = patchMap[dataroom];
                if (patch) {
                    // Remove keys from object
                    patch.unset.forEach((key)=>{
                        delete updatedCompany[key];
                    });
                    // Set boolean flags to false
                    patch.setFalse.forEach((key)=>{
                        updatedCompany[key] = false;
                    });
                }
                console.log('Updated company:', updatedCompany);
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(updatedCompany));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: '',
                    modalHistory: null
                }));
            } else console.error('Failed to disconnect dataroom:', response?.message);
        } catch (error) {
            console.error('Error disconnecting dataroom:', error);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcc fdc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                            className: "c4",
                            style: {
                                margin: "1rem auto 0px",
                                fontSize: "5rem !important",
                                width: "100px",
                                height: "100px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "pl0rem py2rem fs1rem c15 fw400 tti",
                            children: [
                                "Are you sure to disconnect the ",
                                modalState?.modalHistory,
                                "?"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic jcc w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        text: "Disconnect",
                        btnType: "warning",
                        onClick: handleDisconnect,
                        disabled: loading
                    })
                })
            ]
        })
    });
};
var $c13dd2b2ad7b7b79$export$2e2bcd8739ae039 = $c13dd2b2ad7b7b79$var$DisconnectDataroom;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");










const $8992acb1fe6a84ae$var$ConnectDataroomModal = ({ company: company })=>{
    const [connecting, setConnecting] = (0, $acw62.useState)(false);
    const dataroom = [
        {
            id: 1,
            name: 'Google Drive',
            linkKey: 'gDriveURL'
        },
        {
            id: 2,
            name: 'Dropbox',
            linkKey: 'dropboxURL'
        },
        {
            id: 3,
            name: 'Sharepoint',
            linkKey: 'sharePointAuthURL'
        }
    ];
    const info = [
        'Dedicated Diligentsia Folder',
        'Syncs only when you command it',
        'We never access your other folders',
        'Alternative way to create Data Repository'
    ];
    const handleConnect = async (linkKey)=>{
        if (connecting) return;
        const companyId = company?._id || company?.id;
        if (!companyId) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Company not found');
        try {
            setConnecting(true);
            // Reason: always fetch a fresh OAuth URL so scope upgrades (drive.file → drive) are not stuck in Redux/cache.
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/dataroomConnectUrls/${companyId}`);
            const urls = res?.body || res?.data || {};
            const href = urls[linkKey] || company?.[linkKey];
            if (!href) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Connect URL not available. Please refresh and try again.');
                setConnecting(false);
                return;
            }
            window.location.href = href;
        } catch (e) {
            const fallback = company?.[linkKey];
            if (fallback) window.location.href = fallback;
            else {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to start connection. Please refresh and try again.');
                setConnecting(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: "connectDataroom",
        modalCardClasses: "maw1200px",
        customStyle: {
            background: 'linear-gradient(180deg, rgba(245, 247, 255, 1) 0%, rgba(232, 236, 255, 1) 100%)',
            padding: '3rem 4rem'
        },
        girlComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pa df fdc ",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "pa",
                    src: (parcelRequire("hTZXD")),
                    alt: "girl",
                    style: {
                        width: '200px',
                        bottom: '-80px'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "pa",
                    src: (parcelRequire("jp8rB")),
                    alt: "Group",
                    style: {
                        width: '250px',
                        top: '0',
                        right: '-150px'
                    }
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "c15 fw500",
                        children: "Connect data room"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15",
                        children: "Securely link your existing cloud provider to automatically backup and sync your Data Repository documents."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "dg gtcr1-sm gtcr3a-md gg1rem mt2rem",
                children: dataroom.map((room)=>{
                    let image = '';
                    if (room.name === 'Google Drive') image = (parcelRequire("8pegU"));
                    else if (room.name === 'Dropbox') image = (parcelRequire("3Eiuc"));
                    else if (room.name === 'Sharepoint') image = (parcelRequire("lauhO"));
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg1 p1-5rem pb2rem br20px c15 cp df fdc aifs jcfs",
                        children: [
                            image && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: image,
                                alt: room.name,
                                style: {
                                    width: '80px',
                                    height: '80px',
                                    objectFit: 'contain'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "fw500 fs1-5rem tal w100 my1rem",
                                children: room.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                btnType: "warningOutlined",
                                text: connecting ? "Connecting\u2026" : 'Connect Now',
                                customClassName: "df aic jcsb",
                                style: {
                                    padding: '8px 16px',
                                    width: '180px'
                                },
                                disabled: connecting,
                                onClick: ()=>handleConnect(room.linkKey),
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("6rlDG")),
                                    alt: room.name,
                                    width: 20
                                })
                            })
                        ]
                    }, room.id);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bg1 p2rem br20px mt3rem df aic jcsb",
                children: info.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic mr3rem w25",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("3yJPW")),
                                alt: "check",
                                width: 20,
                                className: "mr0-5rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c15 fs10px fsi",
                                children: item
                            })
                        ]
                    }, index))
            })
        ]
    });
};
var $8992acb1fe6a84ae$export$2e2bcd8739ae039 = $8992acb1fe6a84ae$var$ConnectDataroomModal;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");







var $1047f7c995c3f14f$var$FileManager = function FileManager(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M5.596 4h11.73c.916 0 1.787.107 2.584.528l.073.042c.804.446 1.453 1.179 1.872 2.372l.972 2.775h3.577c1.265 0 2.415.51 3.247 1.328A4.476 4.476 0 0 1 31 14.24v10.236a4.476 4.476 0 0 1-1.35 3.196A4.622 4.622 0 0 1 26.405 29H5.596a4.622 4.622 0 0 1-3.247-1.328l-.067-.072A4.47 4.47 0 0 1 1 24.476V8.524c0-1.242.517-2.372 1.35-3.192v-.004A4.622 4.622 0 0 1 5.595 4Zm4.52 11.667c0-.614.505-1.111 1.128-1.111a1.12 1.12 0 0 1 1.129 1.11v.285c.209.065.41.147.602.245l.204-.201a1.142 1.142 0 0 1 1.597 0c.44.434.44 1.137 0 1.571l-.206.202c.1.188.184.386.25.591h.29a1.12 1.12 0 0 1 1.129 1.111 1.12 1.12 0 0 1-1.13 1.111h-.288c-.066.206-.15.405-.25.593l.205.201c.44.434.44 1.138 0 1.572a1.142 1.142 0 0 1-1.597 0l-.206-.203a3.769 3.769 0 0 1-.6.246v.285a1.12 1.12 0 0 1-1.129 1.111 1.12 1.12 0 0 1-1.129-1.11v-.286a3.778 3.778 0 0 1-.6-.246l-.207.203a1.142 1.142 0 0 1-1.596 0 1.099 1.099 0 0 1 0-1.572l.204-.2a3.658 3.658 0 0 1-.25-.594h-.288a1.12 1.12 0 0 1-1.13-1.11 1.12 1.12 0 0 1 1.13-1.111h.29c.066-.206.15-.404.25-.592l-.206-.202a1.099 1.099 0 0 1 0-1.571 1.142 1.142 0 0 1 1.596 0l.205.201c.192-.098.393-.18.602-.245v-.284ZM12.3 18.43a1.517 1.517 0 0 0-2.113.002 1.454 1.454 0 0 0 0 2.077c.268.266.642.43 1.056.43a1.47 1.47 0 0 0 1.492-1.469c0-.407-.167-.775-.435-1.04Zm5.026-12.208H5.597a2.35 2.35 0 0 0-1.651.677 2.268 2.268 0 0 0-.688 1.625v15.952c0 .61.243 1.166.638 1.579l.05.046a2.35 2.35 0 0 0 1.65.677h20.808a2.35 2.35 0 0 0 1.65-.677c.424-.417.688-.993.688-1.625V14.24c0-.631-.264-1.207-.688-1.624a2.35 2.35 0 0 0-1.65-.677h-4.38c-.47-.001-.908-.29-1.068-.751l-1.235-3.525c-.215-.613-.5-.967-.83-1.158l-.048-.024c-.391-.206-.924-.26-1.516-.26Z",
            fill: "#4A67FF"
        })
    });
};
$1047f7c995c3f14f$var$FileManager.defaultProps = {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1047f7c995c3f14f$var$Delete = function Delete(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.552 6.89a.722.722 0 0 0-.722.723v8.082a1.387 1.387 0 0 1-1.452 1.307H7.615a1.386 1.386 0 0 1-1.452-1.307V7.613a.722.722 0 1 0-1.444 0v8.082a2.83 2.83 0 0 0 2.896 2.751h5.763a2.83 2.83 0 0 0 2.896-2.75V7.612a.722.722 0 0 0-.722-.722ZM16.278 4.721h-2.89V3.277a.722.722 0 0 0-.721-.722H8.333a.722.722 0 0 0-.722.722V4.72H4.722a.722.722 0 0 0 0 1.445h11.556a.722.722 0 0 0 0-1.445Zm-7.222 0V4h2.888v.722H9.056Z",
                fill: "#F14D4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.78 14.114V9.058a.722.722 0 1 0-1.444 0v5.056a.722.722 0 1 0 1.444 0ZM12.663 14.114V9.058a.722.722 0 0 0-1.444 0v5.056a.722.722 0 1 0 1.444 0Z",
                fill: "#F14D4D"
            })
        ]
    });
};
$1047f7c995c3f14f$var$Delete.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1047f7c995c3f14f$var$Copy = function Copy(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M5.59 18h6.82a2.585 2.585 0 0 0 2.556-2.25h.445A2.592 2.592 0 0 0 18 13.16V5.59A2.592 2.592 0 0 0 15.41 3H8.59A2.592 2.592 0 0 0 6 5.59V6h-.41A2.592 2.592 0 0 0 3 8.59v6.82A2.592 2.592 0 0 0 5.59 18ZM7.5 5.59c0-.601.489-1.09 1.09-1.09h6.82c.601 0 1.09.489 1.09 1.09v7.57c0 .601-.489 1.09-1.09 1.09H15V8.59A2.592 2.592 0 0 0 12.41 6H7.5v-.41Zm-3 3c0-.601.489-1.09 1.09-1.09h6.82c.601 0 1.09.489 1.09 1.09v6.82c0 .601-.489 1.09-1.09 1.09H5.59c-.601 0-1.09-.489-1.09-1.09V8.59Z",
            fill: "#4A67FF"
        })
    });
};
$1047f7c995c3f14f$var$Copy.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1047f7c995c3f14f$var$Downloads = function Downloads(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14.667 18H6.333c-.89 0-1.727-.347-2.357-.976A3.311 3.311 0 0 1 3 14.667v-.834a.833.833 0 1 1 1.667 0v.834c0 .445.173.863.488 1.178.315.315.733.488 1.178.488h8.334c.445 0 .863-.173 1.178-.488.315-.315.488-.733.488-1.178v-.834a.833.833 0 1 1 1.667 0v.834c0 .89-.347 1.727-.976 2.357-.63.63-1.467.976-2.357.976ZM10.5 14.667a.831.831 0 0 1-.582-.237l-.002-.002-.002-.002-.001-.002-.002-.001-3.334-3.334a.833.833 0 0 1 1.179-1.178l1.91 1.91V3.833a.833.833 0 1 1 1.667 0v7.988l1.911-1.91a.833.833 0 0 1 1.179 1.178l-3.334 3.334-.002.001v.001l-.001.001-.002.001-.002.003a.827.827 0 0 1-.258.172h-.001a.828.828 0 0 1-.323.065Z",
            fill: "#4A67FF"
        })
    });
};
$1047f7c995c3f14f$var$Downloads.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1047f7c995c3f14f$var$Send = function Send(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.493 5.031c-.358 0-.693-.175-.898-.468L9.81 3.437a2.406 2.406 0 0 0-1.974-1.03H3.5a2.406 2.406 0 0 0-2.406 2.405v11.375c0 .638.253 1.25.704 1.702a2.41 2.41 0 0 0 1.702.705h14a2.41 2.41 0 0 0 1.702-.705 2.41 2.41 0 0 0 .704-1.701v-8.75a2.41 2.41 0 0 0-.704-1.702A2.41 2.41 0 0 0 17.5 5.03h-6.007Zm0 1.313H17.5a1.096 1.096 0 0 1 1.094 1.093v8.75a1.095 1.095 0 0 1-1.094 1.094h-14a1.095 1.095 0 0 1-1.094-1.093V4.813c0-.604.49-1.094 1.094-1.094h4.337c.357 0 .693.175.897.468l.785 1.126a2.405 2.405 0 0 0 1.974 1.03Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.192 11.008H7.808a.808.808 0 0 0 0 1.615h5.384a.808.808 0 0 0 0-1.615Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m10.471 10.23 1.582 1.583-1.582 1.583a.807.807 0 1 0 1.142 1.141l2.153-2.153a.806.806 0 0 0 0-1.142l-2.153-2.154a.807.807 0 1 0-1.142 1.142Z",
                fill: "#4A67FF"
            })
        ]
    });
};
$1047f7c995c3f14f$var$Send.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};

const $1047f7c995c3f14f$var$ManageFilesModal = ({ modalType: modalType, section: section, company: company, setSection: setSection, getViewableURL: getViewableURL, handleEditDispatch: handleEditDispatch, setDeleteFileQuestionId: setDeleteFileQuestionId, setDeleteFile: setDeleteFile, tab: tab, targetSection: targetSection, reloadModule: reloadModule, onMoveFile: onMoveFile })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { fileManageSection: fileManageSection } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.files);
    // When the modal is opened from a specific question (e.g. "D001" or "D001.1"),
    // `section.questionId` holds that question's qNo. In that case we scope the file
    // list to only the files belonging to that exact question rather than the whole
    // section (important for Pro plans with sub-question files like D001.1 vs D001).
    // If no file in the list carries a qNo (older code paths), fall back to showing all.
    const visibleFiles = (0, $acw62.useMemo)(()=>{
        const allFiles = section && section.files || [];
        const selectedQNo = section?.questionId;
        if (!selectedQNo) return allFiles;
        const anyTagged = allFiles.some((f)=>f?.qNo);
        if (!anyTagged) return allFiles;
        return allFiles.filter((f)=>String(f?.qNo) === String(selectedQNo));
    }, [
        section
    ]);
    const moveFile = async ({ file: file, qNo: qNo, curQno: curQno, isCut: isCut, sectionName: sectionName })=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveFile/', {
            file: file,
            unallocated: false,
            companyId: company._id,
            isCut: isCut,
            qNo: qNo,
            tab: tab,
            oldQno: curQno,
            isDeduper: false,
            key: file.key,
            sectionName: sectionName
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        reloadModule(tab, false, false, true);
    };
    (0, $acw62.useEffect)(()=>{
        if (Object.keys(fileManageSection).length) {
            setSection(fileManageSection.sectionData);
            dispatch((0, $e0a7c253e2df808f$export$6d5d8bd59e3ba7ac)({}));
            const moveArgs = {
                file: fileManageSection.selectFile[0],
                qNo: fileManageSection.qNo,
                curQno: fileManageSection.sectionData?.questionId ?? fileManageSection.sectionData.sectionNo ?? fileManageSection.sectionData.no,
                isCut: fileManageSection.actionType === "move",
                sectionName: fileManageSection.sectionData.name ?? fileManageSection.sectionData.sectionName
            };
            if (onMoveFile) onMoveFile(moveArgs);
            else moveFile(moveArgs);
        }
    }, [
        fileManageSection
    ]);
    const getFileHTML = (sec, file, index, visibleFiles)=>{
        let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
        const key = file.key;
        const singleFileSection = {
            ...sec,
            files: visibleFiles
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb aic w100 pr1rem pt0-5rem td250 bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: ()=>getViewableURL(file.url),
                        className: `mr1rem pl2rem cp tdu fs1rem pr fw600 bg1 ${fileColor} fileManageFileName w100`,
                        children: file.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mr1rem w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rs-nav rs-nav-default",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "rs-dropdown-toggle rs-nav-item c2 fsi",
                                children: company && company['subscription'] === 'Pro' && sec?.['questionId'] && sec?.['questionId'].length < 12 ? `${sec?.['questionId']} ${sec['sectionName'] ?? ""}` : sec['sectionNo'] ? `${sec['sectionNo']} ${sec['sectionName']}` : sec['no'] ? `${sec['no']} ${sec['name']}` : 'Please select section'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1047f7c995c3f14f$var$Send, {
                                "data-tooltip": "Move",
                                className: "mr1rem cp",
                                onClick: ()=>handleEditDispatch({
                                        key: key,
                                        fileName: file.title,
                                        from: "section",
                                        actionType: "move",
                                        fileData: file,
                                        index: index,
                                        section: singleFileSection
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1047f7c995c3f14f$var$Copy, {
                                "data-tooltip": "Copy",
                                className: "mr1rem cp",
                                onClick: ()=>handleEditDispatch({
                                        key: key,
                                        fileName: file.title,
                                        from: "section",
                                        actionType: "copy",
                                        fileData: file,
                                        index: index,
                                        section: singleFileSection
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "df",
                                target: "_blank",
                                to: file.url,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($1047f7c995c3f14f$var$Downloads, {
                                    "data-tooltip": "Download",
                                    className: `f3 cp mr1rem ${tab == 'repository' ? '' : 'mla'}`
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1047f7c995c3f14f$var$Delete, {
                                className: "cp",
                                "data-tooltip": "Delete",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setDeleteFileQuestionId(file.questionId);
                                    setDeleteFile(file);
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'deleteFile',
                                        from: 'manageFiles'
                                    }));
                                }
                            })
                        ]
                    })
                ]
            })
        }, `${index}-aja-${new Date().getTime()}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            modalCardClasses: "maw1000px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "c15 fw600 tal df aic mb0-5rem fs1-25em",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($1047f7c995c3f14f$var$FileManager, {
                            className: "mr1rem"
                        }),
                        " File Manager"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "c3 fs1rem-sm w100 fw400 tal mb2rem",
                        children: [
                            company && company['subscription'] === 'Pro' && section?.['questionId'] && section?.['questionId'].length < 12 ? `${section?.['questionId']}` : section && (section.sectionNo || section.no),
                            " - ",
                            section && (section.sectionName || section.name)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: "list-file-manager",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 upload-file",
                            children: "Uploaded Directly"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 prepopulated-file",
                            children: "Companies House"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 filing-assistant-file",
                            children: "Filing Assistant"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 sharepoint-file",
                            children: "Sharepoint"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 dropbox-file",
                            children: "Dropbox"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 gdrive-file",
                            children: "Drive"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "devider"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg mb2rem fs1rem lightScrollbar",
                    style: {
                        maxHeight: "300px",
                        overflowY: 'scroll'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb aic w100 pr1rem mt1rem pt0-5rem td250 bsbb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c37 fs12px op60",
                                        children: "File Name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c37 fs12px op60",
                                        style: {
                                            marginLeft: '22px'
                                        },
                                        children: "Section"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c37 fs12px op60",
                                        style: {
                                            marginLeft: '12px'
                                        },
                                        children: "Actions"
                                    })
                                })
                            ]
                        }),
                        visibleFiles && visibleFiles.length > 0 && visibleFiles.map((file, index)=>{
                            return getFileHTML(section, file, index, visibleFiles);
                        })
                    ]
                }),
                section && (!visibleFiles || visibleFiles.length == 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc jcc aic m2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("8S7PI")),
                            alt: "fileManagement"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1rem fw600 mt1rem tac c15 op80",
                            children: "No files found"
                        })
                    ]
                })
            ]
        })
    });
};
var $1047f7c995c3f14f$export$2e2bcd8739ae039 = $1047f7c995c3f14f$var$ManageFilesModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $436c32be0a88c5ca$var$FileManager = function FileManager(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#a)",
                fill: "#4A67FF",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        clipPath: "url(#b)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M27.458 7.237a.749.749 0 0 0-.748-.748h-9.122V5.132h2.433a.749.749 0 0 0 .748-.749V3.207A3.21 3.21 0 0 0 17.562 0H7.746c-.857 0-1.662.334-2.268.94a3.185 3.185 0 0 0-.939 2.267v13.494c0 .413.335.748.749.748h9.12v1.419h-2.431a.748.748 0 0 0-.75.748l.22.384c5.053 1 7.829 3.5 9.597 3.5l3.207.5c.857 0 1.663-.334 2.268-.94.606-.605.94-1.41.94-2.267V7.237Zm-9.896-5.74c.943 0 1.71.767 1.71 1.71v.428H10.953v-.428c0-.628-.181-1.215-.495-1.71h7.104ZM6.036 15.952V3.207c0-.457.178-.886.501-1.209a1.712 1.712 0 0 1 2.919 1.21v1.175c0 .414.335.749.748.749h5.887v1.357h-.934a.749.749 0 0 0-.748.748v4.604h-1.195a.749.749 0 0 0 0 1.498h1.195v2.613H6.036ZM18 21.5c-.943 0-2.094 0-3.565-.707l-1.71-.428h8.32v.428c0 .628.18 1.215.494 1.71L18 21.5Zm7.46.502a1.712 1.712 0 0 1-2.92-1.21v-1.175a.749.749 0 0 0-.747-.75h-5.887V13.34h3.237l-.593.593a.749.749 0 0 0 1.059 1.059l1.871-1.872a.749.749 0 0 0 0-1.059l-1.871-1.87a.748.748 0 1 0-1.059 1.058l.593.593h-3.237V7.986h10.055v12.807a1.7 1.7 0 0 1-.5 1.209Z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M11.239 11.844h-1.123a.749.749 0 1 0 0 1.497h1.123a.749.749 0 1 0 0-1.497ZM7.186 12.06a.755.755 0 0 0 0 1.06c.142.137.333.22.531.22.195 0 .39-.083.528-.221a.743.743 0 0 0 0-1.06c-.277-.277-.778-.277-1.06 0Z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M31.045 21.778c-.37-.752-1.274-1.152-2.303-1.019-.62.08-1.213.376-1.735.637l-.268.133a160.185 160.185 0 0 0-4.701 2.381c-.352-1.032-1.737-1.98-4.128-2.822-.77-.271-1.594-.581-2.466-.91-2.73-1.026-5.31-1.997-6.585-1.924-3.258.186-6.077 2.294-7.762 3.554a.75.75 0 0 0-.275.795l1.962 7.319a.75.75 0 0 0 1.148.425l.009-.006c.962-.659 1.543-1.057 2.547-1.076 1.876-.037 4.722.825 7.231 1.586 2.318.702 3.852 1.15 4.854 1.15.211.003.422-.023.626-.079 1.794-.522 9.162-5.722 11.19-7.74 1.113-1.107.83-2.05.656-2.404Zm-1.714 1.341c-2.097 2.086-9.258 6.986-10.552 7.363-.078.023-.42.075-1.578-.2-.858-.204-1.921-.526-3.047-.867-2.557-.775-5.448-1.651-7.551-1.651l-.145.001c-1.033.02-1.78.333-2.495.765l-1.56-5.824c1.574-1.165 3.967-2.808 6.541-2.955.96-.051 3.738.991 5.972 1.832.84.316 1.71.643 2.495.92 2.192.772 3.2 1.596 3.216 1.935.004.088-.177.403-1.047.81-.447.166-.9.2-1.58.055-.699-.15-1.438-.468-2.152-.777-1.045-.451-2.032-.878-3.023-.878a.75.75 0 1 0 0 1.5c.68 0 1.53.367 2.429.755.78.338 1.589.687 2.433.867 1.028.22 1.768.125 2.417-.117a.725.725 0 0 0 .063-.024c.438-.171.837-.408 1.258-.659.23-.136.468-.278.732-.421 1.526-.83 3.784-1.966 5.236-2.67.093-.045.188-.093.286-.142.415-.207.885-.443 1.254-.49.43-.056.71.081.765.191.042.086-.022.338-.367.681Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h32v32H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(4)",
                            d: "M0 0h24v24H0z"
                        })
                    })
                ]
            })
        ]
    });
};
$436c32be0a88c5ca$var$FileManager.defaultProps = {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};

const $436c32be0a88c5ca$var$deduperReportWaiting = ({ modalType: modalType, onClickDeduperAuditLog: onClickDeduperAuditLog, company: company })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            modalCardClasses: "maw1000px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcsb pr",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcfs aic",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "c15 fw600 tal df aic mb0-5rem fs1-25em",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($436c32be0a88c5ca$var$FileManager, {
                                    className: "mr1rem"
                                }),
                                " Deduper"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "c15 fw600 tac mb1rem fs1-5em",
                    children: company.cName
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "c15 fs1-25rem-sm ttu w100 tac mb2rem",
                    children: "Diligentsia DeDuper Assistant"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tac",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "c15",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Deduper Magic:"
                                }),
                                " We're now summoning the power of AI to checking duplication of files! ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Please stay with us during this magical incantation\u2026"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h9rem",
                            src: (parcelRequire("hA45b")),
                            alt: ""
                        })
                    ]
                })
            ]
        })
    });
};
var $436c32be0a88c5ca$export$2e2bcd8739ae039 = $436c32be0a88c5ca$var$deduperReportWaiting;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");















const $d4f591bf66fcd73d$var$FA_INFO_CONFIG = {
    'unallocated-bin': {
        subtitle: 'Unallocated Bin',
        actionLabel: 'Take me to the bin',
        steps: [
            (parcelRequire("hM019")),
            (parcelRequire("4Xa6G")),
            (parcelRequire("886gJ"))
        ]
    },
    'filing-assistant': {
        subtitle: 'Filing Assistant Manager',
        actionLabel: 'Run filing assistant',
        steps: [
            (parcelRequire("4HwwL")),
            (parcelRequire("gX8Sm")),
            (parcelRequire("e82tD"))
        ]
    },
    'deduper': {
        subtitle: 'Deduper',
        actionLabel: 'View Deduper',
        steps: [
            (parcelRequire("dE8rk")),
            (parcelRequire("exnR2")),
            (parcelRequire("dlLss"))
        ]
    },
    'deduper-reports': {
        subtitle: 'Deduper Reports',
        actionLabel: 'View Report',
        steps: [
            (parcelRequire("j60gY")),
            (parcelRequire("75c8P")),
            (parcelRequire("lw4cX"))
        ]
    }
};

function $d4f591bf66fcd73d$export$2e2bcd8739ae039({ onAction: onAction }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const isOpen = modal['open'] === 'filingAssistantInfo';
    const key = modal['faInfoKey'];
    const config = $d4f591bf66fcd73d$var$FA_INFO_CONFIG[key];
    const close = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    const handleAction = ()=>{
        if (onAction && key) onAction(key);
        close();
    };
    if (!isOpen || !config) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: close,
        className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df aic jcc",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg20 shadow bsbb br20px p4rem maw1200px w100 mx1rem hideScrollbar mah80 oya",
            style: {
                outline: 'none'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "c15 fs2rem fw500 tac",
                    children: "What is it?"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "c3 fs1-25rem fw500 tac mb1-5rem",
                    children: config['subtitle']
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic jcc w80 mla mra mb1-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("e9Vft")),
                        alt: "steps"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc mb2rem",
                    children: config['steps'].map((step, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: step,
                            alt: `step=${i}`,
                            className: "mx1rem"
                        }))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcsb px4rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: close,
                            className: "cp df aic c15 fw500 fs1rem bg44",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mr0-5rem fs1-25rem",
                                    children: "\u2190"
                                }),
                                " Back"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: handleAction,
                            className: "cp shadow c1 fw500 fs1rem br50px px2-5rem py0-75rem bg4 bg3-hover",
                            children: config['actionLabel']
                        })
                    ]
                })
            ]
        })
    });
}


// Helpers for "show info popup only the first time" behaviour (per faInfoKey).
// Reason: each Filing Assistant info popup should educate the user once, then
// subsequent clicks jump straight to the underlying action.
const $fd71835e1939fbe7$var$STORAGE_PREFIX = 'faInfoSeen:';
const $fd71835e1939fbe7$export$daf99fa62e99003f = (key)=>{
    try {
        return localStorage.getItem(`${$fd71835e1939fbe7$var$STORAGE_PREFIX}${key}`) === '1';
    } catch (error) {
        return false;
    }
};
const $fd71835e1939fbe7$export$c70b8cc0254eb9d7 = (key)=>{
    try {
        localStorage.setItem(`${$fd71835e1939fbe7$var$STORAGE_PREFIX}${key}`, '1');
    } catch (error) {}
};
const $fd71835e1939fbe7$export$7476b3b1a66db3ee = (key, { openInfo: openInfo, runAction: runAction })=>{
    if ($fd71835e1939fbe7$export$daf99fa62e99003f(key)) return runAction(key);
    $fd71835e1939fbe7$export$c70b8cc0254eb9d7(key);
    return openInfo(key);
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $a2b7abf4967ef3ad$var$WelcomToDashboardModal = ({ modalType: modalType, dispatch: dispatch, company: company, user: user })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "c15 fw600 pb1rem",
                children: [
                    "Welcome to your ",
                    company?.subscription,
                    " Dashboard!"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "tal",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op70 fs12px mb0-5rem",
                        children: [
                            "Hello there, ",
                            user.firstName,
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op70 fs12px",
                        children: [
                            "Welcome to your Diligentsia ",
                            company?.subscription,
                            " adventure! To make the most of this thrilling journey and unlock the true value of your subscription, we recommend following these steps:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                        className: "tal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                className: "c15 op70 fs12px mb0-25rem",
                                children: [
                                    "First up, embark on the quest of uploading your key corporate documents to your ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Repository"
                                    }),
                                    " . This treasure trove will be your safe haven for all things important."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                className: "c15 op70 fs12px mb0-25rem",
                                children: [
                                    "Next, create a magical link between your Repository and ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Data Room"
                                    }),
                                    " preferred cloud provider. But don't worry, you won't be alone in this. We'll be your guiding star and show you the way! "
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                className: "c15 op70 fs12px mb0-25rem",
                                children: [
                                    "Now that your Repository is all set, it's time to take on your ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Quick Business Audit"
                                    }),
                                    ". Trust us, this is a battle worth fighting!"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                className: "c15 op70 fs12px mb0-25rem",
                                children: [
                                    "After your victorious battle, it's time to review your spoils! Check out your ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "reports"
                                    }),
                                    " showcasing section completeness and risk."
                                ]
                            }),
                            company?.subscription == 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: "c15 op70 fs12px mb0-25rem",
                                children: "With all the hard work done, it's time to bask in the glory of your accomplishment! Obtain your unaudited Diligentsia certificate, a badge of honor for your efforts."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                className: "c15 op70 fs12px mb0-25rem",
                                children: [
                                    "And finally, make your triumphant return to the ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Dashboard"
                                    }),
                                    ". This is your kingdom, where you can access all other modules to continue improving and strengthening your business."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op70 fs12px mb0-25rem",
                        children: [
                            "Here's to an incredible journey, ",
                            user?.firstName,
                            "! Let's conquer this adventure together! "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt2rem w100 fs1rem df jcc",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    btnType: "warning",
                    customClassName: "w40",
                    text: "Let\u2019s Go!",
                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        }))
                })
            })
        ]
    });
};
var $a2b7abf4967ef3ad$export$2e2bcd8739ae039 = $a2b7abf4967ef3ad$var$WelcomToDashboardModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $20694e2bf2131bd3$var$UserDefinedSectionModal = ({ modalType: modalType, editSectionName: editSectionName, additionalSections: additionalSections, isSectionNameDuplicate: isSectionNameDuplicate, onSaveAdditionalSections: onSaveAdditionalSections, onEdit: onEdit, onDelete: onDelete })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdr jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "pr df filing-assistant-pos jcfs aife",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "additional-sections-info pr",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-area",
                                    style: {
                                        top: '-28px',
                                        left: '-24px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                        className: "icon",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h3rem",
                                                src: (parcelRequire("24u8s")),
                                                alt: "info"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "overlay-box left",
                                                style: {
                                                    left: "34px",
                                                    top: "100%"
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15",
                                                    children: "Creating a new user-defined section here will add it to the standard Index used in the Data Repository and reporting, and will be replicated in your cloud data room (Dropbox/Drive/Sharepoint)."
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c15 fs18px fw600 tac mb2rem",
                            children: "Add/Edit Sections"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c4 fs0-75rem tac mb1rem",
                    children: "You can add up to 5 custom sections."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc jcc",
                    children: [
                        additionalSections.map((item, index)=>{
                            const isSaved = item[2] === true;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr mb1rem df fdr aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c4 fs0-875rem fw500 mr0-5rem",
                                        style: {
                                            minWidth: '1.25rem'
                                        },
                                        children: [
                                            index + 1,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: `userSection-${index}`,
                                                disabled: isSaved,
                                                value: item[1],
                                                onChange: (e)=>{
                                                    editSectionName(e.target.value, index);
                                                },
                                                type: "text",
                                                placeholder: "Enter section name...",
                                                className: `w100 br10px userSection p0-5rem ${isSectionNameDuplicate.indexes.includes(item[0]) && "error"} bs1px brss bo42`
                                            }),
                                            isSaved && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "ml0-5rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                                onClick: ()=>onDelete(index),
                                                children: "Delete"
                                            })
                                        ]
                                    })
                                ]
                            }, `addUserDefinedSection-${index}`);
                        }),
                        isSectionNameDuplicate.indexes.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "errorMessage w100 mb1rem",
                            children: [
                                isSectionNameDuplicate.indexes.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            " Sections ",
                                            item,
                                            isSectionNameDuplicate.indexes.length - 1 === index ? '' : ', ',
                                            " "
                                        ]
                                    })),
                                " have matching names. Please change one of them."
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "pr mb1rem df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                customClassName: "mt2rem w20rem",
                                btnType: "warning",
                                text: "Save Section",
                                onClick: onSaveAdditionalSections,
                                disabled: isSectionNameDuplicate.indexes.length
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $20694e2bf2131bd3$export$2e2bcd8739ae039 = $20694e2bf2131bd3$var$UserDefinedSectionModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $4ed66be3561152e3$var$DeleteFileConfirmModal = ({ deleteFile: deleteFile, onConfirm: onConfirm, onCancel: onCancel, modalType: modalType })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        style: {
                            backgroundColor: "rgba(252, 119, 133, 0.2)",
                            padding: "20px",
                            borderRadius: "50px",
                            height: "110px",
                            width: "110px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("kt5GL")),
                            alt: "deleteIcon",
                            style: {
                                height: "70px",
                                width: "70px"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "c15 fs1-75rem fw600 tac mt1-5rem",
                    children: "Delete File"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fs1rem fw400 c3 mb1rem tac",
                    children: deleteFile && deleteFile.originalname
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "c15 fs1-25rem fs1rem-sm fw400 op70 w100 tac mb1rem",
                    children: [
                        "Are you sure you want to permanently delete the file?",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "This action can\u2019t be undone."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        btnType: "warning",
                        onClick: onConfirm,
                        customClassName: "miw200px mla mra",
                        text: "Delete"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    onClick: onCancel,
                    className: "w100 tac mt0-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "fs14px cp",
                        style: {
                            color: "#15131380"
                        },
                        children: "Cancel"
                    })
                })
            ]
        })
    });
};
var $4ed66be3561152e3$export$2e2bcd8739ae039 = $4ed66be3561152e3$var$DeleteFileConfirmModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








const $d5125955c15b76de$var$WarrantyDisclosureTargetList = ({ openRModal: openRModal, setOpenRModal: setOpenRModal, reloadModule: reloadModule, setSection: setSection, section: section })=>{
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const { company: company, tab: tab, rModalData: rModalData } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const { filesMoving: filesMoving } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.files);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [selectedQuestion, setSelectedQuestion] = (0, $acw62.useState)(null);
    const Chevron = ({ className: className = "" })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: className,
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                clipRule: "evenodd"
            })
        });
    };
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const selectTargetSection = async (qNo)=>{
        setSelectedQuestion(qNo);
        const data = {
            file: rModalData?.fileData,
            "unallocated": false,
            "companyId": selectedCompany['_id'],
            "isCut": rModalData.actionType === "move",
            "qNo": qNo,
            "tab": "warranty-disclosure",
            "oldQno": rModalData?.section?.questionId,
            "isDeduper": false,
            "key": rModalData?.key,
            "sectionName": rModalData?.section?.name
        };
        let selectedData = filesMoving && filesMoving.length ? filesMoving.filter((fileMove)=>fileMove['oldQno'] !== rModalData?.section?.no) : [];
        dispatch((0, $e0a7c253e2df808f$export$4d2b8177182ba5a1)([
            ...selectedData,
            data
        ]));
    };
    const handleClose = ()=>{
        setOpenRModal(false);
    };
    const handleConfirm = async ()=>{
        setLoading(true);
        try {
            let i = 0;
            while(i < filesMoving.length){
                const selectedData = filesMoving[i];
                const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveFile', selectedData);
                if (!res || res['code'] != 200) return;
                if (selectedData.isCut) setSection((prevSection)=>{
                    if (!prevSection) return prevSection;
                    const updatedSection = JSON.parse(JSON.stringify(prevSection));
                    const questionIndex = updatedSection.questions.findIndex((q)=>q.qNo === selectedData.oldQno);
                    if (questionIndex === -1) return prevSection;
                    const originalFiles = updatedSection.questions[questionIndex].answer?.files || [];
                    const filteredFiles = originalFiles.filter((file)=>file.key !== selectedData?.key);
                    // Update in the questions array
                    updatedSection.questions[questionIndex].answer.files = filteredFiles;
                    // Also update in the standalone question object if it's the same qNo
                    if (updatedSection.question?.qNo === selectedData.oldQno) updatedSection.question.answer.files = filteredFiles;
                    console.log("*******", updatedSection, "**********");
                    return updatedSection;
                });
                i++;
            }
            setOpenRModal(false);
            reloadModule("warranty-disclosure", false, false, true);
            dispatch((0, $e0a7c253e2df808f$export$4d2b8177182ba5a1)([]));
        } catch (err) {
            console.log(err);
        } finally{
            setLoading(false);
        }
    };
    const getSectionDropDown = (section, fileKey, from, index)=>{
        const qNo = section.sectionNo || section.no;
        const name = section.sectionName || section.name; // Section name
        if (section.questions) // Main section with dropdown (only for top-level sections)
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$d99097c13d4dac9f), {
            children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lightBorder mb0-5rem w100 jcsb cp ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1be75d49f257bf03$export$5e3e5deaaf81ee41), {
                            className: "df aic jcsb bg1 w100 dropdown-section-header px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    className: "c15 fw400 tal",
                                    children: [
                                        qNo,
                                        ". - ",
                                        name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)(Chevron, {
                                    className: `w2rem h2rem c3 td300 ml0-5rem ${!open ? "tr90deg" : "tr270deg"}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$4f68206c92b94e7b), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: section.questions.map((question)=>{
                                    const subFolder = {
                                        sectionNo: question?.qNo,
                                        sectionName: section?.name
                                    };
                                    return getSectionDropDown(subFolder, fileKey, from, index);
                                })
                            })
                        })
                    ]
                })
        }, qNo);
        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `rs-dropdown-item ${selectedQuestion && qNo === selectedQuestion ? 'selected' : ''}`,
            onClick: ()=>selectTargetSection(qNo),
            children: [
                qNo,
                ". ",
                name
            ]
        }, qNo);
    };
    const getModuleDropdown = (module, key, from, index)=>{
        if (module?.sections?.length == 1) {
            const singleSection = module?.sections[0];
            if (singleSection.subFolders) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: Object.values(singleSection.subFolders).map((section)=>{
                    return getSectionDropDown(section, key, from, index);
                })
            });
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: module?.sections && Object.values(module?.sections).map((section)=>{
                return getSectionDropDown(section, key, from, index);
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9a6d1502d000f566$export$2e2bcd8739ae039), {
            overflow: true,
            open: openRModal,
            onClose: handleClose,
            style: {
                zIndex: '2000'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9a6d1502d000f566$export$2e2bcd8739ae039).Header, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic jcfs",
                            children: [
                                "move",
                                "reallocate"
                            ].includes(rModalData.actionType) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("3CMpU")),
                                        alt: "moveFileIcon",
                                        style: {
                                            width: '40px',
                                            height: '40px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15 fw600 ml0-5rem fs20px",
                                        children: "reallocate" === rModalData.actionType ? "Reallocate File" : "Move File"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("4aBsx")),
                                        alt: "moveFileImg",
                                        style: {
                                            width: '40px',
                                            height: '40px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15 fw600 ml0-5rem fs20px",
                                        children: "Copy File"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c3",
                            children: rModalData.fileName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a6d1502d000f566$export$2e2bcd8739ae039).Body, {
                    style: {
                        maxHeight: "550px",
                        paddingRight: "16px"
                    },
                    className: "lightScrollbar",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$a766cd26d0d69044), {
                        children: (()=>{
                            let module = company?.modules[tab] ?? selectedCompany?.modules[tab];
                            if (module) module = JSON.parse(JSON.stringify(module));
                            return getModuleDropdown(module, rModalData.key, rModalData.from, rModalData.index);
                        })()
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        text: rModalData.actionType === "copy" ? "Copy File" : "Move File",
                        btnType: "warning",
                        onClick: handleConfirm,
                        customClassName: "mla mra c1",
                        disabled: selectedQuestion === null || loading
                    })
                })
            ]
        })
    });
};
var $d5125955c15b76de$export$2e2bcd8739ae039 = $d5125955c15b76de$var$WarrantyDisclosureTargetList;



var $003a88e0f3de542d$var$FileManager = function FileManager(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M5.596 4h11.73c.916 0 1.787.107 2.584.528l.073.042c.804.446 1.453 1.179 1.872 2.372l.972 2.775h3.577c1.265 0 2.415.51 3.247 1.328A4.476 4.476 0 0 1 31 14.24v10.236a4.476 4.476 0 0 1-1.35 3.196A4.622 4.622 0 0 1 26.405 29H5.596a4.622 4.622 0 0 1-3.247-1.328l-.067-.072A4.47 4.47 0 0 1 1 24.476V8.524c0-1.242.517-2.372 1.35-3.192v-.004A4.622 4.622 0 0 1 5.595 4Zm4.52 11.667c0-.614.505-1.111 1.128-1.111a1.12 1.12 0 0 1 1.129 1.11v.285c.209.065.41.147.602.245l.204-.201a1.142 1.142 0 0 1 1.597 0c.44.434.44 1.137 0 1.571l-.206.202c.1.188.184.386.25.591h.29a1.12 1.12 0 0 1 1.129 1.111 1.12 1.12 0 0 1-1.13 1.111h-.288c-.066.206-.15.405-.25.593l.205.201c.44.434.44 1.138 0 1.572a1.142 1.142 0 0 1-1.597 0l-.206-.203a3.769 3.769 0 0 1-.6.246v.285a1.12 1.12 0 0 1-1.129 1.111 1.12 1.12 0 0 1-1.129-1.11v-.286a3.778 3.778 0 0 1-.6-.246l-.207.203a1.142 1.142 0 0 1-1.596 0 1.099 1.099 0 0 1 0-1.572l.204-.2a3.658 3.658 0 0 1-.25-.594h-.288a1.12 1.12 0 0 1-1.13-1.11 1.12 1.12 0 0 1 1.13-1.111h.29c.066-.206.15-.404.25-.592l-.206-.202a1.099 1.099 0 0 1 0-1.571 1.142 1.142 0 0 1 1.596 0l.205.201c.192-.098.393-.18.602-.245v-.284ZM12.3 18.43a1.517 1.517 0 0 0-2.113.002 1.454 1.454 0 0 0 0 2.077c.268.266.642.43 1.056.43a1.47 1.47 0 0 0 1.492-1.469c0-.407-.167-.775-.435-1.04Zm5.026-12.208H5.597a2.35 2.35 0 0 0-1.651.677 2.268 2.268 0 0 0-.688 1.625v15.952c0 .61.243 1.166.638 1.579l.05.046a2.35 2.35 0 0 0 1.65.677h20.808a2.35 2.35 0 0 0 1.65-.677c.424-.417.688-.993.688-1.625V14.24c0-.631-.264-1.207-.688-1.624a2.35 2.35 0 0 0-1.65-.677h-4.38c-.47-.001-.908-.29-1.068-.751l-1.235-3.525c-.215-.613-.5-.967-.83-1.158l-.048-.024c-.391-.206-.924-.26-1.516-.26Z",
            fill: "#4A67FF"
        })
    });
};
$003a88e0f3de542d$var$FileManager.defaultProps = {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $003a88e0f3de542d$var$Delete = function Delete(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.552 6.89a.722.722 0 0 0-.722.723v8.082a1.387 1.387 0 0 1-1.452 1.307H7.615a1.386 1.386 0 0 1-1.452-1.307V7.613a.722.722 0 1 0-1.444 0v8.082a2.83 2.83 0 0 0 2.896 2.751h5.763a2.83 2.83 0 0 0 2.896-2.75V7.612a.722.722 0 0 0-.722-.722ZM16.278 4.721h-2.89V3.277a.722.722 0 0 0-.721-.722H8.333a.722.722 0 0 0-.722.722V4.72H4.722a.722.722 0 0 0 0 1.445h11.556a.722.722 0 0 0 0-1.445Zm-7.222 0V4h2.888v.722H9.056Z",
                fill: "#F14D4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.78 14.114V9.058a.722.722 0 1 0-1.444 0v5.056a.722.722 0 1 0 1.444 0ZM12.663 14.114V9.058a.722.722 0 0 0-1.444 0v5.056a.722.722 0 1 0 1.444 0Z",
                fill: "#F14D4D"
            })
        ]
    });
};
$003a88e0f3de542d$var$Delete.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $003a88e0f3de542d$var$Copy = function Copy(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M5.59 18h6.82a2.585 2.585 0 0 0 2.556-2.25h.445A2.592 2.592 0 0 0 18 13.16V5.59A2.592 2.592 0 0 0 15.41 3H8.59A2.592 2.592 0 0 0 6 5.59V6h-.41A2.592 2.592 0 0 0 3 8.59v6.82A2.592 2.592 0 0 0 5.59 18ZM7.5 5.59c0-.601.489-1.09 1.09-1.09h6.82c.601 0 1.09.489 1.09 1.09v7.57c0 .601-.489 1.09-1.09 1.09H15V8.59A2.592 2.592 0 0 0 12.41 6H7.5v-.41Zm-3 3c0-.601.489-1.09 1.09-1.09h6.82c.601 0 1.09.489 1.09 1.09v6.82c0 .601-.489 1.09-1.09 1.09H5.59c-.601 0-1.09-.489-1.09-1.09V8.59Z",
            fill: "#4A67FF"
        })
    });
};
$003a88e0f3de542d$var$Copy.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $003a88e0f3de542d$var$Downloads = function Downloads(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14.667 18H6.333c-.89 0-1.727-.347-2.357-.976A3.311 3.311 0 0 1 3 14.667v-.834a.833.833 0 1 1 1.667 0v.834c0 .445.173.863.488 1.178.315.315.733.488 1.178.488h8.334c.445 0 .863-.173 1.178-.488.315-.315.488-.733.488-1.178v-.834a.833.833 0 1 1 1.667 0v.834c0 .89-.347 1.727-.976 2.357-.63.63-1.467.976-2.357.976ZM10.5 14.667a.831.831 0 0 1-.582-.237l-.002-.002-.002-.002-.001-.002-.002-.001-3.334-3.334a.833.833 0 0 1 1.179-1.178l1.91 1.91V3.833a.833.833 0 1 1 1.667 0v7.988l1.911-1.91a.833.833 0 0 1 1.179 1.178l-3.334 3.334-.002.001v.001l-.001.001-.002.001-.002.003a.827.827 0 0 1-.258.172h-.001a.828.828 0 0 1-.323.065Z",
            fill: "#4A67FF"
        })
    });
};
$003a88e0f3de542d$var$Downloads.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $003a88e0f3de542d$var$Send = function Send(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.493 5.031c-.358 0-.693-.175-.898-.468L9.81 3.437a2.406 2.406 0 0 0-1.974-1.03H3.5a2.406 2.406 0 0 0-2.406 2.405v11.375c0 .638.253 1.25.704 1.702a2.41 2.41 0 0 0 1.702.705h14a2.41 2.41 0 0 0 1.702-.705 2.41 2.41 0 0 0 .704-1.701v-8.75a2.41 2.41 0 0 0-.704-1.702A2.41 2.41 0 0 0 17.5 5.03h-6.007Zm0 1.313H17.5a1.096 1.096 0 0 1 1.094 1.093v8.75a1.095 1.095 0 0 1-1.094 1.094h-14a1.095 1.095 0 0 1-1.094-1.093V4.813c0-.604.49-1.094 1.094-1.094h4.337c.357 0 .693.175.897.468l.785 1.126a2.405 2.405 0 0 0 1.974 1.03Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.192 11.008H7.808a.808.808 0 0 0 0 1.615h5.384a.808.808 0 0 0 0-1.615Z",
                fill: "#4A67FF"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m10.471 10.23 1.582 1.583-1.582 1.583a.807.807 0 1 0 1.142 1.141l2.153-2.153a.806.806 0 0 0 0-1.142l-2.153-2.154a.807.807 0 1 0-1.142 1.142Z",
                fill: "#4A67FF"
            })
        ]
    });
};
$003a88e0f3de542d$var$Send.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};

const $003a88e0f3de542d$var$WarrantyDisclosureManageFilesModal = ({ modalType: modalType, section: section, company: company, setSection: setSection, getViewableURL: getViewableURL, setDeleteFileQuestionId: setDeleteFileQuestionId, setDeleteFile: setDeleteFile, tab: tab, reloadModule: reloadModule })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { fileManageSection: fileManageSection } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.files);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [openRModal, setOpenRModal] = (0, $acw62.useState)(false);
    const moveFile = async ({ file: file, qNo: qNo, curQno: curQno, isCut: isCut, sectionName: sectionName })=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveFile', {
            file: file,
            unallocated: false,
            companyId: company._id,
            isCut: isCut,
            qNo: qNo,
            tab: tab,
            oldQno: curQno,
            isDeduper: false,
            key: file.key,
            sectionName: sectionName
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        reloadModule(tab, false, false, true);
    };
    (0, $acw62.useEffect)(()=>{
        if (Object.keys(fileManageSection).length && modal.open === "manageWarrantyDisclosureFiles") {
            setSection(fileManageSection.sectionData);
            dispatch((0, $e0a7c253e2df808f$export$6d5d8bd59e3ba7ac)({}));
            moveFile({
                file: fileManageSection.selectFile[0],
                qNo: fileManageSection.qNo,
                curQno: fileManageSection.sectionData.sectionNo ?? fileManageSection.sectionData.no,
                isCut: fileManageSection.actionType === "move" ? true : false,
                sectionName: fileManageSection.sectionData.name ?? fileManageSection.sectionData.sectionName
            });
        }
    }, [
        fileManageSection
    ]);
    const handleEditDispatch = async (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        setOpenRModal(true);
    };
    const getFileHTML = (sec, file, index)=>{
        let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
        const key = file.key;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb aic w100 pr1rem pt0-5rem td250 bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: ()=>getViewableURL(file.location),
                        className: `mr1rem pl2rem cp tdu fs1rem pr fw600 bg1 ${fileColor} fileManageFileName w100`,
                        children: file.originalname
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mr1rem w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rs-nav rs-nav-default",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "rs-dropdown-toggle rs-nav-item c2 fsi",
                                children: sec?.['question']['qNo'] ? `${sec?.['question']['qNo']} ${sec['sectionName']}` : sec?.['question']['no'] ? `${sec?.['question']['no']} ${sec['name']}` : 'Please select section'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($003a88e0f3de542d$var$Send, {
                                "data-tooltip": "Move",
                                className: "mr1rem cp",
                                onClick: ()=>handleEditDispatch({
                                        key: key,
                                        fileName: file.title,
                                        actionType: "move",
                                        fileData: file,
                                        index: index,
                                        section: sec
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($003a88e0f3de542d$var$Copy, {
                                "data-tooltip": "Copy",
                                className: "mr1rem cp",
                                onClick: ()=>handleEditDispatch({
                                        key: key,
                                        fileName: file.title,
                                        actionType: "copy",
                                        fileData: file,
                                        index: index,
                                        section: sec
                                    })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "df",
                                target: "_blank",
                                to: file.url,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($003a88e0f3de542d$var$Downloads, {
                                    "data-tooltip": "Download",
                                    className: `f3 cp mr1rem ${tab == 'repository' ? '' : 'mla'}`
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($003a88e0f3de542d$var$Delete, {
                                className: "cp",
                                "data-tooltip": "Delete",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setDeleteFileQuestionId(file.questionId);
                                    setDeleteFile(file);
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'deleteFile',
                                        from: 'manageFiles'
                                    }));
                                }
                            })
                        ]
                    })
                ]
            })
        }, `${index}-aja-${new Date().getTime()}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            modalCardClasses: "maw1000px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "c15 fw600 tal df aic mb0-5rem fs1-25em",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($003a88e0f3de542d$var$FileManager, {
                            className: "mr1rem"
                        }),
                        " File Manager"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "c3 fs1rem-sm w100 fw400 tal mb2rem",
                        children: [
                            section && (section.sectionNo || section.no),
                            " - ",
                            section && (section.sectionName || section.name)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: "list-file-manager",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 upload-file",
                            children: "Uploaded Directly"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 prepopulated-file",
                            children: "Companies House"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 filing-assistant-file",
                            children: "Filing Assistant"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 sharepoint-file",
                            children: "Sharepoint"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 dropbox-file",
                            children: "Dropbox"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                            className: "bg1 fw400 c2 gdrive-file",
                            children: "Drive"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "devider"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg mb2rem fs1rem lightScrollbar",
                    style: {
                        maxHeight: "300px",
                        overflowY: 'scroll'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb aic w100 pr1rem mt1rem pt0-5rem td250 bsbb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c37 fs12px op60",
                                        children: "File Name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c37 fs12px op60",
                                        style: {
                                            marginLeft: '22px'
                                        },
                                        children: "Section"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c37 fs12px op60",
                                        style: {
                                            marginLeft: '12px'
                                        },
                                        children: "Actions"
                                    })
                                })
                            ]
                        }),
                        section && section.question && section.question.answer.files.length > 0 && section.question.answer.files.map((file, index)=>{
                            return getFileHTML(section, file, index);
                        })
                    ]
                }),
                section && section.question && section.question.answer && (section.question.answer.files || section.question.answer.files.length == 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc jcc aic m2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("8S7PI")),
                            alt: "fileManagement"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1rem fw600 mt1rem tac c15 op80",
                            children: "No files found"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5125955c15b76de$export$2e2bcd8739ae039), {
                    openRModal: openRModal,
                    setOpenRModal: setOpenRModal,
                    reloadModule: reloadModule,
                    setSection: setSection,
                    section: section
                })
            ]
        })
    });
};
var $003a88e0f3de542d$export$2e2bcd8739ae039 = $003a88e0f3de542d$var$WarrantyDisclosureManageFilesModal;




const $866b869d60dd72c1$var$AI_REPORT_DISCLAIMER_KEY = 'isAgreeWithAIReportDisclaimer';
const $866b869d60dd72c1$var$INSURANCE_REPORT_LOADING_STORAGE_KEY = 'insuranceReportGenerationStatus';
const $866b869d60dd72c1$var$PRIORITY_OPTIONS = [
    "High Priority",
    "Medium Priority",
    "Low Priority",
    "N/A"
];
const $866b869d60dd72c1$var$PRIORITY_COLORS = {
    "High Priority": "#EB5A46",
    "Medium Priority": "#FD9E31",
    "Low Priority": "#F1D52F",
    "N/A": "#BBBBBB"
};
const $866b869d60dd72c1$var$STATUS_COLORS = {
    "Not Started": "#929090",
    "Not Applicable": "#dbdbdb",
    "In Progress": "#F1D52F",
    "Ready for Review": "#13CB5D",
    "Completed": "#13CB5D"
};
const $866b869d60dd72c1$var$questionMarkSvg = /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
    class: "ml0-5rem",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
            "clip-path": "url(#clip0_1353_49127)",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M7.5 15C11.6356 15 15 11.6356 15 7.5C15 3.36437 11.6356 0 7.5 0C3.36437 0 0 3.36437 0 7.5C0 11.6356 3.36437 15 7.5 15ZM7.5 1.5C10.8083 1.5 13.5 4.19165 13.5 7.5C13.5 10.8083 10.8083 13.5 7.5 13.5C4.19165 13.5 1.5 10.8083 1.5 7.5C1.5 4.19165 4.19165 1.5 7.5 1.5Z",
                    fill: "#59B8FD"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M7.24721 9.64951C7.08633 9.64951 6.95622 9.51454 6.95622 9.34765C6.95622 8.95282 7.01021 8.61176 7.11764 8.32502C7.19646 8.10885 7.32441 7.891 7.50041 7.6709C7.62998 7.51073 7.86212 7.27664 8.19792 6.96974C8.53372 6.66228 8.75182 6.41754 8.85278 6.23497C8.95373 6.0524 9.0034 5.85303 9.0034 5.63685C9.0034 5.24539 8.85602 4.90208 8.56179 4.60583C8.26756 4.30957 7.90639 4.16172 7.47881 4.16172C7.06581 4.16172 6.72084 4.29613 6.44443 4.56438C6.24251 4.7604 6.09081 5.03705 5.9904 5.39436C5.92129 5.63965 5.69077 5.79646 5.44621 5.76622C5.13632 5.72814 4.93225 5.41004 5.02079 5.09922C5.15684 4.62151 5.38466 4.23676 5.70373 3.94442C6.14696 3.53728 6.73325 3.33398 7.46262 3.33398C8.23463 3.33398 8.85062 3.55184 9.31059 3.98811C9.77056 4.42437 10 4.95137 10 5.56965C10 5.92751 9.91902 6.25737 9.7576 6.55867C9.59618 6.86053 9.27982 7.22735 8.80959 7.6597C8.49377 7.95036 8.287 8.16485 8.18982 8.30262C8.09264 8.44039 8.02084 8.59888 7.97441 8.77753C7.93986 8.91026 7.91611 9.10515 7.90315 9.36109C7.89505 9.52238 7.76602 9.64895 7.61054 9.64895H7.24721V9.64951ZM6.90223 11.0944C6.90223 10.778 7.14949 10.5215 7.45452 10.5215C7.75955 10.5215 8.00681 10.778 8.00681 11.0944C8.00681 11.4108 7.75955 11.6673 7.45452 11.6673C7.14949 11.6673 6.90223 11.4108 6.90223 11.0944Z",
                    fill: "#59B8FD",
                    stroke: "#59B8FD",
                    "stroke-width": "0.5"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                id: "clip0_1353_49127",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                    width: "15",
                    height: "15",
                    fill: "white"
                })
            })
        })
    ]
});
const $866b869d60dd72c1$var$canUseBrowserStorage = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $866b869d60dd72c1$var$readJsonFromStorage = (key, fallbackValue)=>{
    if (!$866b869d60dd72c1$var$canUseBrowserStorage()) return fallbackValue;
    try {
        const rawValue = window.localStorage.getItem(key);
        if (!rawValue) return fallbackValue;
        const parsedValue = JSON.parse(rawValue);
        return parsedValue ?? fallbackValue;
    } catch (error) {
        return fallbackValue;
    }
};
const $866b869d60dd72c1$var$writeJsonToStorage = (key, value)=>{
    if (!$866b869d60dd72c1$var$canUseBrowserStorage()) return;
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
    // Ignore storage write failures (quota exceeded, private mode, etc.)
    }
};
const $866b869d60dd72c1$var$getPersistedReportLoadingMap = ()=>{
    const stored = $866b869d60dd72c1$var$readJsonFromStorage($866b869d60dd72c1$var$INSURANCE_REPORT_LOADING_STORAGE_KEY, {});
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
        $866b869d60dd72c1$var$writeJsonToStorage($866b869d60dd72c1$var$INSURANCE_REPORT_LOADING_STORAGE_KEY, {});
        return {};
    }
    return stored;
};
const $866b869d60dd72c1$var$getAiReportDisclaimerAgreements = ()=>{
    const stored = $866b869d60dd72c1$var$readJsonFromStorage($866b869d60dd72c1$var$AI_REPORT_DISCLAIMER_KEY, []);
    if (!Array.isArray(stored)) {
        $866b869d60dd72c1$var$writeJsonToStorage($866b869d60dd72c1$var$AI_REPORT_DISCLAIMER_KEY, []);
        return [];
    }
    return stored;
};

function $866b869d60dd72c1$var$WorkflowInlinePanel({ answer: answer, question: question, section: section, module: module, company: company, user: user, onAnswerUpdated: onAnswerUpdated }) {
    const [noteText, setNoteText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [localAnswer, setLocalAnswer] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(answer);
    const [hoveredNoteIdx, setHoveredNoteIdx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setLocalAnswer(answer);
    }, [
        answer
    ]);
    const answerId = localAnswer?._id;
    const moduleName = module?.type;
    const companyId = company?._id;
    const callAddNote = async (payload)=>{
        if (!answerId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Answer not saved yet \u2014 please answer the question first.");
            return null;
        }
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            ...payload,
            companyId: companyId,
            moduleName: moduleName
        });
        if (res?.code === 200) {
            if (res.body) setLocalAnswer(res.body);
            if (onAnswerUpdated) onAnswerUpdated(res.body);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        return res;
    };
    const handleSaveNote = async ()=>{
        const trimmed = noteText.trim();
        if (!trimmed) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Cannot save an empty note!");
            return;
        }
        setSaving(true);
        await callAddNote({
            taskNotes: [
                {
                    note: trimmed
                }
            ]
        });
        setNoteText("");
        setSaving(false);
    };
    const handleDeleteNote = async (noteId)=>{
        if (!answerId) return;
        setSaving(true);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/deleteTaskNote/${answerId}/${noteId}`);
        if (res?.code === 200) {
            if (res.body) setLocalAnswer(res.body);
            if (onAnswerUpdated) onAnswerUpdated(res.body);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        setSaving(false);
    };
    const notes = [
        ...localAnswer?.taskNotes || []
    ].sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        class: "w100 px0-5rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw1px bo5 br10px df aic px0-75rem py0-5rem mb0-5rem bg1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        rows: 3,
                        placeholder: "Add workflow note",
                        value: noteText,
                        onChange: (e)=>setNoteText(e.target.value),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleSaveNote();
                            }
                        },
                        className: "w100 fs12px c15 pt0-5rem",
                        style: {
                            resize: 'none',
                            outline: 'none',
                            border: 'none'
                        }
                    }),
                    noteText.trim() && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: handleSaveNote,
                        disabled: saving,
                        className: "df aic jcc br50px cp c1 bg4 mt1rem",
                        style: {
                            width: '25px',
                            height: '25px',
                            flexShrink: 0,
                            border: 'none'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "11",
                            height: "10",
                            viewBox: "0 0 11 10",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.0574 0.0122099L0.613533 1.73084C0.489687 1.75309 0.373531 1.80646 0.275979 1.88593C0.178427 1.96541 0.102682 2.06838 0.0558623 2.18517C0.00904232 2.30197 -0.00731535 2.42875 0.00832603 2.5536C0.0239674 2.67845 0.0710945 2.79728 0.145279 2.89891L3.95682 5.2719L5.0353 9.63032C5.10902 9.73229 5.20746 9.81384 5.32136 9.86731C5.43526 9.92078 5.56088 9.94442 5.68643 9.936C5.81198 9.92757 5.93332 9.88737 6.03906 9.81917C6.1448 9.75096 6.23146 9.65699 6.2909 9.54609L10.8448 1.09605C10.9117 0.97287 10.9423 0.833281 10.9331 0.693431C10.9239 0.553581 10.8753 0.419186 10.793 0.305797C10.7106 0.192408 10.5978 0.104659 10.4676 0.0527035C10.3375 0.000747471 10.1953 -0.0132919 10.0574 0.0122099Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            notes.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df fdc gg0-75rem py0-5rem bg1 br10px",
                style: {
                    maxHeight: '20vh',
                    overflowY: 'auto'
                },
                children: notes.map((item, idx)=>{
                    const isAiNote = !!item?.isAi || item?.user?.firstName === 'Clarence' || item?.note && item.note.startsWith(' AI Answer');
                    const hasProfile = !isAiNote && !!item?.user?.profile;
                    const firstName = item?.user?.firstName || "";
                    const lastName = item?.user?.lastName || "";
                    const initials = (firstName[0] || "") + (lastName[0] || "") || "?";
                    const fullName = firstName ? `${firstName} ${lastName}`.trim() : "Guest User";
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aifs gg0-75rem py0-5rem px1rem pr",
                        onMouseEnter: ()=>setHoveredNoteIdx(idx),
                        onMouseLeave: ()=>setHoveredNoteIdx(null),
                        children: [
                            isAiNote ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("bi4Ns")),
                                className: "w30px h30px br50px mr0-5rem",
                                alt: "Clarence",
                                style: {
                                    flexShrink: 0,
                                    alignSelf: 'flex-start'
                                }
                            }) : hasProfile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: item.user.profile,
                                className: "w30px h30px br50px mr0-5rem",
                                alt: fullName,
                                style: {
                                    flexShrink: 0,
                                    alignSelf: 'flex-start'
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "df jcc aic w30px h30px mr0-5rem fw500 fs12px c14 bg5 bw1px bss bo16 br50px",
                                style: {
                                    flexShrink: 0,
                                    alignSelf: 'flex-start'
                                },
                                children: initials
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs13px fw600 c52",
                                        children: fullName
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs11px c14 fw400",
                                        style: {
                                            marginLeft: '6px'
                                        },
                                        children: item.note
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs9px c12 mb0",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(item.createdAt).format("MMM D, YYYY, h:mmA")
                                    })
                                ]
                            }),
                            !isAiNote && hoveredNoteIdx === idx && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleDeleteNote(item._id),
                                disabled: saving,
                                className: "pa cp df aic jcc br50px bg1 bw1px bss bo16",
                                style: {
                                    top: '10px',
                                    right: '10px',
                                    width: '24px',
                                    height: '24px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fa fa-trash-o c23"
                                })
                            })
                        ]
                    }, idx);
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "tac fs13px c12 mt1rem",
                children: "No notes yet. Add the first one above."
            })
        ]
    });
}
























function $866b869d60dd72c1$export$2e2bcd8739ae039({ isManualAdd: isManualAdd, getCompany: getCompany, setIsWorkflowReport: setIsWorkflowReport, profileClass: profileClass, advisors: advisors, permissionLevel: permissionLevel, tab: tab, setTab: setTab, sanitiseTab: sanitiseTab, company: company, setCompany: setCompany, companyId: companyId, openKPI: openKPI, toggleReport: toggleReport, enableAIEnhancedReporting: enableAIEnhancedReporting, calculateStats: calculateStats, calculateSubFolderStats: calculateSubFolderStats, getCompletenessAndRiskHTML: getCompletenessAndRiskHTML, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, reloadModule: reloadModule, twoMinuteTestAIReport: twoMinuteTestAIReport, getFitInvestorFirms: getFitInvestorFirms, isTwoMinuteTesHomePage: isTwoMinuteTesHomePage, setOpenTabs: setOpenTabs, openTabs: openTabs, companyIndex: companyIndex, setCompanyDashboardTab: setCompanyDashboardTab, setCloneImportResult: setCloneImportResult, setCurrentScore: setCurrentScore, reportHistories: reportHistories, setReportHistories: setReportHistories, setFileReport: setFileReport, sortSections: sortSections, showAlert: showAlert, handleSuperflowNext: handleSuperflowNext, setTabName: setTabName, closeTab: closeTab, isBackFitReport: isBackFitReport, setIsBackFitReport: setIsBackFitReport, isLoader: isLoader, setIsLoader: setIsLoader }) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let spinner = document.getElementById("e1jygW4piZH1");
    let { syncing: syncing } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.appData);
    let { unallocatedFiles: unallocatedFiles, deduperReports: dupCheck } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.files);
    let { logList: logList, targetSection: targetSection, processing: processing } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    // Reload module data when auto-fill completes so answers appear without page refresh
    (0, $acw62.useEffect)(()=>{
        if (!modal.autoFillJustCompleted) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            autoFillJustCompleted: false
        }));
        if (tab && reloadModule) reloadModule(tab);
    }, [
        modal.autoFillJustCompleted
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Reload module data after a Auditor Fix is applied
    (0, $acw62.useEffect)(()=>{
        if (!modal.diagnoseFixJustApplied) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            diagnoseFixJustApplied: false
        }));
        if (tab && reloadModule) reloadModule(tab, true);
    }, [
        modal.diagnoseFixJustApplied
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    let companyObjectId = company?._id;
    let reportGenerationRequestRef = (0, $acw62.useRef)(null);
    let lastReportAnchorRef = (0, $acw62.useRef)(null); // Stores anchor to scroll when closing report
    let isComponentMountedRef = (0, $acw62.useRef)(false);
    // Helper function to generate unique key for section/question
    const getReportGenerationKey = (data, isQuestion)=>{
        if (isQuestion) {
            // For questions: use sectionId + questionId or qNo
            const sectionId = data?.sectionId || data?.section?._id;
            const questionId = data?._id || data?.qNo;
            return `question-${sectionId}-${questionId}`;
        } else {
            // For sections: use sectionId
            const sectionId = data?._id || data?.section?._id;
            return `section-${sectionId}`;
        }
    };
    const [reportGenerateLoading, setReportGenerateLoadingState] = (0, $acw62.useState)(()=>{
        if (!companyObjectId) return null;
        const loadingMap = $866b869d60dd72c1$var$getPersistedReportLoadingMap();
        const entry = loadingMap[companyObjectId];
        if (entry && entry.status === 'pending') {
            reportGenerationRequestRef.current = entry.requestId || null;
            return entry.generatingKey || null;
        }
        return null;
    });
    const [agreedAiReportDisclaimerIds, setAgreedAiReportDisclaimerIds] = (0, $acw62.useState)(()=>$866b869d60dd72c1$var$getAiReportDisclaimerAgreements());
    const hasAgreedAiReportDisclaimer = companyObjectId ? agreedAiReportDisclaimerIds.includes(companyObjectId) : false;
    let [section, setSection] = (0, $acw62.useState)();
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    let [loading, setLoading] = (0, $acw62.useState)(false);
    let [logModule, setLogModule] = (0, $acw62.useState)([]);
    let [dateValue, setDateValue] = (0, $acw62.useState)({});
    let [deleteFile, setDeleteFile] = (0, $acw62.useState)();
    let [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    let [saveTimeout, setSaveTimeout] = (0, $acw62.useState)();
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [openToolboxes, setOpenToolboxes] = (0, $acw62.useState)({});
    let [uploadOpenMap, setUploadOpenMap] = (0, $acw62.useState)({});
    let [visibleSection, setVisibleSection] = (0, $acw62.useState)(null);
    let [isFAMenuVisible, setFAMenuVisible] = (0, $acw62.useState)(false);
    let [newUpgradeSync, setNewUpgradeSync] = (0, $acw62.useState)(false);
    let [rightPanelTabMap, setRightPanelTabMap] = (0, $acw62.useState)({});
    let [rightPanelOpenMap, setRightPanelOpenMap] = (0, $acw62.useState)({});
    let [deleteFileLoading, setDeleteFileLoading] = (0, $acw62.useState)(false);
    let [deleteFileQuestionId, setDeleteFileQuestionId] = (0, $acw62.useState)();
    let [deleteUnallocatedFile, setDeleteUnallocatedFile] = (0, $acw62.useState)();
    let [questionsAndAnswersToSave, setQuestionsAndAnswersToSave] = (0, $acw62.useState)([]);
    let [dataRoomMenuVisible, setDataRoomMenuVisible] = (0, $acw62.useState)(true);
    const toggleToolbox = (0, $acw62.useCallback)((questionId)=>{
        setOpenToolboxes((prev)=>({
                ...prev,
                [questionId]: prev[questionId] !== true
            }));
    }, []);
    const patchAnswerInline = (0, $acw62.useCallback)((questionId, moduleName, updatedAnswer)=>{
        if (!updatedAnswer) return;
        const companyClone = JSON.parse(JSON.stringify(company));
        const mod = companyClone?.modules?.[moduleName];
        if (!mod) return;
        if (mod?.expansionPack) for (const key of Object.keys(mod.sections[0]?.subFolders || {})){
            const sec = mod.sections[0].subFolders[key];
            const qi = sec.questions?.findIndex((q)=>q._id == questionId);
            if (qi >= 0) {
                sec.questions[qi] = {
                    ...sec.questions[qi],
                    answer: updatedAnswer
                };
                break;
            }
        }
        else for (const sec of mod?.sections || []){
            const qi = sec.questions?.findIndex((q)=>q._id == questionId);
            if (qi >= 0) {
                sec.questions[qi] = {
                    ...sec.questions[qi],
                    answer: updatedAnswer
                };
                break;
            }
        }
        companyClone.modules[moduleName] = mod;
        dispatch(setCompany(calculateStats(companyClone, tab, 'check2')));
    }, [
        company,
        calculateStats,
        tab
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const handleInlinePriority = (0, $acw62.useCallback)(async (answerId, question, mod, priority)=>{
        if (!answerId) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Answer not saved yet \u2014 please answer the question first.");
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            taskPriority: priority,
            companyId: company['_id'],
            moduleName: mod.type
        });
        if (res?.code !== 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        const updatedAnswer = res.body;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        const companyClone = JSON.parse(JSON.stringify(company));
        const modClone = companyClone?.modules?.[mod.type];
        if (!modClone) return;
        if (modClone?.expansionPack) for (const key of Object.keys(modClone.sections[0]?.subFolders || {})){
            const sec = modClone.sections[0].subFolders[key];
            const qi = sec.questions?.findIndex((q)=>q._id == question._id);
            if (qi >= 0) {
                sec.questions[qi] = {
                    ...sec.questions[qi],
                    answer: updatedAnswer
                };
                break;
            }
        }
        else for (const sec of modClone?.sections || []){
            const qi = sec.questions?.findIndex((q)=>q._id == question._id);
            if (qi >= 0) {
                sec.questions[qi] = {
                    ...sec.questions[qi],
                    answer: updatedAnswer
                };
                break;
            }
        }
        companyClone.modules[mod.type] = modClone;
        dispatch(setCompany(calculateStats(companyClone, tab, 'check2')));
    }, [
        company,
        calculateStats,
        tab
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>{
        const isMember = company['members']?.some((member)=>member._id === user._id) || company?.['advisors']?.[user._id];
        const hasAllPermissions = company ? (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['memberPermissions']?.[user._id]) || (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['advisors']?.[user._id]?.['modules']) : false;
        const isInvestorOwner = company?.['investors'] && Object.keys(company['investors']).length > 0 && company['investors'][user._id] && (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['investors']?.[user._id]?.['modules']);
        if (!company?.isParent && company['owners'][0] === user._id || company?.isParent && company['owners'][0] === user._id || (company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id || isMember && hasAllPermissions || isInvestorOwner) setDataRoomMenuVisible(true);
        else setDataRoomMenuVisible(false);
    }, [
        company
    ]);
    // State to track which section to navigate to after disclaimer
    const [sectionToNavigate, setSectionToNavigate] = (0, $acw62.useState)(null);
    // Ref to track section navigation to avoid stale closures in callbacks
    const sectionToNavigateRef = (0, $acw62.useRef)(null);
    // Store the expected reportType after generation to find it after refetch
    const expectedReportTypeRef = (0, $acw62.useRef)(null);
    // Helper function to sanitize section name for URLs (matches backend logic)
    const sanitizeSectionName = (name)=>{
        if (!name) return '';
        return name.toLowerCase().replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, '') // Remove special characters
        .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
        .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
    };
    // Helper function to get section tab name
    const getSectionTabName = (section, isQuestion, data)=>{
        if (!section) return '';
        const sectionName = section.sectionName || section.name || '';
        const sanitized = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
        return sanitized ? `${sanitized}-section-report` : '';
    };
    // Helper function to check if a section report exists for a given section
    const hasSectionReport = (section, isQuestion, data)=>{
        if (!section || !company?.['aiReports']) return false;
        const sectionName = section.sectionName || section.name || '';
        const sanitizedSectionName = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
        if (!sanitizedSectionName) return false;
        const reportType = `sectionReport_${sanitizedSectionName}`;
        return company['aiReports'].some((report)=>report.reportType === reportType && report?.htmlReport);
    };
    // Helper function to get the report data for a section/question
    const getSectionReport = (section, isQuestion, data)=>{
        if (!section || !company?.['aiReports']) return null;
        const sectionName = section.no || section.name || '';
        const sanitizedSectionName = isQuestion ? data.qNo : sectionName;
        if (!sanitizedSectionName) return null;
        const reportType = `sectionReport_${sanitizedSectionName}`;
        return company['aiReports'].find((report)=>report.reportType === reportType && report?.htmlReport) || null;
    };
    const debouncedSaveAnswer = (0, $acw62.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lwfqC)))((e, question, qNo)=>{
        saveAnswer(e, question, qNo);
    }, 3000), [] // ← ensures debounce function is created once
    );
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingStart', (data)=>{
            dispatch((0, $b11447c30838833f$export$7a34e0accbb4df68)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingFoldersStart', ()=>{
            dispatch((0, $b11447c30838833f$export$b3e07c78a2c60bfb)());
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingFoldersComplete', ()=>{
            dispatch((0, $b11447c30838833f$export$b961a89ac79a5350)());
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('Syncing', (data)=>{
            dispatch((0, $b11447c30838833f$export$74c9a4d719d4ea5c)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingFilesNotAvailable', (data)=>{
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`There are currently no files to sync.`);
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingComplete', (data)=>{
            dispatch((0, $b11447c30838833f$export$8c5c317902a771de)());
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Syncing Process completed.`);
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('syncingComplete', ()=>{
            dispatch((0, $b11447c30838833f$export$8c5c317902a771de)());
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('ReSyncingStart', (data)=>{
            dispatch((0, $b11447c30838833f$export$e6096d4f512f501c)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('ReSyncing', (data)=>{
            dispatch((0, $b11447c30838833f$export$c4374b4dd5806893)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('ReSyncingComplete', ()=>{
            dispatch((0, $b11447c30838833f$export$6c77a92cea265c06)());
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        isComponentMountedRef.current = true;
        return ()=>{
            isComponentMountedRef.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!companyObjectId) {
            reportGenerationRequestRef.current = null;
            if (isComponentMountedRef.current) setReportGenerateLoadingState(null);
            return;
        }
        const loadingMap = $866b869d60dd72c1$var$getPersistedReportLoadingMap();
        const entry = loadingMap[companyObjectId];
        reportGenerationRequestRef.current = entry?.requestId || null;
        const generatingKey = entry?.status === 'pending' ? entry.generatingKey || null : null;
        if (isComponentMountedRef.current) setReportGenerateLoadingState((prev)=>{
            // Only update if the value actually changed
            if (prev !== generatingKey) return generatingKey;
            return prev;
        });
    }, [
        companyObjectId
    ]);
    // Add storage event listener to sync state when localStorage changes (e.g., from other tabs)
    (0, $acw62.useEffect)(()=>{
        const handleStorageChange = (e)=>{
            if (e.key === $866b869d60dd72c1$var$INSURANCE_REPORT_LOADING_STORAGE_KEY && companyObjectId) {
                const loadingMap = $866b869d60dd72c1$var$getPersistedReportLoadingMap();
                const entry = loadingMap[companyObjectId];
                const generatingKey = entry?.status === 'pending' ? entry.generatingKey || null : null;
                if (isComponentMountedRef.current) {
                    setReportGenerateLoadingState(generatingKey);
                    reportGenerationRequestRef.current = entry?.requestId || null;
                }
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return ()=>{
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [
        companyObjectId
    ]);
    const startReportGenerationLoading = (0, $acw62.useCallback)((generatingKey)=>{
        const requestId = `${companyObjectId || 'company'}-${Date.now()}`;
        const loadingMap = $866b869d60dd72c1$var$getPersistedReportLoadingMap();
        if (companyObjectId) {
            loadingMap[companyObjectId] = {
                status: 'pending',
                requestId: requestId,
                generatingKey: generatingKey || null,
                startedAt: Date.now()
            };
            $866b869d60dd72c1$var$writeJsonToStorage($866b869d60dd72c1$var$INSURANCE_REPORT_LOADING_STORAGE_KEY, loadingMap);
        }
        reportGenerationRequestRef.current = requestId;
        if (isComponentMountedRef.current) setReportGenerateLoadingState(generatingKey || null);
        return requestId;
    }, [
        companyObjectId
    ]);
    const stopReportGenerationLoading = (0, $acw62.useCallback)((requestId, options = {})=>{
        const { force: force = false } = options;
        const effectiveRequestId = requestId || reportGenerationRequestRef.current;
        const clearComponentState = (matchedRequestId)=>{
            if (!matchedRequestId || reportGenerationRequestRef.current === matchedRequestId) reportGenerationRequestRef.current = null;
            if (isComponentMountedRef.current) // Force state update to null
            setReportGenerateLoadingState(null);
        };
        if (!companyObjectId) {
            clearComponentState(effectiveRequestId);
            return;
        }
        const loadingMap = $866b869d60dd72c1$var$getPersistedReportLoadingMap();
        const entry = loadingMap[companyObjectId];
        if (!entry) {
            // No entry in localStorage, ensure state is cleared
            clearComponentState(effectiveRequestId);
            return;
        }
        const isMatchingRequest = !effectiveRequestId || entry.requestId === effectiveRequestId;
        const entryAgeMs = entry?.startedAt ? Date.now() - entry.startedAt : 0;
        const isStale = entryAgeMs > 300000; // 5 minutes fallback
        if (force || isMatchingRequest || isStale) {
            // Clear from localStorage first
            delete loadingMap[companyObjectId];
            $866b869d60dd72c1$var$writeJsonToStorage($866b869d60dd72c1$var$INSURANCE_REPORT_LOADING_STORAGE_KEY, loadingMap);
            // Then clear component state
            clearComponentState(entry.requestId);
            // Double-check: verify localStorage was cleared and sync state
            setTimeout(()=>{
                if (isComponentMountedRef.current) {
                    const verifyMap = $866b869d60dd72c1$var$getPersistedReportLoadingMap();
                    const verifyEntry = verifyMap[companyObjectId];
                    if (!verifyEntry || verifyEntry.status !== 'pending') setReportGenerateLoadingState(null);
                }
            }, 100);
            return;
        }
    }, [
        companyObjectId
    ]);
    const handleAiReportDisclaimerClose = (0, $acw62.useCallback)(async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (!companyObjectId) return;
        // Save agreement to localStorage first
        const updatedAgreements = [
            ...agreedAiReportDisclaimerIds
        ];
        if (!updatedAgreements.includes(companyObjectId)) {
            updatedAgreements.push(companyObjectId);
            $866b869d60dd72c1$var$writeJsonToStorage($866b869d60dd72c1$var$AI_REPORT_DISCLAIMER_KEY, updatedAgreements);
            setAgreedAiReportDisclaimerIds(updatedAgreements);
        }
        // await getCompany('repository', company);
        let sectionTab = null;
        const expectedReportType = expectedReportTypeRef.current;
        let anchorToStore = lastReportAnchorRef.current;
        if (expectedReportType) {
            const sanitizedSectionName = expectedReportType.replace('sectionReport_', '');
            sectionTab = `${sanitizedSectionName}-section-report`;
        }
        // Fallback: Use navigation target to construct tab name (from R button flow)
        if (!sectionTab) {
            const navigationTarget = sectionToNavigateRef.current;
            if (navigationTarget) {
                const { section: section, isQuestion: isQuestion, data: data } = navigationTarget;
                sectionTab = getSectionTabName(section, isQuestion, data);
                if (!anchorToStore) anchorToStore = section?.sectionNo || section?.no || data?.sectionNo || data?.qNo || null;
            }
        }
        // Navigate to the tab (following the same pattern as R button)
        if (sectionTab) {
            // Add tab to openTabs set so it appears in the UI
            if (setOpenTabs && openTabs) {
                const newOpenTabs = new Set(openTabs);
                newOpenTabs.add(sectionTab);
                setOpenTabs(newOpenTabs);
            }
            // Persist anchor for scrolling back on close
            if (anchorToStore) {
                lastReportAnchorRef.current = anchorToStore;
                try {
                    localStorage.setItem('lastReportAnchor', anchorToStore);
                } catch (_) {}
            }
            // Set tab and update URL hash (using proper routing like R button does)
            await setTab(sectionTab);
            // Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
            // Use history.replaceState to ensure the hash persists without triggering navigation
            setTimeout(()=>{
                const hashValue = `#${sectionTab}`;
                if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
            }, 100);
            // Clear refs after successful navigation
            expectedReportTypeRef.current = null;
            setSectionToNavigate(null);
            sectionToNavigateRef.current = null;
        }
    }, [
        companyObjectId,
        dispatch,
        setTab,
        getSectionTabName,
        company,
        navigate,
        getCompany,
        agreedAiReportDisclaimerIds,
        setOpenTabs,
        openTabs
    ]);
    const handleSectionReportLinkClick = (0, $acw62.useCallback)((event, section, isQuestion = false, data = null)=>{
        if (!section) {
            event?.preventDefault();
            return;
        }
        // Check if report exists for this section/question
        const hasReport = hasSectionReport(section, isQuestion, data);
        if (!hasReport) {
            event?.preventDefault();
            return;
        }
        if (hasAgreedAiReportDisclaimer) {
            const sectionTab = getSectionTabName(section, isQuestion, data);
            if (sectionTab) {
                setTab(sectionTab);
                // Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
                // Use history.replaceState to ensure the hash persists without triggering navigation
                setTimeout(()=>{
                    const hashValue = `#${sectionTab}`;
                    if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
                }, 100);
            }
            return;
        }
        event.preventDefault();
        const navigationData = {
            section: section,
            isQuestion: isQuestion,
            data: data
        };
        setSectionToNavigate(navigationData);
        sectionToNavigateRef.current = navigationData; // Also store in ref for reliable access
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'DisclaimerAIReportModal'
        }));
    }, [
        dispatch,
        hasAgreedAiReportDisclaimer,
        setTab,
        hasSectionReport,
        getSectionTabName
    ]);
    (0, $acw62.useEffect)(()=>{
        if (processing && location.hash && location.hash === "#repository" && showAlert) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'repositoryAlert'
        }));
    }, [
        processing,
        location.hash,
        showAlert
    ]);
    let sectionRefs = (0, $acw62.useRef)([]);
    let fileImportRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            const sectionPositions = sectionRefs.current.map((ref)=>{
                const id = ref?.id?.split('.')[0];
                const top = Math.floor(ref?.getBoundingClientRect().top);
                return {
                    id: id,
                    top: top
                };
            });
            const currentActiveSection = sectionPositions.find((position)=>position?.['top'] >= 0 && position.top < window.innerHeight);
            if (currentActiveSection) setVisibleSection(currentActiveSection.id);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    const handleEditDispatch = (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(true));
    };
    const syncDrive = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncGDriveDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) setNewUpgradeSync(false);
        window.location.reload();
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const syncDropbox = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        // setNewUpgradeSync(true);
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncDropBoxDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const reverseSyncDropbox = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        // setNewUpgradeSync(true);
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/reSyncDropBoxDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const syncSharePoint = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncSharePointDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const reSyncSharePoint = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/reSyncSharePointDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (questionsAndAnswersToSave.length) {
            if (isSaving) setSaveTimeout(setTimeout(()=>setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                        ...questionsAndAnswersToSave
                    ]), 1000));
            else save();
        }
    }, [
        questionsAndAnswersToSave,
        isSaving
    ]);
    const confirmDeleteFile = async (from)=>{
        if (deleteFileLoading) return;
        setDeleteFileLoading(true);
        let directorId = undefined;
        if (tab.includes('directors-questionnaire')) {
            const dqs = tab.split('_');
            if (dqs.length > 1) directorId = dqs[1];
        }
        let res = {};
        if (tab.includes('directors-questionnaire')) res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: deleteFile,
            questionId: deleteFileQuestionId,
            companyId: companyId,
            directorId: directorId
        });
        else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: deleteFile,
            questionId: deleteFileQuestionId,
            companyId: companyId
        });
        setDeleteFileLoading(false);
        if (!res || res['code'] != 200) return;
        if (tab) await reloadModule(tab);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (section) {
            let _sections = {
                ...section
            };
            _sections.files = section.files?.filter((f)=>f.key != deleteFile.key);
            setSection(_sections);
            setRefresh(!refresh);
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: from
        }));
    };
    const confirmDeleteUnallocatedFile = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/deleteUnallocatedFile', {
            fileReportId: deleteUnallocatedFile.id,
            file: deleteUnallocatedFile.file,
            companyId: companyId
        });
        if (!res || res['code'] != 200) return;
        dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(unallocatedFiles.filter((f)=>f.file.key != deleteUnallocatedFile.file.key)));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedFiles'
        }));
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e, question, qNo)=>{
        if (!company['uploadedFile'] || !company['syncRequired']) dispatch(setCompany({
            ...company,
            uploadedFile: true,
            syncRequired: true
        }));
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        const fileInput = e.currentTarget.querySelector("input[type='file']");
        if (fileInput) fileInput.value = null; // Reset the input field
        saveAnswer(e, question, qNo);
    };
    const radioButtonChanged = (e, question, qNo, moduleType)=>{
        if (company['creatorId']['_id'] != user['_id'] && company['addedByInvestor'] != user['_id'] && (company['servicedBy']['_id'] || company['servicedBy']) != user['_id'] && company['cCategory'] == 'client' && !companyIndex) {
            if (user['role'] == 'Advisor' && !company['advisors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
            if (user['role'] == 'Investor' && !company['investors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
            if (user['role'] == 'Member' && !company?.['memberPermissions']?.[user['_id']]?.[qNo.split('.')[0]]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
        }
        // question = Object.freeze(question);
        question = JSON.parse(JSON.stringify(question));
        const option = e['target']['dataset']['option'];
        const wrapper = e['target'].closest("[data-question-id]");
        //TODO: change to toggleHeight
        for (const showOrHideEl of wrapper.querySelectorAll(".showOrHide"))if (option === "Yes" || option == 'Disclosure') {
            showOrHideEl.classList.remove("dn");
            setTimeout(()=>showOrHideEl.classList.remove("op0", "h0"), 100);
        } else {
            showOrHideEl.classList.add("op0", "h0");
            setTimeout(()=>showOrHideEl.classList.add("dn"), 300);
        }
        // Send only update keys — do NOT include status here; backend owns status/taskStatus derivation
        if (!question['answer'] || question['answer'] == undefined) question['answer'] = {};
        else question['answer'] = {
            _id: question['answer']['_id']
        };
        question['answer']['radioOption'] = option;
        if ([
            'T',
            'Date',
            'DropDown'
        ].includes(question['questionType'])) question['answer']['radioOption'] = 'Yes';
        if (!question['updatedBy']) window.scrollTo({
            top: window['scrollY'] + 150,
            behavior: 'smooth'
        });
        if (option && option !== 'NC') question['answer']['status'] = 'Completed';
        saveAnswer(e, question, qNo, 'radio');
    };
    const cloneFile = (file)=>{
        const clonedFile = new File([
            file
        ], file['name'], {
            type: file['type']
        });
        return clonedFile;
    };
    // handleFileChange — replaced by AutoFill stepper (Filing Assistant now uses autoFillStepper modal)
    // const handleFileChange = async (e) => { ... };
    const sectionNos = [
        'UD021',
        'UD022',
        'UD023',
        'UD024',
        'UD025'
    ];
    const strAdditionalSections = sectionNos.map((sectionNo)=>{
        const section = company?.["modules"]?.[tab]?.['sections'].find((sec)=>sec?.sectionNo === sectionNo);
        if (section && section.type === "Additional Sections" && section['companyId'] && section['sectionName'] !== "") return [
            sectionNo,
            section.sectionName,
            true,
            true
        ];
        else return [
            sectionNo,
            "",
            false,
            true
        ];
    });
    let [additionalSections, setAdditionalSections] = (0, $acw62.useState)(strAdditionalSections);
    const [isSectionNameDuplicate, setIsSectionNameDuplicate] = (0, $acw62.useState)({
        indexes: [],
        name: ''
    });
    const findDuplicates = (arr)=>{
        const map = arr.reduce((acc, [index, name])=>{
            if (name !== "") (acc[name.toLowerCase().trim()] = acc[name.toLowerCase().trim()] || []).push(index);
            return acc;
        }, {});
        for (const [name, indexes] of Object.entries(map)){
            if (indexes.length > 1) return {
                indexes: indexes,
                name: name
            };
        }
        return {
            indexes: [],
            name: ''
        };
    };
    function editSectionName(strVal, index) {
        let newArray = [
            ...additionalSections
        ];
        newArray[index][1] = strVal;
        setAdditionalSections(newArray);
        const newSetData = findDuplicates(newArray);
        newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({
            indexes: [],
            name: ''
        });
    }
    function onEdit(index) {
        let newArray = [
            ...additionalSections
        ];
        if (newArray[index][3] === true && newArray[index][1] === "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please input additional user-defined sections name!');
        newArray[index][3] = !newArray[index][3];
        setAdditionalSections(newArray);
        const newSetData = findDuplicates(newArray);
        newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({
            indexes: [],
            name: ''
        });
    }
    async function onDelete(index) {
        const selectedSection = company["modules"][tab]['sections'].find((sec)=>sec.sectionNo === additionalSections[index][0]);
        let connectDataroomConfig = 0;
        if (company['gDriveLink']) connectDataroomConfig = 1;
        if (company['dropBoxLink']) connectDataroomConfig = 2;
        if (company['sharePointLink']) connectDataroomConfig = 3;
        try {
            const resp = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/delete/customSections', {
                sectionId: selectedSection._id,
                companyId: companyId,
                connectDataroomConfig: connectDataroomConfig
            });
            if (resp['code'] === 200) {
                let newArray = [
                    ...additionalSections
                ];
                newArray[index][2] = false;
                newArray[index][3] = true;
                newArray[index][1] = "";
                setAdditionalSections(newArray);
                const newSetData = findDuplicates(newArray);
                const restIndexes = newSetData.indexes.length ? newSetData.indexes.filter((item)=>item !== newArray[index][0]) : [];
                newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({
                    indexes: restIndexes,
                    name: ''
                });
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp['message']);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                if (tab) reloadModule(tab, true, true);
            }
        } catch (err) {
            console.log(err);
        }
    }
    const onSaveAdditionalSections = async ()=>{
        if (isSectionNameDuplicate.indexes.length && isSectionNameDuplicate.name !== '') return;
        let sectionNames = additionalSections.map((section)=>section[1]);
        if (sectionNames.every((val)=>val === '')) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please enter minimum one section name.");
        let connectDataroomConfig = 0;
        if (company['gDriveLink']) connectDataroomConfig = 1;
        if (company['dropBoxLink']) connectDataroomConfig = 2;
        if (company['sharePointLink']) connectDataroomConfig = 3;
        const additionalQuestion = "Please upload any file related to this section";
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/addSection/`, {
            type: 'Additional Sections',
            sectionNos: sectionNos,
            sectionNames: sectionNames,
            companyId: companyId,
            tab: tab,
            connectDataroomConfig: connectDataroomConfig,
            qDescription: additionalQuestion
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (tab) reloadModule(tab, false, true);
    };
    const saveAnswer = (e, question, sectionNo, type)=>{
        if (permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
            return;
        }
        let subAnswers;
        if (question['qNo'] == 'DEPF008.3.1' && question?.['answer']?.['subAnswers']) subAnswers = question['answer']['subAnswers'];
        question = JSON.parse(JSON.stringify(question));
        // Send only update keys
        const originalStatus = question['answer']?.['status'];
        if (type != 'radio' && question['answer']) question['answer'] = {
            _id: question['answer']['_id']
        };
        if ([
            'T',
            'F/T',
            'Date',
            'DropDown',
            'Radio',
            'Multi'
        ].includes(question['questionType'])) question['answer'].radioOption = 'Yes';
        clearTimeout(saveTimeout);
        let questionAndAnswerToSave = questionsAndAnswersToSave.find((q)=>q._id == question['_id']);
        if (!questionAndAnswerToSave) {
            questionAndAnswerToSave = {
                ...question,
                sectionNo: sectionNo,
                moduleType: question['type'],
                answer: {
                    _id: question.answer?._id,
                    fileIndexes: [],
                    logs: question.answer?.logs,
                    ...question.answer
                }
            };
            if (question?.['answer']?.['status']) questionAndAnswerToSave['answer']['status'] = question['answer']['status'];
            questionsAndAnswersToSave.push(questionAndAnswerToSave);
        }
        if (question['qNo'] == 'DEPF008.3.1' && e.target.name != 'comment') {
            if (!questionAndAnswerToSave['answer']['subAnswers']) questionAndAnswerToSave['answer']['subAnswers'] = {};
            if (subAnswers) questionAndAnswerToSave['answer']['subAnswers'] = {
                ...subAnswers,
                [e.target.name]: e.target.value
            };
            else questionAndAnswerToSave['answer']['subAnswers'][e.target.name] = e.target.value;
            questionAndAnswerToSave.answer.status = e.target.value?.trim() ? 'Completed' : 'Not Started';
        } else if (question['questionType'] == 'Radio') {
            questionAndAnswerToSave.answer['dropdown'] = e.target.dataset.option;
            questionAndAnswerToSave.answer.status = 'Completed';
        } else if (question['questionType'] == 'Multi') {
            let answer = '';
            e.target.value.map((value)=>{
                if (value.length == 0) return;
                if (answer.length > 0) answer = answer + ';' + value;
                else answer = value;
            });
            questionAndAnswerToSave.answer[e.target.name] = answer;
            questionAndAnswerToSave.answer.status = answer ? 'Completed' : 'Not Started';
        } else if (e.target.dataset && e.target.dataset.option) {
            questionAndAnswerToSave.answer.radioOption = e.target.dataset.option;
            if (e.target.dataset.option !== 'NC') questionAndAnswerToSave.answer.status = 'Completed';
        } else if (e.target.files) {
            for (const file of e.target.files){
                let index = attachment.push(file) - 1;
                questionAndAnswerToSave.answer.fileIndexes.push(index);
            }
            //showMessage("Uploading files");
            if (!company['uploadedFile'] || !company['syncRequired']) dispatch(setCompany({
                ...company,
                uploadedFile: true,
                syncRequired: true
            }));
            if (question['questionType'] == 'D/ND') questionAndAnswerToSave.answer.radioOption = 'Disclosure';
            else questionAndAnswerToSave.answer.radioOption = 'Yes';
            questionAndAnswerToSave.answer.status = 'Completed';
        } else if (e.target.type === "checkbox") {
            questionAndAnswerToSave.answer.status = e.target.checked ? "Completed" : "In Progress";
            if (e.target.checked) questionAndAnswerToSave.answer.autoFillNeedsReview = false;
            if (!question['answer']['_id']) questionAndAnswerToSave.answer.radioOption = question['questionType'] == 'D/ND' ? 'Disclosure' : 'Yes';
        } else {
            const val = e.target.value;
            questionAndAnswerToSave.answer[e.target.name] = val || e.target.checked;
            if (val !== undefined) questionAndAnswerToSave.answer.status = val?.toString().trim() ? 'Completed' : 'Not Started';
        }
        if (e.target.files) setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                ...questionsAndAnswersToSave
            ]);
        else setSaveTimeout(setTimeout(()=>setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                    ...questionsAndAnswersToSave
                ]), 10));
    };
    const save = async ()=>{
        setIsSaving(true);
        setQuestionsAndAnswersToSave([]);
        let companyClone = JSON.parse(JSON.stringify({
            ...company
        }));
        let currentCount = 0, percent = 0, filesInfo = [];
        const totalFileCount = attachment.length;
        for (const file of attachment){
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/newUploadFile`, {
                attachment: [
                    file
                ]
            }, true);
            if (!res) continue;
            if (!res.body?.['result']) continue;
            currentCount++;
            filesInfo.push(res.body['result']);
            percent = Math.round(currentCount / totalFileCount * 100);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'computerToDataRepository',
                percent: percent,
                fileName: file['name'],
                totalFiles: totalFileCount,
                filesUploaded: currentCount
            }));
        }
        if (localStorage.getItem('companyId')) companyId = localStorage.getItem('companyId');
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/newSaveAnswers', {
            files: filesInfo,
            companyId: companyId,
            questionsAndAnswersToSave: questionsAndAnswersToSave
        });
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (!res || res['code'] != 200) return setIsSaving(false);
        const { answerErrors: answerErrors, savedQuestions: savedQuestions } = res['body'];
        for (let question of savedQuestions){
            let { sectionNo: sectionNo, _id: _id } = question;
            let moduleName = question['moduleType'] || question['type'];
            if (window.location.hash.includes('directors-questionnaire')) moduleName = window.location.hash.replace('#', '');
            let module = companyClone['modules'][moduleName];
            if (answerErrors[_id]) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(answerErrors[_id]);
                continue;
            }
            // This is for expension pack subsections
            if (module?.['expansionPack']) for (let key of Object.keys(module.sections[0]['subFolders'])){
                let section = module.sections[0]['subFolders'][key];
                if (sectionNo.includes(section['sectionNo'])) {
                    section['updatedAt'] = Date.now();
                    let questionIndex = section['questions'].findIndex(({ _id: _id })=>_id == question['_id']);
                    module.sections[0]['subFolders'][key]['questions'][questionIndex] = question;
                }
            }
            else {
                if (module?.sections) {
                    for (let section of module?.sections)if (sectionNo.includes(`${section['sectionNo']}`)) {
                        section['updatedAt'] = Date.now();
                        if (section?.['subFolders']) for (let key of Object.keys(section['subFolders']))section['subFolders'][key]['updatedAt'] = Date.now();
                        if (section?.['subFolders']?.['subFolders']) for (let key of Object.keys(section['subFolders']['subFolders']))section['subFolders']['subFolders'][key]['updatedAt'] = Date.now();
                        let questionIndex = section['questions'].findIndex(({ _id: _id })=>_id == question['_id']);
                        // question['answer']['logs'] = section['questions'][questionIndex]?.['answer']?.['logs']; // Keep previous logs with user details
                        section['updatedAt'] = Date.now();
                        section['questions'][questionIndex] = question;
                        if (question['answer']['updatedBy']) section['questions'][questionIndex]['answer']['updatedBy'] = question['answer']['updatedBy'];
                    }
                }
            }
            companyClone.modules[moduleName] = module;
        }
        dispatch(setCompany(calculateStats(companyClone, tab, "check2")));
        //if (!repoStarted) setRepoStarted(!!repositoryClone.answers?.find(a => a.radioOption));
        setAttachment([]); //TODO: only remove successful attachments. undo answers set on UI like radio button checks and files selected if it failed
        //questionsAndAnswersToSave.push(...currentQuestionsAndAnswersToSave); //TODO: add failed ones back
        setIsSaving(false);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        return spinner.classList.add("op0");
    };
    const onClickDeduperAuditLog = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getDeduperReportLog/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'deduperReportAuditLog'
        }));
    };
    const onClickUnallocatedBinAuditLog = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getUnallocatedBinLog/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedBinAuditLog'
        }));
    };
    const moveUnallocatedFile = async ({ payload: payload })=>{
        if (payload.length) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveUnallocateFiles', {
                payload: payload,
                companyId: companyId,
                tab: tab
            });
            if (!res || res['code'] != 200) return;
            await reloadModule("repository", true);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            const filteredUnallocatedFiles = unallocatedFiles.filter((uf)=>!uf?.sectionNo);
            dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(filteredUnallocatedFiles));
            setRefresh(!refresh);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select target section');
    };
    const moveDeduperFile = async ({ payload: payload })=>{
        if (payload.length) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveDeduperFile', {
                companyId: companyId,
                tab: tab,
                actions: payload
            });
            if (!res || res['code'] != 200) return;
            const newReport = res['body'];
            if (tab) await reloadModule(tab, true);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            dispatch((0, $e0a7c253e2df808f$export$607aedf5e5b112cd)(JSON.parse(JSON.stringify(newReport))));
            // setDupCheck();
            let curSection = {};
            for (const dupFiles of Object.values(newReport.deduperResult || {})){
                if (!Array.isArray(dupFiles)) continue;
                for (const dupFile of dupFiles)if (dupFile?.file?.key) curSection[dupFile.file.key] = {
                    qNo: dupFile.qNo,
                    name: dupFile.name
                };
            }
            dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
            setRefresh(!refresh);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select target section');
    };
    const onClickFileReportHistory = async ()=>{
        setFAMenuVisible(false);
        setIsLoader({
            show: true,
            message: 'Loading Filing Assistant History...'
        });
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportHistory/${companyId}`);
            setReportHistories(res['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'fileReportHistory'
            }));
        } finally{
            setIsLoader({
                show: false,
                message: ''
            });
        }
    };
    const showDeduperReport = (report)=>{
        // setDupCheck(JSON.parse(JSON.stringify(report)));
        // setDupCheck(report);
        dispatch((0, $e0a7c253e2df808f$export$607aedf5e5b112cd)(report));
        let curSection = {};
        if (report?.deduperResult && typeof report.deduperResult === "object") for (const dupFiles of Object.values(report.deduperResult)){
            if (!Array.isArray(dupFiles)) continue;
            for (const dupFile of dupFiles)if (dupFile?.file?.key) curSection[dupFile.file.key] = {
                qNo: dupFile.qNo,
                name: dupFile.name
            };
        }
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'duplicationCheckSummary'
        }));
    };
    const onClickDeduperReportHistory = async ()=>{
        setFAMenuVisible(false);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getDeduperReportHistory/${company['_id']}`);
        if (res && res.body && !res['body'].length) return checkDuplicatedFiles();
        if (res['body'] && Array.isArray(res['body']) && res['body'].length > 0) showDeduperReport(res['body'][0]);
        else showDeduperReport({});
    // setDeduperHistories(res['body']);
    // dispatch(toggleModal({ open: 'deduperReportHistory' }))
    };
    const handleToggleSuccessAiReportGeneratedModal = async (redirect)=>{
        // Close the success modal first
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        // If user wants to view the report, show disclaimer
        // Navigation will be handled in handleAiReportDisclaimerClose after user clicks "Understood"
        if (redirect) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'DisclaimerAIReportModal'
        }));
    };
    const generateInsuranceAiReport = async ({ data: data, isQuestion: isQuestion })=>{
        setFAMenuVisible(false);
        const isSourceFile = (f)=>f && f.originator !== 'ai-report' && (f.location || f.url);
        const allFiles = isQuestion ? [
            ...(data?.answer?.files || []).filter(isSourceFile).map((file)=>file.location || file.url)
        ] : (data?.questions || data?.section?.questions || []).flatMap((q)=>(q.answer?.files || []).filter(isSourceFile).map((file)=>file.location || file.url)).filter(Boolean);
        const generatingKey = getReportGenerationKey(data, isQuestion);
        const requestId = startReportGenerationLoading(generatingKey);
        if (!companyObjectId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Unable to generate analysis report. Missing company identifier.');
            stopReportGenerationLoading(requestId);
            return;
        }
        if (!allFiles.length) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please upload a document before generating a report.');
            stopReportGenerationLoading(requestId, {
                force: true
            });
            return;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`The report generation process is in progress and may take approximately 8 to 10 minutes to complete.`);
        try {
            const sectionId = isQuestion ? data.sectionId : data?.['_id'] || data.section._id;
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/generateSectionReport/${companyObjectId}/${sectionId}`, {
                "companyId": companyObjectId,
                "files": allFiles,
                "query": 'You are a legal diligence report writer. Follow instructions strictly.',
                "isQuestion": isQuestion,
                ...isQuestion ? {
                    data: data
                } : {}
            });
            // if (true) {
            if (res?.['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                const reportType = res?.body?.reportType || null;
                expectedReportTypeRef.current = reportType;
                let sectionData = null;
                if (isQuestion && data?.sectionId) // Try to find the section from company data using sectionId
                {
                    if (company?.modules) {
                        for (const module of Object.values(company.modules))if (module?.sections) {
                            sectionData = Object.values(module.sections).find((sec)=>sec._id === data.sectionId || sec._id?.toString() === data.sectionId?.toString());
                            if (sectionData) break;
                        }
                    }
                } else if (!isQuestion) // For section reports, data is the section itself
                sectionData = data;
                // Store navigation data (section may be null for questions, but we have qNo in data)
                const anchor = sectionData?.sectionNo || sectionData?.no || data?.sectionNo || data?.qNo || null;
                if (anchor) {
                    lastReportAnchorRef.current = anchor;
                    try {
                        localStorage.setItem('lastReportAnchor', anchor);
                    } catch (_) {}
                }
                setSectionToNavigate({
                    section: sectionData,
                    isQuestion: isQuestion,
                    data: data
                });
                sectionToNavigateRef.current = {
                    section: sectionData,
                    isQuestion: isQuestion,
                    data: data
                };
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'successAiReportGenerated'
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message'] || 'Unable to generate analysis report');
        } catch (error) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(error?.message || 'Unable to generate analysis report');
        } finally{
            stopReportGenerationLoading(requestId, {
                force: true
            });
            setTimeout(()=>{
                if (isComponentMountedRef.current) {
                    const loadingMap = $866b869d60dd72c1$var$getPersistedReportLoadingMap();
                    const entry = loadingMap[companyObjectId];
                    if (!entry || entry.status !== 'pending') {
                        setReportGenerateLoadingState(null);
                        reportGenerationRequestRef.current = null;
                    }
                }
            }, 200);
        }
    };
    const onClickViewUnallocatedFiles = async ()=>{
        setFAMenuVisible(false);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/unallocatedFiles/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)({}));
        dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(res['body']['unallocated']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedFiles'
        }));
    };
    const checkDuplicatedFiles = async ()=>{
        setFAMenuVisible(false);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'checkingDuplication'
        }));
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/checkDuplicate`, {
            companyId: companyId,
            tab: tab
        });
        if (res?.code === 200 && res['body']) showDeduperReport(res['body']);
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    // Show each Filing Assistant info popup only the first time; afterwards run its action directly.
    const onFaInfo = (key)=>{
        const faInfoActions = {
            'unallocated-bin': onClickViewUnallocatedFiles,
            'filing-assistant': onClickFileReportHistory,
            'deduper': checkDuplicatedFiles,
            'deduper-reports': onClickDeduperReportHistory
        };
        return (0, $fd71835e1939fbe7$export$7476b3b1a66db3ee)(key, {
            openInfo: (k)=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'filingAssistantInfo',
                    faInfoKey: k
                })),
            runAction: (k)=>faInfoActions[k]?.()
        });
    };
    const getViewableURL = (url)=>{
        window.open(url, "_blank");
    };
    const getDeduperReportLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>getViewableURL(file['location']),
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem cp",
                                                children: file['originalname']
                                            }, `deduper-log-file-${idx}-${fileIdx}-${file['originalname']}`))
                                    ]
                                })
                            }),
                            log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Comment"
                                        }),
                                        ": ",
                                        log?.['change']?.comment ? log?.['change']?.comment : '-'
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, `deduper-log-${idx}-${log.timestamp}`);
        });
    const getFileReportLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>getViewableURL(file['location']),
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem cp",
                                                children: file['originalname']
                                            }, `file-report-log-file-${idx}-${fileIdx}-${file['originalname']}`))
                                    ]
                                })
                            }),
                            log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Changed Status"
                                            }),
                                            ": ",
                                            log?.['change']?.comment ? log?.['change']?.comment : '-'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Assistant Accuracy"
                                            }),
                                            ": ",
                                            log?.['change']?.accuracy != undefined ? log?.['change']?.accuracy : '-',
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, `file-report-log-${idx}-${log.timestamp}`);
        });
    const getUnallocatedBinLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>getViewableURL(file['location']),
                                                target: "_blank",
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem cp",
                                                children: file['originalname']
                                            }, `unallocated-bin-log-file-${idx}-${fileIdx}-${file['originalname']}`))
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, `unallocated-bin-log-${idx}-${log.timestamp}`);
        });
    const onClickFileManager = (section, questionIndex)=>{
        let curSection = {
            ...targetSection
        };
        if (section && section.files && section.files.length > 0) section.files.map((file)=>{
            curSection[file.key] = {
                qNo: section.sectionNo || section.no,
                name: section.sectionName || section.name
            };
        });
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
    };
    const answerSaved = (answer)=>{
        let updatedBy = answer?.['updatedBy']?.[0] || answer?.['updatedBy'];
        if (updatedBy?.['firstName']) {
            let answerClass = updatedBy?.['role'] == 'Advisor' ? 'advisor-profile' : updatedBy?.['role'] == 'Investor' ? 'investor-profile' : 'client-profile';
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    answer?.['autoFilled'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "ass mr0-5rem br100 w2rem h2rem",
                        src: (parcelRequire("bi4Ns")),
                        alt: "Clarence",
                        "data-tooltip": "Auto-filled by Clarence AI"
                    }) : updatedBy?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${answerClass}`,
                        src: updatedBy['profile'],
                        "data-tooltip": updatedBy['firstName'] ? updatedBy['firstName'] + " " + updatedBy['lastName'] : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `shadow ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem c15 bg16 ${answerClass}`,
                        "data-tooltip": updatedBy?.['firstName'] ? updatedBy['firstName'] + " " + updatedBy['lastName'] : "Register to show your name here",
                        children: [
                            updatedBy?.['firstName']?.[0] || "?",
                            updatedBy?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "fs0-75rem c15",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Answer Saved"
                                }),
                                ", ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(answer['updatedAt']).format('lll')
                                })
                            ]
                        })
                    })
                ]
            });
        }
    };
    const handleSectionLogs = async (id)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/getLogs/${id}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'auditLog'
        }));
    };
    const openWindow = (url)=>{
        if (window.innerWidth <= 640) {
            var a = document.createElement('a');
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");
            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);
            a.dispatchEvent(dispatch);
        } else {
            var width = window.innerWidth * 0.8;
            var height = width * window.innerHeight / window.innerWidth;
            window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + (window.innerHeight - height) / 2 + ', left=' + (window.innerWidth - width) / 2);
        }
        return false;
    };
    const getFilesFromQuestions = (questions)=>questions && questions.filter((q)=>q.answer?.files?.length).reduce((arr, q)=>[
                ...arr,
                ...q.answer.files.map((file)=>({
                        ...file,
                        questionId: q._id,
                        qNo: q.qNo,
                        title: file.originalname,
                        url: file.location,
                        ext: file.originalname.split(".").slice(-1)[0]
                    }))
            ], []);
    const showRiskRecommendation = (key)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
            className: "fs1rem fsi mt2rem df aic c15",
            children: key.includes("recommend") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "mr0-5rem",
                        width: "27",
                        height: "27",
                        viewBox: "0 0 27 27",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.0954 10.0946C21.0954 5.89534 17.6873 2.49208 13.4862 2.50001C9.32805 2.50787 5.97026 5.81889 5.90715 9.97656C5.86673 12.6385 7.19613 14.9926 9.23603 16.3795C9.24414 16.385 9.24902 16.3941 9.24902 16.404C9.6515 16.6551 9.8961 17.0961 9.8961 17.5705V19.2815H17.1055V17.555C17.1055 17.0891 17.3416 16.6547 17.7326 16.4013L17.7526 16.3883C19.7696 15.023 21.0954 12.7136 21.0954 10.0946Z",
                                fill: "url(#paint0_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M13.5034 15.3135C16.3444 15.3135 18.6474 13.0104 18.6474 10.1694C18.6474 7.32845 16.3444 5.02539 13.5034 5.02539C10.6624 5.02539 8.35938 7.32845 8.35938 10.1694C8.35938 13.0104 10.6624 15.3135 13.5034 15.3135Z",
                                fill: "url(#paint1_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M20.6955 12.5354L15.9165 7.7564C15.8453 7.62505 15.7329 7.5332 15.5718 7.5332H11.5191C11.2095 7.5332 11.0781 7.87094 11.0781 8.1805C11.0781 8.46824 11.1821 8.72517 11.3702 8.81365L12.8136 10.2856V13.9406C12.8136 14.0885 12.9026 14.1997 13.0365 14.2748L17.107 18.3453V17.5559C17.107 17.0899 17.343 16.6556 17.7341 16.4021L17.7541 16.3891C19.1136 15.4689 20.1584 14.1193 20.6955 12.5354Z",
                                fill: "url(#paint2_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5249 7.49023H11.4722C11.1626 7.49023 11.0312 7.82797 11.0312 8.13753C11.0312 8.49403 11.1907 8.80359 11.4722 8.80359H12.7668V13.8976C12.7668 14.1978 13.1327 14.3479 13.4986 14.3479C13.8645 14.3479 14.2303 14.1978 14.2303 13.8976V8.80359H15.525C15.8064 8.80359 15.9659 8.49403 15.9659 8.13753C15.9658 7.82792 15.8344 7.49023 15.5249 7.49023Z",
                                fill: "url(#paint3_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M23.8094 9.42578H22.1956C21.8115 9.42578 21.5 9.7372 21.5 10.1214C21.5 10.5055 21.8114 10.817 22.1956 10.817H23.8094C24.1935 10.817 24.505 10.5056 24.505 10.1214C24.505 9.7372 24.1936 9.42578 23.8094 9.42578Z",
                                fill: "url(#paint4_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M5.505 10.1214C5.505 9.73724 5.19358 9.42578 4.80939 9.42578H3.19561C2.81142 9.42578 2.5 9.7372 2.5 10.1214C2.5 10.5055 2.81142 10.817 3.19561 10.817H4.80939C5.19354 10.817 5.505 10.5055 5.505 10.1214Z",
                                fill: "url(#paint5_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.7422 13.985C21.4705 13.7133 21.0301 13.7133 20.7584 13.985C20.4868 14.2566 20.4868 14.6971 20.7584 14.9687L21.8995 16.1098C22.1712 16.3815 22.6116 16.3815 22.8833 16.1098C23.1549 15.8382 23.1549 15.3977 22.8833 15.1261L21.7422 13.985Z",
                                fill: "url(#paint6_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M5.10153 4.13342C4.82989 3.86178 4.38944 3.86178 4.1178 4.13342C3.84615 4.40507 3.84615 4.84551 4.1178 5.11716L5.2589 6.25826C5.53055 6.52991 5.97099 6.52991 6.24264 6.25826C6.51428 5.98662 6.51428 5.54617 6.24264 5.27453L5.10153 4.13342Z",
                                fill: "url(#paint7_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M6.24264 13.985C5.97099 13.7133 5.53055 13.7133 5.2589 13.985L4.1178 15.1261C3.84615 15.3977 3.84615 15.8382 4.1178 16.1098C4.38944 16.3815 4.82989 16.3815 5.10153 16.1098L6.24264 14.9687C6.51428 14.697 6.51428 14.2566 6.24264 13.985Z",
                                fill: "url(#paint8_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M20.7584 6.25826C21.0301 6.52991 21.4705 6.52991 21.7422 6.25826L22.8833 5.11716C23.1549 4.84551 23.1549 4.40507 22.8833 4.13342C22.6116 3.86178 22.1712 3.86178 21.8995 4.13342L20.7584 5.27453C20.4868 5.54617 20.4868 5.98662 20.7584 6.25826Z",
                                fill: "url(#paint9_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M17.1077 17.9497L14.4774 15.3194C14.2488 15.0502 13.908 14.8789 13.5271 14.8789C12.839 14.8789 12.2812 15.4367 12.2812 16.1248C12.2812 16.1696 12.2834 16.2141 12.2882 16.2576C12.3227 16.5842 12.484 16.8732 12.7217 17.0751L14.9278 19.2812H17.1077V17.9497Z",
                                fill: "url(#paint10_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M13.4959 17.3454C14.184 17.3454 14.7419 16.7876 14.7419 16.0994C14.7419 15.4113 14.184 14.8535 13.4959 14.8535C12.8078 14.8535 12.25 15.4113 12.25 16.0994C12.25 16.7876 12.8078 17.3454 13.4959 17.3454Z",
                                fill: "url(#paint11_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M6.42188 12.8516C6.98406 14.2927 7.97314 15.5202 9.23444 16.3778C9.24255 16.3833 9.24742 16.3924 9.24742 16.4022C9.6499 16.6534 9.8945 17.0943 9.8945 17.5687V19.2797H17.1039V17.5533C17.1039 17.0873 17.3399 16.653 17.731 16.3995L17.751 16.3865C19.0185 15.5286 20.0127 14.2977 20.5768 12.8516H6.42188V12.8516Z",
                                fill: "url(#paint12_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z",
                                fill: "url(#paint13_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z",
                                fill: "url(#paint14_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z",
                                fill: "url(#paint15_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 20.4238H10.3136C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3417 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3417 20.4238 16.6766 20.4238Z",
                                fill: "url(#paint16_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z",
                                fill: "url(#paint17_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 20.4238L13.5082 20.3066L10.3136 20.4238C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3418 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3418 20.4238 16.6766 20.4238Z",
                                fill: "url(#paint18_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint0_linear_5984_51730",
                                        x1: "7.93971",
                                        y1: "5.55907",
                                        x2: "17.0821",
                                        y2: "14.7015",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint1_linear_5984_51730",
                                        x1: "11.5881",
                                        y1: "8.25411",
                                        x2: "19.3877",
                                        y2: "16.0536",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint2_linear_5984_51730",
                                        x1: "19.8051",
                                        y1: "16.3438",
                                        x2: "7.67629",
                                        y2: "4.21497",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#D52C1C",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.28",
                                                "stop-color": "#D12C1E",
                                                "stop-opacity": "0.28"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5735",
                                                "stop-color": "#C42C23",
                                                "stop-opacity": "0.574"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8721",
                                                "stop-color": "#AF2B2C",
                                                "stop-opacity": "0.872"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A42B31"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint3_linear_5984_51730",
                                        x1: "11.5522",
                                        y1: "8.09465",
                                        x2: "16.2824",
                                        y2: "12.8249",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#E38523"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#C4237C"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint4_linear_5984_51730",
                                        x1: "20.5813",
                                        y1: "9.21341",
                                        x2: "25.2617",
                                        y2: "10.9686",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint5_linear_5984_51730",
                                        x1: "1.58127",
                                        y1: "9.21341",
                                        x2: "6.26166",
                                        y2: "10.9686",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint6_linear_5984_51730",
                                        x1: "19.4346",
                                        y1: "14.1526",
                                        x2: "24.0474",
                                        y2: "15.8824",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint7_linear_5984_51730",
                                        x1: "2.794",
                                        y1: "4.30097",
                                        x2: "7.40674",
                                        y2: "6.03075",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint8_linear_5984_51730",
                                        x1: "3.46243",
                                        y1: "14.4032",
                                        x2: "6.78304",
                                        y2: "15.6485",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint9_linear_5984_51730",
                                        x1: "20.1031",
                                        y1: "4.55165",
                                        x2: "23.4237",
                                        y2: "5.79689",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint10_linear_5984_51730",
                                        x1: "17.1961",
                                        y1: "19.7937",
                                        x2: "13.3824",
                                        y2: "15.98",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#D52C1C",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.28",
                                                "stop-color": "#D12C1E",
                                                "stop-opacity": "0.28"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5735",
                                                "stop-color": "#C42C23",
                                                "stop-opacity": "0.574"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8721",
                                                "stop-color": "#AF2B2C",
                                                "stop-opacity": "0.872"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A42B31"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint11_linear_5984_51730",
                                        x1: "12.8755",
                                        y1: "15.4789",
                                        x2: "14.0165",
                                        y2: "16.62",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#E38523"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#C4237C"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint12_linear_5984_51730",
                                        x1: "13.4994",
                                        y1: "14.7928",
                                        x2: "13.4994",
                                        y2: "18.3093",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#D52C1C",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.28",
                                                "stop-color": "#D12C1E",
                                                "stop-opacity": "0.28"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5735",
                                                "stop-color": "#C42C23",
                                                "stop-opacity": "0.574"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8721",
                                                "stop-color": "#AF2B2C",
                                                "stop-opacity": "0.872"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A42B31"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint13_linear_5984_51730",
                                        x1: "13.4951",
                                        y1: "18.721",
                                        x2: "13.4951",
                                        y2: "20.1877",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EEF4FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#CFE7FD"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint14_linear_5984_51730",
                                        x1: "10.5019",
                                        y1: "23.2286",
                                        x2: "15.9964",
                                        y2: "23.2286",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#5A5A5A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#464646"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint15_linear_5984_51730",
                                        x1: "13.4996",
                                        y1: "24.1335",
                                        x2: "13.4996",
                                        y2: "23.2058",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#464646",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#202020"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint16_linear_5984_51730",
                                        x1: "13.4951",
                                        y1: "20.7913",
                                        x2: "13.4951",
                                        y2: "22.519",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EEF4FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#CFE7FD"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint17_linear_5984_51730",
                                        x1: "13.4951",
                                        y1: "19.2818",
                                        x2: "13.4951",
                                        y2: "20.7916",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#8AAADC",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#8AAADC"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint18_linear_5984_51730",
                                        x1: "13.4952",
                                        y1: "21.7098",
                                        x2: "13.4952",
                                        y2: "22.7287",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#8AAADC",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#8AAADC"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    "Recommendation:"
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f4 mr0-5rem mah2rem maw2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
                            })
                        ]
                    }),
                    "Risk:"
                ]
            })
        });
    };
    const sortQuestionsByQNo = (questions)=>{
        if (questions.length > 0) return questions.sort((a, b)=>{
            const aParts = a['qNo'].match(/\d+/g).map(Number);
            const bParts = b['qNo'].match(/\d+/g).map(Number);
            for(let i = 0; i < Math.max(aParts.length, bParts.length); i++)if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
            return 0;
        });
    };
    const onAccurateFileName = ()=>{
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                enabled: false,
                companyId: companyId,
                moduleType: tab,
                sectionCode: null,
                scope: 'module',
                scopeName: ''
            },
            tab: tab
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'select',
            autoFillStatusBarPhase: 'select',
            autoFillWithFilling: false,
            autoFillUploadMode: 'files'
        }));
    };
    const onAccurateFolderName = ()=>{
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                enabled: false,
                companyId: companyId,
                moduleType: tab,
                sectionCode: null,
                scope: 'module',
                scopeName: ''
            },
            tab: tab
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'select',
            autoFillStatusBarPhase: 'select',
            autoFillWithFilling: false,
            autoFillUploadMode: 'folders'
        }));
    };
    const handleDisconnectDataRoom = async (dataroomType)=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'disconnectDataRoom',
            modalHistory: dataroomType
        }));
    const handleDateChange = (e, question, qNo)=>{
        setDateValue((prev)=>(prev, {
                [question._id]: e.target.value
            }));
        saveAnswer(e, question, qNo);
    };
    const subFolderModules = [
        "repository"
    ];
    const getSectionHTML = (module, currentSection, ancestorSectionName = null)=>{
        if (module) module = JSON.parse(JSON.stringify(module));
        if (currentSection) currentSection = JSON.parse(JSON.stringify(currentSection));
        const parentSectionName = ancestorSectionName || currentSection?.['sectionName'] || currentSection?.['name'] || null;
        let convert;
        if (module['type'].includes('directors-questionnaire')) convert = currentSection?.subFolders || module?.sections[0]?.subFolders;
        else convert = currentSection?.subFolders || module?.sections;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                convert && Object.values(convert).filter((s)=>(currentSection?.questions || s?.questions || []).find((q)=>q.qNo.match(new RegExp((s.sectionNo || s.no) + "((\.[0-9]+)|$)")))).slice().sort(sortSections).map((section, sectionIdx)=>{
                    // if ((module['type'] == 'repository' || module['type'] == `business-audit-${company['testType']}`) && ((user['role'] == "Advisor" || user['role'] == "Investor") && (user?.['companyId'] && user?.['companyId']?.['_id'] != company?.['_id'])) && (company['advisors'] || company['investors']) && section?.['sectionNo']) {
                    // 	if ((company?.['advisors']?.[user['_id']]?.['modules'] && !company?.['advisors']?.[user['_id']]?.['modules']?.[section?.['sectionNo']] && user['role'] == 'Advisor' && user?.['companyId']?.['_id'] !== company['_id']) || (!company?.['investors']?.[user['_id']]?.['modules']?.[section?.['sectionNo']] && user['role'] == 'Investor')) return;
                    // }
                    let questions;
                    let showSubFolder = false;
                    const qNo = section.sectionNo || section.no;
                    const sectionId = section['_id'] || section['sectionId'] || `section-${sectionIdx}`;
                    if (module['expansionPack']) {
                        showSubFolder = qNo.indexOf('.') < 0;
                        questions = qNo.indexOf('.') > 0 ? section['questions'] : [];
                        section.stats = section.stats || currentSection?.stats; // Temporary
                    } else if (subFolderModules.includes(module.type)) {
                        if (currentSection) section.questions = currentSection.questions;
                        if (Object.values(section && section?.subFolders || {})?.find((s)=>section?.questions?.find((q)=>q.qNo.match(new RegExp((s.sectionNo || s.no) + "(\.[0-9]+)|$"))))) showSubFolder = true;
                        questions = section.questions && section.questions.filter((q)=>q.qNo === qNo) || [];
                    } else questions = section.questions.filter((q)=>q.qNo.match(new RegExp(qNo + "(\.[0-9]+)|$")));
                    section.files = [];
                    if (section && section['files']) section.files = getFilesFromQuestions(questions);
                    // Sort all questions.					
                    questions = questions && sortQuestionsByQNo(questions);
                    const jsx = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            questions && questions.length > 0 && questions.map((question, questionIdx)=>{
                                if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                                let answer = question.answer || {};
                                let showFiles = answer['radioOption'] === "Yes" || answer['radioOption'] == 'Disclosure';
                                let showToolBox = answer['radioOption'] === "Yes" || answer['radioOption'] == "No" || answer['radioOption'] == "N/A" || answer['radioOption'] == 'Disclosure';
                                const _qtCfg = (section?.['toolboxConfig'] || {})[question?.['questionType']] || {};
                                const showFilesTab = _qtCfg['files'] === true;
                                const showCollaborateTab = _qtCfg['collaborate'] === true;
                                const showPolicyMaker = _qtCfg['toolboxPolicyMaker'] === true;
                                const showAnalyser = _qtCfg['toolboxAnalyser'] === true;
                                const showToolboxTab = showPolicyMaker || showAnalyser;
                                const _defaultTab = _qtCfg['files'] === true ? 'files' : _qtCfg['collaborate'] === true ? 'collaborate' : showToolboxTab ? 'toolbox' : 'files';
                                const canSync = Boolean((section.sectionNo || section.no) && (company.gDriveLink || company.sharePointLink || company.dropBoxLink) && module['uploadFiles'] && !tab.includes('directors-questionnaire') && answer?.files?.length && tab === "repository");
                                const canReport = question['isPrompt'] === true && tab === 'repository';
                                const _sectionComplete = section?.['stats']?.['completionPercent'] === 100;
                                const _hasUploadedFiles = (question?.answer?.files || []).some((f)=>f && f.originator !== 'ai-report' && (f.location || f.url));
                                const hasFiles = canReport && _hasUploadedFiles && _sectionComplete;
                                const analyserDisabledTooltip = !_sectionComplete ? 'Complete the 100% section to generate the report' : !_hasUploadedFiles ? 'Upload files to generate the report' : !canReport ? 'No analyser prompt configured for this question' : '';
                                const currentKey = canReport ? getReportGenerationKey(question, true) : null;
                                const isGenerating = canReport && reportGenerateLoading === currentKey;
                                const isAnyGenerating = reportGenerateLoading !== null;
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    "data-module-type": module.type,
                                    "data-section-no": question['qNo'],
                                    "data-question-id": question['_id'],
                                    className: !showSubFolder ? "bss bw2px bo5 br10px px2rem py1rem mt1rem pr" : "pr",
                                    style: answer?.['autoFillNeedsReview'] && answer?.['taskStatus'] !== 'Completed' ? {
                                        borderColor: '#F59E0B'
                                    } : {},
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        "data-module-type": module.type,
                                        "data-section-no": qNo,
                                        "data-question-id": question['_id'],
                                        className: (question.editPermission ?? true ? "" : "op20 pen ") + "dg gg2rem report-upload-area-saf aifs",
                                        style: {
                                            gridTemplateColumns: '50% 45%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: isTwoMinuteTesHomePage && `df fww aifs`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: `df ${answer?.['updatedBy'] ? 'jcsb' : 'jcfe'}`,
                                                                children: answer?.['updatedBy'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    children: answerSaved(answer)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic fww gg0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs1rem c15 fw500",
                                                                        children: question['qNo']
                                                                    }),
                                                                    (!answer.radioOption || answer.radioOption === 'NC') && (!answer.status || answer.status === 'Not Started') && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "br50px px0-75rem py0-25rem fs12px fw500",
                                                                        style: {
                                                                            background: '#e8eaf6',
                                                                            color: '#6b7280'
                                                                        },
                                                                        children: "Not Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "w100 fw400 fs14px c15 mb0",
                                                                        children: question.qDescription
                                                                    })
                                                                ]
                                                            }),
                                                            (()=>{
                                                                const options = question.questionType === 'yesNo' ? [
                                                                    'Yes',
                                                                    'No',
                                                                    'N/A'
                                                                ] : question.questionType === 'YN/F/T' ? [
                                                                    'Yes',
                                                                    'No',
                                                                    'N/A'
                                                                ] : question.questionType === '1to5' ? [
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5
                                                                ] : question.questionType === 'D/ND' ? [
                                                                    'Disclosure',
                                                                    'No Disclosure',
                                                                    'Not Sure',
                                                                    'N/A'
                                                                ] : question.questionType === 'Date' ? [] : question.questionType === 'Radio' || question.questionType === 'DropDown' || question.questionType === 'Multi' ? (question.options || []).map((o)=>typeof o === 'object' ? o['value'] ?? o['name'] ?? '' : o).filter((o)=>o !== '') : [
                                                                    'Yes',
                                                                    'No',
                                                                    'N/A'
                                                                ];
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                    children: module['type'].includes("directors-questionnaire") || module['type'].includes("investor-lead") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            question?.questionType.includes("YN") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df aic fww",
                                                                                children: options.map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                        for: question._id + option,
                                                                                        className: "py1rem df cp fs0-75rem",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "checkbox w30px h30px pr",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                    defaultChecked: answer.radioOption == option,
                                                                                                    "data-option": option,
                                                                                                    id: question._id + option + answer.radioOption,
                                                                                                    onChange: (e)=>radioButtonChanged(e, question, qNo, module.type),
                                                                                                    name: question._id,
                                                                                                    className: "bg1 bo4 bw2px bss cp td250 w30px h30px br5px",
                                                                                                    type: "radio"
                                                                                                }, `${question._id}-${option}-${answer.radioOption}`)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                                                children: option
                                                                                            })
                                                                                        ]
                                                                                    }, `${question._id}-yn-${option}-${optIdx}`))
                                                                            }),
                                                                            question?.questionType.includes("DropDown") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "oyh td250 pr mt1rem",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                                                    value: answer?.dropdown,
                                                                                    name: "dropdown",
                                                                                    className: "pl1rem bss bw2px bo5 w90 br5px p1rem",
                                                                                    onChange: (e)=>saveAnswer(e, question, qNo),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                            value: answer?.dropdown,
                                                                                            selected: true,
                                                                                            disabled: true,
                                                                                            hidden: true,
                                                                                            children: answer?.dropdown
                                                                                        }),
                                                                                        module['type'].includes("investor-lead") ? question['options'] && question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                value: option['name'].replaceAll("'", ','),
                                                                                                children: option['name'].replaceAll("'", ',')
                                                                                            }, idx)) : question['options'] && question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                                value: option['name'],
                                                                                                children: option['name']
                                                                                            }, idx))
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            question?.questionType.includes("Date") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "oyh td250 pr mt1rem",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    value: dateValue[question['_id']] || answer?.date && new Date(answer?.date).toISOString().substring(0, 10),
                                                                                    type: "date",
                                                                                    name: "date",
                                                                                    className: "pl2rem bss bw2px bo5 w90 br5px p1rem",
                                                                                    onChange: (e)=>handleDateChange(e, question, qNo),
                                                                                    max: new Date().toISOString().substring(0, 10)
                                                                                })
                                                                            }),
                                                                            question?.questionType.includes("Radio") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df aic fww",
                                                                                children: question['options'].map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                        for: question._id + option['name'],
                                                                                        className: "py1rem df cp fs0-75rem",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "checkbox checkbox-border-qus w30px h30px pr",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                    defaultChecked: answer['dropdown'] == option['name'],
                                                                                                    "data-option": option['name'],
                                                                                                    onChange: (e)=>saveAnswer(e, question, qNo),
                                                                                                    name: question._id,
                                                                                                    id: question._id + option['name'],
                                                                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                                                                    type: "radio"
                                                                                                }, `${question._id}-${option}-${answer['dropdown']}`)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                                                children: option['name']
                                                                                            })
                                                                                        ]
                                                                                    }, `${question._id}-radio-${option['name']}-${optIdx}`))
                                                                            }),
                                                                            question?.questionType.includes("Multi") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "multi-dropdown mt1rem",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                                    multiple: true,
                                                                                    className: "w400px",
                                                                                    placeholder: "Select any options from dropdown",
                                                                                    name: "dropdown",
                                                                                    id: "demo-multiple-checkbox",
                                                                                    labelId: "demo-multiple-checkbox-label",
                                                                                    onChange: (e)=>saveAnswer(e, question, qNo),
                                                                                    renderValue: (selected)=>selected.join(',  '),
                                                                                    value: question['answer']['dropdown'] ? question['answer']['dropdown']?.split(";") : [],
                                                                                    children: question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                                            value: option['name'],
                                                                                            className: "multi-dropdown-list",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                                    checked: question['answer']?.['dropdown']?.split(";").indexOf(option['name']) > -1
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                                    primary: option['name']
                                                                                                })
                                                                                            ]
                                                                                        }))
                                                                                })
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df aic fww ml1rem",
                                                                        children: options.map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                        for: question._id + option,
                                                                                        className: `df cp fs0-75rem ${question.questionType === '1to5' && (option == 1 || option == 5) ? 'pt2rem pb0-5rem' : 'py1rem'}`,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "checkbox w20px h20px pr",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                    defaultChecked: answer.radioOption == option,
                                                                                                    "data-option": option,
                                                                                                    onChange: (e)=>radioButtonChanged(e, question, qNo, module.type),
                                                                                                    name: question._id,
                                                                                                    disabled: isSaving,
                                                                                                    id: question._id + option + answer.radioOption,
                                                                                                    className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                                                                                    type: "radio"
                                                                                                }, `${question._id}-${option}-${answer.radioOption}`)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "w100 fs0-75rem c15 lh3 ml0-5rem usn mr1-5rem fw500",
                                                                                                children: option
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    question.questionType === '1to5' && option == 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c9 fs0-75rem",
                                                                                        children: "Poor"
                                                                                    }),
                                                                                    question.questionType === '1to5' && option == 5 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c7 fs0-75rem",
                                                                                        children: "Excellent"
                                                                                    })
                                                                                ]
                                                                            }, `${question._id}-option-${option}-${optIdx}`))
                                                                    })
                                                                });
                                                            })(),
                                                            ![
                                                                `business-audit-${company['testType']}`,
                                                                `two-minute-test-${company['testType']}`
                                                            ].includes(module['type']) && module.stats.completionPercent == 100 && answer.radioOption === "No" && [
                                                                "riskDescription",
                                                                "recommendDescription"
                                                            ].filter((key)=>question[key]).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "recommendation",
                                                                    children: [
                                                                        showRiskRecommendation(key),
                                                                        question[key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "mt1rem c15 fs14px",
                                                                                children: s
                                                                            }, `${question._id}-${key}-line-${i}`))
                                                                    ]
                                                                }, `${question._id}-${key}`)),
                                                            module['type'].includes(`business-audit-${company['testType']}`) && answer.radioOption === "No" && [
                                                                "riskDescription",
                                                                "recommendDescription"
                                                            ].filter((key)=>answer?.aiResponse?.['if' + key] || question[key]).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "recommendation",
                                                                    children: [
                                                                        showRiskRecommendation(key),
                                                                        (answer?.aiResponse?.['if' + key] || question[key]).split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "mt1rem c15 fs14px",
                                                                                children: s
                                                                            }, `${question._id}-ai-${key}-line-${i}`))
                                                                    ]
                                                                }, `${question._id}-ai-${key}`)),
                                                            module?.['type'] && company?.['testType'] && module['type'] == `two-minute-test-${company['testType']}` && module?.['stats']?.['completionPercent'] == 100 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    "Yes",
                                                                    "No",
                                                                    1,
                                                                    2,
                                                                    3,
                                                                    4,
                                                                    5
                                                                ].filter((key)=>question?.['answer']?.['aiResponse'] ? question['answer']['aiResponse']["if" + key] : question["if" + key]).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "recommendation" + (answer.radioOption == key ? "" : " dn"),
                                                                        children: [
                                                                            showRiskRecommendation('recommend'),
                                                                            question?.['answer']?.['aiResponse'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                children: question['answer']['aiResponse']["if" + key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "mt1rem c15 fs14px",
                                                                                        children: s
                                                                                    }, `${question._id}-twomin-ai-${key}-line-${i}`))
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                children: question["if" + key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "mt1rem c15 fs14px",
                                                                                        children: s
                                                                                    }, `${question._id}-twomin-${key}-line-${i}`))
                                                                            })
                                                                        ]
                                                                    }, `${question._id}-twomin-${key}`))
                                                            })
                                                        ]
                                                    }),
                                                    question.topTip && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `${isTwoMinuteTesHomePage && sectionIdx == 0 && questionIdx == 0 && "op60"} w80 mt1rem`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc aic",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "w100 df aic mb0-25rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: (parcelRequire("iBc1P")),
                                                                            alt: "icon",
                                                                            className: "w1rem h1rem mb0-25rem mr0-5rem"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "fs14px c15 fw500",
                                                                            children: "Tool Tip"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "w100 fs12px fw300 c12",
                                                                    children: question.topTip
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    question.templateFiles && question.templateFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: (showFiles ? "" : "op0 h0 dn ") + "showOrHide df fww mt0-5rem",
                                                        children: question.templateFiles.map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                className: "df jcc aic br5px lh1 bg4 c1 px0-5rem fw600 mr0-5rem mb0-5rem",
                                                                target: "_blank",
                                                                href: file.location,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "py0-5rem pl0-5rem",
                                                                    children: file.originalname
                                                                })
                                                            }, `template-file-${question._id}-${fileIdx}-${file.originalname}`))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "pl1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fww jcfe aic gg0-5rem mb1rem",
                                                        children: [
                                                            answer?.['_id'] && answer?.status !== 'Not Started' && !module?.['type']?.includes('investor-lead') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "menuHover pr",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                        className: `df aic py0-25rem fs12px fw500 cp br20px bw1px bss bo16 ${answer?.taskPriority ? 'c1 px0-75rem' : 'c15 pl2rem pr1rem'}`,
                                                                        style: answer?.taskPriority ? {
                                                                            background: $866b869d60dd72c1$var$PRIORITY_COLORS[answer.taskPriority] || '#e2e7ff',
                                                                            border: '1px solid currentColor'
                                                                        } : {
                                                                            background: '#e2e7ff'
                                                                        },
                                                                        children: [
                                                                            answer?.taskPriority || 'Priority',
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                className: `${answer?.taskStatus ? 'ml0-5rem' : 'ml1-5rem'}`,
                                                                                width: "10",
                                                                                height: "10",
                                                                                viewBox: "0 0 24 24",
                                                                                fill: "none",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M6 9l6 6 6-6",
                                                                                    stroke: "currentColor",
                                                                                    strokeWidth: "2",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "menu op0 pen pa bg1 shadow br10px zi10",
                                                                        style: {
                                                                            top: '28px',
                                                                            left: 0,
                                                                            minWidth: '160px',
                                                                            overflow: 'hidden'
                                                                        },
                                                                        children: $866b869d60dd72c1$var$PRIORITY_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                onClick: ()=>handleInlinePriority(answer._id, question, module, opt),
                                                                                className: "w100 df aic px1rem py0-5rem cp c1 fs12px fw500",
                                                                                style: {
                                                                                    background: $866b869d60dd72c1$var$PRIORITY_COLORS[opt]
                                                                                },
                                                                                children: opt
                                                                            }, opt))
                                                                    })
                                                                ]
                                                            }),
                                                            answer?.['_id'] && answer?.status !== 'Not Started' && !module?.['type']?.includes('investor-lead') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "menuHover pr",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    className: `df aic py0-25rem fs12px fw500 cp br20px bw1px bss bo16 c1 px1rem`,
                                                                    style: answer?.status ? {
                                                                        background: $866b869d60dd72c1$var$STATUS_COLORS[answer.status] || '#929090',
                                                                        border: '1px solid currentColor'
                                                                    } : {
                                                                        background: '#929090'
                                                                    },
                                                                    children: answer?.status || 'Not Started'
                                                                })
                                                            }),
                                                            answer?.['_id'] && answer?.status !== 'Not Started' && !module?.['type']?.includes('investor-lead') && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                type: "button",
                                                                disabled: isSaving,
                                                                className: "df aic br20px px0-75rem py0-25rem fs12px fw400 cp",
                                                                style: answer.status === 'Completed' ? {
                                                                    background: '#35E586',
                                                                    border: '1px solid #35E586',
                                                                    color: '#fff'
                                                                } : {
                                                                    background: '#f0f0f8',
                                                                    border: '1px solid #a6a6a6',
                                                                    color: '#000'
                                                                },
                                                                onClick: ()=>saveAnswer({
                                                                        target: {
                                                                            type: 'checkbox',
                                                                            checked: answer.status !== 'Completed',
                                                                            dataset: {}
                                                                        }
                                                                    }, question, qNo),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        className: "mr0-5rem",
                                                                        width: "16",
                                                                        height: "16",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M12 5C7 5 2.73 8.11 1 12.5C2.73 16.89 7 20 12 20C17 20 21.27 16.89 23 12.5C21.27 8.11 17 5 12 5Z",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round",
                                                                                fill: "none"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                cx: "12",
                                                                                cy: "12.5",
                                                                                r: "3",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "2",
                                                                                fill: "none"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    "Human ",
                                                                    answer.status === 'Completed' ? 'Reviewed' : 'Review'
                                                                ]
                                                            }),
                                                            !isTwoMinuteTesHomePage && answer.status !== "Completed" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83364f35f447dab2$export$2e2bcd8739ae039), {
                                                                companyId: companyId,
                                                                moduleType: module.type,
                                                                sectionCode: qNo,
                                                                questionId: question._id,
                                                                qNo: question.qNo,
                                                                scope: "question",
                                                                size: "small",
                                                                onComplete: ()=>{
                                                                    reloadModule && reloadModule(tab);
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    isTwoMinuteTesHomePage && (sectionIdx == 0 && questionIdx == 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "two-min-invest-image op80",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic mb1rem op80",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem",
                                                                        children: "Sync"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem",
                                                                        children: "File Manager"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem",
                                                                        children: "Log"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "oyh td250",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                        for: "fileUpload" + new Date().getTime(),
                                                                        className: "w100 bsbb bg50 br5px df jcc fdc aic px1rem py0-5rem bsd bo3 bw2px da-cursor mb0-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                width: "70",
                                                                                height: "70",
                                                                                viewBox: "0 0 70 70",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M59.4632 31.0446C58.5439 25.1606 53.4429 20.6445 47.3047 20.6445C44.9955 20.6445 42.7766 21.2834 40.852 22.4751C37.924 17.5543 32.6528 14.4922 26.7969 14.4922C17.7506 14.4922 10.3906 21.8522 10.3906 30.8984C10.3906 30.9545 10.3906 31.0126 10.3927 31.0687C4.57871 32.048 0 37.1168 0 43.2031C0 49.9883 5.65619 55.5078 12.4414 55.5078H57.5586C64.3438 55.5078 70 49.9883 70 43.2031C70 37.0649 65.3472 31.9639 59.4632 31.0446Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                        "clip-path": "url(#clip0_5984_51759)",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M35 56C42.732 56 49 49.732 49 42C49 34.268 42.732 28 35 28C27.268 28 21 34.268 21 42C21 49.732 27.268 56 35 56Z",
                                                                                                fill: "#4A67FF"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M34.9896 49.6555C33.746 49.6555 32.5026 49.6555 31.2593 49.6555C29.5542 49.6555 28.3237 48.4294 28.315 46.7248C28.3117 46.1298 28.3117 45.5346 28.315 44.9392C28.3182 44.3256 28.6901 43.9308 29.2589 43.9297C29.8276 43.9286 30.2044 44.3207 30.2082 44.9338C30.2121 45.5468 30.2082 46.1456 30.2082 46.7516C30.2126 47.387 30.5861 47.7573 31.2238 47.7578C33.7427 47.7578 36.2614 47.7578 38.78 47.7578C39.4182 47.7578 39.7922 47.387 39.7971 46.7521C39.8015 46.1462 39.7971 45.5402 39.7971 44.9343C39.7971 44.3284 40.175 43.9286 40.746 43.9297C41.3169 43.9308 41.6943 44.3256 41.6893 44.9387C41.6833 45.7136 41.7265 46.4967 41.6292 47.2613C41.4509 48.6602 40.2582 49.6478 38.8429 49.6544C37.5615 49.6582 36.2753 49.6555 34.9896 49.6555Z",
                                                                                                fill: "white"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M34.0577 37.6102C33.9133 37.7448 33.8286 37.8186 33.7498 37.8979C33.1439 38.5098 32.5412 39.1256 31.9325 39.7354C31.5005 40.1685 30.8984 40.2002 30.5079 39.8212C30.1175 39.4423 30.1328 38.8205 30.5577 38.3928C31.7947 37.1481 33.0358 35.9078 34.2808 34.6719C34.7183 34.2344 35.2904 34.2344 35.7279 34.6719C36.9813 35.9151 38.2296 37.1636 39.4729 38.4174C39.8819 38.8303 39.8841 39.451 39.504 39.8218C39.124 40.1926 38.5197 40.1762 38.1024 39.7622C37.4844 39.147 36.8758 38.5219 36.2622 37.9028C36.1829 37.823 36.0981 37.7486 35.9718 37.6294C35.9636 37.8011 35.9537 37.9121 35.9537 38.0231C35.9537 39.9804 35.9565 41.9371 35.9537 43.8944C35.9537 44.6288 35.3073 45.0658 34.6352 44.8044C34.2633 44.6595 34.0615 44.3368 34.0615 43.8643C34.0593 41.9284 34.0593 39.9926 34.0615 38.057L34.0577 37.6102Z",
                                                                                                fill: "white"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                            id: "clip0_5984_51759",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                width: "28",
                                                                                                height: "28",
                                                                                                fill: "white",
                                                                                                transform: "translate(21 28)"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "pen fs1rem fw400 c49 tac op80 mt1rem mb1rem fsi",
                                                                                children: "Click here or drag and drop files (max 100MB)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "oyh td250 pr df aic ",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                rows: "1",
                                                                                style: {
                                                                                    resize: "vertical",
                                                                                    fontSize: "12px",
                                                                                    height: "100px"
                                                                                },
                                                                                name: "comment",
                                                                                type: "text",
                                                                                disabled: true,
                                                                                placeholder: "Add notes",
                                                                                className: "pl3rem bss bw2px bo5 w100 br5px pr1rem py0-75rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                className: "pa ml1rem",
                                                                                width: "18",
                                                                                height: "18",
                                                                                viewBox: "0 0 18 18",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                        "clip-path": "url(#clip0_5984_51771)",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M14.25 8.25H9.75V3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75V8.25H3.75C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75H8.25V14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25V9.75H14.25C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25Z",
                                                                                                fill: "#4A67FF"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                                "clip-path": "url(#clip1_5984_51771)",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M16.7301 14.3415L4.73098 17.2387C4.09339 17.3926 3.45171 17.0005 3.29776 16.3629L0.400638 4.36379C0.246685 3.7262 0.638767 3.08452 1.27636 2.93057L13.2755 0.0334501C13.9131 -0.120503 14.5548 0.27158 14.7087 0.909168L17.6059 12.9083C17.7598 13.5459 17.3678 14.1876 16.7301 14.3415Z",
                                                                                                        fill: "url(#paint0_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M14.3672 14.9115L16.7313 14.3407C17.3688 14.1868 17.7609 13.5451 17.607 12.9075L15.3723 3.65234H14.3672V14.9115Z",
                                                                                                        fill: "url(#paint1_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M15.3863 3.72331L14.7068 0.909168C14.5529 0.271579 13.9112 -0.120503 13.2736 0.0334501L1.27447 2.93057C0.856593 3.03147 0.54424 3.34185 0.421875 3.72331H15.3863Z",
                                                                                                        fill: "url(#paint2_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M1.85156 10.3629L3.30014 16.3624C3.45409 17 4.09574 17.3921 4.73336 17.2382L16.7325 14.341C17.3701 14.1871 17.7622 13.5454 17.6082 12.9078L16.1597 6.9082L1.85156 10.3629Z",
                                                                                                        fill: "url(#paint3_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M11.3983 17.9993H1.36905C0.815741 17.9993 0.367188 17.5508 0.367188 16.9975L0.376011 3.92377C0.376011 3.37046 0.824564 2.92188 1.37787 2.92188H14.4486C15.0019 2.92188 15.4505 3.37043 15.4505 3.92377L15.4417 13.956C15.4417 16.1891 13.6314 17.9993 11.3983 17.9993Z",
                                                                                                        fill: "url(#paint4_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M8.50558 4.14062L7.3125 5.33371L10.9873 9.00846C11.5559 8.8328 12.0046 8.38404 12.1803 7.81538L8.50558 4.14062Z",
                                                                                                        fill: "url(#paint5_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M7.90614 5.57985C8.37206 5.57985 8.74977 5.20214 8.74977 4.73621C8.74977 4.27029 8.37206 3.89258 7.90614 3.89258C7.44021 3.89258 7.0625 4.27029 7.0625 4.73621C7.0625 5.20214 7.44021 5.57985 7.90614 5.57985Z",
                                                                                                        fill: "url(#paint6_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M0.367188 10.6563V16.9965C0.367188 17.5498 0.815741 17.9983 1.36905 17.9983H11.3983C13.6314 17.9983 15.4417 16.1881 15.4417 13.955V10.6562H0.367188V10.6563Z",
                                                                                                        fill: "url(#paint7_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M11.3984 17.9984V14.957C11.3984 14.4037 11.847 13.9551 12.4003 13.9551H15.4418C15.4418 16.1882 13.6315 17.9984 11.3984 17.9984Z",
                                                                                                        fill: "url(#paint8_linear_5984_51771)"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M13.0689 9.20312H7.28104C7.07404 9.20312 6.90625 9.37091 6.90625 9.57791C6.90625 9.78491 7.07404 9.9527 7.28104 9.9527H13.0689C13.2759 9.9527 13.4437 9.78491 13.4437 9.57791C13.4437 9.37091 13.2759 9.20312 13.0689 9.20312Z",
                                                                                                        fill: "white"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M2.74979 9.9527H4.44885C4.65585 9.9527 4.82364 9.78491 4.82364 9.57791C4.82364 9.37091 4.65585 9.20312 4.44885 9.20312H2.74979C2.54279 9.20312 2.375 9.37091 2.375 9.57791C2.375 9.78491 2.54279 9.9527 2.74979 9.9527Z",
                                                                                                        fill: "white"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M5.375 9.57791C5.375 9.78491 5.54279 9.9527 5.74979 9.9527H6.17455C6.38155 9.9527 6.54934 9.78491 6.54934 9.57791C6.54934 9.37091 6.38155 9.20312 6.17455 9.20312H5.74979C5.54282 9.20312 5.375 9.37091 5.375 9.57791Z",
                                                                                                        fill: "white"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M8.53764 10.9688H2.74979C2.54279 10.9688 2.375 11.1365 2.375 11.3435C2.375 11.5505 2.54279 11.7183 2.74979 11.7183H8.53764C8.74464 11.7183 8.91242 11.5505 8.91242 11.3435C8.91242 11.1365 8.74464 10.9688 8.53764 10.9688Z",
                                                                                                        fill: "white"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M13.066 10.9688H11.367C11.16 10.9688 10.9922 11.1365 10.9922 11.3435C10.9922 11.5505 11.16 11.7183 11.367 11.7183H13.066C13.273 11.7183 13.4408 11.5505 13.4408 11.3435C13.4408 11.1365 13.273 10.9688 13.066 10.9688Z",
                                                                                                        fill: "white"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M10.073 10.9688H9.64823C9.44123 10.9688 9.27344 11.1365 9.27344 11.3435C9.27344 11.5505 9.44123 11.7183 9.64823 11.7183H10.073C10.28 11.7183 10.4478 11.5505 10.4478 11.3435C10.4478 11.1365 10.28 10.9688 10.073 10.9688Z",
                                                                                                        fill: "white"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint0_linear_5984_51771",
                                                                                                x1: "4.64913",
                                                                                                y1: "5.97348",
                                                                                                x2: "20.2804",
                                                                                                y2: "15.518",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#D9B1EE"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#814AA0"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint1_linear_5984_51771",
                                                                                                x1: "16.8003",
                                                                                                y1: "9.28193",
                                                                                                x2: "15.1027",
                                                                                                y2: "9.28193",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#5B3374",
                                                                                                        "stop-opacity": "0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#5B3374"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint2_linear_5984_51771",
                                                                                                x1: "7.90405",
                                                                                                y1: "1.33693",
                                                                                                x2: "7.90405",
                                                                                                y2: "3.53614",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#5B3374",
                                                                                                        "stop-opacity": "0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#5B3374"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint3_linear_5984_51771",
                                                                                                x1: "10.1943",
                                                                                                y1: "13.541",
                                                                                                x2: "11.0307",
                                                                                                y2: "17.0005",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#5B3374",
                                                                                                        "stop-opacity": "0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#5B3374"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint4_linear_5984_51771",
                                                                                                x1: "0.973999",
                                                                                                y1: "3.52579",
                                                                                                x2: "14.9207",
                                                                                                y2: "17.4724",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#FFDD00"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#FFB000"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint5_linear_5984_51771",
                                                                                                x1: "9.96461",
                                                                                                y1: "6.7927",
                                                                                                x2: "5.00606",
                                                                                                y2: "1.83419",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#FEA613",
                                                                                                        "stop-opacity": "0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#E94444"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint6_linear_5984_51771",
                                                                                                x1: "7.37934",
                                                                                                y1: "4.20938",
                                                                                                x2: "8.24118",
                                                                                                y2: "5.07123",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#FE93BB"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#FD3581"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint7_linear_5984_51771",
                                                                                                x1: "7.90442",
                                                                                                y1: "15.5917",
                                                                                                x2: "7.90442",
                                                                                                y2: "19.8029",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#FEA613",
                                                                                                        "stop-opacity": "0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#E94444"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint8_linear_5984_51771",
                                                                                                x1: "12.3144",
                                                                                                y1: "14.8711",
                                                                                                x2: "14.6838",
                                                                                                y2: "17.2404",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#FFDD00"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#FFB000"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                id: "clip0_5984_51771",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                    width: "18",
                                                                                                    height: "18",
                                                                                                    fill: "white"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                id: "clip1_5984_51771",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                    width: "18",
                                                                                                    height: "18",
                                                                                                    fill: "white"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "two-min-invest-image",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                for: "fileUpload" + new Date().getTime(),
                                                                className: "w100 bsbb bg50 br5px df jcfs aic px0-5rem py1rem bsd bo3 bw2px da-cursor mb0-5rem op60",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "24",
                                                                        height: "25",
                                                                        viewBox: "0 0 24 25",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                "clip-path": "url(#clip0_5984_51832)",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M18.75 24.5H5.25C4.01 24.5 3 23.491 3 22.25V11.75C3 10.509 4.01 9.5 5.25 9.5H18.75C19.99 9.5 21 10.509 21 11.75V22.25C21 23.491 19.99 24.5 18.75 24.5ZM5.25 11C4.837 11 4.5 11.336 4.5 11.75V22.25C4.5 22.664 4.837 23 5.25 23H18.75C19.163 23 19.5 22.664 19.5 22.25V11.75C19.5 11.336 19.163 11 18.75 11H5.25Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M17.25 11C16.836 11 16.5 10.664 16.5 10.25V6.5C16.5 4.019 14.481 2 12 2C9.519 2 7.5 4.019 7.5 6.5V10.25C7.5 10.664 7.164 11 6.75 11C6.336 11 6 10.664 6 10.25V6.5C6 3.191 8.691 0.5 12 0.5C15.309 0.5 18 3.191 18 6.5V10.25C18 10.664 17.664 11 17.25 11Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M12 17.5C10.897 17.5 10 16.603 10 15.5C10 14.397 10.897 13.5 12 13.5C13.103 13.5 14 14.397 14 15.5C14 16.603 13.103 17.5 12 17.5ZM12 15C11.725 15 11.5 15.224 11.5 15.5C11.5 15.776 11.725 16 12 16C12.275 16 12.5 15.776 12.5 15.5C12.5 15.224 12.275 15 12 15Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M12 20.5C11.586 20.5 11.25 20.164 11.25 19.75V17C11.25 16.586 11.586 16.25 12 16.25C12.414 16.25 12.75 16.586 12.75 17V19.75C12.75 20.164 12.414 20.5 12 20.5Z",
                                                                                        fill: "#4A67FF"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                    id: "clip0_5984_51832",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                        width: "24",
                                                                                        height: "24",
                                                                                        fill: "white",
                                                                                        transform: "translate(0 0.5)"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df fdc jcfs aifs ml1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "pen fs1rem tal fw500 w100 c3 op80 m0rem fsi",
                                                                                children: " Register to access more features "
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "fs13px tal w100 fsi",
                                                                                children: sectionIdx === 0 && [
                                                                                    1,
                                                                                    2
                                                                                ].includes(questionIdx) ? "(No credit card required)" : "Tools Tip, Add files, Sync, File manager, Log"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        disabled: true,
                                                                        className: "dn",
                                                                        id: "fileUpload" + new Date().getTime(),
                                                                        type: "file",
                                                                        multiple: true
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })),
                                                    !isTwoMinuteTesHomePage && answer?.['_id'] && (answer?.['radioOption'] == 'Yes' || answer?.['radioOption'] == 'Disclosure' || answer?.autoFilled) && (question.questionType.includes('F') || question.questionType === 'D/ND') && !module?.['type']?.includes('investor-lead') && !module['type'].includes("directors-questionnaire") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fww mt0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "w100 df jcsb aic cp py0-25rem",
                                                                style: {
                                                                    borderBottom: '1px solid #e5e7eb'
                                                                },
                                                                onClick: ()=>setRightPanelOpenMap((prev)=>({
                                                                            ...prev,
                                                                            [question._id]: prev[question._id] === true ? false : true
                                                                        })),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs13px fw500 c14",
                                                                        children: "Files & Collaboration"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "14",
                                                                        height: "14",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        style: {
                                                                            transform: rightPanelOpenMap[question._id] === true ? 'rotate(0deg)' : 'rotate(-90deg)',
                                                                            transition: 'transform 0.2s'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M6 9l6 6 6-6",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "2",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            rightPanelOpenMap[question._id] === true && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "w100 df jcc aic mb0-5rem mt0-5rem",
                                                                        style: {
                                                                            borderBottom: '2px solid #e5e7eb'
                                                                        },
                                                                        children: [
                                                                            {
                                                                                key: 'files',
                                                                                show: true,
                                                                                label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                    children: [
                                                                                        "Files ",
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                            class: "fs12px c12",
                                                                                            style: {
                                                                                                marginLeft: '4px'
                                                                                            },
                                                                                            children: [
                                                                                                "(",
                                                                                                answer.files?.length || 0,
                                                                                                ")"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                    src: (parcelRequire("atCxS")),
                                                                                    alt: "icon",
                                                                                    className: "mr0-5rem"
                                                                                })
                                                                            },
                                                                            {
                                                                                key: 'collaborate',
                                                                                show: true,
                                                                                label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                    children: [
                                                                                        "Collaborate ",
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                            class: "fs12px c12",
                                                                                            style: {
                                                                                                marginLeft: '4px'
                                                                                            },
                                                                                            children: [
                                                                                                "(",
                                                                                                answer.taskNotes?.length || 0,
                                                                                                ")"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                dot: (answer.taskNotes?.length || 0) > 0,
                                                                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                    src: (parcelRequire("5IILg")),
                                                                                    alt: "icon",
                                                                                    className: "mr0-5rem"
                                                                                })
                                                                            },
                                                                            {
                                                                                key: 'toolbox',
                                                                                show: true,
                                                                                label: 'Toolbox',
                                                                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                    src: (parcelRequire("1MTnu")),
                                                                                    alt: "icon",
                                                                                    className: "mr0-5rem"
                                                                                })
                                                                            }
                                                                        ].filter((t)=>t.show).map((t)=>{
                                                                            const isActive = (rightPanelTabMap[question._id] || _defaultTab) === t.key;
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                onClick: ()=>setRightPanelTabMap((prev)=>({
                                                                                            ...prev,
                                                                                            [question._id]: t.key
                                                                                        })),
                                                                                className: `df jcc aic cp bg1 fw500 fs14px px2rem py0-5rem pr c15`,
                                                                                style: {
                                                                                    borderBottom: isActive && '2px solid #4A67FF'
                                                                                },
                                                                                children: [
                                                                                    t.icon,
                                                                                    t.label,
                                                                                    t.dot && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "mb0-5rem br50px bg4",
                                                                                        style: {
                                                                                            width: '6px',
                                                                                            height: '6px',
                                                                                            display: 'inline-block'
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }, t.key);
                                                                        })
                                                                    }),
                                                                    (rightPanelTabMap[question._id] || _defaultTab) === 'files' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        class: "w100 mt0-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df jcfs ml1rem mb1rem",
                                                                                children: [
                                                                                    canSync && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        onClick: ()=>company.gDriveLink && syncDrive(sectionId, question['qNo']) || company.sharePointLink && syncSharePoint(sectionId, question['qNo']) || company.dropBoxLink && syncDropbox(sectionId, question['qNo']),
                                                                                        className: "df jcc aic bg5 br50px px1rem mr1rem py0-25rem fw400 bss bo16 bw1px c14 fs12px cp",
                                                                                        children: [
                                                                                            "Sync ",
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "df aic ml0-5rem",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                    src: (parcelRequire("1Ar70")),
                                                                                                    alt: "sync",
                                                                                                    style: {
                                                                                                        width: '14px',
                                                                                                        height: '14px'
                                                                                                    }
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    showFiles && answer?.files?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        onClick: ()=>{
                                                                                            const isWarrantyDisclosure = tab === "warranty-disclosure";
                                                                                            if (isWarrantyDisclosure) setSection({
                                                                                                ...section,
                                                                                                questionId: question?.['qNo'],
                                                                                                question: question
                                                                                            });
                                                                                            else setSection({
                                                                                                ...section,
                                                                                                questionId: question?.['qNo']
                                                                                            });
                                                                                            onClickFileManager(section, questionIdx);
                                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                                open: isWarrantyDisclosure ? 'manageWarrantyDisclosureFiles' : 'manageFiles'
                                                                                            }));
                                                                                        },
                                                                                        className: "df jcc aic bg5 br50px mr1rem px1rem py0-25rem fw400 bss bo16 bw1px c14 fs12px cp",
                                                                                        children: [
                                                                                            "File Manager (",
                                                                                            answer.files.length,
                                                                                            ")"
                                                                                        ]
                                                                                    }),
                                                                                    answer?.['updatedBy'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        onClick: ()=>{
                                                                                            setSection({
                                                                                                ...section,
                                                                                                questionId: question?.['qNo']
                                                                                            });
                                                                                            handleSectionLogs(answer['_id']);
                                                                                            setLogModule(` - ${question['qNo']} ${section['sectionName'] || section['name']}`);
                                                                                        },
                                                                                        className: "df jcc aic bg5 br50px mr1rem px1rem py0-25rem fw400 bss bo16 bw1px c14 fs12px cp",
                                                                                        children: "Log"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showFiles && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                        onDragOver: onDragOver,
                                                                                        onDrop: (e)=>onDrop(e, question, qNo),
                                                                                        htmlFor: "fileUpload" + question._id,
                                                                                        className: "w100 bg1 br10px df jcc fdc aic px2rem py0-5rem cp mb0-5rem",
                                                                                        style: {
                                                                                            border: '2px dotted #d2d2d2'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                width: "40",
                                                                                                height: "40",
                                                                                                viewBox: "0 0 40 40",
                                                                                                fill: "none",
                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M33.979 17.7398C33.4537 14.3775 30.5388 11.7969 27.0312 11.7969C25.7117 11.7969 24.4438 12.162 23.344 12.8429C21.6709 10.031 18.6588 8.28125 15.3125 8.28125C10.1432 8.28125 5.9375 12.487 5.9375 17.6562C5.9375 17.6883 5.9375 17.7215 5.93867 17.7535C2.61641 18.3131 0 21.2096 0 24.6875C0 28.5648 3.23211 31.7188 7.10938 31.7188H32.8906C36.7679 31.7188 40 28.5648 40 24.6875C40 21.1799 37.3413 18.2651 33.979 17.7398Z",
                                                                                                        fill: "#F3F5FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                                        clipPath: "url(#clip0_6001_237r)",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z",
                                                                                                                fill: "#4A67FF"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M19.9952 28.3744C19.2845 28.3744 18.574 28.3744 17.8636 28.3744C16.8892 28.3744 16.1861 27.6738 16.1811 26.6997C16.1792 26.3597 16.1792 26.0196 16.1811 25.6794C16.183 25.3288 16.3955 25.1032 16.7205 25.1025C17.0455 25.1019 17.2608 25.326 17.263 25.6763C17.2652 26.0266 17.263 26.3688 17.263 26.715C17.2655 27.0782 17.4789 27.2897 17.8433 27.29C19.2827 27.29 20.7219 27.29 22.1611 27.29C22.5258 27.29 22.7395 27.0782 22.7423 26.7154C22.7448 26.3691 22.7423 26.0229 22.7423 25.6766C22.7423 25.3304 22.9583 25.1019 23.2845 25.1025C23.6108 25.1032 23.8264 25.3288 23.8236 25.6791C23.8202 26.1219 23.8448 26.5694 23.7892 27.0063C23.6873 27.8057 23.0058 28.37 22.197 28.3738C21.4648 28.376 20.7298 28.3744 19.9952 28.3744Z",
                                                                                                                fill: "#F3F5FF"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M19.4627 21.4916C19.3802 21.5684 19.3317 21.6106 19.2867 21.6559C18.9405 22.0056 18.5961 22.3575 18.2483 22.7059C18.0014 22.9534 17.6573 22.9716 17.4342 22.755C17.2111 22.5384 17.2198 22.1831 17.4627 21.9387C18.1695 21.2275 18.8787 20.5188 19.5902 19.8125C19.8402 19.5625 20.167 19.5625 20.417 19.8125C21.1333 20.5229 21.8466 21.2364 22.557 21.9528C22.7908 22.1888 22.792 22.5434 22.5748 22.7553C22.3577 22.9672 22.0123 22.9578 21.7739 22.7213C21.4208 22.3697 21.073 22.0125 20.7223 21.6588C20.677 21.6131 20.6286 21.5706 20.5564 21.5025C20.5517 21.6006 20.5461 21.6641 20.5461 21.7275C20.5461 22.8459 20.5477 23.9641 20.5461 25.0825C20.5461 25.5022 20.1767 25.7519 19.7927 25.6025C19.5802 25.5197 19.4648 25.3353 19.4648 25.0653C19.4636 23.9591 19.4636 22.8529 19.4648 21.7469L19.4627 21.4916Z",
                                                                                                                fill: "#F3F5FF"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                            id: "clip0_6001_237r",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                                width: "16",
                                                                                                                height: "16",
                                                                                                                fill: "white",
                                                                                                                transform: "translate(12 16)"
                                                                                                            })
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "op80 pen fs0-75rem fw400 c12 tac mt0-5rem fsi",
                                                                                                children: "Click here or drag and drop files (max 100MB)"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                onChange: (e)=>saveAnswer(e, question, qNo),
                                                                                                className: "dn",
                                                                                                id: "fileUpload" + question._id,
                                                                                                type: "file",
                                                                                                multiple: true
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    answer.files && answer.files.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fw500 c14 mt1rem fs0-75rem",
                                                                                        children: "Attached Files"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df fdc w100",
                                                                                        style: {
                                                                                            maxHeight: '15vh',
                                                                                            overflow: 'auto'
                                                                                        },
                                                                                        children: answer.files && answer.files.map((file, fileIdx)=>{
                                                                                            let fileColor = file.originator == 'ai-report' ? 'ai-report' : file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "df aic py0-25rem bg5 px1rem br20px mt0-5rem",
                                                                                                style: {
                                                                                                    maxWidth: 'max-content'
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "df aic cp",
                                                                                                        onClick: ()=>getViewableURL(file.location),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: `br50px mr0-5rem ${fileColor}`,
                                                                                                                style: {
                                                                                                                    width: '10px',
                                                                                                                    height: '10px',
                                                                                                                    minWidth: '10px',
                                                                                                                    flexShrink: 0
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: "fw500 c52 fs12px",
                                                                                                                children: file.originalname && file.originalname.length > 40 ? file.originalname.slice(0, 40) + '...' : file.originalname
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99875422f9004601$export$2e2bcd8739ae039), {
                                                                                                        aiMatch: file.aiMatch,
                                                                                                        fileName: file.originalname
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "fa fa-trash-o cp c23 ml0-5rem",
                                                                                                        onClick: (e)=>{
                                                                                                            e.preventDefault();
                                                                                                            setDeleteFileQuestionId(question._id);
                                                                                                            setDeleteFile(file);
                                                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                                                open: 'deleteFile',
                                                                                                                from: ''
                                                                                                            }));
                                                                                                        }
                                                                                                    })
                                                                                                ]
                                                                                            }, `repo-file-${question._id}-${fileIdx}-${file.key || file.originalname}`);
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            module['type'].includes('directors-questionnaire') && question.questionType.includes('T') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "mt1rem",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                    defaultValue: answer.comment,
                                                                                    rows: "3",
                                                                                    style: {
                                                                                        resize: "vertical"
                                                                                    },
                                                                                    onBlur: (e)=>saveAnswer(e, question, qNo),
                                                                                    name: "comment",
                                                                                    className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                                                    placeholder: "Please enter your answer"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    (rightPanelTabMap[question._id] || _defaultTab) === 'collaborate' && /*#__PURE__*/ (0, $ayMG0.jsx)($866b869d60dd72c1$var$WorkflowInlinePanel, {
                                                                        answer: answer,
                                                                        question: question,
                                                                        section: section,
                                                                        module: module,
                                                                        company: company,
                                                                        user: user,
                                                                        onAnswerUpdated: (updatedAnswer)=>patchAnswerInline(question._id, module.type, updatedAnswer)
                                                                    }),
                                                                    (rightPanelTabMap[question._id] || _defaultTab) === 'toolbox' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w100 df fdc mt0-5rem px0-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                class: "w100 c12 fs15px fw300 mb0-5rem",
                                                                                children: "AI-powered tools to help you analyse and generate content for this question."
                                                                            }),
                                                                            showPolicyMaker && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc aic bg1 br10px bw1px bss bo16 p1rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "w100 df jcsb mb0-5rem",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                class: "df aic",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                        src: (parcelRequire("gA5Zr")),
                                                                                                        alt: "policymaker",
                                                                                                        className: "w20px h20px mr0-5rem"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                        className: "fw500 c14 fs14px",
                                                                                                        children: "PolicyMaker"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                                disabled: true,
                                                                                                className: "df aic px1rem py0-25rem fs14px fw500 c3 bg1 br50px bw1px bss bo3 op50 cna",
                                                                                                children: [
                                                                                                    "Launch",
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                        class: "ml0-5rem",
                                                                                                        width: "16",
                                                                                                        height: "16",
                                                                                                        viewBox: "0 0 16 16",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            "fill-rule": "evenodd",
                                                                                                            "clip-rule": "evenodd",
                                                                                                            d: "M14 8.82164C14 9.35985 13.5637 9.79616 13.0255 9.79616C12.4872 9.79616 12.0509 9.35985 12.0509 8.82164V5.32737L3.66359 13.7145C3.28303 14.0952 2.66605 14.0952 2.28544 13.7145C1.90485 13.334 1.90486 12.7169 2.28543 12.3363L10.6729 3.94904H7.17474C6.63651 3.94904 6.20021 3.51273 6.20021 2.97452C6.20021 2.4363 6.63651 2 7.17474 2H13.0255C13.5637 2 14 2.43631 14 2.97452V8.82164Z",
                                                                                                            fill: "#4A67FF"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fs12px c12",
                                                                                        children: "Automatically draft policy clauses and standard commercial terms based on your uploaded agreements and jurisdiction preferences."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            showAnalyser && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc aic bg1 br10px bw1px bss bo16 p1rem mt0-5rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "w100 df jcsb mb0-5rem",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                class: "df aic",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                        src: (parcelRequire("gA5Zr")),
                                                                                                        alt: "policymaker",
                                                                                                        className: "w20px h20px mr0-5rem"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                        className: "fw500 c14 fs14px",
                                                                                                        children: "Analyser"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                                onClick: ()=>canReport && hasFiles && !isAnyGenerating ? generateInsuranceAiReport({
                                                                                                        data: question,
                                                                                                        isQuestion: true
                                                                                                    }) : undefined,
                                                                                                className: `df aic px1rem py0-25rem fs14px fw500 c3 bg1 br50px bw1px bss bo3 ${canReport && hasFiles && !isAnyGenerating ? 'cp' : 'op50 cna'}`,
                                                                                                "data-tooltip": !hasFiles ? analyserDisabledTooltip : "",
                                                                                                children: [
                                                                                                    isGenerating ? 'Generating...' : 'Launch',
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                        class: "ml0-5rem",
                                                                                                        width: "16",
                                                                                                        height: "16",
                                                                                                        viewBox: "0 0 16 16",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            "fill-rule": "evenodd",
                                                                                                            "clip-rule": "evenodd",
                                                                                                            d: "M14 8.82164C14 9.35985 13.5637 9.79616 13.0255 9.79616C12.4872 9.79616 12.0509 9.35985 12.0509 8.82164V5.32737L3.66359 13.7145C3.28303 14.0952 2.66605 14.0952 2.28544 13.7145C1.90485 13.334 1.90486 12.7169 2.28543 12.3363L10.6729 3.94904H7.17474C6.63651 3.94904 6.20021 3.51273 6.20021 2.97452C6.20021 2.4363 6.63651 2 7.17474 2H13.0255C13.5637 2 14 2.43631 14 2.97452V8.82164Z",
                                                                                                            fill: "#4A67FF"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fs12px c12",
                                                                                        children: "Scan uploaded documents for key risks, obligations, and red-flag clauses. Get a structured summary ready for due diligence review."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: module['uploadFiles'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: (module['type'].includes("directors-questionnaire") || module['type'].includes("investor-lead")) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    question?.questionType.includes("F") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: (question?.questionType.includes("YN") && (showFiles ? "" : "op0 h0 dn ")) + "showOrHide oyh td250 oxh p1rem px1-5rem br10px",
                                                                        style: {
                                                                            background: '#F3F5FF'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic jcsb mb0-5rem cp",
                                                                                onClick: ()=>setUploadOpenMap((prev)=>({
                                                                                            ...prev,
                                                                                            [question._id]: prev[question._id] !== false ? false : true
                                                                                        })),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df aic",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                className: "mr0-5rem",
                                                                                                width: "20",
                                                                                                height: "20",
                                                                                                viewBox: "0 0 20 20",
                                                                                                fill: "none",
                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                                        clipPath: "url(#clip0_6001_294_dq)",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M4.85746 16.7168C2.75033 14.9386 2.60107 11.6378 4.52471 9.35828L9.75741 3.15748C10.9943 1.69173 13.1027 1.43054 14.4565 2.57298C15.8103 3.71542 15.9073 5.83769 14.6704 7.30344L9.68688 13.209C9.27425 13.6979 8.57252 13.7852 8.12052 13.4038C7.66853 13.0224 7.63658 12.316 8.04922 11.827L13.0327 5.92146C13.4454 5.43248 13.4123 4.72514 12.9614 4.34464C12.5105 3.96413 11.8077 4.05049 11.3951 4.53947L6.16237 10.7403C5.06301 12.043 5.14829 13.9289 6.35252 14.9451C7.55675 15.9613 9.43012 15.7283 10.5295 14.4256L17.2572 6.45311C17.6699 5.96414 18.3716 5.87685 18.8236 6.25828C19.2756 6.63971 19.3075 7.34612 18.8949 7.8351L12.1671 15.8076C10.2435 18.0871 6.96459 18.4949 4.85746 16.7168Z",
                                                                                                            fill: "#4A67FF"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                            id: "clip0_6001_294_dq",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                                width: "20",
                                                                                                                height: "20",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                className: "fs16px c14 fw400 mb0",
                                                                                                children: [
                                                                                                    "Files ",
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                                        className: "fs14px c12",
                                                                                                        children: [
                                                                                                            "(",
                                                                                                            answer.files ? answer.files.length : 0,
                                                                                                            ")"
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                        style: {
                                                                                            transition: 'transform 0.2s',
                                                                                            transform: uploadOpenMap[question._id] !== false ? 'rotate(180deg)' : 'rotate(0deg)'
                                                                                        },
                                                                                        width: "16",
                                                                                        height: "16",
                                                                                        viewBox: "0 0 24 24",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M6 9l6 6 6-6",
                                                                                            stroke: "#4A67FF",
                                                                                            strokeWidth: "2",
                                                                                            strokeLinecap: "round",
                                                                                            strokeLinejoin: "round"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            uploadOpenMap[question._id] !== false && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                onDragOver: onDragOver,
                                                                                onDrop: (e)=>onDrop(e, question, qNo),
                                                                                htmlFor: "fileUpload" + question._id,
                                                                                className: "w100 bg1 br10px df jcc fdc aic px2rem py0-5rem cp mb0-5rem",
                                                                                style: {
                                                                                    border: '2px dotted #d2d2d2'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                        width: "40",
                                                                                        height: "40",
                                                                                        viewBox: "0 0 40 40",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M33.979 17.7398C33.4537 14.3775 30.5388 11.7969 27.0312 11.7969C25.7117 11.7969 24.4438 12.162 23.344 12.8429C21.6709 10.031 18.6588 8.28125 15.3125 8.28125C10.1432 8.28125 5.9375 12.487 5.9375 17.6562C5.9375 17.6883 5.9375 17.7215 5.93867 17.7535C2.61641 18.3131 0 21.2096 0 24.6875C0 28.5648 3.23211 31.7188 7.10938 31.7188H32.8906C36.7679 31.7188 40 28.5648 40 24.6875C40 21.1799 37.3413 18.2651 33.979 17.7398Z",
                                                                                                fill: "#F3F5FF"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                                clipPath: "url(#clip0_6001_237_dq)",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z",
                                                                                                        fill: "#4A67FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M19.9952 28.3744C19.2845 28.3744 18.574 28.3744 17.8636 28.3744C16.8892 28.3744 16.1861 27.6738 16.1811 26.6997C16.1792 26.3597 16.1792 26.0196 16.1811 25.6794C16.183 25.3288 16.3955 25.1032 16.7205 25.1025C17.0455 25.1019 17.2608 25.326 17.263 25.6763C17.2652 26.0266 17.263 26.3688 17.263 26.715C17.2655 27.0782 17.4789 27.2897 17.8433 27.29C19.2827 27.29 20.7219 27.29 22.1611 27.29C22.5258 27.29 22.7395 27.0782 22.7423 26.7154C22.7448 26.3691 22.7423 26.0229 22.7423 25.6766C22.7423 25.3304 22.9583 25.1019 23.2845 25.1025C23.6108 25.1032 23.8264 25.3288 23.8236 25.6791C23.8202 26.1219 23.8448 26.5694 23.7892 27.0063C23.6873 27.8057 23.0058 28.37 22.197 28.3738C21.4648 28.376 20.7298 28.3744 19.9952 28.3744Z",
                                                                                                        fill: "#F3F5FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M19.4627 21.4916C19.3802 21.5684 19.3317 21.6106 19.2867 21.6559C18.9405 22.0056 18.5961 22.3575 18.2483 22.7059C18.0014 22.9534 17.6573 22.9716 17.4342 22.755C17.2111 22.5384 17.2198 22.1831 17.4627 21.9387C18.1695 21.2275 18.8787 20.5188 19.5902 19.8125C19.8402 19.5625 20.167 19.5625 20.417 19.8125C21.1333 20.5229 21.8466 21.2364 22.557 21.9528C22.7908 22.1888 22.792 22.5434 22.5748 22.7553C22.3577 22.9672 22.0123 22.9578 21.7739 22.7213C21.4208 22.3697 21.073 22.0125 20.7223 21.6588C20.677 21.6131 20.6286 21.5706 20.5564 21.5025C20.5517 21.6006 20.5461 21.6641 20.5461 21.7275C20.5461 22.8459 20.5477 23.9641 20.5461 25.0825C20.5461 25.5022 20.1767 25.7519 19.7927 25.6025C19.5802 25.5197 19.4648 25.3353 19.4648 25.0653C19.4636 23.9591 19.4636 22.8529 19.4648 21.7469L19.4627 21.4916Z",
                                                                                                        fill: "#F3F5FF"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                    id: "clip0_6001_237_dq",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                        width: "16",
                                                                                                        height: "16",
                                                                                                        fill: "white",
                                                                                                        transform: "translate(12 16)"
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "op80 pen fs0-75rem fw400 c12 tac mt0-5rem fsi",
                                                                                        children: "Click here or drag and drop files (max 100MB)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        onChange: (e)=>saveAnswer(e, question, qNo),
                                                                                        className: "dn",
                                                                                        id: "fileUpload" + question._id,
                                                                                        type: "file",
                                                                                        multiple: true
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            uploadOpenMap[question._id] !== false && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    answer.files && answer.files.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: "fw500 c12 mt1rem fs0-75rem",
                                                                                        children: "Attached Files"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df fdc w100",
                                                                                        style: {
                                                                                            maxHeight: '20vh',
                                                                                            overflow: 'auto'
                                                                                        },
                                                                                        children: answer.files && answer.files.map((file, fileIndex)=>{
                                                                                            let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "df aic py0-5rem bg1 px1rem br20px mt0-5rem",
                                                                                                style: {
                                                                                                    maxWidth: 'max-content'
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "df aic cp",
                                                                                                        onClick: ()=>getViewableURL(file.location),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: `br50px mr0-5rem ${fileColor}`,
                                                                                                                style: {
                                                                                                                    width: '10px',
                                                                                                                    height: '10px',
                                                                                                                    minWidth: '10px',
                                                                                                                    flexShrink: 0
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: "fw500 c14 fs12px",
                                                                                                                children: file.originalname && file.originalname.length > 40 ? file.originalname.slice(0, 40) + '...' : file.originalname
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99875422f9004601$export$2e2bcd8739ae039), {
                                                                                                        aiMatch: file.aiMatch,
                                                                                                        fileName: file.originalname
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "fa fa-trash-o cp c23",
                                                                                                        onClick: (e)=>{
                                                                                                            e.preventDefault();
                                                                                                            setDeleteFileQuestionId(question._id);
                                                                                                            setDeleteFile(file);
                                                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                                                open: 'deleteFile',
                                                                                                                from: ''
                                                                                                            }));
                                                                                                        }
                                                                                                    })
                                                                                                ]
                                                                                            }, `allocated-file-${question._id}-${fileIndex}-${file.key || file.originalname}`);
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    question?.questionType.includes("T") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                        children: module['type'].includes("investor-lead") && question['qNo'] == "DEPF008.3.1" ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "mah40vh oa oyh td250 pr mt1rem",
                                                                            children: question?.['subQuestions'] && question['subQuestions'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                children: question?.['subQuestions'].map((subQuestion, subIdx)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                children: subQuestion['subQDescription']
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                                defaultValue: question?.['answer']?.['subAnswers'] && question?.['answer']?.['subAnswers']?.[subQuestion['subQNo']],
                                                                                                rows: "1",
                                                                                                style: {
                                                                                                    resize: "vertical"
                                                                                                },
                                                                                                onBlur: (e)=>saveAnswer(e, question, qNo),
                                                                                                name: subQuestion['subQNo'],
                                                                                                type: "text",
                                                                                                className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                                                                placeholder: `Please enter director LinkedIn url here`
                                                                                            })
                                                                                        ]
                                                                                    }, `subquestion-${question._id}-${subIdx}-${subQuestion['subQNo']}`);
                                                                                })
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                defaultValue: answer.comment,
                                                                                rows: "1",
                                                                                style: {
                                                                                    resize: "vertical"
                                                                                },
                                                                                onBlur: (e)=>saveAnswer(e, question, qNo),
                                                                                name: "comment",
                                                                                type: "text",
                                                                                className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                                                placeholder: `Please enter director LinkedIn url here`
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: (question?.questionType.includes("YN") ? showFiles ? "" : "op0 h0 dn " : "") + "oyh td250 pr mt1rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                defaultValue: answer.comment,
                                                                                rows: "2",
                                                                                style: {
                                                                                    resize: "vertical"
                                                                                },
                                                                                onBlur: (e)=>saveAnswer(e, question, qNo),
                                                                                name: "comment",
                                                                                type: "text",
                                                                                className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                                                placeholder: "Please enter your answer"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, question._id);
                            }),
                            showSubFolder && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "toggleHeight cp",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "oh dg",
                                    style: {
                                        cursor: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                        " ",
                                        getSectionHTML(module, section, parentSectionName || section['sectionName'] || section['name'])
                                    ]
                                })
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: (el)=>{
                            if (section['sectionNo']) sectionRefs.current[sectionIdx] = el;
                        },
                        id: qNo,
                        className: (section['sectionNo'] && "sectionWrapper ") + " bss bw2px bo31 br10px px1rem py1rem mb0-5rem fs1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df mb0-5rem jcsb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        style: {
                                            gap: '0.75rem',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "fs1rem mr0-5rem c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fw400",
                                                        children: [
                                                            section['sectionName'] && `Section ${sectionIdx + 1}: `,
                                                            " "
                                                        ]
                                                    }),
                                                    section['sectionName'] || section['name']
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: (section['sectionNo'] && "sectionTitle") + " fs0-75rem c15",
                                                children: [
                                                    qNo,
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "mx0-5rem",
                                                        children: " | "
                                                    }),
                                                    " ",
                                                    getCompletenessAndRiskHTML(module.type, section.stats, questions)
                                                ]
                                            }),
                                            (()=>{
                                                const sectionQ = questions?.find((q)=>q.qNo === qNo && q?.['answer']?.['autoFilled'] && q?.['answer']?.['autoFillConfidence'] != null);
                                                if (!sectionQ) return null;
                                                const conf = sectionQ['answer']['autoFillConfidence'];
                                                const score = Math.floor(conf * 10);
                                                if (score > 5 || sectionQ['answer']['taskStatus'] === 'Completed') return null;
                                                const color = conf >= 0.7 ? '#059669' : conf >= 0.4 ? '#D97706' : '#9CA3AF';
                                                const bg = conf >= 0.7 ? '#ECFDF5' : conf >= 0.4 ? '#FFFBEB' : '#F3F4F6';
                                                const borderColor = conf >= 0.7 ? '#6EE7B7' : conf >= 0.4 ? '#FDE68A' : '#E5E7EB';
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "br50px px0-75rem py0-25rem fs12px fw500 df aic gg0-25rem",
                                                    style: {
                                                        background: bg,
                                                        color: color,
                                                        border: '1px solid ' + borderColor
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 66 56",
                                                            version: "1.1",
                                                            width: "16",
                                                            height: "16",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M 31.233 11.238 C 30.508 12.124, 30.592 12.860, 31.513 13.708 C 32.541 14.654, 33.063 14.629, 33.925 13.590 C 34.738 12.611, 34.665 11.967, 33.645 11.120 C 32.601 10.254, 32.014 10.283, 31.233 11.238 M 32.063 23.474 C 19.120 36.545, 18.766 37.015, 20.225 39.224 C 23.176 43.690, 24.949 42.712, 38.791 28.982 C 46.056 21.775, 52 15.301, 52 14.595 C 52 12.915, 48.748 10, 46.874 10 C 46.066 10, 39.401 16.063, 32.063 23.474 M 43.196 15.298 C 37.400 21.278, 40.114 24.247, 46.065 18.437 C 49.043 15.529, 49.693 14.335, 48.852 13.322 C 47.284 11.433, 46.767 11.614, 43.196 15.298 M 23 15.383 C 23 16.144, 22.055 17.014, 20.899 17.316 C 18.648 17.905, 19.163 20, 21.559 20 C 22.352 20, 23 20.648, 23 21.441 C 23 23.837, 25.095 24.352, 25.684 22.101 C 25.986 20.945, 26.856 20, 27.617 20 C 28.377 20, 29 19.325, 29 18.500 C 29 17.675, 28.325 17, 27.500 17 C 26.675 17, 26 16.325, 26 15.500 C 26 14.675, 25.325 14, 24.500 14 C 23.675 14, 23 14.623, 23 15.383 M 29.005 29.495 C 22.390 36.155, 21.728 37.156, 23.060 38.488 C 24.392 39.821, 25.432 39.109, 32.403 32.098 C 39.568 24.890, 41.075 22, 37.666 22 C 36.997 22, 33.100 25.373, 29.005 29.495 M 46 32 C 46 33.333, 45.333 34, 44 34 C 42.900 34, 42 34.450, 42 35 C 42 35.550, 42.900 36, 44 36 C 45.333 36, 46 36.667, 46 38 C 46 39.100, 46.450 40, 47 40 C 47.550 40, 48 39.283, 48 38.406 C 48 37.530, 48.900 36.577, 50 36.290 C 52.381 35.667, 52.677 34, 50.406 34 C 49.530 34, 48.577 33.100, 48.290 32 C 48.002 30.900, 47.369 30, 46.883 30 C 46.398 30, 46 30.900, 46 32",
                                                                stroke: "none",
                                                                fill: color,
                                                                fillRule: "evenodd"
                                                            })
                                                        }),
                                                        "Confidence level: ",
                                                        score
                                                    ]
                                                });
                                            })(),
                                            (()=>{
                                                const reportData = getSectionReport(section, false, null);
                                                const accuracyRating = reportData?.validation?.accuracyRating;
                                                const hasAccuracyRating = accuracyRating !== undefined && accuracyRating !== null && !Number.isNaN(Number(accuracyRating));
                                                return hasAccuracyRating ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcc",
                                                    style: {
                                                        padding: '4px 10px',
                                                        borderRadius: '10px',
                                                        fontWeight: '600',
                                                        fontSize: '0.75rem',
                                                        height: '24px',
                                                        lineHeight: '1',
                                                        background: accuracyRating >= 7 ? '#e8f5e9' : accuracyRating >= 5 ? '#fff3e0' : '#ffebee',
                                                        color: accuracyRating >= 7 ? '#1b5e20' : accuracyRating >= 5 ? '#e65100' : '#c62828',
                                                        border: `1px solid ${accuracyRating >= 7 ? '#c8e6c9' : accuracyRating >= 5 ? '#ffe0b2' : '#ffcdd2'}`
                                                    },
                                                    children: [
                                                        "Accuracy: ",
                                                        accuracyRating,
                                                        "/10"
                                                    ]
                                                }) : null;
                                            })()
                                        ]
                                    }),
                                    section['isPrompt'] ? (()=>{
                                        // Check if section has at least one file
                                        const hasFiles = (section.questions || []).some((q)=>(q.answer?.files || []).some((f)=>f && f.originator !== 'ai-report' && (f.location || f.url))) && section?.['stats']?.['completionPercent'] === 100;
                                        const currentKey = getReportGenerationKey(section, false);
                                        const isGenerating = reportGenerateLoading === currentKey;
                                        const isAnyGenerating = reportGenerateLoading !== null;
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic jcc",
                                            style: {
                                                gap: '0.5rem',
                                                flexWrap: 'wrap'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    type: "button",
                                                    disabled: isAnyGenerating || !hasFiles,
                                                    onClick: ()=>hasFiles ? generateInsuranceAiReport({
                                                            data: section,
                                                            isQuestion: false
                                                        }) : "",
                                                    style: {
                                                        height: '40px'
                                                    },
                                                    "data-tooltip": hasFiles ? "" : "Complete the 100% section to generate the report",
                                                    className: `fs14px px1rem br20px cp c1 py0-25rem ${hasFiles && !isAnyGenerating ? 'bg3 bg3-hover' : 'bg5 c15 op50'} `,
                                                    children: isGenerating ? "Generating..." : "Generate Report"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: hasSectionReport(section, false, null) ? `#${getSectionTabName(section, false, null)}` : "#repository",
                                                    onClick: (e)=>{
                                                        if (isAnyGenerating) {
                                                            e.preventDefault();
                                                            return;
                                                        }
                                                        handleSectionReportLinkClick(e, section, false, null);
                                                    },
                                                    className: `cp p1rem c1 ${hasSectionReport(section, false, null) && !isAnyGenerating ? 'bg3 bg3-hover' : 'bg5 c15 op50'} br50px fw400 fs14px zi0 td250 df aic jcc`,
                                                    style: {
                                                        width: '40px',
                                                        height: '40px',
                                                        pointerEvents: isAnyGenerating ? 'none' : 'auto',
                                                        cursor: isAnyGenerating ? 'not-allowed' : 'pointer'
                                                    },
                                                    children: "R"
                                                })
                                            ]
                                        });
                                    })() : null,
                                    !isTwoMinuteTesHomePage && (tab === 'repository' || tab?.includes('business-audit') || tab === 'warranty-disclosure' || tab?.includes('directors-questionnaire') || tab === 'Investment Readiness') && section?.stats?.completionPercent < 100 && qNo && !qNo.includes('.') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83364f35f447dab2$export$2e2bcd8739ae039), {
                                        companyId: companyId,
                                        moduleType: module.type,
                                        sectionCode: qNo,
                                        scope: "section",
                                        size: "small",
                                        onComplete: ()=>{
                                            reloadModule && reloadModule(tab);
                                        }
                                    })
                                ]
                            }),
                            module.type === "business-audit" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "toggleHeight cp",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "mb0-5rem td250 fs0-75rem pen bg5 c6 br5px fw600 px0-5rem py0-5rem",
                                        children: "Show Section"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "oh dg",
                                        style: {
                                            cursor: "auto",
                                            height: "0px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                            jsx
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dg",
                                children: jsx
                            })
                        ]
                    }, `${module.type}-${sectionId}-${qNo}-${sectionIdx}`);
                }),
                (user['role'] == 'Guest' || !user.firstName) && module['type'] == `two-minute-test-${company['testType']}` && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "maw400px mxa my2rem df jcc aic fdc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        btnType: "warning",
                        text: "Next",
                        disabled: module?.['stats']?.['completionPercent'] != 100,
                        customClassName: "df jcc aic",
                        onClick: ()=>openKPI()
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "td250 container bg1 py1rem w100 df",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w80 mr1rem dg gg1rem",
                        children: [
                            user?.role.toLowerCase() === "guest" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                wrapperClass: "tac",
                                heading: company?.modules[tab]?.heading,
                                subheading: company?.modules[tab]?.subheading,
                                paragraph: isTwoMinuteTesHomePage ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        "Register at the end of test to access more features ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs11px",
                                            children: "(No credit card required)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                            className: "c3"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                            }) : null,
                            tab !== 'investor-lead' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic jcsb btn-dataroom-saf pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            !isManualAdd && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                className: "list-file-manager",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 upload-file",
                                                        children: "Uploaded Directly"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 prepopulated-file",
                                                        children: "Companies House"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 filing-assistant-file",
                                                        children: "AI Filing Manager"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 ai-report-file",
                                                        children: "AI Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 sharepoint-file",
                                                        children: "Sharepoint"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 dropbox-file",
                                                        children: "Dropbox"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 gdrive-file",
                                                        children: "Drive"
                                                    })
                                                ]
                                            }),
                                            isManualAdd && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "c15 fs1-5rem tac fw500 pb1rem",
                                                children: "Key Applicant Information"
                                            }),
                                            isTwoMinuteTesHomePage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic mt0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    disabled: true,
                                                    "data-tooltip": "Connect Data room feature is disabled. You must register to access it.",
                                                    className: "op50 cp bg1 c3 bw1px bo3 bss br50px fs0-75rem fw600 px0-75rem py0-5rem df jcc aic mr1rem",
                                                    children: [
                                                        "Connect",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "df ml0-5rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                    className: "pen fds w1rem ml0-5rem"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                    className: "pen fds w1rem ml0-5rem"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                    className: "pen fds w1rem ml0-5rem"
                                                                })
                                                            ]
                                                        }),
                                                        "\xa0\xa0\xa0"
                                                    ]
                                                })
                                            }),
                                            !isTwoMinuteTesHomePage && company.modules?.[tab] && tab === "repository" && (()=>{
                                                const [syncLink, driveName] = company.gDriveLink ? [
                                                    company.gDriveLink,
                                                    "Google Drive"
                                                ] : company.sharePointLink ? [
                                                    company.sharePointLink,
                                                    "SharePoint"
                                                ] : company.dropBoxLink ? [
                                                    company.dropBoxLink,
                                                    "DropBox"
                                                ] : [
                                                    undefined,
                                                    "Not Connected"
                                                ];
                                                let syncRequired = false;
                                                const allFiles = [];
                                                const sections = company?.modules?.[tab]?.sections ?? [];
                                                for (const sec of sections){
                                                    const questions = sec?.questions ?? [];
                                                    for (const ques of questions){
                                                        const files = ques?.answer?.files ?? [];
                                                        if (files.length > 0) allFiles.push(...files);
                                                    }
                                                }
                                                if (company.dropBoxFolderMetadata) syncRequired = allFiles.some((file)=>!file?.dbFileMetadata);
                                                if (company.sharePointLink) syncRequired = allFiles.some((file)=>!file?.spDriveItem);
                                                let disableSyncButton = !syncRequired;
                                                const isMember = company['members']?.some((member)=>member._id === user._id) || company?.['advisors']?.[user._id];
                                                const hasAllPermissions = company ? (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['memberPermissions']?.[user._id]) || (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['advisors']?.[user._id]?.['modules']) : false;
                                                const isInvestorOwner = company?.['investors'] && Object.keys(company['investors']).length > 0 && company['investors'][user._id] && (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['investors']?.[user._id]?.['modules']);
                                                const hasPermission = !company?.isParent && company['owners'][0] === user._id || company?.isParent && company['owners'][0] === user._id || (company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id || isMember && hasAllPermissions || isInvestorOwner;
                                                if (!hasPermission) return null;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic mt0-5rem",
                                                    children: [
                                                        syncLink == undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: 'connectDataroom'
                                                                })),
                                                            className: `${!company['uploadedFile'] && 'op20 pen '} cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem mr0-5rem df jcc aic`,
                                                            children: [
                                                                "Connect",
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "df ml0-5rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                            className: "pen fds w1rem ml0-5rem"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                            className: "pen fds w1rem ml0-5rem"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                            className: "pen fds w1rem ml0-5rem"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        syncLink !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr menuHover mr0-5rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    className: "cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem df jcc aic",
                                                                    children: [
                                                                        company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                            className: "pen fds w1rem mr0-5rem"
                                                                        }),
                                                                        company.dropBoxLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                            className: "pen fds w1rem mr0-5rem"
                                                                        }),
                                                                        company.sharePointLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                            className: "pen fds w1rem mr0-5rem"
                                                                        }),
                                                                        "Data Room",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "ml0-5rem c3",
                                                                            children: "\u25BE"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "menu op0 pen zi10 bg1 br10px shadow pa l0 df fdc",
                                                                    style: {
                                                                        minWidth: '230px'
                                                                    },
                                                                    children: [
                                                                        company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                            children: [
                                                                                company['folderId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                                                                    style: {
                                                                                        borderTopLeftRadius: '10px',
                                                                                        borderTopRightRadius: '10px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing,
                                                                                        onClick: ()=>openWindow(`https://drive.google.com/drive/folders/${company['folderId']}`),
                                                                                        class: `cp df aic ${syncing && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "df",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                                                    className: "pen fds w1rem mr0-5rem"
                                                                                                })
                                                                                            }),
                                                                                            "View Data Room"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing,
                                                                                        onClick: ()=>syncDrive(),
                                                                                        class: `cp df aic ${syncing && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                class: "mr0-5rem",
                                                                                                src: (parcelRequire("1Ar70")),
                                                                                                alt: "sync-data-room"
                                                                                            }),
                                                                                            "Sync Data Room"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                                                                    style: {
                                                                                        borderBottomLeftRadius: '10px',
                                                                                        borderBottomRightRadius: '10px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing,
                                                                                        onClick: ()=>handleDisconnectDataRoom("gdrive"),
                                                                                        class: `cp df aic ${syncing && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                class: "fa fa-unlink c4 mr0-5rem"
                                                                                            }),
                                                                                            "Disconnect"
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        company.dropBoxLink && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                            children: [
                                                                                company['dropBoxFolderMetadata'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                                                                    style: {
                                                                                        borderTopLeftRadius: '10px',
                                                                                        borderTopRightRadius: '10px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing,
                                                                                        onClick: ()=>openWindow(`https://dropbox.com/home/${company['dropBoxFolderMetadata']['path_display']}`),
                                                                                        class: `cp df aic ${syncing && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "df",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                                                    className: "pen fds w1rem mr0-5rem"
                                                                                                })
                                                                                            }),
                                                                                            "View Data Room"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `${company['syncRequired'] || syncRequired ? 'op100' : 'op60'} cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing || disableSyncButton,
                                                                                        onClick: ()=>syncDropbox(),
                                                                                        class: `${company['syncRequired'] || syncRequired ? 'op100' : 'op60'} cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                class: "mr0-5rem",
                                                                                                src: (parcelRequire("1Ar70")),
                                                                                                alt: "sync-data-room"
                                                                                            }),
                                                                                            "Sync Data Room"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company['syncRequired'] || syncRequired) && 'op60 cnd'}`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        onClick: ()=>reverseSyncDropbox(),
                                                                                        class: `cp df aic ${(syncing || company['syncRequired'] || syncRequired) && ''}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                class: "mr0-5rem",
                                                                                                src: (parcelRequire("1Ar70")),
                                                                                                alt: "sync-data-room"
                                                                                            }),
                                                                                            "Reverse Sync"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                                                                    style: {
                                                                                        borderBottomLeftRadius: '10px',
                                                                                        borderBottomRightRadius: '10px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing,
                                                                                        onClick: ()=>handleDisconnectDataRoom("dropbox"),
                                                                                        class: `cp df aic ${syncing && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                class: "fa fa-unlink c4 mr0-5rem"
                                                                                            }),
                                                                                            "Disconnect"
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        company.sharePointLink && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                            children: [
                                                                                company['sharePointFolderDriveItem']?.['rootFolder']?.['webUrl'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                                                                    style: {
                                                                                        borderTopLeftRadius: '10px',
                                                                                        borderTopRightRadius: '10px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing,
                                                                                        onClick: ()=>openWindow(`${company['sharePointFolderDriveItem']['rootFolder']['webUrl']}`),
                                                                                        class: `cp df aic ${syncing && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "df",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                                                    className: "pen fds w1rem mr0-5rem"
                                                                                                })
                                                                                            }),
                                                                                            "View Data Room"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing || disableSyncButton,
                                                                                        onClick: ()=>syncSharePoint(),
                                                                                        class: `cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                class: "mr0-5rem",
                                                                                                src: (parcelRequire("1Ar70")),
                                                                                                alt: "sync-data-room"
                                                                                            }),
                                                                                            "Sync Data Room"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company['syncRequired'] || syncRequired) && 'op60 cnd'}`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing || company['syncRequired'] || syncRequired,
                                                                                        onClick: ()=>reSyncSharePoint(),
                                                                                        class: `cp df aic ${(syncing || company['syncRequired'] || syncRequired) && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                class: "mr0-5rem",
                                                                                                src: (parcelRequire("1Ar70")),
                                                                                                alt: "sync-data-room"
                                                                                            }),
                                                                                            "Reverse Sync"
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                                                                    style: {
                                                                                        borderBottomLeftRadius: '10px',
                                                                                        borderBottomRightRadius: '10px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                        disabled: syncing,
                                                                                        onClick: ()=>handleDisconnectDataRoom("sharepoint"),
                                                                                        class: `cp df aic ${syncing && 'op60 cnd'}`,
                                                                                        style: {
                                                                                            background: 'transparent'
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                class: "fa fa-unlink c4 mr0-5rem"
                                                                                            }),
                                                                                            "Disconnect"
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                            })()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            isTwoMinuteTesHomePage && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                "data-tooltip": "Filing Assistant feature is disabled. You must register to access it.",
                                                className: "cp op50 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem fw600 df jcc aic fs0-75rem pr",
                                                disabled: true,
                                                children: [
                                                    "Filing Assistant",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                        style: {
                                                            color: "#4A67FF",
                                                            marginLeft: "8px",
                                                            fontSize: '12px'
                                                        }
                                                    })
                                                ]
                                            }),
                                            tab === "kitemark" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                                        children: "Kitemark Audit"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                                        children: "Kitemark Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                                        children: "Digital Certificate"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                                        children: "Full Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                                        children: "Report by Section"
                                                    })
                                                ]
                                            }) : !isTwoMinuteTesHomePage && company.modules?.[tab] && tab === "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86bb04e68ae2fbe5$export$2e2bcd8739ae039), {
                                                        companyId: companyId,
                                                        moduleType: tab,
                                                        moduleId: null,
                                                        tab: tab,
                                                        activeModule: company?.modules?.[tab],
                                                        onComplete: ()=>reloadModule && reloadModule(tab, true)
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr menuHover ml0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: (parcelRequire("bx0Zp")),
                                                                alt: "filing-assistant-hover",
                                                                className: "menu op0 pen pa td250",
                                                                style: {
                                                                    bottom: '36px',
                                                                    zIndex: 100
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                className: "cp fs13px fw600 bg1 bg3-hover c3 c1-hover bw1px bo3 bss br50px px1rem py0-5rem df jcc aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: (parcelRequire("6zDJh")),
                                                                        alt: "filing-assistant-icon",
                                                                        className: "mr0-5rem"
                                                                    }),
                                                                    "Filing Manager"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "menu op0 pen zi10 bg1 br10px shadow pa r0 df fdc",
                                                                style: {
                                                                    minWidth: '260px'
                                                                },
                                                                children: [
                                                                    (0, $6a6b4b5ab5be324d$export$2908142509316f06) && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        onClick: ()=>{
                                                                            const isAutoFillActive = [
                                                                                'uploading',
                                                                                'indexing',
                                                                                'allocated',
                                                                                'filling'
                                                                            ].includes(modal.autoFillStatusBarPhase);
                                                                            if (isAutoFillActive) {
                                                                                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auto-fill is already running. Please wait for it to complete.');
                                                                                return;
                                                                            }
                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                open: 'autoFillStepper',
                                                                                autoFillStepperPhase: 'intro',
                                                                                autoFillModuleName: company?.modules?.[tab]?.heading || tab || '',
                                                                                autoFillStatusBarPhase: 'select',
                                                                                autoFillWithFilling: true,
                                                                                autoFillUploadMode: 'files'
                                                                            }));
                                                                            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                                                                                autoFillContext: {
                                                                                    enabled: true,
                                                                                    companyId: companyId,
                                                                                    moduleType: tab,
                                                                                    moduleId: null,
                                                                                    scope: 'module',
                                                                                    scopeName: company?.modules?.[tab]?.heading || tab
                                                                                },
                                                                                tab: tab
                                                                            }));
                                                                        },
                                                                        className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                                                                        style: {
                                                                            borderTopLeftRadius: '10px',
                                                                            borderTopRightRadius: '10px'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                class: "df aic",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                        width: "14",
                                                                                        height: "14",
                                                                                        viewBox: "0 0 14 14",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                                "clip-path": "url(#clip0_1353_49132)",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M3.52723 2.82108L4.74129 3.48554C4.89715 3.5703 4.95458 3.76444 4.86981 3.9203C4.83973 3.97499 4.79598 4.01874 4.74129 4.04882L3.52723 4.71054C3.47254 4.74061 3.42879 4.78436 3.39872 4.83905L2.73426 6.05311C2.6495 6.20897 2.45536 6.2664 2.2995 6.18163C2.24481 6.15155 2.20106 6.1078 2.17098 6.05311L1.50926 4.83905C1.47919 4.78436 1.43544 4.74061 1.38075 4.71054L0.166686 4.04882C0.0108263 3.96405 -0.0465956 3.76991 0.03817 3.61405C0.0682482 3.55936 0.111998 3.51561 0.166686 3.48554L1.38075 2.82108C1.43544 2.791 1.47919 2.74725 1.50926 2.69257L2.17372 1.48124C2.25848 1.32538 2.45536 1.26796 2.61122 1.35546C2.66317 1.38554 2.70692 1.42929 2.737 1.48124L3.40145 2.69257C3.42879 2.74725 3.47254 2.791 3.52723 2.82108Z",
                                                                                                        fill: "#4A67FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M12.5643 9.30204L13.7784 9.96649C13.9343 10.0513 13.9917 10.2454 13.9069 10.4013C13.8768 10.4559 13.8331 10.4997 13.7784 10.5298L12.5643 11.1942C12.5097 11.2243 12.4659 11.2681 12.4358 11.3227L11.7714 12.5368C11.6866 12.6927 11.4897 12.7501 11.3339 12.6653C11.2792 12.6352 11.2354 12.5915 11.2054 12.5368L10.5464 11.32C10.5163 11.2653 10.4725 11.2216 10.4179 11.1915L9.2038 10.527C9.04794 10.4423 8.99051 10.2454 9.07528 10.0895C9.10536 10.0348 9.14911 9.9911 9.2038 9.96102L10.4179 9.29657C10.4725 9.26649 10.5163 9.22274 10.5464 9.16805L11.2108 7.95672C11.2956 7.80087 11.4925 7.74344 11.6483 7.82821C11.703 7.85829 11.7468 7.90204 11.7768 7.95672L12.4413 9.17079C12.4659 9.22821 12.5097 9.27196 12.5643 9.30204Z",
                                                                                                        fill: "#4A67FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M7.30855 1.43355L8.10425 1.86831C8.20542 1.92573 8.2437 2.05425 8.18901 2.15542C8.16987 2.19097 8.1398 2.21831 8.10425 2.24019L7.30855 2.67495C7.273 2.69409 7.24292 2.72417 7.22378 2.75972L6.78902 3.55542C6.73159 3.65659 6.60308 3.69487 6.50191 3.64019C6.46636 3.62105 6.43901 3.59097 6.41714 3.55542L5.98237 2.75972C5.96323 2.72417 5.93316 2.69409 5.89761 2.67495L5.10191 2.24019C5.00073 2.1855 4.96245 2.05698 5.01714 1.95308C5.03628 1.91753 5.06636 1.88745 5.10191 1.86831L5.89761 1.43355C5.93316 1.41441 5.96323 1.38433 5.98237 1.34878L6.41714 0.553078C6.47456 0.451906 6.60308 0.413624 6.70425 0.468312C6.7398 0.487453 6.76714 0.517531 6.78902 0.553078L7.22378 1.34878C7.24292 1.38433 7.273 1.41441 7.30855 1.43355Z",
                                                                                                        fill: "#4A67FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M13.6881 1.79629L12.5643 0.672464C12.1487 0.256839 11.4733 0.254105 11.0549 0.66973C11.0549 0.66973 11.0549 0.66973 11.0522 0.672464L1.03345 10.6939C0.617823 11.1096 0.615089 11.785 1.03345 12.2033L2.15728 13.3272C2.5729 13.7428 3.24829 13.7455 3.66665 13.3272L13.6881 3.30567C14.1038 2.89004 14.1038 2.21465 13.6881 1.79629ZM9.78071 5.58614L8.77446 4.57989L11.7413 1.61036L12.7475 2.61661L9.78071 5.58614Z",
                                                                                                        fill: "#4A67FF"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                    id: "clip0_1353_49132",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                        width: "14",
                                                                                                        height: "14",
                                                                                                        fill: "white"
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        class: "c3 ml0-5rem",
                                                                                        children: [
                                                                                            "Auto Fill",
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                class: "fs10px c12 ml0-5rem",
                                                                                                children: "All Questions"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        onClick: onAccurateFileName,
                                                                        className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                                                                        children: [
                                                                            "Import Files ",
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        onClick: onAccurateFolderName,
                                                                        className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                                                                        children: [
                                                                            "Import Folders ",
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    }),
                                                                    company['subscription'] && company['subscription'].toLowerCase() === "pro" && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        onClick: ()=>onFaInfo('filing-assistant'),
                                                                        className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                                                                        children: [
                                                                            "Filing Assistant History ",
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        onClick: ()=>onFaInfo('deduper'),
                                                                        className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                                                                        children: [
                                                                            "Deduper ",
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        onClick: ()=>onFaInfo('deduper-reports'),
                                                                        className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                                                                        style: {
                                                                            borderBottomLeftRadius: '10px',
                                                                            borderBottomRightRadius: '10px'
                                                                        },
                                                                        children: [
                                                                            "Deduper Reports ",
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "w100 c14 fs13px fw400 px1rem py0-5rem cna op50 df aic jcsb",
                                                                        children: [
                                                                            "Audit Log ",
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "w100 c14 fs13px fw400 px1rem py0-5rem cna op50 df aic jcsb",
                                                                        children: [
                                                                            "Roll Back ",
                                                                            $866b869d60dd72c1$var$questionMarkSvg
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            tab !== 'investor-lead' && tab === "repository" && (!company?.isParent && company['owners'][0] === user._id || company?.isParent && company['owners'][0] === user._id || (company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "dg gtcr2-md gg0-5rem",
                                    children: company['lastSyncBy'] && company.modules?.[tab]?.uploadFiles && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic fs14px c15",
                                        children: [
                                            company['syncRequired'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "* Sync is Required -  "
                                            }),
                                            "Last synced by - ",
                                            company?.['lastSyncBy']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: `ass mx0-5rem br100 w2rem h2rem`,
                                                src: company?.['lastSyncBy']?.['profile']
                                            }),
                                            " ",
                                            company?.['lastSyncBy']?.['firstName'],
                                            ",",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['lastSyned']).format('lll')
                                        ]
                                    })
                                })
                            }),
                            company?.modules[tab] && getSectionHTML(company.modules[tab]),
                            isManualAdd && tab == 'investor-lead' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "df jcc mt1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>company?.['modules']?.[tab]?.['stats']?.['completionPercent'] && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'addingApplicantManual'
                                        })),
                                    "data-tooltip": company?.['modules']?.[tab]?.['stats']?.['completionPercent'] < 99 ? 'Please complete the questionnaire' : '',
                                    disabled: company?.['modules']?.[tab]?.['stats']?.['completionPercent'] < 99,
                                    className: `c1 br20px px4rem py0-5rem mb1rem fw500 tac ${company?.['modules']?.[tab]?.['stats']?.['completionPercent'] < 99 ? 'cna bg16' : 'cp bg4'}`,
                                    children: "Next"
                                })
                            }),
                            tab == 'repository' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "py2rem df jcc gg1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        className: `${company?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`,
                                        onClick: (e)=>toggleReport(e),
                                        children: [
                                            tab.endsWith("-report") ? "Close" : "View",
                                            ' Report'
                                        ]
                                    })
                                })
                            }),
                            tab == 'business-audit' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "py2rem df jcc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>enableAIEnhancedReporting(),
                                    className: `${company?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} h100 mt0-5rem mxa shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen fds h1rem f1 mr0-5rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 448 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                                })
                                            ]
                                        }),
                                        "AI Enhanced Report"
                                    ]
                                })
                            }),
                            (tab == 'warranty-disclosure' || tab == 'software-development') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "py3rem df jcc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    className: `${company?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`,
                                    onClick: ()=>toggleReport(),
                                    children: [
                                        tab.endsWith("-report") ? "Close" : "View",
                                        tab == 'warranty-disclosure' ? ' Disclosure Schedule' : ' Report'
                                    ]
                                })
                            })
                        ]
                    }),
                    company?.modules[tab] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $73a5f3cb80d8115d$export$2e2bcd8739ae039), {
                        isManualAdd: isManualAdd,
                        setIsWorkflowReport: setIsWorkflowReport,
                        visibleSection: visibleSection,
                        setTab: setTab,
                        profileClass: profileClass,
                        advisors: advisors,
                        permissionLevel: permissionLevel,
                        company: company,
                        setCompany: setCompany,
                        tab: tab,
                        sanitiseTab: sanitiseTab,
                        toggleReport: toggleReport,
                        openKPI: openKPI,
                        calculateStats: calculateStats,
                        calculateSubFolderStats: calculateSubFolderStats,
                        getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                        setSection: setSection,
                        getViewableURL: getViewableURL,
                        twoMinuteTestAIReport: twoMinuteTestAIReport,
                        isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                        getFitInvestorFirms: getFitInvestorFirms,
                        setOpenTabs: setOpenTabs,
                        openTabs: openTabs,
                        sortSections: sortSections,
                        handleSuperflowNext: handleSuperflowNext,
                        setCompanyDashboardTab: setCompanyDashboardTab,
                        setTabName: setTabName,
                        closeTab: closeTab,
                        isBackFitReport: isBackFitReport,
                        setIsBackFitReport: setIsBackFitReport,
                        isLoader: isLoader,
                        setIsLoader: setIsLoader,
                        isExternalPage: false
                    })
                ]
            }),
            reportGenerateLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc aic pf l0 b0 bg1 p2rem br20px shadow",
                style: {
                    maxWidth: '450px',
                    margin: '0 auto 0 90px',
                    zIndex: '1000'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "loading-report-generate",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcc ",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    width: 50,
                                    className: "mr1-5rem",
                                    src: (parcelRequire("bwNCH")),
                                    alt: "loading-report-left"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    width: 50,
                                    className: "mr1rem infinite-rotate",
                                    src: (parcelRequire("l0lQ0")),
                                    alt: "loading-report-center"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    width: 50,
                                    src: (parcelRequire("4MwVZ")),
                                    alt: "loading-report-right"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs14px fw400 c37 tac mt1rem",
                            children: "Report being generated - please continue other tasks - we will let you know when report complete"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f5e4159f4b2fdb7$export$2e2bcd8739ae039), {
                modalType: 'fileReportHistory',
                reportHistories: reportHistories,
                setReportHistories: setReportHistories,
                setFileReport: setFileReport,
                setCloneImportResult: setCloneImportResult,
                setCurrentScore: setCurrentScore,
                company: company,
                profileClass: profileClass,
                onRollbackComplete: ()=>reloadModule && reloadModule(tab),
                moduleType: tab,
                moduleName: company?.modules?.[tab]?.heading || tab
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c13dd2b2ad7b7b79$export$2e2bcd8739ae039), {
                tab: tab,
                modalType: 'disconnectDataRoom',
                companyId: company['_id']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40a2fdbd500b75ca$export$2e2bcd8739ae039), {
                modalType: 'unallocatedFiles',
                tab: tab,
                loading: loading,
                setLoading: setLoading,
                company: company,
                setUnallocatedFiles: (0, $e0a7c253e2df808f$export$7f5872b9f0fc6312),
                onClickUnallocatedBinAuditLog: onClickUnallocatedBinAuditLog,
                unallocatedFiles: unallocatedFiles,
                handleEditDispatch: handleEditDispatch,
                moveUnallocatedFile: moveUnallocatedFile,
                setDeleteUnallocatedFile: setDeleteUnallocatedFile,
                targetSection: targetSection
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1047f7c995c3f14f$export$2e2bcd8739ae039), {
                modalType: 'manageFiles',
                reloadModule: reloadModule,
                section: section,
                setSection: setSection,
                company: company,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                setDeleteFileQuestionId: setDeleteFileQuestionId,
                setDeleteFile: setDeleteFile,
                tab: tab,
                targetSection: targetSection
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $003a88e0f3de542d$export$2e2bcd8739ae039), {
                modalType: 'manageWarrantyDisclosureFiles',
                reloadModule: reloadModule,
                section: section,
                setSection: setSection,
                company: company,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                setDeleteFileQuestionId: setDeleteFileQuestionId,
                setDeleteFile: setDeleteFile,
                tab: tab,
                targetSection: targetSection
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436c32be0a88c5ca$export$2e2bcd8739ae039), {
                modalType: 'checkingDuplication',
                company: company,
                onClickDeduperAuditLog: onClickDeduperAuditLog
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e893be82a1a3691c$export$2e2bcd8739ae039), {
                modalType: 'duplicationCheckSummary',
                company: company,
                dupCheck: dupCheck,
                modal: modal,
                profileClass: profileClass,
                onClickDeduperAuditLog: onClickDeduperAuditLog,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                setRefresh: setRefresh,
                reloadModule: reloadModule,
                moveDeduperFile: moveDeduperFile,
                tab: tab
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8992acb1fe6a84ae$export$2e2bcd8739ae039), {
                company: company
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20694e2bf2131bd3$export$2e2bcd8739ae039), {
                onEdit: onEdit,
                onDelete: onDelete,
                modalType: 'proaddsection',
                editSectionName: editSectionName,
                additionalSections: additionalSections,
                isSectionNameDuplicate: isSectionNameDuplicate,
                onSaveAdditionalSections: onSaveAdditionalSections
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed66be3561152e3$export$2e2bcd8739ae039), {
                modalType: "deleteFile",
                deleteFile: deleteFile,
                onConfirm: ()=>confirmDeleteFile(modal['from']),
                onCancel: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: modal['from']
                    }))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed66be3561152e3$export$2e2bcd8739ae039), {
                modalType: "deleteUnallocatedFile",
                deleteFile: deleteUnallocatedFile?.file ?? {},
                onConfirm: confirmDeleteUnallocatedFile,
                onCancel: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'unallocatedFiles'
                    }))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4f591bf66fcd73d$export$2e2bcd8739ae039), {
                onAction: (key)=>{
                    if (key === 'unallocated-bin') onClickViewUnallocatedFiles();
                    if (key === 'filing-assistant') onClickFileReportHistory();
                    if (key === 'deduper') checkDuplicatedFiles();
                    if (key === 'deduper-reports') onClickDeduperReportHistory();
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4def4a546b6daa3e$export$2e2bcd8739ae039), {
                getViewableURL: getViewableURL,
                profileClass: profileClass,
                modalType: "auditLog",
                logList: logList,
                logModule: logModule,
                tab: tab
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deduperReportAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'duplicationCheckSummary'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttc c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'duplicationCheckSummary'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttc w100 tac mb1rem",
                            children: "See the history of Company Deduper Report"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getDeduperReportLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttc w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'duplicationCheckSummary'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'unallocatedBinAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'unallocatedFiles'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttc c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'unallocatedFiles'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttc w100 tac mb1rem",
                            children: "See the history of Company Unallocated Bin"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getUnallocatedBinLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttc w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'unallocatedFiles'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'fileReportAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'importSummary'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttc c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'importSummary'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttc w100 tac mb1rem",
                            children: "See the history of Company File Import"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getFileReportLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttc w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'importSummary'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2b7abf4967ef3ad$export$2e2bcd8739ae039), {
                modalType: 'dataRepository',
                dispatch: dispatch,
                company: company,
                user: user
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'repositoryCompleted',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 pb1rem",
                            children: "Congratulations!"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac df fdc jcc aic tac",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "Hello, ",
                                        user.firstName,
                                        "! \uD83C\uDF89"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Look at you, unstoppable force! \uD83D\uDE80 You've made your first pass at filling your Data Repository and have emerged victorious! Now, it's time to step into your next adventure:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Unleash the magic of connectivity! Sync your Repository with your preferred provider Data Room. This will create an unbreakable bond between your treasures, keeping them safe and accessible anytime, anywhere. \uD83C\uDF10"
                                }),
                                company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    className: "shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                    onClick: ()=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                        syncDrive();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                            className: "pen fds w2rem mr1rem"
                                        }),
                                        "\uD83D\uDC49 Sync Now"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Excited to see the fruits of your labor? View your Repository Report and bask in the glory of your progress. Every detail counts in this journey, and you've made a remarkable headway! \uD83D\uDCC8"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: (e)=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                        toggleReport(e);
                                    },
                                    className: "shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                    children: "\uD83D\uDC49 View Report"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Feeling ready for the next level? It's time to take on the Quick Business Audit questionnaire! Upon its completion, Diligentsia\u2019s unaudited certification awaits. This prized possession will symbolize your company's readiness for any challenge ahead. \uD83D\uDCBC"
                                }),
                                (()=>{
                                    const [syncLink, driveName] = company.gDriveLink ? [
                                        company.gDriveLink,
                                        "Google Drive"
                                    ] : company.sharePointLink ? [
                                        company.sharePointLink,
                                        "SharePoint"
                                    ] : company.dropBoxLink ? [
                                        company.dropBoxLink,
                                        "DropBox"
                                    ] : [
                                        undefined,
                                        "Not Connected"
                                    ];
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df my1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: `${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`,
                                                        onClick: ()=>syncDrive(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 Sync Data room"
                                                        ]
                                                    }),
                                                    company['folderId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100",
                                                        onClick: ()=>openWindow(`https://drive.google.com/drive/folders/${company['folderId']}`),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 View Data Room"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            company.dropBoxLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df my1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: `${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`,
                                                        onClick: ()=>syncDropbox(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 Sync Data room"
                                                        ]
                                                    }),
                                                    company['dropBoxFolderMetadata'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100",
                                                        onClick: ()=>openWindow(`https://dropbox.com/home/${company['dropBoxFolderMetadata']['path_display']}`),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 View Data Room"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            company.sharePointLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df my1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: `${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`,
                                                        onClick: ()=>syncSharePoint(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 Sync Data room"
                                                        ]
                                                    }),
                                                    company['sharePointLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100",
                                                        onClick: ()=>openWindow(`${company['sharePointFolderDriveItem']['rootFolder']['webUrl']}`),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 View Data Room"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            syncLink == undefined && tab == 'repository' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: 'connectDataroom'
                                                    })),
                                                className: `${!company['uploadedFile'] && 'op20 pen '} my1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`,
                                                children: "Connect Data Room"
                                            })
                                        ]
                                    });
                                })(),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "Remember, every adventure you undertake strengthens your fortress, builds your credibility, and takes your business one step closer to greatness. Keep conquering, ",
                                        user['firstName'],
                                        "! \uD83D\uDC4D"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'createdDataRoom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb0-5rem",
                                children: [
                                    "Good news!  Your Cloud Data",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Room has now been created.",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "You can now sync.\u200B"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttc bsbb df jcc",
                                onClick: ()=>{
                                    window.location.href = `/company/${companyId}#repository`;
                                },
                                children: "Let\u2019s go!\u200B"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "addingApplicantManual",
                open: modal['open'] == 'addingApplicantManual',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w100 df fdc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "my1rem",
                                        src: (parcelRequire("iGe5G")),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "c15 fs1-25rem fw500 my1rem",
                                        children: "Thank you for adding this applicant"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "c15 fs1rem fw300",
                                        children: "Your new applicant has been added and is ready for review."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "c15 fs1rem fw300",
                                        children: "Return to InvestorMatch to see the company and its newly generated reports."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df jcc my3rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/investor-dashboard#index?QualifiedLeads",
                                    onClick: ()=>localStorage.removeItem('isManualAdd'),
                                    className: "df jcc cp px3rem py0-5rem c1 bg4 bg3-hover br35px fw400 fs1rem",
                                    children: "Return to InvestorMatch"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9689410d708ead36$export$2e2bcd8739ae039), {
                modalType: 'DisclaimerAIReportModal',
                handleClose: handleAiReportDisclaimerClose,
                subTitle: "This report is for guidance only.",
                content: "This Report has been prepared by Diligensia for the exclusive use of the named client. It is based on information provided as at the date of issue and is intended solely to assist in identifying risks and opportunities. This report was generated by AI and may be inaccurate.  You are urged to check all report content. Diligentsia accepts no responsibility or liability for any errors, omissions, or delays, nor for any actions taken in reliance on this report. The contents do not constitute legal or financial advice, and professional advice should always be sought. This report may not be relied upon by any third party to whom the report is shown and Diligensia accepts no duty of care or liability to any third party who may obtain access to it."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'successAiReportGenerated',
                customStyle: {
                    padding: '0px 0rem 2rem',
                    maxWidth: '500px !important'
                },
                onCloseHandler: ()=>handleToggleSuccessAiReportGeneratedModal(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "c15 tal mt3rem",
                                children: "AI report is ready."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c15 tal fs0-875rem my1rem",
                                style: {
                                    lineHeight: '1.5',
                                    color: '#505050'
                                },
                                children: "We\u2019ve compiled your latest AI report. Review the insights now or come back whenever it suits you\u2014your report will be waiting."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc gg1rem fdcb-sm",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '250px'
                                        },
                                        customClassName: "mt1rem bg2",
                                        text: 'Go to Report',
                                        onClick: ()=>handleToggleSuccessAiReportGeneratedModal(true),
                                        btnType: "warning"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '250px'
                                        },
                                        customClassName: "mt1rem bg5 c15",
                                        text: 'Thanks, I will look later',
                                        onClick: ()=>handleToggleSuccessAiReportGeneratedModal(false),
                                        btnType: "primary"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


















































































































































































































































































function $b425c760e007b312$export$2e2bcd8739ae039({}) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [selectedFeature, setSelectedFeature] = (0, $acw62.useState)({});
    let [selectedHowItWorks, setSelectedHowItWorks] = (0, $acw62.useState)({});
    let [expanded, setExpanded] = (0, $acw62.useState)({
        investmentPanel: false,
        growthPanel: false,
        exitPanel: false
    });
    let [isShowTooltip, setIsShowTooltip] = (0, $acw62.useState)({
        seeMoreTooltip: true,
        howToTooltip: true,
        helpTooltip: true,
        reportTooltip: true,
        workflowReportTooltip: true
    });
    // Free Tools array
    const FREE_TOOLS = {
        subHeading: 'building your business stronger',
        subTiltle: 'For Advisors',
        titleOne: "For You",
        titleTwo: "For Your Clients",
        portfolioProAdvisor: [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE Diligentsia ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Portfolio Pro Dashboard"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Monitor all your clients from one dashboard"
                }),
                isLorem: false,
                isNil: false,
                isLock: false,
                showSeeMoreTooltip: true,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "71",
                        height: "73",
                        viewBox: "0 0 71 73",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M48.7647 16.1159C49.3097 16.1159 49.7537 16.5598 49.7537 17.1056C49.7537 17.6503 49.3099 18.0943 48.7647 18.0943C48.2196 18.0943 47.7765 17.6503 47.7765 17.1056C47.7765 16.5598 48.2197 16.1159 48.7647 16.1159ZM48.7647 20.3864C50.5746 20.3864 52.0455 18.9135 52.0455 17.1056C52.0455 15.2962 50.5746 13.8235 48.7647 13.8235C46.9557 13.8235 45.4847 15.2962 45.4847 17.1056C45.4847 18.9135 46.9557 20.3864 48.7647 20.3864ZM38.7742 16.1159C39.32 16.1159 39.7624 16.5598 39.7624 17.1056C39.7624 17.6503 39.32 18.0943 38.7742 18.0943C38.2284 18.0943 37.7851 17.6503 37.7851 17.1056C37.7851 16.5598 38.2284 16.1159 38.7742 16.1159ZM38.7742 20.3864C40.5832 20.3864 42.055 18.9135 42.055 17.1056C42.055 15.2962 40.5832 13.8235 38.7742 13.8235C36.9651 13.8235 35.4934 15.2962 35.4934 17.1056C35.4934 18.9135 36.9653 20.3864 38.7742 20.3864ZM28.783 16.1159C29.3288 16.1159 29.772 16.5598 29.772 17.1056C29.772 17.6503 29.3288 18.0943 28.783 18.0943C28.2387 18.0943 27.7948 17.6503 27.7948 17.1056C27.7948 16.5598 28.2387 16.1159 28.783 16.1159ZM28.783 20.3864C30.5929 20.3864 32.0638 18.9135 32.0638 17.1056C32.0638 15.2962 30.5929 13.8235 28.783 13.8235C26.9739 13.8235 25.5021 15.2962 25.5021 17.1056C25.5021 18.9135 26.9739 20.3864 28.783 20.3864ZM19.805 9.17313V25.0366C19.805 28.211 22.3863 30.8629 25.5596 30.9472C26.1814 30.963 26.6764 31.4716 26.6764 32.0919V39.1405L34.5319 31.2838C34.747 31.069 35.0397 30.9487 35.343 30.9487H51.8312C55.091 30.9487 57.7435 28.2967 57.7435 25.0364V9.17313C57.7435 5.91256 55.091 3.26104 51.8312 3.26104H25.7173C22.4567 3.26104 19.805 5.91256 19.805 9.17313ZM24.3838 33.1308V41.9085C24.3838 42.9276 25.622 43.4382 26.3408 42.7191L35.8169 33.241H51.8312C56.3549 33.241 60.0353 29.5609 60.0353 25.0366V9.17313C60.0353 4.6493 56.3549 0.96875 51.8312 0.96875H25.7173C21.1934 0.96875 17.5132 4.6493 17.5132 9.17313V25.0366C17.5132 29.0638 20.5054 32.4832 24.3838 33.1308ZM65.8991 53.0083C65.8529 53.0468 65.8157 53.0723 65.7656 53.1069L41.1566 69.1463C40.7886 69.387 40.403 69.4457 39.9792 69.3271L24.7736 65.0735C24.1039 64.8859 23.4537 64.8842 22.7851 65.0665L17.1575 66.6008V50.5299L25.2936 48.2779L39.8791 52.1857C41.6913 52.6716 42.7718 54.5411 42.2857 56.3547C41.8005 58.1669 39.93 59.2457 38.117 58.7602L23.2308 54.7718C22.6186 54.6085 21.9919 54.9709 21.8269 55.5828C21.6636 56.1931 22.0258 56.8219 22.6372 56.9853L37.5234 60.9749C40.3274 61.7251 43.2864 60.2376 44.3244 57.4881L64.7218 48.3194C65.0299 48.1803 65.3008 48.1533 65.6283 48.2261C67.9978 48.7562 67.9487 51.3096 65.8991 53.0083ZM14.8655 68.4102C14.8655 69.1393 14.2727 69.7338 13.5417 69.7338H4.89773C4.16666 69.7338 3.57388 69.1393 3.57388 68.4102V49.4867C3.57388 48.7577 4.16666 48.1632 4.89773 48.1632H13.5417C14.2727 48.1632 14.8655 48.7578 14.8655 49.4867V68.4102ZM69.5908 49.2103C69.2001 47.5913 67.9063 46.3882 66.1296 45.9898C65.3129 45.8065 64.5455 45.8852 63.7821 46.2277L44.6567 54.8261C44.3956 52.571 42.7927 50.5941 40.4719 49.971L25.5856 45.9825C25.3883 45.9297 25.1804 45.9309 24.9824 45.9853L16.9271 48.2145C16.412 46.8463 15.089 45.8709 13.542 45.8709H4.89773C2.90357 45.8709 1.28125 47.4924 1.28125 49.4866V68.4101C1.28125 70.4027 2.9034 72.0257 4.89773 72.0257H13.5417C15.3386 72.0257 16.8321 70.7078 17.112 68.9887L23.3881 67.2783C23.6599 67.2038 23.8838 67.2038 24.1556 67.2796L39.3612 71.5344C40.4124 71.8287 41.472 71.6755 42.4074 71.0662L67.0164 55.0265C67.1409 54.945 67.2468 54.8675 67.3617 54.7715C69.1953 53.2503 70.0492 51.1198 69.5908 49.2103Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF",
                            "stroke-width": "1.5"
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE Diligentsia ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Portfolio Pro Dashboard"
                        ]
                    }),
                    points: [
                        'FREE dashboard for client monitoring',
                        'All your clients in one place - see status',
                        'FREE tools - client benchmarking, automated anylist checklist creator and more',
                        'Access your client dashboards and module status and reports (with permissions)',
                        'Manage permissions for each of your team members',
                        'Allocate colleagues to sections for context sensitive help e.g. tax colleague in tax section',
                        "Promote your firm\u2019s services within sections to unaffiliated companies on the platform without advisors"
                    ],
                    image: (parcelRequire("71DfO")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Portfolio Dashboard"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("hBlAH")),
                        (parcelRequire("asUrc")),
                        (parcelRequire("5KMDo"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df aic bg1 px1rem py1rem w60 mla mra br45px c12 tal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w3rem",
                                    src: (parcelRequire("ldnDr")),
                                    alt: ""
                                })
                            }),
                            " Either your clients can subscribe, or you can sign them up directly (and reclaim via disbursements)"
                        ]
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE Client ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Benchmarking"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Benchmark your client companies"
                }),
                isLorem: false,
                isNil: false,
                isHelpicon: false,
                isLock: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "65",
                        height: "65",
                        viewBox: "0 0 65 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                            "clip-path": "url(#clip0_2119_192)",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M54.9743 42.4394C57.0327 38.6748 58.1973 34.3686 58.1973 29.7915C58.1973 28.5728 58.0618 27.3811 57.8993 26.1894C61.1764 25.404 63.6139 22.479 63.6139 18.9582C63.6139 14.8415 60.2827 11.5103 56.166 11.5103C54.5952 11.5103 53.1598 11.9978 51.9681 12.8103C46.9577 6.879 39.6181 3.38525 31.791 3.38525C17.2202 3.38525 5.38477 15.2207 5.38477 29.7915C5.38477 44.3623 17.2202 56.1978 31.791 56.1978C36.3681 56.1978 40.6743 55.0332 44.4389 52.9748L50.9118 59.4478C52.3743 60.9103 54.2702 61.6144 56.1931 61.6144C58.116 61.6144 60.0118 60.8832 61.4743 59.4478C64.3723 56.5498 64.3723 51.8103 61.4743 48.9123L55.0014 42.4394H54.9743ZM56.166 15.5728C58.0348 15.5728 59.5514 17.0894 59.5514 18.9582C59.5514 20.8269 58.0348 22.3436 56.166 22.3436C54.2973 22.3436 52.7806 20.8269 52.7806 18.9582C52.7806 17.0894 54.2973 15.5728 56.166 15.5728ZM31.791 7.44775C38.6431 7.44775 45.0889 10.6436 49.3139 16.0332C48.9348 16.9269 48.7181 17.929 48.7181 18.9582C48.7181 20.2853 49.0973 21.4769 49.6931 22.5603L35.7452 36.5082L30.0577 30.8207C30.7077 29.7103 31.1139 28.4373 31.1139 27.0832C31.1139 22.9665 27.7827 19.6353 23.666 19.6353C19.5493 19.6353 16.2181 22.9665 16.2181 27.0832C16.2181 28.3019 16.5431 29.4394 17.0577 30.4686L10.6118 36.8873C9.85352 34.6665 9.44727 32.2832 9.44727 29.7915C9.44727 17.4686 19.4681 7.44775 31.791 7.44775ZM20.2806 27.0832C20.2806 25.2144 21.7973 23.6978 23.666 23.6978C25.5348 23.6978 27.0514 25.2144 27.0514 27.0832C27.0514 28.9519 25.5348 30.4686 23.666 30.4686C21.7973 30.4686 20.2806 28.9519 20.2806 27.0832ZM12.3993 40.8415L19.8202 33.4207C20.9306 34.0978 22.2577 34.504 23.666 34.504C24.9118 34.504 26.1035 34.1519 27.1327 33.6103L34.3098 40.7873C34.716 41.1936 35.2306 41.3832 35.7452 41.3832C36.2598 41.3832 36.7743 41.1936 37.1806 40.7873L52.5639 25.404C52.9431 25.6207 53.3493 25.8103 53.7556 25.9457C53.9723 27.2186 54.1348 28.4915 54.1348 29.7644C54.1348 42.0873 44.1139 52.1082 31.791 52.1082C23.5035 52.1082 16.2452 47.5582 12.3993 40.8144V40.8415ZM58.5493 56.5498C57.2223 57.8769 55.0827 57.8769 53.7556 56.5498L47.8785 50.6728C49.666 49.2915 51.291 47.6665 52.6723 45.879L58.5493 51.7561C59.8764 53.0832 59.8764 55.2228 58.5493 56.5498Z",
                                fill: "#4A67FF"
                            })
                        })
                    }),
                    title: 'FREE Client Benchmarking',
                    points: [
                        'Benchmark your client/portfolio companies',
                        'Simple scoring system',
                        'Against each or our wider database (anonymized)',
                        'Benchmarking report'
                    ],
                    image: (parcelRequire("9883i")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Client Benchmarking"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("dIwiD")),
                        (parcelRequire("c2MyR")),
                        (parcelRequire("k52TY"))
                    ]
                }
            },
            {
                title: 'Diligentsia Pro PLUS',
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Charge to assist your clients in self-diligencing"
                }),
                isNil: false,
                isHelpicon: false,
                isLock: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M66.7745 20.1305C62.2389 20.1305 58.5491 23.8399 58.5491 28.3996C58.5491 30.2228 59.1574 31.8945 60.1553 33.263L54.5322 40.7986L47.1836 26.2215C48.7436 24.7157 49.7254 22.6098 49.7254 20.2691C49.7254 15.7094 46.0357 12 41.5 12C36.9643 12 33.2745 15.7094 33.2745 20.2691C33.2745 22.6098 34.2564 24.7157 35.8164 26.2215L28.4678 40.7986L22.8447 33.263C23.8426 31.8945 24.4509 30.2228 24.4509 28.3996C24.4509 23.8399 20.7611 20.1305 16.2254 20.1305C11.6898 20.1305 8 23.8399 8 28.3996C8 32.4637 10.9367 35.8336 14.7856 36.5224L17.5738 59.881C17.7175 61.0909 18.7375 62 19.9491 62H63.0509C64.2625 62 65.2825 61.0909 65.4262 59.881L68.2144 36.5224C72.0633 35.8336 75 32.4637 75 28.3996C75 23.8399 71.3102 20.1305 66.7745 20.1305ZM66.7745 31.8576C64.8783 31.8576 63.3348 30.3072 63.3348 28.3996C63.3348 26.4921 64.8783 24.9416 66.7745 24.9416C68.6708 24.9416 70.2143 26.4921 70.2143 28.3996C70.2143 30.3072 68.6708 31.8576 66.7745 31.8576ZM22.0721 57.1889L19.664 37.0164L26.9489 46.7796C27.4443 47.4468 28.2645 47.825 29.0707 47.7334C29.8956 47.6606 30.6235 47.1673 30.9974 46.4249L40.0863 28.3945C40.5476 28.4756 41.0159 28.5382 41.5 28.5382C41.9841 28.5382 42.4524 28.4756 42.9137 28.3945L52.0026 46.4249C52.3765 47.1673 53.1044 47.6606 53.9293 47.7334C54.7518 47.8227 55.5557 47.4468 56.0511 46.7796L63.336 37.0164L60.9279 57.1889H22.0721ZM12.7857 28.3996C12.7857 26.4921 14.3292 24.9416 16.2254 24.9416C18.1217 24.9416 19.6652 26.4921 19.6652 28.3996C19.6652 30.3072 18.1217 31.8576 16.2254 31.8576C14.3292 31.8576 12.7857 30.3072 12.7857 28.3996ZM38.0603 20.2691C38.0603 18.3616 39.6037 16.8111 41.5 16.8111C43.3963 16.8111 44.9397 18.3616 44.9397 20.2691C44.9397 22.1767 43.3963 23.7271 41.5 23.7271C39.6037 23.7271 38.0603 22.1767 38.0603 20.2691Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62.6515 71C63.9484 71 65 69.8818 65 68.5C65 67.1182 63.9484 66 62.6515 66H20.3485C19.0516 66 18 67.1182 18 68.5C18 69.8818 19.0516 71 20.3485 71H62.6515Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: 'Diligentsia Pro PLUS',
                    points: [
                        "Your client too busy? Can\u2019t or doesn\u2019t want to self-diligence?",
                        'You can assist in module completion on a chargeable basis',
                        'Audited certificate valid for 3 months',
                        `Periodic reporting of changes to repository and  other modules to keep you abreast of developments - opportunity to sell in additional services to support`,
                        `Option of quarterly reviews`
                    ],
                    image: (parcelRequire("kretz")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Diligentsia Pro PLUS"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("eIjoz")),
                        (parcelRequire("hK9yq")),
                        (parcelRequire("9y1fn"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df aic bg1 px3rem py0-5rem w70 mla mra br45px c12 tal jcsb",
                        children: [
                            "A structured environment for your firm to generate additional fees.",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "You can also optionally additionally charge to offer audited certification ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w8rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE Context Sensitive",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Revenue Leads"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Increase revenues from both existing and new clients"
                }),
                isNil: false,
                isHelpicon: true,
                isLock: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "75",
                        height: "57",
                        viewBox: "0 0 75 57",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M46.8111 29.1401L51.0709 24.8236C51.3809 25.9986 51.5625 27.2271 51.5625 28.5001C51.5625 36.3577 45.2543 42.75 37.5 42.75C36.2438 42.75 35.0314 42.566 33.8719 42.2519L38.1316 37.9353C42.7893 37.6135 46.4936 33.8598 46.8111 29.1401ZM74.7047 27.3464C74.4164 26.821 70.3277 19.5612 62.3355 13.4088L58.9248 16.865C64.7525 21.2071 68.4451 26.2711 69.8988 28.5036C67.1209 32.7899 56.2236 47.5 37.5 47.5C34.6922 47.5 32.0812 47.1361 29.6244 46.5554L25.773 50.4581C29.3139 51.5583 33.2057 52.25 37.5 52.25C62.035 52.25 74.199 30.5758 74.7047 29.6537C75.0984 28.9359 75.0984 28.0643 74.7047 27.3464ZM64.9383 4.05426L13.3758 56.3041C12.9182 56.7678 12.3182 57 11.7188 57C11.1193 57 10.5193 56.7678 10.0617 56.3041C9.1459 55.3761 9.1459 53.8733 10.0617 52.9459L16.6219 46.2983C6.01641 39.8104 0.627539 30.2599 0.295312 29.6537C-0.0984375 28.9359 -0.0984375 28.0637 0.295312 27.3458C0.800977 26.4243 12.965 4.75014 37.5 4.75014C43.8439 4.75014 49.3389 6.21669 54.0363 8.38506L61.6242 0.696022C62.54 -0.232007 64.023 -0.232007 64.9383 0.696022C65.8535 1.62405 65.8541 3.12683 64.9383 4.05426ZM20.117 42.7566L26.0508 36.7437C24.4119 34.4138 23.4375 31.5727 23.4375 28.5001C23.4375 20.6424 29.7457 14.2501 37.5 14.2501C40.5322 14.2501 43.3359 15.2375 45.6352 16.8976L50.4334 12.0354C46.6424 10.497 42.3346 9.50012 37.5 9.50012C18.7764 9.50012 7.8791 24.2102 5.10176 28.4965C6.86543 31.2052 11.935 38.0618 20.117 42.7566ZM29.4533 33.2952L42.232 20.3461C40.8381 19.5119 39.2332 19.0001 37.5 19.0001C32.3309 19.0001 28.125 23.262 28.125 28.5001C28.125 30.2564 28.6301 31.8827 29.4533 33.2952Z",
                            fill: "#4A67FF"
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE Context sensitive",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "revenue leads"
                        ]
                    }),
                    points: [
                        'You can add colleagues onto the platform and allocate sections to each e.g. tax to tax partner, corporate to company secretarial',
                        'Across the platform, when your client is addressing a section, your colleague will be a click away from contact',
                        "\u201CIn mind, in sight\u201D \u2013 opportunities to sell In more services across your practice",
                        'Periodic notification of changes to data repository triggers opportunities to sell in additional services',
                        'You can also offer your services to  our companies that come directly onto our platform from the web, ie. NOT through their advisors'
                    ],
                    notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: "14px",
                            color: 'gray',
                            fontStyle: 'italic'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: "bold",
                                    fontStyle: 'normal'
                                },
                                children: `Please Note: `
                            }),
                            "Diligentsia does NOT take commissions from accountants and lawyers, nor do we ask for % of monies raised from investors.We generate our revenues from subscriptions and module charges on companies subscribing to our platform."
                        ]
                    }),
                    image: (parcelRequire("knqcS")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Revenue Generation Leads"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    checkList: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Your cards served to your clients?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Your cards served to unaffiliated companies?*"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("gBgEl")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c12",
                                    children: [
                                        "Other advisors\u2019 cards served to ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "your"
                                        }),
                                        " clients? No."
                                    ]
                                })
                            ]
                        })
                    ],
                    arrayImages: [
                        (parcelRequire("dQ3j7")),
                        (parcelRequire("eE8nI")),
                        (parcelRequire("cQdyd"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df aic w90 mla mra br45px c12 tac jcc mt1rem",
                        children: "*= Companies subscribing to the platform directly i.e not through advisors. The more of your own clients you add, the more often your own business cards will be served by our algorithm to those unaffiliated companies. "
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE - AnyList Checklist",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Builder"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Generate diligence checklists on anything in minutes"
                }),
                isNil: false,
                isHelpicon: true,
                isLock: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE - AnyList Checklist",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Builder"
                        ]
                    }),
                    points: [
                        'Undertaking M&A? Create relevant automated due diligence checklists bespoked to target company',
                        `10 sections; 10 questions per section`,
                        `You can add your own questions and desired answers`,
                        `Questions: can choose subjective, objective or a mixture`,
                        `Completeness and risk scoring`,
                        `Reporting`,
                        `Workflow Manager: Can send to target company and monitor completeness`
                    ],
                    image: (parcelRequire("lB7oR")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "AnyList Checklist Builder"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    checkList: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for you"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for your target user"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Reusable by the target company"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Company gains value from completion - risks & recommendations"
                                })
                            ]
                        })
                    ],
                    arrayImages: [
                        (parcelRequire("fw9PN")),
                        (parcelRequire("6XakL")),
                        (parcelRequire("3vuqz"))
                    ]
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "FREE - Workflow Manager"
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Management and reporting of module completeness and recommendations"
                }),
                isNil: false,
                isHelpicon: true,
                isLock: false,
                isWf: true,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Workflow Manager"
                    }),
                    points: [
                        'Completion of a module on a specific topic identifies risks and recommendations',
                        `The Workflow Manager delivers a structured process to address those issues`,
                        `Issues can be assigned to colleagues, and progress monitored`,
                        `Real-time status reports and summaries for each module`
                    ],
                    image: (parcelRequire("1Q7Rb")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Workflow Manager"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("9z55S")),
                        (parcelRequire("ji7WB")),
                        (parcelRequire("dZZKb"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc bg1 px3rem py0-5rem w70 mla mra br45px c12 tac",
                        children: "A structured approach to improving business performance"
                    })
                }
            }
        ],
        portfolioProInvestor: [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE Diligentsia ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Portfolio Pro Dashboard"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Monitor all your portfolio companies from one dashboard"
                }),
                isLorem: false,
                isNil: false,
                isLock: false,
                showSeeMoreTooltip: true,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "71",
                        height: "73",
                        viewBox: "0 0 71 73",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M48.7647 16.1159C49.3097 16.1159 49.7537 16.5598 49.7537 17.1056C49.7537 17.6503 49.3099 18.0943 48.7647 18.0943C48.2196 18.0943 47.7765 17.6503 47.7765 17.1056C47.7765 16.5598 48.2197 16.1159 48.7647 16.1159ZM48.7647 20.3864C50.5746 20.3864 52.0455 18.9135 52.0455 17.1056C52.0455 15.2962 50.5746 13.8235 48.7647 13.8235C46.9557 13.8235 45.4847 15.2962 45.4847 17.1056C45.4847 18.9135 46.9557 20.3864 48.7647 20.3864ZM38.7742 16.1159C39.32 16.1159 39.7624 16.5598 39.7624 17.1056C39.7624 17.6503 39.32 18.0943 38.7742 18.0943C38.2284 18.0943 37.7851 17.6503 37.7851 17.1056C37.7851 16.5598 38.2284 16.1159 38.7742 16.1159ZM38.7742 20.3864C40.5832 20.3864 42.055 18.9135 42.055 17.1056C42.055 15.2962 40.5832 13.8235 38.7742 13.8235C36.9651 13.8235 35.4934 15.2962 35.4934 17.1056C35.4934 18.9135 36.9653 20.3864 38.7742 20.3864ZM28.783 16.1159C29.3288 16.1159 29.772 16.5598 29.772 17.1056C29.772 17.6503 29.3288 18.0943 28.783 18.0943C28.2387 18.0943 27.7948 17.6503 27.7948 17.1056C27.7948 16.5598 28.2387 16.1159 28.783 16.1159ZM28.783 20.3864C30.5929 20.3864 32.0638 18.9135 32.0638 17.1056C32.0638 15.2962 30.5929 13.8235 28.783 13.8235C26.9739 13.8235 25.5021 15.2962 25.5021 17.1056C25.5021 18.9135 26.9739 20.3864 28.783 20.3864ZM19.805 9.17313V25.0366C19.805 28.211 22.3863 30.8629 25.5596 30.9472C26.1814 30.963 26.6764 31.4716 26.6764 32.0919V39.1405L34.5319 31.2838C34.747 31.069 35.0397 30.9487 35.343 30.9487H51.8312C55.091 30.9487 57.7435 28.2967 57.7435 25.0364V9.17313C57.7435 5.91256 55.091 3.26104 51.8312 3.26104H25.7173C22.4567 3.26104 19.805 5.91256 19.805 9.17313ZM24.3838 33.1308V41.9085C24.3838 42.9276 25.622 43.4382 26.3408 42.7191L35.8169 33.241H51.8312C56.3549 33.241 60.0353 29.5609 60.0353 25.0366V9.17313C60.0353 4.6493 56.3549 0.96875 51.8312 0.96875H25.7173C21.1934 0.96875 17.5132 4.6493 17.5132 9.17313V25.0366C17.5132 29.0638 20.5054 32.4832 24.3838 33.1308ZM65.8991 53.0083C65.8529 53.0468 65.8157 53.0723 65.7656 53.1069L41.1566 69.1463C40.7886 69.387 40.403 69.4457 39.9792 69.3271L24.7736 65.0735C24.1039 64.8859 23.4537 64.8842 22.7851 65.0665L17.1575 66.6008V50.5299L25.2936 48.2779L39.8791 52.1857C41.6913 52.6716 42.7718 54.5411 42.2857 56.3547C41.8005 58.1669 39.93 59.2457 38.117 58.7602L23.2308 54.7718C22.6186 54.6085 21.9919 54.9709 21.8269 55.5828C21.6636 56.1931 22.0258 56.8219 22.6372 56.9853L37.5234 60.9749C40.3274 61.7251 43.2864 60.2376 44.3244 57.4881L64.7218 48.3194C65.0299 48.1803 65.3008 48.1533 65.6283 48.2261C67.9978 48.7562 67.9487 51.3096 65.8991 53.0083ZM14.8655 68.4102C14.8655 69.1393 14.2727 69.7338 13.5417 69.7338H4.89773C4.16666 69.7338 3.57388 69.1393 3.57388 68.4102V49.4867C3.57388 48.7577 4.16666 48.1632 4.89773 48.1632H13.5417C14.2727 48.1632 14.8655 48.7578 14.8655 49.4867V68.4102ZM69.5908 49.2103C69.2001 47.5913 67.9063 46.3882 66.1296 45.9898C65.3129 45.8065 64.5455 45.8852 63.7821 46.2277L44.6567 54.8261C44.3956 52.571 42.7927 50.5941 40.4719 49.971L25.5856 45.9825C25.3883 45.9297 25.1804 45.9309 24.9824 45.9853L16.9271 48.2145C16.412 46.8463 15.089 45.8709 13.542 45.8709H4.89773C2.90357 45.8709 1.28125 47.4924 1.28125 49.4866V68.4101C1.28125 70.4027 2.9034 72.0257 4.89773 72.0257H13.5417C15.3386 72.0257 16.8321 70.7078 17.112 68.9887L23.3881 67.2783C23.6599 67.2038 23.8838 67.2038 24.1556 67.2796L39.3612 71.5344C40.4124 71.8287 41.472 71.6755 42.4074 71.0662L67.0164 55.0265C67.1409 54.945 67.2468 54.8675 67.3617 54.7715C69.1953 53.2503 70.0492 51.1198 69.5908 49.2103Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF",
                            "stroke-width": "1.5"
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE Diligentsia ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Portfolio Pro Dashboard"
                        ]
                    }),
                    points: [
                        'FREE dashboard for client monitoring',
                        'All your clients in one place - see status',
                        'FREE tools - client benchmarking, automated anylist checklist creator and more',
                        'Access your client dashboards and module status and reports (with permissions)',
                        'Manage permissions for each of your team members',
                        'Allocate colleagues to sections for context sensitive help e.g. tax colleague in tax section',
                        "Promote your firm\u2019s services within sections to unaffiliated companies on the platform without advisors"
                    ],
                    image: (parcelRequire("71DfO")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Portfolio Dashboard"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("hBlAH")),
                        (parcelRequire("asUrc")),
                        (parcelRequire("5KMDo"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df aic bg1 px1rem py1rem w60 mla mra br45px fs1rem c12 tal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w3rem",
                                    src: (parcelRequire("ldnDr")),
                                    alt: ""
                                })
                            }),
                            " Either your clients can subscribe, or you can sign them up directly (and reclaim via disbursements)"
                        ]
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE Portfolio ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Benchmarking"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Benchmark your portfolio companies"
                }),
                isLorem: false,
                isNil: false,
                isLock: false,
                showSeeMoreTooltip: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "65",
                        height: "65",
                        viewBox: "0 0 65 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                            "clip-path": "url(#clip0_2119_192)",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M54.9743 42.4394C57.0327 38.6748 58.1973 34.3686 58.1973 29.7915C58.1973 28.5728 58.0618 27.3811 57.8993 26.1894C61.1764 25.404 63.6139 22.479 63.6139 18.9582C63.6139 14.8415 60.2827 11.5103 56.166 11.5103C54.5952 11.5103 53.1598 11.9978 51.9681 12.8103C46.9577 6.879 39.6181 3.38525 31.791 3.38525C17.2202 3.38525 5.38477 15.2207 5.38477 29.7915C5.38477 44.3623 17.2202 56.1978 31.791 56.1978C36.3681 56.1978 40.6743 55.0332 44.4389 52.9748L50.9118 59.4478C52.3743 60.9103 54.2702 61.6144 56.1931 61.6144C58.116 61.6144 60.0118 60.8832 61.4743 59.4478C64.3723 56.5498 64.3723 51.8103 61.4743 48.9123L55.0014 42.4394H54.9743ZM56.166 15.5728C58.0348 15.5728 59.5514 17.0894 59.5514 18.9582C59.5514 20.8269 58.0348 22.3436 56.166 22.3436C54.2973 22.3436 52.7806 20.8269 52.7806 18.9582C52.7806 17.0894 54.2973 15.5728 56.166 15.5728ZM31.791 7.44775C38.6431 7.44775 45.0889 10.6436 49.3139 16.0332C48.9348 16.9269 48.7181 17.929 48.7181 18.9582C48.7181 20.2853 49.0973 21.4769 49.6931 22.5603L35.7452 36.5082L30.0577 30.8207C30.7077 29.7103 31.1139 28.4373 31.1139 27.0832C31.1139 22.9665 27.7827 19.6353 23.666 19.6353C19.5493 19.6353 16.2181 22.9665 16.2181 27.0832C16.2181 28.3019 16.5431 29.4394 17.0577 30.4686L10.6118 36.8873C9.85352 34.6665 9.44727 32.2832 9.44727 29.7915C9.44727 17.4686 19.4681 7.44775 31.791 7.44775ZM20.2806 27.0832C20.2806 25.2144 21.7973 23.6978 23.666 23.6978C25.5348 23.6978 27.0514 25.2144 27.0514 27.0832C27.0514 28.9519 25.5348 30.4686 23.666 30.4686C21.7973 30.4686 20.2806 28.9519 20.2806 27.0832ZM12.3993 40.8415L19.8202 33.4207C20.9306 34.0978 22.2577 34.504 23.666 34.504C24.9118 34.504 26.1035 34.1519 27.1327 33.6103L34.3098 40.7873C34.716 41.1936 35.2306 41.3832 35.7452 41.3832C36.2598 41.3832 36.7743 41.1936 37.1806 40.7873L52.5639 25.404C52.9431 25.6207 53.3493 25.8103 53.7556 25.9457C53.9723 27.2186 54.1348 28.4915 54.1348 29.7644C54.1348 42.0873 44.1139 52.1082 31.791 52.1082C23.5035 52.1082 16.2452 47.5582 12.3993 40.8144V40.8415ZM58.5493 56.5498C57.2223 57.8769 55.0827 57.8769 53.7556 56.5498L47.8785 50.6728C49.666 49.2915 51.291 47.6665 52.6723 45.879L58.5493 51.7561C59.8764 53.0832 59.8764 55.2228 58.5493 56.5498Z",
                                fill: "#4A67FF"
                            })
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE Portfolio ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Benchmarking"
                        ]
                    }),
                    points: [
                        'Benchmark your client/portfolio companies',
                        'Simple scoring system',
                        'Against each or our wider database (anonymized)',
                        'Benchmarking report'
                    ],
                    image: (parcelRequire("9883i")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Portfolio Benchmarking"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("38rPY")),
                        (parcelRequire("hviOk")),
                        (parcelRequire("chGIW"))
                    ]
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE Applicant Leads",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Module"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Qualified investment leads meeting your criteria PLUS due diligence pack"
                }),
                isLorem: false,
                isNil: false,
                isLock: false,
                showSeeMoreTooltip: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "69",
                        height: "67",
                        viewBox: "0 0 69 67",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE Applicant Leads",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    subMenu: {
                        index: 4,
                        points: [
                            '- Data Repository Report',
                            `- 20-section Business Audit`,
                            "- Directors\u2019 questionnaires",
                            '- Draft Warranty Disclosures'
                        ]
                    },
                    points: [
                        'Open to Diligentsia gold certification only',
                        "Matches applicant company investment requirements against your fund\u2019s investment criteria for initial screening",
                        'List of curated applicant company leads, with contact details',
                        "A \u201CFit Report\u201D which shows each the party the Fit with the other",
                        'Supported with a comprehensive Due Diligence Pack, already completed:'
                    ],
                    image: (parcelRequire("3i2EE")),
                    notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: "14px",
                            color: 'gray',
                            fontStyle: 'italic'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: "bold",
                                    fontStyle: 'normal'
                                },
                                children: `Please Note: `
                            }),
                            "Diligentsia does NOT give investment advice, nor do we generate revenue from successful introductions via our platform. Nor do we take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice."
                        ]
                    }),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "FREE Applicant Leads"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("68Qf7")),
                        (parcelRequire("hfO9Z")),
                        (parcelRequire("dh6HU"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w80 mla mra br45px c12 fs1-25rem",
                        children: [
                            "To keep standards up, this module is only available to Diligentsia Gold certified companies ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w4rem",
                                    src: (parcelRequire("93hnj")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE Website Lead",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Qualification Widget"
                    ]
                }),
                isStar: false,
                // boxBottomText: <>Attach to your website for comprehensive initial lead qualification</>,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Coming Soon"
                }),
                isLorem: false,
                isNil: false,
                isLock: false,
                showSeeMoreTooltip: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "65",
                        height: "65",
                        viewBox: "0 0 65 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                            "clip-path": "url(#clip0_2144_2961)",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M59.0649 45.2617C57.0984 43.7326 54.4454 42.424 51.1735 41.365L40.4602 15.9917L46.5688 12.8672C47.8444 12.2148 47.9682 10.436 46.7958 9.61325L33.5931 0.345958C32.6001 -0.350612 31.2153 0.0464848 30.744 1.16567L13.8201 41.3655C10.5497 42.4252 7.89796 43.734 5.93215 45.2629C2.81301 47.6887 2.1582 50.1543 2.1582 51.7955C2.1582 55.6194 5.54178 59.0754 11.6857 61.5269C23.2874 66.1564 41.7041 66.1591 53.3124 61.5269C59.4562 59.0753 62.8399 55.6194 62.8399 51.7955C62.8399 50.1538 62.185 47.6876 59.0649 45.2617ZM49.8453 48.0099C49.4554 49.2351 46.5891 51.0364 41.5124 52.088V46.8234C44.1716 46.3314 46.5386 45.6198 48.4568 44.7218L49.8453 48.0099ZM33.3379 4.81977L42.0218 10.9152L38.975 12.4737C38.5486 11.4667 37.4225 11.0485 36.4752 11.4488C35.5064 11.8578 35.0526 12.9749 35.4618 13.9437C35.8866 14.9496 46.9737 41.2087 46.9737 41.2087C43.6382 42.8044 38.1992 43.7977 32.4992 43.7977C26.7962 43.7977 21.3544 42.8033 18.0195 41.2063L33.3379 4.81977ZM37.704 47.3561V52.6739C34.3705 53.0263 30.6339 53.0271 27.2941 52.6739V47.3561C30.6937 47.6896 34.303 47.6897 37.704 47.3561ZM16.5398 44.721C18.4583 45.6195 20.8258 46.3313 23.4858 46.8234V52.088C18.4091 51.0364 15.5428 49.2351 15.153 48.0099C16.0614 45.8585 15.7407 46.6188 16.5398 44.721ZM51.9009 57.9898C41.1996 62.2598 23.7987 62.26 13.0972 57.9898C8.63223 56.2082 5.96668 53.8926 5.96668 51.7955C5.96668 49.9205 8.14868 47.8888 11.7689 46.2336L11.4485 46.9925C11.3494 47.227 11.2984 47.4789 11.2984 47.7333C11.2984 52.2226 17.4375 55.0875 25.0009 56.209C30.2578 56.8805 34.5371 56.9913 39.9969 56.209C47.5603 55.0875 53.6994 52.2226 53.6994 47.7333C53.6994 47.4789 53.6485 47.227 53.5494 46.9925L53.2292 46.2341C56.8494 47.8887 59.0313 49.9202 59.0313 51.7957C59.0314 53.8925 56.3659 56.2082 51.9009 57.9898Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M6.05446 20.1165L6.23549 21.564C6.35305 22.5043 7.14419 23.2151 8.09174 23.2317C9.07217 23.2425 9.85875 22.5406 10.005 21.6299L10.3029 19.7759C10.7195 17.1847 12.4866 14.9561 14.9131 13.9605C16.4081 13.3486 16.5262 11.3715 15.2166 10.5656L13.8455 9.72178C12.0268 8.60284 10.7581 6.757 10.3644 4.65815L9.99661 2.69615C9.82511 1.78098 9.01745 1.12859 8.08641 1.14318C7.15562 1.16197 6.37501 1.85105 6.2407 2.77232L6.01955 4.28898C5.68047 6.61406 4.31589 8.61617 2.27595 9.78207L0.959737 10.534C-0.43226 11.3293 -0.275859 13.3944 1.22658 13.9668C3.85557 14.9685 5.70548 17.3248 6.05446 20.1165ZM8.15179 9.2857C8.81814 10.3546 9.66045 11.3123 10.6465 12.1125C9.66198 12.9104 8.81535 13.8672 8.1429 14.9374C7.46144 13.8655 6.60263 12.9121 5.60036 12.12C6.61329 11.3192 7.47312 10.3608 8.15179 9.2857Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.0731 25.7884L62.6117 24.9115C60.7798 23.8125 59.5036 21.978 59.1099 19.8784L58.7446 17.93C58.5729 17.0149 57.7612 16.3614 56.8344 16.3771C55.9036 16.3959 55.1231 17.085 54.9887 18.0061L54.7509 19.6365C54.4212 21.8971 53.1013 23.8556 51.1298 25.0098L49.8175 25.7779C48.4474 26.5799 48.6057 28.6172 50.0872 29.1953C52.6459 30.1939 54.4472 32.5073 54.7878 35.2329L54.9835 36.7979C55.1023 37.7491 55.9106 38.466 56.8735 38.466C57.8064 38.466 58.6046 37.7885 58.7531 36.864L59.0523 35.0021C59.4669 32.4225 61.2314 30.2172 63.6575 29.2468L63.801 29.1895C65.2596 28.6055 65.422 26.5977 64.0731 25.7884ZM56.9159 30.1397C56.2488 29.0814 55.4084 28.1387 54.4267 27.3525C55.4202 26.5564 56.2629 25.6061 56.9276 24.5417C57.6 25.6024 58.448 26.5493 59.4408 27.3379C58.4484 28.1256 57.5947 29.0746 56.9159 30.1397Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Functional Expansion Pack - Lead Qualification Widget"
                    }),
                    points: [
                        'Swamped with unsolicited applications for investment?',
                        "Attach our FREE \u201Cno-code\u201D widget to your web site enquiries/contact us page",
                        "Applicant companies complete short questionnaire bespoked to your organisation\u2019s investment criteria (Diligentsia questionnaire wizard)",
                        "\u201CFit Report\u201D generated in real time",
                        "Review/accept/reject\xa0 applications in your Portfolio Pro dashboard",
                        'Use as a base for further stages of our automated diligence process',
                        "Rejected companies benefit - we offer them alternative investors with a potentially better \u201Cfit\u201D. Their time not wasted."
                    ],
                    image: (parcelRequire("ki3OO")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Investor Applicant Qualification Widget"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("3p5l2")),
                        (parcelRequire("6f887")),
                        (parcelRequire("jcp8L"))
                    ]
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "FREE - AnyList Checklist",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Builder"
                    ]
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Generate personalized AI checklists on anything in minutes"
                }),
                isLorem: false,
                isNil: false,
                isLock: false,
                showSeeMoreTooltip: false,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE - AnyList Checklist",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Builder"
                        ]
                    }),
                    points: [
                        'Undertaking M&A? Create relevant automated due diligence checklists bespoked to target company',
                        `10 sections; 10 questions per section`,
                        `You can add your own questions and desired answers`,
                        `Questions: can choose subjective, objective or a mixture`,
                        `Completeness and risk scoring`,
                        `Reporting`,
                        `Workflow Manager: Can send to target company and monitor completeness`
                    ],
                    image: (parcelRequire("lB7oR")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "AnyList Checklist Builder"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    checkList: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for you"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for your target user"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Reusable by the target company"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Company gains value from completion - risks & recommendations"
                                })
                            ]
                        })
                    ],
                    arrayImages: [
                        (parcelRequire("fw9PN")),
                        (parcelRequire("6XakL")),
                        (parcelRequire("3vuqz"))
                    ]
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "FREE - Workflow Manager"
                }),
                isStar: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Management and reporting of module completeness and recommendations"
                }),
                isNil: false,
                isHelpicon: true,
                isLock: false,
                isWf: true,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Workflow Manager"
                    }),
                    points: [
                        'Completion of a module on a specific topic identifies risks and recommendations',
                        `The Workflow Manager delivers a structured process to address those issues`,
                        `Issues can be assigned to colleagues, and progress monitored`,
                        `Real-time status reports and summaries for each module`
                    ],
                    image: (parcelRequire("1Q7Rb")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Workflow Manager"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("9z55S")),
                        (parcelRequire("ji7WB")),
                        (parcelRequire("dZZKb"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc bg1 px3rem py0-5rem w70 mla mra br45px c12 tac",
                        children: "A structured approach to improving business performance"
                    })
                }
            }
        ],
        coreModulesPro: [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Your ",
                        user['role'] == 'Investor' ? 'Portfolio' : 'Client',
                        " Company",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Dashboard"
                    ]
                }),
                isStar: false,
                isCompleteness: true,
                isRisk: true,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: false,
                isHoverList: true,
                showSeeMoreTooltip: true,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 84 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Your Company",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Dashboard"
                        ]
                    }),
                    points: [
                        'All your modules in one place',
                        'Overall completeness and risk scores',
                        'Overall certification (broze/silver/gold)',
                        'At-a-glance module progress and status',
                        'Access to reports for each module',
                        'Expansion Pack purchases (at extra cost)',
                        'Easy one-stop shop for your clients and Investors to work collaboratively with you'
                    ],
                    image: (parcelRequire("7B6TB")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "c3",
                            children: [
                                user['role'] == 'Investor' ? 'Portfolio' : 'Client',
                                " Dashboard"
                            ]
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("eRXe5")),
                        (parcelRequire("fsl7i")),
                        (parcelRequire("4QeXl"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df aic bg1 px1rem py1rem w60 mla mra br45px c12 tal",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w3rem",
                                    src: (parcelRequire("ldnDr")),
                                    alt: ""
                                })
                            }),
                            " Either your client can subscribe, or you can sign them up directly (and reclaim via disbursements)"
                        ]
                    })
                }
            },
            {
                title: 'Data Repository PRO',
                isStar: true,
                isCompleteness: true,
                isRisk: false,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: false,
                isHoverList: true,
                showHowToTooltip: true,
                showReportTooltip: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository',
                sectionList: [
                    'Key Shareholder/Investor Documents',
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "70",
                        height: "59",
                        viewBox: "0 0 70 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                            fill: "#4A67FF"
                        })
                    }),
                    title: 'Data Repository PRO',
                    points: [
                        `All a client's key corporate documents in one place \u{2013} easily accessible to all`,
                        `Standard format - 20 sections 160 subsections -  standardise across all  your clients - saves your time and cost`,
                        `Up to 5 user-defined sections`,
                        `Section checklists for easy creation`,
                        `Already got a bunch of files?  AI Filing Manager will upload and organise their  existing files/data room with a few clicks`,
                        `Prepopulated docs from UK Companies  House`,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to client\u2019s chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "df ml1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                className: "pen fds w2rem mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                className: "pen fds w2rem mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                className: "pen fds w2rem"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        `AI Deduper will help weed out old files`,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                fontWeight: 'bold'
                            },
                            children: "Client unable/too busy? You can provide this chargeable service"
                        })
                    ],
                    image: (parcelRequire("3Unna")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem",
                        children: [
                            "First time? ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "3 ways for your client to populate their Data Repository"
                            })
                        ]
                    }),
                    arrayImages: [
                        (parcelRequire("3nDtB")),
                        (parcelRequire("hATCZ")),
                        (parcelRequire("emcHc"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            {
                title: 'Business Audit PRO',
                isStar: true,
                isCompleteness: true,
                isRisk: true,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: false,
                isHoverList: true,
                isWfReport: true,
                showHelpTooltip: true,
                showWorkflowReportTooltip: true,
                toolTipInfo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overlay-box",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15",
                            children: "Access our detailed help pages and tell our AI Assistants what you require help with"
                        })
                    })
                }),
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                sectionList: [
                    'Key Shareholder/Investor Documents',
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "65",
                        height: "59",
                        viewBox: "0 0 65 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: 'Business Audit PRO',
                    points: [
                        'Step by step audit of your business',
                        'Quick - multiple choice questions',
                        'Individually bespoked to your business, industry, stage of development and objective',
                        'At a glance red/amber/green status',
                        'Both section and overall completeness and risk scores',
                        'Quickly identify strengths and weaknesses',
                        'Risks and recommendations for each section',
                        'All in real-time',
                        'Improvement tracking over time'
                    ],
                    image: (parcelRequire("izGj8")),
                    imageStyle: {
                        height: '92%',
                        width: '90%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Business Audit"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("cKOgx")),
                        (parcelRequire("gRghN")),
                        (parcelRequire("9T8ub"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            {
                title: 'Diligentsia Certification',
                isStar: true,
                isCompletenessRisk: false,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: false,
                isImage: (parcelRequire("3QBnO")),
                toolTipInfo: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overlay-box",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15",
                            children: "Access our detailed help pages and tell our AI Assistants what you require help with"
                        })
                    })
                }),
                toolTipReport: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overlay-box",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "c15 df aic",
                            children: [
                                "Module Report",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon ml0-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "12",
                                        height: "14",
                                        viewBox: "0 0 12 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                            fill: "#505050"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "53",
                        height: "67",
                        viewBox: "0 0 53 67",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M48.6759 19.8499C47.7963 19.009 46.8867 18.1396 46.5988 17.4418C46.2825 16.6754 46.3086 15.3671 46.3338 14.1019C46.3786 11.8552 46.4292 9.30893 44.6987 7.57008C42.9651 5.82808 40.4148 5.8676 38.1666 5.90371C36.904 5.92347 35.5975 5.94428 34.8342 5.62616C34.1366 5.33539 33.2694 4.42487 32.4308 3.54445C30.8482 1.88306 29.0548 0 26.4995 0C23.9442 0 22.1508 1.88306 20.5683 3.54432C19.7298 4.42487 18.8626 5.33539 18.1649 5.62603C17.4018 5.94415 16.0953 5.92347 14.8326 5.90345C12.5825 5.86904 10.034 5.82795 8.30051 7.56981C6.56977 9.30867 6.62054 11.8551 6.6653 14.1018C6.69042 15.3671 6.71659 16.6754 6.40044 17.4416C6.11242 18.1394 5.20281 19.009 4.32318 19.8498C2.66663 21.4334 0.789062 23.2282 0.789062 25.7802C0.789062 28.3322 2.66663 30.1271 4.32318 31.7105C5.20281 32.5514 6.11242 33.4208 6.40031 34.1185C6.71659 34.885 6.69055 36.1933 6.6653 37.4586C6.62054 39.7052 6.5699 42.2514 8.30038 43.9904C9.39136 45.0866 10.8056 45.4771 12.2645 45.6072V65.037C12.2645 65.6959 12.5951 66.3107 13.1447 66.6742C13.694 67.0378 14.3895 67.1012 14.9957 66.8434L26.4995 61.9507L38.0035 66.8434C38.25 66.9482 38.5112 66.9999 38.7715 66.9999C39.151 66.9999 39.5284 66.8899 39.8543 66.6742C40.4038 66.3108 40.7345 65.6959 40.7345 65.037V45.6077C42.1934 45.4776 43.6075 45.087 44.6985 43.991C46.4292 42.2521 46.3785 39.7056 46.3337 37.459C46.3086 36.1937 46.2824 34.8854 46.5986 34.1192C46.8866 33.4213 47.7962 32.5518 48.6758 31.711C50.3324 30.1273 52.2099 28.3326 52.2099 25.7806C52.2099 23.2286 50.3325 21.4336 48.6759 19.8499ZM27.2676 58.0115C26.7769 57.8026 26.2221 57.8026 25.7314 58.0115L16.1903 62.0693V45.6517C16.9681 45.667 17.6775 45.7316 18.1649 45.9346C18.8626 46.2254 19.7298 47.1359 20.5683 48.0163C22.1508 49.6777 23.9442 51.5608 26.4995 51.5608C29.0548 51.5608 30.8482 49.6777 32.4306 48.0164C33.2692 47.1359 34.1364 46.2254 34.8341 45.9347C35.3216 45.7315 36.0309 45.6667 36.8087 45.6514V62.0692L27.2676 58.0115ZM45.9631 28.8732C44.7886 29.9958 43.5743 31.1567 42.9697 32.6216C42.3411 34.145 42.3755 35.8694 42.4087 37.5372C42.4379 39.0027 42.471 40.664 41.9159 41.2216C41.3588 41.7811 39.6957 41.7554 38.2281 41.7319C36.5634 41.706 34.8418 41.6788 33.3241 42.311C31.8636 42.9195 30.7066 44.1342 29.5876 45.309C28.5491 46.3993 27.3722 47.635 26.4992 47.635C25.6263 47.635 24.4493 46.3992 23.4107 45.3088C22.2918 44.1341 21.1349 42.9195 19.6744 42.3108C18.4612 41.8055 17.1179 41.7213 15.7774 41.7213C15.441 41.7213 15.1044 41.7267 14.7705 41.7319C13.3027 41.7548 11.6396 41.7813 11.0826 41.2216C10.5277 40.6639 10.5608 39.0029 10.5899 37.5372C10.6231 35.8694 10.6575 34.1448 10.0288 32.6214C9.42433 31.1567 8.20996 29.9958 7.0355 28.873C5.94753 27.8331 4.71445 26.6543 4.71445 25.7804C4.71445 24.9066 5.94753 23.7277 7.0355 22.6877C8.20996 21.5651 9.42433 20.4042 10.0289 18.9393C10.6575 17.4159 10.6231 15.6915 10.5899 14.0237C10.5607 12.558 10.5276 10.8968 11.0827 10.3392C11.6398 9.77963 13.3037 9.80554 14.7703 9.82897C16.436 9.85488 18.157 9.88223 19.6747 9.24979C21.1351 8.64142 22.292 7.42665 23.4108 6.25193C24.4495 5.16148 25.6265 3.92578 26.4995 3.92578C27.3725 3.92578 28.5495 5.16148 29.588 6.2518C30.7069 7.42665 31.8638 8.64129 33.3242 9.24965C34.842 9.8821 36.5632 9.85449 38.2285 9.82884C39.6961 9.80594 41.3592 9.77977 41.9163 10.3392C42.4711 10.8968 42.438 12.5579 42.409 14.0235C42.3757 15.6912 42.3413 17.4158 42.9701 18.9393C43.5745 20.404 44.7889 21.5648 45.9634 22.6876C47.0513 23.7275 48.2844 24.9064 48.2844 25.7803C48.2844 26.6542 47.0512 27.8331 45.9631 28.8732Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M26.4999 11.4922C18.7286 11.4922 12.4062 17.8321 12.4062 25.6249C12.4062 33.4177 18.7286 39.7577 26.4999 39.7577C34.2713 39.7577 40.5936 33.4178 40.5936 25.625C40.5936 17.8322 34.2713 11.4922 26.4999 11.4922ZM26.4999 35.8319C20.8933 35.8319 16.332 31.2531 16.332 25.625C16.332 19.9969 20.8933 15.4181 26.4999 15.4181C32.1066 15.4181 36.6678 19.9969 36.6678 25.625C36.6678 31.2531 32.1066 35.8319 26.4999 35.8319Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M28.8024 21.9187L25.2446 25.4765L24.1985 24.4304C23.4321 23.6639 22.1892 23.6639 21.4226 24.4304C20.656 25.1968 20.656 26.4397 21.4226 27.2063L23.8567 29.6404C24.2248 30.0085 24.724 30.2154 25.2446 30.2154C25.7652 30.2154 26.2645 30.0087 26.6325 29.6404L31.5782 24.6946C32.3448 23.928 32.3448 22.6853 31.5782 21.9187C30.8117 21.1521 29.5688 21.1521 28.8024 21.9187Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: 'Diligentsia Certification',
                    subMenu: {
                        index: 2,
                        points: [
                            "Bronze \u2013 basic level reached",
                            "Silver \u2013 potentially investible",
                            "Gold \u2013 sophisticated"
                        ]
                    },
                    points: [
                        `Client self-diligences and self-certifies modules`,
                        `Completeness and risk scoring`,
                        `Unaudited certification:`,
                        `Gold certification \u{2013} opens up access to  Investor Leads Module`,
                        `Digital certification valid for 3 months`,
                        `Or, with Diligentsia Pro PLUS your firm can assist and provide client an audited certificate`
                    ],
                    notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: "14px",
                            color: 'gray',
                            fontStyle: 'italic'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: "bold",
                                    fontStyle: 'normal'
                                },
                                children: `Please Note: `
                            }),
                            "Diligentsia does NOT take responsiblity for the unaudited self-certification, which is indicative.  Third parties should undertake their own diligence. We remind companies, however, that third parties may seek to rely on information provided by companies in completion of our modules, and should do so accurately and honestly with this in mind."
                        ]
                    }),
                    image: (parcelRequire("9WBs6")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Diligentsia Certification"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("h5gY8")),
                        (parcelRequire("5i7wo")),
                        (parcelRequire("kplav"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w40 df jcc mla mra",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("aFTOQ")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    })
                }
            }
        ],
        appStoreInvestment: [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Expansion Pack -",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Warranty Disclosure"
                    ]
                }),
                isStar: true,
                isCompleteness: true,
                isRisk: true,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: true,
                isHoverList: true,
                isWfReport: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557715-expansion-pack-warranty-disclosure-module',
                sectionList: [
                    'Share Capital And Authority',
                    'Information',
                    'Business Plan',
                    'Accounts',
                    'Management Accounts',
                    'Events Since The Accounts Date',
                    'Taxation',
                    'Litigation',
                    'Properties',
                    'Intellectual Property',
                    'Assets, Debt & Stock',
                    'Contracts With Connected Persons',
                    'Employment and Consultancy Arrangements',
                    'Statutory & Legal Requirements',
                    'Records & Registers',
                    'Insurance',
                    'Group Structure',
                    'Agreements & Capital Commitments',
                    'Borrowings & Facilities',
                    'Social Obligations'
                ],
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "61",
                        height: "61",
                        viewBox: "0 0 61 61",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M41.5097 47.2986C42.4967 47.2986 43.2968 46.4985 43.2968 45.5115V36.5761C43.2968 35.5892 42.4967 34.7891 41.5097 34.7891C40.5228 34.7891 39.7227 35.5892 39.7227 36.5761V45.5115C39.7227 46.4985 40.5227 47.2986 41.5097 47.2986Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M41.5097 53.8515C42.4967 53.8515 43.2968 53.0514 43.2968 52.0644C43.2968 51.0774 42.4967 50.2773 41.5097 50.2773C40.5228 50.2773 39.7227 51.0774 39.7227 52.0644C39.7227 53.0514 40.5228 53.8515 41.5097 53.8515Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M60.2943 52.9947L49.8187 34.5083C50.755 31.0922 51.2296 27.567 51.2296 24.0177V4.16964C51.2296 2.81325 49.7777 1.9514 48.5869 2.60106L48.076 2.87973C41.2031 6.62879 32.6536 5.65292 26.8021 0.451565L26.8019 0.451327C26.1248 -0.150442 25.1047 -0.150442 24.4277 0.451327L24.4275 0.451565C18.576 5.65304 10.0267 6.62867 3.15372 2.87985L2.64273 2.60106C1.45194 1.9514 0 2.81325 0 4.16964V24.0177C0 31.9811 2.3599 39.6761 6.82438 46.2704C11.2891 52.8647 17.5571 57.9136 24.951 60.8712C25.3682 61.0381 25.8325 61.0405 26.2517 60.8804C26.6152 60.9573 26.9952 60.9989 27.3896 60.9989H55.6299C59.7378 60.999 62.3195 56.5686 60.2943 52.9947ZM23.8277 48.27C17.7053 44.2901 13.3882 38.1987 11.6176 31.2144H23.8277V48.27ZM23.8277 27.6403H10.9459C10.7984 26.4495 10.7225 25.2404 10.7225 24.0178V15.8434C11.169 15.8639 11.6157 15.8743 12.0604 15.8743C16.1158 15.8743 20.1304 15.0271 23.8277 13.4103V27.6403ZM24.7354 8.96974C20.8807 11.1487 16.4977 12.3004 12.0604 12.3004C11.0876 12.3004 10.105 12.244 9.1396 12.1329C8.07879 12.0106 7.14832 12.8401 7.14832 13.9079V24.0178C7.14832 35.6899 13.2668 46.2912 23.2324 52.0996L22.7252 52.9946C22.2606 53.8145 22.041 54.6793 22.0241 55.5257C10.6815 49.1987 3.57416 37.283 3.57416 24.0177V7.0366C6.29588 8.1627 9.17558 8.71562 12.0449 8.71538C16.874 8.71514 21.6705 7.14775 25.6148 4.10638C31.9028 8.95509 40.3531 10.058 47.6555 7.0366V24.0178C47.6555 25.9771 47.4964 27.9283 47.1813 29.854L46.1742 28.0768C45.6362 27.1274 44.8798 26.4293 44.0208 25.9773C44.0595 25.3235 44.0813 24.6685 44.0813 24.0178V13.9079C44.0813 12.8401 43.1509 12.0106 42.0901 12.1328C41.1248 12.2439 40.142 12.3003 39.1692 12.3003C34.7319 12.3003 30.349 11.1485 26.4942 8.96962C25.9485 8.66129 25.2811 8.66129 24.7354 8.96974ZM27.4019 27.6403V13.4104C31.0991 15.0271 35.1137 15.8744 39.1692 15.8744C39.614 15.8744 40.0606 15.8641 40.5071 15.8436V24.0179C40.5071 24.4965 40.4946 24.9779 40.471 25.459C39.1748 25.7103 37.9597 26.4384 37.1234 27.6403H27.4019ZM35.0674 31.2145L27.4019 44.7418V31.2145H35.0674ZM55.6299 57.4249H27.3897C26.0205 57.4249 25.1598 55.948 25.835 54.7568L39.9551 29.839C40.6396 28.631 42.3801 28.631 43.0647 29.839L57.1848 54.7568C57.8597 55.948 56.9991 57.4249 55.6299 57.4249Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Expansion Pack -",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Warranty Disclosure"
                        ]
                    }),
                    points: [
                        'Normally an expensive exercise at the end of a transaction',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Get ahead, early completion will identify showstoppers and give the company time to fix them"
                        }),
                        'Can upload supporting files and notes',
                        'Based on the UK BVCA standard disclosure letter',
                        'At a glance section completion and risk scoring',
                        'Contributes to Diligentsia certification',
                        'Part of DD Pack available to investors',
                        'Still subject to formal legal review later in investment/exit process'
                    ],
                    image: (parcelRequire("bnaJ5")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Warranty Disclosure"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("6B6JN")),
                        (parcelRequire("4fFAl")),
                        (parcelRequire("ibxQi"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Expansion Pack -",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Directors\u2019 Questionnaires"
                    ]
                }),
                isStar: true,
                isCompleteness: true,
                isRisk: true,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557468-directors-questionnaire-module',
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Expansion Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Directors\u2019 Questionnaires"
                        ]
                    }),
                    points: [
                        'Normally part of purchase/sale or investment',
                        'Identify any issues in advance - time for rectification',
                        'Pre-population from Companies House where relevant',
                        'Completeness and risk scoring',
                        'Impress your counterparty with your organisation',
                        'Contributes to Diligentsia certification'
                    ],
                    image: (parcelRequire("3e8So")),
                    liStyle: {
                        paddingTop: "12px",
                        paddingRight: '12px'
                    },
                    imageStyle: {
                        height: '90%'
                    },
                    cardPaddingBottom: {
                        paddingBottom: '12px'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Your Client\u2019s Directors\u2019 Questionnaires"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("aqBrG")),
                        (parcelRequire("f5V3m")),
                        (parcelRequire("bPJsR"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            {
                title: 'Due Diligence Pack',
                isStar: false,
                isLorem: false,
                isNil: false,
                isLock: false,
                isReport: true,
                isHoverList: true,
                isCompletenessRisk: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "fs2rem c28 fw500 lh1",
                            children: "FREE"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Key module reports collated"
                    ]
                }),
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.2423 4.99219C38.0392 4.99219 26.4843 16.5471 26.4843 30.7502C26.4843 35.4448 27.7474 39.8496 29.9507 43.6439L6.94712 66.6474C4.35096 69.2434 4.35096 73.4677 6.94712 76.0637C8.24505 77.3618 9.95015 78.0108 11.6551 78.0108C13.3601 78.0108 15.0653 77.3619 16.3631 76.0637L39.3714 53.0553C43.1605 55.2502 47.557 56.5081 52.242 56.5081C66.4452 56.5081 78.0001 44.953 78.0001 30.7501C78.0001 16.5471 66.4454 4.99219 52.2423 4.99219ZM13.3351 73.0356C12.4087 73.962 10.9015 73.962 9.97525 73.0357C9.04897 72.1094 9.04897 70.6021 9.97525 69.6757L11.4192 68.2317L14.7791 71.5916L13.3351 73.0356ZM17.8072 68.5636L14.4474 65.2037L16.7667 62.8844L20.1265 66.2444L17.8072 68.5636ZM23.1545 63.2161L19.7947 59.8561L32.4432 47.2076C33.4586 48.4271 34.5841 49.5519 35.8046 50.5661L23.1545 63.2161ZM52.2423 52.2257C40.4006 52.2257 30.7669 42.5918 30.7669 30.7502C30.7669 18.9087 40.4006 9.27476 52.2423 9.27476C64.084 9.27476 73.7178 18.9085 73.7178 30.7502C73.7178 42.5919 64.084 52.2257 52.2423 52.2257Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M59.5703 27.024C59.5703 25.8415 58.6117 24.8828 57.4291 24.8828L43.216 24.8828C42.0334 24.8828 41.0748 25.8415 41.0748 27.024C41.0748 28.2066 42.0334 29.1652 43.216 29.1652L57.4291 29.1652C58.6117 29.1654 59.5703 28.2066 59.5703 27.024Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.2187 19.5318C64.2187 18.3493 63.2601 17.3906 62.0775 17.3906L43.2121 17.3906C42.0295 17.3906 41.0709 18.3493 41.0709 19.5318C41.0709 20.7144 42.0295 21.6731 43.2121 21.6731L62.0775 21.6731C63.2601 21.6732 64.2187 20.7144 64.2187 19.5318Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: 'Due Diligence Pack',
                    subMenu: {
                        index: 0,
                        points: [
                            '- Data Repository Report',
                            '- 20-sections Business Audit',
                            "- Directors\u2019 questionnaires",
                            '- Draft Warranty Disclosures '
                        ]
                    },
                    points: [
                        `Pulls together a complete pack of each of the key completed modules' reports:`,
                        `Tracks the sending of the DD Pack to investors introduced through the platform`
                    ],
                    notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: "14px",
                            color: 'gray',
                            fontStyle: 'italic'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: "bold",
                                    fontStyle: 'normal'
                                },
                                children: `Please Note: `
                            }),
                            "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice"
                        ]
                    }),
                    image: (parcelRequire("7J3ig")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Diligence Pack"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("9JAZQ")),
                        (parcelRequire("l0CSg")),
                        (parcelRequire("ko7pf"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w40 df jcc mla mra",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("aFTOQ")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Qualified Investor Leads"
                }),
                isStar: false,
                isCompleteness: true,
                isCompletenessRisk: false,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: true,
                isHoverList: true,
                isTitleIcon: (parcelRequire("3N5Zr")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "69",
                        height: "67",
                        viewBox: "0 0 69 67",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Investor Leads",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Database"
                        ]
                    }),
                    subMenu: {
                        index: 4,
                        points: [
                            '- Data Repository Report',
                            '- 20-section Business Audit',
                            "- Directors\u2019 questionnaires",
                            '- Draft Warranty Disclosures'
                        ]
                    },
                    points: [
                        'Only open to clients reaching Diligentsia gold certification - to preserve standards',
                        `Matches your client's investment requirements against investors\u{2019} investment criteria`,
                        'List of curated investor leads, with contact details',
                        "A \u201CFit Report\u201D which shows each the party the Fit with the other",
                        'Supported with a comprehensive  Due Diligence Pack, already completed:'
                    ],
                    image: (parcelRequire("c1JdN")),
                    notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: "14px",
                            color: 'gray',
                            fontStyle: 'italic'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: "bold",
                                    fontStyle: 'normal'
                                },
                                children: `Please Note: `
                            }),
                            " Please Note: Diligentsia does NOT give investment advice, nor do we generate revenue from successful introductions via our platform.  Nor do we take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice"
                        ]
                    }),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Investor Leads"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("2tJoi")),
                        (parcelRequire("lDJNj")),
                        (parcelRequire("21vwf"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w80 mla mra br45px c12 fs1-25rem",
                        children: [
                            "To keep standards up, this module is only available to Diligentsia Gold certified companies ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w4rem",
                                    src: (parcelRequire("93hnj")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            }
        ],
        appStoreGrowth: [
            // {
            //     title: <>Expansion Pack - <br />Software Development</>,
            //     isStar: false,
            //     isCompleteness: true,
            //     isRisk: true,
            //     isLorem: false,
            //     isNil: false,
            //     isReport: true,
            //     isLock: true,
            //     isHoverList: true,
            //     isWfReport: true,
            //     helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557691-expansion-pack-software-development',
            //     sectionList: ['IT Staff', 'Products & Services', 'Software Development Process', 'Software & Services Utilised', 'Hardware', 'Network Infrastructure', 'Backup & Recovery', 'Documentation', 'Network Security', 'Cybersecurity', 'Compliance', 'Agreements', 'Quality', 'Financial'],
            //     isTitleIcon: require('../../../../images/advisor-dashboard/logo-advisor.svg'),
            //     seeMoreSection: {
            //         icon: <svg width="68" height="67" viewBox="0 0 68 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            //             <path d="M64.0352 39.6001C64.0352 38.9205 63.6512 38.2993 63.0434 37.9955L57.8805 35.4141L63.0434 32.8326C63.6512 32.5288 64.0352 31.9076 64.0352 31.2281C64.0352 30.5485 63.6512 29.9273 63.0434 29.6235L49.5381 22.8709C49.4693 22.3346 49.1618 21.8353 48.6573 21.544L47.1862 20.6946C47.256 20.1359 47.2911 19.579 47.2911 19.0288C47.2911 18.4787 47.256 17.9218 47.1862 17.363L48.6573 16.5136C49.5155 16.0181 49.8094 14.9211 49.3139 14.063L45.7259 7.84849C45.2304 6.99036 44.1333 6.69626 43.2753 7.19189L41.7979 8.04476C40.9022 7.36555 39.9398 6.80582 38.9191 6.37035V4.67682C38.9191 3.68605 38.1159 2.88281 37.1251 2.88281H29.9491C28.9583 2.88281 28.1551 3.68605 28.1551 4.67682V6.37035C27.1344 6.80582 26.172 7.36555 25.2763 8.04476L23.7989 7.19189C22.9405 6.69626 21.8436 6.99048 21.3483 7.84849L17.7603 14.063C17.2648 14.9211 17.5588 16.0183 18.4169 16.5136L19.888 17.363C19.8183 17.9218 19.7831 18.4787 19.7831 19.0288C19.7831 19.579 19.8183 20.1359 19.888 20.6946L18.4169 21.544C17.9125 21.8353 17.6049 22.3347 17.5362 22.8709L4.03079 29.6235C3.42298 29.9273 3.03906 30.5485 3.03906 31.2281C3.03906 31.9076 3.42298 32.5288 4.03079 32.8326L9.19369 35.4141L4.03079 37.9955C3.42298 38.2993 3.03906 38.9205 3.03906 39.6001C3.03906 40.2796 3.42298 40.9008 4.03079 41.2046L9.19369 43.7861L4.03079 46.3675C3.42298 46.6713 3.03906 47.2925 3.03906 47.9721C3.03906 48.6516 3.42298 49.2729 4.03079 49.5766L32.7348 63.9287C32.9873 64.055 33.2621 64.1181 33.5371 64.1181C33.8121 64.1181 34.0869 64.055 34.3394 63.9287L63.0434 49.5766C63.6512 49.2729 64.0352 48.6516 64.0352 47.9721C64.0352 47.2925 63.6512 46.6713 63.0434 46.3675L57.8805 43.7861L63.0434 41.2046C63.6512 40.9008 64.0352 40.2796 64.0352 39.6001ZM23.6189 21.2352C23.4545 20.4926 23.3711 19.7503 23.3711 19.0288C23.3711 18.3074 23.4545 17.5651 23.6189 16.8225C23.7883 16.0581 23.4424 15.2722 22.7644 14.8809L21.7645 14.3036L23.5585 11.1963L24.5658 11.7777C25.2444 12.1694 26.0983 12.0755 26.6756 11.5459C27.7965 10.5176 29.0788 9.77202 30.4867 9.32974C31.2344 9.09473 31.7431 8.40188 31.7431 7.61814V6.47082H35.3311V7.61814C35.3311 8.40188 35.8398 9.09485 36.5875 9.32974C37.9954 9.77202 39.2777 10.5177 40.3986 11.5459C40.9758 12.0755 41.8298 12.1694 42.5084 11.7777L43.5157 11.1963L45.3097 14.3036L44.3099 14.8809C43.6318 15.2722 43.286 16.0582 43.4553 16.8225C43.6198 17.5651 43.7031 18.3074 43.7031 19.0288C43.7031 19.7503 43.6198 20.4926 43.4553 21.2352C43.286 21.9996 43.6318 22.7855 44.3099 23.1768L45.3097 23.7541L43.5157 26.8613L42.5084 26.2798C41.8298 25.8881 40.9756 25.982 40.3986 26.5116C39.2778 27.5399 37.9956 28.2857 36.5875 28.7279C35.8398 28.9628 35.3311 29.6558 35.3311 30.4395V31.5869H31.7431V30.4395C31.7431 29.6558 31.2344 28.9628 30.4867 28.7279C29.0787 28.2857 27.7964 27.5398 26.6756 26.5116C26.0986 25.982 25.2444 25.888 24.5658 26.2798L23.5585 26.8613L21.7645 23.7541L22.7644 23.1768C23.4425 22.7855 23.7883 21.9996 23.6189 21.2352ZM8.84457 31.2281L19.0038 26.1484L21.3483 30.2091C21.8438 31.0673 22.941 31.3613 23.7989 30.8657L25.2763 30.0127C26.172 30.692 27.1344 31.2516 28.1551 31.6872V33.3809C28.1551 34.3716 28.9583 35.1749 29.9491 35.1749H37.1251C38.1159 35.1749 38.9191 34.3716 38.9191 33.3809V31.6873C39.9398 31.2517 40.9022 30.6921 41.7979 30.0128L43.2753 30.8658C44.1332 31.3613 45.2305 31.0672 45.7259 30.2092L48.0704 26.1485L58.2296 31.2281L33.5371 43.5743L8.84457 31.2281ZM58.2296 47.9721L33.5371 60.3183L8.84457 47.9721L13.2051 45.7918L32.7348 55.5566C32.9873 55.6829 33.2621 55.7461 33.5371 55.7461C33.8121 55.7461 34.0869 55.6829 34.3394 55.5566L53.8691 45.7918L58.2296 47.9721ZM33.5371 51.9463L8.84457 39.6001L13.2051 37.4198L32.7348 47.1846C32.9873 47.3109 33.2621 47.3741 33.5371 47.3741C33.8121 47.3741 34.0869 47.3109 34.3394 47.1846L53.8691 37.4198L58.2296 39.6001L33.5371 51.9463Z" fill="#4A67FF" />
            //             <path d="M33.5389 25.6091C37.1661 25.6091 40.117 22.6582 40.117 19.0311C40.117 15.404 37.1661 12.4531 33.5389 12.4531C29.9118 12.4531 26.9609 15.404 26.9609 19.0311C26.9609 22.6582 29.9118 25.6091 33.5389 25.6091ZM33.5389 16.0411C35.1876 16.0411 36.529 17.3824 36.529 19.0311C36.529 20.6798 35.1876 22.0211 33.5389 22.0211C31.8903 22.0211 30.5489 20.6798 30.5489 19.0311C30.5489 17.3824 31.8903 16.0411 33.5389 16.0411Z" fill="#4A67FF" />
            //         </svg>,
            //         title: <>Expansion Pack - <br />Software Development</>,
            //         points: [
            //             <><b>Aimed at: </b> software development companies wishing to undertake an in depth audit of their software development structure, processes and protections</>,
            //             <><b>14 sections - </b> I.T. Staff, Products & Services, Software Development Process, Software & Services Utilised, Hardware, Network Infrastructure, Backup & Recovery, Documentation, Network Security, Cybersecurity Compliance, Agreements, Quality, Financial</>,
            //             'Completeness and risk scoring',
            //             'Automated reporting - including risks and recommendations',
            //             'Tailored to business objectives',
            //             <><b>Benefit: </b> working though these questions will strengthen the business, identify weaknesses, and giving you an opportunity to plug them prior to being subject to due diligence over a key area of your business</>,
            //         ],
            //         image: require('../../../../images/landingpage/banner23-opp.png'),
            //         imageStyle: { height: '90%', width: '94%' }
            //     },
            //     howItWorks: {
            //         subTitle: <span className='c3'>Software Development</span>,
            //         stepImage: require('../../../../images/step-modal-img.png'),
            //         arrayImages: [require('../../../../images/advisor-dashboard/software-development-step-1.png'), require('../../../../images/advisor-dashboard/software-development-step-2.png'), require('../../../../images/advisor-dashboard/software-development-step-3.png')],
            //         bottomSection: <>Iteratively prove and improve your company’s functional competence</>,
            //         // btnContent: <span className="new-shadow bg4 bg3-hover c1 td250 br30px p1rem fw600 cp ttu bsbb tac df jcc aic w250px">Let’s Go!</span>,
            //     }
            // },
            // {
            //     title: <>Expansion Pack -<br /> ESG</>,
            //     isStar: false,
            //     isCompleteness: true,
            //     isRisk: true,
            //     isLorem: false,
            //     isNil: false,
            //     isReport: true,
            //     isLock: true,
            //     isHoverList: true,
            //     isWfReport: true,
            //     helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557477-expansion-pack-environmental-social-governmental-esg',
            //     sectionList: ['Sustainability Governance', 'Environmental', 'Social', 'Governance'],
            //     isTitleIcon: require('../../../../images/advisor-dashboard/logo-advisor.svg'),
            //     seeMoreSection: {
            //         icon: <svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            //             <g clip-path="url(#clip0_1533_32239)">
            //                 <path d="M21.5997 27.9316C22.1418 27.9316 22.5812 27.4923 22.5812 26.9502C22.5812 26.408 22.1418 25.9688 21.5997 25.9688H16.1689C15.6269 25.9688 15.1875 26.408 15.1875 26.9502V39.8724C15.1875 40.4146 15.6269 40.8539 16.1689 40.8539H21.5997C22.1418 40.8539 22.5812 40.4146 22.5812 39.8724C22.5812 39.3303 22.1418 38.891 21.5997 38.891H17.1504V34.3927H21.1992C21.7412 34.3927 22.1806 33.9534 22.1806 33.4112C22.1806 32.8692 21.7412 32.4298 21.1992 32.4298H17.1504V27.9316H21.5997Z" fill="#4A67FF" stroke="#4A67FF" />
            //                 <path d="M50.826 32.4347H46.9349C46.3927 32.4347 45.9534 32.8741 45.9534 33.4161C45.9534 33.9583 46.3927 34.3975 46.9349 34.3975H49.7845C49.5031 36.6774 48.1996 38.9554 45.2117 38.9554C42.1666 38.9554 39.6895 36.4705 39.6895 33.4161C39.6895 30.3617 42.1668 27.877 45.2117 27.877C46.318 27.877 47.385 28.2036 48.2975 28.8218C48.7465 29.1257 49.3566 29.0082 49.6605 28.5595C49.9644 28.1107 49.8471 27.5005 49.3983 27.1965C48.1596 26.3575 46.7119 25.9141 45.2117 25.9141C41.0844 25.9141 37.7266 29.2795 37.7266 33.4161C37.7266 37.5528 41.0844 40.9183 45.2117 40.9183C49.0952 40.9183 51.8074 37.8333 51.8074 33.4161C51.8074 32.8739 51.368 32.4347 50.826 32.4347Z" fill="#4A67FF" stroke="#4A67FF" />
            //                 <path d="M31.9293 32.5995C30.2253 31.9693 28.647 31.2806 28.2836 31.1202C27.8016 30.7754 27.5668 30.2175 27.6537 29.6136C27.7595 28.878 28.3155 28.2902 29.141 28.0409C31.3242 27.3818 33.2803 28.9623 33.3142 28.9902C33.7286 29.3367 34.3458 29.2833 34.6942 28.8697C35.0435 28.4552 34.9908 27.8361 34.5762 27.4867C34.4643 27.3924 31.7982 25.1879 28.5736 26.1619C27.0218 26.6305 25.925 27.8461 25.711 29.3342C25.5122 30.7163 26.1088 32.0455 27.268 32.8032C27.3114 32.8314 27.357 32.8563 27.4042 32.8775C27.4786 32.9107 29.251 33.7018 31.2486 34.4405C32.7774 35.0058 33.5491 35.9171 33.3659 36.9407C33.1911 37.9179 32.1129 38.9563 30.4596 38.9563C28.9884 38.9563 27.5661 38.3545 26.6549 37.3463C26.2914 36.9443 25.6707 36.9127 25.2687 37.2763C24.8666 37.6397 24.8352 38.2605 25.1987 38.6626C26.4757 40.0757 28.4424 40.9192 30.4596 40.9192C32.8474 40.9192 34.9274 39.3574 35.2982 37.2865C35.5771 35.7262 34.8388 33.6755 31.9293 32.5995Z" fill="#4A67FF" stroke="#4A67FF" />
            //                 <path d="M58.3116 10.8509C52.7477 4.70627 45.1676 0.856514 36.9676 0.0107693C36.9676 0.0107693 36.9676 0.0107693 36.9676 0.0106384C36.3851 -0.0483792 35.8033 0.140974 35.3691 0.532506C34.9353 0.923906 34.6864 1.48385 34.6864 2.0684V4.2018C33.897 4.1704 33.1028 4.1704 32.3135 4.2018V2.06853C32.3135 1.48385 32.0647 0.924037 31.6308 0.532636C31.1967 0.140974 30.614 -0.0491643 30.0324 0.0109001C21.8324 0.856514 14.2524 4.70627 8.68828 10.8509C3.08553 17.0382 0 25.0516 0 33.415C0 38.1806 0.977258 42.7879 2.90469 47.1088C3.1435 47.6444 3.59994 48.055 4.15701 48.2353C4.36403 48.3025 4.57825 48.3356 4.79194 48.3356C5.15154 48.3356 5.50918 48.2417 5.82625 48.0583L7.666 46.9933C8.03424 47.6958 8.43205 48.385 8.8563 49.0558L7.01459 50.1219C6.50986 50.414 6.15065 50.9092 6.02921 51.4801C5.90712 52.0543 6.03484 52.6565 6.37979 53.1327C7.84698 55.1575 9.54318 57.0216 11.4214 58.6731C11.8284 59.031 12.4485 58.9913 12.8066 58.5841C13.1645 58.1771 13.1247 57.5568 12.7176 57.1989C10.9486 55.6435 9.35095 53.8879 7.9692 51.9811C7.94879 51.9528 7.94199 51.9218 7.94905 51.8885C7.95861 51.8434 7.98805 51.8264 7.99786 51.8208L13.7455 48.4935L13.7478 48.4772C18.2877 54.4459 25.4521 58.3055 33.5 58.3055C41.5459 58.3055 48.7089 54.4479 53.2488 48.4817C53.2526 48.4896 53.2545 48.4938 53.2545 48.4938L59.002 51.8208C59.0117 51.8264 59.0413 51.8435 59.0508 51.8888C59.0579 51.922 59.0512 51.953 59.0308 51.9812C53.1072 60.1564 43.5631 65.037 33.5 65.037C27.4847 65.037 21.636 63.333 16.5864 60.1091C16.1297 59.8174 15.5229 59.9513 15.2311 60.4081C14.9394 60.865 15.0733 61.4719 15.5301 61.7634C20.8958 65.1892 27.1096 66.9999 33.5 66.9999C38.8773 66.9999 44.2234 65.6917 48.9604 63.2165C53.5436 60.8218 57.5756 57.335 60.6203 53.1329C60.9652 52.6569 61.093 52.0549 60.971 51.4808C60.8496 50.9097 60.4905 50.4145 59.9857 50.1221L58.1438 49.056C58.5683 48.3849 58.9662 47.6957 59.3343 46.9936L61.174 48.0585C61.4911 48.242 61.8486 48.3358 62.2082 48.3358C62.4218 48.3358 62.6362 48.3027 62.8433 48.2356C63.4002 48.0551 63.8566 47.6445 64.0954 47.1092C66.0226 42.7878 67 38.1805 67 33.415C67 25.0516 63.9145 17.0382 58.3116 10.8509ZM34.6864 6.16705V8.55366C34.2931 8.53508 33.8977 8.52461 33.5 8.52461C33.1039 8.52461 32.7084 8.53718 32.3135 8.55615V6.16705C33.1027 6.13329 33.8973 6.13329 34.6864 6.16705ZM10.5568 48.0715C10.1306 47.4019 9.7328 46.7124 9.36665 46.0089L11.4321 44.8132C11.7972 45.5208 12.195 46.2087 12.6239 46.8749L10.5568 48.0715ZM33.5 56.3426C20.892 56.3426 10.6345 46.0573 10.6345 33.415C10.6345 26.5315 13.6793 20.0732 18.9878 15.6964C19.4061 15.3514 19.4656 14.733 19.1208 14.3146C18.7761 13.8967 18.1574 13.8371 17.7392 14.1817C11.9766 18.9329 8.67179 25.9432 8.67179 33.415C8.67179 36.8213 9.35854 40.0697 10.5995 43.0292L4.84311 46.3595C4.83355 46.365 4.80476 46.3816 4.7621 46.3681C4.7324 46.3584 4.71068 46.3387 4.69759 46.3092C2.88296 42.2416 1.96289 37.9033 1.96289 33.415C1.96289 17.1471 14.1167 3.62576 30.2337 1.96332C30.2654 1.95979 30.2928 1.96895 30.3159 1.99002C30.339 2.01069 30.3506 2.03713 30.3506 2.06853V8.72692C27.3316 9.11361 24.3957 10.0515 21.724 11.497C21.2472 11.755 21.0698 12.3504 21.3279 12.8273C21.5858 13.3039 22.1813 13.4812 22.658 13.2234C25.9663 11.4335 29.7154 10.4875 33.5 10.4875C46.1082 10.4875 56.3655 20.7728 56.3655 33.415C56.3655 46.0573 46.1082 56.3426 33.5 56.3426ZM56.4431 48.0714L54.376 46.8748C54.8048 46.2086 55.2026 45.5207 55.5677 44.8131L57.6332 46.0086C57.2673 46.712 56.8694 47.4015 56.4431 48.0714ZM62.3025 46.3093C62.2893 46.3388 62.2677 46.3584 62.238 46.3681C62.1959 46.3817 62.1666 46.3651 62.1572 46.3595L56.4063 43.0305C56.4063 43.0305 56.4017 43.0325 56.3988 43.0337C57.6409 40.073 58.3283 36.823 58.3283 33.4149C58.3283 20.7596 48.8583 10.28 36.6493 8.72378V2.06853C36.6493 2.03726 36.6609 2.01082 36.6839 1.99002C36.7074 1.96895 36.7359 1.9594 36.7663 1.96332V1.96319C52.8818 3.62707 65.0371 17.148 65.0371 33.415C65.0371 37.9032 64.1172 42.2414 62.3025 46.3093Z" fill="#4A67FF" stroke="#4A67FF" />
            //             </g>
            //         </svg>,
            //         title: <>Expansion Pack -<br /> ESG</>,
            //         points: [
            //             <><b>Aimed at: </b> any company needing to demonstrate that they are well-prepared and score highly on an ESG</>,
            //             '4 main sections - Sustainability Governance, Environmental, Social, Governance',
            //             'Completeness and risk scoring',
            //             'Automated reporting - including risks and recommendations',
            //             'Tailored to business objectives',
            //             <><b>Benefit: </b> Working though these questions will strengthen the business, identify weaknesses, and giving you an opportunity to plug them prior to being subject to due diligence if you have stressed your ESG credentials</>,
            //         ],
            //         image: require('../../../../images/landingpage/banner22.png'),
            //         imageStyle: { height: '90%', width: '94%' }
            //     },
            //     howItWorks: {
            //         subTitle: <span className='c3'>ESG</span>,
            //         stepImage: require('../../../../images/step-modal-img.png'),
            //         arrayImages: [require('../../../../images/advisor-dashboard/esg-step-1.png'), require('../../../../images/advisor-dashboard/esg-step-2.png'), require('../../../../images/advisor-dashboard/esg-step-3.png')],
            //         bottomSection: <>Iteratively prove and improve your company’s functional competence</>,
            //         // btnContent: <span className="new-shadow bg4 bg3-hover c1 td250 br30px p1rem fw600 cp ttu bsbb tac df jcc aic w250px">Let’s Go!</span>,
            //     }
            // },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Expansion Pack -",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "SME Cybersecurity"
                    ]
                }),
                isStar: false,
                isLorem: false,
                isNil: false,
                isReport: true,
                isLock: true,
                isHoverList: true,
                isPartnerModule: true,
                isCompletenessRisk: false,
                boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Includes post-completion ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " 30-minute video consultation"
                    ]
                }),
                isWfReport: true,
                sectionList: [
                    'User Access Control',
                    'System Updates and Patches',
                    'Malware Protection',
                    'Firewall and Network Security',
                    'Data Security',
                    'Physical Security',
                    'Incident Response',
                    'Compliance',
                    'Employee Training',
                    'Third Party Security'
                ],
                isTitleIcon: (parcelRequire("kMt1I")),
                seeMoreSection: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("dF4Ki")),
                        alt: ""
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Partner Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Cybersecurity"
                        ]
                    }),
                    points: [
                        "An expansion pack for diligencing your organisation\u2019s cybersecurity protection and preparedness",
                        "Bespoked to each company\u2019s outline platform architecture",
                        'Reporting, completeness and risk scores',
                        'Risk analysis and recommendations',
                        'Includes a 30 minute video call with our cyber security partner to analyze your report'
                    ],
                    isStoryVideo: true,
                    image: (parcelRequire("4IKT1")),
                    imageStyle: {
                        height: '100%',
                        width: '100%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Cybersecurity"
                    }),
                    isStoryVideo: true,
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("a5jEe")),
                        (parcelRequire("5GyoP")),
                        (parcelRequire("hKcfB"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("jalLz")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            }
        ],
        healthboost: [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Enhancing Your Business Plan"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Executive Summary Review',
                    'Exit Strategy Evaluation',
                    'Company Description Evaluation',
                    'Market Analysis Verification',
                    'Organization and Management Structure Assessment',
                    'Service or Product Line Examination',
                    'Marketing and Sales Strategy Inspection',
                    'Funding Request and Financial Projections Check',
                    'SWOT Analysis Update',
                    'Implementation Strategy Review'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Long Term Growth Planning"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Financial Health Assessment',
                    'Strategic Partnerships and Alliances',
                    'Market Analysis and Positioning',
                    'Product/Service Innovation and Development',
                    'Human Resources and Talent Management',
                    'Operational Efficiency and Infrastructure',
                    'Customer Relationship and Retention Strategies',
                    'Risk Management and Mitigation',
                    'Regulatory Compliance and Legal Considerations',
                    'Sustainability and Corporate Social Responsibility'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Improving Your KPIs"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Financial Performance Metrics',
                    'Strategic Alignment Metrics',
                    'Customer Metrics',
                    'Process Metrics',
                    'People Metrics',
                    'Market Metrics',
                    'Operational Efficiency Metrics',
                    'Innovation and Growth Metrics',
                    'Risk and Compliance Metrics',
                    'Sustainability Metrics'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Mitigating Your Key Risks"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Financial Risk Assessment',
                    'Reputation and Brand Risk Evaluation',
                    'Operational Risk Evaluation',
                    'Legal and Compliance Risk Identification',
                    'Market and Competitive Risk Analysis',
                    'Technological Risk Assessment',
                    'Human Resource Risk Evaluation',
                    'Supply Chain and Logistics Risk Identification',
                    'Environmental and Sustainability Risk Analysis',
                    'Strategic and Governance Risk Assessment'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Improving Compliance"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Regulatory Compliance',
                    'Industry-Specific Compliance',
                    'Tax Compliance',
                    'Legal Compliance',
                    'Product Standards Compliance',
                    'Financial Reporting Compliance',
                    'Data Protection Compliance',
                    'Employment Law Compliance',
                    'Environmental Compliance',
                    'Health and Safety Compliance'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Building New Funding Relationships"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Understanding the Company`s Financial Position',
                    'Evaluating Exit Strategies',
                    'Identifying Potential Investors',
                    'Preparing for Initial Investor Meetings',
                    'Presenting Investment Proposals',
                    'Negotiating Investment Terms',
                    'Managing Due Diligence Process',
                    'Finalizing Investment Agreements',
                    'Maintaining Investor Relationships',
                    'Planning for Future Funding Rounds'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Improving Your Existing Funding Terms"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Understanding Your Current Funding Structure',
                    'Monitoring and Reviewing Funding Terms',
                    'Evaluating Shareholder Agreements',
                    'Assessing Bank Loan Terms',
                    'Reviewing Angel/VC Investor Agreements',
                    'Identifying Opportunities for Improvement',
                    'Negotiating Better Terms with Shareholders',
                    'Negotiating Better Terms with Banks',
                    'Negotiating Better Terms with Angel/VC Investors',
                    'Implementing Changes to Funding Terms'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Increasing Your Revenues"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Understanding Your Market',
                    'Performance Monitoring and Improvement',
                    'Pricing Strategies',
                    'Sales and Marketing Tactics',
                    'Customer Retention Strategies',
                    'New Revenue Streams',
                    'Cost Management',
                    'Partnerships and Collaborations',
                    'Investment Opportunities',
                    'Financial Planning and Forecasting'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Driving Your Margins & Profit"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Revenue Management',
                    'Performance Monitoring and Improvement',
                    'Cost Control and Reduction',
                    'Cash Flow Optimization',
                    'Pricing Strategy',
                    'Operational Efficiency',
                    'Financial Planning and Forecasting',
                    'Profit Maximization Strategies',
                    'Risk Management',
                    'Investment and Capital Management'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Improving Your Cashflow"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Revenue Management',
                    'Cash Reserve and Emergency Fund Management',
                    'Cost Control and Reduction',
                    'Cash Flow Forecasting',
                    'Debt Management',
                    'Inventory Management',
                    'Supplier and Vendor Negotiations',
                    'Customer Payment Terms',
                    'Capital Expenditure and Investment',
                    'Tax Planning'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Boosting Outsourcing Efficiency"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Understanding the Business Needs',
                    'Monitoring and Evaluating the Outsourcing Relationship Performance',
                    'Identifying Potential Outsourcing Partners',
                    'Evaluating the Expertise of Outsourcing Partners',
                    'Assessing the Financial Stability of Outsourcing Partners',
                    'Reviewing the Legal and Compliance Aspects',
                    'Analyzing the Communication and Collaboration Methods',
                    'Evaluating the Risk Management Strategies of Outsourcing Partners',
                    'Assessing the Quality Control Measures of Outsourcing Partners',
                    'Reviewing the Outsourcing Partner`s Technology and Infrastructure'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Strengthening Your Controls"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Financial Reporting and Transparency',
                    'Corporate Governance and Ethics',
                    'Operational Efficiency and Effectiveness',
                    'Compliance with Laws and Regulations',
                    'Safeguarding of Assets',
                    'Fraud Detection and Prevention',
                    'Information Systems Security and Control',
                    'Human Resources Management and Control',
                    'Risk Management and Assessment',
                    'Business Continuity Planning'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Optimising Your Taxation"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Understanding the Company`s Current Tax Position',
                    'Implementation of Tax Optimization Measures',
                    'Compliance with Tax Laws and Regulations',
                    'Identification and Utilization of Tax Deductions and Credits',
                    'Effective Tax Planning Strategies',
                    'Review of Financial Statements for Tax Purposes',
                    'Management of Tax Liabilities',
                    'Tax Implications of Business Operations',
                    'Tax Considerations for Business Expansion',
                    'Assessment of Potential Tax Risks'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Enhancing Your Social Media - B2B Businesses"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Social Media Strategy',
                    'Employee Advocacy on Social Media',
                    'LinkedIn Presence',
                    'Facebook Presence',
                    'Content Creation and Curation',
                    'Audience Engagement',
                    'Brand Consistency',
                    'Social Media Analytics',
                    'Social Media Advertising',
                    'Crisis Management on Social Media'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "H - Enhancing Your Social Media - B2C Businesses"
                }),
                isCompleteness: true,
                isRisk: true,
                isReport: true,
                isWfReport: true,
                isLock: true,
                isHoverList: true,
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/10006095-healthboost-modules',
                sectionList: [
                    'Understanding Your Target Audience',
                    'Exploring Emerging Social Media Platforms',
                    'Optimizing Social Media Profiles',
                    'Content Creation and Posting Strategy',
                    'Engagement and Interaction with Followers',
                    'Utilizing Paid Advertising Opportunities',
                    'Monitoring and Responding to Customer Reviews',
                    'Leveraging Influencer Marketing',
                    'Analyzing and Adapting to Social Media Metrics',
                    'Ensuring Compliance with Social Media Policies'
                ],
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("388WO")),
                            alt: "health-boost"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("8iglb")),
                        (parcelRequire("3pvfN")),
                        (parcelRequire("dqkvX"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9o8tm")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            }
        ],
        yourAnyCheckList: [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Checklist for your ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " ",
                        user['role'] == 'Investor' ? "fund\u2019s" : "firm\u2019s",
                        " internal use ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " only"
                    ]
                }),
                isCompleteness: true,
                isRisk: true,
                aiText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Generic | Manual"
                }),
                status: 'Incomplete',
                isReport: true,
                isWfReport: true,
                buttonText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "To Complete"
                }),
                isActiveButton: true,
                isTitleIcon: (parcelRequire("aZ77G"))
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "For use across all ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " your ",
                        user['role'] == 'Investor' ? 'portfolio' : 'clients',
                        " companies"
                    ]
                }),
                isCompleteness: true,
                isRisk: true,
                aiText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Generic | AI Generated"
                }),
                status: 'Not activated',
                isReport: true,
                isWfReport: true,
                buttonText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Activate"
                }),
                isActiveButton: true,
                isTitleIcon: (parcelRequire("aZ77G"))
            },
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Bespoked to a ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " single ",
                        user['role'] == 'Investor' ? 'portfolio' : 'client',
                        " company"
                    ]
                }),
                isCompleteness: true,
                isRisk: true,
                aiText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Bespoked  | AI Generated"
                }),
                status: 'Activated',
                isReport: true,
                isWfReport: true,
                buttonText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Deactivate"
                }),
                isActiveButton: true,
                isTitleIcon: (parcelRequire("aZ77G"))
            }
        ]
    };
    const moduleTooltip = (sections)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "module-tooltip-box",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "hover-list",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("9gCOW")),
                        className: "pa",
                        alt: "list-img"
                    })
                }),
                sections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "tooltip-area",
                    children: sections.map((section, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "overlay-box tal w100 tac cp c3-hover",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: section
                            })
                        }, idx);
                    })
                })
            ]
        });
    };
    const handleSeeMorePopup = async (item)=>{
        await setSelectedFeature(item);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const handleHowItWorks = async (item)=>{
        await setSelectedHowItWorks(item);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'howItWorksModal'
        }));
    };
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedFeature({});
        setSelectedHowItWorks({});
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "dashboard-tools-area",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "box-dashbord-container mla mra ",
                        children: (FREE_TOOLS?.['portfolioProAdvisor'] || FREE_TOOLS?.['portfolioProInvestor']) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bss p2rem br25px w100 keyfeature-box keyfeature-box-portfolio df fww mb3rem pr bsbb gg1-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "keyfeature-box-portfolio-innner pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs1rem c15 fw500 ml1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c7",
                                                children: "FREE"
                                            }),
                                            " - Porfolio Pro"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `keyfeature-box-portfolio-bg w100 df fww pr bsbb`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w100 df fww pt1rem",
                                            children: FREE_TOOLS[user["role"] == "Advisor" ? 'portfolioProAdvisor' : 'portfolioProInvestor'].map((item)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df fw500 fs1-25rem c15 aifs",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "icon-diligenstia mr1rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w40px h40px",
                                                                            src: item?.['isTitleIcon'],
                                                                            alt: "logo image"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "fs1rem fw500 c15 lh2 title-box-feature",
                                                                        children: [
                                                                            item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                type: "button",
                                                                                onClick: ()=>document.getElementById('required-star').scrollIntoView({
                                                                                        behavior: "smooth"
                                                                                    }),
                                                                                className: "cp bg1 icon",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                    src: (parcelRequire("dlp4j")),
                                                                                    alt: "star-img"
                                                                                })
                                                                            }),
                                                                            item?.title
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "right-info-hyper-icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    onClick: ()=>handleSeeMorePopup(item),
                                                                    onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                                                ...st,
                                                                                seeMoreTooltip: false
                                                                            })),
                                                                    className: "info-icon  pr ml0-5rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "27",
                                                                            height: "27",
                                                                            viewBox: "0 0 27 27",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "13.5",
                                                                                    cy: "13.5",
                                                                                    r: "13.5",
                                                                                    transform: "matrix(1 0 0 -1 0 27)",
                                                                                    fill: "#59B8FD"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                                    fill: "white"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: `overlay-box ${isShowTooltip['seeMoreTooltip'] && item['showSeeMoreTooltip'] && ' show-tooltip'}`,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "What is it?",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['howItWorks'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "hover-list-icon  pr cp ml0-5rem",
                                                                    onClick: ()=>handleHowItWorks(item),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "27",
                                                                            height: "27",
                                                                            viewBox: "0 0 27 27",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "13.5",
                                                                                    cy: "13.5",
                                                                                    r: "13.5",
                                                                                    fill: "#59B8FD"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "overlay-box",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "How does it work?",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['helpLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: item?.['helpLink'],
                                                                    target: "_blank",
                                                                    className: "questionmark-icon pr ml0-5rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "27",
                                                                            height: "27",
                                                                            viewBox: "0 0 27 27",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "13.5",
                                                                                    cy: "13.5",
                                                                                    r: "13.5",
                                                                                    fill: "#FC7785"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                                    fill: "white"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                                    fill: "white"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "overlay-box",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "Detailed help pages or ask our AI Assistants for help",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        item?.['sectionList'] && item?.['sectionList'].length > 0 && moduleTooltip(item?.['sectionList']),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df mt2rem jcsb bottom-details w90",
                                                            children: [
                                                                item?.['boxBottomText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: `df mb1rem ${item?.['isWf'] ? 'w70' : 'w90'}`,
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "fs1rem fw400 c28 lh2",
                                                                        children: item['boxBottomText']
                                                                    })
                                                                }),
                                                                item?.['isImage'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: item?.['isImage'],
                                                                    alt: "image"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df",
                                                                    children: [
                                                                        item?.['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                            className: "fs2rem c28 mr2rem fw500",
                                                                            children: [
                                                                                "0% ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                    children: "Module Complete"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        item?.['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                            className: "fs2rem c28 fw500",
                                                                            children: [
                                                                                "0% ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                    children: "Risk Complete"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['isLorem'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                        className: "fs2rem c28 fw500",
                                                                        children: [
                                                                            "Lorem ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem fw400 lh1",
                                                                                children: "Lorem ipsum dolor"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                item?.['isNil'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                        className: "fs2rem c28 fw500",
                                                                        children: [
                                                                            "NIL ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem fw400 lh1",
                                                                                children: "Not yet certified"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                item?.['isLock'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "lock-icon mr1rem mb0-5rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "68",
                                                                        height: "84",
                                                                        viewBox: "0 0 68 84",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M64.0326 35.8503C61.8786 33.697 59.0152 32.5118 55.9702 32.5118H55.1452V21.179C55.1452 9.60292 45.7279 0.185547 34.1524 0.185547H33.3763C21.8008 0.185547 12.3828 9.60292 12.3828 21.179V32.5111H11.5577C8.51281 32.5111 5.64937 33.697 3.49544 35.8503C1.34219 38.0042 0.15625 40.8677 0.15625 43.9133V72.4115C0.15625 75.4572 1.34219 78.3206 3.49544 80.4732C5.64869 82.6271 8.51213 83.813 11.5577 83.813H55.9702C59.0159 83.813 61.8793 82.6271 64.0332 80.4732C66.1865 78.3199 67.3724 75.4565 67.3724 72.4115V43.9133C67.3724 40.8684 66.1865 38.0049 64.0326 35.8503ZM17.8827 21.179C17.8827 12.6362 24.8327 5.68555 33.3763 5.68555H34.1524C42.6953 5.68555 49.6452 12.6362 49.6452 21.179V32.5111H17.8827V21.179ZM61.8724 72.4115C61.8724 73.9646 61.242 75.4854 60.1441 76.584C59.0289 77.6991 57.5467 78.313 55.9702 78.313H11.5577C9.98131 78.313 8.49975 77.6991 7.38394 76.5833C6.2695 75.4695 5.65556 73.988 5.65556 72.4115V43.9133C5.65556 42.3369 6.2695 40.8539 7.38394 39.7395C8.49906 38.625 9.98063 38.0111 11.5571 38.0111H55.9696C57.546 38.0111 59.0282 38.625 60.1427 39.7388C61.2578 40.8546 61.8717 42.3369 61.8717 43.9133L61.8724 72.4115Z",
                                                                                fill: "#F2F3F4"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                                                                fill: "#E8E8E8"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                item?.['isWf'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "lock-icon wf-report mr1rem mb0-5rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "69",
                                                                        height: "69",
                                                                        viewBox: "0 0 69 69",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                opacity: "0.6",
                                                                                cx: "34.5",
                                                                                cy: "34.5",
                                                                                r: "34.5",
                                                                                fill: "#AAACB5"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M21.9253 42.7148L17.4097 26.7148H20.5269L23.4097 38.4727H23.5581L26.6362 26.7148H29.4722L32.5581 38.4805H32.6987L35.5816 26.7148H38.6987L34.1831 42.7148H31.3237L28.1206 31.4883H27.9956L24.7847 42.7148H21.9253ZM40.7085 42.7148V26.7148H50.9585V29.1445H43.6069V33.4883H50.2554V35.918H43.6069V42.7148H40.7085Z",
                                                                                fill: "white"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "report-bottom-area",
                                                            children: [
                                                                item?.['isReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "report-btn pr",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "35",
                                                                            height: "35",
                                                                            viewBox: "0 0 35 35",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "17.5",
                                                                                    cy: "17.5",
                                                                                    r: "17.5",
                                                                                    fill: "#AAACB5"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "overlay-box",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "Module Report",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['isWfReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "report-btn ml1rem pr",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "35",
                                                                            height: "35",
                                                                            viewBox: "0 0 35 35",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "17.5",
                                                                                    cy: "17.5",
                                                                                    r: "17.5",
                                                                                    fill: "#AAACB5"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M8.3544 23L5.07031 11.3636H7.33736L9.43395 19.9148H9.5419L11.7805 11.3636H13.843L16.0874 19.9205H16.1896L18.2862 11.3636H20.5533L17.2692 23H15.1896L12.8601 14.8352H12.7692L10.4339 23H8.3544ZM22.0149 23V11.3636H29.4695V13.1307H24.1229V16.2898H28.9581V18.0568H24.1229V23H22.0149Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "overlay-box",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "Workflow Report",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "box-dashbord-container mla mra mb6rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c15 fs2rem tac mb0-5rem fw500",
                                children: "Diligentsia Pro PLUS - Work With Each Client"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs1rem fw500 c3 tac mb2rem",
                                children: [
                                    "FOR INFORMATION ONLY \u2013 you can access these modules tools via each ",
                                    user['role'] == 'Investor' ? 'portfolio ' : 'client ',
                                    " dashboards"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `bg20 bss bo3 bw2px br50px p2rem bsbb keyfeature-box-core-dashboard ${user['role'] == 'Advisor' ? 'advisor-bg' : 'investor-bg'}`,
                                children: [
                                    FREE_TOOLS?.['coreModulesPro'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg20 bss bo5 bsbb p2rem br25px w100 keyfeature-box keyfeature-box-core-pro df fww mb2rem pr bsbb gg1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "fs1-25rem c15 w100 pl1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c7",
                                                        children: "PRO"
                                                    }),
                                                    " - Core Modules"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs1rem mb4rem w100 c15 mt0-5rem df aic ml1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon mr1rem pr",
                                                        style: {
                                                            top: '4px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("912EB")),
                                                            alt: "TODOO"
                                                        })
                                                    }),
                                                    "Requires subscription Diligentsia Pro by EITHER  your client or you on behalf of your client"
                                                ]
                                            }),
                                            FREE_TOOLS?.['coreModulesPro'].map((item)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df fw500 fs1-25rem c15 aic",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "icon-diligenstia mr1rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w40px h40px",
                                                                            src: item?.['isTitleIcon'],
                                                                            alt: "logo image"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "fs1rem fw500 c15 lh2 title-box-feature",
                                                                        children: [
                                                                            item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                onClick: ()=>document.getElementById('required-star').scrollIntoView({
                                                                                        behavior: "smooth"
                                                                                    }),
                                                                                className: "cp bg1 icon",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                    src: (parcelRequire("dlp4j")),
                                                                                    alt: "star-img"
                                                                                })
                                                                            }),
                                                                            item?.title
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "right-info-hyper-icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    onClick: ()=>handleSeeMorePopup(item),
                                                                    onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                                                ...st,
                                                                                seeMoreTooltip: false
                                                                            })),
                                                                    className: "info-icon  pr ml0-5rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "27",
                                                                            height: "27",
                                                                            viewBox: "0 0 27 27",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "13.5",
                                                                                    cy: "13.5",
                                                                                    r: "13.5",
                                                                                    transform: "matrix(1 0 0 -1 0 27)",
                                                                                    fill: "#59B8FD"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                                    fill: "white"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: `overlay-box ${isShowTooltip['seeMoreTooltip'] && item['showSeeMoreTooltip'] && ' show-tooltip'}`,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "What is it?",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['howItWorks'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "hover-list-icon  pr cp ml0-5rem",
                                                                    onClick: ()=>handleHowItWorks(item),
                                                                    onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                                                ...st,
                                                                                howToTooltip: false
                                                                            })),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "27",
                                                                            height: "27",
                                                                            viewBox: "0 0 27 27",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "13.5",
                                                                                    cy: "13.5",
                                                                                    r: "13.5",
                                                                                    fill: "#59B8FD"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: `overlay-box ${isShowTooltip['howToTooltip'] && item['showHowToTooltip'] && ' show-tooltip'}`,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "How does it work?",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['helpLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: item?.['helpLink'],
                                                                    target: "_blank",
                                                                    className: "questionmark-icon pr ml0-5rem",
                                                                    onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                                                ...st,
                                                                                helpTooltip: false
                                                                            })),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "27",
                                                                            height: "27",
                                                                            viewBox: "0 0 27 27",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "13.5",
                                                                                    cy: "13.5",
                                                                                    r: "13.5",
                                                                                    fill: "#FC7785"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                                    fill: "white"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                                    fill: "white"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: `overlay-box ${isShowTooltip['helpTooltip'] && item['showHelpTooltip'] && ' show-tooltip'}`,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "Detailed help pages or ask our AI Assistants for help",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        item?.['sectionList'] && item?.['sectionList'].length > 0 && moduleTooltip(item?.['sectionList']),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df mt2rem jcsb bottom-details w90",
                                                            children: [
                                                                item?.['boxBottomText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df mb1rem w70",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "fs1rem fw400 c28 lh2",
                                                                        children: item['boxBottomText']
                                                                    })
                                                                }),
                                                                item?.['isImage'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: item?.['isImage'],
                                                                    alt: "image"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df",
                                                                    children: [
                                                                        item?.['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                            className: "fs2rem c28 mr2rem fw500",
                                                                            children: [
                                                                                "0% ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                    children: "Module Complete"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        item?.['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                            className: "fs2rem c28 fw500",
                                                                            children: [
                                                                                "0% ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                    children: "Module Risk"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['isLorem'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                        className: "fs2rem c28 fw500",
                                                                        children: [
                                                                            "Lorem ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem fw400 lh1",
                                                                                children: "Lorem ipsum dolor"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                item?.['isNil'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                        className: "fs2rem c28 fw500",
                                                                        children: [
                                                                            "NIL ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem fw400 lh1",
                                                                                children: "Not yet certified"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                item?.['isLock'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "lock-icon mr1rem mb0-5rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "68",
                                                                        height: "84",
                                                                        viewBox: "0 0 68 84",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M64.0326 35.8503C61.8786 33.697 59.0152 32.5118 55.9702 32.5118H55.1452V21.179C55.1452 9.60292 45.7279 0.185547 34.1524 0.185547H33.3763C21.8008 0.185547 12.3828 9.60292 12.3828 21.179V32.5111H11.5577C8.51281 32.5111 5.64937 33.697 3.49544 35.8503C1.34219 38.0042 0.15625 40.8677 0.15625 43.9133V72.4115C0.15625 75.4572 1.34219 78.3206 3.49544 80.4732C5.64869 82.6271 8.51213 83.813 11.5577 83.813H55.9702C59.0159 83.813 61.8793 82.6271 64.0332 80.4732C66.1865 78.3199 67.3724 75.4565 67.3724 72.4115V43.9133C67.3724 40.8684 66.1865 38.0049 64.0326 35.8503ZM17.8827 21.179C17.8827 12.6362 24.8327 5.68555 33.3763 5.68555H34.1524C42.6953 5.68555 49.6452 12.6362 49.6452 21.179V32.5111H17.8827V21.179ZM61.8724 72.4115C61.8724 73.9646 61.242 75.4854 60.1441 76.584C59.0289 77.6991 57.5467 78.313 55.9702 78.313H11.5577C9.98131 78.313 8.49975 77.6991 7.38394 76.5833C6.2695 75.4695 5.65556 73.988 5.65556 72.4115V43.9133C5.65556 42.3369 6.2695 40.8539 7.38394 39.7395C8.49906 38.625 9.98063 38.0111 11.5571 38.0111H55.9696C57.546 38.0111 59.0282 38.625 60.1427 39.7388C61.2578 40.8546 61.8717 42.3369 61.8717 43.9133L61.8724 72.4115Z",
                                                                                fill: "#F2F3F4"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                                                                fill: "#E8E8E8"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "report-bottom-area",
                                                            children: [
                                                                item?.['isReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "report-btn pr",
                                                                    onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                                                ...st,
                                                                                reportTooltip: false
                                                                            })),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "35",
                                                                            height: "35",
                                                                            viewBox: "0 0 35 35",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "17.5",
                                                                                    cy: "17.5",
                                                                                    r: "17.5",
                                                                                    fill: "#AAACB5"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: `overlay-box ${isShowTooltip['reportTooltip'] && item['showReportTooltip'] && ' show-tooltip'}`,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "Module Report",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                item?.['isWfReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "report-btn ml1rem pr",
                                                                    onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                                                ...st,
                                                                                workflowReportTooltip: false
                                                                            })),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "35",
                                                                            height: "35",
                                                                            viewBox: "0 0 35 35",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                    cx: "17.5",
                                                                                    cy: "17.5",
                                                                                    r: "17.5",
                                                                                    fill: "#AAACB5"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M8.3544 23L5.07031 11.3636H7.33736L9.43395 19.9148H9.5419L11.7805 11.3636H13.843L16.0874 19.9205H16.1896L18.2862 11.3636H20.5533L17.2692 23H15.1896L12.8601 14.8352H12.7692L10.4339 23H8.3544ZM22.0149 23V11.3636H29.4695V13.1307H24.1229V16.2898H28.9581V18.0568H24.1229V23H22.0149Z",
                                                                                    fill: "white"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: `overlay-box ${isShowTooltip['workflowReportTooltip'] && item['showWorkflowReportTooltip'] && ' show-tooltip'}`,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "c15 df aic",
                                                                                children: [
                                                                                    "Workflow Report",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon ml0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            width: "12",
                                                                                            height: "14",
                                                                                            viewBox: "0 0 12 14",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                fill: "#505050"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                            })
                                        ]
                                    }),
                                    (FREE_TOOLS?.['appStoreInvestment'] || FREE_TOOLS?.['appStoreGrowth']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg20 bss bsbb bo5 p2rem br25px w100 keyfeature-box keyfeature-box-core df fww keyfeature-box-two keyfeature-box-appstore pr bsbb gg1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcsb w100 aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "left-area",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                            className: "fs1-25rem c15 w100  pl1rem",
                                                            children: [
                                                                "Diligentsia ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c4",
                                                                    children: "AppStore"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs1rem mb1-5rem w100 c15 mt0-5rem df aic ml1rem",
                                                            children: "Requires Pro subscription"
                                                        })
                                                    ]
                                                })
                                            }),
                                            FREE_TOOLS?.['appStoreInvestment'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w100",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                        className: "accordian-dashboard-main",
                                                        expanded: expanded['investmentPanel'],
                                                        onChange: ()=>setExpanded({
                                                                ...expanded,
                                                                investmentPanel: !expanded['investmentPanel']
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs1-25rem c15 fw600 ml1rem db",
                                                                        children: "Investment Ready"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df fww w100 accordian-dashboard-keyfeature",
                                                                    children: FREE_TOOLS?.['appStoreInvestment'].map((item)=>{
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "df fw500 fs1-25rem c15 aic",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df aic",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                className: "icon-diligenstia mr1rem",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                    className: "w40px h40px",
                                                                                                    src: item?.['isTitleIcon'],
                                                                                                    alt: "logo image"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                className: "fs1rem fw500 c15 lh2 title-box-feature",
                                                                                                children: [
                                                                                                    item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                        onClick: ()=>document.getElementById('required-star').scrollIntoView({
                                                                                                                behavior: "smooth"
                                                                                                            }),
                                                                                                        className: "cp bg1 icon",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                            src: (parcelRequire("dlp4j")),
                                                                                                            alt: "star-img"
                                                                                                        })
                                                                                                    }),
                                                                                                    item?.title
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                item?.['sectionList'] && item?.['sectionList'].length > 0 && moduleTooltip(item?.['sectionList']),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "right-info-hyper-icon",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            onClick: ()=>handleSeeMorePopup(item),
                                                                                            className: "info-icon  pr ml0-5rem",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "27",
                                                                                                    height: "27",
                                                                                                    viewBox: "0 0 27 27",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "13.5",
                                                                                                            cy: "13.5",
                                                                                                            r: "13.5",
                                                                                                            transform: "matrix(1 0 0 -1 0 27)",
                                                                                                            fill: "#59B8FD"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                                                            fill: "white"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "What is it?",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['howItWorks'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "hover-list-icon  pr cp ml0-5rem",
                                                                                            onClick: ()=>handleHowItWorks(item),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "27",
                                                                                                    height: "27",
                                                                                                    viewBox: "0 0 27 27",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "13.5",
                                                                                                            cy: "13.5",
                                                                                                            r: "13.5",
                                                                                                            fill: "#59B8FD"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "How does it work?",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['helpLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                                            href: item?.['helpLink'],
                                                                                            target: "_blank",
                                                                                            className: "questionmark-icon pr ml0-5rem",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "27",
                                                                                                    height: "27",
                                                                                                    viewBox: "0 0 27 27",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "13.5",
                                                                                                            cy: "13.5",
                                                                                                            r: "13.5",
                                                                                                            fill: "#FC7785"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                                                            fill: "white"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                                                            fill: "white"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "Detailed help pages or ask our AI Assistants for help",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "df mt2rem jcsb bottom-details w90",
                                                                                    children: [
                                                                                        item?.['boxBottomText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "df mb1rem w70",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "fs1rem fw400 c28 lh2",
                                                                                                children: item['boxBottomText']
                                                                                            })
                                                                                        }),
                                                                                        item?.['isImage'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                            src: item?.['isImage'],
                                                                                            alt: "image"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df",
                                                                                            children: [
                                                                                                item?.['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                    className: "fs2rem c28 mr2rem fw500",
                                                                                                    children: [
                                                                                                        "0% ",
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                            className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                            children: "Module Complete"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                item?.['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                    className: "fs2rem c28 fw500",
                                                                                                    children: [
                                                                                                        "0% ",
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                            className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                            children: "Module Complete"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['isLorem'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "df",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                className: "fs2rem c28 fw500",
                                                                                                children: [
                                                                                                    "Lorem ",
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "fs0-75rem fw400 lh1",
                                                                                                        children: "Lorem ipsum dolor"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        item?.['isNil'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "df",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                className: "fs2rem c28 fw500",
                                                                                                children: [
                                                                                                    "NIL ",
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "fs0-75rem fw400 lh1",
                                                                                                        children: "Not yet certified"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        item?.['isLock'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "lock-icon mr1rem mb0-5rem",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                width: "68",
                                                                                                height: "84",
                                                                                                viewBox: "0 0 68 84",
                                                                                                fill: "none",
                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M64.0326 35.8503C61.8786 33.697 59.0152 32.5118 55.9702 32.5118H55.1452V21.179C55.1452 9.60292 45.7279 0.185547 34.1524 0.185547H33.3763C21.8008 0.185547 12.3828 9.60292 12.3828 21.179V32.5111H11.5577C8.51281 32.5111 5.64937 33.697 3.49544 35.8503C1.34219 38.0042 0.15625 40.8677 0.15625 43.9133V72.4115C0.15625 75.4572 1.34219 78.3206 3.49544 80.4732C5.64869 82.6271 8.51213 83.813 11.5577 83.813H55.9702C59.0159 83.813 61.8793 82.6271 64.0332 80.4732C66.1865 78.3199 67.3724 75.4565 67.3724 72.4115V43.9133C67.3724 40.8684 66.1865 38.0049 64.0326 35.8503ZM17.8827 21.179C17.8827 12.6362 24.8327 5.68555 33.3763 5.68555H34.1524C42.6953 5.68555 49.6452 12.6362 49.6452 21.179V32.5111H17.8827V21.179ZM61.8724 72.4115C61.8724 73.9646 61.242 75.4854 60.1441 76.584C59.0289 77.6991 57.5467 78.313 55.9702 78.313H11.5577C9.98131 78.313 8.49975 77.6991 7.38394 76.5833C6.2695 75.4695 5.65556 73.988 5.65556 72.4115V43.9133C5.65556 42.3369 6.2695 40.8539 7.38394 39.7395C8.49906 38.625 9.98063 38.0111 11.5571 38.0111H55.9696C57.546 38.0111 59.0282 38.625 60.1427 39.7388C61.2578 40.8546 61.8717 42.3369 61.8717 43.9133L61.8724 72.4115Z",
                                                                                                        fill: "#F2F3F4"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                                                                                        fill: "#E8E8E8"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "report-bottom-area",
                                                                                    children: [
                                                                                        item?.['isReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "report-btn pr",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "35",
                                                                                                    height: "35",
                                                                                                    viewBox: "0 0 35 35",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "17.5",
                                                                                                            cy: "17.5",
                                                                                                            r: "17.5",
                                                                                                            fill: "#AAACB5"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "Module Report",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['isWfReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "report-btn ml1rem pr",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "35",
                                                                                                    height: "35",
                                                                                                    viewBox: "0 0 35 35",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "17.5",
                                                                                                            cy: "17.5",
                                                                                                            r: "17.5",
                                                                                                            fill: "#AAACB5"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M8.3544 23L5.07031 11.3636H7.33736L9.43395 19.9148H9.5419L11.7805 11.3636H13.843L16.0874 19.9205H16.1896L18.2862 11.3636H20.5533L17.2692 23H15.1896L12.8601 14.8352H12.7692L10.4339 23H8.3544ZM22.0149 23V11.3636H29.4695V13.1307H24.1229V16.2898H28.9581V18.0568H24.1229V23H22.0149Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "Workflow Report",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        });
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            FREE_TOOLS?.['appStoreGrowth'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fww pr w100 keyfeature-box-three",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "mt1rem w100",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                        className: "accordian-dashboard-main",
                                                        expanded: expanded['growthPanel'],
                                                        onChange: ()=>setExpanded({
                                                                ...expanded,
                                                                growthPanel: !expanded['growthPanel']
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs1-25rem c15 fw600 ml1rem db",
                                                                        children: "Growth Ready"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df fww w100 accordian-dashboard-keyfeature",
                                                                        children: FREE_TOOLS?.['appStoreGrowth'].map((item)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df fw500 fs1-25rem c15 aic",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df aic",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                    className: "icon-diligenstia mr1rem",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                        className: "w40px h40px",
                                                                                                        src: item?.['isTitleIcon'],
                                                                                                        alt: "logo image"
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                    className: "fs1rem fw500 c15 lh2 title-box-feature",
                                                                                                    children: [
                                                                                                        item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                            onClick: ()=>document.getElementById('required-star').scrollIntoView({
                                                                                                                    behavior: "smooth"
                                                                                                                }),
                                                                                                            className: "cp bg1 icon",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                                src: (parcelRequire("dlp4j")),
                                                                                                                alt: "star-img"
                                                                                                            })
                                                                                                        }),
                                                                                                        item?.title
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    item['isPartnerModule'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        className: "pa",
                                                                                        style: {
                                                                                            top: '-13px',
                                                                                            left: '110px'
                                                                                        },
                                                                                        src: (parcelRequire("i4vA9"))
                                                                                    }),
                                                                                    item?.['sectionList'] && item?.['sectionList'].length > 0 && moduleTooltip(item?.['sectionList']),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "right-info-hyper-icon",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                onClick: ()=>handleSeeMorePopup(item),
                                                                                                className: "info-icon  pr ml0-5rem",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                        width: "27",
                                                                                                        height: "27",
                                                                                                        viewBox: "0 0 27 27",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                cx: "13.5",
                                                                                                                cy: "13.5",
                                                                                                                r: "13.5",
                                                                                                                transform: "matrix(1 0 0 -1 0 27)",
                                                                                                                fill: "#59B8FD"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                                                                fill: "white"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "overlay-box",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                            className: "c15 df aic",
                                                                                                            children: [
                                                                                                                "What is it?",
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                    className: "icon ml0-5rem",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                        width: "12",
                                                                                                                        height: "14",
                                                                                                                        viewBox: "0 0 12 14",
                                                                                                                        fill: "none",
                                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                            fill: "#505050"
                                                                                                                        })
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            item?.['howItWorks'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "hover-list-icon  pr cp ml0-5rem",
                                                                                                onClick: ()=>handleHowItWorks(item),
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                        width: "27",
                                                                                                        height: "27",
                                                                                                        viewBox: "0 0 27 27",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                cx: "13.5",
                                                                                                                cy: "13.5",
                                                                                                                r: "13.5",
                                                                                                                fill: "#59B8FD"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "overlay-box",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                            className: "c15 df aic",
                                                                                                            children: [
                                                                                                                "How does it work?",
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                    className: "icon",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                        width: "12",
                                                                                                                        height: "14",
                                                                                                                        viewBox: "0 0 12 14",
                                                                                                                        fill: "none",
                                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                            fill: "#505050"
                                                                                                                        })
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            item?.['helpLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                                                href: item?.['helpLink'],
                                                                                                target: "_blank",
                                                                                                className: "questionmark-icon pr ml0-5rem",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                        width: "27",
                                                                                                        height: "27",
                                                                                                        viewBox: "0 0 27 27",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                cx: "13.5",
                                                                                                                cy: "13.5",
                                                                                                                r: "13.5",
                                                                                                                fill: "#FC7785"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                                                                fill: "white"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                                                                fill: "white"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "overlay-box",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                            className: "c15 df aic",
                                                                                                            children: [
                                                                                                                "Detailed help pages or ask our AI Assistants for help",
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                    className: "icon ml0-5rem",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                        width: "12",
                                                                                                                        height: "14",
                                                                                                                        viewBox: "0 0 12 14",
                                                                                                                        fill: "none",
                                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                            fill: "#505050"
                                                                                                                        })
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df mt2rem jcsb bottom-details w90",
                                                                                        children: [
                                                                                            item?.['boxBottomText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                className: "df mb1rem w70",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                    className: "fs1rem fw400 c28 lh2",
                                                                                                    children: item['boxBottomText']
                                                                                                })
                                                                                            }),
                                                                                            item?.['isImage'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                src: item?.['isImage'],
                                                                                                alt: "image"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "df",
                                                                                                children: [
                                                                                                    item?.['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                        className: "fs2rem c28 mr2rem fw500",
                                                                                                        children: [
                                                                                                            "0% ",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                                children: "Module Complete"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    item?.['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                        className: "fs2rem c28 fw500",
                                                                                                        children: [
                                                                                                            "0% ",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                                children: "Risk Complete"
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            item?.['isLorem'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                className: "df",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                    className: "fs2rem c28 fw500",
                                                                                                    children: [
                                                                                                        "Lorem ",
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                            className: "fs0-75rem fw400 lh1",
                                                                                                            children: "Lorem ipsum dolor"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            item?.['isNil'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                className: "df",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                    className: "fs2rem c28 fw500",
                                                                                                    children: [
                                                                                                        "NIL ",
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                            className: "fs0-75rem fw400 lh1",
                                                                                                            children: "Not yet certified"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            item?.['isLock'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                className: "lock-icon mr1rem mb0-5rem",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "68",
                                                                                                    height: "84",
                                                                                                    viewBox: "0 0 68 84",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M64.0326 35.8503C61.8786 33.697 59.0152 32.5118 55.9702 32.5118H55.1452V21.179C55.1452 9.60292 45.7279 0.185547 34.1524 0.185547H33.3763C21.8008 0.185547 12.3828 9.60292 12.3828 21.179V32.5111H11.5577C8.51281 32.5111 5.64937 33.697 3.49544 35.8503C1.34219 38.0042 0.15625 40.8677 0.15625 43.9133V72.4115C0.15625 75.4572 1.34219 78.3206 3.49544 80.4732C5.64869 82.6271 8.51213 83.813 11.5577 83.813H55.9702C59.0159 83.813 61.8793 82.6271 64.0332 80.4732C66.1865 78.3199 67.3724 75.4565 67.3724 72.4115V43.9133C67.3724 40.8684 66.1865 38.0049 64.0326 35.8503ZM17.8827 21.179C17.8827 12.6362 24.8327 5.68555 33.3763 5.68555H34.1524C42.6953 5.68555 49.6452 12.6362 49.6452 21.179V32.5111H17.8827V21.179ZM61.8724 72.4115C61.8724 73.9646 61.242 75.4854 60.1441 76.584C59.0289 77.6991 57.5467 78.313 55.9702 78.313H11.5577C9.98131 78.313 8.49975 77.6991 7.38394 76.5833C6.2695 75.4695 5.65556 73.988 5.65556 72.4115V43.9133C5.65556 42.3369 6.2695 40.8539 7.38394 39.7395C8.49906 38.625 9.98063 38.0111 11.5571 38.0111H55.9696C57.546 38.0111 59.0282 38.625 60.1427 39.7388C61.2578 40.8546 61.8717 42.3369 61.8717 43.9133L61.8724 72.4115Z",
                                                                                                            fill: "#F2F3F4"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                                                                                            fill: "#E8E8E8"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "report-bottom-area",
                                                                                        children: [
                                                                                            item?.['isReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "report-btn pr",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                        width: "35",
                                                                                                        height: "35",
                                                                                                        viewBox: "0 0 35 35",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                cx: "17.5",
                                                                                                                cy: "17.5",
                                                                                                                r: "17.5",
                                                                                                                fill: "#AAACB5"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "overlay-box",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                            className: "c15 df aic",
                                                                                                            children: [
                                                                                                                "Module Report",
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                    className: "icon ml0-5rem",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                        width: "12",
                                                                                                                        height: "14",
                                                                                                                        viewBox: "0 0 12 14",
                                                                                                                        fill: "none",
                                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                            fill: "#505050"
                                                                                                                        })
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            item?.['isWfReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "report-btn ml1rem pr",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                        width: "35",
                                                                                                        height: "35",
                                                                                                        viewBox: "0 0 35 35",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                cx: "17.5",
                                                                                                                cy: "17.5",
                                                                                                                r: "17.5",
                                                                                                                fill: "#AAACB5"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M8.3544 23L5.07031 11.3636H7.33736L9.43395 19.9148H9.5419L11.7805 11.3636H13.843L16.0874 19.9205H16.1896L18.2862 11.3636H20.5533L17.2692 23H15.1896L12.8601 14.8352H12.7692L10.4339 23H8.3544ZM22.0149 23V11.3636H29.4695V13.1307H24.1229V16.2898H28.9581V18.0568H24.1229V23H22.0149Z",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "overlay-box",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                            className: "c15 df aic",
                                                                                                            children: [
                                                                                                                "Workflow Report",
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                    className: "icon ml0-5rem",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                        width: "12",
                                                                                                                        height: "14",
                                                                                                                        viewBox: "0 0 12 14",
                                                                                                                        fill: "none",
                                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                            fill: "#505050"
                                                                                                                        })
                                                                                                                    })
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            });
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df fww w100 accordian-dashboard-keyfeature",
                                                                        children: FREE_TOOLS?.['healthboost'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                                                                            style: {
                                                                                backgroundColor: '#efffdd75'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "w100 pl1rem mb2rem",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        className: "",
                                                                                        src: (parcelRequire("388WO")),
                                                                                        alt: "health-boost"
                                                                                    })
                                                                                }),
                                                                                FREE_TOOLS?.['healthboost'].map((item)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                className: "df fw500 fs1-25rem c15 aic",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                    className: "df aic",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                            className: "icon-diligenstia mr1rem",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                                className: "br5px",
                                                                                                                src: (parcelRequire("fePM2")),
                                                                                                                alt: ""
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                            className: "fs1rem fw500 c15 lh2 title-box-feature",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                                    className: "mr0-5rem",
                                                                                                                    src: (parcelRequire("2pz0d")),
                                                                                                                    alt: "health-boost"
                                                                                                                }),
                                                                                                                " ",
                                                                                                                item?.title
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }),
                                                                                            item?.['sectionList'] && item?.['sectionList'].length > 0 && moduleTooltip(item?.['sectionList']),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "right-info-hyper-icon",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "info-icon  pr ml0-5rem",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                                width: "27",
                                                                                                                height: "27",
                                                                                                                viewBox: "0 0 27 27",
                                                                                                                fill: "none",
                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                        cx: "13.5",
                                                                                                                        cy: "13.5",
                                                                                                                        r: "13.5",
                                                                                                                        transform: "matrix(1 0 0 -1 0 27)",
                                                                                                                        fill: "#59B8FD"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                                                                        fill: "white"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                                                                        fill: "white"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                                className: "overlay-box",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                                    className: "c15 df aic",
                                                                                                                    children: [
                                                                                                                        "What is it?",
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                            className: "icon ml0-5rem",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                                width: "12",
                                                                                                                                height: "14",
                                                                                                                                viewBox: "0 0 12 14",
                                                                                                                                fill: "none",
                                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                                    d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                                    fill: "#505050"
                                                                                                                                })
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    item?.['howItWorks'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "hover-list-icon  pr cp ml0-5rem",
                                                                                                        onClick: ()=>handleHowItWorks(item),
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                                width: "27",
                                                                                                                height: "27",
                                                                                                                viewBox: "0 0 27 27",
                                                                                                                fill: "none",
                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                        cx: "13.5",
                                                                                                                        cy: "13.5",
                                                                                                                        r: "13.5",
                                                                                                                        fill: "#59B8FD"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                                                                        fill: "white"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                                className: "overlay-box",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                                    className: "c15 df aic",
                                                                                                                    children: [
                                                                                                                        "How does it work?",
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                            className: "icon",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                                width: "12",
                                                                                                                                height: "14",
                                                                                                                                viewBox: "0 0 12 14",
                                                                                                                                fill: "none",
                                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                                    d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                                    fill: "#505050"
                                                                                                                                })
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    item?.['helpLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                                                        href: item?.['helpLink'],
                                                                                                        target: "_blank",
                                                                                                        className: "questionmark-icon pr ml0-5rem",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                                width: "27",
                                                                                                                height: "27",
                                                                                                                viewBox: "0 0 27 27",
                                                                                                                fill: "none",
                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                        cx: "13.5",
                                                                                                                        cy: "13.5",
                                                                                                                        r: "13.5",
                                                                                                                        fill: "#FC7785"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                                                                        fill: "white"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                                                                        fill: "white"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                                                                        fill: "white"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                                className: "overlay-box",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                                    className: "c15 df aic",
                                                                                                                    children: [
                                                                                                                        "Detailed help pages or ask our AI Assistants for help",
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                            className: "icon ml0-5rem",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                                width: "12",
                                                                                                                                height: "14",
                                                                                                                                viewBox: "0 0 12 14",
                                                                                                                                fill: "none",
                                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                                    d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                                    fill: "#505050"
                                                                                                                                })
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "df mt2rem jcsb bottom-details w90",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "df",
                                                                                                        children: [
                                                                                                            item?.['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                                className: "fs2rem c28 mr2rem fw500",
                                                                                                                children: [
                                                                                                                    "0% ",
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                        className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                                        children: "Module Complete"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            item?.['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                                className: "fs2rem c28 fw500",
                                                                                                                children: [
                                                                                                                    "0% ",
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                        className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                                        children: "Risk Complete"
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    item?.['isLock'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "lock-icon mr1rem mb0-5rem",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                            width: "68",
                                                                                                            height: "84",
                                                                                                            viewBox: "0 0 68 84",
                                                                                                            fill: "none",
                                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                    d: "M64.0326 35.8503C61.8786 33.697 59.0152 32.5118 55.9702 32.5118H55.1452V21.179C55.1452 9.60292 45.7279 0.185547 34.1524 0.185547H33.3763C21.8008 0.185547 12.3828 9.60292 12.3828 21.179V32.5111H11.5577C8.51281 32.5111 5.64937 33.697 3.49544 35.8503C1.34219 38.0042 0.15625 40.8677 0.15625 43.9133V72.4115C0.15625 75.4572 1.34219 78.3206 3.49544 80.4732C5.64869 82.6271 8.51213 83.813 11.5577 83.813H55.9702C59.0159 83.813 61.8793 82.6271 64.0332 80.4732C66.1865 78.3199 67.3724 75.4565 67.3724 72.4115V43.9133C67.3724 40.8684 66.1865 38.0049 64.0326 35.8503ZM17.8827 21.179C17.8827 12.6362 24.8327 5.68555 33.3763 5.68555H34.1524C42.6953 5.68555 49.6452 12.6362 49.6452 21.179V32.5111H17.8827V21.179ZM61.8724 72.4115C61.8724 73.9646 61.242 75.4854 60.1441 76.584C59.0289 77.6991 57.5467 78.313 55.9702 78.313H11.5577C9.98131 78.313 8.49975 77.6991 7.38394 76.5833C6.2695 75.4695 5.65556 73.988 5.65556 72.4115V43.9133C5.65556 42.3369 6.2695 40.8539 7.38394 39.7395C8.49906 38.625 9.98063 38.0111 11.5571 38.0111H55.9696C57.546 38.0111 59.0282 38.625 60.1427 39.7388C61.2578 40.8546 61.8717 42.3369 61.8717 43.9133L61.8724 72.4115Z",
                                                                                                                    fill: "#F2F3F4"
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                    d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                                                                                                    fill: "#E8E8E8"
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "report-bottom-area",
                                                                                                children: [
                                                                                                    item?.['isReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "report-btn pr",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                                width: "35",
                                                                                                                height: "35",
                                                                                                                viewBox: "0 0 35 35",
                                                                                                                fill: "none",
                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                        cx: "17.5",
                                                                                                                        cy: "17.5",
                                                                                                                        r: "17.5",
                                                                                                                        fill: "#AAACB5"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                                                                                        fill: "white"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                                className: "overlay-box",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                                    className: "c15 df aic",
                                                                                                                    children: [
                                                                                                                        "Module Report",
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                            className: "icon ml0-5rem",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                                width: "12",
                                                                                                                                height: "14",
                                                                                                                                viewBox: "0 0 12 14",
                                                                                                                                fill: "none",
                                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                                    d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                                    fill: "#505050"
                                                                                                                                })
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    item?.['isWfReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                        className: "report-btn ml1rem pr",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                                width: "35",
                                                                                                                height: "35",
                                                                                                                viewBox: "0 0 35 35",
                                                                                                                fill: "none",
                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                        cx: "17.5",
                                                                                                                        cy: "17.5",
                                                                                                                        r: "17.5",
                                                                                                                        fill: "#AAACB5"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M8.3544 23L5.07031 11.3636H7.33736L9.43395 19.9148H9.5419L11.7805 11.3636H13.843L16.0874 19.9205H16.1896L18.2862 11.3636H20.5533L17.2692 23H15.1896L12.8601 14.8352H12.7692L10.4339 23H8.3544ZM22.0149 23V11.3636H29.4695V13.1307H24.1229V16.2898H28.9581V18.0568H24.1229V23H22.0149Z",
                                                                                                                        fill: "white"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                                className: "overlay-box",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                                    className: "c15 df aic",
                                                                                                                    children: [
                                                                                                                        "Workflow Report",
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                            className: "icon ml0-5rem",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                                width: "12",
                                                                                                                                height: "14",
                                                                                                                                viewBox: "0 0 12 14",
                                                                                                                                fill: "none",
                                                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                                    d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                                    fill: "#505050"
                                                                                                                                })
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fww pr w100 keyfeature-box-three",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "mt1rem w100",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                        className: "accordian-dashboard-main",
                                                        expanded: expanded['exitPanel'],
                                                        onChange: ()=>setExpanded({
                                                                ...expanded,
                                                                exitPanel: !expanded['exitPanel']
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs1-25rem c15 fw600 ml1rem db",
                                                                        children: "Exit Ready"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df fww w100 accordian-dashboard-keyfeature",
                                                                    children: FREE_TOOLS?.['appStoreGrowth'].map((item)=>{
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "df fw500 fs1-25rem c15 aic",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df aic",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                className: "icon-diligenstia mr1rem",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                    className: "w40px h40px",
                                                                                                    src: item?.['isTitleIcon'],
                                                                                                    alt: "logo image"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                className: "fs1rem fw500 c15 lh2 title-box-feature",
                                                                                                children: [
                                                                                                    item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                        onClick: ()=>document.getElementById('required-star').scrollIntoView({
                                                                                                                behavior: "smooth"
                                                                                                            }),
                                                                                                        className: "cp bg1 icon",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                            src: (parcelRequire("dlp4j")),
                                                                                                            alt: "star-img"
                                                                                                        })
                                                                                                    }),
                                                                                                    item?.title
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                item['isPartnerModule'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                    className: "pa",
                                                                                    style: {
                                                                                        top: '-13px',
                                                                                        left: '110px'
                                                                                    },
                                                                                    src: (parcelRequire("i4vA9"))
                                                                                }),
                                                                                item?.['sectionList'] && item?.['sectionList'].length > 0 && moduleTooltip(item?.['sectionList']),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "right-info-hyper-icon",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            onClick: ()=>handleSeeMorePopup(item),
                                                                                            className: "info-icon  pr ml0-5rem",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "27",
                                                                                                    height: "27",
                                                                                                    viewBox: "0 0 27 27",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "13.5",
                                                                                                            cy: "13.5",
                                                                                                            r: "13.5",
                                                                                                            transform: "matrix(1 0 0 -1 0 27)",
                                                                                                            fill: "#59B8FD"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                                                            fill: "white"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "What is it?",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['howItWorks'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "hover-list-icon  pr cp ml0-5rem",
                                                                                            onClick: ()=>handleHowItWorks(item),
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "27",
                                                                                                    height: "27",
                                                                                                    viewBox: "0 0 27 27",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "13.5",
                                                                                                            cy: "13.5",
                                                                                                            r: "13.5",
                                                                                                            fill: "#59B8FD"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "How does it work?",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['helpLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                                            href: item?.['helpLink'],
                                                                                            target: "_blank",
                                                                                            className: "questionmark-icon pr ml0-5rem",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "27",
                                                                                                    height: "27",
                                                                                                    viewBox: "0 0 27 27",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "13.5",
                                                                                                            cy: "13.5",
                                                                                                            r: "13.5",
                                                                                                            fill: "#FC7785"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                                                            fill: "white"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                                                            fill: "white"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "Detailed help pages or ask our AI Assistants for help",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "df mt2rem jcsb bottom-details w90",
                                                                                    children: [
                                                                                        item?.['boxBottomText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "df mb1rem w70",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "fs1rem fw400 c28 lh2",
                                                                                                children: item['boxBottomText']
                                                                                            })
                                                                                        }),
                                                                                        item?.['isImage'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                            src: item?.['isImage'],
                                                                                            alt: "image"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df",
                                                                                            children: [
                                                                                                item?.['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                    className: "fs2rem c28 mr2rem fw500",
                                                                                                    children: [
                                                                                                        "0% ",
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                            className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                            children: "Module Complete"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                item?.['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                    className: "fs2rem c28 fw500",
                                                                                                    children: [
                                                                                                        "0% ",
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                            className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                                            children: "Risk Complete"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['isLorem'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "df",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                className: "fs2rem c28 fw500",
                                                                                                children: [
                                                                                                    "Lorem ",
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "fs0-75rem fw400 lh1",
                                                                                                        children: "Lorem ipsum dolor"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        item?.['isNil'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "df",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                                className: "fs2rem c28 fw500",
                                                                                                children: [
                                                                                                    "NIL ",
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "fs0-75rem fw400 lh1",
                                                                                                        children: "Not yet certified"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        item?.['isLock'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "lock-icon mr1rem mb0-5rem",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                width: "68",
                                                                                                height: "84",
                                                                                                viewBox: "0 0 68 84",
                                                                                                fill: "none",
                                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M64.0326 35.8503C61.8786 33.697 59.0152 32.5118 55.9702 32.5118H55.1452V21.179C55.1452 9.60292 45.7279 0.185547 34.1524 0.185547H33.3763C21.8008 0.185547 12.3828 9.60292 12.3828 21.179V32.5111H11.5577C8.51281 32.5111 5.64937 33.697 3.49544 35.8503C1.34219 38.0042 0.15625 40.8677 0.15625 43.9133V72.4115C0.15625 75.4572 1.34219 78.3206 3.49544 80.4732C5.64869 82.6271 8.51213 83.813 11.5577 83.813H55.9702C59.0159 83.813 61.8793 82.6271 64.0332 80.4732C66.1865 78.3199 67.3724 75.4565 67.3724 72.4115V43.9133C67.3724 40.8684 66.1865 38.0049 64.0326 35.8503ZM17.8827 21.179C17.8827 12.6362 24.8327 5.68555 33.3763 5.68555H34.1524C42.6953 5.68555 49.6452 12.6362 49.6452 21.179V32.5111H17.8827V21.179ZM61.8724 72.4115C61.8724 73.9646 61.242 75.4854 60.1441 76.584C59.0289 77.6991 57.5467 78.313 55.9702 78.313H11.5577C9.98131 78.313 8.49975 77.6991 7.38394 76.5833C6.2695 75.4695 5.65556 73.988 5.65556 72.4115V43.9133C5.65556 42.3369 6.2695 40.8539 7.38394 39.7395C8.49906 38.625 9.98063 38.0111 11.5571 38.0111H55.9696C57.546 38.0111 59.0282 38.625 60.1427 39.7388C61.2578 40.8546 61.8717 42.3369 61.8717 43.9133L61.8724 72.4115Z",
                                                                                                        fill: "#F2F3F4"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                                                                                        fill: "#E8E8E8"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "report-bottom-area",
                                                                                    children: [
                                                                                        item?.['isReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "report-btn pr",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "35",
                                                                                                    height: "35",
                                                                                                    viewBox: "0 0 35 35",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "17.5",
                                                                                                            cy: "17.5",
                                                                                                            r: "17.5",
                                                                                                            fill: "#AAACB5"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "Module Report",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item?.['isWfReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "report-btn ml1rem pr",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    width: "35",
                                                                                                    height: "35",
                                                                                                    viewBox: "0 0 35 35",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                            cx: "17.5",
                                                                                                            cy: "17.5",
                                                                                                            r: "17.5",
                                                                                                            fill: "#AAACB5"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M8.3544 23L5.07031 11.3636H7.33736L9.43395 19.9148H9.5419L11.7805 11.3636H13.843L16.0874 19.9205H16.1896L18.2862 11.3636H20.5533L17.2692 23H15.1896L12.8601 14.8352H12.7692L10.4339 23H8.3544ZM22.0149 23V11.3636H29.4695V13.1307H24.1229V16.2898H28.9581V18.0568H24.1229V23H22.0149Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "overlay-box",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                        className: "c15 df aic",
                                                                                                        children: [
                                                                                                            "Workflow Report",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                className: "icon ml0-5rem",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                                    width: "12",
                                                                                                                    height: "14",
                                                                                                                    viewBox: "0 0 12 14",
                                                                                                                    fill: "none",
                                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                                        fill: "#505050"
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        });
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        id: "required-star",
                                        className: "df aic pt2rem pl3rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("dlp4j")),
                                                className: "w20px h20px mr0-5rem",
                                                alt: "star-img"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c12 fs0-75rem",
                                                children: "= required for "
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("iMeWL")),
                                                className: "w50px ml0-5rem",
                                                alt: "certificate-img"
                                            })
                                        ]
                                    }),
                                    FREE_TOOLS?.['yourAnyCheckList'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mt2rem bg20 bss bsbb bo3 p2rem br25px w100 keyfeature-box keyfeature-box-core df fww keyfeature-box-two keyfeature-box-anylist pr bsbb gg1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-25rem c15 w100  pl1rem",
                                                children: "Your AnyList Checklists"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs1rem mb1-5rem w100 c15 mt0-5rem df aic pl1rem",
                                                children: "Using Anylist Checklist Builder"
                                            }),
                                            FREE_TOOLS?.['yourAnyCheckList'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "cp w25 keyfeature-wihte-item new-shadow br15px p2rem zi9 pr bsbb cp df",
                                                        style: {
                                                            backgroundColor: '#BDBFC5',
                                                            borderColor: '#BDBFC5'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "icon mr2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "38",
                                                                        height: "38",
                                                                        viewBox: "0 0 38 38",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                "clip-path": "url(#clip0_3761_5532)",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                                                        fill: "#FAFAFA"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                                                                        fill: "#AAACB5"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                    id: "clip0_3761_5532",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                        width: "38",
                                                                                        height: "38",
                                                                                        fill: "white"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                                    className: "c1 fs1-25rem fw500",
                                                                    children: [
                                                                        "Create New ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                        " Checklist Module"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    FREE_TOOLS?.['yourAnyCheckList'].map((item)=>{
                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb",
                                                            style: {
                                                                borderColor: item?.['status'] == 'Incomplete' ? '#FC7785' : item?.['status'] == 'Activated' ? '#15d757' : '#B5BFDE'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df fw500 fs1-25rem c15 aic",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic pr w100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                                                className: "icon-diligenstia mr1rem pr",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        className: "w40px h40px",
                                                                                        src: item?.['isTitleIcon'],
                                                                                        alt: "logo image"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: `activedeactive-area ${item?.['status'] == 'Activated' ? ' bg7' : ' bg16'}`,
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            className: "overlay-box show-tooltip",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "c15 df aic",
                                                                                                children: item?.['status']
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "fs1rem fw500 c15 lh2 title-box-feature w70",
                                                                                children: [
                                                                                    item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        onClick: ()=>document.getElementById('required-star').scrollIntoView({
                                                                                                behavior: "smooth"
                                                                                            }),
                                                                                        className: "cp bg1 icon",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                            src: (parcelRequire("dlp4j")),
                                                                                            alt: "star-img"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "db",
                                                                                        style: {
                                                                                            color: '#15131350',
                                                                                            fontSize: '9px'
                                                                                        },
                                                                                        children: item?.aiText
                                                                                    }),
                                                                                    item?.title
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df remove-edit-area",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        className: "edit-remove",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                            width: "21",
                                                                                            height: "21",
                                                                                            viewBox: "0 0 21 21",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                                    "clip-path": "url(#clip0_3761_5360)",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M19.25 9.625C19.0179 9.625 18.7954 9.71719 18.6313 9.88128C18.4672 10.0454 18.375 10.2679 18.375 10.5V15.75C18.375 16.4462 18.0984 17.1139 17.6062 17.6062C17.1139 18.0984 16.4462 18.375 15.75 18.375H5.25C4.55381 18.375 3.88613 18.0984 3.39384 17.6062C2.90156 17.1139 2.625 16.4462 2.625 15.75V5.25C2.625 4.55381 2.90156 3.88613 3.39384 3.39384C3.88613 2.90156 4.55381 2.625 5.25 2.625H10.5C10.7321 2.625 10.9546 2.53281 11.1187 2.36872C11.2828 2.20462 11.375 1.98206 11.375 1.75C11.375 1.51794 11.2828 1.29538 11.1187 1.13128C10.9546 0.967187 10.7321 0.875 10.5 0.875H5.25C4.67547 0.875 4.10656 0.988163 3.57576 1.20803C3.04496 1.42789 2.56266 1.75015 2.15641 2.15641C1.33594 2.97688 0.875 4.08968 0.875 5.25V15.75C0.875 16.3245 0.988163 16.8934 1.20803 17.4242C1.42789 17.955 1.75015 18.4373 2.15641 18.8436C2.97688 19.6641 4.08968 20.125 5.25 20.125H15.75C16.3245 20.125 16.8934 20.0118 17.4242 19.792C17.955 19.5721 18.4373 19.2498 18.8436 18.8436C19.2498 18.4373 19.5721 17.955 19.792 17.4242C20.0118 16.8934 20.125 16.3245 20.125 15.75V10.5C20.125 10.2679 20.0328 10.0454 19.8687 9.88128C19.7046 9.71719 19.4821 9.625 19.25 9.625Z",
                                                                                                            fill: "#4A67FF"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M6.89501 9.15262C6.65014 9.39718 6.45605 9.68775 6.3239 10.0076C6.19175 10.3275 6.12416 10.6703 6.12501 11.0164V12.2501C6.12501 12.9463 6.40157 13.614 6.89385 14.1063C7.38614 14.5986 8.05381 14.8751 8.75001 14.8751H9.98376C10.3298 14.876 10.6727 14.8084 10.9925 14.6762C11.3124 14.5441 11.6029 14.35 11.8475 14.1051L19.355 6.59762C19.5997 6.35374 19.7939 6.06396 19.9264 5.74489C20.0589 5.42582 20.1271 5.08373 20.1271 4.73824C20.1271 4.39275 20.0589 4.05067 19.9264 3.73159C19.7939 3.41252 19.5997 3.12274 19.355 2.87887L18.1213 1.64512C17.8774 1.4004 17.5876 1.20623 17.2685 1.07374C16.9495 0.941247 16.6074 0.873047 16.2619 0.873047C15.9164 0.873047 15.5743 0.941247 15.2552 1.07374C14.9362 1.20623 14.6464 1.4004 14.4025 1.64512L6.89501 9.15262ZM16.8788 2.87887L18.1213 4.12137C18.2842 4.28531 18.3757 4.50708 18.3757 4.73824C18.3757 4.9694 18.2842 5.19117 18.1213 5.35512L17.3688 6.12512L14.875 3.63137L15.6275 2.87887C15.709 2.79553 15.8063 2.72931 15.9138 2.6841C16.0212 2.63889 16.1366 2.6156 16.2531 2.6156C16.3697 2.6156 16.4851 2.63889 16.5925 2.6841C16.6999 2.72931 16.7973 2.79553 16.8788 2.87887ZM7.87501 11.0164C7.87434 10.9012 7.89641 10.7871 7.93996 10.6804C7.9835 10.5738 8.04766 10.4769 8.12876 10.3951L13.65 4.87387L16.1263 7.35012L10.605 12.8714C10.5232 12.9525 10.4263 13.0166 10.3197 13.0602C10.2131 13.1037 10.0989 13.1258 9.98376 13.1251H8.75001C8.51794 13.1251 8.29538 13.0329 8.13129 12.8688C7.9672 12.7047 7.87501 12.4822 7.87501 12.2501V11.0164Z",
                                                                                                            fill: "#4A67FF"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                        id: "clip0_3761_5360",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                            width: "21",
                                                                                                            height: "21",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        className: "edit-remove",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                            width: "21",
                                                                                            height: "21",
                                                                                            viewBox: "0 0 21 21",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M16.625 6.125C16.3929 6.125 16.1704 6.21719 16.0063 6.38128C15.8422 6.54538 15.75 6.76794 15.75 7V16.7921C15.7249 17.2346 15.526 17.6492 15.1966 17.9457C14.8671 18.2422 14.4339 18.3965 13.9913 18.375H7.00875C6.56608 18.3965 6.13286 18.2422 5.80344 17.9457C5.47402 17.6492 5.2751 17.2346 5.25 16.7921V7C5.25 6.76794 5.15781 6.54538 4.99372 6.38128C4.82962 6.21719 4.60706 6.125 4.375 6.125C4.14294 6.125 3.92038 6.21719 3.75628 6.38128C3.59219 6.54538 3.5 6.76794 3.5 7V16.7921C3.52498 17.6988 3.90826 18.5587 4.56591 19.1834C5.22356 19.808 6.10196 20.1466 7.00875 20.125H13.9913C14.898 20.1466 15.7764 19.808 16.4341 19.1834C17.0917 18.5587 17.475 17.6988 17.5 16.7921V7C17.5 6.76794 17.4078 6.54538 17.2437 6.38128C17.0796 6.21719 16.8571 6.125 16.625 6.125Z",
                                                                                                    fill: "#F14D4D"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M17.5 3.5H14V1.75C14 1.51794 13.9078 1.29538 13.7437 1.13128C13.5796 0.967187 13.3571 0.875 13.125 0.875H7.875C7.64294 0.875 7.42038 0.967187 7.25628 1.13128C7.09219 1.29538 7 1.51794 7 1.75V3.5H3.5C3.26794 3.5 3.04538 3.59219 2.88128 3.75628C2.71719 3.92038 2.625 4.14294 2.625 4.375C2.625 4.60706 2.71719 4.82962 2.88128 4.99372C3.04538 5.15781 3.26794 5.25 3.5 5.25H17.5C17.7321 5.25 17.9546 5.15781 18.1187 4.99372C18.2828 4.82962 18.375 4.60706 18.375 4.375C18.375 4.14294 18.2828 3.92038 18.1187 3.75628C17.9546 3.59219 17.7321 3.5 17.5 3.5ZM8.75 3.5V2.625H12.25V3.5H8.75Z",
                                                                                                    fill: "#F14D4D"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M9.625 14.875V8.75C9.625 8.51794 9.53281 8.29538 9.36872 8.13128C9.20462 7.96719 8.98206 7.875 8.75 7.875C8.51794 7.875 8.29538 7.96719 8.13128 8.13128C7.96719 8.29538 7.875 8.51794 7.875 8.75V14.875C7.875 15.1071 7.96719 15.3296 8.13128 15.4937C8.29538 15.6578 8.51794 15.75 8.75 15.75C8.98206 15.75 9.20462 15.6578 9.36872 15.4937C9.53281 15.3296 9.625 15.1071 9.625 14.875Z",
                                                                                                    fill: "#F14D4D"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M13.125 14.875V8.75C13.125 8.51794 13.0328 8.29538 12.8687 8.13128C12.7046 7.96719 12.4821 7.875 12.25 7.875C12.0179 7.875 11.7954 7.96719 11.6313 8.13128C11.4672 8.29538 11.375 8.51794 11.375 8.75V14.875C11.375 15.1071 11.4672 15.3296 11.6313 15.4937C11.7954 15.6578 12.0179 15.75 12.25 15.75C12.4821 15.75 12.7046 15.6578 12.8687 15.4937C13.0328 15.3296 13.125 15.1071 13.125 14.875Z",
                                                                                                    fill: "#F14D4D"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                item?.['sectionList'] && item?.['sectionList'].length > 0 && moduleTooltip(item?.['sectionList']),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df mt2rem jcsb bottom-details w90",
                                                                    children: [
                                                                        item?.['boxBottomText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "df mb1rem w70",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs1rem fw400 c28 lh2",
                                                                                children: item['boxBottomText']
                                                                            })
                                                                        }),
                                                                        item?.['isImage'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: item?.['isImage'],
                                                                            alt: "image"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df",
                                                                            children: [
                                                                                item?.['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                    className: "fs2rem c28 mr2rem fw500",
                                                                                    children: [
                                                                                        "0% ",
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                            children: "Module Complete"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                item?.['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                    className: "fs2rem c28 fw500",
                                                                                    children: [
                                                                                        "0% ",
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "fs0-75rem fw400 lh1 w4rem db mt0-5rem",
                                                                                            children: "Risk Complete"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        item?.['isLorem'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "df",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                className: "fs2rem c28 fw500",
                                                                                children: [
                                                                                    "Lorem ",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fs0-75rem fw400 lh1",
                                                                                        children: "Lorem ipsum dolor"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        item?.['isNil'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "df",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                                                className: "fs2rem c28 fw500",
                                                                                children: [
                                                                                    "NIL ",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fs0-75rem fw400 lh1",
                                                                                        children: "Not yet certified"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        item?.['isLock'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "lock-icon mr1rem mb0-5rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                width: "68",
                                                                                height: "84",
                                                                                viewBox: "0 0 68 84",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M64.0326 35.8503C61.8786 33.697 59.0152 32.5118 55.9702 32.5118H55.1452V21.179C55.1452 9.60292 45.7279 0.185547 34.1524 0.185547H33.3763C21.8008 0.185547 12.3828 9.60292 12.3828 21.179V32.5111H11.5577C8.51281 32.5111 5.64937 33.697 3.49544 35.8503C1.34219 38.0042 0.15625 40.8677 0.15625 43.9133V72.4115C0.15625 75.4572 1.34219 78.3206 3.49544 80.4732C5.64869 82.6271 8.51213 83.813 11.5577 83.813H55.9702C59.0159 83.813 61.8793 82.6271 64.0332 80.4732C66.1865 78.3199 67.3724 75.4565 67.3724 72.4115V43.9133C67.3724 40.8684 66.1865 38.0049 64.0326 35.8503ZM17.8827 21.179C17.8827 12.6362 24.8327 5.68555 33.3763 5.68555H34.1524C42.6953 5.68555 49.6452 12.6362 49.6452 21.179V32.5111H17.8827V21.179ZM61.8724 72.4115C61.8724 73.9646 61.242 75.4854 60.1441 76.584C59.0289 77.6991 57.5467 78.313 55.9702 78.313H11.5577C9.98131 78.313 8.49975 77.6991 7.38394 76.5833C6.2695 75.4695 5.65556 73.988 5.65556 72.4115V43.9133C5.65556 42.3369 6.2695 40.8539 7.38394 39.7395C8.49906 38.625 9.98063 38.0111 11.5571 38.0111H55.9696C57.546 38.0111 59.0282 38.625 60.1427 39.7388C61.2578 40.8546 61.8717 42.3369 61.8717 43.9133L61.8724 72.4115Z",
                                                                                        fill: "#F2F3F4"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                                                                        fill: "#E8E8E8"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        item?.['isActiveButton'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            style: {
                                                                                top: '-22px',
                                                                                right: '11px'
                                                                            },
                                                                            className: `pr df bg1 br50px mr0-5rem bw1px bss fs0-75rem px1rem py0-5rem bsbb aic active-btn cp ${item?.['status'] == 'Incomplete' ? 'c4' : item?.['status'] == 'Not activated' ? 'c7' : 'c12'}`,
                                                                            children: item?.['buttonText']
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "report-bottom-area",
                                                                    children: [
                                                                        item?.['isReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "report-btn pr",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                    width: "35",
                                                                                    height: "35",
                                                                                    viewBox: "0 0 35 35",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                            cx: "17.5",
                                                                                            cy: "17.5",
                                                                                            r: "17.5",
                                                                                            fill: "#AAACB5"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                                                            fill: "white"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "overlay-box",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        className: "c15 df aic",
                                                                                        children: [
                                                                                            "Module Report",
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                className: "icon ml0-5rem",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                    width: "12",
                                                                                                    height: "14",
                                                                                                    viewBox: "0 0 12 14",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                        fill: "#505050"
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        item?.['isWfReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "report-btn ml1rem pr",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                    width: "35",
                                                                                    height: "35",
                                                                                    viewBox: "0 0 35 35",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                            cx: "17.5",
                                                                                            cy: "17.5",
                                                                                            r: "17.5",
                                                                                            fill: "#AAACB5"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M8.3544 23L5.07031 11.3636H7.33736L9.43395 19.9148H9.5419L11.7805 11.3636H13.843L16.0874 19.9205H16.1896L18.2862 11.3636H20.5533L17.2692 23H15.1896L12.8601 14.8352H12.7692L10.4339 23H8.3544ZM22.0149 23V11.3636H29.4695V13.1307H24.1229V16.2898H28.9581V18.0568H24.1229V23H22.0149Z",
                                                                                            fill: "white"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "overlay-box",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        className: "c15 df aic",
                                                                                        children: [
                                                                                            "Workflow Report",
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                className: "icon ml0-5rem",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                    width: "12",
                                                                                                    height: "14",
                                                                                                    viewBox: "0 0 12 14",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                                                        fill: "#505050"
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "keyFeatureSeeMore",
                open: modal['open'] == 'openSeeMore',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 p4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        maxWidth: '1350px',
                        ...selectedFeature?.seeMoreSection?.cardPaddingBottom
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        width: "55%",
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 df aic",
                                                    children: selectedFeature?.seeMoreSection?.icon
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w90 fw500 c15 pl1rem df aic",
                                                    style: {
                                                        fontSize: '26px',
                                                        lineHeight: '37.32px'
                                                    },
                                                    children: selectedFeature?.seeMoreSection?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: " mt0-5rem",
                                            style: {
                                                paddingLeft: '22px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    style: {
                                                        lineHeight: '25px',
                                                        paddingBottom: "3px",
                                                        paddingTop: "3px",
                                                        paddingLeft: "20px",
                                                        borderLeft: '2px solid #D3D9FC',
                                                        ...selectedFeature?.seeMoreSection?.liStyle
                                                    },
                                                    className: "df fdc fs1rem c14 fs1rem fw400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "circle"
                                                                }),
                                                                objpoints
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: selectedFeature?.seeMoreSection?.subMenu && selectedFeature?.seeMoreSection?.subMenu?.index === index && selectedFeature?.seeMoreSection?.subMenu?.points?.map((str, i, arr)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                    style: {
                                                                        lineHeight: '30px'
                                                                    },
                                                                    children: str
                                                                });
                                                            })
                                                        })
                                                    ]
                                                }, `${objpoints}-${index}`);
                                            })
                                        }),
                                        selectedFeature?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt1rem",
                                            style: {
                                                border: '1px solid gray',
                                                padding: "10px",
                                                borderRadius: '10px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.notePoint
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jce",
                                    style: {
                                        width: '45%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: selectedFeature?.seeMoreSection?.image,
                                            className: "w70",
                                            style: {
                                                objectFit: 'fill'
                                            }
                                        }),
                                        selectedFeature?.seeMoreSection?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("fOQ2M")),
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "videoCompanies"
                                                })),
                                            className: "pa cp zi1",
                                            style: {
                                                right: '10%',
                                                bottom: '10%'
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "howItWorksModal",
                open: modal['open'] == 'howItWorksModal',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        zoom: '0.9',
                        maxWidth: '1350px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww w100",
                            children: [
                                selectedHowItWorks?.['howItWorks']?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcc fdc pa",
                                    style: {
                                        right: '-7%',
                                        top: '-5%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("jLZXj")),
                                            className: "w70",
                                            style: {
                                                borderRadius: '50%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("fOQ2M")),
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "videoCompanies"
                                                })),
                                            className: "cp zi1"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "w100 tac c15 fs1-75rem fw500",
                                    children: "How does it work?"
                                }),
                                selectedHowItWorks?.['howItWorks']?.['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                    className: "w100 tac c15 fs1-25rem fw500 mb1rem",
                                    children: selectedHowItWorks?.['howItWorks']?.['subTitle']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-top-box df w100 jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedHowItWorks?.howItWorks?.stepImage,
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                                    children: selectedHowItWorks?.['howItWorks']?.['arrayImages'] && selectedHowItWorks?.['howItWorks']?.['arrayImages'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['howItWorks']?.['arrayImages'].map((image)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "step-img df jcc px1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: image,
                                                    alt: "ste image"
                                                })
                                            }))
                                    })
                                }),
                                selectedHowItWorks?.['howItWorks']?.['checkList'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb",
                                    children: selectedHowItWorks?.['howItWorks']?.['checkList'] && selectedHowItWorks?.['howItWorks']?.['checkList'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['howItWorks']?.['checkList'].map((array)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-inner w100 pr",
                                                children: array
                                            }))
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: selectedHowItWorks?.['howItWorks']?.['bottomSection'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem c12 mb1rem tac w100",
                                        children: selectedHowItWorks?.['howItWorks']?.['bottomSection']
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        children: selectedHowItWorks?.['howItWorks']?.['btnContent']
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'videoCompanies',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100 p2-5rem bsbb df fdc m1rem maw900px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: '0'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                src: "https://www.loom.com/embed/22404ff9e1514a3ca4a169af00ee93e1?sid=bf8bbfc8-8d7d-4361-9227-cc2876f6bd2d&output=embed",
                                frameborder: "0",
                                webkitallowfullscreen: "true",
                                mozallowfullscreen: "true",
                                allowFullScreen: true,
                                style: {
                                    position: 'absolute',
                                    top: '0',
                                    left: '0',
                                    width: '100%',
                                    height: '100%'
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
}






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");









var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");
















function $f9c229359c25a0c6$export$2e2bcd8739ae039({ companies: companies, setSelectedCompany: setSelectedCompany, noClients: noClients, setPlan: setPlan, handleHowItWorks: handleHowItWorks, HOW_TO_POPUPS: HOW_TO_POPUPS }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [viewEmail, setViewEmail] = (0, $acw62.useState)({});
    let [benchmark, setBenchmark] = (0, $acw62.useState)(true);
    let [eventsHistory, setEventsHistory] = (0, $acw62.useState)({});
    let [deleteSelectedCompany, setDeleteSelectedCompany] = (0, $acw62.useState)(null);
    const handleEventHistory = async (events)=>{
        setEventsHistory(events);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "advisorEventsHistory"
        }));
    };
    const hanleViewEmail = async (email, attachments)=>{
        let updated = email;
        attachments.map((attachment)=>{
            updated = updated.replaceAll(`cid:${attachment.cid}`, attachment.href);
        });
        setViewEmail(updated);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "viewEventEmail"
        }));
    };
    const handleRemoveFromDashboard = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/remove-dashboard-company`, {
                companyId: deleteSelectedCompany['_id']
            });
            if (response?.['code'] === 200) {
                dispatch((0, $b9bcf9787e5ad456$export$1ee9ca58a1c41c03)({
                    _id: deleteSelectedCompany['_id']
                }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message']);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const handlePaymentPopup = async (paymentPlan)=>{
        setPlan(paymentPlan);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'subscriptionPayment'
        }));
    };
    const showCompanyDetails = (company)=>{
        const handleInviteResend = async ()=>{
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/resend-access-invite/${company['_id']}`, {});
        };
        let completeness, risk;
        if (benchmark) {
            risk = company?.["myBenchmark"]?.["risk"];
            completeness = company?.["myBenchmark"]?.["completeness"];
        } else {
            risk = company?.["overallBenchmark"]?.["risk"];
            completeness = company?.["overallBenchmark"]?.["completeness"];
        }
        let ristPrecentage = risk + 50;
        let completenessPrecentage = completeness + 50;
        let permissionAccess = "";
        if (user["role"] == "Advisor") {
            permissionAccess = company?.["advisors"]?.[user["_id"]]?.["type"];
            // If no direct access, check if any team member has access (for admin viewing team member's companies)
            if (!permissionAccess && company?.["advisorsData"]) {
                const teamMemberAdvisor = company["advisorsData"].find((advisor)=>advisor?.["createdBy"]?.toString() === user["_id"] || advisor?.["_id"] === user["_id"]);
                if (teamMemberAdvisor) permissionAccess = company?.["advisors"]?.[teamMemberAdvisor["_id"]]?.["type"] || 'ALL';
            }
        } else {
            permissionAccess = company?.["investors"]?.[user["_id"]]?.["type"];
            // If no direct access, check if any team member has access (for admin viewing team member's companies)
            if (!permissionAccess && company?.["investorData"]) {
                const teamMemberInvestor = company["investorData"].find((investor)=>investor?.["createdBy"]?.toString() === user["_id"] || investor?.["_id"] === user["_id"]);
                if (teamMemberInvestor) permissionAccess = company?.["investors"]?.[teamMemberInvestor["_id"]]?.["type"] || 'ALL';
            }
        }
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df clientNameSection",
                    style: {
                        width: '270px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc jcfs tal w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1-25rem c15 mb1rem w100",
                                children: company["cName"]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcfs aife",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "",
                                        children: company["subscription"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "fs1-25rem c7 mra tal",
                                            children: company["subscription"] == "Pro" ? "PRO" : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: company["subscription"]?.toUpperCase()
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "fs1rem c8 mra tal",
                                            children: "INACTIVE"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        "data-tooltip": "Company Settings",
                                        to: `/company/${company['_id']}#company-settings`,
                                        className: `tac dashboard-btn c1 bg-gradient2 bg-gradient-hover br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100px td250 ml0-5rem ${!company["subscription"] && "pen"}`,
                                        children: "Settings"
                                    }),
                                    permissionAccess && permissionAccess == "ALL" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: company['servicedBy'] && company['servicedBy'] === user['_id'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            onClick: ()=>{
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'removeCompanyFromDashboard'
                                                }));
                                                setDeleteSelectedCompany(company);
                                            },
                                            className: `tac dashboard-btn c1 bg4 br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100px td250 ml0rem cp ${!company["subscription"] && "pen"}`,
                                            children: "Delete"
                                        }) : null
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aifs w250px jcc",
                    children: [
                        user?.['companyId']?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse w60px mr1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "w20 df jcc username-area tac",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc aic",
                                    children: [
                                        user?.['companyId']?.['creatorId']?.["profile"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: `w40px h40px df jcc aic br100 cp mr0-5rem`,
                                            src: user?.['companyId']?.['creatorId']?.["profile"],
                                            "data-tooltip": user?.['companyId']?.['creatorId']?.["firstName"] ? user?.['companyId']?.['creatorId']?.["firstName"] + " " + (user?.['companyId']?.['creatorId']?.lastName ? user?.['companyId']?.['creatorId']?.lastName : "") : "Register to show your name here"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            "data-tooltip": user?.['companyId']?.['creatorId']?.["firstName"] ? user?.['companyId']?.['creatorId']?.["firstName"] + " " + (user?.['companyId']?.['creatorId']?.lastName ? user?.['companyId']?.['creatorId']?.lastName : "") : "Register to show your name here",
                                            className: `w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo3`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    user?.['companyId']?.['creatorId']?.["firstName"] ? user?.['companyId']?.['creatorId']?.["firstName"][0] : '?',
                                                    user?.['companyId']?.['creatorId']?.["lastName"] ? user?.['companyId']?.['creatorId']?.["lastName"][0] : ""
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "ass mt0-5rem fs0-75rem c15",
                                            children: [
                                                user['role'],
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "Admin"
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        company?.["creatorId"]?.["firstName"] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse w60px mr1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "w20 df jcc username-area tac",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc aic",
                                    children: company?.["creatorId"] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            company?.["creatorId"]["profile"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: company?.["creatorId"]["profile"],
                                                className: `w40px h40px df jcc aic br100 cp mr0-5rem client-profile`,
                                                "data-tooltip": (company?.['creatorId']?.['firstName'] && company['creatorId']['firstName']) + " " + (company?.['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : "")
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                "data-tooltip": (company?.['creatorId']?.['firstName'] && company['creatorId']['firstName']) + " " + (company?.['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : ""),
                                                className: `w40px h40px df jcc aic br100 c1 bw3px bss bo29 client-profile`,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        company?.['creatorId']?.['firstName'] && company['creatorId']['firstName'][0],
                                                        company['creatorId']?.['lastName']?.[0] ? company['creatorId']['lastName'][0] : ""
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "ass mt0-5rem fs0-75rem c15",
                                                children: [
                                                    "Company ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Admin"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        company?.['group'] && company['group'] !== "Standard" && company['group'][0] ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse w60px mr2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "w20 df username-area type-user mr2rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            "data-tooltip": company?.['group'] && company['group'] !== "Standard" ? company['group'] : 'No group',
                                            className: `w40px h40px df jcc aic br100 bg4 c1 bo4 bss bw3px mb1rem ${company['group'] ? 'fs1rem' : 'fs0-75rem'}`,
                                            children: company?.['group'] && company['group'] !== "Standard" ? company['group'][0] : 'N/A'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ass mt0-5rem fs0-75rem c15",
                                            children: "Group"
                                        })
                                    ]
                                })
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcse aic fdc reprot-btn-dropdowns",
                    children: [
                        permissionAccess ? company?.["progress"] == "inActive" ? // Client login activated but awaiting client approval
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            onClick: ()=>company["events"] && handleEventHistory(company["events"]),
                            "data-tooltip": `Awaiting client approval ${company?.['clientLoginActivated'] == false ? '(client not yet contacted)' : ''}`,
                            className: `c3 bo3 w100 tac br20px fs0-75rem py0-5rem fw500 dashboard-btn td250 mb0-5rem`,
                            style: {
                                border: "1px solid"
                            },
                            children: [
                                "Awaiting Client Approval",
                                company?.['clientLoginActivated'] == false && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "c4",
                                    style: {
                                        fontSize: '9px'
                                    },
                                    children: "(client not yet contacted)"
                                })
                            ]
                        }) : // Client has approved
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            onClick: ()=>company["events"] && handleEventHistory(company["events"]),
                            "data-tooltip": `${(0, $f1q41.capitalize)(permissionAccess)} access`,
                            className: `c3 bo3 w100 tac br20px fs0-75rem py0-5rem fw500 dashboard-btn td250 mb0-5rem`,
                            style: {
                                border: "1px solid"
                            },
                            children: `${(0, $f1q41.capitalize)(permissionAccess)} access`
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            style: {
                                border: "1px solid"
                            },
                            className: `pen c13 bo13 w100 tac br20px fs0-75rem py0-5rem fw500 w100 mb0-5rem dashboard-btn`,
                            children: "Awaiting Access"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            onClick: ()=>{
                                if (!permissionAccess) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Company access not yet authorised");
                                else if (!company["subscription"]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upgrade this company to a subscription");
                                else dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({}));
                            },
                            "data-tooltip": !permissionAccess ? "Company access not yet authorised" : "",
                            to: !permissionAccess || !company["subscription"] ? "#" : (0, $16250bd714b02a14$export$240514314008da16).replace(":id", company["_id"]),
                            className: `tac dashboard-btn c1 bg-gradient2 br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100 td250 ${!permissionAccess ? 'disabled-look' : ''}`,
                            children: "Dashboard"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "progress-area progress-dashboard mx1rem",
                    style: {
                        display: "flex",
                        position: "relative",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: 80,
                                        height: 80
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${company.stats.completionPercent > 67 ? "green" : company.stats.completionPercent > 33 ? "orange" : "red"}`,
                                        strokeWidth: 18,
                                        value: company.stats.completionPercent || 0,
                                        text: (company.stats.completionPercent || 0) + "%",
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: "round",
                                            strokeWidth: 35,
                                            textSize: "20px",
                                            pathTransitionDuration: 0.5,
                                            trailColor: "#d6d6d6",
                                            backgroundColor: "#fc7785",
                                            dominantBaseline: "ideographic"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bottom-text df fdc tac jcc mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem fw300 c15",
                                            children: "Overall"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: "0"
                                            },
                                            className: "text-center-area c15 fs1rem fw400",
                                            children: "Completeness"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box mx1rem df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: 80,
                                        height: 80
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${company.stats.riskPercent > 67 ? "red" : company.stats.riskPercent > 33 ? "orange" : "green"}`,
                                        strokeWidth: 18,
                                        value: company.stats.riskPercent || 0,
                                        text: company.stats.completionPercent ? `${company.stats.riskPercent || 0}%` : "0%",
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: "butt",
                                            strokeWidth: 35,
                                            textSize: "20px",
                                            pathTransitionDuration: 0.5,
                                            trailColor: "#d6d6d6",
                                            backgroundColor: "#fc7785",
                                            dominantBaseline: "ideographic"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bottom-text df fdc tac jcc mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem fw300 c15",
                                            children: "Overall"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: "0"
                                            },
                                            className: "text-center-area c15 fs1rem fw400",
                                            children: "Risk"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `cp progress-bar workflow-report-progress ${company?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : company?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : ' workflow-progress-pink'}`,
                                    style: {
                                        width: 80,
                                        height: 80,
                                        borderRadius: '50%',
                                        margin: 0,
                                        border: '2px solid #F1F1F1'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        text: (company?.stats?.workflowCompletionPercent || 0) + "%",
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeWidth: '0',
                                            textSize: '20px',
                                            trailColor: '#FBFBFB',
                                            stroke: 'transparent',
                                            strokeLinecap: 'butt',
                                            backgroundColor: '#FBFBFB',
                                            pathTransitionDuration: 0.5,
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bottom-text df fdc tac jcc mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem fw300 c15",
                                            children: "Overall"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: "0"
                                            },
                                            className: "text-center-area c15 fs1rem fw400",
                                            children: "Workflow Completeness"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc fdc progress-box-vertical-dashboard",
                    style: {
                        width: '162px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box-vertical mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-5rem c15",
                                            children: "Low"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-5rem c15",
                                            children: "High"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress progress-bar-vertical style-two",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "progress-bar progress-bar-striped progress-bar-animated",
                                        role: "progressbar",
                                        style: {
                                            width: `${completenessPrecentage}%`
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "precentage-block",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("k3MW3")),
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-75rem mb0-5rem arrow-right",
                                                    children: completenessPrecentage < 35 ? "Below Average" : completenessPrecentage > 70 ? "Above Average" : "Average"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        marginBottom: "0",
                                        fontSize: "12px"
                                    },
                                    className: "text-center-area c15",
                                    children: "Completeness"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box-vertical style-two mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-5rem c15",
                                            children: "Low"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-5rem c15",
                                            children: "High"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress progress-bar-vertical",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        role: "progressbar",
                                        style: {
                                            width: `${ristPrecentage}%`
                                        },
                                        className: "progress-bar progress-bar-striped progress-bar-animated",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "precentage-block",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("k3MW3")),
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-75rem mb0-5rem arrow-right",
                                                    children: ristPrecentage < 35 ? "Below Average" : ristPrecentage > 70 ? "Above Average" : "Average"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        marginBottom: "0",
                                        fontSize: "12px"
                                    },
                                    className: "text-center-area c15",
                                    children: "Risk"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcse mt0-5rem mx1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "certificate-area-dashboard",
                            children: company["cLevel"] && (company["subscription"] == "Pro" || company["subscription"] == "Pro Plus") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    "data-tooltip": "Certification",
                                    to: permissionAccess == "ALL" && `/company/${company['_id']}#unaudited-certification`,
                                    className: "cp",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54119cc183dc6bdf$export$2e2bcd8739ae039), {
                                        className: "op70",
                                        component: "Clients",
                                        level: company["subscription"] == "Lite" ? "None" : company["cLevel"],
                                        expiryTimestamp: company["createdAt"],
                                        company: company,
                                        subscription: company["subscription"]
                                    })
                                })
                            })
                        }),
                        !permissionAccess && (user['role'] == 'Advisor' || user['role'] == 'Investor') && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "cp bg1",
                            onClick: handleInviteResend,
                            title: "Resend invitation",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                "data-tooltip": "Resend invitation",
                                className: "fa fa-repeat c7",
                                style: {
                                    fontSize: "20px"
                                }
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb py1rem add-client-area",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: "addCompany"
                                            })),
                                        className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "h30px w30px",
                                                    width: "38",
                                                    height: "38",
                                                    viewBox: "0 0 38 38",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                            "clip-path": "url(#clip0_2656_879)",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                                                    fill: "#FAFAFA"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                id: "clip0_2656_879",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                    width: "38",
                                                                    height: "38",
                                                                    fill: "white"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "c15 pr",
                                                children: [
                                                    "Add ",
                                                    user['role'] == 'Investor' ? ' Portfolio Company' : ' Client'
                                                ]
                                            })
                                        ]
                                    }),
                                    user['role'] == 'Advisor' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "right-info-hyper-icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "hover-list-icon pr cp",
                                            onClick: ()=>handleHowItWorks(HOW_TO_POPUPS['add-client']),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 27 27",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "13.5",
                                                            cy: "13.5",
                                                            r: "13.5",
                                                            fill: "#59B8FD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                            fill: "white"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "overlay-box",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "c15 df aic",
                                                        children: [
                                                            "How does it work?",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: "icon",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    width: "12",
                                                                    height: "14",
                                                                    viewBox: "0 0 12 14",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                        fill: "#505050"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'groupCompanies'
                                    })),
                                className: `${companies && companies.length <= 1 && 'op20 pen '} df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "h30px w30px",
                                            width: "38",
                                            height: "38",
                                            viewBox: "0 0 38 38",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    "clip-path": "url(#clip0_2656_879)",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                            fill: "#4A67FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                                            fill: "#FAFAFA"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                        id: "clip0_2656_879",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                            width: "38",
                                                            height: "38",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15",
                                        children: "Create Group"
                                    })
                                ]
                            })
                        ]
                    }),
                    companies && companies.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem pl1rem bsbb aic mr1rem cp add-btn-dashboard add-btn-dashboard-switch pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                className: "fs0-75rem fw600",
                                children: benchmark ? `${user["role"] == "Investor" ? "Investor" : "Client"} Portfolio Benchmark` : "Overall Benchmark"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                className: "dashboard-benchmark-switch",
                                defaultChecked: benchmark,
                                onChange: (e)=>setBenchmark(e.target.checked)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "right-info-hyper-icon",
                                style: {
                                    top: '-8px',
                                    right: '2px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "hover-list-icon  pr cp ml0-5rem",
                                    onClick: ()=>handleHowItWorks(HOW_TO_POPUPS['client-benchmarking']),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 27 27",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "13.5",
                                                    cy: "13.5",
                                                    r: "13.5",
                                                    fill: "#59B8FD"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                    fill: "white"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "overlay-box",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c15 df aic",
                                                children: [
                                                    "How does it work?",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "12",
                                                            height: "14",
                                                            viewBox: "0 0 12 14",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                fill: "#505050"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            companies && companies.length > 0 ? companies.map((company, idx)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dropdown-company-dahboard",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg gtcr6-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf clientCard",
                            style: {
                                border: '1px solid #7385BE50',
                                backgroundColor: '#F0F2FD50'
                            },
                            children: showCompanyDetails(company)
                        }),
                        company['childrenCompanies'] && company['childrenCompanies'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dropdown-content",
                                children: company['childrenCompanies'] && company['childrenCompanies'].map((childrenCompany, idx)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "dg gtcr6-md gg1rem py0-5rem px1rem br20px aic bg29 fs1rem mb1rem company-dashboard-sf",
                                        style: {
                                            border: '1px solid #7385BE50',
                                            backgroundColor: '#F0F2FD50'
                                        },
                                        children: showCompanyDetails(childrenCompany)
                                    }, idx);
                                })
                            })
                        })
                    ]
                }, idx);
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: noClients && /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "tac c15 fs1-75rem pt1rem pb3rem lh2 fw500",
                    children: user['role'] == 'Investor' ? 'No Portfolio Company Added' : 'No Clients Added'
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'advisorEventsHistory',
                modalCardClasses: "mawmc",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "c15 fs1-5rem fw600 tac ttu mb1rem",
                            children: "Advisor Events History"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            id: "table",
                            className: "table-activation-advisor",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "ps t0",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1-25rem c15",
                                                children: "Subject"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1-25rem c15",
                                                children: "Sent By"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1-25rem c15",
                                                children: "Sent To"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1-25rem c15",
                                                children: "Date"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "fs1-25rem c15",
                                                children: "Email"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: eventsHistory && Object.keys(eventsHistory).sort().map((event)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c6 fs1rem",
                                                    children: eventsHistory[event]["subject"] || eventsHistory[event]["type"]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c11 fs1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: eventsHistory[event]["from"] ? eventsHistory[event]["from"] : "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c11 fs1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: eventsHistory[event]["email"] ? eventsHistory[event]["email"] : "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "c6 fs1rem",
                                                    children: [
                                                        " ",
                                                        event ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Number(event)).format("lll") : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "df jcc w100",
                                                    children: eventsHistory[event]["html"] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        onClick: ()=>hanleViewEmail(eventsHistory[event]["html"], eventsHistory[event]["attachments"]),
                                                        className: "shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu my0-5rem fs0-75rem",
                                                        children: "View Email"
                                                    })
                                                })
                                            ]
                                        });
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'viewEventEmail',
                modalCardClasses: "mawmc",
                onCloseHandler: ()=>handleEventHistory(eventsHistory),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: viewEmail && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: viewEmail
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'removeCompanyFromDashboard',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row fdc tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                sx: {
                                    fontSize: '8rem',
                                    margin: '20px auto',
                                    color: "#FC7785"
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "c15 fs14px",
                                children: [
                                    "Are you sure to remove ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: deleteSelectedCompany?.['cName']
                                    }),
                                    " from your dashboard?"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcc mt2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                onClick: ()=>{
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })), setDeleteSelectedCompany(null);
                                },
                                customClassName: "c1 mr1rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: "Delete",
                                btnType: "warning",
                                onClick: handleRemoveFromDashboard
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

parcelRequire("acw62");


const $d9dd3aa6d00e57e5$var$SkeletonCard = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w25 keyfeature-wihte-item bg1 new-shadow br15px p1-5rem zi9 pr bsbb",
        style: {
            borderColor: '#e0e0e0'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic pr w100 mb2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "skeleton-pulse br5px mr0-5rem",
                        style: {
                            width: '50px',
                            height: '50px',
                            flexShrink: 0,
                            background: '#e8eaf0'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc w100 gg0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "skeleton-pulse br5px",
                                style: {
                                    width: '40%',
                                    height: '10px',
                                    background: '#e8eaf0'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "skeleton-pulse br5px",
                                style: {
                                    width: '70%',
                                    height: '14px',
                                    background: '#e8eaf0'
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w90 df jcsb mt2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc gg0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "skeleton-pulse br5px",
                                style: {
                                    width: '100px',
                                    height: '10px',
                                    background: '#e8eaf0'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "skeleton-pulse br5px",
                                style: {
                                    width: '70px',
                                    height: '10px',
                                    background: '#e8eaf0'
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "skeleton-pulse br50px",
                        style: {
                            width: '90px',
                            height: '30px',
                            background: '#e8eaf0'
                        }
                    })
                ]
            })
        ]
    });


function $d9dd3aa6d00e57e5$export$2e2bcd8739ae039({ company: company, companyId: companyId, isLoading: isLoading }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const moduleTooltip = (sections)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "module-tooltip-box",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "hover-list",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("9gCOW")),
                        className: "pa",
                        alt: "list-img"
                    })
                }),
                sections && sections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "tooltip-area",
                    children: sections.map((section, idx)=>{
                        let completeness = section.stats.completionPercent;
                        let riskColour;
                        if (section.stats.riskPercent < 38) riskColour = 7;
                        else if (section.stats.riskPercent > 62) riskColour = 9;
                        else riskColour = 8;
                        let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            style: {
                                background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                            },
                            className: "overlay-box tal w100 tac cp c3-hover",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: section['sectionName']
                            })
                        }, idx);
                    })
                })
            ]
        });
    };
    const sortModules = (a, b)=>{
        return new Date(a.createdAt) - new Date(b.createdAt);
    };
    const createChecklistModule = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: `/createChecklist?companyId=${company['_id']};cName=${company['cName']}`,
            className: "cp w25 keyfeature-wihte-item new-shadow br15px p2rem zi9 pr bsbb cp df",
            style: {
                backgroundColor: '#4A67FF',
                borderColor: '#4A67FF50'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        className: "icon mr2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "38",
                            height: "38",
                            viewBox: "0 0 38 38",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                    "clip-path": "url(#clip0_3761_5532)",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                            fill: "#FAFAFA"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                            fill: "#AAACB5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                        id: "clip0_3761_5532",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                            width: "38",
                                            height: "38",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "c1 fs1-25rem fw400",
                        children: "Create New Checklist Module"
                    })
                ]
            })
        });
    };
    const editChecklistModule = async (module)=>window.open(`/createChecklist?companyId=${company['_id']};cName=${company['cName']}#${module?.['_id']}`, '_blank');
    const checklistModule = (module)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p1-5rem zi9 pr",
            style: {
                borderColor: module['isActive'] ? '#2cff28' : '#bdbdbd'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic pr w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: module['isActive'] && `/company/${company['_id']}#${module['type']}`,
                            onClick: ()=>{
                                module['isActive'] && localStorage.setItem('isAnylistBuilder', true);
                            },
                            className: `df w100 ${!module['isActive'] && ' op0-5'}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                    className: "df jcc icon-diligenstia w20 mr0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "br5px w50px",
                                            src: module?.['imageURL'] || (parcelRequire("jSVu6")),
                                            alt: "logo image"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `activedeactive-area`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "overlay-box",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15 df aic",
                                                    children: module['isActive'] ? 'Activated' : 'Deactivated'
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs1rem fw500 c15 lh2 title-box-feature w80",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "db ttc",
                                            style: {
                                                color: '#15131350',
                                                fontSize: '9px'
                                            },
                                            children: [
                                                module['category'],
                                                " | ",
                                                module['genType']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: module['isActive'] ? `c15 c3-hover` : `c12`,
                                            children: module?.type
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            className: "edit-remove w20 df jcc",
                            to: `/createChecklist?companyId=${company['_id']};cName=${company['cName']}#${module?.['_id']}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "21",
                                height: "21",
                                viewBox: "0 0 21 21",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_3761_5360)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M19.25 9.625C19.0179 9.625 18.7954 9.71719 18.6313 9.88128C18.4672 10.0454 18.375 10.2679 18.375 10.5V15.75C18.375 16.4462 18.0984 17.1139 17.6062 17.6062C17.1139 18.0984 16.4462 18.375 15.75 18.375H5.25C4.55381 18.375 3.88613 18.0984 3.39384 17.6062C2.90156 17.1139 2.625 16.4462 2.625 15.75V5.25C2.625 4.55381 2.90156 3.88613 3.39384 3.39384C3.88613 2.90156 4.55381 2.625 5.25 2.625H10.5C10.7321 2.625 10.9546 2.53281 11.1187 2.36872C11.2828 2.20462 11.375 1.98206 11.375 1.75C11.375 1.51794 11.2828 1.29538 11.1187 1.13128C10.9546 0.967187 10.7321 0.875 10.5 0.875H5.25C4.67547 0.875 4.10656 0.988163 3.57576 1.20803C3.04496 1.42789 2.56266 1.75015 2.15641 2.15641C1.33594 2.97688 0.875 4.08968 0.875 5.25V15.75C0.875 16.3245 0.988163 16.8934 1.20803 17.4242C1.42789 17.955 1.75015 18.4373 2.15641 18.8436C2.97688 19.6641 4.08968 20.125 5.25 20.125H15.75C16.3245 20.125 16.8934 20.0118 17.4242 19.792C17.955 19.5721 18.4373 19.2498 18.8436 18.8436C19.2498 18.4373 19.5721 17.955 19.792 17.4242C20.0118 16.8934 20.125 16.3245 20.125 15.75V10.5C20.125 10.2679 20.0328 10.0454 19.8687 9.88128C19.7046 9.71719 19.4821 9.625 19.25 9.625Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M6.89501 9.15262C6.65014 9.39718 6.45605 9.68775 6.3239 10.0076C6.19175 10.3275 6.12416 10.6703 6.12501 11.0164V12.2501C6.12501 12.9463 6.40157 13.614 6.89385 14.1063C7.38614 14.5986 8.05381 14.8751 8.75001 14.8751H9.98376C10.3298 14.876 10.6727 14.8084 10.9925 14.6762C11.3124 14.5441 11.6029 14.35 11.8475 14.1051L19.355 6.59762C19.5997 6.35374 19.7939 6.06396 19.9264 5.74489C20.0589 5.42582 20.1271 5.08373 20.1271 4.73824C20.1271 4.39275 20.0589 4.05067 19.9264 3.73159C19.7939 3.41252 19.5997 3.12274 19.355 2.87887L18.1213 1.64512C17.8774 1.4004 17.5876 1.20623 17.2685 1.07374C16.9495 0.941247 16.6074 0.873047 16.2619 0.873047C15.9164 0.873047 15.5743 0.941247 15.2552 1.07374C14.9362 1.20623 14.6464 1.4004 14.4025 1.64512L6.89501 9.15262ZM16.8788 2.87887L18.1213 4.12137C18.2842 4.28531 18.3757 4.50708 18.3757 4.73824C18.3757 4.9694 18.2842 5.19117 18.1213 5.35512L17.3688 6.12512L14.875 3.63137L15.6275 2.87887C15.709 2.79553 15.8063 2.72931 15.9138 2.6841C16.0212 2.63889 16.1366 2.6156 16.2531 2.6156C16.3697 2.6156 16.4851 2.63889 16.5925 2.6841C16.6999 2.72931 16.7973 2.79553 16.8788 2.87887ZM7.87501 11.0164C7.87434 10.9012 7.89641 10.7871 7.93996 10.6804C7.9835 10.5738 8.04766 10.4769 8.12876 10.3951L13.65 4.87387L16.1263 7.35012L10.605 12.8714C10.5232 12.9525 10.4263 13.0166 10.3197 13.0602C10.2131 13.1037 10.0989 13.1258 9.98376 13.1251H8.75001C8.51794 13.1251 8.29538 13.0329 8.13129 12.8688C7.9672 12.7047 7.87501 12.4822 7.87501 12.2501V11.0164Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_3761_5360",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "21",
                                                height: "21",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                module['isActive'] && module?.['sections'] && module?.['sections'].length > 0 && moduleTooltip(module['sections']),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w90 df jcsb mt2rem bottom-details",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `df fdc ${!module['isActive'] && ' op0-5'}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "c15 fs0-75rem fw300",
                                    children: [
                                        "Creator: ",
                                        module['createdBy']['firstName'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: module['createdBy']['firstName'] + ' ' + module['createdBy']['lastName']
                                        }) : module['createdBy']['role']
                                    ]
                                }),
                                (module?.['createdAt'] || module?.['sections']?.[0]?.['createdAt']) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15 fs0-75rem fw300",
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module['createdAt'] || module?.['sections']?.[0]?.['createdAt']).format('L')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `df bg1 br50px bw1px bss fs0-75rem px1rem py0-5rem mb1rem mr1rem bsbb aic ${module['isActive'] ? 'bo3 c3' : 'bo12 c12'}`,
                            children: module['isActive'] ? 'Activated' : 'Deactivated'
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sectionWrapper p1rem fs0-75rem pr anylist-builder-tab",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "dashboard-tools-area",
                style: {
                    clear: 'both'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "box-dashbord-container mla mra mb6rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `keyfeature-box-core-dashboard`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem bss p2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb2rem pr bsbb",
                            style: {
                                backgroundColor: '#ff00960a'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg20 bss bsbb bo3 p2rem br25px w100 keyfeature-box keyfeature-box-core df fww keyfeature-box-two keyfeature-box-anylist pr bsbb gg1-5rem",
                                style: {
                                    borderColor: '#4A67FF50'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                        className: "fs1-25rem c15 w100 pl2rem mb1rem",
                                        children: [
                                            user?.['role'] && user['role'],
                                            " - Generic Checklists - Across Clients"
                                        ]
                                    }),
                                    createChecklistModule(),
                                    isLoading ? [
                                        1,
                                        2,
                                        3
                                    ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d9dd3aa6d00e57e5$var$SkeletonCard, {}, i)) : Object.values(company?.['checklistModules'] || {}).filter((item)=>item?.['category'] == "external" && !item['isHealthBoost'] && item?.['companies']?.[company['_id']] && Object.keys(item?.['companies']).length !== 1).sort(sortModules).map((module)=>checklistModule(module))
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");









var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bae8d0b4be16a32a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');




var $acw62 = parcelRequire("acw62");


var $d683b97fd1dcbc68$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($d683b97fd1dcbc68$exports, "__esModule", {
    value: true
});
$d683b97fd1dcbc68$exports.default = void 0;

var $d683b97fd1dcbc68$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d683b97fd1dcbc68$var$_default = $d683b97fd1dcbc68$exports.default = (0, $d683b97fd1dcbc68$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');









var $ayMG0 = parcelRequire("ayMG0");


const $9dc40fba00dc8e3b$var$styled = (0, $9a7e913a82f46e5c$export$2e2bcd8739ae039)();
var $9dc40fba00dc8e3b$export$2e2bcd8739ae039 = $9dc40fba00dc8e3b$var$styled;




const $46d24579fa175350$var$StyledFormControl = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039))(({ theme: theme })=>({
        '& .MuiInputLabel-root': {
            color: '#666',
            fontSize: '16px',
            fontWeight: 500,
            '&.Mui-focused': {
                color: '#2979ff'
            },
            '&.MuiInputLabel-shrink': {
                backgroundColor: 'white',
                padding: '0 8px',
                fontSize: '14px'
            }
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '24px',
            backgroundColor: 'white',
            boxShadow: '0 0 0 1px #e0e0e0',
            '& fieldset': {
                borderColor: '#e0e0e0',
                borderRadius: '24px'
            },
            '&:hover fieldset': {
                borderColor: '#b0b0b0'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#2979ff',
                borderWidth: '2px'
            }
        }
    }));
const $46d24579fa175350$var$StyledSelect = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039))(({ theme: theme })=>({
        padding: '6px 12px',
        fontStyle: 'italic',
        fontWeight: 500,
        fontSize: '16px',
        minWidth: '160px',
        width: '200px',
        '& .MuiSelect-icon': {
            color: '#2979ff'
        }
    }));
function $46d24579fa175350$export$2e2bcd8739ae039({ user: user, getQualifiedLeads: getQualifiedLeads }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { query: { sort: sort, page: page, limit: limit } } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.common);
    const handleChange = async (event)=>{
        dispatch((0, $defbea5c5b83142b$export$4833f4501cec619d)({
            sort: event.target.value
        }));
        await getQualifiedLeads(user?.['companyId']?.['_id'], `sortBy=${event.target.value}&page=${page}&limit=${limit}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($46d24579fa175350$var$StyledFormControl, {
        variant: "outlined",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                id: "sort-by-label",
                children: "Sort by"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($46d24579fa175350$var$StyledSelect, {
                labelId: "sort-by-label",
                value: sort || '',
                onChange: handleChange,
                label: "Sort by",
                MenuProps: {
                    PaperProps: {
                        style: {
                            borderRadius: 16
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: "",
                        children: "None"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: "date",
                        children: "Date"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: "fitScore",
                        children: "Fit score"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: "receivedDate",
                        children: "Received Date"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                        value: "responseDate",
                        children: "Response Date"
                    })
                ]
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e1ec0b0c4e143dec$export$427f1c1e2e839f85(slot) {
    return (0, $4Cod0.default)('MuiPagination', slot);
}
const $e1ec0b0c4e143dec$var$paginationClasses = (0, $beCSm.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
var $e1ec0b0c4e143dec$export$2e2bcd8739ae039 = $e1ec0b0c4e143dec$var$paginationClasses;



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

'use client';
const $fcf3350ab6dcf91e$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $fcf3350ab6dcf91e$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = 'usePagination', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $1En50.default)(props, $fcf3350ab6dcf91e$var$_excluded);
    const [page, setPageState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled: disabled,
            'aria-current': item === page ? 'true' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return (0, $8nd05.default)({
        items: items
    }, other);
}



var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $kTdcz = parcelRequire("kTdcz");


var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6a3264dc4d579370$export$e4ce0a775adf2f74(slot) {
    return (0, $4Cod0.default)('MuiPaginationItem', slot);
}
const $6a3264dc4d579370$var$paginationItemClasses = (0, $beCSm.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
var $6a3264dc4d579370$export$2e2bcd8739ae039 = $6a3264dc4d579370$var$paginationItemClasses;




var $jTnBY = parcelRequire("jTnBY");


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $26ce82c6cc8a75d9$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5ef22e36056d1791$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6a273894865f8b08$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $6a273894865f8b08$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const $6a273894865f8b08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, $jTnBY.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, $jTnBY.default)(color)}`,
            color !== 'standard' && `${variant}${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6a3264dc4d579370$export$e4ce0a775adf2f74), classes);
};
const $6a273894865f8b08$var$PaginationItemEllipsis = (0, $d8seH.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }));
const $6a273894865f8b08$var$PaginationItemPage = (0, $d8seH.default)((0, $4a35786d89db9dda$export$2e2bcd8739ae039), {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver: $6a273894865f8b08$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({}, ownerState.variant === 'text' && {
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: (0, $8nd05.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === 'outlined' && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
        [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).selected}`]: (0, $8nd05.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $kTdcz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $6a3264dc4d579370$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $6a273894865f8b08$var$PaginationItemPageIcon = (0, $d8seH.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $8nd05.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px'
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $6a273894865f8b08$var$PaginationItem = /*#__PURE__*/ $acw62.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className: className, color: color = 'standard', component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = 'circular', size: size = 'medium', slots: slots = {}, type: type = 'page', variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $6a273894865f8b08$var$_excluded);
    const ownerState = (0, $8nd05.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const isRtl = (0, $889f7a05097f3e52$export$b2dd014b6c321cb)();
    const classes = $6a273894865f8b08$var$useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, $5ef22e36056d1791$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $26ce82c6cc8a75d9$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $17a626ba35acf52f$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $3dba169293b5f5f0$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $26ce82c6cc8a75d9$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $5ef22e36056d1791$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $17a626ba35acf52f$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $3dba169293b5f5f0$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($6a273894865f8b08$var$PaginationItemPage, (0, $8nd05.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: [
            type === 'page' && page,
            Icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($6a273894865f8b08$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $6a273894865f8b08$export$2e2bcd8739ae039 = $6a273894865f8b08$var$PaginationItem;



var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $081224c8d3cb055f$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $081224c8d3cb055f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e1ec0b0c4e143dec$export$427f1c1e2e839f85), classes);
};
const $081224c8d3cb055f$var$PaginationRoot = (0, $d8seH.default)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $081224c8d3cb055f$var$PaginationUl = (0, $d8seH.default)('ul', {
    name: 'MuiPagination',
    slot: 'Ul',
    overridesResolver: (props, styles)=>styles.ul
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function $081224c8d3cb055f$var$defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const $081224c8d3cb055f$var$Pagination = /*#__PURE__*/ $acw62.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = 'standard', count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $081224c8d3cb055f$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a273894865f8b08$export$2e2bcd8739ae039), (0, $8nd05.default)({}, item)), shape: shape = 'circular', showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = 'medium', variant: variant = 'text' } = props, other = (0, $1En50.default)(props, $081224c8d3cb055f$var$_excluded);
    const { items: items } = (0, $fcf3350ab6dcf91e$export$2e2bcd8739ae039)((0, $8nd05.default)({}, props, {
        componentName: 'Pagination'
    }));
    const ownerState = (0, $8nd05.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $081224c8d3cb055f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationRoot, (0, $8nd05.default)({
        "aria-label": "pagination navigation",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($081224c8d3cb055f$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                    children: renderItem((0, $8nd05.default)({}, item, {
                        color: color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $081224c8d3cb055f$export$2e2bcd8739ae039 = $081224c8d3cb055f$var$Pagination;





const $b05d3f61517eaedd$var$StyledPagination = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)((0, $081224c8d3cb055f$export$2e2bcd8739ae039))(({ theme: theme })=>({
        '& .MuiPagination-ul': {
            display: 'flex',
            gap: '8px',
            backgroundColor: '#f7f8fa',
            padding: '8px 16px',
            borderRadius: '999px'
        },
        '& .MuiPaginationItem-root': {
            borderRadius: '999px',
            fontWeight: 500,
            minWidth: 36,
            height: 36
        },
        '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: '#fff',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
            color: '#151313'
        },
        '& .MuiPaginationItem-ellipsis': {
            color: '#888'
        }
    }));
const $b05d3f61517eaedd$var$CustomPagination = ({ getQualifiedLeads: getQualifiedLeads, user: user })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { query: { page: page, column: column, totalPages: totalPages, limit: limit } } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.common);
    const handleChange = async (_, value)=>{
        dispatch((0, $defbea5c5b83142b$export$4833f4501cec619d)({
            limit: 20,
            page: value
        }));
        await getQualifiedLeads(user?.['companyId']?.['_id'], `sortBy=${column}&page=${value}&limit-${limit}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mt3rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $231d58234d437bc0$export$2e2bcd8739ae039), {
            spacing: 2,
            alignItems: "center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($b05d3f61517eaedd$var$StyledPagination, {
                count: totalPages,
                page: page,
                onChange: handleChange,
                shape: "rounded",
                renderItem: (item)=>{
                    if (item.type === 'previous') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a273894865f8b08$export$2e2bcd8739ae039), {
                        ...item,
                        sx: {
                            fontWeight: 600,
                            borderRadius: '999px',
                            padding: '6px 20px',
                            backgroundColor: '#fff',
                            color: '#aaa',
                            border: '1px solid #e0e0e0',
                            pointerEvents: item.disabled ? 'none' : 'auto'
                        },
                        slots: {
                            previous: ()=>"\u2039 Back"
                        }
                    });
                    if (item.type === 'next') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a273894865f8b08$export$2e2bcd8739ae039), {
                        ...item,
                        sx: {
                            fontWeight: 600,
                            borderRadius: '999px',
                            padding: '6px 20px',
                            backgroundColor: '#2979ff',
                            color: '#fff',
                            border: 'none',
                            '&:hover': {
                                backgroundColor: '#1565c0'
                            }
                        },
                        slots: {
                            next: ()=>"Next \u203A"
                        }
                    });
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a273894865f8b08$export$2e2bcd8739ae039), {
                        ...item,
                        sx: {
                            '&.Mui-selected': {
                                fontWeight: 'bold'
                            }
                        }
                    });
                }
            })
        })
    });
};
var $b05d3f61517eaedd$export$2e2bcd8739ae039 = $b05d3f61517eaedd$var$CustomPagination;



var $ayMG0 = parcelRequire("ayMG0");



const $3ae7ac751da185d0$var$WarningInvestmentCriteria = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: 'warningToCompleteInvestmentCriteria',
            modalCardClasses: "p2rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 tac mb2rem fs14px",
                    children: [
                        "You haven\u2019t completed your Investment Criteria yet. Without it, the company analysis and suggestions may not be fully accurate. Click ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fw600",
                            children: "Proceed"
                        }),
                        " to complete your Investment Criteria, or select ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fw600",
                            children: "Ignore & Proceed"
                        }),
                        " to continue without completing it."
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcc my1rem g1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            customClassName: "mr1rem",
                            text: "Proceed",
                            onClick: ()=>navigate(`/investor-setting#InvestorMatch%20Criteria`)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            btnType: "warning",
                            text: "Ignore & Proceed",
                            onClick: ()=>navigate(`/manualAdd`)
                        })
                    ]
                })
            ]
        })
    });
};
var $3ae7ac751da185d0$export$2e2bcd8739ae039 = $3ae7ac751da185d0$var$WarningInvestmentCriteria;












function $a11307d75d69df9b$export$2e2bcd8739ae039({ loading: loading, user: user, company: company, promptScore: promptScore, qualifiedLeads: qualifiedLeads, investors: investors, saveInvestorMember: saveInvestorMember, getQualifiedLeads: getQualifiedLeads, setQualifiedLeads: setQualifiedLeads }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [selectedLead, setSelectedLead] = (0, $acw62.useState)({});
    const [bestApplicants, setBestApplicants] = (0, $acw62.useState)(false);
    const allQualifiedLeadsRef = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(()=>{
        if (qualifiedLeads.length > 0 && !bestApplicants) allQualifiedLeadsRef.current = qualifiedLeads;
    }, [
        qualifiedLeads
    ]);
    const handleBestApplicantsToggle = ()=>{
        const newValue = !bestApplicants;
        setBestApplicants(newValue);
        if (newValue) setQualifiedLeads(allQualifiedLeadsRef.current.filter((lead)=>lead.fitScorePercentage >= 50));
        else setQualifiedLeads(allQualifiedLeadsRef.current);
    };
    const handleInvestorMember = (leadId, member)=>{
        if (typeof member == 'object') saveInvestorMember(leadId, member['_id']);
    };
    const { strongCount: strongCount, mediumCount: mediumCount, lowCount: lowCount } = (0, $acw62.useMemo)(()=>{
        if (!qualifiedLeads?.length) return {
            strongCount: 0,
            mediumCount: 0,
            lowCount: 0
        };
        return qualifiedLeads.reduce((acc, investor)=>{
            const score = investor.fitScorePercentage;
            if (score > 83) acc.strongCount++;
            else if (score >= 66.6 && score <= 83) acc.mediumCount++;
            else if (score < 66.6) acc.lowCount++;
            return acc;
        }, {
            strongCount: 0,
            mediumCount: 0,
            lowCount: 0
        });
    }, [
        qualifiedLeads
    ]);
    const downloadPDF = async ()=>{
        try {
            const wrapper = document.getElementById("table");
            const filename = [
                `DG-InvestorLeads-${company['cName'].substring(0, 7)}-[${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now()).format("ll")}]`
            ].join(" - ");
            const opt = {
                filename: filename,
                jsPDF: {
                    unit: 'mm',
                    format: 'a2',
                    orientation: 'p'
                }
            };
            await (0, (/*@__PURE__*/$parcel$interopDefault($8994635913a5668f$exports)))().set(opt).from(wrapper).save();
        } catch (e) {
            console.error(e);
        }
    };
    const handleArchiveLead = async (investorId, clientId)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteInvestorLead`, {
            investorId: investorId,
            clientId: clientId
        });
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (res && res['code'] == 200) {
            setQualifiedLeads([]);
            await getQualifiedLeads(company['_id']);
        }
    };
    const handleAddApplicant = ()=>{
        const invalidFields = [
            "annualProfits",
            "annualRevenues",
            "sweetSpot",
            "fundSize"
        ].filter((key)=>company[key] === "Not known");
        if (invalidFields.length > 0 || !company['investment'] || !company['ukRegions'] || company['preferredSectors']['sector1'] === 'Not Selected' || !company['employees']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'warningToCompleteInvestmentCriteria'
        }));
        else navigate(`/manualAdd`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "dropdown-company-dahboard leads-page poppins-font-style *",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "fs2rem df aic jcc c15 mt1rem",
                children: [
                    "Investor",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c4 mr0-5rem",
                        children: "Match"
                    }),
                    " Index"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb pt0rem pl3rem pr3rem aife",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aife",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    onClick: handleAddApplicant,
                                    className: "bo31 bw1px bss br50px c15 df aic jcc fs14px p0-5rem fw400 cp",
                                    style: {
                                        height: '48px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("5DQVD")),
                                                alt: "report"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "px0-5rem",
                                            children: "Add Applicant"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/investor-setting#InvestorMatch%20Criteria`,
                                    className: "bo31 bw1px bss br50px c15 df aic jcc fs14px p0-5rem fw400 cp ml1rem",
                                    style: {
                                        height: '48px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("dcVB2")),
                                                alt: "report"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "px0-5rem",
                                            children: "Investment Criteria"
                                        })
                                    ]
                                }),
                                company?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/investorMatchStats?companyId=${company['_id']}`,
                                    className: "bo31 bw1px bss br50px c15 df aic jcc fs14px p0-5rem fw400 cp ml1rem",
                                    style: {
                                        height: '48px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "mr0-5rem df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("f7BbQ")),
                                                alt: "report"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "px0-5rem",
                                            children: "Module Report/Stats"
                                        })
                                    ]
                                }),
                                qualifiedLeads && qualifiedLeads.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    onClick: downloadPDF,
                                    className: "df aic jcc c1 bg3 py0-5rem px1-5rem br50px mr1rem cp fs14px ml1rem",
                                    style: {
                                        height: '48px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {
                                            className: "c1 mr0-5rem"
                                        }),
                                        "Download PDF"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aife rightBar",
                        children: [
                            qualifiedLeads && qualifiedLeads.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "df aic cp bw2px bo16 bss br30px",
                                        style: {
                                            padding: '3px 15px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c15 fs14px fw500 mr0-5rem",
                                                children: "Best Applicants"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                name: "bestApplicants",
                                                className: "success w100",
                                                checked: bestApplicants,
                                                onChange: handleBestApplicantsToggle
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mr2rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46d24579fa175350$export$2e2bcd8739ae039), {
                                            getQualifiedLeads: getQualifiedLeads,
                                            user: user
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `progress-area-report progress-fit-report mb2rem`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-area",
                                    style: {
                                        display: 'flex',
                                        position: 'relative',
                                        justifyContent: 'end',
                                        alignItems: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "progress-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "progress-bar",
                                                style: {
                                                    width: 80,
                                                    height: 80,
                                                    backgroundColor: '#FBFBFB',
                                                    borderRadius: '50%'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                    className: `${promptScore > 83 ? 'green' : promptScore > 66.6 ? 'orange' : 'red'}`,
                                                    value: promptScore || 0,
                                                    text: `${promptScore || 0}%`,
                                                    strokeWidth: 18,
                                                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                        strokeLinecap: 'round',
                                                        strokeWidth: '5px',
                                                        textSize: '18px',
                                                        pathTransitionDuration: 0.5,
                                                        trailColor: '#d6d6d6',
                                                        backgroundColor: '#fc7785',
                                                        dominantBaseline: 'ideographic'
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "tooltip-area cp pr",
                                                style: {
                                                    top: '83px',
                                                    left: '-24px',
                                                    width: '14px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                    className: "icon",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            classNaw2rem: true,
                                                            me: "h2rem",
                                                            width: "18",
                                                            height: "19",
                                                            viewBox: "0 0 18 19",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    "clip-path": "url(#clip0_2661_6508)",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M9 18.1133C13.9628 18.1133 18 14.076 18 9.11328C18 4.15052 13.9628 0.113281 9 0.113281C4.03724 0.113281 0 4.15052 0 9.11328C0 14.076 4.03724 18.1133 9 18.1133ZM9 1.91328C12.97 1.91328 16.2 5.14326 16.2 9.11328C16.2 13.0833 12.97 16.3133 9 16.3133C5.02998 16.3133 1.8 13.0833 1.8 9.11328C1.8 5.14326 5.02998 1.91328 9 1.91328Z",
                                                                            fill: "#FC7785"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M8.69665 11.6919C8.50359 11.6919 8.34746 11.5299 8.34746 11.3297C8.34746 10.8559 8.41225 10.4466 8.54117 10.1025C8.63575 9.84312 8.78929 9.5817 9.00049 9.31758C9.15597 9.12538 9.43454 8.84446 9.8375 8.47618C10.2405 8.10723 10.5022 7.81355 10.6233 7.59446C10.7445 7.37538 10.8041 7.13613 10.8041 6.87672C10.8041 6.40696 10.6272 5.995 10.2741 5.63949C9.92107 5.28398 9.48767 5.10656 8.97458 5.10656C8.47898 5.10656 8.06501 5.26785 7.73331 5.58976C7.49102 5.82497 7.30897 6.15696 7.18847 6.58573C7.10555 6.88008 6.82892 7.06825 6.53545 7.03196C6.16359 6.98627 5.9187 6.60454 6.02495 6.23156C6.18821 5.65831 6.4616 5.19661 6.84447 4.84581C7.37635 4.35723 8.07991 4.11328 8.95514 4.11328C9.88156 4.11328 10.6207 4.37471 11.1727 4.89823C11.7247 5.42175 12 6.05414 12 6.79608C12 7.22551 11.9028 7.62135 11.7091 7.9829C11.5154 8.34514 11.1358 8.78532 10.5715 9.30414C10.1925 9.65293 9.9444 9.91032 9.82778 10.0756C9.71117 10.241 9.62501 10.4312 9.5693 10.6455C9.52783 10.8048 9.49933 11.0387 9.48378 11.3458C9.47406 11.5394 9.31923 11.6912 9.13265 11.6912H8.69665V11.6919ZM8.28268 13.4258C8.28268 13.0461 8.57939 12.7383 8.94542 12.7383C9.31145 12.7383 9.60817 13.0461 9.60817 13.4258C9.60817 13.8055 9.31145 14.1133 8.94542 14.1133C8.57939 14.1133 8.28268 13.8055 8.28268 13.4258Z",
                                                                            fill: "#FC7785",
                                                                            stroke: "#FC7785",
                                                                            "stroke-width": "0.5"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                        id: "clip0_2661_6508",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                            width: "18",
                                                                            height: "18",
                                                                            fill: "white",
                                                                            transform: "translate(0 0.113281)"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "overlay-box",
                                                            style: {
                                                                left: 'auto',
                                                                top: '0',
                                                                right: '22px',
                                                                zIndex: '9',
                                                                width: '400px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs14px",
                                                                children: '"The Prompt Response Score is a score provided to each applicant company to indicate the promptness of any initial response from an investor \u2013 whether positive or negative". Any initial response that takes more than 10 days is marked negatively'
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    marginBottom: '0',
                                                    fontSize: '13px'
                                                },
                                                className: "text-center-area c15",
                                                children: "Prompt Response Score"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !company?.['_id'] || loading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                class: "df jcc aic py3rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$4bf83b24a11cff0b), {
                    height: "80",
                    width: "80",
                    color: "#8496f4",
                    ariaLabel: "three-dots-loading"
                })
            }) : qualifiedLeads && qualifiedLeads.length == 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "w100 mt2rem c15 fs1-75rem lh2 tac fw500",
                children: "No leads available"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "table-permission",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            id: "table",
                            className: "table-userPermissions table-clientPermissions table-leades",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "ps t0",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "index-table ttu fw500 compnay-name",
                                                style: {
                                                    textAlign: 'left !important',
                                                    width: '300px'
                                                },
                                                children: "Company"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "index-table ttu fw500 source",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: "Source"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "index-table ttu fw500 email-date",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: "Date Added"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                style: {
                                                    minWidth: '125px',
                                                    color: '#151313CC'
                                                },
                                                className: "fs1rem ttu tal customHeaderBgColor",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "br50px df fdc aifs",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df jcc aic mr0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "green mr0-5rem fs10px",
                                                                        children: strongCount
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 fs10px",
                                                                        children: "Strong"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df jcc aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "orange mr0-5rem fs10px",
                                                                        children: mediumCount
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 fs10px",
                                                                        children: "Medium"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df jcc aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "red mr0-5rem fs10px",
                                                                        children: lowCount
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 fs10px",
                                                                        children: "Low"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    "Fit Score"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                className: "index-table ttu fw500 fit-report",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: [
                                                    "Fit",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Report"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                className: "index-table ttu fw500 allocated-member",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: [
                                                    "Allocated",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Member"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "index-table ttu fw500 accepted-rejected",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: "Status "
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                className: "index-table ttu fw500 email-respond",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: [
                                                    "Response ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Email Date"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                className: "index-table ttu fw500 archive",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: [
                                                    "Diligentsia",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Certification"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "index-table ttu fw500 archive",
                                                style: {
                                                    textAlign: 'left'
                                                },
                                                children: "Archive"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: qualifiedLeads.map((lead)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            style: {
                                                backgroundColor: lead.isExampleCompany ? '#e6edf3' : 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 compnay-name tal fs14px tal",
                                                    style: {
                                                        width: '300px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        className: "c3 fs14px tal",
                                                        to: `/company/${lead['clientId']}#diligence-pack`,
                                                        onClick: ()=>{
                                                            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({})), localStorage.setItem('isQualifiedLeads', true);
                                                        },
                                                        children: lead['cName']
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 ttc source fs14px tal",
                                                    children: lead['source'] ? lead['source'] : '-'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 email-date tal",
                                                    children: lead?.['dateContacted'] && lead?.['dateContacted'] != 'Nil' ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(lead['dateContacted']).format('ll') : lead?.['createdAt'] && lead?.['createdAt'] != 'Nil' ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(lead['createdAt']).format('ll') : '-'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fit-score tal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df jcfs",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: `fs14px ml0-5rem tal ${lead['fitScorePercentage'] >= 83 ? 'green' : lead['fitScorePercentage'] <= 82 && lead['fitScorePercentage'] >= 66.6 ? 'orange' : 'red'} `,
                                                            children: `${lead['fitScorePercentage']}%`
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fit-report tal",
                                                    children: lead['clientId'] && user?.['companyId']?.['_id'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        to: `/company/${lead['clientId']}#fit-report:${user['companyId']['_id']}`,
                                                        onClick: ()=>{
                                                            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({})), localStorage.setItem('isQualifiedLeads', true);
                                                        },
                                                        className: "w2rem h2rem df jcc aic br100 bg3 bg4-hover c1 report-btn-r fs14px",
                                                        style: {
                                                            textDecoration: 'none'
                                                        },
                                                        children: "R"
                                                    }) : '-'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 allocated-member tal",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                        className: "w200px",
                                                        placeholder: "Allocate to team",
                                                        name: "investor-dropdown",
                                                        id: "investor-dropdown",
                                                        labelId: "investor-multiple-checkbox-label",
                                                        onChange: (e)=>handleInvestorMember(lead['_id'], e.target.value),
                                                        value: lead['investorMember'] || 'Allocate to team',
                                                        renderValue: (selected)=>{
                                                            if (typeof selected === 'string') return selected;
                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                style: {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    justifyContent: 'flex-start'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: selected?.profile || selected?.profilePicture || (parcelRequire("cfmAr")),
                                                                    alt: "profile",
                                                                    style: {
                                                                        width: '32px',
                                                                        height: '32px',
                                                                        borderRadius: '50%',
                                                                        margin: '0px'
                                                                    }
                                                                })
                                                            });
                                                        },
                                                        children: [
                                                            !lead['investorMember'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                value: "Allocate to team",
                                                                className: "multi-dropdown-list",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                    primary: "Allocate to team"
                                                                })
                                                            }),
                                                            investors.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                    value: option,
                                                                    className: "multi-dropdown-list",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                            checked: lead?.['investorMember']?._id === option['_id']
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                            primary: `${option.firstName} ${option.lastName}`
                                                                        })
                                                                    ]
                                                                }, option['_id']))
                                                        ]
                                                    })
                                                }),
                                                lead['leadStatus'] == 'Accepted' ? /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "accepted-rejected tal green",
                                                    children: "Approved"
                                                }) : lead['leadStatus'] == 'Rejected' ? /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "accepted-rejected tal red",
                                                    children: "Rejected"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "accepted-rejected tal orange",
                                                    children: "Pending"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 email-respond tal",
                                                    children: lead['dateLeadStatus'] != 'Nil' ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(lead['dateLeadStatus']).format('lll') : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 archive tal",
                                                    style: {
                                                        minWidth: '125px'
                                                    },
                                                    children: lead['cLevel'] == 'Gold' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w20",
                                                        src: (parcelRequire("93hnj")),
                                                        alt: "Certification"
                                                    }) : lead['cLevel'] == 'Silver' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w20",
                                                        src: (parcelRequire("iXRwJ")),
                                                        alt: "Certification"
                                                    }) : lead['cLevel'] == 'Bronze' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w20",
                                                        src: (parcelRequire("gBSL3")),
                                                        alt: "Certification"
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w20",
                                                        src: (parcelRequire("9iQ9H")),
                                                        alt: "Certification"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 archive tal",
                                                    style: {
                                                        minWidth: '125px'
                                                    },
                                                    children: lead.isExampleCompany ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                        title: "This is an example of a company with a full diligence pack",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d683b97fd1dcbc68$exports))), {
                                                            fontSize: "medium",
                                                            color: "primary",
                                                            className: "cp"
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        onClick: ()=>{
                                                            setSelectedLead(lead), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: 'archiveLeadPopup'
                                                            }));
                                                        },
                                                        src: (parcelRequire("d4clj")),
                                                        alt: "delete",
                                                        style: {
                                                            width: '24px',
                                                            height: '24px',
                                                            cursor: 'pointer'
                                                        }
                                                    })
                                                })
                                            ]
                                        }, lead._id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b05d3f61517eaedd$export$2e2bcd8739ae039), {
                            getQualifiedLeads: getQualifiedLeads,
                            user: user
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'archiveLeadPopup',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w20",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row fdc tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "c15 fs2rem fw600 tac ttu mb1rem",
                                children: "Archive Lead"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "c15 fs14px",
                                children: [
                                    "Are you sure you want to archive ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: selectedLead['cName']
                                    }),
                                    "?"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsa mt2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                customClassName: "c1 ml1rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: "Archive",
                                btnType: "warning",
                                onClick: ()=>handleArchiveLead(company['_id'], selectedLead['clientId'])
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ae7ac751da185d0$export$2e2bcd8739ae039), {})
        ]
    });
}


/* ============================================================
   Deal Management — embedded shell.
   Renders the whole module INLINE inside the investor dashboard's
   "Deal Management" tab (see Advisor/ClientIndex/index.js), the same
   way Portfolio / InvestorMatch / AnyList render their panels.

   The module is a self-contained mini-app with its own router. React
   Router v6 forbids a <Router> nested inside the app's <BrowserRouter>,
   so the module is mounted into a SEPARATE React root (its own context
   tree) where its MemoryRouter is legal. The module has no Redux / MUI
   / app-context dependencies (verified) — it uses its own contexts plus
   the global axios/socket helpers — so isolation is safe.

   Result: inline in the tab, pipeline → deal → step navigation stays
   internal (browser URL does not change), slim nav, light theme only.
   ============================================================ */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;




/* Toast — React replacement for the prototype's imperative toast() helper.
   Provides a `useToast()` hook returning showToast(message, sync) and renders
   the toast host inside the module. Auto-dismisses after ~3.2s. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $70637bf498997249$var$ToastContext = /*#__PURE__*/ (0, $acw62.createContext)(()=>{});
function $70637bf498997249$export$a407b657d3044108() {
    return (0, $acw62.useContext)($70637bf498997249$var$ToastContext);
}
function $70637bf498997249$export$f5d03d415824e0e({ children: children }) {
    const [toasts, setToasts] = (0, $acw62.useState)([]);
    const showToast = (0, $acw62.useCallback)((message, sync = false)=>{
        const id = Date.now() + Math.random();
        setToasts((prev)=>[
                ...prev,
                {
                    id: id,
                    message: message,
                    sync: sync,
                    leaving: false
                }
            ]);
        setTimeout(()=>setToasts((prev)=>prev.map((t)=>t.id === id ? {
                        ...t,
                        leaving: true
                    } : t)), 3200);
        setTimeout(()=>setToasts((prev)=>prev.filter((t)=>t.id !== id)), 3700);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($70637bf498997249$var$ToastContext.Provider, {
        value: showToast,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "toast-host",
                children: toasts.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `toast${t.sync ? ' toast--sync' : ''}`,
                        style: t.leaving ? {
                            opacity: 0,
                            transition: 'opacity 0.4s'
                        } : undefined,
                        children: t.message
                    }, t.id))
            })
        ]
    });
}


/* ============================================================
   Deal-flow module state.
   - Investor profile: the read-only mirror of the firm's Diligentsia
     investor settings, fetched once from GET /deal/profile and shared
     across the app bar, pipeline, dashboard, profile, triage, decision
     and decline flows (it is needed almost everywhere, so it lives here
     rather than being refetched per screen).
   - Session flags (decided / analysisDone) drive the stepper's
     all-ticked state and the analysis progress-vs-report switch. They
     are seeded from the backend on load and updated after mutations.
   ============================================================ */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
/* ============================================================
   Deal Management — API service layer.
   Thin wrapper over the app's shared request helpers (getRequest /
   postRequest / putRequest from src/config) that centralises every
   /api/deal endpoint. Reads return the response `body`; actions return
   the full response so callers can read `code`, `message` and `body`.
   Per-deal reads use the 'return-response' mode so a legitimate 404
   (step not generated yet) is handled in-component rather than toasting
   or logging the user out.
   ============================================================ */ 
'use strict';
// Resolve a GET into its body, or null on any non-200 (empty/not-found).
const $2f90eebb96c7748d$var$body = (res)=>res && res.code === 200 ? res.body : null;
const $2f90eebb96c7748d$export$6fc568134edf5a70 = async ()=>(0, $bebe1cbb5a309c8c$export$e17608451341e929)('/deal/pipeline', 'return-response');
const $2f90eebb96c7748d$export$631782feed7ac569 = async ()=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/deal/pipeline', 'return-response'));
const $2f90eebb96c7748d$export$720d5b271123ea20 = async ()=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/deal/dashboard', 'return-response'));
const $2f90eebb96c7748d$export$665d336fd546fbed = async ()=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/deal/profile', 'return-response'));
const $2f90eebb96c7748d$export$6bc52dcdb0a32896 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}`, 'return-response'));
const $2f90eebb96c7748d$export$d3862ebde999de49 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/intake`, 'return-response'));
const $2f90eebb96c7748d$export$4143e33485fb8ba8 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/analysis`, 'return-response'));
const $2f90eebb96c7748d$export$3ded8dfaa10f2a40 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/triage`, 'return-response'));
const $2f90eebb96c7748d$export$45a268f1d3c5b949 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/diligence`, 'return-response'));
const $2f90eebb96c7748d$export$19f00a003bc3f759 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/scenarios`, 'return-response'));
const $2f90eebb96c7748d$export$7ca6ee0ed643263f = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/memo`, 'return-response'));
const $2f90eebb96c7748d$export$5061d6c60774bd76 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/decision`, 'return-response'));
const $2f90eebb96c7748d$export$ac72dcc3828af62 = async (id)=>$2f90eebb96c7748d$var$body(await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/audit`, 'return-response'));
const $2f90eebb96c7748d$export$ad35f8678e7ef06 = (id)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/analysis/run`, {}, true); // background run; progress via sockets
const $2f90eebb96c7748d$export$2bee563b1093e80a = (id)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/scenarios/run`, {});
const $2f90eebb96c7748d$export$f66b362cf3179428 = (id, section)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/memo/regenerate`, section ? {
        section: section
    } : {});
const $2f90eebb96c7748d$export$bc8fb7dfcfd1e291 = (id, sections)=>(0, $bebe1cbb5a309c8c$export$2d492ccf07929802)(`/deal/${id}/memo`, {
        sections: sections
    });
const $2f90eebb96c7748d$export$cebf113164678c8c = (id, patch)=>(0, $bebe1cbb5a309c8c$export$2d492ccf07929802)(`/deal/${id}/triage`, patch);
const $2f90eebb96c7748d$export$6995f089eca026dc = (id)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/triage/run`, {}); // AI: generate scorecard + rationale
const $2f90eebb96c7748d$export$a43e1fdbcae080df = (id)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/triage/advance`, {});
const $2f90eebb96c7748d$export$db2c60858a9e1d35 = (id, patch)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/decline`, patch);
const $2f90eebb96c7748d$export$70b4b882616a0d2 = (id, reason)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/intake/override`, {
        reason: reason
    });
const $2f90eebb96c7748d$export$465dd44d1c8dd955 = (id, patch)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/decision`, patch);
const $2f90eebb96c7748d$export$2c52a274f01fae07 = (id, patch)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/diligence/request`, patch);
const $2f90eebb96c7748d$export$e3b778e36ea00b35 = (id, patch)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/diligence/remind`, patch);
const $2f90eebb96c7748d$export$419946e781f7e0e9 = (id, patch)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/questions`, patch);
const $2f90eebb96c7748d$export$69022347ed6cef92 = (id, patch)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/share`, patch);
const $2f90eebb96c7748d$export$b3a397e5f5a52b9f = (id, patch)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/deal/${id}/invite`, patch);
const $2f90eebb96c7748d$export$b8d30bf21159d3b1 = (text)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/deal/sandbox/analyse', {
        text: text
    });
const $2f90eebb96c7748d$export$4b8a698d6c7b2804 = ()=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/deal/dev/seed', {
        reset: false
    }); // dev: populate the caller's firm with the worked example
const $2f90eebb96c7748d$export$ae5c1992bbcb9a02 = (payload)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/deal', payload);
const $2f90eebb96c7748d$export$449e73bfb22de898 = (id, kind)=>(0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/deal/${id}/export/${kind}`, 'return-response');
const $2f90eebb96c7748d$export$dcb8b3f0e2de7e49 = (res)=>!!(res && res.code === 200);


const $3c0860f4d138445e$var$DealStateContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $3c0860f4d138445e$export$4fd56d483b8624a4({ children: children }) {
    const [decided, setDecided] = (0, $acw62.useState)(()=>new Set());
    const [analysisDone, setAnalysisDone] = (0, $acw62.useState)(()=>new Set());
    const [profile, setProfile] = (0, $acw62.useState)(null);
    const [profileLoading, setProfileLoading] = (0, $acw62.useState)(true);
    const [profileError, setProfileError] = (0, $acw62.useState)(false);
    const loadProfile = (0, $acw62.useCallback)(async ()=>{
        setProfileLoading(true);
        setProfileError(false);
        try {
            const p = await (0, $2f90eebb96c7748d$export$665d336fd546fbed)();
            setProfile(p || null);
            if (!p) setProfileError(true);
        } catch (e) {
            setProfileError(true);
        } finally{
            setProfileLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        loadProfile();
    }, [
        loadProfile
    ]);
    const markDecided = (0, $acw62.useCallback)((id)=>setDecided((s)=>new Set(s).add(String(id))), []);
    const markAnalysisDone = (0, $acw62.useCallback)((id)=>setAnalysisDone((s)=>new Set(s).add(String(id))), []);
    const value = {
        profile: profile,
        profileLoading: profileLoading,
        profileError: profileError,
        reloadProfile: loadProfile,
        isDecided: (id)=>decided.has(String(id)),
        isAnalysisDone: (id)=>analysisDone.has(String(id)),
        markDecided: markDecided,
        markAnalysisDone: markAnalysisDone
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3c0860f4d138445e$var$DealStateContext.Provider, {
        value: value,
        children: children
    });
}
function $3c0860f4d138445e$export$cd39639fa62f47f8() {
    return (0, $acw62.useContext)($3c0860f4d138445e$var$DealStateContext);
}
function $3c0860f4d138445e$export$73fc7af4ef9455f4() {
    const { profile: profile, profileLoading: profileLoading, profileError: profileError, reloadProfile: reloadProfile } = $3c0860f4d138445e$export$cd39639fa62f47f8();
    return {
        profile: profile,
        loading: profileLoading,
        error: profileError,
        reload: reloadProfile
    };
}


/* App bar — ported from the prototype's appbar(). Primary nav, fund name + avatar.
   `embedded` renders a slim nav-only row for the in-dashboard tab (no brand bar,
   avatar or theme toggle — dark mode was removed). Nav uses react-router Links;
   the active item is derived from the current path. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/* ============================================================
   Shared helpers for the Deal Management module.
   Ported from the prototype's components.js pure helpers.
   ============================================================ */ /* ============================================================
   Static UI configuration for Deal Management.
   These are presentation constants (step ids/names, stage colours,
   working labels, analysis progress-task copy) — NOT live application
   data. Live data (deals, investor profile, per-deal step data) comes
   from the backend via ./api.js. Kept separate from data/fixtures.js so
   the fixture/mock dataset is never a source of truth for live screens.
   ============================================================ */ /* Working names pending sign-off (DDM-17). Swap here only. */ const $33f9bd8300724d0e$export$79b91d4669dcadcb = {
    scenarios: 'Stress Test',
    aiceo: 'AI CEO Review'
};
const $33f9bd8300724d0e$export$6836fb99d2ec00dc = [
    {
        id: 'intake',
        name: 'Intake'
    },
    {
        id: 'analysis',
        name: 'Analysis'
    },
    {
        id: 'triage',
        name: 'Triage'
    },
    {
        id: 'diligence',
        name: 'Diligence'
    },
    {
        id: 'scenarios',
        name: $33f9bd8300724d0e$export$79b91d4669dcadcb.scenarios
    },
    {
        id: 'memo',
        name: 'IC memo'
    },
    {
        id: 'decision',
        name: 'Decision'
    }
];
const $33f9bd8300724d0e$export$47007d96f3617630 = [
    {
        id: 'new',
        name: 'New',
        dot: '#FB7785'
    },
    {
        id: 'analysis',
        name: 'Analysis',
        dot: '#4A67FF'
    },
    {
        id: 'triage',
        name: 'Triage',
        dot: '#FFD34A'
    },
    {
        id: 'diligence',
        name: 'Diligence',
        dot: '#4A67FF'
    },
    {
        id: 'ic',
        name: 'IC & decided',
        dot: '#4FF786'
    }
];
const $33f9bd8300724d0e$export$410004678225a867 = [
    "Reading the deck \u2014 text, tables and charts",
    'Extracting financials, traction and the ask',
    'Benchmarking market-size claims',
    'Scoring strengths, risks and red flags',
    'Preparing founder questions'
];


const $b398648f62c2864e$export$9e15ff8aa6bc996f = '/deal-management';
function $b398648f62c2864e$export$c061d1cd49f33033(score) {
    if (score == null) return '';
    return score >= 70 ? 'score--green' : score >= 50 ? 'score--amber' : 'score--red';
}
function $b398648f62c2864e$export$f6a098653d630c23(name) {
    return name.split(' ').map((w)=>w[0]).slice(0, 2).join('');
}
function $b398648f62c2864e$export$64bd5e91f880fa34(deal) {
    const map = {
        new: 'intake',
        analysis: 'analysis',
        triage: 'triage',
        diligence: 'diligence',
        ic: 'decision'
    };
    return map[deal.stage] || 'intake';
}
function $b398648f62c2864e$export$825ea1f703a1aac9(level) {
    return level === 'green' ? 'var(--dlg-green)' : level === 'amber' ? 'var(--dlg-amber)' : level === 'red' ? 'var(--dlg-red)' : 'var(--dlg-blue)';
}
function $b398648f62c2864e$export$48fb026443f6105f(stepId) {
    const idx = (0, $33f9bd8300724d0e$export$6836fb99d2ec00dc).findIndex((s)=>s.id === stepId);
    return {
        idx: idx,
        num: idx + 1,
        name: (0, $33f9bd8300724d0e$export$6836fb99d2ec00dc)[idx] ? (0, $33f9bd8300724d0e$export$6836fb99d2ec00dc)[idx].name : ''
    };
}



const $4ed10917cbad1b4e$var$NAV = [
    [
        'pipeline',
        'Pipeline'
    ],
    [
        'dashboard',
        'Dashboard'
    ],
    [
        'profile',
        'Investor profile'
    ],
    [
        'sandbox',
        'Idea sandbox'
    ]
];
function $4ed10917cbad1b4e$var$activeKey(pathname) {
    const rest = pathname.replace((0, $b398648f62c2864e$export$9e15ff8aa6bc996f), '');
    const seg = rest.split('/').filter(Boolean)[0] || 'pipeline';
    return $4ed10917cbad1b4e$var$NAV.some(([k])=>k === seg) ? seg : '';
}
function $4ed10917cbad1b4e$export$2e2bcd8739ae039({ embedded: embedded = false }) {
    const { pathname: pathname } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const active = $4ed10917cbad1b4e$var$activeKey(pathname);
    const [mobileOpen, setMobileOpen] = (0, $acw62.useState)(false);
    const { profile: profile } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    const fundShort = profile && profile.short || 'Deal flow';
    const fundInitials = profile && profile.initials || "\xb7";
    const navLinks = $4ed10917cbad1b4e$var$NAV.map(([key, label])=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
            to: `${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/${key}`,
            className: key === active ? 'is-active' : '',
            onClick: ()=>setMobileOpen(false),
            children: label
        }, key));
    // Inline dashboard tab: a single slim nav row, matching the other tabs' look.
    if (embedded) return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        className: "embednav",
        "aria-label": "Deal management menu",
        children: navLinks
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "appbar",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "hamburger",
                        onClick: ()=>setMobileOpen((o)=>!o),
                        "aria-label": "Menu",
                        "aria-expanded": mobileOpen,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "18",
                            height: "14",
                            viewBox: "0 0 18 14",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    y: "0",
                                    width: "18",
                                    height: "2",
                                    rx: "1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    y: "6",
                                    width: "18",
                                    height: "2",
                                    rx: "1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    y: "12",
                                    width: "18",
                                    height: "2",
                                    rx: "1"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                        className: "appbar__nav",
                        children: navLinks
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "appbar__fund",
                        children: fundShort
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "appbar__avatar",
                        children: fundInitials
                    })
                ]
            }),
            mobileOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mobilenav__scrim",
                onClick: ()=>setMobileOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                className: `mobilenav${mobileOpen ? ' is-open' : ''}`,
                "aria-label": "Main menu",
                children: navLinks
            })
        ]
    });
}


/* Pipeline (landing) — ported from the prototype's Screens.pipeline().
   Board (Kanban across the five stages) + List view, traffic-lit scores,
   Board/List toggle, and "+ Add applicant". Cards open the deal at its
   current step. Deals load live from GET /deal/pipeline. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





/* Shared loading / empty / error states for API-driven screens.
   Reuses the module's existing .stub / .card styling so the look is
   unchanged — these only fill the gap while data loads or is absent. */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $7cf0de650ddb521f$export$669f6ea7d267feaf({ label: label = "Loading\u2026" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "stub",
        "aria-busy": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "stub__title",
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: "One moment while we fetch the latest from Diligentsia."
            })
        ]
    });
}
function $7cf0de650ddb521f$export$fddf379e22a74b00({ title: title = 'Nothing here yet', sub: sub = '' }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "stub",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "stub__title",
                children: title
            }),
            sub ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: sub
            }) : null
        ]
    });
}
function $7cf0de650ddb521f$export$c1ed4f415b9e7023({ title: title = 'Could not load this', sub: sub = 'Please try again.', onRetry: onRetry }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "stub",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "stub__title",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: sub
            }),
            onRetry ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "pill pill--outline",
                style: {
                    marginTop: 12
                },
                onClick: onRetry,
                children: "Retry"
            }) : null
        ]
    });
}


/* Add Applicant + pitch-deck upload. The VC uploads an applicant at the point their
   funding form is submitted: fill the funding-form fields and attach the deck, then
   POST /api/deal/ creates the deal, runs the zero-LLM gate and files the deck to S3.
   On a pass the deal opens at intake (ready for AI analysis); on a gate fail it opens
   at intake showing the dealbreaker. Dropdown options come from the investor profile
   lookups (GET /deal/profile); when absent they fall back to free-text inputs. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



/* Portals a module modal into document.body so its position:fixed overlay is relative
   to the real viewport — not a transformed ancestor. When the module renders inside the
   investor dashboard tab, ancestor elements carry CSS transforms which would otherwise
   trap a fixed overlay inside the tab (covering only part of the page). The `.dlg-dm`
   wrapper keeps the module's scoped modal styles applying at body level. */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $9abd40bffd9b0601$export$2e2bcd8739ae039({ children: children }) {
    if (typeof document === 'undefined') return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "dlg-dm dlg-dm--modalroot",
        children: children
    }), document.body);
}




// Render a <select> when the profile supplies options, else a plain text input.
function $7bf87fe889de5b32$var$LookupField({ label: label, value: value, onChange: onChange, options: options, placeholder: placeholder }) {
    const opts = Array.isArray(options) ? options : [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        className: "dm-field",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "dm-field__label",
                children: label
            }),
            opts.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                value: value,
                onChange: (e)=>onChange(e.target.value),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                        value: "",
                        children: "Select\u2026"
                    }),
                    opts.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                            value: o,
                            children: o
                        }, o))
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                type: "text",
                value: value,
                onChange: (e)=>onChange(e.target.value),
                placeholder: placeholder
            })
        ]
    });
}
function $7bf87fe889de5b32$export$2e2bcd8739ae039({ onClose: onClose, onAdded: onAdded }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const { profile: profile } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    const lookups = profile && profile.lookups || {};
    const [name, setName] = (0, $acw62.useState)('');
    const [founderContact, setFounderContact] = (0, $acw62.useState)('');
    const [sector, setSector] = (0, $acw62.useState)('');
    const [stage, setStage] = (0, $acw62.useState)('');
    const [ask, setAsk] = (0, $acw62.useState)('');
    const [region, setRegion] = (0, $acw62.useState)('');
    const [revenue, setRevenue] = (0, $acw62.useState)('');
    const [file, setFile] = (0, $acw62.useState)(null);
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const canSubmit = name.trim() && file && !submitting;
    const submit = async ()=>{
        if (!canSubmit) return;
        setSubmitting(true);
        const payload = {
            name: name.trim(),
            founderContact: founderContact,
            sector: sector,
            stage: stage,
            ask: ask,
            region: region,
            revenue: revenue,
            attachment: [
                file
            ]
        };
        const res = await (0, $2f90eebb96c7748d$export$ae5c1992bbcb9a02)(payload);
        setSubmitting(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return; // request helper toasts the backend message
        const body = res.body || {};
        const passed = body.gateOutcome !== 'fail';
        showToast(passed ? `${name.trim()} added \u{2014} passed the gate` : `${name.trim()} added \u{2014} ruled out: ${body.dealbreaker || 'dealbreaker'}`);
        onClose();
        if (onAdded) onAdded();
        if (body.deal && body.deal.id) navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${body.deal.id}/intake`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9abd40bffd9b0601$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "modal-overlay",
            onClick: (e)=>{
                if (e.target === e.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modal modal--form",
                role: "dialog",
                "aria-label": "Add applicant",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modal__head",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "modal__title",
                                children: "Add applicant"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "modal__desc",
                                children: "Upload the applicant's pitch deck and funding-form details. The deck is filed to your data room and the auto-decline gate runs instantly \u2014 no AI spend until you run analysis."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modal__body",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dm-formgrid",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "dm-field dm-field--full",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "dm-field__label",
                                            children: "Company name *"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: name,
                                            onChange: (e)=>setName(e.target.value),
                                            placeholder: "e.g. Kestrel Logistics"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "dm-field dm-field--full",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "dm-field__label",
                                            children: "Founder contact email"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "email",
                                            value: founderContact,
                                            onChange: (e)=>setFounderContact(e.target.value),
                                            placeholder: "founder@company.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($7bf87fe889de5b32$var$LookupField, {
                                    label: "Sector",
                                    value: sector,
                                    onChange: setSector,
                                    options: lookups.sectors,
                                    placeholder: "e.g. B2B SaaS"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($7bf87fe889de5b32$var$LookupField, {
                                    label: "Stage",
                                    value: stage,
                                    onChange: setStage,
                                    options: lookups.stages,
                                    placeholder: "e.g. Seed"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "dm-field",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "dm-field__label",
                                            children: "Ask"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: ask,
                                            onChange: (e)=>setAsk(e.target.value),
                                            placeholder: "e.g. \xa31.5M"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($7bf87fe889de5b32$var$LookupField, {
                                    label: "Region",
                                    value: region,
                                    onChange: setRegion,
                                    options: lookups.regions,
                                    placeholder: "e.g. UK"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "dm-field dm-field--full",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "dm-field__label",
                                            children: "Revenue (last 12m)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: revenue,
                                            onChange: (e)=>setRevenue(e.target.value),
                                            placeholder: "e.g. \xa3338k ARR or Pre-revenue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "dm-field dm-field--full",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "dm-field__label",
                                            children: "Pitch deck *"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "file",
                                            accept: ".pdf,.ppt,.pptx,.doc,.docx,.key",
                                            onChange: (e)=>setFile(e.target.files && e.target.files[0])
                                        }),
                                        file ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "dm-field__hint",
                                            children: [
                                                file.name,
                                                " \xb7 ",
                                                (file.size / 1024 / 1024).toFixed(1),
                                                " MB"
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "dm-field__hint",
                                            children: "PDF, PowerPoint or Word \u2014 up to 100 MB"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modal__actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--ghost",
                                onClick: onClose,
                                disabled: submitting,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: submit,
                                disabled: !canSubmit,
                                children: submitting ? "Uploading\u2026" : 'Add & run gate'
                            })
                        ]
                    })
                ]
            })
        })
    });
}



function $22fc30704fa4b906$var$KanbanBoard({ deals: deals, navigate: navigate }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "kanban",
        children: (0, $33f9bd8300724d0e$export$47007d96f3617630).map((stage)=>{
            const stageDeals = deals.filter((d)=>d.stage === stage.id);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "kcol",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "kcol__head",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "kcol__dot",
                                style: {
                                    background: stage.dot
                                }
                            }),
                            stage.name,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "kcol__count",
                                children: stageDeals.length
                            })
                        ]
                    }),
                    stageDeals.map((d)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `kcard ${d.focus ? 'is-focus' : ''}`,
                            onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${d.id}/${(0, $b398648f62c2864e$export$64bd5e91f880fa34)(d)}`),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "kcard__top",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "kcard__name",
                                            children: d.name
                                        }),
                                        d.score != null ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `kcard__score score ${(0, $b398648f62c2864e$export$c061d1cd49f33033)(d.score)}`,
                                            children: d.score
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "kcard__score",
                                            style: {
                                                color: 'var(--dlg-axis)'
                                            },
                                            children: "\u2014"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "kcard__meta",
                                    children: [
                                        d.sector,
                                        " \xb7 ",
                                        d.ask
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "kcard__status",
                                    children: d.status
                                })
                            ]
                        }, d.id))
                ]
            }, stage.id);
        })
    });
}
function $22fc30704fa4b906$var$PipelineList({ deals: deals, navigate: navigate }) {
    const stageName = (id)=>{
        const s = (0, $33f9bd8300724d0e$export$47007d96f3617630).find((x)=>x.id === id);
        return s ? s.name : id;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "listview listwrap",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Company"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Sector"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Ask"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Stage"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Score"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Status"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: deals.map((d)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${d.id}/${(0, $b398648f62c2864e$export$64bd5e91f880fa34)(d)}`),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    style: {
                                        fontWeight: 500
                                    },
                                    children: d.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    children: d.sector
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    children: d.ask
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "chip chip--blue",
                                        children: stageName(d.stage)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    className: `score ${(0, $b398648f62c2864e$export$c061d1cd49f33033)(d.score)}`,
                                    children: d.score != null ? d.score : "\u2014"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    style: {
                                        color: 'var(--dlg-muted)'
                                    },
                                    children: d.status
                                })
                            ]
                        }, d.id))
                })
            ]
        })
    });
}
function $22fc30704fa4b906$export$2e2bcd8739ae039({ view: view = 'board' }) {
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { profile: profile, reload: reloadProfile } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    const [deals, setDeals] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(false);
    const [errMsg, setErrMsg] = (0, $acw62.useState)('');
    const [seeding, setSeeding] = (0, $acw62.useState)(false);
    const [addOpen, setAddOpen] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setError(false);
        const res = await (0, $2f90eebb96c7748d$export$6fc568134edf5a70)();
        if (!res) {
            setError(true);
            setErrMsg("No response from the server \u2014 it may be restarting. Try again in a moment.");
            setDeals(null);
            return;
        }
        if (res.code === 401) {
            setError(true);
            setErrMsg("Your session has expired \u2014 please log in again.");
            setDeals(null);
            return;
        }
        if (res.code === 403) {
            setError(true);
            setErrMsg('This account is not an investor account, so Deal Management is unavailable.');
            setDeals(null);
            return;
        }
        if (/no investor firm/i.test(res.message || '')) {
            setError(true);
            setErrMsg("This account has no investor fund attached. Deal Management is only available on an investor account with a fund \u2014 sign in with your investor account.");
            setDeals(null);
            return;
        }
        if (res.code !== 200 || !res.body) {
            setError(true);
            setErrMsg(res.message || 'Could not load the pipeline.');
            setDeals(null);
            return;
        }
        setDeals(res.body.deals || []);
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    // Dev convenience: populate this firm with the worked example so the flow is walkable.
    const loadDemo = async ()=>{
        if (seeding) return;
        setSeeding(true);
        const res = await (0, $2f90eebb96c7748d$export$4b8a698d6c7b2804)();
        setSeeding(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return;
        showToast('Demo data loaded for your firm');
        await Promise.all([
            load(),
            reloadProfile()
        ]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page__head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "kicker",
                                children: [
                                    "Deal flow \xb7 ",
                                    profile && profile.short || 'Your fund'
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "page__title",
                                children: "Pipeline"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "page__actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "seg",
                                role: "tablist",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: view === 'board' ? 'is-active' : '',
                                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/pipeline`),
                                        children: "Board"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: view === 'list' ? 'is-active' : '',
                                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/pipeline/list`),
                                        children: "List"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: ()=>setAddOpen(true),
                                children: "+ Add applicant"
                            })
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$c1ed4f415b9e7023), {
                title: "Could not load the pipeline",
                sub: errMsg || 'Please try again.',
                onRetry: load
            }) : deals === null ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
                label: "Loading pipeline\u2026"
            }) : deals.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "stub",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "stub__title",
                        children: "No deals yet"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: "New applicants arrive from your funding form and appear here."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        style: {
                            marginTop: 14
                        },
                        onClick: loadDemo,
                        disabled: seeding,
                        children: seeding ? "Loading\u2026" : 'Load demo data'
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    view === 'board' ? /*#__PURE__*/ (0, $ayMG0.jsx)($22fc30704fa4b906$var$KanbanBoard, {
                        deals: deals,
                        navigate: navigate
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)($22fc30704fa4b906$var$PipelineList, {
                        deals: deals,
                        navigate: navigate
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "kanban__legend",
                        children: [
                            "Drag deals between stages, or let the workflow move them for you. Scores are traffic-lit:",
                            ' ',
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "score score--green",
                                children: "70+"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "score score--amber",
                                children: "50\u201369"
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "score score--red",
                                children: "below 50"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            addOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf87fe889de5b32$export$2e2bcd8739ae039), {
                onClose: ()=>setAddOpen(false),
                onAdded: load
            })
        ]
    });
}


/* Deal workspace dispatcher. Loads the deal (GET /deal/:id), renders the per-deal
   stepper and routes to the correct step screen (each fetches its own step data and
   renders its own <main>). Once a decision is logged, the stepper shows all seven
   ticked. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/* Dot stepper — ported from the prototype's stepper(). Seven steps per deal;
   steps before the active one (or all, once a decision is logged) read as done. */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



function $ce9e66af65470eaa$export$2e2bcd8739ae039({ dealId: dealId, activeStep: activeStep, decided: decided = false }) {
    const activeIdx = (0, $33f9bd8300724d0e$export$6836fb99d2ec00dc).findIndex((s)=>s.id === activeStep);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "stepper",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "stepper__rail",
            children: (0, $33f9bd8300724d0e$export$6836fb99d2ec00dc).map((s, i)=>{
                const done = decided || i < activeIdx;
                const state = done ? 'is-done' : i === activeIdx ? 'is-active' : '';
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    className: `stepper__step ${state}`,
                    to: `${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${dealId}/${s.id}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "stepper__dot",
                            children: done ? "\u2713" : i + 1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "stepper__name",
                            children: s.name
                        })
                    ]
                }, s.id);
            })
        })
    });
}






/* Step 1 — Intake + auto-decline gate. Ported from the prototype's intakeBody().
   Funding-form data + pitch-deck, and the non-AI gate: pure field comparison, zero
   token spend. Pass enables AI analysis; fail (or a logged override) routes on.
   Data loads from GET /deal/:id/intake; override persists via POST .../intake/override. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

/* Deal strip — ported from the prototype's dealstrip(). Logo initials, name,
   meta line and a "Step N · Name" chip for the current workspace step. */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $bbff18614c7ce1a9$export$2e2bcd8739ae039({ deal: deal, stepId: stepId }) {
    const d = deal.detail || {};
    const scores = d.analysisScore ? ` \xb7 analysis ${d.analysisScore}/100 \xb7 triage ${d.triageScore}/10` : '';
    const { num: num, name: name } = (0, $b398648f62c2864e$export$48fb026443f6105f)(stepId || 'intake');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "dealstrip",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "dealstrip__logo",
                children: (0, $b398648f62c2864e$export$f6a098653d630c23)(deal.name)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dealstrip__name",
                        children: deal.name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dealstrip__meta",
                        children: [
                            d.round || '',
                            d.round ? " \xb7 " : '',
                            deal.sector,
                            " \xb7 Ask ",
                            deal.ask,
                            d.equity ? ` for ${d.equity}` : '',
                            scores
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "chip chip--blue",
                style: {
                    marginLeft: 'auto'
                },
                children: [
                    "Step ",
                    num,
                    " \xb7 ",
                    name
                ]
            })
        ]
    });
}


/* Decline-with-template-email modal — ported from the prototype's openDecline().
   Template-driven (no free-text): pick a quick response from the firm's Diligentsia
   settings, preview/edit, then "Send & log". Sending persists the decline + queues
   the templated email via POST /deal/:id/decline and appends to the FCA decision log. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




// Fallback quick responses if the profile hasn't loaded — mirrors Diligentsia defaults.
const $b50dad277a8f08ad$var$FALLBACK_RESPONSES = [
    'Too early stage for us at the moment',
    'Has not demonstrated enough traction yet',
    'Not a good fit in terms of the type of funding you are seeking',
    'Operating in a sector in which we are not focused right now',
    'Not a good match in terms of the amount of funds you are seeking'
];
function $b50dad277a8f08ad$var$firstNameFrom(deal) {
    const email = deal && deal.founderContact || deal && deal.detail && deal.detail.contact;
    if (email && email.includes('@')) {
        const p = email.split('@')[0].split(/[._-]/)[0];
        return p.charAt(0).toUpperCase() + p.slice(1);
    }
    return 'there';
}
function $b50dad277a8f08ad$var$buildPreview(deal, reason, firmShort, signerName) {
    const first = $b50dad277a8f08ad$var$firstNameFrom(deal);
    const lowered = reason ? reason.charAt(0).toLowerCase() + reason.slice(1) : '';
    const signer = signerName ? `${signerName} \xb7 ${firmShort}` : firmShort;
    return `Hi ${first},\n\nThank you for applying to ${firmShort} through Diligentsia. We won't be taking this forward: ${lowered}.\n\nThis isn't a reflection on ${deal.name} \u{2014} through Diligentsia, your profile can be matched with investors whose criteria fit, and your investment-readiness workspace stays open to you either way.

Best,
${signer}`;
}
function $b50dad277a8f08ad$export$2e2bcd8739ae039({ deal: deal, context: context, onClose: onClose, onDeclined: onDeclined }) {
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const { profile: profile } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    const firmShort = profile && profile.short || 'the fund';
    const signerName = profile && profile.preferredContact && profile.preferredContact.name;
    const quickResponses = profile && profile.quickResponses && profile.quickResponses.length ? profile.quickResponses : $b50dad277a8f08ad$var$FALLBACK_RESPONSES;
    const suggested = deal.dealbreaker || quickResponses[0];
    const [reason, setReason] = (0, $acw62.useState)(suggested);
    const [preview, setPreview] = (0, $acw62.useState)(()=>$b50dad277a8f08ad$var$buildPreview(deal, suggested, firmShort, signerName));
    const [sending, setSending] = (0, $acw62.useState)(false);
    const onReasonChange = (e)=>{
        const next = e.target.value;
        setReason(next);
        setPreview($b50dad277a8f08ad$var$buildPreview(deal, next, firmShort, signerName));
    };
    const send = async ()=>{
        if (sending) return;
        setSending(true);
        const res = await (0, $2f90eebb96c7748d$export$db2c60858a9e1d35)(deal.id, {
            reason: reason,
            letter: preview,
            context: context
        });
        setSending(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return; // request helper already toasts the backend message
        onClose();
        showToast(`Decline sent to ${deal.name} \xb7 decision logged (reason \xb7 who \xb7 when)`);
        setTimeout(()=>showToast(`${deal.name} profile released for matching with other VCs on Diligentsia`, true), 900);
        if (onDeclined) onDeclined();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9abd40bffd9b0601$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "modal-overlay",
            onClick: (e)=>{
                if (e.target === e.currentTarget) onClose();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modal",
                role: "dialog",
                "aria-label": "Decline with template email",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modal__title",
                        children: [
                            "Decline ",
                            deal.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "modal__desc",
                        children: "Pick a quick response from your Diligentsia settings \u2014 the email is editable before it sends. No free-text box: templates keep the tone consistent."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                        value: reason,
                        onChange: onReasonChange,
                        children: quickResponses.map((q)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                value: q,
                                children: q
                            }, q))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        value: preview,
                        onChange: (e)=>setPreview(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modal__log",
                        children: [
                            "Decision log entry \xb7 ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: context === 'triage' ? 'Quick reject at triage' : 'Quick reject at gate'
                            }),
                            " \u2014 reason: ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: reason
                            }),
                            " \xb7 by ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: signerName ? `${signerName}, ${firmShort}` : firmShort
                            }),
                            " \xb7 ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "today"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "modal__actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--ghost",
                                onClick: onClose,
                                disabled: sending,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: send,
                                disabled: sending,
                                children: sending ? "Sending\u2026" : 'Send & log decision'
                            })
                        ]
                    })
                ]
            })
        })
    });
}






function $a0c04ea32e3b3707$export$2e2bcd8739ae039({ deal: deal }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const [declineOpen, setDeclineOpen] = (0, $acw62.useState)(false);
    const [I, setI] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(false);
    const [overriding, setOverriding] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setError(false);
        setI(null);
        const data = await (0, $2f90eebb96c7748d$export$d3862ebde999de49)(deal.id);
        if (!data) {
            setError(true);
            return;
        }
        setI(data);
    }, [
        deal.id
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "intake"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 14
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$fddf379e22a74b00), {
                    title: "No intake yet",
                    sub: "This deal has no funding-form intake recorded."
                })
            })
        ]
    });
    if (!I) return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "intake"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 14
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
                    label: "Loading intake\u2026"
                })
            })
        ]
    });
    const checks = I.checks || [];
    const form = I.form || [];
    const fired = checks.filter((c)=>!c.pass);
    const overridden = I.gateOutcome === 'overridden';
    const runAnalysis = ()=>{
        showToast(`Intelligentsia analysis started for ${deal.name}`);
        navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/analysis`);
    };
    const override = async ()=>{
        if (overriding) return;
        setOverriding(true);
        const res = await (0, $2f90eebb96c7748d$export$70b4b882616a0d2)(deal.id, "Manual override \u2014 proceeding despite dealbreaker");
        setOverriding(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return;
        showToast(`Override logged \u{2014} ${deal.name} proceeds despite dealbreaker (reason \xb7 who \xb7 when)`);
        setTimeout(()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/analysis`), 700);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "intake"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                style: {
                    marginTop: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__row",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        children: "From the funding form"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "card__hint",
                                        children: "Pre-populated \xb7 nothing re-typed"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dl", {
                                className: "fieldgrid",
                                children: form.map(([k, v])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                                children: k
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                                children: v
                                            })
                                        ]
                                    }, k))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 12
                                },
                                children: "Pitch deck"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: 42,
                                            height: 42,
                                            borderRadius: 12,
                                            background: 'var(--dlg-fill)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 17
                                        },
                                        children: "\uD83D\uDCC4"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 13.5,
                                                    fontWeight: 500
                                                },
                                                children: I.deck || 'No deck uploaded'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 12.5,
                                                    color: 'var(--dlg-green-ink)'
                                                },
                                                children: "\u27F3 Pushed to Diligentsia data repository \xb7 autofill propagated"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__foot",
                                children: "Company account auto-created on Diligentsia \xb7 investment-readiness invite sent to the founder."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card__row",
                        style: {
                            marginBottom: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__label",
                                children: [
                                    "Auto-decline gate \xb7 ",
                                    checks.length,
                                    " criteria"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "card__hint",
                                children: "Checked against profile criteria \xb7 no AI analysis run"
                            })
                        ]
                    }),
                    checks.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `gate__row ${c.pass ? '' : 'is-fail'}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `gate__mark ${c.pass ? 'gate__mark--pass' : 'gate__mark--fail'}`,
                                    children: c.pass ? "\u2713" : "\u2715"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "gate__label",
                                    children: c.label
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontWeight: 500
                                    },
                                    children: c.value
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "gate__note",
                                    children: c.note
                                })
                            ]
                        }, c.label)),
                    checks.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "verdict verdict--pass",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "No rule-out criteria configured"
                                }),
                                " \u2014 applicant admitted. Sync your investor settings to enable the auto-decline gate. Continuing runs AI analysis (token spend starts here)."
                            ]
                        })
                    }) : fired.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "verdict verdict--pass",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Cleared the gate"
                                }),
                                " \u2014 all ",
                                checks.length,
                                " criteria match the profile. Continuing runs AI analysis (token spend starts here)."
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "verdict verdict--fail",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                    children: [
                                        "Dealbreaker fired \u2014 ",
                                        fired.length,
                                        " of ",
                                        checks.length,
                                        "."
                                    ]
                                }),
                                " ",
                                fired[0].label,
                                ": ",
                                fired[0].value,
                                ". No AI has run and no tokens were spent."
                            ]
                        })
                    }),
                    fired.length === 0 || overridden ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            marginTop: 16
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: runAnalysis,
                                children: "Run AI analysis \u2192"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--ghost",
                                onClick: ()=>setDeclineOpen(true),
                                children: "Decline with template email"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 10,
                                    marginTop: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "pill pill--primary",
                                        onClick: ()=>setDeclineOpen(true),
                                        children: "Decline with template email \u2192"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "pill pill--outline",
                                        onClick: override,
                                        disabled: overriding,
                                        children: overriding ? "Logging\u2026" : 'Proceed anyway'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)',
                                    marginTop: 9
                                },
                                children: "Both paths are logged \u2014 reason, who, when \u2014 to the FCA-format decision log."
                            })
                        ]
                    })
                ]
            }),
            declineOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b50dad277a8f08ad$export$2e2bcd8739ae039), {
                deal: deal,
                context: "gate",
                onClose: ()=>setDeclineOpen(false),
                onDeclined: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/pipeline`)
            })
        ]
    });
}


/* Step 2 — AI Analysis. Ported from the prototype's analysisBody(), now driven by
   the real backend. Starting analysis POSTs .../analysis/run; progress arrives over
   sockets (deal:analysis:started/progress/completed/failed). On completion the report
   is refetched from GET .../analysis: a 0–100 score with slide-cited strengths/risks,
   a deal snapshot and deck-completeness checks. No frontend timers fake the progress. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/* Intelligentsia speech bubble — ported from the prototype's bubble(). */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $d1867d50eaca9584$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bubble",
        children: [
            "\u2726 ",
            children
        ]
    });
}








const $f6ad8c34260040d5$var$RING_C = 2 * Math.PI * 48;
function $f6ad8c34260040d5$var$AnalysisProgress({ deal: deal, progress: progress }) {
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const pct = progress.total ? Math.round(progress.current / progress.total * 100) : 0;
    const doneCount = Math.floor(pct / 100 * (0, $33f9bd8300724d0e$export$410004678225a867).length);
    const secs = Math.max(0, Math.round((100 - pct) / 2));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "dealstrip",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "dealstrip__logo",
                        children: (0, $b398648f62c2864e$export$f6a098653d630c23)(deal.name)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dealstrip__name",
                                children: deal.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dealstrip__meta",
                                children: [
                                    deal.detail && deal.detail.round || 'Seed',
                                    " \xb7 ",
                                    deal.sector,
                                    " \xb7 pitch deck"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "chip chip--blue",
                        style: {
                            marginLeft: 'auto'
                        },
                        children: "Analysing"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    marginTop: 14,
                    padding: '28px 26px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 16,
                            maxWidth: 640,
                            margin: '0 auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "aiavatar",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "AI"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d1867d50eaca9584$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Hi, I'm Intelligentsia."
                                    }),
                                    " I'm reading ",
                                    deal.name.split(' ')[0],
                                    "'s deck now \u2014 extracting the numbers, checking the market maths and flagging anything the committee should see."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            maxWidth: 576,
                            margin: '22px auto 0'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "progress",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress__bar",
                                    style: {
                                        width: `${pct}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "progress__meta",
                                children: pct === 0 ? "Starting\u2026" : `${pct}% \xb7 ${progress.label || 'working'}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tasklist",
                                children: (0, $33f9bd8300724d0e$export$410004678225a867).map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `task ${i < doneCount ? 'is-done' : ''} ${i === doneCount ? 'is-active' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "task__dot",
                                                children: "\u2713"
                                            }),
                                            t
                                        ]
                                    }, i))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    textAlign: 'center',
                                    marginTop: 18
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "pill pill--outline",
                                    onClick: ()=>showToast("We'll notify you the moment the report is ready"),
                                    children: "Notify me when it's ready"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $f6ad8c34260040d5$var$AnalysisReport({ deal: deal, A: A }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const [offset, setOffset] = (0, $acw62.useState)($f6ad8c34260040d5$var$RING_C);
    const [exporting, setExporting] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const t = setTimeout(()=>setOffset($f6ad8c34260040d5$var$RING_C * (1 - (A.score || 0) / 100)), 80);
        return ()=>clearTimeout(t);
    }, [
        A.score
    ]);
    const compColor = (c)=>c.state === 'miss' ? 'var(--dlg-red)' : 'var(--dlg-blue)';
    const compMark = (c)=>c.state === 'ok' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            style: {
                color: 'var(--dlg-green-ink)'
            },
            children: "\u2713"
        }) : c.state === 'part' ? "\u25D0" : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            style: {
                color: 'var(--dlg-red-ink)'
            },
            children: "\u2715"
        });
    const chips = A.chips || [];
    const strengths = A.strengths || [];
    const risks = A.risks || [];
    const snapshot = A.snapshot || [];
    const completeness = A.completeness || [];
    const download = async ()=>{
        if (exporting) return;
        setExporting(true);
        const res = await (0, $2f90eebb96c7748d$export$449e73bfb22de898)(deal.id, 'analysis');
        setExporting(false);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res) && res.body && res.body.url) {
            window.open(res.body.url, '_blank', 'noopener');
            showToast('Report PDF ready');
        } else showToast(res && res.message || 'Export is unavailable right now');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "dealstrip",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "dealstrip__logo",
                        children: (0, $b398648f62c2864e$export$f6a098653d630c23)(deal.name)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dealstrip__name",
                                children: deal.name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dealstrip__meta",
                                children: [
                                    deal.detail && deal.detail.round || 'Seed',
                                    " \xb7 ",
                                    deal.sector
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            marginLeft: 'auto',
                            display: 'flex',
                            gap: 8
                        },
                        children: chips.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `chip ${c.cls}`,
                                children: c.text
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    marginTop: 14,
                    display: 'flex',
                    gap: 22,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "ring",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "108",
                                height: "108",
                                viewBox: "0 0 108 108",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        className: "ring__track",
                                        cx: "54",
                                        cy: "54",
                                        r: "48"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        className: "ring__val",
                                        cx: "54",
                                        cy: "54",
                                        r: "48",
                                        strokeDasharray: $f6ad8c34260040d5$var$RING_C,
                                        strokeDashoffset: offset
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ring__num",
                                children: [
                                    A.score,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                        children: "/ 100"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 17,
                                    fontWeight: 600,
                                    color: 'var(--dlg-pos)'
                                },
                                children: A.recommend
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    color: 'var(--dlg-ink-soft)',
                                    marginTop: 4,
                                    maxWidth: 620
                                },
                                children: A.summary
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "chip chip--blue",
                                style: {
                                    marginTop: 10
                                },
                                children: "\u2726 Analysed by Intelligentsia \xb7 findings cite their slide"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                style: {
                    marginTop: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: "Strengths"
                            }),
                            strengths.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "finding",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "finding__dot",
                                            style: {
                                                background: 'var(--dlg-green)'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                s.text,
                                                s.slide ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "cite",
                                                    children: [
                                                        " slide ",
                                                        s.slide
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: "Risks & red flags"
                            }),
                            risks.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "finding",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "finding__dot",
                                            style: {
                                                background: r.level === 'red' ? 'var(--dlg-red)' : 'var(--dlg-amber)'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                r.text,
                                                r.slide ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "cite",
                                                    children: [
                                                        " slide ",
                                                        r.slide
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }, i))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: "Deal snapshot"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("dl", {
                                className: "snap",
                                children: snapshot.map(([k, v])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("dt", {
                                                children: k
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("dd", {
                                                children: v
                                            })
                                        ]
                                    }, k))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: [
                                    "Deck completeness",
                                    A.completenessLabel ? ` \xb7 ${A.completenessLabel}` : ''
                                ]
                            }),
                            completeness.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "comp",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "comp__name",
                                            children: c.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "comp__bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "comp__fill",
                                                style: {
                                                    width: `${c.pct}%`,
                                                    background: compColor(c)
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "comp__mark",
                                            children: compMark(c)
                                        })
                                    ]
                                }, c.name)),
                            A.missingNote ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)',
                                    marginTop: 8
                                },
                                children: A.missingNote
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/triage`),
                        children: "Proceed to triage \u2192"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--outline",
                        onClick: download,
                        disabled: exporting,
                        children: exporting ? "Exporting\u2026" : 'Download report'
                    })
                ]
            })
        ]
    });
}
function $f6ad8c34260040d5$export$2e2bcd8739ae039({ deal: deal }) {
    const { markAnalysisDone: markAnalysisDone } = (0, $3c0860f4d138445e$export$cd39639fa62f47f8)();
    const [phase, setPhase] = (0, $acw62.useState)('loading'); // loading | running | report | error
    const [analysis, setAnalysis] = (0, $acw62.useState)(null);
    const [progress, setProgress] = (0, $acw62.useState)({
        current: 0,
        total: 4,
        label: ''
    });
    const startedRef = (0, $acw62.useRef)(false);
    const loadReport = (0, $acw62.useCallback)(async ()=>{
        const a = await (0, $2f90eebb96c7748d$export$4143e33485fb8ba8)(deal.id);
        if (a && a.status === 'complete') {
            setAnalysis(a);
            setPhase('report');
            markAnalysisDone(deal.id);
            return 'complete';
        }
        return a ? a.status : null;
    }, [
        deal.id,
        markAnalysisDone
    ]);
    // Decide initial phase and (if needed) kick off a run.
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        (async ()=>{
            const a = await (0, $2f90eebb96c7748d$export$4143e33485fb8ba8)(deal.id);
            if (cancelled) return;
            if (a && a.status === 'complete') {
                setAnalysis(a);
                setPhase('report');
                markAnalysisDone(deal.id);
                return;
            }
            setPhase('running');
            // Start a run only if none is already in flight (avoid double-charging on refresh).
            if ((!a || a.status === 'failed') && !startedRef.current) {
                startedRef.current = true;
                const res = await (0, $2f90eebb96c7748d$export$ad35f8678e7ef06)(deal.id);
                if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) {
                    if (!cancelled) setPhase('error');
                }
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        deal.id,
        markAnalysisDone
    ]);
    // Socket progress — scoped to this deal; listeners cleaned up on unmount.
    (0, $acw62.useEffect)(()=>{
        const dealId = String(deal.id);
        const onStarted = (p)=>{
            if (String(p.dealId) === dealId) setProgress({
                current: 0,
                total: p.total || 4,
                label: 'Reading the deck'
            });
        };
        const onProgress = (p)=>{
            if (String(p.dealId) === dealId) setProgress({
                current: p.current || 0,
                total: p.total || 4,
                label: p.label || ''
            });
        };
        const onCompleted = async (p)=>{
            if (String(p.dealId) === dealId) await loadReport();
        };
        const onFailed = (p)=>{
            if (String(p.dealId) === dealId) setPhase('error');
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('deal:analysis:started', onStarted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('deal:analysis:progress', onProgress);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('deal:analysis:completed', onCompleted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('deal:analysis:failed', onFailed);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('deal:analysis:started', onStarted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('deal:analysis:progress', onProgress);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('deal:analysis:completed', onCompleted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('deal:analysis:failed', onFailed);
        };
    }, [
        deal.id,
        loadReport
    ]);
    if (phase === 'loading') return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
            label: "Loading analysis\u2026"
        })
    });
    if (phase === 'error') return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$c1ed4f415b9e7023), {
            title: "Analysis could not be completed",
            sub: "The run failed or the deck could not be read. You can retry.",
            onRetry: ()=>{
                startedRef.current = false;
                (0, $2f90eebb96c7748d$export$ad35f8678e7ef06)(deal.id).then(()=>setPhase('running'));
            }
        })
    });
    if (phase === 'report' && analysis) return /*#__PURE__*/ (0, $ayMG0.jsx)($f6ad8c34260040d5$var$AnalysisReport, {
        deal: deal,
        A: analysis
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f6ad8c34260040d5$var$AnalysisProgress, {
        deal: deal,
        progress: progress
    });
}


/* Step 3 — Triage. Ported from the prototype's triageBody(). Weighted scorecard
   driven by the profile weights, thesis-fit checks, an Advance/Hold/Decline
   recommendation and an editable AI-drafted rationale. Data loads from
   GET /deal/:id/triage; the rationale + recommendation persist via PUT, and
   advancing calls POST .../triage/advance (both append to the FCA decision log). */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");







const $239eda984289c15a$var$RECS = [
    [
        'advance',
        'var(--dlg-green)',
        'Advance',
        'Move to diligence'
    ],
    [
        'hold',
        'var(--dlg-amber)',
        'Hold',
        'Request more info'
    ],
    [
        'decline',
        'var(--dlg-red)',
        'Decline',
        'Send templated pass note'
    ]
];
function $239eda984289c15a$export$2e2bcd8739ae039({ deal: deal }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const { profile: profile } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    const [T, setT] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)('loading'); // loading | generating | ready | noanalysis
    const [rec, setRec] = (0, $acw62.useState)('advance');
    const [rationale, setRationale] = (0, $acw62.useState)('');
    const [declineOpen, setDeclineOpen] = (0, $acw62.useState)(false);
    const [advancing, setAdvancing] = (0, $acw62.useState)(false);
    const [regenerating, setRegenerating] = (0, $acw62.useState)(false);
    const applyTriage = (data)=>{
        setT(data);
        setRationale(data.rationale || '');
        setRec(data.recommendation || 'advance');
        setStatus('ready');
    };
    // No triage stored yet — ask Intelligentsia to score it (needs a completed analysis).
    const generate = (0, $acw62.useCallback)(async ()=>{
        setStatus('generating');
        const res = await (0, $2f90eebb96c7748d$export$6995f089eca026dc)(deal.id);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res) && res.body) applyTriage(res.body);
        else setStatus('noanalysis');
    }, [
        deal.id
    ]);
    const load = (0, $acw62.useCallback)(async ()=>{
        setStatus('loading');
        setT(null);
        const data = await (0, $2f90eebb96c7748d$export$3ded8dfaa10f2a40)(deal.id);
        if (data) {
            applyTriage(data);
            return;
        }
        await generate();
    }, [
        deal.id,
        generate
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const regenerate = async ()=>{
        if (regenerating) return;
        setRegenerating(true);
        const res = await (0, $2f90eebb96c7748d$export$6995f089eca026dc)(deal.id);
        setRegenerating(false);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res) && res.body) {
            applyTriage(res.body);
            showToast('Triage re-scored by Intelligentsia');
        } else showToast(res && res.message || 'Could not regenerate triage');
    };
    if (status === 'loading') return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
            label: "Loading triage\u2026"
        })
    });
    if (status === 'generating') return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
            label: "Intelligentsia is scoring the deal\u2026"
        })
    });
    if (status === 'noanalysis' || !T) return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$fddf379e22a74b00), {
            title: "Run the analysis first",
            sub: "Triage scores the deal against your thesis weights \u2014 it needs the AI analysis to be complete."
        })
    });
    const rows = T.rows || [];
    const fit = T.fit || [];
    const firmShort = profile && profile.short ? profile.short.split(' ')[0] : 'the fund';
    const advance = async ()=>{
        if (advancing) return;
        setAdvancing(true);
        await (0, $2f90eebb96c7748d$export$cebf113164678c8c)(deal.id, {
            rationale: rationale,
            recommendation: rec
        }); // persist edits first
        const res = await (0, $2f90eebb96c7748d$export$a43e1fdbcae080df)(deal.id);
        setAdvancing(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return;
        showToast("Advanced to diligence \u2014 decision logged");
        navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/diligence`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "kicker",
                children: "Step 3 \xb7 Triage"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page__title",
                style: {
                    fontSize: 24,
                    marginBottom: 16
                },
                children: [
                    deal.name,
                    " \u2014 advance, hold, or decline"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: [
                                    "Scorecard vs ",
                                    firmShort,
                                    " thesis"
                                ]
                            }),
                            rows.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "scorerow",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "scorerow__name",
                                            children: r.name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "scorerow__bar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "scorerow__fill",
                                                style: {
                                                    width: `${r.score * 10}%`
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "scorerow__pct",
                                            children: [
                                                r.pct,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "scorerow__score",
                                            children: Number(r.score).toFixed(1)
                                        })
                                    ]
                                }, r.name)),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "weighted",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Weighted score"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "weighted__num",
                                        children: [
                                            T.weighted,
                                            " / 10"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__foot",
                                children: "Weights come straight from your Investor Profile \u2014 change them there and every triage rescores."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: "Thesis fit"
                                    }),
                                    fit.map((f, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "finding",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "finding__dot",
                                                    style: {
                                                        background: f.level === 'green' ? 'var(--dlg-green)' : 'var(--dlg-amber)'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: f.text
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 10
                                        },
                                        children: "Recommendation"
                                    }),
                                    $239eda984289c15a$var$RECS.map(([id, dot, title, sub])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: `rec ${id === rec ? 'is-selected' : ''}`,
                                            onClick: ()=>setRec(id),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "rec__title",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "finding__dot",
                                                            style: {
                                                                background: dot
                                                            }
                                                        }),
                                                        title
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "rec__sub",
                                                    children: sub
                                                })
                                            ]
                                        }, id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            marginBottom: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "chip chip--blue",
                                children: "\u2726 Rationale drafted by Intelligentsia \u2014 edit before saving"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "cp",
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)'
                                },
                                onClick: regenerate,
                                children: regenerating ? "\u27F2 regenerating\u2026" : "\u27F2 regenerate"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        className: "rationale-box",
                        value: rationale,
                        onChange: (e)=>setRationale(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            alignItems: 'center',
                            marginTop: 14,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--green",
                                onClick: advance,
                                disabled: advancing,
                                children: advancing ? "Advancing\u2026" : "Advance to diligence \u2192"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--declinered",
                                onClick: ()=>setDeclineOpen(true),
                                children: "Decline & notify"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)'
                                },
                                children: "Both outcomes are logged to the FCA-format decision log. Declining sends the templated pass note \u2014 editable before it goes."
                            })
                        ]
                    })
                ]
            }),
            declineOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b50dad277a8f08ad$export$2e2bcd8739ae039), {
                deal: deal,
                context: "triage",
                onClose: ()=>setDeclineOpen(false),
                onDeclined: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/pipeline`)
            })
        ]
    });
}


/* Step 4 — Diligence. Ported from the prototype's diligenceBody(). Four tabs:
   Data room (evidence requests + deck verification), Findings (verified vs open,
   founder questions), Comparables (peer multiples) and Financials (ledger audit).
   Data loads from GET /deal/:id/diligence; actions call the secure data-room link,
   founder-questions and PDF-export endpoints. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/* Tab row — ported from the prototype's tabrow(). Underlined tab links for
   the Diligence and Stress Test sub-workspaces. */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $aadb22d0bcd607dc$export$2e2bcd8739ae039({ baseHref: baseHref, tabs: tabs, activeTab: activeTab }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
        className: "tabrow",
        children: tabs.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: `${baseHref}/${t.id}`,
                className: t.id === activeTab ? 'is-active' : '',
                children: t.name
            }, t.id))
    });
}







const $6d204253082cd912$var$TABS = [
    {
        id: 'dataroom',
        name: 'Data room'
    },
    {
        id: 'findings',
        name: 'Findings'
    },
    {
        id: 'comparables',
        name: 'Comparables'
    },
    {
        id: 'financials',
        name: 'Financials'
    }
];
const $6d204253082cd912$var$Dot = ({ level: level })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "finding__dot",
        style: {
            background: (0, $b398648f62c2864e$export$825ea1f703a1aac9)(level)
        }
    });
async function $6d204253082cd912$var$openExport(deal, kind, showToast, setBusy) {
    setBusy(true);
    const res = await (0, $2f90eebb96c7748d$export$449e73bfb22de898)(deal.id, kind);
    setBusy(false);
    if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res) && res.body && res.body.url) {
        window.open(res.body.url, '_blank', 'noopener');
        showToast('Export ready');
    } else showToast(res && res.message || 'Export is unavailable right now');
}
function $6d204253082cd912$var$DataRoom({ deal: deal, D: D, showToast: showToast, navigate: navigate }) {
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const requests = D.dataroom && D.dataroom.requests || [];
    const chase = async ()=>{
        if (busy) return;
        setBusy(true);
        const pending = requests.filter(([, st])=>st !== 'received').map(([name])=>name);
        const res = await (0, $2f90eebb96c7748d$export$2c52a274f01fae07)(deal.id, {
            requests: pending
        });
        setBusy(false);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) showToast('Secure upload link sent to the founder for the pending items');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 6
                                },
                                children: "Evidence requested from the founder"
                            }),
                            requests.map(([name, st])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "reqrow",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `chip ${st === 'received' ? 'chip--green' : 'chip--amber'}`,
                                            style: {
                                                marginLeft: 'auto'
                                            },
                                            children: st === 'received' ? "Received \u2713" : 'Pending'
                                        })
                                    ]
                                }, name)),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)',
                                    marginTop: 10
                                },
                                children: D.dataroom && D.dataroom.requestsNote
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "chip chip--blue",
                                style: {
                                    marginBottom: 10
                                },
                                children: "\u2726 Verified against the deck as files arrive"
                            }),
                            (D.dataroom && D.dataroom.checks || []).map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "finding",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Dot, {
                                            level: c.level
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: c.text
                                        })
                                    ]
                                }, i)),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)',
                                    marginTop: 10
                                },
                                children: D.dataroom && D.dataroom.checksNote
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/diligence/findings`),
                        children: "Open findings \u2192"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--outline",
                        onClick: chase,
                        disabled: busy,
                        children: busy ? "Sending\u2026" : 'Chase pending items'
                    })
                ]
            })
        ]
    });
}
function $6d204253082cd912$var$Findings({ deal: deal, D: D, showToast: showToast, navigate: navigate }) {
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const findings = D.findings || {};
    const send = async ()=>{
        if (busy) return;
        setBusy(true);
        const res = await (0, $2f90eebb96c7748d$export$419946e781f7e0e9)(deal.id, {
            questions: findings.questions || ''
        });
        setBusy(false);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) showToast('Questions sent to the founder via Diligentsia');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: "Verified against evidence"
                            }),
                            (findings.verified || []).map((v, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "finding",
                                    style: {
                                        alignItems: 'flex-start'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Dot, {
                                            level: "green"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: v.title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "chip chip--green",
                                                    style: {
                                                        float: 'right'
                                                    },
                                                    children: "CONFIRMED"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        color: 'var(--dlg-muted)',
                                                        fontSize: 12.5
                                                    },
                                                    children: v.sub
                                                })
                                            ]
                                        })
                                    ]
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: "Open issues \xb7 carried into the memo"
                            }),
                            (findings.open || []).map((o, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "finding",
                                    style: {
                                        alignItems: 'flex-start'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Dot, {
                                            level: o.level
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    style: {
                                                        fontWeight: 600
                                                    },
                                                    children: o.title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `chip ${o.level === 'red' ? 'chip--red' : 'chip--amber'}`,
                                                    style: {
                                                        float: 'right'
                                                    },
                                                    children: o.tag
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        color: 'var(--dlg-muted)',
                                                        fontSize: 12.5
                                                    },
                                                    children: o.sub
                                                })
                                            ]
                                        })
                                    ]
                                }, i))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "chip chip--blue",
                        style: {
                            marginBottom: 10
                        },
                        children: "\u2726 Questions for the founder call \u2014 drafted from the findings"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 13.5,
                            lineHeight: 1.7,
                            color: 'var(--dlg-ink-soft)'
                        },
                        children: findings.questions
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/diligence/comparables`),
                        children: "Continue to comparables \u2192"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--outline",
                        onClick: send,
                        disabled: busy,
                        children: busy ? "Sending\u2026" : 'Send questions to founder'
                    })
                ]
            })
        ]
    });
}
function $6d204253082cd912$var$Comparables({ deal: deal, D: D, showToast: showToast, navigate: navigate }) {
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const comparables = D.comparables || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    display: 'flex',
                    gap: 16,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 6
                                },
                                children: "Valuation context"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 14.5,
                                    color: 'var(--dlg-ink-soft)',
                                    maxWidth: 640
                                },
                                dangerouslySetInnerHTML: {
                                    __html: comparables.context || ''
                                }
                            })
                        ]
                    }),
                    comparables.contextChip ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "chip chip--amber",
                        style: {
                            marginLeft: 'auto',
                            flex: 'none'
                        },
                        children: [
                            "\u25CF ",
                            comparables.contextChip
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                style: {
                    marginTop: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 6
                                },
                                children: "Direct comparables"
                            }),
                            (comparables.peers || []).map((pr, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "peer",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "peer__name",
                                                    children: pr.name
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "peer__meta",
                                                    children: pr.meta
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "chip chip--blue",
                                            style: {
                                                marginLeft: 'auto'
                                            },
                                            children: pr.mult
                                        })
                                    ]
                                }, i)),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)',
                                    marginTop: 10
                                },
                                children: comparables.peersNote
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: [
                                    "Where ",
                                    deal.name.split(' ')[0],
                                    " wins & loses"
                                ]
                            }),
                            (comparables.winsLoses || []).map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "finding",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Dot, {
                                            level: w.level
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: w.text
                                        })
                                    ]
                                }, i)),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-muted)',
                                    marginTop: 10
                                },
                                children: [
                                    "Feeds the defensibility test in ",
                                    (0, $33f9bd8300724d0e$export$79b91d4669dcadcb).scenarios,
                                    ", next step."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "pill pill--primary",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/scenarios`),
                        children: [
                            "Continue to ",
                            (0, $33f9bd8300724d0e$export$79b91d4669dcadcb).scenarios,
                            " \u2192"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--outline",
                        onClick: ()=>$6d204253082cd912$var$openExport(deal, 'comparables', showToast, setBusy),
                        disabled: busy,
                        children: busy ? "Exporting\u2026" : 'Export comparables'
                    })
                ]
            })
        ]
    });
}
function $6d204253082cd912$var$Financials({ deal: deal, D: D, showToast: showToast, navigate: navigate }) {
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const F = D.financials || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "chip chip--blue",
                        style: {
                            marginBottom: 14
                        },
                        children: "\u2726 Financial audit \u2014 run on the founder's ledger, not the deck"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "kpis",
                        children: (F.kpis || []).map(([label, value, sub, tone])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "kpi__label",
                                        children: label
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "kpi__value",
                                        style: tone === 'amber' ? {
                                            color: 'var(--dlg-amber-ink)'
                                        } : undefined,
                                        children: value
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "kpi__sub",
                                        children: sub
                                    })
                                ]
                            }, label))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                style: {
                    marginTop: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 10
                                },
                                children: "Revenue quality"
                            }),
                            (F.revenue || []).map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        marginBottom: 12
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: 13.5,
                                                color: 'var(--dlg-ink-soft)',
                                                marginBottom: 5
                                            },
                                            children: r.label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                height: 10,
                                                borderRadius: 999,
                                                background: 'var(--dlg-fill)'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    width: `${r.pct}%`,
                                                    height: 10,
                                                    borderRadius: 999,
                                                    background: r.color
                                                }
                                            })
                                        })
                                    ]
                                }, i)),
                            (F.revenueDots || []).map((d, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "finding",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Dot, {
                                            level: d.level
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: d.text
                                        })
                                    ]
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 8
                                },
                                children: "What the raise buys"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 13.5,
                                    lineHeight: 1.65,
                                    color: 'var(--dlg-ink-soft)'
                                },
                                dangerouslySetInnerHTML: {
                                    __html: F.raise || ''
                                }
                            }),
                            F.raiseDot ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "finding",
                                style: {
                                    marginTop: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Dot, {
                                        level: F.raiseDot.level
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: F.raiseDot.text
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "pill pill--primary",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/scenarios`),
                        children: [
                            "Continue to ",
                            (0, $33f9bd8300724d0e$export$79b91d4669dcadcb).scenarios,
                            " \u2192"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--outline",
                        onClick: ()=>$6d204253082cd912$var$openExport(deal, 'audit', showToast, setBusy),
                        disabled: busy,
                        children: busy ? "Exporting\u2026" : 'Export audit'
                    })
                ]
            })
        ]
    });
}
function $6d204253082cd912$export$2e2bcd8739ae039({ deal: deal }) {
    const { tab: tabParam } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const tab = [
        'dataroom',
        'findings',
        'comparables',
        'financials'
    ].includes(tabParam) ? tabParam : 'dataroom';
    const [D, setD] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setError(false);
        setD(null);
        const data = await (0, $2f90eebb96c7748d$export$45a268f1d3c5b949)(deal.id);
        if (!data) {
            setError(true);
            return;
        }
        setD(data);
    }, [
        deal.id
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "diligence"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 14
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$fddf379e22a74b00), {
                    title: "No diligence yet",
                    sub: "Run the AI analysis first \u2014 the diligence workspace is built from it."
                })
            })
        ]
    });
    if (!D) return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "diligence"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 14
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
                    label: "Building the diligence workspace with Intelligentsia\u2026 this can take up to a minute the first time."
                })
            })
        ]
    });
    const props = {
        deal: deal,
        D: D,
        showToast: showToast,
        navigate: navigate
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "diligence"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aadb22d0bcd607dc$export$2e2bcd8739ae039), {
                baseHref: `${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/diligence`,
                activeTab: tab,
                tabs: $6d204253082cd912$var$TABS
            }),
            tab === 'dataroom' && /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$DataRoom, {
                ...props
            }),
            tab === 'findings' && /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Findings, {
                ...props
            }),
            tab === 'comparables' && /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Comparables, {
                ...props
            }),
            tab === 'financials' && /*#__PURE__*/ (0, $ayMG0.jsx)($6d204253082cd912$var$Financials, {
                ...props
            })
        ]
    });
}


/* Step 5 — Stress Test. Ported from the prototype's scenariosBody(). Three tabs:
   AI Strategy Review ("AI-CEO" defensibility test), Growth simulation (Monte-Carlo
   ARR at month 24) and Exit paths. Data loads from GET /deal/:id/scenarios; if none
   exists it can be generated via POST .../scenarios/run. "Share with founder" pushes
   outputs into the founder's Research Aid via POST .../share. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








const $887d5c898d3f6b1f$var$Dot = ({ level: level })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "finding__dot",
        style: {
            background: (0, $b398648f62c2864e$export$825ea1f703a1aac9)(level)
        }
    });
const $887d5c898d3f6b1f$var$aiceo = (t)=>(t || '').replaceAll('{AICEO}', (0, $33f9bd8300724d0e$export$79b91d4669dcadcb).aiceo);
function $887d5c898d3f6b1f$export$2e2bcd8739ae039({ deal: deal }) {
    const { tab: tabParam } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const tab = [
        'strategy',
        'growth',
        'exit'
    ].includes(tabParam) ? tabParam : 'strategy';
    const [S, setS] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)('loading'); // loading | ready | empty | generating
    const [sharing, setSharing] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setStatus('loading');
        const data = await (0, $2f90eebb96c7748d$export$19f00a003bc3f759)(deal.id);
        if (!data) {
            setStatus('empty');
            setS(null);
            return;
        }
        setS(data);
        setStatus('ready');
    }, [
        deal.id
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const generate = async ()=>{
        setStatus('generating');
        const res = await (0, $2f90eebb96c7748d$export$2bee563b1093e80a)(deal.id);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) {
            setS(res.body);
            setStatus('ready');
            showToast('Stress test generated');
        } else setStatus('empty');
    };
    const shareWithFounder = async ()=>{
        if (sharing) return;
        setSharing(true);
        const res = await (0, $2f90eebb96c7748d$export$69022347ed6cef92)(deal.id, {
            target: 'founder'
        });
        setSharing(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return;
        showToast(`${(0, $33f9bd8300724d0e$export$79b91d4669dcadcb).aiceo} shared with ${deal.name}`);
        setTimeout(()=>showToast(`Added to ${deal.name.split(' ')[0]}'s Research Aid on Diligentsia`, true), 900);
    };
    if (status === 'loading') return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "scenarios"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 14
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
                    label: "Loading stress test\u2026"
                })
            })
        ]
    });
    if (status === 'empty' || status === 'generating') return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "scenarios"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    marginTop: 14,
                    textAlign: 'center',
                    padding: 28
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "card__label",
                        style: {
                            marginBottom: 8
                        },
                        children: (0, $33f9bd8300724d0e$export$79b91d4669dcadcb).scenarios
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: 13.5,
                            color: 'var(--dlg-muted)',
                            marginBottom: 14
                        },
                        children: [
                            "Run Intelligentsia's strategy, growth and exit simulations for ",
                            deal.name,
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        onClick: generate,
                        disabled: status === 'generating',
                        children: status === 'generating' ? "Generating\u2026" : `Generate ${(0, $33f9bd8300724d0e$export$79b91d4669dcadcb).scenarios}`
                    })
                ]
            })
        ]
    });
    const strategy = S.strategy || {}, growth = S.growth || {}, exit = S.exit || {};
    const TABS = [
        {
            id: 'strategy',
            name: (0, $33f9bd8300724d0e$export$79b91d4669dcadcb).aiceo
        },
        {
            id: 'growth',
            name: 'Growth simulation'
        },
        {
            id: 'exit',
            name: 'Exit paths'
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "scenarios"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aadb22d0bcd607dc$export$2e2bcd8739ae039), {
                baseHref: `${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/scenarios`,
                activeTab: tab,
                tabs: TABS
            }),
            tab === 'strategy' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "chip chip--blue",
                        style: {
                            marginBottom: 12
                        },
                        children: [
                            "\u2726 ",
                            strategy.chip
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid--split45",
                        style: {
                            marginTop: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card plan",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 4
                                        },
                                        children: "Founder's plan"
                                    }),
                                    (strategy.founder || []).map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "plan__row",
                                            children: r
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card plan plan--alt",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 4
                                        },
                                        children: "Intelligentsia's alternative"
                                    }),
                                    (strategy.alternative || []).map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "plan__row",
                                            children: r
                                        }, i))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        style: {
                            display: 'flex',
                            gap: 16,
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 6
                                        },
                                        children: "Defensibility verdict"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 14.5,
                                            color: 'var(--dlg-ink-soft)',
                                            maxWidth: 700
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: strategy.verdict || ''
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "verdict-dots",
                                children: (strategy.verdictDots || []).map((d, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            background: (0, $b398648f62c2864e$export$825ea1f703a1aac9)(d)
                                        }
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            marginTop: 4,
                            flexWrap: 'wrap',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: shareWithFounder,
                                disabled: sharing,
                                children: sharing ? "Sharing\u2026" : "Share with founder \u2192"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--outline",
                                onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/scenarios/growth`),
                                children: "Run growth simulation"
                            })
                        ]
                    })
                ]
            }),
            tab === 'growth' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "chip chip--blue",
                        style: {
                            marginBottom: 12
                        },
                        children: [
                            "\u2726 ",
                            growth.chip
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        style: {
                            marginTop: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 14
                                },
                                children: "Projected ARR in 24 months"
                            }),
                            (growth.rows || []).map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "simrow",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "simrow__head",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "simrow__name",
                                                    children: $887d5c898d3f6b1f$var$aiceo(r.name)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "simrow__bar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "simrow__fill",
                                                        style: {
                                                            width: `${r.pct}%`,
                                                            background: r.color
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "simrow__arr",
                                                    children: r.arr
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "simrow__sub",
                                            children: r.sub
                                        })
                                    ]
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid grid--split45",
                        style: {
                            marginTop: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: "What moves the number"
                                    }),
                                    (growth.movers || []).map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "finding",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($887d5c898d3f6b1f$var$Dot, {
                                                    level: m.level
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: m.text
                                                })
                                            ]
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: "Read for the committee"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 13.5,
                                            lineHeight: 1.65,
                                            color: 'var(--dlg-ink-soft)'
                                        },
                                        children: $887d5c898d3f6b1f$var$aiceo(growth.committee)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/scenarios/exit`),
                                children: "Continue to exit paths \u2192"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--outline",
                                onClick: shareWithFounder,
                                disabled: sharing,
                                children: "Share with founder"
                            })
                        ]
                    })
                ]
            }),
            tab === 'exit' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "chip chip--blue",
                        style: {
                            marginBottom: 12
                        },
                        children: [
                            "\u2726 ",
                            exit.chip
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "exitgrid",
                        style: {
                            marginTop: 12
                        },
                        children: (exit.paths || []).map((x, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "exitcard__head",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "exitcard__name",
                                                children: x.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `chip ${x.tagCls}`,
                                                style: {
                                                    marginLeft: 'auto',
                                                    flex: 'none'
                                                },
                                                children: x.tag
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "exitcard__text",
                                        children: x.text
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "exitcard__ret",
                                        dangerouslySetInnerHTML: {
                                            __html: x.ret || ''
                                        }
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 6
                                },
                                children: "What this means for the deal"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 14,
                                    color: 'var(--dlg-ink-soft)'
                                },
                                dangerouslySetInnerHTML: {
                                    __html: exit.meaning || ''
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            marginTop: 12,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/memo`),
                                children: "Generate IC memo \u2192"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--outline",
                                onClick: shareWithFounder,
                                disabled: sharing,
                                children: "Share with founder"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/* Step 6 — IC Memo. Ported from the prototype's memoBody(). Committee-ready memo
   auto-assembled from analysis + diligence + scenarios; every section is editable and
   individually regenerable. Data loads from GET /deal/:id/memo (generated on demand via
   POST .../memo/regenerate); edits persist via PUT .../memo; export + share are live. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






// Sections/terms arrive as [label, value] tuples; helpers to read/convert.
const $7aa938c3e12612e5$var$toSectionObjs = (sections)=>(sections || []).map(([label, body])=>({
            label: label,
            body: body
        }));
function $7aa938c3e12612e5$export$2e2bcd8739ae039({ deal: deal }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const [M, setM] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)('loading'); // loading | ready | empty | generating
    const [editingIdx, setEditingIdx] = (0, $acw62.useState)(-1);
    const [draft, setDraft] = (0, $acw62.useState)('');
    const [regenIdx, setRegenIdx] = (0, $acw62.useState)(-1);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setStatus('loading');
        const data = await (0, $2f90eebb96c7748d$export$7ca6ee0ed643263f)(deal.id);
        if (!data) {
            setStatus('empty');
            setM(null);
            return;
        }
        setM(data);
        setStatus('ready');
    }, [
        deal.id
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const generateFull = async ()=>{
        setStatus('generating');
        const res = await (0, $2f90eebb96c7748d$export$f66b362cf3179428)(deal.id, null);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) {
            setM(res.body);
            setStatus('ready');
            showToast('IC memo assembled');
        } else setStatus('empty');
    };
    const startEdit = (idx, body)=>{
        setEditingIdx(idx);
        setDraft(body);
    };
    const cancelEdit = ()=>{
        setEditingIdx(-1);
        setDraft('');
    };
    const saveEdit = async (idx)=>{
        const sections = $7aa938c3e12612e5$var$toSectionObjs(M.sections);
        sections[idx] = {
            ...sections[idx],
            body: draft,
            editedByHuman: true
        };
        const res = await (0, $2f90eebb96c7748d$export$bc8fb7dfcfd1e291)(deal.id, sections);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) {
            showToast('Section saved');
            cancelEdit();
            await load();
        }
    };
    const regenerate = async (label, idx)=>{
        setRegenIdx(idx);
        const res = await (0, $2f90eebb96c7748d$export$f66b362cf3179428)(deal.id, label);
        setRegenIdx(-1);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) {
            setM(res.body);
            showToast(`${label} regenerated`);
        }
    };
    const exportPdfMemo = async ()=>{
        if (busy) return;
        setBusy(true);
        const res = await (0, $2f90eebb96c7748d$export$449e73bfb22de898)(deal.id, 'memo');
        setBusy(false);
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res) && res.body && res.body.url) {
            window.open(res.body.url, '_blank', 'noopener');
            showToast('Memo exported to PDF');
        } else showToast(res && res.message || 'Export is unavailable right now');
    };
    const shareWithIC = async ()=>{
        if (busy) return;
        setBusy(true);
        const res = await (0, $2f90eebb96c7748d$export$69022347ed6cef92)(deal.id, {
            target: 'ic'
        });
        setBusy(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return;
        showToast('Memo shared with IC members');
        setTimeout(()=>showToast('IC members notified on Diligentsia', true), 900);
    };
    if (status === 'loading') return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "memo"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    marginTop: 14
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
                    label: "Loading memo\u2026"
                })
            })
        ]
    });
    if (status === 'empty' || status === 'generating') return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbff18614c7ce1a9$export$2e2bcd8739ae039), {
                deal: deal,
                stepId: "memo"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    marginTop: 14,
                    textAlign: 'center',
                    padding: 28
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "card__label",
                        style: {
                            marginBottom: 8
                        },
                        children: "IC memo"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: 13.5,
                            color: 'var(--dlg-muted)',
                            marginBottom: 14
                        },
                        children: [
                            "Assemble a committee-ready memo for ",
                            deal.name,
                            " from the analysis, diligence and stress test."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        onClick: generateFull,
                        disabled: status === 'generating',
                        children: status === 'generating' ? "Assembling\u2026" : 'Generate IC memo'
                    })
                ]
            })
        ]
    });
    const sections = M.sections || [];
    const terms = M.terms || [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    padding: '22px 26px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 12,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            fontSize: 20,
                                            fontWeight: 600
                                        },
                                        children: [
                                            deal.name,
                                            " \u2014 investment memo"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 13,
                                            color: 'var(--dlg-muted)',
                                            marginTop: 2
                                        },
                                        children: M.ref
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    marginLeft: 'auto',
                                    display: 'flex',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "pill pill--outline",
                                        onClick: exportPdfMemo,
                                        disabled: busy,
                                        children: busy ? "Working\u2026" : 'Export PDF'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "pill pill--primary",
                                        onClick: shareWithIC,
                                        disabled: busy,
                                        children: "Share with IC"
                                    })
                                ]
                            })
                        ]
                    }),
                    M.chip ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "chip chip--blue",
                        style: {
                            margin: '12px 0 4px'
                        },
                        children: [
                            "\u2726 ",
                            M.chip
                        ]
                    }) : null,
                    sections.map(([label, body], i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "memo__section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "memo__head",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "memo__label",
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "memo__tools",
                                            children: editingIdx === i ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "cp",
                                                        onClick: ()=>saveEdit(i),
                                                        children: "\u2714 save"
                                                    }),
                                                    " \xb7 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "cp",
                                                        onClick: cancelEdit,
                                                        children: "\u2715 cancel"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "cp",
                                                        onClick: ()=>startEdit(i, body),
                                                        children: "\u270E edit"
                                                    }),
                                                    " \xb7 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "cp",
                                                        onClick: ()=>regenerate(label, i),
                                                        children: regenIdx === i ? "\u27F2 regenerating\u2026" : "\u27F2 regenerate"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                editingIdx === i ? /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    className: "rationale-box",
                                    value: draft,
                                    onChange: (e)=>setDraft(e.target.value),
                                    style: {
                                        minHeight: 120
                                    }
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "memo__body",
                                    dangerouslySetInnerHTML: {
                                        __html: body
                                    }
                                }),
                                i === 1 && terms.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "terms",
                                    children: terms.map(([k, v])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "terms__label",
                                                    children: k
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "terms__value",
                                                    children: v
                                                })
                                            ]
                                        }, k))
                                })
                            ]
                        }, label + i)),
                    M.footer ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 12.5,
                            color: 'var(--dlg-faint)',
                            paddingTop: 12,
                            borderTop: '0.5px solid var(--dlg-hairline)'
                        },
                        children: M.footer
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 14
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/decision`),
                        children: "Record decision \u2192"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--outline",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/deal/${deal.id}/triage`),
                        children: "Back to triage"
                    })
                ]
            })
        ]
    });
}


/* Step 7 — Decision + audit trail. Ported from the prototype's decisionBody().
   Record the outcome with an editable AI-drafted response letter; POST .../decision
   persists the decision, queues the decision-letter email and appends to the FCA
   audit log. The same-day trail is sourced live from GET .../decision (DealAuditEvent).
   Confirming ticks all seven steps and routes back to the pipeline. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






function $73cd10db2c93c719$export$2e2bcd8739ae039({ deal: deal }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const { markDecided: markDecided } = (0, $3c0860f4d138445e$export$cd39639fa62f47f8)();
    const { profile: profile } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    const [D, setD] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)('loading');
    const [choice, setChoice] = (0, $acw62.useState)('advance');
    const [letter, setLetter] = (0, $acw62.useState)('');
    const [recorded, setRecorded] = (0, $acw62.useState)(false);
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setStatus('loading');
        const data = await (0, $2f90eebb96c7748d$export$5061d6c60774bd76)(deal.id);
        if (!data) {
            setStatus('error');
            return;
        }
        setD(data);
        const initial = data.outcome || 'advance';
        setChoice(initial);
        setLetter(data.letters && data.letters[initial] || data.letter || '');
        if (data.outcome) {
            setRecorded(true);
            markDecided(deal.id);
        }
        setStatus('ready');
    }, [
        deal.id,
        markDecided
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    if (status === 'loading') return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
            label: "Loading decision\u2026"
        })
    });
    if (status === 'error' || !D) return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$fddf379e22a74b00), {
            title: "No decision workspace yet",
            sub: "Generate the IC memo first \u2014 the decision step records the committee's outcome."
        })
    });
    const options = D.options || [];
    const letters = D.letters || {};
    const record = D.record || {};
    const trail = D.trail || [];
    const firmShort = profile && profile.short || 'the fund';
    const pick = (id)=>{
        setChoice(id);
        setLetter(letters[id] || letter);
    };
    const persist = async ()=>{
        const res = await (0, $2f90eebb96c7748d$export$465dd44d1c8dd955)(deal.id, {
            outcome: choice,
            letter: letter
        });
        if ((0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) {
            setRecorded(true);
            markDecided(deal.id);
            return true;
        }
        return false;
    };
    const saveSend = async ()=>{
        if (busy) return;
        setBusy(true);
        const done = await persist();
        if (done) {
            showToast('Response saved and sent to the founder');
            await load();
        }
        setBusy(false);
    };
    const confirm = async ()=>{
        if (busy) return;
        setBusy(true);
        // Avoid a duplicate audit event if the response was already recorded above.
        const done = recorded ? true : await persist();
        setBusy(false);
        if (!done) return;
        if (choice === 'advance') {
            showToast("Decision logged \u2014 Advanced \xb7 response sent");
            setTimeout(()=>showToast(`${deal.name} added to ${firmShort}'s Portfolio on Diligentsia`, true), 950);
        } else {
            showToast("Decision logged \u2014 Declined \xb7 constructive feedback sent");
            setTimeout(()=>showToast(`${deal.name} profile released for matching with other VCs`, true), 950);
        }
        setTimeout(()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/pipeline`), 1200);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "kicker",
                children: "Step 7 \xb7 Decision"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "page__title",
                style: {
                    fontSize: 24,
                    marginBottom: 16
                },
                children: "Record the outcome"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 12,
                    marginBottom: 12,
                    flexWrap: 'wrap'
                },
                children: options.map((o)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `opt ${o.id === choice ? 'is-selected' : ''}`,
                        onClick: ()=>pick(o.id),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "opt__title",
                                children: [
                                    o.title,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "opt__radio"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "opt__sub",
                                children: o.sub
                            })
                        ]
                    }, o.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "chip chip--blue",
                                style: {
                                    marginBottom: 10
                                },
                                children: "\u2726 Response drafted by Intelligentsia \u2014 edit before sending"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                className: "rationale-box",
                                style: {
                                    minHeight: 270
                                },
                                value: letter,
                                onChange: (e)=>setLetter(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                style: {
                                    marginTop: 12
                                },
                                onClick: saveSend,
                                disabled: busy,
                                children: busy ? "Sending\u2026" : 'Save & send response'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 12
                                        },
                                        children: "Decision record"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: 14
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__label",
                                                        children: "Outcome"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__value",
                                                        children: choice === 'advance' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                color: 'var(--dlg-pos)'
                                                            },
                                                            children: "Advanced"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                color: 'var(--dlg-red-ink)'
                                                            },
                                                            children: "Declined"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__label",
                                                        children: "Decided by"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__value",
                                                        children: record.decidedBy || "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__label",
                                                        children: "Analysis"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__value",
                                                        children: record.analysis || "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__label",
                                                        children: "Triage"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "terms__value",
                                                        children: record.triage || "\u2014"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: "Audit trail"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "trail",
                                        children: trail.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                color: 'var(--dlg-muted)'
                                            },
                                            children: "No entries yet."
                                        }) : trail.map(([t, text, tone], i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("time", {
                                                        children: t
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "finding__dot",
                                                        style: {
                                                            background: (0, $b398648f62c2864e$export$825ea1f703a1aac9)(tone === 'green' ? 'green' : tone === 'red' ? 'red' : 'blue')
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: text
                                                        }
                                                    })
                                                ]
                                            }, i))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    marginTop: 4,
                    flexWrap: 'wrap',
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--green",
                        onClick: confirm,
                        disabled: busy,
                        children: "Confirm & log decision"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--outline",
                        onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/pipeline`),
                        children: "Back to deal flow"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontSize: 12.5,
                            color: 'var(--dlg-muted)'
                        },
                        children: "Logged in FCA format \u2014 outcome, reason, who, when \u2014 alongside the gate and triage entries."
                    })
                ]
            })
        ]
    });
}


const $34688a3b5a907b47$var$SCREENS = {
    intake: (0, $a0c04ea32e3b3707$export$2e2bcd8739ae039),
    analysis: (0, $f6ad8c34260040d5$export$2e2bcd8739ae039),
    triage: (0, $239eda984289c15a$export$2e2bcd8739ae039),
    diligence: (0, $6d204253082cd912$export$2e2bcd8739ae039),
    scenarios: (0, $887d5c898d3f6b1f$export$2e2bcd8739ae039),
    memo: (0, $7aa938c3e12612e5$export$2e2bcd8739ae039),
    decision: (0, $73cd10db2c93c719$export$2e2bcd8739ae039)
};
function $34688a3b5a907b47$export$2e2bcd8739ae039() {
    const { id: id, step: step } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { isDecided: isDecided } = (0, $3c0860f4d138445e$export$cd39639fa62f47f8)();
    const [deal, setDeal] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setError(false);
        setDeal(null);
        const d = await (0, $2f90eebb96c7748d$export$6bc52dcdb0a32896)(id);
        if (!d) {
            setError(true);
            return;
        }
        setDeal(d);
    }, [
        id
    ]);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const stepId = (0, $33f9bd8300724d0e$export$6836fb99d2ec00dc).some((s)=>s.id === step) ? step : 'intake';
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce9e66af65470eaa$export$2e2bcd8739ae039), {
                dealId: id,
                activeStep: stepId,
                decided: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                className: "page screen",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$c1ed4f415b9e7023), {
                    title: "Deal not found",
                    sub: "This deal could not be loaded \u2014 it may have been removed.",
                    onRetry: load
                })
            })
        ]
    });
    if (!deal) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce9e66af65470eaa$export$2e2bcd8739ae039), {
                dealId: id,
                activeStep: stepId,
                decided: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                className: "page screen",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
                    label: "Loading deal\u2026"
                })
            })
        ]
    });
    const Screen = $34688a3b5a907b47$var$SCREENS[stepId] || (0, $a0c04ea32e3b3707$export$2e2bcd8739ae039);
    // A recorded decision closes the deal — the backend rejects every mutation (read-only);
    // this flag drives the all-ticked stepper and the view-only banner. `deal.decided` is
    // authoritative (from GET /deal/:id); fall back to the session flag for immediacy.
    const locked = deal.decided || isDecided(deal.id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce9e66af65470eaa$export$2e2bcd8739ae039), {
                dealId: deal.id,
                activeStep: stepId,
                decided: locked
            }),
            locked && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "page",
                style: {
                    paddingTop: 12,
                    paddingBottom: 0
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "card",
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        borderColor: 'var(--dlg-blue)',
                        background: 'var(--dlg-fill)'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: 18
                            },
                            children: "\uD83D\uDD12"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontWeight: 600,
                                        color: 'var(--dlg-ink)'
                                    },
                                    children: "Decision recorded \u2014 this deal is read-only"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        fontSize: 13,
                                        color: 'var(--dlg-muted)'
                                    },
                                    children: [
                                        "Outcome: ",
                                        deal.decisionOutcome === 'decline' ? 'Declined' : 'Advanced',
                                        ". You can view every step and export reports, but the workflow is locked \u2014 no further edits or re-runs."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(Screen, {
                deal: deal
            })
        ]
    });
}


/* Fund Dashboard — ported from the prototype's Screens.dashboard(). Live deals,
   pipeline ask vs funds, avg decision time, active diligence, conversion funnel,
   inbound by sector, rejection reasons, inbound-quality trend, governance stats,
   a stagnant-deal nudge and an Intelligentsia insight. Every figure is computed
   by the backend from the firm's deals + FCA audit log (GET /deal/dashboard). */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


/* Labelled progress bar — ported from the prototype's barRow(). */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $4f158d855965cb4c$export$2e2bcd8739ae039({ label: label, right: right, pct: pct, color: color }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    fontSize: 13,
                    color: 'var(--dlg-ink-soft)'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            marginLeft: 'auto',
                            fontWeight: 500,
                            color: 'var(--dlg-ink)'
                        },
                        children: right
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    height: 8,
                    borderRadius: 999,
                    background: 'var(--dlg-fill)',
                    marginTop: 4
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        width: `${pct}%`,
                        height: 8,
                        borderRadius: 999,
                        background: color
                    }
                })
            })
        ]
    });
}







const $fa8e64c710ef587f$var$BLUES = [
    '#4A67FF',
    '#6B82FF',
    '#8C9DFF',
    '#B3BEFF',
    'var(--dlg-green)'
];
function $fa8e64c710ef587f$export$2e2bcd8739ae039() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const { profile: profile } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    const [D, setD] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(false);
    const load = (0, $acw62.useCallback)(async ()=>{
        setError(false);
        const data = await (0, $2f90eebb96c7748d$export$720d5b271123ea20)();
        if (!data) {
            setError(true);
            setD(null);
            return;
        }
        setD(data);
    }, []);
    (0, $acw62.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$c1ed4f415b9e7023), {
            title: "Could not load the dashboard",
            onRetry: load
        })
    });
    if (D === null) return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
            label: "Loading dashboard\u2026"
        })
    });
    const newThisWeek = D.newThisWeek || [];
    const funnel = D.funnel || [];
    const sectors = D.sectors || [];
    const rejections = D.rejections || [];
    const governance = D.governance || [];
    const active = D.activeDiligence || {
        count: 0,
        allocation: "\xa30",
        detail: "\u2014"
    };
    const quality = D.inboundQuality || {
        score: 0,
        best: "\u2014",
        worst: "\u2014"
    };
    const received = funnel[0] ? funnel[0].n : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page__head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "kicker",
                                children: [
                                    "Fund dashboard \xb7 ",
                                    profile && profile.short || 'Your fund'
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "page__title",
                                children: "Pipeline pulse"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "page__actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--ghost",
                                children: "Last 12 months \u25BE"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--outline",
                                onClick: ()=>navigate(`${(0, $b398648f62c2864e$export$9e15ff8aa6bc996f)}/pipeline`),
                                children: "Open pipeline \u2192"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                children: "Deal flow"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat",
                                children: [
                                    D.liveDeals,
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "stat__unit",
                                        children: "live deals"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat__note stat__note--up",
                                children: [
                                    "\u25B2 ",
                                    newThisWeek.length,
                                    " new this week",
                                    newThisWeek.length ? ` \xb7 ${newThisWeek.join(', ')}` : ''
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                children: "Pipeline ask"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat",
                                children: [
                                    D.pipelineAsk,
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "stat__unit",
                                        children: [
                                            "across ",
                                            D.liveDeals
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat__note",
                                children: [
                                    "vs ",
                                    D.fundsThisVintage,
                                    " funds available this vintage"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                children: "Avg decision time"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat",
                                children: [
                                    D.avgDecisionDays,
                                    " days"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "stat__note",
                                children: D.stageDays
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                children: "Active diligence"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat",
                                children: [
                                    active.count,
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "stat__unit",
                                        children: [
                                            "\xb7 ",
                                            active.allocation,
                                            " allocation"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "stat__note",
                                children: active.detail
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__row",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        children: "Conversion funnel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "card__hint",
                                        children: [
                                            received,
                                            " applications"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 7
                                },
                                children: funnel.map((f, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: 118,
                                                    fontSize: 13,
                                                    color: 'var(--dlg-ink-soft)'
                                                },
                                                children: f.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 16,
                                                    borderRadius: 999,
                                                    background: 'var(--dlg-fill)'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        width: `${f.pct}%`,
                                                        height: 16,
                                                        borderRadius: 999,
                                                        background: $fa8e64c710ef587f$var$BLUES[i]
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: 110,
                                                    textAlign: 'right',
                                                    fontWeight: 500,
                                                    fontSize: 13
                                                },
                                                children: i === 0 ? f.n : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        f.n,
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                fontWeight: 400,
                                                                color: 'var(--dlg-faint)'
                                                            },
                                                            children: [
                                                                f.pct,
                                                                "%",
                                                                f.extra ? ` \xb7 ${f.extra}` : ''
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, f.label))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__foot",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: D.gateDeclined
                                            }),
                                            " auto-declined at gate \xb7 zero AI spend"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: D.totalPasses
                                            }),
                                            " total passes"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: D.liveDeals
                                            }),
                                            " still live"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 12
                                },
                                children: "Inbound by sector"
                            }),
                            sectors.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    color: 'var(--dlg-muted)'
                                },
                                children: "No sector data yet."
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 8
                                },
                                children: sectors.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: 92,
                                                    fontSize: 13,
                                                    color: 'var(--dlg-ink-soft)'
                                                },
                                                children: s.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    height: 9,
                                                    borderRadius: 999,
                                                    background: 'var(--dlg-fill)'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        width: `${s.pct}%`,
                                                        height: 9,
                                                        borderRadius: 999,
                                                        background: i === 3 ? 'var(--dlg-coral)' : $fa8e64c710ef587f$var$BLUES[Math.min(i, 3)]
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    width: 34,
                                                    textAlign: 'right',
                                                    fontWeight: 500,
                                                    fontSize: 13
                                                },
                                                children: [
                                                    s.pct,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, s.name))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__foot",
                                children: "Live share of inbound across your thesis sectors"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--3a",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__row",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        children: "Rejection reasons"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "card__hint",
                                        children: [
                                            D.totalPasses,
                                            " passes"
                                        ]
                                    })
                                ]
                            }),
                            rejections.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    color: 'var(--dlg-muted)'
                                },
                                children: "No declines logged yet."
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 9
                                },
                                children: rejections.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f158d855965cb4c$export$2e2bcd8739ae039), {
                                        label: r.reason,
                                        right: `${r.n} \xb7 ${r.pct}%`,
                                        pct: r.pct,
                                        color: i === 3 ? 'var(--dlg-coral)' : i === 4 ? 'var(--dlg-border-soft)' : $fa8e64c710ef587f$var$BLUES[Math.min(i, 2)]
                                    }, r.reason))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        style: {
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                children: "Inbound quality"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    gap: 8,
                                    marginTop: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "stat",
                                        children: [
                                            quality.score,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    color: 'var(--dlg-faint)'
                                                },
                                                children: "/100"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "chip chip--green",
                                        children: "\u25CF healthy"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "stat__note",
                                children: [
                                    "Avg analysis score \xb7 best ",
                                    quality.best,
                                    " \xb7 worst ",
                                    quality.worst
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                viewBox: "0 0 260 58",
                                style: {
                                    width: '100%',
                                    marginTop: 'auto'
                                },
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                        points: "6,42 46,37 86,40 126,27 166,31 206,20 254,16",
                                        fill: "none",
                                        stroke: "var(--dlg-blue)",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "254",
                                        cy: "16",
                                        r: "4.5",
                                        fill: "var(--dlg-blue)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    fontSize: 11.5,
                                    color: 'var(--dlg-axis)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Mar"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            marginLeft: 'auto'
                                        },
                                        children: "Aug"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 10
                                },
                                children: "Governance & network"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 10
                                },
                                children: governance.map((g)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10,
                                            fontSize: 13,
                                            color: 'var(--dlg-ink-soft)'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: '50%',
                                                    background: g.dot,
                                                    flex: 'none'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: g.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    marginLeft: 'auto',
                                                    fontWeight: 500,
                                                    color: 'var(--dlg-ink)'
                                                },
                                                children: g.value
                                            })
                                        ]
                                    }, g.label))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card__row",
                        style: {
                            marginBottom: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                children: "Stagnant deals \xb7 over 7 days in stage"
                            }),
                            D.stagnant ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "chip chip--amber",
                                style: {
                                    marginLeft: 'auto'
                                },
                                children: "1 needs action"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "chip chip--green",
                                style: {
                                    marginLeft: 'auto'
                                },
                                children: "all moving"
                            })
                        ]
                    }),
                    D.stagnant ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stagnant",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: 'var(--dlg-amber)',
                                    flex: 'none'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            fontSize: 14,
                                            fontWeight: 500
                                        },
                                        children: [
                                            D.stagnant.name,
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    fontWeight: 400,
                                                    color: 'var(--dlg-muted)'
                                                },
                                                children: [
                                                    "\xb7 ",
                                                    D.stagnant.meta
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 12.5,
                                            color: 'var(--dlg-muted)'
                                        },
                                        children: D.stagnant.detail
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--ghost",
                                style: {
                                    marginLeft: 'auto'
                                },
                                onClick: ()=>showToast(`Nudge drafted for ${D.stagnant.name} \u{2014} send from the Diligence workspace`),
                                children: "Nudge founder \u2192"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 13,
                            color: 'var(--dlg-muted)'
                        },
                        children: "No deals have stalled \u2014 everything is moving through the pipeline."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d1867d50eaca9584$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: "Intelligentsia:"
                                }),
                                " the gate cleared ",
                                D.totalPasses,
                                " of ",
                                received,
                                " applications before any AI spend. Governance, sector mix and rejection reasons all update live as deals move."
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


/* Investor Profile — ported from the prototype's Screens.profile(). Read-only
   mirror of the VC's Diligentsia investor settings: identity + Companies House,
   objective match criteria (rule-out / advisory), the five scoring weights,
   subjective criteria + thesis read-back, quick responses and preferred contact. */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




function $c00354e0b41ef16b$export$2e2bcd8739ae039() {
    const { profile: P, loading: loading, error: error } = (0, $3c0860f4d138445e$export$73fc7af4ef9455f4)();
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$669f6ea7d267feaf), {
            label: "Loading investor profile\u2026"
        })
    });
    if (error || !P) return /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
        className: "page screen",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7cf0de650ddb521f$export$fddf379e22a74b00), {
            title: "Investor profile not synced yet",
            sub: "Your thesis, criteria and weights sync here from your Diligentsia investor settings. Once synced, every score, triage and memo is weighted against them."
        })
    });
    const criteria = P.criteria || [];
    const weights = P.weights || [];
    const quickResponses = P.quickResponses || [];
    const preferredContact = P.preferredContact || {};
    const extended = P.extended || {};
    const ruleOutCount = criteria.filter((c)=>c.ruleOut).length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page__head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "kicker",
                                children: "Investor profile \xb7 pulled from Diligentsia settings"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "page__title",
                                children: P.short
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "page__sub",
                                children: "Read-only here \u2014 every score, triage and memo is weighted against these settings."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "page__actions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "chip chip--muted",
                                style: {
                                    padding: '7px 14px',
                                    fontSize: 12.5
                                },
                                children: "\u27F3 Synced 2h ago"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "pill pill--primary",
                                href: "https://diligentsia.co.uk/investor-setting",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Edit on Diligentsia \u2197"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card idcard",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 18,
                    marginBottom: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "dealstrip__logo",
                        style: {
                            width: 52,
                            height: 52,
                            borderRadius: '50%',
                            fontSize: 18
                        },
                        children: P.initials
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: 17,
                                            fontWeight: 500
                                        },
                                        children: P.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "chip chip--green",
                                        children: [
                                            "\u2713 Companies House \xb7 ",
                                            P.chNumber
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    fontSize: 13,
                                    color: 'var(--dlg-muted)',
                                    marginTop: 3
                                },
                                children: [
                                    P.website,
                                    " \xb7 ",
                                    P.hq,
                                    " \xb7 ",
                                    P.staffHome,
                                    " staff (",
                                    P.staffGlobal,
                                    " globally) \xb7 Preferred contact: ",
                                    preferredContact.name
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "idcard__facts",
                        style: {
                            marginLeft: 'auto',
                            display: 'flex',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "factchip",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "factchip__label",
                                        children: "Funds available"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "factchip__value",
                                        children: P.fundsAvailable
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "factchip",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "factchip__label",
                                        children: "Investments made"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "factchip__value",
                                        children: P.investmentsMade
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "factchip",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "factchip__label",
                                        children: "Last investment"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "factchip__value",
                                        children: [
                                            P.lastInvestment,
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    color: 'var(--dlg-pos)',
                                                    fontSize: 12
                                                },
                                                children: "\u25CF active"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__row",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        children: "Match criteria \xb7 objective"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "card__hint",
                                        children: "Rule-outs feed the auto-decline gate"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 9
                                },
                                children: criteria.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10,
                                            fontSize: 13.5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    width: 170,
                                                    color: 'var(--dlg-muted)'
                                                },
                                                children: c.label
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    fontWeight: 500
                                                },
                                                children: [
                                                    c.value,
                                                    c.extra ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            color: 'var(--dlg-faint)',
                                                            fontWeight: 400
                                                        },
                                                        children: [
                                                            " ",
                                                            c.extra
                                                        ]
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `chip ${c.ruleOut ? 'chip--red' : 'chip--muted'}`,
                                                style: {
                                                    marginLeft: 'auto'
                                                },
                                                children: c.ruleOut ? "\u2715 rule out" : 'advisory'
                                            })
                                        ]
                                    }, c.label))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__foot",
                                children: [
                                    ruleOutCount,
                                    " of ",
                                    criteria.length,
                                    " criteria are hard rule-outs \u2014 a mismatch declines the deal before any AI spend, with manual override available."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__row",
                                style: {
                                    marginBottom: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        children: "How the AI scores"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "card__hint",
                                        style: {
                                            color: 'var(--dlg-pos)',
                                            fontWeight: 500
                                        },
                                        children: "= 100%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 10
                                },
                                children: weights.map((w, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f158d855965cb4c$export$2e2bcd8739ae039), {
                                        label: w.name,
                                        right: `${w.pct}%`,
                                        pct: w.pct,
                                        color: i < 2 ? 'var(--dlg-blue)' : i < 4 ? 'var(--dlg-blue-mid)' : 'var(--dlg-blue-soft)'
                                    }, w.name))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__foot",
                                children: "Weights drive the triage scorecard on every deal. Set in this module \u2014 Diligentsia backfills."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--split45",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 10
                                },
                                children: "Subjective criteria"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-faint)',
                                    fontWeight: 500
                                },
                                children: "Firm description"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    color: 'var(--dlg-ink-soft)',
                                    margin: '3px 0 10px'
                                },
                                children: P.description
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 12.5,
                                    color: 'var(--dlg-faint)',
                                    fontWeight: 500
                                },
                                children: "Investment criteria"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    color: 'var(--dlg-ink-soft)',
                                    margin: '3px 0 10px'
                                },
                                children: P.investmentCriteria
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $d1867d50eaca9584$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: "Your thesis, as Intelligentsia reads it:"
                                    }),
                                    ' "',
                                    P.thesisReadback,
                                    '" ',
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: 'var(--dlg-bubble-sub)'
                                        },
                                        children: "Used in every deal's thesis-fit check and pitch deck analysis."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__row",
                                style: {
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        children: "Quick responses"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "card__hint",
                                        children: [
                                            quickResponses.length,
                                            " templates \xb7 used in decline emails"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'grid',
                                    gap: 6
                                },
                                children: quickResponses.map((q)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            background: 'var(--dlg-chipfill)',
                                            borderRadius: 999,
                                            padding: '7px 14px',
                                            fontSize: 12.5,
                                            color: 'var(--dlg-ink-soft)',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        },
                                        children: q
                                    }, q))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "grid grid--splitr",
                style: {
                    marginBottom: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "card__label",
                                style: {
                                    marginBottom: 12
                                },
                                children: "Preferred contact for leads"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: 44,
                                            height: 44,
                                            borderRadius: '50%',
                                            background: 'var(--dlg-lavender)',
                                            color: '#26215C',
                                            fontSize: 15,
                                            fontWeight: 500,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        },
                                        children: preferredContact.initials
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 14.5,
                                                    fontWeight: 500
                                                },
                                                children: preferredContact.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 12.5,
                                                    color: 'var(--dlg-coral)',
                                                    fontWeight: 500
                                                },
                                                children: preferredContact.role
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontSize: 12.5,
                                                    color: 'var(--dlg-muted)'
                                                },
                                                children: preferredContact.email
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            marginLeft: 'auto',
                                            textAlign: 'right'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "factchip__label",
                                                children: "Prompt response"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    fontSize: 17,
                                                    fontWeight: 500,
                                                    color: 'var(--dlg-pos)'
                                                },
                                                children: [
                                                    preferredContact.promptResponse,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "card",
                        style: {
                            border: '1.5px dashed var(--dlg-lavender)',
                            boxShadow: 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card__row",
                                style: {
                                    marginBottom: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "card__label",
                                        children: "Extended criteria"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "chip chip--blue",
                                        style: {
                                            marginLeft: 'auto'
                                        },
                                        children: "New fields \xb7 Diligentsia settings backfill"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: 9,
                                    fontSize: 13
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    color: 'var(--dlg-muted)'
                                                },
                                                children: "Ownership target"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontWeight: 500,
                                                    marginTop: 2
                                                },
                                                children: extended.ownershipTarget
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    color: 'var(--dlg-muted)'
                                                },
                                                children: "Follow-on strategy"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontWeight: 500,
                                                    marginTop: 2
                                                },
                                                children: extended.followOn
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    color: 'var(--dlg-muted)'
                                                },
                                                children: "Business model preferences"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontWeight: 500,
                                                    marginTop: 2
                                                },
                                                children: extended.businessModels
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    color: 'var(--dlg-muted)'
                                                },
                                                children: "Keywords & themes"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                style: {
                                                    fontWeight: 500,
                                                    marginTop: 2
                                                },
                                                children: extended.keywords
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/* Idea Sandbox — ported from the prototype's Screens.sandbox(). Standalone tool:
   paste a paragraph, get an instant read vs the thesis (idea-strength score +
   traffic-lit reads) from POST /deal/sandbox/analyse, then invite the founder to
   apply or save it. The analyse call persists a DealSandboxIdea for the firm. */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



const $777b786865917827$var$RING_C = 2 * Math.PI * 40;
const $777b786865917827$var$Dot = ({ level: level })=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "finding__dot",
        style: {
            background: (0, $b398648f62c2864e$export$825ea1f703a1aac9)(level)
        }
    });
/* Starter prompt so the textarea isn't empty on first load (placeholder copy only). */ const $777b786865917827$var$SAMPLE_IDEA = "We\u2019re building a marketplace that lets independent pharmacies pool their purchasing to get hospital-grade pricing from wholesalers. 4,000 UK pharmacies are overpaying by 12\u201318% today. We take 1% of transaction volume.";
function $777b786865917827$var$ScoreRing({ score: score }) {
    const [offset, setOffset] = (0, $acw62.useState)($777b786865917827$var$RING_C);
    (0, $acw62.useEffect)(()=>{
        const t = setTimeout(()=>setOffset($777b786865917827$var$RING_C * (1 - (score || 0) / 100)), 80);
        return ()=>clearTimeout(t);
    }, [
        score
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "ring",
        style: {
            width: 96,
            height: 96
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "96",
                height: "96",
                viewBox: "0 0 96 96",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        className: "ring__track",
                        cx: "48",
                        cy: "48",
                        r: "40"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                        className: "ring__val",
                        cx: "48",
                        cy: "48",
                        r: "40",
                        strokeDasharray: $777b786865917827$var$RING_C,
                        strokeDashoffset: offset
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "ring__num",
                style: {
                    fontSize: 26
                },
                children: [
                    score,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                        children: "/ 100"
                    })
                ]
            })
        ]
    });
}
function $777b786865917827$export$2e2bcd8739ae039() {
    const showToast = (0, $70637bf498997249$export$a407b657d3044108)();
    const [idea, setIdea] = (0, $acw62.useState)($777b786865917827$var$SAMPLE_IDEA);
    const [result, setResult] = (0, $acw62.useState)(null); // { score, reads }
    const [running, setRunning] = (0, $acw62.useState)(false);
    const run = async ()=>{
        if (running || !idea.trim()) return;
        setRunning(true);
        showToast("Intelligentsia is reading the idea\u2026");
        const res = await (0, $2f90eebb96c7748d$export$b8d30bf21159d3b1)(idea.trim());
        setRunning(false);
        if (!(0, $2f90eebb96c7748d$export$dcb8b3f0e2de7e49)(res)) return;
        setResult({
            score: res.body.score,
            reads: res.body.reads || []
        });
    };
    const invite = ()=>{
        showToast("Funding-form invite sent \u2014 a full application starts the real pipeline");
        setTimeout(()=>showToast('Founder account will be auto-created on Diligentsia', true), 900);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
        className: "page screen",
        style: {
            maxWidth: 1020
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "kicker",
                children: "Idea sandbox \xb7 standalone tool"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "page__title",
                style: {
                    marginBottom: 2
                },
                children: "No deck yet? Test the idea."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "page__sub",
                style: {
                    marginBottom: 18
                },
                children: "Paste a paragraph \u2014 office hours, accelerator applications, a founder's cold email \u2014 and get an instant read against your thesis."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    marginBottom: 12
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 13,
                            color: 'var(--dlg-faint)',
                            marginBottom: 8
                        },
                        children: "The idea, in the founder's words"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        className: "rationale-box",
                        style: {
                            minHeight: 96,
                            fontSize: 14
                        },
                        value: idea,
                        onChange: (e)=>setIdea(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "pill pill--primary",
                        style: {
                            marginTop: 12
                        },
                        onClick: run,
                        disabled: running,
                        children: running ? "Analysing\u2026" : result ? 'Re-analyse idea' : 'Analyse idea'
                    })
                ]
            }),
            result && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grid",
                        style: {
                            gridTemplateColumns: '220px 1fr'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    padding: 22
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($777b786865917827$var$ScoreRing, {
                                        score: result.score
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            fontSize: 12.5,
                                            color: 'var(--dlg-muted)',
                                            textAlign: 'center',
                                            marginTop: 10
                                        },
                                        children: "Idea strength vs your thesis"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "chip chip--blue",
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: "\u2726 First read by Intelligentsia"
                                    }),
                                    result.reads.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "finding",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($777b786865917827$var$Dot, {
                                                    level: r.level
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: r.text
                                                })
                                            ]
                                        }, i))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--primary",
                                onClick: invite,
                                children: "Invite founder to apply \u2192"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "pill pill--outline",
                                onClick: ()=>showToast("Saved to sandbox \u2014 revisit any time"),
                                children: "Save to sandbox"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


'use strict';
class $0fdd2214fcf12208$var$DealErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        console.error('[DealManagement] render error:', error, info);
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "dlg-dm",
            style: {
                padding: '24px 28px'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "card",
                style: {
                    maxWidth: 640
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "card__label",
                        style: {
                            marginBottom: 8,
                            color: 'var(--dlg-red-ink)'
                        },
                        children: "Deal Management failed to load"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: 13.5,
                            color: 'var(--dlg-ink-soft)',
                            whiteSpace: 'pre-wrap'
                        },
                        children: String(this.state.error && (this.state.error.stack || this.state.error.message || this.state.error))
                    })
                ]
            })
        });
        return this.props.children;
    }
}
// The isolated module app — its own MemoryRouter lives here, in a separate React root.
function $0fdd2214fcf12208$var$DealApp() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0fdd2214fcf12208$var$DealErrorBoundary, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$ae46f04cfaffe093), {
            initialEntries: [
                '/deal-management/pipeline'
            ],
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "dlg-dm",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70637bf498997249$export$f5d03d415824e0e), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3c0860f4d138445e$export$4fd56d483b8624a4), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed10917cbad1b4e$export$2e2bcd8739ae039), {
                                embedded: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                            to: "/deal-management/pipeline",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management/pipeline",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22fc30704fa4b906$export$2e2bcd8739ae039), {
                                            view: "board"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management/pipeline/list",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22fc30704fa4b906$export$2e2bcd8739ae039), {
                                            view: "list"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management/dashboard",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa8e64c710ef587f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management/profile",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c00354e0b41ef16b$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management/sandbox",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $777b786865917827$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management/deal/:id/:step",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34688a3b5a907b47$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "/deal-management/deal/:id/:step/:tab",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34688a3b5a907b47$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                            to: "/deal-management/pipeline",
                                            replace: true
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
function $0fdd2214fcf12208$export$2e2bcd8739ae039() {
    const hostRef = (0, $acw62.useRef)(null);
    const rootRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const host = hostRef.current;
        if (!host) return;
        const root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(host);
        rootRef.current = root;
        root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($0fdd2214fcf12208$var$DealApp, {}));
        // Defer unmount out of the parent's commit phase to avoid the React
        // "synchronously unmount a root while rendering" warning.
        return ()=>{
            rootRef.current = null;
            setTimeout(()=>root.unmount(), 0);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: hostRef,
        className: "dlg-embed-host"
    });
}




var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");







function $c05184d1bd921939$export$2e2bcd8739ae039({ profileClass: profileClass, advisors: advisors, getAuditLogs: getAuditLogs, setRefresh: setRefresh, sectionsWithChecklist: sectionsWithChecklist, company: company, loading: loading }) {
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [allCompanies, setAllCompanies] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (companies && companies.length > 0) {
            const _companies = companies.reduce((acc, company)=>{
                const seen = new Set(acc.map((c)=>c._id));
                // Clone parent company and delete childrenCompanies
                const companyCopy = {
                    ...company
                };
                delete companyCopy.childrenCompanies;
                // if (company.progress !== 'inActive' && !seen.has(company._id)) {
                // Include all companies (including Free/inactive) in permissions table
                if (!seen.has(company._id)) {
                    acc.push(companyCopy);
                    seen.add(company._id);
                }
                if (Array.isArray(company.childrenCompanies)) company.childrenCompanies.forEach((child)=>{
                    const childCopy = {
                        ...child
                    };
                    delete childCopy.childrenCompanies;
                    // if (child.progress !== 'inActive' && !seen.has(child._id)) {
                    // Include all children companies (including Free/inactive) in permissions table
                    if (!seen.has(child._id)) {
                        acc.push(childCopy);
                        seen.add(child._id);
                    }
                });
                return acc;
            }, []);
            setAllCompanies(_companies);
        }
    }, [
        companies
    ]);
    let [sections, setSections] = (0, $acw62.useState)([]);
    let [groupedSections, setGroupedSections] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const extraModules = company['extraModules'] && company['extraModules'].length ? company['extraModules'].map((mod)=>({
                type: mod.type,
                _id: mod._id,
                sectionNo: mod.id,
                // or mod.moduleKey if you prefer that
                sectionName: mod.moduleName
            })) : [];
        let generateChecklistModuleRawData = [];
        allCompanies.forEach((company)=>{
            if (company.generateChecklistModules) generateChecklistModuleRawData.push(...company.generateChecklistModules);
        });
        const generateChecklistModules = generateChecklistModuleRawData && generateChecklistModuleRawData.length ? generateChecklistModuleRawData.map((mod)=>{
            return {
                checklistModule: true,
                type: mod.type,
                _id: mod._id,
                sectionNo: mod.moduleKey,
                sectionName: mod.moduleName
            };
        }) : [];
        // Combine all sections and filter out duplicates by sectionNo
        const allSections = [
            ...JSON.parse(JSON.stringify(sectionsWithChecklist)),
            ...extraModules,
            ...generateChecklistModules
        ];
        const seenSectionNos = new Set();
        let sectionObj = allSections.filter((section)=>{
            if (seenSectionNos.has(section.sectionNo)) return false; // Skip duplicate
            seenSectionNos.add(section.sectionNo);
            return true;
        });
        let userType = user["role"] === "Advisor" ? "advisors" : "investors";
        for (let company of allCompanies){
            if (company[userType]) for (let advisorId of Object.keys(company[userType])){
                let advisorSettings = company[userType][advisorId];
                let advisor = advisors.find(({ _id: _id })=>_id == advisorId);
                // Skip if no modules or advisor found
                if (!advisorSettings["modules"] || !advisor) continue;
                for (let [key, value] of Object.entries(advisorSettings["modules"])){
                    if (!value) continue;
                    let sectionIndex = sectionObj.findIndex((section)=>{
                        if (section.companyId) return section.sectionNo === key && company["_id"] === section.companyId;
                        return section.sectionNo === key;
                    });
                    if (sectionObj && sectionIndex >= 0) {
                        // Ensure the permission key exists and structure it correctly
                        if (!sectionObj?.[sectionIndex]?.["permission"]) sectionObj[sectionIndex]["permission"] = {}; // Initialize if not exists
                        if (!sectionObj[sectionIndex]["permission"][company["_id"]]) sectionObj[sectionIndex]["permission"][company["_id"]] = {}; // Initialize company permission if not exists
                        // Now, set the permission data for the specific advisor
                        sectionObj[sectionIndex]["permission"][company["_id"]][advisorId] = advisor;
                    }
                }
            }
        }
        setSections(sectionObj);
    }, [
        allCompanies,
        sectionsWithChecklist
    ]);
    (0, $acw62.useEffect)(()=>{
        if (sections && sections.length) {
            const _groupedSections = sections.reduce((acc, section)=>{
                let type = section.sectionNo.includes("UD0") ? "Custom Section" : section.type && /extensions pack|extentions pack/i.test(section.type) ? "Expension Pack" : section.type && section.type.includes("-") ? section.type.split("-")[0].trim() : section.type;
                type = type?.trim();
                const allowedTypes = [
                    "Existing Sections",
                    "Expension Pack",
                    "Additional Sections",
                    "Custom Section"
                ];
                if (!allowedTypes.includes(type)) {
                    if (section?.checklistModule) type = 'checklist';
                    else type = "extraModules";
                }
                if (!acc[type]) acc[type] = [];
                acc[type].push(section);
                return acc;
            }, {});
            setGroupedSections(_groupedSections);
        }
    }, [
        sections
    ]);
    const handlePermissions = async (e, advisor, sectionNo, company)=>{
        const status = e["target"]["checked"];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/advisorPermissions/${company["_id"]}`, {
            advisor: advisor,
            company: company,
            advisorId: advisor["_id"],
            sectionNo: sectionNo,
            status: status,
            firmId: user["companyId"]["_id"]
        });
        let userType = advisor["role"] == "Advisor" ? "advisors" : "investors";
        if (res && res["code"] == 200) {
            let sectionObj = JSON.parse(JSON.stringify(sections));
            let sectionIndex = sections.findIndex((section)=>section["sectionNo"] == sectionNo);
            const companyId = company["_id"];
            const advisorId = advisor["_id"];
            if (status) {
                if (!sectionObj[sectionIndex]["permission"] || !sectionObj[sectionIndex]["permission"][companyId]) sectionObj[sectionIndex] = {
                    ...sectionObj[sectionIndex],
                    "permission": {
                        [companyId]: null
                    }
                };
                sectionObj[sectionIndex]["permission"][companyId] = {
                    ...sectionObj[sectionIndex]["permission"][companyId],
                    [advisorId]: {
                        ...advisor,
                        permissions: {
                            ...company[userType][advisorId] && company[userType][advisorId]['modules'] && company[userType][advisorId]['modules'],
                            [sectionNo]: status
                        }
                    }
                };
            } else delete sectionObj[sectionIndex]["permission"]?.[company["_id"]]?.[advisor["_id"]];
            const updatedData = allCompanies.map((item)=>{
                if (item._id === companyId) return {
                    ...item,
                    [userType]: {
                        ...item[userType],
                        [advisorId]: {
                            ...item[userType][advisorId],
                            modules: {
                                ...item?.[userType]?.[advisorId]?.modules,
                                [sectionNo]: status
                            }
                        }
                    }
                };
                return item; // Return other items unchanged
            });
            dispatch((0, $b9bcf9787e5ad456$export$52d586c008658f4c)(updatedData));
            setSections(sectionObj);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            setRefresh((r)=>!r);
        }
    };
    // on advisor multi allocation
    const handleMultiPermissions = async (e, advisor, sectionNo, company, sections)=>{
        const generated = company?.['generateChecklistModules']?.map((mod)=>mod.moduleKey) || [];
        const _checked = e["target"]["checked"];
        const result = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/advisorMultiPermissions/${company["_id"]}`, {
            advisor: advisor,
            company: company,
            advisorId: advisor["_id"],
            sectionNo: [
                ...sectionNo,
                ...generated || []
            ],
            status: _checked,
            firmId: user["companyId"]["_id"]
        });
        if (result && result["code"] == 200) {
            let sectionObj = await JSON.parse(JSON.stringify(sections));
            sections.map((_, sectionIndex)=>{
                const advisorId = advisor["_id"];
                if (_checked === true) {
                    if (sectionObj[sectionIndex]["permission"]?.[company["_id"]]) {
                        if (!sectionObj[sectionIndex]["permission"][company["_id"]][advisor["_id"]]) sectionObj[sectionIndex]["permission"][company["_id"]] = {
                            ...sectionObj[sectionIndex]["permission"]?.[company["_id"]],
                            [advisor["_id"]]: {
                                ...advisor,
                                permissions: {
                                    ...company['advisors'][advisorId]['modules'],
                                    [sectionNo]: _checked
                                }
                            }
                        };
                    } else sectionObj[sectionIndex] = {
                        ...sectionObj[sectionIndex],
                        permission: {
                            [company["_id"]]: {
                                [advisor["_id"]]: advisor
                            }
                        }
                    };
                } else delete sectionObj[sectionIndex]['permission'][company["_id"]][advisor["_id"]];
            });
            setSections(sectionObj);
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(result["message"]);
        setRefresh((r)=>!r);
    };
    function arraysMatch(data, allList) {
        const allPermissionsExist = data.every((permission)=>allList.includes(permission));
        return allPermissionsExist;
    }
    const checkAdvisorHasAllAllocations = ({ advisor: advisor, company: company })=>{
        if (advisor && company?.['advisors']?.[`${advisor['_id']}`]?.['modules']) {
            const allAllocationCode = sectionsWithChecklist.map((item)=>item.sectionNo);
            const advisorPermission = [];
            Object.entries(company['advisors'][`${advisor['_id']}`]['modules']).map((item)=>item[1] === true && advisorPermission.push(item[0]));
            const result = arraysMatch(allAllocationCode, advisorPermission);
            return result;
        }
        return false;
    };
    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
    const getSectionTitle = (type)=>{
        if (type === "existing sections") return "Core Modules";
        else if (type === "expension pack") return "Expansion Pack";
        else if (type === "extentions pack" || type === "custom section" || type === "additional sections") return capitalizeFirstLetter(type);
        else if (type === "checklist") return "Investor Checklist Modules";
        else return "Extra Modules";
    };
    if (loading && !allCompanies.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem pr",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "table-permission",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                id: "table",
                className: "table-userPermissions table-clientPermissions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        className: "ps t0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "index-table"
                                }),
                                [
                                    1,
                                    2,
                                    3
                                ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "user-area",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mr1rem wfull",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 110,
                                                        height: 22
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 60,
                                                        height: 16
                                                    })
                                                ]
                                            })
                                        })
                                    }, `skel-comp-${i}`))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: [
                            [
                                'Core Modules',
                                5
                            ],
                            [
                                'Expansion Pack',
                                3
                            ]
                        ].map(([label, count], gIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: 4,
                                            style: {
                                                paddingTop: '40px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                variant: "text",
                                                width: 150,
                                                height: 28,
                                                sx: {
                                                    borderRadius: '4px'
                                                }
                                            })
                                        })
                                    }),
                                    Array.from({
                                        length: count
                                    }).map((_, sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        background: '#fafbfe',
                                                        padding: '8px 12px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: '6px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                variant: "rectangular",
                                                                width: 50,
                                                                height: 14,
                                                                sx: {
                                                                    borderRadius: '3px'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                variant: "rectangular",
                                                                width: 90 + sIdx * 20,
                                                                height: 14,
                                                                sx: {
                                                                    borderRadius: '3px'
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                [
                                                    1,
                                                    2,
                                                    3
                                                ].map((cIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "w100 df jcsb aic bg1 p0-5rem br30px",
                                                            style: {
                                                                border: '1px solid #DBDFEE'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                    variant: "circular",
                                                                    width: 32,
                                                                    height: 32
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                    variant: "circular",
                                                                    width: 20,
                                                                    height: 20
                                                                })
                                                            ]
                                                        })
                                                    }, `skel-sc-${cIdx}`))
                                            ]
                                        }, `skel-s-${gIdx}-${sIdx}`))
                                ]
                            }, `skel-g-${gIdx}`))
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem pr",
        children: allCompanies && allCompanies.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    onClick: ()=>getAuditLogs(`/user/advisorPermissions`, user["companyId"]["_id"], "permissions"),
                    className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard pa t0 r0 audit-log-btn",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "36",
                                height: "36",
                                viewBox: "0 0 36 36",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                                    fill: "#4A67FF"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c15",
                            children: "Audit Log"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "table-permission",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        id: "table",
                        className: "table-userPermissions table-clientPermissions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                className: "ps t0",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table"
                                        }),
                                        allCompanies && allCompanies.map((company, cIndex)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "user-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "mr1rem wfull pr",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "di fs1rem c0",
                                                                children: company["cName"]
                                                            }),
                                                            company["subscription"] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "c7 di ml0-5rem",
                                                                children: [
                                                                    "(",
                                                                    company["subscription"]?.toUpperCase(),
                                                                    ")"
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c8 di ml0-5rem",
                                                                    children: "(INACTIVE)"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    multiple: true,
                                                                    className: "select-advisor w10 pa",
                                                                    id: "demo-multiple-name-1",
                                                                    sx: {
                                                                        "& .MuiSvgIcon-root": {
                                                                            color: "#4A67FF"
                                                                        }
                                                                    },
                                                                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                                    value: [],
                                                                    MenuProps: {
                                                                        anchorOrigin: {
                                                                            vertical: "bottom",
                                                                            horizontal: "right"
                                                                        },
                                                                        transformOrigin: {
                                                                            vertical: "top",
                                                                            horizontal: "right"
                                                                        }
                                                                    },
                                                                    children: advisors.map((advisor, idx)=>{
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: advisor,
                                                                            className: "select-advisor-list ttc",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: `${!(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) && "disable-advisor-checkbox"}`,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                        disabled: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor),
                                                                                        checked: checkAdvisorHasAllAllocations({
                                                                                            advisors: advisors,
                                                                                            advisor: advisor,
                                                                                            company: company
                                                                                        }),
                                                                                        onClick: (e)=>handleMultiPermissions(e, advisor, sections.filter((sec)=>!sec.checklistModule).map((item)=>item.sectionNo), company, sections)
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                    style: {
                                                                                        color: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) && "lightgray"
                                                                                    },
                                                                                    primary: advisor["firstName"] + " " + advisor["lastName"] + " - " + (advisor["title"] ? advisor["title"] : advisor["designation"] ? advisor["designation"] : advisor["job"])
                                                                                })
                                                                            ]
                                                                        }, `${cIndex}company-${cIndex}-${idx}-all_allocation`);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, `${cIndex}company-${cIndex}`);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: groupedSections && Object.entries(groupedSections).map(([type, typeSections], inde)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        paddingTop: "40px"
                                                    },
                                                    colSpan: companies.length + 1,
                                                    className: "type-heading",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        style: {
                                                            borderTop: `${inde > 0 ? "1px solid rgb(219, 223, 238)" : "transparent"}`,
                                                            paddingTop: "12px"
                                                        },
                                                        className: "c15",
                                                        children: getSectionTitle(type.toLowerCase())
                                                    })
                                                })
                                            }, `type-heading-${type}`),
                                            typeSections.map((section, idx2)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                            className: "c15 bg0",
                                                            style: {
                                                                background: '#fafbfe'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "fw600 bg0",
                                                                    style: {
                                                                        marginRight: "4px"
                                                                    },
                                                                    children: section["sectionNo"]
                                                                }),
                                                                section['sectionName'] === "Investor Lead Introduction" ? "InvestorMatch" : section['sectionName']
                                                            ]
                                                        }, `${section["sectionName"]}${idx2}`),
                                                        allCompanies && allCompanies.map((company, idxs)=>{
                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "w100 df jcsb bg1 p0-5rem br30px",
                                                                    style: {
                                                                        border: '1px solid #DBDFEE'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "df",
                                                                            children: section.sectionNo.includes("UD0") && section.type === "Additional Sections" && section.companyId !== company['_id'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                children: section?.["permission"]?.[company["_id"]] && Object.values(section["permission"][company["_id"]]).map((advisor, keyIndex)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                        children: advisor?.["profile"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                            src: advisor["profile"],
                                                                                            className: `w3rem h3rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                                                            "data-tooltip": advisor?.["firstName"] ? advisor["firstName"] + " " + advisor["lastName"] : "Register to show your name here"
                                                                                        }, `${keyIndex}-advisor-${keyIndex}`) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            "data-tooltip": advisor["firstName"] ? advisor["firstName"] + " " + advisor["lastName"] : "Register to show your name here",
                                                                                            className: `w3rem h3rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                                                            children: advisor["firstName"] ? advisor["firstName"][0] + advisor["lastName"][0] : "?"
                                                                                        }, `${keyIndex}-advisor-${keyIndex + 1100000}`)
                                                                                    });
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "pr",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                                multiple: true,
                                                                                disabled: section.sectionNo.includes("UD0") && section.type === "Additional Sections" && section.companyId !== company['_id'] || getSectionTitle(type.toLowerCase()) === "Investor Checklist Modules" && !section?.["permission"]?.[company["_id"]],
                                                                                className: "select-advisor w10",
                                                                                id: "demo-multiple-name",
                                                                                sx: {
                                                                                    "& .MuiSvgIcon-root": {
                                                                                        color: "#4A67FF"
                                                                                    }
                                                                                },
                                                                                IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                                                value: [],
                                                                                MenuProps: {
                                                                                    PaperProps: {
                                                                                        style: {
                                                                                            maxHeight: 300,
                                                                                            width: 'auto',
                                                                                            minWidth: '200px'
                                                                                        }
                                                                                    },
                                                                                    anchorOrigin: {
                                                                                        vertical: 'bottom',
                                                                                        horizontal: 'left'
                                                                                    },
                                                                                    transformOrigin: {
                                                                                        vertical: 'top',
                                                                                        horizontal: 'left'
                                                                                    },
                                                                                    getContentAnchorEl: null,
                                                                                    // Important for Safari
                                                                                    keepMounted: true,
                                                                                    // Helps with positioning
                                                                                    marginThreshold: 10,
                                                                                    style: {
                                                                                        WebkitTransform: 'none',
                                                                                        // Safari specific
                                                                                        position: 'fixed' // Helps with Safari positioning
                                                                                    }
                                                                                },
                                                                                children: advisors.map((advisor, idxsd)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                                        value: advisor._id,
                                                                                        className: "select-advisor-list ttc",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                                checked: !!section?.["permission"]?.[company["_id"]]?.[advisor["_id"]],
                                                                                                onChange: (e)=>handlePermissions(e, advisor, section["sectionNo"], company)
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                                primary: `${advisor.firstName} ${advisor.lastName} - ${advisor.title || advisor.designation || advisor.job}`
                                                                                            })
                                                                                        ]
                                                                                    }, `${section["sectionName"]}${idx2}--${idxsd}-drop-${idxsd}`);
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }, `${idxs}-check-${idxs}-${section["sectionName"]}${idx2}`);
                                                        })
                                                    ]
                                                });
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df jcc c15 fs1-75rem fw500 lh2 mt2rem",
            children: "No clients added for permissions"
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");





function $3d7eaf16ec7726c0$export$2e2bcd8739ae039({ profileClass: profileClass, advisors: advisors, setRefresh: setRefresh, company: company }) {
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [allCompanies, setAllCompanies] = (0, $acw62.useState)([]);
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    // Flat list of all TempSections, each enriched with .permission map (mirrors PermissionsClient)
    const [sections, setSections] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    // ─── Flatten companies (parent + children) — identical to PermissionsClient ───
    (0, $acw62.useEffect)(()=>{
        if (!companies?.length) return;
        const seen = new Set();
        const flat = [];
        for (const comp of companies){
            const copy = {
                ...comp
            };
            delete copy.childrenCompanies;
            if (!seen.has(comp._id)) {
                flat.push(copy);
                seen.add(comp._id);
            }
            if (Array.isArray(comp.childrenCompanies)) for (const child of comp.childrenCompanies){
                const childCopy = {
                    ...child
                };
                delete childCopy.childrenCompanies;
                if (!seen.has(child._id)) {
                    flat.push(childCopy);
                    seen.add(child._id);
                }
            }
        }
        setAllCompanies(flat);
    }, [
        companies
    ]);
    // ─── Fetch all TempModules + Checklists with their sections ──────────────────
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/all-modules-section', 'not-showMessage').then((res)=>{
            if (res?.code === 200) {
                const body = res.body;
                const combined = Array.isArray(body) ? body : [
                    ...(body?.modules || []).filter((m)=>m.sections?.length > 0),
                    ...(body?.checklists || []).filter((m)=>m.sections?.length > 0).map((m)=>({
                            ...m,
                            isChecklist: true
                        }))
                ];
                setTempModules(combined);
            }
        }).finally(()=>setIsLoading(false));
    }, []);
    // ─── Build sections with permission data (mirrors PermissionsClient logic) ────
    // Each section gets: { sectionNo, sectionName, moduleId, moduleName, moduleKey,
    //   permission: { [companyId]: { [advisorId]: advisorDoc } } }
    (0, $acw62.useEffect)(()=>{
        if (!tempModules.length || !allCompanies.length) return;
        // Flatten all TempSections annotated with their parent module info
        const flatSections = tempModules.flatMap((m)=>m.sections.map((s)=>({
                    ...s,
                    moduleId: m._id,
                    moduleName: m.moduleName,
                    moduleKey: m.moduleKey
                })));
        const sectionObj = JSON.parse(JSON.stringify(flatSections));
        const userType = user.role === 'Advisor' ? 'advisors' : 'investors';
        for (const comp of allCompanies){
            if (!comp[userType]) continue;
            for (const advisorId of Object.keys(comp[userType])){
                const advisorSettings = comp[userType][advisorId];
                const advisor = advisors.find(({ _id: _id })=>_id == advisorId);
                if (!advisorSettings?.modules || !advisor) continue;
                for (const [key, value] of Object.entries(advisorSettings.modules)){
                    if (!value) continue;
                    const idx = sectionObj.findIndex((s)=>s.sectionNo === key);
                    if (idx >= 0) {
                        if (!sectionObj[idx].permission) sectionObj[idx].permission = {};
                        if (!sectionObj[idx].permission[comp._id]) sectionObj[idx].permission[comp._id] = {};
                        sectionObj[idx].permission[comp._id][advisorId] = advisor;
                    }
                }
            }
        }
        setSections(sectionObj);
    }, [
        allCompanies,
        tempModules
    ]);
    const toggleAccordion = (moduleId)=>{
        setOpenAccordions((prev)=>({
                ...prev,
                [moduleId]: !prev[moduleId]
            }));
    };
    // ─── Single-section permission toggle (mirrors PermissionsClient.handlePermissions) ──
    const handlePermissions = async (e, advisor, sectionNo, comp)=>{
        const status = e.target.checked;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/advisorPermissions/${comp._id}`, {
            advisor: advisor,
            company: comp,
            advisorId: advisor._id,
            sectionNo: sectionNo,
            status: status,
            firmId: user.companyId._id
        });
        const userType = advisor.role === 'Advisor' ? 'advisors' : 'investors';
        if (res?.code === 200) {
            const sectionObj = JSON.parse(JSON.stringify(sections));
            const sectionIndex = sectionObj.findIndex((s)=>s.sectionNo === sectionNo);
            const companyId = comp._id;
            const advisorId = advisor._id;
            if (status) {
                if (!sectionObj[sectionIndex].permission || !sectionObj[sectionIndex].permission[companyId]) sectionObj[sectionIndex] = {
                    ...sectionObj[sectionIndex],
                    permission: {
                        [companyId]: null
                    }
                };
                sectionObj[sectionIndex].permission[companyId] = {
                    ...sectionObj[sectionIndex].permission[companyId],
                    [advisorId]: {
                        ...advisor,
                        permissions: {
                            ...comp[userType]?.[advisorId]?.modules,
                            [sectionNo]: status
                        }
                    }
                };
            } else delete sectionObj[sectionIndex].permission?.[companyId]?.[advisorId];
            const updatedData = allCompanies.map((item)=>{
                if (item._id === companyId) return {
                    ...item,
                    [userType]: {
                        ...item[userType],
                        [advisorId]: {
                            ...item[userType]?.[advisorId],
                            modules: {
                                ...item[userType]?.[advisorId]?.modules,
                                [sectionNo]: status
                            }
                        }
                    }
                };
                return item;
            });
            dispatch((0, $b9bcf9787e5ad456$export$52d586c008658f4c)(updatedData));
            setSections(sectionObj);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
            setRefresh((r)=>!r);
        }
    };
    // ─── Bulk-toggle all temp sections for an advisor on a company ────────────────
    const handleMultiPermissions = async (e, advisor, sectionNos, comp)=>{
        const _checked = e.target.checked;
        const result = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/advisorMultiPermissions/${comp._id}`, {
            advisor: advisor,
            company: comp,
            advisorId: advisor._id,
            sectionNo: sectionNos,
            status: _checked,
            firmId: user.companyId._id
        });
        if (result?.code === 200) {
            const sectionObj = JSON.parse(JSON.stringify(sections));
            sectionObj.forEach((section, sectionIndex)=>{
                const advisorId = advisor._id;
                if (_checked) {
                    if (sectionObj[sectionIndex].permission?.[comp._id]) {
                        if (!sectionObj[sectionIndex].permission[comp._id][advisorId]) sectionObj[sectionIndex].permission[comp._id] = {
                            ...sectionObj[sectionIndex].permission[comp._id],
                            [advisorId]: advisor
                        };
                    } else sectionObj[sectionIndex] = {
                        ...sectionObj[sectionIndex],
                        permission: {
                            ...sectionObj[sectionIndex].permission,
                            [comp._id]: {
                                [advisorId]: advisor
                            }
                        }
                    };
                } else delete sectionObj[sectionIndex].permission?.[comp._id]?.[advisorId];
            });
            setSections(sectionObj);
            // Keep allCompanies in Redux in sync so that subsequent single-section
            // permission changes don't overwrite this bulk update with stale data.
            const userType = advisor.role === 'Advisor' ? 'advisors' : 'investors';
            const currentModules = allCompanies.find((c)=>c._id === comp._id)?.[userType]?.[advisor._id]?.modules || {};
            const newModules = {
                ...currentModules
            };
            sectionNos.forEach((sno)=>{
                newModules[sno] = _checked;
            });
            const updatedCompanies = allCompanies.map((item)=>{
                if (item._id === comp._id) return {
                    ...item,
                    [userType]: {
                        ...item[userType],
                        [advisor._id]: {
                            ...item[userType]?.[advisor._id],
                            modules: newModules
                        }
                    }
                };
                return item;
            });
            dispatch((0, $b9bcf9787e5ad456$export$52d586c008658f4c)(updatedCompanies));
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(result.message);
        setRefresh((r)=>!r);
    };
    // Returns true if an advisor has all temp sections granted for a given company
    const checkAdvisorHasAllAllocations = ({ advisor: advisor, company: comp })=>{
        const userType = user.role === 'Advisor' ? 'advisors' : 'investors';
        if (advisor && comp?.[userType]?.[advisor._id]?.modules) {
            const allTempSectionNos = sections.map((s)=>s.sectionNo);
            if (!allTempSectionNos.length) return false;
            const advisorPermissions = Object.entries(comp[userType][advisor._id].modules).filter(([, val])=>val === true).map(([key])=>key);
            return allTempSectionNos.every((no)=>advisorPermissions.includes(no));
        }
        return false;
    };
    // ─── Empty / loading states ───────────────────────────────────────────────────
    if (!allCompanies.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc c15 fs1-75rem fw500 lh2 mt2rem",
        children: "No clients added for permissions"
    });
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem pr",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "table-permission",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                id: "table-temp-permissions",
                className: "table-userPermissions table-clientPermissions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        className: "ps t0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "index-table"
                                }),
                                allCompanies.map((_, cIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "user-area",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mr1rem wfull",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 110,
                                                        height: 22
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 58,
                                                        height: 16
                                                    })
                                                ]
                                            })
                                        })
                                    }, `skel-comp-${cIndex}`))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: [
                            1,
                            2,
                            3
                        ].map((mIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            background: '#f8f9fa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '10px 12px',
                                                    paddingTop: mIdx > 1 ? '20px' : '10px',
                                                    borderTop: mIdx > 1 ? '1px solid #DBDFEE' : 'none'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    style: {
                                                        gap: '8px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                            variant: "circular",
                                                            width: 22,
                                                            height: 22
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                            variant: "rectangular",
                                                            width: 120 + mIdx * 25,
                                                            height: 18,
                                                            sx: {
                                                                borderRadius: '4px'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                            variant: "rectangular",
                                                            width: 48,
                                                            height: 18,
                                                            sx: {
                                                                borderRadius: '4px'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                            variant: "rectangular",
                                                            width: 72,
                                                            height: 16,
                                                            sx: {
                                                                borderRadius: '4px'
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            allCompanies.map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        background: '#f8f9fa',
                                                        borderTop: mIdx > 1 ? '1px solid #DBDFEE' : 'none'
                                                    }
                                                }, i))
                                        ]
                                    }),
                                    mIdx === 1 && [
                                        1,
                                        2,
                                        3
                                    ].map((sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        background: '#fafbfe',
                                                        padding: '8px 12px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: '6px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                variant: "rectangular",
                                                                width: 58,
                                                                height: 14,
                                                                sx: {
                                                                    borderRadius: '3px'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                variant: "rectangular",
                                                                width: 90 + sIdx * 25,
                                                                height: 14,
                                                                sx: {
                                                                    borderRadius: '3px'
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                allCompanies.map((_, cIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "cp",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "w100 df jcsb aic bg1 p0-5rem br30px",
                                                            style: {
                                                                border: '1px solid #DBDFEE'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                    variant: "circular",
                                                                    width: 32,
                                                                    height: 32
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                    variant: "circular",
                                                                    width: 20,
                                                                    height: 20
                                                                })
                                                            ]
                                                        })
                                                    }, `skel-sc-${cIdx}`))
                                            ]
                                        }, `skel-s-${sIdx}`))
                                ]
                            }, `skel-m-${mIdx}`))
                    })
                ]
            })
        })
    });
    if (!tempModules.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc c15 fs1-25rem fw500 lh2 mt2rem",
        children: "No modules available"
    });
    // Group the flat sections list back into per-module buckets for accordion rendering,
    // preserving the order returned by the API
    const sectionsByModule = tempModules.map((module)=>({
            module: module,
            moduleSections: sections.filter((s)=>String(s.moduleId) === String(module._id))
        })).filter(({ moduleSections: moduleSections })=>moduleSections.length > 0);
    const moduleItems = sectionsByModule.filter(({ module: module })=>!module.isChecklist);
    const checklistItems = sectionsByModule.filter(({ module: module })=>module.isChecklist);
    const allTempSectionNos = sections.map((s)=>s.sectionNo);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem pr",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "table-permission",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                id: "table-temp-permissions",
                className: "table-userPermissions table-clientPermissions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        className: "ps t0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "index-table"
                                }),
                                allCompanies.map((comp, cIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "user-area",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mr1rem wfull pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "di fs1rem c0",
                                                        children: comp.cName
                                                    }),
                                                    comp.subscription ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "c7 di ml0-5rem",
                                                        children: [
                                                            "(",
                                                            comp.subscription?.toUpperCase(),
                                                            ")"
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c8 di ml0-5rem",
                                                        children: "(INACTIVE)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: "",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                            multiple: true,
                                                            className: "select-advisor w10 pa",
                                                            id: `bulk-select-${cIndex}`,
                                                            sx: {
                                                                "& .MuiSvgIcon-root": {
                                                                    color: "#4A67FF"
                                                                }
                                                            },
                                                            IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                            value: [],
                                                            MenuProps: {
                                                                anchorOrigin: {
                                                                    vertical: 'bottom',
                                                                    horizontal: 'right'
                                                                },
                                                                transformOrigin: {
                                                                    vertical: 'top',
                                                                    horizontal: 'right'
                                                                }
                                                            },
                                                            children: advisors.map((advisor, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                    value: advisor,
                                                                    className: "select-advisor-list ttc",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                            checked: checkAdvisorHasAllAllocations({
                                                                                advisor: advisor,
                                                                                company: comp
                                                                            }),
                                                                            onClick: (e)=>handleMultiPermissions(e, advisor, allTempSectionNos, comp)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                            primary: `${advisor.firstName} ${advisor.lastName} - ${advisor.title || advisor.designation || advisor.job || ''}`
                                                                        })
                                                                    ]
                                                                }, `${cIndex}-bulk-${idx}`))
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }, `temp-comp-${cIndex}`))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                        children: [
                            moduleItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: allCompanies.length + 1,
                                            style: {
                                                padding: '16px 0 8px',
                                                borderBottom: '2px solid #4A67FF'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fw600 c3 fs1-25rem",
                                                children: "Modules"
                                            })
                                        })
                                    }),
                                    moduleItems.map(({ module: module, moduleSections: moduleSections }, mIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    onClick: ()=>toggleAccordion(module._id),
                                                    style: {
                                                        background: '#f8f9fa',
                                                        cursor: 'pointer'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            style: {
                                                                padding: '10px 12px',
                                                                paddingTop: mIdx > 0 ? '20px' : '10px',
                                                                borderTop: mIdx > 0 ? '1px solid #DBDFEE' : 'none',
                                                                width: '100% !important',
                                                                minWidth: '100%!important'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df aic jcsb w100",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        gap: '8px'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                                                                            className: "c3 td250",
                                                                            style: {
                                                                                fontSize: '22px',
                                                                                transform: openAccordions[module._id] ? 'rotate(180deg)' : 'rotate(0deg)'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw600 c3 fs1rem",
                                                                            children: module.moduleName
                                                                        }),
                                                                        module.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fs0-75rem c15 px0-5rem py0-25rem br5px",
                                                                            style: {
                                                                                background: '#e9ecef',
                                                                                opacity: 0.8
                                                                            },
                                                                            children: module.moduleKey
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "fs0-75rem",
                                                                            style: {
                                                                                color: '#888'
                                                                            },
                                                                            children: [
                                                                                "(",
                                                                                moduleSections.length,
                                                                                " section",
                                                                                moduleSections.length !== 1 ? 's' : '',
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        allCompanies.map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                style: {
                                                                    background: '#f8f9fa',
                                                                    borderTop: mIdx > 0 ? '1px solid #DBDFEE' : 'none'
                                                                }
                                                            }, i))
                                                    ]
                                                }),
                                                openAccordions[module._id] && moduleSections.map((section, sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "c15 bg0",
                                                                style: {
                                                                    background: '#fafbfe'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 bg0",
                                                                        style: {
                                                                            marginRight: '4px'
                                                                        },
                                                                        children: section.sectionNo
                                                                    }),
                                                                    section.sectionName
                                                                ]
                                                            }),
                                                            allCompanies.map((comp, cIdx)=>{
                                                                const isCompanyLocked = module.isMainModule && !module.companies?.[comp._id];
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "c15 cp",
                                                                    style: isCompanyLocked ? {
                                                                        opacity: 0.4,
                                                                        pointerEvents: 'none'
                                                                    } : {},
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w100 df jcsb bg1 p0-5rem br30px",
                                                                        style: {
                                                                            border: '1px solid #DBDFEE'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df",
                                                                                children: !isCompanyLocked && section.permission?.[comp._id] && Object.values(section.permission[comp._id]).map((advisor, keyIndex)=>advisor?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        src: advisor.profile,
                                                                                        className: `w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                                                        "data-tooltip": advisor.firstName ? `${advisor.firstName} ${advisor.lastName}` : 'Register to show your name here',
                                                                                        alt: ""
                                                                                    }, `${keyIndex}-av`) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        "data-tooltip": advisor.firstName ? `${advisor.firstName} ${advisor.lastName}` : 'Register to show your name here',
                                                                                        className: `w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                                                        children: advisor.firstName ? `${advisor.firstName[0]}${advisor.lastName[0]}` : '?'
                                                                                    }, `${keyIndex}-av-init`))
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "pr",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                                    multiple: true,
                                                                                    className: "select-advisor w10",
                                                                                    id: `section-select-${comp._id}-${section.sectionNo}`,
                                                                                    sx: {
                                                                                        "& .MuiSvgIcon-root": {
                                                                                            color: "#4A67FF"
                                                                                        }
                                                                                    },
                                                                                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                                                    value: [],
                                                                                    disabled: isCompanyLocked,
                                                                                    MenuProps: {
                                                                                        PaperProps: {
                                                                                            style: {
                                                                                                maxHeight: 300,
                                                                                                width: 'auto',
                                                                                                minWidth: '200px'
                                                                                            }
                                                                                        },
                                                                                        anchorOrigin: {
                                                                                            vertical: 'bottom',
                                                                                            horizontal: 'left'
                                                                                        },
                                                                                        transformOrigin: {
                                                                                            vertical: 'top',
                                                                                            horizontal: 'left'
                                                                                        },
                                                                                        getContentAnchorEl: null,
                                                                                        keepMounted: true,
                                                                                        marginThreshold: 10,
                                                                                        style: {
                                                                                            WebkitTransform: 'none',
                                                                                            position: 'fixed'
                                                                                        }
                                                                                    },
                                                                                    children: advisors.map((advisor, adIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                                            value: advisor._id,
                                                                                            className: "select-advisor-list ttc",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                                    checked: !!section.permission?.[comp._id]?.[advisor._id],
                                                                                                    onChange: (e)=>handlePermissions(e, advisor, section.sectionNo, comp)
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                                    primary: `${advisor.firstName} ${advisor.lastName} - ${advisor.title || advisor.designation || advisor.job || ''}`
                                                                                                })
                                                                                            ]
                                                                                        }, `${section.sectionNo}-${comp._id}-${adIdx}`))
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }, `${cIdx}-check-${section.sectionNo}-${sIdx}`);
                                                            })
                                                        ]
                                                    }, section.sectionNo))
                                            ]
                                        }, `m-${module._id}`))
                                ]
                            }),
                            checklistItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: allCompanies.length + 1,
                                            style: {
                                                padding: '32px 0 8px',
                                                borderBottom: '2px solid #4A67FF'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fw600 c3 fs1-25rem",
                                                children: "Checklists"
                                            })
                                        })
                                    }),
                                    checklistItems.filter(({ module: module })=>![
                                            'Exit Readiness',
                                            'Cyber DueDil',
                                            'Business For Sale'
                                        ].includes(module.moduleName)).map(({ module: module, moduleSections: moduleSections }, mIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    onClick: ()=>toggleAccordion(module._id),
                                                    style: {
                                                        background: '#f8f9fa',
                                                        cursor: 'pointer'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            style: {
                                                                padding: '10px 12px',
                                                                paddingTop: mIdx > 0 ? '20px' : '10px',
                                                                borderTop: mIdx > 0 ? '1px solid #DBDFEE' : 'none',
                                                                width: '100% !important',
                                                                minWidth: '100%!important'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df aic jcsb w100",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        gap: '8px'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                                                                            className: "c3 td250",
                                                                            style: {
                                                                                fontSize: '22px',
                                                                                transform: openAccordions[module._id] ? 'rotate(180deg)' : 'rotate(0deg)'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw600 c3 fs1rem",
                                                                            children: module.moduleName
                                                                        }),
                                                                        module.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fs0-75rem c15 px0-5rem py0-25rem br5px",
                                                                            style: {
                                                                                background: '#e9ecef',
                                                                                opacity: 0.8
                                                                            },
                                                                            children: module.moduleKey
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "fs0-75rem",
                                                                            style: {
                                                                                color: '#888'
                                                                            },
                                                                            children: [
                                                                                "(",
                                                                                moduleSections.length,
                                                                                " section",
                                                                                moduleSections.length !== 1 ? 's' : '',
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        allCompanies.map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                style: {
                                                                    background: '#f8f9fa',
                                                                    borderTop: mIdx > 0 ? '1px solid #DBDFEE' : 'none'
                                                                }
                                                            }, i))
                                                    ]
                                                }),
                                                openAccordions[module._id] && moduleSections.map((section, sIdx)=>{
                                                    // console.log(section, "section")
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "c15 bg0",
                                                                style: {
                                                                    background: '#fafbfe'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 bg0",
                                                                        style: {
                                                                            marginRight: '4px'
                                                                        },
                                                                        children: section.sectionNo
                                                                    }),
                                                                    section.sectionName
                                                                ]
                                                            }),
                                                            allCompanies.map((comp, cIdx)=>{
                                                                const isCompanyLocked = !module.companies?.[comp._id];
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "c15 cp",
                                                                    style: isCompanyLocked ? {
                                                                        opacity: 0.4,
                                                                        pointerEvents: 'none'
                                                                    } : {},
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "w100 df jcsb bg1 p0-5rem br30px",
                                                                        style: {
                                                                            border: '1px solid #DBDFEE'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df",
                                                                                children: !isCompanyLocked && section.permission?.[comp._id] && Object.values(section.permission[comp._id]).map((advisor, keyIndex)=>{
                                                                                    return advisor?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        src: advisor.profile,
                                                                                        className: `w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                                                        "data-tooltip": advisor.firstName ? `${advisor.firstName} ${advisor.lastName}` : 'Register to show your name here',
                                                                                        alt: ""
                                                                                    }, `${keyIndex}-cl-av`) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        "data-tooltip": advisor.firstName ? `${advisor.firstName} ${advisor.lastName}` : 'Register to show your name here',
                                                                                        className: `w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                                                        children: advisor.firstName ? `${advisor.firstName[0]}${advisor.lastName[0]}` : '?'
                                                                                    }, `${keyIndex}-cl-av-init`);
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "pr",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                                    multiple: true,
                                                                                    className: "select-advisor w10",
                                                                                    id: `cl-section-select-${comp._id}-${section.sectionNo}`,
                                                                                    sx: {
                                                                                        "& .MuiSvgIcon-root": {
                                                                                            color: "#4A67FF"
                                                                                        }
                                                                                    },
                                                                                    IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                                                    value: [],
                                                                                    disabled: isCompanyLocked,
                                                                                    MenuProps: {
                                                                                        PaperProps: {
                                                                                            style: {
                                                                                                maxHeight: 300,
                                                                                                width: 'auto',
                                                                                                minWidth: '200px'
                                                                                            }
                                                                                        },
                                                                                        anchorOrigin: {
                                                                                            vertical: 'bottom',
                                                                                            horizontal: 'left'
                                                                                        },
                                                                                        transformOrigin: {
                                                                                            vertical: 'top',
                                                                                            horizontal: 'left'
                                                                                        },
                                                                                        getContentAnchorEl: null,
                                                                                        keepMounted: true,
                                                                                        marginThreshold: 10,
                                                                                        style: {
                                                                                            WebkitTransform: 'none',
                                                                                            position: 'fixed'
                                                                                        }
                                                                                    },
                                                                                    children: advisors.map((advisor, adIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                                            value: advisor._id,
                                                                                            className: "select-advisor-list ttc",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                                    checked: !!section.permission?.[comp._id]?.[advisor._id],
                                                                                                    onChange: (e)=>handlePermissions(e, advisor, section.sectionNo, comp)
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                                    primary: `${advisor.firstName} ${advisor.lastName} - ${advisor.title || advisor.designation || advisor.job || ''}`
                                                                                                })
                                                                                            ]
                                                                                        }, `cl-${section.sectionNo}-${comp._id}-${adIdx}`))
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }, `${cIdx}-cl-check-${section.sectionNo}-${sIdx}`);
                                                            })
                                                        ]
                                                    }, section.sectionNo);
                                                })
                                            ]
                                        }, `c-${module._id}`))
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");










var $acw62 = parcelRequire("acw62");






const $63164483940ceacd$var$cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);

const $63164483940ceacd$var$UploadSection = ({ advisorData: advisorData, profileClass: profileClass, onProfileImageHandler: onProfileImageHandler })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "form-group df jsc",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "img-upload-area pr",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "img-box pr shadow",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: advisorData?.profile || (parcelRequire("cfmAr")),
                        alt: "Profile",
                        className: `profile-img w7rem h7rem ${profileClass}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "input-file",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "add-btn bg5",
                            onClick: onProfileImageHandler,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                viewBox: "0 0 487 487",
                                className: "zi3",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9 v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
const $63164483940ceacd$var$EDIT_FORM = [
    {
        identifier: 'firstName',
        type: 'text',
        placeholder: 'First Name',
        className: "pl4rem shadow bg5 w100 br5px p1rem",
        index: 0,
        svg: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: "center-vertically f3 pa l0 ml1rem w2rem",
            viewBox: "0 0 640 512",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                className: "fa-secondary"
            })
        })
    },
    {
        identifier: 'lastName',
        type: 'text',
        placeholder: 'Last Name',
        className: "pl4rem shadow bg5 w100 br5px p1rem",
        index: 1,
        svg: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: "center-vertically f3 pa l0 ml1rem w2rem",
            viewBox: "0 0 640 512",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                className: "fa-secondary"
            })
        })
    },
    {
        identifier: 'email',
        type: 'email',
        placeholder: 'Email',
        className: "pl4rem shadow bg5 w100 br5px p1rem",
        disabled: true,
        index: 2,
        svg: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            className: "center-vertically f3 pa l0 ml1rem w2rem",
            viewBox: "0 0 512 512",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                    className: "fa-secondary"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                    className: "fa-primary"
                })
            ]
        })
    },
    {
        identifier: 'phone',
        type: 'text',
        country: "GB",
        international: true,
        withCountryCallingCode: true,
        placeholder: 'First Name',
        className: "bg5 w100 pl4rem shadow br5px p1rem",
        index: 3,
        svg: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            className: "center-vertically f3 pa l0 ml1rem w2rem",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 384 512",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-primary",
                    d: "M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    className: "fa-secondary",
                    d: "M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
                })
            ]
        }),
        component: "phone-input"
    },
    {
        identifier: 'linkedIn',
        type: 'text',
        placeholder: 'LinkedIn',
        className: "bg5 pl4rem shadow w100 br5px p1rem",
        index: 4,
        svg: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: "center-vertically f3 pa l0 ml1rem w2rem",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 310 310",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                id: "XMLID_801_",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        id: "XMLID_802_",
                        d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73 C77.16,101.969,74.922,99.73,72.16,99.73z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-secondary",
                        id: "XMLID_803_",
                        d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4 c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        className: "fa-primary",
                        id: "XMLID_804_",
                        d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599 c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319 c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995 C310,145.43,300.549,94.761,230.454,94.761z"
                    })
                ]
            })
        })
    },
    {
        identifier: 'title',
        type: 'text',
        placeholder: 'Title',
        className: "pl4rem shadow bg5 w100 br5px p1rem",
        index: 5,
        svg: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: "center-vertically f3 pa l0 ml1rem w2rem",
            viewBox: "0 0 640 512",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                className: "fa-secondary"
            })
        })
    }
];




function $63164483940ceacd$export$2e2bcd8739ae039({ profileClass: profileClass, companies: companies, advisors: advisors, getAuditLogs: getAuditLogs, setRefresh: setRefresh, getAdvisors: getAdvisors, companiesLoading: companiesLoading }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [selectedData, setSelectedData] = (0, $acw62.useState)('');
    let [advisorData, setAdvisorData] = (0, $acw62.useState)('');
    let [uploadProfileModal, setUploadProfileModal] = (0, $acw62.useState)(false);
    let [userProfile, setUserProfile] = (0, $acw62.useState)('');
    let [loading, setLoading] = (0, $acw62.useState)(false);
    let [currentFocus, setCurrentFocus] = (0, $acw62.useState)(null);
    let inputRefs = (0, $acw62.useRef)([]);
    let [permissions, setPermissions] = (0, $acw62.useState)({});
    let [selectAll, setSelectAll] = (0, $acw62.useState)(false);
    let [resendAdvisor, setResendAdvisor] = (0, $acw62.useState)({});
    const [sections, setSections] = (0, $acw62.useState)([
        {
            sectionNo: "D001",
            sectionName: "Key Shareholder/Investor Documents"
        },
        {
            sectionNo: "D002",
            sectionName: "Commercial Activities"
        },
        {
            sectionNo: "D003",
            sectionName: "Legal"
        },
        {
            sectionNo: "D004",
            sectionName: "Property"
        },
        {
            sectionNo: "D005",
            sectionName: "Intellectual Property"
        },
        {
            sectionNo: "D006",
            sectionName: "Insurance"
        },
        {
            sectionNo: "D007",
            sectionName: "Corporate Structure"
        },
        {
            sectionNo: "D008",
            sectionName: "State Aid"
        },
        {
            sectionNo: "D009",
            sectionName: "Finance"
        },
        {
            sectionNo: "D010",
            sectionName: "General Data Protection Regulations (GDPR)"
        },
        {
            sectionNo: "D011",
            sectionName: "Shares & Share Options"
        },
        {
            sectionNo: "D012",
            sectionName: "Taxation"
        },
        {
            sectionNo: "D013",
            sectionName: "Social Media"
        },
        {
            sectionNo: "D014",
            sectionName: "Key People"
        },
        {
            sectionNo: "D015",
            sectionName: "Human Resources"
        },
        {
            sectionNo: "D016",
            sectionName: "Environmental, Social & Governmental (ESG)"
        },
        {
            sectionNo: "D017",
            sectionName: "Key Advisors - Engagement Letters & Corrrspondence"
        },
        {
            sectionNo: "D018",
            sectionName: "IT Systems"
        },
        {
            sectionNo: "D019",
            sectionName: "Regulatory"
        },
        {
            sectionNo: "D020",
            sectionName: "Standards"
        },
        {
            sectionNo: "DEPF005",
            sectionName: "Environmental, Social, Governmental (ESG)"
        },
        {
            sectionNo: "DEPF006",
            sectionName: "Warranty Disclosure"
        },
        {
            sectionNo: "DEPF007",
            sectionName: "Directors Questionnaire"
        },
        {
            sectionNo: "DEPN004",
            sectionName: "Software Development"
        }
    ]);
    (0, $acw62.useEffect)(()=>{
        let sectionObj = JSON.parse(JSON.stringify(sections));
        for (let company of companies){
            const userType = 'revenuelead';
            if (company?.[userType]) for (let advisorId of Object.keys(company?.[userType])){
                let advisorSettings = company?.[userType]?.[advisorId];
                let advisor = advisors.find(({ _id: _id })=>_id == advisorId);
                if (!advisorSettings["modules"] || !advisor) continue;
                sectionObj = sectionObj.map((obj, i, arr)=>{
                    return {
                        ...obj,
                        allocation: {
                            ...obj?.allocation,
                            [company["_id"]]: {
                                ...obj?.allocation?.[company["_id"]],
                                [advisorId]: {
                                    ...advisor,
                                    allocationModule: advisorSettings["modules"]
                                }
                            }
                        }
                    };
                });
            }
        }
        setSections(sectionObj);
    }, [
        companies
    ]);
    // on advisor allocation
    const handleLeadAllocation = async (e, advisor, sectionNo, company)=>{
        if (advisor['emailVerified']) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/allocateRevenueLead/${company["_id"]}`, {
                advisor: advisor,
                company: company,
                advisorId: advisor["_id"],
                sectionNo: sectionNo,
                status: e["target"]["checked"],
                firmId: user["companyId"]["_id"]
            });
            if (res && res["code"] == 200) {
                let sectionObj = await JSON.parse(JSON.stringify(sections));
                let sectionIndex = sections.findIndex((section)=>section["sectionNo"] == sectionNo);
                Object.entries(sectionObj[sectionIndex]["allocation"][company["_id"]]).map((adv)=>{
                    const key = adv[0];
                    const advData = adv[1];
                    sectionObj[sectionIndex]["allocation"][company["_id"]] = {
                        ...sectionObj[sectionIndex]["allocation"]?.[company["_id"]],
                        [advData["_id"]]: {
                            ...advData,
                            ['allocationModule']: {
                                ...advData,
                                [sectionNo]: key === advisor._id ? e["target"]["checked"] : false
                            }
                        }
                    };
                });
                setSections(sectionObj);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
                setRefresh((r)=>!r);
            }
        } else {
            setResendAdvisor(advisor);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "resendInviteMail"
            }));
        }
    };
    function arraysMatch(data, allList) {
        const allDataInAllList = data.every((item)=>allList.includes(item));
        const allAllListInData = allList.every((item)=>data.includes(item));
        return allDataInAllList && allAllListInData;
    }
    const checkAdvisorHasAllAllocations = ({ advisor: advisor, company: company })=>{
        if (advisor && company['revenuelead'] && company['revenuelead'][`${advisor['_id']}`] && company['revenuelead'][`${advisor['_id']}`]['modules']) {
            const allAllocationCode = sections.map((item)=>item.sectionNo);
            const advisorPermission = [];
            Object.entries(company['revenuelead'][`${advisor['_id']}`]['modules']).map((item)=>item[1] === true && advisorPermission.push(item[0]));
            const result = arraysMatch(allAllocationCode, advisorPermission);
            return result;
        }
        return false;
    };
    // on advisor multi allocation
    const handleMultiLeadAllocation = async (e, advisor, sectionNo, company)=>{
        if (advisor['emailVerified']) {
            const _checked = e["target"]["checked"];
            if (_checked === true) {
                if (checkAdvisorHasAllAllocations(advisor, company) === true) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Already Selected a advisor for all');
            }
            const result = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/advisorMultiPermissions/${company["_id"]}`, {
                advisor: advisor,
                company: company,
                advisorId: advisor["_id"],
                sectionNo: sectionNo,
                status: _checked,
                firmId: user["companyId"]["_id"]
            });
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/allocateMultiRevenueLead/${company["_id"]}`, {
                advisor: advisor,
                company: company,
                advisorId: advisor["_id"],
                sectionNo: sectionNo,
                status: _checked,
                firmId: user["companyId"]["_id"]
            });
            if (res && res["code"] == 200) {
                let sectionObj = await JSON.parse(JSON.stringify(sections));
                sections.map((_, sectionIndex)=>{
                    if (!sectionObj[sectionIndex]["allocation"][company["_id"]][advisor["_id"]]) sectionObj[sectionIndex]["allocation"][company["_id"]] = {
                        ...sectionObj[sectionIndex]["allocation"]?.[company["_id"]],
                        [advisor["_id"]]: advisor
                    };
                });
                setSections(sectionObj);
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            setRefresh((r)=>!r);
        } else {
            setResendAdvisor(advisor);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "resendInviteMail"
            }));
        }
    };
    // on edit button Click in  bussiness card
    const onEditHandler = async (advisor)=>{
        if (!advisor?.['permissions']) return;
        const permissionArray = Object?.values(advisor?.['permissions']);
        if (advisor) {
            setAdvisorData({
                firstName: advisor["firstName"],
                lastName: advisor["lastName"],
                email: advisor["email"],
                title: advisor["designation"],
                isDisable: user?._id === advisor?._id ? false : true,
                isSuperUser: user?.["createdBy"] ? false : true,
                phone: advisor["phone"] && advisor["phone"] !== undefined && advisor["phone"] !== 'undefined' ? advisor["phone"] : '+44',
                linkedIn: advisor["linkedIn"] ? advisor["linkedIn"] : '',
                profile: advisor["profile"] ? advisor["profile"] : ''
            });
            if (!permissionArray.includes(false)) setSelectAll(true);
            if (advisor["permissions"]) setPermissions(advisor["permissions"]);
        }
    };
    // on edit modal close
    const onModalClose = ()=>setAdvisorData('');
    // on advisor submit
    const onSubmitAdvisor = async ()=>{
        if (advisorData["firstName"] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter your first name");
        if (advisorData["lastName"] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter your last name");
        if (advisorData["email"] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter your email");
        if (advisorData["designation"] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter your title");
        advisorData = await {
            ...advisorData,
            action: 'edit',
            permissions: permissions
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/addAdvisor`, advisorData);
        if (res && res["code"] == 200) {
            await getAdvisors();
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            onModalClose();
            setSelectedData('');
        }
    };
    // on Fields changed
    const handleChange = (e)=>{
        setAdvisorData({
            ...advisorData,
            [e.target.name]: e.target.value
        });
    };
    // on Upload modal close
    const onUploadModalClose = ()=>{
        setUploadProfileModal(false);
    };
    // on Resent invite link to advisor modal close
    const onResendLinkModalClose = ()=>{
        setResendAdvisor({});
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
    };
    //Upload the profile image
    const handleProfile = async (e)=>{
        let profile = e.target.files[0];
        if (profile && profile.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        profile = URL.createObjectURL(profile);
        setUserProfile(profile);
    };
    // get image url to api submit
    const getImageUrl = async ()=>{
        let attachment = [];
        if ($63164483940ceacd$var$cropper.current && userProfile) {
            setLoading(true);
            let imageToUpload = $63164483940ceacd$var$cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile image", {
                type: "image/png"
            });
            attachment.push(coverFile);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/upload/advisor/profile`, {
                attachment: attachment
            });
            if (response || response["code"] == 200) setAdvisorData({
                ...advisorData,
                profile: response?.message
            });
            else setLoading(false);
            setUserProfile('');
            onUploadModalClose();
            setLoading(false);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    // Ensure the currently focused input keeps the focus
    (0, $acw62.useEffect)(()=>{
        if (currentFocus !== null) inputRefs.current?.[currentFocus]?.focus();
    }, [
        advisorData,
        currentFocus
    ]);
    // on Focus function
    const handleFocus = (index)=>setCurrentFocus(index);
    //handle Permissions section
    const handleAdvisorPermissions = async (e, section)=>{
        if (e.target.checked === false) setSelectAll(false);
        permissions = await {
            ...permissions,
            [section["sectionNo"]]: e.target.checked
        };
        await setPermissions(permissions);
        const permissionArray = Object.values(permissions);
        if (!permissionArray.includes(false)) setSelectAll(true);
    };
    // Select All Permissions
    const selectAllPermissions = (event)=>{
        if (event.target.checked) {
            setSelectAll(event.target.checked);
            sections?.forEach((section)=>{
                if (section.sectionNo.trim() !== "") permissions[section.sectionNo] = event.target.checked;
            });
            setPermissions(permissions);
        } else {
            setSelectAll(false);
            sections?.forEach((section)=>{
                if (section.sectionNo.trim() !== "") permissions[section.sectionNo] = false;
            });
            setPermissions(permissions);
        }
    };
    // Send invitation link to advisor
    const submitResendInvite = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/resendAdvisorInvite/${resendAdvisor["_id"]}`);
        if (res && res["code"] == 200) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            onResendLinkModalClose();
        }
    };
    const hasAdvisorPermission = (advisorData, company, sectionNo)=>{
        if (company?.advisors?.[advisorData?.["_id"]]?.modules?.[sectionNo]) return true;
        return false;
    };
    if (companiesLoading && !(companies && companies.length > 0)) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "table-permission",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                id: "table",
                className: "table-userPermissions table-clientPermissions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        className: "ps t0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "index-table",
                                    children: "Modules"
                                }),
                                [
                                    1,
                                    2,
                                    3
                                ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "user-area",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df jcc aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mr1rem wfull",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 110,
                                                        height: 22
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 60,
                                                        height: 16
                                                    })
                                                ]
                                            })
                                        })
                                    }, `skel-rev-comp-${i}`))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8
                        ].map((sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        style: {
                                            padding: '8px 12px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic",
                                            style: {
                                                gap: '6px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                    variant: "rectangular",
                                                    width: 48,
                                                    height: 14,
                                                    sx: {
                                                        borderRadius: '3px'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                    variant: "rectangular",
                                                    width: 100 + sIdx * 12,
                                                    height: 14,
                                                    sx: {
                                                        borderRadius: '3px'
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    [
                                        1,
                                        2,
                                        3
                                    ].map((cIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w100 df jcsb aic bg1 p0-5rem br30px",
                                                style: {
                                                    border: '1px solid #DBDFEE'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "circular",
                                                        width: 32,
                                                        height: 32
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "circular",
                                                        width: 20,
                                                        height: 20
                                                    })
                                                ]
                                            })
                                        }, `skel-rev-sc-${cIdx}`))
                                ]
                            }, `skel-rev-s-${sIdx}`))
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem",
        children: [
            companies && companies.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        onClick: ()=>getAuditLogs(`/user/allocateRevenueLead`, user["companyId"]["_id"], "allocation"),
                        className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard pa t0 r0 audit-log-btn",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "36",
                                    height: "36",
                                    viewBox: "0 0 36 36",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        "fill-rule": "evenodd",
                                        "clip-rule": "evenodd",
                                        d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                                        fill: "#4A67FF"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c15",
                                children: "Audit Log"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "table-permission",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            id: "table",
                            className: "table-userPermissions table-clientPermissions 1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "ps t0",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "index-table",
                                                children: "Modules"
                                            }),
                                            companies && companies.filter((company)=>company['progress'] !== "inActive").map((company, compIndex)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "user-area",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df jcc aic",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "mr1rem wfull pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "df fs1rem c2",
                                                                    children: [
                                                                        company["cName"],
                                                                        company["subscription"] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "c7 ml0-5rem",
                                                                            children: [
                                                                                "(",
                                                                                company["subscription"]?.toUpperCase(),
                                                                                ")"
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "c8 ml0-5rem",
                                                                                children: "(INACTIVE)"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    className: "pa r0 t0 df jcc aic",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                        multiple: true,
                                                                        labelId: "demo-simple-select-label",
                                                                        className: "select-advisor w10 pa",
                                                                        id: "demo-multiple-name",
                                                                        sx: {
                                                                            "& .MuiSvgIcon-root": {
                                                                                color: "#4A67FF"
                                                                            },
                                                                            "& .MuiSelect-select": '#000'
                                                                        },
                                                                        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                                        value: [],
                                                                        label: "Apply to all Sections",
                                                                        MenuProps: {
                                                                            anchorOrigin: {
                                                                                vertical: "bottom",
                                                                                horizontal: "right"
                                                                            },
                                                                            transformOrigin: {
                                                                                vertical: "top",
                                                                                horizontal: "right"
                                                                            },
                                                                            getContentAnchorEl: null
                                                                        },
                                                                        children: advisors.map((advisor, adIdx)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                                disabled: !advisor?.createdBy,
                                                                                value: advisor,
                                                                                className: "select-advisor-list ttc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: `${!(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) && "disable-advisor-checkbox"}`,
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                            disabled: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor),
                                                                                            checked: checkAdvisorHasAllAllocations({
                                                                                                advisor: advisor,
                                                                                                company: company
                                                                                            }),
                                                                                            onClick: (e)=>handleMultiLeadAllocation(e, advisor, sections.map((item)=>item.sectionNo), company)
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                        style: {
                                                                                            color: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) && "lightgray"
                                                                                        },
                                                                                        primary: advisor["firstName"] + " " + advisor["lastName"] + " - " + (advisor["designation"] ? advisor["designation"] : advisor["job"])
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "ml0-5rem",
                                                                                        children: (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$4202723ba73439f5), {
                                                                                            color: '#008000',
                                                                                            onClick: ()=>setSelectedData({
                                                                                                    ...advisor,
                                                                                                    hasEditButton: true,
                                                                                                    editRoute: "edit"
                                                                                                })
                                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$6a73aa53e89cdaab), {
                                                                                            color: '#F44336',
                                                                                            onClick: ()=>setSelectedData({
                                                                                                    ...advisor,
                                                                                                    hasEditButton: true,
                                                                                                    editRoute: "edit"
                                                                                                })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, adIdx);
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, compIndex);
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: sections.map((section, idx)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                    className: "c15",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: section["sectionNo"]
                                                        }),
                                                        " ",
                                                        section["sectionName"]
                                                    ]
                                                }, idx),
                                                companies && companies.filter((company)=>company['progress'] !== "inActive").map((company, idxx)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "c15 cp",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "w100 df jcsb bg1 p0-5rem br30px s",
                                                            style: {
                                                                border: '1px solid #DBDFEE'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: section?.["allocation"]?.[company["_id"]] && Object.values(section["allocation"][company["_id"]]).sort((a, b)=>new Date(a.createdAt) - new Date(b.createdAt)).map((advisor, indexNum)=>{
                                                                        //Logic to show main advisor as active if there are no any advisor alligned to any section
                                                                        let parentActive = advisors.filter((advisorObj, advisorindex, arr)=>{
                                                                            if (section?.["allocation"]?.[company["_id"]]?.[advisorObj["_id"]]?.allocationModule?.[section["sectionNo"]] === true && advisorObj?.["createdBy"]) return false;
                                                                            return true;
                                                                        }).length < advisors?.length ? false : true;
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                                            children: advisor?.["createdBy"] ? (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) && hasAdvisorPermission(advisor, company, section["sectionNo"]) && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                style: {
                                                                                    border: section?.["allocation"]?.[company["_id"]]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]] === true ? '4px solid #09b255' : '4px solid transparent'
                                                                                },
                                                                                className: `w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                                                src: advisor["profile"] ? advisor["profile"] : (parcelRequire("cfmAr")),
                                                                                onClick: (e)=>handleLeadAllocation(e = {
                                                                                        target: {
                                                                                            checked: !section?.["allocation"]?.[company["_id"]]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]]
                                                                                        }
                                                                                    }, advisor, section["sectionNo"], company),
                                                                                "data-tooltip": advisor?.["firstName"] ? advisor["firstName"] + " " + advisor["lastName"] : "Register to show your name here"
                                                                            }, `${company["_id"]}-${advisor?.["_id"]}-${indexNum}-${"advisorindex"}`) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                style: {
                                                                                    // border: '5px solid green',
                                                                                    border: `4px solid ${parentActive ? "#09b255" : 'transparent'}`,
                                                                                    background: "gray"
                                                                                },
                                                                                className: `w2rem h2rem df jcc aic br100 mr0-5rem pr cna ${profileClass}`,
                                                                                src: advisor["profile"] ? advisor["profile"] : (parcelRequire("cfmAr")),
                                                                                "data-tooltip": advisor["firstName"] ? advisor["firstName"] + " " + advisor["lastName"] + " " + `(Super Advisor)` : "Register to show your name here"
                                                                            })
                                                                        }, `${company["_id"]}-${advisor?.["_id"]}-${indexNum}-${"advisorindex"}-${new Date().getTime()}`);
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "pr",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                        multiple: true,
                                                                        className: "select-advisor w10",
                                                                        id: "demo-multiple-name",
                                                                        sx: {
                                                                            "& .MuiSvgIcon-root": {
                                                                                color: "#4A67FF"
                                                                            }
                                                                        },
                                                                        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                                        value: [],
                                                                        MenuProps: {
                                                                            anchorOrigin: {
                                                                                vertical: "bottom",
                                                                                horizontal: "right"
                                                                            },
                                                                            transformOrigin: {
                                                                                vertical: "top",
                                                                                horizontal: "right"
                                                                            }
                                                                        },
                                                                        disablePortal: true,
                                                                        children: advisors.map((advisor, idx)=>hasAdvisorPermission(advisor, company, section["sectionNo"]) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                                value: advisor,
                                                                                className: "select-advisor-list ttc",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: `${!(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) && "disable-advisor-checkbox"}`,
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                            checked: section?.["allocation"]?.[company["_id"]]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]] === true ? true : false,
                                                                                            disabled: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor),
                                                                                            onClick: (e)=>handleLeadAllocation(e = {
                                                                                                    target: {
                                                                                                        checked: !section?.["allocation"]?.[company["_id"]]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]]
                                                                                                    }
                                                                                                }, advisor, section["sectionNo"], company)
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                        style: {
                                                                                            color: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) && "lightgray"
                                                                                        },
                                                                                        primary: advisor["firstName"] + " " + advisor["lastName"] + " - " + `${advisor["designation"] ? advisor["designation"] : advisor["job"]}`
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "ml0-5rem",
                                                                                        children: (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$4202723ba73439f5), {
                                                                                            color: '#008000',
                                                                                            onClick: ()=>setSelectedData({
                                                                                                    ...advisor,
                                                                                                    hasEditButton: true,
                                                                                                    editRoute: "edit",
                                                                                                    permission: section?.permission
                                                                                                })
                                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$6a73aa53e89cdaab), {
                                                                                            color: '#F44336',
                                                                                            onClick: ()=>setSelectedData({
                                                                                                    ...advisor,
                                                                                                    hasEditButton: true,
                                                                                                    editRoute: "edit",
                                                                                                    permission: section?.permission
                                                                                                })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, `dropdown-for-each-${idxx}-user-${idx}`))
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, `${idxx}-${company['_id']}-${new Date().getTime()}`);
                                                })
                                            ]
                                        });
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc c15 fs1-75rem fw500 lh2 mt2rem",
                children: "No clients added for permissions"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: selectedData,
                onClose: ()=>setSelectedData(''),
                className: "td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ec3d7e6915201e2$export$2e2bcd8739ae039), {
                    setSelectedData: setSelectedData,
                    selectedData: selectedData,
                    onEditClick: ()=>onEditHandler(selectedData),
                    profileClass: profileClass,
                    user: user
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: advisorData,
                onClose: onModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: "15px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: onModalClose,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu ",
                            children: "Edit Advisor"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($63164483940ceacd$var$UploadSection, {
                                            advisorData: advisorData,
                                            profileClass: profileClass,
                                            onProfileImageHandler: ()=>setUploadProfileModal(true)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "dg gtcr2-md gg1rem",
                                            children: $63164483940ceacd$var$EDIT_FORM.slice(0, 2).map((obj, i, arr)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            value: advisorData?.[obj?.identifier],
                                                            name: obj?.identifier,
                                                            ref: (el)=>inputRefs.current[obj?.index] = el,
                                                            type: obj?.type,
                                                            placeholder: obj?.placeholder,
                                                            onChange: (e)=>handleChange(e),
                                                            className: obj?.className,
                                                            onFocus: ()=>handleFocus(obj?.index)
                                                        }),
                                                        obj?.svg
                                                    ]
                                                }, obj?.identifier);
                                            })
                                        }),
                                        $63164483940ceacd$var$EDIT_FORM.slice(2).map((obj, i, arr)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "pr",
                                                children: obj?.component ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $331000cdd042dde5$export$2e2bcd8739ae039), {
                                                            className: obj.className,
                                                            name: obj.identifier,
                                                            country: obj?.country,
                                                            ref: (el)=>inputRefs.current[obj?.index] = el,
                                                            international: obj?.international,
                                                            withCountryCallingCode: obj?.withCountryCallingCode,
                                                            value: advisorData?.[obj?.identifier] ? advisorData?.[obj?.identifier] : '',
                                                            onChange: (e)=>setAdvisorData({
                                                                    ...advisorData,
                                                                    phone: e
                                                                }),
                                                            onFocus: ()=>handleFocus(obj?.index)
                                                        }),
                                                        obj?.svg
                                                    ]
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            disabled: obj?.disabled,
                                                            value: advisorData?.[obj?.identifier],
                                                            name: obj?.identifier,
                                                            type: obj?.type,
                                                            ref: (el)=>inputRefs.current[obj?.index] = el,
                                                            placeholder: obj?.placeholder,
                                                            onChange: (e)=>handleChange(e),
                                                            className: obj?.className,
                                                            onFocus: ()=>handleFocus(obj?.index)
                                                        }),
                                                        obj?.svg
                                                    ]
                                                })
                                            }, obj?.identifier);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "my1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df my0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        checked: selectAll,
                                                        onChange: selectAllPermissions,
                                                        id: "all-permissions",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "checkbox"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem fw600 mx1rem usn",
                                                    children: "All"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem fw400 usn",
                                                    children: "Permissions"
                                                })
                                            ]
                                        }),
                                        sections && sections.map((section)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df my0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w2rem h2rem pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            defultChecked: permissions[section["sectionNo"]],
                                                            checked: permissions[section["sectionNo"]],
                                                            onChange: (e)=>handleAdvisorPermissions(e, section),
                                                            id: `permissions-${section["sectionNo"]}`,
                                                            className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                            type: "checkbox"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem fw600 mx1rem usn",
                                                        children: section["sectionNo"]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem fw400 usn",
                                                        children: section["sectionName"]
                                                    })
                                                ]
                                            });
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: onSubmitAdvisor,
                                    className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic",
                                    children: "Save"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: onModalClose,
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: uploadProfileModal,
                onClose: onUploadModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: onUploadModalClose,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "Upload Profile Picture"
                        }),
                        userProfile == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            for: "profile",
                            className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pen fs1rem fw500 tac",
                                    children: "Upload picture"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: "",
                                        onChange: handleProfile,
                                        id: "profile",
                                        type: "file",
                                        accept: "image/jpeg, image/jpg, image/png"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "Max file size 5MB"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-box pr",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                style: {
                                    maxHeight: "500px"
                                },
                                ref: $63164483940ceacd$var$cropper,
                                guides: false,
                                aspectRatio: 1,
                                className: "cropper-settings",
                                src: userProfile
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        setUserProfile("");
                                        setUploadProfileModal(false);
                                    },
                                    className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        if (!loading) getImageUrl();
                                    },
                                    className: `shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem ${loading && "button-disabled"}`,
                                    children: Object.keys(userProfile).length == 0 ? "Upload" : "Crop & Upload"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "resendInviteMail",
                onClose: onResendLinkModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: "15px"
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: onResendLinkModalClose,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu pt1rem",
                            children: "Resend Invite"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem py1rem tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Advisor ",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fw600 ttc",
                                                children: [
                                                    resendAdvisor["firstName"],
                                                    " ",
                                                    resendAdvisor["lastName"]
                                                ]
                                            }),
                                            " is currently",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fw600 ttc",
                                                children: " Inactive"
                                            }),
                                            ". Please send ",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fw600 ttc",
                                                children: [
                                                    resendAdvisor["firstName"],
                                                    " ",
                                                    resendAdvisor["lastName"]
                                                ]
                                            }),
                                            " an invitation link to activate their account, enabling you to allocate them to any department"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsa",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: onResendLinkModalClose,
                                            className: "w30 shadow bg4 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: submitResendInvite,
                                            className: "w30 shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Send"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $01989d908727d1c4$var$useAdHistoryData = ()=>{
    const [data, setData] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/ads/history`, {}, setData);
            setData(response.body);
        } catch (error) {
            setData({});
            console.error('Error fetching data:', error);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    return {
        data: data,
        loading: loading
    };
};
var $01989d908727d1c4$export$2e2bcd8739ae039 = $01989d908727d1c4$var$useAdHistoryData;


const $3b0ed5abf77b3e73$var$LeadMatricReport = ()=>{
    const { data: data } = (0, $01989d908727d1c4$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df aifs jcsb",
            children: data && Object.entries(data).map((item, idx)=>{
                const companyTypes = item[0];
                const adsData = item[1];
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "sectionWrapper p0-5rem fs0-75rem pr w50",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "table-permission",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "tac",
                                    children: companyTypes.toLowerCase() === "indirect company" ? "Prospect Client Companies" : "Existing Client Companies"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    id: `table${idx}`,
                                    className: "table-userPermissions table-clientPermissions table-report",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("thead", {
                                            className: "ps t0",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "index-table smft",
                                                            children: "Sections"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "index-table taci smft",
                                                            colSpan: "3",
                                                            children: "Served"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "index-table taci smft",
                                                            colSpan: "3",
                                                            children: "Clicked"
                                                        }),
                                                        !companyTypes.includes('Indirect') ? /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "index-table taci smft",
                                                            colSpan: "3",
                                                            children: "Ads"
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "index-table smft"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "subHead smft",
                                                            children: "Week"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "subHead smft",
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "subHead smft",
                                                            children: "YTD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "subHead smft",
                                                            children: "Week"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "subHead smft",
                                                            children: "Month"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "subHead smft",
                                                            children: "YTD"
                                                        }),
                                                        !companyTypes.includes('Indirect') ? /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                            className: "index-table smft",
                                                            children: "(%)"
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: adsData && Object.entries(adsData).map((history, index)=>{
                                                const sectionNo = history[0];
                                                const historyData = history[1];
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "c15",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "fw600",
                                                                        children: [
                                                                            " ",
                                                                            sectionNo,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                                        children: [
                                                                            "(",
                                                                            historyData?.sectionName && historyData?.sectionName,
                                                                            ")"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: historyData['served']['weekCount']
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: historyData['served']['monthServed']
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: historyData['served']['ytdCount']
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: historyData['clicked']['weekCount']
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: historyData['clicked']['monthServed']
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: historyData['clicked']['ytdCount']
                                                                })
                                                            }),
                                                            historyData['percentageOfTotalClients'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c15 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: historyData['percentageOfTotalClients']
                                                                })
                                                            }) : null
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                });
            })
        })
    });
};
var $3b0ed5abf77b3e73$export$2e2bcd8739ae039 = $3b0ed5abf77b3e73$var$LeadMatricReport;


const $56643b6434ce7da2$var$RevenueLeadsAllocation = ({ profileClass: profileClass, companies: companies, advisors: advisors, getAuditLogs: getAuditLogs, setRefresh: setRefresh, getAdvisors: getAdvisors, user: user, loading: loading })=>{
    const [step, setStep] = (0, $acw62.useState)("modules");
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
            value: step,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                    onChange: (e, value)=>setStep(value),
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        "& .MuiTabs-flexContainer": {
                            justifyContent: "center"
                        }
                    },
                    style: {
                        visibility: user?.role ? "visible" : "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                            className: "fs1rem fw600 mt1rem mb1rem",
                            label: `Modules`,
                            value: "modules"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                            className: "fs1rem fw600 mt1rem mb1rem",
                            label: `Lead Metrics Report`,
                            value: "reports"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                    className: "w100",
                    value: "modules",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $63164483940ceacd$export$2e2bcd8739ae039), {
                        profileClass: profileClass,
                        companies: companies,
                        advisors: advisors,
                        getAuditLogs: getAuditLogs,
                        setRefresh: setRefresh,
                        getAdvisors: getAdvisors,
                        companiesLoading: loading
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                    className: "w100",
                    value: "reports",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b0ed5abf77b3e73$export$2e2bcd8739ae039), {
                        profileClass: profileClass,
                        companies: companies,
                        advisors: advisors,
                        getAuditLogs: getAuditLogs,
                        setRefresh: setRefresh,
                        getAdvisors: getAdvisors
                    })
                })
            ]
        })
    });
};
var $56643b6434ce7da2$export$2e2bcd8739ae039 = $56643b6434ce7da2$var$RevenueLeadsAllocation;



var $ayMG0 = parcelRequire("ayMG0");










var $acw62 = parcelRequire("acw62");








var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $3f74b0560524df69$var$useTempAdHistoryData = ()=>{
    const [data, setData] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/ads/temp-history`);
            setData(response?.body || null);
        } catch (error) {
            setData(null);
            console.error('Error fetching temp ads history:', error);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, []);
    return {
        data: data,
        loading: loading
    };
};
var $3f74b0560524df69$export$2e2bcd8739ae039 = $3f74b0560524df69$var$useTempAdHistoryData;


// One cell value, defaulting to 0
const $a041eda37fb3d6a2$var$Cell = ({ value: value })=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
        className: "c15 cp",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df jcc",
            children: value ?? 0
        })
    });
// A table for one company-type bucket (Direct or Indirect)
function $a041eda37fb3d6a2$var$CompanyTable({ title: title, bucketData: bucketData, modules: modules, isDirectCompany: isDirectCompany }) {
    const [openModules, setOpenModules] = (0, $acw62.useState)({});
    const toggle = (moduleId)=>setOpenModules((prev)=>({
                ...prev,
                [moduleId]: !prev[moduleId]
            }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sectionWrapper p0-5rem fs0-75rem pr",
        style: {
            width: '100%',
            overflowX: 'auto'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "table-permission",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "tac mb1rem",
                    style: {
                        fontSize: '1rem',
                        fontWeight: 600
                    },
                    children: title
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    className: `table-userPermissions table-clientPermissions table-report temp-lead-matrix-table ${isDirectCompany ? 'temp-lead-matrix-table--direct' : 'temp-lead-matrix-table--indirect'}`,
                    style: {
                        width: '100%',
                        borderCollapse: 'collapse',
                        tableLayout: 'fixed'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("colgroup", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("col", {}),
                                [
                                    ...Array(isDirectCompany ? 7 : 6)
                                ].map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("col", {}, i))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("thead", {
                            className: "ps t0",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table smft temp-lead-matrix-section-head",
                                            children: "Section"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table taci smft",
                                            colSpan: "3",
                                            children: "Served"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table taci smft",
                                            colSpan: "3",
                                            children: "Clicked"
                                        }),
                                        isDirectCompany && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table taci smft",
                                            colSpan: "1",
                                            children: "Ads"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table smft"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "subHead smft tac",
                                            children: "Week"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "subHead smft tac",
                                            children: "Month"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "subHead smft tac",
                                            children: "YTD"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "subHead smft tac",
                                            children: "Week"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "subHead smft tac",
                                            children: "Month"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "subHead smft tac",
                                            children: "YTD"
                                        }),
                                        isDirectCompany && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "subHead smft",
                                            children: "(%)"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                            children: modules.map((mod)=>{
                                const isOpen = !!openModules[mod._id];
                                const hasSections = mod.sectionNos && mod.sectionNos.length > 0;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                            onClick: ()=>hasSections && toggle(mod._id),
                                            style: {
                                                background: '#f0f2ff',
                                                cursor: hasSections ? 'pointer' : 'default',
                                                borderTop: '2px solid #DBDFEE'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                colSpan: isDirectCompany ? 8 : 7,
                                                style: {
                                                    padding: '8px 12px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    style: {
                                                        gap: '8px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                display: 'inline-block',
                                                                width: '18px',
                                                                textAlign: 'center',
                                                                fontWeight: 700,
                                                                color: '#4A67FF',
                                                                fontSize: '0.9rem'
                                                            },
                                                            children: hasSections ? isOpen ? "\u25BE" : "\u25B8" : ''
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600 c15",
                                                            style: {
                                                                fontSize: '0.9rem'
                                                            },
                                                            children: mod.moduleName
                                                        }),
                                                        mod.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                background: '#e9ecef',
                                                                borderRadius: '4px',
                                                                padding: '1px 6px',
                                                                fontSize: '0.72rem',
                                                                opacity: 0.85
                                                            },
                                                            children: mod.moduleKey
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                fontSize: '0.72rem',
                                                                color: '#888'
                                                            },
                                                            children: [
                                                                "(",
                                                                mod.sectionNos?.length ?? 0,
                                                                " section",
                                                                mod.sectionNos?.length !== 1 ? 's' : '',
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        isOpen && mod.sectionNos.map((sectionNo)=>{
                                            const s = bucketData[sectionNo];
                                            if (!s) return null;
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                style: {
                                                    borderBottom: '1px solid #F0F2FF'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                        className: "c15 temp-lead-matrix-section-cell",
                                                        style: {
                                                            paddingLeft: '32px',
                                                            verticalAlign: 'top'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw600",
                                                                style: {
                                                                    marginRight: '4px'
                                                                },
                                                                children: sectionNo
                                                            }),
                                                            s.sectionName && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                style: {
                                                                    color: '#555',
                                                                    fontSize: '0.78rem'
                                                                },
                                                                children: [
                                                                    "(",
                                                                    s.sectionName,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$Cell, {
                                                        value: s.served?.weekCount
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$Cell, {
                                                        value: s.served?.monthServed
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$Cell, {
                                                        value: s.served?.ytdCount
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$Cell, {
                                                        value: s.clicked?.weekCount
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$Cell, {
                                                        value: s.clicked?.monthServed
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$Cell, {
                                                        value: s.clicked?.ytdCount
                                                    }),
                                                    isDirectCompany && /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$Cell, {
                                                        value: s.percentageOfTotalClients
                                                    })
                                                ]
                                            }, sectionNo);
                                        })
                                    ]
                                }, mod._id);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function $a041eda37fb3d6a2$export$2e2bcd8739ae039() {
    const { data: data, loading: loading } = (0, $3f74b0560524df69$export$2e2bcd8739ae039)();
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic mt2rem",
        style: {
            minHeight: '120px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "fs1rem c15",
            children: "Loading report\u2026"
        })
    });
    if (!data || !data.modules || data.modules.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic mt2rem",
        style: {
            minHeight: '120px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "fs1rem c15",
            children: "No module data available."
        })
    });
    const { modules: modules } = data;
    const directBucket = data['Direct Company'] || {};
    const indirectBucket = data['Indirect Company'] || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df aifs jcsb",
        style: {
            gap: '1rem',
            flexWrap: 'wrap'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$CompanyTable, {
                title: "Existing Client Companies",
                bucketData: indirectBucket,
                modules: modules,
                isDirectCompany: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a041eda37fb3d6a2$var$CompanyTable, {
                title: "Direct Companies",
                bucketData: directBucket,
                modules: modules,
                isDirectCompany: false
            })
        ]
    });
}


function $fcf5ff2cc42b8105$export$2e2bcd8739ae039({ profileClass: profileClass, advisors: advisors, setRefresh: setRefresh }) {
    const [step, setStep] = (0, $acw62.useState)("modules");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
        value: step,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                onChange: (_, value)=>setStep(value),
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    "& .MuiTabs-flexContainer": {
                        justifyContent: "center"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        className: "fs1rem fw600 mt1rem mb1rem",
                        label: "Modules",
                        value: "modules"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                        className: "fs1rem fw600 mt1rem mb1rem",
                        label: "Lead Metrics Report",
                        value: "reports"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                className: "w100",
                value: "modules",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($fcf5ff2cc42b8105$var$TempRevenueLeadsTable, {
                    profileClass: profileClass,
                    advisors: advisors,
                    setRefresh: setRefresh
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                className: "w100",
                value: "reports",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a041eda37fb3d6a2$export$2e2bcd8739ae039), {})
            })
        ]
    });
}

// ─── Allocation table (all logic lives here) ──────────────────────────────────
function $fcf5ff2cc42b8105$var$TempRevenueLeadsTable({ profileClass: profileClass, advisors: advisors, setRefresh: setRefresh }) {
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [allCompanies, setAllCompanies] = (0, $acw62.useState)([]);
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    // Flat list of all TempSections, each enriched with .allocation map
    const [sections, setSections] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    const [resendAdvisor, setResendAdvisor] = (0, $acw62.useState)({});
    // ─── Flatten companies (parent + children) ────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        if (!companies?.length) return;
        const seen = new Set();
        const flat = [];
        for (const comp of companies){
            const copy = {
                ...comp
            };
            delete copy.childrenCompanies;
            if (!seen.has(comp._id)) {
                flat.push(copy);
                seen.add(comp._id);
            }
            if (Array.isArray(comp.childrenCompanies)) for (const child of comp.childrenCompanies){
                const childCopy = {
                    ...child
                };
                delete childCopy.childrenCompanies;
                if (!seen.has(child._id)) {
                    flat.push(childCopy);
                    seen.add(child._id);
                }
            }
        }
        setAllCompanies(flat);
    }, [
        companies
    ]);
    // ─── Fetch all TempModules + Checklists with their sections ──────────────────
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/all-modules-section', 'not-showMessage').then((res)=>{
            if (res?.code === 200) {
                const body = res.body;
                const combined = Array.isArray(body) ? body : [
                    ...(body?.modules || []).filter((m)=>m.sections?.length > 0),
                    ...(body?.checklists || []).filter((m)=>m.sections?.length > 0).map((m)=>({
                            ...m,
                            isChecklist: true
                        }))
                ];
                setTempModules(combined);
            }
        }).finally(()=>setIsLoading(false));
    }, []);
    // ─── Build sections with allocation data from company.revenuelead ─────────────
    // Each section gets: { sectionNo, sectionName, moduleId, moduleName, moduleKey,
    //   allocation: { [companyId]: { [advisorId]: { ...advisor, allocationModule: { [sectionNo]: bool } } } } }
    (0, $acw62.useEffect)(()=>{
        if (!tempModules.length || !allCompanies.length) return;
        const flatSections = tempModules.flatMap((m)=>m.sections.map((s)=>({
                    ...s,
                    moduleId: m._id,
                    moduleName: m.moduleName,
                    moduleKey: m.moduleKey
                })));
        const sectionObj = JSON.parse(JSON.stringify(flatSections));
        for (const comp of allCompanies){
            if (!comp.revenuelead) continue;
            for (const advisorId of Object.keys(comp.revenuelead)){
                const advisorSettings = comp.revenuelead[advisorId];
                const advisor = advisors.find(({ _id: _id })=>_id == advisorId);
                if (!advisorSettings?.modules || !advisor) continue;
                for(let i = 0; i < sectionObj.length; i++){
                    if (!sectionObj[i].allocation) sectionObj[i].allocation = {};
                    if (!sectionObj[i].allocation[comp._id]) sectionObj[i].allocation[comp._id] = {};
                    sectionObj[i].allocation[comp._id][advisorId] = {
                        ...advisor,
                        allocationModule: advisorSettings.modules
                    };
                }
            }
        }
        setSections(sectionObj);
    }, [
        allCompanies,
        tempModules
    ]);
    const toggleAccordion = (moduleId)=>{
        setOpenAccordions((prev)=>({
                ...prev,
                [moduleId]: !prev[moduleId]
            }));
    };
    // Returns true if an advisor has all temp sections allocated for a given company
    const checkAdvisorHasAllAllocations = ({ advisor: advisor, company: comp })=>{
        if (advisor && comp?.revenuelead?.[advisor._id]?.modules) {
            const allTempSectionNos = sections.map((s)=>s.sectionNo);
            if (!allTempSectionNos.length) return false;
            const allocatedSections = Object.entries(comp.revenuelead[advisor._id].modules).filter(([, val])=>val === true).map(([key])=>key);
            return allTempSectionNos.every((no)=>allocatedSections.includes(no));
        }
        return false;
    };
    // Returns true if an advisor has the temp section permission (stored in company.advisors)
    const hasAdvisorPermission = (advisor, comp, sectionNo)=>{
        const userType = user.role === 'Advisor' ? 'advisors' : 'investors';
        return !!comp?.[userType]?.[advisor._id]?.modules?.[sectionNo];
    };
    // ─── Single-section allocation toggle ─────────────────────────────────────────
    const handleLeadAllocation = async (e, advisor, sectionNo, comp)=>{
        if (!advisor.emailVerified) {
            setResendAdvisor(advisor);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'resendInviteMail'
            }));
            return;
        }
        const status = e.target.checked;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/allocateRevenueLead/${comp._id}`, {
            advisor: advisor,
            company: comp,
            advisorId: advisor._id,
            sectionNo: sectionNo,
            status: status,
            firmId: user.companyId._id
        });
        if (res?.code === 200) {
            const newSections = sections.map((s)=>{
                if (s.sectionNo !== sectionNo || !s.allocation?.[comp._id]) return s;
                const updatedCompAlloc = {};
                Object.keys(s.allocation[comp._id]).forEach((advId)=>{
                    const advData = s.allocation[comp._id][advId];
                    updatedCompAlloc[advId] = {
                        ...advData,
                        allocationModule: {
                            ...advData.allocationModule || {},
                            [sectionNo]: advId === advisor._id ? status : false
                        }
                    };
                });
                return {
                    ...s,
                    allocation: {
                        ...s.allocation,
                        [comp._id]: updatedCompAlloc
                    }
                };
            });
            setSections(newSections);
            // Keep allCompanies in Redux in sync
            const updatedCompanies = allCompanies.map((item)=>{
                if (item._id !== comp._id) return item;
                const newRevenuelead = {
                    ...item.revenuelead || {}
                };
                newRevenuelead[advisor._id] = {
                    ...newRevenuelead[advisor._id],
                    modules: {
                        ...newRevenuelead[advisor._id]?.modules || {},
                        [sectionNo]: status
                    }
                };
                if (status) {
                    for(const id in newRevenuelead)if (id !== advisor._id && newRevenuelead[id]?.modules) newRevenuelead[id] = {
                        ...newRevenuelead[id],
                        modules: {
                            ...newRevenuelead[id].modules,
                            [sectionNo]: false
                        }
                    };
                }
                return {
                    ...item,
                    revenuelead: newRevenuelead
                };
            });
            dispatch((0, $b9bcf9787e5ad456$export$52d586c008658f4c)(updatedCompanies));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
            setRefresh((r)=>!r);
        }
    };
    // ─── Bulk-allocate all temp sections for an advisor on a company ──────────────
    const handleMultiLeadAllocation = async (e, advisor, sectionNos, comp)=>{
        if (!advisor.emailVerified) {
            setResendAdvisor(advisor);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'resendInviteMail'
            }));
            return;
        }
        const _checked = e.target.checked;
        const result = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/allocateMultiRevenueLead/${comp._id}`, {
            advisor: advisor,
            company: comp,
            advisorId: advisor._id,
            sectionNo: sectionNos,
            status: _checked,
            firmId: user.companyId._id
        });
        if (result?.code === 200) {
            const newSections = sections.map((s)=>{
                const compAlloc = s.allocation?.[comp._id] || {};
                let updatedCompAlloc;
                if (_checked) {
                    const existing = compAlloc[advisor._id] || {
                        ...advisor,
                        allocationModule: {}
                    };
                    updatedCompAlloc = {
                        ...compAlloc,
                        [advisor._id]: {
                            ...existing,
                            allocationModule: {
                                ...existing.allocationModule || {},
                                [s.sectionNo]: true
                            }
                        }
                    };
                    Object.keys(updatedCompAlloc).forEach((advId)=>{
                        if (advId !== advisor._id) {
                            const advData = updatedCompAlloc[advId];
                            updatedCompAlloc[advId] = {
                                ...advData,
                                allocationModule: {
                                    ...advData.allocationModule || {},
                                    [s.sectionNo]: false
                                }
                            };
                        }
                    });
                } else {
                    const existing = compAlloc[advisor._id];
                    updatedCompAlloc = existing ? {
                        ...compAlloc,
                        [advisor._id]: {
                            ...existing,
                            allocationModule: {
                                ...existing.allocationModule || {},
                                [s.sectionNo]: false
                            }
                        }
                    } : compAlloc;
                }
                return {
                    ...s,
                    allocation: {
                        ...s.allocation || {},
                        [comp._id]: updatedCompAlloc
                    }
                };
            });
            setSections(newSections);
            // Keep allCompanies in Redux in sync
            const currentModules = allCompanies.find((c)=>c._id === comp._id)?.revenuelead?.[advisor._id]?.modules || {};
            const newModules = {
                ...currentModules
            };
            sectionNos.forEach((sno)=>{
                newModules[sno] = _checked;
            });
            const updatedCompanies = allCompanies.map((item)=>{
                if (item._id !== comp._id) return item;
                const newRevenuelead = {
                    ...item.revenuelead || {}
                };
                newRevenuelead[advisor._id] = {
                    ...newRevenuelead[advisor._id],
                    modules: newModules
                };
                if (_checked) {
                    for(const id in newRevenuelead)if (id !== advisor._id && newRevenuelead[id]?.modules) {
                        const updatedMods = {
                            ...newRevenuelead[id].modules
                        };
                        sectionNos.forEach((sno)=>{
                            updatedMods[sno] = false;
                        });
                        newRevenuelead[id] = {
                            ...newRevenuelead[id],
                            modules: updatedMods
                        };
                    }
                }
                return {
                    ...item,
                    revenuelead: newRevenuelead
                };
            });
            dispatch((0, $b9bcf9787e5ad456$export$52d586c008658f4c)(updatedCompanies));
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(result.message);
        setRefresh((r)=>!r);
    };
    const onResendLinkModalClose = ()=>{
        setResendAdvisor({});
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const submitResendInvite = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/resendAdvisorInvite/${resendAdvisor._id}`);
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
            onResendLinkModalClose();
        }
    };
    // ─── Empty / loading states ───────────────────────────────────────────────────
    if (!allCompanies.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc c15 fs1-75rem fw500 lh2 mt2rem",
        children: "No clients added for allocation"
    });
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem pr",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "table-permission",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                id: "table-temp-revenue-allocation",
                className: "table-userPermissions table-clientPermissions",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        className: "ps t0",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "index-table"
                                }),
                                allCompanies.map((_, cIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "user-area",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "mr1rem wfull",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 110,
                                                        height: 22
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                        variant: "text",
                                                        width: 58,
                                                        height: 16
                                                    })
                                                ]
                                            })
                                        })
                                    }, `skel-rev-comp-${cIndex}`))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: [
                            1,
                            2,
                            3
                        ].map((mIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            background: '#f8f9fa'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                style: {
                                                    padding: '10px 12px',
                                                    paddingTop: mIdx > 1 ? '20px' : '10px',
                                                    borderTop: mIdx > 1 ? '1px solid #DBDFEE' : 'none'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    style: {
                                                        gap: '8px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                            variant: "rectangular",
                                                            width: 130 + mIdx * 25,
                                                            height: 18,
                                                            sx: {
                                                                borderRadius: '4px'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                            variant: "rectangular",
                                                            width: 48,
                                                            height: 18,
                                                            sx: {
                                                                borderRadius: '4px'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                            variant: "rectangular",
                                                            width: 72,
                                                            height: 16,
                                                            sx: {
                                                                borderRadius: '4px'
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            allCompanies.map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        background: '#f8f9fa',
                                                        borderTop: mIdx > 1 ? '1px solid #DBDFEE' : 'none'
                                                    }
                                                }, i))
                                        ]
                                    }),
                                    mIdx === 1 && [
                                        1,
                                        2,
                                        3
                                    ].map((sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    style: {
                                                        background: '#fafbfe',
                                                        padding: '8px 12px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        style: {
                                                            gap: '6px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                variant: "rectangular",
                                                                width: 58,
                                                                height: 14,
                                                                sx: {
                                                                    borderRadius: '3px'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                variant: "rectangular",
                                                                width: 90 + sIdx * 25,
                                                                height: 14,
                                                                sx: {
                                                                    borderRadius: '3px'
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                allCompanies.map((_, cIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "cp",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "w100 df jcsb aic bg1 p0-5rem br30px",
                                                            style: {
                                                                border: '1px solid #DBDFEE'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                    variant: "circular",
                                                                    width: 32,
                                                                    height: 32
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                                                    variant: "circular",
                                                                    width: 20,
                                                                    height: 20
                                                                })
                                                            ]
                                                        })
                                                    }, `skel-rev-sc-${cIdx}`))
                                            ]
                                        }, `skel-rev-s-${sIdx}`))
                                ]
                            }, `skel-rev-m-${mIdx}`))
                    })
                ]
            })
        })
    });
    if (!tempModules.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc c15 fs1-25rem fw500 lh2 mt2rem",
        children: "No modules available"
    });
    // Group sections back into per-module buckets for accordion rendering
    const sectionsByModule = tempModules.map((module)=>({
            module: module,
            moduleSections: sections.filter((s)=>String(s.moduleId) === String(module._id))
        })).filter(({ moduleSections: moduleSections })=>moduleSections.length > 0);
    const moduleItems = sectionsByModule.filter(({ module: module })=>!module.isChecklist);
    const checklistItems = sectionsByModule.filter(({ module: module })=>module.isChecklist);
    const allTempSectionNos = sections.map((s)=>s.sectionNo);
    const renderModuleGroup = (items)=>items.filter(({ module: module })=>module.isChecklist && ![
                'Exit Readiness',
                'Cyber DueDil',
                'Business For Sale'
            ].includes(module.moduleName) || !module.isChecklist).map(({ module: module, moduleSections: moduleSections }, mIdx)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        onClick: ()=>toggleAccordion(module._id),
                        style: {
                            background: '#f8f9fa',
                            cursor: 'pointer'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                style: {
                                    padding: '10px 12px',
                                    paddingTop: mIdx > 0 ? '20px' : '10px',
                                    borderTop: mIdx > 0 ? '1px solid #DBDFEE' : 'none'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcsb w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        style: {
                                            gap: '8px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fw600 c15 fs1rem",
                                                children: module.moduleName
                                            }),
                                            module.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs0-75rem c15 px0-5rem py0-25rem br5px",
                                                style: {
                                                    background: '#e9ecef',
                                                    opacity: 0.8
                                                },
                                                children: module.moduleKey
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs0-75rem",
                                                style: {
                                                    color: '#888'
                                                },
                                                children: [
                                                    "(",
                                                    moduleSections.length,
                                                    " section",
                                                    moduleSections.length !== 1 ? 's' : '',
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            allCompanies.map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                    style: {
                                        background: '#f8f9fa',
                                        borderTop: mIdx > 0 ? '1px solid #DBDFEE' : 'none'
                                    }
                                }, i))
                        ]
                    }),
                    openAccordions[module._id] && moduleSections.map((section, sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                    className: "c15 bg0",
                                    style: {
                                        background: '#fafbfe'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600 bg0",
                                            style: {
                                                marginRight: '4px'
                                            },
                                            children: section.sectionNo
                                        }),
                                        section.sectionName
                                    ]
                                }),
                                allCompanies.map((comp, cIdx)=>{
                                    console.log(comp?.revenuelead, "comp");
                                    const isIRSection = section.moduleName === 'Investment Readiness';
                                    const sectionModule = isIRSection ? tempModules.find((m)=>String(m._id) === String(section.moduleId)) : null;
                                    const companyInIRModule = sectionModule?.companies ? String(comp._id) in sectionModule.companies : false;
                                    const companyInChecklist = module.isChecklist ? module.companies ? String(comp._id) in module.companies : false : true;
                                    const isDisabled = isIRSection && !companyInIRModule || module.isChecklist && !companyInChecklist;
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "c15 cp",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100 df jcsb bg1 p0-5rem br30px",
                                            style: {
                                                border: '1px solid #DBDFEE'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df",
                                                    children: !isDisabled && advisors.filter((advisor)=>comp?.revenuelead?.[advisor._id]?.modules?.[section.sectionNo] === true).map((advisor, keyIndex)=>{
                                                        const tooltip = advisor.firstName ? `${advisor.firstName} ${advisor.lastName}` : 'Register to show your name here';
                                                        return advisor?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: advisor.profile,
                                                            style: {
                                                                border: '4px solid #09b255',
                                                                cursor: 'pointer'
                                                            },
                                                            className: `w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                            "data-tooltip": tooltip,
                                                            alt: "",
                                                            onClick: ()=>handleLeadAllocation({
                                                                    target: {
                                                                        checked: false
                                                                    }
                                                                }, advisor, section.sectionNo, comp)
                                                        }, `${keyIndex}-rev-av`) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                border: '4px solid #09b255',
                                                                cursor: 'pointer'
                                                            },
                                                            "data-tooltip": tooltip,
                                                            className: `w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`,
                                                            onClick: ()=>handleLeadAllocation({
                                                                    target: {
                                                                        checked: false
                                                                    }
                                                                }, advisor, section.sectionNo, comp),
                                                            children: advisor.firstName ? `${advisor.firstName[0]}${advisor.lastName[0]}` : '?'
                                                        }, `${keyIndex}-rev-av-init`);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                        multiple: true,
                                                        disabled: isDisabled,
                                                        className: "select-advisor w10",
                                                        id: `rev-section-select-${comp._id}-${section.sectionNo}`,
                                                        sx: {
                                                            "& .MuiSvgIcon-root": {
                                                                color: "#4A67FF"
                                                            }
                                                        },
                                                        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                        value: [],
                                                        MenuProps: {
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 300,
                                                                    width: 'auto',
                                                                    minWidth: '200px'
                                                                }
                                                            },
                                                            anchorOrigin: {
                                                                vertical: 'bottom',
                                                                horizontal: 'left'
                                                            },
                                                            transformOrigin: {
                                                                vertical: 'top',
                                                                horizontal: 'left'
                                                            },
                                                            getContentAnchorEl: null,
                                                            keepMounted: true,
                                                            marginThreshold: 10,
                                                            style: {
                                                                WebkitTransform: 'none',
                                                                position: 'fixed'
                                                            }
                                                        },
                                                        children: advisors.map((advisor, adIdx)=>{
                                                            const isValid = (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor);
                                                            const isAllocated = comp?.revenuelead?.[advisor._id]?.modules?.[section.sectionNo] === true;
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                value: advisor._id,
                                                                className: "select-advisor-list ttc",
                                                                disabled: !isValid,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                        checked: isAllocated,
                                                                        disabled: !isValid,
                                                                        onChange: ()=>handleLeadAllocation({
                                                                                target: {
                                                                                    checked: !isAllocated
                                                                                }
                                                                            }, advisor, section.sectionNo, comp)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                        primary: `${advisor.firstName} ${advisor.lastName} - ${advisor.title || advisor.designation || advisor.job || ''}`
                                                                    })
                                                                ]
                                                            }, `rev-${section.sectionNo}-${comp._id}-${adIdx}`);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }, `${cIdx}-rev-${section.sectionNo}-${sIdx}`);
                                })
                            ]
                        }, section.sectionNo))
                ]
            }, module._id);
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem pr",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "table-permission",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    id: "table-temp-revenue-allocation",
                    className: "table-userPermissions table-clientPermissions",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                            className: "ps t0",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        className: "index-table"
                                    }),
                                    allCompanies.map((comp, cIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "user-area",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mr1rem wfull pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "di fs1rem c0",
                                                            children: comp.cName
                                                        }),
                                                        comp.subscription ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "c7 di ml0-5rem",
                                                            children: [
                                                                "(",
                                                                comp.subscription?.toUpperCase(),
                                                                ")"
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c8 di ml0-5rem",
                                                            children: "(INACTIVE)"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                multiple: true,
                                                                className: "select-advisor w10 pa",
                                                                id: `bulk-rev-select-${cIndex}`,
                                                                sx: {
                                                                    "& .MuiSvgIcon-root": {
                                                                        color: "#4A67FF"
                                                                    }
                                                                },
                                                                IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))),
                                                                value: [],
                                                                MenuProps: {
                                                                    anchorOrigin: {
                                                                        vertical: 'bottom',
                                                                        horizontal: 'right'
                                                                    },
                                                                    transformOrigin: {
                                                                        vertical: 'top',
                                                                        horizontal: 'right'
                                                                    }
                                                                },
                                                                children: advisors.map((advisor, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                        value: advisor,
                                                                        className: "select-advisor-list ttc",
                                                                        disabled: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor) ? 'disable-advisor-checkbox' : '',
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                    disabled: !(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(advisor),
                                                                                    checked: checkAdvisorHasAllAllocations({
                                                                                        advisor: advisor,
                                                                                        company: comp
                                                                                    }),
                                                                                    onClick: (e)=>handleMultiLeadAllocation(e, advisor, allTempSectionNos, comp)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                primary: `${advisor.firstName} ${advisor.lastName} - ${advisor.title || advisor.designation || advisor.job || ''}`
                                                                            })
                                                                        ]
                                                                    }, `${cIndex}-bulk-rev-${idx}`))
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }, `temp-rev-comp-${cIndex}`))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                            children: [
                                moduleItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                colSpan: allCompanies.length + 1,
                                                style: {
                                                    padding: '16px 0 8px',
                                                    borderBottom: '2px solid #4A67FF'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 c3 fs1-25rem",
                                                    children: "Modules"
                                                })
                                            })
                                        }),
                                        renderModuleGroup(moduleItems)
                                    ]
                                }),
                                checklistItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                colSpan: allCompanies.length + 1,
                                                style: {
                                                    padding: '16px 0 8px',
                                                    borderBottom: '2px solid #4A67FF',
                                                    paddingTop: moduleItems.length > 0 ? '32px' : '16px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 c3 fs1-25rem",
                                                    children: "Checklists"
                                                })
                                            })
                                        }),
                                        renderModuleGroup(checklistItems)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal?.open === 'resendInviteMail',
                onClose: onResendLinkModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: onResendLinkModalClose,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu pt1rem",
                            children: "Resend Invite"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs1rem py1rem tac",
                                    children: [
                                        "Advisor ",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fw600 ttc",
                                            children: [
                                                resendAdvisor.firstName,
                                                " ",
                                                resendAdvisor.lastName
                                            ]
                                        }),
                                        " is currently",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600 ttc",
                                            children: " Inactive"
                                        }),
                                        ". Please send ",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fw600 ttc",
                                            children: [
                                                resendAdvisor.firstName,
                                                " ",
                                                resendAdvisor.lastName
                                            ]
                                        }),
                                        " an invitation link to activate their account, enabling you to allocate them to any department"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsa",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: onResendLinkModalClose,
                                            className: "w30 shadow bg4 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: submitResendInvite,
                                            className: "w30 shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Send"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");













function $b4a76053fe526664$export$2e2bcd8739ae039({ plan: plan, companyId: companyId, company: company }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [cardId, setCardId] = (0, $acw62.useState)();
    let [loading, setLoading] = (0, $acw62.useState)(false);
    let [isRemoveCard, setIsRemoveCard] = (0, $acw62.useState)(false);
    let [removeCardDetails, setRemoveCardDetails] = (0, $acw62.useState)({});
    let [stripePromise] = (0, $acw62.useState)((0, $26c5d94e8cfa4743$export$de80f7562c3fd6b1)((0, $6a6b4b5ab5be324d$export$bc0b79747356381c)));
    const Checkout = ()=>{
        const stripe = (0, $7bf3b98cbc00db03$exports.useStripe)();
        const elements = (0, $7bf3b98cbc00db03$exports.useElements)();
        const handleRemoveCard = async ()=>{
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/payment/removeCard', {
                cardId: removeCardDetails?.['id']
            });
            if (response && response['code'] == 200) {
                let user = response?.['body']?.['user'];
                dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
                setIsRemoveCard(false);
                setRemoveCardDetails({});
            }
        };
        const handleSubmit = async (event)=>{
            try {
                const { error: error, paymentMethod: paymentMethod } = await stripe.createPaymentMethod({
                    type: "card",
                    card: elements.getElement((0, $7bf3b98cbc00db03$exports.CardElement))
                });
                if (error) return console.log(error['message']);
                let promoCode = document.getElementById('promoCode2')?.value;
                submitPayment(event, paymentMethod['id'], promoCode, 'promoCode2');
            } catch (e) {
                console.log('*******e = ', e);
            }
        };
        const submitPayment = async (event, paymentId, promoCode, type)=>{
            try {
                if (!promoCode && type != 'promoCode2') promoCode = document.getElementById('promoCode1')?.value;
                setLoading(true);
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/stripeSubscription/${companyId}`, {
                    methodId: paymentId,
                    packageName: plan,
                    promoCode: promoCode
                });
                setLoading(false);
                if (!response || response['code'] != 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                if (response['body']['alreadyActivated']) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    setTimeout(()=>location.href = (0, $16250bd714b02a14$export$240514314008da16).replace(":id", companyId), 2500);
                    return;
                }
                if (plan !== 'Free') {
                    const confirmPayment = await stripe?.confirmCardPayment(response['body']['clientSecret']);
                    if (confirmPayment['error']) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(confirmPayment?.['error']?.['message']);
                    else if (confirmPayment?.['paymentIntent']?.['status'] == 'succeeded') {
                        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Subscription has been activated!');
                        setTimeout(()=>location.href = (0, $16250bd714b02a14$export$240514314008da16).replace(":id", companyId), 2500);
                    }
                // TODO: Mark Payment as done once payment is approved
                } else setTimeout(()=>location.href = (0, $16250bd714b02a14$export$240514314008da16).replace(":id", companyId), 2500);
            } catch (e) {
                console.log('*******e = ', e);
            }
        };
        // ***************** APPROVED DEVELOPMENT PARTNER - Access Code *****************
        const subscriptionWithAccessCode = async ()=>{
            try {
                const accessCode = document.getElementById('access-code')?.['value'];
                if (!accessCode) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide a valid Access Code');
                setLoading(true);
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/subscriptionWithAccessCode/${companyId}`, {
                    packageName: plan,
                    accessCode: accessCode
                });
                setLoading(false);
                if (!response || response['code'] != 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                if (response['body']['alreadyActivated']) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    const role = company?.creatorId?.role?.toLowerCase();
                    const redirectUrl = role === "advisor" ? "/advisor-dashboard" : role === "user" ? "/dashboard" : (0, $16250bd714b02a14$export$240514314008da16).replace(":id", companyId);
                    setTimeout(()=>{
                        location.href = redirectUrl;
                    }, 2500);
                    return;
                }
                if (plan !== 'Free' && response['message'] === 'Subscription is added!') {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Subscription has been activated!');
                    setTimeout(()=>location.href = (0, $16250bd714b02a14$export$240514314008da16).replace(":id", companyId), 2500);
                } else setTimeout(()=>location.href = (0, $16250bd714b02a14$export$240514314008da16).replace(":id", companyId), 2500);
            } catch (e) {
                console.log('*******e = ', e);
            }
        };
        // ===================================================================================
        const CARD_ELEMENT_OPTIONS = {
            style: {
                base: {
                    color: "#32325d",
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "24px",
                    "::placeholder": {
                        color: "#aab7c4"
                    }
                },
                invalid: {
                    color: "#fa755a",
                    iconColor: "#fa755a"
                }
            }
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'subscriptionPayment',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore payment-modal",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "poppins-font-style mah100 bg20 shadow w100 px4rem py3rem df fdc m1rem pr br10px pr",
                                style: {
                                    outline: 'none',
                                    zoom: '0.9',
                                    maxWidth: '1350px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "w100 tac c15 fs1-75rem fw500",
                                        children: "Payment"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                        className: "w100 tac c3 fs1-25rem fw500 mb2rem",
                                        children: "2 Ways to Subscribe"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fww jcc w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "left-area w50 mr3rem bg1 new-shadow br45px",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "header-modal",
                                                        style: {
                                                            backgroundImage: `url(${(parcelRequire("ipdtS"))})`
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "number-header",
                                                            children: "1"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "body-modal pr px3rem py2rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "heading-area tal",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                        className: "c15 fs1-25rem fw600",
                                                                        children: "Make Payment"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                                        className: "c15 fs1rem op0.2 mb1rem fw400",
                                                                        style: {
                                                                            color: '#15131380'
                                                                        },
                                                                        children: [
                                                                            "Subscribe to the ",
                                                                            plan,
                                                                            " yearly plan - \xa3",
                                                                            plan === "Lite" ? 60 : plan === "Pro" ? 600 : 0
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            user?.['stripeMethods']?.length > 0 && user?.['stripeMethods']?.filter((method)=>!method['isExpired'])?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    user?.['stripeMethods']?.filter((method)=>!method['isExpired'])?.map(({ card: card, id: id })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "bg1 c6 br10px px1rem py0-5rem my0-5rem fw500 cp fs1-25rem bsbb df w70 new-shadow mb2rem",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "px1rem df aic",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        className: "h4rem",
                                                                                        src: (parcelRequire("fumV1")),
                                                                                        alt: card['brand']
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "w100",
                                                                                    children: [
                                                                                        setCardId(id),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df jcsb",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                    children: [
                                                                                                        "**** **** **** ",
                                                                                                        card['last4']
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    style: {
                                                                                                        backgroundColor: 'transparent'
                                                                                                    },
                                                                                                    onClick: ()=>{
                                                                                                        setIsRemoveCard(true), setRemoveCardDetails({
                                                                                                            card: card,
                                                                                                            id: id
                                                                                                        });
                                                                                                    },
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        "data-tooltip": "Remove Card",
                                                                                                        className: "fa fa-trash c9 cp",
                                                                                                        style: {
                                                                                                            fontSize: '20px'
                                                                                                        }
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df fdc",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                    className: "ass",
                                                                                                    children: [
                                                                                                        card['brand']?.toUpperCase(),
                                                                                                        " Card"
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                                    className: "ass",
                                                                                                    children: [
                                                                                                        "Expiry: ",
                                                                                                        card['exp_month'],
                                                                                                        "/",
                                                                                                        card['exp_year']
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }, id)),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                        className: "w100 c15 db mt1rem",
                                                                        for: "promoCode",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fw600",
                                                                                children: "Promo Code?"
                                                                            }),
                                                                            " Add to get discount"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        id: "promoCode1",
                                                                        placeholder: "Please insert code here",
                                                                        className: "w50 br8px p1rem mt1rem",
                                                                        type: "text"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        disabled: loading,
                                                                        onClick: (event)=>submitPayment(event, cardId),
                                                                        className: "mt2rem shadow bg4 bg3-hover c1 td250 br35px p1rem fw600 cp ttu w70 bsbb tac df jcc aic mla mra",
                                                                        children: "Buy now"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 w100 tac mt1rem fs0-75rem",
                                                                        style: {
                                                                            color: '#15131360'
                                                                        },
                                                                        children: "Diligentsia does NOT store your credit card information"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 w100 tac mt1rem fs0-75rem",
                                                                        style: {
                                                                            color: '#151313'
                                                                        },
                                                                        children: "Powered by Stripe"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.CardElement), {
                                                                        options: CARD_ELEMENT_OPTIONS
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                        className: "w100 c15 db mt1rem",
                                                                        for: "promoCode",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fw600",
                                                                                children: "Promo Code?"
                                                                            }),
                                                                            " Add to get discount"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        id: "promoCode2",
                                                                        placeholder: "Please insert code here",
                                                                        className: "w50 br8px p1rem mt1rem",
                                                                        type: "text"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        disabled: !stripe || !elements,
                                                                        onClick: ()=>handleSubmit(),
                                                                        className: "mt2rem shadow bg4 bg3-hover c1 td250 br35px p1rem fw600 cp ttu w70 bsbb tac df jcc aic mla mra",
                                                                        children: "Buy now"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 w100 tac mt1rem fs0-75rem",
                                                                        style: {
                                                                            color: '#15131360'
                                                                        },
                                                                        children: "Diligentsia does NOT store your credit card information"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15 w100 tac mt1rem fs0-75rem",
                                                                        style: {
                                                                            color: '#151313'
                                                                        },
                                                                        children: "Powered by Stripe"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "right-area w40 ml2rem bg1 new-shadow br45px",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "header-modal",
                                                        style: {
                                                            backgroundImage: `url(${(parcelRequire("O2jJL"))})`
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "number-header",
                                                            children: "2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "body-modal pr px2rem py2rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "heading-area tal",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                        className: "c15 fs1-25rem fw600",
                                                                        children: "Need a discount code? Just ask."
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "c15 fs1rem op0.2 mb1rem fw400",
                                                                        style: {
                                                                            color: '#15131390'
                                                                        },
                                                                        children: "If you have a discount code for any Diligentsia subscription, enter it here"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "access-code",
                                                                placeholder: "Access Code",
                                                                className: "w100 br8px p1rem mt1rem access-code bg1",
                                                                type: "text"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                disabled: !stripe || !elements,
                                                                onClick: ()=>subscriptionWithAccessCode(),
                                                                className: "mt2rem shadow bg4 bg3-hover c1 td250 br35px p1rem fw600 cp ttu w70 bsbb tac df jcc aic mla mra",
                                                                children: "Use My Discount Code"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "c15 w100 tac mt1rem fs0-75rem",
                                                                style: {
                                                                    color: '#15131360'
                                                                },
                                                                children: "No credit card required"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                class: "df jcc",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    className: "df cp btn-call-book br35px px2rem py0-5rem tal mt2rem",
                                                                    onClick: ()=>window.open('https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true', '_blank'),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                "Want a discount code? ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                    children: "Book a Call"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "icon mx1rem mt0-5rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                width: "29",
                                                                                height: "29",
                                                                                viewBox: "0 0 29 29",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M26.001 1.60077H23.5012C23.5014 1.37729 23.456 1.15637 23.3681 0.952061C23.2802 0.747981 23.1516 0.564939 22.9908 0.414859C22.83 0.26478 22.6405 0.150934 22.4343 0.0808038C22.2282 0.0106732 22.0102 -0.0141053 21.7941 0.0076352C21.4023 0.0576617 21.0423 0.254961 20.7833 0.561432C20.5243 0.868136 20.3846 1.2625 20.3912 1.66879V2.40072C20.391 2.76774 20.5134 3.12354 20.7379 3.4085C20.9623 3.6937 21.2751 3.89077 21.6238 3.96674C21.7235 3.98614 21.8121 4.04482 21.8702 4.13038C21.9286 4.21617 21.952 4.3216 21.9357 4.42493C21.9193 4.52802 21.8643 4.62036 21.7828 4.68254C21.701 4.74449 21.599 4.77137 21.4984 4.75711C20.9678 4.64958 20.4898 4.35597 20.1459 3.9263C19.8022 3.49663 19.6141 2.95733 19.6137 2.40072V1.60077H15.2827C15.2807 1.38874 15.238 1.17952 15.1569 0.984788C15.0758 0.790059 14.9579 0.613797 14.8103 0.466289C14.6624 0.318781 14.4877 0.203065 14.2962 0.125454C14.1045 0.0480767 13.8998 0.01044 13.694 0.0148816C13.4882 0.019557 13.2854 0.0660766 13.0971 0.15187C12.909 0.237663 12.7391 0.361093 12.5975 0.514913C12.456 0.668732 12.3456 0.849903 12.2727 1.0479C12.1998 1.24614 12.1657 1.457 12.1725 1.66879V2.40072C12.1723 2.76774 12.2948 3.12354 12.5192 3.4085C12.7436 3.6937 13.0564 3.89077 13.4051 3.96674C13.5048 3.98614 13.5934 4.04482 13.6515 4.13038C13.7099 4.21617 13.7333 4.3216 13.717 4.42493C13.7006 4.52802 13.6456 4.62036 13.5641 4.68254C13.4823 4.74449 13.3803 4.77137 13.2797 4.75711C12.7491 4.64958 12.2711 4.35597 11.9274 3.9263C11.5835 3.49663 11.3954 2.95733 11.395 2.40072V1.60077H8.89515C8.27684 1.60194 7.68419 1.85511 7.24692 2.30511C6.80987 2.75488 6.56364 3.36478 6.5625 4.0011V6.22962H28.3337V4.0011C28.3326 3.36478 28.0866 2.75488 27.6493 2.30511C27.212 1.85511 26.6194 1.60194 26.001 1.60077ZM12.9501 1.60077C12.953 1.39038 13.0364 1.19004 13.1818 1.04253C13.3274 0.895021 13.5234 0.812267 13.7276 0.812267C13.9319 0.812267 14.1279 0.895021 14.2733 1.04253C14.4189 1.19004 14.502 1.39061 14.5052 1.60077H12.9501ZM21.1688 1.60077C21.1717 1.39038 21.2549 1.19004 21.4005 1.04253C21.5459 0.895021 21.7419 0.812267 21.9463 0.812267C22.1505 0.812267 22.3466 0.895021 22.492 1.04253C22.6376 1.19004 22.7207 1.39061 22.7237 1.60077H21.1688Z",
                                                                                        fill: "url(#paint0_linear_3405_45)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M6.5625 12.6308C6.67475 12.8524 7.49059 14.1643 7.56027 14.3619C7.80982 14.934 7.84671 15.5782 7.66432 16.1756C7.48194 16.7732 7.09258 17.2837 6.56774 17.6134C6.60485 18.2412 6.87718 18.8308 7.32915 19.2622C7.78113 19.6934 8.37861 19.9336 8.99954 19.9338H25.8969C26.5429 19.9329 27.1622 19.6726 27.619 19.2101C28.0757 18.7476 28.3328 18.1204 28.3337 17.4663V7.47461H6.5625V12.6308ZM23.5899 9.4266C23.7921 9.42937 23.9849 9.51261 24.127 9.65833C24.2689 9.80405 24.3486 10.0005 24.3486 10.2052C24.3486 10.41 24.2689 10.6064 24.1268 10.7521C23.9849 10.8981 23.7918 10.9813 23.5899 10.9841C23.3877 10.9813 23.1946 10.8979 23.0527 10.7521C22.9107 10.6064 22.8312 10.41 22.8312 10.2052C22.8312 10.0005 22.9107 9.80405 23.0527 9.65833C23.1948 9.51261 23.3877 9.42937 23.5899 9.4266ZM23.5899 12.9255C23.7918 12.9285 23.9847 13.0117 24.1266 13.1574C24.2686 13.3032 24.3481 13.4996 24.3481 13.7041C24.3481 13.9089 24.2686 14.1053 24.1266 14.251C23.9847 14.3967 23.7918 14.48 23.5899 14.483C23.3877 14.48 23.1948 14.3967 23.053 14.251C22.9111 14.1053 22.8314 13.9089 22.8314 13.7041C22.8314 13.4996 22.9111 13.3032 23.053 13.1574C23.1948 13.0117 23.3877 12.9285 23.5899 12.9255ZM23.5899 16.4244C23.7921 16.4271 23.9849 16.5104 24.127 16.6561C24.2689 16.8018 24.3486 16.9985 24.3486 17.2032C24.3486 17.4077 24.2689 17.6044 24.1268 17.7501C23.9849 17.8959 23.7918 17.9791 23.5899 17.9819C23.3877 17.9791 23.1946 17.8959 23.0527 17.7501C22.9107 17.6044 22.8312 17.4077 22.8312 17.203C22.8312 16.9985 22.9107 16.8018 23.0527 16.6561C23.1948 16.5104 23.3877 16.4271 23.5899 16.4244ZM17.4482 9.4266C17.6504 9.42937 17.8433 9.51261 17.9854 9.65833C18.1272 9.80405 18.2069 10.0005 18.2069 10.2052C18.2069 10.41 18.1272 10.6064 17.9854 10.7521C17.8433 10.8981 17.6504 10.9813 17.4482 10.9841C17.246 10.9813 17.0532 10.8981 16.9111 10.7521C16.769 10.6064 16.6895 10.41 16.6895 10.2052C16.6895 10.0005 16.769 9.80405 16.9111 9.65833C17.0532 9.51261 17.246 9.42937 17.4482 9.4266ZM17.4482 12.9255C17.6502 12.9285 17.843 13.0117 17.9851 13.1574C18.127 13.3032 18.2064 13.4996 18.2064 13.7041C18.2064 13.9089 18.127 14.1053 17.9851 14.251C17.843 14.3967 17.6502 14.48 17.4482 14.483C17.246 14.48 17.0532 14.3967 16.9113 14.251C16.7695 14.1053 16.6898 13.9089 16.6898 13.7041C16.6898 13.4996 16.7695 13.3032 16.9113 13.1574C17.0532 13.0117 17.246 12.9285 17.4482 12.9255ZM17.4482 16.4244C17.6504 16.4271 17.8433 16.5104 17.9854 16.6561C18.1272 16.8018 18.2069 16.9985 18.2069 17.2032C18.2069 17.4077 18.1272 17.6044 17.9854 17.7501C17.8433 17.8959 17.6504 17.9791 17.4482 17.9819C17.246 17.9791 17.0532 17.8959 16.9111 17.7501C16.769 17.6044 16.6895 17.4077 16.6895 17.203C16.6895 16.9985 16.769 16.8018 16.9111 16.6561C17.0532 16.5104 17.246 16.4271 17.4482 16.4244ZM11.3066 9.4266C11.5076 9.43099 11.6991 9.51491 11.8398 9.6604C11.9805 9.80612 12.0593 10.0016 12.0593 10.2052C12.0593 10.4091 11.9805 10.6046 11.8398 10.7501C11.6991 10.8958 11.5076 10.9797 11.3066 10.9841C11.1055 10.9797 10.914 10.8958 10.7733 10.7501C10.6326 10.6046 10.5538 10.4091 10.5538 10.2052C10.5538 10.0016 10.6326 9.80612 10.7733 9.6604C10.914 9.51491 11.1055 9.43099 11.3066 9.4266ZM11.3066 12.9255C11.5076 12.9299 11.6991 13.0138 11.8401 13.1593C11.9808 13.3048 12.0596 13.5005 12.0596 13.7041C12.0596 13.9079 11.9808 14.1035 11.8398 14.2492C11.6991 14.3947 11.5076 14.4786 11.3066 14.483C11.1053 14.4786 10.914 14.3947 10.7731 14.2492C10.6323 14.1035 10.5536 13.9079 10.5536 13.7041C10.5536 13.5005 10.6323 13.3048 10.7731 13.1593C10.914 13.0138 11.1055 12.9299 11.3066 12.9255ZM11.3066 16.4244C11.5076 16.4287 11.6991 16.5127 11.8401 16.6582C11.9808 16.8036 12.0596 16.9994 12.0596 17.2032C12.0596 17.4068 11.9808 17.6026 11.8398 17.7481C11.6991 17.8935 11.5076 17.9775 11.3066 17.9819C11.1053 17.9775 10.9138 17.8935 10.7731 17.7481C10.6323 17.6026 10.5536 17.4068 10.5536 17.203C10.5536 16.9994 10.6323 16.8036 10.7731 16.6582C10.9138 16.5127 11.1055 16.4287 11.3066 16.4244Z",
                                                                                        fill: "url(#paint1_linear_3405_45)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M16.0676 24.159L14.2179 23.076C14.0129 22.957 13.7823 22.8864 13.5444 22.8693C13.3067 22.8521 13.0679 22.8893 12.8474 22.9775C12.6266 23.066 12.4302 23.203 12.2735 23.3781C12.1169 23.5532 12.0045 23.7613 11.9449 23.9861C11.8808 24.1719 11.7748 24.3415 11.6347 24.4825C11.4943 24.6233 11.3237 24.7318 11.1348 24.8C10.9459 24.8684 10.7434 24.8944 10.5429 24.8768C10.342 24.8592 10.1481 24.798 9.97474 24.6977C8.79798 24.0148 7.71304 23.1916 6.74557 22.2474C5.77741 21.3077 4.93153 20.2559 4.22694 19.1155C4.12252 18.9412 4.06024 18.7461 4.04467 18.5449C4.0291 18.3437 4.06093 18.1416 4.13741 17.9541C4.21389 17.7665 4.33319 17.5983 4.48639 17.4621C4.63935 17.326 4.82231 17.2255 5.02107 17.1683C5.22784 17.1059 5.41836 17.0016 5.58071 16.8626C5.74306 16.7236 5.87336 16.5527 5.96312 16.3611C6.05288 16.1697 6.10006 15.9619 6.10166 15.7513C6.10326 15.541 6.05906 15.3325 5.97205 15.1398C6.01418 15.1567 4.80307 13.2242 4.78086 13.1774C4.57111 12.8408 4.23313 12.5986 3.84064 12.5033C3.44816 12.4081 3.03301 12.4676 2.68541 12.669C1.54711 13.3316 0.712229 14.3925 0.351804 15.6346C-0.00862084 16.8764 0.132662 18.2056 0.746804 19.3494C2.74311 23.0863 5.87381 26.1342 9.71369 28.0788C10.8893 28.6778 12.2559 28.8166 13.5336 28.4669C14.8112 28.1173 15.903 27.3052 16.5851 26.1975C16.7942 25.8604 16.8574 25.4563 16.7603 25.074C16.6632 24.6917 16.4141 24.3626 16.0676 24.159Z",
                                                                                        fill: "url(#paint2_linear_3405_45)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint0_linear_3405_45",
                                                                                                x1: "32.4702",
                                                                                                y1: "-4.43338",
                                                                                                x2: "27.7101",
                                                                                                y2: "14.5338",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#A0B0FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#4A67FF"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint1_linear_3405_45",
                                                                                                x1: "32.4703",
                                                                                                y1: "-1.39237",
                                                                                                x2: "16.3035",
                                                                                                y2: "30.8163",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#A0B0FF"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#4A67FF"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                id: "paint2_linear_3405_45",
                                                                                                x1: "17.6373",
                                                                                                y1: "-22.7695",
                                                                                                x2: "-8.63029",
                                                                                                y2: "108.388",
                                                                                                gradientUnits: "userSpaceOnUse",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        "stop-color": "#FFACB0"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                        offset: "1",
                                                                                                        "stop-color": "#FF3F7A"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "c4 fa fa-arrow-right",
                                                                            style: {
                                                                                fontSize: '20px'
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "pa cp",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                style: {
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    bottom: '22px'
                                },
                                width: "60",
                                height: "60",
                                viewBox: "0 0 60 60",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                        opacity: "0.8",
                                        x: "4",
                                        y: "4",
                                        width: "52",
                                        height: "52",
                                        rx: "26",
                                        fill: "#151313"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                        fill: "white"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: isRemoveCard,
                    onClose: ()=>{
                        setIsRemoveCard(false), setRemoveCardDetails({});
                    },
                    className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w60 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                "data-scroll-to": "actions",
                                className: "close-popup",
                                onClick: ()=>{
                                    setIsRemoveCard(false), setRemoveCardDetails({});
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                                children: "Remove Card"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem px2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mb1rem",
                                        children: "Are you sure you want to remove this card?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg5 c6 br10px px1rem py0-5rem fw500 cp fs1-25rem bsbb df asc w50 shadow mb2rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "px1rem df aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "h4rem",
                                                    src: (parcelRequire("fumV1")),
                                                    alt: removeCardDetails?.['card']?.['brand']
                                                })
                                            }),
                                            "**** **** **** ",
                                            removeCardDetails?.['card']?.['last4'],
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            removeCardDetails?.['card']?.['brand']?.toUpperCase(),
                                            " Card",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Expiry: ",
                                            removeCardDetails?.['card']?.['exp_month'],
                                            "/",
                                            removeCardDetails?.['card']?.['exp_year'],
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": "actions",
                                        onClick: ()=>handleRemoveCard(),
                                        className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w60 bsbb tac df jcc asc aic",
                                        children: "Yes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": "actions",
                                        onClick: ()=>{
                                            setIsRemoveCard(false), setRemoveCardDetails({});
                                        },
                                        className: "bg1 c3-hover td250 fs1-25rem cp",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7bf3b98cbc00db03$exports.Elements), {
        stripe: stripePromise,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Checkout, {})
    });
}





var $ayMG0 = parcelRequire("ayMG0");


const $c218604756c85649$var$InvestorMatchDisclaimer = ({ handleClose: handleClose })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: 'investorMatchDisclaimer',
        modalCardClasses: 'maw900px',
        onCloseHandler: handleClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "c15 tac fs1-5rem",
                    children: "Disclaimer"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        maxWidth: '80%',
                        margin: '1rem auto 2rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb1rem fs13px",
                            children: "Before You Continue:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600",
                                            children: "No investment advice. "
                                        }),
                                        "Diligentsia provides tools for companies to initiate matches with investors \u2014 not financial advice."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600",
                                            children: "No liaibility. "
                                        }),
                                        "Diligentsia is not liable for accuracy of information supplied by any party on the platform"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: [
                                        "Are you a",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600",
                                            children: " company? "
                                        }),
                                        " Always seek professional investment advice."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: [
                                        "Are you an",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600",
                                            children: " investor? "
                                        }),
                                        "Diligentsia\u2019s self-diligence info is company-created and unaudited. We\u2019re not liable for its content."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600",
                                            children: "No commsssion. "
                                        }),
                                        "Diligentsia is not paid by investors or third parties as part of the matching process."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: "No involvement post match."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "c15 tac",
                    children: "Happy with this?"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        style: {
                            width: '250px'
                        },
                        customClassName: "mt1rem",
                        text: 'Next',
                        onClick: handleClose,
                        btnType: "warning"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c15 fs11px ttj op60 mt1rem",
                    style: {
                        maxWidth: '80%',
                        margin: '1rem auto'
                    },
                    children: "InvestorMatch information on the Diligentsia Platform, supplied by an applicant company or an investor, has not been reviewed, approved, or endorsed by Diligentsia and may contain inaccuracies, omissions, or outdated information. The content is provided for general informational purposes only. It does not constitute investment advice, a financial promotion, or a recommendation, and should not be relied upon in connection with any investment decision. Diligentsia Limited is not authorised or regulated by the Financial Conduct Authority (FCA), and InvestorMatch is not regulated under the Financial Services and Markets Act 2000 (FSMA). No reliance should be placed on the accuracy or completeness of this information by any party, including companies seeking funding, advisors, or other event attendees. Neither Diligentsia Limited, its employees or agents accept any responsibility or liability for any loss or damage arising from use of or reliance on this feature. Users are strongly encouraged to conduct their own due diligence and verify all information received or provided."
                })
            ]
        })
    });
};
var $c218604756c85649$export$2e2bcd8739ae039 = $c218604756c85649$var$InvestorMatchDisclaimer;





var $a43cd440e32561dc$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 18c4.963 0 9-4.037 9-9s-4.037-9-9-9-9 4.037-9 9 4.037 9 9 9ZM9 1.8c3.97 0 7.2 3.23 7.2 7.2s-3.23 7.2-7.2 7.2S1.8 12.97 1.8 9 5.03 1.8 9 1.8Z",
                fill: "#59B8FD"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.697 11.579a.356.356 0 0 1-.35-.363c0-.473.065-.883.194-1.227.095-.26.248-.52.46-.785.155-.192.434-.473.837-.841.403-.369.664-.663.785-.882.122-.219.181-.458.181-.718 0-.47-.177-.881-.53-1.237a1.76 1.76 0 0 0-1.3-.533c-.495 0-.909.162-1.24.483-.243.236-.425.568-.546.996a.606.606 0 0 1-.653.447c-.371-.046-.616-.428-.51-.8.163-.574.437-1.036.82-1.386C7.375 4.244 8.08 4 8.954 4c.927 0 1.666.261 2.218.785.552.523.827 1.156.827 1.898 0 .43-.097.825-.29 1.187-.195.362-.574.802-1.139 1.32-.378.35-.627.607-.743.772a1.737 1.737 0 0 0-.259.57c-.041.16-.07.393-.085.7a.358.358 0 0 1-.351.346h-.436Zm-.414 1.733c0-.38.296-.687.662-.687.366 0 .663.308.663.688 0 .38-.297.687-.663.687a.675.675 0 0 1-.662-.688Z",
                fill: "#59B8FD",
                stroke: "#59B8FD",
                strokeWidth: ".5"
            })
        ]
    });
};
$a43cd440e32561dc$var$InfoIcon.defaultProps = {
    width: "18",
    height: "18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
// Co-branded partner destinations — shown on both the Advisor and Investor dashboards.
const $a43cd440e32561dc$var$PARTNER_TABS = [
    'Financial',
    'Technology'
];









































function $a43cd440e32561dc$export$2e2bcd8739ae039({ company: company, companyId: companyId, getQualifiedLeads: getQualifiedLeads, setQualifiedLeads: setQualifiedLeads, qualifiedLeads: qualifiedLeads, promptScore: promptScore, noClients: noClients, advisors: advisors, getAdvisors: getAdvisors, investors: investors, handleAddAdvisor: handleAddAdvisor, handleAdvisor: handleAdvisor, setSelectedData: setSelectedData, showEditButton: showEditButton, handleEditRoute: handleEditRoute, loading: loading, hasValidAdvisor: hasValidAdvisor, sectionsWithChecklist: sectionsWithChecklist, subTab: subTab, setSubTab: setSubTab, handleCompanyMember: handleCompanyMember, dashboardTab: dashboardTab, setDashboardTab: setDashboardTab, teamTab: teamTab, setTeamTab: setTeamTab }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    // Deal Room (Investor dashboard): false = left = VC, true = right = PE. Held in Redux because the
    // same switch is also surfaced in Investor Settings -> InvestorMatch Criteria -> Investor Details.
    const dealRoom = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.dealRoom?.isOn) || false;
    let [plan, setPlan] = (0, $acw62.useState)("Pro");
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    let [auditLogs, setAuditLogs] = (0, $acw62.useState)([]);
    let [selectedCompany, setSelectedCompany] = (0, $acw62.useState)({});
    let [selectedHowItWorks, setSelectedHowItWorks] = (0, $acw62.useState)({});
    let [profileClass, setProfileClass] = (0, $acw62.useState)("client-profile");
    const spinner = document.getElementById("e1jygW4piZH1");
    const HOW_TO_POPUPS = {
        'add-client': {
            howItWorks: {
                title: 'Simple onboarding ramp',
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3 mb1rem",
                        children: "Show value in minutes WITHOUT using client data"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                checkList: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "checklist-box df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c15 fs1-25rem",
                            children: "Start free. Prove fast. Upgrade only when your client clearly sees the impact."
                        })
                    })
                ],
                arrayImages: [
                    (parcelRequire("gB01D")),
                    (parcelRequire("MEFCn")),
                    (parcelRequire("1XVow"))
                ]
            }
        },
        'client-benchmarking': {
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Client Benchmarking"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                arrayImages: [
                    (parcelRequire("dIwiD")),
                    (parcelRequire("c2MyR")),
                    (parcelRequire("k52TY"))
                ]
            }
        },
        'team': {
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Add Team Member"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                checkList: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box df jcc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w3rem",
                                src: (parcelRequire("fjCti")),
                                alt: ""
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs1-25rem mx1rem",
                                children: "Chase your colleagues to get activated and to start creating value!"
                            })
                        ]
                    })
                ],
                arrayImages: [
                    (parcelRequire("X3AOK")),
                    (parcelRequire("e0CwZ")),
                    (parcelRequire("hgbtZ"))
                ]
            }
        },
        'revenue-lead': {
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Revenue Generation Leads"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                checkList: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Your cards served to your clients?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Your cards served to unaffiliated companies?*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("gBgEl")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "c12",
                                children: [
                                    "Other advisors\u2019 cards served to ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "your"
                                    }),
                                    " clients? No."
                                ]
                            })
                        ]
                    })
                ],
                arrayImages: [
                    (parcelRequire("dQ3j7")),
                    (parcelRequire("eE8nI")),
                    (parcelRequire("cQdyd"))
                ],
                bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "img-text df aic w90 mla mra br45px c12 tac jcc mt1rem",
                    children: "*= Companies subscribing to the platform directly i.e not through advisors. The more of your own clients you add, the more often your own business cards will be served by our algorithm to those unaffiliated companies. "
                })
            }
        },
        'qualified-leads': {
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "InvestorMatch"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                checkList: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Your cards served to your clients?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Your cards served to unaffiliated companies?*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("gBgEl")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "c12",
                                children: [
                                    "Other advisors\u2019 cards served to ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "your"
                                    }),
                                    " clients? No."
                                ]
                            })
                        ]
                    })
                ],
                arrayImages: [
                    (parcelRequire("h7BuI")),
                    (parcelRequire("fPw2G")),
                    (parcelRequire("iqLwx"))
                ],
                bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "img-text df jcc aic bg1 px1rem py0-5rem w80 mla mra br45px c12 fs1-25rem",
                    children: [
                        "To keep standards up, this module is only available to Diligentsia Gold certified companies ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "icon mx1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("93hnj")),
                                alt: ""
                            })
                        })
                    ]
                })
            }
        },
        'website-widget': {
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Investor Applicant Qualification Web Site Widget"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                arrayImages: [
                    (parcelRequire("DkP6I")),
                    (parcelRequire("5UoR7")),
                    (parcelRequire("as4ju"))
                ]
            }
        },
        'anylist-builder': {
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "AnyList Checklist Builder"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                checkList: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Quick and easy for you"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Quick and easy for your target user"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Reusable by the target company"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w1rem",
                                    src: (parcelRequire("fYwBE")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c12",
                                children: "Company gains value from completion - risks & recommendations"
                            })
                        ]
                    })
                ],
                arrayImages: [
                    (parcelRequire("fw9PN")),
                    (parcelRequire("6XakL")),
                    (parcelRequire("3vuqz"))
                ]
            }
        }
    };
    (0, $acw62.useEffect)(()=>{
        let isAnylistBuilder = localStorage.getItem('isAnylistBuilder');
        if (isAnylistBuilder) {
            setSubTab('AnyListBuilder');
            navigate(`/${user?.role?.toLowerCase()}-dashboard#index?AnyListBuilder`);
            localStorage.removeItem('isAnylistBuilder');
        }
        let isFitDiligence = localStorage.getItem('isFitDiligence');
        if (isFitDiligence) {
            setSubTab('QualifiedLeads');
            navigate(`/${user?.role?.toLowerCase()}-dashboard#index?QualifiedLeads`);
            localStorage.removeItem('isFitDiligence');
        }
        if (user?.role) setProfileClass(user["role"] == "Advisor" ? "advisor-profile" : user["role"] == "Investor" ? "investor-profile" : "client-profile");
    }, []);
    (0, $acw62.useEffect)(()=>{
        getAdvisors();
        if (user?.role) setProfileClass(user["role"] == "Advisor" ? "advisor-profile" : user["role"] == "Investor" ? "investor-profile" : "client-profile");
    }, [
        refresh
    ]);
    const saveInvestorMember = async (leadId, memberId)=>{
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/saveInvestorMember`, {
            leadId: leadId,
            memberId: memberId
        });
        if (response["code"] == 200 && response["body"]) getQualifiedLeads(user?.['companyId']?.['_id']);
    };
    const getAuditLogs = async (endpoint, id, subTab)=>{
        let data;
        if (subTab == "permissions") data = {
            endpoint: endpoint,
            firmId: id
        };
        else if (subTab == "allocation") data = {
            endpoint: endpoint,
            firmId: id
        };
        else if (subTab == "advisors") data = {
            endpoint: endpoint,
            userId: id
        };
        else data = {
            endpoint: endpoint
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/log", data);
        if (res["code"] == 200) {
            setAuditLogs(res["body"]);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "advisorAuditLogs"
            }));
        }
    };
    const handleHowItWorks = async (item)=>{
        await setSelectedHowItWorks(item);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'howItWorksModal'
        }));
    };
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedHowItWorks({});
    };
    const handleDisclaimerPopup = ()=>{
        if (subTab !== "QualifiedLeads") dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'investorMatchDisclaimer'
        }));
    };
    // This component is shared by the Advisor and Investor dashboards, so the partner tabs must be
    // gated on both. Only investors get the Deal Room toggle, and only its PE side (dealRoom = true)
    // opens the co-branded partner page — on VC, and for advisors, the tabs do nothing.
    const isInvestor = user["role"] === "Investor";
    // Deal Room exists on the investor dashboard only: ON = PE, OFF = VC. Advisors have no toggle,
    // so `isPE` is always false for them.
    const certifiiRoute = isInvestor ? $16250bd714b02a14$export$e571b1dcb5172d6f : $16250bd714b02a14$export$bd37f69dd4d7c31e;
    const vaultinumRoute = isInvestor ? $16250bd714b02a14$export$8f15a807ba2937ff : $16250bd714b02a14$export$d8a91f63c9f7c142;
    // The partner tabs always open their own co-branded page — the Deal Room switch no longer
    // redirects them. MorseBridge moved onto the "Deal Room" label itself (see below).
    // Same-tab navigation — each partner page carries its own back arrow.
    const openPartnerTab = (label)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            navigate(label === "Financial" ? certifiiRoute : vaultinumRoute);
        };
    // With Deal Room ON (PE), the label becomes the way into MorseBridge.
    const openMorsebridge = ()=>{
        if (dealRoom) navigate($16250bd714b02a14$export$3ef311402a6d1da9);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            spinner.classList.remove("op0"),
            user?.role && spinner.classList.add("op0"),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4a76053fe526664$export$2e2bcd8739ae039), {
                plan: plan,
                company: company,
                companyId: selectedCompany['_id']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pb2rem df fdc",
                children: [
                    user?.role && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                        wrapperClass: " tac",
                        heading: "",
                        subheading: user?.role?.toLowerCase() === "advisor" ? '' : subTab == "QualifiedLeads" ? '' : `${user["role"] == "Investor" ? "Portfolio" : subTab === 'RevenueLeadsAllocation' ? "Revenue Leads" : subTab === 'AnyListBuilder' ? "AnyList Builder" : subTab} Status`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc aic advisor-index mt1rem",
                        children: dashboardTab == 'Company' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                                value: subTab,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                                        onChange: (e, value)=>{
                                            setSubTab(value), navigate(`/${user?.role?.toLowerCase()}-dashboard#index?${value}`);
                                        },
                                        style: {
                                            visibility: user?.role ? "visible" : "hidden"
                                        },
                                        children: [
                                            user["role"] === "Investor" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                className: "fs1-25rem fw600 diligent-tab tabFont",
                                                value: "deal-management",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic cp diligent-tab-label",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "ml0-5rem fs1-25rem fw500",
                                                        style: {
                                                            fontWeight: 500
                                                        },
                                                        children: "Deal Management"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                className: "fs1-25rem fw600 tabFont",
                                                value: "Client",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic cp diligent-tab-label",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "ml0-5rem fs1-25rem",
                                                        style: {
                                                            fontWeight: 500
                                                        },
                                                        children: `${user["role"] == "Investor" ? "Portfolio" : "Clients"}`
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                onClick: ()=>companyId && navigate(`/company/${companyId}`),
                                                className: `fs1rem fw600 c3`,
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic cp diligent-tab-label",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "ml0-5rem fs1-25rem",
                                                        style: {
                                                            fontWeight: 500
                                                        },
                                                        children: "Your Firm"
                                                    })
                                                }),
                                                value: "your-firm"
                                            }),
                                            user["role"] === "Investor" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                className: "fs1-25rem fw600 diligent-tab tabFont",
                                                value: "QualifiedLeads",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic cp diligent-tab-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "ml0-5rem fw500 fs1-25rem",
                                                            children: "InvestorMatch"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "diligent-tab-icon",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                handleHowItWorks(HOW_TO_POPUPS['qualified-leads']);
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($a43cd440e32561dc$var$InfoIcon, {
                                                                fontSize: "small"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    handleDisclaimerPopup();
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                className: "diligent-tab fs1-25rem fw600 tabFont",
                                                value: "AnyListBuilder",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "diligent-tab-label df aic cp",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "ml0-5rem fs1-25rem fw500",
                                                            style: {
                                                                fontWeight: 500
                                                            },
                                                            children: "AnyList"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "diligent-tab-icon",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                handleHowItWorks(HOW_TO_POPUPS['anylist-builder']);
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($a43cd440e32561dc$var$InfoIcon, {
                                                                fontSize: "small"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            $a43cd440e32561dc$var$PARTNER_TABS.map((label)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                    value: `partner-${label}`,
                                                    className: "fs1-25rem fw600 tabFont",
                                                    style: {
                                                        opacity: 1
                                                    },
                                                    onClick: openPartnerTab(label),
                                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic diligent-tab-label cp",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "ml0-5rem fs1-25rem fw500",
                                                            children: label
                                                        })
                                                    })
                                                }, label))
                                        ]
                                    }),
                                    user["role"] === "Investor" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "deal-management",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fdd2214fcf12208$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "Client",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9c229359c25a0c6$export$2e2bcd8739ae039), {
                                            companies: companies,
                                            setSelectedCompany: setSelectedCompany,
                                            noClients: noClients,
                                            setPlan: setPlan,
                                            handleHowItWorks: handleHowItWorks,
                                            HOW_TO_POPUPS: HOW_TO_POPUPS
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "QualifiedLeads",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a11307d75d69df9b$export$2e2bcd8739ae039), {
                                            profileClass: profileClass,
                                            loading: loading,
                                            companies: companies,
                                            user: user,
                                            promptScore: promptScore,
                                            qualifiedLeads: qualifiedLeads,
                                            investors: investors,
                                            saveInvestorMember: saveInvestorMember,
                                            getQualifiedLeads: getQualifiedLeads,
                                            setQualifiedLeads: setQualifiedLeads,
                                            company: company
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "AnyListBuilder",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9dd3aa6d00e57e5$export$2e2bcd8739ae039), {
                                            company: company,
                                            companyId: companyId,
                                            profileClass: profileClass,
                                            companies: companies,
                                            user: user,
                                            advisors: investors,
                                            getAdvisors: getAdvisors,
                                            getAuditLogs: getAuditLogs,
                                            auditLogs: auditLogs,
                                            isLoading: loading
                                        })
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                                value: teamTab,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                                        onChange: (e, value)=>{
                                            setTeamTab(value), navigate(`/${user?.role?.toLowerCase()}-dashboard#index?${value}`);
                                        },
                                        style: {
                                            visibility: user?.role ? "visible" : "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                className: "fs1-25rem fw600 diligent-tab tabFont",
                                                style: {
                                                    fontWeight: 500,
                                                    textTransform: 'capitalize',
                                                    fontSize: '16px'
                                                },
                                                value: "Team",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic cp diligent-tab-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "ml0-5rem",
                                                            children: [
                                                                user["role"] === "Investor" ? "Investor" : "Advisor",
                                                                " Team"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "diligent-tab-icon",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                handleHowItWorks(HOW_TO_POPUPS['team']);
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($a43cd440e32561dc$var$InfoIcon, {
                                                                fontSize: "small"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                className: "fs1-25rem fw600 tabFont",
                                                value: "TempPermissions",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic cp diligent-tab-label",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "ml0-5rem fw500",
                                                        children: "Team Permissions"
                                                    })
                                                })
                                            }),
                                            user["role"] == "Advisor" && !user["createdBy"] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                                className: "fs1-25rem fw600 diligent-tab tabFont",
                                                value: "TempRevenueLeadsAllocation",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic cp diligent-tab-label",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "ml0-5rem",
                                                            children: "Revenue Leads"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "diligent-tab-icon",
                                                            onClick: ()=>handleHowItWorks(HOW_TO_POPUPS['revenue-lead']),
                                                            style: {
                                                                zIndex: '99'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($a43cd440e32561dc$var$InfoIcon, {})
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "Team",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$2e2bcd8739ae039), {
                                            profileClass: profileClass,
                                            companies: companies,
                                            user: user,
                                            team: user['role'] == 'Investor' ? investors : advisors,
                                            getAdvisors: getAdvisors,
                                            getAuditLogs: getAuditLogs,
                                            auditLogs: auditLogs,
                                            handleAddAdvisor: handleAddAdvisor,
                                            handleAdvisor: handleAdvisor,
                                            setSelectedData: setSelectedData,
                                            showEditButton: showEditButton,
                                            handleEditRoute: handleEditRoute,
                                            hasValidAdvisor: hasValidAdvisor,
                                            handleCompanyMember: handleCompanyMember
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "Permissions",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c05184d1bd921939$export$2e2bcd8739ae039), {
                                            setRefresh: setRefresh,
                                            profileClass: profileClass,
                                            companies: companies,
                                            user: user,
                                            advisors: user["role"] == "Advisor" ? advisors : investors,
                                            getAuditLogs: getAuditLogs,
                                            auditLogs: auditLogs,
                                            sectionsWithChecklist: sectionsWithChecklist,
                                            company: company,
                                            loading: loading
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "TempPermissions",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d7eaf16ec7726c0$export$2e2bcd8739ae039), {
                                            setRefresh: setRefresh,
                                            profileClass: profileClass,
                                            advisors: user["role"] == "Advisor" ? advisors : investors,
                                            company: company
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "RevenueLeadsAllocation",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56643b6434ce7da2$export$2e2bcd8739ae039), {
                                            setRefresh: setRefresh,
                                            getAdvisors: getAdvisors,
                                            profileClass: profileClass,
                                            companies: companies,
                                            user: user,
                                            advisors: user["role"] == "Advisor" ? advisors : investors,
                                            getAuditLogs: getAuditLogs,
                                            auditLogs: auditLogs,
                                            loading: loading
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                        className: "w100",
                                        value: "TempRevenueLeadsAllocation",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fcf5ff2cc42b8105$export$2e2bcd8739ae039), {
                                            setRefresh: setRefresh,
                                            profileClass: profileClass,
                                            advisors: user["role"] == "Advisor" ? advisors : investors
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c218604756c85649$export$2e2bcd8739ae039), {
                handleClose: onModalClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "advisorAuditLogs",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 bg1 shadow w100 bsbb df fdc m1rem maw700px br5px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: user['role'] == 'Investor' ? '#AAFED680' : '#FFF6A680',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Audit Logs"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "px3rem py2rem h50",
                            style: {
                                overflow: 'auto'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 fs1-25rem ttc",
                                            children: [
                                                "Super ",
                                                user['role'],
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fs0-75rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw500 mr0-5rem",
                                                    children: "Name : "
                                                }),
                                                " ",
                                                user?.['companyId']?.['creatorId'] && user['companyId']['creatorId']?.['firstName'] + " " + user['companyId']['creatorId']?.['lastName'] || '-'
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fs0-75rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw500 mr0-5rem",
                                                    children: "Email : "
                                                }),
                                                " ",
                                                user?.['companyId']?.['creatorId'] && user['companyId']['creatorId']?.['email'] || '-'
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fs0-75rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw500 mr0-5rem",
                                                    children: "Title : "
                                                }),
                                                " ",
                                                user?.['companyId']?.['creatorId'] && user['companyId']['creatorId']?.['title'] || '-'
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "ma oya dg gg0-5rem mb2rem w100",
                                    children: auditLogs && auditLogs.length > 0 && auditLogs.map((log)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df my0-5rem",
                                            children: [
                                                log?.["userId"]?.["profile"] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: `ass ml0-5rem br100 w2rem h2rem ${profileClass}`,
                                                    src: log?.["userId"]?.["profile"],
                                                    "data-tooltip": log?.["userId"]?.["firstName"] ? log?.["userId"]?.["firstName"] + " " + log?.["userId"]?.["lastName"] : "Register to show your name here"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem ${profileClass}`,
                                                    "data-tooltip": log?.["userId"]?.["firstName"] ? log?.["userId"]?.["firstName"] + " " + log?.["userId"]?.["lastName"] : "Register to show your name here",
                                                    children: [
                                                        log?.["userId"]?.["firstName"]?.[0] || "?",
                                                        " ",
                                                        log?.["userId"]?.["lastName"]?.[0] || "?"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fs0-75rem ml1rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: log["payload"]['hasBusinessCard'] ? "Business card interaction" : log["message"]
                                                                }),
                                                                " at",
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: new Date(log.timestamp).toLocaleString()
                                                                }),
                                                                " by",
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                    children: [
                                                                        log?.["userId"]?.["firstName"],
                                                                        " ",
                                                                        log?.["userId"]?.["lastName"]
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        log["payload"]?.["permissions"] && log["payload"]?.["action"] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fw500 fs1-25rem ttc",
                                                                    children: [
                                                                        user['role'],
                                                                        " ",
                                                                        log["payload"]["action"],
                                                                        ":"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Name : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["firstName"] && log["payload"]["firstName"] + " " + log["payload"]["lastName"]
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Email : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["email"] ? log["payload"]?.["email"] : "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Designation : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["designation"] ? log["payload"]?.["designation"] : "-"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        log["payload"]?.["sectionNo"] && log['endpoint']?.includes('advisorPermissions') && log["payload"]?.["advisor"] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fw500 fs1-25rem",
                                                                    children: [
                                                                        " Changes to ",
                                                                        `${user['role']}s`,
                                                                        " Permissions:"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: [
                                                                                user['role'],
                                                                                " : "
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["advisor"] && log["payload"]["advisor"]["firstName"] + " " + log["payload"]["advisor"]["lastName"]
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Designation : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["advisor"] ? log["payload"]?.["advisor"]["designation"] : "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Client : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["company"] ? log?.["payload"]?.["company"]["cName"] : "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: [
                                                                                "Permissions",
                                                                                " ",
                                                                                log["payload"]["status"] ? "Added" : "Removed",
                                                                                " ",
                                                                                ":",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        log["payload"]["sectionNo"]
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        log["payload"]?.["sectionNo"] && log['endpoint']?.includes('allocateRevenueLead') && log["payload"]?.["advisor"] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fw500 fs1-25rem",
                                                                    children: [
                                                                        " Changes to ",
                                                                        `${user['role']}s`,
                                                                        " Allocation:"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: [
                                                                                user['role'],
                                                                                " : "
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["advisor"] && log["payload"]["advisor"]["firstName"] + " " + log["payload"]["advisor"]["lastName"]
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Designation : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["advisor"] ? log["payload"]?.["advisor"]["designation"] : "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Client : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["company"] ? log?.["payload"]?.["company"]["cName"] : "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: [
                                                                                "Allocation",
                                                                                " ",
                                                                                log["payload"]["status"] ? "Added" : "Removed",
                                                                                " ",
                                                                                ":",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        log["payload"]["sectionNo"]
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        log["payload"]?.["hasBusinessCard"] && log['endpoint']?.includes('allocateRevenueLead') && log["payload"]?.["advisor"] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fw500 fs1-25rem",
                                                                    children: [
                                                                        " ",
                                                                        `Interaction with `,
                                                                        log?.["payload"]?.["advisor"] && log?.["payload"]?.["advisor"]?.["firstName"] + " " + log?.["payload"]?.["advisor"]?.["lastName"] + "" + `' s ` + log?.['payload']?.['clickedOn'] + " " + ` in `,
                                                                        "Business Card:"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Advisor Designation : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["advisor"] ? log["payload"]?.["advisor"]?.["designation"] : "-"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fs0-75rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 mr0-5rem",
                                                                            children: "Client : "
                                                                        }),
                                                                        " ",
                                                                        log?.["payload"]?.["company"] ? log?.["payload"]?.["company"]?.["cName"] : "-"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ""
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "howItWorksModal",
                open: modal['open'] == 'howItWorksModal',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        zoom: '0.9',
                        maxWidth: '1350px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "w100 tac c15 fs1-75rem fw500 mt1rem",
                                    children: selectedHowItWorks?.['howItWorks']?.['title'] || 'How does it work?'
                                }),
                                selectedHowItWorks?.['howItWorks']?.['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                    className: "w100 tac c15 fs1-25rem fw500 mb1rem",
                                    children: selectedHowItWorks?.['howItWorks']?.['subTitle']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-top-box df w100 jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedHowItWorks?.howItWorks?.stepImage,
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                                    children: selectedHowItWorks?.['howItWorks']?.['arrayImages'] && selectedHowItWorks?.['howItWorks']?.['arrayImages'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['howItWorks']?.['arrayImages'].map((image)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "step-img df jcc px1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: image,
                                                    alt: "ste image"
                                                })
                                            }))
                                    })
                                }),
                                selectedHowItWorks?.['howItWorks']?.['checkList'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb",
                                    children: selectedHowItWorks?.['howItWorks']?.['checkList'] && selectedHowItWorks?.['howItWorks']?.['checkList'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['howItWorks']?.['checkList'].map((array)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-inner w100 pr",
                                                children: array
                                            }))
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: selectedHowItWorks?.['howItWorks']?.['bottomSection'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem c12 mb1rem tac w100",
                                        children: selectedHowItWorks?.['howItWorks']?.['bottomSection']
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        children: selectedHowItWorks?.['howItWorks']?.['btnContent']
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}











const $0bc49bb66b774dc6$var$cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);
/** `#index?<value>` selects either a Company sub-tab or a Manage Team panel. */ const $0bc49bb66b774dc6$var$TEAM_HASH_PANELS = new Set([
    'Team',
    'Permissions',
    'RevenueLeadsAllocation',
    'TempPermissions',
    'TempRevenueLeadsAllocation'
]);
const $0bc49bb66b774dc6$var$COMPANY_HASH_SUBTABS = new Set([
    'Client',
    'your-firm',
    'QualifiedLeads',
    'AnyListBuilder',
    'deal-management'
]);
const $0bc49bb66b774dc6$export$4202723ba73439f5 = ({ color: color, onClick: onClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "48",
        height: "36",
        viewBox: "0 0 77 71",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "cp user-advisor-modal-icon",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M55.8372 3H14.1628C8.00093 3 3 7.992 3 14.1429V43.8571C3 50.008 8.00093 55 14.1628 55H55.8372C61.9991 55 67 50.008 67 43.8571V14.1429C67 7.992 61.9991 3 55.8372 3ZM62.5349 43.8571C62.5349 47.5417 59.5284 50.5429 55.8372 50.5429H14.1628C10.4716 50.5429 7.46512 47.5417 7.46512 43.8571V14.1429C7.46512 10.4583 10.4716 7.45714 14.1628 7.45714H55.8372C59.5284 7.45714 62.5349 10.4583 62.5349 14.1429V43.8571ZM32.0828 31.5257C33.4223 30.0697 34.2558 28.1383 34.2558 26.0286C34.2558 21.512 30.5944 17.8571 26.0698 17.8571C21.5451 17.8571 17.8837 21.512 17.8837 26.0286C17.8837 28.1383 18.7172 30.0697 20.0567 31.5257C18.0028 32.8331 16.3953 34.7943 15.5619 37.2011C15.1749 38.36 15.7702 39.6377 16.9609 40.024C18.1219 40.4103 19.4019 39.7863 19.7888 38.6274C20.7116 35.9829 23.2121 34.2 26.0698 34.2C28.9274 34.2 31.4577 35.9829 32.3507 38.6274C32.6781 39.5486 33.5414 40.1429 34.4642 40.1429C34.7023 40.1429 34.9405 40.1131 35.1786 40.024C36.3395 39.6377 36.9646 38.36 36.5777 37.2011C35.7442 34.7943 34.1367 32.8331 32.0828 31.5257ZM22.3488 26.0286C22.3488 23.9783 24.0158 22.3143 26.0698 22.3143C28.1237 22.3143 29.7907 23.9783 29.7907 26.0286C29.7907 28.0789 28.1237 29.7429 26.0698 29.7429C24.0158 29.7429 22.3488 28.0789 22.3488 26.0286ZM55.093 23.0571C55.093 24.2754 54.0809 25.2857 52.8605 25.2857H43.9302C42.7098 25.2857 41.6977 24.2754 41.6977 23.0571C41.6977 21.8389 42.7098 20.8286 43.9302 20.8286H52.8605C54.0809 20.8286 55.093 21.8389 55.093 23.0571ZM55.093 34.9429C55.093 36.1611 54.0809 37.1714 52.8605 37.1714H43.9302C42.7098 37.1714 41.6977 36.1611 41.6977 34.9429C41.6977 33.7246 42.7098 32.7143 43.9302 32.7143H52.8605C54.0809 32.7143 55.093 33.7246 55.093 34.9429Z",
                fill: "#151313"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "58",
                cy: "54",
                r: "14",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.7846 38.0391C50.4167 38.0391 43.5703 44.8855 43.5703 53.2533C43.5703 61.6212 50.4167 68.4676 58.7846 68.4676C67.1525 68.4676 73.9989 61.6212 73.9989 53.2533C73.9989 44.8855 67.1525 38.0391 58.7846 38.0391ZM65.3267 49.6019L58.3282 58.7305C58.0239 59.0348 57.5675 59.3391 57.111 59.3391C56.6546 59.3391 56.1982 59.1869 55.8939 58.7305L52.2425 54.0141C51.786 53.4055 51.786 52.3405 52.5467 51.8841C53.3075 51.4276 54.2203 51.4276 54.6767 52.1883L57.111 55.3833L62.8925 47.7762C63.3489 47.1676 64.4139 47.0155 65.0225 47.4719C65.7832 47.9283 65.7832 48.8412 65.3267 49.6019Z",
                fill: color ? color : "#505050"
            })
        ]
    });
};






function $0bc49bb66b774dc6$export$2e2bcd8739ae039({}) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let [isShowTeamTab, setIsShowTeamTab] = (0, $acw62.useState)(false);
    let [dashboardTab, setDashboardTab] = (0, $acw62.useState)('Company');
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let company = {
        ...selectedCompany
    };
    let [tab, setTab] = (0, $acw62.useState)('index');
    let [action, setAction] = (0, $acw62.useState)("add");
    let [advisors, setAdvisors] = (0, $acw62.useState)([]);
    let [subTab, setSubTab] = (0, $acw62.useState)('Client');
    const [teamTab, setTeamTab] = (0, $acw62.useState)('Team');
    let [loading, setLoading] = (0, $acw62.useState)(false);
    let [companyId, setCompanyId] = (0, $acw62.useState)('');
    let [investors, setInvestors] = (0, $acw62.useState)([]);
    let [noClients, setNoClients] = (0, $acw62.useState)(false);
    let [promptScore, setPromptScore] = (0, $acw62.useState)(0);
    let [selectAll, setSelectAll] = (0, $acw62.useState)(false);
    let [uploadImage, setUploadImage] = (0, $acw62.useState)("");
    let [permissions, setPermissions] = (0, $acw62.useState)({});
    let [selectedData, setSelectedData] = (0, $acw62.useState)('');
    let [hideUserIcon, setHideUserIcon] = (0, $acw62.useState)(false);
    let [qualifiedLeads, setQualifiedLeads] = (0, $acw62.useState)([]);
    let [updateType, setUpdateType] = (0, $acw62.useState)("profileImage");
    let [profileClass, setProfileClass] = (0, $acw62.useState)("client-profile");
    let [countCertificate, setCountCertificate] = (0, $acw62.useState)({
        None: 0,
        Bronze: 0,
        Silver: 0,
        Gold: 0
    });
    let [advisorData, setAdvisorData] = (0, $acw62.useState)({
        firstName: "",
        lastName: "",
        email: "",
        designation: "",
        phone: '',
        linkedIn: '',
        profile: ""
    });
    let [sections, setSections] = (0, $acw62.useState)([
        {
            sectionNo: "D001",
            sectionName: "Key Shareholder/Investor Documents"
        },
        {
            sectionNo: "D002",
            sectionName: "Commercial Activities"
        },
        {
            sectionNo: "D003",
            sectionName: "Legal"
        },
        {
            sectionNo: "D004",
            sectionName: "Property"
        },
        {
            sectionNo: "D005",
            sectionName: "Intellectual Property"
        },
        {
            sectionNo: "D006",
            sectionName: "Insurance"
        },
        {
            sectionNo: "D007",
            sectionName: "Corporate Structure"
        },
        {
            sectionNo: "D008",
            sectionName: "State Aid"
        },
        {
            sectionNo: "D009",
            sectionName: "Finance"
        },
        {
            sectionNo: "D010",
            sectionName: "General Data Protection Regulations (GDPR)"
        },
        {
            sectionNo: "D011",
            sectionName: "Shares & Share Options"
        },
        {
            sectionNo: "D012",
            sectionName: "Taxation"
        },
        {
            sectionNo: "D013",
            sectionName: "Social Media"
        },
        {
            sectionNo: "D014",
            sectionName: "Key People"
        },
        {
            sectionNo: "D015",
            sectionName: "Human Resources"
        },
        {
            sectionNo: "D016",
            sectionName: "Environmental, Social & Governmental (ESG)"
        },
        {
            sectionNo: "D017",
            sectionName: "Key Advisors - Engagement Letters & Corrrspondence"
        },
        {
            sectionNo: "D018",
            sectionName: "IT Systems"
        },
        {
            sectionNo: "D019",
            sectionName: "Regulatory"
        },
        {
            sectionNo: "D020",
            sectionName: "Standards"
        },
        {
            sectionNo: "DEPF006",
            sectionName: "Warranty Disclosure"
        },
        {
            sectionNo: "DEPF007",
            sectionName: "Directors Questionnaire"
        },
        {
            sectionNo: "DEPF008",
            sectionName: "InvestorMatch"
        },
        {
            sectionNo: "IR",
            sectionName: "Investment Readiness"
        }
    ]);
    const handleNavigationTab = ()=>{
        if (dashboardTab == 'Team') {
            setSubTab('Client');
            setDashboardTab('Company');
        } else {
            setTeamTab('Team');
            setDashboardTab('Team');
        }
    };
    const spinner = document.getElementById("e1jygW4piZH1");
    function hasAllPermissions(companySections, userPermission) {
        return companySections.every((section)=>userPermission[section.sectionNo]);
    }
    (0, $acw62.useEffect)(()=>{
        const urlParams = new URLSearchParams(location?.search);
        const token = urlParams.get('token');
        if (token) {
            (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(token);
            localStorage.setItem('token', token);
            (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/user').then((response)=>{
                if (response['code'] == 200 && response['body']) {
                    dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(response['body']['user']));
                    if (!response['body']['user']?.['isPasswordSet']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'setPasswordPopup'
                    }));
                }
            });
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (advisorData && advisorData?.permissions && company && company['memberPermissions']) setSelectAll(hasAllPermissions(company?.['sections'], advisorData?.permissions));
    }, [
        advisorData,
        company
    ]);
    (0, $acw62.useEffect)(()=>{
        const applyHashToDashboard = ()=>{
            const raw = (window.location.hash || '').replace(/^#+/, '');
            if (!raw) {
                setTab('index');
                return;
            }
            let routePart = raw;
            let queryPart = '';
            const qIdx = raw.indexOf('?');
            if (qIdx >= 0) {
                routePart = raw.slice(0, qIdx);
                queryPart = raw.slice(qIdx + 1);
            }
            setTab(routePart || 'index');
            if (routePart === 'index' && queryPart) {
                if ($0bc49bb66b774dc6$var$TEAM_HASH_PANELS.has(queryPart)) {
                    setDashboardTab('Team');
                    setTeamTab(queryPart);
                } else if ($0bc49bb66b774dc6$var$COMPANY_HASH_SUBTABS.has(queryPart)) {
                    setDashboardTab('Company');
                    setSubTab(queryPart);
                } else {
                    setDashboardTab('Company');
                    setSubTab('Client');
                }
            }
        };
        applyHashToDashboard();
        window.addEventListener('hashchange', applyHashToDashboard);
        let isWorkflowOpen = localStorage.getItem('isWorkflowOpen');
        if (isWorkflowOpen) {
            setTab('your-firm');
            localStorage.removeItem('isWorkflowOpen');
        }
        let isManualAdd = localStorage.getItem('isManualAdd');
        if (isManualAdd) localStorage.removeItem('isManualAdd');
        return ()=>window.removeEventListener('hashchange', applyHashToDashboard);
    }, []);
    (0, $acw62.useEffect)(()=>{
        getAdvisors();
        getCompanies();
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        if (user?.role) setProfileClass(user["role"] == "Advisor" ? "advisor-profile" : user["role"] == "Investor" ? "investor-profile" : "client-profile");
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (user && user?.['companyId']?.['_id']) {
            getQualifiedLeads(user?.['companyId']?.['_id']);
            setCompanyId(user?.['companyId']?.['_id']);
            getCompany(user?.['companyId']?.['_id']);
        }
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        if (companies.length > 0) {
            const initialCount = {
                None: 0,
                Bronze: 0,
                Silver: 0,
                Gold: 0
            };
            companies.forEach((company)=>{
                if (company?.cLevel) initialCount[company.cLevel] = (initialCount[company.cLevel] || 0) + 1;
            });
            setCountCertificate(initialCount); // Set fresh count to avoid double values
        }
    }, [
        companies
    ]);
    const getCompany = async (id)=>{
        setLoading(true);
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${id}`);
        if (res['code'] == 200) {
            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(res['body']));
            // Filter out DEPF005, DEPN004
            const excludeSections = [
                'DEPF005',
                'DEPN004'
            ];
            const filteredSections = res['body']['sections'].filter((section)=>!excludeSections.includes(section.sectionNo));
            const additionalSections = [
                {
                    sectionNo: "IR",
                    sectionName: "Investment Readiness"
                }
            ];
            // Only add if not already present
            const existingSectionNos = filteredSections.map((s)=>s.sectionNo);
            const newSections = additionalSections.filter((s)=>!existingSectionNos.includes(s.sectionNo));
            // Add extra modules (ABF, BFS, CDD, EHE, etc.) - same as Team Permissions tab
            const extraModules = res['body']['extraModules']?.length ? res['body']['extraModules'].map((mod)=>({
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.id,
                    sectionName: mod.moduleName
                })) : [];
            // Add generate checklist modules (investor checklist modules) - same as Team Permissions tab
            const generateChecklistModules = res['body']['generateChecklistModules']?.length ? res['body']['generateChecklistModules'].map((mod)=>({
                    checklistModule: true,
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.moduleKey,
                    sectionName: mod.moduleName
                })) : [];
            setSections([
                ...filteredSections,
                ...newSections,
                ...extraModules,
                ...generateChecklistModules
            ]);
        }
        setLoading(false);
    };
    const getCompanies = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/my-profile`);
        if (response["body"]) {
            let { user: user, companies: companies } = response["body"];
            let groups = companies.filter(({ group: group })=>group == "Parent");
            let standard = companies.filter(({ group: group })=>group != "Parent");
            companies = groups.concat(standard);
            if (companies.length == 0) setNoClients(true);
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
            dispatch((0, $b9bcf9787e5ad456$export$2102c8f11f9a72ed)(companies));
        }
    };
    const getAdvisors = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/getAdvisor`);
        if (response["code"] == 200 && response["body"]) {
            setAdvisors(response["body"]["advisors"]);
            setInvestors(response["body"]["investors"]);
        }
    };
    const getQualifiedLeads = async (investorId, query)=>{
        let endpoint = `/company/getQualifiedLeads/${investorId}`;
        if (query) endpoint = `${endpoint}/?${query}`;
        setLoading(true);
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(endpoint);
        if (response["code"] == 200 && response["body"]) {
            setPromptScore(response['body']['promptScore']);
            setQualifiedLeads(response['body']['qualifiedLeads']);
            dispatch((0, $defbea5c5b83142b$export$4833f4501cec619d)({
                totalPages: response['body']['totalPages']
            }));
        }
        setLoading(false);
    };
    const handleAddAdvisor = async ()=>{
        await setAction("add");
        await setPermissions({});
        await setUpdateType('profileImage');
        await setAdvisorData({
            firstName: "",
            lastName: "",
            email: "",
            designation: "",
            phone: '',
            linkedIn: '',
            profile: ""
        });
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "teamPopup"
        }));
    };
    const handleAdvisor = async (advisor, action)=>{
        if (advisor) {
            setAdvisorData({
                firstName: advisor["firstName"],
                lastName: advisor["lastName"],
                email: advisor["email"],
                designation: advisor["designation"],
                isDisable: user?._id === advisor?._id ? false : true,
                isSuperUser: user?.["createdBy"] ? false : true,
                phone: advisor["phone"] && advisor["phone"] !== undefined && advisor["phone"] !== 'undefined' ? advisor["phone"] : '+44',
                linkedIn: advisor["linkedIn"] ? advisor["linkedIn"] : '',
                profile: advisor["profile"] ? advisor["profile"] : ''
            });
            if (advisor["permissions"]) {
                setPermissions(advisor["permissions"]);
                setSelectAll(sections.map((sec)=>sec.sectionNo).every((section)=>advisor["permissions"][section]));
            }
        }
        setAction(action);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "teamPopup"
        }));
    };
    const handleCompanyMember = async (data, action)=>{
        setAction(action);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "teamPopup"
        }));
    };
    const updateProfile = async ()=>{
        let attachment = [];
        if ($0bc49bb66b774dc6$var$cropper.current && uploadImage) {
            setLoading(true);
            let imageToUpload = $0bc49bb66b774dc6$var$cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile image", {
                type: "image/png"
            });
            attachment.push(coverFile);
            if (updateType == 'profileImage') {
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/upload/advisor/profile`, {
                    attachment: attachment
                });
                if (response || response["code"] == 200) setAdvisorData({
                    ...advisorData,
                    profile: response?.message
                });
                else setLoading(false);
            }
            if (updateType == 'companyLogo') {
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateLogo/${companyId}`, {
                    attachment: attachment
                });
                if (response || response["code"] == 200) await getCompany(companyId);
            }
            setUploadImage('');
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
            if (updateType == 'profileImage') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "teamPopup"
            }));
            setLoading(false);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    const handleUploadImage = async (e)=>{
        let profile = e.target.files[0];
        if (profile && profile.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        profile = await URL.createObjectURL(profile);
        setUploadImage(profile);
    };
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        setSelectAll(false);
        setLoading(false);
        setAdvisorData({
            firstName: "",
            lastName: "",
            email: "",
            designation: "",
            phone: '',
            linkedIn: '',
            profile: ""
        });
        setHideUserIcon(false);
    };
    const onEditClick = (advisor)=>{
        if (advisor?.['editRoute'] === 'current-loggedIn') navigate($16250bd714b02a14$export$91c3232a793620f2);
        else handleAdvisor(advisor, "edit"), setHideUserIcon(true);
    };
    const showEditButton = (advisor)=>{
        if (user?.["createdBy"] && advisor?._id === user?._id) return true;
        if (!user?.["createdBy"]) return true;
        else return false;
    };
    const handleEditRoute = (advisor)=>{
        if (user?.["createdBy"] && advisor?._id === user?._id) return "current-loggedIn";
        if (!user?.["createdBy"] && advisor?._id === user?._id) return "current-loggedIn";
        if (!user?.["createdBy"] && advisor?._id !== user?._id) return 'edit-modal';
        else return "edit-modal";
    };
    const cancelUpdateProfile = ()=>{
        setUploadImage("");
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
        if (updateType == 'profileImage') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "teamPopup"
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            spinner.classList.remove("op0"),
            user?.role && spinner.classList.add("op0"),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                value: tab,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dashboard-container pt1rem df fdc poppins-font-style * ",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `pr w100 mt0rem mb0rem px2rem py0-5rem topbar-shadow`,
                                style: {
                                    backgroundColor: user['role'] == 'Advisor' ? '#fff6a680' : '#aafed680',
                                    borderRadius: '1rem 1rem 0 0'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dg gtcr2 jcsb aic top-admin-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "left-area",
                                            children: user['role'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                className: "c27 df aic lisn",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: `${tab !== `index` && 'fw600'} ttc fs14px c27`,
                                                        children: tab == 'index' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                user['role'] == 'Investor' ? 'Portfolio' : 'Client',
                                                                " Index"
                                                            ]
                                                        }) : tab.replaceAll('-', ' ')
                                                    }),
                                                    user['role'] !== 'Advisor' && tab == `index` && user['role'] !== 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                className: "fs14px c27",
                                                                children: "/"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                className: "fs14px fw600 c27",
                                                                children: user["role"] == "Advisor" ? `Client` : "Investor"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                className: "c27 df aic lisn",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "fs14px c27",
                                                        children: "View"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "fs14px c27",
                                                        children: "/Tab"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: `ttc fs14px c27`,
                                                        children: "/Index"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "right-area df jcfe",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "ass df",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fs1rem aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "mr1rem tar df fdc",
                                                            children: [
                                                                user?.['firstName'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c15 ase",
                                                                    children: user?.['firstName'] + " " + (user?.['lastName'] ?? "")
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c15 ase",
                                                                    children: "Name"
                                                                }),
                                                                user?.['companyId']?.['creatorId']?.['_id'] == user['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: `c3 fs0-75rem ase`,
                                                                    children: "Admin"
                                                                })
                                                            ]
                                                        }),
                                                        user?.['firstName'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`,
                                                            children: user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: user?.['profile'],
                                                                className: `w40px h40px df jcc aic br100`,
                                                                "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ?? "")
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `w30px h30px df jcc aic br100`,
                                                                "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ?? ""),
                                                                children: user?.['firstName'] ? user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "") : "?"
                                                            })
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`,
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `w30px h30px df jcc aic br100`,
                                                                children: "?"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `pr w100 mt0rem mb1rem`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `${tab == `index` && "client-tab"} bg1 new-shadow br20px pt2rem pb2rem px3rem mb0rem pr`,
                                    style: {
                                        borderRadius: '0 0 1rem 1rem '
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fww company-details-area",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "left-company-area w33",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df ",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "new-shadow bw0px bss br10px bsbb w6rem h6rem center-logo-area tac df aic jcc pr",
                                                                style: {
                                                                    borderColor: '#E3E3E3'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: company?.["logo"],
                                                                        className: "w100 cp br10px h100 ofc"
                                                                    }),
                                                                    user['role'] != 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "input-file",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "add-btn bg5",
                                                                            onClick: ()=>{
                                                                                setUpdateType('companyLogo'), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                    open: "uploadProfile"
                                                                                })), setUploadImage("");
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                viewBox: "0 0 487 487",
                                                                                className: "zi3",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z                   M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9                   v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z                   M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z                   M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "ml1rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                        target: "_blank",
                                                                        href: user?.["companyId"]?.["cWebsite"],
                                                                        className: "fs1-5rem fw500 c15",
                                                                        children: user?.["companyId"]?.["cName"] || 'Company Name'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "ass fs1rem my0-5rem c15",
                                                                        children: [
                                                                            "Company Number: ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fw600",
                                                                                children: user?.["companyId"]?.['ukRegNo'] || '-'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "ass fs1rem my0-5rem c15",
                                                                        children: [
                                                                            "Subscription: ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fw600 c7 mra tal",
                                                                                children: "Portfolio PRO"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "center-logo-area w33 df jcc fww fdc mla mra pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "company-name",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                            className: "c15 fs2rem tac w100 fw500 mb2rem",
                                                            children: [
                                                                user['role'] == 'Investor' ? 'Portfolio' : 'Client',
                                                                " Index"
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "right-certificate-area w33 df jce",
                                                    children: tab == 'index' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "certficate-area bg19 px1rem py0-5rem br10px w100",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "c15 fs1rem mb0-5rem",
                                                                    children: user['role'] == 'Advisor' ? 'Number of Clients' : 'Portfolio'
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic jcsb",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aic",
                                                                            style: {
                                                                                width: '110px'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "img-box tal w100",
                                                                                    style: {
                                                                                        maxHeight: '48px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        style: {
                                                                                            maxWidth: '46px',
                                                                                            maxHeight: '52px'
                                                                                        },
                                                                                        src: (parcelRequire("fwl3g")),
                                                                                        alt: "TODO"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "text-box w100",
                                                                                    style: {
                                                                                        marginLeft: '0.5rem'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                                            className: "fw500 c15 fs12px",
                                                                                            children: countCertificate['None']
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                            className: "fs12px c32",
                                                                                            children: "None"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aic",
                                                                            style: {
                                                                                width: '110px',
                                                                                marginLeft: '0.5rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "img-box tal w100",
                                                                                    style: {
                                                                                        maxHeight: '48px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        style: {
                                                                                            maxWidth: '46px',
                                                                                            maxHeight: '52px'
                                                                                        },
                                                                                        src: (parcelRequire("8QnGH")),
                                                                                        alt: "TODO"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "text-box w100",
                                                                                    style: {
                                                                                        marginLeft: '0.5rem'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                                            className: "fw500 c15 fs12px",
                                                                                            children: countCertificate['Bronze']
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                            className: "fs12px c32",
                                                                                            children: "Bronze"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aic",
                                                                            style: {
                                                                                width: '110px',
                                                                                marginLeft: '0.5rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "img-box tal w100",
                                                                                    style: {
                                                                                        maxHeight: '48px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        style: {
                                                                                            maxWidth: '46px',
                                                                                            maxHeight: '52px'
                                                                                        },
                                                                                        src: (parcelRequire("kmrMT")),
                                                                                        alt: "TODO"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "text-box w100",
                                                                                    style: {
                                                                                        marginLeft: '0.5rem'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                                            className: "fw500 c15 fs12px",
                                                                                            children: countCertificate['Silver']
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                            className: "fs12px c32",
                                                                                            children: "Silver"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "certficate-box df bg1 br8px bss bw1px bo31 bsbb p0-5rem mb0-5rem aic",
                                                                            style: {
                                                                                width: '110px',
                                                                                marginLeft: '0.5rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "img-box tal w100",
                                                                                    style: {
                                                                                        maxHeight: '48px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        style: {
                                                                                            maxWidth: '46px',
                                                                                            maxHeight: '52px'
                                                                                        },
                                                                                        src: (parcelRequire("1LLUk")),
                                                                                        alt: "TODO"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "text-box w100",
                                                                                    style: {
                                                                                        marginLeft: '0.5rem'
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                                            className: "fw500 c15 fs12px",
                                                                                            children: countCertificate['Gold']
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                            className: "fs12px c32",
                                                                                            children: "Gold"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "user-area bg19 br30px  mt2rem df aic",
                                            style: {
                                                padding: '0.25rem'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w100 df aic jcsb",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "user-advisor df aic",
                                                        children: [
                                                            user['role'] == 'Advisor' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fs0-75rem",
                                                                children: advisors && advisors.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: advisors?.sort((a, b)=>{
                                                                        const aCond = user?.companyId?.creatorId?._id?.toString() === a?._id?.toString();
                                                                        const bCond = user?.companyId?.creatorId?._id?.toString() === b?._id?.toString();
                                                                        return bCond - aCond;
                                                                    }).map((advisor)=>{
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "pr df bg1 br50px mr0-5rem bw2px bss bsbb aic",
                                                                            style: {
                                                                                borderColor: '#DBDFEE',
                                                                                padding: '0.25rem 1rem 0.25rem 0.5rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    "data-tooltip": advisor['designation'] ? advisor['designation'].toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase()) : user?.['companyId']?.['creatorId']?.['_id'] == advisor?.['_id'] ? "Admin" : "??",
                                                                                    className: `w30px h30px df jcc aic br100 bg4 c1 mr0-5rem ${user['_id'] == advisor['_id'] && ' bw3px bss bo7'}`,
                                                                                    children: advisor?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        src: advisor?.['profile'],
                                                                                        className: `w30px h30px df jcc aic br100 bg4 c1 ${user['_id'] == advisor['_id'] && ' bw3px bss bo7'}`,
                                                                                        "data-tooltip": advisor['designation'] ? advisor['designation'] : "??"
                                                                                    }) : advisor['firstName'] ? advisor['firstName']?.[0] + (advisor['lastName'] ? advisor['lastName']?.[0] : "") : "??"
                                                                                }, advisor['_id']),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "c15 ttc",
                                                                                    children: [
                                                                                        advisor['firstName'] ? advisor['firstName'] + " " + (advisor?.['lastName'] ?? "") : "??",
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                        user?.['companyId']?.['creatorId']?.['_id'] == advisor?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "c4 fs0-75rem",
                                                                                            children: "Admin"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        });
                                                                    })
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df bg1 br100 bw2px bss p0-5rem bsbb",
                                                                    style: {
                                                                        borderColor: '#DBDFEE'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        "data-tooltip": "Register to show your name here",
                                                                        className: `w40px h40px df jcc aic br100 bg4 c1 mr0-5rem`,
                                                                        children: "??"
                                                                    })
                                                                })
                                                            }),
                                                            user['role'] == 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fs0-75rem",
                                                                children: investors && investors.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: investors?.sort((a, b)=>{
                                                                        const aCond = user?.companyId?.creatorId?._id?.toString() === a?._id?.toString();
                                                                        const bCond = user?.companyId?.creatorId?._id?.toString() === b?._id?.toString();
                                                                        return bCond - aCond;
                                                                    }).map((investor)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic",
                                                                            style: {
                                                                                borderColor: '#DBDFEE',
                                                                                paddingRight: '1rem'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    "data-tooltip": investor['designation'] ? investor['designation'] : "??",
                                                                                    className: `w30px h30px df jcc aic br100 bg4 c1 mr0-5rem ${user['_id'] == investor['_id'] && ' bw3px bss bo7'}`,
                                                                                    children: investor?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        src: investor?.['profile'],
                                                                                        className: "w40px h40px df jcc aic br100 bg4 c1",
                                                                                        "data-tooltip": investor['designation'] ? investor['designation'] : "??"
                                                                                    }) : investor['firstName'] ? investor['firstName']?.[0] + (investor['lastName'] ? investor['lastName']?.[0] : "") : "??"
                                                                                }, investor['_id']),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: "c15",
                                                                                    children: [
                                                                                        investor['firstName'] ? investor['firstName'] + " " + (investor?.['lastName'] ?? "") : "??",
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                        user?.['companyId']?.['creatorId']?.['_id'] == investor?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "c4 fs0-75rem",
                                                                                            children: "Admin"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }))
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df bg1 br100 bw2px bss p0-5rem bsbb",
                                                                    style: {
                                                                        borderColor: '#DBDFEE'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        "data-tooltip": "Register to show your name here",
                                                                        className: `w40px h40px df jcc aic br100 bg4 c1 mr0-5rem`,
                                                                        children: "??"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "fs1rem fw600 c1 bg3 br20px df aic jcc px1rem tac cp",
                                                        style: {
                                                            height: '34px'
                                                        },
                                                        onClick: handleNavigationTab,
                                                        children: dashboardTab == 'Team' ? 'Company Dashboard' : 'Manage Team'
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `dahboard-tabs ${user['role'] == 'Investor' ? 'investor-bg' : 'advisor-bg'}`,
                        style: {
                            width: '93%',
                            margin: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                className: "w100",
                                value: "index",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a43cd440e32561dc$export$2e2bcd8739ae039), {
                                    dashboardTab: dashboardTab,
                                    setDashboardTab: setDashboardTab,
                                    sectionsWithChecklist: sections,
                                    company: company,
                                    companyId: companyId,
                                    qualifiedLeads: qualifiedLeads,
                                    promptScore: promptScore,
                                    noClients: noClients,
                                    advisors: advisors,
                                    getAdvisors: getAdvisors,
                                    investors: investors,
                                    getQualifiedLeads: getQualifiedLeads,
                                    setQualifiedLeads: setQualifiedLeads,
                                    handleAddAdvisor: handleAddAdvisor,
                                    handleAdvisor: handleAdvisor,
                                    setSelectedData: setSelectedData,
                                    showEditButton: showEditButton,
                                    loading: loading,
                                    handleEditRoute: handleEditRoute,
                                    hasValidAdvisor: (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d),
                                    subTab: subTab,
                                    setSubTab: setSubTab,
                                    teamTab: teamTab,
                                    setTeamTab: setTeamTab,
                                    handleCompanyMember: handleCompanyMember
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                className: "w100 your-firm",
                                value: "your-firm",
                                children: "Your Firm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                className: "w100 free-tools",
                                value: "free-tools",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b425c760e007b312$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "howItsWorks",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic poppins-font-style *",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah80 bg1 shadow w100 p3rem bsbb df fdc m1rem maw70 pr pt3rem br15px pr poppins-font-style *  ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "content-area",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "title-area df aic mb2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon mr2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                width: "65",
                                                height: "65",
                                                viewBox: "0 0 65 65",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                        "clip-path": "url(#clip0_2711_6886)",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M55.3081 16.9844H34.8101C32.9936 16.9867 31.5217 18.4586 31.5195 20.2749V48.879C31.5277 49.4272 31.9786 49.8649 32.5267 49.8568C32.7459 49.8535 32.9579 49.7778 33.1296 49.6414L39.9276 44.0622H55.3081C57.1241 44.0614 58.5965 42.5902 58.5987 40.7742V20.2749C58.5964 18.4586 57.1245 16.9865 55.3081 16.9844ZM56.6284 40.7744C56.6268 41.5025 56.0362 42.0919 55.308 42.0919H39.5754C39.3474 42.0924 39.1265 42.1714 38.9498 42.3154L33.4898 46.7963V20.2749C33.4905 19.5458 34.081 18.9547 34.8101 18.9533H55.3081C56.0372 18.9549 56.6277 19.546 56.6285 20.2749L56.6284 40.7744Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M45.0595 22.8477C42.6548 22.8507 40.7062 24.7993 40.7031 27.204C40.7031 27.7478 41.1439 28.1886 41.6877 28.1886C42.2314 28.1886 42.6721 27.7478 42.6721 27.204C42.7034 25.8858 43.7975 24.8428 45.1157 24.8741C46.3897 24.9045 47.4153 25.93 47.4456 27.204C47.4456 28.1045 47.0475 28.435 46.2201 29.0362C44.8828 29.7902 44.0607 31.2114 44.0738 32.7467C44.0746 33.2904 44.516 33.7306 45.0596 33.7298C45.6022 33.729 46.042 33.2894 46.0428 32.7467C46.0428 31.601 46.575 31.2151 47.3794 30.6301C50.9962 28.6109 49.4538 22.8842 45.0595 22.8477Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M44.3569 36.7748C43.9857 37.1762 44.0102 37.8025 44.4116 38.1736C44.7909 38.5243 45.3763 38.5243 45.7557 38.1736C46.1269 37.7721 46.1024 37.1459 45.7009 36.7748C45.3216 36.424 44.7362 36.424 44.3569 36.7748Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M26.3449 15.6714C26.856 15.8566 27.4206 15.5924 27.6059 15.0813C27.7912 14.5702 27.527 14.0056 27.0158 13.8202C27.004 13.8159 26.9921 13.8118 26.98 13.808C22.5891 12.4266 18.0369 11.6231 13.4384 11.418C12.8942 11.4313 12.4637 11.8833 12.4769 12.4275C12.4884 12.9039 12.8391 13.3036 13.3097 13.3774C17.7359 13.5738 22.1176 14.3449 26.3449 15.6714Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M13.3109 20.2751C17.8392 20.5015 22.3221 21.287 26.6575 22.6138C27.2034 22.6031 27.6373 22.1521 27.6266 21.6062C27.6186 21.1975 27.36 20.8358 26.9757 20.6963C22.5845 19.316 18.0324 18.5135 13.4341 18.3089C12.8898 18.2964 12.4385 18.7277 12.426 19.2719C12.4144 19.786 12.7995 20.2227 13.3109 20.2751Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M13.3115 27.1658C17.8439 27.3929 22.3308 28.1793 26.6703 29.5071C27.2162 29.4965 27.65 29.0454 27.6393 28.4995C27.6313 28.0908 27.3727 27.7291 26.9884 27.5896C22.5937 26.2082 18.038 25.4048 13.4359 25.1995C12.8916 25.1861 12.4395 25.6164 12.4261 26.1608C12.4136 26.6756 12.7992 27.1134 13.3115 27.1658Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M13.3096 34.0611C15.895 34.2139 18.4689 34.5217 21.0174 34.9833C21.5552 35.0631 22.0559 34.6917 22.1357 34.1538C22.2111 33.645 21.882 33.1638 21.3804 33.0495C18.7532 32.5733 16.0997 32.2568 13.4341 32.1016C12.8905 32.1078 12.4548 32.5535 12.461 33.0973C12.4666 33.5842 12.8273 33.994 13.3096 34.0611Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M26.6688 43.2948C27.2139 43.2863 27.6489 42.8374 27.6403 42.2922C27.6339 41.8814 27.3736 41.5175 26.987 41.3787C22.593 39.9967 18.0375 39.1932 13.4359 38.9886C12.8916 38.9753 12.4395 39.4056 12.4261 39.9499C12.4134 40.4647 12.7991 40.9024 13.3113 40.9549C17.843 41.1821 22.3295 41.968 26.6688 43.2948Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M13.4343 45.884C12.8911 45.8578 12.4297 46.2768 12.4035 46.8199C12.3779 47.352 12.7799 47.8079 13.3111 47.8489C16.6559 48.0346 19.9788 48.5043 23.2439 49.2531C23.7776 49.3607 24.2975 49.0152 24.405 48.4815C24.5071 47.9749 24.2008 47.4755 23.703 47.337C20.3276 46.5617 16.8923 46.0755 13.4343 45.884Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M63.031 8.70062H58.5989V4.33347C58.5989 3.78895 58.1575 3.34766 57.6131 3.34766C41.0719 3.34766 34.5164 7.11228 32.5001 8.6831C30.4836 7.11215 23.9295 3.34766 7.38693 3.34766C6.84317 3.34766 6.40238 3.78845 6.40238 4.33207V4.33347V8.70062H1.97035C0.882724 8.70215 0.00152347 9.58335 0 10.671V59.589C0.000761735 60.6769 0.88247 61.5586 1.97035 61.5593H23.4786C24.0227 61.5391 24.4474 61.0817 24.4272 60.5377C24.4082 60.0219 23.9944 59.6081 23.4786 59.5891H1.97035V10.671H6.40251V54.9143C6.40175 55.4573 6.84127 55.8981 7.38426 55.8989H7.38693C12.7032 55.8292 18.011 56.3483 23.2131 57.4467C26.2491 58.2308 29.5073 59.1124 31.8541 61.2993C32.1066 61.6703 32.612 61.7663 32.983 61.5137C33.0673 61.4564 33.14 61.3836 33.1974 61.2993C34.8368 59.7629 36.8409 58.6699 39.0204 58.1238C45.0769 56.4772 51.3417 55.7253 57.6159 55.8921C58.1597 55.8921 58.6009 55.4516 58.6017 54.9076V47.6682C58.5815 47.1241 58.1241 46.6994 57.5801 46.7196C57.0642 46.7388 56.6505 47.1524 56.6315 47.6682V53.9352C42.8258 54.0612 36.2486 56.8548 33.4833 58.5855V53.804C33.5035 53.2598 33.0789 52.8024 32.5347 52.7822C31.9906 52.762 31.5332 53.1867 31.513 53.7309C31.5121 53.7552 31.5121 53.7796 31.513 53.804V58.5774C28.7396 56.8455 22.1557 54.0612 8.37426 53.9352V5.32741C24.6716 5.48178 30.3564 9.44141 31.5101 10.4177V14.0306C31.5302 14.5747 31.9877 14.9994 32.5318 14.9792C33.0476 14.9601 33.4612 14.5464 33.4804 14.0306V10.4177C34.595 9.43862 40.1267 5.47493 56.6285 5.32334V14.0306C56.6487 14.5747 57.1061 14.9994 57.6501 14.9792C58.166 14.9601 58.5797 14.5464 58.5988 14.0306V10.671H63.0309V59.589H41.5119C40.9678 59.6092 40.5431 60.0666 40.5633 60.6106C40.5825 61.1264 40.9961 61.5402 41.5119 61.5592H63.0309C64.1177 61.5563 64.9976 60.6756 64.9999 59.5888V10.671C64.9978 9.58424 64.1178 8.70367 63.031 8.70062Z",
                                                                fill: "#4A67FF",
                                                                stroke: "#4A67FF",
                                                                "stroke-width": "1.5"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip0_2711_6886",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "65",
                                                                height: "65",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "fs1-75rem c15 fw500",
                                            children: "How it works?"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "registration-inner df fww pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "registration-box w33 p1rem bsbb mb2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "c15 fs1-5rem fw500 pl3rem pr mb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem",
                                                            children: "1"
                                                        }),
                                                        "Add Company"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs1-25rem pl3rem",
                                                    children: "Add one or more client companies and your team colleagues."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "registration-box w33 p1rem bsbb mb2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "c15 fs1-5rem fw500 pl3rem pr mb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem",
                                                            children: "2"
                                                        }),
                                                        "Activate Pro Subscription"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs1-25rem pl3rem",
                                                    children: "Either you or your client can activate a subscription. If you, you can later recover in disbursements."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "registration-box w33 p1rem bsbb mb2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "c15 fs1-5rem fw500 pl3rem pr mb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem",
                                                            children: "3"
                                                        }),
                                                        "Client Authorization"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs1-25rem pl3rem",
                                                    children: "Platform manages your client\u2019s access to their module and data."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "registration-box w33 p1rem bsbb mb2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "c15 fs1-5rem fw500 pl3rem pr mb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem",
                                                            children: "4"
                                                        }),
                                                        "Start Creating Value"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs1-25rem pl3rem",
                                                    children: "You work collaboratively with your clients to create value for everyone."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "registration-box w33 p1rem bsbb mb2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "c15 fs1-5rem fw500 pl3rem pr mb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "numer br100 w2rem h2rem fs1rem bg17 c15 pa l0 tac df aic jcc t0 mt0-5rem",
                                                            children: "5"
                                                        }),
                                                        "Additional Revenue"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs1-25rem pl3rem",
                                                    children: "Help existing and new clients with Diligentsia Pro PLUS. Generate new client introduction via leads module."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w100 mt2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c14 fw500 fs1-25rem",
                                                children: "Rapidly increase the value of your firm!"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "icon-crown pa",
                                            style: {
                                                bottom: '-23px',
                                                right: '-25px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                width: "212",
                                                height: "212",
                                                viewBox: "0 0 212 212",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    opacity: "0.2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M164.422 160.762H47.5861C41.5472 160.762 36.6328 165.676 36.6328 171.715C36.6328 177.754 41.5472 182.668 47.5861 182.668H164.422C170.461 182.668 175.375 177.754 175.375 171.715C175.375 165.676 170.461 160.762 164.422 160.762Z",
                                                            fill: "#F9E109"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M182.674 51.2309C174.62 51.2309 168.069 57.7811 168.069 65.8353C168.069 71.2464 171.063 75.9269 175.452 78.4534C167.003 98.4614 153.823 110.737 141.504 109.627C127.805 108.509 116.632 92.313 110.469 65.2146C118.37 63.2136 124.256 56.0939 124.256 47.5798C124.256 37.51 116.07 29.3242 106 29.3242C95.9303 29.3242 87.7445 37.51 87.7445 47.5798C87.7445 56.0943 93.6302 63.2139 101.531 65.2146C95.368 92.313 84.1954 108.509 70.4966 109.627C58.229 110.737 44.9898 98.4614 36.5487 78.4534C40.9372 75.9269 43.9312 71.246 43.9312 65.8353C43.9312 57.7811 37.3809 51.2309 29.3267 51.2309C21.2729 51.2309 14.7227 57.7811 14.7227 65.8353C14.7227 73.3276 20.4182 79.4468 27.6912 80.279L41.7555 153.462H170.245L184.309 80.279C191.583 79.4468 197.278 73.3276 197.278 65.8353C197.278 57.7811 190.728 51.2309 182.674 51.2309Z",
                                                            fill: "#FCBC04"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ""
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-83px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $409cc7570109bbb7$export$2e2bcd8739ae039), {
                userType: "nonCompany",
                modal: modal,
                getAdvisors: getAdvisors,
                onModalClose: onModalClose,
                user: user,
                action: action,
                advisorData: advisorData,
                profileClass: profileClass,
                setUpdateType: setUpdateType,
                setUploadImage: setUploadImage,
                setSelectedData: setSelectedData,
                hideUserIcon: hideUserIcon,
                setAdvisorData: setAdvisorData,
                setSelectAll: setSelectAll,
                selectAll: selectAll,
                sections: sections,
                setPermissions: setPermissions,
                permissions: permissions,
                company: company
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "addingAdvisor",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#FFF6A680',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: [
                                        user["role"],
                                        " Added"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem py2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem py1rem",
                                    children: "Congratulations! Team Member has been added, now Team Member has been sent an email on the provided email address from where he/she can gain access to the platform."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ""
                                            })),
                                        className: "w30 shadow bg4 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                        children: "Close"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "uploadProfile",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: user['role'] == 'Investor' ? '#AAFED680' : '#FFF6A680',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Upload Profile Picture"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc p3rem",
                            children: [
                                uploadImage == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "profile",
                                    className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs1rem fw500 tac",
                                            children: "Upload picture"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "file",
                                                className: "",
                                                id: "profile",
                                                onChange: (e)=>handleUploadImage(e),
                                                accept: "image/jpeg, image/jpg, image/png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: "Max file size 5MB"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                        ref: $0bc49bb66b774dc6$var$cropper,
                                        guides: false,
                                        src: uploadImage,
                                        aspectRatio: 1,
                                        className: "cropper-settings",
                                        style: {
                                            maxHeight: "500px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>cancelUpdateProfile(),
                                            className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>{
                                                if (!loading) updateProfile();
                                            },
                                            className: `shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem ${loading && "button-disabled"}`,
                                            children: Object.keys(uploadImage).length == 0 ? "Upload" : "Crop & Upload"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: selectedData,
                onClose: ()=>setSelectedData(''),
                className: "td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ec3d7e6915201e2$export$2e2bcd8739ae039), {
                    setSelectedData: setSelectedData,
                    selectedData: selectedData,
                    onEditClick: onEditClick,
                    profileClass: profileClass,
                    user: user
                })
            })
        ]
    });
}







const $409cc7570109bbb7$var$TeamMemberModal = ({ modal: modal, onModalClose: onModalClose, user: user, action: action, advisorData: advisorData, profileClass: profileClass, setUpdateType: setUpdateType, setUploadImage: setUploadImage, setSelectedData: setSelectedData, hideUserIcon: hideUserIcon, setAdvisorData: setAdvisorData, setSelectAll: setSelectAll, selectAll: selectAll, sections: sections, setPermissions: setPermissions, permissions: permissions, getAdvisors: getAdvisors, userType: userType })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    const handleChange = (e)=>setAdvisorData({
            ...advisorData,
            [e.target.name]: e.target.value
        });
    // Get current member from selectedCompany for comparison
    const currentMemberFromStore = (0, $acw62.useMemo)(()=>{
        if (action === "edit" && advisorData?.email && selectedCompany?.members && userType === "company") return selectedCompany.members.find((member)=>member.email === advisorData.email);
        return null;
    }, [
        selectedCompany?.members,
        action,
        advisorData?.email,
        userType
    ]);
    // Update advisorData when selectedCompany changes (for edit mode)
    (0, $acw62.useEffect)(()=>{
        if (currentMemberFromStore && action === "edit") {
            // Compare key fields to avoid unnecessary updates
            const keyFields = [
                'firstName',
                'lastName',
                'email',
                'phone',
                'designation',
                'profile'
            ];
            const hasChanges = keyFields.some((field)=>currentMemberFromStore[field] !== advisorData[field]);
            if (hasChanges) setAdvisorData((prevData)=>({
                    ...prevData,
                    ...currentMemberFromStore
                }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentMemberFromStore,
        action
    ]);
    // Fetch tempModules with sections when modal opens
    (0, $acw62.useEffect)(()=>{
        if (modal['open'] !== 'teamPopup') return;
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/all-modules-section', 'not-showMessage').then((res)=>{
            if (res?.code === 200) {
                const body = res.body;
                const combined = Array.isArray(body) ? body.filter((m)=>m.sections?.length > 0) : [
                    ...(body?.modules || []).filter((m)=>m.sections?.length > 0),
                    ...(body?.checklists || []).filter((m)=>m.sections?.length > 0)
                ];
                setTempModules(combined);
            }
        });
    }, [
        modal['open']
    ]);
    const toggleAccordion = (moduleId)=>setOpenAccordions((prev)=>({
                ...prev,
                [moduleId]: !prev[moduleId]
            }));
    const handleModuleSelectAll = (e, module)=>{
        const checked = e.target.checked;
        const updated = {
            ...permissions
        };
        module.sections.forEach((s)=>{
            updated[s.sectionNo] = checked;
        });
        setPermissions(updated);
    };
    const isModuleAllSelected = (module)=>module.sections.length > 0 && module.sections.every((s)=>permissions[s.sectionNo]);
    const handleAdvisorPermissions = async (e, section)=>{
        if (e.target.checked === false) setSelectAll(false);
        permissions = {
            ...permissions,
            [section["sectionNo"]]: e.target.checked
        };
        setPermissions(permissions);
    };
    const selectAllPermissions = (event)=>{
        const isChecked = event.target.checked;
        setSelectAll(isChecked);
        sections?.forEach((section)=>{
            if (section.sectionNo.trim() !== "") permissions[section.sectionNo] = isChecked;
        });
        tempModules.forEach((module)=>{
            module.sections.forEach((section)=>{
                if (section.sectionNo) permissions[section.sectionNo] = isChecked;
            });
        });
        setPermissions({
            ...permissions
        });
    };
    const submitTeam = async ()=>{
        if (action == "add" || action == "edit") {
            if (advisorData["firstName"] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter your first name");
            if (advisorData["lastName"] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter your last name");
            if (advisorData["email"] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter your email");
        }
        // Company member delete: editMember does not delete — use the dedicated /user/deleteMember endpoint and
        // update the store locally (remove the member) so the list updates without a full page/company refresh.
        if (action == "delete" && userType == "company") {
            const userId = advisorData['_id'] || selectedCompany['members']?.find((m)=>m['email'] === advisorData['email'])?.['_id'];
            if (!userId) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Unable to identify member to delete');
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/deleteMember', {
                companyId: selectedCompany['_id'],
                userId: userId
            });
            if (res && res["code"] == 200) {
                const remainingMembers = (selectedCompany['members'] || []).filter((m)=>String(m['_id']) !== String(userId) && m['email'] !== advisorData['email']);
                const updatedPermissions = {
                    ...selectedCompany['memberPermissions'] || {}
                };
                delete updatedPermissions[userId];
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                    ...selectedCompany,
                    members: remainingMembers,
                    memberPermissions: updatedPermissions
                }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ""
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
                setSelectedData('');
                if (setSelectAll) setSelectAll(false);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.["message"] || "Failed to delete member");
            return;
        }
        advisorData = {
            ...advisorData,
            action: action
        };
        let baseUrl = '/user/addAdvisor';
        if (userType == "company") {
            advisorData = {
                ...advisorData,
                companyId: selectedCompany['_id'],
                permissions: permissions
            };
            baseUrl = '/user/editMember';
        } else advisorData = {
            ...advisorData,
            permissions: permissions
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(baseUrl, advisorData);
        if (res && res["code"] == 200) {
            if (baseUrl == '/user/editMember') {
                const findIndex = selectedCompany['members']?.findIndex((member)=>member['email'] == advisorData['email']) ?? -1;
                let updatedMembers;
                if (findIndex !== -1) updatedMembers = selectedCompany.members.map((member, index)=>index === findIndex ? {
                        ...member,
                        ...advisorData
                    } : member);
                else updatedMembers = [
                    ...selectedCompany.members || [],
                    advisorData
                ];
                const selectedCompanyClone = {
                    ...selectedCompany,
                    members: updatedMembers,
                    memberPermissions: res['body'] || selectedCompany['memberPermissions']
                };
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(selectedCompanyClone));
            }
            if (userType !== "company") {
                await getAdvisors();
                if (action === "add" && res?.body?.newUserId) {
                    const roleField = res.body.userRole;
                    const currentUserEntry = selectedCompany[roleField]?.[user['_id']];
                    dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                        ...selectedCompany,
                        [roleField]: {
                            ...selectedCompany[roleField],
                            [res.body.newUserId]: {
                                type: currentUserEntry?.type,
                                modules: {
                                    ...permissions
                                }
                            }
                        }
                    }));
                }
            }
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            setSelectedData('');
            if (setSelectAll) setSelectAll(false);
            if (action == "add") dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "addingAdvisor"
            }));
            window.location.reload();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: modal["open"] == "teamPopup",
        onClose: ()=>onModalClose(),
        className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "top-header py1rem px2rem df jcsb aic",
                    style: {
                        backgroundColor: userType === "company" ? '#CBD3F980' : user['role'] == 'Investor' ? '#AAFED680' : '#FFF6A680',
                        borderRadius: '8px 8px 0 0'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                            className: "fs1-5rem c15 fw500 ttc",
                            children: [
                                action,
                                " ",
                                userType === "company" ? "Member" : user["role"] == "Advisor" ? "Advisor" : user["role"] == "Investor" ? "Investor" : 'Member'
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w60px",
                            src: (parcelRequire("4vGhj")),
                            alt: "TODO"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                    children: [
                        action == "delete" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "my1rem",
                            children: [
                                "Are you sured you want to delete the",
                                " ",
                                userType === "company" ? "Member" : user["role"] == "Advisor" ? "Advisor" : user["role"] == "Investor" ? "Investor" : 'Member',
                                " (",
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "fw500",
                                    children: [
                                        advisorData["firstName"],
                                        " ",
                                        advisorData["lastName"] ? advisorData["lastName"] : ""
                                    ]
                                }),
                                ")?"
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb aic mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "form-group df jsc",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "img-upload-area pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "img-box pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: advisorData?.profile || (parcelRequire("kBFDN")),
                                                            alt: "Profile",
                                                            className: `profile-img w7rem h7rem ${profileClass}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "input-file",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "add-btn bg5",
                                                                onClick: ()=>{
                                                                    setUpdateType('profileImage'), // Company members have their own upload modal (owned by CompanyTeamMembers); the company page's
                                                                    // "uploadProfile" key is a company-logo uploader, so use a distinct key to avoid hijacking it.
                                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                        open: userType === "company" ? "uploadMemberProfile" : "uploadProfile"
                                                                    })), setUploadImage("");
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    viewBox: "0 0 487 487",
                                                                    className: "zi3",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z          M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9          v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z          M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z          M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df jce advisor-modal",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "cp",
                                                onClick: ()=>setSelectedData({
                                                        ...advisorData,
                                                        hasEditButton: false
                                                    }),
                                                children: !hideUserIcon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bc49bb66b774dc6$export$4202723ba73439f5), {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "advisor-modal-form",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dg gtcr2-md gg1rem advisor-modal",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            value: advisorData["firstName"],
                                                            name: "firstName",
                                                            type: "text",
                                                            placeholder: "First Name",
                                                            onChange: handleChange,
                                                            className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1-25rem"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            className: "center-vertically f15 pa l0 ml1rem w2rem",
                                                            width: "18",
                                                            height: "18",
                                                            viewBox: "0 0 18 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                "fill-rule": "evenodd",
                                                                "clip-rule": "evenodd",
                                                                d: "M9 3C7.34314 3 6 4.34315 6 6C6 7.65683 7.34314 9 9 9C10.6568 9 12 7.65683 12 6C12 4.34315 10.6568 3 9 3ZM4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6C13.5 8.48528 11.4853 10.5 9 10.5C6.51472 10.5 4.5 8.48528 4.5 6ZM4.35986 12.4624C5.58257 11.6981 7.22507 11.25 9 11.25C10.775 11.25 12.4174 11.6981 13.6402 12.4624C14.8522 13.22 15.75 14.3626 15.75 15.75C15.75 16.1642 15.4142 16.5 15 16.5C14.5858 16.5 14.25 16.1642 14.25 15.75C14.25 15.0664 13.8046 14.334 12.8452 13.7344C11.8963 13.1414 10.5388 12.75 9 12.75C7.46123 12.75 6.10372 13.1414 5.15485 13.7344C4.19543 14.334 3.75 15.0664 3.75 15.75C3.75 16.1642 3.41421 16.5 3 16.5C2.58579 16.5 2.25 16.1642 2.25 15.75C2.25 14.3626 3.14771 13.22 4.35986 12.4624Z",
                                                                fill: "#505050"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "text",
                                                        name: "lastName",
                                                        placeholder: "Last Name",
                                                        onChange: handleChange,
                                                        value: advisorData["lastName"] ?? "",
                                                        className: "bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1-25rem"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    name: "email",
                                                    type: "email",
                                                    placeholder: "Email",
                                                    disabled: action == "edit",
                                                    value: advisorData["email"],
                                                    onChange: handleChange,
                                                    className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1-25rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    className: "center-vertically f15 pa l0 ml1rem w2rem",
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 18 18",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M15.1875 3.375H2.8125C2.36495 3.375 1.93572 3.55279 1.61926 3.86926C1.30279 4.18572 1.125 4.61495 1.125 5.0625V12.9375C1.125 13.3851 1.30279 13.8143 1.61926 14.1307C1.93572 14.4472 2.36495 14.625 2.8125 14.625H15.1875C15.6351 14.625 16.0643 14.4472 16.3807 14.1307C16.6972 13.8143 16.875 13.3851 16.875 12.9375V5.0625C16.875 4.61495 16.6972 4.18572 16.3807 3.86926C16.0643 3.55279 15.6351 3.375 15.1875 3.375ZM14.9456 4.5L9.24187 9.045C9.07875 9.19688 8.92125 9.19688 8.72438 9.045L3.05437 4.5H14.9456ZM15.1875 13.5H2.8125C2.66332 13.5 2.52024 13.4407 2.41475 13.3352C2.30926 13.2298 2.25 13.0867 2.25 12.9375V5.29875L7.99312 9.87187C8.26606 10.1368 8.63087 10.286 9.01125 10.2881C9.36973 10.2866 9.71398 10.1477 9.97312 9.9L15.75 5.29875V12.9375C15.75 13.0867 15.6907 13.2298 15.5852 13.3352C15.4798 13.4407 15.3367 13.5 15.1875 13.5Z",
                                                        fill: "#505050"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $331000cdd042dde5$export$2e2bcd8739ae039), {
                                                    name: "phone",
                                                    country: "GB",
                                                    international: true,
                                                    withCountryCallingCode: true,
                                                    value: advisorData?.phone || undefined,
                                                    onChange: (value)=>setAdvisorData({
                                                            ...advisorData,
                                                            phone: value || ''
                                                        }),
                                                    className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1-25rem"
                                                }, `phone-${advisorData?.email || 'new'}`),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "center-vertically f15 pa l0 ml1rem w2rem",
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 18 18",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                            "clip-path": "url(#clip0_2712_8239)",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M3.66509 11.9652C5.44048 14.0874 7.57765 15.7584 10.0169 16.9407C10.9457 17.3809 12.1877 17.903 13.5714 17.9925C13.6572 17.9963 13.7393 18 13.8251 18C14.7538 18 15.4997 17.6792 16.1077 17.0191C16.1114 17.0153 16.1189 17.0079 16.1226 17.0004C16.3389 16.7393 16.5851 16.5044 16.8425 16.2545C17.0178 16.0866 17.1968 15.9113 17.3684 15.7323C18.1628 14.9043 18.1628 13.8525 17.3609 13.0506L15.1193 10.809C14.7389 10.4136 14.2838 10.2047 13.8064 10.2047C13.329 10.2047 12.8702 10.4136 12.4786 10.8052L11.1433 12.1405C11.0203 12.0696 10.8934 12.0062 10.7741 11.9465C10.6249 11.8719 10.4869 11.8011 10.3638 11.7228C9.14789 10.9507 8.04387 9.94364 6.98834 8.6494C6.45498 7.97431 6.09692 7.40738 5.84702 6.82926C6.19763 6.51223 6.52585 6.18027 6.84288 5.85578C6.95477 5.74016 7.0704 5.62453 7.18602 5.50891C7.58884 5.10609 7.80517 4.63987 7.80517 4.16618C7.80517 3.6925 7.59257 3.22627 7.18602 2.82346L6.07454 1.71198C5.944 1.58143 5.82092 1.45462 5.6941 1.32408C5.44794 1.07045 5.19058 0.809366 4.93695 0.574389C4.55279 0.197679 4.10148 0 3.62407 0C3.15038 0 2.69535 0.197679 2.29626 0.578119L0.901314 1.97306C0.394062 2.48031 0.106868 3.09573 0.0471908 3.80812C-0.0236753 4.69954 0.140436 5.64691 0.565633 6.79196C1.21835 8.56361 2.20301 10.2085 3.66509 11.9652ZM0.957261 3.88645C1.00202 3.39039 1.19224 2.97638 1.5503 2.61832L2.93778 1.23083C3.15411 1.02196 3.39282 0.9138 3.62407 0.9138C3.85158 0.9138 4.08283 1.02196 4.29543 1.23829C4.54533 1.46954 4.7803 1.71198 5.03393 1.96933C5.16074 2.09988 5.29129 2.23042 5.42183 2.36469L6.53331 3.47617C6.76455 3.70742 6.88391 3.9424 6.88391 4.17364C6.88391 4.40489 6.76455 4.63987 6.53331 4.87111C6.41768 4.98674 6.30206 5.10609 6.18644 5.22172C5.83957 5.57232 5.51507 5.90427 5.15701 6.2213C5.14955 6.22876 5.14582 6.23249 5.13836 6.23995C4.82879 6.54952 4.87728 6.84418 4.95187 7.06797C4.9556 7.07915 4.95933 7.08661 4.96306 7.0978C5.25026 7.78782 5.64935 8.44426 6.27222 9.22752C7.39116 10.6075 8.56978 11.678 9.86775 12.5023C10.0281 12.6067 10.1997 12.6888 10.3601 12.7708C10.5093 12.8454 10.6473 12.9163 10.7704 12.9946C10.7853 13.0021 10.7965 13.0095 10.8114 13.017C10.9345 13.0804 11.0538 13.1102 11.1732 13.1102C11.4716 13.1102 11.6655 12.92 11.7289 12.8566L13.1239 11.4617C13.3402 11.2453 13.5752 11.1297 13.8064 11.1297C14.0899 11.1297 14.3211 11.305 14.4666 11.4617L16.7157 13.707C17.1632 14.1546 17.1595 14.6395 16.7045 15.1131C16.5478 15.281 16.3837 15.4414 16.2084 15.6092C15.9473 15.8628 15.675 16.1239 15.4289 16.4186C14.9999 16.8811 14.489 17.0974 13.8288 17.0974C13.7654 17.0974 13.6982 17.0937 13.6348 17.0899C12.4115 17.0116 11.2739 16.5342 10.4198 16.1276C8.09982 15.005 6.06335 13.4123 4.37375 11.3908C2.98254 9.71612 2.04636 8.15707 1.42722 6.48612C1.04305 5.46042 0.897585 4.63614 0.957261 3.88645Z",
                                                                fill: "#505050",
                                                                stroke: "#505050",
                                                                "stroke-width": "0.5"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                id: "clip0_2712_8239",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                    width: "18",
                                                                    height: "18",
                                                                    fill: "white"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "text",
                                                    name: "designation",
                                                    placeholder: "Title",
                                                    onChange: handleChange,
                                                    value: advisorData["designation"],
                                                    className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1-25rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "center-vertically f15 pa l0 ml1rem w2rem",
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 18 18",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                            "clip-path": "url(#clip0_2712_8246)",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M15.0019 17.3974H2.99813C2.20343 17.3959 1.44171 17.0796 0.879773 16.5176C0.317837 15.9557 0.00148681 15.194 0 14.3993L0 7.20492C-1.39515e-06 6.40925 0.315692 5.64609 0.877788 5.08294C1.43988 4.51979 2.20246 4.20266 2.99813 4.20117H15.0019C15.7975 4.20266 16.5601 4.51979 17.1222 5.08294C17.6843 5.64609 18 6.40925 18 7.20492V14.3993C17.9985 15.194 17.6822 15.9557 17.1202 16.5176C16.5583 17.0796 15.7966 17.3959 15.0019 17.3974ZM2.99813 5.40492C2.52074 5.40492 2.0629 5.59456 1.72533 5.93213C1.38777 6.2697 1.19813 6.72753 1.19813 7.20492V14.3993C1.19813 14.8767 1.38777 15.3345 1.72533 15.6721C2.0629 16.0097 2.52074 16.1993 2.99813 16.1993H15.0019C15.4793 16.1993 15.9371 16.0097 16.2747 15.6721C16.6122 15.3345 16.8019 14.8767 16.8019 14.3993V7.20492C16.8019 6.72753 16.6122 6.2697 16.2747 5.93213C15.9371 5.59456 15.4793 5.40492 15.0019 5.40492H2.99813Z",
                                                                    fill: "#505050"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M11.9994 3.59969C11.9203 3.59969 11.8421 3.58412 11.769 3.55387C11.696 3.52363 11.6297 3.47929 11.5738 3.4234C11.5179 3.36751 11.4736 3.30116 11.4433 3.22814C11.4131 3.15512 11.3975 3.07685 11.3975 2.99781V2.40156C11.3975 2.24291 11.3349 2.09066 11.2232 1.97795C11.1115 1.86524 10.9599 1.80117 10.8013 1.79969H7.20125C7.04162 1.79969 6.88853 1.8631 6.77566 1.97597C6.66279 2.08885 6.59937 2.24194 6.59937 2.40156V2.99781C6.60748 3.08136 6.59802 3.16568 6.5716 3.24535C6.54518 3.32503 6.50239 3.3983 6.44598 3.46045C6.38956 3.5226 6.32077 3.57227 6.24402 3.60626C6.16726 3.64025 6.08425 3.6578 6.00031 3.6578C5.91637 3.6578 5.83336 3.64025 5.75661 3.60626C5.67986 3.57227 5.61106 3.5226 5.55465 3.46045C5.49823 3.3983 5.45544 3.32503 5.42902 3.24535C5.4026 3.16568 5.39314 3.08136 5.40125 2.99781V2.40156C5.40125 1.92417 5.59089 1.46634 5.92846 1.12877C6.26602 0.791205 6.72386 0.601563 7.20125 0.601562H10.8013C11.2786 0.601563 11.7365 0.791205 12.074 1.12877C12.4116 1.46634 12.6012 1.92417 12.6012 2.40156V2.99781C12.6012 3.07685 12.5857 3.15512 12.5554 3.22814C12.5252 3.30116 12.4809 3.36751 12.425 3.4234C12.3691 3.47929 12.3027 3.52363 12.2297 3.55387C12.1567 3.58412 12.0784 3.59969 11.9994 3.59969Z",
                                                                    fill: "#505050"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M9.00154 11.0587C8.4194 11.0532 7.84475 10.9268 7.31404 10.6875L3.37654 8.94935C3.22736 8.88446 3.11006 8.76296 3.05046 8.61158C2.99086 8.4602 2.99383 8.29135 3.05873 8.14217C3.12362 7.99298 3.24512 7.87569 3.3965 7.81609C3.54788 7.75648 3.71673 7.75946 3.86592 7.82435L7.80341 9.57373C8.18689 9.7438 8.60173 9.83167 9.02123 9.83167C9.44072 9.83167 9.85557 9.7438 10.239 9.57373L14.1765 7.82435C14.2504 7.79222 14.3299 7.77495 14.4104 7.77353C14.491 7.77211 14.571 7.78657 14.646 7.81609C14.7209 7.8456 14.7893 7.88958 14.8473 7.94553C14.9052 8.00148 14.9516 8.0683 14.9837 8.14217C15.0159 8.21603 15.0331 8.29551 15.0345 8.37605C15.036 8.45659 15.0215 8.53663 14.992 8.61158C14.9625 8.68653 14.9185 8.75494 14.8625 8.8129C14.8066 8.87085 14.7398 8.91722 14.6659 8.94935L10.689 10.6875C10.1583 10.9268 9.58368 11.0532 9.00154 11.0587Z",
                                                                    fill: "#505050"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                id: "clip0_2712_8246",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                    width: "18",
                                                                    height: "18",
                                                                    fill: "white"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "my1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "c15 mb1rem fs1-5rem fw500",
                                                    children: "Permissions"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df mt0-5rem mb1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "checkbox w2rem h2rem pr",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                disabled: advisorData?.isOwner ? true : advisorData?.isSuperUser ? false : action == "edit" && advisorData?.isDisable && true,
                                                                checked: selectAll,
                                                                onChange: selectAllPermissions,
                                                                id: "all-permissions",
                                                                className: "bg1 bo16 bw2px bss cp td250 w2rem h2rem br5px new-shadow",
                                                                style: {
                                                                    backgroundColor: advisorData?.isOwner ? "#8f8f8f" : advisorData?.isSuperUser ? "" : action == "edit" && advisorData?.isDisable && "lightgray",
                                                                    borderColor: advisorData?.isOwner ? "#8f8f8f" : advisorData?.isSuperUser ? "" : action == "edit" && advisorData?.isDisable && "lightgray",
                                                                    cursor: advisorData?.isOwner ? "not-allowed" : advisorData?.isSuperUser ? "" : action == "edit" && advisorData?.isDisable && "not-allowed"
                                                                },
                                                                type: "checkbox"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1-5rem fw600 mx1rem usn c15",
                                                            children: "All"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1-5rem fw400 usn c15",
                                                            children: "Permissions"
                                                        })
                                                    ]
                                                }),
                                                tempModules.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "mt1rem",
                                                    children: tempModules.map((module)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "mb0-5rem bss bo16 bw1px br10px oya",
                                                            style: {
                                                                overflow: 'hidden'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df jcsb aic px1rem py0-75rem cp",
                                                                    style: {
                                                                        background: '#f8f9fa',
                                                                        borderBottom: openAccordions[module._id] ? '1px solid #e0e0e0' : 'none'
                                                                    },
                                                                    onClick: ()=>toggleAccordion(module._id),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df aic gg0-5rem",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "checkbox w2rem h2rem pr",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        type: "checkbox",
                                                                                        checked: isModuleAllSelected(module),
                                                                                        disabled: advisorData?.isOwner || action === 'edit' && advisorData?.isDisable && !advisorData?.isSuperUser,
                                                                                        onChange: (e)=>{
                                                                                            e.stopPropagation();
                                                                                            handleModuleSelectAll(e, module);
                                                                                        },
                                                                                        onClick: (e)=>e.stopPropagation(),
                                                                                        className: "bg1 bo16 bw2px bss cp td250 w2rem h2rem br5px new-shadow"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs1rem fw600 c15",
                                                                                    children: module.moduleName
                                                                                }),
                                                                                module.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-75rem c15 px0-5rem py0-25rem br5px",
                                                                                    style: {
                                                                                        background: '#e9ecef',
                                                                                        opacity: 0.7
                                                                                    },
                                                                                    children: module.moduleKey
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                            width: "16",
                                                                            height: "16",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            style: {
                                                                                transform: openAccordions[module._id] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                                transition: 'transform 0.2s'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M6 9l6 6 6-6",
                                                                                stroke: "#505050",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                openAccordions[module._id] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "px1rem py0-75rem df fdc gg0-5rem",
                                                                    children: module.sections.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df aic",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "checkbox w2rem h2rem pr",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        type: "checkbox",
                                                                                        id: `tm-${module._id}-${section.sectionNo}`,
                                                                                        checked: !!permissions[section.sectionNo],
                                                                                        disabled: advisorData?.isOwner || action === 'edit' && advisorData?.isDisable && !advisorData?.isSuperUser,
                                                                                        onChange: (e)=>handleAdvisorPermissions(e, section),
                                                                                        className: "bg1 bo16 bw2px bss cp td250 w2rem h2rem br5px new-shadow"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-85rem fw600 mx1rem usn c15",
                                                                                    children: section.sectionNo
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fs0-85rem fw400 usn c15",
                                                                                    children: section.sectionName
                                                                                })
                                                                            ]
                                                                        }, section.sectionNo))
                                                                })
                                                            ]
                                                        }, module._id))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>submitTeam(),
                            style: {
                                padding: '10px'
                            },
                            className: "new-shadow bg3 bg4-hover c1 td250 br30px p1rem fw600 cp ttu bsbb tac df jcc aic w250px",
                            children: action == "delete" ? 'Delete' : 'Save'
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ""
                                })),
                            className: "c3-hover td250 fs1-25rem cp",
                            children: "Cancel"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    className: "pa cp",
                    onClick: ()=>onModalClose(),
                    style: {
                        left: '50%',
                        transform: 'translateX(-50%)',
                        bottom: '40px'
                    },
                    width: "60",
                    height: "60",
                    viewBox: "0 0 60 60",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            opacity: "0.8",
                            x: "4",
                            y: "4",
                            width: "52",
                            height: "52",
                            rx: "26",
                            fill: "#151313"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                            fill: "white"
                        })
                    ]
                })
            ]
        })
    });
};
var $409cc7570109bbb7$export$2e2bcd8739ae039 = $409cc7570109bbb7$var$TeamMemberModal;



function $f39fe6ee9a0132e2$export$2e2bcd8739ae039({ profileClass: profileClass, company: company, teamMembers: teamMembers, setEditUser: setEditUser, setUserAction: setUserAction, resendInviteMember: resendInviteMember, handleDeleteMember: handleDeleteMember }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [selectedData, setSelectedData] = (0, $acw62.useState)({});
    const [action, setAction] = (0, $acw62.useState)("");
    const [memeberData, setMemberData] = (0, $acw62.useState)({});
    let [hideUserIcon, setHideUserIcon] = (0, $acw62.useState)(false);
    let [updateType, setUpdateType] = (0, $acw62.useState)("profileImage");
    let [uploadImage, setUploadImage] = (0, $acw62.useState)("");
    const [selectAll, setSelectAll] = (0, $acw62.useState)(false);
    const [permissions, setPermissions] = (0, $acw62.useState)({});
    const cropper = (0, $acw62.useRef)(null);
    const handleUploadImage = async (e)=>{
        let profile = e.target.files[0];
        if (profile && profile.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        profile = await URL.createObjectURL(profile);
        setUploadImage(profile);
    };
    // Upload a team member's profile picture. Sets memberData.profile so it shows in the edit form; the picture
    // persists when the user clicks Update (the edit save at /user/editMember already sends `profile`).
    const updateProfile = async ()=>{
        if (cropper.current && uploadImage) {
            let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile-image.png", {
                type: "image/png"
            });
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/upload/advisor/profile`, {
                attachment: [
                    coverFile
                ]
            });
            if (response && (response["code"] == 200 || response["message"])) {
                setMemberData({
                    ...memeberData,
                    profile: response?.["message"]
                });
                setUploadImage("");
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: "teamPopup"
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.["message"] || "Failed to upload image");
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    // Build comprehensive permissions list (sections)
    const allPermissions = (0, $acw62.useMemo)(()=>{
        if (!company?.sections?.length) return [];
        // Extra modules (ABF, BFS, CDD, EHE, etc.)
        const extraModules = company['extraModules'] && company['extraModules'].length ? company['extraModules'].map((mod)=>({
                type: mod.type,
                _id: mod._id,
                sectionNo: mod.id,
                sectionName: mod.moduleName === 'Investment Readiness' && mod.name ? `Investment Readiness (${mod.name})` : mod.moduleName
            })) : [];
        // Investor checklist modules
        const generateChecklistModules = company['generateChecklistModules'] && company['generateChecklistModules'].length ? company['generateChecklistModules'].map((mod)=>({
                checklistModule: true,
                type: mod.type,
                _id: mod._id,
                sectionNo: mod.moduleKey,
                sectionName: mod.moduleName === 'Investment Readiness' ? `Investment Readiness (${mod.moduleKey})` : mod.moduleName
            })) : [];
        // Combine all permissions — hide Exit Readiness unless company testType is 'exit'
        return [
            ...company['sections'],
            ...extraModules,
            ...generateChecklistModules
        ].filter((section)=>section['sectionName'] !== 'Exit Readiness' || company['testType'] === 'exit');
    }, [
        company?.sections,
        company?.extraModules,
        company?.generateChecklistModules
    ]);
    const handleMemberEdit = async (member)=>{
        let permissions = company?.['memberPermissions']?.[member['_id']];
        await setEditUser({
            ...member,
            permissions: permissions
        });
        setUserAction('Edit');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'editUser'
        }));
    };
    const getMembers = async ()=>{
        console.log("Get Members");
    };
    const handleCompanyMember = async (member, action)=>{
        if (member) {
            const isOwner = member._id && (company?.creatorId?._id === member._id || company?.creatorId === member._id);
            setMemberData({
                _id: member["_id"],
                firstName: member["firstName"],
                lastName: member["lastName"],
                email: member["email"],
                designation: member["designation"],
                isDisable: user?._id === member?._id ? false : true,
                isSuperUser: user?.["createdBy"] ? false : true,
                isOwner: isOwner,
                phone: member["phone"] && member["phone"] !== undefined && member["phone"] !== 'undefined' ? member["phone"] : '+44',
                linkedIn: member["linkedIn"] ? member["linkedIn"] : '',
                profile: member["profile"] ? member["profile"] : ''
            });
            // Initialize permissions for edit mode
            if (action === "edit" && member._id) {
                if (isOwner) {
                    // Owner/admin has all permissions by default
                    const ownerPerms = {};
                    allPermissions.forEach((section)=>{
                        if (section.sectionNo) ownerPerms[section.sectionNo] = true;
                    });
                    setPermissions(ownerPerms);
                    setSelectAll(true);
                } else if (company?.memberPermissions?.[member._id]) {
                    const memberPerms = company.memberPermissions[member._id];
                    setPermissions(memberPerms);
                    const allSelected = allPermissions.length > 0 && allPermissions.every((section)=>section.sectionNo && memberPerms[section.sectionNo]);
                    setSelectAll(allSelected);
                } else {
                    setPermissions({});
                    setSelectAll(false);
                }
            } else {
                setPermissions({});
                setSelectAll(false);
            }
        }
        setAction(action);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "teamPopup"
        }));
    };
    const onModalClose = ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
    const handleSetMemberData = (data)=>{
        setMemberData(data);
        if (!data) setSelectedData({});
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc fdc pr mb5rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6df881de6b4bb83c$export$2e2bcd8739ae039), {
                    userType: "company",
                    team: teamMembers,
                    user: user,
                    profileClass: profileClass,
                    setSelectedData: setSelectedData,
                    hasValidAdvisor: (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d),
                    showEditButton: ()=>!user?.["createdBy"],
                    handleEditRoute: (item)=>item?.editRoute || (()=>handleMemberEdit(item)),
                    handleAdvisor: ()=>setSelectedData({
                            ...selectedData,
                            hasEditButton: false
                        }),
                    setResendAdvisor: ()=>setSelectedData({
                            ...selectedData,
                            hasEditButton: false
                        }),
                    handleCompanyMember: handleCompanyMember,
                    UserIcon: (0, $6214114c8c7e1e11$export$4202723ba73439f5),
                    company: company
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: Object.keys(selectedData).length,
                onClose: ()=>setSelectedData({}),
                className: "td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ec3d7e6915201e2$export$2e2bcd8739ae039), {
                    user: user,
                    company: company,
                    selectedData: selectedData,
                    profileClass: profileClass,
                    setSelectedData: setSelectedData,
                    onEditClick: (member)=>handleCompanyMember(member, "edit")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $409cc7570109bbb7$export$2e2bcd8739ae039), {
                userType: "company",
                modal: modal,
                getAdvisors: getMembers,
                onModalClose: onModalClose,
                setUpdateType: setUpdateType,
                setUploadImage: setUploadImage,
                user: user,
                action: action,
                advisorData: memeberData,
                selectedData: memeberData,
                setSelectedData: handleSetMemberData,
                setAdvisorData: setMemberData,
                profileClass: profileClass,
                hideUserIcon: hideUserIcon,
                sections: allPermissions,
                permissions: permissions,
                setPermissions: setPermissions,
                selectAll: selectAll,
                setSelectAll: setSelectAll
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "uploadMemberProfile",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `top-header py1rem px2rem df jcsb aic ${profileClass}`,
                            style: {
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Upload Profile Picture"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc p3rem",
                            children: [
                                uploadImage == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    htmlFor: "memberProfile",
                                    className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs1rem fw500 tac",
                                            children: "Upload Photo"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "file",
                                                id: "memberProfile",
                                                onChange: (e)=>handleUploadImage(e),
                                                accept: "image/jpeg, image/jpg, image/png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: "Max file size 5MB"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                        ref: cropper,
                                        guides: false,
                                        src: uploadImage,
                                        aspectRatio: 1,
                                        className: "cropper-settings",
                                        style: {
                                            maxHeight: "500px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>{
                                                setUploadImage("");
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "teamPopup"
                                                }));
                                            },
                                            className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>updateProfile(),
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: uploadImage == "" ? "Upload" : "Crop & Upload"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $45fvw = parcelRequire("45fvw");


var $17be835537164514$var$AuditLogIcon = function AuditLogIcon(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.418 23.138a7.204 7.204 0 0 1-11.89-5.472 7.204 7.204 0 0 1 7.204-7.205A7.204 7.204 0 0 1 23.64 21.79l2.248 2.205.088-.09a.658.658 0 0 1 .926-.015l3.957 3.84c.258.25.264.665.012.926l-1.428 1.47a.658.658 0 0 1-.926.015l-3.955-3.84a.654.654 0 0 1-.014-.926l.074-.076-2.203-2.161ZM17.732 12.14a5.524 5.524 0 1 0 0 11.048 5.524 5.524 0 0 0 0-11.048Zm0 8.103a.628.628 0 1 1 0 1.256.628.628 0 0 1 0-1.256Zm-.918-4.238a.629.629 0 0 1-1.257 0c0-.6.243-1.144.637-1.538a2.167 2.167 0 0 1 1.538-.637c.601 0 1.145.243 1.538.637.394.394.637.937.637 1.538a2.177 2.177 0 0 1-1.25 1.968.506.506 0 0 0-.22.19.522.522 0 0 0-.076.28v.31a.628.628 0 1 1-1.257 0v-.31c0-.348.097-.674.273-.953.175-.277.43-.502.746-.65a.932.932 0 0 0 .528-.835.915.915 0 0 0-.919-.918.909.909 0 0 0-.649.27.909.909 0 0 0-.269.648Zm-.128 9.801a12.521 12.521 0 0 1-4.504 1.726l-.395.07-.394-.07C5.382 26.486.937 21.211.937 15.103V6.333l10.85-4.652L22.64 6.332v4.753a8.185 8.185 0 0 0-2.117-1.141v-1.97c0-.2-.12-.382-.305-.461l-8.233-3.528a.502.502 0 0 0-.395 0L3.36 7.513a.502.502 0 0 0-.305.461v7.152c0 5.079 3.668 9.484 8.639 10.43a.502.502 0 0 0 .187 0c.713-.136 1.4-.343 2.053-.613.842.44 1.77.74 2.752.864Zm-3.828-1.536a9.53 9.53 0 0 1-1.07.28c-4.454-.894-7.729-4.859-7.729-9.425v-6.82l7.728-3.313 7.732 3.312v1.347a8.208 8.208 0 0 0-6.66 14.618Z",
            fill: "#4A67FF"
        })
    });
};
$17be835537164514$var$AuditLogIcon.defaultProps = {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $17be835537164514$var$Delete = function Delete(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.552 6.89a.722.722 0 0 0-.722.723v8.082a1.387 1.387 0 0 1-1.452 1.307H7.615a1.386 1.386 0 0 1-1.452-1.307V7.613a.722.722 0 1 0-1.444 0v8.082a2.83 2.83 0 0 0 2.896 2.751h5.763a2.83 2.83 0 0 0 2.896-2.75V7.612a.722.722 0 0 0-.722-.722ZM16.278 4.721h-2.89V3.277a.722.722 0 0 0-.721-.722H8.333a.722.722 0 0 0-.722.722V4.72H4.722a.722.722 0 0 0 0 1.445h11.556a.722.722 0 0 0 0-1.445Zm-7.222 0V4h2.888v.722H9.056Z",
                fill: "#F14D4D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.78 14.114V9.058a.722.722 0 1 0-1.444 0v5.056a.722.722 0 1 0 1.444 0ZM12.663 14.114V9.058a.722.722 0 0 0-1.444 0v5.056a.722.722 0 1 0 1.444 0Z",
                fill: "#F14D4D"
            })
        ]
    });
};
$17be835537164514$var$Delete.defaultProps = {
    width: "21",
    height: "21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $17be835537164514$var$TeamPermissionLogs = ({ modalType: modalType, logList: logList, logModule: logModule, profileClass: profileClass, getViewableURL: getViewableURL })=>{
    const getLogsHTML = (logs, showDetails = false)=>logs.filter(({ payload: payload })=>payload.updateData).map((log, idx)=>{
            const { payload: { updateData: updateData } } = log;
            console.log("updateData", updateData);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc my0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                                src: log['userId']['profile'],
                                "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                            }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass} client-profile`,
                                children: [
                                    log?.['userId']?.['firstName']?.[0] || "?",
                                    log?.['userId']?.['lastName']?.[0] || "?"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs0-75rem c15 ml0-5rem df aic",
                                children: [
                                    log['message'],
                                    " at",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c36 op70",
                                        style: {
                                            marginLeft: "6px"
                                        },
                                        children: [
                                            " ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(log.timestamp).format("MMM D, YYYY, h:mmA")
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 mt0-5rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "br10px p1rem mb0-5rem fs0-75rem",
                            style: {
                                backgroundColor: "#FC778533",
                                "grid-template-columns": "25% 75%"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "c2",
                                children: updateData['message']
                            })
                        })
                    })
                ]
            }, `logSection${idx}`);
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            modalType: modalType,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                    className: "c15 fs1-75rem fw600 tal df aic",
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)($17be835537164514$var$AuditLogIcon, {
                            className: "mr1rem"
                        }),
                        " Audit Log"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "c3 fs0-75rem ttu w100 fw400 tal mb1rem mt0-5rem",
                    children: [
                        logModule,
                        "  "
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ma oya dg gg0-5rem mb2rem w100 lightScrollbar pr1rem",
                    style: {
                        maxHeight: "400px"
                    },
                    children: logList.length > 0 ? getLogsHTML(logList, true) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "c4 fs1-5rem ttu w100 tac mb1rem",
                        children: "No Logs Found!!"
                    })
                })
            ]
        })
    });
};
var $17be835537164514$export$2e2bcd8739ae039 = $17be835537164514$var$TeamPermissionLogs;


var $92b48d7b8ab91bfc$var$AuditLogIcon = function AuditLogIcon(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.418 23.138a7.204 7.204 0 0 1-11.89-5.472 7.204 7.204 0 0 1 7.204-7.205A7.204 7.204 0 0 1 23.64 21.79l2.248 2.205.088-.09a.658.658 0 0 1 .926-.015l3.957 3.84c.258.25.264.665.012.926l-1.428 1.47a.658.658 0 0 1-.926.015l-3.955-3.84a.654.654 0 0 1-.014-.926l.074-.076-2.203-2.161ZM17.732 12.14a5.524 5.524 0 1 0 0 11.048 5.524 5.524 0 0 0 0-11.048Zm0 8.103a.628.628 0 1 1 0 1.256.628.628 0 0 1 0-1.256Zm-.918-4.238a.629.629 0 0 1-1.257 0c0-.6.243-1.144.637-1.538a2.167 2.167 0 0 1 1.538-.637c.601 0 1.145.243 1.538.637.394.394.637.937.637 1.538a2.177 2.177 0 0 1-1.25 1.968.506.506 0 0 0-.22.19.522.522 0 0 0-.076.28v.31a.628.628 0 1 1-1.257 0v-.31c0-.348.097-.674.273-.953.175-.277.43-.502.746-.65a.932.932 0 0 0 .528-.835.915.915 0 0 0-.919-.918.909.909 0 0 0-.649.27.909.909 0 0 0-.269.648Zm-.128 9.801a12.521 12.521 0 0 1-4.504 1.726l-.395.07-.394-.07C5.382 26.486.937 21.211.937 15.103V6.333l10.85-4.652L22.64 6.332v4.753a8.185 8.185 0 0 0-2.117-1.141v-1.97c0-.2-.12-.382-.305-.461l-8.233-3.528a.502.502 0 0 0-.395 0L3.36 7.513a.502.502 0 0 0-.305.461v7.152c0 5.079 3.668 9.484 8.639 10.43a.502.502 0 0 0 .187 0c.713-.136 1.4-.343 2.053-.613.842.44 1.77.74 2.752.864Zm-3.828-1.536a9.53 9.53 0 0 1-1.07.28c-4.454-.894-7.729-4.859-7.729-9.425v-6.82l7.728-3.313 7.732 3.312v1.347a8.208 8.208 0 0 0-6.66 14.618Z",
            fill: "#4A67FF"
        })
    });
};
$92b48d7b8ab91bfc$var$AuditLogIcon.defaultProps = {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
function $92b48d7b8ab91bfc$export$2e2bcd8739ae039({ company: company, setEditUser: setEditUser, setUserAction: setUserAction }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let [groupedSections, setGroupedSections] = (0, $acw62.useState)(null);
    const companyId = company?.['_id'] || (typeof window !== 'undefined' ? window.location.pathname.split("/").slice(-1)[0] : '');
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const [allLogs, setAllLogs] = (0, $acw62.useState)([]);
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [openAccordions, setOpenAccordions] = (0, $acw62.useState)({});
    const [savingMemberId, setSavingMemberId] = (0, $acw62.useState)(null);
    const isAdmin = user?.['_id'] && company?.['creatorId']?.['_id'] && user['_id'] === company['creatorId']['_id'];
    const teamMembers = (company['members'] || []).filter((mem)=>mem._id !== company?.['creatorId']?.['_id']);
    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
    const getViewableURL = (url)=>{
        window.open(url, "_blank");
    };
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/all-modules-section', 'not-showMessage').then((res)=>{
            if (res?.code === 200) {
                const body = res.body;
                const combined = Array.isArray(body) ? body.filter((m)=>m.sections?.length > 0) : [
                    ...(body?.modules || []).filter((m)=>m.sections?.length > 0),
                    ...(body?.checklists || []).filter((m)=>m.sections?.length > 0)
                ];
                setTempModules(combined);
            }
        });
    }, []);
    const toggleAccordion = (moduleId)=>setOpenAccordions((prev)=>({
                ...prev,
                [moduleId]: !prev[moduleId]
            }));
    (0, $acw62.useEffect)(()=>{
        if (company['sections'] && company['sections'].length) {
            const extraModules = company['extraModules'] && company['extraModules'].length ? company['extraModules'].map((mod)=>({
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.id,
                    // or mod.moduleKey if you prefer that
                    sectionName: mod.moduleName
                })) : [];
            const generateChecklistModules = company['generateChecklistModules'] && company['generateChecklistModules'].length ? company['generateChecklistModules'].map((mod)=>{
                return {
                    checklistModule: true,
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.moduleKey,
                    sectionName: mod.moduleName
                };
            }) : [];
            const _groupedSections = [
                ...company['sections'],
                ...extraModules,
                ...generateChecklistModules
            ].reduce((acc, section)=>{
                let type = section.sectionNo.includes("UD0") ? "Custom Section" : section.type && /extensions pack|extentions pack/i.test(section.type) ? "Expension Pack" : section.type && section.type.includes("-") ? section.type.split("-")[0].trim() : section.type;
                type = type?.trim();
                const allowedTypes = [
                    "Existing Sections",
                    "Expension Pack",
                    "Additional Sections",
                    "Custom Section"
                ];
                if (!allowedTypes.includes(type)) {
                    if (section?.checklistModule) type = 'checklist';
                    else type = "extraModules";
                }
                if (!acc[type]) acc[type] = [];
                acc[type].push(section);
                return acc;
            }, {});
            setGroupedSections(_groupedSections);
        }
    }, [
        company['sections']
    ]);
    const permissionGroups = (0, $acw62.useMemo)(()=>{
        const groups = [];
        (tempModules || []).forEach((mod)=>{
            const sectionNos = (mod.sections || []).map((s)=>s.sectionNo).filter(Boolean);
            if (sectionNos.length) groups.push({
                id: String(mod._id),
                name: mod.moduleName,
                key: mod.moduleKey,
                sectionNos: sectionNos
            });
        });
        if (groupedSections) Object.entries(groupedSections).filter(([type])=>![
                'Existing Sections',
                'Expension Pack'
            ].includes(type)).forEach(([, typeSections])=>{
            (typeSections || []).forEach((sec)=>{
                if (!sec.sectionNo) return;
                groups.push({
                    id: String(sec.sectionNo),
                    name: sec.sectionName === 'Investor Lead Introduction' ? 'InvestorMatch' : sec.sectionName,
                    key: sec.sectionNo,
                    sectionNos: [
                        sec.sectionNo
                    ]
                });
            });
        });
        return groups;
    }, [
        tempModules,
        groupedSections
    ]);
    const allSectionNos = (0, $acw62.useMemo)(()=>[
            ...new Set(permissionGroups.flatMap((g)=>g.sectionNos))
        ], [
        permissionGroups
    ]);
    const memberHasSections = (member, sectionNos)=>{
        if (!sectionNos?.length) return false;
        const perms = company?.['memberPermissions']?.[member['_id']] || {};
        return sectionNos.every((no)=>!!perms[no]);
    };
    const memberHasAllPermissions = (member)=>memberHasSections(member, allSectionNos);
    const handleMemberEdit = (member)=>{
        if (!setEditUser || !setUserAction) return;
        setEditUser({
            ...member,
            permissions: company?.['memberPermissions']?.[member['_id']]
        });
        setUserAction('Edit');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'editUser'
        }));
    };
    const savePermissions = async (nextCompany, logData)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updatePermission/${companyId}`, {
            permissions: nextCompany['memberPermissions'],
            updateData: logData
        });
        if (res['code'] == 200) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(nextCompany));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        return res;
    };
    const applyMemberPermissions = async (member, nextMemberPerms, logData)=>{
        const nextCompany = {
            ...company,
            memberPermissions: {
                ...company['memberPermissions'] || {},
                [member['_id']]: nextMemberPerms
            }
        };
        return savePermissions(nextCompany, logData);
    };
    const setPermissions = async (e, sectionNo, member)=>{
        if (!isAdmin) {
            e.preventDefault();
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Only admin can change permissions");
        }
        const action = e.target.checked ? "granted" : "revoked";
        const permissions = {
            ...company?.['memberPermissions']?.[member['_id']] || {},
            [sectionNo]: e.target.checked
        };
        await applyMemberPermissions(member, permissions, {
            message: user['firstName'] + " " + user['lastName'] + " " + action + " permission for " + sectionNo + " to " + member['firstName'] + " " + member['lastName'],
            userId: user['_id'],
            sectionNo: sectionNo,
            memberId: member['_id'],
            [member._id]: {
                [sectionNo]: e.target.checked
            }
        });
    };
    const setMemberSectionPermissions = async (member, sectionNos, grantAll, label)=>{
        if (!isAdmin) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Only admin can change permissions");
        if (!sectionNos?.length) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("No modules available to assign.");
        if (savingMemberId) return;
        setSavingMemberId(member['_id']);
        try {
            const current = {
                ...company?.['memberPermissions']?.[member['_id']] || {}
            };
            sectionNos.forEach((no)=>{
                current[no] = grantAll;
            });
            const action = grantAll ? "granted" : "revoked";
            await applyMemberPermissions(member, current, {
                message: `${user['firstName']} ${user['lastName']} ${action} ${label} for ${member['firstName']} ${member['lastName']}`,
                userId: user['_id'],
                memberId: member['_id'],
                [member._id]: current
            });
        } finally{
            setSavingMemberId(null);
        }
    };
    const handleBulkPermissions = (e, member, sectionNos, label)=>{
        e.stopPropagation();
        setMemberSectionPermissions(member, sectionNos, e.target.checked, label);
    };
    const getSectionTitle = (type)=>{
        if (type === "existing sections") return "Core Modules";
        else if (type === "expension pack") return "Expansion Pack";
        else if (type === "extentions pack" || type === "custom section" || type === "additional sections") return capitalizeFirstLetter(type);
        else if (type === "checklist") return "Investor Checklist Modules";
        else return "Extra Modules";
    };
    const getAuditLogs = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/log`, {
            endpoint: `/api/company/updatePermission/${company['_id']}`,
            message: "Permissions updated"
        });
        setAllLogs(res['body']);
        if (res["code"] == 200) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'teamPermissionLogs'
        }));
    };
    const renderPermissionDropdown = (member, { readOnly: readOnly = false } = {})=>{
        const isSaving = savingMemberId === member['_id'];
        const canEdit = isAdmin && !readOnly && !isSaving && allSectionNos.length > 0;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pr",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                    multiple: true,
                    className: "select-advisor w10",
                    id: `member-perm-select-${member['_id']}`,
                    sx: {
                        "& .MuiSvgIcon-root": {
                            color: "#4A67FF"
                        }
                    },
                    IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                    value: [],
                    onChange: ()=>{},
                    disabled: isSaving || !allSectionNos.length,
                    MenuProps: {
                        PaperProps: {
                            style: {
                                maxHeight: 360,
                                width: 'auto',
                                minWidth: '240px'
                            }
                        },
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'right'
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                            value: "all",
                            className: "select-advisor-list ttc",
                            dense: true,
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                    checked: readOnly || memberHasAllPermissions(member),
                                    disabled: !canEdit,
                                    onChange: (e)=>handleBulkPermissions(e, member, allSectionNos, 'all permissions'),
                                    onClick: (e)=>e.stopPropagation()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                    primary: "All permissions"
                                })
                            ]
                        }),
                        permissionGroups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                value: group.id,
                                className: "select-advisor-list ttc",
                                dense: true,
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                        checked: readOnly || memberHasSections(member, group.sectionNos),
                                        disabled: !canEdit,
                                        onChange: (e)=>handleBulkPermissions(e, member, group.sectionNos, group.name),
                                        onClick: (e)=>e.stopPropagation()
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                        primary: group.key ? `${group.name} (${group.key})` : group.name
                                    })
                                ]
                            }, group.id))
                    ]
                }),
                isSaving && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "db fs10px c28 mt0-25rem",
                    children: "Saving\u2026"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcsb aic mr2rem ml1rem fww",
                style: {
                    gap: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df bg1 br50px bw2px bss pr1rem p0-5rem bsbb aic cp add-btn-dashboard",
                        onClick: getAuditLogs,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "bg1 bsbb br100 w40px h40px tac df jcc aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($92b48d7b8ab91bfc$var$AuditLogIcon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c15",
                                children: "Audit Logs"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem pr mb2rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "table-permission",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        id: "table",
                        className: "table-userPermissions table-clientPermissions 96",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                className: "ps t0",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table",
                                            children: "Modules"
                                        }),
                                        company['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "user-area",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcsb",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mr1rem",
                                                                children: company['creatorId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    "data-tooltip": company['creatorId']?.firstName + " " + (company['creatorId']?.lastName && company['creatorId']?.lastName[0] ? company['creatorId']?.lastName[0] : ""),
                                                                    src: company['creatorId']?.['profile'],
                                                                    className: `shadow w2rem h2rem df jcc aic c0 br100 bss bow1px bo31 `
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    "data-tooltip": company['creatorId']?.firstName + " " + (company['creatorId']?.lastName && company['creatorId']?.lastName[0] ? company['creatorId']?.lastName[0] : ""),
                                                                    className: `shadow w2rem h2rem df jcc aic c0 br100 bss bow1px bo31`,
                                                                    children: company['creatorId']?.firstName ? company['creatorId']?.firstName[0] + (company['creatorId']?.lastName ? company['creatorId']?.lastName[0] : "") : "?"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "fs0-75rem",
                                                                        children: [
                                                                            company['creatorId']['firstName'],
                                                                            " ",
                                                                            company['creatorId']['lastName'],
                                                                            " ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c4",
                                                                                children: "(Admin)"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "fs0-75rem",
                                                                        children: [
                                                                            "Status: ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: `${company['creatorId']['emailVerified'] ? 'c7' : 'c13'}`,
                                                                                children: company['creatorId']['emailVerified'] ? 'Activated' : 'Inactive'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    company['creatorId']?.['lastLogin'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "fs0-75rem",
                                                                        children: [
                                                                            "Last Login: ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: (new Date().getTime() - new Date(company['creatorId']['lastLogin']).getTime()) / 2592000000 > 3 ? 'c9' : 'c7',
                                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['creatorId']['lastLogin']).format('ll')
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    renderPermissionDropdown(company['creatorId'], {
                                                        readOnly: true
                                                    })
                                                ]
                                            })
                                        }),
                                        teamMembers.map((member)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "user-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcsb",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic cp",
                                                            onClick: ()=>handleMemberEdit(member),
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "mr1rem",
                                                                    children: member?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        "data-tooltip": member?.firstName + " " + (member?.lastName && member?.lastName[0] ? member?.lastName[0] : ''),
                                                                        src: member?.profile,
                                                                        className: "shadow w2rem h2rem df jcc aic c0 br100 bss bow1px bo31"
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        "data-tooltip": member?.firstName + " " + (member?.lastName && member?.lastName[0] ? member?.lastName[0] : ''),
                                                                        className: "shadow w2rem h2rem df jcc aic c0 br100 bss bow1px bo31",
                                                                        children: member?.firstName ? member?.firstName[0] + (member?.lastName ? member?.lastName[0] : "") : "?"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df fdc",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: "fs0-75rem",
                                                                            children: [
                                                                                member['firstName'],
                                                                                " ",
                                                                                member['lastName']
                                                                            ]
                                                                        }),
                                                                        member['designation'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fs0-75rem c28 w100",
                                                                            children: member['designation']
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "fs0-75rem",
                                                                            children: [
                                                                                "Status: ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: `${member['emailVerified'] ? 'c7' : 'c8'}`,
                                                                                    children: member['emailVerified'] ? 'Activated' : `Invite Sent - (${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(member['updatedAt']).format('ll')})`
                                                                                })
                                                                            ]
                                                                        }),
                                                                        member['emailVerified'] && member['lastLogin'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "fs0-75rem",
                                                                            children: [
                                                                                "Last Login: ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: (new Date().getTime() - new Date(member['lastLogin']).getTime()) / 2592000000 > 3 ? 'c9' : 'c7',
                                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(member['lastLogin']).format('ll')
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        renderPermissionDropdown(member)
                                                    ]
                                                })
                                            }, member._id);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                children: [
                                    tempModules.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: tempModules.map((mod, mIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        onClick: ()=>toggleAccordion(mod._id),
                                                        style: {
                                                            background: '#f8f9fa',
                                                            cursor: 'pointer',
                                                            borderTop: mIdx > 0 ? '1px solid #DBDFEE' : 'none'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "team-temp-module-head-cell",
                                                                style: {
                                                                    padding: '10px 12px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic jcsb w100",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        style: {
                                                                            gap: '8px'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {
                                                                                className: "c3 td250",
                                                                                style: {
                                                                                    fontSize: '22px',
                                                                                    transform: openAccordions[mod._id] ? 'rotate(180deg)' : 'rotate(0deg)'
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fw600 c15 fs1rem",
                                                                                children: mod.moduleName
                                                                            }),
                                                                            mod.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem c15 px0-5rem py0-25rem br5px",
                                                                                style: {
                                                                                    background: '#e9ecef',
                                                                                    opacity: 0.8
                                                                                },
                                                                                children: mod.moduleKey
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "fs0-75rem",
                                                                                style: {
                                                                                    color: '#888'
                                                                                },
                                                                                children: [
                                                                                    "(",
                                                                                    mod.sections?.length || 0,
                                                                                    " section",
                                                                                    mod.sections?.length !== 1 ? 's' : '',
                                                                                    ")"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            company['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                style: {
                                                                    background: '#f8f9fa'
                                                                },
                                                                onClick: (e)=>e.stopPropagation(),
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    className: "df jcc fs0-75rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "checkbox w20px h20px pr",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            disabled: true,
                                                                            defaultChecked: true,
                                                                            className: "shadow bw2px bss w20px h20px br5px",
                                                                            type: "checkbox",
                                                                            style: {
                                                                                backgroundColor: '#8f8f8f',
                                                                                borderColor: '#8f8f8f'
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            teamMembers.map((member)=>{
                                                                const moduleSectionNos = (mod.sections || []).map((s)=>s.sectionNo).filter(Boolean);
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    style: {
                                                                        background: '#f8f9fa'
                                                                    },
                                                                    onClick: (e)=>e.stopPropagation(),
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                        className: "df jcc cp fs0-75rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "cp checkbox w20px h20px pr",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                type: "checkbox",
                                                                                checked: memberHasSections(member, moduleSectionNos),
                                                                                disabled: !isAdmin || savingMemberId === member['_id'],
                                                                                onChange: (e)=>handleBulkPermissions(e, member, moduleSectionNos, mod.moduleName),
                                                                                className: "bg5 shadow bo5 bw2px bss cp td250 w20px h20px br5px",
                                                                                style: !isAdmin ? {
                                                                                    backgroundColor: '#8f8f8f',
                                                                                    borderColor: '#8f8f8f'
                                                                                } : {}
                                                                            })
                                                                        })
                                                                    })
                                                                }, member._id);
                                                            })
                                                        ]
                                                    }),
                                                    openAccordions[mod._id] && (mod.sections || []).map((sec, sIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                    className: "c15 fs12px",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw600 fs12px",
                                                                            style: {
                                                                                marginRight: '4px'
                                                                            },
                                                                            children: sec.sectionNo
                                                                        }),
                                                                        sec.sectionName
                                                                    ]
                                                                }),
                                                                company['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "c6 cp",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                        className: "df jcc cp fs0-75rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "checkbox w20px h20px pr",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                disabled: true,
                                                                                defaultChecked: true,
                                                                                id: `temp-owner-${mod._id}-${sIdx}`,
                                                                                className: "shadow bw2px bss cp td250 w20px h20px br5px",
                                                                                type: "checkbox",
                                                                                style: {
                                                                                    backgroundColor: '#8f8f8f',
                                                                                    borderColor: '#8f8f8f'
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                teamMembers.map((member)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c6 cp",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "df jcc cp fs0-75rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "cp checkbox w20px h20px pr",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    checked: !!company?.['memberPermissions']?.[member['_id']]?.[sec.sectionNo],
                                                                                    onChange: (e)=>setPermissions(e, sec.sectionNo, member),
                                                                                    id: `${sec.sectionNo}-${member["_id"]}`,
                                                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w20px h20px br5px",
                                                                                    type: "checkbox",
                                                                                    style: !isAdmin ? {
                                                                                        backgroundColor: '#8f8f8f',
                                                                                        borderColor: '#8f8f8f'
                                                                                    } : {}
                                                                                })
                                                                            })
                                                                        })
                                                                    }, member._id))
                                                            ]
                                                        }, sec.sectionNo))
                                                ]
                                            }, mod._id))
                                    }),
                                    groupedSections && Object.entries(groupedSections).filter(([type])=>![
                                            'Existing Sections',
                                            'Expension Pack'
                                        ].includes(type)).map(([type, typeSections], inde)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        style: {
                                                            paddingTop: "40px"
                                                        },
                                                        colSpan: teamMembers.length + 2,
                                                        className: "type-heading",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                            style: {
                                                                borderTop: `${inde > 0 || tempModules.length > 0 ? "1px solid rgb(219, 223, 238)" : "transparent"}`,
                                                                paddingTop: "12px"
                                                            },
                                                            className: "c15",
                                                            children: getSectionTitle(type.toLowerCase())
                                                        })
                                                    })
                                                }, `type-heading-${type}`),
                                                typeSections.map((section, idx2)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "c15 fs12px",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 fs12px",
                                                                        children: section['sectionNo']
                                                                    }),
                                                                    " ",
                                                                    section['sectionName'] === "Investor Lead Introduction" ? "InvestorMatch" : section['sectionName']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c6 cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    for: `owner-permission-${idx2}`,
                                                                    className: "df jcc cp fs0-75rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "checkbox w20px h20px pr",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            disabled: true,
                                                                            defaultChecked: true,
                                                                            id: `permission-${idx2}`,
                                                                            className: "shadow bw2px bss cp td250 w20px h20px br5px",
                                                                            type: "checkbox",
                                                                            style: {
                                                                                backgroundColor: '#8f8f8f',
                                                                                borderColor: '#8f8f8f'
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            }, idx2),
                                                            teamMembers.map((member)=>/*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    className: "c6 cp",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                        className: "df jcc cp fs0-75rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "cp checkbox w20px h20px pr",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                checked: !!company?.['memberPermissions']?.[member['_id']]?.[section['sectionNo']],
                                                                                onChange: (e)=>setPermissions(e, section['sectionNo'], member),
                                                                                id: `${section['sectionNo']}-${member['_id']}`,
                                                                                className: "bg5 shadow bo5 bw2px bss cp td250 w20px h20px br5px",
                                                                                type: "checkbox",
                                                                                style: !isAdmin ? {
                                                                                    backgroundColor: '#8f8f8f',
                                                                                    borderColor: '#8f8f8f'
                                                                                } : {}
                                                                            })
                                                                        })
                                                                    })
                                                                }, member._id))
                                                        ]
                                                    }, `company['sections']-section-${idx2}`);
                                                })
                                            ]
                                        });
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17be835537164514$export$2e2bcd8739ae039), {
                getViewableURL: getViewableURL,
                profileClass: "profileClass",
                modalType: "teamPermissionLogs",
                logList: allLogs
            })
        ]
    });
}




function $9dc3b81abd8d4ee8$export$2e2bcd8739ae039({ company: company, teamMembers: teamMembers, setEditUser: setEditUser, setUserAction: setUserAction, resendInviteMember: resendInviteMember, handleDeleteMember: handleDeleteMember }) {
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [teamTab, setTeamTab] = (0, $acw62.useState)("Team Members");
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "dashboard-tools-area",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "box-dashbord-container mla mra mb6rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tabs-navlist tabs-dashboard df aic jcc mt2rem mb2rem",
                        children: [
                            'Team Members',
                            'Team Permissions'
                        ].map((item)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `13 fs1-25rem fw500 c15 cp ${teamTab == item && ' active'}`,
                                    onClick: ()=>setTeamTab(item),
                                    children: item
                                })
                            });
                        })
                    }),
                    user['role'] !== 'Advisor' && user['role'] !== 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc mr2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df bg1 br50px mr0-5rem pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard",
                                onClick: ()=>{
                                    setEditUser({});
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'editUser'
                                    }));
                                    setUserAction('Search');
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bg1 bsbb p0-5rem mr0-5rem br100 w40px h40px tac df jcc aic",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "h30px w30px",
                                            width: "38",
                                            height: "38",
                                            viewBox: "0 0 38 38",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    "clip-path": "url(#clip0_2656_879)",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                            fill: "#4A67FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z",
                                                            fill: "#FAFAFA"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                        id: "clip0_2656_879",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                            width: "38",
                                                            height: "38",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15",
                                        children: "Add to team"
                                    })
                                ]
                            })
                        })
                    }),
                    teamTab == 'Team Members' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f39fe6ee9a0132e2$export$2e2bcd8739ae039), {
                        company: company,
                        teamMembers: teamMembers,
                        setEditUser: setEditUser,
                        setUserAction: setUserAction,
                        resendInviteMember: resendInviteMember,
                        handleDeleteMember: handleDeleteMember
                    }),
                    teamTab == 'Team Permissions' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92b48d7b8ab91bfc$export$2e2bcd8739ae039), {
                        company: company,
                        setEditUser: setEditUser,
                        setUserAction: setUserAction
                    })
                ]
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ba571672f7b8a33c$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($ba571672f7b8a33c$exports, "__esModule", {
    value: true
});
$ba571672f7b8a33c$exports.default = void 0;

var $ba571672f7b8a33c$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ba571672f7b8a33c$var$_default = $ba571672f7b8a33c$exports.default = (0, $ba571672f7b8a33c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $a0a5450dd7e50a49$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($a0a5450dd7e50a49$exports, "__esModule", {
    value: true
});
$a0a5450dd7e50a49$exports.default = void 0;

var $a0a5450dd7e50a49$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a0a5450dd7e50a49$var$_default = $a0a5450dd7e50a49$exports.default = (0, $a0a5450dd7e50a49$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');


var $efec86d92d7c476d$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($efec86d92d7c476d$exports, "__esModule", {
    value: true
});
$efec86d92d7c476d$exports.default = void 0;

var $efec86d92d7c476d$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $efec86d92d7c476d$var$_default = $efec86d92d7c476d$exports.default = (0, $efec86d92d7c476d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), 'Sync');


var $dee4e7f7fcd4d75f$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($dee4e7f7fcd4d75f$exports, "__esModule", {
    value: true
});
$dee4e7f7fcd4d75f$exports.default = void 0;

var $dee4e7f7fcd4d75f$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $dee4e7f7fcd4d75f$var$_default = $dee4e7f7fcd4d75f$exports.default = (0, $dee4e7f7fcd4d75f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonUnchecked');


var $4746b46c9ce21ad5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($4746b46c9ce21ad5$exports, "__esModule", {
    value: true
});
$4746b46c9ce21ad5$exports.default = void 0;

var $4746b46c9ce21ad5$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4746b46c9ce21ad5$var$_default = $4746b46c9ce21ad5$exports.default = (0, $4746b46c9ce21ad5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m11.99 18.54-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27z"
}), 'Layers');



const $d46a85c3c455d19b$var$Spinner = ({ size: size = 20, color: color = '#00e54e' })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($efec86d92d7c476d$exports))), {
        style: {
            fontSize: size,
            color: color,
            animation: 'spin 1s linear infinite'
        }
    });
const $d46a85c3c455d19b$var$getStatusIcon = (status)=>{
    if (status === 'done') return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df aic jcc br100",
        style: {
            width: 28,
            height: 28,
            backgroundColor: '#E6F9EE'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba571672f7b8a33c$exports))), {
            style: {
                fontSize: 14,
                color: '#09B255'
            }
        })
    });
    if (status === 'processing') return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df aic jcc br100",
        style: {
            width: 28,
            height: 28,
            backgroundColor: '#EEF0FF'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d46a85c3c455d19b$var$Spinner, {
            size: 14,
            color: "#00e54e"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df aic jcc br100",
        style: {
            width: 28,
            height: 28,
            backgroundColor: '#F5F6F9'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dee4e7f7fcd4d75f$exports))), {
            style: {
                fontSize: 10,
                color: '#D9D9D9'
            }
        })
    });
};
const $d46a85c3c455d19b$var$ModuleRow = ({ mod: mod, isLast: isLast })=>{
    // analysisDone: true only once workflow:module:done fires with real questionsGenerated
    const analysisDone = !!mod['analysisDone'];
    const isFullyDone = mod['status'] === 'done' && analysisDone;
    const isInProgress = mod['status'] === 'processing' || mod['status'] === 'done' && !analysisDone;
    const pct = mod['totalSections'] > 0 ? Math.round(mod['sectionsDone'] / mod['totalSections'] * 100) : 0;
    const iconStatus = isFullyDone ? 'done' : isInProgress ? 'processing' : 'pending';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df aic px1-5rem py1rem",
        style: {
            borderBottom: isLast ? 'none' : '1px solid #F0F2FF',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    flexShrink: 0
                },
                children: $d46a85c3c455d19b$var$getStatusIcon(iconStatus)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsb mb0-25rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs13px fw500 oh",
                                style: {
                                    color: isInProgress || isFullyDone ? '#151313' : '#AAACB5',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: mod['moduleName']
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs11px fw400 wsn",
                                style: {
                                    color: isFullyDone ? '#09B255' : '#AAACB5',
                                    flexShrink: 0,
                                    marginLeft: 8
                                },
                                children: isFullyDone ? `${mod['questionsGenerated']} issue${mod['questionsGenerated'] !== 1 ? 's' : ''} found` : isInProgress ? `${mod['sectionsDone']} / ${mod['totalSections']} sections` : "Waiting\u2026"
                            })
                        ]
                    }),
                    (isInProgress || isFullyDone) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            height: 4,
                            borderRadius: 4,
                            backgroundColor: '#F0F2FD',
                            overflow: 'hidden'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                height: '100%',
                                borderRadius: 4,
                                backgroundColor: isFullyDone ? '#00e54e' : '#00e54e',
                                width: `${isFullyDone ? 100 : pct}%`,
                                transition: 'width 0.4s ease'
                            }
                        })
                    })
                ]
            })
        ]
    });
};
// Read saved progress from localStorage (shared key with WorkflowMasterSummary helpers)
const $d46a85c3c455d19b$var$readSaved = (cid)=>{
    if (!cid) return null;
    try {
        const raw = localStorage.getItem(`wf_progress_${cid}`);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (Date.now() - (data.startedAt || 0) > 900000) return null;
        return data;
    } catch  {
        return null;
    }
};
const $d46a85c3c455d19b$var$WorkflowGenerationProgress = ({ companyId: companyId, onComplete: onComplete, onError: onError, httpDone: httpDone = false })=>{
    const saved = $d46a85c3c455d19b$var$readSaved(companyId);
    const [modules, setModules] = (0, $acw62.useState)(saved?.modules || []);
    const [doneCount, setDoneCount] = (0, $acw62.useState)((saved?.modules || []).filter((m)=>m.status === 'done').length);
    const [phase, setPhase] = (0, $acw62.useState)(saved?.phase || 'waiting');
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)('');
    const onCompleteRef = (0, $acw62.useRef)(onComplete);
    const onErrorRef = (0, $acw62.useRef)(onError);
    const completedRef = (0, $acw62.useRef)(false);
    // Use a ref so the persist helper inside the effect always has the current companyId
    const companyIdRef = (0, $acw62.useRef)(companyId);
    (0, $acw62.useEffect)(()=>{
        onCompleteRef.current = onComplete;
    }, [
        onComplete
    ]);
    (0, $acw62.useEffect)(()=>{
        onErrorRef.current = onError;
    }, [
        onError
    ]);
    (0, $acw62.useEffect)(()=>{
        companyIdRef.current = companyId;
    }, [
        companyId
    ]);
    const persistProgress = (0, $acw62.useCallback)((newModules, newPhase)=>{
        const cid = companyIdRef.current;
        if (!cid) return;
        try {
            const raw = localStorage.getItem(`wf_progress_${cid}`);
            const existing = raw ? JSON.parse(raw) : {};
            localStorage.setItem(`wf_progress_${cid}`, JSON.stringify({
                ...existing,
                phase: newPhase,
                modules: newModules
            }));
        } catch  {}
    }, []);
    const triggerComplete = (0, $acw62.useCallback)(()=>{
        if (completedRef.current) return;
        completedRef.current = true;
        setPhase('done');
        setModules((prev)=>{
            const updated = prev.map((m)=>m['status'] !== 'done' ? {
                    ...m,
                    status: 'done'
                } : m);
            setDoneCount(updated.length);
            persistProgress(updated, 'done');
            return updated;
        });
        setTimeout(()=>onCompleteRef.current?.(), 1200);
    }, [
        persistProgress
    ]);
    // HTTP fallback — if workflow:complete socket event was missed, httpDone triggers completion
    (0, $acw62.useEffect)(()=>{
        if (!httpDone) return;
        const timer = setTimeout(()=>triggerComplete(), 400);
        return ()=>clearTimeout(timer);
    }, [
        httpDone,
        triggerComplete
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleStarted = ({ modules: mods })=>{
            const initial = (mods || []).map((m)=>({
                    ...m,
                    sectionsDone: 0,
                    status: 'pending',
                    questionsGenerated: 0,
                    analysisDone: false
                }));
            setPhase('running');
            setDoneCount(0);
            setModules(initial);
            persistProgress(initial, 'running');
        };
        const handleSectionDone = ({ moduleId: moduleId, sectionsDone: sectionsDone, totalSections: totalSections })=>{
            setModules((prev)=>{
                const next = prev.map((m)=>{
                    if (String(m['moduleId']) !== String(moduleId)) return m;
                    // Don't downgrade a module that already has its final count from module:done
                    if (m['analysisDone']) return {
                        ...m,
                        sectionsDone: sectionsDone,
                        totalSections: totalSections
                    };
                    const newStatus = sectionsDone >= totalSections ? 'done' : 'processing';
                    return {
                        ...m,
                        sectionsDone: sectionsDone,
                        totalSections: totalSections,
                        status: newStatus
                    };
                });
                setDoneCount(next.filter((m)=>m['status'] === 'done' && m['analysisDone']).length);
                persistProgress(next, 'running');
                return next;
            });
        };
        const handleModuleDone = ({ moduleId: moduleId, questionsGenerated: questionsGenerated })=>{
            setModules((prev)=>{
                const next = prev.map((m)=>String(m['moduleId']) === String(moduleId) ? {
                        ...m,
                        status: 'done',
                        questionsGenerated: questionsGenerated,
                        analysisDone: true
                    } : m);
                setDoneCount(next.filter((m)=>m['status'] === 'done' && m['analysisDone']).length);
                persistProgress(next, 'running');
                return next;
            });
        };
        const handleError = ({ message: message } = {})=>{
            setPhase('error');
            setErrorMsg(message || 'Generation failed. Please try again.');
            onErrorRef.current?.();
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('workflow:started', handleStarted);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('workflow:section:done', handleSectionDone);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('workflow:module:done', handleModuleDone);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('workflow:complete', triggerComplete);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('workflow:error', handleError);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('workflow:started', handleStarted);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('workflow:section:done', handleSectionDone);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('workflow:module:done', handleModuleDone);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('workflow:complete', triggerComplete);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('workflow:error', handleError);
        };
    }, [
        persistProgress,
        triggerComplete
    ]);
    const totalCount = modules.length;
    const headerIcon = ()=>{
        if (phase === 'done') return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df aic jcc br100",
            style: {
                width: 56,
                height: 56,
                backgroundColor: '#E6F9EE'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba571672f7b8a33c$exports))), {
                style: {
                    fontSize: 26,
                    color: '#09B255'
                }
            })
        });
        if (phase === 'error') return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df aic jcc br100",
            style: {
                width: 56,
                height: 56,
                backgroundColor: '#FEE8E8'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a0a5450dd7e50a49$exports))), {
                style: {
                    fontSize: 26,
                    color: '#dd4040'
                }
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df aic jcc br100",
            style: {
                width: 56,
                height: 56,
                backgroundColor: '#EEF0FF'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($d46a85c3c455d19b$var$Spinner, {
                size: 26,
                color: "#00e54e"
            })
        });
    };
    const headerTitle = phase === 'done' ? 'Priority Manager Ready!' : phase === 'error' ? 'Generation Failed' : "Generating Priority Manager\u2026";
    const headerSub = phase === 'done' ? "Your priority issues have been analysed. Loading your results\u2026" : phase === 'error' ? errorMsg : phase === 'waiting' ? "Preparing your modules for analysis\u2026" : 'Analysing unanswered questions across your due diligence modules.';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: `@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sectionWrapper py1rem anylist-builder-tab df fdc aic",
                style: {
                    minHeight: 400,
                    paddingTop: '3rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mb1rem",
                                children: headerIcon()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "fs1-25rem fw600 c15 mb0-25rem",
                                children: headerTitle
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-875rem fw400 c12",
                                style: {
                                    maxWidth: 460
                                },
                                children: headerSub
                            })
                        ]
                    }),
                    totalCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 bsbb",
                        style: {
                            maxWidth: 580
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bg1 br15px",
                            style: {
                                border: '1px solid #DDE2F2',
                                overflow: 'hidden'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic px1-5rem py0-75rem",
                                    style: {
                                        backgroundColor: '#F5F6F9',
                                        borderBottom: '1px solid #DDE2F2',
                                        gap: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4746b46c9ce21ad5$exports))), {
                                            style: {
                                                fontSize: 15,
                                                color: '#00e54e'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs12px fw600 c15",
                                            children: "Module Progress"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs11px fw400",
                                            style: {
                                                color: '#AAACB5'
                                            },
                                            children: [
                                                doneCount,
                                                " / ",
                                                modules.length,
                                                " complete"
                                            ]
                                        })
                                    ]
                                }),
                                modules.map((mod, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d46a85c3c455d19b$var$ModuleRow, {
                                        mod: mod,
                                        isLast: idx === totalCount - 1
                                    }, mod['moduleId']))
                            ]
                        })
                    }),
                    phase !== 'done' && phase !== 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs12px fw400 mt1rem tac",
                        style: {
                            color: '#AAACB5'
                        },
                        children: "This may take a few minutes depending on the number of modules\u2026"
                    })
                ]
            })
        ]
    });
};
var $d46a85c3c455d19b$export$2e2bcd8739ae039 = $d46a85c3c455d19b$var$WorkflowGenerationProgress;



// ── Workflow generation persistence ──────────────────────────────────────────
const $7dd64d9910aee8ce$var$WF_KEY = (cid)=>`wf_progress_${cid}`;
const $7dd64d9910aee8ce$var$WF_TIMEOUT_MS = 900000; // 15 min safety — abandon if server died
const $7dd64d9910aee8ce$var$readWfProgress = (cid)=>{
    if (!cid) return null;
    try {
        const raw = localStorage.getItem($7dd64d9910aee8ce$var$WF_KEY(cid));
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (Date.now() - (data.startedAt || 0) > $7dd64d9910aee8ce$var$WF_TIMEOUT_MS) {
            localStorage.removeItem($7dd64d9910aee8ce$var$WF_KEY(cid));
            return null;
        }
        return data;
    } catch  {
        return null;
    }
};
const $7dd64d9910aee8ce$var$writeWfProgress = (cid, patch)=>{
    if (!cid) return;
    try {
        localStorage.setItem($7dd64d9910aee8ce$var$WF_KEY(cid), JSON.stringify({
            ...$7dd64d9910aee8ce$var$readWfProgress(cid) || {},
            ...patch
        }));
    } catch  {}
};
const $7dd64d9910aee8ce$var$clearWfProgress = (cid)=>{
    if (cid) try {
        localStorage.removeItem($7dd64d9910aee8ce$var$WF_KEY(cid));
    } catch  {}
};
// ─────────────────────────────────────────────────────────────────────────────
const $7dd64d9910aee8ce$var$PRIORITY_OPTIONS = [
    {
        value: 'High',
        label: 'High Priority',
        bg: '#F24E4E',
        color: '#fff'
    },
    {
        value: 'Medium',
        label: 'Medium Priority',
        bg: '#FF8C00',
        color: '#fff'
    },
    {
        value: 'Low',
        label: 'Low Priority',
        bg: '#FFD700',
        color: '#333'
    }
];
const $7dd64d9910aee8ce$var$STATUS_OPTIONS = [
    {
        value: 'Not Started',
        label: 'Not Started',
        bg: '#F5F6F9',
        color: '#505050',
        border: '1px solid #D9D9D9'
    },
    {
        value: 'In Progress',
        label: 'In Progress',
        bg: '#FFD700',
        color: '#333'
    },
    {
        value: 'Ready For Review',
        label: 'Ready For Review',
        bg: '#3DD68C',
        color: '#fff',
        check: true
    },
    {
        value: 'Completed',
        label: 'Completed',
        bg: '#09B255',
        color: '#fff',
        check: true
    },
    {
        value: 'Not Applicable',
        label: 'Not Applicable',
        bg: '#E8EBF5',
        color: '#505050',
        border: '1px solid #D9D9D9'
    }
];
const $7dd64d9910aee8ce$var$TABLE_COLS = [
    'Source / Question(s)',
    'Issue Name',
    'Reason',
    'Investor Lens',
    'Criticality',
    'Action Required',
    'Priority'
];
const $7dd64d9910aee8ce$var$ITEMS_PER_PAGE = 10;



const $7dd64d9910aee8ce$var$getCriticalityIcon = (level)=>{
    const icon = level === 'high' ? (parcelRequire("6iC0x")) : level === 'medium' ? (parcelRequire("3GInX")) : (parcelRequire("5OCVb"));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: icon,
        alt: level,
        style: {
            width: '20px',
            height: '20px'
        }
    });
};
function $7dd64d9910aee8ce$var$ModuleSelectModal({ eligibleMods: eligibleMods, preGenSelectedIds: preGenSelectedIds, setPreGenSelectedIds: setPreGenSelectedIds, modalProgressLoading: modalProgressLoading, modalProgress: modalProgress, handleConfirmGenerate: handleConfirmGenerate, onClose: onClose }) {
    (0, $acw62.useEffect)(()=>{
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.body.style.overflow = prev;
        };
    }, []);
    const allSelected = eligibleMods.length > 0 && eligibleMods.every((m)=>preGenSelectedIds.has(m['_id'].toString()));
    const toggleMod = (id)=>{
        const s = new Set(preGenSelectedIds);
        s.has(id) ? s.delete(id) : s.add(id);
        setPreGenSelectedIds(s);
    };
    const toggleAll = ()=>{
        if (allSelected) setPreGenSelectedIds(new Set());
        else setPreGenSelectedIds(new Set(eligibleMods.map((m)=>m['_id'].toString())));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "pf t0 l0 w100 df aic jcc",
        style: {
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.45)',
            backdropFilter: 'blur(3px)',
            zIndex: 10000
        },
        onClick: onClose,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg1 br20px shadow df fdc",
            style: {
                width: '480px',
                maxHeight: '80vh',
                overflow: 'hidden',
                border: '1px solid #DDE2F2'
            },
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "px2rem pt2rem pb1rem",
                    style: {
                        borderBottom: '1px solid #DDE2F2'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1rem fw600 c15 mb0-25rem",
                            children: "Select Modules to Analyse"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-8rem fw400 c12",
                            children: "Choose one or more modules to generate a priority list for."
                        })
                    ]
                }),
                modalProgressLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df aic jcc py3rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-875rem fw400 c12",
                        children: "Loading module progress\u2026"
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "oya px2rem py1rem",
                            style: {
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcsb py0-5rem mb0-5rem cp",
                                    style: {
                                        borderBottom: '1px solid #F5F6F9'
                                    },
                                    onClick: toggleAll,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-875rem fw500 c15",
                                            children: "Select All"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic jcc br5px ml1rem",
                                            style: {
                                                width: 18,
                                                height: 18,
                                                border: `2px solid ${allSelected ? '#4A67FF' : '#D9D9D9'}`,
                                                backgroundColor: allSelected ? '#4A67FF' : '#fff',
                                                flexShrink: 0
                                            },
                                            children: allSelected && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba571672f7b8a33c$exports))), {
                                                style: {
                                                    fontSize: 12,
                                                    color: '#fff'
                                                }
                                            })
                                        })
                                    ]
                                }),
                                eligibleMods.map((mod)=>{
                                    const id = mod['_id'].toString();
                                    const checked = preGenSelectedIds.has(id);
                                    const answered = modalProgress?.[id] || 0;
                                    const isStarted = answered > 0;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic jcsb py0-75rem cp",
                                        style: {
                                            borderBottom: '1px solid #F5F6F9'
                                        },
                                        onClick: ()=>toggleMod(id),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                style: {
                                                    flex: 1,
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem w100 tal fw500 c15",
                                                        children: mod['moduleName']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem w100 tal fw400",
                                                        style: {
                                                            color: isStarted ? '#09B255' : '#AAACB5',
                                                            marginTop: 2
                                                        },
                                                        children: isStarted ? `${answered} question${answered !== 1 ? 's' : ''} answered` : 'Not started yet'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic jcc br5px ml1rem",
                                                style: {
                                                    width: 18,
                                                    height: 18,
                                                    border: `2px solid ${checked ? '#4A67FF' : '#D9D9D9'}`,
                                                    backgroundColor: checked ? '#4A67FF' : '#fff',
                                                    flexShrink: 0
                                                },
                                                children: checked && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba571672f7b8a33c$exports))), {
                                                    style: {
                                                        fontSize: 12,
                                                        color: '#fff'
                                                    }
                                                })
                                            })
                                        ]
                                    }, id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcsb px2rem py1-5rem",
                            style: {
                                borderTop: '1px solid #DDE2F2'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "fs0-875rem fw500 c12 cp",
                                    style: {
                                        background: 'none',
                                        border: 'none'
                                    },
                                    onClick: onClose,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    className: "df aic br50px py0-5rem px1-5rem fs0-875rem fw500 cp",
                                    style: {
                                        backgroundColor: preGenSelectedIds.size ? '#4A67FF' : '#D9D9D9',
                                        color: '#fff',
                                        border: 'none',
                                        opacity: preGenSelectedIds.size ? 1 : 0.6,
                                        cursor: preGenSelectedIds.size ? 'pointer' : 'default'
                                    },
                                    onClick: handleConfirmGenerate,
                                    disabled: !preGenSelectedIds.size,
                                    children: [
                                        "Generate ",
                                        preGenSelectedIds.size ? `(${preGenSelectedIds.size} module${preGenSelectedIds.size !== 1 ? 's' : ''})` : ''
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


function $7dd64d9910aee8ce$export$2e2bcd8739ae039({ company: company, setTab: setTab }) {
    const companyId = company?.['_id'];
    const [items, setItems] = (0, $acw62.useState)([]);
    const [moduleCompletions, setModuleCompletions] = (0, $acw62.useState)({});
    const [modules, setModules] = (0, $acw62.useState)([]);
    const [assignees, setAssignees] = (0, $acw62.useState)([]);
    const [selectedModule, setSelectedModule] = (0, $acw62.useState)(null);
    const [openDropdown, setOpenDropdown] = (0, $acw62.useState)(null);
    const [loadState, setLoadState] = (0, $acw62.useState)('loading'); // 'loading' | 'empty' | 'data'
    const [isGenerating, setIsGenerating] = (0, $acw62.useState)(()=>$7dd64d9910aee8ce$var$readWfProgress(company?.['_id'])?.generating === true);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [loadProgress, setLoadProgress] = (0, $acw62.useState)(0);
    const [showModuleSelectModal, setShowModuleSelectModal] = (0, $acw62.useState)(false);
    const [modalProgress, setModalProgress] = (0, $acw62.useState)(null); // { moduleId: answeredCount }
    const [modalProgressLoading, setModalProgressLoading] = (0, $acw62.useState)(false);
    const [preGenSelectedIds, setPreGenSelectedIds] = (0, $acw62.useState)(new Set());
    const [genHttpDone, setGenHttpDone] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!openDropdown) return;
        const handler = (e)=>{
            if (!e.target.closest('[data-dropdown]')) setOpenDropdown(null);
        };
        document.addEventListener('mousedown', handler);
        return ()=>document.removeEventListener('mousedown', handler);
    }, [
        openDropdown
    ]);
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        const companyId = company?.['_id'];
        if (!companyId) return;
        setLoadState('loading');
        try {
            const [modulesRes, priorityRes] = await Promise.all([
                (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules?limit=100&isActive=true&companyId=${companyId}`),
                (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/top-priority-questions?companyId=${companyId}`)
            ]);
            if (modulesRes?.['body']?.['modules']) setModules(modulesRes['body']['modules']);
            const body = priorityRes?.['body'] || {};
            const questions = body['questions'] || [];
            const completions = body['moduleCompletions'] || {};
            setItems(questions);
            setModuleCompletions(completions);
            setLoadState(questions.length ? 'data' : 'empty');
        } catch (_) {
            setLoadState('empty');
        }
    }, [
        company
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (loadState !== 'loading') {
            setLoadProgress(0);
            return;
        }
        setLoadProgress(0);
        const interval = setInterval(()=>{
            setLoadProgress((prev)=>{
                if (prev >= 85) {
                    clearInterval(interval);
                    return 85;
                }
                return prev + (85 - prev) * 0.08;
            });
        }, 120);
        return ()=>clearInterval(interval);
    }, [
        loadState
    ]);
    (0, $acw62.useEffect)(()=>{
        const saved = localStorage.getItem('priorityManager');
        if (!saved || !modules.length) return;
        const savedLower = saved.toLowerCase();
        const savedNorm = saved.replace(/\s+/g, '').toLowerCase();
        const match = modules.find((m)=>{
            const nameNorm = (m['moduleName'] || '').replace(/\s+/g, '').toLowerCase();
            const slugNorm = (m['slug'] || '').replace(/\s+/g, '').toLowerCase();
            return m['moduleName'] === saved || m['moduleName']?.toLowerCase() === savedLower || nameNorm === savedNorm || m['slug'] === saved || m['slug']?.toLowerCase() === savedLower || slugNorm === savedNorm || m['moduleKey']?.toLowerCase() === savedLower;
        });
        if (match) setSelectedModule(match);
        localStorage.removeItem('priorityManager');
    }, [
        modules
    ]);
    (0, $acw62.useEffect)(()=>{
        if (loadState === 'loading' || !modules.length) return;
        const flag = localStorage.getItem('openModuleSelectModal');
        if (!flag) return;
        localStorage.removeItem('openModuleSelectModal');
        openModuleSelectModal();
    }, [
        loadState,
        modules
    ]);
    (0, $acw62.useEffect)(()=>{
        setCurrentPage(1);
    }, [
        selectedModule
    ]);
    const handleGenerationComplete = (0, $acw62.useCallback)(async ()=>{
        $7dd64d9910aee8ce$var$clearWfProgress(companyId);
        await fetchData();
        setIsGenerating(false);
    }, [
        fetchData,
        companyId
    ]);
    const handleGenerationError = (0, $acw62.useCallback)(()=>{
        $7dd64d9910aee8ce$var$clearWfProgress(companyId);
        setIsGenerating(false);
    }, [
        companyId
    ]);
    const openModuleSelectModal = async (forceModuleId = null)=>{
        if (!companyId || isGenerating) return;
        setShowModuleSelectModal(true);
        setModalProgressLoading(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/workflow/module-progress?companyId=${companyId}`);
            const progressList = res?.['body'] || [];
            const map = {};
            progressList.forEach((p)=>{
                map[p['moduleId']] = p['answeredCount'];
            });
            setModalProgress(map);
            if (forceModuleId) setPreGenSelectedIds(new Set([
                forceModuleId.toString()
            ]));
            else {
                const eligibleMods = getEligibleModules();
                const withProgress = new Set(eligibleMods.filter((m)=>(map[m['_id']] || 0) > 0).map((m)=>m['_id'].toString()));
                setPreGenSelectedIds(withProgress.size > 0 ? withProgress : new Set(eligibleMods.map((m)=>m['_id'].toString())));
            }
        } catch (_) {
            setModalProgress({});
            const eligibleMods = getEligibleModules();
            setPreGenSelectedIds(new Set(eligibleMods.map((m)=>m['_id'].toString())));
        } finally{
            setModalProgressLoading(false);
        }
    };
    const testType = company?.testType?.toLowerCase();
    const isInvestmentCompany = testType === 'investment';
    const isExitCompany = testType === 'exit';
    const isGrowthCompany = testType === 'growth';
    // DWD and DDQ are Investment/Exit-only modules — not applicable to Growth companies.
    const isDwdDdqAllowed = !isGrowthCompany;
    const getEligibleModules = ()=>modules.filter((mod)=>mod.moduleName !== 'KPI Report' && (mod.moduleName !== 'Investment Readiness' || isInvestmentCompany) && (mod.slug !== 'investor-lead' || isInvestmentCompany) && (mod.slug !== 'exit-readiness' || isExitCompany) && (!mod.isHealthBoost || isGrowthCompany) && (mod.moduleKey !== 'DWD' || isDwdDdqAllowed) && (mod.moduleKey !== 'DDQ' || isDwdDdqAllowed) && (!mod.isPaid || mod.hasPurchased));
    const handleConfirmGenerate = async ()=>{
        if (!companyId || isGenerating || !preGenSelectedIds.size) return;
        setShowModuleSelectModal(false);
        setIsGenerating(true);
        setGenHttpDone(false);
        const moduleIds = [
            ...preGenSelectedIds
        ];
        $7dd64d9910aee8ce$var$writeWfProgress(companyId, {
            generating: true,
            moduleIds: moduleIds,
            startedAt: Date.now(),
            phase: 'waiting',
            modules: []
        });
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/workflow/generate', {
                companyId: companyId,
                moduleIds: moduleIds
            }, true);
            if (res?.['code'] !== 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to generate workflow');
                $7dd64d9910aee8ce$var$clearWfProgress(companyId);
                setIsGenerating(false);
            } else setGenHttpDone(true);
        } catch (_) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to generate workflow');
            $7dd64d9910aee8ce$var$clearWfProgress(companyId);
            setIsGenerating(false);
        }
    };
    const handleDirectGenerate = async (moduleId)=>{
        if (!companyId || isGenerating || !moduleId) return;
        setIsGenerating(true);
        setGenHttpDone(false);
        const moduleIds = [
            moduleId.toString()
        ];
        $7dd64d9910aee8ce$var$writeWfProgress(companyId, {
            generating: true,
            moduleIds: moduleIds,
            startedAt: Date.now(),
            phase: 'waiting',
            modules: []
        });
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/workflow/generate', {
                companyId: companyId,
                moduleIds: moduleIds
            }, true);
            if (res?.['code'] !== 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to generate workflow');
                $7dd64d9910aee8ce$var$clearWfProgress(companyId);
                setIsGenerating(false);
            } else setGenHttpDone(true);
        } catch (_) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to generate workflow');
            $7dd64d9910aee8ce$var$clearWfProgress(companyId);
            setIsGenerating(false);
        }
    };
    const handleNavigateToQuestion = (item)=>{
        if (!setTab) return;
        const sectionQNo = item['qNo']?.split('.')?.[0];
        const mod = modules.find((m)=>m['_id']?.toString() === item['moduleId']?.toString());
        const moduleSlug = mod?.['slug'];
        if (!moduleSlug || !sectionQNo) return;
        localStorage.setItem('lastReportAnchor', sectionQNo);
        setTab(moduleSlug);
        let attempts = 0;
        const poll = setInterval(()=>{
            attempts++;
            const el = document.getElementById(sectionQNo);
            if (el) {
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                localStorage.removeItem('lastReportAnchor');
                clearInterval(poll);
            } else if (attempts >= 30) {
                localStorage.removeItem('lastReportAnchor');
                clearInterval(poll);
            }
        }, 300);
    };
    const updateItem = async (id, field, value)=>{
        setItems((prev)=>prev.map((i)=>i['_id'] === id ? {
                    ...i,
                    [field]: value
                } : i));
        setOpenDropdown(null);
        if (field === 'priority') try {
            await (0, $bebe1cbb5a309c8c$export$2d492ccf07929802)(`/modules/top-priority-questions/${id}`, {
                priority: value,
                companyId: company?.['_id']
            }, true);
        } catch (_) {}
    };
    const PriorityDropdown = ({ item: item })=>{
        const key = `priority-${item['_id']}`;
        const isOpen = openDropdown === key;
        const selected = $7dd64d9910aee8ce$var$PRIORITY_OPTIONS.find((o)=>o.value === item['priority']);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pr df jcfs",
            "data-dropdown": true,
            style: {
                display: 'inline-flex'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "df aic jcc br50px fw500 cp wsn",
                    "data-dropdown": true,
                    style: {
                        backgroundColor: selected?.bg || '#F5F6F9',
                        color: selected?.color || '#505050',
                        border: 'none',
                        gap: '5px',
                        fontSize: '11px',
                        padding: '4px 12px',
                        minWidth: '120px'
                    },
                    onClick: ()=>setOpenDropdown(isOpen ? null : key),
                    children: [
                        selected?.label || 'Priority',
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                            style: {
                                fontSize: 14
                            }
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pa bg1",
                    "data-dropdown": true,
                    style: {
                        top: '110%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 300,
                        minWidth: '160px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        border: '1px solid #DDE2F2'
                    },
                    children: $7dd64d9910aee8ce$var$PRIORITY_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            "data-dropdown": true,
                            className: "cp df aic jcc fw500 wsn",
                            style: {
                                backgroundColor: opt.bg,
                                color: opt.color,
                                padding: '8px 14px',
                                fontSize: '12px',
                                borderBottom: '1px solid rgba(0,0,0,0.06)'
                            },
                            onClick: ()=>updateItem(item['_id'], 'priority', opt.value),
                            children: opt.label
                        }, opt.value))
                })
            ]
        });
    };
    const StatusDropdown = ({ item: item })=>{
        const key = `status-${item['_id']}`;
        const isOpen = openDropdown === key;
        const selected = $7dd64d9910aee8ce$var$STATUS_OPTIONS.find((o)=>o.value === item['workflowStatus']);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pr df jcfs",
            "data-dropdown": true,
            style: {
                display: 'inline-flex'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "df aic jcfs br50px fw500 cp wsn",
                    "data-dropdown": true,
                    style: {
                        backgroundColor: selected?.bg || '#F5F6F9',
                        color: selected?.color || '#505050',
                        border: selected?.border || 'none',
                        gap: '5px',
                        fontSize: '11px',
                        padding: '4px 12px',
                        minWidth: '130px'
                    },
                    onClick: ()=>setOpenDropdown(isOpen ? null : key),
                    children: [
                        selected?.check && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                marginRight: '2px'
                            },
                            children: "\u2713"
                        }),
                        selected?.label || 'Status',
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                            style: {
                                fontSize: 14
                            }
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pa bg1",
                    "data-dropdown": true,
                    style: {
                        top: '110%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 300,
                        minWidth: '170px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        border: '1px solid #DDE2F2'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcsb",
                            style: {
                                backgroundColor: '#F5F6F9',
                                padding: '8px 14px',
                                borderBottom: '1px solid #DDE2F2'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs12px fw500",
                                    style: {
                                        color: '#505050'
                                    },
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fas fa-chevron-down",
                                    style: {
                                        fontSize: '9px',
                                        color: '#969696'
                                    }
                                })
                            ]
                        }),
                        $7dd64d9910aee8ce$var$STATUS_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "data-dropdown": true,
                                className: "cp df aic jcc fw500 wsn",
                                style: {
                                    backgroundColor: opt.bg,
                                    color: opt.color,
                                    padding: '8px 14px',
                                    fontSize: '12px',
                                    border: opt.border || 'none',
                                    borderTop: '1px solid rgba(0,0,0,0.06)'
                                },
                                onClick: ()=>updateItem(item['_id'], 'workflowStatus', opt.value),
                                children: [
                                    opt.check && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            marginRight: '4px'
                                        },
                                        children: "\u2713"
                                    }),
                                    opt.label
                                ]
                            }, opt.value))
                    ]
                })
            ]
        });
    };
    const ROLE_COLORS = {
        'Owner': '#4A67FF',
        'Member': '#038589',
        'Advisor': '#F0AE0D',
        'Investor': '#09B255'
    };
    const AssignedToDropdown = ({ item: item })=>{
        const key = `assignedTo-${item['_id']}`;
        const isOpen = openDropdown === key;
        const assignedName = item['assignedTo'] || '';
        const sectionNo = item['qNo']?.split('.')?.[0] || '';
        const hasPermission = (a)=>{
            // Investor owner (no createdBy) always has access regardless of configured permissions
            if (a['companyRole'] === 'Investor' && !a['createdBy']) return true;
            // null means full access (owner / servicedBy)
            if (a['companyPermissions'] === null) return true;
            if (!sectionNo) return true;
            // companyPermissions is the modules map: { DRN001: true, DRN004: false, ... }
            return !!a['companyPermissions']?.[sectionNo];
        };
        const eligibleAssignees = assignees.filter((a)=>{
            if (!hasPermission(a)) return false;
            const displayName = `${a['firstName'] || ''} ${a['lastName'] || ''}`.trim() || a['email'] || '';
            return !!displayName;
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pr df jcfs",
            "data-dropdown": true,
            style: {
                display: 'inline-flex'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "df aic jcsb br50px fw500 cp wsn",
                    "data-dropdown": true,
                    style: {
                        backgroundColor: '#fff',
                        color: '#151313',
                        border: '1px solid #D9D9D9',
                        gap: '6px',
                        fontSize: '11px',
                        padding: '5px 14px',
                        minWidth: '130px'
                    },
                    onClick: ()=>setOpenDropdown(isOpen ? null : key),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                flex: 1,
                                textAlign: 'left'
                            },
                            children: assignedName || "Assign to\u2026"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                            style: {
                                fontSize: 16,
                                color: '#4A67FF',
                                flexShrink: 0
                            }
                        })
                    ]
                }),
                isOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pa bg1",
                    "data-dropdown": true,
                    style: {
                        top: '110%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 300,
                        minWidth: '200px',
                        maxHeight: '220px',
                        overflowY: 'auto',
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        border: '1px solid #DDE2F2'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic",
                            style: {
                                backgroundColor: '#F5F6F9',
                                padding: '8px 14px',
                                borderBottom: '1px solid #DDE2F2'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs12px fw500",
                                style: {
                                    color: '#505050'
                                },
                                children: "Assign To"
                            })
                        }),
                        eligibleAssignees.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac py0-75rem fs12px c12",
                            children: "No eligible assignees"
                        }),
                        eligibleAssignees.map((a)=>{
                            const name = `${a['firstName'] || ''} ${a['lastName'] || ''}`.trim() || a['email'];
                            const roleColor = ROLE_COLORS[a['companyRole']] || '#969696';
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "data-dropdown": true,
                                className: "cp df aic jcsb px1rem py0-5rem",
                                style: {
                                    borderBottom: '1px solid #F5F6F9',
                                    backgroundColor: assignedName === name ? '#F0F2FD' : 'transparent'
                                },
                                onClick: ()=>updateItem(item['_id'], 'assignedTo', name),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs12px fw400 c15",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs10px fw500 br50px",
                                        style: {
                                            backgroundColor: roleColor + '18',
                                            color: roleColor,
                                            padding: '2px 7px',
                                            marginLeft: '6px',
                                            flexShrink: 0
                                        },
                                        children: a['companyRole']
                                    })
                                ]
                            }, a['_id']);
                        })
                    ]
                })
            ]
        });
    };
    // None certification → DRN + BA only; any cert level unlocks DDQ + DWD as well.
    // Growth companies never see DWD or DDQ regardless of certification.
    const hasCert = company?.['cLevel'] && company['cLevel'] !== 'None';
    const MASTER_SUMMARY_KEYS = hasCert && isDwdDdqAllowed ? new Set([
        'DRN',
        'BA',
        'DWD',
        'DDQ'
    ]) : new Set([
        'DRN',
        'BA'
    ]);
    const hiddenCompleteModules = (()=>{
        if (selectedModule) return [];
        return modules.filter((m)=>{
            if (!MASTER_SUMMARY_KEYS.has(m['moduleKey'])) return false;
            const completion = moduleCompletions[m['_id']?.toString()];
            return completion >= 1;
        });
    })();
    const hiddenCompleteModuleIds = new Set(hiddenCompleteModules.map((m)=>m['_id']?.toString()));
    const displayedItems = (()=>{
        if (selectedModule) return items.filter((i)=>i['moduleName'] === selectedModule['moduleName']);
        return items.filter((i)=>{
            if (!MASTER_SUMMARY_KEYS.has(i['moduleKey'])) return false;
            if (hiddenCompleteModuleIds.has(i['moduleId']?.toString())) return false;
            return true;
        });
    })();
    const completedCount = displayedItems.filter((i)=>i['workflowStatus'] === 'Ready For Review').length;
    const completionPct = displayedItems.length ? Math.round(completedCount / displayedItems.length * 100) : 0;
    // Single module selected → show top 10 for that module (High first, then Medium, then Low).
    // Master Summary → interleave across modules by priority band, cap at 10 total.
    const QUESTION_LIMIT = 10;
    const sortedDisplayedItems = (()=>{
        const bands = [
            'High',
            'Medium',
            'Low'
        ];
        const raw = [];
        for (const band of bands){
            const bandItems = displayedItems.filter((i)=>i['priority'] === band);
            const byModule = {};
            bandItems.forEach((i)=>{
                const k = i['moduleKey'] || 'other';
                if (!byModule[k]) byModule[k] = [];
                byModule[k].push(i);
            });
            const queues = Object.values(byModule);
            let hasMore = true;
            while(hasMore){
                hasMore = false;
                for (const q of queues)if (q.length) {
                    raw.push(q.shift());
                    hasMore = true;
                }
            }
        }
        return raw.slice(0, QUESTION_LIMIT);
    })();
    if (isGenerating) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d46a85c3c455d19b$export$2e2bcd8739ae039), {
        companyId: companyId,
        onComplete: handleGenerationComplete,
        onError: handleGenerationError,
        httpDone: genHttpDone
    });
    if (loadState === 'loading') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "sectionWrapper py1rem anylist-builder-tab df fdc aic jcc",
        style: {
            minHeight: '300px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    width: '50px',
                    height: '50px'
                },
                className: "mb1rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                    value: loadProgress,
                    text: "",
                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                        pathColor: '#FC7785',
                        trailColor: '#F9DEDE',
                        pathTransitionDuration: 0.3
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "fs1rem fw400 c12",
                children: "Loading workflow data\u2026"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "sectionWrapper py1rem fs0-75rem pr anylist-builder-tab",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic jcc w100 mb1-5rem mt1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "fs1-25rem fw600 c15",
                        children: "Priority Manager \u2014 Master Summary"
                    }),
                    (()=>{
                        const cl = company?.['cLevel'] || 'None';
                        const certColor = cl === 'Gold' ? '#F0AE0D' : cl === 'Silver' ? '#AAACB5' : cl === 'Bronze' ? '#fb7a27' : '#969696';
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs11px fw400 mt0-25rem",
                                    style: {
                                        color: '#969696'
                                    },
                                    children: [
                                        "Showing priority questions from ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            style: {
                                                color: '#151313'
                                            },
                                            children: "Data Repository, Business Audit, Warranty Disclosures & Directors Questionnaire"
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "br50px px0-5rem py0-1rem fs10px fw600",
                                            style: {
                                                backgroundColor: certColor + '22',
                                                color: certColor
                                            },
                                            children: cl === 'None' ? 'No Certification' : `${cl} Level`
                                        })
                                    ]
                                }),
                                !selectedModule && hiddenCompleteModules.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs10px fw400 mt0-25rem",
                                    style: {
                                        color: '#09B255'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginRight: '4px'
                                            },
                                            children: "\u2713"
                                        }),
                                        hiddenCompleteModules.map((m)=>m['moduleName']).join(', '),
                                        " ",
                                        hiddenCompleteModules.length === 1 ? 'is' : 'are',
                                        " 100% complete \u2014 questions hidden"
                                    ]
                                })
                            ]
                        });
                    })()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aife jcsb w100 mb1-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aife",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic mb0rem pr",
                            "data-dropdown": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic cp br50px py0-5rem px1rem bss bw1px bo29 c15 fs0-875rem fw500",
                                    style: {
                                        width: 'fit-content',
                                        userSelect: 'none'
                                    },
                                    "data-dropdown": true,
                                    onClick: ()=>setOpenDropdown(openDropdown === 'module-selector' ? null : 'module-selector'),
                                    children: [
                                        selectedModule ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: selectedModule['moduleName']
                                        }) : 'Master Summary',
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebdec3d621c029d6$exports))), {
                                            sx: {
                                                color: '#4b66fe',
                                                ml: 0.5,
                                                fontSize: 18
                                            }
                                        })
                                    ]
                                }),
                                openDropdown === 'module-selector' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pa bg1 br15px shadow",
                                    style: {
                                        top: 'calc(100% + 8px)',
                                        left: 0,
                                        minWidth: '240px',
                                        maxHeight: '300px',
                                        overflowY: 'auto',
                                        zIndex: 100,
                                        border: '1px solid #DDE2F2'
                                    },
                                    "data-dropdown": true,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic px1rem py1rem cp hoverAllModule",
                                            "data-dropdown": true,
                                            style: {
                                                borderBottom: '1px solid #F5F6F9'
                                            },
                                            onClick: ()=>{
                                                setSelectedModule(null);
                                                setOpenDropdown(null);
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs12px fw500 c3",
                                                children: "Master Summary (All)"
                                            })
                                        }),
                                        modules.filter((mod)=>mod.moduleName !== "KPI Report" && (mod.moduleName !== "Investment Readiness" || isInvestmentCompany) && (mod.slug !== "investor-lead" || isInvestmentCompany) && (mod.slug !== "exit-readiness" || isExitCompany) && (!mod.isHealthBoost || isGrowthCompany) && (mod.moduleKey !== 'DWD' || isDwdDdqAllowed) && (mod.moduleKey !== 'DDQ' || isDwdDdqAllowed) && (!mod.isPaid || mod.hasPurchased)).map((mod)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic px1rem py0-5rem cp hoverModule",
                                                "data-dropdown": true,
                                                style: {
                                                    borderBottom: '1px solid #F5F6F9'
                                                },
                                                onClick: ()=>{
                                                    setSelectedModule(mod);
                                                    setOpenDropdown(null);
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs12px fw400 c15",
                                                    children: mod['moduleName']
                                                })
                                            }, mod['_id']))
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aife"
                    })
                ]
            }),
            displayedItems.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt1rem br25px w100 mb1-5rem bsbb bg1 df fdc aic jcc tac",
                style: {
                    border: '1px solid #DDE2F2',
                    minHeight: '280px',
                    padding: '3rem 2rem'
                },
                children: selectedModule ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("3CdlC")),
                            alt: "",
                            style: {
                                width: '48px',
                                marginBottom: '1.25rem',
                                opacity: 0.3
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                            className: "fs1rem fw600 c15 mb0-5rem",
                            children: [
                                "No Priority Items for ",
                                selectedModule['moduleName']
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-875rem fw400 c12 mb1-5rem",
                            style: {
                                maxWidth: '400px'
                            },
                            children: "No priority questions have been set for this module yet. Ask your admin to set priorities from the Module settings."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("3CdlC")),
                            alt: "",
                            style: {
                                width: '48px',
                                marginBottom: '1.25rem',
                                opacity: 0.3
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "fs1rem fw600 c15 mb0-5rem",
                            children: "No Priority Questions Available"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-875rem fw400 c12",
                            style: {
                                maxWidth: '440px'
                            },
                            children: "Please complete your modules and take certifications to get a summarised priorities list of questions."
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt1rem px2rem py2rem br25px w100 mb1-5rem bsbb bg1",
                style: {
                    border: '1px solid #DDE2F2'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100",
                    style: {
                        overflowX: 'auto'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        className: "w100",
                        style: {
                            borderCollapse: 'collapse',
                            minWidth: '1100px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                    style: {
                                        backgroundColor: '#F5F6F9',
                                        borderBottom: '2px solid #DDE2F2'
                                    },
                                    children: $7dd64d9910aee8ce$var$TABLE_COLS.map((col)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "fs11px fw600 c15 ttu tal py0-875rem px1rem wsn tac",
                                            style: {
                                                letterSpacing: '0.03em',
                                                minWidth: [
                                                    'Priority',
                                                    'Status',
                                                    'Criticality'
                                                ].includes(col) ? '120px' : '100px'
                                            },
                                            children: col
                                        }, col))
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: sortedDisplayedItems.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            borderBottom: '1px solid #DDE2F2',
                                            backgroundColor: idx % 2 === 0 ? '#fff' : '#FAFBFF'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                className: "py0-875rem px0-875rem cp",
                                                style: {
                                                    minWidth: '130px'
                                                },
                                                onClick: ()=>handleNavigateToQuestion(item),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs12px fw600 c3 mb0-25rem tal",
                                                        children: item['moduleName']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs11px fw400 c12 tal",
                                                        children: item['qNo']
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py0-875rem px0-875rem tal",
                                                style: {
                                                    minWidth: '160px',
                                                    maxWidth: '180px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs11px fw500 c3",
                                                    children: item['issueName'] || item['qDescription']
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py0-875rem px0-875rem",
                                                style: {
                                                    minWidth: '180px',
                                                    maxWidth: '200px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px fw400 c14 tal",
                                                    children: item['reason']
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py0-875rem px0-875rem",
                                                style: {
                                                    minWidth: '160px',
                                                    maxWidth: '180px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px fw400 c14 tal",
                                                    children: item['investorLens']
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py0-875rem px0-875rem tac",
                                                style: {
                                                    minWidth: '80px'
                                                },
                                                children: $7dd64d9910aee8ce$var$getCriticalityIcon(item['criticality'])
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py0-875rem px0-875rem",
                                                style: {
                                                    minWidth: '180px',
                                                    maxWidth: '200px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px fw400 c14 tal",
                                                    children: item['actionRequired']
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py0-875rem px0-875rem tal",
                                                style: {
                                                    minWidth: '130px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(PriorityDropdown, {
                                                    item: item
                                                })
                                            })
                                        ]
                                    }, item['_id']))
                            })
                        ]
                    })
                })
            }),
            showModuleSelectModal && /*#__PURE__*/ (0, $ayMG0.jsx)($7dd64d9910aee8ce$var$ModuleSelectModal, {
                eligibleMods: getEligibleModules(),
                preGenSelectedIds: preGenSelectedIds,
                setPreGenSelectedIds: setPreGenSelectedIds,
                modalProgressLoading: modalProgressLoading,
                modalProgress: modalProgress,
                handleConfirmGenerate: handleConfirmGenerate,
                onClose: ()=>setShowModuleSelectModal(false)
            })
        ]
    });
}





function $daf292139b169396$export$2e2bcd8739ae039({ company: company, setTab: setTab, setIsWorkflowReport: setIsWorkflowReport, setCompanyDashboardTab: setCompanyDashboardTab, permissionLevel: permissionLevel }) {
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const [showPriorityTooltip, setShowPriorityTooltip] = (0, $acw62.useState)(false);
    const [showPriorityList, setShowPriorityList] = (0, $acw62.useState)(()=>!!localStorage.getItem('priorityManager'));
    const redirectWorkflowTab = async (moduleName)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You have Dashboard access only!');
            return;
        }
        await setTab(`${moduleName}-report`);
        setCompanyDashboardTab('Dashboard');
        await setIsWorkflowReport(true);
        localStorage.setItem('isWorkflowOpen', true);
    };
    const handleChecklistMessages = (isActive, isRedirect)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if (!isActive) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Module not activated yet!`);
        if (!isRedirect) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Module not started yet!`);
    };
    const checklistModules = (modules)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: modules.length > 0 ? Object.values(modules).map((module)=>{
                let isRedirect = false;
                if (module?.['stats'].completionPercent > 0) isRedirect = true;
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb ${!module['isActive'] && ' op0-5'} ${module?.['createdBy']?.['role'] == 'Advisor' && ' advisor-bg'} ${module?.['createdBy']?.['role'] == 'Investor' && ' investor-bg'}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: module['isActive'] && isRedirect && permissionLevel != 'DASHBOARD' && `#${module['type']}-report`,
                            onClick: ()=>{
                                module['isActive'] && isRedirect ? redirectWorkflowTab(module['type']) : handleChecklistMessages(module['isActive'], isRedirect);
                            },
                            className: "cp w100 h100",
                            style: {
                                minHeight: '130px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon-diligenstia mr1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "br5px w50px",
                                                src: module?.['imageURL'] || (parcelRequire("jSVu6")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "cp fs1rem fw500 bg1 c4-hover c15 lh2 title-box-feature tal",
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: module['type']
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc ",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c12 fw300 fs0-75rem mt3rem",
                                                    children: module?.['createdAt'] || module?.['sections']?.[0]?.['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module?.['createdAt'] || module?.['sections']?.[0]?.['createdAt']).format('L') : '-'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: `df bg1 br50px bw1px bss fs0-75rem px1rem py0-5rem mt0-5rem bsbb aic ${module['isActive'] ? ' bo3 c3' : ' bo12 c12'}`,
                                                    children: module['isActive'] ? 'Activated' : 'Deactivated'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc jcc aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `progress-bar workflow-report-progress ${module?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : module?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : module?.stats?.workflowCompletionPercent > 1 ? ' workflow-progress-pink' : '  workflow-progress-grey'}`,
                                                    style: {
                                                        width: 50,
                                                        height: 50,
                                                        borderRadius: '50%',
                                                        margin: 0,
                                                        border: '2px solid #F1F1F1'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                        text: module?.stats?.workflowCompletionPercent ? module?.stats?.workflowCompletionPercent + "%" : 'N/A',
                                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                            strokeWidth: '0',
                                                            textSize: '20px',
                                                            trailColor: '#FBFBFB',
                                                            stroke: 'transparent',
                                                            strokeLinecap: 'butt',
                                                            backgroundColor: '#FBFBFB',
                                                            pathTransitionDuration: 0.5,
                                                            dominantBaseline: 'ideographic'
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    style: {
                                                        marginBottom: "0"
                                                    },
                                                    className: "tac c15 fs0-75rem fw300",
                                                    children: [
                                                        "Workflow ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        " Completeness"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                });
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "w100 tac fs1-75rem fw500 c14 fsi",
                children: "No Workflow Added!"
            })
        });
    };
    if (showPriorityList) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dd64d9910aee8ce$export$2e2bcd8739ae039), {
        company: company,
        setTab: setTab
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sectionWrapper py1rem fs0-75rem pr anylist-builder-tab",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb *",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcfs w100 pl1rem mb0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "fs1-25rem c15 mr1rem",
                                children: "Workflows"
                            }),
                            company?.['subscription'] === 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic mr1rem pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        className: "df aic br50px py0-5rem px1-5rem bss bw1px bo4 c15 fs0-875rem fw500 cp mr0-75rem fsi",
                                        style: {
                                            backgroundColor: '#F0F2FD',
                                            border: '1px solid #DBDFEE'
                                        },
                                        onClick: ()=>{
                                            setShowPriorityList(true);
                                            localStorage.removeItem('priorityManager');
                                        },
                                        children: [
                                            "Priority",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("3CdlC")),
                                                alt: "Priority",
                                                className: "20px 20px ml0-5rem"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pa",
                                        style: {
                                            right: "10px",
                                            top: 0
                                        },
                                        onMouseEnter: ()=>setShowPriorityTooltip(true),
                                        onMouseLeave: ()=>setShowPriorityTooltip(false),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("1q1VK")),
                                                alt: "info",
                                                className: "20px 20px cp"
                                            }),
                                            showPriorityTooltip && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "pa br10px p1rem fs0-75rem fw400 c15 shadow",
                                                style: {
                                                    width: '320px',
                                                    right: 0,
                                                    top: '-110px',
                                                    backgroundColor: '#F5F0BC',
                                                    zIndex: 100
                                                },
                                                children: "The PriorityList report consolidates the most critical remediation issues across all diligence modules. It provides a structured roadmap for achieving investment readiness."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>(item?.['category'] == "all" || item?.['category'] == "internal" || item?.['category'] == "external" || item?.['category'] == "partner") && item['stats']['completionPercent'] > 0 || item['isHealthBoost'] && item['stats']['completionPercent'] > 0))
                ]
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");











var $ayMG0 = parcelRequire("ayMG0");
function $b7e1847e3fac637e$export$2e2bcd8739ae039({ className: className = "w2rem ma" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        className: className,
        viewBox: "0 0 321 66",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M320 51.3082C320 43.1968 313.517 36.6191 305.523 36.6191C297.527 36.6191 291.041 43.1968 291.041 51.3082C291.041 59.4196 297.527 65.9997 305.522 65.9997C313.517 65.9997 320 59.4196 320 51.3082Z",
                fill: "#3BAE5B"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M285.252 16.0562C285.252 7.94185 278.769 1.36719 270.774 1.36719C262.777 1.36719 256.297 7.94246 256.297 16.0562C256.297 24.17 262.778 30.7453 270.774 30.7453C278.769 30.7459 285.252 24.1706 285.252 16.0562Z",
                fill: "#3BAE5B"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M291.201 15.9125C291.201 27.1561 282.085 36.2735 270.841 36.2735C262.804 36.2735 256.293 42.7868 256.293 50.8188C256.293 58.8508 262.804 65.3672 270.841 65.3672C278.873 65.3672 285.383 58.8514 285.383 50.8188C285.383 39.5728 294.5 30.4579 305.748 30.4579C313.778 30.4579 320.293 23.9469 320.293 15.9125C320.293 7.87813 313.777 1.36719 305.748 1.36719C297.715 1.36719 291.201 7.87753 291.201 15.9125Z",
                fill: "#87999F"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M86.3531 30.9238V38.3596H117.479V30.9238C117.479 29.2151 116.421 25.9586 112.585 25.9586H91.2501C87.7518 25.9586 86.3531 29.2151 86.3531 30.9238ZM119.444 57.5382C121.128 57.5382 122.492 58.9192 122.492 60.628V61.8498C122.492 63.5555 121.128 64.9396 119.444 64.9396H91.2501C84.5181 64.9396 79.0586 59.4 79.0586 52.5723V30.9238C79.0586 24.0912 84.5181 18.5547 91.2501 18.5547H112.586C119.32 18.5547 124.777 24.0912 124.777 30.9238V42.6686C124.777 44.3774 123.414 45.7609 121.73 45.7609H86.3543V52.5723C86.3543 55.9574 89.5665 57.5376 91.2507 57.5376L119.444 57.5382Z",
                fill: "#343A40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M169.296 57.5377V45.761H143.066C140.009 45.761 138.173 47.4841 138.173 50.1044V53.1967C138.173 56.5544 141.382 57.5377 143.066 57.5377H169.296ZM136.208 25.958C134.526 25.958 133.16 24.5745 133.16 22.8682V21.6489C133.16 19.9376 134.526 18.5566 136.208 18.5566H164.402C171.136 18.5566 176.596 24.0932 176.596 30.9239V61.8499C176.596 63.5555 175.229 64.9422 173.548 64.9422H143.066C136.334 64.9422 130.875 59.4025 130.875 52.573V50.7294C130.875 43.8974 136.334 38.3603 143.066 38.3603H169.296V30.9245C169.296 29.2158 168.571 25.9593 164.402 25.9593L136.208 25.958Z",
                fill: "#343A40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M183.835 61.8501C183.835 63.5557 185.199 64.9399 186.885 64.9399H188.085C189.768 64.9399 191.132 63.5557 191.132 61.8501V3.09228C191.132 1.38351 189.768 0 188.085 0H186.885C185.199 0 183.835 1.38351 183.835 3.09228V61.8501Z",
                fill: "#343A40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M228.999 45.7616C232.204 45.7616 234.508 47.5921 234.508 50.7268V52.573C234.508 56.1216 232.634 57.5382 228.999 57.5382H201.421C199.737 57.5382 198.373 58.9192 198.373 60.6305V61.8498C198.373 63.5555 199.737 64.9396 201.421 64.9396H229.614C236.855 64.9396 241.809 59.9718 241.809 52.5723V49.4775C241.809 42.648 236.349 38.3596 229.614 38.3596H208.279C205.955 38.3596 203.385 37.405 203.385 33.3918V30.9238C203.385 28.0582 204.916 25.9586 208.279 25.9586H236.473C238.156 25.9586 239.52 24.5726 239.52 22.8663V21.6495C239.52 19.9357 238.156 18.5547 236.473 18.5547H208.279C201.544 18.5547 196.084 24.0912 196.084 30.9238V34.0161C196.084 40.8481 201.544 45.7609 208.279 45.7609H228.999V45.7616Z",
                fill: "#343A40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18.0957 61.8494C18.0957 63.5551 19.4593 64.9392 21.1405 64.9392H50.0993C62.7204 64.9392 72.9575 55.3427 72.9575 41.748V23.1937C72.9575 10.3813 62.7204 0 50.0993 0H21.1405C19.4593 0 18.0957 1.38351 18.0957 3.09228V61.8494ZM25.3926 7.40388H50.0993C58.9408 7.40388 65.671 14.7909 65.6599 23.1937V41.748C65.6599 51.2347 57.9821 57.5378 50.0993 57.5378H25.3926V7.40388Z",
                fill: "#343A40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1.80664 61.85C1.80664 63.5557 3.17028 64.9398 4.85452 64.9398H5.90248C7.58364 64.9398 8.95281 63.5557 8.95281 61.85V20.4004C8.95281 18.6867 7.58364 17.3057 5.90248 17.3057H4.85452C3.17028 17.3057 1.80664 18.6867 1.80664 20.4004V61.85Z",
                fill: "#343A40"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.0057 5.08014C10.0057 2.27442 7.76584 0 5.00287 0C2.23991 0 0 2.27442 0 5.08014C0 7.88211 2.23991 10.154 5.00287 10.154C7.76584 10.154 10.0057 7.88211 10.0057 5.08014Z",
                fill: "#3BAE5B"
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");
function $163b83667de8cb50$export$2e2bcd8739ae039({ className: className = "w2rem ma" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        className: className,
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 800 172",
        style: {
            enableBackground: "new 0 0 800 172"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                style: {
                    fill: "none"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M201.62,33.58c33.22,0,46.66,17.31,46.66,52.53c0,35.23-13.44,52.53-46.66,52.53h-35.54V33.58H201.62z  M186.17,50.58v71.07h15.45c16.53,0,25.8-6.49,25.8-20.39V70.97c0-13.91-9.27-20.39-25.8-20.39H186.17z M308.69,84.72  c0-8.19-4.79-11.74-12.36-11.74c-7.73,0-13.29,3.86-13.29,11.12h-19.31c0.62-17.15,14.52-26.11,33.37-26.11  c18.85,0,30.59,9.43,30.59,27.04v38.63h10.97v14.99h-28.12l-0.16-12.21h-0.62c-4.48,8.65-11.74,14.06-23.8,14.06  c-14.21,0-24.88-10.04-24.88-24.26c0-12.67,9.27-23.18,25.8-24.57l21.78-1.86V84.72z M308.69,107.59v-3.09l-23.18,2.01  c-3.09,0.31-4.32,2.01-4.32,5.1v6.8c0,4.63,4.79,7.11,11.59,7.11C302.67,125.51,308.69,117.47,308.69,107.59 M377.29,74.83h19.62  V59.85h-19.62V33.58h-19.31v26.27h-15.61v14.99h15.61v63.81h38.94v-14.99h-19.62V74.83z M456.55,84.72  c0-8.19-4.79-11.74-12.36-11.74c-7.73,0-13.29,3.86-13.29,11.12h-19.31c0.62-17.15,14.52-26.11,33.37-26.11  c18.85,0,30.59,9.43,30.59,27.04v38.63h10.97v14.99h-28.12l-0.16-12.21h-0.62c-4.48,8.65-11.74,14.06-23.79,14.06  c-14.21,0-24.88-10.04-24.88-24.26c0-12.67,9.27-23.18,25.8-24.57l21.78-1.86V84.72z M456.55,107.59v-3.09l-23.18,2.01  c-3.09,0.31-4.32,2.01-4.32,5.1v6.8c0,4.63,4.79,7.11,11.59,7.11C450.53,125.51,456.55,117.47,456.55,107.59 M524.69,89.51  c-5.1-1.08-8.65-3.24-8.65-8.34c0-5.1,4.63-8.19,11.28-8.19c6.8,0,11.59,3.71,11.89,11.12h19.31  c-0.77-17.46-13.44-26.11-31.21-26.11c-19.31,0-30.59,10.66-30.59,24.1c0,12.36,6.49,19.62,19.78,22.56l13.6,2.94  c6.95,1.39,11.74,3.55,11.74,9.27c0,5.87-6.02,8.65-13.44,8.65c-8.5,0-13.44-4.17-14.21-11.9h-19.31  c0.77,17.15,12.67,26.88,33.53,26.88c21.01,0,32.75-10.81,32.75-24.57c0-13.9-9.11-20.39-20.86-23.02L524.69,89.51z M595.45,50.73  h-19.93V33.58h19.93V50.73z M575.83,59.84h19.31v78.8h-19.31V59.84z M644.89,74.83h19.62V59.85h-19.62V33.58h-19.31v26.27h-15.61  v14.99h15.61v63.81h38.93v-14.99h-19.62V74.83z M710.55,57.99c21.32,0,35.23,16.07,35.23,37.7v9.73H695.1v5.26  c0,9.42,7.26,14.83,15.6,14.83c8.34,0,14.22-4.63,15.14-12.67h19.31c-2.47,17.46-15.61,27.66-34.61,27.66  c-22.4,0-35.54-16.69-35.54-41.41C675.02,74.37,689.23,57.99,710.55,57.99 M695.1,90.44H726v-2.78c0-8.5-6.64-14.68-15.45-14.68  c-8.81,0-15.45,6.18-15.45,14.68V90.44z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                style: {
                    fill: "#FF9F27"
                },
                d: "M20.1,20.61h71.06v29.97H20.1V20.61z M20.1,151.62h71.06v-29.97H20.1V151.62z M91.15,121.65h29.97V50.59H91.15  V121.65z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                style: {
                    fill: "#575559"
                },
                d: "M766.15,29.38c9.91,0,17.95,8.04,17.95,17.95c0,9.91-8.04,17.94-17.95,17.94c-9.91,0-17.94-8.04-17.94-17.94  C748.21,37.42,756.24,29.38,766.15,29.38 M766.15,61.98c8.19,0,14.66-6.47,14.66-14.66c0-8.19-6.47-14.66-14.66-14.66  c-8.19,0-14.66,6.47-14.66,14.66C751.49,55.51,757.96,61.98,766.15,61.98 M763.02,49.6v6.32h-3.29V38.73h7.89  c3.49,0,5.46,1.97,5.46,5.46c0,3.03-1.67,4.7-3.74,5.26l3.79,6.47h-3.64l-3.54-6.32H763.02z M767.82,46.97  c1.26,0,1.87-0.91,1.87-1.97v-1.72c0-1.16-0.66-1.87-1.87-1.87h-4.8v5.56H767.82z"
            })
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");
function $40e3ff42cf90ee3a$export$2e2bcd8739ae039({ className: className = "w2rem ma" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        className: className,
        viewBox: "0 0 205 23",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
            id: "Assets/Logo",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                id: "Logo",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        id: "SVGID_1_-link",
                        transform: "translate(0.000000, 0.012972)",
                        fill: "#23E5AF",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M1.10926573,17.9796707 C-0.277316434,15.5549006 -0.253201961,12.5724333 1.15749468,10.159787 L6.66765164,0.763802601 C6.90879637,0.339467823 7.35491411,0.0727431048 7.83720356,0.0727431048 C8.31949301,0.0727431048 8.76561075,0.339467823 9.00675547,0.763802601 L14.5169124,10.159787 C15.9276091,12.5724333 15.9396663,15.5549006 14.5651414,17.9796707 C13.1906164,20.4044409 10.6103679,21.8956746 7.83720356,21.8956746 C5.05198199,21.8956746 2.48379067,20.4044409 1.10926573,17.9796707 L1.10926573,17.9796707 Z",
                            id: "SVGID_1_"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M26.4321771,17.7879395 C26.9745481,18.4202356 27.800431,18.9309363 28.9468059,19.3078821 C30.0808541,19.6848278 31.2765355,19.8672209 32.5215232,19.8672209 C33.5939384,19.8672209 34.5554141,19.733466 35.3812971,19.4659561 C36.2071801,19.1984462 36.8728171,18.83366 37.3782082,18.3594379 C37.8835992,17.8852159 38.2533976,17.3501961 38.5122564,16.7665382 C38.7711152,16.1828803 38.8943814,15.5262651 38.8943814,14.8331713 C38.8943814,14.1887157 38.7834419,13.6050578 38.5615629,13.0943571 C38.3396838,12.5836564 38.0438452,12.1580725 37.6740468,11.8297649 C37.3042485,11.5014573 36.8728171,11.2096284 36.3920792,10.954278 C35.9113414,10.6989277 35.4059503,10.5043751 34.875906,10.3584606 C34.3458617,10.2125461 33.8158174,10.0666316 33.2980997,9.92071713 C32.7803821,9.77480265 32.274991,9.64104771 31.7942531,9.50729277 C31.3135153,9.37353782 30.8944105,9.22762334 30.5246122,9.08170886 C30.1548138,8.92363484 29.8589751,8.7290822 29.6494227,8.49805094 C29.4398703,8.26701968 29.3289308,7.98735026 29.3289308,7.67120222 C29.3289308,7.07538475 29.5754631,6.60116269 30.0808541,6.23637649 C30.5739186,5.87159029 31.2395556,5.68919718 32.0777652,5.68919718 C33.5199788,5.68919718 34.7896197,6.05398339 35.923668,6.78355579 C36.1578736,6.94162981 36.4167325,7.02674659 36.7125711,7.02674659 C37.0823695,7.02674659 37.415188,6.89299165 37.6987,6.63764131 C37.9822121,6.38229097 38.1301315,6.06614293 38.1301315,5.70135672 C38.1301315,5.39736822 38.0315186,5.12985834 37.8466194,4.92314616 C37.3289017,4.36380732 36.5523252,3.93822342 35.4922366,3.62207537 C34.432148,3.30592733 33.384386,3.14785331 32.3242974,3.14785331 C30.5369388,3.14785331 29.0947252,3.59775629 27.9853302,4.49756226 C26.8759352,5.39736822 26.2965844,6.50388637 26.2965844,7.86575486 C26.2965844,8.51021048 26.4075239,9.08170886 26.6170763,9.58025001 C26.8266287,10.0787911 27.1224674,10.4922155 27.4922657,10.8083636 C27.8620641,11.1245116 28.2811689,11.4163406 28.7742333,11.6595314 C29.2549712,11.9027222 29.7603622,12.0972748 30.2904065,12.2431893 C30.8204508,12.3891038 31.3381685,12.5228587 31.8682128,12.6687732 C32.3982571,12.8146877 32.9036482,12.9484426 33.384386,13.0821975 C33.8651239,13.2159525 34.2965553,13.361867 34.6663536,13.5321005 C35.036152,13.7023341 35.3319906,13.9212058 35.541543,14.1887157 C35.7510954,14.4562256 35.8620349,14.7602141 35.8620349,15.1250003 C35.8620349,15.7208177 35.5908495,16.2315184 35.0484786,16.6692619 C34.5061077,17.1070053 33.6925513,17.325877 32.6201361,17.325877 C31.0300032,17.325877 29.6001163,16.8394954 28.3058221,15.8667322 C28.0839431,15.6964987 27.8250842,15.6113819 27.5292456,15.6113819 C27.1594472,15.6113819 26.8389553,15.7451368 26.5554433,16.0248062 C26.2719312,16.3044757 26.1240119,16.6206237 26.1240119,16.9975694 C26.1363385,17.2772389 26.2349514,17.5325892 26.4321771,17.7879395 L26.4321771,17.7879395 L26.4321771,17.7879395 Z M45.4767919,19.0525317 C45.821937,19.3929988 46.2410418,19.5632324 46.7341063,19.5632324 L55.1408553,19.5632324 C55.4860004,19.5632324 55.7818391,19.441637 56.0283713,19.1862867 C56.2749036,18.9309363 56.3981697,18.6147883 56.3981697,18.2500021 C56.3981697,17.9095349 56.2749036,17.617706 56.0283713,17.3745152 C55.7818391,17.1313244 55.4860004,17.009729 55.1408553,17.009729 L47.8928078,17.009729 L47.8928078,12.5836564 L54.9682828,12.5836564 C55.3134279,12.5836564 55.6092665,12.462061 55.8557988,12.2188702 C56.102331,11.9756794 56.2255971,11.6716909 56.2255971,11.3312238 C56.2255971,10.9664376 56.102331,10.6624491 55.8557988,10.4070987 C55.6092665,10.1517484 55.3134279,10.030153 54.9682828,10.030153 L47.8928078,10.030153 L47.8928078,5.89590937 L55.1408553,5.89590937 C55.4860004,5.89590937 55.7818391,5.77431397 56.0283713,5.53112316 C56.2749036,5.28793236 56.3981697,4.98394386 56.3981697,4.64347674 C56.3981697,4.29085008 56.2749036,3.98686158 56.0283713,3.73151123 C55.7818391,3.47616089 55.4860004,3.35456549 55.1408553,3.35456549 L46.7341063,3.35456549 C46.2410418,3.35456549 45.821937,3.52479905 45.4767919,3.86526618 C45.1316468,4.2057333 44.9590742,4.61915766 44.9590742,5.09337972 L44.9590742,17.8244182 C44.9590742,18.2986402 45.1316468,18.6999051 45.4767919,19.0525317 L45.4767919,19.0525317 Z M63.1654794,19.0525317 C63.5106245,19.3929988 63.9297293,19.5632324 64.4227938,19.5632324 L72.8295428,19.5632324 C73.1746879,19.5632324 73.4705266,19.441637 73.7170588,19.1862867 C73.9635911,18.9309363 74.0868572,18.6147883 74.0868572,18.2500021 C74.0868572,17.9095349 73.9635911,17.617706 73.7170588,17.3745152 C73.4705266,17.1313244 73.1746879,17.009729 72.8295428,17.009729 L65.5814952,17.009729 L65.5814952,12.5836564 L72.6569702,12.5836564 C73.0021154,12.5836564 73.297954,12.462061 73.5444863,12.2188702 C73.7910185,11.9756794 73.9142846,11.6716909 73.9142846,11.3312238 C73.9142846,10.9664376 73.7910185,10.6624491 73.5444863,10.4070987 C73.297954,10.1517484 73.0021154,10.030153 72.6569702,10.030153 L65.5814952,10.030153 L65.5814952,5.89590937 L72.8295428,5.89590937 C73.1746879,5.89590937 73.4705266,5.77431397 73.7170588,5.53112316 C73.9635911,5.28793236 74.0868572,4.98394386 74.0868572,4.64347674 C74.0868572,4.29085008 73.9635911,3.98686158 73.7170588,3.73151123 C73.4705266,3.47616089 73.1746879,3.35456549 72.8295428,3.35456549 L64.4227938,3.35456549 C63.9297293,3.35456549 63.5106245,3.52479905 63.1654794,3.86526618 C62.8203343,4.2057333 62.6477617,4.61915766 62.6477617,5.09337972 L62.6477617,17.8244182 C62.6477617,18.2986402 62.8203343,18.6999051 63.1654794,19.0525317 L63.1654794,19.0525317 Z M80.8664935,19.0525317 C81.2116386,19.3929988 81.6307434,19.5632324 82.1238079,19.5632324 L86.4751017,19.5632324 C88.1515209,19.5632324 89.6553675,19.2227653 90.9619883,18.541831 C92.2686091,17.8608968 93.2917179,16.9002931 94.0066614,15.6721796 C94.7339314,14.444066 95.0914032,13.0335594 95.0914032,11.4649787 C95.0914032,9.88423851 94.7339314,8.4858914 94.0066614,7.25777785 C93.2793913,6.02966431 92.2686091,5.06906064 90.9619883,4.37596686 C89.6553675,3.68287307 88.1515209,3.34240595 86.4751017,3.34240595 L82.1238079,3.34240595 C81.6307434,3.34240595 81.2116386,3.51263951 80.8664935,3.85310664 C80.5213484,4.19357376 80.3487758,4.60699812 80.3487758,5.08122018 L80.3487758,17.8122586 C80.3364492,18.2986402 80.5090218,18.6999051 80.8664935,19.0525317 L80.8664935,19.0525317 Z M83.2825094,5.89590937 L86.4874283,5.89590937 C87.670783,5.89590937 88.6815652,6.15125971 89.544428,6.64980085 C90.4072908,7.14834199 91.035948,7.8171167 91.4550528,8.64396542 C91.8741576,9.47081414 92.08371,10.4192583 92.08371,11.4649787 C92.08371,13.0457189 91.5783189,14.3589493 90.5675367,15.4168292 C89.5567546,16.4747092 88.2008273,17.009729 86.4751017,17.009729 L83.2701827,17.009729 L83.2701827,5.89590937 L83.2825094,5.89590937 Z",
                        id: "Shape",
                        fill: "#AAAAAA",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M101.880022,19.0451551 C102.225515,19.3836528 102.645043,19.5529016 103.138604,19.5529016 L110.393957,19.5529016 C110.73945,19.5529016 111.035586,19.4320096 111.294706,19.1781363 C111.553826,18.9242631 111.677216,18.6099438 111.677216,18.2472677 C111.677216,17.90877 111.553826,17.6186292 111.294706,17.3768451 C111.035586,17.135061 110.73945,17.014169 110.393957,17.014169 L104.298473,17.014169 L104.298473,4.68318208 C104.298473,4.30841679 104.150405,3.99409751 103.866607,3.70395664 C103.582809,3.42590498 103.237316,3.28083454 102.842467,3.28083454 C102.42294,3.28083454 102.077447,3.41381577 101.793649,3.69186744 C101.509851,3.96991911 101.361783,4.29632759 101.361783,4.67109287 L101.361783,17.8120564 C101.349444,18.2956245 101.52219,18.6945682 101.880022,19.0451551 L101.880022,19.0451551 Z M118.105854,19.0451551 C118.451347,19.3836528 118.870874,19.5529016 119.364435,19.5529016 L127.779657,19.5529016 C128.12515,19.5529016 128.421287,19.4320096 128.668068,19.1781363 C128.914848,18.9242631 129.038239,18.6099438 129.038239,18.2472677 C129.038239,17.90877 128.914848,17.6186292 128.668068,17.3768451 C128.421287,17.135061 128.12515,17.014169 127.779657,17.014169 L120.524304,17.014169 L120.524304,12.6136992 L127.606911,12.6136992 C127.952404,12.6136992 128.24854,12.4928071 128.495321,12.2510231 C128.742102,12.009239 128.865492,11.707009 128.865492,11.3685113 C128.865492,11.0058352 128.742102,10.7036051 128.495321,10.4497319 C128.24854,10.1958586 127.952404,10.0749666 127.606911,10.0749666 L120.524304,10.0749666 L120.524304,5.96463758 L127.779657,5.96463758 C128.12515,5.96463758 128.421287,5.84374555 128.668068,5.6019615 C128.914848,5.36017744 129.038239,5.05794737 129.038239,4.71944969 C129.038239,4.3688628 128.914848,4.06663273 128.668068,3.81275947 C128.421287,3.55888621 128.12515,3.43799418 127.779657,3.43799418 L119.364435,3.43799418 C118.870874,3.43799418 118.451347,3.60724302 118.105854,3.9457407 C117.760361,4.28423838 117.587614,4.69527128 117.587614,5.16675019 L117.587614,17.8241456 C117.575275,18.2956245 117.748022,18.6945682 118.105854,19.0451551 L118.105854,19.0451551 Z M135.725996,15.8898732 C136.503355,17.1713287 137.552173,18.1626433 138.847771,18.8396387 C140.155709,19.5287232 141.599376,19.8672209 143.191112,19.8672209 C143.993149,19.8672209 144.795186,19.7705073 145.584885,19.57708 C146.374583,19.3836528 147.102586,19.1056011 147.756555,18.742925 C148.410524,18.3802489 148.941102,17.9208592 149.34829,17.3647559 C149.755478,16.8086526 149.965242,16.1921032 149.965242,15.5392863 L149.965242,12.6136992 C149.965242,12.1422203 149.792496,11.7311874 149.447003,11.3926897 C149.10151,11.054192 148.681982,10.8849432 148.188421,10.8849432 L143.302163,10.8849432 C142.95667,10.8849432 142.660533,11.0058352 142.413753,11.2476192 C142.166972,11.4894033 142.043582,11.7795442 142.043582,12.1180419 C142.043582,12.4928071 142.166972,12.7950372 142.413753,13.0489105 C142.660533,13.3027837 142.95667,13.4236758 143.302163,13.4236758 L147.028552,13.4236758 L147.028552,15.9019624 C146.621364,16.2888168 146.078446,16.6152253 145.375121,16.9053662 C144.671796,17.1955071 143.943793,17.3405775 143.178773,17.3405775 C141.562359,17.3405775 140.217404,16.7844742 139.156247,15.6843567 C138.082751,14.5842392 137.552173,13.1939809 137.552173,11.5014925 C137.552173,9.8090041 138.082751,8.43083497 139.143908,7.33071751 C140.205065,6.24268925 141.55002,5.68658592 143.178773,5.68658592 C143.882098,5.68658592 144.560745,5.81956715 145.214714,6.09761882 C145.868682,6.37567048 146.448617,6.76252497 146.954518,7.25818229 C147.225976,7.53623396 147.55913,7.66921519 147.94164,7.66921519 C148.311811,7.66921519 148.632626,7.53623396 148.916424,7.2823607 C149.187883,7.02848744 149.335951,6.72625737 149.335951,6.36358128 C149.335951,5.98881599 149.212561,5.68658592 148.96578,5.44480186 C147.460418,3.90947309 145.535529,3.14785331 143.191112,3.14785331 C142.006564,3.14785331 140.896051,3.35336976 139.834894,3.75231346 C138.773737,4.15125715 137.860649,4.70736048 137.083289,5.42062345 C136.30593,6.13388642 135.688979,7.01639823 135.232434,8.06815889 C134.77589,9.11991954 134.553787,10.2563046 134.553787,11.5014925 C134.553787,13.1456241 134.948636,14.6084176 135.725996,15.8898732 L135.725996,15.8898732 Z M155.789267,19.2264931 C156.085403,19.5408124 156.467914,19.6858829 156.924458,19.6858829 C157.232934,19.6858829 157.529071,19.6012584 157.800529,19.4199204 C158.071988,19.2506716 158.257074,19.0209767 158.355786,18.7308358 L159.244196,16.4701549 L166.733991,16.4701549 L167.597723,18.7308358 C167.721114,19.0209767 167.906199,19.2506716 168.165319,19.4199204 C168.424439,19.5891692 168.708236,19.6858829 169.029051,19.6858829 C169.485596,19.6858829 169.868106,19.5287232 170.164242,19.2023147 C170.460379,18.8759063 170.608448,18.5253194 170.608448,18.1263757 C170.608448,17.9933945 170.571431,17.8120564 170.509735,17.5944508 L165.352019,4.7919849 C165.154594,4.30841679 164.82144,3.9336515 164.364896,3.64351063 C163.93303,3.38963737 163.488825,3.26874534 163.007602,3.26874534 C162.970585,3.26874534 162.921229,3.26874534 162.884212,3.26874534 C162.378311,3.26874534 161.921767,3.40172657 161.50224,3.67977824 C161.082713,3.9578299 160.786576,4.32050599 160.60149,4.7919849 L155.468452,17.5944508 C155.382078,17.7395212 155.332722,17.9208592 155.332722,18.1263757 C155.345061,18.561587 155.49313,18.9242631 155.789267,19.2264931 L155.789267,19.2264931 Z M162.995263,6.32731367 L165.907275,13.9435115 L160.046234,13.9435115 L162.995263,6.32731367 L162.995263,6.32731367 Z M177.037085,19.0451551 C177.382578,19.3836528 177.802105,19.5529016 178.295667,19.5529016 L185.551019,19.5529016 C185.896512,19.5529016 186.192649,19.4320096 186.451769,19.1781363 C186.710889,18.9242631 186.834279,18.6099438 186.834279,18.2472677 C186.834279,17.90877 186.710889,17.6186292 186.451769,17.3768451 C186.192649,17.135061 185.896512,17.014169 185.551019,17.014169 L179.455536,17.014169 L179.455536,4.68318208 C179.455536,4.30841679 179.307467,3.99409751 179.02367,3.70395664 C178.739872,3.42590498 178.394379,3.28083454 177.99953,3.28083454 C177.580003,3.28083454 177.23451,3.41381577 176.950712,3.69186744 C176.666914,3.96991911 176.518846,4.29632759 176.518846,4.67109287 L176.518846,17.8120564 C176.518846,18.2956245 176.691592,18.6945682 177.037085,19.0451551 L177.037085,19.0451551 Z M192.337489,17.787878 C192.880406,18.4165166 193.707121,18.9242631 194.854652,19.2990284 C195.989843,19.6737937 197.186729,19.8551317 198.432972,19.8551317 C199.506468,19.8551317 200.468913,19.7221505 201.295628,19.456188 C202.122343,19.1902255 202.788651,18.8275495 203.294552,18.3560705 C203.800452,17.8845916 204.170623,17.3526667 204.429743,16.772385 C204.688863,16.1921032 204.812253,15.5392863 204.812253,14.8502017 C204.812253,14.209474 204.701202,13.6291922 204.479099,13.1214457 C204.256996,12.6136992 203.96086,12.1905771 203.590688,11.8641686 C203.220517,11.5377601 202.788651,11.2476192 202.307429,10.993746 C201.826206,10.7398727 201.320306,10.5464455 200.789728,10.401375 C200.259149,10.2563046 199.728571,10.1112342 199.210331,9.96616374 C198.692092,9.8210933 198.186191,9.68811207 197.704969,9.55513084 C197.223746,9.42214961 196.804219,9.27707917 196.434048,9.13200874 C196.063877,8.9748491 195.76774,8.78142186 195.557977,8.551727 C195.335874,8.30994294 195.237162,8.04398048 195.237162,7.7296612 C195.237162,7.13729026 195.483942,6.66581135 195.989843,6.30313526 C196.483404,5.94045918 197.149712,5.75912113 197.988767,5.75912113 C199.432434,5.75912113 200.703354,6.12179722 201.838546,6.84714939 C202.072987,7.00430903 202.332107,7.08893345 202.628244,7.08893345 C202.998415,7.08893345 203.331569,6.95595222 203.615367,6.70207896 C203.899164,6.4482057 204.047233,6.13388642 204.047233,5.77121034 C204.047233,5.46898027 203.948521,5.2030178 203.763435,4.99750135 C203.245196,4.44139802 202.467836,4.01827592 201.406679,3.70395664 C200.345522,3.38963737 199.296704,3.23247773 198.235547,3.23247773 C196.446387,3.23247773 195.00272,3.67977824 193.892207,4.57437925 C192.781694,5.46898027 192.226437,6.60536534 192.226437,7.95935606 C192.226437,8.60008381 192.337489,9.16827635 192.547252,9.66393367 C192.757016,10.159591 193.053153,10.5706239 193.423324,10.8849432 C193.793495,11.1992624 194.213022,11.4894033 194.706583,11.7311874 C195.187806,11.9729714 195.693706,12.1663987 196.224285,12.3114691 C196.754863,12.4565395 197.273103,12.5895208 197.803681,12.7345912 C198.33426,12.8796616 198.84016,13.0126429 199.321382,13.1456241 C199.802605,13.2786053 200.234471,13.4236758 200.604642,13.5929246 C200.974813,13.7621734 201.27095,13.9797791 201.480713,14.2457416 C201.690477,14.511704 201.801528,14.8139341 201.801528,15.1766102 C201.801528,15.7689811 201.53007,16.2767276 200.987152,16.7119389 C200.444235,17.1471503 199.629858,17.3647559 198.556362,17.3647559 C196.964627,17.3647559 195.533299,16.8811878 194.2377,15.9140516 C194.015597,15.7448027 193.756478,15.6601783 193.460341,15.6601783 C193.09017,15.6601783 192.769355,15.7931595 192.485557,16.0712112 C192.201759,16.3492629 192.053691,16.6635821 192.053691,17.0383474 C192.029013,17.2801315 192.140064,17.5340047 192.337489,17.787878 L192.337489,17.787878 L192.337489,17.787878 Z",
                        id: "Shape",
                        fill: "#5C5B5C",
                        fillRule: "nonzero"
                    })
                ]
            })
        })
    });
}






























function $a901588e5eccdb19$export$2e2bcd8739ae039({ getUser: getUser, setIsWorkflowReport: setIsWorkflowReport, profileClass: profileClass, advisors: advisors, permissionLevel: permissionLevel, tab: tab, sanitiseTab: sanitiseTab, company: company, setCompany: setCompany, companyId: companyId, openKPI: openKPI, toggleReport: toggleReport, calculateStats: calculateStats, calculateSubFolderStats: calculateSubFolderStats, setCompanyDashboardTab: setCompanyDashboardTab, getCompletenessAndRiskHTML: getCompletenessAndRiskHTML, aiEnhanced: aiEnhanced, fileReport: fileReport, setFileReport: setFileReport, setAiEnchaned: setAiEnchaned, reloadModule: reloadModule, twoMinuteTestAIReport: twoMinuteTestAIReport, getFitInvestorFirms: getFitInvestorFirms, sortSections: sortSections, reportHistories: reportHistories, setReportHistories: setReportHistories, handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness, updateUserType: updateUserType, handlePartnerChecklistNext: handlePartnerChecklistNext, setTab: setTab, setTabName: setTabName, closeTab: closeTab, isBackFitReport: isBackFitReport, setIsBackFitReport: setIsBackFitReport, isLoader: isLoader, setIsLoader: setIsLoader }) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let { logList: logList, targetSection: targetSection } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const fileImportRef = (0, $acw62.useRef)(null);
    const sectionRefs = (0, $acw62.useRef)([]);
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [section, setSection] = (0, $acw62.useState)();
    let [dupCheck, setDupCheck] = (0, $acw62.useState)({});
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    let [logModule, setLogModule] = (0, $acw62.useState)([]);
    let [deleteFile, setDeleteFile] = (0, $acw62.useState)();
    let [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    let [saveTimeout, setSaveTimeout] = (0, $acw62.useState)();
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [currentScore, setCurrentScore] = (0, $acw62.useState)(0);
    let [visibleSection, setVisibleSection] = (0, $acw62.useState)(null);
    let [newUpgradeSync, setNewUpgradeSync] = (0, $acw62.useState)(false);
    let [isFAMenuVisible, setFAMenuVisible] = (0, $acw62.useState)(false);
    let [unallocatedFiles, setUnallocatedFiles] = (0, $acw62.useState)([]);
    let [cloneImportResult, setCloneImportResult] = (0, $acw62.useState)({});
    let [deleteFileQuestionId, setDeleteFileQuestionId] = (0, $acw62.useState)();
    let [deleteUnallocatedFile, setDeleteUnallocatedFile] = (0, $acw62.useState)();
    let [questionsAndAnswersToSave, setQuestionsAndAnswersToSave] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!modal.diagnoseFixJustApplied) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            diagnoseFixJustApplied: false
        }));
        if (tab && reloadModule) reloadModule(tab, true);
    }, [
        modal.diagnoseFixJustApplied
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            const sectionPositions = sectionRefs.current.map((ref)=>{
                const id = ref?.id?.split('.')[0];
                const top = Math.floor(ref?.getBoundingClientRect().top);
                return {
                    id: id,
                    top: top
                };
            });
            const currentSection = sectionPositions.find((position)=>position?.['top'] >= 0 && position.top < window.innerHeight);
            if (currentSection) setVisibleSection(currentSection.id);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    const syncDrive = async (sectionId, qNo)=>{
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = newUpgradeSync;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncGDriveDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, true);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (newUpgradeSync) setNewUpgradeSync(false);
        window.location.reload();
    };
    const syncDropbox = async (sectionId, qNo)=>{
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        // setNewUpgradeSync(true);
        body['newUpgradeSync'] = newUpgradeSync;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncDropBoxDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, true);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
    };
    const syncSharePoint = async (sectionId, qNo)=>{
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = newUpgradeSync;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncSharePointDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, true);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (questionsAndAnswersToSave.length) {
            if (isSaving) setSaveTimeout(setTimeout(()=>setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                        ...questionsAndAnswersToSave
                    ]), 1000));
            else save();
        }
    }, [
        questionsAndAnswersToSave,
        isSaving
    ]);
    const confirmDeleteFile = async (from)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: deleteFile,
            questionId: deleteFileQuestionId,
            companyId: companyId
        });
        if (!res || res['code'] != 200) return;
        if (tab) await reloadModule(tab);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (section) {
            section.files = section.files.filter((f)=>f.key != deleteFile.key);
            setSection(section);
            setRefresh(!refresh);
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: from
        }));
    };
    const confirmDeleteUnallocatedFile = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/deleteUnallocatedFile', {
            fileReportId: deleteUnallocatedFile.id,
            file: deleteUnallocatedFile.file,
            companyId: companyId
        });
        if (!res || res['code'] != 200) return;
        setUnallocatedFiles(unallocatedFiles.filter((f)=>f.file.key != deleteUnallocatedFile.file.key));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedFiles'
        }));
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e, question, qNo)=>{
        if (!company['uploadedFile'] || !company['syncRequired']) {
            company['uploadedFile'] = true;
            company['syncRequired'] = true;
            dispatch(setCompany(company));
        }
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        e.target.querySelector("input").value = null;
        saveAnswer(e, question, qNo);
    };
    const radioButtonChanged = (e, question, qNo, moduleType)=>{
        // question = Object.freeze(question);
        question = JSON.parse(JSON.stringify(question));
        const option = e.target.dataset.option;
        const wrapper = e.target.closest("[data-question-id]");
        //TODO: change to toggleHeight
        for (const showOrHideEl of wrapper.querySelectorAll(".showOrHide"))if (option === "Yes" || option == 'Disclosure') {
            showOrHideEl.classList.remove("dn");
            setTimeout(()=>showOrHideEl.classList.remove("op0", "h0"), 100);
        } else {
            showOrHideEl.classList.add("op0", "h0");
            setTimeout(()=>showOrHideEl.classList.add("dn"), 300);
        }
        if (!question['answer'] || question['answer'] == undefined) question['answer'] = {};
        question['answer']['radioOption'] = option;
        if (option == 'No') question['answer']['status'] = 'Completed';
        else if (option == 'N/A') question['answer']['status'] = 'Not Applicable';
        else if ([
            'T',
            'Date',
            'DropDown'
        ].includes(question['questionType'])) {
            question['answer']['status'] = 'Completed';
            question['answer']['radioOption'] = 'Yes';
        } else if (question['questionType'].includes('F') || option == 'Disclosure' && moduleType == 'warranty-disclosure') question['answer']['status'] = 'In Progress';
        else question['answer']['status'] = 'Completed';
        saveAnswer(e, question, qNo);
    };
    const cloneFile = (file)=>{
        const clonedFile = new File([
            file
        ], file.name, {
            type: file.type
        });
        return clonedFile;
    };
    const handleFileChange = async (e)=>{
        attachment = [];
        let relPaths = [];
        let filesInfo = [];
        setFAMenuVisible(false);
        let percent = 0;
        let currentCount = 0;
        let filesUploaded = 0;
        const totalFiles = e.target.files.length;
        const totalFileCount = e.target.files.length;
        document.getElementById('upload-file-name').innerHTML = '';
        document.getElementById('upload-progress-bar').value = percent;
        document.getElementById('upload-progress-val').innerHTML = `${currentCount}/${totalFileCount}`;
        for (const file of e.target.files){
            relPaths.push(file.webkitRelativePath);
            const clonedFile = cloneFile(file);
            attachment = [
                clonedFile
            ];
            document.getElementById('upload-file-name').innerHTML = file.name;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/uploadFile`, {
                attachment: attachment
            }, true);
            if (!res) continue;
            if (!res.body?.['report']) continue;
            currentCount++;
            filesInfo.push(res.body['report']);
            filesUploaded = filesUploaded + 1;
            percent = filesUploaded / totalFiles * 100;
            document.getElementById('upload-progress-bar').value = percent;
            document.getElementById('upload-progress-val').innerHTML = `${currentCount}/${totalFileCount}`;
        }
        e.target.value = null;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'allocatingFiles'
        }));
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/uploadFiles`, {
            files: filesInfo,
            companyId: companyId,
            tab: tab,
            relPaths: relPaths
        }, true);
        if (!res) return;
        if (!res.body?.['report']) return;
        // await reloadModule("repository", true);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch(setFileReport(res.body['report']));
        setCloneImportResult(JSON.parse(JSON.stringify(res.body['report']['importResult'])));
        const allocated = Object.keys(res.body['report']['importResult']).filter((key)=>res.body['report']['importResult'][key]['section'].some((element)=>!element.includes("DXXX"))).length;
        const total = Object.keys(res.body['report']['importResult']).length;
        setCurrentScore(total == 0 ? 0 : Math.round(allocated / total * 100));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'importSummary',
            from: ''
        }));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            fileReport: res.body['report'],
            company: company,
            currentScore: total == 0 ? 0 : Math.round(allocated / total * 100),
            reportHistories: reportHistories,
            tab: tab,
            updateFileAllocation: tab,
            profileClass: profileClass
        }));
    };
    const saveAnswer = (e, question, sectionNo)=>{
        question = JSON.parse(JSON.stringify(question));
        if ([
            'T',
            'F/T',
            'Date',
            'DropDown',
            'Radio',
            'Multi'
        ].includes(question['questionType'])) {
            question['answer'].status = 'Completed';
            question['answer'].radioOption = 'Yes';
        }
        if (e.target?.dataset?.option == 'Yes') question['answer'].status = 'Completed';
        clearTimeout(saveTimeout);
        let questionAndAnswerToSave = questionsAndAnswersToSave.find((q)=>q._id == question['_id']);
        if (!questionAndAnswerToSave) {
            questionAndAnswerToSave = {
                ...question,
                sectionNo: sectionNo,
                moduleType: question['type'],
                answer: {
                    _id: question.answer?._id,
                    fileIndexes: [],
                    logs: question.answer?.logs,
                    ...question.answer
                }
            };
            if (question?.['answer']?.['status']) questionAndAnswerToSave['answer']['status'] = question['answer']['status'];
            questionsAndAnswersToSave.push(questionAndAnswerToSave);
        }
        if (question['questionType'] == 'Radio') questionAndAnswerToSave.answer['dropdown'] = e.target.dataset.option;
        else if (question['questionType'] == 'Multi') {
            let answer = '';
            e.target.value.map((value)=>{
                if (value.length == 0) return;
                if (answer.length > 0) answer = answer + ';' + value;
                else answer = value;
            });
            questionAndAnswerToSave.answer[e.target.name] = answer;
        } else if (e.target.dataset && e.target.dataset.option) questionAndAnswerToSave.answer.radioOption = e.target.dataset.option;
        else if (e.target.files) {
            for (const file of e.target.files){
                let index = attachment.push(file) - 1;
                questionAndAnswerToSave.answer.fileIndexes.push(index);
            }
            //showMessage("Uploading files");
            if (!company['uploadedFile'] || !company['syncRequired']) {
                company['uploadedFile'] = true;
                company['syncRequired'] = true;
                dispatch(setCompany(company));
            }
            if (question['questionType'] == 'D/ND') questionAndAnswerToSave.answer.radioOption = 'Disclosure';
        // else questionAndAnswerToSave.answer.radioOption = 'Yes';
        } else if (e.target.type === "checkbox") questionAndAnswerToSave.answer.status = e.target.checked ? "Completed" : "In Progress";
        else questionAndAnswerToSave.answer[e.target.name] = e.target.value || e.target.checked;
        if (e.target.files) setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                ...questionsAndAnswersToSave
            ]);
        else setSaveTimeout(setTimeout(()=>setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                    ...questionsAndAnswersToSave
                ]), 2000));
    };
    const save = async ()=>{
        setIsSaving(true);
        setQuestionsAndAnswersToSave([]);
        let companyClone = JSON.parse(JSON.stringify({
            ...company
        }));
        let currentCount = 0, percent = 0, filesInfo = [];
        const totalFileCount = attachment.length;
        for (const file of attachment){
            // document.getElementById('upload-repository-file-name').innerHTML = file['name'];
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/newUploadFile`, {
                attachment: [
                    file
                ]
            }, true);
            if (!res) continue;
            if (!res.body?.['result']) continue;
            currentCount++;
            filesInfo.push(res.body['result']);
            percent = currentCount / totalFileCount * 100;
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'computerToDataRepository',
                percent: percent,
                fileName: file['name'],
                totalFiles: totalFileCount,
                filesUploaded: currentCount
            }));
        // document.getElementById('upload-repository-progress-bar').value = percent;
        // document.getElementById('upload-repository-progress-val').innerHTML = `${currentCount}/${totalFileCount}`;
        }
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/newSaveAnswers', {
            files: filesInfo,
            companyId: companyId,
            questionsAndAnswersToSave: questionsAndAnswersToSave
        }, true);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (!res || res['code'] != 200) return setIsSaving(false);
        const { answerErrors: answerErrors, savedQuestions: savedQuestions } = res['body'];
        for (let question of savedQuestions){
            let { sectionNo: sectionNo, _id: _id } = question;
            let moduleName = question['moduleType'] || question['type'];
            if (window.location.hash.includes('directors-questionnaire')) moduleName = window.location.hash.replace('#', '');
            let module = companyClone['modules'][moduleName];
            if (answerErrors[_id]) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(answerErrors[_id]);
                continue;
            }
            // This is for expension pack subsections
            if (module?.['expansionPack']) for (let key of Object.keys(module.sections[0]['subFolders'])){
                let section = module.sections[0]['subFolders'][key];
                if (sectionNo.includes(section['sectionNo'])) {
                    let questionIndex = section['questions'].findIndex(({ _id: _id })=>_id == question['_id']);
                    module.sections[0]['subFolders'][key]['questions'][questionIndex] = question;
                }
            }
            else {
                if (module?.sections) {
                    for (let section of module?.sections)if (sectionNo.includes(`${section['sectionNo']}`)) {
                        let questionIndex = section['questions'].findIndex(({ _id: _id })=>_id == question['_id']);
                        // question['answer']['logs'] = section['questions'][questionIndex]?.['answer']?.['logs']; // Keep previous logs with user details
                        section['updatedAt'] = Date.now();
                        section['questions'][questionIndex] = question;
                        if (question['answer']['updatedBy']) section['questions'][questionIndex]['answer']['updatedBy'] = question['answer']['updatedBy'];
                    }
                }
            }
            companyClone.modules[moduleName] = module;
        }
        // await dispatch(setCompany(calculateStats(companyClone, "", "404DD"))); // Sidebar Completeness not working with it
        await dispatch(setCompany(calculateStats(companyClone, tab, "check2")));
        //if (!repoStarted) setRepoStarted(!!repositoryClone.answers?.find(a => a.radioOption));
        setAttachment([]); //TODO: only remove successful attachments. undo answers set on UI like radio button checks and files selected if it failed
        //questionsAndAnswersToSave.push(...currentQuestionsAndAnswersToSave); //TODO: add failed ones back
        setIsSaving(false);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    const handleEditDispatch = (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(true));
    };
    const getFileHTML = (section, file)=>{
        let module = company.modules[tab];
        if (module) module = JSON.parse(JSON.stringify(module));
        const curQno = section?.['questionId'] || section.sectionNo || section.no;
        let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
        const key = file.key;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcfs aic w100 px1rem py0-5rem td250 bsbb",
                children: [
                    [
                        "pdf"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z"
                            })
                        ]
                    }) || [
                        "mp4",
                        "webm",
                        "mkv",
                        "ogg",
                        "avi",
                        "mov"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM192 256H96C78.33 256 64 270.3 64 288v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288C224 270.3 209.7 256 192 256zM295.5 271.3L256 296v80l39.52 24.7C306.2 407.4 320 399.7 320 387.1V284.9C320 272.3 306.2 264.6 295.5 271.3z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM224 384c0 17.67-14.33 32-32 32H96c-17.67 0-32-14.33-32-32V288c0-17.67 14.33-32 32-32h96c17.67 0 32 14.33 32 32V384zM320 387.1c0 12.57-13.82 20.23-24.48 13.57L256 376v-80l39.52-24.7C306.2 264.6 320 272.3 320 284.9V387.1z"
                            })
                        ]
                    }) || [
                        "sheet",
                        "xlsx",
                        "xls",
                        "xlsm",
                        "ots",
                        "csv"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM312 224h-240c-8.875 0-16 7.125-16 16v192c0 8.875 7.125 16 16 16h240c8.875 0 16-7.125 16-16v-192C328 231.1 320.9 224 312 224zM136 416h-48v-48h48V416zM136 336h-48V288h48V336zM216 416h-48v-48h48V416zM216 336h-48V288h48V336zM296 416h-48v-48h48V416zM296 336h-48V288h48V336z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM328 432c0 8.875-7.125 16-16 16h-240c-8.875 0-16-7.125-16-16v-192c0-8.875 7.125-16 16-16h240c8.875 0 16 7.125 16 16V432z"
                            })
                        ]
                    }) || [
                        "png",
                        "jpg",
                        "jpeg",
                        "gif",
                        "bmp",
                        "svg",
                        "webp"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM231.1 295.1C229 290.7 224 288 218.7 288s-10.35 2.674-13.31 7.125L160 363.2l-13.35-20.03C143.7 338.7 138.7 336 133.3 336s-10.35 2.674-13.31 7.125l-53.33 80c-3.273 4.908-3.578 11.22-.7949 16.42C68.68 444.8 74.1 448 80 448h224c5.9 0 11.32-3.248 14.11-8.451c2.783-5.201 2.479-11.52-.7949-16.42L231.1 295.1z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 224c17.67 0 32 14.33 32 32S113.7 288 96 288S64 273.7 64 256S78.33 224 96 224zM318.1 439.5C315.3 444.8 309.9 448 304 448h-224c-5.9 0-11.32-3.248-14.11-8.451c-2.783-5.201-2.479-11.52 .7949-16.42l53.33-80C122.1 338.7 127.1 336 133.3 336s10.35 2.674 13.31 7.125L160 363.2l45.35-68.03C208.3 290.7 213.3 288 218.7 288s10.35 2.674 13.31 7.125l85.33 128C320.6 428 320.9 434.3 318.1 439.5z"
                            })
                        ]
                    }) || [
                        "zip",
                        "7z",
                        "gz",
                        "tar.gz"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M160 32H96v32h64V32zM160 160H96v32h64V160zM160 96H96v32h64V96zM256 0v128h128L256 0zM160 224H96l-30.56 116.5c-7.93 39 22.26 75.45 62.83 75.45c40.26 0 70.45-36.3 62.68-75.15L160 224zM144 368h-32C103.2 368 96 360.8 96 352s7.164-16 16-16h32C152.8 336 160 343.2 160 352S152.8 368 144 368z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 32h64v32H96V32zM96 96h64v32H96V96zM96 160h64v32H96V160zM128.3 415.1c-40.56 0-70.76-36.45-62.83-75.45L96 224h64l30.94 116.9C198.7 379.7 168.5 415.1 128.3 415.1z"
                            })
                        ]
                    }) || [
                        "doc",
                        "docx",
                        "docm",
                        "rtf",
                        "odt",
                        "dot",
                        "dotx"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM304.9 240h-23.37c-5.588 0-10.44 3.859-11.69 9.301L246.2 352L218.4 248.9C216.1 243.6 212.2 240 206.8 240H177.2c-5.426 0-10.18 3.641-11.59 8.883L137.8 352L114.1 249.3C112.9 243.9 108 240 102.5 240H79.08c-7.717 0-13.43 7.18-11.69 14.7l42.46 184C111.1 444.1 115.1 448 121.5 448h29.26c5.428 0 10.18-3.641 11.59-8.883L192 329.1l29.61 109.1C223 444.4 227.8 448 233.2 448h29.26c5.588 0 10.44-3.859 11.69-9.305l42.46-184C318.3 247.2 312.6 240 304.9 240z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM274.1 438.7C272.9 444.1 268 448 262.5 448h-29.26c-5.426 0-10.18-3.641-11.59-8.883L192 329.1l-29.61 109.1C160.1 444.4 156.2 448 150.8 448H121.5c-5.588 0-10.44-3.859-11.69-9.305l-42.46-184C65.66 247.2 71.37 240 79.08 240h23.37c5.588 0 10.44 3.859 11.69 9.301L137.8 352L165.6 248.9C167 243.6 171.8 240 177.2 240h29.61c5.426 0 10.18 3.641 11.59 8.883L246.2 352l23.7-102.7C271.1 243.9 275.1 240 281.5 240h23.37c7.717 0 13.43 7.18 11.69 14.7L274.1 438.7z"
                            })
                        ]
                    }) || [
                        "pptx",
                        "pttm",
                        "ppt"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M199.5 240H128C119.2 240 112 247.2 112 256v176C112 440.8 119.2 448 128 448h16C152.8 448 160 440.8 160 432v-40h44c44.53 0 80.23-38.49 75.59-83.95C275.6 268.5 239.3 240 199.5 240zM204 344H160V288h44c15.44 0 28 12.56 28 28S219.4 344 204 344zM256 0v128h128L256 0z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M204 288H160v56h44c15.44 0 28-12.56 28-28S219.4 288 204 288zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM204 392H160v40C160 440.8 152.8 448 144 448H128c-8.836 0-16-7.164-16-16V256c0-8.836 7.164-16 16-16h71.51c39.75 0 76.05 28.52 80.08 68.05C284.2 353.5 248.5 392 204 392z"
                            })
                        ]
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM272 384h-160C103.2 384 96 391.2 96 400S103.2 416 112 416h160c8.836 0 16-7.164 16-16S280.8 384 272 384zM272 320h-160C103.2 320 96 327.2 96 336S103.2 352 112 352h160c8.836 0 16-7.164 16-16S280.8 320 272 320zM272 256h-160C103.2 256 96 263.2 96 272S103.2 288 112 288h160C280.8 288 288 280.8 288 272S280.8 256 272 256z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM272 416h-160C103.2 416 96 408.8 96 400S103.2 384 112 384h160c8.836 0 16 7.164 16 16S280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336S103.2 320 112 320h160c8.836 0 16 7.164 16 16S280.8 352 272 352zM272 288h-160C103.2 288 96 280.8 96 272S103.2 256 112 256h160C280.8 256 288 263.2 288 272S280.8 288 272 288z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        target: "_blank",
                        to: getViewableURL(file.url),
                        rel: "noopener noreferrer",
                        style: {
                            flex: 1
                        },
                        className: `mx1rem fs1rem fw600 bg1 ${fileColor}`,
                        children: file.title
                    }),
                    tab != 'repository' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mla mr1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "rs-nav rs-nav-default",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        onClick: ()=>handleEditDispatch({
                                                key: key,
                                                fileName: file.title
                                            }),
                                        className: "rs-dropdown-toggle rs-nav-item",
                                        children: [
                                            targetSection[key] && `${targetSection[key]['qNo']}. ${targetSection[key]['name']}` || 'Please select section',
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                width: "1em",
                                                height: "1em",
                                                viewBox: "0 0 16 16",
                                                fill: "currentColor",
                                                "aria-hidden": "true",
                                                focusable: "false",
                                                className: "rs-nav-item-caret rs-icon",
                                                "aria-label": "arrow down line",
                                                "data-category": "direction",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M8 11a.997.997 0 01-.707-.293l-3-3a.999.999 0 111.414-1.414L8 8.586l2.293-2.293a.999.999 0 111.414 1.414l-3 3A.997.997 0 018 11z"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                "data-tooltip": "Move",
                                className: "h1rem mr1rem cp",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    moveFile(curQno, file, true, targetSection[key]?.['qNo'], targetSection[key]?.['name'], false);
                                },
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 20 20",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M9.77 11.5l5.34 3.91c.44.33 1.24.59 1.79.59H20L6.89 6.38A3.5 3.5 0 105.5 8.37L7.73 10 5.5 11.63a3.5 3.5 0 101.38 1.99l2.9-2.12zM3.5 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM15.1 4.59A3.53 3.53 0 0116.9 4H20l-7.5 5.5L10.45 8l4.65-3.41z"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                "data-tooltip": "Copy",
                                className: "h1rem mr1rem cp",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    moveFile(curQno, file, false, targetSection[key]?.['qNo'], targetSection[key]?.['name'], false);
                                },
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 256 256",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                    fill: "#000",
                                    strokeMiterlimit: "10",
                                    strokeWidth: "1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M51.047 40.954H14.692a1 1 0 000 2h36.354a1 1 0 00.001-2zM51.047 55.05H14.692a1 1 0 100 2h36.354a1 1 0 10.001-2zM51.047 69.146H14.692a1 1 0 100 2h36.354a1 1 0 10.001-2z",
                                            transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M87.894 16.034a.991.991 0 00-.053-.263c-.011-.032-.02-.063-.034-.093a.987.987 0 00-.2-.295L72.211.286a.967.967 0 00-.29-.191c-.032-.015-.065-.023-.098-.034a.949.949 0 00-.246-.048C71.554.011 71.533 0 71.511 0H33.138a6.792 6.792 0 00-6.785 6.785v2.313H8.878a6.792 6.792 0 00-6.785 6.785v67.333A6.792 6.792 0 008.878 90h47.983a6.792 6.792 0 006.785-6.784v-2.313h17.476a6.791 6.791 0 006.784-6.784V16.097c0-.022-.011-.041-.012-.063zm-3.436-.937h-8.727a3.224 3.224 0 01-3.221-3.22V3.381l11.948 11.716zM61.646 83.216A4.79 4.79 0 0156.861 88H8.878a4.79 4.79 0 01-4.785-4.784V15.882a4.79 4.79 0 014.785-4.785h37.373V21.15a5.05 5.05 0 005.044 5.044h10.352v57.022zm-1.448-59.021h-8.903a3.047 3.047 0 01-3.044-3.044V12.48l11.947 11.715zm20.924 54.707H63.646V62.049h11.661a1 1 0 100-2H63.646V47.952h11.661a1 1 0 100-2H63.646V33.856h11.661a1 1 0 100-2H63.646v-6.662c0-.022-.011-.041-.013-.063a.976.976 0 00-.053-.262c-.012-.033-.021-.066-.035-.097a.999.999 0 00-.175-.26c-.008-.008-.012-.019-.021-.027l-.003-.004-15.387-15.09-.001-.001-.007-.006a.993.993 0 00-.282-.188c-.013-.006-.023-.016-.036-.021-.023-.01-.048-.008-.072-.016a.976.976 0 00-.245-.048c-.023-.002-.043-.013-.066-.013H28.354V6.785A4.79 4.79 0 0133.138 2h37.373v9.877a5.227 5.227 0 005.221 5.22h10.175v57.021a4.79 4.79 0 01-4.785 4.784z",
                                            transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        target: "_blank",
                        to: file.url,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            "data-tooltip": "Download",
                            className: `f3 h1rem cp mr1rem ${tab != 'repository' ? '' : 'mla'}`,
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 512 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary",
                                    d: "M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary",
                                    d: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    const Chevron = ({ className: className = "" })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            className: className,
            fill: "currentColor",
            viewBox: "0 0 20 20",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                clipRule: "evenodd"
            })
        });
    };
    function isSubarray(subarray, array) {
        const sortedSubarray = subarray.slice().sort();
        const sortedArray = array.slice().sort();
        let i = 0;
        return sortedArray.some((element)=>{
            if (element === sortedSubarray[i]) i++;
            return i === sortedSubarray.length;
        });
    }
    const onClickDeduperAuditLog = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getDeduperReportLog/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'deduperReportAuditLog'
        }));
    };
    const onClickUnallocatedBinAuditLog = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getUnallocatedBinLog/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedBinAuditLog'
        }));
    };
    const selectTargetSection = async (fileKey, qNo, name, from, index)=>{
        if (from == 'fileReport') {
            if (fileReport.importResult[fileKey]['section'][index] != qNo) {
                fileReport.importResult[fileKey]['section'][index] = qNo;
                // Calc Assistant Accuracy Score
                const score = calcAccuracyScore();
                fileReport.currentScore = score;
                const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/allocateFile`, {
                    companyId: companyId,
                    fileReportId: fileReport['_id'],
                    fileKey: fileKey,
                    index: index,
                    qNo: qNo,
                    score: score,
                    file: fileReport.importResult[fileKey]['file'],
                    isAdd: false
                });
                if (!res) return;
            }
        } else {
            let curSection = targetSection;
            curSection[fileKey] = {
                qNo: qNo,
                name: name
            };
            dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
        }
        setRefresh(!refresh);
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(false));
    };
    const getSectionDropDown = (section, fileKey, from, index)=>{
        const qNo = section.sectionNo || section.no;
        const name = section.sectionName || section.name;
        if (section.subFolders) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$d99097c13d4dac9f), {
                children: ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1be75d49f257bf03$export$5e3e5deaaf81ee41), {
                                className: 'w100 df aic dropdown-section-header jcsb cp bg5 mb0-5rem',
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                        style: {
                                            color: '#002d63'
                                        },
                                        children: [
                                            qNo,
                                            ". ",
                                            name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(Chevron, {
                                        className: `w1rem h1rem td300 ml0-5rem ${!open ? 'tr90deg' : 'tr270deg'}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1be75d49f257bf03$export$4f68206c92b94e7b), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `pl1rem`,
                                    children: Object.keys(section.subFolders).map((key)=>{
                                        return getSectionDropDown(section.subFolders[key], fileKey, from, index);
                                    })
                                })
                            })
                        ]
                    })
            }, qNo)
        });
        else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "rs-dropdown-item",
                onClick: ()=>selectTargetSection(fileKey, qNo, name, from, index),
                children: [
                    qNo,
                    ". ",
                    name
                ]
            })
        });
    };
    const getSectionNameFromSection = (section, qNo)=>{
        if (section.sectionNo == qNo || section.no == qNo) return section.sectionName || section.name;
        if (section.subFolders) for (const subFolder of Object.values(section.subFolders)){
            let result = getSectionNameFromSection(subFolder, qNo);
            if (result != "") return result;
        }
        return "";
    };
    const getSectionName = (module, qNo)=>{
        if (qNo == "DXXX") return "Unallocated Bin";
        const sections = module?.sections;
        for (const section of sections){
            const sectionName = getSectionNameFromSection(section, qNo);
            if (sectionName != "") return sectionName;
        }
        return "Unknown";
    };
    const moveUnallocatedFile = async (unallocatedFile, cut, qNo, sectionName)=>{
        if (qNo) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveFile', {
                fileReportId: unallocatedFile.id,
                file: unallocatedFile.file,
                unallocated: true,
                companyId: companyId,
                isCut: cut,
                qNo: qNo,
                tab: tab,
                sectionName: sectionName
            });
            if (!res || res['code'] != 200) return;
            await reloadModule("repository", cut ? true : false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            if (cut) {
                setUnallocatedFiles(unallocatedFiles.filter((f)=>f.file.key != unallocatedFile.file.key));
                setRefresh(!refresh);
            }
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select target section');
    };
    const moveDeduperFile = async (deduperId, curQno, file, cut, qNo, sectionName, key, index)=>{
        if (cut && curQno == qNo) return;
        if (qNo) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveDeduperFile', {
                deduperId: deduperId,
                file: file,
                companyId: companyId,
                isCut: cut,
                qNo: qNo,
                tab: tab,
                sectionName: sectionName,
                oldQno: curQno,
                key: key,
                index: index
            });
            if (!res || res['code'] != 200) return;
            const newReport = res['body'];
            if (tab) await reloadModule(tab, cut ? true : false);
            if (cut) {
                const modules = company.modules[tab];
                for (const section of modules?.sections){
                    const sectionQno = section.sectionNo || section.no;
                    if (sectionQno == curQno) {
                        section.files = section.files.filter((f)=>f.key != file.key);
                        setSection(section);
                        break;
                    }
                }
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            setDupCheck(JSON.parse(JSON.stringify(newReport)));
            let curSection = {};
            for (const dupFiles of Object.values(newReport.deduperResult))for (const dupFile of dupFiles)curSection[dupFile.file.key] = {
                qNo: dupFile.qNo,
                name: dupFile.name
            };
            dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
            setRefresh(!refresh);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select target section');
    };
    const moveFile = async (curQno, file, cut, qNo, sectionName, isDeduper, key, index)=>{
        if (cut && curQno == qNo) return;
        if (qNo) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveFile', {
                file: file,
                unallocated: false,
                companyId: companyId,
                isCut: cut,
                qNo: qNo,
                tab: tab,
                sectionName: sectionName,
                oldQno: curQno,
                isDeduper: isDeduper
            });
            if (!res || res['code'] != 200) return;
            const newFile = res['body']['file'];
            if (tab) await reloadModule(tab, cut ? true : false);
            let curSection = targetSection;
            if (isDeduper) {
                if (!cut) {
                    let curDupCheck = dupCheck;
                    curSection[file.key] = {
                        qNo: qNo,
                        name: sectionName
                    };
                    dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
                }
            } else {
                if (cut) section.files = section.files.filter((f)=>f.key != file.key);
                else {
                    section.files.push(newFile);
                    curSection[newFile.key] = {
                        qNo: qNo,
                        name: sectionName
                    };
                    dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
                }
                setSection(section);
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            setRefresh(!refresh);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select target section');
    };
    const onClickFileReportHistory = async ()=>{
        setFAMenuVisible(false);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportHistory/${companyId}`);
        setReportHistories(res['body']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'fileReportHistory'
        }));
    };
    const showDeduperReport = (report)=>{
        // setDupCheck(JSON.parse(JSON.stringify(report)));
        setDupCheck(report);
        let curSection = {};
        if (report.deduperResult) {
            for (const dupFiles of Object.values(report.deduperResult))for (const dupFile of dupFiles)curSection[dupFile.file.key] = {
                qNo: dupFile.qNo,
                name: dupFile.name
            };
        }
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'duplicationCheckSummary'
        }));
    };
    const onClickDeduperReportHistory = async ()=>{
        setFAMenuVisible(false);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getDeduperReportHistory/${companyId}`);
        if (res['body'] && Array.isArray(res['body']) && res['body'].length > 0) showDeduperReport(res['body'][0]);
        else showDeduperReport({});
    // setDeduperHistories(res['body']);
    // dispatch(toggleModal({ open: 'deduperReportHistory' }))
    };
    const onClickViewUnallocatedFiles = async ()=>{
        setFAMenuVisible(false);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/unallocatedFiles/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)({}));
        setUnallocatedFiles(res['body']['unallocated']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedFiles'
        }));
    };
    const getReportStatus = (report)=>{
        if (!report) return "-";
        let hasUnallocatedFile = false;
        for (let result of Object.values(report['importResult']))if (result.section.includes("DXXX")) {
            hasUnallocatedFile = true;
            break;
        }
        /*if (hasUnallocatedFile)
    	return <p className="red">Awaiting manual allocation</p>;
    else */ if (report['status'] == 'In Progress') return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "orange",
            children: "Not yet reviewed"
        });
        else if (report['status'] == 'Complete') return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "green",
            children: "Reviewed and Accepted"
        });
        else return "-";
    };
    const onClickDeduperReport = (report)=>{
        setDupCheck(JSON.parse(JSON.stringify(report)));
        // setDupCheck(report);
        let curSection = {};
        for (const dupFiles of Object.values(report.deduperResult))for (const dupFile of dupFiles)curSection[dupFile.file.key] = {
            qNo: dupFile.qNo,
            name: dupFile.name
        };
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'duplicationCheckSummary',
            from: 'deduperHistory'
        }));
    };
    const onClickReport = (report)=>{
        // setFileReport(JSON.parse(JSON.stringify(report)));
        dispatch(setFileReport(report));
        setCloneImportResult(JSON.parse(JSON.stringify(report['importResult'])));
        setCurrentScore(report['currentScore']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'importSummary',
            from: 'reportHistory'
        }));
    };
    const checkDuplicatedFiles = async ()=>{
        setFAMenuVisible(false);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'checkingDuplication'
        }));
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/checkDuplicate`, {
            companyId: companyId,
            tab: tab
        });
        showDeduperReport(res['body']);
    };
    const getReportHistoryEntryHTML = (report)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                className: "cp",
                onClick: ()=>onClickReport(report),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `mx1rem fs1rem fw600 bg1`,
                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report['importDate']).format('lll')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `frs-td mx1rem fs1rem fw600 bg1`,
                        children: Object.keys(report['importResult']).length
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `frs-td mx1rem fs1rem fw600 bg1`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `w2rem h2rem jcc aic br100 bg3 c1 bw3px bss bo7 dib wsn`,
                            children: report?.['importBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: report?.['importBy']?.['profile'],
                                className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
                                "data-tooltip": report?.['importBy']?.['firstName'] ? report?.['importBy']?.['firstName'] + " " + (report?.['importBy']?.['lastName'] ? report?.['importBy']?.['lastName'] : "") : "?"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `wsn w2rem h2rem df jcc aic br100 ${profileClass}`,
                                "data-tooltip": report?.['importBy']?.['firstName'] ? report?.['importBy']?.['firstName'] + " " + (report?.['importBy']?.['lastName'] ? report?.['importBy']?.['lastName'] : "") : "?",
                                children: report?.['importBy']?.['firstName'] ? report?.['importBy']?.['firstName'] + (report?.['importBy']?.['lastName'] ? report?.['importBy']?.['lastName'] : "") : "?"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `frs-td mx1rem fs1rem fw600 bg1`,
                        children: report?.['lastAllocatedBy'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `w2rem h2rem jcc aic br100 bw3px bss dib wsn`,
                            children: report?.['lastAllocatedBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: report?.['lastAllocatedBy']?.['profile'],
                                className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
                                "data-tooltip": report?.['lastAllocatedBy']?.['firstName'] ? report?.['lastAllocatedBy']?.['firstName'] + " " + report?.['lastAllocatedBy']?.['lastName'] : "?"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: `wsn w2rem h2rem df jcc aic br100 ${profileClass}`,
                                "data-tooltip": report?.['lastAllocatedBy']?.['firstName'] ? report?.['lastAllocatedBy']?.['firstName'] + " " + report?.['lastAllocatedBy']?.['lastName'] : "?",
                                children: report?.['lastAllocatedBy']?.['firstName'] ? report?.['lastAllocatedBy']?.['firstName'] + report?.['lastAllocatedBy']?.['lastName'] : "?"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                        className: `frs-td mx1rem fs1rem fw600 bg1`,
                        children: [
                            report?.['initialScore'],
                            '% -> ',
                            report?.['currentScore'],
                            '%'
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: `frs-td mx1rem fs1rem fw600 bg1`,
                        children: getReportStatus(report)
                    })
                ]
            })
        });
    };
    const removeDuplicate = (key, index)=>{
        if (dupCheck.deduperResult[key] && dupCheck.deduperResult[key].length > 0 && dupCheck.deduperResult[key].length > index) dupCheck.deduperResult[key].splice(index, 1);
        if (dupCheck.deduperResult[key].length == 0) delete dupCheck.deduperResult[key];
        setRefresh(!refresh);
    };
    const getViewableURL = (url)=>{
        return `https://docs.google.com/gview?url=${url}&embedded=true`;
    // var width = window.innerWidth * 0.8;
    // var height = width * window.innerHeight / window.innerWidth;
    // var popup = window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + ((window.innerHeight - height) / 2) + ', left=' + ((window.innerWidth - width) / 2));
    // var embedTag = document.createElement('iframe');
    // embedTag.src = `https://docs.google.com/gview?url=${url}&embedded=true`;
    // // embedTag.type = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    // embedTag.width = '100';
    // embedTag.height = '100';
    // popup.document.body.appendChild(embedTag);
    // return false;
    };
    const deleteDeduperFile = async (key, questionId, file, index)=>{
        let directorId = undefined;
        if (tab.includes('directors-questionnaire')) {
            const dqs = tab.split('_');
            if (dqs.length > 1) directorId = dqs[1];
        }
        let res = {};
        if (tab.includes('directors-questionnaire')) res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: file,
            questionId: questionId,
            companyId: companyId,
            directorId: directorId
        });
        else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: file,
            questionId: questionId,
            companyId: companyId
        });
        if (!res || res['code'] != 200) return;
        // res = await postRequest('/company/deleteDeduperFile', { deduperId: dupCheck['_id'], companyId, key, index, file, tab });
        // if (!res || res['code'] != 200) return;
        // showMessage(res['message']);
        if (tab) await reloadModule(tab);
        removeDuplicate(key, index);
    };
    const getDuplicationCheckEntryHTML = (key)=>{
        const fileName = key;
        const files = dupCheck.deduperResult[key];
        const deduperId = dupCheck['_id'];
        let module = company.modules[tab];
        if (module) module = JSON.parse(JSON.stringify(module));
        if (Array.isArray(files)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: files.filter((f)=>f != null && f != undefined).map((checkFile, index)=>{
                let file = checkFile.file;
                const curQno = checkFile.qNo;
                let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                let fileKey = file.key;
                const ext = file.originalname.split(".").slice(-1)[0];
                const url = file.location;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `df jcfs aic w100 px1rem py0-5rem td250 bsbb ${index == files.length - 1 ? 'fis-tr bbw3' : ''}`,
                        children: [
                            [
                                "pdf"
                            ].includes(ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z"
                                    })
                                ]
                            }) || [
                                "mp4",
                                "webm",
                                "mkv",
                                "ogg",
                                "avi",
                                "mov"
                            ].includes(ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M256 0v128h128L256 0zM192 256H96C78.33 256 64 270.3 64 288v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288C224 270.3 209.7 256 192 256zM295.5 271.3L256 296v80l39.52 24.7C306.2 407.4 320 399.7 320 387.1V284.9C320 272.3 306.2 264.6 295.5 271.3z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM224 384c0 17.67-14.33 32-32 32H96c-17.67 0-32-14.33-32-32V288c0-17.67 14.33-32 32-32h96c17.67 0 32 14.33 32 32V384zM320 387.1c0 12.57-13.82 20.23-24.48 13.57L256 376v-80l39.52-24.7C306.2 264.6 320 272.3 320 284.9V387.1z"
                                    })
                                ]
                            }) || [
                                "sheet",
                                "xlsx",
                                "xls",
                                "xlsm",
                                "ots",
                                "csv"
                            ].includes(ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M256 0v128h128L256 0zM312 224h-240c-8.875 0-16 7.125-16 16v192c0 8.875 7.125 16 16 16h240c8.875 0 16-7.125 16-16v-192C328 231.1 320.9 224 312 224zM136 416h-48v-48h48V416zM136 336h-48V288h48V336zM216 416h-48v-48h48V416zM216 336h-48V288h48V336zM296 416h-48v-48h48V416zM296 336h-48V288h48V336z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM328 432c0 8.875-7.125 16-16 16h-240c-8.875 0-16-7.125-16-16v-192c0-8.875 7.125-16 16-16h240c8.875 0 16 7.125 16 16V432z"
                                    })
                                ]
                            }) || [
                                "png",
                                "jpg",
                                "jpeg",
                                "gif",
                                "bmp",
                                "svg",
                                "webp"
                            ].includes(ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M256 0v128h128L256 0zM231.1 295.1C229 290.7 224 288 218.7 288s-10.35 2.674-13.31 7.125L160 363.2l-13.35-20.03C143.7 338.7 138.7 336 133.3 336s-10.35 2.674-13.31 7.125l-53.33 80c-3.273 4.908-3.578 11.22-.7949 16.42C68.68 444.8 74.1 448 80 448h224c5.9 0 11.32-3.248 14.11-8.451c2.783-5.201 2.479-11.52-.7949-16.42L231.1 295.1z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 224c17.67 0 32 14.33 32 32S113.7 288 96 288S64 273.7 64 256S78.33 224 96 224zM318.1 439.5C315.3 444.8 309.9 448 304 448h-224c-5.9 0-11.32-3.248-14.11-8.451c-2.783-5.201-2.479-11.52 .7949-16.42l53.33-80C122.1 338.7 127.1 336 133.3 336s10.35 2.674 13.31 7.125L160 363.2l45.35-68.03C208.3 290.7 213.3 288 218.7 288s10.35 2.674 13.31 7.125l85.33 128C320.6 428 320.9 434.3 318.1 439.5z"
                                    })
                                ]
                            }) || [
                                "zip",
                                "7z",
                                "gz",
                                "tar.gz"
                            ].includes(ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M160 32H96v32h64V32zM160 160H96v32h64V160zM160 96H96v32h64V96zM256 0v128h128L256 0zM160 224H96l-30.56 116.5c-7.93 39 22.26 75.45 62.83 75.45c40.26 0 70.45-36.3 62.68-75.15L160 224zM144 368h-32C103.2 368 96 360.8 96 352s7.164-16 16-16h32C152.8 336 160 343.2 160 352S152.8 368 144 368z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 32h64v32H96V32zM96 96h64v32H96V96zM96 160h64v32H96V160zM128.3 415.1c-40.56 0-70.76-36.45-62.83-75.45L96 224h64l30.94 116.9C198.7 379.7 168.5 415.1 128.3 415.1z"
                                    })
                                ]
                            }) || [
                                "doc",
                                "docx",
                                "docm",
                                "rtf",
                                "odt",
                                "dot",
                                "dotx"
                            ].includes(ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M256 0v128h128L256 0zM304.9 240h-23.37c-5.588 0-10.44 3.859-11.69 9.301L246.2 352L218.4 248.9C216.1 243.6 212.2 240 206.8 240H177.2c-5.426 0-10.18 3.641-11.59 8.883L137.8 352L114.1 249.3C112.9 243.9 108 240 102.5 240H79.08c-7.717 0-13.43 7.18-11.69 14.7l42.46 184C111.1 444.1 115.1 448 121.5 448h29.26c5.428 0 10.18-3.641 11.59-8.883L192 329.1l29.61 109.1C223 444.4 227.8 448 233.2 448h29.26c5.588 0 10.44-3.859 11.69-9.305l42.46-184C318.3 247.2 312.6 240 304.9 240z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM274.1 438.7C272.9 444.1 268 448 262.5 448h-29.26c-5.426 0-10.18-3.641-11.59-8.883L192 329.1l-29.61 109.1C160.1 444.4 156.2 448 150.8 448H121.5c-5.588 0-10.44-3.859-11.69-9.305l-42.46-184C65.66 247.2 71.37 240 79.08 240h23.37c5.588 0 10.44 3.859 11.69 9.301L137.8 352L165.6 248.9C167 243.6 171.8 240 177.2 240h29.61c5.426 0 10.18 3.641 11.59 8.883L246.2 352l23.7-102.7C271.1 243.9 275.1 240 281.5 240h23.37c7.717 0 13.43 7.18 11.69 14.7L274.1 438.7z"
                                    })
                                ]
                            }) || [
                                "pptx",
                                "pttm",
                                "ppt"
                            ].includes(ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M199.5 240H128C119.2 240 112 247.2 112 256v176C112 440.8 119.2 448 128 448h16C152.8 448 160 440.8 160 432v-40h44c44.53 0 80.23-38.49 75.59-83.95C275.6 268.5 239.3 240 199.5 240zM204 344H160V288h44c15.44 0 28 12.56 28 28S219.4 344 204 344zM256 0v128h128L256 0z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M204 288H160v56h44c15.44 0 28-12.56 28-28S219.4 288 204 288zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM204 392H160v40C160 440.8 152.8 448 144 448H128c-8.836 0-16-7.164-16-16V256c0-8.836 7.164-16 16-16h71.51c39.75 0 76.05 28.52 80.08 68.05C284.2 353.5 248.5 392 204 392z"
                                    })
                                ]
                            }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "f3 h2rem w2rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 384 512",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-primary",
                                        d: "M256 0v128h128L256 0zM272 384h-160C103.2 384 96 391.2 96 400S103.2 416 112 416h160c8.836 0 16-7.164 16-16S280.8 384 272 384zM272 320h-160C103.2 320 96 327.2 96 336S103.2 352 112 352h160c8.836 0 16-7.164 16-16S280.8 320 272 320zM272 256h-160C103.2 256 96 263.2 96 272S103.2 288 112 288h160C280.8 288 288 280.8 288 272S280.8 256 272 256z"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "fa-secondary",
                                        d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM272 416h-160C103.2 416 96 408.8 96 400S103.2 384 112 384h160c8.836 0 16 7.164 16 16S280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336S103.2 320 112 320h160c8.836 0 16 7.164 16 16S280.8 352 272 352zM272 288h-160C103.2 288 96 280.8 96 272S103.2 256 112 256h160C280.8 256 288 263.2 288 272S280.8 288 272 288z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                target: "_blank",
                                to: getViewableURL(url),
                                style: {
                                    flex: 1
                                },
                                className: `mx1rem fs1rem fw600 bg1 ${fileColor}`,
                                children: file.originalname
                            }),
                            tab == 'repository' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mla mr1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "rs-nav rs-nav-default",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                onClick: ()=>handleEditDispatch({
                                                        key: fileKey,
                                                        fileName: file.originalname
                                                    }),
                                                className: "rs-dropdown-toggle rs-nav-item",
                                                children: [
                                                    targetSection[fileKey] && `${targetSection[fileKey]['qNo']}. ${targetSection[fileKey]['name']}` || 'Please select section',
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        width: "1em",
                                                        height: "1em",
                                                        viewBox: "0 0 16 16",
                                                        fill: "currentColor",
                                                        "aria-hidden": "true",
                                                        focusable: "false",
                                                        className: "rs-nav-item-caret rs-icon",
                                                        "aria-label": "arrow down line",
                                                        "data-category": "direction",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M8 11a.997.997 0 01-.707-.293l-3-3a.999.999 0 111.414-1.414L8 8.586l2.293-2.293a.999.999 0 111.414 1.414l-3 3A.997.997 0 018 11z"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        "data-tooltip": "Move",
                                        className: "h1rem mr1rem cp",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            moveDeduperFile(deduperId, curQno, file, true, targetSection[fileKey]?.['qNo'], targetSection[fileKey]?.['name'], key, index);
                                        },
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 20 20",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M9.77 11.5l5.34 3.91c.44.33 1.24.59 1.79.59H20L6.89 6.38A3.5 3.5 0 105.5 8.37L7.73 10 5.5 11.63a3.5 3.5 0 101.38 1.99l2.9-2.12zM3.5 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM15.1 4.59A3.53 3.53 0 0116.9 4H20l-7.5 5.5L10.45 8l4.65-3.41z"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        "data-tooltip": "Copy",
                                        className: "h1rem mr1rem cp",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            moveDeduperFile(deduperId, curQno, file, false, targetSection[fileKey]?.['qNo'], targetSection[fileKey]?.['name'], key, index);
                                        },
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 256 256",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                            fill: "#000",
                                            strokeMiterlimit: "10",
                                            strokeWidth: "1",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M51.047 40.954H14.692a1 1 0 000 2h36.354a1 1 0 00.001-2zM51.047 55.05H14.692a1 1 0 100 2h36.354a1 1 0 10.001-2zM51.047 69.146H14.692a1 1 0 100 2h36.354a1 1 0 10.001-2z",
                                                    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M87.894 16.034a.991.991 0 00-.053-.263c-.011-.032-.02-.063-.034-.093a.987.987 0 00-.2-.295L72.211.286a.967.967 0 00-.29-.191c-.032-.015-.065-.023-.098-.034a.949.949 0 00-.246-.048C71.554.011 71.533 0 71.511 0H33.138a6.792 6.792 0 00-6.785 6.785v2.313H8.878a6.792 6.792 0 00-6.785 6.785v67.333A6.792 6.792 0 008.878 90h47.983a6.792 6.792 0 006.785-6.784v-2.313h17.476a6.791 6.791 0 006.784-6.784V16.097c0-.022-.011-.041-.012-.063zm-3.436-.937h-8.727a3.224 3.224 0 01-3.221-3.22V3.381l11.948 11.716zM61.646 83.216A4.79 4.79 0 0156.861 88H8.878a4.79 4.79 0 01-4.785-4.784V15.882a4.79 4.79 0 014.785-4.785h37.373V21.15a5.05 5.05 0 005.044 5.044h10.352v57.022zm-1.448-59.021h-8.903a3.047 3.047 0 01-3.044-3.044V12.48l11.947 11.715zm20.924 54.707H63.646V62.049h11.661a1 1 0 100-2H63.646V47.952h11.661a1 1 0 100-2H63.646V33.856h11.661a1 1 0 100-2H63.646v-6.662c0-.022-.011-.041-.013-.063a.976.976 0 00-.053-.262c-.012-.033-.021-.066-.035-.097a.999.999 0 00-.175-.26c-.008-.008-.012-.019-.021-.027l-.003-.004-15.387-15.09-.001-.001-.007-.006a.993.993 0 00-.282-.188c-.013-.006-.023-.016-.036-.021-.023-.01-.048-.008-.072-.016a.976.976 0 00-.245-.048c-.023-.002-.043-.013-.066-.013H28.354V6.785A4.79 4.79 0 0133.138 2h37.373v9.877a5.227 5.227 0 005.221 5.22h10.175v57.021a4.79 4.79 0 01-4.785 4.784z",
                                                    transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                target: "_blank",
                                to: url,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    "data-tooltip": "Download",
                                    className: `f3 h1rem cp mr1rem ${tab == 'repository' ? '' : 'mla'}`,
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 512 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                });
            })
        });
    };
    const getUnallocatedFileHTML = (unallocatedFile)=>{
        const file = unallocatedFile.file;
        const fileExt = file.originalname.split(".").slice(-1)[0];
        const fileUrl = file.location;
        const title = file.originalname;
        const key = file.key;
        let module = company.modules[tab];
        if (module) module = JSON.parse(JSON.stringify(module));
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "mx1rem fs1rem fw600 bg1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdr aic jcl pl3rem",
                            children: [
                                [
                                    "pdf"
                                ].includes(fileExt) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z"
                                        })
                                    ]
                                }) || [
                                    "mp4",
                                    "webm",
                                    "mkv",
                                    "ogg",
                                    "avi",
                                    "mov"
                                ].includes(fileExt) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M256 0v128h128L256 0zM192 256H96C78.33 256 64 270.3 64 288v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288C224 270.3 209.7 256 192 256zM295.5 271.3L256 296v80l39.52 24.7C306.2 407.4 320 399.7 320 387.1V284.9C320 272.3 306.2 264.6 295.5 271.3z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM224 384c0 17.67-14.33 32-32 32H96c-17.67 0-32-14.33-32-32V288c0-17.67 14.33-32 32-32h96c17.67 0 32 14.33 32 32V384zM320 387.1c0 12.57-13.82 20.23-24.48 13.57L256 376v-80l39.52-24.7C306.2 264.6 320 272.3 320 284.9V387.1z"
                                        })
                                    ]
                                }) || [
                                    "sheet",
                                    "xlsx",
                                    "xls",
                                    "xlsm",
                                    "ots",
                                    "csv"
                                ].includes(fileExt) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M256 0v128h128L256 0zM312 224h-240c-8.875 0-16 7.125-16 16v192c0 8.875 7.125 16 16 16h240c8.875 0 16-7.125 16-16v-192C328 231.1 320.9 224 312 224zM136 416h-48v-48h48V416zM136 336h-48V288h48V336zM216 416h-48v-48h48V416zM216 336h-48V288h48V336zM296 416h-48v-48h48V416zM296 336h-48V288h48V336z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM328 432c0 8.875-7.125 16-16 16h-240c-8.875 0-16-7.125-16-16v-192c0-8.875 7.125-16 16-16h240c8.875 0 16 7.125 16 16V432z"
                                        })
                                    ]
                                }) || [
                                    "png",
                                    "jpg",
                                    "jpeg",
                                    "gif",
                                    "bmp",
                                    "svg",
                                    "webp"
                                ].includes(fileExt) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M256 0v128h128L256 0zM231.1 295.1C229 290.7 224 288 218.7 288s-10.35 2.674-13.31 7.125L160 363.2l-13.35-20.03C143.7 338.7 138.7 336 133.3 336s-10.35 2.674-13.31 7.125l-53.33 80c-3.273 4.908-3.578 11.22-.7949 16.42C68.68 444.8 74.1 448 80 448h224c5.9 0 11.32-3.248 14.11-8.451c2.783-5.201 2.479-11.52-.7949-16.42L231.1 295.1z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 224c17.67 0 32 14.33 32 32S113.7 288 96 288S64 273.7 64 256S78.33 224 96 224zM318.1 439.5C315.3 444.8 309.9 448 304 448h-224c-5.9 0-11.32-3.248-14.11-8.451c-2.783-5.201-2.479-11.52 .7949-16.42l53.33-80C122.1 338.7 127.1 336 133.3 336s10.35 2.674 13.31 7.125L160 363.2l45.35-68.03C208.3 290.7 213.3 288 218.7 288s10.35 2.674 13.31 7.125l85.33 128C320.6 428 320.9 434.3 318.1 439.5z"
                                        })
                                    ]
                                }) || [
                                    "zip",
                                    "7z",
                                    "gz",
                                    "tar.gz"
                                ].includes(fileExt) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M160 32H96v32h64V32zM160 160H96v32h64V160zM160 96H96v32h64V96zM256 0v128h128L256 0zM160 224H96l-30.56 116.5c-7.93 39 22.26 75.45 62.83 75.45c40.26 0 70.45-36.3 62.68-75.15L160 224zM144 368h-32C103.2 368 96 360.8 96 352s7.164-16 16-16h32C152.8 336 160 343.2 160 352S152.8 368 144 368z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 32h64v32H96V32zM96 96h64v32H96V96zM96 160h64v32H96V160zM128.3 415.1c-40.56 0-70.76-36.45-62.83-75.45L96 224h64l30.94 116.9C198.7 379.7 168.5 415.1 128.3 415.1z"
                                        })
                                    ]
                                }) || [
                                    "doc",
                                    "docx",
                                    "docm",
                                    "rtf",
                                    "odt",
                                    "dot",
                                    "dotx"
                                ].includes(fileExt) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M256 0v128h128L256 0zM304.9 240h-23.37c-5.588 0-10.44 3.859-11.69 9.301L246.2 352L218.4 248.9C216.1 243.6 212.2 240 206.8 240H177.2c-5.426 0-10.18 3.641-11.59 8.883L137.8 352L114.1 249.3C112.9 243.9 108 240 102.5 240H79.08c-7.717 0-13.43 7.18-11.69 14.7l42.46 184C111.1 444.1 115.1 448 121.5 448h29.26c5.428 0 10.18-3.641 11.59-8.883L192 329.1l29.61 109.1C223 444.4 227.8 448 233.2 448h29.26c5.588 0 10.44-3.859 11.69-9.305l42.46-184C318.3 247.2 312.6 240 304.9 240z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM274.1 438.7C272.9 444.1 268 448 262.5 448h-29.26c-5.426 0-10.18-3.641-11.59-8.883L192 329.1l-29.61 109.1C160.1 444.4 156.2 448 150.8 448H121.5c-5.588 0-10.44-3.859-11.69-9.305l-42.46-184C65.66 247.2 71.37 240 79.08 240h23.37c5.588 0 10.44 3.859 11.69 9.301L137.8 352L165.6 248.9C167 243.6 171.8 240 177.2 240h29.61c5.426 0 10.18 3.641 11.59 8.883L246.2 352l23.7-102.7C271.1 243.9 275.1 240 281.5 240h23.37c7.717 0 13.43 7.18 11.69 14.7L274.1 438.7z"
                                        })
                                    ]
                                }) || [
                                    "pptx",
                                    "pttm",
                                    "ppt"
                                ].includes(fileExt) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M199.5 240H128C119.2 240 112 247.2 112 256v176C112 440.8 119.2 448 128 448h16C152.8 448 160 440.8 160 432v-40h44c44.53 0 80.23-38.49 75.59-83.95C275.6 268.5 239.3 240 199.5 240zM204 344H160V288h44c15.44 0 28 12.56 28 28S219.4 344 204 344zM256 0v128h128L256 0z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M204 288H160v56h44c15.44 0 28-12.56 28-28S219.4 288 204 288zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM204 392H160v40C160 440.8 152.8 448 144 448H128c-8.836 0-16-7.164-16-16V256c0-8.836 7.164-16 16-16h71.51c39.75 0 76.05 28.52 80.08 68.05C284.2 353.5 248.5 392 204 392z"
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "f3 h2rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 384 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M256 0v128h128L256 0zM272 384h-160C103.2 384 96 391.2 96 400S103.2 416 112 416h160c8.836 0 16-7.164 16-16S280.8 384 272 384zM272 320h-160C103.2 320 96 327.2 96 336S103.2 352 112 352h160c8.836 0 16-7.164 16-16S280.8 320 272 320zM272 256h-160C103.2 256 96 263.2 96 272S103.2 288 112 288h160C280.8 288 288 280.8 288 272S280.8 256 272 256z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM272 416h-160C103.2 416 96 408.8 96 400S103.2 384 112 384h160c8.836 0 16 7.164 16 16S280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336S103.2 320 112 320h160c8.836 0 16 7.164 16 16S280.8 352 272 352zM272 288h-160C103.2 288 96 280.8 96 272S103.2 256 112 256h160C280.8 256 288 263.2 288 272S280.8 288 272 288z"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    target: "_blank",
                                    to: getViewableURL(fileUrl),
                                    className: `mx1rem fs1rem fw600 tal`,
                                    style: {
                                        flex: 1
                                    },
                                    children: title
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                        className: "frs-td mx1rem fs1rem fw600 bg1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdr aic jcr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mla mr1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "rs-nav rs-nav-default",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            onClick: ()=>handleEditDispatch({
                                                    key: key,
                                                    fileName: title
                                                }),
                                            className: "rs-dropdown-toggle rs-nav-item",
                                            children: [
                                                targetSection[key] && `${targetSection[key]['qNo']}. ${targetSection[key]['name']}` || 'Please select section',
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    width: "1em",
                                                    height: "1em",
                                                    viewBox: "0 0 16 16",
                                                    fill: "currentColor",
                                                    "aria-hidden": "true",
                                                    focusable: "false",
                                                    className: "rs-nav-item-caret rs-icon",
                                                    "aria-label": "arrow down line",
                                                    "data-category": "direction",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M8 11a.997.997 0 01-.707-.293l-3-3a.999.999 0 111.414-1.414L8 8.586l2.293-2.293a.999.999 0 111.414 1.414l-3 3A.997.997 0 018 11z"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    "data-tooltip": "Move",
                                    className: "h1rem mr1rem cp",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        moveUnallocatedFile(unallocatedFile, true, targetSection[key]?.['qNo'], targetSection[key]?.['name']);
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 20 20",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9.77 11.5l5.34 3.91c.44.33 1.24.59 1.79.59H20L6.89 6.38A3.5 3.5 0 105.5 8.37L7.73 10 5.5 11.63a3.5 3.5 0 101.38 1.99l2.9-2.12zM3.5 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM15.1 4.59A3.53 3.53 0 0116.9 4H20l-7.5 5.5L10.45 8l4.65-3.41z"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    "data-tooltip": "Copy",
                                    className: "h1rem mr1rem cp",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        moveUnallocatedFile(unallocatedFile, false, targetSection[key]?.['qNo'], targetSection[key]?.['name']);
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 256 256",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        fill: "#000",
                                        strokeMiterlimit: "10",
                                        strokeWidth: "1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M51.047 40.954H14.692a1 1 0 000 2h36.354a1 1 0 00.001-2zM51.047 55.05H14.692a1 1 0 100 2h36.354a1 1 0 10.001-2zM51.047 69.146H14.692a1 1 0 100 2h36.354a1 1 0 10.001-2z",
                                                transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M87.894 16.034a.991.991 0 00-.053-.263c-.011-.032-.02-.063-.034-.093a.987.987 0 00-.2-.295L72.211.286a.967.967 0 00-.29-.191c-.032-.015-.065-.023-.098-.034a.949.949 0 00-.246-.048C71.554.011 71.533 0 71.511 0H33.138a6.792 6.792 0 00-6.785 6.785v2.313H8.878a6.792 6.792 0 00-6.785 6.785v67.333A6.792 6.792 0 008.878 90h47.983a6.792 6.792 0 006.785-6.784v-2.313h17.476a6.791 6.791 0 006.784-6.784V16.097c0-.022-.011-.041-.012-.063zm-3.436-.937h-8.727a3.224 3.224 0 01-3.221-3.22V3.381l11.948 11.716zM61.646 83.216A4.79 4.79 0 0156.861 88H8.878a4.79 4.79 0 01-4.785-4.784V15.882a4.79 4.79 0 014.785-4.785h37.373V21.15a5.05 5.05 0 005.044 5.044h10.352v57.022zm-1.448-59.021h-8.903a3.047 3.047 0 01-3.044-3.044V12.48l11.947 11.715zm20.924 54.707H63.646V62.049h11.661a1 1 0 100-2H63.646V47.952h11.661a1 1 0 100-2H63.646V33.856h11.661a1 1 0 100-2H63.646v-6.662c0-.022-.011-.041-.013-.063a.976.976 0 00-.053-.262c-.012-.033-.021-.066-.035-.097a.999.999 0 00-.175-.26c-.008-.008-.012-.019-.021-.027l-.003-.004-15.387-15.09-.001-.001-.007-.006a.993.993 0 00-.282-.188c-.013-.006-.023-.016-.036-.021-.023-.01-.048-.008-.072-.016a.976.976 0 00-.245-.048c-.023-.002-.043-.013-.066-.013H28.354V6.785A4.79 4.79 0 0133.138 2h37.373v9.877a5.227 5.227 0 005.221 5.22h10.175v57.021a4.79 4.79 0 01-4.785 4.784z",
                                                transform: "matrix(2.81 0 0 2.81 1.407 1.407)"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    target: "_blank",
                                    to: fileUrl,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        "data-tooltip": "Download",
                                        className: "f3 h1rem cp mr1rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 512 512",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-primary",
                                                d: "M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-secondary",
                                                d: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    const getLogsHTML = (logs, showDetails = false)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: log['message']
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            showDetails && log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: getViewableURL(file['location']),
                                                target: "_blank",
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem",
                                                children: file['originalname']
                                            }, idx))
                                    ]
                                })
                            }),
                            showDetails && log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Changed Status"
                                            }),
                                            ": ",
                                            log?.['change']?.status ? log?.['change']?.status : '-'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Selected Option"
                                            }),
                                            ": ",
                                            log?.['change']?.radioOption ? log?.['change']?.radioOption : '-'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Updated Comment"
                                            }),
                                            ": ",
                                            log?.['change']?.comment ? log?.['change']?.comment : '-'
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, idx);
        });
    const getDeduperReportLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: getViewableURL(file['location']),
                                                target: "_blank",
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem",
                                                children: file['originalname']
                                            }, idx))
                                    ]
                                })
                            }),
                            log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Comment"
                                        }),
                                        ": ",
                                        log?.['change']?.comment ? log?.['change']?.comment : '-'
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, idx);
        });
    const getFileReportLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: getViewableURL(file['location']),
                                                target: "_blank",
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem",
                                                children: file['originalname']
                                            }, idx))
                                    ]
                                })
                            }),
                            log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Changed Status"
                                            }),
                                            ": ",
                                            log?.['change']?.comment ? log?.['change']?.comment : '-'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Assistant Accuracy"
                                            }),
                                            ": ",
                                            log?.['change']?.accuracy != undefined ? log?.['change']?.accuracy : '-',
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, idx);
        });
    const getUnallocatedBinLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: getViewableURL(file['location']),
                                                target: "_blank",
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem",
                                                children: file['originalname']
                                            }, idx))
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, idx);
        });
    const onClickFileManager = (section)=>{
        let curSection = JSON.parse(JSON.stringify(targetSection));
        if (section && section.files && section.files.length > 0) section.files.map((file)=>{
            curSection[file.key] = {
                qNo: section.sectionNo || section.no,
                name: section.sectionName || section.name
            };
        });
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
    };
    const answerSaved = (answer)=>{
        let updatedBy = answer?.['updatedBy']?.[0] || answer?.['updatedBy'];
        if (updatedBy?.['firstName']) {
            let answerClass = updatedBy?.['role'] == 'Advisor' ? 'advisor-profile' : updatedBy?.['role'] == 'Investor' ? 'investor-profile' : 'client-profile';
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    updatedBy?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${answerClass}`,
                        src: updatedBy['profile'],
                        "data-tooltip": updatedBy['firstName'] ? updatedBy['firstName'] + " " + updatedBy['lastName'] : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${answerClass}`,
                        "data-tooltip": updatedBy?.['firstName'] ? updatedBy['firstName'] + " " + updatedBy['lastName'] : "Register to show your name here",
                        children: [
                            updatedBy?.['firstName']?.[0] || "?",
                            updatedBy?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "fs0-75rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Answer Saved"
                                }),
                                ", ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(answer['updatedAt']).format('lll')
                                })
                            ]
                        })
                    })
                ]
            });
        }
    };
    const handleSectionLogs = async (id)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/getLogs/${id}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'auditLog'
        }));
    };
    const openWindow = (url)=>{
        if (window.innerWidth <= 640) {
            var a = document.createElement('a');
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");
            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);
            a.dispatchEvent(dispatch);
        } else {
            var width = window.innerWidth * 0.8;
            var height = width * window.innerHeight / window.innerWidth;
            window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + (window.innerHeight - height) / 2 + ', left=' + (window.innerWidth - width) / 2);
        }
        return false;
    };
    const getFilesFromQuestions = (questions)=>questions && questions.filter((q)=>q.answer?.files?.length).reduce((arr, q)=>[
                ...arr,
                ...q.answer.files.map((file)=>({
                        ...file,
                        questionId: q._id,
                        qNo: q.qNo,
                        title: file.originalname,
                        url: file.location,
                        ext: file.originalname.split(".").slice(-1)[0]
                    }))
            ], []);
    const onAccurateFileName = ()=>{
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                enabled: false,
                companyId: companyId,
                moduleType: tab,
                sectionCode: null,
                scope: 'module',
                scopeName: ''
            },
            tab: tab
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'select',
            autoFillStatusBarPhase: 'select',
            autoFillWithFilling: false,
            autoFillUploadMode: 'files'
        }));
    };
    const onAccurateFolderName = ()=>{
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                enabled: false,
                companyId: companyId,
                moduleType: tab,
                sectionCode: null,
                scope: 'module',
                scopeName: ''
            },
            tab: tab
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'select',
            autoFillStatusBarPhase: 'select',
            autoFillWithFilling: false,
            autoFillUploadMode: 'folders'
        }));
    };
    const subFolderModules = [
        "repository"
    ];
    const getSectionHTML = (module, currentSection)=>{
        if (module) module = JSON.parse(JSON.stringify(module));
        if (currentSection) currentSection = JSON.parse(JSON.stringify(currentSection));
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: (currentSection?.subFolders || module?.sections) && Object.values(currentSection?.subFolders || module?.sections).length && Object.values(currentSection?.subFolders || module?.sections).filter((s)=>(currentSection?.questions || s?.questions || []).find((q)=>q.qNo.match(new RegExp((s.sectionNo || s.no) + "((\.[0-9]+)|$)")))).slice().sort(sortSections).map((section, sectionIdx)=>{
                // if ((module['type'] == 'repository' || module['type'] == `business-audit-${company['testType']}`) && (user['role'] == "Advisor" || user['role'] == "Investor") && (company['advisors'] || company['investors']) && section?.['sectionNo']) {
                //     if ((!company?.['advisors']?.[user['_id']]?.['modules'][section?.['sectionNo']] && user['role'] == 'Advisor') || !company?.['investors']?.[user['_id']]?.['modules'][section?.['sectionNo']] && user['role'] == 'Investor') return;
                // }
                const qNo = section.sectionNo || section.no;
                const sectionId = section['_id'] || section['sectionId'];
                let questions;
                let showSubFolder = false;
                if (module['expansionPack']) {
                    showSubFolder = qNo.indexOf('.') < 0;
                    questions = qNo.indexOf('.') > 0 ? section['questions'] : [];
                    section.stats = section.stats || currentSection?.stats; // Temporary
                } else if (subFolderModules.includes(module.type)) {
                    if (currentSection) section.questions = currentSection.questions;
                    if (Object.values(section && section?.subFolders || {})?.find((s)=>section?.questions?.find((q)=>q.qNo.match(new RegExp((s.sectionNo || s.no) + "(\.[0-9]+)|$"))))) showSubFolder = true;
                    questions = section.questions && section.questions.filter((q)=>q.qNo === qNo) || [];
                } else questions = section.questions.filter((q)=>q.qNo.match(new RegExp(qNo + "(\.[0-9]+)|$")));
                section.files = [];
                if (section && section['files']) section.files = getFilesFromQuestions(questions);
                // Sort all questions.
                questions = questions.sort(sortQuestions);
                const jsx = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        questions && questions.length > 0 && questions.map((question)=>{
                            if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                            const answer = question.answer || {};
                            const showFiles = answer['radioOption'] === "Yes" || answer['radioOption'] == 'Disclosure' || answer['radioOption'] === "No";
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                "data-module-type": module.type,
                                "data-section-no": question['qNo'],
                                "data-question-id": question['_id'],
                                className: !showSubFolder && "bss bw2px bo5 br10px px2rem py1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `df ${answer?.['updatedBy'] ? 'jcsb' : 'jcfe'}`,
                                        children: [
                                            answer?.['updatedBy'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: answerSaved(answer)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df gg1rem fs0-75rem mb0-5rem",
                                                children: [
                                                    (section.sectionNo || section.no) && (company.gDriveLink || company.sharePointLink || company.dropBoxLink) && module['uploadFiles'] && !tab.includes('directors-questionnaire') && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: (section.editPermission ?? true ? "" : "op20 pen ") + "bg5 bg6-hover c1-hover td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                                        onClick: ()=>company.gDriveLink && syncDrive(sectionId, question['qNo']) || company.sharePointLink && syncSharePoint(sectionId, question['qNo']) || company.dropBoxLink && syncDropbox(sectionId, question['qNo']),
                                                        children: "Sync"
                                                    }),
                                                    answer['logs'] && answer['logs'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        onClick: ()=>{
                                                            handleSectionLogs(answer['_id']);
                                                            setLogModule(` - ${section['sectionName'] || section['name']} - ${question['qNo']}`);
                                                        },
                                                        className: "mla bg5 bg6-hover c1-hover td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                                        children: "Log"
                                                    }),
                                                    showFiles && answer && answer.files && answer?.files?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        onClick: ()=>{
                                                            setSection({
                                                                ...section,
                                                                questionId: question?.['qNo']
                                                            });
                                                            onClickFileManager(section);
                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: 'manageFiles'
                                                            }));
                                                        },
                                                        className: "bg5 bg6-hover c1-hover td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                                        children: [
                                                            "Manage Files (",
                                                            answer.files.length,
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        "data-module-type": module.type,
                                        "data-section-no": qNo,
                                        "data-question-id": question['_id'],
                                        className: (question.editPermission ?? true ? "" : "op20 pen ") + "gtcr" + (module['uploadFiles'] ? 2 : 1) + "-lg df fdr jcsb gg2rem report-upload-area-saf",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w50",
                                                children: [
                                                    section.sectionName === 'Legal' && !module['type'].includes("business-audit") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "fs1rem",
                                                        children: [
                                                            question.qNo,
                                                            " ",
                                                            question.qDescription
                                                        ]
                                                    }) : module['type'].includes("investor-lead") && question.qNo.split('.').length > 3 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "fs1rem",
                                                        children: [
                                                            question.qNo,
                                                            ".",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '14px'
                                                                },
                                                                children: question.qNo
                                                            }),
                                                            " - ",
                                                            question.qDescription
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "fs1rem",
                                                        children: [
                                                            question.qNo,
                                                            " ",
                                                            question.qDescription
                                                        ]
                                                    }),
                                                    (()=>{
                                                        const options = question.questionType === 'yesNo' ? [
                                                            'Yes',
                                                            'No',
                                                            'N/A'
                                                        ] : question.questionType === 'YN/F/T' ? [
                                                            'Yes',
                                                            'No',
                                                            'N/A'
                                                        ] : question.questionType === '1to5' ? [
                                                            1,
                                                            2,
                                                            3,
                                                            4,
                                                            5
                                                        ] : question.questionType === 'D/ND' ? [
                                                            'Disclosure',
                                                            'No Disclosure',
                                                            'Not Sure',
                                                            'N/A'
                                                        ] : question.questionType === 'Date' ? [] : question.questionType === 'Radio' || question.questionType === 'DropDown' || question.questionType === 'Multi' ? (question.options || []).map((o)=>typeof o === 'object' ? o['value'] ?? o['name'] ?? '' : o).filter((o)=>o !== '') : [
                                                            'Yes',
                                                            'No',
                                                            'N/A'
                                                        ];
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df aic fww",
                                                            children: options.map((option, indOpt)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            for: question._id + option,
                                                                            className: `df cp fs0-75rem ${question.questionType === '1to5' && (option == 1 || option == 5) ? 'pt2rem pb0-5rem' : 'py1rem'}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "checkbox w30px h30px pr",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        defaultChecked: answer.radioOption == option,
                                                                                        "data-option": option,
                                                                                        onChange: (e)=>radioButtonChanged(e, question, qNo, module.type),
                                                                                        name: question._id,
                                                                                        id: question._id + option,
                                                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                                                        type: "radio"
                                                                                    }, `${question._id}-${option}-${answer.radioOption}${indOpt}`)
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                                    children: option
                                                                                })
                                                                            ]
                                                                        }, question._id + option),
                                                                        question.questionType === '1to5' && option == 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "c9 fs0-75rem",
                                                                            children: "Poor"
                                                                        }),
                                                                        question.questionType === '1to5' && option == 5 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "c7 fs0-75rem",
                                                                            children: "Excellent"
                                                                        })
                                                                    ]
                                                                }))
                                                        });
                                                    })(),
                                                    answer.radioOption === "No" && [
                                                        "riskDescription",
                                                        "recommendDescription"
                                                    ].filter((key)=>question[key]).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "recommendation",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                                    className: "fs1-25rem mt2rem df aic",
                                                                    children: key.includes("recommend") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                className: "f3 mr0-5rem mah2rem maw2rem",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                viewBox: "0 0 640 512",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        className: "fa-primary",
                                                                                        d: "M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        className: "fa-secondary",
                                                                                        d: "M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            "Recommendation:"
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                className: "f4 mr0-5rem mah2rem maw2rem",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                viewBox: "0 0 512 512",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        className: "fa-primary",
                                                                                        d: "M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        className: "fa-secondary",
                                                                                        d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            "Risk:"
                                                                        ]
                                                                    })
                                                                }),
                                                                question[key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "mt1rem",
                                                                        children: s
                                                                    }, i))
                                                            ]
                                                        }, question._id + key)),
                                                    module.stats.completionPercent == 100 && [
                                                        "Yes",
                                                        "No",
                                                        1,
                                                        2,
                                                        3,
                                                        4,
                                                        5
                                                    ].filter((key)=>question["if" + key]).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "recommendation" + (answer.radioOption == key ? "" : " dn"),
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                                    className: "fs1rem mt2rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            className: "f3 mr0-5rem mah2rem maw2rem",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            viewBox: "0 0 640 512",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    className: "fa-primary",
                                                                                    d: "M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    className: "fa-secondary",
                                                                                    d: "M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        "Recommendation:"
                                                                    ]
                                                                }),
                                                                question["if" + key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "mt1rem",
                                                                        children: s
                                                                    }, i))
                                                            ]
                                                        }, question._id + key)),
                                                    question.topTip && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: (showFiles ? "" : "op0 h0 dn ") + "showOrHide oyh td250 df aifs mb0-5rem mt0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        className: "f3 w20px mr0-5rem",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        viewBox: "0 0 640 512",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                className: "fa-primary",
                                                                                d: "M240.1 415.1l.0167 38.36c0 6.297 1.89 12.43 5.359 17.68l17.09 25.69c5.25 7.875 17.18 14.28 26.65 14.28h61.72c9.438 0 21.38-6.394 26.63-14.27l17.09-25.69C397.6 467.6 400 459.7 400 454.4l.1562-70.35l-159.9 .002L240.1 415.1zM112 192c0-13.25-10.75-24-24-24h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64C101.3 216 112 205.3 112 192zM616 168h-64c-13.25 0-24 10.75-24 24s10.75 24 24 24h64c13.25 0 24-10.75 24-24S629.3 168 616 168zM131.1 55.25l-55.5-32C68.25 18.75 59 18.63 51.38 22.88c-7.5 4.375-12.13 12.37-12.13 21c.125 8.75 4.875 16.75 12.38 20.88L107.1 96.75C114.5 101.3 123.8 101.4 131.4 97.13c7.5-4.375 12.12-12.37 12.12-21C143.4 67.38 138.6 59.38 131.1 55.25zM588.4 319.3l-55.5-32c-7.375-4.5-16.62-4.625-24.25-.375c-7.5 4.375-12.12 12.37-12.12 21c.125 8.75 4.875 16.75 12.38 20.88l55.5 32c11.38 6.375 25.88 2.375 32.38-9C603.3 340.5 599.5 326 588.4 319.3zM107.1 287.3L51.62 319.3c-7.5 4.125-12.25 12.12-12.38 20.88c0 8.625 4.625 16.63 12.13 21c7.625 4.25 16.87 4.125 24.25-.375l55.5-32c11.12-6.75 14.87-21.25 8.375-32.5C133 284.9 118.5 280.9 107.1 287.3zM521 100c4.125 0 8.25-1.125 12-3.25l55.38-32c11.25-6.75 14.88-21.25 8.375-32.5c-6.5-11.38-21-15.38-32.38-9L509 55.25c-9.5 5.375-14 16.5-11.25 27C500.6 92.75 510.1 100 521 100z"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                className: "fa-secondary",
                                                                                d: "M319.5 .0154C217.5 .2654 144 82.1 144 175.1c0 42.63 15.4 83.76 43.52 115.8c16.62 18.88 42.36 58.23 52.24 91.48c0 .25 .1146 .5105 .1146 .7604l160.3 .0007c0-.25 .0833-.5111 .0833-.7611c9.875-33.25 35.61-72.61 52.24-91.48C480.6 259.8 496 218.6 496 175.1C496 78.62 416.8-.2346 319.5 .0154zM320 96.01c-44.13 0-80 35.87-80 79.1c0 8.875-7.125 16-16 16s-16-7.125-16-16C208.1 114.1 258.1 64.14 320 64.01c8.875 0 16 7.126 16 16S328.9 96.01 320 96.01z"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                        children: "Top Tip"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: (showFiles ? "" : "op0 h0 dn ") + "showOrHide oyh td250 w100 mb0-5rem",
                                                                children: question.topTip
                                                            })
                                                        ]
                                                    }),
                                                    question.toolboxOffer && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: (showFiles ? "" : "op0 h0 dn ") + "showOrHide oyh td250 df aifs mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        className: "f3 w20px mr0-5rem",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        viewBox: "0 0 512 512",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                className: "fa-primary",
                                                                                d: "M512 205.3V320h-128V272C384 263.1 376.9 256 368 256h-32C327.1 256 320 263.1 320 272V320H192V272C192 263.1 184.9 256 176 256h-32C135.1 256 128 263.1 128 272V320H0V205.3c0-8.5 3.375-16.62 9.375-22.62l45.25-45.25C60.63 131.4 68.75 128 77.25 128h357.5c8.5 0 16.62 3.375 22.62 9.375l45.25 45.25C508.6 188.6 512 196.8 512 205.3z"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                className: "fa-secondary",
                                                                                d: "M384 320v48c0 8.875-7.125 16-16 16h-32c-8.875 0-16-7.125-16-16V320H192v48C192 376.9 184.9 384 176 384h-32C135.1 384 128 376.9 128 368V320H0v128c0 17.62 14.38 32 32 32h448c17.62 0 32-14.38 32-32v-128H384zM176 80h160V128H384V80C384 53.5 362.5 32 336 32h-160C149.5 32 128 53.5 128 80V128h48V80z"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                        children: "Toolbox Offer"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: (showFiles ? "" : "op0 h0 dn ") + "showOrHide oyh td250 w100 mb0-5rem",
                                                                children: question.toolboxOffer
                                                            })
                                                        ]
                                                    }),
                                                    question.templateFiles && question.templateFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: (showFiles ? "" : "op0 h0 dn ") + "showOrHide df fww mt0-5rem",
                                                        children: question.templateFiles.map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                className: "df jcc aic br25px lh1 bg4 c1 px0-5rem fw600 mr0-5rem mb0-5rem",
                                                                target: "_blank",
                                                                href: file.location,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "py0-5rem pl0-5rem",
                                                                    children: file.originalname
                                                                })
                                                            }, file.originalname))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: (!answer['radioOption'] && "op0 h0 dn ") + " w50 showOrHide oyh td250 ",
                                                children: [
                                                    question?.['answer']?.['radioOption'] !== 'N/A' && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        for: question._id + "complete",
                                                        className: "df cp mt0-5rem pb1rem pl3rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "checkbox w30px h30px pr",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    defaultChecked: answer.status === "Completed",
                                                                    onChange: (e)=>saveAnswer(e, question, qNo),
                                                                    name: "status",
                                                                    id: question._id + "complete",
                                                                    className: "br20 shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                                    type: "checkbox"
                                                                }, `${question._id}-${qNo}-${answer.status}`)
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw500 w100 fs0-75rem lh3 ml0-5rem usn mr2rem",
                                                                children: "Mark as Complete"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        onDragOver: onDragOver,
                                                        onDrop: (e)=>onDrop(e, question, qNo),
                                                        for: "fileUpload" + question._id,
                                                        className: "w100 bsbb bg5 br5px df jcc aic px1rem py2rem bsd bo6 bw2px cp mb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "pen fs1rem fw500 tac",
                                                                children: "Click here or drag and drop files (max 100MB)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                onChange: (e)=>saveAnswer(e, question, qNo),
                                                                className: "dn",
                                                                id: "fileUpload" + question._id,
                                                                type: "file",
                                                                multiple: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fww",
                                                        children: answer.files && answer.files.map((file)=>{
                                                            let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: `df jcc aic br25px lh1 c1 px0-5rem fw600 mr0-5rem mb0-5rem ${fileColor}`,
                                                                target: "_blank",
                                                                to: getViewableURL(file.location),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "py0-5rem pl0-5rem",
                                                                        children: file.originalname
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "fa fa-trash m0-5rem red",
                                                                        "aria-hidden": "true",
                                                                        onClick: (e)=>{
                                                                            e.preventDefault();
                                                                            setDeleteFileQuestionId(question._id);
                                                                            setDeleteFile(file);
                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                open: 'deleteFile',
                                                                                from: ''
                                                                            }));
                                                                        }
                                                                    })
                                                                ]
                                                            }, file.originalname);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "oyh td250 pr",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                defaultValue: answer.comment,
                                                                rows: "3",
                                                                style: {
                                                                    resize: "vertical"
                                                                },
                                                                onBlur: (e)=>saveAnswer(e, question, qNo),
                                                                name: "comment",
                                                                type: "text",
                                                                placeholder: "Any notes you wish to add\u2026",
                                                                className: "pl4rem bss bw2px bo5 w100 br5px p1rem"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                className: "f3 pa mt1rem l0 ml1rem w2rem",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 512 512",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        className: "fa-primary",
                                                                        d: "M23.1 512c-6.156 0-12.28-2.344-16.97-7.031c-9.375-9.375-9.375-24.6 0-33.98l304-303.1c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-303.1 304C36.32 509.7 30.16 512 23.1 512z"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        className: "fa-secondary",
                                                                        d: "M483.4 244.2L351.9 287.1h97.74c-9.873 10.62 3.749-3.125-46.24 46.87l-147.6 49.12h98.24c-74.99 73.12-194.6 70.62-246.8 54.1l237.8-238c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L72.87 405.2l-.3107-.5296c-9.24-30.89-29.15-162.9 56.55-248.4l85.74-85.68c90.62-90.62 189.8-88.27 252.3-25.78C517.8 95.34 528.9 169.7 483.4 244.2z"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, question._id);
                        }),
                        showSubFolder && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "toggleHeight cp",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "oh dg",
                                style: {
                                    cursor: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                    " ",
                                    getSectionHTML(module, section)
                                ]
                            })
                        })
                    ]
                });
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    ref: (el)=>{
                        if (section['sectionNo']) sectionRefs.current[sectionIdx] = el;
                    },
                    id: qNo,
                    className: (section['sectionNo'] && "sectionWrapper ") + "bss bw2px bo5 br10px px1rem py0-5rem fs1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: (section['sectionNo'] && "sectionTitle") + " fs0-75rem",
                            children: [
                                qNo,
                                " - ",
                                getCompletenessAndRiskHTML(module.type, section.stats, questions)
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df",
                            children: section.sectionName ? /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "fs1-25rem mr1rem mb0-5rem",
                                children: section.sectionName
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "fs1rem mr1rem mb0-5rem",
                                children: section.name
                            })
                        }),
                        module.type === "business-audit" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "toggleHeight cp",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mb0-5rem td250 fs0-75rem pen bg5 c6 br5px fw600 px0-5rem py0-5rem",
                                    children: "Show Section"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "oh dg",
                                    style: {
                                        cursor: "auto",
                                        height: "0px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                        jsx
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg",
                            children: jsx
                        })
                    ]
                }, qNo);
            })
        });
    };
    const sortQuestions = (a, b)=>{
        if (tab && tab == 'investor-lead' && (a.qNo.split('.').length > 3 || b.qNo.split('.').length > 3)) {
            let valueA = a.qNo.split('.')[a.qNo.split('.').length - 2];
            let valueB = b.qNo.split('.')[a.qNo.split('.').length - 2];
            return valueA - valueB;
        } else {
            let valueA = a.qNo.split('.')[a.qNo.split('.').length - 1];
            let valueB = b.qNo.split('.')[a.qNo.split('.').length - 1];
            return valueA - valueB;
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "td250 container bg1 py1rem shadow w100 df",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `w80 mr1rem dg ${localStorage.getItem('isDemoChecklist') && 'mb6rem'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dg gtcr4-md gg0-5rem btn-dataroom-saf mah3rem",
                                style: tab === 'Investment Readiness' ? {
                                    display: 'none'
                                } : {},
                                children: tab === "kitemark" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Kitemark Audit"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Kitemark Report"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Digital Certificate"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Full Report"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Report by Section"
                                        })
                                    ]
                                }) : (()=>{
                                    const [syncLink, driveName] = company.gDriveLink ? [
                                        company.gDriveLink,
                                        "Google Drive"
                                    ] : company.sharePointLink ? [
                                        company.sharePointLink,
                                        "SharePoint"
                                    ] : company.dropBoxLink ? [
                                        company.dropBoxLink,
                                        "DropBox"
                                    ] : [
                                        undefined,
                                        "Not Connected"
                                    ];
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: tab == 'repository' && !company['modules'][tab]?.isHealthBoost && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pr df filing-assistant-pos jce aife",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "menuHover pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        onMouseEnter: ()=>setFAMenuVisible(true),
                                                        className: "w200px btn-filing-assistant shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "tooltip-area",
                                                                style: {
                                                                    top: '-8px',
                                                                    right: '-8px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                                    className: "icon",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "h3rem",
                                                                            src: (parcelRequire("24u8s")),
                                                                            alt: ""
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "overlay-box",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    children: "You can always manually upload files into our repository using our checklist questions below."
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    children: "However, our Filing Assistant enables you to point to the Data Room/folders/files you would like us to quickly ingest into your Diligentsia Data Repository and our Filing Assistant will automatically allocate them to the various sections within our repository index structure in seconds"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    children: 'Prior to actual allocation, our Filing Assistant Manager allows you to review our proposed allocation of files to sections and if necessary reallocate before you "go firm".'
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    children: "You can also use our deduper feature to remove unwanted duplicate files."
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    children: "We provide complete audit logs and reports within the Data Repository itself."
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            "Filing Assistant"
                                                        ]
                                                    }),
                                                    isFAMenuVisible && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "miw100 menu op0 bsbb bw0px bbw5px bss bo3 zi1 bg1 shadow td250 pen p0-5rem pa t100 r0 df fdc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                onClick: onAccurateFileName,
                                                                className: "bsbb wsn w100 td250 c4-hover p0-5rem ass cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Import Files"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                onClick: onAccurateFolderName,
                                                                className: "bsbb w100 wsn td250 c4-hover p0-5rem ass cp",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: "Import Folders"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                onClick: onClickFileReportHistory,
                                                                className: "bsbb w100 td250 c4-hover p0-5rem ass cp wsn",
                                                                children: "Filing Assistant History"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                onClick: onClickViewUnallocatedFiles,
                                                                className: "bsbb w100 td250 c4-hover p0-5rem ass cp wsn",
                                                                children: "View Unallocated Files"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                onClick: ()=>checkDuplicatedFiles(),
                                                                className: "bsbb w100 td250 c4-hover p0-5rem ass cp wsn",
                                                                children: "Deduper"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                onClick: onClickDeduperReportHistory,
                                                                className: "bsbb w100 td250 c4-hover p0-5rem ass cp wsn",
                                                                children: "Deduper Reports"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    });
                                })()
                            }),
                            tab === 'Investment Readiness' && company?.modules?.[tab] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic jce",
                                style: {
                                    gap: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86bb04e68ae2fbe5$export$2e2bcd8739ae039), {
                                        companyId: companyId,
                                        moduleType: tab,
                                        moduleId: null,
                                        tab: tab,
                                        activeModule: company.modules[tab],
                                        onComplete: ()=>reloadModule && reloadModule(tab, true)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83364f35f447dab2$export$2e2bcd8739ae039), {
                                        companyId: companyId,
                                        moduleType: tab,
                                        moduleId: company.modules[tab]?._id,
                                        scope: "module",
                                        scopeName: company.modules[tab]?.heading || tab,
                                        size: "medium",
                                        onComplete: ()=>{
                                            reloadModule && reloadModule(tab);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dg gtcr4-md gg0-5rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                wrapperClass: "tac ttc",
                                heading: company?.modules[tab]?.heading,
                                subheading: company?.modules[tab]?.subheading
                            }),
                            getSectionHTML(company.modules[sanitiseTab(tab)])
                        ]
                    }),
                    company?.modules[tab.includes('%20') ? tab.replaceAll('%20', ' ') : tab] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $73a5f3cb80d8115d$export$2e2bcd8739ae039), {
                        setIsWorkflowReport: setIsWorkflowReport,
                        visibleSection: visibleSection,
                        profileClass: profileClass,
                        advisors: advisors,
                        permissionLevel: permissionLevel,
                        company: company,
                        setCompany: setCompany,
                        isLoader: isLoader,
                        setIsLoader: setIsLoader,
                        getUser: getUser,
                        tab: tab,
                        sanitiseTab: sanitiseTab,
                        toggleReport: toggleReport,
                        openKPI: openKPI,
                        calculateStats: calculateStats,
                        calculateSubFolderStats: calculateSubFolderStats,
                        getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                        setSection: setSection,
                        getViewableURL: getViewableURL,
                        twoMinuteTestAIReport: twoMinuteTestAIReport,
                        getFitInvestorFirms: getFitInvestorFirms,
                        sortSections: sortSections,
                        handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness,
                        updateUserType: updateUserType,
                        handlePartnerChecklistNext: handlePartnerChecklistNext,
                        setCompanyDashboardTab: setCompanyDashboardTab,
                        setTab: setTab,
                        setTabName: setTabName,
                        closeTab: closeTab,
                        isBackFitReport: isBackFitReport,
                        setIsBackFitReport: setIsBackFitReport,
                        isExternalPage: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'fileReportHistory',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: company.cName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                children: "Diligentsia Filing Assistant"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg0-5rem mb2rem fs1rem mah300px oya",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    className: "fis bcc frs-table",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th frs-th",
                                                        children: "Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th frs-th",
                                                        children: "File Count"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th frs-th",
                                                        children: "Import By"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th frs-th",
                                                        children: "Reallocated By"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th frs-th",
                                                        children: "Accuracy Change"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th",
                                                        style: {
                                                            minWidth: '124px'
                                                        },
                                                        children: "Status"
                                                    })
                                                ]
                                            })
                                        }),
                                        reportHistories.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: reportHistories.filter((f)=>f['importResult'] != null && f['importResult'] != undefined).map(getReportHistoryEntryHTML)
                                        })
                                    ]
                                }),
                                reportHistories.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs1-25rem tac",
                                    children: "No file report history"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'unallocatedFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mih80 pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px mah80 br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df fdr jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: [
                                    company.cName,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Unallocated File Manager -",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ml1rem",
                                        "data-tooltip": "Your Diligentsia Filing Assistant was unable to automatically <br/>allocate these files to our Data Repository sections.  <br/>Could you please help them by manually reallocating them <br/>from your \u201Cunallocated bin\u201D to the correct section or subsection <br/>folder in your Data Repository?",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon",
                                            "data-tooltip": "Your Diligentsia Filing Assistant was unable to automatically <br/>allocate these files to our Data Repository sections.  <br/>Could you please help them by manually reallocating them <br/>from your \u201Cunallocated bin\u201D to the correct section or subsection <br/>folder in your Data Repository?",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                width: '25px',
                                                height: '25px',
                                                "data-tooltip": "Your Diligentsia Filing Assistant was unable to automatically <br/>allocate these files to our Data Repository sections.  <br/>Could you please help them by manually reallocating them <br/>from your \u201Cunallocated bin\u201D to the correct section or subsection <br/>folder in your Data Repository?",
                                                src: (parcelRequire("24u8s")),
                                                alt: ""
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                    children: "Diligentsia Filing Assistant"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: onClickUnallocatedBinAuditLog,
                                    className: "pa r0 cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem mr3rem fw500",
                                    children: "Audit Log"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mb2rem fs1rem w100 fg1 oya",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    className: "fis bcc frs-table w100 h100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th frs-th",
                                                        style: {
                                                            width: '40%'
                                                        },
                                                        children: "Unallocated File"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "fis-th frs-th",
                                                        style: {
                                                            width: '60%'
                                                        },
                                                        children: "File Re-Allocator"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: unallocatedFiles && unallocatedFiles.length > 0 && unallocatedFiles.map(getUnallocatedFileHTML)
                                        })
                                    ]
                                }),
                                unallocatedFiles && unallocatedFiles.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw600 mt1rem tac",
                                    children: "No unallocated files"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1047f7c995c3f14f$export$2e2bcd8739ae039), {
                modalType: 'manageFiles',
                reloadModule: reloadModule,
                section: section,
                setSection: setSection,
                company: company,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                setDeleteFileQuestionId: setDeleteFileQuestionId,
                setDeleteFile: setDeleteFile,
                tab: tab,
                targetSection: targetSection
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'checkingDuplication',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 tac mb1rem fs1-5em",
                            children: company.cName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fs1-25rem-sm ttu w100 tac mb2rem",
                            children: "Diligentsia DeDuper Assistant"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "\uD83D\uDD2E ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Deduper Magic:"
                                        }),
                                        " We're now summoning the power of AI to checking duplication of files! ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "Please stay with us during this magical incantation\u2026"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h9rem",
                                    src: (parcelRequire("hA45b")),
                                    alt: ""
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'allocatingFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style cookies-modal mah100 bg1 shadow w100 df fdc m1rem pr br10px pr freecompany-modal",
                    style: {
                        outline: 'none',
                        maxWidth: '750px',
                        borderRadius: '20px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "pa t0 ro",
                            src: (parcelRequire("aYFpF")),
                            alt: "",
                            style: {
                                right: '-236px',
                                width: '38%'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p3rem pr w100 bsbb tac",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w10rem h10rem mla mra mt1rem",
                                    src: (parcelRequire("hA45b")),
                                    alt: "",
                                    style: {
                                        marginTop: '-54px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                                    children: company.subscription
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h2rem pa t0 r0",
                                    src: (parcelRequire("jSVu6")),
                                    alt: "TODO",
                                    style: {
                                        top: '15px',
                                        right: '21px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-gradient fw600 tac mb1rem fs1-5em",
                                    children: company.cName
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "c15 fs1-25rem-sm w100 tac mb1rem",
                                    children: "Performing Filing assistant magic!"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "progress-area w60 mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "progress-dashboard-horizantal mb1rem",
                                            role: "progressbar",
                                            id: "progressBar",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "progress-bar progress-bar-striped progress-bar-animated",
                                                id: "innerBar",
                                                style: {
                                                    width: `70%`
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem",
                                            style: {
                                                color: '#15131370'
                                            },
                                            children: "This may take a few seconds"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs0-75rem",
                                        style: {
                                            color: '#15131370'
                                        },
                                        children: [
                                            "We\u2019re now summoning the power of AI to allocating files to appropriate sections! ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Please stay with us during this magical incantation."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                bottom: '-80px',
                                transform: 'translateX(-50%)'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'duplicationCheckSummary',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 tac mb1rem fs1-5em",
                            children: company.cName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fs1-25rem-sm ttu w100 tac mb2rem",
                            children: "Diligentsia DeDuper Assistant"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>onClickDeduperAuditLog(dupCheck['_id']),
                            className: "pa r0 cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem mr3rem fw500",
                            children: "Audit Log"
                        }),
                        dupCheck.deduperResult && Object.keys(dupCheck.deduperResult).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            className: "w100 mb2rem",
                            children: [
                                "Checked by\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `w2rem h2rem jcc aic br100 bw3px bss dib wsn`,
                                    children: dupCheck?.['checkBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: dupCheck?.['checkBy']?.['profile'],
                                        className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
                                        "data-tooltip": dupCheck?.['checkBy']?.['firstName'] ? dupCheck?.['checkBy']?.['firstName'] + " " + dupCheck?.['checkBy']?.['lastName'] : "?"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `wsn w2rem h2rem df jcc aic br100 bg3 c1`,
                                        "data-tooltip": dupCheck?.['checkBy']?.['firstName'] ? dupCheck?.['checkBy']?.['firstName'] + " " + dupCheck?.['checkBy']?.['lastName'] : "?",
                                        children: dupCheck?.['checkBy']?.['firstName'] ? dupCheck?.['checkBy']?.['firstName'][0] + dupCheck?.['checkBy']?.['lastName'][0] : "?"
                                    })
                                }),
                                "\xa0",
                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(dupCheck?.['checkAt']).format('lll')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg0-5rem mb2rem fs1rem mah300px oya",
                            children: [
                                dupCheck.deduperResult && Object.keys(dupCheck.deduperResult).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "dg gg0-5rem mb2rem fs1rem",
                                    children: Object.keys(dupCheck.deduperResult).map(getDuplicationCheckEntryHTML)
                                }),
                                (!dupCheck.deduperResult || Object.keys(dupCheck.deduperResult).length == 0) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs1-25rem tac",
                                    children: "No Duplicated files"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: modal['from'] == 'deduperHistory' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'deduperReportHistory'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttu bsbb tac mb1rem df jcc aic mr1rem",
                                children: "Back to List"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'connectDataroom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw900px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs3rem fw600 tac mb2rem",
                            children: "Connect Data Room"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gtcr3-md gg1rem mb2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "bg1 br5px bss bo6 bw2px p1rem shadow",
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    href: company?.gDriveURL,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "ma mb1rem df jcc aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                    className: "maw100 mr0-5rem h2rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs1-5rem dib",
                                                    children: "Google Drive"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 tac fw600 fs1-25rem",
                                            children: [
                                                "Connect Now",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "f3 ml0-5rem w1rem",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 448 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M256 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L370.8 256l-137.4-137.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C272.4 444.9 264.2 448 256 448z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l32 32L338.8 288z"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "bg1 br5px bss bo6 bw2px p1rem shadow",
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    href: company?.dropboxURL,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "ma mb1rem df jcc aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                    className: "maw100 mr0-5rem h2rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs1-5rem dib",
                                                    children: "Dropbox"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 tac fw600 fs1-25rem",
                                            children: [
                                                "Connect Now",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "f3 ml0-5rem w1rem",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 448 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M256 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L370.8 256l-137.4-137.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C272.4 444.9 264.2 448 256 448z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l32 32L338.8 288z"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "bg1 br5px bss bo6 bw2px p1rem shadow",
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    href: company?.sharePointAuthURL,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "ma mb1rem df jcc aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                    className: "maw100 mr0-5rem h2rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "fs1-5rem dib",
                                                    children: "SharePoint"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 tac fw600 fs1-25rem",
                                            children: [
                                                "Connect Now",
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "f3 ml0-5rem w1rem",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 448 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M256 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L370.8 256l-137.4-137.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C272.4 444.9 264.2 448 256 448z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l32 32L338.8 288z"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7e1847e3fac637e$export$2e2bcd8739ae039), {
                                        className: "maw100 mr0-5rem h2rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40e3ff42cf90ee3a$export$2e2bcd8739ae039), {
                                        className: "maw100 mr0-5rem h2rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $163b83667de8cb50$export$2e2bcd8739ae039), {
                                        className: "maw100 mr0-5rem h2rem"
                                    })
                                ].map((logo, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg1 br5px bss bo6 bw2px p1rem shadow op20 pen",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "ma mb1rem df jcc aic",
                                                children: logo
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "w100 tac fw600 fs0-75rem",
                                                children: "Coming Soon"
                                            })
                                        ]
                                    }, idx))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-5rem fs2rem-sm ttu w100 tac mb1rem",
                            children: "What's This?"
                        }),
                        [
                            "This links and mirrors your Diligentsia Data Repository and your existing cloud storage provider.*",
                            "Our automated API will create a Diligentsia Corporate Folder within your chosen cloud provider's storage.*",
                            "At your command (not ours), the two are synced.",
                            "Diligentsia does NOT access your other folders at any time",
                            "Diligentsia does NOT send your data outside our platform - only you can do so."
                        ].map((bulletPoint, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb0-5rem df aifs",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        className: "w2rem ha f3 mr0-5rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 448 512",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-primary",
                                                d: "M310.6 278.6l-112 112c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25L242.8 256L153.4 166.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l112 112C316.9 239.6 320 247.8 320 256S316.9 272.4 310.6 278.6z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-secondary",
                                                d: "M384 32H64C28.65 32 0 60.66 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.66 419.3 32 384 32zM310.6 278.6l-112 112c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25L242.8 256L153.4 166.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l112 112C316.9 239.6 320 247.8 320 256S316.9 272.4 310.6 278.6z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w100",
                                        children: bulletPoint
                                    })
                                ]
                            }, idx)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "mt1rem fs1rem",
                            children: "*You must already have an account with that provider (we cannot access files already on the provider's platform and we do not collect personal data from the provider)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'proaddsection',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw900px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdr jcc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-gradient fs3rem fw600 tac mb2rem",
                                    children: "User-Defined Sections"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pr df filing-assistant-pos jcfs aife",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "additional-sections-info pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area",
                                            style: {
                                                top: '-32px',
                                                right: '-24px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                className: "icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "h3rem",
                                                        src: (parcelRequire("24u8s")),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Creating a new user-defined section here will add it to the standard Index used in the Data Repository and reporting, and will be replicated in your cloud data room (Dropbox/Drive/Sharepoint)."
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed66be3561152e3$export$2e2bcd8739ae039), {
                modalType: "deleteFile",
                deleteFile: deleteFile,
                onConfirm: ()=>confirmDeleteFile(modal['from']),
                onCancel: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: modal['from']
                    }))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteUnallocatedFile',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'unallocatedFiles'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'unallocatedFiles'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs3rem fw600",
                            children: "Delete Unallocated File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem",
                            children: "Are you sure you want to delete this unallocated file?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-25rem fw500 mb1rem",
                            children: deleteUnallocatedFile && deleteUnallocatedFile.originalname
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>confirmDeleteUnallocatedFile(),
                            className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'unallocatedFiles'
                                })),
                            className: "c3-hover td250 fs1-25rem cp",
                            children: "Cancel"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'auditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: [
                                "See the history of ",
                                company?.['modules']?.[tab]?.['heading'],
                                " ",
                                logModule
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getLogsHTML(logList, true) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttu w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deduperReportAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'duplicationCheckSummary'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'duplicationCheckSummary'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of Company Deduper Report"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getDeduperReportLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttu w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'duplicationCheckSummary'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttu bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'unallocatedBinAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'unallocatedFiles'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'unallocatedFiles'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of Company Unallocated Bin"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getUnallocatedBinLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttu w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'unallocatedFiles'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttu bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'fileReportAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'importSummary'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'importSummary'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of Company File Import"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getFileReportLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttu w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'importSummary'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttu bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'createdDataRoom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb0-5rem",
                                children: [
                                    "Good news!  Your Cloud Data",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Room has now been created.",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "You can now sync.\xe2\u20AC\u2039"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttu bsbb df jcc",
                                onClick: ()=>{
                                    window.location.href = `/company/${companyId}#repository`;
                                },
                                children: "Let\xe2\u20AC\u2122s go!\xe2\u20AC\u2039"
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");




var $acw62 = parcelRequire("acw62");























function $d6123099ae995020$export$2e2bcd8739ae039({ user: user, company: company, module: module, tab: tab, setTab: setTab, setIsBackFitReport: setIsBackFitReport, fitInvestorFirms: fitInvestorFirms, getFitInvestorFirms: getFitInvestorFirms, investorId: investorId, linearProgress: linearProgress, setIsShowFitReport: setIsShowFitReport, sortSections: sortSections }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    let [isReload, setIsReload] = (0, $acw62.useState)(false);
    let [leadStatus, setLeadStatus] = (0, $acw62.useState)('');
    let [fitMetrics, setFitMetrics] = (0, $acw62.useState)({});
    let [investorFirm, setInvestorFirm] = (0, $acw62.useState)({});
    let [isBlurContact, setIsBlurContact] = (0, $acw62.useState)(true);
    let [isEditDeatils, setIsEditDeatils] = (0, $acw62.useState)(false);
    let [sectionTab, setSectionTab] = (0, $acw62.useState)([
        'Fit Metrics',
        'About the Investor',
        'About the Company',
        'Foundational Diligence Reports',
        'Value Diligence Reports',
        'Detailed Answers'
    ]);
    // OPTIMIZATION: Lazy load directors when not available (excluded in lightweight mode)
    let [directors, setDirectors] = (0, $acw62.useState)(company?.['directors'] || []);
    // OPTIMIZATION: Lazy load research aid reports when not available (excluded in lightweight mode)
    let [researchAidReports, setResearchAidReports] = (0, $acw62.useState)(company?.['researchAidReports'] || []);
    // Fetch directors if not available (excluded in lightweight mode)
    (0, $acw62.useEffect)(()=>{
        const fetchDirectors = async ()=>{
            if (company?.['directorsCount'] !== undefined && !company?.['directors']) try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/directors`);
                if (response['code'] === 200 && response['body']) setDirectors(response['body']['directors'] || []);
            } catch (e) {
                console.error('Failed to fetch directors:', e);
            }
            else if (company?.['directors']) setDirectors(company['directors']);
        };
        fetchDirectors();
    }, [
        company?._id,
        company?.['directors'],
        company?.['directorsCount']
    ]);
    // Fetch research aid reports if not embedded on the company object (not always included)
    (0, $acw62.useEffect)(()=>{
        const fetchReports = async ()=>{
            if (company?.['researchAidReports']) {
                setResearchAidReports(company['researchAidReports']);
                return;
            }
            try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/reports`);
                if (response['code'] === 200 && response['body']?.['reports']) setResearchAidReports(response['body']['reports']['researchAidReports'] || []);
            } catch (e) {
                console.error('Failed to fetch reports:', e);
            }
        };
        if (company?._id) fetchReports();
    }, [
        company?._id,
        company?.['researchAidReports'],
        company?.['reportsCount']
    ]);
    const handleScroll = (tab)=>{
        const element = document.querySelector(`[data-target="${tab}"]`); // Target element
        if (element) {
            const yOffset = -100; // Adjust this value as needed
            const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (localStorage.getItem('scrollToFoundational')) {
            setTimeout(()=>document.getElementById('Foundational Diligence Reports').scrollIntoView({
                    behavior: 'smooth'
                }), 100);
            localStorage.removeItem('scrollToFoundational');
        }
        if (localStorage.getItem('scrollToValue')) {
            setTimeout(()=>document.getElementById('Value Diligence Reports').scrollIntoView({
                    behavior: 'smooth'
                }), 100);
            localStorage.removeItem('scrollToValue');
        }
        let scrollTo = '';
        let clientId = location.href.split('#')[0].split('/')[4];
        if (location.hash.includes('#fit-report')) investorId = location.href.split('#').slice(-1)[0].split(':').slice(-1)[0];
        if (investorId) getFitReport(investorId, scrollTo);
        if (clientId && investorId) getFitMetrics(clientId, investorId, scrollTo);
    }, []);
    (0, $acw62.useEffect)(()=>{
        document.getElementById("pdfContent").classList.add("a4-pdf", "p3rem");
        let wrapper = document.getElementById("pdf");
        wrapper.innerHTML = "";
        let children = Array.from(document.getElementById("pdfContent").children);
        let i = 0;
        let _pageNumber = 1;
        let page = document.createElement("div");
        page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        wrapper.appendChild(page); // Append the first page directly
        let usedPageHeight = 96; // Initial height used on the page
        let pageHeight = getHeight(page);
        let footerHeight = 8;
        // Create watermark
        let watermark = document.createElement("img");
        watermark.classList.add("op20", "pa");
        watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
        watermark.style.top = "50%";
        watermark.style.left = "50%";
        watermark.style.width = "297mm";
        page.appendChild(watermark);
        let section = document.querySelector('#pdfContent .section-break');
        while(children.length && i < 250){
            // Process children for table and other content
            for (let child of children){
                i++;
                // Create footerLogo
                let footer = document.createElement("div");
                footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
                let footerLogo = document.createElement("img");
                footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
                footerLogo.alt = "miniicon";
                footerLogo.classList.add("h40px", "w40px", "tal");
                // Create trademark
                let trademark = document.createElement("p");
                trademark.innerText = `\xa9 Diligentsia Limited ${new Date().getFullYear()}`;
                trademark.classList.add("tac", "c37", "fs12px", "fw400");
                // Create pageNumber
                let pageNumber = document.createElement("h3");
                pageNumber.innerText = "Page " + _pageNumber;
                pageNumber.classList.add("fw600", "c36", "fs14px");
                // Append footerLogo and trademark to footer
                footer.appendChild(footerLogo);
                footer.appendChild(trademark);
                footer.appendChild(pageNumber);
                let childHeight = getHeight(child);
                if (usedPageHeight + childHeight + footerHeight > pageHeight || child?.className == section?.className) {
                    page.classList.add("df", "fdc");
                    if (i > 1) {
                        _pageNumber++;
                        page = createNewPage(wrapper);
                        page.appendChild(footer);
                    }
                    usedPageHeight = 96;
                }
                page.appendChild(child.cloneNode(true));
                usedPageHeight += childHeight;
            }
            // Remove processed children
            children.splice(0, children.length);
        }
        // Clean up after processing
        wrapper.classList.remove("op0", "pen");
        document.getElementById("pdfContent").classList.remove("a4", "p3rem");
        let contentBtn = document.querySelectorAll("#pdf button");
        for(let j = 0; j < contentBtn.length; j++){
            if (contentBtn[j]['id'] == 'bio') contentBtn[j].addEventListener('click', ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'investorBio'
                })));
            if (contentBtn[j]['id'] == 'edit-details') contentBtn[j].addEventListener('click', ()=>{
                setIsEditDeatils(false), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'editDetails'
                }));
            });
            if (contentBtn[j]['id'] == 'view-contact') contentBtn[j].addEventListener('click', ()=>handleAcceptReject('Accepted'));
            if (contentBtn[j]['id'] == 'contact-details') contentBtn[j].addEventListener('click', ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'companyContactDetails'
                })));
            if (contentBtn[j]['id'] == 'manage-file') contentBtn[j].addEventListener('click', ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'manageFiles'
                })));
            if (contentBtn[j]['id'] == 'foundational-report') contentBtn[j].addEventListener('click', handleFoundationalReport);
            if (contentBtn[j]['id'] == 'director-foundational-report') contentBtn[j].addEventListener('click', handleDirectorFoundationalReport);
            if (contentBtn[j]['id'] == 'value-report') contentBtn[j].addEventListener('click', handleValueReport);
            if (contentBtn[j]['id'] == 'readmore-investor-description') contentBtn[j].addEventListener('click', ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'readMoreInvestorDescription'
                })));
            if (contentBtn[j]['id'] == 'readmore-criteria') contentBtn[j].addEventListener('click', ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'readMoreCriteria'
                })));
            if (contentBtn[j]['id'] == 'readmore-company-description') contentBtn[j].addEventListener('click', ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'readMoreCompanyDescription'
                })));
            if (contentBtn[j]['id'] == 'copy') contentBtn[j].addEventListener('click', (e)=>{
                navigator.clipboard.writeText(e.target.id);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Text Copied!');
            });
        }
    });
    function createNewPage(wrapper) {
        let newPage = document.createElement("div");
        newPage.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        let header = document.createElement("img");
        header.classList.add("db", "ma", "h1rem");
        titleHeading(newPage);
        wrapper.appendChild(newPage);
        return newPage;
    }
    (0, $acw62.useEffect)(()=>{
        if (isReload) window.location.reload();
    }, [
        location.href
    ]);
    (0, $acw62.useEffect)(()=>{
        if (Object.keys(fitMetrics).length > 0) {
            if (fitMetrics['leadStatus'] == 'Accepted') setIsBlurContact(false);
            else setIsBlurContact(true);
        }
    }, [
        fitMetrics
    ]);
    const handleFoundationalReport = (e)=>{
        if (e.target.id !== 'foundational-report') {
            setIsBackFitReport(true);
            localStorage.setItem('scrollToFoundational', true);
            setTab(e.target.id);
        }
    };
    const handleDirectorFoundationalReport = (e)=>{
        if (e.target.id) {
            setIsBackFitReport(true);
            localStorage.setItem('scrollToFoundational', true);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'showDirectors'
            }));
        }
    };
    const handleValueReport = (e)=>{
        if (e.target.id !== 'value-report') {
            setIsBackFitReport(true);
            localStorage.setItem('scrollToValue', true);
            setTab(e.target.id);
        }
    };
    const handleInvestorLeads = async ()=>{
        if (fitInvestorFirms.length == 0) await getFitInvestorFirms();
        setIsReload(true);
    };
    const getFitReport = async (investorId, scrollTo)=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getInvestorFirm/${investorId}`);
        if (response['code'] == 200) {
            await setInvestorFirm(response['body']);
            if (scrollTo !== '') document.getElementById(scrollTo).scrollIntoView();
        }
    };
    const getFitMetrics = async (clientId, investorId, scrollTo)=>{
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getFitMetrics`, {
            clientId: clientId,
            investorId: investorId
        });
        console.log("***********response::", response);
        if (response['code'] == 200) {
            await setFitMetrics(response['body']);
            if (scrollTo !== '') document.getElementById(scrollTo).scrollIntoView();
        }
    };
    const handleAcceptReject = (status)=>{
        setLeadStatus(status);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'clientAcceptReject'
        }));
    };
    const updateLeadStatus = async (status)=>{
        let clientId = location.href.split('#')[0].split('/')[4];
        // let investorId = (location.href.split('#').slice(-1)[0]).split(':').slice(-1)[0];
        const data = {
            status: status,
            client: company['creatorId'],
            clientId: clientId,
            investor: user,
            investorId: investorId
        };
        if (clientId && investorId && investorFirm && company && company?.['creatorId']) {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateLeadStatus`, data);
            if (res['code'] == 200) {
                if (status == 'Accepted') setIsBlurContact(false);
                else setIsBlurContact(true);
                if (clientId && investorId) getFitMetrics(clientId, investorId, '');
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
            }
        }
    };
    const titleHeading = (page)=>{
        let title = document.createElement("span");
        title.classList.add("db", "w100", "fw600", "fs1-25rem", "tal", "c15");
        title.innerText = 'Fit Report';
        let subTitle = document.createElement("span");
        subTitle.classList.add("db", "w100", "fw300", "fs1rem", "tal", "c15");
        subTitle.innerText = user['role'] == "Investor" ? investorFirm['cName'] : company['cName'];
        page.appendChild(title);
        page.appendChild(subTitle);
    };
    const convertImageToBase64 = async (imgUrl)=>{
        try {
            const proxyUrl = `${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api/company/pdf-proxy?url=${encodeURIComponent(imgUrl)}`;
            const response = await fetch(proxyUrl);
            const blob = await response.blob();
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error converting image to base64:', error);
            return imgUrl;
        }
    };
    const convertAllImagesToBase64 = async (element)=>{
        const images = element.querySelectorAll('img');
        const imagePromises = [];
        for (const img of images){
            const src = img.src;
            if (src && (src.includes('s3') || src.includes('amazonaws') || src.includes('cloudfront'))) imagePromises.push(convertImageToBase64(src).then((base64)=>{
                img.setAttribute('data-original-src', src);
                img.src = base64;
            }).catch(()=>{}));
        }
        await Promise.all(imagePromises);
    };
    const restoreOriginalImages = (element)=>{
        const images = element.querySelectorAll('img[data-original-src]');
        for (const img of images){
            img.src = img.getAttribute('data-original-src');
            img.removeAttribute('data-original-src');
        }
    };
    const downloadPDF = async ()=>{
        try {
            const wrapper = document.getElementById("pdf");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.remove("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah100vh"));
            wrapper.classList.remove("gg2rem");
            for (const page of wrapper.children)page.classList.remove("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.add("op0");
            // Convert S3 images to base64 before generating PDF
            await convertAllImagesToBase64(wrapper);
            const filename = 'Fit-Report';
            const opt = {
                filename: filename,
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'p'
                },
                html2canvas: {
                    useCORS: true,
                    allowTaint: true,
                    logging: false,
                    scale: 2
                }
            };
            await (0, (/*@__PURE__*/$parcel$interopDefault($8994635913a5668f$exports)))().set(opt).from(wrapper).save();
            // Restore original image URLs after PDF generation
            restoreOriginalImages(wrapper);
            wrapper.classList.add("gg2rem");
            for (const page of wrapper.children)page.classList.add("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.remove("op0");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.add("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah100vh"));
        } catch (e) {
            console.error(e);
        }
    };
    const getOverviewContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "minh100vh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "dg gg1rem minh100vh-report",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "report-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "tal c15",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1-25rem fw600 ttu usn",
                                                children: "Fit Report"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "ass fs1-25rem mb1-5rem",
                                                children: company['cName']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "ass fs1rem",
                                                children: [
                                                    "Company Reg: ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: company?.['ukRegNo']
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "ass fs1rem",
                                                children: [
                                                    "Subscription: ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: company?.['subscription']
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "ass fs1rem",
                                                children: [
                                                    "Objective: ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Investment"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "tar c15",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "bo5 bw2 bss mb1rem w60px h60px br100",
                                                src: (user['role'] == "Investor" ? company?.['logo'] : investorFirm?.['logo']) || (parcelRequire("cfmAr")),
                                                alt: "image"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "ass fs1rem",
                                                children: [
                                                    "Generated By: ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Temp"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "ass fs1rem",
                                                children: [
                                                    "Report Date : ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now()).format('ll')
                                                    })
                                                ]
                                            }),
                                            module?.['sections'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c12 ass fs0-75rem",
                                                children: [
                                                    "Last Module Update: ",
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module?.['sections']?.[0]?.['updatedAt']).format('ll')
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc bo5 bw1px bss br10px p2rem my1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc aic w30 progress-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `progress-bar workflow-report-progress ${(module?.stats?.completionPercent || 0) > 67 ? 'workflow-progress-green' : (module?.stats?.completionPercent || 0) > 33 ? 'workflow-progress-yellow' : '  workflow-progress-grey'}`,
                                                style: {
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: '50%',
                                                    margin: 0,
                                                    border: '2px solid #F1F1F1'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                    text: (module?.stats?.completionPercent || 0) + "%",
                                                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                        strokeWidth: '0',
                                                        textSize: '25px',
                                                        trailColor: '#FBFBFB',
                                                        stroke: 'transparent',
                                                        strokeLinecap: 'butt',
                                                        backgroundColor: '#FBFBFB',
                                                        pathTransitionDuration: 0.5,
                                                        dominantBaseline: 'ideographic'
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    marginBottom: '0',
                                                    fontSize: '14px'
                                                },
                                                className: " c12",
                                                children: [
                                                    "Investor",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c4",
                                                        children: "Match"
                                                    }),
                                                    " One",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c4",
                                                        children: "Form"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " Completeness"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "w40 df jcc",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "fs1-25rem fw500",
                                            children: "Overall Result"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc aic w30 progress-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `progress-bar workflow-report-progress ${fitMetrics['fitScorePercentage'] > 85 ? 'workflow-progress-green' : fitMetrics['fitScorePercentage'] > 70 ? 'workflow-progress-orange' : '  workflow-progress-pink'}`,
                                                style: {
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: '50%',
                                                    margin: 0,
                                                    border: '2px solid #F1F1F1'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                    text: (fitMetrics['fitScorePercentage'] || 0) + "%",
                                                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                        strokeWidth: '0',
                                                        textSize: '25px',
                                                        trailColor: '#FBFBFB',
                                                        stroke: 'transparent',
                                                        strokeLinecap: 'butt',
                                                        backgroundColor: '#FBFBFB',
                                                        pathTransitionDuration: 0.5,
                                                        dominantBaseline: 'ideographic'
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    marginBottom: '0',
                                                    fontSize: '14px'
                                                },
                                                className: "c12",
                                                children: "Fit Score"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                    class: "c5"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "section-btn",
                    className: "btn-group fit-btn-group mt1rem",
                    children: sectionTab.map((tab, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            id: `content-btn-${idx}`,
                            class: "w100 df cp bg5 mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fa fa-angle-right mr1rem",
                                    style: {
                                        fontSize: '24px'
                                    },
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fs1rem fw500 c15 mb0-5rem",
                                    style: {
                                        padding: '5px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            "data-scroll-to": tab,
                                            class: "w20 fs1rem fw600 tal ml2rem",
                                            children: [
                                                "0",
                                                idx + 1
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            "data-scroll-to": tab,
                                            class: "w80 fs1rem fw300 tal",
                                            children: tab
                                        })
                                    ]
                                })
                            ]
                        });
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    class: "bo5 bw1px bss br10px p1rem c14 mt0-5rem",
                    style: {
                        fontSize: '10px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            class: "c15 fw500",
                            children: "Disclaimer - General Use & Responsibility:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "This report has been generated using the Diligentsia platform and is provided for general information purposes only. The content is based entirely on information, responses, and documentation submitted by the company, and Diligentsia Limited does not verify, audit, or validate the accuracy, completeness, or reliability of any such input. All outputs, including assessments, scores, and matches, are derived from algorithmic logic applied to self-declared data and do not constitute investment advice, endorsement, recommendation, or assurance of quality or suitability. Diligentsia Limited is not authorised or regulated by the Financial Conduct Authority and does not carry out any regulated activities as defined in the Financial Services and Markets Act 2000. The company remains solely responsible for the substance and accuracy of all information provided, and any party using this report \u2014 including prospective investors \u2014 must undertake their own due diligence and seek independent professional advice before making decisions based on its contents. Diligentsia accepts no liability for any loss or consequence arising from reliance on this report or any of its outputs."
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    class: "bo5 bw1px bss br10px p1rem c14 mt0-5rem",
                    style: {
                        fontSize: '10px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            class: "c15 fw500",
                            children: "Disclaimer \u2013 Platform Processes and Algorithms:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "The outputs contained in this report are generated through automated processes and algorithms provided by the Diligentsia platform. While these tools are designed to assist with structuring and presenting company information, Diligentsia Limited makes no representation or warranty as to the accuracy, completeness, or reliability of any outcome produced by such processes. The platform does not conduct contextual analysis, independent verification, or human review of user inputs, and no algorithmic result should be relied upon as a definitive statement of fact. Diligentsia accepts no responsibility for any inaccuracies, omissions, or misclassifications that may arise as a result of the operation of its tools, and disclaims all liability for any decisions made or actions taken in reliance on the outputs."
                    ]
                })
            ]
        });
    };
    const handleCopyClipboard = async (text)=>{
        await navigator.clipboard.writeText(text);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Text Copied!');
    };
    // Get Fit Metrics Content
    const getFitMetricsContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "section-break"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "mt3rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w100 fs1rem fw600 c15 mb0-5rem ml1rem",
                            children: "Fit Metrics"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc bo5 bw1px bss br10px p1rem",
                            id: "Fit Metrics",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "w80 df jcc fdc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "bo5 bw2 bss mb0-5rem w50px h50px br100",
                                            src: investorFirm?.['logo'] || (parcelRequire("cfmAr")),
                                            alt: "image"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem fw500",
                                            children: investorFirm?.['cName']
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w20 df jcc fdc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `progress-bar workflow-report-progress ${fitMetrics['fitScorePercentage'] > 85 ? 'workflow-progress-green' : fitMetrics['fitScorePercentage'] > 70 ? 'workflow-progress-orange' : '  workflow-progress-pink'}`,
                                            style: {
                                                width: 50,
                                                height: 50,
                                                borderRadius: '50%',
                                                margin: 0,
                                                border: '2px solid #F1F1F1'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                text: (fitMetrics['fitScorePercentage'] || 0) + "%",
                                                styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                    strokeWidth: '0',
                                                    textSize: '20px',
                                                    trailColor: '#FBFBFB',
                                                    stroke: 'transparent',
                                                    strokeLinecap: 'butt',
                                                    backgroundColor: '#FBFBFB',
                                                    pathTransitionDuration: 0.5,
                                                    dominantBaseline: 'ideographic'
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: '0',
                                                fontSize: '14px'
                                            },
                                            className: "c12",
                                            children: "Fit Score"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "df jcc mt3rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                className: "table table-striped",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    class: "fs0-75rem fsi fw400 c0",
                                                    style: {
                                                        background: '#000f66c7',
                                                        color: '#fff'
                                                    },
                                                    children: "#"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    class: "fs0-75rem fsi fw400 c0",
                                                    style: {
                                                        background: '#000f66c7',
                                                        color: '#fff'
                                                    },
                                                    children: "Preferred Investment Criteria"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    class: "fs0-75rem fsi fw400 c0",
                                                    style: {
                                                        background: '#000f66c7',
                                                        color: '#fff'
                                                    },
                                                    children: "Company Matching Information"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    class: "fs0-75rem fsi fw400 c0",
                                                    style: {
                                                        background: '#000f66c7',
                                                        color: '#fff'
                                                    },
                                                    children: "Fit"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        class: "fs0-75rem c15 fsi",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Preferred Sectors:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['preferredSectors']?.['firmValue'] ? fitMetrics?.['preferredSectors']?.['firmValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['preferredSectors']?.['selectedValue'] ? fitMetrics?.['preferredSectors']?.['selectedValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: `fa fa-circle ${fitMetrics?.['preferredSectors']?.['percentage'] > 70 ? 'green' : fitMetrics?.['preferredSectors']?.['percentage'] > 30 ? 'orange' : 'red'}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Preferred Investment Stage:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        children: fitMetrics?.['stageFocus']?.['firmValue'] ? fitMetrics?.['stageFocus']?.['firmValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        children: fitMetrics?.['stageFocus']?.['selectedValue'] ? fitMetrics?.['stageFocus']?.['selectedValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: `fa fa-circle ${fitMetrics?.['stageFocus']?.['percentage'] > 70 ? 'green' : fitMetrics?.['stageFocus']?.['percentage'] > 30 ? 'orange' : 'red'}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        class: "fs0-75rem c15 fsi",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Investment Sweet Spot:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['sweetSpot']?.['firmValue'] ? fitMetrics?.['sweetSpot']?.['firmValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['sweetSpot']?.['selectedValue'] ? fitMetrics?.['sweetSpot']?.['selectedValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: `fa fa-circle ${fitMetrics?.['sweetSpot']?.['percentage'] > 70 ? 'green' : fitMetrics?.['sweetSpot']?.['percentage'] > 30 ? 'orange' : 'red'}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Minimum Annual Revenues:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        children: fitMetrics?.['annualRevenues']?.['firmValue'] ? fitMetrics?.['annualRevenues']?.['firmValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        children: fitMetrics?.['annualRevenues']?.['selectedValue'] ? fitMetrics?.['annualRevenues']?.['selectedValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi bg5",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: `fa fa-circle ${fitMetrics?.['annualRevenues']?.['percentage'] > 70 ? 'green' : fitMetrics?.['annualRevenues']?.['percentage'] > 30 ? 'orange' : 'red'}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        class: "fs0-75rem c15 fsi",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Minimum Annual Profits:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['annualProfits']?.['firmValue'] ? fitMetrics?.['annualProfits']?.['firmValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['annualProfits']?.['selectedValue'] ? fitMetrics?.['annualProfits']?.['selectedValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: `fa fa-circle ${fitMetrics?.['annualProfits']?.['percentage'] > 70 ? 'green' : fitMetrics?.['annualProfits']?.['percentage'] > 30 ? 'orange' : 'red'}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        class: "fs0-75rem c15 fsi",
                                                        scope: "row",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Preferred Regions:"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['regionFocus']?.['firmValue'] ? fitMetrics?.['regionFocus']?.['firmValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: fitMetrics?.['regionFocus']?.['selectedValue'] ? fitMetrics?.['regionFocus']?.['selectedValue'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        class: "fs0-75rem c15 fsi",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: `fa fa-circle ${fitMetrics?.['regionFocus']?.['percentage'] > 70 ? 'green' : fitMetrics?.['regionFocus']?.['percentage'] > 30 ? 'orange' : 'red'}`
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc w100 mt2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                id: "manage-file",
                                className: "w200px cp df jcc aic tac mxa br25px py0-5rem bg3 bg4-hover c1 fs0-75rem",
                                children: "View Pitch Deck"
                            })
                        })
                    ]
                })
            ]
        });
    };
    // Get About Investor Content
    const getAboutInvestorContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "section-break"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt1rem",
                    id: "About the Investor",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w100 fs1rem fw600 c15 mb0-5rem ml1rem",
                            children: "About the Investor"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc bo5 bw1px bss br10px p1rem",
                            id: "Fit Metrics",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w20 df jcc aic",
                                    children: [
                                        investorFirm?.['source']?.['isBVCA'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w50px ml0-5rem",
                                            src: (parcelRequire("aWpLg")),
                                            alt: "image"
                                        }),
                                        investorFirm?.['source']?.['isCrunchBase'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w50px ml0-5rem",
                                            src: (parcelRequire("3c5p9")),
                                            alt: "image"
                                        }),
                                        investorFirm?.['source']?.['isSeedLegals'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w50px ml0-5rem",
                                            src: (parcelRequire("kZBx4")),
                                            alt: "image"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "w60 df jcc fdc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "bo5 bw2 bss mb0-5rem w50px h50px br100",
                                            src: investorFirm?.['logo'] || (parcelRequire("cfmAr")),
                                            alt: "image"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: investorFirm['cWebsite'],
                                            target: "_blank",
                                            className: "cp c15 c3-hover fs1rem fw500",
                                            children: investorFirm?.['cName']
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w20 df jcc fdc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `progress-bar workflow-report-progress ${investorFirm?.['promptScore'] > 67 ? 'workflow-progress-green' : investorFirm?.['promptScore'] > 33 ? 'workflow-progress-yellow' : '  workflow-progress-grey'}`,
                                            style: {
                                                width: 50,
                                                height: 50,
                                                borderRadius: '50%',
                                                margin: 0,
                                                border: '2px solid #F1F1F1'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                text: (investorFirm?.['promptScore'] || 0) + "%",
                                                styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                    strokeWidth: '0',
                                                    textSize: '20px',
                                                    trailColor: '#FBFBFB',
                                                    stroke: 'transparent',
                                                    strokeLinecap: 'butt',
                                                    backgroundColor: '#FBFBFB',
                                                    pathTransitionDuration: 0.5,
                                                    dominantBaseline: 'ideographic'
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                marginBottom: '0',
                                                fontSize: '14px'
                                            },
                                            className: "c12",
                                            children: "Prompt Score"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb mt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "Full Company Name: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: investorFirm['cName'] ? investorFirm['cName'] : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "Website: ",
                                        investorFirm['cWebsite'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "tdu wordbreak",
                                            href: investorFirm['cWebsite'],
                                            target: "_blank",
                                            children: investorFirm['cWebsite']
                                        }) : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "Business Location: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: investorFirm?.['cCountry'] ? investorFirm?.['cCountry'] : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "No. of Investments made: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: fitMetrics?.['noOfInvestments']?.['firmValue'] ? fitMetrics?.['noOfInvestments']?.['firmValue'] : '-'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "Address: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: investorFirm['cAddress'] ? investorFirm['cAddress'] : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "Tel: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: investorFirm['cPhone'] ? investorFirm['cPhone'] : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "Funds for Investment: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: fitMetrics?.['fundsAvailable']?.['firmValue'] ? fitMetrics?.['fundsAvailable']?.['firmValue'] : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 tal mb0-5rem c15 fs0-75rem",
                                    children: [
                                        "Date of last Investment: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: fitMetrics?.['lastInvestmentDate']?.['firmValue'] ? fitMetrics?.['lastInvestmentDate']?.['firmValue'] : '-'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    class: "fs0-75rem c15 mt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        investorFirm?.['companyDescription'] && investorFirm['companyDescription'].length > 600 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                investorFirm['companyDescription'].substring(0, 1000),
                                "... ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    id: "readmore-investor-description",
                                    className: "cp tdu fs0-75rem fw600 bg1",
                                    children: "read more"
                                })
                            ]
                        }) : investorFirm['companyDescription']
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    class: "fs0-75rem c15 my1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "Investment Criteria"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        investorFirm?.['investmentCriteria'] && investorFirm['investmentCriteria'].length > 600 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                investorFirm['investmentCriteria'].substring(0, 1000),
                                "... ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    id: "readmore-criteria",
                                    className: "cp tdu fs0-75rem fw600 bg1",
                                    children: "read more"
                                })
                            ]
                        }) : investorFirm['investmentCriteria']
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df my1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `w50 bg5 p0-5rem bo5 bw1px bss df fww aic br8px`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `user-area w20`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "user-img",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: " h4rem w4rem br100",
                                        src: investorFirm?.['contact']?.['profile'] || investorFirm?.['contact']?.['profilePicture'] || (parcelRequire("cfmAr")),
                                        alt: "image"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `progress-box w50`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box tal",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                            className: "fs0-75rem df",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: investorFirm?.['contact']?.['name'] ? investorFirm?.['contact']?.['name'] : investorFirm?.['contact']?.['firstName'] + ' ' + investorFirm?.['contact']?.['lastName'] || 'Name: -'
                                                }),
                                                investorFirm?.['contact']?.['linkedIn'] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: investorFirm?.['contact']?.['linkedIn'],
                                                    target: "_blank",
                                                    className: "icon w10px ml0-5rem bg5 cp",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            version: "1.1",
                                                            className: "f3",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 310 310",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73              C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4              c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599              c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319              c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995              C310,145.43,300.549,94.761,230.454,94.761z"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem c6",
                                            children: investorFirm?.['contact']?.['designation'] || 'Designation'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs0-75rem c6",
                                            children: [
                                                "Phone: ",
                                                investorFirm?.['contact']?.['phone'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        investorFirm?.['contact']?.['phone'],
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "cp bg5",
                                                            id: "copy",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                id: investorFirm?.['contact']?.['phone'],
                                                                className: "fa fa-clipboard c4",
                                                                style: {
                                                                    fontSize: '12px'
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }) : '-'
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc button-list w30",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    id: "bio",
                                    className: "bg3 bg4-hover c1 br20px py0-5rem px2rem cp df jcc aic fw500 fs0-75rem",
                                    children: "Bio"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    // Get About Company Content
    const getAboutCompanyContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "section-break"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt1rem",
                    id: "About the Company",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "w100 fs1rem fw600 c15 mb0-5rem ml1rem",
                        children: "About the Company"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "w100 df jcc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w20 df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "bo5 bw1px bss br10px p0-5rem w60px h60px mb1rem",
                                src: company?.['logo'] || (parcelRequire("cfmAr")),
                                alt: "image"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w80 df jcsb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "w40 df fdc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "fs0-75rem w100 c15",
                                            children: [
                                                "Company Name: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['cName'] ? company['cName'] : '-'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "fs0-75rem w100 c15",
                                            children: [
                                                "Website: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['cWebsite'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                        className: "tdu wordbreak",
                                                        href: company['cWebsite'],
                                                        target: "_blank",
                                                        children: company['cWebsite']
                                                    }) : '-'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "fs0-75rem w100 c15",
                                            children: [
                                                "Sectors: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: fitMetrics?.['preferredSectors']?.['selectedValue'] ? fitMetrics?.['preferredSectors']?.['selectedValue'] : '-'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "w40 df fdc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "fs0-75rem w100 c15",
                                            children: [
                                                "Address: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['cAddress'] ? company['cAddress'] : '-'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "fs0-75rem w100 c15",
                                            children: [
                                                "Tel: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['cPhone'] ? company['cPhone'] : '-'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "fs0-75rem w100 c15",
                                            children: [
                                                "Full Time Employees: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: fitMetrics?.['fullTimeEmployees'] ? fitMetrics?.['fullTimeEmployees'] : '-'
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    class: "fs0-75rem c15 mt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        company?.['companyDescription'] && company['companyDescription'].length > 600 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                company['companyDescription'].substring(0, 1000),
                                "... ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    id: "readmore-company-description",
                                    className: "cp tdu fs0-75rem fw600 bg1",
                                    children: "read more"
                                })
                            ]
                        }) : company['companyDescription']
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "report-start mt1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `dg gtcr-audit fs0-75rem c1 gtcr-audit-fit-report-about br10px`,
                            style: {
                                background: '#000f66c7'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs0-75rem fw400 tac",
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs0-75rem fw400 tac",
                                    children: "Actual Previous Year"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs0-75rem fw400 tac",
                                    children: "Expected Current Year"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs0-75rem fw400 tac",
                                    children: "Forcast Next Year"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `dg tableRow fs0-75rem gtcr-audit-fit-report-about`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi fw600 pt0-25rem`,
                                    children: "Revenues"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi pt0-25rem`,
                                    children: fitMetrics?.['previousRevenues'] ? fitMetrics?.['previousRevenues'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi pt0-25rem`,
                                    children: fitMetrics?.['annualRevenues']?.['selectedValue'] ? fitMetrics?.['annualRevenues']?.['selectedValue'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi pt0-25rem`,
                                    children: fitMetrics?.['nextRevenues'] ? fitMetrics?.['nextRevenues'] : '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `dg tableRow fs0-75rem gtcr-audit-fit-report-about`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi fw600 pt0-25rem`,
                                    children: "Profits/(Loss)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi pt0-25rem`,
                                    children: fitMetrics?.['previousProfits'] ? fitMetrics?.['previousProfits'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi pt0-25rem`,
                                    children: fitMetrics?.['annualProfits']?.['selectedValue'] ? fitMetrics?.['annualProfits']?.['selectedValue'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df jcc c15 fsi pt0-25rem`,
                                    children: fitMetrics?.['nextProfits'] ? fitMetrics?.['nextProfits'] : '-'
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w50 bg1 p1rem bo5 bw1px bss df fww aic mt1rem br8px",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `user-area tac w100`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "user-img",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h4rem w4rem br100",
                                    src: company?.['creatorId']?.['profile'] || (parcelRequire("cfmAr")),
                                    alt: "image"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                        className: "fs0-75rem df jcc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    company?.['creatorId']?.['firstName'],
                                                    " ",
                                                    company?.['creatorId']?.['lastName']
                                                ]
                                            }),
                                            company?.['creatorId']?.['linkedIn'] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: company?.['creatorId']?.['linkedIn'],
                                                target: "_blank",
                                                className: "icon w10px ml0-5rem bg5 cp",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        version: "1.1",
                                                        className: "f3",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 310 310",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73              C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4              c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599              c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319              c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995              C310,145.43,300.549,94.761,230.454,94.761z"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        id: "contact-details",
                                        className: "df jcc bg3 bg4-hover c1 br20px fw600 w70 py0-5rem fs0-75rem",
                                        children: "Contact Details"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    // Get Foundational Diligence Reports
    const getFoundationalDiligenceReports = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "section-break"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt2rem",
                    id: "Foundational Diligence Reports",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w100 fs1rem fw600 c15 mb0-5rem ml1rem",
                            children: "Foundational Diligence Reports"
                        }),
                        foundationalDiligenceCard({
                            title: 'Data Repository',
                            completionPercent: company?.['modules']?.['repository']?.['stats']?.['completionPercent'] || 0,
                            valueReportId: 'repository-report'
                        }),
                        foundationalDiligenceCard({
                            title: 'Business Audit',
                            completionPercent: company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] || 0,
                            riskPercent: company?.['modules']?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent'] || 0,
                            valueReportId: `business-audit-${company['testType']}-report`
                        }),
                        foundationalDiligenceCard({
                            title: 'Directors Questionnaire',
                            completionPercent: company?.['directorsStats']?.['completionPercent'] || 0,
                            riskPercent: company?.['directorsStats']?.['riskPercent'] || 0
                        }),
                        foundationalDiligenceCard({
                            title: 'Warranty Disclosure Schedule',
                            completionPercent: company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['completionPercent'] || 0,
                            riskPercent: company?.['modules']?.[`warranty-disclosure`]?.['stats']?.['riskPercent'] || 0,
                            valueReportId: `warranty-disclosure-report`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df bo5 bw1px br10px bss px1rem py2rem my0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "w30 df jcc tac fs1rem fw600 c15",
                                    children: "Unaudited Certification"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w70 df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "bottom-certification w100 my0-5rem df jcfs fww",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w90",
                                                    src: (parcelRequire("7BAlA")),
                                                    alt: ""
                                                }),
                                                linearProgress && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "progress-dashboard-horizantal w90",
                                                    role: "progressbar",
                                                    id: "progressBar",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "progress-bar progress-bar-striped progress-bar-animated",
                                                        id: "innerBar",
                                                        style: {
                                                            width: `${linearProgress}%`
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const foundationalDiligenceCard = ({ title: title, completionPercent: completionPercent, riskPercent: riskPercent, valueReportId: valueReportId })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                class: "w100 df bo5 bw1px br10px bss px1rem py2rem my0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        class: "w30 df jcc tac fs1rem fw600 c15",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        class: "w40 df jcc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df fdc aic mr1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        class: `fs1rem fw600 ${completionPercent > 67 ? 'green' : completionPercent > 33 ? 'orange' : completionPercent > 0 ? 'red' : 'c12'}`,
                                        children: [
                                            completionPercent,
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "fs0-75rem c12",
                                        children: "Completeness"
                                    })
                                ]
                            }),
                            title !== 'Data Repository' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df fdc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        class: `fs1rem fw600 ${riskPercent > 67 ? 'red' : riskPercent > 33 ? 'orange' : riskPercent > 0 ? 'red' : 'c12'}`,
                                        children: [
                                            riskPercent,
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "fs0-75rem c12",
                                        children: "Risk"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        class: "w30 df jcc",
                        children: completionPercent > 0 ? title == 'Directors Questionnaire' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            id: "director-foundational-report",
                            class: "cp w70 fs0-75rem fw500 c1 bg3 br20px py0-5rem tac",
                            style: {
                                maxHeight: '35px'
                            },
                            children: "View Report"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            id: "foundational-report",
                            class: "cp w70 fs0-75rem fw500 c1 bg3 br20px py0-5rem tac",
                            style: {
                                maxHeight: '35px'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/company/${company['_id']}#${valueReportId}`,
                                id: valueReportId,
                                children: "View Report"
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-tooltip": "Insufficient information provided to run report",
                            class: "cna w70 fs0-75rem fw500 py0-5rem c1 bg12 br20px",
                            style: {
                                maxHeight: '35px'
                            },
                            children: "View Report"
                        })
                    })
                ]
            })
        });
    };
    // Get Value Diligence Reports
    const getValueDiligenceReports = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "section-break"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt2rem",
                    id: "Value Diligence Reports",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w100 fs1rem fw600 c15 mb0-5rem ml1rem",
                            children: "Value Diligence Reports"
                        }),
                        researchAidReports && researchAidReports.length > 0 ? researchAidReports.map((report)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: valueDiligenceCard(report)
                            });
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df fdc aic jcc bo5 bw1px br10px bss px1rem py3rem mt4rem my0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw600 c15 tac mb0-5rem",
                                    children: "No ResearchAid reports generated yet"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-875rem fw400 c12 tac",
                                    children: "Generate ResearchAid reports to view your Value Diligence Reports here."
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const valueDiligenceCard = (report)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                class: "w100 df bo5 bw1px br10px bss px1rem py2rem my0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        class: "w30 df jcc tac fs1rem fw600 c15",
                        children: report['name']
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        class: "w40 df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc aic mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    class: `fs1rem fw600 ${report['score'] >= 4 ? 'c34' : report['score'] >= 2 ? 'c39' : report['score'] > 0 ? 'c4' : 'c12'}`,
                                    children: [
                                        report?.['score'] ? Number.parseFloat(report['score']).toFixed(1) : '0.0',
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "fs0-75rem c12",
                                    children: "Report Score/5"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        class: "w30 df jcc",
                        children: report?.['htmlReport'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            id: "value-report",
                            class: "cp w70 fs0-75rem fw500 c1 bg3 br20px py0-5rem tac",
                            style: {
                                maxHeight: '35px'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/company/${company['_id']}#${report['_id']}?${report['reportType']}-researchaid`,
                                id: `${report['reportType']}-researchaid`,
                                children: "View Report"
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-tooltip": "Insufficient information provided to run report",
                            class: "cna w70 fs0-75rem fw500 c1 bg12 br20px",
                            style: {
                                maxHeight: '35px'
                            },
                            children: "View Report"
                        })
                    })
                ]
            })
        });
    };
    // Get Detailed Answers
    const getDetailedAnswers = ()=>{
        let sections = [];
        if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) sections = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        sections = sections.slice().sort(sortSections);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: sections.length > 0 && sections.map((section, sectionIdx)=>{
                let questions;
                questions = section?.questions || [];
                let completionPercent, riskPercent;
                if (section?.stats?.completionPercent) completionPercent = section.stats.completionPercent;
                if (section?.stats?.riskPercent) riskPercent = section.stats.riskPercent;
                questions = sortQuestionsByQNo(questions);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "section-break"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt2rem",
                            id: "Detailed Answers",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "w100 fs1rem fw600 c15 ml1rem",
                                    children: [
                                        "One",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: "c4",
                                            children: "Form"
                                        }),
                                        " Detailed Answer"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mt1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: `w100 df p1rem fs0-75rem c1 br10px`,
                                            style: {
                                                background: '#000f66c7'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "w50 fs0-75rem fw600 tal ml2rem",
                                                    children: "Question"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "w50 fs0-75rem fw600 tal ml2rem",
                                                    children: "Answer"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    class: "fs1rem fw600 c15 my1rem ml1rem",
                                                    children: [
                                                        "Section-",
                                                        sectionIdx + 1,
                                                        ": ",
                                                        section['name'],
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "mx1rem",
                                                            children: "|"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: `fw400 ${completionPercent < 34 ? "c9" : completionPercent < 67 ? 'c8' : 'c7'}`,
                                                            children: [
                                                                completionPercent,
                                                                "% Completed"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                questions && questions.length > 0 && questions.map((ques, quesIdx)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: `w100 df p0-5rem br10px ${quesIdx % 2 == 0 ? 'bg5' : 'bg1'}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "w50 c14 fs0-75rem fw600 tal ml2rem",
                                                                children: ques['qDescription']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "w50 c14 fs0-75rem fw600 tal ml2rem",
                                                                children: [
                                                                    ques?.['answer']?.['dropdown'] || ques?.['answer']?.['comment'] || ques?.['answer']?.['radioOption'],
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    ques?.['answer']?.['files'] && ques['answer']['files'].length > 0 && ques['answer']['files'].map((file)=>{
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                            target: "_blank",
                                                                            href: file['location'],
                                                                            className: "fs0-75rem c15 tdu cp mr0-5rem",
                                                                            children: file['originalname']
                                                                        });
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    });
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            })
        });
    };
    const sortQuestionsByQNo = (questions)=>{
        if (questions && questions.length > 0) return questions.slice().sort((a, b)=>{
            const aParts = a['qNo'].match(/\d+/g).map(Number);
            const bParts = b['qNo'].match(/\d+/g).map(Number);
            for(let i = 0; i < Math.max(aParts.length, bParts.length); i++)if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
            return 0;
        });
        return questions || [];
    };
    const showPopupPercent = (value, type)=>{
        let color;
        if (type == 'Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
        else if (type == 'Completeness') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: `${color}`,
            children: [
                value || 0,
                "% ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c6",
                    children: type
                })
            ]
        });
    };
    const handleClosePopup = async ()=>{
        await window.scrollTo(0, 0);
        setTimeout(()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            })), 200);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "td250 container bg1 py2rem bo5 bw2 bss w100 df",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 mr1rem dg bg5 py2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcc w100 mb2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>downloadPDF(),
                                    className: "cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen fds h1rem f1 mr0-5rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 640 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                })
                                            ]
                                        }),
                                        "Download PDF"
                                    ]
                                }),
                                user['role'] == 'User' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>{
                                        setIsShowFitReport(false);
                                        handleInvestorLeads();
                                    },
                                    className: "cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600",
                                    children: "Back to Investor Leads"
                                }),
                                localStorage.getItem('isQualifiedLeads') && user['role'] == 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/investor-dashboard#index?QualifiedLeads",
                                    onClick: ()=>localStorage.removeItem("isQualifiedLeads"),
                                    className: "cp tac ml1rem bg4 bg3-hover fs0-75rem c1 br20px px2rem py0-5rem fw600",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 21 21",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z",
                                                    fill: "white",
                                                    stroke: "white",
                                                    "stroke-width": "0.5"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z",
                                                    fill: "white",
                                                    stroke: "white",
                                                    "stroke-width": "0.5"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ml0-5rem",
                                            children: "Back to Investor Match"
                                        })
                                    ]
                                }),
                                localStorage.getItem('isDiligencePack') && user['role'] == 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "#diligence-pack",
                                    onClick: ()=>setTab('diligence-pack'),
                                    className: "cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600",
                                    children: "Back to Diligence Pack"
                                })
                            ]
                        }),
                        company && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                                    id: "pdf",
                                    className: "op0 pen ma td250 dg gg2rem"
                                }),
                                user['role'] == 'User' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>{
                                            setIsShowFitReport(false);
                                            handleInvestorLeads();
                                        },
                                        className: "cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600",
                                        children: "Back to Investor Leads"
                                    })
                                }),
                                localStorage.getItem('isDiligencePack') && user['role'] == 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "#diligence-pack",
                                        onClick: ()=>setTab('diligence-pack'),
                                        className: "cp tac ml1rem bg3 bg4-hover fs0-75rem c1 br20px px2rem py0-5rem fw600",
                                        children: "Back to Diligence Pack"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    id: "pdfContent",
                                    className: "bsbb w0 h0 oh op0 pen db",
                                    children: [
                                        getOverviewContent(),
                                        getFitMetricsContent(),
                                        getAboutInvestorContent(),
                                        getAboutCompanyContent(),
                                        getFoundationalDiligenceReports(),
                                        getValueDiligenceReports(),
                                        getDetailedAnswers()
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'investorBio',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah100 oya bg1 bo5 bw2 bss w100 px3rem py1rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "About the Investor",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr modal-bio investor-leads-tooltip",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac c15 lh2 fs1-75rem fw600 mb2rem",
                                    children: "Investor Bio"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "user-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area cp",
                                            style: {
                                                top: '35px',
                                                right: '20px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                className: "icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "h2rem",
                                                        src: (parcelRequire("24u8s")),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        style: {
                                                            left: '-400px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Please note that if you wish to contact the investor directly, then they will not received the additional validation of the Diligentsia Diligence Report nor the fit report, and it will be treated by the investor as an unsolicited approach, which historically result in less attention/success."
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "user-img",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h4rem w4rem br100",
                                                src: investorFirm?.['contact']?.['profile'] || investorFirm?.['contact']?.['profilePicture'] || (parcelRequire("cfmAr")),
                                                alt: "image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "fs0-75rem df",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: investorFirm?.['contact']?.['name'] ? investorFirm?.['contact']?.['name'] : investorFirm?.['contact']?.['firstName'] + ' ' + investorFirm?.['contact']?.['lastName'] || 'Name: -'
                                                        }),
                                                        investorFirm?.['contact']?.['linkedIn'] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: investorFirm?.['contact']?.['linkedIn'],
                                                            target: "_blank",
                                                            className: "icon w10px ml0-5rem bg1 cp",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                version: "1.1",
                                                                className: "f3",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 310 310",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73              C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4              c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599              c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319              c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995              C310,145.43,300.549,94.761,230.454,94.761z"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: `fs0-75rem df`,
                                                    children: [
                                                        "Email: ",
                                                        investorFirm?.['contact']?.['email'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                investorFirm?.['contact']?.['email'],
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    className: "cp bg1",
                                                                    onClick: ()=>handleCopyClipboard(investorFirm?.['contact']?.['email']),
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "fa fa-clipboard c4",
                                                                        style: {
                                                                            fontSize: '12px'
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }) : '-'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: `fs0-75rem df`,
                                                    children: [
                                                        "Phone:",
                                                        investorFirm?.['contact']?.['phone'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                investorFirm?.['contact']?.['phone'],
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    className: "cp bg1",
                                                                    onClick: ()=>handleCopyClipboard(investorFirm?.['contact']?.['phone']),
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "fa fa-clipboard c4",
                                                                        style: {
                                                                            fontSize: '12px'
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }) : '-'
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "description-box my1rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "fs1rem mb0-5rem",
                                                    children: "Bio:"
                                                }),
                                                user['role'] == "Investor" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>{
                                                        setIsEditDeatils(true), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            open: 'editDetails'
                                                        }));
                                                    },
                                                    className: "bo5 bw2 bss bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu bsbb tac fs0-75rem mb1rem",
                                                    children: "Edit Details?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem",
                                            children: investorFirm?.['contact']?.['bio'] && investorFirm?.['contact']?.['bio'] !== 'n/a' ? investorFirm?.['contact']?.['bio'] : 'No information available from our search'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'readMoreInvestorDescription',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah100 oya bg1 bo5 bw2 bss w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "About the Investor",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr modal-bio",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac c15 lh2 fs1-5rem fw600 mb2rem",
                                    children: "Investor Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "description-box mt1rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "fs1rem c15 mb1rem",
                                            children: "Description:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem c14",
                                            children: investorFirm['companyDescription']
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'readMoreCriteria',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah100 oya bg1 bo5 bw2 bss w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "About the Investor",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr modal-bio",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac c15 lh2 fs1-5rem fw600 mb2rem",
                                    children: "Investment Criteria"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "description-box mt1rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "fs1rem c15 mb1rem",
                                            children: "Criteria:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem c14",
                                            children: investorFirm['investmentCriteria']
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'readMoreCompanyDescription',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah100 oya bg1 bo5 bw2 bss w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "About the Company",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr modal-bio",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac c15 lh2 fs1-5rem fw600 mb2rem",
                                    children: "Company Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "description-box mt1rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "fs1rem c15 mb1rem",
                                            children: "Description:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem c14",
                                            children: company['companyDescription']
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'editDetails',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 bo5 bw2 bss w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "image",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "About the Investor",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac pt2rem pb1rem",
                            children: "Edit Details"
                        }),
                        isEditDeatils && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac fs1rem my1rem",
                            children: "We recognise that you may not be the contact person within your firm who should deal with these initial approaches, and you can nominate a colleague to be the point person in your place.  However, we wish to offer quality, not quantity of diligenced leads in both directions, and for this reason ask that you nominate a specific individual rather than a generic \u201Cenquiries @\u201D email address."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac fs1rem my1rem",
                            children: "You can edit your firm\u2019s details or your own bio in your Investor Settings accessed via your Portfolio Pro dashboard  or booking a call with Mark Bernstein, the Diligentsia CEO "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "https://koalendar.com/e/meet-with-mark-bernstein",
                            target: "_blank",
                            className: "fs1rem c3 tdu mb1rem",
                            children: "https://koalendar.com/e/meet-with-mark-bernstein"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'companyContactDetails',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 bo5 bw2 bss w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "About the Company",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr modal-bio",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-5rem fw600 mb2rem",
                                    children: "Company Contact Details"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "user-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "user-img",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h4rem w4rem br100",
                                                src: company?.['creatorId']?.['profile'] || (parcelRequire("cfmAr")),
                                                alt: "image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "fs0-75rem df",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: company?.['creatorId']?.['firstName'] ? company?.['creatorId']?.['firstName'] + ' ' + company?.['creatorId']?.['lastName'] : 'Name: -'
                                                        }),
                                                        company?.['creatorId']?.['linkedIn'] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: company['creatorId']['linkedIn'],
                                                            target: "_blank",
                                                            className: "icon w10px ml0-5rem bg1 cp",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                version: "1.1",
                                                                className: "f3",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 310 310",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73              C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4              c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599              c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319              c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995              C310,145.43,300.549,94.761,230.454,94.761z"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw500 mr0-5rem",
                                                            children: "Email: "
                                                        }),
                                                        company?.['creatorId']?.['email'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                company?.['creatorId']?.['email'],
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    className: "cp bg1",
                                                                    onClick: ()=>handleCopyClipboard(company?.['creatorId']?.['email']),
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "fa fa-clipboard c4",
                                                                        style: {
                                                                            fontSize: '12px'
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }) : '-'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw500 mr0-5rem",
                                                            children: "Phone: "
                                                        }),
                                                        company?.['creatorId']?.['phone'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                company['creatorId']['phone'],
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    className: "cp bg1",
                                                                    onClick: ()=>handleCopyClipboard(company['creatorId']['phone']),
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "fa fa-clipboard c4",
                                                                        style: {
                                                                            fontSize: '12px'
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }) : '-'
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'manageFiles',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 pr oya bg1 bo5 bw2 bss w100 p3rem pt5rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "image",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "Fit Metrics",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fw600 tac fs1-25rem",
                            children: company.cName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c4 fw400 tac mb1rem fs1rem",
                            children: "Pitch Deck"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc"
                        }),
                        fitMetrics['deckFiles'] && fitMetrics['deckFiles'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: fitMetrics['deckFiles'].map((file)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb my1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            target: "_blank",
                                            href: file['location'],
                                            className: "fs1rem c15 tdu cp",
                                            children: file['originalname']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: file['location'],
                                            download: true,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                "data-tooltip": "Download",
                                                className: `f3 h1rem cp mr1rem ${tab == 'repository' ? '' : 'mla'}`,
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg gg1rem my2rem fs1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs1rem fw400 gcs1 gce5-md tac",
                                children: "Pitch Deck haven't been added yet!"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'showDirectors',
                className: "backdrop showDirectors td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr maw800px inner-showDirectors pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "Diligence Reports",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-header",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem",
                                children: "LIST OF QUESTIONNAIRES"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "table-area-showDirectors",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    id: "table",
                                    className: "table-showDirectors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "ps t0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: "Designation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: "Progress"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: directors && directors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: directors.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: `${item['headShot'] && 'df aic '} c6 fw500 ttc`,
                                                                children: [
                                                                    item['headShot'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: item['headShot']['location'],
                                                                        className: "w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem"
                                                                    }),
                                                                    item['name']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c6 fw500 ttc",
                                                                children: item['designation']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "p1rem c6 fw500 ttc",
                                                                children: [
                                                                    "(",
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['completionPercent'] || 0, 'Completeness'),
                                                                    " / ",
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['riskPercent'] || 0, 'Risk'),
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        localStorage.setItem('isDiligenceReport', true);
                                                                        setTab(`directors-questionnaire_${item['_id']}-report`);
                                                                    },
                                                                    className: "cp bg4 bg3-hover c1 tac c1 bo5 bw2 bss px1rem py0-5rem br5px fw500",
                                                                    children: "Report"
                                                                })
                                                            })
                                                        ]
                                                    }, idx))
                                            })
                                        })
                                    ]
                                }),
                                directors && directors.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac py1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-gradient fw600",
                                        children: "No Directors by this Company"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "logo-modal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h2rem",
                                        src: (parcelRequire("aR1CT")),
                                        alt: "TODO"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'clientAcceptReject',
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 bo5 bw2 bss w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "actions",
                            className: "close-popup",
                            onClick: ()=>handleClosePopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                            children: "Access Request "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem",
                                    children: [
                                        "Are you sure you want to ",
                                        leadStatus.slice(0, -2).toLowerCase(),
                                        " this lead request of ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: company['cName']
                                        }),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    "data-scroll-to": "actions",
                                    onClick: ()=>updateLeadStatus(leadStatus),
                                    className: "bo5 bw2 bss bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic",
                                    children: leadStatus.slice(0, -2)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    "data-scroll-to": "actions",
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    className: "bg1 c3-hover td250 fs1-25rem cp",
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



















var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


const $307c020ccdad72e6$var$ListOfSectionMenu = ({ module: module, sections: sections = [], onNavigateSection: onNavigateSection })=>{
    const [showSub, setShowSub] = (0, $acw62.useState)(false);
    const titleRef = (0, $acw62.useRef)(null);
    const hideTimer = (0, $acw62.useRef)(null);
    const show = ()=>{
        clearTimeout(hideTimer.current);
        setShowSub(true);
    };
    const hide = ()=>{
        hideTimer.current = setTimeout(()=>setShowSub(false), 150);
    };
    const navigateSection = (sectionNo)=>{
        if (typeof onNavigateSection === 'function') onNavigateSection(sectionNo);
    };
    // sections with subFolders then use subFolders as sections
    if (sections.length === 1 && sections[0]?.subFolders) {
        const subFoldersArray = Array.isArray(sections[0].subFolders) ? sections[0].subFolders : Object.values(sections[0].subFolders);
        if (subFoldersArray.length > 0) {
            const parentStats = sections[0]?.stats || {
                completionPercent: 0,
                riskPercent: 0
            };
            sections = subFoldersArray.map((sub)=>({
                    sectionName: sub.name,
                    sectionNo: sub.no,
                    stats: parentStats,
                    questions: sub.questions || []
                }));
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: titleRef,
                className: "ds-module-menu__title cp",
                onMouseEnter: show,
                onMouseLeave: hide,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                style: {
                                    width: '16px',
                                    height: '16px',
                                    marginRight: '8px'
                                },
                                src: (parcelRequire("jowwK")),
                                alt: "list-of-sections"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "List of Sections"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        style: {
                            height: '10px',
                            marginRight: '8px'
                        },
                        src: (parcelRequire("d729Q")),
                        alt: "arrow-right"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ds-module-menu__divider"
            }),
            showSub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ds-module-menu__sub",
                style: {
                    position: 'fixed',
                    top: titleRef.current?.getBoundingClientRect().top + 20,
                    left: titleRef.current?.getBoundingClientRect().right - 70,
                    zIndex: 99999,
                    opacity: 1,
                    pointerEvents: 'auto'
                },
                onMouseEnter: show,
                onMouseLeave: hide,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "tooltip-area",
                    children: sections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `tooltip-area ${module?.heading === "Investor Match" || sections.length && sections.length < 8 ? 'tooltip-top-important' : ''}`,
                        children: sections.map((section, idx)=>{
                            if (!section.stats) section.stats = module?.['module']?.['sections']?.[0]?.['stats'] || module?.['sections']?.[0]?.['stats'] || {
                                completionPercent: 0,
                                riskPercent: 0
                            };
                            const completeness = section.stats.completionPercent || 0;
                            let riskColour;
                            if (module.type === "repository" || (section.stats.riskPercent || 0) < 38) riskColour = 7;
                            else if (section.stats.riskPercent > 62) riskColour = 9;
                            else riskColour = 8;
                            let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                            let colorChange = false;
                            if (module['type'] == "warranty-disclosure") {
                                if (section?.questions && section?.questions.length > 0) section?.questions.map((question)=>{
                                    if (question?.['answer']?.['radioOption'] == 'Disclosure' || question?.['answer']?.['radioOption'] == 'Not Sure') {
                                        colorChange = true;
                                        return;
                                    }
                                });
                            }
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>navigateSection(section['sectionNo']),
                                style: {
                                    background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                },
                                "data-scroll-to": section['sectionNo'],
                                className: "overlay-box tal w100 tac cp c3-hover",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: section['sectionName']
                                })
                            }, idx);
                        })
                    })
                })
            }), document.body)
        ]
    });
};
var $307c020ccdad72e6$export$2e2bcd8739ae039 = $307c020ccdad72e6$var$ListOfSectionMenu;






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $4aa1eeaaa8768bb3$var$KeyFeatureSeeMoreModal = ({ selectedSeeMore: selectedSeeMore })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            id: "keyFeatureSeeMore",
            modalType: 'seeMorePopupNew',
            modalCardClasses: "maw1300px",
            children: selectedSeeMore && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df w100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            width: "55%",
                            height: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df w100 mb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w10 df aic",
                                        children: selectedSeeMore?.icon
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w90 fw500 c15 pl1rem df aic",
                                        style: {
                                            fontSize: '26px',
                                            lineHeight: '37.32px'
                                        },
                                        children: selectedSeeMore?.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                className: " mt0-5rem",
                                style: {
                                    paddingLeft: '22px'
                                },
                                children: selectedSeeMore?.points?.map((objpoints, index)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        style: {
                                            lineHeight: '25px',
                                            paddingBottom: "3px",
                                            paddingTop: "3px",
                                            paddingLeft: "20px",
                                            borderLeft: '2px solid #D3D9FC'
                                        },
                                        className: "df fdc fs1rem c14 fs1rem fw400",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "circle"
                                                    }),
                                                    objpoints
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: selectedSeeMore?.subMenu && selectedSeeMore?.subMenu?.index == index && selectedSeeMore?.subMenu?.points?.map((str, i, arr)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                        style: {
                                                            lineHeight: '30px'
                                                        },
                                                        children: str
                                                    });
                                                })
                                            })
                                        ]
                                    }, `${objpoints}-${index}`);
                                })
                            }),
                            selectedSeeMore?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt1rem",
                                style: {
                                    border: '1px solid gray',
                                    padding: "10px",
                                    borderRadius: '10px'
                                },
                                children: selectedSeeMore?.notePoint
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jce",
                        style: {
                            width: '45%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: selectedSeeMore?.image,
                                className: "w70",
                                style: {
                                    objectFit: 'fill'
                                }
                            }),
                            selectedSeeMore?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("fOQ2M")),
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: "videoCompanies"
                                    })),
                                className: "pa cp zi1",
                                style: {
                                    right: '10%',
                                    bottom: '10px'
                                }
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $4aa1eeaaa8768bb3$export$2e2bcd8739ae039 = $4aa1eeaaa8768bb3$var$KeyFeatureSeeMoreModal;







const $151351a1dd6ada95$var$ModuleCardMenus = ({ module: module, onNavigateSection: onNavigateSection, setReportTab: setReportTab, type: type, seeMore: seeMore, howItWorks: howItWorks, setIsWorkflowReport: setIsWorkflowReport, menus: menus, company: company })=>{
    const [selectedSeeMore, setSelectedSeeMore] = (0, $acw62.useState)({});
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let sections = module?.['sections'] || module?.['module']?.['sections'] || [];
    const handleSeeMore = ()=>{
        setSelectedSeeMore(seeMore);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'seeMorePopupNew'
        }));
    };
    const handleHowItWorks = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'howItWorksPopupNew',
            howItWorksData: howItWorks
        }));
    };
    const getHelpLink = (module)=>{
        const type = module?.['type'];
        if (!type || typeof type === 'object') return '';
        const helpLinks = {
            'kpi-report': 'https://intercom.help/diligentsia-limited/en/articles/8557593-key-performance-indicator-kpi-reporting',
            'repository': 'https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository',
            'unaudited-certification': 'https://intercom.help/diligentsia-limited/en/collections/6775868-your-certification',
            'warranty-disclosure': 'https://intercom.help/diligentsia-limited/en/articles/8557715-expansion-pack-warranty-disclosure-module',
            'directors-questionnaire': 'https://intercom.help/diligentsia-limited/en/articles/8557468-directors-questionnaire-module',
            'software-development': 'https://intercom.help/diligentsia-limited/en/articles/8557691-expansion-pack-software-development',
            'esg': 'https://intercom.help/diligentsia-limited/en/articles/8557477-expansion-pack-environmental-social-governmental-esg'
        };
        // handle prefix-based types
        if (type.includes('two-minute-test-')) return 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard';
        if (type.includes('business-audit-')) return 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit';
        return helpLinks[type] || '';
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "ds-module-menu",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "ds-module-card__menu",
                        children: "\u2022\u2022\u2022"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "ds-module-menu__dropdown",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ds-module-menu__section ds-submenu",
                                children: [
                                    sections.length > 0 && (menus?.includes('listOfSections') || module?.['menus']?.includes('listOfSections')) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $307c020ccdad72e6$export$2e2bcd8739ae039), {
                                        module: module,
                                        sections: sections,
                                        onNavigateSection: onNavigateSection
                                    }),
                                    seeMore && (menus?.includes('seeMore') || module?.['menus']?.includes('seeMore')) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: handleSeeMore,
                                        className: "ds-module-menu__item df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                style: {
                                                    width: '16px',
                                                    height: '16px',
                                                    marginRight: '8px'
                                                },
                                                src: (parcelRequire("ktVzj")),
                                                alt: "what-is-it"
                                            }),
                                            "What is it"
                                        ]
                                    }) : null,
                                    howItWorks && (menus?.includes('howItWorks') || module?.['menus']?.includes('howItWorks')) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: handleHowItWorks,
                                        className: "ds-module-menu__item df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                style: {
                                                    width: '16px',
                                                    height: '16px',
                                                    marginRight: '8px'
                                                },
                                                src: (parcelRequire("d6YfF")),
                                                alt: "what-is-it"
                                            }),
                                            "How it works"
                                        ]
                                    }) : null,
                                    getHelpLink(module) !== '' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        type: "button",
                                        onClick: ()=>window.open(getHelpLink(module), '_blank', 'noopener,noreferrer'),
                                        className: "ds-module-menu__item df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                style: {
                                                    width: '16px',
                                                    height: '16px',
                                                    marginRight: '8px'
                                                },
                                                src: (parcelRequire("lzxyC")),
                                                alt: "what-is-it"
                                            }),
                                            "Help"
                                        ]
                                    }) : null
                                ]
                            }),
                            (seeMore || howItWorks || getHelpLink(module) !== '') && menus?.includes('report') ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ds-module-menu__divider"
                            }) : null,
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ds-module-menu__section",
                                children: [
                                    (menus?.includes('report') || module?.['menus']?.includes('report')) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        disabled: [
                                            'warranty-disclosure',
                                            'directors-questionnaire'
                                        ].includes(module['type']) && !company['expensions']?.[module['id']],
                                        to: module?.['stats']?.completionPercent > 0 && type != 'investor-lead' && `#${type}-report`,
                                        onClick: ()=>{
                                            if ([
                                                'warranty-disclosure',
                                                'directors-questionnaire'
                                            ].includes(module['type']) && !company['expensions']?.[module['id']]) return;
                                            module?.['stats']?.completionPercent > 0 && setReportTab(type);
                                        },
                                        className: `ds-module-menu__item df aic ${module?.['stats']?.completionPercent == 0 ? 'ds-is-disabled' : ''} ${[
                                            'warranty-disclosure',
                                            'directors-questionnaire'
                                        ].includes(module['type']) && !company['expensions']?.[module['id']] ? 'ds-is-disabled' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                style: {
                                                    width: '16px',
                                                    height: '16px',
                                                    marginRight: '8px'
                                                },
                                                src: (parcelRequire("cNord")),
                                                alt: "what-is-it"
                                            }),
                                            "Report"
                                        ]
                                    }),
                                    (menus?.includes('workflow') || module?.['menus']?.includes('workflow')) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: module?.['stats']?.completionPercent > 0 && `#${module['type']}`,
                                        onClick: (e)=>{
                                            module?.['stats']?.completionPercent > 0 && localStorage.setItem('isWorkflowOpen', true);
                                            setIsWorkflowReport(true);
                                            setTab(`${module['type']}-report`);
                                        },
                                        className: `ds-module-menu__item df aic ${module?.['stats']?.completionPercent == 0 ? 'ds-is-disabled' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                style: {
                                                    width: '16px',
                                                    height: '16px',
                                                    marginRight: '8px'
                                                },
                                                src: (parcelRequire("bLX5S")),
                                                alt: "what-is-it"
                                            }),
                                            "Workflow report"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            Object.keys(selectedSeeMore).length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4aa1eeaaa8768bb3$export$2e2bcd8739ae039), {
                selectedSeeMore: selectedSeeMore
            }) : null
        ]
    });
};
var $151351a1dd6ada95$export$2e2bcd8739ae039 = $151351a1dd6ada95$var$ModuleCardMenus;











function $2f9e7d74c90dd72e$export$2e2bcd8739ae039({ buttonClass: buttonClass, linearProgress: linearProgress, permissionLevel: permissionLevel, step: step, title: title, type: type, seeMore: seeMore, howItWorks: howItWorks, handleSeeMore: handleSeeMore, handleHowItWorks: handleHowItWorks, directors: directors, directorsStats: directorsStats, company: company, moduleCertification: moduleCertification, module: module, setTab: setTab, getFitInvestorFirms: getFitInvestorFirms, scrollId: scrollId, setModuleTab: setModuleTab, setIsViewTwoMinuteReport: setIsViewTwoMinuteReport, isReady: isReady = false, fitInvestorFirms: fitInvestorFirms, subscription: subscription, time: time, isBuy: isBuy, price: price, information: information }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const { strongCount: strongCount, mediumCount: mediumCount, lowCount: lowCount } = (0, $acw62.useMemo)(()=>{
        if (!fitInvestorFirms?.length) return {
            strongCount: 0,
            mediumCount: 0,
            lowCount: 0
        };
        return fitInvestorFirms.reduce((acc, investor)=>{
            const score = investor.fitScorePercentage;
            if (score >= 83) acc.strongCount++;
            else if (score >= 66.6 && score < 83) acc.mediumCount++;
            else if (score < 66.6) acc.lowCount++;
            return acc;
        }, {
            strongCount: 0,
            mediumCount: 0,
            lowCount: 0
        });
    }, [
        fitInvestorFirms
    ]);
    const handleLinkModuleTab = (type, module)=>{
        if (type.startsWith('two-minute-') && !company['freeModules'] || company['freeModules'] && !company['freeModules'][type]) return `#`;
        if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
            if ([
                'software-development',
                'esg',
                'warranty-disclosure',
                'directors-questionnaire',
                'investor-lead'
            ].includes(type) && !company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) return '#';
        }
        if (permissionLevel == 'ALL') {
            if (user?.['role'] == 'Guest' && (type == `two-minute-test-${company?.['testType']}` || type == "kpi-report")) return '#';
            if (type == 'directors-questionnaire') return '#';
            return `#${type}`;
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (type === "kpi-report") setIsViewTwoMinuteReport(false);
    }, [
        type
    ]);
    const setReportTab = async (type)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You have Dashboard access only!');
            return;
        }
        if (type == 'investor-lead') {
            if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
                if (!company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`;
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
            getFitInvestorFirms();
            return;
        }
        setTab(type + '-report');
    };
    const showPercent = (value, type, title)=>{
        let color;
        if (value > 0) {
            if (type == 'Module Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
            else if (type == 'Module Complete') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
        } else color = 'c28';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
            className: `${color} fs2rem lh1 ${title === "InvestorMatch" ? 'mr0rem' : 'mr2rem'}`,
            children: [
                value || 0,
                "%",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `${value > 0 ? 'c15 ' : 'c28 '} fs0-75rem w4rem db fw300`,
                    children: type
                })
            ]
        });
    };
    const navigateSection = async (type, sectionNo)=>{
        if (user?.['role'] == 'Guest') {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'noRegistrationReport'
            }));
            return;
        }
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if ([
            'software-development',
            'esg',
            'warranty-disclosure',
            'directors-questionnaire',
            'investor-lead'
        ].includes(type)) {
            // CHECK EXPANSION PACK PERMISSIONS FOR MEMBERS
            const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`;
            if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
                if (!company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
            // CHECK EXPANSION PACK PERMISSIONS FOR ADVISORS/INVESTORS
            if ((user['role'] == "Advisor" || user['role'] == 'Investor') && company['creatorId']['_id'] != user['_id']) {
                if (!company?.[user['role'] == "Investor" ? 'investors' : 'advisors']?.[user['_id']]?.['modules']?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
        }
        await setTab(type);
        setTimeout(()=>{
            let element = document.getElementById(sectionNo);
            if (element) element.scrollIntoView({
                behavior: 'instant'
            }, true);
        }, 1000);
    };
    const moduleTooltip = (sections, module)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "cp module-tooltip-box",
            children: sections?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: `tooltip-area ${module?.heading === "Investor Match" || sections?.length && sections?.length < 8 ? 'tooltip-top-important' : ''}`,
                children: sections.map((section, idx)=>{
                    if (!section.stats) section.stats = module['sections'][0]['stats'];
                    const completeness = section.stats.completionPercent;
                    let riskColour;
                    if (module.type === "repository" || section.stats.riskPercent < 38) riskColour = 7;
                    else if (section.stats.riskPercent > 62) riskColour = 9;
                    else riskColour = 8;
                    let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                    let colorChange = false;
                    if (module['type'] == "warranty-disclosure") {
                        if (section?.questions && section?.questions.length > 0) section?.questions.map((question)=>{
                            if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
                                colorChange = true;
                                return;
                            }
                        });
                    }
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>navigateSection(type, section['sectionNo']),
                        style: {
                            background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                        },
                        "data-scroll-to": section['sectionNo'],
                        className: "overlay-box tal w100 tac cp c3-hover",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: section['sectionName']
                        })
                    }, idx);
                })
            })
        });
    };
    const directorModuleTooltip = (items)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "module-tooltip-box",
            children: items.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "tooltip-area",
                children: items.map((item, idx)=>{
                    let completeness = company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['completionPercent'] ? company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['completionPercent'] : 0;
                    let riskColour;
                    if (company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['riskPercent'] && company['moduleStats']?.[`directors-questionnaire_${item?._id}`]?.['stats']?.['riskPercent'] < 38) riskColour = 7;
                    else if (company['moduleStats']?.[`directors-questionnaire_${item?._id}`]['stats']?.['riskPercent'] && company['moduleStats']?.[`directors-questionnaire_${item?._id}`]['stats']?.['riskPercent'] > 62) riskColour = 9;
                    else riskColour = 8;
                    let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                        },
                        className: "overlay-box tal",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: item['name']
                        })
                    }, idx);
                })
            })
        });
    };
    function transformSubFoldersToSections(subFolders) {
        return Object.values(subFolders).map((item, index)=>{
            return {
                _id: item.sectionId || `${item.sectionNo}-${index}`,
                // fallback id
                sectionNo: item.sectionNo,
                sectionName: item.sectionName,
                type: "Workflow Sections",
                subFolders: {},
                // since these contain questions instead
                questions: item.questions || [],
                stats: item.stats || {},
                isDefault: false,
                isSection: true,
                isPrompt: false,
                updatedAt: new Date().toISOString()
            };
        });
    }
    const tranformedData = (module)=>{
        if (module['type'] && module['type'] === "investor-lead" && module['sections'] && module['sections'][0] && module['sections'][0]['subFolders']) return {
            ...module,
            sections: transformSubFoldersToSections(module['sections'][0]['subFolders'])
        };
        return module;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: scrollId,
                className: `${buttonClass} ${user?.['role'] == 'Guest' ? 'bo3' : 'bo7'}  w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151351a1dd6ada95$export$2e2bcd8739ae039), {
                        menus: module['menus'],
                        module: tranformedData(module),
                        onNavigateSection: navigateSection,
                        setReportTab: setReportTab,
                        type: module?.['title'] || module?.['heading'] || '',
                        company: company,
                        seeMore: seeMore,
                        howItWorks: howItWorks
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: handleLinkModuleTab(type, module),
                        onClick: ()=>setModuleTab(setTab, type, module),
                        className: "cp w100 h100",
                        style: {
                            minHeight: '133px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cp ttc pr fs1rem fw500 c15 lh2 df aic zi1 w100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fw500 fs1-25rem c15 aifs w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic cp w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon-diligenstia mr1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w40px h40px",
                                                    src: (parcelRequire("3N5Zr")),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs1rem fw500 c15 lh2 title-box-feature w100",
                                                children: [
                                                    company?.['subscription'] == 'Pro' && (type == 'repository' || type == `business-audit-${company?.['testType']}` || type == 'warranty-disclosure' || type.includes("directors-questionnaire")) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>document.getElementById('dashboard-required-star').scrollIntoView({
                                                                behavior: "smooth"
                                                            }),
                                                        type: "button",
                                                        className: "cp bg1 icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("dlp4j")),
                                                            alt: "star-img"
                                                        })
                                                    }),
                                                    title === "InvestorMatch" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "c15 fs11px fw400",
                                                                children: "OneForm"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "cp c4-hover",
                                                                children: [
                                                                    "Investor",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "c4",
                                                                        children: "Match"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df aic jcsb w100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "cp c4-hover",
                                                                children: title
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "c59 ttu",
                                                                children: subscription
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            company?.['subscription'] == 'Pro' && type == "unaudited-certification" && linearProgress && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bottom-certification w70 mt1rem df jcfs fww pr",
                                style: {
                                    top: '16px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w100",
                                        src: (parcelRequire("7BAlA")),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "progress-dashboard-horizantal",
                                        role: "progressbar",
                                        id: "progressBar",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "progress-bar progress-bar-striped progress-bar-animated",
                                            id: "innerBar",
                                            style: {
                                                width: `${linearProgress}%`
                                            }
                                        })
                                    })
                                ]
                            }),
                            type.includes("directors-questionnaire") && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "cp step-box text-gradient",
                                style: {
                                    fontSize: '12px',
                                    right: '50px'
                                },
                                children: [
                                    "(",
                                    directors.length,
                                    ") - Directors"
                                ]
                            }),
                            user['role'] == 'Guest' && step && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "step-box",
                                children: [
                                    "Step ",
                                    step
                                ]
                            }),
                            time && !module.stats.completionPercent ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc aife",
                                    style: {
                                        position: 'absolute',
                                        right: '10px',
                                        bottom: '10px'
                                    },
                                    children: time && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("jJgJl")),
                                                style: {
                                                    width: '14px',
                                                    height: '14px'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontSize: '14px'
                                                },
                                                children: time
                                            })
                                        ]
                                    })
                                })
                            }) : moduleCertification && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    title === "InvestorMatch" && !module.stats.completionPercent ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : moduleCertification == 'None' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "ribbon ribbon-bottom-right grey",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "mr0-5rem",
                                            style: {
                                                width: '70px'
                                            },
                                            src: (parcelRequire("h5UTs")),
                                            alt: ""
                                        })
                                    }),
                                    moduleCertification == 'Bronze' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "trophy-cup ribbon ribbon-bottom-right bronze",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "h4rem",
                                            src: (parcelRequire("cXyX2")),
                                            alt: ""
                                        })
                                    }),
                                    moduleCertification == 'Silver' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "trophy-cup ribbon ribbon-bottom-right silver",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "h4rem",
                                            src: (parcelRequire("7YoCF")),
                                            alt: ""
                                        })
                                    }),
                                    moduleCertification == 'Gold' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "trophy-cup ribbon ribbon-bottom-right gold",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "h4rem",
                                            src: (parcelRequire("gr5qi")),
                                            alt: ""
                                        })
                                    })
                                ]
                            }),
                            information && !module.stats.completionPercent ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "bottom-features df jcsb aife mt1rem tal pa c15 op50",
                                    style: {
                                        bottom: '15px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w70 tal c15 pr",
                                        style: {
                                            fontSize: '0.75rem'
                                        },
                                        children: information
                                    })
                                })
                            }) : type == "directors-questionnaire" && directorsStats ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tooltip-area style-two pa df aic jcsb w90",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "percentage-area df jcc aic mb1rem",
                                    children: [
                                        showPercent(directorsStats?.completionPercent || 0, 'Module Complete', title),
                                        showPercent(directorsStats?.riskPercent || 0, 'Module Risk', title)
                                    ]
                                })
                            }) : module?.stats && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: type !== "kpi-report" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: title === "InvestorMatch" && !module.stats.completionPercent ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "c70",
                                        children: [
                                            "One application from to match ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "against our investor database"
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "cp tooltip-area style-two pa df aic jcsb w90",
                                        style: type.includes("directors-questionnaire") ? {
                                            bottom: "30px"
                                        } : {},
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `percentage-area df jcc aic ${user['role'] == 'Guest' && ' mb1rem'}`,
                                            children: title === "InvestorMatch" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc aifs jcfs px1rem ",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: `${strongCount > 0 ? 'c34' : 'c28'} fs2rem fw600 lh1 w100 tal`,
                                                                    children: strongCount
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "c15 fs0-75rem w4rem db fw300",
                                                                    style: {
                                                                        lineHeight: '1.2'
                                                                    },
                                                                    children: [
                                                                        "Strong ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                        "Matches"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc aifs jcfs p0rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: `${mediumCount > 0 ? 'c75' : 'c28'} fs2rem fw600 lh1 w100 tal`,
                                                                    children: mediumCount
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "c15 fs0-75rem w4rem db fw300",
                                                                    style: {
                                                                        lineHeight: '1.2'
                                                                    },
                                                                    children: [
                                                                        "Medium ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                        "Matches"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    showPercent(module.stats.completionPercent || 0, 'Module Complete', title),
                                                    type != 'repository' && type != 'investor-lead' && showPercent(module.stats.riskPercent || 0, 'Module Risk', title)
                                                ]
                                            })
                                        })
                                    })
                                })
                            }),
                            type == "kpi-report" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bottom-features df jcsb aife mt1rem tal pa c15 op50",
                                        style: {
                                            bottom: '15px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 tal c15 pr",
                                            style: {
                                                fontSize: '0.75rem'
                                            },
                                            children: [
                                                "AI generated & bespoked to",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "your company"
                                            ]
                                        })
                                    }),
                                    isReady && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "br50px c1 pa",
                                        style: {
                                            background: '#15D757',
                                            right: '15px',
                                            bottom: '15px',
                                            padding: '2px 10px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "mr0-5rem",
                                                src: (parcelRequire("bqkT1")),
                                                alt: "Ready"
                                            }),
                                            "Ready"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    module ? type !== "kpi-report" && moduleTooltip(module['expansionPack'] ? Object.values(module['sections'][0]['subFolders']) : module.sections, module) : title == "Directors Questionnaire" && directorModuleTooltip(directors)
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "noRegistrationReport",
                modalCardClasses: "maw800px",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fw600 tac w100",
                            children: "Registration"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc jcc my1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "my0-5rem c15 op70 fs14px",
                                        children: [
                                            "To view or store/print your company reports, ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " you need to register (no credit card required)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/register",
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "shadow bsbb jcc df fdc aic fw500  px1rem c1 bg4 br19px cp",
                                        style: {
                                            width: '44%',
                                            paddingTop: '4px',
                                            paddingBottom: '4px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Register for FREE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fw400 c21 df fdc",
                                                style: {
                                                    marginTop: "-2px",
                                                    fontSize: '10px',
                                                    lineHeight: '15px',
                                                    fontStyle: 'italic'
                                                },
                                                children: "No credit card required"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mt1-5rem c15 op70 fs11px fsi df aic tac lh1",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                            style: {
                                                color: "#4A67FF",
                                                fontSize: '12px',
                                                marginRight: '4px'
                                            }
                                        }),
                                        " Get access to more features. Store your test results plus FREE bonus KPI Report, all bespoked by AI to your company."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");





const $d7d2c3a0ad8be93d$var$DirectorQuestionnaireDisclaimer = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: 'directorQuestionnaireDisclaimer',
        modalCardClasses: 'maw900px',
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pb2rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "c15 tac fs1-5rem",
                    children: "Important Notice"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        maxWidth: '80%',
                        margin: '1rem auto 3rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb1rem fs13px",
                            children: "Before You Continue:"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: "This questionnaire collects sensitive personal information, including financial background and any prior criminal convictions."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: "Your responses may be shared by your company with investors, advisors, co-directors, employees, and other authorised parties."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: "You are responsible for ensuring all answers are true, accurate, and complete. False or misleading information may have legal consequences."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: "This platform does not provide legal or financial advice. Seek independent advice if needed."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "c15 mb0-5rem fs13px",
                                    children: "Your data will be handled in line with applicable privacy laws and the platform\u2019s privacy policy. "
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "c15 tac fs1rem",
                    children: "Happy with this?"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pr",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "pa",
                        src: (parcelRequire("1KKTD")),
                        alt: "clarenceIcon",
                        style: {
                            right: 0,
                            top: '-90px',
                            maxWidth: '300px'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        style: {
                            width: '250px'
                        },
                        customClassName: "mt1rem",
                        text: 'Next',
                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'showDirectors'
                            })),
                        btnType: "warning"
                    })
                })
            ]
        })
    });
};
var $d7d2c3a0ad8be93d$export$2e2bcd8739ae039 = $d7d2c3a0ad8be93d$var$DirectorQuestionnaireDisclaimer;






var $ayMG0 = parcelRequire("ayMG0");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $1b4452c718b053d1$var$Road = ({ title: title, upgradeToPro: upgradeToPro, keyTitle: keyTitle = "Free", company: company, setShowExpension: setShowExpension, hideKeyTitle: hideKeyTitle = false })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `w100 df aic pr`,
            children: [
                keyTitle && !hideKeyTitle && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df fdc aic jcc w10",
                    style: {
                        height: '153px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `bg76 c1 br20px fs1rem ttu df aic jcc w100 fw600`,
                        style: {
                            padding: '4px 16px'
                        },
                        children: keyTitle
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `pr road ${keyTitle ? 'dib' : ''}`,
                    style: {
                        width: keyTitle ? keyTitle === "Lite" ? '60%' : keyTitle === "Pro" ? '65%' : keyTitle === "Free" ? '75%' : '100%' : '100%'
                    },
                    children: [
                        title && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c1 br20px fs1rem bg76 pa zi1 df aic jcc ttu",
                            style: {
                                left: '2px',
                                top: '2px',
                                paddingLeft: '1rem',
                                paddingRight: '1rem',
                                height: '32px'
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "db",
                            style: {
                                width: '100%',
                                borderTop: '3px solid transparent',
                                borderImage: 'repeating-linear-gradient( to right, white 0, white 10px,  transparent 10px, transparent 20px ) 1'
                            }
                        }),
                        keyTitle === "Free" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "c1 fs1rem fw400 br50px px1rem py0-5rem tac pa",
                            style: {
                                backgroundColor: '#68D261',
                                width: '200px',
                                right: '-2px',
                                top: '-2px'
                            },
                            children: "Upgrade for more"
                        })
                    ]
                }),
                (keyTitle === "Pro" && company?.['subscription'] === 'Lite' || keyTitle !== "Free" && (!company?.['subscription'] || company?.['subscription'] === "Free")) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc jcfs aifs ml3rem bg1 br20px pa shadow",
                    style: {
                        right: '0px',
                        top: '-56px',
                        padding: '12px',
                        zIndex: '999'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    className: "c15 fs1rem fw400",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fs20px fw600",
                                            children: keyTitle === "Lite" ? "\xa38.25" : "\xa383.25"
                                        }),
                                        "/month"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15 fs13px op60",
                                    children: "billed annually"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            btnType: "warning",
                            customClassName: "cp my0-5rem",
                            text: "Buy Now",
                            style: {
                                maxWidth: '180px'
                            },
                            onClick: ()=>{
                                setShowExpension(hideKeyTitle ? 'Pro' : keyTitle);
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'subscriptionPaymentConfirm'
                                }));
                            }
                        })
                    ]
                })
            ]
        })
    });
};
var $1b4452c718b053d1$export$2e2bcd8739ae039 = $1b4452c718b053d1$var$Road;



var $ayMG0 = parcelRequire("ayMG0");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $24a66d4502874f37$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15 1H9v2h6zm-4 13h2V8h-2zm8.03-6.61 1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61M12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"
}), 'TimerOutlined');



const $6e4f92cf1fb81405$var$WhatToDoNextCards = ({ count: count, title: title, timingButton: timingButton, appStore: appStore, description: description, lengthCards: lengthCards, image: image, icon: icon })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${lengthCards === 2 ? 'ml0-5rem' : 'ml1-5rem'}`,
        style: {
            maxWidth: '150px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `pr bg1 br10px df aisb fdc jcsb  w100 `,
                style: {
                    height: '210px',
                    width: '100%'
                },
                children: [
                    count && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "pa p0-5rem c1 df aic jcc",
                        style: {
                            top: '-18px',
                            left: '50%',
                            height: '32px',
                            width: '32px',
                            transform: 'translateX(-50%)',
                            background: '#4A67FF',
                            borderRadius: '50px'
                        },
                        children: count
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100",
                        children: title
                    }),
                    image && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: image,
                        alt: "image",
                        width: 96,
                        height: 76,
                        className: "ml1rem"
                    }),
                    icon && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: icon,
                        alt: "icon",
                        width: 60,
                        height: 60,
                        className: "ml1rem"
                    }),
                    appStore && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pl1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                style: {
                                    width: '80px'
                                },
                                src: (parcelRequire("FTXhj")),
                                alt: "appStoreIcon"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c15 fs9px op60",
                                children: "(Additional purchase required)"
                            })
                        ]
                    }),
                    timingButton && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bg4 df aic fs12px ml1rem mb0-5rem fw600",
                        style: {
                            color: '#101F68',
                            background: '#FC7785',
                            borderRadius: '20px',
                            padding: '4px 4px',
                            width: '84px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24a66d4502874f37$export$2e2bcd8739ae039), {
                                className: "ml0-5rem",
                                style: {
                                    color: '#101F68',
                                    marginRight: '4px',
                                    maxWidth: '18px'
                                }
                            }),
                            timingButton
                        ]
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "c15 tac fs11px ml0rem mt2rem",
                style: {
                    height: '50px',
                    width: '100%'
                },
                children: description
            })
        ]
    });
};
var $6e4f92cf1fb81405$export$2e2bcd8739ae039 = $6e4f92cf1fb81405$var$WhatToDoNextCards;





const $710d879c9ded52d9$var$WhatToDoNextModal = ({ Objective: Objective, subscription: subscription = "free", company: company, setShowExpension: setShowExpension })=>{
    const data = {
        "investment": [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                    children: [
                        "Investment",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Readiness Module"
                    ]
                }),
                timingButton: '30 Min',
                description: subscription === "Lite" ? "Match against our investor database" : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Assesses investment-readiness. Builds Research",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "Aid"
                        }),
                        " Reports"
                    ]
                })
            },
            ...subscription === "Free" ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "One",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Form"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Investor",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Match"
                            })
                        ]
                    }),
                    timingButton: '10 Min',
                    description: 'Match against our investor database '
                }
            ] : [],
            ...[
                'lite',
                'pro'
            ].includes(subscription.toLowerCase()) ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Business Audit",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '30 Min',
                    description: subscription === "Lite" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Assesses investment-readiness. Builds Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            }),
                            " Reports"
                        ]
                    }) : 'Check your business for strengths and weaknesses'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Data Repository ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '2 Days',
                    description: subscription === "Lite" ? "Check your business for strengths and weaknesses" : 'Organise your key docs for diligence and beyond'
                },
                ...subscription === "Lite" ? [
                    {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                            children: [
                                "One",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c4",
                                    children: "Form"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Investor",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c4",
                                    children: "Match"
                                })
                            ]
                        }),
                        timingButton: '10 Min',
                        description: 'Organise your key docs for diligence and beyond'
                    }
                ] : []
            ] : [],
            ...subscription === "Pro" ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Draft Directors\u2019 ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Questionnaires ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '15 Min',
                    appStore: true,
                    description: 'Investors want to know about you'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Draft Warranty ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Disclosures ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '1 Day',
                    appStore: true,
                    description: 'Investor want to know details of any problems in your business'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "One",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Form"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Investor",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Match"
                            })
                        ]
                    }),
                    timingButton: '10 Min',
                    description: 'Match against our investor database'
                }
            ] : []
        ],
        "growth": [
            ...subscription !== "Pro" ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Growth Readiness",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '10 Min',
                    description: 'Check your growth readiness'
                }
            ] : [],
            ...subscription === "Free" ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Loan Readiness",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '30 Min',
                    description: 'Loan readiness checklist for application to 140 lenders'
                }
            ] : [],
            ...[
                'lite',
                'pro'
            ].includes(subscription.toLowerCase()) ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Business Audit",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '30 Min',
                    description: 'Check your business for strengths and weaknesses'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Data Repository ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '2 Days',
                    description: 'Organise your key docs for diligence and beyond'
                },
                ...subscription === "Lite" ? [
                    {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                            children: [
                                "Loan Readiness",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Module"
                            ]
                        }),
                        timingButton: '30 Min',
                        description: 'Loan readiness checklist for application to 140 lenders'
                    }
                ] : []
            ] : [],
            ...subscription === "Pro" ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Healthboost  ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Modules x20"
                        ]
                    }),
                    timingButton: '30 Min',
                    appStore: true,
                    description: 'Complete modules to systematically increase business value'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Any",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "List"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Builder"
                        ]
                    }),
                    timingButton: '5 Min',
                    icon: (parcelRequire("etvvZ")),
                    description: 'Create process checklists on anything'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Builder"
                        ]
                    }),
                    icon: (parcelRequire("etvvZ")),
                    timingButton: '5 Min',
                    description: 'Create research reports on anything'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Partner Value",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Creation Modules"
                        ]
                    }),
                    timingButton: '30 Min',
                    appStore: true,
                    description: '3rd party modules to add further value to your business'
                }
            ] : []
        ],
        "exit": [
            {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                    children: [
                        "Exit Readiness ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Module"
                    ]
                }),
                timingButton: '10 Min',
                description: 'Check your exit readiness'
            },
            ...subscription === "Free" ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pt1rem px1rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "ResearchAid ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    image: (parcelRequire("amtBP")),
                    timingButton: '30 Min',
                    description: 'Report summaries only'
                }
            ] : [],
            ...[
                'lite',
                'pro'
            ].includes(subscription.toLowerCase()) ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Business Audit",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '30 Min',
                    description: 'Check your business for strengths and weaknesses'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Data Repository ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '2 Days',
                    description: 'Organise your key docs for diligence and beyond'
                },
                ...subscription === "Lite" ? [
                    {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                            children: [
                                "Sale Readiness ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Module"
                            ]
                        }),
                        timingButton: '30 Min',
                        description: 'Enhance your value and speed of sale'
                    }
                ] : []
            ] : [],
            ...subscription === "Pro" ? [
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Draft Directors\u2019 ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Questionnaires ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '15 Min',
                    appStore: true,
                    description: 'Investors want to know about you'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Draft Warranty ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Disclosures ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '1 Day',
                    appStore: true,
                    description: 'Investor want to know details of any problems in your business'
                },
                {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem mt0-5rem w100 fs12px c15 fw600",
                        children: [
                            "Sale Readiness ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Module"
                        ]
                    }),
                    timingButton: '30 Min',
                    description: 'Enhance your value and speed of sale'
                }
            ] : []
        ]
    };
    const cardsLength = data[Objective] ? data[Objective].length : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: "whatToDoNextModal",
        modalCardClasses: `py3rem ${cardsLength === 2 ? 'maw1000px' : cardsLength === 4 ? 'maw1200px' : 'maw1500px'} `,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc aic jcc br20px p3rem",
            style: {
                background: '#637DF833'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "c15 fs2rem mb5rem",
                    children: "Suggested Module Completion Order"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "whatToDoNextModalWrapper",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b4452c718b053d1$export$2e2bcd8739ae039), {
                            company: company,
                            title: subscription,
                            keyTitle: company?.['testType'],
                            upgradeToPro: subscription !== "Pro",
                            hideKeyTitle: true,
                            setShowExpension: setShowExpension
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `df aic jcc pr`,
                            style: {
                                top: '-70px',
                                left: cardsLength === 2 ? '-30px' : cardsLength === 4 ? '-30px' : '0px',
                                width: cardsLength === 2 ? "100%" : '85%'
                            },
                            children: Objective && data?.[Objective].map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e4f92cf1fb81405$export$2e2bcd8739ae039), {
                                    lengthCards: cardsLength,
                                    count: index + 1,
                                    title: item.title,
                                    timingButton: item.timingButton,
                                    description: item.description,
                                    appStore: item.appStore,
                                    image: item.image,
                                    icon: item.icon
                                }, index))
                        })
                    ]
                })
            ]
        })
    });
};
var $710d879c9ded52d9$export$2e2bcd8739ae039 = $710d879c9ded52d9$var$WhatToDoNextModal;



var $ayMG0 = parcelRequire("ayMG0");

































const $87ab33a89f0105e5$var$WhatYouGetModal = ({ subscription: subscription, Objective: Objective = "investment", company: company, showExpension: showExpension, setShowExpension: setShowExpension, user: user })=>{
    let data = {
        "investment": {
            "Free": [
                {
                    card: 'investorMatch',
                    description: 'Number of matches only'
                },
                {
                    card: 'investorReadiness',
                    description: 'Full report'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Report summaries only'
                }
            ],
            "Lite": [
                {
                    card: 'investorMatch',
                    description: 'Investor Names'
                },
                {
                    card: 'investorReadiness',
                    description: 'Full report'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Full report'
                },
                {
                    card: 'diligencePack',
                    description: 'Slim pack'
                }
            ],
            "Pro": [
                {
                    card: 'investorFitReport',
                    description: 'Detailed report on each investor'
                },
                {
                    card: 'investorReadiness',
                    description: 'Full report'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Full report + edit + build your own'
                },
                {
                    card: 'diligencePack',
                    description: 'Full pack + build your own'
                },
                {
                    card: 'yourCertification',
                    description: 'Stand out from the crowd'
                },
                {
                    card: 'investorFitReport',
                    description: '1-Click connections'
                }
            ]
        },
        "growth": {
            "Free": [
                {
                    card: 'growthReadiness',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Report summaries only'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'loanReadiness',
                    description: 'Full report'
                }
            ],
            "Lite": [
                {
                    card: 'growthReadiness',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Report summaries only'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'diligencePack',
                    description: 'Slim pack'
                },
                {
                    card: 'loanReadiness',
                    description: 'Full report'
                }
            ],
            "Pro": [
                {
                    card: 'growthReadiness',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Report summaries only'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'diligencePack',
                    description: 'Slim pack'
                },
                {
                    card: 'reasearchAidBuilder',
                    description: 'Full research reports created by you'
                },
                {
                    card: 'anyListBuilder',
                    description: 'Full checklist modules created by you'
                },
                {
                    card: 'partnerModule',
                    description: 'Let partners create more value'
                },
                {
                    card: 'yourCertification',
                    description: 'Stand out from the crowd'
                }
            ]
        },
        "exit": {
            "Free": [
                {
                    card: 'exitReadiness',
                    description: 'Full report'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Report summaries only'
                }
            ],
            "Lite": [
                {
                    card: 'exitReadiness',
                    description: 'Full report'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Full report'
                },
                {
                    card: 'diligencePack',
                    description: 'Slim pack'
                }
            ],
            "Pro": [
                {
                    card: 'exitReadiness',
                    description: 'Full report'
                },
                {
                    card: 'kpiReport',
                    description: 'Full report'
                },
                {
                    card: 'reasearchAidReport',
                    description: 'Full report + edit + build your own'
                },
                {
                    card: 'diligencePack',
                    description: 'Full pack + build your own'
                },
                {
                    card: 'reasearchAidBuilder',
                    description: 'Full research reports created by you'
                },
                {
                    card: 'anyListBuilder',
                    description: 'Full checklist modules created by you'
                },
                {
                    card: 'partnerModule',
                    description: 'Let partners create more value'
                },
                {
                    card: 'yourCertification',
                    description: 'Stand out from the crowd'
                }
            ]
        }
    };
    let filteredData = {
        ...data
    };
    if (subscription === 'Lite') delete filteredData[Objective.toLowerCase()]['Free'];
    else if (subscription === 'Pro' || user?.role?.toLowerCase() === 'investor' || user?.role?.toLowerCase() === 'advisor' || user && user['createdBy'] && user?.['createdBy']?.['role']?.toLowerCase() === 'investor' || user?.['createdBy']?.['role']?.toLowerCase() === 'advisor') {
        delete filteredData[Objective.toLowerCase()]['Free'];
        delete filteredData[Objective.toLowerCase()]['Lite'];
    }
    // if subscription is undefined/null/Free → show all (as-is)
    // so no change required in that case
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: "whatYouGetModal",
        modalCardClasses: "maw1500px py3rem",
        customStyle: {
            paddingLeft: '0rem',
            paddingRight: '0rem'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "c15 fs2rem mb2rem tac fw500",
                    children: "What You Get"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "px1rem",
                    children: Object.entries(filteredData[Objective.toLowerCase()]).map(([keyTitle, items], objIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `df fdc br20px py3rem px1-5rem mb3rem ${keyTitle === "Lite" ? "w80" : keyTitle === "Free" ? "w70" : "w100"}`,
                            style: {
                                background: '#D4DBFC'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `whatYouGetModalWrapper ${[
                                    "Lite",
                                    "Free"
                                ].includes(keyTitle) && "pr"}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b4452c718b053d1$export$2e2bcd8739ae039), {
                                        keyTitle: keyTitle,
                                        showExpension: showExpension,
                                        setShowExpension: setShowExpension,
                                        upgradeToPro: [
                                            "Free",
                                            "Lite"
                                        ].includes(keyTitle),
                                        company: company
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc  jcsb pa",
                                        style: {
                                            width: keyTitle === "Free" ? "78%" : '80%',
                                            marginLeft: '10%'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df",
                                            children: [
                                                items.map((item, index)=>{
                                                    let cardImage = null;
                                                    if (keyTitle === "Free") {
                                                        if (item.card === 'investorMatch') cardImage = (parcelRequire("2S8Rb"));
                                                        else if (item.card === 'investorReadiness') cardImage = (parcelRequire("8dYc6"));
                                                        else if (item.card === 'kpiReport') cardImage = (parcelRequire("28d7u"));
                                                        else if (item.card === 'reasearchAidReport') cardImage = (parcelRequire("b6BEA"));
                                                        else if (item.card === 'growthReadiness') cardImage = (parcelRequire("g4rCm"));
                                                        else if (item.card === 'loanReadiness') cardImage = (parcelRequire("aeBaH"));
                                                        else if (item.card === 'exitReadiness') cardImage = (parcelRequire("vzYIQ"));
                                                    } else if (keyTitle === "Lite") {
                                                        if (item.card === 'investorMatch') cardImage = (parcelRequire("2S8Rb"));
                                                        else if (item.card === 'investorReadiness') cardImage = (parcelRequire("8dYc6"));
                                                        else if (item.card === 'kpiReport') cardImage = (parcelRequire("28d7u"));
                                                        else if (item.card === 'reasearchAidReport') cardImage = (parcelRequire("b6BEA"));
                                                        else if (item.card === 'diligencePack') cardImage = (parcelRequire("7bhVJ"));
                                                        else if (item.card === 'growthReadiness') cardImage = (parcelRequire("g4rCm"));
                                                        else if (item.card === 'loanReadiness') cardImage = (parcelRequire("aeBaH"));
                                                        else if (item.card === 'exitReadiness') cardImage = (parcelRequire("vzYIQ"));
                                                    } else if (keyTitle === "Pro") {
                                                        if (item.card === 'investorMatch') cardImage = (parcelRequire("kqQBl"));
                                                        else if (item.card === 'investorReadiness') cardImage = (parcelRequire("8dYc6"));
                                                        else if (item.card === 'kpiReport') cardImage = (parcelRequire("28d7u"));
                                                        else if (item.card === 'reasearchAidReport') cardImage = (parcelRequire("b6BEA"));
                                                        else if (item.card === 'diligencePack') cardImage = (parcelRequire("8LjKs"));
                                                        else if (item.card === 'yourCertification') cardImage = (parcelRequire("6pfy5"));
                                                        else if (item.card === 'investorFitReport') cardImage = (parcelRequire("74k55"));
                                                        else if (item.card === 'reasearchAidBuilder') cardImage = (parcelRequire("e6E38"));
                                                        else if (item.card === 'anyListBuilder') cardImage = (parcelRequire("5EpVu"));
                                                        else if (item.card === 'partnerModule') cardImage = (parcelRequire("eNzUS"));
                                                        else if (item.card === 'growthReadiness') cardImage = (parcelRequire("g4rCm"));
                                                        else if (item.card === 'loanReadiness') cardImage = (parcelRequire("aeBaH"));
                                                        else if (item.card === 'exitReadiness') cardImage = (parcelRequire("vzYIQ"));
                                                    }
                                                    // Skip rendering if cardImage is null
                                                    if (!cardImage) return null;
                                                    // Convert cardImage to string for safe string operations
                                                    const cardImageStr = String(cardImage);
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc aic jcc",
                                                        style: {
                                                            maxWidth: '110px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df aic jcc",
                                                                style: {
                                                                    height: '154px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: cardImage,
                                                                    className: keyTitle === "Free" ? "ml2rem" : 'ml0-5rem ',
                                                                    alt: "cardImage",
                                                                    style: {
                                                                        width: cardImageStr.includes('diligencePackFree') ? '112px' : cardImageStr.includes('researchAidReport') ? '100px' : cardImageStr.includes('diligencePackPro') ? '110px' : (Objective === "growth" || Objective === "exit") && keyTitle === "Pro" ? '90px' : '100px',
                                                                        height: cardImageStr.includes('diligencePackFree') ? '123px' : cardImageStr.includes('researchAidReport') ? '128px' : cardImageStr.includes('diligencePackPro') ? '123px' : 'auto',
                                                                        objectFit: 'contain'
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df fdc aic jcfs",
                                                                style: {
                                                                    height: '44px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: `c15 fs12px mt0-5rem ${keyTitle === "Free" ? "ml2rem" : 'ml1rem '} tac w100`,
                                                                        children: item.description
                                                                    }),
                                                                    item.description === "1-Click connections" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        style: {
                                                                            width: '80px'
                                                                        },
                                                                        src: (parcelRequire("FTXhj")),
                                                                        alt: "appStoreIcon"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                }),
                                                keyTitle !== "Free" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: `df fdc jcfs aifs ${keyTitle === "Lite" ? 'ml1rem' : 'ml1rem'}`,
                                                    children: [
                                                        keyTitle === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            style: {
                                                                width: '60px',
                                                                marginTop: '3rem'
                                                            },
                                                            src: (parcelRequire("9Aecm")),
                                                            alt: "locationPin"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            style: {
                                                                width: '50px',
                                                                marginTop: '3rem'
                                                            },
                                                            src: (parcelRequire("1CCPV")),
                                                            alt: "locationPin"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "mt0-5rem",
                                                            children: Objective === "exit" && keyTitle !== "Free" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                        className: "c15 fs1rem",
                                                                        children: "Present to purchasers"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "c15 fs13px",
                                                                        children: [
                                                                            "Confident that you are ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            " exit ready"
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : Objective === "growth" && keyTitle !== "Free" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                                        className: "c15 fs1rem",
                                                                        children: [
                                                                            "See your ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            " value grow"
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                                        className: "c15 fs1rem",
                                                                        children: [
                                                                            "Pitch for ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            " Investment"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "c15 fs13px",
                                                                        children: [
                                                                            "Confident that you are ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                            " investment ready"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, `${objIndex}_whatYouGet`))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "tac w100 c15 fs12px",
                    children: "* AppStore requires Pro subscription"
                })
            ]
        })
    });
};
var $87ab33a89f0105e5$export$2e2bcd8739ae039 = $87ab33a89f0105e5$var$WhatYouGetModal;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");










const $ce51629355c8164e$var$VerticalRoad = ({ company: company, setTab: setTab })=>{
    const cLevel = company?.cLevel || 'None';
    const handleNavigateToCertification = ()=>{
        window.location.hash = '#unaudited-certification';
        setTab('unaudited-certification');
    };
    // Calculate position based on cLevel
    const getPosition = ()=>{
        switch(cLevel){
            case 'None':
                return {
                    top: '1%'
                };
            case 'Bronze':
                return {
                    top: '33%'
                };
            case 'Silver':
                return {
                    top: '66%'
                };
            case 'Gold':
                return {
                    top: '98%'
                };
            default:
                return {
                    top: '1%'
                };
        }
    };
    // Get transform based on cLevel
    const getTransform = ()=>{
        switch(cLevel){
            case 'None':
                return 'translateX(-50%)';
            case 'Bronze':
            case 'Silver':
                return 'translateX(-50%) translateY(-50%)';
            case 'Gold':
                return 'translateX(-50%)';
            default:
                return 'translateX(-50%)';
        }
    };
    const getJourneyImageSrc = ()=>{
        switch(company?.['testType']){
            case 'investment':
                return (parcelRequire("9mZnR"));
            case 'growth':
                return (parcelRequire("gEFao"));
            case 'exit':
                return (parcelRequire("ckYT2"));
            default:
                return (parcelRequire("gEFao"));
        }
    };
    // Get image source based on cLevel
    const getImageSrc = ()=>{
        switch(cLevel){
            case 'None':
                return (parcelRequire("7I9Dg"));
            case 'Bronze':
                return (parcelRequire("9oIEm"));
            case 'Silver':
                return (parcelRequire("f7wni"));
            case 'Gold':
                return (parcelRequire("fylCo"));
            default:
                return (parcelRequire("7I9Dg"));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df fdc aic pr mt1rem ml1rem",
        style: {
            width: "43px",
            paddingBottom: "130px"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pr road df jcc",
            style: {
                height: '74%',
                width: '100%'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "db",
                    style: {
                        height: '100%',
                        width: '3px',
                        borderLeft: '3px solid transparent',
                        borderImage: 'repeating-linear-gradient( to bottom, white 0, white 10px,  transparent 10px, transparent 20px ) 1'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("1v2Rh")),
                    style: {
                        position: 'absolute',
                        top: '8px',
                        left: 'calc(50%)',
                        transform: 'translateX(-50%)',
                        maxHeight: '120px'
                    },
                    alt: "None"
                }),
                cLevel && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: getImageSrc(),
                    onClick: ()=>handleNavigateToCertification(),
                    className: "w70px pa zi1 cp",
                    alt: cLevel,
                    style: {
                        ...getPosition(),
                        left: '50%',
                        transform: getTransform()
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: getJourneyImageSrc(),
                    style: {
                        position: 'absolute',
                        bottom: '-50px',
                        left: 'calc(50%)',
                        transform: 'translateX(-50%)',
                        maxHeight: '120px'
                    },
                    alt: "None"
                })
            ]
        })
    });
};
var $ce51629355c8164e$export$2e2bcd8739ae039 = $ce51629355c8164e$var$VerticalRoad;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $2454e33776bf53f1$var$SectionTitle = ({ title: title, subtitle: subtitle, company: company, user: user })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
        className: "fs1-25rem c15 w100",
        children: [
            " ",
            title,
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            (!company?.subscription || company?.subscription !== 'Pro') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: subtitle === "Unlock Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    text: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-75rem c1",
                        children: company?.subscription === 'Lite' ? 'Unlock Pro' : 'Upgrade to start'
                    }),
                    onClick: ()=>{
                        const userRole = user?.role?.toLowerCase();
                        const servicedRole = company?.servicedBy?.role?.toLowerCase();
                        const companyId = company?._id;
                        const isSpecialRole = [
                            'advisor',
                            'investor'
                        ].includes(userRole) || [
                            'advisor',
                            'investor'
                        ].includes(servicedRole) || user?.['createdBy']?.['role']?.toLowerCase() == 'investor' || user?.['createdBy']?.['role']?.toLowerCase() == 'advisor';
                        if (isSpecialRole) navigate(`/billing/${companyId}/pro/${servicedRole}`);
                        else navigate((0, $16250bd714b02a14$export$3623221f872af69b).replace(':id', companyId));
                    },
                    btnType: "warning",
                    style: {
                        padding: '0.5rem 1.5rem'
                    },
                    customClassName: "mt0-5rem mb1rem"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fs1rem c59 tal w100",
                    children: subtitle
                })
            })
        ]
    });
};
var $2454e33776bf53f1$export$2e2bcd8739ae039 = $2454e33776bf53f1$var$SectionTitle;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $87bcb1e0ef590b5f$exports = {};
"use strict";
Object.defineProperty($87bcb1e0ef590b5f$exports, "__esModule", {
    value: true
});
$87bcb1e0ef590b5f$exports["default"] = void 0;

var $87bcb1e0ef590b5f$var$_slider = $87bcb1e0ef590b5f$var$_interopRequireDefault((parcelRequire("99b6d")));
function $87bcb1e0ef590b5f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $87bcb1e0ef590b5f$var$_default = $87bcb1e0ef590b5f$exports["default"] = $87bcb1e0ef590b5f$var$_slider["default"];


/**
 * CommonSlider
 *
 * A reusable carousel/slider for dashboard cards. It groups children into
 * pages (slides) of `itemsPerSlide` and lays them out as a CSS grid with
 * `columns` per row inside each slide.
 *
 * Reuses the `.advisor-carousel-*` CSS classes already defined in the
 * project stylesheet so that navigation arrows, dots and layout stay
 * consistent everywhere.
 *
 * Props:
 *  - children:       React nodes to be rendered inside the slider.
 *  - itemsPerSlide:  Number of items shown on a single slide (default 6).
 *  - columns:        Grid columns per slide (default 3).
 *  - className:      Extra class for the outer wrapper.
 *  - slideClassName: Extra class for each slide container.
 *  - gridStyle:      Inline style overrides for the inner grid.
 */ const $028c120b092ae74e$var$CommonSlider = ({ children: children, itemsPerSlide: itemsPerSlide = 6, columns: columns = 3, className: className = '', slideClassName: slideClassName = '', gridStyle: gridStyle = {} })=>{
    const sliderRef = (0, $acw62.useRef)(null);
    const wrapperRef = (0, $acw62.useRef)(null);
    const items = (0, $acw62.useMemo)(()=>(0, $acw62.Children).toArray(children).filter(Boolean), [
        children
    ]);
    const groupedItems = (0, $acw62.useMemo)(()=>{
        const groups = [];
        for(let i = 0; i < items.length; i += itemsPerSlide)groups.push(items.slice(i, i + itemsPerSlide));
        return groups;
    }, [
        items,
        itemsPerSlide
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!sliderRef.current || !wrapperRef.current) return;
        const recalculate = ()=>{
            if (sliderRef.current) sliderRef.current.slickGoTo(0, true);
        };
        const t1 = setTimeout(recalculate, 50);
        const t2 = setTimeout(recalculate, 200);
        window.addEventListener('resize', recalculate);
        return ()=>{
            clearTimeout(t1);
            clearTimeout(t2);
            window.removeEventListener('resize', recalculate);
        };
    }, [
        groupedItems.length
    ]);
    if (items.length === 0) return null;
    const showControls = groupedItems.length > 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: wrapperRef,
        className: `advisor-carousel-wrapper ${className}`,
        style: {
            width: '100%',
            maxWidth: '100%',
            position: 'relative',
            isolation: 'isolate',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                className: "advisor-carousel-slider",
                ref: sliderRef,
                infinite: showControls,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                dots: showControls,
                adaptiveHeight: false,
                variableWidth: false,
                customPaging: (i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "advisor-carousel-dot",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "advisor-carousel-dot-number",
                            children: i + 1
                        })
                    }),
                appendDots: (dots)=>/*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: "advisor-carousel-dots",
                        style: {
                            margin: '0px',
                            padding: '0px',
                            listStyle: 'none'
                        },
                        children: dots
                    }),
                children: groupedItems.map((slideItems, slideIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `advisor-carousel-slide ${slideClassName}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "advisor-carousel-slide-content",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dg advisor-carousel-grid",
                                style: {
                                    width: '100%',
                                    gridTemplateColumns: `repeat(${columns}, 1fr)`,
                                    boxSizing: 'border-box',
                                    rowGap: '1rem',
                                    columnGap: '1rem',
                                    ...gridStyle
                                },
                                children: slideItems.map((item, itemIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "advisor-carousel-item",
                                        style: {
                                            width: '100%',
                                            minWidth: 0,
                                            boxSizing: 'border-box'
                                        },
                                        children: item
                                    }, itemIndex))
                            })
                        })
                    }, slideIndex))
            }),
            showControls && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "advisor-carousel-nav advisor-carousel-prev bg3 br100 df jcc aic cp",
                        onClick: ()=>sliderRef.current?.slickPrev(),
                        "aria-label": "Previous slide",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M12.5 15L7.5 10L12.5 5",
                                stroke: "white",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "advisor-carousel-nav advisor-carousel-next bg3 br100 df jcc aic cp",
                        onClick: ()=>sliderRef.current?.slickNext(),
                        "aria-label": "Next slide",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M7.5 5L12.5 10L7.5 15",
                                stroke: "white",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $028c120b092ae74e$export$2e2bcd8739ae039 = $028c120b092ae74e$var$CommonSlider;


// Advisor Card Component
const $5287a2219e0eaa28$var$AdvisorCard = ({ topBar: topBar, title: title, content: content, button: button })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "advisor-carousel-slide",
        style: {
            minHeight: '240px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "br20px bg1 shadow p1rem",
            style: {
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '240px'
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc aic",
                style: {
                    gap: '1rem',
                    height: '100%',
                    alignItems: 'center'
                },
                children: [
                    topBar?.type === 'text' || topBar?.type === 'image' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcc",
                        style: {
                            height: '60px'
                        },
                        children: [
                            topBar?.type === 'text' && topBar?.text && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bg38 br20px px1rem py0-5rem",
                                style: {
                                    backgroundColor: '#E8F5E9',
                                    borderRadius: '20px',
                                    width: 'fit-content'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c59 fw600 fs1-25rem",
                                    children: topBar.text
                                })
                            }),
                            topBar?.type === 'image' && topBar?.imageUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: topBar.imageUrl,
                                    alt: title || 'Advisor',
                                    className: "br20ox ofc",
                                    style: {
                                        maxWidth: '100%',
                                        height: 'auto'
                                    }
                                })
                            })
                        ]
                    }) : null,
                    title || content ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic",
                        style: {
                            height: '60px'
                        },
                        children: [
                            title && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem tac",
                                style: {
                                    color: '#FC7785',
                                    fontWeight: 600,
                                    textAlign: 'center'
                                },
                                children: title
                            }),
                            content && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem tac",
                                style: {
                                    color: '#5E5F66',
                                    fontSize: !title ? '1rem' : '0.75rem',
                                    flex: 1,
                                    textAlign: 'center'
                                },
                                children: content
                            })
                        ]
                    }) : null,
                    button?.text && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "br20px px1-5rem py0-75rem c1 fw500 cp",
                        style: {
                            backgroundColor: '#F78B9B',
                            border: 'none',
                            borderRadius: '20px',
                            color: '#fff',
                            fontSize: '0.875rem',
                            width: 'fit-content',
                            cursor: 'pointer'
                        },
                        onClick: ()=>{
                            if (button?.link) {
                                if (button.link === '#') ;
                                else // For external links, open in new tab
                                window.open(button.link, '_blank', 'noopener,noreferrer');
                            }
                        },
                        children: button.text
                    })
                ]
            })
        })
    });
};





// Advisor Carousel Data (fallback when no cards are supplied)
const $5287a2219e0eaa28$var$advisorCarouselData = [
    {
        id: 1,
        topBar: {
            type: 'text',
            text: 'PRO Plus'
        },
        title: "Can\u2019t or don\u2019t want to DIY?",
        content: 'Be matched to an individual advisor or one of our specialist partner organsiations',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 2,
        topBar: {
            type: 'image',
            imageUrl: (parcelRequire("bdueI"))
        },
        title: 'AdvisorMatch',
        content: 'Get help from one of our CFOs',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 3,
        topBar: {
            type: 'image',
            imageUrl: (parcelRequire("5jXbT"))
        },
        title: 'Get help from an experienced C-suite expert',
        content: 'Multi-discipline',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 4,
        topBar: {
            type: 'image',
            imageUrl: (parcelRequire("hxcH4"))
        },
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Get help from an experienced ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                " CFO"
            ]
        }),
        content: 'Fixed price 4 quarterly reviews',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 5,
        topBar: {
            type: 'image',
            imageUrl: (parcelRequire("23KCH"))
        },
        title: 'Get help from investment readiness specialist',
        content: "St. John\u2019s Innovation Centre",
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    },
    {
        id: 6,
        topBar: {
            type: 'image',
            imageUrl: (parcelRequire("j1Rr6"))
        },
        title: 'Get help from business growth specialist',
        content: 'North East Innovation Accelerator',
        button: {
            text: 'Book A Call',
            link: 'https://koalendar.com/e/meet-with-mark-bernstein'
        }
    }
];
const $5287a2219e0eaa28$var$AdvisorCarousel = ({ cards: cards })=>{
    const resolvedCards = Array.isArray(cards) && cards.length > 0 ? cards.map((c, i)=>({
            id: c?._id || c?.assistanceCardId || c?.id || i + 1,
            topBar: c?.imageURL ? {
                type: 'image',
                imageUrl: c.imageURL
            } : c?.topText ? {
                type: 'text',
                text: c.topText
            } : {
                type: 'text',
                text: 'Diligentsia Plus'
            },
            title: c?.moduleName || c?.title || '',
            content: c?.moduleDescription || c?.description || '',
            button: {
                text: c?.buttonText || '',
                link: c?.buttonLink || c?.button?.link || ''
            }
        })) : $5287a2219e0eaa28$var$advisorCarouselData;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $028c120b092ae74e$export$2e2bcd8739ae039), {
        itemsPerSlide: 6,
        columns: 3,
        gridStyle: {
            columnGap: '0rem'
        },
        children: resolvedCards.map((card)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5287a2219e0eaa28$var$AdvisorCard, {
                topBar: card.topBar,
                title: card.title,
                content: card.content,
                button: card.button
            }, card.id))
    });
};
var $5287a2219e0eaa28$export$2e2bcd8739ae039 = $5287a2219e0eaa28$var$AdvisorCarousel;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $da1cd1d5f4d3b1fe$var$HealthboostCarousel = ({ items: items, healthboostBox: healthboostBox })=>{
    const healthboostCarouselRef = (0, $acw62.useRef)(null);
    const wrapperRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        // Force slick to recalculate dimensions after mount or when items change
        if (healthboostCarouselRef.current && wrapperRef.current) {
            const recalculate = ()=>{
                if (healthboostCarouselRef.current) healthboostCarouselRef.current.slickGoTo(0, true);
            };
            // Initial recalculation
            const timer1 = setTimeout(()=>{
                if (healthboostCarouselRef.current) healthboostCarouselRef.current.slickGoTo(0, true);
            }, 50);
            const timer2 = setTimeout(()=>{
                if (healthboostCarouselRef.current) healthboostCarouselRef.current.slickGoTo(0, true);
            }, 200);
            // Handle window resize
            window.addEventListener('resize', recalculate);
            return ()=>{
                clearTimeout(timer1);
                clearTimeout(timer2);
                window.removeEventListener('resize', recalculate);
            };
        }
    }, [
        items
    ]);
    // Filter items that are valid modules (have type or moduleKey)
    const validItems = items.filter((item)=>item && (item['type'] || item['moduleKey']));
    // Group items into slides of 6 (2 rows x 3 columns)
    const groupedItems = [];
    for(let i = 0; i < validItems.length; i += 6)groupedItems.push(validItems.slice(i, i + 6));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: wrapperRef,
        className: "healthboost-carousel-wrapper",
        style: {
            width: '100%',
            maxWidth: '100%',
            position: 'relative',
            isolation: 'isolate',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                className: "healthboost-carousel-slider",
                ref: healthboostCarouselRef,
                infinite: groupedItems.length > 1,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                arrows: false,
                dots: true,
                adaptiveHeight: false,
                variableWidth: false,
                customPaging: (i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "healthboost-carousel-dot",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "healthboost-carousel-dot-number",
                            children: i + 1
                        })
                    }),
                appendDots: (dots)=>/*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: "healthboost-carousel-dots",
                        style: {
                            margin: '0px',
                            padding: '0px',
                            listStyle: 'none'
                        },
                        children: dots
                    }),
                children: groupedItems.map((slideItems, slideIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "healthboost-carousel-slide",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "healthboost-carousel-slide-content",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dg gtcr3 healthboost-carousel-grid",
                                style: {
                                    width: '100%',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    boxSizing: 'border-box',
                                    rowGap: '2rem',
                                    columnGap: '1rem'
                                },
                                children: slideItems.map((module, itemIndex)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "healthboost-carousel-item",
                                        style: {
                                            width: '100%',
                                            minWidth: 0,
                                            boxSizing: 'border-box'
                                        },
                                        children: healthboostBox(module)
                                    }, module['type'] || module['moduleKey'] || itemIndex);
                                })
                            })
                        })
                    }, slideIndex))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "healthboost-carousel-nav healthboost-carousel-prev bg3 br100 df jcc aic cp",
                onClick: ()=>healthboostCarouselRef.current?.slickPrev(),
                "aria-label": "Previous slide",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12.5 15L7.5 10L12.5 5",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "healthboost-carousel-nav healthboost-carousel-next bg3 br100 df jcc aic cp",
                onClick: ()=>healthboostCarouselRef.current?.slickNext(),
                "aria-label": "Next slide",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7.5 5L12.5 10L7.5 15",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                })
            })
        ]
    });
};
var $da1cd1d5f4d3b1fe$export$2e2bcd8739ae039 = $da1cd1d5f4d3b1fe$var$HealthboostCarousel;






var $ayMG0 = parcelRequire("ayMG0");


var $45fvw = parcelRequire("45fvw");



function $8a6920c5c8f56776$export$2e2bcd8739ae039({ report: report, type: type, item: item, company: company, user: user, permissionLevel: permissionLevel, onReportRedirect: onReportRedirect, onReportName: onReportName, onDeleteHistoryRecord: onDeleteHistoryRecord, isGenerateAllResearchAid: isGenerateAllResearchAid }) {
    const creator = report?.['createdBy'];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bo7 w100 keyfeature-wihte-item bg1 new-shadow br15px p1-5rem mx1rem my1-5rem pr bsbb",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "cp w100 h100",
                style: {
                    minHeight: '130px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon-diligenstia mr1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "br5px w50px",
                                    src: (parcelRequire("jSVu6")),
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc mr1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "w100 tal",
                                        style: {
                                            color: '#929090',
                                            fontSize: '11px'
                                        },
                                        children: [
                                            "Research",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "Aid"
                                            })
                                        ]
                                    }),
                                    report?.['htmlReport'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: permissionLevel !== 'DASHBOARD' ? `#${report['_id']}?${report['reportType']}-researchaid` : '#',
                                        onClick: ()=>onReportRedirect(report),
                                        className: "w100 fs1rem c15",
                                        children: report['name']
                                    }) : report['reportType'] === 'swotAnalysis' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>onReportName(report),
                                        className: "cp w100 bg1 fs1rem tal c15",
                                        children: report['name']
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/researchAid/${company['_id']}?${report['reportType']}`,
                                        state: {
                                            company: company
                                        },
                                        className: "w100 fs1rem c15",
                                        children: report['name']
                                    })
                                ]
                            }),
                            report?.['htmlReport'] && company['subscription'] === 'Pro' && user['role'] !== 'Advisor' && user['role'] !== 'Investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/researchAid/${company['_id']}#${report['_id'] || ''}?${report['reportType']}`,
                                        state: {
                                            company: company
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "cp fa fa-edit pl1rem c3",
                                            style: {
                                                fontSize: '20px',
                                                fontWeight: '400'
                                            }
                                        })
                                    }),
                                    report?.['history']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "cp module-tooltip-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "hover-list",
                                                style: {
                                                    position: 'relative',
                                                    left: 'auto',
                                                    top: 'auto'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "cp fa fa-history pl1rem c4",
                                                    style: {
                                                        fontSize: '20px',
                                                        fontWeight: '400'
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "tooltip-area tooltip-reaserchaid",
                                                children: report['history'].map((data)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        style: {
                                                            padding: '5px 10px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic w100",
                                                            children: [
                                                                data?.['userId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`,
                                                                    className: "shadow w2rem h2rem bg16 bw3px bss bo19 df jcc aic br100 c1 mr0-5rem",
                                                                    children: data['userId']['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: data['userId']['profile'],
                                                                        className: "new-shadow w30px h30px df jcc aic br100 bg16 c1",
                                                                        alt: "",
                                                                        "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "bg16 c15 br50px",
                                                                        "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`,
                                                                        children: data['userId']?.firstName ? data['userId'].firstName[0] + (data['userId'].lastName?.[0] || '') : '?'
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "text-box df aic jcsb w100",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c15",
                                                                            style: {
                                                                                fontSize: '10px'
                                                                            },
                                                                            children: data['lastUpdatedTime'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                children: data['lastUpdatedTime']
                                                                            })
                                                                        }),
                                                                        onDeleteHistoryRecord && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>onDeleteHistoryRecord(report['_id'], data['_id'], type),
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                className: "fa fa-trash c9 cp",
                                                                                style: {
                                                                                    fontSize: '20px'
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, data['_id']))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df jcsb mt3rem px1rem",
                        children: [
                            !report?.['htmlReport'] && !report?.['score'] && !(report?.['reportType'] === 'swotAnalysis' && report?.['disableSwotReport']) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: isGenerateAllResearchAid && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "cna br25px px3rem cp bg16 py0-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$67ad50c48ca3ede4), {
                                        height: "20",
                                        width: "20",
                                        strokeWidth: "4",
                                        secondaryColor: "#f9f9f9",
                                        color: "#000",
                                        ariaLabel: "oval-loading"
                                    })
                                })
                            }) : // A generated report (SWOT included) always carries htmlReport/score/createdAt. Show the
                            // date + score whenever it is generated — don't hard-require a populated creator, otherwise
                            // a report whose createdBy isn't populated (e.g. SWOT) renders a blank card body.
                            (report?.['htmlReport'] || report?.['score']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    company['subscription'] === 'Free' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc mt1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "w100 fs0-75rem fw300",
                                                children: "Executive Summary only."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "w100 fs0-75rem fw300",
                                                children: [
                                                    "To ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c7 fw500",
                                                        children: "UNLOCK"
                                                    }),
                                                    " upgrade to PRO/LITE"
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic",
                                        children: [
                                            creator && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`,
                                                className: "shadow w40px h40px bg16 bw3px bss bo19 df jcc aic br100 c1",
                                                children: creator?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: creator.profile,
                                                    className: "new-shadow w30px h30px df jcc aic br100 bg16 c1",
                                                    alt: "",
                                                    "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "bg16 c15 br50px",
                                                    "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`,
                                                    children: creator?.firstName ? creator.firstName[0] + (creator.lastName?.[0] || '') : '?'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem c15 ml0-5rem",
                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report.createdAt).format('ll')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: `fs1-5rem tac ${report?.['score'] >= 4 ? 'c34' : report?.['score'] >= 2 ? 'c39' : 'c4'}`,
                                                children: [
                                                    report?.['score'],
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem",
                                                        children: "/5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs0-75rem fw400 c15",
                                                children: [
                                                    "Report ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " Score"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            item?.['time'] && !report?.['score'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic pa",
                                style: {
                                    right: '10px',
                                    bottom: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("jJgJl")),
                                        style: {
                                            width: '14px',
                                            height: '14px'
                                        },
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: item?.['time']
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}











const $10ce69539c98d6ac$var$FreeDashboard = ({ user: user, company: company, permissionLevel: permissionLevel, setTab: setTab, setIsViewTwoMinuteReport: setIsViewTwoMinuteReport, isGenerateAllResearchAid: isGenerateAllResearchAid, fitInvestorFirms: fitInvestorFirms, investorFirmCounts: investorFirmCounts, checklistModules: checklistModules, sortModules: sortModules, portfolioProReports: portfolioProReports, extensionPackages: extensionPackages, showExtraModules: showExtraModules, proPlusPacks: proPlusPacks, getFitInvestorFirms: getFitInvestorFirms, handleSeeMore: handleSeeMore, handleHowItWorks: handleHowItWorks, setModuleTab: setModuleTab, moduleBox: moduleBox, handleRegisterNow: handleRegisterNow, MODULE_NEW_DASHBOARD: MODULE_NEW_DASHBOARD, MODULE_BOX: MODULE_BOX, setCompanyDashboardTab: setCompanyDashboardTab, healthboostBox: healthboostBox })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const subscription = company['subscription'] || 'Lite';
    let [isSwotReport, setIsSwotReport] = (0, $acw62.useState)(false);
    const handleReportRedirect = (report)=>{
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        setTab(`${report['_id']}?${report['reportType']}-researchaid`);
        setCompanyDashboardTab('Dashboard');
    };
    (0, $acw62.useEffect)(()=>{
        if (fitInvestorFirms.length == 0) getFitInvestorFirms(false);
    }, []);
    const handleReportName = (report)=>{
        if (report['reportType'] == 'swotAnalysis') {
            if (report?.['disableSwotReport']) setIsSwotReport(true);
            else setIsSwotReport(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'swotReportPopup'
            }));
        }
    };
    const reportCard = (report, type, item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a6920c5c8f56776$export$2e2bcd8739ae039), {
            report: report,
            type: type,
            item: item,
            company: company,
            user: user,
            permissionLevel: permissionLevel,
            onReportRedirect: handleReportRedirect,
            onReportName: handleReportName,
            onDeleteHistoryRecord: undefined,
            isGenerateAllResearchAid: isGenerateAllResearchAid
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "box-dashbord-contaxiner mla mra mb6rem mt2rem",
        style: {
            width: '98%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `bg20 bss bo5 bsbb px2rem py2rem br25px w100 ${user?.['role'] == 'Guest' ? 'bo3' : 'bo28'} keyfeature-box keyfeature-box-company-${subscription.toLowerCase()} df fww mb2rem pr bsbb bw1px`,
                style: {
                    backgroundColor: '#EEFFF7'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcsb w100 aic",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2454e33776bf53f1$export$2e2bcd8739ae039), {
                            title: "Some Easy Wins",
                            subtitle: "FREE"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg1rem gtcr4 w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f9e7d74c90dd72e$export$2e2bcd8739ae039), {
                                permissionLevel: permissionLevel,
                                user: user,
                                company: company,
                                setIsViewTwoMinuteReport: setIsViewTwoMinuteReport,
                                step: "2",
                                title: "KPI Report",
                                type: "kpi-report",
                                module: {
                                    ...company.modules["two-minute-test-" + company.testType],
                                    menus: [
                                        'howItWorks',
                                        'seeMore'
                                    ]
                                },
                                setTab: setTab,
                                handleSeeMore: handleSeeMore,
                                handleHowItWorks: handleHowItWorks,
                                seeMore: MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise']?.['kpi']?.['seeMore'],
                                howItWorks: MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise']?.['kpi']?.['howItWorks'],
                                setModuleTab: setModuleTab,
                                isReady: true,
                                subscription: "Free"
                            }),
                            company['testType'] == 'growth' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : company['testType'] == 'investment' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f9e7d74c90dd72e$export$2e2bcd8739ae039), {
                                        permissionLevel: permissionLevel,
                                        company: company,
                                        title: "InvestorMatch",
                                        type: "investor-lead",
                                        moduleCertification: company?.['moduleCertification']?.['investor-lead'],
                                        module: {
                                            ...company['modules']['investor-lead'],
                                            menus: [
                                                'listOfSections',
                                                'report'
                                            ]
                                        },
                                        setTab: setTab,
                                        getFitInvestorFirms: getFitInvestorFirms,
                                        handleSeeMore: handleSeeMore,
                                        handleHowItWorks: handleHowItWorks,
                                        seeMore: MODULE_BOX['appStoreInvestment']['investor-leads']['seeMore'],
                                        howItWorks: MODULE_BOX['appStoreInvestment']['investor-leads']['howItWorks'],
                                        setModuleTab: setModuleTab,
                                        fitInvestorFirms: fitInvestorFirms
                                    }, "DEPF008"),
                                    company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>{
                                        return item?.['type'] == 'Top 10 Investment Readiness Cock Ups To Avoid' && item?.['category'] == "all" && item['isActive'] && !item['isHealthBoost'];
                                    }).sort(sortModules).map((module)=>({
                                            ...module,
                                            menus: module?.menus || [
                                                'listOfSections',
                                                'seeMore',
                                                'howItWorks',
                                                'report',
                                                'workflow'
                                            ]
                                        }))),
                                    company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>{
                                        return item?.['category'] == "partner" && item?.['testType'] == 'investment' && item['isActive'] && !item['isHealthBoost'];
                                    }).sort(sortModules).map((module)=>({
                                            ...module,
                                            menus: module?.menus || [
                                                'listOfSections',
                                                'seeMore',
                                                'howItWorks',
                                                'report',
                                                'workflow'
                                            ]
                                        }))),
                                    company?.['modules'] && !company?.['modules']['Investment Readiness'] && company?.['extraModules'] && showExtraModules(company['extraModules'].filter((item)=>item['testType'] == 'investment' && item['isActive'])),
                                    user?.['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/register",
                                        onClick: ()=>handleRegisterNow(),
                                        className: `pr bss ${user?.['role'] == 'Guest' ? 'bo3' : 'bo7'} bw3px btn-packge w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb register-btn`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon-diligenstia mr1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w40px h40px",
                                                            src: (parcelRequire("3N5Zr")),
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "fs1rem fw500 c15 lh2 title-box-feature tal",
                                                        children: [
                                                            " Register Now",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "db w100 tal fw500 fs0-5rem",
                                                                children: "Register your company email FREE now (no credit card required) to preserve your dashboard and access your reports"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: "/register",
                                                onClick: ()=>handleRegisterNow(),
                                                className: "cp registerButtonAnimation",
                                                children: "Register Now"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-box",
                                                children: "Step 4"
                                            })
                                        ]
                                    })
                                ]
                            }) : company['testType'] == 'exit' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>{
                                        return item?.['type'] == 'Top 10 Investment Readiness Cock Ups To Avoid' && item?.['category'] == "all" && item['isActive'] && !item['isHealthBoost'];
                                    }).sort(sortModules).map((module)=>({
                                            ...module,
                                            menus: module?.menus || [
                                                'listOfSections',
                                                'seeMore',
                                                'howItWorks',
                                                'report',
                                                'workflow'
                                            ]
                                        }))),
                                    company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>{
                                        return item?.['category'] == "partner" && item?.['testType'] == 'exit' && item['isActive'] && !item['isHealthBoost'];
                                    }).sort(sortModules).map((module)=>({
                                            ...module,
                                            menus: module?.menus || [
                                                'listOfSections',
                                                'seeMore',
                                                'howItWorks',
                                                'report',
                                                'workflow'
                                            ]
                                        }))),
                                    company?.['modules'] && !company?.['modules']['Exit Readiness'] && company?.['extraModules'] && showExtraModules(company['extraModules'].filter((item)=>item['testType'] == 'exit' && item['isActive'])),
                                    user?.['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/register",
                                        onClick: ()=>handleRegisterNow(),
                                        className: `pr bss ${user?.['role'] == 'Guest' ? 'bo3' : 'bo7'} bw3px btn-packge w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb register-btn`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon-diligenstia mr1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w40px h40px",
                                                            src: (parcelRequire("3N5Zr")),
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "fs1rem fw500 c15 lh2 title-box-feature tal",
                                                        children: [
                                                            " Register Now",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "db w100 tal fw500 fs0-5rem",
                                                                children: "Register your company email FREE now (no credit card required) to preserve your dashboard and access your reports"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: "/register",
                                                onClick: ()=>handleRegisterNow(),
                                                className: "cp registerButtonAnimation",
                                                children: "Register Now"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "step-box",
                                                children: "Step 4"
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "right-img-areas df w100 aic jcfe",
                        style: {
                            margin: '-58px 0'
                        },
                        children: user['role'] == 'Guest' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w30 mt2rem pr",
                            style: {
                                right: '-52px'
                            },
                            src: (parcelRequire("httRN")),
                            alt: "aiIcon"
                        }) : company?.moduleStats && company?.moduleStats["two-minute-test-" + company.testType]?.['stats']?.['completionPercent'] == 100 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w30 mt2rem pr",
                            style: {
                                right: '-52px'
                            },
                            src: (parcelRequire("aR2xO")),
                            alt: "aiIcon"
                        }) : null
                    })
                ]
            }),
            MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grs1-md gre3-md df fdc aifs tac",
                        style: {
                            width: '21%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aifs tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-25re c15 w100 tal",
                                        children: "Now let\u2019s get organised"
                                    }),
                                    subscription == 'Free' && /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1rem c59 tal w100",
                                        children: user['role'] == 'Advisor' ? 'PRO only' : 'LITE & PRO only'
                                    }),
                                    subscription !== 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        text: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem c1",
                                            children: subscription === 'Lite' ? 'Unlock Pro' : 'Upgrade to start'
                                        }),
                                        onClick: ()=>{
                                            const userRole = user?.role?.toLowerCase();
                                            const servicedRole = company?.servicedBy?.role?.toLowerCase();
                                            const companyId = company?._id;
                                            const isSpecialRole = [
                                                'advisor',
                                                'investor'
                                            ].includes(userRole) || [
                                                'advisor',
                                                'investor'
                                            ].includes(servicedRole) || user?.['createdBy']?.['role']?.toLowerCase() == 'investor' || user?.['createdBy']?.['role']?.toLowerCase() == 'advisor';
                                            if (isSpecialRole) navigate(`/billing/${companyId}/pro/${servicedRole}`);
                                            else navigate((0, $16250bd714b02a14$export$3623221f872af69b).replace(':id', companyId));
                                        },
                                        btnType: "warning",
                                        style: {
                                            padding: '0.5rem 1.5rem'
                                        },
                                        customClassName: "mt0-5rem"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100 h100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'whatYouGetModal'
                                        })),
                                    src: (parcelRequire("l7mJg")),
                                    style: {
                                        width: '230px',
                                        height: '251px'
                                    },
                                    alt: "dashboardIcon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dg gg1rem gtcr3 fww coreworkspace-update",
                        style: {
                            width: '75%'
                        },
                        children: (()=>{
                            const items = Object.values(MODULE_NEW_DASHBOARD[company['testType']]?.['letsOrganise'] || {}).filter((item)=>item['title']);
                            if (company['subscription'] !== 'Lite') return items.map((item, idx)=>moduleBox(item));
                            let firstTwoItems = items.slice(0, 2);
                            let remainingItems = items.slice(2);
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    firstTwoItems.length > 0 && ![
                                        'Free',
                                        'Pro'
                                    ].includes(company['subscription']) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            gridColumn: 'span 2',
                                            backgroundColor: '#EEFFF7',
                                            borderRadius: '15px',
                                            padding: '16px 16px 12px',
                                            border: '1px solid rgba(115, 133, 190, 0.5)',
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: '1rem'
                                        },
                                        children: firstTwoItems.map((item, idx)=>moduleBox(item))
                                    }, "first-two-container"),
                                    remainingItems.map((item, idx)=>moduleBox(item))
                                ]
                            });
                        })()
                    })
                ]
            }) : null,
            MODULE_NEW_DASHBOARD[company['testType']]?.['proveOurValue'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grs1-md gre3-md df fdc aifs tac",
                        style: {
                            width: '21%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aifs tal",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-25re c15 w100 tal",
                                        children: "Prove our value..."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem c59 tal w100",
                                        children: "PRO only"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100 h100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("jGyES")),
                                    style: {
                                        width: '230px',
                                        height: '251px'
                                    },
                                    alt: "dashboardIcon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dg gg1rem gtcr3 fww coreworkspace-update",
                        style: {
                            width: '75%'
                        },
                        children: Object.values(MODULE_NEW_DASHBOARD[company['testType']]?.['proveOurValue'] || {}).map((item)=>item?.module ? reportCard(item?.['module'], item?.['isReseachAid']?.['type'], item) : moduleBox(item))
                    })
                ]
            }) : null,
            MODULE_NEW_DASHBOARD[company['testType']]?.['getPitching'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grs1-md gre3-md df fdc aifs tac",
                        style: {
                            width: '21%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aifs tal",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-25re c15 w100 tal",
                                        children: ".. and get pitching!"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem c59 tal w100",
                                        children: "PRO only"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100 h100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("9SkeM")),
                                    style: {
                                        width: '230px',
                                        height: '251px'
                                    },
                                    alt: "dashboardIcon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dg gg1rem gtcr3 fww coreworkspace-update",
                        style: {
                            width: '75%'
                        },
                        children: Object.values(MODULE_NEW_DASHBOARD[company['testType']]?.['getPitching'] || {}).map((item)=>item['title'] && moduleBox(item))
                    })
                ]
            }) : null,
            MODULE_NEW_DASHBOARD[company['testType']]?.['turboBoost'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df jcsb fww mb2rem pr bsbb bw2 bo28 bw1px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grs1-md gre3-md df fdc aifs tac",
                        style: {
                            width: '21%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aifs tal",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-25re c15 w100 tal",
                                        children: ".. and turbo boost your growth!"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem c59 tal w100",
                                        children: "PRO only"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100 h100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("itXx6")),
                                    style: {
                                        width: '230px',
                                        height: '251px'
                                    },
                                    alt: "dashboardIcon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "healthboost-carousel-container",
                        style: {
                            width: '75%',
                            position: 'relative'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da1cd1d5f4d3b1fe$export$2e2bcd8739ae039), {
                            items: (()=>{
                                // Get actual company healthBoost modules
                                if (company?.['modules'] && Object.values(company['modules']).length > 0) return Object.values(company['modules']).filter((item)=>item?.['category'] == "all" && item?.['isHealthBoost']).sort(sortModules).map((item)=>({
                                        ...MODULE_NEW_DASHBOARD[company['testType']]?.['turboBoost']?.[item['type']] || {
                                            un: "true"
                                        },
                                        ...item
                                    }));
                                return [];
                            })(),
                            healthboostBox: healthboostBox
                        })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grs1-md gre3-md df fdc aifs tac",
                        style: {
                            width: '21%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aifs tal",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-25re c15 w100 tal",
                                        children: "Need advisor assistance?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem c59 tal w100",
                                        children: "Diligentsia Plus"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100 h100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("kdws4")),
                                    style: {
                                        width: '230px',
                                        height: '251px'
                                    },
                                    alt: "dashboardIcon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "advisor-carousel-container",
                        style: {
                            width: '75%',
                            position: 'relative'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5287a2219e0eaa28$export$2e2bcd8739ae039), {
                            setCompanyDashboardTab: setCompanyDashboardTab
                        })
                    })
                ]
            })
        ]
    });
};
var $10ce69539c98d6ac$export$2e2bcd8739ae039 = $10ce69539c98d6ac$var$FreeDashboard;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





const $2e7cfd1339b30947$var$HowItWorkModal = ({ selectedHowItWorks: selectedHowItWorks })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            id: "keyFeatureSeeMore",
            modalType: 'howItWorksPopupNew',
            modalCardClasses: "maw1300px",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fww w100",
                children: [
                    selectedHowItWorks?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc fdc pa",
                        style: {
                            right: '-7%',
                            top: '-5%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("jLZXj")),
                                className: "w70",
                                style: {
                                    borderRadius: '50%'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("fOQ2M")),
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: "videoCompanies"
                                    })),
                                className: "cp zi1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "w100 tac c15 fs1-75rem fw500",
                        children: "How does it work?"
                    }),
                    selectedHowItWorks?.['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                        className: "w100 tac c15 fs1-25rem fw500 mb1rem",
                        children: selectedHowItWorks?.['subTitle']
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "step-top-box df w100 jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: selectedHowItWorks?.['stepImage'],
                            className: "w70",
                            style: {
                                objectFit: 'fill'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                        children: [
                            selectedHowItWorks?.['arrayImages'].length,
                            selectedHowItWorks?.['arrayImages'] && selectedHowItWorks?.['arrayImages'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: selectedHowItWorks?.['arrayImages'].map((image)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "step-img df jcc px1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: image,
                                            alt: "ste image"
                                        })
                                    });
                                })
                            })
                        ]
                    }),
                    selectedHowItWorks?.['checkList'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb",
                        children: selectedHowItWorks?.['checkList'] && selectedHowItWorks?.['checkList'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: selectedHowItWorks?.['checkList'].map((array)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "checklist-inner w100 pr",
                                    children: array
                                });
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc w100",
                        children: selectedHowItWorks?.['bottomSection'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-25rem c12 mb1rem tac w100",
                            children: selectedHowItWorks?.['bottomSection']
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            children: selectedHowItWorks?.['btnContent']
                        })
                    })
                ]
            })
        })
    });
};
var $2e7cfd1339b30947$export$2e2bcd8739ae039 = $2e7cfd1339b30947$var$HowItWorkModal;


















































































































































































































































































































































































































































function $d4b71702867a3909$export$2e2bcd8739ae039({ investorFirmCounts: investorFirmCounts, company: company, setTab: setTab, setIsViewTwoMinuteReport: setIsViewTwoMinuteReport, isWorkflowReport: isWorkflowReport, setIsWorkflowReport: setIsWorkflowReport, permissionLevel: permissionLevel, getFitInvestorFirms: getFitInvestorFirms, selectedSeeMore: selectedSeeMore, setSelectedSeeMore: setSelectedSeeMore, setCompanyDashboardTab: setCompanyDashboardTab, setCertificateSeeMore: setCertificateSeeMore, isGenerateAllResearchAid: isGenerateAllResearchAid, fitInvestorFirms: fitInvestorFirms }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const modalJustClosedRef = (0, $acw62.useRef)(false);
    let [isSwotReport, setIsSwotReport] = (0, $acw62.useState)(false);
    let [plan, setPlan] = (0, $acw62.useState)();
    let [payload, setPayload] = (0, $acw62.useState)(null);
    let [companyId, setCompanyId] = (0, $acw62.useState)("");
    let [showExpension, setShowExpension] = (0, $acw62.useState)(null);
    let [reportTab, setReportTab] = (0, $acw62.useState)(null);
    // let [selectedSeeMore, setSelectedSeeMore] = useState({});
    let [selectedModules, setSelectedModules] = (0, $acw62.useState)(null);
    let [selectedHowItWorks, setSelectedHowItWorks] = (0, $acw62.useState)({});
    let [selectedThingsToDo, setSelectedThingsToDo] = (0, $acw62.useState)({});
    let [expanded, setExpanded] = (0, $acw62.useState)({
        investmentPanel: false,
        growthPanel: false,
        exitPanel: false
    });
    // OPTIMIZATION: Lazy load directors when not available (excluded in lightweight mode)
    let [directors, setDirectors] = (0, $acw62.useState)(company?.['directors'] || []);
    (0, $acw62.useEffect)(()=>{
        if (company['researchAidReports'] && company['researchAidReports'].length > 0) {
            const report = company?.['researchAidReports'].filter((item)=>item?.['reportType'] === "swotAnalysis")?.[0];
            if (report?.['disableSwotReport']) setIsSwotReport(true);
            else setIsSwotReport(false);
        }
    }, [
        company
    ]);
    const handleLinkModuleTab = (type, module)=>{
        if (type.startsWith('two-minute-') && !company['freeModules'] || company['freeModules'] && !company['freeModules'][type]) return `#`;
        if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
            if ([
                'software-development',
                'esg',
                'warranty-disclosure',
                'directors-questionnaire'
            ].includes(type) && !company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) return '#';
        }
        if (permissionLevel == 'ALL') {
            if (user?.['role'] == 'Guest' && (type == `two-minute-test-${company?.['testType']}` || type == "kpi-report")) return '#';
            if (type == 'directors-questionnaire') return '#';
            return `#${type}`;
        }
    };
    const MODULE_NEW_DASHBOARD = {
        "investment": {
            letsOrganise: {
                "business-audit": {
                    title: 'Business Audit',
                    menus: [
                        'listOfSections',
                        'seeMore',
                        'howItWorks'
                    ],
                    type: `business-audit-${company?.testType}`,
                    module: company?.['modules']?.["business-audit-" + company.testType],
                    aboveTitle: company?.['liteToPro'] && company?.['modules']?.["business-audit-" + company.testType]['stats']['completionPercent'] === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 op50",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Not started"
                    }) : company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '30 mins',
                    subscription: company?.['subscription'] === "Pro" ? "PRO" : 'LITE',
                    isCompleteness: true,
                    isCertification: true,
                    isRisk: true,
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "20 section review bespoked to ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " your business"
                        ]
                    }),
                    tooltip: [
                        'Key Shareholder/Investor Documents',
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "59",
                            viewBox: "0 0 65 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Business Audit Lite"
                        }),
                        points: [
                            'Step by step audit of your business',
                            'Quick - multiple choice questions',
                            'Individually bespoked to your business, industry, stage of development and objective',
                            'At a glance Red/Amber/Green status',
                            'Both section and overall completeness and risk scores',
                            'Quickly identify strengths and weaknesses',
                            'Risks and recommendations for each section',
                            'All in real-time',
                            'Improvement tracking over time'
                        ],
                        image: (parcelRequire("izGj8"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Business Audit"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("dCQNv")),
                            (parcelRequire("ltgw0")),
                            (parcelRequire("aydTN"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "data-repository": {
                    title: 'Data Repository',
                    menus: [
                        'listOfSections',
                        'seeMore',
                        'howItWorks'
                    ],
                    type: 'repository',
                    module: company?.['modules']?.["repository"],
                    aboveTitle: company?.['liteToPro'] && company?.['modules']?.["repository"]['stats']['completionPercent'] === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 op50",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Not started"
                    }) : company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '2 Days',
                    subscription: company?.['subscription'] === "Pro" ? "PRO" : 'LITE',
                    isCompleteness: true,
                    isCertification: true,
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Complete your Data Repository",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " with all your key docs"
                        ]
                    }),
                    tooltip: [
                        'Key Shareholder/Investor Documents',
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "70",
                            height: "59",
                            viewBox: "0 0 70 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                                fill: "#4A67FF"
                            })
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Data Repository Lite"
                        }),
                        points: [
                            "All your key corporate documents in one place \u2013 easily accessible to all",
                            '20 sections (Lite)',
                            "Not created one before? No worries \u2013 checklists take you through each section",
                            'Completeness scoring',
                            'Prepopulated docs from UK Companies House where available (UK companies only)',
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to your chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    })
                                ]
                            }),
                            'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                        ],
                        image: (parcelRequire("3Unna"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            children: [
                                "First time? ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c3",
                                    children: "3 Ways to populate your Data Repository"
                                })
                            ]
                        }),
                        arrayImages: [
                            (parcelRequire("gDAuw")),
                            (parcelRequire("2oIlR")),
                            (parcelRequire("fqHfJ"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "workflow-manager": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Workflow Manager"
                    }),
                    subscription: 'PRO',
                    companyDashboardTab: 'Workflows',
                    logo: (parcelRequire("duikr")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "AI analyses and prioritises your",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " remediation of issues "
                        ]
                    })
                },
                "anylist-builder": {
                    title: 'AnyList Builder',
                    subscription: 'PRO',
                    menus: [
                        'seeMore',
                        'howItWorks'
                    ],
                    type: 'anylist-builder',
                    companyDashboardTab: 'AnyLists',
                    time: '5 mins',
                    logo: (parcelRequire("ZkulW")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c78",
                                children: "Unlock"
                            }),
                            " build own checklists on ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " anything"
                        ]
                    }),
                    isCompleteness: true,
                    isRisk: true,
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "FREE - Anylist Checklist ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Builder"
                            ]
                        }),
                        points: [
                            'Undertaking M&A? Create relevant automated due diligence checklists bespoked to target company',
                            `10 sections; 10 questions per section`,
                            `You can add your own questions and desired answers`,
                            `Questions: can choose subjective, objective or a mixture`,
                            `Completeness and risk scoring`,
                            `Reporting`,
                            `Workflow Manager: Can send to target company and monitor completeness`
                        ],
                        image: (parcelRequire("lB7oR")),
                        imageStyle: {
                            height: '90%',
                            width: '94%'
                        }
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "AnyList Checklist Builder"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("1PiK1")),
                            (parcelRequire("jcfD1")),
                            (parcelRequire("4CdTy"))
                        ],
                        checkList: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Quick and easy for you"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Quick and easy for your target user"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Reusable by the target company"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Company gains value from completion - risks & recommendations"
                                    })
                                ]
                            })
                        ],
                        btnContent: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "new-shadow bg4 bg3-hover c1 td250 br30px p1rem fw600 cp ttu bsbb tac df jcc aic w250px",
                            children: "Let\u2019s Go!"
                        })
                    }
                },
                "two-minute-test": {
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "kpi": {
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "61",
                            viewBox: "0 0 65 61",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.2344 23.8359H25.4996L30.2058 28.5422C30.6631 28.9951 31.4732 29.0629 32.0013 28.5422L36.7076 23.8359H46.9727C47.6738 23.8359 48.2422 23.2676 48.2422 22.5664V2.25391C48.2422 1.55274 47.6738 0.984375 46.9727 0.984375H15.2344C14.5332 0.984375 13.9648 1.55274 13.9648 2.25391V22.5664C13.9648 23.2676 14.5332 23.8359 15.2344 23.8359ZM16.5039 3.52344H45.7031V21.2969H36.1816C35.845 21.2969 35.522 21.4307 35.284 21.6687L31.1035 25.8492L26.9231 21.6687C26.685 21.4307 26.3621 21.2969 26.0254 21.2969H16.5039V3.52344Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M60.8196 50.2333C60.3238 49.7375 59.52 49.7375 59.0241 50.2333C58.5283 50.729 58.5283 51.5329 59.0241 52.0288L60.6654 53.6701H6.34766V5.3189L7.98903 6.96028C8.44632 7.41312 9.25641 7.48092 9.78453 6.96028C10.2803 6.46453 10.2803 5.66066 9.78453 5.16478L5.97594 1.35619C5.48019 0.860437 4.67632 0.860437 4.18044 1.35619L0.371846 5.16478C-0.123906 5.66053 -0.123906 6.4644 0.371846 6.96028C0.867598 7.45603 1.67147 7.45603 2.16734 6.96028L3.80859 5.3189V9.99814H1.26953C0.568369 9.99814 0 10.5665 0 11.2677C0 11.9688 0.568369 12.5372 1.26953 12.5372H3.80859V16.3458H1.26953C0.568369 16.3458 0 16.9142 0 17.6153C0 18.3165 0.568369 18.8849 1.26953 18.8849H3.80859V22.6935H1.26953C0.568369 22.6935 0 23.2618 0 23.963C0 24.6641 0.568369 25.2325 1.26953 25.2325H3.80859V29.0411H1.26953C0.568369 29.0411 0 29.6095 0 30.3106C0 31.0118 0.568369 31.5802 1.26953 31.5802H3.80859V35.3888H1.26953C0.568369 35.3888 0 35.9571 0 36.6583C0 37.3595 0.568369 37.9278 1.26953 37.9278H3.80859V41.7364H1.26953C0.568369 41.7364 0 42.3048 0 43.006C0 43.7071 0.568369 44.2755 1.26953 44.2755H3.80859V48.0841H1.26953C0.568369 48.0841 0 48.6525 0 49.3536C0 50.0548 0.568369 50.6231 1.26953 50.6231H3.80859V54.9395C3.80859 55.6407 4.37696 56.2091 5.07813 56.2091H9.14063V58.7481C9.14063 59.4493 9.70899 60.0177 10.4102 60.0177C11.1113 60.0177 11.6797 59.4493 11.6797 58.7481V56.2091H15.4883V58.7481C15.4883 59.4493 16.0567 60.0177 16.7578 60.0177C17.459 60.0177 18.0273 59.4493 18.0273 58.7481V56.2091H21.8359V58.7481C21.8359 59.4493 22.4043 60.0177 23.1055 60.0177C23.8066 60.0177 24.375 59.4493 24.375 58.7481V56.2091H28.1836V58.7481C28.1836 59.4493 28.752 60.0177 29.4531 60.0177C30.1543 60.0177 30.7227 59.4493 30.7227 58.7481V56.2091H34.5313V58.7481C34.5313 59.4493 35.0996 60.0177 35.8008 60.0177C36.5019 60.0177 37.0703 59.4493 37.0703 58.7481V56.2091H40.8789V58.7481C40.8789 59.4493 41.4473 60.0177 42.1484 60.0177C42.8496 60.0177 43.418 59.4493 43.418 58.7481V56.2091H47.2266V58.7481C47.2266 59.4493 47.7949 60.0177 48.4961 60.0177C49.1973 60.0177 49.7656 59.4493 49.7656 58.7481V56.2091H53.5742V58.7481C53.5742 59.4493 54.1426 60.0177 54.8438 60.0177C55.5449 60.0177 56.1133 59.4493 56.1133 58.7481V56.2091H60.6656L59.0242 57.8505C58.5284 58.3462 58.5284 59.1501 59.0242 59.646C59.4815 60.0988 60.2916 60.1666 60.8197 59.646L64.6283 55.8374C65.124 55.3416 65.124 54.5377 64.6283 54.0419L60.8196 50.2333Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M26.1527 18.7578C26.4563 18.7578 26.7607 18.6496 27.0036 18.4301C27.5238 17.96 27.5643 17.1572 27.0942 16.6371L23.0877 12.2041L26.7589 8.33395C27.2415 7.82524 27.2203 7.02176 26.7116 6.53921C26.2029 6.05666 25.3994 6.07786 24.9168 6.58656L22.3438 9.29904V7.33203C22.3438 6.63087 21.7754 6.0625 21.0742 6.0625C20.3731 6.0625 19.8047 6.63087 19.8047 7.33203V17.4883C19.8047 18.1894 20.3731 18.7578 21.0742 18.7578C21.7754 18.7578 22.3438 18.1894 22.3438 17.4883V15.1676L25.2105 18.3395C25.4611 18.6169 25.8063 18.7578 26.1527 18.7578Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M30.9766 18.7578C31.6777 18.7578 32.2461 18.1894 32.2461 17.4883V13.6797H33.5156C35.6157 13.6797 37.3242 11.9712 37.3242 9.87109C37.3242 7.77104 35.6157 6.0625 33.5156 6.0625H30.9766C30.2754 6.0625 29.707 6.63087 29.707 7.33203V17.4883C29.707 18.1894 30.2754 18.7578 30.9766 18.7578ZM32.2461 8.60156H33.5156C34.2156 8.60156 34.7852 9.17107 34.7852 9.87109C34.7852 10.5711 34.2156 11.1406 33.5156 11.1406H32.2461V8.60156Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M41.1328 8.60156C41.834 8.60156 42.4023 8.03317 42.4023 7.33203C42.4023 6.63089 41.834 6.0625 41.1328 6.0625C40.4317 6.0625 39.8633 6.63089 39.8633 7.33203C39.8633 8.03317 40.4317 8.60156 41.1328 8.60156Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M41.1328 18.7559C41.8323 18.7559 42.4023 18.1858 42.4023 17.4863V13.043C42.4023 12.3435 41.8323 11.7734 41.1328 11.7734C40.4333 11.7734 39.8633 12.3435 39.8633 13.043V17.4863C39.8633 18.1858 40.4333 18.7559 41.1328 18.7559Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M63.7305 18.7578H56.1133C55.4121 18.7578 54.8438 19.3262 54.8438 20.0273C54.8438 20.7285 55.4121 21.2969 56.1133 21.2969H60.7709L55.6067 26.7241C55.1694 27.1682 55.1203 28.027 55.6512 28.518C56.085 28.9491 56.957 29.0075 57.4463 28.4735L62.4609 23.2026V27.6445C62.4609 28.3457 63.0293 28.9141 63.7305 28.9141C64.4316 28.9141 65 28.3457 65 27.6445V20.0273C65 19.3262 64.4316 18.7578 63.7305 18.7578Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M43.4929 39.4569L39.3154 37.6291C39.341 37.4366 39.3555 37.2405 39.3555 37.041C39.3555 34.5909 37.3622 32.5976 34.9121 32.5976C33.5385 32.5976 32.3086 33.2244 31.4928 34.2069L23.9952 30.9268C23.4587 30.6923 22.8319 30.8547 22.4771 31.3198L9.4009 48.4585C8.97561 49.016 9.08276 49.8126 9.64008 50.2379C10.1263 50.619 10.9747 50.5862 11.4195 49.9987L23.8908 33.6526L30.4973 36.5429C30.4789 36.7066 30.4686 36.8726 30.4686 37.0411C30.4686 39.4912 32.4619 41.4845 34.912 41.4845C36.2531 41.4845 37.4564 40.8864 38.2718 39.9439L43.2896 42.1394C43.4509 42.2105 43.621 42.2461 43.7975 42.2461C44.144 42.2461 44.4805 42.1026 44.7191 41.8512L49.57 36.7528C50.0083 36.3087 50.0546 35.4503 49.5256 34.9589C49.0914 34.529 48.2202 34.4678 47.7305 35.0034L43.4929 39.4569ZM34.9121 38.9453C33.8621 38.9453 33.0078 38.091 33.0078 37.041C33.0078 35.9909 33.8621 35.1367 34.9121 35.1367C35.9622 35.1367 36.8164 35.9909 36.8164 37.041C36.8164 38.091 35.9622 38.9453 34.9121 38.9453Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.5898 33.0078C53.291 33.0078 53.8594 32.4394 53.8594 31.7383C53.8594 31.0371 53.291 30.4688 52.5898 30.4688C51.8887 30.4688 51.3203 31.0371 51.3203 31.7383C51.3203 32.4394 51.8887 33.0078 52.5898 33.0078Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Free Key Performance",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                " Indicators (KPI) Report"
                            ]
                        }),
                        points: [
                            'AI generated list of Key Performance Indicators',
                            'Specifically generated for your business',
                            'Based on your industry',
                            'For each KPI, we explain the KPI, how to calculate it, and what the target benchmark is'
                        ],
                        image: (parcelRequire("kk8Qe"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "KPI Report"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("bLZ0V")),
                            (parcelRequire("k6BF8")),
                            (parcelRequire("l4ysc"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "*= not guaranteed!"
                        })
                    }
                },
                "warranty-disclosure": {
                    id: 'DEPF006',
                    menus: [
                        'listOfSections',
                        'report',
                        'seeMore',
                        'howItWorks'
                    ],
                    hideBuyButton: true,
                    type: 'warranty-disclosure',
                    module: company?.['modules']?.["warranty-disclosure"],
                    isBuy: !company?.['modules']?.["warranty-disclosure"],
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Draft Warranty Disclosures"
                    }),
                    aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '30 mins',
                    isCertification: true,
                    price: "\xa3500",
                    isCompleteness: true,
                    isRisk: true,
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Save time and legal cost pre-",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "investment"
                        ]
                    }),
                    tooltip: [
                        'Share Capital And Authority',
                        'Information',
                        'Business Plan',
                        'Accounts',
                        'Management Accounts',
                        'Events Since The Accounts Date',
                        'Taxation',
                        'Litigation',
                        'Properties',
                        'Intellectual Property',
                        'Assets, Debt & Stock',
                        'Contracts With Connected Persons',
                        'Employment and Consultancy Arrangements',
                        'Statutory & Legal Requirements',
                        'Records & Registers',
                        'Insurance',
                        'Group Structure',
                        'Agreements & Capital Commitments',
                        'Borrowings & Facilities',
                        'Social Obligations'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557715-expansion-pack-warranty-disclosure-module',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "65",
                            viewBox: "0 0 65 65",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.2324 50.4004C45.2841 50.4004 46.1367 49.5478 46.1367 48.4961V38.9746C46.1367 37.9229 45.2841 37.0703 44.2324 37.0703C43.1807 37.0703 42.3281 37.9229 42.3281 38.9746V48.4961C42.3281 49.5478 43.1806 50.4004 44.2324 50.4004Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.2324 57.3828C45.2841 57.3828 46.1367 56.5302 46.1367 55.4785C46.1367 54.4268 45.2841 53.5742 44.2324 53.5742C43.1807 53.5742 42.3281 54.4268 42.3281 55.4785C42.3281 56.5302 43.1807 57.3828 44.2324 57.3828Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.2492 56.4708L53.0864 36.7718C54.0841 33.1317 54.5899 29.3753 54.5899 25.5931V4.44314C54.5899 2.99778 53.0427 2.0794 51.7738 2.77168L51.2295 3.06862C43.9058 7.06359 34.7955 6.02371 28.5602 0.481185L28.5599 0.480931C27.8384 -0.16031 26.7513 -0.16031 26.03 0.480931L26.0297 0.481185C19.7944 6.02384 10.6844 7.06346 3.36058 3.06875L2.81608 2.77168C1.54718 2.0794 0 2.99778 0 4.44314V25.5931C0 34.0789 2.51469 42.2785 7.27201 49.3054C12.0296 56.3323 18.7087 61.7123 26.5876 64.8639C27.0322 65.0418 27.5269 65.0443 27.9737 64.8737C28.361 64.9557 28.7658 65 29.1862 65H59.2788C63.6562 65.0001 66.4072 60.2791 64.2492 56.4708ZM25.3907 51.4362C18.8667 47.1952 14.2664 40.7043 12.3796 33.2618H25.3907V51.4362ZM25.3907 29.4533H11.6638C11.5067 28.1844 11.4258 26.896 11.4258 25.5932V16.8827C11.9016 16.9045 12.3776 16.9155 12.8515 16.9155C17.1728 16.9155 21.4508 16.0128 25.3907 14.2899V29.4533ZM26.3579 9.55809C22.2503 11.8799 17.5799 13.1072 12.8515 13.1072C11.8149 13.1072 10.7678 13.0472 9.7391 12.9287C8.6087 12.7984 7.6172 13.6823 7.6172 14.8202V25.5932C7.6172 38.0309 14.137 49.3276 24.7563 55.517L24.2158 56.4706C23.7207 57.3443 23.4867 58.2659 23.4687 59.1678C11.3821 52.4258 3.8086 39.7285 3.8086 25.5931V7.49815C6.70885 8.69811 9.77744 9.2873 12.835 9.28705C17.9808 9.28679 23.0919 7.6166 27.295 4.37573C33.9954 9.54248 43 10.7177 50.7813 7.49815V25.5932C50.7813 27.6811 50.6118 29.7602 50.276 31.8122L49.2029 29.9185C48.6296 28.9068 47.8236 28.1628 46.9082 27.6812C46.9495 26.9846 46.9727 26.2866 46.9727 25.5932V14.8202C46.9727 13.6823 45.9813 12.7984 44.8509 12.9286C43.8222 13.047 42.775 13.1071 41.7384 13.1071C37.0101 13.1071 32.3397 11.8798 28.232 9.55797C27.6506 9.22941 26.9394 9.22941 26.3579 9.55809ZM29.1993 29.4533V14.29C33.139 16.0128 37.4169 16.9157 41.7384 16.9157C42.2124 16.9157 42.6883 16.9046 43.1641 16.8828V25.5933C43.1641 26.1033 43.1508 26.6163 43.1257 27.1289C41.7444 27.3967 40.4496 28.1726 39.5584 29.4533H29.1993ZM37.3676 33.2619L29.1993 47.6766V33.2619H37.3676ZM59.2788 61.1915H29.1863C27.7272 61.1915 26.8101 59.6178 27.5296 58.3484L42.5758 31.7963C43.3053 30.5089 45.16 30.5089 45.8894 31.7963L60.9357 58.3484C61.6549 59.6178 60.7379 61.1915 59.2788 61.1915Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Expansion Pack - ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Warranty Disclosure"
                            ]
                        }),
                        points: [
                            "Save thousands on lawyers\u2019 fees",
                            'Normally an expensive exercise at the end of a transaction',
                            'Get ahead, early completion will identify showstoppers and give you time to fix them',
                            'Based on the UK BVCA standard disclosure letter',
                            'Contributes to Diligentsia certification',
                            'Part of DD Pack available to investors'
                        ],
                        image: (parcelRequire("bnaJ5"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Warranty Disclosure"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("2mFD2")),
                            (parcelRequire("ca6j0")),
                            (parcelRequire("5fyAg"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "directors-questionnaires": {
                    id: 'DEPF007',
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Draft Directors\u2019 Questionnaires"
                    }),
                    menus: [
                        'report',
                        'seeMore',
                        'howItWorks'
                    ],
                    aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    type: 'directors-questionnaire',
                    isCertification: true,
                    module: company?.['modules']?.[`directors-questionnaire_${directors?.[0]?.['_id']}`],
                    directorsStats: company['directorsStats'],
                    information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "Save time and cost pre-investment"
                    }),
                    isRisk: true,
                    isCompleteness: true,
                    price: "\xa3250",
                    isBuy: !company?.['modules']?.[`directors-questionnaire_${directors?.[0]?.['_id']}`],
                    time: '15 mins',
                    tooltip: directors && directors.length > 0 && directors.map((d)=>typeof d === 'object' ? d.name || '' : d).filter(Boolean),
                    helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557468-directors-questionnaire-module',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Expansion Pack - ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Directors\u2019 Questionnaires"
                            ]
                        }),
                        points: [
                            'Normally part of purchase/sale or investment',
                            'Identify any issues in advance - time for rectification',
                            'Pre-population from Companies House where relevant',
                            'Completeness and risk scoring',
                            'Impress your counterparty with your organisation',
                            'Contributes to Diligentsia certification'
                        ],
                        image: (parcelRequire("3e8So"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Directors\u2019 Questionnaires"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("5NBD1")),
                            (parcelRequire("gw040")),
                            (parcelRequire("77FeN"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                }
            },
            proveOurValue: {
                "research-aid-report": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            }),
                            " Builder"
                        ]
                    }),
                    logo: (parcelRequire("ZkulW")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Edit/update existing reports. ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Generate your own reports"
                        ]
                    }),
                    subscription: 'PRO',
                    companyDashboardTab: 'ResearchAid',
                    time: '5 mins'
                },
                "market-opportunity": {
                    title: 'Market Opportunity',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'marketReport')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?marketReport`
                },
                "route-to-market": {
                    title: 'Route to Market',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'routeToMarketReport')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?routeToMarketReport`
                },
                "technology-advantage": {
                    title: 'Technology Advantage',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'TCAR3')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?TCAR3`
                },
                "swot": {
                    title: 'SWOT',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'swotAnalysis')?.[0] || null,
                    isReseachAid: true,
                    openModal: 'swotReportPopup'
                }
            },
            getPitching: {
                "diligence-pack": {
                    title: 'Diligence Pack',
                    menus: [
                        'seeMore',
                        'howItWorks'
                    ],
                    information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "See your diligence reports and files in one place - as third parties will see them"
                    }),
                    subscription: 'PRO',
                    type: '#diligence-pack',
                    link: `/company/${company?.['_id']}#diligence-pack`,
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.2423 4.99219C38.0392 4.99219 26.4843 16.5471 26.4843 30.7502C26.4843 35.4448 27.7474 39.8496 29.9507 43.6439L6.94712 66.6474C4.35096 69.2434 4.35096 73.4677 6.94712 76.0637C8.24505 77.3618 9.95015 78.0108 11.6551 78.0108C13.3601 78.0108 15.0653 77.3619 16.3631 76.0637L39.3714 53.0553C43.1605 55.2502 47.557 56.5081 52.242 56.5081C66.4452 56.5081 78.0001 44.953 78.0001 30.7501C78.0001 16.5471 66.4454 4.99219 52.2423 4.99219ZM13.3351 73.0356C12.4087 73.962 10.9015 73.962 9.97525 73.0357C9.04897 72.1094 9.04897 70.6021 9.97525 69.6757L11.4192 68.2317L14.7791 71.5916L13.3351 73.0356ZM17.8072 68.5636L14.4474 65.2037L16.7667 62.8844L20.1265 66.2444L17.8072 68.5636ZM23.1545 63.2161L19.7947 59.8561L32.4432 47.2076C33.4586 48.4271 34.5841 49.5519 35.8046 50.5661L23.1545 63.2161ZM52.2423 52.2257C40.4006 52.2257 30.7669 42.5918 30.7669 30.7502C30.7669 18.9087 40.4006 9.27476 52.2423 9.27476C64.084 9.27476 73.7178 18.9085 73.7178 30.7502C73.7178 42.5919 64.084 52.2257 52.2423 52.2257Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M59.5703 27.024C59.5703 25.8415 58.6117 24.8828 57.4291 24.8828L43.216 24.8828C42.0334 24.8828 41.0748 25.8415 41.0748 27.024C41.0748 28.2066 42.0334 29.1652 43.216 29.1652L57.4291 29.1652C58.6117 29.1654 59.5703 28.2066 59.5703 27.024Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.2187 19.5318C64.2187 18.3493 63.2601 17.3906 62.0775 17.3906L43.2121 17.3906C42.0295 17.3906 41.0709 18.3493 41.0709 19.5318C41.0709 20.7144 42.0295 21.6731 43.2121 21.6731L62.0775 21.6731C63.2601 21.6732 64.2187 20.7144 64.2187 19.5318Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: `Due Diligence Pack`,
                        subMenu: {
                            index: 0,
                            points: [
                                '- Data Repository Report',
                                '- 20-sections Business Audit',
                                "- Directors\u2019 questionnaires",
                                '- Draft Warranty Disclosures '
                            ]
                        },
                        points: [
                            `Pulls together a complete pack of each of the key completed modules' reports:`,
                            `Tracks the sending of the DD Pack to investors introduced through the platform`
                        ],
                        notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                fontSize: "14px",
                                color: 'gray',
                                fontStyle: 'italic'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontWeight: "bold",
                                        fontStyle: 'normal'
                                    },
                                    children: `Please Note: `
                                }),
                                "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice"
                            ]
                        }),
                        image: (parcelRequire("7J3ig")),
                        imageStyle: {
                            height: '90%',
                            width: '94%'
                        }
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Diligence Pack"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("k6VNW")),
                            (parcelRequire("3ASou")),
                            (parcelRequire("illzP"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w40 df jcc mla mra",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "icon mx1-5rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("aFTOQ")),
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        })
                    }
                },
                "pitch-deck-analyser": {
                    title: 'Corporate Deck Analyser',
                    information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "Coming Soon: Analysis of your corporate deck - giving you the chance to improve it"
                    }),
                    subscription: 'PRO',
                    time: '5 mins',
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                    comingSoon: true,
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "70",
                            height: "59",
                            viewBox: "0 0 70 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                                fill: "#4A67FF"
                            })
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Data Repository Lite"
                        }),
                        points: [
                            "All your key corporate documents in one place \u2013 easily accessible to all",
                            '20 sections (Lite)',
                            "Not created one before? No worries \u2013 checklists take you through each section",
                            'Completeness scoring',
                            'Prepopulated docs from UK Companies House where available (UK companies only)',
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to your chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    })
                                ]
                            }),
                            'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                        ],
                        image: (parcelRequire("3Unna"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            children: [
                                "First time? ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c3",
                                    children: "3 Ways to populate your Data Repository"
                                })
                            ]
                        }),
                        arrayImages: [
                            (parcelRequire("gDAuw")),
                            (parcelRequire("2oIlR")),
                            (parcelRequire("fqHfJ"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "investorMatch": {
                    title: 'InvestorMatch',
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Get matched and connect with",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " investors"
                        ]
                    }),
                    companyDashboardTab: 'InvestorMatch',
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "investorManagement": {
                    title: 'Investor Management',
                    type: 'share-diligence-pack',
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Track diligence packs sent to",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " investors NOT already on platform"
                        ]
                    }),
                    subscription: 'PRO'
                }
            }
        },
        "growth": {
            letsOrganise: {
                "business-audit": {
                    title: 'Business Audit',
                    menus: [
                        'listOfSections',
                        'seeMore',
                        'howItWorks'
                    ],
                    isCertification: true,
                    type: `business-audit-${company?.testType}`,
                    module: company?.['modules']?.["business-audit-" + company.testType],
                    aboveTitle: company?.['liteToPro'] && company?.['modules']?.["business-audit-" + company.testType]['stats']['completionPercent'] === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 op50",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Not started"
                    }) : company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '2 mins',
                    subscription: company?.['subscription'] === "Pro" ? "PRO" : 'LITE',
                    isCompleteness: true,
                    isRisk: true,
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "20 section review bespoked to ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " your business"
                        ]
                    }),
                    tooltip: [
                        'Key Shareholder/Investor Documents',
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "59",
                            viewBox: "0 0 65 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Business Audit Lite"
                        }),
                        points: [
                            'Step by step audit of your business',
                            'Quick - multiple choice questions',
                            'Individually bespoked to your business, industry, stage of development and objective',
                            'At a glance Red/Amber/Green status',
                            'Both section and overall completeness and risk scores',
                            'Quickly identify strengths and weaknesses',
                            'Risks and recommendations for each section',
                            'All in real-time',
                            'Improvement tracking over time'
                        ],
                        image: (parcelRequire("izGj8"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Business Audit"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("dCQNv")),
                            (parcelRequire("ltgw0")),
                            (parcelRequire("aydTN"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "data-repository": {
                    title: 'Data Repository',
                    menus: [
                        'listOfSections',
                        'seeMore',
                        'howItWorks'
                    ],
                    type: 'repository',
                    isCertification: true,
                    module: company?.['modules']?.["repository"],
                    aboveTitle: company?.['liteToPro'] && company?.['modules']?.["repository"]['stats']['completionPercent'] === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 op50",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Not started"
                    }) : company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '2 Days',
                    subscription: company?.['subscription'] === "Pro" ? "PRO" : 'LITE',
                    isCompleteness: true,
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Complete your Data Repository",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " with all your key docs"
                        ]
                    }),
                    tooltip: [
                        'Key Shareholder/Investor Documents',
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "70",
                            height: "59",
                            viewBox: "0 0 70 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                                fill: "#4A67FF"
                            })
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Data Repository Lite"
                        }),
                        points: [
                            "All your key corporate documents in one place \u2013 easily accessible to all",
                            '20 sections (Lite)',
                            "Not created one before? No worries \u2013 checklists take you through each section",
                            'Completeness scoring',
                            'Prepopulated docs from UK Companies House where available (UK companies only)',
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to your chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    })
                                ]
                            }),
                            'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                        ],
                        image: (parcelRequire("3Unna"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            children: [
                                "First time? ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c3",
                                    children: "3 Ways to populate your Data Repository"
                                })
                            ]
                        }),
                        arrayImages: [
                            (parcelRequire("gDAuw")),
                            (parcelRequire("2oIlR")),
                            (parcelRequire("fqHfJ"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "workflow-manager": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Workflow Manager"
                    }),
                    subscription: 'PRO',
                    companyDashboardTab: 'Workflows',
                    logo: (parcelRequire("duikr")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "AI analyses and prioritises your",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " remediation of issues "
                        ]
                    })
                },
                "anylist-builder": {
                    title: "AnyList Builder",
                    menus: [
                        'seeMore',
                        'howItWorks'
                    ],
                    subscription: 'PRO',
                    companyDashboardTab: 'AnyLists',
                    time: '5 mins',
                    type: 'anylist-builder',
                    logo: (parcelRequire("ZkulW")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c78",
                                children: "Unlock"
                            }),
                            " build own checklists on ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " anything"
                        ]
                    }),
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "FREE - Anylist Checklist ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Builder"
                            ]
                        }),
                        points: [
                            'Undertaking M&A? Create relevant automated due diligence checklists bespoked to target company',
                            `10 sections; 10 questions per section`,
                            `You can add your own questions and desired answers`,
                            `Questions: can choose subjective, objective or a mixture`,
                            `Completeness and risk scoring`,
                            `Reporting`,
                            `Workflow Manager: Can send to target company and monitor completeness`
                        ],
                        image: (parcelRequire("lB7oR")),
                        imageStyle: {
                            height: '90%',
                            width: '94%'
                        }
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "AnyList Checklist Builder"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("1PiK1")),
                            (parcelRequire("jcfD1")),
                            (parcelRequire("4CdTy"))
                        ],
                        checkList: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Quick and easy for you"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Quick and easy for your target user"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Reusable by the target company"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Company gains value from completion - risks & recommendations"
                                    })
                                ]
                            })
                        ],
                        btnContent: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "new-shadow bg4 bg3-hover c1 td250 br30px p1rem fw600 cp ttu bsbb tac df jcc aic w250px",
                            children: "Let\u2019s Go!"
                        })
                    }
                },
                "two-minute-test": {
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "kpi": {
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "61",
                            viewBox: "0 0 65 61",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.2344 23.8359H25.4996L30.2058 28.5422C30.6631 28.9951 31.4732 29.0629 32.0013 28.5422L36.7076 23.8359H46.9727C47.6738 23.8359 48.2422 23.2676 48.2422 22.5664V2.25391C48.2422 1.55274 47.6738 0.984375 46.9727 0.984375H15.2344C14.5332 0.984375 13.9648 1.55274 13.9648 2.25391V22.5664C13.9648 23.2676 14.5332 23.8359 15.2344 23.8359ZM16.5039 3.52344H45.7031V21.2969H36.1816C35.845 21.2969 35.522 21.4307 35.284 21.6687L31.1035 25.8492L26.9231 21.6687C26.685 21.4307 26.3621 21.2969 26.0254 21.2969H16.5039V3.52344Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M60.8196 50.2333C60.3238 49.7375 59.52 49.7375 59.0241 50.2333C58.5283 50.729 58.5283 51.5329 59.0241 52.0288L60.6654 53.6701H6.34766V5.3189L7.98903 6.96028C8.44632 7.41312 9.25641 7.48092 9.78453 6.96028C10.2803 6.46453 10.2803 5.66066 9.78453 5.16478L5.97594 1.35619C5.48019 0.860437 4.67632 0.860437 4.18044 1.35619L0.371846 5.16478C-0.123906 5.66053 -0.123906 6.4644 0.371846 6.96028C0.867598 7.45603 1.67147 7.45603 2.16734 6.96028L3.80859 5.3189V9.99814H1.26953C0.568369 9.99814 0 10.5665 0 11.2677C0 11.9688 0.568369 12.5372 1.26953 12.5372H3.80859V16.3458H1.26953C0.568369 16.3458 0 16.9142 0 17.6153C0 18.3165 0.568369 18.8849 1.26953 18.8849H3.80859V22.6935H1.26953C0.568369 22.6935 0 23.2618 0 23.963C0 24.6641 0.568369 25.2325 1.26953 25.2325H3.80859V29.0411H1.26953C0.568369 29.0411 0 29.6095 0 30.3106C0 31.0118 0.568369 31.5802 1.26953 31.5802H3.80859V35.3888H1.26953C0.568369 35.3888 0 35.9571 0 36.6583C0 37.3595 0.568369 37.9278 1.26953 37.9278H3.80859V41.7364H1.26953C0.568369 41.7364 0 42.3048 0 43.006C0 43.7071 0.568369 44.2755 1.26953 44.2755H3.80859V48.0841H1.26953C0.568369 48.0841 0 48.6525 0 49.3536C0 50.0548 0.568369 50.6231 1.26953 50.6231H3.80859V54.9395C3.80859 55.6407 4.37696 56.2091 5.07813 56.2091H9.14063V58.7481C9.14063 59.4493 9.70899 60.0177 10.4102 60.0177C11.1113 60.0177 11.6797 59.4493 11.6797 58.7481V56.2091H15.4883V58.7481C15.4883 59.4493 16.0567 60.0177 16.7578 60.0177C17.459 60.0177 18.0273 59.4493 18.0273 58.7481V56.2091H21.8359V58.7481C21.8359 59.4493 22.4043 60.0177 23.1055 60.0177C23.8066 60.0177 24.375 59.4493 24.375 58.7481V56.2091H28.1836V58.7481C28.1836 59.4493 28.752 60.0177 29.4531 60.0177C30.1543 60.0177 30.7227 59.4493 30.7227 58.7481V56.2091H34.5313V58.7481C34.5313 59.4493 35.0996 60.0177 35.8008 60.0177C36.5019 60.0177 37.0703 59.4493 37.0703 58.7481V56.2091H40.8789V58.7481C40.8789 59.4493 41.4473 60.0177 42.1484 60.0177C42.8496 60.0177 43.418 59.4493 43.418 58.7481V56.2091H47.2266V58.7481C47.2266 59.4493 47.7949 60.0177 48.4961 60.0177C49.1973 60.0177 49.7656 59.4493 49.7656 58.7481V56.2091H53.5742V58.7481C53.5742 59.4493 54.1426 60.0177 54.8438 60.0177C55.5449 60.0177 56.1133 59.4493 56.1133 58.7481V56.2091H60.6656L59.0242 57.8505C58.5284 58.3462 58.5284 59.1501 59.0242 59.646C59.4815 60.0988 60.2916 60.1666 60.8197 59.646L64.6283 55.8374C65.124 55.3416 65.124 54.5377 64.6283 54.0419L60.8196 50.2333Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M26.1527 18.7578C26.4563 18.7578 26.7607 18.6496 27.0036 18.4301C27.5238 17.96 27.5643 17.1572 27.0942 16.6371L23.0877 12.2041L26.7589 8.33395C27.2415 7.82524 27.2203 7.02176 26.7116 6.53921C26.2029 6.05666 25.3994 6.07786 24.9168 6.58656L22.3438 9.29904V7.33203C22.3438 6.63087 21.7754 6.0625 21.0742 6.0625C20.3731 6.0625 19.8047 6.63087 19.8047 7.33203V17.4883C19.8047 18.1894 20.3731 18.7578 21.0742 18.7578C21.7754 18.7578 22.3438 18.1894 22.3438 17.4883V15.1676L25.2105 18.3395C25.4611 18.6169 25.8063 18.7578 26.1527 18.7578Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M30.9766 18.7578C31.6777 18.7578 32.2461 18.1894 32.2461 17.4883V13.6797H33.5156C35.6157 13.6797 37.3242 11.9712 37.3242 9.87109C37.3242 7.77104 35.6157 6.0625 33.5156 6.0625H30.9766C30.2754 6.0625 29.707 6.63087 29.707 7.33203V17.4883C29.707 18.1894 30.2754 18.7578 30.9766 18.7578ZM32.2461 8.60156H33.5156C34.2156 8.60156 34.7852 9.17107 34.7852 9.87109C34.7852 10.5711 34.2156 11.1406 33.5156 11.1406H32.2461V8.60156Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M41.1328 8.60156C41.834 8.60156 42.4023 8.03317 42.4023 7.33203C42.4023 6.63089 41.834 6.0625 41.1328 6.0625C40.4317 6.0625 39.8633 6.63089 39.8633 7.33203C39.8633 8.03317 40.4317 8.60156 41.1328 8.60156Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M41.1328 18.7559C41.8323 18.7559 42.4023 18.1858 42.4023 17.4863V13.043C42.4023 12.3435 41.8323 11.7734 41.1328 11.7734C40.4333 11.7734 39.8633 12.3435 39.8633 13.043V17.4863C39.8633 18.1858 40.4333 18.7559 41.1328 18.7559Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M63.7305 18.7578H56.1133C55.4121 18.7578 54.8438 19.3262 54.8438 20.0273C54.8438 20.7285 55.4121 21.2969 56.1133 21.2969H60.7709L55.6067 26.7241C55.1694 27.1682 55.1203 28.027 55.6512 28.518C56.085 28.9491 56.957 29.0075 57.4463 28.4735L62.4609 23.2026V27.6445C62.4609 28.3457 63.0293 28.9141 63.7305 28.9141C64.4316 28.9141 65 28.3457 65 27.6445V20.0273C65 19.3262 64.4316 18.7578 63.7305 18.7578Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M43.4929 39.4569L39.3154 37.6291C39.341 37.4366 39.3555 37.2405 39.3555 37.041C39.3555 34.5909 37.3622 32.5976 34.9121 32.5976C33.5385 32.5976 32.3086 33.2244 31.4928 34.2069L23.9952 30.9268C23.4587 30.6923 22.8319 30.8547 22.4771 31.3198L9.4009 48.4585C8.97561 49.016 9.08276 49.8126 9.64008 50.2379C10.1263 50.619 10.9747 50.5862 11.4195 49.9987L23.8908 33.6526L30.4973 36.5429C30.4789 36.7066 30.4686 36.8726 30.4686 37.0411C30.4686 39.4912 32.4619 41.4845 34.912 41.4845C36.2531 41.4845 37.4564 40.8864 38.2718 39.9439L43.2896 42.1394C43.4509 42.2105 43.621 42.2461 43.7975 42.2461C44.144 42.2461 44.4805 42.1026 44.7191 41.8512L49.57 36.7528C50.0083 36.3087 50.0546 35.4503 49.5256 34.9589C49.0914 34.529 48.2202 34.4678 47.7305 35.0034L43.4929 39.4569ZM34.9121 38.9453C33.8621 38.9453 33.0078 38.091 33.0078 37.041C33.0078 35.9909 33.8621 35.1367 34.9121 35.1367C35.9622 35.1367 36.8164 35.9909 36.8164 37.041C36.8164 38.091 35.9622 38.9453 34.9121 38.9453Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.5898 33.0078C53.291 33.0078 53.8594 32.4394 53.8594 31.7383C53.8594 31.0371 53.291 30.4688 52.5898 30.4688C51.8887 30.4688 51.3203 31.0371 51.3203 31.7383C51.3203 32.4394 51.8887 33.0078 52.5898 33.0078Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Free Key Performance",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                " Indicators (KPI) Report"
                            ]
                        }),
                        points: [
                            'AI generated list of Key Performance Indicators',
                            'Specifically generated for your business',
                            'Based on your industry',
                            'For each KPI, we explain the KPI, how to calculate it, and what the target benchmark is'
                        ],
                        image: (parcelRequire("kk8Qe"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "KPI Report"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("bLZ0V")),
                            (parcelRequire("k6BF8")),
                            (parcelRequire("l4ysc"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "*= not guaranteed!"
                        })
                    }
                }
            },
            proveOurValue: {
                "market-opportunity": {
                    title: 'Market Opportunity',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'marketReport')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?marketReport`
                },
                "route-to-market": {
                    title: 'Route to Market',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'routeToMarketReport')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?routeToMarketReport`
                },
                "technology-advantage": {
                    title: 'Technology Advantage',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'TCAR3')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?TCAR3`
                },
                "swot": {
                    title: 'SWOT',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'swotAnalysis')?.[0] || null,
                    isReseachAid: true,
                    openModal: 'swotReportPopup'
                },
                "research-aid-report": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            }),
                            " Builder"
                        ]
                    }),
                    logo: (parcelRequire("ZkulW")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Edit/update existing reports. ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Generate your own reports"
                        ]
                    }),
                    subscription: 'PRO',
                    companyDashboardTab: 'ResearchAid',
                    time: '5 mins'
                }
            },
            turboBoost: {
                "H - Enhancing Your Business Plan": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Enhancing Your Business ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Plan"
                        ]
                    }),
                    "type": "H - Enhancing Your Business Plan",
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    "module": company?.['modules']?.['H - Enhancing Your Business Plan'],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    time: '5 mins',
                    logo: (parcelRequire("lqLan")),
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.2423 4.99219C38.0392 4.99219 26.4843 16.5471 26.4843 30.7502C26.4843 35.4448 27.7474 39.8496 29.9507 43.6439L6.94712 66.6474C4.35096 69.2434 4.35096 73.4677 6.94712 76.0637C8.24505 77.3618 9.95015 78.0108 11.6551 78.0108C13.3601 78.0108 15.0653 77.3619 16.3631 76.0637L39.3714 53.0553C43.1605 55.2502 47.557 56.5081 52.242 56.5081C66.4452 56.5081 78.0001 44.953 78.0001 30.7501C78.0001 16.5471 66.4454 4.99219 52.2423 4.99219ZM13.3351 73.0356C12.4087 73.962 10.9015 73.962 9.97525 73.0357C9.04897 72.1094 9.04897 70.6021 9.97525 69.6757L11.4192 68.2317L14.7791 71.5916L13.3351 73.0356ZM17.8072 68.5636L14.4474 65.2037L16.7667 62.8844L20.1265 66.2444L17.8072 68.5636ZM23.1545 63.2161L19.7947 59.8561L32.4432 47.2076C33.4586 48.4271 34.5841 49.5519 35.8046 50.5661L23.1545 63.2161ZM52.2423 52.2257C40.4006 52.2257 30.7669 42.5918 30.7669 30.7502C30.7669 18.9087 40.4006 9.27476 52.2423 9.27476C64.084 9.27476 73.7178 18.9085 73.7178 30.7502C73.7178 42.5919 64.084 52.2257 52.2423 52.2257Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M59.5703 27.024C59.5703 25.8415 58.6117 24.8828 57.4291 24.8828L43.216 24.8828C42.0334 24.8828 41.0748 25.8415 41.0748 27.024C41.0748 28.2066 42.0334 29.1652 43.216 29.1652L57.4291 29.1652C58.6117 29.1654 59.5703 28.2066 59.5703 27.024Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.2187 19.5318C64.2187 18.3493 63.2601 17.3906 62.0775 17.3906L43.2121 17.3906C42.0295 17.3906 41.0709 18.3493 41.0709 19.5318C41.0709 20.7144 42.0295 21.6731 43.2121 21.6731L62.0775 21.6731C63.2601 21.6732 64.2187 20.7144 64.2187 19.5318Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: `Due Diligence Pack`,
                        subMenu: {
                            index: 0,
                            points: [
                                '- Data Repository Report',
                                '- 20-sections Business Audit',
                                "- Directors\u2019 questionnaires",
                                '- Draft Warranty Disclosures '
                            ]
                        },
                        points: [
                            `Pulls together a complete pack of each of the key completed modules' reports:`,
                            `Tracks the sending of the DD Pack to investors introduced through the platform`
                        ],
                        notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                fontSize: "14px",
                                color: 'gray',
                                fontStyle: 'italic'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontWeight: "bold",
                                        fontStyle: 'normal'
                                    },
                                    children: `Please Note: `
                                }),
                                "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice"
                            ]
                        }),
                        image: (parcelRequire("7J3ig")),
                        imageStyle: {
                            height: '90%',
                            width: '94%'
                        }
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Diligence Pack"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("k6VNW")),
                            (parcelRequire("3ASou")),
                            (parcelRequire("illzP"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w40 df jcc mla mra",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "icon mx1-5rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("aFTOQ")),
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        })
                    }
                },
                "H - Long Term Growth Planning": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Long Term Growth ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Planning"
                        ]
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    time: '5 mins',
                    type: 'H - Long Term Growth Planning',
                    logo: (parcelRequire("lqLan")),
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "70",
                            height: "59",
                            viewBox: "0 0 70 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                                fill: "#4A67FF"
                            })
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Data Repository Lite"
                        }),
                        points: [
                            "All your key corporate documents in one place \u2013 easily accessible to all",
                            '20 sections (Lite)',
                            "Not created one before? No worries \u2013 checklists take you through each section",
                            'Completeness scoring',
                            'Prepopulated docs from UK Companies House where available (UK companies only)',
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to your chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    })
                                ]
                            }),
                            'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                        ],
                        image: (parcelRequire("3Unna"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            children: [
                                "First time? ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c3",
                                    children: "3 Ways to populate your Data Repository"
                                })
                            ]
                        }),
                        arrayImages: [
                            (parcelRequire("gDAuw")),
                            (parcelRequire("2oIlR")),
                            (parcelRequire("fqHfJ"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "H - Improving Your KPIs": {
                    title: 'Improving Your KPIs',
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    type: "H - Improving Your KPIs",
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    logo: (parcelRequire("lqLan")),
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Mitigating Your Key Risks": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Mitigating Your Key",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Risks"
                        ]
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    logo: (parcelRequire("lqLan")),
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Improving Compliance": {
                    title: 'Improving Compliance',
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Building New Funding Relationships": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Mitigating Your Key ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Risks"
                        ]
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Improving Your Existing Funding Terms": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Improving Your Existing  ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Funding Terms"
                        ]
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Increasing Your Revenues": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Increasing Your Revenues"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Driving Your Margins & Profit": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Driving Your Margins & Profit"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Improving Your Cashflow": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Improving Your Cashflow"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Boosting Outsourcing Efficiency": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Boosting Outsourcing Efficiency"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Strengthening Your Controls": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Strengthening Your Controls"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Optimising Your Taxation": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Optimising Your Taxation"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Enhancing Yor Social Media - B2B Businesses": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Enhancing Yor Social Media - B2B Businesses"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "H - Enhancing Your Social Media - B2C Businesses": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Enhancing Your Social Media - B2C Businesses"
                    }),
                    menus: [
                        'listOfSections',
                        'report',
                        'workflow'
                    ],
                    isBuy: company['subscription'] !== 'Pro',
                    price: "\xa399",
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Intellectual Property',
                        'Corporate Structure',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Human Resources',
                        'IT Systems'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                }
            }
        },
        "exit": {
            letsOrganise: {
                "business-audit": {
                    title: 'Business Audit',
                    menus: [
                        'listOfSections',
                        'seeMore',
                        'howItWorks'
                    ],
                    type: `business-audit-${company?.testType}`,
                    isCertification: true,
                    module: company?.['modules']?.["business-audit-" + company.testType],
                    aboveTitle: company?.['liteToPro'] && company?.['modules']?.["business-audit-" + company.testType]['stats']['completionPercent'] === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 op50",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Not started"
                    }) : company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '2 mins',
                    isRisk: true,
                    isCompleteness: true,
                    subscription: company?.['subscription'] === "Pro" ? "PRO" : 'LITE',
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "20 section review bespoked to ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " your business"
                        ]
                    }),
                    tooltip: [
                        'Key Shareholder/Investor Documents',
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "59",
                            viewBox: "0 0 65 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Business Audit Lite"
                        }),
                        points: [
                            'Step by step audit of your business',
                            'Quick - multiple choice questions',
                            'Individually bespoked to your business, industry, stage of development and objective',
                            'At a glance Red/Amber/Green status',
                            'Both section and overall completeness and risk scores',
                            'Quickly identify strengths and weaknesses',
                            'Risks and recommendations for each section',
                            'All in real-time',
                            'Improvement tracking over time'
                        ],
                        image: (parcelRequire("izGj8"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Business Audit"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("dCQNv")),
                            (parcelRequire("ltgw0")),
                            (parcelRequire("aydTN"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "data-repository": {
                    title: 'Data Repository',
                    menus: [
                        'listOfSections',
                        'seeMore',
                        'howItWorks'
                    ],
                    type: 'repository',
                    module: company?.['modules']?.["repository"],
                    isCertification: true,
                    aboveTitle: company?.['liteToPro'] && company?.['modules']?.["repository"]['stats']['completionPercent'] === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c15 op50",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Not started"
                    }) : company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '2 Days',
                    subscription: company?.['subscription'] === "Pro" ? "PRO" : 'LITE',
                    isCompleteness: true,
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Complete your Data Repository",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " with all your key docs"
                        ]
                    }),
                    tooltip: [
                        'Key Shareholder/Investor Documents',
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "70",
                            height: "59",
                            viewBox: "0 0 70 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                                fill: "#4A67FF"
                            })
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Data Repository Lite"
                        }),
                        points: [
                            "All your key corporate documents in one place \u2013 easily accessible to all",
                            '20 sections (Lite)',
                            "Not created one before? No worries \u2013 checklists take you through each section",
                            'Completeness scoring',
                            'Prepopulated docs from UK Companies House where available (UK companies only)',
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to your chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    })
                                ]
                            }),
                            'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                        ],
                        image: (parcelRequire("3Unna"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            children: [
                                "First time? ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c3",
                                    children: "3 Ways to populate your Data Repository"
                                })
                            ]
                        }),
                        arrayImages: [
                            (parcelRequire("gDAuw")),
                            (parcelRequire("2oIlR")),
                            (parcelRequire("fqHfJ"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "workflow-manager": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Workflow Manager"
                    }),
                    subscription: 'PRO',
                    companyDashboardTab: 'Workflows',
                    logo: (parcelRequire("duikr")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "AI analyses and prioritises your",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " remediation of issues "
                        ]
                    })
                },
                "anylist-builder": {
                    title: "AnyList Builder",
                    menus: [
                        'seeMore',
                        'howItWorks'
                    ],
                    subscription: 'PRO',
                    type: 'anylist-builder',
                    companyDashboardTab: 'AnyLists',
                    time: '5 mins',
                    logo: (parcelRequire("ZkulW")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c78",
                                children: "Unlock"
                            }),
                            " build own checklists on ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " anything"
                        ]
                    }),
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "FREE - Anylist Checklist ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Builder"
                            ]
                        }),
                        points: [
                            'Undertaking M&A? Create relevant automated due diligence checklists bespoked to target company',
                            `10 sections; 10 questions per section`,
                            `You can add your own questions and desired answers`,
                            `Questions: can choose subjective, objective or a mixture`,
                            `Completeness and risk scoring`,
                            `Reporting`,
                            `Workflow Manager: Can send to target company and monitor completeness`
                        ],
                        image: (parcelRequire("lB7oR")),
                        imageStyle: {
                            height: '90%',
                            width: '94%'
                        }
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "AnyList Checklist Builder"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("1PiK1")),
                            (parcelRequire("jcfD1")),
                            (parcelRequire("4CdTy"))
                        ],
                        checkList: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Quick and easy for you"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Quick and easy for your target user"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Reusable by the target company"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w1rem",
                                            src: (parcelRequire("fYwBE")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c12",
                                        children: "Company gains value from completion - risks & recommendations"
                                    })
                                ]
                            })
                        ],
                        btnContent: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "new-shadow bg4 bg3-hover c1 td250 br30px p1rem fw600 cp ttu bsbb tac df jcc aic w250px",
                            children: "Let\u2019s Go!"
                        })
                    }
                },
                "two-minute-test": {
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "70",
                            height: "62",
                            viewBox: "0 0 70 62",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                        }),
                        points: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Bespoked to your company - its objectives and stage of development"
                            }),
                            'Section by section completeness and risk scores',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: "Real-time reports - with associated risks and suggestions for improvement"
                            }),
                            'Pass/fail certificates'
                        ],
                        image: (parcelRequire("4tyyd"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "2-Minute Test Investment/Growth/Exit Ready"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("4qXP0")),
                            (parcelRequire("6KEUK")),
                            (parcelRequire("5Pn0p"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "A quick introduction to how our modules work"
                        })
                    }
                },
                "kpi": {
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "61",
                            viewBox: "0 0 65 61",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M15.2344 23.8359H25.4996L30.2058 28.5422C30.6631 28.9951 31.4732 29.0629 32.0013 28.5422L36.7076 23.8359H46.9727C47.6738 23.8359 48.2422 23.2676 48.2422 22.5664V2.25391C48.2422 1.55274 47.6738 0.984375 46.9727 0.984375H15.2344C14.5332 0.984375 13.9648 1.55274 13.9648 2.25391V22.5664C13.9648 23.2676 14.5332 23.8359 15.2344 23.8359ZM16.5039 3.52344H45.7031V21.2969H36.1816C35.845 21.2969 35.522 21.4307 35.284 21.6687L31.1035 25.8492L26.9231 21.6687C26.685 21.4307 26.3621 21.2969 26.0254 21.2969H16.5039V3.52344Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M60.8196 50.2333C60.3238 49.7375 59.52 49.7375 59.0241 50.2333C58.5283 50.729 58.5283 51.5329 59.0241 52.0288L60.6654 53.6701H6.34766V5.3189L7.98903 6.96028C8.44632 7.41312 9.25641 7.48092 9.78453 6.96028C10.2803 6.46453 10.2803 5.66066 9.78453 5.16478L5.97594 1.35619C5.48019 0.860437 4.67632 0.860437 4.18044 1.35619L0.371846 5.16478C-0.123906 5.66053 -0.123906 6.4644 0.371846 6.96028C0.867598 7.45603 1.67147 7.45603 2.16734 6.96028L3.80859 5.3189V9.99814H1.26953C0.568369 9.99814 0 10.5665 0 11.2677C0 11.9688 0.568369 12.5372 1.26953 12.5372H3.80859V16.3458H1.26953C0.568369 16.3458 0 16.9142 0 17.6153C0 18.3165 0.568369 18.8849 1.26953 18.8849H3.80859V22.6935H1.26953C0.568369 22.6935 0 23.2618 0 23.963C0 24.6641 0.568369 25.2325 1.26953 25.2325H3.80859V29.0411H1.26953C0.568369 29.0411 0 29.6095 0 30.3106C0 31.0118 0.568369 31.5802 1.26953 31.5802H3.80859V35.3888H1.26953C0.568369 35.3888 0 35.9571 0 36.6583C0 37.3595 0.568369 37.9278 1.26953 37.9278H3.80859V41.7364H1.26953C0.568369 41.7364 0 42.3048 0 43.006C0 43.7071 0.568369 44.2755 1.26953 44.2755H3.80859V48.0841H1.26953C0.568369 48.0841 0 48.6525 0 49.3536C0 50.0548 0.568369 50.6231 1.26953 50.6231H3.80859V54.9395C3.80859 55.6407 4.37696 56.2091 5.07813 56.2091H9.14063V58.7481C9.14063 59.4493 9.70899 60.0177 10.4102 60.0177C11.1113 60.0177 11.6797 59.4493 11.6797 58.7481V56.2091H15.4883V58.7481C15.4883 59.4493 16.0567 60.0177 16.7578 60.0177C17.459 60.0177 18.0273 59.4493 18.0273 58.7481V56.2091H21.8359V58.7481C21.8359 59.4493 22.4043 60.0177 23.1055 60.0177C23.8066 60.0177 24.375 59.4493 24.375 58.7481V56.2091H28.1836V58.7481C28.1836 59.4493 28.752 60.0177 29.4531 60.0177C30.1543 60.0177 30.7227 59.4493 30.7227 58.7481V56.2091H34.5313V58.7481C34.5313 59.4493 35.0996 60.0177 35.8008 60.0177C36.5019 60.0177 37.0703 59.4493 37.0703 58.7481V56.2091H40.8789V58.7481C40.8789 59.4493 41.4473 60.0177 42.1484 60.0177C42.8496 60.0177 43.418 59.4493 43.418 58.7481V56.2091H47.2266V58.7481C47.2266 59.4493 47.7949 60.0177 48.4961 60.0177C49.1973 60.0177 49.7656 59.4493 49.7656 58.7481V56.2091H53.5742V58.7481C53.5742 59.4493 54.1426 60.0177 54.8438 60.0177C55.5449 60.0177 56.1133 59.4493 56.1133 58.7481V56.2091H60.6656L59.0242 57.8505C58.5284 58.3462 58.5284 59.1501 59.0242 59.646C59.4815 60.0988 60.2916 60.1666 60.8197 59.646L64.6283 55.8374C65.124 55.3416 65.124 54.5377 64.6283 54.0419L60.8196 50.2333Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M26.1527 18.7578C26.4563 18.7578 26.7607 18.6496 27.0036 18.4301C27.5238 17.96 27.5643 17.1572 27.0942 16.6371L23.0877 12.2041L26.7589 8.33395C27.2415 7.82524 27.2203 7.02176 26.7116 6.53921C26.2029 6.05666 25.3994 6.07786 24.9168 6.58656L22.3438 9.29904V7.33203C22.3438 6.63087 21.7754 6.0625 21.0742 6.0625C20.3731 6.0625 19.8047 6.63087 19.8047 7.33203V17.4883C19.8047 18.1894 20.3731 18.7578 21.0742 18.7578C21.7754 18.7578 22.3438 18.1894 22.3438 17.4883V15.1676L25.2105 18.3395C25.4611 18.6169 25.8063 18.7578 26.1527 18.7578Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M30.9766 18.7578C31.6777 18.7578 32.2461 18.1894 32.2461 17.4883V13.6797H33.5156C35.6157 13.6797 37.3242 11.9712 37.3242 9.87109C37.3242 7.77104 35.6157 6.0625 33.5156 6.0625H30.9766C30.2754 6.0625 29.707 6.63087 29.707 7.33203V17.4883C29.707 18.1894 30.2754 18.7578 30.9766 18.7578ZM32.2461 8.60156H33.5156C34.2156 8.60156 34.7852 9.17107 34.7852 9.87109C34.7852 10.5711 34.2156 11.1406 33.5156 11.1406H32.2461V8.60156Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M41.1328 8.60156C41.834 8.60156 42.4023 8.03317 42.4023 7.33203C42.4023 6.63089 41.834 6.0625 41.1328 6.0625C40.4317 6.0625 39.8633 6.63089 39.8633 7.33203C39.8633 8.03317 40.4317 8.60156 41.1328 8.60156Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M41.1328 18.7559C41.8323 18.7559 42.4023 18.1858 42.4023 17.4863V13.043C42.4023 12.3435 41.8323 11.7734 41.1328 11.7734C40.4333 11.7734 39.8633 12.3435 39.8633 13.043V17.4863C39.8633 18.1858 40.4333 18.7559 41.1328 18.7559Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M63.7305 18.7578H56.1133C55.4121 18.7578 54.8438 19.3262 54.8438 20.0273C54.8438 20.7285 55.4121 21.2969 56.1133 21.2969H60.7709L55.6067 26.7241C55.1694 27.1682 55.1203 28.027 55.6512 28.518C56.085 28.9491 56.957 29.0075 57.4463 28.4735L62.4609 23.2026V27.6445C62.4609 28.3457 63.0293 28.9141 63.7305 28.9141C64.4316 28.9141 65 28.3457 65 27.6445V20.0273C65 19.3262 64.4316 18.7578 63.7305 18.7578Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M43.4929 39.4569L39.3154 37.6291C39.341 37.4366 39.3555 37.2405 39.3555 37.041C39.3555 34.5909 37.3622 32.5976 34.9121 32.5976C33.5385 32.5976 32.3086 33.2244 31.4928 34.2069L23.9952 30.9268C23.4587 30.6923 22.8319 30.8547 22.4771 31.3198L9.4009 48.4585C8.97561 49.016 9.08276 49.8126 9.64008 50.2379C10.1263 50.619 10.9747 50.5862 11.4195 49.9987L23.8908 33.6526L30.4973 36.5429C30.4789 36.7066 30.4686 36.8726 30.4686 37.0411C30.4686 39.4912 32.4619 41.4845 34.912 41.4845C36.2531 41.4845 37.4564 40.8864 38.2718 39.9439L43.2896 42.1394C43.4509 42.2105 43.621 42.2461 43.7975 42.2461C44.144 42.2461 44.4805 42.1026 44.7191 41.8512L49.57 36.7528C50.0083 36.3087 50.0546 35.4503 49.5256 34.9589C49.0914 34.529 48.2202 34.4678 47.7305 35.0034L43.4929 39.4569ZM34.9121 38.9453C33.8621 38.9453 33.0078 38.091 33.0078 37.041C33.0078 35.9909 33.8621 35.1367 34.9121 35.1367C35.9622 35.1367 36.8164 35.9909 36.8164 37.041C36.8164 38.091 35.9622 38.9453 34.9121 38.9453Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.5898 33.0078C53.291 33.0078 53.8594 32.4394 53.8594 31.7383C53.8594 31.0371 53.291 30.4688 52.5898 30.4688C51.8887 30.4688 51.3203 31.0371 51.3203 31.7383C51.3203 32.4394 51.8887 33.0078 52.5898 33.0078Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Free Key Performance",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                " Indicators (KPI) Report"
                            ]
                        }),
                        points: [
                            'AI generated list of Key Performance Indicators',
                            'Specifically generated for your business',
                            'Based on your industry',
                            'For each KPI, we explain the KPI, how to calculate it, and what the target benchmark is'
                        ],
                        image: (parcelRequire("kk8Qe"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "KPI Report"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("bLZ0V")),
                            (parcelRequire("k6BF8")),
                            (parcelRequire("l4ysc"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                            children: "*= not guaranteed!"
                        })
                    }
                },
                "warranty-disclosure": {
                    id: 'DEPF006',
                    menus: [
                        'listOfSections',
                        'report',
                        'seeMore',
                        'howItWorks'
                    ],
                    hideBuyButton: true,
                    type: 'warranty-disclosure',
                    isCertification: true,
                    module: company?.['modules']?.["warranty-disclosure"],
                    isBuy: !company?.['modules']?.["warranty-disclosure"],
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Draft Warranty Disclosures"
                    }),
                    aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    time: '30 mins',
                    price: "\xa3500",
                    isRisk: true,
                    isCompleteness: true,
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Save time and legal cost pre-",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "investment"
                        ]
                    }),
                    tooltip: [
                        'Share Capital And Authority',
                        'Information',
                        'Business Plan',
                        'Accounts',
                        'Management Accounts',
                        'Events Since The Accounts Date',
                        'Taxation',
                        'Litigation',
                        'Properties',
                        'Intellectual Property',
                        'Assets, Debt & Stock',
                        'Contracts With Connected Persons',
                        'Employment and Consultancy Arrangements',
                        'Statutory & Legal Requirements',
                        'Records & Registers',
                        'Insurance',
                        'Group Structure',
                        'Agreements & Capital Commitments',
                        'Borrowings & Facilities',
                        'Social Obligations'
                    ],
                    helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557715-expansion-pack-warranty-disclosure-module',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "65",
                            height: "65",
                            viewBox: "0 0 65 65",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.2324 50.4004C45.2841 50.4004 46.1367 49.5478 46.1367 48.4961V38.9746C46.1367 37.9229 45.2841 37.0703 44.2324 37.0703C43.1807 37.0703 42.3281 37.9229 42.3281 38.9746V48.4961C42.3281 49.5478 43.1806 50.4004 44.2324 50.4004Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M44.2324 57.3828C45.2841 57.3828 46.1367 56.5302 46.1367 55.4785C46.1367 54.4268 45.2841 53.5742 44.2324 53.5742C43.1807 53.5742 42.3281 54.4268 42.3281 55.4785C42.3281 56.5302 43.1807 57.3828 44.2324 57.3828Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.2492 56.4708L53.0864 36.7718C54.0841 33.1317 54.5899 29.3753 54.5899 25.5931V4.44314C54.5899 2.99778 53.0427 2.0794 51.7738 2.77168L51.2295 3.06862C43.9058 7.06359 34.7955 6.02371 28.5602 0.481185L28.5599 0.480931C27.8384 -0.16031 26.7513 -0.16031 26.03 0.480931L26.0297 0.481185C19.7944 6.02384 10.6844 7.06346 3.36058 3.06875L2.81608 2.77168C1.54718 2.0794 0 2.99778 0 4.44314V25.5931C0 34.0789 2.51469 42.2785 7.27201 49.3054C12.0296 56.3323 18.7087 61.7123 26.5876 64.8639C27.0322 65.0418 27.5269 65.0443 27.9737 64.8737C28.361 64.9557 28.7658 65 29.1862 65H59.2788C63.6562 65.0001 66.4072 60.2791 64.2492 56.4708ZM25.3907 51.4362C18.8667 47.1952 14.2664 40.7043 12.3796 33.2618H25.3907V51.4362ZM25.3907 29.4533H11.6638C11.5067 28.1844 11.4258 26.896 11.4258 25.5932V16.8827C11.9016 16.9045 12.3776 16.9155 12.8515 16.9155C17.1728 16.9155 21.4508 16.0128 25.3907 14.2899V29.4533ZM26.3579 9.55809C22.2503 11.8799 17.5799 13.1072 12.8515 13.1072C11.8149 13.1072 10.7678 13.0472 9.7391 12.9287C8.6087 12.7984 7.6172 13.6823 7.6172 14.8202V25.5932C7.6172 38.0309 14.137 49.3276 24.7563 55.517L24.2158 56.4706C23.7207 57.3443 23.4867 58.2659 23.4687 59.1678C11.3821 52.4258 3.8086 39.7285 3.8086 25.5931V7.49815C6.70885 8.69811 9.77744 9.2873 12.835 9.28705C17.9808 9.28679 23.0919 7.6166 27.295 4.37573C33.9954 9.54248 43 10.7177 50.7813 7.49815V25.5932C50.7813 27.6811 50.6118 29.7602 50.276 31.8122L49.2029 29.9185C48.6296 28.9068 47.8236 28.1628 46.9082 27.6812C46.9495 26.9846 46.9727 26.2866 46.9727 25.5932V14.8202C46.9727 13.6823 45.9813 12.7984 44.8509 12.9286C43.8222 13.047 42.775 13.1071 41.7384 13.1071C37.0101 13.1071 32.3397 11.8798 28.232 9.55797C27.6506 9.22941 26.9394 9.22941 26.3579 9.55809ZM29.1993 29.4533V14.29C33.139 16.0128 37.4169 16.9157 41.7384 16.9157C42.2124 16.9157 42.6883 16.9046 43.1641 16.8828V25.5933C43.1641 26.1033 43.1508 26.6163 43.1257 27.1289C41.7444 27.3967 40.4496 28.1726 39.5584 29.4533H29.1993ZM37.3676 33.2619L29.1993 47.6766V33.2619H37.3676ZM59.2788 61.1915H29.1863C27.7272 61.1915 26.8101 59.6178 27.5296 58.3484L42.5758 31.7963C43.3053 30.5089 45.16 30.5089 45.8894 31.7963L60.9357 58.3484C61.6549 59.6178 60.7379 61.1915 59.2788 61.1915Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Expansion Pack - ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Warranty Disclosure"
                            ]
                        }),
                        points: [
                            "Save thousands on lawyers\u2019 fees",
                            'Normally an expensive exercise at the end of a transaction',
                            'Get ahead, early completion will identify showstoppers and give you time to fix them',
                            'Based on the UK BVCA standard disclosure letter',
                            'Contributes to Diligentsia certification',
                            'Part of DD Pack available to investors'
                        ],
                        image: (parcelRequire("bnaJ5"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Warranty Disclosure"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("2mFD2")),
                            (parcelRequire("ca6j0")),
                            (parcelRequire("5fyAg"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "directors-questionnaires": {
                    id: 'DEPF007',
                    title: "Draft Directors\u2019 Questionnaires",
                    menus: [
                        'report',
                        'seeMore',
                        'howItWorks'
                    ],
                    aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c77",
                        style: {
                            fontSize: '11px'
                        },
                        children: "Certification"
                    }) : '',
                    isCertification: true,
                    type: 'directors-questionnaire',
                    module: company?.['modules']?.[`directors-questionnaire_${directors?.[0]?.['_id']}`],
                    directorsStats: company['directorsStats'],
                    information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "Save time and cost pre-investment"
                    }),
                    isRisk: true,
                    isCompleteness: true,
                    price: "\xa3250",
                    isBuy: !company?.['modules']?.[`directors-questionnaire_${directors?.[0]?.['_id']}`],
                    time: '15 mins',
                    tooltip: directors && directors.length > 0 && directors.map((d)=>typeof d === 'object' ? d.name || '' : d).filter(Boolean),
                    helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557468-directors-questionnaire-module',
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Expansion Pack - ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Directors\u2019 Questionnaires"
                            ]
                        }),
                        points: [
                            'Normally part of purchase/sale or investment',
                            'Identify any issues in advance - time for rectification',
                            'Pre-population from Companies House where relevant',
                            'Completeness and risk scoring',
                            'Impress your counterparty with your organisation',
                            'Contributes to Diligentsia certification'
                        ],
                        image: (parcelRequire("3e8So"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Directors\u2019 Questionnaires"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("5NBD1")),
                            (parcelRequire("gw040")),
                            (parcelRequire("77FeN"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                }
            },
            proveOurValue: {
                "market-opportunity": {
                    title: 'Market Opportunity',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'marketReport')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?marketReport`
                },
                "route-to-market": {
                    title: 'Route to Market',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'routeToMarketReport')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?routeToMarketReport`
                },
                "technology-advantage": {
                    title: 'Technology Advantage',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'TCAR3')?.[0] || null,
                    isReseachAid: true,
                    navigate: `/researchAid/${company?.['_id']}?TCAR3`
                },
                "swot": {
                    title: 'SWOT',
                    aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        style: {
                            color: '#929090',
                            fontSize: '11px'
                        },
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            })
                        ]
                    }),
                    time: '5 mins',
                    subscription: 'PRO',
                    module: company?.['researchAidReports']?.filter((item)=>item['reportType'] === 'swotAnalysis')?.[0] || null,
                    isReseachAid: true,
                    openModal: 'swotReportPopup'
                },
                "research-aid-report": {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "Research",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Aid"
                            }),
                            " Builder"
                        ]
                    }),
                    logo: (parcelRequire("ZkulW")),
                    information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 op50",
                        children: [
                            "Edit/update existing reports. ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Generate your own reports"
                        ]
                    }),
                    subscription: 'PRO',
                    companyDashboardTab: 'ResearchAid',
                    time: '5 mins'
                }
            },
            getPitching: {
                "diligence-pack": {
                    title: 'Diligence Pack',
                    information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "See your diligence reports and files in one place - as third parties will see them"
                    }),
                    subscription: 'PRO',
                    type: '#diligence-pack',
                    link: `/company/${company?.['_id']}#diligence-pack`,
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "83",
                            height: "83",
                            viewBox: "0 0 83 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M52.2423 4.99219C38.0392 4.99219 26.4843 16.5471 26.4843 30.7502C26.4843 35.4448 27.7474 39.8496 29.9507 43.6439L6.94712 66.6474C4.35096 69.2434 4.35096 73.4677 6.94712 76.0637C8.24505 77.3618 9.95015 78.0108 11.6551 78.0108C13.3601 78.0108 15.0653 77.3619 16.3631 76.0637L39.3714 53.0553C43.1605 55.2502 47.557 56.5081 52.242 56.5081C66.4452 56.5081 78.0001 44.953 78.0001 30.7501C78.0001 16.5471 66.4454 4.99219 52.2423 4.99219ZM13.3351 73.0356C12.4087 73.962 10.9015 73.962 9.97525 73.0357C9.04897 72.1094 9.04897 70.6021 9.97525 69.6757L11.4192 68.2317L14.7791 71.5916L13.3351 73.0356ZM17.8072 68.5636L14.4474 65.2037L16.7667 62.8844L20.1265 66.2444L17.8072 68.5636ZM23.1545 63.2161L19.7947 59.8561L32.4432 47.2076C33.4586 48.4271 34.5841 49.5519 35.8046 50.5661L23.1545 63.2161ZM52.2423 52.2257C40.4006 52.2257 30.7669 42.5918 30.7669 30.7502C30.7669 18.9087 40.4006 9.27476 52.2423 9.27476C64.084 9.27476 73.7178 18.9085 73.7178 30.7502C73.7178 42.5919 64.084 52.2257 52.2423 52.2257Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M59.5703 27.024C59.5703 25.8415 58.6117 24.8828 57.4291 24.8828L43.216 24.8828C42.0334 24.8828 41.0748 25.8415 41.0748 27.024C41.0748 28.2066 42.0334 29.1652 43.216 29.1652L57.4291 29.1652C58.6117 29.1654 59.5703 28.2066 59.5703 27.024Z",
                                    fill: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M64.2187 19.5318C64.2187 18.3493 63.2601 17.3906 62.0775 17.3906L43.2121 17.3906C42.0295 17.3906 41.0709 18.3493 41.0709 19.5318C41.0709 20.7144 42.0295 21.6731 43.2121 21.6731L62.0775 21.6731C63.2601 21.6732 64.2187 20.7144 64.2187 19.5318Z",
                                    fill: "#4A67FF"
                                })
                            ]
                        }),
                        title: `Due Diligence Pack`,
                        subMenu: {
                            index: 0,
                            points: [
                                '- Data Repository Report',
                                '- 20-sections Business Audit',
                                "- Directors\u2019 questionnaires",
                                '- Draft Warranty Disclosures '
                            ]
                        },
                        points: [
                            `Pulls together a complete pack of each of the key completed modules' reports:`,
                            `Tracks the sending of the DD Pack to investors introduced through the platform`
                        ],
                        notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                fontSize: "14px",
                                color: 'gray',
                                fontStyle: 'italic'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontWeight: "bold",
                                        fontStyle: 'normal'
                                    },
                                    children: `Please Note: `
                                }),
                                "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice"
                            ]
                        }),
                        image: (parcelRequire("7J3ig")),
                        imageStyle: {
                            height: '90%',
                            width: '94%'
                        }
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "Diligence Pack"
                            })
                        }),
                        stepImage: (parcelRequire("aCagb")),
                        arrayImages: [
                            (parcelRequire("k6VNW")),
                            (parcelRequire("3ASou")),
                            (parcelRequire("illzP"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w40 df jcc mla mra",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "icon mx1-5rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("aFTOQ")),
                                            alt: ""
                                        })
                                    })
                                ]
                            })
                        })
                    }
                },
                // 'benchmarking': {
                // 	title: 'Benchmarking Report',
                // 	type: "benchmark-reporting",
                // 	subscription: 'PRO',
                // 	disable: !['advisor', 'investor'].includes(user?.['role'].toLowerCase()),
                // 	seeMore: {
                // 		icon: <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                // 			<g clip-path="url(#clip0_2119_192)">
                // 				<path d="M54.9743 42.4394C57.0327 38.6748 58.1973 34.3686 58.1973 29.7915C58.1973 28.5728 58.0618 27.3811 57.8993 26.1894C61.1764 25.404 63.6139 22.479 63.6139 18.9582C63.6139 14.8415 60.2827 11.5103 56.166 11.5103C54.5952 11.5103 53.1598 11.9978 51.9681 12.8103C46.9577 6.879 39.6181 3.38525 31.791 3.38525C17.2202 3.38525 5.38477 15.2207 5.38477 29.7915C5.38477 44.3623 17.2202 56.1978 31.791 56.1978C36.3681 56.1978 40.6743 55.0332 44.4389 52.9748L50.9118 59.4478C52.3743 60.9103 54.2702 61.6144 56.1931 61.6144C58.116 61.6144 60.0118 60.8832 61.4743 59.4478C64.3723 56.5498 64.3723 51.8103 61.4743 48.9123L55.0014 42.4394H54.9743ZM56.166 15.5728C58.0348 15.5728 59.5514 17.0894 59.5514 18.9582C59.5514 20.8269 58.0348 22.3436 56.166 22.3436C54.2973 22.3436 52.7806 20.8269 52.7806 18.9582C52.7806 17.0894 54.2973 15.5728 56.166 15.5728ZM31.791 7.44775C38.6431 7.44775 45.0889 10.6436 49.3139 16.0332C48.9348 16.9269 48.7181 17.929 48.7181 18.9582C48.7181 20.2853 49.0973 21.4769 49.6931 22.5603L35.7452 36.5082L30.0577 30.8207C30.7077 29.7103 31.1139 28.4373 31.1139 27.0832C31.1139 22.9665 27.7827 19.6353 23.666 19.6353C19.5493 19.6353 16.2181 22.9665 16.2181 27.0832C16.2181 28.3019 16.5431 29.4394 17.0577 30.4686L10.6118 36.8873C9.85352 34.6665 9.44727 32.2832 9.44727 29.7915C9.44727 17.4686 19.4681 7.44775 31.791 7.44775ZM20.2806 27.0832C20.2806 25.2144 21.7973 23.6978 23.666 23.6978C25.5348 23.6978 27.0514 25.2144 27.0514 27.0832C27.0514 28.9519 25.5348 30.4686 23.666 30.4686C21.7973 30.4686 20.2806 28.9519 20.2806 27.0832ZM12.3993 40.8415L19.8202 33.4207C20.9306 34.0978 22.2577 34.504 23.666 34.504C24.9118 34.504 26.1035 34.1519 27.1327 33.6103L34.3098 40.7873C34.716 41.1936 35.2306 41.3832 35.7452 41.3832C36.2598 41.3832 36.7743 41.1936 37.1806 40.7873L52.5639 25.404C52.9431 25.6207 53.3493 25.8103 53.7556 25.9457C53.9723 27.2186 54.1348 28.4915 54.1348 29.7644C54.1348 42.0873 44.1139 52.1082 31.791 52.1082C23.5035 52.1082 16.2452 47.5582 12.3993 40.8144V40.8415ZM58.5493 56.5498C57.2223 57.8769 55.0827 57.8769 53.7556 56.5498L47.8785 50.6728C49.666 49.2915 51.291 47.6665 52.6723 45.879L58.5493 51.7561C59.8764 53.0832 59.8764 55.2228 58.5493 56.5498Z" fill="#4A67FF" />
                // 			</g>
                // 		</svg>,
                // 		title: <>FREE Client <br />Benchmarking</>,
                // 		points: [
                // 			'Benchmark your client/portfolio companies',
                // 			'Simple scoring system',
                // 			'Against each or our wider database (anonymized)',
                // 			'Benchmarking report',
                // 		],
                // 		image: require('../../../../images/landingpage/banner25.png'),
                // 		imageStyle: { height: '90%', width: '94%' }
                // 	},
                // },
                "pitch-deck-analyser": {
                    title: 'Corporate Deck Analyser',
                    information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "Coming Soon: Analysis of your corporate deck - giving you the chance to improve it"
                    }),
                    subscription: 'PRO',
                    time: '5 mins',
                    tooltip: [
                        'Commercial Activities',
                        'Legal',
                        'Property',
                        'Intellectual Property',
                        'Insurance',
                        'Corporate Structure',
                        'State Aid',
                        'Finance',
                        'General Data Protection Regulations (GDPR)',
                        'Shares & Share Options',
                        'Taxation',
                        'Social Media',
                        'Key People',
                        'Human Resources',
                        'Environmental, Social & Governmental (ESG)',
                        'Key Advisors - Engagement Letters & Corrrspondence',
                        'IT Systems',
                        'Regulatory',
                        'Standards'
                    ],
                    helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                    comingSoon: true,
                    seeMore: {
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "70",
                            height: "59",
                            viewBox: "0 0 70 59",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                                fill: "#4A67FF"
                            })
                        }),
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Data Repository Lite"
                        }),
                        points: [
                            "All your key corporate documents in one place \u2013 easily accessible to all",
                            '20 sections (Lite)',
                            "Not created one before? No worries \u2013 checklists take you through each section",
                            'Completeness scoring',
                            'Prepopulated docs from UK Companies House where available (UK companies only)',
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to your chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem ml0-5rem"
                                    })
                                ]
                            }),
                            'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                        ],
                        image: (parcelRequire("3Unna"))
                    },
                    howItWorks: {
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            children: [
                                "First time? ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c3",
                                    children: "3 Ways to populate your Data Repository"
                                })
                            ]
                        }),
                        arrayImages: [
                            (parcelRequire("gDAuw")),
                            (parcelRequire("2oIlR")),
                            (parcelRequire("fqHfJ"))
                        ],
                        bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                            children: [
                                "Threshold scores required for Diligentsia certification",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w9rem",
                                        src: (parcelRequire("jBY5D")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    }
                },
                "purchaserManagement": {
                    title: 'Purchaser Management',
                    type: 'share-diligence-pack',
                    information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "Manage external access to your diligence packs"
                    }),
                    subscription: 'PRO'
                }
            }
        }
    };
    const MODULE_BOX = {
        getPitching: {
            "diligence-pack": {
                title: 'Diligence Pack',
                information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c15 op50",
                    children: "Lorem ipsum dolor sit amet, consectetur"
                }),
                subscription: 'PRO',
                tooltip: [
                    'Key Shareholder/Investor Documents',
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "65",
                        height: "59",
                        viewBox: "0 0 65 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Business Audit Lite"
                    }),
                    points: [
                        'Step by step audit of your business',
                        'Quick - multiple choice questions',
                        'Individually bespoked to your business, industry, stage of development and objective',
                        'At a glance Red/Amber/Green status',
                        'Both section and overall completeness and risk scores',
                        'Quickly identify strengths and weaknesses',
                        'Risks and recommendations for each section',
                        'All in real-time',
                        'Improvement tracking over time'
                    ],
                    image: (parcelRequire("izGj8"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Business Audit"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("dCQNv")),
                        (parcelRequire("ltgw0")),
                        (parcelRequire("aydTN"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "pitch-deck-analyser": {
                title: 'Pitch Deck Analyser',
                information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c15 op50",
                    children: "Lorem ipsum dolor sit amet, consectetur"
                }),
                subscription: 'PRO',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "70",
                        height: "59",
                        viewBox: "0 0 70 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                            fill: "#4A67FF"
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Data Repository Lite"
                    }),
                    points: [
                        "All your key corporate documents in one place \u2013 easily accessible to all",
                        '20 sections (Lite)',
                        "Not created one before? No worries \u2013 checklists take you through each section",
                        'Completeness scoring',
                        'Prepopulated docs from UK Companies House where available (UK companies only)',
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "df",
                            children: [
                                "Can sync to your chosen cloud provider ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                })
                            ]
                        }),
                        'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                    ],
                    image: (parcelRequire("3Unna"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem",
                        children: [
                            "First time? ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "3 Ways to populate your Data Repository"
                            })
                        ]
                    }),
                    arrayImages: [
                        (parcelRequire("gDAuw")),
                        (parcelRequire("2oIlR")),
                        (parcelRequire("fqHfJ"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "investorMatch": {
                title: 'InvestorMatch',
                information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c15 op50",
                    children: "Lorem ipsum dolor sit amet, consectetur"
                }),
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "investorManagement": {
                title: 'Investor Management',
                information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c15 op50",
                    children: "Lorem ipsum dolor sit amet, consectetur"
                }),
                subscription: 'PRO',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            }
        },
        proOnly: {
            "market-opportunity": {
                title: 'Market Opportunity',
                aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    style: {
                        color: '#929090',
                        fontSize: '11px'
                    },
                    children: [
                        "Research",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "Aid"
                        })
                    ]
                }),
                time: '5 mins',
                subscription: 'PRO',
                tooltip: [
                    'Key Shareholder/Investor Documents',
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "65",
                        height: "59",
                        viewBox: "0 0 65 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Business Audit Lite"
                    }),
                    points: [
                        'Step by step audit of your business',
                        'Quick - multiple choice questions',
                        'Individually bespoked to your business, industry, stage of development and objective',
                        'At a glance Red/Amber/Green status',
                        'Both section and overall completeness and risk scores',
                        'Quickly identify strengths and weaknesses',
                        'Risks and recommendations for each section',
                        'All in real-time',
                        'Improvement tracking over time'
                    ],
                    image: (parcelRequire("izGj8"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Business Audit"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("dCQNv")),
                        (parcelRequire("ltgw0")),
                        (parcelRequire("aydTN"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "route-to-market": {
                title: 'Route to Market',
                aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    style: {
                        color: '#929090',
                        fontSize: '11px'
                    },
                    children: [
                        "Research",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "Aid"
                        })
                    ]
                }),
                time: '5 mins',
                subscription: 'PRO',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "70",
                        height: "59",
                        viewBox: "0 0 70 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                            fill: "#4A67FF"
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Data Repository Lite"
                    }),
                    points: [
                        "All your key corporate documents in one place \u2013 easily accessible to all",
                        '20 sections (Lite)',
                        "Not created one before? No worries \u2013 checklists take you through each section",
                        'Completeness scoring',
                        'Prepopulated docs from UK Companies House where available (UK companies only)',
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "df",
                            children: [
                                "Can sync to your chosen cloud provider ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                })
                            ]
                        }),
                        'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                    ],
                    image: (parcelRequire("3Unna"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem",
                        children: [
                            "First time? ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "3 Ways to populate your Data Repository"
                            })
                        ]
                    }),
                    arrayImages: [
                        (parcelRequire("gDAuw")),
                        (parcelRequire("2oIlR")),
                        (parcelRequire("fqHfJ"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "technology-advantage": {
                title: 'Technology Advantage',
                aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    style: {
                        color: '#929090',
                        fontSize: '11px'
                    },
                    children: [
                        "Research",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "Aid"
                        })
                    ]
                }),
                time: '5 mins',
                subscription: 'PRO',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "swot": {
                title: 'SWOT',
                aboveTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    style: {
                        color: '#929090',
                        fontSize: '11px'
                    },
                    children: [
                        "Research",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "Aid"
                        })
                    ]
                }),
                time: '5 mins',
                subscription: 'PRO',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "research-aid-report": {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        "Research",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "Aid"
                        }),
                        " Builder"
                    ]
                }),
                logo: (parcelRequire("ZkulW")),
                information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 op50",
                    children: [
                        "Edit/update existing reports. ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Generate your own reports"
                    ]
                }),
                subscription: 'PRO',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            }
        },
        liteCoreWorkspace: {
            "business-audit": {
                title: 'Business Audit',
                aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c77",
                    style: {
                        fontSize: '11px'
                    },
                    children: "Certification"
                }) : '',
                time: '2 mins',
                subscription: 'LITE',
                information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 op50",
                    children: [
                        "20 section review bespoked to ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " your business"
                    ]
                }),
                tooltip: [
                    'Key Shareholder/Investor Documents',
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "65",
                        height: "59",
                        viewBox: "0 0 65 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Business Audit Lite"
                    }),
                    points: [
                        'Step by step audit of your business',
                        'Quick - multiple choice questions',
                        'Individually bespoked to your business, industry, stage of development and objective',
                        'At a glance Red/Amber/Green status',
                        'Both section and overall completeness and risk scores',
                        'Quickly identify strengths and weaknesses',
                        'Risks and recommendations for each section',
                        'All in real-time',
                        'Improvement tracking over time'
                    ],
                    image: (parcelRequire("izGj8"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Business Audit"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("dCQNv")),
                        (parcelRequire("ltgw0")),
                        (parcelRequire("aydTN"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "data-repository": {
                title: 'Data Repository',
                aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c77",
                    style: {
                        fontSize: '11px'
                    },
                    children: "Certification"
                }) : '',
                time: '2 Days',
                subscription: 'LITE',
                information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 op50",
                    children: [
                        "Complete your Data Repository",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " with all your key docs"
                    ]
                }),
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "70",
                        height: "59",
                        viewBox: "0 0 70 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                            fill: "#4A67FF"
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Data Repository Lite"
                    }),
                    points: [
                        "All your key corporate documents in one place \u2013 easily accessible to all",
                        '20 sections (Lite)',
                        "Not created one before? No worries \u2013 checklists take you through each section",
                        'Completeness scoring',
                        'Prepopulated docs from UK Companies House where available (UK companies only)',
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "df",
                            children: [
                                "Can sync to your chosen cloud provider ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                    className: "pen fds w2rem ml0-5rem"
                                })
                            ]
                        }),
                        'Give Clarence, our AI Filing Manager all your files and she will file them in the repository for you!'
                    ],
                    image: (parcelRequire("3Unna"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem",
                        children: [
                            "First time? ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "3 Ways to populate your Data Repository"
                            })
                        ]
                    }),
                    arrayImages: [
                        (parcelRequire("gDAuw")),
                        (parcelRequire("2oIlR")),
                        (parcelRequire("fqHfJ"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "warranty-disclosure": {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Warranty Disclosure"
                }),
                aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c77",
                    style: {
                        fontSize: '11px'
                    },
                    children: "Certification"
                }) : '',
                subscription: 'PRO',
                time: '30 mins',
                information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 op50",
                    children: [
                        "Save time and legal cost pre-",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "investment"
                    ]
                }),
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "directors-questionnaires": {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Directors\u2019 Questionnaires"
                }),
                aboveTitle: company?.['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c77",
                    style: {
                        fontSize: '11px'
                    },
                    children: "Certification"
                }) : '',
                information: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c15 op50",
                    children: "Save time and cost pre-investment"
                }),
                isRisk: true,
                isCompleteness: true,
                isBuy: true,
                time: '15 mins',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "workflow-manager": {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Workflow Manager"
                }),
                subscription: 'PRO',
                logo: (parcelRequire("duikr")),
                information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 op50",
                    children: [
                        "AI analyses and prioritises your",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " remediation of issues "
                    ]
                }),
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "anylist-builder": {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "AnyList Builder"
                }),
                subscription: 'PRO',
                logo: (parcelRequire("ZkulW")),
                information: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 op50",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c78",
                            children: "Unlock"
                        }),
                        " build own checklists on ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " anything"
                    ]
                }),
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "two-minute-test": {
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "kpi": {
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "65",
                        height: "61",
                        viewBox: "0 0 65 61",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.2344 23.8359H25.4996L30.2058 28.5422C30.6631 28.9951 31.4732 29.0629 32.0013 28.5422L36.7076 23.8359H46.9727C47.6738 23.8359 48.2422 23.2676 48.2422 22.5664V2.25391C48.2422 1.55274 47.6738 0.984375 46.9727 0.984375H15.2344C14.5332 0.984375 13.9648 1.55274 13.9648 2.25391V22.5664C13.9648 23.2676 14.5332 23.8359 15.2344 23.8359ZM16.5039 3.52344H45.7031V21.2969H36.1816C35.845 21.2969 35.522 21.4307 35.284 21.6687L31.1035 25.8492L26.9231 21.6687C26.685 21.4307 26.3621 21.2969 26.0254 21.2969H16.5039V3.52344Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M60.8196 50.2333C60.3238 49.7375 59.52 49.7375 59.0241 50.2333C58.5283 50.729 58.5283 51.5329 59.0241 52.0288L60.6654 53.6701H6.34766V5.3189L7.98903 6.96028C8.44632 7.41312 9.25641 7.48092 9.78453 6.96028C10.2803 6.46453 10.2803 5.66066 9.78453 5.16478L5.97594 1.35619C5.48019 0.860437 4.67632 0.860437 4.18044 1.35619L0.371846 5.16478C-0.123906 5.66053 -0.123906 6.4644 0.371846 6.96028C0.867598 7.45603 1.67147 7.45603 2.16734 6.96028L3.80859 5.3189V9.99814H1.26953C0.568369 9.99814 0 10.5665 0 11.2677C0 11.9688 0.568369 12.5372 1.26953 12.5372H3.80859V16.3458H1.26953C0.568369 16.3458 0 16.9142 0 17.6153C0 18.3165 0.568369 18.8849 1.26953 18.8849H3.80859V22.6935H1.26953C0.568369 22.6935 0 23.2618 0 23.963C0 24.6641 0.568369 25.2325 1.26953 25.2325H3.80859V29.0411H1.26953C0.568369 29.0411 0 29.6095 0 30.3106C0 31.0118 0.568369 31.5802 1.26953 31.5802H3.80859V35.3888H1.26953C0.568369 35.3888 0 35.9571 0 36.6583C0 37.3595 0.568369 37.9278 1.26953 37.9278H3.80859V41.7364H1.26953C0.568369 41.7364 0 42.3048 0 43.006C0 43.7071 0.568369 44.2755 1.26953 44.2755H3.80859V48.0841H1.26953C0.568369 48.0841 0 48.6525 0 49.3536C0 50.0548 0.568369 50.6231 1.26953 50.6231H3.80859V54.9395C3.80859 55.6407 4.37696 56.2091 5.07813 56.2091H9.14063V58.7481C9.14063 59.4493 9.70899 60.0177 10.4102 60.0177C11.1113 60.0177 11.6797 59.4493 11.6797 58.7481V56.2091H15.4883V58.7481C15.4883 59.4493 16.0567 60.0177 16.7578 60.0177C17.459 60.0177 18.0273 59.4493 18.0273 58.7481V56.2091H21.8359V58.7481C21.8359 59.4493 22.4043 60.0177 23.1055 60.0177C23.8066 60.0177 24.375 59.4493 24.375 58.7481V56.2091H28.1836V58.7481C28.1836 59.4493 28.752 60.0177 29.4531 60.0177C30.1543 60.0177 30.7227 59.4493 30.7227 58.7481V56.2091H34.5313V58.7481C34.5313 59.4493 35.0996 60.0177 35.8008 60.0177C36.5019 60.0177 37.0703 59.4493 37.0703 58.7481V56.2091H40.8789V58.7481C40.8789 59.4493 41.4473 60.0177 42.1484 60.0177C42.8496 60.0177 43.418 59.4493 43.418 58.7481V56.2091H47.2266V58.7481C47.2266 59.4493 47.7949 60.0177 48.4961 60.0177C49.1973 60.0177 49.7656 59.4493 49.7656 58.7481V56.2091H53.5742V58.7481C53.5742 59.4493 54.1426 60.0177 54.8438 60.0177C55.5449 60.0177 56.1133 59.4493 56.1133 58.7481V56.2091H60.6656L59.0242 57.8505C58.5284 58.3462 58.5284 59.1501 59.0242 59.646C59.4815 60.0988 60.2916 60.1666 60.8197 59.646L64.6283 55.8374C65.124 55.3416 65.124 54.5377 64.6283 54.0419L60.8196 50.2333Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M26.1527 18.7578C26.4563 18.7578 26.7607 18.6496 27.0036 18.4301C27.5238 17.96 27.5643 17.1572 27.0942 16.6371L23.0877 12.2041L26.7589 8.33395C27.2415 7.82524 27.2203 7.02176 26.7116 6.53921C26.2029 6.05666 25.3994 6.07786 24.9168 6.58656L22.3438 9.29904V7.33203C22.3438 6.63087 21.7754 6.0625 21.0742 6.0625C20.3731 6.0625 19.8047 6.63087 19.8047 7.33203V17.4883C19.8047 18.1894 20.3731 18.7578 21.0742 18.7578C21.7754 18.7578 22.3438 18.1894 22.3438 17.4883V15.1676L25.2105 18.3395C25.4611 18.6169 25.8063 18.7578 26.1527 18.7578Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M30.9766 18.7578C31.6777 18.7578 32.2461 18.1894 32.2461 17.4883V13.6797H33.5156C35.6157 13.6797 37.3242 11.9712 37.3242 9.87109C37.3242 7.77104 35.6157 6.0625 33.5156 6.0625H30.9766C30.2754 6.0625 29.707 6.63087 29.707 7.33203V17.4883C29.707 18.1894 30.2754 18.7578 30.9766 18.7578ZM32.2461 8.60156H33.5156C34.2156 8.60156 34.7852 9.17107 34.7852 9.87109C34.7852 10.5711 34.2156 11.1406 33.5156 11.1406H32.2461V8.60156Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M41.1328 8.60156C41.834 8.60156 42.4023 8.03317 42.4023 7.33203C42.4023 6.63089 41.834 6.0625 41.1328 6.0625C40.4317 6.0625 39.8633 6.63089 39.8633 7.33203C39.8633 8.03317 40.4317 8.60156 41.1328 8.60156Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M41.1328 18.7559C41.8323 18.7559 42.4023 18.1858 42.4023 17.4863V13.043C42.4023 12.3435 41.8323 11.7734 41.1328 11.7734C40.4333 11.7734 39.8633 12.3435 39.8633 13.043V17.4863C39.8633 18.1858 40.4333 18.7559 41.1328 18.7559Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M63.7305 18.7578H56.1133C55.4121 18.7578 54.8438 19.3262 54.8438 20.0273C54.8438 20.7285 55.4121 21.2969 56.1133 21.2969H60.7709L55.6067 26.7241C55.1694 27.1682 55.1203 28.027 55.6512 28.518C56.085 28.9491 56.957 29.0075 57.4463 28.4735L62.4609 23.2026V27.6445C62.4609 28.3457 63.0293 28.9141 63.7305 28.9141C64.4316 28.9141 65 28.3457 65 27.6445V20.0273C65 19.3262 64.4316 18.7578 63.7305 18.7578Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M43.4929 39.4569L39.3154 37.6291C39.341 37.4366 39.3555 37.2405 39.3555 37.041C39.3555 34.5909 37.3622 32.5976 34.9121 32.5976C33.5385 32.5976 32.3086 33.2244 31.4928 34.2069L23.9952 30.9268C23.4587 30.6923 22.8319 30.8547 22.4771 31.3198L9.4009 48.4585C8.97561 49.016 9.08276 49.8126 9.64008 50.2379C10.1263 50.619 10.9747 50.5862 11.4195 49.9987L23.8908 33.6526L30.4973 36.5429C30.4789 36.7066 30.4686 36.8726 30.4686 37.0411C30.4686 39.4912 32.4619 41.4845 34.912 41.4845C36.2531 41.4845 37.4564 40.8864 38.2718 39.9439L43.2896 42.1394C43.4509 42.2105 43.621 42.2461 43.7975 42.2461C44.144 42.2461 44.4805 42.1026 44.7191 41.8512L49.57 36.7528C50.0083 36.3087 50.0546 35.4503 49.5256 34.9589C49.0914 34.529 48.2202 34.4678 47.7305 35.0034L43.4929 39.4569ZM34.9121 38.9453C33.8621 38.9453 33.0078 38.091 33.0078 37.041C33.0078 35.9909 33.8621 35.1367 34.9121 35.1367C35.9622 35.1367 36.8164 35.9909 36.8164 37.041C36.8164 38.091 35.9622 38.9453 34.9121 38.9453Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.5898 33.0078C53.291 33.0078 53.8594 32.4394 53.8594 31.7383C53.8594 31.0371 53.291 30.4688 52.5898 30.4688C51.8887 30.4688 51.3203 31.0371 51.3203 31.7383C51.3203 32.4394 51.8887 33.0078 52.5898 33.0078Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Free Key Performance",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Indicators (KPI) Report"
                        ]
                    }),
                    points: [
                        'AI generated list of Key Performance Indicators',
                        'Specifically generated for your business',
                        'Based on your industry',
                        'For each KPI, we explain the KPI, how to calculate it, and what the target benchmark is'
                    ],
                    image: (parcelRequire("kk8Qe"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "KPI Report"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("bLZ0V")),
                        (parcelRequire("k6BF8")),
                        (parcelRequire("l4ysc"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "*= not guaranteed!"
                    })
                }
            }
        },
        proCoreWorkspace: {
            "two-minute-test": {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "2- Minute\u200B ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        company['testType'] ? company['testType'].charAt(0).toUpperCase() + company['testType'].slice(1) : '',
                        " Ready"
                    ]
                }),
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Intellectual Property',
                    'Corporate Structure',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Human Resources',
                    'IT Systems'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
                isRisk: true,
                isCompleteness: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "70",
                        height: "62",
                        viewBox: "0 0 70 62",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.6095 21.1169L66.6497 19.0768C67.7176 18.0088 67.7176 16.2776 66.6497 15.2098C65.5818 14.142 63.8505 14.1419 62.7828 15.2098L60.7425 17.2499C57.2018 14.4159 52.8645 12.5386 48.125 12.0121V6.39062H50.8594C52.3696 6.39062 53.5938 5.16645 53.5938 3.65625C53.5938 2.14605 52.3696 0.921875 50.8594 0.921875H39.9219C38.4117 0.921875 37.1875 2.14605 37.1875 3.65625C37.1875 5.16645 38.4117 6.39062 39.9219 6.39062H42.6562V12.0121C37.9168 12.5385 33.5795 14.4157 30.0388 17.2499L27.9985 15.2098C26.9306 14.1419 25.1993 14.1419 24.1315 15.2098C23.0638 16.2777 23.0636 18.009 24.1315 19.0768L26.1718 21.1169C22.8006 25.3286 20.7812 30.6668 20.7812 36.4688C20.7812 50.0384 31.821 61.0781 45.3906 61.0781C58.9602 61.0781 70 50.0384 70 36.4688C70 30.6668 67.9807 25.3286 64.6095 21.1169ZM45.3906 55.6094C34.8365 55.6094 26.25 47.0229 26.25 36.4688C26.25 31.1996 28.3903 26.4212 31.8469 22.9566C31.8522 22.9514 31.8581 22.947 31.8634 22.9417C31.8687 22.9363 31.8731 22.9305 31.8784 22.9251C35.343 19.4685 40.1215 17.3281 45.3906 17.3281C50.6598 17.3281 55.4382 19.4685 58.9028 22.9251C58.9081 22.9305 58.9125 22.9363 58.9179 22.9417C58.9232 22.947 58.9291 22.9514 58.9344 22.9566C62.3909 26.4212 64.5312 31.1996 64.5312 36.4688C64.5312 47.0229 55.9448 55.6094 45.3906 55.6094Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.6489 43.4843V45.4476L50.8908 42.8706C50.6212 42.4753 50.1287 42.3037 49.6757 42.4465C49.2226 42.5895 48.9141 43.0141 48.9141 43.4944V48.8794C48.9141 49.4856 49.3996 49.9771 49.9985 49.9771C50.5973 49.9771 51.0829 49.4856 51.0829 48.8794V47.0156L52.7034 49.391C53.0008 49.8262 53.5233 50.0162 54.0039 49.8646C54.4906 49.7108 54.8177 49.2418 54.8177 48.6976V43.4844C54.8177 42.8782 54.3322 42.3867 53.7333 42.3867C53.1344 42.3866 52.6489 42.878 52.6489 43.4843Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M42.0264 43.3759C42.0256 43.3715 42.0248 43.367 42.0239 43.3626C41.9174 42.8203 41.4715 42.4198 40.9393 42.3886C40.4076 42.3579 39.9207 42.7034 39.7562 43.2298C39.7522 43.2424 39.7486 43.255 39.7451 43.2677L39.1997 45.2543L38.6324 43.2572C38.6286 43.2441 38.6247 43.2311 38.6205 43.2182C38.4508 42.6934 37.9615 42.3529 37.4287 42.3898C36.8968 42.4268 36.4549 42.8324 36.3542 43.3761C36.3534 43.3803 36.3527 43.3844 36.3519 43.3886L35.4389 48.6423C35.3352 49.2389 35.7168 49.8099 36.2913 49.9175C36.8653 50.0251 37.4155 49.6288 37.5192 49.0322L37.7279 47.8315L38.0902 49.1069C38.0939 49.12 38.0978 49.133 38.102 49.1459C38.2631 49.6437 38.7099 49.9771 39.2151 49.9771C39.2171 49.9771 39.2192 49.977 39.2212 49.977C39.7289 49.9743 40.1753 49.6355 40.3321 49.134C40.336 49.1214 40.3397 49.1087 40.3432 49.096L40.6925 47.8236L40.9169 49.0433C41.0266 49.6388 41.5802 50.0291 42.1535 49.9154C42.7269 49.8016 43.1029 49.2266 42.9932 48.6312L42.0264 43.3759Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.6992 43.4844V48.8794C44.6992 49.4856 45.2656 49.9771 45.9643 49.9771C46.6629 49.9771 47.2293 49.4856 47.2293 48.8794V43.4844C47.2293 42.8782 46.6629 42.3867 45.9643 42.3867C45.2656 42.3867 44.6992 42.8782 44.6992 43.4844Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M49.5505 36.7228C50.5976 36.7228 51.4475 37.6121 51.4475 38.7108C51.4475 39.8095 50.5976 40.6987 49.5505 40.6987H41.9345C40.7002 40.6987 39.6113 39.9712 39.0941 38.7996C38.5705 37.6161 38.7475 36.2603 39.5557 35.2624C40.6078 33.9612 42.1962 33.0633 43.7323 32.1949L43.738 32.1916C46.1004 30.8571 47.6484 29.879 47.6484 28.5007C47.6484 27.2112 46.4925 26.1204 45.1241 26.1204C43.7291 26.1204 42.5947 27.3092 42.5947 28.771C42.5947 29.8697 41.7461 30.759 40.6977 30.759C39.6493 30.759 38.8007 29.8697 38.8007 28.771C38.8007 25.1172 41.6399 22.1445 45.1241 22.1445C48.6083 22.1445 51.4424 24.9953 51.4424 28.5007C51.4424 32.3546 48.1717 34.2035 45.5417 35.6902L45.5389 35.6918L45.4999 35.7138C44.9131 36.0459 44.3195 36.3818 43.7961 36.7228H49.5505Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.4062 36.4688C16.4062 34.9586 15.1821 33.7344 13.6719 33.7344H2.73438C1.22418 33.7344 0 34.9586 0 36.4688C0 37.9789 1.22418 39.2031 2.73438 39.2031H13.6719C15.1821 39.2031 16.4062 37.9789 16.4062 36.4688Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 22.7969H8.20312C6.69293 22.7969 5.46875 24.0211 5.46875 25.5312C5.46875 27.0414 6.69293 28.2656 8.20312 28.2656H15.5459C17.0561 28.2656 18.2803 27.0414 18.2803 25.5312C18.2803 24.0211 17.0559 22.7969 15.5459 22.7969Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5459 44.6719H8.20312C6.69293 44.6719 5.46875 45.8961 5.46875 47.4062C5.46875 48.9164 6.69293 50.1406 8.20312 50.1406H15.5459C17.0561 50.1406 18.2803 48.9164 18.2803 47.4062C18.2803 45.8961 17.0559 44.6719 15.5459 44.6719Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "FREE 2-Minute Test Investment/Growth/Exit Ready"
                    }),
                    points: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Quick multiple-choice test to determine your company's investment/growth/exit readiness"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Bespoked to your company - its objectives and stage of development"
                        }),
                        'Section by section completeness and risk scores',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: "Real-time reports - with associated risks and suggestions for improvement"
                        }),
                        'Pass/fail certificates'
                    ],
                    image: (parcelRequire("4tyyd"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "2-Minute Test Investment/Growth/Exit Ready"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("4qXP0")),
                        (parcelRequire("6KEUK")),
                        (parcelRequire("5Pn0p"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-text df jcc aic w60 mla mra br45px c12 fs1-25rem",
                        children: "A quick introduction to how our modules work"
                    })
                }
            },
            "data-repository": {
                title: 'Data Repository',
                tooltip: [
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository\u200B",
                isRisk: false,
                isCompleteness: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "70",
                        height: "59",
                        viewBox: "0 0 70 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                            fill: "#4A67FF"
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Data Repository PRO"
                    }),
                    points: [
                        "All your key corporate documents in one place \u2013 easily accessible to all",
                        '160 subsections (Pro) 5 user-defined sections (Pro)',
                        "Not created one before?\xa0 No worries\xa0\u2013 checklists take you through each section",
                        'Completeness scoring',
                        'Prepopulated docs from UK Companies House where available (UK companies only)',
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df",
                                children: [
                                    "Can sync to your chosen cloud provider ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "df ml1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                className: "pen fds w2rem mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                className: "pen fds w2rem mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                className: "pen fds w2rem"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        "Already got a bunch of files?\xa0 AI Filing\xa0Assistant will automatically organize your existing files/data room (Pro)",
                        'Deduper will help weed out old files (Pro)'
                    ],
                    image: (parcelRequire("3Unna"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem",
                        children: [
                            "First time? ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "3 Ways to populate your Data Repository"
                            })
                        ]
                    }),
                    arrayImages: [
                        (parcelRequire("gDAuw")),
                        (parcelRequire("2oIlR")),
                        (parcelRequire("fqHfJ"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "business-audit": {
                title: 'Business Audit',
                tooltip: [
                    'Key Shareholder/Investor Documents',
                    'Commercial Activities',
                    'Legal',
                    'Property',
                    'Intellectual Property',
                    'Insurance',
                    'Corporate Structure',
                    'State Aid',
                    'Finance',
                    'General Data Protection Regulations (GDPR)',
                    'Shares & Share Options',
                    'Taxation',
                    'Social Media',
                    'Key People',
                    'Human Resources',
                    'Environmental, Social & Governmental (ESG)',
                    'Key Advisors - Engagement Letters & Corrrspondence',
                    'IT Systems',
                    'Regulatory',
                    'Standards'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775860-your-business-audit',
                isRisk: true,
                isCompleteness: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "65",
                        height: "59",
                        viewBox: "0 0 65 59",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62.7412 39.2338L54.7026 32.1414C55.3147 30.532 55.651 28.7877 55.651 26.9662C55.651 23.2992 54.2916 19.9438 52.0508 17.3768V2.8418C52.0508 1.79012 51.1982 0.9375 50.1465 0.9375H9.52148C8.4698 0.9375 7.61719 1.79012 7.61719 2.8418V28.8672H1.9043C0.852617 28.8672 0 29.7198 0 30.7715V52.3535C0 55.5036 2.5628 58.0664 5.71289 58.0664H46.3379C49.488 58.0664 52.0508 55.5036 52.0508 52.3535V47.2169L53.3202 48.6554C55.8676 51.5423 60.3225 51.6813 63.0451 48.9589C65.7676 46.2363 65.6284 41.7811 62.7412 39.2338ZM7.61719 52.3535C7.61719 53.4035 6.76292 54.2578 5.71289 54.2578C4.66286 54.2578 3.80859 53.4035 3.80859 52.3535V32.6758H7.61719V52.3535ZM48.2422 52.3535C48.2422 53.4035 47.3879 54.2578 46.3379 54.2578H11.0995C11.3108 53.662 11.4258 53.0209 11.4258 52.3535V4.74609H48.2422V14.2642C46.1183 13.057 43.2377 12.3633 40.625 12.3633C40.602 12.3633 40.5938 12.3633 40.5935 12.3633H17.1387C16.087 12.3633 15.2344 13.2159 15.2344 14.2676C15.2344 15.3193 16.087 16.1719 17.1387 16.1719H31.2314C30.0337 17.2624 29.0179 18.5491 28.2346 19.9805H17.1387C16.087 19.9805 15.2344 20.8331 15.2344 21.8848C15.2344 22.9364 16.087 23.7891 17.1387 23.7891H26.8009C26.5729 24.8123 26.4518 25.8753 26.4518 26.9661C26.4518 27.1777 26.4574 27.3881 26.4663 27.5977H17.1387C16.087 27.5977 15.2344 28.4503 15.2344 29.502C15.2344 30.5536 16.087 31.4062 17.1387 31.4062H27.143C27.5806 32.774 28.2147 34.0546 29.0122 35.2148H17.1387C16.087 35.2148 15.2344 36.0675 15.2344 37.1191C15.2344 38.1708 16.087 39.0234 17.1387 39.0234H32.8287C35.1721 40.6266 38.0039 41.5657 41.0514 41.5657C42.8732 41.5657 44.6177 41.2292 46.2272 40.617L48.2422 42.9007V52.3535ZM41.0514 37.7572C35.1013 37.7572 30.2604 32.9164 30.2604 26.9662C30.2604 21.016 35.1013 16.1752 41.0514 16.1752C47.0016 16.1752 51.8425 21.016 51.8425 26.9662C51.8425 32.9164 47.0016 37.7572 41.0514 37.7572ZM60.3519 46.2659C59.1828 47.435 57.2697 47.3752 56.1759 46.1355L49.6594 38.7504C50.8741 37.8607 51.9464 36.7883 52.836 35.5736L60.2215 42.0897C61.4613 43.1836 61.521 45.0967 60.3519 46.2659Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M28.5645 42.832H17.1387C16.087 42.832 15.2344 43.6846 15.2344 44.7363C15.2344 45.788 16.087 46.6406 17.1387 46.6406H28.5645C29.6161 46.6406 30.4688 45.788 30.4688 44.7363C30.4688 43.6846 29.6161 42.832 28.5645 42.832Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Business Audit PRO"
                    }),
                    points: [
                        'Step by step audit of your business',
                        'Quick - multiple choice questions',
                        'Individually bespoked to your business, industry, stage of development and objective',
                        'At a glance red/amber/green status',
                        'Both section and overall completeness and risk scores',
                        'Quickly identify strengths and weaknesses',
                        'Risks and recommendations for each section',
                        'All in real-time',
                        'Improvement tracking over time'
                    ],
                    image: (parcelRequire("izGj8"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Business Audit"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("76mOo")),
                        (parcelRequire("eDzCn")),
                        (parcelRequire("6yoVR"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "unaudited-certification": {
                title: 'Diligentsia Unaudited Certification',
                helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6775868-your-certification',
                isCertificate: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "51",
                        height: "65",
                        viewBox: "0 0 51 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M47.0127 19.2576C46.1594 18.4418 45.2769 17.5983 44.9976 16.9214C44.6908 16.1778 44.716 14.9085 44.7405 13.6812C44.7839 11.5015 44.8331 9.03118 43.1542 7.3442C41.4723 5.65418 38.9981 5.69252 36.817 5.72756C35.592 5.74673 34.3245 5.76692 33.584 5.45829C32.9072 5.1762 32.0659 4.29285 31.2523 3.4387C29.7169 1.82688 27.977 0 25.498 0C23.0189 0 21.279 1.82688 19.7438 3.43857C18.9302 4.29285 18.0889 5.1762 17.4121 5.45816C16.6717 5.76679 15.4042 5.74673 14.1792 5.72731C11.9962 5.69392 9.52378 5.65406 7.84202 7.34395C6.16291 9.03092 6.21217 11.5013 6.25559 13.681C6.27996 14.9085 6.30536 16.1778 5.99863 16.9212C5.7192 17.5982 4.83674 18.4418 3.98335 19.2575C2.37623 20.7939 0.554688 22.5351 0.554688 25.011C0.554688 27.4868 2.37623 29.2282 3.98335 30.7643C4.83674 31.5801 5.7192 32.4236 5.99851 33.1005C6.30536 33.8441 6.28009 35.1134 6.25559 36.3409C6.21217 38.5205 6.16304 40.9908 7.84189 42.6779C8.90031 43.7414 10.2723 44.1202 11.6877 44.2464V63.0965C11.6877 63.7357 12.0084 64.3322 12.5416 64.6848C13.0746 65.0375 13.7493 65.0991 14.3374 64.849L25.498 60.1023L36.6587 64.849C36.8979 64.9507 37.1513 65.0008 37.4038 65.0008C37.772 65.0008 38.1381 64.8941 38.4544 64.6848C38.9874 64.3323 39.3083 63.7357 39.3083 63.0965V44.2469C40.7237 44.1207 42.0955 43.7417 43.154 42.6784C44.8331 40.9914 44.7838 38.5209 44.7404 36.3413C44.716 35.1138 44.6906 33.8445 44.9973 33.1012C45.2768 32.4241 46.1592 31.5805 47.0126 30.7648C48.6197 29.2284 50.4413 27.4872 50.4413 25.0114C50.4413 22.5355 48.6199 20.794 47.0127 19.2576ZM26.2432 56.2806C25.7671 56.0779 25.2288 56.0779 24.7528 56.2806L15.4964 60.2173V44.2896C16.251 44.3044 16.9392 44.3671 17.4121 44.564C18.0889 44.8461 18.9302 45.7295 19.7438 46.5836C21.279 48.1954 23.0189 50.0223 25.498 50.0223C27.977 50.0223 29.7169 48.1954 31.2521 46.5838C32.0657 45.7295 32.9071 44.8461 33.5839 44.5642C34.0569 44.367 34.745 44.3042 35.4996 44.2893V60.2172L26.2432 56.2806ZM44.3809 28.0117C43.2414 29.1008 42.0633 30.227 41.4768 31.6483C40.8669 33.1262 40.9003 34.7992 40.9325 36.4172C40.9608 37.839 40.9929 39.4507 40.4544 39.9916C39.914 40.5345 38.3005 40.5095 36.8767 40.4868C35.2616 40.4616 33.5914 40.4352 32.1189 41.0485C30.702 41.6389 29.5796 42.8174 28.494 43.9571C27.4865 45.0148 26.3447 46.2137 25.4977 46.2137C24.6508 46.2137 23.509 45.0147 22.5013 43.9569C21.4159 42.8173 20.2935 41.6389 18.8765 41.0484C17.6995 40.5581 16.3964 40.4765 15.0958 40.4765C14.7694 40.4765 14.4429 40.4817 14.1189 40.4868C12.695 40.509 11.0815 40.5346 10.5411 39.9916C10.0028 39.4505 10.0349 37.8391 10.0631 36.4172C10.0953 34.7992 10.1287 33.126 9.51871 31.648C8.9323 30.227 7.75416 29.1008 6.61474 28.0115C5.55924 27.0026 4.36295 25.859 4.36295 25.0112C4.36295 24.1634 5.55924 23.0197 6.61474 22.0108C7.75416 20.9216 8.9323 19.7954 9.51883 18.3742C10.1287 16.8963 10.0953 15.2233 10.0631 13.6052C10.0348 12.1833 10.0027 10.5716 10.5412 10.0307C11.0816 9.48783 12.6959 9.51297 14.1188 9.5357C15.7348 9.56083 17.4044 9.58737 18.8768 8.97379C20.2936 8.38358 21.416 7.20506 22.5015 6.06539C23.5091 5.00748 24.6511 3.80864 25.498 3.80864C26.3449 3.80864 27.4869 5.00748 28.4944 6.06526C29.5798 7.20506 30.7022 8.38346 32.1191 8.97367C33.5916 9.58724 35.2614 9.56045 36.8771 9.53557C38.3009 9.51335 39.9143 9.48796 40.4548 10.0307C40.9931 10.5716 40.9609 12.1832 40.9328 13.6051C40.9005 15.223 40.8671 16.8962 41.4771 18.3742C42.0635 19.7952 43.2417 20.9214 44.3811 22.0106C45.4366 23.0196 46.6329 24.1633 46.6329 25.0111C46.6329 25.8589 45.4365 27.0026 44.3809 28.0117Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M25.4974 11.1484C17.9579 11.1484 11.8242 17.2991 11.8242 24.8594C11.8242 32.4197 17.9579 38.5705 25.4974 38.5705C33.0368 38.5705 39.1705 32.4198 39.1705 24.8595C39.1705 17.2993 33.0368 11.1484 25.4974 11.1484ZM25.4974 34.7619C20.058 34.7619 15.6329 30.3197 15.6329 24.8595C15.6329 19.3994 20.058 14.9572 25.4974 14.9572C30.9367 14.9572 35.3619 19.3994 35.3619 24.8595C35.3619 30.3197 30.9367 34.7619 25.4974 34.7619Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M27.733 21.2648L24.2814 24.7165L23.2665 23.7016C22.5229 22.958 21.3171 22.958 20.5734 23.7016C19.8297 24.4452 19.8297 25.651 20.5734 26.3947L22.9349 28.7562C23.292 29.1133 23.7763 29.314 24.2814 29.314C24.7864 29.314 25.2709 29.1134 25.6279 28.7562L30.426 23.9579C31.1697 23.2142 31.1697 22.0085 30.426 21.2648C29.6824 20.5211 28.4766 20.5211 27.733 21.2648Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Diligentsia ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Certification"
                        ]
                    }),
                    points: [
                        'Complete modules',
                        'Completeness and risk scoring',
                        'Unaudited certification:',
                        "Gold certification \u2013 opens up access to InvestorMatch",
                        'Digital certification valid for 3 months',
                        'Or, with Diligentsia Pro PLUS, have your lawyer or accountant assist and provide you an audited certificate'
                    ],
                    subMenu: {
                        index: 2,
                        points: [
                            "- Bronze \u2013 basic level reached",
                            "- Silver \u2013 potentially investible",
                            "- Gold \u2013 sophisticated"
                        ]
                    },
                    image: (parcelRequire("9WBs6"))
                }
            }
        },
        appStoreInvestment: {
            "warranty-disclosure": {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Expansion Pack -",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Warranty Disclosure"
                    ]
                }),
                tooltip: [
                    'Share Capital And Authority',
                    'Information',
                    'Business Plan',
                    'Accounts',
                    'Management Accounts',
                    'Events Since The Accounts Date',
                    'Taxation',
                    'Litigation',
                    'Properties',
                    'Intellectual Property',
                    'Assets, Debt & Stock',
                    'Contracts With Connected Persons',
                    'Employment and Consultancy Arrangements',
                    'Statutory & Legal Requirements',
                    'Records & Registers',
                    'Insurance',
                    'Group Structure',
                    'Agreements & Capital Commitments',
                    'Borrowings & Facilities',
                    'Social Obligations'
                ],
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557715-expansion-pack-warranty-disclosure-module',
                isRisk: true,
                isLockArea: true,
                isCompleteness: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "65",
                        height: "65",
                        viewBox: "0 0 65 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.2324 50.4004C45.2841 50.4004 46.1367 49.5478 46.1367 48.4961V38.9746C46.1367 37.9229 45.2841 37.0703 44.2324 37.0703C43.1807 37.0703 42.3281 37.9229 42.3281 38.9746V48.4961C42.3281 49.5478 43.1806 50.4004 44.2324 50.4004Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M44.2324 57.3828C45.2841 57.3828 46.1367 56.5302 46.1367 55.4785C46.1367 54.4268 45.2841 53.5742 44.2324 53.5742C43.1807 53.5742 42.3281 54.4268 42.3281 55.4785C42.3281 56.5302 43.1807 57.3828 44.2324 57.3828Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.2492 56.4708L53.0864 36.7718C54.0841 33.1317 54.5899 29.3753 54.5899 25.5931V4.44314C54.5899 2.99778 53.0427 2.0794 51.7738 2.77168L51.2295 3.06862C43.9058 7.06359 34.7955 6.02371 28.5602 0.481185L28.5599 0.480931C27.8384 -0.16031 26.7513 -0.16031 26.03 0.480931L26.0297 0.481185C19.7944 6.02384 10.6844 7.06346 3.36058 3.06875L2.81608 2.77168C1.54718 2.0794 0 2.99778 0 4.44314V25.5931C0 34.0789 2.51469 42.2785 7.27201 49.3054C12.0296 56.3323 18.7087 61.7123 26.5876 64.8639C27.0322 65.0418 27.5269 65.0443 27.9737 64.8737C28.361 64.9557 28.7658 65 29.1862 65H59.2788C63.6562 65.0001 66.4072 60.2791 64.2492 56.4708ZM25.3907 51.4362C18.8667 47.1952 14.2664 40.7043 12.3796 33.2618H25.3907V51.4362ZM25.3907 29.4533H11.6638C11.5067 28.1844 11.4258 26.896 11.4258 25.5932V16.8827C11.9016 16.9045 12.3776 16.9155 12.8515 16.9155C17.1728 16.9155 21.4508 16.0128 25.3907 14.2899V29.4533ZM26.3579 9.55809C22.2503 11.8799 17.5799 13.1072 12.8515 13.1072C11.8149 13.1072 10.7678 13.0472 9.7391 12.9287C8.6087 12.7984 7.6172 13.6823 7.6172 14.8202V25.5932C7.6172 38.0309 14.137 49.3276 24.7563 55.517L24.2158 56.4706C23.7207 57.3443 23.4867 58.2659 23.4687 59.1678C11.3821 52.4258 3.8086 39.7285 3.8086 25.5931V7.49815C6.70885 8.69811 9.77744 9.2873 12.835 9.28705C17.9808 9.28679 23.0919 7.6166 27.295 4.37573C33.9954 9.54248 43 10.7177 50.7813 7.49815V25.5932C50.7813 27.6811 50.6118 29.7602 50.276 31.8122L49.2029 29.9185C48.6296 28.9068 47.8236 28.1628 46.9082 27.6812C46.9495 26.9846 46.9727 26.2866 46.9727 25.5932V14.8202C46.9727 13.6823 45.9813 12.7984 44.8509 12.9286C43.8222 13.047 42.775 13.1071 41.7384 13.1071C37.0101 13.1071 32.3397 11.8798 28.232 9.55797C27.6506 9.22941 26.9394 9.22941 26.3579 9.55809ZM29.1993 29.4533V14.29C33.139 16.0128 37.4169 16.9157 41.7384 16.9157C42.2124 16.9157 42.6883 16.9046 43.1641 16.8828V25.5933C43.1641 26.1033 43.1508 26.6163 43.1257 27.1289C41.7444 27.3967 40.4496 28.1726 39.5584 29.4533H29.1993ZM37.3676 33.2619L29.1993 47.6766V33.2619H37.3676ZM59.2788 61.1915H29.1863C27.7272 61.1915 26.8101 59.6178 27.5296 58.3484L42.5758 31.7963C43.3053 30.5089 45.16 30.5089 45.8894 31.7963L60.9357 58.3484C61.6549 59.6178 60.7379 61.1915 59.2788 61.1915Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Expansion Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Warranty Disclosure"
                        ]
                    }),
                    points: [
                        "Save thousands on lawyers\u2019 fees",
                        'Normally an expensive exercise at the end of a transaction',
                        'Get ahead, early completion will identify showstoppers and give you time to fix them',
                        'Based on the UK BVCA standard disclosure letter',
                        'Contributes to Diligentsia certification',
                        'Part of DD Pack available to investors'
                    ],
                    image: (parcelRequire("bnaJ5"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Warranty Disclosure"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("2mFD2")),
                        (parcelRequire("ca6j0")),
                        (parcelRequire("5fyAg"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "director-questionnaires": {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Expansion Pack -",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Directors Questionnaire"
                    ]
                }),
                tooltip: directors && directors.length > 0 && directors.map((d)=>typeof d === 'object' ? d.name || '' : d).filter(Boolean),
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557468-directors-questionnaire-module',
                isRisk: true,
                isLockArea: true,
                isCompleteness: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Expansion Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Directors\u2019 Questionnaires"
                        ]
                    }),
                    points: [
                        'Normally part of purchase/sale or investment',
                        'Identify any issues in advance - time for rectification',
                        'Pre-population from Companies House where relevant',
                        'Completeness and risk scoring',
                        'Impress your counterparty with your organisation',
                        'Contributes to Diligentsia certification'
                    ],
                    image: (parcelRequire("3e8So"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Directors\u2019 Questionnaires"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("5NBD1")),
                        (parcelRequire("gw040")),
                        (parcelRequire("77FeN"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "Threshold scores required for Diligentsia certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "investor-leads": {
                title: 'InvestorMatch',
                isRisk: true,
                isLockArea: true,
                isCompleteness: true,
                modalShow: 'seeCertificate',
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "65",
                        height: "65",
                        viewBox: "0 0 65 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                            "clip-path": "url(#clip0_1258_25999)",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M53.3274 48.6467C52.8032 48.4258 52.1557 48.2168 51.3995 48.0241V44.5064C52.123 44.5726 52.8104 44.7193 53.4369 44.9395C54.0915 45.2082 54.5234 45.0149 54.8537 44.6302C55.0686 44.3753 55.1774 44.0837 55.1774 43.7632C55.1774 43.1728 54.8727 42.739 54.3301 42.5457C53.4651 42.2154 52.4808 42.0063 51.3995 41.9238V41.1079C51.3995 40.8123 51.2907 40.5469 51.0849 40.3412C50.6682 39.9244 49.9506 39.9277 49.5469 40.353C49.3549 40.5587 49.2533 40.8195 49.2533 41.1079V41.9683C48.4899 42.0797 47.8123 42.3038 47.2343 42.6354C46.5305 43.0391 45.9898 43.5601 45.6288 44.1833C45.2677 44.8058 45.0842 45.4946 45.0842 46.2312C45.0842 47.0811 45.3168 47.8006 45.7742 48.3695C46.2087 48.9101 46.7585 49.3328 47.4086 49.6257C47.9211 49.857 48.5403 50.0766 49.2533 50.2797V53.654C48.3994 53.5616 47.5705 53.3387 46.7841 52.9901C46.2815 52.7634 45.6674 52.8689 45.3011 53.2673C45.0737 53.5144 44.9531 53.823 44.9531 54.1585C44.9531 54.4279 45.0344 54.6795 45.1923 54.9036C45.347 55.1271 45.5475 55.2909 45.7828 55.3886C46.8621 55.8486 48.0279 56.1435 49.2533 56.2674V57.1317C49.2533 57.5249 49.4237 57.77 49.5712 57.9116C49.771 58.0977 50.0292 58.196 50.3182 58.196C50.6236 58.196 50.891 58.0905 51.0915 57.8912C51.2927 57.6927 51.3995 57.4299 51.3995 57.1317V56.2654C52.1328 56.1789 52.7999 55.9915 53.3884 55.7058C54.121 55.3493 54.6977 54.8604 55.1027 54.2509L55.1034 54.2496C55.5123 53.631 55.7194 52.9338 55.7194 52.1769C55.7194 51.2529 55.4802 50.4888 55.009 49.9068C54.5607 49.3524 53.9952 48.9285 53.3274 48.6467ZM53.0299 52.0648C53.0299 52.6343 52.8484 53.3853 51.3995 53.6317V50.8498C51.9133 51.0163 52.3189 51.1886 52.6086 51.3643C52.9002 51.5406 53.0299 51.7568 53.0299 52.0648ZM49.2533 44.6361V47.4638C48.813 47.3131 48.463 47.1453 48.2087 46.9625C47.925 46.76 47.792 46.4854 47.792 46.1001C47.792 45.6794 47.9447 45.3622 48.2736 45.102C48.5312 44.8982 48.8595 44.7423 49.2533 44.6361Z",
                                    fill: "#4A67FF",
                                    stroke: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M55.7051 35.688C56.4818 34.359 57.2132 32.91 57.5881 31.6617C59.3672 31.477 60.7638 29.9869 60.7638 28.1596V26.2743C60.7638 24.3228 59.1766 22.7356 57.2251 22.7356H53.9347V22.2644C53.9347 18.135 51.4662 14.5782 47.9311 12.9713C48.9619 11.9118 49.6031 10.4706 49.6031 8.87886C49.6031 5.637 46.9661 3 43.7249 3C40.483 3 37.846 5.637 37.846 8.87886C37.846 10.4707 38.4871 11.9119 39.5181 12.9715C35.9832 14.5785 33.5144 18.1352 33.5144 22.2644V22.7356H27.5385V22.2644C27.5385 18.1352 25.0701 14.5786 21.5353 12.9716C22.5664 11.912 23.2075 10.4707 23.2075 8.87886C23.2075 5.637 20.5705 3 17.3287 3C14.0868 3 11.4498 5.637 11.4498 8.87886C11.4498 10.4707 12.0909 11.912 13.122 12.9716C9.58721 14.5786 7.11879 18.1352 7.11879 22.2644V22.7356H3.82778C1.87624 22.7356 0.289062 24.3228 0.289062 26.2743V28.1596C0.289062 29.9914 1.69267 31.4845 3.47817 31.6631C5.1643 37.1824 15.0032 50.2419 24.2763 54.9451L25.6269 63.8581C25.7377 64.5908 26.4192 65.0993 27.1552 64.984C27.8878 64.8726 28.3917 64.1884 28.281 63.4558L26.9337 54.5664C26.8144 53.6705 26.2652 52.9071 25.412 52.4641C17.2422 48.3592 8.3023 36.551 6.3003 31.699H54.7362C54.4046 32.4992 53.8666 33.5595 53.0671 34.8767C52.1398 34.6873 51.1785 34.5916 50.1968 34.5916C41.1097 34.5916 34.0368 43.0442 36.0102 52.1803C36.0174 52.2137 36.0195 52.2485 36.0269 52.2819C35.905 52.3481 35.785 52.411 35.6664 52.47C34.8453 52.8652 34.2654 53.6378 34.1107 54.5585L32.7607 63.4558C32.6493 64.1884 33.1533 64.8726 33.8866 64.984C33.9547 64.9944 34.0222 64.999 34.0897 64.999C34.7418 64.999 35.3139 64.5226 35.4148 63.8581L36.8499 54.8796C36.8575 54.8758 36.865 54.8708 36.8725 54.867C39.1058 60.0146 44.2373 63.6274 50.2014 63.6274C58.2009 63.6274 64.7095 57.1188 64.7095 49.1194C64.7095 43.061 60.982 37.8632 55.7051 35.688ZM40.5302 8.87886C40.5302 7.11737 41.9634 5.68418 43.7249 5.68418C45.4864 5.68418 46.9189 7.11737 46.9189 8.87886C46.9189 10.596 45.5547 11.9908 43.8544 12.0604C43.8108 12.0599 43.7686 12.0539 43.7249 12.0539C43.6811 12.0539 43.639 12.0599 43.5954 12.0604C41.8951 11.9908 40.5302 10.596 40.5302 8.87886ZM36.1985 22.2644C36.1985 18.158 39.5054 14.8147 43.5954 14.7446C43.6395 14.7456 43.6805 14.7577 43.7249 14.7577C43.7692 14.7577 43.8102 14.7456 43.8544 14.7446C47.9437 14.8147 51.2506 18.158 51.2506 22.2644V22.7356H36.1985V22.2644ZM14.134 8.87886C14.134 7.11737 15.5672 5.68418 17.3287 5.68418C19.0901 5.68418 20.5233 7.11737 20.5233 8.87886C20.5233 10.596 19.1585 11.9908 17.4582 12.0604C17.4146 12.0599 17.3724 12.0539 17.3287 12.0539C17.2849 12.0539 17.2427 12.0599 17.1991 12.0604C15.4988 11.9908 14.134 10.596 14.134 8.87886ZM9.80298 22.2644C9.80298 18.158 13.1099 14.8147 17.1991 14.7446C17.2433 14.7456 17.2843 14.7577 17.3287 14.7577C17.3731 14.7577 17.414 14.7456 17.4582 14.7446C21.5474 14.8147 24.8543 18.158 24.8543 22.2644V22.7356H9.80298V22.2644ZM2.97325 26.2743C2.97325 25.8031 3.35661 25.4198 3.82778 25.4198H57.2251C57.6963 25.4198 58.0796 25.8031 58.0796 26.2743V28.1596C58.0796 28.6308 57.6963 29.0142 57.2251 29.0142H3.82778C3.35661 29.0142 2.97325 28.6308 2.97325 28.1596V26.2743ZM50.2014 60.9433C43.6231 60.9433 38.369 55.5713 38.369 49.12C38.369 42.6626 43.6799 37.1619 50.4304 37.2913C56.8042 37.4128 62.0253 42.6473 62.0253 49.1194C62.0253 55.6391 56.7212 60.9433 50.2014 60.9433Z",
                                    fill: "#4A67FF",
                                    stroke: "#4A67FF"
                                })
                            ]
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "InvestorMatch"
                    }),
                    points: [
                        'Open to Diligentsia gold certification only',
                        "Matches your investment requirements against investors\u2019 investment criteria",
                        "A \u201CFit Report\u201D which shows each the party the Fit with the other",
                        "Supported with a comprehensive\xa0Due Diligence Pack, already completed:",
                        'At-a-glance module progress and status',
                        'Access to reports for each module',
                        'Supported with a comprehensive Due Diligence Pack, already completed:'
                    ],
                    subMenu: {
                        index: 6,
                        points: [
                            "- Data Repository Report",
                            "- 20-section Business Audit",
                            "- Directors\u2019 questionnaires",
                            "- Draft Warranty Disclosure"
                        ]
                    },
                    image: (parcelRequire("c1JdN"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "InvestorMatch"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("dCrgl")),
                        (parcelRequire("kGT2Y")),
                        (parcelRequire("50m9m"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "To keep standards up, this module is only available to Diligentsia Gold certified companies",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w3rem",
                                    src: (parcelRequire("93hnj")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            },
            "checklist-builder": {
                title: 'Automated Diligence Checklist Builder',
                isPaperIcon: true,
                isDescription: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "You can create your own ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " bespoked pre-investment checklists"
                    ]
                }),
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "65",
                        height: "65",
                        viewBox: "0 0 65 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                            "clip-path": "url(#clip0_1258_26722)",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M21.0762 30.7226C22.1279 30.7226 22.9805 29.8701 22.9805 28.8184C22.9805 27.7666 22.1279 26.9141 21.0762 26.9141C20.0245 26.9141 19.1719 27.7666 19.1719 28.8184C19.1719 29.8701 20.0245 30.7226 21.0762 30.7226Z",
                                    fill: "#4A67FF",
                                    stroke: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M56.8305 35.0965C56.0911 34.3487 54.8855 34.342 54.1375 35.0816L43.9312 45.1756L41.4617 42.7061C40.7182 41.9625 39.5124 41.9625 38.7687 42.7061C38.025 43.4498 38.025 44.6555 38.7687 45.3992L42.5773 49.2078C42.9491 49.5796 43.4364 49.7656 43.9239 49.7656C44.4079 49.7656 44.8919 49.5823 45.263 49.2153L56.8157 37.7895C57.5635 37.05 57.57 35.8442 56.8305 35.0965Z",
                                    fill: "#4A67FF",
                                    stroke: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M55.4783 23.1054H42.0213V9.52145C42.0213 4.27132 37.75 0 32.4999 0H9.52145C4.27132 0 0 4.27132 0 9.52145V28.8183C0 33.4164 3.27665 37.2637 7.61716 38.1484V44.0526C7.61716 44.8199 8.07775 45.5123 8.78538 45.8088C9.4986 46.1077 10.314 45.9442 10.8567 45.4101L18.0452 38.3397H26.787V47.8612C26.787 53.1113 31.0583 57.3826 36.3085 57.3826H38.2128V63.0955C38.2128 63.8657 38.6766 64.5601 39.3883 64.8548C40.0999 65.1496 40.919 64.9866 41.4636 64.4419L48.523 57.3826H55.4783C60.7285 57.3826 64.9998 53.1113 64.9998 47.8612V32.6268C64.9998 27.3767 60.7286 23.1054 55.4783 23.1054ZM26.787 32.6268V34.5311H17.2656C16.7659 34.5311 16.2864 34.7274 15.9302 35.0778L11.4257 39.5084V36.4354C11.4257 35.3837 10.5731 34.5311 9.52145 34.5311C6.37137 34.5311 3.80858 31.9683 3.80858 28.8183V9.52145C3.80858 6.37137 6.37137 3.80858 9.52145 3.80858H32.4999C35.65 3.80858 38.2128 6.37137 38.2128 9.52145V23.1054H36.3085C31.0583 23.1054 26.787 27.3767 26.787 32.6268ZM61.1912 47.8612C61.1912 51.0112 58.6284 53.574 55.4783 53.574H47.7342C47.2291 53.574 46.7447 53.7747 46.3878 54.1319L42.0213 58.4981V55.4783C42.0213 54.4267 41.1687 53.574 40.1171 53.574H36.3085C33.1584 53.574 30.5956 51.0112 30.5956 47.8612V32.6268C30.5956 29.4768 33.1584 26.914 36.3085 26.914H55.4783C58.6284 26.914 61.1912 29.4768 61.1912 32.6268V47.8612Z",
                                    fill: "#4A67FF",
                                    stroke: "#4A67FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M21.0762 7.61719C17.9261 7.61719 15.3633 10.18 15.3633 13.3301C15.3633 14.3817 16.2159 15.2344 17.2676 15.2344C18.3192 15.2344 19.1719 14.3817 19.1719 13.3301C19.1719 12.28 20.0261 11.4258 21.0762 11.4258C22.1262 11.4258 22.9804 12.28 22.9804 13.3301C22.9804 13.8252 22.4192 14.797 21.5734 15.1334C20.1145 15.7136 19.1719 17.103 19.1719 18.6729V21.2011C19.1719 22.2528 20.0245 23.1054 21.0762 23.1054C22.1278 23.1054 22.9677 22.2528 22.9677 21.2011L22.9684 18.6724C25.1393 17.8087 26.789 15.512 26.789 13.3301C26.789 10.18 24.2264 7.61719 21.0762 7.61719Z",
                                    fill: "#4A67FF",
                                    stroke: "#4A67FF"
                                })
                            ]
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4"
                            }),
                            " AnyList Checklist ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Builder"
                        ]
                    }),
                    points: [
                        'Undertaking M&A? Create relevant automated dule diligence checklists bespoked to target company',
                        'You can add your own questions and desired answers',
                        'Questions: Can choose subjective, objective or a mixture',
                        'Completeness and risk scoring',
                        'Reporting',
                        'Workflow Manager: Can send to target company and monitor completeness'
                    ],
                    image: (parcelRequire("8DFan"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "AnyList Checklist Builder"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("c4Hy6")),
                        (parcelRequire("kkcIb")),
                        (parcelRequire("78dFL"))
                    ],
                    checkList: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for you"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for your target user"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Reusable by the target company"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Company gains value from completion - risks & recommendations"
                                })
                            ]
                        })
                    ]
                }
            },
            "investment-readiness-checklist": {
                title: 'Investment Readiness',
                tooltip: [
                    "Key Investment Documents\u200B",
                    'Clear Identification Of Growth Opportunities',
                    'Financial Diligence',
                    'Legal Diligence',
                    "I.P. Diligence\u200B",
                    "Misc Diligence\u200B",
                    'Demonstration of Market Need',
                    'Demonstration of Early Customer Traction',
                    'Clear Definition Of Business Model Future Profitability',
                    'Operational Efficiency Assessment'
                ],
                logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/ehe-partner-logo.png',
                isRisk: true,
                isLockArea: true,
                isCompleteness: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Expansion Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Directors\u2019 Questionnaires"
                        ]
                    }),
                    points: [
                        'Normally part of purchase/sale or investment',
                        'Identify any issues in advance - time for rectification',
                        'Pre-population from Companies House where relevant',
                        'Completeness and risk scoring',
                        'Impress your counterparty with your organisation',
                        'Contributes to Diligentsia certification'
                    ],
                    image: (parcelRequire("3e8So"))
                }
            }
        },
        appStoreGrowth: {
            "cybersecurity": {
                title: 'SME Cybersecurity',
                logo: (parcelRequire("kMt1I")),
                extraModule: {
                    text: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Including 30-minute video ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " consultation"
                        ]
                    }),
                    btnText: 'Free'
                },
                isPartner: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("kMt1I")),
                        alt: ""
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Partner Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Cybersecurity"
                        ]
                    }),
                    points: [
                        "An expansion pack for diligencing your organisation\u2019s cybersecurity protection and preparedness",
                        "Bespoked to each company\u2019s outline platform architecture",
                        'Reporting, completeness and risk scores',
                        'Risk analysis and recommendations',
                        'Includes a 30 minute video call with our cyber security partner to analyze your report'
                    ],
                    isStoryVideo: true,
                    image: (parcelRequire("4IKT1")),
                    imageStyle: {
                        height: '100%',
                        width: '100%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "SME Cybersecurity"
                    }),
                    isStoryVideo: true,
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("a5jEe")),
                        (parcelRequire("5GyoP")),
                        (parcelRequire("hKcfB"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-4",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("jalLz")),
                                    alt: ""
                                }),
                                " "
                            ]
                        })
                    })
                }
            },
            "Alternative Business Funding": {
                title: 'Alternative Business Funding',
                logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/abf-partner-logo.png',
                extraModule: {
                    text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "One applications to 140 funding choices"
                    }),
                    btnText: 'Free'
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Alternative Business Funding"
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("5G1H8")),
                        (parcelRequire("cO4sV")),
                        (parcelRequire("9nX0s"))
                    ]
                }
            }
        },
        appStoreExit: {
            "Business For Sale": {
                title: 'Business For Sale',
                logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png',
                extraModule: {
                    text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Enhance your value and speed of sale on Businesses For Sale"
                    }),
                    btnText: 'Free'
                },
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: 'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png',
                        alt: ""
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Partner Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Business For Sale"
                        ]
                    }),
                    points: [
                        'Get a report on what to fix personalized to your business',
                        'Organize key documents',
                        'Business audit',
                        'Risks and recommendations',
                        'Diligence reports to show buyers'
                    ],
                    image: (parcelRequire("tYq1A")),
                    imageStyle: {
                        height: '70%',
                        width: '70%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Business For Sale"
                    }),
                    stepImage: (parcelRequire("g06LD")),
                    arrayImages: [
                        (parcelRequire("hlWaF")),
                        (parcelRequire("iOEPt")),
                        (parcelRequire("laFXl")),
                        (parcelRequire("dDdZn")),
                        (parcelRequire("apeEM"))
                    ]
                }
            }
        },
        proPlus: {
            "pro-plus": {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Diligentsia Audited Quarterly Certification"
                }),
                helpLink: 'https://intercom.help/diligentsia-limited/en/articles/8557463-diligentsia-pro-plus-plan',
                isProPlus: true,
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "53",
                        height: "40",
                        viewBox: "0 0 53 40",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M46.2939 6.76571C42.7419 6.76571 39.8523 9.67063 39.8523 13.2415C39.8523 14.6693 40.3286 15.9785 41.1102 17.0502L36.7065 22.9516L30.9516 11.5358C32.1732 10.3565 32.9422 8.70731 32.9422 6.87426C32.9422 3.30336 30.0526 0.398438 26.5006 0.398438C22.9485 0.398438 20.0589 3.30336 20.0589 6.87426C20.0589 8.70731 20.8279 10.3565 22.0495 11.5358L16.2946 22.9516L11.891 17.0502C12.6725 15.9785 13.1489 14.6693 13.1489 13.2415C13.1489 9.67063 10.2593 6.76571 6.70723 6.76571C3.1552 6.76571 0.265625 9.67063 0.265625 13.2415C0.265625 16.4242 2.56548 19.0633 5.57961 19.6027L7.76315 37.8956C7.8757 38.8431 8.67449 39.5551 9.62335 39.5551H43.3778C44.3266 39.5551 45.1254 38.8431 45.238 37.8956L47.4215 19.6027C50.4356 19.0633 52.7355 16.4242 52.7355 13.2415C52.7355 9.67063 49.8459 6.76571 46.2939 6.76571ZM46.2939 15.9496C44.8088 15.9496 43.6001 14.7354 43.6001 13.2415C43.6001 11.7477 44.8088 10.5335 46.2939 10.5335C47.7789 10.5335 48.9877 11.7477 48.9877 13.2415C48.9877 14.7354 47.7789 15.9496 46.2939 15.9496ZM11.2859 35.7873L9.40009 19.9896L15.1051 27.6355C15.4931 28.158 16.1354 28.4542 16.7668 28.3824C17.4128 28.3254 17.9828 27.9391 18.2756 27.3577L25.3934 13.2375C25.7547 13.301 26.1214 13.3501 26.5006 13.3501C26.8797 13.3501 27.2464 13.301 27.6077 13.2375L34.7255 27.3577C35.0183 27.9391 35.5884 28.3254 36.2344 28.3824C36.8785 28.4523 37.508 28.158 37.896 27.6355L43.601 19.9896L41.7152 35.7873H11.2859ZM4.01347 13.2415C4.01347 11.7477 5.22219 10.5335 6.70723 10.5335C8.19229 10.5335 9.40101 11.7477 9.40101 13.2415C9.40101 14.7354 8.19229 15.9496 6.70723 15.9496C5.22219 15.9496 4.01347 14.7354 4.01347 13.2415ZM23.8068 6.87426C23.8068 5.3804 25.0155 4.16619 26.5006 4.16619C27.9856 4.16619 29.1943 5.3804 29.1943 6.87426C29.1943 8.36811 27.9856 9.58233 26.5006 9.58233C25.0155 9.58233 23.8068 8.36811 23.8068 6.87426Z",
                            fill: "#4A67FF"
                        })
                    }),
                    title: `Diligentsia Pro PLUS`,
                    points: [
                        "Too busy? Can\u2019t or don\u2019t want to self-diligence?",
                        'Completeness and risk scoring',
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Get your accountant/lawyer to assist in module ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "completion"
                            ]
                        }),
                        'Audited certificate valid for 3 months',
                        'Option of quarterly reviews'
                    ],
                    image: (parcelRequire("j0lPb"))
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Diligentsia Pro PLUS"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("kWd14")),
                        (parcelRequire("b1C6b")),
                        (parcelRequire("2P7rJ"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text df jcc aic bg1 px1rem py0-5rem w60 mla mra br45px c12 fs1-25rem",
                        children: [
                            "*= You can also optionally request AUDITED certification",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w9rem",
                                    src: (parcelRequire("jBY5D")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                }
            }
        },
        portfolioPro: {
            "diligence-pack": {
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.2423 4.99219C38.0392 4.99219 26.4843 16.5471 26.4843 30.7502C26.4843 35.4448 27.7474 39.8496 29.9507 43.6439L6.94712 66.6474C4.35096 69.2434 4.35096 73.4677 6.94712 76.0637C8.24505 77.3618 9.95015 78.0108 11.6551 78.0108C13.3601 78.0108 15.0653 77.3619 16.3631 76.0637L39.3714 53.0553C43.1605 55.2502 47.557 56.5081 52.242 56.5081C66.4452 56.5081 78.0001 44.953 78.0001 30.7501C78.0001 16.5471 66.4454 4.99219 52.2423 4.99219ZM13.3351 73.0356C12.4087 73.962 10.9015 73.962 9.97525 73.0357C9.04897 72.1094 9.04897 70.6021 9.97525 69.6757L11.4192 68.2317L14.7791 71.5916L13.3351 73.0356ZM17.8072 68.5636L14.4474 65.2037L16.7667 62.8844L20.1265 66.2444L17.8072 68.5636ZM23.1545 63.2161L19.7947 59.8561L32.4432 47.2076C33.4586 48.4271 34.5841 49.5519 35.8046 50.5661L23.1545 63.2161ZM52.2423 52.2257C40.4006 52.2257 30.7669 42.5918 30.7669 30.7502C30.7669 18.9087 40.4006 9.27476 52.2423 9.27476C64.084 9.27476 73.7178 18.9085 73.7178 30.7502C73.7178 42.5919 64.084 52.2257 52.2423 52.2257Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M59.5703 27.024C59.5703 25.8415 58.6117 24.8828 57.4291 24.8828L43.216 24.8828C42.0334 24.8828 41.0748 25.8415 41.0748 27.024C41.0748 28.2066 42.0334 29.1652 43.216 29.1652L57.4291 29.1652C58.6117 29.1654 59.5703 28.2066 59.5703 27.024Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.2187 19.5318C64.2187 18.3493 63.2601 17.3906 62.0775 17.3906L43.2121 17.3906C42.0295 17.3906 41.0709 18.3493 41.0709 19.5318C41.0709 20.7144 42.0295 21.6731 43.2121 21.6731L62.0775 21.6731C63.2601 21.6732 64.2187 20.7144 64.2187 19.5318Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: `Due Diligence Pack`,
                    subMenu: {
                        index: 0,
                        points: [
                            '- Data Repository Report',
                            '- 20-sections Business Audit',
                            "- Directors\u2019 questionnaires",
                            '- Draft Warranty Disclosures '
                        ]
                    },
                    points: [
                        `Pulls together a complete pack of each of the key completed modules' reports:`,
                        `Tracks the sending of the DD Pack to investors introduced through the platform`
                    ],
                    notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            fontSize: "14px",
                            color: 'gray',
                            fontStyle: 'italic'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    fontWeight: "bold",
                                    fontStyle: 'normal'
                                },
                                children: `Please Note: `
                            }),
                            "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice"
                        ]
                    }),
                    image: (parcelRequire("7J3ig")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "Diligence Pack"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("k6VNW")),
                        (parcelRequire("3ASou")),
                        (parcelRequire("illzP"))
                    ],
                    bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w40 df jcc mla mra",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon mx1-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("aFTOQ")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    })
                }
            },
            'benchmarking': {
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "65",
                        height: "65",
                        viewBox: "0 0 65 65",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                            "clip-path": "url(#clip0_2119_192)",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M54.9743 42.4394C57.0327 38.6748 58.1973 34.3686 58.1973 29.7915C58.1973 28.5728 58.0618 27.3811 57.8993 26.1894C61.1764 25.404 63.6139 22.479 63.6139 18.9582C63.6139 14.8415 60.2827 11.5103 56.166 11.5103C54.5952 11.5103 53.1598 11.9978 51.9681 12.8103C46.9577 6.879 39.6181 3.38525 31.791 3.38525C17.2202 3.38525 5.38477 15.2207 5.38477 29.7915C5.38477 44.3623 17.2202 56.1978 31.791 56.1978C36.3681 56.1978 40.6743 55.0332 44.4389 52.9748L50.9118 59.4478C52.3743 60.9103 54.2702 61.6144 56.1931 61.6144C58.116 61.6144 60.0118 60.8832 61.4743 59.4478C64.3723 56.5498 64.3723 51.8103 61.4743 48.9123L55.0014 42.4394H54.9743ZM56.166 15.5728C58.0348 15.5728 59.5514 17.0894 59.5514 18.9582C59.5514 20.8269 58.0348 22.3436 56.166 22.3436C54.2973 22.3436 52.7806 20.8269 52.7806 18.9582C52.7806 17.0894 54.2973 15.5728 56.166 15.5728ZM31.791 7.44775C38.6431 7.44775 45.0889 10.6436 49.3139 16.0332C48.9348 16.9269 48.7181 17.929 48.7181 18.9582C48.7181 20.2853 49.0973 21.4769 49.6931 22.5603L35.7452 36.5082L30.0577 30.8207C30.7077 29.7103 31.1139 28.4373 31.1139 27.0832C31.1139 22.9665 27.7827 19.6353 23.666 19.6353C19.5493 19.6353 16.2181 22.9665 16.2181 27.0832C16.2181 28.3019 16.5431 29.4394 17.0577 30.4686L10.6118 36.8873C9.85352 34.6665 9.44727 32.2832 9.44727 29.7915C9.44727 17.4686 19.4681 7.44775 31.791 7.44775ZM20.2806 27.0832C20.2806 25.2144 21.7973 23.6978 23.666 23.6978C25.5348 23.6978 27.0514 25.2144 27.0514 27.0832C27.0514 28.9519 25.5348 30.4686 23.666 30.4686C21.7973 30.4686 20.2806 28.9519 20.2806 27.0832ZM12.3993 40.8415L19.8202 33.4207C20.9306 34.0978 22.2577 34.504 23.666 34.504C24.9118 34.504 26.1035 34.1519 27.1327 33.6103L34.3098 40.7873C34.716 41.1936 35.2306 41.3832 35.7452 41.3832C36.2598 41.3832 36.7743 41.1936 37.1806 40.7873L52.5639 25.404C52.9431 25.6207 53.3493 25.8103 53.7556 25.9457C53.9723 27.2186 54.1348 28.4915 54.1348 29.7644C54.1348 42.0873 44.1139 52.1082 31.791 52.1082C23.5035 52.1082 16.2452 47.5582 12.3993 40.8144V40.8415ZM58.5493 56.5498C57.2223 57.8769 55.0827 57.8769 53.7556 56.5498L47.8785 50.6728C49.666 49.2915 51.291 47.6665 52.6723 45.879L58.5493 51.7561C59.8764 53.0832 59.8764 55.2228 58.5493 56.5498Z",
                                fill: "#4A67FF"
                            })
                        })
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE Client ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Benchmarking"
                        ]
                    }),
                    points: [
                        'Benchmark your client/portfolio companies',
                        'Simple scoring system',
                        'Against each or our wider database (anonymized)',
                        'Benchmarking report'
                    ],
                    image: (parcelRequire("9883i")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                }
            },
            "checklist-builder": {
                title: 'AnyList Checklist Builder',
                isPaperIcon: true,
                redirectToChecklist: true,
                isDescription: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "You can create your own ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " bespoked pre-investment checklists"
                    ]
                }),
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "83",
                        height: "83",
                        viewBox: "0 0 83 83",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "FREE - Anylist Checklist ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Builder"
                        ]
                    }),
                    points: [
                        'Undertaking M&A? Create relevant automated due diligence checklists bespoked to target company',
                        `10 sections; 10 questions per section`,
                        `You can add your own questions and desired answers`,
                        `Questions: can choose subjective, objective or a mixture`,
                        `Completeness and risk scoring`,
                        `Reporting`,
                        `Workflow Manager: Can send to target company and monitor completeness`
                    ],
                    image: (parcelRequire("lB7oR")),
                    imageStyle: {
                        height: '90%',
                        width: '94%'
                    }
                },
                howItWorks: {
                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c3",
                            children: "AnyList Checklist Builder"
                        })
                    }),
                    stepImage: (parcelRequire("aCagb")),
                    arrayImages: [
                        (parcelRequire("1PiK1")),
                        (parcelRequire("jcfD1")),
                        (parcelRequire("4CdTy"))
                    ],
                    checkList: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for you"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Quick and easy for your target user"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Reusable by the target company"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "checklist-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w1rem",
                                        src: (parcelRequire("fYwBE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c12",
                                    children: "Company gains value from completion - risks & recommendations"
                                })
                            ]
                        })
                    ],
                    btnContent: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "new-shadow bg4 bg3-hover c1 td250 br30px p1rem fw600 cp ttu bsbb tac df jcc aic w250px",
                        children: "Let\u2019s Go!"
                    })
                }
            }
        }
    };
    // Fetch directors if not available (excluded in lightweight mode)
    const fetchDirectors = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/directors`);
            if (response['code'] === 200 && response['body']) setDirectors(response['body']['directors'] || []);
        } catch (e) {
            console.error('Failed to fetch directors:', e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchDirectors();
    }, [
        company?._id,
        company?.['directorsCount']
    ]);
    const handleExpandCollapse = (states)=>{
        window.localStorage.setItem('expandedPanels', JSON.stringify(states));
        setExpanded(states);
    };
    (0, $acw62.useEffect)(()=>{
        if (window.localStorage.getItem('expandedPanels')) {
            const storedStates = JSON.parse(window.localStorage.getItem('expandedPanels'));
            setExpanded(storedStates);
        }
        let isManualAdd = localStorage.getItem('isManualAdd');
        if (isManualAdd) localStorage.removeItem('isManualAdd');
    }, []);
    const setModuleTab = async (setTab, type, module)=>{
        if (modal['open'] === "" && (type.startsWith('two-minute-') && !company['freeModules'] || company['freeModules'] && !company['freeModules'][type]) && !type.startsWith('repository')) {
            setShowExpension(type);
            setPayload({
                setTab: setTab,
                type: type,
                module: module
            });
            if (module && module['sectionStats']) {
                const key = Object.keys(module['sectionStats'])[0];
                const code = key.split(" - ")[1];
                if (company['expansionPack'] && !company['expansionPack'][code]) return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'subscriptionPaymentConfirm'
                }));
            }
        }
        // CHECK KPI & CERTIFICATE FOR GUEST USERS
        if (user?.['role'] == 'Guest') {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'noRegistrationReport'
            }));
            return;
        }
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT') && type && ![
            'kpi-report',
            'benchmark-reporting'
        ].includes(type)) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if ([
            'software-development',
            'esg',
            'warranty-disclosure',
            'directors-questionnaire',
            'investor-lead'
        ].includes(type)) {
            // CHECK EXPANSION PACK PERMISSIONS FOR MEMBERS
            const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`;
            if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
                if (!company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
            // CHECK EXPANSION PACK PERMISSIONS FOR ADVISORS/INVESTORS
            if ((user['role'] == "Advisor" || user['role'] == 'Investor') && company['creatorId']['_id'] != user['_id']) {
                if (!company?.[user['role'] == "Investor" ? 'investors' : 'advisors']?.[user['_id']]?.['modules']?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
        }
        if (type.includes("directors-questionnaire")) {
            if (localStorage.getItem('isDirectoreDisclaimer')) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'showDirectors'
            }));
            else {
                localStorage.setItem('isDirectoreDisclaimer', true);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'directorQuestionnaireDisclaimer'
                }));
            }
            return;
        } else {
            setTab(type);
            if (module) dispatch((0, $b73aa58a82b722b1$export$4ad686614bba9050)(module));
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (isWorkflowReport && !window.location.hash.includes('#workflow')) setIsWorkflowReport(false);
    }, []);
    const handleSeeMore = async (object)=>{
        if (object) {
            await setSelectedSeeMore(object);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'seeMorePopup'
            }));
        }
    };
    const handleHowItWorks = async (object)=>{
        if (object) {
            await setSelectedHowItWorks(object);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'howItWorksPopup'
            }));
        }
    };
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedSeeMore({});
        setSelectedHowItWorks({});
        // Set flag to prevent navigation immediately after modal close
        modalJustClosedRef.current = true;
        setTimeout(()=>{
            modalJustClosedRef.current = false;
        }, 300); // 300ms delay to prevent navigation from modal close click events
    };
    // Track modal state changes to detect when modal closes
    (0, $acw62.useEffect)(()=>{
        if (modal && !modal['open']) {
            // Modal was just closed
            modalJustClosedRef.current = true;
            const timer = setTimeout(()=>{
                modalJustClosedRef.current = false;
            }, 300);
            return ()=>clearTimeout(timer);
        }
    }, [
        modal
    ]);
    const handleNavigate = (item, event)=>{
        if (item.disable) return;
        const blocked = {
            Free: [
                "PRO",
                "LITE"
            ],
            Lite: [
                "PRO"
            ],
            PRO: []
        };
        if (blocked[company.subscription]?.includes(item.subscription)) {
            if (user['role'] == 'Advisor' || user['role'] == 'Investor' || user['createdBy'] && user['createdBy']['role'] == 'Advisor' || user['createdBy']['role'] == 'Investor') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Access denied. A Pro subscription is required to access this module.`);
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You are not authorized to access this module. Please upgrade to ${item.subscription} subscription`);
        }
        if (item['isBuy'] && !company['expensions'][item['id']]) {
            setShowExpension(item['id']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'subscriptionPaymentConfirm'
            }));
            return;
        } else if (item['isBuy'] && company['expensions'][item['id']] && /directors['’]?\s*questionnaires?/i.test(item.title)) return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'showDirectors'
        }));
        if (item['companyDashboardTab'] && item['companyDashboardTab'] !== '#') return setCompanyDashboardTab(item['companyDashboardTab']);
        // Prevent navigation if a modal is currently open
        if (modal && modal['open']) {
            // If a modal is open, don't navigate
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            return;
        }
        // Prevent navigation if modal was just closed (to prevent navigation from modal close click events)
        if (modalJustClosedRef.current) {
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            return;
        }
        // Prevent event bubbling if event is provided
        if (event) event.stopPropagation();
        if (item['type'] === "benchmark-reporting") {
            setTab('benchmark-reporting');
            if (item['link'] && item['link'] !== '#') setTimeout(()=>{
                const hashValue = item['link'];
                if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
            }, 100);
            return;
        }
        if (item['type'] === 'share-diligence-pack') {
            setTab('share-diligence-pack');
            if (item['link'] && item['link'] !== '#') setTimeout(()=>{
                const hashValue = '#share-diligence-pack';
                if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
            }, 100);
            return;
        }
        if (item['type'] === '#diligence-pack') {
            setTab('diligence-pack');
            if (item['link'] && item['link'] !== '#') setTimeout(()=>{
                const hashValue = '#diligence-pack';
                if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
            }, 100);
            return;
        }
        if (item['openModal']) return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: item['openModal']
        }));
        if (item?.['navigate']) return navigate(item['navigate']);
        if (item['type'] === "anylist-builder") setCompanyDashboardTab('AnyLists');
        if (item['type'] && item['module']) {
            const link = handleLinkModuleTab(item['type'], item['module']);
            setModuleTab(setTab, item['type'], item['module']);
            if (link && link !== '#') setTimeout(()=>{
                const hashValue = link;
                if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
            }, 100);
        }
    };
    // Tooltip component that uses fixed positioning to avoid overflow clipping
    const TooltipWrapper = ({ tooltip: tooltip, children: children, moduleType: moduleType, sections: sections })=>{
        const tooltipRef = (0, $acw62.useRef)(null);
        const tooltipElementRef = (0, $acw62.useRef)(null);
        const hoverTimeoutRef = (0, $acw62.useRef)(null);
        const [tooltipPosition, setTooltipPosition] = (0, $acw62.useState)(null);
        const [isTooltipHovered, setIsTooltipHovered] = (0, $acw62.useState)(false);
        const handleTooltipMouseEnter = ()=>{
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            if (tooltipRef.current) {
                const rect = tooltipRef.current.getBoundingClientRect();
                const tooltipWidth = 240; // Width from CSS
                const tooltipHeight = tooltip.length * 40; // Approximate height per item
                // Calculate position for fixed positioning (relative to viewport)
                // Match the CSS: left: 6%, top: 50% with translateY(-50%)
                let top = rect.top + rect.height / 2;
                let left = rect.left + rect.width * 0.06;
                // Ensure tooltip stays within viewport bounds
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                // Adjust horizontal position if tooltip would overflow right
                if (left + tooltipWidth > viewportWidth - 10) left = viewportWidth - tooltipWidth - 10;
                // Adjust horizontal position if tooltip would overflow left
                if (left < 10) left = 10;
                // Adjust vertical position if tooltip would overflow bottom
                if (top + tooltipHeight / 2 > viewportHeight - 10) top = viewportHeight - tooltipHeight / 2 - 10;
                // Adjust vertical position if tooltip would overflow top
                if (top - tooltipHeight / 2 < 10) top = tooltipHeight / 2 + 10;
                setTooltipPosition({
                    top: top,
                    left: left
                });
                setIsTooltipHovered(true);
            }
        };
        const handleTooltipMouseLeave = ()=>{
            // Add a small delay before hiding to allow moving mouse to tooltip
            hoverTimeoutRef.current = setTimeout(()=>{
                setIsTooltipHovered(false);
                setTooltipPosition(null);
            }, 200);
        };
        const handleTooltipElementMouseEnter = ()=>{
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            setIsTooltipHovered(true);
        };
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            };
        }, []);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: tooltipRef,
            className: "cp module-tooltip-box",
            onMouseEnter: handleTooltipMouseEnter,
            onMouseLeave: handleTooltipMouseLeave,
            children: [
                children,
                tooltip && tooltip.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "tooltip-area",
                            style: {
                                display: 'none'
                            },
                            children: tooltip.map((point, idx)=>{
                                // Check if this is a section with stats (for progress display)
                                const sectionSelected = sections && sections.length > 0 ? sections.filter((section)=>section?.sectionName === point)[0] : null;
                                if (sectionSelected) {
                                    // Apply progress logic similar to CoreWorkspaceButton.js
                                    if (!sectionSelected.stats) sectionSelected.stats = {
                                        completionPercent: 0,
                                        riskPercent: 0
                                    };
                                    const completeness = sectionSelected.stats.completionPercent || 0;
                                    let riskColour;
                                    // Check if module type is repository or riskPercent is low (similar to CoreWorkspaceButton.js)
                                    if (moduleType === "repository" || sectionSelected.stats.riskPercent !== undefined && sectionSelected.stats.riskPercent < 38) riskColour = 7;
                                    else if (sectionSelected.stats.riskPercent !== undefined && sectionSelected.stats.riskPercent > 62) riskColour = 9;
                                    else riskColour = 8;
                                    let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                                    let colorChange = false;
                                    // Check module type for warranty-disclosure (similar to CoreWorkspaceButton.js)
                                    if (moduleType === "warranty-disclosure") {
                                        if (sectionSelected?.questions && sectionSelected?.questions.length > 0) sectionSelected.questions.map((question)=>{
                                            if (question['answer']?.['radioOption'] == 'Disclosure' || question['answer']?.['radioOption'] == 'Not Sure') {
                                                colorChange = true;
                                                return;
                                            }
                                        });
                                    }
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        style: {
                                            background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`,
                                            width: '100%',
                                            textAlign: 'left',
                                            cursor: 'pointer'
                                        },
                                        className: "overlay-box tal w100 tac cp c3-hover",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: sectionSelected.sectionName || sectionSelected.name || point
                                        })
                                    }, idx);
                                }
                                // Default behavior for simple strings/names
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "overlay-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: point?.['role'] == "Director" || point?.['designation'] == "Director" ? point['name'] : point
                                    })
                                }, idx);
                            })
                        }),
                        isTooltipHovered && tooltipPosition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "tooltip-area",
                            style: {
                                position: 'fixed',
                                top: `${tooltipPosition.top}px`,
                                left: `${tooltipPosition.left}px`,
                                transform: 'translateY(-50%)',
                                zIndex: 9999,
                                display: 'block',
                                width: '240px',
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                padding: '8px',
                                boxShadow: '0 6px 12px -2px #32325d40, 0 3px 7px -3px #0000004d',
                                pointerEvents: 'auto'
                            },
                            ref: tooltipElementRef,
                            onMouseEnter: handleTooltipElementMouseEnter,
                            onMouseLeave: handleTooltipMouseLeave,
                            children: tooltip.map((point, idx)=>{
                                // Check if this is a section with stats (for progress display)
                                const sectionSelected = sections && sections.length > 0 ? sections.filter((section)=>section?.sectionName === point)[0] : null;
                                if (sectionSelected) {
                                    // Apply progress logic similar to CoreWorkspaceButton.js
                                    if (!sectionSelected.stats) sectionSelected.stats = {
                                        completionPercent: 0,
                                        riskPercent: 0
                                    };
                                    const completeness = sectionSelected.stats.completionPercent || 0;
                                    let riskColour;
                                    // Check if module type is repository or riskPercent is low (similar to CoreWorkspaceButton.js)
                                    if (moduleType === "repository" || sectionSelected.stats.riskPercent !== undefined && sectionSelected.stats.riskPercent < 38) riskColour = 7;
                                    else if (sectionSelected.stats.riskPercent !== undefined && sectionSelected.stats.riskPercent > 62) riskColour = 9;
                                    else riskColour = 8;
                                    let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                                    let colorChange = false;
                                    // Check module type for warranty-disclosure (similar to CoreWorkspaceButton.js)
                                    if (moduleType === "warranty-disclosure") {
                                        if (sectionSelected?.questions && sectionSelected?.questions.length > 0) sectionSelected.questions.map((question)=>{
                                            if (question['answer']?.['radioOption'] == 'Disclosure' || question['answer']?.['radioOption'] == 'Not Sure') {
                                                colorChange = true;
                                                return;
                                            }
                                        });
                                    }
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>{
                                            // Navigate to section if sectionNo is available
                                            if (sectionSelected.sectionNo) navigateSection(sectionSelected, moduleType, sectionSelected.sectionNo);
                                        },
                                        style: {
                                            background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`,
                                            fontSize: '8px',
                                            color: '#000',
                                            padding: '10px',
                                            transition: 'all 0.3s ease-in-out',
                                            boxSizing: 'border-box',
                                            textAlign: 'left',
                                            width: '100%',
                                            cursor: 'pointer',
                                            border: 'none',
                                            borderRadius: '4px',
                                            marginBottom: '4px'
                                        },
                                        className: "overlay-box tal w100 tac cp c3-hover",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: sectionSelected.sectionName || sectionSelected.name || point
                                        })
                                    }, idx);
                                }
                                // Default behavior for simple strings/names
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "overlay-box",
                                    style: {
                                        backgroundColor: '#f0f0f8',
                                        fontSize: '8px',
                                        color: '#000',
                                        padding: '10px',
                                        transition: 'all 0.3s ease-in-out',
                                        boxSizing: 'border-box'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: point?.['role'] == "Director" || point?.['designation'] == "Director" ? point['name'] : point
                                    })
                                }, idx);
                            })
                        }), document.body)
                    ]
                })
            ]
        });
    };
    // Tooltip component for info-icon overlay-box (description tooltip)
    const InfoIconTooltip = ({ content: content, children: children })=>{
        const tooltipRef = (0, $acw62.useRef)(null);
        const tooltipElementRef = (0, $acw62.useRef)(null);
        const hoverTimeoutRef = (0, $acw62.useRef)(null);
        const [tooltipPosition, setTooltipPosition] = (0, $acw62.useState)(null);
        const [isTooltipHovered, setIsTooltipHovered] = (0, $acw62.useState)(false);
        const handleTooltipMouseEnter = ()=>{
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            if (tooltipRef.current) {
                const rect = tooltipRef.current.getBoundingClientRect();
                const tooltipWidth = 350; // Width from CSS
                const tooltipHeight = 100; // Approximate height
                // Calculate position for fixed positioning
                // CSS: left: -389px, top: 50% with translateY(-50%)
                // Position to the left of the icon
                let top = rect.top + rect.height / 2;
                let left = rect.left - 389; // Position to the left
                // Ensure tooltip stays within viewport bounds
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                // Adjust horizontal position if tooltip would overflow left
                if (left < 10) left = rect.right + 20; // Position to the right instead
                // Adjust horizontal position if tooltip would overflow right
                if (left + tooltipWidth > viewportWidth - 10) left = viewportWidth - tooltipWidth - 10;
                // Adjust vertical position if tooltip would overflow bottom
                if (top + tooltipHeight / 2 > viewportHeight - 10) top = viewportHeight - tooltipHeight / 2 - 10;
                // Adjust vertical position if tooltip would overflow top
                if (top - tooltipHeight / 2 < 10) top = tooltipHeight / 2 + 10;
                setTooltipPosition({
                    top: top,
                    left: left
                });
                setIsTooltipHovered(true);
            }
        };
        const handleTooltipMouseLeave = ()=>{
            hoverTimeoutRef.current = setTimeout(()=>{
                setIsTooltipHovered(false);
                setTooltipPosition(null);
            }, 200);
        };
        const handleTooltipElementMouseEnter = ()=>{
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            setIsTooltipHovered(true);
        };
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            };
        }, []);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: tooltipRef,
            className: "info-icon cp pr ml0-5rem",
            onMouseEnter: handleTooltipMouseEnter,
            onMouseLeave: handleTooltipMouseLeave,
            children: [
                children,
                content && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "shadow overlay-box",
                            style: {
                                display: 'none'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pl1rem py0-5rem fs1rem c15 fw400 tti",
                                children: content
                            })
                        }),
                        isTooltipHovered && tooltipPosition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "shadow overlay-box",
                            ref: tooltipElementRef,
                            style: {
                                position: 'fixed',
                                top: `${tooltipPosition.top}px`,
                                left: `${tooltipPosition.left}px`,
                                transform: 'translateY(-50%)',
                                zIndex: 9999,
                                display: 'block',
                                width: '350px',
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                padding: '16px',
                                boxShadow: '0 6px 12px -2px #32325d40, 0 3px 7px -3px #0000004d',
                                pointerEvents: 'auto'
                            },
                            onMouseEnter: handleTooltipElementMouseEnter,
                            onMouseLeave: handleTooltipMouseLeave,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "pl1rem py0-5rem fs1rem c15 fw400 tti",
                                children: content
                            })
                        }), document.body)
                    ]
                })
            ]
        });
    };
    // Tooltip component for checklistModuleTooltip (sections list)
    const ChecklistTooltipWrapper = ({ module: module, sections: sections, children: children })=>{
        const tooltipRef = (0, $acw62.useRef)(null);
        const tooltipElementRef = (0, $acw62.useRef)(null);
        const hoverTimeoutRef = (0, $acw62.useRef)(null);
        const [tooltipPosition, setTooltipPosition] = (0, $acw62.useState)(null);
        const [isTooltipHovered, setIsTooltipHovered] = (0, $acw62.useState)(false);
        const handleTooltipMouseEnter = ()=>{
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            if (tooltipRef.current && sections && sections.length > 0) {
                const rect = tooltipRef.current.getBoundingClientRect();
                const tooltipWidth = 240; // Width from CSS
                const tooltipHeight = sections.length * 40; // Approximate height per section
                // Calculate position for fixed positioning
                // Match the CSS: left: 6%, top: 50% with translateY(-50%)
                let top = rect.top + rect.height / 2;
                let left = rect.left + rect.width * 0.06;
                // Ensure tooltip stays within viewport bounds
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                // Adjust horizontal position if tooltip would overflow right
                if (left + tooltipWidth > viewportWidth - 10) left = viewportWidth - tooltipWidth - 10;
                // Adjust horizontal position if tooltip would overflow left
                if (left < 10) left = 10;
                // Adjust vertical position if tooltip would overflow bottom
                if (top + tooltipHeight / 2 > viewportHeight - 10) top = viewportHeight - tooltipHeight / 2 - 10;
                // Adjust vertical position if tooltip would overflow top
                if (top - tooltipHeight / 2 < 10) top = tooltipHeight / 2 + 10;
                setTooltipPosition({
                    top: top,
                    left: left
                });
                setIsTooltipHovered(true);
            }
        };
        const handleTooltipMouseLeave = ()=>{
            hoverTimeoutRef.current = setTimeout(()=>{
                setIsTooltipHovered(false);
                setTooltipPosition(null);
            }, 200);
        };
        const handleTooltipElementMouseEnter = ()=>{
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
                hoverTimeoutRef.current = null;
            }
            setIsTooltipHovered(true);
        };
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
            };
        }, []);
        const navigateSection = async (module, moduleName, sectionNo)=>{
            if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
                return;
            }
            await setTab(moduleName);
            setTimeout(()=>{
                let element = document.getElementById(sectionNo);
                if (element) element.scrollIntoView({
                    behavior: 'instant'
                }, true);
            }, 1000);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            ref: tooltipRef,
            className: "cp module-tooltip-box",
            onMouseEnter: handleTooltipMouseEnter,
            onMouseLeave: handleTooltipMouseLeave,
            children: [
                children,
                sections && sections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "tooltip-area",
                            style: {
                                display: 'none'
                            },
                            children: sections.map((section, idx)=>{
                                let completeness = section?.['stats']?.['completionPercent'] ? section?.['stats']?.['completionPercent'] : 0;
                                let riskColour;
                                if (section?.['stats']?.['riskPercent'] < 38) riskColour = 7;
                                else if (section?.['stats']?.['riskPercent'] > 62) riskColour = 9;
                                else riskColour = 8;
                                let hexColour = riskColour == 8 ? "#ddb64044" : riskColour == 9 ? "#dd404044" : "#40dda144";
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigateSection(module, section['moduleName'], section['sectionNo']),
                                    style: {
                                        background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                    },
                                    "data-scroll-to": section['sectionNo'],
                                    className: "overlay-box tal w100 tac cp c3-hover",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: section['sectionName']
                                    })
                                }, idx);
                            })
                        }),
                        isTooltipHovered && tooltipPosition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "tooltip-area",
                            ref: tooltipElementRef,
                            style: {
                                position: 'fixed',
                                top: `${tooltipPosition.top}px`,
                                left: `${tooltipPosition.left}px`,
                                transform: 'translateY(-50%)',
                                zIndex: 9999,
                                display: 'block',
                                width: '240px',
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                padding: '8px',
                                boxShadow: '0 6px 12px -2px #32325d40, 0 3px 7px -3px #0000004d',
                                pointerEvents: 'auto'
                            },
                            onMouseEnter: handleTooltipElementMouseEnter,
                            onMouseLeave: handleTooltipMouseLeave,
                            children: sections.map((section, idx)=>{
                                let completeness = section?.['stats']?.['completionPercent'] ? section?.['stats']?.['completionPercent'] : 0;
                                let riskColour;
                                if (section?.['stats']?.['riskPercent'] < 38) riskColour = 7;
                                else if (section?.['stats']?.['riskPercent'] > 62) riskColour = 9;
                                else riskColour = 8;
                                let hexColour = riskColour == 8 ? "#ddb64044" : riskColour == 9 ? "#dd404044" : "#40dda144";
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>navigateSection(module, section['moduleName'], section['sectionNo']),
                                    style: {
                                        background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`,
                                        backgroundColor: '#f0f0f8',
                                        fontSize: '8px',
                                        color: '#000',
                                        padding: '10px',
                                        transition: 'all 0.3s ease-in-out',
                                        boxSizing: 'border-box',
                                        textAlign: 'left',
                                        width: '100%',
                                        cursor: 'pointer'
                                    },
                                    "data-scroll-to": section['sectionNo'],
                                    className: "overlay-box tal w100 tac cp c3-hover",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: section['sectionName']
                                    })
                                }, idx);
                            })
                        }), document.body)
                    ]
                })
            ]
        });
    };
    const moduleBox = (item)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bo7 cp w100 keyfeature-wihte-item bg1 new-shadow br15px p1-5rem pr bsbb",
            children: [
                item['menus'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151351a1dd6ada95$export$2e2bcd8739ae039), {
                    menus: item['menus'],
                    module: item,
                    onNavigateSection: navigateSection,
                    setReportTab: setReportTab,
                    setIsWorkflowReport: setIsWorkflowReport,
                    type: item?.['title'],
                    company: company,
                    seeMore: item['seeMore'],
                    howItWorks: item['howItWorks']
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic w100",
                    style: {
                        opacity: item['id'] || item['redirectToChecklist'] ? '1' : '1'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "icon-diligenstia mr1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: `${item['comingSoon'] && 'op50'}`,
                                src: item['logo'] || (parcelRequire("3N5Zr")),
                                alt: ""
                            })
                        }),
                        item['title'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            onClick: ()=>{
                                item['redirectToChecklist'] ? navigate(`/createChecklist?companyId=${company['_id']};cName=${company['cName']}`) : item['modalShow'] && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: item['modalShow']
                                }));
                                setSelectedModules(item);
                            },
                            className: `fs1rem fw500 c15 lh2 title-box-feature w100 = ${item['comingSoon'] && 'op50'}`,
                            children: [
                                item['isPartner'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    class: "db w100 c3 fs0-75rem fw300",
                                    children: "Partner"
                                }),
                                item['aboveTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: item['aboveTitle']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "w100 df aic jcsb",
                                    onClick: (e)=>handleNavigate(item, e),
                                    children: item['title'] === 'InvestorMatch' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c15 fs11px fw400",
                                                children: "OneForm"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "cp c4-hover",
                                                children: [
                                                    "Investor",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c4",
                                                        children: "Match"
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            item['title'],
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c59",
                                                children: item['subscription']
                                            })
                                        ]
                                    })
                                }),
                                item['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "db w100 tal fw500 fs1rem",
                                    children: item['subTitle']
                                })
                            ]
                        })
                    ]
                }),
                item['isCompleteness'] || item['isRisk'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "tooltip-area style-two pa df aic jcsb fww",
                    style: {
                        opacity: item['id'] || item['redirectToChecklist'] ? '1' : '1',
                        bottom: '10px',
                        left: '22px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "percentage-area df aic w100",
                            children: [
                                item['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: `mb0-5rem fs2rem c28 lh1 mr2rem w50`,
                                    children: showPercent(item['directorsStats']?.['completionPercent'] || item['module']?.['stats']['completionPercent'] || 0, 'Module Complete')
                                }),
                                item['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: `mb0-5rem fs2rem c28 lh1 mr2rem w50`,
                                    children: showPercent(item['directorsStats']?.['riskPercent'] || item['module']?.['stats']['riskPercent'] || 0, 'Module Risk')
                                })
                            ]
                        }),
                        item['isLockArea'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lock-area",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "68",
                                height: "84",
                                viewBox: "0 0 68 84",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M64.0326 35.8522C61.8786 33.699 59.0152 32.5137 55.9702 32.5137H55.1452V21.181C55.1452 9.60487 45.7279 0.1875 34.1524 0.1875H33.3763C21.8008 0.1875 12.3828 9.60487 12.3828 21.181V32.5131H11.5577C8.51281 32.5131 5.64937 33.699 3.49544 35.8522C1.34219 38.0062 0.15625 40.8696 0.15625 43.9152V72.4135C0.15625 75.4591 1.34219 78.3226 3.49544 80.4751C5.64869 82.6291 8.51213 83.815 11.5577 83.815H55.9702C59.0159 83.815 61.8793 82.6291 64.0332 80.4751C66.1865 78.3219 67.3724 75.4584 67.3724 72.4135V43.9152C67.3724 40.8703 66.1865 38.0069 64.0326 35.8522ZM17.8827 21.181C17.8827 12.6381 24.8327 5.6875 33.3763 5.6875H34.1524C42.6953 5.6875 49.6452 12.6381 49.6452 21.181V32.5131H17.8827V21.181ZM61.8724 72.4135C61.8724 73.9666 61.242 75.4873 60.1441 76.5859C59.0289 77.7011 57.5467 78.315 55.9702 78.315H11.5577C9.98131 78.315 8.49975 77.7011 7.38394 76.5852C6.2695 75.4715 5.65556 73.9899 5.65556 72.4135V43.9152C5.65556 42.3388 6.2695 40.8559 7.38394 39.7414C8.49906 38.627 9.98063 38.0131 11.5571 38.0131H55.9696C57.546 38.0131 59.0282 38.627 60.1427 39.7407C61.2578 40.8566 61.8717 42.3388 61.8717 43.9152L61.8724 72.4135Z",
                                        fill: "#F2F3F4"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M22.6488 62.365V64.045H15.3738L15.0438 62.965C15.4938 62.525 15.8238 62.08 16.0338 61.63C16.2438 61.17 16.3488 60.6 16.3488 59.92C16.3488 59.85 16.3388 59.735 16.3188 59.575H14.6538V58.135H15.8988C15.6988 57.455 15.5988 56.84 15.5988 56.29C15.5988 55.61 15.7438 55.025 16.0338 54.535C16.3338 54.035 16.7488 53.655 17.2788 53.395C17.8088 53.135 18.4188 53.005 19.1088 53.005C20.2188 53.005 21.0638 53.315 21.6438 53.935C22.2338 54.545 22.5438 55.33 22.5738 56.29H20.6388C20.6288 55.81 20.5038 55.435 20.2638 55.165C20.0238 54.885 19.6488 54.745 19.1388 54.745C18.6688 54.745 18.2938 54.885 18.0138 55.165C17.7438 55.445 17.6088 55.875 17.6088 56.455C17.6088 56.715 17.6338 56.975 17.6838 57.235C17.7438 57.485 17.8288 57.785 17.9388 58.135H20.7588V59.575H18.3138C18.3338 59.735 18.3438 59.855 18.3438 59.935C18.3438 60.365 18.2588 60.795 18.0888 61.225C17.9288 61.645 17.6788 62.025 17.3388 62.365H22.6488ZM32.0283 54.88H27.1683V57.445C27.3783 57.185 27.6783 56.975 28.0683 56.815C28.4583 56.645 28.8733 56.56 29.3133 56.56C30.1133 56.56 30.7683 56.735 31.2783 57.085C31.7883 57.435 32.1583 57.885 32.3883 58.435C32.6183 58.975 32.7333 59.555 32.7333 60.175C32.7333 61.325 32.4033 62.25 31.7433 62.95C31.0933 63.65 30.1633 64 28.9533 64C27.8133 64 26.9033 63.715 26.2233 63.145C25.5433 62.575 25.1583 61.83 25.0683 60.91H27.1083C27.1983 61.31 27.3983 61.63 27.7083 61.87C28.0283 62.11 28.4333 62.23 28.9233 62.23C29.5133 62.23 29.9583 62.045 30.2583 61.675C30.5583 61.305 30.7083 60.815 30.7083 60.205C30.7083 59.585 30.5533 59.115 30.2433 58.795C29.9433 58.465 29.4983 58.3 28.9083 58.3C28.4883 58.3 28.1383 58.405 27.8583 58.615C27.5783 58.825 27.3783 59.105 27.2583 59.455H25.2483V53.035H32.0283V54.88ZM34.3316 58.39C34.3316 56.66 34.6416 55.305 35.2616 54.325C35.8916 53.345 36.9316 52.855 38.3816 52.855C39.8316 52.855 40.8666 53.345 41.4866 54.325C42.1166 55.305 42.4316 56.66 42.4316 58.39C42.4316 60.13 42.1166 61.495 41.4866 62.485C40.8666 63.475 39.8316 63.97 38.3816 63.97C36.9316 63.97 35.8916 63.475 35.2616 62.485C34.6416 61.495 34.3316 60.13 34.3316 58.39ZM40.3616 58.39C40.3616 57.65 40.3116 57.03 40.2116 56.53C40.1216 56.02 39.9316 55.605 39.6416 55.285C39.3616 54.965 38.9416 54.805 38.3816 54.805C37.8216 54.805 37.3966 54.965 37.1066 55.285C36.8266 55.605 36.6366 56.02 36.5366 56.53C36.4466 57.03 36.4016 57.65 36.4016 58.39C36.4016 59.15 36.4466 59.79 36.5366 60.31C36.6266 60.82 36.8166 61.235 37.1066 61.555C37.3966 61.865 37.8216 62.02 38.3816 62.02C38.9416 62.02 39.3666 61.865 39.6566 61.555C39.9466 61.235 40.1366 60.82 40.2266 60.31C40.3166 59.79 40.3616 59.15 40.3616 58.39ZM44.0289 58.39C44.0289 56.66 44.3389 55.305 44.9589 54.325C45.5889 53.345 46.6289 52.855 48.0789 52.855C49.5289 52.855 50.5639 53.345 51.1839 54.325C51.8139 55.305 52.1289 56.66 52.1289 58.39C52.1289 60.13 51.8139 61.495 51.1839 62.485C50.5639 63.475 49.5289 63.97 48.0789 63.97C46.6289 63.97 45.5889 63.475 44.9589 62.485C44.3389 61.495 44.0289 60.13 44.0289 58.39ZM50.0589 58.39C50.0589 57.65 50.0089 57.03 49.9089 56.53C49.8189 56.02 49.6289 55.605 49.3389 55.285C49.0589 54.965 48.6389 54.805 48.0789 54.805C47.5189 54.805 47.0939 54.965 46.8039 55.285C46.5239 55.605 46.3339 56.02 46.2339 56.53C46.1439 57.03 46.0989 57.65 46.0989 58.39C46.0989 59.15 46.1439 59.79 46.2339 60.31C46.3239 60.82 46.5139 61.235 46.8039 61.555C47.0939 61.865 47.5189 62.02 48.0789 62.02C48.6389 62.02 49.0639 61.865 49.3539 61.555C49.6439 61.235 49.8339 60.82 49.9239 60.31C50.0139 59.79 50.0589 59.15 50.0589 58.39Z",
                                        fill: "#DADADA"
                                    })
                                ]
                            })
                        })
                    ]
                }) : item['information'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "dif w70 tal fw500 pa",
                    style: {
                        bottom: '10px',
                        left: '22px',
                        fontSize: '0.75rem'
                    },
                    children: item['type'] === "anylist-builder" && company['subscription'] === "Pro" ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op50",
                        children: "Build a checklist on anything in minutes"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: item['information']
                    })
                }),
                item['isCertification'] && (item['module']?.['stats']['completionPercent'] > 0 || item?.['directorsStats']?.['completionPercent'] > 0) || item['isCertification'] && (item['module']?.['stats']['completionPercent'] > 0 || item?.['directorsStats']?.['completionPercent'] > 0) && ![
                    'repository'
                ].includes(item['type']) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "pa",
                        style: {
                            bottom: '10px',
                            right: '10px'
                        },
                        children: item['module']?.['stats']['completionPercent'] === 100 && item['module']?.['stats']['riskPercent'] <= 25 || item['type'] === "repository" && item['module']?.['stats']['completionPercent'] === 100 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("ektZg")),
                            style: {
                                width: '67px',
                                height: '67px'
                            }
                        }) : item['module']?.['stats']['completionPercent'] > 90 && item['module']?.['stats']['riskPercent'] < 50 || item['type'] === "repository" && item['module']?.['stats']['completionPercent'] > 90 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("3Zw4L")),
                            style: {
                                width: '67px',
                                height: '67px'
                            }
                        }) : item['module']?.['stats']['completionPercent'] > 75 && item['module']?.['stats']['riskPercent'] < 50 || item['type'] === "repository" && item['module']?.['stats']['completionPercent'] > 75 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("7fl4F")),
                            style: {
                                width: '67px',
                                height: '67px'
                            }
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("k17d7")),
                            style: {
                                width: '67px',
                                height: '67px'
                            }
                        })
                    })
                }) : item['time'] || item['isBuy'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aife",
                        style: {
                            position: 'absolute',
                            right: '10px',
                            bottom: '10px'
                        },
                        children: [
                            item['time'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("jJgJl")),
                                        style: {
                                            width: '14px',
                                            height: '14px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: [
                                            item['time'],
                                            " +"
                                        ]
                                    })
                                ]
                            }),
                            item['isBuy'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: item['price'] ? `${item['price']}` : 'Buy Now',
                                onClick: ()=>{
                                    setShowExpension(item['id']);
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'subscriptionPaymentConfirm'
                                    }));
                                },
                                btnType: "warning",
                                style: {
                                    padding: '0.25rem 1rem',
                                    marginBottom: '4px'
                                }
                            })
                        ]
                    })
                }) : null,
                item['isCertificate'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bottom-certification w70 mt1rem df jcfs fww pr",
                    style: {
                        top: '16px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w100",
                            src: (parcelRequire("7BAlA")),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "progress-dashboard-horizantal",
                            role: "progressbar",
                            id: "progressBar",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "progress-bar progress-bar-striped progress-bar-animated",
                                id: "innerBar",
                                style: {
                                    width: `${20}%`
                                }
                            })
                        })
                    ]
                }),
                item['extraModule'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df op0-5 w100 mt1rem pr",
                    style: {
                        top: '35px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w60 tal fs0-75rem c12",
                            children: item['extraModule']['text']
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w40 df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                class: "bg4 c1 br15px px1-5rem",
                                children: item['extraModule']['btnText']
                            })
                        })
                    ]
                }),
                item['isPaperIcon'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jce",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "w20",
                        src: (parcelRequire("cjM2l")),
                        alt: ""
                    })
                }),
                item['isDescription'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    class: "fs0-75rem c12 fw300",
                    children: item['isDescription']
                }),
                item['isProPlus'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bottom-certificate mt1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df jcsb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-75rem fw300 c15",
                                children: "Pro PLUS"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                style: {
                                    width: '150px'
                                },
                                src: (parcelRequire("43Zse")),
                                alt: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da20b8fe5a9fd138$export$2e2bcd8739ae039), {
                    plan: !showExpension ? 'Pro' : typeof showExpension === "string" ? showExpension : showExpension?.['moduleKey'],
                    setShowExpension: setShowExpension,
                    defaultStep: showExpension && typeof showExpension === 'string' && [
                        'Free',
                        'Lite',
                        'Pro'
                    ].includes(showExpension) ? 'subscriptionUpgrade' : showExpension && typeof (showExpension.moduleKey || showExpension) === 'string' && (showExpension.moduleKey || showExpension).startsWith('two-minute') || showExpension && typeof (showExpension.moduleKey || showExpension) === 'string' && (showExpension.moduleKey || showExpension).startsWith('investor-lead') ? 'freeModule' : 'modulePurchase',
                    company: company,
                    companyId: company['_id'],
                    payload: payload,
                    module: showExpension,
                    showExpension: showExpension,
                    setModuleTab: setModuleTab
                })
            ]
        });
    };
    const extensionPackages = (id)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg20 bss bo5 bsbb px2rem py3rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo28 bw1px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "grs1-md gre3-md df fdc aic tac w20",
                            style: {
                                marginTop: '5px'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tooltip-box w250px p1rem br30px pricing-tooltbox bg1 df jcc",
                                style: {
                                    minHeight: '207px',
                                    border: '1px solid #ccc',
                                    backgroundColor: '#fff'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "fs1-25rem fs1-5rem-sm fw500 pa",
                                        style: {
                                            top: '-9%',
                                            left: '50%',
                                            transform: 'translateX(-50%)'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "shadow bg3 c1 fs1-25rem px1-5rem br10px",
                                            children: "PRO"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: (0, $16250bd714b02a14$export$3623221f872af69b).replace(":id", company['_id']),
                                        className: "subs-btn mt0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                className: "fs1-75rem",
                                                children: [
                                                    "\xa3",
                                                    (0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)['Pro']['price'] / 12,
                                                    "/month"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "shadow bg4 bg3-hover fs0-75rem c1 td250 br30px px2rem py0-5rem cp tac mt0-5rem",
                                                children: "Upgrade to PRO"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem",
                                                children: "* charged annually"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww w80 coreworkspace-update",
                            children: Object.values(MODULE_BOX['proCoreWorkspace']).map((item)=>moduleBox(item))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `bg20 bss bo5 bsbb p2rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 gg1-5rem ${company['expensions'] && Object.keys(company['expensions']).length > 0 ? 'bo7' : 'bo16'} bw1px`,
                    style: {
                        backgroundColor: '#F0F2FD'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcsb pr bsbb",
                            style: {
                                marginBottom: '-34px'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                        className: "fs1-25rem c15 w100  pl1rem",
                                        children: [
                                            "Diligentsia ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "AppStore"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/billing/${company._id}`,
                                        className: "subs-btn pl1rem c15 df aic fs1rem mt0-5rem mb1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "tooltip-box pricing-tooltbox icon mr0-5rem pr",
                                            style: {
                                                top: '4px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "tooltip-area",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        style: {
                                                            width: "300px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                                            plan: "Pro",
                                                            component: "Dashboard",
                                                            children: company['subscription'] !== 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                to: "/pricing-plans",
                                                                className: "shadow bg3 bg4-hover c1 br5px p0-5rem fw600 cp ttu w70 tac my1rem",
                                                                children: "Buy Plan"
                                                            })
                                                        })
                                                    })
                                                }),
                                                "Requires Pro subscription"
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df fww pr bsbb",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w100",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                            className: "accordian-dashboard-main",
                                            expanded: expanded['investmentPanel'],
                                            onChange: ()=>handleExpandCollapse({
                                                    ...expanded,
                                                    investmentPanel: !expanded['investmentPanel']
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1-25rem c15 fw600 ml1rem db",
                                                            children: "Investment Ready"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "dg gg1rem gtcr4 w100 dashboard-keybox",
                                                        children: Object.entries(MODULE_BOX['appStoreInvestment']).filter(([key])=>key !== "investor-leads" && key !== "investment-readiness-checklist").map(([_, item])=>moduleBox(item))
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mt1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                            className: "accordian-dashboard-main",
                                            expanded: expanded['growthPanel'],
                                            onChange: ()=>handleExpandCollapse({
                                                    ...expanded,
                                                    growthPanel: !expanded['growthPanel']
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1-25rem c15 fw600 ml1rem db",
                                                            children: "Growth Ready "
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "dg gg1rem gtcr4 w100 dashboard-keybox",
                                                            children: Object.values(MODULE_BOX['appStoreGrowth']).map((item)=>moduleBox(item))
                                                        }),
                                                        healthboostBox()
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mt1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                            className: "accordian-dashboard-main",
                                            expanded: expanded['exitPanel'],
                                            onChange: ()=>handleExpandCollapse({
                                                    ...expanded,
                                                    exitPanel: !expanded['exitPanel']
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1-25rem c15 fw600 ml1rem db",
                                                            children: "Exit Ready "
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "dg gg1rem gtcr4 w100 dashboard-keybox",
                                                        children: Object.values(MODULE_BOX['appStoreExit']).map((item)=>moduleBox(item))
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    const proPlusPacks = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg20 bss bo5 bsbb p2rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2 bo7 bw1px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                    className: "fs1-25rem c15 w100 pl1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c7",
                            children: "PRO PLUS"
                        }),
                        " - Contact Us"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "grs1-md gre3-md df fdc jcc aic tac w20",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tooltip-box w250px p1rem br15px pricing-tooltbox bg1 df jcc",
                        style: {
                            minHeight: '207px',
                            border: '1px solid #ccc',
                            backgroundColor: '#fff'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1-25rem fs1-5rem-sm fw500 pa w100",
                                style: {
                                    top: '-9%',
                                    left: '50%',
                                    transform: 'translateX(-50%)'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "shadow bg3 c1 fs1-25rem px1-5rem br10px",
                                    children: "PRO PLUS"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "subs-btn mt1rem df jcc fdc bg1",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        style: {
                                            fontSize: '11px'
                                        },
                                        children: [
                                            "Upgrade to Pro PLUS to obtain ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "A THIRD PARTY AUDIT CERTIFICATE"
                                            }),
                                            " - diligenced by your accountant, lawyer or ourselves."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: {
                                            fontSize: '11px'
                                        },
                                        children: "For more information."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        className: "w70 df jcc aic shadow bg4 bg3-hover fs0-75rem c1 br30px px1rem py0-5rem cp tac mt1rem",
                                        target: "_blank",
                                        href: "https://koalendar.com/e/meet-with-mark-bernstein",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                style: {
                                                    padding: '4px'
                                                },
                                                className: "bg1 br50px mr0-5rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "22",
                                                height: "22",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    fill: "#fc7785",
                                                    d: "M21.384,17.752a2.108,2.108,0,0,1-.522,3.359,7.543,7.543,0,0,1-5.476.642C10.5,20.523,3.477,13.5,2.247,8.614a7.543,7.543,0,0,1,.642-5.476,2.108,2.108,0,0,1,3.359-.522L8.333,4.7a2.094,2.094,0,0,1,.445,2.328A3.877,3.877,0,0,1,8,8.2c-2.384,2.384,5.417,10.185,7.8,7.8a3.877,3.877,0,0,1,1.173-.781,2.092,2.092,0,0,1,2.328.445Z"
                                                })
                                            }),
                                            "Contact Us"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "tooltip-area",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "overlay-box",
                                    style: {
                                        width: "300px"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5fe2fbe9d7cb90c$export$2e2bcd8739ae039), {
                                        plan: "Pro PLUS",
                                        component: "Dashboard"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gg1rem gtcr3 coreworkspace-update",
                    style: {
                        width: '75%'
                    },
                    children: [
                        moduleBox(MODULE_BOX['proPlus']['pro-plus']),
                        (user['role'] == 'Advisor' || user['role'] == 'Investor') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f9e7d74c90dd72e$export$2e2bcd8739ae039), {
                            company: company,
                            title: "Checklist Tasks",
                            type: "checklist-tasks",
                            setTab: setTab,
                            setModuleTab: setModuleTab
                        })
                    ]
                })
            ]
        });
    };
    const portfolioProReports = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg20 bss bo5 bsbb p2rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                    className: "fs1-25rem c15 w100 pl1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c7",
                            children: "Portfolio PRO"
                        }),
                        " - Core Workspace"
                    ]
                }),
                (user['role'] !== 'Advisor' || user['role'] !== 'Investor') && (permissionLevel == 'ALL' || permissionLevel == 'DASHBOARD & REPORT') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "all-reprots-area pr w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f9e7d74c90dd72e$export$2e2bcd8739ae039), {
                        company: company,
                        title: "Benchmarking Report",
                        type: "benchmark-reporting",
                        setTab: setTab,
                        seeMore: MODULE_BOX['portfolioPro']['benchmarking']['seeMore'],
                        handleSeeMore: handleSeeMore,
                        handleHowItWorks: handleHowItWorks,
                        setModuleTab: setModuleTab
                    })
                })
            ]
        });
    };
    const handleRegisterNow = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (company) dispatch((0, $b4397434d961d2b4$export$50f0ed8944cb1d90)(company));
    };
    const handleUpgrade = (plan)=>{
        if (company) dispatch((0, $b4397434d961d2b4$export$50f0ed8944cb1d90)(company));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Upgrade to ${plan} plan you need to Register`);
        localStorage.removeItem('registerAs');
        setTimeout(()=>window.location.pathname = '/register', 1000);
    };
    const showPercent = (value, type)=>{
        let color;
        if (value > 0) {
            if (type == 'Module Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
            else if (type == 'Module Complete') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
        } else color = 'c28';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
            className: `${color} fs2rem lh1 mr2rem`,
            children: [
                value || 0,
                "%",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `${value > 0 ? 'c15 ' : 'c28 '} fs0-75rem w4rem db fw300`,
                    children: type
                })
            ]
        });
    };
    const navigateSection = async (module, tab, sectionNo)=>{
        if (module && module['isHealthBoost'] && module?.['moduleKey'] && company?.['expensions'] && !company['expensions'][module['moduleKey']]) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please (Buy Now) to access it!');
            return;
        }
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        await setTab(tab);
        setTimeout(()=>{
            let element = document.getElementById(sectionNo);
            if (element) element.scrollIntoView({
                behavior: 'instant'
            }, true);
        }, 1000);
    };
    const checklistModuleTooltip = (module, sections)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ChecklistTooltipWrapper, {
            module: module,
            sections: sections,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hover-list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("9gCOW")),
                    className: "pa",
                    alt: "list-img"
                })
            })
        });
    };
    const linkToChecklistTab = (link)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        } else return `#${link}`;
    };
    const handleSetChecklistTab = async (module, moduleType)=>{
        if (moduleType === "healthboost" && !company['expensions'][module['moduleKey']] && company['subscription'] !== 'Pro') return;
        if ((company['subscription'] == 'Free' || company['subscription'] == 'Lite') && module?.type !== "Investment Readiness" && module?.type !== "Top 10 Investment Readiness Cock Ups To Avoid" && module?.type !== "Exit Readiness" && !module?.isExitReadiness) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please upgrade to PRO subscription!');
        if ((user['role'] == "Advisor" || user['role'] == 'Investor') && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`;
        if ((user['role'] == "Advisor" || user['role'] == 'Investor') && company['creatorId']['_id'] != user['_id']) {
            if (!company?.[user['role'] == "Investor" ? 'investors' : 'advisors']?.[user['_id']]?.['modules']?.[module?.['moduleKey']] && module['type'] && module['type'] != 'Investment Readiness' && module?.type !== "Top 10 Investment Readiness Cock Ups To Avoid") {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                return;
            }
        }
        if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
            // Try to get moduleKey from multiple sources
            let moduleKey = module?.['moduleKey'];
            // Fallback: Look up by moduleName in generateChecklistModules
            if (!moduleKey && company?.['generateChecklistModules']?.length) {
                const matchedModule = company['generateChecklistModules'].find((m)=>m.moduleName === module?.['type'] || m.moduleName?.toLowerCase() === module?.['type']?.toLowerCase());
                moduleKey = matchedModule?.moduleKey;
            }
            if (!company?.['memberPermissions']?.[user['_id']]?.[moduleKey]) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                return;
            }
        }
        const hashValue = `#${module?.['type']}`;
        // Set tab first, then set hash after a brief delay to ensure it persists
        await setTab(module?.['type']);
        // Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
        // Use history.replaceState to ensure the hash persists without triggering navigation
        setTimeout(()=>{
            if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
        }, 100);
    };
    const sortModules = (a, b)=>{
        return new Date(a.createdAt) - new Date(b.createdAt);
    };
    const checklistModules = (modules)=>{
        return Object.values(modules).map((module)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: " bo7 w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151351a1dd6ada95$export$2e2bcd8739ae039), {
                        module: module,
                        onNavigateSection: navigateSection,
                        setReportTab: setReportTab,
                        setIsWorkflowReport: setIsWorkflowReport,
                        type: module?.['title'] || module?.['heading'] || '',
                        company: company,
                        seeMore: module['seeMore'],
                        howItWorks: module['howItWorks']
                    }),
                    module['testType'] !== 'investment' && module['testType'] !== 'exit' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: (module['type'].includes('SME Cybersecurity') || module['category'] == 'partner') && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "pa",
                            style: {
                                top: '-10px',
                                right: '15px',
                                transform: 'translateX(-50%)'
                            },
                            src: (parcelRequire("cODJZ"))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: ()=>linkToChecklistTab(module?.['type']),
                            onClick: ()=>handleSetChecklistTab(module, "checklist"),
                            className: "cp w100 h100",
                            style: {
                                minHeight: '130px'
                            },
                            children: [
                                module?.['stats'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-area style-two pa df aic jcsb w90",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "percentage-area df jcc aic",
                                        children: [
                                            showPercent(module?.['stats']['completionPercent'], 'Module Complete'),
                                            showPercent(module?.['stats']['riskPercent'], 'Module Risk')
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon-diligenstia mr1rem",
                                            children: module['type'].includes('SME Cybersecurity') ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "br5px",
                                                src: (parcelRequire("kMt1I")),
                                                alt: ""
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w40px h40px br5px",
                                                src: module?.['imageURL'] || (parcelRequire("3N5Zr")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                module['type'] === "Investment Readiness" ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15 fs11px fw400",
                                                    children: "OneForm"
                                                }) : '',
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: `cp fs1rem fw500 bg1 c4-hover c15 lh2 title-box-feature tal ${module['type'] === "Investment Readiness" && "ReadinessTitle"}`,
                                                    children: module['type']
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                module['type'].includes('SME Cybersecurity') && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac c12 fw300",
                                    style: {
                                        fontSize: '10px'
                                    },
                                    children: "(Including 30-minute video consultation)"
                                })
                            ]
                        })
                    })
                ]
            });
        });
    };
    // Function to render a single healthboost module
    const healthboostModule = (module)=>{
        if (!module) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-tooltip": !company['subscription'] || company['subscription'] !== 'Pro' ? "Upgrade to pro" : "",
            className: `${!company['subscription'] || company['subscription'] !== 'Pro' && 'op20'} bo7 w100 keyfeature-wihte-item bg1 new-shadow br15px p1-5rem pr bsbb`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151351a1dd6ada95$export$2e2bcd8739ae039), {
                    module: module,
                    onNavigateSection: navigateSection,
                    setReportTab: setReportTab,
                    setIsWorkflowReport: setIsWorkflowReport,
                    type: module?.['title'] || module?.['heading'] || '',
                    company: company,
                    seeMore: module['seeMore'],
                    howItWorks: module['howItWorks']
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        // to={`#${module?.['type']}`}
                        className: "cp w100 h100",
                        style: {
                            minHeight: '130px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon-diligenstia mr1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "br5px",
                                            src: (parcelRequire("fePM2")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>handleSetChecklistTab(module, 'healthboost'),
                                        className: "cp fs1rem fw500 bg1 c4-hover c15 lh2 title-box-feature tal",
                                        children: module['type']
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb aic pa w100",
                                style: {
                                    bottom: '10px',
                                    left: '0rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc mt1rem",
                                        children: module?.['stats']?.['completionPercent'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcc tac pl1-5rem pb1rem",
                                            children: [
                                                showPercent(module?.['stats']['completionPercent'], 'Module Complete'),
                                                showPercent(module?.['stats']['riskPercent'], 'Module Risk')
                                            ]
                                        }) : null
                                    }),
                                    module['isBuy'] && (!company['expensions'] || module && module['moduleKey'] && company['expensions'] && !company['expensions'][module['moduleKey']] && company['subscription'] !== 'Pro') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        text: module['price'] ? `${module['price']}` : 'Buy Now',
                                        onClick: ()=>{
                                            setShowExpension(module['moduleKey']);
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'subscriptionPaymentConfirm'
                                            }));
                                        },
                                        btnType: "warning",
                                        style: {
                                            padding: '0.25rem 1rem',
                                            marginBottom: '4px',
                                            marginRight: '1rem'
                                        }
                                    }) : module?.['time'] && !module?.['stats']?.['completionPercent'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aife",
                                            style: {
                                                position: 'absolute',
                                                right: '10px',
                                                bottom: '10px'
                                            },
                                            children: module?.['time'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("jJgJl")),
                                                        style: {
                                                            width: '14px',
                                                            height: '14px'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            fontSize: '14px'
                                                        },
                                                        children: module?.['time']
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            ]
        }, module['type'] || module['moduleKey']);
    };
    // Function to render all healthboost modules (for non-carousel use)
    const healthboostModules = (modules)=>{
        return Object.values(modules).map((module)=>{
            return healthboostModule(module);
        });
    };
    // Function for carousel - accepts a single module and renders it
    // Also works without parameters to render the container (for backward compatibility)
    const healthboostBox = (module)=>{
        if (module === undefined) {
            let healthBoost = [];
            if (company?.['modules'] && Object.values(company['modules']).length > 0) healthBoost = Object.values(company?.['modules']).filter((item)=>item?.['category'] == "all" && item?.['isHealthBoost']).sort(sortModules);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: healthBoost.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt2rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb2rem pr bsb gg1-5rem",
                    style: {
                        backgroundColor: '#efffdd75'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 pl1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "",
                                src: (parcelRequire("388WO")),
                                alt: "health-boost"
                            })
                        }),
                        healthboostModules(healthBoost)
                    ]
                })
            });
        }
        // If called with a module parameter, render just that module
        if (!module) return null;
        return healthboostModule(module);
    };
    const generatePartnerModule = async (module)=>{
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            return;
        }
        let data = {
            category: 'partner',
            partnerId: module['_id'],
            companies: {
                [company['_id']]: company['cName']
            },
            memberPermissions: {
                [user['_id']]: {
                    ...user,
                    company: {
                        [company['_id']]: company['cName']
                    }
                }
            }
        };
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatePartnerPopup'
        }));
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
        if (res?.['code'] == 200) {
            window.location.href = `/company/${company['_id']}#${module['moduleName']}`;
            window.location.reload();
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const showExtraModules = (extraModules)=>{
        return extraModules.map((module)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bo7 cp w100 keyfeature-wihte-item bg1 new-shadow br15px p1-5rem pr bsbb",
                onClick: ()=>generatePartnerModule(module),
                children: [
                    module['testType'] !== 'investment' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "pa",
                        style: {
                            top: '-10px',
                            right: '-10px',
                            transform: 'translateX(-50%)'
                        },
                        src: (parcelRequire("cODJZ"))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "right-info-hyper-icon right-info-dashboard-area",
                        children: module['moduleDescription'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "info-icon cp pr ml0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    width: "27",
                                    height: "27",
                                    viewBox: "0 0 27 27",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                            cx: "13.5",
                                            cy: "13.5",
                                            r: "13.5",
                                            transform: "matrix(1 0 0 -1 0 27)",
                                            fill: "#59B8FD"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                            fill: "white"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                            fill: "white"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "shadow overlay-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "pl1rem py0-5rem fs1rem c15 fw400 tti",
                                        children: module['moduleDescription']
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "mr1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w40px h40px",
                                    src: module['imageURL'] || (parcelRequire("a8Wtc")),
                                    alt: ""
                                })
                            }),
                            module['moduleName'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    module['moduleName'] && module['moduleName'].toLowerCase() === 'investment readiness' ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15 fs11px fw400",
                                        children: "OneForm"
                                    }) : "",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem fw500 c15 lh2 mb1rem",
                                        children: module['moduleName'] === "Cyber DueDil" ? 'SME Cybersecurity' : module['moduleName']
                                    })
                                ]
                            })
                        ]
                    }),
                    module['moduleName'] === "Investment Readiness" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c70 pa fs13px",
                        style: {
                            bottom: '12px'
                        },
                        children: [
                            "Check your investment ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " readiness and access ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " summary ResearchAid Reports"
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb mt4rem",
                            children: [
                                module['moduleText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw500 c28 lh2 mr1rem",
                                    children: module['moduleText']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "cp c1 bg4 fs0-75rem br20px px2rem py0-5rem",
                                        children: "Free"
                                    })
                                })
                            ]
                        })
                    })
                ]
            });
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4a76053fe526664$export$2e2bcd8739ae039), {
                plan: plan,
                company: company,
                companyId: companyId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8434b9dd21e99392$export$2e2bcd8739ae039), {
                user: user,
                company: company,
                showExpension: showExpension
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10ce69539c98d6ac$export$2e2bcd8739ae039), {
                        user: user,
                        investorFirmCounts: investorFirmCounts,
                        company: company,
                        permissionLevel: permissionLevel,
                        setTab: setTab,
                        setIsViewTwoMinuteReport: setIsViewTwoMinuteReport,
                        checklistModules: checklistModules,
                        sortModules: sortModules,
                        portfolioProReports: portfolioProReports,
                        extensionPackages: extensionPackages,
                        showExtraModules: showExtraModules,
                        proPlusPacks: proPlusPacks,
                        getFitInvestorFirms: getFitInvestorFirms,
                        fitInvestorFirms: fitInvestorFirms,
                        handleSeeMore: handleSeeMore,
                        handleHowItWorks: handleHowItWorks,
                        setModuleTab: setModuleTab,
                        moduleBox: moduleBox,
                        handleRegisterNow: handleRegisterNow,
                        MODULE_NEW_DASHBOARD: MODULE_NEW_DASHBOARD,
                        MODULE_BOX: MODULE_BOX,
                        setCompanyDashboardTab: setCompanyDashboardTab,
                        healthboostBox: healthboostBox,
                        isGenerateAllResearchAid: isGenerateAllResearchAid
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce51629355c8164e$export$2e2bcd8739ae039), {
                        company: company,
                        setTab: setTab
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "keyFeatureSeeMore",
                open: modal['open'] == 'seeMorePopup',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '1350px'
                    },
                    children: [
                        selectedSeeMore && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        width: "55%",
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 df aic",
                                                    children: selectedSeeMore?.icon
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w90 fw500 c15 pl1rem df aic",
                                                    style: {
                                                        fontSize: '26px',
                                                        lineHeight: '37.32px'
                                                    },
                                                    children: selectedSeeMore?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: " mt0-5rem",
                                            style: {
                                                paddingLeft: '22px'
                                            },
                                            children: selectedSeeMore?.points?.map((objpoints, index)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    style: {
                                                        lineHeight: '25px',
                                                        paddingBottom: "3px",
                                                        paddingTop: "3px",
                                                        paddingLeft: "20px",
                                                        borderLeft: '2px solid #D3D9FC'
                                                    },
                                                    className: "df fdc fs1rem c14 fs1rem fw400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "circle"
                                                                }),
                                                                objpoints
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: selectedSeeMore?.subMenu && selectedSeeMore?.subMenu?.index == index && selectedSeeMore?.subMenu?.points?.map((str, i, arr)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                    style: {
                                                                        lineHeight: '30px'
                                                                    },
                                                                    children: str
                                                                });
                                                            })
                                                        })
                                                    ]
                                                }, `${objpoints}-${index}`);
                                            })
                                        }),
                                        selectedSeeMore?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt1rem",
                                            style: {
                                                border: '1px solid gray',
                                                padding: "10px",
                                                borderRadius: '10px'
                                            },
                                            children: selectedSeeMore?.notePoint
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jce",
                                    style: {
                                        width: '45%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: selectedSeeMore?.image,
                                            className: "w70",
                                            style: {
                                                objectFit: 'fill'
                                            }
                                        }),
                                        selectedSeeMore?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("fOQ2M")),
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "videoCompanies"
                                                })),
                                            className: "pa cp zi1",
                                            style: {
                                                right: '10%',
                                                bottom: '10px'
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            modal['open'] === 'howItWorksPopupNew' && modal?.howItWorksData && Object.keys(modal.howItWorksData).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e7cfd1339b30947$export$2e2bcd8739ae039), {
                selectedHowItWorks: modal.howItWorksData
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "howItWorksPopup",
                open: modal['open'] == 'howItWorksPopup',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        zoom: '0.9',
                        maxWidth: '1550px',
                        ...selectedSeeMore?.seeMoreSection?.cardPaddingBottom
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww w100",
                            children: [
                                selectedHowItWorks?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcc fdc pa",
                                    style: {
                                        right: '-7%',
                                        top: '-5%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("jLZXj")),
                                            className: "w70",
                                            style: {
                                                borderRadius: '50%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("fOQ2M")),
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "videoCompanies"
                                                })),
                                            className: "cp zi1"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "w100 tac c15 fs1-75rem fw500",
                                    children: "How does it work?"
                                }),
                                selectedHowItWorks?.['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                    className: "w100 tac c15 fs1-25rem fw500 mb1rem",
                                    children: selectedHowItWorks?.['subTitle']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-top-box df w100 jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedHowItWorks?.['stepImage'],
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                                    children: selectedHowItWorks?.['arrayImages'] && selectedHowItWorks?.['arrayImages'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['arrayImages'].map((image)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "step-img df jcc px1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: image,
                                                    alt: "ste image"
                                                })
                                            });
                                        })
                                    })
                                }),
                                selectedHowItWorks?.['checkList'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb",
                                    children: selectedHowItWorks?.['checkList'] && selectedHowItWorks?.['checkList'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['checkList'].map((array)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-inner w100 pr",
                                                children: array
                                            });
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: selectedHowItWorks?.['bottomSection'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem c12 mb1rem tac w100",
                                        children: selectedHowItWorks?.['bottomSection']
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        children: selectedHowItWorks?.['btnContent']
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'videoCompanies',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100 p2-5rem bsbb df fdc m1rem maw900px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: '0'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                src: "https://www.loom.com/embed/22404ff9e1514a3ca4a169af00ee93e1?sid=bf8bbfc8-8d7d-4361-9227-cc2876f6bd2d&output=embed",
                                frameborder: "0",
                                webkitallowfullscreen: "true",
                                mozallowfullscreen: "true",
                                allowFullScreen: true,
                                style: {
                                    position: 'absolute',
                                    top: '0',
                                    left: '0',
                                    width: '100%',
                                    height: '100%'
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7d2c3a0ad8be93d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'seeCertificate',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc onone",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `mah90 oya bg1 shadow w100 pt1rem pl1rem pr1rem pb2rem bsbb df fdc m1rem br20px pr maw50`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb aic fdc step-box-modal",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "step-box-box-1 tac w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w200px ma",
                                                    src: (parcelRequire("2fucc")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                    className: "c15 fs2rem fw400 mb1rem",
                                                    children: "Oops!"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "tac c15 op60 maw80 px2rem fs1rem lh1-5rem",
                                            children: "Sorry, but can only access this module if you have Diligentsia Gold certification. This is to preserve the quality of qualified and diligenced leads we introduce to investors on our investor database. We look forwards to seeing you soon once you have achieved gold!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `#unaudited-certification`,
                                        className: "p1rem pl4rem pr4rem shadow c1 bg4 bg3-hover br35px mt1rem mb1rem mr2-5rem cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                        onClick: ()=>{
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }));
                                            setModuleTab(setTab, 'unaudited-certification');
                                        },
                                        children: "See Certification status"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })), resetStates();
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '100px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "generatePartnerPopup",
                open: modal['open'] == 'generatePartnerPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: "Performing checklist creation magic!"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar module-progress-bar`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: "This may take couple of minutes to generate checklist."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $710d879c9ded52d9$export$2e2bcd8739ae039), {
                Objective: company['testType'],
                subscription: company['subscription'],
                company: company
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87ab33a89f0105e5$export$2e2bcd8739ae039), {
                Objective: company['testType'],
                subscription: company['subscription'],
                company: company,
                showExpension: showExpension,
                setShowExpension: setShowExpension,
                user: user
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "swotReportPopup",
                open: modal['open'] == 'swotReportPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc my3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1-5rem",
                                            children: "SWOT Analysis Report"
                                        }),
                                        isSwotReport ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem c15 mb1rem tac",
                                            children: [
                                                "Generate the other ResearchAid reports before ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " generating the SWOT Report"
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem c15 mb1rem tac",
                                            children: [
                                                "The SWOT report will produce better results if you first generate  ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " the Technology Competitive Advantage Report"
                                            ]
                                        })
                                    ]
                                }),
                                isSwotReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "bg4 fs0-75rem fw600 c1 td250 br30px px4rem py0-5rem cp tac",
                                        children: "Back"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsa mt2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "bg4 fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: (user['role'] != 'Advisor' && user['role'] != 'Investor' || user?.['companyId']?.['_id'] == company?.['_id']) && `/researchAid/${company['_id']}?swotAnalysis`,
                                            "data-tooltip": (user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id'] ? `${user['role']} can't generate report from company dashboard!` : '',
                                            state: {
                                                company: company
                                            },
                                            className: `fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac ${(user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id'] ? 'cna bg16' : 'cp bg3'}`,
                                            children: "Generate"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}



var $ayMG0 = parcelRequire("ayMG0");
"use client";
const $bd56a4485ab443d2$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $bd56a4485ab443d2$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $acw62.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ // eslint-disable-next-line @typescript-eslint/no-use-before-define
        const element = /*#__PURE__*/ (0, $ayMG0.jsx)($bd56a4485ab443d2$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $acw62.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $bd56a4485ab443d2$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $bd56a4485ab443d2$var$ROUND_PRECISION) / $bd56a4485ab443d2$var$ROUND_PRECISION;
}
function $bd56a4485ab443d2$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$bd56a4485ab443d2$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $bd56a4485ab443d2$var$ProgressBar = /*#__PURE__*/ $acw62.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(props.bsPrefix, 'progress');
    if (isChild) return $bd56a4485ab443d2$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, bsPrefix),
        children: children ? (0, $d3ae4136892dd278$export$871de8747c9eaa88)(children, (child)=>/*#__PURE__*/ (0, $acw62.cloneElement)(child, {
                isChild: true
            })) : $bd56a4485ab443d2$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$bd56a4485ab443d2$var$ProgressBar.displayName = 'ProgressBar';
var $bd56a4485ab443d2$export$2e2bcd8739ae039 = $bd56a4485ab443d2$var$ProgressBar;







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $1129f9c8b56c4712$var$UpgradeCards = ({ user: user, company: company, upgradePlan: upgradePlan, setShowExpension: setShowExpension })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handleUpgrade = (card)=>{
        if (upgradePlan) {
            setShowExpension(card['title']);
            return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'subscriptionPaymentConfirm'
            }));
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'whatYouGetModal'
        }));
    };
    // Don't show any cards if subscription is Pro
    if (company?.['subscription'] === 'Pro') return null;
    const allUpgradeCards = [
        {
            title: 'Lite',
            price: "\xa38.25",
            buttonText: 'Upgrade'
        },
        {
            title: 'Pro',
            price: "\xa383.25",
            buttonText: 'Upgrade'
        }
    ];
    // Filter cards based on subscription
    let upgradeCards = [];
    if (user && (user?.role?.toLowerCase() === 'advisor' || user?.role?.toLowerCase() === 'investor' || company?.['servicedBy']?.['role']?.toLowerCase() === 'advisor' || company?.['servicedBy']?.['role']?.toLowerCase() === 'investor')) upgradeCards = allUpgradeCards.filter((card)=>card.title === 'Pro');
    else {
        if (company?.['subscription'] === 'Free') // Show both cards for Free subscription
        upgradeCards = allUpgradeCards;
        else if (company?.['subscription'] === 'Lite') // Show only PRO card for Lite subscription
        upgradeCards = allUpgradeCards.filter((card)=>card.title === 'Pro');
        else // Default: show both cards (for cases where subscription might be null or undefined)
        upgradeCards = allUpgradeCards;
    }
    // Don't render if no cards to show
    if (upgradeCards.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df aic jcfe tac ",
        style: {
            marginTop: '5px'
        },
        children: upgradeCards.map((card, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `shadow br20px p1rem ${index + 1 === upgradeCards.length ? 'mr0rem' : 'mr1rem'}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb aifs fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs1-25rem fw500 c59 w100 tal ttu",
                                    children: card.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs1-25rem fs1-5rem-sm fw500 c3",
                                    children: [
                                        card.price,
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs14px c15 fw400",
                                            children: "/month"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>handleUpgrade(card),
                            className: "bg4 bg3-hover fs1rem c1 td250 br30px px2rem py0-5rem cp tac mt0-5rem ml1rem fw600",
                            children: card.buttonText
                        })
                    ]
                })
            }, card.title))
    });
};
var $1129f9c8b56c4712$export$2e2bcd8739ae039 = $1129f9c8b56c4712$var$UpgradeCards;






// Helper function to get certification level image
const $029a2d9637150f15$var$getCertificationLevelImage = (level)=>{
    const images = {
        None: (parcelRequire("4QCMo")),
        Bronze: (parcelRequire("l8qRI")),
        Silver: (parcelRequire("7RlQ5")),
        Gold: (parcelRequire("7Y2KK"))
    };
    return images[level] || images.None;
};
// Helper function to get certification level display name
const $029a2d9637150f15$var$getCertificationLevelName = (cLevel)=>{
    return cLevel === "None" || !cLevel ? 'Not Yet Certified' : cLevel;
};


// Helper function to render check icon
const $029a2d9637150f15$var$renderCheckIcon = (condition, checkType = 'default')=>{
    const checkIconStyle = {
        width: '24px',
        height: '24px',
        marginLeft: '-2px',
        marginTop: '-2px',
        left: '12px',
        top: '4px'
    };
    const checkIcon = checkType === 'business-audit' ? (parcelRequire("P717a")) : (parcelRequire("dRdvp"));
    return condition ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: checkIcon,
        alt: "check",
        className: "pa",
        style: checkIconStyle
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "icon round"
    });
};
// Helper function to render score display with NIL logic
const $029a2d9637150f15$var$renderScoreDisplay = (value, allowedLevels, companyLevel, label, isRisk = false)=>{
    console.log(value, "----->", allowedLevels, "companyLevel", companyLevel, "label", label, "isRisk", isRisk);
    const isAllowed = allowedLevels.some((level)=>companyLevel?.toLowerCase() === level.toLowerCase());
    const scoreStyle = {
        backgroundColor: '#02BC7D21',
        padding: '4px 12px',
        textAlign: 'center'
    };
    const nilStyle = {
        color: '#5E5F66',
        fontSize: '14px'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "c15 fs1rem br20px",
        style: scoreStyle,
        children: isAllowed || value > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: `w100 tal ${isRisk ? 'df aic' : ''}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: isRisk ? "c9" : "c7",
                children: [
                    value || 0,
                    "%"
                ]
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "fsi fw600 w100 tal",
            style: nilStyle,
            children: "NIL"
        })
    });
};
// Helper function to render Buy button
const $029a2d9637150f15$var$renderBuyButton = (onClick, condition)=>{
    if (!condition) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bg4 c1 br20px tac df aic jcc",
        style: {
            padding: '2px 6px',
            width: '80px',
            maxHeight: '32px',
            fontSize: '14px'
        },
        onClick: onClick,
        children: "Buy"
    });
};
// Configuration for certification levels
const $029a2d9637150f15$var$CERTIFICATION_LEVELS = [
    'None',
    'Bronze',
    'Silver',
    'Gold'
];



// Configuration for requirements by level
const $029a2d9637150f15$var$REQUIREMENTS_CONFIG = {
    Bronze: {
        image: (parcelRequire("bYbOr")),
        requirements: [
            {
                id: 'p1',
                type: 'data-repository',
                title: 'Data Repository',
                requiredCompleteness: 75,
                moduleKey: 'repository',
                statKey: 'completionPercent',
                allowedLevels: [
                    'bronze',
                    'silver',
                    'gold'
                ]
            },
            {
                id: 'p2',
                type: 'business-audit',
                title: 'Business Audit',
                requiredCompleteness: 75,
                requiredRisk: 50,
                moduleKey: `business-audit-{testType}`,
                statKey: 'completionPercent',
                riskKey: 'riskPercent',
                allowedLevels: [
                    'bronze',
                    'silver',
                    'gold'
                ]
            }
        ]
    },
    Silver: {
        image: (parcelRequire("f4EyH")),
        requirements: [
            {
                id: 'p1',
                type: 'data-repository',
                title: 'Data Repository',
                requiredCompleteness: 90,
                moduleKey: 'repository',
                statKey: 'completionPercent',
                allowedLevels: [
                    'silver',
                    'gold'
                ]
            },
            {
                id: 'p2',
                type: 'business-audit',
                title: 'Business Audit',
                requiredCompleteness: 90,
                requiredRisk: 50,
                moduleKey: `business-audit-{testType}`,
                statKey: 'completionPercent',
                riskKey: 'riskPercent',
                allowedLevels: [
                    'silver',
                    'gold'
                ]
            },
            {
                id: 'p3',
                type: 'warranty-disclosure',
                title: 'Draft Warranty Disclosures',
                requiredCompleteness: 75,
                moduleKey: 'warranty-disclosure',
                statKey: 'riskPercent',
                allowedLevels: [
                    'silver',
                    'gold'
                ],
                hasBuyButton: true,
                buyButtonCode: 'DEPF006'
            },
            {
                id: 'p4',
                type: 'directors-questionnaire',
                title: "Draft Director\u2019s Questionnaires",
                requiredCompleteness: 75,
                requiredRisk: 50,
                moduleKey: `directors-questionnaire-{directorId}`,
                statKey: 'completionPercent',
                riskKey: 'riskPercent',
                allowedLevels: [
                    'silver',
                    'gold'
                ],
                hasBuyButton: true,
                buyButtonCode: 'DEPF007'
            }
        ]
    },
    Gold: {
        image: (parcelRequire("ibdCR")),
        requirements: [
            {
                id: 'p1',
                type: 'data-repository',
                title: 'Data Repository',
                requiredCompleteness: 100,
                moduleKey: 'repository',
                statKey: 'completionPercent',
                allowedLevels: [
                    'bronze',
                    'silver',
                    'gold'
                ]
            },
            {
                id: 'p2',
                type: 'business-audit',
                title: 'Business Audit',
                requiredCompleteness: 100,
                requiredRisk: 25,
                moduleKey: `business-audit-{testType}`,
                statKey: 'completionPercent',
                riskKey: 'riskPercent',
                allowedLevels: [
                    'bronze',
                    'silver',
                    'gold'
                ]
            },
            {
                id: 'p3',
                type: 'warranty-disclosure',
                title: 'Draft Warranty Disclosures',
                requiredCompleteness: 90,
                moduleKey: 'warranty-disclosure',
                statKey: 'completionPercent',
                allowedLevels: [
                    'bronze',
                    'silver',
                    'gold'
                ],
                hasBuyButton: true,
                buyButtonCode: 'DEPF006'
            },
            {
                id: 'p4',
                type: 'directors-questionnaire',
                title: "Draft Director\u2019s Questionnaires",
                requiredCompleteness: 90,
                requiredRisk: 50,
                moduleKey: `directors-questionnaire-{directorId}`,
                statKey: 'completionPercent',
                riskKey: 'riskPercent',
                allowedLevels: [
                    'bronze',
                    'silver',
                    'gold'
                ],
                hasBuyButton: true,
                buyButtonCode: 'DEPF007'
            }
        ]
    }
};


// Component for rendering a requirement item
const $029a2d9637150f15$var$RequirementItem = ({ requirement: requirement, level: level, company: company, disabledCertificates: disabledCertificates, directors: directors, dispatch: dispatch, setShowExpension: setShowExpension })=>{
    // Look up stats from certTempModulesStats by certType matching requirement.type
    const certModuleStats = Object.values(company?.['certTempModulesStats'] || {}).find((m)=>m['certType'] === requirement.type) || {};
    const moduleExists = !!certModuleStats['moduleKey'];
    // Silver warranty-disclosure displays riskPercent as the "completeness" value (statKey: 'riskPercent')
    let completionPercent = 0;
    let riskPercent = 0;
    if (requirement.type === 'warranty-disclosure' && level === 'Silver') completionPercent = certModuleStats['completionPercent'] || 0;
    else {
        completionPercent = certModuleStats['completionPercent'] || 0;
        riskPercent = certModuleStats['riskPercent'] || 0;
    }
    const isChecked = requirement.type === 'business-audit' || requirement.type === 'directors-questionnaire' ? completionPercent >= requirement.requiredCompleteness && riskPercent <= requirement.requiredRisk : completionPercent >= requirement.requiredCompleteness;
    const allowedLevels = requirement.allowedLevels || [
        level.toLowerCase()
    ];
    const showScore = allowedLevels.some((l)=>company['cLevel']?.toLowerCase() === l.toLowerCase());
    const handleBuyClick = ()=>{
        if (disabledCertificates) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'subscriptionPaymentConfirm'
        }));
        setShowExpension(requirement.buyButtonCode);
    };
    console.log(certModuleStats['moduleKey'], "----->", disabledCertificates, "certModuleStats", requirement.hasBuyButton);
    const shouldShowBuyButton = requirement.hasBuyButton && (disabledCertificates || !moduleExists);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
        className: !disabledCertificates && company['points']?.[level]?.[requirement.id] && 'check',
        children: [
            $029a2d9637150f15$var$renderCheckIcon(isChecked, requirement.type === 'business-audit' || requirement.type === 'directors-questionnaire' ? 'business-audit' : 'default'),
            requirement.type === 'warranty-disclosure' && level === 'Silver' && isChecked && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "icon check",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("dRdvp")),
                    alt: ""
                })
            }),
            requirement.type === 'directors-questionnaire' && level === 'Silver' && isChecked && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "icon check",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("dRdvp")),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `df ${requirement.hasBuyButton ? 'jcsb' : ''}`,
                style: requirement.hasBuyButton ? {
                    columnGap: '1rem'
                } : {},
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                            className: "c74 df aic jcsb",
                            children: [
                                requirement.title,
                                " ",
                                $029a2d9637150f15$var$renderBuyButton(handleBuyClick, shouldShowBuyButton)
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gtcr3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: " "
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fw300",
                                    style: {
                                        color: '#929090',
                                        fontSize: '14px'
                                    },
                                    children: "Your Score:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fw300",
                                    style: {
                                        color: '#929090',
                                        fontSize: '14px'
                                    },
                                    children: "Required Score:"
                                }),
                                requirement.type === 'data-repository' || requirement.type === 'warranty-disclosure' && level === 'Gold' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem",
                                            children: "Completeness"
                                        }),
                                        $029a2d9637150f15$var$renderScoreDisplay(shouldShowBuyButton ? 0 : completionPercent, allowedLevels, company['cLevel'], 'Completeness', false),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c74",
                                            children: [
                                                "> ",
                                                requirement.requiredCompleteness,
                                                "%"
                                            ]
                                        })
                                    ]
                                }) : requirement.type === 'warranty-disclosure' && level === 'Silver' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem",
                                            children: "Completeness"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "c15 fs1rem br20px ",
                                            style: {
                                                backgroundColor: '#02BC7D21',
                                                padding: '4px 12px',
                                                maxWidth: '160px',
                                                textAlign: 'center'
                                            },
                                            children: showScore && !shouldShowBuyButton ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "w100 tal",
                                                children: [
                                                    completionPercent,
                                                    "   "
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fsi fw600 w100 tal",
                                                style: {
                                                    color: '#5E5F66',
                                                    fontSize: '14px'
                                                },
                                                children: "NIL"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c74",
                                            children: [
                                                "> ",
                                                requirement.requiredCompleteness || 0,
                                                "%"
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "df aic w100 c15",
                                            children: "Completeness"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: $029a2d9637150f15$var$renderScoreDisplay(shouldShowBuyButton ? 0 : completionPercent, allowedLevels, company['cLevel'], 'Completeness', false)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c74",
                                            children: [
                                                " >  ",
                                                requirement.requiredCompleteness,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "df aic w100 c15",
                                            children: "Risk"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "c15 fs1rem br20px mt0-5rem",
                                            style: {
                                                backgroundColor: '#02BC7D21',
                                                padding: '4px 12px',
                                                maxWidth: '150px',
                                                textAlign: 'center'
                                            },
                                            children: showScore && !shouldShowBuyButton ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "df aic w100",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "c9",
                                                    children: [
                                                        riskPercent,
                                                        "%"
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fsi fw600 w100 tal",
                                                style: {
                                                    color: '#5E5F66',
                                                    fontSize: '14px'
                                                },
                                                children: "NIL"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c74",
                                            children: [
                                                "< ",
                                                requirement.requiredRisk,
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
// Component for rendering a certification level card
const $029a2d9637150f15$var$CertificationLevelCard = ({ level: level, config: config, company: company, disabledCertificates: disabledCertificates, directors: directors, dispatch: dispatch, setShowExpension: setShowExpension })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `jcsb data-check-box ${disabledCertificates && 'op60'}`,
        "aria-disabled": disabledCertificates,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic mb2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: config.image,
                        alt: `${level} certification`,
                        style: {
                            width: '82px',
                            height: '100px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc jcfs aifs ml1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "c15 fs1-5rem lh1 w100 tal",
                                children: level
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c27 fs0-75rem lh1 mt0-5rem",
                                children: "Unaudited Certification Progress"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "data-list",
                children: config.requirements.map((requirement)=>/*#__PURE__*/ (0, $ayMG0.jsx)($029a2d9637150f15$var$RequirementItem, {
                        requirement: requirement,
                        level: level,
                        company: company,
                        disabledCertificates: disabledCertificates,
                        directors: directors,
                        dispatch: dispatch,
                        setShowExpension: setShowExpension
                    }, requirement.id))
            })
        ]
    });
};

function $029a2d9637150f15$export$2e2bcd8739ae039({ company: company, setTab: setTab, directors: directors }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let [payload, setPayload] = (0, $acw62.useState)(null);
    let [showExpension, setShowExpension] = (0, $acw62.useState)(null);
    const [linearProgress, setLinearProgress] = (0, $acw62.useState)(25);
    const [disabledCertificates, setDisabledCertificates] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        if ([
            'Lite',
            'Free'
        ].includes(company['subscription'])) setDisabledCertificates(true);
        else setDisabledCertificates(false);
        // Set Linear Progress
        const progressMap = {
            Bronze: 50,
            Silver: 75,
            Gold: 100
        };
        setLinearProgress(progressMap[company['cLevel']] || 25);
    }, [
        company
    ]);
    const getDisabledCertificates = (company, level)=>{
        if (company['cLevel'] === 'None') return true;
        if (company['cLevel'] === 'Bronze') return level === 'Silver' || level === 'Gold';
        if (company['cLevel'] === 'Silver') return level === 'Gold';
        if (company['cLevel'] === 'Gold') return false;
        return true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "certificates-page",
                children: company['points'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: disabledCertificates && 'disabled-certificates-page',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "badges-sec c2 br20px df jcsb aife",
                                style: {
                                    backgroundColor: '#2947EF1A',
                                    border: '1px solid #7385BE80'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pt1rem pl2rem pb1rem df",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "badges-area w100",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "certificates-current w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "top-heading",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                className: "c15",
                                                                children: "Your Progress"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                style: {
                                                                    color: '#44D991'
                                                                },
                                                                children: "PRO Only"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "ass fs0-75rem df aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: $029a2d9637150f15$var$getCertificationLevelImage(company['cLevel'] || 'None'),
                                                                        alt: `${company['cLevel'] || 'None'} star`
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "ml0-5rem c15 op70 fsi fs1-25rem w100",
                                                                        children: $029a2d9637150f15$var$getCertificationLevelName(company['cLevel'])
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df ",
                                                        children: company['points'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "packge-select",
                                                            style: {
                                                                width: '100%'
                                                            },
                                                            children: $029a2d9637150f15$var$CERTIFICATION_LEVELS.map((level)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: `px1rem ${company['cLevel'] === level && 'current'}`,
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54119cc183dc6bdf$export$2e2bcd8739ae039), {
                                                                        className: "z12",
                                                                        component: "Certificates",
                                                                        level: level,
                                                                        subscription: company['subscription'],
                                                                        expiryTimestamp: company['createdAt'],
                                                                        company: company,
                                                                        large: true
                                                                    })
                                                                }, level))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "p1rem w100",
                                                        children: company['certificateNext'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                width: '100%'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "certificate-progress-bar certificate-progress-bar-custom",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd56a4485ab443d2$export$2e2bcd8739ae039), {
                                                                    now: linearProgress
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("dTtgw")),
                                        alt: "certification-bg",
                                        className: "certification-bg",
                                        style: {
                                            maxWidth: '600px',
                                            height: 'auto'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt2rem br20px pt2rem pl2rem pb1rem",
                                style: {
                                    backgroundColor: '#fff',
                                    border: '1px solid #DBDFEE'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "progress-sec",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb aifs mb1rem pr2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        paddingLeft: '10px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "c15",
                                                            children: " Requirements for certification progress"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                            style: {
                                                                color: '#44D991'
                                                            },
                                                            children: "PRO Only"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1129f9c8b56c4712$export$2e2bcd8739ae039), {
                                                    company: company,
                                                    upgradePlan: true,
                                                    setShowExpension: setShowExpension
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "container",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "data-check-sec",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "dg gg2rem gtcr3",
                                                    children: Object.entries($029a2d9637150f15$var$REQUIREMENTS_CONFIG).map(([level, config])=>/*#__PURE__*/ (0, $ayMG0.jsx)($029a2d9637150f15$var$CertificationLevelCard, {
                                                            level: level,
                                                            config: config,
                                                            company: company,
                                                            disabledCertificates: getDisabledCertificates(company, level),
                                                            directors: directors,
                                                            dispatch: dispatch,
                                                            setShowExpension: setShowExpension
                                                        }, level))
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da20b8fe5a9fd138$export$2e2bcd8739ae039), {
                plan: !showExpension ? 'Pro' : typeof showExpension === "string" ? showExpension : showExpension?.['moduleKey'],
                setShowExpension: setShowExpension,
                defaultStep: [
                    'Lite',
                    'Pro'
                ].includes(showExpension) ? 'subscriptionUpgrade' : 'modulePurchase',
                company: company,
                companyId: company['_id'],
                payload: payload,
                module: showExpension,
                showExpension: showExpension
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");









var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

function $6577913b75629c54$export$2e2bcd8739ae039({ message: message }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "loader",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "loader-area df fdc aic",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: {
                        width: '25%'
                    },
                    src: (parcelRequire("hA45b"))
                }),
                message && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "loading-text",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "text-gradient",
                        style: {
                            fontSize: '1.5rem'
                        },
                        children: message
                    })
                })
            ]
        })
    });
}







// function to convert certification level to progress percentage
const $86727a4e8cc19e92$var$cLevelToProgress = (cLevel)=>{
    const level = (cLevel || '').toLowerCase();
    if (level === 'none' || !level) return 25;
    if (level === 'bronze') return 50;
    if (level === 'silver') return 75;
    if (level === 'gold') return 100;
    return 25;
};
const $86727a4e8cc19e92$var$PlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "30px",
        height: "30px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#4A67FF",
                d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M21,14h6v20h-6V14z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M14,21h20v6H14V21z"
            })
        ]
    });
};
const $86727a4e8cc19e92$var$DisablePlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                "clip-path": "url(#clip0_2037_11597)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M14 0C6.28009 0 0 6.28009 0 14C0 21.7199 6.28009 28 14 28C21.7199 28 28 21.7199 28 14C28 6.28009 21.7199 0 14 0Z",
                        fill: "#CECECE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.1229 15.1652H15.1645V20.1236C15.1645 20.7677 14.642 21.2902 13.9979 21.2902C13.3538 21.2902 12.8313 20.7677 12.8313 20.1236V15.1652H7.87289C7.22882 15.1652 6.7063 14.6427 6.7063 13.9986C6.7063 13.3546 7.22882 12.832 7.87289 12.832H12.8313V7.87363C12.8313 7.22955 13.3538 6.70703 13.9979 6.70703C14.642 6.70703 15.1645 7.22955 15.1645 7.87363V12.832H20.1229C20.767 12.832 21.2895 13.3546 21.2895 13.9986C21.2895 14.6427 20.767 15.1652 20.1229 15.1652Z",
                        fill: "#FAFAFA"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_2037_11597",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "28",
                        height: "28",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
const $86727a4e8cc19e92$var$statusOptions = [
    {
        value: "Interested",
        label: "Pending",
        tooltip: 'Not available for Climb26',
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M10.0007 0.832031C4.94615 0.832031 0.833984 4.9442 0.833984 9.9987C0.833984 15.0532 4.94615 19.1654 10.0007 19.1654C15.0552 19.1654 19.1673 15.0532 19.1673 9.9987C19.1673 4.9442 15.0552 0.832031 10.0007 0.832031ZM10.0007 17.332C5.95723 17.332 2.66732 14.0421 2.66732 9.9987C2.66732 5.95528 5.95723 2.66536 10.0007 2.66536C14.0441 2.66536 17.334 5.95528 17.334 9.9987C17.334 14.0421 14.0441 17.332 10.0007 17.332Z",
                    fill: "#FFBC00"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M8.16667 6.33203C7.66067 6.33203 7.25 6.74178 7.25 7.2487V12.7487C7.25 13.2556 7.66067 13.6654 8.16667 13.6654C8.67267 13.6654 9.08333 13.2556 9.08333 12.7487V7.2487C9.08333 6.74178 8.67267 6.33203 8.16667 6.33203Z",
                    fill: "#FFBC00"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M11.8346 6.33203C11.3277 6.33203 10.918 6.74178 10.918 7.2487V12.7487C10.918 13.2556 11.3277 13.6654 11.8346 13.6654C12.3416 13.6654 12.7513 13.2556 12.7513 12.7487V7.2487C12.7513 6.74178 12.3416 6.33203 11.8346 6.33203Z",
                    fill: "#FFBC00"
                })
            ]
        })
    },
    {
        value: "Accepted",
        label: "Approved",
        tooltip: 'Not available for Climb26',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.7828 6.28613C13.0439 6.54723 13.0439 6.97046 12.7828 7.23143L8.29878 11.7156C8.03769 11.9766 7.61458 11.9766 7.35349 11.7156L5.21891 9.58089C4.95781 9.31993 4.95781 8.89669 5.21891 8.63573C5.47987 8.37463 5.90311 8.37463 6.16407 8.63573L7.82607 10.2977L11.8375 6.28613C12.0986 6.02517 12.5219 6.02517 12.7828 6.28613ZM17.5564 9.00087C17.5564 13.7299 13.7293 17.5564 9.00087 17.5564C4.27179 17.5564 0.445312 13.7293 0.445312 9.00087C0.445312 4.27179 4.27244 0.445312 9.00087 0.445312C13.7299 0.445312 17.5564 4.27244 17.5564 9.00087ZM16.2196 9.00087C16.2196 5.01069 12.9905 1.78212 9.00087 1.78212C5.01069 1.78212 1.78212 5.01121 1.78212 9.00087C1.78212 12.991 5.01121 16.2196 9.00087 16.2196C12.991 16.2196 16.2196 12.9905 16.2196 9.00087Z",
                fill: "#15D757"
            })
        })
    },
    {
        value: "Rejected",
        label: "Rejected",
        tooltip: 'Not available for Climb26',
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M8.55556 0C6.86343 0 5.2093 0.501774 3.80235 1.44187C2.39539 2.38197 1.29881 3.71816 0.651257 5.28148C0.00370702 6.84481 -0.165722 8.56504 0.164396 10.2247C0.494514 11.8843 1.30935 13.4087 2.50587 14.6052C3.70238 15.8018 5.22684 16.6166 6.88645 16.9467C8.54607 17.2768 10.2663 17.1074 11.8296 16.4599C13.3929 15.8123 14.7291 14.7157 15.6692 13.3088C16.6093 11.9018 17.1111 10.2477 17.1111 8.55555C17.1084 6.2873 16.2062 4.11272 14.6023 2.50882C12.9984 0.904921 10.8238 0.00267592 8.55556 0ZM8.55556 15.5556C7.17109 15.5556 5.81771 15.145 4.66657 14.3758C3.51542 13.6067 2.61822 12.5134 2.0884 11.2343C1.55859 9.95525 1.41997 8.54779 1.69006 7.18992C1.96016 5.83206 2.62684 4.58477 3.60581 3.60581C4.58478 2.62684 5.83206 1.96015 7.18993 1.69006C8.54779 1.41996 9.95526 1.55858 11.2343 2.0884C12.5134 2.61821 13.6067 3.51542 14.3758 4.66656C15.145 5.81771 15.5556 7.17108 15.5556 8.55555C15.5535 10.4114 14.8153 12.1907 13.503 13.503C12.1907 14.8153 10.4114 15.5535 8.55556 15.5556Z",
                    fill: "#F14D4D"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M11.9758 5.13283C11.8246 4.9817 11.6196 4.8968 11.4058 4.8968C11.1919 4.8968 10.9869 4.9817 10.8357 5.13283L8.55534 7.41347L6.275 5.13283C6.20062 5.05583 6.11165 4.99442 6.01327 4.95217C5.91489 4.90992 5.80909 4.88768 5.70202 4.88675C5.59495 4.88582 5.48878 4.90622 5.38968 4.94675C5.29058 4.98729 5.20055 5.04715 5.12484 5.12284C5.04913 5.19853 4.98926 5.28854 4.94872 5.38762C4.90817 5.48669 4.88777 5.59285 4.8887 5.69989C4.88963 5.80693 4.91188 5.91271 4.95414 6.01107C4.9964 6.10943 5.05782 6.19838 5.13484 6.27275L7.41517 8.55339L5.13484 10.834C5.05782 10.9084 4.9964 10.9973 4.95414 11.0957C4.91188 11.1941 4.88963 11.2998 4.8887 11.4069C4.88777 11.5139 4.90817 11.6201 4.94872 11.7192C4.98926 11.8182 5.04913 11.9082 5.12484 11.9839C5.20055 12.0596 5.29058 12.1195 5.38968 12.16C5.48878 12.2006 5.59495 12.221 5.70202 12.22C5.80909 12.2191 5.91489 12.1969 6.01327 12.1546C6.11165 12.1124 6.20062 12.0509 6.275 11.9739L8.55534 9.6933L10.8357 11.9739C10.9101 12.0509 10.999 12.1124 11.0974 12.1546C11.1958 12.1969 11.3016 12.2191 11.4087 12.22C11.5157 12.221 11.6219 12.2006 11.721 12.16C11.8201 12.1195 11.9101 12.0596 11.9858 11.9839C12.0615 11.9082 12.1214 11.8182 12.162 11.7192C12.2025 11.6201 12.2229 11.5139 12.222 11.4069C12.221 11.2998 12.1988 11.1941 12.1565 11.0957C12.1143 10.9973 12.0529 10.9084 11.9758 10.834L9.6955 8.55339L11.9758 6.27275C12.127 6.12157 12.2119 5.91655 12.2119 5.70279C12.2119 5.48902 12.127 5.28401 11.9758 5.13283Z",
                    fill: "#F14D4D"
                })
            ]
        })
    }
];
const $86727a4e8cc19e92$var$Option = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "pr",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
            ...props,
            className: "cp pr",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                    className: "icon",
                    children: props.data.icon
                }),
                props.data.label
            ]
        })
    });








function $86727a4e8cc19e92$export$2e2bcd8739ae039({ company: company, setCompanyDashboardTab: setCompanyDashboardTab, setTab: setTab, isExternal: isExternal, setReport: setReport, setIsDirectorsReport: setIsDirectorsReport }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const dropdownRef = (0, $acw62.useRef)(null);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [isSaved, setIsSaved] = (0, $acw62.useState)(false);
    let [isDropdown, setIsDropdown] = (0, $acw62.useState)(false);
    let [qualifiedLead, setQualifiedLead] = (0, $acw62.useState)({});
    let [showDropdown, setShowDropdown] = (0, $acw62.useState)(false);
    let [newQuickResponse, setNewQuickResponse] = (0, $acw62.useState)('');
    let [selectedResponse, setSelectedResponse] = (0, $acw62.useState)('');
    let [existingReportUrl, setExistingReportUrl] = (0, $acw62.useState)(null);
    let [existingReportDate, setExistingReportDate] = (0, $acw62.useState)(null);
    let [isGeneratingReport, setIsGeneratingReport] = (0, $acw62.useState)(false);
    let [statusSelected, setStatusSelected] = (0, $acw62.useState)($86727a4e8cc19e92$var$statusOptions[0]);
    let [reports, setReports] = (0, $acw62.useState)([]);
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let [docsArray, setDocsArray] = (0, $acw62.useState)(company?.['investmentReadinessFiles'] || []);
    let [localModules, setLocalModules] = (0, $acw62.useState)(company?.['modules'] || {});
    let [localDirectorsStats, setLocalDirectorsStats] = (0, $acw62.useState)(company?.['directorsStats'] || null);
    let [expanded, setExpanded] = (0, $acw62.useState)({
        consolidatedDocument: true,
        investorFitReportPanel: true,
        valueDiligenceReportPanel: true,
        foundationalDiligenceReportPanel: true
    });
    (0, $acw62.useEffect)(()=>{
        // Add event listener when component mounts
        document.addEventListener('mousedown', toggleDropdown);
        // Clean up event listener when component unmounts
        return ()=>{
            document.removeEventListener('mousedown', toggleDropdown);
        };
    }, []);
    const toggleDropdown = (event)=>{
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsDropdown(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (localStorage.getItem('scrollToValue')) {
            setTimeout(()=>document.getElementById('value-diligence-section').scrollIntoView({
                    behavior: 'smooth'
                }), 100);
            localStorage.removeItem('scrollToValue');
        }
        if (localStorage.getItem('scrollToFoundational')) {
            setTimeout(()=>document.getElementById('foundational-diligence-section').scrollIntoView({
                    behavior: 'smooth'
                }), 100);
            localStorage.removeItem('scrollToFoundational');
        }
    }, []);
    // Fetch all DiligencePack data from dedicated endpoint
    (0, $acw62.useEffect)(()=>{
        if (!company?._id) return;
        const fetchDiligencePackData = async ()=>{
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/diligence-pack/${company._id}`);
            if (res?.['code'] === 200) {
                const { researchAidReports: researchAidReports, investmentReadinessFiles: investmentReadinessFiles, modules: modules, directorsStats: directorsStats } = res['body'];
                if (researchAidReports) setReports(researchAidReports);
                if (investmentReadinessFiles) setDocsArray(investmentReadinessFiles);
                if (modules) setLocalModules(modules);
                if (directorsStats) setLocalDirectorsStats(directorsStats);
            }
        };
        fetchDiligencePackData();
    }, [
        company?._id
    ]);
    const qualifiedLeadFetchedRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const clientId = company?._id;
        const investorId = user?.['companyId']?.['_id'];
        if (!clientId || !investorId || clientId === investorId || user?.['role'] !== 'Investor') return;
        const fetchKey = `${clientId}:${investorId}`;
        if (qualifiedLeadFetchedRef.current === fetchKey) return;
        qualifiedLeadFetchedRef.current = fetchKey;
        let cancelled = false;
        const fetchQualifiedLead = async ()=>{
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getQualifiedLead`, {
                clientId: clientId,
                investorId: investorId
            });
            if (!cancelled && res && res['code'] == 200) setQualifiedLead(res['body']);
        };
        fetchQualifiedLead();
        return ()=>{
            cancelled = true;
        };
    }, [
        company?._id,
        user?.['companyId']?._id,
        user?.['role']
    ]);
    (0, $acw62.useEffect)(()=>{
        if (modal['open'] == 'setStatusPopup') return;
        if (qualifiedLead['status'] == 'Accepted') setStatusSelected($86727a4e8cc19e92$var$statusOptions[1]);
        else if (qualifiedLead['status'] == 'Rejected') setStatusSelected($86727a4e8cc19e92$var$statusOptions[2]);
        else setStatusSelected($86727a4e8cc19e92$var$statusOptions[0]);
    }, [
        qualifiedLead
    ]);
    const handleToggle = (isOpen)=>setShowDropdown(isOpen);
    const handleChange = async (option)=>{
        await setStatusSelected(option);
        if (option['value'] == 'Rejected') {
            setSelectedResponse('');
            setNewQuickResponse('');
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'reasonRejectionPopup'
            }));
        } else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'setStatusPopup'
        }));
    };
    const updateLeadStatus = async (status)=>{
        if (company && user?.['companyId']?.['_id']) {
            let data = {
                status: status,
                client: company['creatorId'],
                clientId: company['_id'],
                investor: user,
                investorId: user['companyId']['_id']
            };
            if (status == 'Rejected') data = {
                ...data,
                quickResponse: selectedResponse,
                isSaved: isSaved
            };
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateLeadStatus`, data);
            if (res && res['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                setQualifiedLead(res['body']);
            }
        }
    };
    const SingleValue = ({ children: children, ...props })=>{
        const color = props.data.label == "Approved" ? "#15D757" : props.data.label == "Pending" ? "#FFBC00" : "#F14D4D";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).SingleValue, {
            ...props,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                    className: "icon cp",
                    children: props.data.icon
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        color: color
                    },
                    children: children
                })
            ]
        });
    };
    const fileBox = (files)=>{
        let externalFilePermissions;
        if (user?.['type'] == 'External') externalFilePermissions = company?.externalUserPermissions?.filePermissions || [];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: `cp w100 bg1 br15px mx0-5rem p2rem pr bsbb bo7 diligence-pack-boxes docs-diligence-boxes`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "docs-boxs-area mt0-5rem",
                children: files.map((file)=>{
                    let show = true;
                    if (user?.['type'] == 'External' && !externalFilePermissions?.includes(file?.['name'])) show = false;
                    else show = true;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: show && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: file['location'],
                            target: '_blank',
                            download: true,
                            className: `box-docs`,
                            "data-tooltip": file['name'].length > 22 ? file['name'] : '',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                "data-tooltip": file['name'].length > 22 ? file['name'] : '',
                                children: file['name'].length > 22 ? file['name'].substring(0, 20) + '...' : file['name']
                            })
                        })
                    });
                })
            })
        });
    };
    const handleReportOpen = async (item)=>{
        const isShareCodeUrl = window.location.pathname.includes('/shareCode/');
        if (isExternal && (user['type'] == 'External' || isShareCodeUrl)) {
            if (item['title'] == "Directors' Questionnaires") setIsDirectorsReport(true);
            // Fetch fresh URL via API to avoid expired pre-signed S3 URLs
            try {
                const payload = {
                    companyId: company['_id']
                };
                if (item['htmlReport'] && item['reportType']) {
                    payload.reportType = item['reportType'];
                    if (item['_id']) payload.reportId = item['_id'];
                } else if (item['type']) payload.moduleName = item['type'];
                const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getModuleReport`, payload);
                if (res?.['code'] === 200 && res?.['body']?.['reportUrl']) setReport({
                    ...item,
                    reportUrl: res['body']['reportUrl']
                });
                else setReport(item);
            } catch (e) {
                setReport(item);
            }
        } else {
            if (item['type'] == "investor-lead") {
                window.location.href = `/company/${company['_id']}#fit-report:${user?.['companyId']?.['_id']}`;
                await setCompanyDashboardTab('Dashboard');
                setTab(`fit-report:${user?.['companyId']?.['_id']}`);
                return;
            } else if (item['htmlReport']) {
                window.location.href = `/company/${company['_id']}#${item['_id']}?${item['reportType']}-researchaid`;
                await setCompanyDashboardTab('Dashboard');
                setTab(`${item['reportType']}-researchaid`);
                localStorage.setItem('isDiligencePack', true);
                localStorage.setItem('scrollToValue', true);
                return;
            } else if (item['title'] == "Directors' Questionnaires") {
                await setCompanyDashboardTab('Dashboard');
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'showTempDirectors',
                    tempDirectorsModuleSlug: item['slug'] || 'DDQ'
                }));
                localStorage.setItem('isDiligencePack', true);
                localStorage.setItem('scrollToFoundational', true);
                return;
            } else {
                window.location = `/company/${company['_id']}#${item['type']}-report`;
                await setCompanyDashboardTab('Dashboard');
                setTab(`${item['type']}-report`);
                localStorage.setItem('isDiligencePack', true);
                localStorage.setItem('scrollToFoundational', true);
                return;
            }
        }
    };
    const moduleBox = (item)=>{
        let externalReportPermissions = {}, tooltip = '';
        if (user['type'] == 'External') {
            if (company?.externalUserPermissions) externalReportPermissions = company.externalUserPermissions.reportPermissions || {};
        }
        if ((item['completeness'] || item['score']) < 1) tooltip = 'Module is not started yet!';
        else tooltip = '';
        // Check if user has permission to access this report
        const hasPermission = user['type'] != 'External' || externalReportPermissions[item['title']];
        const canOpen = (item['completeness'] || item['score']) > 0 && hasPermission;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: hasPermission && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `bo7 w100 bg1 br15px p2rem pr bsbb diligence-pack-boxes ${user['type'] == 'External' && !externalReportPermissions[item['title']] && 'op0-5'} ${canOpen ? 'cp' : ''}`,
                "data-tooltip": tooltip,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic",
                        children: item['title'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>{
                                canOpen && handleReportOpen(item);
                            },
                            className: `w100 tal fs1rem fw500 bg1 lh2 title-box-feature ${canOpen ? 'cp c15' : 'cna c12'} `,
                            children: [
                                item['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "db fw400 fs0-75rem mb0-5rem op50",
                                    "data-tooltip": tooltip,
                                    children: item['subTitle']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    class: canOpen ? 'c4-hover ttc' : 'ttc',
                                    style: {
                                        fontSize: '14px'
                                    },
                                    "data-tooltip": tooltip,
                                    children: item['title']
                                })
                            ]
                        })
                    }),
                    (item['isCompleteness'] || item['isRisk']) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "tooltip-area style-two pa df aic jcsb w100 fww",
                        style: {
                            opacity: item['completeness'] > 0 ? '1' : '0.6'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "percentage-area df aic w100 pl1-5rem",
                            children: [
                                item['isCompleteness'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: `fs1-75rem lh1 mr2rem w50 ${item['completeness'] > 67 ? 'green' : item['completeness'] > 33 ? 'yellow' : item['completeness'] > 0 ? 'red' : 'c28'}`,
                                    children: [
                                        item['completeness'],
                                        "%",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs0-75rem w4rem db fw300",
                                            children: [
                                                "Module ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " Completeness"
                                            ]
                                        })
                                    ]
                                }),
                                item['isRisk'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: `fs1-75rem lh1 w50 ${item['risk'] > 67 ? 'red' : item['risk'] > 33 ? 'yellow' : item['risk'] > 0 ? 'green' : 'c28'}`,
                                    children: [
                                        item['risk'],
                                        "%",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15 fs0-75rem w4rem db fw300",
                                            children: [
                                                "Module ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "Risk"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    item['isScore'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "tooltip-area style-two pa df aic jcsb w100 fww",
                        style: {
                            opacity: item['score'] > 0 ? '1' : '0.6'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "percentage-area df aic w100 pl2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                className: `fs1-75rem lh1 mr2rem w50 ${item['score'] >= 4 ? 'c34' : item['score'] >= 2 ? 'c39' : item['score'] > 0 ? 'c4' : 'c28'}`,
                                children: [
                                    Number.parseFloat(item['score']).toFixed(1),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c15 fs0-75rem w4rem db fw300",
                                        children: [
                                            "Report ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Score/5"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        });
    };
    const handleDiligenceReport = async ()=>{
        if (isGeneratingReport) return;
        try {
            const checkRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/checkDiligenceReport/${company._id}`);
            if (checkRes?.['code'] == 200 && checkRes?.['body']?.['exists']) {
                setExistingReportUrl(checkRes['body']['reportUrl']);
                setExistingReportDate(checkRes['body']['updatedAt']);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'consolidatedReportExists'
                }));
            } else generateNewDiligenceReport();
        } catch (err) {
            generateNewDiligenceReport();
        }
    };
    const openDiligenceReport = (reportUrl)=>{
        if (isExternal && setReport) setReport({
            reportUrl: reportUrl,
            reportType: 'consolidated-diligence',
            htmlReport: true
        });
        else {
            localStorage.setItem('consolidatedReportUrl', reportUrl);
            setTab('consolidated-diligence');
        }
    };
    const generateNewDiligenceReport = async ()=>{
        if (isGeneratingReport) return;
        try {
            setIsGeneratingReport(true);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            setIsLoader({
                show: true,
                message: 'Generating Diligence Report...'
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Generating Diligence Report... This may take a few minutes.');
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/generateDiligenceReport', {
                companyId: company._id
            });
            if (res?.['code'] == 200 && res?.['body']?.['reportUrl']) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Diligence Report generated successfully.');
                openDiligenceReport(res['body']['reportUrl']);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message'] || 'Failed to generate report. Please try again.');
        } catch (err) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error generating report. Please try again.');
        } finally{
            setIsGeneratingReport(false);
            setIsLoader({
                show: false,
                message: 'Generating Diligence Report...'
            });
        }
    };
    const handleBackToInvestorMatch = ()=>{
        if (user?.['role'] == "Investor" && localStorage.getItem("isQualifiedLeads")) localStorage.removeItem("isQualifiedLeads");
        else setCompanyDashboardTab('InvestorMatch');
    };
    const linkBackToInvestorMatch = ()=>{
        if (user?.['role'] == "Investor" && localStorage.getItem("isQualifiedLeads")) return "/investor-dashboard#index?QualifiedLeads";
        else return "#";
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb pt1rem p1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w80 mt1rem",
                                    src: (parcelRequire("b0Cmg")),
                                    alt: "image"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df jcc aic fdc c15 fs1-5rem fw600 mb1-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem c14 tac",
                                        children: company['cName']
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "tac",
                                        children: "Diligence Pack"
                                    }),
                                    !isExternal && company?.['testType'] == 'investment' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        variant: "warning",
                                        onClick: ()=>{
                                            if (user['role'] == 'Investor') navigate(`/investor-dashboard#index?QualifiedLeads`);
                                            else setCompanyDashboardTab('InvestorMatch');
                                        },
                                        className: "pr br50px new-shadow cp c1 px1rem py0-5rem my1rem fs14px fw500 bg4 bg3-hover",
                                        text: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "16",
                                                    height: "16",
                                                    viewBox: "0 0 21 21",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z",
                                                            fill: "white",
                                                            stroke: "white",
                                                            "stroke-width": "0.5"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z",
                                                            fill: "white",
                                                            stroke: "white",
                                                            "stroke-width": "0.5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "ml0-5rem",
                                                    children: "Back to Investor Match"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df w250px h120px bw1px br20px bo16 bss px1-5rem py1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc w70",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "w100 fs1-25rem c32",
                                                children: company['cLevel'] ? company['cLevel'] === "None" ? 'None' : company['cLevel'] : 'None'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w80 mt0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("3kPLx")),
                                                    alt: "allStars"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w80 bg16 br10px",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "progress-value",
                                                    style: {
                                                        width: `${$86727a4e8cc19e92$var$cLevelToProgress(company?.['cLevel'])}%`,
                                                        transition: 'width 0.3s ease-out'
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "df jcc aic w30",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "certficate-area",
                                            children: company['cLevel'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54119cc183dc6bdf$export$2e2bcd8739ae039), {
                                                className: "mla mra dashbaord-certficate-page mt0-5rem",
                                                component: "Company",
                                                level: company['cLevel'],
                                                expiryTimestamp: company['createdAt'],
                                                company: company,
                                                subscription: company['subscription']
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    user?.['role'] == 'Investor' && company?.['_id'] != user?.['companyId']?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dropdown-area df w100 jcsb aic mt1rem mb2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                value: statusSelected,
                                options: $86727a4e8cc19e92$var$statusOptions,
                                onChange: handleChange,
                                className: "diligence-status-select",
                                components: {
                                    Option: $86727a4e8cc19e92$var$Option,
                                    SingleValue: SingleValue
                                },
                                styles: {
                                    singleValue: (base)=>({
                                            ...base,
                                            display: "flex",
                                            alignItems: "center"
                                        }),
                                    input: (baseStyles)=>({
                                            ...baseStyles,
                                            color: 'transparent'
                                        })
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "df jcc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                                    className: "dropdown-diligence-pack w100",
                                    show: showDropdown,
                                    onToggle: handleToggle,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                                            variant: "success",
                                            id: "dropdown-basic",
                                            className: "dropdown-btn cp bg1 p1rem br5px pr bw2px bo5 bss",
                                            onClick: ()=>setShowDropdown(!showDropdown),
                                            children: [
                                                "Actions",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "icon-right pa r0 mr1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            className: "ml0-5rem w1rem h1rem f6 f6-xl",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 448 512",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                                            className: "dropdown-content cp shadow fww bg1 br5px",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "14",
                                                                height: "14",
                                                                viewBox: "0 0 14 14",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M10.5703 13.4275H3.42745C2.66433 13.4275 1.94684 13.1303 1.40716 12.5906C0.867511 12.051 0.570312 11.3335 0.570312 10.5703V9.85598C0.570312 9.46147 0.890092 9.14167 1.2846 9.14167C1.67911 9.14167 1.99889 9.46147 1.99889 9.85598V10.5703C1.99889 10.9519 2.1475 11.3106 2.41728 11.5804C2.68713 11.8502 3.04586 11.9989 3.42745 11.9989H10.5703C10.9519 11.9989 11.3106 11.8502 11.5804 11.5804C11.8502 11.3106 11.9989 10.9518 11.9989 10.5703V9.85598C11.9989 9.46147 12.3187 9.14167 12.7131 9.14167C13.1076 9.14167 13.4275 9.46147 13.4275 9.85598V10.5703C13.4275 11.3334 13.1303 12.0509 12.5906 12.5906C12.0509 13.1303 11.3334 13.4275 10.5703 13.4275ZM6.99887 10.5703C6.90006 10.5703 6.80599 10.5502 6.72041 10.514C6.64057 10.4802 6.56554 10.4312 6.49989 10.3671C6.49986 10.3671 6.49986 10.3671 6.49984 10.3671C6.49936 10.3666 6.49889 10.3661 6.49842 10.3657C6.49829 10.3656 6.49814 10.3654 6.49802 10.3653C6.49762 10.3649 6.49727 10.3645 6.49689 10.3642C6.49664 10.3639 6.49642 10.3637 6.49617 10.3634C6.49592 10.3632 6.4956 10.3629 6.49537 10.3627C6.49487 10.3622 6.49432 10.3616 6.49382 10.3611L3.63667 7.50394C3.35773 7.22501 3.35773 6.77273 3.63667 6.49378C3.9156 6.21484 4.3679 6.21482 4.64683 6.49378L6.28461 8.13155V1.2846C6.28458 0.890092 6.60436 0.570312 6.99887 0.570312C7.39338 0.570312 7.71319 0.890092 7.71319 1.2846V8.13152L9.35093 6.49378C9.62984 6.21484 10.0822 6.21484 10.3611 6.49378C10.64 6.77271 10.64 7.22501 10.3611 7.50394L7.50394 10.3611C7.50344 10.3616 7.50289 10.3621 7.50239 10.3626C7.50212 10.3629 7.50182 10.3632 7.5016 10.3634C7.50135 10.3637 7.50112 10.3639 7.50087 10.3641C7.50052 10.3645 7.50012 10.3649 7.49977 10.3652C7.49965 10.3653 7.49948 10.3655 7.49935 10.3656C7.4989 10.3661 7.49843 10.3666 7.49795 10.367C7.49793 10.367 7.49793 10.367 7.4979 10.3671C7.49004 10.3747 7.48208 10.3822 7.47395 10.3894C7.41414 10.4427 7.34752 10.4843 7.27708 10.514C7.27683 10.5141 7.27663 10.5142 7.27638 10.5143C7.27611 10.5144 7.27588 10.5146 7.27561 10.5147C7.19047 10.5505 7.09701 10.5703 6.99887 10.5703Z",
                                                                    fill: "#151313"
                                                                })
                                                            })
                                                        }),
                                                        "Download Pack"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                                    className: "red-txt",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 18 18",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M14.25 5.25C14.0511 5.25 13.8603 5.32902 13.7197 5.46967C13.579 5.61032 13.5 5.80109 13.5 6V14.3932C13.4785 14.7725 13.308 15.1279 13.0256 15.382C12.7433 15.6362 12.3719 15.7684 11.9925 15.75H6.0075C5.62807 15.7684 5.25674 15.6362 4.97438 15.382C4.69202 15.1279 4.52151 14.7725 4.5 14.3932V6C4.5 5.80109 4.42098 5.61032 4.28033 5.46967C4.13968 5.32902 3.94891 5.25 3.75 5.25C3.55109 5.25 3.36032 5.32902 3.21967 5.46967C3.07902 5.61032 3 5.80109 3 6V14.3932C3.02141 15.1704 3.34994 15.9074 3.91364 16.4429C4.47733 16.9783 5.23025 17.2686 6.0075 17.25H11.9925C12.7697 17.2686 13.5227 16.9783 14.0864 16.4429C14.6501 15.9074 14.9786 15.1704 15 14.3932V6C15 5.80109 14.921 5.61032 14.7803 5.46967C14.6397 5.32902 14.4489 5.25 14.25 5.25Z",
                                                                        fill: "#F14D4D"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M15 3H12V1.5C12 1.30109 11.921 1.11032 11.7803 0.96967C11.6397 0.829018 11.4489 0.75 11.25 0.75H6.75C6.55109 0.75 6.36032 0.829018 6.21967 0.96967C6.07902 1.11032 6 1.30109 6 1.5V3H3C2.80109 3 2.61032 3.07902 2.46967 3.21967C2.32902 3.36032 2.25 3.55109 2.25 3.75C2.25 3.94891 2.32902 4.13968 2.46967 4.28033C2.61032 4.42098 2.80109 4.5 3 4.5H15C15.1989 4.5 15.3897 4.42098 15.5303 4.28033C15.671 4.13968 15.75 3.94891 15.75 3.75C15.75 3.55109 15.671 3.36032 15.5303 3.21967C15.3897 3.07902 15.1989 3 15 3ZM7.5 3V2.25H10.5V3H7.5Z",
                                                                        fill: "#F14D4D"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M8.25 12.75V7.5C8.25 7.30109 8.17098 7.11032 8.03033 6.96967C7.88968 6.82902 7.69891 6.75 7.5 6.75C7.30109 6.75 7.11032 6.82902 6.96967 6.96967C6.82902 7.11032 6.75 7.30109 6.75 7.5V12.75C6.75 12.9489 6.82902 13.1397 6.96967 13.2803C7.11032 13.421 7.30109 13.5 7.5 13.5C7.69891 13.5 7.88968 13.421 8.03033 13.2803C8.17098 13.1397 8.25 12.9489 8.25 12.75Z",
                                                                        fill: "#F14D4D"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M11.25 12.75V7.5C11.25 7.30109 11.171 7.11032 11.0303 6.96967C10.8897 6.82902 10.6989 6.75 10.5 6.75C10.3011 6.75 10.1103 6.82902 9.96967 6.96967C9.82902 7.11032 9.75 7.30109 9.75 7.5V12.75C9.75 12.9489 9.82902 13.1397 9.96967 13.2803C10.1103 13.421 10.3011 13.5 10.5 13.5C10.6989 13.5 10.8897 13.421 11.0303 13.2803C11.171 13.1397 11.25 12.9489 11.25 12.75Z",
                                                                        fill: "#F14D4D"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        "Archive"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Divider, {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                    children: "More Diligence?"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 18 18",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    opacity: "0.5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M7.54959 14.4169H3.83203C3.52153 14.4169 3.26953 14.1649 3.26953 13.8544V2.25C3.26953 1.9395 3.52153 1.6875 3.83203 1.6875H12.2695C12.58 1.6875 12.832 1.9395 12.832 2.25V9.12375C12.832 9.43481 13.0835 9.68625 13.3945 9.68625C13.7056 9.68625 13.957 9.43481 13.957 9.12375V2.25C13.957 1.31962 13.1999 0.5625 12.2695 0.5625H3.83203C2.90166 0.5625 2.14453 1.31962 2.14453 2.25V13.8544C2.14453 14.7847 2.90166 15.5419 3.83203 15.5419H7.54959C7.86066 15.5419 8.11209 15.2904 8.11209 14.9794C8.11209 14.6683 7.86066 14.4169 7.54959 14.4169Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M15.4308 13.1932L14.6444 12.9097C13.9261 12.6509 13.3658 12.0901 13.1065 11.3723L12.823 10.5854C12.823 10.5848 12.823 10.5843 12.8225 10.5832C12.7302 10.33 12.4872 10.1602 12.2183 10.1602C12.2172 10.1602 12.2166 10.1602 12.2161 10.1602C11.9461 10.1613 11.7036 10.3328 11.6136 10.5848L11.3296 11.3723C11.0703 12.0901 10.51 12.6503 9.79227 12.9097L9.00308 13.1937C8.75052 13.286 8.58008 13.529 8.58008 13.7984C8.58008 14.0678 8.75052 14.3103 9.00533 14.4031L9.79227 14.6866C10.51 14.9459 11.0703 15.5062 11.3296 16.2245L11.6125 17.0097C11.7036 17.264 11.9461 17.4355 12.2161 17.4367H12.2183C12.4878 17.4367 12.7302 17.2668 12.823 17.0114L13.1065 16.2245C13.3658 15.5067 13.9261 14.9459 14.6444 14.6872L15.4313 14.4037C15.6856 14.312 15.856 14.0684 15.856 13.799C15.8555 13.5284 15.6856 13.2848 15.4308 13.1932ZM12.2178 15.446C11.8611 14.731 11.2846 14.1545 10.5696 13.7984C11.2846 13.4418 11.8611 12.8652 12.2178 12.1503C12.5738 12.8652 13.1504 13.4418 13.8659 13.7984C13.1504 14.1545 12.5738 14.731 12.2178 15.446Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M5.06641 3.99609H6.98003C7.29109 3.99609 7.54253 3.74466 7.54253 3.43359C7.54253 3.12253 7.29109 2.87109 6.98003 2.87109H5.06641C4.75534 2.87109 4.50391 3.12253 4.50391 3.43359C4.50391 3.74466 4.75534 3.99609 5.06641 3.99609Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.039 5.17969H5.06641C4.75534 5.17969 4.50391 5.43113 4.50391 5.74219C4.50391 6.05325 4.75534 6.30469 5.06641 6.30469H11.039C11.3501 6.30469 11.6015 6.05325 11.6015 5.74219C11.6015 5.43113 11.3501 5.17969 11.039 5.17969Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.6015 8.05078C11.6015 7.73972 11.3501 7.48828 11.039 7.48828H5.06641C4.75534 7.48828 4.50391 7.73972 4.50391 8.05078C4.50391 8.36184 4.75534 8.61328 5.06641 8.61328H11.039C11.3501 8.61328 11.6015 8.36128 11.6015 8.05078Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M5.0625 9.79688C4.75144 9.79688 4.5 10.0483 4.5 10.3594C4.5 10.6704 4.75144 10.9219 5.0625 10.9219H10.1981C10.5092 10.9219 10.7606 10.6704 10.7606 10.3594C10.7606 10.0483 10.5092 9.79688 10.1981 9.79688H5.0625Z",
                                                                            fill: "#151313"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        "AnyList Checklist Builder"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 18 18",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    opacity: "0.5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M7.54959 14.4169H3.83203C3.52153 14.4169 3.26953 14.1649 3.26953 13.8544V2.25C3.26953 1.9395 3.52153 1.6875 3.83203 1.6875H12.2695C12.58 1.6875 12.832 1.9395 12.832 2.25V9.12375C12.832 9.43481 13.0835 9.68625 13.3945 9.68625C13.7056 9.68625 13.957 9.43481 13.957 9.12375V2.25C13.957 1.31962 13.1999 0.5625 12.2695 0.5625H3.83203C2.90166 0.5625 2.14453 1.31962 2.14453 2.25V13.8544C2.14453 14.7847 2.90166 15.5419 3.83203 15.5419H7.54959C7.86066 15.5419 8.11209 15.2904 8.11209 14.9794C8.11209 14.6683 7.86066 14.4169 7.54959 14.4169Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M15.4308 13.1932L14.6444 12.9097C13.9261 12.6509 13.3658 12.0901 13.1065 11.3723L12.823 10.5854C12.823 10.5848 12.823 10.5843 12.8225 10.5832C12.7302 10.33 12.4872 10.1602 12.2183 10.1602C12.2172 10.1602 12.2166 10.1602 12.2161 10.1602C11.9461 10.1613 11.7036 10.3328 11.6136 10.5848L11.3296 11.3723C11.0703 12.0901 10.51 12.6503 9.79227 12.9097L9.00308 13.1937C8.75052 13.286 8.58008 13.529 8.58008 13.7984C8.58008 14.0678 8.75052 14.3103 9.00533 14.4031L9.79227 14.6866C10.51 14.9459 11.0703 15.5062 11.3296 16.2245L11.6125 17.0097C11.7036 17.264 11.9461 17.4355 12.2161 17.4367H12.2183C12.4878 17.4367 12.7302 17.2668 12.823 17.0114L13.1065 16.2245C13.3658 15.5067 13.9261 14.9459 14.6444 14.6872L15.4313 14.4037C15.6856 14.312 15.856 14.0684 15.856 13.799C15.8555 13.5284 15.6856 13.2848 15.4308 13.1932ZM12.2178 15.446C11.8611 14.731 11.2846 14.1545 10.5696 13.7984C11.2846 13.4418 11.8611 12.8652 12.2178 12.1503C12.5738 12.8652 13.1504 13.4418 13.8659 13.7984C13.1504 14.1545 12.5738 14.731 12.2178 15.446Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M5.06641 3.99609H6.98003C7.29109 3.99609 7.54253 3.74466 7.54253 3.43359C7.54253 3.12253 7.29109 2.87109 6.98003 2.87109H5.06641C4.75534 2.87109 4.50391 3.12253 4.50391 3.43359C4.50391 3.74466 4.75534 3.99609 5.06641 3.99609Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.039 5.17969H5.06641C4.75534 5.17969 4.50391 5.43113 4.50391 5.74219C4.50391 6.05325 4.75534 6.30469 5.06641 6.30469H11.039C11.3501 6.30469 11.6015 6.05325 11.6015 5.74219C11.6015 5.43113 11.3501 5.17969 11.039 5.17969Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.6015 8.05078C11.6015 7.73972 11.3501 7.48828 11.039 7.48828H5.06641C4.75534 7.48828 4.50391 7.73972 4.50391 8.05078C4.50391 8.36184 4.75534 8.61328 5.06641 8.61328H11.039C11.3501 8.61328 11.6015 8.36128 11.6015 8.05078Z",
                                                                            fill: "#151313"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M5.0625 9.79688C4.75144 9.79688 4.5 10.0483 4.5 10.3594C4.5 10.6704 4.75144 10.9219 5.0625 10.9219H10.1981C10.5092 10.9219 10.7606 10.6704 10.7606 10.3594C10.7606 10.0483 10.5092 9.79688 10.1981 9.79688H5.0625Z",
                                                                            fill: "#151313"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        "ResearchAid Report Builder"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `bg20 bss bo5 bsbb p1rem pl2rem pr2rem br25px w100 df fww mb2rem pr bsbb bw2 gg1-5rem bo16 bw1px`,
                style: {
                    backgroundColor: '#F0F2FD50'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df fww pr bsbb",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                className: "accordian-dashboard-main accordian-dashboard-diligence-pack",
                                expanded: expanded['consolidatedDocument'],
                                onChange: ()=>setExpanded({
                                        ...expanded,
                                        consolidatedDocument: !expanded['consolidatedDocument']
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs1-25rem c15 fw600 db",
                                                children: "Consolidated Document"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "df aic",
                                                    style: {
                                                        width: '15%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "",
                                                        src: (parcelRequire("6YRhl")),
                                                        alt: "consolidated document"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "df jcc aic",
                                                    style: {
                                                        width: '85%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fww w100",
                                                        style: {
                                                            gap: '20px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: `cp bo7 w100 bg1 br15px p2rem pr bsbb diligence-pack-boxes ${isGeneratingReport ? 'op50' : ''}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                        onClick: ()=>handleDiligenceReport(),
                                                                        disabled: isGeneratingReport,
                                                                        className: `w100 tal fs1rem fw500 bg1 lh2 title-box-feature ${isGeneratingReport ? 'pen' : 'cp'} c15`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "db fw400 fs0-75rem mb0-5rem op50",
                                                                                children: "Report"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                class: "c4-hover ttc",
                                                                                style: {
                                                                                    fontSize: '14px'
                                                                                },
                                                                                children: isGeneratingReport ? 'Generating Report...' : 'Diligence Report'
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w100 pa l0",
                                                                    style: {
                                                                        bottom: '30px'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "db fw300 fs0-75rem px1rem",
                                                                        children: "A consolidated overview of all your diligence reports"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `bg20 bss bo5 bsbb p1rem pl2rem pr2rem br25px w100 df fww mb2rem pr bsbb bw2 gg1-5rem bo16 bw1px`,
                style: {
                    backgroundColor: '#F0F2FD50'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df fww pr bsbb",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                className: "accordian-dashboard-main accordian-dashboard-diligence-pack",
                                expanded: expanded['investorFitReportPanel'],
                                onChange: ()=>setExpanded({
                                        ...expanded,
                                        investorFitReportPanel: !expanded['investorFitReportPanel']
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs1-25rem c15 fw600 db",
                                                children: user?.['role'] == 'Investor' && company?.['_id'] != user?.['companyId']?.['_id'] ? 'Investor Fit Report' : 'Report & Docs'
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "df aic",
                                                    style: {
                                                        width: '15%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "",
                                                        src: (parcelRequire("8LsaC")),
                                                        alt: "fit report"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    class: "df jcc aic",
                                                    style: {
                                                        width: '85%'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fww w100",
                                                            style: {
                                                                gap: '20px'
                                                            },
                                                            children: [
                                                                !isExternal && user?.['role'] == 'Investor' && company?.['_id'] != user?.['companyId']?.['_id'] && moduleBox({
                                                                    ...localModules?.['investor-lead'],
                                                                    title: 'Fit Report',
                                                                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            "Investor",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                class: "c4",
                                                                                children: "Match"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isCompleteness: true,
                                                                    completeness: localModules?.['investor-lead']?.['stats']?.['completionPercent'] || 0
                                                                }),
                                                                company?.['testType'] === 'exit' ? moduleBox({
                                                                    ...localModules?.['Exit Readiness'],
                                                                    title: 'Exit Readiness Report',
                                                                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            "Exit",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                class: "c4",
                                                                                children: "Ready"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isCompleteness: true,
                                                                    completeness: localModules?.['Exit Readiness']?.['stats']?.['completionPercent'] || 0,
                                                                    isRisk: true,
                                                                    risk: localModules?.['Exit Readiness']?.['stats']?.['riskPercent'] || 0
                                                                }) : moduleBox({
                                                                    ...localModules?.['Investment Readiness'],
                                                                    title: 'Investment Readiness Report',
                                                                    subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            "Investor",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                class: "c4",
                                                                                children: "Match"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isCompleteness: true,
                                                                    completeness: localModules?.['Investment Readiness']?.['stats']?.['completionPercent'] || 0,
                                                                    isRisk: true,
                                                                    risk: localModules?.['Investment Readiness']?.['stats']?.['riskPercent'] || 0
                                                                }),
                                                                docsArray && docsArray.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df diligence-docs-area",
                                                                    style: {
                                                                        overflowX: 'auto'
                                                                    },
                                                                    children: Array.from({
                                                                        length: Math.ceil(docsArray.length / 5)
                                                                    }, (_, i)=>fileBox(docsArray.slice(i * 5, (i + 1) * 5)))
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "pa img-fit",
                                                            style: {
                                                                bottom: '-17px',
                                                                right: '-61px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "fit-report-ai-img fr",
                                                                src: (parcelRequire("3QPt8")),
                                                                alt: "image"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `bg20 bss bo5 bsbb p1rem pl2rem pr2rem br25px w100 df fww mb2rem pr bsbb bw2 gg1-5rem bo16 bw1px`,
                style: {
                    backgroundColor: '#F0F2FD50'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df fww pr bsbb",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                className: "accordian-dashboard-main accordian-dashboard-diligence-pack",
                                expanded: expanded['valueDiligenceReportPanel'],
                                onChange: ()=>setExpanded({
                                        ...expanded,
                                        valueDiligenceReportPanel: !expanded['valueDiligenceReportPanel']
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs1-25rem c15 fw600 db",
                                                children: "Value Diligence Reports"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "df aic w20",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "ml2rem",
                                                        src: (parcelRequire("8azsK")),
                                                        alt: "value diligence"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "df jcc aic w80",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        id: "value-diligence-section",
                                                        className: "df fww w100",
                                                        style: {
                                                            gap: '30px'
                                                        },
                                                        children: reports && reports.length > 0 && reports.map((report)=>report['reportType'] != 'insuranceGapAnalysis' && moduleBox({
                                                                ...report,
                                                                title: report['name'],
                                                                subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        "Research",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            class: "c4",
                                                                            children: "Aid"
                                                                        })
                                                                    ]
                                                                }),
                                                                isScore: true,
                                                                score: report['score'] || 0
                                                            }))
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `bg20 bss bo5 bsbb p1rem pl2rem pr2rem br25px w100 df fww mb2rem pr bsbb bw2 gg1-5rem bo16 bw1px`,
                style: {
                    backgroundColor: '#F0F2FD50'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df fww pr bsbb",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                className: "accordian-dashboard-main accordian-dashboard-diligence-pack",
                                expanded: expanded['foundationalDiligenceReportPanel'],
                                onChange: ()=>setExpanded({
                                        ...expanded,
                                        foundationalDiligenceReportPanel: !expanded['foundationalDiligenceReportPanel']
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                            className: "df aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs1-25rem c15 fw600 db",
                                                children: "Foundational Diligence Reports"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "df aic w20",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "ml2rem",
                                                        src: (parcelRequire("bjwHv")),
                                                        alt: "foundational diligence"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "df jcc aic w80",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        id: "foundational-diligence-section",
                                                        className: "df fww w100",
                                                        style: {
                                                            gap: '30px'
                                                        },
                                                        children: [
                                                            moduleBox({
                                                                ...localModules?.['repository'],
                                                                title: 'Data Repository',
                                                                subTitle: 'Report',
                                                                isCompleteness: true,
                                                                completeness: localModules?.['repository']?.['stats']?.['completionPercent'] || 0
                                                            }),
                                                            moduleBox({
                                                                ...localModules?.[`business-audit-${company['testType']}`],
                                                                title: `Quick Business Audit ${company['testType']}`,
                                                                subTitle: 'Report',
                                                                isCompleteness: true,
                                                                completeness: localModules?.[`business-audit-${company['testType']}`]?.['stats']?.['completionPercent'] || 0,
                                                                isRisk: true,
                                                                risk: localModules?.[`business-audit-${company['testType']}`]?.['stats']?.['riskPercent'] || 0
                                                            }),
                                                            moduleBox({
                                                                ...localModules?.['warranty-disclosure'],
                                                                title: `Warranty Disclosure`,
                                                                subTitle: 'Report',
                                                                isCompleteness: true,
                                                                completeness: localModules?.['warranty-disclosure']?.['stats']?.['completionPercent'] || 0,
                                                                isRisk: true,
                                                                risk: localModules?.['warranty-disclosure']?.['stats']?.['riskPercent'] || 0
                                                            }),
                                                            moduleBox({
                                                                ...localModules?.['directors-questionnaire'],
                                                                title: `Directors' Questionnaires`,
                                                                subTitle: 'Report',
                                                                isCompleteness: true,
                                                                completeness: localDirectorsStats?.['completionPercent'] || 0,
                                                                isRisk: true,
                                                                risk: localDirectorsStats?.['riskPercent'] || 0
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'setStatusPopup',
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "c15 fs2rem fw600 tac ttu my2rem",
                                    children: "Access Request "
                                }),
                                statusSelected && statusSelected?.['value'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc gg1rem px2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "tac c14 fs1rem my1rem",
                                            children: [
                                                "Are you sure you want to ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: statusSelected?.['label'].toLowerCase()
                                                }),
                                                " this lead request of ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['cName']
                                                }),
                                                "?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcsa mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            open: ''
                                                        })),
                                                    className: "new-shadow bg1 c4 bw1px bo4 bss br10px px2rem py0-5rem cp ttu",
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>updateLeadStatus(statusSelected?.['value']),
                                                    className: `new-shadow c1 br10px px2rem py0-5rem cp ttu ${statusSelected?.['label'] == 'Approved' ? 'bg34' : statusSelected?.['label'] == 'Rejected' ? 'bg9' : 'bg8'}`,
                                                    children: statusSelected?.['label']
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'reasonRejectionPopup',
                className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "c15 fs1-75rem fw400 tac my2rem",
                                    children: "Reason for Rejection"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "c15 fs1rem fw400 mb0-5rem",
                                    children: "Please select a response"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "cp df jcsb px1rem py0-5rem bw1px bo16 bss br5px",
                                    onClick: ()=>setIsDropdown(!isDropdown),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: `${selectedResponse ? 'c15' : 'c12'} fs1rem fw400`,
                                            children: selectedResponse == '' ? 'Select your quick response' : selectedResponse.length < 70 ? selectedResponse : selectedResponse.substring(0, 70) + '...'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-angle-down"
                                        })
                                    ]
                                }),
                                isDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    ref: dropdownRef,
                                    class: "cp pr shadow df fdc bg1 br5px oa py0-5rem",
                                    style: {
                                        top: '-5px',
                                        maxHeight: '300px'
                                    },
                                    children: [
                                        user?.['companyId']?.['quickResponses'] && user?.['companyId']?.['quickResponses'].length > 0 && user['companyId']['quickResponses'].map((item)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                onClick: ()=>{
                                                    setSelectedResponse(item), setIsDropdown(!isDropdown);
                                                },
                                                class: "bg5-hover w100 c15 px1rem py0-5rem",
                                                children: item
                                            });
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df pr bg1 py0-5rem px1rem bw1px br30px bss bo31 my0-5rem fs1rem response-box",
                                            children: [
                                                newQuickResponse == '' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "cp plus-btn mr1rem pr",
                                                    style: {
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        padding: '0',
                                                        top: '2px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($86727a4e8cc19e92$var$DisablePlusIcon, {})
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>{
                                                        setSelectedResponse(newQuickResponse), setIsDropdown(!isDropdown);
                                                    },
                                                    className: "cp plus-btn mr1rem pr",
                                                    style: {
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        padding: '0',
                                                        top: '2px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($86727a4e8cc19e92$var$PlusIcon, {})
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    value: newQuickResponse,
                                                    onChange: (e)=>setNewQuickResponse(e.target.value),
                                                    placeholder: "Add Quick Response - up to 200 characters",
                                                    InputProps: {
                                                        style: {
                                                            borderRadius: "0",
                                                            marginBottom: '0',
                                                            fontSize: '14px',
                                                            border: 'none',
                                                            padding: '0'
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                newQuickResponse.length > 0 && newQuickResponse == selectedResponse && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "df cp fs0-75rem py1rem mx0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w30px h30px pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    checked: isSaved,
                                                    onClick: ()=>setIsSaved(!isSaved),
                                                    className: "shadow cp bg5 bo5 bw1px bss w30px h30px br5px",
                                                    type: "radio"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "fs0-75rem c12",
                                            children: "Save this as quick response for future use"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w100 df jcc mt2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>updateLeadStatus('Rejected'),
                                        className: `px2rem py0-5rem c1 br35px fw400 fs1rem ${selectedResponse ? 'cp bg4' : 'cna bg16'}`,
                                        children: "Reject & Send Email"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'consolidatedReportExists',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "maw700px w90 bg1 br20px p3rem pr df fdc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c15 fs1-5rem fw600 tac mb1rem",
                            children: "Diligence Report Already Exists"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fs0-875rem tac mb0-5rem op70",
                            children: "A Consolidated Diligence Report was last generated on"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c4 fs1rem fw600 tac mb1-5rem",
                            children: existingReportDate ? new Date(existingReportDate).toLocaleDateString('en-GB', {
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            }) : ''
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fs0-875rem tac mb2rem op70",
                            children: "Would you like to view the existing report or generate a new one?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcc w100",
                            style: {
                                gap: '15px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                        openDiligenceReport(existingReportUrl);
                                    },
                                    className: "cp bg4 c1 br35px fw500 fs0-875rem px2rem py0-75rem bw0",
                                    children: "View Existing"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>generateNewDiligenceReport(),
                                    className: "cp bg1 c4 br35px fw500 fs0-875rem px2rem py0-75rem bw1px bo4 bss",
                                    children: "Generate New"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                right: '15px',
                                top: '15px'
                            },
                            width: "30",
                            height: "30",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");







function $dce461e3ca02b46d$export$2e2bcd8739ae039({ getCompany: getCompany, setCompany: setCompany, calculateStats: calculateStats, sectionRefs: sectionRefs, user: user, company: company, module: module, tab: tab, setTab: setTab, isLoader: isLoader, setIsLoader: setIsLoader, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, twoMinuteTestAIReport: twoMinuteTestAIReport, sortSections: sortSections }) {
    console.log(module, "module");
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const textareaRef = (0, $acw62.useRef)(null);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [noteId, setNoteId] = (0, $acw62.useState)('');
    let [answerId, setAnswerId] = (0, $acw62.useState)('');
    let [editNote, setEditNote] = (0, $acw62.useState)('');
    let [taskNotes, setTaskNotes] = (0, $acw62.useState)([]);
    let [isMarked, setIsMarked] = (0, $acw62.useState)(false);
    let [addTextarea, setAddTextarea] = (0, $acw62.useState)(1);
    let [isSaveNote, setIsSaveNote] = (0, $acw62.useState)(false);
    let [statusDropdown, setStatusDropdown] = (0, $acw62.useState)(false);
    let [checklistModule, setChecklistModule] = (0, $acw62.useState)(false);
    let [priorityDropdown, setPriorityDropdown] = (0, $acw62.useState)(false);
    let [directorCertification, setDirectorCertification] = (0, $acw62.useState)('None');
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    (0, $acw62.useEffect)(()=>{
        if (!module) setTab(tab);
        if (tab && tab.includes('directors-questionnaire')) {
            if (module?.stats?.completionPercent >= 90 && module?.stats?.riskPercent <= 50) setDirectorCertification('Gold');
            else if (module?.stats?.completionPercent >= 75 && module?.stats?.riskPercent <= 50) setDirectorCertification('Silver');
            else setDirectorCertification('None');
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array
        const hasNoKPIs = company?.['kpiCount'] !== undefined ? company['kpiCount'] === 0 : company?.['keyPerformanceIndicators']?.length === 0;
        if (user['role'] == 'Guest' && hasNoKPIs) getCompany();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (module?.['type']) {
            if (![
                `two-minute-test-${company['testType']}`,
                'repository',
                'software-development',
                'esg',
                'warranty-disclosure',
                `business-audit-${company['testType']}`,
                'directors-questionnaire'
            ].includes(module['type'])) setChecklistModule(true);
        }
    }, [
        module
    ]);
    (0, $acw62.useEffect)(()=>{
        document.getElementById("pdfContent").classList.add("a4-pdf", "p3rem");
        let wrapper = document.getElementById("pdf");
        wrapper.innerHTML = "";
        let children = Array.from(document.getElementById("pdfContent").children);
        let i = 0;
        let _pageNumber = 1;
        let page = document.createElement("div");
        page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        wrapper.appendChild(page); // Append the first page directly
        let usedPageHeight = 96; // Initial height used on the page
        let pageHeight = getHeight(page);
        let footerHeight = 8;
        // Create watermark
        let watermark = document.createElement("img");
        watermark.classList.add("op20", "pa");
        watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
        watermark.style.top = "50%";
        watermark.style.left = "50%";
        watermark.style.width = "297mm";
        page.appendChild(watermark);
        let section = document.querySelector('#pdfContent .section-break');
        while(children.length && i < 250){
            // Process children for table and other content
            for (let child of children){
                i++;
                // Create footerLogo
                let footer = document.createElement("div");
                footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
                let footerLogo = document.createElement("img");
                footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
                footerLogo.alt = "miniicon";
                footerLogo.classList.add("h40px", "w40px", "tal");
                // Create trademark
                let trademark = document.createElement("p");
                trademark.innerText = `\xa9 Diligentsia Limited ${new Date().getFullYear()}`;
                trademark.classList.add("tac", "c37", "fs12px", "fw400");
                // Create pageNumber
                let pageNumber = document.createElement("h3");
                pageNumber.innerText = "Page " + _pageNumber;
                pageNumber.classList.add("fw600", "c36", "fs14px");
                // Append footerLogo and trademark to footer
                footer.appendChild(footerLogo);
                footer.appendChild(trademark);
                footer.appendChild(pageNumber);
                let childHeight = getHeight(child);
                // if (usedPageHeight + childHeight + footerHeight > pageHeight) {
                if (usedPageHeight + childHeight + footerHeight > pageHeight || child?.className == section?.className) {
                    page.classList.add("df", "fdc");
                    if (i > 1) {
                        _pageNumber++;
                        page = createNewPage(wrapper);
                        page.appendChild(footer);
                    }
                    usedPageHeight = 96;
                }
                page.appendChild(child.cloneNode(true));
                usedPageHeight += childHeight;
            }
            // Remove processed children
            children.splice(0, children.length);
        }
        // Clean up after processing
        wrapper.classList.remove("op0", "pen");
        document.getElementById("pdfContent").classList.remove("a4", "p3rem");
        // Workflow Notes Events
        let pdfInputs = wrapper.querySelectorAll("#pdf input");
        for(let j = 0; j < pdfInputs.length; j++)pdfInputs[j].addEventListener('click', ()=>setIsMarked(!isMarked));
        let pdfTextareas = wrapper.querySelectorAll("#pdf textarea");
        for(let j = 0; j < pdfTextareas.length; j++)pdfTextareas[j].addEventListener('change', (e)=>{
            setAnswerId(e.target.id);
            handleTaskNotes(e);
            setIsSaveNote(true);
        });
        for(let j = 0; j < pdfTextareas.length; j++)pdfTextareas[j].addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            setAnswerId(e.target.id);
            setIsSaveNote(true);
            setTimeout(()=>document.getElementById(e.target.id).scrollIntoView({
                    behavior: "instant"
                }), 100);
            requestAnimationFrame(()=>{
                let textarea = document.getElementById(e.target.id);
                if (textarea) {
                    textarea.focus({
                        preventScroll: true
                    });
                    try {
                        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
                    } catch (error) {
                        console.warn("Selection error:", error);
                    }
                }
            });
        });
        let reportBtn = document.querySelectorAll("#pdf button");
        for(let i = 0; i < reportBtn.length; i++){
            if (reportBtn[i]['id'] == 'status-value') reportBtn[i].addEventListener('click', (e)=>saveTaskStatus(e));
            if (reportBtn[i]['id'] == 'status-dropdown') reportBtn[i].addEventListener('click', (e)=>{
                setAnswerId(e.target.value);
                setPriorityDropdown(false);
                setStatusDropdown(!statusDropdown);
                document.getElementById(e.target.value).scrollIntoView({
                    behavior: "instant"
                });
            });
            if (reportBtn[i]['id'] == 'priority-value') reportBtn[i].addEventListener('click', (e)=>saveTaskPriority(e));
            if (reportBtn[i]['id'] == 'priority-dropdown') reportBtn[i].addEventListener('click', (e)=>{
                setAnswerId(e.target.value);
                setStatusDropdown(false);
                setPriorityDropdown(!priorityDropdown);
                document.getElementById(e.target.value).scrollIntoView({
                    behavior: "instant"
                });
            });
            if (reportBtn[i]['id'] == 'save-notes') reportBtn[i].addEventListener('click', (e)=>saveTaskNotes(e));
            if (reportBtn[i]['id'] == 'delete-note') reportBtn[i].addEventListener('click', (e)=>{
                if (e.target.id) {
                    answerId = e.target.id.split('+')[0];
                    noteId = e.target.id.split('+')[1];
                    setNoteId(noteId);
                    setAnswerId(answerId);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: "deleteNotePopup"
                    }));
                }
            });
            if (reportBtn[i]['id'] == 'edit-note') reportBtn[i].addEventListener('click', (e)=>{
                if (e.target.id) {
                    answerId = e.target.id.split('+')[0];
                    noteId = e.target.id.split('+')[1];
                    editNote = e.target.id.split('+')[2];
                    setNoteId(noteId);
                    setEditNote(editNote);
                    setAnswerId(answerId);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: "editNotePopup"
                    }));
                }
            });
        }
        document.body.onmousedown = ()=>{
            setTimeout(()=>{
                if (statusDropdown) setStatusDropdown(false);
                if (priorityDropdown) setPriorityDropdown(false);
            }, 500);
        };
    });
    (0, $acw62.useEffect)(()=>{
        if (answerId) setTimeout(()=>{
            let textarea = document.querySelector(`textarea[id="${answerId}"]`);
            if (textarea) {
                textarea.focus({
                    preventScroll: true
                });
                setTimeout(()=>document.getElementById(answerId).scrollIntoView({
                        behavior: "instant"
                    }), 100);
                if (textarea.value && textarea.value.length > 0) try {
                    textarea.setSelectionRange(textarea.value.length, textarea.value.length);
                } catch (error) {
                    console.warn("Selection error (fixed):", error);
                }
                else console.warn("Skipping setSelectionRange because value is empty or undefined");
            } else console.warn("Textarea not found on first render!");
        }, 50);
    }, [
        answerId
    ]);
    (0, $acw62.useEffect)(()=>{
        let pdfTextareas = document.querySelectorAll("#pdf textarea");
        pdfTextareas.forEach((textarea)=>{
            textarea.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                let clickedId = e.target.getAttribute("id");
                if (clickedId) {
                    setAnswerId(clickedId);
                    setIsSaveNote(true);
                }
            });
        });
        return ()=>{
            pdfTextareas.forEach((textarea)=>{
                textarea.removeEventListener('click', ()=>{});
            });
        };
    }, []);
    function createNewPage(wrapper) {
        let newPage = document.createElement("div");
        newPage.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        let header = document.createElement("img");
        header.classList.add("db", "ma", "h1rem");
        titleHeading(newPage);
        // Add additional headers based on the module type
        addHeadersBasedOnModule(newPage);
        wrapper.appendChild(newPage);
        return newPage;
    }
    function addHeadersBasedOnModule(page) {
        if (module?.['type'].includes("repository")) repositoryHeaders(page);
        if (module?.['type'].includes("warranty-disclosure")) warrantyDisclosureHeaders(page);
        if ([
            "software-development",
            "esg"
        ].includes(module?.['type']) || checklistModule) riskRecommendationHeaders(page);
        if (module?.['type'].includes(`directors-questionnaire_${module?.['director']?.['_id']}`)) directorsQuestionnaireHeaders(page);
    }
    const titleHeading = (page)=>{
        const title = document.createElement("span");
        let div = null;
        let quesAnsHead = null;
        title.classList.add("db", "fw700", "fs1-25rem", "c15", 'ttu');
        if (tab.match(/two-minute-test-.*-report/)) {
            title.classList.add("tal", "w100");
            title.innerText = `2 Minute ${module?.heading} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb0-5rem");
            div.innerText = `${company['cName']}`;
            quesAnsHead = document.createElement("div");
            quesAnsHead.classList.add("w100", "br10px", "p0-5rem", "fs1rem", "bg52", "df", "aic", "c1");
            let leftBar = document.createElement("div");
            leftBar.innerText = "Question";
            leftBar.classList.add("w80", "pl1rem");
            let rightBar = document.createElement("div");
            rightBar.innerText = "Answer";
            rightBar.classList.add("w20");
            quesAnsHead.appendChild(leftBar);
            quesAnsHead.appendChild(rightBar);
            page.appendChild(title);
            page.appendChild(div);
            page.appendChild(quesAnsHead);
            return page;
        } else if (checklistModule) {
            title.classList.add("tac", "mb1-75rem");
            title.innerText = module['type'] + ' Report' + ' - ' + company['cName'];
        } else {
            title.classList.add("tal", "w100");
            title.innerText = `${module?.heading} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb1rem");
            div.innerText = `${company['cName']}`;
            let warpElement = document.createElement('div');
            let warpElement2 = document.createElement('div');
            let logoTag = document.createElement('img');
            logoTag.classList.add("sad");
            logoTag.src = company['logo'];
            logoTag.alt = "companyLogo";
            logoTag.style.maxWidth = "150px";
            logoTag.style.maxHeight = "60px";
            warpElement2.appendChild(title);
            warpElement2.appendChild(div);
            warpElement.classList.add("df", "aic", "jcsb");
            warpElement.appendChild(warpElement2);
            if (company['logo']) warpElement.appendChild(logoTag);
            page.appendChild(warpElement);
            return page;
        }
        page.appendChild(title);
        return page;
    };
    const repositoryHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg52", "c1", "tac", "br10px");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const riskRecommendationHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Risk</h3><h3>Recommendation</h3>";
        page.appendChild(headings);
    };
    const warrantyDisclosureHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Disclosure</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const directorsQuestionnaireHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Text</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const sortQuestions = (a, b)=>{
        let valueA = a.qNo.split('.')[a.qNo.split('.').length - 1];
        let valueB = b.qNo.split('.')[a.qNo.split('.').length - 1];
        return valueA - valueB;
    };
    const sortLogs = (a, b)=>new Date(b.timestamp) - new Date(a.timestamp);
    const getAuditContent = ()=>{
        const sectionAnswers = answers.filter((a)=>!Object.values(module?.sections).filter((s)=>s.isHidden).find((s)=>a.qNo.includes(s.sectionNo)));
        const logs = sectionAnswers.filter((a)=>a.logs.length).reduce((arr, a)=>[
                ...arr,
                ...a.logs
            ], []).sort(sortLogs);
        return logs.map((log, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 p1rem br5px df my0-5rem",
                children: [
                    log.userId.profilePicture && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "ass ml0-5rem br100 w2rem h2rem",
                        src: log.userId.profilePicture
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem bg3 c1",
                        children: [
                            log.userId.firstName[0],
                            log.userId.lastName[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: log.message
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log.files.map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: file.location,
                                    target: "_blank",
                                    className: "db c3-hover fw600",
                                    children: file.originalname
                                }, idx)),
                            (log.payload.answers || [
                                log.payload
                            ]).map((answer, idx)=>{
                                const question = answer.questionId ? questions.find((q)=>q._id == answer.questionId) : "";
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        question && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: question.qNo
                                                }),
                                                " - ",
                                                question.qDescription
                                            ]
                                        }),
                                        answer.file && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Filename"
                                                }),
                                                ": ",
                                                answer.file.originalname
                                            ]
                                        }),
                                        answer.status && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Changed Status"
                                                }),
                                                ": ",
                                                answer.status
                                            ]
                                        }),
                                        answer.radioOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Selected Option"
                                                }),
                                                ": ",
                                                answer.radioOption
                                            ]
                                        }),
                                        answer.comment && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Entered Comment"
                                                }),
                                                ": ",
                                                answer.comment
                                            ]
                                        })
                                    ]
                                });
                            })
                        ]
                    })
                ]
            }, idx));
    };
    const getSyncContent = ()=>{
        const records = module?.sections.flatMap((section)=>section?.questions?.flatMap((question)=>question?.answer?.logs || [])).sort(sortLogs);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "df jcc aic mb1-3rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                            className: "w2rem mr0-5rem"
                        }),
                        "Google Drive Synchronization Report"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr3 bg6 c1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Date Synced"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Synced By "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Files Synced"
                        })
                    ]
                }),
                records.map((record, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg tableRow gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(record['timestamp']).format('lll')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: `${record['userId']['firstName']} ${record['userId']['lastName']}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    record['userId']['email']
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                style: {
                                    textAlign: 'left'
                                },
                                children: record['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        href: file['location'],
                                        target: "'_blank",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "File"
                                            }),
                                            ": ",
                                            file['originalname']
                                        ]
                                    }, idx))
                            })
                        ]
                    }, idx))
            ]
        });
    };
    const getOverviewContent = ()=>{
        let array = [];
        if (module && module?.['type'] && [
            'warranty-disclosure',
            'directors-questionnaire',
            'software-development',
            'esg'
        ].includes(module['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections.filter((s)=>!s.isHidden);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "minh100vh 100vh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2a gg2rem bg5 pt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "px2-5rem py2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1-5rem fw600 lh3 c36",
                                    children: "Workflow Completeness Report"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem ttc fw300 lh2 c36 mb3rem",
                                    children: module?.['type'] ? module['type'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw300 lh1 c36",
                                    children: "Company Name:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw500 lh5 c36 mb0-5rem",
                                    children: company?.['cName'] ? company['cName'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw300 lh1 c36",
                                    children: "Test Type:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem ttc fw500 lh5 c36 mb0-5rem",
                                    children: [
                                        "Sell/",
                                        company['testType']
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "px2-5rem py2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jce",
                                    children: company?.['logo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w70px mb2rem",
                                        src: company['logo'],
                                        alt: "img"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem fw300 lh4 c36 tae",
                                    children: [
                                        "Subscription: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: (user['role'] == 'Advisor' || user['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: company['subscription']?.toUpperCase()
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem ttc fw300 lh4 c36 tae",
                                    children: [
                                        "Company Reg: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fw500",
                                            children: [
                                                company?.['ukRegNo'] ? company['ukRegNo'] : '-',
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem ttc fw300 lh4 c36 tae",
                                    children: [
                                        "Issue Date: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format('ll')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw300 lh4 c36 tae",
                                    children: "Generated By:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw500 lh2 c36 tae",
                                    children: user['email']
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "dg gg1rem minh100vh-report",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "report-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dg gtcr2a gg2rem px2rem py3rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "director-review",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs1rem fw600 lh1 c36 mb3-5rem",
                                                children: "Current Workflow Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs1rem fw500 c36 tas w100 lh1",
                                                        children: "Director Review:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fww aifs",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "checkobox-report pr mr0-5rem mt0-5rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    style: {
                                                                        width: '25px',
                                                                        height: '25px'
                                                                    },
                                                                    name: "status",
                                                                    defaultChecked: isMarked,
                                                                    className: "checkbox shadow df bg5 bo5 bw2px bss cp td250 br5px",
                                                                    type: "checkbox"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fs0-75rem c12 lh1 w80",
                                                                children: isMarked ? 'Marked as completed by' : 'Mark as complete'
                                                            }),
                                                            isMarked ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fdc aifs ml1-5rem",
                                                                style: {
                                                                    marginTop: '-8px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df fww",
                                                                    children: [
                                                                        user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: user?.['profile'],
                                                                            className: `w2rem h2rem df jcc aic br100`,
                                                                            "data-tooltip": user['firstName'] ? user['firstName'] + " " + user?.['lastName'] : "Register to show your name here"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: `w2rem h2rem df jcc aic br100`,
                                                                            "data-tooltip": user?.['firstName'] ? user['firstName'] + " " + user?.['lastName'] : "Register to show your name here",
                                                                            children: user?.['firstName'] ? user['firstName'][0] + user?.['lastName']?.[0] : "?"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fww",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c36 fs0-75rem fw500 tal ml0-5rem w100",
                                                                                    children: user?.['firstName'] ? user['firstName'] + " " + user?.['lastName'] : "?"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c36 fs0-5rem fw400 tal ml0-5rem w100",
                                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format('ll')
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs0-5rem c4 fw400 ml2rem",
                                                                style: {
                                                                    marginTop: '-8px'
                                                                },
                                                                children: "Only authorized reviewer can mark complete"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df jce mb2-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "tae mr0-5rem fs1rem c36 fw500 lh1",
                                                        children: [
                                                            "Checklist ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " Completeness"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `progress-bar workflow-report-progress ${module?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : module?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : ' workflow-progress-pink'}`,
                                                        style: {
                                                            width: 65,
                                                            height: 65,
                                                            backgroundColor: '#fda9a4',
                                                            borderRadius: '50%',
                                                            margin: 0,
                                                            border: '2px solid #F1F1F1'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                            text: (module?.stats?.workflowCompletionPercent || 0) + "%",
                                                            styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                                strokeWidth: '0',
                                                                textSize: '20px',
                                                                trailColor: '#FBFBFB',
                                                                stroke: 'transparent',
                                                                strokeLinecap: 'butt',
                                                                pathTransitionDuration: 0.5,
                                                                backgroundColor: '#FBFBFB',
                                                                dominantBaseline: 'ideographic'
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem fw500 lh4 c6 tae",
                                                children: "Last Updated:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem fw300 lh4 c6 tae",
                                                children: module && module?.['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module?.['createdAt']).format('lll') : 'Nothing updated'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h60vh oscy",
                                children: array && array.length > 0 && array.sort(sortSections).map((section, idx)=>{
                                    let completeness = section.stats.workflowCompletionPercent;
                                    let hexColour = section?.stats?.workflowCompletionPercent > 75 ? '#d8fcc7' : section?.stats?.workflowCompletionPercent > 26 ? '#fff4c9' : section?.stats?.workflowCompletionPercent > 1 ? '#ffcecc' : '#dbdbdb';
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "px2rem ",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            style: {
                                                height: '40px'
                                            },
                                            "data-tooltip": completeness ? `This section has ${completeness}% workflow completeness` : '',
                                            "data-scroll-to": section.sectionNo,
                                            className: "df c3 c6 bg5 td250 c3-hover px1rem py0-5rem cp new-report-btn",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pen usn ass mt0-5rem tal left-heading",
                                                    children: section['sectionNo']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`,
                                                        width: '70%',
                                                        height: '40px',
                                                        paddingTop: '10px',
                                                        marginLeft: 0,
                                                        paddingLeft: '25px'
                                                    },
                                                    className: "pen uss ass fw600 tal pt1rem br5px right-detail",
                                                    children: section.sectionName
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `progress-bar workflow-report-progress pa ${completeness > 75 ? 'workflow-progress-green' : completeness > 26 ? 'workflow-progress-yellow' : completeness > 1 ? ' workflow-progress-pink' : ' workflow-progress-grey'}`,
                                                    style: {
                                                        width: 40,
                                                        height: 40,
                                                        backgroundColor: '#fda9a4',
                                                        borderRadius: '50%',
                                                        right: '3px',
                                                        margin: 0
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                        text: (completeness || 0) + "%",
                                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                            strokeLinecap: 'round',
                                                            strokeWidth: '5px',
                                                            textSize: '25px',
                                                            pathTransitionDuration: 0.5,
                                                            trailColor: '#d6d6d6',
                                                            backgroundColor: '#fc7785',
                                                            dominantBaseline: 'ideographic'
                                                        })
                                                    })
                                                })
                                            ]
                                        }, idx)
                                    });
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    const handleTaskNotes = (e)=>{
        let obj = {
            note: e.target.value
        };
        setTaskNotes((prevNotes)=>[
                ...prevNotes,
                obj
            ]); // Immutable update
    };
    const saveTaskNotes = async ()=>{
        let array = taskNotes.filter((item)=>item.note.trim() !== ""); // ensure no empty notes
        if (array.length === 0) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Cannot save an empty note!");
            return;
        }
        setIsLoader({
            show: true,
            message: 'Updating...'
        });
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            taskNotes: array,
            companyId: company['_id'],
            moduleName: module['type']
        });
        if (res['code'] == 200) {
            await handleUpdateWorkflow(res['body']);
            setAddTextarea(1);
            setTaskNotes([]); // clear notes after saving
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (taskNotes.length > 0 && isSaveNote) {
            saveTaskNotes();
            setIsSaveNote(false);
        }
    }, [
        taskNotes
    ]);
    const saveTaskStatus = async (e)=>{
        setStatusDropdown(false);
        setIsLoader({
            show: true,
            message: 'Updating...'
        });
        setTimeout(async ()=>{
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
                taskStatus: e.target.value,
                companyId: company['_id'],
                moduleName: module['type']
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
            if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
        }, 1000);
    };
    const saveTaskPriority = async (e)=>{
        setPriorityDropdown(false);
        setIsLoader({
            show: true,
            message: 'Updating...'
        });
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            taskPriority: e.target.value,
            companyId: company['_id'],
            moduleName: module['type']
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
    };
    const handleUpdateWorkflow = async (updatedAnswer)=>{
        if (answerId) setTimeout(()=>document.getElementById(answerId).scrollIntoView(), 100);
        let { sectionId: sectionId } = updatedAnswer;
        if (module['sections']) {
            for (let section of module['sections'])if (section['_id'] == sectionId) {
                let questionIndex = section['questions'].findIndex(({ _id: _id })=>_id == updatedAnswer['questionId']);
                let questions1 = Object.assign([], section['questions'], {
                    [questionIndex]: {
                        ...section['questions'][questionIndex],
                        ['answer']: updatedAnswer
                    }
                });
                let sectionIndex = module['sections'].findIndex(({ _id: _id })=>_id == sectionId);
                let sections = Object.assign([], module['sections'], {
                    [sectionIndex]: {
                        ...section,
                        questions: questions1
                    }
                });
                company = {
                    ...company,
                    modules: {
                        ...company['modules'],
                        [module['type']]: {
                            ...company['modules'][module['type']],
                            sections: sections
                        }
                    }
                };
                setAnswerId('');
                let companyClone = await calculateStats(company);
                dispatch(setCompany(companyClone));
            }
        }
        setIsLoader({
            show: false,
            message: 'Loading...'
        });
    };
    const handleDeleteNote = async ()=>{
        if (noteId != '' && answerId != '') {
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/deleteTaskNote/${answerId}/${noteId}`);
            if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
            setNoteId('');
            setTimeout(()=>document.getElementById(answerId).scrollIntoView(), 100);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        }
    };
    const handleEditNote = async ()=>{
        if (noteId != '' && answerId != '') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/updateTaskNote/${answerId}/${noteId}`, {
                note: editNote
            });
            if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
            setNoteId('');
            setEditNote('');
            setTimeout(()=>document.getElementById(answerId).scrollIntoView(), 100);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        }
    };
    const sortByDate = (a, b)=>{
        return new Date(b.updatedAt) - new Date(a.updatedAt);
    };
    const getAuditReportContent = ()=>{
        let array = [];
        if (module && module?.['type'] && [
            'warranty-disclosure',
            'directors-questionnaire',
            'software-development',
            'esg'
        ].includes(module['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections.filter((s)=>!s.isHidden);
        array = array && array.slice().sort(sortSections) || [];
        let checklistModule = false;
        if (module['type'] != "repository" && module['type'] != "software-development" && module['type'] != "esg" && module['type'] != "warranty-disclosure" && module['type'] != `business-audit-${company['testType']}` && !module['type'].includes("directors-questionnaire")) checklistModule = true;
        sectionRefs.current.length = array && array.length || 0;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: array && array.length > 0 && array.map((section, index)=>{
                if (!section) return null;
                let completionPercent, riskPercent;
                if (section?.stats?.completionPercent) completionPercent = section.stats.completionPercent;
                if (section?.stats?.riskPercent) riskPercent = section.stats.riskPercent;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "section-break"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            ref: (el)=>{
                                if (section['sectionNo']) sectionRefs.current[index] = el;
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                className: "df jcc aic tac mb1rem fs1rem",
                                children: [
                                    section['sectionNo'],
                                    " - ",
                                    section['sectionName'],
                                    " Report \xa0-\xa0",
                                    completionPercent && completionPercent > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: completionPercent < 34 ? "c9" : completionPercent < 67 ? 'c8' : 'c7',
                                                children: [
                                                    "Completed ",
                                                    completionPercent || 0,
                                                    "%"
                                                ]
                                            }),
                                            riskPercent > 0 && module['type'] != "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: riskPercent < 38 ? "c7" : riskPercent < 62 ? 'c8' : 'c9',
                                                        children: [
                                                            riskPercent || 0,
                                                            "% Risk"
                                                        ]
                                                    }),
                                                    " "
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c12",
                                                children: "Not Started"
                                            }),
                                            module['type'] != "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c12",
                                                        children: "No Risk Score"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        section?.questions && section?.questions.slice().sort(sortQuestions).filter((q)=>q.answer).map((question, idx)=>{
                            if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                            let isRisky = question.answer.radioOption === "No";
                            let statusColor, priorityColor;
                            if (question?.['answer']?.['taskStatus'] == 'N/A') statusColor = 'grey-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Not Started') statusColor = 'sky-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Started') statusColor = 'blue-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'In Progress') statusColor = 'yellow-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Completed - Further Work') statusColor = 'orange-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Completed - No Issues') statusColor = 'green-bg';
                            else statusColor = '';
                            if (question?.['answer']['taskPriority'] == 'N/A') priorityColor = 'grey-bg';
                            else if (question?.['answer']['taskPriority'] == 'High Priority') priorityColor = 'red-bg';
                            else if (question?.['answer']['taskPriority'] == 'Medium Priority') priorityColor = 'orange-bg';
                            else if (question?.['answer']['taskPriority'] == 'Low Priority') priorityColor = 'yellow-bg';
                            else priorityColor = '';
                            let notes = [];
                            if (question?.['answer']?.['taskNotes']) notes = question?.['answer']?.['taskNotes'].slice().sort(sortByDate);
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `dg tableRow fs0-75rem ${[
                                        "repository",
                                        "directors-questionnaire"
                                    ].includes(module?.['type']) ? 'gtcr-audit' : 'gtcr-audit-workflow'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc aic jcfs pt0-25rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fw600",
                                                        children: [
                                                            question['qNo'],
                                                            ":"
                                                        ]
                                                    }),
                                                    " ",
                                                    question?.['qDescription']
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes("directors-questionnaire") ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aic tac jcfs pt1rem br5px",
                                            children: question?.questionType.includes("YN") ? question.answer['radioOption'] || question.answer['status'] : "-"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc aic tac jcfs pt1rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `${[
                                                    "Disclosure",
                                                    "No Disclosure"
                                                ].includes(question?.answer?.['radioOption']) ? ' px0-5rem ' : ' px1rem '} py0-5rem br10px c1 ${(question?.answer?.['radioOption'] || question?.answer?.['status'])?.includes('Yes') ? ' bg34' : (question?.answer?.['radioOption'] || question?.answer?.['status'])?.includes('No') ? ' bg4' : ' bg16'}`,
                                                children: question.answer['radioOption'] || question.answer['status'] || '-'
                                            })
                                        }),
                                        module?.['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem br5px",
                                                    children: question?.answer?.files?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "File"
                                                                    }),
                                                                    ": ",
                                                                    file['originalname']
                                                                ]
                                                            }, idx))
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "No Files Uploaded"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem br5px",
                                                    children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: question['answer']['comment']
                                                    })
                                                })
                                            ]
                                        }),
                                        checklistModule && question?.['answer']?.['radioOption'] != 'N/A' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                id: question?.['answer']['_id'],
                                                className: "df fdc tal jcs pt0-5rem mx0-5rem",
                                                children: [
                                                    question?.['answer']?.['radioOption'] != 'Yes' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df pb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['riskDescription'] || question?.['ifNo']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['recommendDescription'] || question?.['toptip'] || question.answer.radioOption == "Yes" && question?.['ifYes']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w90 p1rem my0-5rem",
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: [
                                                            "Files:",
                                                            question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 ? question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: "ml0-5rem tdu",
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: file['originalname']
                                                                }, idx)) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "ml0-5rem fs0-75rem fw500",
                                                                children: "No files uploaded"
                                                            })
                                                        ]
                                                    }),
                                                    question?.['answer'] && question?.['answer']?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "mb1rem py0-5rem px0-5rem df aic jcsb br5px",
                                                                style: {
                                                                    background: '#e1e1f155'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        children: "Workflow Notes:"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "right-area-details df aic",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "priority-dropdown",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        id: "priority-dropdown",
                                                                                        value: question?.['answer']['_id'],
                                                                                        "data-tooltip": "Priority",
                                                                                        className: `dropdown-btn px1rem fs0-75rem mr0-5rem c36 bg35 cp br20px pr bss bw1px bo36 ${question?.['answer']['taskPriority'] && priorityColor}`,
                                                                                        children: question?.['answer']['taskPriority'] || 'Priority'
                                                                                    }),
                                                                                    answerId == question?.['answer']['_id'] && priorityDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                                                        className: "dropdown-content cp new-shadow fww",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp first-item red-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "High Priority",
                                                                                                    children: "High Priority"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp orange-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "Medium Priority",
                                                                                                    children: "Medium Priority"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp yellow-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "Low Priority",
                                                                                                    children: "Low Priority"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp last-item grey-bg ",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "N/A",
                                                                                                    children: "N/A"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "status-dropdown",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        id: "status-dropdown",
                                                                                        value: question?.['answer']['_id'],
                                                                                        "data-tooltip": "Status",
                                                                                        className: `dropdown-btn px1rem fs0-75rem mr0-5rem c36 bg1 cp br20px pr bss bw1px bo36 ${question?.['answer']['taskStatus'] && statusColor}`,
                                                                                        children: question?.['answer']['taskStatus'] || 'Status'
                                                                                    }),
                                                                                    answerId == question?.['answer']['_id'] && statusDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                                                        className: "dropdown-content cp new-shadow fww",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp first-item grey-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "N/A",
                                                                                                    children: "N/A"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp sky-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Not Started",
                                                                                                    children: "Not Started"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp blue-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Started",
                                                                                                    children: "Started"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp yellow-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "In Progress",
                                                                                                    children: "In Progress"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp orange-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Completed - Further Work",
                                                                                                    children: "Completed - Further Work"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp last-item green-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Completed - No Issues",
                                                                                                    children: "Completed - No Issues"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "br5px p1rem",
                                                                style: {
                                                                    background: '#e1e1f155'
                                                                },
                                                                children: [
                                                                    question?.['answer']?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "task-notes-scroll mt1rem",
                                                                        children: [
                                                                            ...Array(answerId == question?.['answer']['_id'] ? addTextarea : 1)
                                                                        ].map((x, idx)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc br10px bg1 bss bw2px bo31 p1rem mb0-5rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "icon-textare df",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                            ref: textareaRef,
                                                                                            className: "w100 h100 br5px p0-5rem fs0-75rem",
                                                                                            style: {
                                                                                                backgroundColor: "transparent",
                                                                                                resize: "vertical"
                                                                                            },
                                                                                            placeholder: "Add workflow note",
                                                                                            rows: "1",
                                                                                            cols: "50",
                                                                                            value: answerId == question?.['answer']['_id'] && taskNotes.length > 0 ? taskNotes?.[idx]?.['note'] : '',
                                                                                            id: question?.['answer']['_id'],
                                                                                            onChange: handleTaskNotes,
                                                                                            onFocus: (e)=>e.target.select()
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df jsfs w100 pt0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: '10px'
                                                                                            },
                                                                                            className: "ml-1rem c12",
                                                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now()).format('lll')
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            });
                                                                        })
                                                                    }),
                                                                    answerId == question?.['answer']['_id'] && isSaveNote && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df jcc",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            id: "save-notes",
                                                                            value: question?.['answer']['_id'],
                                                                            className: `dropdown-btn bg4 fs0-75rem mt0-5rem c1 cp br5px px1rem pr bss bw1px bo4`,
                                                                            children: addTextarea > 1 ? 'Save Notes' : 'Save Note'
                                                                        })
                                                                    }),
                                                                    notes && notes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "task-notes-scroll",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs0-75rem fw500 c36",
                                                                                children: "Notes:"
                                                                            }),
                                                                            notes.map((item)=>{
                                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "notes-details mt0-5rem bssb px0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df jcsb aic mb1rem",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                    className: "w80 notes-left-area df aic",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                            className: "notes-img mr0-5rem",
                                                                                                            children: item?.['user']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                                src: item?.['user']?.['profile'],
                                                                                                                className: `w2rem h2rem df jcc aic br100`,
                                                                                                                "data-tooltip": item?.['user']['firstName'] ? item?.['user']['firstName'] + " " + item?.['user']?.['lastName'] : "Register to show your name here"
                                                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: `new-shadow w2rem h2rem df jcc aic br100`,
                                                                                                                "data-tooltip": item?.['user']['firstName'] ? item?.['user']['firstName'] + " " + item?.['user']?.['lastName'] : "Register to show your name here",
                                                                                                                children: item?.['user']['firstName'] ? item?.['user']['firstName'][0] + item?.['user']?.['lastName']?.[0] : "?"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                            className: "notes-text",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                                                                                    className: "fs0-5rem c36",
                                                                                                                    style: {
                                                                                                                        fontSize: '10px'
                                                                                                                    },
                                                                                                                    children: [
                                                                                                                        item?.['user']['firstName'] ? item?.['user']['firstName'] + " " + item?.['user']?.['lastName'] : 'Guest User',
                                                                                                                        ": ",
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                            className: "fw300 c37",
                                                                                                                            children: item['note']
                                                                                                                        })
                                                                                                                    ]
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                                    className: "mr1rem fs0-5rem",
                                                                                                                    color: "#4C6B9270",
                                                                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(item['createdAt']).format('lll')
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                item['user']['_id'] == user['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                    className: "w20 notes-left-area df jcc aic",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                            className: "cp c4",
                                                                                                            style: {
                                                                                                                background: 'transparent'
                                                                                                            },
                                                                                                            id: "delete-note",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                id: question?.['answer']['_id'] + '+' + item['_id'],
                                                                                                                "data-tooltip": "Delete Note",
                                                                                                                className: "fa fa-trash",
                                                                                                                "aria-hidden": "true"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                            className: "cp c36",
                                                                                                            style: {
                                                                                                                background: 'transparent'
                                                                                                            },
                                                                                                            id: "edit-note",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                id: question?.['answer']['_id'] + '+' + item['_id'] + '+' + item['note'],
                                                                                                                "data-tooltip": "Edit Note",
                                                                                                                className: "fa fa-pencil",
                                                                                                                "aria-hidden": "true"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                });
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes("directors-questionnaire") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question?.questionType.includes("Date") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.answer && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(question?.answer?.date).format('ll')
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: question['answer'] ? question['answer']['comment'] || question['answer']['dropdown'] : '-'
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question.answer.files.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "File"
                                                                    }),
                                                                    ": ",
                                                                    file['originalname']
                                                                ]
                                                            }, idx))
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "-"
                                                    })
                                                })
                                            ]
                                        }),
                                        module?.['type'].includes(`business-audit-${company['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc tal jcfs pt0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df  pb0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w50 tac px0-5rem",
                                                        children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                question?.['answer']?.['aiResponse']?.['ifriskDescription'] && question?.['answer']?.['aiResponse']?.['ifriskDescription'],
                                                                question['riskDescription'] && question['riskDescription']
                                                            ]
                                                        }) : "Well done"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w50 tac px0-5rem",
                                                        children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] && question?.['answer']?.['aiResponse']?.['ifrecommendDescription'],
                                                                question['recommendDescription'] && question['recommendDescription']
                                                            ]
                                                        }) : "No recommendation at this time"
                                                    })
                                                ]
                                            })
                                        }),
                                        [
                                            "warranty-disclosure",
                                            "software-development",
                                            "esg"
                                        ].includes(module?.['type']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc tal jcfs pt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df pb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' && question['answer']['radioOption'] == 'Disclosure' ? question?.['answer']?.['comment'] && question?.['answer']?.['comment'] : module?.['type'] == 'warranty-disclosure' ? '-' : question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] || question['recommendDescription']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' ? question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                            children: "File"
                                                                        }),
                                                                        ": ",
                                                                        file['originalname']
                                                                    ]
                                                                }, idx)) : question?.['answer']?.['aiResponse']?.['ifriskDescription'] || question['riskDescription']
                                                        })
                                                    ]
                                                }),
                                                [
                                                    "software-development",
                                                    "esg"
                                                ].includes(module?.['type']) && question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "w90 p1rem my0-5rem",
                                                    style: {
                                                        background: '#e1e1f155'
                                                    },
                                                    children: [
                                                        "Files: ",
                                                        question['answer']['files'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                className: "ml0-5rem tdu",
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: file['originalname']
                                                            }))
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            });
                        })
                    ]
                });
            })
        });
    };
    const getTwoMinuteTestContent = ()=>{
        const writeSections = (sections)=>Object.values(sections).filter((s)=>!s.isHidden).map((section, index)=>{
                const questionsAndAnswers = section?.questions?.slice().sort(sortQuestions).filter((q)=>q?.answer?.radioOption);
                if (questionsAndAnswers && questionsAndAnswers.length) sectionRefs.current.length = questionsAndAnswers.length;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: questionsAndAnswers.map((question, idx)=>{
                        const { answer: answer } = question;
                        if (!aiEnhanced && Object.values(answer?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    id: section.sectionNo,
                                    ref: (el)=>{
                                        if (section['sectionNo']) sectionRefs.current[index] = el;
                                    },
                                    className: "usn pen fs1rem fw600 mt-3 tac",
                                    children: [
                                        section.sectionNo,
                                        " - ",
                                        section.sectionName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "question-box  c1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                children: [
                                                    "Question: ",
                                                    question['qNo']
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: question['qDescription']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Answer:"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `${question['answer']['radioOption'] == 'Yes' || question['answer']['radioOption'] < 3 ? 'green' : 'red'} c4`,
                                                    children: question['answer']['radioOption']
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "recomended-box",
                                    children: (()=>{
                                        const recommendationKey = [
                                            "ifYes",
                                            "ifNo",
                                            "",
                                            "if1",
                                            "if2",
                                            "if3",
                                            "if4",
                                            "if5"
                                        ].find((key)=>key.includes("if" + answer.radioOption));
                                        return recommendationKey && question[recommendationKey] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Recommendation:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs1rem",
                                                    children: answer?.['aiResponse']?.[recommendationKey] || question[recommendationKey]
                                                })
                                            ]
                                        });
                                    })()
                                })
                            ]
                        }, idx);
                    })
                });
            });
        return writeSections(module?.sections);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: company && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                    id: "pdf",
                    className: "op0 pen ma td250 dg gg2rem"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "hideOnDownload mt2rem aic df",
                    children: [
                        !user.firstName && tab == 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc aic fdc ",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1-25rem mb1rem tac",
                                    children: "Now let's view your 2-minute test report..."
                                }),
                                user['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>twoMinuteTestAIReport(module),
                                        className: "shadow bsbb jcc w200px w9rem df fdc aic fw500  px1rem c1 bg4 br19px cp registerButtonAnimation",
                                        style: {
                                            width: '25%',
                                            paddingTop: '7px',
                                            paddingBottom: '7px'
                                        },
                                        children: "View 2-Minute Test Report"
                                    })
                                })
                            ]
                        }),
                        tab.match(/two-minute-test-.*-report/) && user?.['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: `/company/${company['_id']}`,
                                style: {
                                    width: '15%',
                                    paddingTop: '7px',
                                    paddingBottom: '7px'
                                },
                                className: `shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                                children: "Next"
                            })
                        }),
                        module && module?.['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc aic w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setTab(""),
                                className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "Dashboard"
                            })
                        }),
                        module && module?.['type'].includes(`business-audit-${company?.['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(module['type']),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Business Audit"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(""),
                                    className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Dashboard"
                                })
                            ]
                        }),
                        module && module?.['type'] == "warranty-disclosure" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc aic w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setTab(""),
                                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "Dashboard"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                    id: "pdfContent",
                    className: "bsbb w0 h0 oh op0 pen db",
                    style: {
                        width: 0,
                        height: 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            getOverviewContent(),
                            [
                                'repository-report',
                                `business-audit-${company?.['testType']}-report`,
                                'warranty-disclosure-report',
                                'software-development-report',
                                'esg-report',
                                `directors-questionnaire_${module?.['director']?.['_id']}`
                            ].includes(tab) ? getAuditReportContent() : tab.includes("repository-sync-report") ? getSyncContent() : tab.includes("repository-audit-report") ? getAuditContent() : tab.match(/two-minute-test-.*-report/) ? getTwoMinuteTestContent() : getAuditReportContent()
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    id: "deleteNotePopup",
                    open: modal['open'] === 'deleteNotePopup',
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                                children: "Confirmation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem c15 fw400 my1rem",
                                children: "Are you sure you want to delete note ?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb gg1rem mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>{
                                            setNoteId(''), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }));
                                        },
                                        className: "shadow bo4 bss bg1 bg4-hover c4 c1-hover td250 br5px p1rem fw600 cp w30 ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>handleDeleteNote(),
                                        className: "shadow bg3 bo3 bss bo4-hover bg4-hover c1 td250 br5px p1rem fw600 w50 cp ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Confirm"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    id: "editNotePopup",
                    open: modal['open'] === 'editNotePopup',
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                                children: "Edit Note"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                className: "h100 bss bw2px bo16 w100 br5px px1-5rem py1rem fs1rem mb1rem",
                                style: {
                                    backgroundColor: "transparent",
                                    resize: "vertical"
                                },
                                placeholder: "Add workflow note",
                                rows: "2",
                                cols: "50",
                                defaultValue: editNote || '',
                                onChange: (e)=>setEditNote(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb gg1rem mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>{
                                            setNoteId(''), setEditNote(''), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }));
                                        },
                                        className: "shadow bo4 bss bg1 bg4-hover c4 c1-hover td250 br5px p1rem fw600 cp w30 ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>handleEditNote(),
                                        className: "shadow bg3 bo3 bss bo4-hover bg4-hover c1 td250 br5px p1rem fw600 w50 cp ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("45fvw");








function $22cbb003a0ad0275$export$2e2bcd8739ae039({ company: company, modules: modules, tab: tab, setTab: setTab, showReport: showReport, handleContent: handleContent }) {
    const getSidebarHTML = (module, showInTooltip = false)=>{
        let array = [];
        if (module !== '') {
            if (module && module.sections && module?.['expansionPack']) array = Object.values(module['sections'][0]['subFolders']);
            else array = module?.sections;
        }
        const style = showInTooltip ? {} : {
            width: "calc((100% - 4rem) / 5)"
        };
        const jsx = module && module.sections && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            id: "sidebar",
            style: style,
            className: "h100vh w100 bsbb dg gg1rem br5px bg5 ps t0 sidebar-report all-sidebar-report",
            children: [
                !showInTooltip && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc aic fdc p0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c3 fs1rem ttu w100 tac",
                            children: "Diligence Pack"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>setTab(""),
                            className: `shadow mt1rem mxa bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac close-reports`,
                            children: "Close Report"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                            style: {
                                border: "none",
                                height: "1px",
                                display: "block",
                                width: "100%",
                                marginTop: "18px",
                                backgroundColor: "#002d63"
                            }
                        }),
                        company != null && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>downloadPDF(),
                                className: "h100 mt1rem mb0-5rem mxa shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        className: "pen fds h1rem f1 mr0-5rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 640 512",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-primary",
                                                d: "M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-secondary",
                                                d: "M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                            })
                                        ]
                                    }),
                                    "Download PDF"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                    style: {
                        border: "none",
                        height: "1px",
                        display: "block",
                        width: "100%",
                        backgroundColor: "#002d63"
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mah100 mya oya df fdc siedbar-dropdwon",
                    children: Object.values(modules).map((value, idx)=>{
                        if (showReport?.includes('directors-questionnaire') && value?.type == showReport) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: value['type'] == showReport,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleContent(value['type']),
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    "aria-controls": "panel1a-content",
                                    id: "panel1a-header",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        children: company?.['modules']?.[value['type']]?.heading
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mah100 mya oya df fdc jcsb",
                                        children: array.length > 0 && array.map((section)=>{
                                            // TODO: Calculate Stats for Expansion Packs
                                            if (!section.stats) section.stats = module['sections'][0]['stats'];
                                            const completeness = section.stats.completionPercent;
                                            let riskColour;
                                            if (module.type === "repository" || section.stats.riskPercent < 38) riskColour = 7;
                                            else if (section.stats.riskPercent > 62) riskColour = 9;
                                            else riskColour = 8;
                                            let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                                            let tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "tac maw200px",
                                                children: `This section is ${completeness}% complete` + (module['type'] !== "repository" ? ` with ${section.stats.completionPercent === 0 ? "no risk score" : `a risk score of ${section.stats.riskPercent}%`}.` : "")
                                            }));
                                            if (section['disabled']) tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "tac maw200px",
                                                children: `Please request admin to access ${section['sectionNo']}`
                                            }));
                                            let colorChange = false;
                                            if (module['type'] == "warranty-disclosure") section?.questions.map((question)=>{
                                                if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
                                                    colorChange = true;
                                                    return;
                                                }
                                            });
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    "data-tooltip": tooltip,
                                                    style: {
                                                        background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                                    },
                                                    "data-scroll-to": section['sectionNo'],
                                                    className: `c2 c3-hover bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: (showInTooltip ? 'fs0-5rem ' : 'fs0-75rem ') + "fw500 asc pen uss ass tal",
                                                        children: [
                                                            section['sectionName'],
                                                            " "
                                                        ]
                                                    })
                                                })
                                            });
                                        })
                                    })
                                })
                            ]
                        });
                        if (value?.['heading'] && !value['type'].includes('directors-questionnaire')) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: value['type'] == showReport,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    onClick: ()=>handleContent(value['type']),
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    "aria-controls": "panel1a-content",
                                    id: "panel1a-header",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        children: company?.['modules']?.[value['type']]?.heading
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mah100 mya oya df fdc jcsb",
                                        children: array.length > 0 && array.map((section)=>{
                                            // TODO: Calculate Stats for Expansion Packs
                                            if (!section.stats) section.stats = module['sections'][0]['stats'];
                                            const completeness = section.stats.completionPercent;
                                            let riskColour;
                                            if (module.type === "repository" || section.stats.riskPercent < 38) riskColour = 7;
                                            else if (section.stats.riskPercent > 62) riskColour = 9;
                                            else riskColour = 8;
                                            let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                                            let tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "tac maw200px",
                                                children: `This section is ${completeness}% complete` + (module['type'] !== "repository" ? ` with ${section.stats.completionPercent === 0 ? "no risk score" : `a risk score of ${section.stats.riskPercent}%`}.` : "")
                                            }));
                                            if (section['disabled']) tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "tac maw200px",
                                                children: `Please request admin to access ${section['sectionNo']}`
                                            }));
                                            let colorChange = false;
                                            if (module['type'] == "warranty-disclosure") section?.questions.map((question)=>{
                                                if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
                                                    colorChange = true;
                                                    return;
                                                }
                                            });
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    "data-tooltip": tooltip,
                                                    style: {
                                                        background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                                    },
                                                    "data-scroll-to": section['sectionNo'],
                                                    className: `c2 c3-hover bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: (showInTooltip ? 'fs0-5rem ' : 'fs0-75rem ') + "fw500 asc pen uss ass tal",
                                                        children: [
                                                            section['sectionName'],
                                                            " "
                                                        ]
                                                    })
                                                })
                                            });
                                        })
                                    })
                                })
                            ]
                        });
                    })
                })
            ]
        });
        return showInTooltip ? (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(jsx) : jsx;
    };
    const downloadPDF = async ()=>{
        try {
            const wrapper = document.getElementById("pdf");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.remove("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah100vh"));
            wrapper.classList.remove("gg2rem");
            for (const page of wrapper.children)page.classList.remove("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.add("op0");
            const filename = [
                company.cName,
                company.subscription,
                tab
            ].join(" - ");
            const opt = {
                filename: filename,
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'p'
                }
            };
            await (0, (/*@__PURE__*/$parcel$interopDefault($8994635913a5668f$exports)))().set(opt).from(wrapper).save();
            wrapper.classList.add("gg2rem");
            for (const page of wrapper.children)page.classList.add("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.remove("op0");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.add("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah100vh"));
        } catch (e) {
            console.error(e);
        }
    };
    const newReport = showReport ? showReport : `two-minute-test-${company['testType']}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: getSidebarHTML(modules[newReport])
    });
}







function $b56e0040e90bd8b5$export$2e2bcd8739ae039({ user: user, company: company, modules: modules, tab: tab, setTab: setTab, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned }) {
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    const [showReport, setShowReport] = (0, $acw62.useState)('');
    const directorModules = Object.values(modules).filter((item)=>item.type?.includes('directors-questionnaire'));
    // useEffect(() => {
    // 	setShowReport(modules?.[`two-minute-test-${company?.['testType']}`]?.['type']);
    // }, [modules]);
    (0, $acw62.useEffect)(()=>{
        document.getElementById("pdfContent").classList.add("a4-pdf", "p3rem");
        const wrapper = document.getElementById("pdf");
        wrapper.innerHTML = "";
        const children = Array.from(document.getElementById("pdfContent").children);
        let i = 0;
        while(children.length && i < 250){
            i++;
            const page = document.createElement("div");
            page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p3rem", "shadow", "new-report");
            if (aiEnhanced) page.classList.add('report-ai');
            wrapper.appendChild(page);
            const watermark = document.createElement("img");
            watermark.classList.add("op20", "pa");
            watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
            watermark.style.top = "50%";
            watermark.style.left = "50%";
            watermark.style.width = "297mm";
            page.appendChild(watermark);
            const pageHeight = getHeight(page);
            let usedPageHeight = 96;
            let childrenToRemove = 0;
            let footer = document.createElement("div");
            footer.classList.add("tac", "fw600", "df", "fdc", "jcfe", "h100");
            footer.innerText = "Page " + i;
            let footerHeight = 8;
            if (i > 1) {
                const header = document.createElement("img");
                header.classList.add("db", "ma", "h3rem");
                header.innerText = "Page " + i;
                page.appendChild(header);
                const title = document.createElement("span");
                title.classList.add("db", "ma", "mb1-3rem", "fw700", "fs1-25rem", "h2rem", "tac", "c6");
                title.innerText = showReport.toUpperCase() + "-REPORT";
                page.appendChild(title);
                usedPageHeight += getHeight(header);
            }
            for (const child of children){
                const childHeight = getHeight(child);
                if (usedPageHeight + childHeight + footerHeight < pageHeight || childHeight > pageHeight - 96) {
                    child.classList.add("pr");
                    page.appendChild(child.cloneNode(true));
                    usedPageHeight += childHeight;
                    childrenToRemove++;
                } else {
                    page.classList.add("df", "fdc");
                    page.appendChild(footer);
                    break;
                }
            }
            if (childrenToRemove == 0) break;
            children.splice(0, childrenToRemove);
        }
        wrapper.classList.remove("op0", "pen");
        document.getElementById("pdfContent").classList.remove("a4", "p3rem");
        let pdfInputs = wrapper.querySelectorAll("#pdf input");
        for(let j = 0; j < pdfInputs.length; j++)pdfInputs[j].addEventListener('click', (event)=>saveAnswerInput(event));
        let pdfTextareas = wrapper.querySelectorAll("#pdf textarea");
        for(let j = 0; j < pdfTextareas.length; j++)pdfTextareas[j].addEventListener('click', (event)=>saveAnswerTextarea(event));
    });
    const handleContent = (type)=>{
        if (type == showReport) setShowReport('');
        else setShowReport(type);
    };
    (0, $acw62.useEffect)(()=>{
        for(let i = 0; i < Object.entries(modules).length; i++){
            let contentBtn = document.getElementById(`content-btn-${i}`);
            if (modules[contentBtn?.value]) contentBtn.addEventListener('click', ()=>handleContent(contentBtn['value']));
        }
        let opt = document.getElementById(`director-opt`);
        if (opt) {
            if (modules[opt?.['value']]) {
                opt.addEventListener('change', ()=>handleContent(opt['value']));
                opt.value = showReport;
            }
            return ()=>opt.removeEventListener('change', handleContent);
        }
    }, [
        showReport,
        handleContent
    ]);
    const getOverviewContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "minh100vh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "w100 tac c6 lh2 fs1-75rem",
                    children: "Company Report - " + company['cName']
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt0-5rem mr1rem dg gg1rem minh100vh-report",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "h100 df fdc jcsb aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "logo-report",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h2rem",
                                    src: (parcelRequire("b0Cmg")),
                                    alt: "TODO"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "report-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dg gtcr2a gg2rem mb0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "h100 df fdc jcsb aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs1rem mb0-5rem",
                                                        children: "Company Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs1rem fw700 lh1 ttu usn c6",
                                                        children: company['cName']
                                                    }),
                                                    company['testType'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "ass fs1rem mt0-5rem mb0-5rem",
                                                                children: "Test Type"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                className: "fs1rem fw700 lh1 ttu usn c6",
                                                                children: company['testType']
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                className: "right-list",
                                                children: [
                                                    [
                                                        "Subscription",
                                                        (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: company['subscription']?.toUpperCase()
                                                        })
                                                    ],
                                                    [
                                                        "Company Reg",
                                                        company.ukRegNo
                                                    ],
                                                    [
                                                        "Issue Date",
                                                        (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("MMM Do YYYY")
                                                    ],
                                                    [
                                                        "Generated By",
                                                        company.creatorId.email
                                                    ]
                                                ].map((arr, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            arr[0],
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: arr[1]
                                                            })
                                                        ]
                                                    }, idx))
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "heading-area tac df fdc jcc aic",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "w200 c6 lh2 fs1-25rem",
                                        style: {
                                            borderBottom: '3px solid #002d63'
                                        },
                                        children: "Your Overall Result"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `progress-area-report`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "progress-area",
                                        style: {
                                            display: 'flex',
                                            position: 'relative',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "progress-box all-report-progress-box",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "progress-bar",
                                                        style: {
                                                            width: 80,
                                                            height: 80,
                                                            backgroundColor: '#ebeeff',
                                                            borderRadius: '50%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                            className: `${company?.['stats']?.['completionPercent'] > 67 ? 'green' : company?.['stats']?.['completionPercent'] > 33 ? 'orange' : 'red'}`,
                                                            value: company?.['stats']?.['completionPercent'] || 0,
                                                            text: `${company?.['stats']?.['completionPercent'] || 0}%`,
                                                            styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                                strokeLinecap: 'round',
                                                                strokeWidth: '5px',
                                                                textSize: '22px',
                                                                pathTransitionDuration: 0.5,
                                                                trailColor: '#d6d6d6',
                                                                backgroundColor: '#fc7785'
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            marginBottom: '0',
                                                            fontSize: '18px'
                                                        },
                                                        className: "text-center-area",
                                                        children: "Completeness"
                                                    })
                                                ]
                                            }),
                                            company['cLevel'] && company['subscription'] != "Free" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54119cc183dc6bdf$export$2e2bcd8739ae039), {
                                                className: 'op70',
                                                component: "AllReports",
                                                level: company['subscription'] == "Lite" ? 'None' : company['cLevel'],
                                                expiryTimestamp: company['createdAt'],
                                                company: company,
                                                subscription: company['subscription']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "progress-box all-report-progress-box",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "progress-bar",
                                                        style: {
                                                            width: 80,
                                                            height: 80,
                                                            backgroundColor: '#ebeeff',
                                                            borderRadius: '50%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                            className: `${company?.['stats']?.['riskPercent'] > 67 ? 'red' : company?.['stats']?.['riskPercent'] > 33 ? 'orange' : 'green'}`,
                                                            value: company?.['stats']?.['riskPercent'] || 0,
                                                            text: company?.['stats']?.['completionPercent'] ? `${company?.['stats']?.['riskPercent'] || 0}%` : "0%",
                                                            styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                                strokeLinecap: 'butt',
                                                                strokeWidth: '5px',
                                                                textSize: '22px',
                                                                pathTransitionDuration: 0.5,
                                                                trailColor: '#d6d6d6',
                                                                backgroundColor: '#fc7785'
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            marginBottom: '0',
                                                            fontSize: '18px'
                                                        },
                                                        className: "text-center-area",
                                                        children: "Risk"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                modules && Object.values(modules).map((value, idx)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: value?.['heading'] && !value['type'].includes('directors-questionnaire') && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    id: `content-btn-${idx}`,
                                                    value: value['type'],
                                                    className: `${value['type'] == showReport && 'active '} df c6 jcc ttc td250 c3-hover px1rem py0-5rem cp new-report-btn reports-btn-area`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "pen usn ass mr0-5rem tac fs1rem",
                                                        children: [
                                                            company?.['modules']?.[value['type']]?.heading,
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root",
                                                                    focusable: "false",
                                                                    "aria-hidden": "true",
                                                                    viewBox: "0 0 24 24",
                                                                    "data-testid": "ExpandMoreIcon",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                showReport !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        maxHeight: '250px',
                                                        overflow: 'scroll'
                                                    },
                                                    children: value['type'] == showReport && moduleContents(showReport)
                                                })
                                            ]
                                        })
                                    });
                                }),
                                directorModules.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "fs1rem fw600",
                                            children: "Select Director"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("select", {
                                            id: `director-opt`,
                                            placeholder: "Select Director",
                                            className: "df c6 ttc td250 c3-hover px1rem py0-5rem cp new-report-btn",
                                            children: directorModules?.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: item?.type,
                                                    className: "pen usn ass mr0-5rem tal",
                                                    label: `Director-${item?.director?.name}`
                                                }))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const moduleContents = (moduleType)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: (modules[moduleType]?.['type']?.includes('warranty-disclosure') || modules[moduleType]['type']?.includes('directors-questionnaire') || modules[moduleType]['type']?.includes('software-development') || modules[moduleType]['type']?.includes('esg') ? Object.values(modules[moduleType].sections[0].subFolders) : modules[moduleType].sections).filter((s)=>!s.isHidden).map((section, idx)=>{
                let completeness = section.stats.completionPercent;
                let riskColour;
                if (modules[moduleType]?.type === "two-minute-test-growth" || section.stats.riskPercent < 38) riskColour = 7;
                else if (section.stats.riskPercent > 62) riskColour = 9;
                else riskColour = 8;
                let hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                let colorChange = false;
                if (modules?.[moduleType]['type'] == "warranty-disclosure") section?.questions.map((question)=>{
                    if (question['answer']['radioOption'] == 'Disclosure' || question['answer']['radioOption'] == 'Not Sure') {
                        colorChange = true;
                        return;
                    }
                });
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    style: {
                        background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                    },
                    "data-scroll-to": section.sectionNo,
                    className: " df c3 c6 td250 c3-hover px1rem py0-5rem cp new-report-btn",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pen usn ass mr0-5rem tal left-heading",
                            children: section.sectionNo
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pen uss ass fw600 tal right-detail",
                            children: section.sectionName
                        })
                    ]
                }, idx);
            })
        });
    };
    const saveAnswerInput = async (event)=>{
        let answerId = event.target.id.split('_')[1];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            done: true
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
    };
    const saveAnswerTextarea = async (event)=>{
        let answerId = event.target.id.split('_')[1];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            note: event.target.value
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
    };
    const sortQuestions = (a, b)=>{
        let valueA = a.qNo.split('.')[a.qNo.split('.').length - 1];
        let valueB = b.qNo.split('.')[a.qNo.split('.').length - 1];
        return valueA - valueB;
    };
    const getAuditReportContent = (data)=>{
        let array = [];
        if (data?.['type']?.includes("warranty-disclosure") || data?.['type']?.includes("directors-questionnaire") || data?.['type']?.includes("software-development") || data?.['type']?.includes("esg")) {
            if (data?.sections[0]?.subFolders && Object?.values(data?.sections[0]?.subFolders)?.length > 0) array = Object.values(data?.sections[0]?.subFolders)?.filter((s)=>!s.isHidden);
        } else array = data.sections.filter((s)=>!s.isHidden);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: array.length > 0 && array.map((section)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem",
                            id: section['sectionNo'],
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "df jcc aic mb1rem fs1rem",
                                    children: [
                                        section['sectionNo'],
                                        " - ",
                                        section['sectionName'],
                                        " Report \xa0-\xa0",
                                        section.stats.completionPercent && section.stats.completionPercent > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: section.stats.completionPercent < 34 ? "c9" : section.stats.completionPercent < 67 ? 'c8' : 'c7',
                                                    children: [
                                                        "Completed ",
                                                        section.stats.completionPercent || 0,
                                                        "%"
                                                    ]
                                                }),
                                                section.stats.riskPercent > 0 && data['type'] !== "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        "\xa0-\xa0",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: section.stats.riskPercent < 38 ? "c7" : section.stats.riskPercent < 62 ? 'c8' : 'c9',
                                                            children: [
                                                                section.stats.riskPercent || 0,
                                                                "% Risk"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "Not Started"
                                                }),
                                                "\xa0-\xa0",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "No Risk Score"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                section['stats']['completionPercent'] > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `dg gtcr-audit fs0-75rem bg6 c1`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "tac",
                                            children: "Question"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "tac",
                                            children: "Answer"
                                        }),
                                        data['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Files Uploaded"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Notes"
                                                })
                                            ]
                                        }),
                                        data['type'].includes("directors-questionnaire") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Text"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Files Uploaded"
                                                })
                                            ]
                                        }),
                                        (data['type'].includes("business-audit") || data['type'] == "software-development" || data['type'] == "esg") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Risk"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Recommendation"
                                                })
                                            ]
                                        }),
                                        data['type'] == "warranty-disclosure" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Disclosure"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "tac",
                                                    children: "Files Uploaded"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                section['stats']['completionPercent'] == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "df jcc tac fs1rem fw500 c4",
                                    children: "Section Not Started"
                                })
                            ]
                        }),
                        section['stats']['completionPercent'] > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: section?.questions && section?.questions?.slice().sort(sortQuestions).filter((q)=>q.answer).map((question, idx)=>{
                                if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                                let isRisky = question.answer.radioOption === "No";
                                // let addClass = (data['type'].includes("repository") || data['type'].includes("business-audit") || data['type'].includes("warranty-disclosure") || data['type'].includes("software-development") || data['type'].includes("esg")) ? true : false;
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `dg tableRow  fs0-75rem ${data['type'].includes("repository") || data['type'].includes("directors-questionnaire") ? 'gtcr-audit' : 'gtcr-audit-two'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `df fdc aic jcfs pt0-25rem`,
                                                children: question.qDescription
                                            }),
                                            data['type'].includes("directors-questionnaire") ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fdc aic tac jcfs pt1rem",
                                                children: question?.questionType.includes("YN") ? question.answer['radioOption'] || question.answer['status'] : "-"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: `df fdc aic tac jcfs pt1rem`,
                                                children: [
                                                    " ",
                                                    question.answer['radioOption'] || question.answer['status'],
                                                    " "
                                                ]
                                            }),
                                            data['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc aic tac jcfs pt1rem",
                                                        children: question?.answer?.files?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                            children: "File"
                                                                        }),
                                                                        ": ",
                                                                        file['originalname']
                                                                    ]
                                                                }, idx))
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "No Files Uploaded"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc aic tac jcfs pt1rem",
                                                        children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: question['answer']['comment']
                                                        })
                                                    })
                                                ]
                                            }),
                                            data['type'].includes("directors-questionnaire") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc aic tac jcfs pt1rem",
                                                        children: question?.questionType.includes("Date") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: question?.answer && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(question?.answer?.date).format('ll')
                                                            })
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                children: question['answer'] ? question['answer']['comment'] || question['answer']['dropdown'] : '-'
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df fdc aic tac jcfs pt1rem",
                                                        children: question.answer.files.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                            children: "File"
                                                                        }),
                                                                        ": ",
                                                                        file['originalname']
                                                                    ]
                                                                }, idx))
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "-"
                                                        })
                                                    })
                                                ]
                                            }),
                                            data['type'].includes("business-audit") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc tal jcfs pt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df  pb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        question?.['answer']?.['aiResponse']?.['ifriskDescription'] && question?.['answer']?.['aiResponse']?.['ifriskDescription'],
                                                                        question['riskDescription'] && question['riskDescription']
                                                                    ]
                                                                }) : "Well done"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] && question?.['answer']?.['aiResponse']?.['ifrecommendDescription'],
                                                                        question['recommendDescription'] && question['recommendDescription']
                                                                    ]
                                                                }) : "No recommendation at this time"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: question['answer'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc jcc aic",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                        className: " h100 br5px p0-5rem fs0-75rem",
                                                                        id: 'note_' + question['answer']['_id'],
                                                                        name: "note",
                                                                        onChange: saveAnswerTextarea,
                                                                        value: question['answer']['note'],
                                                                        style: {
                                                                            backgroundColor: "transparent",
                                                                            resize: "vertical"
                                                                        },
                                                                        placeholder: "Add note",
                                                                        rows: "1",
                                                                        cols: "50"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: " df jcsa",
                                                                    children: [
                                                                        (question['answer']['done'] || question['answer']['note']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                "Last Edited: ",
                                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now(question?.['answer']?.['updatedAt'] && question?.['answer']?.['updatedAt'])).format('ll')
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "checkobox-report asc pr ml1rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                style: {
                                                                                    width: '25px',
                                                                                    height: '25px'
                                                                                },
                                                                                id: 'done_' + question['answer']['_id'],
                                                                                name: "status",
                                                                                onClick: saveAnswerInput,
                                                                                checked: question['answer']['done'] ? true : false,
                                                                                className: "checkbox bg5 shadow bo5 bw2px bss cp td250 br5px",
                                                                                type: "checkbox",
                                                                                defaultChecked: false
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            (data['type'] == "warranty-disclosure" || data['type'] == "software-development" || data['type'] == "esg") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc tal jcfs pt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df pb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: data['type'] == 'warranty-disclosure' && question['answer']['radioOption'] == 'Disclosure' ? question?.['answer']?.['comment'] && question?.['answer']?.['comment'] : data['type'] == 'warranty-disclosure' ? '-' : question?.answer?.['questionId']?.['recommendDescription'] && question.answer['questionId']['recommendDescription']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: data['type'] == 'warranty-disclosure' ? question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                        href: file['location'],
                                                                        target: "'_blank",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                children: "File"
                                                                            }),
                                                                            ": ",
                                                                            file['originalname']
                                                                        ]
                                                                    }, idx)) : question?.answer?.['questionId']?.['riskDescription'] && question.answer['questionId']['riskDescription']
                                                            })
                                                        ]
                                                    }),
                                                    (data['type'] == "software-development" || data['type'] == "esg") && question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w90 p1rem my0-5rem",
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: [
                                                            "Files: ",
                                                            question['answer']['files'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: "ml0-5rem tdu",
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: file['originalname']
                                                                }))
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: question['answer'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc jcc aic",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                        id: 'note_' + question['answer']['_id'],
                                                                        name: "note",
                                                                        className: " h100 br5px p0-5rem fs0-75rem",
                                                                        type: "checkbox",
                                                                        onChange: saveAnswerTextarea,
                                                                        value: question['answer']['note'],
                                                                        style: {
                                                                            backgroundColor: "transparent",
                                                                            resize: "vertical"
                                                                        },
                                                                        placeholder: "Add note",
                                                                        rows: "1",
                                                                        cols: "50"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: " df jcsa",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                "Last Edited:- ",
                                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now(question?.['answer']?.['updatedAt'] && question?.['answer']?.['updatedAt'])).format('ll')
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "checkobox-report asc pr ml1rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                id: 'done_' + question['answer']['_id'],
                                                                                name: "status",
                                                                                style: {
                                                                                    width: '25px',
                                                                                    height: '25px'
                                                                                },
                                                                                onClick: saveAnswerInput,
                                                                                checked: question['answer']['done'] ? true : false,
                                                                                className: "checkbox bg5 shadow bo5 bw2px bss cp td250 br5px",
                                                                                type: "checkbox",
                                                                                defaultChecked: false
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, idx)
                                });
                            })
                        })
                    ]
                });
            })
        });
    };
    const getTwoMinuteTestContent = (module)=>{
        if (module?.sections) {
            const writeSections = (sections)=>Object.values(sections).filter((s)=>!s?.isHidden).map((section)=>{
                    if (section?.questions) {
                        const questionsAndAnswers = section?.questions?.slice().sort(sortQuestions).filter((q)=>q?.qDescription);
                        if (questionsAndAnswers.length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: questionsAndAnswers.map((question, idx)=>{
                                const { answer: answer } = question;
                                if (!aiEnhanced && Object.values(answer?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            id: section.sectionNo,
                                            className: "usn pen fs1rem fw600 mt-3 tac",
                                            children: [
                                                section.sectionNo,
                                                " - ",
                                                section.sectionName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "question-box  c15",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                        children: [
                                                            "Question: ",
                                                            question['qNo']
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: question['qDescription']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mt1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Answer:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `${question['answer']['radioOption'] == 'Yes' || question['answer']['radioOption'] < 3 ? 'green' : 'red'} c4`,
                                                            children: question['answer']['radioOption'] || 'Not Answered'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "recomended-box",
                                            children: (()=>{
                                                const recommendationKey = [
                                                    "ifYes",
                                                    "ifNo",
                                                    "",
                                                    "if1",
                                                    "if2",
                                                    "if3",
                                                    "if4",
                                                    "if5"
                                                ].find((key)=>key.includes("if" + answer.radioOption));
                                                return recommendationKey && question[recommendationKey] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Recommendation:"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs1rem",
                                                            children: answer?.['aiResponse']?.[recommendationKey] || question[recommendationKey]
                                                        })
                                                    ]
                                                });
                                            })()
                                        })
                                    ]
                                }, idx);
                            })
                        });
                    }
                });
            return writeSections(module?.sections);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "td250 container bg1 py2rem shadow w100 df",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w80 mr1rem dg bg5 py2rem",
                children: company && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                            id: "pdf",
                            className: "op0 pen ma td250 dg gg2rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                            id: "pdfContent",
                            className: "bsbb w0 h0 oh op0 pen db",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    getOverviewContent(),
                                    modules?.[`two-minute-test-${company?.['testType']}`] && showReport == modules[`two-minute-test-${company['testType']}`]['type'] && getTwoMinuteTestContent(modules[`two-minute-test-${company['testType']}`]),
                                    modules?.['repository'] && showReport == modules?.['repository']['type'] && getAuditReportContent(modules?.['repository']),
                                    modules?.[`business-audit-${company?.['testType']}`] && showReport == modules?.[`business-audit-${company?.['testType']}`]['type'] && getAuditReportContent(modules?.[`business-audit-${company?.['testType']}`]),
                                    modules?.['warranty-disclosure'] && showReport == modules?.['warranty-disclosure']['type'] && getAuditReportContent(modules?.['warranty-disclosure']),
                                    modules?.['software-development'] && showReport == modules?.['software-development']['type'] && getAuditReportContent(modules?.['software-development']),
                                    modules?.['esg'] && showReport == modules?.['esg']['type'] && getAuditReportContent(modules?.['esg']),
                                    showReport && showReport?.includes('directors-questionnaire') && getAuditReportContent(modules?.[showReport])
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22cbb003a0ad0275$export$2e2bcd8739ae039), {
                user: user,
                company: company,
                modules: modules,
                tab: tab,
                setTab: setTab,
                showReport: showReport,
                handleContent: handleContent
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");




var $acw62 = parcelRequire("acw62");











































function $5ea756d09d9085bc$export$2e2bcd8739ae039({ profileClass: profileClass, company: company, getCompany: getCompany, handleMemberEdit: handleMemberEdit }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let companyId = location.pathname.split("/").slice(-1)[0];
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    company = {
        ...selectedCompany
    };
    let [cvData, setCvData] = (0, $acw62.useState)({});
    let [director, setDirector] = (0, $acw62.useState)('');
    // OPTIMIZATION: Lazy load directors when not available (excluded in lightweight mode)
    let [directors, setDirectors] = (0, $acw62.useState)(company?.['directors'] || []);
    let [editInput, setEditInput] = (0, $acw62.useState)('');
    let [updateData, setUpdateData] = (0, $acw62.useState)([]);
    let [updateType, setUpdateType] = (0, $acw62.useState)('');
    let [attachment, setAttachment] = (0, $acw62.useState)({});
    let [companiesGroup, setCompaniesGroup] = (0, $acw62.useState)({}); // { companyId: '', group: '', percentage: '' }
    let [filingReadMore, setFilingReadMore] = (0, $acw62.useState)({});
    let [chargeReadMore, setChargeReadMore] = (0, $acw62.useState)({});
    let [controlReadMore, setControlReadMore] = (0, $acw62.useState)({});
    let [officersReadMore, setOfficersReadMore] = (0, $acw62.useState)({});
    let [auditLogList, setAuditLogList] = (0, $acw62.useState)([]);
    let [permissionLogList, setPermissionLogList] = (0, $acw62.useState)([]);
    let [tabIndex, setTabIndex] = (0, $acw62.useState)('Companies House Core Info');
    let [tabCompanySnapshot, setTabCompanySnapshot] = (0, $acw62.useState)('Filing History');
    let [selectAll, setSelectAll] = (0, $acw62.useState)(false);
    let [editUser, setEditUser] = (0, $acw62.useState)({});
    const [userAction, setUserAction] = (0, $acw62.useState)('Search');
    const [filingCurrentPage, setFilingCurrentPage] = (0, $acw62.useState)(0);
    const [officersCurrentPage, setOfficersCurrentPage] = (0, $acw62.useState)(0);
    const [personsCurrentPage, setPersonsCurrentPage] = (0, $acw62.useState)(0);
    const [chargesCurrentPage, setChargesCurrentPage] = (0, $acw62.useState)(0);
    const [registersCurrentPage, setRegistersCurrentPage] = (0, $acw62.useState)(0);
    let [formData, setFormData] = (0, $acw62.useState)({
        linkedIn: '',
        companyId: '',
        directorId: ''
    });
    let permissionNames = {
        D002: "Commercial Activities",
        D003: "Legal",
        D004: "Property",
        D005: "Intellectual Property",
        D006: "Insurance",
        D007: "Corporate Structure",
        D008: "State Aid",
        D009: "Finance",
        D010: "GDPR",
        D011: "Shares & Share Options",
        D012: "Taxation",
        D013: "Social Media",
        D014: "Key People",
        D015: "Human Resources",
        D016: "ESG",
        D017: "Key Advisors",
        D018: "It Systems",
        D019: "Regulatory",
        D020: "Standards",
        DEPF005: "Environmental, Social, Governmental",
        DEPF006: "Warranty Disclosure",
        DEPF007: "Directors  Questionnaire",
        DEPF004: "Software Development"
    };
    let companyKeys = {
        fiveWords: 'Description',
        companyDescription: 'Detail Box',
        vatRegCode: 'VAT Code',
        ukUTRCode: 'UTR Code',
        cAddress: 'Address Line',
        cPostalCod: 'Postal Code',
        cCountry: 'Country',
        cWebsite: 'Website Url',
        cLinkedin: 'LinkedIn Url',
        cFacebook: 'Facebook Url',
        cInstagram: 'Instgram Url'
    };
    // Fetch directors if not available (excluded in lightweight mode)
    (0, $acw62.useEffect)(()=>{
        const fetchDirectors = async ()=>{
            if (company?.['directorsCount'] !== undefined && !company?.['directors']) try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/directors`);
                if (response['code'] === 200 && response['body']) setDirectors(response['body']['directors'] || []);
            } catch (e) {
                console.error('Failed to fetch directors:', e);
            }
            else if (company?.['directors']) setDirectors(company['directors']);
        };
        fetchDirectors();
    }, [
        company?._id,
        company?.['directors'],
        company?.['directorsCount']
    ]);
    let [ragFiles, setRagFiles] = (0, $acw62.useState)([]);
    let [ragFileToDelete, setRagFileToDelete] = (0, $acw62.useState)(null);
    let [ragFileSearch, setRagFileSearch] = (0, $acw62.useState)('');
    let [ragStatusFilter, setRagStatusFilter] = (0, $acw62.useState)('All');
    let [ragModuleFilter, setRagModuleFilter] = (0, $acw62.useState)('All');
    let [ragFilesPage, setRagFilesPage] = (0, $acw62.useState)(1);
    let [ragFilesPerPage, setRagFilesPerPage] = (0, $acw62.useState)(10);
    let [selectedRagFiles, setSelectedRagFiles] = (0, $acw62.useState)([]);
    let [ragFileProcessing, setRagFileProcessing] = (0, $acw62.useState)(null); // fileUrl of file being indexed/unindexed
    let [ragBulkProcessing, setRagBulkProcessing] = (0, $acw62.useState)(null); // 'index' | 'unindex' | 'delete' | null
    const handleUserChange = (e)=>setEditUser({
            ...editUser,
            [e.target.name]: e.target.type === "radio" ? e.target.id : e.target.value
        });
    const changeUser = (e)=>{
        const updatedPermissions = {
            ...editUser.permissions,
            [e.target.name]: e.target.checked
        };
        setEditUser({
            ...editUser,
            permissions: updatedPermissions
        });
    };
    function hasAllPermissions(companySections, userPermission) {
        return companySections.every((section)=>userPermission[section.sectionNo]);
    }
    (0, $acw62.useEffect)(()=>{
        if (editUser && editUser?.permissions && company && company['memberPermissions']) setSelectAll(hasAllPermissions(company?.['sections'], editUser?.permissions));
    }, [
        editUser,
        company
    ]);
    const findUser = async ()=>{
        let email = document.getElementById('searchEmail').value;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/findUser`, {
            email: email,
            companyId: companyId
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (!res || res['code'] != 200) return;
        if (res['body']['found']) {
            setUserAction('Add');
            setEditUser(res['body']['user']);
        } else {
            editUser['email'] = document.getElementById('searchEmail').value;
            setEditUser(editUser);
            setUserAction('New');
        }
    };
    const saveUser = async ()=>{
        const permissions = editUser.permissions || {};
        const email = document.getElementById("userEmail").value;
        const lastName = document.getElementById("userLastName").value;
        const firstName = document.getElementById("userFirstName").value;
        const designation = document.getElementById("designation").value;
        let res = '';
        if (userAction == 'Edit') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/editMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        else if (userAction == 'New') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/newMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/addMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        if (!res || res['code'] != 200) return;
        if (getCompany) getCompany();
        else fetchCompany();
        setEditUser({});
        setUserAction('Search');
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        setSelectAll(false);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const selectAllPermissions = (event)=>{
        const isChecked = event.target.checked;
        setSelectAll(isChecked);
        let permissions = {};
        company?.['sections']?.forEach((section)=>{
            if (section.sectionNo.trim() !== "") permissions[section.sectionNo] = isChecked;
        });
        setEditUser({
            ...editUser,
            permissions: permissions
        });
    };
    (0, $acw62.useEffect)(()=>{
        // getCompanies();
        let isCompanySettings = localStorage.getItem("isCompanySettings");
        if (isCompanySettings == null) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'companySettings'
            }));
            localStorage.setItem('isCompanySettings', true);
        }
    }, []);
    const fetchCompany = async ()=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}?lightweight=false`);
            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(res['body']));
        } catch (error) {
            console.error("Error fetching company data:", error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchCompany();
    }, [
        companyId
    ]);
    (0, $acw62.useEffect)(()=>{
        setFormData((prevFormData)=>({
                ...prevFormData,
                companyId: companyId
            }));
    }, [
        companyId
    ]);
    (0, $acw62.useEffect)(()=>{
        setFormData((prevFormData)=>({
                ...prevFormData,
                directorId: director
            }));
    }, [
        director
    ]);
    // Fetch RAG files when tab changes to RAG Files
    (0, $acw62.useEffect)(()=>{
        if (tabIndex === 'Knowledge Base') fetchRagFiles();
    }, [
        tabIndex
    ]);
    const fetchRagFiles = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/clarence/rag-files/${companyId}`);
        if (res?.code === 200) setRagFiles(res.body.files || []);
    };
    const getCompanies = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/my-profile`);
        if (response['body']) {
            let { user: user, companies: companies } = response['body'];
            let groups = companies.filter(({ group: group })=>group == 'Parent');
            let standard = companies.filter(({ group: group })=>group != 'Parent');
            companies = groups.concat(standard);
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
            dispatch((0, $b9bcf9787e5ad456$export$2102c8f11f9a72ed)(companies));
        }
    };
    const saveAnswer = async (e)=>{
        updateData = {
            ...updateData,
            [e.target.name]: e.target.value
        };
        await setUpdateData(updateData);
        dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
            ...company,
            [e.target.name]: e.target.value
        }));
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/update/${companyId}`, {
            update: updateData,
            companyId: companyId
        });
        if (res || res['code'] == 200) setEditInput('');
    };
    const submitDeleteCompany = async (e)=>{
        let requestBody = {
            companyId: companyId,
            companyName: company?.['cName'],
            creatorId: company?.['creatorId']?.['_id'],
            creatorEmail: company?.['creatorId']?.['email'],
            creatorName: `${company?.['creatorId']?.['firstName']} ${company?.['creatorId']?.['lastName']}`
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/delete`, requestBody);
        if (res['code'] == 200) {
            window.location.href = user?.['role'] == 'Advisor' || user?.['role'] == 'Investor' ? `/${user?.['role']?.toLowerCase()}-dashboard` : (0, $16250bd714b02a14$export$4695c1a423ffe431);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        }
    };
    const btnPrev = async (id)=>{
        let box = await document.querySelector(id);
        let width = await box.clientWidth;
        box.scrollLeft = box.scrollLeft - width;
    };
    const btnNext = async (id)=>{
        let box = await document.querySelector(id);
        let width = await box.clientWidth;
        box.scrollLeft = box.scrollLeft + width;
    };
    const getAuditLogs = async (endpoint)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', {
            endpoint: endpoint,
            companyId: companyId
        });
        if (res || res['code'] == 200) {
            await setAuditLogList(res['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'auditLogs'
            }));
        }
    };
    const auditLogButton = (path)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            onClick: ()=>getAuditLogs(path),
            className: "cp df jcc px2rem py0-5rem bg5 fs0-75rem fw500 br30px bw1px bo16 bss",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "bg5 mr1rem w20px h20px df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "36",
                        height: "36",
                        viewBox: "0 0 36 36",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                            fill: "#4A67FF"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c15",
                    children: "Audit Log"
                })
            ]
        });
    };
    const companyAuditLogButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'companyAuditLog'
                })),
            className: "cp df jcc px2rem py0-5rem bg5 fs0-75rem fw500 br30px bw1px bo16 bss",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "bg5 mr1rem w20px h20px df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "36",
                        height: "36",
                        viewBox: "0 0 36 36",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                            fill: "#4A67FF"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c15",
                    children: "Audit Log"
                })
            ]
        });
    };
    // Delete Company Handler
    const handleDeleteCompany = ()=>{
        if (company?.childrenCompanies) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'warningDeleteCompany'
        }));
        else if (company?.isParent && companies?.length > 1) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'warningDeleteCompany'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'companyDelete'
        }));
    };
    const getSidebarHTML = ()=>{
        const tabs = [
            "Companies House Core Info",
            "Group Info",
            "Company Profile",
            "Director's Info",
            "Direct/Indirect Channel",
            "Company Stage Of Development",
            "Company Objectives",
            "Subscription Model Info",
            "User Permissions",
            "Advisor Permissions",
            "Knowledge Base",
            "Delete Company"
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            id: "sidebar-company-settings",
            style: {
                width: "calc((100% - 4rem) / 5)"
            },
            className: "sidebar-company-settings w100 bsbb dg gg1rem br5px bg0 ps t0 sidebar-report",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg5 br10px py0-5rem mt3rem bw1px bo16 bss",
                style: {
                    backgroundColor: '#F0F2FD50',
                    borderColor: '#7385BE650'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc aic fdc p0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac",
                                children: "Company Settings"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac",
                                children: "Index"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/company/${companyId}`,
                                className: "c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px3rem py0-5rem df aic jcc mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon mr0-5rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "15",
                                            height: "15",
                                            viewBox: "0 0 21 21",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z",
                                                    fill: "white",
                                                    stroke: "white",
                                                    strokeWidth: "0.5"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z",
                                                    fill: "white",
                                                    stroke: "white",
                                                    strokeWidth: "0.5"
                                                })
                                            ]
                                        })
                                    }),
                                    "Back"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah100 mya oya df fdc jcsb mt2-5rem",
                        children: [
                            tabs.map((tab, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>{
                                        setTabIndex(tab);
                                        setUpdateData([]);
                                    },
                                    className: `bg5 cp w100 df c2 px1rem py0-75rem ${tab == tabIndex && 'c3'}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-75rem tal",
                                        children: tab
                                    })
                                }, idx);
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                className: "my0-5rem c16"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleDeleteCompany(),
                                className: `bg5 cp delete-active w100 df px1rem py0-5rem`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs0-75rem tal",
                                    children: "Delete Company"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    //********** Companies House Core **********//
    const companiesHouseCore = ()=>{
        const tabs = [
            "Filing History",
            "Officers",
            "Persons with significant control",
            "Charges",
            "Registers"
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb aic mb1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1-5rem fw500 c14",
                                children: "COMPANY INFORMATION"
                            }),
                            auditLogButton(`/company/update/${companyId}`)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "p1-5rem c15 fs0-75rem bw1px bo16 br20px bss mb2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Status: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company?.['cStatus'] ? company?.['cStatus'] : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Number: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company?.['ukRegNo'] ? company?.['ukRegNo'] : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Title: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company?.['cName'] ? company?.['cName'] : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Date of Creation: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company?.['doIncorporation'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['doIncorporation']).format('YYYY-MM-DD') : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Address: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company?.['cAddress'] ? company?.['cAddress'] : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Accounts: ",
                                                company?.['cAccounts'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                            children: [
                                                                "Next Accounts Made Up To ",
                                                                company?.['cAccounts']?.['next_made_up_to']
                                                            ]
                                                        }),
                                                        " Due By ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: company?.['cAccounts']?.['next_due']
                                                        }),
                                                        ", Last Accounts Made Up To ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: company?.['cAccounts']?.['last_accounts']?.['made_up_to']
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Confirmation Statement: ",
                                                company?.['cStatements'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                            children: [
                                                                "Next Statement Made Up To ",
                                                                company?.['cStatements']?.['next_made_up_to']
                                                            ]
                                                        }),
                                                        " Due By ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: company?.['cStatements']?.['next_due']
                                                        }),
                                                        ", Last Statement Made Up To ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: company?.['cStatements']?.['last_made_up_to']
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "-"
                                                })
                                            ]
                                        }),
                                        company?.['ukRegNo'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: `https://find-and-update.company-information.service.gov.uk/company/${company?.['ukRegNo']}`,
                                                    target: "_blank",
                                                    className: "df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem mr1rem fs0-75rem fw500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("jNDOY")),
                                                            className: "mr0-5rem"
                                                        }),
                                                        "Companies House - Direct"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: `https://find-and-update.company-information.service.gov.uk/company/${company?.['ukRegNo']}/more`,
                                                    target: "_blank",
                                                    className: "df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem fs0-75rem fw500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("jNDOY")),
                                                            className: "mr0-5rem"
                                                        }),
                                                        "View Snapshot"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("1SlVW"))
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1-5rem fw500 c14 mb1rem",
                                children: "COMPANY SNAPSHOT"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "p1-5rem bw1px bo16 br20px bss",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc",
                                        children: tabs.map((tab, idx)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setTabCompanySnapshot(tab),
                                                className: `cp py0-5rem px1rem bg1 fs1rem ${tab == tabCompanySnapshot ? ' c3 fw600' : 'c12 fw400'}`,
                                                style: {
                                                    borderBottom: tab == tabCompanySnapshot && '2px solid #6366f1'
                                                },
                                                children: tab
                                            }, idx);
                                        })
                                    }),
                                    tabCompanySnapshot == "Filing History" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: filingHistoryTab()
                                    }) : tabCompanySnapshot == "Officers" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: officersTab()
                                    }) : tabCompanySnapshot == "Persons with significant control" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: personsSignificantTab()
                                    }) : tabCompanySnapshot == "Charges" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: chargesTab()
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: registersTab()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb2rem p1-5rem bw1px bo16 br20px bss",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcsb",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-125rem fw600 c14 mb1rem",
                                    children: "HMRC"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "vatRegCode",
                                        name: "vatRegCode",
                                        onBlur: saveAnswer,
                                        defaultValue: company?.['vatRegCode'],
                                        placeholder: "Please add VAT reg number",
                                        className: "w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "ukUTRCode",
                                        name: "ukUTRCode",
                                        onBlur: saveAnswer,
                                        defaultValue: company?.['ukUTRCode'],
                                        placeholder: "Please add UTR number",
                                        className: "w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    const filingHistoryTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cFiling'] ? Math.ceil(company['cFiling'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (filingCurrentPage < totalPages - 1) setFilingCurrentPage(filingCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (filingCurrentPage > 0) setFilingCurrentPage(filingCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cFiling']) return [];
            let startIndex = filingCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cFiling'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "FILING HISTORY"
                }),
                company['cFiling'] && company['cFiling'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((history, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Category: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['category'] ? history['category'] : 'Officers'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "File name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['description'] || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Bar Code: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['barcode'] || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Transaction ID: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['transaction_id'] || '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Date: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['date'] || '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        history?.['Location'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            href: history['Location'],
                                            target: "_blank",
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "View Document"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${filingCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: filingCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${filingCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: filingCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const officersTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cOfficers'] ? Math.ceil(company['cOfficers'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (officersCurrentPage < totalPages - 1) setOfficersCurrentPage(officersCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (officersCurrentPage > 0) setOfficersCurrentPage(officersCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cOfficers']) return [];
            let startIndex = officersCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cOfficers'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "OFFICERS"
                }),
                company['cOfficers'] && company['cOfficers'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Role: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['officer_role'] ? data['officer_role'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "w70",
                                                        src: (parcelRequire("kBFDN")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['name'] ? data['name'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Appointed On: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['appointed_on'] ? data['appointed_on'] : '-'
                                                        })
                                                    ]
                                                }),
                                                data['appointment'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        data['appointment']['type'],
                                                        " Filing: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: data['appointment']['Location'],
                                                            target: "_blank",
                                                            className: "c3 fw600",
                                                            children: "View Document"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Address: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['address'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    data['address']['premises'] && data['address']['premises'],
                                                                    data['address']['address_line_1'] && ', ' + data['address']['address_line_1'],
                                                                    data['address']['address_line_2'] && ', ' + data['address']['address_line_2'],
                                                                    data['address']['locality'] && ' - ' + data['address']['locality'],
                                                                    data['address']['region'] && ', ' + data['address']['region'],
                                                                    data['address']['country'] && ', ' + data['address']['country']
                                                                ]
                                                            }) : '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>{
                                                setOfficersReadMore(data);
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'officersReadMore'
                                                }));
                                            },
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${officersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: officersCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${officersCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: officersCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const personsSignificantTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cSignificantControl'] ? Math.ceil(company['cSignificantControl'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (personsCurrentPage < totalPages - 1) setPersonsCurrentPage(personsCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (personsCurrentPage > 0) setPersonsCurrentPage(personsCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cSignificantControl']) return [];
            let startIndex = personsCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cSignificantControl'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "PERSONS WITH SIGNIFICANT CONTROL"
                }),
                company['cSignificantControl'] && company['cSignificantControl'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Significant Control"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['name'] ? data['name'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "mb0-5rem",
                                                    children: "Controls:"
                                                }),
                                                data['natures_of_control'] && data['natures_of_control'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    className: "ml1-5rem mb0-5rem",
                                                    children: data['natures_of_control'].map((control, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            className: "fw600",
                                                            children: control
                                                        }, idx))
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600",
                                                    children: "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>{
                                                setControlReadMore(data);
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'controlReadMore'
                                                }));
                                            },
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${personsCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: personsCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${personsCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: personsCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const chargesTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cCharges'] ? Math.ceil(company['cCharges'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (chargesCurrentPage < totalPages - 1) setChargesCurrentPage(chargesCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (chargesCurrentPage > 0) setChargesCurrentPage(chargesCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cCharges']) return [];
            let startIndex = chargesCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cCharges'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "CHARGES"
                }),
                company['cCharges'] && company['cCharges'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Status: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['status'] ? data['status'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Persons Entitled: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['persons_entitled'] ? data['persons_entitled'][0]['name'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Charge Description: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['classification']['description'] ? data['classification']['description'] : '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>{
                                                setChargeReadMore(data);
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'chargeReadMore'
                                                }));
                                            },
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${chargesCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: chargesCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${chargesCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: chargesCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const registersTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cRegisters'] ? Math.ceil(company['cRegisters'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (registersCurrentPage < totalPages - 1) setRegistersCurrentPage(registersCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (registersCurrentPage > 0) setRegistersCurrentPage(registersCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cRegisters']) return [];
            let startIndex = registersCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cRegisters'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "REGISTERS"
                }),
                company['cRegisters'] && company['cRegisters'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Register"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: "DE ROOS, Peter Wouter"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Occupation: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: "Occupation:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Address: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: "Lidl House, 14 , Kingston Road - Surbiton"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${registersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: registersCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${registersCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: registersCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    //********** Group Info **********// 
    const groupInfo = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr1rem ml1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb mb2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem c15",
                            children: company?.['cName']
                        }),
                        auditLogButton(`/company/updateChild`)
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcfe mb1rem",
                    children: company?.['group'] == 'Parent' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df mr2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                onClick: ()=>{
                                    setUpdateType('Add');
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'addGroupCompany'
                                    }));
                                },
                                className: `${companies.length == 0 && 'op20 pen '} bg3 bg4-hover c1 br20px py0-5rem px1rem fw600 cp mr1rem df jcc aic`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        class: "fa fa-plus mr0-5rem",
                                        "aria-hidden": "true"
                                    }),
                                    " ADD"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                onClick: ()=>{
                                    setUpdateType('Edit');
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'updateGroupCompany'
                                    }));
                                },
                                className: "bg3 bg4-hover c1 br20px py0-5rem px1rem fw600 cp mr1rem df jcc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        class: "fa fa-edit mr0-5rem"
                                    }),
                                    " EDIT"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                onClick: ()=>{
                                    setUpdateType('Delete');
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'updateGroupCompany'
                                    }));
                                },
                                className: "bg4 c1 br20px py0-5rem px1rem fw600 cp mr1rem df jcc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        class: "fa fa-trash-o mr0-5rem"
                                    }),
                                    " DELETE"
                                ]
                            })
                        ]
                    })
                }),
                company?.['parentId'] && company?.['parentCompany'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dropdown-company-dahboard",
                    children: [
                        showCompanyDetails(company?.['parentCompany']),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dropdown-content",
                            style: {
                                display: "block",
                                top: '0px'
                            },
                            children: showCompanyDetails(company)
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dropdown-company-dahboard",
                    children: [
                        showCompanyDetails(company),
                        company?.['childrenCompanies'] && company?.['childrenCompanies'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dropdown-content",
                                style: {
                                    display: "block",
                                    top: '0px'
                                },
                                children: company?.['childrenCompanies'] && company?.['childrenCompanies'].map((childrenCompany, idx)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: showCompanyDetails(childrenCompany)
                                    });
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    const showCompanyDetails = (company)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "dg gtcr6-md gg1rem p1rem bw1px bo16 bss br20px bg1 fs1rem mb1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcse",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "fs1rem c15 w10rem",
                            children: company?.['cName']
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "ml1rem",
                            children: company?.['subscription'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "fs1rem c7 mra tal",
                                children: company?.['subscription']?.toUpperCase()
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "fs1rem c8 mra tal",
                                children: "INACTIVE"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcse",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "df username-area ml1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc mr1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ass mb0-5rem fs0-75rem",
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'userDetail'
                                            })),
                                        "data-tooltip": company?.['group'] && company?.['group'] !== "Standard" ? company?.['group'] : 'No group',
                                        className: "w2rem h2rem df jcc aic fs0-75rem p0-5rem br100 bg4 c1",
                                        children: company?.['group'] && company?.['group'] !== "Standard" ? company?.['group'][0] : 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "df username-area",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ass mb0-5rem fs0-75rem",
                                        children: "Owner"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'userDetail'
                                            })),
                                        "data-tooltip": user.firstName ? user.firstName + " " + user.lastName : "Register to show your name here",
                                        className: "w2rem h2rem df jcc aic fs0-75rem p0-5rem br100 bg3 c1 mr0-5rem",
                                        children: user.firstName ? user.firstName[0] + user.lastName[0] : "?"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: (0, $16250bd714b02a14$export$240514314008da16).replace(":id", company?.['_id']),
                    className: `${!company.subscription && 'op20 pen '} tac c1 bg3 br20px px0-25rem py0-5rem fs0-75rem fw500`,
                    children: "Dashboard"
                }),
                company?.['subscription'] && company['subscription'] != 'Pro' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: (0, $16250bd714b02a14$export$3623221f872af69b).replace(":id", company?.['_id']),
                    className: `${user['email'] == 'temp' && 'op20 pen '} tac c1 bg3 br20px px1rem py0-5rem fw500 fs0-75rem`,
                    children: "Upgrade"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    "data-testid": "subscribeNow",
                    to: (0, $16250bd714b02a14$export$3623221f872af69b).replace(":id", company?.['_id']),
                    className: "tac c1 bg3 br20px px1rem py0-5rem fw500 fs0-75rem",
                    children: "Subscribe Now"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "progress-area progress-dashboard",
                    style: {
                        display: 'flex',
                        position: 'relative',
                        justifyContent: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: 50,
                                        height: 50
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${company.stats.completionPercent > 67 ? 'green' : company.stats.completionPercent > 33 ? 'orange' : 'red'}`,
                                        value: company.stats.completionPercent || 0,
                                        text: (company.stats.completionPercent || 0) + "%",
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: 'round',
                                            strokeWidth: '5px',
                                            textSize: '20px',
                                            pathTransitionDuration: 0.5,
                                            trailColor: '#d6d6d6',
                                            backgroundColor: '#fc7785',
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        marginBottom: '0',
                                        fontSize: '11px'
                                    },
                                    className: "text-center-area",
                                    children: "Completeness"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "progress-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: 50,
                                        height: 50
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${company.stats.riskPercent > 67 ? 'red' : company.stats.riskPercent > 33 ? 'orange' : 'green'}`,
                                        value: company.stats.riskPercent || 0,
                                        text: company.stats.completionPercent ? `${company.stats.riskPercent || 0}%` : "0%",
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: 'butt',
                                            strokeWidth: '5px',
                                            textSize: '20px',
                                            pathTransitionDuration: 0.5,
                                            trailColor: '#d6d6d6',
                                            backgroundColor: '#fc7785',
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        marginBottom: '0',
                                        fontSize: '11px'
                                    },
                                    className: "text-center-area",
                                    children: "Risk"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "certificate-area-dashboard df jcc",
                    children: company?.['cLevel'] && (company?.['subscription'] == "Pro" || company?.['subscription'] == "Pro Plus") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54119cc183dc6bdf$export$2e2bcd8739ae039), {
                        className: 'op70',
                        component: "CompanySettings",
                        level: company?.['subscription'] == "Lite" ? 'None' : company?.['cLevel'],
                        expiryTimestamp: company?.['createdAt'],
                        company: company,
                        subscription: company?.['subscription']
                    })
                })
            ]
        });
    };
    const handleChildCompany = async (el)=>{
        if (!companiesGroup[el['companyId']]) companiesGroup[el['companyId']] = {
            companyId: el['companyId']
        };
        if (el['selected']) companiesGroup[el['companyId']]['selected'] = el['selected'];
        if (el['group']) {
            document.getElementById(`group-${el['companyId']}`).value = el['group'];
            companiesGroup[el['companyId']]['group'] = el['group'];
        }
        if (el['percentage']) {
            document.getElementById(`percentage-${el['companyId']}`).value = el['percentage'];
            companiesGroup[el['companyId']]['percentage'] = el['percentage'];
        }
        if (el['event']?.['target']?.['checked'] == false) delete companiesGroup[el['companyId']];
        setCompaniesGroup(companiesGroup);
    };
    const updateGroupCompany = async ()=>{
        let childUpdates = await Object.values(companiesGroup).filter((company)=>{
            if (updateType == "Delete") company['group'] = 'Standard';
            if (!company['group'] && updateType == "Add") company['group'] = 'Subsidiary';
            if (!company['percentage'] && updateType == "Add") company['percentage'] = '0';
            if (company['selected'] == 'true') return company;
        });
        let data = {
            parentId: company['_id'],
            childUpdates: childUpdates,
            type: updateType
        };
        if (data) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateChild`, {
                data: data,
                companyId: companyId
            });
            if (res || res['code'] == 200) {
                if (getCompany) getCompany();
                else fetchCompany();
                getCompanies();
                setCompaniesGroup({});
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            }
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Company is not identified");
    };
    //********** Company Profile **********//
    const companyProfile = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w80 mx1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb aic mb1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c14 fs1-5rem fw500 ttu",
                            children: company?.['cName']
                        }),
                        auditLogButton(`/company/update/${companyId}`)
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "fs1rem fw400 c15 mb0-5rem",
                    children: "Address"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                style: {
                                    position: 'absolute',
                                    left: '10px',
                                    top: '30%'
                                },
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 0C5.40545 0 2.48108 2.92437 2.48108 6.51888C2.48108 10.9798 8.31487 17.5287 8.56325 17.8053C8.79655 18.0651 9.20387 18.0647 9.43674 17.8053C9.68512 17.5287 15.5189 10.9798 15.5189 6.51888C15.5188 2.92437 12.5945 0 9 0ZM9 16.5139C7.03663 14.1817 3.65502 9.5805 3.65502 6.51895C3.65502 3.57166 6.05274 1.17394 9 1.17394C11.9473 1.17394 14.345 3.57166 14.345 6.51892C14.3449 9.58061 10.9639 14.181 9 16.5139Z",
                                        fill: "#505050"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 3.23926C7.19149 3.23926 5.7202 4.71058 5.7202 6.51909C5.7202 8.3276 7.19152 9.79892 9 9.79892C10.8085 9.79892 12.2798 8.3276 12.2798 6.51909C12.2798 4.71058 10.8085 3.23926 9 3.23926ZM9 8.62498C7.83879 8.62498 6.89414 7.6803 6.89414 6.51909C6.89414 5.35788 7.83882 4.4132 9 4.4132C10.1612 4.4132 11.1059 5.35788 11.1059 6.51909C11.1059 7.6803 10.1612 8.62498 9 8.62498Z",
                                        fill: "#505050"
                                    })
                                ]
                            }),
                            editInput == 'cAddress' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                onBlur: (event)=>{
                                    saveAnswer(event), setEditInput(null);
                                },
                                defaultValue: company?.['cAddress'],
                                name: "cAddress",
                                type: "text",
                                placeholder: "Address Line",
                                className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                readOnly: true,
                                value: company?.['cAddress'] || '',
                                placeholder: "Address Line",
                                onFocus: ()=>setEditInput('cAddress'),
                                className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M6.75 3C7.16421 3 7.5 3.33579 7.5 3.75V6H10.5V3.75C10.5 3.33579 10.8358 3 11.25 3C11.6642 3 12 3.33579 12 3.75V6H14.25C14.6642 6 15 6.33579 15 6.75C15 7.16421 14.6642 7.5 14.25 7.5H12V10.5H14.25C14.6642 10.5 15 10.8358 15 11.25C15 11.6642 14.6642 12 14.25 12H12V14.25C12 14.6642 11.6642 15 11.25 15C10.8358 15 10.5 14.6642 10.5 14.25V12H7.5V14.25C7.5 14.6642 7.16421 15 6.75 15C6.33579 15 6 14.6642 6 14.25V12H3.75C3.33579 12 3 11.6642 3 11.25C3 10.8358 3.33579 10.5 3.75 10.5H6V7.5H3.75C3.33579 7.5 3 7.16421 3 6.75C3 6.33579 3.33579 6 3.75 6H6V3.75C6 3.33579 6.33579 3 6.75 3ZM10.5 10.5V7.5H7.5V10.5H10.5Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cPostalCode' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company?.['cPostalCode'],
                                    name: "cPostalCode",
                                    type: "text",
                                    placeholder: "Postal Code",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company?.['cPostalCode'] || '',
                                    placeholder: "Postal Code",
                                    onFocus: ()=>setEditInput('cPostalCode'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15.3775 1.60232C15.179 1.48669 14.8423 1.32778 14.3885 1.17257C12.5943 0.558914 10.6085 0.558914 8.65143 1.58632C7.10195 2.39934 5.53205 2.39934 4.09686 1.9087C3.96647 1.86413 3.85052 1.82007 3.75001 1.77877V0.749988C3.75001 0.335777 3.4142 0 2.99999 0C2.58578 0 2.25 0.335777 2.25 0.749988V2.25035V9.76384V17.25C2.25 17.6642 2.58578 18 2.99999 18C3.4142 18 3.74998 17.6642 3.74998 17.25V10.8872C5.50758 11.454 7.44152 11.4286 9.34847 10.428C10.8981 9.61492 12.468 9.61492 13.9032 10.1056C14.2567 10.2264 14.5051 10.3436 14.6226 10.412C15.1226 10.7031 15.75 10.3425 15.75 9.76388V2.25039C15.75 1.98348 15.6081 1.73668 15.3775 1.60232ZM14.25 8.64025C12.4924 8.07353 10.5584 8.09919 8.6515 9.09977C7.10191 9.91287 5.53201 9.91287 4.09679 9.42223C3.96647 9.37768 3.85042 9.33363 3.74994 9.29232V3.37402C5.50751 3.94073 7.44152 3.91507 9.34843 2.91449C10.8981 2.10101 12.4679 2.10101 13.903 2.59182C14.0334 2.6364 14.1495 2.68049 14.25 2.72183V8.64025H14.25Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cCountry' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company?.['cCountry'],
                                    name: "cCountry",
                                    type: "text",
                                    placeholder: "Country",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company?.['cCountry'] || '',
                                    placeholder: "Country",
                                    onFocus: ()=>setEditInput('cCountry'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                    className: "fs1rem fw400 c15 mb0-5rem",
                    children: [
                        "Overview ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fs0-75rem fw300 c12 fsi",
                            children: "(200 words generated by AI)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb1-5rem",
                    children: editInput == 'companyDescription' ? /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        rows: 15,
                        onBlur: (event)=>{
                            saveAnswer(event), setEditInput(null);
                        },
                        defaultValue: company?.['companyDescription'] || '',
                        name: "companyDescription",
                        className: "w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem",
                        placeholder: "Overview..."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: ()=>setEditInput('companyDescription'),
                        className: "w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem cp",
                        children: company?.['companyDescription'] || ''
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "fs1rem fw400 c15 mb0-5rem",
                    children: "Web & Socials"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 1.125C7.44248 1.125 5.91992 1.58686 4.62489 2.45218C3.32985 3.31749 2.32049 4.5474 1.72445 5.98637C1.12841 7.42534 0.972461 9.00874 1.27632 10.5363C1.58018 12.0639 2.3302 13.4671 3.43154 14.5685C4.53288 15.6698 5.93607 16.4198 7.46367 16.7237C8.99127 17.0275 10.5747 16.8716 12.0136 16.2756C13.4526 15.6795 14.6825 14.6702 15.5478 13.3751C16.4131 12.0801 16.875 10.5575 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125ZM9 15.75C8.29688 15.75 7.38 14.3044 6.96938 11.8125H11.0306C10.62 14.3044 9.70313 15.75 9 15.75ZM6.82875 10.6875C6.77813 10.1587 6.75 9.59625 6.75 9C6.75 8.40375 6.77813 7.84125 6.82875 7.3125H11.1713C11.2219 7.84125 11.25 8.40375 11.25 9C11.25 9.59625 11.2219 10.1587 11.1713 10.6875H6.82875ZM2.25 9C2.25358 8.43063 2.32726 7.86386 2.46938 7.3125H5.70375C5.65313 7.875 5.625 8.4375 5.625 9C5.625 9.5625 5.65313 10.125 5.70375 10.6875H2.46938C2.32726 10.1361 2.25358 9.56937 2.25 9ZM9 2.25C9.70313 2.25 10.62 3.69563 11.0306 6.1875H6.96938C7.38 3.69563 8.29688 2.25 9 2.25ZM12.2963 7.3125H15.5306C15.8232 8.41848 15.8232 9.58152 15.5306 10.6875H12.2963C12.375 10.125 12.375 9.5625 12.375 9C12.375 8.4375 12.375 7.875 12.2963 7.3125ZM15.1088 6.1875H12.1613C11.9947 4.91356 11.5983 3.68044 10.9913 2.54813C11.8964 2.83223 12.732 3.30288 13.4441 3.92972C14.1562 4.55657 14.729 5.32569 15.1256 6.1875H15.1088ZM7.00875 2.54813C6.40171 3.68044 6.00528 4.91356 5.83875 6.1875H2.87438C3.271 5.32569 3.84382 4.55657 4.55593 3.92972C5.26803 3.30288 6.1036 2.83223 7.00875 2.54813ZM2.87438 11.8125H5.83875C6.00528 13.0864 6.40171 14.3196 7.00875 15.4519C6.1036 15.1678 5.26803 14.6971 4.55593 14.0703C3.84382 13.4434 3.271 12.6743 2.87438 11.8125ZM10.9913 15.4519C11.5983 14.3196 11.9947 13.0864 12.1613 11.8125H15.1256C14.729 12.6743 14.1562 13.4434 13.4441 14.0703C12.732 14.6971 11.8964 15.1678 10.9913 15.4519Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cWebsite' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company?.['cWebsite'],
                                    name: "cWebsite",
                                    type: "url",
                                    placeholder: "Website",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company?.['cWebsite'] || '',
                                    placeholder: "Website",
                                    onFocus: ()=>setEditInput('cWebsite'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cLinkedin' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company?.['cLinkedin'],
                                    name: "cLinkedin",
                                    type: "url",
                                    placeholder: "LinkedIn Url",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company?.['cLinkedin'] || '',
                                    placeholder: "LinkedIn Url",
                                    onFocus: ()=>setEditInput('cLinkedin'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125V2.875C17 1.84106 16.1589 1 15.125 1ZM15.75 15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H11.4375V11.1875H13.4384L13.6715 9.25H11.4375V7.15625C11.4375 6.62183 11.8406 6.21875 12.375 6.21875H13.7812V4.40625C13.4111 4.354 12.6971 4.28125 12.375 4.28125C11.6461 4.28125 10.9155 4.58875 10.3706 5.12476C9.8092 5.677 9.5 6.40039 9.5 7.16174V9.25H7.46875V11.1875H9.5V15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cFacebook' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company?.['cFacebook'],
                                    name: "cFacebook",
                                    type: "url",
                                    placeholder: "Facebook URL",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company?.['cFacebook'] || '',
                                    placeholder: "Facebook URL",
                                    onFocus: ()=>setEditInput('cFacebook'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9.15778 17C9.1048 17 9.05182 17 8.99847 16.9998C7.74428 17.0028 6.58542 16.9709 5.45842 16.9023C4.42518 16.8395 3.48203 16.4824 2.73078 15.8699C2.0059 15.2788 1.51088 14.4796 1.25953 13.4947C1.04077 12.6373 1.02918 11.7956 1.01807 10.9816C1.01001 10.3974 1.00171 9.7053 1 9.00144C1.00171 8.29465 1.01001 7.60251 1.01807 7.0184C1.02918 6.20444 1.04077 5.36276 1.25953 4.50521C1.51088 3.52035 2.0059 2.72115 2.73078 2.13009C3.48203 1.51753 4.42518 1.16048 5.45854 1.09761C6.58554 1.02913 7.74464 0.997147 9.00153 1.0002C10.2561 0.997514 11.4146 1.02913 12.5416 1.09761C13.5748 1.16048 14.518 1.51753 15.2692 2.13009C15.9942 2.72115 16.4891 3.52035 16.7405 4.50521C16.9592 5.36264 16.9708 6.20444 16.9819 7.0184C16.99 7.60251 16.9984 8.29465 17 8.99851V9.00144C16.9984 9.7053 16.99 10.3974 16.9819 10.9816C16.9708 11.7955 16.9593 12.6372 16.7405 13.4947C16.4891 14.4796 15.9942 15.2788 15.2692 15.8699C14.518 16.4824 13.5748 16.8395 12.5416 16.9023C11.4623 16.968 10.3536 17 9.15778 17ZM8.99847 15.7498C10.2323 15.7527 11.3651 15.7216 12.4656 15.6547C13.2469 15.6072 13.9243 15.3536 14.4793 14.9011C14.9922 14.4828 15.3455 13.9056 15.5292 13.1857C15.7114 12.4719 15.7219 11.7056 15.732 10.9645C15.7399 10.3843 15.7482 9.697 15.75 8.99998C15.7482 8.30283 15.7399 7.6157 15.732 7.03549C15.7219 6.2944 15.7114 5.52804 15.5292 4.81418C15.3455 4.0942 14.9922 3.51705 14.4793 3.09872C13.9243 2.64632 13.2469 2.39278 12.4656 2.3453C11.3651 2.27828 10.2323 2.2474 9.0014 2.25008C7.76784 2.24715 6.63486 2.27828 5.53435 2.3453C4.75307 2.39278 4.07568 2.64632 3.52073 3.09872C3.00777 3.51705 2.65448 4.0942 2.47076 4.81418C2.28862 5.52804 2.27812 6.29428 2.26799 7.03549C2.26006 7.61619 2.25176 8.30381 2.25005 9.00144C2.25176 9.69602 2.26006 10.3838 2.26799 10.9645C2.27812 11.7056 2.28862 12.4719 2.47076 13.1857C2.65448 13.9056 3.00777 14.4828 3.52073 14.9011C4.07568 15.3535 4.75307 15.6071 5.53435 15.6545C6.63486 15.7216 7.76808 15.7528 8.99847 15.7498ZM8.96869 12.9062C6.8148 12.9062 5.06229 11.1539 5.06229 8.99998C5.06229 6.84604 6.8148 5.09372 8.96869 5.09372C11.1227 5.09372 12.8751 6.84604 12.8751 8.99998C12.8751 11.1539 11.1227 12.9062 8.96869 12.9062ZM8.96869 6.34372C7.50403 6.34372 6.31234 7.53537 6.31234 8.99998C6.31234 10.4646 7.50403 11.6562 8.96869 11.6562C10.4335 11.6562 11.625 10.4646 11.625 8.99998C11.625 7.53537 10.4335 6.34372 8.96869 6.34372ZM13.3126 3.84371C12.7949 3.84371 12.3751 4.26339 12.3751 4.78122C12.3751 5.29904 12.7949 5.71872 13.3126 5.71872C13.8304 5.71872 14.2501 5.29904 14.2501 4.78122C14.2501 4.26339 13.8304 3.84371 13.3126 3.84371Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cInstagram' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company?.['cInstagram'],
                                    name: "cInstagram",
                                    type: "url",
                                    placeholder: "Instagram URL",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company?.['cInstagram'] || '',
                                    placeholder: "Instagram URL",
                                    onFocus: ()=>setEditInput('cInstagram'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "cp tac c1 br25px px2rem py0-75rem fw500",
                    style: {
                        backgroundColor: '#ff7b7b',
                        border: 'none',
                        fontSize: '0.9rem'
                    },
                    children: "Save Changes"
                })
            ]
        });
    };
    //********** Director's Information **********//
    const directorsInfo = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "p2rem",
            children: company['directors'] && company['directors'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df fww gap1-5rem",
                children: company['directors'].map((director, idx)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem bw1px bo16 br30px bss m1rem",
                        style: {
                            flex: '0 0 calc(44% - 0.75rem)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb mb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: director?.['headShot']?.['location'] || (parcelRequire("kBFDN")),
                                                className: "w60px h60px br100 mr1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs1rem fw500 c14 mb0-25rem",
                                                        children: director['name'] ? director['name'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs0-75rem fw600",
                                                        children: director['role'] ? director['role'] : 'Director'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs0-75rem fw400 fsi",
                                                        children: director['designation'] ? director['designation'] : 'llp-designated-member'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("bqQxn")),
                                            className: "w80"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    placeholder: "LinkedIn",
                                    value: formData['directorId'] === director['_id'] && formData['linkedIn'] ? formData['linkedIn'] : director['linkedIn'] || '',
                                    onFocus: (e)=>{
                                        if (!formData['directorId'] || formData['directorId'] !== director['_id']) setFormData({
                                            linkedIn: director['linkedIn'] || '',
                                            companyId: company['_id'],
                                            directorId: director['_id']
                                        });
                                    },
                                    onBlur: (e)=>{
                                        if (formData['linkedIn'] && formData['linkedIn'].length > 0 && formData['linkedIn'] !== director['linkedIn']) handleSubmitDirector();
                                    },
                                    onChange: (e)=>setFormData({
                                            linkedIn: e.target.value,
                                            companyId: company['_id'],
                                            directorId: director['_id']
                                        }),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            style: {
                                                marginRight: '8px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z",
                                                fill: "#505050"
                                            })
                                        })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df aic h10",
                                children: director?.['cv'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-circle c4",
                                            style: {
                                                fontSize: '10px'
                                            },
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            target: "_blank",
                                            href: director['cv']?.['location'],
                                            className: "c3 fs0-75rem fw500 tdu",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "px0-5rem",
                                                children: director['cv']?.['originalname']
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>{
                                    showUploadPopup(director);
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'uploadCvData'
                                    }));
                                },
                                className: "df aic jcc cp bg3 c1 br10px px2rem py0-5rem my1rem fw500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        className: "mr0-75rem",
                                        width: "23",
                                        height: "23",
                                        viewBox: "0 0 23 23",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                clipPath: "url(#clip0_2183_912)",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
                                                        fill: "white"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M11.4914 17.7883C10.4699 17.7883 9.44852 17.7883 8.4273 17.7883C7.02663 17.7883 6.01589 16.7811 6.0087 15.3809C6.00601 14.8922 6.00601 14.4033 6.0087 13.9142C6.0114 13.4102 6.31687 13.0859 6.78406 13.085C7.25124 13.0841 7.56076 13.4062 7.5639 13.9097C7.56704 14.4133 7.5639 14.9052 7.5639 15.4029C7.56749 15.9249 7.87431 16.229 8.3981 16.2295C10.4672 16.2295 12.5362 16.2295 14.605 16.2295C15.1292 16.2295 15.4365 15.9249 15.4405 15.4034C15.4441 14.9056 15.4405 14.4079 15.4405 13.9102C15.4405 13.4124 15.7509 13.0841 16.2199 13.085C16.6889 13.0859 16.9988 13.4102 16.9948 13.9138C16.9899 14.5503 17.0253 15.1936 16.9454 15.8216C16.7989 16.9707 15.8192 17.782 14.6566 17.7874C13.6041 17.7905 12.5475 17.7883 11.4914 17.7883Z",
                                                        fill: "#4A67FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M10.726 7.89412C10.6074 8.00463 10.5377 8.06527 10.473 8.13041C9.97531 8.63309 9.48027 9.13891 8.98029 9.63978C8.62541 9.99557 8.13082 10.0216 7.81008 9.71031C7.48934 9.399 7.50192 8.88824 7.85096 8.53695C8.86709 7.51453 9.88652 6.4957 10.9092 5.48047C11.2686 5.12109 11.7385 5.12109 12.0979 5.48047C13.1275 6.50169 14.1529 7.52726 15.1741 8.55717C15.5101 8.89633 15.5119 9.40619 15.1997 9.71076C14.8875 10.0153 14.3911 10.0019 14.0484 9.6618C13.5408 9.15643 13.0408 8.64297 12.5368 8.13445C12.4716 8.06887 12.402 8.00777 12.2982 7.90984C12.2915 8.0509 12.2834 8.14209 12.2834 8.23328C12.2834 9.84104 12.2856 11.4483 12.2834 13.0561C12.2834 13.6594 11.7524 14.0183 11.2003 13.8036C10.8949 13.6846 10.7291 13.4195 10.7291 13.0314C10.7273 11.4412 10.7273 9.85107 10.7291 8.26113L10.726 7.89412Z",
                                                        fill: "#4A67FF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                    id: "clip0_2183_912",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                        width: "23",
                                                        height: "23",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    "Upload CV"
                                ]
                            })
                        ]
                    }, idx);
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "c14 w100 mt2rem tac fs1-25rem",
                children: "This company has no directors!"
            })
        });
    };
    const handleCvChange = async (event)=>{
        if (event.target.files) {
            const newAttachment = [];
            for (const file of event.target.files)newAttachment.push(file);
            setAttachment(newAttachment);
            const updatedCvData = {
                ...cvData
            };
            updatedCvData[director['_id']] = newAttachment[0];
            setCvData(updatedCvData);
        }
    };
    const showUploadPopup = (director)=>{
        setDirector(director['_id']);
        const matchingDirector = company?.['directors'].find((d)=>d['_id'] === director['_id']);
        const linkedInValue = matchingDirector && matchingDirector['linkedIn'] !== 'undefined' ? matchingDirector['linkedIn'] : null;
        setFormData({
            ...formData,
            linkedIn: linkedInValue
        });
        setDirector(director);
    };
    const handleSubmit = async ()=>{
        let data;
        if (attachment) data = {
            attachment: attachment,
            ...formData
        };
        else data = {
            ...formData
        };
        const regex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{5,30}\/?$/;
        const isValid = regex.test(formData.linkedIn);
        if (!isValid) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please provide a valid linkedin profile url");
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/saveCV', data);
        if (res && res['code'] == 200) {
            const { updatedQuestion: updatedQuestion } = res['body'];
            // Update local directors state
            const updatedDirectors = directors.map((director)=>{
                if (director['_id'] == updatedQuestion['directorId']) return {
                    ...director,
                    cv: updatedQuestion['files'][0]
                };
                return director;
            });
            setDirectors(updatedDirectors);
            const updatedCompany = {
                ...company,
                directors: updatedDirectors
            };
            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...company,
                updatedCompany: updatedCompany
            }));
            if (getCompany) await getCompany();
            else fetchCompany();
            closeDirectorPopup();
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        }
    };
    const handleSubmitDirector = async ()=>{
        let data = {
            ...formData
        };
        if (formData['linkedIn'] && formData['linkedIn'].length > 0) {
            const regex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{5,30}\/?$/;
            const isValid = regex.test(formData['linkedIn']);
            if (!isValid) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please provide a valid linkedin profile url");
        }
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/saveCV', data);
        if (res && res['code'] == 200) {
            if (getCompany) await getCompany();
            else fetchCompany();
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        }
    };
    const closeDirectorPopup = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setFormData({
            ...formData,
            linkedIn: ''
        });
    };
    const confirmDeleteFiles = async ()=>{
        let questionId = "64bf7e6bacdfbb8c415c2cb4";
        let index = company?.directors.findIndex((el)=>el['_id'] == director['_id']);
        const directorId = director['_id'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: attachment,
            questionId: questionId,
            companyId: companyId,
            directorId: directorId
        });
        if (res && res['code'] == 200) {
            Object.keys(company.modules).map((module)=>{
                if (module === `directors-questionnaire_${director['_id']}`) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)((company)=>{
                    const updatedCompany = {
                        ...company
                    };
                    const moduleObj = updatedCompany.modules[module];
                    if (moduleObj && moduleObj.sections[0]?.subFolders[2]?.questions[0]?.answer?.files) moduleObj.sections[0].subFolders[2].questions[0].answer.files = moduleObj.sections[0].subFolders[2].questions[0].answer.files?.filter((file)=>{
                        return file !== attachment;
                    });
                    return updatedCompany;
                }));
            });
            const updatedCvData = {
                ...cvData
            };
            if (updatedCvData.hasOwnProperty(directorId)) delete updatedCvData[directorId];
            setCvData(updatedCvData);
            if (getCompany) await getCompany();
            else fetchCompany();
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        }
    };
    //********** Direct/Indirect Channel **********// 
    const directIndirectChannel = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem c15",
                            children: company?.['cName']
                        }),
                        companyAuditLogButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr mt2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "c15",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Type of customer:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "directWeb",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox active w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        defaultChecked: company?.['customerType'] && company?.['customerType'] == 'Direct' ? true : false,
                                                        name: "customerTypeDirect",
                                                        id: "customerTypeDirect",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Direct (from the web)?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "advisorPartner",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        defaultChecked: company?.['customerType'] && company?.['customerType'] == 'Indirect' ? true : false,
                                                        name: "customerTypeAdvisor",
                                                        id: "customerTypeAdvisor",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Introduced via a advisor partner?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "Hybrid",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        defaultChecked: company?.['customerType'] && company?.['customerType'] == 'Hybrid' ? true : false,
                                                        name: "customerTypeHybrid",
                                                        id: "customerTypeHybrid",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Hybrid"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area-company-settings pa cp",
                                            "data-tooltip": "This is the type of customer you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon",
                                                "data-tooltip": "This is the type of customer you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    "data-tooltip": "This is the type of customer you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                                    src: (parcelRequire("24u8s")),
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "c15 mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Payment Source:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "directWebpayment",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        defaultChecked: company?.['paymentSource'] && company?.['paymentSource'] == 'Direct' ? true : false,
                                                        name: "paymentSourceDirect",
                                                        id: "paymentSourceDirect",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Direct (from the web)?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "advisorPartnerpayment",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        defaultChecked: company?.['paymentSource'] && company?.['paymentSource'] == 'Paid' ? true : false,
                                                        name: "paymentSourcePaid",
                                                        id: "paymentSourcePaid",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Paid via a advisor partner?"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "Other",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        defaultChecked: company?.['paymentSource'] && company?.['paymentSource'] == 'Other' ? true : false,
                                                        name: "paymentSourceOther",
                                                        id: "paymentSourceOther",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Other"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area-company-settings pa cp",
                                            "data-tooltip": "This is the payment source you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon",
                                                "data-tooltip": "This is the payment Source you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    "data-tooltip": "This is the payment Source you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                                    src: (parcelRequire("24u8s")),
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    //********** Company Stage of Development **********// 
    const companyStageofDevelopment = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem c15",
                            children: company?.['cName']
                        }),
                        companyAuditLogButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pr mt2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "c15",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Stage of development:"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        for: "Pre-Revenue",
                                        className: "py0-5rem df cp mb0-5rem label-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w2rem h2rem pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultChecked: company?.['cStage'] && company?.['cStage'] == 'Pre-Revenue' ? true : false,
                                                    name: "preRevenue",
                                                    id: "preRevenue",
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                    type: "radio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100 fs0-75rem lh3 ml0-5rem usn ml1rem",
                                                children: "Pre-Revenue"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        for: "Post-Revenue Early Stage",
                                        className: "py0-5rem df cp mb0-5rem label-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w2rem h2rem pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultChecked: company?.['cStage'] && company?.['cStage'] == 'Post-Revenue Early Stage' ? true : false,
                                                    name: "postRevenueEarlyStage",
                                                    id: "postRevenueEarlyStage",
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                    type: "radio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100 fs0-75rem lh3 ml0-5rem usn ml1rem",
                                                children: "Post-Revenue Early Stage"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        for: "Mature",
                                        className: "py0-5rem df cp mb0-5rem label-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w2rem h2rem pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultChecked: company?.['cStage'] && company?.['cStage'] == 'Mature' ? true : false,
                                                    name: "mature",
                                                    id: "mature",
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                    type: "radio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100  lh3 ml0-5rem usn ml1rem",
                                                children: "Mature"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "tooltip-area-company-settings pa cp",
                                        "data-tooltip": "This is the stage of development you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon",
                                            "data-tooltip": "This is the stage of development you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                "data-tooltip": "This is the stage of development you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform",
                                                src: (parcelRequire("24u8s")),
                                                alt: ""
                                            })
                                        })
                                    })
                                ]
                            }),
                            company?.['cStage'] && company?.['cStage'] == 'Pre-Revenue' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c15",
                                    children: [
                                        "Company stage ",
                                        company?.['cStage'],
                                        " means that we tweak our AI algoirthms to focus on prerevenue issues your business is likely to face."
                                    ]
                                })
                            }),
                            company?.['cStage'] && company?.['cStage'] == 'Post-Revenue Early Stage' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c15",
                                    children: [
                                        "Company stage ",
                                        company?.['cStage'],
                                        " means that we tweak our AI algoirthms to focus on issues that a company at your stage of development is likely to face."
                                    ]
                                })
                            }),
                            company?.['cStage'] && company?.['cStage'] == 'Mature' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c15",
                                    children: [
                                        "Company stage ",
                                        company?.['cStage'],
                                        " means that we tweak our AI algoirthms to focus on the issues faced by a more mature business."
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    //********** Company Objectives **********// 
    const companyObjectives = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem c15",
                            children: company?.['cName']
                        }),
                        companyAuditLogButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pr mt2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "c15",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Company Objectives:"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        for: "Lookingforinvestment",
                                        className: "py0-5rem df cp mb0-5rem label-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w2rem h2rem pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultChecked: company?.['testType'] && company?.['testType'] == 'investment' ? true : false,
                                                    name: "investment",
                                                    id: "investment",
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                    type: "radio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100 lh3 ml0-5rem usn ml1rem",
                                                children: "Looking for investment"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        for: "Accelerategrowth",
                                        className: "py0-5rem df cp mb0-5rem label-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w2rem h2rem pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultChecked: company?.['testType'] && company?.['testType'] == 'growth' ? true : false,
                                                    name: "growth",
                                                    id: "growth",
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                    type: "radio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100 lh3 ml0-5rem usn ml1rem",
                                                children: "Accelerate growth"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        for: "Lookingtoexit",
                                        className: "py0-5rem df cp mb0-5rem label-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w2rem h2rem pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    defaultChecked: company?.['testType'] && company?.['testType'] == 'exit' ? true : false,
                                                    name: "exit",
                                                    id: "exit",
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                    type: "radio"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100 lh3 ml0-5rem usn ml1rem",
                                                children: "Looking to exit"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "tooltip-area-company-settings pa cp",
                                        "data-tooltip": "This is the objective you have selected for this<br /> company on the Diligentsia platform \u2013 questions and<br /> answers will be tailored to this objective",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon",
                                            "data-tooltip": "This is the objective you have selected for this<br /> company on the Diligentsia platform \u2013 questions and<br /> answers will be tailored to this objective",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                "data-tooltip": "This is the objective you have selected for this<br /> company on the Diligentsia platform \u2013 questions and<br /> answers will be tailored to this objective",
                                                src: (parcelRequire("24u8s")),
                                                alt: ""
                                            })
                                        })
                                    })
                                ]
                            }),
                            company?.['testType'] && company?.['testType'] == 'investment' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c15",
                                    children: [
                                        "Company type ",
                                        company?.['testType'],
                                        " means that we tweak our AI algoirthms to focus on preparing your business to make it more investment ready."
                                    ]
                                })
                            }),
                            company?.['testType'] && company?.['testType'] == 'growth' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c15",
                                    children: [
                                        "Company type ",
                                        company?.['testType'],
                                        " means that we tweak our AI algoirthms to  focus on preparing your business to turbocharge your growth."
                                    ]
                                })
                            }),
                            company?.['testType'] && company?.['testType'] == 'exit' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "c15",
                                    children: [
                                        "Company type ",
                                        company?.['testType'],
                                        " means that we tweak our AI algoirthms to focus on preparing your business to make it more exit ready."
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    //********** Subsription Model Info **********// 
    const subscriptionModelInfo = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs1rem mt2rem pr mr2rem ml1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem c15",
                            children: company?.['cName']
                        }),
                        companyAuditLogButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr mt2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            class: "c14",
                            children: [
                                company?.['cName'],
                                " Subscriptions:"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "c15 mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Core Modules:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr df jcsb w60 p1rem pb2rem bw1px br10px bo16 bss bg1 my1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "DevelopmentPartner",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        disabled: company?.['subscription'] && company?.['subscription'] == 'Free' ? false : true,
                                                        defaultChecked: company?.['subscription'] && company?.['subscription'] == 'Free' ? true : false,
                                                        name: "free",
                                                        id: "free",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio",
                                                        style: {
                                                            cursor: company?.['subscription'] && company?.['subscription'] == 'Free' ? 'pointer' : 'not-allowed'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100 fs0-75rem lh3 ml0-5rem usn ml1rem",
                                                    children: "Free"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "Lite",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        disabled: company?.['subscription'] && company?.['subscription'] == 'Lite' ? false : true,
                                                        defaultChecked: company?.['subscription'] && company?.['subscription'] == 'Lite' ? true : false,
                                                        name: "lite",
                                                        id: "lite",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio",
                                                        style: {
                                                            cursor: company?.['subscription'] && company?.['subscription'] == 'Lite' ? 'pointer' : 'not-allowed'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Lite"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "Pro",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        disabled: company?.['subscription'] && company?.['subscription'] == 'Pro' ? false : true,
                                                        defaultChecked: company?.['subscription'] && company?.['subscription'] == 'Pro' ? true : false,
                                                        name: "pro",
                                                        id: "pro",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio",
                                                        style: {
                                                            cursor: company?.['subscription'] && company?.['subscription'] == 'Pro' ? 'pointer' : 'not-allowed'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Pro"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "ProPlus",
                                            className: "py0-5rem df cp mb0-5rem label-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        disabled: company?.['subscription'] && company?.['subscription'] == 'Pro Plus' ? false : true,
                                                        defaultChecked: company?.['subscription'] && company?.['subscription'] == 'Pro Plus' ? true : false,
                                                        name: "proPlus",
                                                        id: "proPlus",
                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio",
                                                        style: {
                                                            cursor: company?.['subscription'] && company?.['subscription'] == 'Pro Plus' ? 'pointer' : 'not-allowed'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "w100  lh3 ml0-5rem usn ml1rem",
                                                    children: "Pro PLUS"
                                                })
                                            ]
                                        }),
                                        company?.['createdAt'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "pa fs0-75rem fw600 mt0-5rem",
                                            style: {
                                                top: '70px',
                                                left: '230px'
                                            },
                                            children: [
                                                "Renewal Date: ",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date(company?.['createdAt']).setFullYear(new Date(company?.['createdAt']).getFullYear() + 1)).format('DD/MMM/YYYY')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area-company-settings pa cp",
                                            "data-tooltip": "This lists the SaaS modules you have subscribed<br /> to for this company \u2013 you can change this by upgrading<br /> from your company dashboard",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon",
                                                "data-tooltip": "This lists the SaaS modules you have subscribed<br /> to for this company \u2013 you can change this by upgrading<br /> from your company dashboard",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    "data-tooltip": "This lists the SaaS modules you have subscribed<br /> to for this company \u2013 you can change this by upgrading<br /> from your company dashboard",
                                                    src: (parcelRequire("24u8s")),
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "c15 mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Expansion Packs:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100 p1rem px2rem bw1px br10px bo16 bss bg1 my1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                        className: "fs0-75rem",
                                        children: company?.['expensions'] && Object.keys(company?.['expensions']).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                company?.['expensions']['DEPN004'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw500",
                                                            children: "DEPN004"
                                                        }),
                                                        " \u2013 Industry Expansion Pack \u2013 Software Development",
                                                        isNaN(company?.['expensions']['DEPN004']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fw600",
                                                            children: [
                                                                " - (Renewal Date: ",
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date(company?.['expensions']['DEPN004']).setFullYear(new Date(company?.['expensions']['DEPN004']).getFullYear() + 1)).format('DD/MMM/YYYY'),
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                company?.['expensions']['DEPF005'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw500",
                                                            children: "DEPF005"
                                                        }),
                                                        " \u2013 Function Expansion Pack - Environmental Social & Governmental (ESG) ",
                                                        isNaN(company?.['expensions']['DEPF005']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fw600",
                                                            children: [
                                                                " - (Renewal Date: ",
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date(company?.['expensions']['DEPF005']).setFullYear(new Date(company?.['expensions']['DEPF005']).getFullYear() + 1)).format('DD/MMM/YYYY'),
                                                                ") "
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                company?.['expensions']['DEPF006'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw500",
                                                            children: "DEPF006"
                                                        }),
                                                        " \u2013 Function Expansion Pack \u2013 Warranty Disclosure Schedule ",
                                                        isNaN(company?.['expensions']['DEPF006']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fw600",
                                                            children: [
                                                                " - (Renewal Date: ",
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date(company?.['expensions']['DEPF006']).setFullYear(new Date(company?.['expensions']['DEPF006']).getFullYear() + 1)).format('DD/MMM/YYYY'),
                                                                ") "
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                company?.['expensions']['DEPF007'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw500",
                                                            children: "DEPF007"
                                                        }),
                                                        " \u2013 Expansion Pack \u2013 DD \u2013 Directors Questionnaire ",
                                                        isNaN(company?.['expensions']['DEPF007']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fw600",
                                                            children: [
                                                                " - (Renewal Date: ",
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date(company?.['expensions']['DEPF007']).setFullYear(new Date(company?.['expensions']['DEPF007']).getFullYear() + 1)).format('DD/MMM/YYYY'),
                                                                ") "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "w100 my2rem tac fs1rem",
                                            children: "This company has no expansion pack subscriptions at this time"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    //********** User Permissions **********// 
    const userPermissions = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem report-page",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            disabled: user['role'] == 'Advisor' || user['role'] == 'Investor',
                            className: `shadow c1 td250 br5px px1rem py0-5rem mx1rem fw600 cp ttu bsbb tac df jcc aic ${user['role'] == 'Advisor' || user['role'] == 'Investor' ? 'bg12' : 'bg3 bg4-hover'}`,
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'editUser'
                                })),
                            children: "Add New Member"
                        }),
                        company?.['members'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `bg3 bg4-hover shadow c1 td250 br5px px1rem py0-5rem mx1rem fw600 cp ttu bsbb tac df jcc aic`,
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'userList'
                                        })),
                                    children: "All Members"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `bg3 bg4-hover shadow c1 td250 br5px px1rem py0-5rem mx1rem fw600 cp ttu bsbb tac df jcc aic`,
                                    onClick: ()=>getPermissionsLogs(),
                                    children: "Audit Log"
                                })
                            ]
                        })
                    ]
                }),
                company?.['members'] && company?.['members'].length == 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "tac mt2rem",
                    children: "No Members Created!"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "table-permission mt2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        id: "table",
                        className: "table-userPermissions",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                className: "ps t0",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "index-table",
                                            children: "Modules"
                                        }),
                                        company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                            className: "user-area",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcc aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "mr1rem",
                                                            children: company?.['creatorId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                "data-tooltip": company?.['creatorId']?.firstName + " " + company?.['creatorId']?.lastName,
                                                                src: company?.['creatorId']?.['profile'],
                                                                className: `w2rem h2rem df jcc aic br100 ${profileClass}`
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                "data-tooltip": company?.['creatorId']?.firstName + " " + company?.['creatorId']?.lastName,
                                                                className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
                                                                children: company?.['creatorId']?.firstName ? company?.['creatorId']?.firstName[0] + company?.['creatorId']?.lastName[0] : "?"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            children: [
                                                                company?.['creatorId']['firstName'],
                                                                " ",
                                                                company?.['creatorId']['lastName'],
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                " (Owner)"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcc fdc",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "fs0-75rem ml3rem",
                                                            children: [
                                                                "Status: ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c7 mr0-5rem",
                                                                    children: "Activated "
                                                                })
                                                            ]
                                                        }),
                                                        company?.['creatorId']?.['lastLogin'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "fs0-75rem ml3rem",
                                                            children: [
                                                                " Last Login: ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: (new Date().getTime() - new Date(company?.['creatorId']['lastLogin']).getTime()) / 2592000000 > 3 ? 'c9' : 'c7',
                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['creatorId']['lastLogin']).format('ll')
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        company?.['members'] && company?.['members'].map((member)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                                className: "user-area",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcc aic cp",
                                                        onClick: ()=>handleMemberEdit(member),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mr1rem",
                                                                children: member?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    "data-tooltip": member?.firstName + " " + member?.lastName,
                                                                    src: member?.profile,
                                                                    className: "w2rem h2rem df jcc aic br100 bg4 c1"
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    "data-tooltip": member?.firstName + " " + member?.lastName,
                                                                    className: "w2rem h2rem df jcc aic br100 bg4 c1",
                                                                    children: member?.firstName ? member?.firstName[0] + member?.lastName[0] : "?"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                children: [
                                                                    member['firstName'],
                                                                    " ",
                                                                    member['lastName'],
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    " (",
                                                                    member['designation'],
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df jcc fdc fs0-75rem ml3rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                children: [
                                                                    "Status: ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `${member['emailVerified'] ? ' c7' : ' c8'} mr0-5rem`,
                                                                        children: member['emailVerified'] ? 'Activated' : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            children: [
                                                                                "Invite Sent - ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                " (",
                                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(member['updatedAt']).format('ll'),
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            member['emailVerified'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                children: [
                                                                    " Last Login: ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: (new Date().getTime() - new Date(member['lastLogin']).getTime()) / (1000 * 3600 * 24 * 30) > 3 ? 'c9' : 'c7',
                                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(member['lastLogin']).format('ll')
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: company?.['sections'] && company?.['sections'].map((section, idx)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                className: "c6",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fw600",
                                                        children: section['sectionNo']
                                                    }),
                                                    " ",
                                                    section['sectionName']
                                                ]
                                            }, idx),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "c6 cp",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    for: `owner-permission-${idx}`,
                                                    className: "df jcc cp fs0-75rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w2rem h2rem pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            disabled: true,
                                                            defaultChecked: true,
                                                            id: `permission-${idx}`,
                                                            className: "shadow bw2px bss cp td250 w2rem h2rem br5px",
                                                            type: "checkbox",
                                                            style: {
                                                                backgroundColor: '#8f8f8f',
                                                                borderColor: '#8f8f8f'
                                                            }
                                                        })
                                                    })
                                                })
                                            }, idx),
                                            company?.['members'] && company?.['members'].map((member, idx)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c6 cp",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        for: `member-permission-${idx}`,
                                                        className: "df jcc cp fs0-75rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "checkbox w2rem h2rem pr",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                checked: company?.['memberPermissions']?.[member['_id']]?.[section['sectionNo']],
                                                                onChange: (e)=>setPermissions(e, section['sectionNo'], member),
                                                                id: `${section['sectionNo']}-${member['_id']}`,
                                                                className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                                type: "checkbox"
                                                            })
                                                        })
                                                    })
                                                }, idx);
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    const setPermissions = async (e, sectionNo, member)=>{
        let permissions = company?.['memberPermissions']?.[member['_id']];
        permissions = {
            ...permissions,
            [sectionNo]: e.target.checked
        };
        if (company?.['memberPermissions']?.[member['_id']]) {
            company['memberPermissions'] = {
                ...company?.['memberPermissions'],
                [member['_id']]: permissions
            };
            await dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(company));
            savePermissions();
        }
    };
    const savePermissions = async ()=>{
        // User Updated
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updatePermission/${companyId}`, {
            permissions: company?.['memberPermissions']
        });
        if (res || res['code'] == 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    const getPermissionsLogs = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/permissionsLogs', {
            companyId: companyId
        });
        if (res || res['code'] == 200) {
            await setPermissionLogList(res['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'permissionsLogs'
            }));
        }
    };
    //********** Advisor Permissions **********// 
    const advisorPermissions = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper c15 p1rem fs1rem mt2rem pr mr2rem ml1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "company-name fs1-75rem",
                    children: company?.['cName']
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr mt2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            children: "Stage of development:"
                        }),
                        [
                            {
                                number: 'D017.1',
                                title: 'Accountants'
                            },
                            {
                                number: 'D017.2',
                                title: 'Lawyers'
                            },
                            {
                                number: 'D017.3',
                                title: 'Intellectual Property Advisors'
                            },
                            {
                                number: 'D017.4',
                                title: 'Property Advisors'
                            },
                            {
                                number: 'D017.5',
                                title: 'PR & Media Advisors'
                            },
                            {
                                number: 'D017.6',
                                title: 'Corporate Finance Advisors'
                            },
                            {
                                number: 'D017.7',
                                title: 'Commercial Bankers'
                            },
                            {
                                number: 'D017.8',
                                title: 'Investment Bankers'
                            },
                            {
                                number: 'D017.9',
                                title: 'Insurance Brokers'
                            },
                            {
                                number: 'D017.10',
                                title: 'GDPR Advisors'
                            },
                            {
                                number: 'D017.11',
                                title: 'Registrars'
                            },
                            {
                                number: 'D017.12',
                                title: 'Corporate Brokers'
                            },
                            {
                                number: 'D017.13',
                                title: 'Other'
                            }
                        ].map((item)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "development-customer df aic jcsb mt2rem w70",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "left-area mr2rem ",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        children: [
                                                            item['number'],
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: item['title']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr df mt1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "url",
                                                                placeholder: "Web site url",
                                                                className: "bg5 w100 br30px bw1px bo16 bss py0-5rem px1rem mr1rem"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "email",
                                                                placeholder: "Email of contact",
                                                                className: "bg5 w100 br30px bw1px bo16 bss py0-5rem px1rem"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                for: "Accountants",
                                                className: "py0-5rem df cp mb0-5rem label-checkbox",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "checkbox w2rem h2rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "Accountants1",
                                                        id: "Accountants",
                                                        className: "bg5 bo16 bw1px bss cp td250 w2rem h2rem br5px",
                                                        type: "radio"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                        style: {
                                            border: "none",
                                            height: "1px",
                                            display: "block",
                                            width: "70%",
                                            marginTop: "18px",
                                            backgroundColor: "#002d6340"
                                        }
                                    })
                                ]
                            });
                        })
                    ]
                })
            ]
        });
    };
    //********** RAG Files **********//
    const formatFileSize = (bytes)=>{
        if (!bytes) return '-';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    };
    const confirmDeleteRagFile = async ()=>{
        if (!ragFileToDelete) return;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rag-files/delete', {
            companyId: companyId,
            fileLocation: ragFileToDelete.fileUrl
        });
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('File deleted successfully');
            setRagFiles(ragFiles.filter((f)=>f.fileUrl !== ragFileToDelete.fileUrl));
            setRagFileToDelete(null);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to delete file');
    };
    const handleIndexRagFile = async (file)=>{
        setRagFileProcessing(file.fileUrl);
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rag-files/index', {
            companyId: companyId,
            fileLocation: file.fileUrl
        });
        setRagFileProcessing(null);
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('File indexed successfully');
            setRagFiles(ragFiles.map((f)=>f.fileUrl === file.fileUrl ? {
                    ...f,
                    ragStatus: 'Indexed',
                    ragIndexedAt: new Date()
                } : f));
        } else {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to index file');
            if (res?.code !== 200) setRagFiles(ragFiles.map((f)=>f.fileUrl === file.fileUrl ? {
                    ...f,
                    ragStatus: 'Failed'
                } : f));
        }
    };
    const handleUnindexRagFile = async (file)=>{
        setRagFileProcessing(file.fileUrl);
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rag-files/unindex', {
            companyId: companyId,
            fileLocation: file.fileUrl
        });
        setRagFileProcessing(null);
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('File unindexed successfully');
            setRagFiles(ragFiles.map((f)=>f.fileUrl === file.fileUrl ? {
                    ...f,
                    ragStatus: null,
                    ragIndexedAt: null
                } : f));
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to unindex file');
    };
    const ragFilesTab = ()=>{
        const allFiles = ragFiles;
        // Get unique modules from all files for the dropdown
        const uniqueModules = [
            ...new Set(allFiles.map((f)=>f.moduleType).filter(Boolean))
        ];
        // Filter by search, status and module
        const filteredFiles = allFiles.filter((file)=>{
            const matchesSearch = !ragFileSearch || file.fileName.toLowerCase().includes(ragFileSearch.toLowerCase());
            const matchesStatus = ragStatusFilter === 'All' || ragStatusFilter === 'Indexed' && file.ragStatus === 'Indexed' || ragStatusFilter === 'Failed' && file.ragStatus === 'Failed' || ragStatusFilter === 'Unindexed' && !file.ragStatus;
            const matchesModule = ragModuleFilter === 'All' || file.moduleType === ragModuleFilter;
            return matchesSearch && matchesStatus && matchesModule;
        });
        // Pagination calculations
        const totalFiles = filteredFiles.length;
        const totalPages = Math.ceil(totalFiles / ragFilesPerPage);
        const startIndex = (ragFilesPage - 1) * ragFilesPerPage;
        const endIndex = startIndex + ragFilesPerPage;
        const filesToDisplay = filteredFiles.slice(startIndex, endIndex);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem",
            style: {
                height: 'calc(100vh - 120px)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb aic mb1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem bbn",
                            children: `${company?.cName} - Knowledge Base`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    value: ragModuleFilter,
                                    onChange: (e)=>{
                                        setRagModuleFilter(e.target.value);
                                        setRagFilesPage(1);
                                    },
                                    className: "br5px px0-5rem py0-5rem bo1 bg1 fs0-875rem cp",
                                    style: {
                                        maxWidth: '160px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "All",
                                            children: "All Modules"
                                        }),
                                        uniqueModules.map((mod)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                value: mod,
                                                children: mod.replace(/-/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase())
                                            }, mod))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    value: ragStatusFilter,
                                    onChange: (e)=>{
                                        setRagStatusFilter(e.target.value);
                                        setRagFilesPage(1);
                                    },
                                    className: "br5px px0-5rem py0-5rem bo1 bg1 fs0-875rem cp",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "All",
                                            children: "All Status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "Indexed",
                                            children: "Synced"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "Failed",
                                            children: "Failed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "Unindexed",
                                            children: "Not Synced"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    style: {
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '5px',
                                        padding: '0.5rem 0.75rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "w1rem h1rem mr0-5rem",
                                            style: {
                                                fill: '#999'
                                            },
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 512 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            placeholder: "Search files...",
                                            value: ragFileSearch,
                                            onChange: (e)=>{
                                                setRagFileSearch(e.target.value);
                                                setRagFilesPage(1);
                                            },
                                            className: "bsbb bg-transparent outline-none fs0-875rem",
                                            style: {
                                                border: 'none',
                                                width: '200px'
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                allFiles.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden',
                            minHeight: 0
                        },
                        children: [
                            selectedRagFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic jcsb p1rem br10px mb1rem",
                                style: {
                                    backgroundColor: '#eff6ff',
                                    border: '1px solid #3b82f6',
                                    flexShrink: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "fw500 c4 fs0-875rem",
                                        children: [
                                            selectedRagFiles.length,
                                            " file",
                                            selectedRagFiles.length > 1 ? 's' : '',
                                            " selected"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic gg0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                disabled: ragBulkProcessing !== null,
                                                onClick: async ()=>{
                                                    setRagBulkProcessing('index');
                                                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rag-files/index', {
                                                        companyId: companyId,
                                                        fileLocations: selectedRagFiles
                                                    });
                                                    setRagBulkProcessing(null);
                                                    if (res?.code === 200) {
                                                        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
                                                        setRagFiles(ragFiles.map((f)=>selectedRagFiles.includes(f.fileUrl) ? {
                                                                ...f,
                                                                ragStatus: 'Indexed',
                                                                ragIndexedAt: new Date()
                                                            } : f));
                                                        setSelectedRagFiles([]);
                                                    } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to index files');
                                                },
                                                className: "df aic gg0-5rem px1rem py0-5rem br5px fw500 fs0-875rem c1 td250",
                                                style: {
                                                    backgroundColor: ragBulkProcessing ? '#93c5fd' : '#3b82f6',
                                                    border: 'none',
                                                    cursor: ragBulkProcessing ? 'not-allowed' : 'pointer',
                                                    opacity: ragBulkProcessing && ragBulkProcessing !== 'index' ? 0.5 : 1
                                                },
                                                children: [
                                                    ragBulkProcessing === 'index' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        style: {
                                                            width: '0.875rem',
                                                            height: '0.875rem',
                                                            animation: 'spin 1s linear infinite'
                                                        },
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                style: {
                                                                    opacity: 0.25
                                                                },
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10",
                                                                stroke: "#fff",
                                                                strokeWidth: "4"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                style: {
                                                                    opacity: 0.75
                                                                },
                                                                fill: "#fff",
                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        style: {
                                                            fill: '#fff',
                                                            width: '0.875rem',
                                                            height: '0.875rem'
                                                        },
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 328.8 302 377.2c52.2 52.2 136.4 52.2 188.6 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6c-31.5-31.5-31.5-82.5 0-114L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.8l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6c41.2-57.5 33.8-134.5-18.2-186.5c-52.2-52.2-136.4-52.2-188.6 0L60.2 244.3z"
                                                        })
                                                    }),
                                                    ragBulkProcessing === 'index' ? 'Syncing...' : 'Sync'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                disabled: ragBulkProcessing !== null,
                                                onClick: async ()=>{
                                                    setRagBulkProcessing('unindex');
                                                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rag-files/unindex', {
                                                        companyId: companyId,
                                                        fileLocations: selectedRagFiles
                                                    });
                                                    setRagBulkProcessing(null);
                                                    if (res?.code === 200) {
                                                        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
                                                        setRagFiles(ragFiles.map((f)=>selectedRagFiles.includes(f.fileUrl) ? {
                                                                ...f,
                                                                ragStatus: null,
                                                                ragIndexedAt: null
                                                            } : f));
                                                        setSelectedRagFiles([]);
                                                    } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to unindex files');
                                                },
                                                className: "df aic gg0-5rem px1rem py0-5rem br5px fw500 fs0-875rem td250",
                                                style: {
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #6b7280',
                                                    color: '#374151',
                                                    cursor: ragBulkProcessing ? 'not-allowed' : 'pointer',
                                                    opacity: ragBulkProcessing && ragBulkProcessing !== 'unindex' ? 0.5 : 1
                                                },
                                                children: [
                                                    ragBulkProcessing === 'unindex' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        style: {
                                                            width: '0.875rem',
                                                            height: '0.875rem',
                                                            animation: 'spin 1s linear infinite'
                                                        },
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                style: {
                                                                    opacity: 0.25
                                                                },
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10",
                                                                stroke: "#374151",
                                                                strokeWidth: "4"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                style: {
                                                                    opacity: 0.75
                                                                },
                                                                fill: "#374151",
                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        style: {
                                                            fill: '#374151',
                                                            width: '0.875rem',
                                                            height: '0.875rem'
                                                        },
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6c-31.5-31.5-31.5-82.5 0-114l57.4-57.4-47.3-37.1z"
                                                        })
                                                    }),
                                                    ragBulkProcessing === 'unindex' ? 'Unsyncing...' : 'Unsync'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                disabled: ragBulkProcessing !== null,
                                                onClick: async ()=>{
                                                    setRagBulkProcessing('delete');
                                                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rag-files/delete', {
                                                        companyId: companyId,
                                                        fileLocations: selectedRagFiles
                                                    });
                                                    setRagBulkProcessing(null);
                                                    if (res?.code === 200) {
                                                        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
                                                        setRagFiles(ragFiles.filter((f)=>!selectedRagFiles.includes(f.fileUrl)));
                                                        setSelectedRagFiles([]);
                                                    } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to delete files');
                                                },
                                                className: "df aic gg0-5rem px1rem py0-5rem br5px fw500 fs0-875rem c1 td250",
                                                style: {
                                                    backgroundColor: ragBulkProcessing === 'delete' ? '#fca5a5' : '#ef4444',
                                                    border: 'none',
                                                    cursor: ragBulkProcessing ? 'not-allowed' : 'pointer',
                                                    opacity: ragBulkProcessing && ragBulkProcessing !== 'delete' ? 0.5 : 1
                                                },
                                                children: [
                                                    ragBulkProcessing === 'delete' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        style: {
                                                            width: '0.875rem',
                                                            height: '0.875rem',
                                                            animation: 'spin 1s linear infinite'
                                                        },
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                style: {
                                                                    opacity: 0.25
                                                                },
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10",
                                                                stroke: "#fff",
                                                                strokeWidth: "4"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                style: {
                                                                    opacity: 0.75
                                                                },
                                                                fill: "#fff",
                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        style: {
                                                            fill: '#fff',
                                                            width: '0.875rem',
                                                            height: '0.875rem'
                                                        },
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 448 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM394.8 466.1C393.2 492.3 372.3 512 346.9 512H101.1C75.75 512 54.77 492.3 53.19 466.1L31.1 128H416L394.8 466.1z"
                                                        })
                                                    }),
                                                    ragBulkProcessing === 'delete' ? 'Deleting...' : 'Delete'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                disabled: ragBulkProcessing !== null,
                                                onClick: ()=>setSelectedRagFiles([]),
                                                className: "df aic jcc px0-75rem py0-5rem br5px fs0-875rem c6 td250",
                                                style: {
                                                    backgroundColor: '#f3f4f6',
                                                    border: '1px solid #d1d5db',
                                                    cursor: ragBulkProcessing ? 'not-allowed' : 'pointer',
                                                    opacity: ragBulkProcessing ? 0.5 : 1
                                                },
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dg br10px bg5 p1rem mb0-5rem aic",
                                style: {
                                    gridTemplateColumns: '0.3fr 2fr 1.5fr 1fr 1fr 0.8fr 1fr 0.8fr',
                                    flexShrink: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "checkbox",
                                        checked: filesToDisplay.length > 0 && filesToDisplay.every((f)=>selectedRagFiles.includes(f.fileUrl)),
                                        onChange: (e)=>{
                                            if (e.target.checked) setSelectedRagFiles([
                                                ...new Set([
                                                    ...selectedRagFiles,
                                                    ...filesToDisplay.map((f)=>f.fileUrl)
                                                ])
                                            ]);
                                            else setSelectedRagFiles(selectedRagFiles.filter((url)=>!filesToDisplay.find((f)=>f.fileUrl === url)));
                                        },
                                        className: "cp",
                                        style: {
                                            width: '1rem',
                                            height: '1rem'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fw600 c4 fs0-875rem",
                                        children: "File Name"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fw600 c4 fs0-875rem tac",
                                        children: "Module"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fw600 c4 fs0-875rem tac",
                                        children: "Section"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fw600 c4 fs0-875rem tac",
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fw600 c4 fs0-875rem tac",
                                        children: "Size"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fw600 c4 fs0-875rem tac",
                                        children: "Uploaded"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fw600 c4 fs0-875rem tac",
                                        children: "Actions"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc gg0-5rem",
                                style: {
                                    flex: 1,
                                    overflowY: 'auto',
                                    minHeight: 0
                                },
                                children: filesToDisplay.map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "dg p1rem br10px bg1 shadow-sm aic",
                                        style: {
                                            gridTemplateColumns: '0.3fr 2fr 1.5fr 1fr 1fr 0.8fr 1fr 0.8fr',
                                            border: '1px solid #f0f0f0'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                checked: selectedRagFiles.includes(file.fileUrl),
                                                onChange: (e)=>{
                                                    if (e.target.checked) setSelectedRagFiles([
                                                        ...selectedRagFiles,
                                                        file.fileUrl
                                                    ]);
                                                    else setSelectedRagFiles(selectedRagFiles.filter((url)=>url !== file.fileUrl));
                                                },
                                                className: "cp",
                                                style: {
                                                    width: '1rem',
                                                    height: '1rem'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic cp",
                                                style: {
                                                    overflow: 'hidden',
                                                    minWidth: 0
                                                },
                                                onClick: ()=>window.open(file.fileUrl, '_blank'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "mr0-5rem",
                                                        style: {
                                                            fill: '#3b82f6',
                                                            minWidth: '1.25rem',
                                                            width: '1.25rem',
                                                            height: '1.25rem',
                                                            flexShrink: 0
                                                        },
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 384 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c4 fs0-875rem c3-hover td250",
                                                        style: {
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        },
                                                        title: file.fileName,
                                                        children: file.fileName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c6 fs0-875rem df aic jcc",
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                },
                                                title: file.moduleType ? file.moduleType.replace(/-/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase()) : '-',
                                                children: file.moduleType ? file.moduleType.replace(/-/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase()) : '-'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c6 fs0-875rem df aic jcc",
                                                children: file.qNo || '-'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic jcc",
                                                children: file.ragStatus ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `px0-75rem py0-25rem br20px fs0-75rem fw500 ${file.ragStatus === 'Indexed' ? 'bg3 c1' : file.ragStatus === 'Failed' ? 'c1' : 'bg5 c4'}`,
                                                    style: {
                                                        backgroundColor: file.ragStatus === 'Failed' ? '#ef4444' : ''
                                                    },
                                                    children: file.ragStatus === 'Indexed' ? 'Synced' : file.ragStatus
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "px0-75rem py0-25rem br20px fs0-75rem fw500 c6",
                                                    style: {
                                                        backgroundColor: '#f3f4f6'
                                                    },
                                                    children: "Not Synced"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c6 fs0-875rem df aic jcc",
                                                children: formatFileSize(file.size)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c6 fs0-875rem df aic jcc",
                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(file.uploadedAt).format('DD MMM YY')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcc gg0-5rem",
                                                children: [
                                                    ragFileProcessing === file.fileUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic jcc p0-5rem br50",
                                                        style: {
                                                            backgroundColor: '#e5e7eb',
                                                            width: '2rem',
                                                            height: '2rem'
                                                        },
                                                        title: "Processing...",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            style: {
                                                                width: '1rem',
                                                                height: '1rem',
                                                                animation: 'spin 1s linear infinite'
                                                            },
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                    style: {
                                                                        opacity: 0.25
                                                                    },
                                                                    cx: "12",
                                                                    cy: "12",
                                                                    r: "10",
                                                                    stroke: "#6b7280",
                                                                    strokeWidth: "4"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    style: {
                                                                        opacity: 0.75
                                                                    },
                                                                    fill: "#6b7280",
                                                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                                })
                                                            ]
                                                        })
                                                    }) : file.ragStatus === 'Indexed' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        onClick: ()=>handleUnindexRagFile(file),
                                                        className: "cp df aic jcc p0-5rem br50 td250 pr",
                                                        style: {
                                                            backgroundColor: '#fef3c7'
                                                        },
                                                        title: "Unsync file",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            style: {
                                                                fill: '#f59e0b',
                                                                width: '1rem',
                                                                height: '1rem'
                                                            },
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 576 512",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6c-31.5-31.5-31.5-82.5 0-114l57.4-57.4-47.3-37.1z"
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        onClick: ()=>handleIndexRagFile(file),
                                                        className: "cp df aic jcc p0-5rem br50 td250 pr",
                                                        style: {
                                                            backgroundColor: '#dcfce7'
                                                        },
                                                        title: "Sync file",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            style: {
                                                                fill: '#22c55e',
                                                                width: '1rem',
                                                                height: '1rem'
                                                            },
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 640 512",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C680.9 251.2 253.6 328.8 302 377.2c52.2 52.2 136.4 52.2 188.6 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6c-31.5-31.5-31.5-82.5 0-114L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.8l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6c41.2-57.5 33.8-134.5-18.2-186.5c-52.2-52.2-136.4-52.2-188.6 0L60.2 244.3z"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        onClick: ()=>{
                                                            setRagFileToDelete(file);
                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: 'deleteRagFile'
                                                            }));
                                                        },
                                                        className: "cp df aic jcc p0-5rem br50 td250",
                                                        style: {
                                                            backgroundColor: '#fef2f2'
                                                        },
                                                        title: "Delete file",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            style: {
                                                                fill: '#ef4444',
                                                                width: '1rem',
                                                                height: '1rem'
                                                            },
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 448 512",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M135.2 17.69C140.6 6.848 151.7 0 163.8 0H284.2C296.3 0 307.4 6.848 312.8 17.69L320 32H416C433.7 32 448 46.33 448 64C448 81.67 433.7 96 416 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H128L135.2 17.69zM394.8 466.1C393.2 492.3 372.3 512 346.9 512H101.1C75.75 512 54.77 492.3 53.19 466.1L31.1 128H416L394.8 466.1z"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, idx))
                            }),
                            filesToDisplay.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tac py3rem c6",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "No files match your filters."
                                })
                            }),
                            totalFiles > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb aic mt1rem pt1rem",
                                style: {
                                    borderTop: '1px solid #e0e0e0',
                                    flexShrink: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic gg0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c6 fs0-875rem",
                                                children: "Show"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                value: ragFilesPerPage,
                                                onChange: (e)=>{
                                                    setRagFilesPerPage(Number(e.target.value));
                                                    setRagFilesPage(1);
                                                },
                                                className: "br5px px0-5rem py0-25rem bo1 bg1 fs0-875rem cp",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: 10,
                                                        children: "10"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: 25,
                                                        children: "25"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: 50,
                                                        children: "50"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c6 fs0-875rem",
                                                children: "entries"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c6 fs0-875rem",
                                        children: [
                                            "Showing ",
                                            startIndex + 1,
                                            " to ",
                                            Math.min(endIndex, totalFiles),
                                            " of ",
                                            totalFiles,
                                            " files"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic gg0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setRagFilesPage((prev)=>Math.max(1, prev - 1)),
                                                disabled: ragFilesPage === 1,
                                                className: `px0-75rem py0-25rem br5px fs0-875rem bo1 ${ragFilesPage === 1 ? 'c6 bg5' : 'cp c4 bg1 bg5-hover'}`,
                                                children: "Previous"
                                            }),
                                            Array.from({
                                                length: Math.min(5, totalPages)
                                            }, (_, i)=>{
                                                let pageNum;
                                                if (totalPages <= 5) pageNum = i + 1;
                                                else if (ragFilesPage <= 3) pageNum = i + 1;
                                                else if (ragFilesPage >= totalPages - 2) pageNum = totalPages - 4 + i;
                                                else pageNum = ragFilesPage - 2 + i;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>setRagFilesPage(pageNum),
                                                    className: `w2rem h2rem br5px fs0-875rem bo1 cp ${ragFilesPage === pageNum ? 'c1 bg3' : 'c4 bg1 bg5-hover'}`,
                                                    children: [
                                                        " ",
                                                        pageNum,
                                                        " "
                                                    ]
                                                }, pageNum);
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setRagFilesPage((prev)=>Math.min(totalPages, prev + 1)),
                                                disabled: ragFilesPage === totalPages,
                                                className: `px0-75rem py0-25rem br5px fs0-875rem bo1 ${ragFilesPage === totalPages ? 'c6 bg5' : 'cp c4 bg1 bg5-hover'}`,
                                                children: " Next "
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tac mt3rem c6",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "No files found in the Knowledge Base for this company."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem mt0-5rem",
                            children: "Files are automatically indexed when uploaded to the Repository."
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "td250 container bg1 py1rem shadow w100 df company-settings-page",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w80 mr1rem gg1rem mt1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tac ttc df fdc jcc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "w100 c14 fs2rem lh2",
                                        children: tabIndex
                                    }),
                                    tabIndex == "Companies House Core Info" && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>{
                                            if (getCompany) getCompany();
                                            else fetchCompany();
                                        },
                                        className: "cp tac c1 bg3 bg4-hover br20px px2rem py0-5rem fw500 mt1rem",
                                        children: "Refresh"
                                    })
                                ]
                            }),
                            company && tabIndex == "Companies House Core Info" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: companiesHouseCore()
                            }),
                            company && tabIndex == "Group Info" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: groupInfo()
                            }),
                            company && tabIndex == "Company Profile" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: companyProfile()
                            }),
                            company && tabIndex == "Director's Info" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: directorsInfo()
                            }),
                            company && tabIndex == "Direct/Indirect Channel" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: directIndirectChannel()
                            }),
                            company && tabIndex == "Company Stage Of Development" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: companyStageofDevelopment()
                            }),
                            company && tabIndex == "Company Objectives" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: companyObjectives()
                            }),
                            company && tabIndex == "Subscription Model Info" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: subscriptionModelInfo()
                            }),
                            company && tabIndex == "Advisor Permissions" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: advisorPermissions()
                            }),
                            company && tabIndex == "Knowledge Base" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: ragFilesTab()
                            })
                        ]
                    }),
                    getSidebarHTML()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'filingReadMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "avtar-area df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem",
                                src: (parcelRequire("cjTf7")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mt1rem text-gradient fs1-5rem tac",
                            children: "Filing History"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setFilingReadMore({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "group-inputs mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Category:"
                                        }),
                                        " ",
                                        filingReadMore['category'] ? filingReadMore['category'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Description:"
                                        }),
                                        " ",
                                        filingReadMore['description'] ? filingReadMore['description'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Bar Code:"
                                        }),
                                        " ",
                                        filingReadMore['barcode'] ? filingReadMore['barcode'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Transaction Id:"
                                        }),
                                        " ",
                                        filingReadMore['transaction_id'] ? filingReadMore['transaction_id'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Date:"
                                        }),
                                        " ",
                                        filingReadMore['date'] ? filingReadMore['date'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Document:"
                                        }),
                                        " ",
                                        filingReadMore['Location'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: filingReadMore['Location'],
                                            target: "_blank",
                                            className: "tdu ttu",
                                            children: "View Document"
                                        }) : '-'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'officersReadMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "avtar-area df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem",
                                src: (parcelRequire("dR1A7")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mt1rem text-gradient fs1-5rem tac",
                            children: "Officers"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setOfficersReadMore({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "group-inputs mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Name:"
                                        }),
                                        "  ",
                                        officersReadMore['name'] ? officersReadMore['name'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Role:"
                                        }),
                                        "  ",
                                        officersReadMore['officer_role'] ? officersReadMore['officer_role'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Address:"
                                        }),
                                        " ",
                                        officersReadMore['address'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                officersReadMore['address']['premises'] && officersReadMore['address']['premises'],
                                                officersReadMore['address']['address_line_1'] && ', ' + officersReadMore['address']['address_line_1'],
                                                officersReadMore['address']['address_line_2'] && ', ' + officersReadMore['address']['address_line_2'],
                                                officersReadMore['address']['locality'] && ' - ' + officersReadMore['address']['locality'],
                                                officersReadMore['address']['region'] && ', ' + officersReadMore['address']['region'],
                                                officersReadMore['address']['country'] && ', ' + officersReadMore['address']['country']
                                            ]
                                        }) : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Nationality:"
                                        }),
                                        "  ",
                                        officersReadMore['nationality'] ? officersReadMore['nationality'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Occupation:"
                                        }),
                                        "  ",
                                        officersReadMore['occupation'] ? officersReadMore['occupation'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "DOB:"
                                        }),
                                        "  ",
                                        officersReadMore['date_of_birth'] ? officersReadMore['date_of_birth']['month'] + '/' + officersReadMore['date_of_birth']['year'] : '-'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'controlReadMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "avtar-area df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem",
                                src: (parcelRequire("dR1A7")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mt1rem text-gradient fs1-5rem tac",
                            children: "Persons with Significant Control"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setControlReadMore({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "group-inputs mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Name:"
                                        }),
                                        "  ",
                                        controlReadMore['name'] ? controlReadMore['name'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Controls:"
                                        }),
                                        controlReadMore['natures_of_control'] && controlReadMore['natures_of_control'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: controlReadMore['natures_of_control'].map((control, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: control
                                                    })
                                                }, idx))
                                        }) : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "E-Tag:"
                                        }),
                                        "  ",
                                        controlReadMore['etag'] ? controlReadMore['etag'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Notified Date:"
                                        }),
                                        "  ",
                                        controlReadMore['notified_on'] ? controlReadMore['notified_on'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Address:"
                                        }),
                                        " ",
                                        controlReadMore['address'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                controlReadMore['address']['premises'] && controlReadMore['address']['premises'],
                                                controlReadMore['address']['address_line_1'] && ', ' + controlReadMore['address']['address_line_1'],
                                                controlReadMore['address']['address_line_2'] && ', ' + controlReadMore['address']['address_line_2'],
                                                controlReadMore['address']['locality'] && ' - ' + controlReadMore['address']['locality'],
                                                controlReadMore['address']['region'] && ', ' + controlReadMore['address']['region'],
                                                controlReadMore['address']['country'] && ', ' + controlReadMore['address']['country']
                                            ]
                                        }) : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Nationality:"
                                        }),
                                        "  ",
                                        controlReadMore['nationality'] ? controlReadMore['nationality'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "DOB:"
                                        }),
                                        "  ",
                                        controlReadMore['date_of_birth'] ? controlReadMore['date_of_birth']['month'] + '/' + controlReadMore['date_of_birth']['year'] : '-'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'chargeReadMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "avtar-area df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem",
                                src: (parcelRequire("dR1A7")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mt1rem text-gradient fs1-5rem tac",
                            children: "Charges"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setChargeReadMore({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "group-inputs mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Persons Entitled:"
                                        }),
                                        "  ",
                                        chargeReadMore['persons_entitled'] ? chargeReadMore['persons_entitled'][0]['name'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Charge Description:"
                                        }),
                                        "  ",
                                        chargeReadMore['classification'] ? chargeReadMore?.['classification']?.['description'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Status:"
                                        }),
                                        "  ",
                                        chargeReadMore['status'] ? chargeReadMore['status'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "E-Tag:"
                                        }),
                                        "  ",
                                        chargeReadMore['etag'] ? chargeReadMore['etag'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Charge Number:"
                                        }),
                                        "  ",
                                        chargeReadMore['charge_number'] ? chargeReadMore['charge_number'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Delivered On:"
                                        }),
                                        "  ",
                                        chargeReadMore['delivered_on'] ? chargeReadMore['delivered_on'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Satisfied On:"
                                        }),
                                        "  ",
                                        chargeReadMore['satisfied_on'] ? chargeReadMore['satisfied_on'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Short Particulars:"
                                        }),
                                        "  ",
                                        chargeReadMore['particulars'] ? chargeReadMore?.['particulars']?.['description'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Amount secured description:"
                                        }),
                                        "  ",
                                        chargeReadMore['secured_details'] ? chargeReadMore?.['secured_details']?.['description'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Transaction filing type:"
                                        }),
                                        "  ",
                                        chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['filing_type'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "my1rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Transaction filing Delivered On:"
                                        }),
                                        "  ",
                                        chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['delivered_on'] : '-'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'uploadCvData',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>closeDirectorPopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs1-25rem fw600 mt1rem",
                            children: "Director Info Update"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "group-inputs mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs1rem fw500 mb1rem",
                                    children: "Upload CV Here"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "fileUpload",
                                    className: "w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs1rem fw500 tac",
                                            children: "Upload CV"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            onChange: handleCvChange,
                                            className: "dn",
                                            id: "fileUpload",
                                            type: "file",
                                            multiple: true
                                        })
                                    ]
                                }),
                                cvData[director['_id']] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fww mt0-5rem",
                                    children: cvData[director['_id']] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "df jcc aic br25px lh1 bg3 c1 px0-5rem fw600 mr0-5rem mb0-5rem",
                                        target: "_blank",
                                        href: cvData[director['_id']]?.location,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "py0-5rem px0-5rem",
                                            children: cvData[director['_id']]?.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw500 mt1rem mb0-5rem",
                                    children: "LinkedIn Profile"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    id: "LinkedinUrl",
                                    name: "LinkedinUrl",
                                    type: "url",
                                    placeholder: "Please add LinkedIn url",
                                    value: formData['linkedIn'] || '',
                                    onChange: (e)=>setFormData({
                                            ...formData,
                                            linkedIn: e.target.value
                                        }),
                                    className: "w100 show-input shadow bg5 br5px p1rem mb1rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcse",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>handleSubmit(),
                                        className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 my1rem",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem",
                            children: "Are you sure you want to delete this file?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-25rem fw500 mb1rem",
                            children: attachment && attachment.originalname
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>confirmDeleteFiles(),
                            className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            className: "c3-hover td250 fs1-25rem cp",
                            children: "Cancel"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'companyDelete',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem c15",
                            children: company?.['cName']
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'deleteAuditLog'
                                        })),
                                    className: "pa r0 cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem mr3rem fw500",
                                    children: "Audit Log"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-gradient fw600 pb1rem",
                                    children: "Delete Company"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "Are you certain you want to delete that ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: company?.['cName']
                                    }),
                                    " Company?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    className: "h100 mt0-5rem shadow bg4 bg3-hover c1 td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>submitDeleteCompany(),
                                    className: "h100 mt0-5rem shadow bg3 bg4-hover c1 td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'addGroupCompany',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 mih35 bg1 shadow w100 p2rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setCompaniesGroup({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "Add Group Company"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bottom-company-area",
                            children: companies && companies.map((childCompnay, idx)=>{
                                if (childCompnay['_id'] !== company?.['_id'] && childCompnay['group'] !== "Parent") return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "company-detail-box df aic w95",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "checkbox active w2rem h2rem pr mr1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                onChange: (event)=>handleChildCompany({
                                                        event: event,
                                                        companyId: childCompnay['_id'],
                                                        group: companiesGroup[childCompnay['_id']]?.['group'],
                                                        selected: 'true'
                                                    }),
                                                id: `childCompnay-${childCompnay['_id']}`,
                                                className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                type: "checkbox"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "company-detail df fww p1rem br10px shadow bg1 fs1rem mb1rem w100 aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "fs0-75rem mr1rem w9rem",
                                                    children: childCompnay['cName']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "mr0-5rem df jsc w6rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs1rem c7 mra tal mr0-5rem w4rem",
                                                            children: childCompnay['subscription'] ? childCompnay['subscription']?.toUpperCase() : 'INACTIVE'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "w30 df username-area",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "ass fs0-75rem mt0-3rem ml0-5rem mr0-2rem",
                                                                            children: "Owner"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                    open: 'userDetail'
                                                                                })),
                                                                            "data-tooltip": user?.firstName ? user?.firstName + " " + user?.lastName : "Register to show your name here",
                                                                            className: "w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem fs0-75rem",
                                                                            children: user?.firstName ? user?.firstName?.[0] + user?.lastName?.[0] : "?"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "dropdown-company w4rem px1rem py0-5rem ml1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        value: companiesGroup[childCompnay['_id']]?.['group'],
                                                        name: "dropdown",
                                                        className: "fs0-75rem",
                                                        onChange: (e)=>handleChildCompany({
                                                                companyId: childCompnay['_id'],
                                                                group: e.target.value
                                                            }),
                                                        id: `group-${childCompnay['_id']}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Subsidiary",
                                                                children: "Subsidiary"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Associate",
                                                                children: "Associate"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "percentage-area ml1rem w7rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "input-area",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onChange: (e)=>handleChildCompany({
                                                                    companyId: childCompnay['_id'],
                                                                    group: companiesGroup[childCompnay['_id']]?.['group'],
                                                                    percentage: e.target.value
                                                                }),
                                                            placeholder: "Enter Percentage %",
                                                            id: `percentage-${childCompnay['_id']}`,
                                                            type: "text",
                                                            className: "fw600",
                                                            min: "1",
                                                            max: "100"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: updateGroupCompany,
                            id: "createGroup",
                            className: `${(company == null || companiesGroup.length == 0) && 'op20 pen '} mt0-5rem shadow bg3 bg4-hover c1 td250 br5px pt0-5rem pb0-5rem pl3rem pr3rem fw600 cp ttu bsbb tac df jcc aic`,
                            children: "Add"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'updateGroupCompany',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 mih35 bg1 shadow w100 p2rem bsbb df fdc m1rem maw700px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })), setCompaniesGroup({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: [
                                updateType,
                                " Group Company"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "bottom-company-area",
                            children: company && company?.['childrenCompanies'] && company?.['childrenCompanies'].map((childCompnay, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "company-detail-box df aic w95",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "checkbox active w2rem h2rem pr mr1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                onChange: (event)=>handleChildCompany({
                                                        event: event,
                                                        companyId: childCompnay['_id'],
                                                        group: childCompnay['group'],
                                                        percentage: childCompnay['percentage'],
                                                        selected: 'true'
                                                    }),
                                                id: `childCompnay${childCompnay['_id']}`,
                                                className: "bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px",
                                                type: "checkbox"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "company-detail df fww p1rem br10px shadow bg1 fs1rem mb1rem w100 aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                    className: "fs0-75rem mr1rem w9rem",
                                                    children: childCompnay['cName']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "mr0-5rem df jsc w6rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs1rem c7 mra tal mr0-5rem w4rem",
                                                            children: childCompnay['subscription'] ? childCompnay['subscription']?.toUpperCase() : 'INACTIVE'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "w30 df username-area",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "ass fs0-75rem mt0-3rem ml0-5rem mr0-2rem",
                                                                            children: "Owner"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                    open: 'userDetail'
                                                                                })),
                                                                            "data-tooltip": user?.firstName ? user?.firstName + " " + user?.lastName : "Register to show your name here",
                                                                            className: "w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem fs0-75rem",
                                                                            children: user?.firstName ? user?.firstName?.[0] + user?.lastName?.[0] : "?"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "dropdown-company w4rem px1rem py0-5rem ml1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        defaultValue: childCompnay['group'],
                                                        disabled: updateType == "Delete",
                                                        name: "dropdown",
                                                        className: "fs0-75rem",
                                                        onChange: (e)=>handleChildCompany({
                                                                companyId: childCompnay['_id'],
                                                                group: e.target.value
                                                            }),
                                                        id: `group-${childCompnay['_id']}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Subsidiary",
                                                                children: "Subsidiary"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Associate",
                                                                children: "Associate"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "percentage-area ml1rem w7rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "input-area",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            defaultValue: childCompnay['percentage'],
                                                            disabled: updateType == "Delete",
                                                            onChange: (e)=>handleChildCompany({
                                                                    companyId: childCompnay['_id'],
                                                                    percentage: e.target.value
                                                                }),
                                                            placeholder: "Enter Percentage %",
                                                            id: `percentage-${childCompnay['_id']}`,
                                                            type: "text",
                                                            className: "fw600",
                                                            min: "1",
                                                            max: "100",
                                                            style: {
                                                                color: updateType == 'Delete' && '#aeacac'
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>updateGroupCompany(),
                            id: "createGroup",
                            className: `${(company == null || companiesGroup.length == 0) && 'op20 pen '} mt0-5rem shadow bg3 bg4-hover c1 td250 br5px pt0-5rem pb0-5rem pl3rem pr3rem fw600 cp ttu bsbb tac df jcc aic`,
                            children: updateType
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'permissionsLogs',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company?.['cName'],
                                " User Permission Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of User Permissions"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: permissionLogList && permissionLogList.length > 0 ? permissionLogList.map((log)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df my0-5rem",
                                    children: [
                                        log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: `ass ml0-5rem br100 w2rem h2rem ${profileClass}`,
                                            src: log['userId']['profile'],
                                            "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                                        }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`,
                                            children: [
                                                log?.['userId']?.['firstName']?.[0] || "?",
                                                log?.['userId']?.['lastName']?.[0] || "?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem ml1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: log['message']
                                                        }),
                                                        " at ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: new Date(log.timestamp).toLocaleString()
                                                        })
                                                    ]
                                                }),
                                                log?.['endpoint']?.includes('newMember') || log?.['endpoint']?.includes('editMember') ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "First Name:"
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['firstName']
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Last Name:"
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['lastName']
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Email:"
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['email']
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: "Designation:"
                                                                }),
                                                                " ",
                                                                log?.['payload']?.['designation']
                                                            ]
                                                        })
                                                    ]
                                                }) : log?.['endpoint']?.includes('updatePermission') ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Changed Permission:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: log?.['payload']?.['sectionNo']
                                                                }),
                                                                " - (",
                                                                permissionNames[log?.['payload']?.['sectionNo']],
                                                                ") permission is ",
                                                                log?.['payload']?.['action'] ? 'added to' : 'removed from',
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                    children: [
                                                                        " ",
                                                                        log?.['payload']?.['member']?.['firstName']
                                                                    ]
                                                                }),
                                                                " - (",
                                                                log?.['payload']?.['member']?.['designation'],
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }) : ''
                                            ]
                                        })
                                    ]
                                });
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttu w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'auditLogs',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac ttu",
                            children: [
                                company?.['cName'],
                                " Company Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of Company Audit Updated"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df",
                                    children: [
                                        company?.['creatorId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: `ass ml0-5rem br100 w2rem h2rem ${profileClass}`,
                                            src: company?.['creatorId']['profile'],
                                            "data-tooltip": company?.['creatorId']?.['firstName'] ? company?.['creatorId']?.['firstName'] + " " + company?.['creatorId']?.['lastName'] : "Register to show your name here"
                                        }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem ${profileClass}`,
                                            children: [
                                                company?.['creatorId']?.['firstName']?.[0] || "?",
                                                company?.['creatorId']?.['lastName']?.[0] || "?"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs0-75rem ml1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Company details updates"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Company Name:"
                                                }),
                                                " ",
                                                company?.['cName']
                                            ]
                                        }),
                                        company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Company Owner:"
                                                }),
                                                " ",
                                                company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']?.['lastName']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Created At:"
                                                }),
                                                " ",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['creaedAt']).format('ll')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Payment Source:"
                                                }),
                                                " ",
                                                company?.['paymentSource']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Stage of development:"
                                                }),
                                                " ",
                                                company?.['cStage']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Company Objectives:"
                                                }),
                                                " ",
                                                company?.['testType']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Company Subscription:"
                                                }),
                                                (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company?.['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: company?.['subscription']
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                auditLogList && auditLogList.length > 0 && auditLogList.map((log)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df my0-5rem",
                                        children: [
                                            log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: `ass ml0-5rem br100 w2rem h2rem ${profileClass}`,
                                                src: log['userId']['profile'],
                                                "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                                            }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`,
                                                children: [
                                                    log?.['userId']?.['firstName']?.[0] || "?",
                                                    log?.['userId']?.['lastName']?.[0] || "?"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem ml1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: log['message']
                                                            }),
                                                            " at ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: new Date(log.timestamp).toLocaleString()
                                                            }),
                                                            " by ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                children: [
                                                                    log?.['userId']?.['firstName'],
                                                                    " ",
                                                                    log?.['userId']?.['lastName']
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    log['payload']['update'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 fs1rem",
                                                                children: [
                                                                    "Changes to ",
                                                                    company?.['cName'],
                                                                    " - Company Details:"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df w100",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "mr0-5rem",
                                                                        children: Object.keys(log['payload']['update']).map((key)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "fw600",
                                                                                children: [
                                                                                    companyKeys[key],
                                                                                    ":"
                                                                                ]
                                                                            });
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        children: Object.values(log['payload']['update']).map((value)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                children: value
                                                                            });
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    log['payload']?.['data']?.['childUpdates'] && log['payload']?.['data']?.['childUpdates'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 fs1rem",
                                                                children: [
                                                                    log['payload']['data']['type'] && log['payload']['data']['type'],
                                                                    " Group Info:"
                                                                ]
                                                            }),
                                                            log['payload']?.['data']?.['childUpdates'].map((data)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        companies && companies.length > 0 && companies.map((company)=>{
                                                                            if (company?.['_id'] == log['payload']?.['data']?.['parentId']) {
                                                                                if (company?.['childrenCompanies']) for (let childCompnay of company?.['childrenCompanies']){
                                                                                    if (childCompnay['_id'] == data['companyId']) return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "fw600",
                                                                                                children: "Company Name:"
                                                                                            }),
                                                                                            " ",
                                                                                            childCompnay['cName']
                                                                                        ]
                                                                                    });
                                                                                }
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: "Group:"
                                                                                }),
                                                                                " ",
                                                                                data['group']
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: "Percentage:"
                                                                                }),
                                                                                " ",
                                                                                data['percentage'],
                                                                                "%"
                                                                            ]
                                                                        })
                                                                    ]
                                                                });
                                                            })
                                                        ]
                                                    }),
                                                    log['payload']['directorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 fs1rem",
                                                                children: [
                                                                    "Changes to ",
                                                                    log['payload']['directorId']['name'],
                                                                    " - Director's Info:"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "CV:"
                                                                    }),
                                                                    log['files'].length > 0 && log['files'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                            className: "fw400 mr0-5rem fs0-75rem tdu",
                                                                            target: "_blank",
                                                                            href: file?.location,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                children: file?.originalname
                                                                            })
                                                                        }))
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "LinkedIn:"
                                                                    }),
                                                                    log['payload']['linkedIn'] && log['payload']['linkedIn'] !== 'undefined' ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                        className: "fw400 mr0-5rem fs0-75rem tdu",
                                                                        target: "_blank",
                                                                        href: log['payload']['linkedIn'],
                                                                        children: log['payload']['linkedIn']
                                                                    }) : '-'
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'companyAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac ttu",
                            children: [
                                company?.['cName'],
                                " - ",
                                tabIndex,
                                " Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: [
                                "See the history of ",
                                tabIndex,
                                " Updates"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df my0-5rem",
                                children: [
                                    company?.['creatorId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: `ass ml0-5rem br100 w2rem h2rem ${profileClass}`,
                                        src: company?.['creatorId']['profile'],
                                        "data-tooltip": company?.['creatorId'].firstName ? company?.['creatorId'].firstName + " " + company?.['creatorId'].lastName : "Register to show your name here"
                                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`,
                                        children: [
                                            company?.['creatorId']?.['firstName']?.[0] || "?",
                                            company?.['creatorId']?.['lastName']?.[0] || "?"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs0-75rem ml1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                        children: [
                                                            tabIndex,
                                                            " Updated"
                                                        ]
                                                    }),
                                                    " at ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: new Date(company?.createdAt).toLocaleString()
                                                    }),
                                                    " ",
                                                    company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            " by ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                children: [
                                                                    company?.['creatorId']['firstName'],
                                                                    " ",
                                                                    company?.['creatorId']['lastName']
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df fw500 fs1rem mb0-5rem",
                                                        children: [
                                                            tabIndex,
                                                            " Info:"
                                                        ]
                                                    }),
                                                    tabIndex == "Direct/Indirect Channel" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Name:"
                                                                    }),
                                                                    " ",
                                                                    company?.['cName']
                                                                ]
                                                            }),
                                                            company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Owner:"
                                                                    }),
                                                                    " ",
                                                                    company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Created At:"
                                                                    }),
                                                                    " ",
                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['creaedAt']).format('ll')
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Type of customer:"
                                                                    }),
                                                                    " ",
                                                                    company?.['customerType']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Payment Source:"
                                                                    }),
                                                                    " ",
                                                                    company?.['paymentSource']
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    tabIndex == "Company Stage Of Development" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Name:"
                                                                    }),
                                                                    " ",
                                                                    company?.['cName']
                                                                ]
                                                            }),
                                                            company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Owner:"
                                                                    }),
                                                                    " ",
                                                                    company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Created At:"
                                                                    }),
                                                                    " ",
                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['creaedAt']).format('ll')
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Stage of development:"
                                                                    }),
                                                                    " ",
                                                                    company?.['cStage']
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    tabIndex == "Company Objectives" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Name:"
                                                                    }),
                                                                    " ",
                                                                    company?.['cName']
                                                                ]
                                                            }),
                                                            company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Owner:"
                                                                    }),
                                                                    " ",
                                                                    company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Created At:"
                                                                    }),
                                                                    " ",
                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['creaedAt']).format('ll')
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Objectives:"
                                                                    }),
                                                                    " ",
                                                                    company?.['testType']
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    tabIndex == "Subscription Model Info" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Name:"
                                                                    }),
                                                                    " ",
                                                                    company?.['cName']
                                                                ]
                                                            }),
                                                            company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Owner:"
                                                                    }),
                                                                    " ",
                                                                    company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Created At:"
                                                                    }),
                                                                    " ",
                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['creaedAt']).format('ll')
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "Company Subscription:"
                                                                    }),
                                                                    (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company?.['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                        children: company?.['subscription']
                                                                    })
                                                                ]
                                                            }),
                                                            company?.['expensions'] && Object.keys(company?.['expensions']).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "df fw500 fs1rem my0-5rem",
                                                                        children: "Expansion Info:"
                                                                    }),
                                                                    company?.['expensions']['DEPN004'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        children: [
                                                                            "DEPN004 \u2013 Industry Expansion Pack \u2013 Software Development ",
                                                                            isNaN(company?.['expensions']['DEPN004']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    " - ",
                                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['expensions']['DEPN004']).format('ll')
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    company?.['expensions']['DEPF005'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        children: [
                                                                            "DEPF005 \u2013 Function Expansion Pack - Environmental Social & Governmental (ESG) ",
                                                                            isNaN(company?.['expensions']['DEPF005']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    " - ",
                                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['expensions']['DEPF005']).format('ll')
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    company?.['expensions']['DEPF006'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        children: [
                                                                            "DEPF006 \u2013 Function Expansion Pack \u2013 Warranty Disclosure Schedule ",
                                                                            isNaN(company?.['expensions']['DEPF006']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    " - ",
                                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['expensions']['DEPF006']).format('ll')
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    company?.['expensions']['DEPF007'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        children: [
                                                                            "DEPF007 \u2013 Expansion Pack \u2013 DD \u2013 Directors Questionnaire ",
                                                                            isNaN(company?.['expensions']['DEPF007']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    " - ",
                                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['expensions']['DEPF007']).format('ll')
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'editUser',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: [
                                        userAction,
                                        " User"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah600px oya advisor-box-content",
                            children: userAction === 'Search' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "searchEmail",
                                                name: "searchEmail",
                                                type: "email",
                                                placeholder: "Search Email",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        id: "NewUserStep",
                                        onClick: findUser,
                                        className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                        children: "Search User"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userFirstName",
                                                name: "firstName",
                                                type: "text",
                                                placeholder: "First Name",
                                                onChange: handleUserChange,
                                                value: editUser['firstName'] || "",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userLastName",
                                                name: "lastName",
                                                type: "text",
                                                placeholder: "Last Name",
                                                onChange: handleUserChange,
                                                value: editUser['lastName'] || "",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userEmail",
                                                name: "email",
                                                type: "email",
                                                placeholder: "Email",
                                                onChange: handleUserChange,
                                                value: editUser['email'] || "",
                                                disabled: userAction == 'Edit' || userAction == 'Add' ? true : false,
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "designation",
                                                name: "designation",
                                                type: "text",
                                                placeholder: "Job Title",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem",
                                                onChange: handleUserChange,
                                                value: editUser['designation'] || ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 448 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H184L133.3 308.8zM314.7 308.8L264 512h149.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M176 288l32 56l-31.99 135.1L184 512h80l7.988-32.05L240 344l32-56H176zM224 0C153.3 0 96 57.25 96 128s57.25 128 128 128s128-57.25 128-128S294.8 0 224 0z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "c15 fs1-25rem ttu w100 tal 0 mb0-5rem",
                                        children: "Permissions"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        id: "userPermissions",
                                        className: "dg gg0-5rem my1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "tac df jcfs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w30px h30px pr mr1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onChange: selectAllPermissions,
                                                            className: "bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                            type: "checkbox",
                                                            checked: selectAll
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem c15 fw600 mr1rem usn",
                                                        children: "All Permissions"
                                                    })
                                                ]
                                            }),
                                            company?.['sections'] && company?.['sections'].map((section, idx)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    for: "permissions" + section['sectionNo'],
                                                    className: "df cp fs1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "checkbox w30px h30px pr mr1rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                onChange: changeUser,
                                                                name: section['sectionNo'],
                                                                id: "permissions" + section['sectionNo'],
                                                                className: "bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                                checked: editUser.permissions && editUser.permissions[section['sectionNo']]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1rem fw600 mr1rem usn c15",
                                                            children: section['sectionNo']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1rem fw400 usn c15",
                                                            children: section['sectionName']
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>saveUser(),
                                        className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "c3-hover td250 fs1-25rem cp",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setSelectAll(false);
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '12px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac ttu",
                            children: [
                                company?.['cName'],
                                " - Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: [
                                "See the history of ",
                                company?.['cName'],
                                " Updates"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df my0-5rem",
                                children: [
                                    company?.['creatorId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: `ass ml0-5rem br100 w2rem h2rem bg3`,
                                        src: company?.['creatorId']['profile'],
                                        "data-tooltip": company?.['creatorId'].firstName ? company?.['creatorId'].firstName + " " + company?.['creatorId'].lastName : "Register to show your name here"
                                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`,
                                        children: [
                                            company?.['creatorId']?.['firstName']?.[0] || "?",
                                            company?.['creatorId']?.['lastName']?.[0] || "?"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "fs0-75rem ml1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                        children: [
                                                            company?.['cName'],
                                                            " Updated"
                                                        ]
                                                    }),
                                                    " at ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: new Date(company?.createdAt).toLocaleString()
                                                    }),
                                                    " ",
                                                    company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            " by ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                children: [
                                                                    company?.['creatorId']['firstName'],
                                                                    " ",
                                                                    company?.['creatorId']['lastName']
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df fw500 fs1rem mb0-5rem",
                                                        children: [
                                                            company?.['cName'],
                                                            " Info:"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df fw500 ttc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw600 mr0-5rem",
                                                                children: "Company Name:"
                                                            }),
                                                            " ",
                                                            company?.['cName']
                                                        ]
                                                    }),
                                                    company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df fw500 ttc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw600 mr0-5rem",
                                                                children: "Company Owner:"
                                                            }),
                                                            " ",
                                                            company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df fw500 ttc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw600 mr0-5rem",
                                                                children: "Created At:"
                                                            }),
                                                            " ",
                                                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company?.['creaedAt']).format('ll')
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "df fw500 ttc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw600 mr0-5rem",
                                                                children: "Company Objectives:"
                                                            }),
                                                            " ",
                                                            company?.['testType']
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteRagFile',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 my1rem tac",
                            children: "Delete RAG File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c4 tac mb1rem",
                            children: "Are you sure you want to delete this file from RAG index?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-25rem fw500 mb1rem tac",
                            style: {
                                wordBreak: 'break-all'
                            },
                            children: ragFileToDelete?.fileName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c6 fs0-75rem tac mb2rem",
                            children: "This will remove the file from Clarence AI's knowledge base."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>confirmDeleteRagFile(),
                            className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            className: "c3-hover td250 fs1-25rem cp tac",
                            children: "Cancel"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'warningDeleteCompany',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 p3rem shadow w100 bsbb df fdc maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-75rem ttu w100 tac mb1rem",
                            children: "Warning"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc fs1rem mb1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Before deleting this company, please ensure that all associated companies under this user are deleted first, as this is the primary company. Additionally, if this company has any subsidiary companies, you must first remove its status as the parent company in the group."
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc fdc fdr-md aic fs1rem px1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                className: "shadow my0-5rem bg3 bg4-hover c1 td250 br5px p0-5rem fw600 cp ttu w40 bsbb tac",
                                children: "Ok"
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");









function $779840fc7d20dab3$export$771a64cb5cac4b84({ report: report, type: type, company: company, user: user, permissionLevel: permissionLevel, isGenerateAllResearchAid: isGenerateAllResearchAid = false, setTab: setTab, setCompanyDashboardTab: setCompanyDashboardTab }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const handleReportRedirect = (rep)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        setTab(`${rep['_id']}?${rep['reportType']}-researchaid`);
        setCompanyDashboardTab('Dashboard');
    };
    const handleReportName = (rep)=>{
        if (rep['reportType'] == 'swotAnalysis') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'swotReportPopup'
        }));
    };
    const creator = report?.['createdBy'];
    // History shows regeneration events only; prepend the first-generation date (createdAt) so it's included too.
    // Dedupe in case a report already recorded its creation in history (same minute → same formatted string).
    const createdStr = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report?.['createdAt']).format('MMMM Do, YYYY  hh:mma');
    const historyRows = (report?.['history'] || []).some((h)=>h?.['lastUpdatedTime'] === createdStr) ? report?.['history'] || [] : [
        {
            userId: creator,
            lastUpdatedTime: createdStr
        },
        ...report?.['history'] || []
    ];
    // Show the latest generated date on the card (last regeneration if any, else first generation).
    const latestMoment = report?.['history']?.length ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report['history'][report['history'].length - 1]?.['lastUpdatedTime'], 'MMMM Do, YYYY  hh:mma') : null;
    const latestDate = latestMoment && latestMoment.isValid() ? latestMoment.format('ll') : (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report?.['createdAt']).format('ll');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "right-info-hyper-icon",
                style: {
                    top: '-20px',
                    right: '-20px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "cp info-icon pr ml0-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "",
                        src: (parcelRequire("6WOfV")),
                        alt: "three-dot-icon"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    className: "cp w100 h100",
                    style: {
                        minHeight: '130px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon-diligenstia mr1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "br5px w50px",
                                        src: (parcelRequire("jSVu6")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc mr1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 fs0-75rem fw300 c12 mb0-5rem",
                                            children: "Diligentsia ResearchAid"
                                        }),
                                        report?.['htmlReport'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: permissionLevel != 'DASHBOARD' && `#${report['_id']}?${report['reportType']}-researchaid`,
                                            onClick: ()=>handleReportRedirect(report),
                                            className: "w100 fs1rem c15",
                                            children: report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']
                                        }) : report['reportType'] == 'swotAnalysis' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>handleReportName(report),
                                            className: "cp w100 bg1 fs1rem tal c15",
                                            children: report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "w100 fs1rem c12 op60",
                                            children: report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']
                                        })
                                    ]
                                }),
                                report?.['htmlReport'] && company['subscription'] == 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: `/researchAid/${company['_id']}#${report['_id']}?${report['reportType']}`,
                                            state: {
                                                company: company
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "cp fa fa-edit pl1rem c3",
                                                style: {
                                                    fontSize: '20px',
                                                    fontWeight: '400'
                                                }
                                            })
                                        }),
                                        report?.['history'] && report['history'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cp module-tooltip-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "hover-list",
                                                    style: {
                                                        position: 'relative',
                                                        left: 'auto',
                                                        top: 'auto'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "cp fa fa-history pl1rem c4",
                                                        style: {
                                                            fontSize: '20px',
                                                            fontWeight: '400'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "tooltip-area tooltip-reaserchaid",
                                                    children: historyRows.map((data, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "overlay-box",
                                                            style: {
                                                                padding: '5px 10px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic w100",
                                                                children: [
                                                                    data?.['userId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`,
                                                                        className: "shadow w2rem h2rem bg16 bw3px bss bo19 df jcc aic br100 c1 mr0-5rem",
                                                                        children: data['userId']['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: data['userId']['profile'],
                                                                            className: "new-shadow w30px h30px df jcc aic br100 bg16 c1",
                                                                            "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "bg16 c15 br50px",
                                                                            "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`,
                                                                            children: data['userId']?.firstName ? data['userId'].firstName[0] + (data['userId'].lastName?.[0] || "") : "?"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "c15",
                                                                        style: {
                                                                            fontSize: '10px'
                                                                        },
                                                                        children: data['lastUpdatedTime']
                                                                    })
                                                                ]
                                                            })
                                                        }, i))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `w100 df jcsb px1rem ${report?.['reportType'] == 'TCAR3' ? 'mt1rem' : 'mt2rem'}`,
                            children: [
                                !report?.['htmlReport'] && !report?.['score'] && !(report?.['reportType'] == 'swotAnalysis' && report?.['disableSwotReport']) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: isGenerateAllResearchAid ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: `cna br25px px3rem cp bg16 py0-5rem`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$67ad50c48ca3ede4), {
                                            height: "20",
                                            width: "20",
                                            strokeWidth: "4",
                                            secondaryColor: "#f9f9f9",
                                            color: "#000",
                                            ariaLabel: "oval-loading"
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/researchAid/${company['_id']}?${report['reportType']}`,
                                        state: {
                                            company: company
                                        },
                                        className: `c1 fs0-75rem fw600 td250 br25px px2rem py0-5rem cp bg4 bg3-hover`,
                                        children: "Generate"
                                    })
                                }) : (report?.['htmlReport'] || report?.['score']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        company['subscription'] == 'Free' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "w100 fs0-75rem fw300",
                                                    children: "Executive Summary only."
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "w100 fs0-75rem fw300",
                                                    children: [
                                                        "To ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c7 fw500",
                                                            children: "UNLOCK"
                                                        }),
                                                        " upgrade to PRO/LITE"
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb aic mt1rem",
                                            children: [
                                                creator && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`,
                                                    className: "shadow w40px h40px bg16 bw3px bss bo19 df jcc aic br100 c1",
                                                    children: creator?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: creator.profile,
                                                        className: "new-shadow w30px h30px df jcc aic br100 bg16 c1",
                                                        "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bg16 c15 br50px",
                                                        "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`,
                                                        children: creator?.firstName ? creator.firstName[0] + (creator.lastName?.[0] || "") : "?"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs0-75rem c15 ml0-5rem",
                                                    children: latestDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: `fs1-5rem tac ${report?.['score'] >= 4 ? 'c34' : report?.['score'] >= 2 ? 'c39' : 'c4'}`,
                                                    children: [
                                                        report?.['score'],
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem",
                                                            children: "/5"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem fw400 c15",
                                                    children: [
                                                        "Report ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        " Score"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                report?.['reportType'] == 'swotAnalysis' && report?.['disableSwotReport'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs0-75rem fw300 c14 tti",
                                    children: "Please complete the other 4 reports prior to generating this report"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}








function $779840fc7d20dab3$export$2e2bcd8739ae039({ company: company, getCompany: getCompany, setTab: setTab, setCompanyDashboardTab: setCompanyDashboardTab, permissionLevel: permissionLevel, isGenerateAllResearchAid: isGenerateAllResearchAid }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [isSwotReport, setIsSwotReport] = (0, $acw62.useState)(false);
    // Always fetch reports from single endpoint
    let [reports, setReports] = (0, $acw62.useState)([]);
    let [researchAidReports, setResearchAidReports] = (0, $acw62.useState)([]);
    let [loadingReports, setLoadingReports] = (0, $acw62.useState)(false);
    // Fetch reports from single endpoint
    (0, $acw62.useEffect)(()=>{
        const fetchReports = async ()=>{
            if (company?._id && !loadingReports) {
                setLoadingReports(true);
                try {
                    const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/reports`);
                    if (response['code'] == 200 && response['body']?.['reports']) {
                        setReports(response['body']['reports']['customReports'] || []);
                        setResearchAidReports(response['body']['reports']['researchAidReports'] || []);
                    }
                } catch (e) {
                    console.error('Failed to fetch reports:', e);
                } finally{
                    setLoadingReports(false);
                }
            }
        };
        fetchReports();
    }, [
        company?._id
    ]);
    const deleteHistoryRecord = async (reportId, historyId, type)=>{
        if (reportId && historyId) {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteReportHistory`, {
                reportId: reportId,
                historyId: historyId
            });
            if (res['code'] == '200') getCompany(); // remove record from frontend from history array
        }
    };
    const handleReportName = (report)=>{
        if (report['reportType'] == 'swotAnalysis') {
            if (report?.['disableSwotReport']) setIsSwotReport(true);
            else setIsSwotReport(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'swotReportPopup'
            }));
        }
    };
    const handleReportRedirect = (report)=>{
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        setTab(`${report['_id']}?${report['reportType']}-researchaid`);
        setCompanyDashboardTab('Dashboard');
    };
    const reportCard = (report, type)=>{
        let creator;
        if (report?.['createdBy']) creator = report?.['createdBy'];
        // Prepend the first-generation date (createdAt) to the history; show the latest generated date on the card.
        const createdStr = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report?.['createdAt']).format('MMMM Do, YYYY  hh:mma');
        const historyRows = (report?.['history'] || []).some((h)=>h?.['lastUpdatedTime'] === createdStr) ? report?.['history'] || [] : [
            {
                userId: creator,
                lastUpdatedTime: createdStr
            },
            ...report?.['history'] || []
        ];
        const latestMoment = report?.['history']?.length ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report['history'][report['history'].length - 1]?.['lastUpdatedTime'], 'MMMM Do, YYYY  hh:mma') : null;
        const latestDate = latestMoment && latestMoment.isValid() ? latestMoment.format('ll') : (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(report?.['createdAt']).format('ll');
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "right-info-hyper-icon",
                    style: {
                        top: '-20px',
                        right: '-20px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "cp info-icon pr ml0-5rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "",
                            src: (parcelRequire("6WOfV")),
                            alt: "three-dot-icon"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "cp w100 h100",
                        style: {
                            minHeight: '130px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon-diligenstia mr1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "br5px w50px",
                                            src: (parcelRequire("jSVu6")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "df fdc mr1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "w100 fs0-75rem fw300 c12 mb0-5rem",
                                                children: "Diligentsia ResearchAid"
                                            }),
                                            report?.['htmlReport'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: permissionLevel != 'DASHBOARD' && `#${report['_id']}?${report['reportType']}-researchaid`,
                                                onClick: ()=>handleReportRedirect(report),
                                                className: "w100 fs1rem c15",
                                                children: report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']
                                            }) : report['reportType'] == 'swotAnalysis' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleReportName(report),
                                                className: "cp w100 bg1 fs1rem tal c15",
                                                children: report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "w100 fs1rem c12 op60",
                                                children: report['name'].length > 30 ? report['name'].substring(0, 30) + '...' : report['name']
                                            })
                                        ]
                                    }),
                                    report?.['htmlReport'] && company['subscription'] == 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: `/researchAid/${company['_id']}#${report['_id']}?${report['reportType']}`,
                                                state: {
                                                    company: company
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "cp fa fa-edit pl1rem c3",
                                                    style: {
                                                        fontSize: '20px',
                                                        fontWeight: '400'
                                                    }
                                                })
                                            }),
                                            report?.['history'] && report['history'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "cp module-tooltip-box",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "hover-list",
                                                        style: {
                                                            position: 'relative',
                                                            left: 'auto',
                                                            top: 'auto'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "cp fa fa-history pl1rem c4",
                                                            style: {
                                                                fontSize: '20px',
                                                                fontWeight: '400'
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "tooltip-area tooltip-reaserchaid",
                                                        children: historyRows.map((data)=>{
                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "overlay-box",
                                                                style: {
                                                                    padding: '5px 10px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic  w100",
                                                                    children: [
                                                                        data?.['userId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`,
                                                                            className: "shadow w2rem h2rem bg16 bw3px bss bo19 df jcc aic br100 c1 mr0-5rem",
                                                                            children: data['userId']['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                src: data['userId']['profile'],
                                                                                className: "new-shadow w30px h30px df jcc aic br100 bg16 c1",
                                                                                "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "bg16 c15 br50px",
                                                                                "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`,
                                                                                children: data['userId']?.firstName ? data['userId'].firstName[0] + (data['userId'].lastName?.[0] || "") : "?"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "text-box df aic jcsb w100",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c15",
                                                                                    style: {
                                                                                        fontSize: '10px'
                                                                                    },
                                                                                    children: data['lastUpdatedTime'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        children: data['lastUpdatedTime']
                                                                                    })
                                                                                }),
                                                                                data['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                    onClick: ()=>deleteHistoryRecord(report['_id'], data['_id'], type),
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "fa fa-trash c9 cp",
                                                                                        style: {
                                                                                            fontSize: '20px'
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            });
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `w100 df jcsb px1rem ${report?.['reportType'] == 'TCAR3' ? 'mt1rem' : 'mt2rem'}`,
                                children: [
                                    !report?.['htmlReport'] && !(report?.['reportType'] == 'swotAnalysis' && report?.['disableSwotReport']) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: isGenerateAllResearchAid ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: `cna br25px px3rem cp bg16 py0-5rem `,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$67ad50c48ca3ede4), {
                                                height: "20",
                                                width: "20",
                                                strokeWidth: "4",
                                                secondaryColor: "#f9f9f9",
                                                color: "#000",
                                                ariaLabel: "oval-loading"
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: `/researchAid/${company['_id']}?${report['reportType']}`,
                                            // data-tooltip={((user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id']) ? `${user['role']} can't generate report from company dashboard!` : ''}
                                            state: {
                                                company: company
                                            },
                                            className: `c1 fs0-75rem fw600 td250 br25px px2rem py0-5rem cp bg4 bg3-hover`,
                                            children: "Generate"
                                        })
                                    }) : report?.['htmlReport'] && creator && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            company['subscription'] == 'Free' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "df fdc mt1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "w100 fs0-75rem fw300",
                                                        children: "Executive Summary only."
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "w100 fs0-75rem fw300",
                                                        children: [
                                                            "To ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                class: "c7 fw500",
                                                                children: "UNLOCK"
                                                            }),
                                                            " upgrade to PRO/LITE"
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "df jcsb mt1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`,
                                                        className: "shadow w40px h40px bg16 bw3px bss bo19 df jcc aic br100 c1",
                                                        children: creator?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: creator.profile,
                                                            className: "new-shadow w30px h30px df jcc aic br100 bg16 c1",
                                                            "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "bg16 c15 br50px",
                                                            "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`,
                                                            children: creator?.firstName ? creator.firstName[0] + (creator.lastName?.[0] || "") : "?"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "fs0-75rem c15 ml0-5rem",
                                                        children: latestDate
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: `fs1-5rem tac ${report?.['score'] >= 4 ? 'c34' : report?.['score'] >= 2 ? 'c39' : 'c4'}`,
                                                        children: [
                                                            report?.['score'],
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                class: "fs0-75rem",
                                                                children: "/5"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "fs0-75rem fw400 c15",
                                                        children: [
                                                            "Report ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " Score"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    report?.['reportType'] == 'swotAnalysis' && report?.['disableSwotReport'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-75rem fw300 c14 tti",
                                        children: "Please complete the other 4 reports prior to generating this report"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    const dummyReportCard = (subscription)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "right-info-hyper-icon",
                    style: {
                        top: '-20px',
                        right: '-20px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "cp info-icon pr ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "",
                                src: (parcelRequire("6WOfV")),
                                alt: "three-dot-icon"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "overlay-box",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c15",
                                    children: "What is it?"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "cp w100 h100",
                        style: {
                            minHeight: '130px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon-diligenstia mr1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "br5px w50px",
                                            src: (parcelRequire("jSVu6")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "df fdc mr1rem",
                                        children: "Your Report Here"
                                    }),
                                    subscription == 'PRO' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                "data-tooltip": "Edit",
                                                className: "cp fa fa-edit pl1rem c3",
                                                style: {
                                                    fontSize: '20px',
                                                    fontWeight: '400'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                "data-tooltip": "History",
                                                className: "cp fa fa-history pl1rem c4",
                                                style: {
                                                    fontSize: '20px',
                                                    fontWeight: '400'
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df jcsb mt3rem px1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "df fdc mt1rem",
                                        children: subscription == 'PRO' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "w100 fs0-75rem fw300",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    class: "c7 fw500",
                                                    children: "UNLOCK"
                                                }),
                                                " to edit/rerun full report. ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " Plus create your own reports"
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            class: "w100 fs0-75rem fw300",
                                            children: [
                                                "Upgrade to LITE. ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    class: "c7 fw500",
                                                    children: "UNLOCK"
                                                }),
                                                " full ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " report to see how others see you"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: `fs1-5rem tac c12`,
                                                children: "0.0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "fs0-75rem fw400 c12",
                                                children: [
                                                    "Report ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " Score"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    };
    const upgradeCard = (subscription)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "shadow bg1 tac w100 h200px p1rem br30px",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "pr",
                    style: {
                        bottom: '20%'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "shadow c59 fs1-25rem px1-5rem br10px bw1px bo59 bss ttu",
                        style: {
                            background: '#E4FFEB'
                        },
                        children: subscription
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "subs-btn mt0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "fs1rem fw500 c15 mb0-5rem",
                            children: [
                                "Have you thought ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                " about upgrading?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/billing/${company['_id']}`,
                            className: "bg4 bg3-hover fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac mt0-5rem",
                            children: "Find out more"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sectionWrapper py1rem fs0-75rem pr anylist-builder-tab",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "fs1-25rem c15 w100 pl1rem mb2rem",
                                children: [
                                    "Research Aid Reports - ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "fw600 c7 ttu",
                                        children: company['subscription']
                                    })
                                ]
                            }),
                            researchAidReports && researchAidReports.length > 0 && researchAidReports.map((item)=>reportCard(item, 'researchAidReports')),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "research-aid-ai-img",
                                children: researchAidReports && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "pa r0 b0",
                                    src: (parcelRequire("1icau")),
                                    alt: "research-aid-ai"
                                })
                            })
                        ]
                    }),
                    company['subscription'] == 'Pro' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "fs1-25rem c15 w100 pl1rem mb2rem",
                                children: [
                                    "User Generate Reports - ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "fw600 c7 ttu",
                                        children: "PRO"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "df jcc aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/researchAid/${company['_id']}?customReport`,
                                    state: {
                                        company: company
                                    },
                                    className: `w25 keyfeature-wihte-item br15px p2rem mx1rem cp bg3`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic my3rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "fa fa-plus-circle cp mr2rem c1",
                                                style: {
                                                    fontSize: '48px'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "c1 fs1-25rem fw400",
                                                children: [
                                                    "ResearchAid ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " Report Builder"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            reports && reports.length > 0 && reports.map((item)=>reportCard(item, 'customReports')),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "research-aid-ai-img",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "pa r0 b0",
                                    src: (parcelRequire("5r3ds")),
                                    alt: "research-aid-ai"
                                })
                            })
                        ]
                    }),
                    company['subscription'] == 'Free' && !company?.['servicedBy'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "fs1-25rem c15 w100 pl1rem",
                                children: [
                                    "Research Aid Reports - ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "fw600 c7 ttu",
                                        children: "Lite"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb py1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "grs1-md df fdc aic tac w20 mt1rem",
                                        children: upgradeCard('Lite')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fww w80 coreworkspace-update",
                                        children: dummyReportCard('Lite')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "research-aid-ai-img",
                                children: researchAidReports && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "pa r0 b0",
                                    src: (parcelRequire("5lyHS")),
                                    alt: "research-aid-ai"
                                })
                            })
                        ]
                    }),
                    (company['subscription'] == 'Free' || company['subscription'] == 'Lite') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "fs1-25rem c15 w100 pl1rem",
                                children: [
                                    "Research Aid Reports - ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "fw600 c7 ttu",
                                        children: "PRO"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb py1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "grs1-md df fdc aic tac w20 mt1rem",
                                        children: upgradeCard('PRO')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fww w80 coreworkspace-update",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                "data-tooltip": "Upgrade to PRO for create custom report",
                                                className: `bo7 w25 keyfeature-wihte-item bg3 br15px p2rem mx1rem op30 cna`,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic my3rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "fa fa-plus-circle cp mr2rem c1",
                                                            style: {
                                                                fontSize: '48px'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                            className: "c1 fs1-25rem fw400",
                                                            children: [
                                                                "ResearchAid ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                " Report Builder"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            dummyReportCard('PRO')
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "swotReportPopup",
                open: modal['open'] == 'swotReportPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc my3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1-5rem",
                                            children: "SWOT Analysis Report"
                                        }),
                                        isSwotReport ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem c15 mb1rem tac",
                                            children: [
                                                "Generate the other ResearchAid reports before ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " generating the SWOT Report"
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem c15 mb1rem tac",
                                            children: [
                                                "The SWOT report will produce better results if you first generate  ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " the Technology Competitive Advantage Report"
                                            ]
                                        })
                                    ]
                                }),
                                isSwotReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "bg4 fs0-75rem fw600 c1 td250 br30px px4rem py0-5rem cp tac",
                                        children: "Back"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsa mt2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "bg4 fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: `/researchAid/${company['_id']}?swotAnalysis`,
                                            state: {
                                                company: company
                                            },
                                            className: `fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac cp bg3`,
                                            children: "Generate"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");


var $7JB23 = parcelRequire("7JB23");


var $acw62 = parcelRequire("acw62");





function $b6a1128853993c07$export$2e2bcd8739ae039({ profileClass: profileClass, user: user, auditReportLogs: auditReportLogs, company: company }) {
    let [tabPanel, setTabPanel] = (0, $acw62.useState)('Last Month');
    const downloadPDF = async ()=>{
        const input = document.getElementById('rootElementId');
        (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(input).then((canvas)=>{
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 600;
            const pageHeight = 841.88976378;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            heightLeft -= pageHeight;
            const pdf = new (0, $15d064020a078dff$export$ba1e2ffc633a60f5)({
                orientation: 'p',
                unit: 'pt',
                format: [
                    600,
                    841.88976378
                ]
            });
            pdf.addImage(canvas, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
            while(heightLeft >= 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(canvas, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
                heightLeft -= pageHeight;
            }
            pdf.save(`Company-Audit.pdf`);
        });
    };
    const companyLogTable = (logs)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            id: "table",
            className: "table-company-log bg1",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    className: "ps t0",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "By"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Changes"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Time"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Module"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: auditReportLogs && auditReportLogs[logs] && auditReportLogs[logs].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: auditReportLogs[logs].map((log)=>{
                            if (log?.['userId']) return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df tac aic jcc w100",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                "data-tooltip": log?.['userId']?.['firstName'] ? log['userId']['firstName'] + " " + log['userId']['lastName'] : "Register to show your name here",
                                                className: `w2rem h2rem df jcc aic br100 ${profileClass}`,
                                                children: log?.['userId']?.['firstName'] ? log['userId']['firstName'][0] + log['userId']['lastName'][0] : "?"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "",
                                        children: log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Selected Option"
                                                        }),
                                                        ": ",
                                                        log?.['change']?.['radioOption'] ? log?.['change']['radioOption'] : '-'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Changed Status"
                                                        }),
                                                        ": ",
                                                        log?.['change']?.['status'] ? log?.['change']['status'] : '-'
                                                    ]
                                                }),
                                                log?.['change']?.['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "df jcc aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            children: "Files:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df fdc",
                                                            children: log['change']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                    to: file['location'],
                                                                    target: "_blank",
                                                                    className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem my0-5rem",
                                                                    children: file['originalname']
                                                                }, idx))
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(log?.['timestamp']).format('lll')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "ttc",
                                        children: (log?.['payload']?.['questionsAndAnswersToSave'][0]?.['type']).replaceAll("-", " ")
                                    })
                                ]
                            });
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        className: "pa mt1rem fs1-25rem fw500",
                        style: {
                            left: '45%'
                        },
                        children: "No Audit Log History!"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container bg1 py2rem mih70vh company-audit-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            id: "rootElementId",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "report-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "logo-report mb1rem df jcsb aic w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h2rem",
                                    src: (parcelRequire("b0Cmg")),
                                    alt: "TODO"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>downloadPDF(),
                                    className: "h100 my0-5rem shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen fds h1rem f1 mr0-5rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 640 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                })
                                            ]
                                        }),
                                        "Download PDF"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gtcr2a gg2rem mb1-3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h100 df fdc jcsb",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "ass fs1rem mb0-5rem",
                                                children: "Company Name"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1rem fw700 lh1 ttu usn c6",
                                                children: company['cName']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "ass fs1rem mt0-5rem mb0-5rem",
                                                children: "Test Type"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1rem fw700 lh1 ttu usn c6",
                                                children: company['testType']
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "right-list",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Subscription ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: company['subscription']?.toUpperCase()
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Company Reg ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: company['ukRegNo']
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Issue Date ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['updatedAt']).format("MMM Do YYYY")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Generated By ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: company['creatorId']['email']
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading-area mb2rem tac df fdc jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "w200 c6 lh2 fs1-25rem",
                                style: {
                                    borderBottom: '3px solid #002d63'
                                },
                                children: "Company Audit Log History"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "table-area-company-log",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc aic advisor-index",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                            value: tabPanel,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4de90d51946fb4d3$export$2e2bcd8739ae039), {
                                    onChange: (e, value)=>setTabPanel(value),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            className: "fs0-5rem fw600",
                                            label: "Last Week",
                                            value: "Last Week"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            className: "fs0-5rem fw600",
                                            label: "Last Month",
                                            value: "Last Month"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                            className: "fs0-5rem fw600",
                                            label: "Last Quarter",
                                            value: "Last Quarter"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Last Week",
                                    children: companyLogTable('weekLogs')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Last Month",
                                    children: companyLogTable('monthLogs')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100",
                                    value: "Last Quarter",
                                    children: companyLogTable('quaterLogs')
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");





























function $eeccad8a63eab6e4$export$2e2bcd8739ae039({ company: company, setTab: setTab, setIsWorkflowReport: setIsWorkflowReport, setCompanyDashboardTab: setCompanyDashboardTab, permissionLevel: permissionLevel, isLoading: isLoading }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [isShown, setIsShow] = (0, $acw62.useState)(true);
    let [feedbackNote, setFeedbackNote] = (0, $acw62.useState)('');
    let [isSaveChecklistBox, setIsSaveChecklistBox] = (0, $acw62.useState)(true);
    let [feedback, setFeedback] = (0, $acw62.useState)("I\u2019m just exploring for now");
    let [isDemoPartnerChecklist, setIsDemoPartnerChecklist] = (0, $acw62.useState)(false);
    const createBoxes = [
        {
            title: '3-Click Checklist',
            timeImg: (parcelRequire("1zadQ")),
            points: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Internal"
                }),
                'Quick and easy',
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Bespoked to ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "your company"
                        })
                    ]
                }),
                '10 sections x 10 question',
                'Yes/No answers',
                'Reporting & Workflow Manager'
            ],
            lockImg: (parcelRequire("8o63N"))
        },
        {
            title: "\u201CFull-Fat\u201D Checklist",
            timeImg: (parcelRequire("3ifeb")),
            points: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Internal"
                }),
                'Manual question input or use AI',
                'Editable',
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Bespoked to ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "your company"
                        })
                    ]
                }),
                'You choose style',
                'You choose length',
                'You choose risk scoring or not',
                'You choose team member permissions',
                'Reporting & Workflow Manager'
            ],
            lockImg: (parcelRequire("8o63N"))
        },
        {
            title: 'M&A Checklist',
            timeImg: (parcelRequire("jF4Gg")),
            points: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "External"
                }),
                'Manual question input or use AI',
                'Editable',
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Bespoked to your ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "target company"
                        })
                    ]
                }),
                'You choose style',
                'You choose length',
                'You choose risk scoring or not',
                'Reporting & Workflow Manager',
                'You choose team member permissions',
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: "Send to external parties for completion"
                })
            ],
            lockImg: (parcelRequire("8o63N"))
        }
    ];
    const saveChecklistBoxes = [
        // {
        // 	title: localStorage.getItem('isPartnerChecklist') ? 'Complete Registration' : 'Register Now',
        // 	textBottom: `${localStorage.getItem('isPartnerChecklist') ? 'Add your password ' : 'Register your company '} for FREE now (no credit card required) to preserve your dashboard and access your reports`,
        // 	btnText: <>{localStorage.getItem('isPartnerChecklist') ? 'Add Password' : 'Register for FREE'}<i className="db w100 fs0-5rem tal" style={{ marginTop: '-4px' }}>{localStorage.getItem('isPartnerChecklist') ? 'to complete registration' : 'No credit card required'}</i></>,
        // 	linkTo: '/register',
        // },
        {
            title: 'Register Now',
            textBottom: 'Register your company for FREE now (no credit card required) to preserve your dashboard and access your reports',
            btnText: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Register for FREE",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        className: "db w100 fs0-5rem tal",
                        style: {
                            marginTop: '-4px'
                        },
                        children: "No credit card required"
                    })
                ]
            }),
            linkTo: '/register'
        },
        {
            title: 'Are you an Investor?',
            textBottom: 'Check whether your firm/funds is already pre-populated in our 700 investor database. If so, we can add your demo checklist to your account',
            btnText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Investor Database Check"
            }),
            tootlTipInfo: {
                tooltip: [
                    'Check whether your firm/funds is already pre-populated in our 700 investor database '
                ]
            },
            linkTo: '/landing-page-vcs#investor-lookup'
        }
    ];
    (0, $acw62.useEffect)(()=>{
        let anylistHowTo = localStorage.getItem('anylistHowTo');
        if (!anylistHowTo && company['modules'] && !Object.values(company['modules']).filter((item)=>item?.['category'] == "internal" && !item['isHealthBoost']).length) setIsShow(false);
        if (localStorage.getItem('isDemoChecklist') || localStorage.getItem('isPartnerChecklist')) {
            setIsDemoPartnerChecklist(true);
            setIsShow(true);
        } else setIsDemoPartnerChecklist(false);
        let moduleName;
        if (location?.hash) moduleName = location.hash.split('#')[1];
        if (moduleName) setIsSaveChecklistBox(false);
    }, []);
    const showPercent = (value, type)=>{
        let color;
        if (value > 0) {
            if (type == 'Module Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
            else if (type == 'Module Complete') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
        } else color = 'c28';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
            className: `${color} fs2rem lh1 mr2rem`,
            children: [
                value || 0,
                "%",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `${value > 0 ? 'c15 ' : 'c28 '} fs0-75rem w4rem db fw300`,
                    children: type
                })
            ]
        });
    };
    const navigateSection = async (tab, sectionNo)=>{
        await setTab(tab);
        setTimeout(()=>{
            let element = document.getElementById(sectionNo);
            if (element) element.scrollIntoView({
                behavior: 'instant'
            }, true);
        }, 1000);
    };
    const handleModuleToolTip = async (section)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if (isDemoPartnerChecklist) return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'noRegistrationPopup'
        }));
        await navigateSection(section['moduleName'], section['sectionNo']);
        setCompanyDashboardTab('Dashboard');
    };
    // Collect a section's questions including all nested sub-folder questions.
    const collectSectionQuestions = (section)=>{
        let questions = [
            ...section?.['questions'] || []
        ];
        const walk = (subFolders)=>{
            if (!subFolders || typeof subFolders !== 'object') return;
            Object.values(subFolders).forEach((sf)=>{
                if (sf?.['questions']) questions = questions.concat(sf['questions']);
                if (sf?.['subFolders']) walk(sf['subFolders']);
            });
        };
        walk(section?.['subFolders']);
        return questions;
    };
    // Completeness + risk gradient for a section. Computes from the section's actual question answers
    // (same as the module sidebar) when questions are present; falls back to cached section.stats otherwise.
    const getSectionBackground = (section)=>{
        const questions = collectSectionQuestions(section).filter((q)=>q && !q['isSkipped']);
        let completeness = 0;
        let riskColour = 7;
        let hasEngagement = false;
        if (questions.length > 0) {
            const answered = questions.filter((q)=>[
                    'Completed',
                    'Not Applicable'
                ].includes(q?.['answer']?.['status']));
            completeness = Math.round(answered.length / questions.length * 100);
            let yesCount = 0, noCount = 0;
            questions.forEach((q)=>{
                const opt = q?.['answer']?.['radioOption'];
                if (opt === 'Yes') yesCount++;
                else if (opt === 'No' || opt === 'Disclosure' || opt === 'Not Sure') noCount++;
            });
            const totalYesNo = yesCount + noCount;
            hasEngagement = completeness > 0 || totalYesNo > 0;
            const riskPercent = totalYesNo > 0 ? noCount / totalYesNo * 100 : 0;
            riskColour = riskPercent <= 33 ? 7 : riskPercent >= 66 ? 9 : 8;
        } else {
            // No questions loaded (lightweight overview) — use cached stats.
            completeness = section?.['stats']?.['completionPercent'] || 0;
            const riskPercent = section?.['stats']?.['riskPercent'] || 0;
            hasEngagement = completeness > 0 || riskPercent > 0;
            riskColour = riskPercent < 38 ? 7 : riskPercent > 62 ? 9 : 8;
        }
        const hexColour = riskColour == 8 ? "#ddb64044" : riskColour == 9 ? "#dd404044" : "#40dda144";
        // Fill to completeness; a section that is engaged (answered) but 0% complete still shows a full bar — matches the sidebar.
        const fillPercent = completeness > 0 ? completeness : hasEngagement ? 100 : 0;
        return `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${fillPercent}%, #f0f0f8 ${fillPercent}%)`;
    };
    const checklistModuleTooltip = (sections)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `cp module-tooltip-box`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "hover-list",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("9gCOW")),
                        className: "pa",
                        alt: "list-img"
                    })
                }),
                sections && sections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "tooltip-area",
                    children: sections.map((section, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: ()=>handleModuleToolTip(section),
                            style: {
                                background: getSectionBackground(section)
                            },
                            "data-scroll-to": section['sectionNo'],
                            className: "overlay-box tal w100 tac cp c3-hover",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: section['sectionName']
                            })
                        }, idx);
                    })
                })
            ]
        });
    };
    const setModuleTab = async (module)=>{
        if ((user['role'] == "Advisor" || user['role'] == 'Investor') && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if (isDemoPartnerChecklist) return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'noRegistrationPopup'
        }));
        if (module['isActive']) {
            await setTab(module?.['type']);
            setCompanyDashboardTab('Dashboard');
        }
    };
    const setChecklitsReportTab = async (moduleName, type)=>{
        if (isDemoPartnerChecklist) return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'noRegistrationPopup'
        }));
        if (type == 'workflow-report') {
            await setIsWorkflowReport(true);
            localStorage.setItem('isWorkflowOpen', true);
        }
        await setTab(`${moduleName}-report`);
        setCompanyDashboardTab('Dashboard');
    };
    const checklistModules = (modules)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: modules.length > 0 ? Object.values(modules).map((module)=>{
                const isCreator = module['createdBy'] && module['createdBy']['_id'] == user['_id'];
                const isAdvisor = user['role'].toLowerCase() == 'advisor';
                const isInvestor = user['role'].toLowerCase() == 'investor';
                let showRisk = true;
                if (module?.['riskScoring'] == false) showRisk = false;
                else showRisk = true;
                const moduleKey = module['moduleKey'];
                const advisorModules = company?.['advisors']?.[user['_id']]?.['modules'];
                const investorModules = company?.['investors']?.[user['_id']]?.['modules'];
                const hasAdvisorAccess = advisorModules && Object.keys(advisorModules).some((k)=>k.replace(/\d+$/, '') === moduleKey && advisorModules[k]);
                const hasInvestorAccess = investorModules && Object.keys(investorModules).some((k)=>k.replace(/\d+$/, '') === moduleKey && investorModules[k]);
                const notAccessible = company['_id'] !== user?.['companyId']?.['_id'] && module['isActive'] && !isDemoPartnerChecklist && (company?.['memberPermissions']?.[user?._id] && !company?.['memberPermissions']?.[user?._id]?.[module?.['moduleKey']] || isAdvisor && !isCreator && advisorModules && !hasAdvisorAccess) || isInvestor && !isCreator && investorModules && !hasInvestorAccess;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb ${isDemoPartnerChecklist && 'op60'} ${module?.['createdBy']?.['role'] == 'Advisor' && ' advisor-bg'} ${module?.['createdBy']?.['role'] == 'Investor' && ' investor-bg'}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "right-info-hyper-icon right-info-dashboard-area",
                            children: (module['moduleDescription'] || module?.['sections']?.[0]?.['moduleDescription']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "info-icon cp pr ml0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "27",
                                        height: "27",
                                        viewBox: "0 0 27 27",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                cx: "13.5",
                                                cy: "13.5",
                                                r: "13.5",
                                                transform: "matrix(1 0 0 -1 0 27)",
                                                fill: "#59B8FD"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                fill: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "shadow overlay-box",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "pl1rem py0-5rem fs1rem c15 fw400 tti",
                                            children: module['moduleDescription'] || module?.['sections']?.[0]?.['moduleDescription']
                                        })
                                    })
                                ]
                            })
                        }),
                        module['isActive'] && module?.['sections'] && checklistModuleTooltip(module['sections']),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: `tooltip-area style-two pa df aic jcsb w90 ${!module['isActive'] && ' op0-5'}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "percentage-area df jcc aic",
                                    children: [
                                        showPercent(module?.['stats']['completionPercent'], 'Module Complete'),
                                        showRisk && showPercent(module?.['stats']['riskPercent'], 'Module Risk')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `df bg1 br50px bw1px bss fs0-75rem px1rem py0-5rem mb1rem bsbb aic ${module['isActive'] ? 'bo3 c3' : 'bo12 c12'}`,
                                    children: module['isActive'] ? 'Activated' : 'Deactivated'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `df w100 ${!module['isActive'] && ' op0-5'}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: notAccessible ? "#" : module['isActive'] && !isDemoPartnerChecklist && `#${module?.['type']}`,
                                onClick: async (e)=>notAccessible ? (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You do not have permission to access this module.") : setModuleTab(module),
                                className: "df aic w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon-diligenstia mr1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "br5px w50px",
                                            src: module?.['imageURL'] || (parcelRequire("jSVu6")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: `fs1rem fw500 bg1 c15 lh2 title-box-feature tal ${module['isActive'] && ' cp c4-hover'}`,
                                        style: {
                                            background: 'transparent'
                                        },
                                        children: module['moduleName']
                                    })
                                ]
                            })
                        }),
                        (permissionLevel == "ALL" || permissionLevel == "DASHBOARD & REPORT") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "report-bottom-area",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: module?.['stats'].completionPercent > 0 && module['isActive'] && !isDemoPartnerChecklist && `#${module['type']}-report`,
                                    onClick: ()=>{
                                        module?.['stats'].completionPercent > 0 && module['isActive'] && setChecklitsReportTab(module['type'], 'module-report');
                                    },
                                    className: `w2rem h2rem df jcc mr0-5rem aic br100 c1 report-btn pr ${module?.['stats'].completionPercent > 0 && module['isActive'] ? ' bg3 bg4-hover' : ' bg12'}`,
                                    children: [
                                        "R",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "overlay-box",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c15 df aic",
                                                children: [
                                                    "Module Report",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon ml0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "12",
                                                            height: "14",
                                                            viewBox: "0 0 12 14",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                fill: "#505050"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                company['subscription'] == 'Pro' && module?.['createdBy']?.['_id'] == user['_id'] && !isDemoPartnerChecklist && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    className: "cp w2rem h2rem df jcc mr0-5rem aic br100 c1 report-btn pr bg3 bg4-hover",
                                    to: `/createChecklist?companyId=${company['_id']};cName=${company['cName']}#${module?.['_id']}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "c1 fa fa-edit",
                                            style: {
                                                fontSize: '16px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "overlay-box",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c15 df aic",
                                                children: [
                                                    "Edit Checklist",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon ml0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "12",
                                                            height: "14",
                                                            viewBox: "0 0 12 14",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                fill: "#505050"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: module?.['stats'].completionPercent > 0 && module['isActive'] && !isDemoPartnerChecklist && `#${module['type']}`,
                                    onClick: ()=>{
                                        module?.['stats'].completionPercent > 0 && module['isActive'] && setChecklitsReportTab(module['type'], 'workflow-report');
                                    },
                                    className: `w2rem h2rem df jcc aic br100 c1 report-btn pr ${module?.['stats'].completionPercent > 0 && module['isActive'] ? ' bg3 bg4-hover' : ' bg12'}`,
                                    children: [
                                        "WF",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "overlay-box",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c15 df aic",
                                                children: [
                                                    "Workflow Report",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon ml0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "12",
                                                            height: "14",
                                                            viewBox: "0 0 12 14",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                fill: "#505050"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "w100 tac fs1-75rem fw500 c14 fsi",
                children: "No Checklist Created!"
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isShown || company?.['modules'] && Object.values(company['modules']).filter((item)=>{
                const userRole = user?.['role']?.toLowerCase?.() || '';
                const creatorRole = item?.['createdBy']?.['role']?.toLowerCase?.() || '';
                return (item?.['category'] == "internal" || item?.['category'] == "external") && !item['isHealthBoost'] && !([
                    'advisor',
                    'investor'
                ].includes(userRole) && item?.['category'] == "internal" && ![
                    'advisor',
                    'investor'
                ].includes(creatorRole));
            }).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "sectionWrapper py1rem fs0-75rem pr anylist-builder-tab",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                        href: !isDemoPartnerChecklist && company['subscription'] == 'Pro' && `/createChecklist?companyId=${company['_id']};cName=${company['cName']}`,
                        target: "_blank",
                        onClick: ()=>{
                            if (!isDemoPartnerChecklist && company['subscription'] == 'Pro') localStorage.setItem('checklistCreatedFromNewUrl', window.location.pathname.includes('/company/') ? '1' : '0');
                        },
                        "data-tooltip": isDemoPartnerChecklist ? 'You must register to access it' : company['subscription'] != 'Pro' ? 'Upgrade to Pro for Add/Edit checklist' : '',
                        className: `df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard pa t0 r0 audit-log-btn ${(isDemoPartnerChecklist || company['subscription'] != 'Pro') && 'op30 cna'}`,
                        style: {
                            width: '206px',
                            marginBottom: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    width: "38",
                                    height: "38",
                                    viewBox: "0 0 38 38",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                            "clip-path": "url(#clip0_3623_3962)",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z",
                                                    fill: "#4A67FF"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M27.3098 20.5805H20.5805V27.3098C20.5805 28.1839 19.8714 28.893 18.9973 28.893C18.1232 28.893 17.4141 28.1839 17.4141 27.3098V20.5805H10.6848C9.8107 20.5805 9.10156 19.8714 9.10156 18.9973C9.10156 18.1232 9.8107 17.4141 10.6848 17.4141H17.4141V10.6848C17.4141 9.8107 18.1232 9.10156 18.9973 9.10156C19.8714 9.10156 20.5805 9.8107 20.5805 10.6848V17.4141H27.3098C28.1839 17.4141 28.893 18.1232 28.893 18.9973C28.893 19.8714 28.1839 20.5805 27.3098 20.5805Z",
                                                    fill: "#FAFAFA"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                id: "clip0_3623_3962",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                    width: "38",
                                                    height: "38",
                                                    fill: "white"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c15",
                                children: "Add/Edit Checklist"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: `fs1-25rem c15 w100 pl2rem mb1rem`,
                                children: "AnyList Checklists"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: !isDemoPartnerChecklist && company['subscription'] == 'Pro' && `/createChecklist?companyId=${company['_id']};cName=${company['cName']}`,
                                onClick: ()=>{
                                    if (!isDemoPartnerChecklist && company['subscription'] == 'Pro') localStorage.setItem('checklistCreatedFromNewUrl', window.location.pathname.includes('/company/') ? '1' : '0');
                                },
                                "data-tooltip": isDemoPartnerChecklist ? 'You must register to access it' : company['subscription'] != 'Pro' ? 'Upgrade to Pro for create checklist' : '',
                                className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb cp ${(isDemoPartnerChecklist || company['subscription'] != 'Pro') && 'op30 cna'}`,
                                style: {
                                    backgroundColor: '#4A67FF',
                                    borderColor: '#4A67FF50'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-plus-circle cp mr2rem c1",
                                            style: {
                                                fontSize: '48px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c1 fs1-25rem fw400",
                                            children: "Create New Checklist Module"
                                        })
                                    ]
                                })
                            }),
                            isLoading ? [
                                1,
                                2,
                                3
                            ].map((i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "skeleton-pulse br5px",
                                                    style: {
                                                        width: '60%',
                                                        height: '14px',
                                                        background: '#e8eaf0'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "skeleton-pulse br5px",
                                                    style: {
                                                        width: '25%',
                                                        height: '14px',
                                                        background: '#e8eaf0'
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "skeleton-pulse br5px mr1rem",
                                                    style: {
                                                        width: '50px',
                                                        height: '50px',
                                                        background: '#e8eaf0',
                                                        flexShrink: 0
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "skeleton-pulse br5px",
                                                    style: {
                                                        width: '70%',
                                                        height: '16px',
                                                        background: '#e8eaf0'
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "skeleton-pulse br5px mb0-5rem",
                                            style: {
                                                width: '100%',
                                                height: '10px',
                                                background: '#e8eaf0'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "skeleton-pulse br5px",
                                            style: {
                                                width: '80%',
                                                height: '10px',
                                                background: '#e8eaf0'
                                            }
                                        })
                                    ]
                                }, i)) : company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>{
                                const userRole = user?.['role']?.toLowerCase?.() || '';
                                const creatorRole = item?.['createdBy']?.['role']?.toLowerCase?.() || '';
                                return (item?.['category'] == "internal" || item?.['category'] == "external") && !item['isHealthBoost'] && !([
                                    'advisor',
                                    'investor'
                                ].includes(userRole) && item?.['category'] == "internal" && ![
                                    'advisor',
                                    'investor'
                                ].includes(creatorRole));
                            })),
                            localStorage.getItem('isPartnerChecklist') && isSaveChecklistBox && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'noRegistrationPopup'
                                    })),
                                className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb op60",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "df fw500 fs1-25rem aic",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem c15 ttc df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "icon-diligenstia mr1rem pr",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "br5px w50px",
                                                        src: (parcelRequire("jSVu6")),
                                                        alt: "checklist-logo"
                                                    })
                                                }),
                                                "KPI Report"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "right-info-hyper-icon",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "info-icon  pr ml0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "27",
                                                        height: "27",
                                                        viewBox: "0 0 27 27",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "13.5",
                                                                cy: "13.5",
                                                                r: "13.5",
                                                                transform: "matrix(1 0 0 -1 0 27)",
                                                                fill: "#59B8FD"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c15",
                                                            children: "What is it?"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "questionmark-icon pr ml0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "27",
                                                        height: "27",
                                                        viewBox: "0 0 27 27",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "13.5",
                                                                cy: "13.5",
                                                                r: "13.5",
                                                                fill: "#FC7785"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c15",
                                                            children: "Access detailed help pages and tell our AI Assistants what you require help with"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df mt2rem jcsb bottom-details w90",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem c28 mr2rem ",
                                                children: "AI generated & bespoked to your company"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'noRegistrationPopup'
                                            })),
                                        className: "report-btn report-btn pa",
                                        style: {
                                            bottom: '-19px',
                                            right: '-7px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "35",
                                            height: "35",
                                            viewBox: "0 0 35 35",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "17.5",
                                                    cy: "17.5",
                                                    r: "17.5",
                                                    fill: `url(#paint0_linear_2634_3594)`
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M12.808 24.3711V11.2802H17.7171C18.7228 11.2802 19.5666 11.4549 20.2484 11.8043C20.9345 12.1538 21.4522 12.6438 21.8017 13.2745C22.1553 13.9009 22.3322 14.6317 22.3322 15.467C22.3322 16.3065 22.1532 17.0352 21.7953 17.6531C21.4416 18.2667 20.9196 18.7418 20.2292 19.0785C19.5389 19.4109 18.6909 19.5771 17.6852 19.5771H14.1887V17.6083H17.3656C17.9536 17.6083 18.4352 17.5273 18.8102 17.3654C19.1852 17.1992 19.4622 16.9585 19.6411 16.6431C19.8244 16.3235 19.916 15.9315 19.916 15.467C19.916 15.0025 19.8244 14.6062 19.6411 14.2781C19.4579 13.9457 19.1788 13.6942 18.8038 13.5238C18.4288 13.3491 17.9451 13.2617 17.3528 13.2617H15.1795V24.3711H12.808ZM19.5708 18.4393L22.8116 24.3711H20.1653L16.9821 18.4393H19.5708Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                        id: "paint0_linear_2634_3594",
                                                        x1: "41.65",
                                                        y1: "-24.9083",
                                                        x2: "-14.5036",
                                                        y2: "39.1152",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                "stop-color": "#A0B0FF"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                offset: "1",
                                                                "stop-color": "#4A67FF"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (localStorage.getItem('isDemoChecklist') || localStorage.getItem('isPartnerChecklist')) && isSaveChecklistBox && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "sectionWrapper pb1rem fs0-75rem pr save-checklit-tab",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                            style: {
                                backgroundColor: '#FDF5F3',
                                borderColor: '#FC7785'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: `fs1-25rem c15 w100 pl2rem mb1rem`,
                                    children: "Lastly! Save Your Checklist"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "left-ai-img w25 mr1rem pr",
                                    style: {
                                        marginLeft: '-55px',
                                        marginBottom: '-32px'
                                    },
                                    children: localStorage.getItem('isPartnerChecklist') ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w100 pa b0",
                                        src: (parcelRequire("bZGhT"))
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w100 pa b0",
                                        src: (parcelRequire("c9nfY"))
                                    })
                                }),
                                saveChecklistBoxes.map((box)=>{
                                    if (localStorage.getItem('isPartnerChecklist') && box['title'] == 'Are you an Investor?') return;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bo7 w25 bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb lastly-checklist",
                                        children: [
                                            box?.['tootlTipInfo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "right-info-hyper-icon right-info-dashboard-area",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "info-icon cp pr ml0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "27",
                                                            height: "27",
                                                            viewBox: "0 0 27 27",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                    cx: "13.5",
                                                                    cy: "13.5",
                                                                    r: "13.5",
                                                                    transform: "matrix(1 0 0 -1 0 27)",
                                                                    fill: "#59B8FD"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                    fill: "white"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "shadow overlay-box",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "pl1rem py0-5rem fs1rem c15 fw400 tti",
                                                                children: box?.['tootlTipInfo']['tooltip']
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1-25rem mb1rem c15 w100",
                                                children: box['title']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs1rem c12",
                                                style: {
                                                    height: '50%'
                                                },
                                                children: box['textBottom']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcc aic mt1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: box['linkTo'],
                                                    className: "w90 h3rem df jcsb cp bg4 br50px px1rem c1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: box['btnText']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "15",
                                                                height: "12",
                                                                viewBox: "0 0 15 12",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M1.02795 6.99367H11.6466L8.41576 10.2753C7.48773 11.2179 8.87978 12.6317 9.80781 11.6891L12.7503 8.69585L14.7145 6.69763C15.0952 6.30866 15.0952 5.68047 14.7145 5.2915L9.80781 0.30194C9.62113 0.107098 9.36417 -0.00222683 9.09645 3.43939e-05C8.21271 0.000147455 7.779 1.09346 8.41576 1.7159L11.6543 4.99753H0.977139C-0.383907 5.06612 -0.282283 7.06249 1.02795 6.99367Z",
                                                                    fill: "white"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "right-btn w20 ml1rem pr",
                                    style: {
                                        marginBottom: '27px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'notTodayPopup'
                                            })),
                                        className: "w100 bw1px bss bo4 df jcc cp bg1 br50px py0-5rem px1rem c4 tac pa b0",
                                        children: "Not today, thanks"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "sectionWrapper p1rem fs0-75rem pr anylist-builder-tab mt2rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bss p2rem br25px w100 keyfeature-box keyfeature-box-portfolio anylist-checklist anylist-checklist-steps df fww mb3rem pr bsbb ",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "w100 tac c15 fs1-75rem fw500",
                            children: "How does it work?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                            className: "w100 tac c15 fs1-25rem fw500 mb1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c3",
                                children: "AnyList Checklist Builder"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "step-top-box df w100 jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("aCagb")),
                                className: "w60",
                                style: {
                                    objectFit: 'fill'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-img df jcc px1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("4HKhG")),
                                        alt: "ste image"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-img df jcc px1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("30FZJ")),
                                        alt: "ste image"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-img df jcc px1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("hwktJ")),
                                        alt: "ste image"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "checklist-area aic df bg1 py0-5rem w70 mla mra br45px mb1rem jcsb bsbb",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "checklist-inner w100 pr df aic jcsb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "checklist-box w20 pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon pa",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w1rem",
                                                    src: (parcelRequire("fYwBE")),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c12 pl1-5rem db",
                                                children: "Quick and easy for you"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "checklist-box w20 pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon pa",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w1rem",
                                                    src: (parcelRequire("fYwBE")),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c12 pl1-5rem db",
                                                children: "Quick and easy for your target user"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "checklist-box w20 pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon pa",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w1rem",
                                                    src: (parcelRequire("gBgEl")),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c12 pl1-5rem db",
                                                children: "Reusable by the target company"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "checklist-box w30 pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon pa",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w1rem",
                                                    src: (parcelRequire("gBgEl")),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c12 pl1-5rem db",
                                                children: "Company gains value from completion - risks & recommendations"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc w100 mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>{
                                    setIsShow(true), localStorage.setItem('anylistHowTo', true);
                                },
                                className: "cp tac td250 dashboard-btn c1 bg4 bg3-hover br30px fs0-75rem fw500 mr0-5rem w110 td270 w200px p1rem ml2rem df aic jcc",
                                children: "Next"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "noRegistrationPopup",
                modalCardClasses: "maw800px",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fw600 tac w100",
                            children: "Registration"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc jcc my1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "my0-5rem c15 op70 fs14px",
                                        children: [
                                            "To view checklist or store/print your reports, ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " you need to register (no credit card required)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/register",
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "shadow bsbb jcc df fdc aic fw500  px1rem c1 bg4 br19px cp",
                                        style: {
                                            width: '44%',
                                            paddingTop: '4px',
                                            paddingBottom: '4px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Register for FREE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fw400 c21 df fdc",
                                                style: {
                                                    marginTop: "-2px",
                                                    fontSize: '10px',
                                                    lineHeight: '15px',
                                                    fontStyle: 'italic'
                                                },
                                                children: "No credit card required"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mt1-5rem c15 op70 fs11px fsi df aic tac lh1",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                            style: {
                                                color: "#4A67FF",
                                                fontSize: '12px',
                                                marginRight: '4px'
                                            }
                                        }),
                                        " Get access to more features. Store your test results plus FREE bonus KPI Report, all bespoked by AI to your company."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'notTodayPopup',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc jcc aic w700px mah90 oya bg20 shadow bsbb br20px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcsb px2rem",
                            style: {
                                backgroundImage: `url(${(parcelRequire("hJtjK"))})`,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df aic c1 fs1-25rem fw400",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "cp mr1rem",
                                            src: (parcelRequire("iF1TY")),
                                            alt: "icon"
                                        }),
                                        " Your Feedback"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "pr",
                                    style: {
                                        top: '11px'
                                    },
                                    src: (parcelRequire("697mI")),
                                    alt: "icon-img"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 bg1 px3rem py3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw300 c12 mb1-5rem",
                                    children: "Before you go, we'd love to know why you\u2019re choosing to pass on signing up for FREE today. Your feedback helps us make things better for everyone!"
                                }),
                                [
                                    "I\u2019m just exploring for now",
                                    "I didn\u2019t find the checklist useful",
                                    'The process feels too complicated',
                                    'Other (please specify):'
                                ].map((item)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        onClick: ()=>setFeedback(item),
                                        className: "cp df w100 mb0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                checked: feedback == item,
                                                id: item,
                                                className: "cp w20px h20px",
                                                name: "feedback",
                                                type: "radio",
                                                value: item
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "cp fs1rem fw300 ml0-5rem c15",
                                                for: item,
                                                children: item
                                            })
                                        ]
                                    });
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: feedbackNote || '',
                                    rows: "4",
                                    style: {
                                        resize: 'none'
                                    },
                                    name: "feedback-note",
                                    className: "lpins w100 br10px p1rem mt1rem",
                                    onChange: (e)=>setFeedbackNote(e.target.value),
                                    placeholder: "Write your reason..."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100 df jcc mt2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        className: "w40 tac cp c1 bg4 p1rem fw600 fs1rem br35px td250",
                                        onClick: ()=>(0, $bebe1cbb5a309c8c$export$5863150075eb9294)(),
                                        children: "Exit"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '100px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");



var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

const $78c4a013f0c22bc5$var$getInvestorMatchColoums = ({ type: type, strongCount: strongCount = 0, mediumCount: mediumCount = 0, lowCount: lowCount = 0 })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: type === "investor" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Investor"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Website"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: [
                        "Completeness",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "tooltip-area cp",
                            style: {
                                top: '1rem'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                className: "icon",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h2rem",
                                        src: (parcelRequire("24u8s")),
                                        alt: "info"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "overlay-box",
                                        style: {
                                            top: '100px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "This score is calculated on the responsiveness of this investor to  approaches via this platform \u2013 BUT please note that a response does NOT indicate successful funding."
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Priority Score"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Prompt Response Score"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Fit Report"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Contact Investor"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Date Contacted"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Archive"
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '170px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Investor"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Website"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Fit Score"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                    style: {
                        minWidth: '175px',
                        color: '#151313CC',
                        maxWidth: '300px'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: [
                        "Prompt ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Response Score"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Fit Report"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Contact Investor"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Date Contacted"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                    style: {
                        minWidth: '125px',
                        color: '#151313CC'
                    },
                    className: "fs1rem ttu tal customHeaderBgColor",
                    children: "Archive"
                })
            ]
        })
    });
};
var $78c4a013f0c22bc5$export$2e2bcd8739ae039 = $78c4a013f0c22bc5$var$getInvestorMatchColoums;



var $ayMG0 = parcelRequire("ayMG0");

const $9d1613998e3b1140$var$InvestorMatchUpgradeCard = ({ title: title, subTitle: subTitle, btnTxt: btnTxt, price: price, wrapperClass: wrapperClass, redirectLink: redirectLink })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "shadow bg1 p1rem br20px pr",
        style: {
            width: '280px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "br8px pa tac",
                style: {
                    background: title.includes('AppStore') ? '#FFECEE' : '#E4FFEB',
                    color: title.includes('AppStore') ? '#FC7785' : '#44D991',
                    border: title.includes('AppStore') ? '1px solid #FC7785' : '1px solid #A8EFAB',
                    top: '-18px',
                    minWidth: title.includes('AppStore') ? '120px' : '80px',
                    left: '50%',
                    paddingTop: '0.25rem',
                    paddingBottom: '0.25rem',
                    transform: `translateX(-50%)`
                },
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w100 df fdc aic jcc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "py1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "c3 fs1-5rem fw600",
                                        children: [
                                            "\xa3",
                                            price
                                        ]
                                    }),
                                    " / month*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "op60 c15 w100 tac fs12px",
                                children: "* billed annually"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "fs1rem c15 tac tac mb1rem",
                        style: {
                            width: '220px'
                        },
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                        text: btnTxt,
                        btnType: "warning",
                        onClick: ()=>window.location.href = redirectLink
                    })
                ]
            })
        ]
    });
};
var $9d1613998e3b1140$export$2e2bcd8739ae039 = $9d1613998e3b1140$var$InvestorMatchUpgradeCard;











const $46df257b3dd34ddd$var$BlurRow = ({ idx: idx })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "c15 poppins-font-style fw400 tal fs14px",
                style: {
                    minWidth: '170px',
                    filter: blur('5px')
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredinvestor",
                    src: (parcelRequire("93y1O"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "c3 tal",
                style: {
                    minWidth: '125px',
                    maxWidth: '300px',
                    filter: blur('5px')
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredwebsite",
                    src: (parcelRequire("cculX"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "c6 tal",
                style: {
                    minWidth: '125px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredpromptResponse",
                    src: (parcelRequire("8pEOX"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "c15 fs14px tal",
                style: {
                    minWidth: '125px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredpromptResponse",
                    src: (parcelRequire("8pEOX"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                className: "c6 df jcc fs14px tal",
                style: {
                    minWidth: '125px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredreport",
                    src: (parcelRequire("dzNWB"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                style: {
                    minWidth: '125px'
                },
                className: "c6",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredcontactInvestor",
                    src: (parcelRequire("bnIhg"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                style: {
                    minWidth: '125px'
                },
                className: `c6 unselectable`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "blureddateContacted",
                    src: (parcelRequire("2kqd2"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                style: {
                    minWidth: '125px'
                },
                className: `c6 tal unselectable`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredstatus",
                    src: (parcelRequire("esenB"))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                style: {
                    minWidth: '125px'
                },
                className: `c6 tal unselectable`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    alt: "bluredarchieve",
                    src: (parcelRequire("eaAwo"))
                })
            })
        ]
    }, idx);
};
// Helper function to ensure URL has protocol
const $46df257b3dd34ddd$var$formatWebsiteUrl = (url)=>{
    if (!url) return url;
    return url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
};















const $46df257b3dd34ddd$var$InvestorLeadList = ({ linearProgress: linearProgress, fitInvestorFirms: fitInvestorFirms, setFitInvestorFirms: setFitInvestorFirms, company: company, downloadPDF: downloadPDF, setTab: setTab, isLeadPdf: isLeadPdf, user: user, setIsBackFitReport: setIsBackFitReport, handleInvestorEmail: handleInvestorEmail, getFitInvestorFirms: getFitInvestorFirms, tab: tab, investorFirmCounts: investorFirmCounts, setInvestorFirmCounts: setInvestorFirmCounts })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [isShowFitReport, setIsShowFitReport] = (0, $acw62.useState)(false);
    const [selectedInvestor, setSelectedInvestor] = (0, $acw62.useState)(null);
    const [bestApplicants, setBestApplicants] = (0, $acw62.useState)(false);
    const allInvestorFirmsRef = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(()=>{
        if (fitInvestorFirms.length > 0 && !bestApplicants) allInvestorFirmsRef.current = fitInvestorFirms;
    }, [
        fitInvestorFirms
    ]);
    const handleBestApplicantsToggle = ()=>{
        const newValue = !bestApplicants;
        setBestApplicants(newValue);
        if (newValue) setFitInvestorFirms(allInvestorFirmsRef.current.filter((investor)=>investor.fitScorePercentage >= 50));
        else setFitInvestorFirms(allInvestorFirmsRef.current);
    };
    const { strongCount: strongCount, mediumCount: mediumCount, lowCount: lowCount } = (0, $acw62.useMemo)(()=>{
        if (!fitInvestorFirms?.length) return {
            strongCount: 0,
            mediumCount: 0,
            lowCount: 0
        };
        return fitInvestorFirms.reduce((acc, investor)=>{
            const score = investor.fitScorePercentage;
            if (score >= 83) acc.strongCount++;
            else if (score >= 66.6 && score < 83) acc.mediumCount++;
            else if (score < 66.6) acc.lowCount++;
            return acc;
        }, {
            strongCount: 0,
            mediumCount: 0,
            lowCount: 0
        });
    }, [
        fitInvestorFirms
    ]);
    (0, $acw62.useEffect)(()=>{
        if (fitInvestorFirms.length == 0) getFitInvestorFirms(true);
    }, []);
    const handleDeleteLead = async (investorId)=>{
        const clientId = company['_id'];
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/deleteInvestorLead`, {
            investorId: investorId,
            clientId: clientId
        });
        if (res && res['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            getFitInvestorFirms(true);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: Object.keys(company).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg1 br50px mr0-5rem pr1rem p0-5rem bsbb aic mr1rem cp",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "fs1-5rem df aic jcc c15 mt1rem",
                    children: [
                        "Investor",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4 mr0-5rem",
                            children: "Match"
                        }),
                        " Index"
                    ]
                }),
                isShowFitReport ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6123099ae995020$export$2e2bcd8739ae039), {
                    tab: tab,
                    user: user,
                    setTab: setTab,
                    company: company,
                    linearProgress: linearProgress,
                    fitInvestorFirms: fitInvestorFirms,
                    investorId: selectedInvestor?.['_id'],
                    setIsBackFitReport: setIsBackFitReport,
                    setIsShowFitReport: setIsShowFitReport,
                    module: company?.modules?.['investor-lead'],
                    getFitInvestorFirms: getFitInvestorFirms,
                    moduleCertification: company?.moduleCertification?.['investor-lead']
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `dg gg1-5rem sm-gtcr1 pt2rem ${company['cLevel'] && company['cLevel'].toLowerCase() === "gold" && company?.subscription && ![
                                'free',
                                'lite'
                            ].includes(company?.subscription.toLowerCase()) ? "gtcr3" : "investorMatchTopbar"}`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aifs fdc jcfe",
                                    children: [
                                        !company?.subscription || company?.subscription && [
                                            'free',
                                            'lite'
                                        ].includes(company?.subscription.toLowerCase()) ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("9J5Dz")),
                                            className: "mb1rem maw400px",
                                            alt: "info"
                                        }) : null,
                                        fitInvestorFirms.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    onClick: downloadPDF,
                                                    className: "df aic jcc c1 bg3 py0-5rem px1-5rem br50px cp fs14px mr1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {
                                                            className: "c1 mr0-5rem"
                                                        }),
                                                        "Download PDF"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    disabled: !company?.subscription || company?.subscription && [
                                                        'free',
                                                        'lite'
                                                    ].includes(company?.subscription.toLowerCase()),
                                                    to: !company?.subscription || company?.subscription && [
                                                        'free',
                                                        'lite'
                                                    ].includes(company?.subscription.toLowerCase()) ? null : '#share-diligence-pack',
                                                    onClick: ()=>!company?.subscription || company?.subscription && [
                                                            'free',
                                                            'lite'
                                                        ].includes(company?.subscription.toLowerCase()) ? (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('This module is restricted for your subscription. You need to upgrade.') : setTab('share-diligence-pack'),
                                                    className: "cp df jcc px1-5rem py0-5rem br25px bg4 c1 fs1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-share-alt c1 mr0-5rem"
                                                        }),
                                                        "Share Diligence Pack"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcfe fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic br50px bo31 bw1px bss py0-5rem px2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc aic jcc px1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c34 fs1-5rem fw600",
                                                            children: strongCount
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c15",
                                                            children: "Strong"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc aic jcc px1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c75 fs1-5rem fw600",
                                                            children: mediumCount
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c15",
                                                            children: "Medium"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        company['cLevel'] && company['cLevel'].toLowerCase() !== "gold" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic jcc br8px mt1rem",
                                            style: {
                                                border: '1px solid #F7D14E',
                                                padding: '4px 8px',
                                                background: '#FFF6C5',
                                                maxHeight: '64px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    width: 50,
                                                    src: (parcelRequire("bIdNX")),
                                                    alt: "gold"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "c15 ml0-5rem fs12px",
                                                    children: [
                                                        "+[",
                                                        Number(investorFirmCounts['gold']) + Number(investorFirmCounts['silver']) + Number(investorFirmCounts['bronze']) + Number(investorFirmCounts['threshold'] || 0),
                                                        "] more investors"
                                                    ]
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic jcc pt1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "df aic cp px1-5rem py0-5rem bw1px bo16 bss br30px",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c15 fs14px fw500 mr0-5rem",
                                                        children: "Best Applicants"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                        name: "bestApplicants",
                                                        className: "success w100",
                                                        checked: bestApplicants,
                                                        onChange: handleBestApplicantsToggle
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `df aife ${!company?.subscription || company?.subscription && 'free' === company?.subscription.toLowerCase() ? 'jcsb' : 'jcfe'} `,
                                    style: {
                                        gap: '1rem'
                                    },
                                    children: !company?.subscription || company?.subscription && 'free' === company?.subscription.toLowerCase() ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d1613998e3b1140$export$2e2bcd8739ae039), {
                                                title: 'LITE',
                                                price: 8.25,
                                                subTitle: 'Upgrade to release investor names',
                                                wrapperClass: 'mr1rem',
                                                btnTxt: 'Find out more',
                                                redirectLink: `/billing/${company['_id']}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d1613998e3b1140$export$2e2bcd8739ae039), {
                                                title: 'PRO',
                                                price: 83.25,
                                                subTitle: 'Upgrade to release investor detailed fit reports',
                                                btnTxt: 'Find out more',
                                                redirectLink: `/billing/${company['_id']}`
                                            })
                                        ]
                                    }) : company?.subscription && 'lite' === company?.subscription.toLowerCase() ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d1613998e3b1140$export$2e2bcd8739ae039), {
                                            title: 'PRO',
                                            price: 83.25,
                                            subTitle: 'Upgrade to release investor detailed fit reports',
                                            btnTxt: 'Find out more',
                                            redirectLink: `/billing/${company['_id']}`
                                        })
                                    }) : company['cLevel'] && company['cLevel'].toLowerCase() !== "gold" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("7dxat")),
                                        className: "maw400px",
                                        alt: "info"
                                    }) : ''
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mt1rem mb5rem w100 bsbb df fdc br20px pr customHeaderBgColor",
                            style: {
                                border: '1px solid #7385BE80'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "px1rem py1rem br20px",
                                    children: isLeadPdf ? /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "ass w100 tac c15 fs3rem lh1 my10rem",
                                        children: "Downloading..."
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                        id: "leadsPDF",
                                        className: `db oa investor-leads-tooltip ${user['role'].toLowerCase() === "user" ? "companySideInvestorMatch" : "investorMatchSide"}`,
                                        style: {
                                            height: '60vh'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                className: "",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                    style: {
                                                        verticalAlign: 'bottom'
                                                    },
                                                    children: (0, $78c4a013f0c22bc5$export$2e2bcd8739ae039)({
                                                        type: user['role'],
                                                        subscription: company['subscription'],
                                                        strongCount: strongCount,
                                                        mediumCount: mediumCount,
                                                        lowCount: lowCount
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                                class: "cp",
                                                children: [
                                                    fitInvestorFirms.length && company?.subscription && [
                                                        'free'
                                                    ].includes(company?.subscription.toLowerCase()) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: Array.from({
                                                            length: fitInvestorFirms.length
                                                        }).map((_, idx)=>{
                                                            const requiredLevel = fitInvestorFirms[idx]['requiredLevel'] || null;
                                                            if (requiredLevel) return /*#__PURE__*/ (0, $ayMG0.jsx)($46df257b3dd34ddd$var$BlurRow, {
                                                                idx: idx
                                                            });
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c15 poppins-font-style fw400 tal fs14px",
                                                                        style: {
                                                                            minWidth: '170px',
                                                                            filter: blur('5px')
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredinvestor",
                                                                            src: (parcelRequire("93y1O"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c3 tal",
                                                                        style: {
                                                                            minWidth: '125px',
                                                                            maxWidth: '300px',
                                                                            filter: blur('5px')
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredwebsite",
                                                                            src: (parcelRequire("cculX"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c6 tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: `${fitInvestorFirms[idx]['fitScorePercentage'] >= 83 ? 'green' : fitInvestorFirms[idx]['fitScorePercentage'] >= 66.6 && fitInvestorFirms[idx]['fitScorePercentage'] <= 83 ? 'orange' : 'red'} fs14px tal`,
                                                                            children: [
                                                                                fitInvestorFirms[idx]['fitScorePercentage'],
                                                                                "%"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c15 fs14px tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredpromptResponse",
                                                                            src: (parcelRequire("8pEOX"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c6 df jcc fs14px tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredreport",
                                                                            src: (parcelRequire("dzNWB"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: "c6",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredcontactInvestor",
                                                                            src: (parcelRequire("bnIhg"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 unselectable`,
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "blureddateContacted",
                                                                            src: (parcelRequire("2kqd2"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 tal unselectable`,
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredstatus",
                                                                            src: (parcelRequire("esenB"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 tal unselectable`,
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredarchieve",
                                                                            src: (parcelRequire("eaAwo"))
                                                                        })
                                                                    })
                                                                ]
                                                            }, idx);
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
                                                    company?.subscription.toLowerCase() === 'lite' && fitInvestorFirms?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: fitInvestorFirms.map((investor, index)=>{
                                                            const requiredLevel = investor['requiredLevel'] || null;
                                                            if (requiredLevel) return /*#__PURE__*/ (0, $ayMG0.jsx)($46df257b3dd34ddd$var$BlurRow, {
                                                                idx: index
                                                            });
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c15 poppins-font-style fw400 tal fs14px",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: investor['name'] || '-'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c40 tal",
                                                                        style: {
                                                                            minWidth: '125px',
                                                                            maxWidth: '300px'
                                                                        },
                                                                        children: investor['website'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                            href: $46df257b3dd34ddd$var$formatWebsiteUrl(investor['website']),
                                                                            target: "_blank",
                                                                            className: "cp c3 tdu fs14px tal",
                                                                            children: investor['website']
                                                                        }) : '-'
                                                                    }),
                                                                    user['role'] == 'investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                style: {
                                                                                    minWidth: '125px'
                                                                                },
                                                                                className: "c6 fs14px tal",
                                                                                children: investor['completeness'] ? investor['completeness'] + '%' : '-'
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                style: {
                                                                                    minWidth: '125px'
                                                                                },
                                                                                className: "c6 fs14px tal",
                                                                                children: investor['priorityScore'] ? Number(investor['priorityScore']).toFixed(2) : '-'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c6 tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: `${investor['fitScorePercentage'] >= 83 ? 'green' : investor['fitScorePercentage'] >= 66.6 && investor['fitScorePercentage'] <= 83 ? 'orange' : 'red'}  fs14px tal`,
                                                                            children: investor['fitScorePercentage'] ? `${investor['fitScorePercentage']}%` : '-'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c15 fs14px tal",
                                                                        style: {
                                                                            minWidth: '150px'
                                                                        },
                                                                        children: investor['promptScore'] || investor['promptScore'] === 0 ? Number(investor['promptScore']).toFixed(2) : '-'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c6 tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        "data-tooltip": "Upgrade to Pro required",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            "data-tooltip": "Upgrade to Pro required",
                                                                            className: "w2rem h2rem df jcc aic br100 bg3 bg4-hover c1 report-btn-r fs14px",
                                                                            children: "R"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: "c6",
                                                                        "data-tooltip": "Upgrade to Pro required",
                                                                        children: investor['isContacted'] && investor['isContacted'] !== '-' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "c40 fs14px tal",
                                                                            "data-tooltip": "Upgrade to Pro required",
                                                                            children: "Contacted"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "c40 fs14px tal",
                                                                            "data-tooltip": "Upgrade to Pro required",
                                                                            children: "Contact"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 unselectable`,
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "blureddateContacted",
                                                                            src: (parcelRequire("2kqd2"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 tal unselectable`,
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredstatus",
                                                                            src: (parcelRequire("esenB"))
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 tal unselectable`,
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            alt: "bluredarchieve",
                                                                            src: (parcelRequire("eaAwo"))
                                                                        })
                                                                    })
                                                                ]
                                                            }, investor._id);
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
                                                    company?.subscription.toLowerCase() === 'pro' && fitInvestorFirms?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: fitInvestorFirms.map((investor, index)=>{
                                                            const requiredLevel = investor['requiredLevel'] || null;
                                                            if (requiredLevel) return /*#__PURE__*/ (0, $ayMG0.jsx)($46df257b3dd34ddd$var$BlurRow, {
                                                                idx: index
                                                            });
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c15 poppins-font-style fw400 tal fs14px",
                                                                        style: {
                                                                            minWidth: '170px'
                                                                        },
                                                                        children: investor['name'] || '-'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c40 tal",
                                                                        style: {
                                                                            minWidth: '125px',
                                                                            maxWidth: '300px'
                                                                        },
                                                                        children: investor['website'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                            href: $46df257b3dd34ddd$var$formatWebsiteUrl(investor['website']),
                                                                            target: "_blank",
                                                                            className: "cp c3 tdu fs14px tal",
                                                                            children: investor['website']
                                                                        }) : '-'
                                                                    }),
                                                                    user['role'] == 'investor' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                style: {
                                                                                    minWidth: '125px'
                                                                                },
                                                                                className: "c6 fs14px tal",
                                                                                children: investor['completeness'] ? investor['completeness'] + '%' : '-'
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                style: {
                                                                                    minWidth: '125px'
                                                                                },
                                                                                className: "c6 fs14px tal",
                                                                                children: investor['priorityScore'] ? Number(investor['priorityScore']).toFixed(2) : '-'
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c6 tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: `${investor['fitScorePercentage'] >= 83 ? 'green' : investor['fitScorePercentage'] >= 66.6 && investor['fitScorePercentage'] <= 83 ? 'orange' : 'red'}  fs14px tal`,
                                                                            children: investor['fitScorePercentage'] ? `${investor['fitScorePercentage']}%` : '-'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c15 fs14px tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: investor['promptScore'] || investor['promptScore'] === 0 ? Number(investor['promptScore']).toFixed(2) : '-'
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        className: "c6 df jcc fs14px tal",
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            onClick: ()=>{
                                                                                setIsShowFitReport(true), setSelectedInvestor(investor);
                                                                            },
                                                                            className: "w2rem h2rem df jcc aic br100 bg3 bg4-hover c1 report-btn-r fs14px",
                                                                            children: "R"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: "c6",
                                                                        children: investor['isContacted'] && investor['isContacted'] !== '-' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "c40 fs14px tal",
                                                                            children: "Contacted"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "c40 fs14px tal",
                                                                            onClick: (e)=>handleInvestorEmail(investor),
                                                                            children: "Contact"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 ${!investor['isContacted'] && 'unselectable'}`,
                                                                        children: investor['leadStatus'] == 'Accepted' || investor['leadStatus'] == 'Rejected' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c15 fs14px tal",
                                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(investor['dateLeadStatus']).format('lll')
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                            children: investor['dateContacted'] && investor['dateContacted'] !== "Nil" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c15 fs14px tal",
                                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(investor['dateContacted']).format('MMM DD, YYYY')
                                                                                })
                                                                            }) : '-'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 tal ${!investor['isContacted'] && 'unselectable'}`,
                                                                        children: investor['dateLeadStatus'] == "Nil" ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "orange",
                                                                            children: "Pending"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "tooltip-area cp fs1rem tal",
                                                                            style: {
                                                                                position: 'relative'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "icon",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                        className: `${investor['leadStatus'] == 'Accepted' ? 'green' : 'red'} fs1rem fw500`,
                                                                                        children: investor['leadStatus']
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "overlay-box",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                            children: [
                                                                                                "The lead has been ",
                                                                                                investor['leadStatus'],
                                                                                                " by the Investor."
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                        style: {
                                                                            minWidth: '125px'
                                                                        },
                                                                        className: `c6 tal ${!investor['isContacted'] && 'unselectable'}`,
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: (parcelRequire("d4clj")),
                                                                            alt: "dlticon",
                                                                            onClick: ()=>handleDeleteLead(investor._id)
                                                                        })
                                                                    })
                                                                ]
                                                            }, `${investor._id} ${index}`);
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                !fitInvestorFirms?.length && company?.subscription ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pa df fdc aic jcc gg1rem",
                                    style: {
                                        left: 0,
                                        right: 0,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        pointerEvents: 'none'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1-25rem fw600 c15 tac",
                                            style: {
                                                opacity: '80%'
                                            },
                                            children: "No investor firms matched to fit score"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>setTab('investor-lead'),
                                            className: "bg3 c1 br50px px2rem py0-75rem fs14px fw500 cp bsn",
                                            style: {
                                                pointerEvents: 'all'
                                            },
                                            children: "Complete Investor Match Module"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $46df257b3dd34ddd$export$2e2bcd8739ae039 = $46df257b3dd34ddd$var$InvestorLeadList;



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");




var $acw62 = parcelRequire("acw62");







function $b8082c9444689024$export$2e2bcd8739ae039({ company: propCompany, setCompany: setCompany, getCompany: getCompany, setTab: setTab }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const company = selectedCompany || propCompany;
    const readinessReportLabel = company?.['testType'] === 'exit' ? 'Exit Readiness Report' : 'Investment Readiness Report';
    const permissionLists = [
        readinessReportLabel,
        "Market Opportunity Report",
        "Competitor Analysis Report",
        "Route to Market Report",
        "Technology Competitive Advantage Report",
        "SWOT Report",
        "Data Repository",
        company?.["testType"] ? `Quick Business Audit ${company["testType"]}` : "Quick Business Audit",
        "Warranty Disclosure",
        "Directors' Questionnaires"
    ];
    let [allUsers, setAllUsers] = (0, $acw62.useState)([]);
    let [docsArray, setDocsArray] = (0, $acw62.useState)([]);
    let [selectedUser, setSelectedUser] = (0, $acw62.useState)({});
    let [filePermissions, setFilePermissions] = (0, $acw62.useState)([]); // Changed from object to array
    let [reportPermissions, setReportPermissions] = (0, $acw62.useState)({});
    let [externalUserDetails, setExternalUserDetails] = (0, $acw62.useState)({
        firstName: '',
        lastName: '',
        email: ''
    });
    // Fetch external users from the lightweight dedicated endpoint and merge into the
    // company object, instead of relying on the heavy company fetch to assemble them.
    const loadExternalMembers = async ()=>{
        if (!company?.['_id']) return;
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/external-users/${company['_id']}`);
            if (res['code'] === 200) dispatch(setCompany({
                ...company,
                externalMembers: res['body']?.['externalMembers'] || {}
            }));
        } catch (error) {
            console.error('Error loading external users:', error);
        }
    };
    // Load external users once per company (Share Diligence Pack tab).
    (0, $acw62.useEffect)(()=>{
        if (company?.['_id']) loadExternalMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        company?.['_id']
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!company) return;
        const users = [];
        if (company?.['externalMembers'] && Object.keys(company['externalMembers']).length > 0) Object.entries(company['externalMembers']).forEach(([memberKey, externalMember])=>{
            users.push({
                id: memberKey,
                email: externalMember['email'],
                type: externalMember?.['role'] == 'Guest' ? 'External' : externalMember['role'],
                firm: externalMember?.['role'] == 'Guest' ? 'External User' : externalMember?.['cName'],
                filePermissions: (externalMember['filePermissions'] || []).filter((f)=>f),
                // Filter out null/undefined values
                reportPermissions: externalMember['reportPermissions'] || {},
                name: `${externalMember['firstName'] || ''} ${externalMember['lastName'] || ''}`.trim(),
                lastLoginAt: externalMember?.['lastLoginAt'] || externalMember?.['lastLogin'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(externalMember?.['lastLoginAt'] || externalMember['lastLogin']).format('lll') : 'Never',
                status: externalMember['status'] || 'active',
                shareCode: externalMember['shareCode']
            });
        });
        setAllUsers(users);
        if (docsArray.length == 0) getInvestmentModuleFiles(company['_id']);
    }, [
        company
    ]);
    const getInvestmentModuleFiles = async (companyId)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getInvestmentModuleFiles/${companyId}`);
        if (res['code'] == 200) setDocsArray(res['body']['files']);
    };
    const updatePermissions = async (userId, permissionType, selectedItems)=>{
        if (!company?.externalMembers?.[userId]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Member not found to update permissions');
        if (![
            'reportPermissions',
            'filePermissions'
        ].includes(permissionType)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Permission type is invalid');
        let permissions;
        if (permissionType === 'filePermissions') permissions = selectedItems || [];
        else {
            permissions = {};
            if (selectedItems && Array.isArray(selectedItems)) selectedItems.forEach((item)=>{
                permissions[item] = true;
            });
        }
        try {
            const originalPermissions = company.externalMembers[userId][permissionType] || (permissionType === 'filePermissions' ? [] : {});
            let updatedCompany = {
                ...company,
                externalMembers: {
                    ...company.externalMembers,
                    [userId]: {
                        ...company.externalMembers[userId],
                        [permissionType]: permissions
                    }
                }
            };
            dispatch(setCompany(updatedCompany));
            let data = {
                userId: userId,
                action: 'updatePermissions',
                permissionType: permissionType,
                permissions: permissions
            };
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateExternalUser/${company['_id']}`, data);
            if (res['code'] === 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Permissions updated successfully');
            else {
                let revertedCompany = {
                    ...company,
                    externalMembers: {
                        ...company.externalMembers,
                        [userId]: {
                            ...company.externalMembers[userId],
                            [permissionType]: originalPermissions
                        }
                    }
                };
                dispatch(setCompany(revertedCompany));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Failed to update permissions');
            }
        } catch (error) {
            console.error('Error updating permissions:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error updating permissions');
        }
    };
    const handleResendInvite = async (userId, email)=>{
        try {
            const data = {
                userId: userId,
                email: email
            };
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/resendInvite/${company['_id']}`, data);
            if (res['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Invite resent successfully to ${email}`);
                await loadExternalMembers();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Failed to resend invite');
        } catch (error) {
            console.error('Error resending invite:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error resending invite');
        }
    };
    const handleCopyShareLink = (shareCode)=>{
        if (!shareCode) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Share link not available');
        const shareLink = `${window.location.origin}/shareCode/${shareCode}/diligence-pack/${company['_id']}`;
        navigator.clipboard.writeText(shareLink).then(()=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Share link copied to clipboard')).catch(()=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to copy link'));
    };
    const handleDeleteUser = async (userId)=>{
        try {
            if (company.externalMembers && company.externalMembers[userId]) {
                let updateCompany = {
                    ...company,
                    externalMembers: {
                        ...company.externalMembers
                    }
                };
                delete updateCompany.externalMembers[userId];
                dispatch(setCompany(updateCompany));
            }
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/removeExternalUser/${company['_id']}`, {
                userId: userId
            });
            if (res['code'] === 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('User deleted successfully');
            else {
                await loadExternalMembers();
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Failed to delete user');
            }
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        } catch (error) {
            console.error('Error deleting user:', error);
            await loadExternalMembers();
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error deleting user');
        }
    };
    const handleStatusToggle = async (userId, currentStatus)=>{
        const newStatus = currentStatus == 'active' ? 'inactive' : 'active';
        try {
            const originalStatus = company.externalMembers[userId]?.status;
            let updatedCompany = {
                ...company,
                externalMembers: {
                    ...company.externalMembers,
                    [userId]: {
                        ...company.externalMembers[userId],
                        status: newStatus
                    }
                }
            };
            dispatch(setCompany(updatedCompany));
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateExternalUser/${company['_id']}`, {
                userId: userId,
                action: 'updateStatus',
                status: newStatus
            });
            if (res['code'] === 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`User access ${newStatus} successfully`);
            else {
                let revertedCompany = {
                    ...company,
                    externalMembers: {
                        ...company.externalMembers,
                        [userId]: {
                            ...company.externalMembers[userId],
                            status: originalStatus
                        }
                    }
                };
                dispatch(setCompany(revertedCompany));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error updating status');
        }
    };
    const handleReactivateAccess = async (userId)=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateExternalUser/${company['_id']}`, {
                userId: userId,
                action: 'updateExpiry'
            });
            if (res['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Access reactivated successfully');
                await loadExternalMembers();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Failed to reactivate access');
        } catch (error) {
            console.error('Error reactivating access:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error reactivating access');
        }
    };
    const handleSubmitShareForm = async ()=>{
        if (!externalUserDetails.firstName.trim()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter a first name');
        if (!externalUserDetails.lastName.trim()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter a last name');
        if (!externalUserDetails.email.trim()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter a email address');
        if (Object.keys(reportPermissions).length == 0) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select at least one report to share');
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(externalUserDetails.email)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter a valid email address');
        try {
            let data = {
                firstName: externalUserDetails.firstName,
                lastName: externalUserDetails.lastName,
                email: externalUserDetails.email,
                reportPermissions: reportPermissions,
                filePermissions: filePermissions
            };
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/shareWithExternalUser/${company['_id']}`, data);
            if (res['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                // Refresh company data to show new external user in table
                await loadExternalMembers();
                setExternalUserDetails({
                    firstName: '',
                    lastName: '',
                    email: ''
                });
                setFilePermissions([]);
                setReportPermissions({});
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Failed to share diligence pack');
        } catch (error) {
            console.error('Error sharing diligence pack:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while sharing the diligence pack');
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w100 pb4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc my2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c15 fs1-5rem tac",
                                children: "Share Diligence Pack"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df jcc pa r0 cp",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "#diligence-pack",
                                        onClick: ()=>setTab('diligence-pack'),
                                        class: "df jcc px2rem py0-75rem br25px bg3 c1 fs1rem mr0-5rem",
                                        children: "Show Diligence Pack"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'shareExternalUser'
                                            })),
                                        className: "cp df aic jcc px2rem py0-75rem br25px bg4 c1 fs1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                class: "fa fa-share-alt c1 mr0-5rem"
                                            }),
                                            "Share with external user"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 oa share-diligence-table",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100 table-advisor",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                children: "Firm"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                children: "Email Address"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                children: "Last Login"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                style: {
                                                    minWidth: '250px'
                                                },
                                                children: "Report Permissions"
                                            }),
                                            docsArray.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                style: {
                                                    minWidth: '250px'
                                                },
                                                children: "File Permissions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "bg5 tac fw600 fs1-25rem py1rem px0-75rem",
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: allUsers.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            colSpan: docsArray.length > 0 ? 9 : 8,
                                            className: "tac py2rem c4 fw600 fs1-25rem",
                                            children: "No external users found!"
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            " ",
                                            allUsers.map((user)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: user['name']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: user['firm']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw500",
                                                                children: user['type']
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                href: `mailto:${user['email']}`,
                                                                className: "c3 c4-hover",
                                                                children: user['email']
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: user['lastLoginAt']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                                size: "small",
                                                                sx: {
                                                                    m: 1,
                                                                    minWidth: 200
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    multiple: true,
                                                                    displayEmpty: true,
                                                                    value: (()=>{
                                                                        let perms = user?.reportPermissions || {};
                                                                        return permissionLists.filter((p)=>perms[p] === true);
                                                                    })(),
                                                                    onChange: (e)=>updatePermissions(user['id'], 'reportPermissions', e.target.value),
                                                                    renderValue: (selected)=>{
                                                                        if (selected.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                                                            class: "c14 fs0-875rem",
                                                                            children: "Select permissions"
                                                                        });
                                                                        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            class: "fs0-875rem",
                                                                            children: [
                                                                                selected.length,
                                                                                " report",
                                                                                selected.length > 1 ? 's' : '',
                                                                                " allocated"
                                                                            ]
                                                                        });
                                                                    },
                                                                    MenuProps: {
                                                                        PaperProps: {
                                                                            style: {
                                                                                maxHeight: 250,
                                                                                width: 300
                                                                            }
                                                                        }
                                                                    },
                                                                    children: permissionLists.map((permission)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: permission,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                    className: "cp fs0-5rem c4 mr0-5rem",
                                                                                    checked: (()=>{
                                                                                        let perms = user?.reportPermissions || {};
                                                                                        return perms[permission] === true;
                                                                                    })()
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                    primary: permission,
                                                                                    primaryTypographyProps: {
                                                                                        style: {
                                                                                            fontSize: '14px',
                                                                                            color: '#4a4a4a',
                                                                                            textTransform: 'capitalize'
                                                                                        }
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }, permission))
                                                                })
                                                            })
                                                        }),
                                                        docsArray.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                                size: "small",
                                                                sx: {
                                                                    m: 1,
                                                                    minWidth: 200
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    multiple: true,
                                                                    displayEmpty: true,
                                                                    value: user?.filePermissions || [],
                                                                    onChange: (e)=>updatePermissions(user['id'], 'filePermissions', e.target.value),
                                                                    renderValue: (selected)=>{
                                                                        if (selected.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                                                            class: "c14 fs0-875rem",
                                                                            children: "Select files"
                                                                        });
                                                                        else return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            class: "fs0-875rem",
                                                                            children: [
                                                                                selected.length,
                                                                                " file",
                                                                                selected.length > 1 ? 's' : '',
                                                                                " allocated"
                                                                            ]
                                                                        });
                                                                    },
                                                                    MenuProps: {
                                                                        PaperProps: {
                                                                            style: {
                                                                                maxHeight: 250,
                                                                                width: 300
                                                                            }
                                                                        }
                                                                    },
                                                                    children: docsArray.filter((doc)=>doc?.name).map((doc)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            className: "df aic fs0-75rem c14 bw1px bss bo16 p0-5rem",
                                                                            value: doc['name'],
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                    className: "cp fs0-5rem c4 mr0-5rem",
                                                                                    checked: user?.filePermissions?.includes(doc['name']) || false
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                                                    title: doc['name'],
                                                                                    arrow: true,
                                                                                    placement: "top",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                        primary: doc['name']?.length > 20 ? doc['name']?.substring(0, 20) + '...' + doc['name']?.slice(-10) : doc['name'],
                                                                                        primaryTypographyProps: {
                                                                                            style: {
                                                                                                fontSize: '14px',
                                                                                                color: '#4a4a4a'
                                                                                            }
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, doc['name']))
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: [
                                                                'expired',
                                                                'revoked'
                                                            ].includes(user['status']) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a8b4f445fd9172$export$2e2bcd8739ae039), {
                                                                title: `Invite is ${user['status']}`,
                                                                arrow: true,
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                                        checked: false,
                                                                        disabled: true,
                                                                        size: "small"
                                                                    })
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                                checked: user['status'] == 'active',
                                                                onChange: ()=>handleStatusToggle(user['id'], user['status']),
                                                                size: "small",
                                                                color: "success"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            className: "tac py1rem px0-75rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df jcc aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: ()=>handleCopyShareLink(user['shareCode']),
                                                                        className: "cp p0-5rem br5px",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            class: "fa fa-copy c7 c4-hover",
                                                                            "data-tooltip": "Copy Share Link",
                                                                            style: {
                                                                                fontSize: '18px'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: ()=>handleResendInvite(user['id'], user['email']),
                                                                        className: "cp p0-5rem br5px",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            class: "fa fa-repeat c7 c4-hover",
                                                                            "data-tooltip": "Resend Email",
                                                                            style: {
                                                                                fontSize: '18px'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: ()=>handleReactivateAccess(user['id']),
                                                                        className: "cp p0-5rem br5px",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            class: "fa fa-clock-o c7 c4-hover",
                                                                            "data-tooltip": "Reactivate Access",
                                                                            style: {
                                                                                fontSize: '18px'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: async ()=>{
                                                                            await setSelectedUser(user), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                open: 'deleteExternalUser'
                                                                            }));
                                                                        },
                                                                        className: "cp p0-5rem br5px",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            class: "fa fa-trash c23 c9-hover",
                                                                            "data-tooltip": "Delete User",
                                                                            style: {
                                                                                fontSize: '18px'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, user['id']))
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'shareExternalUser',
                onClose: ()=>{
                    setFilePermissions([]);
                    setReportPermissions({});
                    setExternalUserDetails({
                        firstName: '',
                        lastName: '',
                        email: ''
                    });
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                },
                className: "backdrop td500 zi4 pf t0 l0 w100 h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px3rem df fdc m1rem br10px pr",
                    style: {
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fs1-5rem fw600 mb0-5rem",
                            children: "Share with External User"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c14 fs1rem mb1rem",
                            children: "Share this Diligence Pack with someone outside of Diligentsia."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc oa h70vh px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs1-25rem fw600 mb0-5rem",
                                            children: "Recipient Details"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "db c14 mb0-5rem fs0-875rem fw500",
                                                    children: [
                                                        "First Name ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c3",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    size: "small",
                                                    variant: "outlined",
                                                    placeholder: "Enter first name",
                                                    value: externalUserDetails['firstName'],
                                                    onChange: (e)=>setExternalUserDetails({
                                                            ...externalUserDetails,
                                                            firstName: e.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "db c14 mb0-5rem fs0-875rem fw500",
                                                    children: [
                                                        "Last Name ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c3",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    size: "small",
                                                    variant: "outlined",
                                                    placeholder: "Enter last name",
                                                    value: externalUserDetails['lastName'],
                                                    onChange: (e)=>setExternalUserDetails({
                                                            ...externalUserDetails,
                                                            lastName: e.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: "db c14 mb0-5rem fs0-875rem fw500",
                                                    children: [
                                                        "Email Address ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c3",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    size: "small",
                                                    type: "email",
                                                    variant: "outlined",
                                                    value: externalUserDetails.email,
                                                    placeholder: "Enter email address",
                                                    onChange: (e)=>setExternalUserDetails({
                                                            ...externalUserDetails,
                                                            email: e.target.value
                                                        })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs1-25rem fw600 mb1rem",
                                            children: "Select Reports to Share"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic pb1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "df fs0-75rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w20px h20px pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            id: "selectAllReports",
                                                            checked: Object.keys(reportPermissions).filter((key)=>reportPermissions[key]).length === permissionLists.length,
                                                            onChange: (e)=>{
                                                                const newPermissions = {};
                                                                if (e.target.checked) permissionLists.forEach((permission)=>newPermissions[permission] = true);
                                                                setReportPermissions(newPermissions);
                                                            },
                                                            className: `cp bg1 bo4 bw1px bss td250 w20px h20px br5px`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `w100 c15 fs0-875rem lh3 ml0-5rem usn mr2rem fw600`,
                                                        children: "Select All Reports"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "section-list section-list",
                                            children: permissionLists.map((permission, idx)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic pb1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        for: permission + idx,
                                                        className: "df fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "checkbox w20px h20px pr",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "checkbox",
                                                                    id: permission + idx,
                                                                    "data-option": permission,
                                                                    checked: reportPermissions[permission] || false,
                                                                    onChange: (e)=>setReportPermissions({
                                                                            ...reportPermissions,
                                                                            [permission]: e.target.checked
                                                                        }),
                                                                    className: `cp bg1 bo4 bw1px bss td250 w20px h20px br5px`
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `w100 c15 fs0-75rem lh3 ml0-5rem usn mr2rem fw500`,
                                                                children: permission
                                                            })
                                                        ]
                                                    }, idx)
                                                }, idx);
                                            })
                                        })
                                    ]
                                }),
                                docsArray.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs1-25rem fw600 mb1rem",
                                            children: "Select Files to Share"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df aic pb1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "df fs0-75rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w20px h20px pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            id: "selectAllFiles",
                                                            checked: docsArray.length > 0 && filePermissions.length === docsArray.length,
                                                            onChange: (e)=>{
                                                                if (e.target.checked) setFilePermissions(docsArray.map((doc)=>doc.name));
                                                                else setFilePermissions([]);
                                                            },
                                                            className: `cp bg1 bo4 bw1px bss td250 w20px h20px br5px`
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `w100 c15 fs0-875rem lh3 ml0-5rem usn mr2rem fw600`,
                                                        children: "Select All Files"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "section-list section-list",
                                            children: docsArray.map((doc, idx)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic pb1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        for: doc?.['name'] + idx,
                                                        className: "df fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "checkbox w20px h20px pr",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "checkbox",
                                                                    id: doc?.['name'] + idx,
                                                                    "data-option": doc?.['name'],
                                                                    checked: filePermissions.includes(doc['name']),
                                                                    onChange: (e)=>{
                                                                        if (e.target.checked) setFilePermissions([
                                                                            ...filePermissions,
                                                                            doc['name']
                                                                        ]);
                                                                        else setFilePermissions(filePermissions.filter((file)=>file !== doc['name']));
                                                                    },
                                                                    className: `cp bg1 bo4 bw1px bss td250 w20px h20px br5px`
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `w100 c15 fs0-75rem lh3 ml0-5rem usn mr2rem fw500`,
                                                                children: doc['name']?.length > 70 ? doc['name']?.substring(0, 40) + '...' + doc['name']?.slice(-20) : doc['name']
                                                            })
                                                        ]
                                                    }, idx)
                                                }, idx);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcfe aic mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>{
                                        setFilePermissions([]);
                                        setReportPermissions({});
                                        setExternalUserDetails({
                                            firstName: '',
                                            lastName: '',
                                            email: ''
                                        });
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                    },
                                    className: "cp mr1rem px2rem py0-75rem br25px bss bw1px bo4 bg1 c4 fs1rem",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: handleSubmitShareForm,
                                    className: "cp px2rem py0-75rem br25px bg4 c1 fs1rem ",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'deleteExternalUser',
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w20",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row fdc tac my2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "c15 fs2rem fw600 tac ttu mb1rem",
                                children: "Delete External User"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "c15",
                                children: [
                                    "Are you sure you want to delete ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: selectedUser['name']
                                    }),
                                    "?"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcsa mt2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                customClassName: "c1 ml1rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                text: "Submit",
                                btnType: "warning",
                                onClick: ()=>handleDeleteUser(selectedUser['id'])
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");


var $7JB23 = parcelRequire("7JB23");


var $acw62 = parcelRequire("acw62");


function $82340729f0c68d95$export$2e2bcd8739ae039({ user: user, company: company }) {
    console.log(user, company);
    let [benchmark, setBenchmark] = (0, $acw62.useState)(false);
    let [selectedModule, setSelectedModule] = (0, $acw62.useState)('repository');
    const downloadPDF = async ()=>{
        const input = document.getElementById('rootElementId');
        (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(input).then((canvas)=>{
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 600;
            const pageHeight = 841.88976378;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            heightLeft -= pageHeight;
            const pdf = new (0, $15d064020a078dff$export$ba1e2ffc633a60f5)({
                orientation: 'p',
                unit: 'pt',
                format: [
                    600,
                    841.88976378
                ]
            });
            pdf.addImage(canvas, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
            while(heightLeft >= 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(canvas, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
                heightLeft -= pageHeight;
            }
            pdf.save(`Benchmark-Report.pdf`);
        });
    };
    const benchmarkReportTable = ()=>{
        let module = {};
        let moduleRisk, moduleCompleteness;
        let moduleRistPrecentage, moduleCompletenessPrecentage;
        if (benchmark) module = company?.['myBenchmark']?.['modules']?.[selectedModule];
        else module = company?.['overallBenchmark']?.['modules']?.[selectedModule];
        if (module) {
            moduleRisk = module['stats']['riskPercent'];
            moduleCompleteness = module['stats']['completionPercent'];
            moduleRistPrecentage = moduleRisk + 50;
            moduleCompletenessPrecentage = moduleCompleteness + 50;
        }
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            id: "table",
            className: "table-company-log w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    className: "ps t0",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                children: "Sections"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                className: "ttc",
                                children: selectedModule.replaceAll('-', ' ')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: module ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            module['sections'] && Object.keys(module['sections']).map((section)=>{
                                let risk = module['sections'][section]['riskPercent'];
                                let completeness = module['sections'][section]['completionPercent'];
                                let ristPrecentage = risk + 50;
                                let completenessPrecentage = completeness + 50;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: section
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df jcse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "progress-box-vertical",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "progress progress-bar-vertical",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "progress-bar progress-bar-striped progress-bar-animated",
                                                                    role: "progressbar",
                                                                    style: {
                                                                        width: `${completenessPrecentage}%`
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "precentage-block",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                children: completeness.toFixed(0)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem mb0-5rem arrow-right",
                                                                                children: completenessPrecentage < 35 ? 'Below Average' : completenessPrecentage > 70 ? 'Above Average' : 'Average'
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    marginBottom: '0',
                                                                    fontSize: '8px',
                                                                    bottom: '-7px'
                                                                },
                                                                className: "text-center-area",
                                                                children: "Completeness"
                                                            })
                                                        ]
                                                    }),
                                                    selectedModule !== 'repository' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "progress-box-vertical style-two",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "progress progress-bar-vertical style-two",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "progress-bar progress-bar-striped progress-bar-animated",
                                                                    role: "progressbar",
                                                                    style: {
                                                                        width: `${ristPrecentage}%`
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "precentage-block",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                children: risk.toFixed(0)
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem mb0-5rem arrow-right",
                                                                                children: ristPrecentage < 35 ? 'Below Average' : ristPrecentage > 70 ? 'Above Average' : 'Average'
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    marginBottom: '0',
                                                                    fontSize: '8px',
                                                                    bottom: '-7px'
                                                                },
                                                                className: "text-center-area",
                                                                children: "Risk"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: "Average"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcse",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "progress-box-vertical",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "progress progress-bar-vertical",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "progress-bar progress-bar-striped progress-bar-animated",
                                                                role: "progressbar",
                                                                style: {
                                                                    width: `${moduleCompletenessPrecentage}%`
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "precentage-block",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            children: moduleCompleteness.toFixed(0)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fs0-75rem mb0-5rem arrow-right",
                                                                            children: moduleCompletenessPrecentage < 35 ? 'Below Average' : moduleCompletenessPrecentage > 70 ? 'Above Average' : 'Average'
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginBottom: '0',
                                                                fontSize: '8px',
                                                                bottom: '-7px'
                                                            },
                                                            className: "text-center-area",
                                                            children: "Completeness"
                                                        })
                                                    ]
                                                }),
                                                selectedModule !== 'repository' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "progress-box-vertical style-two",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "progress progress-bar-vertical style-two",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "progress-bar progress-bar-striped progress-bar-animated",
                                                                role: "progressbar",
                                                                style: {
                                                                    width: `${moduleRistPrecentage}%`
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "precentage-block",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            children: moduleRisk.toFixed(0)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fs0-75rem mb0-5rem arrow-right",
                                                                            children: moduleRistPrecentage < 35 ? 'Below Average' : moduleRistPrecentage > 70 ? 'Above Average' : 'Average'
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                marginBottom: '0',
                                                                fontSize: '8px',
                                                                bottom: '-7px'
                                                            },
                                                            className: "text-center-area",
                                                            children: "Risk"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        className: "pa fs1-25rem fw600 mt1rem",
                        style: {
                            left: '35%'
                        },
                        children: "None of your other companies are eligible for benchmark"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container bg1 py2rem mih70vh company-audit-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            id: "rootElementId",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "report-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "logo-report mb1rem df jcsb aic w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h2rem",
                                    src: (parcelRequire("b0Cmg")),
                                    alt: "TODO"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>downloadPDF(),
                                    className: "h100 my0-5rem shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen fds h1rem f1 mr0-5rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 640 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                })
                                            ]
                                        }),
                                        "Download PDF"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gtcr2a gg2rem mb1-3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h100 df fdc jcsb",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "ass fs1rem mb0-5rem",
                                                children: "Company Name"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1rem fw700 lh1 ttu usn c6",
                                                children: company['cName']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "ass fs1rem mt0-5rem mb0-5rem",
                                                children: "Test Type"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                className: "fs1rem fw700 lh1 ttu usn c6",
                                                children: company['testType']
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "right-list",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Subscription ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: company['subscription']?.toUpperCase()
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Company Reg ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: company['ukRegNo']
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Issue Date ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['updatedAt']).format("MMM Do YYYY")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    "Generated By ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: company['creatorId']['email']
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading-area mb2rem tac df fdc jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "w200 c6 lh2 fs1-25rem",
                                style: {
                                    borderBottom: '3px solid #002d63'
                                },
                                children: "Benchmarking Report"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                    className: "dropdown-add-group w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                            variant: "success",
                            id: "dropdown-basic",
                            className: "dropdown-btn cp pl5rem shadow bg5 w95 br5px p1rem pr",
                            children: [
                                selectedModule.replaceAll('-', ' '),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "icon-right pa r0 mr1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "ml0-5rem w1rem h1rem f6 f6-xl",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 448 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "fa-secondary",
                                                d: "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "center-vertically f3 pa l0 ml1rem w2rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 640 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M608 352h-96c-17.62 0-32 14.38-32 32v96c0 17.62 14.38 32 32 32h96c17.62 0 32-14.38 32-32v-96C640 366.4 625.6 352 608 352zM128 352H32c-17.62 0-32 14.38-32 32v96c0 17.62 14.38 32 32 32h96c17.62 0 32-14.38 32-32v-96C160 366.4 145.6 352 128 352zM368 352h-96c-17.62 0-32 14.38-32 32v96c0 17.62 14.38 32 32 32h96c17.62 0 32-14.38 32-32v-96C400 366.4 385.6 352 368 352zM384 0H256C238.4 0 224 14.38 224 32v96c0 17.62 14.38 32 32 32h128c17.62 0 32-14.38 32-32V32C416 14.38 401.6 0 384 0z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M584 262.4V352h-48V272h-192V352h-48V272h-192V352h-48V262.4C56 241.3 73.25 224 94.38 224H296V160h48v64h201.6C566.8 224 584 241.3 584 262.4z"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                            className: "dropdown-content cp shadow fww",
                            children: Object.keys(company?.['overallBenchmark']?.['modules']).map((module)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                    onClick: ()=>setSelectedModule(module),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "item fs1rem m0-5rem mb1rem cp bg5",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df tal",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "fs1-25rem ttc",
                                                children: module.replaceAll('-', ' ')
                                            })
                                        })
                                    })
                                });
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc jcc tac",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                            className: "",
                            defaultChecked: benchmark,
                            onChange: (e)=>setBenchmark(e.target.checked)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "fs0-75rem fw600",
                            children: benchmark ? 'Client Portfolio Benchmark' : 'Overall Benchmark'
                        })
                    ]
                }),
                benchmarkReportTable()
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");


var $7JB23 = parcelRequire("7JB23");


var $acw62 = parcelRequire("acw62");








function $3466f5c37a66c198$export$2e2bcd8739ae039({ profileClass: profileClass, user: user, company: company, checklistTask: checklistTask, getChecklistTask: getChecklistTask }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [action, setAction] = (0, $acw62.useState)('create'); // create, update, delete, complete
    let [auditLogs, setAuditLogs] = (0, $acw62.useState)([]);
    let [checklistTaskState, setChecklistTaskState] = (0, $acw62.useState)({});
    const downloadPDF = async ()=>{
        const input = document.getElementById('rootElementId');
        (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(input).then((canvas)=>{
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 600;
            const pageHeight = 841.88976378;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            heightLeft -= pageHeight;
            const pdf = new (0, $15d064020a078dff$export$ba1e2ffc633a60f5)({
                orientation: 'p',
                unit: 'pt',
                format: [
                    600,
                    841.88976378
                ]
            });
            pdf.addImage(canvas, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
            while(heightLeft >= 0){
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(canvas, 'JPEG', 0, position, imgWidth, imgHeight, '', 'FAST');
                heightLeft -= pageHeight;
            }
            pdf.save(`Checklist-Report.pdf`);
        });
    };
    const handleChange = (e)=>setChecklistTaskState({
            ...checklistTaskState,
            [e.target.name]: e.target.value
        });
    const createChecklistTask = async (action)=>{
        await setAction(action);
        await setChecklistTaskState({});
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'actionTaskPopup'
        }));
    };
    const handleChecklistTask = async (task, action)=>{
        await setAction(action);
        await setChecklistTaskState(task);
        if (action == 'delete') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'deleteTaskPopup'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'actionTaskPopup'
        }));
    };
    const submitChecklistTask = async ()=>{
        if (checklistTaskState['title'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please provide title");
        if (checklistTaskState['description'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please provide Description");
        if (checklistTaskState['module'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please provide module");
        checklistTaskState = {
            ...checklistTaskState,
            action: action
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/task/checklistTask/${company['_id']}`, checklistTaskState);
        if (res && res['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            await getChecklistTask('checklist-tasks');
            setChecklistTaskState({});
        }
    };
    const getAuditLogs = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', {
            endpoint: `/task/checklistTask/${company['_id']}`
        });
        if (res['code'] == 200) {
            await setAuditLogs(res['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'taskAuditLogs'
            }));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "checklist-page company-audit-page",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "table-area-company-log",
                    id: "rootElementId",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "w100 tac c6 lh2 fs1-75rem",
                            children: [
                                "Checklist Report - ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "ttu",
                                    children: company['cName']
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "h100 df fdc jcsb aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "logo-report",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h2rem",
                                    src: (parcelRequire("b0Cmg")),
                                    alt: "TODO"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "report-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "logo-report mb1rem df jcsb aic w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "h2rem",
                                            src: (parcelRequire("b0Cmg")),
                                            alt: "TODO"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>downloadPDF(),
                                            className: "h100 my0-5rem shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "pen fds h1rem f1 mr0-5rem",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 640 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                        })
                                                    ]
                                                }),
                                                "Download PDF"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dg gtcr2a gg2rem mb1-3rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "h100 df fdc jcsb",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs1rem mb0-5rem",
                                                        children: "Company Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs1rem fw700 lh1 ttu usn c6",
                                                        children: company['cName']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs1rem mt0-5rem mb0-5rem",
                                                        children: "Test Type"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs1rem fw700 lh1 ttu usn c6",
                                                        children: company['testType']
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                className: "right-list",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            "Subscription ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                    children: company['subscription']?.toUpperCase()
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            "Company Reg ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: company['ukRegNo']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            "Issue Date ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['updatedAt']).format("MMM Do YYYY")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            "Generated By ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: company['creatorId']['email']
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "logo-report mb1rem df jcfe aic w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>createChecklistTask('create'),
                                            className: "h100 my0-5rem shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic mr1rem",
                                            children: "Create Task"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>getAuditLogs(),
                                            className: "h100 my0-5rem shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                            children: "Audit Log"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            id: "table",
                            className: "table-company-log",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    className: "ps t0",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Task Created By"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Task Title"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Module"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Notes"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                children: "Action"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: checklistTask.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: checklistTask.map((task)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df tac aic jcc w100",
                                                            children: task?.['createdBy']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: `w2rem h2rem df jcc aic br100 mr0-5rem ${profileClass}`,
                                                                src: task['createdBy']['profile'],
                                                                "data-tooltip": task?.['createdBy']?.['firstName'] ? task['createdBy']['firstName'] + " " + task['createdBy']['lastName'] : "Register to show your name here"
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                "data-tooltip": task?.['createdBy']?.['firstName'] ? task['createdBy']['firstName'] + " " + task['createdBy']['lastName'] : "Register to show your name here",
                                                                className: `w2rem h2rem df jcc aic br100 mr0-5rem fs0-75rem ${profileClass}`,
                                                                children: task?.['createdBy']?.['firstName'] ? task['createdBy']['firstName'][0] + task['createdBy']['lastName'][0] : "?"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "ttc",
                                                        children: task['title'] ? task['title'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "w100 df jcc fs0-75rem",
                                                            children: task['description'] ? task['description'] : '-'
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "ttc",
                                                        children: task['module'] ? task['module'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "",
                                                        children: task['status'] ? task['status'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "",
                                                        children: task['notes'] ? task['notes'] : '-'
                                                    }),
                                                    user['role'] == "Advisor" ? /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df jcsb aic",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>handleChecklistTask(task, 'update'),
                                                                    className: "c3 bo3 cp df jcc aic px0-5rem py0-5rem pr bw2px bss br5px fs0-75rem mr0-5rem",
                                                                    children: "Update"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>handleChecklistTask(task, 'delete'),
                                                                    className: "c4 bo4 cp df jcc aic px0-5rem py0-5rem pr bw2px bss br5px fs0-75rem",
                                                                    children: "Delete"
                                                                })
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "df jcc aic",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>handleChecklistTask(task, 'complete'),
                                                            className: "c7 cp df jcc aic px0-5rem py0-5rem pr bo7 bw2px br5px fs0-75rem bss",
                                                            children: "Complete"
                                                        })
                                                    })
                                                ]
                                            });
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                        className: "pa fs1-25rem fw500",
                                        style: {
                                            left: '45%'
                                        },
                                        children: "No Task Created!"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'actionTaskPopup',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                                children: [
                                    action,
                                    " Task"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem px2rem",
                                children: [
                                    action == 'complete' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        value: checklistTaskState['notes'],
                                                        name: "notes",
                                                        type: "text",
                                                        rows: "4",
                                                        placeholder: "Add Notes",
                                                        onChange: handleChange,
                                                        className: "pl4rem shadow bg5 w100 br5px p1rem"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        style: {
                                                            top: '20%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        value: checklistTaskState['status'],
                                                        onChange: handleChange,
                                                        name: "status",
                                                        className: "pl4rem shadow bg5 w100 br5px p1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Select Status"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Not Started",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Not Started"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Not Applicable",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Not Applicable"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "In Progress",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "In Progress"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "Completed",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Completed"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        value: checklistTaskState['title'],
                                                        name: "title",
                                                        type: "text",
                                                        placeholder: "Title",
                                                        onChange: handleChange,
                                                        className: "pl4rem shadow bg5 w100 br5px p1rem"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        value: checklistTaskState['description'],
                                                        name: "description",
                                                        type: "text",
                                                        placeholder: "Description",
                                                        onChange: handleChange,
                                                        className: "pl4rem shadow bg5 w100 br5px p1rem"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        value: checklistTaskState['module'],
                                                        onChange: handleChange,
                                                        name: "module",
                                                        className: "pl4rem shadow bg5 w100 br5px p1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Select Module"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "repository",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Repository"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "business-audit-investment",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Business Audit Investment"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "business-audit-growth",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Business Audit Growth"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "business-audit-exit",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Business Audit Exit"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "warranty-disclosure",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Warranty Disclosure"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "directors-questionnaire",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Directors Questionnaire"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "esg",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "ESG"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "software-development",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Software Development"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "two-minute-test-investment",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Two Minute Test Investment"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "two-minute-test-growth",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Two Minute Test Growth"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "two-minute-test-exit",
                                                                className: "pen usn ass mr0-5rem tal",
                                                                children: "Two Minute Test Exit"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                        viewBox: "0 0 640 512",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                            className: "fa-secondary"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>submitChecklistTask(),
                                        className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic",
                                        children: action
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "c3-hover td250 fs1-25rem cp",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'deleteTaskPopup',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs2rem fw600 tac ttu mb1rem pb1rem",
                                children: "Delete Task"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem px2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            "Are you sure you want to ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4 fw500",
                                                children: "DELETE"
                                            }),
                                            " task - (",
                                            checklistTaskState['title'],
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>submitChecklistTask(),
                                        className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic",
                                        children: "Delete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "c3-hover td250 fs1-25rem cp",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    open: modal['open'] == 'taskAuditLogs',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem pa t0 center-horizontally",
                                src: (parcelRequire("aR1CT")),
                                alt: "TODO",
                                style: {
                                    top: '15px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs1-5rem fw600 tac ttu",
                                children: "Checklist Tasks Audit Logs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs0-75rem ttu w100 tac mb1rem",
                                children: "See the history of checklist tasks"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ma oya dg gg0-5rem mb2rem w100",
                                children: auditLogs && auditLogs.length > 0 ? auditLogs.map((log)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df my0-5rem",
                                        children: [
                                            log?.['userId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: `ass ml0-5rem br100 w2rem h2rem ${profileClass}`,
                                                src: log?.['userId']?.['profile'],
                                                "data-tooltip": log?.['userId']?.['firstName'] ? log?.['userId']?.['firstName'] + " " + log?.['userId']?.['lastName'] : "Register to show your name here"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem ${profileClass}`,
                                                "data-tooltip": log?.['userId']?.['firstName'] ? log?.['userId']?.['firstName'] + " " + log?.['userId']?.['lastName'] : "Register to show your name here",
                                                children: [
                                                    log?.['userId']?.['firstName'][0] || "?",
                                                    " ",
                                                    log?.['userId']?.['lastName'][0] || "?"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem ml1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: log['message']
                                                            }),
                                                            " at ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: new Date(log.timestamp).toLocaleString()
                                                            }),
                                                            " by ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                children: [
                                                                    log?.['userId']?.['firstName'],
                                                                    " ",
                                                                    log?.['userId']?.['lastName']
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 fs1rem ttc",
                                                                children: [
                                                                    "Task ",
                                                                    log['payload']['action'],
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fs0-75rem ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw500 mr0-5rem",
                                                                        children: "Title : "
                                                                    }),
                                                                    " ",
                                                                    log?.['payload']?.['title'] ? log['payload']['title'] : '-'
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fs0-75rem ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw500 mr0-5rem",
                                                                        children: "Module : "
                                                                    }),
                                                                    " ",
                                                                    log?.['payload']?.['module'] ? log['payload']['module'] : '-'
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fs0-75rem ttc",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw500 mr0-5rem",
                                                                        children: "Status : "
                                                                    }),
                                                                    " ",
                                                                    log?.['payload']?.['status'] ? log['payload']['status'] : '-'
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "text-gradient fs1-75rem ttu w100 tac mb1rem",
                                    children: "No Logs Found!"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");


















function $3895089df44b52e2$export$2e2bcd8739ae039({ permissionLevel: permissionLevel, company: company, setTab: setTab, setDashboardTab: setDashboardTab, setCompanyDashboardTab: setCompanyDashboardTab }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [selectedFeature, setSelectedFeature] = (0, $acw62.useState)({});
    const [selectedHowItWorks, setSelectedHowItWorks] = (0, $acw62.useState)({});
    const [isShowTooltip, setIsShowTooltip] = (0, $acw62.useState)({
        seeMoreTooltip: true,
        howToTooltip: true,
        helpTooltip: true,
        reportTooltip: true,
        workflowReportTooltip: true
    });
    // Free Tools array
    const PORTFOLIO_PRO_DASHBOARD = [
        {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Due Diligence Pack"
            }),
            boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Key module reports collated"
            }),
            type: "diligence-pack-reporting",
            helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
            isTitleIcon: (parcelRequire("3N5Zr")),
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "83",
                    height: "83",
                    viewBox: "0 0 83 83",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M52.2423 4.99219C38.0392 4.99219 26.4843 16.5471 26.4843 30.7502C26.4843 35.4448 27.7474 39.8496 29.9507 43.6439L6.94712 66.6474C4.35096 69.2434 4.35096 73.4677 6.94712 76.0637C8.24505 77.3618 9.95015 78.0108 11.6551 78.0108C13.3601 78.0108 15.0653 77.3619 16.3631 76.0637L39.3714 53.0553C43.1605 55.2502 47.557 56.5081 52.242 56.5081C66.4452 56.5081 78.0001 44.953 78.0001 30.7501C78.0001 16.5471 66.4454 4.99219 52.2423 4.99219ZM13.3351 73.0356C12.4087 73.962 10.9015 73.962 9.97525 73.0357C9.04897 72.1094 9.04897 70.6021 9.97525 69.6757L11.4192 68.2317L14.7791 71.5916L13.3351 73.0356ZM17.8072 68.5636L14.4474 65.2037L16.7667 62.8844L20.1265 66.2444L17.8072 68.5636ZM23.1545 63.2161L19.7947 59.8561L32.4432 47.2076C33.4586 48.4271 34.5841 49.5519 35.8046 50.5661L23.1545 63.2161ZM52.2423 52.2257C40.4006 52.2257 30.7669 42.5918 30.7669 30.7502C30.7669 18.9087 40.4006 9.27476 52.2423 9.27476C64.084 9.27476 73.7178 18.9085 73.7178 30.7502C73.7178 42.5919 64.084 52.2257 52.2423 52.2257Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M59.5703 27.024C59.5703 25.8415 58.6117 24.8828 57.4291 24.8828L43.216 24.8828C42.0334 24.8828 41.0748 25.8415 41.0748 27.024C41.0748 28.2066 42.0334 29.1652 43.216 29.1652L57.4291 29.1652C58.6117 29.1654 59.5703 28.2066 59.5703 27.024Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M64.2187 19.5318C64.2187 18.3493 63.2601 17.3906 62.0775 17.3906L43.2121 17.3906C42.0295 17.3906 41.0709 18.3493 41.0709 19.5318C41.0709 20.7144 42.0295 21.6731 43.2121 21.6731L62.0775 21.6731C63.2601 21.6732 64.2187 20.7144 64.2187 19.5318Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Due Diligence Pack"
                }),
                points: [
                    '- Data Repository Report',
                    '- 20-sections Business Audit',
                    "- Directors\u2019 questionnaires",
                    '- Draft Warranty Disclosures '
                ],
                image: (parcelRequire("7J3ig")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            },
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Diligence Pack"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                arrayImages: [
                    (parcelRequire("k6VNW")),
                    (parcelRequire("3ASou")),
                    (parcelRequire("illzP"))
                ],
                bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w40 df jcc mla mra",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1-5rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "",
                                    src: (parcelRequire("aFTOQ")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                })
            }
        },
        {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Benchmarking Report"
            }),
            boxBottomText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Compare company performance against your clients or whole platform"
            }),
            type: "benchmark-reporting",
            helpLink: 'https://intercom.help/diligentsia-limited/en/collections/6922239-2-minute-test-from-dashboard',
            isTitleIcon: (parcelRequire("3N5Zr")),
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "65",
                    height: "65",
                    viewBox: "0 0 65 65",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        "clip-path": "url(#clip0_2119_192)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M54.9743 42.4394C57.0327 38.6748 58.1973 34.3686 58.1973 29.7915C58.1973 28.5728 58.0618 27.3811 57.8993 26.1894C61.1764 25.404 63.6139 22.479 63.6139 18.9582C63.6139 14.8415 60.2827 11.5103 56.166 11.5103C54.5952 11.5103 53.1598 11.9978 51.9681 12.8103C46.9577 6.879 39.6181 3.38525 31.791 3.38525C17.2202 3.38525 5.38477 15.2207 5.38477 29.7915C5.38477 44.3623 17.2202 56.1978 31.791 56.1978C36.3681 56.1978 40.6743 55.0332 44.4389 52.9748L50.9118 59.4478C52.3743 60.9103 54.2702 61.6144 56.1931 61.6144C58.116 61.6144 60.0118 60.8832 61.4743 59.4478C64.3723 56.5498 64.3723 51.8103 61.4743 48.9123L55.0014 42.4394H54.9743ZM56.166 15.5728C58.0348 15.5728 59.5514 17.0894 59.5514 18.9582C59.5514 20.8269 58.0348 22.3436 56.166 22.3436C54.2973 22.3436 52.7806 20.8269 52.7806 18.9582C52.7806 17.0894 54.2973 15.5728 56.166 15.5728ZM31.791 7.44775C38.6431 7.44775 45.0889 10.6436 49.3139 16.0332C48.9348 16.9269 48.7181 17.929 48.7181 18.9582C48.7181 20.2853 49.0973 21.4769 49.6931 22.5603L35.7452 36.5082L30.0577 30.8207C30.7077 29.7103 31.1139 28.4373 31.1139 27.0832C31.1139 22.9665 27.7827 19.6353 23.666 19.6353C19.5493 19.6353 16.2181 22.9665 16.2181 27.0832C16.2181 28.3019 16.5431 29.4394 17.0577 30.4686L10.6118 36.8873C9.85352 34.6665 9.44727 32.2832 9.44727 29.7915C9.44727 17.4686 19.4681 7.44775 31.791 7.44775ZM20.2806 27.0832C20.2806 25.2144 21.7973 23.6978 23.666 23.6978C25.5348 23.6978 27.0514 25.2144 27.0514 27.0832C27.0514 28.9519 25.5348 30.4686 23.666 30.4686C21.7973 30.4686 20.2806 28.9519 20.2806 27.0832ZM12.3993 40.8415L19.8202 33.4207C20.9306 34.0978 22.2577 34.504 23.666 34.504C24.9118 34.504 26.1035 34.1519 27.1327 33.6103L34.3098 40.7873C34.716 41.1936 35.2306 41.3832 35.7452 41.3832C36.2598 41.3832 36.7743 41.1936 37.1806 40.7873L52.5639 25.404C52.9431 25.6207 53.3493 25.8103 53.7556 25.9457C53.9723 27.2186 54.1348 28.4915 54.1348 29.7644C54.1348 42.0873 44.1139 52.1082 31.791 52.1082C23.5035 52.1082 16.2452 47.5582 12.3993 40.8144V40.8415ZM58.5493 56.5498C57.2223 57.8769 55.0827 57.8769 53.7556 56.5498L47.8785 50.6728C49.666 49.2915 51.291 47.6665 52.6723 45.879L58.5493 51.7561C59.8764 53.0832 59.8764 55.2228 58.5493 56.5498Z",
                            fill: "#4A67FF"
                        })
                    })
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Benchmarking Report"
                }),
                points: [
                    'Benchmark your client/portfolio companies',
                    'Simple scoring system',
                    'Against each or our wider database (anonymized)',
                    'Benchmarking report'
                ],
                image: (parcelRequire("9883i")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            },
            howItWorks: {
                subTitle: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c3",
                        children: "Benchmarking Report"
                    })
                }),
                stepImage: (parcelRequire("aCagb")),
                arrayImages: [
                    (parcelRequire("k6VNW")),
                    (parcelRequire("3ASou")),
                    (parcelRequire("illzP"))
                ],
                bottomSection: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w40 df jcc mla mra",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "img-text aic df jcc bg1 px1rem py1rem w100 mla mra br45px oxa",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "icon mx1-5rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "",
                                    src: (parcelRequire("aFTOQ")),
                                    alt: ""
                                })
                            })
                        ]
                    })
                })
            }
        }
    ];
    const handleSeeMorePopup = async (item)=>{
        await setSelectedFeature(item);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const handleHowItWorks = async (item)=>{
        await setSelectedHowItWorks(item);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'howItWorksModal'
        }));
    };
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedFeature({});
    };
    const handleLinkClick = (link)=>{
        if (permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        return link;
    };
    const handleModuleRedirect = async (type)=>{
        if (permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        await setTab(type);
        setDashboardTab('Company Dashboard');
        setCompanyDashboardTab('Dashboard');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pr",
                children: PORTFOLIO_PRO_DASHBOARD && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg20 bss bo5 bsbb p2rem br25px w100 keyfeature-box keyfeature-box-company-pro df fww mb2rem pr bsbb bw2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-25rem c15 w100 pl1rem",
                            children: "Core Workplace"
                        }),
                        PORTFOLIO_PRO_DASHBOARD.map((item, idx)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr bsbb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "right-info-hyper-icon",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                onClick: ()=>handleSeeMorePopup(item),
                                                onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                            ...st,
                                                            seeMoreTooltip: false
                                                        })),
                                                className: "info-icon  pr ml0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "27",
                                                        height: "27",
                                                        viewBox: "0 0 27 27",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "13.5",
                                                                cy: "13.5",
                                                                r: "13.5",
                                                                transform: "matrix(1 0 0 -1 0 27)",
                                                                fill: "#59B8FD"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `overlay-box ${isShowTooltip['seeMoreTooltip'] && item['showSeeMoreTooltip'] && ' show-tooltip'}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "c15 df aic",
                                                            children: [
                                                                "What is it?",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "icon ml0-5rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "12",
                                                                        height: "14",
                                                                        viewBox: "0 0 12 14",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                            fill: "#505050"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            item?.['howItWorks'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "hover-list-icon  pr cp ml0-5rem",
                                                onClick: ()=>handleHowItWorks(item),
                                                onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                            ...st,
                                                            howToTooltip: false
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "27",
                                                        height: "27",
                                                        viewBox: "0 0 27 27",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "13.5",
                                                                cy: "13.5",
                                                                r: "13.5",
                                                                fill: "#59B8FD"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `overlay-box ${isShowTooltip['howToTooltip'] && item['showHowToTooltip'] && ' show-tooltip'}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "c15 df aic",
                                                            children: [
                                                                "How does it work?",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "icon",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "12",
                                                                        height: "14",
                                                                        viewBox: "0 0 12 14",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                            fill: "#505050"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            item?.['helpLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: item?.['helpLink'],
                                                target: "_blank",
                                                className: "questionmark-icon pr ml0-5rem",
                                                onMouseEnter: ()=>setIsShowTooltip((st)=>({
                                                            ...st,
                                                            helpTooltip: false
                                                        })),
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "27",
                                                        height: "27",
                                                        viewBox: "0 0 27 27",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "13.5",
                                                                cy: "13.5",
                                                                r: "13.5",
                                                                fill: "#FC7785"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M6.80001 15.7992C7.79413 15.7992 8.60003 14.9934 8.60003 13.9992C8.60003 13.0051 7.79413 12.1992 6.80001 12.1992C5.80589 12.1992 5 13.0051 5 13.9992C5 14.9934 5.80589 15.7992 6.80001 15.7992Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M12.9992 15.7992C13.9934 15.7992 14.7992 14.9934 14.7992 13.9992C14.7992 13.0051 13.9934 12.1992 12.9992 12.1992C12.0051 12.1992 11.1992 13.0051 11.1992 13.9992C11.1992 14.9934 12.0051 15.7992 12.9992 15.7992Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M19.2004 15.7992C20.1945 15.7992 21.0004 14.9934 21.0004 13.9992C21.0004 13.0051 20.1945 12.1992 19.2004 12.1992C18.2063 12.1992 17.4004 13.0051 17.4004 13.9992C17.4004 14.9934 18.2063 15.7992 19.2004 15.7992Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `overlay-box ${isShowTooltip['helpTooltip'] && item['showHelpTooltip'] && ' show-tooltip'}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "c15 df aic",
                                                            children: [
                                                                "Detailed help pages or ask our AI Assistants for help",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "icon ml0-5rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "12",
                                                                        height: "14",
                                                                        viewBox: "0 0 12 14",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                            fill: "#505050"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: ()=>handleLinkClick(`#${item['type']}`),
                                        onClick: ()=>handleModuleRedirect(item['type']),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fw500 fs1-25rem c15 aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon-diligenstia mr1rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "w40px h40px",
                                                                src: item?.['isTitleIcon'],
                                                                alt: "logo image"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs1rem fw500 c15 lh2 title-box-feature",
                                                            children: item?.title
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df mt2rem jcsb bottom-details w90",
                                                children: item?.['boxBottomText'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df mb1rem w100 pr",
                                                    style: {
                                                        top: '29px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs0-75rem fw400 c28 lh2",
                                                        children: item['boxBottomText']
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, `core-workplace-${idx}`);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "keyFeatureSeeMore",
                open: modal['open'] == 'openSeeMore',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 p4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        maxWidth: '1350px',
                        ...selectedFeature?.seeMoreSection?.cardPaddingBottom
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        width: "55%",
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 df aic",
                                                    children: selectedFeature?.seeMoreSection?.icon
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w90 fw500 c15 pl1rem df aic",
                                                    style: {
                                                        fontSize: '26px',
                                                        lineHeight: '37.32px'
                                                    },
                                                    children: selectedFeature?.seeMoreSection?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: " mt0-5rem",
                                            style: {
                                                paddingLeft: '22px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    style: {
                                                        lineHeight: '25px',
                                                        paddingBottom: "3px",
                                                        paddingTop: "3px",
                                                        paddingLeft: "20px",
                                                        borderLeft: '2px solid #D3D9FC',
                                                        ...selectedFeature?.seeMoreSection?.liStyle
                                                    },
                                                    className: "df fdc fs1rem c14 fs1rem fw400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "circle"
                                                                }),
                                                                objpoints
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: selectedFeature?.seeMoreSection?.subMenu && selectedFeature?.seeMoreSection?.subMenu?.index === index && selectedFeature?.seeMoreSection?.subMenu?.points?.map((str, i, arr)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                    style: {
                                                                        lineHeight: '30px'
                                                                    },
                                                                    children: str
                                                                }, `submenu-point-${i}`);
                                                            })
                                                        })
                                                    ]
                                                }, `feature-point-${index}-${selectedFeature?.seeMoreSection?.title || 'item'}`);
                                            })
                                        }),
                                        selectedFeature?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt1rem",
                                            style: {
                                                border: '1px solid gray',
                                                padding: "10px",
                                                borderRadius: '10px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.notePoint
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jce",
                                    style: {
                                        width: '45%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedFeature?.seeMoreSection?.image,
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "howItWorksModal",
                open: modal['open'] == 'howItWorksModal',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        zoom: '0.9',
                        maxWidth: '1350px',
                        ...selectedFeature?.seeMoreSection?.cardPaddingBottom
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "w100 tac c15 fs1-75rem fw500",
                                    children: "How does it work?"
                                }),
                                selectedHowItWorks?.['howItWorks']?.['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                    className: "w100 tac c15 fs1-25rem fw500 mb1rem",
                                    children: selectedHowItWorks?.['howItWorks']?.['subTitle']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-top-box df w100 jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedHowItWorks?.howItWorks?.stepImage,
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                                    children: selectedHowItWorks?.['howItWorks']?.['arrayImages'] && selectedHowItWorks?.['howItWorks']?.['arrayImages'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['howItWorks']?.['arrayImages'].map((image)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "step-img df jcc px1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: image,
                                                    alt: "ste image"
                                                })
                                            });
                                        })
                                    })
                                }),
                                selectedHowItWorks?.['howItWorks']?.['checkList'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb",
                                    children: selectedHowItWorks?.['howItWorks']?.['checkList'] && selectedHowItWorks?.['howItWorks']?.['checkList'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['howItWorks']?.['checkList'].map((array, idx)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-inner w100 pr",
                                                children: array
                                            }, `checklist-item-${idx}`);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: selectedHowItWorks?.['howItWorks']?.['bottomSection'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem c12 mb1rem tac w100",
                                        children: selectedHowItWorks?.['howItWorks']?.['bottomSection']
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        children: selectedHowItWorks?.['howItWorks']?.['btnContent']
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");








function $0985801ff83f3d7d$export$2e2bcd8739ae039({ permissionLevel: permissionLevel, company: company, setTab: setTab, setIsWorkflowReport: setIsWorkflowReport, setDashboardTab: setDashboardTab, setCompanyDashboardTab: setCompanyDashboardTab }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const showPercent = (value, type)=>{
        let color;
        if (value > 0) {
            if (type == 'Workflow Manager Complete') color = value > 75 ? 'green' : value > 26 ? 'yellow' : 'pink';
            else if (type == 'Questions Complete') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
        } else color = 'c28';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
            className: `${color} tac fs2rem lh1 mr0-5rem`,
            children: [
                value || 0,
                "%",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `${value > 0 ? 'c15 ' : 'c28 '} ${type == 'Questions Complete' ? 'w4rem ' : 'w8rem '} fs0-75rem db fw300`,
                    children: type
                })
            ]
        });
    };
    const navigateSection = async (tab, sectionNo)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        await setTab(tab);
        setDashboardTab('Company Dashboard');
        setCompanyDashboardTab('Dashboard');
        setTimeout(()=>{
            let element = document.getElementById(sectionNo);
            if (element) element.scrollIntoView({
                behavior: 'instant'
            }, true);
        }, 1000);
    };
    const checklistModuleTooltip = (sections)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "cp module-tooltip-box",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "hover-list",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("9gCOW")),
                        className: "pa",
                        alt: "list-img"
                    })
                }),
                sections && sections.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "tooltip-area",
                    children: sections.map((section, idx)=>{
                        let completeness = section?.['stats']?.['completionPercent'] ? section?.['stats']?.['completionPercent'] : 0;
                        let riskColour;
                        if (section?.['stats']?.['riskPercent'] < 38) riskColour = 7;
                        else if (section?.['stats']?.['riskPercent'] > 62) riskColour = 9;
                        else riskColour = 8;
                        let hexColour = riskColour == 8 ? "#ddb64044" : riskColour == 9 ? "#dd404044" : "#40dda144";
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            onClick: async ()=>{
                                await navigateSection(section['moduleName'], section['sectionNo']);
                            },
                            style: {
                                background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                            },
                            "data-scroll-to": section['sectionNo'],
                            className: "overlay-box tal w100 tac cp c3-hover",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: section['sectionName']
                            })
                        }, `section-${section['_id'] || section['sectionNo']}-${idx}`);
                    })
                })
            ]
        });
    };
    const setChecklitsReportTab = async (moduleName, type)=>{
        if (type == 'workflow-report') {
            await setIsWorkflowReport(true);
            localStorage.setItem('isWorkflowOpen', true);
        }
        await setTab(`${moduleName}-report`);
        setDashboardTab('Company Dashboard');
        setCompanyDashboardTab('Dashboard');
    };
    const sortModules = (a, b)=>{
        return new Date(a.createdAt) - new Date(b.createdAt);
    };
    const handleModuleRedirect = async (type)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        await setTab(type);
        setDashboardTab('Company Dashboard');
        setCompanyDashboardTab('Dashboard');
    };
    const handleLinkClick = (link)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        return link;
    };
    const checklistModules = (modules)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: Object.values(modules).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: Object.values(modules).map((module)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb advisor-bg`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcc right-info-hyper-icon right-info-dashboard-area",
                                    style: {
                                        right: '-40px',
                                        alignItems: 'start'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w50 bg1",
                                            src: (parcelRequire("8RPC6")),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "info-icon cp pr ml0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "27",
                                                    height: "27",
                                                    viewBox: "0 0 27 27",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "13.5",
                                                            cy: "13.5",
                                                            r: "13.5",
                                                            transform: "matrix(1 0 0 -1 0 27)",
                                                            fill: "#59B8FD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                            fill: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                            fill: "white"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "shadow overlay-box",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "pl1rem py0-5rem fs1rem c15 fw400 tti",
                                                        children: module['moduleDescription'] || module?.['sections']?.[0]?.['moduleDescription']
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                module?.['sections'] && checklistModuleTooltip(module?.['sections']),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: ()=>handleLinkClick(`#${module?.['type']}`),
                                    onClick: ()=>handleModuleRedirect(module?.['type']),
                                    className: "cp w100 h100",
                                    style: {
                                        minHeight: '130px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area style-two pa df aic jcsb w90",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "percentage-area df jcc aic",
                                                children: [
                                                    showPercent(module?.['stats']['completionPercent'], 'Questions Complete'),
                                                    showPercent(module?.['stats']['workflowCompletionPercent'], 'Workflow Manager Complete')
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "icon-diligenstia mr1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "br5px",
                                                        style: {
                                                            maxWidth: "32px"
                                                        },
                                                        src: module?.['imageURL'] || (parcelRequire("cBcFJ")),
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "cp fs1rem fw500 bg1 c4-hover c15 lh2 title-box-feature tal advisor-bg-lite",
                                                    children: module['type']
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                permissionLevel != 'DASHBOARD' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "report-bottom-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: module?.['stats'].completionPercent > 0 && `#${module['type']}-report`,
                                            onClick: ()=>{
                                                module?.['stats'].completionPercent > 0 && setChecklitsReportTab(module['type'], 'module-report');
                                            },
                                            className: `w2rem h2rem df jcc mr0-5rem aic br100 c1 report-btn pr ${module?.['stats'].completionPercent > 0 ? ' bg3 bg4-hover' : ' bg12'}`,
                                            children: [
                                                "R",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "overlay-box",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "c15 df aic",
                                                        children: [
                                                            "Module Report",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: "icon ml0-5rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    width: "12",
                                                                    height: "14",
                                                                    viewBox: "0 0 12 14",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                        fill: "#505050"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: module?.['stats'].completionPercent > 0 && `#${module['type']}`,
                                            onClick: ()=>{
                                                module?.['stats'].completionPercent > 0 && setChecklitsReportTab(module['type'], 'workflow-report');
                                            },
                                            className: `w2rem h2rem df jcc aic br100 c1 report-btn pr ${module?.['stats'].completionPercent > 0 ? ' bg3 bg4-hover' : ' bg12'}`,
                                            children: [
                                                "WF",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "overlay-box",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "c15 df aic",
                                                        children: [
                                                            "Workflow Report",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: "icon ml0-5rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    width: "12",
                                                                    height: "14",
                                                                    viewBox: "0 0 12 14",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z",
                                                                        fill: "#505050"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, `checklist-module-${module['_id'] || module['type']}`);
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "w100 fs2rem fw500 tac c3 pl2rem mb1rem",
                children: "No Checklist Modules"
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sectionWrapper py1rem fs0-75rem pr anylist-builder-tab",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt1rem bss px2rem py1rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb2rem pr bsbb",
                style: {
                    backgroundColor: '#ff00960a'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb1rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 df jcsb aic px2rem mb1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    className: "fs1-25rem fw500 c15",
                                    children: [
                                        user['role'],
                                        " - Internal Use Only"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "w100 fs1-25rem fw500 c15 pl2rem mb1rem",
                                children: "The 12 Boxes"
                            }),
                            company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>item['category'] == 'internal').sort(sortModules))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt0-5rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb1rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "fs1-25rem fw500 c15 w100 pl2rem mb1rem",
                                children: [
                                    user['role'],
                                    " - Generic Checklists - Across All Clients"
                                ]
                            }),
                            company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>item['category'] == 'external').sort(sortModules))
                        ]
                    })
                ]
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");
parcelRequire("acw62");








function $64eb88388e6047d6$export$2e2bcd8739ae039({ permissionLevel: permissionLevel, company: company, setTab: setTab, setIsWorkflowReport: setIsWorkflowReport, setDashboardTab: setDashboardTab, setCompanyDashboardTab: setCompanyDashboardTab }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const redirectWorkflowTab = async (moduleName, isRedirect)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if (!isRedirect) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Module not started yet!');
            return;
        } else {
            await setIsWorkflowReport(true);
            await setTab(`${moduleName}-report`);
            setDashboardTab('Company Dashboard');
            setCompanyDashboardTab('Dashboard');
        }
    };
    const sortModules = (a, b)=>{
        return new Date(a.createdAt) - new Date(b.createdAt);
    };
    const checklistModules = (modules)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: Object.values(modules).length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: Object.values(modules).map((module)=>{
                    let isRedirect = false;
                    if (module?.['stats'] && module?.['stats']?.['completionPercent'] > 0) isRedirect = true;
                    else isRedirect = false;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `bo7 w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem mx1rem my1-5rem pr bsbb advisor-bg`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            className: "ttc fs1rem fw500 c15 lh2 zi1 w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "right-info-hyper-icon right-info-dashboard-area",
                                    style: {
                                        right: '-60px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w50 bg1",
                                        src: (parcelRequire("8RPC6")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: isRedirect && permissionLevel != 'DASHBOARD' && `#${module['type']}-report`,
                                    onClick: ()=>redirectWorkflowTab(module['type'], isRedirect),
                                    className: "cp w100 h100",
                                    style: {
                                        minHeight: '130px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100 df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "icon-diligenstia mr1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "br5px",
                                                        style: {
                                                            maxWidth: "32px"
                                                        },
                                                        src: module?.['imageURL'] || (parcelRequire("cBcFJ")),
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "cp fs1rem fw500 bg1 c4-hover c15 lh2 title-box-feature tal advisor-bg-lite",
                                                    children: module['type']
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100 df jcsb",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c12 fw300 fs0-75rem mt4rem",
                                                    children: module?.['createdAt'] || module?.['sections']?.[0]?.['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module?.['createdAt'] || module?.['sections']?.[0]?.['createdAt']).format('L') : '-'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df fdc jcc aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `progress-bar workflow-report-progress ${module?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : module?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : module?.stats?.workflowCompletionPercent > 1 ? ' workflow-progress-pink' : '  workflow-progress-grey'}`,
                                                            style: {
                                                                width: 50,
                                                                height: 50,
                                                                borderRadius: '50%',
                                                                margin: 0,
                                                                border: '2px solid #F1F1F1'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                                text: module?.stats?.workflowCompletionPercent ? module?.stats?.workflowCompletionPercent + "%" : 'N/A',
                                                                styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                                    strokeWidth: '0',
                                                                    textSize: '20px',
                                                                    trailColor: '#FBFBFB',
                                                                    stroke: 'transparent',
                                                                    strokeLinecap: 'butt',
                                                                    backgroundColor: '#FBFBFB',
                                                                    pathTransitionDuration: 0.5,
                                                                    dominantBaseline: 'ideographic'
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            style: {
                                                                marginBottom: "0"
                                                            },
                                                            className: "tac c15 fs0-75rem fw300",
                                                            children: [
                                                                "Workflow ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                " Completeness"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, `workflow-module-${module['_id'] || module['type']}`);
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "w100 fs2rem fw500 tac c3 pl2rem mb1rem",
                children: "No Checklist Modules"
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sectionWrapper py1rem fs0-75rem pr anylist-builder-tab",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt1rem bss px2rem py1rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb2rem pr bsbb",
                style: {
                    backgroundColor: '#ff00960a'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt1rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb1rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 df jcsb aic px2rem mb1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    className: "fs1-25rem fw500 c15",
                                    children: [
                                        user['role'],
                                        " - Internal Use Only"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "w100 fs1-25rem fw500 c15 pl2rem mb1rem",
                                children: "The 12 Boxes"
                            }),
                            company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>item['category'] == 'internal').sort(sortModules))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt0-5rem bss px1rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb1rem pr bsbb",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "fs1-25rem fw500 c15 w100 pl2rem mb1rem",
                                children: [
                                    user['role'],
                                    " - Generic Checklists - Across All Clients"
                                ]
                            }),
                            company?.['modules'] && Object.values(company['modules']).length > 0 && checklistModules(Object.values(company['modules']).filter((item)=>item['category'] == 'external').sort(sortModules))
                        ]
                    })
                ]
            })
        })
    });
}


function $f14fac7464a42f8a$export$2e2bcd8739ae039({ permissionLevel: permissionLevel, company: company, companyId: companyId, setTab: setTab, setDashboardTab: setDashboardTab, setCompanyDashboardTab: setCompanyDashboardTab, setIsWorkflowReport: setIsWorkflowReport }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [protfolioProTab, setProtfolioProTab] = (0, $acw62.useState)("Core Workplace");
    let [modulesForChecklist, setModulesForChecklist] = (0, $acw62.useState)([]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "dashboard-tools-area",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "box-dashbord-container mla mra mb6rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tabs-navlist tabs-dashboard df aic jcc mt2rem mb2rem",
                        children: [
                            'Core Workplace',
                            'Checklist Modules',
                            'Checklist Workflows'
                        ].map((item, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc",
                                children: [
                                    (item == 'Checklist Modules' || item == 'Checklist Workflows') && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4 fs0-75rem",
                                        style: {
                                            marginTop: '-15px',
                                            color: '#8E8E8E'
                                        },
                                        children: user['role']
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: `fs1-25rem fw500 c15 cp ${protfolioProTab == item && ' active'}`,
                                        onClick: ()=>setProtfolioProTab(item),
                                        children: item
                                    })
                                ]
                            }, `${item}-${index}`);
                        })
                    }),
                    protfolioProTab == 'Core Workplace' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3895089df44b52e2$export$2e2bcd8739ae039), {
                        permissionLevel: permissionLevel,
                        setTab: setTab,
                        setDashboardTab: setDashboardTab,
                        setCompanyDashboardTab: setCompanyDashboardTab
                    }),
                    protfolioProTab == 'Checklist Modules' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0985801ff83f3d7d$export$2e2bcd8739ae039), {
                        permissionLevel: permissionLevel,
                        company: company,
                        setTab: setTab,
                        setIsWorkflowReport: setIsWorkflowReport,
                        setDashboardTab: setDashboardTab,
                        setCompanyDashboardTab: setCompanyDashboardTab
                    }),
                    protfolioProTab == 'Checklist Workflows' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $64eb88388e6047d6$export$2e2bcd8739ae039), {
                        permissionLevel: permissionLevel,
                        company: company,
                        setTab: setTab,
                        setIsWorkflowReport: setIsWorkflowReport,
                        setDashboardTab: setDashboardTab,
                        setCompanyDashboardTab: setCompanyDashboardTab
                    })
                ]
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");





function $91ba6c0aac080db6$export$2e2bcd8739ae039({ company: company, tab: tab }) {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    // A4 dimensions in pixels (at 96 DPI)
    const A4_HEIGHT_PX = 1122; // 297mm at 96 DPI
    const A4_WIDTH_PX = 794; // 210mm at 96 DPI
    const PAGE_MARGIN_TOP = 48; // 3rem
    const PAGE_MARGIN_BOTTOM = 48; // 3rem
    const FOOTER_HEIGHT = 80; // Footer height including margins
    const HEADER_HEIGHT = 96; // Header height for continuation pages
    const AVAILABLE_HEIGHT = A4_HEIGHT_PX - PAGE_MARGIN_TOP - PAGE_MARGIN_BOTTOM - FOOTER_HEIGHT;
    let [reportId, setReportId] = (0, $acw62.useState)();
    let [reportData, setReportData] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        if (window.location.hash) reportId = window.location.hash.split('?')[0];
        if (reportId) {
            reportId = reportId.replaceAll('#', '');
            setReportId(reportId);
        }
    }, []);
    // Lazy load specific report from API
    (0, $acw62.useEffect)(()=>{
        const fetchReport = async ()=>{
            if (company?._id && reportId && tab) try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/reports`);
                if (response['code'] == 200 && response['body']?.['reports']) {
                    // Merge both report arrays to find the report
                    const allReports = [
                        ...response['body']['reports']['researchAidReports'] || [],
                        ...response['body']['reports']['customReports'] || []
                    ];
                    const report = allReports.find((item)=>item['_id'] === reportId);
                    if (report) setReportData(report);
                }
            } catch (e) {
                console.error('Failed to fetch report:', e);
            }
        };
        fetchReport();
    }, [
        company?._id,
        reportId,
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        const pdfContent = document.getElementById("pdfContent");
        const wrapper = document.getElementById("pdf");
        if (!pdfContent || !wrapper) return;
        // Free subscription: only the first page is readable; every following page is blurred.
        // (Blur is page-based, not section-based, so it works even if the Executive Summary is short/missing.)
        const isFreeReport = company?.['subscription'] === 'Free';
        pdfContent.classList.add("a4-pdf", "p3rem");
        wrapper.innerHTML = "";
        let children = Array.from(pdfContent.children);
        let pageNumber = 1;
        let currentPageHeight = 0;
        let contentContainer = null;
        // Helper function to create footer
        const createFooter = (pageNum)=>{
            const footer = document.createElement("div");
            footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
            footer.style.bottom = "10px";
            footer.style.left = "0";
            footer.style.right = "0";
            footer.style.padding = "0 48px";
            const footerLogo = document.createElement("img");
            footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
            footerLogo.alt = "miniicon";
            footerLogo.classList.add("h40px", "w40px", "tal");
            const trademark = document.createElement("p");
            trademark.innerText = `\xa9 Diligentsia Limited ${new Date().getFullYear()}`;
            trademark.classList.add("tac", "c37", "fs12px", "fw400");
            const pageNumberElem = document.createElement("h3");
            pageNumberElem.innerText = "Page " + pageNum;
            pageNumberElem.classList.add("fw600", "c36", "fs14px");
            footer.appendChild(footerLogo);
            footer.appendChild(trademark);
            footer.appendChild(pageNumberElem);
            return footer;
        };
        // Helper function to create a new page
        const createPage = (isFirstPage = false)=>{
            const page = document.createElement("div");
            page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "px3rem", "shadow", "new-report", "researchaid-report");
            page.style.minHeight = A4_HEIGHT_PX + "px";
            page.style.maxHeight = A4_HEIGHT_PX + "px";
            page.style.position = "relative";
            // Add watermark
            const watermark = document.createElement("img");
            watermark.classList.add("op20", "pa");
            watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
            watermark.style.top = "50%";
            watermark.style.left = "50%";
            watermark.style.width = "297mm";
            watermark.style.zIndex = "0";
            page.appendChild(watermark);
            // Create content container
            const content = document.createElement("div");
            content.style.position = "relative";
            content.style.zIndex = "1";
            content.style.paddingBottom = FOOTER_HEIGHT + "px";
            // Free subscription: blur every page except the first
            if (isFreeReport && !isFirstPage) content.classList.add("blur-disabled");
            // Add header for continuation pages
            if (!isFirstPage) {
                titleHeading(content);
                currentPageHeight = HEADER_HEIGHT;
            } else currentPageHeight = 0;
            page.appendChild(content);
            // Add footer
            const footer = createFooter(pageNumber);
            page.appendChild(footer);
            wrapper.appendChild(page);
            pageNumber++;
            return {
                page: page,
                content: content
            };
        };
        // Helper function to check if element fits on current page
        const fitsOnPage = (elementHeight)=>{
            return currentPageHeight + elementHeight <= AVAILABLE_HEIGHT;
        };
        // Helper function to split large content elements
        const splitLargeElement = (element)=>{
            const elementHeight = getHeight(element);
            // If element fits on page, just add it
            if (fitsOnPage(elementHeight)) {
                contentContainer.appendChild(element.cloneNode(true));
                currentPageHeight += elementHeight;
                return;
            }
            // For divs with multiple children, try to split by children
            if (element.tagName === 'DIV' && element.children.length > 0) {
                const children = Array.from(element.children);
                let wrapper = element.cloneNode(false);
                children.forEach((child)=>{
                    const childHeight = getHeight(child);
                    if (!fitsOnPage(childHeight)) {
                        // Flush the current wrapper onto the current page (leave it intact — do NOT clear it,
                        // it has already been appended to the DOM). Clearing the shared node here was emptying
                        // the previous page and moving its content to the last page, leaving the first page blank.
                        if (wrapper.children.length > 0) contentContainer.appendChild(wrapper);
                        // Create new page
                        const newPage = createPage();
                        contentContainer = newPage.content;
                        // Start a fresh wrapper node for the new page
                        wrapper = element.cloneNode(false);
                    }
                    wrapper.appendChild(child.cloneNode(true));
                    currentPageHeight += childHeight;
                });
                // Add remaining wrapper
                if (wrapper.children.length > 0) contentContainer.appendChild(wrapper);
            } else {
                // For other elements or single large elements, add to new page
                if (currentPageHeight > 0) {
                    const newPage = createPage();
                    contentContainer = newPage.content;
                }
                contentContainer.appendChild(element.cloneNode(true));
                currentPageHeight += elementHeight;
            }
        };
        // Helper function to process table elements
        const processTable = (table)=>{
            const rows = Array.from(table.querySelectorAll('tr'));
            let clonedTable = table.cloneNode(false);
            let tableHeader = null;
            // Check if table has thead
            const thead = table.querySelector('thead');
            if (thead) tableHeader = thead.cloneNode(true);
            rows.forEach((row, index)=>{
                const rowHeight = getHeight(row);
                if (!fitsOnPage(rowHeight)) {
                    // Add current table to page if it has rows
                    if (clonedTable.querySelector('tr')) contentContainer.appendChild(clonedTable);
                    // Create new page
                    const newPage = createPage();
                    contentContainer = newPage.content;
                    // Start new table with header if exists
                    clonedTable = table.cloneNode(false);
                    if (tableHeader) {
                        clonedTable.appendChild(tableHeader.cloneNode(true));
                        currentPageHeight += getHeight(tableHeader);
                    }
                }
                clonedTable.appendChild(row.cloneNode(true));
                currentPageHeight += rowHeight;
            });
            // Add remaining table
            if (clonedTable.querySelector('tr')) contentContainer.appendChild(clonedTable);
        };
        // Create first page
        const firstPage = createPage(true);
        contentContainer = firstPage.content;
        // Process all children
        children.forEach((child, index)=>{
            const childHeight = getHeight(child);
            // Handle tables specially
            if (child.tagName === 'TABLE') processTable(child);
            else if (childHeight > AVAILABLE_HEIGHT || !fitsOnPage(childHeight)) // Element is too tall for the space left on the current page. Split it by its children so it fills the
            // current page and flows onto the next — instead of moving the whole section to a fresh page, which was
            // leaving the first page blank below the header when the first section didn't quite fit whole.
            splitLargeElement(child);
            else {
                // Element fits on the current page — add it as-is.
                contentContainer.appendChild(child.cloneNode(true));
                currentPageHeight += childHeight;
            }
        });
        // Clean up
        wrapper.classList.remove("op0", "pen");
        pdfContent.classList.remove("a4", "p3rem");
    });
    const titleHeading = (page)=>{
        const title = document.createElement("span");
        title.classList.add("db", "fw600", "fs1-5rem", "c15", "ttu", "tal", "ass");
        title.classList.add("tal", "mb1-75rem");
        title.innerHTML = reportData['name'] + "<br><span class='db fw400 fs1-5rem c15 fsi tal ass mb1-5rem'>" + company['cName'] + "</span>";
        page.appendChild(title);
        return page;
    };
    const showReportData = ()=>{
        let lastUpdatedTime = reportData?.['history'] && reportData?.['history'].length > 0 && reportData?.['history']?.[reportData?.['history'].length - 1]?.['lastUpdatedTime'];
        console.log("*********lastUpdatedTime::", lastUpdatedTime);
        if (reportData?.['htmlReport']) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb bg54 c15 mb3rem p2rem px2-5rem aic",
                    style: {
                        margin: '-32px -48px 1rem',
                        backgroundSize: '100% 100%',
                        backgroundImage: `url(${(parcelRequire("5xUdw"))})`
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "ass c15 fs1-75rem fw700",
                                    children: company['cName']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "ass c15 fs1-25rem fw400 fsi",
                                    children: reportData['name']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem c15 mt1rem ass",
                                    children: [
                                        "Created By: ",
                                        reportData?.['createdBy']?.['firstName'],
                                        " ",
                                        reportData?.['createdBy']?.['lastName']
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem c15 ass",
                                    children: [
                                        "Report Date: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw600",
                                            children: lastUpdatedTime || (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(reportData['updatedAt']).format('MMM Do YYYY, h:mm A')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc pr3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar reasearcaid-report bg1 p0-5rem br100",
                                    style: {
                                        width: 100,
                                        height: 100,
                                        border: '3px solid #f1f1f1'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${reportData['score'] >= 4 ? 'green' : reportData['score'] >= 2 ? 'orange' : 'red'}`,
                                        value: reportData['score'],
                                        strokeWidth: 18,
                                        text: reportData['score'],
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: 'round',
                                            textSize: '20px',
                                            pathTransitionDuration: 0.5,
                                            trailColor: '#d6d6d6',
                                            backgroundColor: '#fc7785',
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "fs1rem fw400 c15 mt0-75rem",
                                    children: "Report Score"
                                })
                            ]
                        })
                    ]
                }),
                reportData?.['htmlReport'].map((item, idx)=>{
                    // Blur is applied page-by-page in the pagination effect (Free subscription), not per section here
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        class: "c15",
                        dangerouslySetInnerHTML: {
                            __html: item
                        }
                    }, idx);
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: company && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                    id: "pdf",
                    className: `op0 pen ma td250 dg gg2rem jcc`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                    id: "pdfContent",
                    className: "bsbb w0 h0 oh op0 pen db pr",
                    style: {
                        width: "210mm"
                    },
                    children: showReportData()
                })
            ]
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");






function $013ff032d592f1b0$export$2e2bcd8739ae039({ company: company, tab: tab, setTab: setTab, setOpenTabs: setOpenTabs, setTabName: setTabName, setCompanyDashboardTab: setCompanyDashboardTab, isBackFitReport: isBackFitReport, setIsBackFitReport: setIsBackFitReport, title: title, reportData: reportData, onCloseReport: onCloseReport }) {
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [sidebarFixed, setSidebarFixed] = (0, $acw62.useState)(false);
    const [isDownloading, setIsDownloading] = (0, $acw62.useState)(false);
    let reportsNames = {
        'marketReport-researchaid': 'MarketOpporunity',
        'competitorReport-researchaid': 'CompetitorAnalysis',
        'routeToMarketReport-researchaid': 'RouteToMarket',
        'TCAR3-researchaid': 'TechAdvantage',
        'swotAnalysis-researchaid': 'SWOT',
        'insuranceGapAnalysis-researchaid': 'InsuranceGapAnalysis',
        'insurance-gap-analysis-report': 'InsuranceGapAnalysis'
    };
    const resolveResearchAidReportKey = (tabValue)=>{
        if (!tabValue) return null;
        const normalized = String(tabValue).trim();
        if (normalized.includes('?')) {
            const suffix = normalized.split('?').pop();
            return suffix?.endsWith('-researchaid') ? suffix : null;
        }
        if (normalized.endsWith('-researchaid') || normalized === 'insurance-gap-analysis-report') return normalized;
        return null;
    };
    const getPdfReportLabel = ()=>{
        const reportKey = resolveResearchAidReportKey(tab);
        if (reportKey && reportsNames[reportKey]) return reportsNames[reportKey];
        if (reportData?.reportType && reportsNames[`${reportData.reportType}-researchaid`]) return reportsNames[`${reportData.reportType}-researchaid`];
        if (reportData?.name) return String(reportData.name).replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '') || 'ResearchAid';
        if (title) return String(title).replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '') || 'ResearchAid';
        return 'ResearchAid';
    };
    (0, $acw62.useEffect)(()=>{
        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const handleSidebarStick = ()=>{
            if (isSafari && window.scrollY > 925) setSidebarFixed(true);
            else setSidebarFixed(false);
        };
        window.addEventListener('scroll', handleSidebarStick);
        return ()=>window.removeEventListener('scroll', handleSidebarStick);
    }, []);
    const convertImageToBase64 = async (imgUrl)=>{
        try {
            let absoluteUrl = imgUrl;
            if (!imgUrl.startsWith('http') && !imgUrl.startsWith('//') && !imgUrl.startsWith('data:') && !imgUrl.startsWith('blob:')) {
                if (imgUrl.startsWith('/')) absoluteUrl = window.location.origin + imgUrl;
                else absoluteUrl = new window.URL(imgUrl, window.location.href).href;
            }
            const needsProxy = absoluteUrl.includes('s3') || absoluteUrl.includes('amazonaws') || absoluteUrl.includes('cloudfront');
            const fetchUrl = needsProxy ? `${0, $6a6b4b5ab5be324d$export$61abde59b50deb8e}/api/company/pdf-proxy?url=${encodeURIComponent(absoluteUrl)}` : absoluteUrl;
            const response = await fetch(fetchUrl);
            const blob = await response.blob();
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error converting image to base64:', imgUrl, error);
            return imgUrl;
        }
    };
    const convertAllImagesToBase64 = async (element)=>{
        // Convert all img elements
        const images = element.querySelectorAll('img');
        const imagePromises = [];
        for (const img of images){
            const src = img.src;
            if (src && (src.includes('s3') || src.includes('amazonaws') || src.includes('cloudfront') || src.startsWith('http'))) imagePromises.push(convertImageToBase64(src).then((base64)=>{
                img.setAttribute('data-original-src', src);
                img.src = base64;
            }));
        }
        // Convert background images (check both computed styles and inline styles)
        const allElements = element.querySelectorAll('*');
        const backgroundPromises = [];
        allElements.forEach((el)=>{
            // Check computed style first
            let bgImage = window.getComputedStyle(el).backgroundImage;
            // Also check inline style if computed style is empty
            if ((!bgImage || bgImage === 'none') && el.style.backgroundImage) bgImage = el.style.backgroundImage;
            if (bgImage && bgImage !== 'none' && bgImage.includes('url(')) {
                const urlMatch = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);
                if (urlMatch && urlMatch[1]) {
                    let bgUrl = urlMatch[1];
                    // Skip if already a data URL or blob URL
                    if (bgUrl.startsWith('data:') || bgUrl.startsWith('blob:')) // Already converted, skip
                    return;
                    // Convert all external and relative image URLs (including webpack-processed paths)
                    // This includes: http URLs, S3 URLs, and relative paths (webpack bundles)
                    const shouldConvert = bgUrl.startsWith('http') || bgUrl.startsWith('//') || bgUrl.startsWith('/') || bgUrl.includes('s3') || bgUrl.includes('amazonaws') || bgUrl.includes('cloudfront') || bgUrl.includes('static/');
                    if (shouldConvert) backgroundPromises.push(convertImageToBase64(bgUrl).then((base64)=>{
                        const originalBg = el.style.backgroundImage || bgImage;
                        el.setAttribute('data-original-bg', originalBg);
                        el.style.backgroundImage = `url(${base64})`;
                    }).catch((err)=>{
                        console.warn('Failed to convert background image:', bgUrl, err);
                    }));
                }
            }
        });
        await Promise.all([
            ...imagePromises,
            ...backgroundPromises
        ]);
    };
    const restoreOriginalImages = (element)=>{
        // Restore img elements
        const images = element.querySelectorAll('img[data-original-src]');
        for (const img of images){
            img.src = img.getAttribute('data-original-src');
            img.removeAttribute('data-original-src');
        }
        // Restore background images
        const bgElements = element.querySelectorAll('[data-original-bg]');
        for (const el of bgElements){
            el.style.backgroundImage = el.getAttribute('data-original-bg');
            el.removeAttribute('data-original-bg');
        }
    };
    const downloadPDF = async ()=>{
        if (isDownloading) return;
        if ((company['subscription'] != 'Pro' || user?.['role'] == 'Guest') && user['type'] !== 'External') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please upgrade to PRO to download report');
        // When a Papermill PDF exists, download it directly instead of re-rendering via html2pdf
        const papermillUrl = document.getElementById('analyser-pdf-url')?.href;
        if (papermillUrl) {
            try {
                setIsDownloading(true);
                const _sectionLabel = title && title !== 'Section Report' && title !== 'Insurance Gap Analysis Report' ? title : getPdfReportLabel();
                const filename = `${company?.['cName'] || 'Company'} ${_sectionLabel} Analyser Report \u{2013} ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format('DD.MM.YY')}.pdf`;
                const proxyUrl = `${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api/company/pdf-proxy?url=${encodeURIComponent(papermillUrl)}`;
                const response = await fetch(proxyUrl);
                if (!response.ok) throw new Error('Download failed');
                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                setTimeout(()=>URL.revokeObjectURL(blobUrl), 1000);
            } catch (e) {
                console.error('Error downloading Papermill PDF:', e);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error downloading PDF. Please try again.');
            } finally{
                setIsDownloading(false);
            }
            return;
        }
        try {
            setIsDownloading(true);
            const wrapper = document.getElementById("pdf");
            if (!wrapper) {
                console.error('PDF wrapper not found');
                return;
            }
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.remove("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah100vh"));
            wrapper.classList.remove("gg2rem");
            for (const page of wrapper.children)page.classList.remove("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.add("op0");
            // Wait for all images to load first
            const allImages = wrapper.querySelectorAll('img');
            const imageLoadPromises = Array.from(allImages).map((img)=>{
                if (img.complete) return Promise.resolve();
                return new Promise((resolve, reject)=>{
                    img.onload = resolve;
                    img.onerror = resolve; // Resolve even on error to not block
                    setTimeout(resolve, 2000); // Timeout after 2 seconds
                });
            });
            await Promise.all(imageLoadPromises);
            // Convert all images (including background images) to base64
            await convertAllImagesToBase64(wrapper);
            // Wait a bit for base64 images to be applied
            await new Promise((resolve)=>setTimeout(resolve, 300));
            const _sectionLabel = title && title !== 'Section Report' && title !== 'Insurance Gap Analysis Report' ? title : getPdfReportLabel();
            const filename = `${company?.['cName'] || 'Company'} ${_sectionLabel} Analyser Report \u{2013} ${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format('DD.MM.YY')}.pdf`;
            const opt = {
                filename: filename,
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'p'
                },
                html2canvas: {
                    useCORS: true,
                    allowTaint: true,
                    logging: false,
                    scale: 2,
                    backgroundColor: '#ffffff',
                    removeContainer: true
                }
            };
            await (0, (/*@__PURE__*/$parcel$interopDefault($8994635913a5668f$exports)))().set(opt).from(wrapper).save();
            // Restore original images after PDF generation
            restoreOriginalImages(wrapper);
            wrapper.classList.add("gg2rem");
            for (const page of wrapper.children)page.classList.add("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.remove("op0");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.add("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah100vh"));
        } catch (e) {
            console.error('Error generating PDF:', e);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Error generating PDF. Please try again.');
        } finally{
            setIsDownloading(false);
        }
    };
    const handleCloseReport = async ()=>{
        // if (title) {
        //     setTab('repository')
        //     setCompanyDashboardTab('Dashboard')
        //     // setTimeout(() => {
        //     //     const targetElement = document.getElementById("D006");
        //     //     if (targetElement) {
        //     //         targetElement.scrollIntoView({
        //     //             behavior: 'smooth',
        //     //             block: 'start'
        //     //         });
        //     //     }
        //     // }, 500);
        //     return
        // }
        console.log(tab);
        if (tab.includes('analyser')) {
            await setTabName('');
            setCompanyDashboardTab('Analyser');
            return;
        }
        if (user['role'] == 'Investor' && user?.['companyId']?.['_id'] && isBackFitReport) {
            await setCompanyDashboardTab('Dashboard');
            setIsBackFitReport(false);
            setTab(`fit-report:${user?.['companyId']?.['_id']}`);
            setOpenTabs(new Set([
                `fit-report:${user?.['companyId']?.['_id']}`
            ]));
            return;
        }
        if (localStorage.getItem('isDiligencePack') && !isBackFitReport || user?.['type'] == 'External') {
            await setCompanyDashboardTab('Dashboard');
            setTab('diligence-pack');
            setOpenTabs(new Set([
                `diligence-pack`
            ]));
            localStorage.removeItem('isDiligencePack');
            return;
        }
        if (user['role'] == 'User' && isBackFitReport) {
            setIsBackFitReport(false);
            setTabName('');
            setCompanyDashboardTab('InvestorMatch');
            return;
        }
        if (tab.includes('DRN0')) {
            setTabName('repository');
            setTab('repository');
            setOpenTabs(new Set([
                `repository`
            ]));
            setCompanyDashboardTab('Dashboard');
            window.location.href = `/company/${company['_id']}#repository`;
            return;
        }
        await setTabName('');
        setCompanyDashboardTab('ResearchAid');
    };
    const handleCloseReportLink = ()=>{
        if (user['role'] == 'Investor' && user?.['companyId']?.['_id'] && isBackFitReport) return `/company/${company['_id']}#fit-report:${user?.['companyId']?.['_id']}`;
        else if (localStorage.getItem('isDiligencePack') && !isBackFitReport || user?.['type'] == 'External') return `/company/${company['_id']}#diligence-pack`;
        else return `/company/${company['_id']}`;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            id: "sidebar",
            style: {
                width: "calc((100% - 4rem) / 5)"
            },
            className: `w100 h100 bsbb dg gg1rem t0 sidebar-report ${sidebarFixed ? 'sidebar-fixed' : 'ps'}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bo45 bss bw1px br8px bg38",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc aic fdc py1rem pb6rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c3 fs1-5rem fw500 ttu w100 tac mb1rem",
                            children: title ? title : "RESEARCHAID REPORT"
                        }),
                        user['type'] !== 'External' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>handleCloseReport(),
                            className: "close-report-btn-reaserch cp my1rem mxa bg1 bg4-hover c15 fs1rem c1-hover td250 fw300 bw1px bss bo4 br50px py0-5rem px3rem tac",
                            type: "button",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fa fa-times-circle c4 c1-hover td250 mr0-5rem "
                                }),
                                " Close Report"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>downloadPDF(),
                            type: "button",
                            disabled: isDownloading,
                            "data-tooltip": company['subscription'] != 'Pro' ? 'Please upgrade to PRO to download report' : '',
                            className: `df jcc aic mt0-5rem mxa shadow c1 br30px fs0-75rem py0-75rem px3rem fw600 ttu download-report-btn-reaserch ${isDownloading || (company['subscription'] != 'Pro' || user?.['role'] == 'Guest') && user['type'] !== 'External' ? ' bg3 cna op30' : ' bg3 bg4-hover cp'}`,
                            children: isDownloading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$67ad50c48ca3ede4), {
                                        height: "16",
                                        width: "16",
                                        strokeWidth: "4",
                                        secondaryColor: "#ffffff80",
                                        color: "#fff",
                                        ariaLabel: "oval-loading"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ml0-5rem",
                                        children: "Downloading..."
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        className: "mr0-5rem",
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M10.5703 13.4294H3.42745C2.66433 13.4294 1.94684 13.1322 1.40716 12.5925C0.867511 12.0529 0.570312 11.3354 0.570312 10.5722V9.85793C0.570312 9.46342 0.890092 9.14362 1.2846 9.14362C1.67911 9.14362 1.99889 9.46342 1.99889 9.85793V10.5722C1.99889 10.9538 2.1475 11.3126 2.41728 11.5824C2.68713 11.8522 3.04586 12.0008 3.42745 12.0008H10.5703C10.9519 12.0008 11.3106 11.8522 11.5804 11.5824C11.8502 11.3125 11.9989 10.9538 11.9989 10.5722V9.85793C11.9989 9.46342 12.3187 9.14362 12.7131 9.14362C13.1076 9.14362 13.4275 9.46342 13.4275 9.85793V10.5722C13.4275 11.3354 13.1303 12.0528 12.5906 12.5925C12.0509 13.1322 11.3334 13.4294 10.5703 13.4294ZM6.99887 10.5722C6.90006 10.5722 6.80599 10.5522 6.72041 10.5159C6.64057 10.4822 6.56554 10.4332 6.49989 10.3691C6.49986 10.369 6.49986 10.369 6.49984 10.369C6.49936 10.3686 6.49889 10.3681 6.49842 10.3676C6.49829 10.3675 6.49814 10.3673 6.49802 10.3672C6.49762 10.3669 6.49727 10.3665 6.49689 10.3661C6.49664 10.3659 6.49642 10.3657 6.49617 10.3654C6.49592 10.3651 6.4956 10.3648 6.49537 10.3646C6.49487 10.3641 6.49432 10.3636 6.49382 10.3631L3.63667 7.50589C3.35773 7.22696 3.35773 6.77469 3.63667 6.49573C3.9156 6.21679 4.3679 6.21677 4.64683 6.49573L6.28461 8.1335V1.28656C6.28458 0.892046 6.60436 0.572266 6.99887 0.572266C7.39338 0.572266 7.71319 0.892046 7.71319 1.28656V8.13348L9.35093 6.49573C9.62984 6.21679 10.0822 6.21679 10.3611 6.49573C10.64 6.77466 10.64 7.22696 10.3611 7.50589L7.50394 10.363C7.50344 10.3635 7.50289 10.3641 7.50239 10.3646C7.50212 10.3648 7.50182 10.3651 7.5016 10.3653C7.50135 10.3656 7.50112 10.3658 7.50087 10.3661C7.50052 10.3665 7.50012 10.3668 7.49977 10.3672C7.49965 10.3673 7.49948 10.3675 7.49935 10.3676C7.4989 10.368 7.49843 10.3685 7.49795 10.369C7.49793 10.369 7.49793 10.369 7.4979 10.369C7.49004 10.3767 7.48208 10.3841 7.47395 10.3913C7.41414 10.4447 7.34752 10.4863 7.27708 10.516C7.27683 10.5161 7.27663 10.5162 7.27638 10.5163C7.27611 10.5164 7.27588 10.5165 7.27561 10.5166C7.19047 10.5525 7.09701 10.5722 6.99887 10.5722Z",
                                            fill: "white"
                                        })
                                    }),
                                    "Download PDF"
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");


const $def17927b8072e3f$var$SuperFlowHeader = ({ company: company, breadcrum: breadcrum, heading: heading, page: page })=>{
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: `${page != 'InvestorMatch Stats' && 'dashboard-container'}  pt2rem pb1rem df fdc`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `banner-advisor-dashboard pr w100 mt2rem mb1rem company-dashboard-bg ${company?.['creatorId']?.['role'] == 'Advisor' ? 'advisor-bg-lite' : company?.['creatorId']?.['role'] == 'Investor' ? 'investor-bg' : 'client-bg'}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `company-tab bg1 new-shadow br20px py2rem px3rem my2rem pr`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `dg gtcr2 jcsb aic top-admin-area mb2rem`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic left-area",
                                    children: [
                                        page == 'InvestorMatch Stats' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "/investor-dashboard#index?QualifiedLeads",
                                            className: "cp mt0-5rem mr1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                width: "22",
                                                height: "16",
                                                viewBox: "0 0 22 16",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                                    fill: "#151313"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "df aic lisn",
                                            children: breadcrum && breadcrum.map((item, idx)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    className: `c27 ${idx == breadcrum.length - 1 && 'c12 fw600'}`,
                                                    children: item
                                                });
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "right-area df jcfe",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "ass df",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fs1rem aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "mr1rem tar df fdc",
                                                    children: [
                                                        user?.['firstName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c15 ase",
                                                            children: user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : "")
                                                        }),
                                                        company?.['creatorId']?.['_id'] == user['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `c3 ase fs0-75rem`,
                                                            children: "Company Admin"
                                                        })
                                                    ]
                                                }),
                                                user?.['firstName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `w30px h30px df jcc aic br100 bg3 c1 bw3px bss bo30`,
                                                    children: user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: user?.['profile'],
                                                        className: `w30px h30px df jcc aic br100 bw3px bss bo30`,
                                                        "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : "")
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `w30px h30px df jcc aic br100`,
                                                        "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : ""),
                                                        children: user?.['firstName'] ? user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "") : "?"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww aifs company-details-area",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "left-company-area w33",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "fs1-5rem fw500 c27",
                                        children: company?.['cName'] || "Loading..."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "center-logo-area w33 df jcc fww fdc mla mra pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "company-name",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "c15 fs2rem mt2rem tac w100 fw500 mb2rem",
                                            children: heading
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "right-certificate-area w33 df jce"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $def17927b8072e3f$export$2e2bcd8739ae039 = $def17927b8072e3f$var$SuperFlowHeader;






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");





const $b9f7071fd0c9532c$var$RepositoryAlert = ({ setTabName: setTabName })=>{
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const handleClose = ()=>{
        setTabName('');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$c42821355a5f8135)(true));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
            open: modal['open'] == 'repositoryAlert',
            onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                })),
            className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "h2rem pa t0 l0 m1rem",
                        src: (parcelRequire("aR1CT")),
                        alt: "TODO"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tac my1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb0-5rem",
                            children: "The files allocation process is currently running in the background. Please access this module after some time."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/company/${id}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                onClick: handleClose,
                                className: "w100 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttu bsbb df jcc",
                                children: "Go Back"
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $b9f7071fd0c9532c$export$2e2bcd8739ae039 = $b9f7071fd0c9532c$var$RepositoryAlert;






var $ayMG0 = parcelRequire("ayMG0");










const $75097013a2b9925d$var$FirstSetupDataRepositoryModal = ({ modalType: modalType, dispatch: dispatch, companyId: companyId, company: company })=>{
    const handleVisitedDataRepo = async ()=>{
        try {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...company,
                firstVisitRepository: true
            }));
            localStorage.setItem('firstVisitRepository', true);
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/updateFirstVisitDataRepo', {
                companyId: companyId
            });
        } catch (err) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(err.message);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: modalType,
        modalCardClasses: "maw1300px FirstSetupData bg38",
        onCloseHandler: handleVisitedDataRepo,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs1-5rem fw500",
                        children: "How to populate our Data Repository"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "c3 fs1-25rem fw500 mb2rem",
                        children: "First time?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                class: "w100 df jcc mb2rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "",
                    src: (parcelRequire("ayytt")),
                    alt: "steps"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w100 df jcc",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "mx0-5rem",
                        src: (parcelRequire("7UE16")),
                        alt: "first-time-repository-1"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "mx0-5rem",
                        src: (parcelRequire("coXQs")),
                        alt: "first-time-repository-2"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "mx0-5rem",
                        src: (parcelRequire("1gvNG")),
                        alt: "first-time-repository-3"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "mx0-5rem",
                        src: (parcelRequire("iCdyZ")),
                        alt: "first-time-repository-4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt2rem w100 fs1rem df jcc",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    btnType: "warning",
                    customClassName: "w20 cp",
                    text: "Let\u2019s Go!",
                    onClick: handleVisitedDataRepo
                })
            })
        ]
    });
};
var $75097013a2b9925d$export$2e2bcd8739ae039 = $75097013a2b9925d$var$FirstSetupDataRepositoryModal;




var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");




var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $6717d2334b7944f8$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');




var $ebf2f600012585f0$exports = {};
$ebf2f600012585f0$exports = new URL("reportHDRBg.0cd0e4a6.png", import.meta.url).toString();




const $ceaf1026d7cd7a8b$var$InsuranceGapAnalysisReport = ({ company: company, tab: tab, onReportResolved: onReportResolved })=>{
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    // A4 dimensions in pixels at 96 DPI — .a4-pdf SASS class = 210mm × 297.7mm
    const A4_HEIGHT_PX = 1125; // 297.7mm × (96/25.4) ≈ 1125px
    const A4_WIDTH_PX = 794; // 210mm × (96/25.4) ≈ 794px
    const FOOTER_HEIGHT = 80; // Footer is position:absolute — content paddingBottom reserves this space
    const SAFETY_BUFFER = 20; // Buffer so content never brushes the footer
    // Fallbacks used only if DOM measurement of the header element fails
    const FIRST_PAGE_HEADER_HEIGHT = 220;
    const HEADER_HEIGHT = 120;
    // AVAILABLE_HEIGHT = full page height minus the footer reserve at the bottom.
    // Header height is NOT subtracted here — it is tracked in currentPageHeight from the first element added.
    const AVAILABLE_HEIGHT = A4_HEIGHT_PX - FOOTER_HEIGHT - SAFETY_BUFFER; // ≈ 1025px
    let [reportId, setReportId] = (0, $acw62.useState)();
    let [reportData, setReportData] = (0, $acw62.useState)({});
    let [fetchedAiReports, setFetchedAiReports] = (0, $acw62.useState)(null);
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const createdBy = [
        user?.firstName,
        user?.lastName
    ].filter(Boolean).join(' ') || user?.email || 'Diligentsia Team';
    // When viewing a history snapshot, show that version's saved date; otherwise use createdAt.
    // New records store lastUpdatedTime as UTC ISO-8601; legacy records stored a human-readable
    // string (saved in server local time — treat as UTC for prod backward compat).
    const historyReportDate = (()=>{
        if (reportData['lastUpdatedTime']) {
            const iso = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(reportData['lastUpdatedTime'], (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).ISO_8601, true);
            if (iso.isValid()) return iso.local().format('MMM Do YYYY, h:mm A');
            const legacy = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).utc(reportData['lastUpdatedTime'], [
                'MMMM Do, YYYY  hh:mma',
                'MMMM Do, YYYY hh:mma'
            ], true);
            if (legacy.isValid()) return legacy.local().format('MMM Do YYYY, h:mm A');
        }
        if (reportData['createdAt']) return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).utc(reportData['createdAt']).local().format('MMM Do YYYY, h:mm A');
        return '';
    })();
    const reportDate = historyReportDate;
    (0, $acw62.useEffect)(()=>{
        // Update reportId when tab or hash changes
        if (tab) {
            // If tab is provided, use it directly
            let sanitizedTab = (0, $cb3ceb5821786f07$export$57c43fe781091dc0)(tab);
            // Also remove -analyser suffix if present (for Analyser reports)
            sanitizedTab = sanitizedTab.replace(/-analyser$/, '');
            setReportId(sanitizedTab);
        } else if (window.location.hash) {
            let hash = window.location.hash.split('?')[0];
            if (hash) {
                hash = hash.replaceAll('#', '');
                let sanitizedHash = (0, $cb3ceb5821786f07$export$57c43fe781091dc0)(hash);
                // Also remove -analyser suffix if present
                sanitizedHash = sanitizedHash.replace(/-analyser$/, '');
                setReportId(sanitizedHash);
            }
        }
    }, [
        tab
    ]);
    // Also listen to hash changes for direct navigation
    (0, $acw62.useEffect)(()=>{
        const handleHashChange = ()=>{
            if (window.location.hash && !tab) {
                let hash = window.location.hash.split('?')[0];
                if (hash) {
                    hash = hash.replaceAll('#', '');
                    let sanitizedHash = (0, $cb3ceb5821786f07$export$57c43fe781091dc0)(hash);
                    // Also remove -analyser suffix if present
                    sanitizedHash = sanitizedHash.replace(/-analyser$/, '');
                    setReportId(sanitizedHash);
                }
            }
        };
        // Also check on mount
        handleHashChange();
        window.addEventListener('hashchange', handleHashChange);
        return ()=>window.removeEventListener('hashchange', handleHashChange);
    }, [
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!company?._id) return;
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/reports`).then((res)=>{
            if (res?.['code'] == 200) setFetchedAiReports(res['body']?.['reports']?.['aiReports'] || []);
        }).catch(()=>{});
    }, [
        company?._id
    ]);
    (0, $acw62.useEffect)(()=>{
        // Prefer the dedicated /reports payload. company.aiReports is often missing or stripped
        // of nested history.htmlReport (separate APIs / payload optimization), which made history
        // opens silently fall back to the latest report.
        const reportsArray = fetchedAiReports != null ? fetchedAiReports : company?.['aiReports'] || [];
        if (!reportId || !String(reportId).trim()) {
            console.log('[InsuranceGapAnalysisReport] No reportId provided or empty');
            setReportData({});
            return;
        }
        // Reason: when opening a history version, wait for /reports so we can resolve the
        // snapshot (unless sessionStorage already has it from the Analyser card click).
        const rawReportIdEarly = String(reportId || '').trim();
        const needsHistory = rawReportIdEarly.includes('--history--') || rawReportIdEarly.includes('history=');
        if (needsHistory && fetchedAiReports == null) {
            let hasSessionSnapshot = false;
            try {
                const hid = rawReportIdEarly.includes('--history--') ? rawReportIdEarly.split('--history--')[1] : new URLSearchParams(rawReportIdEarly.split('?')[1] || '').get('history') || '';
                hasSessionSnapshot = !!(hid && sessionStorage.getItem(`analyserHistory:${hid}`));
            } catch (_) {
                hasSessionSnapshot = false;
            }
            if (!hasSessionSnapshot) return;
        }
        // Clean reportId - remove query params / history delimiter and ensure it's a string
        const rawReportId = String(reportId || '').trim();
        // Supports both legacy `?history=<id>` and current `--history--<id>` tab formats
        let historyId = '';
        let cleanReportId = rawReportId;
        if (rawReportId.includes('--history--')) {
            const parts = rawReportId.split('--history--');
            cleanReportId = parts[0].trim();
            historyId = (parts[1] || '').trim();
        } else {
            cleanReportId = rawReportId.split('?')[0].trim();
            const reportIdQuery = rawReportId.split('?')[1];
            if (reportIdQuery) historyId = new URLSearchParams(reportIdQuery).get('history') || '';
        }
        // Reason: even if /reports hasn't loaded yet, an Analyser card click may have stashed
        // the archived htmlReport — render that immediately so history never falls back to latest.
        if (historyId) try {
            const raw = sessionStorage.getItem(`analyserHistory:${historyId}`);
            if (raw) {
                const snapshot = JSON.parse(raw);
                if (Array.isArray(snapshot['htmlReport']) && snapshot['htmlReport'].length) {
                    setReportData({
                        reportLabel: snapshot['reportLabel'] || cleanReportId,
                        name: snapshot['name'] || cleanReportId,
                        htmlReport: snapshot['htmlReport'],
                        lastUpdatedTime: snapshot['lastUpdatedTime'] || null,
                        pdfUrl: snapshot['pdfUrl'] || null,
                        score: snapshot['score'] != null ? snapshot['score'] : null,
                        report: snapshot['report'] != null ? snapshot['report'] : null,
                        isHistoryVersion: true
                    });
                    if (onReportResolved) onReportResolved(snapshot['reportLabel'] || snapshot['name'] || '');
                // Continue below to merge richer metadata from /reports when available
                }
            }
        } catch (_) {}
        if (reportsArray.length === 0) {
            // Keep sessionStorage-rendered history; otherwise show empty until /reports returns
            if (!historyId) {
                console.log('[InsuranceGapAnalysisReport] No reports available yet');
                setReportData({});
            }
            return;
        }
        // Helper function to sanitize reportLabel for matching (must match Analyser/index.js sanitizeReportLabel)
        const sanitizeForMatching = (label)=>{
            if (!label) return '';
            return label.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9.-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
        };
        // Find matching report
        let foundReport = null;
        for (const item of reportsArray){
            if (!item?.htmlReport) continue;
            // Priority 1: Try matching by sanitized reportLabel (for Analyser reports with reportLabel)
            // This should be checked first since we're now using reportLabel as the primary identifier
            if (item.reportLabel) {
                const sanitizedLabel = sanitizeForMatching(item.reportLabel);
                if (sanitizedLabel === cleanReportId || sanitizedLabel === reportId) {
                    foundReport = item;
                    break;
                }
            }
            // Priority 2: Try matching by _id (for Analyser reports using _id as identifier)
            if (item._id) {
                const itemIdStr = item._id.toString();
                if (itemIdStr === cleanReportId || itemIdStr === reportId) {
                    foundReport = item;
                    break;
                }
            }
            if (item.reportType && item.reportType.startsWith('sectionReport_')) {
                const sanitizedSectionName = item.reportType.replace('sectionReport_', '');
                const itemSanitizedName = item.sanitizedSectionName || sanitizedSectionName;
                let extractedSectionName = reportId;
                if (reportId.endsWith('-section')) extractedSectionName = reportId.replace(/-section$/, '');
                if (itemSanitizedName === extractedSectionName) {
                    foundReport = item;
                    break;
                }
                if (itemSanitizedName === reportId) {
                    foundReport = item;
                    break;
                }
                if (itemSanitizedName.toLowerCase() === extractedSectionName.toLowerCase()) {
                    foundReport = item;
                    break;
                }
                if (item.reportType === `sectionReport_${reportId}` || item.reportType === `sectionReport_${extractedSectionName}`) {
                    foundReport = item;
                    break;
                }
            } else {
                // Standard report matching by name
                const itemNameSanitized = (0, $cb3ceb5821786f07$export$57c43fe781091dc0)(item['name']?.toLowerCase().replaceAll(" ", "-") || '');
                if (itemNameSanitized === reportId || itemNameSanitized === (0, $cb3ceb5821786f07$export$57c43fe781091dc0)(reportId)) {
                    foundReport = item;
                    break;
                }
            }
        }
        if (foundReport) {
            // If a history id was requested, render that saved snapshot instead of the latest version.
            let resolvedReport = foundReport;
            if (historyId) {
                let snapshot = null;
                // Reason: Analyser stashes the exact archived htmlReport when the card is clicked.
                // Prefer that over re-resolving from company.aiReports /reports, because those
                // payloads can omit nested history.htmlReport and we would silently show latest.
                try {
                    const raw = sessionStorage.getItem(`analyserHistory:${historyId}`);
                    if (raw) snapshot = JSON.parse(raw);
                } catch (_) {
                    snapshot = null;
                }
                if (snapshot && Array.isArray(snapshot['htmlReport']) && snapshot['htmlReport'].length) resolvedReport = {
                    ...foundReport,
                    htmlReport: snapshot['htmlReport'],
                    lastUpdatedTime: snapshot['lastUpdatedTime'] || null,
                    pdfUrl: snapshot['pdfUrl'] || foundReport['pdfUrl'] || null,
                    score: snapshot['score'] != null ? snapshot['score'] : foundReport['score'],
                    report: snapshot['report'] != null ? snapshot['report'] : foundReport['report'],
                    isHistoryVersion: true
                };
                else if (Array.isArray(foundReport['history'])) {
                    const historyEntry = foundReport['history'].find((h)=>String(h?.['_id'] || '') === String(historyId));
                    if (historyEntry && Array.isArray(historyEntry['htmlReport']) && historyEntry['htmlReport'].length) resolvedReport = {
                        ...foundReport,
                        htmlReport: historyEntry['htmlReport'],
                        lastUpdatedTime: historyEntry['lastUpdatedTime'],
                        pdfUrl: historyEntry['pdfUrl'] || foundReport['pdfUrl'] || null,
                        score: historyEntry['score'] != null ? historyEntry['score'] : foundReport['score'],
                        report: historyEntry['report'] != null ? historyEntry['report'] : foundReport['report'],
                        isHistoryVersion: true
                    };
                    else {
                        console.warn('[InsuranceGapAnalysisReport] History snapshot not found or has no content, keeping prior/latest carefully:', historyId);
                        // Reason: never silently replace an already-rendered archived snapshot with latest
                        return;
                    }
                } else {
                    console.warn('[InsuranceGapAnalysisReport] No history array on report for historyId:', historyId);
                    return;
                }
            }
            setReportData(resolvedReport);
            if (onReportResolved) onReportResolved(foundReport['reportLabel'] || foundReport['name'] || '');
        } else if (!historyId) {
            // Debug: Log when report is not found to help diagnose issues
            if (reportId && reportsArray.length > 0) console.error('[InsuranceGapAnalysisReport] Report not found:', {
                reportId: reportId,
                cleanReportId: cleanReportId,
                historyId: historyId,
                count: reportsArray.length
            });
            setReportData({});
        }
    // If historyId was set and foundReport missing, keep sessionStorage-rendered archived view.
    }, [
        tab,
        reportId,
        company,
        fetchedAiReports
    ]);
    (0, $acw62.useEffect)(()=>{
        const pdfContent = document.getElementById("pdfContent");
        const wrapper = document.getElementById("pdf");
        if (!pdfContent || !wrapper || !reportData?.['htmlReport']) return;
        // Reason: when Papermill generated the PDF, show the embedded viewer instead
        if (reportData?.['pdfUrl']) return;
        // Deduplicate htmlReport array if needed (safety check)
        let htmlReportArray = reportData['htmlReport'];
        if (Array.isArray(htmlReportArray)) {
            const seen = new Set();
            htmlReportArray = htmlReportArray.filter((item, index)=>{
                if (!item || typeof item !== 'string') return false;
                const trimmed = item.trim();
                if (trimmed.length === 0) return false; // Remove empty items
                const normalized = trimmed.replace(/\s+/g, ' ');
                if (seen.has(normalized)) {
                    console.warn(`Duplicate htmlReport section at index ${index} detected and removed`);
                    return false;
                }
                seen.add(normalized);
                return true;
            });
        }
        pdfContent.classList.add("a4-pdf", "p3rem");
        wrapper.innerHTML = "";
        // Add global styles to ensure tables don't overflow
        if (!document.getElementById('table-width-fix')) {
            const style = document.createElement('style');
            style.id = 'table-width-fix';
            style.textContent = `
                #pdf table {
                    max-width: 100% !important;
                    width: 100% !important;
                    box-sizing: border-box !important;
                    table-layout: auto !important;
                    border-collapse: collapse !important;
                }
                #pdf table td, #pdf table th {
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    white-space: normal !important;
                    /* Remove max-width: 0 to allow all columns to render properly */
                    /* With table-layout: auto, columns will auto-size based on content */
                }
                #pdf .insurance-gap-report {
                    width: 210mm !important;
                    max-width: 210mm !important;
                }
                #pdf .insurance-gap-report > div {
                    max-width: 100% !important;
                    overflow: hidden !important;
                }
            `;
            document.head.appendChild(style);
        }
        // Get children from pdfContent - filter out non-report content (buttons, disclaimers, etc.)
        // Also extract all tables from containers to process them individually
        let children = [];
        const allTables = new Set(); // Track all tables to prevent duplicates
        Array.from(pdfContent.children).forEach((child)=>{
            // Only process elements that contain report content (not the CTA buttons or disclaimer)
            const isReportContent = child.classList.contains('insurance-section') || child.classList.contains('insurance-report-content') || child.querySelector && (child.querySelector('table') || child.querySelector('.summary-container'));
            if (!isReportContent) return;
            // If child contains tables, we'll extract them separately
            // But keep the child for non-table content
            const tablesInChild = child.querySelectorAll('table');
            if (tablesInChild.length > 0) // Child contains tables - we'll process tables separately
            // But keep child reference for extracting titles/summaries
            children.push(child);
            else // Child doesn't contain tables - process as regular content
            children.push(child);
        });
        if (children.length === 0) return;
        let pageNumber = 1;
        let currentPageHeight = 0;
        let contentContainer = null;
        // Track which tables have had their titles added (to prevent duplicates across pages)
        const tableTitlesAdded = new Set();
        // Helper function to create footer
        const createFooter = (pageNum)=>{
            const footer = document.createElement("div");
            footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
            footer.style.bottom = "10px";
            footer.style.left = "0";
            footer.style.right = "0";
            footer.style.padding = "0 0px";
            const footerLogo = document.createElement("img");
            footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
            footerLogo.alt = "miniicon";
            footerLogo.classList.add("h40px", "w40px", "tal");
            const trademark = document.createElement("p");
            trademark.innerText = `\xa9 Diligentsia Limited ${new Date().getFullYear()}`;
            trademark.classList.add("tac", "c37", "fs12px", "fw400");
            const pageNumberElem = document.createElement("h3");
            pageNumberElem.innerText = "Page " + pageNum;
            pageNumberElem.classList.add("fw600", "c36", "fs14px");
            footer.appendChild(footerLogo);
            footer.appendChild(trademark);
            footer.appendChild(pageNumberElem);
            return footer;
        };
        // Helper function to create a new page
        const createPage = (isFirstPage = false)=>{
            const page = document.createElement("div");
            page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "px3rem", "shadow", "new-report", "insurance-gap-report");
            // Add watermark
            const watermark = document.createElement("img");
            watermark.classList.add("op20", "pa");
            watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
            watermark.style.top = "50%";
            watermark.style.left = "50%";
            watermark.style.width = "297mm";
            watermark.style.zIndex = "0";
            page.appendChild(watermark);
            // Create content container
            const content = document.createElement("div");
            content.style.position = "relative";
            content.style.zIndex = "1";
            content.style.paddingBottom = FOOTER_HEIGHT + SAFETY_BUFFER + "px"; // Extra padding to prevent footer overlap
            content.style.width = "100%";
            content.style.maxWidth = "100%";
            content.style.boxSizing = "border-box";
            content.style.overflow = "hidden";
            content.style.height = "100%";
            // Add header for all pages
            titleHeading(content, isFirstPage);
            page.appendChild(content);
            // Add footer
            const footer = createFooter(pageNumber);
            page.appendChild(footer);
            wrapper.appendChild(page);
            pageNumber++;
            // Measure actual rendered header height now that the page is in the DOM.
            // This is more accurate than hardcoded constants and handles different report types / content lengths.
            page.offsetHeight; // force reflow
            const headerEl = content.firstElementChild;
            currentPageHeight = headerEl ? getHeight(headerEl) : isFirstPage ? FIRST_PAGE_HEADER_HEIGHT : HEADER_HEIGHT;
            return {
                page: page,
                content: content
            };
        };
        // Helper function to check if element fits on current page
        // Use conservative check with buffer to prevent overflow
        const fitsOnPage = (elementHeight, buffer = 5)=>{
            const fits = currentPageHeight + elementHeight + buffer < AVAILABLE_HEIGHT;
            return fits;
        };
        // Helper function to split large content elements
        const splitLargeElement = (element)=>{
            const elementHeight = getHeight(element);
            // If element fits on page, just add it (with buffer for safety)
            if (fitsOnPage(elementHeight, 10)) {
                contentContainer.appendChild(element.cloneNode(true));
                currentPageHeight += elementHeight;
                return;
            }
            // For divs with multiple children, try to split by children
            if (element.tagName === 'DIV' && element.children.length > 0) {
                const children = Array.from(element.children);
                const wrapper = element.cloneNode(false);
                children.forEach((child)=>{
                    const childHeight = getHeight(child);
                    if (!fitsOnPage(childHeight, 10)) {
                        // Add current wrapper if it has content
                        if (wrapper.children.length > 0) contentContainer.appendChild(wrapper);
                        // Create new page
                        const newPage = createPage();
                        contentContainer = newPage.content;
                        // Create new wrapper
                        wrapper.innerHTML = '';
                    }
                    wrapper.appendChild(child.cloneNode(true));
                    currentPageHeight += childHeight;
                });
                // Add remaining wrapper
                if (wrapper.children.length > 0) contentContainer.appendChild(wrapper);
            } else {
                // For other elements or single large elements, add to new page
                if (currentPageHeight > 0) {
                    const newPage = createPage();
                    contentContainer = newPage.content;
                }
                contentContainer.appendChild(element.cloneNode(true));
                currentPageHeight += elementHeight;
            }
        };
        // Helper function to clone table with all styles and structure preserved (without thead/tbody)
        const cloneTableStructure = (originalTable)=>{
            const cloned = originalTable.cloneNode(false);
            // Copy all attributes (id, class, data-*, style, width, border, cellspacing, cellpadding, etc.)
            Array.from(originalTable.attributes).forEach((attr)=>{
                cloned.setAttribute(attr.name, attr.value);
            });
            // Copy inline styles explicitly - this preserves width, borders, padding, etc.
            if (originalTable.style && originalTable.style.cssText) cloned.style.cssText = originalTable.style.cssText;
            // Ensure table doesn't overflow page width - constrain to content area
            // Content area is 210mm (A4 width) minus padding (3rem on each side = 6rem total)
            // 3rem ≈ 48px, so 6rem ≈ 96px
            // Available width = 794px - 96px = 698px
            cloned.style.maxWidth = '100%';
            cloned.style.width = '100%';
            cloned.style.boxSizing = 'border-box';
            // Use 'auto' layout to allow all columns to render properly
            // Fixed layout might hide columns if colgroup is incorrect
            cloned.style.tableLayout = 'auto'; // Allow table to adjust column widths automatically
            // Also copy common style properties that might affect layout
            if (originalTable.style.borderCollapse) cloned.style.borderCollapse = originalTable.style.borderCollapse;
            if (originalTable.style.tableLayout && originalTable.style.tableLayout !== 'auto') // Only override if original was 'fixed' - but we'll use 'auto' for better column rendering
            cloned.style.tableLayout = 'auto';
            // Preserve colgroup and col elements (critical for column widths)
            // But do NOT copy thead or tbody - we'll add those separately to avoid duplication
            const colgroup = originalTable.querySelector('colgroup');
            if (colgroup) {
                // Deep clone colgroup to preserve all col elements and their attributes
                const clonedColgroup = colgroup.cloneNode(true);
                cloned.appendChild(clonedColgroup);
                // Verify all col elements are preserved
                const originalCols = colgroup.querySelectorAll('col');
                const clonedCols = clonedColgroup.querySelectorAll('col');
                if (originalCols.length !== clonedCols.length) console.warn(`Colgroup clone mismatch: original=${originalCols.length}, cloned=${clonedCols.length}`);
            }
            return cloned;
        };
        // Helper function to apply table wrapper styling (for individual table container)
        // Each table gets its own wrapper with border - no grouping of multiple tables
        const applyTableWrapperStyles = (wrapper)=>{
            if (!wrapper) return;
            // Apply border with 20px radius and #C9C9C9 color - this is for ONE table only
            wrapper.style.border = '1px solid #C9C9C9';
            wrapper.style.borderRadius = '20px';
            wrapper.style.overflow = 'hidden';
            wrapper.style.width = '100%';
            wrapper.style.maxWidth = '100%';
            wrapper.style.boxSizing = 'border-box';
            wrapper.style.marginBottom = '2rem'; // Add spacing between tables
            wrapper.style.padding = '0'; // No padding on wrapper - padding will be on inner content
            // Ensure table inside doesn't exceed wrapper width and A4 constraints
            const table = wrapper.querySelector('table');
            if (table) {
                // Critical: Ensure table never overflows A4 width (210mm = 794px at 96 DPI)
                // Account for page padding (3rem = 48px on each side = 96px total)
                // Available width = 794px - 96px = 698px
                table.style.maxWidth = '100%';
                table.style.width = '100%';
                table.style.boxSizing = 'border-box';
                table.style.tableLayout = 'auto'; // Allow flexible column widths
                // Prevent table from exceeding container
                table.style.overflow = 'hidden';
                table.style.wordWrap = 'break-word';
                table.style.overflowWrap = 'break-word';
            }
        };
        // Helper function to apply c15 class to title headings and subheadings
        const applyTitleStyles = (titleElement)=>{
            if (!titleElement) return;
            // Apply c15 class to all headings and text elements in the title
            const headings = titleElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
            headings.forEach((heading)=>{
                if (!heading.classList.contains('c15')) heading.classList.add('c15');
            });
            // Also check if the title element itself is a heading
            if (titleElement.tagName.match(/^H[1-6]$/)) {
                if (!titleElement.classList.contains('c15')) titleElement.classList.add('c15');
            }
            // Apply to any text elements that might be subtitles
            const textElements = titleElement.querySelectorAll('p, span, div');
            textElements.forEach((el)=>{
                // Only apply if it's likely a subtitle (short text, not too long)
                if (el.textContent.trim().length < 200 && el.textContent.trim().length > 0) {
                    if (!el.classList.contains('c15')) el.classList.add('c15');
                }
            });
        };
        const createTitleElement = (headingText, subheadingText)=>{
            if (!headingText && !subheadingText) return null;
            const container = document.createElement('div');
            container.style.marginBottom = '1.5rem';
            if (headingText) {
                const heading = document.createElement('h2');
                heading.textContent = headingText;
                container.appendChild(heading);
            }
            if (subheadingText) {
                const subtitle = document.createElement('p');
                subtitle.textContent = subheadingText;
                container.appendChild(subtitle);
            }
            return container;
        };
        const inferTitleFromTableStructure = (table)=>{
            if (!table) return null;
            // First, try to identify by table position (if it's the third table, it's likely Technical Policy Schedule)
            const allTables = pdfContent ? Array.from(pdfContent.querySelectorAll('table')) : [];
            const tableIndex = allTables.indexOf(table);
            // Try to identify by header columns first
            const headerCells = table.querySelectorAll('thead th');
            let headerTexts = Array.from(headerCells).map((cell)=>cell.textContent.trim().toLowerCase());
            if (headerTexts.length === 0) {
                const firstRow = table.querySelector('tr');
                if (firstRow) headerTexts = Array.from(firstRow.querySelectorAll('th, td')).map((cell)=>cell.textContent.trim().toLowerCase());
            }
            // Function to check if keywords match (more flexible matching)
            const containsKeywords = (keywords, requireAll = false)=>{
                if (requireAll) return keywords.every((keyword)=>headerTexts.some((text)=>text.includes(keyword)));
                else // Check if any keyword matches
                return keywords.some((keyword)=>headerTexts.some((text)=>text.includes(keyword)));
            };
            // Technical Policy Schedule: has Basis, Limit, Deductible, Territory columns
            // More flexible matching - check for key terms
            if (headerTexts.length > 0) {
                const hasTechnicalColumns = containsKeywords([
                    'basis'
                ], true) && (containsKeywords([
                    'limit'
                ], true) || containsKeywords([
                    'lim'
                ], true)) && (containsKeywords([
                    'deductible'
                ], true) || containsKeywords([
                    'excess'
                ], true)) && (containsKeywords([
                    'territory'
                ], true) || containsKeywords([
                    'geographic'
                ], true));
                if (hasTechnicalColumns) return createTitleElement('Technical Policy Schedule', 'Detailed coverage specifications');
                // Policy Schedule: has Insurer, Premium, Status columns
                const hasPolicyColumns = containsKeywords([
                    'insurer'
                ], true) && (containsKeywords([
                    'premium'
                ], true) || containsKeywords([
                    'prem'
                ], true)) && containsKeywords([
                    'status'
                ], true);
                if (hasPolicyColumns) return createTitleElement('Policy Schedule', 'Current insurance cover');
                // Gap Analysis: has gap-related keywords
                if (containsKeywords([
                    'gap'
                ], false) || containsKeywords([
                    'potential',
                    'improvement'
                ], false)) return createTitleElement('Gap Analysis', 'Potential policy improvements identified through risk assessment');
            }
            // Fallback: Use table position to infer title
            // First table (index 0) = Gap Analysis
            // Second table (index 1) = Policy Schedule  
            // Third table (index 2) = Technical Policy Schedule
            if (tableIndex === 0) return createTitleElement('Gap Analysis', 'Potential policy improvements identified through risk assessment');
            else if (tableIndex === 1) return createTitleElement('Policy Schedule', 'Current insurance cover');
            else if (tableIndex === 2) return createTitleElement('Technical Policy Schedule', 'Detailed coverage specifications');
            return null;
        };
        // Helper function to ensure header row has correct styling
        const applyTableHeaderStyles = (thead)=>{
            if (!thead) return;
            // Apply background color #F0F2FD to header row
            const headerRows = thead.querySelectorAll('tr');
            headerRows.forEach((row)=>{
                row.style.backgroundColor = '#F0F2FD';
                // Ensure header cells use c15 class
                const headerCells = row.querySelectorAll('th');
                headerCells.forEach((cell)=>{
                    if (!cell.classList.contains('c15')) cell.classList.add('c15');
                });
            });
        };
        // Helper function to find table title and summary-container from the table's context
        const findTableTitleAndSummary = (table)=>{
            // Check parent and siblings for title (could be a heading with subtitle)
            let current = table.parentElement;
            let titleElement = null;
            let summaryContainer = null;
            let titleContainer = null;
            // Common table title patterns to look for
            const titlePatterns = [
                /Gap Analysis/i,
                /Policy Schedule/i,
                /Technical Policy Schedule/i,
                /Policy.*Schedule/i,
                /Coverage.*Specification/i,
                /Detailed coverage specifications/i
            ];
            // Function to check a container for title elements and summary-container
            const findTitleAndSummaryInContainer = (container, tableRef)=>{
                if (!container) return {
                    title: null,
                    summary: null
                };
                const tableIndex = Array.from(container.children).indexOf(tableRef);
                if (tableIndex > 0) {
                    // Check if there's a heading followed by a subtitle/description and summary-container
                    // Look back up to 10 elements to find title, summary-container, etc.
                    let previousIdx = tableIndex - 1;
                    let titleElements = [];
                    let summaryElements = [];
                    let foundTitleContent = false;
                    let foundSummaryContent = false;
                    // Look for heading elements (H1-H6) or divs containing headings, and summary-containers
                    while(previousIdx >= 0 && previousIdx >= tableIndex - 10){
                        const sibling = container.children[previousIdx];
                        if (sibling) {
                            const siblingText = sibling.textContent.trim();
                            const isHeading = sibling.tagName.match(/^H[1-6]$/);
                            const hasHeading = sibling.querySelector('h1, h2, h3, h4, h5, h6');
                            const hasText = siblingText !== '';
                            // Check if this is a summary-container
                            const isSummaryContainer = sibling.classList.contains('summary-container') || sibling.querySelector('.summary-container') || sibling.tagName === 'DIV' && sibling.querySelector('.summary-box');
                            // Check if this element contains title-like text
                            const containsTitleText = titlePatterns.some((pattern)=>pattern.test(siblingText));
                            // Check if element is likely a title element
                            const isLikelyTitle = isHeading || hasHeading || sibling.classList.contains('table-title') || containsTitleText || hasText && siblingText.length < 400 && siblingText.length > 0 && !isSummaryContainer;
                            // If it's a table, stop looking (we've gone too far)
                            if (sibling.tagName === 'TABLE') break;
                            if (isSummaryContainer) {
                                // Found summary-container - add it to summary elements
                                summaryElements.unshift(sibling);
                                foundSummaryContent = true;
                            } else if (isLikelyTitle) {
                                titleElements.unshift(sibling);
                                foundTitleContent = true;
                            } else if ((foundTitleContent || foundSummaryContent) && siblingText.length === 0) {
                                // Skip empty elements if we've already found content
                                previousIdx--;
                                continue;
                            } else if (foundTitleContent && foundSummaryContent) break;
                            else if (foundTitleContent && !foundSummaryContent) {
                                // Found title but not summary yet, continue looking
                                previousIdx--;
                                continue;
                            } else {
                                // Haven't found title yet, continue looking
                                previousIdx--;
                                continue;
                            }
                        }
                        previousIdx--;
                    }
                    // Build result object with title and summary
                    let result = {
                        title: null,
                        summary: null
                    };
                    // Process title elements
                    if (titleElements.length > 0) {
                        if (titleElements.length > 1) {
                            const titleContainer = document.createElement('div');
                            titleContainer.style.marginBottom = '1.5rem';
                            titleElements.forEach((el)=>{
                                titleContainer.appendChild(el.cloneNode(true));
                            });
                            result.title = titleContainer;
                        } else {
                            const singleEl = titleElements[0];
                            if (singleEl.querySelector('h1, h2, h3, h4, h5, h6') && (singleEl.querySelector('p') || singleEl.textContent.includes('\n'))) result.title = singleEl;
                            else {
                                const prevSibling = singleEl.previousElementSibling;
                                if (prevSibling && prevSibling.textContent.trim().length < 300 && !prevSibling.querySelector('table') && !prevSibling.classList.contains('summary-container')) {
                                    const titleContainer = document.createElement('div');
                                    titleContainer.style.marginBottom = '1.5rem';
                                    titleContainer.appendChild(prevSibling.cloneNode(true));
                                    titleContainer.appendChild(singleEl.cloneNode(true));
                                    result.title = titleContainer;
                                } else result.title = singleEl;
                            }
                        }
                    }
                    // Process summary elements
                    if (summaryElements.length > 0) {
                        if (summaryElements.length > 1) {
                            const summaryWrapper = document.createElement('div');
                            summaryWrapper.style.marginBottom = '1.5rem';
                            summaryElements.forEach((el)=>{
                                summaryWrapper.appendChild(el.cloneNode(true));
                            });
                            result.summary = summaryWrapper;
                        } else result.summary = summaryElements[0];
                    }
                    return result;
                }
                return {
                    title: null,
                    summary: null
                };
            };
            // First, try finding in direct parent
            let result = findTitleAndSummaryInContainer(current, table);
            titleElement = result.title;
            summaryContainer = result.summary;
            // If not found, try parent's parent (in case table is nested in a wrapper)
            if (!titleElement && !summaryContainer && current && current.parentElement) {
                result = findTitleAndSummaryInContainer(current.parentElement, current);
                if (!titleElement) titleElement = result.title;
                if (!summaryContainer) summaryContainer = result.summary;
            }
            // If still not found, try finding in pdfContent directly
            // Check all children of pdfContent to find the container that has our table
            if (!titleElement && !summaryContainer && pdfContent) // Find which child of pdfContent contains this table
            for(let i = 0; i < pdfContent.children.length; i++){
                const child = pdfContent.children[i];
                if (child.contains(table) || child === table) {
                    // Found the container/wrapper that has our table
                    // Check previous siblings of this container
                    if (i > 0) {
                        const titleElements = [];
                        const summaryElements = [];
                        for(let j = i - 1; j >= Math.max(0, i - 10); j--){
                            const sibling = pdfContent.children[j];
                            if (sibling) {
                                const text = sibling.textContent.trim();
                                const hasTitlePattern = titlePatterns.some((pattern)=>pattern.test(text));
                                const hasHeading = sibling.tagName.match(/^H[1-6]$/) || sibling.querySelector('h1, h2, h3, h4, h5, h6');
                                const isSummaryContainer = sibling.classList.contains('summary-container') || sibling.querySelector('.summary-container') || sibling.tagName === 'DIV' && sibling.querySelector('.summary-box');
                                // If it's another table, stop looking
                                if (sibling.tagName === 'TABLE' || sibling.querySelector('table')) break;
                                // Check if this could be a title element or summary-container
                                if (isSummaryContainer) summaryElements.unshift(sibling);
                                else if (hasTitlePattern || hasHeading || text.length < 400 && text.length > 0) titleElements.unshift(sibling);
                                else if (titleElements.length > 0 || summaryElements.length > 0) break;
                            }
                        }
                        // Process title elements
                        if (titleElements.length > 0 && !titleElement) {
                            if (titleElements.length > 1) {
                                titleContainer = document.createElement('div');
                                titleContainer.style.marginBottom = '1.5rem';
                                titleElements.forEach((el)=>{
                                    titleContainer.appendChild(el.cloneNode(true));
                                });
                                titleElement = titleContainer;
                            } else titleElement = titleElements[0];
                        }
                        // Process summary elements
                        if (summaryElements.length > 0 && !summaryContainer) {
                            if (summaryElements.length > 1) {
                                const summaryWrapper = document.createElement('div');
                                summaryWrapper.style.marginBottom = '1.5rem';
                                summaryElements.forEach((el)=>{
                                    summaryWrapper.appendChild(el.cloneNode(true));
                                });
                                summaryContainer = summaryWrapper;
                            } else summaryContainer = summaryElements[0];
                        }
                        if (titleElement || summaryContainer) break; // Found elements, stop searching
                    }
                    break; // Found table container, stop searching
                }
            }
            // If no title found, infer from table structure
            if (!titleElement) titleElement = inferTitleFromTableStructure(table);
            // Return both title and summary-container
            return {
                title: titleElement,
                summary: summaryContainer
            };
        };
        // Helper function to find table title (backward compatibility)
        const findTableTitle = (table)=>{
            const result = findTableTitleAndSummary(table);
            return result.title;
        };
        // Helper function to get a unique identifier for a table
        const getTableId = (table)=>{
            // Use table's position in the document or a unique attribute
            const tableIndex = Array.from(pdfContent.querySelectorAll('table')).indexOf(table);
            const tableParent = table.parentElement;
            const parentIndex = tableParent ? Array.from(pdfContent.children).indexOf(tableParent) : -1;
            return `table-${parentIndex}-${tableIndex}`;
        };
        // Compute optimal column width percentages for multi-column tables.
        // With table-layout:auto the browser squishes Description/long-text columns, causing rows to be
        // very tall and wasting most of each page. Forcing explicit percentages keeps rows short and dense.
        const computeOptimalColumnWidths = (sourceTable)=>{
            const thead = sourceTable.querySelector('thead');
            if (!thead) return null;
            const headerRow = thead.querySelector('tr');
            if (!headerRow) return null;
            const headers = Array.from(headerRow.querySelectorAll('th, td')).map((th)=>th.textContent.trim().toLowerCase());
            const n = headers.length;
            if (n < 4) return null; // simple tables need no intervention
            // narrow = pure short identifiers (Ref, Status, #)
            const isNarrow = (h)=>/^(ref|no\.|#|id|num|code|status|flag|tier|grade|rank)$/.test(h);
            // date = columns with actual date values (matched by word "date")
            const isDate = (h)=>/\bdate\b/.test(h);
            // desc = primary long-content column — clearly named description/detail column, OR
            // a column whose header text strongly implies long narrative content
            const isPrimaryDesc = (h)=>/^(description|detail|details|notes?)$/.test(h) || /^description[\s/]/.test(h) || /(concentration\s+risk|risk\s+assessment|narrative|summary|comments?)$/.test(h);
            const cats = headers.map((h)=>isNarrow(h) ? 'narrow' : isDate(h) ? 'date' : isPrimaryDesc(h) ? 'desc' : 'medium');
            const narrowCount = cats.filter((c)=>c === 'narrow').length;
            const dateCount = cats.filter((c)=>c === 'date').length;
            const descCount = cats.filter((c)=>c === 'desc').length;
            const mediumCount = cats.filter((c)=>c === 'medium').length;
            const NARROW_W = 6; // identifiers need very little space
            const DATE_W = 8; // date strings are short
            const fixedTotal = narrowCount * NARROW_W + dateCount * DATE_W;
            const freeSpace = 100 - fixedTotal;
            let descW = 0, mediumW = 0;
            if (descCount > 0 && mediumCount > 0) {
                // Desc gets 50% of free space; medium cols share remaining 50%
                const descTotal = Math.floor(freeSpace * 0.50);
                const mediumTotal = freeSpace - descTotal;
                descW = Math.floor(descTotal / descCount);
                mediumW = Math.floor(mediumTotal / mediumCount);
            } else if (descCount > 0) descW = Math.floor(freeSpace / descCount);
            else // No primary description column — equal distribution among medium cols
            mediumW = mediumCount > 0 ? Math.floor(freeSpace / mediumCount) : 0;
            const widths = cats.map((c)=>c === 'narrow' ? NARROW_W : c === 'date' ? DATE_W : c === 'desc' ? descW : mediumW);
            const total = widths.reduce((s, w)=>s + w, 0);
            const remainder = 100 - total;
            if (remainder !== 0) {
                // Give leftover to the widest-category column (desc first, then medium)
                const adjIdx = cats.indexOf('desc') >= 0 ? cats.indexOf('desc') : cats.indexOf('medium') >= 0 ? cats.indexOf('medium') : 0;
                widths[adjIdx] += remainder;
            }
            return widths;
        };
        // Apply explicit column widths via colgroup + table-layout:fixed so rows render at measured widths.
        const applyColumnWidths = (tableEl, widths)=>{
            if (!widths) return;
            tableEl.style.tableLayout = 'fixed';
            tableEl.style.width = '100%';
            const existing = tableEl.querySelector('colgroup');
            if (existing) tableEl.removeChild(existing);
            const colgroup = document.createElement('colgroup');
            widths.forEach((w)=>{
                const col = document.createElement('col');
                col.style.width = w + '%';
                colgroup.appendChild(col);
            });
            tableEl.insertBefore(colgroup, tableEl.firstChild);
        };
        // Helper function to process table elements
        const processTable = (table)=>{
            // Get both title and summary-container
            let { title: tableTitle, summary: tableSummary } = findTableTitleAndSummary(table);
            if (!tableTitle) tableTitle = inferTitleFromTableStructure(table);
            const tableId = getTableId(table);
            // Compute optimal column widths once per table — applied to every clone so measurement
            // and final rendering use the same fixed widths, eliminating auto-layout surprises.
            const columnWidths = computeOptimalColumnWidths(table);
            // Create a temporary container to measure table elements accurately.
            // Rows must be measured at the width they will actually occupy on the page, NOT at the
            // pdfContent width (794px). On the page: A4(794) - px3rem padding(96) - wrapper border(2) - inner padding(16) = 680px.
            const TABLE_RENDER_WIDTH = A4_WIDTH_PX - 96 - 2 - 16; // 680px
            const tempContainer = document.createElement('div');
            tempContainer.style.position = 'absolute';
            tempContainer.style.left = '-9999px';
            tempContainer.style.top = '0';
            tempContainer.style.width = TABLE_RENDER_WIDTH + 'px';
            tempContainer.style.padding = '0';
            tempContainer.style.margin = '0';
            wrapper.appendChild(tempContainer);
            // Clone the table to preserve structure; apply column widths so measurements reflect actual rendering
            const originalTable = table.cloneNode(true);
            applyColumnWidths(originalTable, columnWidths);
            tempContainer.appendChild(originalTable);
            // Get only data rows from tbody elements (exclude thead rows)
            const thead = originalTable.querySelector('thead');
            const tbodyElements = originalTable.querySelectorAll('tbody');
            const rows = [];
            tbodyElements.forEach((tbody)=>{
                Array.from(tbody.querySelectorAll('tr')).forEach((tr)=>{
                    // Store reference to row - it will be cloned later with all its cells intact
                    // Verify row has cells before adding
                    const cells = tr.querySelectorAll('td, th');
                    if (cells.length === 0) console.warn('Found row with no cells:', tr);
                    else rows.push(tr);
                });
            });
            // If no tbody exists, get all rows but exclude those in thead
            if (rows.length === 0) {
                const allRows = Array.from(originalTable.querySelectorAll('tr'));
                allRows.forEach((tr)=>{
                    // Only include rows that are NOT inside a thead
                    if (!thead || !thead.contains(tr)) rows.push(tr);
                });
            }
            // Verify all rows have the same number of cells (to detect missing columns)
            if (rows.length > 0 && thead) {
                // Get expected cell count from header
                const headerRow = thead.querySelector('tr');
                const expectedCellCount = headerRow ? headerRow.querySelectorAll('th, td').length : 0;
                // Check first few rows to verify column count
                rows.slice(0, 3).forEach((row, idx)=>{
                    const cellCount = row.querySelectorAll('td, th').length;
                    if (cellCount !== expectedCellCount && expectedCellCount > 0) // If cells are missing, check if they're empty or actually missing
                    {
                        if (cellCount < expectedCellCount) console.error(`Row ${idx} is MISSING ${expectedCellCount - cellCount} cells!`);
                    }
                });
            }
            let tableHeader = null;
            let tableHeaderHeight = 0;
            // Extract and measure header if exists
            if (thead) {
                tableHeader = thead.cloneNode(true);
                // Verify all header cells are preserved
                const headerRows = tableHeader.querySelectorAll('tr');
                headerRows.forEach((headerRow, idx)=>{
                    const headerCells = headerRow.querySelectorAll('th, td');
                });
                // Apply header styling before measuring
                applyTableHeaderStyles(tableHeader);
                const tempHeaderTable = cloneTableStructure(table);
                applyColumnWidths(tempHeaderTable, columnWidths);
                tempHeaderTable.appendChild(tableHeader);
                tempContainer.appendChild(tempHeaderTable);
                // Force a reflow to get accurate height
                tempHeaderTable.offsetHeight;
                tableHeaderHeight = getHeight(tempHeaderTable);
                tempContainer.removeChild(tempHeaderTable);
            }
            // Measure each row height accurately (only data rows, not header rows)
            // IMPORTANT: Measure rows incrementally to get accurate heights that account for table layout
            // When rows are measured together, column widths distribute more accurately
            const rowHeights = [];
            // Create a measurement table with header for accurate column width distribution
            const measurementTable = cloneTableStructure(table);
            applyColumnWidths(measurementTable, columnWidths);
            if (thead) {
                const tempHeader = thead.cloneNode(true);
                applyTableHeaderStyles(tempHeader);
                measurementTable.appendChild(tempHeader);
            }
            const measurementTbody = document.createElement('tbody');
            measurementTable.appendChild(measurementTbody);
            tempContainer.appendChild(measurementTable);
            // Measure rows incrementally - add one row at a time and measure the difference
            let previousTableHeight = getHeight(measurementTable);
            rows.forEach((row, rowIdx)=>{
                const rowClone = row.cloneNode(true);
                measurementTbody.appendChild(rowClone);
                // Force reflow to get accurate measurement
                measurementTable.offsetHeight;
                const newTableHeight = getHeight(measurementTable);
                const rowHeight = newTableHeight - previousTableHeight;
                // Store the incremental height (what this row adds to the table)
                rowHeights.push(Math.max(rowHeight, 0)); // Ensure non-negative
                previousTableHeight = newTableHeight;
            });
            // Clean up measurement table
            tempContainer.removeChild(measurementTable);
            // Clean up temp container
            wrapper.removeChild(tempContainer);
            // Now process rows for pagination - append tables incrementally for accurate measurement
            let currentTable = cloneTableStructure(table);
            applyColumnWidths(currentTable, columnWidths);
            let tbody = document.createElement('tbody');
            let hasRowsInCurrentTable = false;
            let currentTableHeight = 0;
            // Add header to first table if it exists
            if (tableHeader) {
                const clonedHeader = tableHeader.cloneNode(true);
                applyTableHeaderStyles(clonedHeader);
                currentTable.appendChild(clonedHeader);
                hasRowsInCurrentTable = true;
                currentTableHeight = tableHeaderHeight;
            // Note: We don't add table header to currentPageHeight here because
            // currentTableHeight already accounts for it, and we'll add it when we append the table
            }
            // Track if we've already rendered the title and summary for this table
            let titleRendered = tableTitlesAdded.has(tableId);
            let summaryRendered = false;
            // Helper to measure title height if needed
            const measureTitleHeight = ()=>{
                if (!tableTitle || titleRendered) return 0;
                // Create a temporary title element to measure
                const tempTitle = tableTitle.cloneNode(true);
                tempTitle.style.position = 'absolute';
                tempTitle.style.left = '-9999px';
                tempTitle.style.top = '0';
                tempTitle.style.visibility = 'hidden';
                tempTitle.style.width = A4_WIDTH_PX - 96 + 'px'; // Account for page padding (3rem each side = 48px * 2 = 96px)
                contentContainer.appendChild(tempTitle);
                const titleHeight = getHeight(tempTitle) + 16; // Add margin-bottom (1rem = 16px)
                contentContainer.removeChild(tempTitle);
                return titleHeight;
            };
            // Pre-calculate wrapper overhead values (fixed for all segments)
            const wrapperPadding = 16; // 0.5rem top + 0.5rem bottom = 16px
            const wrapperBorder = 2; // 1px top + 1px bottom = 2px
            const wrapperMargin = 32; // 2rem margin bottom = 32px
            const wrapperOverheadBuffer = 5; // Small buffer for spacing variations and border radius
            const baseWrapperOverhead = wrapperPadding + wrapperBorder + wrapperMargin + wrapperOverheadBuffer;
            const titleHeight = measureTitleHeight();
            const firstTableWrapperOverhead = baseWrapperOverhead + titleHeight;
            // Process each row - check if it fits BEFORE adding it
            rows.forEach((row, index)=>{
                const rowHeight = rowHeights[index];
                // Calculate what the height would be if we add this row
                const currentTableHeightWithNewRow = currentTableHeight + rowHeight;
                // ALWAYS include wrapper overhead in the estimate. The wrapper border + padding + margin (55px)
                // is incurred every time the table segment is committed, regardless of how many rows it contains.
                // Using titleRendered to decide whether to include the title height in the overhead:
                // before the title is rendered (first segment of a first-time table) it costs more overhead.
                const currentWrapperOverhead = titleRendered ? baseWrapperOverhead : firstTableWrapperOverhead;
                // Calculate total height if we add this row
                const rowSafetyBuffer = 10;
                const estimatedHeightIfAdded = currentPageHeight + currentTableHeightWithNewRow + currentWrapperOverhead + rowSafetyBuffer;
                // If this would exceed available height, save current table and start new page
                // Use strict comparison (>) to be more conservative and prevent overflow
                // Only break if we have rows in current table (don't break on empty table)
                if (estimatedHeightIfAdded > AVAILABLE_HEIGHT && hasRowsInCurrentTable && tbody.children.length > 0) {
                    // Save current table segment
                    currentTable.appendChild(tbody);
                    // Create wrapper for THIS table only - each table gets its own border
                    const tableWrapper = document.createElement('div');
                    applyTableWrapperStyles(tableWrapper);
                    // Create inner content container for proper spacing
                    const tableContentWrapper = document.createElement('div');
                    tableContentWrapper.style.padding = '0.5rem';
                    tableContentWrapper.style.width = '100%';
                    tableContentWrapper.style.boxSizing = 'border-box';
                    if (tableTitle && !titleRendered) {
                        const titleClone = tableTitle.cloneNode(true);
                        titleClone.setAttribute('data-table-title', tableId);
                        titleClone.style.marginBottom = '1rem';
                        titleClone.style.paddingLeft = '0';
                        titleClone.style.paddingTop = '0';
                        // Apply c15 class to title elements
                        applyTitleStyles(titleClone);
                        tableContentWrapper.appendChild(titleClone);
                        tableTitlesAdded.add(tableId);
                        titleRendered = true;
                    }
                    // Add table to content wrapper
                    tableContentWrapper.appendChild(currentTable);
                    // Add content wrapper to table wrapper (which has the border)
                    tableWrapper.appendChild(tableContentWrapper);
                    contentContainer.appendChild(tableWrapper);
                    // CRITICAL: Measure ACTUAL rendered height instead of using estimate
                    // Add small buffer to account for any rounding or measurement variations
                    const actualWrapperHeight = getHeight(tableWrapper) + 2; // Small buffer for safety
                    currentPageHeight += actualWrapperHeight;
                    // Create new page
                    const newPage = createPage();
                    contentContainer = newPage.content;
                    // Start new table with header - preserve all styles and structure
                    // IMPORTANT: Do NOT add title on continuation pages
                    currentTable = cloneTableStructure(table);
                    applyColumnWidths(currentTable, columnWidths);
                    tbody = document.createElement('tbody');
                    hasRowsInCurrentTable = false;
                    currentTableHeight = 0;
                    // Add header to new table (but NOT the title - title only on first page)
                    if (tableHeader) {
                        // Deep clone the header to preserve ALL header cells
                        const clonedHeader = tableHeader.cloneNode(true);
                        // Verify header cells are preserved
                        const headerCells = clonedHeader.querySelectorAll('th, td');
                        applyTableHeaderStyles(clonedHeader);
                        currentTable.appendChild(clonedHeader);
                        currentTableHeight = tableHeaderHeight;
                        hasRowsInCurrentTable = true;
                    // Note: currentPageHeight is already set correctly by createPage()
                    // Header height is included in currentTableHeight and will be part of wrapper measurement
                    }
                }
                // Add row to current table (this will always fit because we checked above)
                // Clone row with deep=true to preserve all cells and their content, attributes, and styles
                const clonedRow = row.cloneNode(true);
                // Ensure all cells are preserved - verify column count matches header
                const originalCells = row.querySelectorAll('td, th');
                const clonedCells = clonedRow.querySelectorAll('td, th');
                const headerCellCount = tableHeader ? tableHeader.querySelector('tr')?.querySelectorAll('th, td').length : 0;
                if (originalCells.length !== clonedCells.length) console.error(`Row ${index} cell count mismatch after clone: original=${originalCells.length}, cloned=${clonedCells.length}`);
                // Verify all cell attributes are preserved (colspan, rowspan, width, styles, classes)
                originalCells.forEach((originalCell, cellIdx)=>{
                    const clonedCell = clonedCells[cellIdx];
                    if (clonedCell) {
                        // Verify colspan and rowspan are preserved
                        if (originalCell.hasAttribute('colspan') && !clonedCell.hasAttribute('colspan')) clonedCell.setAttribute('colspan', originalCell.getAttribute('colspan'));
                        if (originalCell.hasAttribute('rowspan') && !clonedCell.hasAttribute('rowspan')) clonedCell.setAttribute('rowspan', originalCell.getAttribute('rowspan'));
                        // Verify cell content is preserved
                        if (originalCell.textContent.trim() !== clonedCell.textContent.trim()) console.warn(`Row ${index}, Cell ${cellIdx}: content may differ (original="${originalCell.textContent.trim().substring(0, 20)}", cloned="${clonedCell.textContent.trim().substring(0, 20)}")`);
                    }
                });
                if (headerCellCount > 0 && clonedCells.length !== headerCellCount) console.error(`Row ${index} has ${clonedCells.length} cells but header has ${headerCellCount} cells!`);
                // Verify cells have content (some might be empty but should still exist)
                clonedCells.forEach((cell, cellIdx)=>{
                    if (!cell) console.error(`Row ${index} is missing cell at index ${cellIdx}!`);
                });
                tbody.appendChild(clonedRow);
                currentTableHeight += rowHeight;
                hasRowsInCurrentTable = true;
            });
            // Append remaining table if it has rows
            if (hasRowsInCurrentTable && tbody.children.length > 0) {
                currentTable.appendChild(tbody);
                // Wrap table in a container with proper styling - each table gets its own border
                const tableWrapper = document.createElement('div');
                applyTableWrapperStyles(tableWrapper);
                // Create inner content container for proper spacing
                const tableContentWrapper = document.createElement('div');
                tableContentWrapper.style.padding = '0.5rem';
                tableContentWrapper.style.width = '100%';
                tableContentWrapper.style.boxSizing = 'border-box';
                // Add table title ONLY if it hasn't been added yet
                if (tableTitle && !titleRendered) {
                    const titleClone = tableTitle.cloneNode(true);
                    titleClone.setAttribute('data-table-title', tableId);
                    titleClone.style.marginBottom = '1rem';
                    titleClone.style.paddingLeft = '0';
                    titleClone.style.paddingTop = '0';
                    // Apply c15 class to title elements
                    applyTitleStyles(titleClone);
                    tableContentWrapper.appendChild(titleClone);
                    tableTitlesAdded.add(tableId);
                    titleRendered = true;
                }
                // Add table to content wrapper
                tableContentWrapper.appendChild(currentTable);
                // Add content wrapper to table wrapper (which has the border)
                tableWrapper.appendChild(tableContentWrapper);
                contentContainer.appendChild(tableWrapper);
                // CRITICAL: Measure ACTUAL rendered height instead of using estimate
                // Add small buffer to account for any rounding or measurement variations
                const actualWrapperHeight = getHeight(tableWrapper) + 2; // Small buffer for safety
                currentPageHeight += actualWrapperHeight;
            }
        };
        // Create first page
        const firstPage = createPage(true);
        contentContainer = firstPage.content;
        // Track processed tables to prevent duplicates
        const processedTableIds = new Set();
        // Helper function to get a unique identifier for a table element
        const getTableUniqueId = (table)=>{
            // Use table's content signature as unique ID
            const tableContent = table.outerHTML.replace(/\s+/g, ' ').trim();
            // Create a hash-like identifier from content
            let hash = 0;
            for(let i = 0; i < Math.min(tableContent.length, 100); i++){
                const char = tableContent.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32-bit integer
            }
            return `table-${Math.abs(hash)}`;
        };
        // Helper function to extract and process all tables from a container
        // Each table is processed individually with its own border wrapper
        const extractAndProcessTables = (container)=>{
            if (!container) return;
            // Find all tables in the container (both direct children and nested)
            const allTablesInContainer = container.querySelectorAll('table');
            if (allTablesInContainer.length === 0) return;
            // Process each table individually with its own border
            // The table's parent context is preserved for title/summary detection
            allTablesInContainer.forEach((table)=>{
                const tableId = getTableUniqueId(table);
                // Skip if this table was already processed
                if (processedTableIds.has(tableId)) {
                    console.warn(`Duplicate table detected and skipped: ${tableId}`);
                    return;
                }
                processedTableIds.add(tableId);
                // Process this table individually with its own border
                // The processTable function will find the title/summary from the table's context
                processTable(table);
            });
        };
        // Process all children
        children.forEach((child, index)=>{
            const childHeight = getHeight(child);
            const tableElement = child.tagName === 'TABLE' ? child : child.querySelector('table');
            if (tableElement) {
                // If child is a direct table, process it individually
                if (child.tagName === 'TABLE') {
                    const tableId = getTableUniqueId(child);
                    if (!processedTableIds.has(tableId)) {
                        processedTableIds.add(tableId);
                        processTable(child);
                    } else console.warn(`Duplicate direct table detected and skipped at index ${index}`);
                } else // Child contains table(s) - extract and process each table individually
                // Each table will get its own border wrapper
                // Do NOT clone the entire child as it might contain multiple tables
                extractAndProcessTables(child);
            } else if (childHeight > AVAILABLE_HEIGHT) // Handle very large elements that need splitting (non-table elements)
            splitLargeElement(child);
            else {
                // Regular element (no tables) - check if it fits on current page
                if (!fitsOnPage(childHeight, 10)) {
                    // Create new page
                    const newPage = createPage();
                    contentContainer = newPage.content;
                }
                contentContainer.appendChild(child.cloneNode(true));
                currentPageHeight += childHeight;
            }
        });
        // Clean up - ensure pdfContent is completely hidden after processing
        wrapper.classList.remove("op0", "pen");
        pdfContent.classList.remove("a4", "p3rem");
        // Ensure pdfContent is hidden and doesn't interfere with display
        pdfContent.style.display = 'none';
        pdfContent.style.visibility = 'hidden';
        pdfContent.style.position = 'absolute';
        pdfContent.style.left = '-9999px';
    }, [
        reportData
    ]);
    const titleHeading = (page, isFirstPage = false)=>{
        if (isFirstPage) {
            const headerWrapper = document.createElement("div");
            headerWrapper.style.display = "flex";
            headerWrapper.style.justifyContent = "space-between";
            headerWrapper.style.alignItems = "flex-start";
            headerWrapper.style.background = "#f5f7ff";
            headerWrapper.style.padding = "40px 48px";
            headerWrapper.style.borderRadius = "24px";
            headerWrapper.style.margin = "-32px -48px 24px -48px";
            headerWrapper.style.position = "relative";
            headerWrapper.style.overflow = "hidden";
            headerWrapper.style.border = "1px solid rgba(37, 99, 235, 0.12)";
            headerWrapper.style.boxShadow = "0 18px 45px rgba(79, 97, 190, 0.12)";
            headerWrapper.style.backgroundImage = `url(${$ebf2f600012585f0$exports})`;
            headerWrapper.style.backgroundRepeat = "no-repeat";
            headerWrapper.style.backgroundPosition = "calc(100% - 32px) center";
            headerWrapper.style.backgroundSize = "auto 105%";
            const headerLeft = document.createElement("div");
            headerLeft.style.display = "flex";
            headerLeft.style.flexDirection = "column";
            headerLeft.style.alignItems = "flex-start";
            headerLeft.style.gap = "2px";
            const reportTitle = document.createElement("h1");
            // Use dynamic report name from reportData, fallback to "Insurance Gap Analysis Report" for insurance reports
            const reportName = reportData?.name || (reportData?.reportType === 'insuranceGapAnalysis' ? 'Insurance Gap Analysis Report' : 'Section Report');
            reportTitle.textContent = reportName;
            reportTitle.style.fontSize = "1.8rem";
            reportTitle.style.fontWeight = "600";
            reportTitle.style.color = "#111827";
            reportTitle.style.margin = "0";
            reportTitle.style.width = "100%";
            const companyName = document.createElement("p");
            companyName.textContent = (company?.['cName'] || '').toUpperCase();
            companyName.style.fontSize = "1.5rem";
            companyName.style.fontStyle = "italic";
            companyName.style.fontWeight = "400";
            companyName.style.letterSpacing = "0.08em";
            companyName.style.color = "#4b5563";
            companyName.style.margin = "0";
            companyName.style.textAlign = "left";
            companyName.style.width = "100%";
            const metaContainer = document.createElement("div");
            metaContainer.style.marginTop = "12px";
            metaContainer.style.display = "flex";
            metaContainer.style.flexDirection = "column";
            metaContainer.style.alignItems = "flex-start";
            metaContainer.style.gap = "6px";
            const createdByLine = document.createElement("p");
            createdByLine.innerHTML = `Created by: <span style="font-weight:600;">${createdBy}</span>`;
            createdByLine.style.margin = "0";
            createdByLine.style.textAlign = "left";
            createdByLine.style.width = "100%";
            createdByLine.style.fontSize = "0.9rem";
            createdByLine.style.color = "#1f2937";
            const reportDateLine = document.createElement("p");
            if (historyReportDate) reportDateLine.innerHTML = `Report Date: <span style="font-weight:600;">${reportDate}</span>`;
            reportDateLine.style.margin = "0";
            reportDateLine.style.fontSize = "0.9rem";
            reportDateLine.style.color = "#1f2937";
            metaContainer.appendChild(createdByLine);
            metaContainer.appendChild(reportDateLine);
            const sectionLabel = reportData?.reportLabel && reportData.reportLabel !== reportName ? reportData.reportLabel : null;
            if (sectionLabel) reportTitle.textContent = `${reportName} \u{2014} ${sectionLabel}`;
            headerLeft.appendChild(reportTitle);
            headerLeft.appendChild(companyName);
            headerLeft.appendChild(metaContainer);
            const headerRight = document.createElement("div");
            headerRight.style.display = "flex";
            headerRight.style.flexDirection = "column";
            headerRight.style.alignItems = "flex-end";
            const logo = document.createElement("img");
            logo.src = $803d4ad2316930d5$exports;
            logo.alt = "Diligentsia";
            logo.style.height = "32px";
            logo.style.objectFit = "contain";
            headerRight.appendChild(logo);
            headerWrapper.appendChild(headerLeft);
            headerWrapper.appendChild(headerRight);
            page.appendChild(headerWrapper);
        } else {
            const continuationHeader = document.createElement("div");
            continuationHeader.style.display = "flex";
            continuationHeader.style.justifyContent = "space-between";
            continuationHeader.style.alignItems = "baseline";
            continuationHeader.style.marginBottom = "16px";
            const leftGroup = document.createElement("div");
            leftGroup.style.display = "flex";
            leftGroup.style.flexDirection = "column";
            const title = document.createElement("p");
            title.style.fontWeight = "600";
            title.style.fontSize = "1rem";
            title.style.color = "#1f2937";
            title.style.width = "100%";
            title.style.textAlign = "left";
            // Use dynamic report name from reportData, fallback to "Insurance Gap Analysis Report" for insurance reports
            const reportName = reportData?.name || (reportData?.reportType === 'insuranceGapAnalysis' ? 'Insurance Gap Analysis Report' : 'Section Report');
            const continuationSectionLabel = reportData?.reportLabel && reportData.reportLabel !== reportName ? reportData.reportLabel : null;
            title.textContent = continuationSectionLabel ? `${reportName} \u{2014} ${continuationSectionLabel}` : reportName;
            const companyLine = document.createElement("p");
            companyLine.style.fontSize = "0.85rem";
            companyLine.style.color = "#4b5563";
            companyLine.style.marginTop = "4px";
            companyLine.style.textAlign = "left";
            companyLine.style.width = "100%";
            companyLine.textContent = company?.['cName'] || '';
            leftGroup.appendChild(title);
            leftGroup.appendChild(companyLine);
            const dateSpan = document.createElement("p");
            dateSpan.style.fontSize = "0.85rem";
            dateSpan.style.color = "#4b5563";
            dateSpan.style.textAlign = "left";
            dateSpan.style.width = "100%";
            dateSpan.textContent = reportDate;
            leftGroup.appendChild(dateSpan);
            const headerRight = document.createElement("div");
            headerRight.style.display = "flex";
            headerRight.style.flexDirection = "column";
            headerRight.style.alignItems = "flex-end";
            const logo = document.createElement("img");
            logo.src = $803d4ad2316930d5$exports;
            logo.alt = "Diligentsia";
            logo.style.height = "32px";
            logo.style.objectFit = "contain";
            headerRight.appendChild(logo);
            continuationHeader.appendChild(leftGroup);
            continuationHeader.appendChild(headerRight);
            page.appendChild(continuationHeader);
        }
        return page;
    };
    const showReportContent = ()=>{
        // Deduplicate htmlReport array to prevent duplicate rendering
        let htmlReportArray = reportData?.['htmlReport'];
        if (Array.isArray(htmlReportArray)) {
            const seen = new Set();
            htmlReportArray = htmlReportArray.filter((item, index)=>{
                if (!item || typeof item !== 'string') return false;
                const trimmed = item.trim();
                if (trimmed.length === 0) return false; // Remove empty items
                const normalized = trimmed.replace(/\s+/g, ' ');
                if (seen.has(normalized)) {
                    console.warn(`Duplicate htmlReport section at index ${index} detected and removed in showReportContent`);
                    return false;
                }
                seen.add(normalized);
                return true;
            });
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: htmlReportArray?.map((item, idx)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `insurance-section insurance-report-content ${company['subscription'] === 'Free' && company['cCategory'] === "client" && idx > 1 ? 'blur-disabled' : ''}`,
                    dangerouslySetInnerHTML: {
                        __html: `${item}`
                    },
                    style: {
                        fontSize: '11px',
                        lineHeight: '1.4',
                        color: '#1f2937',
                        marginBottom: idx < htmlReportArray.length - 1 ? '0.5rem' : '0',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        maxWidth: '100%'
                    }
                }, `insurance-report-${idx}`);
            })
        });
    };
    const showEmptyState = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df jcc aic fdc py4rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    textAlign: 'center',
                    padding: '3rem',
                    background: '#f9fafb',
                    borderRadius: '16px',
                    maxWidth: '500px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            fontSize: '4rem',
                            marginBottom: '1rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        style: {
                            fontSize: '1.5rem',
                            fontWeight: '600',
                            color: '#1f2937',
                            marginBottom: '0.75rem'
                        },
                        children: "No Report Available"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        style: {
                            fontSize: '1rem',
                            color: '#6b7280'
                        },
                        children: "Generate your section report to see comprehensive analysis and recommendations"
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            company && reportData?.['htmlReport'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    reportData['pdfUrl'] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        id: "analyser-pdf-url",
                        href: reportData['pdfUrl'],
                        style: {
                            display: 'none'
                        },
                        "aria-hidden": "true"
                    }),
                    reportData['isHistoryVersion'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aic jcc mb1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "bg4 c1 fs12px fw600 br50px px1-5rem py0-5rem",
                            children: [
                                "Viewing archived generation",
                                reportDate ? ` \u{2014} ${reportDate}` : ''
                            ]
                        })
                    }),
                    reportData['pdfUrl'] ? /* Papermill PDF — show inline viewer */ /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                        src: reportData['pdfUrl'],
                        title: "Analyser Report",
                        className: "w100 br12px",
                        style: {
                            height: '80vh',
                            minHeight: '600px',
                            border: 'none'
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                id: "pdf",
                                className: `op0 pen ma td250 dg gg2rem jcc sectionWiseReport`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                id: "pdfContent",
                                className: "bsbb w0 h0 oh op0 pen db pr",
                                style: {
                                    width: "210mm"
                                },
                                children: [
                                    showReportContent(),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                className: "bg4 c1 w300 px1rem py0-5rem br50px df aic jcsb fs14px cp mr1rem tdnone",
                                                href: "https://koalendar.com/e/meet-with-mark-bernstein",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("2SkE2")),
                                                        alt: "cfo-icon",
                                                        style: {
                                                            width: "16px",
                                                            height: '16px'
                                                        },
                                                        className: "mr0-5rem"
                                                    }),
                                                    "Book a Call with CFO",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6717d2334b7944f8$export$2e2bcd8739ae039), {
                                                        className: "c1 ml0-5rem"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                className: "bg4 c1 w300 px1rem py0-5rem br50px df aic jcsb fs14px cp tdnone",
                                                href: "https://koalendar.com/e/meet-with-mark-bernstein",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("2SkE2")),
                                                        alt: "cfo-icon",
                                                        style: {
                                                            width: "16px",
                                                            height: '16px'
                                                        },
                                                        className: "mr0-5rem"
                                                    }),
                                                    "Book a Call with Insurer"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mt1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c15 fw500 mb1rem fs14px",
                                                children: "This report is for guidance only."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs12px",
                                                style: {
                                                    color: '#505050',
                                                    lineHeight: '2.5'
                                                },
                                                children: "This Report has been prepared by Diligensia for the exclusive use of the named client. It is based on information provided as at the date of issue and is intended solely to assist in identifying risks and opportunities. This report was generated by AI and may be inaccurate.\xa0 You are urged to check all report content. Diligentsia accepts no responsibility or liability for any errors, omissions, or delays, nor for any actions taken in reliance on this report. The contents do not constitute legal or financial advice, and professional advice should always be sought. This report may not be relied upon by any third party to whom the report is shown and Diligensia accepts no duty of care or liability to any third party who may obtain access to it."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            company['subscription'] === 'Free' && company['cCategory'] === "client" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt3rem tac pa",
                                style: {
                                    bottom: '100px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    zIndex: 10
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: 'white',
                                        padding: '2rem 3rem',
                                        borderRadius: '16px',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                                        backdropFilter: 'blur(10px)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            style: {
                                                fontSize: '1.5rem',
                                                fontWeight: '700',
                                                marginBottom: '0.75rem'
                                            },
                                            children: "\uD83D\uDD12 Unlock Complete Analysis"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            style: {
                                                fontSize: '1rem',
                                                opacity: '0.95',
                                                marginBottom: '1.5rem'
                                            },
                                            children: "Upgrade to PRO or LITE to access the full Insurance Gap Analysis Report with detailed recommendations"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            style: {
                                                background: 'white',
                                                color: '#667eea',
                                                padding: '0.75rem 2rem',
                                                borderRadius: '8px',
                                                border: 'none',
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                transition: 'transform 0.2s'
                                            },
                                            children: "Upgrade Now"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            company && !reportData?.['htmlReport'] && showEmptyState()
        ]
    });
};
var $ceaf1026d7cd7a8b$export$2e2bcd8739ae039 = $ceaf1026d7cd7a8b$var$InsuranceGapAnalysisReport;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $n3TJI = parcelRequire("n3TJI");

// Set the worker source
$n3TJI.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${$n3TJI.version}/pdf.worker.min.js`;
const $9310f9c2b7964d10$var$THUMBNAIL_SCALE = 0.2;
function $9310f9c2b7964d10$export$2e2bcd8739ae039({ src: src, className: className = '', style: style = {}, title: title = 'PDF Viewer' }) {
    const containerRef = (0, $acw62.useRef)(null);
    const mainScrollRef = (0, $acw62.useRef)(null);
    const pageRefsRef = (0, $acw62.useRef)([]);
    const observerRef = (0, $acw62.useRef)(null);
    const visibilityMapRef = (0, $acw62.useRef)({});
    const renderTasksRef = (0, $acw62.useRef)([]);
    const pagesRenderedRef = (0, $acw62.useRef)(false);
    const [pdfDoc, setPdfDoc] = (0, $acw62.useState)(null);
    const [pdfBytes, setPdfBytes] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    const [scale, setScale] = (0, $acw62.useState)(1.5);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)(1);
    const [sidebarOpen, setSidebarOpen] = (0, $acw62.useState)(true);
    const [thumbnails, setThumbnails] = (0, $acw62.useState)([]);
    const [pageInputValue, setPageInputValue] = (0, $acw62.useState)('1');
    // Load the PDF document via backend proxy
    (0, $acw62.useEffect)(()=>{
        if (!src) return;
        let cancelled = false;
        setLoading(true);
        setError(null);
        setPdfDoc(null);
        setPdfBytes(null);
        setThumbnails([]);
        setCurrentPage(1);
        setPageInputValue('1');
        pagesRenderedRef.current = false;
        pageRefsRef.current = [];
        visibilityMapRef.current = {};
        const proxyUrl = `${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api/company/pdf-proxy?url=${encodeURIComponent(src)}`;
        fetch(proxyUrl).then((res)=>{
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.arrayBuffer();
        }).then((data)=>{
            if (cancelled) return;
            // Store a copy before PDF.js transfers/detaches the ArrayBuffer
            setPdfBytes(data.slice(0));
            return $n3TJI.getDocument({
                data: new Uint8Array(data),
                cMapUrl: `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${$n3TJI.version}/cmaps/`,
                cMapPacked: true
            }).promise;
        }).then((doc)=>{
            if (!cancelled) {
                setPdfDoc(doc);
                setLoading(false);
            }
        }).catch((err)=>{
            if (!cancelled) {
                console.error('PDF load error:', err);
                setError('Failed to load PDF');
                setLoading(false);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        src
    ]);
    // Render all pages
    const renderPages = (0, $acw62.useCallback)(async ()=>{
        if (!pdfDoc || !containerRef.current || pagesRenderedRef.current) return;
        pagesRenderedRef.current = true;
        const container = containerRef.current;
        renderTasksRef.current.forEach((t)=>t.cancel?.());
        renderTasksRef.current = [];
        container.innerHTML = '';
        pageRefsRef.current = [];
        visibilityMapRef.current = {};
        if (observerRef.current) observerRef.current.disconnect();
        // Track which page is most visible in the scroll area
        observerRef.current = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const pageNum = parseInt(entry.target.dataset.pageNum, 10);
                visibilityMapRef.current[pageNum] = entry.intersectionRatio;
            });
            let maxRatio = 0;
            let mostVisible = 1;
            Object.entries(visibilityMapRef.current).forEach(([num, ratio])=>{
                if (ratio > maxRatio) {
                    maxRatio = ratio;
                    mostVisible = parseInt(num, 10);
                }
            });
            setCurrentPage(mostVisible);
            setPageInputValue(String(mostVisible));
        }, {
            root: mainScrollRef.current,
            threshold: [
                0,
                0.1,
                0.25,
                0.5,
                0.75,
                1.0
            ]
        });
        for(let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++)try {
            const page = await pdfDoc.getPage(pageNum);
            const viewport = page.getViewport({
                scale: scale
            });
            const pageDiv = document.createElement('div');
            pageDiv.style.cssText = `position:relative;width:${viewport.width}px;height:${viewport.height}px;margin:0 auto 8px auto;`;
            pageDiv.dataset.pageNum = pageNum;
            const canvas = document.createElement('canvas');
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.style.display = 'block';
            pageDiv.appendChild(canvas);
            container.appendChild(pageDiv);
            pageRefsRef.current[pageNum - 1] = pageDiv;
            observerRef.current.observe(pageDiv);
            const ctx = canvas.getContext('2d');
            const renderTask = page.render({
                canvasContext: ctx,
                viewport: viewport
            });
            renderTasksRef.current.push(renderTask);
            await renderTask.promise;
            // Overlay clickable link annotations
            const annotations = await page.getAnnotations();
            const linkAnnotations = annotations.filter((a)=>a.subtype === 'Link' && a.url);
            if (linkAnnotations.length > 0) {
                const annotLayer = document.createElement('div');
                annotLayer.style.cssText = `position:absolute;top:0;left:0;width:${viewport.width}px;height:${viewport.height}px;`;
                linkAnnotations.forEach((annotation)=>{
                    const [x1, y1, x2, y2] = viewport.convertToViewportRectangle(annotation.rect);
                    const link = document.createElement('a');
                    link.href = annotation.url;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    link.title = annotation.url;
                    link.style.cssText = `position:absolute;left:${Math.min(x1, x2)}px;top:${Math.min(y1, y2)}px;width:${Math.abs(x2 - x1)}px;height:${Math.abs(y2 - y1)}px;cursor:pointer;display:block;background:transparent;border:none;z-index:1;`;
                    link.addEventListener('mouseenter', ()=>{
                        link.style.backgroundColor = 'rgba(0,100,255,0.1)';
                        link.style.borderBottom = '2px solid rgba(0,100,255,0.4)';
                    });
                    link.addEventListener('mouseleave', ()=>{
                        link.style.backgroundColor = 'transparent';
                        link.style.borderBottom = 'none';
                    });
                    annotLayer.appendChild(link);
                });
                pageDiv.appendChild(annotLayer);
            }
        } catch (err) {
            if (err.name !== 'RenderingCancelledException') console.error(`Error rendering page ${pageNum}:`, err);
        }
    }, [
        pdfDoc,
        scale
    ]);
    // Render thumbnails once per PDF load (not on scale change)
    (0, $acw62.useEffect)(()=>{
        if (!pdfDoc) return;
        let cancelled = false;
        setThumbnails([]);
        (async ()=>{
            for(let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++){
                if (cancelled) break;
                try {
                    const page = await pdfDoc.getPage(pageNum);
                    const viewport = page.getViewport({
                        scale: $9310f9c2b7964d10$var$THUMBNAIL_SCALE
                    });
                    const canvas = document.createElement('canvas');
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    await page.render({
                        canvasContext: canvas.getContext('2d'),
                        viewport: viewport
                    }).promise;
                    if (!cancelled) {
                        const dataUrl = canvas.toDataURL();
                        setThumbnails((prev)=>[
                                ...prev,
                                {
                                    pageNum: pageNum,
                                    dataUrl: dataUrl
                                }
                            ]);
                    }
                } catch (err) {
                // skip failed thumbnail
                }
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        pdfDoc
    ]);
    // Render pages when doc loads or scale changes
    (0, $acw62.useEffect)(()=>{
        if (pdfDoc) {
            pagesRenderedRef.current = false;
            renderPages();
        }
    }, [
        pdfDoc,
        scale,
        renderPages
    ]);
    // Cleanup observer on unmount
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, []);
    const scrollToPage = (0, $acw62.useCallback)((pageNum)=>{
        const pageDiv = pageRefsRef.current[pageNum - 1];
        if (pageDiv) pageDiv.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, []);
    const handleDownload = (0, $acw62.useCallback)(()=>{
        if (!pdfBytes) return;
        const blob = new Blob([
            pdfBytes
        ], {
            type: 'application/pdf'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = title !== 'PDF Viewer' ? `${title}.pdf` : 'document.pdf';
        a.click();
        URL.revokeObjectURL(url);
    }, [
        pdfBytes,
        title
    ]);
    const handlePrint = (0, $acw62.useCallback)(()=>{
        if (!pdfBytes) return;
        const blob = new Blob([
            pdfBytes
        ], {
            type: 'application/pdf'
        });
        const url = URL.createObjectURL(blob);
        const win = window.open(url, '_blank');
        if (win) win.addEventListener('load', ()=>{
            win.print();
            URL.revokeObjectURL(url);
        });
    }, [
        pdfBytes
    ]);
    const handlePageInputKeyDown = (e)=>{
        if (e.key === 'Enter') {
            const num = parseInt(pageInputValue, 10);
            if (pdfDoc && num >= 1 && num <= pdfDoc.numPages) scrollToPage(num);
            else setPageInputValue(String(currentPage));
        }
    };
    const handlePageInputBlur = ()=>{
        const num = parseInt(pageInputValue, 10);
        if (!pdfDoc || isNaN(num) || num < 1 || num > pdfDoc.numPages) setPageInputValue(String(currentPage));
    };
    if (!src) return null;
    const numPages = pdfDoc?.numPages ?? 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        style: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#525659',
            overflow: 'hidden',
            ...style
        },
        title: title,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '8px 12px',
                    backgroundColor: '#323639',
                    borderBottom: '1px solid #474a4d',
                    zIndex: 10,
                    gap: '8px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setSidebarOpen((o)=>!o),
                        style: $9310f9c2b7964d10$var$toolbarBtnStyle,
                        title: sidebarOpen ? 'Hide Thumbnails' : 'Show Thumbnails',
                        children: "\u2630"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            flex: 1,
                            justifyContent: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                value: pageInputValue,
                                onChange: (e)=>setPageInputValue(e.target.value),
                                onKeyDown: handlePageInputKeyDown,
                                onBlur: handlePageInputBlur,
                                style: {
                                    width: '38px',
                                    textAlign: 'center',
                                    background: '#474a4d',
                                    border: '1px solid #5a5d60',
                                    color: '#ddd',
                                    borderRadius: '4px',
                                    padding: '3px 4px',
                                    fontSize: '13px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    color: '#888',
                                    fontSize: '13px'
                                },
                                children: [
                                    "/ ",
                                    numPages || "\u2014"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: '1px',
                                    height: '18px',
                                    background: '#5a5d60',
                                    margin: '0 4px'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setScale((s)=>Math.max(0.5, s - 0.25)),
                                style: $9310f9c2b7964d10$var$toolbarBtnStyle,
                                title: "Zoom Out",
                                children: "\u2212"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                style: {
                                    color: '#ccc',
                                    fontSize: '13px',
                                    minWidth: '44px',
                                    textAlign: 'center'
                                },
                                children: [
                                    Math.round(scale * 100),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setScale((s)=>Math.min(3, s + 0.25)),
                                style: $9310f9c2b7964d10$var$toolbarBtnStyle,
                                title: "Zoom In",
                                children: "+"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setScale(1.5),
                                style: {
                                    ...$9310f9c2b7964d10$var$toolbarBtnStyle,
                                    fontSize: '12px',
                                    padding: '4px 10px'
                                },
                                title: "Reset Zoom",
                                children: "Reset"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: '6px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: handleDownload,
                                style: {
                                    ...$9310f9c2b7964d10$var$toolbarBtnStyle,
                                    fontSize: '12px',
                                    padding: '4px 12px'
                                },
                                title: "Download PDF",
                                disabled: !pdfBytes,
                                children: "Download"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: handlePrint,
                                style: {
                                    ...$9310f9c2b7964d10$var$toolbarBtnStyle,
                                    fontSize: '12px',
                                    padding: '4px 12px'
                                },
                                title: "Print PDF",
                                disabled: !pdfBytes,
                                children: "Print"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    flex: 1,
                    overflow: 'hidden'
                },
                children: [
                    sidebarOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            width: '150px',
                            flexShrink: 0,
                            overflowY: 'auto',
                            backgroundColor: '#3a3d40',
                            borderRight: '1px solid #474a4d',
                            padding: '8px 0'
                        },
                        children: [
                            thumbnails.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    color: '#888',
                                    fontSize: '11px',
                                    textAlign: 'center',
                                    padding: '16px 8px'
                                },
                                children: loading ? 'Loading...' : 'Loading thumbnails...'
                            }),
                            thumbnails.map(({ pageNum: pageNum, dataUrl: dataUrl })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    onClick: ()=>scrollToPage(pageNum),
                                    style: {
                                        padding: '6px 8px',
                                        cursor: 'pointer',
                                        backgroundColor: currentPage === pageNum ? '#525659' : 'transparent',
                                        borderLeft: currentPage === pageNum ? '3px solid #6ab0f5' : '3px solid transparent',
                                        transition: 'background 0.1s'
                                    },
                                    title: `Page ${pageNum}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: dataUrl,
                                            alt: `Page ${pageNum}`,
                                            style: {
                                                width: '100%',
                                                display: 'block',
                                                border: '1px solid #555',
                                                borderRadius: '2px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                color: '#aaa',
                                                fontSize: '10px',
                                                textAlign: 'center',
                                                marginTop: '3px'
                                            },
                                            children: pageNum
                                        })
                                    ]
                                }, pageNum))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: mainScrollRef,
                        style: {
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'auto'
                        },
                        children: [
                            loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '200px',
                                    color: '#ccc'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '14px',
                                                marginBottom: '8px'
                                            },
                                            children: "Loading PDF..."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                width: '40px',
                                                height: '40px',
                                                border: '3px solid #555',
                                                borderTop: '3px solid #fff',
                                                borderRadius: '50%',
                                                animation: 'spin 1s linear infinite',
                                                margin: '0 auto'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                                            children: `@keyframes spin { to { transform: rotate(360deg); } }`
                                        })
                                    ]
                                })
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '200px',
                                    color: '#ff6b6b'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '14px',
                                                marginBottom: '8px'
                                            },
                                            children: error
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>window.open(src, '_blank'),
                                            style: {
                                                ...$9310f9c2b7964d10$var$toolbarBtnStyle,
                                                padding: '6px 16px'
                                            },
                                            children: "Open PDF directly"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                ref: containerRef,
                                style: {
                                    padding: '16px 0'
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $9310f9c2b7964d10$var$toolbarBtnStyle = {
    background: '#474a4d',
    border: '1px solid #5a5d60',
    color: '#ddd',
    padding: '4px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: '1'
};



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");





function $7ed163864272cf1a$export$2e2bcd8739ae039({ company: company, getCompany: getCompany, setTab: setTab, setCompanyDashboardTab: setCompanyDashboardTab, permissionLevel: permissionLevel }) {
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [aiReports, setAiReports] = (0, $acw62.useState)([]);
    let [groupedAiReports, setGroupedAiReports] = (0, $acw62.useState)([]);
    let [loadingReports, setLoadingReports] = (0, $acw62.useState)(false);
    const [selectedModuleId, setSelectedModuleId] = (0, $acw62.useState)('');
    const [selectedSectionId, setSelectedSectionId] = (0, $acw62.useState)('');
    const [tempModules, setTempModules] = (0, $acw62.useState)([]);
    const [tempSections, setTempSections] = (0, $acw62.useState)([]);
    const [loadingModules, setLoadingModules] = (0, $acw62.useState)(false);
    const [loadingSections, setLoadingSections] = (0, $acw62.useState)(false);
    const [regeneratingReportId, setRegeneratingReportId] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const fetchAiReports = async ()=>{
            if (company?._id && !loadingReports) {
                setLoadingReports(true);
                try {
                    const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/reports`);
                    if (response['code'] == 200 && response['body']?.['reports']) {
                        setAiReports(response['body']['reports']['aiReports'] || []);
                        setGroupedAiReports(response['body']['reports']['groupedAiReports'] || []);
                    }
                } catch (e) {
                    console.error('Failed to fetch AI reports:', e);
                } finally{
                    setLoadingReports(false);
                }
            }
        };
        fetchAiReports();
    }, [
        company?._id
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!company?.['_id']) return;
        const fetchTempModules = async ()=>{
            setLoadingModules(true);
            try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules?limit=100&isActive=true&companyId=${company['_id']}`, 'not-showMessage');
                if (response['code'] == 200 && response['body']?.['modules']) setTempModules(response['body']['modules']);
            } catch (e) {
                console.error('Failed to fetch temp modules:', e);
            } finally{
                setLoadingModules(false);
            }
        };
        fetchTempModules();
    }, [
        company?.['_id']
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedModuleId) {
            setTempSections([]);
            setSelectedSectionId('');
            return;
        }
        const fetchSections = async ()=>{
            setLoadingSections(true);
            try {
                const rawObjective = company?.['testType'] || '';
                const companyObjective = rawObjective ? rawObjective.charAt(0).toUpperCase() + rawObjective.slice(1) : '';
                const subscriptionTier = company?.['subscription'] || '';
                const params = new URLSearchParams();
                if (companyObjective) params.set('companyObjective', companyObjective);
                if (subscriptionTier) params.set('subscriptionTier', subscriptionTier);
                if (company?.['_id']) params.set('companyId', company['_id']);
                const query = params.toString() ? `?${params.toString()}` : '';
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-sections/for-module/${selectedModuleId}${query}`, 'not-showMessage');
                if (response['code'] == 200 && response['body']?.['sections']) setTempSections(response['body']['sections']);
            } catch (e) {
                console.error('Failed to fetch temp sections:', e);
            } finally{
                setLoadingSections(false);
            }
        };
        fetchSections();
    }, [
        selectedModuleId,
        company?.['testType'],
        company?.['subscription']
    ]);
    const sanitizeReportLabel = (label)=>{
        if (!label) return '';
        return label.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9.-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
    };
    const getLatestHistoryEntry = (history)=>{
        if (!Array.isArray(history) || !history.length) return null;
        return history.reduce((latest, current)=>{
            if (!latest?.lastUpdatedTime) return current;
            if (!current?.lastUpdatedTime) return latest;
            const latestDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).utc(latest.lastUpdatedTime, [
                'MMMM Do, YYYY  hh:mma',
                'MMMM Do, YYYY hh:mma'
            ]);
            const currentDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).utc(current.lastUpdatedTime, [
                'MMMM Do, YYYY  hh:mma',
                'MMMM Do, YYYY hh:mma'
            ]);
            return currentDate.isAfter(latestDate) ? current : latest;
        });
    };
    // Reason: new records store lastUpdatedTime as UTC ISO-8601 (new Date().toISOString()).
    // Legacy records stored a human-readable local-time string — fall back to parsing those as
    // UTC (they were generated on a UTC server in prod). Either way the result is shifted to the
    // viewer's local timezone for display.
    const formatHistoryTime = (timeStr)=>{
        if (!timeStr) return '';
        const iso = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(timeStr, (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).ISO_8601, true);
        if (iso.isValid()) return iso.local().format('MMM Do YYYY, h:mm A');
        const legacy = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).utc(timeStr, [
            'MMMM Do, YYYY  hh:mma',
            'MMMM Do, YYYY hh:mma'
        ], true);
        if (legacy.isValid()) return legacy.local().format('MMM Do YYYY, h:mm A');
        return timeStr;
    };
    const formatLatestReportDate = (report)=>{
        const latest = getLatestHistoryEntry(report?.history);
        if (latest?.lastUpdatedTime) {
            const local = formatHistoryTime(latest.lastUpdatedTime);
            const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(local, 'MMM Do YYYY, h:mm A');
            return parsed.isValid() ? parsed.format('D MMMM, YYYY') : local;
        }
        if (report?.createdAt) return (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).utc(report.createdAt).local().format('D MMMM, YYYY');
        return '';
    };
    const selectedModule = (0, $acw62.useMemo)(()=>{
        if (!selectedModuleId) return null;
        return tempModules.find((m)=>m['_id'] === selectedModuleId) || null;
    }, [
        tempModules,
        selectedModuleId
    ]);
    const selectedSection = (0, $acw62.useMemo)(()=>{
        if (!selectedSectionId) return null;
        return tempSections.find((s)=>s['_id'] === selectedSectionId) || null;
    }, [
        tempSections,
        selectedSectionId
    ]);
    const filteredGroups = (0, $acw62.useMemo)(()=>{
        if (!groupedAiReports?.length) return [];
        const moduleKey = selectedModule?.['moduleKey'] || '';
        const sectionNo = selectedSection?.['sectionNo'] || '';
        if (sectionNo) return groupedAiReports.filter((g)=>g['sectionNo'] === sectionNo);
        if (moduleKey) return groupedAiReports.filter((g)=>g['sectionNo'].startsWith(moduleKey));
        return groupedAiReports;
    }, [
        groupedAiReports,
        selectedModule,
        selectedSection
    ]);
    const handleModuleChange = (e)=>{
        setSelectedModuleId(e.target.value);
        setSelectedSectionId('');
    };
    const handleSectionChange = (e)=>{
        setSelectedSectionId(e.target.value);
    };
    const getReportSectionId = (report)=>{
        const rt = report?.['reportType'] || '';
        if (!rt.startsWith('sectionReport_')) return null;
        return rt.replace('sectionReport_', '');
    };
    const handleRegenerate = async (report)=>{
        const sectionId = getReportSectionId(report);
        if (!sectionId) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Select a section to regenerate this report', 'error');
        const files = report['fileurl'];
        if (!files || !files.length) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('No source files found on this report', 'error');
        setRegeneratingReportId(report['_id']);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/generateTempSectionReport/${company['_id']}/${sectionId}`, {
                files: files,
                isQuestion: false,
                focusArea: report['focusArea'] || null
            });
            if (res['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Report regenerated successfully', 'success');
                const updated = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company['_id']}/reports`);
                if (updated['code'] == 200 && updated['body']?.['reports']) {
                    setAiReports(updated['body']['reports']['aiReports'] || []);
                    setGroupedAiReports(updated['body']['reports']['groupedAiReports'] || []);
                }
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message'] || 'Failed to regenerate report', 'error');
        } catch (e) {
            console.error('Regenerate report error:', e);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to regenerate report', 'error');
        } finally{
            setRegeneratingReportId(null);
        }
    };
    const handleReportRedirect = (report)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') return;
        const tabIdentifier = report['reportLabel'] ? sanitizeReportLabel(report['reportLabel']) : report['_id'];
        setTab(`${tabIdentifier}-analyser`);
        setCompanyDashboardTab('Dashboard');
    };
    // Reason: history versions open in the same analyser tab as the latest report, but the
    // history entry id travels inside the tab value (before the -analyser suffix so routing that
    // relies on tab.endsWith('-analyser') keeps working). InsuranceGapAnalysisReport reads this
    // ?history=<id> and renders that snapshot instead of the latest htmlReport.
    const handleHistoryRedirect = (report, entry)=>{
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') return;
        if (!entry?.['_id']) return;
        const tabIdentifier = report['reportLabel'] ? sanitizeReportLabel(report['reportLabel']) : report['_id'];
        setTab(`${tabIdentifier}?history=${entry['_id']}-analyser`);
        setCompanyDashboardTab('Dashboard');
    };
    const reportCard = (report)=>{
        let creator;
        if (report?.['createdBy']) creator = report?.['createdBy'];
        const reportTitle = report['reportLabel'] || report['name'] || 'Name of the analysis report';
        const canOpen = !!report?.['htmlReport'] && permissionLevel != 'DASHBOARD';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bo29 bss bw1px bg1 br15px p1-5rem mx0-75rem my1rem pr bsbb df fdc jcsb",
            style: {
                width: '210px',
                minWidth: '210px',
                minHeight: '280px',
                flex: '0 0 180px'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcsb mb1-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw400 c70",
                                    children: "Reporter"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    children: [
                                        regeneratingReportId === report['_id'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-spinner fa-spin c3 mr0-5rem",
                                            style: {
                                                fontSize: '16px'
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            "data-tooltip": "Regenerate Report",
                                            onClick: ()=>handleRegenerate(report),
                                            className: "cp fa fa-refresh c3 mr0-5rem",
                                            style: {
                                                fontSize: '16px'
                                            }
                                        }),
                                        report?.['history'] && report['history'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cp module-tooltip-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "hover-list",
                                                    style: {
                                                        position: 'relative',
                                                        left: 'auto',
                                                        top: 'auto'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        "data-tooltip": "History",
                                                        className: "cp fa fa-history c4",
                                                        style: {
                                                            fontSize: '16px',
                                                            marginTop: '4px'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "tooltip-area tooltip-reaserchaid",
                                                    children: report['history'].map((data, idx)=>{
                                                        const hasHtmlReport = Array.isArray(data?.['htmlReport']) && data['htmlReport'].length > 0;
                                                        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `overlay-box ${hasHtmlReport ? 'cp' : 'cna op50'}`,
                                                            style: {
                                                                padding: '5px 10px'
                                                            },
                                                            "data-tooltip": hasHtmlReport ? 'View this generated report' : 'No saved report available for this version',
                                                            onClick: ()=>hasHtmlReport && handleHistoryRedirect(report, data),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic w100",
                                                                children: [
                                                                    data?.['userId'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        "data-tooltip": `${data['userId']?.firstName ?? ''} ${data['userId']?.lastName ?? ''}`,
                                                                        className: "shadow w2rem h2rem bg16 bw3px bss bo19 df jcc aic br100 c1 mr0-5rem",
                                                                        children: data['userId']['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: data['userId']['profile'],
                                                                            className: "new-shadow w30px h30px df jcc aic br100 bg16 c1",
                                                                            alt: ""
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "bg16 c15 br50px",
                                                                            children: data['userId']?.firstName ? data['userId'].firstName[0] + (data['userId'].lastName?.[0] || '') : '?'
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "text-box df aic jcsb w100",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c15",
                                                                            style: {
                                                                                fontSize: '10px'
                                                                            },
                                                                            children: formatHistoryTime(data['lastUpdatedTime'])
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }, data['_id'] || idx);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        canOpen ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `#${sanitizeReportLabel(report['reportLabel'] || report['_id'])}-analyser`,
                            onClick: ()=>handleReportRedirect(report),
                            className: "db w100 fs1rem fw600 c15 lh1-5 ttc",
                            children: [
                                reportTitle,
                                " Report"
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w100 fs1rem fw600 c15 lh1-5 ttc",
                            children: reportTitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df aic mt2rem",
                    children: [
                        creator ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            "data-tooltip": `${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`,
                            className: "shadow w30px h30px bg16 bw2px bss bo19 df jcc aic br100 c1 mr0-5rem",
                            children: creator?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: creator.profile,
                                className: "br100",
                                style: {
                                    width: '30px',
                                    height: '30px'
                                },
                                alt: ""
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "bg16 c15 fs0-75rem",
                                children: creator?.firstName ? creator.firstName[0] + (creator.lastName?.[0] || '') : '?'
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "w30px h30px bg16 br100 mr0-5rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw400 c15",
                            children: formatLatestReportDate(report) || "\u2014"
                        })
                    ]
                })
            ]
        }, report['_id']);
    };
    const dummyReportCard = (title = 'Name of the report here')=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bo29 bss bw1px bg1 br15px p1-5rem mx0-75rem my1rem pr bsbb df fdc jcsb op60",
            style: {
                width: '210px',
                minWidth: '210px',
                minHeight: '280px',
                flex: '0 0 180px'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcsb mb1-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw400 c28",
                                    children: "Reporter"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            "data-tooltip": "Edit",
                                            className: "fa fa-edit c3 mr0-5rem",
                                            style: {
                                                fontSize: '16px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            "data-tooltip": "History",
                                            className: "fa fa-history c4",
                                            style: {
                                                fontSize: '16px'
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "w100 fs1rem fw600 c15 lh1-5",
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df aic mt2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "w30px h30px bg16 br100 mr0-5rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw400 c28",
                            children: "8 March, 2025"
                        })
                    ]
                })
            ]
        });
    };
    const upgradeCard = (subscription)=>{
        const navigationUrl = [
            'Advisor',
            'Investor'
        ].includes(company?.['servicedBy']?.['role'] || user['role']) ? `/billing/${company['_id']}/pro/${user['role'].toLowerCase() === "user" ? company?.['servicedBy']?.['role'].toLowerCase() : user['role'].toLowerCase()}` : `/billing/${company['_id']}`;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "shadow bg1 tac w100 p1rem br30px",
            style: {
                height: '212px'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "pr",
                    style: {
                        bottom: '20%'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "shadow c59 fs1-25rem px1-5rem br10px bw1px bo59 bss ttu",
                        style: {
                            background: '#E4FFEB'
                        },
                        children: subscription
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "subs-btn mt0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "fs1rem fw500 c15 mb0-5rem",
                            children: [
                                "Have you thought ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                " about upgrading?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: navigationUrl,
                            className: "bg4 bg3-hover fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac mt0-5rem",
                            children: "Find out more"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper py1rem fs0-75rem pr anylist-builder-tab",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic jcsb w100 mb1-5rem fww",
                    style: {
                        gap: '1rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic fww",
                            style: {
                                gap: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    style: {
                                        width: '180px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: selectedModuleId,
                                            onChange: handleModuleChange,
                                            disabled: loadingModules,
                                            className: `bg1 br50px bw1px bss bo29 px1-5rem py0-75rem fs0-875rem c28 fsi w100 bsbb ${loadingModules ? 'cna op60' : 'cp'}`,
                                            style: {
                                                appearance: 'none',
                                                WebkitAppearance: 'none',
                                                paddingRight: '2.5rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "",
                                                    children: loadingModules ? 'Loading...' : 'All Modules'
                                                }),
                                                !loadingModules && tempModules.map((mod)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: mod['_id'],
                                                        children: mod['moduleName']
                                                    }, mod['_id']))
                                            ]
                                        }),
                                        loadingModules ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-spinner fa-spin pa c3",
                                            style: {
                                                right: '1rem',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none',
                                                fontSize: '10px'
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-chevron-down pa c28",
                                            style: {
                                                right: '1rem',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none',
                                                fontSize: '10px'
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    style: {
                                        width: '180px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                            value: selectedSectionId,
                                            onChange: handleSectionChange,
                                            disabled: !selectedModuleId || loadingSections,
                                            className: `bg1 br50px bw1px bss bo29 px1-5rem py0-75rem fs0-875rem c28 fsi w100 bsbb ${selectedModuleId && !loadingSections ? 'cp' : 'cna op60'}`,
                                            style: {
                                                appearance: 'none',
                                                WebkitAppearance: 'none',
                                                paddingRight: '2.5rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                    value: "",
                                                    children: loadingSections ? 'Loading...' : 'All Sections'
                                                }),
                                                !loadingSections && tempSections.map((section, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                        value: section['_id'] || '',
                                                        children: section['sectionName']
                                                    }, section['_id'] || idx))
                                            ]
                                        }),
                                        loadingSections ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-spinner fa-spin pa c3",
                                            style: {
                                                right: '1rem',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none',
                                                fontSize: '10px'
                                            }
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-chevron-down pa c28",
                                            style: {
                                                right: '1rem',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none',
                                                fontSize: '10px'
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                loadingReports ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt0-5rem bss px1-5rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                    style: {
                        background: '#F5F6F9'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 tac py3rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1rem c12",
                            children: "Loading reports..."
                        })
                    })
                }) : filteredGroups.length > 0 ? filteredGroups.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt0-5rem bss px1-5rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                        style: {
                            background: '#F5F6F9'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df aic w100 pl0-5rem mb1-5rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs1-25rem fw600 c15",
                                    children: group['sectionName']
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 df fww aifs",
                                style: {
                                    gap: '0.25rem'
                                },
                                children: group['reports'].map((item)=>reportCard(item))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "research-aid-ai-img",
                                style: {
                                    height: '280px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "pa r0 b0",
                                    src: (parcelRequire("1icau")),
                                    alt: "ai-analyser"
                                })
                            })
                        ]
                    }, group['sectionNo'])) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt0-5rem bss px1-5rem py2rem br25px w100 keyfeature-box-portfolio anylist-checklist df fww mb3rem pr bsbb",
                    style: {
                        background: '#F5F6F9'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 tac py3rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem c12",
                                children: aiReports.length > 0 ? 'No reports match the selected module' : 'No AI reports available yet'
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "research-aid-ai-img",
                            style: {
                                height: '280px'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                style: {
                                    position: 'absolute',
                                    bottom: '0',
                                    right: '0'
                                },
                                src: (parcelRequire("aYpFv")),
                                alt: "ai-analyser"
                            })
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");







































































const $b5414be11cddc08f$var$AppStore = ({ company: company, setTab: setTab, user: user, permissionLevel: permissionLevel })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [selectedThingsToDo, setSelectedThingsToDo] = (0, $acw62.useState)({});
    const APP_STORE_PARTNERS = [
        {
            isPopup: false,
            needToGenerate: true,
            logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/Cybersecurity_Basics.png',
            icon: 'https://checklist-icons.s3.us-east-2.amazonaws.com/Cybersecurity_Basics.png',
            module: company?.['extraModules']?.find((item)=>item['moduleName'] == 'Cyber DueDil') || {},
            type: 'Cyber DueDil',
            title: 'SME DueDil',
            tag: 'Partner',
            bottomText: 'Including 30-minute video consultation',
            btnText: 'More',
            website: '',
            websiteUrl: '',
            bookCall: '',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Cyber DueDil',
                mainHeading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Partner Pack - ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Cyber DueDil"
                    ]
                }),
                points: [
                    'Get a report on what to fix personalized to your business',
                    'Organize key documents',
                    'Business audit',
                    'Risks and recommendations',
                    'Diligence reports to show buyers'
                ],
                boxes: [],
                stepImage: (parcelRequire("g06LD")),
                arrayImages: [
                    (parcelRequire("hlWaF")),
                    (parcelRequire("iOEPt")),
                    (parcelRequire("laFXl")),
                    (parcelRequire("dDdZn")),
                    (parcelRequire("apeEM"))
                ],
                extraModule: {
                    text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Enhance your value and speed of sale on Businesses For Sale"
                    }),
                    btnText: 'Free'
                },
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: 'https://checklist-icons.s3.us-east-2.amazonaws.com/Cybersecurity_Basics.png',
                        alt: ""
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Partner Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Cyber DueDil"
                        ]
                    }),
                    points: [
                        'Get a report on what to fix personalized to your business',
                        'Organize key documents',
                        'Business audit',
                        'Risks and recommendations',
                        'Diligence reports to show buyers'
                    ],
                    image: (parcelRequire("tYq1A")),
                    imageStyle: {
                        height: '70%',
                        width: '70%'
                    }
                }
            }
        },
        {
            isPopup: false,
            needToGenerate: true,
            logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/abf-partner-logo.png',
            icon: 'https://checklist-icons.s3.us-east-2.amazonaws.com/abf-partner-logo.png',
            module: company?.['extraModules']?.find((item)=>item['moduleName'] == 'Alternative Business Funding') || {},
            title: 'Loan readiness Checklist',
            tag: 'Partner',
            type: 'Alternative Business Funding',
            bottomText: 'Loan readiness checklist for application to 140 lenders via ABF - increase your chances',
            btnText: 'More',
            website: '',
            websiteUrl: '',
            bookCall: '',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Bespoked financial analysis from your own AI finance copilot',
                mainHeading: 'Instant financial insights from your accounting data - in plain English',
                bottomHeading: 'Financial analysis that works alongside CFOs and finance teams not instead of them',
                points: [
                    'Connects directly to Xero, Quickbooks and other accounting platforms',
                    "Ask natural\u2011language questions and get tailored financial analysis instantly",
                    "Hyper\u2011bespoke reporting across cash flow, margins, runway and performance",
                    "Proactive, actionable insights \u2014 not static dashboards",
                    "Fast to deploy, cost\u2011effective and finance team friendly"
                ],
                bottomText: 'Designed to support your judgement with faster, deeper financial visibility'
            }
        },
        {
            isPopup: false,
            needToGenerate: true,
            logo: 'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png',
            icon: 'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png',
            module: company?.['extraModules']?.find((item)=>item['moduleName'] == 'Business For Sale') || {},
            type: 'Business For Sale',
            title: 'Sale readiness checklist',
            tag: 'Partner',
            bottomText: 'Enhance your value and speed of sale on Businesses For Sale',
            btnText: 'More',
            website: '',
            websiteUrl: '',
            bookCall: '',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Business For Sale',
                mainHeading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Partner Pack - ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Business For Sale"
                    ]
                }),
                points: [
                    'Get a report on what to fix personalized to your business',
                    'Organize key documents',
                    'Business audit',
                    'Risks and recommendations',
                    'Diligence reports to show buyers'
                ],
                boxes: [],
                stepImage: (parcelRequire("g06LD")),
                arrayImages: [
                    (parcelRequire("hlWaF")),
                    (parcelRequire("iOEPt")),
                    (parcelRequire("laFXl")),
                    (parcelRequire("dDdZn")),
                    (parcelRequire("apeEM"))
                ],
                extraModule: {
                    text: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Enhance your value and speed of sale on Businesses For Sale"
                    }),
                    btnText: 'Free'
                },
                seeMore: {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: 'https://checklist-icons.s3.us-east-2.amazonaws.com/bfs-partner-logo.png',
                        alt: ""
                    }),
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Partner Pack - ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            " Business For Sale"
                        ]
                    }),
                    points: [
                        'Get a report on what to fix personalized to your business',
                        'Organize key documents',
                        'Business audit',
                        'Risks and recommendations',
                        'Diligence reports to show buyers'
                    ],
                    image: (parcelRequire("tYq1A")),
                    imageStyle: {
                        height: '70%',
                        width: '70%'
                    }
                }
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("3BbyF")),
            icon: (parcelRequire("javVb")),
            title: 'Due Dig',
            tag: 'Partner',
            bottomText: 'Software code diligence and reviews',
            btnText: 'More',
            website: 'www.duedig.co.uk',
            websiteUrl: 'https://www.duedig.co.uk/',
            bookCall: 'https://calendly.com/duedig/intro',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'CTO -led Tech Due Diligence',
                mainHeading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Tech Due Diligence For Early Stage Companies ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " & Investors"
                    ]
                }),
                points: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Expert CTO Lens"
                            }),
                            " -  deep code & architecture review by seasoned CTOs"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Actionable Scorecard"
                            }),
                            " - Clear risk ratings and red-flag heatmap for IC memo"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Rapid Turnaround"
                            }),
                            " - Speed that matches transaction pace without sacrificing rigor"
                        ]
                    })
                ],
                boxes: [
                    {
                        title: '$850M',
                        subTitle: 'CAPITAL UNDER REVIEW'
                    },
                    {
                        title: '75+ years',
                        subTitle: 'COMBINED CTO EXPERIENCE'
                    },
                    {
                        title: '10 days',
                        subTitle: 'AVG. TURNAROUND'
                    }
                ],
                bottomText: 'Get your board-ready tech risk report in 7-10 days.'
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("aE6n3")),
            icon: (parcelRequire("lRae8")),
            title: 'Knolli.ai',
            tag: 'Partner',
            bottomText: 'Build your own Ai financial agents',
            btnText: 'More',
            website: 'www.knolli.ai',
            websiteUrl: 'https://www.knolli.ai/',
            bookCall: 'https://cal.com/mandeeptaunk/30min',
            rightSideImg: `url(${(parcelRequire("dyKJW"))}), url(${(parcelRequire("dYkl9"))})`
        },
        {
            isPopup: true,
            logo: (parcelRequire("hPEJZ")),
            icon: (parcelRequire("1HDNE")),
            title: 'GenFinance.ai',
            tag: 'Partner',
            bottomText: 'Company Valuation Report',
            btnText: 'More',
            website: 'www.genfinance.ai',
            websiteUrl: 'https://www.genfinance.ai/',
            bookCall: 'https://cal.com/team/genfinance-ai/intro-company',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Big 4-trained finance AI experts',
                mainHeading: 'AI For Finance, By Finance Professionals',
                bottomHeading: 'Accelerating finance teams to become genuine strategic powerhouses, through responsible innovation and measurable results',
                points: [
                    'Finance AI Readiness Scorecard',
                    'AI Savings Finder',
                    'Board-Ready AI Strategy',
                    'Done For You Ai-Deployment'
                ],
                boxes: [
                    {
                        title: "\xa31.7bn",
                        subTitle: 'Cost Savings to be captured from using AI  (UK Economy 2024)'
                    },
                    {
                        title: '10+ years',
                        subTitle: 'Combined Experience'
                    },
                    {
                        title: '28',
                        subTitle: 'Finance Team Projects'
                    }
                ]
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("3Tb8j")),
            icon: (parcelRequire("kMbGU")),
            title: 'Yoono.Ai',
            tag: 'Partner',
            bottomText: 'Diligence individuals and management teams',
            btnText: 'More',
            website: 'www.yoono.ai',
            websiteUrl: 'https://www.yoono.ai/',
            bookCall: 'https://yoono.ai/demo-request',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'YOONO helps you search, verify and understand public information - ethically and intelligently',
                mainHeading: 'Detailed diligence reports on people in minutes',
                bottomHeading: 'You diligence the business. How do you quickly and inexpensively diligence the people?',
                points: [
                    'Enter a name and employer, or upload a CV or LinkedIn profile',
                    'Our engine cross-checks and analyses public data, employment history, media mentions, social profiles, and more to validate accuracy',
                    'Review a clear, moderated report highlighting verified facts, potential discrepancies, and concerning content, ethically sourced and ready to use',
                    'Ready in minutes'
                ],
                boxes: [
                    {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "\xa3200",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    class: "ml0-5rem fw300 fs0-75rem c12",
                                    children: "plus VAT"
                                })
                            ]
                        }),
                        subTitle: 'Individual report'
                    },
                    {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "\xa3800",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    class: "ml0-5rem fw300 fs0-75rem c12",
                                    children: "plus VAT"
                                })
                            ]
                        }),
                        subTitle: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Team bundle x5 reports ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                " (get one free)"
                            ]
                        })
                    },
                    {
                        title: '',
                        subTitle: 'Self-diligence and include in Diligentsia diligence pack to speed transaction completion'
                    }
                ]
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("eqFVc")),
            icon: (parcelRequire("a3JXO")),
            title: 'Kiss The Fish',
            tag: 'Partner',
            bottomText: 'Accelerated sales growth with fractional sales directors',
            btnText: 'More',
            website: 'www.kissthefish.net',
            websiteUrl: 'https://www.kissthefish.net/',
            bookCall: 'https://www.kissthefish.net/',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Fractional Sales Directors',
                mainHeading: "Accelerate revenue with strategic sales leadership \u2014 without the full-time cost",
                bottomHeading: 'On-demand senior sales leadership, coaching & strategy. Transform inconsistent sales into predictable, scalable growth.',
                points: [
                    'Fractional Sales Directors embedded in your business',
                    'Board-level sales strategy & diagnostics',
                    'Coaching to up skill your team',
                    "Flexible engagement \u2014 pay for only what you need",
                    'Proven revenue acceleration results'
                ],
                bottomText: "Tailored sales leadership \u2014 delivered in flexible packages to suit your business needs"
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("aqeGv")),
            icon: (parcelRequire("bnvTy")),
            title: 'Nume',
            tag: 'Partner',
            bottomText: 'Onboard Your AI CFO In 5 Minutes',
            btnText: 'More',
            website: 'www.nume.ai',
            websiteUrl: 'https://www.nume.ai/',
            bookCall: 'https://www.nume.ai/',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Bespoked financial analysis from your own AI finance copilot',
                mainHeading: 'Instant financial insights from your accounting data - in plain English',
                bottomHeading: 'Financial analysis that works alongside CFOs and finance teams not instead of them',
                points: [
                    'Connects directly to Xero, QuickBooks and other accounting platforms',
                    "Ask natural\u2011language questions and get tailored financial analysis instantly",
                    "Hyper\u2011bespoke reporting across cash flow, margins, runway and performance",
                    "Proactive, actionable insights \u2014 not static dashboards",
                    "Fast to deploy, cost\u2011effective and finance team friendly"
                ],
                bottomText: 'Designed to support your judgement with faster, deeper financial visibility'
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("4yNMH")),
            icon: (parcelRequire("2Ap9I")),
            title: 'Startup 2 Standup',
            tag: 'Partner',
            bottomText: 'Founder community to support your journey',
            btnText: 'More',
            website: 'www.startup2standup.com',
            websiteUrl: 'https://www.startup2standup.com/',
            bookCall: 'https://calendly.com/ollie-startup2standup/15min',
            content: {
                topHeading: 'A founder community built to cut through isolation and drive growth with peer support',
                mainHeading: 'A supportive network and structured resources for startup and growth founders',
                bottomHeading: 'Shared experience, encouragement and practical insight to accelerate your journey',
                points: [
                    'Community of founders who understand the entrepreneurial grind',
                    'Peer-to-peer support, shared learning and encouragement',
                    'Group sessions, expert input and practical workshops',
                    'Access to a curated network of investors and specialist advisors',
                    'Expert insight at a founder-friendly, low-cost entry point'
                ],
                bottomText: 'Supportive ecosystem tailored to early-stage and scaling founders'
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("aUWiE")),
            icon: (parcelRequire("5CJ1x")),
            title: 'Freshbat Strategic Marketing',
            tag: 'Partner',
            bottomText: 'Polish traction and GTM strategy for investment readiness',
            btnText: 'More',
            website: 'www.freshbat.com',
            websiteUrl: 'https://www.freshbat.com/',
            bookCall: 'https://freshbat.com/contact/',
            content: {
                topHeading: 'Go-to-market specialist growth consultancy ',
                mainHeading: 'Low-cost GTM expertise to help early-stage companies prove traction and investor readiness',
                bottomHeading: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        "Targeted go-to-market strategy reviews designed for fundraising success",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Clarify route-to-market, traction levers and commercial narrative \u2014 fast"
                    ]
                }),
                points: [
                    'Strengthen your investment story with a credible GTM plan',
                    'Identify the fastest path to early traction and revenue signals',
                    'Avoid common GTM mistakes that put investors off',
                    'Clear actions founders can execute immediately',
                    'Expert insight at a founder-friendly, low-cost entry point'
                ],
                bottomText: 'Boost your marketing strategy in a day ....'
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("9KZLI")),
            icon: (parcelRequire("9ypgU")),
            title: 'Go EO',
            tag: 'Partner',
            bottomText: 'Experts in Employee Ownership Trust setup and management',
            btnText: 'More',
            website: 'www.goeo.uk',
            websiteUrl: 'https://www.goeo.uk/',
            bookCall: 'https://goeo.uk/contact',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Structured, cost effective Employee Ownership Trust (EOT) sales',
                mainHeading: 'Expert EOT providers, from feasibility to completion',
                bottomHeading: 'End-to-end EOT management - taking care of the technical complexity and ensuring each step runs smoothly and speedily.',
                points: [
                    'Complete process: financials, tax clearance, trust set up, legal docs, submissions',
                    'Founded by a Chartered Tax Adviser who sold his own business to an EOT in 2021',
                    'Highly recommended with multiple 5 star reviews on Google and Trustpilot',
                    "Specialists in businesses with 5\u201325 employees, valuations up to \xa35m",
                    'Straightforward, affordable and simple process'
                ],
                bottomText: 'Streamlined EOT sales service for founders and professional advisers'
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("cULhn")),
            icon: (parcelRequire("3p35q")),
            title: 'Intelect Group',
            tag: 'Partner',
            bottomText: 'Inexpensive external diligence on people in minutes',
            btnText: 'More',
            website: 'www.intelect-group.com',
            websiteUrl: 'https://www.intelect-group.com/',
            bookCall: 'https://intelect-group.com/book-a-call/',
            rightSideImg: `url(${(parcelRequire("8r03d"))})`,
            content: {
                topHeading: 'Independent third-party due diligence on directors & senior management',
                mainHeading: "External verification and risk insight on leadership teams \u2014 beyond self-disclosure",
                bottomHeading: 'Objective verification to validate disclosures and identify hidden risk',
                points: [
                    'Third-party verification of director & senior management disclosures',
                    "Builds on Diligentsia\u2019s self-reported Directors\u2019 Questionnaires",
                    'Investigator-led integrity, reputation and conduct checks',
                    'Clear, decision-ready reporting for investors, boards and advisers',
                    'Diligence a whole team in hours - and gain peace of mind'
                ],
                bottomText: "Inexpensive - from as little as \xa350 per Director or manager"
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("haYIc")),
            icon: (parcelRequire("jNsLY")),
            title: 'Green Ripple',
            tag: 'Partner',
            bottomText: 'Forensic pitch preparation, traction & investor strategy',
            btnText: 'More',
            website: 'www.greenripple.co',
            websiteUrl: 'https://www.greenripple.co/',
            bookCall: 'https://www.greenripple.co/',
            content: {
                topHeading: 'Forensic investment readiness coaching that turns your story into investor-ready conviction',
                mainHeading: "Sharpen your investor pitch \u2014 narrative, clarity & traction that investors recognise",
                bottomHeading: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        "Intensive pitch and investment proposition preparation for early stage companies",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Deep refinement of narrative, customer insights and evidence that investors prioritise"
                    ]
                }),
                points: [
                    "Investor messaging that answers \u201CWhy you? Why now?\u201D with evidence-based clarity",
                    'Structured pitch review and refinement to surface traction-focused milestones',
                    'Alignment of market positioning, customer need and unique value proposition',
                    'Data-driven differentiation so investors instantly grasp your edge',
                    'Playbook to engage the right investors and convert interest into term sheets'
                ],
                bottomText: "Focused investment storytelling and readiness \u2014 not generic marketing or consultancy"
            }
        },
        {
            isPopup: true,
            logo: (parcelRequire("jdErA")),
            icon: (parcelRequire("3TXzc")),
            title: 'Flocast',
            tag: 'Partner',
            bottomText: 'Plug & play cashflow modelling',
            btnText: 'More',
            website: 'www.flocast.co.uk',
            websiteUrl: 'https://www.flocast.co.uk/',
            bookCall: 'https://flocast.co.uk/#book-a-demo',
            content: {
                topHeading: "A simple, plug-and-play cashflow app that helps founders and CFOs see what\u2019s coming next",
                mainHeading: 'Real-time cashflow visibility, forecasting and funding access for growing businesses',
                bottomHeading: 'A practical tool fractional CFOs can use to give clients faster, clearer financial insight',
                points: [
                    'Ideal for fractional CFOs supporting multiple SME clients',
                    'Instant cashflow forecasts and real-time financial visibility',
                    'Helps clients plan for VAT, cash pinch points and funding needs',
                    'Plug-and-play setup with rolling monthly contract',
                    'No hidden fees and built for founders and growing SMEs'
                ],
                bottomText: 'Simple monthly pricing, fast setup and practical insight for everyday finance decision'
            }
        }
    ];
    const handleThingsToDo = (item)=>{
        if (item?.['needToGenerate']) {
            // Checklist already exists for this company (live modules map, kept in sync by setTab) — just open it, don't recreate it.
            const alreadyCreated = company?.['modules']?.[item['type']] || company?.['generateChecklistModules']?.find((m)=>m['moduleName'] === item['type']);
            if (alreadyCreated) {
                window.location.hash = item['type'];
                setTab(item['type'], true);
                return;
            }
            generatePartnerModule(item['module']);
            return;
        } else if (item?.['isPopup']) {
            setSelectedThingsToDo(item);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'thingsToDo'
            }));
        } else window.open(item['websiteUrl'], '_blank');
    };
    const generatePartnerModule = async (module)=>{
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            return;
        }
        let data = {
            category: 'partner',
            partnerId: module['_id'],
            companies: {
                [company['_id']]: company['cName']
            },
            memberPermissions: {
                [user['_id']]: {
                    ...user,
                    company: {
                        [company['_id']]: company['cName']
                    }
                }
            }
        };
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatePartnerPopup'
        }));
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (res?.['code'] == 200 && res?.['body']?.['module']?.['moduleName']) {
            window.location.hash = res['body']['module']['moduleName'];
            setTab(res['body']['module']['moduleName'], true);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w100 df fdc aic jcc pb5rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w100 df fdc aic jcc",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df fdc aic jcc my2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "fs1-5rem fw500 c15 w100 tac",
                        children: "AppStore"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "box-dashbord-contaxiner mla mra mb6rem mt2rem",
                style: {
                    width: '98%'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fww pr w100 bg20 p2rem py2rem pb6rem keyfeature-box keyfeature-box-company-pro mb2rem bss bo28 bw1px br25px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aifs tac",
                            style: {
                                width: '20%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc aifs tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-25re c15 w100 tal",
                                        children: "Our Partners"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mt2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("7XACG")),
                                        style: {
                                            width: '230px',
                                            height: '251px'
                                        },
                                        alt: "dashboardIcon"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg gg1rem gtcr3 fww coreworkspace-update",
                            style: {
                                width: '75%'
                            },
                            children: APP_STORE_PARTNERS.map((item, index)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `bo7 w100 keyfeature-wihte-item bg1 new-shadow br15px px2rem py1rem pr bsbb`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cp right-info-hyper-icon",
                                            style: {
                                                right: '-20px',
                                                top: '-20px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "questionmark pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: (parcelRequire("6WOfV")),
                                                    alt: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "w100 h100 df jcsb fdc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    class: "df aic pt0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "mr1rem br5px",
                                                            style: index === 0 ? {
                                                                backgroundColor: '#F6EBFF',
                                                                width: '60px',
                                                                height: '60px',
                                                                objectFit: 'contain'
                                                            } : [
                                                                1,
                                                                3,
                                                                4
                                                            ].includes(index) ? {
                                                                border: '1px solid #E3E3E3',
                                                                borderRadius: '10px',
                                                                width: '60px',
                                                                height: '60px',
                                                                objectFit: 'contain',
                                                                padding: '0.25rem'
                                                            } : {},
                                                            src: item['icon'],
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc",
                                                            onClick: ()=>handleThingsToDo(item),
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    class: "w100 fs0-75rem cp c3",
                                                                    children: item['tag']
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    class: "w100 cp c15",
                                                                    children: item['title']
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    class: "df jcsb aife",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            class: "fs0-875rem c12 mr0-5rem",
                                                            children: item['bottomText']
                                                        }),
                                                        item['needToGenerate'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "",
                                                            src: (parcelRequire("fYhjK")),
                                                            alt: ""
                                                        }) : item['btnText'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>handleThingsToDo(item),
                                                            class: "cp c1 bg4 fs0-75rem br20px px2rem py0-75rem",
                                                            style: {
                                                                maxHeight: '42px'
                                                            },
                                                            children: item['btnText']
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'thingsToDo',
                onClose: ()=>{
                    setSelectedThingsToDo({}), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                },
                className: "backdrop td500 zi4 df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style w100 maw1300px mah100 bg1 shadow df jcc pr",
                    children: [
                        Object.keys(selectedThingsToDo).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w70 pl5rem px3rem py2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "w100 h100 df fdc jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "df jcsb",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                        href: selectedThingsToDo['websiteUrl'],
                                                        target: "_blank",
                                                        class: "cp df fdc c15 fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "w50",
                                                                src: selectedThingsToDo['logo'],
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                class: "w100 mt0-5rem ml0-5rem c4 c3-hover",
                                                                children: selectedThingsToDo['website']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "fs1-25rem c15",
                                                        children: [
                                                            "App",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                class: "c4",
                                                                children: "Store"
                                                            }),
                                                            " Partner Program"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Knolli.ai' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "w100 df fdc c15 my2rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "w100 fs2rem fw500",
                                                        children: "Finance Function AI Specialists"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "w100 fs1rem",
                                                        children: "Turbocharge your finance function with intelligent FP&A agents"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "w100 fs1rem my2rem",
                                                        children: [
                                                            "Automate analysis, reporting and forecasting - freeing  your team to ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " focus on higher value insight and strategy"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "w100 fs1-25rem fw500 mb2rem",
                                                        children: [
                                                            "Need help? You specify in plain English. We can design ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " and deploy AI agents for you in days for as little as \xa31,000 ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " per agent."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("8L0Le")),
                                                        alt: ""
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['content'] && [
                                                'Due Dig',
                                                'GenFinance.ai',
                                                'Yoono.Ai',
                                                'Kiss The Fish',
                                                'Nume',
                                                'Startup 2 Standup',
                                                'Freshbat Strategic Marketing',
                                                'Go EO',
                                                'Intelect Group',
                                                'Green Ripple',
                                                'Flocast',
                                                'Certifii Limited',
                                                'Vaultinum Limited',
                                                'Opus Business Grants'
                                            ].includes(selectedThingsToDo['title']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "w100 df fdc c15 my3rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "w100 c4 fs0-75rem fw500 mb0-5rem",
                                                        children: selectedThingsToDo['content']['topHeading']
                                                    }),
                                                    selectedThingsToDo['title'] == 'Due Dig' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "w100 fs1rem mb1rem",
                                                        children: "Independent, investor-grade tech due diligence - fast, clear, and actionable"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: `w100 fs2rem fw500 lh2 mb1rem`,
                                                        children: selectedThingsToDo['content']['mainHeading']
                                                    }),
                                                    (selectedThingsToDo['title'] == 'GenFinance.ai' || selectedThingsToDo['title'] == 'Yoono.Ai' || selectedThingsToDo['title'] == 'Kiss The Fish' || selectedThingsToDo['title'] == 'Nume' || selectedThingsToDo['title'] == 'Go EO' || selectedThingsToDo['title'] == 'Green Ripple' || selectedThingsToDo['title'] == 'Flocast') && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "w100 fs1rem mb2rem",
                                                        children: selectedThingsToDo?.['content']?.['bottomHeading']
                                                    }),
                                                    selectedThingsToDo?.['content']?.['points'] && /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                        class: "pl1rem mb1rem c12",
                                                        children: selectedThingsToDo?.['content']['points'].map((point)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                class: "mb0-5rem",
                                                                children: point
                                                            }))
                                                    }),
                                                    selectedThingsToDo?.['content']?.['boxes'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        class: "df jcfs my1rem",
                                                        children: selectedThingsToDo?.['content']['boxes'].map((box)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                class: "w25 df fdc jcc p1-5rem bw1px bo16 bss br10px mx0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        class: "fs1rem fw600 tac",
                                                                        children: box['title']
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        class: "fs0-75rem fw600 tac",
                                                                        children: box['subTitle']
                                                                    })
                                                                ]
                                                            }))
                                                    }),
                                                    [
                                                        'Due Dig',
                                                        'Kiss The Fish',
                                                        'Nume',
                                                        'Startup 2 Standup',
                                                        'Freshbat Strategic Marketing',
                                                        'Go EO',
                                                        'Intelect Group',
                                                        'Green Ripple',
                                                        'Flocast',
                                                        'Certifii Limited',
                                                        'Vaultinum Limited',
                                                        'Opus Business Grants'
                                                    ].includes(selectedThingsToDo['title']) && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: `w100 c15 fs1rem fw400 my1rem ${(selectedThingsToDo['title'] == 'Go EO' || selectedThingsToDo['title'] == 'Certifii Limited' || selectedThingsToDo['title'] == 'Vaultinum Limited') && 'mb5rem'}`,
                                                        children: selectedThingsToDo?.['content']?.['bottomText']
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w30",
                                    style: {
                                        backgroundColor: '#99ceff'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "df fdc aic w100 h100",
                                        style: {
                                            backgroundImage: selectedThingsToDo['rightSideImg'],
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover'
                                        },
                                        children: [
                                            selectedThingsToDo['title'] == 'Knolli.ai' && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                class: "c15 fs2rem tac mt3rem lh2",
                                                children: [
                                                    "Book a ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " discovery call ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " with a ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c4",
                                                        children: "human"
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Due Dig' && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                class: "c15 fs2rem tac mt4rem lh1",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "fs4rem fw600",
                                                        children: "15%"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " off for Diligentsia ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c7",
                                                        children: "Pro"
                                                    }),
                                                    " subscribers"
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'GenFinance.ai' && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                class: "c15 fs2rem tac mt5rem lh2",
                                                children: [
                                                    "Free discovery call ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " for Diligentsia ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c7",
                                                        children: "Pro"
                                                    }),
                                                    " subscribers"
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Yoono.Ai' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "",
                                                src: (parcelRequire("d6bjp")),
                                                alt: ""
                                            }),
                                            selectedThingsToDo['title'] == 'Kiss The Fish' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "c15 fs2rem fw400 tal mt5rem lh2 px3rem",
                                                children: "Book your call now & get a free 30-minute revenue growth session"
                                            }),
                                            selectedThingsToDo['title'] == 'Nume' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "c15 fs2rem fw400 tal mt5rem lh2 px3rem",
                                                children: "Try for FREE for 45 days - see real\u2011time financial insights from your own data"
                                            }),
                                            selectedThingsToDo['title'] == 'Startup 2 Standup' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs1rem fw200 tal mt3rem lh2 px2rem",
                                                        children: "Let our community help you get to where you want to get, more quickly with less stress"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs2rem fw400 tal my3rem lh2 px2rem",
                                                        children: "Limited free trial access or introductory founder session"
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Freshbat Strategic Marketing' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1-5rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs1rem fw200 tal mt3rem lh2 px3rem",
                                                        children: "Introductory GTM strategy boost \u2014 fast, focused and affordable"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs2rem fw400 tal my3rem lh2 px3rem",
                                                        children: "Book a GTM strategy boost to improve investor confidence"
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Go EO' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "c15 fs2rem fw400 tal mt6rem lh2 px3rem",
                                                        children: [
                                                            "Get in touch with ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " the EOT experts\xa0"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Intelect Group' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs2rem fw400 tal mt2rem lh2 px3rem",
                                                        children: "Book a discovery call to understand how we can diligence quickly"
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Green Ripple' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs2rem fw400 tal my2rem lh2 px3rem",
                                                        children: "Book an investor readiness review \u2014 refine your pitch and attract the backers you want"
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Flocast' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs14px fw300 fsi tal my2rem lh2 px3rem",
                                                        children: "Founder-friendly, low-cost access to smarter cashflow forecasting"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs2rem fw400 tal mt2rem mb0-5rem lh2 px3rem",
                                                        children: "Book a demo and see how Flocast can strengthen client cashflow visibility"
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Certifii Limited' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "certifii-cta-img",
                                                        src: (parcelRequire("coacY"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "certifii-cta-panel",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Contact us for a free consultation and assessment of your requirements"
                                                        })
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Vaultinum Limited' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "vaultinum-cta-img",
                                                        src: (parcelRequire("9D14E"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "vaultinum-cta-panel",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Contact us for a free consultation and assessment of your requirements"
                                                        })
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Opus Business Grants' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        class: "w60 mt1rem ml6rem",
                                                        src: (parcelRequire("fnOP2"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "vaultinum-cta-img",
                                                        src: (parcelRequire("lfuBX"))
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "vaultinum-cta-panel",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Contact us for a free consultation and assessment of your requirements"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: selectedThingsToDo['bookCall'],
                                                target: "_blank",
                                                className: `w50 cp bg4 br40px df jcsb aic px1rem py0-5rem mt2rem${selectedThingsToDo['title'] == 'Certifii Limited' || selectedThingsToDo['title'] == 'Vaultinum Limited' || selectedThingsToDo['title'] == 'Opus Business Grants' ? ' certifii-cta-btn' : ''}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        class: "df aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                width: "27",
                                                                height: "27",
                                                                viewBox: "0 0 39 39",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        opacity: "0.9",
                                                                        d: "M33.3804 4.33135H30.3365C30.3365 4.06704 30.2812 3.80565 30.1742 3.56399C30.0671 3.32233 29.9106 3.10577 29.7148 2.92823C29.519 2.75069 29.2882 2.61612 29.0373 2.53317C28.7863 2.45022 28.5207 2.42072 28.2577 2.44659C27.7806 2.50563 27.3422 2.73901 27.0268 3.10184C26.7115 3.46466 26.5414 3.93129 26.5493 4.41196V5.27811C26.5493 5.7122 26.6983 6.13314 26.9716 6.47044C27.2448 6.80774 27.6256 7.04092 28.0503 7.13093C28.1718 7.15386 28.2795 7.22337 28.3505 7.32465C28.4215 7.42592 28.45 7.55091 28.4301 7.67296C28.4102 7.795 28.3433 7.90441 28.2438 7.97784C28.1443 8.05127 28.0201 8.0829 27.8976 8.06597C27.2514 7.93885 26.6694 7.59143 26.2509 7.083C25.8323 6.57457 25.6032 5.93665 25.6026 5.27811V4.33135H20.329C20.3267 4.08071 20.2747 3.83301 20.1759 3.60262C20.0772 3.37224 19.9337 3.16374 19.7537 2.98923C19.5738 2.81471 19.361 2.67764 19.1277 2.58597C18.8944 2.49429 18.6453 2.44983 18.3947 2.45517C18.1441 2.46051 17.897 2.51553 17.6678 2.61705C17.4387 2.71858 17.2319 2.86458 17.0596 3.04659C16.8872 3.22861 16.7527 3.44302 16.6639 3.67741C16.575 3.91179 16.5336 4.16147 16.5419 4.41199L16.5419 5.27811C16.5418 5.7122 16.6909 6.13313 16.9641 6.47043C17.2374 6.80773 17.6182 7.04091 18.0428 7.13093C18.1643 7.15388 18.272 7.2234 18.343 7.32467C18.4139 7.42593 18.4425 7.55091 18.4225 7.67293C18.4026 7.79496 18.3358 7.90436 18.2363 7.97779C18.1368 8.05121 18.0126 8.08285 17.8901 8.06595C17.244 7.93882 16.662 7.5914 16.2434 7.08297C15.8249 6.57455 15.5957 5.93663 15.5951 5.27809V4.33135H12.5512C11.7984 4.33275 11.0767 4.63244 10.5444 5.1648C10.012 5.69716 9.71233 6.41879 9.71094 7.17165V9.80842H36.2207V7.17165C36.2193 6.41878 35.9196 5.69715 35.3872 5.1648C34.8549 4.63244 34.1332 4.33275 33.3804 4.33135ZM17.4887 4.33135C17.4924 4.08268 17.5937 3.84544 17.7709 3.67089C17.9481 3.49634 18.1868 3.3985 18.4355 3.3985C18.6842 3.39851 18.9229 3.49636 19.1 3.67091C19.2772 3.84547 19.3786 4.08272 19.3822 4.33139L17.4887 4.33135ZM27.4961 4.33135C27.4998 4.08268 27.6012 3.84544 27.7784 3.67089C27.9555 3.49634 28.1942 3.3985 28.4429 3.3985C28.6916 3.39851 28.9303 3.49636 29.1075 3.67091C29.2846 3.84547 29.386 4.08272 29.3897 4.33139L27.4961 4.33135Z",
                                                                        fill: "#FEFEFE"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        opacity: "0.9",
                                                                        d: "M9.74219 17.1934C9.87852 17.459 10.8695 19.0329 10.954 19.27C11.2572 19.9563 11.3021 20.729 11.0806 21.4458C10.8591 22.1626 10.386 22.7752 9.74849 23.1707C9.7935 23.9237 10.1243 24.6311 10.6733 25.1485C11.2223 25.6658 11.9481 25.954 12.7024 25.9543H33.2286C34.0134 25.9531 34.7657 25.6409 35.3206 25.086C35.8755 24.5311 36.1877 23.7788 36.1888 22.994V11.0078H9.74219V17.1934ZM30.4261 13.3495C30.6717 13.3528 30.9061 13.4527 31.0786 13.6275C31.251 13.8023 31.3477 14.0381 31.3477 14.2837C31.3477 14.5292 31.251 14.765 31.0785 14.9398C30.906 15.1146 30.6717 15.2145 30.4261 15.2178C30.1805 15.2145 29.9461 15.1146 29.7736 14.9398C29.6012 14.7649 29.5045 14.5292 29.5045 14.2836C29.5045 14.038 29.6012 13.8023 29.7737 13.6275C29.9462 13.4527 30.1805 13.3528 30.4261 13.3495ZM30.4261 17.5469C30.6716 17.5503 30.9059 17.6502 31.0783 17.8251C31.2506 17.9999 31.3473 18.2355 31.3473 18.481C31.3473 18.7266 31.2506 18.9622 31.0782 19.137C30.9058 19.3118 30.6716 19.4117 30.4261 19.4152C30.1806 19.4117 29.9463 19.3118 29.7739 19.137C29.6016 18.9622 29.5049 18.7265 29.5049 18.481C29.5049 18.2355 29.6016 17.9999 29.774 17.825C29.9464 17.6502 30.1806 17.5503 30.4261 17.5469ZM30.4261 21.7442C30.6717 21.7475 30.9061 21.8474 31.0786 22.0223C31.251 22.1971 31.3477 22.4328 31.3477 22.6784C31.3477 22.924 31.251 23.1597 31.0785 23.3345C30.906 23.5094 30.6717 23.6092 30.4261 23.6126C30.1805 23.6092 29.9461 23.5093 29.7736 23.3345C29.6012 23.1597 29.5045 22.924 29.5045 22.6784C29.5045 22.4328 29.6012 22.1971 29.7737 22.0222C29.9462 21.8474 30.1805 21.7475 30.4261 21.7442ZM22.9655 13.3495C23.2111 13.3528 23.4455 13.4527 23.618 13.6275C23.7905 13.8023 23.8872 14.0381 23.8872 14.2837C23.8872 14.5292 23.7904 14.765 23.618 14.9398C23.4455 15.1146 23.2111 15.2145 22.9655 15.2178C22.7199 15.2145 22.4855 15.1146 22.3131 14.9398C22.1406 14.7649 22.0439 14.5292 22.0439 14.2836C22.0439 14.038 22.1406 13.8023 22.3131 13.6275C22.4856 13.4527 22.72 13.3528 22.9655 13.3495ZM22.9655 17.5469C23.211 17.5503 23.4453 17.6502 23.6177 17.8251C23.7901 17.9999 23.8867 18.2355 23.8867 18.481C23.8867 18.7266 23.79 18.9622 23.6177 19.137C23.4453 19.3118 23.211 19.4117 22.9655 19.4152C22.72 19.4117 22.4857 19.3118 22.3134 19.137C22.141 18.9622 22.0443 18.7265 22.0443 18.481C22.0443 18.2355 22.141 17.9999 22.3134 17.825C22.4858 17.6502 22.7201 17.5503 22.9655 17.5469ZM22.9655 21.7442C23.2111 21.7475 23.4455 21.8474 23.618 22.0223C23.7905 22.1971 23.8872 22.4328 23.8872 22.6784C23.8872 22.924 23.7904 23.1597 23.618 23.3345C23.4455 23.5094 23.2111 23.6092 22.9655 23.6126C22.7199 23.6092 22.4855 23.5094 22.3131 23.3345C22.1406 23.1597 22.0439 22.924 22.0439 22.6784C22.0439 22.4328 22.1406 22.1971 22.3131 22.0222C22.4856 21.8474 22.72 21.7475 22.9655 21.7442ZM15.505 13.3495C15.7493 13.3547 15.9818 13.4554 16.1527 13.63C16.3237 13.8047 16.4194 14.0393 16.4194 14.2837C16.4194 14.528 16.3236 14.7626 16.1527 14.9373C15.9818 15.1119 15.7492 15.2126 15.5049 15.2178C15.2606 15.2126 15.0281 15.1119 14.8572 14.9373C14.6862 14.7626 14.5905 14.528 14.5905 14.2836C14.5905 14.0393 14.6862 13.8046 14.8572 13.63C15.0281 13.4554 15.2607 13.3547 15.505 13.3495ZM15.505 17.5469C15.7493 17.552 15.9819 17.6527 16.1529 17.8273C16.3239 18.002 16.4196 18.2366 16.4196 18.481C16.4196 18.7254 16.3239 18.9601 16.1529 19.1347C15.9819 19.3094 15.7493 19.41 15.5049 19.4152C15.2606 19.41 15.028 19.3093 14.857 19.1347C14.686 18.9601 14.5902 18.7254 14.5902 18.481C14.5902 18.2366 14.686 18.002 14.857 17.8273C15.028 17.6527 15.2606 17.552 15.505 17.5469ZM15.505 21.7442C15.7493 21.7494 15.9819 21.8501 16.1529 22.0247C16.3239 22.1993 16.4197 22.434 16.4196 22.6784C16.4196 22.9228 16.3239 23.1575 16.1529 23.3321C15.9819 23.5067 15.7493 23.6074 15.5049 23.6126C15.2606 23.6074 15.028 23.5067 14.857 23.3321C14.686 23.1575 14.5902 22.9228 14.5902 22.6784C14.5902 22.434 14.686 22.1993 14.857 22.0247C15.028 21.85 15.2606 21.7494 15.505 21.7442Z",
                                                                        fill: "#FEFEFE"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M21.993 30.9786L19.7586 29.6342C19.5111 29.4866 19.2327 29.3987 18.9453 29.3775C18.6579 29.3563 18.3695 29.4024 18.1031 29.512C17.8366 29.6217 17.5993 29.7919 17.4101 30.0092C17.2209 30.2266 17.0849 30.485 17.013 30.7641C16.9356 30.9948 16.8076 31.2054 16.6383 31.3802C16.4689 31.5551 16.2626 31.6898 16.0344 31.7746C15.8062 31.8593 15.5619 31.8919 15.3195 31.8699C15.0771 31.848 14.8427 31.772 14.6334 31.6476C13.2117 30.7997 11.9014 29.7777 10.7327 28.6054C9.56324 27.4388 8.54149 26.133 7.69034 24.7173C7.56427 24.5008 7.48903 24.2585 7.47032 24.0087C7.4516 23.7589 7.4899 23.5081 7.58232 23.2753C7.67473 23.0424 7.81885 22.8336 8.00378 22.6646C8.18871 22.4957 8.40963 22.3709 8.64984 22.2998C8.89934 22.2223 9.12966 22.0929 9.32573 21.9202C9.52179 21.7475 9.67919 21.5353 9.78762 21.2976C9.89604 21.0599 9.95306 20.802 9.95494 20.5407C9.95681 20.2794 9.90351 20.0207 9.79851 19.7814C9.84927 19.8024 8.3863 17.4031 8.35944 17.345C8.10616 16.9272 7.69801 16.6264 7.22391 16.5081C6.74982 16.3899 6.24821 16.4639 5.8284 16.7139C4.45345 17.5364 3.44502 18.8536 3.00966 20.3955C2.57429 21.9374 2.74495 23.5875 3.48667 25.0076C5.89802 29.647 9.67986 33.431 14.3178 35.8451C15.738 36.5888 17.3888 36.7613 18.9321 36.3271C20.4753 35.8929 21.794 34.8849 22.6179 33.5097C22.8707 33.0912 22.9468 32.5894 22.8297 32.1147C22.7125 31.6401 22.4115 31.2314 21.993 30.9786Z",
                                                                        fill: "#FEFEFE"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "c1 fs0-875rem fw600 ml0-5rem",
                                                                children: "Book a Call"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        width: "20",
                                                        height: "17",
                                                        viewBox: "0 0 28 25",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Green Ripple' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "c15 fs0-75rem fw300 tal mt3rem lh2 px3rem",
                                                        children: "\u201CHighly recommended - after 30 years of doing this stuff...GR have taught me loads whilst going through their process with Diligentsia itself.  They tell you what you don\u2019t want to hear!\u201D"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        class: "w100 c15 fs0-75rem fw500 tal mt0-5rem lh2 px3rem",
                                                        children: "Mark Bernstein, Founder, Diligentsia"
                                                    })
                                                ]
                                            }),
                                            selectedThingsToDo['title'] == 'Flocast' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    class: "c15 fs14px fw300 fsi tal mt5rem mb3rem lh2 px3rem",
                                                    children: "Use promo code : Dili30 to get your discount courtesy of Flocast"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                setSelectedThingsToDo({}), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            },
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $b5414be11cddc08f$export$2e2bcd8739ae039 = $b5414be11cddc08f$var$AppStore;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $7aa087f4714d751e$var$cLevelToProgress = (cLevel)=>{
    const level = (cLevel || '').toLowerCase();
    if (level === 'none' || !level) return 25;
    if (level === 'bronze') return 50;
    if (level === 'silver') return 75;
    if (level === 'gold') return 100;
    return 25;
};









const $7aa087f4714d751e$var$CompanyCard = ({ company: company, user: user, dashboardTab: dashboardTab, companyDashboardTab: companyDashboardTab, setUploadImage: setUploadImage, setCertificateSeeMore: setCertificateSeeMore, setTab: setTab, permissionTooltip: permissionTooltip, setUserAction: setUserAction, setEditUser: setEditUser, setDashboardTab: setDashboardTab, isShowTeamTab: isShowTeamTab, isPortfolio: isPortfolio, setTabName: setTabName, profileClass: profileClass, tab: tab, companyIndex: companyIndex, setOpenTabs: setOpenTabs })=>{
    const [linearProgress, setLinearProgress] = (0, $acw62.useState)(0);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        setLinearProgress(company?.['stats']?.['workflowCompletionPercent'] || 0);
    }, [
        company?.['stats']?.['workflowCompletionPercent']
    ]);
    const handleNavigate = ()=>{
        if (dashboardTab == 'Team' || tab !== '') {
            setTab('');
            setTabName('');
            setOpenTabs(new Set());
            navigate(`/company/${company?.['_id']}`);
            return setDashboardTab('Company');
        }
        if (user['role'] == 'Advisor') navigate('/advisor-dashboard');
        else if (user['role'] == 'Investor') navigate('/investor-dashboard');
        else navigate('/dashboard');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `pr w100 mt0rem mb1rem ${company?.['_id'] && user?.['_id'] && ' company-dashboard-bg'} ${user['role'] == 'Advisor' && user?.['companyId']?.['_id'] == company?.['_id'] || company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' ? 'advisor-bg-lite' : (user['role'] == 'Investor' && user?.['companyId']?.['_id'] == company?.['_id'] || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['cName'] !== "YOUR COMPANY HERE LIMITED" ? 'investor-bg' : 'client-bg'}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `dg gtcr2 jcsb aic top-admin-area mb0rem px2rem py0-5rem topbar-shadow`,
                    style: {
                        background: '#C5CFFF80',
                        borderRadius: '1rem 1rem 0 0'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "left-area df aic jcfs",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic bg4 br50px p0-5rem jcc cp ",
                                    style: {
                                        width: '210px',
                                        padding: '6px 0.5rem',
                                        height: '34px'
                                    },
                                    onClick: handleNavigate,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("kcO1m")),
                                            alt: "back"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs14px fw600 c1 ml0-5rem",
                                            children: user['role'] == 'Advisor' ? dashboardTab === 'Team' || tab !== '' ? 'Company Dashboard' : 'Client Index' : user['role'] == 'Investor' ? 'Portfolio Index' : dashboardTab === 'Team' || tab !== '' ? 'Company Dashboard' : 'Company Index'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    className: "c15 df aic lisn ml1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            className: "fs14px c15",
                                            children: [
                                                company?.['_id'] && user?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: (user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] == company?.['_id'] ? 'Your Firm' : 'Company'
                                                }),
                                                " Index"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "fs14px c15",
                                            children: "/"
                                        }),
                                        dashboardTab == 'Team' && /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: "fs14px c15",
                                            children: "Company/"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            className: `fs14px c15 ${dashboardTab === 'Team' && 'fw600'}`,
                                            children: dashboardTab
                                        }),
                                        dashboardTab == 'Company' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    className: "fs14px c15",
                                                    children: "/"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                    className: "fs14px fw600 c15",
                                                    children: companyDashboardTab
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "right-area df jcfe",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ass df",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fs1rem aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "mr1rem tar df fdc",
                                            children: [
                                                user?.['firstName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c15 ase",
                                                    children: user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : "")
                                                }),
                                                company?.['creatorId']?.['_id'] == user['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `c3 ase fs0-75rem`,
                                                    children: "Company Admin"
                                                })
                                            ]
                                        }),
                                        user?.['firstName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo30`,
                                            children: user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: user?.['profile'],
                                                className: `w40px h40px df jcc aic br100`,
                                                "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : "")
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `w40px h40px df jcc aic br100`,
                                                "data-tooltip": user?.['firstName'] + " " + (user?.['lastName'] ? user?.['lastName'] : ""),
                                                children: user?.['firstName'] ? user?.['firstName']?.[0] + (user?.['lastName'] ? user?.['lastName']?.[0] : "") : "?"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `company-tab bg1 new-shadow py2rem px2rem pr`,
                    style: {
                        borderRadius: '0 0 1rem 1rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww aifs company-details-area",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "left-company-area w33 df",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aifs jcfs",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "bw0px bss br10px bsbb w6rem h6rem p1rem tac df aic jcc pr center-logo-area",
                                                style: {
                                                    border: '1px solid #E3E3E3',
                                                    minWidth: '6rem',
                                                    minHeight: '6rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: company["logo"] || (parcelRequire("duLaW")),
                                                        className: "w100 cp br10px h100 ofc"
                                                    }),
                                                    user['role'] != 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "input-file",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "add-btn bg5",
                                                            onClick: ()=>{
                                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: "uploadProfile"
                                                                })), setUploadImage("");
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                viewBox: "0 0 487 487",
                                                                className: "zi3",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z                 M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9                 v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z                 M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z                 M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "ml1-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aifs",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "fs1-5rem fw500 c15",
                                                        children: company.cName || "Loading..."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "ass fs1rem my0-5rem c15",
                                                    children: [
                                                        "Company Objective: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600 ttc",
                                                            children: company.testType
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "ass fs1rem my0-5rem c15",
                                                    children: [
                                                        "Company Stage: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600 ttc",
                                                            children: company?.['cStage']
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "center-logo-area w33 df jcc fww fdc mla mra pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "company-name",
                                        children: company?.['_id'] && user?.['_id'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                            className: "c15 fs2rem tac w100 fw500 mb2rem",
                                            children: [
                                                tab ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: "Workspace"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: (user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] == company?.['_id'] ? 'Your Firm' : user['role'] == 'Advisor' && company?.['creatorId']?.['createdBy'] ? 'Client ' : 'Company '
                                                }),
                                                " View"
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            class: "df jcc aic",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$4bf83b24a11cff0b), {
                                                height: "80",
                                                width: "80",
                                                color: "#8496f4",
                                                ariaLabel: "three-dots-loading"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "right-certificate-area w33 df jce",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "#unaudited-certification",
                                        onClick: ()=>setTab('unaudited-certification'),
                                        className: "br20px p1rem",
                                        style: {
                                            border: '1px solid #DBDFEE',
                                            width: '260px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df w100 fww",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df jcsb w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs1-5rem c32",
                                                                children: company['cLevel'] ? company['cLevel'] === "None" ? 'None' : company['cLevel'] : 'Not Yet Certified'
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "w100",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic w100 jcsb",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                style: {
                                                                                    width: '30px',
                                                                                    height: '30px'
                                                                                },
                                                                                src: (parcelRequire("4QCMo")),
                                                                                alt: "noneStar"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                style: {
                                                                                    width: '30px',
                                                                                    height: '30px',
                                                                                    marginLeft: '5px'
                                                                                },
                                                                                src: (parcelRequire("l8qRI")),
                                                                                alt: "noneStar"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                style: {
                                                                                    width: '30px',
                                                                                    height: '30px',
                                                                                    marginLeft: '5px'
                                                                                },
                                                                                src: (parcelRequire("7RlQ5")),
                                                                                alt: "noneStar"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                style: {
                                                                                    width: '30px',
                                                                                    height: '30px',
                                                                                    marginLeft: '5px'
                                                                                },
                                                                                src: (parcelRequire("7Y2KK")),
                                                                                alt: "noneStar"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "certificateProgress mt0-5rem mb0-5rem w100",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "progress-value",
                                                                            style: {
                                                                                width: `${$7aa087f4714d751e$var$cLevelToProgress(company?.['cLevel'])}%`,
                                                                                transition: 'width 0.3s ease-out'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "certficate-area",
                                                            children: company['cLevel'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $54119cc183dc6bdf$export$2e2bcd8739ae039), {
                                                                className: "mla mra dashbaord-certficate-page mt0-5rem",
                                                                component: "Company",
                                                                level: company['cLevel'],
                                                                expiryTimestamp: company['createdAt'],
                                                                company: company,
                                                                subscription: company['subscription']
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        user?.['type'] !== 'External' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fww aic mt2rem add-member-area",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "user-area bg19 br30px p0-5rem df aic jcsb w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "user-advisor df aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "ass df",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic mr1rem bg1 br35px adivsor-user-company",
                                                            children: [
                                                                company['members'] && [
                                                                    ...company['members'],
                                                                    company?.['creatorId']
                                                                ].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic",
                                                                    style: {
                                                                        padding: '0.25rem 0'
                                                                    },
                                                                    children: [
                                                                        ...new Map([
                                                                            ...company['members'],
                                                                            company?.['creatorId']
                                                                        ].filter(Boolean).map((member)=>[
                                                                                member['_id'],
                                                                                member
                                                                            ])).values()
                                                                    ].sort((a, b)=>{
                                                                        if (company && company['creatorId'] && a._id === company['creatorId']['_id']) return -1;
                                                                        if (company && company['creatorId'] && b._id === company['creatorId']['_id']) return 1;
                                                                        return 0;
                                                                    }).map((member)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df bg25  br20px",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    "data-tooltip": member?.['firstName'] && member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : ""),
                                                                                    className: `shadow w30px h30px bw3px bss bo19 df jcc aic br100 c1`,
                                                                                    children: member?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        src: member?.['profile'],
                                                                                        className: `w30px h30px df jcc aic br100 bg4 c1 ${profileClass}`,
                                                                                        "data-tooltip": member?.['firstName'] && member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : "")
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c15",
                                                                                        "data-tooltip": member?.['firstName'] && member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : ""),
                                                                                        children: member['firstName'] ? member['firstName'][0] + (member?.['lastName'] ? member?.['lastName']?.[0] : "") : "?"
                                                                                    })
                                                                                }),
                                                                                company?.['memberPermissions'] && company?.['memberPermissions'][member?._id] && Object.keys(company['memberPermissions']).length > 0 && permissionTooltip(company?.['memberPermissions'][member?._id], company['owners'].includes(member?._id))
                                                                            ]
                                                                        }, `member-${member['_id']}`))
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        "data-tooltip": user['email'] == 'temp' ? "Register to add members" : "No Members",
                                                                        className: `${user['email'] == 'temp' && 'da-cursor '} br100 w2rem h2rem`,
                                                                        src: (parcelRequire("kBFDN"))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: `${user['email'] == 'temp' ? 'c15 ' : 'c4 '} ml0-5rem fs0-75rem`,
                                                                    children: "Members"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic mr1rem bg1 br35px adivsor-user-company",
                                                            children: [
                                                                company['advisorData'] && company['advisorData'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic py0-5rem",
                                                                    children: company['advisorData']?.map((advisor, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: `df bg25 mr0-5rem br20px`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    "data-tooltip": advisor?.['firstName'] && advisor?.['firstName'] + " " + (advisor?.['lastName'] ? advisor?.['lastName'] : ""),
                                                                                    className: `shadow w30px h30px bw3px bss bo19 df jcc aic br100 c1`,
                                                                                    children: advisor?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        src: advisor?.['profile'],
                                                                                        className: `w30px h30px df jcc aic br100 bg4 c1 ${profileClass}`,
                                                                                        "data-tooltip": advisor?.['firstName'] && advisor?.['firstName'] + " " + (advisor?.['lastName'] ? advisor?.['lastName'] : "")
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c15",
                                                                                        "data-tooltip": advisor?.['firstName'] && advisor?.['firstName'] + " " + (advisor?.['lastName'] ? advisor?.['lastName'] : ""),
                                                                                        children: advisor['firstName'] ? advisor['firstName'][0] + (advisor?.['lastName'] ? advisor?.['lastName']?.[0] : "") : "?"
                                                                                    })
                                                                                }),
                                                                                company?.['advisors'] && company?.['advisors']?.[advisor['_id']] && company['advisors'][advisor['_id']]['modules'] && Object.keys(company['advisors'][advisor['_id']]['modules']).length > 0 && permissionTooltip(company['advisors'][advisor['_id']]['modules'])
                                                                            ]
                                                                        }, `advisor-${advisor['_id']}`))
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        "data-tooltip": user['email'] == 'temp' ? "Register to add advisors" : "No Advisor",
                                                                        className: `${user['email'] == 'temp' && 'da-cursor '} br100 w3rem h3rem`,
                                                                        src: (parcelRequire("kBFDN"))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: `${user['email'] == 'temp' ? 'c12 ' : 'c4 '} ml0-5rem fs0-75rem`,
                                                                    children: "Advisors"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic mr1rem bg1 br35px adivsor-user-company",
                                                            children: [
                                                                company?.['investorData'] && company?.['investorData']?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic",
                                                                    children: company?.['investorData']?.map((investor)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df bg25 br20px",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    "data-tooltip": investor['firstName'] ? investor['firstName'] + " " + (investor?.['lastName'] ? investor?.['lastName'] : "") : "Register to show your name here",
                                                                                    className: `w2rem h2rem df jcc aic br100 bg4 c1 mr0-5rem`,
                                                                                    children: investor?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        src: investor?.['profile'],
                                                                                        className: "w2rem h2rem df jcc aic br100 bg4 c1",
                                                                                        "data-tooltip": investor.firstName ? investor.firstName + " " + (investor?.lastName ? investor?.lastName : "") : "Register to show your name here"
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        children: investor['firstName'] ? investor['firstName']?.[0] + (investor['lastName'] ? investor['lastName']?.[0] : "") : "?"
                                                                                    })
                                                                                }),
                                                                                company?.['investors'] && company?.['investors']?.[investor['_id']] && company?.['investors']?.[investor['_id']]?.['modules'] && Object.keys(company?.['investors']?.[investor['_id']]?.['modules']).length > 0 && permissionTooltip(company?.['investors']?.[investor['_id']]?.['modules'] ?? {})
                                                                            ]
                                                                        }, `investor-${investor['_id']}`))
                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        "data-tooltip": user['email'] == 'temp' ? "Register to add investors" : "No Investor",
                                                                        className: `${user['email'] == 'temp' && 'da-cursor '} br100 w3rem h3rem`,
                                                                        src: (parcelRequire("kBFDN"))
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: `${user['email'] == 'temp' ? 'c12 ' : 'c4 '} ml0-5rem fs0-75rem`,
                                                                    children: "Investors"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            user?.['role'] != "Guest" && isShowTeamTab && !localStorage.getItem("isQualifiedLeads") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fs1rem fw600 c1 bg3 br20px df aic jcc px1rem tac cp",
                                                style: {
                                                    height: '34px'
                                                },
                                                onClick: ()=>setDashboardTab(dashboardTab == 'Team' ? 'Company' : 'Team'),
                                                children: dashboardTab == 'Team' ? 'Company Dashboard' : 'Manage Team'
                                            })
                                        ]
                                    })
                                }),
                                user['role'] == 'Advisor' || user['role'] == 'Investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tabs-navlist df aic jcc mt2rem pr",
                                        style: {
                                            cursor: user['role'] == 'Guest' && 'not-allowed'
                                        }
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: " "
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $7aa087f4714d751e$export$2e2bcd8739ae039 = $7aa087f4714d751e$var$CompanyCard;


const $cb3ceb5821786f07$var$cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);
const $cb3ceb5821786f07$export$57c43fe781091dc0 = (t)=>decodeURIComponent(t).replace(/(-sync)?-report$/, "");
/** Decode URL-encoded tab values for storage; avoids storing values like "Cyber%20DueDil". */ const $cb3ceb5821786f07$var$decodeTabValue = (v)=>{
    if (typeof v !== 'string') return v;
    try {
        return decodeURIComponent(v);
    } catch (_) {
        return v;
    }
};

































function $cb3ceb5821786f07$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let company = {
        ...selectedCompany
    };
    const store = (0, $391671225302c365$export$6ccbb43953eebf8)();
    let { fileReport: fileReport, currentScore: currentScore, processing: processing, tempModuleAllocationPatch: tempModuleAllocationPatch } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const [selectedDirector, setSelectedDirector] = (0, $acw62.useState)({});
    const sectionRefs = (0, $acw62.useRef)([]);
    const initialized = (0, $acw62.useRef)(false);
    let [editUser, setEditUser] = (0, $acw62.useState)({});
    let [moduleAI, setModuleAI] = (0, $acw62.useState)('');
    let [advisors, setAdvisors] = (0, $acw62.useState)([]);
    let [investors, setInvestors] = (0, $acw62.useState)([]);
    let [companyId, setCompanyId] = (0, $acw62.useState)({});
    let [selectAll, setSelectAll] = (0, $acw62.useState)(false);
    let [allPermissions, setAllPermissions] = (0, $acw62.useState)([]);
    let [isLeadPdf, setIsLeadPdf] = (0, $acw62.useState)(false);
    let [showAlert, setShowAlert] = (0, $acw62.useState)(false);
    let [uploadImage, setUploadImage] = (0, $acw62.useState)("");
    let [userModules, setUserModules] = (0, $acw62.useState)([]);
    let [aiEnhanced, setAiEnchaned] = (0, $acw62.useState)(false);
    let [openTabs, _setOpenTabs] = (0, $acw62.useState)(new Set());
    const setOpenTabs = (0, $acw62.useCallback)((arg)=>{
        _setOpenTabs((prev)=>{
            const next = typeof arg === 'function' ? arg(prev) : arg;
            const list = next instanceof Set ? [
                ...next
            ] : Array.isArray(next) ? next : [
                next
            ];
            return new Set(list.map($cb3ceb5821786f07$var$decodeTabValue));
        });
    }, []);
    let [isPortfolio, setIsPortfolio] = (0, $acw62.useState)(false);
    let [isManualAdd, setIsManualAdd] = (0, $acw62.useState)(false);
    let [acceptEmail, setAcceptEmail] = (0, $acw62.useState)(false);
    let [investorEmail, setInvestorEmail] = (0, $acw62.useState)({});
    let [checklistTask, setChecklistTask] = (0, $acw62.useState)([]);
    let [userAction, setUserAction] = (0, $acw62.useState)('Search');
    let [companyIndex, setCompanyIndex] = (0, $acw62.useState)(false);
    let [isPrePopulate, setIsPrePopulate] = (0, $acw62.useState)(true);
    let [linearProgress, setLinearProgress] = (0, $acw62.useState)(25);
    let [isClientIndex, setIsClientIndex] = (0, $acw62.useState)(true);
    let [deleteMemberId, setDeleteMemberId] = (0, $acw62.useState)('');
    let [isShowTeamTab, setIsShowTeamTab] = (0, $acw62.useState)(true);
    let [selectedSeeMore, setSelectedSeeMore] = (0, $acw62.useState)({});
    let [selectedModules, setSelectedModules] = (0, $acw62.useState)({});
    let [reportHistories, setReportHistories] = (0, $acw62.useState)([]);
    let [files, setFiles] = (0, $acw62.useState)(company?.['files'] || []);
    let [auditReportLogs, setAuditReportLogs] = (0, $acw62.useState)({});
    let [visibleSection, setVisibleSection] = (0, $acw62.useState)(null);
    let [fitInvestorFirms, setFitInvestorFirms] = (0, $acw62.useState)([]);
    let [permissionLevel, setPermissionLevel] = (0, $acw62.useState)('ALL');
    let [isBackFitReport, setIsBackFitReport] = (0, $acw62.useState)(false);
    let [cloneImportResult, setCloneImportResult] = (0, $acw62.useState)({});
    let [isWorkflowReport, setIsWorkflowReport] = (0, $acw62.useState)(false);
    let [profileClass, setProfileClass] = (0, $acw62.useState)('client-profile');
    let [dashboardTab, setDashboardTab] = (0, $acw62.useState)("Company");
    let [isGetInvestorMatches, setIsGetInvestorMatches] = (0, $acw62.useState)(true);
    let [directors, setDirectors] = (0, $acw62.useState)(company?.['directors'] || []);
    let [isViewTwoMinuteReport, setIsViewTwoMinuteReport] = (0, $acw62.useState)(false);
    let [isGenerateAllResearchAid, setIsGenerateAllResearchAid] = (0, $acw62.useState)(false);
    let [isTwoMinuteTesHomePage, setIsTwoMinuteTesHomePage] = (0, $acw62.useState)(false);
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let [activatingClient, setActivatingClient] = (0, $acw62.useState)(null);
    let [companyDashboardTab, setCompanyDashboardTab] = (0, $acw62.useState)("Dashboard");
    let [tab, setTabName] = (0, $acw62.useState)(props && props?.isCallback ? 'repository' : '');
    const lastReportAnchorRef = (0, $acw62.useRef)(null); // Anchor to scroll when closing report
    const [moduleContent] = (0, $acw62.useState)({
        'kpi': {
            heading: 'KPI',
            aiEnhanced: true,
            uploadFiles: false,
            subheading: 'Key Performance Indicators'
        },
        'repository': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Repository',
            subheading: 'Securely store all your important documents here'
        },
        'business-audit-investment': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'business-audit-growth': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'business-audit-exit': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'directors-questionnaire': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Directors Questionnaire',
            subheading: ''
        },
        'two-minute-test-exit': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Exit Ready Test',
            subheading: 'See How Exit Ready You Are'
        },
        'two-minute-test-growth': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Growth Ready Test',
            subheading: 'See How Growth Ready You Are'
        },
        'two-minute-test-investment': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Investment Ready Test',
            subheading: 'How Investment Ready Are You'
        },
        'esg': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Environmental, Social & Governmental',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'software-development': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Software Development',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'warranty-disclosure': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Warranty Disclosure Schedule',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'unaudited-certification': {
            sections: [],
            heading: 'Certification',
            subheading: 'This is your current certification'
        },
        'investor-lead': {
            uploadFiles: true,
            heading: 'Investor Match',
            subheading: 'Securely store all your important documents here'
        }
    });
    const [investorFirmCounts, setInvestorFirmCounts] = (0, $acw62.useState)({
        gold: 0,
        silver: 0,
        bronze: 0,
        threshold: 0
    });
    (0, $acw62.useEffect)(()=>{
        const patch = tempModuleAllocationPatch;
        if (!patch?.savedQuestions?.length || !selectedCompany) return;
        const answerByQuestionId = new Map(patch.savedQuestions.filter((item)=>item?._id && item?.answer).map((item)=>[
                String(item._id),
                item.answer
            ]));
        if (!answerByQuestionId.size) {
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                tempModuleAllocationPatch: null
            }));
            return;
        }
        const updatedCompany = JSON.parse(JSON.stringify(selectedCompany));
        let hasChanges = false;
        const containers = [
            updatedCompany.modules,
            updatedCompany.tempModules
        ].filter(Boolean);
        containers.forEach((container)=>{
            Object.values(container).forEach((module)=>{
                (module?.sections || []).forEach((section)=>{
                    (section?.questions || []).forEach((question)=>{
                        const nextAnswer = answerByQuestionId.get(String(question?._id));
                        if (!nextAnswer) return;
                        question.answer = nextAnswer;
                        hasChanges = true;
                    });
                });
            });
        });
        if (hasChanges) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(updatedCompany));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: null
        }));
    }, [
        tempModuleAllocationPatch,
        selectedCompany,
        dispatch
    ]);
    const handleDeleteDirector = async (item)=>{
        if (item) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'deleteDirector'
            }));
            setSelectedDirector(item);
        } else {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/${company._id}/delete-director/${selectedDirector['_id']}`, {});
            if (response['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                    ...company,
                    directors: directors.filter((el)=>el['_id'] !== selectedDirector['_id'])
                }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'showDirectors'
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        }
    };
    const findUser = async ()=>{
        let email = document.getElementById('searchEmail').value;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/findUser`, {
            email: email,
            companyId: companyId
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (!res || res['code'] != 200) return;
        if (res['body']['found']) {
            setUserAction('Add');
            setEditUser(res['body']['user']);
        } else {
            editUser['email'] = document.getElementById('searchEmail').value;
            setEditUser(editUser);
            setUserAction('New');
        }
    };
    const saveUser = async ()=>{
        const permissions = editUser.permissions || {};
        const email = document.getElementById("userEmail").value;
        const lastName = document.getElementById("userLastName").value;
        const firstName = document.getElementById("userFirstName").value;
        const designation = document.getElementById("designation").value;
        let res = '';
        if (userAction == 'Edit') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/editMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        else if (userAction == 'New') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/newMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/addMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        if (!res || res['code'] != 200) return;
        getCompany();
        setEditUser({});
        setUserAction('Search');
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        setSelectAll(false);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    // Build comprehensive permissions list (same as TeamPermissions.js)
    (0, $acw62.useEffect)(()=>{
        if (company?.['sections'] && company['sections'].length) {
            // Extra modules (ABF, BFS, CDD, EHE, etc.)
            const extraModules = company['extraModules'] && company['extraModules'].length ? company['extraModules'].map((mod)=>({
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.id,
                    sectionName: mod.moduleName === 'Investment Readiness' && mod.name ? `Investment Readiness (${mod.name})` : mod.moduleName
                })) : [];
            // Investor checklist modules
            const generateChecklistModules = company['generateChecklistModules'] && company['generateChecklistModules'].length ? company['generateChecklistModules'].map((mod)=>({
                    checklistModule: true,
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.moduleKey,
                    sectionName: mod.moduleName === 'Investment Readiness' ? `Investment Readiness (${mod.moduleKey})` : mod.moduleName
                })) : [];
            // Global TempModules (category: 'all') — e.g. Top 10 Investment Readiness
            const tempModulePermissions = company['tempModulePermissions'] && company['tempModulePermissions'].length ? company['tempModulePermissions'].map((mod)=>({
                    checklistModule: true,
                    _id: mod._id,
                    sectionNo: mod.moduleKey,
                    sectionName: mod.moduleName
                })) : [];
            // Combine all permissions — hide Exit Readiness unless company testType is 'exit'
            const combinedPermissions = [
                ...company['sections'],
                ...extraModules,
                ...generateChecklistModules,
                ...tempModulePermissions
            ].filter((section)=>section['sectionName'] !== 'Exit Readiness' || company['testType'] === 'exit');
            setAllPermissions(combinedPermissions);
        }
    }, [
        company?.['sections'],
        company?.['extraModules'],
        company?.['generateChecklistModules'],
        company?.['tempModulePermissions'],
        company?.['testType']
    ]);
    const selectAllPermissions = (event)=>{
        const isChecked = event.target.checked;
        setSelectAll(isChecked);
        let permissions = {};
        allPermissions.forEach((section)=>{
            if (section.sectionNo && section.sectionNo.trim() !== "") permissions[section.sectionNo] = isChecked;
        });
        setEditUser({
            ...editUser,
            permissions: permissions
        });
    };
    const handleUserChange = (e)=>setEditUser({
            ...editUser,
            [e.target.name]: e.target.type === "radio" ? e.target.id : e.target.value
        });
    const changeUser = (e)=>{
        const updatedPermissions = {
            ...editUser.permissions,
            [e.target.name]: e.target.checked
        };
        setEditUser({
            ...editUser,
            permissions: updatedPermissions
        });
    };
    (0, $acw62.useEffect)(()=>{
        // Only redirect to billing if company has NO subscription at all
        // Allow Free and Lite subscriptions to access dashboard (for deferred client activation flow)
        if (user && company && company['_id'] && Object.keys(company).length && (typeof user['companyId'] === "string" && user['companyId'] !== company['_id'] || typeof user['companyId'] === "object" && user['companyId']?._id !== company['_id']) && user['role'] === 'Advisor' && !company['subscription']) {
            navigate(`/billing/${company['_id']}?plan=pro`);
            console.error("Company has no subscription", company['_id'], user['companyId']);
        }
        let checkManualAdd = localStorage.getItem('isManualAdd');
        if (user && user?.['role'] == 'Investor' && company?.['addedByInvestor'] == user?.['_id'] && checkManualAdd) setIsManualAdd(true);
        else setIsManualAdd(false);
    }, [
        user,
        company
    ]);
    (0, $acw62.useEffect)(()=>{
        if (location?.hash) {
            let _tabName = location.hash.replace('#', '');
            if (_tabName === 'company-settings' || _tabName === 'company-audit-log') {
                setDashboardTab('Company');
                setTabName(_tabName);
            }
        }
    }, [
        location?.hash
    ]);
    function hasAllPermissions(companySections, userPermission) {
        return companySections.every((section)=>userPermission[section.sectionNo]);
    }
    (0, $acw62.useEffect)(()=>{
        if (editUser && editUser?.permissions && company && company['memberPermissions']) setSelectAll(hasAllPermissions(company?.['sections'], editUser?.permissions));
    }, [
        editUser,
        company
    ]);
    (0, $acw62.useEffect)(()=>{
        let tabName = window.location.hash.replace('#', '');
        if (tabName) {
            setTabName(tabName);
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                tab: tabName
            }));
        } else dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tab: ''
        }));
    }, []);
    // OPTIMIZATION: Fetch directors and files if not available (excluded in lightweight mode)
    (0, $acw62.useEffect)(()=>{
        const fetchDirectorsAndFiles = async ()=>{
            if (company?._id) {
                // Fetch directors if needed
                if (company?.['directorsCount'] !== undefined && !company?.['directors']) try {
                    const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/directors`);
                    if (response['code'] === 200 && response['body']) setDirectors(response['body']['directors'] || []);
                } catch (e) {
                    console.error('Failed to fetch directors:', e);
                }
                else if (company?.['directors']) setDirectors(company['directors']);
                // Fetch files if needed
                if (company?.['filesCount'] !== undefined && !company?.['files']) try {
                    const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/files`);
                    if (response['code'] === 200 && response['body']) setFiles(response['body']['files'] || []);
                } catch (e) {
                    console.error('Failed to fetch files:', e);
                }
                else if (company?.['files']) setFiles(company['files']);
            }
        };
        fetchDirectorsAndFiles();
    }, [
        company?._id,
        company?.['directors'],
        company?.['files'],
        company?.['directorsCount'],
        company?.['filesCount']
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            const sectionPositions = sectionRefs.current.map((ref)=>{
                const id = ref?.id?.split('.')[0];
                const element = document.getElementById(id);
                const rect = element ? element.getBoundingClientRect() : {
                    top: 0
                };
                return {
                    id: id,
                    top: rect.top
                };
            });
            const currentSection = sectionPositions.find((position)=>position?.['top'] >= 0 && position.top < window.innerHeight);
            if (currentSection) setVisibleSection(currentSection.id);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (user && (Object.keys(user).length == 0 || !user['stripeMethods'])) getUser();
        if (user && user['role'] !== 'Guest') getAdvisors();
        if (!initialized.current) {
            initialized.current = true;
            if (location.pathname.includes('gDriveCallBack')) connectGDrive();
            else if (location.pathname.includes('dropBoxCallBack')) connectDropBox();
            else if (location.pathname.includes('sharePointCallBack')) connectSharePoint();
            else {
                let tabName = window.location.hash.replace('#', '');
                getCompany(tabName, selectedCompany);
                document.querySelectorAll(".sectionWrapper").forEach((el)=>observer.observe(el));
            }
        }
        let isWorkflowTab = localStorage.getItem('isWorkflowTab');
        if (isWorkflowTab) setCompanyDashboardTab('Workflows');
        let isResearchAid = localStorage.getItem('isResearchAid');
        if (isResearchAid) setCompanyDashboardTab('ResearchAid');
        let isAnylistTab = localStorage.getItem('isAnylistTab');
        let isDemoChecklist = localStorage.getItem('isDemoChecklist');
        let isPartnerChecklist = localStorage.getItem('isPartnerChecklist');
        if (isAnylistTab || isDemoChecklist || isPartnerChecklist) setCompanyDashboardTab('AnyLists');
    }, []);
    const hasTriggeredRef = (0, $acw62.useRef)(false); // this ensures one-time trigger
    (0, $acw62.useEffect)(()=>{
        async function fetchData() {
            const stageProgress = selectedCompany['stageProgress'];
            const companyId = company._id;
            if (Object.keys(selectedCompany).length && stageProgress === 'updated' && !hasTriggeredRef.current) {
                hasTriggeredRef.current = true; // prevent future calls
                setShowAlert(true);
                dispatch((0, $12074930bd2c1829$export$4bdbd1eea6fc9500)(true));
                const tab = 'repository';
                // Use lazy-loaded files state instead of company['files']
                let relPaths = [];
                let fileInfo = [];
                for(let i = 0; i < files.length; i++){
                    relPaths[i] = '';
                    fileInfo[i] = files[i];
                }
                const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/matchFiles`, {
                    files: files,
                    companyId: companyId,
                    tab: tab,
                    relPaths: relPaths
                }, true, "noAnimation");
                if (!res?.body?.['report']) return;
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(res.body['report']));
                setCloneImportResult(JSON?.parse(JSON?.stringify(res.body?.['report']?.['importResult'])));
                const allocated = Object.keys(res.body['report']['importResult']).filter((key)=>res.body['report']['importResult'][key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).length;
                const total = Object.keys(res.body['report']['importResult']).length;
                const score = total === 0 ? 0 : Math.round(allocated / total * 100);
                (0, $12074930bd2c1829$export$fb8d60304f3762b3)(score);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'importSummary',
                    from: ''
                }));
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    fileReport: res.body['report'],
                    company: company,
                    tab: tab,
                    underProcessingTab: tab,
                    currentScore: score,
                    reportHistories: reportHistories,
                    profileClass: profileClass
                }));
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                    ...selectedCompany,
                    stageProgress: 'pending'
                }));
                dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
                    syncing: true,
                    message: "Folders are currently creating"
                }));
                setShowAlert(false);
                const syncBody = {
                    newUpgradeSync: true,
                    tab: tab
                };
                if (selectedCompany['foldersPopulated']) {
                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncGDriveDataroom/${companyId}`, syncBody, true);
                    if (tab) reloadModule(tab ?? location.hash, false, false, true, "2");
                    if (!res) return;
                } else if (selectedCompany['dropBoxFoldersPopulated']) {
                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncDropBoxDataroom/${companyId}`, syncBody, true);
                    if (tab) reloadModule(tab ?? location.hash, false, false, true, "3");
                    if (!res) return;
                } else if (selectedCompany['sharePointFoldersPopulated']) {
                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/syncSharePointDataroom/${companyId}`, syncBody, true);
                    if (tab) reloadModule(tab ?? location.hash, false, false, true, "4");
                    if (!res) return;
                }
                dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
                    syncing: false,
                    message: null
                }));
            }
        }
        fetchData();
    }, [
        selectedCompany
    ]);
    (0, $acw62.useEffect)(()=>{
        let isWorkflowTab = localStorage.getItem('isWorkflowTab');
        if (isWorkflowTab) localStorage.removeItem('isWorkflowTab');
        let isResearchAid = localStorage.getItem('isResearchAid');
        if (isResearchAid) localStorage.removeItem('isResearchAid');
        localStorage.removeItem('isAnylistTab');
        setInvestorFirmCounts({
            gold: 0,
            silver: 0,
            bronze: 0,
            threshold: 0
        });
    }, [
        tab,
        companyDashboardTab,
        dashboardTab
    ]);
    (0, $acw62.useEffect)(()=>{
        if (user?.['type'] == 'Superflow' && user?.['partnerId']) getPartner(user?.['partnerId']);
        if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile br100' : 'client-profile');
    }, [
        user
    ]);
    const getPartner = async (id)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/${id}`);
        if (res['code'] == 200) dispatch((0, $3d3d7a2ee763f32a$export$6af6109222273956)(res['body']));
    };
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('aireport:generated', async (data)=>{
            if (data['moduleType']) setModuleAI(data['moduleType']);
            if (data['userId'] == user['_id']) {
                // setTab(tab, true); // Get updated AI Report from Server
                setAiEnchaned(true);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(data['message']);
                if (!tab.match(/two-minute-test-.*-report/)) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'completeAIReport'
                }));
            }
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('Sync', async (data)=>{
            dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
                syncing: false,
                message: null
            }));
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(data['message']);
        });
    }, [
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)
    ]);
    // TODO: Check if the data exists
    (0, $acw62.useEffect)(()=>{
        location.hash = tab;
        window.scroll(0, 450);
        if (tab.endsWith("-report")) setIsPrePopulate(false);
        if (tab == 'checklist-tasks' && checklistTask.length == 0) getChecklistTask(tab);
        if (tab == 'company-audit-log' && Object.values(auditReportLogs).length == 0) getChangeReports(tab);
        if (tab == 'diligence-pack-reporting' && Object.values(selectedModules).length == 0) getCompanyByModules(tab);
        if (tab && tab.includes('two-minute-test') && user?.['role'] == 'Guest' && !user.firstName) return setIsTwoMinuteTesHomePage(true);
        else setIsTwoMinuteTesHomePage(false);
        if (tab && tab.includes('directors-questionnaire')) Array.from(openTabs).map(async (openTab)=>{
            if (openTab.includes('directors-questionnaire')) {
                await openTabs.delete(openTab);
                setOpenTabs(new Set(Array.from(openTabs)));
            // if (tab === openTab) await setTab("");
            }
        });
        if (tab && tab !== 'fit-report') setOpenTabs((prev)=>new Set([
                ...prev,
                $cb3ceb5821786f07$var$decodeTabValue(tab)
            ]));
        if (tab == '' && window.location.pathname.includes('company')) {
            if (user['role'] != 'Guest' && modal?.['open'] !== 'setPasswordPopup') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            setCompanyIndex(true);
        } else setCompanyIndex(false);
        let isWorkflowOpen = localStorage.getItem('isWorkflowOpen');
        let isAnylistBuilder = localStorage.getItem('isAnylistBuilder');
        let isDiligencePack = localStorage.getItem('isDiligencePack');
        let isDemoChecklist = localStorage.getItem('isDemoChecklist');
        let isPartnerChecklist = localStorage.getItem('isPartnerChecklist');
        if (isAnylistBuilder || isDemoChecklist || isPartnerChecklist || isDiligencePack) {
            setCompanyIndex(true);
            if (user['role'] == 'Investor' && (tab == 'diligence-pack' || tab.includes('fit-report'))) setIsClientIndex(false);
        }
        if (isWorkflowOpen) setTimeout(()=>{
            setIsWorkflowReport(true);
            localStorage.removeItem('isWorkflowOpen');
        }, 100);
    }, [
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        if (user['role'] == 'Advisor' && company['advisors'] && company['advisors']?.[user['_id']] && company['advisors']?.[user['_id']]?.['type']) {
            permissionLevel = company['advisors']?.[user['_id']]?.['type'];
            setPermissionLevel(permissionLevel);
        }
        if (user['role'] == 'Investor' && company['investors'] && company['investors']?.[user['_id']] && company['investors']?.[user['_id']]?.['type']) {
            permissionLevel = company['investors']?.[user['_id']]?.['type'];
            setPermissionLevel(permissionLevel);
        }
        if (company?.['cLevel'] == 'Bronze') setLinearProgress(50);
        else if (company?.['cLevel'] == 'Silver') setLinearProgress(75);
        else if (company?.['cLevel'] == 'Gold') setLinearProgress(100);
        else setLinearProgress(25);
        // Get Investor Matches for Superflow Popup
        if (user?.['type'] == 'Superflow' && tab == 'investor-lead') {
            if (company?.['modules']?.['investor-lead']) {
                let sections = company?.['modules']?.['investor-lead']?.['sections'][0]?.['subFolders'];
                if (Object.values(sections)?.length > 0) {
                    let completedSections = Object.values(sections).filter((section)=>(section?.['sectionNo'] == 'DEPF008.1' || section?.['sectionNo'] == 'DEPF008.2') && section?.['stats']?.['completionPercent'] == 100).map((section)=>section?.['sectionNo']);
                    if (isGetInvestorMatches && completedSections?.length == 2 && completedSections?.includes('DEPF008.1') && completedSections?.includes('DEPF008.2')) {
                        setIsGetInvestorMatches(false);
                        getFitInvestorFirms();
                    }
                }
            }
        }
        if (user?.['role'] == 'Advisor' || user?.['role'] == 'Investor') {
            if (user?.['companyId']?.['_id'] == company?.['_id']) setIsShowTeamTab(false);
            else setIsShowTeamTab(true);
        }
    }, [
        company
    ]);
    const handleSuperFlowPopup = async ()=>{
        if (partner?.['name'] == 'Climb26 Super Flow' || partner?.['name'] == 'EHE Super Flow') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'applyInvestorMatchPopup'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'superFlowPopup'
        }));
    };
    const handleActivateClientLogin = async (companyId)=>{
        try {
            setActivatingClient(companyId);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/activateClientLogin/${companyId}`, {});
            if (response?.['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Client login activated successfully');
                getCompany();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Failed to activate client login');
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while activating client login');
        } finally{
            setActivatingClient(null);
        }
    };
    const getCompany = async (tabName, _company)=>{
        let reset = false;
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        if (tabName && tabName.includes('%20')) {
            tabName = tabName.replaceAll('%20', ' ');
            reset = true;
        }
        let res = '';
        let moduleName = tabName ? $cb3ceb5821786f07$export$57c43fe781091dc0(tabName) : window.location.href.includes("#") ? window.location.hash.substring(1) : undefined;
        setIsLoader({
            show: true,
            message: 'Loading...'
        });
        if (reset || moduleName && (Object.keys(moduleContent).includes(moduleName) || moduleName.includes('directors-questionnaire'))) {
            let checkManualAdd = localStorage.getItem('isManualAdd');
            let query = `?moduleName=${moduleName}`;
            if (checkManualAdd && user && user?.['role'] == 'Investor' && moduleName == 'investor-lead') query = `?moduleName=${moduleName}&tags=short-investor-lead`;
            res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}${query}`);
        } else res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}`);
        if (selectedCompany['stageProgress'] === 'updated') res['body']['stageProgress'] = 'updated';
        setIsLoader({
            show: false,
            message: 'Loading...'
        });
        if (res['code'] == 200) {
            !res['body']['firstVisitRepository'] && moduleName && moduleName.toLowerCase() === "repository" && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'firstSetupDataRepository'
            }));
            res['body']['modules']['kpi'] = {
                type: "kpi",
                sections: []
            };
            for (let module of Object.values(res['body']['modules'])){
                let content = module['type'].includes('directors-questionnaire') ? moduleContent['directors-questionnaire'] : moduleContent[module['type']];
                if (content) {
                    module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
                    module['aiEnhanced'] = content['aiEnhanced'];
                    module['subheading'] = content['subHeading'];
                    module['uploadFiles'] = content['uploadFiles'];
                    if (!module['uploadFiles'] && content['heading'] === "Repository") module['uploadFiles'] = true;
                }
            }
            res['body']['modules']['unaudited-certification'] = moduleContent['unaudited-certification'];
            if (!moduleName && _company?.['modules'] && companyId === _company._id) res['body']['modules'] = _company['modules'];
            const resultArray = Object.entries(res['body']['modules']).filter(([key, value])=>value?.stats?.completionScore > 0).map(([key])=>key);
            setUserModules(resultArray);
            await dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...res['body'],
                from: 434
            }));
            if (moduleName && moduleName.toLowerCase() === "repository" && !res?.['body']?.['stats']?.['completionScore'] && res['body']['subscription'] != 'Free') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'dataRepository'
            }));
            setCompanyId(companyId);
            localStorage.setItem('companyId', companyId);
            if (tabName) setTab(tabName, reset);
        }
    };
    const getCompanyByModules = async (tabName)=>{
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        let moduleName = tabName && $cb3ceb5821786f07$export$57c43fe781091dc0(tabName);
        if (Object.values(selectedModules).length == 0) {
            let res = '';
            setIsLoader({
                show: true,
                message: 'Loading...'
            });
            if (userModules && (Object.keys(moduleContent).includes(userModules) || userModules.includes('directors-questionnaire'))) res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}?moduleName=${moduleName}`);
            else res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/allReports/${companyId}`);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
            if (res['code'] == 200) {
                for (let module of Object.values(res['body'])){
                    let content = module['type'].includes('directors-questionnaire') ? moduleContent['directors-questionnaire'] : moduleContent[module['type']];
                    if (content) {
                        module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
                        module['aiEnhanced'] = content['aiEnhanced'];
                        module['subheading'] = content['subHeading'];
                        module['uploadFiles'] = content['uploadFiles'];
                    }
                }
                await setSelectedModules(res['body']);
                await setCompanyId(companyId);
                localStorage.setItem('companyId', companyId);
            }
        }
        setTabName(tabName);
    };
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        if (response && response['code'] == 200) {
            let user = response?.['body']?.['user'];
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
        }
    };
    const getAdvisors = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/getAdvisor`);
        if (response['code'] == 200 && response['body']) {
            setAdvisors(response['body']['advisors']);
            setInvestors(response['body']['investors']);
        }
    };
    const getFitInvestorFirms = async (isNavigate)=>{
        let clientId = location.pathname.split('/')[2];
        if (!clientId) clientId = company['_id'];
        if (clientId) {
            let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFitInvestorFirms/${clientId}`);
            if (response['code'] == 200 && response['body']) {
                if (response['message'] && user['type'] != 'Superflow' && isNavigate) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                if (Array.isArray(response['body'])) {
                    setFitInvestorFirms(response['body']);
                    const disqualifiedFirms = response['body'].reduce((acc, firm)=>{
                        if (firm['requiredLevel']) acc[firm['requiredLevel'].toLowerCase()] += 1;
                        return acc;
                    }, {
                        gold: 0,
                        silver: 0,
                        bronze: 0,
                        threshold: 0
                    });
                    setInvestorFirmCounts(disqualifiedFirms);
                }
                if (user['type'] != 'Superflow' && isNavigate) setCompanyDashboardTab('InvestorMatch');
            }
        }
    };
    const getChangeReports = async (tabName)=>{
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        if (Object.values(auditReportLogs).length == 0) {
            setIsLoader({
                show: true,
                message: 'Loading...'
            });
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/log/changeReports/${companyId}`);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
            if (res['code'] == 200) {
                await setAuditReportLogs(res['body']);
                await setCompanyId(companyId);
                localStorage.setItem('companyId', companyId);
            }
        }
        setTabName(tabName);
    };
    const getChecklistTask = async (tabName)=>{
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/task/get/${companyId}`);
        if (res['code'] == 200) {
            await setChecklistTask(res['body']);
            await setCompanyId(companyId);
            localStorage.setItem('companyId', companyId);
        }
        setTabName(tabName);
    };
    const downloadPDF = async ()=>{
        try {
            setIsLeadPdf(true);
            const wrapper = document.getElementById("leadsPDF");
            wrapper.classList.remove("db");
            wrapper.classList.remove("h60vh");
            wrapper.classList.remove("oa");
            // const filename = 'Curated Investor Leads';
            const filename = [
                `DG-InvestorLeads-${company['cName'].substring(0, 7)}-${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now()).format("ll")}`
            ].join(" - ");
            const opt = {
                filename: filename,
                jsPDF: {
                    unit: 'mm',
                    format: 'a2',
                    orientation: 'p'
                }
            };
            await (0, (/*@__PURE__*/$parcel$interopDefault($8994635913a5668f$exports)))().set(opt).from(wrapper).save();
            wrapper.classList.add("db");
            wrapper.classList.add("h60vh");
            wrapper.classList.add("oa");
            setTimeout(()=>setIsLeadPdf(false), 1000);
        } catch (e) {
            console.error(e);
        }
    };
    const setTab = async (tabName, reset, isAfterSync, firstVisitRepository, companyNotFetch, check)=>{
        if (tabName == "diligence-pack-reporting") return getCompanyByModules(tabName);
        if (tabName == "company-audit-log") return getChangeReports(tabName);
        if (tabName == "checklist-tasks") return getChecklistTask(tabName);
        let moduleName = tabName && $cb3ceb5821786f07$export$57c43fe781091dc0(tabName);
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tab: moduleName
        }));
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        let finalUpdatedData = {};
        const _moduleSections = selectedCompany['modules']?.[moduleName]?.['sections'];
        // Call getModule when: module is in store but sections are empty (e.g. duplicate moduleId mismatch),
        // OR module is in store with sections but questions not yet loaded.
        const _moduleInStore = !!(moduleName && selectedCompany['modules']?.hasOwnProperty(moduleName));
        const _needsLoad = tabName && _moduleInStore && (!_moduleSections?.length || !_moduleSections[0]?.['questions']);
        if (reset || _needsLoad) {
            setIsLoader({
                show: true,
                message: 'Loading...'
            });
            let obj = {
                companyId: companyId,
                moduleName: moduleName
            };
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getModule`, obj);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
            if (response['code'] != 200) return;
            // Read latest from store after await to avoid stale closure (company/selectedCompany may have been {} when setTab was called)
            const { selectedCompany: latestSelectedCompany } = store.getState().company;
            const latestCompany = {
                ...latestSelectedCompany
            };
            !latestSelectedCompany['firstVisitRepository'] && moduleName && moduleName.toLowerCase() === "repository" && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'firstSetupDataRepository'
            }));
            if (response && response?.body?.[moduleName]) {
                finalUpdatedData = {
                    ...latestSelectedCompany,
                    ...latestCompany,
                    modules: {
                        ...latestSelectedCompany['modules'],
                        [moduleName]: {
                            ...latestSelectedCompany['modules']?.[moduleName],
                            ...response['body'][moduleName],
                            ...latestSelectedCompany['modules']?.[moduleName]['questions'] ? {
                                questions: latestSelectedCompany['modules']?.[moduleName]['questions']
                            } : {},
                            ...moduleName === "repository" && {
                                uploadFiles: true
                            }
                        }
                    },
                    from: "543"
                };
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(finalUpdatedData));
            }
            let data = {};
            if (isAfterSync == true) {
                const dataList = [
                    'lastSyncBy',
                    'lastSyned',
                    'unallocatedFiles'
                ];
                response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getData`, {
                    companyId: companyId,
                    dataList: dataList
                });
                if (response && response['code'] === 200) {
                    for (const dataItem of dataList)if (dataItem in response['body'] && response['body'][dataItem] !== undefined) data = {
                        ...data,
                        [dataItem]: response['body'][dataItem]
                    };
                }
                if (!companyNotFetch) getCompany(tabName, latestSelectedCompany);
            }
            if (tabName && tabName !== "investor-lead") finalUpdatedData = calculateStats(finalUpdatedData, tabName);
            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...latestSelectedCompany,
                ...finalUpdatedData,
                ...data,
                syncRequired: false,
                from: "576"
            }));
        }
        if (tabName) {
            setCompanyDashboardTab('Dashboard');
            setTabName(tabName);
        }
        if (moduleName == 'investor-lead') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const reloadModule = (resetTab, isAfterSync, hideFisrtTime = false, companyNotFetch, check)=>setTimeout(()=>setTab(resetTab, true, isAfterSync, hideFisrtTime, companyNotFetch, check), 1000);
    const handleCloseReportToRepository = (0, $acw62.useCallback)((anchorOverride)=>{
        const anchor = anchorOverride || lastReportAnchorRef.current || (()=>{
            try {
                return localStorage.getItem('lastReportAnchor');
            } catch (_) {
                return null;
            }
        })();
        setTab('repository');
        setTabName('repository');
        window.location.hash = '#repository';
        setOpenTabs((prev)=>{
            const next = new Set(prev);
            next.add('repository');
            return next;
        });
        setTimeout(()=>{
            const targetId = anchor || (()=>{
                try {
                    return localStorage.getItem('lastReportAnchor');
                } catch (_) {
                    return null;
                }
            })();
            if (targetId) {
                const el = document.getElementById(targetId);
                if (el && el.scrollIntoView) el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }, 500);
    }, [
        setTab,
        setTabName,
        setOpenTabs
    ]);
    (0, $acw62.useEffect)(()=>{
        let moduleName = tab && $cb3ceb5821786f07$export$57c43fe781091dc0(tab);
        if (moduleName == 'repository' && Object.keys(selectedCompany).length && !selectedCompany['firstVisitRepository']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'firstSetupDataRepository'
        }));
    }, [
        selectedCompany
    ]);
    const moveToCompanyPage = (isTempCompany)=>{
        let { state: state } = urlSearchData(location['search']);
        let [companyId, verifier] = parseState(state);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        window.location.href = `${$16250bd714b02a14$export$240514314008da16.split('/')[1]}/${companyId}#repository`;
    };
    const connectGDrive = ()=>{
        let { code: code, state: companyId } = urlSearchData(location['search']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectingDataRoom'
        }));
        window.localStorage.removeItem('fromTempCompany');
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectGDrive`, {
            code: code,
            companyId: companyId
        }).then((response)=>{
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'createdDataRoom'
                }));
                setTimeout(()=>moveToCompanyPage(true), 1000);
            } else setTimeout(()=>moveToCompanyPage(true), 1000);
        }).catch((e)=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create Google Drive folders'));
    };
    const connectDropBox = async ()=>{
        let { code: code, state: companyId } = urlSearchData(location['search']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectingDataRoom'
        }));
        window.localStorage.removeItem('fromTempCompany');
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectDropBox`, {
            code: code,
            companyId: companyId
        }).then((response)=>{
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'createdDataRoom'
                }));
                setTimeout(()=>moveToCompanyPage(true), 1000);
            } else // showMessage(response['message']);
            setTimeout(()=>moveToCompanyPage(true), 1000);
        }).catch((error)=>{
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create Dropbox folders');
        });
    };
    const connectSharePoint = async ()=>{
        let { code: code, state: state, client_info: client_info } = urlSearchData(location['search']);
        const [companyId, verifier] = parseState(state);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectingDataRoom'
        }));
        window.localStorage.removeItem('fromTempCompany');
        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectSharePoint`, {
            code: code,
            companyId: companyId,
            client_info: client_info,
            verifier: verifier
        }, true, false, true).then(async (response)=>{
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'createdDataRoom'
                }));
                setTimeout(()=>moveToCompanyPage(true), 1000);
            }
            if (response?.message.includes("only supports Company")) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'notSupportPersonalAccount'
            }));
        }).catch((error)=>{
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create SharePoint folders');
        });
    };
    const urlSearchData = (searchString)=>{
        if (!searchString) return {};
        return searchString.substring(1).split('&').reduce((result, next)=>{
            let pair = next.split('=');
            result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            return result;
        }, {});
    };
    const parseState = (state)=>{
        if (state.length > 25) {
            const decode = (0, (/*@__PURE__*/$parcel$interopDefault($6u4NZ))).decode(state);
            return decode.split("==");
        }
        return [
            state,
            ""
        ];
    };
    const handleMemberEdit = (user)=>{
        user['permissions'] = company['memberPermissions'][user['_id']];
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'editUser'
        }));
        setEditUser(user);
        setUserAction('Edit');
    };
    const resendInviteMember = async (memberId)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/resendInvite', {
            companyId: companyId,
            memberId: memberId
        });
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const handleDeleteMember = (userId)=>{
        setDeleteMemberId(userId);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'deleteMember'
        }));
    };
    const submitDeleteMember = async ()=>{
        if (deleteMemberId !== '') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/deleteMember', {
                companyId: companyId,
                userId: deleteMemberId
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            if (!res || res['code'] != 200) return;
            getCompany();
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const openKPI = async ()=>{
        try {
            // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array (excluded in lightweight mode)
            const hasKPIs = company['kpiCount'] !== undefined ? company['kpiCount'] > 0 : company['keyPerformanceIndicators'] && Object.values(company['keyPerformanceIndicators']).length > 0;
            if (!hasKPIs) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('We are generating your KPI report, please wait!');
                let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/generateKPI/${companyId}`);
                if (res['code'] == 200) await getCompany();
            }
            await setIsViewTwoMinuteReport(true);
            setTab("kpi-report");
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/generateAIReport/${company['_id']}`, {
                module: `two-minute-test-${company?.['testType']}`
            });
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Unable to generate KPI');
        }
    };
    const linksToCloseTab = ()=>{
        if ((user?.['role'] == 'Investor' || user?.['role'] == 'Advisor') && company?.['_id'] != user?.['companyId']?.['_id'] && tab == 'diligence-pack') return `/investor-dashboard`;
        else if ((window.location.href.includes('fit-report') || tab.includes('fit-report')) && user['role'] == 'Investor') return `/company/${companyId}#diligence-pack`;
        else return window.location.pathname;
    };
    const closeTab = (e, openTab)=>{
        if ((user?.['role'] == 'Investor' || user?.['role'] == 'Advisor') && company?.['_id'] != user?.['companyId']?.['_id'] && tab == 'diligence-pack') return navigate(`/investor-dashboard`);
        if ((window.location.href.includes('fit-report') || tab.includes('fit-report')) && user['role'] == 'Investor') {
            navigate(`/company/${companyId}#diligence-pack`);
            setTab('diligence-pack');
            return;
        }
        localStorage.removeItem('isDiligenceReport');
        if (e?.stopPropagation) e.stopPropagation();
        openTabs.delete(openTab);
        setOpenTabs(new Set(Array.from(openTabs)));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setAiEnchaned(false);
        if (tab === openTab) setTabName('');
    };
    const setCertificateSeeMore = async ()=>{
        let seeMore = {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "51",
                height: "65",
                viewBox: "0 0 51 65",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M47.0127 19.2576C46.1594 18.4418 45.2769 17.5983 44.9976 16.9214C44.6908 16.1778 44.716 14.9085 44.7405 13.6812C44.7839 11.5015 44.8331 9.03118 43.1542 7.3442C41.4723 5.65418 38.9981 5.69252 36.817 5.72756C35.592 5.74673 34.3245 5.76692 33.584 5.45829C32.9072 5.1762 32.0659 4.29285 31.2523 3.4387C29.7169 1.82688 27.977 0 25.498 0C23.0189 0 21.279 1.82688 19.7438 3.43857C18.9302 4.29285 18.0889 5.1762 17.4121 5.45816C16.6717 5.76679 15.4042 5.74673 14.1792 5.72731C11.9962 5.69392 9.52378 5.65406 7.84202 7.34395C6.16291 9.03092 6.21217 11.5013 6.25559 13.681C6.27996 14.9085 6.30536 16.1778 5.99863 16.9212C5.7192 17.5982 4.83674 18.4418 3.98335 19.2575C2.37623 20.7939 0.554688 22.5351 0.554688 25.011C0.554688 27.4868 2.37623 29.2282 3.98335 30.7643C4.83674 31.5801 5.7192 32.4236 5.99851 33.1005C6.30536 33.8441 6.28009 35.1134 6.25559 36.3409C6.21217 38.5205 6.16304 40.9908 7.84189 42.6779C8.90031 43.7414 10.2723 44.1202 11.6877 44.2464V63.0965C11.6877 63.7357 12.0084 64.3322 12.5416 64.6848C13.0746 65.0375 13.7493 65.0991 14.3374 64.849L25.498 60.1023L36.6587 64.849C36.8979 64.9507 37.1513 65.0008 37.4038 65.0008C37.772 65.0008 38.1381 64.8941 38.4544 64.6848C38.9874 64.3323 39.3083 63.7357 39.3083 63.0965V44.2469C40.7237 44.1207 42.0955 43.7417 43.154 42.6784C44.8331 40.9914 44.7838 38.5209 44.7404 36.3413C44.716 35.1138 44.6906 33.8445 44.9973 33.1012C45.2768 32.4241 46.1592 31.5805 47.0126 30.7648C48.6197 29.2284 50.4413 27.4872 50.4413 25.0114C50.4413 22.5355 48.6199 20.794 47.0127 19.2576ZM26.2432 56.2806C25.7671 56.0779 25.2288 56.0779 24.7528 56.2806L15.4964 60.2173V44.2896C16.251 44.3044 16.9392 44.3671 17.4121 44.564C18.0889 44.8461 18.9302 45.7295 19.7438 46.5836C21.279 48.1954 23.0189 50.0223 25.498 50.0223C27.977 50.0223 29.7169 48.1954 31.2521 46.5838C32.0657 45.7295 32.9071 44.8461 33.5839 44.5642C34.0569 44.367 34.745 44.3042 35.4996 44.2893V60.2172L26.2432 56.2806ZM44.3809 28.0117C43.2414 29.1008 42.0633 30.227 41.4768 31.6483C40.8669 33.1262 40.9003 34.7992 40.9325 36.4172C40.9608 37.839 40.9929 39.4507 40.4544 39.9916C39.914 40.5345 38.3005 40.5095 36.8767 40.4868C35.2616 40.4616 33.5914 40.4352 32.1189 41.0485C30.702 41.6389 29.5796 42.8174 28.494 43.9571C27.4865 45.0148 26.3447 46.2137 25.4977 46.2137C24.6508 46.2137 23.509 45.0147 22.5013 43.9569C21.4159 42.8173 20.2935 41.6389 18.8765 41.0484C17.6995 40.5581 16.3964 40.4765 15.0958 40.4765C14.7694 40.4765 14.4429 40.4817 14.1189 40.4868C12.695 40.509 11.0815 40.5346 10.5411 39.9916C10.0028 39.4505 10.0349 37.8391 10.0631 36.4172C10.0953 34.7992 10.1287 33.126 9.51871 31.648C8.9323 30.227 7.75416 29.1008 6.61474 28.0115C5.55924 27.0026 4.36295 25.859 4.36295 25.0112C4.36295 24.1634 5.55924 23.0197 6.61474 22.0108C7.75416 20.9216 8.9323 19.7954 9.51883 18.3742C10.1287 16.8963 10.0953 15.2233 10.0631 13.6052C10.0348 12.1833 10.0027 10.5716 10.5412 10.0307C11.0816 9.48783 12.6959 9.51297 14.1188 9.5357C15.7348 9.56083 17.4044 9.58737 18.8768 8.97379C20.2936 8.38358 21.416 7.20506 22.5015 6.06539C23.5091 5.00748 24.6511 3.80864 25.498 3.80864C26.3449 3.80864 27.4869 5.00748 28.4944 6.06526C29.5798 7.20506 30.7022 8.38346 32.1191 8.97367C33.5916 9.58724 35.2614 9.56045 36.8771 9.53557C38.3009 9.51335 39.9143 9.48796 40.4548 10.0307C40.9931 10.5716 40.9609 12.1832 40.9328 13.6051C40.9005 15.223 40.8671 16.8962 41.4771 18.3742C42.0635 19.7952 43.2417 20.9214 44.3811 22.0106C45.4366 23.0196 46.6329 24.1633 46.6329 25.0111C46.6329 25.8589 45.4365 27.0026 44.3809 28.0117Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M25.4974 11.1484C17.9579 11.1484 11.8242 17.2991 11.8242 24.8594C11.8242 32.4197 17.9579 38.5705 25.4974 38.5705C33.0368 38.5705 39.1705 32.4198 39.1705 24.8595C39.1705 17.2993 33.0368 11.1484 25.4974 11.1484ZM25.4974 34.7619C20.058 34.7619 15.6329 30.3197 15.6329 24.8595C15.6329 19.3994 20.058 14.9572 25.4974 14.9572C30.9367 14.9572 35.3619 19.3994 35.3619 24.8595C35.3619 30.3197 30.9367 34.7619 25.4974 34.7619Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M27.733 21.2648L24.2814 24.7165L23.2665 23.7016C22.5229 22.958 21.3171 22.958 20.5734 23.7016C19.8297 24.4452 19.8297 25.651 20.5734 26.3947L22.9349 28.7562C23.292 29.1133 23.7763 29.314 24.2814 29.314C24.7864 29.314 25.2709 29.1134 25.6279 28.7562L30.426 23.9579C31.1697 23.2142 31.1697 22.0085 30.426 21.2648C29.6824 20.5211 28.4766 20.5211 27.733 21.2648Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Diligentsia ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Certification"
                ]
            }),
            points: [
                'Complete modules',
                'Completeness and risk scoring',
                'Unaudited certification:',
                "Gold certification \u2013 opens up access to InvestorMatch",
                'Digital certification valid for 3 months',
                'Or, with Diligentsia Pro PLUS, have your lawyer or accountant assist and provide you an audited certificate'
            ],
            subMenu: {
                index: 2,
                points: [
                    "- Bronze \u2013 basic level reached",
                    "- Silver \u2013 potentially investible",
                    "- Gold \u2013 sophisticated"
                ]
            },
            image: (parcelRequire("9WBs6"))
        };
        await setSelectedSeeMore(seeMore);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'seeMorePopup'
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (modal.resetTab) {
            openTabs.delete('repository');
            if (!openTabs.has(tab)) setOpenTabs(new Set(Array.from(openTabs)));
            if (tab === 'repository') setTab('');
            dispatch((0, $ee5327cdf6cdce8c$export$c42821355a5f8135)(false));
        }
    }, [
        modal.resetTab
    ]);
    const toggleReport = async (e, reportType)=>{
        if (tab.endsWith("-report")) {
            closeTab(e, tab);
            if (tab === "kpi-report") {
                if (user['role'] == 'Guest') setTab("two-minute-test-" + company.testType);
                else setTab('');
            } else {
                if (tab == `business-audit-${company['testType']}`) enableAIEnhancedReporting();
                if (permissionLevel != 'DASHBOARD & REPORT') await setTab((reportType || tab).replace(/(-sync)?-report$/, ""));
            // navigate(`#${(reportType || tab).replace(/(-sync)?-report$/, "")}`);
            }
        } else {
            // navigate(`#${tab}-report`);
            if (tab == `business-audit-${company['testType']}`) enableAIEnhancedReporting();
            setTab(reportType || tab + "-report");
            scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        e.target.innerText = tab.endsWith("-report") ? e.target.innerText.replace("CLOSE", "VIEW") : e.target.innerText.replace("VIEW", "CLOSE");
    };
    const twoMinuteTestAIReport = async (module)=>{
        if (tab.includes('two-minute-test') && module['stats']['completionPercent'] < 100) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please complete the Test!');
        else enableAIEnhancedReporting();
    };
    const enableAIEnhancedReporting = async ()=>{
        if (aiEnhanced) {
            if (!tab.includes("report")) setTab(tab + "-report");
            if (user['role'] == 'Guest' || tab == 'kpi-report') setTab(`two-minute-test-${company?.['testType']}-report`);
            if (user['role'] == 'Guest' && tab.includes('two-minute-test')) setOpenTabs((prevTabs)=>{
                const updatedTabs = new Set(prevTabs);
                const tabName = `two-minute-test-${company?.['testType']}-report`;
                updatedTabs.add(tabName);
                return updatedTabs;
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('AI Report Generated. Check AI Enhanced Recommendations.');
            return;
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatingAIReport'
        }));
        let module;
        if (user['role'] == 'Guest' || tab == 'kpi-report') module = `two-minute-test-${company?.['testType']}`;
        else module = tab.replace('-report', '');
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/generateAIReport/${company['_id']}`, {
            module: module
        });
        if (response['code'] == 400) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const calculateCertification = (company)=>{
        let auditType = 'business-audit-' + company['testType'];
        let points = {
            'Bronze': {},
            'Silver': {},
            'Gold': {}
        }, extraModules = {
            'Bronze': {},
            'Silver': {},
            'Gold': {}
        };
        let data = {
            'repository': {
                // completeness: 75,
                'completeness': company['modules']?.['repository']?.['stats']?.['completionPercent'] || 0
            },
            'business-audit': {
                'risk': company['modules']?.[auditType]?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules']?.[auditType]?.['stats']?.['completionPercent'] || 0
            },
            'warranty-disclosure': {
                'completeness': company['modules']?.['warranty-disclosure']?.['stats']?.['completionPercent'] || 0
            },
            'directors-questionnaire': {
                'risk': company?.['directorsStats']?.['riskPercent'] || 0,
                'completeness': company?.['directorsStats']?.['completionPercent'] || 0
            },
            'esg': {
                'risk': company['modules']?.['esg']?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules']?.['esg']?.['stats']?.['completionPercent'] || 0
            },
            'software-development': {
                'risk': company['modules']?.['software-development']?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules']?.['software-development']?.['stats']?.['completionPercent'] || 0
            },
            'two-minute-test': {
                'risk': company['modules'][`two-minute-test-${company['testType']}`]?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules'][`two-minute-test-${company['testType']}`]?.['stats']?.['completionPercent'] || 0
            }
        };
        for (let [moduleKey, object] of Object.entries(company['modules']))if (!data[moduleKey]) {
            data[moduleKey] = {
                completeness: object?.['stats']?.['completionPercent'] || 0,
                risk: object?.['stats']?.['riskPercent'] || 0
            };
            points['Bronze'][moduleKey] = data[moduleKey]['completeness'] >= 60 && data[moduleKey]['risk'] <= 60;
            points['Silver'][moduleKey] = data[moduleKey]['completeness'] >= 80 && data[moduleKey]['risk'] <= 40;
            points['Gold'][moduleKey] = data[moduleKey]['completeness'] == 100 && data[moduleKey]['risk'] <= 30;
            company['moduleCertification'] = {
                ...company['moduleCertification'],
                [moduleKey]: points['Gold'][moduleKey] ? 'Gold' : points['Silver'][moduleKey] ? 'Silver' : points['Bronze'][moduleKey] ? 'Bronze' : 'None'
            };
        }
        points['Bronze']['p1'] = data['repository']['completeness'] >= 75;
        points['Bronze']['p2'] = data['business-audit']['completeness'] >= 75 && data['business-audit']['risk'] <= 50;
        points['Bronze']['status'] = points['Bronze']['p1'] && points['Bronze']['p2'] ? 'complete-button' : points['Bronze']['p1'] || points['Bronze']['p2'] ? 'inprogrees-btn' : 'noy-yet-btn';
        points['Bronze']['active'] = points['Bronze']['status'] == 'complete-button';
        extraModules['Bronze']['p1'] = data['esg']['completeness'] >= 75 && data['esg']['risk'] <= 50;
        extraModules['Bronze']['p2'] = data['software-development']['completeness'] >= 75 && data['software-development']['risk'] <= 50;
        points['Silver']['p1'] = data['repository']['completeness'] >= 90;
        points['Silver']['p2'] = data['business-audit']['completeness'] >= 90 && data['business-audit']['risk'] <= 50;
        points['Silver']['p3'] = data['warranty-disclosure']['completeness'] >= 75;
        points['Silver']['p4'] = data['directors-questionnaire']['completeness'] >= 75 && data['directors-questionnaire']['risk'] <= 50;
        points['Silver']['status'] = points['Silver']['p1'] && points['Silver']['p2'] && points['Silver']['p3'] && points['Silver']['p4'] ? 'complete-button' : points['Silver']['p1'] || points['Silver']['p2'] || points['Silver']['p3'] || points['Silver']['p4'] ? 'inprogrees-btn' : 'noy-yet-btn';
        points['Silver']['active'] = points['Silver']['status'] == 'complete-button';
        extraModules['Silver']['p1'] = data['esg']['completeness'] >= 90 && data['esg']['risk'] <= 50;
        extraModules['Silver']['p2'] = data['software-development']['completeness'] >= 90 && data['software-development']['risk'] <= 50;
        points['Gold']['p1'] = data['repository']['completeness'] == 100;
        points['Gold']['p2'] = data['business-audit']['completeness'] == 100 && data['business-audit']['risk'] <= 25;
        points['Gold']['p3'] = data['warranty-disclosure']['completeness'] >= 90;
        points['Gold']['p4'] = data['directors-questionnaire']['completeness'] >= 90 && data['directors-questionnaire']['risk'] <= 50;
        points['Gold']['status'] = points['Gold']['p1'] && points['Gold']['p2'] && points['Gold']['p3'] && points['Gold']['p4'] ? 'complete-button' : points['Gold']['p1'] || points['Gold']['p2'] || points['Gold']['p3'] || points['Gold']['p4'] ? 'inprogrees-btn' : 'noy-yet-btn';
        points['Gold']['active'] = points['Gold']['status'] == 'complete-button';
        extraModules['Gold']['p1'] = data['esg']['completeness'] == 100 && data['esg']['risk'] <= 25;
        extraModules['Gold']['p2'] = data['software-development']['completeness'] == 100 && data['software-development']['risk'] <= 25;
        company['points'] = points;
        let cLevel = points['Bronze']['active'] && points['Silver']['active'] && points['Gold']['active'] ? 'Gold' : points['Bronze']['active'] && points['Silver']['active'] ? 'Silver' : points['Bronze']['active'] ? 'Bronze' : 'None';
        company['cLevel'] = cLevel;
        company['certificateNext'] = cLevel == 'Gold' ? 'All Done' : cLevel == 'Silver' ? 'Gold' : cLevel == 'Bronze' ? 'Silver' : cLevel == 'None' ? 'Bronze' : 'None';
        company['moduleCertification'] = {
            ...company['moduleCertification'],
            'repository': points['Gold']['p1'] ? 'Gold' : points['Silver']['p1'] ? 'Silver' : points['Bronze']['p1'] ? 'Bronze' : 'None',
            'business-audit': points['Gold']['p2'] ? 'Gold' : points['Silver']['p2'] ? 'Silver' : points['Bronze']['p2'] ? 'Bronze' : 'None',
            'warranty-disclosure': points['Gold']['p3'] ? 'Gold' : points['Silver']['p3'] ? 'Silver' : points['Bronze']['p3'] ? 'Bronze' : 'None',
            'directors-questionnaire': points['Gold']['p4'] ? 'Gold' : points['Silver']['p4'] ? 'Silver' : points['Bronze']['p4'] ? 'Bronze' : 'None',
            'esg': extraModules['Gold']['p1'] ? 'Gold' : extraModules['Silver']['p1'] ? 'Silver' : extraModules['Bronze']['p1'] ? 'Bronze' : 'None',
            'software-development': extraModules['Gold']['p2'] ? 'Gold' : extraModules['Silver']['p2'] ? 'Silver' : extraModules['Bronze']['p2'] ? 'Bronze' : 'None'
        };
        company['moduleCertification'][`two-minute-test-${company['testType']}`] = data['two-minute-test']['risk'] == 0 && data['two-minute-test']['completeness'] == 0 ? 'None' : data['two-minute-test']['risk'] <= 50 && data['two-minute-test']['completeness'] == 100 ? 'Pass' : 'Fail';
        let completePoints = 0, totalPoints = 0;
        let point = points[company['certificateNext']] || points[cLevel];
        if (point) Object.keys(point).forEach((key)=>{
            if (key.indexOf('p') >= 0) {
                totalPoints++;
                if (point[key]) completePoints++;
            }
        });
        company['certificateProgress'] = completePoints / totalPoints * 100;
        return company;
    };
    const calculateStats = (companyObject, moduleName, check)=>{
        companyObject = JSON.parse(JSON.stringify(companyObject));
        const wasRepositoryComplete = companyObject?.['modules']?.['repository']?.['stats']?.['completionPercent'] === 100;
        // for (const module of Object.values(companyObject.modules)) {
        let module = companyObject?.['modules']?.[$cb3ceb5821786f07$export$57c43fe781091dc0(moduleName ?? tab)];
        if (module) {
            if (module['stats']) module['stats'] = {
                minRiskScore: 0,
                maxRiskScore: 0,
                riskScore: 0,
                maxCompletionScore: 0,
                completionScore: 0,
                workflowCompletionScore: 0,
                workflowMaxScore: 0
            };
            if (module['sections']) {
                for (const section of Object.freeze(module['sections'])){
                    section['stats'] = {
                        minRiskScore: 0,
                        maxRiskScore: 0,
                        riskScore: 0,
                        maxCompletionScore: 0,
                        completionScore: 0,
                        workflowCompletionScore: 0,
                        workflowMaxScore: 0
                    };
                    // TODO: For Expension packs aggregate all questions from SubFolders
                    let questions = [];
                    if (module['expansionPack']) {
                        Object.values(section['subFolders']).forEach((subSection)=>questions = questions.concat(subSection['questions']));
                        questions = questions.filter((question)=>question !== undefined);
                    } else questions = section['questions'];
                    if (questions) for (const question of questions){
                        if (section["type"] === "Existing Sections" && question["type"] === "repository" && companyObject["subscription"] == "Pro" && question["qNo"].split(".").length == 1) continue;
                        else if (section["type"] === "Existing Sections" && question["type"] === "repository" && companyObject["subscription"] == "Lite" && question["qNo"].split(".").length > 1) continue;
                        if (!question['isSkipped']) {
                            let answer = question?.['answer'] || {};
                            if ([
                                "Completed",
                                "Not Applicable"
                            ].includes(answer?.['status'])) {
                                // if (["Completed", "Not Applicable"].includes(answer?.['status']) || module['type'] !== "repository" && answer?.['radioOption']) {
                                if (answer?.['radioOption'] && answer?.['radioOption'] !== 'NC') section['stats']['completionScore'] += question['completionScore'] || 1;
                                // Risk score calculation - skip N/A answers as they should not affect risk
                                if (answer?.['radioOption'] !== 'N/A') {
                                    if (question['questionType'] == 'D/ND') section['stats']['riskScore'] += answer?.['radioOption'] == 'Disclosure' ? question['riskIfD'] : answer?.['radioOption'] == 'No Disclosure' ? question['riskIfND'] : answer?.['radioOption'] == 'Not Sure' ? question['riskIfNS'] : 0;
                                    else section['stats']['riskScore'] += question["riskIf" + answer?.['radioOption']] || 0;
                                    const allRiskScores = Object.keys(question).filter((k)=>k.startsWith("riskIf")).map((k)=>question[k]);
                                    section['stats']['minRiskScore'] += Math.min(...allRiskScores);
                                    section['stats']['maxRiskScore'] += Math.max(...allRiskScores);
                                }
                                let workflowScores = {
                                    'Not Started': 0,
                                    'Started': 0.25,
                                    'In Progress': 0.50,
                                    'Completed - Further Work': 0.75,
                                    'Completed - No Issues': 1
                                };
                                if (answer['taskStatus'] && Object.keys(workflowScores).includes(answer['taskStatus'])) {
                                    section['stats']['workflowMaxScore'] += 1;
                                    section['stats']['workflowCompletionScore'] += workflowScores[answer['taskStatus']];
                                }
                            }
                            section['stats']['maxCompletionScore'] += question['completionScore'] || 1;
                        }
                    }
                    if (section['stats']['completionScore'] == 0 || section['stats']['maxRiskScore'] === section['stats']['minRiskScore']) section['stats']['riskPercent'] = 0;
                    else section['stats']['riskPercent'] = Math.round((section['stats']['riskScore'] - section['stats']['minRiskScore']) / (section['stats']['maxRiskScore'] - section['stats']['minRiskScore']) * 100);
                    section['stats']['completionPercent'] = Math.round(section['stats']['completionScore'] / section['stats']['maxCompletionScore'] * 100);
                    section['stats']['workflowCompletionPercent'] = Math.round(section['stats']['workflowCompletionScore'] / section['stats']['workflowMaxScore'] * 100);
                    if (section['subFolders']) calculateSubFolderStats(module, section['subFolders'], questions);
                }
                module['stats'] = module.sections.reduce((stats, section)=>{
                    for(const key in section['stats'])stats[key] = (stats[key] ?? 0) + section['stats'][key];
                    return stats;
                }, {
                    minRiskScore: 0,
                    maxRiskScore: 0,
                    riskScore: 0,
                    maxCompletionScore: 0,
                    completionScore: 0,
                    workflowCompletionScore: 0,
                    workflowMaxScore: 0
                });
                if (module['type'] == 'repository' && companyObject['subscription'] == 'Lite') module["stats"]["maxCompletionScore"] = 20;
                if (module['stats']['completionScore'] == 0 || module['stats']['maxRiskScore'] === module['stats']['minRiskScore']) module['stats']['riskPercent'] = 0;
                else module['stats']['riskPercent'] = Math.round((module['stats']['riskScore'] - module['stats']['minRiskScore']) / (module['stats']['maxRiskScore'] - module['stats']['minRiskScore']) * 100);
                if (module['stats']['completionScore']) module['stats']['completionPercent'] = Math.round(module['stats']['completionScore'] / module['stats']['maxCompletionScore'] * 100);
                module['stats']['workflowCompletionPercent'] = Math.round(module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore'] * 100);
            }
            companyObject['stats'] = Object.values(companyObject.modules).reduce((stats, module)=>{
                if (module?.['stats']?.['completionScore'] > 0) for(const key in module['stats'])stats[key] = (stats[key] ?? 0) + module['stats'][key];
                return stats;
            }, {
                minRiskScore: 0,
                maxRiskScore: 0,
                riskScore: 0,
                maxCompletionScore: 0,
                completionScore: 0,
                workflowCompletionScore: 0,
                workflowMaxScore: 0
            });
            if (companyObject['stats']['completionScore'] == 0) companyObject['stats']['riskPercent'] = 0;
            else companyObject['stats']['riskPercent'] = Math.round((companyObject['stats']['riskScore'] - companyObject['stats']['minRiskScore']) / (companyObject['stats'].maxRiskScore - companyObject['stats']['minRiskScore']) * 100);
            companyObject['stats']['completionPercent'] = Math.round(companyObject['stats']['completionScore'] / companyObject['stats'].maxCompletionScore * 100);
            companyObject['stats']['workflowCompletionPercent'] = Math.round(module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore'] * 100);
            if (!wasRepositoryComplete && companyObject?.modules?.repository?.['stats']?.['completionPercent'] == 100) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'respositoryCompleted'
            }));
            if (tab == `two-minute-test-${company['testType']}` && companyObject?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 100) {
                if (!moduleName) reloadModule(`two-minute-test-${company['testType']}`, true, null, null, "1");
                if (!tab.endsWith("-report") && user['role'] == 'Guest') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'twoMinuteTestCompleted'
                }));
            }
            calculateCertification(companyObject);
            companyObject = calculateDirectorStats(companyObject);
        }
        return companyObject;
    };
    const calculateDirectorStats = (companyObj)=>{
        let directorsCount = 0;
        if (companyObj['directorsStats']) {
            companyObj['directorsStats']['riskPercent'] = 0;
            companyObj['directorsStats']['completionPercent'] = 0;
        }
        for (let module of Object.values(companyObj['modules']))if (module['type'] && module['type'].includes('directors-questionnaire')) {
            if (!companyObj['directorsStats']) companyObj['directorsStats'] = {
                riskPercent: module['stats']['riskPercent'],
                completionPercent: module['stats']['completionPercent']
            };
            else {
                companyObj['directorsStats']['riskPercent'] += module['stats']['riskPercent'];
                companyObj['directorsStats']['completionPercent'] += module['stats']['completionPercent'];
            }
            directorsCount++;
        }
        if (directorsCount > 0) {
            companyObj['directorsStats']['riskPercent'] = (companyObj['directorsStats']['riskPercent'] / directorsCount).toFixed(0);
            companyObj['directorsStats']['completionPercent'] = (companyObj['directorsStats']['completionPercent'] / directorsCount).toFixed(0);
        }
        const directorsStatsPercentage = {
            personal: {
                completionPercent: 0,
                riskPercent: 0
            },
            occupational: {
                completionPercent: 0,
                riskPercent: 0
            },
            personalFinantial: {
                completionPercent: 0,
                riskPercent: 0
            },
            litigation: {
                completionPercent: 0,
                riskPercent: 0
            }
        };
        let numofDirectors = 0;
        for(const moduleKey in companyObj['modules'])if (typeof companyObj['modules'][moduleKey] === 'object') {
            const module = companyObj['modules'][moduleKey];
            if (moduleKey.includes('directors-questionnaire')) {
                for (const section of module['sections']){
                    if (section['subFolders']) for(const subFolderKey in section['subFolders']){
                        const subFolder = section.subFolders[subFolderKey];
                        if (subFolder['sectionNo'] == "DEPF007.1") {
                            directorsStatsPercentage['personal']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['personal']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                        if (subFolder['sectionNo'] == "DEPF007.2") {
                            directorsStatsPercentage['occupational']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['occupational']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                        if (subFolder['sectionNo'] == "DEPF007.3") {
                            directorsStatsPercentage['personalFinantial']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['personalFinantial']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                        if (subFolder['sectionNo'] == "DEPF007.4") {
                            directorsStatsPercentage['litigation']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['litigation']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                    }
                }
                numofDirectors++;
            }
        }
        if (numofDirectors > 0) for(const category in directorsStatsPercentage){
            directorsStatsPercentage[category]['completionPercent'] /= numofDirectors;
            directorsStatsPercentage[category]['riskPercent'] /= numofDirectors;
        }
        companyObj['directorSectionStats'] = directorsStatsPercentage;
        return companyObj;
    };
    const calculateSubFolderStats = (module, subFolders, questions)=>{
        for (const subFolder of Object.values(subFolders)){
            subFolder.stats = {
                minRiskScore: 0,
                maxRiskScore: 0,
                riskScore: 0,
                maxCompletionScore: 0,
                completionScore: 0,
                workflowCompletionScore: 0,
                workflowMaxScore: 0
            };
            let currentQuestions;
            if (subFolder['questions']) currentQuestions = subFolder['questions'];
            else currentQuestions = questions && questions.filter((q)=>q.qNo.match(new RegExp(subFolder.no + "((\.[0-9]+)|$)")));
            if (currentQuestions) {
                for (const question of currentQuestions)if (!question['isSkipped']) {
                    let answer = question['answer'] || {};
                    if ([
                        "Completed",
                        "Not Applicable"
                    ].includes(answer?.status)) {
                        // if (["Completed", "Not Applicable"].includes(answer?.status) || module.type !== "repository" && answer?.['radioOption']) {
                        if (answer?.['radioOption'] && answer?.['radioOption'] !== 'NC') subFolder['stats']['completionScore'] += question['completionScore'] || 1;
                        // Risk score calculation - skip N/A answers as they should not affect risk
                        if (answer?.['radioOption'] !== 'N/A') {
                            if (question['questionType'] == 'D/ND') subFolder['stats']['riskScore'] += answer?.['radioOption'] == 'Disclosure' ? question['riskIfD'] : answer?.['radioOption'] == 'No Disclosure' ? question['riskIfND'] : answer?.['radioOption'] == 'Not Sure' ? question['riskIfNS'] : 0;
                            else subFolder['stats']['riskScore'] += question["riskIf" + answer?.['radioOption']] || 0;
                            const allRiskScores = Object.keys(question).filter((k)=>k.startsWith("riskIf")).map((k)=>question[k]);
                            subFolder['stats']['minRiskScore'] += Math.min(...allRiskScores);
                            subFolder['stats']['maxRiskScore'] += Math.max(...allRiskScores);
                        }
                        let workflowScores = {
                            'Not Started': 0,
                            'Started': 0.25,
                            'In Progress': 0.50,
                            'Completed - Further Work': 0.75,
                            'Completed - No Issues': 1
                        };
                        if (answer['taskStatus'] && Object.keys(workflowScores).includes(answer['taskStatus'])) {
                            subFolder['stats']['workflowMaxScore'] += 1;
                            subFolder['stats']['workflowCompletionScore'] += workflowScores[answer['taskStatus']];
                        }
                    }
                    subFolder['stats']['maxCompletionScore'] += question['completionScore'] || 1;
                }
            }
            if (subFolder['stats']['completionScore'] == 0 || subFolder['stats']['maxRiskScore'] === subFolder['stats']['minRiskScore']) subFolder['stats']['riskPercent'] = 0;
            else subFolder['stats']['riskPercent'] = Math.round((subFolder['stats']['riskScore'] - subFolder['stats']['minRiskScore']) / (subFolder['stats']['maxRiskScore'] - subFolder['stats']['minRiskScore']) * 100);
            subFolder['stats']['completionPercent'] = Math.round(subFolder['stats']['completionScore'] / subFolder['stats']['maxCompletionScore'] * 100);
            subFolder['stats']['workflowCompletionPercent'] = Math.round(module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore'] * 100);
            if (subFolder.subFolders) calculateSubFolderStats(module, subFolder['subFolders'], currentQuestions);
        }
    };
    const getCompletenessAndRiskHTML = (layoutType, stats, questions)=>{
        let tabModule = company?.['modules']?.[$cb3ceb5821786f07$export$57c43fe781091dc0(tab)];
        if (stats) stats = JSON.parse(JSON.stringify(stats));
        if (questions) questions = JSON.parse(JSON.stringify(questions));
        let completenessColour = 9 - Math.floor(stats['completionPercent'] / 33.34);
        let completenessText = stats['completionPercent'] && stats['completionPercent'] > 0 ? stats['completionPercent'] + `% ${stats['completionPercent'] == 100 ? 'Completed' : 'Complete'}` : "Not Started";
        // If its 1 question
        if (questions && questions.length == 1) {
            completenessText = questions[0]?.['answer']?.status || 'Not Started';
            completenessColour = completenessText === 'Not Started' ? 9 : completenessText == 'In Progress' || completenessText == 'Not Applicable' ? 8 : completenessText == 'Completed' ? 7 : 9;
        }
        if (layoutType.includes("repository") || layoutType.includes("investor-lead") || tabModule?.['riskScoring'] == false) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "fw600 lh1 fs1rem mt1rem c" + completenessColour,
            children: completenessText
        });
        let riskText, riskColour;
        if (stats['riskPercent'] == 0 && stats['completionPercent'] == 0) {
            riskColour = 37;
            riskText = "No Risk Score";
        } else if (stats['riskPercent'] > 62) {
            riskColour = 9;
            riskText = "High Risk";
        } else if (stats['riskPercent'] < 38) {
            riskColour = 34;
            riskText = "Low Risk";
        } else {
            riskColour = 8;
            riskText = "Medium Risk";
        }
        if (layoutType.includes("sidebar")) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: `fw300 c${completenessColour} tac fw600 lh1 fs1rem mt1rem`,
                    children: [
                        stats.completionPercent || 0,
                        "% Complete"
                    ]
                }),
                (!layoutType.includes("repository") || !layoutType.includes("investor-lead") || tabModule?.['riskScoring'] == true) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `fw300 c${riskColour} tac fw600 lh1 fs1rem mt0-5rem`,
                    children: riskText
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c" + completenessColour,
                    children: completenessText
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "mx0-5rem",
                    children: " | "
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c" + riskColour,
                    children: riskText
                })
            ]
        });
    };
    const handleContactInvestor = async (investor, isContacted = true)=>{
        let investorId = investor['_id'];
        let clientId = location.pathname.split('/')[2];
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/contactInvestor`, {
            investorId: investorId,
            clientId: clientId,
            isContacted: isContacted
        });
        if (res && res['code'] == 200) getFitInvestorFirms();
        else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    const handleInvestorEmail = async (investor)=>{
        if (!investor['isContacted']) {
            setAcceptEmail(false);
            await setInvestorEmail(investor);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'investorEmailSent'
            }));
        }
    };
    const sendInvestorEmail = async ()=>{
        let data = {
            investorId: investorEmail['_id'],
            investorName: investorEmail['name'],
            clientId: company['_id'],
            clientName: company['cName'],
            fitScorePercentage: investorEmail['fitScorePercentage'],
            contactId: investorEmail['contactId'],
            contactName: investorEmail['contactName'],
            email: investorEmail['contactEmail']
        };
        if (investorEmail) {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/sendInvestorEmail`, data);
            if (res['code'] == 200) {
                await handleContactInvestor(investorEmail, true);
                setInvestorEmail({});
                setAcceptEmail(false);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            }
        }
    };
    const handleUploadImage = async (e)=>{
        let profile = e.target.files[0];
        if (profile && profile.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        profile = await URL.createObjectURL(profile);
        setUploadImage(profile);
    };
    const updateProfile = async ()=>{
        let attachment = [];
        if ($cb3ceb5821786f07$var$cropper.current && uploadImage) {
            let imageToUpload = $cb3ceb5821786f07$var$cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile-image.png", {
                type: "image/png"
            });
            attachment.push(coverFile);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateLogo/${companyId}`, {
                attachment: attachment
            });
            if (response || response["code"] == 200) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...selectedCompany,
                logo: response?.['body']?.['logo']
            }));
            setUploadImage('');
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    const permissionTooltip = (permissions, isOwner)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "module-tooltip-box",
            style: {
                position: 'relative'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("9gCOW")),
                    style: {
                        width: '20px',
                        height: '20px',
                        bottom: '25px',
                        left: '-10px'
                    },
                    className: "cp pa",
                    alt: "list-img"
                }),
                company?.['sections'] && company['sections'].length > 0 && Object.keys(permissions).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "tooltip-area tooltip-area-permissions",
                    style: {
                        height: '60vh',
                        overflow: 'auto'
                    },
                    children: company['sections'].map((sec, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "dashboard-permission-overlaybox overlay-box cp w100 tac bss bw1px bo28",
                            style: {
                                opacity: permissions?.[sec?.['sectionNo']] || isOwner ? '1' : '0.5'
                            },
                            children: [
                                (permissions?.[sec?.['sectionNo']] || isOwner) && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fa fa-check-circle green mr0-5rem",
                                    style: {
                                        fontSize: '13px'
                                    }
                                }),
                                sec['sectionName']
                            ]
                        }, `section-${sec?.['sectionNo'] || idx}`);
                    })
                })
            ]
        });
    };
    const showPopupPercent = (value, type)=>{
        let color;
        if (type == 'Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
        else if (type == 'Completeness') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: `${color}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c6",
                    children: type
                }),
                " ",
                value || 0,
                "% "
            ]
        });
    };
    const createDirector = async ()=>{
        const companyId = location.pathname.split("/").slice(-1)[0];
        const name = document.getElementById("directorName").value;
        const designation = document.getElementById("directorDesignation").value;
        if (name && designation) {
            const postBody = {
                name: name,
                designation: designation
            };
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/createDirector/${companyId}`, postBody);
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                window.location.reload();
            }
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter director name and designation");
    };
    const handleViewDirector = async (item)=>{
        if (localStorage.getItem('isDiligencePack') && !isBackFitReport || user?.['type'] == 'External') await setTab(`directors-questionnaire_${item['_id']}-report`);
        else await setTab(`directors-questionnaire_${item['_id']}`);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const handleBackDirectors = async ()=>{
        await setTabName("");
        await setOpenTabs(new Set());
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'showDirectors'
        }));
    };
    const sortSections = (a, b)=>{
        let valueA = (a?.sectionNo || a?.no).match(/\d+/g);
        let valueB = (b?.sectionNo || b?.no).match(/\d+/g);
        return valueA - valueB;
    };
    const handleDemoNext = async ()=>{
        let module = company['modules'][tab.replace('-report', '')];
        if (isPrePopulate && module) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'demoChecklistFlow'
            }));
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/populate`, {
                companyId: company['_id'],
                moduleId: module['_id']
            });
            if (res?.['code'] == 200) {
                await setTab(tab, true);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                setIsPrePopulate(false);
            }
        } else {
            setIsPrePopulate(false);
            if (tab.endsWith("-report")) {
                if (isWorkflowReport) window.location.href = `/company/${company['_id']}`;
                else {
                    setIsWorkflowReport(true);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'demoChecklistFlow'
                    }));
                    setTimeout(()=>{
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        }));
                        setTab(tab);
                    }, 4000);
                }
            } else {
                setIsWorkflowReport(false);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'demoChecklistFlow'
                }));
                setTimeout(()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    setTab(`${tab}-report`);
                }, 4000);
            }
        }
    };
    const handlePartnerChecklistNext = async ()=>{
        setIsPrePopulate(false);
        if (tab.endsWith("-report")) window.location.href = `/company/${company['_id']}`;
        else {
            setIsWorkflowReport(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'demoChecklistFlow'
            }));
            setTimeout(()=>{
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                setTab(`${tab}-report`);
            }, 4000);
        }
    };
    const handleSuperflowNext = async ()=>{
        if (company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100) handleSuperFlowPopup();
    };
    const nextInvestmentReadiness = async ()=>{
        if (company['modules']?.['Investment Readiness']) {
            window.location.href = `/company/${company['_id']}#${partner['moduleName']}`;
            setTimeout(()=>window.location.reload(), 200);
        } else window.location.href = `/completeInvestment/${partner['_id']}?companyId=${company['_id']}&cName=${company['cName']}`;
    };
    const handleCompleteInvestmentReadiness = async ()=>{
        const currentCompanyId = selectedCompany?.['_id'] || companyId;
        if (!currentCompanyId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Company not loaded yet. Please try again.');
            return;
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'completeInvestmentReadiness'
        }));
        setIsGenerateAllResearchAid(true);
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/generateAllReports', {
            companyId: currentCompanyId
        });
        if (res['code'] == '200') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatedResearchAidReports'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'notGeneratedResearchAidReports'
        }));
        setIsGenerateAllResearchAid(false);
        if (user && user['type'] == 'Superflow') {
            if (res) await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
                type: 'User'
            });
        }
    };
    const updateUserType = async ()=>{
        if (user && user['type'] == 'Superflow') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
                type: 'User'
            });
            if (res['code'] == '200') window.location.href = `/company/${companyId}`;
        }
    };
    const handleRedirectResearchAid = async ()=>{
        await getCompany();
        await getUser();
        navigate(`/company/${company['_id']}`);
        setCompanyDashboardTab('ResearchAid');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "company-dashboard-view poppins-font-style * ",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                    value: dashboardTab,
                    children: [
                        user?.['type'] == 'Superflow' && (tab.includes('Readiness') || tab.includes('investor-lead')) || isManualAdd ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $def17927b8072e3f$export$2e2bcd8739ae039), {
                            page: "Company",
                            company: company,
                            breadcrum: [
                                'Company View',
                                '/Company',
                                `/${tab.includes('investor-lead') ? 'InvestorMatch' : 'Investment Readiness'}`
                            ],
                            heading: user?.['role'] == 'Investor' && company?.['addedByInvestor'] == user?.['_id'] && tab == 'investor-lead' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "Investor",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "Match"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " Add Applicant"
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "One"
                                    }),
                                    "Form ",
                                    tab.includes('investor-lead') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Investor",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "Match"
                                            })
                                        ]
                                    }) : 'Investment Readiness'
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dashboard-container pt1rem df fdc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7aa087f4714d751e$export$2e2bcd8739ae039), {
                                company: company,
                                user: user,
                                dashboardTab: dashboardTab,
                                companyDashboardTab: companyDashboardTab,
                                setUploadImage: setUploadImage,
                                setCertificateSeeMore: setCertificateSeeMore,
                                setTab: setTab,
                                permissionTooltip: permissionTooltip,
                                setUserAction: setUserAction,
                                userAction: userAction,
                                setEditUser: setEditUser,
                                setDashboardTab: setDashboardTab,
                                isShowTeamTab: isShowTeamTab,
                                isPortfolio: isPortfolio,
                                setTabName: setTabName,
                                profileClass: profileClass,
                                tab: tab,
                                companyIndex: companyIndex,
                                setOpenTabs: setOpenTabs
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `dahboard-tabs`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100 company-dashboard",
                                    value: "Company",
                                    children: [
                                        isClientIndex && user?.['type'] !== 'Superflow' && user?.['type'] !== 'External' && !localStorage.getItem("isQualifiedLeads") && !isManualAdd && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tabs-navlist tabs-dashboard df aic jcc mt2rem",
                                            children: [
                                                'Dashboard',
                                                'Analyser',
                                                'AnyLists',
                                                'Workflows',
                                                'ResearchAid',
                                                'InvestorMatch',
                                                'AppStore'
                                            ].map((item, idx)=>{
                                                if ((user['role'] == 'Advisor' || user['role'] == 'Investor' || company?.['testType'] == "growth" || company?.['testType'] == "exit") && item == 'InvestorMatch') return;
                                                if ((company['subscription'] == 'Free' || company['subscription'] == 'Lite') && item == 'Analyser') return;
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        disabled: user['role'] == 'Guest',
                                                        className: `fs1-25rem fw500 c15 ${companyDashboardTab == item && ' active'}`,
                                                        onClick: ()=>{
                                                            if (item === 'InvestorMatch' && companyDashboardTab !== item) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: 'investorMatchDisclaimer'
                                                            }));
                                                            else setCompanyDashboardTab(item);
                                                        },
                                                        style: {
                                                            cursor: user['role'] == 'Guest' ? 'not-allowed' : 'pointer'
                                                        },
                                                        children: item
                                                    })
                                                }, `dashboard-tab-${idx}`);
                                            })
                                        }),
                                        (user?.['role'] == 'Advisor' || user?.['role'] == 'Investor') && permissionLevel && company?.['clientLoginActivated'] === false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            class: "w100 mt1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleActivateClientLogin(company['_id']),
                                                disabled: activatingClient === company['_id'],
                                                "data-tooltip": "Click to send activation email to client",
                                                className: `cp c1 bg3 bg4-hover tac br20px fs0-75rem px3rem py0-5rem fw500 td250 mb0-5rem ${activatingClient === company['_id'] ? 'op50' : ''}`,
                                                style: {
                                                    border: "none"
                                                },
                                                children: activatingClient === company['_id'] ? 'Activating...' : 'Activate Client Login'
                                            })
                                        }),
                                        company['subscription'] !== 'Pro' && tab === "" && companyDashboardTab == 'Dashboard' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1129f9c8b56c4712$export$2e2bcd8739ae039), {
                                            user: user,
                                            company: company
                                        }),
                                        companyDashboardTab == 'Dashboard' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                tab.endsWith("-report") && user?.role.toLowerCase() === "guest" && user?.['type'] !== 'External' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                                    wrapperClass: "tac",
                                                    heading: "",
                                                    subheading: "",
                                                    paragraph: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            "Register at the end of test to access more features ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fs11px",
                                                                children: "(No credit card required)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                                className: "c3"
                                                            })
                                                        ]
                                                    })
                                                }) : null,
                                                company['modules'] && user?.['type'] !== 'External' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df top-tabs-report",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `df aic oxa w100`,
                                                            children: Array.from(openTabs).map((openTab, idx)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                    to: `#${openTab}`,
                                                                    onClick: ()=>setTab(openTab),
                                                                    className: (tab === openTab ? "bg1" : "bo6") + " shadow p1rem mt1rem wsn usn td250 c15 tab cp df fw600 ttu fs1rem jcc aic pr zi1 tal",
                                                                    children: [
                                                                        company.modules[openTab]?.heading == undefined ? openTab.includes("directors-questionnaire") ? "Directors Questionnaire Report" : openTab.includes("fit-report") ? 'Fit Report' : openTab.split('?')[0].endsWith("-analyser") || openTab.endsWith("-analyser") || openTab.includes('--history--') ? (()=>{
                                                                            // Strip -analyser, legacy ?history=, and --history--<id>
                                                                            const tabId = openTab.replace(/-analyser$/, '').split('?')[0].split('--history--')[0];
                                                                            // Find the matching report in aiReports
                                                                            const report = company?.['aiReports']?.find((r)=>{
                                                                                if (r._id && r._id.toString() === tabId) return true;
                                                                                // Also check by sanitized reportLabel
                                                                                if (r.reportLabel) {
                                                                                    const sanitized = r.reportLabel.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9.-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
                                                                                    return sanitized === tabId;
                                                                                }
                                                                                return false;
                                                                            });
                                                                            return report?.reportLabel || report?.name || /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    tabId.replaceAll("-", " ").replaceAll("%20", " "),
                                                                                    " Analyser"
                                                                                ]
                                                                            });
                                                                        })() : openTab.includes("-researchaid") && openTab.includes('?') ? openTab.split('?')[1] : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                            children: openTab.replaceAll("-", " ").replaceAll("%20", " ")
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                            children: openTab.includes("directors-questionnaire") ? company.modules[openTab]?.heading.split(",")[0] : openTab.includes("investor-lead") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "c15",
                                                                                children: [
                                                                                    "Investor",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c4",
                                                                                        children: "Match"
                                                                                    })
                                                                                ]
                                                                            }) : company.modules[openTab]?.heading || company.modules[openTab.replace(/-report/, "")]?.heading + " Report"
                                                                        }),
                                                                        !isPortfolio && isClientIndex && user?.['type'] !== 'Superflow' && !isManualAdd && !localStorage.getItem("isQualifiedLeads") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                            className: "ml0-5rem pr",
                                                                            to: linksToCloseTab(),
                                                                            onClick: (e)=>closeTab(e, openTab),
                                                                            style: {
                                                                                top: '4px'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                width: "23",
                                                                                height: "24",
                                                                                viewBox: "0 0 23 24",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                        opacity: "0.8",
                                                                                        x: "1.53125",
                                                                                        y: "2.03516",
                                                                                        width: "19.9333",
                                                                                        height: "19.9333",
                                                                                        rx: "9.96667",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M18.6149 4.88438C17.2076 3.47722 15.4146 2.51896 13.4627 2.13078C11.5108 1.7426 9.48763 1.94193 7.64901 2.70357C5.81039 3.4652 4.2389 4.75494 3.13327 6.40969C2.02763 8.06443 1.4375 10.0099 1.4375 12C1.4375 13.9901 2.02763 15.9356 3.13327 17.5903C4.2389 19.2451 5.81039 20.5348 7.64901 21.2964C9.48763 22.0581 11.5108 22.2574 13.4627 21.8692C15.4146 21.4811 17.2076 20.5228 18.6149 19.1156C19.5494 18.1812 20.2907 17.0719 20.7964 15.851C21.3022 14.6301 21.5625 13.3215 21.5625 12C21.5625 10.6785 21.3022 9.36992 20.7964 8.14902C20.2907 6.92811 19.5494 5.81878 18.6149 4.88438ZM15.093 14.5444C15.1648 14.6116 15.2221 14.6929 15.2612 14.7831C15.3004 14.8734 15.3205 14.9707 15.3205 15.0691C15.3205 15.1674 15.3004 15.2648 15.2612 15.355C15.2221 15.4453 15.1648 15.5265 15.093 15.5938C15.0259 15.6604 14.9462 15.7131 14.8586 15.7488C14.7711 15.7846 14.6773 15.8027 14.5827 15.8022C14.3942 15.8014 14.2135 15.7265 14.0796 15.5938L11.4993 13.0134L8.9549 15.5938C8.82102 15.7265 8.64033 15.8014 8.45177 15.8022C8.35718 15.8027 8.26341 15.7846 8.17584 15.7488C8.08827 15.7131 8.00862 15.6604 7.94146 15.5938C7.80759 15.4591 7.73245 15.2769 7.73245 15.087C7.73245 14.8972 7.80759 14.715 7.94146 14.5803L10.4858 12L7.94146 9.45563C7.82371 9.31813 7.76218 9.14126 7.76917 8.96037C7.77616 8.77948 7.85115 8.60789 7.97915 8.47988C8.10716 8.35188 8.27875 8.27689 8.45964 8.2699C8.64053 8.26291 8.8174 8.32444 8.9549 8.44219L11.4993 10.9866L14.0436 8.44219C14.1102 8.37329 14.1897 8.31817 14.2775 8.27997C14.3653 8.24178 14.4599 8.22127 14.5556 8.2196C14.6514 8.21793 14.7466 8.23514 14.8357 8.27025C14.9248 8.30536 15.0062 8.35768 15.0751 8.42422C15.144 8.49077 15.1991 8.57023 15.2373 8.65808C15.2755 8.74592 15.296 8.84043 15.2977 8.9362C15.2993 9.03198 15.2821 9.12715 15.247 9.21627C15.2119 9.30539 15.1596 9.38673 15.093 9.45563L12.5127 12L15.093 14.5444Z",
                                                                                        fill: "#FC7785"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }, `tab-${openTab}-${idx}`);
                                                            })
                                                        }),
                                                        tab && tab.includes('directors-questionnaire') && !isBackFitReport && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            onClick: async ()=>handleBackDirectors(),
                                                            className: "tac dashboard-btn c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 td270 w200px mb0-5rem p1rem df aic jcc",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "icon mr1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "21",
                                                                        height: "21",
                                                                        viewBox: "0 0 21 21",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z",
                                                                                fill: "white",
                                                                                stroke: "white",
                                                                                "stroke-width": "0.5"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z",
                                                                                fill: "white",
                                                                                stroke: "white",
                                                                                "stroke-width": "0.5"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                "Back To Directors"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                company['modules'] && (tab && tab !== "" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pr report-page",
                                                    style: {
                                                        transform: 'none'
                                                    },
                                                    children: [
                                                        tab.endsWith("-section-report") || tab.endsWith("-analysis-report") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ceaf1026d7cd7a8b$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    title: tab.endsWith("-section-report") ? "Section Report" : "Insurance Gap Analysis Report",
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.endsWith("-report") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: isWorkflowReport ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dce461e3ca02b46d$export$2e2bcd8739ae039), {
                                                                        sectionRefs: sectionRefs,
                                                                        getCompany: getCompany,
                                                                        setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                                        calculateStats: calculateStats,
                                                                        profileClass: profileClass,
                                                                        user: user,
                                                                        company: company,
                                                                        aiEnhanced: aiEnhanced,
                                                                        setAiEnchaned: setAiEnchaned,
                                                                        moduleCertification: company?.moduleCertification[tab.includes('business-audit') ? 'business-audit-' + company.testType : $cb3ceb5821786f07$export$57c43fe781091dc0(tab)],
                                                                        module: company.modules[$cb3ceb5821786f07$export$57c43fe781091dc0(tab)],
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                                        sortSections: sortSections,
                                                                        isLoader: isLoader,
                                                                        setIsLoader: setIsLoader
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33a9b39b88c46765$export$2e2bcd8739ae039), {
                                                                            sectionRefs: sectionRefs,
                                                                            getCompany: getCompany,
                                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                                            profileClass: profileClass,
                                                                            user: user,
                                                                            company: company,
                                                                            aiEnhanced: aiEnhanced,
                                                                            setAiEnchaned: setAiEnchaned,
                                                                            moduleCertification: company?.moduleCertification[tab.includes('business-audit') ? 'business-audit-' + company.testType : $cb3ceb5821786f07$export$57c43fe781091dc0(tab)],
                                                                            module: company.modules[$cb3ceb5821786f07$export$57c43fe781091dc0(tab)],
                                                                            tab: tab,
                                                                            setTab: setTabName,
                                                                            twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                                            sortSections: sortSections,
                                                                            openTabs: openTabs,
                                                                            setOpenTabs: setOpenTabs
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $73a5f3cb80d8115d$export$2e2bcd8739ae039), {
                                                                    getCompany: getCompany,
                                                                    getUser: getUser,
                                                                    isWorkflowReport: isWorkflowReport,
                                                                    setIsWorkflowReport: setIsWorkflowReport,
                                                                    isViewTwoMinuteReport: isViewTwoMinuteReport,
                                                                    visibleSection: visibleSection,
                                                                    profileClass: profileClass,
                                                                    advisors: user['role'] == 'Advisor' ? advisors : investors,
                                                                    permissionLevel: permissionLevel,
                                                                    company: company,
                                                                    setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                                    tab: tab,
                                                                    sanitiseTab: $cb3ceb5821786f07$export$57c43fe781091dc0,
                                                                    toggleReport: toggleReport,
                                                                    openKPI: openKPI,
                                                                    enableAIEnhancedReporting: enableAIEnhancedReporting,
                                                                    calculateStats: calculateStats,
                                                                    calculateSubFolderStats: calculateSubFolderStats,
                                                                    getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                                                                    twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                                    getFitInvestorFirms: getFitInvestorFirms,
                                                                    setTab: setTab,
                                                                    setTabName: setTabName,
                                                                    setOpenTabs: setOpenTabs,
                                                                    openTabs: openTabs,
                                                                    sortSections: sortSections,
                                                                    handlePartnerChecklistNext: handlePartnerChecklistNext,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    closeTab: closeTab,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    isLoader: isLoader,
                                                                    setIsLoader: setIsLoader,
                                                                    isExternalPage: false
                                                                })
                                                            ]
                                                        }) : tab.includes('insuranceGapAnalysis-researchaid') ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ceaf1026d7cd7a8b$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        setCompanyDashboardTab: setCompanyDashboardTab
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.endsWith("-researchaid") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91ba6c0aac080db6$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        setCompanyDashboardTab: setCompanyDashboardTab
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.endsWith("-analyser") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ceaf1026d7cd7a8b$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        setCompanyDashboardTab: setCompanyDashboardTab
                                                                    }, tab)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    title: "AI Analyser Report",
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.includes('fit-report') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6123099ae995020$export$2e2bcd8739ae039), {
                                                            user: user,
                                                            company: company,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            moduleCertification: company?.moduleCertification['investor-lead'],
                                                            module: company.modules['investor-lead'],
                                                            tab: tab,
                                                            setTab: setTab,
                                                            fitInvestorFirms: fitInvestorFirms,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            linearProgress: linearProgress
                                                        }) : tab === 'unaudited-certification' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $029a2d9637150f15$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            user: user,
                                                            company: company,
                                                            setTab: setTab,
                                                            directors: directors
                                                        }) : tab === 'diligence-pack' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86727a4e8cc19e92$export$2e2bcd8739ae039), {
                                                            company: company,
                                                            setCompanyDashboardTab: setCompanyDashboardTab,
                                                            setTab: setTab,
                                                            isExternal: false
                                                        }) : tab === 'consolidated-diligence' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "w100 h100 p2rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic jcc mb1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: ()=>setTab('diligence-pack'),
                                                                        className: "cp bg4 c1 br35px fw500 fs0-875rem px2rem py0-5rem bw0",
                                                                        children: "Back to Diligence Pack"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9310f9c2b7964d10$export$2e2bcd8739ae039), {
                                                                    src: localStorage.getItem('consolidatedReportUrl'),
                                                                    className: "w100 br10px",
                                                                    style: {
                                                                        height: 'calc(100vh - 120px)'
                                                                    },
                                                                    title: "Consolidated Diligence Report"
                                                                })
                                                            ]
                                                        }) : tab === 'share-diligence-pack' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8082c9444689024$export$2e2bcd8739ae039), {
                                                            company: company,
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            getCompany: getCompany,
                                                            setTab: setTab,
                                                            setTabName: setTabName
                                                        }) : tab === 'company-settings' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ea756d09d9085bc$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            company: company,
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            setTab: setTab,
                                                            getCompany: getCompany,
                                                            handleMemberEdit: handleMemberEdit
                                                        }) : tab === 'checklist-tasks' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3466f5c37a66c198$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            checklistTask: checklistTask,
                                                            user: user,
                                                            company: company,
                                                            setTab: setTab,
                                                            getChecklistTask: getChecklistTask
                                                        }) : tab === 'diligence-pack-reporting' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: company != {} && selectedModules != {} && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b56e0040e90bd8b5$export$2e2bcd8739ae039), {
                                                                profileClass: profileClass,
                                                                user: user,
                                                                company: company,
                                                                aiEnhanced: aiEnhanced,
                                                                setAiEnchaned: setAiEnchaned,
                                                                modules: selectedModules,
                                                                tab: tab,
                                                                setTab: setTabName
                                                            })
                                                        }) : tab === 'company-audit-log' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6a1128853993c07$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            auditReportLogs: auditReportLogs,
                                                            user: user,
                                                            company: company
                                                        }) : tab === 'benchmark-reporting' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82340729f0c68d95$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            user: user,
                                                            company: company,
                                                            tab: tab,
                                                            setTab: setTab
                                                        }) : tab === 'investorMatch' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46df257b3dd34ddd$export$2e2bcd8739ae039), {
                                                            tab: tab,
                                                            user: user,
                                                            setTab: setTab,
                                                            company: company,
                                                            isLeadPdf: isLeadPdf,
                                                            downloadPDF: downloadPDF,
                                                            fitInvestorFirms: fitInvestorFirms,
                                                            setFitInvestorFirms: setFitInvestorFirms,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            handleInvestorEmail: handleInvestorEmail,
                                                            handleContactInvestor: handleContactInvestor,
                                                            investorFirmCounts: investorFirmCounts,
                                                            setInvestorFirmCounts: setInvestorFirmCounts
                                                        }) : [
                                                            `two-minute-test-${company['testType']}`,
                                                            'repository',
                                                            `business-audit-${company['testType']}`,
                                                            'warranty-disclosure',
                                                            'investor-lead',
                                                            'software-development',
                                                            'esg'
                                                        ].includes(tab) || tab.includes('directors-questionnaire') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $866b869d60dd72c1$export$2e2bcd8739ae039), {
                                                            isManualAdd: isManualAdd,
                                                            setTabName: setTabName,
                                                            getCompany: getCompany,
                                                            setIsWorkflowReport: setIsWorkflowReport,
                                                            profileClass: profileClass,
                                                            advisors: user['role'] == 'Advisor' ? advisors : investors,
                                                            permissionLevel: permissionLevel,
                                                            tab: tab,
                                                            setTab: setTab,
                                                            sanitiseTab: $cb3ceb5821786f07$export$57c43fe781091dc0,
                                                            company: {
                                                                ...selectedCompany
                                                            },
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            companyId: companyId,
                                                            openKPI: openKPI,
                                                            toggleReport: toggleReport,
                                                            showAlert: showAlert,
                                                            enableAIEnhancedReporting: enableAIEnhancedReporting,
                                                            calculateStats: calculateStats,
                                                            calculateSubFolderStats: calculateSubFolderStats,
                                                            getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                                                            aiEnhanced: aiEnhanced,
                                                            setAiEnchaned: setAiEnchaned,
                                                            setOpenTabs: setOpenTabs,
                                                            openTabs: openTabs,
                                                            reloadModule: reloadModule,
                                                            twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                                                            cloneImportResult: cloneImportResult,
                                                            setCloneImportResult: setCloneImportResult,
                                                            fileReport: {
                                                                ...fileReport
                                                            },
                                                            setFileReport: (0, $12074930bd2c1829$export$9291658802bc1f31),
                                                            currentScore: currentScore,
                                                            setCurrentScore: (0, $12074930bd2c1829$export$fb8d60304f3762b3),
                                                            reportHistories: reportHistories,
                                                            setReportHistories: setReportHistories,
                                                            sortSections: sortSections,
                                                            companyIndex: companyIndex,
                                                            handleSuperflowNext: handleSuperflowNext,
                                                            setCompanyDashboardTab: setCompanyDashboardTab,
                                                            closeTab: closeTab,
                                                            isBackFitReport: isBackFitReport,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            isLoader: isLoader,
                                                            setIsLoader: setIsLoader
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a901588e5eccdb19$export$2e2bcd8739ae039), {
                                                            closeTab: closeTab,
                                                            setTabName: setTabName,
                                                            setCompanyDashboardTab: setCompanyDashboardTab,
                                                            setIsWorkflowReport: setIsWorkflowReport,
                                                            profileClass: profileClass,
                                                            advisors: user['role'] == 'Advisor' ? advisors : investors,
                                                            permissionLevel: permissionLevel,
                                                            tab: tab,
                                                            setTab: setTab,
                                                            sanitiseTab: $cb3ceb5821786f07$export$57c43fe781091dc0,
                                                            getUser: getUser,
                                                            company: company,
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            companyId: companyId,
                                                            openKPI: openKPI,
                                                            toggleReport: toggleReport,
                                                            enableAIEnhancedReporting: enableAIEnhancedReporting,
                                                            fileReport: {
                                                                ...fileReport
                                                            },
                                                            setFileReport: (0, $12074930bd2c1829$export$9291658802bc1f31),
                                                            reportHistories: reportHistories,
                                                            setReportHistories: setReportHistories,
                                                            calculateStats: calculateStats,
                                                            calculateSubFolderStats: calculateSubFolderStats,
                                                            getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                                                            aiEnhanced: aiEnhanced,
                                                            setAiEnchaned: setAiEnchaned,
                                                            reloadModule: reloadModule,
                                                            twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                                                            sortSections: sortSections,
                                                            handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness,
                                                            updateUserType: updateUserType,
                                                            handlePartnerChecklistNext: handlePartnerChecklistNext,
                                                            isBackFitReport: isBackFitReport,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            isLoader: isLoader,
                                                            setIsLoader: setIsLoader
                                                        }),
                                                        localStorage.getItem('isDemoChecklist') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            class: "pf w90 h10vh df jcsb bg12 b0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    class: "w60 pl3rem fs1rem c1 fw300",
                                                                    children: tab.endsWith("-report") ? isWorkflowReport ? 'Automated Checklist Workflow' : 'Automated Checklist Report' : 'Module Checklist'
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    class: "w40 df jcc aic pa r0 b0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            onClick: (e)=>handleDemoNext(e),
                                                                            className: "cp shadow c1 fw400 fs0-75rem pr br38px w200px h3rem mt6rem df aic jcc bg4",
                                                                            children: [
                                                                                tab.endsWith("-report") || !isPrePopulate ? 'Ok, next' : 'Pre-Populate',
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                    className: "icon pr ml0-5rem",
                                                                                    style: {
                                                                                        top: '3px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                        width: "30",
                                                                                        height: "30",
                                                                                        viewBox: "0 0 30 30",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                                                            fill: "white"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        tab.endsWith("-report") ? isWorkflowReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("2Z82J")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("h9XVc")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        }) : isPrePopulate ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("fv0ry")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("16z8Y")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        localStorage.getItem('isPartnerChecklist') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            class: "df jcc w100 my2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handlePartnerChecklistNext(),
                                                                className: `shadow c1 fw400 fs0-75rem pr br38px w200px h3rem df aic jcc ${company.modules[$cb3ceb5821786f07$export$57c43fe781091dc0(tab)] && company.modules[$cb3ceb5821786f07$export$57c43fe781091dc0(tab)]?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                                                children: "Next"
                                                            })
                                                        }),
                                                        user?.['type'] == 'Superflow' && tab == 'investor-lead' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            class: "df jcc w100 my2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleSuperflowNext(),
                                                                "data-tooltip": company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] != 100 ? 'Please complete the module 100%' : '',
                                                                className: `shadow c1 fw400 fs0-75rem pr br38px w200px h3rem df aic jcc ${company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100 ? 'bg4 cp' : 'bg16 cna'} `,
                                                                children: "Next"
                                                            })
                                                        }),
                                                        user?.['type'] == 'Superflow' && tab == 'Investment Readiness' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            class: "df jcc w100 my2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleCompleteInvestmentReadiness(),
                                                                className: `shadow c1 fw400 fs1rem pr br38px px5rem py0-5rem df aic jcc mr1rem ${company?.modules?.[tab] && company?.modules?.[tab]?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                                                children: "Next"
                                                            })
                                                        })
                                                    ]
                                                }) || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4b71702867a3909$export$2e2bcd8739ae039), {
                                                    linearProgress: linearProgress,
                                                    isWorkflowReport: isWorkflowReport,
                                                    setIsWorkflowReport: setIsWorkflowReport,
                                                    profileClass: profileClass,
                                                    getFitInvestorFirms: getFitInvestorFirms,
                                                    permissionLevel: permissionLevel,
                                                    setCertificateSeeMore: setCertificateSeeMore,
                                                    fitInvestorFirms: fitInvestorFirms,
                                                    user: user,
                                                    company: company,
                                                    setTab: setTab,
                                                    setIsViewTwoMinuteReport: setIsViewTwoMinuteReport,
                                                    selectedSeeMore: selectedSeeMore,
                                                    setSelectedSeeMore: setSelectedSeeMore,
                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                    isGenerateAllResearchAid: isGenerateAllResearchAid,
                                                    investorFirmCounts: investorFirmCounts
                                                }))
                                            ]
                                        }),
                                        companyDashboardTab == 'Analyser' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ed163864272cf1a$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setIsWorkflowReport: setIsWorkflowReport,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel
                                            })
                                        }),
                                        companyDashboardTab == 'AnyLists' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eeccad8a63eab6e4$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setIsWorkflowReport: setIsWorkflowReport,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel,
                                                isLoading: isLoader['show']
                                            })
                                        }),
                                        companyDashboardTab == 'Workflows' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daf292139b169396$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setIsWorkflowReport: setIsWorkflowReport,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel
                                            })
                                        }),
                                        companyDashboardTab == 'ResearchAid' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $779840fc7d20dab3$export$2e2bcd8739ae039), {
                                                company: company,
                                                getCompany: getCompany,
                                                setTab: setTab,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel,
                                                isGenerateAllResearchAid: isGenerateAllResearchAid
                                            })
                                        }),
                                        companyDashboardTab == 'InvestorMatch' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46df257b3dd34ddd$export$2e2bcd8739ae039), {
                                                tab: tab,
                                                user: user,
                                                setTab: setTab,
                                                company: company,
                                                isLeadPdf: isLeadPdf,
                                                downloadPDF: downloadPDF,
                                                linearProgress: linearProgress,
                                                fitInvestorFirms: fitInvestorFirms,
                                                setFitInvestorFirms: setFitInvestorFirms,
                                                setIsBackFitReport: setIsBackFitReport,
                                                handleInvestorEmail: handleInvestorEmail,
                                                getFitInvestorFirms: getFitInvestorFirms,
                                                handleContactInvestor: handleContactInvestor,
                                                investorFirmCounts: investorFirmCounts,
                                                setInvestorFirmCounts: setInvestorFirmCounts
                                            })
                                        }),
                                        companyDashboardTab == 'AppStore' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5414be11cddc08f$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel,
                                                user: user
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100 company-dashboard",
                                    value: "Team",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dc3b81abd8d4ee8$export$2e2bcd8739ae039), {
                                        company: company,
                                        teamMembers: company?.['members'],
                                        setEditUser: setEditUser,
                                        setUserAction: setUserAction,
                                        resendInviteMember: resendInviteMember,
                                        handleDeleteMember: handleDeleteMember
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100 company-dashboard",
                                    value: "Portfolio Dashboard",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f14fac7464a42f8a$export$2e2bcd8739ae039), {
                                        permissionLevel: permissionLevel,
                                        company: company,
                                        companyId: companyId,
                                        setTab: setTab,
                                        setDashboardTab: setDashboardTab,
                                        setCompanyDashboardTab: setCompanyDashboardTab,
                                        setIsWorkflowReport: setIsWorkflowReport
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c218604756c85649$export$2e2bcd8739ae039), {
                handleClose: ()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    setCompanyDashboardTab('InvestorMatch');
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "generatedResearchAidReports",
                open: modal['open'] == 'generatedResearchAidReports',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr my1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-25rem fw600 c15 my2rem mb2rem tac",
                                    children: "ResearchAid Reports Generated"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("ase4v")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mxa",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem fw400 c15 mt3rem mb1rem",
                                            children: [
                                                "Reports from ResearchAid are generated!",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "Let\u2019s go to your ResearchAid tab"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tac w100 db",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleRedirectResearchAid(),
                                                className: "cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                                children: "Next"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "applyInvestorMatchPopup",
                open: modal['open'] == 'applyInvestorMatchPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w800px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df my1rem",
                                src: (parcelRequire("kpQLa")),
                                alt: ""
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df my1rem",
                                src: (parcelRequire("1IN79")),
                                alt: ""
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c15 fs1-25rem fw400 tac mb1rem",
                                children: [
                                    "Thank you for applying to Investor",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "c4",
                                        children: "Match"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1-25rem fw400 tac mb1rem",
                                children: "Thank you for applying for investment from us."
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c14 fs0-75rem fw300 tac mb1rem",
                                children: [
                                    "We will notify you of your investor matches and name/details 3 days before ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " the show. (Many investors only buy tickets shortly before the show)"
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c14 fs0-75rem fw300 tac mb1rem",
                                children: [
                                    "We will be in touch with you shortly once we have reviewed your ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " application."
                                ]
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("9FXIX")),
                                alt: ""
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1rem fw500 tac mt1rem",
                                children: "Want to increase investor interest?"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1rem fw500 tac mt3rem",
                                children: "Want a speedier decision?"
                            }),
                            partner?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tac w100 db",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/completeInvestment/${partner['_id']}?companyId=${company['_id']}&cName=${company['cName']}`,
                                    className: "cp px5rem py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                    children: "Next"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "superFlowPopup",
                open: modal['open'] == 'superFlowPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w100 df",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "mr3rem",
                                        src: (parcelRequire("iGe5G")),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "df fdc jcc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "w100 c15 fs1-25rem fw500 my1rem",
                                                children: [
                                                    "Thank you for completing your Investor",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c4",
                                                        children: "Match"
                                                    }),
                                                    " assessment"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c15 fs1-25rem fw500 tac",
                                                children: "You are well on the way to accessing your goodies!"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w50 df jcsb my2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("dCaAd")),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w30 df fdc fs10px fw300 tas p1rem bw1px bo16 bss br15px",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c15 fs0-75rem fw600 mb1rem",
                                                children: "Investor Matches"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c12 lh2 mb0-5rem",
                                                children: "We have found you a number of database matches."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: `w100 fs1rem lh1 fw600 ${fitInvestorFirms.length > 0 ? 'c34' : 'c16'}`,
                                                children: [
                                                    fitInvestorFirms.length,
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `fs10px fw500 ${fitInvestorFirms.length > 0 ? 'c15' : 'c12'}`,
                                                        children: "Matches"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df jcc my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "c15 fs1-25rem fw500",
                                    children: "Now let\u2019s complete your Investment Readiness checklist"
                                })
                            }),
                            partner?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w80 df jce my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>nextInvestmentReadiness(),
                                    className: "df jcc cp w30 py0-5rem c1 bg4 bg3-hover br35px fw400 fs1rem",
                                    children: "Next"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'userList',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100  bsbb df fdc m1rem maw900px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Members"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: [
                                company['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr df aic fs1rem-sm",
                                    children: [
                                        company['creatorId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: company['creatorId']?.['profile'],
                                            className: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                            "data-tooltip": company['creatorId'].firstName ? company['creatorId'].firstName + " " + (company['creatorId']?.lastName ? company['creatorId']?.lastName : "") : "Register to show your name here"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                            children: company?.['creatorId']?.['firstName']?.[0]?.toUpperCase() + (company?.['creatorId']?.['lastName'] ? company?.['creatorId']?.['lastName']?.[0]?.toUpperCase() : "")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                marginLeft: "1.5rem"
                                            },
                                            className: "pl2rem br5px shadow h4rem w100 bg5 df aic dg gtcr7-md gg1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem",
                                                    children: company['creatorId']['firstName']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-75rem",
                                                    children: " Owner "
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem",
                                                    children: [
                                                        " ",
                                                        company['creatorId']['email'],
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem tac"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-75rem c7",
                                                    children: "Active"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem tac",
                                                    children: [
                                                        " ",
                                                        company['creatorId']?.['lastLogin'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                "Last Login:",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: (new Date().getTime() - new Date(company['creatorId']['lastLogin']).getTime()) / 2592000000 > 3 ? 'c9' : 'c7',
                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['creatorId']['lastLogin']).format('ll')
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem tac"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                company['members'] && company['members'].map((user)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr df aic fs1rem-sm",
                                        children: [
                                            user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: user?.['profile'],
                                                className: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                                "data-tooltip": user.firstName ? user.firstName + " " + (user?.lastName ? user?.lastName : "") : "Register to show your name here"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                                children: (user?.['firstName'] ? user?.['firstName']?.[0]?.toUpperCase() : '') + (user?.['lastName'] ? user?.['lastName']?.[0]?.toUpperCase() : '')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    marginLeft: "1.5rem"
                                                },
                                                className: "pl2rem br5px shadow h4rem w100 bg5 df aic dg gtcr7-md gg1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem",
                                                        children: user['firstName']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem",
                                                        children: [
                                                            " ",
                                                            user['designation']?.toUpperCase(),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem",
                                                        children: [
                                                            " ",
                                                            user['email'],
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem tac",
                                                        onClick: ()=>handleMemberEdit(user),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            className: "cp",
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-edit"
                                                                }),
                                                                " Edit "
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `fs0-75rem ${user['emailVerified'] ? ' c7' : ' c8'}`,
                                                        children: user['emailVerified'] ? 'Active' : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                "Invite Sent ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(user['updatedAt']).format('ll')
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem tac",
                                                        children: [
                                                            " ",
                                                            !user['emailVerified'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    className: "cp",
                                                                    onClick: ()=>resendInviteMember(user['_id']),
                                                                    children: [
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "fa fa-history c8"
                                                                        }),
                                                                        " Resend "
                                                                    ]
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    "Last Login:",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: (new Date().getTime() - new Date(user['lastLogin']).getTime()) / 2592000000 > 3 ? 'c9' : 'c7',
                                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(user['lastLogin']).format('ll')
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs1rem tac",
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                className: "cp",
                                                                onClick: ()=>handleDeleteMember(user['_id']),
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "fa fa-trash c9"
                                                                    }),
                                                                    " Delete "
                                                                ]
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `team-member-${user['_id']}`)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'editUser'
                                        }));
                                        setEditUser({});
                                        setUserAction('Search');
                                    },
                                    className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                    children: "New Member"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setSelectAll(false);
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'generatingAIReport',
                onCloseHandler: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h9rem",
                                src: (parcelRequire("hA45b")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1-5rem c15",
                                children: "Generating AI Report"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb1-5rem c15 fs12px px1rem op70",
                                children: [
                                    "Whilst we prepare your bespoked 2-minute test report, why don\u2019t your bonus ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        className: "fsi",
                                        children: "BONUS KPI Report"
                                    }),
                                    " which suggests 10 useful business metrics for your business, how to calculate them, and your industry comparables.  You can then click on the \u201C2 Minute Test Report\u201D button to view it."
                                ]
                            })
                        ]
                    }),
                    tab != 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "21",
                                height: "22",
                                viewBox: "0 0 21 22",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_5984_61323)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.2524 14.5155L6.983 5.24614C6.78588 5.04898 6.50209 4.96547 6.22959 5.02441C5.95708 5.08335 5.73313 5.27662 5.63506 5.5376L0.0524681 20.391C-0.060735 20.6922 0.0126009 21.0318 0.240033 21.2594C0.468654 21.4882 0.80855 21.5601 1.10829 21.4477L15.9717 15.8751C16.5385 15.6633 16.6837 14.9286 16.2524 14.5155ZM9.343 16.6082L3.99936 14.5529L5.00453 11.8785L13.3732 15.0972L9.343 16.6082ZM6.723 7.30632L12.3704 12.9537L5.58183 10.3427L6.723 7.30632ZM3.42215 16.0887L7.02869 17.4759L2.22371 19.2774L3.42215 16.0887Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.2407 4.70189C13.2024 3.7402 13.2026 2.18349 12.2407 1.22159C11.2811 0.262073 9.71997 0.262073 8.76041 1.22159C7.79868 2.18333 7.79855 3.74003 8.76041 4.70189C9.71985 5.66133 11.2811 5.66145 12.2407 4.70189ZM9.9205 2.38168C10.2403 2.06188 10.7607 2.06184 11.0806 2.38168C11.4012 2.70226 11.4012 3.22115 11.0806 3.54176C10.7607 3.8616 10.2403 3.8616 9.9205 3.54176C9.59992 3.22119 9.59992 2.7023 9.9205 2.38168Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M19.6484 10.6074H18.8281V9.78711C18.8281 9.33405 18.4609 8.9668 18.0078 8.9668C17.5548 8.9668 17.1875 9.33405 17.1875 9.78711V10.6074H16.3672C15.9141 10.6074 15.5469 10.9747 15.5469 11.4277C15.5469 11.8808 15.9141 12.248 16.3672 12.248H17.1875V13.0684C17.1875 13.5214 17.5548 13.8887 18.0078 13.8887C18.4609 13.8887 18.8281 13.5214 18.8281 13.0684V12.248H19.6484C20.1015 12.248 20.4688 11.8808 20.4688 11.4277C20.4688 10.9747 20.1015 10.6074 19.6484 10.6074Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.1231 8.43608C16.4435 8.11571 16.4435 7.59633 16.1231 7.276C15.8026 6.9555 15.8024 6.43653 16.1231 6.11591C16.4437 5.79538 16.9625 5.79529 17.2832 6.11591C17.6038 6.43649 18.1232 6.43604 18.4433 6.11591C18.7637 5.79554 18.7636 5.27616 18.4433 4.95583C18.1228 4.63533 18.1226 4.11636 18.4433 3.79574C18.7638 3.47516 19.2828 3.47512 19.6033 3.79574C19.9237 4.11611 20.4431 4.11611 20.7635 3.79574C21.0838 3.47537 21.0838 2.95599 20.7635 2.63566C19.8039 1.67609 18.2426 1.67618 17.2832 2.63566C16.8507 3.06808 16.5994 3.63316 16.5664 4.23908C15.9604 4.27206 15.3953 4.52344 14.963 4.95587C14.4982 5.4207 14.2422 6.03868 14.2422 6.69604C14.2422 7.3534 14.4982 7.97138 14.963 8.43621C15.2834 8.75642 15.8028 8.75642 16.1231 8.43608Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M15.4219 2.14062C15.8749 2.14062 16.2422 1.77336 16.2422 1.32031C16.2422 0.867266 15.8749 0.5 15.4219 0.5C14.9688 0.5 14.6016 0.867266 14.6016 1.32031C14.6016 1.77336 14.9688 2.14062 15.4219 2.14062Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.1797 8.53906C20.6327 8.53906 21 8.1718 21 7.71875C21 7.2657 20.6327 6.89844 20.1797 6.89844C19.7266 6.89844 19.3594 7.2657 19.3594 7.71875C19.3594 8.1718 19.7266 8.53906 20.1797 8.53906Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.1406 8.53906C12.5937 8.53906 12.9609 8.1718 12.9609 7.71875C12.9609 7.2657 12.5937 6.89844 12.1406 6.89844C11.6876 6.89844 11.3203 7.2657 11.3203 7.71875C11.3203 8.1718 11.6876 8.53906 12.1406 8.53906Z",
                                                fill: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_5984_61323",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "21",
                                                height: "21",
                                                fill: "white",
                                                transform: "translate(0 0.5)"
                                            })
                                        })
                                    })
                                ]
                            }),
                            btnType: "warning",
                            text: "Free KPI Report",
                            textClassName: "ttu",
                            customClassName: "df",
                            onClick: ()=>openKPI()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'completeAIReport',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px6rem py3rem bsbb df fdc aic m1rem maw800px pr pt5rem br20px pr",
                    style: {
                        backgroundImage: `url(${(parcelRequire("dJEkK"))})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        lineHeight: '1.8'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "mb1-5rem c15",
                            children: "AI Report Now Complete!\u200B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac c12",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb1-5rem c15 fs12px px1rem op70",
                                    children: '"\uD83C\uDF1F Huzzah, Valiant Voyager! \uD83C\uDF1F The stars have aligned and the spells have been cast. Your AI-enhanced report has been meticulously crafted and is now ready for your discerning eyes. Unveil the magic and insights within... simply click below to embark on this revelation! \uD83D\uDCDC\u2728"\u200B'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h8rem",
                                    src: (parcelRequire("ase4v")),
                                    alt: ""
                                })
                            ]
                        }),
                        moduleAI !== '' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>{
                                setTab(moduleAI + "-report", true);
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            },
                            className: `w40 df jcc aic fw500 px1rem py0-5rem c1 bg4 br19px cp`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 448 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                        })
                                    ]
                                }),
                                "View AI Report"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75097013a2b9925d$export$2e2bcd8739ae039), {
                modalType: "firstSetupDataRepository",
                dispatch: dispatch,
                companyId: companyId,
                company: company
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'DataRepositorySetupSteps',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: company.cName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                children: "Diligentsia Filing Assistant"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step1. Select your data room folders/files to be ingested"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "pen h2rem",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z",
                                        style: {
                                            fill: '#4A67FF'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step2. With the use of AI we do our magic in the background and allocate your files to our Repository sections"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "pen h2rem",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z",
                                        style: {
                                            fill: '#4A67FF'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step3. You review the allocation of your files to our sections and reallocate if desired"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "pen h2rem",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z",
                                        style: {
                                            fill: '#4A67FF'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step4. You can (optionally) remove duplicated files using our deduper"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc fdr jcc aic mt2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 w40 ttu bsbb tac mb1rem df jcc aic mr1rem",
                                children: "Let's go to Filing Assistant"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'connectingDataRoom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fw600 pb1rem",
                            children: [
                                props.storageName || 'Data Room',
                                " to be Connected!"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac my1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb0-5rem",
                                    children: "Setting up a replica (backup) Diligentsia folder structure in your chosen cloud Data Room will take a few moments.  Once created, you will be able to sync between the two platforms, effectively creating a backup on your cloud."
                                }),
                                props.storageId != 'GDrive' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb0-5rem fs0-75rem",
                                    children: "If you already have a data room, You can also choose to copy files from other folders in your cloud folders to the Diligentsia Data Room folder in your cloud. You can  then import/sync them. Your files imported in this manner coloured differently depending upon their source.  You will then need to go into each section and mark that section as \u201Ccomplete\u201D.\u200B"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb0-5rem",
                                    children: "We keep an audit log of all changes and have comprehensive reporting."
                                }),
                                props.storageId == 'GDrive' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h10rem",
                                    src: (parcelRequire("3Ow7q")),
                                    alt: ""
                                }),
                                props.storageId == 'dropbox' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h10rem",
                                    src: (parcelRequire("46E3R")),
                                    alt: ""
                                }),
                                props.storageId == 'sharepoint' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h10rem",
                                    src: (parcelRequire("8HFxV")),
                                    alt: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "px1rem py0-5rem mr1rem fw600",
                                children: "Patience!\u200B"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'createdDataRoom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb0-5rem",
                                children: [
                                    "Good news!  Your Cloud Data",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Room has now been created.",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "You can now sync.\u200B"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttu bsbb df jcc",
                                onClick: ()=>{
                                    moveToCompanyPage();
                                },
                                children: "Let\u2019s go!\u200B"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteMember',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Delete Member"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac my1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c15",
                                        children: "Are you certain you want to delete Member?"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "new-shadow bg4 bg3-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>submitDeleteMember(),
                                            className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                            children: "Submit"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'investorEmailSent',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw500px pr pt3rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 tac",
                            children: "Contact Investor"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs1rem",
                                children: [
                                    "Are you sure you want to contact investor ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: investorEmail['name']
                                    }),
                                    "?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>{
                                        setInvestorEmail({}), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                    },
                                    className: "h100 mt0-5rem shadow bg4 c1 td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>sendInvestorEmail(),
                                    className: "bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Send Email"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'twoMinuteTestCompleted',
                onCloseHandler: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "maw100px mah100px mb1rem",
                                width: "100",
                                height: "101",
                                viewBox: "0 0 118 119",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "59",
                                        cy: "59.5",
                                        r: "59",
                                        fill: "#15D757",
                                        "fill-opacity": "0.2"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_6321_2)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M53 75.4999C52.207 75.4999 51.443 75.1859 50.879 74.6208L42.879 66.6208C41.707 65.4499 41.707 63.5499 42.879 62.3789C44.05 61.2069 45.95 61.2069 47.121 62.3789L52.675 67.9328L68.599 46.6999C69.595 45.3739 71.477 45.1069 72.799 46.0999C74.125 47.0939 74.394 48.9748 73.4 50.2998L55.4 74.2999C54.879 74.9958 54.08 75.4309 53.213 75.4919C53.142 75.4969 53.07 75.4999 53 75.4999Z",
                                                fill: "#15D757"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M35 60.5H30C29.447 60.5 29 60.053 29 59.5C29 58.947 29.447 58.5 30 58.5H35C35.553 58.5 36 58.947 36 59.5C36 60.053 35.553 60.5 35 60.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M33.8838 74.9998C33.5378 74.9998 33.2018 74.8208 33.0168 74.4998C32.7408 74.0208 32.9048 73.4098 33.3828 73.1338L37.7128 70.6338C38.1898 70.3588 38.8018 70.5208 39.0788 70.9998C39.3548 71.4788 39.1908 72.0898 38.7128 72.3658L34.3828 74.8658C34.2258 74.9568 34.0538 74.9998 33.8838 74.9998Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M44.4997 85.6139C44.3297 85.6139 44.1577 85.5709 44.0007 85.4799C43.5217 85.2039 43.3577 84.5919 43.6347 84.1139L46.1347 79.7839C46.4117 79.3049 47.0227 79.1409 47.5007 79.4179C47.9787 79.6949 48.1437 80.3059 47.8667 80.7839L45.3667 85.1139C45.1807 85.4339 44.8457 85.6139 44.4997 85.6139Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M59 89.5C58.447 89.5 58 89.053 58 88.5V83.5C58 82.947 58.447 82.5 59 82.5C59.553 82.5 60 82.947 60 83.5V88.5C60 89.053 59.553 89.5 59 89.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M73.501 85.6134C73.155 85.6134 72.819 85.4344 72.634 85.1134L70.134 80.7834C69.858 80.3044 70.022 79.6934 70.5 79.4174C70.976 79.1414 71.589 79.3044 71.866 79.7834L74.366 84.1134C74.642 84.5924 74.478 85.2034 74 85.4794C73.843 85.5704 73.671 85.6134 73.501 85.6134Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M84.1109 75.0002C83.9409 75.0002 83.7689 74.9572 83.6119 74.8662L79.2819 72.3662C78.8029 72.0902 78.6389 71.4782 78.9159 71.0002C79.1919 70.5212 79.8049 70.3582 80.2819 70.6342L84.6119 73.1342C85.0909 73.4102 85.2549 74.0222 84.9779 74.5002C84.7919 74.8212 84.4569 75.0002 84.1109 75.0002Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M88 60.5H83C82.447 60.5 82 60.053 82 59.5C82 58.947 82.447 58.5 83 58.5H88C88.553 58.5 89 58.947 89 59.5C89 60.053 88.553 60.5 88 60.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M79.7823 48.5007C79.4363 48.5007 79.1003 48.3217 78.9153 48.0007C78.6393 47.5217 78.8033 46.9107 79.2813 46.6347L83.6113 44.1347C84.0883 43.8577 84.7013 44.0217 84.9773 44.5007C85.2533 44.9797 85.0893 45.5907 84.6113 45.8667L80.2813 48.3667C80.1243 48.4577 79.9523 48.5007 79.7823 48.5007Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M70.9997 39.7154C70.8297 39.7154 70.6577 39.6724 70.5007 39.5814C70.0217 39.3054 69.8577 38.6934 70.1347 38.2154L72.6347 33.8854C72.9107 33.4064 73.5227 33.2424 74.0007 33.5194C74.4787 33.7964 74.6437 34.4074 74.3667 34.8854L71.8667 39.2154C71.6807 39.5354 71.3457 39.7154 70.9997 39.7154Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M59 36.5C58.447 36.5 58 36.053 58 35.5V30.5C58 29.947 58.447 29.5 59 29.5C59.553 29.5 60 29.947 60 30.5V35.5C60 36.053 59.553 36.5 59 36.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M47.001 39.717C46.655 39.717 46.319 39.538 46.134 39.217L43.634 34.887C43.358 34.408 43.522 33.797 44 33.521C44.477 33.245 45.09 33.408 45.366 33.887L47.866 38.217C48.142 38.696 47.978 39.307 47.5 39.583C47.343 39.674 47.171 39.717 47.001 39.717Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M38.2125 48.4992C38.0425 48.4992 37.8705 48.4562 37.7135 48.3652L33.3835 45.8652C32.9045 45.5892 32.7405 44.9772 33.0175 44.4992C33.2935 44.0202 33.9055 43.8552 34.3835 44.1332L38.7135 46.6332C39.1925 46.9092 39.3565 47.5212 39.0795 47.9992C38.8935 48.3202 38.5585 48.4992 38.2125 48.4992Z",
                                                fill: "#AEE090"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_6321_2",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "60",
                                                height: "60",
                                                fill: "white",
                                                transform: "translate(29 29.5)"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1-5rem c15",
                                children: "Two Minute Test Completed"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb1-5rem c15 fs12px px1rem op70",
                                children: [
                                    "Whilst we prepare your report, please glance at your ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        className: "fsi",
                                        children: "BONUS KPI Report"
                                    }),
                                    " which has been tailored to your business and suggests 10  useful business metrics, how to calculate them, and what your industry comparables could be."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "21",
                                height: "22",
                                viewBox: "0 0 21 22",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_5984_61323)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.2524 14.5155L6.983 5.24614C6.78588 5.04898 6.50209 4.96547 6.22959 5.02441C5.95708 5.08335 5.73313 5.27662 5.63506 5.5376L0.0524681 20.391C-0.060735 20.6922 0.0126009 21.0318 0.240033 21.2594C0.468654 21.4882 0.80855 21.5601 1.10829 21.4477L15.9717 15.8751C16.5385 15.6633 16.6837 14.9286 16.2524 14.5155ZM9.343 16.6082L3.99936 14.5529L5.00453 11.8785L13.3732 15.0972L9.343 16.6082ZM6.723 7.30632L12.3704 12.9537L5.58183 10.3427L6.723 7.30632ZM3.42215 16.0887L7.02869 17.4759L2.22371 19.2774L3.42215 16.0887Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.2407 4.70189C13.2024 3.7402 13.2026 2.18349 12.2407 1.22159C11.2811 0.262073 9.71997 0.262073 8.76041 1.22159C7.79868 2.18333 7.79855 3.74003 8.76041 4.70189C9.71985 5.66133 11.2811 5.66145 12.2407 4.70189ZM9.9205 2.38168C10.2403 2.06188 10.7607 2.06184 11.0806 2.38168C11.4012 2.70226 11.4012 3.22115 11.0806 3.54176C10.7607 3.8616 10.2403 3.8616 9.9205 3.54176C9.59992 3.22119 9.59992 2.7023 9.9205 2.38168Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M19.6484 10.6074H18.8281V9.78711C18.8281 9.33405 18.4609 8.9668 18.0078 8.9668C17.5548 8.9668 17.1875 9.33405 17.1875 9.78711V10.6074H16.3672C15.9141 10.6074 15.5469 10.9747 15.5469 11.4277C15.5469 11.8808 15.9141 12.248 16.3672 12.248H17.1875V13.0684C17.1875 13.5214 17.5548 13.8887 18.0078 13.8887C18.4609 13.8887 18.8281 13.5214 18.8281 13.0684V12.248H19.6484C20.1015 12.248 20.4688 11.8808 20.4688 11.4277C20.4688 10.9747 20.1015 10.6074 19.6484 10.6074Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.1231 8.43608C16.4435 8.11571 16.4435 7.59633 16.1231 7.276C15.8026 6.9555 15.8024 6.43653 16.1231 6.11591C16.4437 5.79538 16.9625 5.79529 17.2832 6.11591C17.6038 6.43649 18.1232 6.43604 18.4433 6.11591C18.7637 5.79554 18.7636 5.27616 18.4433 4.95583C18.1228 4.63533 18.1226 4.11636 18.4433 3.79574C18.7638 3.47516 19.2828 3.47512 19.6033 3.79574C19.9237 4.11611 20.4431 4.11611 20.7635 3.79574C21.0838 3.47537 21.0838 2.95599 20.7635 2.63566C19.8039 1.67609 18.2426 1.67618 17.2832 2.63566C16.8507 3.06808 16.5994 3.63316 16.5664 4.23908C15.9604 4.27206 15.3953 4.52344 14.963 4.95587C14.4982 5.4207 14.2422 6.03868 14.2422 6.69604C14.2422 7.3534 14.4982 7.97138 14.963 8.43621C15.2834 8.75642 15.8028 8.75642 16.1231 8.43608Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M15.4219 2.14062C15.8749 2.14062 16.2422 1.77336 16.2422 1.32031C16.2422 0.867266 15.8749 0.5 15.4219 0.5C14.9688 0.5 14.6016 0.867266 14.6016 1.32031C14.6016 1.77336 14.9688 2.14062 15.4219 2.14062Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.1797 8.53906C20.6327 8.53906 21 8.1718 21 7.71875C21 7.2657 20.6327 6.89844 20.1797 6.89844C19.7266 6.89844 19.3594 7.2657 19.3594 7.71875C19.3594 8.1718 19.7266 8.53906 20.1797 8.53906Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.1406 8.53906C12.5937 8.53906 12.9609 8.1718 12.9609 7.71875C12.9609 7.2657 12.5937 6.89844 12.1406 6.89844C11.6876 6.89844 11.3203 7.2657 11.3203 7.71875C11.3203 8.1718 11.6876 8.53906 12.1406 8.53906Z",
                                                fill: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_5984_61323",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "21",
                                                height: "21",
                                                fill: "white",
                                                transform: "translate(0 0.5)"
                                            })
                                        })
                                    })
                                ]
                            }),
                            btnType: "warning",
                            text: "Free KPI Report",
                            textClassName: "ttu",
                            customClassName: "df",
                            onClick: ()=>{
                                openKPI(), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'notSupportPersonalAccount',
                onCloseHandler: moveToCompanyPage,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "60",
                                height: "60",
                                viewBox: "0 0 82 82",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M40.9346 76C60.3018 76 76.002 60.2998 76.002 40.9326C76.002 21.5654 60.3018 5.86523 40.9346 5.86523C21.5674 5.86523 5.86719 21.5654 5.86719 40.9326C5.86719 60.2998 21.5674 76 40.9346 76Z",
                                        fill: "url(#paint0_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M75.8262 44.4635L45.6436 14.2808C44.6406 12.9422 42.8694 12.8047 40.8963 12.8047C37.7014 12.8047 35.7969 13.9299 35.7969 16.9691C35.7969 26.2423 36.8879 39.5683 36.8879 48.8416C36.8879 50.0536 36.8291 50.9124 37.672 51.4674L57.8565 71.6519C67.6994 66.2184 74.6533 56.1932 75.8262 44.4635Z",
                                        fill: "url(#paint1_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M57.5222 71.8347L45.3323 59.6447C44.2374 58.4271 42.6732 57.9434 40.9715 57.9434C37.5426 57.9434 35.2656 60.3763 35.2656 63.6493C35.2656 65.3942 35.7417 67.0187 36.9961 68.1378L44.6613 75.803C49.2741 75.3157 53.6198 73.9344 57.5222 71.8347Z",
                                        fill: "url(#paint2_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M46.8997 63.6494C46.8997 66.8446 44.1724 69.65 40.9772 69.65C37.5482 69.65 34.9766 66.8446 34.9766 63.6494C34.9766 60.3765 37.5482 57.6488 40.9772 57.6488C44.1724 57.6488 46.8997 60.3765 46.8997 63.6494ZM45.4192 48.8431C45.4192 51.259 42.7695 52.272 40.8991 52.272C38.4055 52.272 36.3014 51.259 36.3014 48.8431C36.3014 39.5699 35.2103 26.2438 35.2103 16.9706C35.2103 13.9314 37.704 12.2168 40.8991 12.2168C43.9383 12.2168 46.51 13.9311 46.51 16.9706C46.5102 26.2438 45.4192 39.5696 45.4192 48.8431Z",
                                        fill: "url(#paint3_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint0_linear_5984_47190",
                                                x1: "24.6242",
                                                y1: "24.6222",
                                                x2: "58.4244",
                                                y2: "58.4225",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#FF637B"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#E63950"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint1_linear_5984_47190",
                                                x1: "62.8505",
                                                y1: "50.2933",
                                                x2: "26.647",
                                                y2: "26.0601",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#E63950",
                                                        "stop-opacity": "0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.0467",
                                                        "stop-color": "#E4354B",
                                                        "stop-opacity": "0.047"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.4669",
                                                        "stop-color": "#D31822",
                                                        "stop-opacity": "0.467"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.7991",
                                                        "stop-color": "#C90709",
                                                        "stop-opacity": "0.799"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#C50000"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint2_linear_5984_47190",
                                                x1: "54.4907",
                                                y1: "74.2011",
                                                x2: "36.1085",
                                                y2: "61.5086",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#E63950",
                                                        "stop-opacity": "0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.0467",
                                                        "stop-color": "#E4354B",
                                                        "stop-opacity": "0.047"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.4669",
                                                        "stop-color": "#D31822",
                                                        "stop-opacity": "0.467"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.7991",
                                                        "stop-color": "#C90709",
                                                        "stop-opacity": "0.799"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#C50000"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint3_linear_5984_47190",
                                                x1: "34.9769",
                                                y1: "40.9333",
                                                x2: "46.8997",
                                                y2: "40.9333",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#EDF5FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#D5E8FE"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1-5rem c15",
                                children: "Only Microsoft business accounts are supported"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb1-5rem c15 fs12px px1rem op70",
                                children: "Diligentsia only supports data synchronisation with Microsoft 365 Sharepoint business accounts.  These are sometimes called \u2018Work or School\u2019 accounts by Microsoft. You may have been trying to connect to a Microsoft personal account."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $297fb5ec09626165$export$2e2bcd8739ae039), {}),
                            btnType: "warning",
                            text: "Try with Diffrent Account",
                            textClassName: "ttu",
                            customClassName: "df",
                            onClick: moveToCompanyPage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "uploadProfile",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `top-header py1rem px2rem df jcsb aic ${profileClass}`,
                            style: {
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Upload Company Logo"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc p3rem",
                            children: [
                                uploadImage == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "profile",
                                    className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs1rem fw500 tac",
                                            children: "Upload Logo"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "file",
                                                className: "",
                                                id: "profile",
                                                onChange: (e)=>handleUploadImage(e),
                                                accept: "image/jpeg, image/jpg, image/png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: "Max file size 5MB"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                        ref: $cb3ceb5821786f07$var$cropper,
                                        guides: false,
                                        src: uploadImage,
                                        aspectRatio: 1,
                                        className: "cropper-settings",
                                        style: {
                                            maxHeight: "500px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ""
                                                })),
                                            className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>updateProfile(),
                                            className: `shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem`,
                                            children: Object.keys(uploadImage).length == 0 ? "Upload" : "Crop & Upload"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'showDirectors',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop showDirectors td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr maw1000px inner-showDirectors pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "c15 fw600 tac ",
                                    children: "LIST OF QUESTIONNAIRES"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tar my0-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'addDirector'
                                            })),
                                        className: "cp tac c1 bg3 br5px shadow px0-25rem py0-5rem fw500 director-add",
                                        children: "Add a Director or Senior Manager\u200B"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "table-area-showDirectors",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    id: "table",
                                    className: "table-showDirectors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "ps t0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Designation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Progress"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: directors && directors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: directors.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: `${item['headShot'] && 'df aic '} c6 fw500 ttc`,
                                                                children: [
                                                                    item['headShot'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: item['headShot']['location'],
                                                                        className: "w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem"
                                                                    }),
                                                                    item['name']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c6 fw500 ttc",
                                                                children: item['designation']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "p1rem c6 fw500 ttc",
                                                                children: [
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['completionPercent'] || 0, 'Completeness'),
                                                                    ". ",
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['riskPercent'] || 0, 'Risk')
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "df jcfs aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `#directors-questionnaire_${item['_id']}`,
                                                                        onClick: ()=>handleViewDirector(item),
                                                                        className: "cp tac px1rem py0-5rem br5px fw500",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            class: "fa fa-eye fs1-5rem c4",
                                                                            style: {
                                                                                fontSize: '22px'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        class: "cp",
                                                                        onClick: ()=>handleDeleteDirector(item),
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                fontSize: '24px',
                                                                                color: '#FC7785'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, `director-${item['_id'] || idx}`))
                                            })
                                        })
                                    ]
                                }),
                                directors && directors.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac py3rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-gradient fw600",
                                        children: "No Directors Added"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "logo-modal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h2rem",
                                        src: (parcelRequire("aR1CT")),
                                        alt: "TODO"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "deleteDirector",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "c15 fs2rem tac lh1 fw600 mb2rem",
                        children: "DELETE DIRECTOR"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fs1rem fw500 mb1rem c15 tac w100",
                        children: [
                            "Are you sure you want to remove ",
                            selectedDirector['name'],
                            " as a Director or Senior Manager. This action cannot be reversed."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc aic gg1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                onClick: ()=>handleDeleteDirector(),
                                btnType: "warning",
                                text: "Delete Director"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                btnType: "outline",
                                text: "Cancel"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'addDirector',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "ADD DIRECTOR"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "directorName",
                                            type: "text",
                                            placeholder: "Name of Director",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 640 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                className: "fa-secondary"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "directorDesignation",
                                            type: "text",
                                            placeholder: "Designation of Director",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-288C0 117.5 21.5 96 48 96h416C490.5 96 512 117.5 512 144z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M176 96H128V48C128 21.5 149.5 0 176 0h160C362.5 0 384 21.5 384 48V96h-48V48h-160V96z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    onClick: ()=>createDirector(),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen ml0-5rem h1rem f1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 640 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M616 200h-48v-48C568 138.8 557.3 128 544 128s-24 10.75-24 24v48h-48C458.8 200 448 210.8 448 224s10.75 24 24 24h48v48C520 309.3 530.8 320 544 320s24-10.75 24-24v-48h48C629.3 248 640 237.3 640 224S629.3 200 616 200z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"
                                                })
                                            ]
                                        }),
                                        "Add Director"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'showDirectors'
                                        })),
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Back to List of Questionaire's"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'editUser',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: [
                                        userAction,
                                        " User"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah600px oya advisor-box-content",
                            children: userAction === 'Search' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "searchEmail",
                                                name: "searchEmail",
                                                type: "email",
                                                placeholder: "Search Email",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        id: "NewUserStep",
                                        onClick: findUser,
                                        className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                        children: "Search User"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userFirstName",
                                                name: "firstName",
                                                type: "text",
                                                placeholder: "First Name",
                                                onChange: handleUserChange,
                                                value: editUser['firstName'] || "",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userLastName",
                                                name: "lastName",
                                                type: "text",
                                                placeholder: "Last Name",
                                                onChange: handleUserChange,
                                                value: editUser['lastName'] || "",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userEmail",
                                                name: "email",
                                                type: "email",
                                                placeholder: "Email",
                                                onChange: handleUserChange,
                                                value: editUser['email'] || "",
                                                disabled: userAction == 'Edit' || userAction == 'Add' ? true : false,
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "designation",
                                                name: "designation",
                                                type: "text",
                                                placeholder: "Job Title",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem",
                                                onChange: handleUserChange,
                                                value: editUser['designation'] || ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 448 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H184L133.3 308.8zM314.7 308.8L264 512h149.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M176 288l32 56l-31.99 135.1L184 512h80l7.988-32.05L240 344l32-56H176zM224 0C153.3 0 96 57.25 96 128s57.25 128 128 128s128-57.25 128-128S294.8 0 224 0z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "c15 fs1-25rem ttu w100 tal 0 mb0-5rem",
                                        children: "Permissions"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        id: "userPermissions",
                                        className: "dg gg0-5rem mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "tac df jcfs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w30px h30px pr mr1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onChange: selectAllPermissions,
                                                            className: "bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                            type: "checkbox",
                                                            checked: selectAll
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem c15 fw600 mr1rem usn",
                                                        children: "All Permissions"
                                                    })
                                                ]
                                            }),
                                            allPermissions && allPermissions.map((section, idx)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    for: "permissions" + section['sectionNo'],
                                                    className: "df cp fs1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "checkbox w30px h30px pr mr1rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                onChange: changeUser,
                                                                name: section['sectionNo'],
                                                                id: "permissions" + section['sectionNo'],
                                                                className: "bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                                checked: editUser.permissions && editUser.permissions[section['sectionNo']]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1rem fw600 mr1rem usn c15",
                                                            children: section['sectionNo']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs1rem fw400 usn c15",
                                                            children: section['sectionName']
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>saveUser(),
                                        className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "c3-hover td250 fs1-25rem cp",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setSelectAll(false);
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '12px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b9f7071fd0c9532c$export$2e2bcd8739ae039), {
                setTabName: setTabName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "demoChecklistFlow",
                open: modal['open'] == 'demoChecklistFlow',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: isPrePopulate ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    "Completing demo checklist for you ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " to save time\u2026"
                                                ]
                                            }) : tab.endsWith("-report") ? 'Generating your workflow manager' : 'Generating your checklist report'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar ${isPrePopulate && ` questions-progress-bar`}`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: [
                                                "This may take ",
                                                isPrePopulate ? ' couple of minutes' : ' few seconds',
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                !isPrePopulate && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pa",
                                    style: {
                                        top: '10px',
                                        right: '-345px'
                                    },
                                    children: tab.endsWith("-report") ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w80",
                                        src: (parcelRequire("3DH5F")),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w80",
                                        src: (parcelRequire("2Gkf0")),
                                        alt: ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $6u4NZ = parcelRequire("6u4NZ");








var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");




















function $15b5fd06d1c53733$export$2e2bcd8739ae039({ getCompany: getCompany, sectionRefs: sectionRefs, user: user, company: company, moduleCertification: moduleCertification, module: inputModule, tab: tab, setTab: setTab, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, twoMinuteTestAIReport: twoMinuteTestAIReport, sortSections: sortSections }) {
    const [tempModule, setTempModule] = (0, $acw62.useState)(null);
    const module = tempModule;
    // Data Repository temp modules carry slug 'repository' but type 'unique' (not 'repository'),
    // so detect repository modules by slug OR the legacy type value.
    const isRepositoryModule = module?.['type'] === 'repository' || module?.['slug'] === 'repository';
    // Only modules with certification rules can be certified. Without rules, certification is always
    // 'none' — so we must NOT show the "Insufficient Score" badge for them (it's meaningless there).
    const hasCertificationRules = Array.isArray(module?.['certificationRules']) && module['certificationRules'].length > 0;
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let [checklistModule, setChecklistModule] = (0, $acw62.useState)(false);
    let [directorCertification, setDirectorCertification] = (0, $acw62.useState)('None');
    // OPTIMIZATION: Lazy load KPIs when not available (excluded in lightweight mode)
    let [kpis, setKpis] = (0, $acw62.useState)(company?.['keyPerformanceIndicators'] || []);
    // const sanitiseTab = t => decodeURIComponent(t).replace(/(-sync)?-report$/, "")
    const sanitiseTab = (t = '')=>decodeURIComponent(t).replace(/(-sync)?-report$/, "");
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    (0, $acw62.useEffect)(()=>{
        const fetchTempModuleForReport = async ()=>{
            if (!company?._id || !tab || tab === 'kpi-report') return;
            try {
                const moduleSlugRaw = sanitiseTab(tab).replace(/^temp-/, '');
                const moduleSlug = moduleSlugRaw.includes('business-audit') ? moduleSlugRaw.replace(`-${company?.['testType']}`, '') : moduleSlugRaw;
                if (!moduleSlug) return;
                const companyId = company?._id;
                let resolvedModuleName = moduleSlug;
                let resolvedDirectorId = null;
                if (moduleSlug.includes('directors-questionnaire_')) {
                    const parts = moduleSlug.split('_');
                    resolvedModuleName = 'directors-questionnaire';
                    resolvedDirectorId = parts[1] || null;
                } else if (moduleSlug.includes('business-audit')) resolvedModuleName = moduleSlug.replace(`-${company?.['testType']}`, '');
                else if (moduleSlug.includes('%20')) resolvedModuleName = moduleSlug.replaceAll('%20', ' ');
                const moduleName = resolvedModuleName;
                const directorId = resolvedDirectorId;
                const isValidCompanyId = typeof company._id === 'string' && company._id.trim().length > 0;
                let query = isValidCompanyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
                if (directorId) query += `${query ? '&' : '?'}directorId=${encodeURIComponent(directorId)}`;
                const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${encodeURIComponent(moduleName)}${query}`);
                if (res?.code === 200 && res?.body) {
                    setTempModule(res.body);
                    dispatch((0, $12074930bd2c1829$export$65113a50fb519714)({
                        ...res.body,
                        moduleSlug: res.body.moduleSlug || moduleSlug,
                        moduleName: res.body.moduleName || moduleSlug,
                        companyId: company._id
                    }));
                } else setTempModule(null);
            } catch (_) {
                // Keep legacy prop module as fallback when temp lookup fails.
                setTempModule(null);
            }
        };
        fetchTempModuleForReport();
    }, [
        company?._id,
        company?.testType,
        tab
    ]);
    // Fetch KPIs if not available (excluded in lightweight mode)
    (0, $acw62.useEffect)(()=>{
        const fetchKPIs = async ()=>{
            if (company?.['kpiCount'] !== undefined && !company?.['keyPerformanceIndicators'] && tab.includes('kpi')) try {
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/kpis`);
                if (response['code'] === 200 && response['body']) setKpis(response['body']['kpis'] || []);
            } catch (e) {
                console.error('Failed to fetch KPIs:', e);
            }
            else if (company?.['keyPerformanceIndicators']) setKpis(company['keyPerformanceIndicators']);
        };
        fetchKPIs();
    }, [
        company?._id,
        company?.['keyPerformanceIndicators'],
        company?.['kpiCount'],
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array
        const hasNoKPIs = company?.['kpiCount'] !== undefined ? company['kpiCount'] === 0 : !company['keyPerformanceIndicators'] || Object.values(company['keyPerformanceIndicators']).length === 0;
        if (tab == 'kpi-report' && hasNoKPIs) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'generatingKPI'
            }));
            generateKPI();
        }
    }, []);
    const generateKPI = async ()=>{
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Generating your KPI report, please wait!');
        let res = (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/generateKPI/${company['_id']}`);
        if (res['code'] == '200') await getCompany(company['_id']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (!module) setTab(tab);
        if (tab && module && tab.includes(`directors-questionnaire_${module?.['director']?.['_id']}-report`)) {
            if (module?.stats?.completionPercent >= 90 && module?.stats?.riskPercent <= 50) setDirectorCertification('Gold');
            else if (module?.stats?.completionPercent >= 75 && module?.stats?.riskPercent <= 50) setDirectorCertification('Silver');
            else setDirectorCertification('None');
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array
        const hasNoKPIs = company?.['kpiCount'] !== undefined ? company['kpiCount'] === 0 : company?.['keyPerformanceIndicators']?.length === 0;
        if (user['role'] == 'Guest' && hasNoKPIs) getCompany();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (module?.['type']) {
            if (!(isRepositoryModule || [
                'kpi',
                `two-minute-test-${company['testType']}`,
                'repository',
                'software-development',
                'esg',
                'warranty-disclosure',
                `business-audit-${company['testType']}`,
                `directors-questionnaire_${module?.['director']?.['_id']}`
            ].includes(module['type']))) setChecklistModule(true);
        }
    }, [
        module
    ]);
    (0, $acw62.useEffect)(()=>{
        // Skip PDF DOM manipulation if using Papermill PDF iframe
        if (module?.reportUrl) return;
        document.getElementById("pdfContent").classList.add("a4-pdf", "p3rem");
        let wrapper = document.getElementById("pdf");
        wrapper.innerHTML = "";
        let children = Array.from(document.getElementById("pdfContent").children);
        let i = 0;
        let _pageNumber = 1;
        let page = document.createElement("div");
        page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        wrapper.appendChild(page); // Append the first page directly
        let usedPageHeight = 96; // Initial height used on the page
        let pageHeight = getHeight(page);
        let footerHeight = 8;
        // Create watermark
        let watermark = document.createElement("img");
        watermark.classList.add("op20", "pa");
        watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
        watermark.style.top = "50%";
        watermark.style.left = "50%";
        watermark.style.width = "297mm";
        page.appendChild(watermark);
        let section = document.querySelector('#pdfContent .section-break');
        while(children.length && i < 250){
            // Process children for table and other content
            for (let child of children){
                i++;
                // Create footerLogo
                let footer = document.createElement("div");
                footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
                let footerLogo = document.createElement("img");
                footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
                footerLogo.alt = "miniicon";
                footerLogo.classList.add("h40px", "w40px", "tal");
                // Create trademark
                let trademark = document.createElement("p");
                trademark.innerText = `\xa9 Diligentsia Limited ${new Date().getFullYear()}`;
                trademark.classList.add("tac", "c37", "fs12px", "fw400");
                // Create pageNumber
                let pageNumber = document.createElement("h3");
                pageNumber.innerText = "Page " + _pageNumber;
                pageNumber.classList.add("fw600", "c36", "fs14px");
                // Append footerLogo and trademark to footer
                footer.appendChild(footerLogo);
                footer.appendChild(trademark);
                footer.appendChild(pageNumber);
                let childHeight = getHeight(child);
                if (usedPageHeight + childHeight + footerHeight > pageHeight || child?.className == section?.className && usedPageHeight + childHeight + footerHeight > pageHeight / 2) {
                    page.classList.add("df", "fdc");
                    if (i > 1) {
                        _pageNumber++;
                        page = createNewPage(wrapper);
                        page.appendChild(footer);
                    }
                    usedPageHeight = 96;
                }
                page.appendChild(child.cloneNode(true));
                usedPageHeight += childHeight;
            }
            // Remove processed children
            children.splice(0, children.length);
        }
        // Clean up after processing
        wrapper.classList.remove("op0", "pen");
        document.getElementById("pdfContent").classList.remove("a4", "p3rem");
        // Set up event listeners for inputs and textareas
        setupEventListeners(wrapper);
    });
    function createNewPage(wrapper) {
        let newPage = document.createElement("div");
        newPage.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        let header = document.createElement("img");
        header.classList.add("db", "ma", "h1rem");
        titleHeading(newPage);
        // Add additional headers based on the module type
        addHeadersBasedOnModule(newPage);
        wrapper.appendChild(newPage);
        return newPage;
    }
    function addHeadersBasedOnModule(page) {
        // Reason: these are temp modules whose `type` is 'unique' (not the slug), so detect Directors-Questionnaire and
        // Warranty-Disclosure reports from the tab. They must use their own header, NOT the Risk/Recommendation one.
        // Header selection only — no other rendering logic is changed.
        const slug = sanitiseTab(tab || '');
        const isDirectorsQuestionnaire = slug.includes('directors-questionnaire');
        const isWarrantyDisclosure = slug.includes('warranty-disclosure');
        if (isRepositoryModule) repositoryHeaders(page);
        if (isWarrantyDisclosure) warrantyDisclosureHeaders(page);
        if (!isWarrantyDisclosure && !isDirectorsQuestionnaire && ([
            "software-development",
            "esg"
        ].includes(module?.['type']) || checklistModule)) riskRecommendationHeaders(page);
        if (isDirectorsQuestionnaire) directorsQuestionnaireHeaders(page);
    }
    function setupEventListeners(wrapper) {
        let pdfInputs = wrapper.querySelectorAll("#pdf input");
        pdfInputs.forEach((input)=>input.addEventListener('click', (e)=>saveAnswerInput(e)));
        let pdfTextareas = wrapper.querySelectorAll("#pdf textarea");
        pdfTextareas.forEach((textarea)=>textarea.addEventListener('change', (e)=>saveAnswerInput(e)));
    }
    const titleHeading = (page)=>{
        const title = document.createElement("span");
        let div = null;
        let quesAnsHead = null;
        title.classList.add("db", "fw700", "fs1-25rem", "c15", 'ttu');
        if (tab.match(/two-minute-test-.*-report/)) {
            title.classList.add("tal", "w100");
            title.innerText = `2 Minute ${module?.heading} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb0-5rem");
            div.innerText = `${company['cName']}`;
            quesAnsHead = document.createElement("div");
            quesAnsHead.classList.add("w100", "br10px", "p0-5rem", "fs1rem", "bg52", "df", "aic", "c1");
            let leftBar = document.createElement("div");
            leftBar.innerText = "Question";
            leftBar.classList.add("w80", "pl1rem");
            let rightBar = document.createElement("div");
            rightBar.innerText = "Answer";
            rightBar.classList.add("w20");
            quesAnsHead.appendChild(leftBar);
            quesAnsHead.appendChild(rightBar);
            page.appendChild(title);
            page.appendChild(div);
            page.appendChild(quesAnsHead);
            return page;
        } else if (checklistModule) {
            title.classList.add("tac", "mb1-75rem");
            title.innerText = module['type'] + ' Report' + ' - ' + company['cName'];
        } else {
            title.classList.add("tal", "w100");
            title.innerText = `${tab.includes('kpi-report') ? 'KPI' : module?.heading || inputModule?.['type'] || ''} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb1rem");
            div.innerText = `${company['cName']}`;
            let warpElement = document.createElement('div');
            let warpElement2 = document.createElement('div');
            let logoTag = document.createElement('img');
            logoTag.classList.add("sad");
            logoTag.src = company['logo'];
            logoTag.alt = "companyLogo";
            logoTag.style.maxWidth = "150px";
            logoTag.style.maxHeight = "60px";
            warpElement2.appendChild(title);
            warpElement2.appendChild(div);
            warpElement.classList.add("df", "aic", "jcsb");
            warpElement.appendChild(warpElement2);
            if (company['logo']) warpElement.appendChild(logoTag);
            page.appendChild(warpElement);
            return page;
        }
        page.appendChild(title);
        return page;
    };
    const repositoryHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg52", "c1", "tac", "br10px");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const riskRecommendationHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Risk</h3><h3>Recommendation</h3>";
        page.appendChild(headings);
    };
    const warrantyDisclosureHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Disclosure</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const directorsQuestionnaireHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Text</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const sortQuestions = (a, b)=>{
        let valueA = a.qNo.split('.')[a.qNo.split('.').length - 1];
        let valueB = b.qNo.split('.')[a.qNo.split('.').length - 1];
        return valueA - valueB;
    };
    const sortLogs = (a, b)=>new Date(b.timestamp) - new Date(a.timestamp);
    const getAuditContent = ()=>{
        const sectionAnswers = answers.filter((a)=>!Object.values(module?.sections).filter((s)=>s.isHidden).find((s)=>a.qNo.includes(s.sectionNo)));
        const logs = sectionAnswers.filter((a)=>(a?.logs || []).length).reduce((arr, a)=>[
                ...arr,
                ...a?.logs || []
            ], []).sort(sortLogs);
        return logs.map((log, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 p1rem br5px df my0-5rem",
                children: [
                    log.userId.profilePicture && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "ass ml0-5rem br100 w2rem h2rem",
                        src: log.userId.profilePicture
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem bg3 c1",
                        children: [
                            log.userId.firstName[0],
                            log.userId.lastName[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: log.message
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log.files.map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: file.location,
                                    target: "_blank",
                                    className: "db c3-hover fw600",
                                    children: file.originalname
                                }, idx)),
                            (log.payload.answers || [
                                log.payload
                            ]).map((answer, idx)=>{
                                const question = answer.questionId ? questions.find((q)=>q._id == answer.questionId) : "";
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        question && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: question.qNo
                                                }),
                                                " - ",
                                                question.qDescription
                                            ]
                                        }),
                                        answer.file && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Filename"
                                                }),
                                                ": ",
                                                answer.file.originalname
                                            ]
                                        }),
                                        answer.status && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Changed Status"
                                                }),
                                                ": ",
                                                answer.status
                                            ]
                                        }),
                                        answer.radioOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Selected Option"
                                                }),
                                                ": ",
                                                answer.radioOption
                                            ]
                                        }),
                                        answer.comment && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Entered Comment"
                                                }),
                                                ": ",
                                                answer.comment
                                            ]
                                        })
                                    ]
                                });
                            })
                        ]
                    })
                ]
            }, idx));
    };
    const getSyncContent = ()=>{
        const records = module?.sections.flatMap((section)=>section?.questions?.flatMap((question)=>question?.answer?.logs || [])).sort(sortLogs);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "df jcc aic mb1-3rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                            className: "w2rem mr0-5rem"
                        }),
                        "Google Drive Synchronization Report"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr3 bg6 c1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Date Synced"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Synced By "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Files Synced"
                        })
                    ]
                }),
                records.map((record, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg tableRow gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(record['timestamp']).format('lll')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: `${record['userId']['firstName']} ${record['userId']['lastName']}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    record['userId']['email']
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                style: {
                                    textAlign: 'left'
                                },
                                children: record['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        href: file['location'],
                                        target: "'_blank",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "File"
                                            }),
                                            ": ",
                                            file['originalname']
                                        ]
                                    }, idx))
                            })
                        ]
                    }, `record-${idx}`))
            ]
        });
    };
    // Reason: the report used to colour sections from the weighted riskIf<option> score, which disagreed with the
    // index sidebar. These mirror SidebarIndexNew's colour model exactly so both views always show the same colour.
    // investor-lead and explicitly disabled modules never show risk colours.
    const isModuleWithoutRiskScoring = ()=>module?.['type'] === 'investor-lead' || module?.['riskScoring'] === false;
    const isWDModule = ()=>module?.['moduleKey'] === 'DWD' || module?.['type'] === 'warranty-disclosure' || module?.['moduleName'] && /warranty disclosure/i.test(String(module['moduleName']));
    // Plain Yes/No tally over the section's questions. N/A and NC are excluded from the tally.
    // Returns null when nothing is answered (no colour), green when every answered question is N/A.
    const computeYesNoRiskColor = (questions1)=>{
        let yesCount = 0, noCount = 0, naCount = 0;
        for (const q of questions1 || []){
            if (q.isSkipped) continue;
            const opt = q.answer?.radioOption;
            if (!opt) continue;
            if (opt === 'Yes') yesCount++;
            else if (opt === 'No') noCount++;
            else if (opt === 'N/A' || opt === 'NC') naCount++;
        }
        const answered = yesCount + noCount;
        if (answered === 0) return naCount > 0 ? '#40dda144' : null;
        const riskPercent = noCount / answered * 100;
        if (riskPercent <= 33) return '#40dda144';
        if (riskPercent >= 66) return '#dd404044';
        return '#ddb64044';
    };
    // WD: Disclosure/Not Sure in any question → red; else green if answered.
    const computeWDRiskColor = (questions1)=>{
        let hasAnswered = false;
        for (const q of questions1 || []){
            if (q.isSkipped) continue;
            const opt = q.answer?.radioOption;
            if (!opt || opt === 'N/A' || opt === 'NC') continue;
            hasAnswered = true;
            if (opt === 'Disclosure' || opt === 'Not Sure') return '#dd404044';
        }
        return hasAnswered ? '#40dda144' : null;
    };
    const getSubSectionQuestions = (section, subSection)=>{
        if (subSection?.sectionNo && subSection?.questions) return subSection.questions;
        const subNo = subSection?.no;
        return subSection?.questions || subNo && section?.questions?.filter((q)=>q.qNo?.match(new RegExp(String(subNo).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + "((\\.[0-9]+)|$)"))) || [];
    };
    const getSubSectionCompleteness = (section, subSection)=>{
        let subCompleteness = subSection?.stats?.completionPercent;
        if (subCompleteness == null || isNaN(subCompleteness)) {
            const subQuestions = getSubSectionQuestions(section, subSection);
            if (subQuestions.length) {
                const activeQs = subQuestions.filter((q)=>!q.isSkipped);
                if (activeQs.length) {
                    const completed = activeQs.filter((q)=>q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
                    subCompleteness = Math.round(completed / activeQs.length * 100);
                } else subCompleteness = 0;
            } else subCompleteness = 0;
        }
        return subCompleteness ?? 0;
    };
    const subSectionHasNoAnswer = (section, subSection)=>{
        return getSubSectionQuestions(section, subSection).some((q)=>{
            const opt = q.answer?.radioOption;
            return opt === 'No' || opt === 'No Disclosure';
        });
    };
    // Mirrors SidebarIndexNew.getAllSectionQuestions — a whole-section row aggregates its subFolder questions at every
    // depth, which is how the sidebar tallies a section. SubFolder rows use their own questions only.
    const getAllSectionQuestions = (section)=>{
        const questions1 = [
            ...section?.questions || []
        ];
        const collectFromSubFolders = (subFoldersMap)=>{
            Object.values(subFoldersMap).forEach((subFolder)=>{
                questions1.push(...subFolder.questions || []);
                if (subFolder.subFolders) collectFromSubFolders(subFolder.subFolders);
            });
        };
        if (section?.subFolders) collectFromSubFolders(section.subFolders);
        return questions1;
    };
    const getSubSectionBackground = (section, subSection)=>{
        const subCompleteness = getSubSectionCompleteness(section, subSection);
        const hasNo = subSectionHasNoAnswer(section, subSection);
        const skipRiskScoring = isModuleWithoutRiskScoring();
        if (subCompleteness <= 0 && (skipRiskScoring || !hasNo)) return 'transparent';
        const fillPercent = subCompleteness > 0 ? subCompleteness : 100;
        if (skipRiskScoring) return `linear-gradient(90deg, #40dda144 0%, #40dda144 ${fillPercent}%, #f0f0f8 ${fillPercent}%)`;
        const isWholeSectionRow = section === subSection;
        const questions1 = isWholeSectionRow ? getAllSectionQuestions(section) : getSubSectionQuestions(section, subSection);
        const colour = (isWDModule() ? computeWDRiskColor(questions1) : computeYesNoRiskColor(questions1)) ?? '#40dda144';
        return `linear-gradient(90deg, ${colour} 0%, ${colour} ${fillPercent}%, #f0f0f8 ${fillPercent}%)`;
    };
    const getOverviewContent = ()=>{
        let hideRisk = false;
        if (module?.['riskScoring'] == false || tab == 'repository-report') hideRisk = true;
        else hideRisk = false;
        let array = [];
        if ([
            'warranty-disclosure',
            `directors-questionnaire_${module?.['director']?.['_id']}`,
            'software-development',
            'esg'
        ].includes(module?.['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections.filter((s)=>!s.isHidden);
        if (array?.length) sectionRefs.current.length = array.length;
        // array = array.filter((section) => section.isSection);
        // Reason: director questionnaire reports are per-director, so surface the director's name under the title.
        // Prefer the tempModule's director (backend attaches it for director reports); fall back to the legacy module prop which carries it from company data.
        const directorInfo = module?.['director'] || inputModule?.['director'];
        const directorName = directorInfo?.['name'] || `${directorInfo?.['firstName'] || ''} ${directorInfo?.['lastName'] || ''}`.trim();
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100",
                            children: [
                                checklistModule ? /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "w100 tal c15 lh2 fs1-25rem ttc",
                                    children: (module?.['moduleName'] ? module['moduleName'] : '') + ' Report'
                                }) : tab.match(/two-minute-test-.*-report/) ? /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "w100 tal c15 lh2 fs1-25rem ttc",
                                    children: '2 Minute ' + module?.heading
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "w100 tal c15 lh2 fs1-25rem ttc",
                                    children: (module?.['heading'] || (module?.['type'].includes('directors-questionnaire') ? 'Directors Questionnaire' : module?.['type']) || '') + ' Report'
                                }),
                                directorName && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tal fs12px fw400 c3 mt0-25rem mb0 ttc",
                                    children: directorName
                                })
                            ]
                        }),
                        company['logo'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: company['logo'],
                            style: {
                                maxHeight: "70px",
                                maxWidth: "150px"
                            },
                            alt: "companyLogo"
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mt0-5rem dg gg0-5rem minh100vh-report",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "fs1rem fsi fw400 lh1 ttu usn c15",
                            children: company['cName']
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "report-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dg gtcr2a gg2rem mb1-3rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "h100 df fdc aifs ",
                                            children: [
                                                [
                                                    "Company Reg:",
                                                    company['ukRegNo']
                                                ],
                                                [
                                                    "Subscription:",
                                                    (company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: company['subscription']?.toUpperCase()
                                                    })
                                                ],
                                                [
                                                    "Objective :",
                                                    company['testType']
                                                ]
                                            ].map((arr, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "ass fs12px mt0-25rem mb0-25rem c15",
                                                            children: arr[0]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs12px fw700 lh1 ttu usn c15 ml0-5rem",
                                                            children: arr[1]
                                                        })
                                                    ]
                                                }, `reportLeft-Head-${idx}`))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aife",
                                            children: [
                                                [
                                                    "Generated By",
                                                    user.email
                                                ],
                                                [
                                                    "Report Date",
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format("MMM Do YYYY, h:mm A")
                                                ]
                                            ].map((arr, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic jcfs",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "ass fs12px mt0-25rem mb0-25rem c15",
                                                            children: [
                                                                arr[0],
                                                                ": "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs12px fw700 lh1 ttu usn c15 ml0-5rem",
                                                            children: arr[1]
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `progress-area-report bo31 bss br20px bw1px mb1rem px1rem py0-5rem`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "progress-area",
                                        style: {
                                            display: 'flex',
                                            position: 'relative',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "progress-box p1rem",
                                                style: {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "progress-bar",
                                                        style: {
                                                            width: 80,
                                                            height: 80,
                                                            backgroundColor: '#FBFBFB',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `${module?.stats?.completionPercent > 67 ? 'bg-green' : module?.stats?.completionPercent > 33 ? 'bg-orange' : 'bg-red'} c2 df jcc aic`,
                                                            style: {
                                                                width: "68px",
                                                                height: "68px",
                                                                borderRadius: '50%'
                                                            },
                                                            children: (module?.stats?.completionPercent || 0) + "%"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "text-center-area mt1rem c37 mb0rem fs1rem tac",
                                                        style: {
                                                            display: 'block',
                                                            textAlign: 'center',
                                                            whiteSpace: 'nowrap'
                                                        },
                                                        children: [
                                                            "Module ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "Completeness"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            tab.match(/two-minute-test-.*-report/) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic jcc fdc ",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "c15",
                                                    children: "Your Overall Result"
                                                })
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df jcc mb1rem",
                                                children: tab && module && tab.includes(`directors-questionnaire_${module?.['director']?.['_id']}`) && directorCertification ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        directorCertification == 'None' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w50",
                                                            src: (parcelRequire("9pBV1")),
                                                            alt: "Label"
                                                        }),
                                                        directorCertification == 'Silver' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w30",
                                                            src: (parcelRequire("7YoCF")),
                                                            alt: "Trophy"
                                                        }),
                                                        directorCertification == 'Gold' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w30",
                                                            src: (parcelRequire("gr5qi")),
                                                            alt: "Trophy"
                                                        })
                                                    ]
                                                }) : hasCertificationRules ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: moduleCertification && moduleCertification?.toLowerCase() == 'bronze' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w30 ${isRepositoryModule && 'mr7rem'}`,
                                                        src: (parcelRequire("cXyX2")),
                                                        alt: "Trophy"
                                                    }) : moduleCertification && moduleCertification?.toLowerCase() == 'silver' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w30 ${isRepositoryModule && 'mr7rem'}`,
                                                        src: (parcelRequire("7YoCF")),
                                                        alt: "Trophy"
                                                    }) : moduleCertification && moduleCertification?.toLowerCase() == 'gold' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w30 ${isRepositoryModule && 'mr7rem'}`,
                                                        src: (parcelRequire("gr5qi")),
                                                        alt: "Trophy"
                                                    }) : moduleCertification && moduleCertification?.toLowerCase() == 'none' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: `w50 ${isRepositoryModule && 'mr7rem'}`,
                                                        src: (parcelRequire("9pBV1")),
                                                        alt: "Label"
                                                    }) : null
                                                }) : null
                                            }),
                                            hideRisk ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "progress-box-hidden",
                                                style: {
                                                    minWidth: '148px'
                                                }
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "progress-box p1rem",
                                                style: {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "progress-bar",
                                                        style: {
                                                            width: 80,
                                                            height: 80,
                                                            backgroundColor: '#FBFBFB',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `${module?.stats?.riskPercent > 67 ? 'bg-red' : module?.stats?.riskPercent > 33 ? 'bg-orange' : 'bg-green'} c2 df jcc aic`,
                                                            style: {
                                                                width: "66px",
                                                                height: "66px",
                                                                borderRadius: '50%'
                                                            },
                                                            children: (module?.stats?.riskPercent || 0) + "%"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "text-center-area mt1rem c37 mb0rem fs1rem tac",
                                                        style: {
                                                            display: 'block',
                                                            textAlign: 'center',
                                                            whiteSpace: 'nowrap'
                                                        },
                                                        children: [
                                                            "Module ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "Risk"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "oscy h60vh",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "c37 fs14px tac mr0-5rem wsn",
                                                    style: {
                                                        flex: '0 0 150px'
                                                    },
                                                    children: "Section"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "c37 fs14px tal wsn",
                                                    style: {
                                                        flex: '1 1 0',
                                                        minWidth: 0,
                                                        paddingLeft: '12px'
                                                    },
                                                    children: "Name"
                                                })
                                            ]
                                        }),
                                        array && array.length > 0 && array.sort(sortSections).map((section, idx)=>{
                                            const isSubFolderOverview = [
                                                'warranty-disclosure',
                                                `directors-questionnaire_${module?.['director']?.['_id']}`,
                                                'software-development',
                                                'esg'
                                            ].includes(module?.['type']);
                                            const parentSection = module?.sections?.[0];
                                            const sectionNo = section.sectionNo || section.no;
                                            const sectionName = section.sectionName || section.name;
                                            const reportBackground = section.isDisabled ? '#fff' : getSubSectionBackground(isSubFolderOverview ? parentSection : section, section);
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                "data-scroll-to": sectionNo,
                                                className: "df c15 td250 px1rem py0-5rem cp new-report-btn bg54",
                                                style: {
                                                    opacity: `${section.isDisabled ? 0.5 : 1}`
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "pen usn ass mr0-5rem tac left-heading df aic jcc c15 wsn",
                                                        style: {
                                                            flex: '0 0 150px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $067517aabc6d84f7$export$2e2bcd8739ae039), {
                                                                className: "pa l10 c3"
                                                            }),
                                                            sectionNo
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        style: {
                                                            background: reportBackground,
                                                            opacity: `${section.isDisabled ? 0.5 : 1}`,
                                                            flex: '1 1 0',
                                                            minWidth: 0,
                                                            whiteSpace: 'nowrap'
                                                        },
                                                        className: "pen uss ass fw600 tal right-detail fs14px c15 df aic jcsb",
                                                        children: [
                                                            sectionName,
                                                            section.isDisabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                                className: "c15 fw400 fs1rem"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, `${idx}-report`);
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const saveAnswerInput = async (event)=>{
    // let answerId = event.target.id.split('_')[1];
    // const res = await postRequest(`/question/addNote/${answerId}`, { done: true });
    // showMessage(res?.['message']);
    };
    const sortQuestionsByQNo = (questions1)=>{
        if (questions1 && questions1.length > 0) return questions1 && questions1.slice().sort((a, b)=>{
            const aParts = a['qNo'].match(/\d+/g).map(Number);
            const bParts = b['qNo'].match(/\d+/g).map(Number);
            for(let i = 0; i < Math.max(aParts.length, bParts.length); i++)if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
            return 0;
        });
    };
    const getAuditReportContent = ()=>{
        let array = [];
        if ([
            'warranty-disclosure',
            `directors-questionnaire_${module?.['director']?.['_id']}`,
            'software-development',
            'esg'
        ].includes(module?.['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections.filter((s)=>!s.isHidden);
        if (array && array.length > 0) {
            sectionRefs.current.length = array.length;
            // array = array.filter((section) => section.isSection);
            array = array.slice().sort(sortSections);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: array && array.length > 0 && array.map((section, index)=>{
                let questions1;
                let completionPercent, riskPercent;
                const qNo = section.sectionNo || section.no;
                if (isRepositoryModule && company['subscription'] == 'Lite') questions1 = section.questions && section.questions.filter((q)=>q.qNo == qNo) || [];
                else questions1 = section?.questions;
                // questions = questions.sort(sortQuestions);
                questions1 = sortQuestionsByQNo(questions1);
                if (section?.stats?.completionPercent) completionPercent = section.stats.completionPercent;
                if (section?.stats?.riskPercent) riskPercent = section.stats.riskPercent;
                if (isRepositoryModule && company['subscription'] == 'Lite') {
                    if (section.questions) completionPercent = section.questions.filter((q)=>q.qNo == section.sectionNo)[0]?.['answer']?.['status'] == 'Completed' ? 100 : 0;
                }
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "section-break"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                className: "df jcc aic tac mb1rem fs1rem",
                                children: [
                                    section['sectionNo'],
                                    " - ",
                                    section['sectionName'],
                                    " Report \xa0-\xa0",
                                    completionPercent && completionPercent > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: completionPercent < 34 ? "c9" : completionPercent < 67 ? 'c8' : 'c7',
                                                children: [
                                                    "Completed ",
                                                    completionPercent || 0,
                                                    "%"
                                                ]
                                            }),
                                            riskPercent > 0 && !isRepositoryModule && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: riskPercent < 38 ? "c7" : riskPercent < 62 ? 'c8' : 'c9',
                                                        children: [
                                                            riskPercent || 0,
                                                            "% Risk"
                                                        ]
                                                    }),
                                                    " "
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c12",
                                                children: "Not Started"
                                            }),
                                            !isRepositoryModule && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c12",
                                                        children: "No Risk Score"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        questions1 && questions1.length > 0 && questions1.filter((q)=>q.answer)?.map((question, idx)=>{
                            if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                            let isRisky = question?.['answer']?.['radioOption'] == "No";
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    id: qNo,
                                    className: `mah40vh dg tableRow fs0-75rem my0-5rem ${isRepositoryModule || [
                                        `directors-questionnaire_${module?.['director']?.['_id']}`
                                    ].includes(module?.['type']) ? 'gtcr-audit' : 'gtcr-audit-two'}`,
                                    style: {
                                        overflow: 'auto'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc jcfs pt0-25rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fw600",
                                                        children: [
                                                            question['qNo'],
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c2 db fw500",
                                                        children: question?.['qDescription']
                                                    })
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes(`directors-questionnaire_${module?.['director']?.['_id']}`) ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aic tac jcfs pt1rem br5px",
                                            children: question?.questionType.includes("YN") ? question.answer['radioOption'] || question.answer['status'] : "-"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc aic tac jcfs pt1rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `${[
                                                    "Disclosure",
                                                    "No Disclosure"
                                                ].includes(question?.answer?.['radioOption']) ? ' px0-5rem ' : ' px1rem '} br10px c1 ${[
                                                    'Yes',
                                                    'No Disclosure'
                                                ].includes(question?.answer?.['radioOption']) ? ' bg34' : question?.answer?.['radioOption']?.includes('No') ? ' bg4' : question?.answer?.['radioOption']?.includes('Disclosure') ? ' bg39' : ' bg16'}`,
                                                style: {
                                                    paddingTop: "4px",
                                                    paddingBottom: "4px"
                                                },
                                                children: question.answer['radioOption'] || question.answer['status'] || 'N/A'
                                            })
                                        }),
                                        module?.['type'].includes(`directors-questionnaire_${module?.['director']?.['_id']}`) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question?.questionType.includes("Date") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.answer && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(question?.answer?.date).format('ll')
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: question['answer'] ? question['answer']['comment'] || question['answer']['dropdown'] : '-'
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question?.answer?.files?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "File"
                                                                    }),
                                                                    ": ",
                                                                    file['originalname']
                                                                ]
                                                            }, idx))
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "-"
                                                    })
                                                })
                                            ]
                                        }),
                                        isRepositoryModule && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "db pt1rem br5px",
                                                style: {
                                                    marginLeft: "30px"
                                                },
                                                children: [
                                                    question?.answer?.files?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            question?.['answer']?.['files'] && question['answer']['files'].slice(0, 20).map((file, idxI)=>{
                                                                let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: `${fileColor} fileManageFileName pr mb0-5rem px1rem`,
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: file['originalname']
                                                                }, `laal-${idx}-${idxI}`);
                                                            }),
                                                            question?.['answer']?.['files']?.length > 20 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                className: "cp",
                                                                target: "_blank",
                                                                href: `/company/${company['_id']}#${location.href.split('#')[1]}`,
                                                                style: {
                                                                    marginTop: "12px",
                                                                    fontWeight: 700
                                                                },
                                                                children: [
                                                                    "for more information click here ",
                                                                    location.href.split('#')[1]
                                                                ]
                                                            }, `question-${idx}-sd`) : null
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "op30 c15",
                                                        children: "No Files Uploaded"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc aic tac jcfs pt1rem br5px c37 pl2rem",
                                                        children: [
                                                            "Notes - ",
                                                            question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                children: question['answer']['comment']
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes(`business-audit-${company['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: question?.['answer']?.['status'] == 'Completed' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fdc tal jcfs pt0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df pb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: question?.['answer']?.['aiResponse']?.['ifriskDescription'] ? question?.['answer']['aiResponse']['ifriskDescription'] : question['riskDescription'] ? question['riskDescription'] : '-'
                                                            }) : "Well done"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] ? question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] : question['recommendDescription'] ? question['recommendDescription'] : '-'
                                                            }) : "No recommendation at this time"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        checklistModule && question?.['answer']?.['radioOption'] != 'N/A' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc tal jcs pt0-5rem ",
                                                children: [
                                                    question?.['answer']?.['radioOption'] != 'Yes' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df pb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['riskDescription'] || question?.['ifNo']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['recommendDescription'] || question?.['toptip'] || question.answer.radioOption == "Yes" && question?.['ifYes']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w90 p1rem my0-5rem",
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: [
                                                            "Files:",
                                                            question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 ? question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: "ml0-5rem tdu",
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: file['originalname']
                                                                }, idx)) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "ml0-5rem fs0-75rem fw500",
                                                                children: "No files uploaded"
                                                            })
                                                        ]
                                                    }),
                                                    question?.['answer']?.['comment'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w90 p1rem my0-5rem",
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: [
                                                            "Note: ",
                                                            question?.['answer']?.['comment']
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        [
                                            "warranty-disclosure",
                                            "software-development",
                                            "esg"
                                        ].includes(module?.['type']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc tal jcfs pt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df pb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' && question['answer']['radioOption'] == 'Disclosure' ? question?.['answer']?.['comment'] && question?.['answer']?.['comment'] : module?.['type'] == 'warranty-disclosure' ? '-' : question?.['answer']?.['aiResponse']?.['ifriskDescription'] ? question?.['answer']['aiResponse']['ifriskDescription'] : question['riskDescription'] ? question['riskDescription'] : '-'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' ? question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                            children: "File"
                                                                        }),
                                                                        ": ",
                                                                        file['originalname']
                                                                    ]
                                                                }, idx)) : question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] ? question?.['answer']['aiResponse']['ifrecommendDescription'] : question['recommendDescription'] ? question['recommendDescription'] : '-'
                                                        })
                                                    ]
                                                }),
                                                [
                                                    "software-development",
                                                    "esg"
                                                ].includes(module?.['type']) && question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "w90 p1rem my0-5rem",
                                                    style: {
                                                        background: '#e1e1f155'
                                                    },
                                                    children: [
                                                        "Files: ",
                                                        question['answer']['files'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                className: "ml0-5rem tdu",
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: file['originalname']
                                                            }))
                                                    ]
                                                }),
                                                [
                                                    "software-development",
                                                    "esg"
                                                ].includes(module?.['type']) && question?.['answer']?.['comment'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "w90 fs0-75rem p1rem my0-5rem",
                                                    style: {
                                                        background: '#e1e1f155'
                                                    },
                                                    children: [
                                                        "Note: ",
                                                        question['answer']['comment']
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, `pdf-report-${idx}-${index}`)
                            });
                        })
                    ]
                });
            })
        });
    };
    const getTwoMinuteTestContent = ()=>{
        const writeSections = (sections)=>Object.values(sections).filter((s)=>!s.isHidden).map((section, index)=>{
                const questionsAndAnswers = section?.questions?.slice().sort(sortQuestions).filter((q)=>q?.answer?.radioOption);
                if (questionsAndAnswers && questionsAndAnswers.length) sectionRefs.current.length = questionsAndAnswers.length;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: questionsAndAnswers && questionsAndAnswers.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                id: section.sectionNo,
                                ref: (el)=>{
                                    if (section['sectionNo']) sectionRefs.current[index] = el;
                                },
                                className: "usn pen fs1rem fw400 mt1rem tal c15 w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: `fw600`,
                                        children: [
                                            "Section ",
                                            index + 1
                                        ]
                                    }),
                                    " - ",
                                    section.sectionName
                                ]
                            }),
                            questionsAndAnswers.map((question, idx)=>{
                                const { answer: answer } = question;
                                if (!aiEnhanced && Object.values(answer?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "question-box c1 mt0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "c15 fs1rem",
                                                children: question['qNo']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aifs lg-fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c15 fs14px w80",
                                                        children: question['qDescription']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w20",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: `${question['answer']['radioOption'] == 'Yes' || question['answer']['radioOption'] < 3 ? 'bg-green' : 'bg-red'} c1 br50px px1rem ml1rem fs14px py0-5rem`,
                                                            children: question['answer']['radioOption']
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "recomended-box mt1rem",
                                                children: (()=>{
                                                    const recommendationKey = [
                                                        "ifYes",
                                                        "ifNo",
                                                        "",
                                                        "if1",
                                                        "if2",
                                                        "if3",
                                                        "if4",
                                                        "if5"
                                                    ].find((key)=>key.includes("if" + answer.radioOption));
                                                    return recommendationKey && question[recommendationKey] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "bg53 br10px p1rem mt1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "c15 fsi df aic fs14px mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "21",
                                                                        height: "22",
                                                                        viewBox: "0 0 21 22",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                "clip-path": "url(#clip0_5984_54722)",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M16.2103 16.9044C15.9637 16.2436 15.2247 15.9077 14.5645 16.1561L11.8761 17.1671C11.1253 17.4497 10.3345 17.5799 9.54688 17.562L10.2036 20.0462C11.202 19.9596 12.1924 19.7419 13.148 19.3895L15.4626 18.5354C16.1217 18.2924 16.4563 17.5624 16.2103 16.9044Z",
                                                                                        fill: "url(#paint0_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M17.8688 16.6819C17.5837 16.0519 16.8394 15.7745 16.2112 16.0639L13.6529 17.2414C12.6572 17.6999 11.5662 17.8758 10.4942 17.7678L9.5 20.2757C11.3823 20.4392 13.2926 20.1219 15.0438 19.3293L17.2476 18.3315C17.8751 18.0475 18.1531 17.3091 17.8688 16.6819Z",
                                                                                        fill: "url(#paint1_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M19.0177 16.731C18.6862 16.1084 17.9094 15.8728 17.2877 16.206L14.7559 17.5622C13.7705 18.0903 12.6696 18.337 11.5697 18.2939L10.7188 20.9049C12.6483 20.9539 14.5753 20.5125 16.3093 19.5978L18.4913 18.4463C19.1127 18.1186 19.3482 17.3508 19.0177 16.731Z",
                                                                                        fill: "url(#paint2_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M10.5037 0.5C10.1392 0.5 9.84375 0.795482 9.84375 1.15998V2.53235C9.84375 2.89684 10.1392 3.19232 10.5037 3.19232C10.8682 3.19232 11.1637 2.89684 11.1637 2.53235V1.15998C11.1637 0.795482 10.8682 0.5 10.5037 0.5Z",
                                                                                        fill: "url(#paint3_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M20.087 10.0898H18.7147C18.3502 10.0898 18.0547 10.3853 18.0547 10.7498C18.0547 11.1143 18.3502 11.4098 18.7147 11.4098H20.087C20.4515 11.4098 20.747 11.1143 20.747 10.7498C20.747 10.3853 20.4515 10.0898 20.087 10.0898Z",
                                                                                        fill: "url(#paint4_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2.28235 10.0898H0.909976C0.545482 10.0898 0.25 10.3853 0.25 10.7498C0.25 11.1143 0.545482 11.4098 0.909976 11.4098H2.28235C2.64684 11.4098 2.94232 11.1143 2.94232 10.7498C2.94228 10.3853 2.6468 10.0898 2.28235 10.0898Z",
                                                                                        fill: "url(#paint5_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M4.18133 3.50189C3.9236 3.24416 3.5057 3.24416 3.24798 3.50189C2.99026 3.75961 2.99026 4.17747 3.24798 4.43519L4.21839 5.4056C4.47611 5.66332 4.89397 5.66332 5.15173 5.4056C5.40946 5.14787 5.40946 4.73002 5.15173 4.47225L4.18133 3.50189Z",
                                                                                        fill: "url(#paint6_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M17.7454 3.50189C17.4877 3.24416 17.0699 3.24416 16.8121 3.50189L15.8417 4.47229C15.584 4.73002 15.584 5.14787 15.8417 5.40564C16.0995 5.66336 16.5173 5.66336 16.7751 5.40564L17.7455 4.43523C18.0032 4.17751 18.0032 3.75961 17.7454 3.50189Z",
                                                                                        fill: "url(#paint7_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M5.3953 5.6453C2.57657 8.46404 2.57657 13.0341 5.3953 15.8529C8.21404 18.6716 12.7841 18.6716 15.6029 15.8529C18.4216 13.0341 18.4216 8.46404 15.6029 5.6453C12.7841 2.82657 8.21404 2.82657 5.3953 5.6453Z",
                                                                                        fill: "url(#paint8_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M10.5021 5.31641C7.5022 5.31641 5.07031 7.74829 5.07031 10.7482C5.07031 13.7481 7.5022 16.18 10.5021 16.18C13.502 16.18 15.9339 13.7481 15.9339 10.7482C15.9339 7.74829 13.502 5.31641 10.5021 5.31641Z",
                                                                                        fill: "url(#paint9_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M5.39529 15.8538C8.21403 18.6725 12.7841 18.6725 15.6029 15.8538C17.0122 14.4444 17.7169 12.5972 17.7169 10.75H3.28125C3.28125 12.5972 3.98594 14.4444 5.39529 15.8538Z",
                                                                                        fill: "url(#paint10_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M15.9311 10.9057L14.4537 9.42832C14.2973 9.23492 14.0699 9.09294 13.7863 9.05172L13.1477 8.95891C13.1226 8.934 11.3645 7.18305 11.3645 7.18305C10.899 6.60753 9.94828 6.67526 9.59729 7.38642L8.99031 8.61628C8.92689 8.74479 8.80427 8.83386 8.66246 8.85444L7.30524 9.05168C6.43765 9.17776 6.09124 10.2439 6.71901 10.8559C6.71901 10.8559 7.7672 11.9023 7.77572 11.9113C7.82439 11.9975 7.84346 12.0986 7.82633 12.1986L7.59446 13.5503C7.52438 13.959 7.69049 14.3216 7.96699 14.5473L9.50979 16.0902C9.83142 16.1495 10.1629 16.1809 10.5017 16.1809C13.4492 16.1808 15.8482 13.8331 15.9311 10.9057Z",
                                                                                        fill: "url(#paint11_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M11.4474 7.34351L12.0544 8.57337C12.1178 8.70188 12.2404 8.79095 12.3822 8.81154L13.7395 9.00877C14.607 9.13485 14.9535 10.201 14.3257 10.813L13.3436 11.7703C13.241 11.8703 13.1942 12.0144 13.2184 12.1556L13.4502 13.5074C13.5984 14.3715 12.6914 15.0304 11.9155 14.6224L10.7015 13.9842C10.5746 13.9175 10.4231 13.9175 10.2963 13.9842L9.08232 14.6224C8.30635 15.0304 7.3994 14.3715 7.54759 13.5074L7.77945 12.1556C7.80367 12.0144 7.75685 11.8703 7.65424 11.7703L6.67214 10.813C6.04436 10.201 6.39078 9.13485 7.25837 9.00877L8.61558 8.81154C8.7574 8.79095 8.87998 8.70188 8.94343 8.57337L9.55041 7.34351C9.93838 6.55737 11.0594 6.55737 11.4474 7.34351Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M11.9154 14.6222L10.7015 13.9839C10.5746 13.9172 10.4232 13.9172 10.2963 13.9839L9.08245 14.6222C8.30647 15.0302 7.3994 14.3713 7.54755 13.507L7.77954 12.1555C7.80363 12.0141 7.75693 11.8699 7.65416 11.77L6.6721 10.8127C6.33457 10.4836 6.2787 10.0233 6.43402 9.64844L13.2221 11.9893C13.2103 12.0431 13.2087 12.0996 13.2183 12.1555L13.4502 13.507C13.5985 14.3713 12.6914 15.0302 11.9154 14.6222Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M10.7026 13.9842L11.9166 14.6224C12.6925 15.0304 13.5995 14.3715 13.4513 13.5074L13.2195 12.1556C13.1952 12.0144 13.2421 11.8703 13.3447 11.7703L14.3268 10.813C14.9546 10.201 14.6081 9.13485 13.7405 9.00877L12.3833 8.81154C12.2415 8.79095 12.1189 8.70188 12.0555 8.57337L11.4485 7.34351C11.2545 6.95044 10.8773 6.75391 10.5 6.75391V13.9343C10.5695 13.9342 10.6391 13.9509 10.7026 13.9842Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M9.08216 14.6222L10.296 13.9839C10.4229 13.9172 10.5744 13.9172 10.7012 13.9839L11.9151 14.6222C12.6911 15.0302 13.5981 14.3713 13.45 13.507L13.218 12.1555C13.1939 12.0141 13.2406 11.8699 13.3434 11.77L14.3254 10.8127C14.663 10.4836 14.7188 10.0233 14.5635 9.64844L7.77542 11.9893C7.7872 12.0431 7.78885 12.0996 7.77929 12.1555L7.5473 13.507C7.39907 14.3713 8.30615 15.0302 9.08216 14.6222Z",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M13.8107 12.6094L12.791 13.629C11.9672 14.4528 10.8499 14.9156 9.6849 14.9156H8.70312V17.7429C11.0926 18.355 13.7344 17.7263 15.6049 15.8557C15.8514 15.6092 16.0759 15.349 16.2793 15.078L13.8107 12.6094Z",
                                                                                        fill: "url(#paint12_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M18.7047 16.3155L17.6513 17.1043C17.605 17.1368 17.5584 17.1687 17.5114 17.2C16.2467 18.0426 14.7191 18.3939 13.2064 18.2481C11.9413 18.1262 11.435 18.0371 9.80568 17.1574C9.52157 17.004 9.48241 16.6971 9.71806 16.4764L9.78262 16.4159C11.0463 15.9079 12.2593 15.2847 13.4067 14.5547C14.0655 14.1356 14.2454 13.2532 13.8069 12.6072C13.4077 12.0191 12.6294 11.8297 12.0029 12.1652C10.9272 12.7414 9.74231 13.0926 8.52143 13.1933C8.28817 13.2126 8.0535 13.2062 7.82073 13.182C7.08738 13.1056 5.31185 12.9331 4.71722 12.9872C4.71174 12.9877 4.70622 12.9882 4.70071 12.9888C3.14419 13.1328 1.86925 14.2862 1.56524 15.8197L1.54716 15.911C1.15409 17.8917 2.44197 19.8165 4.42318 20.2092L7.84428 20.8874L9.99917 21.2936C13.3815 21.9036 16.868 21.1507 19.6889 19.201L20.3735 18.6911C21.0329 18.2355 21.1955 17.3331 20.7368 16.675C20.2764 16.0146 19.3639 15.8533 18.7047 16.3155Z",
                                                                                        fill: "url(#paint13_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M3.06724 13.5703C2.30646 14.0795 1.75218 14.8782 1.56524 15.8211L1.54716 15.9123C1.15409 17.8931 2.44197 19.8179 4.42318 20.2106L7.84428 20.8888L9.99917 21.2951C10.3069 21.3506 10.6155 21.3945 10.9244 21.4275L3.06724 13.5703Z",
                                                                                        fill: "url(#paint14_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M13.809 12.6071C13.4098 12.0191 12.6315 11.8297 12.005 12.1652C10.8185 12.8007 9.49912 13.1626 8.14516 13.2165C8.12481 13.2173 8.10447 13.2182 8.08417 13.2192C5.79563 13.3338 5.5645 16.6262 7.81434 17.0607C7.97604 17.0919 8.1433 17.0758 8.29611 17.0144L9.78476 16.416C11.0484 15.908 12.2615 15.2848 13.4089 14.5548C14.0677 14.1356 14.2475 13.2532 13.809 12.6071Z",
                                                                                        fill: "url(#paint15_linear_5984_54722)"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2.17638 20.4957H0.894394C0.400441 20.4957 0 20.0953 0 19.6014V13.6171C0 13.1231 0.400441 12.7227 0.894394 12.7227H2.17638C2.67034 12.7227 3.07078 13.1231 3.07078 13.6171V19.6014C3.07078 20.0953 2.67038 20.4957 2.17638 20.4957Z",
                                                                                        fill: "url(#paint16_linear_5984_54722)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint0_linear_5984_54722",
                                                                                        x1: "12.7258",
                                                                                        y1: "16.173",
                                                                                        x2: "12.968",
                                                                                        y2: "17.3652",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint1_linear_5984_54722",
                                                                                        x1: "13.1515",
                                                                                        y1: "16.3163",
                                                                                        x2: "13.4902",
                                                                                        y2: "17.7781",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint2_linear_5984_54722",
                                                                                        x1: "14.1626",
                                                                                        y1: "17.2462",
                                                                                        x2: "14.6066",
                                                                                        y2: "18.2972",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint3_linear_5984_54722",
                                                                                        x1: "9.84916",
                                                                                        y1: "3.32692",
                                                                                        x2: "8.53655",
                                                                                        y2: "1.74127",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint4_linear_5984_54722",
                                                                                        x1: "18.1698",
                                                                                        y1: "10.5962",
                                                                                        x2: "19.8938",
                                                                                        y2: "11.8426",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint5_linear_5984_54722",
                                                                                        x1: "2.8261",
                                                                                        y1: "10.1657",
                                                                                        x2: "1.14153",
                                                                                        y2: "8.94779",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint6_linear_5984_54722",
                                                                                        x1: "4.93266",
                                                                                        y1: "5.38776",
                                                                                        x2: "2.98674",
                                                                                        y2: "3.52078",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint7_linear_5984_54722",
                                                                                        x1: "15.5459",
                                                                                        y1: "5.14404",
                                                                                        x2: "17.2932",
                                                                                        y2: "3.45622",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint8_linear_5984_54722",
                                                                                        x1: "3.23077",
                                                                                        y1: "9.78771",
                                                                                        x2: "19.2211",
                                                                                        y2: "15.5866",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint9_linear_5984_54722",
                                                                                        x1: "13.9779",
                                                                                        y1: "15.1785",
                                                                                        x2: "4.74789",
                                                                                        y2: "6.32304",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FEF0AE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FAC600"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint10_linear_5984_54722",
                                                                                        x1: "12.5334",
                                                                                        y1: "14.8492",
                                                                                        x2: "14.0698",
                                                                                        y2: "16.7511",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FE9738",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FE9738"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint11_linear_5984_54722",
                                                                                        x1: "14.1378",
                                                                                        y1: "15.8456",
                                                                                        x2: "8.44981",
                                                                                        y2: "6.47689",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#BE3F45",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#BE3F45"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint12_linear_5984_54722",
                                                                                        x1: "12.4912",
                                                                                        y1: "15.1923",
                                                                                        x2: "12.4912",
                                                                                        y2: "17.7678",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FE9738",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FE9738"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint13_linear_5984_54722",
                                                                                        x1: "9.73667",
                                                                                        y1: "13.0482",
                                                                                        x2: "13.3397",
                                                                                        y2: "23.1475",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFEEE6"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#FFB09E"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint14_linear_5984_54722",
                                                                                        x1: "7.34016",
                                                                                        y1: "17.4989",
                                                                                        x2: "1.15368",
                                                                                        y2: "17.4989",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFB09E",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#EC806B"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint15_linear_5984_54722",
                                                                                        x1: "10.1034",
                                                                                        y1: "14.3586",
                                                                                        x2: "12.3963",
                                                                                        y2: "16.6514",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#FFB09E",
                                                                                                "stop-opacity": "0"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#EC806B"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                        id: "paint16_linear_5984_54722",
                                                                                        x1: "0.418887",
                                                                                        y1: "16.6092",
                                                                                        x2: "2.90439",
                                                                                        y2: "16.6092",
                                                                                        gradientUnits: "userSpaceOnUse",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                "stop-color": "#B3DAFE"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                offset: "1",
                                                                                                "stop-color": "#0182FC"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                        id: "clip0_5984_54722",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                            width: "21",
                                                                                            height: "21",
                                                                                            fill: "white",
                                                                                            transform: "translate(0 0.5)"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        className: "ml0-5rem",
                                                                        children: "Recommendation:"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs14px c15 lh1-5",
                                                                children: answer?.['aiResponse']?.[recommendationKey] || question[recommendationKey]
                                                            })
                                                        ]
                                                    });
                                                })()
                                            })
                                        ]
                                    })
                                }, `section-random-${idx}`);
                            }),
                            " "
                        ]
                    })
                });
            });
        return writeSections(module?.sections);
    };
    const getKPIContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg52 br5px py0-5rem df aic jcsb mb1rem mt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1 ml1rem",
                            children: "#KPI Name"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1",
                            children: "KPI Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1",
                            children: "KPI Calculation"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "miw8rem c1",
                            children: "KPI Metric"
                        })
                    ]
                }),
                kpis && kpis.map((kpi, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px fw500 fsi",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: kpi['title'] || '-'
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px",
                                children: kpi['name'] || '-'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px",
                                children: kpi['calculation'] || '-'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                className: "miw8rem tal c15 fs12px",
                                children: kpi['metric'] || '-'
                            })
                        ]
                    }, `${idx}-kpi`))
            ]
        });
    };
    // If module has a reportUrl (Papermill PDF), show it with PdfViewer (links open in new tab)
    if (module?.reportUrl) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w100 h100",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9310f9c2b7964d10$export$2e2bcd8739ae039), {
            src: module.reportUrl,
            className: "w100 br10px",
            style: {
                height: '100vh'
            },
            title: "Module Report PDF"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            company && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                        id: "pdf",
                        className: `op0 pen ma td250 dg gg2rem ${tab}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "hideOnDownload mt2rem aic df",
                        children: [
                            !user.firstName && tab == 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df jcc aic fdc ",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem mb1rem tac c15",
                                        children: "Now let's view your 2-minute test report..."
                                    }),
                                    user['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>twoMinuteTestAIReport(module),
                                            className: "shadow bsbb jcc w100px w9rem df fdc aic fw500  px1rem c1 bg4 br19px cp registerButtonAnimation",
                                            style: {
                                                width: '25%',
                                                paddingTop: '7px',
                                                paddingBottom: '7px'
                                            },
                                            children: "View 2-Minute Test Report"
                                        })
                                    })
                                ]
                            }),
                            tab.match(/two-minute-test-.*-report/) && user?.['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 df jcc aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: `/company/${company['_id']}`,
                                    style: {
                                        width: '15%',
                                        paddingTop: '7px',
                                        paddingBottom: '7px'
                                    },
                                    className: `shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                                    children: "Next"
                                })
                            }),
                            module && module?.['type'] && isRepositoryModule && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(""),
                                    className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Dashboard"
                                })
                            }),
                            module && module?.['type'] && module?.['type'].includes(`business-audit-${company?.['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc aic w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setTab(module['type']),
                                        className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                        children: "Business Audit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>setTab(""),
                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                        children: "Dashboard"
                                    })
                                ]
                            }),
                            module && module?.['type'] && module?.['type'] == "warranty-disclosure" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic w100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(""),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Dashboard"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                        id: "pdfContent",
                        className: "bsbb w0 h0 oh op0 pen db pr",
                        style: {
                            width: "210mm"
                        },
                        children: tab === "kpi-report" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df aic jcsb pdfHeaderCustom",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "tal c15 lh1 mt1rem fs1-25rem ",
                                                    children: "KPI Report"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "fsi tal c15 fs1rem fw400 mb1rem",
                                                    children: company['cName']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mt3rem c15",
                                                    children: [
                                                        "Report Date: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600 c15",
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date()).format('MMM DD, YYYY')
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 df fdc jcsb aife",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w80px h80px mb2rem",
                                                    src: (parcelRequire("hiMCQ")),
                                                    alt: "bonusIcon"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15 fs12px fw500 w100 tar",
                                                    children: "Bespoke KPI report for your company"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                getKPIContent()
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                getOverviewContent(),
                                [
                                    'repository-report',
                                    `business-audit-${company?.['testType']}-report`,
                                    'warranty-disclosure-report',
                                    'software-development-report',
                                    'esg-report',
                                    `directors-questionnaire_${module?.['director']?.['_id']}`
                                ].includes(tab) ? getAuditReportContent() : tab.includes("repository-sync-report") ? getSyncContent() : tab.includes("repository-audit-report") ? getAuditContent() : tab.match(/two-minute-test-.*-report/) ? getTwoMinuteTestContent() : getAuditReportContent()
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'generatingKPI',
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tac",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h9rem",
                            src: (parcelRequire("hA45b")),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "mb0-5rem c15",
                            children: "Generating KPI Report"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fs0-75rem mb1rem",
                            children: "This may take few seconds."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "mb1-5rem c15 fs12px px1rem op70",
                            children: [
                                "We are prepare your ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    className: "fsi",
                                    children: "BONUS KPI Report"
                                }),
                                ", which suggests 10 useful business metrics for your business, how to calculate them, and your industry comparables."
                            ]
                        })
                    ]
                })
            })
        ]
    });
}








var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");













var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $27c855d4daab692d$var$ListOfSectionMenu = ({ module: module, sections: sections = [], onNavigateSection: onNavigateSection, company: company })=>{
    const [showSub, setShowSub] = (0, $acw62.useState)(false);
    const titleRef = (0, $acw62.useRef)(null);
    const hideTimer = (0, $acw62.useRef)(null);
    const show = ()=>{
        clearTimeout(hideTimer.current);
        setShowSub(true);
    };
    // Longer delay so the user can move the mouse to the scrollbar without the sub closing
    const hide = ()=>{
        hideTimer.current = setTimeout(()=>setShowSub(false), 400);
    };
    const navigateSection = (sectionNo)=>{
        const type = module?.['slug'].includes('business-audit') ? `${module?.['slug']}-${company['testType']}` : module?.['slug'];
        if (typeof onNavigateSection === 'function') onNavigateSection(type, sectionNo);
    };
    // sections with subFolders then use subFolders as sections
    if (sections.length === 1 && sections[0]?.subFolders) {
        const subFoldersArray = Array.isArray(sections[0].subFolders) ? sections[0].subFolders : Object.values(sections[0].subFolders);
        if (subFoldersArray.length > 0) {
            const parentStats = sections[0]?.stats || {
                completionPercent: 0,
                riskPercent: 0
            };
            sections = subFoldersArray.map((sub)=>({
                    sectionName: sub.name,
                    sectionNo: sub.no,
                    stats: parentStats,
                    questions: sub.questions || []
                }));
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                ref: titleRef,
                className: "ds-module-menu__title cp",
                onMouseEnter: show,
                onMouseLeave: hide,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                style: {
                                    width: '16px',
                                    height: '16px',
                                    marginRight: '8px'
                                },
                                src: (parcelRequire("jowwK")),
                                alt: "list-of-sections"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "List of Sections"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        style: {
                            height: '10px',
                            marginRight: '8px'
                        },
                        src: (parcelRequire("d729Q")),
                        alt: "arrow-right"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ds-module-menu__divider"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ds-module-menu__sub",
                style: {
                    opacity: showSub ? 1 : 0,
                    pointerEvents: showSub ? 'auto' : 'none',
                    overflowY: 'auto',
                    maxHeight: '50vh'
                },
                onMouseEnter: show,
                onMouseLeave: hide,
                children: sections.length > 0 && sections.map((section, idx)=>{
                    if (!section.stats) section.stats = module?.['module']?.['sections']?.[0]?.['stats'] || module?.['sections']?.[0]?.['stats'] || {
                        completionPercent: 0,
                        riskPercent: 0
                    };
                    const completeness = section.stats.completionPercent || 0;
                    let riskColour;
                    if (module.type === "repository" || (section.stats.riskPercent || 0) < 38) riskColour = 7;
                    else if (section.stats.riskPercent > 62) riskColour = 9;
                    else riskColour = 8;
                    const hexColour = riskColour === 8 ? "#ddb64044" : riskColour === 9 ? "#dd404044" : "#40dda144";
                    let colorChange = false;
                    if (module['type'] === "warranty-disclosure" && section?.questions?.length > 0) section.questions.forEach((question)=>{
                        if (question?.['answer']?.['radioOption'] === 'Disclosure' || question?.['answer']?.['radioOption'] === 'Not Sure') colorChange = true;
                    });
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>navigateSection(section['sectionNo']),
                        style: {
                            background: `linear-gradient(90deg, ${colorChange ? "#f9922a" : hexColour} 0%, ${colorChange ? "#f9922a" : hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                        },
                        "data-scroll-to": section['sectionNo'],
                        className: "overlay-box tal w100 tac cp c3-hover",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: section['sectionName']
                        })
                    }, idx);
                })
            })
        ]
    });
};
var $27c855d4daab692d$export$2e2bcd8739ae039 = $27c855d4daab692d$var$ListOfSectionMenu;









const $0a86646fcef869f1$var$ModuleCardMenusNew = ({ module: module, onNavigateSection: onNavigateSection, menus: menus, reportMenu: reportMenu, company: company, setTab: setTab, setIsWorkflowReport: setIsWorkflowReport, setCompanyDashboardTab: setCompanyDashboardTab })=>{
    const [selectedSeeMore, setSelectedSeeMore] = (0, $acw62.useState)({});
    const [activeDynamicMenu, setActiveDynamicMenu] = (0, $acw62.useState)(null);
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [dropdownPos, setDropdownPos] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const triggerRef = (0, $acw62.useRef)(null);
    const hoverTimeoutRef = (0, $acw62.useRef)(null);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let sections = module?.['sections'] || module?.['module']?.['sections'] || [];
    const isExpansionLocked = [
        'warranty-disclosure',
        'directors-questionnaire'
    ].includes(module?.type) && !company?.expensions?.[module?.id];
    const isPaid = module?.isPaid || false;
    const hasBoughtExpension = Array.isArray(company?.boughtExpensions) && company.boughtExpensions.some((id)=>id?.toString() === module?._id?.toString());
    const hasPurchased = !isPaid || module?.hasPurchased === true || hasBoughtExpension;
    /** Align with SidebarIndexNew / company stats: module completion drives report & workflow menus. */ const moduleCompletionPercent = Number(module?.stats?.completionPercent ?? module?.completenessPercent ?? 0) || 0;
    const canUseReportMenus = moduleCompletionPercent > 0;
    const openPaidModulePurchaseModal = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'subscriptionPaymentConfirm',
            purchasePlan: 'tempModulePurchase',
            purchaseDefaultStep: 'tempModulePurchase',
            modulePurchase: {
                tempModuleId: module?._id,
                moduleName: module?.moduleName,
                price: module?.price,
                subscriptionTier: company?.subscription,
                companyObjective: company?.testType,
                stripeProductPriceId: module?.stripeProductPriceId
            }
        }));
    };
    const isReportOrWorkflowMenu = (menu)=>menu?.key === 'report' || menu?.key === 'workflowReport' || menu?.label?.toLowerCase?.() === 'report';
    const handleDynamicMenuClick = (menu)=>{
        if (!menu || menu.isActive === false || isExpansionLocked) return;
        if (isReportOrWorkflowMenu(menu)) {
            if (isPaid && !hasPurchased) {
                openPaidModulePurchaseModal();
                return;
            }
            if (!canUseReportMenus) return;
            if (menu?.key === 'workflowReport') {
                setCompanyDashboardTab?.('Dashboard');
                setIsWorkflowReport?.(true);
            }
            if (module?.['moduleName'] === "Business Audit") {
                setTab(`${module['slug']}-${company['testType']}-report`);
                navigate(`/company/${company['_id']}#${module['slug']}-${company['testType']}-report`);
            } else {
                setTab(`${module['slug']}-report`);
                navigate(`/company/${company['_id']}#${module['slug']}-report`);
            }
            return;
        }
        if (menu.actionType === 'navigate') {
            if (menu.navigateUrl) window.open(menu.navigateUrl, '_blank', 'noopener,noreferrer');
            return;
        }
        if (menu.actionType === 'modal') {
            setActiveDynamicMenu(menu);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'dynamicModuleMenuModal'
            }));
        }
    };
    const dynamicMenus = Array.isArray(module?.menusConfig) ? module.menusConfig.filter((m)=>m && m.isActive !== false) : [];
    const openMenu = (0, $acw62.useCallback)(()=>{
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = null;
        }
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const SUB_WIDTH = 240;
            // Rough height estimates used only for overflow detection
            const DROPDOWN_EST_HEIGHT = 300;
            const SUB_EST_HEIGHT = 400;
            // Flip main dropdown above the trigger if not enough space below
            const spaceBelow = window.innerHeight - rect.bottom;
            const flipDown = spaceBelow < DROPDOWN_EST_HEIGHT;
            // Flip sub-menu leftward if it would overflow the right edge
            const flipSub = rect.right + SUB_WIDTH > window.innerWidth;
            // Flip sub-menu upward if it would overflow the bottom of the viewport.
            // When the main dropdown is flipped upward the sub starts near the top
            // of the dropdown; when it is below the trigger we check from rect.bottom.
            const subOriginY = flipDown ? rect.top - DROPDOWN_EST_HEIGHT : rect.bottom;
            const flipSubDown = subOriginY + SUB_EST_HEIGHT > window.innerHeight;
            setDropdownPos({
                top: flipDown ? rect.top + window.scrollY - 4 : rect.bottom + window.scrollY + 4,
                left: rect.right + window.scrollX,
                flipDown: flipDown,
                flipSub: flipSub,
                flipSubDown: flipSubDown
            });
        }
        setIsOpen(true);
    }, []);
    const closeMenu = (0, $acw62.useCallback)(()=>{
        hoverTimeoutRef.current = setTimeout(()=>setIsOpen(false), 400);
    }, []);
    // Close on scroll / resize so the portal doesn't drift.
    // Ignore scroll events that originate inside the dropdown itself (e.g. the sections list).
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) return;
        const close = (e)=>{
            if (e.target && e.target.closest && e.target.closest('.ds-module-menu__dropdown')) return;
            setIsOpen(false);
        };
        window.addEventListener('scroll', close, true);
        window.addEventListener('resize', close);
        return ()=>{
            window.removeEventListener('scroll', close, true);
            window.removeEventListener('resize', close);
        };
    }, [
        isOpen
    ]);
    // The dropdown is portalled to document.body so it escapes every
    // overflow:hidden / clipping ancestor (the 200px card, the rounded dashboard card, etc.)
    const dropdown = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: [
            'ds-module-menu__dropdown',
            dropdownPos.flipSub ? 'ds-module-menu__dropdown--flip-sub' : '',
            dropdownPos.flipDown ? 'ds-module-menu__dropdown--flip-down' : '',
            dropdownPos.flipSubDown ? 'ds-module-menu__dropdown--flip-sub-down' : ''
        ].filter(Boolean).join(' '),
        style: {
            position: 'absolute',
            top: dropdownPos.top,
            left: dropdownPos.left,
            // Flip upward: translateY(-100%) moves the bottom edge to the trigger's top.
            // Flip downward (default): translateY(0) keeps the top edge at the trigger's bottom.
            transform: dropdownPos.flipDown ? 'translateX(-100%) translateY(-100%)' : 'translateX(-100%) translateY(0)',
            zIndex: 99999,
            // Override the CSS initial state (opacity:0, pointer-events:none) since
            // the portal lives in document.body and the :hover selector no longer applies
            opacity: 1,
            pointerEvents: 'auto'
        },
        onMouseEnter: openMenu,
        onMouseLeave: closeMenu,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "ds-module-menu__section ds-submenu",
            children: [
                sections.length > 0 && (menus?.includes('listOfSections') || module?.['menus']?.includes('listOfSections')) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $27c855d4daab692d$export$2e2bcd8739ae039), {
                    module: module,
                    sections: sections,
                    onNavigateSection: onNavigateSection,
                    company: company
                }),
                dynamicMenus.map((menu)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        onClick: ()=>handleDynamicMenuClick(menu),
                        className: "ds-module-menu__item df aic",
                        children: [
                            menu.iconURL && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                style: {
                                    width: '16px',
                                    height: '16px',
                                    marginRight: '8px'
                                },
                                src: menu.iconURL,
                                alt: menu.label || 'menu-icon'
                            }),
                            menu.label || 'Menu'
                        ]
                    }, menu.key || menu.label)),
                reportMenu && reportMenu.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ds-module-menu__divider"
                        }),
                        reportMenu.map((menu)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                disabled: !canUseReportMenus && (menu?.key === 'report' || menu?.key === 'workflowReport'),
                                onClick: ()=>handleDynamicMenuClick(menu),
                                className: [
                                    'ds-module-menu__item df aic',
                                    !canUseReportMenus && (menu?.key === 'report' || menu?.key === 'workflowReport') ? 'op20 pen' : ''
                                ].filter(Boolean).join(' '),
                                children: [
                                    menu.key === 'report' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            marginRight: '8px'
                                        },
                                        src: (parcelRequire("cNord")),
                                        alt: "report"
                                    }),
                                    menu.key === 'workflowReport' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            marginRight: '8px'
                                        },
                                        src: (parcelRequire("bLX5S")),
                                        alt: "workflow-report"
                                    }),
                                    menu.label || 'Menu'
                                ]
                            }, menu.key || menu.label))
                    ]
                })
            ]
        })
    }), document.body) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "ds-module-menu",
                onMouseEnter: openMenu,
                onMouseLeave: closeMenu,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: triggerRef,
                        className: "ds-module-card__menu",
                        children: "\u2022\u2022\u2022"
                    }),
                    dropdown
                ]
            }),
            Object.keys(selectedSeeMore).length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4aa1eeaaa8768bb3$export$2e2bcd8739ae039), {
                selectedSeeMore: selectedSeeMore
            }) : null,
            activeDynamicMenu && activeDynamicMenu.actionType === 'modal' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "dynamicModuleMenuModal",
                modalCardClasses: "maw900px",
                onCloseHandler: ()=>setActiveDynamicMenu(null),
                customStyle: {
                    padding: '2rem'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style w100 df fdc",
                    children: [
                        activeDynamicMenu.modalTitle && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "fs1-5rem fw600 c15 mb1rem tac",
                            children: activeDynamicMenu.modalTitle
                        }),
                        activeDynamicMenu.modalImageURL && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: activeDynamicMenu.modalImageURL,
                            alt: activeDynamicMenu.modalTitle || 'menu-modal',
                            style: {
                                width: '100%',
                                borderRadius: '12px',
                                objectFit: 'contain'
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var $0a86646fcef869f1$export$2e2bcd8739ae039 = $0a86646fcef869f1$var$ModuleCardMenusNew;






var $ayMG0 = parcelRequire("ayMG0");




const $0829586188706cd0$var$ModuleCardHeader = ({ resolvedLogo: resolvedLogo, logoAlt: logoAlt, subTitle: subTitle, moduleTagColor: moduleTagColor, name: name, moduleSlug: moduleSlug, company: company, subscriptionLabel: subscriptionLabel, setTab: setTab, isPaid: isPaid, hasPurchased: hasPurchased, isRestricted: isRestricted, onRequirePurchase: onRequirePurchase, onRestrictedClick: onRestrictedClick, externalUrl: externalUrl, isResearchAid: isResearchAid, isNavigationModule: isNavigationModule, isDirectorsModule: isDirectorsModule, tempDirectorsModuleSlug: tempDirectorsModuleSlug, isMemberPermissionRestricted: isMemberPermissionRestricted, isInvestmentReadiness: isInvestmentReadiness, isExitReadiness: isExitReadiness, needToCreate: needToCreate, onNeedToCreate: onNeedToCreate, isCreatingIRM: isCreatingIRM, isResearchAidReportGenerated: isResearchAidReportGenerated, onOpenResearchAidReport: onOpenResearchAidReport, module: module, report: report, setTabName: setTabName })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const tagHex = typeof moduleTagColor === 'string' ? moduleTagColor.trim() : '';
    const hasValidTagHex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(tagHex);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df aic jcsb w100",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic w100",
            style: {
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "br10px bg1 p0-5rem df aic jcc",
                    style: {
                        width: '60px',
                        height: '60px',
                        border: '1px solid #E3E3E3',
                        flexShrink: 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: resolvedLogo,
                        alt: logoAlt,
                        width: 52,
                        height: 47
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc pr w100",
                    children: [
                        subTitle ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: `fs12px fw400 pa ${hasValidTagHex ? '' : 'c15 op70'}`,
                            style: {
                                left: '1rem',
                                top: '-14px',
                                ...hasValidTagHex ? {
                                    color: tagHex
                                } : {}
                            },
                            children: subTitle.length > 22 ? subTitle.substring(0, 22) + '...' : subTitle
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df aic jcsb w100",
                            children: isMemberPermissionRestricted ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ml1rem df fdc cp",
                                style: {
                                    overflow: 'hidden'
                                },
                                onClick: ()=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("You don't have permission for this module. Please contact your admin to gain access."),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "fs15px fw500 c15",
                                    style: {
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        lineHeight: '1.2'
                                    },
                                    children: name === 'InvestorMatch' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Investor",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "Match"
                                            })
                                        ]
                                    }) : name.length > 30 ? name.substring(0, 30) + '...' : name
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: isResearchAidReportGenerated && isNavigationModule && isResearchAid ? `/company/${company?.['_id']}#${report['_id']}?${report['reportType']}-researchaid` : isPaid && !hasPurchased || (isInvestmentReadiness || isExitReadiness) && needToCreate ? '#' : isRestricted ? '#' : isDirectorsModule ? '#' : isNavigationModule && isResearchAid && externalUrl === '#' ? '' : isNavigationModule && isResearchAid ? `/researchAid/${company?.['_id']}?${externalUrl}` : externalUrl ? '#' : `#${moduleSlug}`,
                                        state: {
                                            company: company
                                        },
                                        onClick: (e)=>{
                                            if (isResearchAidReportGenerated && isNavigationModule && isResearchAid) {
                                                console.log("1");
                                                onOpenResearchAidReport && onOpenResearchAidReport();
                                                return;
                                            }
                                            if ((isInvestmentReadiness || isExitReadiness) && needToCreate) {
                                                console.log("2");
                                                e.preventDefault();
                                                if (!isCreatingIRM) onNeedToCreate && onNeedToCreate();
                                                return;
                                            }
                                            if (isRestricted) {
                                                console.log("3");
                                                e.preventDefault();
                                                onRestrictedClick && onRestrictedClick();
                                                return;
                                            }
                                            if (isDirectorsModule && hasPurchased) {
                                                console.log("4");
                                                e.preventDefault();
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'showTempDirectors',
                                                    tempDirectorsModuleSlug: tempDirectorsModuleSlug || moduleSlug
                                                }));
                                                return;
                                            }
                                            if (externalUrl && !isResearchAid) {
                                                console.log("5");
                                                e.preventDefault();
                                                window.open(externalUrl, '_blank', 'noopener,noreferrer');
                                                return;
                                            }
                                            if (isPaid && !hasPurchased) {
                                                console.log("6");
                                                e.preventDefault();
                                                onRequirePurchase && onRequirePurchase();
                                                return;
                                            }
                                            if (isNavigationModule && isResearchAid && externalUrl === '#') {
                                                console.log("7");
                                                e.preventDefault();
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'swotReportPopup'
                                                }));
                                                return;
                                            }
                                            console.log("8");
                                            setTab(moduleSlug);
                                        },
                                        className: "fs15px fw500 c15 ml1rem",
                                        style: {
                                            overflow: 'hidden',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            marginTop: '0px',
                                            lineHeight: '1.2'
                                        },
                                        children: name === "InvestorMatch" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Investor",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c4",
                                                    children: "Match"
                                                })
                                            ]
                                        }) : name.length > 30 ? name.substring(0, 30) + '...' : name
                                    }),
                                    subscriptionLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs14px fw600 ml0-5rem c7",
                                        style: {
                                            flexShrink: 0,
                                            letterSpacing: '0.03em'
                                        },
                                        children: company?.['subscription'] === "Free" || company?.['subscription'] === "Lite" ? /(audit|repository)/i.test(name) ? 'LITE' : 'PRO' : 'PRO'
                                    }) : name?.includes('KPI Report') ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs14px fw600 ml0-5rem ttu c59",
                                        style: {
                                            flexShrink: 0,
                                            letterSpacing: '0.03em'
                                        },
                                        children: "Free"
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $0829586188706cd0$export$2e2bcd8739ae039 = $0829586188706cd0$var$ModuleCardHeader;



var $ayMG0 = parcelRequire("ayMG0");
const $4dda7bde7f371856$var$ModuleCardDescription = ({ descriptionText: descriptionText })=>{
    if (!descriptionText) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            flex: 1
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "fs11px fw400 c15 op70 m0 h100 df aife",
        style: {
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
        },
        children: (()=>{
            if (descriptionText.length <= 30) return descriptionText;
            const breakIndex = descriptionText.lastIndexOf(' ', 30);
            if (breakIndex === -1) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    descriptionText.slice(0, 30),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    descriptionText.slice(30)
                ]
            });
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    descriptionText.slice(0, breakIndex),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    descriptionText.slice(breakIndex + 1)
                ]
            });
        })()
    });
};
var $4dda7bde7f371856$export$2e2bcd8739ae039 = $4dda7bde7f371856$var$ModuleCardDescription;



var $ayMG0 = parcelRequire("ayMG0");

const $5d0cfa59c4d8a292$var$ModuleCardStats = ({ showCompleteness: showCompleteness, completenessPercent: completenessPercent, showRisk: showRisk, riskPercent: riskPercent, isInvestorMatch: isInvestorMatch, strongMatchCount: strongMatchCount, mediumMatchCount: mediumMatchCount })=>{
    if (isInvestorMatch) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df aic",
        style: {
            gap: '0.25rem'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: `${strongMatchCount > 0 ? 'green' : 'c28'} fs2rem lh1 mr2rem`,
                children: [
                    strongMatchCount || 0,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `${strongMatchCount > 0 ? 'c15' : 'c15'} fs0-75rem w4rem db fw300`,
                        children: "Strong Match"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                className: `${mediumMatchCount > 0 ? 'yellow' : 'c28'} fs2rem lh1 mr2rem`,
                children: [
                    mediumMatchCount || 0,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `${mediumMatchCount > 0 ? 'c15' : 'c15'} fs0-75rem w4rem db fw300`,
                        children: "Medium Match"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df aic",
        style: {
            gap: '0.25rem'
        },
        children: [
            showCompleteness && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac8fd7b02f1c6431$export$2e2bcd8739ae039), {
                value: completenessPercent,
                type: "Module Complete"
            }),
            showRisk && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac8fd7b02f1c6431$export$2e2bcd8739ae039), {
                value: riskPercent,
                type: "Module Risk"
            })
        ]
    });
};
var $5d0cfa59c4d8a292$export$2e2bcd8739ae039 = $5d0cfa59c4d8a292$var$ModuleCardStats;



var $ayMG0 = parcelRequire("ayMG0");




const $16a68356aa4a314d$var$CertificationBadge = ({ moduleCertification: moduleCertification })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df aic jcc",
        style: {
            width: '64px',
            height: '64px'
        },
        children: [
            moduleCertification?.toLowerCase() === 'bronze' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "h4rem",
                src: (parcelRequire("cXyX2")),
                alt: "bronze"
            }),
            moduleCertification?.toLowerCase() === 'silver' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "h4rem",
                src: (parcelRequire("7YoCF")),
                alt: "silver"
            }),
            moduleCertification?.toLowerCase() === 'gold' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "h4rem",
                src: (parcelRequire("gr5qi")),
                alt: "gold"
            }),
            (!moduleCertification || moduleCertification?.toLowerCase() === 'none') && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "h4rem",
                src: (parcelRequire("gr5qi")),
                alt: "certification",
                style: {
                    opacity: 0.35,
                    filter: 'grayscale(1)'
                }
            })
        ]
    });
};
var $16a68356aa4a314d$export$2e2bcd8739ae039 = $16a68356aa4a314d$var$CertificationBadge;



var $ayMG0 = parcelRequire("ayMG0");
const $8ac2724ea7e056e7$var$PassFailBadge = ({ resolvedLogo: resolvedLogo, logoAlt: logoAlt, hasPassed: hasPassed })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "br10px df fdc aic jcc pr",
        style: {
            width: '70px',
            height: '70px',
            border: '1px solid #E3E3E3',
            overflow: 'hidden',
            background: '#f9f9f9'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: resolvedLogo,
                alt: logoAlt,
                style: {
                    width: '28px',
                    height: '28px',
                    objectFit: 'contain',
                    marginBottom: '4px'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "fw700 tac",
                style: {
                    fontSize: '10px',
                    color: hasPassed ? '#2e7d32' : '#c62828',
                    background: hasPassed ? '#e8f5e9' : '#ffebee',
                    borderRadius: '4px',
                    padding: '1px 5px',
                    lineHeight: '16px'
                },
                children: hasPassed ? 'Passed' : 'Failed'
            })
        ]
    });
};
var $8ac2724ea7e056e7$export$2e2bcd8739ae039 = $8ac2724ea7e056e7$var$PassFailBadge;




const $97fe78def71c3b36$var$DURATION_LABELS = {
    'isReady': 'Is Ready',
    '1 mins': '1 Min',
    '2 mins': '2 Mins',
    '3mins': '3 Mins',
    '5mins': '5 Mins',
    '10mins': '10 Mins',
    '15mins': '15 Mins',
    '30mins': '30 Mins',
    '2 days': '2 Days'
};
const $97fe78def71c3b36$var$getModuleUrl = (moduleName)=>{
    return moduleName.trim().toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-');
};

function $97fe78def71c3b36$var$ModuleCard({ name: name = 'Module Name', subTitle: subTitle = '', logoAlt: logoAlt = 'Module Logo', description: description, module: module, user: user, permissionLevel: permissionLevel, moduleCertification: moduleCertification, getFitInvestorFirms: getFitInvestorFirms, type: type, setTab: setTab, company: company, setIsWorkflowReport: setIsWorkflowReport, seeMore: seeMore = null, howItWorks: howItWorks = null, imageURL: imageURL, showPercentages: showPercentages, setCompanyDashboardTab: setCompanyDashboardTab, menus: menus, reportMenu: reportMenu, report: report = null, setTabName: setTabName }) {
    const defaultLogo = (parcelRequire("a8Wtc"));
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [isCreatingIRM, setIsCreatingIRM] = (0, $acw62.useState)(false);
    const [isCreatingER, setIsCreatingER] = (0, $acw62.useState)(false);
    const resolvedLogo = imageURL || module?.imageURL || defaultLogo;
    const moduleSlug = module?.slug?.includes('business-audit') ? `${module?.slug}-${company?.['testType']}` : module?.slug || type || $97fe78def71c3b36$var$getModuleUrl(name);
    const descriptionText = description ?? module?.moduleDescription ?? '';
    // ── Derived state from module fields ─────────────────────────────────────
    const isStarted = module?.isStarted || false;
    const completenessPercent = module?.completenessPercent || 0;
    const riskPercent = module?.riskPercent || 0;
    const sectionRestriction = module?.sectionAccessRestrictions?.filter((r)=>r?.companyObjective?.toLowerCase() === company?.testType?.toLowerCase() && r?.subscriptionTier?.toLowerCase() === company?.subscription?.toLowerCase())[0]?.isRestricted || false;
    // ResearchAid report cards are always accessible from the dashboard (same as the ResearchAid tab) — never apply the subscription restriction to them
    const isResearchAidCard = module?.isResearchAid === true;
    // KPI Report is free for every user and has no sections an admin could grant permission on, so it must never be
    // permission-gated — otherwise members are blocked with no way for the admin to unblock them.
    const isKpiReportCard = String(module?.['moduleKey'] || '').toLowerCase() === 'kpi' || /kpi report/i.test(String(module?.['moduleName'] || name || ''));
    // Reason: a card can expose a parent section number while permissions are granted per sub-section — InvestorMatch's
    // card carries sections: [{ sectionNo: 'DEPF008' }] but the permissions tree grants DEPF008.1 … DEPF008.4 — so a
    // grant on any child must satisfy the parent. Values are read as truthy, since legacy permissions store 1, not true.
    const hasSectionPermission = (perms, sectionNo)=>{
        if (!perms || !sectionNo) return false;
        if (perms[sectionNo]) return true;
        const childPrefix = `${sectionNo}.`;
        return Object.keys(perms).some((key)=>key.startsWith(childPrefix) && perms[key]);
    };
    const isMemberPermissionRestricted = (()=>{
        if (isKpiReportCard) return false;
        if (user?.['role'] !== 'User' && user?.['role'] !== 'Member' || !user?.['createdBy'] || user['createdBy']['role'].toLowerCase() !== 'user' || company?.['creatorId']?.['_id']?.toString() === user?.['_id']?.toString()) return false;
        const memberPerms = company?.['memberPermissions']?.[user['_id']];
        const sections = module?.sections || [];
        const sectionsWithNo = sections.filter((s)=>s['sectionNo']);
        if (module?.['moduleKey'] && hasSectionPermission(memberPerms, module['moduleKey'])) return false;
        if (sectionsWithNo.some((s)=>hasSectionPermission(memberPerms, s['sectionNo']))) return false;
        if (!module?.['moduleKey'] && !sectionsWithNo.length) return false;
        return true;
    })();
    const isRestricted = !isResearchAidCard && (sectionRestriction || module?.isRestricted === true || isMemberPermissionRestricted);
    const isPaid = module?.isPaid || false;
    const hasBoughtExpension = Array.isArray(company?.boughtExpensions) && company.boughtExpensions.some((id)=>id?.toString() === module?._id?.toString());
    const hasPurchased = hasBoughtExpension || !isPaid || module?.hasPurchased === true;
    // console.log(!isPaid, module?.hasPurchased === true, hasBoughtExpension, "isPaid, hasPurchased -----function------> ModuleCard")
    const showRestrictedMessage = ()=>{
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('This module is restricted for your subscription. You need to upgrade.');
    };
    const isRestrictedBlocked = ()=>{
        if (!isRestricted) return false;
        showRestrictedMessage();
        return true;
    };
    const openPaidModulePurchaseModal = ()=>{
        if (isRestrictedBlocked()) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'subscriptionPaymentConfirm',
            purchasePlan: 'tempModulePurchase',
            purchaseDefaultStep: 'tempModulePurchase',
            modulePurchase: {
                tempModuleId: module?._id,
                moduleName: module?.moduleName || name,
                price: module?.price,
                subscriptionTier: company?.subscription,
                companyObjective: company?.testType,
                stripeProductPriceId: module?.stripeProductPriceId
            }
        }));
    };
    const handleIRMCreate = async ()=>{
        setIsCreatingIRM(true);
        // Step 1: fetch the IRM partner to get its _id (key CLIMB26 is the IRM partner)
        const partnerRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/checklist/partner/KPMG');
        if (partnerRes?.code !== 200 || !partnerRes?.body?.['_id']) {
            setIsCreatingIRM(false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Investment Readiness configuration not found', 'error');
            return;
        }
        // Step 2: trigger the standard checklist creation (step 0 = all-in-one run).
        // genType:'automatic' → GPT generates section names when partner has no fixedSections/dynamicSections.
        // totalQuestions:50 → 10 sections × 5 questions each (totalQuestions / 10 per section in addDDSections).
        const isHybrid = partnerRes['body']['checklist'] === 'Hybrid' && partnerRes['body']['fixedSections'] && partnerRes['body']['dynamicSections'];
        const payload = {
            partnerId: partnerRes['body']['_id'],
            category: 'partner',
            companies: {
                [company['_id']]: company['cName']
            },
            memberPermissions: {
                [user['_id']]: {
                    ...user,
                    company: {
                        _id: company['_id']
                    }
                }
            },
            totalQuestions: 50,
            ...!isHybrid && {
                genType: 'automatic'
            }
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/checklist/create/0', payload);
        setIsCreatingIRM(false);
        if (res?.code !== 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to create Investment Readiness module', 'error');
            return;
        }
        // reset=true forces setTab to re-fetch fresh section/question data after creation
        navigate(`/company/${company['_id']}#${moduleSlug}`);
        setTab(moduleSlug, true);
    };
    const handleExitCreate = async ()=>{
        setIsCreatingER(true);
        // Fetch the exit-readiness partner by testType ('exit' resolves via testType fallback in getPartner).
        const partnerRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/checklist/partner/ESFX');
        if (partnerRes?.code !== 200 || !partnerRes?.body?.['_id']) {
            setIsCreatingER(false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Exit Readiness configuration not found', 'error');
            return;
        }
        const isHybrid = partnerRes['body']['checklist'] === 'Hybrid' && partnerRes['body']['fixedSections'] && partnerRes['body']['dynamicSections'];
        const payload = {
            partnerId: partnerRes['body']['_id'],
            category: 'partner',
            companies: {
                [company['_id']]: company['cName']
            },
            memberPermissions: {
                [user['_id']]: {
                    ...user,
                    company: {
                        _id: company['_id']
                    }
                }
            },
            totalQuestions: 50,
            ...!isHybrid && {
                genType: 'automatic'
            }
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/checklist/create/0', payload);
        setIsCreatingER(false);
        if (res?.code !== 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Failed to create Exit Readiness module', 'error');
            return;
        }
        navigate(`/company/${company['_id']}#${moduleSlug}`);
        setTab(moduleSlug, true);
    };
    const setTabWithRestrictionCheck = async (nextTab)=>{
        if (isRestrictedBlocked()) return;
        if (user?.['role'] === 'Member' && company?.['creatorId']?.['_id']?.toString() !== user?.['_id']?.toString()) {
            const userPerms = company?.['memberPermissions']?.[user['_id']];
            const sectionNos = (module?.['sections'] || []).map((s)=>s?.['sectionNo']).filter(Boolean);
            const hasAnyPermission = sectionNos.some((sNo)=>hasSectionPermission(userPerms, sNo));
            if (sectionNos.length && userPerms && !hasAnyPermission && !isKpiReportCard && ![
                'Exit Readiness',
                'Investment Readiness'
            ].includes(module?.['moduleName'])) {
                const adminName = company?.['creatorId']?.['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] || ''}`.trim() : 'user';
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You don't have permission for this module. Please contact your admin ${adminName} to gain access`);
                return;
            }
        }
        if (module?.isDirectorsModule) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'showTempDirectors',
                tempDirectorsModuleSlug: module.slug || moduleSlug
            }));
            return;
        }
        if (module?.isNavigationModule) setCompanyDashboardTab(nextTab.includes('#') ? nextTab.replace('#', '') : `${nextTab}`);
        else return setTab(nextTab);
    };
    // Open an already-generated ResearchAid report in the report viewer tab (instead of the generate page)
    const openResearchAidReportView = ()=>{
        const reportId = report?.['_id'] || module?.reportId;
        const reportType = report?.['reportType'] || module?.externalUrl;
        if (!reportId || !reportType) return;
        setTab(`${reportId}?${reportType}-researchaid`);
        if (setCompanyDashboardTab) setCompanyDashboardTab('Dashboard');
    };
    const durationLabel = module?.duration && module.duration !== 'NIL' ? $97fe78def71c3b36$var$DURATION_LABELS[module.duration] || null : null;
    // ResearchAid: use embedded module data as fallback when report prop is null
    const effectiveScore = report?.['score'] ?? module?.reportScore;
    const effectiveCreatedBy = report?.['createdBy'] ?? module?.reportCreatedBy;
    const effectiveCreatedAt = report?.['createdAt'] ?? module?.reportCreatedAt;
    const effectiveReportId = report?.['_id'] ?? module?.reportId;
    const effectiveReportType = report?.['reportType'] ?? module?.externalUrl;
    const isReportGenerated = !!(report?.['htmlReport']?.length || module?.isReportGenerated || effectiveScore && effectiveCreatedBy);
    const effectiveReport = report || (module?.isReportGenerated || effectiveScore && effectiveReportId ? {
        _id: effectiveReportId,
        reportType: effectiveReportType
    } : null);
    const showStats = isStarted || hasBoughtExpension;
    const showCompleteness = (showStats || module?.completeness === 'Yes') && module?.completeness === 'Yes';
    const showRisk = (showStats || module?.risks === 'Yes') && module?.risks === 'Yes';
    const showCertification = showStats && module?.certification === 'Yes';
    const showPassFail = showStats && module?.passFail === 'Yes';
    const subscriptionLabel = (()=>{
        const regex = /(audit|repository|anylist|Workflow)/i;
        if (regex.test(module?.moduleName)) return company?.subscription?.toUpperCase();
        return null;
    })();
    const hasPassed = completenessPercent >= 70;
    const navigateSection = async (type, sectionNo)=>{
        if (isPaid && !hasPurchased) {
            openPaidModulePurchaseModal();
            return;
        }
        if (user?.['role'] == 'Guest') {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'noRegistrationReport'
            }));
            return;
        }
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT')) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if ([
            'software-development',
            'esg',
            'warranty-disclosure',
            'directors-questionnaire'
        ].includes(type)) {
            const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`;
            if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
                if (!company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
            if ((user['role'] == "Advisor" || user['role'] == 'Investor') && company['creatorId']['_id'] != user['_id']) {
                if (!company?.[user['role'] == "Investor" ? 'investors' : 'advisors']?.[user['_id']]?.['modules']?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
        }
        await setTabWithRestrictionCheck(type);
        navigate(`/company/${company['_id']}#${type}`);
        setTimeout(()=>{
            let element = document.getElementById(sectionNo);
            if (element) element.scrollIntoView({
                behavior: 'instant'
            }, true);
        }, 10000);
    };
    const setReportTab = async (type)=>{
        if (isRestrictedBlocked()) return;
        if (isPaid && !hasPurchased) {
            openPaidModulePurchaseModal();
            return;
        }
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && permissionLevel == 'DASHBOARD') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You have Dashboard access only!');
            return;
        }
        if (type == 'investor-lead') {
            getFitInvestorFirms();
            return;
        }
        setTabWithRestrictionCheck(type + '-report');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg1 new-shadow df fdc jcsb pr",
        style: {
            height: '200px',
            border: '1px solid #B5BFDE',
            borderRadius: '20px',
            padding: '1.25rem'
        },
        children: [
            (module?.menusConfig?.length > 0 || module?.reportMenu?.length > 0) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a86646fcef869f1$export$2e2bcd8739ae039), {
                module: module,
                onNavigateSection: navigateSection,
                setReportTab: setReportTab,
                setIsWorkflowReport: setIsWorkflowReport,
                setCompanyDashboardTab: setCompanyDashboardTab,
                setTabWithRestrictionCheck: setTabWithRestrictionCheck,
                type: type,
                setTab: setTab,
                company: company,
                seeMore: seeMore,
                howItWorks: howItWorks,
                menus: menus,
                reportMenu: reportMenu
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc jcsb",
                style: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0829586188706cd0$export$2e2bcd8739ae039), {
                        module: module,
                        resolvedLogo: resolvedLogo,
                        logoAlt: logoAlt,
                        subTitle: subTitle,
                        moduleTagColor: module?.moduleTagColor,
                        name: name,
                        setTab: setTabWithRestrictionCheck,
                        moduleSlug: moduleSlug,
                        company: company,
                        subscriptionLabel: subscriptionLabel,
                        isPaid: isPaid,
                        hasPurchased: hasPurchased,
                        isRestricted: isRestricted,
                        onRestrictedClick: showRestrictedMessage,
                        onRequirePurchase: openPaidModulePurchaseModal,
                        externalUrl: module?.externalUrl,
                        isResearchAid: module?.isResearchAid || false,
                        isReportGenerated: module?.isReportGenerated || false,
                        reportId: module?.reportId || null,
                        onOpenResearchAidReport: openResearchAidReportView,
                        isNavigationModule: module?.isNavigationModule || false,
                        isDirectorsModule: module?.isDirectorsModule || false,
                        tempDirectorsModuleSlug: module?.slug || moduleSlug,
                        isMemberPermissionRestricted: isMemberPermissionRestricted,
                        isInvestmentReadiness: module?.isInvestmentReadiness || false,
                        isExitReadiness: module?.isExitReadiness || false,
                        needToCreate: module?.needToCreate || false,
                        onNeedToCreate: module?.isExitReadiness ? handleExitCreate : handleIRMCreate,
                        isCreatingIRM: module?.isExitReadiness ? isCreatingER : isCreatingIRM,
                        isResearchAidReportGenerated: module?.isResearchAid && isReportGenerated,
                        report: effectiveReport,
                        setTabName: setTabName
                    }),
                    module?.isResearchAid ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `w100 df jcsb ${effectiveReportType === 'TCAR3' ? 'mt1rem' : 'mt2rem'}`,
                        children: [
                            !effectiveScore && !isReportGenerated && !(effectiveReportType === 'swotAnalysis' && report?.['disableSwotReport']) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: `/researchAid/${company['_id']}?${effectiveReportType}`,
                                state: {
                                    company: company
                                },
                                className: "c1 fs0-75rem fw600 td250 br25px px2rem py0-5rem cp bg4 bg3-hover",
                                children: "Generate"
                            }),
                            effectiveScore && effectiveCreatedBy ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "cp w100 df jcsb",
                                onClick: ()=>{
                                    setTab(`${effectiveReportId}?${effectiveReportType}-researchaid`);
                                    if (setCompanyDashboardTab) setCompanyDashboardTab('Dashboard');
                                },
                                children: [
                                    company['subscription'] === 'Free' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "w100 fs0-75rem fw300",
                                                children: "Executive Summary only."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "w100 fs0-75rem fw300",
                                                children: [
                                                    "To ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c7 fw500",
                                                        children: "UNLOCK"
                                                    }),
                                                    " upgrade to PRO/LITE"
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                "data-tooltip": `${effectiveCreatedBy?.firstName ?? ''} ${effectiveCreatedBy?.lastName ?? ''}`,
                                                className: "shadow w40px h40px bg16 bw3px bss bo19 df jcc aic br100 c1",
                                                children: effectiveCreatedBy?.profile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: effectiveCreatedBy.profile,
                                                    className: "new-shadow w30px h30px df jcc aic br100 bg16 c1"
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "bg16 c15 br50px",
                                                    children: effectiveCreatedBy?.firstName ? effectiveCreatedBy.firstName[0] + (effectiveCreatedBy.lastName?.[0] || '') : '?'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem c15 ml0-5rem",
                                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(effectiveCreatedAt).format('ll')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: `fs1-5rem tac ${effectiveScore >= 4 ? 'c34' : effectiveScore >= 2 ? 'c39' : 'c4'}`,
                                                children: [
                                                    effectiveScore,
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem",
                                                        children: "/5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs0-75rem fw400 c15",
                                                children: [
                                                    "Report ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " Score"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : effectiveReportType === 'swotAnalysis' && report?.['disableSwotReport'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem fw300 c14 tti",
                                children: "Please complete the other 4 reports prior to generating this report"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df aife jcsb",
                        style: {
                            gap: '0.5rem'
                        },
                        children: [
                            !isPaid && showStats && (showCompleteness || showRisk) || isPaid && hasPurchased && showCompleteness && showRisk ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d0cfa59c4d8a292$export$2e2bcd8739ae039), {
                                showCompleteness: showCompleteness,
                                completenessPercent: completenessPercent,
                                showRisk: showRisk,
                                riskPercent: riskPercent,
                                isInvestorMatch: module?.isInvestorMatch || false,
                                strongMatchCount: module?.strongMatchCount || 0,
                                mediumMatchCount: module?.mediumMatchCount || 0
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dda7bde7f371856$export$2e2bcd8739ae039), {
                                descriptionText: descriptionText
                            }),
                            !isPaid && showStats || isPaid && hasPurchased ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic jcfe",
                                style: {
                                    flexShrink: 0
                                },
                                children: [
                                    showCertification && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16a68356aa4a314d$export$2e2bcd8739ae039), {
                                        moduleCertification: moduleCertification
                                    }),
                                    showPassFail && !showCertification && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ac2724ea7e056e7$export$2e2bcd8739ae039), {
                                        resolvedLogo: resolvedLogo,
                                        logoAlt: logoAlt,
                                        hasPassed: hasPassed
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8b51cf619c26ee5$export$2e2bcd8739ae039), {
                                durationLabel: durationLabel,
                                isPaid: isPaid && !hasPurchased,
                                onBuyClick: openPaidModulePurchaseModal
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $97fe78def71c3b36$export$2e2bcd8739ae039 = $97fe78def71c3b36$var$ModuleCard;







function $c509866364afb9eb$var$ModuleCardSkeleton() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            height: '200px',
            border: '1px solid #B5BFDE',
            borderRadius: '20px',
            padding: '1.25rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                        variant: "circular",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                variant: "text",
                                width: "70%",
                                height: 20
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                                variant: "text",
                                width: "50%",
                                height: 16
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: "90%",
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                        variant: "text",
                        width: "75%",
                        height: 14
                    })
                ]
            })
        ]
    });
}
function $c509866364afb9eb$var$DashboardCardSkeleton({ moduleCount: moduleCount = 4, backgroundColor: backgroundColor = "#EEFFF7" }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "box-dashbord-contaxiner mla mra my1rem",
        style: {
            width: '98%'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "bg20 bss bo5 bsbb px2rem py2rem br25px w100 bw1px",
            style: {
                backgroundColor: backgroundColor
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 mb1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                            variant: "text",
                            width: 220,
                            height: 28
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $445470756a9ff70a$export$2e2bcd8739ae039), {
                            variant: "text",
                            width: 160,
                            height: 20,
                            style: {
                                marginTop: '4px'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "dg gg1rem gtcr4 w100",
                    children: Array.from({
                        length: moduleCount
                    }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($c509866364afb9eb$var$ModuleCardSkeleton, {}, i))
                })
            ]
        })
    });
}








function $c509866364afb9eb$export$2e2bcd8739ae039({ company: company, setTab: setTab, isWorkflowReport: isWorkflowReport, setIsWorkflowReport: setIsWorkflowReport, permissionLevel: permissionLevel, selectedSeeMore: selectedSeeMore, setSelectedSeeMore: setSelectedSeeMore, setCompanyDashboardTab: setCompanyDashboardTab, setTabName: setTabName }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const modalJustClosedRef = (0, $acw62.useRef)(false);
    let [isSwotReport, setIsSwotReport] = (0, $acw62.useState)(false);
    let [plan, setPlan] = (0, $acw62.useState)();
    let [payload, setPayload] = (0, $acw62.useState)(null);
    let [companyId, setCompanyId] = (0, $acw62.useState)("");
    let [showExpension, setShowExpension] = (0, $acw62.useState)(null);
    let [selectedHowItWorks, setSelectedHowItWorks] = (0, $acw62.useState)({});
    let [expanded, setExpanded] = (0, $acw62.useState)({
        investmentPanel: false,
        growthPanel: false,
        exitPanel: false
    });
    // OPTIMIZATION: Lazy load directors when not available (excluded in lightweight mode)
    let [directors, setDirectors] = (0, $acw62.useState)(company?.['directors'] || []);
    let [dashboardCards, setDashboardCards] = (0, $acw62.useState)(null);
    let [investorMatchCounts, setInvestorMatchCounts] = (0, $acw62.useState)(null);
    let [researchAidReports, setResearchAidReports] = (0, $acw62.useState)([]);
    let [workflowGenerated, setWorkflowGenerated] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const cid = company?.['_id'];
        if (!cid) return;
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/workflow/pending-answers?companyId=${cid}`).then((res)=>{
            setWorkflowGenerated(Array.isArray(res?.['body']) && res['body'].length > 0);
        }).catch(()=>{});
    }, [
        company?.['_id']
    ]);
    (0, $acw62.useEffect)(()=>{
        if (company['researchAidReports'] && company['researchAidReports'].length > 0) {
            const report = company?.['researchAidReports'].filter((item)=>item?.['reportType'] === "swotAnalysis")?.[0];
            if (report?.['disableSwotReport']) setIsSwotReport(true);
            else setIsSwotReport(false);
        }
    }, [
        company
    ]);
    const getDashboardCards = (0, $acw62.useCallback)(async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/dashboard-cards?modules=true&sections=true&companyId=${company?.['_id']}`);
            if (response?.code === 200) return response?.body;
        } catch (e) {
            console.error('Failed to fetch dashboard cards:', e);
        }
        return null;
    }, [
        company?._id
    ]);
    const fetchInvestorMatchCounts = (0, $acw62.useCallback)(async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/dashboard-cards/investor-match-counts?companyId=${company?.['_id']}`);
            if (response?.code === 200) return response?.body;
        } catch (e) {
            console.error('Failed to fetch investor match counts:', e);
        }
        return null;
    }, [
        company?._id
    ]);
    const fetchResearchAidReports = (0, $acw62.useCallback)(async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company?.['_id']}/reports`);
            if (response?.code === 200) return response?.body?.['reports']?.['researchAidReports'] || [];
        } catch (e) {
            console.error('Failed to fetch research aid reports:', e);
        }
        return [];
    }, [
        company?._id
    ]);
    // Attach a ResearchAid report to its dashboard card. The nav card's externalUrl is joined to the report's
    // reportType. Some cards (notably SWOT) have an externalUrl that isn't exactly 'swotAnalysis' (empty/#/mis-cased)
    // because they historically opened a popup instead of navigating — so fall back to a normalized/alias match and
    // finally the card title, otherwise their date/score never render on the dashboard even though the report exists.
    const REPORTTYPE_ALIASES = {
        swot: 'swotAnalysis',
        swotanalysis: 'swotAnalysis'
    };
    const findResearchAidReport = (m)=>{
        if (!m?.['isResearchAid'] || !Array.isArray(researchAidReports)) return null;
        const key = (m?.['externalUrl'] || '').trim();
        // 1. Exact reportType match (marketReport, competitorReport, routeToMarketReport, TCAR3, swotAnalysis)
        let report = researchAidReports.find((r)=>r?.['reportType'] === key);
        if (report) return report;
        // 2. Case-insensitive / punctuation-stripped match + known aliases (handles 'swot', 'SwotAnalysis', etc.)
        const norm = key.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (norm) {
            report = researchAidReports.find((r)=>(r?.['reportType'] || '').toLowerCase() === norm) || REPORTTYPE_ALIASES[norm] && researchAidReports.find((r)=>r?.['reportType'] === REPORTTYPE_ALIASES[norm]);
            if (report) return report;
        }
        // 3. Title-based fallback (handles empty/# externalUrl, e.g. a SWOT card that opened a popup)
        const title = (m?.['moduleName'] || '').trim().toLowerCase();
        if (title) {
            if (title.includes('swot')) {
                report = researchAidReports.find((r)=>r?.['reportType'] === 'swotAnalysis');
                if (report) return report;
            }
            report = researchAidReports.find((r)=>(r?.['name'] || '').trim().toLowerCase() === title);
        }
        return report || null;
    };
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        const isInvestment = String(company?.testType || '').toLowerCase() === 'investment';
        const cardsPromise = getDashboardCards().then((body)=>{
            if (!cancelled) setDashboardCards(body);
        });
        const countsPromise = isInvestment ? fetchInvestorMatchCounts().then((counts)=>{
            if (!cancelled) setInvestorMatchCounts(counts);
        }) : Promise.resolve();
        const reportsPromise = fetchResearchAidReports().then((reports)=>{
            if (!cancelled) setResearchAidReports(reports);
        });
        Promise.all([
            cardsPromise,
            countsPromise,
            reportsPromise
        ]);
        return ()=>{
            cancelled = true;
        };
    }, [
        getDashboardCards,
        fetchInvestorMatchCounts,
        fetchResearchAidReports
    ]);
    // Fetch directors if not available (excluded in lightweight mode)
    const fetchDirectors = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/directors`);
            if (response['code'] === 200 && response['body']) setDirectors(response['body']['directors'] || []);
        } catch (e) {
            console.error('Failed to fetch directors:', e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchDirectors();
    }, [
        company?._id,
        company?.['directors'],
        company?.['directorsCount']
    ]);
    (0, $acw62.useEffect)(()=>{
        if (window.localStorage.getItem('expandedPanels')) {
            const storedStates = JSON.parse(window.localStorage.getItem('expandedPanels'));
            setExpanded(storedStates);
        }
        let isManualAdd = localStorage.getItem('isManualAdd');
        if (isManualAdd) localStorage.removeItem('isManualAdd');
    }, []);
    const setModuleTab = async (setTab, type, module)=>{
        if (modal['open'] === "" && (type.startsWith('two-minute-') && !company['freeModules'] || company['freeModules'] && !company['freeModules'][type]) && !type.startsWith('repository')) {
            setShowExpension(type);
            setPayload({
                setTab: setTab,
                type: type,
                module: module
            });
            if (module && module['sectionStats']) {
                const key = Object.keys(module['sectionStats'])[0];
                const code = key.split(" - ")[1];
                if (company['expansionPack'] && !company['expansionPack'][code]) return dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'subscriptionPaymentConfirm'
                }));
            }
        }
        // CHECK KPI & CERTIFICATE FOR GUEST USERS
        if (user?.['role'] == 'Guest') {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'noRegistrationReport'
            }));
            return;
        }
        // CHECK EXPANSION PACK PERMISSIONS LEVEL OF ADVISORS/INVESTORS
        if ((user['role'] == "Advisor" || user['role'] == "Investor") && (permissionLevel == 'DASHBOARD' || permissionLevel == 'DASHBOARD & REPORT') && type && ![
            'kpi-report',
            'benchmark-reporting'
        ].includes(type)) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`You have ${permissionLevel} access only!`);
            return;
        }
        if ([
            'software-development',
            'esg',
            'warranty-disclosure',
            'directors-questionnaire',
            'investor-lead'
        ].includes(type)) {
            // CHECK EXPANSION PACK PERMISSIONS FOR MEMBERS
            const message = `You don't have permission for this module. Please contact your admin ${company['creatorId']['firstName'] ? `${company['creatorId']['firstName']} ${company['creatorId']['lastName'] ? company['creatorId']['lastName'] : ""}` : 'user'} to gain access`;
            if (user['role'] == 'Member' && company['creatorId']['_id'] != user['_id']) {
                if (!company?.['memberPermissions']?.[user['_id']]?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
            // CHECK EXPANSION PACK PERMISSIONS FOR ADVISORS/INVESTORS
            if ((user['role'] == "Advisor" || user['role'] == 'Investor') && company['creatorId']['_id'] != user['_id']) {
                if (!company?.[user['role'] == "Investor" ? 'investors' : 'advisors']?.[user['_id']]?.['modules']?.[module?.['sections']?.[0]?.['sectionNo']]) {
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(message);
                    return;
                }
            }
        }
        if (type.includes("directors-questionnaire")) {
            if (localStorage.getItem('isDirectoreDisclaimer')) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'showDirectors'
            }));
            else {
                localStorage.setItem('isDirectoreDisclaimer', true);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'directorQuestionnaireDisclaimer'
                }));
            }
            return;
        } else {
            setTab(type);
            if (module) dispatch((0, $b73aa58a82b722b1$export$4ad686614bba9050)(module));
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (isWorkflowReport && !window.location.hash.includes('#workflow')) setIsWorkflowReport(false);
    }, []);
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedSeeMore({});
        setSelectedHowItWorks({});
        // Set flag to prevent navigation immediately after modal close
        modalJustClosedRef.current = true;
        setTimeout(()=>{
            modalJustClosedRef.current = false;
        }, 300); // 300ms delay to prevent navigation from modal close click events
    };
    // Track modal state changes to detect when modal closes
    (0, $acw62.useEffect)(()=>{
        if (modal && !modal['open']) {
            // Modal was just closed
            modalJustClosedRef.current = true;
            const timer = setTimeout(()=>{
                modalJustClosedRef.current = false;
            }, 300);
            return ()=>clearTimeout(timer);
        }
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4a76053fe526664$export$2e2bcd8739ae039), {
                plan: plan,
                company: company,
                companyId: companyId
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8434b9dd21e99392$export$2e2bcd8739ae039), {
                user: user,
                company: company,
                showExpension: showExpension
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcfe pt2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg38 px1rem w200px tac c15 py0-5rem br20px fsi fs15px cp mr1rem",
                        onClick: ()=>{
                            if (workflowGenerated) {
                                localStorage.setItem('priorityManager', '1');
                                setCompanyDashboardTab('Workflows');
                            } else {
                                localStorage.setItem('priorityManager', '1');
                                localStorage.setItem('openModuleSelectModal', '1');
                                setCompanyDashboardTab('Workflows');
                            }
                        },
                        style: {
                            border: '1px solid #DBDFEE'
                        },
                        children: "What to do next"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bg38 px1rem w200px tac c15 py0-5rem br20px fsi fs15px cp",
                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'whatYouGetModal'
                            })),
                        style: {
                            border: '1px solid #DBDFEE'
                        },
                        children: "What you get"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df",
                children: [
                    dashboardCards === null ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc",
                        style: {
                            width: '98%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c509866364afb9eb$var$DashboardCardSkeleton, {
                                moduleCount: 4,
                                backgroundColor: "#EEFFF7"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c509866364afb9eb$var$DashboardCardSkeleton, {
                                moduleCount: 4,
                                backgroundColor: "#f0f2fd50"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($c509866364afb9eb$var$DashboardCardSkeleton, {
                                moduleCount: 3,
                                backgroundColor: "#f0f2fd50"
                            })
                        ]
                    }) : dashboardCards?.['cards']?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc",
                        style: {
                            width: '98%'
                        },
                        children: dashboardCards?.['cards']?.map((card, index)=>{
                            const hasImage = !!card?.['imageURL'];
                            const gridMode = String(card?.['grid'] || '').trim().toLowerCase();
                            const isSlider = gridMode === 'slider';
                            const isDiligentsiaPlusSlider = String(card?.['subTitle'] || '').trim().toLowerCase() === 'diligentsia plus' && isSlider;
                            if (isDiligentsiaPlusSlider) {
                                const assistanceCards = Array.isArray(card?.modules) ? card.modules.filter((m)=>m?.isAssistanceCard) : [];
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "box-dashbord-contaxiner mla mra my1rem",
                                    style: {
                                        width: '98%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `bg20 bss bo5 bsbb px2rem py4rem br25px w100 keyfeature-box keyfeature-box-company-${company['subscription'].toLowerCase()} df fww pr bsbb bw1px ${user?.['role'] == 'Guest' ? 'bo3' : 'bo28'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "grs1-md gre3-md df fdc aifs tac",
                                                style: {
                                                    width: '21%'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc aifs tal",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                                className: "fs1-25re c15 w100 tal",
                                                                children: card?.['title'] || 'Need advisor assistance?'
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs1rem c59 tal w100",
                                                                children: card?.['subTitle']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df jcc aic w100 h100 mt1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: card?.['imageURL'] || (parcelRequire("kdws4")),
                                                            style: {
                                                                width: '230px',
                                                                height: '251px'
                                                            },
                                                            alt: "dashboardIcon"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "advisor-carousel-container",
                                                style: {
                                                    width: '75%',
                                                    position: 'relative'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5287a2219e0eaa28$export$2e2bcd8739ae039), {
                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                    cards: assistanceCards
                                                })
                                            })
                                        ]
                                    })
                                }, index);
                            }
                            const moduleColumns = hasImage ? 3 : 4;
                            const orderedModules = Array.isArray(card?.modules) ? [
                                ...card.modules
                            ].sort((a, b)=>{
                                if (a?.moduleName === 'KPI Report') return -1;
                                if (b?.moduleName === 'KPI Report') return 1;
                                return 0;
                            }) : [];
                            const moduleCards = orderedModules.length > 0 ? orderedModules.map((m)=>{
                                const resolvedModule = m?.isInvestorMatch && investorMatchCounts ? {
                                    ...m,
                                    strongMatchCount: investorMatchCounts.strongMatchCount,
                                    mediumMatchCount: investorMatchCounts.mediumMatchCount
                                } : m;
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $97fe78def71c3b36$export$2e2bcd8739ae039), {
                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                    name: m?.moduleName || 'Module',
                                    subTitle: m?.moduleSubTitle || '',
                                    description: m?.moduleDescription,
                                    moduleCertification: m?.moduleCertification,
                                    module: resolvedModule,
                                    user: user,
                                    permissionLevel: permissionLevel,
                                    type: m?.moduleKey || m?.moduleName,
                                    setTab: setTab,
                                    company: company,
                                    setIsWorkflowReport: setIsWorkflowReport,
                                    imageURL: m?.imageURL,
                                    showPercentages: m,
                                    menus: [
                                        'listOfSections'
                                    ],
                                    reportMenu: m?.['reportMenu'],
                                    report: m?.isResearchAid ? researchAidReports.find((r)=>r?.reportType === (m?.externalUrl === '#' ? 'swotAnalysis' : m?.externalUrl)) || null : null,
                                    setTabName: setTabName
                                }, m?._id || m?.moduleKey || m?.moduleName);
                            }) : [];
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "box-dashbord-contaxiner mla mra my1rem",
                                style: {
                                    width: '98%'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `bg20 bss bo5 bsbb px2rem py2rem br25px w100 ${user?.['role'] == 'Guest' ? 'bo3' : 'bo28'} keyfeature-box keyfeature-box-company-${company['subscription'].toLowerCase()} df fdc pr bsbb bw1px 66`,
                                    style: {
                                        backgroundColor: index === 0 ? '#EEFFF7' : '#f0f2fd50'
                                    },
                                    children: [
                                        !hasImage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w100 mb1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2454e33776bf53f1$export$2e2bcd8739ae039), {
                                                title: card?.['title'],
                                                subtitle: card?.['subTitle'],
                                                company: company,
                                                user: user
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aifs jcsb",
                                            style: {
                                                width: '100%'
                                            },
                                            children: [
                                                hasImage && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcsb aic fdc",
                                                    style: {
                                                        width: '25%'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2454e33776bf53f1$export$2e2bcd8739ae039), {
                                                            title: card?.['title'],
                                                            subtitle: card?.['subTitle'],
                                                            company: company,
                                                            user: user
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df jcc aic w100 h100 mt1rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: card?.['imageURL'],
                                                                alt: "dashboardIcon"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                isSlider ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        width: hasImage ? '75%' : '100%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $028c120b092ae74e$export$2e2bcd8739ae039), {
                                                        itemsPerSlide: moduleColumns * 2,
                                                        columns: moduleColumns,
                                                        children: moduleCards
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `dg gg1rem ${hasImage ? 'gtcr3' : 'gtcr4'} w80`,
                                                    style: {
                                                        width: hasImage ? '75%' : '100%'
                                                    },
                                                    children: moduleCards
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce51629355c8164e$export$2e2bcd8739ae039), {
                        company: company,
                        setTab: setTab
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "keyFeatureSeeMore",
                open: modal['open'] == 'seeMorePopup',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '1350px'
                    },
                    children: [
                        selectedSeeMore && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        width: "55%",
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 df aic",
                                                    children: selectedSeeMore?.icon
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w90 fw500 c15 pl1rem df aic",
                                                    style: {
                                                        fontSize: '26px',
                                                        lineHeight: '37.32px'
                                                    },
                                                    children: selectedSeeMore?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: " mt0-5rem",
                                            style: {
                                                paddingLeft: '22px'
                                            },
                                            children: selectedSeeMore?.points?.map((objpoints, index)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    style: {
                                                        lineHeight: '25px',
                                                        paddingBottom: "3px",
                                                        paddingTop: "3px",
                                                        paddingLeft: "20px",
                                                        borderLeft: '2px solid #D3D9FC'
                                                    },
                                                    className: "df fdc fs1rem c14 fs1rem fw400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "circle"
                                                                }),
                                                                objpoints
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: selectedSeeMore?.subMenu && selectedSeeMore?.subMenu?.index == index && selectedSeeMore?.subMenu?.points?.map((str, i, arr)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                    style: {
                                                                        lineHeight: '30px'
                                                                    },
                                                                    children: str
                                                                });
                                                            })
                                                        })
                                                    ]
                                                }, `${objpoints}-${index}`);
                                            })
                                        }),
                                        selectedSeeMore?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt1rem",
                                            style: {
                                                border: '1px solid gray',
                                                padding: "10px",
                                                borderRadius: '10px'
                                            },
                                            children: selectedSeeMore?.notePoint
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jce",
                                    style: {
                                        width: '45%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: selectedSeeMore?.image,
                                            className: "w70",
                                            style: {
                                                objectFit: 'fill'
                                            }
                                        }),
                                        selectedSeeMore?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("fOQ2M")),
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "videoCompanies"
                                                })),
                                            className: "pa cp zi1",
                                            style: {
                                                right: '10%',
                                                bottom: '10px'
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            modal['open'] === 'howItWorksPopupNew' && modal?.howItWorksData && Object.keys(modal.howItWorksData).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e7cfd1339b30947$export$2e2bcd8739ae039), {
                selectedHowItWorks: modal.howItWorksData
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "howItWorksPopup",
                open: modal['open'] == 'howItWorksPopup',
                onClose: ()=>onModalClose(),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        zoom: '0.9',
                        maxWidth: '1550px',
                        ...selectedSeeMore?.seeMoreSection?.cardPaddingBottom
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww w100",
                            children: [
                                selectedHowItWorks?.['isStoryVideo'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcc fdc pa",
                                    style: {
                                        right: '-7%',
                                        top: '-5%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("jLZXj")),
                                            className: "w70",
                                            style: {
                                                borderRadius: '50%'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("fOQ2M")),
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "videoCompanies"
                                                })),
                                            className: "cp zi1"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "w100 tac c15 fs1-75rem fw500",
                                    children: "How does it work?"
                                }),
                                selectedHowItWorks?.['subTitle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                    className: "w100 tac c15 fs1-25rem fw500 mb1rem",
                                    children: selectedHowItWorks?.['subTitle']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-top-box df w100 jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedHowItWorks?.['stepImage'],
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                                    children: selectedHowItWorks?.['arrayImages'] && selectedHowItWorks?.['arrayImages'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['arrayImages'].map((image)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "step-img df jcc px1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: image,
                                                    alt: "ste image"
                                                })
                                            });
                                        })
                                    }) : null
                                }),
                                selectedHowItWorks?.['checkList'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb",
                                    children: selectedHowItWorks?.['checkList'] && selectedHowItWorks?.['checkList'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: selectedHowItWorks?.['checkList'].map((array)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-inner w100 pr",
                                                children: array
                                            });
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: selectedHowItWorks?.['bottomSection'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1-25rem c12 mb1rem tac w100",
                                        children: selectedHowItWorks?.['bottomSection']
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc w100",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        children: selectedHowItWorks?.['btnContent']
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'videoCompanies',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100 p2-5rem bsbb df fdc m1rem maw900px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: '0'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                src: "https://www.loom.com/embed/22404ff9e1514a3ca4a169af00ee93e1?sid=bf8bbfc8-8d7d-4361-9227-cc2876f6bd2d&output=embed",
                                frameborder: "0",
                                webkitallowfullscreen: "true",
                                mozallowfullscreen: "true",
                                allowFullScreen: true,
                                style: {
                                    position: 'absolute',
                                    top: '0',
                                    left: '0',
                                    width: '100%',
                                    height: '100%'
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7d2c3a0ad8be93d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'seeCertificate',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc onone",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `mah90 oya bg1 shadow w100 pt1rem pl1rem pr1rem pb2rem bsbb df fdc m1rem br20px pr maw50`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb aic fdc step-box-modal",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "step-box-box-1 tac w100",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w200px ma",
                                                    src: (parcelRequire("2fucc")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                    className: "c15 fs2rem fw400 mb1rem",
                                                    children: "Oops!"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "tac c15 op60 maw80 px2rem fs1rem lh1-5rem",
                                            children: "Sorry, but can only access this module if you have Diligentsia Gold certification. This is to preserve the quality of qualified and diligenced leads we introduce to investors on our investor database. We look forwards to seeing you soon once you have achieved gold!"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `#unaudited-certification`,
                                        className: "p1rem pl4rem pr4rem shadow c1 bg4 bg3-hover br35px mt1rem mb1rem mr2-5rem cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                        onClick: ()=>{
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }));
                                            setModuleTab(setTab, 'unaudited-certification');
                                        },
                                        children: "See Certification status"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })), resetStates();
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '100px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "generatePartnerPopup",
                open: modal['open'] == 'generatePartnerPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: "Performing checklist creation magic!"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar module-progress-bar`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: "This may take couple of minutes to generate checklist."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $710d879c9ded52d9$export$2e2bcd8739ae039), {
                Objective: company['testType'],
                subscription: company['subscription'],
                company: company,
                showExpension: showExpension,
                setShowExpension: setShowExpension
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87ab33a89f0105e5$export$2e2bcd8739ae039), {
                Objective: company['testType'],
                subscription: company['subscription'],
                company: company,
                showExpension: showExpension,
                setShowExpension: setShowExpension,
                user: user
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da20b8fe5a9fd138$export$2e2bcd8739ae039), {
                plan: showExpension || modal.purchasePlan || 'Pro',
                defaultStep: modal.purchaseDefaultStep,
                companyId: company?._id,
                company: company,
                module: modal.modulePurchase,
                setShowExpension: ()=>{}
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "swotReportPopup",
                open: modal['open'] == 'swotReportPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc my3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1-5rem",
                                            children: "SWOT Analysis Report"
                                        }),
                                        isSwotReport ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem c15 mb1rem tac",
                                            children: [
                                                "Generate the other ResearchAid reports before ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " generating the SWOT Report"
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem c15 mb1rem tac",
                                            children: [
                                                "The SWOT report will produce better results if you first generate  ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " the Technology Competitive Advantage Report"
                                            ]
                                        })
                                    ]
                                }),
                                isSwotReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "bg4 fs0-75rem fw600 c1 td250 br30px px4rem py0-5rem cp tac",
                                        children: "Back"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsa mt2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "bg4 fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: (user['role'] != 'Advisor' && user['role'] != 'Investor' || user?.['companyId']?.['_id'] == company?.['_id']) && `/researchAid/${company['_id']}?swotAnalysis`,
                                            "data-tooltip": (user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id'] ? `${user['role']} can't generate report from company dashboard!` : '',
                                            state: {
                                                company: company
                                            },
                                            className: `fs0-75rem fw600 c1 td250 br30px px3rem py0-5rem cp tac ${(user['role'] == 'Advisor' || user['role'] == 'Investor') && user?.['companyId']?.['_id'] != company?.['_id'] ? 'cna bg16' : 'cp bg3'}`,
                                            children: "Generate"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");

var $7JB23 = parcelRequire("7JB23");




var $acw62 = parcelRequire("acw62");
















'use strict';
function $b0b365559f7dda09$export$9ef31d2dc1512c0d(sectionNoOrQNo) {
    if (sectionNoOrQNo == null || sectionNoOrQNo === '') return false;
    const root = String(sectionNoOrQNo).split('.')[0].trim();
    if (!root) return false;
    // Reason: createCustomSection assigns UD021–UD025; older flows used UD001–UD005 / CS…
    if (/^UD00[1-5]$/i.test(root)) return true;
    if (/^UD02[1-5]$/i.test(root)) return true;
    if (/^CS[A-Z0-9]+$/i.test(root)) return true;
    return false;
}



























function $41a7e2f21e80a06c$export$2e2bcd8739ae039({ visibleSection: visibleSection = '', isManualAdd: isManualAdd, getUser: getUser, isWorkflowReport: isWorkflowReport, setIsWorkflowReport: setIsWorkflowReport, company: company, advisors: advisors, permissionLevel: permissionLevel, setCompany: setCompany, tab: tab, setTab: setTab, sanitiseTab: sanitiseTab, toggleReport: toggleReport, handleSuperflowNext: handleSuperflowNext, setCompanyDashboardTab: setCompanyDashboardTab, getCompletenessAndRiskHTML: getCompletenessAndRiskHTML, isExternalPage: isExternalPage, setSection: setSection, getViewableURL: getViewableURL, isViewTwoMinuteReport: isViewTwoMinuteReport, twoMinuteTestAIReport: twoMinuteTestAIReport, isTwoMinuteTesHomePage: isTwoMinuteTesHomePage, setOpenTabs: setOpenTabs, openTabs: openTabs, sortSections: sortSections, handlePartnerChecklistNext: handlePartnerChecklistNext, handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness, updateUserType: updateUserType, setTabName: setTabName, closeTab: closeTab, isBackFitReport: isBackFitReport, setIsBackFitReport: setIsBackFitReport, isLoader: isLoader, setIsLoader: setIsLoader, tempModule: tempModule, getTempModuleTitleForTab: getTempModuleTitleForTab }) {
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let { tempModuleAllocationPatch: tempModuleAllocationPatch } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    let [folderNo, setFolderNo] = (0, $acw62.useState)('');
    let [folderName, setFolderName] = (0, $acw62.useState)('');
    let [folderFiles, setFolderFiles] = (0, $acw62.useState)([]);
    let [activePoint, setActivePoint] = (0, $acw62.useState)('');
    let [sectionExpand, setSectionExpand] = (0, $acw62.useState)({});
    let [sidebarFixed, setSidebarFixed] = (0, $acw62.useState)(false);
    let [allSectionsExpand, setAllSectionsExpand] = (0, $acw62.useState)(false);
    let [isDemoPartnerChecklist, setIsDemoPartnerChecklist] = (0, $acw62.useState)(false);
    let [fetchedTempModule, setFetchedTempModule] = (0, $acw62.useState)(null);
    const [sidebarModuleSnapshot, setSidebarModuleSnapshot] = (0, $acw62.useState)(null);
    const effectiveTempModule = tempModule || fetchedTempModule;
    const displayModule = sidebarModuleSnapshot || effectiveTempModule;
    const effectiveModuleHasQuestions = effectiveTempModule?.sections?.some((s)=>s?.questions?.length > 0) ?? false;
    let coreInfoResearchAid = {
        'marketOpportunity': {
            name: 'Market Opportunity',
            path: 'S1 Q1 & S1 Q2',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        },
        'routeToMarket': {
            name: 'Route to Market',
            path: 'S1 Q1',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        },
        'competitorAnalysis': {
            name: 'Competitor Analysis',
            path: 'S5 Q1 & S5 Q5',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        },
        'technologyAdvantage': {
            name: 'Technology Advantage',
            path: 'S4 Q1 & S4 Q4',
            sectionNo: '',
            notUploaded: false,
            uploaded: false
        }
    };
    (0, $acw62.useEffect)(()=>{
        const fetchTempModuleForSidebar = async ()=>{
            if (!company?._id || !tab || tab === 'kpi-report') return;
            if (effectiveModuleHasQuestions) return;
            try {
                const moduleSlugRaw = (typeof sanitiseTab === 'function' ? sanitiseTab(tab) : tab || '').replace(/^temp-/, '');
                const moduleSlug = moduleSlugRaw.includes('business-audit') ? moduleSlugRaw.replace(`-${company?.['testType']}`, '') : moduleSlugRaw;
                if (!moduleSlug) return;
                let resolvedModuleName = moduleSlug;
                let resolvedDirectorId = null;
                if (moduleSlug.includes('directors-questionnaire_')) {
                    const parts = moduleSlug.split('_');
                    resolvedModuleName = 'directors-questionnaire';
                    resolvedDirectorId = parts[1] || null;
                } else if (moduleSlug.includes('business-audit')) resolvedModuleName = moduleSlug.replace(`-${company?.['testType']}`, '');
                else if (moduleSlug.includes('%20')) resolvedModuleName = moduleSlug.replaceAll('%20', ' ');
                const moduleName = resolvedModuleName;
                const directorId = resolvedDirectorId;
                const isValidCompanyId = typeof company._id === 'string' && company._id.trim().length > 0;
                let query = isValidCompanyId ? `?companyId=${encodeURIComponent(company._id)}` : '';
                if (directorId) query += `${query ? '&' : '?'}directorId=${encodeURIComponent(directorId)}`;
                const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${encodeURIComponent(moduleName)}${query}`);
                if (res?.code === 200 && res?.body) {
                    setFetchedTempModule(res.body);
                    dispatch((0, $12074930bd2c1829$export$65113a50fb519714)({
                        ...res.body,
                        moduleSlug: res.body.moduleSlug || moduleSlug,
                        moduleName: res.body.moduleName || moduleSlug,
                        companyId: company._id
                    }));
                }
            } catch (_) {}
        };
        fetchTempModuleForSidebar();
    }, [
        company?._id,
        company?.testType,
        tab,
        sanitiseTab,
        effectiveModuleHasQuestions
    ]);
    // Parent (QuestionAnswersPage) owns tempModule — drop stale sidebar snapshot when it updates
    (0, $acw62.useEffect)(()=>{
        setSidebarModuleSnapshot(null);
    }, [
        tempModule
    ]);
    const applyAnswerPatchToModule = (source, answerByQuestionId)=>{
        const clone = JSON.parse(JSON.stringify(source));
        const WORKFLOW_SCORES = {
            'Not Started': 0,
            'Started': 0.25,
            'In Progress': 0.5,
            'Completed - Further Work': 0.75,
            'Completed - No Issues': 1,
            'Completed': 1,
            'Ready for Review': 0.75
        };
        const computeRisk = clone.riskScoring !== false;
        (clone.sections || []).forEach((section)=>{
            (section.questions || []).forEach((question)=>{
                const nextAnswer = answerByQuestionId.get(String(question?._id));
                if (nextAnswer) question.answer = nextAnswer;
            });
            if (section.subFolders) Object.values(section.subFolders).forEach((subFolder)=>{
                (subFolder.questions || []).forEach((question)=>{
                    const nextAnswer = answerByQuestionId.get(String(question?._id));
                    if (nextAnswer) question.answer = nextAnswer;
                });
                if (subFolder.stats) delete subFolder.stats.riskPercent;
            });
        });
        let totalQ = 0, completedQ = 0, wfMax = 0, wfScore = 0;
        let modRiskScore = 0, modMinRisk = 0, modMaxRisk = 0;
        (clone.sections || []).forEach((section)=>{
            const questions = (section.questions || []).filter((q)=>!q.isSkipped);
            const secTotal = questions.length;
            const secCompleted = questions.filter((q)=>q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
            let secWfMax = 0, secWfScore = 0;
            let secRiskScore = 0, secMinRisk = 0, secMaxRisk = 0;
            questions.forEach((q)=>{
                const ts = q.answer?.taskStatus || q.answer?.status;
                if (ts && WORKFLOW_SCORES[ts] !== undefined) {
                    secWfMax += 1;
                    secWfScore += WORKFLOW_SCORES[ts];
                }
                if (computeRisk) {
                    const radioOption = q.answer?.radioOption;
                    if (radioOption && radioOption !== 'N/A' && radioOption !== 'NC') {
                        secRiskScore += q['riskIf' + radioOption] || 0;
                        const riskVals = Object.keys(q).filter((k)=>k.startsWith('riskIf')).map((k)=>q[k]);
                        if (riskVals.length > 0) {
                            secMinRisk += Math.min(...riskVals);
                            secMaxRisk += Math.max(...riskVals);
                        }
                    }
                }
            });
            const secPercent = secTotal > 0 ? Math.round(secCompleted / secTotal * 100) : 0;
            const secWfPercent = secWfMax > 0 ? Math.round(secWfScore / secWfMax * 100) : 0;
            const secRiskPercent = !computeRisk || secRiskScore === 0 || secMaxRisk === secMinRisk ? 0 : Math.round((secRiskScore - secMinRisk) / (secMaxRisk - secMinRisk) * 100);
            section.stats = {
                ...section.stats || {},
                completionPercent: secPercent,
                workflowCompletionPercent: secWfPercent,
                completed: secCompleted,
                total: secTotal,
                riskPercent: secRiskPercent
            };
            totalQ += secTotal;
            completedQ += secCompleted;
            wfMax += secWfMax;
            wfScore += secWfScore;
            modRiskScore += secRiskScore;
            modMinRisk += secMinRisk;
            modMaxRisk += secMaxRisk;
        });
        const modPercent = totalQ > 0 ? Math.round(completedQ / totalQ * 100) : 0;
        const modWfPercent = wfMax > 0 ? Math.round(wfScore / wfMax * 100) : 0;
        const modRiskPercent = !computeRisk || modRiskScore === 0 || modMaxRisk === modMinRisk ? 0 : Math.round((modRiskScore - modMinRisk) / (modMaxRisk - modMinRisk) * 100);
        clone.stats = {
            ...clone.stats || {},
            completionPercent: modPercent,
            workflowCompletionPercent: modWfPercent,
            completed: completedQ,
            total: totalQ,
            riskPercent: modRiskPercent
        };
        return clone;
    };
    (0, $acw62.useEffect)(()=>{
        const patch = tempModuleAllocationPatch;
        if (!patch?.savedQuestions?.length) return;
        const baseModule = fetchedTempModule || tempModule;
        if (!baseModule?.sections?.length) return;
        if (String(patch.moduleId) !== String(baseModule?._id)) return;
        const answerByQuestionId = new Map(patch.savedQuestions.filter((item)=>item?._id && item?.answer).map((item)=>[
                String(item._id),
                item.answer
            ]));
        if (!answerByQuestionId.size) return;
        const patched = applyAnswerPatchToModule(baseModule, answerByQuestionId);
        setFetchedTempModule(patched);
        if (tempModule) setSidebarModuleSnapshot(patched);
    }, [
        tempModuleAllocationPatch,
        tempModule,
        fetchedTempModule
    ]);
    const handleScroll = (scrollTo)=>{
        if (!scrollTo) return;
        // 1. Try direct id match (works for standard modules where section wrappers get id={sectionNo})
        // 2. Fall back to data-section-no exact match (works for temp modules where question qNo === subfolder.no)
        // 3. Fall back to data-section-no prefix match (catches sub-questions like "DRN001.1.001")
        const targetElement = document.getElementById(scrollTo) || document.querySelector(`[data-section-no="${scrollTo}"]`) || document.querySelector(`[data-section-no^="${scrollTo}."]`);
        if (targetElement) targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (localStorage.getItem('isDemoChecklist') || localStorage.getItem('isPartnerChecklist')) setIsDemoPartnerChecklist(true);
        else setIsDemoPartnerChecklist(false);
        let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const handleSidebarStick = ()=>{
            if (isSafari && window.scrollY > 925) setSidebarFixed(true);
            else setSidebarFixed(false);
        };
        window.addEventListener('scroll', handleSidebarStick);
        return ()=>window.removeEventListener('scroll', handleSidebarStick);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const sanitizedTab = typeof sanitiseTab === 'function' ? sanitiseTab(tab) : tab;
        const normalizedTab = sanitizedTab?.replace(/^temp-/, '');
        const moduleSections = displayModule?.sections ?? company?.tempModules?.[sanitizedTab]?.sections ?? company?.tempModules?.[normalizedTab]?.sections ?? company?.modules?.[sanitizedTab]?.sections ?? company?.modules?.[normalizedTab]?.sections;
        if (tab === 'repository') setActivePoint(moduleSections?.[1]?.sectionNo);
        else {
            if (tab.includes('-report')) tab = tab.replace(/-report$/, "");
            setActivePoint(moduleSections?.[0]?.sectionNo);
        }
    }, [
        tab,
        displayModule
    ]);
    //Get company by Id
    const getCompanyById = async (companyId)=>{
        if (companyId) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/company-data/${companyId}`);
            window.open(res['body']?.cWebsite, "_blank");
        }
    };
    const getAllocatedAdvisorId = (data, activePoint)=>{
        if (data) {
            for (let [key, value] of Object.entries(data)){
                if (value.modules && value.modules[activePoint] === true) return key;
            }
            return null;
        }
    };
    const truncateText = (text, maxLength)=>{
        if (!text || text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };
    const getSectionName = (data, sectionNo)=>{
        let moduleName = null;
        for(const moduleKey in data?.modules){
            const module = data?.modules[moduleKey];
            // Check if module has sections before trying to access them
            if (module?.sections) {
                const matchingSection = module.sections.find((section)=>section.sectionNo === sectionNo);
                if (matchingSection) {
                    moduleName = matchingSection.sectionName;
                    break;
                }
            }
        }
        if (moduleName) return moduleName;
        else return "N/A";
    };
    // Reason: derived synchronously so allocatedAdvisor is always in sync with visibleSection/activePoint in the same render, preventing a stale-state double render on IndirectCompanyUserAdCard.
    // visibleSection is the primary driver (updates on every scroll/navigation); activePoint is the fallback when no section is visible yet.
    const allocatedAdvisor = (0, $acw62.useMemo)(()=>{
        const key = visibleSection || activePoint;
        const advisorId = getAllocatedAdvisorId(company?.revenuelead, key);
        const sectionName = getSectionName(company, key) ?? tab;
        if (advisorId) return {
            ...company?.advisorData?.find((obj)=>obj?._id === advisorId),
            sectionName: sectionName
        };
        return {
            ...company?.advisorData?.find((obj)=>!obj?.createdBy),
            sectionName: sectionName
        };
    }, [
        activePoint,
        visibleSection,
        company,
        tab
    ]);
    const onCardLog = async (company, user, allocatedAdvisor, clickedOn, adsData)=>{
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/log/card/log`, {
            firmId: allocatedAdvisor?.companyId,
            advisor: allocatedAdvisor,
            hasBusinessCard: true,
            routeName: location.pathname,
            clickedOn: clickedOn,
            company: company,
            ...adsData && adsData?.adId ? {
                adId: adsData?.adId
            } : {},
            ...adsData && adsData?.visibleSection ? {
                sectionNo: adsData?.visibleSection.includes('.') ? adsData?.visibleSection.split('.')[0] : adsData?.visibleSection
            } : {},
            ...adsData && adsData?.isDefault && {
                isDefault: adsData?.isDefault
            }
        });
    };
    const LiButton = ({ link: link, company: company, user: user, allocatedAdvisor: allocatedAdvisor, withoutLog: withoutLog })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                borderRadius: "2.5rem",
                padding: "0px 12px",
                color: "#ffffff",
                fontSize: "12px",
                fontWeight: "700",
                lineHeight: "1rem",
                cursor: link ? "pointer" : 'text',
                background: link ? "linear-gradient(120.13deg, #4A67FF -3.15%, #3956F0 8.51%, #798EFF 71.07%, #8496F4 102.88%)" : '#999'
            },
            onClick: ()=>{
                if (link) window.open(link.startsWith("https://") ? link : `https://${link}`, '_blank');
                if (withoutLog === false) onCardLog(company, user, allocatedAdvisor, "linkedIn");
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("dnTAO")),
                alt: "Linkedin Logo",
                style: {
                    height: '10px'
                }
            })
        });
    };
    const getFilesFromQuestions = (questions)=>questions && questions.filter((q)=>q.answer?.files?.length).reduce((arr, q)=>[
                ...arr,
                ...q.answer.files.map((file)=>({
                        ...file,
                        questionId: q._id,
                        questionNo: q.qNo,
                        answerId: q.answer._id,
                        drLastSync: q?.answer?.drLastSync ? q?.answer?.drLastSync : '',
                        dbLastSync: q?.answer?.dbLastSync ? q?.answer?.dbLastSync : '',
                        title: file.originalname,
                        url: file.location,
                        ext: file.originalname.split(".").slice(-1)[0]
                    }))
            ], []);
    const toggleSectionExpand = (sectionId)=>setSectionExpand((prevState)=>({
                ...prevState,
                [sectionId]: !prevState[sectionId]
            }));
    const toggleAllSectionsExpand = ()=>setAllSectionsExpand(!allSectionsExpand);
    const handleReport = async (e, module)=>{
        if (user['role'] == 'Investor' && user?.['companyId']?.['_id'] && isBackFitReport) {
            window.location.href = `/company/${company['_id']}#fit-report:${user?.['companyId']?.['_id']}`;
            setIsBackFitReport(false);
            setTab(`fit-report:${user?.['companyId']?.['_id']}`);
            setOpenTabs(new Set([
                `fit-report:${user?.['companyId']?.['_id']}`
            ]));
            return;
        }
        if (localStorage.getItem('isDiligencePack') && !isBackFitReport || user?.['type'] == 'External') {
            window.location.href = `/company/${company['_id']}#diligence-pack`;
            setTab('diligence-pack');
            setOpenTabs(new Set([
                `diligence-pack`
            ]));
            localStorage.removeItem('isDiligencePack');
            return;
        }
        if (user['role'] == 'User' && isBackFitReport) {
            setIsBackFitReport(false);
            setTabName('');
            setCompanyDashboardTab('InvestorMatch');
            return;
        }
        if (isWorkflowReport) setIsWorkflowReport(false);
        let isDiligenceReport = localStorage.getItem('isDiligenceReport');
        if (isDiligenceReport) {
            // close all tabs
            Array.from(openTabs).map(async (openTab)=>{
                await openTabs.delete(openTab);
                setOpenTabs(new Set(Array.from(openTabs)));
            });
            let redirectTab = location.href.split('#')[1];
            setTab(redirectTab);
            return;
        }
        if (tab.includes('two-minute-test') && !tab.endsWith("-report")) twoMinuteTestAIReport(module);
        else if (tab.includes('investor-lead')) {
            window.history.replaceState(null, '', window.location.pathname);
            setCompanyDashboardTab('InvestorMatch');
            setTabName('');
            closeTab(e, tab);
        } else toggleReport(e);
    };
    // Reason: HealthBoost TempSection.sectionNo uses old format ("HEYBP1") but TempQuestion.qNo uses
    // new format ("EYBP001.1"). SubFolder.no also uses old format ("HEYBP1.1"). We must derive the
    // effective qNo prefix from the section's actual questions, not from sectionNo.
    // DRN/DDQ/DWD use consistent prefixes (sectionNo="DRN001", subNo="DRN001.1", qNo="DRN001.1.001")
    // so they are detected via the sectionNo-starts-with check and returned unchanged.
    const resolveSubFolderEffectiveNo = (section, subNo)=>{
        const sNo = String(subNo || '');
        const sectionNo = String(section?.sectionNo || '');
        if (!sNo || !sectionNo) return sNo;
        // Step 1: if subNo starts with sectionNo, verify questions also use the same prefix.
        // DRN/DDQ/DWD: all consistent → return unchanged.
        if (sNo.toUpperCase().startsWith(sectionNo.toUpperCase())) {
            const qs = section?.questions;
            if (!Array.isArray(qs) || qs.length === 0) return sNo;
            if (qs.some((q)=>String(q.qNo || '').toUpperCase().startsWith(sectionNo.toUpperCase()))) return sNo;
        // Questions use a different prefix (HealthBoost mismatch) → fall through to step 2
        }
        // Step 2: derive the question-level prefix from the section's actual questions.
        // HealthBoost: sectionNo="HEYBP1", first question.qNo="EYBP001.1" → qPrefix="EYBP001"
        const qs = section?.questions;
        let qPrefix = sectionNo;
        if (Array.isArray(qs) && qs.length > 0) for (const q of qs){
            const qNo = String(q?.qNo || '');
            const d = qNo.lastIndexOf('.');
            if (d > 0) {
                qPrefix = qNo.slice(0, d);
                break;
            }
        }
        // Extract numeric suffix from subNo (e.g. "HEYBP1.1"→"1", "K1.1"→"1", "1"→"1")
        const lastDot = sNo.lastIndexOf('.');
        const suffix = lastDot >= 0 ? sNo.slice(lastDot + 1) : sNo;
        return suffix ? `${qPrefix}.${suffix}` : qPrefix;
    };
    const getSubSectionQuestions = (section, subSection)=>{
        // Reason: empty array is truthy in JS — only use subSection.questions when it's non-empty
        const hasOwnQuestions = Array.isArray(subSection?.questions) && subSection.questions.length > 0;
        if (hasOwnQuestions) return subSection.questions;
        if (!subSection?.no) return [];
        const effectiveNo = resolveSubFolderEffectiveNo(section, subSection.no);
        if (!effectiveNo) return [];
        const re = new RegExp(effectiveNo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + "((\\.[0-9]+)|$)");
        return section?.questions?.filter((q)=>q.qNo?.match(re)) || [];
    };
    /** Derive subfolder completion when stats aren't persisted (temp modules). */ const getSubSectionCompleteness = (section, subSection)=>{
        let subCompleteness = subSection?.stats?.completionPercent;
        if (subCompleteness == null || isNaN(subCompleteness)) {
            const subQuestions = getSubSectionQuestions(section, subSection);
            if (subQuestions.length) {
                const activeQs = subQuestions.filter((q)=>!q.isSkipped);
                if (activeQs.length) {
                    const completed = activeQs.filter((q)=>q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
                    subCompleteness = Math.round(completed / activeQs.length * 100);
                } else subCompleteness = 0;
            } else subCompleteness = 0;
        }
        return subCompleteness ?? 0;
    };
    // Compute risk color from Yes/No answers only: No/(Yes+No) ratio → green/orange/red.
    // N/A and NC answers are excluded from the Yes/No tally.
    // Returns null when no questions are answered (no color shown).
    // Returns green when all answered questions are N/A.
    const computeYesNoRiskColor = (questions)=>{
        let yesCount = 0, noCount = 0, naCount = 0;
        for (const q of questions || []){
            if (q.isSkipped) continue;
            const opt = q.answer?.radioOption;
            if (!opt) continue;
            if (opt === 'Yes') yesCount++;
            else if (opt === 'No') noCount++;
            else if (opt === 'N/A' || opt === 'NC') naCount++;
        }
        const answered = yesCount + noCount;
        if (answered === 0) return naCount > 0 ? '#40dda144' : null;
        const riskPercent = noCount / answered * 100;
        if (riskPercent <= 33) return '#40dda144';
        if (riskPercent >= 66) return '#dd404044';
        return '#ddb64044';
    };
    // Collect all questions from a section including all levels of subFolders for accurate risk aggregation
    const getAllSectionQuestions = (section)=>{
        const questions = [
            ...section?.questions || []
        ];
        const collectFromSubFolders = (subFoldersMap)=>{
            Object.values(subFoldersMap).forEach((subFolder)=>{
                questions.push(...subFolder.questions || []);
                if (subFolder.subFolders) collectFromSubFolders(subFolder.subFolders);
            });
        };
        if (section?.subFolders) collectFromSubFolders(section.subFolders);
        return questions;
    };
    // investor-lead and explicitly disabled modules never show risk colours.
    const isModuleWithoutRiskScoring = (module)=>{
        if (module?.['type'] === 'investor-lead' || module?.['riskScoring'] === false) return true;
        return false;
    };
    const isWDModule = (module)=>module?.['moduleKey'] === 'DWD' || module?.['type'] === 'warranty-disclosure' || module?.['moduleName'] && /warranty disclosure/i.test(String(module['moduleName']));
    // WD: Disclosure/Not Sure in any question (including subfolder questions) → red; else green if answered.
    // WD is the only module where subfolder answers drive the parent section to red via this path.
    // All other modules: plain Yes/No count over all section questions — no subfolder inheritance.
    const computeSectionRiskColor = (section, module)=>{
        if (isModuleWithoutRiskScoring(module)) return null;
        const questions = getAllSectionQuestions(section);
        if (isWDModule(module)) {
            let hasAnswered = false;
            for (const q of questions){
                if (q.isSkipped) continue;
                const opt = q.answer?.radioOption;
                if (!opt || opt === 'N/A' || opt === 'NC') continue;
                hasAnswered = true;
                if (opt === 'Disclosure' || opt === 'Not Sure') return '#dd404044';
            }
            return hasAnswered ? '#40dda144' : null;
        }
        return computeYesNoRiskColor(questions);
    };
    const subSectionHasNoAnswer = (section, subSection)=>{
        return getSubSectionQuestions(section, subSection).some((q)=>q.answer?.radioOption === 'No');
    };
    const getSubSectionBackground = (section, subSection, skipRiskScoring = false)=>{
        const subCompleteness = getSubSectionCompleteness(section, subSection);
        const hasNo = subSectionHasNoAnswer(section, subSection);
        if (subCompleteness <= 0 && (skipRiskScoring || !hasNo)) return 'transparent';
        const fillPercent = subCompleteness > 0 ? subCompleteness : 100;
        if (skipRiskScoring) return `linear-gradient(90deg, #40dda144 0%, #40dda144 ${fillPercent}%, #f0f0f8 ${fillPercent}%)`;
        const questions = getSubSectionQuestions(section, subSection);
        const colour = computeYesNoRiskColor(questions) ?? '#40dda144';
        return `linear-gradient(90deg, ${colour} 0%, ${colour} ${fillPercent}%, #f0f0f8 ${fillPercent}%)`;
    };
    const showSection = (section, sectionFiles, subSection, skipRiskScoring = false)=>{
        // Hide sub-folders that have no questions mapped to their number
        if (getSubSectionQuestions(section, subSection).length === 0) return null;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: isTwoMinuteTesHomePage ? /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: "df fww w100 cna",
                style: {
                    width: '96%',
                    padding: '5px 0px 0px 7px'
                },
                disabled: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "fw500 w70 asc pen uss ass tal pr1-5rem",
                        children: [
                            `${subSection?.no} ${subSection?.name}`,
                            " "
                        ]
                    }),
                    sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "df jcc aic pa r0 cp mr0-5rem fs10px bg1 br10px h20px",
                        onClick: ()=>{
                            setSection(section);
                            setFolderNo(subSection?.no);
                            setFolderName(subSection?.name);
                            setFolderFiles(sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no));
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'manageIndexFiles'
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "mr0-25rem",
                                width: "10",
                                height: "10",
                                viewBox: "0 0 10 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                        clipPath: "url(#clipSidebarAttach)",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                            fill: "#4A67FF"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clipSidebarAttach",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "10",
                                                height: "10",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                "data-scroll-to": subSection?.no,
                onClick: ()=>{
                    handleScroll(resolveSubFolderEffectiveNo(section, subSection?.no));
                },
                className: "df fww w100",
                style: {
                    width: '96%',
                    padding: '5px 0px 0px 7px',
                    background: getSubSectionBackground(section, subSection, skipRiskScoring)
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `fw500 w70 asc pen uss ass tal pr1-5rem c2 c6-hover`,
                        children: [
                            `${subSection?.no} ${subSection?.name}`,
                            " "
                        ]
                    }),
                    subSection?.['updatedAt'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 df jcc fs10px mt0-5rem cp c6-hover",
                        children: [
                            "(Last Updated: ",
                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(subSection?.['updatedAt']).format('DD/MMM/YY'),
                            ")"
                        ]
                    }),
                    sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "df jcc aic pa r0 cp mr0-5rem fs10px bg1 br10px h20px",
                        onClick: ()=>{
                            setSection(section);
                            setFolderNo(subSection?.no);
                            setFolderName(subSection?.name);
                            setFolderFiles(sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no));
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'manageIndexFiles'
                            }));
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "mr0-25rem",
                                width: "10",
                                height: "10",
                                viewBox: "0 0 10 10",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                        clipPath: "url(#clipSidebarAttach)",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                            fill: "#4A67FF"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clipSidebarAttach",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "10",
                                                height: "10",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            sectionFiles && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length > 0 && sectionFiles.filter((file)=>file.questionNo === subSection?.no)?.length
                        ]
                    })
                ]
            })
        });
    };
    function getSectionUpdatedAt(company, section) {
        // Prefer section.updatedAt as fallback (temp modules carry their own timestamp)
        const fallback = section.updatedAt || company.updatedAt;
        // Case 1: No questions
        if (!section.questions || section.questions.length === 0) return fallback;
        // Collect all answer.updatedAt values
        const answerDates = section.questions.map((q)=>q.answer?.updatedAt).filter(Boolean);
        // Case 2: No answered questions — fall back to section/company timestamp
        if (answerDates.length === 0) return fallback;
        // Case 3: Return the latest answer.updatedAt
        return answerDates.reduce((latest, date)=>{
            return new Date(date) > new Date(latest) ? date : latest;
        });
    }
    const getSidebarHTML = (module, showInTooltip = false)=>{
        let array = [];
        const reportEnabled = module?.report ? module.report === "Yes" : true;
        const workflowEnabled = module?.workflowReport === "Yes";
        const showViewOrCloseReportButton = tab?.endsWith("-report") || reportEnabled || workflowEnabled && isWorkflowReport || module?.['moduleName'].includes('Directors');
        // if (module) calculateStats(company, tab, "check1");
        if (module && module.sections && module?.['expansionPack']) array = Object.values(module['sections'][0]['subFolders']);
        else if (module?.isInvestorMatch && module?.sections?.[0]?.subFolders) {
            // Investor Match (DEPF008): display the top-level subFolders (Your Company, Funding Requirement…)
            // directly in the sidebar instead of the single DEPF008 section.
            const flatQuestions = module.sections[0].questions || [];
            array = Object.values(module.sections[0].subFolders).map((sfNode)=>{
                const sfNo = sfNode.sectionNo || sfNode.no;
                const sfName = sfNode.sectionName || sfNode.name;
                if (!sfNo) return null;
                // Compute per-subfolder completion from the flat questions array
                let completionPercent = sfNode.stats?.completionPercent ?? 0;
                if (flatQuestions.length) {
                    const escaped = sfNo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    const re = new RegExp(`^${escaped}(\\.[0-9].*)?$`);
                    const sfQuestions = flatQuestions.filter((q)=>q.qNo && re.test(q.qNo));
                    if (sfQuestions.length) {
                        const completed = sfQuestions.filter((q)=>q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
                        completionPercent = Math.round(completed / sfQuestions.length * 100);
                    }
                }
                return {
                    ...sfNode,
                    sectionNo: sfNo,
                    sectionName: sfName,
                    _id: sfNode._id || sfNo,
                    stats: {
                        ...sfNode.stats || {},
                        completionPercent: completionPercent,
                        riskPercent: sfNode.stats?.riskPercent ?? 0
                    }
                };
            }).filter(Boolean);
        } else array = module?.sections;
        if (array?.length > 0) {
            for(let i = 0; i < array.length; i++)if (array[i].type == "Additional Sections" && array[i].sectionName === '') {
                array.splice(i, 1);
                i -= 1;
            }
        }
        // True when any section carries a non-empty subFolders map (e.g. temp-module Data Repository)
        const moduleHasSubFolders = (array || []).some((s)=>s?.subFolders && Object.keys(s.subFolders).length > 0);
        const isRepositoryLike = module?.['type'] === 'repository' || module?.['moduleKey'] === 'DRN';
        const skipRiskScoring = isModuleWithoutRiskScoring(module);
        const style = showInTooltip ? {} : {
            width: "calc((100% - 4rem) / 5)"
        };
        const jsx = module && module.sections && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            id: "sidebar",
            style: style,
            className: (showInTooltip ? "" : tab == 'esg' || tab == 'business-audit' || tab.includes("two-minute-test") ? "esg-sidebar " : "h100vh ") + (tab && tab.match(/directors-questionnaire/) && " questionnaire-sidebar ") + (isRepositoryLike && " repository-sidebar ") + ` w100 bsbb dg gg1rem t0 sidebar-report ${sidebarFixed ? 'sidebar-fixed' : 'ps'}`,
            children: [
                isManualAdd ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("931hv")),
                        alt: "inteligent-girl"
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bo45 bss bw1px br8px bg38",
                    children: [
                        !showInTooltip && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic fdc p0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c3 fs1-25rem ttu w100 tac",
                                    children: (()=>{
                                        if (tab == 'investor-lead' || module?.['heading'] == 'Investor Match' || module?.['type'] == 'investor-lead') return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c15",
                                            children: [
                                                "Investor",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c4",
                                                    children: "Match"
                                                })
                                            ]
                                        });
                                        const tempTitle = typeof getTempModuleTitleForTab === 'function' ? getTempModuleTitleForTab(tab) || getTempModuleTitleForTab(String(tab || '').replace(/-report$/, '')) : '';
                                        if (module?.['heading']) return module['heading'];
                                        if (displayModule?.['moduleName']) return displayModule['moduleName'];
                                        if (displayModule?.['heading']) return displayModule['heading'];
                                        if (tempTitle) return tempTitle;
                                        if (module?.['type']?.includes('directors-questionnaire')) return 'Directors Questionnaire';
                                        return module?.['type'] || (company.modules[sanitiseTab(tab)]?.['heading'] || '') + " Report";
                                    })()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "c3 ttu lh1 fs1-25rem mt0-5rem tac pr w100",
                                    children: [
                                        " Index",
                                        module?.['type'] === 'repository' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "https://intercom.help/diligentsia-limited/en/collections/6737385-your-diligentsia-data-repository",
                                            target: "_blank",
                                            className: "help-icon pa cp",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "question-button",
                                                    src: (parcelRequire("1ScrU")),
                                                    alt: ""
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "https://intercom.help/diligentsia-limited/en",
                                            target: "_blank",
                                            className: "help-icon pa cp",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "question-button",
                                                    src: (parcelRequire("1ScrU")),
                                                    alt: ""
                                                })
                                            })
                                        })
                                    ]
                                }),
                                (permissionLevel == "ALL" || permissionLevel == "DASHBOARD & REPORT") && user?.['type'] !== 'Superflow' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        tab.includes("kpi-report") && isViewTwoMinuteReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("7hMZV"))
                                        }) : showViewOrCloseReportButton && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: isDemoPartnerChecklist === true,
                                            onClick: (e)=>handleReport(e, module),
                                            className: `${!isDemoPartnerChecklist && module?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} mt1rem mxa ${isDemoPartnerChecklist === true ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br50px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac ${tab.endsWith("-report") && 'close-report'}`,
                                            "data-tooltip": isDemoPartnerChecklist === true ? 'You must register to access it' : '',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    style: {
                                                        position: 'relative',
                                                        top: '4px'
                                                    },
                                                    className: "pen fds h1rem f1 mr0-5rem close-svg",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "pen fa-primary",
                                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                    })
                                                }),
                                                tab == 'investor-lead' ? 'Investor Leads' : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        tab.endsWith("-report") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: workflowEnabled && isWorkflowReport ? "Close Workflow" : 'Close'
                                                        }) : "View",
                                                        tab == 'warranty-disclosure' ? ' Disclosure Schedule' : ' Report'
                                                    ]
                                                })
                                            ]
                                        }),
                                        company?.['subscription'] === 'Pro' && (()=>{
                                            const moduleCompleteness = Number(module?.['stats']?.['completionPercent'] ?? 0);
                                            const isPriorityManagerLocked = moduleCompleteness < 71;
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                disabled: isPriorityManagerLocked,
                                                className: `${isPriorityManagerLocked ? 'op20 pen bg16 cna' : 'cp bg3 bg4-hover'} py0-5rem px1rem c1 br35px my0-5rem fw600 fs0-75rem zi0 td250`,
                                                "data-tooltip": isPriorityManagerLocked ? 'Complete at least 71% of this module to unlock Priority Manager' : '',
                                                onClick: ()=>{
                                                    if (isPriorityManagerLocked) return;
                                                    const moduleName = company?.['modules']?.[sanitiseTab(tab)]?.['moduleName'] || company?.['modules']?.[sanitiseTab(tab)]?.['heading'] || tab;
                                                    localStorage.setItem('priorityManager', moduleName);
                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: ''
                                                    }));
                                                    setCompanyDashboardTab('Workflows');
                                                },
                                                children: "Priority Manager"
                                            });
                                        })(),
                                        workflowEnabled && !tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: isDemoPartnerChecklist === true,
                                            onClick: async (e)=>{
                                                await setIsWorkflowReport(true);
                                                handleReport(e, module);
                                            },
                                            className: `${!isDemoPartnerChecklist && module?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} mt1rem mxa ${isDemoPartnerChecklist === true ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br50px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac ${tab.endsWith("-report") && 'close-report'}`,
                                            "data-tooltip": isDemoPartnerChecklist === true ? 'You must register to access it' : '',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    style: {
                                                        position: 'relative',
                                                        top: '4px'
                                                    },
                                                    className: "pen fds h1rem f1 mr0-5rem close-svg",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "pen fa-primary",
                                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                    })
                                                }),
                                                "View Workflow Report"
                                            ]
                                        })
                                    ]
                                }),
                                tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: (isDemoPartnerChecklist || user['role'] == 'Guest') && user['type'] !== 'External',
                                            onClick: ()=>downloadPDF(),
                                            className: `h100 my0-5rem mxa shadow ${(isDemoPartnerChecklist || user['role'] == 'Guest') && user['type'] !== 'External' ? 'bg16 cna' : 'bg3 bg4-hover cp'} c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 ttu bsbb tac df jcc aic`,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "pen fds h1rem f1 mr0-5rem",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 640 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M537.6 226.6C541.7 215.9 544 204.2 544 192c0-53-43-96-96-96c-19.69 0-38.09 6-53.31 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.703 .1094 5.445 .2031 8.133C40.2 219.8 0 273.2 0 336C0 415.5 64.5 480 144 480H512c70.69 0 128-57.3 128-128C640 290.1 596 238.4 537.6 226.6zM424.1 320.1l-88 88C334.4 411.5 328.5 416 320 416s-14.4-4.467-16.97-7.031l-88-88c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L296 334.1V184C296 170.8 306.8 160 320 160s24 10.75 24 24v150.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0S434.3 311.6 424.1 320.1z"
                                                        })
                                                    ]
                                                }),
                                                "Download PDF"
                                            ]
                                        }),
                                        tab == "kpi-report" && isViewTwoMinuteReport && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>twoMinuteTestAIReport(module),
                                            style: {
                                                padding: '6px 25px'
                                            },
                                            className: `${module?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                                            children: "View 2-Minute Test Report"
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: getCompletenessAndRiskHTML("sidebar-" + tab, displayModule?.stats ?? company.modules[sanitiseTab(tab)]?.stats)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `mah100 mya oya df fdc jcsb bbrr5px bblr5px ${module['type']?.includes('business-audit') && "businessAuditSidebar"}`,
                            children: tab !== "kpi-report" && array.length > 0 && array.slice().sort(sortSections).map((section)=>{
                                let sectionFiles = getFilesFromQuestions(section?.questions);
                                // TODO: Calculate Stats for Expansion Packs
                                if (!section.stats) section.stats = module['sections'][0]['stats'];
                                let completeness;
                                if (isWorkflowReport && section?.stats?.workflowCompletionPercent) completeness = section.stats.workflowCompletionPercent;
                                else if (module['type'] == 'repository' && company['subscription'] == 'Lite') {
                                    if (section.questions) completeness = section.questions.filter((q)=>q.qNo == section.sectionNo)[0]?.['answer']?.['status'] == 'Completed' ? 100 : 0;
                                } else completeness = section.stats.completionPercent ?? 0;
                                let hexColour;
                                if (isWorkflowReport && section?.stats?.workflowCompletionPercent) hexColour = section?.stats?.workflowCompletionPercent > 75 ? '#d8fcc7' : section?.stats?.workflowCompletionPercent > 26 ? '#fff4c9' : section?.stats?.workflowCompletionPercent > 1 ? '#ffcecc' : '#dbdbdb';
                                else {
                                    // Reason: modules with risk scoring off (investor-lead / Investor Match) and sections with no Yes/No
                                    // answers produce no risk colour — fall back to the green completeness fill instead of transparent,
                                    // which is what getSubSectionBackground already does for sub-folders.
                                    const riskColor = computeSectionRiskColor(section, module);
                                    hexColour = isRepositoryLike || !riskColor ? '#40dda144' : riskColor;
                                }
                                let tooltip;
                                if (isWorkflowReport) tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac maw200px",
                                    children: `This section has ${completeness ?? 0}% workflow completeness`
                                }));
                                else tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac maw200px",
                                    children: `This section is ${completeness}% complete`
                                }));
                                if (section['disabled']) tooltip = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac maw200px",
                                    children: `Please request admin to access ${section['sectionNo']}`
                                }));
                                // Reason: checklist modules (internal/external/all) store their own permissions within the module — skip dashboard permission filters
                                const isChecklistModule = !module?.['dashboardPlacements'];
                                const creatorId = company?.['creatorId']?.['_id'] || company?.['creatorId'];
                                const isCreator = user?.['_id']?.toString() === creatorId?.toString();
                                if (!isChecklistModule && !isCreator) {
                                    // Hide sections for advisors/investors who lack explicit section permission
                                    // Exception: Investor Match / IR; UD001–UD005 / UD021–UD025 / CS… custom slots always listed
                                    if ((user['role'] === 'Advisor' || user['role'] === 'Investor') && user?.['companyId']?.['_id'] && user?.['companyId']?.['_id'] != company?.['_id'] && section?.['sectionNo'] && !module?.isInvestorMatch && !module?.isInvestmentReadiness && !(0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(section['sectionNo'])) {
                                        if (user['role'] === 'Advisor') {
                                            const advisorModules = company?.['advisors']?.[user['_id']]?.['modules'];
                                            if (advisorModules && !advisorModules[section['sectionNo']]) return null;
                                        }
                                        if (user['role'] === 'Investor') {
                                            const investorModules = company?.['investors']?.[user['_id']]?.['modules'];
                                            if (investorModules && !investorModules[section['sectionNo']]) return null;
                                        }
                                    }
                                    // Hide sections for Members who lack explicit section permission
                                    if ((user['role'] === 'Member' || user['role'] === 'User' && user['createdBy'] || user['role'] === 'User' && !company?.['owner']?.includes(user['_id'])) && section?.['sectionNo'] && !(0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(section['sectionNo'])) {
                                        const memberPerms = company?.['memberPermissions']?.[user['_id']];
                                        if (memberPerms && !memberPerms[section['sectionNo']]) return null;
                                    }
                                }
                                let disabledSection = false;
                                if ((module['type'] == 'repository' || module['type'] == `business-audit-${company['testType']}`) && user['role'] == 'Member' && user?.['companyId'] && user?.['companyId']?.['_id'] != company?.['_id'] && company['memberPermissions']) {
                                    if (!(0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(section['sectionNo']) && !company?.owners.includes(user['_id']) && !company?.['memberPermissions']?.[user['_id']]?.[section['sectionNo']]) disabledSection = true;
                                }
                                if (tab == 'Investment Readiness') {
                                    let answers = {};
                                    section?.questions && section?.questions.forEach((ques)=>{
                                        const qNo = ques['qNo'];
                                        answers[qNo] = {
                                            radioOption: ques?.['answer']?.['radioOption'],
                                            hasContent: ques?.['answer'] && (ques?.['answer']?.['files']?.length > 0 || ques?.['answer']?.['comment'])
                                        };
                                    });
                                    const isYesWithContent = (qNo)=>{
                                        return answers[qNo]?.radioOption === 'Yes' && answers[qNo]?.hasContent;
                                    };
                                    const isNoOrNA = (qNo)=>{
                                        return answers[qNo]?.radioOption === 'No' || answers[qNo]?.radioOption === 'N/A';
                                    };
                                    // module.moduleKey ('IR') does NOT match the real section prefix ('IRZIA'), so derive the prefix
                                    // from the section's own sectionNo by stripping its trailing section number ('IRZIA1' -> 'IRZIA').
                                    const mKey = String(section?.['sectionNo'] || '').replace(/[0-9]+$/, '');
                                    // marketOpportunity (requires both 1.1 AND 1.2)
                                    if (section['sectionNo'] == `${mKey}1`) {
                                        coreInfoResearchAid['marketOpportunity']['sectionNo'] = section['sectionNo'];
                                        const q11 = `${mKey}1.1`;
                                        const q12 = `${mKey}1.2`;
                                        if (isYesWithContent(q11) && isYesWithContent(q12)) {
                                            coreInfoResearchAid['marketOpportunity']['uploaded'] = true;
                                            coreInfoResearchAid['marketOpportunity']['notUploaded'] = false;
                                        } else if (isNoOrNA(q11) || isNoOrNA(q12)) {
                                            coreInfoResearchAid['marketOpportunity']['uploaded'] = false;
                                            coreInfoResearchAid['marketOpportunity']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['marketOpportunity']['uploaded'] = false;
                                            coreInfoResearchAid['marketOpportunity']['notUploaded'] = false;
                                        }
                                    }
                                    // routeToMarket (requires only 1.1)
                                    if (section['sectionNo'] == `${mKey}1`) {
                                        coreInfoResearchAid['routeToMarket']['sectionNo'] = section['sectionNo'];
                                        const q11 = `${mKey}1.1`;
                                        if (isYesWithContent(q11)) {
                                            coreInfoResearchAid['routeToMarket']['uploaded'] = true;
                                            coreInfoResearchAid['routeToMarket']['notUploaded'] = false;
                                        } else if (isNoOrNA(q11)) {
                                            coreInfoResearchAid['routeToMarket']['uploaded'] = false;
                                            coreInfoResearchAid['routeToMarket']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['routeToMarket']['uploaded'] = false;
                                            coreInfoResearchAid['routeToMarket']['notUploaded'] = false;
                                        }
                                    }
                                    // competitorAnalysis (requires both 5.1 AND 5.5)
                                    if (section['sectionNo'] == `${mKey}5`) {
                                        coreInfoResearchAid['competitorAnalysis']['sectionNo'] = section['sectionNo'];
                                        const q51 = `${mKey}5.1`;
                                        const q55 = `${mKey}5.5`;
                                        if (isYesWithContent(q51) && isYesWithContent(q55)) {
                                            coreInfoResearchAid['competitorAnalysis']['uploaded'] = true;
                                            coreInfoResearchAid['competitorAnalysis']['notUploaded'] = false;
                                        } else if (isNoOrNA(q51) || isNoOrNA(q55)) {
                                            coreInfoResearchAid['competitorAnalysis']['uploaded'] = false;
                                            coreInfoResearchAid['competitorAnalysis']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['competitorAnalysis']['uploaded'] = false;
                                            coreInfoResearchAid['competitorAnalysis']['notUploaded'] = false;
                                        }
                                    }
                                    // technologyAdvantage (requires both 4.1 AND 4.4)
                                    if (section['sectionNo'] == `${mKey}4`) {
                                        coreInfoResearchAid['technologyAdvantage']['sectionNo'] = section['sectionNo'];
                                        const q41 = `${mKey}4.1`;
                                        const q44 = `${mKey}4.4`;
                                        if (isYesWithContent(q41) && isYesWithContent(q44)) {
                                            coreInfoResearchAid['technologyAdvantage']['uploaded'] = true;
                                            coreInfoResearchAid['technologyAdvantage']['notUploaded'] = false;
                                        } else if (isNoOrNA(q41) || isNoOrNA(q44)) {
                                            coreInfoResearchAid['technologyAdvantage']['uploaded'] = false;
                                            coreInfoResearchAid['technologyAdvantage']['notUploaded'] = true;
                                        } else {
                                            coreInfoResearchAid['technologyAdvantage']['uploaded'] = false;
                                            coreInfoResearchAid['technologyAdvantage']['notUploaded'] = false;
                                        }
                                    }
                                }
                                const lastUpdateSection = getSectionUpdatedAt(company, section);
                                // Exit/Investment Readiness: render main sections only, never their subFolders
                                const hideSubFoldersForModule = module?.['moduleName'] === 'Exit Readiness' || module?.['moduleName'] === 'Investment Readiness';
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: !hideSubFoldersForModule && isRepositoryLike ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                disabled: section['disabled'] || disabledSection,
                                                "data-tooltip": tooltip || '',
                                                className: `c3-hover c51 bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`,
                                                style: {
                                                    background: section['disabled'] || disabledSection ? 'transparent' : `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                                },
                                                onClick: ()=>handleScroll(section['sectionNo']),
                                                children: [
                                                    tab.endsWith("-report") && !isExternalPage && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `asc checkbox w30px h30px pr mr1rem ${section['disabled'] || section['isDisabled'] || disabledSection ? 'op40' : 'op100 c3-hover'}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onChange: ()=>{
                                                                section['isHidden'] = !section['isHidden'];
                                                                dispatch(setCompany({
                                                                    ...company
                                                                }));
                                                            },
                                                            checked: !section['isHidden'],
                                                            type: "checkbox",
                                                            className: "bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        onClick: ()=>handleScroll(section['sectionNo']),
                                                        className: "df fdc w100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                class: "df",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `${showInTooltip ? 'fs0-5rem ' : 'fs0-75rem'} ${section['disabled'] || section['isDisabled'] || disabledSection ? 'op40' : 'op100 c3-hover'} sidemenu fw500 asc pen uss ass tal pr1rem`,
                                                                        children: section['sectionName']
                                                                    }),
                                                                    sectionFiles && sectionFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                        className: "df aic jcc cp fs10px bg1 br10px h20px",
                                                                        onClick: ()=>{
                                                                            setSection(section);
                                                                            setFolderNo(section?.sectionNo);
                                                                            setFolderFiles(sectionFiles);
                                                                            setFolderName(section?.sectionName);
                                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                open: 'manageIndexFiles'
                                                                            }));
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                className: "mr0-25rem",
                                                                                width: "10",
                                                                                height: "10",
                                                                                viewBox: "0 0 10 10",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                        clipPath: "url(#clipSidebarAttach)",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                                                                            fill: "#4A67FF"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                            id: "clipSidebarAttach",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                width: "10",
                                                                                                height: "10",
                                                                                                fill: "white"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            sectionFiles.length > 0 && sectionFiles.length
                                                                        ]
                                                                    }),
                                                                    !allSectionsExpand && section?.subFolders && !(isRepositoryLike && company['subscription'] === 'Lite') && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        disabled: section['disabled'] || disabledSection,
                                                                        className: `c3-hover expand-button cp`,
                                                                        onClick: ()=>toggleSectionExpand(section['_id']),
                                                                        children: section['disabled'] || section['isDisabled'] || disabledSection ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                                            className: "op40",
                                                                            style: {
                                                                                fontSize: "18px",
                                                                                fontWeight: 300
                                                                            }
                                                                        }) : sectionExpand[section['_id']] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41b252a7376cfacd$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2037fde3f2b67600$export$2e2bcd8739ae039), {})
                                                                    })
                                                                ]
                                                            }),
                                                            !isTwoMinuteTesHomePage && lastUpdateSection && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: `w100 df jcc fs10px mt0-5rem cp c6-hover ${section['disabled'] || disabledSection ? 'c12 c12-hover' : 'c14'}`,
                                                                children: [
                                                                    "(Last Updated: ",
                                                                    (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(lastUpdateSection).format('DD/MMM/YY'),
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (sectionExpand[section['_id']] || allSectionsExpand) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "sub-folders cp",
                                                children: section?.subFolders && Object.keys(section?.subFolders).map((subFolder)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            showSection(section, sectionFiles, section?.subFolders[subFolder], skipRiskScoring || isRepositoryLike),
                                                            section?.subFolders[subFolder]?.subFolders && Object.keys(section?.subFolders[subFolder]?.subFolders).map((subSubFolder)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        showSection(section, sectionFiles, section?.subFolders[subFolder]?.subFolders[subSubFolder], skipRiskScoring || isRepositoryLike),
                                                                        section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders && Object.keys(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders).map((subSubSubFolder)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                children: isTwoMinuteTesHomePage ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                    className: "df fww w100",
                                                                                    style: {
                                                                                        width: '96%',
                                                                                        padding: '5px 0px 0px 7px',
                                                                                        cursor: 'not-allowed'
                                                                                    },
                                                                                    disabled: true,
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "w70 asc pen uss ass tal pr1-5rem pl1rem",
                                                                                        children: [
                                                                                            section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no,
                                                                                            " ",
                                                                                            section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name
                                                                                        ]
                                                                                    })
                                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    onClick: ()=>{
                                                                                        handleScroll(resolveSubFolderEffectiveNo(section, section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no));
                                                                                    },
                                                                                    className: "df fww w100",
                                                                                    style: {
                                                                                        width: '92%',
                                                                                        padding: '5px 0px 0px 15px',
                                                                                        background: getSubSectionBackground(section, section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder], skipRiskScoring || isRepositoryLike)
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                            className: "w70 asc pen uss ass tal pr1-5rem pl1rem c2 c6-hover",
                                                                                            children: [
                                                                                                section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no,
                                                                                                " ",
                                                                                                section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name
                                                                                            ]
                                                                                        }),
                                                                                        sectionFiles && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                            className: "df jcc aic pa r0 cp mr0-5rem fs10px bg1 br10px h20px",
                                                                                            onClick: ()=>{
                                                                                                setSection(section);
                                                                                                setFolderNo(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no);
                                                                                                setFolderName(section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.name);
                                                                                                setFolderFiles(sectionFiles && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no));
                                                                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                                    open: 'manageIndexFiles'
                                                                                                }));
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                    className: "mr0-25rem",
                                                                                                    width: "10",
                                                                                                    height: "10",
                                                                                                    viewBox: "0 0 10 10",
                                                                                                    fill: "none",
                                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                                            clipPath: "url(#clipSidebarAttach)",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                                                                                                fill: "#4A67FF"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                                id: "clipSidebarAttach",
                                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                                    width: "10",
                                                                                                                    height: "10",
                                                                                                                    fill: "white"
                                                                                                                })
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                sectionFiles && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length > 0 && sectionFiles.filter((file)=>file.questionNo === section?.subFolders[subFolder]?.subFolders[subSubFolder]?.subFolders[subSubSubFolder]?.no)?.length
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            });
                                                                        })
                                                                    ]
                                                                });
                                                            })
                                                        ]
                                                    });
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>{
                                            setActivePoint(section['sectionNo']);
                                            handleScroll(section['sectionNo']);
                                        },
                                        disabled: disabledSection,
                                        "data-tooltip": tooltip,
                                        className: `${disabledSection ? 'c12' : 'c2 c3-hover'} bg5 w100 df td250 px1rem pl0-5rem py0-5rem cp pr`,
                                        style: {
                                            background: disabledSection ? 'transparent' : `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`
                                        },
                                        children: [
                                            tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "asc checkbox w30px h30px pr mr1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    onChange: (e)=>{
                                                        section['isHidden'] = !section['isHidden'];
                                                        dispatch(setCompany({
                                                            ...company
                                                        }));
                                                    },
                                                    className: "bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                    type: "checkbox",
                                                    checked: !section['isHidden']
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: (showInTooltip ? 'fs0-5rem ' : 'fs0-75rem ') + " sidemenu fw500 asc pen uss ass tal",
                                                children: [
                                                    section['sectionName'],
                                                    " "
                                                ]
                                            }),
                                            sectionFiles && sectionFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                className: "df jcc aic pa r0 cp fs10px bg1 br10px h20px",
                                                onClick: ()=>{
                                                    setSection(section);
                                                    setFolderNo(section?.sectionNo);
                                                    setFolderFiles(sectionFiles);
                                                    setFolderName(section?.sectionName);
                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: 'manageIndexFiles'
                                                    }));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        className: "mr0-25rem",
                                                        width: "10",
                                                        height: "10",
                                                        viewBox: "0 0 10 10",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                clipPath: "url(#clipSidebarAttach)",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M2.13248 8.71006C1.00074 7.75501 0.920568 5.98214 1.95376 4.7578L4.76425 1.42734C5.4286 0.640082 6.56101 0.499793 7.28814 1.1134C8.01527 1.72701 8.06738 2.86688 7.40303 3.65414L4.72637 6.82601C4.50474 7.08864 4.12784 7.13552 3.88508 6.93065C3.64231 6.72579 3.62515 6.34637 3.84678 6.08374L6.52344 2.91187C6.74507 2.64924 6.72732 2.26933 6.48514 2.06496C6.24296 1.86059 5.86547 1.90698 5.64385 2.16961L2.83335 5.50007C2.24288 6.19978 2.28868 7.21269 2.93548 7.7585C3.58227 8.30432 4.58846 8.17916 5.17893 7.47944L8.79243 3.19743C9.01405 2.9348 9.39095 2.88791 9.63372 3.09278C9.87649 3.29765 9.89365 3.67706 9.67202 3.93969L6.05853 8.22171C5.02534 9.44605 3.26422 9.66511 2.13248 8.71006Z",
                                                                    fill: "#4A67FF"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                    id: "clipSidebarAttach",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                        width: "10",
                                                                        height: "10",
                                                                        fill: "white"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    sectionFiles.length > 0 && sectionFiles.length
                                                ]
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        company.subscription == "Pro" && module?.['isCustomSection'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "hf df aic jcc mt1 mb4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "additional-sections-button",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'proaddsection'
                                        })),
                                    className: "btn-packge shadow bg3 bg4-hover c1 td250 br50px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic fs0-75rem",
                                    children: [
                                        "Add/Edit User Defined Sections",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tooltip-area",
                                            style: {
                                                color: 'black',
                                                left: '-8px',
                                                right: 'auto'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                className: "icon",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "h4rem",
                                                        src: (parcelRequire("24u8s")),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "overlay-box",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: "Diligentsia Pro allows users to add up to 5 user-defined sections to the Data Repository Index structure.  These are then replicated in your Data Room (Drive/Sharepoint/Dropbox )"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                user['role'] == 'Guest' && localStorage.getItem('isPartnerChecklist') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df fdc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>handlePartnerChecklistNext(module),
                            className: `w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem mt1rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                            children: "Next"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: module?.['stats']['completionPercent'] > 0 && "/register",
                            className: `w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem mt0-5rem df aic jcc ${module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                            children: "Save for later"
                        }),
                        !tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w100 mb1rem",
                            src: (parcelRequire("gDTQF")),
                            alt: ""
                        }),
                        tab.endsWith("-report") && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w100 mb1rem",
                            src: (parcelRequire("40qsd")),
                            alt: ""
                        })
                    ]
                }),
                user['type'] == 'Superflow' && tab == `investor-lead` && (()=>{
                    // Prefer the live localModule stats (tempModule) — its completion is recomputed by answer status,
                    // which credits investor-lead's free-text questions that calculateStats / company.modules stats miss.
                    const investorLeadCompletion = tempModule?.['stats']?.['completionPercent'] ?? company?.modules?.['investor-lead']?.['stats']?.['completionPercent'];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc aic mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "df w100 mb1rem",
                                    src: (parcelRequire("4VhrM")),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>handleSuperflowNext(),
                                    "data-tooltip": investorLeadCompletion != 100 ? 'Please complete the module 100%' : '',
                                    className: `w50 shadow fw500 fs0-75rem br50px px1rem py0-5rem df aic jcc ${investorLeadCompletion == 100 ? 'bg4 cp c1' : 'bg16 cna c14'} `,
                                    children: "Next"
                                })
                            ]
                        })
                    });
                })(),
                tab == 'Investment Readiness' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "superflow-section mah40 oscy",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "bo45 bss bw1px br10px bg1 p0-5rem mt0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    class: "c14 fs1rem lh2 tac",
                                    children: [
                                        "Core Information For ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " ResearchAid Reports"
                                    ]
                                }),
                                Object.values(coreInfoResearchAid).map((item)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>{
                                            setActivePoint(item['sectionNo']);
                                            handleScroll(item['sectionNo']);
                                        },
                                        class: "cp w100 df bo45 bss bw1px br20px bg1 p0-5rem mt0-5rem",
                                        style: {
                                            backgroundColor: item['uploaded'] ? '#deffe9' : item['notUploaded'] ? '#ffdddd' : '#ffffff'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "w10 mr0-5rem",
                                                children: [
                                                    item['uploaded'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "w20px h20px",
                                                        src: (parcelRequire("2M7mC")),
                                                        alt: "check-icon"
                                                    }),
                                                    item['notUploaded'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "w20px h20px",
                                                        src: (parcelRequire("aHhy4")),
                                                        alt: "cross-icon"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "w80 df fdc mx0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "w100 fs0-75rem c14 lh1",
                                                        children: [
                                                            item['name'],
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                class: "c4",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        class: "w100 fs0-75rem c12 lh2",
                                                        children: [
                                                            "(",
                                                            item['path'],
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                class: "w10 ml0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w20px h20px",
                                                    src: (parcelRequire("e7RTg")),
                                                    alt: "file-icon"
                                                })
                                            })
                                        ]
                                    });
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "df fdc aic mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df w100 mb1rem",
                                src: (parcelRequire("1avjd")),
                                alt: ""
                            })
                        }),
                        user['type'] == 'Superflow' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 df fdc aic mb2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>handleCompleteInvestmentReadiness(),
                                        className: `w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                        children: "Next"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>updateUserType(),
                                        className: `w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                        children: "Save for later"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df fdc aic mb2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleCompleteInvestmentReadiness(),
                                className: `w50 shadow c1 fs0-75rem fw600 br50px px1rem py0-5rem mt0-5rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                children: "Generate"
                            })
                        })
                    ]
                }),
                user?.['type'] == 'Superflow' && tab == 'Investment Readiness-report' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "df fdc aic mt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w100 mb1rem",
                            src: (parcelRequire("jhDfB")),
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>module?.['stats']['completionPercent'] > 0 && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'superFlowCompletedPopup'
                                })),
                            className: `w50 shadow c1 fw400 fs0-75rem fw600 pr mxa br50px px1rem py0-5rem my1rem df aic jcc ${module && module?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                            children: "Next"
                        })
                    ]
                }),
                tab.match(/two-minute-test-.*-report/) && user?.role.toLowerCase() === "guest" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("lkR4C")),
                            alt: "2minutesTestSidebarDiligentsia"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: `/company/${company['_id']}`,
                            style: {
                                width: '75%',
                                paddingTop: '12px',
                                paddingBottom: '12px',
                                marginLeft: "auto",
                                marginRight: "auto"
                            },
                            className: `shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                            children: "Next"
                        })
                    ]
                }) : (!localStorage.getItem('isDemoChecklist') || !localStorage.getItem('isPartneChecklist')) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        (0, $1eef38cfda4b0c52$export$884def0ebe460136)({
                            company: company
                        }) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: company?.servicedBy && company?.servicedBy?.role === "Advisor" ? tab !== 'investor-lead' && tab !== 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59010cfc8b663697$export$2e2bcd8739ae039), {
                                onCardLog: onCardLog,
                                user: user,
                                LiButton: LiButton,
                                company: company,
                                truncateText: truncateText,
                                activePoint: activePoint,
                                visibleSection: visibleSection,
                                getCompanyById: getCompanyById,
                                allocatedAdvisor: allocatedAdvisor?.email ? allocatedAdvisor : {
                                    ...user,
                                    sectionName: getSectionName(company, visibleSection)
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8615c75609e057bd$export$2e2bcd8739ae039), {
                                onCardLog: onCardLog,
                                user: user,
                                LiButton: LiButton,
                                company: company,
                                truncateText: truncateText,
                                getSectionName: getSectionName,
                                activePoint: activePoint,
                                visibleSection: visibleSection,
                                getCompanyById: getCompanyById
                            })
                        }),
                        shouldRenderReferOffer ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af33af4f3eed7fb8$export$2e2bcd8739ae039), {}) : null,
                        (0, $1eef38cfda4b0c52$export$f5f94221ec047dbf)({
                            company: company,
                            user: user
                        }) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f95fdf0c9db68ad9$export$2e2bcd8739ae039), {
                            company: company
                        }) : null
                    ]
                }),
                user['role'] == 'Guest' && tab == `two-minute-test-${company['testType']}` && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    class: "df fdc aic mt1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "df w100 mb1rem",
                        src: (parcelRequire("aSPAr")),
                        alt: ""
                    })
                })
            ]
        });
        return showInTooltip ? (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup(jsx) : jsx;
    };
    const convertImageToBase64 = async (imgUrl)=>{
        try {
            const proxyUrl = `${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api/company/pdf-proxy?url=${encodeURIComponent(imgUrl)}`;
            const response = await fetch(proxyUrl);
            const blob = await response.blob();
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error converting image to base64:', error);
            return imgUrl;
        }
    };
    const convertAllImagesToBase64 = async (element)=>{
        const images = element.querySelectorAll('img');
        const imagePromises = [];
        for (const img of images){
            const src = img.src;
            if (src && (src.includes('s3') || src.includes('amazonaws') || src.includes('cloudfront'))) imagePromises.push(convertImageToBase64(src).then((base64)=>{
                img.setAttribute('data-original-src', src);
                img.src = base64;
            }).catch(()=>{}));
        }
        await Promise.all(imagePromises);
    };
    const restoreOriginalImages = (element)=>{
        const images = element.querySelectorAll('img[data-original-src]');
        for (const img of images){
            img.src = img.getAttribute('data-original-src');
            img.removeAttribute('data-original-src');
        }
    };
    const downloadPDF = async ()=>{
        try {
            // If Papermill PDF exists (reportUrl), download from S3 directly
            const moduleName = tab ? sanitiseTab(tab) : '';
            const currentModule = company?.modules?.[moduleName];
            // Build filename: [Company Name] > [Section Name] Report > [Date]
            const _dateStr = new Date().toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
            let _sectionName = '';
            if (tab?.endsWith('-section-report')) {
                const _qNo = tab.replace(/-section-report$/, '');
                const _aiReport = company?.['aiReports']?.find((r)=>r['reportType'] === `sectionReport_${_qNo}`);
                _sectionName = _aiReport?.['reportLabel'] || _aiReport?.['name'] || _qNo;
            } else _sectionName = displayModule?.['moduleName'] || (typeof getTempModuleTitleForTab === 'function' ? getTempModuleTitleForTab(tab) : '') || moduleName || tab || 'Report';
            const _filename = `${company?.['cName'] || 'Company'} > ${_sectionName} Report > ${_dateStr}`;
            if (currentModule?.reportUrl) {
                setIsLoader({
                    show: true,
                    message: 'Downloading PDF...'
                });
                // Create a temporary link to trigger download
                const link = document.createElement('a');
                link.href = currentModule.reportUrl;
                link.target = '_blank';
                link.download = `${_filename}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setIsLoader({
                    show: false,
                    message: 'Loading...'
                });
                return;
            }
            setIsLoader({
                show: true,
                message: 'PDF Downloading...'
            });
            const wrapper = document.getElementById("pdf");
            // Reason: capture the report EXACTLY as the browser renders #pdf. snapDOM captures the live layout faithfully,
            // so the previous pre-capture mutations (uncapping row heights via mah40vh->mah100vh, removing the page gap and
            // the cover-list cap) were the ONLY thing making the PDF diverge from the on-screen report — they reflowed
            // content past the pre-computed page boundaries, which produced the broken footers, notes boxes and label wraps.
            // Leaving the DOM untouched makes the PDF match the browser page-for-page.
            // Reason: snapDOM captures via an SVG <foreignObject> (real browser render), so unlike html2canvas it PAINTS the
            // global pink ::-webkit-scrollbar chrome and honours text-align inherited from ancestors above the captured page.
            // Inject an export-only stylesheet to match the previous PDF format: hide scrollbars, drop overflow/height caps so
            // nothing scrolls or clips, and left-align report rows (elements with .tac stay centred via their own declaration).
            const exportStyle = document.createElement("style");
            exportStyle.setAttribute("data-pdf-export", "true");
            exportStyle.textContent = `
				/* Only hide scrollbars \u{2014} everything else must render exactly as on screen so the PDF matches the browser. */
				#pdf ::-webkit-scrollbar { display: none !important; width: 0 !important; height: 0 !important; background: transparent !important; }
				#pdf, #pdf * { scrollbar-width: none !important; }
			`;
            document.head.appendChild(exportStyle);
            let tempWrapper = wrapper;
            for (const hideEl of tempWrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.add("op0");
            // Convert S3 images to base64 before generating PDF
            await convertAllImagesToBase64(tempWrapper);
            const filename = _filename;
            // Wait for web fonts to finish loading and let layout settle so html2canvas measures text with the correct
            // (Poppins) metrics rather than a fallback font.
            try {
                if (document.fonts && document.fonts.ready) await document.fonts.ready;
            } catch (e) {}
            await new Promise((res)=>requestAnimationFrame(()=>requestAnimationFrame(res)));
            // Generate PDF page by page to avoid page break issues
            const pages = tempWrapper.querySelectorAll('.a4-pdf');
            const pdf = new (0, $15d064020a078dff$export$ba1e2ffc633a60f5)({
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait'
            });
            const pdfWidth = 210;
            const pdfHeight = 297;
            // Reason: snapDOM's SVG-foreignObject renderer mis-paints this report's flex/text layouts INCONSISTENTLY across
            // pages (invented backgrounds, broken white-space:nowrap, centred/clipped questions, columns merging) even though
            // the live CSS is correct — so it can't be trusted per-page. html2canvas re-implements the browser's own rendering
            // and reproduces the on-screen layout faithfully (proven on the cover page). To keep it fast across many pages we
            // temporarily DETACH the other pages during each capture (replacing them with a placeholder comment to preserve
            // order), so html2canvas only has to clone/render this one page. Each .a4-pdf is a fixed 210mm-wide, self-contained
            // page, and #pdf is built imperatively (not React-managed), so detaching/restoring siblings is safe and does not
            // change how the captured page renders.
            const allPages = Array.from(pages);
            for(let i = 0; i < allPages.length; i++){
                const page = allPages[i];
                const detached = [];
                for(let j = 0; j < allPages.length; j++)if (j !== i) {
                    const ph = document.createComment('pdf-page');
                    allPages[j].replaceWith(ph);
                    detached.push([
                        ph,
                        allPages[j]
                    ]);
                }
                let canvas;
                try {
                    canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(page, {
                        useCORS: true,
                        allowTaint: true,
                        logging: false,
                        scale: 1.2,
                        backgroundColor: '#ffffff'
                    });
                } finally{
                    for (const [ph, el] of detached)ph.replaceWith(el);
                }
                const imgData = canvas.toDataURL('image/jpeg', 0.6);
                if (i > 0) pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
            }
            pdf.save(filename + '.pdf');
            // Restore original image URLs after PDF generation
            restoreOriginalImages(tempWrapper);
            wrapper.classList.add("gg2rem");
            for (const page of wrapper.children)page.classList.add("shadow");
            for (const hideEl of wrapper.querySelectorAll(".hideOnDownload"))hideEl.classList.remove("op0");
            document.querySelectorAll(".oscy").forEach((el)=>el.classList.add("h60vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.add("mah40vh"));
            document.querySelectorAll(".tableRow").forEach((el)=>el.classList.remove("mah100vh"));
            exportStyle.remove();
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
        } catch (e) {
            console.error(e);
            // Reason: ensure the export-only stylesheet never lingers if capture throws mid-run
            document.querySelector('style[data-pdf-export]')?.remove();
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
        }
    };
    const getFileHTML = (file)=>{
        let fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
        const key = file.key;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df jcfs aic w100 px1rem py0-5rem td250 bsbb",
                children: [
                    [
                        "pdf"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M292 312h-4.422c-3.256 .1484-24.48 1.359-54.15 6.406c-11.75-10.84-21.61-23.59-29.44-38.05c1.047-3.207 2.076-6.449 3.082-9.723C208.8 263.8 216 232.1 216 208c0-22.05-17.94-40-40-40c-22.05 0-40 17.95-40 40c0 .3555 .1973 34.39 16.53 74.36c-8.396 23.11-18.58 46.31-30.33 69.14c-25.65 12.07-46.84 26.54-63.02 43.05C51.74 402.2 48 412.1 48 424.1C48 446.1 65.92 464 87.94 464c12.9 0 25.04-6.238 32.48-16.68c8.74-12.27 21.94-32.1 36.37-58.41c18.86-7.582 40.44-13.99 64.31-19.1c16.18 11.43 34.5 20.64 54.55 27.39C281.1 399 286.9 400 292.9 400C317.1 400 336 380.7 336 356C336 331.7 316.3 312 292 312zM94.38 428.8C90.47 434.3 80 432 80 422.4c0-2.094 .75-4.094 2.062-5.438c10.77-11 23.8-20.34 38.02-28.31C108.8 408 99.27 421.9 94.38 428.8zM176 200c4.406 0 8 3.594 8 8c0 18.16-4.906 41.59-6.859 50.25C168.3 231.3 168 210.1 168 208C168 203.6 171.6 200 176 200zM156.5 354.6c7.891-16.09 15.78-33.97 23.12-53.34c7.625 13.03 17.38 26.09 29.8 38.16C192.7 343.2 174.5 348.1 156.5 354.6zM292.9 368c-2.422 0-4.844-.375-6.984-1.125c-14.72-4.938-27.58-11.12-38.84-18.12C271.2 344.1 287.7 344 288 344h4c6.609 0 12 5.375 12 12.88C304 363 299 368 292.9 368zM256 0v128h128L256 0z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M184 208c0-4.406-3.594-8-8-8S168 203.6 168 208c0 2.062 .2969 23.31 9.141 50.25C179.1 249.6 184 226.2 184 208zM156.5 354.6c17.98-6.5 36.13-11.44 52.92-15.19c-12.42-12.06-22.17-25.12-29.8-38.16C172.3 320.6 164.4 338.5 156.5 354.6zM80 422.4c0 9.656 10.47 11.97 14.38 6.375C99.27 421.9 108.8 408 120.1 388.6c-14.22 7.969-27.25 17.31-38.02 28.31C80.75 418.3 80 420.3 80 422.4zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM292.9 400c-5.994 0-11.81-.9531-17.22-2.805c-20.06-6.758-38.38-15.96-54.55-27.39c-23.88 5.109-45.46 11.52-64.31 19.1c-14.43 26.31-27.63 46.15-36.37 58.41C112.1 457.8 100.8 464 87.94 464C65.92 464 48 446.1 48 424.1c0-11.92 3.74-21.82 11.18-29.51c16.18-16.52 37.37-30.99 63.02-43.05c11.75-22.83 21.94-46.04 30.33-69.14C136.2 242.4 136 208.4 136 208c0-22.05 17.95-40 40-40c22.06 0 40 17.95 40 40c0 24.1-7.227 55.75-8.938 62.63c-1.006 3.273-2.035 6.516-3.082 9.723c7.83 14.46 17.7 27.21 29.44 38.05C263.1 313.4 284.3 312.1 287.6 312H292c24.26 0 44 19.74 44 44C336 380.7 317.1 400 292.9 400zM292 344H288c-.3438 .0313-16.83 .9687-40.95 4.75c11.27 7 24.12 13.19 38.84 18.12C288 367.6 290.5 368 292.9 368C299 368 304 363 304 356.9C304 349.4 298.6 344 292 344z"
                            })
                        ]
                    }) || [
                        "mp4",
                        "webm",
                        "mkv",
                        "ogg",
                        "avi",
                        "mov"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM192 256H96C78.33 256 64 270.3 64 288v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288C224 270.3 209.7 256 192 256zM295.5 271.3L256 296v80l39.52 24.7C306.2 407.4 320 399.7 320 387.1V284.9C320 272.3 306.2 264.6 295.5 271.3z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM224 384c0 17.67-14.33 32-32 32H96c-17.67 0-32-14.33-32-32V288c0-17.67 14.33-32 32-32h96c17.67 0 32 14.33 32 32V384zM320 387.1c0 12.57-13.82 20.23-24.48 13.57L256 376v-80l39.52-24.7C306.2 264.6 320 272.3 320 284.9V387.1z"
                            })
                        ]
                    }) || [
                        "sheet",
                        "xlsx",
                        "xls",
                        "xlsm",
                        "ots",
                        "csv"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM312 224h-240c-8.875 0-16 7.125-16 16v192c0 8.875 7.125 16 16 16h240c8.875 0 16-7.125 16-16v-192C328 231.1 320.9 224 312 224zM136 416h-48v-48h48V416zM136 336h-48V288h48V336zM216 416h-48v-48h48V416zM216 336h-48V288h48V336zM296 416h-48v-48h48V416zM296 336h-48V288h48V336z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM328 432c0 8.875-7.125 16-16 16h-240c-8.875 0-16-7.125-16-16v-192c0-8.875 7.125-16 16-16h240c8.875 0 16 7.125 16 16V432z"
                            })
                        ]
                    }) || [
                        "png",
                        "jpg",
                        "jpeg",
                        "gif",
                        "bmp",
                        "svg",
                        "webp"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM231.1 295.1C229 290.7 224 288 218.7 288s-10.35 2.674-13.31 7.125L160 363.2l-13.35-20.03C143.7 338.7 138.7 336 133.3 336s-10.35 2.674-13.31 7.125l-53.33 80c-3.273 4.908-3.578 11.22-.7949 16.42C68.68 444.8 74.1 448 80 448h224c5.9 0 11.32-3.248 14.11-8.451c2.783-5.201 2.479-11.52-.7949-16.42L231.1 295.1z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 224c17.67 0 32 14.33 32 32S113.7 288 96 288S64 273.7 64 256S78.33 224 96 224zM318.1 439.5C315.3 444.8 309.9 448 304 448h-224c-5.9 0-11.32-3.248-14.11-8.451c-2.783-5.201-2.479-11.52 .7949-16.42l53.33-80C122.1 338.7 127.1 336 133.3 336s10.35 2.674 13.31 7.125L160 363.2l45.35-68.03C208.3 290.7 213.3 288 218.7 288s10.35 2.674 13.31 7.125l85.33 128C320.6 428 320.9 434.3 318.1 439.5z"
                            })
                        ]
                    }) || [
                        "zip",
                        "7z",
                        "gz",
                        "tar.gz"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M160 32H96v32h64V32zM160 160H96v32h64V160zM160 96H96v32h64V96zM256 0v128h128L256 0zM160 224H96l-30.56 116.5c-7.93 39 22.26 75.45 62.83 75.45c40.26 0 70.45-36.3 62.68-75.15L160 224zM144 368h-32C103.2 368 96 360.8 96 352s7.164-16 16-16h32C152.8 336 160 343.2 160 352S152.8 368 144 368z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM96 32h64v32H96V32zM96 96h64v32H96V96zM96 160h64v32H96V160zM128.3 415.1c-40.56 0-70.76-36.45-62.83-75.45L96 224h64l30.94 116.9C198.7 379.7 168.5 415.1 128.3 415.1z"
                            })
                        ]
                    }) || [
                        "doc",
                        "docx",
                        "docm",
                        "rtf",
                        "odt",
                        "dot",
                        "dotx"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM304.9 240h-23.37c-5.588 0-10.44 3.859-11.69 9.301L246.2 352L218.4 248.9C216.1 243.6 212.2 240 206.8 240H177.2c-5.426 0-10.18 3.641-11.59 8.883L137.8 352L114.1 249.3C112.9 243.9 108 240 102.5 240H79.08c-7.717 0-13.43 7.18-11.69 14.7l42.46 184C111.1 444.1 115.1 448 121.5 448h29.26c5.428 0 10.18-3.641 11.59-8.883L192 329.1l29.61 109.1C223 444.4 227.8 448 233.2 448h29.26c5.588 0 10.44-3.859 11.69-9.305l42.46-184C318.3 247.2 312.6 240 304.9 240z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM274.1 438.7C272.9 444.1 268 448 262.5 448h-29.26c-5.426 0-10.18-3.641-11.59-8.883L192 329.1l-29.61 109.1C160.1 444.4 156.2 448 150.8 448H121.5c-5.588 0-10.44-3.859-11.69-9.305l-42.46-184C65.66 247.2 71.37 240 79.08 240h23.37c5.588 0 10.44 3.859 11.69 9.301L137.8 352L165.6 248.9C167 243.6 171.8 240 177.2 240h29.61c5.426 0 10.18 3.641 11.59 8.883L246.2 352l23.7-102.7C271.1 243.9 275.1 240 281.5 240h23.37c7.717 0 13.43 7.18 11.69 14.7L274.1 438.7z"
                            })
                        ]
                    }) || [
                        "pptx",
                        "pttm",
                        "ppt"
                    ].includes(file.ext) && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M199.5 240H128C119.2 240 112 247.2 112 256v176C112 440.8 119.2 448 128 448h16C152.8 448 160 440.8 160 432v-40h44c44.53 0 80.23-38.49 75.59-83.95C275.6 268.5 239.3 240 199.5 240zM204 344H160V288h44c15.44 0 28 12.56 28 28S219.4 344 204 344zM256 0v128h128L256 0z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M204 288H160v56h44c15.44 0 28-12.56 28-28S219.4 288 204 288zM256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM204 392H160v40C160 440.8 152.8 448 144 448H128c-8.836 0-16-7.164-16-16V256c0-8.836 7.164-16 16-16h71.51c39.75 0 76.05 28.52 80.08 68.05C284.2 353.5 248.5 392 204 392z"
                            })
                        ]
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f3 h2rem w2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 384 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 0v128h128L256 0zM272 384h-160C103.2 384 96 391.2 96 400S103.2 416 112 416h160c8.836 0 16-7.164 16-16S280.8 384 272 384zM272 320h-160C103.2 320 96 327.2 96 336S103.2 352 112 352h160c8.836 0 16-7.164 16-16S280.8 320 272 320zM272 256h-160C103.2 256 96 263.2 96 272S103.2 288 112 288h160C280.8 288 288 280.8 288 272S280.8 256 272 256z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 128V0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V128H256zM272 416h-160C103.2 416 96 408.8 96 400S103.2 384 112 384h160c8.836 0 16 7.164 16 16S280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336S103.2 320 112 320h160c8.836 0 16 7.164 16 16S280.8 352 272 352zM272 288h-160C103.2 288 96 280.8 96 272S103.2 256 112 256h160C280.8 256 288 263.2 288 272S280.8 288 272 288z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: ()=>getViewableURL(file.url),
                        rel: "noopener noreferrer",
                        style: {
                            flex: 1
                        },
                        className: `mx1rem fs1rem cp fw600 bg1 ${fileColor}`,
                        children: file.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        target: "_blank",
                        to: file.url,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            "data-tooltip": "Download",
                            className: `f3 h1rem cp mr1rem ${tab == 'repository' ? '' : 'mla'}`,
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 512 512",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-primary",
                                    d: "M105.4 246.6c-12.49-12.5-12.49-32.75 0-45.25c12.5-12.5 32.76-12.5 45.25 0L224 274.8V32c0-17.67 14.33-32 32-32c17.67 0 32 14.33 32 32v242.8l73.38-73.38c12.49-12.5 32.75-12.5 45.25 0c12.49 12.5 12.49 32.75 0 45.25l-128 128C272.4 380.9 264.2 384 256 384s-16.38-3.125-22.62-9.375L105.4 246.6z"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "fa-secondary",
                                    d: "M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z"
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    const handleRedirectDashboard = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
            type: 'User'
        });
        if (res['code'] == '200') {
            await getUser();
            setTabName('');
            setOpenTabs(new Set());
            navigate(`/company/${company['_id']}`);
        }
    };
    const userRoleLower = typeof user?.role === 'string' ? user.role.toLowerCase() : '';
    const createdByRoleLower = typeof user?.createdBy?.role === 'string' ? user.createdBy.role.toLowerCase() : '';
    const userEmailHasCfoDomain = typeof user?.email === 'string' && user.email.includes('@cfocentre.com');
    const companyHasCfoAdvisor = Array.isArray(company?.advisorData) && company.advisorData.some((advisor)=>typeof advisor?.email === 'string' && advisor.email.includes('@cfocentre.com'));
    const createdByRole = company?.creatorId?.createdBy?.role?.toLowerCase();
    const isCreatedByAdvisorOrInvestor = !createdByRole || [
        'investor',
        'advisor'
    ].includes(createdByRole);
    const shouldRenderReferOffer = (userEmailHasCfoDomain && userRoleLower === 'advisor' || companyHasCfoAdvisor || userRoleLower === 'advisor' || createdByRoleLower === 'advisor') && !isCreatedByAdvisorOrInvestor;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            getSidebarHTML(displayModule || company.modules[sanitiseTab(tab)]),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'manageIndexFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "text-gradient fw600 tac mb1rem fs1-25em",
                            children: [
                                company.cName,
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Section File Manager"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                            children: `${folderNo} ${folderName}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg gg1rem mb2rem fs1rem",
                            children: folderFiles && folderFiles.length > 0 && folderFiles.map((file)=>{
                                return getFileHTML(file);
                            }) || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs1-25rem fw500 gcs1 gce5-md tac",
                                children: "No files have been added yet"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "completeInvestmentReadiness",
                open: modal['open'] == 'completeInvestmentReadiness',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w800px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df my2rem",
                                src: (parcelRequire("iGe5G")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c15 fs1-25rem fw400 tac mb1rem",
                                children: [
                                    "Thank you for completing your Investment Readiness ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " assessment."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1rem fw400 tac mb3rem",
                                children: "We are creating your ResearchAid Reports now. It will be ready in few minutes meantime you can view your Investment Readiness Report."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tac w100 db",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    onClick: (e)=>handleReport(e, company?.['modules']?.[sanitiseTab(tab)]),
                                    to: `#${tab}-report`,
                                    className: "cp w300px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                    children: "View Report*"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "superFlowCompletedPopup",
                open: modal['open'] == 'superFlowCompletedPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg5 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w20",
                                src: (parcelRequire("dNazT")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1-5rem fw500 mb3rem",
                                children: "Congratulations. You now have access to the following reports"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df jcc w50",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("blGti")),
                                        alt: "step-1"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("dloz2")),
                                        alt: "step-2"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("1QZ0E")),
                                        alt: "step-3"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w40 mr0-5rem",
                                        src: (parcelRequire("jh3BR")),
                                        alt: "step-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tac w100 db mt1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>handleRedirectDashboard(),
                                    className: "cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                    children: "Let's Go!"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "notGeneratedResearchAidReports",
                open: modal['open'] == 'notGeneratedResearchAidReports',
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr my1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-25rem fw600 c4 my2rem mb2rem tac",
                                    children: "ResearchAid Reports Not Generated!"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("6Ycgy")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mxa",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem fw400 c15 mt3rem mb1rem",
                                            children: [
                                                "We are sorry due to some technical issues ResearchAid Reports are not generated automatically!",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "You can go to ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Dashboard"
                                                }),
                                                " and generate them manually."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tac w100 db",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>window.location.href = `/company/${company['_id']}`,
                                                className: "cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                                children: "Dashboard"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $810fd00e44870152$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f057e242d303909$export$2e2bcd8739ae039), {})
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");


var $acw62 = parcelRequire("acw62");








/**
 * Percent shown in workflow report / sidebar workflow mode.
 * Legacy company modules use task workflow scores; temp modules use checklist completionPercent.
 */ const $1c519f43076178a7$export$8ec8d478e850e2c9 = (stats)=>{
    if (!stats) return 0;
    if (stats.workflowMaxScore > 0) return stats.workflowCompletionPercent ?? 0;
    return stats.completionPercent ?? 0;
};


function $50f56850e74303b5$export$2e2bcd8739ae039({ getCompany: getCompany, setCompany: setCompany, calculateStats: calculateStats, sectionRefs: sectionRefs, user: user, company: company, module: moduleFromCompany, tab: tab, setTab: setTab, isLoader: isLoader, setIsLoader: setIsLoader, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, twoMinuteTestAIReport: twoMinuteTestAIReport, sortSections: sortSections }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const textareaRef = (0, $acw62.useRef)(null);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const sanitiseReportTab = (t = '')=>decodeURIComponent(t).replace(/(-sync)?-report$/, "");
    let [tempModuleFetched, setTempModuleFetched] = (0, $acw62.useState)(null);
    let [noteId, setNoteId] = (0, $acw62.useState)('');
    let [answerId, setAnswerId] = (0, $acw62.useState)('');
    let [editNote, setEditNote] = (0, $acw62.useState)('');
    let [taskNotes, setTaskNotes] = (0, $acw62.useState)([]);
    let [isMarked, setIsMarked] = (0, $acw62.useState)(false);
    let [addTextarea, setAddTextarea] = (0, $acw62.useState)(1);
    let [isSaveNote, setIsSaveNote] = (0, $acw62.useState)(false);
    let [statusDropdown, setStatusDropdown] = (0, $acw62.useState)(false);
    let [checklistModule, setChecklistModule] = (0, $acw62.useState)(false);
    let [priorityDropdown, setPriorityDropdown] = (0, $acw62.useState)(false);
    let [directorCertification, setDirectorCertification] = (0, $acw62.useState)('None');
    const module = tempModuleFetched ?? moduleFromCompany;
    const getHeight = (child)=>child.offsetHeight + parseFloat(getComputedStyle(child).marginTop) + parseFloat(getComputedStyle(child).marginBottom);
    (0, $acw62.useEffect)(()=>{
        const fetchTempModuleForWorkflowReport = async ()=>{
            if (!company?._id || !tab || tab === 'kpi-report') return;
            try {
                const moduleSlugRaw = sanitiseReportTab(tab).replace(/^temp-/, '');
                const moduleSlug = moduleSlugRaw.includes('business-audit') ? moduleSlugRaw.replace(`-${company?.['testType']}`, '') : moduleSlugRaw;
                if (!moduleSlug) return;
                const companyId = company?._id;
                let resolvedModuleName = moduleSlug;
                let resolvedDirectorId = null;
                if (moduleSlug.includes('directors-questionnaire_')) {
                    const parts = moduleSlug.split('_');
                    resolvedModuleName = 'directors-questionnaire';
                    resolvedDirectorId = parts[1] || null;
                } else if (moduleSlug.includes('business-audit')) resolvedModuleName = moduleSlug.replace(`-${company?.['testType']}`, '');
                else if (moduleSlug.includes('%20')) resolvedModuleName = moduleSlug.replaceAll('%20', ' ');
                const moduleName = resolvedModuleName;
                const directorId = resolvedDirectorId;
                const isValidCompanyId = typeof company._id === 'string' && company._id.trim().length > 0;
                let query = isValidCompanyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
                if (directorId) query += `${query ? '&' : '?'}directorId=${encodeURIComponent(directorId)}`;
                const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${encodeURIComponent(moduleName)}${query}`);
                if (res?.code === 200 && res?.body) {
                    setTempModuleFetched(res.body);
                    dispatch((0, $12074930bd2c1829$export$65113a50fb519714)({
                        ...res.body,
                        moduleSlug: res.body.moduleSlug || moduleSlug,
                        moduleName: res.body.moduleName || moduleSlug,
                        companyId: company._id
                    }));
                } else if (!moduleFromCompany) setTempModuleFetched(null);
            } catch (_) {
                if (!moduleFromCompany) setTempModuleFetched(null);
            }
        };
        fetchTempModuleForWorkflowReport();
    }, [
        company?._id,
        company?.testType,
        tab,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!module) setTab(tab);
        if (tab && tab.includes('directors-questionnaire')) {
            if (module?.stats?.completionPercent >= 90 && module?.stats?.riskPercent <= 50) setDirectorCertification('Gold');
            else if (module?.stats?.completionPercent >= 75 && module?.stats?.riskPercent <= 50) setDirectorCertification('Silver');
            else setDirectorCertification('None');
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array
        const hasNoKPIs = company?.['kpiCount'] !== undefined ? company['kpiCount'] === 0 : company?.['keyPerformanceIndicators']?.length === 0;
        if (user['role'] == 'Guest' && hasNoKPIs) getCompany();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (module?.['type']) {
            if (![
                `two-minute-test-${company['testType']}`,
                'repository',
                'software-development',
                'esg',
                'warranty-disclosure',
                `business-audit-${company['testType']}`,
                'directors-questionnaire'
            ].includes(module['type'])) setChecklistModule(true);
        }
    }, [
        module
    ]);
    (0, $acw62.useEffect)(()=>{
        document.getElementById("pdfContent").classList.add("a4-pdf", "p3rem");
        let wrapper = document.getElementById("pdf");
        wrapper.innerHTML = "";
        let children = Array.from(document.getElementById("pdfContent").children);
        let i = 0;
        let _pageNumber = 1;
        let page = document.createElement("div");
        page.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        wrapper.appendChild(page); // Append the first page directly
        let usedPageHeight = 96; // Initial height used on the page
        let pageHeight = getHeight(page);
        let footerHeight = 8;
        // Create watermark
        let watermark = document.createElement("img");
        watermark.classList.add("op20", "pa");
        watermark.style.transform = "translate(-50%, -50%) rotate(30deg)";
        watermark.style.top = "50%";
        watermark.style.left = "50%";
        watermark.style.width = "297mm";
        page.appendChild(watermark);
        let section = document.querySelector('#pdfContent .section-break');
        while(children.length && i < 250){
            // Process children for table and other content
            for (let child of children){
                i++;
                // Create footerLogo
                let footer = document.createElement("div");
                footer.classList.add("tac", "fw600", "df", "jcsb", "aife", "pa", "c36", "b10", "l0", "pdfFooterCustom");
                let footerLogo = document.createElement("img");
                footerLogo.src = "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/miniicon-1735284051094.png";
                footerLogo.alt = "miniicon";
                footerLogo.classList.add("h40px", "w40px", "tal");
                // Create trademark
                let trademark = document.createElement("p");
                trademark.innerText = `\xa9 Diligentsia Limited ${new Date().getFullYear()}`;
                trademark.classList.add("tac", "c37", "fs12px", "fw400");
                // Create pageNumber
                let pageNumber = document.createElement("h3");
                pageNumber.innerText = "Page " + _pageNumber;
                pageNumber.classList.add("fw600", "c36", "fs14px");
                // Append footerLogo and trademark to footer
                footer.appendChild(footerLogo);
                footer.appendChild(trademark);
                footer.appendChild(pageNumber);
                let childHeight = getHeight(child);
                // if (usedPageHeight + childHeight + footerHeight > pageHeight) {
                if (usedPageHeight + childHeight + footerHeight > pageHeight || child?.className == section?.className) {
                    page.classList.add("df", "fdc");
                    if (i > 1) {
                        _pageNumber++;
                        page = createNewPage(wrapper);
                        page.appendChild(footer);
                    }
                    usedPageHeight = 96;
                }
                page.appendChild(child.cloneNode(true));
                usedPageHeight += childHeight;
            }
            // Remove processed children
            children.splice(0, children.length);
        }
        // Clean up after processing
        wrapper.classList.remove("op0", "pen");
        document.getElementById("pdfContent").classList.remove("a4", "p3rem");
        // Workflow Notes Events
        let pdfInputs = wrapper.querySelectorAll("#pdf input");
        for(let j = 0; j < pdfInputs.length; j++)pdfInputs[j].addEventListener('click', ()=>setIsMarked(!isMarked));
        let pdfTextareas = wrapper.querySelectorAll("#pdf textarea");
        for(let j = 0; j < pdfTextareas.length; j++)pdfTextareas[j].addEventListener('change', (e)=>{
            setAnswerId(e.target.id);
            handleTaskNotes(e);
            setIsSaveNote(true);
        });
        for(let j = 0; j < pdfTextareas.length; j++)pdfTextareas[j].addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            setAnswerId(e.target.id);
            setIsSaveNote(true);
            setTimeout(()=>document.getElementById(e.target.id).scrollIntoView({
                    behavior: "instant"
                }), 100);
            requestAnimationFrame(()=>{
                let textarea = document.getElementById(e.target.id);
                if (textarea) {
                    textarea.focus({
                        preventScroll: true
                    });
                    try {
                        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
                    } catch (error) {
                        console.warn("Selection error:", error);
                    }
                }
            });
        });
        let reportBtn = document.querySelectorAll("#pdf button");
        for(let i = 0; i < reportBtn.length; i++){
            if (reportBtn[i]['id'] == 'status-value') reportBtn[i].addEventListener('click', (e)=>saveTaskStatus(e));
            if (reportBtn[i]['id'] == 'status-dropdown') reportBtn[i].addEventListener('click', (e)=>{
                setAnswerId(e.target.value);
                setPriorityDropdown(false);
                setStatusDropdown(!statusDropdown);
                document.getElementById(e.target.value).scrollIntoView({
                    behavior: "instant"
                });
            });
            if (reportBtn[i]['id'] == 'priority-value') reportBtn[i].addEventListener('click', (e)=>saveTaskPriority(e));
            if (reportBtn[i]['id'] == 'priority-dropdown') reportBtn[i].addEventListener('click', (e)=>{
                setAnswerId(e.target.value);
                setStatusDropdown(false);
                setPriorityDropdown(!priorityDropdown);
                document.getElementById(e.target.value).scrollIntoView({
                    behavior: "instant"
                });
            });
            if (reportBtn[i]['id'] == 'save-notes') reportBtn[i].addEventListener('click', (e)=>saveTaskNotes(e));
            if (reportBtn[i]['id'] == 'delete-note') reportBtn[i].addEventListener('click', (e)=>{
                if (e.target.id) {
                    answerId = e.target.id.split('+')[0];
                    noteId = e.target.id.split('+')[1];
                    setNoteId(noteId);
                    setAnswerId(answerId);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: "deleteNotePopup"
                    }));
                }
            });
            if (reportBtn[i]['id'] == 'edit-note') reportBtn[i].addEventListener('click', (e)=>{
                if (e.target.id) {
                    answerId = e.target.id.split('+')[0];
                    noteId = e.target.id.split('+')[1];
                    editNote = e.target.id.split('+')[2];
                    setNoteId(noteId);
                    setEditNote(editNote);
                    setAnswerId(answerId);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: "editNotePopup"
                    }));
                }
            });
        }
        document.body.onmousedown = ()=>{
            setTimeout(()=>{
                if (statusDropdown) setStatusDropdown(false);
                if (priorityDropdown) setPriorityDropdown(false);
            }, 500);
        };
    });
    (0, $acw62.useEffect)(()=>{
        if (answerId) setTimeout(()=>{
            let textarea = document.querySelector(`textarea[id="${answerId}"]`);
            if (textarea) {
                textarea.focus({
                    preventScroll: true
                });
                setTimeout(()=>document.getElementById(answerId).scrollIntoView({
                        behavior: "instant"
                    }), 100);
                if (textarea.value && textarea.value.length > 0) try {
                    textarea.setSelectionRange(textarea.value.length, textarea.value.length);
                } catch (error) {
                    console.warn("Selection error (fixed):", error);
                }
                else console.warn("Skipping setSelectionRange because value is empty or undefined");
            } else console.warn("Textarea not found on first render!");
        }, 50);
    }, [
        answerId
    ]);
    (0, $acw62.useEffect)(()=>{
        let pdfTextareas = document.querySelectorAll("#pdf textarea");
        pdfTextareas.forEach((textarea)=>{
            textarea.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                let clickedId = e.target.getAttribute("id");
                if (clickedId) {
                    setAnswerId(clickedId);
                    setIsSaveNote(true);
                }
            });
        });
        return ()=>{
            pdfTextareas.forEach((textarea)=>{
                textarea.removeEventListener('click', ()=>{});
            });
        };
    }, []);
    function createNewPage(wrapper) {
        let newPage = document.createElement("div");
        newPage.classList.add("a4-pdf", "oyh", "bg1", "bsbb", "oh", "pr", "p1-5rem", "shadow", "new-report");
        let header = document.createElement("img");
        header.classList.add("db", "ma", "h1rem");
        titleHeading(newPage);
        // Add additional headers based on the module type
        addHeadersBasedOnModule(newPage);
        wrapper.appendChild(newPage);
        return newPage;
    }
    function addHeadersBasedOnModule(page) {
        if (module?.type?.includes("repository")) repositoryHeaders(page);
        if (module?.type?.includes("warranty-disclosure")) warrantyDisclosureHeaders(page);
        if ([
            "software-development",
            "esg"
        ].includes(module?.type) || checklistModule) riskRecommendationHeaders(page);
        if (module?.type?.includes(`directors-questionnaire_${module?.['director']?.['_id']}`)) directorsQuestionnaireHeaders(page);
    }
    const titleHeading = (page)=>{
        const title = document.createElement("span");
        let div = null;
        let quesAnsHead = null;
        title.classList.add("db", "fw700", "fs1-25rem", "c15", 'ttu');
        if (tab.match(/two-minute-test-.*-report/)) {
            title.classList.add("tal", "w100");
            title.innerText = `2 Minute ${module?.heading} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb0-5rem");
            div.innerText = `${company['cName']}`;
            quesAnsHead = document.createElement("div");
            quesAnsHead.classList.add("w100", "br10px", "p0-5rem", "fs1rem", "bg52", "df", "aic", "c1");
            let leftBar = document.createElement("div");
            leftBar.innerText = "Question";
            leftBar.classList.add("w80", "pl1rem");
            let rightBar = document.createElement("div");
            rightBar.innerText = "Answer";
            rightBar.classList.add("w20");
            quesAnsHead.appendChild(leftBar);
            quesAnsHead.appendChild(rightBar);
            page.appendChild(title);
            page.appendChild(div);
            page.appendChild(quesAnsHead);
            return page;
        } else if (checklistModule) {
            title.classList.add("tac", "mb1-75rem");
            title.innerText = (module?.type || '') + ' Report' + ' - ' + company['cName'];
        } else {
            title.classList.add("tal", "w100");
            title.innerText = `${module?.heading} Report`;
            div = document.createElement("div");
            div.classList.add("db", "fb", "fsi", "fs1rem", "c15", "mb1rem");
            div.innerText = `${company['cName']}`;
            let warpElement = document.createElement('div');
            let warpElement2 = document.createElement('div');
            let logoTag = document.createElement('img');
            logoTag.classList.add("sad");
            logoTag.src = company['logo'];
            logoTag.alt = "companyLogo";
            logoTag.style.maxWidth = "150px";
            logoTag.style.maxHeight = "60px";
            warpElement2.appendChild(title);
            warpElement2.appendChild(div);
            warpElement.classList.add("df", "aic", "jcsb");
            warpElement.appendChild(warpElement2);
            if (company['logo']) warpElement.appendChild(logoTag);
            page.appendChild(warpElement);
            return page;
        }
        page.appendChild(title);
        return page;
    };
    const repositoryHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg52", "c1", "tac", "br10px");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const riskRecommendationHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Risk</h3><h3>Recommendation</h3>";
        page.appendChild(headings);
    };
    const warrantyDisclosureHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Disclosure</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const directorsQuestionnaireHeaders = (page)=>{
        const headings = document.createElement("div");
        headings.classList.add("dg", "gtcr-audit", "fs0-75rem", "bg6", "c1", "tac");
        headings.innerHTML = "<h3>Question</h3><h3>Answer</h3><h3>Text</h3><h3>Files Uploaded</h3>";
        page.appendChild(headings);
    };
    const sortQuestions = (a, b)=>{
        let valueA = a.qNo.split('.')[a.qNo.split('.').length - 1];
        let valueB = b.qNo.split('.')[a.qNo.split('.').length - 1];
        return valueA - valueB;
    };
    const sortLogs = (a, b)=>new Date(b.timestamp) - new Date(a.timestamp);
    const getAuditContent = ()=>{
        const sectionAnswers = answers.filter((a)=>!Object.values(module?.sections).filter((s)=>s.isHidden).find((s)=>a.qNo.includes(s.sectionNo)));
        const logs = sectionAnswers.filter((a)=>a.logs.length).reduce((arr, a)=>[
                ...arr,
                ...a.logs
            ], []).sort(sortLogs);
        return logs.map((log, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 p1rem br5px df my0-5rem",
                children: [
                    log.userId.profilePicture && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "ass ml0-5rem br100 w2rem h2rem",
                        src: log.userId.profilePicture
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem bg3 c1",
                        children: [
                            log.userId.firstName[0],
                            log.userId.lastName[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: log.message
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log.files.map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: file.location,
                                    target: "_blank",
                                    className: "db c3-hover fw600",
                                    children: file.originalname
                                }, idx)),
                            (log.payload.answers || [
                                log.payload
                            ]).map((answer, idx)=>{
                                const question = answer.questionId ? questions.find((q)=>q._id == answer.questionId) : "";
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                                    children: [
                                        question && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: question.qNo
                                                }),
                                                " - ",
                                                question.qDescription
                                            ]
                                        }),
                                        answer.file && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Filename"
                                                }),
                                                ": ",
                                                answer.file.originalname
                                            ]
                                        }),
                                        answer.status && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Changed Status"
                                                }),
                                                ": ",
                                                answer.status
                                            ]
                                        }),
                                        answer.radioOption && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Selected Option"
                                                }),
                                                ": ",
                                                answer.radioOption
                                            ]
                                        }),
                                        answer.comment && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Entered Comment"
                                                }),
                                                ": ",
                                                answer.comment
                                            ]
                                        })
                                    ]
                                });
                            })
                        ]
                    })
                ]
            }, idx));
    };
    const getSyncContent = ()=>{
        const records = module?.sections.flatMap((section)=>section?.questions?.flatMap((question)=>question?.answer?.logs || [])).sort(sortLogs);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                    className: "df jcc aic mb1-3rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                            className: "w2rem mr0-5rem"
                        }),
                        "Google Drive Synchronization Report"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr3 bg6 c1",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Date Synced"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Synced By "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "fs1-5rem p1rem",
                            children: "Files Synced"
                        })
                    ]
                }),
                records.map((record, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg tableRow gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(record['timestamp']).format('lll')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc aic p1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: `${record['userId']['firstName']} ${record['userId']['lastName']}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    record['userId']['email']
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fdc jcc aic p1rem",
                                style: {
                                    textAlign: 'left'
                                },
                                children: record['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        href: file['location'],
                                        target: "'_blank",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "File"
                                            }),
                                            ": ",
                                            file['originalname']
                                        ]
                                    }, idx))
                            })
                        ]
                    }, idx))
            ]
        });
    };
    const getOverviewContent = ()=>{
        let array = [];
        if (module && module?.['type'] && [
            'warranty-disclosure',
            'directors-questionnaire',
            'software-development',
            'esg'
        ].includes(module['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections.filter((s)=>!s.isHidden);
        const moduleCompleteness = (0, $1c519f43076178a7$export$8ec8d478e850e2c9)(module?.stats);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "minh100vh 100vh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dg gtcr2a gg2rem bg5 pt1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "px2-5rem py2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1-5rem fw600 lh3 c36",
                                    children: "Workflow Completeness Report"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem ttc fw300 lh2 c36 mb3rem",
                                    children: module?.['type'] ? module['type'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw300 lh1 c36",
                                    children: "Company Name:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw500 lh5 c36 mb0-5rem",
                                    children: company?.['cName'] ? company['cName'] : '-'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw300 lh1 c36",
                                    children: "Test Type:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem ttc fw500 lh5 c36 mb0-5rem",
                                    children: [
                                        "Sell/",
                                        company['testType']
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "px2-5rem py2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jce",
                                    children: company?.['logo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w70px mb2rem",
                                        src: company['logo'],
                                        alt: "img"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem fw300 lh4 c36 tae",
                                    children: [
                                        "Subscription: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: (user['role'] == 'Advisor' || user['role'] == 'Investor') && company['subscription'] == 'Pro' ? 'Portfolio PRO' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: company['subscription']?.toUpperCase()
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem ttc fw300 lh4 c36 tae",
                                    children: [
                                        "Company Reg: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fw500",
                                            children: [
                                                company?.['ukRegNo'] ? company['ukRegNo'] : '-',
                                                " "
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs0-75rem ttc fw300 lh4 c36 tae",
                                    children: [
                                        "Issue Date: ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fw500",
                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format('ll')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw300 lh4 c36 tae",
                                    children: "Generated By:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs0-75rem fw500 lh2 c36 tae",
                                    children: user['email']
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "dg gg1rem minh100vh-report",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "report-start",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dg gtcr2a gg2rem px2rem py3rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "director-review",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs1rem fw600 lh1 c36 mb3-5rem",
                                                children: "Current Workflow Status"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs1rem fw500 c36 tas w100 lh1",
                                                        children: "Director Review:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fww aifs",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "checkobox-report pr mr0-5rem mt0-5rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    style: {
                                                                        width: '25px',
                                                                        height: '25px'
                                                                    },
                                                                    name: "status",
                                                                    defaultChecked: isMarked,
                                                                    className: "checkbox shadow df bg5 bo5 bw2px bss cp td250 br5px",
                                                                    type: "checkbox"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fs0-75rem c12 lh1 w80",
                                                                children: isMarked ? 'Marked as completed by' : 'Mark as complete'
                                                            }),
                                                            isMarked ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fdc aifs ml1-5rem",
                                                                style: {
                                                                    marginTop: '-8px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df fww",
                                                                    children: [
                                                                        user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: user?.['profile'],
                                                                            className: `w2rem h2rem df jcc aic br100`,
                                                                            "data-tooltip": user['firstName'] ? user['firstName'] + " " + user?.['lastName'] : "Register to show your name here"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: `w2rem h2rem df jcc aic br100`,
                                                                            "data-tooltip": user?.['firstName'] ? user['firstName'] + " " + user?.['lastName'] : "Register to show your name here",
                                                                            children: user?.['firstName'] ? user['firstName'][0] + user?.['lastName']?.[0] : "?"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df fww",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c36 fs0-75rem fw500 tal ml0-5rem w100",
                                                                                    children: user?.['firstName'] ? user['firstName'] + " " + user?.['lastName'] : "?"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "c36 fs0-5rem fw400 tal ml0-5rem w100",
                                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))().format('ll')
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs0-5rem c4 fw400 ml2rem",
                                                                style: {
                                                                    marginTop: '-8px'
                                                                },
                                                                children: "Only authorized reviewer can mark complete"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df jce mb2-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "tae mr0-5rem fs1rem c36 fw500 lh1",
                                                        children: [
                                                            "Checklist ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " Completeness"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `progress-bar workflow-report-progress ${moduleCompleteness > 75 ? 'workflow-progress-green' : moduleCompleteness > 26 ? 'workflow-progress-yellow' : ' workflow-progress-pink'}`,
                                                        style: {
                                                            width: 65,
                                                            height: 65,
                                                            backgroundColor: '#fda9a4',
                                                            borderRadius: '50%',
                                                            margin: 0,
                                                            border: '2px solid #F1F1F1'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                            text: moduleCompleteness + "%",
                                                            styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                                strokeWidth: '0',
                                                                textSize: '20px',
                                                                trailColor: '#FBFBFB',
                                                                stroke: 'transparent',
                                                                strokeLinecap: 'butt',
                                                                pathTransitionDuration: 0.5,
                                                                backgroundColor: '#FBFBFB',
                                                                dominantBaseline: 'ideographic'
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem fw500 lh4 c6 tae",
                                                children: "Last Updated:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem fw300 lh4 c6 tae",
                                                children: module && module?.['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(module?.['createdAt']).format('lll') : 'Nothing updated'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h60vh oscy",
                                children: array && array.length > 0 && array.sort(sortSections).map((section, idx)=>{
                                    let completeness = (0, $1c519f43076178a7$export$8ec8d478e850e2c9)(section?.stats);
                                    let hexColour = completeness > 75 ? '#d8fcc7' : completeness > 26 ? '#fff4c9' : completeness > 1 ? '#ffcecc' : '#dbdbdb';
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "px2rem ",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            style: {
                                                height: '40px'
                                            },
                                            "data-tooltip": completeness ? `This section has ${completeness}% workflow completeness` : '',
                                            "data-scroll-to": section.sectionNo,
                                            className: "df c3 c6 bg5 td250 c3-hover px1rem py0-5rem cp new-report-btn",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pen usn ass mt0-5rem tal left-heading",
                                                    children: section['sectionNo']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        background: `linear-gradient(90deg, ${hexColour} 0%, ${hexColour} ${completeness}%, #f0f0f8 ${completeness}%)`,
                                                        width: '70%',
                                                        height: '40px',
                                                        paddingTop: '10px',
                                                        marginLeft: 0,
                                                        paddingLeft: '25px'
                                                    },
                                                    className: "pen uss ass fw600 tal pt1rem br5px right-detail",
                                                    children: section.sectionName
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `progress-bar workflow-report-progress pa ${completeness > 75 ? 'workflow-progress-green' : completeness > 26 ? 'workflow-progress-yellow' : completeness > 1 ? ' workflow-progress-pink' : ' workflow-progress-grey'}`,
                                                    style: {
                                                        width: 40,
                                                        height: 40,
                                                        backgroundColor: '#fda9a4',
                                                        borderRadius: '50%',
                                                        right: '3px',
                                                        margin: 0
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                        text: (completeness || 0) + "%",
                                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                            strokeLinecap: 'round',
                                                            strokeWidth: '5px',
                                                            textSize: '25px',
                                                            pathTransitionDuration: 0.5,
                                                            trailColor: '#d6d6d6',
                                                            backgroundColor: '#fc7785',
                                                            dominantBaseline: 'ideographic'
                                                        })
                                                    })
                                                })
                                            ]
                                        }, idx)
                                    });
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    const handleTaskNotes = (e)=>{
        let obj = {
            note: e.target.value
        };
        setTaskNotes((prevNotes)=>[
                ...prevNotes,
                obj
            ]); // Immutable update
    };
    const saveTaskNotes = async ()=>{
        let array = taskNotes.filter((item)=>item.note.trim() !== ""); // ensure no empty notes
        if (array.length === 0) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Cannot save an empty note!");
            return;
        }
        setIsLoader({
            show: true,
            message: 'Updating...'
        });
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            taskNotes: array,
            companyId: company['_id'],
            moduleName: module['type']
        });
        if (res['code'] == 200) {
            await handleUpdateWorkflow(res['body']);
            setAddTextarea(1);
            setTaskNotes([]); // clear notes after saving
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (taskNotes.length > 0 && isSaveNote) {
            saveTaskNotes();
            setIsSaveNote(false);
        }
    }, [
        taskNotes
    ]);
    const saveTaskStatus = async (e)=>{
        setStatusDropdown(false);
        setIsLoader({
            show: true,
            message: 'Updating...'
        });
        setTimeout(async ()=>{
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
                taskStatus: e.target.value,
                companyId: company['_id'],
                moduleName: module['type']
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
            if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
        }, 1000);
    };
    const saveTaskPriority = async (e)=>{
        setPriorityDropdown(false);
        setIsLoader({
            show: true,
            message: 'Updating...'
        });
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            taskPriority: e.target.value,
            companyId: company['_id'],
            moduleName: module['type']
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
    };
    const handleUpdateWorkflow = async (updatedAnswer)=>{
        if (answerId) setTimeout(()=>document.getElementById(answerId).scrollIntoView(), 100);
        let { sectionId: sectionId } = updatedAnswer;
        if (module['sections']) {
            for (let section of module['sections'])if (section['_id'] == sectionId) {
                let questionIndex = section['questions'].findIndex(({ _id: _id })=>_id == updatedAnswer['questionId']);
                let questions1 = Object.assign([], section['questions'], {
                    [questionIndex]: {
                        ...section['questions'][questionIndex],
                        ['answer']: updatedAnswer
                    }
                });
                let sectionIndex = module['sections'].findIndex(({ _id: _id })=>_id == sectionId);
                let sections = Object.assign([], module['sections'], {
                    [sectionIndex]: {
                        ...section,
                        questions: questions1
                    }
                });
                company = {
                    ...company,
                    modules: {
                        ...company['modules'],
                        [module['type']]: {
                            ...company['modules'][module['type']],
                            sections: sections
                        }
                    }
                };
                setAnswerId('');
                let companyClone = await calculateStats(company);
                dispatch(setCompany(companyClone));
            }
        }
        setIsLoader({
            show: false,
            message: 'Loading...'
        });
    };
    const handleDeleteNote = async ()=>{
        if (noteId != '' && answerId != '') {
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/deleteTaskNote/${answerId}/${noteId}`);
            if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
            setNoteId('');
            setTimeout(()=>document.getElementById(answerId).scrollIntoView(), 100);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        }
    };
    const handleEditNote = async ()=>{
        if (noteId != '' && answerId != '') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/updateTaskNote/${answerId}/${noteId}`, {
                note: editNote
            });
            if (res['code'] == 200) await handleUpdateWorkflow(res['body']);
            setNoteId('');
            setEditNote('');
            setTimeout(()=>document.getElementById(answerId).scrollIntoView(), 100);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message']);
        }
    };
    const sortByDate = (a, b)=>{
        return new Date(b.updatedAt) - new Date(a.updatedAt);
    };
    const getAuditReportContent = ()=>{
        if (!module) return null;
        let array = [];
        if (module && module?.['type'] && [
            'warranty-disclosure',
            'directors-questionnaire',
            'software-development',
            'esg'
        ].includes(module['type'])) {
            if (module?.sections[0]?.subFolders && Object.values(module?.sections[0]?.subFolders).length > 0) array = Object.values(module.sections[0].subFolders).filter((s)=>!s.isHidden);
        } else array = module?.sections?.filter((s)=>!s.isHidden);
        array = array && array.slice().sort(sortSections) || [];
        let checklistModule = false;
        if (module?.['type'] != "repository" && module?.['type'] != "software-development" && module?.['type'] != "esg" && module?.['type'] != "warranty-disclosure" && module?.['type'] != `business-audit-${company['testType']}` && !module?.['type']?.includes("directors-questionnaire")) checklistModule = true;
        sectionRefs.current.length = array && array.length || 0;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: array && array.length > 0 && array.map((section, index)=>{
                if (!section) return null;
                const completionPercent = (0, $1c519f43076178a7$export$8ec8d478e850e2c9)(section?.stats);
                const riskPercent = section?.stats?.riskPercent ?? 0;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "section-break"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt1rem",
                            ref: (el)=>{
                                if (section['sectionNo']) sectionRefs.current[index] = el;
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                className: "df jcc aic tac mb1rem fs1rem",
                                children: [
                                    section['sectionNo'],
                                    " - ",
                                    section['sectionName'],
                                    " Report \xa0-\xa0",
                                    completionPercent > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: completionPercent < 34 ? "c9" : completionPercent < 67 ? 'c8' : 'c7',
                                                children: [
                                                    "Completed ",
                                                    completionPercent,
                                                    "%"
                                                ]
                                            }),
                                            riskPercent > 0 && module['type'] != "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: riskPercent < 38 ? "c7" : riskPercent < 62 ? 'c8' : 'c9',
                                                        children: [
                                                            riskPercent || 0,
                                                            "% Risk"
                                                        ]
                                                    }),
                                                    " "
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c12",
                                                children: "Not Started"
                                            }),
                                            module['type'] != "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    " \xa0-\xa0 ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c12",
                                                        children: "No Risk Score"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        section?.questions && section?.questions.slice().sort(sortQuestions).filter((q)=>q.answer).map((question, idx)=>{
                            if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                            let isRisky = question.answer.radioOption === "No";
                            let statusColor, priorityColor;
                            if (question?.['answer']?.['taskStatus'] == 'N/A') statusColor = 'grey-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Not Started') statusColor = 'sky-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Started') statusColor = 'blue-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'In Progress') statusColor = 'yellow-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Completed - Further Work') statusColor = 'orange-bg';
                            else if (question?.['answer']?.['taskStatus'] == 'Completed - No Issues') statusColor = 'green-bg';
                            else statusColor = '';
                            if (question?.['answer']['taskPriority'] == 'N/A') priorityColor = 'grey-bg';
                            else if (question?.['answer']['taskPriority'] == 'High Priority') priorityColor = 'red-bg';
                            else if (question?.['answer']['taskPriority'] == 'Medium Priority') priorityColor = 'orange-bg';
                            else if (question?.['answer']['taskPriority'] == 'Low Priority') priorityColor = 'yellow-bg';
                            else priorityColor = '';
                            let notes = [];
                            if (question?.['answer']?.['taskNotes']) notes = question?.['answer']?.['taskNotes'].slice().sort(sortByDate);
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `dg tableRow fs0-75rem ${[
                                        "repository",
                                        "directors-questionnaire"
                                    ].includes(module?.['type']) ? 'gtcr-audit' : 'gtcr-audit-workflow'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc aic jcfs pt0-25rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fw600",
                                                        children: [
                                                            question['qNo'],
                                                            ":"
                                                        ]
                                                    }),
                                                    " ",
                                                    question?.['qDescription']
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes("directors-questionnaire") ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc aic tac jcfs pt1rem br5px",
                                            children: question?.questionType.includes("YN") ? question.answer['radioOption'] || question.answer['status'] : "-"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `df fdc aic tac jcfs pt1rem br5px`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `${[
                                                    "Disclosure",
                                                    "No Disclosure"
                                                ].includes(question?.answer?.['radioOption']) ? ' px0-5rem ' : ' px1rem '} py0-5rem br10px c1 ${(question?.answer?.['radioOption'] || question?.answer?.['status'])?.includes('Yes') ? ' bg34' : (question?.answer?.['radioOption'] || question?.answer?.['status'])?.includes('No') ? ' bg4' : ' bg16'}`,
                                                children: question.answer['radioOption'] || question.answer['status'] || '-'
                                            })
                                        }),
                                        module?.['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem br5px",
                                                    children: question?.answer?.files?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "File"
                                                                    }),
                                                                    ": ",
                                                                    file['originalname']
                                                                ]
                                                            }, idx))
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "No Files Uploaded"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem br5px",
                                                    children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: question['answer']['comment']
                                                    })
                                                })
                                            ]
                                        }),
                                        checklistModule && question?.['answer']?.['radioOption'] != 'N/A' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                id: question?.['answer']['_id'],
                                                className: "df fdc tal jcs pt0-5rem mx0-5rem",
                                                children: [
                                                    question?.['answer']?.['radioOption'] != 'Yes' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df pb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['riskDescription'] || question?.['ifNo']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "w50 tac px0-5rem",
                                                                children: question?.['recommendDescription'] || question?.['toptip'] || question.answer.radioOption == "Yes" && question?.['ifYes']
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "w90 p1rem my0-5rem",
                                                        style: {
                                                            background: '#e1e1f155'
                                                        },
                                                        children: [
                                                            "Files:",
                                                            question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 ? question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: "ml0-5rem tdu",
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: file['originalname']
                                                                }, idx)) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "ml0-5rem fs0-75rem fw500",
                                                                children: "No files uploaded"
                                                            })
                                                        ]
                                                    }),
                                                    question?.['answer'] && question?.['answer']?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "mb1rem py0-5rem px0-5rem df aic jcsb br5px",
                                                                style: {
                                                                    background: '#e1e1f155'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        children: "Workflow Notes:"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "right-area-details df aic",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "priority-dropdown",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        id: "priority-dropdown",
                                                                                        value: question?.['answer']['_id'],
                                                                                        "data-tooltip": "Priority",
                                                                                        className: `dropdown-btn px1rem fs0-75rem mr0-5rem c36 bg35 cp br20px pr bss bw1px bo36 ${question?.['answer']['taskPriority'] && priorityColor}`,
                                                                                        children: question?.['answer']['taskPriority'] || 'Priority'
                                                                                    }),
                                                                                    answerId == question?.['answer']['_id'] && priorityDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                                                        className: "dropdown-content cp new-shadow fww",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp first-item red-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "High Priority",
                                                                                                    children: "High Priority"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp orange-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "Medium Priority",
                                                                                                    children: "Medium Priority"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp yellow-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "Low Priority",
                                                                                                    children: "Low Priority"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp last-item grey-bg ",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "w100 cp fs0-75rem",
                                                                                                    id: "priority-value",
                                                                                                    value: "N/A",
                                                                                                    children: "N/A"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "status-dropdown",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                        id: "status-dropdown",
                                                                                        value: question?.['answer']['_id'],
                                                                                        "data-tooltip": "Status",
                                                                                        className: `dropdown-btn px1rem fs0-75rem mr0-5rem c36 bg1 cp br20px pr bss bw1px bo36 ${question?.['answer']['taskStatus'] && statusColor}`,
                                                                                        children: question?.['answer']['taskStatus'] || 'Status'
                                                                                    }),
                                                                                    answerId == question?.['answer']['_id'] && statusDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                                                        className: "dropdown-content cp new-shadow fww",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp first-item grey-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "N/A",
                                                                                                    children: "N/A"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp sky-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Not Started",
                                                                                                    children: "Not Started"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp blue-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Started",
                                                                                                    children: "Started"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp yellow-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "In Progress",
                                                                                                    children: "In Progress"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp orange-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Completed - Further Work",
                                                                                                    children: "Completed - Further Work"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                                                className: "cp last-item green-bg",
                                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                    className: "cp fs0-75rem",
                                                                                                    id: "status-value",
                                                                                                    value: "Completed - No Issues",
                                                                                                    children: "Completed - No Issues"
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "br5px p1rem",
                                                                style: {
                                                                    background: '#e1e1f155'
                                                                },
                                                                children: [
                                                                    question?.['answer']?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "task-notes-scroll mt1rem",
                                                                        children: [
                                                                            ...Array(answerId == question?.['answer']['_id'] ? addTextarea : 1)
                                                                        ].map((x, idx)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df fdc br10px bg1 bss bw2px bo31 p1rem mb0-5rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "icon-textare df",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                            ref: textareaRef,
                                                                                            className: "w100 h100 br5px p0-5rem fs0-75rem",
                                                                                            style: {
                                                                                                backgroundColor: "transparent",
                                                                                                resize: "vertical"
                                                                                            },
                                                                                            placeholder: "Add workflow note",
                                                                                            rows: "1",
                                                                                            cols: "50",
                                                                                            value: answerId == question?.['answer']['_id'] && taskNotes.length > 0 ? taskNotes?.[idx]?.['note'] : '',
                                                                                            id: question?.['answer']['_id'],
                                                                                            onChange: handleTaskNotes,
                                                                                            onFocus: (e)=>e.target.select()
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df jsfs w100 pt0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                            style: {
                                                                                                fontSize: '10px'
                                                                                            },
                                                                                            className: "ml-1rem c12",
                                                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now()).format('lll')
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            });
                                                                        })
                                                                    }),
                                                                    answerId == question?.['answer']['_id'] && isSaveNote && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df jcc",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                            id: "save-notes",
                                                                            value: question?.['answer']['_id'],
                                                                            className: `dropdown-btn bg4 fs0-75rem mt0-5rem c1 cp br5px px1rem pr bss bw1px bo4`,
                                                                            children: addTextarea > 1 ? 'Save Notes' : 'Save Note'
                                                                        })
                                                                    }),
                                                                    notes && notes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "task-notes-scroll",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fs0-75rem fw500 c36",
                                                                                children: "Notes:"
                                                                            }),
                                                                            notes.map((item)=>{
                                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "notes-details mt0-5rem bssb px0-5rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "df jcsb aic mb1rem",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                    className: "w80 notes-left-area df aic",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                            className: "notes-img mr0-5rem",
                                                                                                            children: item?.['user']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                                src: item?.['user']?.['profile'],
                                                                                                                className: `w2rem h2rem df jcc aic br100`,
                                                                                                                "data-tooltip": item?.['user']['firstName'] ? item?.['user']['firstName'] + " " + item?.['user']?.['lastName'] : "Register to show your name here"
                                                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: `new-shadow w2rem h2rem df jcc aic br100`,
                                                                                                                "data-tooltip": item?.['user']['firstName'] ? item?.['user']['firstName'] + " " + item?.['user']?.['lastName'] : "Register to show your name here",
                                                                                                                children: item?.['user']['firstName'] ? item?.['user']['firstName'][0] + item?.['user']?.['lastName']?.[0] : "?"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                            className: "notes-text",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                                                                                    className: "fs0-5rem c36",
                                                                                                                    style: {
                                                                                                                        fontSize: '10px'
                                                                                                                    },
                                                                                                                    children: [
                                                                                                                        item?.['user']['firstName'] ? item?.['user']['firstName'] + " " + item?.['user']?.['lastName'] : 'Guest User',
                                                                                                                        ": ",
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                            className: "fw300 c37",
                                                                                                                            children: item['note']
                                                                                                                        })
                                                                                                                    ]
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                                    className: "mr1rem fs0-5rem",
                                                                                                                    color: "#4C6B9270",
                                                                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(item['createdAt']).format('lll')
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                item['user']['_id'] == user['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                    className: "w20 notes-left-area df jcc aic",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                            className: "cp c4",
                                                                                                            style: {
                                                                                                                background: 'transparent'
                                                                                                            },
                                                                                                            id: "delete-note",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                id: question?.['answer']['_id'] + '+' + item['_id'],
                                                                                                                "data-tooltip": "Delete Note",
                                                                                                                className: "fa fa-trash",
                                                                                                                "aria-hidden": "true"
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                                                            className: "cp c36",
                                                                                                            style: {
                                                                                                                background: 'transparent'
                                                                                                            },
                                                                                                            id: "edit-note",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                                id: question?.['answer']['_id'] + '+' + item['_id'] + '+' + item['note'],
                                                                                                                "data-tooltip": "Edit Note",
                                                                                                                className: "fa fa-pencil",
                                                                                                                "aria-hidden": "true"
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                });
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        module?.['type'].includes("directors-questionnaire") && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question?.questionType.includes("Date") ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.answer && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(question?.answer?.date).format('ll')
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: question['answer'] ? question['answer']['comment'] || question['answer']['dropdown'] : '-'
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc aic tac jcfs pt1rem",
                                                    children: question.answer.files.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "File"
                                                                    }),
                                                                    ": ",
                                                                    file['originalname']
                                                                ]
                                                            }, idx))
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "-"
                                                    })
                                                })
                                            ]
                                        }),
                                        module?.['type'].includes(`business-audit-${company['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fdc tal jcfs pt0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df  pb0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w50 tac px0-5rem",
                                                        children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                question?.['answer']?.['aiResponse']?.['ifriskDescription'] && question?.['answer']?.['aiResponse']?.['ifriskDescription'],
                                                                question['riskDescription'] && question['riskDescription']
                                                            ]
                                                        }) : "Well done"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w50 tac px0-5rem",
                                                        children: isRisky ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] && question?.['answer']?.['aiResponse']?.['ifrecommendDescription'],
                                                                question['recommendDescription'] && question['recommendDescription']
                                                            ]
                                                        }) : "No recommendation at this time"
                                                    })
                                                ]
                                            })
                                        }),
                                        [
                                            "warranty-disclosure",
                                            "software-development",
                                            "esg"
                                        ].includes(module?.['type']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc tal jcfs pt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df pb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' && question['answer']['radioOption'] == 'Disclosure' ? question?.['answer']?.['comment'] && question?.['answer']?.['comment'] : module?.['type'] == 'warranty-disclosure' ? '-' : question?.['answer']?.['aiResponse']?.['ifrecommendDescription'] || question['recommendDescription']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w50 tac px0-5rem",
                                                            children: module?.['type'] == 'warranty-disclosure' ? question?.['answer']?.['files'] && question['answer']['files'].map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                    href: file['location'],
                                                                    target: "'_blank",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                            children: "File"
                                                                        }),
                                                                        ": ",
                                                                        file['originalname']
                                                                    ]
                                                                }, idx)) : question?.['answer']?.['aiResponse']?.['ifriskDescription'] || question['riskDescription']
                                                        })
                                                    ]
                                                }),
                                                [
                                                    "software-development",
                                                    "esg"
                                                ].includes(module?.['type']) && question?.['answer']?.['files'] && question?.['answer']?.['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "w90 p1rem my0-5rem",
                                                    style: {
                                                        background: '#e1e1f155'
                                                    },
                                                    children: [
                                                        "Files: ",
                                                        question['answer']['files'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                className: "ml0-5rem tdu",
                                                                href: file['location'],
                                                                target: "'_blank",
                                                                children: file['originalname']
                                                            }))
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            });
                        })
                    ]
                });
            })
        });
    };
    const getTwoMinuteTestContent = ()=>{
        const writeSections = (sections)=>Object.values(sections).filter((s)=>!s.isHidden).map((section, index)=>{
                const questionsAndAnswers = section?.questions?.slice().sort(sortQuestions).filter((q)=>q?.answer?.radioOption);
                if (questionsAndAnswers && questionsAndAnswers.length) sectionRefs.current.length = questionsAndAnswers.length;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: questionsAndAnswers.map((question, idx)=>{
                        const { answer: answer } = question;
                        if (!aiEnhanced && Object.values(answer?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                    id: section.sectionNo,
                                    ref: (el)=>{
                                        if (section['sectionNo']) sectionRefs.current[index] = el;
                                    },
                                    className: "usn pen fs1rem fw600 mt-3 tac",
                                    children: [
                                        section.sectionNo,
                                        " - ",
                                        section.sectionName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "question-box  c1",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                children: [
                                                    "Question: ",
                                                    question['qNo']
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: question['qDescription']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: "Answer:"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: `${question['answer']['radioOption'] == 'Yes' || question['answer']['radioOption'] < 3 ? 'green' : 'red'} c4`,
                                                    children: question['answer']['radioOption']
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "recomended-box",
                                    children: (()=>{
                                        const recommendationKey = [
                                            "ifYes",
                                            "ifNo",
                                            "",
                                            "if1",
                                            "if2",
                                            "if3",
                                            "if4",
                                            "if5"
                                        ].find((key)=>key.includes("if" + answer.radioOption));
                                        return recommendationKey && question[recommendationKey] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Recommendation:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs1rem",
                                                    children: answer?.['aiResponse']?.[recommendationKey] || question[recommendationKey]
                                                })
                                            ]
                                        });
                                    })()
                                })
                            ]
                        }, idx);
                    })
                });
            });
        return writeSections(module?.sections);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: company && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                    id: "pdf",
                    className: "op0 pen ma td250 dg gg2rem"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "hideOnDownload mt2rem aic df",
                    children: [
                        !user.firstName && tab == 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df jcc aic fdc ",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1-25rem mb1rem tac",
                                    children: "Now let's view your 2-minute test report..."
                                }),
                                user['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>twoMinuteTestAIReport(module),
                                        className: "shadow bsbb jcc w200px w9rem df fdc aic fw500  px1rem c1 bg4 br19px cp registerButtonAnimation",
                                        style: {
                                            width: '25%',
                                            paddingTop: '7px',
                                            paddingBottom: '7px'
                                        },
                                        children: "View 2-Minute Test Report"
                                    })
                                })
                            ]
                        }),
                        tab.match(/two-minute-test-.*-report/) && user?.['role'] == 'Guest' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc aic",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: `/company/${company['_id']}`,
                                style: {
                                    width: '15%',
                                    paddingTop: '7px',
                                    paddingBottom: '7px'
                                },
                                className: `shadow bsbb jcc df fdc aic fw500 my1rem px1rem c1 bg4 br19px cp registerButtonAnimation`,
                                children: "Next"
                            })
                        }),
                        module && module?.['type'] == "repository" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc aic w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setTab(""),
                                className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "Dashboard"
                            })
                        }),
                        module && module?.['type'].includes(`business-audit-${company?.['testType']}`) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(module['type']),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Business Audit"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>setTab(""),
                                    className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Dashboard"
                                })
                            ]
                        }),
                        module && module?.['type'] == "warranty-disclosure" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc aic w100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setTab(""),
                                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "Dashboard"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("table", {
                    id: "pdfContent",
                    className: "bsbb w0 h0 oh op0 pen db",
                    style: {
                        width: 0,
                        height: 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            getOverviewContent(),
                            [
                                'repository-report',
                                `business-audit-${company?.['testType']}-report`,
                                'warranty-disclosure-report',
                                'software-development-report',
                                'esg-report',
                                `directors-questionnaire_${module?.['director']?.['_id']}`
                            ].includes(tab) ? getAuditReportContent() : tab.includes("repository-sync-report") ? getSyncContent() : tab.includes("repository-audit-report") ? getAuditContent() : tab.match(/two-minute-test-.*-report/) ? getTwoMinuteTestContent() : getAuditReportContent()
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    id: "deleteNotePopup",
                    open: modal['open'] === 'deleteNotePopup',
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                                children: "Confirmation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem c15 fw400 my1rem",
                                children: "Are you sure you want to delete note ?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb gg1rem mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>{
                                            setNoteId(''), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }));
                                        },
                                        className: "shadow bo4 bss bg1 bg4-hover c4 c1-hover td250 br5px p1rem fw600 cp w30 ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>handleDeleteNote(),
                                        className: "shadow bg3 bo3 bss bo4-hover bg4-hover c1 td250 br5px p1rem fw600 w50 cp ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Confirm"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    id: "editNotePopup",
                    open: modal['open'] === 'editNotePopup',
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                                children: "Edit Note"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                className: "h100 bss bw2px bo16 w100 br5px px1-5rem py1rem fs1rem mb1rem",
                                style: {
                                    backgroundColor: "transparent",
                                    resize: "vertical"
                                },
                                placeholder: "Add workflow note",
                                rows: "2",
                                cols: "50",
                                defaultValue: editNote || '',
                                onChange: (e)=>setEditNote(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb gg1rem mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>{
                                            setNoteId(''), setEditNote(''), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }));
                                        },
                                        className: "shadow bo4 bss bg1 bg4-hover c4 c1-hover td250 br5px p1rem fw600 cp w30 ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        "data-scroll-to": answerId,
                                        onClick: ()=>handleEditNote(),
                                        className: "shadow bg3 bo3 bss bo4-hover bg4-hover c1 td250 br5px p1rem fw600 w50 cp ttu  bsbb tac mb1rem df jcc aic",
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}




































var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




// Tabs carry a `value` and a `label`. The value is the internal id used for hash routing, for the
// `companyDashboardTab == 'x'` render conditions, and by the ~26 setCompanyDashboardTab call sites
// across the app — so renaming a tab is a label-only change and never breaks navigation or old
// bookmarked #hash links.
const $562489718ce8396e$var$tab = (value, label = value)=>({
        value: value,
        label: label
    });
const $562489718ce8396e$export$6fd7b65f3b3a8bd5 = [
    $562489718ce8396e$var$tab('Financial'),
    $562489718ce8396e$var$tab('Technology')
];
const $562489718ce8396e$export$df4c7595e14965d3 = [
    $562489718ce8396e$var$tab('Dashboard', 'Corporate'),
    ...$562489718ce8396e$export$6fd7b65f3b3a8bd5
];
const $562489718ce8396e$export$3f3e67abb67b263a = [
    'Analyser',
    'AnyLists',
    'Workflows',
    'ResearchAid',
    'InvestorMatch',
    'AppStore'
].map((t)=>$562489718ce8396e$var$tab(t));
const $562489718ce8396e$var$PARTNER_VALUES = $562489718ce8396e$export$6fd7b65f3b3a8bd5.map((t)=>t.value);
// The module row belongs to Corporate, so only that tab reveals it on hover.
const $562489718ce8396e$var$HOVER_TAB = 'Dashboard';
const $562489718ce8396e$export$d9a4cca3740decc7 = [
    'Dashboard',
    ...$562489718ce8396e$export$3f3e67abb67b263a.map((t)=>t.value)
];
function $562489718ce8396e$export$2e2bcd8739ae039({ company: company, companyId: companyId, activeTab: activeTab, onTabChange: onTabChange, navigateOnClick: navigateOnClick = false, className: className = '' }) {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const [hoveredTab, setHoveredTab] = (0, $acw62.useState)('');
    // Closing is deferred so the pointer can travel from the Corporate tab down into the module row
    // without the row vanishing en route. Any re-entry cancels the pending close.
    const closeTimer = (0, $acw62.useRef)(null);
    const HOVER_CLOSE_DELAY = 300;
    const cancelClose = ()=>{
        if (closeTimer.current) {
            clearTimeout(closeTimer.current);
            closeTimer.current = null;
        }
    };
    const openRow = (item)=>{
        cancelClose();
        setHoveredTab(item);
    };
    const scheduleClose = ()=>{
        cancelClose();
        closeTimer.current = setTimeout(()=>setHoveredTab(''), HOVER_CLOSE_DELAY);
    };
    (0, $acw62.useEffect)(()=>cancelClose, []);
    if (user?.['type'] === 'Superflow' || user?.['type'] === 'External') return null;
    const isGuest = user?.['role'] === 'Guest';
    const hideInvestorMatch = user?.['role'] === 'Advisor' || user?.['role'] === 'Investor' || company?.['testType'] == "growth" || company?.['testType'] == "exit";
    // The module row is revealed by hovering the Corporate tab, and hidden otherwise.
    const showModuleRow = !!hoveredTab;
    // Same-tab navigation — each partner page carries its own back arrow.
    const openCertifii = ()=>navigate($16250bd714b02a14$export$37575e7e3c62bf69);
    const openVaultinum = ()=>navigate($16250bd714b02a14$export$f8d8776d8b70eb77);
    const handleClick = (item)=>{
        if (item === 'InvestorMatch') {
            if (navigateOnClick) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'investorMatchDisclaimer'
                }));
                return;
            }
            if (activeTab !== item) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'investorMatchDisclaimer'
                }));
                return;
            }
        }
        if (navigateOnClick) navigate(`/company/${companyId}`, {
            state: {
                activeTab: item
            }
        });
        else if (onTabChange) onTabChange(item);
    };
    const renderTab = ({ value: value, label: label }, idx, isPartner = false)=>{
        // Only Corporate opens the module row; every other tab merely holds it open.
        const opensRow = value === $562489718ce8396e$var$HOVER_TAB;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df fdc",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                // Reason: the Corporate tab must stay enabled — a `disabled` button fires no mouse
                // events in most browsers, which would kill the hover that reveals the module row.
                disabled: isGuest,
                className: `fs1-25rem fw500 ${isPartner ? 'c3' : 'c15'}${activeTab === value ? ' active' : ''}`,
                // Financial opens the co-branded Certifii page, Technology the Vaultinum one —
                // both in a new browser tab.
                onClick: isPartner ? value === 'Financial' ? openCertifii : openVaultinum : ()=>handleClick(value),
                // Corporate opens the row; module tabs only hold it open — clearing it there is what
                // would make the row vanish the moment the pointer reached a module tab. Partner tabs
                // close it, since the row is not theirs. Focus mirrors hover.
                onMouseEnter: opensRow ? ()=>openRow(value) : isPartner ? scheduleClose : cancelClose,
                onFocus: opensRow ? ()=>openRow(value) : isPartner ? scheduleClose : cancelClose,
                // Every tab shows the pointer on hover — including the inert partner tabs. Only guests
                // get not-allowed.
                style: {
                    cursor: isGuest ? 'not-allowed' : 'pointer'
                },
                children: label
            })
        }, `company-tab-${value}-${idx}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `company-tabs-wrap ${className}`.trim(),
        onMouseLeave: scheduleClose,
        onMouseEnter: cancelClose,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "cp tabs-navlist tabs-dashboard df aic jcc mt2rem",
                children: $562489718ce8396e$export$df4c7595e14965d3.map((item, idx)=>renderTab(item, idx, $562489718ce8396e$var$PARTNER_VALUES.includes(item.value)))
            }),
            showModuleRow && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "tabs-navlist tabs-dashboard company-tabs-modules df aic jcc",
                onMouseEnter: cancelClose,
                children: $562489718ce8396e$export$3f3e67abb67b263a.map((item, idx)=>{
                    if (hideInvestorMatch && item.value === 'InvestorMatch') return null;
                    return renderTab(item, idx);
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");




var $acw62 = parcelRequire("acw62");








var $lwfqC = parcelRequire("lwfqC");



const $564b3e95a736953b$export$18e55fcebd381b72 = 'insuranceReportGenerationStatus';
const $564b3e95a736953b$export$7a1e5df59fb6157a = 'isAgreeWithAIReportDisclaimer';
const $564b3e95a736953b$export$ab5999610d8bf036 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $564b3e95a736953b$export$b24c36592e86b8f1 = (key, fallbackValue)=>{
    if (!$564b3e95a736953b$export$ab5999610d8bf036()) return fallbackValue;
    try {
        const rawValue = window.localStorage.getItem(key);
        if (!rawValue) return fallbackValue;
        const parsedValue = JSON.parse(rawValue);
        return parsedValue ?? fallbackValue;
    } catch (error) {
        return fallbackValue;
    }
};
const $564b3e95a736953b$export$2ac5f5081b4dba80 = (key, value)=>{
    if (!$564b3e95a736953b$export$ab5999610d8bf036()) return;
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
    // Ignore storage write failures (quota exceeded, private mode, etc.)
    }
};
const $564b3e95a736953b$export$503183a1eef33108 = ()=>{
    const stored = $564b3e95a736953b$export$b24c36592e86b8f1($564b3e95a736953b$export$18e55fcebd381b72, {});
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
        $564b3e95a736953b$export$2ac5f5081b4dba80($564b3e95a736953b$export$18e55fcebd381b72, {});
        return {};
    }
    return stored;
};
const $564b3e95a736953b$export$7a58d99a89e5d398 = ()=>{
    const stored = $564b3e95a736953b$export$b24c36592e86b8f1($564b3e95a736953b$export$7a1e5df59fb6157a, []);
    if (!Array.isArray(stored)) {
        $564b3e95a736953b$export$2ac5f5081b4dba80($564b3e95a736953b$export$7a1e5df59fb6157a, []);
        return [];
    }
    return stored;
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");






























function $25ee15d5fd9a59f0$export$2e2bcd8739ae039({ deleteFile: // Modal-related state
deleteFile, deleteUnallocatedFile: deleteUnallocatedFile, deleteFileLoading: deleteFileLoading, logModule: logModule, isSaving: isSaving, attachment: attachment, additionalSections: additionalSections, isSectionNameDuplicate: isSectionNameDuplicate, isCustomSectionEnabled: isCustomSectionEnabled, newUpgradeSync: newUpgradeSync, confirmDeleteFile: // Modal handlers
confirmDeleteFile, confirmDeleteUnallocatedFile: confirmDeleteUnallocatedFile, moveUnallocatedFile: moveUnallocatedFile, moveDeduperFile: moveDeduperFile, onClickDeduperAuditLog: onClickDeduperAuditLog, onClickUnallocatedBinAuditLog: onClickUnallocatedBinAuditLog, onClickFileReportHistory: onClickFileReportHistory, showDeduperReport: showDeduperReport, onClickDeduperReportHistory: onClickDeduperReportHistory, onSaveAdditionalSections: onSaveAdditionalSections, editSectionName: editSectionName, onEdit: onEdit, onDelete: onDelete, handleToggleSuccessAiReportGeneratedModal: handleToggleSuccessAiReportGeneratedModal, handleAiReportDisclaimerClose: handleAiReportDisclaimerClose, getDeduperReportLogsHTML: getDeduperReportLogsHTML, getFileReportLogsHTML: getFileReportLogsHTML, getUnallocatedBinLogsHTML: getUnallocatedBinLogsHTML, getViewableURL: getViewableURL, handleEditDispatch: handleEditDispatch, handleFileChange: handleFileChange, setDeleteFile: setDeleteFile, setDeleteFileQuestionId: setDeleteFileQuestionId, setDeleteUnallocatedFile: setDeleteUnallocatedFile, setLoading: setLoading, setRefresh: setRefresh, setSection: setSection, syncDrive: syncDrive, syncDropbox: syncDropbox, syncSharePoint: syncSharePoint, openWindow: openWindow, toggleReport: toggleReport, onMoveFile: onMoveFile, modal: // Redux state
modal, user: user, logList: logList, targetSection: targetSection, processing: processing, unallocatedFiles: unallocatedFiles, dupCheck: dupCheck, company: // Parent props
company, companyId: companyId, tab: tab, activeModule: activeModule, permissionLevel: permissionLevel, advisors: advisors, profileClass: profileClass, loading: loading, section: section, reloadModule: reloadModule, reportHistories: reportHistories, setReportHistories: setReportHistories, setFileReport: setFileReport, setCloneImportResult: setCloneImportResult, setCurrentScore: setCurrentScore, fileImportRef: fileImportRef, onRollbackComplete: onRollbackComplete }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f5e4159f4b2fdb7$export$2e2bcd8739ae039), {
                modalType: 'fileReportHistory',
                reportHistories: reportHistories,
                setReportHistories: setReportHistories,
                setFileReport: setFileReport,
                setCloneImportResult: setCloneImportResult,
                setCurrentScore: setCurrentScore,
                company: company,
                profileClass: profileClass,
                onRollbackComplete: onRollbackComplete,
                moduleType: tab,
                moduleId: activeModule?._id || null,
                moduleName: activeModule?.heading || tab
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c13dd2b2ad7b7b79$export$2e2bcd8739ae039), {
                tab: tab,
                modalType: 'disconnectDataRoom',
                companyId: company?.['_id']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40a2fdbd500b75ca$export$2e2bcd8739ae039), {
                modalType: 'unallocatedFiles',
                tab: tab,
                loading: loading,
                setLoading: setLoading,
                company: company,
                setUnallocatedFiles: (0, $e0a7c253e2df808f$export$7f5872b9f0fc6312),
                onClickUnallocatedBinAuditLog: onClickUnallocatedBinAuditLog,
                unallocatedFiles: unallocatedFiles,
                handleEditDispatch: handleEditDispatch,
                moveUnallocatedFile: moveUnallocatedFile,
                setDeleteUnallocatedFile: setDeleteUnallocatedFile,
                targetSection: targetSection
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1047f7c995c3f14f$export$2e2bcd8739ae039), {
                modalType: 'manageFiles',
                reloadModule: reloadModule,
                section: section,
                setSection: setSection,
                company: company,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                setDeleteFileQuestionId: setDeleteFileQuestionId,
                setDeleteFile: setDeleteFile,
                tab: tab,
                targetSection: targetSection,
                onMoveFile: onMoveFile
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $003a88e0f3de542d$export$2e2bcd8739ae039), {
                modalType: 'manageWarrantyDisclosureFiles',
                reloadModule: reloadModule,
                section: section,
                setSection: setSection,
                company: company,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                setDeleteFileQuestionId: setDeleteFileQuestionId,
                setDeleteFile: setDeleteFile,
                tab: tab,
                targetSection: targetSection
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $436c32be0a88c5ca$export$2e2bcd8739ae039), {
                modalType: 'checkingDuplication',
                company: company,
                onClickDeduperAuditLog: onClickDeduperAuditLog
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e893be82a1a3691c$export$2e2bcd8739ae039), {
                modalType: 'duplicationCheckSummary',
                company: company,
                dupCheck: dupCheck,
                modal: modal,
                profileClass: profileClass,
                onClickDeduperAuditLog: onClickDeduperAuditLog,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                setRefresh: setRefresh,
                reloadModule: reloadModule,
                moveDeduperFile: moveDeduperFile,
                tab: tab
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'allocatingFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr oya bg1 shadow w100 pl3rem pr3rem pb5rem pt0rem bsbb df fdc m1rem maw1000px br5px pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "AnimateWiz tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h15rem mla mra",
                                        src: (parcelRequire("hA45b")),
                                        alt: "animWiz"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-5rem-sm w100 tac mb2rem c15",
                                    children: "Performing Filing assistant magic!"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "tac",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c27 mb2rem",
                                            children: "This may take a few seconds"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c27",
                                            children: [
                                                "We're now summoning the power of AI to allocating files to appropriate sections! ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "Please stay with us during this magical incantation."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group 1000002103-1733923364928.png",
                                alt: "messageLadie",
                                className: "girlImage1"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                bottom: '80px',
                                transform: 'translateX(-50%)'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8992acb1fe6a84ae$export$2e2bcd8739ae039), {
                company: company
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20694e2bf2131bd3$export$2e2bcd8739ae039), {
                onEdit: onEdit,
                onDelete: onDelete,
                modalType: 'proaddsection',
                editSectionName: editSectionName,
                additionalSections: additionalSections,
                isSectionNameDuplicate: isSectionNameDuplicate,
                onSaveAdditionalSections: onSaveAdditionalSections
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed66be3561152e3$export$2e2bcd8739ae039), {
                modalType: "deleteFile",
                deleteFile: deleteFile,
                onConfirm: ()=>confirmDeleteFile(modal['from']),
                onCancel: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: modal['from']
                    }))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed66be3561152e3$export$2e2bcd8739ae039), {
                modalType: "deleteUnallocatedFile",
                deleteFile: deleteUnallocatedFile?.file ?? {},
                onConfirm: confirmDeleteUnallocatedFile,
                onCancel: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'unallocatedFiles'
                    }))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4def4a546b6daa3e$export$2e2bcd8739ae039), {
                getViewableURL: getViewableURL,
                profileClass: profileClass,
                modalType: "auditLog",
                logList: logList,
                logModule: logModule,
                tab: tab
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deduperReportAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'duplicationCheckSummary'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttc c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'duplicationCheckSummary'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttc w100 tac mb1rem",
                            children: "See the history of Company Deduper Report"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getDeduperReportLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttc w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'duplicationCheckSummary'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'unallocatedBinAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'unallocatedFiles'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttc c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'unallocatedFiles'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttc w100 tac mb1rem",
                            children: "See the history of Company Unallocated Bin"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getUnallocatedBinLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttc w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'unallocatedFiles'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'fileReportAuditLog',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'importSummary'
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttc c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'importSummary'
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac",
                            children: [
                                company['cName'],
                                " Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttc w100 tac mb1rem",
                            children: "See the history of Company File Import"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: logList.length > 0 ? getFileReportLogsHTML(logList) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-50rem ttc w100 tac mb1rem",
                                children: "No Logs Found!!"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df w100 fdr jcc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'importSummary'
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic",
                                children: "Go Back"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2b7abf4967ef3ad$export$2e2bcd8739ae039), {
                modalType: 'dataRepository',
                dispatch: dispatch,
                company: company,
                user: user
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'repositoryCompleted',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 pb1rem",
                            children: "Congratulations!"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac df fdc jcc aic tac",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "Hello, ",
                                        user.firstName,
                                        "! \uD83C\uDF89"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Look at you, unstoppable force! \uD83D\uDE80 You've made your first pass at filling your Data Repository and have emerged victorious! Now, it's time to step into your next adventure:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Unleash the magic of connectivity! Sync your Repository with your preferred provider Data Room. This will create an unbreakable bond between your treasures, keeping them safe and accessible anytime, anywhere. \uD83C\uDF10"
                                }),
                                company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    className: "shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                    onClick: ()=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                        syncDrive();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                            className: "pen fds w2rem mr1rem"
                                        }),
                                        "\uD83D\uDC49 Sync Now"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Excited to see the fruits of your labor? View your Repository Report and bask in the glory of your progress. Every detail counts in this journey, and you've made a remarkable headway! \uD83D\uDCC8"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: (e)=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                        toggleReport(e);
                                    },
                                    className: "shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                                    children: "\uD83D\uDC49 View Report"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Feeling ready for the next level? It's time to take on the Quick Business Audit questionnaire! Upon its completion, Diligentsia's unaudited certification awaits. This prized possession will symbolize your company's readiness for any challenge ahead. \uD83D\uDCBC"
                                }),
                                (()=>{
                                    const [syncLink, driveName] = company.gDriveLink ? [
                                        company.gDriveLink,
                                        "Google Drive"
                                    ] : company.sharePointLink ? [
                                        company.sharePointLink,
                                        "SharePoint"
                                    ] : company.dropBoxLink ? [
                                        company.dropBoxLink,
                                        "DropBox"
                                    ] : [
                                        undefined,
                                        "Not Connected"
                                    ];
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df my1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: `${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`,
                                                        onClick: ()=>syncDrive(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 Sync Data room"
                                                        ]
                                                    }),
                                                    company['folderId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100",
                                                        onClick: ()=>openWindow(`https://drive.google.com/drive/folders/${company['folderId']}`),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 View Data Room"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            company.dropBoxLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df my1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: `${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`,
                                                        onClick: ()=>syncDropbox(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 Sync Data room"
                                                        ]
                                                    }),
                                                    company['dropBoxFolderMetadata'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100",
                                                        onClick: ()=>openWindow(`https://dropbox.com/home/${company['dropBoxFolderMetadata']['path_display']}`),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 View Data Room"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            company.sharePointLink && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df my1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: `${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`,
                                                        onClick: ()=>syncSharePoint(),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 Sync Data room"
                                                        ]
                                                    }),
                                                    company['sharePointLink'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        className: "ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100",
                                                        onClick: ()=>openWindow(`${company['sharePointFolderDriveItem']['rootFolder']['webUrl']}`),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                                className: "pen fds w2rem"
                                                            }),
                                                            "\xa0\xa0\xa0 View Data Room"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            syncLink == undefined && tab == 'repository' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: 'connectDataroom'
                                                    })),
                                                className: `${!company['uploadedFile'] && 'op20 pen '} my1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`,
                                                children: "Connect Data Room"
                                            })
                                        ]
                                    });
                                })(),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "Remember, every adventure you undertake strengthens your fortress, builds your credibility, and takes your business one step closer to greatness. Keep conquering, ",
                                        user['firstName'],
                                        "! \uD83D\uDC4D"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'createdDataRoom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb0-5rem",
                                children: [
                                    "Good news!  Your Cloud Data",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Room has now been created.",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "You can now sync.\u200B"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttc bsbb df jcc",
                                onClick: ()=>{
                                    window.location.href = `/company/${companyId}#repository`;
                                },
                                children: "Let's go!\u200B"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "addingApplicantManual",
                open: modal['open'] == 'addingApplicantManual',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w100 df fdc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "my1rem",
                                        src: (parcelRequire("iGe5G")),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "c15 fs1-25rem fw500 my1rem",
                                        children: "Thank you for adding this applicant"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "c15 fs1rem fw300",
                                        children: "Your new applicant has been added and is ready for review."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        class: "c15 fs1rem fw300",
                                        children: "Return to InvestorMatch to see the company and its newly generated reports."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df jcc my3rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/investor-dashboard#index?QualifiedLeads",
                                    onClick: ()=>localStorage.removeItem('isManualAdd'),
                                    className: "df jcc cp px3rem py0-5rem c1 bg4 bg3-hover br35px fw400 fs1rem",
                                    children: "Return to InvestorMatch"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9689410d708ead36$export$2e2bcd8739ae039), {
                modalType: 'DisclaimerAIReportModal',
                handleClose: handleAiReportDisclaimerClose,
                subTitle: "This report is for guidance only.",
                content: "This Report has been prepared by Diligensia for the exclusive use of the named client. It is based on information provided as at the date of issue and is intended solely to assist in identifying risks and opportunities. This report was generated by AI and may be inaccurate.  You are urged to check all report content. Diligentsia accepts no responsibility or liability for any errors, omissions, or delays, nor for any actions taken in reliance on this report. The contents do not constitute legal or financial advice, and professional advice should always be sought. This report may not be relied upon by any third party to whom the report is shown and Diligensia accepts no duty of care or liability to any third party who may obtain access to it."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'successAiReportGenerated',
                customStyle: {
                    padding: '0px 0rem 2rem',
                    maxWidth: '500px !important'
                },
                onCloseHandler: ()=>handleToggleSuccessAiReportGeneratedModal(false),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "px4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "c15 tal mt3rem",
                                children: "AI report is ready."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c15 tal fs0-875rem my1rem",
                                style: {
                                    lineHeight: '1.5',
                                    color: '#505050'
                                },
                                children: "We've compiled your latest AI report. Review the insights now or come back whenever it suits you\u2014your report will be waiting."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc gg1rem fdcb-sm",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '250px'
                                        },
                                        customClassName: "mt1rem bg2",
                                        text: 'Go to Report',
                                        onClick: ()=>handleToggleSuccessAiReportGeneratedModal(true),
                                        btnType: "warning"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        style: {
                                            width: '250px'
                                        },
                                        customClassName: "mt1rem bg5 c15",
                                        text: 'Thanks, I will look later',
                                        onClick: ()=>handleToggleSuccessAiReportGeneratedModal(false),
                                        btnType: "primary"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");











var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");


const $468f7cfba016062c$var$PRIORITY_OPTIONS = [
    "High Priority",
    "Medium Priority",
    "Low Priority",
    "N/A"
];
const $468f7cfba016062c$var$STATUS_OPTIONS = [
    "N/A",
    "Not Started",
    "Started",
    "In Progress",
    "Completed - Further Work",
    "Completed - No Issues"
];
const $468f7cfba016062c$var$PRIORITY_STYLES = {
    "High Priority": {
        background: "#EB5A46"
    },
    "Medium Priority": {
        background: "#FD9E31"
    },
    "Low Priority": {
        background: "#F1D52F"
    },
    "N/A": {
        background: "#BBBBBB"
    }
};
const $468f7cfba016062c$var$STATUS_STYLES = {
    "N/A": {
        background: "#BBBBBB"
    },
    "Not Started": {
        background: "#87DDEC"
    },
    "Started": {
        background: "#20A5DE"
    },
    "In Progress": {
        background: "#F1D52F"
    },
    "Completed - Further Work": {
        background: "#FD9E31"
    },
    "Completed - No Issues": {
        background: "#35E586"
    }
};

function $468f7cfba016062c$export$2e2bcd8739ae039({ open: open, onClose: onClose, question: question, section: section, answer: answer, user: user, company: company, module: module, onAnswerUpdated: onAnswerUpdated }) {
    const [noteText, setNoteText] = (0, $acw62.useState)("");
    const [saving, setSaving] = (0, $acw62.useState)(false);
    const [localAnswer, setLocalAnswer] = (0, $acw62.useState)(answer);
    const [hoveredNoteIdx, setHoveredNoteIdx] = (0, $acw62.useState)(null);
    const textareaRef = (0, $acw62.useRef)(null);
    // Re-sync local state whenever the modal is opened with fresh answer data
    (0, $acw62.useEffect)(()=>{
        if (open) setLocalAnswer(answer);
    }, [
        open
    ]);
    const answerId = localAnswer?._id;
    const moduleName = module?.type;
    const companyId = company?._id;
    const currentPriority = localAnswer?.taskPriority || null;
    const currentStatus = localAnswer?.taskStatus || null;
    const callAddNote = async (payload)=>{
        if (!answerId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Answer not saved yet \u2014 please answer the question first.");
            return null;
        }
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            ...payload,
            companyId: companyId,
            moduleName: moduleName
        });
        if (res?.code === 200) {
            if (res.body) setLocalAnswer(res.body);
            onAnswerUpdated(res.body);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        return res;
    };
    const handleSaveNote = async ()=>{
        const trimmed = noteText.trim();
        if (!trimmed) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Cannot save an empty note!");
            return;
        }
        setSaving(true);
        await callAddNote({
            taskNotes: [
                {
                    note: trimmed
                }
            ]
        });
        setNoteText("");
        setSaving(false);
    };
    const handlePriority = async (value)=>{
        setSaving(true);
        await callAddNote({
            taskPriority: value
        });
        setSaving(false);
    };
    const handleStatus = async (value)=>{
        setSaving(true);
        await callAddNote({
            taskStatus: value
        });
        setSaving(false);
    };
    const handleDeleteNote = async (noteId)=>{
        if (!answerId) return;
        setSaving(true);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/deleteTaskNote/${answerId}/${noteId}`);
        if (res?.code === 200) {
            if (res.body) setLocalAnswer(res.body);
            onAnswerUpdated(res.body);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        setSaving(false);
    };
    const notes = [
        ...localAnswer?.taskNotes || []
    ].sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df aic jcc",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 br20px shadow p1rem",
                    style: {
                        width: "min(920px, 195vw)",
                        maxHeight: "85vh",
                        display: "flex",
                        flexDirection: "column",
                        outline: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcsb px1-5rem pt1-5rem pb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs1-5rem c15 mb0-25rem fw400",
                                            children: "Workflow notes:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem fw300 c3 mb0",
                                            children: [
                                                module?.heading || module?.type,
                                                " - ",
                                                question?.qNo,
                                                " ",
                                                section?.sectionName || section?.name || ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic gg0-5rem fww",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "menuHover pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    disabled: saving,
                                                    className: `df aic px1rem py0-25rem fs12px fw500 cp bg5 br20px bw1px bss bo16 ${currentPriority ? 'c1' : 'c15'}`,
                                                    style: currentPriority && {
                                                        ...$468f7cfba016062c$var$PRIORITY_STYLES[currentPriority],
                                                        border: "1px solid currentColor"
                                                    },
                                                    children: [
                                                        currentPriority || "Priority",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            className: "ml0-5rem",
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M6 9l6 6 6-6",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "menu op0 pen pa bg1 shadow br10px zi10",
                                                    style: {
                                                        top: "25px",
                                                        right: 0,
                                                        minWidth: "160px",
                                                        overflow: "hidden"
                                                    },
                                                    children: $468f7cfba016062c$var$PRIORITY_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>handlePriority(opt),
                                                            className: "w100 df aic px1rem py0-5rem cp c1 fs12px fw500",
                                                            style: {
                                                                ...$468f7cfba016062c$var$PRIORITY_STYLES[opt]
                                                            },
                                                            children: opt
                                                        }, opt))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "menuHover pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    disabled: saving,
                                                    className: `df aic px1rem py0-25rem fs12px fw500 cp br20px bw1px bss bo16 ${currentStatus ? 'c1' : 'c15'}`,
                                                    style: currentStatus && {
                                                        ...$468f7cfba016062c$var$STATUS_STYLES[currentStatus],
                                                        border: "1px solid currentColor"
                                                    },
                                                    children: [
                                                        currentStatus || "Status",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            className: "ml0-5rem",
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M6 9l6 6 6-6",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "menu op0 pen pa bg1 shadow br10px zi10",
                                                    style: {
                                                        top: "25px",
                                                        right: 0,
                                                        minWidth: "195px",
                                                        overflow: "hidden"
                                                    },
                                                    children: $468f7cfba016062c$var$STATUS_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>handleStatus(opt),
                                                            className: "w100 df aic px1rem py0-5rem cp c1 fs12px fw500",
                                                            style: {
                                                                ...$468f7cfba016062c$var$STATUS_STYLES[opt]
                                                            },
                                                            children: opt
                                                        }, opt))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "oya px1-5rem py1rem",
                            style: {
                                flex: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bss bw1px bo5 br10px df aic px0-75rem py0-5rem mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fw400 fs1-5rem mx0-5rem mb2rem",
                                            children: "+"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            ref: textareaRef,
                                            rows: 3,
                                            placeholder: "Add workflow note",
                                            value: noteText,
                                            onChange: (e)=>setNoteText(e.target.value),
                                            onKeyDown: (e)=>{
                                                if (e.key === "Enter" && !e.shiftKey) {
                                                    e.preventDefault();
                                                    handleSaveNote();
                                                }
                                            },
                                            className: "w100 fs15px c15 pt1rem"
                                        }),
                                        noteText.trim() && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: handleSaveNote,
                                            disabled: saving,
                                            className: "df aic jcc br50px cp c1 bg3 ml0-5rem",
                                            style: {
                                                width: "28px",
                                                height: "28px",
                                                flexShrink: 0,
                                                border: "none",
                                                marginTop: "2px"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M5 12h14M12 5l7 7-7 7",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                notes.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df fdc gg0-75rem py0-5rem bg5 br10px mah30vh oa",
                                    children: notes.map((item, idx)=>{
                                        const isAiNote = !!item?.isAi || item?.user?.firstName === 'Clarence' || item?.note && item.note.startsWith(' AI Answer');
                                        const hasProfile = !isAiNote && !!item?.user?.profile;
                                        const firstName = item?.user?.firstName || "";
                                        const lastName = item?.user?.lastName || "";
                                        const initials = (firstName[0] || "") + (lastName[0] || "") || "?";
                                        const fullName = firstName ? `${firstName} ${lastName}`.trim() : "Guest User";
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aifs gg0-75rem py0-75rem px1rem pr",
                                            onMouseEnter: ()=>setHoveredNoteIdx(idx),
                                            onMouseLeave: ()=>setHoveredNoteIdx(null),
                                            children: [
                                                isAiNote ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("bi4Ns")),
                                                    className: "w30px h30px br50px mr0-5rem",
                                                    alt: "Clarence",
                                                    style: {
                                                        flexShrink: 0,
                                                        alignSelf: 'flex-start'
                                                    }
                                                }) : hasProfile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: item.user.profile,
                                                    className: "w30px h30px br50px mr0-5rem",
                                                    alt: fullName,
                                                    style: {
                                                        flexShrink: 0,
                                                        alignSelf: 'flex-start'
                                                    }
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df jcc aic w30px h30px br50px mr0-5rem fw500 fs12px c1 bg3",
                                                    style: {
                                                        flexShrink: 0,
                                                        alignSelf: 'flex-start'
                                                    },
                                                    children: initials
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        flex: 1,
                                                        minWidth: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fs13px fw600 c15",
                                                            children: [
                                                                fullName,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs13px c15 fw400",
                                                            children: item.note
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs11px mt0-25rem mb0",
                                                            style: {
                                                                color: "#9ca3af"
                                                            },
                                                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(item.createdAt).format("MMM D, YYYY, h:mmA")
                                                        })
                                                    ]
                                                }),
                                                hoveredNoteIdx === idx && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>handleDeleteNote(item._id),
                                                    disabled: saving,
                                                    className: "pa cp df aic jcc br50px bg1 bw1px bss bo16",
                                                    style: {
                                                        top: '10px',
                                                        right: '20px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "fa fa-trash-o c23"
                                                    })
                                                })
                                            ]
                                        }, idx);
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "tac fs13px c12 mt1rem",
                                    children: "No notes yet. Add the first one above."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    className: "pa cp",
                    onClick: onClose,
                    style: {
                        left: '50%',
                        transform: 'translateX(-50%)',
                        bottom: '12px'
                    },
                    width: "60",
                    height: "60",
                    viewBox: "0 0 60 60",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            opacity: "0.8",
                            x: "4",
                            y: "4",
                            width: "52",
                            height: "52",
                            rx: "26",
                            fill: "#151313"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                            fill: "white"
                        })
                    ]
                })
            ]
        })
    });
}


const $a51f428ec710cfe5$var$PRIORITY_OPTIONS = [
    "High Priority",
    "Medium Priority",
    "Low Priority",
    "N/A"
];
const $a51f428ec710cfe5$var$PRIORITY_COLORS = {
    "High Priority": "#EB5A46",
    "Medium Priority": "#FD9E31",
    "Low Priority": "#F1D52F",
    "N/A": "#BBBBBB"
};
const $a51f428ec710cfe5$var$STATUS_COLORS = {
    "Not Started": "#929090",
    "In Progress": "#F1D52F",
    "Ready for Review": "#13CB5D",
    "Completed": "#13CB5D"
};
/** Match admin toolbox keys (yesNo, YN/F/T, etc.) for section.toolboxConfig lookup. */ const $a51f428ec710cfe5$var$resolveQuestionToolboxConfig = (section, questionType)=>{
    const cfg = section?.['toolboxConfig'] || {};
    const keys = [];
    if (questionType === 'YN' || questionType === 'yesNo') keys.push('yesNo', 'YN/F/T');
    else if (questionType && String(questionType).includes('YN')) keys.push(questionType, 'YN/F/T', 'yesNo');
    else if (questionType) keys.push(questionType);
    for (const key of keys){
        if (cfg[key] && typeof cfg[key] === 'object') return cfg[key];
    }
    // Reason: custom sections (UD021–UD025) are created as YN/F without toolboxConfig — enable Files/Collaborate by default for file-capable types
    const qt = String(questionType || '');
    if (qt.includes('F') || qt === 'D/ND' || qt === 'FILE') return {
        files: true,
        collaborate: true
    };
    return {};
};


function $a51f428ec710cfe5$var$WorkflowInlinePanel({ answer: answer, question: question, section: section, module: module, company: company, user: user, onAnswerUpdated: onAnswerUpdated }) {
    const [noteText, setNoteText] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [localAnswer, setLocalAnswer] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(answer);
    const [hoveredNoteIdx, setHoveredNoteIdx] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setLocalAnswer(answer || {});
    }, [
        answer
    ]);
    const answerId = localAnswer?._id;
    const moduleName = module?.type;
    const companyId = company?._id;
    const callAddNote = async (payload)=>{
        if (!answerId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Answer not saved yet \u2014 please answer the question first.");
            return null;
        }
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${answerId}`, {
            ...payload,
            companyId: companyId,
            moduleName: moduleName
        });
        if (res?.code === 200) {
            if (res.body) setLocalAnswer(res.body);
            if (onAnswerUpdated) onAnswerUpdated(res.body);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        return res;
    };
    const handleSaveNote = async ()=>{
        const trimmed = noteText.trim();
        if (!trimmed) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Cannot save an empty note!");
            return;
        }
        setSaving(true);
        await callAddNote({
            taskNotes: [
                {
                    note: trimmed
                }
            ]
        });
        setNoteText("");
        setSaving(false);
    };
    const handleDeleteNote = async (noteId)=>{
        if (!answerId) return;
        setSaving(true);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/question/deleteTaskNote/${answerId}/${noteId}`);
        if (res?.code === 200) {
            if (res.body) setLocalAnswer(res.body);
            if (onAnswerUpdated) onAnswerUpdated(res.body);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        setSaving(false);
    };
    const notes = [
        ...localAnswer?.taskNotes || []
    ].sort((a, b)=>new Date(b.createdAt) - new Date(a.createdAt));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w100 px0-5rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bss bw1px bo5 br10px df aic px0-75rem py0-5rem mb0-5rem bg1",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        rows: 3,
                        placeholder: "Add workflow note",
                        value: noteText,
                        onChange: (e)=>setNoteText(e.target.value),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleSaveNote();
                            }
                        },
                        className: "w100 fs12px c15 pt0-5rem",
                        style: {
                            resize: 'none',
                            outline: 'none',
                            border: 'none'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("169qC")),
                        alt: "Wispr",
                        className: "cp mt1rem ml0-5rem",
                        style: {
                            width: '25px',
                            height: '25px'
                        }
                    }),
                    noteText.trim() && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: handleSaveNote,
                        disabled: saving,
                        className: "df aic jcc br50px cp c1 bg4 mt1rem ml0-5rem",
                        style: {
                            width: '25px',
                            height: '25px',
                            flexShrink: 0,
                            border: 'none'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "11",
                            height: "10",
                            viewBox: "0 0 11 10",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M10.0574 0.0122099L0.613533 1.73084C0.489687 1.75309 0.373531 1.80646 0.275979 1.88593C0.178427 1.96541 0.102682 2.06838 0.0558623 2.18517C0.00904232 2.30197 -0.00731535 2.42875 0.00832603 2.5536C0.0239674 2.67845 0.0710945 2.79728 0.145279 2.89891L3.95682 5.2719L5.0353 9.63032C5.10902 9.73229 5.20746 9.81384 5.32136 9.86731C5.43526 9.92078 5.56088 9.94442 5.68643 9.936C5.81198 9.92757 5.93332 9.88737 6.03906 9.81917C6.1448 9.75096 6.23146 9.65699 6.2909 9.54609L10.8448 1.09605C10.9117 0.97287 10.9423 0.833281 10.9331 0.693431C10.9239 0.553581 10.8753 0.419186 10.793 0.305797C10.7106 0.192408 10.5978 0.104659 10.4676 0.0527035C10.3375 0.000747471 10.1953 -0.0132919 10.0574 0.0122099Z",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            notes.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df fdc gg0-75rem py0-5rem bg1 br10px",
                style: {
                    maxHeight: '20vh',
                    overflowY: 'auto'
                },
                children: notes.map((item, idx)=>{
                    const isAiNote = !!item?.isAi || item?.user?.firstName === 'Clarence' || item?.note && item.note.startsWith(' AI Answer');
                    const hasProfile = !isAiNote && !!item?.user?.profile;
                    const firstName = item?.user?.firstName || "";
                    const lastName = item?.user?.lastName || "";
                    const initials = (firstName[0] || "") + (lastName[0] || "") || "?";
                    const fullName = firstName ? `${firstName} ${lastName}`.trim() : "Guest User";
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aifs gg0-75rem py0-5rem px1rem pr",
                        onMouseEnter: ()=>setHoveredNoteIdx(idx),
                        onMouseLeave: ()=>setHoveredNoteIdx(null),
                        children: [
                            isAiNote ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("bi4Ns")),
                                className: "w30px h30px br50px mr0-5rem",
                                alt: "Clarence",
                                style: {
                                    flexShrink: 0,
                                    alignSelf: 'flex-start'
                                }
                            }) : hasProfile ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: item.user.profile,
                                className: "w30px h30px br50px mr0-5rem",
                                alt: fullName,
                                style: {
                                    flexShrink: 0,
                                    alignSelf: 'flex-start'
                                }
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "df jcc aic w30px h30px mr0-5rem fw500 fs12px c14 bg5 bw1px bss bo16 br50px",
                                style: {
                                    flexShrink: 0,
                                    alignSelf: 'flex-start'
                                },
                                children: initials
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs13px fw600 c52",
                                        children: fullName
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs11px c14 fw400",
                                        style: {
                                            marginLeft: '6px'
                                        },
                                        children: item.note
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs9px c12 mb0",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(item.createdAt).format("MMM D, YYYY, h:mmA")
                                    })
                                ]
                            }),
                            hoveredNoteIdx === idx && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleDeleteNote(item._id),
                                disabled: saving,
                                className: "pa cp df aic jcc br50px bg1 bw1px bss bo16",
                                style: {
                                    top: '10px',
                                    right: '10px',
                                    width: '24px',
                                    height: '24px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fa fa-trash-o c23"
                                })
                            })
                        ]
                    }, idx);
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "tac fs13px c12 mt1rem",
                children: "No notes yet. Add the first one above."
            })
        ]
    });
}








function $a51f428ec710cfe5$export$2e2bcd8739ae039({ question: question, questionIdx: questionIdx, sectionIdx: sectionIdx, section: section, qNo: qNo, sectionId: sectionId, showSubFolder: showSubFolder, module: module, isSaving: isSaving, isTwoMinuteTesHomePage: isTwoMinuteTesHomePage, reportGenerateLoading: reportGenerateLoading, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, company: company, tab: tab, user: user, saveAnswer: saveAnswer, radioButtonChanged: radioButtonChanged, syncDrive: syncDrive, syncSharePoint: syncSharePoint, syncDropbox: syncDropbox, setSection: setSection, handleSectionLogs: handleSectionLogs, setLogModule: setLogModule, onClickFileManager: onClickFileManager, generateInsuranceAiReport: generateInsuranceAiReport, handleSectionReportLinkClick: handleSectionReportLinkClick, getReportGenerationKey: getReportGenerationKey, showRiskRecommendation: showRiskRecommendation, answerSaved: answerSaved, getViewableURL: getViewableURL, setDeleteFileQuestionId: setDeleteFileQuestionId, setDeleteFile: setDeleteFile, onDragOver: onDragOver, onDrop: onDrop, handleDateChange: handleDateChange, dateValue: dateValue, dispatch: dispatch, moduleId: moduleId, reloadModule: reloadModule, patchAnswerInModule: patchAnswerInModule, ancestorSectionName: ancestorSectionName = null, nestingLevel: nestingLevel = 0 }) {
    if (!aiEnhanced && Object.values(question?.['answer']?.['aiResponse'] || {}).length > 0) setAiEnchaned(true);
    const hasChecklistModuleKeys = Object.keys(company?.['checklistModules']?.[module?.['moduleName']] || {}).length > 0;
    let answer = question.answer || {};
    let showFiles = true;
    const _qtCfg = $a51f428ec710cfe5$var$resolveQuestionToolboxConfig(section, question?.['questionType']);
    const tooltipText = (question?.tooltip || question?.topTip || '').trim();
    const toolboxText = (question?.toolboxOffer || question?.toolboxTip || '').trim();
    const showTooltipBlock = tooltipText && _qtCfg['showTooltip'] !== false;
    const showToolboxBlock = toolboxText && _qtCfg['showToolbox'] !== false;
    const showFilesTab = _qtCfg['files'] === true || hasChecklistModuleKeys;
    const showCollaborateTab = _qtCfg['collaborate'] === true || hasChecklistModuleKeys;
    const showPolicyMaker = _qtCfg['toolboxPolicyMaker'] === true;
    const showAnalyser = _qtCfg['toolboxAnalyser'] === true;
    const showRollback = !!(answer['autoFilled'] && !answer['rolledBack']);
    const showToolboxTab = showPolicyMaker || showAnalyser || showRollback;
    const isLegacyQuestionnaireModule = module?.['type']?.includes('directors-questionnaire') || module?.['type']?.includes('investor-lead');
    const [uploadOpen, setUploadOpen] = (0, $acw62.useState)(true);
    const [isDragOver, setIsDragOver] = (0, $acw62.useState)(false);
    const [workflowModalOpen, setWorkflowModalOpen] = (0, $acw62.useState)(false);
    const [localAnswer, setLocalAnswer] = (0, $acw62.useState)(answer);
    const skipNextAnswerSync = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const [rightPanelTab, setRightPanelTab] = (0, $acw62.useState)(()=>{
        if (_qtCfg['files'] === true || hasChecklistModuleKeys) return 'files';
        if (_qtCfg['collaborate'] === true) return 'collaborate';
        if (_qtCfg['toolboxPolicyMaker'] === true || _qtCfg['toolboxAnalyser'] === true) return 'toolbox';
        if (answer['autoFilled'] && !answer['rolledBack']) return 'toolbox';
        return null;
    });
    const [rightPanelOpen, setRightPanelOpen] = (0, $acw62.useState)(()=>!!(answer['radioOption'] || answer['answerText'] || answer['status']));
    const [rollbackLoading, setRollbackLoading] = (0, $acw62.useState)(false);
    const handleRollbackAnswer = async ()=>{
        if (rollbackLoading || !localAnswer['_id']) return;
        setRollbackLoading(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/rollback-run', {
                answerId: localAnswer['_id']
            });
            if (res['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Answer rolled back successfully', 'success');
                const now = new Date();
                const userName = `${user?.['firstName'] || ''} ${user?.['lastName'] || ''}`.trim() || 'User';
                const dateStr = now.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                });
                const timeStr = now.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true
                });
                const rollbackNote = {
                    note: `Answer rolled back by ${userName} on ${dateStr} at ${timeStr}`,
                    isAi: false,
                    createdAt: now.toISOString()
                };
                const cleanedNotes = [
                    ...(localAnswer['taskNotes'] || []).filter((n)=>!n['isAi']),
                    rollbackNote
                ];
                // Server restores the pre-autofill snapshot when one exists — patch from it; fall back to blanks for legacy answers
                const restored = res['body']?.['restoredAnswer'];
                const blankPatch = {
                    radioOption: '',
                    comment: '',
                    files: [],
                    autoFilled: false,
                    autoFillNeedsReview: false,
                    autoFillConfidence: null,
                    autoFillSources: [],
                    rolledBack: true,
                    status: 'Not Started',
                    taskStatus: 'Not Started'
                };
                const patchData = {
                    ...restored || blankPatch,
                    taskNotes: cleanedNotes
                };
                skipNextAnswerSync.current = true;
                if (patchAnswerInModule) patchAnswerInModule(question['_id'], {
                    ...localAnswer,
                    ...patchData
                });
                setLocalAnswer((a)=>({
                        ...a,
                        ...patchData
                    }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to roll back answer', 'error');
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to roll back answer', 'error');
        }
        setRollbackLoading(false);
    };
    // Sync localAnswer whenever the parent replaces question.answer (e.g. after save: same _id, new status)
    // Skip one sync cycle after a local rollback so the optimistic state is not overwritten
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (skipNextAnswerSync.current) {
            skipNextAnswerSync.current = false;
            return;
        }
        setLocalAnswer(question.answer || {});
    }, [
        question.answer
    ]);
    // Auto-open the right panel when a valid (non-N/A) answer is confirmed saved (updatedBy set by API)
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (hasChecklistModuleKeys && answer?.['updatedBy'] && answer?.['radioOption'] && answer?.['radioOption'] !== 'N/A') setRightPanelOpen(true);
    }, [
        answer?.['updatedBy'],
        answer?.['radioOption']
    ]);
    const handleWorkflowAnswerUpdated = (updatedAnswer)=>{
        setLocalAnswer(updatedAnswer);
        if (patchAnswerInModule && updatedAnswer) patchAnswerInModule(question._id, updatedAnswer);
        const resolvedModuleId = module?._id || moduleId;
        if (resolvedModuleId && updatedAnswer) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: {
                moduleId: String(resolvedModuleId),
                savedQuestions: [
                    {
                        _id: String(question._id),
                        answer: updatedAnswer
                    }
                ]
            }
        }));
    };
    const handleInlinePriority = async (priority)=>{
        if (!localAnswer?._id) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Answer not saved yet \u2014 please answer the question first.");
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${localAnswer._id}`, {
            taskPriority: priority,
            companyId: company['_id'],
            moduleName: module.type
        });
        if (res?.code !== 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        handleWorkflowAnswerUpdated(res.body);
    };
    const handleHumanReview = async ()=>{
        if (!localAnswer?._id) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Answer not saved yet \u2014 please answer the question first.");
        const isCompleting = localAnswer.taskStatus !== 'Completed';
        const newStatus = isCompleting ? 'Completed' : 'In Progress';
        const payload = {
            status: newStatus,
            taskStatus: newStatus,
            companyId: company['_id'],
            moduleName: module.type
        };
        if (isCompleting) payload.autoFillNeedsReview = false;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/addNote/${localAnswer._id}`, payload);
        if (res?.code !== 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || "Something went wrong");
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        handleWorkflowAnswerUpdated(res.body);
    };
    const qNoDepth = Math.max(0, (question['qNo']?.match(/\./g) || []).length - 1);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-module-type": module.type,
        "data-section-no": question['qNo'],
        "data-question-id": question['_id'],
        className: `${!showSubFolder ? "br10px p1rem m0-5rem pr bg1" : ""} pr`,
        style: !showSubFolder ? {
            boxShadow: '0 6px 16px rgba(0, 0, 0, 0.10), 0 2px 4px rgba(0, 0, 0, 0.06)',
            ...qNoDepth > 0 ? {
                marginLeft: `${qNoDepth * 30}px`
            } : {},
            ...localAnswer?.['autoFillNeedsReview'] && localAnswer?.['taskStatus'] !== 'Completed' ? {
                outline: '2px solid #F59E0B'
            } : {}
        } : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            "data-module-type": module.type,
            "data-section-no": qNo,
            "data-question-id": question['_id'],
            className: (question.editPermission ?? true ? "" : "op20 pen ") + "dg gg2rem report-upload-area-saf aifs",
            style: {
                gridTemplateColumns: '55% 43%'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: isTwoMinuteTesHomePage && `df fww aifs`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcsb",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: localAnswer?.['updatedBy'] && !localAnswer?.['rolledBack'] && answerSaved(localAnswer)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic fww gg0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs1rem c15 fw500",
                                            children: [
                                                question['qNo'],
                                                [
                                                    'Investment Readiness',
                                                    'Exit Readiness'
                                                ].includes(module['moduleName']) ? ` ${question['qDescription']}` : ` ${Object.values(section?.['subFolders'] || {}).filter((sf)=>sf.no.toString() == question['qNo'].toString())[0]?.name || ""}` || ""
                                            ]
                                        }),
                                        (!answer.radioOption || answer.radioOption === 'NC') && (!answer.status || answer.status === 'Not Started') && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "br50px px0-75rem py0-25rem fs12px fw500",
                                            style: {
                                                background: '#e8eaf6',
                                                color: '#6b7280'
                                            },
                                            children: "Not Started"
                                        }),
                                        (()=>{
                                            const conf = localAnswer?.['autoFillConfidence'];
                                            if (!localAnswer?.['autoFilled'] || conf == null || !localAnswer?.['autoFillNeedsReview'] || localAnswer?.['taskStatus'] === 'Completed') return null;
                                            const score = Math.floor(conf * 10);
                                            if (score > 5) return null;
                                            const color = conf >= 0.7 ? '#059669' : conf >= 0.4 ? '#D97706' : '#9CA3AF';
                                            const bg = conf >= 0.7 ? '#ECFDF5' : conf >= 0.4 ? '#FFFBEB' : '#F3F4F6';
                                            const borderColor = conf >= 0.7 ? '#6EE7B7' : conf >= 0.4 ? '#FDE68A' : '#E5E7EB';
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "br50px px0-75rem py0-25rem fs12px fw500 df aic gg0-25rem",
                                                style: {
                                                    background: bg,
                                                    color: color,
                                                    border: '1px solid ' + borderColor
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 66 56",
                                                        version: "1.1",
                                                        width: "14",
                                                        height: "14",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M 31.233 11.238 C 30.508 12.124, 30.592 12.860, 31.513 13.708 C 32.541 14.654, 33.063 14.629, 33.925 13.590 C 34.738 12.611, 34.665 11.967, 33.645 11.120 C 32.601 10.254, 32.014 10.283, 31.233 11.238 M 32.063 23.474 C 19.120 36.545, 18.766 37.015, 20.225 39.224 C 23.176 43.690, 24.949 42.712, 38.791 28.982 C 46.056 21.775, 52 15.301, 52 14.595 C 52 12.915, 48.748 10, 46.874 10 C 46.066 10, 39.401 16.063, 32.063 23.474 M 43.196 15.298 C 37.400 21.278, 40.114 24.247, 46.065 18.437 C 49.043 15.529, 49.693 14.335, 48.852 13.322 C 47.284 11.433, 46.767 11.614, 43.196 15.298 M 23 15.383 C 23 16.144, 22.055 17.014, 20.899 17.316 C 18.648 17.905, 19.163 20, 21.559 20 C 22.352 20, 23 20.648, 23 21.441 C 23 23.837, 25.095 24.352, 25.684 22.101 C 25.986 20.945, 26.856 20, 27.617 20 C 28.377 20, 29 19.325, 29 18.500 C 29 17.675, 28.325 17, 27.500 17 C 26.675 17, 26 16.325, 26 15.500 C 26 14.675, 25.325 14, 24.500 14 C 23.675 14, 23 14.623, 23 15.383 M 29.005 29.495 C 22.390 36.155, 21.728 37.156, 23.060 38.488 C 24.392 39.821, 25.432 39.109, 32.403 32.098 C 39.568 24.890, 41.075 22, 37.666 22 C 36.997 22, 33.100 25.373, 29.005 29.495 M 46 32 C 46 33.333, 45.333 34, 44 34 C 42.900 34, 42 34.450, 42 35 C 42 35.550, 42.900 36, 44 36 C 45.333 36, 46 36.667, 46 38 C 46 39.100, 46.450 40, 47 40 C 47.550 40, 48 39.283, 48 38.406 C 48 37.530, 48.900 36.577, 50 36.290 C 52.381 35.667, 52.677 34, 50.406 34 C 49.530 34, 48.577 33.100, 48.290 32 C 48.002 30.900, 47.369 30, 46.883 30 C 46.398 30, 46 30.900, 46 32",
                                                            stroke: "none",
                                                            fill: color,
                                                            fillRule: "evenodd"
                                                        })
                                                    }),
                                                    "Confidence level: ",
                                                    score
                                                ]
                                            });
                                        })(),
                                        ![
                                            'Investment Readiness',
                                            'Exit Readiness'
                                        ].includes(module['moduleName']) ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 fw400 fs14px c15 mb0",
                                            children: question.qDescription
                                        }) : null
                                    ]
                                }),
                                (()=>{
                                    const options = question.questionType === 'yesNo' ? [
                                        'Yes',
                                        'No',
                                        'N/A'
                                    ] : question.questionType === 'YN/F/T' ? [
                                        'Yes',
                                        'No',
                                        'N/A'
                                    ] : question.questionType === 'YN/TA' ? [
                                        'Yes',
                                        'No',
                                        'N/A'
                                    ] : question.questionType === 'YN/IMG' ? [
                                        'Yes',
                                        'No',
                                        'N/A'
                                    ] : question.questionType === 'FILE' ? [] : question.questionType === 'TA' ? [] : question.questionType === '1to5' ? [
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ] : question.questionType === 'D/ND' ? [
                                        'Disclosure',
                                        'No Disclosure',
                                        'Not Sure',
                                        'N/A'
                                    ] : question.questionType === 'Date' ? [] : question.questionType === 'Radio' || question.questionType === 'DropDown' || question.questionType === 'Multi' ? (question.options || []).map((o)=>typeof o === 'object' ? o['value'] ?? o['name'] ?? '' : o).filter((o)=>o !== '') : [
                                        'Yes',
                                        'No',
                                        'N/A'
                                    ];
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: module['type'].includes("directors-questionnaire") || module['type'].includes("investor-lead") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                question?.questionType.includes("YN") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic fww",
                                                    children: options.map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            for: question._id + option,
                                                            className: "py1rem df cp fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "checkbox w30px h30px pr",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        defaultChecked: answer.radioOption == option,
                                                                        "data-option": option,
                                                                        id: question._id + option + answer.radioOption,
                                                                        onChange: (e)=>radioButtonChanged(e, question, qNo, module.type),
                                                                        name: question._id,
                                                                        className: "bg1 bo4 bw2px bss cp td250 w30px h30px br5px",
                                                                        type: "radio"
                                                                    }, `${question._id}-${option}-${answer.radioOption}`)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                    children: option
                                                                })
                                                            ]
                                                        }, `${question._id}-yn-${option}-${optIdx}`))
                                                }),
                                                question?.questionType.includes("DropDown") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "oyh td250 pr mt1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        value: answer?.dropdown || answer?.comment,
                                                        name: "dropdown",
                                                        className: "pl1rem bss bw2px bo5 w90 br5px p1rem",
                                                        onChange: (e)=>saveAnswer(e, question, qNo),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: answer?.dropdown || answer?.comment,
                                                                selected: true,
                                                                disabled: true,
                                                                hidden: true,
                                                                children: answer?.dropdown || answer?.comment
                                                            }),
                                                            module['type'].includes("investor-lead") ? question['options'] && question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: option['name'].replaceAll("'", ','),
                                                                    children: option['name'].replaceAll("'", ',')
                                                                }, idx)) : question['options'] && question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: option['name'],
                                                                    children: option['name']
                                                                }, idx))
                                                        ]
                                                    })
                                                }),
                                                question?.questionType.includes("Date") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "oyh td250 pr mt1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        value: dateValue[question['_id']] || answer?.date && new Date(answer?.date).toISOString().substring(0, 10),
                                                        type: "date",
                                                        name: "date",
                                                        className: "pl2rem bss bw2px bo5 w90 br5px p1rem",
                                                        onChange: (e)=>handleDateChange(e, question, qNo),
                                                        max: new Date().toISOString().substring(0, 10)
                                                    })
                                                }),
                                                question?.questionType.includes("Radio") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic fww",
                                                    children: question['options'].map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            for: question._id + option['name'],
                                                            className: "py1rem df cp fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "checkbox checkbox-border-qus w30px h30px pr",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        defaultChecked: answer['dropdown'] == option['name'],
                                                                        "data-option": option['name'],
                                                                        onChange: (e)=>saveAnswer(e, question, qNo),
                                                                        name: question._id,
                                                                        id: question._id + option['name'],
                                                                        className: "bg5 shadow bo5 bw2px bss cp td250 w30px h30px br5px",
                                                                        type: "radio"
                                                                    }, `${question._id}-${option}-${answer['dropdown']}`)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                    children: option['name']
                                                                })
                                                            ]
                                                        }, `${question._id}-radio-${option['name']}-${optIdx}`))
                                                }),
                                                question?.questionType.includes("Multi") && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "multi-dropdown mt1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                        multiple: true,
                                                        className: "w400px",
                                                        placeholder: "Select any options from dropdown",
                                                        name: "dropdown",
                                                        id: "demo-multiple-checkbox",
                                                        labelId: "demo-multiple-checkbox-label",
                                                        onChange: (e)=>saveAnswer(e, question, qNo),
                                                        renderValue: (selected)=>selected.join(',  '),
                                                        value: question['answer']['dropdown'] ? question['answer']['dropdown']?.split(";") : [],
                                                        children: question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                value: option['name'],
                                                                className: "multi-dropdown-list",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                        checked: question['answer']?.['dropdown']?.split(";").indexOf(option['name']) > -1
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                        primary: option['name']
                                                                    })
                                                                ]
                                                            }))
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                question.questionType === 'DropDown' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "oyh td250 pr mt1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                        defaultValue: answer?.dropdown || answer?.comment || '',
                                                        name: "dropdown",
                                                        className: "pl1rem bss bw2px bo5 w90 br5px p1rem",
                                                        onChange: (e)=>saveAnswer(e, question, qNo),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: "",
                                                                disabled: true,
                                                                hidden: true,
                                                                children: "Select an option"
                                                            }),
                                                            options.map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                    value: option,
                                                                    children: option
                                                                }, idx))
                                                        ]
                                                    }, `dropdown-${question._id}-${answer?.dropdown || answer?.comment}`)
                                                }),
                                                question.questionType === 'Multi' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "multi-dropdown mt1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                        multiple: true,
                                                        className: "w400px",
                                                        placeholder: "Select any options from dropdown",
                                                        name: "dropdown",
                                                        id: `multi-${question._id}`,
                                                        labelId: `multi-label-${question._id}`,
                                                        onChange: (e)=>saveAnswer(e, question, qNo),
                                                        renderValue: (selected)=>selected.join(',  '),
                                                        value: answer?.dropdown || answer?.comment ? answer.dropdown.split(";") : [],
                                                        children: options.map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                value: option,
                                                                className: "multi-dropdown-list",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                        checked: (answer?.dropdown || answer?.comment?.split(";") || []).indexOf(option) > -1
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                        primary: option
                                                                    })
                                                                ]
                                                            }, idx))
                                                    })
                                                }),
                                                question.questionType === 'Radio' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic fww ml1rem",
                                                    children: options.map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            htmlFor: question._id + option,
                                                            className: "py1rem df cp fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "checkbox w20px h20px pr",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                        defaultChecked: answer['dropdown'] == option,
                                                                        "data-option": option,
                                                                        onChange: (e)=>saveAnswer(e, question, qNo),
                                                                        name: question._id,
                                                                        disabled: isSaving,
                                                                        id: question._id + option,
                                                                        className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                                                        type: "radio"
                                                                    }, `${question._id}-${option}-${answer['dropdown']}`)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "w100 fs0-75rem c15 lh3 ml0-5rem usn mr1-5rem fw500",
                                                                    children: option
                                                                })
                                                            ]
                                                        }, `${question._id}-radio-${option}-${optIdx}`))
                                                }),
                                                question.questionType === 'Date' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "oyh td250 pr mt1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        value: dateValue[question['_id']] || answer?.date && new Date(answer?.date).toISOString().substring(0, 10),
                                                        type: "date",
                                                        name: "date",
                                                        className: "pl2rem bss bw2px bo5 w90 br5px p1rem",
                                                        onChange: (e)=>handleDateChange(e, question, qNo),
                                                        max: new Date().toISOString().substring(0, 10)
                                                    })
                                                }),
                                                ![
                                                    'DropDown',
                                                    'Multi',
                                                    'Radio',
                                                    'Date',
                                                    'FILE',
                                                    'TA'
                                                ].includes(question.questionType) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df aic fww ml1rem",
                                                    children: options.map((option, optIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    htmlFor: question._id + option,
                                                                    className: `df cp fs0-75rem ${question.questionType === '1to5' && (option == 1 || option == 5) ? 'pt2rem pb0-5rem' : 'py1rem'}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "checkbox w20px h20px pr",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                defaultChecked: answer.radioOption == option,
                                                                                "data-option": option,
                                                                                onChange: (e)=>radioButtonChanged(e, question, qNo, module.type),
                                                                                name: question._id,
                                                                                disabled: isSaving,
                                                                                id: question._id + option + answer.radioOption,
                                                                                className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                                                                type: "radio"
                                                                            }, `${question._id}-${option}-${answer.radioOption}`)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "w100 fs0-75rem c15 lh3 ml0-5rem usn mr1-5rem fw500",
                                                                            children: option
                                                                        })
                                                                    ]
                                                                }),
                                                                question.questionType === '1to5' && option == 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c9 fs0-75rem",
                                                                    children: "Poor"
                                                                }),
                                                                question.questionType === '1to5' && option == 5 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c7 fs0-75rem",
                                                                    children: "Excellent"
                                                                })
                                                            ]
                                                        }, `${question._id}-option-${option}-${optIdx}`))
                                                })
                                            ]
                                        })
                                    });
                                })(),
                                ![
                                    `business-audit-${company['testType']}`,
                                    `two-minute-test-${company['testType']}`
                                ].includes(module['moduleName']) && answer['status'] !== "Not Started" && answer.radioOption === "No" && [
                                    "riskDescription",
                                    "recommendDescription"
                                ].filter((key)=>question[key] && question[key] !== "" && question[key] !== "\n").map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "recommendation",
                                        children: [
                                            showRiskRecommendation(key),
                                            question[key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "mt1rem c15 fs14px",
                                                    children: s
                                                }, `${question._id}-${key}-line-${i}`))
                                        ]
                                    }, `${question._id}-${key}`)),
                                module['moduleName'].includes(`business-audit-${company['testType']}`) && answer.radioOption === "No" && [
                                    "riskDescription",
                                    "recommendDescription"
                                ].filter((key)=>answer?.aiResponse?.['if' + key] || question[key]).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "recommendation",
                                        children: [
                                            showRiskRecommendation(key),
                                            (answer?.aiResponse?.['if' + key] || question[key]).split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "mt1rem c15 fs14px",
                                                    children: s
                                                }, `${question._id}-ai-${key}-line-${i}`))
                                        ]
                                    }, `${question._id}-ai-${key}`)),
                                module?.['type'] && company?.['testType'] && module['type'] == `two-minute-test-${company['testType']}` && module?.['stats']?.['completionPercent'] == 100 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: [
                                        "Yes",
                                        "No",
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ].filter((key)=>question?.['answer']?.['aiResponse'] ? question['answer']['aiResponse']["if" + key] : question["if" + key]).map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "recommendation" + (answer.radioOption == key ? "" : " dn"),
                                            children: [
                                                showRiskRecommendation('recommend'),
                                                question?.['answer']?.['aiResponse'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: question['answer']['aiResponse']["if" + key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "mt1rem c15 fs14px",
                                                            children: s
                                                        }, `${question._id}-twomin-ai-${key}-line-${i}`))
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: question["if" + key].split(/\n/).map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "mt1rem c15 fs14px",
                                                            children: s
                                                        }, `${question._id}-twomin-${key}-line-${i}`))
                                                })
                                            ]
                                        }, `${question._id}-twomin-${key}`))
                                })
                            ]
                        }),
                        showTooltipBlock && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `${isTwoMinuteTesHomePage && sectionIdx == 0 && questionIdx == 0 && "op60"} w80 mt1rem`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb0-25rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("iBc1P")),
                                                alt: "icon",
                                                className: "w1rem h1rem mb0-25rem mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs14px c15 fw500",
                                                children: "Tool Tip"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 fs12px fw300 c12",
                                        children: tooltipText
                                    })
                                ]
                            })
                        }),
                        showToolboxBlock && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w80 mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic bg38 br10px p1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb0-25rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("1MTnu")),
                                                alt: "icon",
                                                className: "w1rem h1rem mb0-25rem mr0-5rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs14px c15 fw500",
                                                children: "Tool Box"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 fs12px fw400 c15",
                                        children: toolboxText
                                    })
                                ]
                            })
                        }),
                        question.templateFiles && question.templateFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc aifs w80 mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df fww gg0-5rem",
                                children: question.templateFiles.map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "df aic br5px bg38 px0-75rem py0-25rem",
                                        target: "_blank",
                                        href: file.location,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs12px fw500 c3",
                                            children: file.originalname
                                        })
                                    }, `template-file-${question._id}-${fileIdx}-${file.originalname}`))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcfe gg0-5rem fww aic",
                            children: [
                                answer?.['_id'] && answer?.status !== 'Not Started' && !module?.['type']?.includes('investor-lead') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "menuHover pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            className: `df aic py0-25rem fs12px fw500 cp br20px bw1px bss bo16 ${localAnswer?.taskPriority ? 'c1 px0-75rem' : 'c15 pl2rem pr1rem'}`,
                                            style: localAnswer?.taskPriority ? {
                                                background: $a51f428ec710cfe5$var$PRIORITY_COLORS[localAnswer.taskPriority] || '#e2e7ff',
                                                border: '1px solid currentColor'
                                            } : {
                                                background: '#e2e7ff'
                                            },
                                            children: [
                                                localAnswer?.taskPriority || 'Priority',
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    className: `${localAnswer?.taskPriority ? 'ml0-5rem' : 'ml1-5rem'}`,
                                                    width: "10",
                                                    height: "10",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M6 9l6 6 6-6",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "menu op0 pen pa bg1 shadow br10px zi10",
                                            style: {
                                                top: '28px',
                                                left: 0,
                                                minWidth: '160px',
                                                overflow: 'hidden'
                                            },
                                            children: $a51f428ec710cfe5$var$PRIORITY_OPTIONS.map((opt)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>handleInlinePriority(opt),
                                                    className: "w100 df aic px1rem py0-5rem cp c1 fs12px fw500",
                                                    style: {
                                                        background: $a51f428ec710cfe5$var$PRIORITY_COLORS[opt]
                                                    },
                                                    children: opt
                                                }, opt))
                                        })
                                    ]
                                }),
                                answer?.['_id'] && answer?.status !== 'Not Started' && !module?.['type']?.includes('investor-lead') && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "df aic py0-25rem fs12px fw500 cp br20px bw1px bss bo16 c1 px1rem",
                                    style: localAnswer?.status ? {
                                        background: $a51f428ec710cfe5$var$STATUS_COLORS[localAnswer.status] || '#929090',
                                        border: '1px solid currentColor'
                                    } : {
                                        background: '#929090'
                                    },
                                    children: localAnswer?.status || 'Not Started'
                                }),
                                answer?.['_id'] && answer?.status !== 'Not Started' && !module?.['type']?.includes('investor-lead') && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    type: "button",
                                    className: "df aic br20px px0-75rem py0-25rem fs12px fw400 cp",
                                    style: localAnswer && localAnswer?.taskStatus && localAnswer?.taskStatus.includes('Completed') || answer && answer.status === 'Completed' ? {
                                        background: '#35E586',
                                        border: '1px solid #35E586',
                                        color: '#fff'
                                    } : {
                                        background: '#f0f0f8',
                                        border: '1px solid #a6a6a6',
                                        color: '#000'
                                    },
                                    onClick: ()=>handleHumanReview(),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "mr0-5rem",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M12 5C7 5 2.73 8.11 1 12.5C2.73 16.89 7 20 12 20C17 20 21.27 16.89 23 12.5C21.27 8.11 17 5 12 5Z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    fill: "none"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                    cx: "12",
                                                    cy: "12.5",
                                                    r: "3",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    fill: "none"
                                                })
                                            ]
                                        }),
                                        "Human ",
                                        localAnswer?.taskStatus === 'Completed' ? 'Reviewed' : 'Review'
                                    ]
                                }),
                                !isTwoMinuteTesHomePage && moduleId && (tab === 'repository' || tab?.includes('business-audit') || tab === 'warranty-disclosure' || tab?.includes('directors-questionnaire') || tab === 'Investment Readiness') && answer?.status !== 'Completed' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83364f35f447dab2$export$2e2bcd8739ae039), {
                                    companyId: company?._id,
                                    moduleType: tab,
                                    moduleId: moduleId,
                                    questionId: question._id,
                                    qNo: question.qNo,
                                    scope: "question",
                                    size: "small",
                                    disabled: hasChecklistModuleKeys,
                                    onComplete: ()=>reloadModule && reloadModule(tab)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $468f7cfba016062c$export$2e2bcd8739ae039), {
                            open: workflowModalOpen,
                            onClose: ()=>setWorkflowModalOpen(false),
                            question: question,
                            section: section,
                            answer: localAnswer,
                            user: user,
                            company: company,
                            module: module,
                            onAnswerUpdated: handleWorkflowAnswerUpdated
                        }),
                        isTwoMinuteTesHomePage && (sectionIdx == 0 && questionIdx == 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "two-min-invest-image op80",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic mb1rem op80",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem",
                                            children: "Sync"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem",
                                            children: "File Manager"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "ml0-5rem bg5 td250 br50px px1-5rem py0-5rem fw600 da-cursor bsbb tac df jcc aic bss bo31 bw1px c15 fs0-75rem",
                                            children: "Log"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "oyh td250",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            for: "fileUpload" + new Date().getTime(),
                                            className: "w100 bsbb bg50 br5px df jcc fdc aic px2rem py0-5rem bsd bo3 bw2px da-cursor mb0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "70",
                                                    height: "70",
                                                    viewBox: "0 0 70 70",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M59.4632 31.0446C58.5439 25.1606 53.4429 20.6445 47.3047 20.6445C44.9955 20.6445 42.7766 21.2834 40.852 22.4751C37.924 17.5543 32.6528 14.4922 26.7969 14.4922C17.7506 14.4922 10.3906 21.8522 10.3906 30.8984C10.3906 30.9545 10.3906 31.0126 10.3927 31.0687C4.57871 32.048 0 37.1168 0 43.2031C0 49.9883 5.65619 55.5078 12.4414 55.5078H57.5586C64.3438 55.5078 70 49.9883 70 43.2031C70 37.0649 65.3472 31.9639 59.4632 31.0446Z",
                                                            fill: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                            "clip-path": "url(#clip0_5984_51759)",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M35 56C42.732 56 49 49.732 49 42C49 34.268 42.732 28 35 28C27.268 28 21 34.268 21 42C21 49.732 27.268 56 35 56Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M34.9896 49.6555C33.746 49.6555 32.5026 49.6555 31.2593 49.6555C29.5542 49.6555 28.3237 48.4294 28.315 46.7248C28.3117 46.1298 28.3117 45.5346 28.315 44.9392C28.3182 44.3256 28.6901 43.9308 29.2589 43.9297C29.8276 43.9286 30.2044 44.3207 30.2082 44.9338C30.2121 45.5468 30.2082 46.1456 30.2082 46.7516C30.2126 47.387 30.5861 47.7573 31.2238 47.7578C33.7427 47.7578 36.2614 47.7578 38.78 47.7578C39.4182 47.7578 39.7922 47.387 39.7971 46.7521C39.8015 46.1462 39.7971 45.5402 39.7971 44.9343C39.7971 44.3284 40.175 43.9286 40.746 43.9297C41.3169 43.9308 41.6943 44.3256 41.6893 44.9387C41.6833 45.7136 41.7265 46.4967 41.6292 47.2613C41.4509 48.6602 40.2582 49.6478 38.8429 49.6544C37.5615 49.6582 36.2753 49.6555 34.9896 49.6555Z",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M34.0577 37.6102C33.9133 37.7448 33.8286 37.8186 33.7498 37.8979C33.1439 38.5098 32.5412 39.1256 31.9325 39.7354C31.5005 40.1685 30.8984 40.2002 30.5079 39.8212C30.1175 39.4423 30.1328 38.8205 30.5577 38.3928C31.7947 37.1481 33.0358 35.9078 34.2808 34.6719C34.7183 34.2344 35.2904 34.2344 35.7279 34.6719C36.9813 35.9151 38.2296 37.1636 39.4729 38.4174C39.8819 38.8303 39.8841 39.451 39.504 39.8218C39.124 40.1926 38.5197 40.1762 38.1024 39.7622C37.4844 39.147 36.8758 38.5219 36.2622 37.9028C36.1829 37.823 36.0981 37.7486 35.9718 37.6294C35.9636 37.8011 35.9537 37.9121 35.9537 38.0231C35.9537 39.9804 35.9565 41.9371 35.9537 43.8944C35.9537 44.6288 35.3073 45.0658 34.6352 44.8044C34.2633 44.6595 34.0615 44.3368 34.0615 43.8643C34.0593 41.9284 34.0593 39.9926 34.0615 38.057L34.0577 37.6102Z",
                                                                    fill: "white"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                id: "clip0_5984_51759",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                    width: "28",
                                                                    height: "28",
                                                                    fill: "white",
                                                                    transform: "translate(21 28)"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pen fs1rem fw400 c49 tac op80 mt1rem mb1rem fsi",
                                                    children: "Click here or drag and drop files (max 100MB)"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "oyh td250 pr df aic ",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                    rows: "1",
                                                    style: {
                                                        resize: "vertical"
                                                    },
                                                    name: "comment",
                                                    type: "text",
                                                    disabled: true,
                                                    placeholder: "Add notes",
                                                    className: "pl3rem bss bw2px bo5 w100 br5px pr1rem py0-75rem"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "pa ml1rem",
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 18 18",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                            "clip-path": "url(#clip0_5984_51771)",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M14.25 8.25H9.75V3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75V8.25H3.75C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75H8.25V14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25V9.75H14.25C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    "clip-path": "url(#clip1_5984_51771)",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M16.7301 14.3415L4.73098 17.2387C4.09339 17.3926 3.45171 17.0005 3.29776 16.3629L0.400638 4.36379C0.246685 3.7262 0.638767 3.08452 1.27636 2.93057L13.2755 0.0334501C13.9131 -0.120503 14.5548 0.27158 14.7087 0.909168L17.6059 12.9083C17.7598 13.5459 17.3678 14.1876 16.7301 14.3415Z",
                                                                            fill: "url(#paint0_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M14.3672 14.9115L16.7313 14.3407C17.3688 14.1868 17.7609 13.5451 17.607 12.9075L15.3723 3.65234H14.3672V14.9115Z",
                                                                            fill: "url(#paint1_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M15.3863 3.72331L14.7068 0.909168C14.5529 0.271579 13.9112 -0.120503 13.2736 0.0334501L1.27447 2.93057C0.856593 3.03147 0.54424 3.34185 0.421875 3.72331H15.3863Z",
                                                                            fill: "url(#paint2_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M1.85156 10.3629L3.30014 16.3624C3.45409 17 4.09574 17.3921 4.73336 17.2382L16.7325 14.341C17.3701 14.1871 17.7622 13.5454 17.6082 12.9078L16.1597 6.9082L1.85156 10.3629Z",
                                                                            fill: "url(#paint3_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.3983 17.9993H1.36905C0.815741 17.9993 0.367188 17.5508 0.367188 16.9975L0.376011 3.92377C0.376011 3.37046 0.824564 2.92188 1.37787 2.92188H14.4486C15.0019 2.92188 15.4505 3.37043 15.4505 3.92377L15.4417 13.956C15.4417 16.1891 13.6314 17.9993 11.3983 17.9993Z",
                                                                            fill: "url(#paint4_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M8.50558 4.14062L7.3125 5.33371L10.9873 9.00846C11.5559 8.8328 12.0046 8.38404 12.1803 7.81538L8.50558 4.14062Z",
                                                                            fill: "url(#paint5_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M7.90614 5.57985C8.37206 5.57985 8.74977 5.20214 8.74977 4.73621C8.74977 4.27029 8.37206 3.89258 7.90614 3.89258C7.44021 3.89258 7.0625 4.27029 7.0625 4.73621C7.0625 5.20214 7.44021 5.57985 7.90614 5.57985Z",
                                                                            fill: "url(#paint6_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M0.367188 10.6563V16.9965C0.367188 17.5498 0.815741 17.9983 1.36905 17.9983H11.3983C13.6314 17.9983 15.4417 16.1881 15.4417 13.955V10.6562H0.367188V10.6563Z",
                                                                            fill: "url(#paint7_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.3984 17.9984V14.957C11.3984 14.4037 11.847 13.9551 12.4003 13.9551H15.4418C15.4418 16.1882 13.6315 17.9984 11.3984 17.9984Z",
                                                                            fill: "url(#paint8_linear_5984_51771)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M13.0689 9.20312H7.28104C7.07404 9.20312 6.90625 9.37091 6.90625 9.57791C6.90625 9.78491 7.07404 9.9527 7.28104 9.9527H13.0689C13.2759 9.9527 13.4437 9.78491 13.4437 9.57791C13.4437 9.37091 13.2759 9.20312 13.0689 9.20312Z",
                                                                            fill: "white"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M2.74979 9.9527H4.44885C4.65585 9.9527 4.82364 9.78491 4.82364 9.57791C4.82364 9.37091 4.65585 9.20312 4.44885 9.20312H2.74979C2.54279 9.20312 2.375 9.37091 2.375 9.57791C2.375 9.78491 2.54279 9.9527 2.74979 9.9527Z",
                                                                            fill: "white"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M5.375 9.57791C5.375 9.78491 5.54279 9.9527 5.74979 9.9527H6.17455C6.38155 9.9527 6.54934 9.78491 6.54934 9.57791C6.54934 9.37091 6.38155 9.20312 6.17455 9.20312H5.74979C5.54282 9.20312 5.375 9.37091 5.375 9.57791Z",
                                                                            fill: "white"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M8.53764 10.9688H2.74979C2.54279 10.9688 2.375 11.1365 2.375 11.3435C2.375 11.5505 2.54279 11.7183 2.74979 11.7183H8.53764C8.74464 11.7183 8.91242 11.5505 8.91242 11.3435C8.91242 11.1365 8.74464 10.9688 8.53764 10.9688Z",
                                                                            fill: "white"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M13.066 10.9688H11.367C11.16 10.9688 10.9922 11.1365 10.9922 11.3435C10.9922 11.5505 11.16 11.7183 11.367 11.7183H13.066C13.273 11.7183 13.4408 11.5505 13.4408 11.3435C13.4408 11.1365 13.273 10.9688 13.066 10.9688Z",
                                                                            fill: "white"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M10.073 10.9688H9.64823C9.44123 10.9688 9.27344 11.1365 9.27344 11.3435C9.27344 11.5505 9.44123 11.7183 9.64823 11.7183H10.073C10.28 11.7183 10.4478 11.5505 10.4478 11.3435C10.4478 11.1365 10.28 10.9688 10.073 10.9688Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint0_linear_5984_51771",
                                                                    x1: "4.64913",
                                                                    y1: "5.97348",
                                                                    x2: "20.2804",
                                                                    y2: "15.518",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#D9B1EE"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#814AA0"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint1_linear_5984_51771",
                                                                    x1: "16.8003",
                                                                    y1: "9.28193",
                                                                    x2: "15.1027",
                                                                    y2: "9.28193",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#5B3374",
                                                                            "stop-opacity": "0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#5B3374"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint2_linear_5984_51771",
                                                                    x1: "7.90405",
                                                                    y1: "1.33693",
                                                                    x2: "7.90405",
                                                                    y2: "3.53614",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#5B3374",
                                                                            "stop-opacity": "0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#5B3374"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint3_linear_5984_51771",
                                                                    x1: "10.1943",
                                                                    y1: "13.541",
                                                                    x2: "11.0307",
                                                                    y2: "17.0005",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#5B3374",
                                                                            "stop-opacity": "0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#5B3374"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint4_linear_5984_51771",
                                                                    x1: "0.973999",
                                                                    y1: "3.52579",
                                                                    x2: "14.9207",
                                                                    y2: "17.4724",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#FFDD00"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#FFB000"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint5_linear_5984_51771",
                                                                    x1: "9.96461",
                                                                    y1: "6.7927",
                                                                    x2: "5.00606",
                                                                    y2: "1.83419",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#FEA613",
                                                                            "stop-opacity": "0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#E94444"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint6_linear_5984_51771",
                                                                    x1: "7.37934",
                                                                    y1: "4.20938",
                                                                    x2: "8.24118",
                                                                    y2: "5.07123",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#FE93BB"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#FD3581"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint7_linear_5984_51771",
                                                                    x1: "7.90442",
                                                                    y1: "15.5917",
                                                                    x2: "7.90442",
                                                                    y2: "19.8029",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#FEA613",
                                                                            "stop-opacity": "0"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#E94444"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                    id: "paint8_linear_5984_51771",
                                                                    x1: "12.3144",
                                                                    y1: "14.8711",
                                                                    x2: "14.6838",
                                                                    y2: "17.2404",
                                                                    gradientUnits: "userSpaceOnUse",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            "stop-color": "#FFDD00"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                            offset: "1",
                                                                            "stop-color": "#FFB000"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                    id: "clip0_5984_51771",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                        width: "18",
                                                                        height: "18",
                                                                        fill: "white"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                    id: "clip1_5984_51771",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                        width: "18",
                                                                        height: "18",
                                                                        fill: "white"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "two-min-invest-image",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "fileUpload" + new Date().getTime(),
                                    className: "w100 bsbb bg50 br5px df jcfs aic px0-5rem py1rem bsd bo3 bw2px da-cursor mb0-5rem op60",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "24",
                                            height: "25",
                                            viewBox: "0 0 24 25",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    "clip-path": "url(#clip0_5984_51832)",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M18.75 24.5H5.25C4.01 24.5 3 23.491 3 22.25V11.75C3 10.509 4.01 9.5 5.25 9.5H18.75C19.99 9.5 21 10.509 21 11.75V22.25C21 23.491 19.99 24.5 18.75 24.5ZM5.25 11C4.837 11 4.5 11.336 4.5 11.75V22.25C4.5 22.664 4.837 23 5.25 23H18.75C19.163 23 19.5 22.664 19.5 22.25V11.75C19.5 11.336 19.163 11 18.75 11H5.25Z",
                                                            fill: "#4A67FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M17.25 11C16.836 11 16.5 10.664 16.5 10.25V6.5C16.5 4.019 14.481 2 12 2C9.519 2 7.5 4.019 7.5 6.5V10.25C7.5 10.664 7.164 11 6.75 11C6.336 11 6 10.664 6 10.25V6.5C6 3.191 8.691 0.5 12 0.5C15.309 0.5 18 3.191 18 6.5V10.25C18 10.664 17.664 11 17.25 11Z",
                                                            fill: "#4A67FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M12 17.5C10.897 17.5 10 16.603 10 15.5C10 14.397 10.897 13.5 12 13.5C13.103 13.5 14 14.397 14 15.5C14 16.603 13.103 17.5 12 17.5ZM12 15C11.725 15 11.5 15.224 11.5 15.5C11.5 15.776 11.725 16 12 16C12.275 16 12.5 15.776 12.5 15.5C12.5 15.224 12.275 15 12 15Z",
                                                            fill: "#4A67FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M12 20.5C11.586 20.5 11.25 20.164 11.25 19.75V17C11.25 16.586 11.586 16.25 12 16.25C12.414 16.25 12.75 16.586 12.75 17V19.75C12.75 20.164 12.414 20.5 12 20.5Z",
                                                            fill: "#4A67FF"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                        id: "clip0_5984_51832",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                            width: "24",
                                                            height: "24",
                                                            fill: "white",
                                                            transform: "translate(0 0.5)"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc jcfs aifs ml1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pen fs1rem tal fw500 w100 c3 op80 m0rem fsi",
                                                    children: " Register to access more features "
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "fs13px tal w100 fsi",
                                                    children: sectionIdx === 0 && [
                                                        1,
                                                        2
                                                    ].includes(questionIdx) ? "(No credit card required)" : "Tools Tip, Add files, Sync, File manager, Log"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            disabled: true,
                                            className: "dn",
                                            id: "fileUpload" + new Date().getTime(),
                                            type: "file",
                                            multiple: true
                                        })
                                    ]
                                })
                            })
                        })),
                        ([
                            'TA',
                            'T'
                        ].includes(question.questionType) || question.questionType === 'YN/TA' && answer.radioOption === "Yes") && !isLegacyQuestionnaireModule && /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                            rows: 5,
                            name: "comment",
                            placeholder: "Please enter your answer",
                            defaultValue: answer?.comment || '',
                            onChange: (e)=>saveAnswer(e, question, qNo),
                            className: "w100 bss bw1px bo16 br5px p0-75rem fs14px c15 p1rem mt0-5rem",
                            style: {
                                resize: 'vertical',
                                outline: 'none'
                            }
                        }),
                        rightPanelTab && ![
                            'YN/TA',
                            'YN/IMG',
                            'FILE'
                        ].includes(question.questionType) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: !isTwoMinuteTesHomePage && (hasChecklistModuleKeys && answer?.['updatedBy'] && answer?.['radioOption'] && answer?.['radioOption'] !== 'N/A' || answer?.['_id'] && ((answer?.['radioOption'] == 'Yes' || answer?.['radioOption'] == 'No' || answer?.['radioOption'] == 'Disclosure' || answer?.['radioOption'] == 'Non-Disclosure') && (question.questionType.includes('F') || question.questionType === 'D/ND') || showRollback)) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fww mt0-5rem ",
                                style: {
                                    border: '2px solid #e5e7eb',
                                    padding: '1rem',
                                    borderRadius: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `w100 df jcsb aic cp ${rightPanelOpen ? 'py0-25rem' : 'py0-5rem px1rem br10px bg1'}`,
                                        style: !rightPanelOpen ? {
                                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)'
                                        } : undefined,
                                        onClick: ()=>setRightPanelOpen((o)=>!o),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "fs13px fw500 c14",
                                                children: showFilesTab && showCollaborateTab && showToolboxTab ? 'Files, Collaboration & Toolbox' : showFilesTab && showCollaborateTab && !showToolboxTab ? 'Files & Collaboration' : showFilesTab && showToolboxTab && !showCollaborateTab ? 'Files & Toolbox' : showCollaborateTab && showToolboxTab && !showFilesTab ? 'Collaborate & Toolbox' : showFilesTab && !showCollaborateTab && !showToolboxTab ? 'Files' : !showFilesTab && showCollaborateTab && !showToolboxTab ? 'Collaborate' : !showFilesTab && !showCollaborateTab && showToolboxTab ? 'ToolBox' : ''
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                style: {
                                                    transform: rightPanelOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
                                                    transition: 'transform 0.2s'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M6 9l6 6 6-6",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        ]
                                    }),
                                    rightPanelOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w100 df jcfs aic mb0-5rem",
                                                style: {
                                                    borderBottom: '2px solid #e5e7eb'
                                                },
                                                children: [
                                                    {
                                                        key: 'files',
                                                        show: showFilesTab,
                                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                            children: [
                                                                "Files ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "fs12px c12",
                                                                    style: {
                                                                        marginLeft: '4px'
                                                                    },
                                                                    children: [
                                                                        "(",
                                                                        answer.files?.length || 0,
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("atCxS")),
                                                            alt: "icon",
                                                            className: "mr0-5rem"
                                                        })
                                                    },
                                                    {
                                                        key: 'collaborate',
                                                        show: showCollaborateTab,
                                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                                            children: [
                                                                "Collaborate ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "fs12px c12",
                                                                    style: {
                                                                        marginLeft: '4px'
                                                                    },
                                                                    children: [
                                                                        "(",
                                                                        localAnswer.taskNotes?.length || 0,
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        dot: (localAnswer.taskNotes?.length || 0) > 0,
                                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("5IILg")),
                                                            alt: "icon",
                                                            className: "mr0-5rem"
                                                        })
                                                    },
                                                    {
                                                        key: 'toolbox',
                                                        show: showToolboxTab,
                                                        label: 'Toolbox',
                                                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("1MTnu")),
                                                            alt: "icon",
                                                            className: "mr0-5rem"
                                                        })
                                                    }
                                                ].filter((t)=>t.show).map((t, _i, data)=>{
                                                    const isActive = rightPanelTab === t.key;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        onClick: ()=>setRightPanelTab(t.key),
                                                        className: "df jcc aic cp bg1 fw500 fs14px px2rem py0-5rem pr c15",
                                                        style: {
                                                            borderBottom: isActive ? '2px solid #4A67FF' : undefined,
                                                            width: data.length === 1 ? '100%' : data.length === 2 ? '50%' : '33.33%'
                                                        },
                                                        children: [
                                                            t.icon,
                                                            t.label,
                                                            t.dot && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "mb0-5rem br50px bg4",
                                                                style: {
                                                                    width: '6px',
                                                                    height: '6px',
                                                                    display: 'inline-block'
                                                                }
                                                            })
                                                        ]
                                                    }, t.key);
                                                })
                                            }),
                                            rightPanelTab === 'files' && (()=>{
                                                const tabCanSync = Boolean((section.sectionNo || section.no) && (company.gDriveLink || company.sharePointLink || company.dropBoxLink) && module['uploadFiles'] && !tab.includes('directors-questionnaire') && answer?.files?.length && tab === "repository");
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w100 mt0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df jcfs mb1rem",
                                                            children: [
                                                                tabCanSync && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    onClick: ()=>company.gDriveLink && syncDrive(sectionId, question['qNo']) || company.sharePointLink && syncSharePoint(sectionId, question['qNo']) || company.dropBoxLink && syncDropbox(sectionId, question['qNo']),
                                                                    className: "df jcc aic bg5 br50px px1rem mr1rem py0-25rem fw400 bss bo16 bw1px c14 fs12px cp",
                                                                    children: [
                                                                        "Sync ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "df aic ml0-5rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                src: (parcelRequire("1Ar70")),
                                                                                alt: "sync",
                                                                                style: {
                                                                                    width: '14px',
                                                                                    height: '14px'
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                showFiles && answer?.files?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    onClick: ()=>{
                                                                        const isWarrantyDisclosure = tab === "warranty-disclosure";
                                                                        if (isWarrantyDisclosure) setSection({
                                                                            ...section,
                                                                            questionId: question?.['qNo'],
                                                                            question: question
                                                                        });
                                                                        else setSection({
                                                                            ...section,
                                                                            questionId: question?.['qNo']
                                                                        });
                                                                        onClickFileManager(section, questionIdx);
                                                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                            open: isWarrantyDisclosure ? 'manageWarrantyDisclosureFiles' : 'manageFiles'
                                                                        }));
                                                                    },
                                                                    className: "df jcc aic bg5 br50px mr1rem px1rem py0-25rem fw400 bss bo16 bw1px c14 fs12px cp",
                                                                    children: [
                                                                        "File Manager (",
                                                                        answer.files.length,
                                                                        ")"
                                                                    ]
                                                                }),
                                                                (localAnswer?.['updatedBy'] || localAnswer?.['rolledBack']) && localAnswer?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>{
                                                                        setSection({
                                                                            ...section,
                                                                            questionId: question?.['qNo']
                                                                        });
                                                                        handleSectionLogs(localAnswer['_id']);
                                                                        setLogModule(` - ${question['qNo']} ${section['sectionName'] || section['name']}`);
                                                                    },
                                                                    className: "df jcc aic bg5 br50px mr1rem px1rem py0-25rem fw400 bss bo16 bw1px c14 fs12px cp",
                                                                    children: "Log"
                                                                }),
                                                                showRollback && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: handleRollbackAnswer,
                                                                    disabled: rollbackLoading,
                                                                    "data-tooltip": "Undo the AI-filled answer and restore your previous answer, or reset to empty if none existed",
                                                                    className: `df jcc aic bg1 br50px px0-5rem py0-25rem bw1px bss cp ${rollbackLoading ? 'op50 cna' : ''}`,
                                                                    style: {
                                                                        color: '#FC7785',
                                                                        borderColor: '#FC7785'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "16",
                                                                        height: "16",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M3 12C3 7.02944 7.02944 3 12 3C14.8273 3 17.35 4.30367 19 6.34267M21 12C21 16.9706 16.9706 21 12 21C9.1727 21 6.65 19.6963 5 17.6573",
                                                                                stroke: "#FC7785",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M19 2V7H14",
                                                                                stroke: "#FC7785",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M5 22V17H10",
                                                                                stroke: "#FC7785",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        showFiles && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    onDragOver: onDragOver,
                                                                    onDrop: (e)=>onDrop(e, question, qNo),
                                                                    htmlFor: "fileUpload" + question._id,
                                                                    className: "w100 bg1 br10px df jcc fdc aic px2rem py0-5rem cp mb0-5rem",
                                                                    style: {
                                                                        border: '2px dotted #d2d2d2'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                            width: "40",
                                                                            height: "40",
                                                                            viewBox: "0 0 40 40",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M33.979 17.7398C33.4537 14.3775 30.5388 11.7969 27.0312 11.7969C25.7117 11.7969 24.4438 12.162 23.344 12.8429C21.6709 10.031 18.6588 8.28125 15.3125 8.28125C10.1432 8.28125 5.9375 12.487 5.9375 17.6562C5.9375 17.6883 5.9375 17.7215 5.93867 17.7535C2.61641 18.3131 0 21.2096 0 24.6875C0 28.5648 3.23211 31.7188 7.10938 31.7188H32.8906C36.7679 31.7188 40 28.5648 40 24.6875C40 21.1799 37.3413 18.2651 33.979 17.7398Z",
                                                                                    fill: "#F3F5FF"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                    clipPath: "url(#clip0_6001_237_qi)",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z",
                                                                                            fill: "#4A67FF"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M19.9952 28.3744C19.2845 28.3744 18.574 28.3744 17.8636 28.3744C16.8892 28.3744 16.1861 27.6738 16.1811 26.6997C16.1792 26.3597 16.1792 26.0196 16.1811 25.6794C16.183 25.3288 16.3955 25.1032 16.7205 25.1025C17.0455 25.1019 17.2608 25.326 17.263 25.6763C17.2652 26.0266 17.263 26.3688 17.263 26.715C17.2655 27.0782 17.4789 27.2897 17.8433 27.29C19.2827 27.29 20.7219 27.29 22.1611 27.29C22.5258 27.29 22.7395 27.0782 22.7423 26.7154C22.7448 26.3691 22.7423 26.0229 22.7423 25.6766C22.7423 25.3304 22.9583 25.1019 23.2845 25.1025C23.6108 25.1032 23.8264 25.3288 23.8236 25.6791C23.8202 26.1219 23.8448 26.5694 23.7892 27.0063C23.6873 27.8057 23.0058 28.37 22.197 28.3738C21.4648 28.376 20.7298 28.3744 19.9952 28.3744Z",
                                                                                            fill: "#F3F5FF"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M19.4627 21.4916C19.3802 21.5684 19.3317 21.6106 19.2867 21.6559C18.9405 22.0056 18.5961 22.3575 18.2483 22.7059C18.0014 22.9534 17.6573 22.9716 17.4342 22.755C17.2111 22.5384 17.2198 22.1831 17.4627 21.9387C18.1695 21.2275 18.8787 20.5188 19.5902 19.8125C19.8402 19.5625 20.167 19.5625 20.417 19.8125C21.1333 20.5229 21.8466 21.2364 22.557 21.9528C22.7908 22.1888 22.792 22.5434 22.5748 22.7553C22.3577 22.9672 22.0123 22.9578 21.7739 22.7213C21.4208 22.3697 21.073 22.0125 20.7223 21.6588C20.677 21.6131 20.6286 21.5706 20.5564 21.5025C20.5517 21.6006 20.5461 21.6641 20.5461 21.7275C20.5461 22.8459 20.5477 23.9641 20.5461 25.0825C20.5461 25.5022 20.1767 25.7519 19.7927 25.6025C19.5802 25.5197 19.4648 25.3353 19.4648 25.0653C19.4636 23.9591 19.4636 22.8529 19.4648 21.7469L19.4627 21.4916Z",
                                                                                            fill: "#F3F5FF"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                        id: "clip0_6001_237_qi",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                            width: "16",
                                                                                            height: "16",
                                                                                            fill: "white",
                                                                                            transform: "translate(12 16)"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "op80 pen fs0-75rem fw400 c12 tac mt0-5rem fsi",
                                                                            children: "Click here or drag and drop files (max 100MB)"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            onChange: (e)=>saveAnswer(e, question, qNo),
                                                                            className: "dn",
                                                                            id: "fileUpload" + question._id,
                                                                            type: "file",
                                                                            multiple: true
                                                                        })
                                                                    ]
                                                                }),
                                                                answer.files && answer.files.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "fw500 c14 mt1rem fs0-75rem",
                                                                    children: "Attached Files"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df fdc w100",
                                                                    style: {
                                                                        maxHeight: '15vh',
                                                                        overflow: 'auto'
                                                                    },
                                                                    children: answer.files && answer.files.map((file, fileIdx)=>{
                                                                        const fileColor = file.originator == 'ai-report' ? 'ai-report' : file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df aic py0-25rem bg5 px1rem br20px mt0-5rem",
                                                                            style: {
                                                                                maxWidth: 'max-content'
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "df aic cp",
                                                                                    onClick: ()=>getViewableURL(file.location),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: `br50px mr0-5rem ${fileColor}`,
                                                                                            style: {
                                                                                                width: '10px',
                                                                                                height: '10px',
                                                                                                minWidth: '10px',
                                                                                                flexShrink: 0
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "fw500 c52 fs12px",
                                                                                            children: file.originalname && file.originalname.length > 40 ? file.originalname.slice(0, 40) + '...' : file.originalname
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99875422f9004601$export$2e2bcd8739ae039), {
                                                                                    aiMatch: file.aiMatch,
                                                                                    fileName: file.originalname
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                    className: "fa fa-trash-o cp c23 ml0-5rem",
                                                                                    onClick: (e)=>{
                                                                                        e.preventDefault();
                                                                                        setDeleteFileQuestionId(question._id);
                                                                                        setDeleteFile(file);
                                                                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                            open: 'deleteFile',
                                                                                            from: ''
                                                                                        }));
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }, `tab-file-${question._id}-${fileIdx}-${file.key || file.originalname}`);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                            })(),
                                            rightPanelTab === 'collaborate' && /*#__PURE__*/ (0, $ayMG0.jsx)($a51f428ec710cfe5$var$WorkflowInlinePanel, {
                                                answer: localAnswer,
                                                question: question,
                                                section: section,
                                                module: module,
                                                company: company,
                                                user: user,
                                                onAnswerUpdated: handleWorkflowAnswerUpdated
                                            }),
                                            rightPanelTab === 'toolbox' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w100 df fdc mt0-5rem px0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 c12 fs15px fw300 mb0-5rem",
                                                        children: "AI-powered tools to help you analyse and generate content for this question."
                                                    }),
                                                    localAnswer['autoFilled'] && !localAnswer['rolledBack'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc aic bg1 br10px bw1px bss bo16 p1rem mb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "w100 df jcsb mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                className: "mr0-5rem",
                                                                                width: "20",
                                                                                height: "20",
                                                                                viewBox: "0 0 24 24",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M3 12C3 7.02944 7.02944 3 12 3C14.8273 3 17.35 4.30367 19 6.34267M21 12C21 16.9706 16.9706 21 12 21C9.1727 21 6.65 19.6963 5 17.6573",
                                                                                        stroke: "#FC7785",
                                                                                        strokeWidth: "2",
                                                                                        strokeLinecap: "round"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M19 2V7H14",
                                                                                        stroke: "#FC7785",
                                                                                        strokeWidth: "2",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M5 22V17H10",
                                                                                        stroke: "#FC7785",
                                                                                        strokeWidth: "2",
                                                                                        strokeLinecap: "round",
                                                                                        strokeLinejoin: "round"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fw500 c14 fs14px",
                                                                                children: "Rollback Answer"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: handleRollbackAnswer,
                                                                        disabled: rollbackLoading,
                                                                        className: `df aic px1rem py0-25rem fs14px fw500 br50px bw1px bss cp ${rollbackLoading ? 'op50 cna' : ''}`,
                                                                        style: {
                                                                            color: '#FC7785',
                                                                            borderColor: '#FC7785',
                                                                            background: '#fff'
                                                                        },
                                                                        children: rollbackLoading ? 'Rolling back...' : 'Rollback'
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs12px c12",
                                                                children: "Undo the AI-filled answer and restore your previous answer, or reset to empty if none existed."
                                                            })
                                                        ]
                                                    }),
                                                    showPolicyMaker && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fdc aic bg1 br10px bw1px bss bo16 p1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "w100 df jcsb mb0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                src: (parcelRequire("gA5Zr")),
                                                                                alt: "policymaker",
                                                                                className: "w20px h20px mr0-5rem"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "fw500 c14 fs14px",
                                                                                children: "PolicyMaker"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                        disabled: true,
                                                                        className: "df aic px1rem py0-25rem fs14px fw500 c3 bg1 br50px bw1px bss bo3 op50 cna",
                                                                        children: [
                                                                            "Launch",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                className: "ml0-5rem",
                                                                                width: "16",
                                                                                height: "16",
                                                                                viewBox: "0 0 16 16",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    fillRule: "evenodd",
                                                                                    clipRule: "evenodd",
                                                                                    d: "M14 8.82164C14 9.35985 13.5637 9.79616 13.0255 9.79616C12.4872 9.79616 12.0509 9.35985 12.0509 8.82164V5.32737L3.66359 13.7145C3.28303 14.0952 2.66605 14.0952 2.28544 13.7145C1.90485 13.334 1.90486 12.7169 2.28543 12.3363L10.6729 3.94904H7.17474C6.63651 3.94904 6.20021 3.51273 6.20021 2.97452C6.20021 2.4363 6.63651 2 7.17474 2H13.0255C13.5637 2 14 2.43631 14 2.97452V8.82164Z",
                                                                                    fill: "#4A67FF"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs12px c12",
                                                                children: "Automatically draft policy clauses and standard commercial terms based on your uploaded agreements and jurisdiction preferences."
                                                            })
                                                        ]
                                                    }),
                                                    showAnalyser && (()=>{
                                                        const _sectionComplete = section?.['stats']?.['completionPercent'] === 100 || question?.answer?.status === "Completed";
                                                        const _hasUploadedFiles = (question?.answer?.files || []).some((f)=>f && f.originator !== 'ai-report' && (f.location || f.url));
                                                        const _canReport = question['isPrompt'] === true && tab === 'repository';
                                                        const _hasFiles = _canReport && _hasUploadedFiles && _sectionComplete;
                                                        const _disabledTooltip = !_sectionComplete ? 'Complete the 100% section to generate the report' : !_hasUploadedFiles ? 'Upload files to generate the report' : !_canReport ? 'No analyser prompt configured for this question' : '';
                                                        const _isAnyGenerating = reportGenerateLoading !== null;
                                                        const _isGenerating = _canReport && reportGenerateLoading === getReportGenerationKey(question, true);
                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc aic bg1 br10px bw1px bss bo16 p1rem mt0-5rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "w100 df jcsb mb0-5rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df aic",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                    src: (parcelRequire("gA5Zr")),
                                                                                    alt: "analyser",
                                                                                    className: "w20px h20px mr0-5rem"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "fw500 c14 fs14px",
                                                                                    children: "Analyser"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df aic",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                                    onClick: ()=>_canReport && _hasFiles && !_isAnyGenerating ? generateInsuranceAiReport({
                                                                                            data: question,
                                                                                            isQuestion: true
                                                                                        }) : undefined,
                                                                                    className: `df aic px1rem py0-25rem fs14px fw500 c3 bg1 br50px bw1px bss bo3 ${_canReport && _hasFiles && !_isAnyGenerating ? 'cp' : 'op50 cna'}`,
                                                                                    "data-tooltip": !_hasFiles ? _disabledTooltip : "",
                                                                                    children: [
                                                                                        _isGenerating ? 'Generating...' : 'Launch',
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                            className: "ml0-5rem",
                                                                                            width: "16",
                                                                                            height: "16",
                                                                                            viewBox: "0 0 16 16",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                fillRule: "evenodd",
                                                                                                clipRule: "evenodd",
                                                                                                d: "M14 8.82164C14 9.35985 13.5637 9.79616 13.0255 9.79616C12.4872 9.79616 12.0509 9.35985 12.0509 8.82164V5.32737L3.66359 13.7145C3.28303 14.0952 2.66605 14.0952 2.28544 13.7145C1.90485 13.334 1.90486 12.7169 2.28543 12.3363L10.6729 3.94904H7.17474C6.63651 3.94904 6.20021 3.51273 6.20021 2.97452C6.20021 2.4363 6.63651 2 7.17474 2H13.0255C13.5637 2 14 2.43631 14 2.97452V8.82164Z",
                                                                                                fill: "#4A67FF"
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                question?.['answer']?.['isAiReportGenerated'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    onClick: (e)=>handleSectionReportLinkClick(e, section, true, {
                                                                                            qNo: question?.['qNo'],
                                                                                            skipReportCheck: true
                                                                                        }),
                                                                                    className: "fs14px c1 bg3 br50px px0-5rem py0-25rem ml0-5rem df aic jcc cp",
                                                                                    style: {
                                                                                        height: '31px',
                                                                                        width: '31px'
                                                                                    },
                                                                                    children: "R"
                                                                                }) : null
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "fs12px c12",
                                                                    children: "Scan uploaded documents for key risks, obligations, and red-flag clauses. Get a structured summary ready for due diligence review."
                                                                })
                                                            ]
                                                        });
                                                    })()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: module['uploadFiles'] !== false && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: module['type'].includes("directors-questionnaire") || module['type'].includes("investor-lead") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            question?.questionType.includes("F") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: (question?.questionType.includes("YN") && (showFiles ? "" : "op0 h0 dn ")) + "showOrHide oyh td250 oxh p1rem px1-5rem br10px",
                                                style: {
                                                    background: '#F3F5FF'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic jcsb mb0-5rem cp",
                                                        onClick: ()=>setUploadOpen((o)=>!o),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        className: "mr0-5rem",
                                                                        width: "20",
                                                                        height: "20",
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                clipPath: "url(#clip0_6001_294_dq)",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                    d: "M4.85746 16.7168C2.75033 14.9386 2.60107 11.6378 4.52471 9.35828L9.75741 3.15748C10.9943 1.69173 13.1027 1.43054 14.4565 2.57298C15.8103 3.71542 15.9073 5.83769 14.6704 7.30344L9.68688 13.209C9.27425 13.6979 8.57252 13.7852 8.12052 13.4038C7.66853 13.0224 7.63658 12.316 8.04922 11.827L13.0327 5.92146C13.4454 5.43248 13.4123 4.72514 12.9614 4.34464C12.5105 3.96413 11.8077 4.05049 11.3951 4.53947L6.16237 10.7403C5.06301 12.043 5.14829 13.9289 6.35252 14.9451C7.55675 15.9613 9.43012 15.7283 10.5295 14.4256L17.2572 6.45311C17.6699 5.96414 18.3716 5.87685 18.8236 6.25828C19.2756 6.63971 19.3075 7.34612 18.8949 7.8351L12.1671 15.8076C10.2435 18.0871 6.96459 18.4949 4.85746 16.7168Z",
                                                                                    fill: "#4A67FF"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                    id: "clip0_6001_294_dq",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                        width: "20",
                                                                                        height: "20",
                                                                                        fill: "white"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "fs16px c14 fw400 mb0",
                                                                        children: [
                                                                            "Files ",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                className: "fs14px c12",
                                                                                children: [
                                                                                    "(",
                                                                                    answer.files?.length ?? 0,
                                                                                    ")"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                style: {
                                                                    transition: 'transform 0.2s',
                                                                    transform: uploadOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                                                                },
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M6 9l6 6 6-6",
                                                                    stroke: "#4A67FF",
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    uploadOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        onDragOver: onDragOver,
                                                        onDrop: (e)=>onDrop(e, question, qNo),
                                                        htmlFor: "fileUpload" + question._id,
                                                        className: "w100 bg1 br10px df jcc fdc aic px2rem py0-5rem cp mb0-5rem",
                                                        style: {
                                                            border: '2px dotted #d2d2d2'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                width: "40",
                                                                height: "40",
                                                                viewBox: "0 0 40 40",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M33.979 17.7398C33.4537 14.3775 30.5388 11.7969 27.0312 11.7969C25.7117 11.7969 24.4438 12.162 23.344 12.8429C21.6709 10.031 18.6588 8.28125 15.3125 8.28125C10.1432 8.28125 5.9375 12.487 5.9375 17.6562C5.9375 17.6883 5.9375 17.7215 5.93867 17.7535C2.61641 18.3131 0 21.2096 0 24.6875C0 28.5648 3.23211 31.7188 7.10938 31.7188H32.8906C36.7679 31.7188 40 28.5648 40 24.6875C40 21.1799 37.3413 18.2651 33.979 17.7398Z",
                                                                        fill: "#F3F5FF"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                        clipPath: "url(#clip0_6001_237_dq)",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z",
                                                                                fill: "#4A67FF"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M19.9952 28.3744C19.2845 28.3744 18.574 28.3744 17.8636 28.3744C16.8892 28.3744 16.1861 27.6738 16.1811 26.6997C16.1792 26.3597 16.1792 26.0196 16.1811 25.6794C16.183 25.3288 16.3955 25.1032 16.7205 25.1025C17.0455 25.1019 17.2608 25.326 17.263 25.6763C17.2652 26.0266 17.263 26.3688 17.263 26.715C17.2655 27.0782 17.4789 27.2897 17.8433 27.29C19.2827 27.29 20.7219 27.29 22.1611 27.29C22.5258 27.29 22.7395 27.0782 22.7423 26.7154C22.7448 26.3691 22.7423 26.0229 22.7423 25.6766C22.7423 25.3304 22.9583 25.1019 23.2845 25.1025C23.6108 25.1032 23.8264 25.3288 23.8236 25.6791C23.8202 26.1219 23.8448 26.5694 23.7892 27.0063C23.6873 27.8057 23.0058 28.37 22.197 28.3738C21.4648 28.376 20.7298 28.3744 19.9952 28.3744Z",
                                                                                fill: "#F3F5FF"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M19.4627 21.4916C19.3802 21.5684 19.3317 21.6106 19.2867 21.6559C18.9405 22.0056 18.5961 22.3575 18.2483 22.7059C18.0014 22.9534 17.6573 22.9716 17.4342 22.755C17.2111 22.5384 17.2198 22.1831 17.4627 21.9387C18.1695 21.2275 18.8787 20.5188 19.5902 19.8125C19.8402 19.5625 20.167 19.5625 20.417 19.8125C21.1333 20.5229 21.8466 21.2364 22.557 21.9528C22.7908 22.1888 22.792 22.5434 22.5748 22.7553C22.3577 22.9672 22.0123 22.9578 21.7739 22.7213C21.4208 22.3697 21.073 22.0125 20.7223 21.6588C20.677 21.6131 20.6286 21.5706 20.5564 21.5025C20.5517 21.6006 20.5461 21.6641 20.5461 21.7275C20.5461 22.8459 20.5477 23.9641 20.5461 25.0825C20.5461 25.5022 20.1767 25.7519 19.7927 25.6025C19.5802 25.5197 19.4648 25.3353 19.4648 25.0653C19.4636 23.9591 19.4636 22.8529 19.4648 21.7469L19.4627 21.4916Z",
                                                                                fill: "#F3F5FF"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                            id: "clip0_6001_237_dq",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                width: "16",
                                                                                height: "16",
                                                                                fill: "white",
                                                                                transform: "translate(12 16)"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "op80 pen fs0-75rem fw400 c12 tac mt0-5rem fsi",
                                                                children: "Click here or drag and drop files (max 100MB)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                onChange: (e)=>saveAnswer(e, question, qNo),
                                                                className: "dn",
                                                                id: "fileUpload" + question._id,
                                                                type: "file",
                                                                multiple: true
                                                            })
                                                        ]
                                                    }),
                                                    uploadOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            answer.files && answer.files.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fw500 c12 mt1rem fs0-75rem",
                                                                children: "Attached Files"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df fdc w100",
                                                                style: {
                                                                    maxHeight: '20vh',
                                                                    overflow: 'auto'
                                                                },
                                                                children: answer.files && answer.files.map((file, fileIndex)=>{
                                                                    const fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic py0-5rem bg1 px1rem br20px mt0-5rem",
                                                                        style: {
                                                                            maxWidth: 'max-content'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df aic cp",
                                                                                onClick: ()=>getViewableURL(file.location),
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: `br50px mr0-5rem ${fileColor}`,
                                                                                        style: {
                                                                                            width: '10px',
                                                                                            height: '10px',
                                                                                            minWidth: '10px',
                                                                                            flexShrink: 0
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "fw500 c14 fs12px",
                                                                                        children: file.originalname?.length > 40 ? file.originalname.slice(0, 40) + '...' : file.originalname
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99875422f9004601$export$2e2bcd8739ae039), {
                                                                                aiMatch: file.aiMatch,
                                                                                fileName: file.originalname
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                className: "fa fa-trash-o cp c23 ml0-5rem",
                                                                                onClick: (e)=>{
                                                                                    e.preventDefault();
                                                                                    setDeleteFileQuestionId(question._id);
                                                                                    setDeleteFile(file);
                                                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                                        open: 'deleteFile',
                                                                                        from: ''
                                                                                    }));
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, `allocated-file-${question._id}-${fileIndex}-${file.key || file.originalname}`);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            question?.questionType.includes("T") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: module['type'].includes("investor-lead") && question['qNo'] == "DEPF008.3.1" ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "mah40vh oa oyh td250 pr mt1rem",
                                                    children: question?.['subQuestions'] && question['subQuestions'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: question?.['subQuestions'].map((subQuestion, subIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        children: subQuestion['subQDescription']
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                        defaultValue: question?.['answer']?.['subAnswers'] && question?.['answer']?.['subAnswers']?.[subQuestion['subQNo']],
                                                                        rows: "1",
                                                                        style: {
                                                                            resize: "vertical"
                                                                        },
                                                                        onBlur: (e)=>saveAnswer(e, question, qNo),
                                                                        name: subQuestion['subQNo'],
                                                                        type: "text",
                                                                        className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                                        placeholder: "Please enter director LinkedIn url here"
                                                                    })
                                                                ]
                                                            }, `subquestion-${question._id}-${subIdx}-${subQuestion['subQNo']}`))
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        defaultValue: answer.comment,
                                                        rows: "1",
                                                        style: {
                                                            resize: "vertical"
                                                        },
                                                        onBlur: (e)=>saveAnswer(e, question, qNo),
                                                        name: "comment",
                                                        type: "text",
                                                        className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                        placeholder: "Please enter director LinkedIn url here"
                                                    })
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: (question?.questionType.includes("YN") ? showFiles ? "" : "op0 h0 dn " : "") + "oyh td250 pr mt1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        defaultValue: answer.comment,
                                                        rows: "3",
                                                        style: {
                                                            resize: "vertical"
                                                        },
                                                        onBlur: (e)=>saveAnswer(e, question, qNo),
                                                        name: "comment",
                                                        type: "text",
                                                        className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                        placeholder: "Any notes you wish to add"
                                                    })
                                                })
                                            })
                                        ]
                                    }) : null
                                })
                            })
                        }) : null,
                        !rightPanelTab && module['uploadFiles'] !== false && (module['type']?.includes('directors-questionnaire') || module['type']?.includes('investor-lead')) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                question?.questionType.includes("F") && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: (question?.questionType.includes("YN") ? showFiles ? "" : "op0 h0 dn " : "") + "showOrHide oyh td250 oxh p1rem px1-5rem br10px",
                                    style: {
                                        background: '#F3F5FF'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic jcsb mb0-5rem cp",
                                            onClick: ()=>setUploadOpen((o)=>!o),
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            className: "mr0-5rem",
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 20 20",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                    clipPath: "url(#clip0_6001_294_dq)",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M4.85746 16.7168C2.75033 14.9386 2.60107 11.6378 4.52471 9.35828L9.75741 3.15748C10.9943 1.69173 13.1027 1.43054 14.4565 2.57298C15.8103 3.71542 15.9073 5.83769 14.6704 7.30344L9.68688 13.209C9.27425 13.6979 8.57252 13.7852 8.12052 13.4038C7.66853 13.0224 7.63658 12.316 8.04922 11.827L13.0327 5.92146C13.4454 5.43248 13.4123 4.72514 12.9614 4.34464C12.5105 3.96413 11.8077 4.05049 11.3951 4.53947L6.16237 10.7403C5.06301 12.043 5.14829 13.9289 6.35252 14.9451C7.55675 15.9613 9.43012 15.7283 10.5295 14.4256L17.2572 6.45311C17.6699 5.96414 18.3716 5.87685 18.8236 6.25828C19.2756 6.63971 19.3075 7.34612 18.8949 7.8351L12.1671 15.8076C10.2435 18.0871 6.96459 18.4949 4.85746 16.7168Z",
                                                                        fill: "#4A67FF"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                        id: "clip0_6001_294_dq",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                            width: "20",
                                                                            height: "20",
                                                                            fill: "white"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "fs16px c14 fw400 mb0",
                                                            children: [
                                                                "Files ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "fs14px c12",
                                                                    children: [
                                                                        "(",
                                                                        answer.files?.length ?? 0,
                                                                        ")"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    style: {
                                                        transition: 'transform 0.2s',
                                                        transform: uploadOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                                                    },
                                                    width: "16",
                                                    height: "16",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M6 9l6 6 6-6",
                                                        stroke: "#4A67FF",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            ]
                                        }),
                                        uploadOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                            onDragOver: onDragOver,
                                            onDrop: (e)=>onDrop(e, question, qNo),
                                            htmlFor: "fileUpload" + question._id,
                                            className: "w100 bg1 br10px df jcc fdc aic px2rem py0-5rem cp mb0-5rem",
                                            style: {
                                                border: '2px dotted #d2d2d2'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "40",
                                                    height: "40",
                                                    viewBox: "0 0 40 40",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M33.979 17.7398C33.4537 14.3775 30.5388 11.7969 27.0312 11.7969C25.7117 11.7969 24.4438 12.162 23.344 12.8429C21.6709 10.031 18.6588 8.28125 15.3125 8.28125C10.1432 8.28125 5.9375 12.487 5.9375 17.6562C5.9375 17.6883 5.9375 17.7215 5.93867 17.7535C2.61641 18.3131 0 21.2096 0 24.6875C0 28.5648 3.23211 31.7188 7.10938 31.7188H32.8906C36.7679 31.7188 40 28.5648 40 24.6875C40 21.1799 37.3413 18.2651 33.979 17.7398Z",
                                                            fill: "#F3F5FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                            clipPath: "url(#clip0_6001_237_dq)",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M20 32C24.4183 32 28 28.4183 28 24C28 19.5817 24.4183 16 20 16C15.5817 16 12 19.5817 12 24C12 28.4183 15.5817 32 20 32Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M19.9952 28.3744C19.2845 28.3744 18.574 28.3744 17.8636 28.3744C16.8892 28.3744 16.1861 27.6738 16.1811 26.6997C16.1792 26.3597 16.1792 26.0196 16.1811 25.6794C16.183 25.3288 16.3955 25.1032 16.7205 25.1025C17.0455 25.1019 17.2608 25.326 17.263 25.6763C17.2652 26.0266 17.263 26.3688 17.263 26.715C17.2655 27.0782 17.4789 27.2897 17.8433 27.29C19.2827 27.29 20.7219 27.29 22.1611 27.29C22.5258 27.29 22.7395 27.0782 22.7423 26.7154C22.7448 26.3691 22.7423 26.0229 22.7423 25.6766C22.7423 25.3304 22.9583 25.1019 23.2845 25.1025C23.6108 25.1032 23.8264 25.3288 23.8236 25.6791C23.8202 26.1219 23.8448 26.5694 23.7892 27.0063C23.6873 27.8057 23.0058 28.37 22.197 28.3738C21.4648 28.376 20.7298 28.3744 19.9952 28.3744Z",
                                                                    fill: "#F3F5FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M19.4627 21.4916C19.3802 21.5684 19.3317 21.6106 19.2867 21.6559C18.9405 22.0056 18.5961 22.3575 18.2483 22.7059C18.0014 22.9534 17.6573 22.9716 17.4342 22.755C17.2111 22.5384 17.2198 22.1831 17.4627 21.9387C18.1695 21.2275 18.8787 20.5188 19.5902 19.8125C19.8402 19.5625 20.167 19.5625 20.417 19.8125C21.1333 20.5229 21.8466 21.2364 22.557 21.9528C22.7908 22.1888 22.792 22.5434 22.5748 22.7553C22.3577 22.9672 22.0123 22.9578 21.7739 22.7213C21.4208 22.3697 21.073 22.0125 20.7223 21.6588C20.677 21.6131 20.6286 21.5706 20.5564 21.5025C20.5517 21.6006 20.5461 21.6641 20.5461 21.7275C20.5461 22.8459 20.5477 23.9641 20.5461 25.0825C20.5461 25.5022 20.1767 25.7519 19.7927 25.6025C19.5802 25.5197 19.4648 25.3353 19.4648 25.0653C19.4636 23.9591 19.4636 22.8529 19.4648 21.7469L19.4627 21.4916Z",
                                                                    fill: "#F3F5FF"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                id: "clip0_6001_237_dq",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    fill: "white",
                                                                    transform: "translate(12 16)"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "op80 pen fs0-75rem fw400 c12 tac mt0-5rem fsi",
                                                    children: "Click here or drag and drop files (max 100MB)"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    onChange: (e)=>saveAnswer(e, question, qNo),
                                                    className: "dn",
                                                    id: "fileUpload" + question._id,
                                                    type: "file",
                                                    multiple: true
                                                })
                                            ]
                                        }),
                                        uploadOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                answer.files && answer.files.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fw500 c12 mt1rem fs0-75rem",
                                                    children: "Attached Files"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "df fdc w100",
                                                    style: {
                                                        maxHeight: '20vh',
                                                        overflow: 'auto'
                                                    },
                                                    children: answer.files && answer.files.map((file, fileIndex)=>{
                                                        const fileColor = file.originator == 'filing-assistant' ? 'filing-assistant-file' : file.originator == 'sharepoint' ? 'sharepoint-file' : file.originator == 'dropbox' ? 'dropbox-file' : file.originator == 'gdrive' ? 'gdrive-file' : file.bucket == `repository-diligentsia${(0, $6a6b4b5ab5be324d$export$e5d97828673c2a38) === "production" ? "-prod" : ""}` ? "upload-file" : 'prepopulated-file';
                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df aic py0-5rem bg1 px1rem br20px mt0-5rem",
                                                            style: {
                                                                maxWidth: 'max-content'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic cp",
                                                                    onClick: ()=>getViewableURL(file.location),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: `br50px mr0-5rem ${fileColor}`,
                                                                            style: {
                                                                                width: '10px',
                                                                                height: '10px',
                                                                                minWidth: '10px',
                                                                                flexShrink: 0
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "fw500 c14 fs12px",
                                                                            children: file.originalname?.length > 40 ? file.originalname.slice(0, 40) + '...' : file.originalname
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99875422f9004601$export$2e2bcd8739ae039), {
                                                                    aiMatch: file.aiMatch,
                                                                    fileName: file.originalname
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-trash-o cp c23 ml0-5rem",
                                                                    onClick: (e)=>{
                                                                        e.preventDefault();
                                                                        setDeleteFileQuestionId(question._id);
                                                                        setDeleteFile(file);
                                                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                            open: 'deleteFile',
                                                                            from: ''
                                                                        }));
                                                                    }
                                                                })
                                                            ]
                                                        }, `allocated-file-${question._id}-${fileIndex}-${file.key || file.originalname}`);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                question?.questionType.includes("T") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: module['type'].includes("investor-lead") && question['qNo'] === 'DEPF008.3.1' ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mah40vh oa oyh td250 pr mt1rem",
                                        children: question?.['subQuestions']?.length > 0 ? question['subQuestions'].map((subQuestion, subIdx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: subQuestion['subQDescription']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                        defaultValue: question?.['answer']?.['subAnswers']?.[subQuestion['subQNo']],
                                                        rows: "1",
                                                        style: {
                                                            resize: 'vertical'
                                                        },
                                                        onBlur: (e)=>saveAnswer(e, question, qNo),
                                                        name: subQuestion['subQNo'],
                                                        type: "text",
                                                        className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                                        placeholder: "Please enter director LinkedIn url here"
                                                    })
                                                ]
                                            }, `subquestion-${question._id}-${subIdx}-${subQuestion['subQNo']}`)) : /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            defaultValue: answer?.comment,
                                            rows: "1",
                                            style: {
                                                resize: 'vertical'
                                            },
                                            onBlur: (e)=>saveAnswer(e, question, qNo),
                                            name: "comment",
                                            type: "text",
                                            className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                            placeholder: "Please enter director LinkedIn url here"
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: (question?.questionType.includes('YN') ? showFiles ? '' : 'op0 h0 dn ' : '') + 'oyh td250 pr mt1rem',
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                            defaultValue: answer?.comment,
                                            rows: 2,
                                            style: {
                                                resize: 'vertical'
                                            },
                                            onBlur: (e)=>saveAnswer(e, question, qNo),
                                            name: "comment",
                                            type: "text",
                                            className: "pl1-5rem bss bw2px bo5 w100 br5px p1rem",
                                            placeholder: "Please enter your answer"
                                        })
                                    })
                                })
                            ]
                        }),
                        (question.questionType === 'YN/IMG' && answer.radioOption === "Yes" || question.questionType === 'FILE') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 mt0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: `w100 bsbb br5px df jcc fdc aic px2rem py0-5rem bsd bw2px cp mb0-5rem td300 ${isDragOver ? 'bg35 bo7' : 'bg50 bo3'}`,
                                    onDragOver: (e)=>{
                                        e.preventDefault();
                                        setIsDragOver(true);
                                    },
                                    onDragLeave: ()=>setIsDragOver(false),
                                    onDrop: (e)=>{
                                        e.preventDefault();
                                        setIsDragOver(false);
                                        if (e.dataTransfer.files && e.dataTransfer.files[0]) saveAnswer({
                                            target: {
                                                files: e.dataTransfer.files
                                            }
                                        }, question, qNo);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "70",
                                            height: "70",
                                            viewBox: "0 0 70 70",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M59.4632 31.0446C58.5439 25.1606 53.4429 20.6445 47.3047 20.6445C44.9955 20.6445 42.7766 21.2834 40.852 22.4751C37.924 17.5543 32.6528 14.4922 26.7969 14.4922C17.7506 14.4922 10.3906 21.8522 10.3906 30.8984C10.3906 30.9545 10.3906 31.0126 10.3927 31.0687C4.57871 32.048 0 37.1168 0 43.2031C0 49.9883 5.65619 55.5078 12.4414 55.5078H57.5586C64.3438 55.5078 70 49.9883 70 43.2031C70 37.0649 65.3472 31.9639 59.4632 31.0446Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    clipPath: `url(#clip_upload_${question._id})`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M35 56C42.732 56 49 49.732 49 42C49 34.268 42.732 28 35 28C27.268 28 21 34.268 21 42C21 49.732 27.268 56 35 56Z",
                                                            fill: "#4A67FF"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M34.9896 49.6555C33.746 49.6555 32.5026 49.6555 31.2593 49.6555C29.5542 49.6555 28.3237 48.4294 28.315 46.7248C28.3117 46.1298 28.3117 45.5346 28.315 44.9392C28.3182 44.3256 28.6901 43.9308 29.2589 43.9297C29.8276 43.9286 30.2044 44.3207 30.2082 44.9338C30.2121 45.5468 30.2082 46.1456 30.2082 46.7516C30.2126 47.387 30.5861 47.7573 31.2238 47.7578C33.7427 47.7578 36.2614 47.7578 38.78 47.7578C39.4182 47.7578 39.7922 47.387 39.7971 46.7521C39.8015 46.1462 39.7971 45.5402 39.7971 44.9343C39.7971 44.3284 40.175 43.9286 40.746 43.9297C41.3169 43.9308 41.6943 44.3256 41.6893 44.9387C41.6833 45.7136 41.7265 46.4967 41.6292 47.2613C41.4509 48.6602 40.2582 49.6478 38.8429 49.6544C37.5615 49.6582 36.2753 49.6555 34.9896 49.6555Z",
                                                            fill: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M34.0577 37.6102C33.9133 37.7448 33.8286 37.8186 33.7498 37.8979C33.1439 38.5098 32.5412 39.1256 31.9325 39.7354C31.5005 40.1685 30.8984 40.2002 30.5079 39.8212C30.1175 39.4423 30.1328 38.8205 30.5577 38.3928C31.7947 37.1481 33.0358 35.9078 34.2808 34.6719C34.7183 34.2344 35.2904 34.2344 35.7279 34.6719C36.9813 35.9151 38.2296 37.1636 39.4729 38.4174C39.8819 38.8303 39.8841 39.451 39.504 39.8218C39.124 40.1926 38.5197 40.1762 38.1024 39.7622C37.4844 39.147 36.8758 38.5219 36.2622 37.9028C36.1829 37.823 36.0981 37.7486 35.9718 37.6294C35.9636 37.8011 35.9537 37.9121 35.9537 38.0231C35.9537 39.9804 35.9565 41.9371 35.9537 43.8944C35.9537 44.6288 35.3073 45.0658 34.6352 44.8044C34.2633 44.6595 34.0615 44.3368 34.0615 43.8643C34.0593 41.9284 34.0593 39.9926 34.0615 38.057L34.0577 37.6102Z",
                                                            fill: "white"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                        id: `clip_upload_${question._id}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                            width: "28",
                                                            height: "28",
                                                            fill: "white",
                                                            transform: "translate(21 28)"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs0-875rem fw400 c12 tac mt1rem mb0-25rem",
                                            children: "Click here or drag and drop files"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs12px fw400 c12 tac mb1rem",
                                            children: "(max 100MB)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "file",
                                            className: "dn",
                                            multiple: true,
                                            onChange: (e)=>{
                                                if (e.target.files && e.target.files[0]) saveAnswer(e, question, qNo);
                                            }
                                        })
                                    ]
                                }),
                                answer?.files?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "fs12px fw500 c14 bg5 px1rem py0-25rem br5px",
                                            children: [
                                                answer.files.length,
                                                " file",
                                                answer.files.length !== 1 ? 's' : '',
                                                " uploaded"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df fww gg0-5rem mt0-5rem",
                                            children: answer.files.map((file, fi)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic br5px bg5 px0-75rem py0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: file.location,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            className: "fs12px c3 fw500",
                                                            children: file.originalname
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "fa fa-trash-o cp c23 ml0-5rem",
                                                            onClick: (e)=>{
                                                                e.preventDefault();
                                                                setDeleteFileQuestionId(question._id);
                                                                setDeleteFile(file);
                                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: 'deleteFile',
                                                                    from: ''
                                                                }));
                                                            }
                                                        })
                                                    ]
                                                }, fi))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, question._id);
}



const $bc1b61278319d25b$var$subFolderModules = [
    "repository"
];
function $bc1b61278319d25b$export$2e2bcd8739ae039({ module: module, currentSection: currentSection, section: // State
section, refresh: refresh, loading: loading, isSaving: isSaving, questionsAndAnswersToSave: questionsAndAnswersToSave, attachment: attachment, visibleSection: visibleSection, isFAMenuVisible: isFAMenuVisible, deleteFile: deleteFile, dateValue: dateValue, additionalSections: additionalSections, isSectionNameDuplicate: isSectionNameDuplicate, reportGenerateLoading: reportGenerateLoading, hasAgreedAiReportDisclaimer: hasAgreedAiReportDisclaimer, saveAnswer: // Handlers
saveAnswer, radioButtonChanged: radioButtonChanged, handleFileChange: handleFileChange, confirmDeleteFile: confirmDeleteFile, syncDrive: syncDrive, syncDropbox: syncDropbox, syncSharePoint: syncSharePoint, generateInsuranceAiReport: generateInsuranceAiReport, handleSectionReportLinkClick: handleSectionReportLinkClick, setSection: setSection, setRefresh: setRefresh, setDeleteFile: setDeleteFile, setDeleteFileQuestionId: setDeleteFileQuestionId, handleSectionLogs: handleSectionLogs, setLogModule: setLogModule, onClickFileManager: onClickFileManager, answerSaved: answerSaved, getViewableURL: getViewableURL, getFilesFromQuestions: getFilesFromQuestions, showRiskRecommendation: showRiskRecommendation, sortQuestionsByQNo: sortQuestionsByQNo, getReportGenerationKey: getReportGenerationKey, hasSectionReport: hasSectionReport, getSectionReport: getSectionReport, getSectionTabName: getSectionTabName, getCompletenessAndRiskHTML: getCompletenessAndRiskHTML, user: // Redux state
user, modal: modal, company: // Parent props
company, tab: tab, permissionLevel: permissionLevel, advisors: advisors, companyId: companyId, openKPI: openKPI, isTwoMinuteTesHomePage: isTwoMinuteTesHomePage, sortSections: sortSections, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, onDragOver: onDragOver, onDrop: onDrop, handleDateChange: handleDateChange, dispatch: // dispatch
dispatch, toggleModal: toggleModal, sectionRefs: sectionRefs, moduleId: moduleId, reloadModule: reloadModule, patchAnswerInModule: patchAnswerInModule, ancestorSectionName: ancestorSectionName = null, indentLevel: indentLevel = 0 }) {
    if (module) module = JSON.parse(JSON.stringify(module));
    if (currentSection) currentSection = JSON.parse(JSON.stringify(currentSection));
    const parentSectionName = ancestorSectionName || currentSection?.['sectionName'] || currentSection?.['name'] || null;
    let convert;
    if (module['type'].includes('directors-questionnaire')) convert = currentSection?.subFolders || module?.sections[0]?.subFolders;
    else convert = currentSection?.subFolders || module?.sections;
    const getQuestionsForNode = (node, inheritedQuestions = [])=>{
        const qNo = node?.sectionNo || node?.no;
        const ownPool = Array.isArray(node?.questions) && node.questions.length > 0 ? node.questions : inheritedQuestions;
        const matched = (ownPool || []).filter((q)=>q?.qNo === qNo);
        if (matched.length > 0) return matched;
        if (node?.question) return [
            node.question
        ];
        return [];
    };
    const hasNestedRenderableContent = (node, inheritedQuestions = [])=>{
        const ownQuestions = getQuestionsForNode(node, inheritedQuestions);
        const childNodes = Object.values(node?.subFolders || {});
        if (ownQuestions.length > 0) return true;
        // Expansion-pack style: section owns a flat questions array (e.g. DEPF008 with DEPF008.1, DEPF008.2…)
        if (Array.isArray(node?.questions) && node.questions.length > 0) return true;
        return childNodes.some((child)=>hasNestedRenderableContent(child, Array.isArray(node?.questions) ? node.questions : inheritedQuestions));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            convert && Object.values(convert).filter((s)=>hasNestedRenderableContent(s, currentSection?.questions || [])).slice().sort(sortSections).map((sectionItem, sectionIdx)=>{
                // Reason: checklist modules (internal/external/all) store their own permissions within the module — skip dashboard permission filters
                const isChecklistModule = !module?.['dashboardPlacements'];
                const creatorId = company?.['creatorId']?.['_id'] || company?.['creatorId'];
                const isCreator = user?.['_id']?.toString() === creatorId?.toString();
                if (!isChecklistModule && !isCreator) {
                    // Hide sections for advisors/investors who lack explicit section permission
                    // Exception: Investor Match / IR; UD001–UD005 / UD021–UD025 / CS… custom slots always visible
                    if ((user['role'] === 'Advisor' || user['role'] === 'Investor') && user?.['companyId']?.['_id'] && user?.['companyId']?.['_id'] != company?.['_id'] && sectionItem?.['sectionNo'] && !module?.isInvestorMatch && !module?.isInvestmentReadiness && !(0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(sectionItem['sectionNo'])) {
                        if (user['role'] === 'Advisor') {
                            const advisorModules = company?.['advisors']?.[user['_id']]?.['modules'];
                            if (advisorModules && !advisorModules[sectionItem['sectionNo']]) return null;
                        }
                        if (user['role'] === 'Investor') {
                            const investorModules = company?.['investors']?.[user['_id']]?.['modules'];
                            if (investorModules && !investorModules[sectionItem['sectionNo']]) return null;
                        }
                    }
                    // Hide sections for Members who lack explicit section permission
                    if ((user['role'] === 'Member' || user['role'] === 'User' && user['createdBy'] || user['role'] === 'User' && !company?.['owner']?.includes(user['_id'])) && sectionItem?.['sectionNo'] && !(0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(sectionItem['sectionNo'])) {
                        const memberPerms = company?.['memberPermissions']?.[user['_id']];
                        if (memberPerms && !memberPerms[sectionItem['sectionNo']]) return null;
                    }
                }
                const qNo = sectionItem.sectionNo || sectionItem.no;
                const sectionId = sectionItem['_id'] || sectionItem['sectionId'] || `section-${sectionIdx}`;
                let questions;
                let showSubFolder = false;
                let subfolderGroups = null;
                if (module['expansionPack']) {
                    showSubFolder = qNo.indexOf('.') < 0;
                    questions = qNo.indexOf('.') > 0 ? sectionItem['questions'] : [];
                    sectionItem.stats = sectionItem.stats || currentSection?.stats; // Temporary
                } else if ($bc1b61278319d25b$var$subFolderModules.includes(module.type)) {
                    if (currentSection) sectionItem.questions = currentSection.questions;
                    showSubFolder = Object.values(sectionItem && sectionItem?.subFolders || {}).length > 0;
                    questions = getQuestionsForNode(sectionItem, currentSection?.questions || []);
                } else if ((module.isInvestorMatch || module.isInvestmentReadiness) && sectionItem.subFolders && Object.keys(sectionItem.subFolders).length > 0) {
                    const allQuestions = sectionItem.questions || [];
                    subfolderGroups = Object.values(sectionItem.subFolders).map((sfNode)=>{
                        const sfNo = sfNode.sectionNo || sfNode.no;
                        const sfName = sfNode.sectionName || sfNode.name;
                        if (!sfNo) return null;
                        const escaped = sfNo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                        const re = new RegExp(`^${escaped}(\\.[0-9].*)?$`);
                        const sfQuestions = allQuestions.filter((q)=>q.qNo && re.test(q.qNo));
                        const completed = sfQuestions.filter((q)=>q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
                        const completionPercent = sfQuestions.length ? Math.round(completed / sfQuestions.length * 100) : 0;
                        return {
                            sfNo: sfNo,
                            sfName: sfName,
                            sfQuestions: sortQuestionsByQNo([
                                ...sfQuestions
                            ]),
                            completionPercent: completionPercent
                        };
                    }).filter(Boolean);
                    questions = allQuestions;
                } else questions = sectionItem.questions.filter((q)=>q.qNo.match(new RegExp(qNo + "(\.[0-9]+)|$")));
                sectionItem.files = [];
                sectionItem.files = getFilesFromQuestions(questions);
                // Sort all questions.
                questions = questions && sortQuestionsByQNo([
                    ...questions || []
                ]);
                const jsx = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: subfolderGroups ? subfolderGroups.map(({ sfNo: sfNo, sfName: sfName, sfQuestions: sfQuestions, completionPercent: completionPercent }, groupIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            id: sfNo,
                            className: "sectionWrapper br10px p1rem fs1rem mb1rem bg1",
                            style: {
                                boxShadow: '0 6px 16px rgba(0, 0, 0, 0.10), 0 2px 4px rgba(0, 0, 0, 0.06)'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dg",
                                children: sfQuestions.map((question, questionIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a51f428ec710cfe5$export$2e2bcd8739ae039), {
                                        question: question,
                                        questionIdx: questionIdx,
                                        sectionIdx: sectionIdx,
                                        section: sectionItem,
                                        qNo: sfNo,
                                        sectionId: sfNo,
                                        showSubFolder: false,
                                        module: module,
                                        isSaving: isSaving,
                                        isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                                        reportGenerateLoading: reportGenerateLoading,
                                        aiEnhanced: aiEnhanced,
                                        setAiEnchaned: setAiEnchaned,
                                        company: company,
                                        tab: tab,
                                        user: user,
                                        saveAnswer: saveAnswer,
                                        radioButtonChanged: radioButtonChanged,
                                        syncDrive: syncDrive,
                                        syncSharePoint: syncSharePoint,
                                        syncDropbox: syncDropbox,
                                        setSection: setSection,
                                        handleSectionLogs: handleSectionLogs,
                                        setLogModule: setLogModule,
                                        onClickFileManager: onClickFileManager,
                                        generateInsuranceAiReport: generateInsuranceAiReport,
                                        handleSectionReportLinkClick: handleSectionReportLinkClick,
                                        hasSectionReport: hasSectionReport,
                                        getSectionTabName: getSectionTabName,
                                        getReportGenerationKey: getReportGenerationKey,
                                        showRiskRecommendation: showRiskRecommendation,
                                        answerSaved: answerSaved,
                                        getViewableURL: getViewableURL,
                                        setDeleteFileQuestionId: setDeleteFileQuestionId,
                                        setDeleteFile: setDeleteFile,
                                        onDragOver: onDragOver,
                                        onDrop: onDrop,
                                        handleDateChange: handleDateChange,
                                        dateValue: dateValue,
                                        dispatch: dispatch,
                                        toggleModal: toggleModal,
                                        moduleId: moduleId,
                                        reloadModule: reloadModule,
                                        patchAnswerInModule: patchAnswerInModule,
                                        ancestorSectionName: parentSectionName || sectionItem['sectionName'] || sectionItem['name'],
                                        nestingLevel: indentLevel
                                    }, question._id))
                            })
                        }, sfNo)) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            questions && questions.length > 0 && questions.map((question, questionIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a51f428ec710cfe5$export$2e2bcd8739ae039), {
                                    question: question,
                                    questionIdx: questionIdx,
                                    sectionIdx: sectionIdx,
                                    section: sectionItem,
                                    qNo: qNo,
                                    sectionId: sectionId,
                                    showSubFolder: showSubFolder,
                                    module: module,
                                    isSaving: isSaving,
                                    isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                                    reportGenerateLoading: reportGenerateLoading,
                                    aiEnhanced: aiEnhanced,
                                    setAiEnchaned: setAiEnchaned,
                                    company: company,
                                    tab: tab,
                                    user: user,
                                    saveAnswer: saveAnswer,
                                    radioButtonChanged: radioButtonChanged,
                                    syncDrive: syncDrive,
                                    syncSharePoint: syncSharePoint,
                                    syncDropbox: syncDropbox,
                                    setSection: setSection,
                                    handleSectionLogs: handleSectionLogs,
                                    setLogModule: setLogModule,
                                    onClickFileManager: onClickFileManager,
                                    generateInsuranceAiReport: generateInsuranceAiReport,
                                    handleSectionReportLinkClick: handleSectionReportLinkClick,
                                    hasSectionReport: hasSectionReport,
                                    getSectionTabName: getSectionTabName,
                                    getReportGenerationKey: getReportGenerationKey,
                                    showRiskRecommendation: showRiskRecommendation,
                                    answerSaved: answerSaved,
                                    getViewableURL: getViewableURL,
                                    setDeleteFileQuestionId: setDeleteFileQuestionId,
                                    setDeleteFile: setDeleteFile,
                                    onDragOver: onDragOver,
                                    onDrop: onDrop,
                                    handleDateChange: handleDateChange,
                                    dateValue: dateValue,
                                    dispatch: dispatch,
                                    toggleModal: toggleModal,
                                    moduleId: moduleId,
                                    reloadModule: reloadModule,
                                    patchAnswerInModule: patchAnswerInModule,
                                    ancestorSectionName: parentSectionName || sectionItem['sectionName'] || sectionItem['name'],
                                    nestingLevel: indentLevel
                                }, question._id)),
                            showSubFolder && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "toggleHeight cp",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "oh dg",
                                    style: {
                                        cursor: "auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($bc1b61278319d25b$export$2e2bcd8739ae039, {
                                            module: module,
                                            currentSection: sectionItem,
                                            section: section,
                                            ancestorSectionName: parentSectionName || sectionItem['sectionName'] || sectionItem['name'],
                                            indentLevel: indentLevel + 1,
                                            refresh: refresh,
                                            loading: loading,
                                            isSaving: isSaving,
                                            questionsAndAnswersToSave: questionsAndAnswersToSave,
                                            attachment: attachment,
                                            visibleSection: visibleSection,
                                            isFAMenuVisible: isFAMenuVisible,
                                            deleteFile: deleteFile,
                                            dateValue: dateValue,
                                            additionalSections: additionalSections,
                                            isSectionNameDuplicate: isSectionNameDuplicate,
                                            reportGenerateLoading: reportGenerateLoading,
                                            hasAgreedAiReportDisclaimer: hasAgreedAiReportDisclaimer,
                                            saveAnswer: saveAnswer,
                                            radioButtonChanged: radioButtonChanged,
                                            handleFileChange: handleFileChange,
                                            confirmDeleteFile: confirmDeleteFile,
                                            syncDrive: syncDrive,
                                            syncDropbox: syncDropbox,
                                            syncSharePoint: syncSharePoint,
                                            generateInsuranceAiReport: generateInsuranceAiReport,
                                            handleSectionReportLinkClick: handleSectionReportLinkClick,
                                            setSection: setSection,
                                            setRefresh: setRefresh,
                                            setDeleteFile: setDeleteFile,
                                            setDeleteFileQuestionId: setDeleteFileQuestionId,
                                            handleSectionLogs: handleSectionLogs,
                                            setLogModule: setLogModule,
                                            onClickFileManager: onClickFileManager,
                                            answerSaved: answerSaved,
                                            getViewableURL: getViewableURL,
                                            getFilesFromQuestions: getFilesFromQuestions,
                                            showRiskRecommendation: showRiskRecommendation,
                                            sortQuestionsByQNo: sortQuestionsByQNo,
                                            getReportGenerationKey: getReportGenerationKey,
                                            hasSectionReport: hasSectionReport,
                                            getSectionReport: getSectionReport,
                                            getSectionTabName: getSectionTabName,
                                            getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                                            user: user,
                                            modal: modal,
                                            company: company,
                                            tab: tab,
                                            permissionLevel: permissionLevel,
                                            advisors: advisors,
                                            companyId: companyId,
                                            openKPI: openKPI,
                                            isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                                            sortSections: sortSections,
                                            aiEnhanced: aiEnhanced,
                                            setAiEnchaned: setAiEnchaned,
                                            onDragOver: onDragOver,
                                            onDrop: onDrop,
                                            handleDateChange: handleDateChange,
                                            dispatch: dispatch,
                                            toggleModal: toggleModal,
                                            sectionRefs: sectionRefs,
                                            moduleId: moduleId,
                                            reloadModule: reloadModule,
                                            patchAnswerInModule: patchAnswerInModule
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                });
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    ref: (el)=>{
                        if (sectionItem['sectionNo']) sectionRefs.current[sectionIdx] = el;
                    },
                    id: qNo,
                    className: (sectionItem['sectionNo'] && "sectionWrapper ") + " br10px p1rem fs1rem bg1",
                    style: {
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.10), 0 2px 4px rgba(0, 0, 0, 0.06)',
                        ...indentLevel > 0 ? {
                            marginLeft: `${indentLevel * 1.5}rem`,
                            borderLeft: '3px solid #DDE2F2'
                        } : {}
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    style: {
                                        gap: '0.75rem',
                                        flexWrap: 'wrap'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                            className: "fs1rem mr0-5rem c15",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fw400",
                                                    children: [
                                                        sectionItem['sectionName'] && `Section ${sectionIdx + 1}: `,
                                                        " "
                                                    ]
                                                }),
                                                sectionItem['sectionName'] || sectionItem['name']
                                            ]
                                        }),
                                        (()=>{
                                            const reportData = getSectionReport(sectionItem, false, null);
                                            const accuracyRating = reportData?.validation?.accuracyRating;
                                            const hasAccuracyRating = accuracyRating !== undefined && accuracyRating !== null && !Number.isNaN(Number(accuracyRating));
                                            return hasAccuracyRating ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcc",
                                                style: {
                                                    padding: '4px 10px',
                                                    background: accuracyRating >= 7 ? '#e8f5e9' : accuracyRating >= 5 ? '#fff3e0' : '#ffebee',
                                                    color: accuracyRating >= 7 ? '#1b5e20' : accuracyRating >= 5 ? '#e65100' : '#c62828',
                                                    border: `1px solid ${accuracyRating >= 7 ? '#c8e6c9' : accuracyRating >= 5 ? '#ffe0b2' : '#ffcdd2'}`,
                                                    borderRadius: '10px',
                                                    fontWeight: '600',
                                                    fontSize: '0.75rem',
                                                    height: '24px',
                                                    lineHeight: '1'
                                                },
                                                children: [
                                                    "Accuracy: ",
                                                    accuracyRating,
                                                    "/10"
                                                ]
                                            }) : null;
                                        })()
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic jcfe",
                                    children: [
                                        !isTwoMinuteTesHomePage && moduleId && (tab === 'repository' || tab?.includes('business-audit') || tab === 'warranty-disclosure' || tab?.includes('directors-questionnaire') || tab === 'Investment Readiness') && sectionItem?.['sectionNo'] && !sectionItem['sectionNo'].includes('.') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83364f35f447dab2$export$2e2bcd8739ae039), {
                                            companyId: companyId,
                                            moduleType: tab,
                                            moduleId: moduleId,
                                            sectionCode: qNo,
                                            scope: "section",
                                            scopeName: sectionItem['sectionName'] || qNo,
                                            size: "small",
                                            onComplete: ()=>reloadModule && reloadModule(tab)
                                        }),
                                        sectionItem['isPrompt'] ? (()=>{
                                            // Check if section has at least one file
                                            const hasFiles = (sectionItem.questions || []).some((q)=>(q.answer?.files || []).some((f)=>f && f.originator !== 'ai-report' && (f.location || f.url))) && sectionItem?.['stats']?.['completionPercent'] === 100;
                                            const currentKey = getReportGenerationKey(sectionItem, false);
                                            const isGenerating = reportGenerateLoading === currentKey;
                                            const isAnyGenerating = reportGenerateLoading !== null;
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic jcc",
                                                style: {
                                                    gap: '0.5rem',
                                                    flexWrap: 'wrap'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        type: "button",
                                                        disabled: isAnyGenerating || !hasFiles,
                                                        onClick: ()=>hasFiles ? generateInsuranceAiReport({
                                                                data: sectionItem,
                                                                isQuestion: false
                                                            }) : "",
                                                        className: `fs14px px1rem br20px cp c3 py0-25rem bg1 ${hasFiles && !isAnyGenerating ? 'br50px bw1px bss bo3' : 'bg5 c15 op50'} `,
                                                        style: {
                                                            height: '40px'
                                                        },
                                                        "data-tooltip": hasFiles ? "" : "Complete the 100% section to generate the report",
                                                        children: isGenerating ? "Generating..." : "Generate Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                        onClick: (e)=>{
                                                            if (isAnyGenerating) {
                                                                e.preventDefault();
                                                                return;
                                                            }
                                                            handleSectionReportLinkClick(e, sectionItem, false, null);
                                                        },
                                                        to: hasSectionReport(sectionItem, false, null) ? `#${getSectionTabName(sectionItem, false, null)}` : "#repository",
                                                        className: `cp p1rem c1 ${hasSectionReport(sectionItem, false, null) && !isAnyGenerating ? 'bg3 bg3-hover' : 'bg5 c15 op50'} br50px fw400 fs14px zi0 td250 df aic jcc`,
                                                        style: {
                                                            width: '40px',
                                                            height: '40px',
                                                            pointerEvents: isAnyGenerating ? 'none' : 'auto',
                                                            cursor: isAnyGenerating ? 'not-allowed' : 'pointer'
                                                        },
                                                        children: "R"
                                                    })
                                                ]
                                            });
                                        })() : null
                                    ]
                                })
                            ]
                        }),
                        module.type === "business-audit" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "toggleHeight cp",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "mb0-5rem td250 fs0-75rem pen bg5 c6 br5px fw600 px0-5rem py0-5rem",
                                    children: "Show Section"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "oh dg",
                                    style: {
                                        cursor: "auto",
                                        height: "0px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                        jsx
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg",
                            children: jsx
                        })
                    ]
                }, `${module.type}-${sectionId}-${qNo}-${sectionIdx}`);
            }),
            (user['role'] == 'Guest' || !user.firstName) && module['type'] == `two-minute-test-${company['testType']}` && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "maw400px mxa my2rem df jcc aic fdc",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    btnType: "warning",
                    text: "Next",
                    disabled: module?.['stats']?.['completionPercent'] != 100,
                    customClassName: "df jcc aic",
                    onClick: ()=>openKPI()
                })
            })
        ]
    });
}





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $6df1e2d737f2c033$var$questionMarkSvg = /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "#9ca3af",
            strokeWidth: "2"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 16v-4m0-4h.01",
            stroke: "#9ca3af",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    ]
});


function $6df1e2d737f2c033$export$2e2bcd8739ae039({ tab: tab, company: company, localModule: localModule, isDataRepository: isDataRepository, onImportFileFolder: onImportFileFolder, onClickFileReportHistory: onClickFileReportHistory, onClickViewUnallocatedFiles: onClickViewUnallocatedFiles, checkDuplicatedFiles: checkDuplicatedFiles, onClickDeduperReportHistory: onClickDeduperReportHistory, onAutoFill: onAutoFill, onDiagnose: onDiagnose, isChecklist: isChecklist }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [diagnoseSelection, setDiagnoseSelection] = (0, $acw62.useState)(new Set([
        'clarence',
        'human'
    ]));
    const toggleDiagnoseSelection = (key)=>{
        setDiagnoseSelection((prev)=>{
            const next = new Set(prev);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    };
    // Maps each info popup key to the action that runs after (or instead of) the popup.
    const faInfoActions = {
        'unallocated-bin': onClickViewUnallocatedFiles,
        'filing-assistant': onClickFileReportHistory,
        'deduper': checkDuplicatedFiles,
        'deduper-reports': onClickDeduperReportHistory
    };
    // Show the info popup only the first time; afterwards run the action directly.
    const onFaInfo = (key)=>(0, $fd71835e1939fbe7$export$7476b3b1a66db3ee)(key, {
            openInfo: (k)=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'filingAssistantInfo',
                    faInfoKey: k
                })),
            runAction: (k)=>faInfoActions[k]?.()
        });
    if (tab === "kitemark") return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                children: "Kitemark Audit"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                children: "Kitemark Report"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                children: "Digital Certificate"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                children: "Full Report"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic",
                children: "Report by Section"
            })
        ]
    });
    if (!localModule) return null;
    const dropdown = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "menu op0 pen zi10 bg1 br10px shadow pa r0 df fdc",
        style: {
            minWidth: '260px'
        },
        children: [
            onAutoFill && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                onClick: isChecklist ? undefined : onAutoFill,
                className: `w100 fs13px fw400 px1rem py0-5rem df aic jcsb ${isChecklist ? 'op50 cna' : 'bg5-hover c14 cp'}`,
                style: {
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 14 14",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        clipPath: "url(#clip0_fa_af)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M3.52723 2.82108L4.74129 3.48554C4.89715 3.5703 4.95458 3.76444 4.86981 3.9203C4.83973 3.97499 4.79598 4.01874 4.74129 4.04882L3.52723 4.71054C3.47254 4.74061 3.42879 4.78436 3.39872 4.83905L2.73426 6.05311C2.6495 6.20897 2.45536 6.2664 2.2995 6.18163C2.24481 6.15155 2.20106 6.1078 2.17098 6.05311L1.50926 4.83905C1.47919 4.78436 1.43544 4.74061 1.38075 4.71054L0.166686 4.04882C0.0108263 3.96405 -0.0465956 3.76991 0.03817 3.61405C0.0682482 3.55936 0.111998 3.51561 0.166686 3.48554L1.38075 2.82108C1.43544 2.791 1.47919 2.74725 1.50926 2.69257L2.17372 1.48124C2.25848 1.32538 2.45536 1.26796 2.61122 1.35546C2.66317 1.38554 2.70692 1.42929 2.737 1.48124L3.40145 2.69257C3.42879 2.74725 3.47254 2.791 3.52723 2.82108Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M13.6881 1.79629L12.5643 0.672464C12.1487 0.256839 11.4733 0.254105 11.0549 0.66973L1.03345 10.6939C0.617823 11.1096 0.615089 11.785 1.03345 12.2033L2.15728 13.3272C2.5729 13.7428 3.24829 13.7455 3.66665 13.3272L13.6881 3.30567C14.1038 2.89004 14.1038 2.21465 13.6881 1.79629Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_fa_af",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "14",
                                                height: "14",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "c3 ml0-5rem",
                                children: [
                                    "Auto Fill",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs10px c12 ml0-5rem",
                                        children: "All Questions"
                                    })
                                ]
                            })
                        ]
                    }),
                    $6df1e2d737f2c033$var$questionMarkSvg
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                onClick: onImportFileFolder,
                className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                style: !onAutoFill ? {
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px'
                } : {},
                children: [
                    "Import File/Folder ",
                    $6df1e2d737f2c033$var$questionMarkSvg
                ]
            }),
            company?.subscription?.toLowerCase() === "pro" && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                onClick: ()=>onFaInfo('filing-assistant'),
                className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                children: [
                    "Filing Assistant History ",
                    $6df1e2d737f2c033$var$questionMarkSvg
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                onClick: ()=>onFaInfo('deduper'),
                className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                children: [
                    "Deduper ",
                    $6df1e2d737f2c033$var$questionMarkSvg
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                onClick: ()=>onFaInfo('deduper-reports'),
                className: "w100 bg5-hover c14 fs13px fw400 px1rem py0-5rem cp df aic jcsb",
                style: {
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px'
                },
                children: [
                    "Deduper Reports ",
                    $6df1e2d737f2c033$var$questionMarkSvg
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "w100 c14 fs13px fw400 px1rem py0-5rem cna op50 df aic jcsb",
                children: [
                    "Audit Log ",
                    $6df1e2d737f2c033$var$questionMarkSvg
                ]
            }),
            (0, $6a6b4b5ab5be324d$export$2908142509316f06) && onDiagnose && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `sub-menuHover pr w100${isChecklist ? ' op50 cna' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: `w100 fs13px fw400 px1rem py0-5rem df aic jcsb ${isChecklist ? 'cna' : 'bg5-hover c14 cp'}`,
                        style: {
                            borderBottomLeftRadius: '10px',
                            borderBottomRightRadius: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        style: {
                                            marginRight: '6px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
                                            stroke: "#4A67FF",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c3",
                                        children: "Auditor"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M9 6l6 6-6 6",
                                    stroke: "#9ca3af",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "sub-menu op0 pen pa bg1 shadow br10px zi10 df fdc",
                        style: {
                            minWidth: '220px',
                            right: '100%',
                            top: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "df aic px1rem py0-5rem bg5-hover cp",
                                style: {
                                    gap: '0.5rem',
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "checkbox w20px h20px pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                            checked: diagnoseSelection.has('clarence'),
                                            onChange: ()=>toggleDiagnoseSelection('clarence')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs13px fw400 c14",
                                        children: "Clarence Answers"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs11px c12 mla wsn",
                                        children: "(AI-filled)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "df aic px1rem py0-5rem bg5-hover cp",
                                style: {
                                    gap: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "checkbox w20px h20px pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "checkbox",
                                            className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                            checked: diagnoseSelection.has('human'),
                                            onChange: ()=>toggleDiagnoseSelection('human')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs13px fw400 c14",
                                        children: "Human Answers"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bss bs1px bo29 mx1rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                disabled: diagnoseSelection.size === 0 || isChecklist,
                                onClick: ()=>!isChecklist && onDiagnose([
                                        ...diagnoseSelection
                                    ]),
                                className: "w100 bg3 c1 fw600 fs13px cp py0-75rem",
                                style: {
                                    border: 'none',
                                    borderBottomLeftRadius: '10px',
                                    borderBottomRightRadius: '10px',
                                    opacity: diagnoseSelection.size === 0 || isChecklist ? 0.5 : 1
                                },
                                children: "Generate Report"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df aic",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pr menuHover ml0-5rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("bx0Zp")),
                    alt: "filing-assistant-hover",
                    className: "pa td250",
                    style: {
                        bottom: '36px',
                        zIndex: 100
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                    className: "cp fs13px fw600 bg1 bg3-hover c3 c1-hover bw1px bo3 bss br50px px1rem py0-5rem df jcc aic",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("6zDJh")),
                            alt: "filing-assistant-icon",
                            className: "mr0-5rem"
                        }),
                        "Filing Manager"
                    ]
                }),
                dropdown
            ]
        })
    });
}




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");









function $4e7192990804519c$export$2e2bcd8739ae039({ company: company, user: user, tab: tab, syncing: syncing, syncApiBase: syncApiBase, onConnectDataRoom: onConnectDataRoom, syncDrive: syncDrive, reSyncGDrive: reSyncGDrive, syncDropbox: syncDropbox, reverseSyncDropbox: reverseSyncDropbox, syncSharePoint: syncSharePoint, reSyncSharePoint: reSyncSharePoint, handleDisconnectDataRoom: handleDisconnectDataRoom, localModule: localModule, isDataRepository: isDataRepository, isTwoMinuteTesHomePage: isTwoMinuteTesHomePage }) {
    if (isTwoMinuteTesHomePage) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df aic mt0-5rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            disabled: true,
            "data-tooltip": "Connect Data room feature is disabled. You must register to access it.",
            className: "op50 cp bg1 c3 bw1px bo3 bss br50px fs0-75rem fw600 px0-75rem py0-5rem df jcc aic mr0-5rem",
            children: [
                "Connect",
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "df ml0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                            className: "pen fds w1rem ml0-5rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                            className: "pen fds w1rem ml0-5rem"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                            className: "pen fds w1rem ml0-5rem"
                        })
                    ]
                })
            ]
        })
    });
    if (!localModule || !isDataRepository || !tab?.includes('repository')) return null;
    const syncLink = company.gDriveLink || company.sharePointLink || company.dropBoxLink;
    const allFiles = [];
    for (const sec of localModule?.sections ?? [])for (const ques of sec?.questions ?? []){
        const files = ques?.answer?.files ?? [];
        if (files.length > 0) allFiles.push(...files);
    }
    let syncRequired = false;
    if (company.dropBoxFolderMetadata) syncRequired = allFiles.some((f)=>!f?.dbFileMetadata);
    if (company.sharePointLink) syncRequired = allFiles.some((f)=>!f?.spDriveItem);
    const disableSyncButton = !syncRequired;
    const isMember = company['members']?.some((m)=>m._id === user._id) || company?.['advisors']?.[user._id];
    const hasAllPermissions = company ? (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['memberPermissions']?.[user._id]) || (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['advisors']?.[user._id]?.['modules']) : false;
    const isInvestorOwner = company?.['investors'] && Object.keys(company['investors']).length > 0 && company['investors'][user._id] && (0, $1eef38cfda4b0c52$export$70ef88cdd0c977d9)(company?.['investors']?.[user._id]?.['modules']);
    const canManageDataRoom = !company?.isParent && company?.owners?.[0] === user._id || company?.isParent && company?.owners?.[0] === user._id || (company?.servicedBy?._id || company?.servicedBy) === user._id || isMember && hasAllPermissions || isInvestorOwner;
    if (!canManageDataRoom) return null;
    const openWindow = (url)=>window.open(url, "_blank");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df aic mt0-5rem",
        children: [
            syncLink == undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                onClick: ()=>onConnectDataRoom(syncApiBase),
                className: ` cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem mr0-5rem df jcc aic`,
                children: [
                    "Connect",
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "df ml0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                className: "pen fds w1rem ml0-5rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                className: "pen fds w1rem ml0-5rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                className: "pen fds w1rem ml0-5rem"
                            })
                        ]
                    })
                ]
            }),
            syncLink !== undefined && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pr menuHover mr0-5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "cp fs13px fw600 bg1 c3 bw1px bo3 bss br50px px1rem py0-5rem df jcc aic",
                        children: [
                            company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                className: "pen fds w1rem mr0-5rem"
                            }),
                            company.dropBoxLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                className: "pen fds w1rem mr0-5rem"
                            }),
                            company.sharePointLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                className: "pen fds w1rem mr0-5rem"
                            }),
                            "Data Room",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "ml0-5rem c3",
                                children: "\u25BE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "menu op0 pen zi10 bg1 br10px shadow pa l0 df fdc",
                        style: {
                            minWidth: '230px'
                        },
                        children: [
                            company.gDriveLink && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    company.folderId && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                        style: {
                                            borderTopLeftRadius: '10px',
                                            borderTopRightRadius: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing,
                                            onClick: ()=>openWindow(`https://drive.google.com/drive/folders/${company.folderId}`),
                                            className: `cp df aic ${syncing && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                                        className: "pen fds w1rem mr0-5rem"
                                                    })
                                                }),
                                                "View Data Room"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing,
                                            onClick: ()=>syncDrive(),
                                            className: `cp df aic ${syncing && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("1Ar70")),
                                                    alt: "sync-data-room"
                                                }),
                                                "Sync Data Room"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                        style: {
                                            borderBottomLeftRadius: '10px',
                                            borderBottomRightRadius: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing,
                                            onClick: ()=>handleDisconnectDataRoom("gdrive"),
                                            className: `cp df aic ${syncing && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-unlink c4 mr0-5rem"
                                                }),
                                                "Disconnect"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            company.dropBoxLink && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    company.dropBoxFolderMetadata && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                        style: {
                                            borderTopLeftRadius: '10px',
                                            borderTopRightRadius: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing,
                                            onClick: ()=>openWindow(`https://dropbox.com/home/${company.dropBoxFolderMetadata.path_display}`),
                                            className: `cp df aic ${syncing && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                                        className: "pen fds w1rem mr0-5rem"
                                                    })
                                                }),
                                                "View Data Room"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `${company.syncRequired || syncRequired ? 'op100' : 'op60'} cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing || disableSyncButton,
                                            onClick: ()=>syncDropbox(),
                                            className: `${company.syncRequired || syncRequired ? 'op100' : 'op60'} cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("1Ar70")),
                                                    alt: "sync-data-room"
                                                }),
                                                "Sync Data Room"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>reverseSyncDropbox(),
                                            className: "cp df aic",
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("1Ar70")),
                                                    alt: "sync-data-room"
                                                }),
                                                "Reverse Sync"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                        style: {
                                            borderBottomLeftRadius: '10px',
                                            borderBottomRightRadius: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing,
                                            onClick: ()=>handleDisconnectDataRoom("dropbox"),
                                            className: `cp df aic ${syncing && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-unlink c4 mr0-5rem"
                                                }),
                                                "Disconnect"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            company.sharePointLink && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    company.sharePointFolderDriveItem?.rootFolder?.webUrl && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                        style: {
                                            borderTopLeftRadius: '10px',
                                            borderTopRightRadius: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing,
                                            onClick: ()=>openWindow(`${company.sharePointFolderDriveItem.rootFolder.webUrl}`),
                                            className: `cp df aic ${syncing && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "df",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                                        className: "pen fds w1rem mr0-5rem"
                                                    })
                                                }),
                                                "View Data Room"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing || disableSyncButton,
                                            onClick: ()=>syncSharePoint(),
                                            className: `cp df aic ${(syncing || disableSyncButton) && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("1Ar70")),
                                                    alt: "sync-data-room"
                                                }),
                                                "Sync Data Room"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing || company.syncRequired || syncRequired,
                                            onClick: ()=>reSyncSharePoint(),
                                            className: `cp df aic ${(syncing || company.syncRequired || syncRequired) && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("1Ar70")),
                                                    alt: "sync-data-room"
                                                }),
                                                "Reverse Sync"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: `cp df aic w100 bg5-hover c14 px1rem py0-5rem ${syncing && 'op60 cnd'}`,
                                        style: {
                                            borderBottomLeftRadius: '10px',
                                            borderBottomRightRadius: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            disabled: syncing,
                                            onClick: ()=>handleDisconnectDataRoom("sharepoint"),
                                            className: `cp df aic ${syncing && 'op60 cnd'}`,
                                            style: {
                                                background: 'transparent'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "fa fa-unlink c4 mr0-5rem"
                                                }),
                                                "Disconnect"
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");



function $7025e9396255e510$export$95883a84c8eb08c8(companyId, moduleSlug, company) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [state, setState] = (0, $acw62.useState)({
        module: null,
        sections: [],
        loading: true,
        error: null
    });
    // Parse directors-questionnaire_${directorId} tab format
    let resolvedModuleName = moduleSlug;
    let resolvedDirectorId = null;
    if (moduleSlug.includes('directors-questionnaire_')) {
        const parts = moduleSlug.split('_');
        resolvedModuleName = 'directors-questionnaire';
        resolvedDirectorId = parts[1] || null;
    } else if (moduleSlug.includes('business-audit')) resolvedModuleName = moduleSlug.replace(`-${company?.['testType']}`, '');
    else if (/%[0-9A-Fa-f]{2}/.test(moduleSlug)) // Reason: on page refresh, window.location.hash preserves percent-encoded characters
    // (e.g. %C2%A0 for NBSP in checklist names). Fully decode here so the lookup name
    // matches the module document in the DB instead of containing literal percent sequences.
    try {
        resolvedModuleName = decodeURIComponent(moduleSlug);
    } catch (_) {
        resolvedModuleName = moduleSlug;
    }
    const moduleName = resolvedModuleName;
    const directorId = resolvedDirectorId;
    const fetchData = (0, $acw62.useCallback)(async ()=>{
        if (!moduleName || !companyId || typeof companyId === "object" && Object.keys(companyId).length === 0) return;
        setState((prev)=>({
                ...prev,
                loading: true,
                error: null
            }));
        try {
            const isValidCompanyId = typeof companyId === 'string' && companyId.trim().length > 0;
            let query = isValidCompanyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
            if (directorId) query += `${query ? '&' : '?'}directorId=${encodeURIComponent(directorId)}`;
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${encodeURIComponent(moduleName)}${query}`);
            if (!res || res.code !== 200) throw new Error(res?.message || 'Failed to load module data.');
            const module = res?.body;
            if (!module) throw new Error(`Module "${moduleName}" not found.`);
            setState({
                module: module,
                sections: module.sections || [],
                loading: false,
                error: null
            });
            // Cache for consumers that depend on the active temp module (e.g. OpenRModalComponentNew).
            dispatch((0, $12074930bd2c1829$export$65113a50fb519714)({
                ...module,
                moduleSlug: module.moduleSlug || moduleSlug,
                moduleName: module.moduleName || moduleName,
                companyId: companyId
            }));
        } catch (err) {
            setState((prev)=>({
                    ...prev,
                    loading: false,
                    error: err.message
                }));
        }
    }, [
        companyId,
        moduleName,
        moduleSlug,
        directorId,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch((0, $12074930bd2c1829$export$f7e2ffccf44ba912)());
        };
    }, [
        dispatch
    ]);
    return {
        ...state,
        refetch: fetchData
    };
}



/** Clarence/auto-fill files often have location/originalname but no S3 key. */ const $2b1aff43fcfd6fe2$var$isSameAnswerFile = (a, b)=>{
    if (!a || !b) return false;
    if (a.key && b.key) return a.key === b.key;
    if (a.location && b.location) try {
        return decodeURIComponent(a.location.split('?')[0]) === decodeURIComponent(b.location.split('?')[0]);
    } catch (e) {
        return a.location === b.location;
    }
    return !!(a.originalname && a.originalname === b.originalname);
};
const $2b1aff43fcfd6fe2$var$isReportSourceFile = (f)=>f && f.originator !== 'ai-report' && (f.location || f.url);
const $2b1aff43fcfd6fe2$var$collectQuestionSourceFileUrls = (question)=>(question?.answer?.files || []).filter($2b1aff43fcfd6fe2$var$isReportSourceFile).map((f)=>f.location || f.url).filter(Boolean);
const $2b1aff43fcfd6fe2$var$findQuestionInModule = (mod, data)=>{
    if (!mod?.sections || !data) return null;
    const qid = data._id || data.questionId;
    const qNo = data.qNo;
    for (const sec of mod.sections){
        const pools = [
            sec.questions || []
        ];
        if (sec.subFolders) Object.values(sec.subFolders).forEach((sub)=>{
            if (sub.questions) pools.push(sub.questions);
        });
        for (const pool of pools){
            const q = pool.find((x)=>qid && String(x._id) === String(qid) || qNo && String(x.qNo) === String(qNo));
            if (q) return q;
        }
    }
    return null;
};
const $2b1aff43fcfd6fe2$var$collectSectionSourceFileUrls = (mod, data)=>{
    const sectionId = data?._id || data?.section?._id;
    const sectionNo = data?.sectionNo || data?.no;
    const locations = [];
    const addQs = (qs, qNoPrefix)=>{
        for (const q of qs || []){
            if (qNoPrefix && q.qNo !== qNoPrefix && !(q.qNo && String(q.qNo).startsWith(qNoPrefix + '.'))) continue;
            locations.push(...$2b1aff43fcfd6fe2$var$collectQuestionSourceFileUrls(q));
        }
    };
    if (mod?.sections) for (const sec of mod.sections){
        if (sectionId && String(sec._id) === String(sectionId) || sectionNo && (sec.sectionNo === sectionNo || sec.no === sectionNo)) {
            addQs(sec.questions);
            if (sec.subFolders) Object.values(sec.subFolders).forEach((sub)=>addQs(sub.questions));
        }
        if (sectionNo && sec.subFolders) {
            for (const sub of Object.values(sec.subFolders))if (sub.no === sectionNo || sub.sectionNo === sectionNo) addQs(sec.questions, sectionNo);
        }
    }
    if (locations.length) return [
        ...new Set(locations)
    ];
    const questions = data?.questions || data?.section?.questions || [];
    return [
        ...new Set(questions.flatMap($2b1aff43fcfd6fe2$var$collectQuestionSourceFileUrls))
    ];
};





function $2b1aff43fcfd6fe2$export$2e2bcd8739ae039({ isManualAdd: isManualAdd, getCompany: getCompany, setIsWorkflowReport: setIsWorkflowReport, profileClass: profileClass, advisors: advisors, permissionLevel: permissionLevel, tab: tab, setTab: setTab, sanitiseTab: sanitiseTab, company: company, setCompany: setCompany, companyId: companyId, openKPI: openKPI, toggleReport: toggleReport, enableAIEnhancedReporting: enableAIEnhancedReporting, calculateStats: calculateStats, calculateSubFolderStats: calculateSubFolderStats, getCompletenessAndRiskHTML: getCompletenessAndRiskHTML, aiEnhanced: aiEnhanced, setAiEnchaned: setAiEnchaned, reloadModule: reloadModule, twoMinuteTestAIReport: twoMinuteTestAIReport, getFitInvestorFirms: getFitInvestorFirms, isTwoMinuteTesHomePage: isTwoMinuteTesHomePage, setOpenTabs: setOpenTabs, openTabs: openTabs, companyIndex: companyIndex, setCompanyDashboardTab: setCompanyDashboardTab, setCloneImportResult: setCloneImportResult, setCurrentScore: setCurrentScore, reportHistories: reportHistories, setReportHistories: setReportHistories, setFileReport: setFileReport, sortSections: sortSections, showAlert: showAlert, handleSuperflowNext: handleSuperflowNext, handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness, updateUserType: updateUserType, handlePartnerChecklistNext: handlePartnerChecklistNext, setTabName: setTabName, closeTab: closeTab, isBackFitReport: isBackFitReport, setIsBackFitReport: setIsBackFitReport, isLoader: isLoader, setIsLoader: setIsLoader, syncApiBase: syncApiBase = '/modules', logsApiBase: logsApiBase = '/modules' }) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const spinner = document.getElementById("e1jygW4piZH1");
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let { syncing: syncing } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.appData);
    let { logList: logList, targetSection: targetSection, processing: processing, company: fileAllocationCompany, tempModuleAllocationPatch: tempModuleAllocationPatch } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    let { unallocatedFiles: unallocatedFiles, deduperReports: dupCheck } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.files);
    const companyObjectId = company?._id;
    const reportGenerationRequestRef = (0, $acw62.useRef)(null);
    const lastReportAnchorRef = (0, $acw62.useRef)(null); // Stores anchor to scroll when closing report
    const isComponentMountedRef = (0, $acw62.useRef)(false);
    // Classify a purchased TempModule (from company.boughtExpensions) into an autofill picklist entry — mirrors getCertModuleType() in module_stats.util.js
    const classifyBoughtModule = (m)=>{
        if (m?.isDirectorsModule) return {
            key: m.slug || 'directors-questionnaire',
            label: "Directors' Questionnaire"
        };
        const name = (m?.moduleName || '').toLowerCase();
        if (name.includes('warranty') || name.includes('draft') && name.includes('disclosure')) return {
            key: 'warranty-disclosure',
            label: 'Warranty Disclosures'
        };
        // PISCES Core Disclosures has an empty slug — fall back to moduleName, which the by-name endpoint resolves
        // Commented out for now — hide PISCES from the autofill picker
        // if (name.includes('pisces') && name.includes('disclosure')) return { key: m.slug || m.moduleName, label: 'PISCES Core Disclosures' };
        if (name.includes('business audit') || name.includes('business-audit')) return {
            key: m.slug || `business-audit-${company?.testType || ''}`,
            label: 'Business Audit'
        };
        // Investment Readiness only applies to testType 'investment' companies (Exit/Growth Readiness are the equivalents for other testTypes)
        if (name.includes('investment readiness') && company?.testType === 'investment') return {
            key: 'Investment Readiness',
            label: 'Investment Readiness'
        };
        return null;
    };
    // Helper function to generate unique key for section/question
    const getReportGenerationKey = (data, isQuestion)=>{
        if (isQuestion) {
            // For questions: use sectionId + questionId or qNo
            const sectionId = data?.sectionId || data?.section?._id;
            const questionId = data?._id || data?.qNo;
            return `question-${sectionId}-${questionId}`;
        } else {
            // For sections: use sectionId
            const sectionId = data?._id || data?.section?._id;
            return `section-${sectionId}`;
        }
    };
    const [reportGenerateLoading, setReportGenerateLoadingState] = (0, $acw62.useState)(()=>{
        if (!companyObjectId) return null;
        const loadingMap = (0, $564b3e95a736953b$export$503183a1eef33108)();
        const entry = loadingMap[companyObjectId];
        if (entry && entry.status === 'pending') {
            reportGenerationRequestRef.current = entry.requestId || null;
            return entry.generatingKey || null;
        }
        return null;
    });
    const [agreedAiReportDisclaimerIds, setAgreedAiReportDisclaimerIds] = (0, $acw62.useState)(()=>(0, $564b3e95a736953b$export$7a58d99a89e5d398)());
    const hasAgreedAiReportDisclaimer = companyObjectId ? agreedAiReportDisclaimerIds.includes(companyObjectId) : false;
    let [isModuleDeactivated, setIsModuleDeactivated] = (0, $acw62.useState)(false);
    let [section, setSection] = (0, $acw62.useState)();
    let [refresh, setRefresh] = (0, $acw62.useState)(false);
    let [loading, setLoading] = (0, $acw62.useState)(false);
    let [logModule, setLogModule] = (0, $acw62.useState)([]);
    let [deleteFile, setDeleteFile] = (0, $acw62.useState)();
    let [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    let [saveTimeout, setSaveTimeout] = (0, $acw62.useState)();
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [visibleSection, setVisibleSection] = (0, $acw62.useState)(null);
    let [isFAMenuVisible, setFAMenuVisible] = (0, $acw62.useState)(false);
    let [newUpgradeSync, setNewUpgradeSync] = (0, $acw62.useState)(false);
    let [deleteFileLoading, setDeleteFileLoading] = (0, $acw62.useState)(false);
    let [deleteFileQuestionId, setDeleteFileQuestionId] = (0, $acw62.useState)();
    let [deleteUnallocatedFile, setDeleteUnallocatedFile] = (0, $acw62.useState)();
    let [questionsAndAnswersToSave, setQuestionsAndAnswersToSave] = (0, $acw62.useState)([]);
    const [dateValue, setDateValue] = (0, $acw62.useState)({});
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [dataRoomMenuVisible, setDataRoomMenuVisible] = (0, $acw62.useState)(false);
    // State to track which section to navigate to after disclaimer
    const [sectionToNavigate, setSectionToNavigate] = (0, $acw62.useState)(null);
    // Ref to track section navigation to avoid stale closures in callbacks
    const sectionToNavigateRef = (0, $acw62.useRef)(null);
    // Store the expected reportType after generation to find it after refetch
    const expectedReportTypeRef = (0, $acw62.useRef)(null);
    const applyReverseSyncedAnswersRef = (0, $acw62.useRef)(null);
    const refetchActiveModuleRef = (0, $acw62.useRef)(null);
    // ── Temp-module: always fetch from API by slug (tab) ────────────────────
    const { module: activeModule, loading: activeModuleLoading, refetch: refetchActiveModule } = (0, $7025e9396255e510$export$95883a84c8eb08c8)(companyId, tab, company);
    // True for both the old static "repository" tab and any temp-module whose type contains "repository"
    const isDataRepository = tab === 'repository' || syncApiBase === '/modules' && activeModule?.type && /repository/i.test(String(activeModule.type));
    // True when the current module is configured as a checklist — Auto Fill and Auditor are disabled in this mode
    const hasChecklistModuleKeys = Object.keys(company?.['checklistModules']?.[activeModule?.['moduleName']] || {}).length > 0;
    // Local copy of the module — updated in-place after save/delete/move without re-fetching
    const [localModule, setLocalModule] = (0, $acw62.useState)(null);
    const localModuleRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        localModuleRef.current = localModule;
    }, [
        localModule
    ]);
    (0, $acw62.useEffect)(()=>{
        if (activeModule) // Recompute stats from answer status on load so completion (and the Superflow "Next" gate) reflects the
        // real progress rather than a possibly-stale backend completionPercent.
        setLocalModule(recomputeLocalStats(JSON.parse(JSON.stringify(activeModule))));
    }, [
        activeModule
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // investor-lead / Investment Readiness are fetched separately (useModuleData), and AnyList/partner checklists
    // read their overview completeness from cached section stats which go stale after answering (TempAnswer saves
    // don't recompute the ModuleStats cache). Mirror the full localModule — with its status-based recomputed stats
    // and per-section stats — back into company.modules[tab] so the AnyLists tab cards + section tooltips reflect
    // live progress the same way the opened-module sidebar does. Reference-equality guard prevents an update loop.
    (0, $acw62.useEffect)(()=>{
        if (!localModule) return;
        if (company?.['modules']?.[tab] === localModule) return;
        dispatch(setCompany({
            ...company,
            modules: {
                ...company['modules'] || {},
                [tab]: localModule
            }
        }));
    }, [
        localModule,
        tab,
        company,
        dispatch
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Superflow investor-lead: fetch investor matches in the background as soon as the questions the backend
    // actually needs for matching are answered (5 in section DEPF008.1 + DEPF008.2.4) — so matches are loaded
    // well before the user finishes the module and clicks Next, and the popup opens instantly with the count.
    // Fires once (ref-guarded). We key off these specific questions (not full-section completion) because
    // investor-lead checkbox/note questions don't reliably flip to a 'Completed' status, and the fetch itself
    // is slow (~100s) so we want to start it at the earliest correct moment.
    const REQUIRED_MATCH_QNOS = [
        'DEPF008.1.1',
        'DEPF008.1.2',
        'DEPF008.1.3.2',
        'DEPF008.1.4.2',
        'DEPF008.1.7',
        'DEPF008.2.4'
    ];
    const investorMatchesFetchedRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (investorMatchesFetchedRef.current) return;
        if (user?.['type'] !== 'Superflow' || tab !== 'investor-lead' || !localModule?.sections) return;
        const byQNo = new Map();
        for (const sec of localModule.sections){
            for (const q of sec.questions || [])if (q?.qNo) byQNo.set(q.qNo, q);
            if (sec.subFolders) {
                for (const sub of Object.values(sec.subFolders))for (const q of sub.questions || [])if (q?.qNo) byQNo.set(q.qNo, q);
            }
        }
        const hasAnswer = (q)=>{
            const a = q?.answer;
            if (!a) return false;
            if (a.status === 'Completed' || a.status === 'Not Applicable') return true;
            if (a.dropdown != null && a.dropdown !== '') return true;
            if (a.radioOption != null && a.radioOption !== '' && a.radioOption !== 'NC') return true;
            if (a.value != null && a.value !== '') return true;
            return false;
        };
        const allRequiredAnswered = REQUIRED_MATCH_QNOS.every((qNo)=>hasAnswer(byQNo.get(qNo)));
        if (allRequiredAnswered) {
            investorMatchesFetchedRef.current = true;
            getFitInvestorFirms?.();
        }
    }, [
        localModule,
        tab,
        user,
        getFitInvestorFirms
    ]);
    const WORKFLOW_SCORES = {
        'Not Started': 0,
        'Started': 0.25,
        'In Progress': 0.5,
        'Completed - Further Work': 0.75,
        'Completed - No Issues': 1,
        'Completed': 1,
        'Ready for Review': 0.75
    };
    const patchQuestionAnswerInClone = (clone, questionId, updatedAnswer)=>{
        const qid = String(questionId);
        for (const sec of clone.sections || []){
            const qi = sec.questions?.findIndex((q)=>String(q._id) === qid);
            if (qi >= 0) sec.questions[qi] = {
                ...sec.questions[qi],
                answer: updatedAnswer
            };
            if (sec.subFolders) Object.values(sec.subFolders).forEach((sub)=>{
                const sqi = sub.questions?.findIndex((q)=>String(q._id) === qid);
                if (sqi >= 0) sub.questions[sqi] = {
                    ...sub.questions[sqi],
                    answer: updatedAnswer
                };
            });
        }
    };
    // Recompute section and module completion stats from local question answer data
    const recomputeLocalStats = (mod)=>{
        if (!mod?.sections) return mod;
        const computeRisk = mod.riskScoring !== false;
        let totalQ = 0, completedQ = 0, wfMax = 0, wfScore = 0;
        let modRiskScore = 0, modMinRisk = 0, modMaxRisk = 0;
        for (const sec of mod.sections){
            const questions = (sec.questions || []).filter((q)=>!q.isSkipped);
            const secTotal = questions.length;
            const secCompleted = questions.filter((q)=>q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
            let secWfMax = 0, secWfScore = 0;
            let secRiskScore = 0, secMinRisk = 0, secMaxRisk = 0;
            questions.forEach((q)=>{
                const ts = q.answer?.taskStatus || q.answer?.status;
                if (ts && WORKFLOW_SCORES[ts] !== undefined) {
                    secWfMax += 1;
                    secWfScore += WORKFLOW_SCORES[ts];
                }
                if (computeRisk) {
                    const radioOption = q.answer?.radioOption;
                    if (radioOption && radioOption !== 'N/A' && radioOption !== 'NC') {
                        secRiskScore += q['riskIf' + radioOption] || 0;
                        const riskVals = Object.keys(q).filter((k)=>k.startsWith('riskIf')).map((k)=>q[k]);
                        if (riskVals.length > 0) {
                            secMinRisk += Math.min(...riskVals);
                            secMaxRisk += Math.max(...riskVals);
                        }
                    }
                }
            });
            const secPercent = secTotal > 0 ? Math.round(secCompleted / secTotal * 100) : 0;
            const secWfPercent = secWfMax > 0 ? Math.round(secWfScore / secWfMax * 100) : 0;
            const secRiskPercent = !computeRisk || secRiskScore === 0 || secMaxRisk === secMinRisk ? 0 : Math.round((secRiskScore - secMinRisk) / (secMaxRisk - secMinRisk) * 100);
            sec.stats = {
                ...sec.stats || {},
                completionPercent: secPercent,
                workflowCompletionPercent: secWfPercent,
                completed: secCompleted,
                total: secTotal,
                riskPercent: secRiskPercent
            };
            totalQ += secTotal;
            completedQ += secCompleted;
            wfMax += secWfMax;
            wfScore += secWfScore;
            modRiskScore += secRiskScore;
            modMinRisk += secMinRisk;
            modMaxRisk += secMaxRisk;
        }
        const modPercent = totalQ > 0 ? Math.round(completedQ / totalQ * 100) : 0;
        const modWfPercent = wfMax > 0 ? Math.round(wfScore / wfMax * 100) : 0;
        const modRiskPercent = !computeRisk || modRiskScore === 0 || modMaxRisk === modMinRisk ? 0 : Math.round((modRiskScore - modMinRisk) / (modMaxRisk - modMinRisk) * 100);
        mod.stats = {
            ...mod.stats || {},
            completionPercent: modPercent,
            workflowCompletionPercent: modWfPercent,
            completed: completedQ,
            total: totalQ,
            riskPercent: modRiskPercent
        };
        return mod;
    };
    // Patch localModule answers from the savedQuestions returned by the save API,
    // then recompute section and module stats so progress bars update immediately.
    const updateLocalAnswers = (0, $acw62.useCallback)((savedQuestions)=>{
        if (!savedQuestions?.length) return;
        setLocalModule((prev)=>{
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const savedQ of savedQuestions)patchQuestionAnswerInClone(clone, savedQ._id, savedQ.answer);
            return recomputeLocalStats(clone);
        });
    }, []);
    // After reverse sync: merge TempAnswer payloads into question.answer by questionId or qNo.
    const applyReverseSyncedAnswers = (0, $acw62.useCallback)((updatedAnswers)=>{
        if (!updatedAnswers?.length) return;
        setLocalModule((prev)=>{
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const ans of updatedAnswers){
                const qid = ans.questionId ? String(ans.questionId) : null;
                const qNo = ans.qNo != null ? String(ans.qNo) : null;
                const mergeAnswer = (existing)=>({
                        ...existing || {},
                        ...ans,
                        _id: ans._id || existing?._id,
                        files: ans.files || existing?.files || [],
                        radioOption: ans.radioOption || existing?.radioOption,
                        status: ans.status || existing?.status,
                        drFolderId: ans.drFolderId || existing?.drFolderId
                    });
                let patched = false;
                for (const sec of clone.sections || []){
                    for(let i = 0; i < (sec.questions || []).length; i++){
                        const q = sec.questions[i];
                        if (qid && String(q._id) === qid || qNo && String(q.qNo) === qNo) {
                            sec.questions[i] = {
                                ...q,
                                answer: mergeAnswer(q.answer)
                            };
                            patched = true;
                        }
                    }
                    if (sec.subFolders) Object.values(sec.subFolders).forEach((sub)=>{
                        for(let i = 0; i < (sub.questions || []).length; i++){
                            const q = sub.questions[i];
                            if (qid && String(q._id) === qid || qNo && String(q.qNo) === qNo) {
                                sub.questions[i] = {
                                    ...q,
                                    answer: mergeAnswer(q.answer)
                                };
                                patched = true;
                            }
                        }
                    });
                }
                if (!patched && qNo) console.warn('[applyReverseSyncedAnswers] no question matched', {
                    qNo: qNo,
                    qid: qid
                });
            }
            return recomputeLocalStats(clone);
        });
    }, []);
    // Patch a single answer in localModule after /question/addNote (workflow notes) — no full refetch
    const patchAnswerInModule = (0, $acw62.useCallback)((questionId, updatedAnswer)=>{
        setLocalModule((prev)=>{
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            patchQuestionAnswerInClone(clone, questionId, updatedAnswer);
            return recomputeLocalStats(clone);
        });
    }, []);
    // After /modules/allocateFiles, merge returned TempAnswer payloads into localModule (no refetch)
    (0, $acw62.useEffect)(()=>{
        const patch = tempModuleAllocationPatch;
        if (!patch?.savedQuestions?.length || !localModule || !activeModule?._id) return;
        if (String(patch.moduleId) !== String(activeModule._id)) return;
        updateLocalAnswers(patch.savedQuestions);
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: null
        }));
    }, [
        tempModuleAllocationPatch,
        localModule,
        activeModule?._id,
        updateLocalAnswers,
        dispatch
    ]);
    // Sync additionalSections (user-defined sections) whenever the module loads
    (0, $acw62.useEffect)(()=>{
        if (!activeModule) return;
        const customSections = (activeModule.sections || []).filter((s)=>s.companyId && s.type === 'Additional Sections');
        const saved = customSections.map((s)=>[
                s._id,
                s.sectionName,
                true,
                true
            ]);
        const empty = Array.from({
            length: Math.max(0, 5 - saved.length)
        }, ()=>[
                null,
                '',
                false,
                true
            ]);
        setAdditionalSections([
            ...saved,
            ...empty
        ]);
    }, [
        activeModule?._id
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Reload module data after AutoFill completes (triggered via modal flag)
    (0, $acw62.useEffect)(()=>{
        if (!modal.autoFillJustCompleted) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            autoFillJustCompleted: false
        }));
        refetchActiveModule();
    }, [
        modal.autoFillJustCompleted
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Reload module data after a Auditor Fix is applied (modal stays open)
    (0, $acw62.useEffect)(()=>{
        if (!modal.diagnoseFixJustApplied) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            diagnoseFixJustApplied: false
        }));
        refetchActiveModule();
    }, [
        modal.diagnoseFixJustApplied
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // ── End temp-module fetch ────────────────────────────────────────────────
    // Helper function to sanitize section name for URLs (matches backend logic)
    const sanitizeSectionName = (name)=>{
        if (!name) return '';
        return name.toLowerCase().replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, '') // Remove special characters
        .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
        .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
    };
    // Helper function to get section tab name
    const getSectionTabName = (section, isQuestion, data)=>{
        if (!section) return '';
        const sectionName = section.sectionName || section.name || '';
        const sanitized = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
        return sanitized ? `${sanitized}-section-report` : '';
    };
    // Helper function to check if a section report exists for a given section
    const hasSectionReport = (section, isQuestion, data)=>{
        if (!section || !company?.['aiReports']) return false;
        const sectionName = section.sectionName || section.name || '';
        const sanitizedSectionName = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
        if (!sanitizedSectionName) return false;
        const reportType = `sectionReport_${sanitizedSectionName}`;
        return company['aiReports'].some((report)=>report.reportType === reportType && report?.htmlReport);
    };
    // Helper function to get the report data for a section/question
    const getSectionReport = (section, isQuestion, data)=>{
        if (!section || !company?.['aiReports']) return null;
        const sectionName = section.no || section.name || '';
        const sanitizedSectionName = isQuestion ? data.qNo : sectionName;
        if (!sanitizedSectionName) return null;
        const reportType = `sectionReport_${sanitizedSectionName}`;
        return company['aiReports'].find((report)=>report.reportType === reportType && report?.htmlReport) || null;
    };
    const debouncedSaveAnswer = (0, $acw62.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lwfqC)))((e, question, qNo)=>{
        saveAnswer(e, question, qNo);
    }, 3000), [] // ← ensures debounce function is created once
    );
    (0, $acw62.useEffect)(()=>{
        applyReverseSyncedAnswersRef.current = applyReverseSyncedAnswers;
    }, [
        applyReverseSyncedAnswers
    ]);
    (0, $acw62.useEffect)(()=>{
        refetchActiveModuleRef.current = refetchActiveModule;
    }, [
        refetchActiveModule
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingStart', (data)=>{
            dispatch((0, $b11447c30838833f$export$7a34e0accbb4df68)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingFoldersStart', ()=>{
            dispatch((0, $b11447c30838833f$export$b3e07c78a2c60bfb)());
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingFoldersComplete', ()=>{
            dispatch((0, $b11447c30838833f$export$b961a89ac79a5350)());
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('Syncing', (data)=>{
            dispatch((0, $b11447c30838833f$export$74c9a4d719d4ea5c)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingFilesNotAvailable', (data)=>{
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`There are currently no files to sync.`);
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('SyncingComplete', (data)=>{
            dispatch((0, $b11447c30838833f$export$8c5c317902a771de)());
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Syncing Process completed.`);
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('syncingComplete', ()=>{
            dispatch((0, $b11447c30838833f$export$8c5c317902a771de)());
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('ReSyncingStart', (data)=>{
            dispatch((0, $b11447c30838833f$export$e6096d4f512f501c)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('ReSyncing', (data)=>{
            dispatch((0, $b11447c30838833f$export$c4374b4dd5806893)(data));
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('ReSyncingComplete', (payload)=>{
            if (payload?.updatedAnswers?.length) applyReverseSyncedAnswersRef.current?.(payload.updatedAnswers);
            dispatch((0, $b11447c30838833f$export$6c77a92cea265c06)());
            // Ensure module UI matches DB even if HTTP response body was empty/missed.
            refetchActiveModuleRef.current?.();
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (activeModule && activeModule['isActive'] === false) setIsModuleDeactivated(true);
        else if (activeModule && activeModule['isActive'] === true) setIsModuleDeactivated(false);
    }, [
        activeModule?.['isActive']
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleChecklistDeactivated = ({ moduleId: moduleId, moduleKey: moduleKey, isActive: isActive })=>{
            if (isActive) return;
            const currentId = activeModule?._id ? String(activeModule['_id']) : null;
            const currentKey = activeModule?.['moduleKey'] || null;
            if (currentId && moduleId && currentId === moduleId || currentKey && moduleKey && currentKey === moduleKey) {
                setIsModuleDeactivated(true);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('This checklist has been deactivated by your advisor.');
            }
        };
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('checklistDeactivated', handleChecklistDeactivated);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('checklistDeactivated', handleChecklistDeactivated);
        };
    }, [
        activeModule?._id,
        activeModule?.['moduleKey']
    ]);
    (0, $acw62.useEffect)(()=>{
        isComponentMountedRef.current = true;
        return ()=>{
            isComponentMountedRef.current = false;
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!companyObjectId) {
            reportGenerationRequestRef.current = null;
            if (isComponentMountedRef.current) setReportGenerateLoadingState(null);
            return;
        }
        const loadingMap = (0, $564b3e95a736953b$export$503183a1eef33108)();
        const entry = loadingMap[companyObjectId];
        reportGenerationRequestRef.current = entry?.requestId || null;
        const generatingKey = entry?.status === 'pending' ? entry.generatingKey || null : null;
        if (isComponentMountedRef.current) setReportGenerateLoadingState((prev)=>{
            // Only update if the value actually changed
            if (prev !== generatingKey) return generatingKey;
            return prev;
        });
    }, [
        companyObjectId
    ]);
    // Add storage event listener to sync state when localStorage changes (e.g., from other tabs)
    (0, $acw62.useEffect)(()=>{
        const handleStorageChange = (e)=>{
            if (e.key === (0, $564b3e95a736953b$export$18e55fcebd381b72) && companyObjectId) {
                const loadingMap = (0, $564b3e95a736953b$export$503183a1eef33108)();
                const entry = loadingMap[companyObjectId];
                const generatingKey = entry?.status === 'pending' ? entry.generatingKey || null : null;
                if (isComponentMountedRef.current) {
                    setReportGenerateLoadingState(generatingKey);
                    reportGenerationRequestRef.current = entry?.requestId || null;
                }
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return ()=>{
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [
        companyObjectId
    ]);
    const startReportGenerationLoading = (0, $acw62.useCallback)((generatingKey)=>{
        const requestId = `${companyObjectId || 'company'}-${Date.now()}`;
        const loadingMap = (0, $564b3e95a736953b$export$503183a1eef33108)();
        if (companyObjectId) {
            loadingMap[companyObjectId] = {
                status: 'pending',
                requestId: requestId,
                generatingKey: generatingKey || null,
                startedAt: Date.now()
            };
            (0, $564b3e95a736953b$export$2ac5f5081b4dba80)((0, $564b3e95a736953b$export$18e55fcebd381b72), loadingMap);
        }
        reportGenerationRequestRef.current = requestId;
        if (isComponentMountedRef.current) setReportGenerateLoadingState(generatingKey || null);
        return requestId;
    }, [
        companyObjectId
    ]);
    const stopReportGenerationLoading = (0, $acw62.useCallback)((requestId, options = {})=>{
        const { force: force = false } = options;
        const effectiveRequestId = requestId || reportGenerationRequestRef.current;
        const clearComponentState = (matchedRequestId)=>{
            if (!matchedRequestId || reportGenerationRequestRef.current === matchedRequestId) reportGenerationRequestRef.current = null;
            if (isComponentMountedRef.current) // Force state update to null
            setReportGenerateLoadingState(null);
        };
        if (!companyObjectId) {
            clearComponentState(effectiveRequestId);
            return;
        }
        const loadingMap = (0, $564b3e95a736953b$export$503183a1eef33108)();
        const entry = loadingMap[companyObjectId];
        if (!entry) {
            // No entry in localStorage, ensure state is cleared
            clearComponentState(effectiveRequestId);
            return;
        }
        const isMatchingRequest = !effectiveRequestId || entry.requestId === effectiveRequestId;
        const entryAgeMs = entry?.startedAt ? Date.now() - entry.startedAt : 0;
        const isStale = entryAgeMs > 300000; // 5 minutes fallback
        if (force || isMatchingRequest || isStale) {
            // Clear from localStorage first
            delete loadingMap[companyObjectId];
            (0, $564b3e95a736953b$export$2ac5f5081b4dba80)((0, $564b3e95a736953b$export$18e55fcebd381b72), loadingMap);
            // Then clear component state
            clearComponentState(entry.requestId);
            // Double-check: verify localStorage was cleared and sync state
            setTimeout(()=>{
                if (isComponentMountedRef.current) {
                    const verifyMap = (0, $564b3e95a736953b$export$503183a1eef33108)();
                    const verifyEntry = verifyMap[companyObjectId];
                    if (!verifyEntry || verifyEntry.status !== 'pending') setReportGenerateLoadingState(null);
                }
            }, 100);
            return;
        }
    }, [
        companyObjectId
    ]);
    const handleAiReportDisclaimerClose = (0, $acw62.useCallback)(async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (!companyObjectId) return;
        // Save agreement to localStorage first
        const updatedAgreements = [
            ...agreedAiReportDisclaimerIds
        ];
        if (!updatedAgreements.includes(companyObjectId)) {
            updatedAgreements.push(companyObjectId);
            (0, $564b3e95a736953b$export$2ac5f5081b4dba80)((0, $564b3e95a736953b$export$7a1e5df59fb6157a), updatedAgreements);
            setAgreedAiReportDisclaimerIds(updatedAgreements);
        }
        // await getCompany('repository', company);
        let sectionTab = null;
        const expectedReportType = expectedReportTypeRef.current;
        let anchorToStore = lastReportAnchorRef.current;
        if (expectedReportType) {
            const sanitizedSectionName = expectedReportType.replace('sectionReport_', '');
            sectionTab = `${sanitizedSectionName}-section-report`;
        }
        // Fallback: Use navigation target to construct tab name (from R button flow)
        if (!sectionTab) {
            const navigationTarget = sectionToNavigateRef.current;
            if (navigationTarget) {
                const { section: section, isQuestion: isQuestion, data: data } = navigationTarget;
                sectionTab = getSectionTabName(section, isQuestion, data);
                if (!anchorToStore) anchorToStore = section?.sectionNo || section?.no || data?.sectionNo || data?.qNo || null;
            }
        }
        // Navigate to the tab (following the same pattern as R button)
        if (sectionTab) {
            // Add tab to openTabs set so it appears in the UI
            if (setOpenTabs && openTabs) {
                const newOpenTabs = new Set(openTabs);
                newOpenTabs.add(sectionTab);
                setOpenTabs(newOpenTabs);
            }
            // Persist anchor for scrolling back on close
            if (anchorToStore) {
                lastReportAnchorRef.current = anchorToStore;
                try {
                    localStorage.setItem('lastReportAnchor', anchorToStore);
                } catch (_) {}
            }
            // Set tab and update URL hash (using proper routing like R button does)
            await setTab(sectionTab);
            // Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
            // Use history.replaceState to ensure the hash persists without triggering navigation
            setTimeout(()=>{
                const hashValue = `#${sectionTab}`;
                if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
            }, 100);
            // Clear refs after successful navigation
            expectedReportTypeRef.current = null;
            setSectionToNavigate(null);
            sectionToNavigateRef.current = null;
        }
    }, [
        companyObjectId,
        dispatch,
        setTab,
        getSectionTabName,
        company,
        navigate,
        getCompany,
        agreedAiReportDisclaimerIds,
        setOpenTabs,
        openTabs
    ]);
    const handleSectionReportLinkClick = (0, $acw62.useCallback)((event, section, isQuestion = false, data = null)=>{
        if (!section) {
            event?.preventDefault();
            return;
        }
        // Check if report exists — skip when caller already confirmed via isAiReportGenerated (backend-verified)
        const hasReport = data?.skipReportCheck || hasSectionReport(section, isQuestion, data);
        if (!hasReport) {
            event?.preventDefault();
            return;
        }
        if (hasAgreedAiReportDisclaimer) {
            const sectionTab = getSectionTabName(section, isQuestion, data);
            if (sectionTab) {
                setTab(sectionTab);
                // Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
                // Use history.replaceState to ensure the hash persists without triggering navigation
                setTimeout(()=>{
                    const hashValue = `#${sectionTab}`;
                    if (window.location.hash !== hashValue) window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
                }, 100);
            }
            return;
        }
        event.preventDefault();
        const navigationData = {
            section: section,
            isQuestion: isQuestion,
            data: data
        };
        setSectionToNavigate(navigationData);
        sectionToNavigateRef.current = navigationData; // Also store in ref for reliable access
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'DisclaimerAIReportModal'
        }));
    }, [
        dispatch,
        hasAgreedAiReportDisclaimer,
        setTab,
        hasSectionReport,
        getSectionTabName
    ]);
    (0, $acw62.useEffect)(()=>{
        if (processing && location.hash && location.hash === "#repository" && showAlert) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'repositoryAlert'
        }));
    }, [
        processing,
        location.hash,
        showAlert
    ]);
    let sectionRefs = (0, $acw62.useRef)([]);
    let fileImportRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            const sectionPositions = sectionRefs.current.map((ref)=>{
                const id = ref?.id?.split('.')[0];
                const top = Math.floor(ref?.getBoundingClientRect().top);
                return {
                    id: id,
                    top: top
                };
            });
            const currentActiveSection = sectionPositions.find((position)=>position?.['top'] >= 0 && position.top < window.innerHeight);
            if (currentActiveSection) setVisibleSection(currentActiveSection.id);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    const handleEditDispatch = (action)=>{
        dispatch((0, $12074930bd2c1829$export$484cc9173fdb35fb)({
            ...action
        }));
        dispatch((0, $12074930bd2c1829$export$a8d03de66a369b2f)(true));
    };
    const syncDrive = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${syncApiBase}/syncGDriveDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) setNewUpgradeSync(false);
        window.location.reload();
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const reSyncGDrive = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        if (localModule?._id || localModule?.id) body['moduleId'] = localModule._id || localModule.id;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${syncApiBase}/reSyncGDriveDataroom/${companyId}`, body, true);
        if (!res || res.code !== 200) {
            dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
                syncing: false,
                message: null
            }));
            return;
        }
        // Immediate UI update from API payload (no hard refresh needed)
        const updatedAnswers = res.body?.updatedAnswers || res.data?.updatedAnswers || [];
        if (updatedAnswers.length) applyReverseSyncedAnswers(updatedAnswers);
        // Refetch temp module so useModuleData/localModule stay in sync with DB
        if (typeof refetchActiveModule === 'function') await refetchActiveModule();
        else if (tab) reloadModule(tab, true, false, true);
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const syncDropbox = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        // setNewUpgradeSync(true);
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${syncApiBase}/syncDropBoxDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const reverseSyncDropbox = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        // setNewUpgradeSync(true);
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${syncApiBase}/reSyncDropBoxDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const syncSharePoint = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${syncApiBase}/syncSharePointDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    const reSyncSharePoint = async (sectionId, qNo)=>{
        if (syncing) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please wait! Syncing is under process");
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: true,
            message: "Files are currently syncing"
        }));
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${syncApiBase}/reSyncSharePointDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
            syncing: false,
            message: null
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (questionsAndAnswersToSave.length) {
            if (isSaving) setSaveTimeout(setTimeout(()=>setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                        ...questionsAndAnswersToSave
                    ]), 1000));
            else save();
        }
    }, [
        questionsAndAnswersToSave,
        isSaving
    ]);
    const confirmDeleteFile = async (from)=>{
        if (deleteFileLoading) return;
        setDeleteFileLoading(true);
        let directorId = undefined;
        if (tab.includes('directors-questionnaire')) {
            const dqs = tab.split('_');
            if (dqs.length > 1) directorId = dqs[1];
        }
        const deletePayload = {
            file: deleteFile,
            questionId: deleteFileQuestionId,
            companyId: companyId
        };
        if (directorId) deletePayload.directorId = directorId;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/temp-answers/delete-file', deletePayload);
        setDeleteFileLoading(false);
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        // Update localModule to remove the file without a full API refetch
        const deletedFile = deleteFile;
        const deletedQuestionId = deleteFileQuestionId;
        const remainingFromApi = res['body'] && Array.isArray(res['body']['files']) ? res['body']['files'] : null;
        const nextStatus = res['body'] && res['body']['status'];
        if (deletedQuestionId && deletedFile) setLocalModule((prev)=>{
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            const qid = String(deletedQuestionId);
            const applyRemoval = (q)=>{
                if (!q?.answer) return q;
                const remaining = remainingFromApi != null ? remainingFromApi : (q.answer.files || []).filter((f)=>!$2b1aff43fcfd6fe2$var$isSameAnswerFile(f, deletedFile));
                const updatedAnswer = {
                    ...q.answer,
                    files: remaining
                };
                if (nextStatus) updatedAnswer.status = nextStatus;
                else if (remaining.length === 0 && q.answer.radioOption === 'Yes') updatedAnswer.status = 'In Progress';
                return {
                    ...q,
                    answer: updatedAnswer
                };
            };
            for (const sec of clone.sections || []){
                const qi = sec.questions?.findIndex((q)=>String(q._id) === qid);
                if (qi >= 0) sec.questions[qi] = applyRemoval(sec.questions[qi]);
                if (sec.subFolders) Object.values(sec.subFolders).forEach((sub)=>{
                    const sqi = sub.questions?.findIndex((q)=>String(q._id) === qid);
                    if (sqi >= 0) sub.questions[sqi] = applyRemoval(sub.questions[sqi]);
                });
            }
            return recomputeLocalStats(clone);
        });
        if (section) {
            let _sections = {
                ...section
            };
            _sections.files = section.files?.filter((f)=>!$2b1aff43fcfd6fe2$var$isSameAnswerFile(f, deletedFile));
            setSection(_sections);
            setRefresh(!refresh);
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: from
        }));
    };
    const confirmDeleteUnallocatedFile = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/deleteUnallocatedFile', {
            fileReportId: deleteUnallocatedFile.id,
            file: deleteUnallocatedFile.file,
            companyId: companyId
        });
        if (!res || res['code'] != 200) return;
        dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(unallocatedFiles.filter((f)=>f.file.key != deleteUnallocatedFile.file.key)));
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedFiles'
        }));
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e, question, qNo)=>{
        if (!company['uploadedFile'] || !company['syncRequired']) dispatch(setCompany({
            ...company,
            uploadedFile: true,
            syncRequired: true
        }));
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        const fileInput = e.currentTarget.querySelector("input[type='file']");
        if (fileInput) fileInput.value = null; // Reset the input field
        saveAnswer(e, question, qNo);
    };
    const radioButtonChanged = (e, question, qNo, moduleType)=>{
        const isOpenModule = activeModule?.isInvestorMatch || activeModule?.isInvestmentReadiness;
        const customSlotNoPermissionOk = (0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(qNo);
        if (!isOpenModule && !customSlotNoPermissionOk && company['creatorId']?.['_id'] != user['_id'] && company['addedByInvestor'] != user['_id'] && (company['servicedBy']?.['_id'] || company['servicedBy']) != user['_id'] && company['cCategory'] == 'client' && !companyIndex) {
            if (user['role'] == 'Advisor' && !company['advisors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]] && !company['advisors']?.[user['_id']]?.['modules']?.[qNo.split('.').slice(0, 2).join('.')]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
            if (user['role'] == 'Investor' && !company['investors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]] && !company['investors']?.[user['_id']]?.['modules']?.[qNo.split('.').slice(0, 2).join('.')]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
            if (user['role'] == 'Member' && !company?.['memberPermissions']?.[user['_id']]?.[qNo.split('.')[0]] && !company?.['memberPermissions']?.[user['_id']]?.[qNo.split('.')[0].replace(/\d+$/, '')] && !company?.['memberPermissions']?.[user['_id']]?.[qNo.split('.').slice(0, 2).join('.')]) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
        }
        // question = Object.freeze(question);
        question = JSON.parse(JSON.stringify(question));
        const option = e['target']['dataset']['option'];
        const wrapper = e['target'].closest("[data-question-id]");
        //TODO: change to toggleHeight
        for (const showOrHideEl of wrapper.querySelectorAll(".showOrHide"))if (option === "Yes" || option == 'Disclosure') {
            showOrHideEl.classList.remove("dn");
            setTimeout(()=>showOrHideEl.classList.remove("op0", "h0"), 100);
        } else {
            showOrHideEl.classList.add("op0", "h0");
            setTimeout(()=>showOrHideEl.classList.add("dn"), 300);
        }
        // Send only update keys
        if (!question['answer'] || question['answer'] == undefined) question['answer'] = {};
        else question['answer'] = {
            _id: question['answer']['_id'],
            status: question['answer']['status']
        };
        question['answer']['radioOption'] = option;
        if (option == 'No') question['answer']['status'] = 'Completed';
        else if ([
            'T',
            'Date',
            'DropDown'
        ].includes(question['questionType'])) {
            question['answer']['status'] = 'Completed';
            question['answer']['radioOption'] = 'Yes';
        } else if (question['questionType'].includes('F') || option == 'Disclosure' && moduleType == 'warranty-disclosure') question['answer']['status'] = question['answer']['status'] ?? 'In Progress';
        else question['answer']['status'] = 'Completed';
        if (!question['updatedBy']) window.scrollTo({
            top: window['scrollY'] + 150,
            behavior: 'smooth'
        });
        if ([
            "Yes",
            "No",
            "N/A"
        ].includes(option) && tab.includes('two-minute-test')) question['answer']['status'] = 'Completed';
        if (tab === 'investor-lead') question['answer']['status'] = 'Completed';
        // Immediately patch localModule so React re-render keeps the correct showFiles state
        // (prevents the dn class from being re-applied before the save round-trip completes)
        const newRadioOption = question['answer']['radioOption'];
        const newStatus = question['answer']['status'];
        setLocalModule((prev)=>{
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const sec of clone.sections){
                const qi = sec.questions?.findIndex((q)=>q._id === question['_id'] || q._id?.toString() === question['_id']?.toString());
                if (qi >= 0) {
                    const q = sec.questions[qi];
                    q.answer = q.answer || {};
                    q.answer.radioOption = newRadioOption;
                    if (newStatus) q.answer.status = newStatus;
                    break;
                }
            }
            return clone;
        });
        saveAnswer(e, question, qNo, 'radio');
    };
    const cloneFile = (file)=>{
        const clonedFile = new File([
            file
        ], file['name'], {
            type: file['type']
        });
        return clonedFile;
    };
    const handleFileChange = async (e)=>{
        if (e['target'].files.length > 80) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Oops! You can upload up to 80 files at a time. Please try again with fewer files.");
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'computerToClarence',
            percent: 0
        }));
        attachment = [];
        let relPaths = [], filesInfo = [];
        setFAMenuVisible(false);
        let percent = 0, filesUploaded = 0;
        const totalFiles = e['target']['files'].length;
        for (const file of e['target'].files){
            relPaths.push(file.webkitRelativePath);
            const clonedFile = cloneFile(file);
            attachment = [
                clonedFile
            ];
            const uploadEndpoint = `/modules/uploadFile`;
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(uploadEndpoint, {
                attachment: attachment
            });
            if (!res) continue;
            if (!res.body?.['report']) continue;
            filesInfo.push(res['body']['report']);
            filesUploaded = filesUploaded + 1;
            percent = Math.round(filesUploaded / totalFiles * 100);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'computerToClarence',
                percent: percent,
                fileName: file['name'],
                totalFiles: totalFiles,
                filesUploaded: filesUploaded
            }));
        }
        e['target']['value'] = null;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'allocatingFiles'
        }));
        const uploadFilesEndpoint = `/modules/uploadFiles`;
        const uploadFilesPayload = {
            files: filesInfo,
            companyId: companyId,
            moduleId: activeModule?._id,
            relPaths: relPaths
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(uploadFilesEndpoint, uploadFilesPayload);
        if (!res) return;
        if (!res['body']?.['report']) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch(setFileReport(res['body']['report']));
        setCloneImportResult(JSON.parse(JSON.stringify(res['body']['report']['importResult'])));
        const allocated = Object.keys(res['body']['report']['importResult']).filter((key)=>res['body']['report']['importResult'][key]['section'].some((element)=>!element.includes("DXXX"))).length;
        // DXXX
        const total = Object.keys(res['body']['report']['importResult']).length;
        e['target']['value'] = '';
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'tempImportSummary',
            from: ''
        }));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            fileReport: res.body['report'],
            company: company,
            currentScore: total == 0 ? 0 : Math.round(allocated / total * 100),
            reportHistories: reportHistories,
            profileClass: profileClass,
            moduleId: activeModule?._id || null
        }));
    };
    const strAdditionalSections = (()=>{
        const customSections = (activeModule?.sections || []).filter((s)=>s.companyId && s.type === 'Additional Sections');
        const saved = customSections.map((s)=>[
                s._id,
                s.sectionName,
                true,
                true
            ]);
        const empty = Array.from({
            length: Math.max(0, 5 - saved.length)
        }, ()=>[
                null,
                '',
                false,
                true
            ]);
        return [
            ...saved,
            ...empty
        ];
    })();
    let [additionalSections, setAdditionalSections] = (0, $acw62.useState)(strAdditionalSections);
    const [isSectionNameDuplicate, setIsSectionNameDuplicate] = (0, $acw62.useState)({
        indexes: [],
        name: ''
    });
    const findDuplicates = (arr)=>{
        const map = arr.reduce((acc, [index, name])=>{
            if (name !== "") (acc[name.toLowerCase().trim()] = acc[name.toLowerCase().trim()] || []).push(index);
            return acc;
        }, {});
        for (const [name, indexes] of Object.entries(map)){
            if (indexes.length > 1) return {
                indexes: indexes,
                name: name
            };
        }
        return {
            indexes: [],
            name: ''
        };
    };
    function editSectionName(strVal, index) {
        let newArray = [
            ...additionalSections
        ];
        newArray[index][1] = strVal;
        setAdditionalSections(newArray);
        const newSetData = findDuplicates(newArray);
        newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({
            indexes: [],
            name: ''
        });
    }
    function onEdit(index) {
        let newArray = [
            ...additionalSections
        ];
        if (newArray[index][3] === true && newArray[index][1] === "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please input additional user-defined sections name!');
        newArray[index][3] = !newArray[index][3];
        setAdditionalSections(newArray);
        const newSetData = findDuplicates(newArray);
        newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({
            indexes: [],
            name: ''
        });
    }
    async function onDelete(index) {
        const sectionId = additionalSections[index][0];
        // Unsaved new slot — just clear it
        if (!sectionId) {
            setAdditionalSections((prev)=>{
                const next = [
                    ...prev
                ];
                next[index] = [
                    null,
                    '',
                    false,
                    true
                ];
                return next;
            });
            return;
        }
        try {
            const resp = await (0, $bebe1cbb5a309c8c$export$73d2141cd2451ba9)(`/modules/temp-sections/custom/${sectionId}`);
            if (resp?.code === 200) {
                // Replace deleted slot with empty slot (maintain 5 total)
                setAdditionalSections((prev)=>{
                    const next = [
                        ...prev
                    ];
                    next[index] = [
                        null,
                        '',
                        false,
                        true
                    ];
                    return next;
                });
                // Remove section from localModule immediately (no full refetch needed)
                setLocalModule((prev)=>{
                    if (!prev) return prev;
                    const clone = JSON.parse(JSON.stringify(prev));
                    clone.sections = clone.sections.filter((s)=>s._id?.toString() !== sectionId?.toString());
                    return recomputeLocalStats(clone);
                });
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(resp.message);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                if (typeof refetchActiveModule === 'function') await refetchActiveModule();
            }
        } catch (err) {
            console.log(err);
        }
    }
    const onSaveAdditionalSections = async ()=>{
        if (isSectionNameDuplicate.indexes.length && isSectionNameDuplicate.name !== '') return;
        // Only process entries that have a name and no _id yet (new, unsaved sections)
        const newEntries = additionalSections.filter((s)=>!s[0] && s[1].trim());
        if (!newEntries.length) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter at least one new section name.');
        if (!activeModule?._id) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Module not found. Please reload the page.');
        const results = await Promise.all(newEntries.map((s)=>(0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/temp-sections/custom', {
                moduleId: activeModule._id,
                sectionName: s[1].trim(),
                companyId: companyId
            })));
        const failed = results.filter((r)=>!r || r.code !== 200);
        if (failed.length) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(failed[0]?.message || 'Failed to create one or more sections.');
            return;
        }
        // Optimistic local insert so the card appears immediately; then refetch so sidebar + Q&A match DB
        const created = results.map((r)=>r.body).filter((b)=>b?.section);
        setLocalModule((prev)=>{
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const { section: section, question: question } of created)clone.sections.push({
                ...section,
                questions: [
                    {
                        ...question,
                        answer: {
                            radioOption: 'NC',
                            status: 'Not Started',
                            files: [],
                            logs: [],
                            taskNotes: [],
                            aiResponse: {},
                            comment: '',
                            dropdown: '',
                            date: null
                        }
                    }
                ],
                stats: {
                    completionPercent: 0,
                    totalQuestions: 1,
                    completedQuestions: 0,
                    riskScore: 0
                }
            });
            return recomputeLocalStats(clone);
        });
        // Refresh additionalSections — maintain exactly 5 slots
        setAdditionalSections((prev)=>{
            const createdMap = new Map(created.map((c)=>[
                    c.section.sectionName.trim(),
                    c.section
                ]));
            const next = prev.map((s)=>{
                if (!s[0] && s[1].trim() && createdMap.has(s[1].trim())) {
                    const sec = createdMap.get(s[1].trim());
                    return [
                        sec._id,
                        sec.sectionName,
                        true,
                        true
                    ];
                }
                return s;
            });
            return next;
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Section saved successfully.');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        // Reason: refetch pulls company custom sections (UD021–UD025) from by-name so sidebar/Q&A stay in sync after create
        if (typeof refetchActiveModule === 'function') await refetchActiveModule();
    };
    const saveAnswer = (e, question, sectionNo, type)=>{
        const customSaveOk = (0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(question?.qNo) || (0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(sectionNo);
        if (permissionLevel == 'DASHBOARD' && !customSaveOk) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
            return;
        }
        const permNo = question?.qNo || sectionNo;
        const isOpenModuleForSave = activeModule?.isInvestorMatch || activeModule?.isInvestmentReadiness;
        const customSlotOkForSave = (0, $b0b365559f7dda09$export$9ef31d2dc1512c0d)(permNo);
        if (permNo && !isOpenModuleForSave && !customSlotOkForSave && company['creatorId']?.['_id'] != user['_id'] && company['addedByInvestor'] != user['_id'] && (company['servicedBy']?.['_id'] || company['servicedBy']) != user['_id'] && company['cCategory'] == 'client' && !companyIndex) {
            if (user['role'] == 'Advisor' && !company['advisors']?.[user['_id']]?.['modules']?.[permNo.split('.')[0]] && !company['advisors']?.[user['_id']]?.['modules']?.[permNo.split('.').slice(0, 2).join('.')]) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
                return;
            }
            if (user['role'] == 'Investor' && !company['investors']?.[user['_id']]?.['modules']?.[permNo.split('.')[0]] && !company['investors']?.[user['_id']]?.['modules']?.[permNo.split('.').slice(0, 2).join('.')]) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
                return;
            }
            if (user['role'] == 'Member' && !company?.['memberPermissions']?.[user['_id']]?.[permNo.split('.')[0]] && !company?.['memberPermissions']?.[user['_id']]?.[permNo.split('.')[0].replace(/\d+$/, '')] && !company?.['memberPermissions']?.[user['_id']]?.[permNo.split('.').slice(0, 2).join('.')]) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('To access this module please contact your account admin');
                return;
            }
        }
        let subAnswers;
        if (question['qNo'] == 'DEPF008.3.1' && question?.['answer']?.['subAnswers']) subAnswers = question['answer']['subAnswers'];
        question = JSON.parse(JSON.stringify(question));
        const priorAnswerStatus = question?.answer?.status;
        const priorRadioOption = question?.answer?.radioOption;
        // Send only update keys
        if (type != 'radio' && question['answer']) question['answer'] = {
            _id: question['answer']['_id']
        };
        if ([
            'T',
            'F/T',
            'Date',
            'DropDown',
            'Radio',
            'Multi'
        ].includes(question['questionType'])) {
            question['answer'].status = 'Completed';
            question['answer'].radioOption = 'Yes';
        }
        if ([
            'YN/F/T'
        ].includes(question['questionType']) && question['answer'].radioOption == 'N/A') question['answer'].status = 'Completed';
        clearTimeout(saveTimeout);
        let questionAndAnswerToSave = questionsAndAnswersToSave.find((q)=>q._id == question['_id']);
        if (!questionAndAnswerToSave) {
            // Extract directorId from tab for director-wise temp modules
            let directorIdFromTab = undefined;
            if (tab && tab.includes('directors-questionnaire_')) {
                const tabParts = tab.split('_');
                if (tabParts.length > 1) directorIdFromTab = tabParts[1];
            }
            questionAndAnswerToSave = {
                ...question,
                sectionNo: sectionNo,
                moduleType: question['type'],
                answer: {
                    _id: question.answer?._id,
                    fileIndexes: [],
                    logs: question.answer?.logs,
                    ...question.answer,
                    ...directorIdFromTab && !question.answer?.directorId && {
                        directorId: directorIdFromTab
                    }
                }
            };
            if (question?.['answer']?.['status']) questionAndAnswerToSave['answer']['status'] = question['answer']['status'];
            questionsAndAnswersToSave.push(questionAndAnswerToSave);
        }
        if (question['qNo'] == 'DEPF008.3.1' && e.target.name != 'comment') {
            if (!questionAndAnswerToSave['answer']['subAnswers']) questionAndAnswerToSave['answer']['subAnswers'] = {};
            if (subAnswers) questionAndAnswerToSave['answer']['subAnswers'] = {
                ...subAnswers,
                [e.target.name]: e.target.value
            };
            else questionAndAnswerToSave['answer']['subAnswers'][e.target.name] = e.target.value;
        } else if (question['questionType'] == 'Radio') questionAndAnswerToSave.answer['dropdown'] = e.target.dataset.option;
        else if (question['questionType'] == 'Multi') {
            let answer = '';
            e.target.value.map((value)=>{
                if (value.length == 0) return;
                if (answer.length > 0) answer = answer + ';' + value;
                else answer = value;
            });
            questionAndAnswerToSave.answer[e.target.name] = answer;
        } else if (e.target.dataset && e.target.dataset.option) {
            questionAndAnswerToSave.answer.radioOption = e.target.dataset.option;
            questionAndAnswerToSave.answer.status = 'Completed';
        } else if (e.target.files) {
            for (const file of e.target.files){
                let index = attachment.push(file) - 1;
                questionAndAnswerToSave.answer.fileIndexes.push(index);
            }
            //showMessage("Uploading files");
            if (!company['uploadedFile'] || !company['syncRequired']) dispatch(setCompany({
                ...company,
                uploadedFile: true,
                syncRequired: true
            }));
            if (question['questionType'] == 'D/ND') questionAndAnswerToSave.answer.radioOption = 'Disclosure';
            else {
                const effectiveRadioOption = questionAndAnswerToSave.answer.radioOption || priorRadioOption;
                if (!effectiveRadioOption || effectiveRadioOption === 'NC') questionAndAnswerToSave.answer.radioOption = 'Yes';
            }
        } else if (e.target.type === "checkbox") {
            questionAndAnswerToSave.answer.status = e.target.checked ? "Completed" : "In Progress";
            if (!question['answer']['_id']) questionAndAnswerToSave.answer.radioOption = question['questionType'] == 'D/ND' ? 'Disclosure' : 'Yes';
        } else questionAndAnswerToSave.answer[e.target.name] = e.target.value || e.target.checked;
        if (question['questionType'] === 'TA' && questionAndAnswerToSave.answer.comment) questionAndAnswerToSave.answer.status = 'Completed';
        const curSaveStatus = questionAndAnswerToSave.answer.status;
        const isCompletedLikeSave = curSaveStatus === 'Completed' || curSaveStatus === 'Not Applicable';
        if (!isCompletedLikeSave) {
            if (priorAnswerStatus === 'Not Started' || priorAnswerStatus === undefined || priorAnswerStatus === null || priorAnswerStatus === '') questionAndAnswerToSave.answer.status = 'In Progress';
            else if ((curSaveStatus === undefined || curSaveStatus === null || curSaveStatus === '') && priorAnswerStatus) questionAndAnswerToSave.answer.status = priorAnswerStatus;
        }
        if (tab === 'investor-lead' && e.target.type !== 'checkbox') {
            questionAndAnswerToSave.answer.status = 'Completed';
            if (type !== 'radio') {
                const qId = question['_id'];
                setLocalModule((prev)=>{
                    if (!prev) return prev;
                    const clone = JSON.parse(JSON.stringify(prev));
                    for (const sec of clone.sections){
                        const qi = sec.questions?.findIndex((q)=>q._id === qId || q._id?.toString() === qId?.toString());
                        if (qi >= 0) {
                            sec.questions[qi] = {
                                ...sec.questions[qi],
                                answer: {
                                    ...sec.questions[qi].answer,
                                    status: 'Completed'
                                }
                            };
                            break;
                        }
                    }
                    return recomputeLocalStats(clone);
                });
            }
        }
        if (e.target.files) setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                ...questionsAndAnswersToSave
            ]);
        else setSaveTimeout(setTimeout(()=>setQuestionsAndAnswersToSave((questionsAndAnswersToSave)=>[
                    ...questionsAndAnswersToSave
                ]), 10));
    };
    const save = async ()=>{
        setIsSaving(true);
        setQuestionsAndAnswersToSave([]);
        let currentCount = 0, percent = 0, filesInfo = [];
        const totalFileCount = attachment.length;
        for (const file of attachment){
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/newUploadFile`, {
                attachment: [
                    file
                ]
            }, true);
            if (!res) continue;
            if (!res.body?.['result']) continue;
            currentCount++;
            filesInfo.push(res.body['result']);
            percent = Math.round(currentCount / totalFileCount * 100);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'computerToDataRepository',
                percent: percent,
                fileName: file['name'],
                totalFiles: totalFileCount,
                filesUploaded: currentCount
            }));
        }
        const currentCompanyId = localStorage.getItem('companyId') || companyId;
        const isLegacyModule = activeModule?.isInvestmentReadiness || activeModule?.isInvestorMatch;
        const saveEndpoint = isLegacyModule ? '/question/newSaveAnswers' : '/modules/temp-answers/save';
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(saveEndpoint, {
            files: filesInfo,
            companyId: currentCompanyId,
            questionsAndAnswersToSave: questionsAndAnswersToSave
        });
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (!res || res['code'] != 200) {
            setIsSaving(false);
            return;
        }
        const { answerErrors: answerErrors = {}, savedQuestions: savedQuestions = [] } = res['body'];
        if (answerErrors && Object.keys(answerErrors).length > 0) Object.values(answerErrors).forEach((msg)=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(msg));
        if (savedQuestions.length > 0) {
            updateLocalAnswers(savedQuestions);
            // Broadcast saved answers to the sidebar so its progress bars update immediately
            // without requiring a page refresh. SidebarIndexNew listens to tempModuleAllocationPatch.
            if (activeModule?._id) dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                tempModuleAllocationPatch: {
                    moduleId: String(activeModule._id),
                    savedQuestions: savedQuestions
                }
            }));
        }
        setAttachment([]);
        setIsSaving(false);
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        spinner?.classList?.add("op0");
    };
    const onClickDeduperAuditLog = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getDeduperReportLog/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'deduperReportAuditLog'
        }));
    };
    const onClickUnallocatedBinAuditLog = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getUnallocatedBinLog/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedBinAuditLog'
        }));
    };
    const moveUnallocatedFile = async ({ payload: payload })=>{
        if (payload.length) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/moveUnallocateFiles', {
                payload: payload,
                companyId: companyId,
                moduleId: activeModule._id,
                tab: tab
            });
            if (!res || res['code'] != 200) return;
            const savedQuestions = res?.body?.savedQuestions || [];
            if (savedQuestions.length > 0) {
                updateLocalAnswers(savedQuestions);
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    tempModuleAllocationPatch: {
                        moduleId: String(activeModule._id),
                        savedQuestions: savedQuestions
                    }
                }));
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            const filteredUnallocatedFiles = unallocatedFiles.filter((uf)=>!uf?.sectionNo);
            dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(filteredUnallocatedFiles));
            setRefresh(!refresh);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select target section');
    };
    const moveDeduperFile = async ({ payload: payload })=>{
        if (payload.length) {
            const isTempModule = !!activeModule?._id;
            const endpoint = '/modules/moveDeduperFile';
            const body = isTempModule ? {
                companyId: companyId,
                moduleId: activeModule._id,
                actions: payload
            } : {
                companyId: companyId,
                tab: tab,
                actions: payload
            };
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(endpoint, body);
            if (!res || res['code'] != 200) return;
            if (tab) await reloadModule(tab, true);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            if (isTempModule) // Modules response: { results: [...] } — no DeduperReport
            setRefresh(!refresh);
            else {
                const newReport = res['body'];
                dispatch((0, $e0a7c253e2df808f$export$607aedf5e5b112cd)(JSON.parse(JSON.stringify(newReport))));
                let curSection = {};
                for (const dupFiles of Object.values(newReport.deduperResult || {})){
                    if (!Array.isArray(dupFiles)) continue;
                    for (const dupFile of dupFiles)if (dupFile?.file?.key) curSection[dupFile.file.key] = {
                        qNo: dupFile.qNo,
                        name: dupFile.name
                    };
                }
                dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
                setRefresh(!refresh);
            }
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select target section');
    };
    const onClickFileReportHistory = async ()=>{
        setFAMenuVisible(false);
        setIsLoader({
            show: true,
            message: 'Loading Filing Assistant History...'
        });
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFileReportHistory/${companyId}`);
            setReportHistories(res['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'fileReportHistory'
            }));
        } finally{
            setIsLoader({
                show: false,
                message: ''
            });
        }
    };
    const showDeduperReport = (report)=>{
        // setDupCheck(JSON.parse(JSON.stringify(report)));
        // setDupCheck(report);
        dispatch((0, $e0a7c253e2df808f$export$607aedf5e5b112cd)(report));
        let curSection = {};
        if (report?.deduperResult && typeof report.deduperResult === "object") for (const dupFiles of Object.values(report.deduperResult)){
            if (!Array.isArray(dupFiles)) continue;
            for (const dupFile of dupFiles)if (dupFile?.file?.key) curSection[dupFile.file.key] = {
                qNo: dupFile.qNo,
                name: dupFile.name
            };
        }
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'duplicationCheckSummary'
        }));
    };
    const onClickDeduperReportHistory = async ()=>{
        setFAMenuVisible(false);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getDeduperReportHistory/${company['_id']}`);
        if (res && res.body && !res['body'].length) return checkDuplicatedFiles();
        if (res['body'] && Array.isArray(res['body']) && res['body'].length > 0) showDeduperReport(res['body'][0]);
        else showDeduperReport({});
    // setDeduperHistories(res['body']);
    // dispatch(toggleModal({ open: 'deduperReportHistory' }))
    };
    const handleToggleSuccessAiReportGeneratedModal = async (redirect)=>{
        // Close the success modal first
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        // If user wants to view the report, show disclaimer
        // Navigation will be handled in handleAiReportDisclaimerClose after user clicks "Understood"
        if (redirect) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'DisclaimerAIReportModal'
        }));
    };
    const generateInsuranceAiReport = async ({ data: data, isQuestion: isQuestion })=>{
        setFAMenuVisible(false);
        const liveModule = localModuleRef.current || localModule;
        const allFiles = isQuestion ? $2b1aff43fcfd6fe2$var$collectQuestionSourceFileUrls($2b1aff43fcfd6fe2$var$findQuestionInModule(liveModule, data) || data) : $2b1aff43fcfd6fe2$var$collectSectionSourceFileUrls(liveModule, data);
        const generatingKey = getReportGenerationKey(data, isQuestion);
        const requestId = startReportGenerationLoading(generatingKey);
        if (!companyObjectId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Unable to generate analysis report. Missing company identifier.');
            stopReportGenerationLoading(requestId);
            return;
        }
        if (!allFiles.length) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please upload a document before generating a report.');
            stopReportGenerationLoading(requestId, {
                force: true
            });
            return;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`The report generation process is in progress and may take approximately 8 to 10 minutes to complete.`);
        try {
            const sectionId = isQuestion ? data.sectionId : data?.['_id'] || data.section._id;
            const isTempFlow = !!activeModule?._id;
            const reportEndpoint = isTempFlow ? `${syncApiBase}/generateTempSectionReport/${companyObjectId}/${sectionId}` : `${syncApiBase}/generateSectionReport/${companyObjectId}/${sectionId}`;
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(reportEndpoint, {
                "companyId": companyObjectId,
                "files": allFiles,
                "query": 'You are a legal diligence report writer. Follow instructions strictly.',
                "isQuestion": isQuestion,
                ...isQuestion ? {
                    data: data
                } : {},
                ...isTempFlow ? {
                    usePapermill: true
                } : {}
            });
            // if (true) {
            if (res?.['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                if (refetchActiveModuleRef.current) refetchActiveModuleRef.current();
                const reportType = res?.body?.reportType || null;
                expectedReportTypeRef.current = reportType;
                let sectionData = null;
                if (isQuestion && data?.sectionId) // Try to find the section from company data using sectionId
                {
                    if (company?.modules) {
                        for (const module of Object.values(company.modules))if (module?.sections) {
                            sectionData = Object.values(module.sections).find((sec)=>sec._id === data.sectionId || sec._id?.toString() === data.sectionId?.toString());
                            if (sectionData) break;
                        }
                    }
                } else if (!isQuestion) // For section reports, data is the section itself
                sectionData = data;
                // Store navigation data (section may be null for questions, but we have qNo in data)
                const anchor = sectionData?.sectionNo || sectionData?.no || data?.sectionNo || data?.qNo || null;
                if (anchor) {
                    lastReportAnchorRef.current = anchor;
                    try {
                        localStorage.setItem('lastReportAnchor', anchor);
                    } catch (_) {}
                }
                setSectionToNavigate({
                    section: sectionData,
                    isQuestion: isQuestion,
                    data: data
                });
                sectionToNavigateRef.current = {
                    section: sectionData,
                    isQuestion: isQuestion,
                    data: data
                };
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'successAiReportGenerated'
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message'] || 'Unable to generate analysis report');
        } catch (error) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(error?.message || 'Unable to generate analysis report');
        } finally{
            stopReportGenerationLoading(requestId, {
                force: true
            });
            setTimeout(()=>{
                if (isComponentMountedRef.current) {
                    const loadingMap = (0, $564b3e95a736953b$export$503183a1eef33108)();
                    const entry = loadingMap[companyObjectId];
                    if (!entry || entry.status !== 'pending') {
                        setReportGenerateLoadingState(null);
                        reportGenerationRequestRef.current = null;
                    }
                }
            }, 200);
        }
    };
    const onClickViewUnallocatedFiles = async ()=>{
        setFAMenuVisible(false);
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/unallocatedFiles/${companyId}`);
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)({}));
        dispatch((0, $e0a7c253e2df808f$export$7f5872b9f0fc6312)(res['body']['unallocated']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'unallocatedFiles'
        }));
    };
    const checkDuplicatedFiles = async ()=>{
        setFAMenuVisible(false);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'checkingDuplication'
        }));
        const isTempModule = !!activeModule?._id;
        const payload = isTempModule ? {
            companyId: companyId,
            moduleId: activeModule._id
        } : {
            companyId: companyId,
            tab: tab
        };
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/checkDuplicate`, payload);
        showDeduperReport(res?.['body'] || {});
    };
    const getViewableURL = (url)=>{
        window.open(url, "_blank");
    };
    const getDeduperReportLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>getViewableURL(file['location']),
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem cp",
                                                children: file['originalname']
                                            }, `deduper-log-file-${idx}-${fileIdx}-${file['originalname']}`))
                                    ]
                                })
                            }),
                            log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Comment"
                                        }),
                                        ": ",
                                        log?.['change']?.comment ? log?.['change']?.comment : '-'
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, `deduper-log-${idx}-${log.timestamp}`);
        });
    const getFileReportLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>getViewableURL(file['location']),
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem cp",
                                                children: file['originalname']
                                            }, `file-report-log-file-${idx}-${fileIdx}-${file['originalname']}`))
                                    ]
                                })
                            }),
                            log?.['change'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Changed Status"
                                            }),
                                            ": ",
                                            log?.['change']?.comment ? log?.['change']?.comment : '-'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: "Assistant Accuracy"
                                            }),
                                            ": ",
                                            log?.['change']?.accuracy != undefined ? log?.['change']?.accuracy : '-',
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, `file-report-log-${idx}-${log.timestamp}`);
        });
    const getUnallocatedBinLogsHTML = (logs)=>logs.map((log, idx)=>{
            if (!log['files']) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: " "
            });
            else return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    log?.['userId']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${profileClass}`,
                        src: log['userId']['profile'],
                        "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`,
                        children: [
                            log?.['userId']?.['firstName']?.[0] || "?",
                            log?.['userId']?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "fs0-75rem c15",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            log['message'],
                                            " by ",
                                            log?.['userId']?.['firstName'],
                                            " "
                                        ]
                                    }),
                                    " at ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: new Date(log.timestamp).toLocaleString()
                                    })
                                ]
                            }),
                            log['files'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "df fs0-75rem mb0-5rem",
                                    children: [
                                        "Files: ",
                                        log['files'].map((file, fileIdx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                onClick: ()=>getViewableURL(file['location']),
                                                target: "_blank",
                                                className: "db c3-hover fw600 tdu fs0-75rem ml0-5rem cp",
                                                children: file['originalname']
                                            }, `unallocated-bin-log-file-${idx}-${fileIdx}-${file['originalname']}`))
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, `unallocated-bin-log-${idx}-${log.timestamp}`);
        });
    const onClickFileManager = (section, questionIndex)=>{
        let curSection = {
            ...targetSection
        };
        if (section && section.files && section.files.length > 0) section.files.map((file)=>{
            curSection[file.key] = {
                qNo: section.sectionNo || section.no,
                name: section.sectionName || section.name
            };
        });
        dispatch((0, $12074930bd2c1829$export$d9cc0dc4121e3dbf)(curSection));
        // Patch fileAllocation.company.modules[tab] with a flat tempQuestions list so
        // the destination picker (openRModal) shows temp questions (qNo + section name)
        if (localModule?.sections) {
            const tempQuestions = [];
            for (const sec of localModule.sections){
                for (const q of sec.questions || [])if (q.qNo) tempQuestions.push({
                    qNo: q.qNo,
                    qDescription: q.qDescription || '',
                    sectionNo: sec.sectionNo,
                    sectionName: sec.sectionName || ''
                });
            }
            const baseCompany = fileAllocationCompany || company;
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                company: {
                    ...baseCompany,
                    modules: {
                        ...baseCompany?.modules || {},
                        [tab]: {
                            isTempModule: true,
                            tempQuestions: tempQuestions,
                            sections: []
                        }
                    }
                }
            }));
        }
    };
    const answerSaved = (answer)=>{
        let updatedBy = answer?.['updatedBy']?.[0] || answer?.['updatedBy'];
        if (updatedBy?.['firstName']) {
            let answerClass = updatedBy?.['role'] == 'Advisor' ? 'advisor-profile' : updatedBy?.['role'] == 'Investor' ? 'investor-profile' : 'client-profile';
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df my0-5rem",
                children: [
                    answer?.['autoFilled'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: "ass mr0-5rem br100 w2rem h2rem",
                        src: (parcelRequire("bi4Ns")),
                        alt: "Clarence",
                        "data-tooltip": "Auto-filled by Clarence AI"
                    }) : updatedBy?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: `ass mr0-5rem br100 w2rem h2rem ${answerClass}`,
                        src: updatedBy['profile'],
                        "data-tooltip": updatedBy['firstName'] ? updatedBy['firstName'] + " " + updatedBy['lastName'] : "Register to show your name here"
                    }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: `shadow ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem c15 bg16 ${answerClass}`,
                        "data-tooltip": updatedBy?.['firstName'] ? updatedBy['firstName'] + " " + updatedBy['lastName'] : "Register to show your name here",
                        children: [
                            updatedBy?.['firstName']?.[0] || "?",
                            updatedBy?.['lastName']?.[0] || "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "fs0-75rem c15",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: "Answer Saved"
                                }),
                                ", ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(answer['updatedAt']).format('lll')
                                })
                            ]
                        })
                    })
                ]
            });
        }
    };
    const handleSectionLogs = async (id)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`${logsApiBase}/getLogs/${id}`);
        dispatch((0, $12074930bd2c1829$export$73dba2c4178787b2)(res['body']));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'auditLog'
        }));
    };
    const openWindow = (url)=>{
        if (window.innerWidth <= 640) {
            var a = document.createElement('a');
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");
            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);
            a.dispatchEvent(dispatch);
        } else {
            var width = window.innerWidth * 0.8;
            var height = width * window.innerHeight / window.innerWidth;
            window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + (window.innerHeight - height) / 2 + ', left=' + (window.innerWidth - width) / 2);
        }
        return false;
    };
    const getFilesFromQuestions = (questions)=>questions && questions.filter((q)=>q.answer?.files?.length).reduce((arr, q)=>[
                ...arr,
                ...q.answer.files.map((file)=>({
                        ...file,
                        questionId: q._id,
                        qNo: q.qNo,
                        title: file.originalname,
                        url: file.location,
                        ext: file.originalname.split(".").slice(-1)[0]
                    }))
            ], []);
    // Map qNo → question (used for temp move/copy destination lookup)
    const questionByQNo = (0, $acw62.useMemo)(()=>{
        if (!localModule?.sections) return {};
        const map = {};
        for (const sec of localModule.sections){
            for (const q of sec.questions || [])if (q.qNo) map[q.qNo] = q;
        }
        return map;
    }, [
        localModule
    ]);
    // Move/copy a file between temp module questions without a full module refetch
    const handleTempMoveFile = (0, $acw62.useCallback)(async ({ file: file, qNo: qNo, curQno: curQno, isCut: isCut, sectionName: sectionName })=>{
        // Investment Readiness & Investor Match/Lead use the legacy non-temp moveFile
        // endpoint because their answers live on the regular Company modules tree,
        // not in TempAnswer. Route those tabs to /company/moveFile and refetch.
        const isLegacyMoveFileTab = tab === 'Investment Readiness' || tab === 'investor-lead';
        if (isLegacyMoveFileTab) {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/moveFile', {
                file: file,
                unallocated: false,
                companyId: companyId,
                isCut: isCut,
                qNo: qNo,
                tab: tab,
                oldQno: curQno,
                isDeduper: false,
                key: file.key,
                sectionName: sectionName
            });
            if (!res || res['code'] !== 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Move/copy failed');
                return;
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            if (reloadModule) reloadModule(tab, false, false, true);
            return;
        }
        // source: file.questionId is already the MongoDB _id (set by getFilesFromQuestions)
        const fromQuestionId = file?.questionId ?? curQno;
        // Primary lookup: exact qNo match (standard sections and new custom sections use sectionNo as qNo).
        // Fallback: legacy custom sections stored qNo as '<sectionNo>.Q1' — try the first child question
        // whose qNo starts with '<sectionNo>.' so moves still work for pre-existing documents.
        let toQuestion = questionByQNo[qNo];
        if (!toQuestion) {
            const prefix = qNo + '.';
            toQuestion = Object.values(questionByQNo).find((q)=>q.qNo && q.qNo.startsWith(prefix));
        }
        if (!toQuestion) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Destination question not found');
            return;
        }
        const toQuestionId = toQuestion._id;
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/modules/temp-answers/move-file', {
            companyId: companyId,
            fromQuestionId: fromQuestionId,
            toQuestionId: toQuestionId,
            fileKey: file.key,
            isCut: isCut
        });
        if (!res || res['code'] !== 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.message || 'Move/copy failed');
            return;
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        const movedFile = res?.body?.file || file;
        const toAnswerId = res?.body?.toAnswerId;
        setLocalModule((prev)=>{
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            let sourceQ = null, destQ = null;
            for (const sec of clone.sections)for (const q of sec.questions || []){
                if (q._id?.toString() === fromQuestionId?.toString()) sourceQ = q;
                if (q._id?.toString() === toQuestionId?.toString()) destQ = q;
            }
            if (!sourceQ || !destQ) return prev;
            if (isCut) {
                sourceQ.answer = sourceQ.answer || {};
                sourceQ.answer.files = (sourceQ.answer.files || []).filter((f)=>f.key !== file.key);
                if (sourceQ.answer.files.length === 0 && sourceQ.answer.radioOption === 'Yes') sourceQ.answer.status = 'In Progress';
            }
            destQ.answer = destQ.answer || {};
            if (toAnswerId) destQ.answer._id = toAnswerId;
            destQ.answer.files = destQ.answer.files || [];
            if (!destQ.answer.files.some((f)=>f.key === movedFile.key)) destQ.answer.files.push(movedFile);
            if (![
                'Yes',
                'Disclosure'
            ].includes(destQ.answer.radioOption)) destQ.answer.radioOption = 'Yes';
            destQ.answer.status = 'Completed';
            return recomputeLocalStats(clone);
        });
    }, [
        companyId,
        questionByQNo,
        tab,
        reloadModule
    ]);
    const showRiskRecommendation = (key)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
            className: "fs1rem fsi mt2rem df aic c15",
            children: key.includes("recommend") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "mr0-5rem",
                        width: "27",
                        height: "27",
                        viewBox: "0 0 27 27",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.0954 10.0946C21.0954 5.89534 17.6873 2.49208 13.4862 2.50001C9.32805 2.50787 5.97026 5.81889 5.90715 9.97656C5.86673 12.6385 7.19613 14.9926 9.23603 16.3795C9.24414 16.385 9.24902 16.3941 9.24902 16.404C9.6515 16.6551 9.8961 17.0961 9.8961 17.5705V19.2815H17.1055V17.555C17.1055 17.0891 17.3416 16.6547 17.7326 16.4013L17.7526 16.3883C19.7696 15.023 21.0954 12.7136 21.0954 10.0946Z",
                                fill: "url(#paint0_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M13.5034 15.3135C16.3444 15.3135 18.6474 13.0104 18.6474 10.1694C18.6474 7.32845 16.3444 5.02539 13.5034 5.02539C10.6624 5.02539 8.35938 7.32845 8.35938 10.1694C8.35938 13.0104 10.6624 15.3135 13.5034 15.3135Z",
                                fill: "url(#paint1_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M20.6955 12.5354L15.9165 7.7564C15.8453 7.62505 15.7329 7.5332 15.5718 7.5332H11.5191C11.2095 7.5332 11.0781 7.87094 11.0781 8.1805C11.0781 8.46824 11.1821 8.72517 11.3702 8.81365L12.8136 10.2856V13.9406C12.8136 14.0885 12.9026 14.1997 13.0365 14.2748L17.107 18.3453V17.5559C17.107 17.0899 17.343 16.6556 17.7341 16.4021L17.7541 16.3891C19.1136 15.4689 20.1584 14.1193 20.6955 12.5354Z",
                                fill: "url(#paint2_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.5249 7.49023H11.4722C11.1626 7.49023 11.0312 7.82797 11.0312 8.13753C11.0312 8.49403 11.1907 8.80359 11.4722 8.80359H12.7668V13.8976C12.7668 14.1978 13.1327 14.3479 13.4986 14.3479C13.8645 14.3479 14.2303 14.1978 14.2303 13.8976V8.80359H15.525C15.8064 8.80359 15.9659 8.49403 15.9659 8.13753C15.9658 7.82792 15.8344 7.49023 15.5249 7.49023Z",
                                fill: "url(#paint3_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M23.8094 9.42578H22.1956C21.8115 9.42578 21.5 9.7372 21.5 10.1214C21.5 10.5055 21.8114 10.817 22.1956 10.817H23.8094C24.1935 10.817 24.505 10.5056 24.505 10.1214C24.505 9.7372 24.1936 9.42578 23.8094 9.42578Z",
                                fill: "url(#paint4_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M5.505 10.1214C5.505 9.73724 5.19358 9.42578 4.80939 9.42578H3.19561C2.81142 9.42578 2.5 9.7372 2.5 10.1214C2.5 10.5055 2.81142 10.817 3.19561 10.817H4.80939C5.19354 10.817 5.505 10.5055 5.505 10.1214Z",
                                fill: "url(#paint5_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.7422 13.985C21.4705 13.7133 21.0301 13.7133 20.7584 13.985C20.4868 14.2566 20.4868 14.6971 20.7584 14.9687L21.8995 16.1098C22.1712 16.3815 22.6116 16.3815 22.8833 16.1098C23.1549 15.8382 23.1549 15.3977 22.8833 15.1261L21.7422 13.985Z",
                                fill: "url(#paint6_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M5.10153 4.13342C4.82989 3.86178 4.38944 3.86178 4.1178 4.13342C3.84615 4.40507 3.84615 4.84551 4.1178 5.11716L5.2589 6.25826C5.53055 6.52991 5.97099 6.52991 6.24264 6.25826C6.51428 5.98662 6.51428 5.54617 6.24264 5.27453L5.10153 4.13342Z",
                                fill: "url(#paint7_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M6.24264 13.985C5.97099 13.7133 5.53055 13.7133 5.2589 13.985L4.1178 15.1261C3.84615 15.3977 3.84615 15.8382 4.1178 16.1098C4.38944 16.3815 4.82989 16.3815 5.10153 16.1098L6.24264 14.9687C6.51428 14.697 6.51428 14.2566 6.24264 13.985Z",
                                fill: "url(#paint8_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M20.7584 6.25826C21.0301 6.52991 21.4705 6.52991 21.7422 6.25826L22.8833 5.11716C23.1549 4.84551 23.1549 4.40507 22.8833 4.13342C22.6116 3.86178 22.1712 3.86178 21.8995 4.13342L20.7584 5.27453C20.4868 5.54617 20.4868 5.98662 20.7584 6.25826Z",
                                fill: "url(#paint9_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M17.1077 17.9497L14.4774 15.3194C14.2488 15.0502 13.908 14.8789 13.5271 14.8789C12.839 14.8789 12.2812 15.4367 12.2812 16.1248C12.2812 16.1696 12.2834 16.2141 12.2882 16.2576C12.3227 16.5842 12.484 16.8732 12.7217 17.0751L14.9278 19.2812H17.1077V17.9497Z",
                                fill: "url(#paint10_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M13.4959 17.3454C14.184 17.3454 14.7419 16.7876 14.7419 16.0994C14.7419 15.4113 14.184 14.8535 13.4959 14.8535C12.8078 14.8535 12.25 15.4113 12.25 16.0994C12.25 16.7876 12.8078 17.3454 13.4959 17.3454Z",
                                fill: "url(#paint11_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M6.42188 12.8516C6.98406 14.2927 7.97314 15.5202 9.23444 16.3778C9.24255 16.3833 9.24742 16.3924 9.24742 16.4022C9.6499 16.6534 9.8945 17.0943 9.8945 17.5687V19.2797H17.1039V17.5533C17.1039 17.0873 17.3399 16.653 17.731 16.3995L17.751 16.3865C19.0185 15.5286 20.0127 14.2977 20.5768 12.8516H6.42188V12.8516Z",
                                fill: "url(#paint12_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z",
                                fill: "url(#paint13_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z",
                                fill: "url(#paint14_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z",
                                fill: "url(#paint15_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 20.4238H10.3136C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3417 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3417 20.4238 16.6766 20.4238Z",
                                fill: "url(#paint16_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z",
                                fill: "url(#paint17_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M16.6766 20.4238L13.5082 20.3066L10.3136 20.4238C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3418 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3418 20.4238 16.6766 20.4238Z",
                                fill: "url(#paint18_linear_5984_51730)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint0_linear_5984_51730",
                                        x1: "7.93971",
                                        y1: "5.55907",
                                        x2: "17.0821",
                                        y2: "14.7015",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint1_linear_5984_51730",
                                        x1: "11.5881",
                                        y1: "8.25411",
                                        x2: "19.3877",
                                        y2: "16.0536",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint2_linear_5984_51730",
                                        x1: "19.8051",
                                        y1: "16.3438",
                                        x2: "7.67629",
                                        y2: "4.21497",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#D52C1C",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.28",
                                                "stop-color": "#D12C1E",
                                                "stop-opacity": "0.28"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5735",
                                                "stop-color": "#C42C23",
                                                "stop-opacity": "0.574"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8721",
                                                "stop-color": "#AF2B2C",
                                                "stop-opacity": "0.872"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A42B31"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint3_linear_5984_51730",
                                        x1: "11.5522",
                                        y1: "8.09465",
                                        x2: "16.2824",
                                        y2: "12.8249",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#E38523"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#C4237C"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint4_linear_5984_51730",
                                        x1: "20.5813",
                                        y1: "9.21341",
                                        x2: "25.2617",
                                        y2: "10.9686",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint5_linear_5984_51730",
                                        x1: "1.58127",
                                        y1: "9.21341",
                                        x2: "6.26166",
                                        y2: "10.9686",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint6_linear_5984_51730",
                                        x1: "19.4346",
                                        y1: "14.1526",
                                        x2: "24.0474",
                                        y2: "15.8824",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint7_linear_5984_51730",
                                        x1: "2.794",
                                        y1: "4.30097",
                                        x2: "7.40674",
                                        y2: "6.03075",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint8_linear_5984_51730",
                                        x1: "3.46243",
                                        y1: "14.4032",
                                        x2: "6.78304",
                                        y2: "15.6485",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint9_linear_5984_51730",
                                        x1: "20.1031",
                                        y1: "4.55165",
                                        x2: "23.4237",
                                        y2: "5.79689",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#F7E07D"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#E69642"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint10_linear_5984_51730",
                                        x1: "17.1961",
                                        y1: "19.7937",
                                        x2: "13.3824",
                                        y2: "15.98",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#D52C1C",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.28",
                                                "stop-color": "#D12C1E",
                                                "stop-opacity": "0.28"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5735",
                                                "stop-color": "#C42C23",
                                                "stop-opacity": "0.574"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8721",
                                                "stop-color": "#AF2B2C",
                                                "stop-opacity": "0.872"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A42B31"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint11_linear_5984_51730",
                                        x1: "12.8755",
                                        y1: "15.4789",
                                        x2: "14.0165",
                                        y2: "16.62",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#E38523"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#C4237C"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint12_linear_5984_51730",
                                        x1: "13.4994",
                                        y1: "14.7928",
                                        x2: "13.4994",
                                        y2: "18.3093",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#D52C1C",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.28",
                                                "stop-color": "#D12C1E",
                                                "stop-opacity": "0.28"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.5735",
                                                "stop-color": "#C42C23",
                                                "stop-opacity": "0.574"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "0.8721",
                                                "stop-color": "#AF2B2C",
                                                "stop-opacity": "0.872"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#A42B31"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint13_linear_5984_51730",
                                        x1: "13.4951",
                                        y1: "18.721",
                                        x2: "13.4951",
                                        y2: "20.1877",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EEF4FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#CFE7FD"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint14_linear_5984_51730",
                                        x1: "10.5019",
                                        y1: "23.2286",
                                        x2: "15.9964",
                                        y2: "23.2286",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#5A5A5A"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#464646"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint15_linear_5984_51730",
                                        x1: "13.4996",
                                        y1: "24.1335",
                                        x2: "13.4996",
                                        y2: "23.2058",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#464646",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#202020"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint16_linear_5984_51730",
                                        x1: "13.4951",
                                        y1: "20.7913",
                                        x2: "13.4951",
                                        y2: "22.519",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#EEF4FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#CFE7FD"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint17_linear_5984_51730",
                                        x1: "13.4951",
                                        y1: "19.2818",
                                        x2: "13.4951",
                                        y2: "20.7916",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#8AAADC",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#8AAADC"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "paint18_linear_5984_51730",
                                        x1: "13.4952",
                                        y1: "21.7098",
                                        x2: "13.4952",
                                        y2: "22.7287",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                "stop-color": "#8AAADC",
                                                "stop-opacity": "0"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "1",
                                                "stop-color": "#8AAADC"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    "Recommendation:"
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        className: "f4 mr0-5rem mah2rem maw2rem",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-primary",
                                d: "M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                className: "fa-secondary",
                                d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
                            })
                        ]
                    }),
                    "Risk:"
                ]
            })
        });
    };
    const sortQuestionsByQNo = (questions)=>{
        if (questions.length > 0) return questions.sort((a, b)=>{
            const aParts = a['qNo'].match(/\d+/g).map(Number);
            const bParts = b['qNo'].match(/\d+/g).map(Number);
            for(let i = 0; i < Math.max(aParts.length, bParts.length); i++)if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
            return 0;
        });
    };
    // Single entry point for importing either files or folders — the upload step offers both. (DIL: merge Import Files/Folders)
    const onImportFileFolder = ()=>{
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            autoFillContext: {
                enabled: false,
                companyId: companyId,
                moduleType: tab,
                moduleId: activeModule?._id,
                sectionCode: null,
                scope: 'module',
                scopeName: ''
            },
            tab: tab
        }));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'autoFillStepper',
            autoFillStepperPhase: 'select',
            autoFillStatusBarPhase: 'select',
            autoFillWithFilling: false,
            autoFillUploadMode: 'files'
        }));
    };
    const handleDisconnectDataRoom = async (dataroomType)=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'disconnectDataRoom',
            modalHistory: dataroomType
        }));
    const handleDateChange = (e, question, qNo)=>{
        setDateValue((prev)=>(prev, {
                [question._id]: e.target.value
            }));
        debouncedSaveAnswer(e, question, qNo);
    };
    const subFolderModules = [
        "repository"
    ];
    const getSectionHTML = (module, currentSection)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bc1b61278319d25b$export$2e2bcd8739ae039), {
            module: module,
            currentSection: currentSection,
            section: section,
            refresh: refresh,
            loading: loading,
            isSaving: isSaving,
            questionsAndAnswersToSave: questionsAndAnswersToSave,
            attachment: attachment,
            visibleSection: visibleSection,
            isFAMenuVisible: isFAMenuVisible,
            deleteFile: deleteFile,
            dateValue: dateValue,
            additionalSections: additionalSections,
            isSectionNameDuplicate: isSectionNameDuplicate,
            reportGenerateLoading: reportGenerateLoading,
            hasAgreedAiReportDisclaimer: hasAgreedAiReportDisclaimer,
            saveAnswer: saveAnswer,
            radioButtonChanged: radioButtonChanged,
            handleFileChange: handleFileChange,
            confirmDeleteFile: confirmDeleteFile,
            syncDrive: syncDrive,
            syncDropbox: syncDropbox,
            syncSharePoint: syncSharePoint,
            generateInsuranceAiReport: generateInsuranceAiReport,
            handleSectionReportLinkClick: handleSectionReportLinkClick,
            setSection: setSection,
            setRefresh: setRefresh,
            setDeleteFile: setDeleteFile,
            setDeleteFileQuestionId: setDeleteFileQuestionId,
            handleSectionLogs: handleSectionLogs,
            setLogModule: setLogModule,
            onClickFileManager: onClickFileManager,
            answerSaved: answerSaved,
            getViewableURL: getViewableURL,
            getFilesFromQuestions: getFilesFromQuestions,
            showRiskRecommendation: showRiskRecommendation,
            sortQuestionsByQNo: sortQuestionsByQNo,
            getReportGenerationKey: getReportGenerationKey,
            hasSectionReport: hasSectionReport,
            getSectionReport: getSectionReport,
            getSectionTabName: getSectionTabName,
            getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
            user: user,
            modal: modal,
            company: company,
            tab: tab,
            permissionLevel: permissionLevel,
            advisors: advisors,
            companyId: companyId,
            openKPI: openKPI,
            isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
            sortSections: sortSections,
            aiEnhanced: aiEnhanced,
            setAiEnchaned: setAiEnchaned,
            onDragOver: onDragOver,
            onDrop: onDrop,
            handleDateChange: handleDateChange,
            dispatch: dispatch,
            toggleModal: (0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e),
            sectionRefs: sectionRefs,
            moduleId: activeModule?._id || null,
            reloadModule: reloadModule,
            patchAnswerInModule: patchAnswerInModule
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "td250 container bg1 py1rem w100 df",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w80 mr1rem df fdc gg0-5rem",
                        children: [
                            user?.role.toLowerCase() === "guest" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                wrapperClass: "tac",
                                heading: activeModule?.heading,
                                subheading: activeModule?.subheading,
                                paragraph: isTwoMinuteTesHomePage ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        "Register at the end of test to access more features ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs11px",
                                            children: "(No credit card required)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                            className: "c3"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                            }) : null,
                            isManualAdd && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1-5rem tac fw500 pb1rem",
                                children: "Key Applicant Information"
                            }),
                            tab !== 'investor-lead' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb btn-dataroom-saf pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            !isManualAdd && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                className: "list-file-manager",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 upload-file",
                                                        children: "Uploaded Directly"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 prepopulated-file",
                                                        children: "Companies House"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 filing-assistant-file",
                                                        children: "AI Filing Manager"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 ai-report-file",
                                                        children: "AI Report"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 sharepoint-file",
                                                        children: "Sharepoint"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 dropbox-file",
                                                        children: "Dropbox"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        className: "bg1 fw400 c2 gdrive-file",
                                                        children: "Drive"
                                                    })
                                                ]
                                            }),
                                            tab?.includes('repository') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e7192990804519c$export$2e2bcd8739ae039), {
                                                company: company,
                                                user: user,
                                                tab: tab,
                                                syncing: syncing,
                                                syncApiBase: syncApiBase,
                                                onConnectDataRoom: (apiBase)=>{
                                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: "connectDataroom"
                                                    }));
                                                },
                                                syncDrive: syncDrive,
                                                reSyncGDrive: reSyncGDrive,
                                                syncDropbox: syncDropbox,
                                                reverseSyncDropbox: reverseSyncDropbox,
                                                syncSharePoint: syncSharePoint,
                                                reSyncSharePoint: reSyncSharePoint,
                                                handleDisconnectDataRoom: handleDisconnectDataRoom,
                                                localModule: localModule,
                                                isDataRepository: isDataRepository,
                                                isTwoMinuteTesHomePage: isTwoMinuteTesHomePage
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            isTwoMinuteTesHomePage && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                "data-tooltip": "Filling Assistant feature is disabled. You must register to access it.",
                                                className: "da-cursor btn-filing-assistant bg3 op50 c1 td250 br50px px1rem py0-75rem fw600 cp bsbb tac df jcc aic fs0-75rem pr",
                                                disabled: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "pa r0",
                                                        style: {
                                                            top: "-15px"
                                                        },
                                                        src: (parcelRequire("4Rkxv")),
                                                        alt: "fillingIcons"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                        style: {
                                                            color: "#fff",
                                                            marginRight: "8px",
                                                            fontSize: '12px'
                                                        }
                                                    }),
                                                    "Filing Assistant"
                                                ]
                                            }),
                                            !isTwoMinuteTesHomePage && activeModule?._id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: tab?.includes('repository') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6df1e2d737f2c033$export$2e2bcd8739ae039), {
                                                    tab: tab,
                                                    company: company,
                                                    localModule: localModule,
                                                    isDataRepository: isDataRepository,
                                                    isChecklist: hasChecklistModuleKeys,
                                                    onImportFileFolder: onImportFileFolder,
                                                    onClickFileReportHistory: onClickFileReportHistory,
                                                    onClickViewUnallocatedFiles: onClickViewUnallocatedFiles,
                                                    checkDuplicatedFiles: checkDuplicatedFiles,
                                                    onClickDeduperReportHistory: onClickDeduperReportHistory,
                                                    onAutoFill: async ()=>{
                                                        const mods = company?.modules || {};
                                                        const expensions = company?.expensions || {};
                                                        const subscription = company?.subscription || '';
                                                        const testType = company?.testType || '';
                                                        const autoFillAvailableModules = [
                                                            {
                                                                key: 'repository',
                                                                label: 'Data Repository'
                                                            }
                                                        ];
                                                        // Business Audit — company-light never surfaces this via company.modules (isCoreModuleType excludes it), so
                                                        // fall back to the same entitlement rule the backend uses (company.controller.js:1331): Lite/Pro subscription only (not Pro Plus)
                                                        const baKey = Object.keys(mods).find((k)=>k.startsWith('business-audit')) || ([
                                                            'Lite',
                                                            'Pro'
                                                        ].includes(subscription) && testType ? `business-audit-${testType}` : null);
                                                        if (baKey) autoFillAvailableModules.push({
                                                            key: baKey,
                                                            label: 'Business Audit'
                                                        });
                                                        // Warranty Disclosure — in modules OR expensions DEPF006 only (DEPF008 = Investor Lead, not WD)
                                                        if (mods['warranty-disclosure'] || expensions['DEPF006']) autoFillAvailableModules.push({
                                                            key: 'warranty-disclosure',
                                                            label: 'Warranty Disclosures'
                                                        });
                                                        // Directors Questionnaire — only if module actually exists in company.modules (requires directors setup)
                                                        const dqKey = Object.keys(mods).find((k)=>k.startsWith('directors-questionnaire'));
                                                        if (dqKey) autoFillAvailableModules.push({
                                                            key: dqKey,
                                                            label: "Directors' Questionnaire"
                                                        });
                                                        // Investment Readiness — company-light never surfaces this via company.modules either (also core-excluded);
                                                        // it's gated purely by testType 'investment' (mirrors shouldBuildSynthetic in dashboard_card.controller.js), no subscription requirement
                                                        if (mods['Investment Readiness'] || testType === 'investment') autoFillAvailableModules.push({
                                                            key: 'Investment Readiness',
                                                            label: 'Investment Readiness'
                                                        });
                                                        // New-dashboard TempModule purchases — resolve company.boughtExpensions (raw TempModule ids) against the active TempModule catalogue
                                                        const boughtIds = Array.isArray(company?.boughtExpensions) ? company.boughtExpensions.map(String) : [];
                                                        try {
                                                            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/temp-modules?limit=100&isActive=true');
                                                            const allTempModules = res?.body?.modules || [];
                                                            boughtIds.forEach((id)=>{
                                                                const m = allTempModules.find((tm)=>String(tm._id) === id);
                                                                const classified = m && classifyBoughtModule(m);
                                                                if (classified && !autoFillAvailableModules.some((a)=>a.key === classified.key)) autoFillAvailableModules.push(classified);
                                                            });
                                                        // Top 10 Cock Ups is entitlement-free (bypasses the Free/Lite gate on the dashboard), so it's not in boughtExpensions
                                                        // Commented out for now — hide Top 10 Cockups from the autofill picker
                                                        // const top10 = allTempModules.find(tm => tm.moduleKey === 'T1IRCUTA' || (/top\s*10/i.test(tm.moduleName || '') && /cock/i.test(tm.moduleName || '')));
                                                        // if (top10 && !autoFillAvailableModules.some(a => a.key === (top10.slug || top10.moduleName))) autoFillAvailableModules.push({ key: top10.slug || top10.moduleName, label: 'Top 10 Cockups' });
                                                        } catch (e) {
                                                            console.error('Failed to resolve temp modules for autofill picker', e);
                                                        }
                                                        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                                                            autoFillContext: {
                                                                enabled: true,
                                                                companyId: companyId,
                                                                moduleType: tab,
                                                                moduleId: activeModule._id,
                                                                scope: 'module',
                                                                scopeName: activeModule.heading || tab
                                                            },
                                                            tab: tab
                                                        }));
                                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            open: 'autoFillStepper',
                                                            autoFillStepperPhase: 'intro',
                                                            autoFillModuleName: activeModule?.heading || tab || '',
                                                            autoFillStatusBarPhase: 'select',
                                                            autoFillWithFilling: true,
                                                            autoFillUploadMode: 'files',
                                                            autoFillAvailableModules: autoFillAvailableModules
                                                        }));
                                                    },
                                                    onDiagnose: (sources)=>{
                                                        const isLegacy = activeModule?.isInvestmentReadiness || activeModule?.isInvestorMatch;
                                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            open: 'diagnoseReport',
                                                            diagnoseLoading: true,
                                                            diagnoseResults: [],
                                                            diagnoseSummary: null,
                                                            diagnoseModuleName: activeModule?.heading || tab || '',
                                                            diagnoseCompanyId: companyId,
                                                            diagnoseModuleType: tab,
                                                            diagnoseModuleId: isLegacy ? null : activeModule?._id || null
                                                        }));
                                                        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/diagnose', {
                                                            companyId: companyId,
                                                            moduleType: tab,
                                                            ...!isLegacy && activeModule?._id ? {
                                                                moduleId: activeModule._id
                                                            } : {},
                                                            sources: sources
                                                        }).then((response)=>{
                                                            if (response?.code === 200) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                diagnoseLoading: false,
                                                                diagnoseResults: response.body.results || [],
                                                                diagnoseSummary: response.body.summary || null
                                                            }));
                                                            else {
                                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: '',
                                                                    diagnoseLoading: false
                                                                }));
                                                                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Auditor failed. Please try again.');
                                                            }
                                                        }).catch(()=>{
                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: '',
                                                                diagnoseLoading: false
                                                            }));
                                                            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Auditor failed. Please try again.');
                                                        });
                                                    }
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83364f35f447dab2$export$2e2bcd8739ae039), {
                                                            companyId: companyId,
                                                            moduleType: tab,
                                                            moduleId: activeModule._id,
                                                            scope: "module",
                                                            scopeName: activeModule.heading || tab,
                                                            size: "medium",
                                                            disabled: hasChecklistModuleKeys,
                                                            onComplete: ()=>reloadModule && reloadModule(tab)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: hasChecklistModuleKeys ? 'op50 pen' : '',
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86bb04e68ae2fbe5$export$2e2bcd8739ae039), {
                                                                companyId: companyId,
                                                                moduleType: tab,
                                                                moduleId: activeModule?.isInvestmentReadiness || activeModule?.isInvestorMatch ? null : activeModule._id,
                                                                tab: tab,
                                                                activeModule: activeModule,
                                                                onComplete: ()=>reloadModule && reloadModule(tab)
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            tab !== 'investor-lead' && isDataRepository && (!company?.isParent && company['owners'][0] === user._id || company?.isParent && company['owners'][0] === user._id || (company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "dg gtcr2-md gg0-5rem",
                                    children: company['lastSyncBy'] && localModule?.uploadFiles && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic fs14px c15",
                                        children: [
                                            company['syncRequired'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "* Sync is Required -  "
                                            }),
                                            "Last synced by - ",
                                            company?.['lastSyncBy']?.['profile'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: `ass mx0-5rem br100 w2rem h2rem`,
                                                src: company?.['lastSyncBy']?.['profile']
                                            }),
                                            " ",
                                            company?.['lastSyncBy']?.['firstName'],
                                            ",",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['lastSyned']).format('lll')
                                        ]
                                    })
                                })
                            }),
                            isModuleDeactivated ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic jcc p4rem tac",
                                style: {
                                    minHeight: '400px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df aic jcc br100 mb2rem",
                                        style: {
                                            width: '80px',
                                            height: '80px',
                                            background: '#FC778520'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                            style: {
                                                fontSize: '40px',
                                                color: '#FC7785'
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "c15 fs1-5rem fw600 mb1rem",
                                        children: "Checklist Deactivated"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c28 fs1rem fw400 maw500px",
                                        children: "This checklist has been deactivated. Please contact your account admin to regain access."
                                    })
                                ]
                            }) : activeModuleLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df jcc aic p2rem c15 fs1rem",
                                children: "Loading module..."
                            }) : localModule && getSectionHTML(localModule),
                            isManualAdd && tab == 'investor-lead' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "df jcc mt1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>localModule?.['stats']?.['completionPercent'] && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'addingApplicantManual'
                                        })),
                                    "data-tooltip": localModule?.['stats']?.['completionPercent'] < 99 ? 'Please complete the questionnaire' : '',
                                    disabled: localModule?.['stats']?.['completionPercent'] < 99,
                                    className: `c1 br20px px4rem py0-5rem mb1rem fw500 tac ${localModule?.['stats']?.['completionPercent'] < 99 ? 'cna bg16' : 'cp bg4'}`,
                                    children: "Next"
                                })
                            }),
                            tab == 'business-audit' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "py2rem df jcc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>enableAIEnhancedReporting(),
                                    className: `${localModule?.['stats']?.['completionPercent'] == 0 && 'op20 pen '} h100 mt0-5rem mxa shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen fds h1rem f1 mr0-5rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 448 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                                })
                                            ]
                                        }),
                                        "AI Enhanced Report"
                                    ]
                                })
                            })
                        ]
                    }),
                    localModule && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41a7e2f21e80a06c$export$2e2bcd8739ae039), {
                        isManualAdd: isManualAdd,
                        setIsWorkflowReport: setIsWorkflowReport,
                        visibleSection: visibleSection,
                        setTab: setTab,
                        profileClass: profileClass,
                        advisors: advisors,
                        permissionLevel: permissionLevel,
                        company: company,
                        setCompany: setCompany,
                        tab: tab,
                        sanitiseTab: sanitiseTab,
                        toggleReport: toggleReport,
                        openKPI: openKPI,
                        calculateStats: calculateStats,
                        calculateSubFolderStats: calculateSubFolderStats,
                        getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                        setSection: setSection,
                        getViewableURL: getViewableURL,
                        twoMinuteTestAIReport: twoMinuteTestAIReport,
                        isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                        getFitInvestorFirms: getFitInvestorFirms,
                        setOpenTabs: setOpenTabs,
                        openTabs: openTabs,
                        sortSections: sortSections,
                        handleSuperflowNext: handleSuperflowNext,
                        handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness,
                        updateUserType: updateUserType,
                        handlePartnerChecklistNext: handlePartnerChecklistNext,
                        setCompanyDashboardTab: setCompanyDashboardTab,
                        setTabName: setTabName,
                        closeTab: closeTab,
                        isBackFitReport: isBackFitReport,
                        setIsBackFitReport: setIsBackFitReport,
                        isLoader: isLoader,
                        setIsLoader: setIsLoader,
                        isExternalPage: false,
                        tempModule: localModule
                    })
                ]
            }),
            reportGenerateLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc aic pf l0 b0 bg1 p2rem br20px shadow",
                style: {
                    maxWidth: '450px',
                    margin: '0 auto 0 90px',
                    zIndex: '1000'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "loading-report-generate",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcc ",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    width: 50,
                                    className: "mr1-5rem",
                                    src: (parcelRequire("bwNCH")),
                                    alt: "loading-report-left"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    width: 50,
                                    className: "mr1rem infinite-rotate",
                                    src: (parcelRequire("l0lQ0")),
                                    alt: "loading-report-center"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    width: 50,
                                    src: (parcelRequire("4MwVZ")),
                                    alt: "loading-report-right"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs14px fw400 c37 tac mt1rem",
                            children: "Report being generated - please continue other tasks - we will let you know when report complete"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25ee15d5fd9a59f0$export$2e2bcd8739ae039), {
                deleteFile: deleteFile,
                deleteUnallocatedFile: deleteUnallocatedFile,
                deleteFileLoading: deleteFileLoading,
                logModule: logModule,
                isSaving: isSaving,
                attachment: attachment,
                additionalSections: additionalSections,
                isSectionNameDuplicate: isSectionNameDuplicate,
                isCustomSectionEnabled: activeModule?.isCustomSection === true,
                activeModule: activeModule,
                newUpgradeSync: newUpgradeSync,
                confirmDeleteFile: confirmDeleteFile,
                confirmDeleteUnallocatedFile: confirmDeleteUnallocatedFile,
                moveUnallocatedFile: moveUnallocatedFile,
                moveDeduperFile: moveDeduperFile,
                onClickDeduperAuditLog: onClickDeduperAuditLog,
                onClickUnallocatedBinAuditLog: onClickUnallocatedBinAuditLog,
                onClickFileReportHistory: onClickFileReportHistory,
                showDeduperReport: showDeduperReport,
                onClickDeduperReportHistory: onClickDeduperReportHistory,
                onSaveAdditionalSections: onSaveAdditionalSections,
                editSectionName: editSectionName,
                onEdit: onEdit,
                onDelete: onDelete,
                handleToggleSuccessAiReportGeneratedModal: handleToggleSuccessAiReportGeneratedModal,
                handleAiReportDisclaimerClose: handleAiReportDisclaimerClose,
                getDeduperReportLogsHTML: getDeduperReportLogsHTML,
                getFileReportLogsHTML: getFileReportLogsHTML,
                getUnallocatedBinLogsHTML: getUnallocatedBinLogsHTML,
                getViewableURL: getViewableURL,
                handleEditDispatch: handleEditDispatch,
                handleFileChange: handleFileChange,
                setDeleteFile: setDeleteFile,
                setDeleteFileQuestionId: setDeleteFileQuestionId,
                setDeleteUnallocatedFile: setDeleteUnallocatedFile,
                setLoading: setLoading,
                setRefresh: setRefresh,
                setSection: setSection,
                syncDrive: syncDrive,
                syncDropbox: syncDropbox,
                syncSharePoint: syncSharePoint,
                openWindow: openWindow,
                toggleReport: toggleReport,
                onMoveFile: handleTempMoveFile,
                modal: modal,
                user: user,
                logList: logList,
                targetSection: targetSection,
                processing: processing,
                unallocatedFiles: unallocatedFiles,
                dupCheck: dupCheck,
                company: company,
                companyId: companyId,
                tab: tab,
                permissionLevel: permissionLevel,
                advisors: advisors,
                profileClass: profileClass,
                loading: loading,
                section: section,
                reloadModule: reloadModule,
                reportHistories: reportHistories,
                setReportHistories: setReportHistories,
                setFileReport: setFileReport,
                setCloneImportResult: setCloneImportResult,
                setCurrentScore: setCurrentScore,
                fileImportRef: fileImportRef,
                onRollbackComplete: ()=>refetchActiveModule()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4f591bf66fcd73d$export$2e2bcd8739ae039), {
                onAction: (key)=>{
                    if (key === 'unallocated-bin') onClickViewUnallocatedFiles();
                    if (key === 'filing-assistant') onClickFileReportHistory();
                    if (key === 'deduper') checkDuplicatedFiles();
                    if (key === 'deduper-reports') onClickDeduperReportHistory();
                }
            })
        ]
    });
}


const $6dc8626146af9081$var$cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);
const $6dc8626146af9081$export$57c43fe781091dc0 = (t)=>decodeURIComponent(t).replace(/(-sync)?-report$/, "");
// Reason: sourced from CompanyTabs so the nav and the hash-routing list can't drift apart.
const $6dc8626146af9081$var$TOP_NAV_TABS = (0, $562489718ce8396e$export$d9a4cca3740decc7);
/** Decode URL-encoded tab values for storage; avoids storing values like "Cyber%20DueDil". */ const $6dc8626146af9081$var$decodeTabValue = (v)=>{
    if (typeof v !== 'string') return v;
    try {
        return decodeURIComponent(v);
    } catch (_) {
        return v;
    }
};






































function $6dc8626146af9081$export$2e2bcd8739ae039(props) {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let company = {
        ...selectedCompany
    };
    const modulesContainerKey = company?.tempModules ? 'tempModules' : 'modules';
    const getModulesContainer = (obj = company)=>obj?.[modulesContainerKey] || {};
    const normModuleLookupKey = (s)=>{
        if (s == null || s === '') return '';
        return $6dc8626146af9081$export$57c43fe781091dc0(String(s)).replace(/^temp-/, '').toLowerCase();
    };
    const moduleIdentityKeys = (mod)=>{
        if (!mod || typeof mod !== 'object') return [];
        return [
            mod.moduleSlug,
            mod.slug,
            mod.moduleKey,
            mod.type,
            mod.moduleName
        ].filter(Boolean).map(normModuleLookupKey).filter(Boolean);
    };
    const getModuleByTab = (obj = company, rawTab = tab)=>{
        const normalizedTab = $6dc8626146af9081$export$57c43fe781091dc0(rawTab || '');
        const normalizedWithoutTempPrefix = normalizedTab.replace(/^temp-/, '');
        const tabIds = [
            normModuleLookupKey(normalizedTab),
            normModuleLookupKey(normalizedWithoutTempPrefix)
        ].filter((v, i, a)=>v && a.indexOf(v) === i);
        if (reduxTempModule && tabIds.length) {
            const reduxIds = moduleIdentityKeys(reduxTempModule);
            if (reduxIds.some((id)=>tabIds.includes(id))) return reduxTempModule;
        }
        const pickDirect = (container)=>container?.[normalizedTab] || container?.[normalizedWithoutTempPrefix];
        let found = pickDirect(obj?.tempModules) || pickDirect(obj?.modules) || getModulesContainer(obj)?.[normalizedTab] || getModulesContainer(obj)?.[normalizedWithoutTempPrefix];
        if (found) return found;
        for (const container of [
            obj?.tempModules,
            obj?.modules
        ].filter(Boolean))for (const [storageKey, mod] of Object.entries(container)){
            if (!mod || typeof mod !== 'object') continue;
            const keyNorm = normModuleLookupKey(storageKey);
            const ids = [
                ...moduleIdentityKeys(mod),
                keyNorm
            ].filter(Boolean);
            if (tabIds.some((t)=>ids.includes(t))) return mod;
        }
        return undefined;
    };
    const store = (0, $391671225302c365$export$6ccbb43953eebf8)();
    let { fileReport: fileReport, currentScore: currentScore, processing: processing, tempModuleAllocationPatch: tempModuleAllocationPatch, tempModule: reduxTempModule } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.fileAllocation);
    const [selectedDirector, setSelectedDirector] = (0, $acw62.useState)({});
    const [tempDirectorStats, setTempDirectorStats] = (0, $acw62.useState)([]);
    const sectionRefs = (0, $acw62.useRef)([]);
    const initialized = (0, $acw62.useRef)(false);
    let [editUser, setEditUser] = (0, $acw62.useState)({});
    let [moduleAI, setModuleAI] = (0, $acw62.useState)('');
    let [advisors, setAdvisors] = (0, $acw62.useState)([]);
    let [investors, setInvestors] = (0, $acw62.useState)([]);
    let [companyId, setCompanyId] = (0, $acw62.useState)({});
    let [allPermissions, setAllPermissions] = (0, $acw62.useState)([]);
    let [editUserTempModules, setEditUserTempModules] = (0, $acw62.useState)([]);
    let [editUserOpenAccordions, setEditUserOpenAccordions] = (0, $acw62.useState)({});
    let [isLeadPdf, setIsLeadPdf] = (0, $acw62.useState)(false);
    let [showAlert, setShowAlert] = (0, $acw62.useState)(false);
    let [uploadImage, setUploadImage] = (0, $acw62.useState)("");
    let [userModules, setUserModules] = (0, $acw62.useState)([]);
    let [aiEnhanced, setAiEnchaned] = (0, $acw62.useState)(false);
    let [tempModuleTitleMap, setTempModuleTitleMap] = (0, $acw62.useState)({});
    let [openTabs, _setOpenTabs] = (0, $acw62.useState)(new Set());
    const setOpenTabs = (0, $acw62.useCallback)((arg)=>{
        _setOpenTabs((prev)=>{
            const next = typeof arg === 'function' ? arg(prev) : arg;
            const list = next instanceof Set ? [
                ...next
            ] : Array.isArray(next) ? next : [
                next
            ];
            return new Set(list.map($6dc8626146af9081$var$decodeTabValue));
        });
    }, []);
    let [isPortfolio, setIsPortfolio] = (0, $acw62.useState)(false);
    let [isManualAdd, setIsManualAdd] = (0, $acw62.useState)(false);
    let [acceptEmail, setAcceptEmail] = (0, $acw62.useState)(false);
    let [investorEmail, setInvestorEmail] = (0, $acw62.useState)({});
    let [checklistTask, setChecklistTask] = (0, $acw62.useState)([]);
    let [userAction, setUserAction] = (0, $acw62.useState)('Search');
    let [companyIndex, setCompanyIndex] = (0, $acw62.useState)(false);
    let [isPrePopulate, setIsPrePopulate] = (0, $acw62.useState)(true);
    let [linearProgress, setLinearProgress] = (0, $acw62.useState)(25);
    let [isClientIndex, setIsClientIndex] = (0, $acw62.useState)(true);
    let [deleteMemberId, setDeleteMemberId] = (0, $acw62.useState)('');
    let [isShowTeamTab, setIsShowTeamTab] = (0, $acw62.useState)(true);
    let [selectedSeeMore, setSelectedSeeMore] = (0, $acw62.useState)({});
    let [selectedModules, setSelectedModules] = (0, $acw62.useState)({});
    let [reportHistories, setReportHistories] = (0, $acw62.useState)([]);
    let [files, setFiles] = (0, $acw62.useState)(company?.['files'] || []);
    let [auditReportLogs, setAuditReportLogs] = (0, $acw62.useState)({});
    let [visibleSection, setVisibleSection] = (0, $acw62.useState)(null);
    let [fitInvestorFirms, setFitInvestorFirms] = (0, $acw62.useState)([]);
    let [permissionLevel, setPermissionLevel] = (0, $acw62.useState)('ALL');
    let [isBackFitReport, setIsBackFitReport] = (0, $acw62.useState)(false);
    let [cloneImportResult, setCloneImportResult] = (0, $acw62.useState)({});
    let [isWorkflowReport, setIsWorkflowReport] = (0, $acw62.useState)(false);
    let [profileClass, setProfileClass] = (0, $acw62.useState)('client-profile');
    let [dashboardTab, setDashboardTab] = (0, $acw62.useState)("Company");
    let [isGetInvestorMatches, setIsGetInvestorMatches] = (0, $acw62.useState)(true);
    let [directors, setDirectors] = (0, $acw62.useState)(company?.['directors'] || []);
    let [isViewTwoMinuteReport, setIsViewTwoMinuteReport] = (0, $acw62.useState)(false);
    let [isGenerateAllResearchAid, setIsGenerateAllResearchAid] = (0, $acw62.useState)(false);
    let [isTwoMinuteTesHomePage, setIsTwoMinuteTesHomePage] = (0, $acw62.useState)(false);
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let [activatingClient, setActivatingClient] = (0, $acw62.useState)(null);
    let [companyDashboardTab, setCompanyDashboardTab] = (0, $acw62.useState)("Dashboard");
    let [activeReportLabel, setActiveReportLabel] = (0, $acw62.useState)('');
    let [tab, setTabName] = (0, $acw62.useState)(props && props?.isCallback ? 'repository' : '');
    const lastReportAnchorRef = (0, $acw62.useRef)(null); // Anchor to scroll when closing report
    const [moduleContent] = (0, $acw62.useState)({
        'kpi': {
            heading: 'KPI',
            aiEnhanced: true,
            uploadFiles: false,
            subheading: 'Key Performance Indicators'
        },
        'repository': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Repository',
            subheading: 'Securely store all your important documents here'
        },
        'business-audit-investment': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'business-audit-growth': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'business-audit-exit': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Business Audit',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'directors-questionnaire': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Directors Questionnaire',
            subheading: ''
        },
        'two-minute-test-exit': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Exit Ready Test',
            subheading: 'See How Exit Ready You Are'
        },
        'two-minute-test-growth': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Growth Ready Test',
            subheading: 'See How Growth Ready You Are'
        },
        'two-minute-test-investment': {
            aiEnhanced: true,
            uploadFiles: false,
            heading: 'Investment Ready Test',
            subheading: 'How Investment Ready Are You'
        },
        'esg': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Environmental, Social & Governmental',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'software-development': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Software Development',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'warranty-disclosure': {
            aiEnhanced: false,
            uploadFiles: true,
            heading: 'Warranty Disclosure Schedule',
            subheading: 'Get expert recommendations on how to reduce risk'
        },
        'unaudited-certification': {
            sections: [],
            heading: 'Certification',
            subheading: 'This is your current certification'
        },
        'investor-lead': {
            uploadFiles: true,
            heading: 'Investor Match',
            subheading: 'Securely store all your important documents here'
        }
    });
    const [investorFirmCounts, setInvestorFirmCounts] = (0, $acw62.useState)({
        gold: 0,
        silver: 0,
        bronze: 0,
        threshold: 0
    });
    (0, $acw62.useEffect)(()=>{
        const urlParams = new URLSearchParams(location?.search);
        const token = urlParams.get('token');
        if (token) {
            (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(token);
            localStorage.setItem('token', token);
            (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/user').then((response)=>{
                if (!response || response['code'] != 200 || !response['body']) return;
                dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(response['body']['user']));
                if (!response['body']['user']?.['isPasswordSet']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'setPasswordPopup'
                }));
            });
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        const patch = tempModuleAllocationPatch;
        if (!patch?.savedQuestions?.length || !selectedCompany) return;
        const answerByQuestionId = new Map(patch.savedQuestions.filter((item)=>item?._id && item?.answer).map((item)=>[
                String(item._id),
                item.answer
            ]));
        if (!answerByQuestionId.size) {
            dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                tempModuleAllocationPatch: null
            }));
            return;
        }
        const updatedCompany = JSON.parse(JSON.stringify(selectedCompany));
        let hasChanges = false;
        const containers = [
            updatedCompany.modules,
            updatedCompany.tempModules
        ].filter(Boolean);
        containers.forEach((container)=>{
            Object.values(container).forEach((module)=>{
                (module?.sections || []).forEach((section)=>{
                    (section?.questions || []).forEach((question)=>{
                        const nextAnswer = answerByQuestionId.get(String(question?._id));
                        if (!nextAnswer) return;
                        question.answer = nextAnswer;
                        hasChanges = true;
                    });
                });
            });
        });
        if (hasChanges) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(updatedCompany));
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tempModuleAllocationPatch: null
        }));
    }, [
        tempModuleAllocationPatch,
        selectedCompany,
        dispatch
    ]);
    const handleDeleteDirector = async (item)=>{
        if (item) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'deleteDirector'
            }));
            setSelectedDirector(item);
        } else {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/${company._id}/delete-director/${selectedDirector['_id']}`, {});
            if (response['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                    ...company,
                    directors: directors.filter((el)=>el['_id'] !== selectedDirector['_id'])
                }));
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'showDirectors'
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        }
    };
    const findUser = async ()=>{
        let email = document.getElementById('searchEmail').value;
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/findUser`, {
            email: email,
            companyId: companyId
        });
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        if (!res || res['code'] != 200) return;
        if (res['body']['found']) {
            setUserAction('Add');
            setEditUser(res['body']['user']);
        } else {
            setEditUser({
                ...editUser,
                email: email
            });
            setUserAction('New');
        }
    };
    const saveUser = async ()=>{
        const permissions = editUser.permissions || {};
        const email = document.getElementById("userEmail").value;
        const lastName = document.getElementById("userLastName").value;
        const firstName = document.getElementById("userFirstName").value;
        const designation = document.getElementById("designation").value;
        let res = '';
        if (userAction == 'Edit') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/editMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        else if (userAction == 'New') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/newMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/addMember', {
            companyId: companyId,
            firstName: firstName,
            lastName: lastName,
            email: email,
            designation: designation,
            permissions: permissions
        });
        if (!res || res['code'] != 200) return;
        getCompany();
        setEditUser({});
        setUserAction('Search');
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    // Build comprehensive permissions list — sections/extraModules/generateChecklistModules are now
    // included in the company-light API response so company state is populated on this route.
    (0, $acw62.useEffect)(()=>{
        if (company?.['sections'] && company['sections'].length) {
            const extraModules = company['extraModules'] && company['extraModules'].length ? company['extraModules'].map((mod)=>({
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.id,
                    sectionName: mod.moduleName === 'Investment Readiness' && mod.name ? `Investment Readiness (${mod.name})` : mod.moduleName
                })) : [];
            const generateChecklistModules = company['generateChecklistModules'] && company['generateChecklistModules'].length ? company['generateChecklistModules'].map((mod)=>({
                    checklistModule: true,
                    type: mod.type,
                    _id: mod._id,
                    sectionNo: mod.moduleKey,
                    sectionName: mod.moduleName === 'Investment Readiness' ? `Investment Readiness (${mod.moduleKey})` : mod.moduleName
                })) : [];
            // Global TempModules (category: 'all') — e.g. Top 10 Investment Readiness
            const tempModulePermissions = company['tempModulePermissions'] && company['tempModulePermissions'].length ? company['tempModulePermissions'].map((mod)=>({
                    checklistModule: true,
                    _id: mod._id,
                    sectionNo: mod.moduleKey,
                    sectionName: mod.moduleName
                })) : [];
            // Combine all permissions — hide Exit Readiness unless company testType is 'exit'
            const combinedPermissions = [
                ...company['sections'],
                ...extraModules,
                ...generateChecklistModules,
                ...tempModulePermissions
            ].filter((section)=>section['sectionName'] !== 'Exit Readiness' || company['testType'] === 'exit');
            setAllPermissions(combinedPermissions);
        }
    }, [
        company?.['sections'],
        company?.['extraModules'],
        company?.['generateChecklistModules'],
        company?.['tempModulePermissions'],
        company?.['testType']
    ]);
    // Reason: the "All Permissions" checkbox is derived from the same modules the section checkboxes render from —
    // keeping it as separate state let a stale sync effect immediately uncheck it after a select-all.
    const selectAll = (0, $acw62.useMemo)(()=>{
        const sections = editUserTempModules.flatMap((module)=>module.sections || []).filter((section)=>section.sectionNo);
        return sections.length > 0 && sections.every((section)=>editUser?.permissions?.[section.sectionNo]);
    }, [
        editUserTempModules,
        editUser?.permissions
    ]);
    const selectAllPermissions = (event)=>{
        const isChecked = event.target.checked;
        const permissions = {
            ...editUser.permissions || {}
        };
        editUserTempModules.forEach((module)=>{
            (module.sections || []).forEach((section)=>{
                if (section.sectionNo) permissions[section.sectionNo] = isChecked;
            });
        });
        setEditUser({
            ...editUser,
            permissions: permissions
        });
    };
    const handleUserChange = (e)=>setEditUser({
            ...editUser,
            [e.target.name]: e.target.type === "radio" ? e.target.id : e.target.value
        });
    const changeUser = (e)=>{
        const updatedPermissions = {
            ...editUser.permissions,
            [e.target.name]: e.target.checked
        };
        setEditUser({
            ...editUser,
            permissions: updatedPermissions
        });
    };
    const toggleEditUserAccordion = (moduleId)=>setEditUserOpenAccordions((prev)=>({
                ...prev,
                [moduleId]: !prev[moduleId]
            }));
    const handleEditUserModuleSelectAll = (e, module)=>{
        const checked = e.target.checked;
        const updated = {
            ...editUser.permissions || {}
        };
        module.sections.forEach((s)=>{
            updated[s.sectionNo] = checked;
        });
        setEditUser({
            ...editUser,
            permissions: updated
        });
    };
    const isEditUserModuleAllSelected = (module)=>module.sections.length > 0 && module.sections.every((s)=>editUser.permissions?.[s.sectionNo]);
    const handleEditUserSectionPermission = (e, section)=>{
        const updated = {
            ...editUser.permissions || {},
            [section.sectionNo]: e.target.checked
        };
        setEditUser({
            ...editUser,
            permissions: updated
        });
    };
    (0, $acw62.useEffect)(()=>{
        // Only redirect to billing if company has NO subscription at all
        // Allow Free and Lite subscriptions to access dashboard (for deferred client activation flow)
        if (user && company && company['_id'] && Object.keys(company).length && (typeof user['companyId'] === "string" && user['companyId'] !== company['_id'] || typeof user['companyId'] === "object" && user['companyId']?._id !== company['_id']) && user['role'] === 'Advisor' && !company['subscription']) {
            navigate(`/billing/${company['_id']}?plan=pro`);
            console.error("Company has no subscription", company['_id'], user['companyId']);
        }
        let checkManualAdd = localStorage.getItem('isManualAdd');
        if (user && user?.['role'] == 'Investor' && company?.['addedByInvestor'] == user?.['_id'] && checkManualAdd) setIsManualAdd(true);
        else setIsManualAdd(false);
    }, [
        user,
        company
    ]);
    (0, $acw62.useEffect)(()=>{
        if (location?.hash) {
            let _tabName = location.hash.replace('#', '');
            if (_tabName === 'company-settings' || _tabName === 'company-audit-log') {
                setDashboardTab('Company');
                setTabName(_tabName);
            }
        }
    }, [
        location?.hash
    ]);
    (0, $acw62.useEffect)(()=>{
        if (modal['open'] !== 'editUser') return;
        (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/all-modules-section', 'not-showMessage').then((res)=>{
            if (res?.code === 200) {
                const body = res.body;
                const combined = Array.isArray(body) ? body.filter((m)=>m.sections?.length > 0) : [
                    ...(body?.modules || []).filter((m)=>m.sections?.length > 0),
                    ...(body?.checklists || []).filter((m)=>m.sections?.length > 0)
                ];
                setEditUserTempModules(combined);
            }
        });
    }, [
        modal['open']
    ]);
    (0, $acw62.useEffect)(()=>{
        // Decode first — tab names with spaces ("Financial Model") arrive as "Financial%20Model"
        // and would otherwise never match TOP_NAV_TABS, falling through to the module-tab branch.
        let tabName = $6dc8626146af9081$var$decodeTabValue(window.location.hash.replace('#', ''));
        if (tabName) {
            if ($6dc8626146af9081$var$TOP_NAV_TABS.includes(tabName)) {
                setCompanyDashboardTab(tabName);
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    tab: ''
                }));
            } else {
                setTabName(tabName);
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    tab: tabName
                }));
            }
        } else dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tab: ''
        }));
    }, []);
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        (async ()=>{
            try {
                const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/modules/temp-modules?limit=100&isActive=true');
                if (!isMounted) return;
                const modulesList = res?.body?.modules || [];
                const map = {};
                modulesList.forEach((m)=>{
                    if (!m || !m.moduleName) return;
                    const keys = [
                        m.slug,
                        m.moduleKey,
                        m.moduleName
                    ].filter(Boolean).map((k)=>String(k).toLowerCase());
                    keys.forEach((k)=>{
                        if (k) map[k] = m.moduleName;
                    });
                });
                setTempModuleTitleMap(map);
            } catch (e) {
                console.error('Failed to load temp modules manifest', e);
            }
        })();
        return ()=>{
            isMounted = false;
        };
    }, []);
    const getTempModuleTitleForTab = (0, $acw62.useCallback)((openTab)=>{
        if (!openTab) return '';
        const normalized = $6dc8626146af9081$export$57c43fe781091dc0(openTab).replace(/^temp-/, '').toLowerCase();
        return tempModuleTitleMap[normalized] || tempModuleTitleMap[openTab?.toLowerCase()] || '';
    }, [
        tempModuleTitleMap
    ]);
    // OPTIMIZATION: Fetch directors and files if not available (excluded in lightweight mode)
    (0, $acw62.useEffect)(()=>{
        const fetchDirectorsAndFiles = async ()=>{
            if (company?._id) {
                // Fetch directors if needed
                if (company?.['directorsCount'] !== undefined && !company?.['directors']) try {
                    const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/directors`);
                    if (response['code'] === 200 && response['body']) setDirectors(response['body']['directors'] || []);
                } catch (e) {
                    console.error('Failed to fetch directors:', e);
                }
                else if (company?.['directors']) setDirectors(company['directors']);
                // Fetch files if needed
                if (company?.['filesCount'] !== undefined && !company?.['files']) try {
                    const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/files`);
                    if (response['code'] === 200 && response['body']) setFiles(response['body']['files'] || []);
                } catch (e) {
                    console.error('Failed to fetch files:', e);
                }
                else if (company?.['files']) setFiles(company['files']);
            }
        };
        fetchDirectorsAndFiles();
    }, [
        company?._id,
        company?.['directors'],
        company?.['files'],
        company?.['directorsCount'],
        company?.['filesCount']
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            const sectionPositions = sectionRefs.current.map((ref)=>{
                const id = ref?.id?.split('.')[0];
                const element = document.getElementById(id);
                const rect = element ? element.getBoundingClientRect() : {
                    top: 0
                };
                return {
                    id: id,
                    top: rect.top
                };
            });
            const currentSection = sectionPositions.find((position)=>position?.['top'] >= 0 && position.top < window.innerHeight);
            if (currentSection) setVisibleSection(currentSection.id);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (user && (Object.keys(user).length == 0 || !user['stripeMethods'])) getUser();
        if (user && user['role'] !== 'Guest') getAdvisors();
        if (!initialized.current) {
            initialized.current = true;
            if (location.pathname.includes('gDriveCallBack')) connectGDrive();
            else if (location.pathname.includes('dropBoxCallBack')) connectDropBox();
            else if (location.pathname.includes('sharePointCallBack')) connectSharePoint();
            else {
                let tabName = $6dc8626146af9081$var$decodeTabValue(window.location.hash.replace('#', ''));
                getCompany($6dc8626146af9081$var$TOP_NAV_TABS.includes(tabName) ? '' : tabName, selectedCompany);
                document.querySelectorAll(".sectionWrapper").forEach((el)=>observer.observe(el));
            }
        }
        let isWorkflowTab = localStorage.getItem('isWorkflowTab');
        if (isWorkflowTab) setCompanyDashboardTab('Workflows');
        let isResearchAid = localStorage.getItem('isResearchAid');
        if (isResearchAid) setCompanyDashboardTab('ResearchAid');
        let isAnylistTab = localStorage.getItem('isAnylistTab');
        let isDemoChecklist = localStorage.getItem('isDemoChecklist');
        let isPartnerChecklist = localStorage.getItem('isPartnerChecklist');
        if (isAnylistTab || isDemoChecklist || isPartnerChecklist) setCompanyDashboardTab('AnyLists');
    }, []);
    const hasTriggeredRef = (0, $acw62.useRef)(false); // this ensures one-time trigger
    (0, $acw62.useEffect)(()=>{
        async function fetchData() {
            const stageProgress = selectedCompany['stageProgress'];
            const companyId = company._id;
            if (Object.keys(selectedCompany).length && stageProgress === 'updated' && !hasTriggeredRef.current) {
                hasTriggeredRef.current = true; // prevent future calls
                setShowAlert(true);
                dispatch((0, $12074930bd2c1829$export$4bdbd1eea6fc9500)(true));
                const tab = 'repository';
                // Use lazy-loaded files state instead of company['files']
                let relPaths = [];
                let fileInfo = [];
                for(let i = 0; i < files.length; i++){
                    relPaths[i] = '';
                    fileInfo[i] = files[i];
                }
                const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/matchFiles`, {
                    files: files,
                    companyId: companyId,
                    tab: tab,
                    relPaths: relPaths
                }, true, "noAnimation");
                if (!res?.body?.['report']) return;
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                dispatch((0, $12074930bd2c1829$export$9291658802bc1f31)(res.body['report']));
                setCloneImportResult(JSON?.parse(JSON?.stringify(res.body?.['report']?.['importResult'])));
                const allocated = Object.keys(res.body['report']['importResult']).filter((key)=>res.body['report']['importResult'][key]['section'].some((element)=>!element.includes("DXXX") && !element.includes("SXXX"))).length;
                const total = Object.keys(res.body['report']['importResult']).length;
                const score = total === 0 ? 0 : Math.round(allocated / total * 100);
                (0, $12074930bd2c1829$export$fb8d60304f3762b3)(score);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'tempImportSummary',
                    from: ''
                }));
                dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
                    fileReport: res.body['report'],
                    company: company,
                    tab: tab,
                    underProcessingTab: tab,
                    currentScore: score,
                    reportHistories: reportHistories,
                    profileClass: profileClass
                }));
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                    ...selectedCompany,
                    stageProgress: 'pending'
                }));
                dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
                    syncing: true,
                    message: "Folders are currently creating"
                }));
                setShowAlert(false);
                const syncBody = {
                    newUpgradeSync: true,
                    tab: tab
                };
                if (selectedCompany['foldersPopulated']) {
                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/syncGDriveDataroom/${companyId}`, syncBody, true);
                    if (tab) reloadModule(tab ?? location.hash, false, false, true, "2");
                    if (!res) return;
                } else if (selectedCompany['dropBoxFoldersPopulated']) {
                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/syncDropBoxDataroom/${companyId}`, syncBody, true);
                    if (tab) reloadModule(tab ?? location.hash, false, false, true, "3");
                    if (!res) return;
                } else if (selectedCompany['sharePointFoldersPopulated']) {
                    const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/syncSharePointDataroom/${companyId}`, syncBody, true);
                    if (tab) reloadModule(tab ?? location.hash, false, false, true, "4");
                    if (!res) return;
                }
                dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
                    syncing: false,
                    message: null
                }));
            }
        }
        fetchData();
    }, [
        selectedCompany
    ]);
    (0, $acw62.useEffect)(()=>{
        let isWorkflowTab = localStorage.getItem('isWorkflowTab');
        if (isWorkflowTab) localStorage.removeItem('isWorkflowTab');
        let isResearchAid = localStorage.getItem('isResearchAid');
        if (isResearchAid) localStorage.removeItem('isResearchAid');
        localStorage.removeItem('isAnylistTab');
        setInvestorFirmCounts({
            gold: 0,
            silver: 0,
            bronze: 0,
            threshold: 0
        });
    }, [
        tab,
        companyDashboardTab,
        dashboardTab
    ]);
    (0, $acw62.useEffect)(()=>{
        if (user?.['type'] == 'Superflow' && user?.['partnerId']) getPartner(user?.['partnerId']);
        if (user) setProfileClass(user['role'] == 'Advisor' ? 'advisor-profile' : user['role'] == 'Investor' ? 'investor-profile br100' : 'client-profile');
    }, [
        user
    ]);
    const getPartner = async (id)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/${id}`);
        if (res['code'] == 200) dispatch((0, $3d3d7a2ee763f32a$export$6af6109222273956)(res['body']));
    };
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('aireport:generated', async (data)=>{
            if (data['moduleType']) setModuleAI(data['moduleType']);
            if (data['userId'] == user['_id']) {
                // setTab(tab, true); // Get updated AI Report from Server
                setAiEnchaned(true);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(data['message']);
                if (!tab.match(/two-minute-test-.*-report/)) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'completeAIReport'
                }));
            }
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('Sync', async (data)=>{
            dispatch((0, $22a1fae7337b63c9$export$96f23038668b4320)({
                syncing: false,
                message: null
            }));
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(data['message']);
        });
    }, [
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)
    ]);
    // TODO: Check if the data exists
    (0, $acw62.useEffect)(()=>{
        location.hash = tab;
        window.scroll(0, 450);
        if (tab.endsWith("-report")) setIsPrePopulate(false);
        if (tab == 'checklist-tasks' && checklistTask.length == 0) getChecklistTask(tab);
        if (tab == 'company-audit-log' && Object.values(auditReportLogs).length == 0) getChangeReports(tab);
        if (tab == 'diligence-pack-reporting' && Object.values(selectedModules).length == 0) getCompanyByModules(tab);
        if (tab && tab.includes('two-minute-test') && user?.['role'] == 'Guest' && !user.firstName) return setIsTwoMinuteTesHomePage(true);
        else setIsTwoMinuteTesHomePage(false);
        if (tab && tab.includes('directors-questionnaire')) Array.from(openTabs).map(async (openTab)=>{
            if (openTab.includes('directors-questionnaire')) {
                await openTabs.delete(openTab);
                setOpenTabs(new Set(Array.from(openTabs)));
            // if (tab === openTab) await setTab("");
            }
        });
        if (tab && tab !== 'fit-report') setOpenTabs((prev)=>new Set([
                ...prev,
                $6dc8626146af9081$var$decodeTabValue(tab)
            ]));
        if (tab == '' && window.location.pathname.includes('company')) {
            const hasToken = new URLSearchParams(location?.search).get('token');
            if (user['role'] != 'Guest' && !hasToken) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            setCompanyIndex(true);
        } else setCompanyIndex(false);
        let isWorkflowOpen = localStorage.getItem('isWorkflowOpen');
        let isAnylistBuilder = localStorage.getItem('isAnylistBuilder');
        let isDiligencePack = localStorage.getItem('isDiligencePack');
        let isDemoChecklist = localStorage.getItem('isDemoChecklist');
        let isPartnerChecklist = localStorage.getItem('isPartnerChecklist');
        if (isAnylistBuilder || isDemoChecklist || isPartnerChecklist || isDiligencePack) {
            setCompanyIndex(true);
            if (user['role'] == 'Investor' && (tab == 'diligence-pack' || tab.includes('fit-report'))) setIsClientIndex(false);
        }
        if (isWorkflowOpen) setTimeout(()=>{
            setIsWorkflowReport(true);
            localStorage.removeItem('isWorkflowOpen');
        }, 100);
    }, [
        tab
    ]);
    (0, $acw62.useEffect)(()=>{
        if (user['role'] == 'Advisor' && company['advisors'] && company['advisors']?.[user['_id']] && company['advisors']?.[user['_id']]?.['type']) {
            permissionLevel = company['advisors']?.[user['_id']]?.['type'];
            setPermissionLevel(permissionLevel);
        }
        if (user['role'] == 'Investor' && company['investors'] && company['investors']?.[user['_id']] && company['investors']?.[user['_id']]?.['type']) {
            permissionLevel = company['investors']?.[user['_id']]?.['type'];
            setPermissionLevel(permissionLevel);
        }
        if (company?.['cLevel'] == 'Bronze') setLinearProgress(50);
        else if (company?.['cLevel'] == 'Silver') setLinearProgress(75);
        else if (company?.['cLevel'] == 'Gold') setLinearProgress(100);
        else setLinearProgress(25);
        // Investor Matches for the Superflow popup are fetched in the background from QuestionAnswersPage as soon as
        // sections DEPF008.1 & DEPF008.2 are completed (that component has the real-time per-section answer data),
        // so by the time the user clicks Next the matches are already loaded and the popup opens instantly.
        if (user?.['role'] == 'Advisor' || user?.['role'] == 'Investor') {
            if (user?.['companyId']?.['_id'] == company?.['_id']) setIsShowTeamTab(false);
            else setIsShowTeamTab(true);
        }
    }, [
        company
    ]);
    const handleSuperFlowPopup = async ()=>{
        if (partner?.['name'] == 'Climb26 Super Flow' || partner?.['name'] == 'EHE Super Flow') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'applyInvestorMatchPopup'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'superFlowPopup'
        }));
    };
    const handleActivateClientLogin = async (companyId)=>{
        try {
            setActivatingClient(companyId);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/activateClientLogin/${companyId}`, {});
            if (response?.['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Client login activated successfully');
                getCompany();
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Failed to activate client login');
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while activating client login');
        } finally{
            setActivatingClient(null);
        }
    };
    const getCompany = async (tabName, _company)=>{
        let reset = false;
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        if (tabName && tabName.includes('%20')) {
            tabName = tabName.replaceAll('%20', ' ');
            reset = true;
        }
        let moduleName = tabName ? $6dc8626146af9081$export$57c43fe781091dc0(tabName) : window.location.href.includes("#") ? window.location.hash.substring(1) : undefined;
        setIsLoader({
            show: true,
            message: 'Loading...'
        });
        // Lightweight API — returns company metadata only (no modules/sections/questions/answers).
        // Modules are preserved from existing Redux state and loaded lazily via setTab / temp-modules.
        const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/company-light/${companyId}`);
        if (selectedCompany['stageProgress'] === 'updated') res['body']['stageProgress'] = 'updated';
        setIsLoader({
            show: false,
            message: 'Loading...'
        });
        if (res['code'] == 200) {
            !res['body']['firstVisitRepository'] && moduleName && moduleName.toLowerCase() === "repository" && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'firstSetupDataRepository'
            }));
            // Preserve whatever modules are already in Redux — light API does not return full modules.
            // Merge checklistModules from company-light (metadata + cached stats, no questions).
            const existingModules = _company?.['modules'] || selectedCompany?.['modules'] || {};
            const modules = {
                ...res['body']?.['checklistModules'] || {},
                ...existingModules
            };
            if (!modules['kpi']) modules['kpi'] = {
                type: 'kpi',
                sections: []
            };
            modules['unaudited-certification'] = moduleContent['unaudited-certification'];
            const resultArray = Object.entries(modules).filter(([, value])=>value?.stats?.completionScore > 0).map(([key])=>key);
            setUserModules(resultArray);
            await dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...res['body'],
                modules: modules,
                from: 434
            }));
            if (moduleName && moduleName.toLowerCase() === "repository" && !res?.['body']?.['stats']?.['completionScore'] && res['body']['subscription'] != 'Free') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'dataRepository'
            }));
            setCompanyId(companyId);
            localStorage.setItem('companyId', companyId);
            if (tabName) setTab(tabName, reset);
        }
    };
    const getCompanyByModules = async (tabName)=>{
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        let moduleName = tabName && $6dc8626146af9081$export$57c43fe781091dc0(tabName);
        if (Object.values(selectedModules).length == 0) {
            let res = '';
            setIsLoader({
                show: true,
                message: 'Loading...'
            });
            if (userModules && (Object.keys(moduleContent).includes(userModules) || userModules.includes('directors-questionnaire'))) res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}?moduleName=${moduleName}`);
            else res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/allReports/${companyId}`);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
            if (res['code'] == 200) {
                for (let module of Object.values(res['body'])){
                    let content = module['type'].includes('directors-questionnaire') ? moduleContent['directors-questionnaire'] : moduleContent[module['type']];
                    if (content) {
                        module['heading'] = module['director'] ? `${content['heading']} - ${module['director']['name']} (${module['director']['designation']})` : content['heading'];
                        module['aiEnhanced'] = content['aiEnhanced'];
                        module['subheading'] = content['subHeading'];
                        module['uploadFiles'] = content['uploadFiles'];
                    }
                }
                await setSelectedModules(res['body']);
                await setCompanyId(companyId);
                localStorage.setItem('companyId', companyId);
            }
        }
        setTabName(tabName);
    };
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        if (response && response['code'] == 200) {
            let user = response?.['body']?.['user'];
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
        }
    };
    const getAdvisors = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/getAdvisor`);
        if (response['code'] == 200 && response['body']) {
            setAdvisors(response['body']['advisors']);
            setInvestors(response['body']['investors']);
        }
    };
    const getFitInvestorFirms = async (isNavigate)=>{
        let clientId = location.pathname.split('/')[2];
        if (!clientId) clientId = company['_id'];
        if (clientId) {
            let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getFitInvestorFirms/${clientId}`);
            if (response['code'] == 200 && response['body']) {
                if (response['message'] && user['type'] != 'Superflow' && isNavigate) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                if (Array.isArray(response['body'])) {
                    setFitInvestorFirms(response['body']);
                    const disqualifiedFirms = response['body'].reduce((acc, firm)=>{
                        if (firm['requiredLevel']) acc[firm['requiredLevel'].toLowerCase()] += 1;
                        return acc;
                    }, {
                        gold: 0,
                        silver: 0,
                        bronze: 0,
                        threshold: 0
                    });
                    setInvestorFirmCounts(disqualifiedFirms);
                }
                if (user['type'] != 'Superflow' && isNavigate) setCompanyDashboardTab('InvestorMatch');
            }
        }
    };
    const getChangeReports = async (tabName)=>{
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        if (Object.values(auditReportLogs).length == 0) {
            setIsLoader({
                show: true,
                message: 'Loading...'
            });
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/log/changeReports/${companyId}`);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
            if (res['code'] == 200) {
                await setAuditReportLogs(res['body']);
                await setCompanyId(companyId);
                localStorage.setItem('companyId', companyId);
            }
        }
        setTabName(tabName);
    };
    const getChecklistTask = async (tabName)=>{
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        if (companyId.toLowerCase().includes('callback')) return;
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/task/get/${companyId}`);
        if (res['code'] == 200) {
            await setChecklistTask(res['body']);
            await setCompanyId(companyId);
            localStorage.setItem('companyId', companyId);
        }
        setTabName(tabName);
    };
    const downloadPDF = async ()=>{
        try {
            setIsLeadPdf(true);
            const wrapper = document.getElementById("leadsPDF");
            wrapper.classList.remove("db");
            wrapper.classList.remove("h60vh");
            wrapper.classList.remove("oa");
            // const filename = 'Curated Investor Leads';
            const filename = [
                `DG-InvestorLeads-${company['cName'].substring(0, 7)}-${(0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(Date.now()).format("ll")}`
            ].join(" - ");
            const opt = {
                filename: filename,
                jsPDF: {
                    unit: 'mm',
                    format: 'a2',
                    orientation: 'p'
                }
            };
            await (0, (/*@__PURE__*/$parcel$interopDefault($8994635913a5668f$exports)))().set(opt).from(wrapper).save();
            wrapper.classList.add("db");
            wrapper.classList.add("h60vh");
            wrapper.classList.add("oa");
            setTimeout(()=>setIsLeadPdf(false), 1000);
        } catch (e) {
            console.error(e);
        }
    };
    const setTab = async (tabName, reset, isAfterSync, firstVisitRepository, companyNotFetch, check)=>{
        if (tabName == "diligence-pack-reporting") return getCompanyByModules(tabName);
        if (tabName == "company-audit-log") return getChangeReports(tabName);
        if (tabName == "checklist-tasks") return getChecklistTask(tabName);
        let moduleName = tabName && $6dc8626146af9081$export$57c43fe781091dc0(tabName);
        dispatch((0, $12074930bd2c1829$export$7372fe6818c27bf4)({
            tab: moduleName
        }));
        const companyId = props && props?.isCallback ? props.companyId : location.pathname.split("/").slice(-1)[0];
        let finalUpdatedData = {};
        if (reset || tabName && selectedCompany['modules']?.[moduleName]?.['sections'].length > 0 && !selectedCompany['modules']?.[moduleName]?.['sections'][0]['questions']) {
            setIsLoader({
                show: true,
                message: 'Loading...'
            });
            let obj = {
                companyId: companyId,
                moduleName: moduleName
            };
            const activeModule = selectedCompany?.modules?.[moduleName];
            const isTempModulePage = !!(activeModule?.isTempModule || activeModule?._id);
            const endpoint = `/modules/temp-modules/get-module`;
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(endpoint, obj);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
            if (response['code'] != 200) return;
            // Read latest from store after await to avoid stale closure (company/selectedCompany may have been {} when setTab was called)
            const { selectedCompany: latestSelectedCompany } = store.getState().company;
            const latestCompany = {
                ...latestSelectedCompany
            };
            !latestSelectedCompany['firstVisitRepository'] && moduleName && moduleName.toLowerCase() === "repository" && dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'firstSetupDataRepository'
            }));
            if (response && response?.body?.[moduleName]) {
                finalUpdatedData = {
                    ...latestSelectedCompany,
                    ...latestCompany,
                    modules: {
                        ...latestSelectedCompany['modules'],
                        [moduleName]: {
                            ...latestSelectedCompany['modules']?.[moduleName],
                            ...response['body'][moduleName],
                            ...latestSelectedCompany['modules']?.[moduleName]['questions'] ? {
                                questions: latestSelectedCompany['modules']?.[moduleName]['questions']
                            } : {},
                            ...moduleName === "repository" && {
                                uploadFiles: true
                            }
                        }
                    },
                    from: "543"
                };
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(finalUpdatedData));
            }
            let data = {};
            if (isAfterSync == true) {
                const dataList = [
                    'lastSyncBy',
                    'lastSyned',
                    'unallocatedFiles'
                ];
                response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getData`, {
                    companyId: companyId,
                    dataList: dataList
                });
                if (response && response['code'] === 200) {
                    for (const dataItem of dataList)if (dataItem in response['body'] && response['body'][dataItem] !== undefined) data = {
                        ...data,
                        [dataItem]: response['body'][dataItem]
                    };
                }
                if (!companyNotFetch) getCompany(tabName, latestSelectedCompany);
            }
            if (tabName && tabName !== "investor-lead") finalUpdatedData = calculateStats(finalUpdatedData, tabName);
            dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...latestSelectedCompany,
                ...finalUpdatedData,
                ...data,
                syncRequired: false,
                from: "576"
            }));
        }
        if (tabName) {
            setCompanyDashboardTab('Dashboard');
            setTabName(tabName);
        }
        if (moduleName == 'investor-lead') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const reloadModule = (resetTab, isAfterSync, hideFisrtTime = false, companyNotFetch, check)=>setTimeout(()=>setTab(resetTab, true, isAfterSync, hideFisrtTime, companyNotFetch, check), 1000);
    const handleCloseReportToRepository = (0, $acw62.useCallback)((anchorOverride)=>{
        const anchor = anchorOverride || lastReportAnchorRef.current || (()=>{
            try {
                return localStorage.getItem('lastReportAnchor');
            } catch (_) {
                return null;
            }
        })();
        setTab('repository');
        setTabName('repository');
        window.location.hash = '#repository';
        setOpenTabs((prev)=>{
            const next = new Set(prev);
            next.add('repository');
            return next;
        });
        setTimeout(()=>{
            const targetId = anchor || (()=>{
                try {
                    return localStorage.getItem('lastReportAnchor');
                } catch (_) {
                    return null;
                }
            })();
            if (targetId) {
                const el = document.getElementById(targetId);
                if (el && el.scrollIntoView) el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }, 500);
    }, [
        setTab,
        setTabName,
        setOpenTabs
    ]);
    (0, $acw62.useEffect)(()=>{
        let moduleName = tab && $6dc8626146af9081$export$57c43fe781091dc0(tab);
        if (moduleName == 'repository' && Object.keys(selectedCompany).length && !selectedCompany['firstVisitRepository']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'firstSetupDataRepository'
        }));
    }, [
        selectedCompany
    ]);
    const moveToCompanyPage = ()=>{
        let { state: state } = urlSearchData(location['search']);
        let [companyId, verifier] = parseState(state);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        window.location.href = `/company/${companyId}#repository`;
    };
    const connectGDrive = ()=>{
        let { code: code, state: companyId } = urlSearchData(location['search']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectingDataRoom'
        }));
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectGDrive`, {
            code: code,
            companyId: companyId
        }).then((response)=>{
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'createdDataRoom'
                }));
                setTimeout(()=>moveToCompanyPage(), 1000);
            } else setTimeout(()=>moveToCompanyPage(), 1000);
        }).catch((e)=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create Google Drive folders'));
    };
    const connectDropBox = async ()=>{
        let { code: code, state: companyId } = urlSearchData(location['search']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectingDataRoom'
        }));
        (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectDropBox`, {
            code: code,
            companyId: companyId
        }).then((response)=>{
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'createdDataRoom'
                }));
                setTimeout(()=>moveToCompanyPage(), 1000);
            } else // showMessage(response['message']);
            setTimeout(()=>moveToCompanyPage(), 1000);
        }).catch((error)=>{
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create Dropbox folders');
        });
    };
    const connectSharePoint = async ()=>{
        let { code: code, state: state, client_info: client_info } = urlSearchData(location['search']);
        const [companyId, verifier] = parseState(state);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'connectingDataRoom'
        }));
        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/modules/connectSharePoint`, {
            code: code,
            companyId: companyId,
            client_info: client_info,
            verifier: verifier
        }, true, false, true).then(async (response)=>{
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'createdDataRoom'
                }));
                setTimeout(()=>moveToCompanyPage(), 1000);
            }
            if (response?.message.includes("only supports Company")) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'notSupportPersonalAccount'
            }));
        }).catch((error)=>{
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Failed to create SharePoint folders');
        });
    };
    const urlSearchData = (searchString)=>{
        if (!searchString) return {};
        return searchString.substring(1).split('&').reduce((result, next)=>{
            let pair = next.split('=');
            result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            return result;
        }, {});
    };
    const parseState = (state)=>{
        if (state.length > 25) {
            const decode = (0, (/*@__PURE__*/$parcel$interopDefault($6u4NZ))).decode(state);
            return decode.split("==");
        }
        return [
            state,
            ""
        ];
    };
    const handleMemberEdit = (user)=>{
        user['permissions'] = company['memberPermissions'][user['_id']];
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'editUser'
        }));
        setEditUser(user);
        setUserAction('Edit');
    };
    const resendInviteMember = async (memberId)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/resendInvite', {
            companyId: companyId,
            memberId: memberId
        });
        if (!res || res['code'] != 200) return;
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const handleDeleteMember = (userId)=>{
        setDeleteMemberId(userId);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'deleteMember'
        }));
    };
    const submitDeleteMember = async ()=>{
        if (deleteMemberId !== '') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/deleteMember', {
                companyId: companyId,
                userId: deleteMemberId
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            if (!res || res['code'] != 200) return;
            getCompany();
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    const openKPI = async ()=>{
        try {
            // OPTIMIZATION: Use kpiCount instead of keyPerformanceIndicators array (excluded in lightweight mode)
            const hasKPIs = company['kpiCount'] !== undefined ? company['kpiCount'] > 0 : company['keyPerformanceIndicators'] && Object.values(company['keyPerformanceIndicators']).length > 0;
            if (!hasKPIs) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('We are generating your KPI report, please wait!');
                let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/generateKPI/${companyId}`);
                if (res['code'] == 200) await getCompany();
            }
            await setIsViewTwoMinuteReport(true);
            setTab("kpi-report");
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/generateAIReport/${company['_id']}`, {
                module: `two-minute-test-${company?.['testType']}`
            });
        } catch (e) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Unable to generate KPI');
        }
    };
    const linksToCloseTab = ()=>{
        if ((user?.['role'] == 'Investor' || user?.['role'] == 'Advisor') && company?.['_id'] != user?.['companyId']?.['_id'] && tab == 'diligence-pack') return `/investor-dashboard`;
        else if ((window.location.href.includes('fit-report') || tab.includes('fit-report')) && user['role'] == 'Investor') return `/company/${companyId}#diligence-pack`;
        else return window.location.pathname;
    };
    const closeTab = (e, openTab)=>{
        if ((user?.['role'] == 'Investor' || user?.['role'] == 'Advisor') && company?.['_id'] != user?.['companyId']?.['_id'] && tab == 'diligence-pack') return navigate(`/investor-dashboard`);
        if ((window.location.href.includes('fit-report') || tab.includes('fit-report')) && user['role'] == 'Investor') {
            navigate(`/company/${companyId}#diligence-pack`);
            setTab('diligence-pack');
            return;
        }
        localStorage.removeItem('isDiligenceReport');
        if (e?.stopPropagation) e.stopPropagation();
        openTabs.delete(openTab);
        setOpenTabs(new Set(Array.from(openTabs)));
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setAiEnchaned(false);
        if (tab === openTab) setTabName('');
    };
    const setCertificateSeeMore = async ()=>{
        let seeMore = {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "51",
                height: "65",
                viewBox: "0 0 51 65",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M47.0127 19.2576C46.1594 18.4418 45.2769 17.5983 44.9976 16.9214C44.6908 16.1778 44.716 14.9085 44.7405 13.6812C44.7839 11.5015 44.8331 9.03118 43.1542 7.3442C41.4723 5.65418 38.9981 5.69252 36.817 5.72756C35.592 5.74673 34.3245 5.76692 33.584 5.45829C32.9072 5.1762 32.0659 4.29285 31.2523 3.4387C29.7169 1.82688 27.977 0 25.498 0C23.0189 0 21.279 1.82688 19.7438 3.43857C18.9302 4.29285 18.0889 5.1762 17.4121 5.45816C16.6717 5.76679 15.4042 5.74673 14.1792 5.72731C11.9962 5.69392 9.52378 5.65406 7.84202 7.34395C6.16291 9.03092 6.21217 11.5013 6.25559 13.681C6.27996 14.9085 6.30536 16.1778 5.99863 16.9212C5.7192 17.5982 4.83674 18.4418 3.98335 19.2575C2.37623 20.7939 0.554688 22.5351 0.554688 25.011C0.554688 27.4868 2.37623 29.2282 3.98335 30.7643C4.83674 31.5801 5.7192 32.4236 5.99851 33.1005C6.30536 33.8441 6.28009 35.1134 6.25559 36.3409C6.21217 38.5205 6.16304 40.9908 7.84189 42.6779C8.90031 43.7414 10.2723 44.1202 11.6877 44.2464V63.0965C11.6877 63.7357 12.0084 64.3322 12.5416 64.6848C13.0746 65.0375 13.7493 65.0991 14.3374 64.849L25.498 60.1023L36.6587 64.849C36.8979 64.9507 37.1513 65.0008 37.4038 65.0008C37.772 65.0008 38.1381 64.8941 38.4544 64.6848C38.9874 64.3323 39.3083 63.7357 39.3083 63.0965V44.2469C40.7237 44.1207 42.0955 43.7417 43.154 42.6784C44.8331 40.9914 44.7838 38.5209 44.7404 36.3413C44.716 35.1138 44.6906 33.8445 44.9973 33.1012C45.2768 32.4241 46.1592 31.5805 47.0126 30.7648C48.6197 29.2284 50.4413 27.4872 50.4413 25.0114C50.4413 22.5355 48.6199 20.794 47.0127 19.2576ZM26.2432 56.2806C25.7671 56.0779 25.2288 56.0779 24.7528 56.2806L15.4964 60.2173V44.2896C16.251 44.3044 16.9392 44.3671 17.4121 44.564C18.0889 44.8461 18.9302 45.7295 19.7438 46.5836C21.279 48.1954 23.0189 50.0223 25.498 50.0223C27.977 50.0223 29.7169 48.1954 31.2521 46.5838C32.0657 45.7295 32.9071 44.8461 33.5839 44.5642C34.0569 44.367 34.745 44.3042 35.4996 44.2893V60.2172L26.2432 56.2806ZM44.3809 28.0117C43.2414 29.1008 42.0633 30.227 41.4768 31.6483C40.8669 33.1262 40.9003 34.7992 40.9325 36.4172C40.9608 37.839 40.9929 39.4507 40.4544 39.9916C39.914 40.5345 38.3005 40.5095 36.8767 40.4868C35.2616 40.4616 33.5914 40.4352 32.1189 41.0485C30.702 41.6389 29.5796 42.8174 28.494 43.9571C27.4865 45.0148 26.3447 46.2137 25.4977 46.2137C24.6508 46.2137 23.509 45.0147 22.5013 43.9569C21.4159 42.8173 20.2935 41.6389 18.8765 41.0484C17.6995 40.5581 16.3964 40.4765 15.0958 40.4765C14.7694 40.4765 14.4429 40.4817 14.1189 40.4868C12.695 40.509 11.0815 40.5346 10.5411 39.9916C10.0028 39.4505 10.0349 37.8391 10.0631 36.4172C10.0953 34.7992 10.1287 33.126 9.51871 31.648C8.9323 30.227 7.75416 29.1008 6.61474 28.0115C5.55924 27.0026 4.36295 25.859 4.36295 25.0112C4.36295 24.1634 5.55924 23.0197 6.61474 22.0108C7.75416 20.9216 8.9323 19.7954 9.51883 18.3742C10.1287 16.8963 10.0953 15.2233 10.0631 13.6052C10.0348 12.1833 10.0027 10.5716 10.5412 10.0307C11.0816 9.48783 12.6959 9.51297 14.1188 9.5357C15.7348 9.56083 17.4044 9.58737 18.8768 8.97379C20.2936 8.38358 21.416 7.20506 22.5015 6.06539C23.5091 5.00748 24.6511 3.80864 25.498 3.80864C26.3449 3.80864 27.4869 5.00748 28.4944 6.06526C29.5798 7.20506 30.7022 8.38346 32.1191 8.97367C33.5916 9.58724 35.2614 9.56045 36.8771 9.53557C38.3009 9.51335 39.9143 9.48796 40.4548 10.0307C40.9931 10.5716 40.9609 12.1832 40.9328 13.6051C40.9005 15.223 40.8671 16.8962 41.4771 18.3742C42.0635 19.7952 43.2417 20.9214 44.3811 22.0106C45.4366 23.0196 46.6329 24.1633 46.6329 25.0111C46.6329 25.8589 45.4365 27.0026 44.3809 28.0117Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M25.4974 11.1484C17.9579 11.1484 11.8242 17.2991 11.8242 24.8594C11.8242 32.4197 17.9579 38.5705 25.4974 38.5705C33.0368 38.5705 39.1705 32.4198 39.1705 24.8595C39.1705 17.2993 33.0368 11.1484 25.4974 11.1484ZM25.4974 34.7619C20.058 34.7619 15.6329 30.3197 15.6329 24.8595C15.6329 19.3994 20.058 14.9572 25.4974 14.9572C30.9367 14.9572 35.3619 19.3994 35.3619 24.8595C35.3619 30.3197 30.9367 34.7619 25.4974 34.7619Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M27.733 21.2648L24.2814 24.7165L23.2665 23.7016C22.5229 22.958 21.3171 22.958 20.5734 23.7016C19.8297 24.4452 19.8297 25.651 20.5734 26.3947L22.9349 28.7562C23.292 29.1133 23.7763 29.314 24.2814 29.314C24.7864 29.314 25.2709 29.1134 25.6279 28.7562L30.426 23.9579C31.1697 23.2142 31.1697 22.0085 30.426 21.2648C29.6824 20.5211 28.4766 20.5211 27.733 21.2648Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Diligentsia ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Certification"
                ]
            }),
            points: [
                'Complete modules',
                'Completeness and risk scoring',
                'Unaudited certification:',
                "Gold certification \u2013 opens up access to InvestorMatch",
                'Digital certification valid for 3 months',
                'Or, with Diligentsia Pro PLUS, have your lawyer or accountant assist and provide you an audited certificate'
            ],
            subMenu: {
                index: 2,
                points: [
                    "- Bronze \u2013 basic level reached",
                    "- Silver \u2013 potentially investible",
                    "- Gold \u2013 sophisticated"
                ]
            },
            image: (parcelRequire("9WBs6"))
        };
        await setSelectedSeeMore(seeMore);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'seeMorePopup'
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (modal.resetTab) {
            openTabs.delete('repository');
            if (!openTabs.has(tab)) setOpenTabs(new Set(Array.from(openTabs)));
            if (tab === 'repository') setTab('');
            dispatch((0, $ee5327cdf6cdce8c$export$c42821355a5f8135)(false));
        }
    }, [
        modal.resetTab
    ]);
    const toggleReport = async (e, reportType)=>{
        if (tab.endsWith("-report")) {
            closeTab(e, tab);
            if (tab === "kpi-report") {
                if (user['role'] == 'Guest') setTab("two-minute-test-" + company.testType);
                else setTab('');
            } else {
                if (tab == `business-audit-${company['testType']}`) enableAIEnhancedReporting();
                if (permissionLevel != 'DASHBOARD & REPORT') await setTab((reportType || tab).replace(/(-sync)?-report$/, ""));
            // navigate(`#${(reportType || tab).replace(/(-sync)?-report$/, "")}`);
            }
        } else {
            // navigate(`#${tab}-report`);
            if (tab == `business-audit-${company['testType']}`) enableAIEnhancedReporting();
            setTab(reportType || tab + "-report");
            scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        e.target.innerText = tab.endsWith("-report") ? e.target.innerText.replace("CLOSE", "VIEW") : e.target.innerText.replace("VIEW", "CLOSE");
    };
    const twoMinuteTestAIReport = async (module)=>{
        if (tab.includes('two-minute-test') && module['stats']['completionPercent'] < 100) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please complete the Test!');
        else enableAIEnhancedReporting();
    };
    const enableAIEnhancedReporting = async ()=>{
        if (aiEnhanced) {
            if (!tab.includes("report")) setTab(tab + "-report");
            if (user['role'] == 'Guest' || tab == 'kpi-report') setTab(`two-minute-test-${company?.['testType']}-report`);
            if (user['role'] == 'Guest' && tab.includes('two-minute-test')) setOpenTabs((prevTabs)=>{
                const updatedTabs = new Set(prevTabs);
                const tabName = `two-minute-test-${company?.['testType']}-report`;
                updatedTabs.add(tabName);
                return updatedTabs;
            });
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('AI Report Generated. Check AI Enhanced Recommendations.');
            return;
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatingAIReport'
        }));
        let module;
        if (user['role'] == 'Guest' || tab == 'kpi-report') module = `two-minute-test-${company?.['testType']}`;
        else module = tab.replace('-report', '');
    // const response = await postRequest(`/company/generateAIReport/${company['_id']}`, { module });
    // if (response['code'] == 400) dispatch(toggleModal({ open: '' }));
    };
    const calculateCertification = (company)=>{
        let auditType = 'business-audit-' + company['testType'];
        let points = {
            'Bronze': {},
            'Silver': {},
            'Gold': {}
        }, extraModules = {
            'Bronze': {},
            'Silver': {},
            'Gold': {}
        };
        let data = {
            'repository': {
                // completeness: 75,
                'completeness': company['modules']?.['repository']?.['stats']?.['completionPercent'] || 0
            },
            'business-audit': {
                'risk': company['modules']?.[auditType]?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules']?.[auditType]?.['stats']?.['completionPercent'] || 0
            },
            'warranty-disclosure': {
                'completeness': company['modules']?.['warranty-disclosure']?.['stats']?.['completionPercent'] || 0
            },
            'directors-questionnaire': {
                'risk': company?.['directorsStats']?.['riskPercent'] || 0,
                'completeness': company?.['directorsStats']?.['completionPercent'] || 0
            },
            'esg': {
                'risk': company['modules']?.['esg']?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules']?.['esg']?.['stats']?.['completionPercent'] || 0
            },
            'software-development': {
                'risk': company['modules']?.['software-development']?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules']?.['software-development']?.['stats']?.['completionPercent'] || 0
            },
            'two-minute-test': {
                'risk': company['modules'][`two-minute-test-${company['testType']}`]?.['stats']?.['riskPercent'] || 0,
                'completeness': company['modules'][`two-minute-test-${company['testType']}`]?.['stats']?.['completionPercent'] || 0
            }
        };
        for (let [moduleKey, object] of Object.entries(company['modules']))if (!data[moduleKey]) {
            data[moduleKey] = {
                completeness: object?.['stats']?.['completionPercent'] || 0,
                risk: object?.['stats']?.['riskPercent'] || 0
            };
            points['Bronze'][moduleKey] = data[moduleKey]['completeness'] >= 60 && data[moduleKey]['risk'] <= 60;
            points['Silver'][moduleKey] = data[moduleKey]['completeness'] >= 80 && data[moduleKey]['risk'] <= 40;
            points['Gold'][moduleKey] = data[moduleKey]['completeness'] == 100 && data[moduleKey]['risk'] <= 30;
            company['moduleCertification'] = {
                ...company['moduleCertification'],
                [moduleKey]: points['Gold'][moduleKey] ? 'Gold' : points['Silver'][moduleKey] ? 'Silver' : points['Bronze'][moduleKey] ? 'Bronze' : 'None'
            };
        }
        points['Bronze']['p1'] = data['repository']['completeness'] >= 75;
        points['Bronze']['p2'] = data['business-audit']['completeness'] >= 75 && data['business-audit']['risk'] <= 50;
        points['Bronze']['status'] = points['Bronze']['p1'] && points['Bronze']['p2'] ? 'complete-button' : points['Bronze']['p1'] || points['Bronze']['p2'] ? 'inprogrees-btn' : 'noy-yet-btn';
        points['Bronze']['active'] = points['Bronze']['status'] == 'complete-button';
        extraModules['Bronze']['p1'] = data['esg']['completeness'] >= 75 && data['esg']['risk'] <= 50;
        extraModules['Bronze']['p2'] = data['software-development']['completeness'] >= 75 && data['software-development']['risk'] <= 50;
        points['Silver']['p1'] = data['repository']['completeness'] >= 90;
        points['Silver']['p2'] = data['business-audit']['completeness'] >= 90 && data['business-audit']['risk'] <= 50;
        points['Silver']['p3'] = data['warranty-disclosure']['completeness'] >= 75;
        points['Silver']['p4'] = data['directors-questionnaire']['completeness'] >= 75 && data['directors-questionnaire']['risk'] <= 50;
        points['Silver']['status'] = points['Silver']['p1'] && points['Silver']['p2'] && points['Silver']['p3'] && points['Silver']['p4'] ? 'complete-button' : points['Silver']['p1'] || points['Silver']['p2'] || points['Silver']['p3'] || points['Silver']['p4'] ? 'inprogrees-btn' : 'noy-yet-btn';
        points['Silver']['active'] = points['Silver']['status'] == 'complete-button';
        extraModules['Silver']['p1'] = data['esg']['completeness'] >= 90 && data['esg']['risk'] <= 50;
        extraModules['Silver']['p2'] = data['software-development']['completeness'] >= 90 && data['software-development']['risk'] <= 50;
        points['Gold']['p1'] = data['repository']['completeness'] == 100;
        points['Gold']['p2'] = data['business-audit']['completeness'] == 100 && data['business-audit']['risk'] <= 25;
        points['Gold']['p3'] = data['warranty-disclosure']['completeness'] >= 90;
        points['Gold']['p4'] = data['directors-questionnaire']['completeness'] >= 90 && data['directors-questionnaire']['risk'] <= 50;
        points['Gold']['status'] = points['Gold']['p1'] && points['Gold']['p2'] && points['Gold']['p3'] && points['Gold']['p4'] ? 'complete-button' : points['Gold']['p1'] || points['Gold']['p2'] || points['Gold']['p3'] || points['Gold']['p4'] ? 'inprogrees-btn' : 'noy-yet-btn';
        points['Gold']['active'] = points['Gold']['status'] == 'complete-button';
        extraModules['Gold']['p1'] = data['esg']['completeness'] == 100 && data['esg']['risk'] <= 25;
        extraModules['Gold']['p2'] = data['software-development']['completeness'] == 100 && data['software-development']['risk'] <= 25;
        company['points'] = points;
        let cLevel = points['Bronze']['active'] && points['Silver']['active'] && points['Gold']['active'] ? 'Gold' : points['Bronze']['active'] && points['Silver']['active'] ? 'Silver' : points['Bronze']['active'] ? 'Bronze' : 'None';
        company['cLevel'] = cLevel;
        company['certificateNext'] = cLevel == 'Gold' ? 'All Done' : cLevel == 'Silver' ? 'Gold' : cLevel == 'Bronze' ? 'Silver' : cLevel == 'None' ? 'Bronze' : 'None';
        company['moduleCertification'] = {
            ...company['moduleCertification'],
            'repository': points['Gold']['p1'] ? 'Gold' : points['Silver']['p1'] ? 'Silver' : points['Bronze']['p1'] ? 'Bronze' : 'None',
            'business-audit': points['Gold']['p2'] ? 'Gold' : points['Silver']['p2'] ? 'Silver' : points['Bronze']['p2'] ? 'Bronze' : 'None',
            'warranty-disclosure': points['Gold']['p3'] ? 'Gold' : points['Silver']['p3'] ? 'Silver' : points['Bronze']['p3'] ? 'Bronze' : 'None',
            'directors-questionnaire': points['Gold']['p4'] ? 'Gold' : points['Silver']['p4'] ? 'Silver' : points['Bronze']['p4'] ? 'Bronze' : 'None',
            'esg': extraModules['Gold']['p1'] ? 'Gold' : extraModules['Silver']['p1'] ? 'Silver' : extraModules['Bronze']['p1'] ? 'Bronze' : 'None',
            'software-development': extraModules['Gold']['p2'] ? 'Gold' : extraModules['Silver']['p2'] ? 'Silver' : extraModules['Bronze']['p2'] ? 'Bronze' : 'None'
        };
        company['moduleCertification'][`two-minute-test-${company['testType']}`] = data['two-minute-test']['risk'] == 0 && data['two-minute-test']['completeness'] == 0 ? 'None' : data['two-minute-test']['risk'] <= 50 && data['two-minute-test']['completeness'] == 100 ? 'Pass' : 'Fail';
        let completePoints = 0, totalPoints = 0;
        let point = points[company['certificateNext']] || points[cLevel];
        if (point) Object.keys(point).forEach((key)=>{
            if (key.indexOf('p') >= 0) {
                totalPoints++;
                if (point[key]) completePoints++;
            }
        });
        company['certificateProgress'] = completePoints / totalPoints * 100;
        return company;
    };
    const calculateStats = (companyObject, moduleName, check)=>{
        if (Object.keys(companyObject).length == 0) return companyObject;
        companyObject = JSON.parse(JSON.stringify(companyObject));
        const wasRepositoryComplete = companyObject?.['modules']?.['repository']?.['stats']?.['completionPercent'] === 100;
        // for (const module of Object.values(companyObject.modules)) {
        let module = companyObject['modules'][$6dc8626146af9081$export$57c43fe781091dc0(moduleName ?? tab)];
        if (module) {
            if (module['stats']) module['stats'] = {
                minRiskScore: 0,
                maxRiskScore: 0,
                riskScore: 0,
                maxCompletionScore: 0,
                completionScore: 0,
                workflowCompletionScore: 0,
                workflowMaxScore: 0
            };
            if (module['sections']) {
                for (const section of Object.freeze(module['sections'])){
                    section['stats'] = {
                        minRiskScore: 0,
                        maxRiskScore: 0,
                        riskScore: 0,
                        maxCompletionScore: 0,
                        completionScore: 0,
                        workflowCompletionScore: 0,
                        workflowMaxScore: 0
                    };
                    // TODO: For Expension packs aggregate all questions from SubFolders
                    let questions = [];
                    if (module['expansionPack']) {
                        Object.values(section['subFolders']).forEach((subSection)=>questions = questions.concat(subSection['questions']));
                        questions = questions.filter((question)=>question !== undefined);
                    } else questions = section['questions'];
                    if (questions) for (const question of questions){
                        if (section["type"] === "Existing Sections" && question["type"] === "repository" && companyObject["subscription"] == "Pro" && question["qNo"].split(".").length == 1) continue;
                        else if (section["type"] === "Existing Sections" && question["type"] === "repository" && companyObject["subscription"] == "Lite" && question["qNo"].split(".").length > 1) continue;
                        if (!question['isSkipped']) {
                            let answer = question?.['answer'] || {};
                            if ([
                                "Completed",
                                "Not Applicable"
                            ].includes(answer?.['status'])) {
                                // if (["Completed", "Not Applicable"].includes(answer?.['status']) || module['type'] !== "repository" && answer?.['radioOption']) {
                                if (answer?.['radioOption'] && answer?.['radioOption'] !== 'NC') section['stats']['completionScore'] += question['completionScore'] || 1;
                                // Risk score calculation - skip N/A answers as they should not affect risk
                                if (answer?.['radioOption'] !== 'N/A') {
                                    if (question['questionType'] == 'D/ND') section['stats']['riskScore'] += answer?.['radioOption'] == 'Disclosure' ? question['riskIfD'] : answer?.['radioOption'] == 'No Disclosure' ? question['riskIfND'] : answer?.['radioOption'] == 'Not Sure' ? question['riskIfNS'] : 0;
                                    else section['stats']['riskScore'] += question["riskIf" + answer?.['radioOption']] || 0;
                                    const allRiskScores = Object.keys(question).filter((k)=>k.startsWith("riskIf")).map((k)=>question[k]);
                                    section['stats']['minRiskScore'] += Math.min(...allRiskScores);
                                    section['stats']['maxRiskScore'] += Math.max(...allRiskScores);
                                }
                                let workflowScores = {
                                    'Not Started': 0,
                                    'Started': 0.25,
                                    'In Progress': 0.50,
                                    'Completed - Further Work': 0.75,
                                    'Completed - No Issues': 1
                                };
                                if (answer['taskStatus'] && Object.keys(workflowScores).includes(answer['taskStatus'])) {
                                    section['stats']['workflowMaxScore'] += 1;
                                    section['stats']['workflowCompletionScore'] += workflowScores[answer['taskStatus']];
                                }
                            }
                            section['stats']['maxCompletionScore'] += question['completionScore'] || 1;
                        }
                    }
                    if (section['stats']['completionScore'] == 0 || section['stats']['maxRiskScore'] === section['stats']['minRiskScore']) section['stats']['riskPercent'] = 0;
                    else section['stats']['riskPercent'] = Math.round((section['stats']['riskScore'] - section['stats']['minRiskScore']) / (section['stats']['maxRiskScore'] - section['stats']['minRiskScore']) * 100);
                    section['stats']['completionPercent'] = Math.round(section['stats']['completionScore'] / section['stats']['maxCompletionScore'] * 100);
                    section['stats']['workflowCompletionPercent'] = Math.round(section['stats']['workflowCompletionScore'] / section['stats']['workflowMaxScore'] * 100);
                    if (section['subFolders']) calculateSubFolderStats(module, section['subFolders'], questions);
                }
                module['stats'] = module.sections.reduce((stats, section)=>{
                    for(const key in section['stats'])stats[key] = (stats[key] ?? 0) + section['stats'][key];
                    return stats;
                }, {
                    minRiskScore: 0,
                    maxRiskScore: 0,
                    riskScore: 0,
                    maxCompletionScore: 0,
                    completionScore: 0,
                    workflowCompletionScore: 0,
                    workflowMaxScore: 0
                });
                if (module['type'] == 'repository' && companyObject['subscription'] == 'Lite') module["stats"]["maxCompletionScore"] = 20;
                if (module['stats']['completionScore'] == 0 || module['stats']['maxRiskScore'] === module['stats']['minRiskScore']) module['stats']['riskPercent'] = 0;
                else module['stats']['riskPercent'] = Math.round((module['stats']['riskScore'] - module['stats']['minRiskScore']) / (module['stats']['maxRiskScore'] - module['stats']['minRiskScore']) * 100);
                if (module['stats']['completionScore']) module['stats']['completionPercent'] = Math.round(module['stats']['completionScore'] / module['stats']['maxCompletionScore'] * 100);
                module['stats']['workflowCompletionPercent'] = Math.round(module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore'] * 100);
            }
            companyObject['stats'] = Object.values(companyObject.modules).reduce((stats, module)=>{
                if (module?.['stats']?.['completionScore'] > 0) for(const key in module['stats'])stats[key] = (stats[key] ?? 0) + module['stats'][key];
                return stats;
            }, {
                minRiskScore: 0,
                maxRiskScore: 0,
                riskScore: 0,
                maxCompletionScore: 0,
                completionScore: 0,
                workflowCompletionScore: 0,
                workflowMaxScore: 0
            });
            if (companyObject['stats']['completionScore'] == 0) companyObject['stats']['riskPercent'] = 0;
            else companyObject['stats']['riskPercent'] = Math.round((companyObject['stats']['riskScore'] - companyObject['stats']['minRiskScore']) / (companyObject['stats'].maxRiskScore - companyObject['stats']['minRiskScore']) * 100);
            companyObject['stats']['completionPercent'] = Math.round(companyObject['stats']['completionScore'] / companyObject['stats'].maxCompletionScore * 100);
            companyObject['stats']['workflowCompletionPercent'] = Math.round(module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore'] * 100);
            if (!wasRepositoryComplete && companyObject?.modules?.repository?.['stats']?.['completionPercent'] == 100) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'respositoryCompleted'
            }));
            if (tab == `two-minute-test-${company['testType']}` && companyObject?.['modules']?.[tab]?.['stats']?.['completionPercent'] == 100) {
                if (!moduleName) reloadModule(`two-minute-test-${company['testType']}`, true, null, null, "1");
                if (!tab.endsWith("-report") && user['role'] == 'Guest') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'twoMinuteTestCompleted'
                }));
            }
            calculateCertification(companyObject);
            companyObject = calculateDirectorStats(companyObject);
        }
        return companyObject;
    };
    const calculateDirectorStats = (companyObj)=>{
        let directorsCount = 0;
        if (companyObj['directorsStats']) {
            companyObj['directorsStats']['riskPercent'] = 0;
            companyObj['directorsStats']['completionPercent'] = 0;
        }
        for (let module of Object.values(companyObj['modules']))if (module['type'] && module['type'].includes('directors-questionnaire')) {
            if (!companyObj['directorsStats']) companyObj['directorsStats'] = {
                riskPercent: module['stats']['riskPercent'],
                completionPercent: module['stats']['completionPercent']
            };
            else {
                companyObj['directorsStats']['riskPercent'] += module['stats']['riskPercent'];
                companyObj['directorsStats']['completionPercent'] += module['stats']['completionPercent'];
            }
            directorsCount++;
        }
        if (directorsCount > 0) {
            companyObj['directorsStats']['riskPercent'] = (companyObj['directorsStats']['riskPercent'] / directorsCount).toFixed(0);
            companyObj['directorsStats']['completionPercent'] = (companyObj['directorsStats']['completionPercent'] / directorsCount).toFixed(0);
        }
        const directorsStatsPercentage = {
            personal: {
                completionPercent: 0,
                riskPercent: 0
            },
            occupational: {
                completionPercent: 0,
                riskPercent: 0
            },
            personalFinantial: {
                completionPercent: 0,
                riskPercent: 0
            },
            litigation: {
                completionPercent: 0,
                riskPercent: 0
            }
        };
        let numofDirectors = 0;
        for(const moduleKey in companyObj['modules'])if (typeof companyObj['modules'][moduleKey] === 'object') {
            const module = companyObj['modules'][moduleKey];
            if (moduleKey.includes('directors-questionnaire')) {
                for (const section of module['sections']){
                    if (section['subFolders']) for(const subFolderKey in section['subFolders']){
                        const subFolder = section.subFolders[subFolderKey];
                        if (subFolder['sectionNo'] == "DEPF007.1") {
                            directorsStatsPercentage['personal']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['personal']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                        if (subFolder['sectionNo'] == "DEPF007.2") {
                            directorsStatsPercentage['occupational']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['occupational']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                        if (subFolder['sectionNo'] == "DEPF007.3") {
                            directorsStatsPercentage['personalFinantial']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['personalFinantial']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                        if (subFolder['sectionNo'] == "DEPF007.4") {
                            directorsStatsPercentage['litigation']['completionPercent'] += subFolder['stats']['completionPercent'];
                            directorsStatsPercentage['litigation']['riskPercent'] += subFolder['stats']['riskPercent'];
                        }
                    }
                }
                numofDirectors++;
            }
        }
        if (numofDirectors > 0) for(const category in directorsStatsPercentage){
            directorsStatsPercentage[category]['completionPercent'] /= numofDirectors;
            directorsStatsPercentage[category]['riskPercent'] /= numofDirectors;
        }
        companyObj['directorSectionStats'] = directorsStatsPercentage;
        return companyObj;
    };
    const calculateSubFolderStats = (module, subFolders, questions)=>{
        for (const subFolder of Object.values(subFolders)){
            subFolder.stats = {
                minRiskScore: 0,
                maxRiskScore: 0,
                riskScore: 0,
                maxCompletionScore: 0,
                completionScore: 0,
                workflowCompletionScore: 0,
                workflowMaxScore: 0
            };
            let currentQuestions;
            if (subFolder['questions']) currentQuestions = subFolder['questions'];
            else currentQuestions = questions && questions.filter((q)=>q.qNo.match(new RegExp(subFolder.no + "((\.[0-9]+)|$)")));
            if (currentQuestions) {
                for (const question of currentQuestions)if (!question['isSkipped']) {
                    let answer = question['answer'] || {};
                    if ([
                        "Completed",
                        "Not Applicable"
                    ].includes(answer?.status)) {
                        // if (["Completed", "Not Applicable"].includes(answer?.status) || module.type !== "repository" && answer?.['radioOption']) {
                        if (answer?.['radioOption'] && answer?.['radioOption'] !== 'NC') subFolder['stats']['completionScore'] += question['completionScore'] || 1;
                        // Risk score calculation - skip N/A answers as they should not affect risk
                        if (answer?.['radioOption'] !== 'N/A') {
                            if (question['questionType'] == 'D/ND') subFolder['stats']['riskScore'] += answer?.['radioOption'] == 'Disclosure' ? question['riskIfD'] : answer?.['radioOption'] == 'No Disclosure' ? question['riskIfND'] : answer?.['radioOption'] == 'Not Sure' ? question['riskIfNS'] : 0;
                            else subFolder['stats']['riskScore'] += question["riskIf" + answer?.['radioOption']] || 0;
                            const allRiskScores = Object.keys(question).filter((k)=>k.startsWith("riskIf")).map((k)=>question[k]);
                            subFolder['stats']['minRiskScore'] += Math.min(...allRiskScores);
                            subFolder['stats']['maxRiskScore'] += Math.max(...allRiskScores);
                        }
                        let workflowScores = {
                            'Not Started': 0,
                            'Started': 0.25,
                            'In Progress': 0.50,
                            'Completed - Further Work': 0.75,
                            'Completed - No Issues': 1
                        };
                        if (answer['taskStatus'] && Object.keys(workflowScores).includes(answer['taskStatus'])) {
                            subFolder['stats']['workflowMaxScore'] += 1;
                            subFolder['stats']['workflowCompletionScore'] += workflowScores[answer['taskStatus']];
                        }
                    }
                    subFolder['stats']['maxCompletionScore'] += question['completionScore'] || 1;
                }
            }
            if (subFolder['stats']['completionScore'] == 0 || subFolder['stats']['maxRiskScore'] === subFolder['stats']['minRiskScore']) subFolder['stats']['riskPercent'] = 0;
            else subFolder['stats']['riskPercent'] = Math.round((subFolder['stats']['riskScore'] - subFolder['stats']['minRiskScore']) / (subFolder['stats']['maxRiskScore'] - subFolder['stats']['minRiskScore']) * 100);
            subFolder['stats']['completionPercent'] = Math.round(subFolder['stats']['completionScore'] / subFolder['stats']['maxCompletionScore'] * 100);
            subFolder['stats']['workflowCompletionPercent'] = Math.round(module['stats']['workflowCompletionScore'] / module['stats']['workflowMaxScore'] * 100);
            if (subFolder.subFolders) calculateSubFolderStats(module, subFolder['subFolders'], currentQuestions);
        }
    };
    const getCompletenessAndRiskHTML = (layoutType, stats, questions)=>{
        let tabModule = company?.['modules']?.[$6dc8626146af9081$export$57c43fe781091dc0(tab)];
        if (stats) stats = JSON.parse(JSON.stringify(stats));
        if (questions) questions = JSON.parse(JSON.stringify(questions));
        let completenessColour = 9 - Math.floor(stats['completionPercent'] / 33.34);
        let completenessText = stats['completionPercent'] && stats['completionPercent'] > 0 ? stats['completionPercent'] + `% ${stats['completionPercent'] == 100 ? 'Completed' : 'Complete'}` : "Not Started";
        // If its 1 question
        if (questions && questions.length == 1) {
            completenessText = questions[0]?.['answer']?.status || 'Not Started';
            completenessColour = completenessText === 'Not Started' ? 9 : completenessText == 'In Progress' || completenessText == 'Not Applicable' ? 8 : completenessText == 'Completed' ? 7 : 9;
        }
        if (layoutType.includes("repository") || layoutType.includes("investor-lead") || tabModule?.['riskScoring'] == false) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "fw600 lh1 fs1rem mt1rem c" + completenessColour,
            children: completenessText
        });
        let riskText, riskColour;
        if (stats['riskPercent'] == 0 && stats['completionPercent'] == 0) {
            riskColour = 37;
            riskText = "No Risk Score";
        } else if (stats['riskPercent'] > 62) {
            riskColour = 9;
            riskText = "High Risk";
        } else if (stats['riskPercent'] < 38) {
            riskColour = 34;
            riskText = "Low Risk";
        } else {
            riskColour = 8;
            riskText = "Medium Risk";
        }
        if (layoutType.includes("sidebar")) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: `fw300 c${completenessColour} tac fw600 lh1 fs1rem mt1rem`,
                    children: [
                        stats.completionPercent || 0,
                        "% Complete"
                    ]
                }),
                (!layoutType.includes("repository") || !layoutType.includes("investor-lead") || tabModule?.['riskScoring'] == true) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: `fw300 c${riskColour} tac fw600 lh1 fs1rem mt0-5rem`,
                    children: riskText
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c" + completenessColour,
                    children: completenessText
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "mx0-5rem",
                    children: " | "
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c" + riskColour,
                    children: riskText
                })
            ]
        });
    };
    const handleContactInvestor = async (investor, isContacted = true)=>{
        let investorId = investor['_id'];
        let clientId = location.pathname.split('/')[2];
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/contactInvestor`, {
            investorId: investorId,
            clientId: clientId,
            isContacted: isContacted
        });
        if (res && res['code'] == 200) getFitInvestorFirms();
        else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    const handleInvestorEmail = async (investor)=>{
        if (!investor['isContacted']) {
            setAcceptEmail(false);
            await setInvestorEmail(investor);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'investorEmailSent'
            }));
        }
    };
    const sendInvestorEmail = async ()=>{
        let data = {
            investorId: investorEmail['_id'],
            investorName: investorEmail['name'],
            clientId: company['_id'],
            clientName: company['cName'],
            fitScorePercentage: investorEmail['fitScorePercentage'],
            contactId: investorEmail['contactId'],
            contactName: investorEmail['contactName'],
            email: investorEmail['contactEmail']
        };
        if (investorEmail) {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/sendInvestorEmail`, data);
            if (res['code'] == 200) {
                await handleContactInvestor(investorEmail, true);
                setInvestorEmail({});
                setAcceptEmail(false);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            }
        }
    };
    const handleUploadImage = async (e)=>{
        let profile = e.target.files[0];
        if (profile && profile.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        profile = await URL.createObjectURL(profile);
        setUploadImage(profile);
    };
    const updateProfile = async ()=>{
        let attachment = [];
        if ($6dc8626146af9081$var$cropper.current && uploadImage) {
            let imageToUpload = $6dc8626146af9081$var$cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile-image.png", {
                type: "image/png"
            });
            attachment.push(coverFile);
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateLogo/${companyId}`, {
                attachment: attachment
            });
            if (response || response["code"] == 200) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                ...selectedCompany,
                logo: response?.['body']?.['logo']
            }));
            setUploadImage('');
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    const permissionTooltip = (permissions, isOwner)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "module-tooltip-box",
            style: {
                position: 'relative'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("9gCOW")),
                    style: {
                        width: '20px',
                        height: '20px',
                        bottom: '25px',
                        left: '-10px'
                    },
                    className: "cp pa",
                    alt: "list-img"
                }),
                company?.['sections'] && company['sections'].length > 0 && Object.keys(permissions).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "tooltip-area tooltip-area-permissions",
                    style: {
                        height: '60vh',
                        overflow: 'auto'
                    },
                    children: company['sections'].map((sec, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "dashboard-permission-overlaybox overlay-box cp w100 tac bss bw1px bo28",
                            style: {
                                opacity: permissions?.[sec?.['sectionNo']] || isOwner ? '1' : '0.5'
                            },
                            children: [
                                (permissions?.[sec?.['sectionNo']] || isOwner) && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fa fa-check-circle green mr0-5rem",
                                    style: {
                                        fontSize: '13px'
                                    }
                                }),
                                sec['sectionName']
                            ]
                        }, `section-${sec?.['sectionNo'] || idx}`);
                    })
                })
            ]
        });
    };
    const showPopupPercent = (value, type)=>{
        let color;
        if (type == 'Risk') color = value > 67 ? 'red' : value > 33 ? 'yellow' : 'green';
        else if (type == 'Completeness') color = value > 67 ? 'green' : value > 33 ? 'yellow' : 'red';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: `${color}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c6",
                    children: type
                }),
                " ",
                value || 0,
                "% "
            ]
        });
    };
    const createDirector = async ()=>{
        const companyId = location.pathname.split("/").slice(-1)[0];
        const name = document.getElementById("directorName").value;
        const designation = document.getElementById("directorDesignation").value;
        if (name && designation) {
            const postBody = {
                name: name,
                designation: designation
            };
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/createDirector/${companyId}`, postBody);
            if (response && response['code'] == 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                window.location.reload();
            }
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Enter director name and designation");
    };
    const handleViewDirector = async (item)=>{
        const moduleName = `directors-questionnaire_${item['_id']}`;
        const tabName = localStorage.getItem('isDiligencePack') && !isBackFitReport || user?.['type'] == 'External' ? `${moduleName}-report` : moduleName;
        setIsLoader({
            show: true,
            message: 'Loading...'
        });
        try {
            const cId = props?.isCallback ? props.companyId : location.pathname.split('/').slice(-1)[0];
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/getModule', {
                companyId: cId,
                moduleName: moduleName
            });
            if (response && response['code'] === 200 && response['body']?.[moduleName]) {
                const { selectedCompany: latest } = store.getState().company;
                dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                    ...latest,
                    modules: {
                        ...latest['modules'],
                        [moduleName]: {
                            ...latest['modules']?.[moduleName],
                            ...response['body'][moduleName]
                        }
                    },
                    from: 'handleViewDirector'
                }));
            }
        } catch (e) {
            console.error('Failed to fetch director module:', e);
        }
        setIsLoader({
            show: false,
            message: 'Loading...'
        });
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setTabName(tabName);
    };
    const handleViewTempDirector = async (item)=>{
        await setTab(`directors-questionnaire_${item['_id']}`);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (modal['open'] === 'showTempDirectors' && modal['tempDirectorsModuleSlug'] && companyId) (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/temp-modules/by-name/${encodeURIComponent(modal['tempDirectorsModuleSlug'])}/directors-stats?companyId=${encodeURIComponent(companyId)}`).then((res)=>{
            if (res && res['code'] === 200) setTempDirectorStats(res['body']?.['directorStats'] || []);
        }).catch(()=>setTempDirectorStats([]));
    }, [
        modal['open'],
        modal['tempDirectorsModuleSlug'],
        companyId
    ]);
    const handleBackDirectors = async ()=>{
        await setTabName("");
        await setOpenTabs(new Set());
        // If we came from the temp directors flow, reopen the temp directors modal
        if (modal['tempDirectorsModuleSlug']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'showTempDirectors',
            tempDirectorsModuleSlug: modal['tempDirectorsModuleSlug']
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'showDirectors'
        }));
    };
    const sortSections = (a, b)=>{
        let valueA = (a?.sectionNo || a?.no).match(/\d+/g);
        let valueB = (b?.sectionNo || b?.no).match(/\d+/g);
        return valueA - valueB;
    };
    const handleDemoNext = async ()=>{
        let module = company['modules'][tab.replace('-report', '')];
        if (isPrePopulate && module) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'demoChecklistFlow'
            }));
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/populate`, {
                companyId: company['_id'],
                moduleId: module['_id']
            });
            if (res?.['code'] == 200) {
                await setTab(tab, true);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                setIsPrePopulate(false);
            }
        } else {
            setIsPrePopulate(false);
            if (tab.endsWith("-report")) {
                if (isWorkflowReport) window.location.href = `/company/${company['_id']}`;
                else {
                    setIsWorkflowReport(true);
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'demoChecklistFlow'
                    }));
                    setTimeout(()=>{
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        }));
                        setTab(tab);
                    }, 4000);
                }
            } else {
                setIsWorkflowReport(false);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: 'demoChecklistFlow'
                }));
                setTimeout(()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    setTab(`${tab}-report`);
                }, 4000);
            }
        }
    };
    const handlePartnerChecklistNext = async ()=>{
        setIsPrePopulate(false);
        if (tab.endsWith("-report")) window.location.href = `/company/${company['_id']}`;
        else {
            setIsWorkflowReport(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'demoChecklistFlow'
            }));
            setTimeout(()=>{
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                setTab(`${tab}-report`);
            }, 4000);
        }
    };
    const handleSuperflowNext = async ()=>{
        // Matches are pre-fetched in the background (see QuestionAnswersPage) once DEPF008.1 & DEPF008.2 complete,
        // so just open the popup — no await, it appears instantly with the count already populated.
        if (company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100) handleSuperFlowPopup();
    };
    const nextInvestmentReadiness = async ()=>{
        if (company['modules']?.['Investment Readiness']) {
            window.location.href = `/company/${company['_id']}#${partner['moduleName']}`;
            setTimeout(()=>window.location.reload(), 200);
        } else window.location.href = `/completeInvestment/${partner['_id']}?companyId=${company['_id']}&cName=${company['cName']}`;
    };
    const handleCompleteInvestmentReadiness = async ()=>{
        const currentCompanyId = selectedCompany?.['_id'] || companyId;
        if (!currentCompanyId) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Company not loaded yet. Please try again.');
            return;
        }
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'completeInvestmentReadiness'
        }));
        setIsGenerateAllResearchAid(true);
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/generateAllReports', {
            companyId: currentCompanyId
        });
        if (res['code'] == '200') dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'generatedResearchAidReports'
        }));
        else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'notGeneratedResearchAidReports'
        }));
        setIsGenerateAllResearchAid(false);
        if (user && user['type'] == 'Superflow') {
            if (res) await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
                type: 'User'
            });
        }
    };
    const updateUserType = async ()=>{
        if (user && user['type'] == 'Superflow') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
                type: 'User'
            });
            if (res['code'] == '200') window.location.href = `/company/${companyId}`;
        }
    };
    const handleRedirectResearchAid = async ()=>{
        await getCompany();
        await getUser();
        navigate(`/company/${company['_id']}`);
        setCompanyDashboardTab('ResearchAid');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "company-dashboard-view poppins-font-style * ",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c89acdb493330259$export$2e2bcd8739ae039), {
                    value: dashboardTab,
                    children: [
                        user?.['type'] == 'Superflow' && (tab.includes('Readiness') || tab.includes('investor-lead')) || isManualAdd ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $def17927b8072e3f$export$2e2bcd8739ae039), {
                            page: "Company",
                            company: company,
                            breadcrum: [
                                'Company View',
                                '/Company',
                                `/${tab.includes('investor-lead') ? 'InvestorMatch' : 'Investment Readiness'}`
                            ],
                            heading: user?.['role'] == 'Investor' && company?.['addedByInvestor'] == user?.['_id'] && tab == 'investor-lead' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "Investor",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "Match"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " Add Applicant"
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "One"
                                    }),
                                    "Form ",
                                    tab.includes('investor-lead') ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Investor",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "Match"
                                            })
                                        ]
                                    }) : 'Investment Readiness'
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dashboard-container pt1rem df fdc ",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7aa087f4714d751e$export$2e2bcd8739ae039), {
                                company: company,
                                user: user,
                                dashboardTab: dashboardTab,
                                companyDashboardTab: companyDashboardTab,
                                setUploadImage: setUploadImage,
                                setCertificateSeeMore: setCertificateSeeMore,
                                setTab: setTab,
                                permissionTooltip: permissionTooltip,
                                setUserAction: setUserAction,
                                userAction: userAction,
                                setEditUser: setEditUser,
                                setDashboardTab: setDashboardTab,
                                isShowTeamTab: isShowTeamTab,
                                isPortfolio: isPortfolio,
                                setTabName: setTabName,
                                profileClass: profileClass,
                                tab: tab,
                                companyIndex: companyIndex,
                                setOpenTabs: setOpenTabs
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `dahboard-tabs`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100 company-dashboard",
                                    value: "Company",
                                    children: [
                                        isClientIndex && !isManualAdd && !localStorage.getItem("isQualifiedLeads") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $562489718ce8396e$export$2e2bcd8739ae039), {
                                            company: company,
                                            companyId: company?.['_id'],
                                            activeTab: companyDashboardTab,
                                            onTabChange: setCompanyDashboardTab
                                        }),
                                        (user?.['role'] == 'Advisor' || user?.['role'] == 'Investor') && permissionLevel && company?.['clientLoginActivated'] === false && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            class: "w100 mt1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleActivateClientLogin(company['_id']),
                                                disabled: activatingClient === company['_id'],
                                                "data-tooltip": "Click to send activation email to client",
                                                className: `cp c1 bg3 bg4-hover tac br20px fs0-75rem px3rem py0-5rem fw500 td250 mb0-5rem ${activatingClient === company['_id'] ? 'op50' : ''}`,
                                                style: {
                                                    border: "none"
                                                },
                                                children: activatingClient === company['_id'] ? 'Activating...' : 'Activate Client Login'
                                            })
                                        }),
                                        company['subscription'] !== 'Pro' && tab === "" && companyDashboardTab == 'Dashboard' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1129f9c8b56c4712$export$2e2bcd8739ae039), {
                                            user: user,
                                            company: company
                                        }),
                                        companyDashboardTab == 'Dashboard' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                tab.endsWith("-report") && user?.role.toLowerCase() === "guest" && user?.['type'] !== 'External' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                                                    wrapperClass: "tac",
                                                    heading: "",
                                                    subheading: "",
                                                    paragraph: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            "Register at the end of test to access more features ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fs11px",
                                                                children: "(No credit card required)"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a195f2587f794494$export$2e2bcd8739ae039), {
                                                                className: "c3"
                                                            })
                                                        ]
                                                    })
                                                }) : null,
                                                company['modules'] && user?.['type'] !== 'External' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df top-tabs-report",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: `df aic oxa w100`,
                                                            children: Array.from(openTabs).map((openTab, idx)=>{
                                                                const openTabModule = getModuleByTab(company, openTab) || getModuleByTab(company, openTab.replace(/-report/, ""));
                                                                const openTabModuleName = openTabModule?.heading?.split(",")[0] || openTabModule?.moduleName || openTabModule?.name || getTempModuleTitleForTab(openTab) || getTempModuleTitleForTab(openTab.replace(/-report$/, ''));
                                                                const openTabLabel = openTab.includes("investor-lead") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                    className: "c15",
                                                                    children: [
                                                                        "Investor",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "c4",
                                                                            children: "Match"
                                                                        })
                                                                    ]
                                                                }) : openTab.includes("kpi-report") || openTab === "kpi" ? "KPI Report" : openTabModuleName ? openTabModuleName : openTab.includes("directors-questionnaire") ? "Directors Questionnaire Report" : openTab.includes("fit-report") ? 'Fit Report' : openTab.split('?')[0].endsWith("-analyser") || openTab.endsWith("-analyser") || openTab.includes('--history--') ? (()=>{
                                                                    // Strip -analyser, legacy ?history=, and --history--<id>
                                                                    const tabId = openTab.replace(/-analyser$/, '').split('?')[0].split('--history--')[0];
                                                                    const report = company?.['aiReports']?.find((r)=>{
                                                                        if (r._id && r._id.toString() === tabId) return true;
                                                                        if (r.reportLabel) {
                                                                            const sanitized = r.reportLabel.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9.-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
                                                                            return sanitized === tabId;
                                                                        }
                                                                        return false;
                                                                    });
                                                                    return report?.reportLabel || report?.name || `${tabId.replaceAll("-", " ").replaceAll("%20", " ")} Analyser`;
                                                                })() : openTab.includes("-researchaid") && openTab.includes('?') ? openTab.split('?')[1] : openTab.replaceAll("-", " ").replaceAll("%20", " ");
                                                                const labelEndsWithReport = typeof openTabLabel === 'string' && /\breport$/i.test(openTabLabel.trim());
                                                                const displayOpenTabLabel = openTab.endsWith("-report") && !labelEndsWithReport ? typeof openTabLabel === 'string' ? `${openTabLabel} Report` : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        openTabLabel,
                                                                        " Report"
                                                                    ]
                                                                }) : openTabLabel;
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                    to: `#${openTab}`,
                                                                    onClick: ()=>setTab(openTab),
                                                                    className: (tab === openTab ? "bg1" : "bo6") + " shadow p1rem mt1rem wsn usn td250 c15 tab cp df fw600 ttu fs1rem jcc aic pr zi1 tal",
                                                                    children: [
                                                                        displayOpenTabLabel,
                                                                        !isPortfolio && isClientIndex && user?.['type'] !== 'Superflow' && !isManualAdd && !localStorage.getItem("isQualifiedLeads") && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                            className: "ml0-5rem pr",
                                                                            to: linksToCloseTab(),
                                                                            onClick: (e)=>closeTab(e, openTab),
                                                                            style: {
                                                                                top: '4px'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                width: "23",
                                                                                height: "24",
                                                                                viewBox: "0 0 23 24",
                                                                                fill: "none",
                                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                        opacity: "0.8",
                                                                                        x: "1.53125",
                                                                                        y: "2.03516",
                                                                                        width: "19.9333",
                                                                                        height: "19.9333",
                                                                                        rx: "9.96667",
                                                                                        fill: "white"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M18.6149 4.88438C17.2076 3.47722 15.4146 2.51896 13.4627 2.13078C11.5108 1.7426 9.48763 1.94193 7.64901 2.70357C5.81039 3.4652 4.2389 4.75494 3.13327 6.40969C2.02763 8.06443 1.4375 10.0099 1.4375 12C1.4375 13.9901 2.02763 15.9356 3.13327 17.5903C4.2389 19.2451 5.81039 20.5348 7.64901 21.2964C9.48763 22.0581 11.5108 22.2574 13.4627 21.8692C15.4146 21.4811 17.2076 20.5228 18.6149 19.1156C19.5494 18.1812 20.2907 17.0719 20.7964 15.851C21.3022 14.6301 21.5625 13.3215 21.5625 12C21.5625 10.6785 21.3022 9.36992 20.7964 8.14902C20.2907 6.92811 19.5494 5.81878 18.6149 4.88438ZM15.093 14.5444C15.1648 14.6116 15.2221 14.6929 15.2612 14.7831C15.3004 14.8734 15.3205 14.9707 15.3205 15.0691C15.3205 15.1674 15.3004 15.2648 15.2612 15.355C15.2221 15.4453 15.1648 15.5265 15.093 15.5938C15.0259 15.6604 14.9462 15.7131 14.8586 15.7488C14.7711 15.7846 14.6773 15.8027 14.5827 15.8022C14.3942 15.8014 14.2135 15.7265 14.0796 15.5938L11.4993 13.0134L8.9549 15.5938C8.82102 15.7265 8.64033 15.8014 8.45177 15.8022C8.35718 15.8027 8.26341 15.7846 8.17584 15.7488C8.08827 15.7131 8.00862 15.6604 7.94146 15.5938C7.80759 15.4591 7.73245 15.2769 7.73245 15.087C7.73245 14.8972 7.80759 14.715 7.94146 14.5803L10.4858 12L7.94146 9.45563C7.82371 9.31813 7.76218 9.14126 7.76917 8.96037C7.77616 8.77948 7.85115 8.60789 7.97915 8.47988C8.10716 8.35188 8.27875 8.27689 8.45964 8.2699C8.64053 8.26291 8.8174 8.32444 8.9549 8.44219L11.4993 10.9866L14.0436 8.44219C14.1102 8.37329 14.1897 8.31817 14.2775 8.27997C14.3653 8.24178 14.4599 8.22127 14.5556 8.2196C14.6514 8.21793 14.7466 8.23514 14.8357 8.27025C14.9248 8.30536 15.0062 8.35768 15.0751 8.42422C15.144 8.49077 15.1991 8.57023 15.2373 8.65808C15.2755 8.74592 15.296 8.84043 15.2977 8.9362C15.2993 9.03198 15.2821 9.12715 15.247 9.21627C15.2119 9.30539 15.1596 9.38673 15.093 9.45563L12.5127 12L15.093 14.5444Z",
                                                                                        fill: "#FC7785"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }, `tab-${openTab}-${idx}`);
                                                            })
                                                        }),
                                                        tab && tab.includes('directors-questionnaire') && !isBackFitReport && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            onClick: async ()=>handleBackDirectors(),
                                                            className: "tac dashboard-btn c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 td270 w200px mb0-5rem p1rem df aic jcc",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "icon mr1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "21",
                                                                        height: "21",
                                                                        viewBox: "0 0 21 21",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z",
                                                                                fill: "white",
                                                                                stroke: "white",
                                                                                "stroke-width": "0.5"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z",
                                                                                fill: "white",
                                                                                stroke: "white",
                                                                                "stroke-width": "0.5"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                "Back To Directors"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                company['modules'] && (tab && tab !== "" && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pr report-page",
                                                    style: {
                                                        transform: 'none'
                                                    },
                                                    children: [
                                                        tab.endsWith("-section-report") || tab.endsWith("-analysis-report") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem a",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ceaf1026d7cd7a8b$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab,
                                                                        onReportResolved: setActiveReportLabel
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    title: activeReportLabel || (tab.endsWith("-section-report") ? "Section Report" : "Insurance Gap Analysis Report"),
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.endsWith("-report") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: isWorkflowReport ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50f56850e74303b5$export$2e2bcd8739ae039), {
                                                                        sectionRefs: sectionRefs,
                                                                        getCompany: getCompany,
                                                                        setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                                        calculateStats: calculateStats,
                                                                        profileClass: profileClass,
                                                                        user: user,
                                                                        company: company,
                                                                        aiEnhanced: aiEnhanced,
                                                                        setAiEnchaned: setAiEnchaned,
                                                                        moduleCertification: company?.moduleCertification[tab.includes('business-audit') ? 'business-audit-' + company.testType : $6dc8626146af9081$export$57c43fe781091dc0(tab)],
                                                                        module: getModuleByTab(company, tab),
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                                        sortSections: sortSections,
                                                                        isLoader: isLoader,
                                                                        setIsLoader: setIsLoader
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15b5fd06d1c53733$export$2e2bcd8739ae039), {
                                                                            sectionRefs: sectionRefs,
                                                                            getCompany: getCompany,
                                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                                            profileClass: profileClass,
                                                                            user: user,
                                                                            company: company,
                                                                            aiEnhanced: aiEnhanced,
                                                                            setAiEnchaned: setAiEnchaned,
                                                                            moduleCertification: getModuleByTab(company, tab.includes("business-audit") ? `business-audit` : tab)?.stats?.moduleCertification || 'none',
                                                                            module: getModuleByTab(company, tab),
                                                                            tab: tab,
                                                                            setTab: setTabName,
                                                                            twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                                            sortSections: sortSections,
                                                                            openTabs: openTabs,
                                                                            setOpenTabs: setOpenTabs
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41a7e2f21e80a06c$export$2e2bcd8739ae039), {
                                                                    getCompany: getCompany,
                                                                    getUser: getUser,
                                                                    isWorkflowReport: isWorkflowReport,
                                                                    setIsWorkflowReport: setIsWorkflowReport,
                                                                    isViewTwoMinuteReport: isViewTwoMinuteReport,
                                                                    visibleSection: visibleSection,
                                                                    profileClass: profileClass,
                                                                    advisors: user['role'] == 'Advisor' ? advisors : investors,
                                                                    permissionLevel: permissionLevel,
                                                                    company: company,
                                                                    setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                                    tab: tab,
                                                                    sanitiseTab: $6dc8626146af9081$export$57c43fe781091dc0,
                                                                    toggleReport: toggleReport,
                                                                    openKPI: openKPI,
                                                                    enableAIEnhancedReporting: enableAIEnhancedReporting,
                                                                    calculateStats: calculateStats,
                                                                    calculateSubFolderStats: calculateSubFolderStats,
                                                                    getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                                                                    twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                                    getFitInvestorFirms: getFitInvestorFirms,
                                                                    setTab: setTab,
                                                                    setTabName: setTabName,
                                                                    setOpenTabs: setOpenTabs,
                                                                    openTabs: openTabs,
                                                                    sortSections: sortSections,
                                                                    handlePartnerChecklistNext: handlePartnerChecklistNext,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    closeTab: closeTab,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    isLoader: isLoader,
                                                                    setIsLoader: setIsLoader,
                                                                    isExternalPage: false,
                                                                    tempModule: getModuleByTab(company, tab),
                                                                    getTempModuleTitleForTab: getTempModuleTitleForTab
                                                                })
                                                            ]
                                                        }) : tab.includes('insuranceGapAnalysis-researchaid') ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ceaf1026d7cd7a8b$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        setCompanyDashboardTab: setCompanyDashboardTab
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.endsWith("-researchaid") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91ba6c0aac080db6$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        setCompanyDashboardTab: setCompanyDashboardTab
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.endsWith("-analyser") ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "td250 container bg1 py2rem w100 df",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ceaf1026d7cd7a8b$export$2e2bcd8739ae039), {
                                                                        company: company,
                                                                        tab: tab,
                                                                        setTab: setTab,
                                                                        setCompanyDashboardTab: setCompanyDashboardTab
                                                                    }, tab)
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                                    title: "AI Analyser Report",
                                                                    company: company,
                                                                    tab: tab,
                                                                    setTab: setTab,
                                                                    setOpenTabs: setOpenTabs,
                                                                    setTabName: setTabName,
                                                                    isBackFitReport: isBackFitReport,
                                                                    setIsBackFitReport: setIsBackFitReport,
                                                                    setCompanyDashboardTab: setCompanyDashboardTab,
                                                                    onCloseReport: handleCloseReportToRepository
                                                                })
                                                            ]
                                                        }) : tab.includes('fit-report') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6123099ae995020$export$2e2bcd8739ae039), {
                                                            user: user,
                                                            company: company,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            moduleCertification: company?.moduleCertification['investor-lead'],
                                                            module: company.modules['investor-lead'],
                                                            tab: tab,
                                                            setTab: setTab,
                                                            fitInvestorFirms: fitInvestorFirms,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            linearProgress: linearProgress
                                                        }) : tab === 'unaudited-certification' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $029a2d9637150f15$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            user: user,
                                                            company: company,
                                                            setTab: setTab,
                                                            directors: directors
                                                        }) : tab === 'diligence-pack' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86727a4e8cc19e92$export$2e2bcd8739ae039), {
                                                            company: company,
                                                            setCompanyDashboardTab: setCompanyDashboardTab,
                                                            setTab: setTab,
                                                            isExternal: false
                                                        }) : tab === 'consolidated-diligence' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "w100 h100 p2rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic jcc mb1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        onClick: ()=>setTab('diligence-pack'),
                                                                        className: "cp bg4 c1 br35px fw500 fs0-875rem px2rem py0-5rem bw0",
                                                                        children: "Back to Diligence Pack"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9310f9c2b7964d10$export$2e2bcd8739ae039), {
                                                                    src: localStorage.getItem('consolidatedReportUrl'),
                                                                    className: "w100 br10px",
                                                                    style: {
                                                                        height: 'calc(100vh - 120px)'
                                                                    },
                                                                    title: "Consolidated Diligence Report"
                                                                })
                                                            ]
                                                        }) : tab === 'share-diligence-pack' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8082c9444689024$export$2e2bcd8739ae039), {
                                                            company: company,
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            getCompany: getCompany,
                                                            setTab: setTab,
                                                            setTabName: setTabName
                                                        }) : tab === 'company-settings' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ea756d09d9085bc$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            company: company,
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            setTab: setTab,
                                                            getCompany: getCompany,
                                                            handleMemberEdit: handleMemberEdit
                                                        }) : tab === 'checklist-tasks' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3466f5c37a66c198$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            checklistTask: checklistTask,
                                                            user: user,
                                                            company: company,
                                                            setTab: setTab,
                                                            getChecklistTask: getChecklistTask
                                                        }) : tab === 'diligence-pack-reporting' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: company != {} && selectedModules != {} && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b56e0040e90bd8b5$export$2e2bcd8739ae039), {
                                                                profileClass: profileClass,
                                                                user: user,
                                                                company: company,
                                                                aiEnhanced: aiEnhanced,
                                                                setAiEnchaned: setAiEnchaned,
                                                                modules: selectedModules,
                                                                tab: tab,
                                                                setTab: setTabName
                                                            })
                                                        }) : tab === 'company-audit-log' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6a1128853993c07$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            auditReportLogs: auditReportLogs,
                                                            user: user,
                                                            company: company
                                                        }) : tab === 'benchmark-reporting' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $82340729f0c68d95$export$2e2bcd8739ae039), {
                                                            profileClass: profileClass,
                                                            user: user,
                                                            company: company,
                                                            tab: tab,
                                                            setTab: setTab
                                                        }) : tab === 'investorMatch' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46df257b3dd34ddd$export$2e2bcd8739ae039), {
                                                            tab: tab,
                                                            user: user,
                                                            setTab: setTab,
                                                            company: company,
                                                            isLeadPdf: isLeadPdf,
                                                            downloadPDF: downloadPDF,
                                                            fitInvestorFirms: fitInvestorFirms,
                                                            setFitInvestorFirms: setFitInvestorFirms,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            handleInvestorEmail: handleInvestorEmail,
                                                            handleContactInvestor: handleContactInvestor,
                                                            investorFirmCounts: investorFirmCounts,
                                                            setInvestorFirmCounts: setInvestorFirmCounts
                                                        }) : [
                                                            `two-minute-test-${company['testType']}`,
                                                            'repository',
                                                            `business-audit-${company['testType']}`,
                                                            'warranty-disclosure',
                                                            'investor-lead',
                                                            'software-development',
                                                            'esg'
                                                        ].includes(tab) || tab.includes('directors-questionnaire') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b1aff43fcfd6fe2$export$2e2bcd8739ae039), {
                                                            isManualAdd: isManualAdd,
                                                            setTabName: setTabName,
                                                            getCompany: getCompany,
                                                            setIsWorkflowReport: setIsWorkflowReport,
                                                            profileClass: profileClass,
                                                            advisors: user['role'] == 'Advisor' ? advisors : investors,
                                                            permissionLevel: permissionLevel,
                                                            tab: tab,
                                                            setTab: setTab,
                                                            sanitiseTab: $6dc8626146af9081$export$57c43fe781091dc0,
                                                            company: {
                                                                ...selectedCompany
                                                            },
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            companyId: companyId,
                                                            openKPI: openKPI,
                                                            toggleReport: toggleReport,
                                                            showAlert: showAlert,
                                                            enableAIEnhancedReporting: enableAIEnhancedReporting,
                                                            calculateStats: calculateStats,
                                                            calculateSubFolderStats: calculateSubFolderStats,
                                                            getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                                                            aiEnhanced: aiEnhanced,
                                                            setAiEnchaned: setAiEnchaned,
                                                            setOpenTabs: setOpenTabs,
                                                            openTabs: openTabs,
                                                            reloadModule: reloadModule,
                                                            twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                                                            cloneImportResult: cloneImportResult,
                                                            setCloneImportResult: setCloneImportResult,
                                                            fileReport: {
                                                                ...fileReport
                                                            },
                                                            setFileReport: (0, $12074930bd2c1829$export$9291658802bc1f31),
                                                            currentScore: currentScore,
                                                            setCurrentScore: (0, $12074930bd2c1829$export$fb8d60304f3762b3),
                                                            reportHistories: reportHistories,
                                                            setReportHistories: setReportHistories,
                                                            sortSections: sortSections,
                                                            companyIndex: companyIndex,
                                                            handleSuperflowNext: handleSuperflowNext,
                                                            setCompanyDashboardTab: setCompanyDashboardTab,
                                                            closeTab: closeTab,
                                                            isBackFitReport: isBackFitReport,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            isLoader: isLoader,
                                                            setIsLoader: setIsLoader
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2b1aff43fcfd6fe2$export$2e2bcd8739ae039), {
                                                            closeTab: closeTab,
                                                            setTabName: setTabName,
                                                            setCompanyDashboardTab: setCompanyDashboardTab,
                                                            setIsWorkflowReport: setIsWorkflowReport,
                                                            profileClass: profileClass,
                                                            advisors: user['role'] == 'Advisor' ? advisors : investors,
                                                            permissionLevel: permissionLevel,
                                                            tab: tab,
                                                            setTab: setTab,
                                                            sanitiseTab: $6dc8626146af9081$export$57c43fe781091dc0,
                                                            getUser: getUser,
                                                            company: company,
                                                            setCompany: (0, $b4397434d961d2b4$export$56500b0941c6fe84),
                                                            companyId: companyId,
                                                            openKPI: openKPI,
                                                            toggleReport: toggleReport,
                                                            enableAIEnhancedReporting: enableAIEnhancedReporting,
                                                            fileReport: {
                                                                ...fileReport
                                                            },
                                                            setFileReport: (0, $12074930bd2c1829$export$9291658802bc1f31),
                                                            reportHistories: reportHistories,
                                                            setReportHistories: setReportHistories,
                                                            calculateStats: calculateStats,
                                                            calculateSubFolderStats: calculateSubFolderStats,
                                                            getCompletenessAndRiskHTML: getCompletenessAndRiskHTML,
                                                            aiEnhanced: aiEnhanced,
                                                            setAiEnchaned: setAiEnchaned,
                                                            reloadModule: reloadModule,
                                                            twoMinuteTestAIReport: twoMinuteTestAIReport,
                                                            getFitInvestorFirms: getFitInvestorFirms,
                                                            isTwoMinuteTesHomePage: isTwoMinuteTesHomePage,
                                                            sortSections: sortSections,
                                                            handleCompleteInvestmentReadiness: handleCompleteInvestmentReadiness,
                                                            updateUserType: updateUserType,
                                                            handlePartnerChecklistNext: handlePartnerChecklistNext,
                                                            isBackFitReport: isBackFitReport,
                                                            setIsBackFitReport: setIsBackFitReport,
                                                            isLoader: isLoader,
                                                            setIsLoader: setIsLoader,
                                                            syncApiBase: "/modules",
                                                            logsApiBase: "/modules"
                                                        }),
                                                        localStorage.getItem('isDemoChecklist') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            class: "pf w90 h10vh df jcsb bg12 b0",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    class: "w60 pl3rem fs1rem c1 fw300",
                                                                    children: tab.endsWith("-report") ? isWorkflowReport ? 'Automated Checklist Workflow' : 'Automated Checklist Report' : 'Module Checklist'
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    class: "w40 df jcc aic pa r0 b0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                            onClick: (e)=>handleDemoNext(e),
                                                                            className: "cp shadow c1 fw400 fs0-75rem pr br38px w200px h3rem mt6rem df aic jcc bg4",
                                                                            children: [
                                                                                tab.endsWith("-report") || !isPrePopulate ? 'Ok, next' : 'Pre-Populate',
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                    className: "icon pr ml0-5rem",
                                                                                    style: {
                                                                                        top: '3px'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                        width: "30",
                                                                                        height: "30",
                                                                                        viewBox: "0 0 30 30",
                                                                                        fill: "none",
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                                                            fill: "white"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        tab.endsWith("-report") ? isWorkflowReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("2Z82J")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("h9XVc")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        }) : isPrePopulate ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("fv0ry")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "w60",
                                                                            src: (parcelRequire("16z8Y")),
                                                                            alt: "demo-checklist-sidebar"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        localStorage.getItem('isPartnerChecklist') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            class: "df jcc w100 my2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handlePartnerChecklistNext(),
                                                                className: `shadow c1 fw400 fs0-75rem pr br38px w200px h3rem df aic jcc ${getModuleByTab(company, tab) && getModuleByTab(company, tab)?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                                                children: "Next"
                                                            })
                                                        }),
                                                        user?.['type'] == 'Superflow' && tab == 'investor-lead' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            class: "df jcc w100 my2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleSuperflowNext(),
                                                                "data-tooltip": company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] != 100 ? 'Please complete the module 100%' : '',
                                                                className: `shadow c1 fw400 fs0-75rem pr br38px px5rem py0-5rem df aic jcc ${company?.modules?.['investor-lead'] && company?.modules?.['investor-lead']?.['stats']?.['completionPercent'] == 100 ? 'bg4 cp' : 'bg16 cna'} `,
                                                                children: "Next"
                                                            })
                                                        }),
                                                        user?.['type'] == 'Superflow' && tab == 'Investment Readiness' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            class: "df jcc w100 my2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                onClick: ()=>handleCompleteInvestmentReadiness(),
                                                                className: `shadow c1 fw400 fs0-75rem pr br38px px5rem py0-5rem df aic jcc mr1rem ${company?.modules?.[tab] && company?.modules?.[tab]?.['stats']['completionPercent'] > 0 ? 'bg4 cp' : 'bg16 cna'} `,
                                                                children: "Next"
                                                            })
                                                        })
                                                    ]
                                                }) || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: props?.optimized ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c509866364afb9eb$export$2e2bcd8739ae039), {
                                                        linearProgress: linearProgress,
                                                        isWorkflowReport: isWorkflowReport,
                                                        setIsWorkflowReport: setIsWorkflowReport,
                                                        profileClass: profileClass,
                                                        getFitInvestorFirms: getFitInvestorFirms,
                                                        permissionLevel: permissionLevel,
                                                        setCertificateSeeMore: setCertificateSeeMore,
                                                        fitInvestorFirms: fitInvestorFirms,
                                                        user: user,
                                                        company: company,
                                                        setTab: setTab,
                                                        setIsViewTwoMinuteReport: setIsViewTwoMinuteReport,
                                                        selectedSeeMore: selectedSeeMore,
                                                        setSelectedSeeMore: setSelectedSeeMore,
                                                        setCompanyDashboardTab: setCompanyDashboardTab,
                                                        isGenerateAllResearchAid: isGenerateAllResearchAid,
                                                        investorFirmCounts: investorFirmCounts,
                                                        setTabName: setTabName
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4b71702867a3909$export$2e2bcd8739ae039), {
                                                        linearProgress: linearProgress,
                                                        isWorkflowReport: isWorkflowReport,
                                                        setIsWorkflowReport: setIsWorkflowReport,
                                                        profileClass: profileClass,
                                                        getFitInvestorFirms: getFitInvestorFirms,
                                                        permissionLevel: permissionLevel,
                                                        setCertificateSeeMore: setCertificateSeeMore,
                                                        fitInvestorFirms: fitInvestorFirms,
                                                        user: user,
                                                        company: company,
                                                        setTab: setTab,
                                                        setIsViewTwoMinuteReport: setIsViewTwoMinuteReport,
                                                        selectedSeeMore: selectedSeeMore,
                                                        setSelectedSeeMore: setSelectedSeeMore,
                                                        setCompanyDashboardTab: setCompanyDashboardTab,
                                                        isGenerateAllResearchAid: isGenerateAllResearchAid,
                                                        investorFirmCounts: investorFirmCounts,
                                                        setTabName: setTabName
                                                    })
                                                }))
                                            ]
                                        }),
                                        companyDashboardTab == 'Analyser' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ed163864272cf1a$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setIsWorkflowReport: setIsWorkflowReport,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel
                                            })
                                        }),
                                        companyDashboardTab == 'AnyLists' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eeccad8a63eab6e4$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setIsWorkflowReport: setIsWorkflowReport,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel,
                                                isLoading: isLoader['show']
                                            })
                                        }),
                                        companyDashboardTab == 'Workflows' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daf292139b169396$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setIsWorkflowReport: setIsWorkflowReport,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel
                                            })
                                        }),
                                        companyDashboardTab == 'ResearchAid' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $779840fc7d20dab3$export$2e2bcd8739ae039), {
                                                company: company,
                                                getCompany: getCompany,
                                                setTab: setTab,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel,
                                                isGenerateAllResearchAid: isGenerateAllResearchAid
                                            })
                                        }),
                                        companyDashboardTab == 'InvestorMatch' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46df257b3dd34ddd$export$2e2bcd8739ae039), {
                                                tab: tab,
                                                user: user,
                                                setTab: setTab,
                                                company: company,
                                                isLeadPdf: isLeadPdf,
                                                downloadPDF: downloadPDF,
                                                linearProgress: linearProgress,
                                                fitInvestorFirms: fitInvestorFirms,
                                                setFitInvestorFirms: setFitInvestorFirms,
                                                setIsBackFitReport: setIsBackFitReport,
                                                handleInvestorEmail: handleInvestorEmail,
                                                getFitInvestorFirms: getFitInvestorFirms,
                                                handleContactInvestor: handleContactInvestor,
                                                investorFirmCounts: investorFirmCounts,
                                                setInvestorFirmCounts: setInvestorFirmCounts
                                            })
                                        }),
                                        companyDashboardTab == 'AppStore' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b5414be11cddc08f$export$2e2bcd8739ae039), {
                                                company: company,
                                                setTab: setTab,
                                                setCompanyDashboardTab: setCompanyDashboardTab,
                                                permissionLevel: permissionLevel,
                                                user: user
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100 company-dashboard",
                                    value: "Team",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dc3b81abd8d4ee8$export$2e2bcd8739ae039), {
                                        company: company,
                                        teamMembers: company?.['members'],
                                        setEditUser: setEditUser,
                                        setUserAction: setUserAction,
                                        resendInviteMember: resendInviteMember,
                                        handleDeleteMember: handleDeleteMember
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74c67866e4db07b8$export$2e2bcd8739ae039), {
                                    className: "w100 company-dashboard",
                                    value: "Portfolio Dashboard",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f14fac7464a42f8a$export$2e2bcd8739ae039), {
                                        permissionLevel: permissionLevel,
                                        company: company,
                                        companyId: companyId,
                                        setTab: setTab,
                                        setDashboardTab: setDashboardTab,
                                        setCompanyDashboardTab: setCompanyDashboardTab,
                                        setIsWorkflowReport: setIsWorkflowReport
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c218604756c85649$export$2e2bcd8739ae039), {
                handleClose: ()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    setCompanyDashboardTab('InvestorMatch');
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "generatedResearchAidReports",
                open: modal['open'] == 'generatedResearchAidReports',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr my1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fs1-25rem fw600 c15 my2rem mb2rem tac",
                                    children: "ResearchAid Reports Generated"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("ase4v")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mxa",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs1rem fw400 c15 mt3rem mb1rem",
                                            children: [
                                                "Reports from ResearchAid are generated!",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                "Let\u2019s go to your ResearchAid tab"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tac w100 db",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>handleRedirectResearchAid(),
                                                className: "cp w200px py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                                children: "Next"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "applyInvestorMatchPopup",
                open: modal['open'] == 'applyInvestorMatchPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w800px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df my1rem",
                                src: (parcelRequire("kpQLa")),
                                alt: ""
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df my1rem",
                                src: (parcelRequire("1IN79")),
                                alt: ""
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c15 fs1-25rem fw400 tac mb1rem",
                                children: [
                                    "Thank you for applying to Investor",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "c4",
                                        children: "Match"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1-25rem fw400 tac mb1rem",
                                children: "Thank you for applying for investment from us."
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c14 fs0-75rem fw300 tac mb1rem",
                                children: [
                                    "We will notify you of your investor matches and name/details 3 days before ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " the show. (Many investors only buy tickets shortly before the show)"
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c14 fs0-75rem fw300 tac mb1rem",
                                children: [
                                    "We will be in touch with you shortly once we have reviewed your ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " application."
                                ]
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("9FXIX")),
                                alt: ""
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1rem fw500 tac mt1rem",
                                children: "Want to increase investor interest?"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                class: "c15 fs1rem fw500 tac mt3rem",
                                children: "Want a speedier decision?"
                            }),
                            partner?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tac w100 db",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/completeInvestment/${partner['_id']}?companyId=${company['_id']}&cName=${company['cName']}`,
                                    className: "cp px5rem py0-5rem c1 bg4 bg3-hover br35px my1rem fw400 fs1rem zi0 td250",
                                    children: "Next"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "superFlowPopup",
                open: modal['open'] == 'superFlowPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc oscy",
                    style: {
                        maxHeight: '100vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mah90 oya bg1 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close-popup",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    style: {
                                        position: 'relative',
                                        top: '4px'
                                    },
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 320 512",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        className: "pen fa-primary",
                                        d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w100 df",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "mr3rem",
                                        src: (parcelRequire("iGe5G")),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "df fdc jcc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "w100 c15 fs1-25rem fw500 my1rem",
                                                children: [
                                                    "Thank you for completing your Investor",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "c4",
                                                        children: "Match"
                                                    }),
                                                    " assessment"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c15 fs1-25rem fw500 tac",
                                                children: "You are well on the way to accessing your goodies!"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w50 df jcsb my2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("dCaAd")),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w30 df fdc fs10px fw300 tas p1rem bw1px bo16 bss br15px",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c15 fs0-75rem fw600 mb1rem",
                                                children: "Investor Matches"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c12 lh2 mb0-5rem",
                                                children: "We have found you a number of database matches."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: `w100 fs1rem lh1 fw600 ${fitInvestorFirms.length > 0 ? 'c34' : 'c16'}`,
                                                children: [
                                                    fitInvestorFirms.length,
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `fs10px fw500 ${fitInvestorFirms.length > 0 ? 'c15' : 'c12'}`,
                                                        children: "Matches"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df jcc my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "c15 fs1-25rem fw500",
                                    children: "Now let\u2019s complete your Investment Readiness checklist"
                                })
                            }),
                            partner?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w80 df jce my1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>nextInvestmentReadiness(),
                                    className: "df jcc cp w30 py0-5rem c1 bg4 bg3-hover br35px fw400 fs1rem",
                                    children: "Next"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'userList',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100  bsbb df fdc m1rem maw900px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Members"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: [
                                company['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr df aic fs1rem-sm",
                                    children: [
                                        company['creatorId']?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: company['creatorId']?.['profile'],
                                            className: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                            "data-tooltip": company['creatorId'].firstName ? company['creatorId'].firstName + " " + (company['creatorId']?.lastName ? company['creatorId']?.lastName : "") : "Register to show your name here"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                            children: company?.['creatorId']?.['firstName']?.[0]?.toUpperCase() + (company?.['creatorId']?.['lastName'] ? company?.['creatorId']?.['lastName']?.[0]?.toUpperCase() : "")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                marginLeft: "1.5rem"
                                            },
                                            className: "pl2rem br5px shadow h4rem w100 bg5 df aic dg gtcr7-md gg1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem",
                                                    children: company['creatorId']['firstName']
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-75rem",
                                                    children: " Owner "
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem",
                                                    children: [
                                                        " ",
                                                        company['creatorId']['email'],
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem tac"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-75rem c7",
                                                    children: "Active"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "fs0-75rem tac",
                                                    children: [
                                                        " ",
                                                        company['creatorId']?.['lastLogin'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                "Last Login:",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: (new Date().getTime() - new Date(company['creatorId']['lastLogin']).getTime()) / 2592000000 > 3 ? 'c9' : 'c7',
                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['creatorId']['lastLogin']).format('ll')
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs1rem tac"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                company['members'] && company['members'].map((user)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr df aic fs1rem-sm",
                                        children: [
                                            user?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: user?.['profile'],
                                                className: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                                "data-tooltip": user.firstName ? user.firstName + " " + (user?.lastName ? user?.lastName : "") : "Register to show your name here"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: `pen pa t0 l0 w3rem h3rem df jcc aic br100 ${profileClass}`,
                                                children: (user?.['firstName'] ? user?.['firstName']?.[0]?.toUpperCase() : '') + (user?.['lastName'] ? user?.['lastName']?.[0]?.toUpperCase() : '')
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                style: {
                                                    marginLeft: "1.5rem"
                                                },
                                                className: "pl2rem br5px shadow h4rem w100 bg5 df aic dg gtcr7-md gg1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem",
                                                        children: user['firstName']
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem",
                                                        children: [
                                                            " ",
                                                            user['designation']?.toUpperCase(),
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem",
                                                        children: [
                                                            " ",
                                                            user['email'],
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem tac",
                                                        onClick: ()=>handleMemberEdit(user),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            className: "cp",
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-edit"
                                                                }),
                                                                " Edit "
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `fs0-75rem ${user['emailVerified'] ? ' c7' : ' c8'}`,
                                                        children: user['emailVerified'] ? 'Active' : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                "Invite Sent ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(user['updatedAt']).format('ll')
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem tac",
                                                        children: [
                                                            " ",
                                                            !user['emailVerified'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                    className: "cp",
                                                                    onClick: ()=>resendInviteMember(user['_id']),
                                                                    children: [
                                                                        " ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "fa fa-history c8"
                                                                        }),
                                                                        " Resend "
                                                                    ]
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    "Last Login:",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: (new Date().getTime() - new Date(user['lastLogin']).getTime()) / 2592000000 > 3 ? 'c9' : 'c7',
                                                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(user['lastLogin']).format('ll')
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs1rem tac",
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                                className: "cp",
                                                                onClick: ()=>handleDeleteMember(user['_id']),
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "fa fa-trash c9"
                                                                    }),
                                                                    " Delete "
                                                                ]
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `team-member-${user['_id']}`)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'editUser'
                                        }));
                                        setEditUser({});
                                        setUserAction('Search');
                                    },
                                    className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                    children: "New Member"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'generatingAIReport',
                onCloseHandler: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h9rem",
                                src: (parcelRequire("hA45b")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1-5rem c15",
                                children: "Generating AI Report"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb1-5rem c15 fs12px px1rem op70",
                                children: [
                                    "Whilst we prepare your bespoked 2-minute test report, why don\u2019t your bonus ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        className: "fsi",
                                        children: "BONUS KPI Report"
                                    }),
                                    " which suggests 10 useful business metrics for your business, how to calculate them, and your industry comparables.  You can then click on the \u201C2 Minute Test Report\u201D button to view it."
                                ]
                            })
                        ]
                    }),
                    tab != 'kpi-report' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "21",
                                height: "22",
                                viewBox: "0 0 21 22",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_5984_61323)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.2524 14.5155L6.983 5.24614C6.78588 5.04898 6.50209 4.96547 6.22959 5.02441C5.95708 5.08335 5.73313 5.27662 5.63506 5.5376L0.0524681 20.391C-0.060735 20.6922 0.0126009 21.0318 0.240033 21.2594C0.468654 21.4882 0.80855 21.5601 1.10829 21.4477L15.9717 15.8751C16.5385 15.6633 16.6837 14.9286 16.2524 14.5155ZM9.343 16.6082L3.99936 14.5529L5.00453 11.8785L13.3732 15.0972L9.343 16.6082ZM6.723 7.30632L12.3704 12.9537L5.58183 10.3427L6.723 7.30632ZM3.42215 16.0887L7.02869 17.4759L2.22371 19.2774L3.42215 16.0887Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.2407 4.70189C13.2024 3.7402 13.2026 2.18349 12.2407 1.22159C11.2811 0.262073 9.71997 0.262073 8.76041 1.22159C7.79868 2.18333 7.79855 3.74003 8.76041 4.70189C9.71985 5.66133 11.2811 5.66145 12.2407 4.70189ZM9.9205 2.38168C10.2403 2.06188 10.7607 2.06184 11.0806 2.38168C11.4012 2.70226 11.4012 3.22115 11.0806 3.54176C10.7607 3.8616 10.2403 3.8616 9.9205 3.54176C9.59992 3.22119 9.59992 2.7023 9.9205 2.38168Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M19.6484 10.6074H18.8281V9.78711C18.8281 9.33405 18.4609 8.9668 18.0078 8.9668C17.5548 8.9668 17.1875 9.33405 17.1875 9.78711V10.6074H16.3672C15.9141 10.6074 15.5469 10.9747 15.5469 11.4277C15.5469 11.8808 15.9141 12.248 16.3672 12.248H17.1875V13.0684C17.1875 13.5214 17.5548 13.8887 18.0078 13.8887C18.4609 13.8887 18.8281 13.5214 18.8281 13.0684V12.248H19.6484C20.1015 12.248 20.4688 11.8808 20.4688 11.4277C20.4688 10.9747 20.1015 10.6074 19.6484 10.6074Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.1231 8.43608C16.4435 8.11571 16.4435 7.59633 16.1231 7.276C15.8026 6.9555 15.8024 6.43653 16.1231 6.11591C16.4437 5.79538 16.9625 5.79529 17.2832 6.11591C17.6038 6.43649 18.1232 6.43604 18.4433 6.11591C18.7637 5.79554 18.7636 5.27616 18.4433 4.95583C18.1228 4.63533 18.1226 4.11636 18.4433 3.79574C18.7638 3.47516 19.2828 3.47512 19.6033 3.79574C19.9237 4.11611 20.4431 4.11611 20.7635 3.79574C21.0838 3.47537 21.0838 2.95599 20.7635 2.63566C19.8039 1.67609 18.2426 1.67618 17.2832 2.63566C16.8507 3.06808 16.5994 3.63316 16.5664 4.23908C15.9604 4.27206 15.3953 4.52344 14.963 4.95587C14.4982 5.4207 14.2422 6.03868 14.2422 6.69604C14.2422 7.3534 14.4982 7.97138 14.963 8.43621C15.2834 8.75642 15.8028 8.75642 16.1231 8.43608Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M15.4219 2.14062C15.8749 2.14062 16.2422 1.77336 16.2422 1.32031C16.2422 0.867266 15.8749 0.5 15.4219 0.5C14.9688 0.5 14.6016 0.867266 14.6016 1.32031C14.6016 1.77336 14.9688 2.14062 15.4219 2.14062Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.1797 8.53906C20.6327 8.53906 21 8.1718 21 7.71875C21 7.2657 20.6327 6.89844 20.1797 6.89844C19.7266 6.89844 19.3594 7.2657 19.3594 7.71875C19.3594 8.1718 19.7266 8.53906 20.1797 8.53906Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.1406 8.53906C12.5937 8.53906 12.9609 8.1718 12.9609 7.71875C12.9609 7.2657 12.5937 6.89844 12.1406 6.89844C11.6876 6.89844 11.3203 7.2657 11.3203 7.71875C11.3203 8.1718 11.6876 8.53906 12.1406 8.53906Z",
                                                fill: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_5984_61323",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "21",
                                                height: "21",
                                                fill: "white",
                                                transform: "translate(0 0.5)"
                                            })
                                        })
                                    })
                                ]
                            }),
                            btnType: "warning",
                            text: "Free KPI Report",
                            textClassName: "ttu",
                            customClassName: "df",
                            onClick: ()=>openKPI()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'completeAIReport',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px6rem py3rem bsbb df fdc aic m1rem maw800px pr pt5rem br20px pr",
                    style: {
                        backgroundImage: `url(${(parcelRequire("dJEkK"))})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        lineHeight: '1.8'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "mb1-5rem c15",
                            children: "AI Report Now Complete!\u200B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tac c12",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb1-5rem c15 fs12px px1rem op70",
                                    children: '"\uD83C\uDF1F Huzzah, Valiant Voyager! \uD83C\uDF1F The stars have aligned and the spells have been cast. Your AI-enhanced report has been meticulously crafted and is now ready for your discerning eyes. Unveil the magic and insights within... simply click below to embark on this revelation! \uD83D\uDCDC\u2728"\u200B'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "h8rem",
                                    src: (parcelRequire("ase4v")),
                                    alt: ""
                                })
                            ]
                        }),
                        moduleAI !== '' && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>{
                                setTab(moduleAI + "-report", true);
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            },
                            className: `w40 df jcc aic fw500 px1rem py0-5rem c1 bg4 br19px cp`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    className: "pen fds h1rem f1 mr0-5rem",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 448 512",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-primary",
                                            d: "M339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "fa-secondary",
                                            d: "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z"
                                        })
                                    ]
                                }),
                                "View AI Report"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75097013a2b9925d$export$2e2bcd8739ae039), {
                modalType: "firstSetupDataRepository",
                dispatch: dispatch,
                companyId: companyId,
                company: company
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'DataRepositorySetupSteps',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr oya bg1 shadow w100 p3rem pt5rem bsbb df fdc m1rem maw1000px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "pa t0 l0 m1rem ttu c7 fs1-5rem fw500",
                            children: company.subscription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem fs1-5em",
                                children: company.cName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "c4 fs1-25rem-sm ttu w100 tac mb2rem",
                                children: "Diligentsia Filing Assistant"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step1. Select your data room folders/files to be ingested"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "pen h2rem",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z",
                                        style: {
                                            fill: '#4A67FF'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step2. With the use of AI we do our magic in the background and allocate your files to our Repository sections"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "pen h2rem",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z",
                                        style: {
                                            fill: '#4A67FF'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step3. You review the allocation of your files to our sections and reallocate if desired"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: "pen h2rem",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19.924 13.617A1 1 0 0 0 19 13h-3V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10H5a1 1 0 0 0-.707 1.707l7 7a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0 .217-1.09z",
                                        style: {
                                            fill: '#4A67FF'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "repository-step",
                                    children: "Step4. You can (optionally) remove duplicated files using our deduper"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc fdr jcc aic mt2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 w40 ttu bsbb tac mb1rem df jcc aic mr1rem",
                                children: "Let's go to Filing Assistant"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'connectingDataRoom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df fdc aic m1rem mah90 oya",
                    style: {
                        outline: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "connecting-dataroom-modal bg38 shadow w100 df fdc maw1100px pr br20px px3rem py2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic mb1-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dataroom-provider-icon df jcc aic mr1rem oh",
                                            children: [
                                                props.storageId == 'GDrive' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w100 h100",
                                                    src: (parcelRequire("3nZQn")),
                                                    alt: "Google Drive"
                                                }),
                                                props.storageId == 'dropbox' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w100 h100",
                                                    src: (parcelRequire("dRr6z")),
                                                    alt: "Dropbox"
                                                }),
                                                props.storageId == 'sharepoint' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w100 h100",
                                                    src: (parcelRequire("lnvWz")),
                                                    alt: "SharePoint"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "w100 fs14px fw300 c15",
                                                    children: "Integration Setup"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                                    className: "fs20px fw500 c15 lh1",
                                                    children: [
                                                        props.storageName || 'Data Room',
                                                        " to be ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "c4",
                                                            children: "Connected!"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fww jcsb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dataroom-feature-card mb1rem bsbb",
                                            style: {
                                                width: 'calc(50% - 0.5rem)'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mb0-5rem",
                                                    src: (parcelRequire("8xM0j")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "fs1rem fw500 c15 mb0-5rem",
                                                    children: "Folder Replication"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px fw400 c27 lh2",
                                                    children: "A replica of your Diligentsia folder structure will be set up in your chosen cloud Data Room in just a few moments."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dataroom-feature-card mb1rem bsbb",
                                            style: {
                                                width: 'calc(50% - 0.5rem)'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mb0-5rem",
                                                    src: (parcelRequire("aMopV")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "fs1rem fw500 c15 mb0-5rem",
                                                    children: "Two-Way Sync"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px fw400 c27 lh2",
                                                    children: "Once created, sync seamlessly between Diligentsia and your cloud \u2014 effectively creating a live backup."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dataroom-feature-card mb1rem bsbb",
                                            style: {
                                                width: 'calc(50% - 0.5rem)'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mb0-5rem",
                                                    src: (parcelRequire("40cRe")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "fs1rem fw500 c15 mb0-5rem",
                                                    children: "Import Existing Files"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px fw400 c27 lh2",
                                                    children: "Copy files from other cloud folders into your Diligentsia Data Room folder, then import and sync them with ease."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dataroom-feature-card mb1rem bsbb",
                                            style: {
                                                width: 'calc(50% - 0.5rem)'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mb0-5rem",
                                                    src: (parcelRequire("4W4iq")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    className: "fs1rem fw500 c15 mb0-5rem",
                                                    children: "Source Colour Coding"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs12px fw400 c27 lh2",
                                                    children: 'Imported files are colour-coded by source. Mark each section as "complete" once reviewed.'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic p1rem mb1-5rem bs1px bo18 br10px",
                                    style: {
                                        backgroundColor: '#E2E7FF'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w30px h30px mr0-5rem",
                                            src: (parcelRequire("hxhdZ")),
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "fs14px fw300 c27 lh2",
                                            children: [
                                                "We keep a ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw500 c14",
                                                    children: "full audit log"
                                                }),
                                                " of all changes and provide ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw500 c14",
                                                    children: "comprehensive reporting"
                                                }),
                                                " across your entire data room."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aife jcsb fww",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df fdc",
                                            style: {
                                                flex: '1 1 auto',
                                                maxWidth: '65%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "w100 fs14px fw400 c27 mb0-5rem",
                                                    children: "Setting things up... Patience!"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "dataroom-progress-track",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "dataroom-progress-fill"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                            text: "Got it",
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            btnType: "warning",
                                            customClassName: "ml1rem"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "cp mt1-5rem",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            width: "48",
                            height: "48",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'createdDataRoom',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb0-5rem",
                                children: [
                                    "Good news!  Your Cloud Data",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Room has now been created.",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "You can now sync.\u200B"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttu bsbb df jcc",
                                onClick: ()=>{
                                    moveToCompanyPage();
                                },
                                children: "Let\u2019s go!\u200B"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteMember',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah70 bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Delete Member"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah500px oya advisor-box-content",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac my1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c15",
                                        children: "Are you certain you want to delete Member?"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ''
                                                })),
                                            className: "new-shadow bg4 bg3-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>submitDeleteMember(),
                                            className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                            children: "Submit"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '40px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'investorEmailSent',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw500px pr pt3rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 tac",
                            children: "Contact Investor"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs1rem",
                                children: [
                                    "Are you sure you want to contact investor ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: investorEmail['name']
                                    }),
                                    "?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>{
                                        setInvestorEmail({}), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        }));
                                    },
                                    className: "h100 mt0-5rem shadow bg4 c1 td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>sendInvestorEmail(),
                                    className: "bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                    children: "Send Email"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'twoMinuteTestCompleted',
                onCloseHandler: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "maw100px mah100px mb1rem",
                                width: "100",
                                height: "101",
                                viewBox: "0 0 118 119",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                        cx: "59",
                                        cy: "59.5",
                                        r: "59",
                                        fill: "#15D757",
                                        "fill-opacity": "0.2"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_6321_2)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M53 75.4999C52.207 75.4999 51.443 75.1859 50.879 74.6208L42.879 66.6208C41.707 65.4499 41.707 63.5499 42.879 62.3789C44.05 61.2069 45.95 61.2069 47.121 62.3789L52.675 67.9328L68.599 46.6999C69.595 45.3739 71.477 45.1069 72.799 46.0999C74.125 47.0939 74.394 48.9748 73.4 50.2998L55.4 74.2999C54.879 74.9958 54.08 75.4309 53.213 75.4919C53.142 75.4969 53.07 75.4999 53 75.4999Z",
                                                fill: "#15D757"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M35 60.5H30C29.447 60.5 29 60.053 29 59.5C29 58.947 29.447 58.5 30 58.5H35C35.553 58.5 36 58.947 36 59.5C36 60.053 35.553 60.5 35 60.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M33.8838 74.9998C33.5378 74.9998 33.2018 74.8208 33.0168 74.4998C32.7408 74.0208 32.9048 73.4098 33.3828 73.1338L37.7128 70.6338C38.1898 70.3588 38.8018 70.5208 39.0788 70.9998C39.3548 71.4788 39.1908 72.0898 38.7128 72.3658L34.3828 74.8658C34.2258 74.9568 34.0538 74.9998 33.8838 74.9998Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M44.4997 85.6139C44.3297 85.6139 44.1577 85.5709 44.0007 85.4799C43.5217 85.2039 43.3577 84.5919 43.6347 84.1139L46.1347 79.7839C46.4117 79.3049 47.0227 79.1409 47.5007 79.4179C47.9787 79.6949 48.1437 80.3059 47.8667 80.7839L45.3667 85.1139C45.1807 85.4339 44.8457 85.6139 44.4997 85.6139Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M59 89.5C58.447 89.5 58 89.053 58 88.5V83.5C58 82.947 58.447 82.5 59 82.5C59.553 82.5 60 82.947 60 83.5V88.5C60 89.053 59.553 89.5 59 89.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M73.501 85.6134C73.155 85.6134 72.819 85.4344 72.634 85.1134L70.134 80.7834C69.858 80.3044 70.022 79.6934 70.5 79.4174C70.976 79.1414 71.589 79.3044 71.866 79.7834L74.366 84.1134C74.642 84.5924 74.478 85.2034 74 85.4794C73.843 85.5704 73.671 85.6134 73.501 85.6134Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M84.1109 75.0002C83.9409 75.0002 83.7689 74.9572 83.6119 74.8662L79.2819 72.3662C78.8029 72.0902 78.6389 71.4782 78.9159 71.0002C79.1919 70.5212 79.8049 70.3582 80.2819 70.6342L84.6119 73.1342C85.0909 73.4102 85.2549 74.0222 84.9779 74.5002C84.7919 74.8212 84.4569 75.0002 84.1109 75.0002Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M88 60.5H83C82.447 60.5 82 60.053 82 59.5C82 58.947 82.447 58.5 83 58.5H88C88.553 58.5 89 58.947 89 59.5C89 60.053 88.553 60.5 88 60.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M79.7823 48.5007C79.4363 48.5007 79.1003 48.3217 78.9153 48.0007C78.6393 47.5217 78.8033 46.9107 79.2813 46.6347L83.6113 44.1347C84.0883 43.8577 84.7013 44.0217 84.9773 44.5007C85.2533 44.9797 85.0893 45.5907 84.6113 45.8667L80.2813 48.3667C80.1243 48.4577 79.9523 48.5007 79.7823 48.5007Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M70.9997 39.7154C70.8297 39.7154 70.6577 39.6724 70.5007 39.5814C70.0217 39.3054 69.8577 38.6934 70.1347 38.2154L72.6347 33.8854C72.9107 33.4064 73.5227 33.2424 74.0007 33.5194C74.4787 33.7964 74.6437 34.4074 74.3667 34.8854L71.8667 39.2154C71.6807 39.5354 71.3457 39.7154 70.9997 39.7154Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M59 36.5C58.447 36.5 58 36.053 58 35.5V30.5C58 29.947 58.447 29.5 59 29.5C59.553 29.5 60 29.947 60 30.5V35.5C60 36.053 59.553 36.5 59 36.5Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M47.001 39.717C46.655 39.717 46.319 39.538 46.134 39.217L43.634 34.887C43.358 34.408 43.522 33.797 44 33.521C44.477 33.245 45.09 33.408 45.366 33.887L47.866 38.217C48.142 38.696 47.978 39.307 47.5 39.583C47.343 39.674 47.171 39.717 47.001 39.717Z",
                                                fill: "#AEE090"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M38.2125 48.4992C38.0425 48.4992 37.8705 48.4562 37.7135 48.3652L33.3835 45.8652C32.9045 45.5892 32.7405 44.9772 33.0175 44.4992C33.2935 44.0202 33.9055 43.8552 34.3835 44.1332L38.7135 46.6332C39.1925 46.9092 39.3565 47.5212 39.0795 47.9992C38.8935 48.3202 38.5585 48.4992 38.2125 48.4992Z",
                                                fill: "#AEE090"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_6321_2",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "60",
                                                height: "60",
                                                fill: "white",
                                                transform: "translate(29 29.5)"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1-5rem c15",
                                children: "Two Minute Test Completed"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mb1-5rem c15 fs12px px1rem op70",
                                children: [
                                    "Whilst we prepare your report, please glance at your ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        className: "fsi",
                                        children: "BONUS KPI Report"
                                    }),
                                    " which has been tailored to your business and suggests 10  useful business metrics, how to calculate them, and what your industry comparables could be."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "21",
                                height: "22",
                                viewBox: "0 0 21 22",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_5984_61323)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.2524 14.5155L6.983 5.24614C6.78588 5.04898 6.50209 4.96547 6.22959 5.02441C5.95708 5.08335 5.73313 5.27662 5.63506 5.5376L0.0524681 20.391C-0.060735 20.6922 0.0126009 21.0318 0.240033 21.2594C0.468654 21.4882 0.80855 21.5601 1.10829 21.4477L15.9717 15.8751C16.5385 15.6633 16.6837 14.9286 16.2524 14.5155ZM9.343 16.6082L3.99936 14.5529L5.00453 11.8785L13.3732 15.0972L9.343 16.6082ZM6.723 7.30632L12.3704 12.9537L5.58183 10.3427L6.723 7.30632ZM3.42215 16.0887L7.02869 17.4759L2.22371 19.2774L3.42215 16.0887Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.2407 4.70189C13.2024 3.7402 13.2026 2.18349 12.2407 1.22159C11.2811 0.262073 9.71997 0.262073 8.76041 1.22159C7.79868 2.18333 7.79855 3.74003 8.76041 4.70189C9.71985 5.66133 11.2811 5.66145 12.2407 4.70189ZM9.9205 2.38168C10.2403 2.06188 10.7607 2.06184 11.0806 2.38168C11.4012 2.70226 11.4012 3.22115 11.0806 3.54176C10.7607 3.8616 10.2403 3.8616 9.9205 3.54176C9.59992 3.22119 9.59992 2.7023 9.9205 2.38168Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M19.6484 10.6074H18.8281V9.78711C18.8281 9.33405 18.4609 8.9668 18.0078 8.9668C17.5548 8.9668 17.1875 9.33405 17.1875 9.78711V10.6074H16.3672C15.9141 10.6074 15.5469 10.9747 15.5469 11.4277C15.5469 11.8808 15.9141 12.248 16.3672 12.248H17.1875V13.0684C17.1875 13.5214 17.5548 13.8887 18.0078 13.8887C18.4609 13.8887 18.8281 13.5214 18.8281 13.0684V12.248H19.6484C20.1015 12.248 20.4688 11.8808 20.4688 11.4277C20.4688 10.9747 20.1015 10.6074 19.6484 10.6074Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.1231 8.43608C16.4435 8.11571 16.4435 7.59633 16.1231 7.276C15.8026 6.9555 15.8024 6.43653 16.1231 6.11591C16.4437 5.79538 16.9625 5.79529 17.2832 6.11591C17.6038 6.43649 18.1232 6.43604 18.4433 6.11591C18.7637 5.79554 18.7636 5.27616 18.4433 4.95583C18.1228 4.63533 18.1226 4.11636 18.4433 3.79574C18.7638 3.47516 19.2828 3.47512 19.6033 3.79574C19.9237 4.11611 20.4431 4.11611 20.7635 3.79574C21.0838 3.47537 21.0838 2.95599 20.7635 2.63566C19.8039 1.67609 18.2426 1.67618 17.2832 2.63566C16.8507 3.06808 16.5994 3.63316 16.5664 4.23908C15.9604 4.27206 15.3953 4.52344 14.963 4.95587C14.4982 5.4207 14.2422 6.03868 14.2422 6.69604C14.2422 7.3534 14.4982 7.97138 14.963 8.43621C15.2834 8.75642 15.8028 8.75642 16.1231 8.43608Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M15.4219 2.14062C15.8749 2.14062 16.2422 1.77336 16.2422 1.32031C16.2422 0.867266 15.8749 0.5 15.4219 0.5C14.9688 0.5 14.6016 0.867266 14.6016 1.32031C14.6016 1.77336 14.9688 2.14062 15.4219 2.14062Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20.1797 8.53906C20.6327 8.53906 21 8.1718 21 7.71875C21 7.2657 20.6327 6.89844 20.1797 6.89844C19.7266 6.89844 19.3594 7.2657 19.3594 7.71875C19.3594 8.1718 19.7266 8.53906 20.1797 8.53906Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M12.1406 8.53906C12.5937 8.53906 12.9609 8.1718 12.9609 7.71875C12.9609 7.2657 12.5937 6.89844 12.1406 6.89844C11.6876 6.89844 11.3203 7.2657 11.3203 7.71875C11.3203 8.1718 11.6876 8.53906 12.1406 8.53906Z",
                                                fill: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_5984_61323",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "21",
                                                height: "21",
                                                fill: "white",
                                                transform: "translate(0 0.5)"
                                            })
                                        })
                                    })
                                ]
                            }),
                            btnType: "warning",
                            text: "Free KPI Report",
                            textClassName: "ttu",
                            customClassName: "df",
                            onClick: ()=>{
                                openKPI(), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: 'notSupportPersonalAccount',
                onCloseHandler: moveToCompanyPage,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "tac",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "60",
                                height: "60",
                                viewBox: "0 0 82 82",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M40.9346 76C60.3018 76 76.002 60.2998 76.002 40.9326C76.002 21.5654 60.3018 5.86523 40.9346 5.86523C21.5674 5.86523 5.86719 21.5654 5.86719 40.9326C5.86719 60.2998 21.5674 76 40.9346 76Z",
                                        fill: "url(#paint0_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M75.8262 44.4635L45.6436 14.2808C44.6406 12.9422 42.8694 12.8047 40.8963 12.8047C37.7014 12.8047 35.7969 13.9299 35.7969 16.9691C35.7969 26.2423 36.8879 39.5683 36.8879 48.8416C36.8879 50.0536 36.8291 50.9124 37.672 51.4674L57.8565 71.6519C67.6994 66.2184 74.6533 56.1932 75.8262 44.4635Z",
                                        fill: "url(#paint1_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M57.5222 71.8347L45.3323 59.6447C44.2374 58.4271 42.6732 57.9434 40.9715 57.9434C37.5426 57.9434 35.2656 60.3763 35.2656 63.6493C35.2656 65.3942 35.7417 67.0187 36.9961 68.1378L44.6613 75.803C49.2741 75.3157 53.6198 73.9344 57.5222 71.8347Z",
                                        fill: "url(#paint2_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M46.8997 63.6494C46.8997 66.8446 44.1724 69.65 40.9772 69.65C37.5482 69.65 34.9766 66.8446 34.9766 63.6494C34.9766 60.3765 37.5482 57.6488 40.9772 57.6488C44.1724 57.6488 46.8997 60.3765 46.8997 63.6494ZM45.4192 48.8431C45.4192 51.259 42.7695 52.272 40.8991 52.272C38.4055 52.272 36.3014 51.259 36.3014 48.8431C36.3014 39.5699 35.2103 26.2438 35.2103 16.9706C35.2103 13.9314 37.704 12.2168 40.8991 12.2168C43.9383 12.2168 46.51 13.9311 46.51 16.9706C46.5102 26.2438 45.4192 39.5696 45.4192 48.8431Z",
                                        fill: "url(#paint3_linear_5984_47190)"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint0_linear_5984_47190",
                                                x1: "24.6242",
                                                y1: "24.6222",
                                                x2: "58.4244",
                                                y2: "58.4225",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#FF637B"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#E63950"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint1_linear_5984_47190",
                                                x1: "62.8505",
                                                y1: "50.2933",
                                                x2: "26.647",
                                                y2: "26.0601",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#E63950",
                                                        "stop-opacity": "0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.0467",
                                                        "stop-color": "#E4354B",
                                                        "stop-opacity": "0.047"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.4669",
                                                        "stop-color": "#D31822",
                                                        "stop-opacity": "0.467"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.7991",
                                                        "stop-color": "#C90709",
                                                        "stop-opacity": "0.799"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#C50000"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint2_linear_5984_47190",
                                                x1: "54.4907",
                                                y1: "74.2011",
                                                x2: "36.1085",
                                                y2: "61.5086",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#E63950",
                                                        "stop-opacity": "0"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.0467",
                                                        "stop-color": "#E4354B",
                                                        "stop-opacity": "0.047"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.4669",
                                                        "stop-color": "#D31822",
                                                        "stop-opacity": "0.467"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "0.7991",
                                                        "stop-color": "#C90709",
                                                        "stop-opacity": "0.799"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#C50000"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint3_linear_5984_47190",
                                                x1: "34.9769",
                                                y1: "40.9333",
                                                x2: "46.8997",
                                                y2: "40.9333",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#EDF5FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#D5E8FE"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "mb1-5rem c15",
                                children: "Only Microsoft business accounts are supported"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "mb1-5rem c15 fs12px px1rem op70",
                                children: "Diligentsia only supports data synchronisation with Microsoft 365 Sharepoint business accounts.  These are sometimes called \u2018Work or School\u2019 accounts by Microsoft. You may have been trying to connect to a Microsoft personal account."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $297fb5ec09626165$export$2e2bcd8739ae039), {}),
                            btnType: "warning",
                            text: "Try with Diffrent Account",
                            textClassName: "ttu",
                            customClassName: "df",
                            onClick: moveToCompanyPage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "uploadProfile",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `top-header py1rem px2rem df jcsb aic ${profileClass}`,
                            style: {
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Upload Company Logo"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc p3rem",
                            children: [
                                uploadImage == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "profile",
                                    className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs1rem fw500 tac",
                                            children: "Upload Logo"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "file",
                                                className: "",
                                                id: "profile",
                                                onChange: (e)=>handleUploadImage(e),
                                                accept: "image/jpeg, image/jpg, image/png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: "Max file size 5MB"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                        ref: $6dc8626146af9081$var$cropper,
                                        guides: false,
                                        src: uploadImage,
                                        aspectRatio: 1,
                                        className: "cropper-settings",
                                        style: {
                                            maxHeight: "500px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: ""
                                                })),
                                            className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>updateProfile(),
                                            className: `shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem`,
                                            children: Object.keys(uploadImage).length == 0 ? "Upload" : "Crop & Upload"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'showDirectors',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop showDirectors td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr maw1000px inner-showDirectors pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "c15 fw600 tac ",
                                    children: "LIST OF QUESTIONNAIRES"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tar my0-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'addDirector'
                                            })),
                                        className: "cp tac c1 bg3 br5px shadow px0-25rem py0-5rem fw500 director-add",
                                        children: "Add a Director or Senior Manager\u200B"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "table-area-showDirectors",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    id: "table",
                                    className: "table-showDirectors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "ps t0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Designation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Progress"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: directors && directors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: directors.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: `${item['headShot'] && 'df aic '} c6 fw500 ttc`,
                                                                children: [
                                                                    item['headShot'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: item['headShot']['location'],
                                                                        className: "w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem"
                                                                    }),
                                                                    item['name']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c6 fw500 ttc",
                                                                children: item['designation']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "p1rem c6 fw500 ttc",
                                                                children: [
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['completionPercent'] || 0, 'Completeness'),
                                                                    ". ",
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['riskPercent'] || 0, 'Risk')
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "df jcfs aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `#directors-questionnaire_${item['_id']}`,
                                                                        onClick: ()=>handleViewDirector(item),
                                                                        className: "cp tac px1rem py0-5rem br5px fw500",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            class: "fa fa-eye fs1-5rem c4",
                                                                            style: {
                                                                                fontSize: '22px'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        class: "cp",
                                                                        onClick: ()=>handleDeleteDirector(item),
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                fontSize: '24px',
                                                                                color: '#FC7785'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, `director-${item['_id'] || idx}`))
                                            })
                                        })
                                    ]
                                }),
                                directors && directors.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac py3rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-gradient fw600",
                                        children: "No Directors Added"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "logo-modal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h2rem",
                                        src: (parcelRequire("aR1CT")),
                                        alt: "TODO"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'showTempDirectors',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop showDirectors td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr maw1000px inner-showDirectors pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "c15 fw600 tac",
                                    children: "LIST OF QUESTIONNAIRES"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tar my0-5rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'addDirector'
                                            })),
                                        className: "cp tac c1 bg3 br5px shadow px0-25rem py0-5rem fw500 director-add",
                                        children: "Add a Director or Senior Manager"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "table-area-showDirectors",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    id: "table-temp-directors",
                                    className: "table-showDirectors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "ps t0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Designation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Progress"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        className: "c15",
                                                        children: "Action"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: directors && directors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: directors.map((item, idx)=>{
                                                    const dStats = tempDirectorStats.find((s)=>s.directorId === String(item['_id']));
                                                    const completionPct = dStats?.completionPercent || 0;
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: `${item['headShot'] && 'df aic '} c6 fw500 ttc`,
                                                                children: [
                                                                    item['headShot'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: item['headShot']['location'],
                                                                        className: "w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem"
                                                                    }),
                                                                    item['name']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c6 fw500 ttc",
                                                                children: item['designation']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "p1rem c6 fw500 ttc",
                                                                children: showPopupPercent(completionPct, 'Completeness')
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "df jcfs aic",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                        to: `#directors-questionnaire_${item['_id']}`,
                                                                        onClick: ()=>handleViewTempDirector(item),
                                                                        className: "cp tac px1rem py0-5rem br5px fw500",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "fa fa-eye fs1-5rem c4",
                                                                            style: {
                                                                                fontSize: '22px'
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        class: "cp",
                                                                        onClick: ()=>handleDeleteDirector(item),
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                fontSize: '24px',
                                                                                color: '#FC7785'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, `temp-director-${item['_id'] || idx}`);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                directors && directors.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac py3rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-gradient fw600",
                                        children: "No Directors Added"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "logo-modal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h2rem",
                                        src: (parcelRequire("aR1CT")),
                                        alt: "TODO"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "deleteDirector",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "c15 fs2rem tac lh1 fw600 mb2rem",
                        children: "DELETE DIRECTOR"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fs1rem fw500 mb1rem c15 tac w100",
                        children: [
                            "Are you sure you want to remove ",
                            selectedDirector['name'],
                            " as a Director or Senior Manager. This action cannot be reversed."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc aic gg1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                onClick: ()=>handleDeleteDirector(),
                                btnType: "warning",
                                text: "Delete Director"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                btnType: "outline",
                                text: "Cancel"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'addDirector',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "ADD DIRECTOR"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "directorName",
                                            type: "text",
                                            placeholder: "Name of Director",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 640 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                className: "fa-secondary"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            id: "directorDesignation",
                                            type: "text",
                                            placeholder: "Designation of Director",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-288C0 117.5 21.5 96 48 96h416C490.5 96 512 117.5 512 144z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M176 96H128V48C128 21.5 149.5 0 176 0h160C362.5 0 384 21.5 384 48V96h-48V48h-160V96z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    onClick: ()=>createDirector(),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "pen ml0-5rem h1rem f1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 640 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M616 200h-48v-48C568 138.8 557.3 128 544 128s-24 10.75-24 24v48h-48C458.8 200 448 210.8 448 224s10.75 24 24 24h48v48C520 309.3 530.8 320 544 320s24-10.75 24-24v-48h48C629.3 248 640 237.3 640 224S629.3 200 616 200z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3C0 496.5 15.52 512 34.66 512h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"
                                                })
                                            ]
                                        }),
                                        "Add Director"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'showDirectors'
                                        })),
                                    className: "c3-hover td250 fs1-25rem cp",
                                    children: "Back to List of Questionaire's"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'editUser',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100  bsbb df fdc m1rem maw600px br10px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "top-header py1rem px2rem df jcsb aic",
                            style: {
                                backgroundColor: '#CBD3F980',
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: [
                                        userAction,
                                        " User"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc gg1rem px3rem py2rem mah600px oya advisor-box-content",
                            children: userAction === 'Search' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "searchEmail",
                                                name: "searchEmail",
                                                type: "email",
                                                placeholder: "Search Email",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        id: "NewUserStep",
                                        onClick: findUser,
                                        className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                        children: "Search User"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userFirstName",
                                                name: "firstName",
                                                type: "text",
                                                placeholder: "First Name",
                                                onChange: handleUserChange,
                                                value: editUser['firstName'] || "",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userLastName",
                                                name: "lastName",
                                                type: "text",
                                                placeholder: "Last Name",
                                                onChange: handleUserChange,
                                                value: editUser['lastName'] || "",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 640 512",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                    className: "fa-secondary"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "userEmail",
                                                name: "email",
                                                type: "email",
                                                placeholder: "Email",
                                                onChange: handleUserChange,
                                                value: editUser['email'] || "",
                                                disabled: userAction == 'Edit' || userAction == 'Add' ? true : false,
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                viewBox: "0 0 512 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                        className: "fa-secondary"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                        className: "fa-primary"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "designation",
                                                name: "designation",
                                                type: "text",
                                                placeholder: "Job Title",
                                                className: "pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem",
                                                onChange: handleUserChange,
                                                value: editUser['designation'] || ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 448 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H184L133.3 308.8zM314.7 308.8L264 512h149.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M176 288l32 56l-31.99 135.1L184 512h80l7.988-32.05L240 344l32-56H176zM224 0C153.3 0 96 57.25 96 128s57.25 128 128 128s128-57.25 128-128S294.8 0 224 0z"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "my1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                className: "c15 mb1rem fs1-5rem fw500",
                                                children: "Permissions"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df mt0-5rem mb1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w2rem h2rem pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            onChange: selectAllPermissions,
                                                            checked: selectAll,
                                                            id: "edituser-all-permissions",
                                                            className: "bg1 bo16 bw2px bss cp td250 w2rem h2rem br5px new-shadow",
                                                            type: "checkbox"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem fw600 mx1rem usn c15",
                                                        children: "All"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs1rem fw400 usn c15",
                                                        children: "Permissions"
                                                    })
                                                ]
                                            }),
                                            editUserTempModules.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "mt1rem",
                                                children: editUserTempModules.map((module)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "mb0-5rem bss bo16 bw1px br10px",
                                                        style: {
                                                            overflow: 'hidden'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df jcsb aic px1rem py0-75rem cp",
                                                                style: {
                                                                    background: '#f8f9fa',
                                                                    borderBottom: editUserOpenAccordions[module._id] ? '1px solid #e0e0e0' : 'none'
                                                                },
                                                                onClick: ()=>toggleEditUserAccordion(module._id),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic gg0-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "checkbox w2rem h2rem pr",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    checked: isEditUserModuleAllSelected(module),
                                                                                    onChange: (e)=>{
                                                                                        e.stopPropagation();
                                                                                        handleEditUserModuleSelectAll(e, module);
                                                                                    },
                                                                                    onClick: (e)=>e.stopPropagation(),
                                                                                    className: "bg1 bo16 bw2px bss cp td250 w2rem h2rem br5px new-shadow"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem fw600 c15",
                                                                                children: module.moduleName
                                                                            }),
                                                                            module.moduleKey && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem c15 px0-5rem py0-25rem br5px",
                                                                                style: {
                                                                                    background: '#e9ecef',
                                                                                    opacity: 0.7
                                                                                },
                                                                                children: module.moduleKey
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "16",
                                                                        height: "16",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        style: {
                                                                            transform: editUserOpenAccordions[module._id] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                            transition: 'transform 0.2s'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M6 9l6 6 6-6",
                                                                            stroke: "#505050",
                                                                            strokeWidth: "2",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            editUserOpenAccordions[module._id] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "px1rem py0-75rem df fdc gg0-5rem",
                                                                children: module.sections.map((section)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df aic",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "checkbox w2rem h2rem pr",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "checkbox",
                                                                                    id: `eu-${module._id}-${section.sectionNo}`,
                                                                                    checked: !!editUser.permissions?.[section.sectionNo],
                                                                                    onChange: (e)=>handleEditUserSectionPermission(e, section),
                                                                                    className: "bg1 bo16 bw2px bss cp td250 w2rem h2rem br5px new-shadow"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem fw600 mx1rem usn c15",
                                                                                children: section.sectionNo
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "fs0-75rem fw400 usn c15",
                                                                                children: section.sectionName
                                                                            })
                                                                        ]
                                                                    }, section.sectionNo))
                                                            })
                                                        ]
                                                    }, module._id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>saveUser(),
                                        className: "new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem",
                                        children: "Save"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })),
                                        className: "c3-hover td250 fs1-25rem cp",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '12px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b9f7071fd0c9532c$export$2e2bcd8739ae039), {
                setTabName: setTabName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "demoChecklistFlow",
                open: modal['open'] == 'demoChecklistFlow',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: isPrePopulate ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    "Completing demo checklist for you ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " to save time\u2026"
                                                ]
                                            }) : tab.endsWith("-report") ? 'Generating your workflow manager' : 'Generating your checklist report'
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar ${isPrePopulate && ` questions-progress-bar`}`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: [
                                                "This may take ",
                                                isPrePopulate ? ' couple of minutes' : ' few seconds',
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                !isPrePopulate && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pa",
                                    style: {
                                        top: '10px',
                                        right: '-345px'
                                    },
                                    children: tab.endsWith("-report") ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w80",
                                        src: (parcelRequire("3DH5F")),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w80",
                                        src: (parcelRequire("2Gkf0")),
                                        alt: ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




/* ============================================================
   Deal Management — standalone module shell.
   Mounted at /deal-management/* (see AnimatedRoutes) for direct
   URLs / deep-links. The primary entry point is now the inline tab
   inside the investor dashboard (see EmbeddedDealManagement.jsx).
   Light theme only — dark mode has been removed.
   ============================================================ */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





/* Shared route table for the Deal Management module. Paths are RELATIVE to a
   `/deal-management/*` parent route, so the same table works under the app's
   BrowserRouter (standalone route) and under the embedded MemoryRouter (dashboard
   tab). Screens navigate via BASE ('/deal-management') in helpers.js, so the parent
   segment lines up in both mounts. */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");






function $5a6055885e9b016b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                index: true,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22fc30704fa4b906$export$2e2bcd8739ae039), {
                    view: "board"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "pipeline",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22fc30704fa4b906$export$2e2bcd8739ae039), {
                    view: "board"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "pipeline/list",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22fc30704fa4b906$export$2e2bcd8739ae039), {
                    view: "list"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "dashboard",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa8e64c710ef587f$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "profile",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c00354e0b41ef16b$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "sandbox",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $777b786865917827$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "deal/:id/:step",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34688a3b5a907b47$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "deal/:id/:step/:tab",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34688a3b5a907b47$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                    to: "pipeline",
                    replace: true
                })
            })
        ]
    });
}


'use strict';
function $618f91e944784bb8$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    // Scroll to top on screen change, matching the prototype's per-render behaviour
    (0, $acw62.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "dlg-dm dlg-dm--standalone",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70637bf498997249$export$f5d03d415824e0e), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3c0860f4d138445e$export$4fd56d483b8624a4), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed10917cbad1b4e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a6055885e9b016b$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


















function $2306e3952f6c12d7$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let [company, setCompany] = (0, $acw62.useState)(companies[location.pathname.split("/").slice(-1)[0]] || {});
    (0, $acw62.useEffect)(()=>{
        getCompany();
    }, []);
    const getCompany = async ()=>{
        const companyId = location.pathname.split("/").slice(-1)[0];
        if (companyId) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}`);
            setCompany(res['body']);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "expansionpack-page py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Industry Expansion Pack",
                            subheading: "Software Development\u200B"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ma lef-img-area",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("l1H8g")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ma w100 right-text-area",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Software Development companies wishing to undertake an in depth audit of its software development structure, processes and protections.\u200B\u200B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "number-sec",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                            className: "bg5 br5px shadow",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Sections: "
                                                        }),
                                                        " 20 - I.T. Staff, Products & Services, Software Development",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "Process, Software & Services Utilised, Hardware\u200B",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "Network Infrastructure, Backup & Recovery, Documentation",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "Network Security, Cybersecurity",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "Compliance, Agreements, Quality",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "Financial"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Questions: "
                                                        }),
                                                        " `100"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "AI Generated Company Specific Questions included? "
                                                        }),
                                                        " Yes/No"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "about-img",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-box bg5 br5px shadow",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "\u201CThis type of exercise is often undertaken following a problem such as a data breach or systems implosion which can represent an existential risk to the organisation.  Doing it advance significantly reduces the chances of these things happening in the first place\u201D  Paul Smith,, CTO,\u200B"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "boost-sec bg-gradient c1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg2rem gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("5g3Sv")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb py4rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "fds c1 fs2rem tac",
                                    children: [
                                        "Save the costs of external",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fds ",
                                            children: "consultants\u2026"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic py4rem",
                                children: loggedIn ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: !company?.['expensions']?.['DEPN004'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'payment'
                                            })),
                                        style: {
                                            padding: '15px',
                                            position: 'relative'
                                        },
                                        className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                        children: [
                                            "One off purchase \u2013 BUY NOW!",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "tooltip-btn",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa3 500"
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("LogIn to - BUY NOW!"),
                                    style: {
                                        padding: '15px',
                                        position: 'relative'
                                    },
                                    className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                    children: [
                                        "One off purchase \u2013 BUY NOW!",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tooltip-btn",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\xa3 500"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "benfits-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Benefits"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("5k6Ll")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Enhanced process efficiency:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Completing a comprehensive software development evaluation checklist can help a company identify inefficiencies and areas for improvement in its processes and procedures. This can lead to more streamlined workflows, increased productivity, and ultimately higher-quality software."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("82L9j")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Improved risk management:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "A thorough evaluation of software development processes and procedures can help a company uncover potential risks and vulnerabilities. By addressing these issues proactively, the company can mitigate the likelihood of costly errors, delays, or security breaches."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("8F1Ms")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Increased scalability:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "By evaluating and optimizing software development processes, a company can better prepare for future growth. Efficient, well-documented processes are more easily scalable, allowing the company to handle increased demand and expand its operations seamlessly."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("jTIek")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Attractiveness to investors:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "A company that demonstrates a strong commitment to best practices in software development is more likely to attract external investment. By completing a 100-question evaluation checklist, the company can showcase its adherence to industry standards, giving potential investors confidence in its ability to deliver high-quality products and services."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("cRc7X")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Team alignment and collaboration:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Working through a comprehensive evaluation checklist can help ensure that all team members are on the same page regarding the company's software development processes and procedures. This can foster better communication, collaboration, and a shared understanding of expectations, leading to a more cohesive and effective team."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("4YzyZ")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Competitive advantage:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "A company that has thoroughly evaluated and optimized its software development processes is more likely to produce high-quality, innovative products and services. This can give the company a competitive edge in the market, helping it to stand out among competitors and attract customers or clients."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modal-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h5rem",
                                src: (parcelRequire("eHMrP")),
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Share Capital and Authority"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Business Plan"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Management Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Properties"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Assets,Debt & Stock"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Employment and Consultancy Arrangements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Records & Registers"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Group Structure"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Borrowings & Facilities"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Information"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Events Since The Accounts Date"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Litigation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Intellectual Property"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Contracts with Connected Persons"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Statutory & Legal Requirements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Insurance"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Agreements & Captial Commitments"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Social Obligations"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8434b9dd21e99392$export$2e2bcd8739ae039), {
                user: user,
                company: company,
                showExpension: 'DEPN004'
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

















function $e0b9224e21e310b1$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let [company, setCompany] = (0, $acw62.useState)(companies[location.pathname.split("/").slice(-1)[0]] || {});
    (0, $acw62.useEffect)(()=>{
        getCompany();
    }, []);
    const getCompany = async ()=>{
        const companyId = location.pathname.split("/").slice(-1)[0];
        if (companyId) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}`);
            setCompany(res['body']);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "expansionpack-page py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Expansion Pack",
                            subheading: "Warranty Disclosure Schedule\u200B"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ma lef-img-area",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("l1H8g")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ma w100 right-text-area",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Any company looking to raise investment or exit.  Investors and purchasers will require warranties fro m the management/shareholders.  This process typically takes weeks if left to the end of the transaction and can cost \xa320,000+ if undertaken by lawyers.  By completing this module in advance of the transaction not only will you speed it up and save money on lawyers, you will also identify \u201Cblocking\u201D issues and resolve them ahead of time.  You will also increase investor interest if you can disclose that you have undertaken this exericise and can demonstrate no blocking issues.  This version follows the UK British Venture Capital Association  standard schedule. \u200B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "number-sec",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                            className: "bg5 br5px shadow",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Sections: "
                                                        }),
                                                        " 20"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Questions: "
                                                        }),
                                                        " 100"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "AI Generated Company Specific Questions included? "
                                                        }),
                                                        " Yes/No"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Benefit: "
                                                        }),
                                                        " Working though these questions will strengthen the business, identify weaknesses,  and giving you an opportunity to plug them prior to being subject to due diligence over a key area of your business"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "about-img",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "img-box",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "br5px",
                                                    src: (parcelRequire("eYpf8")),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "text-box bg5 br5px shadow",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "\u201CCompleting  Diligentsia\u2019s warranty disclosure schedule at the start of my transaction rather than the end  saved us weeks of time in determining whether our sale would complete.  A must for companies looking for funding or to exit\u201D"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: "Ted Bechman, CEO, The Income Group Limited"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "boost-sec bg-gradient c1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg2rem gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("5g3Sv")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb py4rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "fds c1 fs2rem tac",
                                    children: [
                                        "Boost your Diligentsia",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fds ",
                                            children: "Certification Score..."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic py4rem",
                                children: loggedIn ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: !company?.['expensions']?.['DEPF006'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'payment'
                                            })),
                                        style: {
                                            padding: '15px',
                                            position: 'relative'
                                        },
                                        className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                        children: [
                                            "One off purchase \u2013 BUY NOW!",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "tooltip-btn",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa3 500"
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("LogIn to - BUY NOW!"),
                                    style: {
                                        padding: '15px',
                                        position: 'relative'
                                    },
                                    className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                    children: [
                                        "One off purchase \u2013 BUY NOW!",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tooltip-btn",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\xa3 500"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "benfits-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Benefits"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("5k6Ll")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Streamlined due diligence process:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        "Completing the",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "British Venture Capital Association (BVCA) warranty disclosure schedule in advance enables a faster and smoother due diligence process. It helps demonstrate to potential investors that the company has thoroughly assessed its business and is well-prepared for investment discussions."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("82L9j")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Enhanced credibility and trust:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        "CBy proactively completing the BVCA",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "warranty disclosure schedule, the company demonstrates a high level of professionalism and transparency. This can help build trust and credibility with potential inves    rities, such as refining the business plan, rather than scrambling to provide documentation and information at the last minute.\u200B"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("8F1Ms")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Increased likelihood of successful investment:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        "Completing the Overall, a company that has completed its own BVCA warranty disclosure schedule in advance demonstrates a higher level of preparedness and commitment to the investment process. This can make the ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "company more attractive to investors, ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "ultimately increasing the likelihood ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        "of securing the desired external investment for investment discussions."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modal-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h5rem",
                                src: (parcelRequire("eHMrP")),
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Share Capital and Authority"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Business Plan"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Management Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Properties"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Assets,Debt & Stock"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Employment and Consultancy Arrangements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Records & Registers"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Group Structure"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Borrowings & Facilities"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Information"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Events Since The Accounts Date"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Litigation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Intellectual Property"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Contracts with Connected Persons"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Statutory & Legal Requirements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Insurance"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Agreements & Captial Commitments"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Social Obligations"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8434b9dd21e99392$export$2e2bcd8739ae039), {
                user: user,
                company: company,
                showExpension: 'DEPF006'
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




















function $84d216fb247af9d4$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let [company, setCompany] = (0, $acw62.useState)(companies[location.pathname.split("/").slice(-1)[0]] || {});
    (0, $acw62.useEffect)(()=>{
        getCompany();
    }, []);
    const getCompany = async ()=>{
        const companyId = location.pathname.split("/").slice(-1)[0];
        if (companyId) {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}`);
            setCompany(res['body']);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "expansionpack-page py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Expansion Pack \u2013 DD \u2013",
                            subheading: "Director's Questionnaire"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ma lef-img-area",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("l1H8g")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ma w100 right-text-area",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Any company needing to demonstrate that they  are well-prepared for third party referencing in due diligence on their Directors on investment or exit. \u200B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "number-sec",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                            className: "bg5 br5px shadow",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Sections: "
                                                        }),
                                                        " 4"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Questions: "
                                                        }),
                                                        " 20"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "AI Generated Company Specific Questions included? "
                                                        }),
                                                        " No"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Benefit: "
                                                        }),
                                                        " This module automates the process of obtaining and collating and storing questionnaires via an automated process, and automatically adds the reports to the Data Repository by sending to Directors (and senior mangers if required) and shareholders,  a quick questionnaire to fill in in relation to their dealings with your business.  This enables you to identify blocking issues early, and once completed you can show at the start of the diligence process to demonstrate your company\u2019s good standing amongst its stakeholders."
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "about-img",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "img-box",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "br5px",
                                                    src: (parcelRequire("eYpf8")),
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "text-box bg5 br5px shadow",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "\u201C\u201CInvestors invest in people.  Having Directors\u2019 Questionnaires completed early in the diligence process saves time and ticks off another uncertainty\u201D.  James Ross, CEO\u200B"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "boost-sec bg-gradient c1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg2rem gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("5g3Sv")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb py4rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "fds c1 fs2rem tac",
                                    children: [
                                        "Boost your Diligentsia",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fds ",
                                            children: "certification score\u2026\u200B"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic py4rem",
                                children: loggedIn ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: !company?.['expensions']?.['DEPF007'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'payment'
                                            })),
                                        style: {
                                            padding: '15px',
                                            position: 'relative'
                                        },
                                        className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                        children: [
                                            "One off purchase \u2013 BUY NOW!",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "tooltip-btn",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "\xa3 500"
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>(0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("LogIn to - BUY NOW!"),
                                    style: {
                                        padding: '15px',
                                        position: 'relative'
                                    },
                                    className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                    children: [
                                        "One off purchase \u2013 BUY NOW!",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tooltip-btn",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\xa3 500"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "benfits-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Benefits"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("5k6Ll")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Identification of Potential Conflicts of Interest:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Directors Questionnaires can help identify any potential conflicts of interest at the beginning of the due diligence process. This allows time for the company to evaluate and mitigate these risks before they become more significant issues.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("82L9j")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Clear Understanding of Roles and Responsibilities:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "The questionnaire can ensure that each director understands their role and responsibilities in the company. This understanding helps align the management team and promotes a shared vision for the company.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("8F1Ms")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Promotes Transparency:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Having directors fill out the questionnaire at the beginning of the due diligence process promotes transparency and trust. It shows potential investors that the company has nothing to hide and is confident in its operations and management.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("jTIek")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Prevents Delays:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Having this information at the beginning of the process can help prevent delays later on. For instance, if a potential issue is discovered towards the end of due diligence, it could cause a significant delay or even derail the entire process. Completing the questionnaire early can help identify such issues and provide time to address them."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("cRc7X")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Regulatory Compliance:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Depending on the jurisdiction, directors may be legally required to disclose certain information. Filling out the questionnaire at the start of due diligence helps ensure that the company is in compliance with these regulations."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("4YzyZ")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Better Preparation for Potential Challenges:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "The information collected from the questionnaire can help the company better prepare for potential challenges or difficult questions that may arise during the due diligence process. This preparation can result in a smoother, more efficient process and increase the likelihood of a successful outcome."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modal-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h5rem",
                                src: (parcelRequire("eHMrP")),
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dg gg2rem gtcr",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df tac  fdc",
                                style: {
                                    padding: '0 25px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                        children: "Personal"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                        children: "Occupational"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                        children: "Personal Financial"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                        children: "Litigation, Disputes & Proceedings"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8434b9dd21e99392$export$2e2bcd8739ae039), {
                user: user,
                company: company,
                showExpension: 'DEPF007'
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $6u4NZ = parcelRequire("6u4NZ");
function $bd0345cd00b1f91a$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const urlSearchData = (searchString)=>{
        if (!searchString) return {};
        return searchString.substring(1).split('&').reduce((result, next)=>{
            let pair = next.split('=');
            result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            return result;
        }, {});
    };
    const parseState = (state)=>{
        if (state.length > 25) {
            const decode = (0, (/*@__PURE__*/$parcel$interopDefault($6u4NZ))).decode(state);
            return decode.split("==");
        }
        return [
            state,
            ""
        ];
    };
    // useEffect(() => {
    let { code: code, state: state, client_info: client_info } = urlSearchData(location['search']);
    let [companyId, verifier] = parseState(state);
    const newProps = {};
    newProps['isCallback'] = true;
    if (location.pathname.includes('gDriveCallBack')) {
        newProps['storageId'] = 'GDrive';
        newProps['storageName'] = 'Google Drive';
    } else if (location.pathname.includes('dropBoxCallBack')) {
        newProps['storageId'] = 'dropbox';
        newProps['storageName'] = 'Dropbox';
    } else if (location.pathname.includes('sharePointCallBack')) {
        newProps['storageId'] = 'sharepoint';
        newProps['storageName'] = 'SharePoint';
    } else newProps['isCallback'] = false;
    newProps['code'] = code;
    newProps['companyId'] = companyId;
    newProps['client_info'] = client_info;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3ceb5821786f07$export$2e2bcd8739ae039), {
        ...newProps
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");





var $acw62 = parcelRequire("acw62");







var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");




var $acw62 = parcelRequire("acw62");






const $b40dd314a65fd52f$var$PlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "30px",
        height: "30px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#4A67FF",
                d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M21,14h6v20h-6V14z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M14,21h20v6H14V21z"
            })
        ]
    });
};
const $b40dd314a65fd52f$var$DisablePlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                "clip-path": "url(#clip0_2037_11597)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M14 0C6.28009 0 0 6.28009 0 14C0 21.7199 6.28009 28 14 28C21.7199 28 28 21.7199 28 14C28 6.28009 21.7199 0 14 0Z",
                        fill: "#CECECE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.1229 15.1652H15.1645V20.1236C15.1645 20.7677 14.642 21.2902 13.9979 21.2902C13.3538 21.2902 12.8313 20.7677 12.8313 20.1236V15.1652H7.87289C7.22882 15.1652 6.7063 14.6427 6.7063 13.9986C6.7063 13.3546 7.22882 12.832 7.87289 12.832H12.8313V7.87363C12.8313 7.22955 13.3538 6.70703 13.9979 6.70703C14.642 6.70703 15.1645 7.22955 15.1645 7.87363V12.832H20.1229C20.767 12.832 21.2895 13.3546 21.2895 13.9986C21.2895 14.6427 20.767 15.1652 20.1229 15.1652Z",
                        fill: "#FAFAFA"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_2037_11597",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "28",
                        height: "28",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
function $b40dd314a65fd52f$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `investor-tabpanel-${index}`,
        "aria-labelledby": `investor-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                p: 3
            },
            children: children
        })
    });
}























const $b40dd314a65fd52f$var$InvestorMatchCriteria = ({ company: company, setCompany: setCompany, user: user, options: options, ukRegions: ukRegions, companyContact: companyContact, setSelectedContact: setSelectedContact, investorMatchTabs: investorMatchTabs, selectedInvestorTab: selectedInvestorTab, setSelectedInvestorTab: setSelectedInvestorTab })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    // Deal Room switch — shared with the portfolio tab row on the investor dashboard.
    const dealRoom = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.dealRoom?.isOn) || false;
    // With Deal Room ON (PE), the label is the way into MorseBridge — same as on the portfolio tabs.
    const openMorsebridge = ()=>{
        if (dealRoom) window.open($16250bd714b02a14$export$3ef311402a6d1da9, "_blank", "noopener,noreferrer");
    };
    const cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [errors, setErrors] = (0, $acw62.useState)({});
    let [editInput, setEditInput] = (0, $acw62.useState)('');
    let [uploadType, setUploadType] = (0, $acw62.useState)('');
    let [auditLogList, setAuditLogList] = (0, $acw62.useState)([]);
    let [currentImage, setCurrentImage] = (0, $acw62.useState)('');
    let [quickResponse, setQuickResponse] = (0, $acw62.useState)('');
    let [passwordType, setPasswordType] = (0, $acw62.useState)(true);
    let [isImageModal, setIsImageModal] = (0, $acw62.useState)(false);
    let [selectedStages, setSelectedStages] = (0, $acw62.useState)([]);
    let [selectedSectors, setSelectedSectors] = (0, $acw62.useState)([]);
    let [selectedUKRegions, setSelectedUKRegions] = (0, $acw62.useState)({});
    let [quickResponseList, setQuickResponseList] = (0, $acw62.useState)([]);
    let [isSettingsChanged, setSettingsChanged] = (0, $acw62.useState)(false);
    let [updateSettingsData, setUpdateSettingsData] = (0, $acw62.useState)({});
    let [contactDetail, setContactDetail] = (0, $acw62.useState)({
        profilePicture: '',
        firstName: '',
        lastName: '',
        designation: '',
        location: '',
        email: '',
        phone: '',
        linkedIn: '',
        password: '',
        confirmPassword: '',
        bio: '',
        isMainRecipient: false
    });
    let applicantPreparednessTwo = [
        {
            img: (parcelRequire("54Tzx")),
            title: 'Ignore Certification',
            certificationLevel: 'None',
            subTitle: 'You will receive undiligenced matches'
        },
        {
            img: (parcelRequire("k9drL")),
            title: 'At Least Bronze Certified',
            certificationLevel: 'Bronze',
            subTitle: 'Unaudited Certification'
        },
        {
            img: (parcelRequire("7yGAu")),
            title: 'At Least Silver Certified',
            certificationLevel: 'Silver',
            subTitle: 'Unaudited Certification'
        },
        {
            img: (parcelRequire("hnx8c")),
            title: 'At Least Gold Certified',
            certificationLevel: 'Gold',
            subTitle: 'Unaudited Certification'
        }
    ];
    let errorStyles = {
        errorBorder: {
            border: '1px solid #ff0000',
            borderRadius: selectedInvestorTab == 'Objective Criteria' ? '30px' : '10px'
        },
        errorText: {
            color: '#ff0000',
            fontSize: '0.75rem',
            marginTop: '0.25rem'
        }
    };
    let auditLogKeys = {
        cWebsite: 'Company Website',
        cPhone: 'Company Phone',
        cAddress: 'Company Address',
        companyEmail: 'Company Email',
        employees: 'Company Employees',
        fundSize: 'Funds Available',
        noOfInvestments: 'No. of Investments',
        lastInvestmentDate: 'Date of Last Investment',
        preferredSectors: 'Preferred Sectors',
        stageFocus: 'Investment Stage',
        sweetSpot: 'Sweet Spot',
        annualRevenues: 'Annual Revenues',
        annualProfits: 'Annual Profits',
        ukRegions: 'UK Regions',
        companyDescription: 'Company Description',
        investmentCriteria: 'Investment Criteria',
        investmentThesis: 'Investment Thesis'
    };
    (0, $acw62.useEffect)(()=>{
        if (errors) setErrors({});
    }, [
        selectedInvestorTab
    ]);
    (0, $acw62.useEffect)(()=>{
        getInvestorCriteria();
        let tempSectors = [];
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector1']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector1'])) tempSectors.push(company['preferredSectors']['sector1']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector2']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector2'])) tempSectors.push(company['preferredSectors']['sector2']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector3']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector3'])) tempSectors.push(company['preferredSectors']['sector3']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector4']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector4'])) tempSectors.push(company['preferredSectors']['sector4']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector5']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector5'])) tempSectors.push(company['preferredSectors']['sector5']);
        setSelectedSectors(tempSectors);
        if (company && company['preferredContact']) {
            const member = company?.['members']?.find((member)=>member['_id'] === company['preferredContact']);
            setSelectedContact(member);
        }
        let tempStages = [];
        if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage1']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage1'])) tempStages.push(company['stageFocus']['stage1']);
        if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage2']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage2'])) tempStages.push(company['stageFocus']['stage2']);
        if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage3']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage3'])) tempStages.push(company['stageFocus']['stage3']);
        setSelectedStages(tempStages);
        if (company?.['ukRegions'] && Object.keys(company['ukRegions']).length > 0) setSelectedUKRegions(company['ukRegions']);
        if (company?.['quickResponses'] && company['quickResponses'].length > 0) setQuickResponseList(company['quickResponses']);
    }, [
        company
    ]);
    (0, $acw62.useEffect)(()=>{
        if (company && company['_id']) getInvestorCriteria();
    }, [
        company
    ]);
    const getInvestorCriteria = async ()=>{
        if (company && company['_id'] && !company['investorCriteria']) {
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/investor/${company['_id']}/criteria`);
            if (res && res['code'] == 200) setCompany({
                ...company,
                investorCriteria: res['body']
            });
        }
    };
    const auditLogButton = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            onClick: ()=>getSettingsLogs(`/company/adminAddEditInvestor`),
            className: "cp df jcc w200px py0-5rem bg5 br30px fs0-75rem fw500 bw1px bo16 bss mr1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "bg5 mr1rem w20px h20px df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "36",
                        height: "36",
                        viewBox: "0 0 36 36",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                            fill: "#4A67FF"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c15",
                    children: "Audit Log"
                })
            ]
        });
    };
    const getSettingsLogs = async (endpoint)=>{
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', {
            endpoint: endpoint,
            action: 'edit',
            companyId: company['_id']
        });
        if (response && response['code'] == 200) {
            await setAuditLogList(response['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'investorCriteriaAuditLogs'
            }));
        }
    };
    const uploadImage = async ()=>{
        let attachment = [];
        if (cropper.current && currentImage) {
            let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile image", {
                type: "image/png"
            });
            attachment.push(coverFile);
            setCurrentImage(imageToUpload);
            let response;
            if (uploadType == 'logo') {
                response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateLogo/${company['_id']}`, {
                    attachment: attachment
                });
                if (response || response["code"] == 200) await setCompany({
                    ...company,
                    logo: response?.['body']?.['logo']
                });
                setIsImageModal(false);
            } else {
                response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/uploadFile`, {
                    attachment: attachment
                }, true);
                if (response || response['code'] == 200) setContactDetail({
                    ...contactDetail,
                    profilePicture: response?.['body']?.['report']?.['location']
                });
                setSettingsChanged(true);
                setIsImageModal(false);
            }
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message']);
        }
    };
    const handleImage = async (e)=>{
        let image = e.target.files[0];
        if (image && image.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        image = await URL.createObjectURL(image);
        setCurrentImage(image);
    };
    const validateFields = ()=>{
        let errorsObj = {};
        // Validation for Investor Details
        if (selectedInvestorTab == 'Investor Details') {
            // Validate UK Employees
            if (!company?.['employees']?.['ukEmployees'] || company?.['employees']?.['ukEmployees'] == '') errorsObj.ukEmployees = 'Please enter number of staff in London';
            // Validate Global Employees
            if (!company?.['employees']?.['globalEmployees'] || company?.['employees']?.['globalEmployees'] == '') errorsObj.globalEmployees = 'Please enter number of staff globally';
            // Validate Fund Size
            if (!company?.['fundSize'] || company?.['fundSize'] == 'Not known') errorsObj.fundSize = 'Please select funds available for investment';
            // Validate Number of Investments
            if (!company?.['investment']?.['noOfInvestments'] || company?.['investment']?.['noOfInvestments'] == 'Not known') errorsObj.noOfInvestments = 'Please select number of investments made';
            // Validate Last Investment Date
            if (!company?.['investment']?.['lastInvestmentDate'] || company?.['investment']?.['lastInvestmentDate'] == 'Not known') errorsObj.lastInvestmentDate = 'Please select date of last investment';
        }
        // Validation for Objective Criteria
        if (selectedInvestorTab == 'Objective Criteria') {
            // Validate Sectors
            if (!selectedSectors || selectedSectors.length == 0) errorsObj.sectors = 'Please select at least one sector';
            // Validate Stages
            if (!selectedStages || selectedStages.length == 0) errorsObj.stage = 'Please select at least one stage';
            // Validate Sweet Spot
            if (!company?.['sweetSpot'] || company?.['sweetSpot'] == 'Not known') errorsObj.sweetSpot = 'Please select investment sweet spot';
            // Validate Annual Revenues
            if (!company?.['annualRevenues'] || company?.['annualRevenues'] == 'Not known') errorsObj.annualRevenues = 'Please select minimum annual revenues';
            // Validate Annual Profits
            if (!company?.['annualProfits'] || company?.['annualProfits'] == 'Not known') errorsObj.annualProfits = 'Please select minimum annual profits';
            // Validate UK Regions
            if (!selectedUKRegions || Object.keys(selectedUKRegions).length == 0) errorsObj.ukRegions = 'Please select at least one region';
        }
        // Validation for Contact Details
        if (selectedInvestorTab == 'Contact Details') {
            let requiredFields = [
                {
                    firstName: 'first name'
                },
                {
                    lastName: 'last name'
                },
                {
                    email: 'email'
                },
                {
                    phone: 'phone'
                },
                {
                    linkedIn: 'linkedIn'
                },
                {
                    password: 'password'
                },
                {
                    confirmPassword: 'confirm password'
                }
            ];
            requiredFields.forEach((field)=>{
                let key = Object.keys(field)[0];
                let value = Object.values(field)[0];
                if (!contactDetail[key] || contactDetail[key] == '') errorsObj[key] = `Please enter ${value}`;
            });
        }
        setErrors(errorsObj);
        return Object.keys(errorsObj).length == 0;
    };
    const handleValueChange = (event)=>{
        const { name: name, value: value } = event.target;
        // Clear error when field is changed
        if (errors[name]) setErrors((prev)=>{
            let newErrors = {
                ...prev
            };
            delete newErrors[name];
            return newErrors;
        });
        if (name === 'ukEmployees' || name === 'globalEmployees') {
            setUpdateSettingsData({
                ...updateSettingsData,
                employees: {
                    ...updateSettingsData['employees'],
                    [name]: value
                }
            });
            setCompany({
                ...company,
                employees: {
                    ...company['employees'],
                    [name]: value
                }
            });
        } else if (name === 'noOfInvestments' || name === 'lastInvestmentDate') {
            setUpdateSettingsData({
                ...updateSettingsData,
                [name]: value
            });
            setCompany({
                ...company,
                investment: {
                    ...company['investment'],
                    [name]: value
                }
            });
        } else if (name === 'sectors') {
            if (value.length <= 5) {
                setSelectedSectors(value);
                setUpdateSettingsData({
                    ...updateSettingsData,
                    preferredSectors: `${value[0] ? value[0] : 'Not Selected'}, ${value[1] ? value[1] : 'Not Selected'}, ${value[2] ? value[2] : 'Not Selected'}, ${value[3] ? value[3] : 'Not Selected'}, ${value[4] ? value[4] : 'Not Selected'}`
                });
                setCompany({
                    ...company,
                    preferredSectors: {
                        ...company['preferredSectors'],
                        sector1: value[0] ? value[0] : 'Not Selected',
                        sector2: value[1] ? value[1] : 'Not Selected',
                        sector3: value[2] ? value[2] : 'Not Selected',
                        sector4: value[3] ? value[3] : 'Not Selected',
                        sector5: value[4] ? value[4] : 'Not Selected'
                    }
                });
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select up to 5 sectors');
        } else if (name === 'stage') {
            if (value.length <= 3) {
                setSelectedStages(value);
                setUpdateSettingsData({
                    ...updateSettingsData,
                    stageFocus: `${value[0] ? value[0] : 'Not Selected'}, ${value[1] ? value[1] : 'Not Selected'}, ${value[2] ? value[2] : 'Not Selected'}`
                });
                setCompany({
                    ...company,
                    stageFocus: {
                        ...company['stageFocus'],
                        stage1: value[0] ? value[0] : 'Not Selected',
                        stage2: value[1] ? value[1] : 'Not Selected',
                        stage3: value[2] ? value[2] : 'Not Selected'
                    }
                });
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select up to 3 stages');
        } else if (name === 'ukRegions') {
            let ukRegions = {};
            if (value.length > 0) value.map((region)=>{
                ukRegions = {
                    ...ukRegions,
                    [region]: true
                };
            });
            setSelectedUKRegions(ukRegions);
            setUpdateSettingsData({
                ...updateSettingsData,
                ukRegions: ukRegions
            });
            setCompany({
                ...company,
                ukRegions: ukRegions
            });
        } else if (name === 'isBVCA' || name === 'isSeedLegals' || name === 'isCrunchBase') {
            setUpdateSettingsData({
                ...updateSettingsData,
                [name]: !company['source'][name]
            });
            setCompany({
                ...company,
                source: {
                    ...company['source'],
                    [name]: !company['source'][name]
                }
            });
        } else {
            setUpdateSettingsData({
                ...updateSettingsData,
                [name]: value
            });
            setCompany({
                ...company,
                [name]: value
            });
        }
        setSettingsChanged(true);
    };
    const handleInvestorCriteria = async (name, value)=>{
        let investorCriteria;
        if (name == 'requireInvestmentReadiness' || name == 'requiredCertificationLevel') investorCriteria = {
            ...company['investorCriteria'],
            [name]: value
        };
        else {
            let ruleOutFilters = {
                ...company['investorCriteria']['ruleOutFilters'],
                [name]: value
            };
            investorCriteria = {
                ...company['investorCriteria'],
                ruleOutFilters: ruleOutFilters
            };
        }
        setCompany({
            ...company,
            investorCriteria: investorCriteria
        });
        setSettingsChanged(true);
    };
    const saveSettings = async ()=>{
        if (!validateFields()) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('All fields must be completed to enable a good investment match');
            return;
        }
        if (selectedInvestorTab == 'Quick Response' && quickResponseList.length == 0) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter at least one quick response');
            return;
        }
        if (selectedInvestorTab == 'Contact Details') {
            if (contactDetail['password'] != contactDetail['confirmPassword']) {
                errors['confirmPassword'] = 'Password and Confirm Password do not match';
                setErrors({
                    ...errors
                });
                return;
            }
            let data = {
                title: 'Team Member',
                email: contactDetail['email'],
                phone: contactDetail['phone'],
                linkedIn: contactDetail['linkedIn'],
                lastName: contactDetail['lastName'],
                firstName: contactDetail['firstName'],
                designation: contactDetail['designation'],
                profilePicture: contactDetail['profilePicture'],
                isMainRecipient: contactDetail['isMainRecipient'],
                action: 'add',
                permissions: {
                    D001: true,
                    D002: true,
                    D003: true,
                    D004: true,
                    D005: true,
                    D006: true,
                    D007: true,
                    D008: true,
                    D009: true,
                    D010: true,
                    D011: true,
                    D012: true,
                    D013: true,
                    D014: true,
                    D015: true,
                    D016: true,
                    D017: true,
                    D018: true,
                    D019: true,
                    D020: true,
                    DEPF005: true,
                    DEPF006: true,
                    DEPF007: true,
                    DEPN004: true
                }
            };
        } else {
            let data = {
                companyId: company['_id'],
                action: 'edit',
                investorId: company['_id'],
                investorData: company,
                contactData: companyContact
            };
            if (selectedInvestorTab == 'Quick Response') data = {
                ...data,
                quickResponses: quickResponseList
            };
            else data = {
                ...data,
                update: updateSettingsData
            };
            let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/adminAddEditInvestor`, data);
            if (response && response['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Settings saved successfully');
                setUpdateSettingsData({});
                setSettingsChanged(false);
                setErrors({});
            }
            if (selectedInvestorTab == 'Objective Criteria') {
                let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/investor/${company['_id']}/criteria`, {
                    updateData: company['investorCriteria']
                });
                if (res && res['code'] == 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            }
        }
    };
    // Investor Details
    const investorDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "form-group df mb2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-upload-area",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: company?.['logo'] || (parcelRequire("cfmAr")),
                                    alt: "Profile",
                                    style: {
                                        width: '100px',
                                        height: 'auto',
                                        borderRadius: '50px'
                                    },
                                    className: `cp c1 shadow p0-5rem ${user['role'] == 'Investor' ? 'investor-bg' : 'advisor-bg'}`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "input-file",
                                    style: {
                                        position: 'relative',
                                        left: '-5%',
                                        bottom: '-40%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "add-btn shadow",
                                        onClick: ()=>{
                                            setIsImageModal(true), setUploadType('logo'), setCurrentImage('');
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            viewBox: "0 0 487 487",
                                            className: "zi3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9 v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            class: "fs1-25rem fw500 c27 mb0-5rem",
                                            children: company['cName']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("lable", {
                                            className: "c15",
                                            children: "Company logo"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w60 df fdc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb aic mb2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "fs1-25rem c15 fw500",
                                    style: {
                                        margin: 0
                                    },
                                    children: "Company Information"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `fs1rem fw500 c15 mr0-5rem${dealRoom ? ' cp' : ''}`,
                                            onClick: openMorsebridge,
                                            title: dealRoom ? 'Open MorseBridge' : undefined,
                                            children: "Deal Room"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                            name: "dealRoom",
                                            className: "success",
                                            checked: dealRoom,
                                            onChange: ()=>dispatch((0, $0b8fb0446eadf91e$export$e1724ae90b5a8316)(!dealRoom)),
                                            // Reason: the global tooltip handler reads e.target.dataset.tooltip with no
                                            // closest() walk, so it must sit on MUI's invisible input, not a wrapper.
                                            inputProps: {
                                                'data-tooltip': dealRoom ? 'PE (Private Equity)' : 'VC (Venture Capital)',
                                                'aria-label': dealRoom ? 'PE (Private Equity)' : 'VC (Venture Capital)'
                                            }
                                        })
                                    ]
                                }),
                                auditLogButton()
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            value: company['cName'] || '-',
                            InputProps: {
                                readOnly: true,
                                style: {
                                    borderRadius: "10px",
                                    marginBottom: '8px',
                                    fontSize: '14px'
                                },
                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("5r6c6")),
                                    alt: "cName",
                                    className: "df mr1rem"
                                })
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    value: "UK Registered (Company House)",
                                    InputProps: {
                                        readOnly: true,
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("h9sGd")),
                                            alt: "cReg",
                                            className: "df mr1rem"
                                        }),
                                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-check-circle c30 mr1rem",
                                            style: {
                                                fontSize: '25px'
                                            }
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    value: company['ukRegNo'] || '-',
                                    InputProps: {
                                        readOnly: true,
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("h9sGd")),
                                            alt: "cReg",
                                            className: "df mr1rem"
                                        })
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    type: "url",
                                    name: "cWebsite",
                                    value: company['cWebsite'] || '',
                                    placeholder: "https://www.example.com",
                                    onChange: (e)=>handleValueChange(e),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("e2Yht")),
                                            alt: "cWebsite",
                                            className: "df mr1rem"
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    type: "tel",
                                    name: "cPhone",
                                    value: company['cPhone'] || '',
                                    placeholder: "0123456789",
                                    onChange: (e)=>handleValueChange(e),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("fSLCH")),
                                            alt: "cPhone",
                                            className: "df mr1rem"
                                        })
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    type: "text",
                                    name: "cAddress",
                                    value: company['cAddress'] || '',
                                    placeholder: "Company office address",
                                    onChange: (e)=>handleValueChange(e),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("kUe3E")),
                                            alt: "cAddress",
                                            className: "df mr1rem"
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    type: "email",
                                    name: "companyEmail",
                                    value: company['companyEmail'] || '',
                                    placeholder: "example@example.com",
                                    onChange: (e)=>handleValueChange(e),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("gaJU8")),
                                            alt: "cReg",
                                            className: "df mr1rem"
                                        })
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem mt0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "df fdc w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            class: "fs0-75rem fw500 c15 mb0-5rem",
                                            children: "Number of staff in home country"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            type: "number",
                                            name: "ukEmployees",
                                            value: company['employees']?.['ukEmployees'] || '',
                                            placeholder: "Number of staff in home country",
                                            onChange: (e)=>handleValueChange(e),
                                            style: errors?.['ukEmployees'] ? errorStyles['errorBorder'] : {},
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                }
                                            }
                                        }),
                                        errors?.['ukEmployees'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: "w100",
                                            style: errorStyles['errorText'],
                                            children: errors['ukEmployees']
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "df fdc w100",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            class: "fs0-75rem fw500 c15 mb0-5rem",
                                            children: "Number of staff globally"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            type: "number",
                                            name: "globalEmployees",
                                            value: company['employees']?.['globalEmployees'] || '',
                                            placeholder: "Number of staff globally",
                                            onChange: (e)=>handleValueChange(e),
                                            style: errors?.['globalEmployees'] ? errorStyles['errorBorder'] : {},
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                }
                                            }
                                        }),
                                        errors?.['globalEmployees'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: "w100",
                                            style: errorStyles['errorText'],
                                            children: errors['globalEmployees']
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "my0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    class: "fs0-75rem fw500 c15 mb0-5rem",
                                    children: "Funds available for investment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    variant: "outlined",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                            name: "fundSize",
                                            onChange: (e)=>handleValueChange(e),
                                            value: company['fundSize'] || 'Not known',
                                            placeholder: "Select funds available for investment",
                                            style: errors?.['fundSize'] ? errorStyles['errorBorder'] : {},
                                            sx: {
                                                '& .MuiSelect-select': {
                                                    borderRadius: '10px'
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '10px'
                                                }
                                            },
                                            children: options?.fundSizes?.map((fund)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                    value: fund,
                                                    children: fund
                                                }, fund))
                                        }),
                                        errors?.['fundSize'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: "w100",
                                            style: errorStyles['errorText'],
                                            children: errors['fundSize']
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    class: "fs0-75rem fw500 c15 mb0-5rem",
                                    children: "Number of investment made"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    variant: "outlined",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                            name: "noOfInvestments",
                                            onChange: (e)=>handleValueChange(e),
                                            placeholder: "Select number of investment made",
                                            style: errors?.['noOfInvestments'] ? errorStyles['errorBorder'] : {},
                                            value: company?.['investment']?.['noOfInvestments'] || 'Not known',
                                            sx: {
                                                '& .MuiSelect-select': {
                                                    borderRadius: '10px'
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '10px'
                                                }
                                            },
                                            children: options?.noOfInvestments?.map((investmentNumber)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                    value: investmentNumber,
                                                    children: investmentNumber
                                                }, investmentNumber))
                                        }),
                                        errors?.['noOfInvestments'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: "w100",
                                            style: errorStyles['errorText'],
                                            children: errors['noOfInvestments']
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    class: "fs0-75rem fw500 c15 mb0-5rem",
                                    children: "Date of last investment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    variant: "outlined",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                            name: "lastInvestmentDate",
                                            onChange: (e)=>handleValueChange(e),
                                            placeholder: "Select date of last investment",
                                            style: errors?.['lastInvestmentDate'] ? errorStyles['errorBorder'] : {},
                                            value: company?.['investment']?.['lastInvestmentDate'] || 'Not known',
                                            sx: {
                                                '& .MuiSelect-select': {
                                                    borderRadius: '10px'
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderRadius: '10px'
                                                }
                                            },
                                            children: options?.lastInvestmentDate?.map((investmentDate)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                    value: investmentDate,
                                                    children: investmentDate
                                                }, investmentDate))
                                        }),
                                        errors?.['lastInvestmentDate'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            class: "w100",
                                            style: errorStyles['errorText'],
                                            children: errors['lastInvestmentDate']
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    // Objective Criteria
    const objectiveCriteria = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "objective-criteria-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb mb2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "w100 fs1-5rem fw500 c15",
                            children: company['cName']
                        }),
                        auditLogButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jscb bg1 p2rem bw1px br15px bss bo16 mb1rem investment-criteria-box",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w50 df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "w100 fs1rem c15 fw400 mb1rem",
                                    children: "1. Is interest in applicant preparedness? - tick as required"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "w80 df jcsb bg1 p1rem bw1px br10px bss bo16 mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    class: "mr0-5rem",
                                                    src: (parcelRequire("54Tzx"))
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    class: "df fdc jcc",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "w100 fs1rem c15 fw400",
                                                            children: "Investment Readiness Checklist"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "w100 fs0-75rem c12",
                                                            children: "Completed in advance of application"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            className: "df cp fs0-75rem py1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w30px h30px pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    checked: company?.['investorCriteria']?.['requireInvestmentReadiness'],
                                                    name: "requireInvestmentReadiness",
                                                    onClick: (e)=>handleInvestorCriteria('requireInvestmentReadiness', !company?.['investorCriteria']?.['requireInvestmentReadiness']),
                                                    className: "cp bg5 bo5 bw1px bss w30px h30px br5px",
                                                    type: "radio"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w50 df aic jcfe",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                class: "",
                                src: (parcelRequire("k0W4k"))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jscb bg1 p2rem bw1px br15px bss bo16 mb1rem investment-criteria-box",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w80 df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "w100 fs1rem c15 fw400 mb1rem",
                                    children: "2. Your interest in applicant preparedness? - tick as required"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "df fww",
                                    children: applicantPreparednessTwo.map((item)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "w40 df jcsb bg1 p1rem bw1px br10px bss bo16 mb0-5rem mr0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    class: "df jcc",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            class: "mr1rem",
                                                            src: item['img']
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            class: "df fdc jcc",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "w100 fs0-75rem c15 fw400",
                                                                    children: item['title']
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "w100 fs0-75rem c12",
                                                                    children: item['subTitle']
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "df cp fs0-75rem py1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w30px h30px pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            checked: company?.['investorCriteria']?.['requiredCertificationLevel'] == item['certificationLevel'],
                                                            name: "requiredCertificationLevel",
                                                            value: item['certificationLevel'],
                                                            onChange: (e)=>handleInvestorCriteria(e.target.name, e.target.value),
                                                            className: "cp bg5 bo5 bw1px bss w30px h30px br5px",
                                                            type: "radio"
                                                        })
                                                    })
                                                })
                                            ]
                                        });
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w20 df aic jcfe",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                class: "",
                                src: (parcelRequire("bcgpJ"))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jscb bg1 p2rem bw1px br15px bss bo16 mb1rem investment-criteria-box",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w90 df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "w100 fs1-5rem fw500 c15 mb1rem",
                                    children: "INVESTMENT CRITERIA FOR APPLICANT MATCHING"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "w100 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    class: "df jcsb mb1rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "fs1rem fw500 c15 db mb0-5rem",
                                                            children: "Preferred sectors investment categories?"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            className: "fs1rem fw500 c15 db mb0-5rem",
                                                            children: [
                                                                "Rule out?",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "cp tooltip ml0-5rem",
                                                                    "data-tooltip": 'If any button set to "Green" then applicant will not be matched',
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        "data-tooltip": 'If any button set to "Green" then applicant will not be matched',
                                                                        width: "19",
                                                                        height: "19",
                                                                        viewBox: "0 0 19 19",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                "data-tooltip": 'If any button set to "Green" then applicant will not be matched',
                                                                                cx: "9.5",
                                                                                cy: "9.5",
                                                                                r: "9.5",
                                                                                transform: "matrix(1 0 0 -1 0 19)",
                                                                                fill: "#59B8FD"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                "data-tooltip": 'If any button set to "Green" then applicant will not be matched',
                                                                                d: "M8.55572 7.75264C8.56067 7.42855 8.82539 7.16878 9.14947 7.16878C9.47356 7.16878 9.73828 7.43102 9.74322 7.75264L9.94114 13.0865C9.95351 13.2894 9.87929 13.4873 9.7358 13.6407C9.58242 13.8039 9.36966 13.8979 9.14947 13.8979C8.92929 13.8979 8.71653 13.8039 8.56315 13.6407C8.41966 13.4873 8.34544 13.2894 8.35781 13.0865L8.55572 7.75264Z",
                                                                                fill: "white"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                "data-tooltip": 'If any button set to "Green" then applicant will not be matched',
                                                                                d: "M9.14814 4.39811C9.58537 4.39811 9.93981 4.75255 9.93981 5.18978C9.93981 5.627 9.58537 5.98145 9.14814 5.98145C8.71092 5.98145 8.35648 5.627 8.35648 5.18978C8.35648 4.75255 8.71092 4.39811 9.14814 4.39811Z",
                                                                                fill: "white"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            variant: "outlined",
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: [
                                                                selectedSectors.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                                                    id: "multi-select-label",
                                                                    children: "Select sectors"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    multiple: true,
                                                                    name: "sectors",
                                                                    value: selectedSectors || [],
                                                                    onChange: (e)=>handleValueChange(e),
                                                                    renderValue: (selected)=>selected.length > 0 ? selected.join(', ') : 'Select sectors',
                                                                    style: errors?.['sectors'] ? errorStyles['errorBorder'] : {},
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            borderRadius: '30px'
                                                                        }
                                                                    },
                                                                    children: options?.sectors?.map((sector)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: sector,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                    checked: selectedSectors.includes(sector)
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                    primary: sector
                                                                                })
                                                                            ]
                                                                        }, sector))
                                                                }),
                                                                errors?.['sectors'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    class: "w100 ml1-5rem",
                                                                    style: errorStyles['errorText'],
                                                                    children: errors['sectors']
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                            name: "sectors",
                                                            checked: company?.['investorCriteria']?.['ruleOutFilters']?.['sectors'],
                                                            onChange: (e)=>handleInvestorCriteria(e.target.name, e.target.checked),
                                                            sx: {
                                                                ml: 3,
                                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                                    color: '#15D757'
                                                                },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                    backgroundColor: '#15D757'
                                                                }
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem fw500 c15 db mb0-5rem",
                                                    children: "Preferred investment stage?"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            variant: "outlined",
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: [
                                                                selectedStages.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                                                    id: "multi-select-label",
                                                                    children: "Select stages"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    multiple: true,
                                                                    name: "stage",
                                                                    value: selectedStages || [],
                                                                    onChange: (e)=>handleValueChange(e),
                                                                    renderValue: (selected)=>selected.length > 0 ? selected.join(', ') : 'Select stages',
                                                                    style: errors?.['stage'] ? errorStyles['errorBorder'] : {},
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            borderRadius: '30px'
                                                                        }
                                                                    },
                                                                    children: options?.stages?.map((stage)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: stage,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                    checked: selectedStages.includes(stage)
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                    primary: stage
                                                                                })
                                                                            ]
                                                                        }, stage))
                                                                }),
                                                                errors?.['stage'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    class: "w100 ml1-5rem",
                                                                    style: errorStyles['errorText'],
                                                                    children: errors['stage']
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                            name: "stage",
                                                            checked: company?.['investorCriteria']?.['ruleOutFilters']?.['stage'],
                                                            onChange: (e)=>handleInvestorCriteria(e.target.name, e.target.checked),
                                                            sx: {
                                                                ml: 3,
                                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                                    color: '#15D757'
                                                                },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                    backgroundColor: '#15D757'
                                                                }
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem fw500 c15 db mb0-5rem",
                                                    children: "Investment sweet spot?"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            variant: "outlined",
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    name: "sweetSpot",
                                                                    value: company?.sweetSpot || '',
                                                                    onChange: (e)=>handleValueChange(e),
                                                                    style: errors?.['sweetSpot'] ? errorStyles['errorBorder'] : {},
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            borderRadius: '30px'
                                                                        }
                                                                    },
                                                                    children: options?.sweetSpots?.map((spot)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: spot,
                                                                            children: spot
                                                                        }, spot))
                                                                }),
                                                                errors?.['sweetSpot'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    class: "w100 ml1-5rem",
                                                                    style: errorStyles['errorText'],
                                                                    children: errors['sweetSpot']
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                            name: "sweetSpot",
                                                            checked: company?.['investorCriteria']?.['ruleOutFilters']?.['sweetSpot'],
                                                            onChange: (e)=>handleInvestorCriteria(e.target.name, e.target.checked),
                                                            sx: {
                                                                ml: 3,
                                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                                    color: '#15D757'
                                                                },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                    backgroundColor: '#15D757'
                                                                }
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem fw500 c15 db mb0-5rem",
                                                    children: "Minimum annual revenues current year"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            variant: "outlined",
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    name: "annualRevenues",
                                                                    value: company?.annualRevenues || '',
                                                                    onChange: (e)=>handleValueChange(e),
                                                                    style: errors?.['annualRevenues'] ? errorStyles['errorBorder'] : {},
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            borderRadius: '30px'
                                                                        }
                                                                    },
                                                                    children: options?.revenues?.map((revenue)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: revenue,
                                                                            children: revenue
                                                                        }, revenue))
                                                                }),
                                                                errors?.['annualRevenues'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    class: "w100 ml1-5rem",
                                                                    style: errorStyles['errorText'],
                                                                    children: errors['annualRevenues']
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                            name: "annualRevenues",
                                                            checked: company?.['investorCriteria']?.['ruleOutFilters']?.['annualRevenues'],
                                                            onChange: (e)=>handleInvestorCriteria(e.target.name, e.target.checked),
                                                            sx: {
                                                                ml: 3,
                                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                                    color: '#15D757'
                                                                },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                    backgroundColor: '#15D757'
                                                                }
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem fw500 c15 db mb0-5rem",
                                                    children: "Minimum annual profit current year"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            variant: "outlined",
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    name: "annualProfits",
                                                                    value: company?.annualProfits || '',
                                                                    onChange: (e)=>handleValueChange(e),
                                                                    style: errors?.['annualProfits'] ? errorStyles['errorBorder'] : {},
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            borderRadius: '30px'
                                                                        }
                                                                    },
                                                                    children: options?.profits?.map((profit)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: profit,
                                                                            children: profit
                                                                        }, profit))
                                                                }),
                                                                errors?.['annualProfits'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    class: "w100 ml1-5rem",
                                                                    style: errorStyles['errorText'],
                                                                    children: errors['annualProfits']
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                            name: "annualProfits",
                                                            checked: company?.['investorCriteria']?.['ruleOutFilters']?.['annualProfits'],
                                                            onChange: (e)=>handleInvestorCriteria(e.target.name, e.target.checked),
                                                            sx: {
                                                                ml: 3,
                                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                                    color: '#15D757'
                                                                },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                    backgroundColor: '#15D757'
                                                                }
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w50 mb1rem ",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "fs1rem fw500 c15 db mb0-5rem",
                                                    children: "Preferred regions?"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bcd22a386c6068c0$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            variant: "outlined",
                                                            sx: {
                                                                flex: 1
                                                            },
                                                            children: [
                                                                Object.keys(selectedUKRegions).length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09846a8ab0aba36e$export$2e2bcd8739ae039), {
                                                                    id: "multi-select-label",
                                                                    children: "Select regions"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                    multiple: true,
                                                                    name: "ukRegions",
                                                                    value: Object.keys(selectedUKRegions) || [],
                                                                    onChange: (e)=>handleValueChange(e),
                                                                    renderValue: (selected)=>selected.length > 0 ? selected.join(', ') : 'Select regions',
                                                                    style: errors?.['ukRegions'] ? errorStyles['errorBorder'] : {},
                                                                    sx: {
                                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                                            borderRadius: '30px'
                                                                        }
                                                                    },
                                                                    children: ukRegions?.map((region)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                            value: region,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                    checked: !!selectedUKRegions[region]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                    primary: region
                                                                                })
                                                                            ]
                                                                        }, region))
                                                                }),
                                                                errors?.['ukRegions'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    class: "w100 ml1-5rem",
                                                                    style: errorStyles['errorText'],
                                                                    children: errors['ukRegions']
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                            name: "regions",
                                                            checked: company?.['investorCriteria']?.['ruleOutFilters']?.['regions'],
                                                            onChange: (e)=>handleInvestorCriteria(e.target.name, e.target.checked),
                                                            sx: {
                                                                ml: 3,
                                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                                    color: '#15D757'
                                                                },
                                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                    backgroundColor: '#15D757'
                                                                }
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w10 df aifs jcfe mt2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                class: "",
                                src: (parcelRequire("5oLQF"))
                            })
                        })
                    ]
                })
            ]
        });
    };
    // Subjective Criteria
    const subjectiveCriteria = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "objective-criteria-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb mb2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "w100 fs1-5rem fw500 c15",
                            children: "SUBJECTIVE CRITERIA"
                        }),
                        auditLogButton()
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "heading-edit-area df aic mb0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mr0-5rem fs1rem fw400 c15",
                            children: "Firm Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "edit-icon cb bg0 br0 cp",
                            onClick: ()=>editInput === 'companyDescription' ? setEditInput('') : setEditInput('companyDescription'),
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_2226_15296)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.5 8.24951C16.3011 8.24951 16.1103 8.32853 15.9697 8.46918C15.829 8.60983 15.75 8.8006 15.75 8.99951V13.4995C15.75 14.0962 15.5129 14.6685 15.091 15.0905C14.669 15.5125 14.0967 15.7495 13.5 15.7495H4.5C3.90326 15.7495 3.33097 15.5125 2.90901 15.0905C2.48705 14.6685 2.25 14.0962 2.25 13.4995V4.49951C2.25 3.90277 2.48705 3.33048 2.90901 2.90852C3.33097 2.48656 3.90326 2.24951 4.5 2.24951H9C9.19891 2.24951 9.38968 2.17049 9.53033 2.02984C9.67098 1.88919 9.75 1.69842 9.75 1.49951C9.75 1.3006 9.67098 1.10983 9.53033 0.969182C9.38968 0.828529 9.19891 0.749512 9 0.749512H4.5C4.00754 0.749512 3.51991 0.846508 3.06494 1.03496C2.60997 1.22342 2.19657 1.49964 1.84835 1.84786C1.14509 2.55112 0.75 3.50495 0.75 4.49951V13.4995C0.75 13.992 0.846997 14.4796 1.03545 14.9346C1.22391 15.3895 1.50013 15.8029 1.84835 16.1512C2.55161 16.8544 3.50544 17.2495 4.5 17.2495H13.5C13.9925 17.2495 14.4801 17.1525 14.9351 16.9641C15.39 16.7756 15.8034 16.4994 16.1517 16.1512C16.4999 15.8029 16.7761 15.3895 16.9645 14.9346C17.153 14.4796 17.25 13.992 17.25 13.4995V8.99951C17.25 8.8006 17.171 8.60983 17.0303 8.46918C16.8897 8.32853 16.6989 8.24951 16.5 8.24951Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M5.91001 7.84482C5.70012 8.05445 5.53376 8.3035 5.42049 8.57767C5.30722 8.85183 5.24928 9.14568 5.25001 9.44232V10.4998C5.25001 11.0966 5.48706 11.6689 5.90902 12.0908C6.33097 12.5128 6.90327 12.7498 7.50001 12.7498H8.55751C8.85415 12.7505 9.148 12.6926 9.42216 12.5793C9.69632 12.4661 9.94538 12.2997 10.155 12.0898L16.59 5.65482C16.7998 5.44579 16.9662 5.1974 17.0798 4.92391C17.1933 4.65042 17.2518 4.3572 17.2518 4.06107C17.2518 3.76494 17.1933 3.47172 17.0798 3.19823C16.9662 2.92474 16.7998 2.67635 16.59 2.46732L15.5325 1.40982C15.3235 1.20006 15.0751 1.03363 14.8016 0.920066C14.5281 0.806504 14.2349 0.748047 13.9388 0.748047C13.6426 0.748047 13.3494 0.806504 13.0759 0.920066C12.8024 1.03363 12.554 1.20006 12.345 1.40982L5.91001 7.84482ZM14.4675 2.46732L15.5325 3.53232C15.6722 3.67284 15.7506 3.86293 15.7506 4.06107C15.7506 4.25921 15.6722 4.4493 15.5325 4.58982L14.8875 5.24982L12.75 3.11232L13.395 2.46732C13.4649 2.39589 13.5483 2.33913 13.6404 2.30038C13.7324 2.26163 13.8313 2.24166 13.9313 2.24166C14.0312 2.24166 14.1301 2.26163 14.2222 2.30038C14.3142 2.33913 14.3977 2.39589 14.4675 2.46732ZM6.75001 9.44232C6.74944 9.34362 6.76836 9.24577 6.80568 9.15439C6.843 9.06301 6.898 8.9799 6.96751 8.90982L11.7 4.17732L13.8225 6.29982L9.09001 11.0323C9.01993 11.1018 8.93681 11.1568 8.84544 11.1941C8.75406 11.2315 8.65621 11.2504 8.55751 11.2498H7.50001C7.30109 11.2498 7.11033 11.1708 6.96968 11.0302C6.82902 10.8895 6.75001 10.6987 6.75001 10.4998V9.44232Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_2226_15296",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "18",
                                                height: "18",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "group-inputs",
                        style: {
                            minHeight: '10vh'
                        },
                        children: editInput === 'companyDescription' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac p0rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                rows: 10,
                                className: `c15 fs0-75rem w100`,
                                name: "companyDescription",
                                placeholder: "Please add at least 500 characters for this field to be complete",
                                defaultValue: company?.['companyDescription'],
                                onBlur: (e)=>{
                                    handleValueChange(e), setEditInput('');
                                },
                                onChange: (e)=>handleValueChange(e)
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            onClick: ()=>setEditInput('companyDescription'),
                            className: "c15 fs0-75rem",
                            children: company['companyDescription'] || 'Enter the Company Description here...'
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "heading-edit-area df aic mb0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mr0-5rem fs1rem fw400 c15",
                            children: "Firm Investment Criteria"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "edit-icon cb bg0 br0 cp",
                            onClick: ()=>editInput === 'investmentCriteria' ? setEditInput('') : setEditInput('investmentCriteria'),
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_2226_15296)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.5 8.24951C16.3011 8.24951 16.1103 8.32853 15.9697 8.46918C15.829 8.60983 15.75 8.8006 15.75 8.99951V13.4995C15.75 14.0962 15.5129 14.6685 15.091 15.0905C14.669 15.5125 14.0967 15.7495 13.5 15.7495H4.5C3.90326 15.7495 3.33097 15.5125 2.90901 15.0905C2.48705 14.6685 2.25 14.0962 2.25 13.4995V4.49951C2.25 3.90277 2.48705 3.33048 2.90901 2.90852C3.33097 2.48656 3.90326 2.24951 4.5 2.24951H9C9.19891 2.24951 9.38968 2.17049 9.53033 2.02984C9.67098 1.88919 9.75 1.69842 9.75 1.49951C9.75 1.3006 9.67098 1.10983 9.53033 0.969182C9.38968 0.828529 9.19891 0.749512 9 0.749512H4.5C4.00754 0.749512 3.51991 0.846508 3.06494 1.03496C2.60997 1.22342 2.19657 1.49964 1.84835 1.84786C1.14509 2.55112 0.75 3.50495 0.75 4.49951V13.4995C0.75 13.992 0.846997 14.4796 1.03545 14.9346C1.22391 15.3895 1.50013 15.8029 1.84835 16.1512C2.55161 16.8544 3.50544 17.2495 4.5 17.2495H13.5C13.9925 17.2495 14.4801 17.1525 14.9351 16.9641C15.39 16.7756 15.8034 16.4994 16.1517 16.1512C16.4999 15.8029 16.7761 15.3895 16.9645 14.9346C17.153 14.4796 17.25 13.992 17.25 13.4995V8.99951C17.25 8.8006 17.171 8.60983 17.0303 8.46918C16.8897 8.32853 16.6989 8.24951 16.5 8.24951Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M5.91001 7.84482C5.70012 8.05445 5.53376 8.3035 5.42049 8.57767C5.30722 8.85183 5.24928 9.14568 5.25001 9.44232V10.4998C5.25001 11.0966 5.48706 11.6689 5.90902 12.0908C6.33097 12.5128 6.90327 12.7498 7.50001 12.7498H8.55751C8.85415 12.7505 9.148 12.6926 9.42216 12.5793C9.69632 12.4661 9.94538 12.2997 10.155 12.0898L16.59 5.65482C16.7998 5.44579 16.9662 5.1974 17.0798 4.92391C17.1933 4.65042 17.2518 4.3572 17.2518 4.06107C17.2518 3.76494 17.1933 3.47172 17.0798 3.19823C16.9662 2.92474 16.7998 2.67635 16.59 2.46732L15.5325 1.40982C15.3235 1.20006 15.0751 1.03363 14.8016 0.920066C14.5281 0.806504 14.2349 0.748047 13.9388 0.748047C13.6426 0.748047 13.3494 0.806504 13.0759 0.920066C12.8024 1.03363 12.554 1.20006 12.345 1.40982L5.91001 7.84482ZM14.4675 2.46732L15.5325 3.53232C15.6722 3.67284 15.7506 3.86293 15.7506 4.06107C15.7506 4.25921 15.6722 4.4493 15.5325 4.58982L14.8875 5.24982L12.75 3.11232L13.395 2.46732C13.4649 2.39589 13.5483 2.33913 13.6404 2.30038C13.7324 2.26163 13.8313 2.24166 13.9313 2.24166C14.0312 2.24166 14.1301 2.26163 14.2222 2.30038C14.3142 2.33913 14.3977 2.39589 14.4675 2.46732ZM6.75001 9.44232C6.74944 9.34362 6.76836 9.24577 6.80568 9.15439C6.843 9.06301 6.898 8.9799 6.96751 8.90982L11.7 4.17732L13.8225 6.29982L9.09001 11.0323C9.01993 11.1018 8.93681 11.1568 8.84544 11.1941C8.75406 11.2315 8.65621 11.2504 8.55751 11.2498H7.50001C7.30109 11.2498 7.11033 11.1708 6.96968 11.0302C6.82902 10.8895 6.75001 10.6987 6.75001 10.4998V9.44232Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_2226_15296",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "18",
                                                height: "18",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "group-inputs",
                        style: {
                            minHeight: '10vh'
                        },
                        children: editInput === 'investmentCriteria' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac p0rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                rows: 10,
                                className: `c15 fs0-75rem w100`,
                                name: "investmentCriteria",
                                placeholder: "Please add at least 500 characters for this field to be complete",
                                defaultValue: company?.['investmentCriteria'],
                                onBlur: (e)=>{
                                    handleValueChange(e), setEditInput('');
                                },
                                onChange: (e)=>handleValueChange(e)
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            onClick: ()=>setEditInput('investmentCriteria'),
                            className: "c15 fs0-75rem",
                            children: company['investmentCriteria'] || 'Enter the Investment Criteria here...'
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "heading-edit-area mb0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1rem fw400 c15",
                            children: "Firm Investment Thesis"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mr0-5rem fs0-75rem fw400 c49 fsi",
                                    children: "(We will use your thesis in our triage algorithms in our pitch deck analysers)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "edit-icon cb bg0 br0 cp",
                                    onClick: ()=>editInput === 'investmentThesis' ? setEditInput('') : setEditInput('investmentThesis'),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                "clip-path": "url(#clip0_2226_15296)",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M16.5 8.24951C16.3011 8.24951 16.1103 8.32853 15.9697 8.46918C15.829 8.60983 15.75 8.8006 15.75 8.99951V13.4995C15.75 14.0962 15.5129 14.6685 15.091 15.0905C14.669 15.5125 14.0967 15.7495 13.5 15.7495H4.5C3.90326 15.7495 3.33097 15.5125 2.90901 15.0905C2.48705 14.6685 2.25 14.0962 2.25 13.4995V4.49951C2.25 3.90277 2.48705 3.33048 2.90901 2.90852C3.33097 2.48656 3.90326 2.24951 4.5 2.24951H9C9.19891 2.24951 9.38968 2.17049 9.53033 2.02984C9.67098 1.88919 9.75 1.69842 9.75 1.49951C9.75 1.3006 9.67098 1.10983 9.53033 0.969182C9.38968 0.828529 9.19891 0.749512 9 0.749512H4.5C4.00754 0.749512 3.51991 0.846508 3.06494 1.03496C2.60997 1.22342 2.19657 1.49964 1.84835 1.84786C1.14509 2.55112 0.75 3.50495 0.75 4.49951V13.4995C0.75 13.992 0.846997 14.4796 1.03545 14.9346C1.22391 15.3895 1.50013 15.8029 1.84835 16.1512C2.55161 16.8544 3.50544 17.2495 4.5 17.2495H13.5C13.9925 17.2495 14.4801 17.1525 14.9351 16.9641C15.39 16.7756 15.8034 16.4994 16.1517 16.1512C16.4999 15.8029 16.7761 15.3895 16.9645 14.9346C17.153 14.4796 17.25 13.992 17.25 13.4995V8.99951C17.25 8.8006 17.171 8.60983 17.0303 8.46918C16.8897 8.32853 16.6989 8.24951 16.5 8.24951Z",
                                                        fill: "#4A67FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M5.91001 7.84482C5.70012 8.05445 5.53376 8.3035 5.42049 8.57767C5.30722 8.85183 5.24928 9.14568 5.25001 9.44232V10.4998C5.25001 11.0966 5.48706 11.6689 5.90902 12.0908C6.33097 12.5128 6.90327 12.7498 7.50001 12.7498H8.55751C8.85415 12.7505 9.148 12.6926 9.42216 12.5793C9.69632 12.4661 9.94538 12.2997 10.155 12.0898L16.59 5.65482C16.7998 5.44579 16.9662 5.1974 17.0798 4.92391C17.1933 4.65042 17.2518 4.3572 17.2518 4.06107C17.2518 3.76494 17.1933 3.47172 17.0798 3.19823C16.9662 2.92474 16.7998 2.67635 16.59 2.46732L15.5325 1.40982C15.3235 1.20006 15.0751 1.03363 14.8016 0.920066C14.5281 0.806504 14.2349 0.748047 13.9388 0.748047C13.6426 0.748047 13.3494 0.806504 13.0759 0.920066C12.8024 1.03363 12.554 1.20006 12.345 1.40982L5.91001 7.84482ZM14.4675 2.46732L15.5325 3.53232C15.6722 3.67284 15.7506 3.86293 15.7506 4.06107C15.7506 4.25921 15.6722 4.4493 15.5325 4.58982L14.8875 5.24982L12.75 3.11232L13.395 2.46732C13.4649 2.39589 13.5483 2.33913 13.6404 2.30038C13.7324 2.26163 13.8313 2.24166 13.9313 2.24166C14.0312 2.24166 14.1301 2.26163 14.2222 2.30038C14.3142 2.33913 14.3977 2.39589 14.4675 2.46732ZM6.75001 9.44232C6.74944 9.34362 6.76836 9.24577 6.80568 9.15439C6.843 9.06301 6.898 8.9799 6.96751 8.90982L11.7 4.17732L13.8225 6.29982L9.09001 11.0323C9.01993 11.1018 8.93681 11.1568 8.84544 11.1941C8.75406 11.2315 8.65621 11.2504 8.55751 11.2498H7.50001C7.30109 11.2498 7.11033 11.1708 6.96968 11.0302C6.82902 10.8895 6.75001 10.6987 6.75001 10.4998V9.44232Z",
                                                        fill: "#4A67FF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                    id: "clip0_2226_15296",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                        width: "18",
                                                        height: "18",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "group-inputs",
                        style: {
                            minHeight: '10vh'
                        },
                        children: editInput === 'investmentThesis' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac p0rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                rows: 10,
                                className: `c15 fs0-75rem w100`,
                                name: "investmentThesis",
                                placeholder: "Please add at least 500 characters for this field to be complete",
                                defaultValue: company?.['investmentThesis'],
                                onBlur: (e)=>{
                                    handleValueChange(e), setEditInput('');
                                },
                                onChange: (e)=>handleValueChange(e)
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            onClick: ()=>setEditInput('investmentThesis'),
                            className: "c15 fs0-75rem",
                            children: company['investmentThesis'] || 'Enter the Investment Thesis here...'
                        })
                    })
                })
            ]
        });
    };
    const handleContactDetail = (name, value)=>{
    // setContactDetail({ ...contactDetail, [name]: value });
    // setSettingsChanged(true);
    };
    // Contact Details
    const contactDetails = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "form-group df jcsb mb2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-upload-area",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "img-box",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w6rem h6rem pr br100",
                                    src: contactDetail?.['profilePicture'] || (parcelRequire("cfmAr")),
                                    alt: "TODO"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "input-file",
                                    style: {
                                        position: 'relative',
                                        left: '-5%',
                                        bottom: '-40%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "add-btn shadow",
                                        onClick: ()=>{
                                            setIsImageModal(true), setUploadType('profilePicture'), setCurrentImage('');
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            viewBox: "0 0 487 487",
                                            className: "zi3",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9 v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                            class: "fs1-25rem fw500 c27 mb0-5rem",
                                            children: [
                                                contactDetail['firstName'] == '' && contactDetail['lastName'] == '' ? 'Contact Name' : contactDetail?.['firstName'] ? contactDetail?.['firstName'] : '',
                                                " ",
                                                contactDetail?.['lastName'] ? contactDetail?.['lastName'] : ''
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("lable", {
                                            className: "c15",
                                            children: "Upload Image"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w60 df fdc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            class: "w100 fs1-25rem mb1rem c15 fw500",
                            children: "Investor Contact Information"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            type: "text",
                                            placeholder: "Enter first name",
                                            value: contactDetail['firstName'] || '',
                                            onChange: (e)=>handleContactDetail('firstName', e.target.value),
                                            style: errors?.['firstName'] ? errorStyles['errorBorder'] : {},
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                },
                                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    style: {
                                                        marginRight: '10px'
                                                    },
                                                    width: "14",
                                                    height: "16",
                                                    viewBox: "0 0 14 16",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M7 2C5.34314 2 4 3.34315 4 5C4 6.65683 5.34314 8 7 8C8.65683 8 10 6.65683 10 5C10 3.34315 8.65683 2 7 2ZM2.5 5C2.5 2.51472 4.51472 0.5 7 0.5C9.48528 0.5 11.5 2.51472 11.5 5C11.5 7.48528 9.48528 9.5 7 9.5C4.51472 9.5 2.5 7.48528 2.5 5ZM2.35986 11.4624C3.58257 10.6981 5.22507 10.25 7 10.25C8.77495 10.25 10.4174 10.6981 11.6402 11.4624C12.8522 12.22 13.75 13.3626 13.75 14.75C13.75 15.1642 13.4142 15.5 13 15.5C12.5858 15.5 12.25 15.1642 12.25 14.75C12.25 14.0664 11.8046 13.334 10.8452 12.7344C9.89627 12.1414 8.53878 11.75 7 11.75C5.46123 11.75 4.10372 12.1414 3.15485 12.7344C2.19543 13.334 1.75 14.0664 1.75 14.75C1.75 15.1642 1.41421 15.5 1 15.5C0.58579 15.5 0.25 15.1642 0.25 14.75C0.25 13.3626 1.14771 12.22 2.35986 11.4624Z",
                                                        fill: "black"
                                                    })
                                                })
                                            }
                                        }),
                                        errors?.['firstName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w100 ml1rem",
                                            style: errorStyles['errorText'],
                                            children: errors['firstName']
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            type: "text",
                                            placeholder: "Enter last name",
                                            value: contactDetail['lastName'] || '',
                                            onChange: (e)=>handleContactDetail('lastName', e.target.value),
                                            style: errors?.['lastName'] ? errorStyles['errorBorder'] : {},
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                }
                                            }
                                        }),
                                        errors?.['lastName'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w100 ml1rem",
                                            style: errorStyles['errorText'],
                                            children: errors['lastName']
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            type: "email",
                                            placeholder: "Enter contact email",
                                            value: contactDetail['email'] || '',
                                            onChange: (e)=>handleContactDetail('email', e.target.value),
                                            style: errors?.['email'] ? errorStyles['errorBorder'] : {},
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                },
                                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("gaJU8")),
                                                    alt: "cReg",
                                                    className: "df mr1rem"
                                                })
                                            }
                                        }),
                                        errors?.['email'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w100 ml1rem",
                                            style: errorStyles['errorText'],
                                            children: errors['email']
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            type: "tel",
                                            placeholder: "Enter contact phone",
                                            value: contactDetail['phone'] || '',
                                            onChange: (e)=>handleContactDetail('phone', e.target.value),
                                            style: errors?.['phone'] ? errorStyles['errorBorder'] : {},
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                },
                                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("fSLCH")),
                                                    alt: "cReg",
                                                    className: "df mr1rem"
                                                })
                                            }
                                        }),
                                        errors?.['phone'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w100 ml1rem",
                                            style: errorStyles['errorText'],
                                            children: errors['phone']
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    type: "text",
                                    placeholder: "Enter contact designation",
                                    value: contactDetail['designation'] || '',
                                    onChange: (e)=>handleContactDetail('designation', e.target.value),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            style: {
                                                marginRight: '10px'
                                            },
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                    "clip-path": "url(#clip0_1969_5258)",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M15.0019 17.3974H2.99813C2.20343 17.3959 1.44171 17.0796 0.879773 16.5176C0.317837 15.9557 0.00148681 15.194 0 14.3993L0 7.20492C-1.39515e-06 6.40925 0.315692 5.64609 0.877788 5.08294C1.43988 4.51979 2.20246 4.20266 2.99813 4.20117H15.0019C15.7975 4.20266 16.5601 4.51979 17.1222 5.08294C17.6843 5.64609 18 6.40925 18 7.20492V14.3993C17.9985 15.194 17.6822 15.9557 17.1202 16.5176C16.5583 17.0796 15.7966 17.3959 15.0019 17.3974ZM2.99813 5.40492C2.52074 5.40492 2.0629 5.59456 1.72533 5.93213C1.38777 6.2697 1.19813 6.72753 1.19813 7.20492V14.3993C1.19813 14.8767 1.38777 15.3345 1.72533 15.6721C2.0629 16.0097 2.52074 16.1993 2.99813 16.1993H15.0019C15.4793 16.1993 15.9371 16.0097 16.2747 15.6721C16.6122 15.3345 16.8019 14.8767 16.8019 14.3993V7.20492C16.8019 6.72753 16.6122 6.2697 16.2747 5.93213C15.9371 5.59456 15.4793 5.40492 15.0019 5.40492H2.99813Z",
                                                            fill: "#505050"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M11.9994 3.59969C11.9203 3.59969 11.8421 3.58412 11.769 3.55387C11.696 3.52363 11.6297 3.47929 11.5738 3.4234C11.5179 3.36751 11.4736 3.30116 11.4433 3.22814C11.4131 3.15512 11.3975 3.07685 11.3975 2.99781V2.40156C11.3975 2.24291 11.3349 2.09066 11.2232 1.97795C11.1115 1.86524 10.9599 1.80117 10.8013 1.79969H7.20125C7.04162 1.79969 6.88853 1.8631 6.77566 1.97597C6.66279 2.08885 6.59937 2.24194 6.59937 2.40156V2.99781C6.60748 3.08136 6.59802 3.16568 6.5716 3.24535C6.54518 3.32503 6.50239 3.3983 6.44598 3.46045C6.38956 3.5226 6.32077 3.57227 6.24402 3.60626C6.16726 3.64025 6.08425 3.6578 6.00031 3.6578C5.91637 3.6578 5.83336 3.64025 5.75661 3.60626C5.67986 3.57227 5.61106 3.5226 5.55465 3.46045C5.49823 3.3983 5.45544 3.32503 5.42902 3.24535C5.4026 3.16568 5.39314 3.08136 5.40125 2.99781V2.40156C5.40125 1.92417 5.59089 1.46634 5.92846 1.12877C6.26602 0.791205 6.72386 0.601563 7.20125 0.601562H10.8013C11.2786 0.601563 11.7365 0.791205 12.074 1.12877C12.4116 1.46634 12.6012 1.92417 12.6012 2.40156V2.99781C12.6012 3.07685 12.5857 3.15512 12.5554 3.22814C12.5252 3.30116 12.4809 3.36751 12.425 3.4234C12.3691 3.47929 12.3027 3.52363 12.2297 3.55387C12.1567 3.58412 12.0784 3.59969 11.9994 3.59969Z",
                                                            fill: "#505050"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M9.00154 11.0587C8.4194 11.0532 7.84475 10.9268 7.31404 10.6875L3.37654 8.94935C3.22736 8.88446 3.11006 8.76296 3.05046 8.61158C2.99086 8.4602 2.99383 8.29135 3.05873 8.14217C3.12362 7.99298 3.24512 7.87569 3.3965 7.81609C3.54788 7.75648 3.71673 7.75946 3.86592 7.82435L7.80341 9.57373C8.18689 9.7438 8.60173 9.83167 9.02123 9.83167C9.44072 9.83167 9.85557 9.7438 10.239 9.57373L14.1765 7.82435C14.2504 7.79222 14.3299 7.77495 14.4104 7.77353C14.491 7.77211 14.571 7.78657 14.646 7.81609C14.7209 7.8456 14.7893 7.88958 14.8473 7.94553C14.9052 8.00148 14.9516 8.0683 14.9837 8.14217C15.0159 8.21603 15.0331 8.29551 15.0345 8.37605C15.036 8.45659 15.0215 8.53663 14.992 8.61158C14.9625 8.68653 14.9185 8.75494 14.8625 8.8129C14.8066 8.87085 14.7398 8.91722 14.6659 8.94935L10.689 10.6875C10.1583 10.9268 9.58368 11.0532 9.00154 11.0587Z",
                                                            fill: "#505050"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                        id: "clip0_1969_5258",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                            width: "18",
                                                            height: "18",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    type: "text",
                                    placeholder: "Enter contact location",
                                    value: contactDetail['location'] || '',
                                    onChange: (e)=>handleContactDetail('location', e.target.value),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            style: {
                                                marginRight: '10px'
                                            },
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M9 0C5.40545 0 2.48108 2.92437 2.48108 6.51888C2.48108 10.9798 8.31487 17.5287 8.56325 17.8053C8.79655 18.0651 9.20387 18.0647 9.43674 17.8053C9.68512 17.5287 15.5189 10.9798 15.5189 6.51888C15.5188 2.92437 12.5945 0 9 0ZM9 16.5139C7.03663 14.1817 3.65502 9.5805 3.65502 6.51895C3.65502 3.57166 6.05274 1.17394 9 1.17394C11.9473 1.17394 14.345 3.57166 14.345 6.51892C14.3449 9.58061 10.9639 14.181 9 16.5139Z",
                                                    fill: "#505050"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M9.00001 3.23926C7.1915 3.23926 5.72021 4.71058 5.72021 6.51909C5.72021 8.3276 7.19154 9.79892 9.00001 9.79892C10.8085 9.79892 12.2798 8.3276 12.2798 6.51909C12.2798 4.71058 10.8085 3.23926 9.00001 3.23926ZM9.00001 8.62498C7.8388 8.62498 6.89415 7.6803 6.89415 6.51909C6.89415 5.35788 7.83884 4.4132 9.00001 4.4132C10.1612 4.4132 11.1059 5.35788 11.1059 6.51909C11.1059 7.6803 10.1612 8.62498 9.00001 8.62498Z",
                                                    fill: "#505050"
                                                })
                                            ]
                                        })
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w100 df mb0-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                type: "url",
                                placeholder: "Enter contact linkedIn",
                                value: contactDetail['linkedIn'] || '',
                                onChange: (e)=>handleContactDetail('linkedIn', e.target.value),
                                InputProps: {
                                    style: {
                                        borderRadius: "10px",
                                        fontSize: '14px'
                                    },
                                    startAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        style: {
                                            marginRight: '10px'
                                        },
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                "clip-path": "url(#clip0_5984_38509)",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M5 17H1V6H5V17ZM1.66663 16.2904H4.33337V6.70964H1.66663V16.2904Z",
                                                        fill: "#505050",
                                                        stroke: "#505050",
                                                        "stroke-width": "0.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M17 17H13V10.9677C13 10.3799 12.5522 9.90321 12 9.90321C11.4476 9.90321 11 10.3799 11 10.9677V17H7V6H11V6.71406C11.6038 6.24937 12.33 5.99948 13.075 6C15.2374 6 17 7.86734 17 10.1649V17ZM13.6666 16.2904H16.3333V10.1649C16.3287 8.25341 14.8706 6.70717 13.075 6.70964C12.2542 6.70964 11.4833 7.07778 10.9083 7.74311L10.3333 8.41285V6.70964H7.66663V16.2904H10.3333V10.9677C10.3333 9.98781 11.0795 9.19357 12 9.19357C12.9204 9.19357 13.6666 9.98781 13.6666 10.9677V16.2904Z",
                                                        fill: "#505050",
                                                        stroke: "#505050",
                                                        "stroke-width": "0.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M3 5C1.89539 5 1 4.10461 1 3C1 1.89551 1.89539 1 3 1C4.10461 1 5 1.89551 5 3C4.99768 4.10364 4.10364 4.9978 3 5ZM3 1.66675C2.26367 1.66675 1.66663 2.26367 1.66663 3C1.66663 3.73645 2.26367 4.33337 3 4.33337C3.73633 4.33337 4.33337 3.73645 4.33337 3C4.33337 2.26367 3.73633 1.66675 3 1.66675Z",
                                                        fill: "#505050",
                                                        stroke: "#505050",
                                                        "stroke-width": "0.5"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                    id: "clip0_5984_38509",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                        width: "18",
                                                        height: "18",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "c4 fs0-75rem fsi mb1rem w100 tal",
                            children: [
                                "Please do not put generic enquiries @email address here. Having qualified the leads,",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "we ask that it be provided to a named individuals within your organisation"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            class: "w100 fs1-25rem mb0-5rem c15 fw500",
                            children: "Contact Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df gg1rem mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            placeholder: "Set new password",
                                            value: contactDetail['password'] || '',
                                            type: passwordType ? "password" : "text",
                                            style: errors?.['password'] ? errorStyles['errorBorder'] : {},
                                            onChange: (e)=>handleContactDetail('password', e.target.value),
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                },
                                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("8lNxh")),
                                                    alt: "cReg",
                                                    className: "df mr1rem"
                                                }),
                                                endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: !passwordType ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "pa cp w20px h20px",
                                                        onClick: ()=>setPasswordType(!passwordType),
                                                        width: "27",
                                                        height: "21",
                                                        viewBox: "0 0 27 21",
                                                        fill: "none",
                                                        xmlns: "http:www.w3.org/2000/svg",
                                                        style: {
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            right: "12px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                                            fill: "#404040"
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        className: "pa cp w20px h20px",
                                                        onClick: ()=>setPasswordType(!passwordType),
                                                        width: "27",
                                                        height: "21",
                                                        viewBox: "0 0 27 21",
                                                        fill: "none",
                                                        xmlns: "http:www.w3.org/2000/svg",
                                                        style: {
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            right: "12px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                                                fill: "#404040"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                                                fill: "#404040"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }
                                        }),
                                        errors?.['password'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w100 ml1rem",
                                            style: errorStyles['errorText'],
                                            children: errors['password']
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            placeholder: "Set confirm password",
                                            type: passwordType ? "password" : "text",
                                            value: contactDetail['confirmPassword'] || '',
                                            onChange: (e)=>handleContactDetail('confirmPassword', e.target.value),
                                            style: errors?.['confirmPassword'] ? errorStyles['errorBorder'] : {},
                                            InputProps: {
                                                style: {
                                                    borderRadius: "10px",
                                                    fontSize: '14px'
                                                },
                                                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("8lNxh")),
                                                    alt: "cReg",
                                                    className: "df mr1rem"
                                                }),
                                                endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: !passwordType ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        className: "pa cp w20px h20px",
                                                        onClick: ()=>setPasswordType(!passwordType),
                                                        width: "27",
                                                        height: "21",
                                                        viewBox: "0 0 27 21",
                                                        fill: "none",
                                                        xmlns: "http:www.w3.org/2000/svg",
                                                        style: {
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            right: "12px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                                            fill: "#404040"
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        className: "pa cp w20px h20px",
                                                        onClick: ()=>setPasswordType(!passwordType),
                                                        width: "27",
                                                        height: "21",
                                                        viewBox: "0 0 27 21",
                                                        fill: "none",
                                                        xmlns: "http:www.w3.org/2000/svg",
                                                        style: {
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            right: "12px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                                                fill: "#404040"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                                                fill: "#404040"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }
                                        }),
                                        errors?.['confirmPassword'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w100 ml1rem",
                                            style: errorStyles['errorText'],
                                            children: errors['confirmPassword']
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w90 df fdc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading-edit-area df aic mb0-5rem mt0-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "mr0-5rem fs1-25rem fw400 c15",
                                children: [
                                    "Contact Bio ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c49 fsi fs0-75rem",
                                        children: "(Provided to our qualified leads)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "group-inputs",
                                style: {
                                    minHeight: '10vh'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    rows: 5,
                                    name: "bio",
                                    className: "c15 fs0-75rem w100",
                                    placeholder: "Enter contact bio",
                                    defaultValue: contactDetail['bio'] || '',
                                    onChange: (e)=>handleContactDetail('bio', e.target.value)
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w60 df fdc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        class: "w100 df jcsb p1rem bw1px br15px bss bo31",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                class: "c15 fw300",
                                style: {
                                    fontSize: '14px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "fs1rem fw500",
                                        children: "Active?"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        class: "c12 fsi",
                                        children: "(If active it will be used during investor match)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                name: "isMainRecipient",
                                checked: contactDetail['isMainRecipient'],
                                onChange: (e)=>handleContactDetail('isMainRecipient', e.target.checked),
                                className: "success w100"
                            })
                        ]
                    })
                })
            ]
        });
    };
    const handleQuickResponse = ()=>{
        setQuickResponseList([
            ...quickResponseList,
            quickResponse
        ]);
        setQuickResponse('');
        setSettingsChanged(true);
    };
    const handleDeleteQuickResponse = (item)=>{
        setQuickResponseList(quickResponseList.filter((response)=>response !== item));
        setSettingsChanged(true);
    };
    // Quick Reponses
    const quickReponses = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "objective-criteria-container w80",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "w100 fs1-5rem fw500 c27 mb0-5rem",
                        children: "Quick responses"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "w100 c15 fs1rem",
                        children: [
                            "Reasons for rejection ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c49 fs0-75rem fsi",
                                children: "(Please select/add reasons you want to see in the selection dropdown)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            quickResponseList.length > 0 && quickResponseList.map((item)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg1 p1rem bw1px br30px bss bo31 mt1rem c15 fs1rem df fsi pr response-box",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "w90",
                                            children: item
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>handleDeleteQuickResponse(item),
                                            className: "cp btn-close-right pa r0 t0 p0 mt1rem mr2rem op0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                width: "21",
                                                height: "21",
                                                viewBox: "0 0 21 21",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M16.625 6.125C16.3929 6.125 16.1704 6.21719 16.0063 6.38128C15.8422 6.54538 15.75 6.76794 15.75 7V16.7921C15.7249 17.2346 15.526 17.6492 15.1966 17.9457C14.8671 18.2422 14.4339 18.3965 13.9913 18.375H7.00875C6.56608 18.3965 6.13286 18.2422 5.80344 17.9457C5.47402 17.6492 5.2751 17.2346 5.25 16.7921V7C5.25 6.76794 5.15781 6.54538 4.99372 6.38128C4.82962 6.21719 4.60706 6.125 4.375 6.125C4.14294 6.125 3.92038 6.21719 3.75628 6.38128C3.59219 6.54538 3.5 6.76794 3.5 7V16.7921C3.52498 17.6988 3.90826 18.5587 4.56591 19.1834C5.22356 19.808 6.10196 20.1466 7.00875 20.125H13.9913C14.898 20.1466 15.7764 19.808 16.4341 19.1834C17.0917 18.5587 17.475 17.6988 17.5 16.7921V7C17.5 6.76794 17.4078 6.54538 17.2437 6.38128C17.0796 6.21719 16.8571 6.125 16.625 6.125Z",
                                                        fill: "#F14D4D"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M17.5 3.5H14V1.75C14 1.51794 13.9078 1.29538 13.7437 1.13128C13.5796 0.967187 13.3571 0.875 13.125 0.875H7.875C7.64294 0.875 7.42038 0.967187 7.25628 1.13128C7.09219 1.29538 7 1.51794 7 1.75V3.5H3.5C3.26794 3.5 3.04538 3.59219 2.88128 3.75628C2.71719 3.92038 2.625 4.14294 2.625 4.375C2.625 4.60706 2.71719 4.82962 2.88128 4.99372C3.04538 5.15781 3.26794 5.25 3.5 5.25H17.5C17.7321 5.25 17.9546 5.15781 18.1187 4.99372C18.2828 4.82962 18.375 4.60706 18.375 4.375C18.375 4.14294 18.2828 3.92038 18.1187 3.75628C17.9546 3.59219 17.7321 3.5 17.5 3.5ZM8.75 3.5V2.625H12.25V3.5H8.75Z",
                                                        fill: "#F14D4D"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M9.625 14.875V8.75C9.625 8.51794 9.53281 8.29538 9.36872 8.13128C9.20462 7.96719 8.98206 7.875 8.75 7.875C8.51794 7.875 8.29538 7.96719 8.13128 8.13128C7.96719 8.29538 7.875 8.51794 7.875 8.75V14.875C7.875 15.1071 7.96719 15.3296 8.13128 15.4937C8.29538 15.6578 8.51794 15.75 8.75 15.75C8.98206 15.75 9.20462 15.6578 9.36872 15.4937C9.53281 15.3296 9.625 15.1071 9.625 14.875Z",
                                                        fill: "#F14D4D"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M13.125 14.875V8.75C13.125 8.51794 13.0328 8.29538 12.8687 8.13128C12.7046 7.96719 12.4821 7.875 12.25 7.875C12.0179 7.875 11.7954 7.96719 11.6313 8.13128C11.4672 8.29538 11.375 8.51794 11.375 8.75V14.875C11.375 15.1071 11.4672 15.3296 11.6313 15.4937C11.7954 15.6578 12.0179 15.75 12.25 15.75C12.4821 15.75 12.7046 15.6578 12.8687 15.4937C13.0328 15.3296 13.125 15.1071 13.125 14.875Z",
                                                        fill: "#F14D4D"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg1 py0-5rem px1rem bw1px br30px bss bo31 mt1rem c15 fs1rem df fsi pr response-box",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "mr1rem",
                                        children: quickResponse == '' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "cp plus-btn mr1rem pr",
                                            style: {
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                padding: '0',
                                                top: '2px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($b40dd314a65fd52f$var$DisablePlusIcon, {})
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>handleQuickResponse(),
                                            className: "cp plus-btn mr1rem pr",
                                            style: {
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                padding: '0',
                                                top: '2px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($b40dd314a65fd52f$var$PlusIcon, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        value: quickResponse,
                                        onChange: (e)=>setQuickResponse(e.target.value),
                                        placeholder: "Add Quick Response - up to 300 characters",
                                        InputProps: {
                                            style: {
                                                borderRadius: "0",
                                                marginBottom: '0',
                                                fontSize: '14px',
                                                border: 'none',
                                                padding: '0'
                                            }
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            company?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        class: "df jcc mb1rem setting-investor",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                            value: selectedInvestorTab,
                            onChange: (_, newValue)=>setSelectedInvestorTab(newValue),
                            "aria-label": "InvestorMatch Tabs",
                            children: investorMatchTabs.map((tab)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                                    label: tab,
                                    value: tab,
                                    onClick: ()=>setSelectedInvestorTab(tab)
                                }, tab))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b40dd314a65fd52f$var$TabPanel, {
                        value: selectedInvestorTab,
                        index: "Investor Details",
                        children: investorDetails()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b40dd314a65fd52f$var$TabPanel, {
                        value: selectedInvestorTab,
                        index: "Objective Criteria",
                        children: objectiveCriteria()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b40dd314a65fd52f$var$TabPanel, {
                        value: selectedInvestorTab,
                        index: "Subjective Criteria",
                        children: subjectiveCriteria()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b40dd314a65fd52f$var$TabPanel, {
                        value: selectedInvestorTab,
                        index: "Contact Details",
                        children: contactDetails()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b40dd314a65fd52f$var$TabPanel, {
                        value: selectedInvestorTab,
                        index: "Quick Response",
                        children: quickReponses()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df mt1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>saveSettings(),
                            className: `w200px df aic jcc c1 br30px px2rem py0-5rem fw500 ${!isSettingsChanged ? 'bg12 cna' : 'bg4 cp'}`,
                            disabled: !isSettingsChanged,
                            children: "Save Changes"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: isImageModal,
                onClose: ()=>setIsImageModal(false),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `top-header py1rem px2rem df jcsb aic ${user['role'] == 'Advisor' ? 'advisor-bg' : 'investor-bg'}`,
                            style: {
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Upload Profile Picture"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc p3rem",
                            children: [
                                currentImage == '' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "profile",
                                    className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs1rem fw500 tac",
                                            children: "Upload picture"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "input-btn pa t0 w100 op0 l0 cp",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: "w100 l0 h5rem cp",
                                                onChange: (e)=>handleImage(e),
                                                id: "currentImage",
                                                type: "file",
                                                accept: "image/jpeg, image/jpg, image/png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: "Max file size 5MB"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                        ref: cropper,
                                        guides: false,
                                        aspectRatio: 1,
                                        className: "cropper-settings",
                                        src: currentImage
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>setIsImageModal(false),
                                            className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>uploadImage(),
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: Object.keys(currentImage).length == 0 ? 'Upload' : 'Crop & Upload'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'investorCriteriaAuditLogs',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "c15 fs1-5rem fw600 tac ttu",
                            children: [
                                company['cName'],
                                " Audit Logs"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c4 fs0-75rem w100 tac mb1rem",
                            children: "See the history of Investor Criteria Updates"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c14 fs1rem fw600 ml1rem",
                                        children: "Company Details:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "new-shadow bg1 bw1px br10px bo31 bss p1rem mx0-5rem fs0-75rem c14",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c15 fw600 mr0-5rem",
                                                    children: "Company Name:"
                                                }),
                                                " ",
                                                company['cName']
                                            ]
                                        }),
                                        company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c15 fw600 mr0-5rem",
                                                    children: "Company Owner:"
                                                }),
                                                " ",
                                                company['creatorId']['firstName'] + ' ' + company['creatorId']['lastName']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c15 fw600 mr0-5rem",
                                                    children: "Created At:"
                                                }),
                                                " ",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['creaedAt']).format('ll')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c15 fw600 mr0-5rem",
                                                    children: "Payment Source:"
                                                }),
                                                " ",
                                                company['paymentSource']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c15 fw600 mr0-5rem",
                                                    children: "Stage of development:"
                                                }),
                                                " ",
                                                company['cStage']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "c15 fw600 mr0-5rem",
                                                    children: "Company Objectives:"
                                                }),
                                                " ",
                                                company['testType']
                                            ]
                                        })
                                    ]
                                }),
                                auditLogList && auditLogList.length > 0 && auditLogList.map((log)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: log['payload']['update'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df my0-5rem",
                                            children: [
                                                (log?.['userId']?.['profile'] || log?.['userId']?.['profilePicture']) && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: `ass ml0-5rem br100 w2rem h2rem client-profile`,
                                                    src: log?.['userId']?.['profile'] || log?.['userId']?.['profilePicture'],
                                                    "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                                                }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem client-profile`,
                                                    children: [
                                                        log?.['userId']?.['firstName']?.[0] || "?",
                                                        log?.['userId']?.['lastName']?.[0] || "?"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w100 c14",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "fs0-75rem ml0-5rem",
                                                            children: [
                                                                "Investor Criteria updated at ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(log.timestamp).format('lll')
                                                                }),
                                                                " by ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                    children: [
                                                                        log?.['userId']['firstName'],
                                                                        " ",
                                                                        log?.['userId']['lastName']
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "new-shadow bg1 bw1px br10px bo31 bss p1rem mx0-5rem fs0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "df fw500 fs1rem c15 mb0-5rem",
                                                                    children: [
                                                                        "Changes to ",
                                                                        company['cName'],
                                                                        " - Investor Criteria:"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df w100",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "mr0-5rem",
                                                                            children: Object.keys(log['payload']['update']).map((key)=>{
                                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                    className: "fw600 mb0-5rem c15",
                                                                                    children: [
                                                                                        auditLogKeys[key],
                                                                                        ":"
                                                                                    ]
                                                                                });
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            children: Object.values(log['payload']['update']).map((value)=>{
                                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                    className: "mb0-5rem c14",
                                                                                    children: typeof value == 'object' ? Object.keys(value).map((key)=>{
                                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                            class: "fw500",
                                                                                            children: [
                                                                                                key,
                                                                                                typeof value[key] == 'string' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                                    children: [
                                                                                                        ": ",
                                                                                                        value[key]
                                                                                                    ]
                                                                                                }),
                                                                                                ", "
                                                                                            ]
                                                                                        });
                                                                                    }) : typeof value == 'string' ? value : typeof value == 'boolean' && value ? 'True' : 'False'
                                                                                });
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    });
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $b40dd314a65fd52f$export$2e2bcd8739ae039 = $b40dd314a65fd52f$var$InvestorMatchCriteria;



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");



var $acw62 = parcelRequire("acw62");







const $a13e63b7a73e33fd$var$PlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "30px",
        height: "30px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#4A67FF",
                d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M21,14h6v20h-6V14z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M14,21h20v6H14V21z"
            })
        ]
    });
};
const $a13e63b7a73e33fd$var$DisablePlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_2037_11597)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M14 0C6.28009 0 0 6.28009 0 14C0 21.7199 6.28009 28 14 28C21.7199 28 28 21.7199 28 14C28 6.28009 21.7199 0 14 0Z",
                        fill: "#CECECE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M20.1229 15.1652H15.1645V20.1236C15.1645 20.7677 14.642 21.2902 13.9979 21.2902C13.3538 21.2902 12.8313 20.7677 12.8313 20.1236V15.1652H7.87289C7.22882 15.1652 6.7063 14.6427 6.7063 13.9986C6.7063 13.3546 7.22882 12.832 7.87289 12.832H12.8313V7.87363C12.8313 7.22955 13.3538 6.70703 13.9979 6.70703C14.642 6.70703 15.1645 7.22955 15.1645 7.87363V12.832H20.1229C20.767 12.832 21.2895 13.3546 21.2895 13.9986C21.2895 14.6427 20.767 15.1652 20.1229 15.1652Z",
                        fill: "#FAFAFA"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_2037_11597",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "28",
                        height: "28",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
function $a13e63b7a73e33fd$var$TabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `client-tabpanel-${index}`,
        "aria-labelledby": `client-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00a20d475386f68c$export$2e2bcd8739ae039), {
            sx: {
                p: 3
            },
            children: children
        })
    });
}





function $a13e63b7a73e33fd$export$2e2bcd8739ae039({ user: user, company: company, advisors: advisors, setAdvisors: setAdvisors, selectedClientMatchTab: selectedClientMatchTab, setSelectedClientMatchTab: setSelectedClientMatchTab, clientMatchTabs: clientMatchTabs }) {
    const cropper = (0, $acw62.useRef)(null);
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [editInput, setEditInput] = (0, $acw62.useState)("");
    const [userProfile, setUserProfile] = (0, $acw62.useState)("");
    const [quickResponse, setQuickResponse] = (0, $acw62.useState)('');
    const [selectedAdvisor, setSelectedAdvisor] = (0, $acw62.useState)(user);
    const [quickResponseList, setQuickResponseList] = (0, $acw62.useState)([]);
    const [isSettingsChanged, setSettingsChanged] = (0, $acw62.useState)(false);
    const [objectiveCriteriaQues, setObjectiveCriteriaQues] = (0, $acw62.useState)([]);
    const [generatingSummary, setGeneratingSummary] = (0, $acw62.useState)(false);
    const fetchQuestions = async (selectedAdvisorId)=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/getAdvisorsQuestions', {
                selectedAdvisorId: selectedAdvisorId
            });
            if (response?.code === 200) setObjectiveCriteriaQues(response.body || []);
        } catch (error) {
            console.error('Error fetching questions:', error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (selectedAdvisor?._id) fetchQuestions(selectedAdvisor._id);
    }, [
        selectedAdvisor?._id
    ]);
    const saveAdvisorAnswer = async (questionId, selectedRadio, selectedDropdown)=>{
        try {
            const payload = {
                selectedAdvisorId: selectedAdvisor._id,
                questionId: questionId
            };
            if (selectedRadio !== undefined) payload.selectedRadio = selectedRadio;
            if (selectedDropdown !== undefined) payload.selectedDropdown = selectedDropdown;
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/saveAdvisorAnswer', payload);
            if (response?.code === 200) setObjectiveCriteriaQues((prev)=>prev.map((q)=>q._id === questionId ? {
                        ...q,
                        answer: response.body
                    } : q));
            else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Failed to save answer');
        } catch (error) {
            console.error('Error saving answer:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while saving');
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (selectedAdvisor?._id) {
            const updatedAdvisor = advisors?.find((a)=>a._id === selectedAdvisor._id) || user;
            setSelectedAdvisor(updatedAdvisor);
        }
    }, [
        advisors
    ]);
    // Initialize quickResponseList from company
    (0, $acw62.useEffect)(()=>{
        if (company?.quickResponses?.length > 0) setQuickResponseList(company.quickResponses);
    }, [
        company
    ]);
    const handleQuickResponse = ()=>{
        if (!quickResponse.trim()) return;
        setQuickResponseList([
            ...quickResponseList,
            quickResponse
        ]);
        setQuickResponse('');
        setSettingsChanged(true);
    };
    const handleDeleteQuickResponse = (item)=>{
        setQuickResponseList(quickResponseList.filter((response)=>response !== item));
        setSettingsChanged(true);
    };
    const saveQuickResponses = async ()=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/update/${company._id}`, {
                update: {
                    quickResponses: quickResponseList
                }
            });
            if (response?.code === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Quick responses saved successfully');
                setSettingsChanged(false);
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Failed to save quick responses');
        } catch (error) {
            console.error('Error saving quick responses:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while saving');
        }
    };
    const updateAdvisorField = async (advisorId, field, value)=>{
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateProfile', {
                _id: advisorId,
                [field]: value,
                advisorId: advisorId
            });
            if (response?.['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Updated successfully');
                // For isMainRecipient, ensure mutual exclusivity in the UI
                if (field === 'isMainRecipient' && value === true) setAdvisors((prev)=>prev.map((advisor)=>({
                            ...advisor,
                            isMainRecipient: advisor['_id'] === advisorId ? true : false
                        })));
                else setAdvisors((prev)=>prev.map((advisor)=>advisor['_id'] === advisorId ? {
                            ...advisor,
                            [field]: value
                        } : advisor));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Failed to update');
        } catch (error) {
            console.error('Error updating advisor:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while updating');
        }
    };
    const handleAdvisorChange = (field, value)=>setSelectedAdvisor((prev)=>({
                ...prev,
                [field]: value
            }));
    const generateAdvisorSummary = async ()=>{
        if (!selectedAdvisor?.['_id']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select an advisor');
        const specialSkills = selectedAdvisor?.['specialSkills']?.trim();
        const sectorExperience = selectedAdvisor?.['sectorExperience']?.trim();
        const trackRecord = selectedAdvisor?.['trackRecord']?.trim();
        if (!specialSkills || !sectorExperience || !trackRecord) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill in Special Skills, Sector Experience and Track Record Highlights');
        setGeneratingSummary(true);
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/generateAdvisorSummary', {
                advisorId: selectedAdvisor['_id'],
                specialSkills: specialSkills,
                sectorExperience: sectorExperience,
                trackRecord: trackRecord
            });
            if (res?.['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message'] || 'AI Summary generated successfully');
                const updatedFields = {
                    wordSummary: res?.['body']['wordSummary'],
                    specialSkills: res?.['body']['specialSkills'],
                    sectorExperience: res?.['body']['sectorExperience'],
                    trackRecord: res?.['body']['trackRecord']
                };
                setSelectedAdvisor((prev)=>({
                        ...prev,
                        ...updatedFields
                    }));
                setAdvisors((prev)=>prev.map((advisor)=>advisor['_id'] === selectedAdvisor['_id'] ? {
                            ...advisor,
                            ...updatedFields
                        } : advisor));
                if (selectedAdvisor['_id'] === user['_id']) dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)({
                    ...user,
                    ...updatedFields,
                    updatedAt: new Date()
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res?.['message'] || 'Failed to generate AI summary');
        } catch (error) {
            console.error('Error generating AI summary:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while generating AI summary');
        } finally{
            setGeneratingSummary(false);
        }
    };
    const saveAdvisorProfile = async ()=>{
        if (!selectedAdvisor?.['firstName']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter first name');
        if (!selectedAdvisor?.['lastName']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter last name');
        if (!selectedAdvisor?.['email']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter email');
        setLoading(true);
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateProfile', selectedAdvisor);
            if (response?.['code'] === 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Profile updated successfully');
                // Update advisors list
                setAdvisors((prev)=>prev.map((advisor)=>advisor['_id'] === selectedAdvisor['_id'] ? {
                            ...advisor,
                            ...selectedAdvisor
                        } : advisor));
                // Update redux if it's the current user
                if (selectedAdvisor['_id'] === user['_id']) dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)({
                    ...user,
                    ...selectedAdvisor,
                    updatedAt: new Date()
                }));
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.['message'] || 'Failed to update profile');
        } catch (error) {
            console.error('Error saving advisor profile:', error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('An error occurred while saving');
        } finally{
            setLoading(false);
        }
    };
    const handleProfile = async (e)=>{
        let profile = e.target.files[0];
        if (!profile) return;
        if (profile && profile.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        profile = await URL.createObjectURL(profile);
        setUserProfile(profile);
    };
    const updateAdvisorProfile = async ()=>{
        if (cropper.current && userProfile) {
            setLoading(true);
            let imageToUpload = cropper?.current?.cropper?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile-image.png", {
                type: "image/png"
            });
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/updateProfile`, {
                _id: selectedAdvisor['_id'],
                attachment: [
                    coverFile
                ]
            });
            if (response?.['code'] === 200) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ""
                }));
                setSelectedAdvisor((prev)=>({
                        ...prev,
                        profile: imageToUpload
                    }));
                setAdvisors((prev)=>prev.map((advisor)=>advisor['_id'] === selectedAdvisor['_id'] ? {
                            ...advisor,
                            profile: imageToUpload
                        } : advisor));
                if (selectedAdvisor['_id'] === user['_id']) dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)({
                    ...user,
                    profile: imageToUpload
                }));
                setUserProfile("");
            }
            setLoading(false);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Profile updated');
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    const getAdvisorStatus = (advisor)=>{
        if (!advisor['emailVerified']) return {
            label: 'Inactive',
            color: '#FF0B0F'
        };
        const hasRequiredFields = advisor['firstName'] && advisor['lastName'] && advisor['email'] && advisor['phone'] && advisor['linkedIn'];
        if (!hasRequiredFields) return {
            label: 'Incomplete profile',
            color: '#FFBC00'
        };
        else return {
            label: 'Available',
            color: '#15D757'
        };
    };
    const SelectAdvisor = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
            displayEmpty: true,
            value: selectedAdvisor?._id || '',
            onChange: (e)=>{
                const advisor = advisors?.find((a)=>a._id === e.target.value) || user;
                setSelectedAdvisor(advisor);
            },
            sx: {
                borderRadius: '20px',
                '& .MuiOutlinedInput-notchedOutline': {
                    border: '1px solid #E5E7EB'
                },
                '& .MuiSelect-select': {
                    padding: '10px 20px'
                }
            },
            children: advisors?.map((advisor)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                    value: advisor._id,
                    children: [
                        advisor.firstName,
                        " ",
                        advisor.lastName
                    ]
                }, advisor._id))
        });
    // Team Admin Tab
    const teamAdmin = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr team-admin",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcsb aic mb2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        class: "fs1-5rem fw500 c14 ml1rem",
                        children: [
                            "ADVISOR",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("spam", {
                                class: "c4",
                                children: "MATCH"
                            }),
                            " TEAM"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 oa bg1 br10px shadow-sm",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        className: "w100 table-advisor",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "bg5 tal fw600 fs1rem py1rem px0-75rem",
                                            children: "PROFILE"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "bg5 tal fw600 fs1rem py1rem px0-75rem",
                                            children: "TITLE"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "bg5 tal fw600 fs1rem py1rem px0-75rem",
                                            children: "EMAIL"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "bg5 tal fw600 fs1rem py1rem px0-75rem",
                                            children: "PHONE"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "bg5 tac fw600 fs1rem py1rem px0-75rem",
                                            children: "NEW CLIENTS?"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            className: "bg5 tal fw600 fs1rem py1rem px0-75rem",
                                            children: "STATUS"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("th", {
                                            className: "df bg5 tac fw600 fs1rem py1rem px0-75rem",
                                            children: [
                                                "PRIMARY CONTACT",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "right-info-hyper-icon",
                                                    style: {
                                                        top: '110px',
                                                        right: '50px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "hover-list-icon cp",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 27 27",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                        cx: "13.5",
                                                                        cy: "13.5",
                                                                        r: "13.5",
                                                                        fill: "#59B8FD"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z",
                                                                        fill: "white"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "overlay-box",
                                                                style: {
                                                                    width: '260px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "fs0-75rem fw400 c15",
                                                                    children: "This individual will be copied in to first response email for admin purposes"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                children: advisors.length > 0 ? advisors.map((advisor)=>{
                                    let status = getAdvisorStatus(advisor);
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        class: `${!advisor['emailVerified'] && 'op0-5'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py1rem px0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic ",
                                                    children: [
                                                        advisor['profilePicture'] || advisor['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: advisor['profilePicture'] || advisor['profile'],
                                                            alt: `${advisor['firstName']} ${advisor['lastName']}`.trim(),
                                                            className: "w3rem h3rem br100 bw2px bo12 bss mr0-5rem"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "w3rem h3rem br100 df aic jcc fw600 fs1rem bg5 bw2px bo12 bss mr0-5rem",
                                                            children: `${advisor['firstName']} ${advisor['lastName']}`.trim().split(' ').map((n)=>n[0]).join('').toUpperCase().slice(0, 2)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df fdc tal",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "fs0-875rem c15",
                                                                    children: `${advisor['firstName']} ${advisor['lastName']}`.trim()
                                                                }),
                                                                company?.['creatorId']?.['_id'] == advisor['_id'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "w100 c4 fs0-75rem",
                                                                    children: "Admin"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py1rem px0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-875rem c15",
                                                    children: advisor['designation'] || advisor['title'] || '-'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py1rem px0-5rem",
                                                children: advisor['email'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: `mailto:${advisor['email']}`,
                                                    className: "fs0-875rem c3 tdu",
                                                    children: advisor['email']
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-875rem c14",
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py1rem px0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-875rem c15",
                                                    children: advisor['phone'] || '-'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "tac py1rem px0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    color: "success",
                                                    checked: advisor['isNewClient'] == true,
                                                    onChange: (e)=>updateAdvisorField(advisor['_id'], 'isNewClient', e.target.checked)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "py1rem px0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fs0-75rem fw500",
                                                    style: {
                                                        color: status['color']
                                                    },
                                                    children: status['label']
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "tac py1rem px0-5rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "form-check form-switch df jcc",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "radio",
                                                        className: "cp w20px h20px",
                                                        name: "primaryContact",
                                                        checked: advisor['isMainRecipient'] == true,
                                                        onChange: ()=>updateAdvisorField(advisor['_id'], 'isMainRecipient', true)
                                                    })
                                                })
                                            })
                                        ]
                                    }, advisor['_id']);
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        colSpan: 7,
                                        className: "tac py3rem c4 fw500 fs1rem",
                                        children: "No advisors found in this team."
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    // Profiles Tab
    const profiles = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sectionWrapper p2rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w70 bg1 br10px p2rem shadow-sm mb2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        class: "df jcsb aic mb1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "form-group df aic",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "img-upload-area pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "img-box pr shadow w4rem h4rem br50px mr1-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: selectedAdvisor?.['profile'] || (parcelRequire("cfmAr")),
                                                    alt: "Profile",
                                                    className: "profile-img w100 h100 br50px"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "input-file",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "new-shadow add-btn bw1px bo16 bss",
                                                        onClick: ()=>{
                                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                open: "uploadAdvisorProfile"
                                                            }));
                                                        },
                                                        style: {
                                                            top: '25px',
                                                            left: '-20px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            viewBox: "0 0 487 487",
                                                            className: "zi3",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z              M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9              v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z              M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z              M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "w100 fs1-25rem fw600 c15",
                                                children: [
                                                    selectedAdvisor?.['firstName'],
                                                    " ",
                                                    selectedAdvisor?.['lastName']
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "w100 fs0-875rem c14",
                                                children: "Upload Image"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aife",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcc mb0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c15 fs1rem",
                                                children: "Open to new clients?"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                color: "success",
                                                checked: selectedAdvisor?.['isNewClient'] == true,
                                                onChange: (e)=>updateAdvisorField(selectedAdvisor?.['_id'], 'isNewClient', e.target.checked)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6214114c8c7e1e11$export$4202723ba73439f5), {
                                        color: (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(selectedAdvisor) ? '#008000' : '#F44336'
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mt0-5rem",
                                        children: SelectAdvisor()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df aic jcsb mb1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem c15",
                                    children: "Advisor Contact Information"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic jcsb mb0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df aic w50 mr0-5rem pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        class: "pa c1 mx1rem",
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 18 18",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            "fill-rule": "evenodd",
                                                            "clip-rule": "evenodd",
                                                            d: "M9 3C7.34314 3 6 4.34315 6 6C6 7.65683 7.34314 9 9 9C10.6568 9 12 7.65683 12 6C12 4.34315 10.6568 3 9 3ZM4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6C13.5 8.48528 11.4853 10.5 9 10.5C6.51472 10.5 4.5 8.48528 4.5 6ZM4.35986 12.4624C5.58257 11.6981 7.22506 11.25 9 11.25C10.775 11.25 12.4174 11.6981 13.6402 12.4624C14.8522 13.22 15.75 14.3626 15.75 15.75C15.75 16.1642 15.4142 16.5 15 16.5C14.5858 16.5 14.25 16.1642 14.25 15.75C14.25 15.0664 13.8046 14.334 12.8452 13.7344C11.8963 13.1414 10.5388 12.75 9 12.75C7.46122 12.75 6.10372 13.1414 5.15485 13.7344C4.19543 14.334 3.75 15.0664 3.75 15.75C3.75 16.1642 3.41421 16.5 3 16.5C2.58579 16.5 2.25 16.1642 2.25 15.75C2.25 14.3626 3.14771 13.22 4.35986 12.4624Z",
                                                            fill: "#505050"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        className: `w100 bg1 bw1px bss py0-75rem br10px pl3rem ${selectedAdvisor?.['firstName'] && selectedAdvisor['firstName'].length > 0 ? 'bo42' : 'bo4'}`,
                                                        value: selectedAdvisor?.['firstName'] || '',
                                                        onChange: (e)=>handleAdvisorChange('firstName', e.target.value),
                                                        id: "firstName",
                                                        placeholder: "First Name",
                                                        type: "text"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df aic w50",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    className: `w100 bg1 bw1px bss py0-75rem br10px pl1rem ${selectedAdvisor?.['lastName'] && selectedAdvisor['lastName'].length > 0 ? 'bo42' : 'bo4'}`,
                                                    value: selectedAdvisor?.['lastName'] || '',
                                                    onChange: (e)=>handleAdvisorChange('lastName', e.target.value),
                                                    id: "lastName",
                                                    placeholder: "Last Name",
                                                    type: "text"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                class: "pa c1 mx1rem",
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                        "clip-path": "url(#clip0_3929_48261)",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M15.0019 17.3974H2.99813C2.20343 17.3959 1.44171 17.0796 0.879773 16.5176C0.317837 15.9557 0.00148681 15.194 0 14.3993L0 7.20492C-1.39515e-06 6.40925 0.315692 5.64609 0.877788 5.08294C1.43988 4.51979 2.20246 4.20266 2.99813 4.20117H15.0019C15.7975 4.20266 16.5601 4.51979 17.1222 5.08294C17.6843 5.64609 18 6.40925 18 7.20492V14.3993C17.9985 15.194 17.6822 15.9557 17.1202 16.5176C16.5583 17.0796 15.7966 17.3959 15.0019 17.3974ZM2.99813 5.40492C2.52074 5.40492 2.0629 5.59456 1.72533 5.93213C1.38777 6.2697 1.19813 6.72753 1.19813 7.20492V14.3993C1.19813 14.8767 1.38777 15.3345 1.72533 15.6721C2.0629 16.0097 2.52074 16.1993 2.99813 16.1993H15.0019C15.4793 16.1993 15.9371 16.0097 16.2747 15.6721C16.6122 15.3345 16.8019 14.8767 16.8019 14.3993V7.20492C16.8019 6.72753 16.6122 6.2697 16.2747 5.93213C15.9371 5.59456 15.4793 5.40492 15.0019 5.40492H2.99813Z",
                                                                fill: "#505050"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M11.9994 3.59969C11.9203 3.59969 11.8421 3.58412 11.769 3.55387C11.696 3.52363 11.6297 3.47929 11.5738 3.4234C11.5179 3.36751 11.4736 3.30116 11.4433 3.22814C11.4131 3.15512 11.3975 3.07685 11.3975 2.99781V2.40156C11.3975 2.24291 11.3349 2.09066 11.2232 1.97795C11.1115 1.86524 10.9599 1.80117 10.8013 1.79969H7.20125C7.04162 1.79969 6.88853 1.8631 6.77566 1.97597C6.66279 2.08885 6.59937 2.24194 6.59937 2.40156V2.99781C6.60748 3.08136 6.59802 3.16568 6.5716 3.24535C6.54518 3.32503 6.50239 3.3983 6.44598 3.46045C6.38956 3.5226 6.32077 3.57227 6.24402 3.60626C6.16726 3.64025 6.08425 3.6578 6.00031 3.6578C5.91637 3.6578 5.83336 3.64025 5.75661 3.60626C5.67986 3.57227 5.61106 3.5226 5.55465 3.46045C5.49823 3.3983 5.45544 3.32503 5.42902 3.24535C5.4026 3.16568 5.39314 3.08136 5.40125 2.99781V2.40156C5.40125 1.92417 5.59089 1.46634 5.92846 1.12877C6.26602 0.791205 6.72386 0.601563 7.20125 0.601562H10.8013C11.2786 0.601563 11.7365 0.791205 12.074 1.12877C12.4116 1.46634 12.6012 1.92417 12.6012 2.40156V2.99781C12.6012 3.07685 12.5857 3.15512 12.5554 3.22814C12.5252 3.30116 12.4809 3.36751 12.425 3.4234C12.3691 3.47929 12.3027 3.52363 12.2297 3.55387C12.1567 3.58412 12.0784 3.59969 11.9994 3.59969Z",
                                                                fill: "#505050"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M9.00154 11.0587C8.4194 11.0532 7.84475 10.9268 7.31404 10.6875L3.37654 8.94935C3.22736 8.88446 3.11006 8.76296 3.05046 8.61158C2.99086 8.4602 2.99383 8.29135 3.05873 8.14217C3.12362 7.99298 3.24512 7.87569 3.3965 7.81609C3.54788 7.75648 3.71673 7.75946 3.86592 7.82435L7.80341 9.57373C8.18689 9.7438 8.60173 9.83167 9.02123 9.83167C9.44072 9.83167 9.85557 9.7438 10.239 9.57373L14.1765 7.82435C14.2504 7.79222 14.3299 7.77495 14.4104 7.77353C14.491 7.77211 14.571 7.78657 14.646 7.81609C14.7209 7.8456 14.7893 7.88958 14.8473 7.94553C14.9052 8.00148 14.9516 8.0683 14.9837 8.14217C15.0159 8.21603 15.0331 8.29551 15.0345 8.37605C15.036 8.45659 15.0215 8.53663 14.992 8.61158C14.9625 8.68653 14.9185 8.75494 14.8625 8.8129C14.8066 8.87085 14.7398 8.91722 14.6659 8.94935L10.689 10.6875C10.1583 10.9268 9.58368 11.0532 9.00154 11.0587Z",
                                                                fill: "#505050"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip0_3929_48261",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "18",
                                                                height: "18",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `w100 bg1 bw1px bss py0-75rem br10px pl3rem ${selectedAdvisor?.['title'] && selectedAdvisor['title'].length > 0 || selectedAdvisor?.['designation'] && selectedAdvisor['designation'].length > 0 ? 'bo42' : 'bo4'}`,
                                                value: selectedAdvisor['designation'] || selectedAdvisor?.['title'] || '',
                                                onChange: (e)=>handleAdvisorChange('title', e.target.value),
                                                id: "title",
                                                placeholder: "Title",
                                                type: "text"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                class: "pa c1 mx1rem",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M19.8571 4.85742H4.14286C3.57454 4.85742 3.02949 5.08319 2.62763 5.48505C2.22576 5.88691 2 6.43196 2 7.00028V17.0003C2 17.5686 2.22576 18.1136 2.62763 18.5155C3.02949 18.9174 3.57454 19.1431 4.14286 19.1431H19.8571C20.4255 19.1431 20.9705 18.9174 21.3724 18.5155C21.7742 18.1136 22 17.5686 22 17.0003V7.00028C22 6.43196 21.7742 5.88691 21.3724 5.48505C20.9705 5.08319 20.4255 4.85742 19.8571 4.85742ZM19.55 6.28599L12.3071 12.0574C12.1 12.2503 11.9 12.2503 11.65 12.0574L4.45 6.28599H19.55ZM19.8571 17.7146H4.14286C3.95342 17.7146 3.77174 17.6393 3.63778 17.5054C3.50383 17.3714 3.42857 17.1897 3.42857 17.0003V7.30028L10.7214 13.1074C11.068 13.4439 11.5313 13.6333 12.0143 13.636C12.4695 13.6341 12.9066 13.4577 13.2357 13.1431L20.5714 7.30028V17.0003C20.5714 17.1897 20.4962 17.3714 20.3622 17.5054C20.2283 17.6393 20.0466 17.7146 19.8571 17.7146Z",
                                                    fill: "#505050"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `w100 bg1 bw1px bss py0-75rem br10px pl3rem ${selectedAdvisor?.['email'] && selectedAdvisor['email'].length > 0 ? 'bo42' : 'bo4'}`,
                                                value: selectedAdvisor?.['email'] || '',
                                                onChange: (e)=>handleAdvisorChange('email', e.target.value),
                                                id: "email",
                                                placeholder: "Email",
                                                type: "text"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                class: "pa c1 mx1rem",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M19.8571 4.85742H4.14286C3.57454 4.85742 3.02949 5.08319 2.62763 5.48505C2.22576 5.88691 2 6.43196 2 7.00028V17.0003C2 17.5686 2.22576 18.1136 2.62763 18.5155C3.02949 18.9174 3.57454 19.1431 4.14286 19.1431H19.8571C20.4255 19.1431 20.9705 18.9174 21.3724 18.5155C21.7742 18.1136 22 17.5686 22 17.0003V7.00028C22 6.43196 21.7742 5.88691 21.3724 5.48505C20.9705 5.08319 20.4255 4.85742 19.8571 4.85742ZM19.55 6.28599L12.3071 12.0574C12.1 12.2503 11.9 12.2503 11.65 12.0574L4.45 6.28599H19.55ZM19.8571 17.7146H4.14286C3.95342 17.7146 3.77174 17.6393 3.63778 17.5054C3.50383 17.3714 3.42857 17.1897 3.42857 17.0003V7.30028L10.7214 13.1074C11.068 13.4439 11.5313 13.6333 12.0143 13.636C12.4695 13.6341 12.9066 13.4577 13.2357 13.1431L20.5714 7.30028V17.0003C20.5714 17.1897 20.4962 17.3714 20.3622 17.5054C20.2283 17.6393 20.0466 17.7146 19.8571 17.7146Z",
                                                    fill: "#505050"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `w100 bg1 bw1px bss py0-75rem br10px pl3rem ${selectedAdvisor?.['alternativeEmail'] && selectedAdvisor['alternativeEmail'].length > 0 ? 'bo42' : 'bo4'}`,
                                                value: selectedAdvisor?.['alternativeEmail'] || '',
                                                onChange: (e)=>handleAdvisorChange('alternativeEmail', e.target.value),
                                                id: "alternativeEmail",
                                                placeholder: "Alternative Email",
                                                type: "text"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                class: "pa c1 mx1rem",
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M3.66509 11.9652C5.44048 14.0874 7.57765 15.7584 10.0169 16.9407C10.9457 17.3809 12.1877 17.903 13.5714 17.9925C13.6572 17.9963 13.7393 18 13.8251 18C14.7538 18 15.4997 17.6792 16.1077 17.0191C16.1114 17.0153 16.1189 17.0079 16.1226 17.0004C16.3389 16.7393 16.5851 16.5044 16.8425 16.2545C17.0178 16.0866 17.1968 15.9113 17.3684 15.7323C18.1628 14.9043 18.1628 13.8525 17.3609 13.0506L15.1193 10.809C14.7389 10.4136 14.2838 10.2047 13.8064 10.2047C13.329 10.2047 12.8702 10.4136 12.4786 10.8052L11.1433 12.1405C11.0203 12.0696 10.8934 12.0062 10.7741 11.9465C10.6249 11.8719 10.4869 11.8011 10.3638 11.7228C9.14789 10.9507 8.04387 9.94364 6.98834 8.6494C6.45498 7.97431 6.09692 7.40738 5.84702 6.82926C6.19763 6.51223 6.52585 6.18027 6.84288 5.85578C6.95477 5.74016 7.0704 5.62453 7.18602 5.50891C7.58884 5.10609 7.80517 4.63987 7.80517 4.16618C7.80517 3.6925 7.59257 3.22627 7.18602 2.82346L6.07454 1.71198C5.944 1.58143 5.82092 1.45462 5.6941 1.32408C5.44794 1.07045 5.19058 0.809366 4.93695 0.574389C4.55279 0.197679 4.10148 0 3.62407 0C3.15038 0 2.69535 0.197679 2.29626 0.578119L0.901314 1.97306C0.394062 2.48031 0.106868 3.09573 0.0471908 3.80812C-0.0236753 4.69954 0.140436 5.64691 0.565633 6.79196C1.21835 8.56361 2.20301 10.2085 3.66509 11.9652ZM0.957261 3.88645C1.00202 3.39039 1.19224 2.97638 1.5503 2.61832L2.93778 1.23083C3.15411 1.02196 3.39282 0.9138 3.62407 0.9138C3.85158 0.9138 4.08283 1.02196 4.29543 1.23829C4.54533 1.46954 4.7803 1.71198 5.03393 1.96933C5.16074 2.09988 5.29129 2.23042 5.42183 2.36469L6.53331 3.47617C6.76455 3.70742 6.88391 3.9424 6.88391 4.17364C6.88391 4.40489 6.76455 4.63987 6.53331 4.87111C6.41768 4.98674 6.30206 5.10609 6.18644 5.22172C5.83957 5.57232 5.51507 5.90427 5.15701 6.2213C5.14955 6.22876 5.14582 6.23249 5.13836 6.23995C4.82879 6.54952 4.87728 6.84418 4.95187 7.06797C4.9556 7.07915 4.95933 7.08661 4.96306 7.0978C5.25026 7.78782 5.64935 8.44426 6.27222 9.22752C7.39116 10.6075 8.56978 11.678 9.86775 12.5023C10.0281 12.6067 10.1997 12.6888 10.3601 12.7708C10.5093 12.8454 10.6473 12.9163 10.7704 12.9946C10.7853 13.0021 10.7965 13.0095 10.8114 13.017C10.9345 13.0804 11.0538 13.1102 11.1732 13.1102C11.4716 13.1102 11.6655 12.92 11.7289 12.8566L13.1239 11.4617C13.3402 11.2453 13.5752 11.1297 13.8064 11.1297C14.0899 11.1297 14.3211 11.305 14.4666 11.4617L16.7157 13.707C17.1632 14.1546 17.1595 14.6395 16.7045 15.1131C16.5478 15.281 16.3837 15.4414 16.2084 15.6092C15.9473 15.8628 15.675 16.1239 15.4289 16.4186C14.9999 16.8811 14.489 17.0974 13.8288 17.0974C13.7654 17.0974 13.6982 17.0937 13.6348 17.0899C12.4115 17.0116 11.2739 16.5342 10.4198 16.1276C8.09982 15.005 6.06335 13.4123 4.37375 11.3908C2.98254 9.71612 2.04636 8.15707 1.42722 6.48612C1.04305 5.46042 0.897585 4.63614 0.957261 3.88645Z",
                                                    fill: "#505050",
                                                    stroke: "#505050",
                                                    "stroke-width": "0.5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `w100 bg1 bw1px bss py0-75rem br10px pl3rem ${selectedAdvisor?.['phone'] && selectedAdvisor['phone'].length > 0 ? 'bo42' : 'bo4'}`,
                                                value: selectedAdvisor?.['phone'] || '',
                                                onChange: (e)=>handleAdvisorChange('phone', e.target.value),
                                                id: "phone",
                                                placeholder: "Phone Number",
                                                type: "text"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                class: "pa c1 mx1rem",
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                        "clip-path": "url(#clip0_3652_1947)",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M5 17H1V6H5V17ZM1.66663 16.2904H4.33337V6.70964H1.66663V16.2904Z",
                                                                fill: "#505050",
                                                                stroke: "#505050",
                                                                "stroke-width": "0.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M17 17H13V10.9677C13 10.3799 12.5522 9.90321 12 9.90321C11.4476 9.90321 11 10.3799 11 10.9677V17H7V6H11V6.71406C11.6038 6.24937 12.33 5.99948 13.075 6C15.2374 6 17 7.86734 17 10.1649V17ZM13.6666 16.2904H16.3333V10.1649C16.3287 8.25341 14.8706 6.70717 13.075 6.70964C12.2542 6.70964 11.4833 7.07778 10.9083 7.74311L10.3333 8.41285V6.70964H7.66663V16.2904H10.3333V10.9677C10.3333 9.98781 11.0795 9.19357 12 9.19357C12.9204 9.19357 13.6666 9.98781 13.6666 10.9677V16.2904Z",
                                                                fill: "#505050",
                                                                stroke: "#505050",
                                                                "stroke-width": "0.5"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M3 5C1.89539 5 1 4.10461 1 3C1 1.89551 1.89539 1 3 1C4.10461 1 5 1.89551 5 3C4.99768 4.10364 4.10364 4.9978 3 5ZM3 1.66675C2.26367 1.66675 1.66663 2.26367 1.66663 3C1.66663 3.73645 2.26367 4.33337 3 4.33337C3.73633 4.33337 4.33337 3.73645 4.33337 3C4.33337 2.26367 3.73633 1.66675 3 1.66675Z",
                                                                fill: "#505050",
                                                                stroke: "#505050",
                                                                "stroke-width": "0.5"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip0_3652_1947",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "18",
                                                                height: "18",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `w100 bg1 bw1px bss py0-75rem br10px pl3rem ${selectedAdvisor?.['linkedIn'] && selectedAdvisor['linkedIn'].length > 0 ? 'bo42' : 'bo4'}`,
                                                value: selectedAdvisor?.['linkedIn'] || '',
                                                onChange: (e)=>handleAdvisorChange('linkedIn', e.target.value),
                                                id: "linkedIn",
                                                placeholder: "LinkedIn",
                                                type: "text"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb0-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "pa mx1rem",
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20ZM19 7H5V6H19V7Z",
                                                    fill: "#000000"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: `w100 bg1 bw1px bss py0-75rem br10px pl3rem ${selectedAdvisor?.['calendarLink'] && selectedAdvisor['calendarLink'].length > 0 ? 'bo42' : 'bo4'}`,
                                                value: selectedAdvisor?.['calendarLink'] || '',
                                                onChange: (e)=>handleAdvisorChange('calendarLink', e.target.value),
                                                id: "calendarLink",
                                                placeholder: "Insert link to your online calendar e.g. calendly",
                                                type: "text"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic mb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem fw500 c15",
                                        children: "Additional Information for Advisor"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "Match"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df mb0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w50 mr0-5rem pr df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "pa",
                                                style: {
                                                    left: '12px',
                                                    zIndex: 1
                                                },
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M9.00039 1.12507C8.0136 1.12088 7.0357 1.31162 6.12282 1.68635C5.20994 2.06108 4.38005 2.61241 3.6808 3.3087C2.98155 4.00499 2.4267 4.83253 2.0481 5.74381C1.6695 6.65509 1.47461 7.63217 1.47461 8.61897C1.47461 9.60577 1.6695 10.5829 2.0481 11.4941C2.4267 12.4054 2.98155 13.233 3.6808 13.9292C4.38005 14.6255 5.20994 15.1769 6.12282 15.5516C7.0357 15.9263 8.0136 16.1171 9.00039 16.1129C9.14102 16.1129 9.27883 16.1101 9.41664 16.1016V14.9738C9.28164 14.9823 9.14664 14.9879 9.00883 14.9879H9.00039C8.09195 14.9879 7.1132 13.7279 6.59851 11.7085H8.81195V10.5835H6.37352C6.18602 9.28147 6.18602 7.95929 6.37352 6.65726H11.6245C11.7078 7.22555 11.7548 7.79859 11.7651 8.37288L12.8901 8.35319C12.8805 7.78592 12.8382 7.21967 12.7635 6.65726H15.0895C15.2969 7.29096 15.4022 7.9536 15.4016 8.62038C15.4024 8.86102 15.3883 9.10147 15.3595 9.34038H16.4929C16.5154 9.10976 16.5266 8.86788 16.5266 8.62038C16.5207 6.62895 15.7249 4.72123 14.3139 3.31598C12.9028 1.91072 10.9918 1.12277 9.00039 1.12507ZM2.59914 8.62038C2.59854 7.9536 2.70392 7.29096 2.91133 6.65726H5.23727C5.06381 7.96032 5.06476 9.28069 5.24008 10.5835H2.91133C2.70414 9.94975 2.59877 9.28714 2.59914 8.62038ZM6.57039 14.5126C5.22949 13.9606 4.1138 12.9727 3.40352 11.7085H5.44539C5.65388 12.7017 6.03463 13.6507 6.57039 14.5126ZM5.44258 5.53226H3.40352C4.11213 4.26671 5.22836 3.27837 6.57039 2.72819C6.032 3.58904 5.65018 4.53836 5.44258 5.53226ZM6.59851 5.53226C7.1132 3.51007 8.09195 2.25007 9.00039 2.25007C9.91445 2.25007 10.8904 3.49882 11.4051 5.53226H6.59851ZM12.5638 5.53226C12.3621 4.5419 11.986 3.5953 11.4529 2.73663C12.7853 3.28885 13.8929 4.27363 14.5973 5.53226H12.5638Z",
                                                        fill: "#505050"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M12.5124 16.7429C12.614 16.8283 12.7425 16.8751 12.8752 16.8751C13.008 16.8751 13.1364 16.8283 13.2381 16.7429C13.3337 16.6613 15.5668 14.7516 15.5668 12.3666C15.5697 12.0114 15.5022 11.659 15.3682 11.3299C15.2342 11.0009 15.0364 10.7016 14.7862 10.4494C14.536 10.1971 14.2383 9.99691 13.9103 9.86029C13.5823 9.72366 13.2305 9.65332 12.8752 9.65332C12.5199 9.65332 12.1682 9.72366 11.8402 9.86029C11.5122 9.99691 11.2145 10.1971 10.9643 10.4494C10.7141 10.7016 10.5163 11.0009 10.3823 11.3299C10.2483 11.659 10.1808 12.0114 10.1837 12.3666C10.1837 14.7516 12.4168 16.6613 12.5124 16.7429ZM12.8752 10.7776C13.2936 10.7809 13.6935 10.9501 13.9873 11.248C14.281 11.546 14.4445 11.9483 14.4418 12.3666C14.4418 13.7166 13.4349 14.9513 12.8752 15.5335C12.3156 14.9513 11.3087 13.7166 11.3087 12.3666C11.306 11.9483 11.4695 11.546 11.7632 11.248C12.0569 10.9501 12.4569 10.7809 12.8752 10.7776Z",
                                                        fill: "#505050"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M13.4331 12.3655C13.4319 12.2553 13.3982 12.1479 13.3361 12.0569C13.2741 11.9658 13.1865 11.8952 13.0844 11.8538C12.9822 11.8125 12.8702 11.8022 12.7622 11.8244C12.6543 11.8466 12.5554 11.9003 12.4779 11.9786C12.4004 12.0569 12.3478 12.1564 12.3267 12.2646C12.3056 12.3727 12.317 12.4847 12.3595 12.5864C12.4019 12.688 12.4735 12.7749 12.5652 12.836C12.6568 12.8971 12.7646 12.9297 12.8747 12.9297C13.0236 12.9289 13.1661 12.869 13.2708 12.7632C13.3755 12.6574 13.4339 12.5143 13.4331 12.3655Z",
                                                        fill: "#505050"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                displayEmpty: true,
                                                value: selectedAdvisor?.['affiliateCompany'] || '',
                                                onChange: (e)=>handleAdvisorChange('affiliateCompany', e.target.value),
                                                renderValue: (selected)=>selected || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fsi c12",
                                                        children: "Affiliate Company"
                                                    }),
                                                sx: {
                                                    borderRadius: '10px',
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: '1px solid #E5E7EB'
                                                    },
                                                    '& .MuiSelect-select': {
                                                        padding: '12px',
                                                        paddingLeft: '40px'
                                                    }
                                                },
                                                children: [
                                                    'None',
                                                    'CFO Centre',
                                                    'Fractionality',
                                                    'Other'
                                                ].map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                        value: item,
                                                        children: item
                                                    }, item))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w50 mr0-5rem pr df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "pa",
                                                style: {
                                                    left: '12px',
                                                    zIndex: 1
                                                },
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M9.00039 1.12507C8.0136 1.12088 7.0357 1.31162 6.12282 1.68635C5.20994 2.06108 4.38005 2.61241 3.6808 3.3087C2.98155 4.00499 2.4267 4.83253 2.0481 5.74381C1.6695 6.65509 1.47461 7.63217 1.47461 8.61897C1.47461 9.60577 1.6695 10.5829 2.0481 11.4941C2.4267 12.4054 2.98155 13.233 3.6808 13.9292C4.38005 14.6255 5.20994 15.1769 6.12282 15.5516C7.0357 15.9263 8.0136 16.1171 9.00039 16.1129C9.14102 16.1129 9.27883 16.1101 9.41664 16.1016V14.9738C9.28164 14.9823 9.14664 14.9879 9.00883 14.9879H9.00039C8.09195 14.9879 7.1132 13.7279 6.59851 11.7085H8.81195V10.5835H6.37352C6.18602 9.28147 6.18602 7.95929 6.37352 6.65726H11.6245C11.7078 7.22555 11.7548 7.79859 11.7651 8.37288L12.8901 8.35319C12.8805 7.78592 12.8382 7.21967 12.7635 6.65726H15.0895C15.2969 7.29096 15.4022 7.9536 15.4016 8.62038C15.4024 8.86102 15.3883 9.10147 15.3595 9.34038H16.4929C16.5154 9.10976 16.5266 8.86788 16.5266 8.62038C16.5207 6.62895 15.7249 4.72123 14.3139 3.31598C12.9028 1.91072 10.9918 1.12277 9.00039 1.12507ZM2.59914 8.62038C2.59854 7.9536 2.70392 7.29096 2.91133 6.65726H5.23727C5.06381 7.96032 5.06476 9.28069 5.24008 10.5835H2.91133C2.70414 9.94975 2.59877 9.28714 2.59914 8.62038ZM6.57039 14.5126C5.22949 13.9606 4.1138 12.9727 3.40352 11.7085H5.44539C5.65388 12.7017 6.03463 13.6507 6.57039 14.5126ZM5.44258 5.53226H3.40352C4.11213 4.26671 5.22836 3.27837 6.57039 2.72819C6.032 3.58904 5.65018 4.53836 5.44258 5.53226ZM6.59851 5.53226C7.1132 3.51007 8.09195 2.25007 9.00039 2.25007C9.91445 2.25007 10.8904 3.49882 11.4051 5.53226H6.59851ZM12.5638 5.53226C12.3621 4.5419 11.986 3.5953 11.4529 2.73663C12.7853 3.28885 13.8929 4.27363 14.5973 5.53226H12.5638Z",
                                                        fill: "#505050"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M12.5124 16.7429C12.614 16.8283 12.7425 16.8751 12.8752 16.8751C13.008 16.8751 13.1364 16.8283 13.2381 16.7429C13.3337 16.6613 15.5668 14.7516 15.5668 12.3666C15.5697 12.0114 15.5022 11.659 15.3682 11.3299C15.2342 11.0009 15.0364 10.7016 14.7862 10.4494C14.536 10.1971 14.2383 9.99691 13.9103 9.86029C13.5823 9.72366 13.2305 9.65332 12.8752 9.65332C12.5199 9.65332 12.1682 9.72366 11.8402 9.86029C11.5122 9.99691 11.2145 10.1971 10.9643 10.4494C10.7141 10.7016 10.5163 11.0009 10.3823 11.3299C10.2483 11.659 10.1808 12.0114 10.1837 12.3666C10.1837 14.7516 12.4168 16.6613 12.5124 16.7429ZM12.8752 10.7776C13.2936 10.7809 13.6935 10.9501 13.9873 11.248C14.281 11.546 14.4445 11.9483 14.4418 12.3666C14.4418 13.7166 13.4349 14.9513 12.8752 15.5335C12.3156 14.9513 11.3087 13.7166 11.3087 12.3666C11.306 11.9483 11.4695 11.546 11.7632 11.248C12.0569 10.9501 12.4569 10.7809 12.8752 10.7776Z",
                                                        fill: "#505050"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M13.4331 12.3655C13.4319 12.2553 13.3982 12.1479 13.3361 12.0569C13.2741 11.9658 13.1865 11.8952 13.0844 11.8538C12.9822 11.8125 12.8702 11.8022 12.7622 11.8244C12.6543 11.8466 12.5554 11.9003 12.4779 11.9786C12.4004 12.0569 12.3478 12.1564 12.3267 12.2646C12.3056 12.3727 12.317 12.4847 12.3595 12.5864C12.4019 12.688 12.4735 12.7749 12.5652 12.836C12.6568 12.8971 12.7646 12.9297 12.8747 12.9297C13.0236 12.9289 13.1661 12.869 13.2708 12.7632C13.3755 12.6574 13.4339 12.5143 13.4331 12.3655Z",
                                                        fill: "#505050"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                displayEmpty: true,
                                                value: selectedAdvisor?.['uCountry'] || '',
                                                onChange: (e)=>handleAdvisorChange('uCountry', e.target.value),
                                                renderValue: (selected)=>selected || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fsi c12",
                                                        children: "Select Country"
                                                    }),
                                                sx: {
                                                    borderRadius: '10px',
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: '1px solid #E5E7EB'
                                                    },
                                                    '& .MuiSelect-select': {
                                                        padding: '12px',
                                                        paddingLeft: '40px'
                                                    }
                                                },
                                                children: [
                                                    'United Kingdom',
                                                    'United States',
                                                    'Canada',
                                                    'Australia',
                                                    'Other'
                                                ].map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                        value: item,
                                                        children: item
                                                    }, item))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df mb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w50 mr0-5rem pr df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "pa",
                                                style: {
                                                    left: '12px',
                                                    zIndex: 1
                                                },
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M9.00039 1.12507C8.0136 1.12088 7.0357 1.31162 6.12282 1.68635C5.20994 2.06108 4.38005 2.61241 3.6808 3.3087C2.98155 4.00499 2.4267 4.83253 2.0481 5.74381C1.6695 6.65509 1.47461 7.63217 1.47461 8.61897C1.47461 9.60577 1.6695 10.5829 2.0481 11.4941C2.4267 12.4054 2.98155 13.233 3.6808 13.9292C4.38005 14.6255 5.20994 15.1769 6.12282 15.5516C7.0357 15.9263 8.0136 16.1171 9.00039 16.1129C9.14102 16.1129 9.27883 16.1101 9.41664 16.1016V14.9738C9.28164 14.9823 9.14664 14.9879 9.00883 14.9879H9.00039C8.09195 14.9879 7.1132 13.7279 6.59851 11.7085H8.81195V10.5835H6.37352C6.18602 9.28147 6.18602 7.95929 6.37352 6.65726H11.6245C11.7078 7.22555 11.7548 7.79859 11.7651 8.37288L12.8901 8.35319C12.8805 7.78592 12.8382 7.21967 12.7635 6.65726H15.0895C15.2969 7.29096 15.4022 7.9536 15.4016 8.62038C15.4024 8.86102 15.3883 9.10147 15.3595 9.34038H16.4929C16.5154 9.10976 16.5266 8.86788 16.5266 8.62038C16.5207 6.62895 15.7249 4.72123 14.3139 3.31598C12.9028 1.91072 10.9918 1.12277 9.00039 1.12507ZM2.59914 8.62038C2.59854 7.9536 2.70392 7.29096 2.91133 6.65726H5.23727C5.06381 7.96032 5.06476 9.28069 5.24008 10.5835H2.91133C2.70414 9.94975 2.59877 9.28714 2.59914 8.62038ZM6.57039 14.5126C5.22949 13.9606 4.1138 12.9727 3.40352 11.7085H5.44539C5.65388 12.7017 6.03463 13.6507 6.57039 14.5126ZM5.44258 5.53226H3.40352C4.11213 4.26671 5.22836 3.27837 6.57039 2.72819C6.032 3.58904 5.65018 4.53836 5.44258 5.53226ZM6.59851 5.53226C7.1132 3.51007 8.09195 2.25007 9.00039 2.25007C9.91445 2.25007 10.8904 3.49882 11.4051 5.53226H6.59851ZM12.5638 5.53226C12.3621 4.5419 11.986 3.5953 11.4529 2.73663C12.7853 3.28885 13.8929 4.27363 14.5973 5.53226H12.5638Z",
                                                        fill: "#505050"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M12.5124 16.7429C12.614 16.8283 12.7425 16.8751 12.8752 16.8751C13.008 16.8751 13.1364 16.8283 13.2381 16.7429C13.3337 16.6613 15.5668 14.7516 15.5668 12.3666C15.5697 12.0114 15.5022 11.659 15.3682 11.3299C15.2342 11.0009 15.0364 10.7016 14.7862 10.4494C14.536 10.1971 14.2383 9.99691 13.9103 9.86029C13.5823 9.72366 13.2305 9.65332 12.8752 9.65332C12.5199 9.65332 12.1682 9.72366 11.8402 9.86029C11.5122 9.99691 11.2145 10.1971 10.9643 10.4494C10.7141 10.7016 10.5163 11.0009 10.3823 11.3299C10.2483 11.659 10.1808 12.0114 10.1837 12.3666C10.1837 14.7516 12.4168 16.6613 12.5124 16.7429ZM12.8752 10.7776C13.2936 10.7809 13.6935 10.9501 13.9873 11.248C14.281 11.546 14.4445 11.9483 14.4418 12.3666C14.4418 13.7166 13.4349 14.9513 12.8752 15.5335C12.3156 14.9513 11.3087 13.7166 11.3087 12.3666C11.306 11.9483 11.4695 11.546 11.7632 11.248C12.0569 10.9501 12.4569 10.7809 12.8752 10.7776Z",
                                                        fill: "#505050"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M13.4331 12.3655C13.4319 12.2553 13.3982 12.1479 13.3361 12.0569C13.2741 11.9658 13.1865 11.8952 13.0844 11.8538C12.9822 11.8125 12.8702 11.8022 12.7622 11.8244C12.6543 11.8466 12.5554 11.9003 12.4779 11.9786C12.4004 12.0569 12.3478 12.1564 12.3267 12.2646C12.3056 12.3727 12.317 12.4847 12.3595 12.5864C12.4019 12.688 12.4735 12.7749 12.5652 12.836C12.6568 12.8971 12.7646 12.9297 12.8747 12.9297C13.0236 12.9289 13.1661 12.869 13.2708 12.7632C13.3755 12.6574 13.4339 12.5143 13.4331 12.3655Z",
                                                        fill: "#505050"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                displayEmpty: true,
                                                value: selectedAdvisor?.['uRegion'] || '',
                                                onChange: (e)=>handleAdvisorChange('uRegion', e.target.value),
                                                renderValue: (selected)=>selected || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fsi c12",
                                                        children: "Region"
                                                    }),
                                                sx: {
                                                    borderRadius: '10px',
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: '1px solid #E5E7EB'
                                                    },
                                                    '& .MuiSelect-select': {
                                                        padding: '12px',
                                                        paddingLeft: '40px'
                                                    }
                                                },
                                                children: [
                                                    'UK',
                                                    'England & Wales',
                                                    'Scotland',
                                                    'Northern Ireland',
                                                    'North East, North West',
                                                    'Yorkshire & Humberside',
                                                    'East Midlands',
                                                    'West Midlands',
                                                    'East of England',
                                                    'London',
                                                    'South East',
                                                    'South West',
                                                    'Offshore',
                                                    'Other',
                                                    'Non-UK'
                                                ].map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                        value: item,
                                                        children: item
                                                    }, item))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w50 mr0-5rem pr df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "pa",
                                                style: {
                                                    left: '12px',
                                                    zIndex: 1
                                                },
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M8.99939 0C5.40484 0 2.48047 2.92437 2.48047 6.51888C2.48047 10.9798 8.31426 17.5287 8.56264 17.8053C8.79594 18.0651 9.20326 18.0647 9.43613 17.8053C9.68451 17.5287 15.5183 10.9798 15.5183 6.51888C15.5182 2.92437 12.5939 0 8.99939 0ZM8.99939 16.5139C7.03602 14.1817 3.65441 9.5805 3.65441 6.51895C3.65441 3.57166 6.05213 1.17394 8.99939 1.17394C11.9466 1.17394 14.3444 3.57166 14.3444 6.51892C14.3443 9.58061 10.9633 14.181 8.99939 16.5139Z",
                                                        fill: "#505050"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M9.0005 3.23926C7.19199 3.23926 5.7207 4.71058 5.7207 6.51909C5.7207 8.3276 7.19203 9.79892 9.0005 9.79892C10.809 9.79892 12.2803 8.3276 12.2803 6.51909C12.2803 4.71058 10.809 3.23926 9.0005 3.23926ZM9.0005 8.62498C7.83929 8.62498 6.89464 7.6803 6.89464 6.51909C6.89464 5.35788 7.83932 4.4132 9.0005 4.4132C10.1617 4.4132 11.1064 5.35788 11.1064 6.51909C11.1064 7.6803 10.1617 8.62498 9.0005 8.62498Z",
                                                        fill: "#505050"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                className: "w100",
                                                displayEmpty: true,
                                                value: selectedAdvisor?.['uCity'] || '',
                                                onChange: (e)=>handleAdvisorChange('uCity', e.target.value),
                                                renderValue: (selected)=>selected || /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fsi c12",
                                                        children: "City"
                                                    }),
                                                sx: {
                                                    borderRadius: '10px',
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        border: '1px solid #E5E7EB'
                                                    },
                                                    '& .MuiSelect-select': {
                                                        padding: '12px',
                                                        paddingLeft: '40px'
                                                    }
                                                },
                                                children: [
                                                    'All',
                                                    'Birmingham',
                                                    'Bournemouth & Poole',
                                                    'Bristol',
                                                    'Cardiff, Belfast',
                                                    'Edinburgh',
                                                    'Glasgow',
                                                    'Hull',
                                                    'Leeds',
                                                    'Leicester',
                                                    'Liverpool',
                                                    'London',
                                                    'Manchester',
                                                    'Newcastle & Teeside',
                                                    'Sheffield',
                                                    'Southampton',
                                                    'Other'
                                                ].map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                        value: item,
                                                        children: item
                                                    }, item))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-75rem c4 fsi mb1-5rem",
                                children: "Please do not put generic enquiries @email address here. Having qualified the leads, we ask that it be provided to a named individuals within your organisation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `c1 px3rem py0-75rem br20px fw600 ${loading ? 'cna bg16' : 'cp bg4'}`,
                                onClick: saveAdvisorProfile,
                                disabled: loading,
                                children: loading ? 'Saving...' : 'Save Changes'
                            })
                        ]
                    })
                ]
            })
        });
    };
    // Skills & Experience Tab
    const skillsExperience = ()=>{
        let isCompleted = selectedAdvisor?.['specialSkills']?.trim() && selectedAdvisor?.['sectorExperience']?.trim() && selectedAdvisor?.['trackRecord']?.trim();
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "df jcsb aic mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: selectedAdvisor?.['profile'] || (parcelRequire("cfmAr")),
                                    alt: "Profile",
                                    className: "shadow w80px h80px br50px mr1rem bw1px bss bo7"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs1-25rem fw500 c15 ttu",
                                    children: [
                                        selectedAdvisor?.['firstName'],
                                        " ",
                                        selectedAdvisor?.['lastName']
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt0-5rem mr1rem",
                            children: SelectAdvisor()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df jcfe px1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        class: `df jcc aic w150px fs0-75rem p0-5rem bw1px bss br30px ${isCompleted ? 'c14 bo7' : 'c12 bo16'}`,
                        style: {
                            background: isCompleted ? '#ebf9f4' : '#f1f1f1'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                style: {
                                    fontSize: '15px'
                                },
                                class: `fa fa-check-circle mr0-5rem ${isCompleted ? 'c7' : 'c12'}`
                            }),
                            " Completed"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "heading-edit-area df aic mb0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mr0-5rem fs1rem fw400 c15",
                            children: "Special Skills"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "edit-icon cb bg0 br0 cp",
                            onClick: ()=>editInput === 'specialSkills' ? setEditInput('') : setEditInput('specialSkills'),
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_2226_15296)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M16.5 8.24951C16.3011 8.24951 16.1103 8.32853 15.9697 8.46918C15.829 8.60983 15.75 8.8006 15.75 8.99951V13.4995C15.75 14.0962 15.5129 14.6685 15.091 15.0905C14.669 15.5125 14.0967 15.7495 13.5 15.7495H4.5C3.90326 15.7495 3.33097 15.5125 2.90901 15.0905C2.48705 14.6685 2.25 14.0962 2.25 13.4995V4.49951C2.25 3.90277 2.48705 3.33048 2.90901 2.90852C3.33097 2.48656 3.90326 2.24951 4.5 2.24951H9C9.19891 2.24951 9.38968 2.17049 9.53033 2.02984C9.67098 1.88919 9.75 1.69842 9.75 1.49951C9.75 1.3006 9.67098 1.10983 9.53033 0.969182C9.38968 0.828529 9.19891 0.749512 9 0.749512H4.5C4.00754 0.749512 3.51991 0.846508 3.06494 1.03496C2.60997 1.22342 2.19657 1.49964 1.84835 1.84786C1.14509 2.55112 0.75 3.50495 0.75 4.49951V13.4995C0.75 13.992 0.846997 14.4796 1.03545 14.9346C1.22391 15.3895 1.50013 15.8029 1.84835 16.1512C2.55161 16.8544 3.50544 17.2495 4.5 17.2495H13.5C13.9925 17.2495 14.4801 17.1525 14.9351 16.9641C15.39 16.7756 15.8034 16.4994 16.1517 16.1512C16.4999 15.8029 16.7761 15.3895 16.9645 14.9346C17.153 14.4796 17.25 13.992 17.25 13.4995V8.99951C17.25 8.8006 17.171 8.60983 17.0303 8.46918C16.8897 8.32853 16.6989 8.24951 16.5 8.24951Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M5.91001 7.84482C5.70012 8.05445 5.53376 8.3035 5.42049 8.57767C5.30722 8.85183 5.24928 9.14568 5.25001 9.44232V10.4998C5.25001 11.0966 5.48706 11.6689 5.90902 12.0908C6.33097 12.5128 6.90327 12.7498 7.50001 12.7498H8.55751C8.85415 12.7505 9.148 12.6926 9.42216 12.5793C9.69632 12.4661 9.94538 12.2997 10.155 12.0898L16.59 5.65482C16.7998 5.44579 16.9662 5.1974 17.0798 4.92391C17.1933 4.65042 17.2518 4.3572 17.2518 4.06107C17.2518 3.76494 17.1933 3.47172 17.0798 3.19823C16.9662 2.92474 16.7998 2.67635 16.59 2.46732L15.5325 1.40982C15.3235 1.20006 15.0751 1.03363 14.8016 0.920066C14.5281 0.806504 14.2349 0.748047 13.9388 0.748047C13.6426 0.748047 13.3494 0.806504 13.0759 0.920066C12.8024 1.03363 12.554 1.20006 12.345 1.40982L5.91001 7.84482ZM14.4675 2.46732L15.5325 3.53232C15.6722 3.67284 15.7506 3.86293 15.7506 4.06107C15.7506 4.25921 15.6722 4.4493 15.5325 4.58982L14.8875 5.24982L12.75 3.11232L13.395 2.46732C13.4649 2.39589 13.5483 2.33913 13.6404 2.30038C13.7324 2.26163 13.8313 2.24166 13.9313 2.24166C14.0312 2.24166 14.1301 2.26163 14.2222 2.30038C14.3142 2.33913 14.3977 2.39589 14.4675 2.46732ZM6.75001 9.44232C6.74944 9.34362 6.76836 9.24577 6.80568 9.15439C6.843 9.06301 6.898 8.9799 6.96751 8.90982L11.7 4.17732L13.8225 6.29982L9.09001 11.0323C9.01993 11.1018 8.93681 11.1568 8.84544 11.1941C8.75406 11.2315 8.65621 11.2504 8.55751 11.2498H7.50001C7.30109 11.2498 7.11033 11.1708 6.96968 11.0302C6.82902 10.8895 6.75001 10.6987 6.75001 10.4998V9.44232Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_2226_15296",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "18",
                                                height: "18",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "group-inputs",
                        style: {
                            minHeight: '10vh'
                        },
                        children: editInput === 'specialSkills' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac p0rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                rows: 10,
                                className: `c15 fs0-75rem w100`,
                                name: "specialSkills",
                                placeholder: "Enter the Special Skills here...",
                                defaultValue: selectedAdvisor?.['specialSkills'],
                                onBlur: (e)=>{
                                    handleAdvisorChange('specialSkills', e.target.value), setEditInput('');
                                },
                                onChange: (e)=>handleAdvisorChange('specialSkills', e.target.value)
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            onClick: ()=>setEditInput('specialSkills'),
                            className: "cp c15 fs0-75rem",
                            children: selectedAdvisor['specialSkills'] || 'Enter the Special Skills here...'
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "heading-edit-area w100 mb0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mr0-5rem fs1rem fw400 c15",
                            children: "Sector Experience"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "fs0-75rem c12 fsi mr1rem",
                                    children: "(This information is used to assist in creating our 200-word summary)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "edit-icon cb bg0 br0 cp",
                                    onClick: ()=>editInput === 'sectorExperience' ? setEditInput('') : setEditInput('sectorExperience'),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                "clip-path": "url(#clip0_2226_15296)",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M16.5 8.24951C16.3011 8.24951 16.1103 8.32853 15.9697 8.46918C15.829 8.60983 15.75 8.8006 15.75 8.99951V13.4995C15.75 14.0962 15.5129 14.6685 15.091 15.0905C14.669 15.5125 14.0967 15.7495 13.5 15.7495H4.5C3.90326 15.7495 3.33097 15.5125 2.90901 15.0905C2.48705 14.6685 2.25 14.0962 2.25 13.4995V4.49951C2.25 3.90277 2.48705 3.33048 2.90901 2.90852C3.33097 2.48656 3.90326 2.24951 4.5 2.24951H9C9.19891 2.24951 9.38968 2.17049 9.53033 2.02984C9.67098 1.88919 9.75 1.69842 9.75 1.49951C9.75 1.3006 9.67098 1.10983 9.53033 0.969182C9.38968 0.828529 9.19891 0.749512 9 0.749512H4.5C4.00754 0.749512 3.51991 0.846508 3.06494 1.03496C2.60997 1.22342 2.19657 1.49964 1.84835 1.84786C1.14509 2.55112 0.75 3.50495 0.75 4.49951V13.4995C0.75 13.992 0.846997 14.4796 1.03545 14.9346C1.22391 15.3895 1.50013 15.8029 1.84835 16.1512C2.55161 16.8544 3.50544 17.2495 4.5 17.2495H13.5C13.9925 17.2495 14.4801 17.1525 14.9351 16.9641C15.39 16.7756 15.8034 16.4994 16.1517 16.1512C16.4999 15.8029 16.7761 15.3895 16.9645 14.9346C17.153 14.4796 17.25 13.992 17.25 13.4995V8.99951C17.25 8.8006 17.171 8.60983 17.0303 8.46918C16.8897 8.32853 16.6989 8.24951 16.5 8.24951Z",
                                                        fill: "#4A67FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M5.91001 7.84482C5.70012 8.05445 5.53376 8.3035 5.42049 8.57767C5.30722 8.85183 5.24928 9.14568 5.25001 9.44232V10.4998C5.25001 11.0966 5.48706 11.6689 5.90902 12.0908C6.33097 12.5128 6.90327 12.7498 7.50001 12.7498H8.55751C8.85415 12.7505 9.148 12.6926 9.42216 12.5793C9.69632 12.4661 9.94538 12.2997 10.155 12.0898L16.59 5.65482C16.7998 5.44579 16.9662 5.1974 17.0798 4.92391C17.1933 4.65042 17.2518 4.3572 17.2518 4.06107C17.2518 3.76494 17.1933 3.47172 17.0798 3.19823C16.9662 2.92474 16.7998 2.67635 16.59 2.46732L15.5325 1.40982C15.3235 1.20006 15.0751 1.03363 14.8016 0.920066C14.5281 0.806504 14.2349 0.748047 13.9388 0.748047C13.6426 0.748047 13.3494 0.806504 13.0759 0.920066C12.8024 1.03363 12.554 1.20006 12.345 1.40982L5.91001 7.84482ZM14.4675 2.46732L15.5325 3.53232C15.6722 3.67284 15.7506 3.86293 15.7506 4.06107C15.7506 4.25921 15.6722 4.4493 15.5325 4.58982L14.8875 5.24982L12.75 3.11232L13.395 2.46732C13.4649 2.39589 13.5483 2.33913 13.6404 2.30038C13.7324 2.26163 13.8313 2.24166 13.9313 2.24166C14.0312 2.24166 14.1301 2.26163 14.2222 2.30038C14.3142 2.33913 14.3977 2.39589 14.4675 2.46732ZM6.75001 9.44232C6.74944 9.34362 6.76836 9.24577 6.80568 9.15439C6.843 9.06301 6.898 8.9799 6.96751 8.90982L11.7 4.17732L13.8225 6.29982L9.09001 11.0323C9.01993 11.1018 8.93681 11.1568 8.84544 11.1941C8.75406 11.2315 8.65621 11.2504 8.55751 11.2498H7.50001C7.30109 11.2498 7.11033 11.1708 6.96968 11.0302C6.82902 10.8895 6.75001 10.6987 6.75001 10.4998V9.44232Z",
                                                        fill: "#4A67FF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                    id: "clip0_2226_15296",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                        width: "18",
                                                        height: "18",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "group-inputs",
                        style: {
                            minHeight: '15vh'
                        },
                        children: editInput === 'sectorExperience' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac p0rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                rows: 10,
                                className: `c15 fs0-75rem w100`,
                                name: "sectorExperience",
                                placeholder: "Enter the Sector Experience here...",
                                defaultValue: selectedAdvisor?.['sectorExperience'],
                                onBlur: (e)=>{
                                    handleAdvisorChange('sectorExperience', e.target.value), setEditInput('');
                                },
                                onChange: (e)=>handleAdvisorChange('sectorExperience', e.target.value)
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            onClick: ()=>setEditInput('sectorExperience'),
                            className: "cp c15 fs0-75rem",
                            children: selectedAdvisor['sectorExperience'] || 'Enter the Sector Experience here...'
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "heading-edit-area w100 mb0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mr0-5rem fs1rem fw400 c15",
                            children: "Track Record Highlights"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "fs0-75rem c12 fsi mr1rem",
                                    children: "(This information is used to assist in creating our 200-word summary)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "edit-icon cb bg0 br0 cp",
                                    onClick: ()=>editInput === 'trackRecord' ? setEditInput('') : setEditInput('trackRecord'),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                "clip-path": "url(#clip0_2226_15296)",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M16.5 8.24951C16.3011 8.24951 16.1103 8.32853 15.9697 8.46918C15.829 8.60983 15.75 8.8006 15.75 8.99951V13.4995C15.75 14.0962 15.5129 14.6685 15.091 15.0905C14.669 15.5125 14.0967 15.7495 13.5 15.7495H4.5C3.90326 15.7495 3.33097 15.5125 2.90901 15.0905C2.48705 14.6685 2.25 14.0962 2.25 13.4995V4.49951C2.25 3.90277 2.48705 3.33048 2.90901 2.90852C3.33097 2.48656 3.90326 2.24951 4.5 2.24951H9C9.19891 2.24951 9.38968 2.17049 9.53033 2.02984C9.67098 1.88919 9.75 1.69842 9.75 1.49951C9.75 1.3006 9.67098 1.10983 9.53033 0.969182C9.38968 0.828529 9.19891 0.749512 9 0.749512H4.5C4.00754 0.749512 3.51991 0.846508 3.06494 1.03496C2.60997 1.22342 2.19657 1.49964 1.84835 1.84786C1.14509 2.55112 0.75 3.50495 0.75 4.49951V13.4995C0.75 13.992 0.846997 14.4796 1.03545 14.9346C1.22391 15.3895 1.50013 15.8029 1.84835 16.1512C2.55161 16.8544 3.50544 17.2495 4.5 17.2495H13.5C13.9925 17.2495 14.4801 17.1525 14.9351 16.9641C15.39 16.7756 15.8034 16.4994 16.1517 16.1512C16.4999 15.8029 16.7761 15.3895 16.9645 14.9346C17.153 14.4796 17.25 13.992 17.25 13.4995V8.99951C17.25 8.8006 17.171 8.60983 17.0303 8.46918C16.8897 8.32853 16.6989 8.24951 16.5 8.24951Z",
                                                        fill: "#4A67FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M5.91001 7.84482C5.70012 8.05445 5.53376 8.3035 5.42049 8.57767C5.30722 8.85183 5.24928 9.14568 5.25001 9.44232V10.4998C5.25001 11.0966 5.48706 11.6689 5.90902 12.0908C6.33097 12.5128 6.90327 12.7498 7.50001 12.7498H8.55751C8.85415 12.7505 9.148 12.6926 9.42216 12.5793C9.69632 12.4661 9.94538 12.2997 10.155 12.0898L16.59 5.65482C16.7998 5.44579 16.9662 5.1974 17.0798 4.92391C17.1933 4.65042 17.2518 4.3572 17.2518 4.06107C17.2518 3.76494 17.1933 3.47172 17.0798 3.19823C16.9662 2.92474 16.7998 2.67635 16.59 2.46732L15.5325 1.40982C15.3235 1.20006 15.0751 1.03363 14.8016 0.920066C14.5281 0.806504 14.2349 0.748047 13.9388 0.748047C13.6426 0.748047 13.3494 0.806504 13.0759 0.920066C12.8024 1.03363 12.554 1.20006 12.345 1.40982L5.91001 7.84482ZM14.4675 2.46732L15.5325 3.53232C15.6722 3.67284 15.7506 3.86293 15.7506 4.06107C15.7506 4.25921 15.6722 4.4493 15.5325 4.58982L14.8875 5.24982L12.75 3.11232L13.395 2.46732C13.4649 2.39589 13.5483 2.33913 13.6404 2.30038C13.7324 2.26163 13.8313 2.24166 13.9313 2.24166C14.0312 2.24166 14.1301 2.26163 14.2222 2.30038C14.3142 2.33913 14.3977 2.39589 14.4675 2.46732ZM6.75001 9.44232C6.74944 9.34362 6.76836 9.24577 6.80568 9.15439C6.843 9.06301 6.898 8.9799 6.96751 8.90982L11.7 4.17732L13.8225 6.29982L9.09001 11.0323C9.01993 11.1018 8.93681 11.1568 8.84544 11.1941C8.75406 11.2315 8.65621 11.2504 8.55751 11.2498H7.50001C7.30109 11.2498 7.11033 11.1708 6.96968 11.0302C6.82902 10.8895 6.75001 10.6987 6.75001 10.4998V9.44232Z",
                                                        fill: "#4A67FF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                    id: "clip0_2226_15296",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                        width: "18",
                                                        height: "18",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1-5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "group-inputs",
                        style: {
                            minHeight: '15vh'
                        },
                        children: editInput === 'trackRecord' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac p0rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                rows: 10,
                                className: `c15 fs0-75rem w100`,
                                name: "trackRecord",
                                placeholder: "Enter the Track Record Highlights here...",
                                defaultValue: selectedAdvisor?.['trackRecord'],
                                onBlur: (e)=>{
                                    handleAdvisorChange('trackRecord', e.target.value), setEditInput('');
                                },
                                onChange: (e)=>handleAdvisorChange('trackRecord', e.target.value)
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            onClick: ()=>setEditInput('trackRecord'),
                            className: "cp c15 fs0-75rem",
                            children: selectedAdvisor['trackRecord'] || 'Enter the Track Record Highlights here...'
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "heading-edit-area df jcsb mb0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "w100 mr0-5rem fs1rem fw400 c15",
                                    children: "200-word Summary - provided to qualified leads"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "w100 df aic",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            class: "fs0-75rem c12 fsi mr1rem",
                                            children: "(This is your potted bio)"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "edit-icon cb bg0 br0 cp",
                                            onClick: ()=>editInput === 'wordSummary' ? setEditInput('') : setEditInput('wordSummary'),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                        "clip-path": "url(#clip0_2226_15296)",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M16.5 8.24951C16.3011 8.24951 16.1103 8.32853 15.9697 8.46918C15.829 8.60983 15.75 8.8006 15.75 8.99951V13.4995C15.75 14.0962 15.5129 14.6685 15.091 15.0905C14.669 15.5125 14.0967 15.7495 13.5 15.7495H4.5C3.90326 15.7495 3.33097 15.5125 2.90901 15.0905C2.48705 14.6685 2.25 14.0962 2.25 13.4995V4.49951C2.25 3.90277 2.48705 3.33048 2.90901 2.90852C3.33097 2.48656 3.90326 2.24951 4.5 2.24951H9C9.19891 2.24951 9.38968 2.17049 9.53033 2.02984C9.67098 1.88919 9.75 1.69842 9.75 1.49951C9.75 1.3006 9.67098 1.10983 9.53033 0.969182C9.38968 0.828529 9.19891 0.749512 9 0.749512H4.5C4.00754 0.749512 3.51991 0.846508 3.06494 1.03496C2.60997 1.22342 2.19657 1.49964 1.84835 1.84786C1.14509 2.55112 0.75 3.50495 0.75 4.49951V13.4995C0.75 13.992 0.846997 14.4796 1.03545 14.9346C1.22391 15.3895 1.50013 15.8029 1.84835 16.1512C2.55161 16.8544 3.50544 17.2495 4.5 17.2495H13.5C13.9925 17.2495 14.4801 17.1525 14.9351 16.9641C15.39 16.7756 15.8034 16.4994 16.1517 16.1512C16.4999 15.8029 16.7761 15.3895 16.9645 14.9346C17.153 14.4796 17.25 13.992 17.25 13.4995V8.99951C17.25 8.8006 17.171 8.60983 17.0303 8.46918C16.8897 8.32853 16.6989 8.24951 16.5 8.24951Z",
                                                                fill: "#4A67FF"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M5.91001 7.84482C5.70012 8.05445 5.53376 8.3035 5.42049 8.57767C5.30722 8.85183 5.24928 9.14568 5.25001 9.44232V10.4998C5.25001 11.0966 5.48706 11.6689 5.90902 12.0908C6.33097 12.5128 6.90327 12.7498 7.50001 12.7498H8.55751C8.85415 12.7505 9.148 12.6926 9.42216 12.5793C9.69632 12.4661 9.94538 12.2997 10.155 12.0898L16.59 5.65482C16.7998 5.44579 16.9662 5.1974 17.0798 4.92391C17.1933 4.65042 17.2518 4.3572 17.2518 4.06107C17.2518 3.76494 17.1933 3.47172 17.0798 3.19823C16.9662 2.92474 16.7998 2.67635 16.59 2.46732L15.5325 1.40982C15.3235 1.20006 15.0751 1.03363 14.8016 0.920066C14.5281 0.806504 14.2349 0.748047 13.9388 0.748047C13.6426 0.748047 13.3494 0.806504 13.0759 0.920066C12.8024 1.03363 12.554 1.20006 12.345 1.40982L5.91001 7.84482ZM14.4675 2.46732L15.5325 3.53232C15.6722 3.67284 15.7506 3.86293 15.7506 4.06107C15.7506 4.25921 15.6722 4.4493 15.5325 4.58982L14.8875 5.24982L12.75 3.11232L13.395 2.46732C13.4649 2.39589 13.5483 2.33913 13.6404 2.30038C13.7324 2.26163 13.8313 2.24166 13.9313 2.24166C14.0312 2.24166 14.1301 2.26163 14.2222 2.30038C14.3142 2.33913 14.3977 2.39589 14.4675 2.46732ZM6.75001 9.44232C6.74944 9.34362 6.76836 9.24577 6.80568 9.15439C6.843 9.06301 6.898 8.9799 6.96751 8.90982L11.7 4.17732L13.8225 6.29982L9.09001 11.0323C9.01993 11.1018 8.93681 11.1568 8.84544 11.1941C8.75406 11.2315 8.65621 11.2504 8.55751 11.2498H7.50001C7.30109 11.2498 7.11033 11.1708 6.96968 11.0302C6.82902 10.8895 6.75001 10.6987 6.75001 10.4998V9.44232Z",
                                                                fill: "#4A67FF"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip0_2226_15296",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "18",
                                                                height: "18",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isCompleted ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `c1 px2rem py0-75rem br20px fw600 mb0-5rem cna bg16`,
                            disabled: true,
                            "data-tooltip": "Please complete the 3 sections above first",
                            children: "Generate AI Summary"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `c1 px2rem py0-75rem br20px fw600 mb0-5rem ${generatingSummary ? 'cna bg16' : 'cp bg4'}`,
                            onClick: generateAdvisorSummary,
                            disabled: generatingSummary,
                            children: generatingSummary ? 'Generating...' : 'Generate AI Summary'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `edit-box-detail bg1 p1rem bw1px br15px bss bo31 mb1-5rem ${!isCompleted ? 'op0-5 cna' : ''}`,
                    "data-tooltip": !isCompleted ? 'Please complete the 3 sections above first' : '',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "group-inputs",
                        style: {
                            minHeight: '15vh'
                        },
                        children: !isCompleted ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fs0-75rem op0-5",
                            children: "Please complete the 3 sections above first..."
                        }) : editInput === 'wordSummary' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "df tac p0rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                rows: 10,
                                className: `c15 fs0-75rem w100`,
                                name: "wordSummary",
                                placeholder: "Enter the 200-word Summary here...",
                                defaultValue: selectedAdvisor?.['wordSummary'],
                                onBlur: (e)=>{
                                    handleAdvisorChange('wordSummary', e.target.value), setEditInput('');
                                },
                                onChange: (e)=>handleAdvisorChange('wordSummary', e.target.value)
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            onClick: ()=>setEditInput('wordSummary'),
                            className: "cp c15 fs0-75rem",
                            children: selectedAdvisor['wordSummary'] || 'Enter the 200-word Summary here...'
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: `c1 px3rem py0-75rem br20px fw600 mt1rem ${loading ? 'cna bg16' : 'cp bg4'}`,
                    onClick: saveAdvisorProfile,
                    disabled: loading,
                    children: loading ? 'Saving...' : 'Save Changes'
                }),
                selectedAdvisor?.['updatedAt'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    class: "c4 fs0-75rem mt0-5rem ml2rem",
                    children: [
                        "Last edited ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(selectedAdvisor['updatedAt']).format('ll')
                        })
                    ]
                })
            ]
        });
    };
    // Objective Criteria Tab
    const objectiveCriteria = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            class: "w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    class: "df jcsb aic mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: selectedAdvisor?.['profile'] || (parcelRequire("cfmAr")),
                                    alt: "Profile",
                                    className: "shadow w80px h80px br50px mr1rem bw1px bss bo7"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs1-25rem fw500 c15 ttu",
                                    children: [
                                        selectedAdvisor?.['firstName'],
                                        " ",
                                        selectedAdvisor?.['lastName']
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt0-5rem mr1rem",
                            children: SelectAdvisor()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    class: "w100 df fdc aic",
                    children: objectiveCriteriaQues.map((ques, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df fdc px1-5rem py2rem mb0-5rem bw1px bo16 bss br10px",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    class: "w100 c15 fs0-75rem fw500 mb0-5rem",
                                    children: [
                                        "Question ",
                                        idx + 1,
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    class: "w100 c15 fs0-75rem fw300 ml1rem mb0-5rem",
                                    children: ques['qDescription']
                                }),
                                ques['radioOptions'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w40 df jcsb ml1rem mb0-5rem",
                                    children: ques['radioOptions'].map((option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc fs0-75rem c15",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    type: "radio",
                                                    name: `radio-${ques._id}`,
                                                    class: "cp w10px h10px mr0-5rem",
                                                    checked: ques.answer?.selectedRadio === option,
                                                    onChange: ()=>saveAdvisorAnswer(ques._id, option, undefined)
                                                }),
                                                option
                                            ]
                                        }, option))
                                }),
                                ques['dropdownOptions'] && ques['dropdownOptions'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w20 df jcsb ml1rem mt0-5rem",
                                    children: ques['dropdownType'] === 'multi' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                        multiple: true,
                                        displayEmpty: true,
                                        className: "w100 fs0-75rem",
                                        value: ques.answer?.selectedDropdown || [],
                                        onChange: (e)=>{
                                            const value = e.target.value;
                                            if (value.length <= 3) saveAdvisorAnswer(ques._id, undefined, value);
                                            else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can select up to 3 options only');
                                        },
                                        renderValue: (selected)=>selected.length === 0 ? 'Select options' : selected.join(', '),
                                        sx: {
                                            borderRadius: '20px',
                                            fontSize: '0.75rem',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: '1px solid #E5E7EB'
                                            },
                                            '& .MuiSelect-select': {
                                                padding: '10px 20px'
                                            }
                                        },
                                        children: ques['dropdownOptions']?.map((option)=>{
                                            const currentSelected = ques.answer?.selectedDropdown || [];
                                            const isSelected = currentSelected.includes(option);
                                            const isDisabled = !isSelected && currentSelected.length >= 3;
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                value: option,
                                                disabled: isDisabled,
                                                sx: {
                                                    padding: '4px 10px',
                                                    opacity: isDisabled ? 0.5 : 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                        checked: isSelected,
                                                        size: "small",
                                                        sx: {
                                                            padding: '2px'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                        primary: option,
                                                        primaryTypographyProps: {
                                                            fontSize: '0.75rem'
                                                        }
                                                    })
                                                ]
                                            }, option);
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                        displayEmpty: true,
                                        className: "w100 fs0-75rem",
                                        value: ques.answer?.selectedDropdown?.[0] || '',
                                        onChange: (e)=>saveAdvisorAnswer(ques._id, undefined, [
                                                e.target.value
                                            ]),
                                        renderValue: (selected)=>selected || 'Select option',
                                        sx: {
                                            borderRadius: '20px',
                                            fontSize: '0.75rem',
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: '1px solid #E5E7EB'
                                            },
                                            '& .MuiSelect-select': {
                                                padding: '10px 20px'
                                            }
                                        },
                                        children: ques['dropdownOptions']?.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                value: option,
                                                children: option
                                            }, option))
                                    })
                                })
                            ]
                        }, ques._id);
                    })
                })
            ]
        });
    };
    // Quick Response Tab
    const quickResponsesTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "objective-criteria-container w80",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "w100 fs1-5rem fw500 c27 mb0-5rem",
                            children: "Quick responses"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "w100 c15 fs1rem",
                            children: [
                                "Reasons for rejection ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c49 fs0-75rem fsi",
                                    children: "(Please select/add reasons you want to see in the selection dropdown)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "w100 df jcc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w80",
                                    children: [
                                        quickResponseList.length > 0 && quickResponseList.map((item)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "bg1 p1rem bw1px br30px bss bo31 mt1rem c15 fs1rem df fsi pr response-box",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w90",
                                                        children: item
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>handleDeleteQuickResponse(item),
                                                        className: "cp btn-close-right pa r0 t0 p0 mt1rem mr2rem op0",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "21",
                                                            height: "21",
                                                            viewBox: "0 0 21 21",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M16.625 6.125C16.3929 6.125 16.1704 6.21719 16.0063 6.38128C15.8422 6.54538 15.75 6.76794 15.75 7V16.7921C15.7249 17.2346 15.526 17.6492 15.1966 17.9457C14.8671 18.2422 14.4339 18.3965 13.9913 18.375H7.00875C6.56608 18.3965 6.13286 18.2422 5.80344 17.9457C5.47402 17.6492 5.2751 17.2346 5.25 16.7921V7C5.25 6.76794 5.15781 6.54538 4.99372 6.38128C4.82962 6.21719 4.60706 6.125 4.375 6.125C4.14294 6.125 3.92038 6.21719 3.75628 6.38128C3.59219 6.54538 3.5 6.76794 3.5 7V16.7921C3.52498 17.6988 3.90826 18.5587 4.56591 19.1834C5.22356 19.808 6.10196 20.1466 7.00875 20.125H13.9913C14.898 20.1466 15.7764 19.808 16.4341 19.1834C17.0917 18.5587 17.475 17.6988 17.5 16.7921V7C17.5 6.76794 17.4078 6.54538 17.2437 6.38128C17.0796 6.21719 16.8571 6.125 16.625 6.125Z",
                                                                    fill: "#F14D4D"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M17.5 3.5H14V1.75C14 1.51794 13.9078 1.29538 13.7437 1.13128C13.5796 0.967187 13.3571 0.875 13.125 0.875H7.875C7.64294 0.875 7.42038 0.967187 7.25628 1.13128C7.09219 1.29538 7 1.51794 7 1.75V3.5H3.5C3.26794 3.5 3.04538 3.59219 2.88128 3.75628C2.71719 3.92038 2.625 4.14294 2.625 4.375C2.625 4.60706 2.71719 4.82962 2.88128 4.99372C3.04538 5.15781 3.26794 5.25 3.5 5.25H17.5C17.7321 5.25 17.9546 5.15781 18.1187 4.99372C18.2828 4.82962 18.375 4.60706 18.375 4.375C18.375 4.14294 18.2828 3.92038 18.1187 3.75628C17.9546 3.59219 17.7321 3.5 17.5 3.5ZM8.75 3.5V2.625H12.25V3.5H8.75Z",
                                                                    fill: "#F14D4D"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M9.625 14.875V8.75C9.625 8.51794 9.53281 8.29538 9.36872 8.13128C9.20462 7.96719 8.98206 7.875 8.75 7.875C8.51794 7.875 8.29538 7.96719 8.13128 8.13128C7.96719 8.29538 7.875 8.51794 7.875 8.75V14.875C7.875 15.1071 7.96719 15.3296 8.13128 15.4937C8.29538 15.6578 8.51794 15.75 8.75 15.75C8.98206 15.75 9.20462 15.6578 9.36872 15.4937C9.53281 15.3296 9.625 15.1071 9.625 14.875Z",
                                                                    fill: "#F14D4D"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M13.125 14.875V8.75C13.125 8.51794 13.0328 8.29538 12.8687 8.13128C12.7046 7.96719 12.4821 7.875 12.25 7.875C12.0179 7.875 11.7954 7.96719 11.6313 8.13128C11.4672 8.29538 11.375 8.51794 11.375 8.75V14.875C11.375 15.1071 11.4672 15.3296 11.6313 15.4937C11.7954 15.6578 12.0179 15.75 12.25 15.75C12.4821 15.75 12.7046 15.6578 12.8687 15.4937C13.0328 15.3296 13.125 15.1071 13.125 14.875Z",
                                                                    fill: "#F14D4D"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, item);
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "bg1 py0-5rem px1rem bw1px br30px bss bo31 mt1rem c15 fs1rem df fsi pr response-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "mr1rem",
                                                    children: quickResponse === '' ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        className: "cp plus-btn mr1rem pr",
                                                        style: {
                                                            backgroundColor: 'transparent',
                                                            border: 'none',
                                                            padding: '0',
                                                            top: '2px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a13e63b7a73e33fd$var$DisablePlusIcon, {})
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        onClick: ()=>handleQuickResponse(),
                                                        className: "cp plus-btn mr1rem pr",
                                                        style: {
                                                            backgroundColor: 'transparent',
                                                            border: 'none',
                                                            padding: '0',
                                                            top: '2px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a13e63b7a73e33fd$var$PlusIcon, {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    value: quickResponse,
                                                    onChange: (e)=>setQuickResponse(e.target.value),
                                                    placeholder: "Add Quick Response - up to 300 characters",
                                                    inputProps: {
                                                        maxLength: 300
                                                    },
                                                    InputProps: {
                                                        style: {
                                                            borderRadius: "0",
                                                            marginBottom: '0',
                                                            fontSize: '14px',
                                                            border: 'none',
                                                            padding: '0'
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w20",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        class: " mx2rem",
                                        src: (parcelRequire("4h5pa")),
                                        alt: "IMAGE"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df mt1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>saveQuickResponses(),
                        className: `w200px df aic jcc c1 br30px px2rem py0-5rem fw500 ${!isSettingsChanged ? 'bg12 cna' : 'bg4 cp'}`,
                        disabled: !isSettingsChanged,
                        children: "Save Changes"
                    })
                })
            ]
        });
    };
    // Main
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                class: "df jcc setting-investor",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7be483edbed3b474$export$2e2bcd8739ae039), {
                    value: selectedClientMatchTab,
                    onChange: (_, newValue)=>setSelectedClientMatchTab(newValue),
                    "aria-label": "AdvisorMatch Tabs",
                    children: clientMatchTabs.map((tab)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6a3a0c577f6eee9$export$2e2bcd8739ae039), {
                            label: tab,
                            value: tab,
                            onClick: ()=>setSelectedClientMatchTab(tab)
                        }, tab))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a13e63b7a73e33fd$var$TabPanel, {
                value: selectedClientMatchTab,
                index: "Team Admin",
                children: teamAdmin()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a13e63b7a73e33fd$var$TabPanel, {
                value: selectedClientMatchTab,
                index: "Profiles",
                children: profiles()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a13e63b7a73e33fd$var$TabPanel, {
                value: selectedClientMatchTab,
                index: "Skills & Experience",
                children: skillsExperience()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a13e63b7a73e33fd$var$TabPanel, {
                value: selectedClientMatchTab,
                index: "Objective Criteria",
                children: objectiveCriteria()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a13e63b7a73e33fd$var$TabPanel, {
                value: selectedClientMatchTab,
                index: "Quick Response",
                children: quickResponsesTab()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
                modalType: "uploadAdvisorProfile",
                onCloseHandler: ()=>{
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })), setUserProfile("");
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: `c15 ${userProfile === "" ? "tac" : "tal"} lh1 fw600 mb2rem`,
                        children: "Upload Profile Picture"
                    }),
                    userProfile === "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        htmlFor: "advisorProfile",
                        className: "w60 bsbb bg5 br5px tac bsd bo3 bw2px cp pr db upload-pic-area mxa px1rem py4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                className: "",
                                onChange: handleProfile,
                                onDrop: handleProfile,
                                id: "profile",
                                type: "file",
                                accept: "image/jpeg, image/jpg, image/png"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc aic jcc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("doQrw")),
                                        alt: "upLoading"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w60 mxa c15 op60 tac mt1rem",
                                        children: "Upload or drag and drop (max 5MB)"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "img-box pr maw300px mxa mah300px",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                            style: {
                                maxHeight: "300px"
                            },
                            ref: cropper,
                            guides: false,
                            aspectRatio: 1,
                            className: "cropper-settings",
                            src: userProfile
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc w100",
                        children: [
                            userProfile !== "" && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                type: "button",
                                className: "c3 bg44 bo3 bss bw1px w20rem mr1rem br50px mt2rem pr cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac",
                                children: [
                                    "Change Picture",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: "op0 w100 h100 pa l0 t0 cp",
                                        onChange: handleProfile,
                                        onDrop: handleProfile,
                                        id: "advisorProfile2",
                                        type: "file",
                                        accept: "image/jpeg, image/jpg, image/png"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `c1 px2-5rem py0-75rem br50px mt2rem w20rem fw600 ${loading ? 'cna bg16' : 'cp bg4'}`,
                                onClick: ()=>{
                                    if (!loading) updateAdvisorProfile();
                                },
                                disabled: loading,
                                children: loading ? 'Saving...' : 'Save'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






const $a5d74d48e8d56916$var$cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);





































function $a5d74d48e8d56916$export$2e2bcd8739ae039({ profileClass: profileClass, getCompany: getCompany, handleMemberEdit: handleMemberEdit }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let companies = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.companies);
    let companyId = location.pathname.split("/").slice(-1)[0];
    const isCompanySettings = window.location.pathname.includes("company-settings");
    let [cvData, setCvData] = (0, $acw62.useState)({});
    let [company, setCompany] = (0, $acw62.useState)({});
    let [director, setDirector] = (0, $acw62.useState)('');
    let [isValid, setIsValid] = (0, $acw62.useState)(true);
    let [advisors, setAdvisors] = (0, $acw62.useState)([]);
    let [investors, setInvestors] = (0, $acw62.useState)([]);
    let [editInput, setEditInput] = (0, $acw62.useState)('');
    let [attachment, setAttachment] = (0, $acw62.useState)();
    let [uploadType, setUploadType] = (0, $acw62.useState)('');
    let [advisorLogo, setAdvisorLogo] = (0, $acw62.useState)();
    let [promptScore, setPromptScore] = (0, $acw62.useState)(0);
    let [auditLogList, setAuditLogList] = (0, $acw62.useState)([]);
    let [currentImage, setCurrentImage] = (0, $acw62.useState)('');
    let [isImageModal, setIsImageModal] = (0, $acw62.useState)(false);
    let [companyContact, setCompanyContact] = (0, $acw62.useState)({});
    let [chargeReadMore, setChargeReadMore] = (0, $acw62.useState)({});
    let [selectedStages, setSelectedStages] = (0, $acw62.useState)([]);
    let [controlReadMore, setControlReadMore] = (0, $acw62.useState)({});
    let [selectedSectors, setSelectedSectors] = (0, $acw62.useState)([]);
    let [officersReadMore, setOfficersReadMore] = (0, $acw62.useState)({});
    let [selectedContact, setSelectedContact] = (0, $acw62.useState)(null);
    let [filingCurrentPage, setFilingCurrentPage] = (0, $acw62.useState)(0);
    let [isMainRecipient, setIsMainRecipient] = (0, $acw62.useState)(false);
    let [updateCompanyData, setUpdateCompanyData] = (0, $acw62.useState)({});
    let [selectedUKRegions, setSelectedUKRegions] = (0, $acw62.useState)({});
    let [isSettingsChanged, setSettingsChanged] = (0, $acw62.useState)(false);
    let [updateSettingsData, setUpdateSettingsData] = (0, $acw62.useState)({});
    let [indexTab, setIndexTab] = (0, $acw62.useState)('Companies House Data');
    let [personsCurrentPage, setPersonsCurrentPage] = (0, $acw62.useState)(0);
    let [chargesCurrentPage, setChargesCurrentPage] = (0, $acw62.useState)(0);
    let [officersCurrentPage, setOfficersCurrentPage] = (0, $acw62.useState)(0);
    let [registersCurrentPage, setRegistersCurrentPage] = (0, $acw62.useState)(0);
    let [isInvestorMatchTabs, setIsInvestorMatchTabs] = (0, $acw62.useState)(false);
    let [isClientMatchTabs, setIsClientMatchTabs] = (0, $acw62.useState)(false);
    let [investorLeadQuestions, setInvestorLeadQuestions] = (0, $acw62.useState)([]);
    let [tabCompanySnapshot, setTabCompanySnapshot] = (0, $acw62.useState)('Filing History');
    let [leadSectionActive, setLeadSectionActive] = (0, $acw62.useState)('Standard Questions');
    let [formData, setFormData] = (0, $acw62.useState)({
        linkedIn: '',
        companyId: '',
        directorId: ''
    });
    let [selectedInvestorTab, setSelectedInvestorTab] = (0, $acw62.useState)(`${user?.['role'] || ''} Details`);
    let [selectedClientMatchTab, setSelectedClientMatchTab] = (0, $acw62.useState)('Team Admin');
    let [newContact, setNewContact] = (0, $acw62.useState)({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        profilePicture: '',
        linkedIn: ''
    });
    let clientMatchTabs = [
        'Team Admin',
        'Profiles',
        'Skills & Experience',
        'Objective Criteria',
        'Quick Response'
    ];
    let investorMatchTabs = [
        `${user?.['role'] || ''} Details`,
        'Objective Criteria',
        'Subjective Criteria',
        'Quick Response'
    ];
    let options = {
        empty: [
            '',
            'not known',
            'not selected',
            'none selected',
            'nil'
        ],
        cStages: [
            "Pre-Revenue",
            "Post-Revenue Early Stage",
            "Mature"
        ],
        noOfInvestments: [
            '<10',
            '10-20',
            '20-100',
            '>100',
            'Not known'
        ],
        fundSizes: [
            "<\xa35m",
            "\xa35m-\xa3100m",
            "\xa3100m-\xa3500m",
            "\xa3500m-\xa31bn",
            ">\xa31bn",
            'Not known'
        ],
        lastInvestmentDate: [
            'Within 6 months',
            'Within 12 months',
            'More than 12 months',
            'Not known'
        ],
        profits: [
            'Nil',
            "<\xa3100,000",
            "\xa3100,000-\xa3500,000",
            "\xa3500,001-\xa31m",
            ">\xa31m ARR",
            "\xa31m-\xa35m",
            "\xa35m-\xa310m",
            "\xa310m-\xa320m",
            "\xa320m-\xa3100m",
            "\xa3100m+",
            'Not known'
        ],
        revenues: [
            'Nil',
            "<\xa3100,000",
            "\xa3100,000-\xa3500,000",
            "\xa3500,001-\xa31m",
            ">\xa31m ARR",
            "\xa31m-\xa35m",
            "\xa35m-\xa310m",
            "\xa310m-\xa320m",
            "\xa320m-\xa3100m",
            "\xa3100m+",
            'Not known'
        ],
        sweetSpots: [
            "<\xa3100,000",
            "\xa3100,001-\xa31,000,000",
            "\xa31,000,001-\xa35,000,000",
            "\xa35,000,001-\xa320,000,000",
            "\xa320,000,001-\xa3100,000,000",
            ">\xa3100,000,001",
            'Not known'
        ],
        stages: [
            'Angel',
            'Pre-Seed',
            'Seed',
            'Venture Capital - Series A',
            'Venture Capital - Series B+',
            'Private Equity',
            'Accelerator',
            'Angel Group',
            'Convertible Note',
            'Corporate Centure Capital',
            'Co-working Space',
            'Crowdfunding',
            'Debt',
            'Early Stage Venture',
            'Entrepreneurship Program',
            'Family Investment Office',
            'Fund of Funds',
            'Government Office',
            'Grant',
            'Hedge Fund',
            'Incubator',
            'Initial Coin Offering',
            'Investment Bank',
            'IPO',
            'Late Stage Venture',
            'Non-Equity Assistance',
            'Pension Funds',
            'Pre-IPO',
            'Post-IPO',
            'Secondary Market',
            'Secondary Purchaser',
            'Startup Competition',
            'Syndicate',
            'University Program',
            'Venture Debt',
            'Other',
            'Not Selected'
        ],
        sectors: [
            'General',
            'Accounting',
            'Advertising',
            'Advice',
            'Aerospace',
            'Ag Tech',
            'Analytics',
            'Angel Investment',
            'Apps',
            'Artificial Intelligence',
            'Asset Management',
            'Banking',
            'Big Data',
            'Biotechnology',
            'Blockchain',
            'Business Development',
            'Business Information Systems',
            'CleanTech',
            'Cloud Infrastructure',
            'Commerce & Shopping',
            'Commercial Real Estate',
            'Community & Lifestyle',
            'Consumer',
            'Consumer Electronics',
            'Consumer Goods',
            'Consulting',
            'Credit',
            'Cryptocurrency',
            'Customer Service',
            'Cybersecurity',
            'Data & Analytics',
            'Data Management',
            'Database',
            'Delivery',
            'Developer APIs',
            'Developer Platform',
            'Document Management',
            'E-Commerce',
            'Education',
            'Energy',
            'Enterprise Software',
            'Environmental Engineering',
            'Events',
            'Female Focus',
            'Finance',
            'Financial Services',
            'FinTech',
            'Food & Beverage',
            'Gaming',
            'Genetics',
            'Government',
            'Gov Tech',
            'GreenTech',
            'Hardware',
            'Healthcare',
            'Higher Education',
            'Impact Investing',
            'Information Technology',
            'Infrastructure',
            'Intellectual Property',
            'Internet',
            'Internet Services',
            'Insurance',
            'Insurtech',
            'Incubators',
            'Law Enforcement',
            'Legal',
            'Legal Tech',
            'Lending & Investments',
            'Life Science',
            'Machine Learning',
            'Management Consulting',
            'Manufacturing',
            'Marketplace',
            'Media & Entertainment',
            'Medical',
            'Medical Device',
            'Mobile',
            'Mobile Apps',
            'Oil & Gas',
            'Payments',
            'Privacy & Security',
            'Productivity Tools',
            'Professional Services',
            'Prop Tech',
            'Real Estate',
            'Retail',
            'Risk Management',
            'SaaS',
            'Sales & Marketing',
            'Science & Engineering',
            'Smart Cities',
            'Software',
            'Stock Exchanges',
            'Sustainability',
            'Tax Consulting',
            'Transportation',
            'Venture Capital',
            'Video',
            'Wealth Management',
            'Web3',
            'Web Development',
            'Web Hosting',
            'Wellness',
            'Wholesale',
            'Other',
            'Not Selected'
        ]
    };
    let companyKeys = {
        fiveWords: 'Description',
        companyDescription: 'Detail Box',
        vatRegCode: 'VAT Code',
        ukUTRCode: 'UTR Code',
        cAddress: 'Address Line',
        cPostalCode: 'Postal Code',
        cCountry: 'Country',
        cWebsite: 'Website Url',
        cLinkedin: 'LinkedIn Url',
        cFacebook: 'Facebook Url',
        cInstagram: 'Instgram Url',
        cStage: 'Company Stage',
        job: 'Contact Job Title',
        email: 'Contact Email',
        phone: 'Contact Phone',
        linkedIn: 'Contact LinkedIn',
        bio: 'Contact Bio'
    };
    let invalidEmails = [
        'hello@',
        'enquiries@',
        'pitch@',
        'info@',
        'contact@',
        'support@',
        'team@',
        'admin@',
        'feedback@',
        'partnership@',
        'inquiries@',
        'office@'
    ];
    let ukRegions = [
        'UK',
        'East Midlands',
        'West Midlands',
        'East of England',
        'South East England',
        'South West England',
        'North West England',
        'North East England',
        'Yorkshire and the Humber',
        'Greater London',
        'Scotland',
        'Wales',
        'Northern Ireland',
        'Channel Islands (Jersey & Guernsey)',
        'Isle of Man'
    ];
    (0, $acw62.useEffect)(()=>{
        if (location.hash) {
            let tab = location.hash.split('#')[1];
            tab = tab.replaceAll('%20', ' ');
            setIndexTab(tab);
        }
    }, [
        location.hash
    ]);
    (0, $acw62.useEffect)(()=>{
        getInvestorLeadQuestions();
    }, []);
    (0, $acw62.useEffect)(()=>{
        let isCompanySettings = localStorage.getItem("isInvestorSettings");
        if (isCompanySettings == null) // dispatch(toggleModal({ open: 'companySettings' }));
        localStorage.setItem('isInvestorSettings', true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        getAdvisors();
    }, []);
    const getAdvisors = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user/getAdvisor`);
        if (response["code"] == 200 && response["body"]) {
            setAdvisors(response["body"]["advisors"]);
            setInvestors(response["body"]["investors"]);
        }
    };
    (0, $acw62.useEffect)(()=>{
        fetchCompany();
    }, [
        user.companyId?._id
    ]);
    const fetchCompany = async ()=>{
        try {
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${user.companyId?._id}?lightweight=false`);
            setCompany(res['body']);
        } catch (error) {
            console.error("Error fetching company data:", error);
        }
    };
    const handleSavePreferredContact = async ()=>{
        if (!selectedContact) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please select a contact to save as preferred contact");
        console.log(companyContact, "companyContact");
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/setPreferredContact`, {
            companyId: isCompanySettings ? companyId : user.companyId._id,
            contactId: selectedContact['_id']
        });
        if (response && response['code'] === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Preferred contact saved successfully");
            setIsMainRecipient(true);
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message || "Failed to save preferred contact");
    };
    const handleSetLead = (member)=>{
        if (!(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(member)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Business Card data not complete');
        if (member && member['_id']) setSelectedContact(member);
    };
    (0, $acw62.useEffect)(()=>{
        if (user.companyId?._id) {
            setFormData((prevFormData)=>({
                    ...prevFormData,
                    companyId: user.companyId?._id
                }));
            fetchInvestorFirmDetails();
            fetchCompany();
            getPromptScore(user.companyId?._id);
        } else if (isCompanySettings) fetchInvestorFirmDetails();
    }, [
        user.companyId?._id
    ]);
    (0, $acw62.useEffect)(()=>{
        setFormData((prevFormData)=>({
                ...prevFormData,
                directorId: director
            }));
    }, [
        director
    ]);
    (0, $acw62.useEffect)(()=>{
        let tempSectors = [];
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector1']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector1'])) tempSectors.push(company['preferredSectors']['sector1']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector2']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector2'])) tempSectors.push(company['preferredSectors']['sector2']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector3']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector3'])) tempSectors.push(company['preferredSectors']['sector3']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector4']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector4'])) tempSectors.push(company['preferredSectors']['sector4']);
        if (company['preferredSectors'] && !options['empty'].includes(company['preferredSectors']['sector5']?.toLowerCase()) && !tempSectors.includes(company['preferredSectors']['sector5'])) tempSectors.push(company['preferredSectors']['sector5']);
        setSelectedSectors(tempSectors);
        if (company && company['preferredContact']) {
            const member = company?.['members']?.find((member)=>member['_id'] === company['preferredContact']);
            setSelectedContact(member);
        }
        let tempStages = [];
        if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage1']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage1'])) tempStages.push(company['stageFocus']['stage1']);
        if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage2']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage2'])) tempStages.push(company['stageFocus']['stage2']);
        if (company['stageFocus'] && !options['empty'].includes(company['stageFocus']['stage3']?.toLowerCase()) && !tempStages.includes(company['stageFocus']['stage3'])) tempStages.push(company['stageFocus']['stage3']);
        setSelectedStages(tempStages);
        if (company?.['ukRegions'] && Object.keys(company['ukRegions']).length > 0) setSelectedUKRegions(company['ukRegions']);
    }, [
        company
    ]);
    const fetchInvestorFirmDetails = async ()=>{
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getInvestorFirm/${isCompanySettings ? companyId : user.companyId._id}`);
        if (response && response?.['code'] == 200 && response['body']) {
            let { contact: contact, ...companyWithoutContact } = response.body;
            setCompany(companyWithoutContact);
            setCompanyContact(contact);
        }
    };
    const getPromptScore = async (investorId)=>{
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getPromptScore/${isCompanySettings ? companyId : investorId}`);
        if (response && response['code'] === 200) setPromptScore(response['body']);
    };
    const getInvestorLeadQuestions = async ()=>{
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/getModuleQuestions`, {
            type: 'investor-lead'
        });
        if (response && response['code'] === 200) {
            const sortedQuestions = response['body'].sort((a, b)=>{
                const qNoA = a.qNo || '', qNoB = b.qNo || '';
                // Split by dot and compare each part
                const partsA = qNoA.split('.'), partsB = qNoB.split('.');
                for(let i = 0; i < Math.max(partsA.length, partsB.length); i++){
                    const partA = partsA[i] || '', partB = partsB[i] || '';
                    // Try to parse as numbers, if both are numeric compare as numbers
                    const numA = parseInt(partA), numB = parseInt(partB);
                    if (!isNaN(numA) && !isNaN(numB)) {
                        if (numA !== numB) return numA - numB;
                        else {
                            if (partA !== partB) return partA.localeCompare(partB);
                        }
                    }
                }
                return 0;
            });
            setInvestorLeadQuestions(sortedQuestions);
        }
    };
    const getAuditLogs = async (endpoint)=>{
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/log', {
            endpoint: endpoint,
            companyId: company['_id']
        });
        if (response && response['code'] == 200) {
            await setAuditLogList(response['body']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'auditLogs'
            }));
        }
    };
    const uploadImage = async ()=>{
        let attachment = [];
        if ($a5d74d48e8d56916$var$cropper.current && currentImage) {
            let imageToUpload = $a5d74d48e8d56916$var$cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "profile image", {
                type: "image/png"
            });
            attachment.push(coverFile);
            setCurrentImage(imageToUpload);
            if (uploadType == 'advisorLogo') {
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/updateLogo/${company['_id']}`, {
                    attachment: attachment
                });
                if (response || response["code"] == 200) await setAdvisorLogo(response?.['body']?.['logo']);
                setIsImageModal(false);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message);
            } else {
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/uploadFile`, {
                    attachment: attachment
                }, true);
                if (response || response['code'] == 200) {
                    if (uploadType === 'logo') setCompany({
                        ...company,
                        logo: response?.['body']?.['report']?.['location']
                    });
                    else if (uploadType === 'newContactImage') setNewContact({
                        ...newContact,
                        profilePicture: response?.['body']?.['report']?.['location']
                    });
                    setSettingsChanged(true);
                    setIsImageModal(false);
                }
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response.message);
            }
        }
    };
    const handleImage = async (e1)=>{
        let image = e1.target.files[0];
        if (image && image.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        image = await URL.createObjectURL(image);
        setCurrentImage(image);
    };
    const handleContactChange = (event)=>{
        const { name: name, value: value } = event.target;
        setUpdateSettingsData({
            ...updateSettingsData,
            [name]: value
        });
        setCompanyContact({
            ...companyContact,
            [name]: value
        });
    };
    // Regex to validate LinkedIn profile URL
    const linkedInRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?$/;
    const handleNewContactChange = (event)=>{
        const { name: name, value: value } = event.target;
        if (name && name.toLowerCase() === "linkedin") setIsValid(linkedInRegex.test(e.target.value));
        if (name === 'isMainRecipient') {
            if (isMainRecipient) setIsMainRecipient(!isMainRecipient);
            else if (newContact['firstName'] == '' || newContact['lastName'] == '' || newContact['email'] == '' || newContact['phone'] == '' || newContact['linkedIn'] == '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please complete all fields. Contact can only be added if all fields are completed.');
            else setIsMainRecipient(!isMainRecipient);
        } else setNewContact({
            ...newContact,
            [name]: value
        });
    };
    const saveSettings = async ()=>{
        if (invalidEmails.some((invalidEmail)=>companyContact['email']?.includes(invalidEmail))) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Email can not contain "hello@, enquiries@, pitch@, info@, contact@, support@, team@, admin@, feedback@, partnership@, inquiries@, office@ etc."`);
            return;
        }
        if (!isValid) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Enter valid linkedin profile url');
        let data = {
            update: updateSettingsData,
            companyId: company['_id'],
            action: 'edit',
            investorId: company['_id'],
            investorData: company,
            contactData: companyContact
        };
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/adminAddEditInvestor`, data);
        if (response && response['code'] === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Settings saved successfully');
            setUpdateSettingsData({});
            setSettingsChanged(false);
        }
    };
    const saveAnswer = async (e1)=>{
        let update = {
            ...company,
            [e1.target.name]: e1.target.value
        };
        updateCompanyData = {
            ...updateCompanyData,
            [e1.target.name]: e1.target.value
        };
        await setUpdateCompanyData(updateCompanyData);
        setCompany(update);
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/update/${company['_id']}`, {
            update: updateCompanyData,
            companyId: company['_id']
        });
        if (response && response['code'] === 200) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
    };
    const addNewContact = async ()=>{
        if (newContact['firstName'] == '' || newContact['lastName'] == '' || newContact['email'] == '') {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please complete all fields. Contact can only be added if all fields are completed.');
            return;
        }
        let data = {
            firstName: newContact['firstName'],
            lastName: newContact['lastName'],
            email: newContact['email'],
            phone: newContact['phone'],
            linkedIn: newContact['linkedIn'],
            profilePicture: newContact['profilePicture'],
            title: 'Team Member',
            isMainRecipient: isMainRecipient,
            designation: user?.['designation'] || user?.['title'] || user?.['job'] || '',
            action: 'add',
            permissions: {
                D001: true,
                D002: true,
                D003: true,
                D004: true,
                D005: true,
                D006: true,
                D007: true,
                D008: true,
                D009: true,
                D010: true,
                D011: true,
                D012: true,
                D013: true,
                D014: true,
                D015: true,
                D016: true,
                D017: true,
                D018: true,
                D019: true,
                D020: true,
                DEPF005: true,
                DEPF006: true,
                DEPF007: true,
                DEPN004: true
            }
        };
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/addAdvisor`, data);
        if (response && response["code"] == 200) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Contact added successfully');
            setIsMainRecipient(false);
            setNewContact({
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                profilePicture: '',
                linkedIn: ''
            });
        }
    };
    const handleAnswer = (e1, questionType)=>{
        const { name: name, value: value } = e1['target'];
        if (questionType.includes('YN')) setInvestorLeadQuestions((prevQuestions)=>prevQuestions.map((question)=>question['_id'] == name ? {
                    ...question,
                    radioOption: value
                } : question));
        else if (questionType.includes('Multi')) setInvestorLeadQuestions((prevQuestions)=>prevQuestions.map((question)=>question['_id'] == name ? {
                    ...question,
                    dropdown: value.join(';')
                } : question));
        else if (questionType.includes('T')) setInvestorLeadQuestions((prevQuestions)=>prevQuestions.map((question)=>question['_id'] == name ? {
                    ...question,
                    comment: value
                } : question));
        else setInvestorLeadQuestions((prevQuestions)=>prevQuestions.map((question)=>question['_id'] == name ? {
                    ...question,
                    dropdown: value
                } : question));
    };
    const showUploadPopup = (director)=>{
        setDirector(director['_id']);
        const matchingDirector = company?.['directors'].find((d)=>d['_id'] === director['_id']);
        const linkedInValue = matchingDirector && matchingDirector['linkedIn'] !== 'undefined' ? matchingDirector['linkedIn'] : null;
        setFormData({
            ...formData,
            linkedIn: linkedInValue
        });
        setDirector(director);
    };
    const confirmDeleteFiles = async ()=>{
        let questionId = "64bf7e6bacdfbb8c415c2cb4";
        let index = company?.directors.findIndex((el)=>el['_id'] == director['_id']);
        const directorId = director['_id'];
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteFile', {
            file: attachment,
            questionId: questionId,
            companyId: company['_id'],
            directorId: directorId
        });
        if (res && res['code'] == 200) {
            Object.keys(company.modules).map((module)=>{
                if (module === `directors-questionnaire_${director['_id']}`) setCompany((company)=>{
                    const updatedCompany = {
                        ...company
                    };
                    const moduleObj = updatedCompany.modules[module];
                    if (moduleObj && moduleObj.sections[0]?.subFolders[2]?.questions[0]?.answer?.files) moduleObj.sections[0].subFolders[2].questions[0].answer.files = moduleObj.sections[0].subFolders[2].questions[0].answer.files?.filter((file)=>{
                        return file !== attachment;
                    });
                    return updatedCompany;
                });
            });
            const updatedCvData = {
                ...cvData
            };
            if (updatedCvData.hasOwnProperty(directorId)) delete updatedCvData[directorId];
            setCvData(updatedCvData);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res.message);
        }
    };
    const closeDirectorPopup = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setFormData({
            ...formData,
            linkedIn: ''
        });
    };
    const handleSubmitDirector = async ()=>{
        let data;
        if (attachment) data = {
            attachment: [
                attachment
            ],
            ...formData
        };
        else data = {
            ...formData
        };
        if (formData['linkedIn'].length > 0) {
            const regex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{5,30}\/?$/;
            const isValid = regex.test(formData['linkedIn']);
            if (!isValid) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please provide a valid linkedin profile url");
        }
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/question/saveCV', data);
        if (res && res['code'] == 200) {
            const { files: files, linkedIn: linkedIn } = res['body'];
            const updatedCompanyDirectors = company.directors.map((director)=>{
                if (director['_id'] == formData.directorId) return {
                    ...director,
                    cv: files[0],
                    linkedIn: linkedIn || formData.linkedIn
                };
                return director;
            });
            const updatedCompany = {
                ...company,
                directors: updatedCompanyDirectors
            };
            setCompany(updatedCompany);
            await fetchInvestorFirmDetails();
            await fetchCompany();
            closeDirectorPopup();
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        }
    };
    const selectIndexTab = (tab)=>{
        if (tab == 'InvestorMatch Criteria') setIsInvestorMatchTabs(!isInvestorMatchTabs);
        else setIsInvestorMatchTabs(false);
        if (tab == 'AdvisorMatch') setIsClientMatchTabs(!isClientMatchTabs);
        else setIsClientMatchTabs(false);
        setIndexTab(tab);
        setUpdateCompanyData({});
        setUpdateSettingsData({});
    };
    const auditLogButton = (path)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            onClick: ()=>getAuditLogs(path),
            className: "cp df jcc px2rem py0-5rem bg5 fs0-75rem fw500 br30px bw1px bo16 bss",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "bg5 mr1rem w20px h20px df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "36",
                        height: "36",
                        viewBox: "0 0 36 36",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
                            fill: "#4A67FF"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c15",
                    children: "Audit Log"
                })
            ]
        });
    };
    const getSidebarHTML = ()=>{
        const tabs = user?.['role'] == 'Advisor' ? [
            "Companies House Data",
            "Company Profile",
            "Director's Information",
            "Advisor Permissions",
            "AdvisorMatch"
        ] : [
            "Companies House Data",
            "Company Profile",
            "Director's Information",
            "Investor Permissions",
            "InvestorMatch Criteria",
            "Investment Leads",
            "Preferred Contact For Leads"
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            id: "sidebar-company-settings",
            style: {
                width: "calc((100% - 4rem) / 5)"
            },
            className: "sidebar-company-settings w100 bsbb dg gg1rem br5px bg0 ps t0 sidebar-report",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg5 br10px py0-5rem mt3rem bw1px bo16 bss",
                    style: {
                        backgroundColor: '#F0F2FD50',
                        borderColor: '#7385BE650'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic fdc p0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac",
                                    children: [
                                        user?.['role'],
                                        " Settings"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac",
                                    children: "Index"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: user?.['role'] == 'Advisor' ? `/advisor-dashboard` : user?.['role'] == 'Investor' ? `/investor-dashboard` : `/dashboard`,
                                    className: "c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px3rem py0-5rem df aic jcc mt1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon mr0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                width: "15",
                                                height: "15",
                                                viewBox: "0 0 21 21",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z",
                                                        fill: "white",
                                                        stroke: "white",
                                                        "stroke-width": "0.5"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z",
                                                        fill: "white",
                                                        stroke: "white",
                                                        "stroke-width": "0.5"
                                                    })
                                                ]
                                            })
                                        }),
                                        "Back"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mah100 mya oya df fdc jcsb mt2-5rem",
                            children: [
                                tabs.map((tab, idx)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: `#${tab}`,
                                                onClick: ()=>selectIndexTab(tab),
                                                className: `bg5 cp w100 df c2 px1rem py0-75rem df jcsb ${tab == indexTab && 'c3'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem tal",
                                                        children: tab
                                                    }),
                                                    tab == 'InvestorMatch Criteria' && isInvestorMatchTabs && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        class: "fa fa-angle-up mr0-5rem"
                                                    }),
                                                    tab == 'InvestorMatch Criteria' && !isInvestorMatchTabs && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        class: "fa fa-angle-down mr0-5rem"
                                                    }),
                                                    tab == 'AdvisorMatch' && isClientMatchTabs && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        class: "fa fa-angle-up mr0-5rem"
                                                    }),
                                                    tab == 'AdvisorMatch' && !isClientMatchTabs && /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        class: "fa fa-angle-down mr0-5rem"
                                                    })
                                                ]
                                            }, idx),
                                            tab == 'InvestorMatch Criteria' && isInvestorMatchTabs && investorMatchTabs.map((subTab)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: `bg5 cp df c2 px2rem py0-75rem`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `fs0-75rem tal c3-hover ${selectedInvestorTab == subTab && 'c3'}`,
                                                        onClick: ()=>setSelectedInvestorTab(subTab),
                                                        children: subTab
                                                    })
                                                });
                                            }),
                                            tab == 'AdvisorMatch' && isClientMatchTabs && clientMatchTabs.map((subTab)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: `bg5 cp df c2 px2rem py0-75rem`,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `fs0-75rem tal c3-hover ${selectedClientMatchTab == subTab && 'c3'}`,
                                                        onClick: ()=>setSelectedClientMatchTab(subTab),
                                                        children: subTab
                                                    })
                                                });
                                            })
                                        ]
                                    });
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                    class: "my0-5rem c16"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'companyDelete'
                                        })),
                                    className: `bg5 cp delete-active w100 df px1rem py0-5rem `,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-75rem tal",
                                        children: "Delete Company"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                indexTab == 'InvestorMatch Criteria' && isInvestorMatchTabs && selectedInvestorTab == 'Investor Details' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "w100 mt1rem",
                    src: (parcelRequire("7jB25")),
                    alt: "Intelligence"
                }),
                indexTab == 'AdvisorMatch' && isClientMatchTabs && selectedClientMatchTab == 'Skills & Experience' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "w100 mt1rem",
                    src: (parcelRequire("a1Fed")),
                    alt: "Intelligence"
                })
            ]
        });
    };
    //********** Companies House Data **********//
    const companiesHouseData = ()=>{
        const tabs = [
            "Filing History",
            "Officers",
            "Persons with significant control",
            "Charges",
            "Registers"
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb aic mb1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1-5rem fw500 c14",
                                children: "COMPANY INFORMATION"
                            }),
                            auditLogButton(`/company/update/${company['_id']}`)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "p1-5rem c15 fs0-75rem bw1px bo16 br20px bss mb2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            class: "df jcsb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    class: "df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Status: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['isActive'] ? 'Active' : '-'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Number: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['ukRegNo'] ? company['ukRegNo'] : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Title: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['cName'] ? company['cName'] : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Date of Creation: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['createdAt'] ? (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['createdAt']).format('YYYY-MM-DD') : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "w100 mb0-5rem",
                                            children: [
                                                "Company Address: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: company['cAddress'] ? company['cAddress'] : "-"
                                                })
                                            ]
                                        }),
                                        company['ukRegNo'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df mt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: `https://find-and-update.company-information.service.gov.uk/company/${company['ukRegNo']}`,
                                                    target: "_blank",
                                                    className: "df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem mr1rem fs0-75rem fw500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("jNDOY")),
                                                            className: "mr0-5rem"
                                                        }),
                                                        "Companies House - Direct"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: `https://find-and-update.company-information.service.gov.uk/company/${company['ukRegNo']}/more`,
                                                    target: "_blank",
                                                    className: "df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem fs0-75rem fw500",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: (parcelRequire("jNDOY")),
                                                            className: "mr0-5rem"
                                                        }),
                                                        "View Snapshot"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("1SlVW"))
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "fs1-5rem fw500 c14 mb1rem",
                                children: "COMPANY SNAPSHOT"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "p1-5rem bw1px bo16 br20px bss",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc",
                                        children: tabs.map((tab, idx)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>setTabCompanySnapshot(tab),
                                                className: `cp py0-5rem px1rem bg1 fs1rem ${tab == tabCompanySnapshot ? ' c3 fw600' : 'c12 fw400'}`,
                                                style: {
                                                    borderBottom: tab == tabCompanySnapshot && '2px solid #6366f1'
                                                },
                                                children: tab
                                            }, idx);
                                        })
                                    }),
                                    tabCompanySnapshot == "Filing History" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: filingHistoryTab()
                                    }) : tabCompanySnapshot == "Officers" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: officersTab()
                                    }) : tabCompanySnapshot == "Persons with significant control" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: personsSignificantTab()
                                    }) : tabCompanySnapshot == "Charges" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: chargesTab()
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: registersTab()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mb2rem p1-5rem bw1px bo16 br20px bss",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df jcsb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "fs1-125rem fw600 c14 mb1rem",
                                        children: "HMRC"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        class: "mb1rem",
                                        src: (parcelRequire("5Mjhm"))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "vatRegCode",
                                        name: "vatRegCode",
                                        onBlur: saveAnswer,
                                        value: company?.['vatRegCode'] || '',
                                        placeholder: "Please add VAT reg number",
                                        className: "w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem",
                                        onChange: (event)=>setCompany({
                                                ...company,
                                                [event['target']['name']]: event['target']['value']
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        id: "ukUTRCode",
                                        name: "ukUTRCode",
                                        onBlur: saveAnswer,
                                        placeholder: "Please add UTR number",
                                        value: company?.['ukUTRCode'] || '',
                                        className: "w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem",
                                        onChange: (event)=>setCompany({
                                                ...company,
                                                [event['target']['name']]: event['target']['value']
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    const filingHistoryTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cFiling'] ? Math.ceil(company['cFiling'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (filingCurrentPage < totalPages - 1) setFilingCurrentPage(filingCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (filingCurrentPage > 0) setFilingCurrentPage(filingCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cFiling']) return [];
            let startIndex = filingCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cFiling'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "FILING HISTORY"
                }),
                company['cFiling'] && company['cFiling'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((history, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Category: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['category'] ? history['category'] : 'Officers'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "File name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['description'] || 'appoint-person-member-limited-liability-partnership-with-appointment-date'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Bar Code: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['barcode'] || 'XDZJMW00'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Transaction ID: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['transaction_id'] || 'MzQ2MDk4ODY3NGFkaXkzaXF6'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Date: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: history['date'] || '2025-04-01'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        history?.['Location'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            href: history['Location'],
                                            target: "_blank",
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "View Document"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${filingCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: filingCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${filingCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: filingCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const officersTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cOfficers'] ? Math.ceil(company['cOfficers'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (officersCurrentPage < totalPages - 1) setOfficersCurrentPage(officersCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (officersCurrentPage > 0) setOfficersCurrentPage(officersCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cOfficers']) return [];
            let startIndex = officersCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cOfficers'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "OFFICERS"
                }),
                company['cOfficers'] && company['cOfficers'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Role: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['officer_role'] ? data['officer_role'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "w70",
                                                        src: (parcelRequire("kBFDN")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['name'] ? data['name'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Appointed On: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['appointed_on'] ? data['appointed_on'] : '-'
                                                        })
                                                    ]
                                                }),
                                                data['appointment'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        data['appointment']['type'],
                                                        " Filing: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: data['appointment']['Location'],
                                                            target: "_blank",
                                                            className: "c3 fw600",
                                                            children: "View Document"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Address: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['address'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    data['address']['premises'] && data['address']['premises'],
                                                                    data['address']['address_line_1'] && ', ' + data['address']['address_line_1'],
                                                                    data['address']['address_line_2'] && ', ' + data['address']['address_line_2'],
                                                                    data['address']['locality'] && ' - ' + data['address']['locality'],
                                                                    data['address']['region'] && ', ' + data['address']['region'],
                                                                    data['address']['country'] && ', ' + data['address']['country']
                                                                ]
                                                            }) : '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>{
                                                setOfficersReadMore(data);
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'officersReadMore'
                                                }));
                                            },
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${officersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: officersCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${officersCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: officersCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const personsSignificantTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cSignificantControl'] ? Math.ceil(company['cSignificantControl'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (personsCurrentPage < totalPages - 1) setPersonsCurrentPage(personsCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (personsCurrentPage > 0) setPersonsCurrentPage(personsCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cSignificantControl']) return [];
            let startIndex = personsCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cSignificantControl'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "PERSONS WITH SIGNIFICANT CONTROL"
                }),
                company['cSignificantControl'] && company['cSignificantControl'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Significant Control"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['name'] ? data['name'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "mb0-5rem",
                                                    children: "Controls:"
                                                }),
                                                data['natures_of_control'] && data['natures_of_control'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    className: "ml1-5rem mb0-5rem",
                                                    children: data['natures_of_control'].map((control, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            className: "fw600",
                                                            children: control
                                                        }, idx))
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600",
                                                    children: "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>{
                                                setControlReadMore(data);
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'controlReadMore'
                                                }));
                                            },
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${personsCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: personsCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${personsCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: personsCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const chargesTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cCharges'] ? Math.ceil(company['cCharges'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (chargesCurrentPage < totalPages - 1) setChargesCurrentPage(chargesCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (chargesCurrentPage > 0) setChargesCurrentPage(chargesCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cCharges']) return [];
            let startIndex = chargesCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cCharges'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "CHARGES"
                }),
                company['cCharges'] && company['cCharges'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Status: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['status'] ? data['status'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Persons Entitled: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['persons_entitled'] ? data['persons_entitled'][0]['name'] : '-'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Charge Description: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: data['classification']['description'] ? data['classification']['description'] : '-'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>{
                                                setChargeReadMore(data);
                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'chargeReadMore'
                                                }));
                                            },
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${chargesCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: chargesCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${chargesCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: chargesCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    const registersTab = ()=>{
        let itemsPerPage = 4;
        let totalPages = company['cRegisters'] ? Math.ceil(company['cRegisters'].length / itemsPerPage) : 0;
        const handleNext = ()=>{
            if (registersCurrentPage < totalPages - 1) setRegistersCurrentPage(registersCurrentPage + 1);
        };
        const handlePrev = ()=>{
            if (registersCurrentPage > 0) setRegistersCurrentPage(registersCurrentPage - 1);
        };
        const getCurrentPageItems = ()=>{
            if (!company['cRegisters']) return [];
            let startIndex = registersCurrentPage * itemsPerPage;
            let endIndex = startIndex + itemsPerPage;
            return company['cRegisters'].slice(startIndex, endIndex);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "c14 fs1-125rem fw600 mb1-5rem tac ttu",
                    children: "REGISTERS"
                }),
                company['cRegisters'] && company['cRegisters'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fww gap1rem mb1-5rem",
                            children: getCurrentPageItems().map((data, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg19 br10px p1-5rem m0-5rem pr",
                                    style: {
                                        flex: '0 0 calc(45% - 0.5rem)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs0-75rem c15 mb0-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-circle mr0-5rem c12"
                                                        }),
                                                        "Register"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pa",
                                                    style: {
                                                        top: '1.5rem',
                                                        right: '1.5rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "",
                                                        src: (parcelRequire("bqQxn")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "c15 fs0-75rem mb0-75rem w80",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Name: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: "DE ROOS, Peter Wouter"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Occupation: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: "Occupation:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "mb0-5rem",
                                                    children: [
                                                        "Address: ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fw600",
                                                            children: "Lidl House, 14 , Kingston Road - Surbiton"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            className: "df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr0-5rem",
                                                    src: (parcelRequire("jNDOY")),
                                                    alt: ""
                                                }),
                                                "Read More"
                                            ]
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        totalPages > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcc aic gap0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem mr1rem ${registersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handlePrev,
                                    disabled: registersCurrentPage == 0,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: `c1 df aic jcc br100 p0-5rem ${registersCurrentPage == totalPages - 1 ? 'bg12 cna' : 'bg3 cp'}`,
                                    onClick: handleNext,
                                    disabled: registersCurrentPage == totalPages - 1,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        fill: "white",
                                        viewBox: "0 0 16 16",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 tac",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "my3rem c15 fs1-25rem tac",
                        children: "Coming Soon!"
                    })
                })
            ]
        });
    };
    //********** Company Profile **********//
    const companyProfile = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w80 mx1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb aic mb1rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "c14 fs1-5rem fw500 ttu",
                            children: company['cName']
                        }),
                        auditLogButton(`/company/update/${company['_id']}`)
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "fs1rem fw400 c15 mb0-5rem",
                    children: "Address"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                style: {
                                    position: 'absolute',
                                    left: '10px',
                                    top: '30%'
                                },
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 0C5.40545 0 2.48108 2.92437 2.48108 6.51888C2.48108 10.9798 8.31487 17.5287 8.56325 17.8053C8.79655 18.0651 9.20387 18.0647 9.43674 17.8053C9.68512 17.5287 15.5189 10.9798 15.5189 6.51888C15.5188 2.92437 12.5945 0 9 0ZM9 16.5139C7.03663 14.1817 3.65502 9.5805 3.65502 6.51895C3.65502 3.57166 6.05274 1.17394 9 1.17394C11.9473 1.17394 14.345 3.57166 14.345 6.51892C14.3449 9.58061 10.9639 14.181 9 16.5139Z",
                                        fill: "#505050"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 3.23926C7.19149 3.23926 5.7202 4.71058 5.7202 6.51909C5.7202 8.3276 7.19152 9.79892 9 9.79892C10.8085 9.79892 12.2798 8.3276 12.2798 6.51909C12.2798 4.71058 10.8085 3.23926 9 3.23926ZM9 8.62498C7.83879 8.62498 6.89414 7.6803 6.89414 6.51909C6.89414 5.35788 7.83882 4.4132 9 4.4132C10.1612 4.4132 11.1059 5.35788 11.1059 6.51909C11.1059 7.6803 10.1612 8.62498 9 8.62498Z",
                                        fill: "#505050"
                                    })
                                ]
                            }),
                            editInput == 'cAddress' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                onBlur: (event)=>{
                                    saveAnswer(event), setEditInput(null);
                                },
                                defaultValue: company?.['cAddress'],
                                name: "cAddress",
                                type: "text",
                                placeholder: "Address Line",
                                className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                readOnly: true,
                                value: company?.['cAddress'] || '',
                                placeholder: "Address Line",
                                onFocus: ()=>setEditInput('cAddress'),
                                className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        "fill-rule": "evenodd",
                                        "clip-rule": "evenodd",
                                        d: "M6.75 3C7.16421 3 7.5 3.33579 7.5 3.75V6H10.5V3.75C10.5 3.33579 10.8358 3 11.25 3C11.6642 3 12 3.33579 12 3.75V6H14.25C14.6642 6 15 6.33579 15 6.75C15 7.16421 14.6642 7.5 14.25 7.5H12V10.5H14.25C14.6642 10.5 15 10.8358 15 11.25C15 11.6642 14.6642 12 14.25 12H12V14.25C12 14.6642 11.6642 15 11.25 15C10.8358 15 10.5 14.6642 10.5 14.25V12H7.5V14.25C7.5 14.6642 7.16421 15 6.75 15C6.33579 15 6 14.6642 6 14.25V12H3.75C3.33579 12 3 11.6642 3 11.25C3 10.8358 3.33579 10.5 3.75 10.5H6V7.5H3.75C3.33579 7.5 3 7.16421 3 6.75C3 6.33579 3.33579 6 3.75 6H6V3.75C6 3.33579 6.33579 3 6.75 3ZM10.5 10.5V7.5H7.5V10.5H10.5Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cPostalCode' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company['cPostalCode'],
                                    name: "cPostalCode",
                                    type: "text",
                                    placeholder: "Postal Code",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company['cPostalCode'] || '',
                                    placeholder: "Postal Code",
                                    onFocus: ()=>setEditInput('cPostalCode'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15.3775 1.60232C15.179 1.48669 14.8423 1.32778 14.3885 1.17257C12.5943 0.558914 10.6085 0.558914 8.65143 1.58632C7.10195 2.39934 5.53205 2.39934 4.09686 1.9087C3.96647 1.86413 3.85052 1.82007 3.75001 1.77877V0.749988C3.75001 0.335777 3.4142 0 2.99999 0C2.58578 0 2.25 0.335777 2.25 0.749988V2.25035V9.76384V17.25C2.25 17.6642 2.58578 18 2.99999 18C3.4142 18 3.74998 17.6642 3.74998 17.25V10.8872C5.50758 11.454 7.44152 11.4286 9.34847 10.428C10.8981 9.61492 12.468 9.61492 13.9032 10.1056C14.2567 10.2264 14.5051 10.3436 14.6226 10.412C15.1226 10.7031 15.75 10.3425 15.75 9.76388V2.25039C15.75 1.98348 15.6081 1.73668 15.3775 1.60232ZM14.25 8.64025C12.4924 8.07353 10.5584 8.09919 8.6515 9.09977C7.10191 9.91287 5.53201 9.91287 4.09679 9.42223C3.96647 9.37768 3.85042 9.33363 3.74994 9.29232V3.37402C5.50751 3.94073 7.44152 3.91507 9.34843 2.91449C10.8981 2.10101 12.4679 2.10101 13.903 2.59182C14.0334 2.6364 14.1495 2.68049 14.25 2.72183V8.64025H14.25Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cCountry' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company['cCountry'],
                                    name: "cCountry",
                                    type: "text",
                                    placeholder: "Country",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company['cCountry'] || '',
                                    placeholder: "Country",
                                    onFocus: ()=>setEditInput('cCountry'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                    className: "fs1rem fw400 c15 mb0-5rem",
                    children: [
                        "Overview ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fs0-75rem fw300 c12 fsi",
                            children: "(200 words generated by AI)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb1-5rem",
                    children: editInput == 'description' ? /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        rows: 15,
                        onBlur: (event)=>{
                            saveAnswer(event), setEditInput(null);
                        },
                        defaultValue: company['description'] ? company['description'] : company['companyDescription'] ? company['companyDescription'] : "",
                        name: "description",
                        className: "w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem",
                        placeholder: "Overview..."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        onClick: ()=>setEditInput('description'),
                        className: "w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem",
                        children: company['description'] ? company['description'] : company['companyDescription'] ? company['companyDescription'] : ""
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: "fs1rem fw400 c15 mb0-5rem",
                    children: "Web & Socials"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9 1.125C7.44248 1.125 5.91992 1.58686 4.62489 2.45218C3.32985 3.31749 2.32049 4.5474 1.72445 5.98637C1.12841 7.42534 0.972461 9.00874 1.27632 10.5363C1.58018 12.0639 2.3302 13.4671 3.43154 14.5685C4.53288 15.6698 5.93607 16.4198 7.46367 16.7237C8.99127 17.0275 10.5747 16.8716 12.0136 16.2756C13.4526 15.6795 14.6825 14.6702 15.5478 13.3751C16.4131 12.0801 16.875 10.5575 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125ZM9 15.75C8.29688 15.75 7.38 14.3044 6.96938 11.8125H11.0306C10.62 14.3044 9.70313 15.75 9 15.75ZM6.82875 10.6875C6.77813 10.1587 6.75 9.59625 6.75 9C6.75 8.40375 6.77813 7.84125 6.82875 7.3125H11.1713C11.2219 7.84125 11.25 8.40375 11.25 9C11.25 9.59625 11.2219 10.1587 11.1713 10.6875H6.82875ZM2.25 9C2.25358 8.43063 2.32726 7.86386 2.46938 7.3125H5.70375C5.65313 7.875 5.625 8.4375 5.625 9C5.625 9.5625 5.65313 10.125 5.70375 10.6875H2.46938C2.32726 10.1361 2.25358 9.56937 2.25 9ZM9 2.25C9.70313 2.25 10.62 3.69563 11.0306 6.1875H6.96938C7.38 3.69563 8.29688 2.25 9 2.25ZM12.2963 7.3125H15.5306C15.8232 8.41848 15.8232 9.58152 15.5306 10.6875H12.2963C12.375 10.125 12.375 9.5625 12.375 9C12.375 8.4375 12.375 7.875 12.2963 7.3125ZM15.1088 6.1875H12.1613C11.9947 4.91356 11.5983 3.68044 10.9913 2.54813C11.8964 2.83223 12.732 3.30288 13.4441 3.92972C14.1562 4.55657 14.729 5.32569 15.1256 6.1875H15.1088ZM7.00875 2.54813C6.40171 3.68044 6.00528 4.91356 5.83875 6.1875H2.87438C3.271 5.32569 3.84382 4.55657 4.55593 3.92972C5.26803 3.30288 6.1036 2.83223 7.00875 2.54813ZM2.87438 11.8125H5.83875C6.00528 13.0864 6.40171 14.3196 7.00875 15.4519C6.1036 15.1678 5.26803 14.6971 4.55593 14.0703C3.84382 13.4434 3.271 12.6743 2.87438 11.8125ZM10.9913 15.4519C11.5983 14.3196 11.9947 13.0864 12.1613 11.8125H15.1256C14.729 12.6743 14.1562 13.4434 13.4441 14.0703C12.732 14.6971 11.8964 15.1678 10.9913 15.4519Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cWebsite' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company['cWebsite'],
                                    name: "cWebsite",
                                    type: "url",
                                    placeholder: "Website",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company['cWebsite'] || '',
                                    placeholder: "Website",
                                    onFocus: ()=>setEditInput('cWebsite'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w50 pr",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 18 18",
                                        fill: "none",
                                        style: {
                                            position: 'absolute',
                                            left: '10px',
                                            top: '30%'
                                        },
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z",
                                            fill: "#505050"
                                        })
                                    }),
                                    editInput == 'cLinkedin' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        onBlur: (event)=>{
                                            saveAnswer(event), setEditInput(null);
                                        },
                                        defaultValue: company['cLinkedin'],
                                        name: "cLinkedin",
                                        type: "url",
                                        placeholder: "LinkedIn Url",
                                        className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        readOnly: true,
                                        value: company['cLinkedin'] || '',
                                        placeholder: "LinkedIn Url",
                                        onFocus: ()=>setEditInput('cLinkedin'),
                                        className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df mb1-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr mr1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125V2.875C17 1.84106 16.1589 1 15.125 1ZM15.75 15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H11.4375V11.1875H13.4384L13.6715 9.25H11.4375V7.15625C11.4375 6.62183 11.8406 6.21875 12.375 6.21875H13.7812V4.40625C13.4111 4.354 12.6971 4.28125 12.375 4.28125C11.6461 4.28125 10.9155 4.58875 10.3706 5.12476C9.8092 5.677 9.5 6.40039 9.5 7.16174V9.25H7.46875V11.1875H9.5V15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cFacebook' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company['cFacebook'],
                                    name: "cFacebook",
                                    type: "url",
                                    placeholder: "Facebook URL",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company['cFacebook'] || '',
                                    placeholder: "Facebook URL",
                                    onFocus: ()=>setEditInput('cFacebook'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w50 pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                    style: {
                                        position: 'absolute',
                                        left: '10px',
                                        top: '30%'
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M9.15778 17C9.1048 17 9.05182 17 8.99847 16.9998C7.74428 17.0028 6.58542 16.9709 5.45842 16.9023C4.42518 16.8395 3.48203 16.4824 2.73078 15.8699C2.0059 15.2788 1.51088 14.4796 1.25953 13.4947C1.04077 12.6373 1.02918 11.7956 1.01807 10.9816C1.01001 10.3974 1.00171 9.7053 1 9.00144C1.00171 8.29465 1.01001 7.60251 1.01807 7.0184C1.02918 6.20444 1.04077 5.36276 1.25953 4.50521C1.51088 3.52035 2.0059 2.72115 2.73078 2.13009C3.48203 1.51753 4.42518 1.16048 5.45854 1.09761C6.58554 1.02913 7.74464 0.997147 9.00153 1.0002C10.2561 0.997514 11.4146 1.02913 12.5416 1.09761C13.5748 1.16048 14.518 1.51753 15.2692 2.13009C15.9942 2.72115 16.4891 3.52035 16.7405 4.50521C16.9592 5.36264 16.9708 6.20444 16.9819 7.0184C16.99 7.60251 16.9984 8.29465 17 8.99851V9.00144C16.9984 9.7053 16.99 10.3974 16.9819 10.9816C16.9708 11.7955 16.9593 12.6372 16.7405 13.4947C16.4891 14.4796 15.9942 15.2788 15.2692 15.8699C14.518 16.4824 13.5748 16.8395 12.5416 16.9023C11.4623 16.968 10.3536 17 9.15778 17ZM8.99847 15.7498C10.2323 15.7527 11.3651 15.7216 12.4656 15.6547C13.2469 15.6072 13.9243 15.3536 14.4793 14.9011C14.9922 14.4828 15.3455 13.9056 15.5292 13.1857C15.7114 12.4719 15.7219 11.7056 15.732 10.9645C15.7399 10.3843 15.7482 9.697 15.75 8.99998C15.7482 8.30283 15.7399 7.6157 15.732 7.03549C15.7219 6.2944 15.7114 5.52804 15.5292 4.81418C15.3455 4.0942 14.9922 3.51705 14.4793 3.09872C13.9243 2.64632 13.2469 2.39278 12.4656 2.3453C11.3651 2.27828 10.2323 2.2474 9.0014 2.25008C7.76784 2.24715 6.63486 2.27828 5.53435 2.3453C4.75307 2.39278 4.07568 2.64632 3.52073 3.09872C3.00777 3.51705 2.65448 4.0942 2.47076 4.81418C2.28862 5.52804 2.27812 6.29428 2.26799 7.03549C2.26006 7.61619 2.25176 8.30381 2.25005 9.00144C2.25176 9.69602 2.26006 10.3838 2.26799 10.9645C2.27812 11.7056 2.28862 12.4719 2.47076 13.1857C2.65448 13.9056 3.00777 14.4828 3.52073 14.9011C4.07568 15.3535 4.75307 15.6071 5.53435 15.6545C6.63486 15.7216 7.76808 15.7528 8.99847 15.7498ZM8.96869 12.9062C6.8148 12.9062 5.06229 11.1539 5.06229 8.99998C5.06229 6.84604 6.8148 5.09372 8.96869 5.09372C11.1227 5.09372 12.8751 6.84604 12.8751 8.99998C12.8751 11.1539 11.1227 12.9062 8.96869 12.9062ZM8.96869 6.34372C7.50403 6.34372 6.31234 7.53537 6.31234 8.99998C6.31234 10.4646 7.50403 11.6562 8.96869 11.6562C10.4335 11.6562 11.625 10.4646 11.625 8.99998C11.625 7.53537 10.4335 6.34372 8.96869 6.34372ZM13.3126 3.84371C12.7949 3.84371 12.3751 4.26339 12.3751 4.78122C12.3751 5.29904 12.7949 5.71872 13.3126 5.71872C13.8304 5.71872 14.2501 5.29904 14.2501 4.78122C14.2501 4.26339 13.8304 3.84371 13.3126 3.84371Z",
                                        fill: "#505050"
                                    })
                                }),
                                editInput == 'cInstagram' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    onBlur: (event)=>{
                                        saveAnswer(event), setEditInput(null);
                                    },
                                    defaultValue: company['cInstagram'],
                                    name: "cInstagram",
                                    type: "url",
                                    placeholder: "Instagram URL",
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    readOnly: true,
                                    value: company['cInstagram'] || '',
                                    placeholder: "Instagram URL",
                                    onFocus: ()=>setEditInput('cInstagram'),
                                    className: "w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "cp tac c1 br25px px2rem py0-75rem fw500",
                    style: {
                        backgroundColor: '#ff7b7b',
                        border: 'none',
                        fontSize: '0.9rem'
                    },
                    children: "Save Changes"
                })
            ]
        });
    };
    //********** Director's Information **********//
    const directorsInfo = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "p2rem",
            children: company['directors'] && company['directors'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df fww gap1-5rem",
                children: company['directors'].map((director, idx)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "p2rem bw1px bo16 br30px bss m1rem",
                        style: {
                            flex: '0 0 calc(44% - 0.75rem)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcsb mb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: director?.['headShot']?.['location'] || (parcelRequire("kBFDN")),
                                                className: "w60px h60px br100 mr1rem"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                class: "df fdc c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs1rem fw500 c14 mb0-25rem",
                                                        children: director['name'] ? director['name'] : '-'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs0-75rem fw600",
                                                        children: director['role'] ? director['role'] : 'Director'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs0-75rem fw400 fsi",
                                                        children: director['designation'] ? director['designation'] : 'llp-designated-member'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: (parcelRequire("bqQxn")),
                                            className: "w80"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    placeholder: "LinkedIn",
                                    value: formData['directorId'] === director['_id'] && formData['linkedIn'] ? formData['linkedIn'] : director['linkedIn'] || '',
                                    onFocus: (e1)=>{
                                        if (!formData['directorId'] || formData['directorId'] !== director['_id']) setFormData({
                                            linkedIn: director['linkedIn'] || '',
                                            companyId: company['_id'],
                                            directorId: director['_id']
                                        });
                                    },
                                    onBlur: (e1)=>{
                                        if (formData['linkedIn'] && formData['linkedIn'].length > 0 && formData['linkedIn'] !== director['linkedIn']) handleSubmitDirector();
                                    },
                                    onChange: (e1)=>setFormData({
                                            linkedIn: e1.target.value,
                                            companyId: company['_id'],
                                            directorId: director['_id']
                                        }),
                                    InputProps: {
                                        style: {
                                            borderRadius: "10px",
                                            marginBottom: '8px',
                                            fontSize: '14px'
                                        },
                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            style: {
                                                marginRight: '8px'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z",
                                                fill: "#505050"
                                            })
                                        })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "df aic h10",
                                children: director?.['cv'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            class: "fa fa-circle c4",
                                            style: {
                                                fontSize: '10px'
                                            },
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            target: "_blank",
                                            href: director['cv']?.['location'],
                                            className: "c3 fs0-75rem fw500 tdu",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "px0-5rem",
                                                children: director['cv']?.['originalname']
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>{
                                    showUploadPopup(director);
                                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'uploadCvData'
                                    }));
                                },
                                className: "df aic jcc cp bg3 c1 br10px px2rem py0-5rem my1rem fw500",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        class: "mr0-75rem",
                                        width: "23",
                                        height: "23",
                                        viewBox: "0 0 23 23",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                "clip-path": "url(#clip0_2183_912)",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
                                                        fill: "white"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M11.4914 17.7883C10.4699 17.7883 9.44852 17.7883 8.4273 17.7883C7.02663 17.7883 6.01589 16.7811 6.0087 15.3809C6.00601 14.8922 6.00601 14.4033 6.0087 13.9142C6.0114 13.4102 6.31687 13.0859 6.78406 13.085C7.25124 13.0841 7.56076 13.4062 7.5639 13.9097C7.56704 14.4133 7.5639 14.9052 7.5639 15.4029C7.56749 15.9249 7.87431 16.229 8.3981 16.2295C10.4672 16.2295 12.5362 16.2295 14.605 16.2295C15.1292 16.2295 15.4365 15.9249 15.4405 15.4034C15.4441 14.9056 15.4405 14.4079 15.4405 13.9102C15.4405 13.4124 15.7509 13.0841 16.2199 13.085C16.6889 13.0859 16.9988 13.4102 16.9948 13.9138C16.9899 14.5503 17.0253 15.1936 16.9454 15.8216C16.7989 16.9707 15.8192 17.782 14.6566 17.7874C13.6041 17.7905 12.5475 17.7883 11.4914 17.7883Z",
                                                        fill: "#4A67FF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M10.726 7.89412C10.6074 8.00463 10.5377 8.06527 10.473 8.13041C9.97531 8.63309 9.48027 9.13891 8.98029 9.63978C8.62541 9.99557 8.13082 10.0216 7.81008 9.71031C7.48934 9.399 7.50192 8.88824 7.85096 8.53695C8.86709 7.51453 9.88652 6.4957 10.9092 5.48047C11.2686 5.12109 11.7385 5.12109 12.0979 5.48047C13.1275 6.50169 14.1529 7.52726 15.1741 8.55717C15.5101 8.89633 15.5119 9.40619 15.1997 9.71076C14.8875 10.0153 14.3911 10.0019 14.0484 9.6618C13.5408 9.15643 13.0408 8.64297 12.5368 8.13445C12.4716 8.06887 12.402 8.00777 12.2982 7.90984C12.2915 8.0509 12.2834 8.14209 12.2834 8.23328C12.2834 9.84104 12.2856 11.4483 12.2834 13.0561C12.2834 13.6594 11.7524 14.0183 11.2003 13.8036C10.8949 13.6846 10.7291 13.4195 10.7291 13.0314C10.7273 11.4412 10.7273 9.85107 10.7291 8.26113L10.726 7.89412Z",
                                                        fill: "#4A67FF"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                    id: "clip0_2183_912",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                        width: "23",
                                                        height: "23",
                                                        fill: "white"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    "Upload CV"
                                ]
                            })
                        ]
                    }, idx);
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "c14 w100 mt2rem tac fs1-25rem",
                children: "This company has no directors!"
            })
        });
    };
    //********** Investor/Advisor Permissions **********//
    const permissionsTab = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "p1rem fs1rem mt2rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    class: "c14 fs1-25rem mb1rem",
                    children: "Stage of development:"
                }),
                [
                    {
                        qNo: 'D017.1',
                        title: 'Accountants'
                    },
                    {
                        qNo: 'D017.2',
                        title: 'Lawyers'
                    },
                    {
                        qNo: 'D017.3',
                        title: 'Intellectual Property Advisors'
                    },
                    {
                        qNo: 'D017.4',
                        title: 'Property Advisors'
                    },
                    {
                        qNo: 'D017.5',
                        title: 'PR & Media Advisors'
                    },
                    {
                        qNo: 'D017.6',
                        title: 'Corporate Finance Advisors'
                    },
                    {
                        qNo: 'D017.7',
                        title: 'Commercial Bankers'
                    },
                    {
                        qNo: 'D017.8',
                        title: 'Investment Bankers'
                    },
                    {
                        qNo: 'D017.9',
                        title: 'Insurance Brokers'
                    },
                    {
                        qNo: 'D017.10',
                        title: 'GDPR Advisors'
                    },
                    {
                        qNo: 'D017.11',
                        title: 'Registrars'
                    },
                    {
                        qNo: 'D017.12',
                        title: 'Corporate Brokers'
                    },
                    {
                        qNo: 'D017.13',
                        title: 'Other'
                    }
                ].map((item)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic jcsb mt1-5rem w80",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "mr1rem w70",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "c15 fs1rem",
                                                children: [
                                                    item['qNo'],
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: item['title']
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df mt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "url",
                                                        placeholder: "Web site url",
                                                        className: "w50 bss bw1px bo16 br10px p1rem mr1rem"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "email",
                                                        placeholder: "Email of contact",
                                                        className: "w50 bss bw1px bo16 br10px p1rem"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "df jce w30",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            for: item['qNo'],
                                            className: "df cp fs0-75rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "checkbox w30px h30px pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    name: item['title'],
                                                    id: item['qNo'],
                                                    className: "bg1 bo12 bw1px bss cp td250 w30px h30px br5px",
                                                    type: "radio"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                class: "db w80 mt1rem bg16",
                                style: {
                                    border: "none",
                                    height: "1px"
                                }
                            })
                        ]
                    });
                })
            ]
        });
    };
    //********** Our Funds Preferred Investment Criteria **********//
    const investmentLeads = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "p1rem pr mx1rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "br5px dg gg0-5rem mb1rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 df jcc aic",
                        children: [
                            'Standard Questions',
                            'Bespoked Questions'
                        ].map((item)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setLeadSectionActive(item),
                                className: `cp py0-5rem px1rem bg1 fs1rem ${item == leadSectionActive ? ' c3 fw600' : 'c12 fw400'}`,
                                style: {
                                    borderBottom: item == leadSectionActive && '2px solid #6366f1'
                                },
                                children: item
                            });
                        })
                    }),
                    leadSectionActive == 'Standard Questions' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "c15 fs1rem mt2rem mb0-5rem",
                                children: "STANDARD INVESTMENT APPLICANT QUESTIONS"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bss bw1px bo5 br10px p1-5rem c15 fs1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "dg",
                                    children: investorLeadQuestions && investorLeadQuestions.map((question)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            "data-module-type": question['type'],
                                            "data-section-no": question['qNo'],
                                            "data-question-id": question['_id'],
                                            className: "bss bw2px bo5 br10px px2rem py1rem mb1rem question-box",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fww pr w100 bsbb aic",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "tooltip-area-custom cp",
                                                        style: {
                                                            top: '-22px',
                                                            right: '-25px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h2rem",
                                                                    src: (parcelRequire("24u8s")),
                                                                    alt: ""
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "overlay-box",
                                                                    style: {
                                                                        left: '-380px',
                                                                        top: '0',
                                                                        right: 'auto'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                        className: "fs0-75rem c6",
                                                                        children: "Please toggle to include/exclude questions from your applicant lead qualification checklist. Please remember that the longer/more difficult the checklist, the less likely applicant companies are to complete it!"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w70 pr1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "mb2rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "fs1rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                            children: [
                                                                                question['qNo'],
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        question['qDescription']
                                                                    ]
                                                                }),
                                                                question['questionType'].includes('YN') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic fww",
                                                                    children: [
                                                                        'Yes',
                                                                        'No',
                                                                        'N/A'
                                                                    ].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            for: question['_id'] + option,
                                                                            className: "df cp fs0-75rem py1rem",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "checkbox w20px h20px pr",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        id: question['_id'] + option,
                                                                                        name: question['_id'],
                                                                                        type: "radio",
                                                                                        className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                                                                        "data-option": option,
                                                                                        defaultChecked: question['radioOption'] == option,
                                                                                        onChange: (e1)=>handleAnswer(e1, question['questionType'])
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                                    children: option
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                }),
                                                                question['questionType'].includes('DropDown') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w50 oyh td250 pr mt1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                                        name: question['_id'],
                                                                        value: question['dropdown'] || '',
                                                                        onChange: (e1)=>handleAnswer(e1, question['questionType']),
                                                                        className: "pl1rem bss bw1px bo16 w100 br20px p1rem",
                                                                        children: [
                                                                            question['dropdown'] && /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                value: question['dropdown'],
                                                                                selected: true,
                                                                                disabled: true,
                                                                                hidden: true,
                                                                                children: question['dropdown']
                                                                            }),
                                                                            question['options'] && question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                                    value: option['name'].replaceAll("'", ','),
                                                                                    children: option['name'].replaceAll("'", ',')
                                                                                }, idx))
                                                                        ]
                                                                    })
                                                                }),
                                                                question['questionType'].includes('Radio') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic fww",
                                                                    children: question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            for: question['_id'] + option['name'],
                                                                            className: "df cp fs0-75rem py1rem",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "checkbox w20px h20px pr",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        id: question['_id'] + option['name'],
                                                                                        name: question['_id'],
                                                                                        type: "radio",
                                                                                        className: "bg1 bo4 bw1px bss cp td250 w20px h20px br5px",
                                                                                        "data-option": option['name'],
                                                                                        defaultChecked: question['dropdown'] == option['name'],
                                                                                        onChange: (e1)=>handleAnswer(e1, question['questionType'])
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                                    children: option['name']
                                                                                })
                                                                            ]
                                                                        }, idx))
                                                                }),
                                                                question?.questionType.includes('Multi') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "multi-dropdown mt1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96e1233e8d06bb2d$export$2e2bcd8739ae039), {
                                                                        id: "demo-multiple-checkbox",
                                                                        name: question['_id'],
                                                                        labelId: "demo-multiple-checkbox-label",
                                                                        multiple: true,
                                                                        className: "w400px",
                                                                        placeholder: "Select any options from dropdown",
                                                                        onChange: (e1)=>handleAnswer(e1, question['questionType']),
                                                                        renderValue: (selected)=>selected.join(', '),
                                                                        value: question['dropdown'] ? question['dropdown'].split(";") : [],
                                                                        children: question['options'].map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1ac984bce84b2164$export$2e2bcd8739ae039), {
                                                                                value: option['name'],
                                                                                className: "multi-dropdown-list",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12775c00f473d955$export$2e2bcd8739ae039), {
                                                                                        checked: question['dropdown']?.split(";").indexOf(option['name']) > -1
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d696835f9b43a35$export$2e2bcd8739ae039), {
                                                                                        primary: option['name']
                                                                                    })
                                                                                ]
                                                                            }))
                                                                    })
                                                                }),
                                                                question['questionType'] == 'T' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "w80 oyh td250 pr mt1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                        rows: "3",
                                                                        name: question['_id'],
                                                                        type: "text",
                                                                        style: {
                                                                            resize: "vertical"
                                                                        },
                                                                        className: "pl1-5rem bss bw1px bo16 w100 br15px p1rem",
                                                                        placeholder: "Any notes you wish to add",
                                                                        defaultValue: question['comment'],
                                                                        onBlur: (e1)=>handleAnswer(e1, question['questionType'])
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w30 pl1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "pr tae mb6rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                                className: "success",
                                                                defaultChecked: true
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }))
                                })
                            })
                        ]
                    }),
                    leadSectionActive == 'Bespoked Questions' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "c15 fs1rem mt2rem",
                                children: "BESPOKE INVESTMENT APPLICANT QUESTIONS"
                            }),
                            [
                                'Question 1',
                                'Question 2',
                                'Question 3'
                            ].map((item)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bss bw1px bo16 br10px p1-5rem px1rem mb1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fww pr w100 bsbb aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "tooltip-area-custom cp",
                                                style: {
                                                    top: '-30px',
                                                    right: '-30px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                    className: "icon",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "h2rem",
                                                            src: (parcelRequire("24u8s")),
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "overlay-box",
                                                            style: {
                                                                left: '-380px',
                                                                top: '0',
                                                                right: 'auto'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs0-75rem c6",
                                                                children: "Please toggle to include/exclude questions from your applicant lead qualification checklist. Please remember that the longer/more difficult the checklist, the less likely applicant companies are to complete it!"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w70 pr1rem c15",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "mb1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "fs1rem fw500",
                                                                children: [
                                                                    item,
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                name: "input-text",
                                                                type: "text",
                                                                placeholder: "Write question in your own words",
                                                                className: "w100 bss bw1px br10px bo16 p1rem my1rem"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df aic fww ",
                                                                children: [
                                                                    'Checkbox',
                                                                    'Multiline',
                                                                    'Radio',
                                                                    'Dropdowns',
                                                                    'Text'
                                                                ].map((option)=>{
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                        for: option,
                                                                        className: "df cp fs0-75rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "checkbox w30px h30px pr",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    "data-option": option,
                                                                                    name: "option",
                                                                                    id: option,
                                                                                    className: "bg1 bo16 bw1px bss cp td250 w30px h30px br5px",
                                                                                    type: "radio",
                                                                                    checked: ""
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "w100 fs0-75rem lh3 ml0-5rem usn mr2rem fw500",
                                                                                children: option
                                                                            })
                                                                        ]
                                                                    });
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        name: "input-text",
                                                        type: "text",
                                                        placeholder: "Insert desired answer from company",
                                                        className: "w100 bss bw1px br10px bo16 p1rem"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w30 pl1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "pr tae mb6rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                        className: "success",
                                                        defaultChecked: true
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                });
                            })
                        ]
                    })
                ]
            })
        });
    };
    //********** Preferred Contact for Leads **********//
    const preferredContactForLeads = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem",
                            children: company['cName']
                        }),
                        auditLogButton(`/company/addEditDeleteInvestor`)
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "br5px dg gg0-5rem my1rem mb1rem invest-box-funds mt2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcsb aic mt1rem mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "user-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w6rem h6rem pr br100 mb0-5ren",
                                                src: (selectedContact || companyContact)?.['profile'] || (parcelRequire("cfmAr")),
                                                alt: "TODO"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "df fs1-25rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                (selectedContact || companyContact)?.['firstName'] ? (selectedContact || companyContact)?.['firstName'] : '',
                                                                " ",
                                                                (selectedContact || companyContact)?.['lastName'] ? (selectedContact || companyContact)?.['lastName'] : ''
                                                            ]
                                                        }),
                                                        (selectedContact || companyContact)?.['linkedIn'] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            href: (selectedContact || companyContact)?.['linkedIn'].includes('https') ? (selectedContact || companyContact)?.['linkedIn'] : `https://${(selectedContact || companyContact)?.['linkedIn']}`,
                                                            target: "_blank",
                                                            className: "icon ml0-5rem bg1 cp",
                                                            style: {
                                                                width: '15px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                id: "icon",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    version: "1.1",
                                                                    className: "f3",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    viewBox: "0 0 310 310",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73                C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4                c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599                c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319                c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995                C310,145.43,300.549,94.761,230.454,94.761z"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "group-inputs",
                                                    children: editInput == 'job' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "df tac p0rem fs1rem c4 fw600",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            name: "job",
                                                            type: "text",
                                                            className: "c2",
                                                            defaultValue: (selectedContact || companyContact)?.['job'] || (selectedContact || companyContact)?.['title'],
                                                            placeholder: "Enter job title",
                                                            onBlur: ()=>{
                                                                saveSettings(), setEditInput(null);
                                                            },
                                                            onChange: (event)=>handleContactChange(event)
                                                        })
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs1rem c4 fw600",
                                                        children: (selectedContact || companyContact)?.['job'] ? (selectedContact || companyContact)?.['job'] : (selectedContact || companyContact)?.['title'] ? (selectedContact || companyContact)?.['title'] : ''
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-area progress-dashboard",
                                    style: {
                                        display: 'flex',
                                        position: 'relative',
                                        justifyContent: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "progress-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "progress-bar",
                                                style: {
                                                    width: 50,
                                                    height: 50
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                    className: `${promptScore > 67 ? 'green' : promptScore > 33 ? 'orange' : 'red'}`,
                                                    value: promptScore || 0,
                                                    text: `${promptScore || 0}%`,
                                                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                        strokeLinecap: 'round',
                                                        strokeWidth: '5px',
                                                        textSize: '20px',
                                                        pathTransitionDuration: 0.5,
                                                        trailColor: '#d6d6d6',
                                                        backgroundColor: '#fc7785',
                                                        dominantBaseline: 'ideographic'
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    marginBottom: '0',
                                                    fontSize: '11px'
                                                },
                                                className: "text-center-area",
                                                children: "Prompt Response Score"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "content-area",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "right-list",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs14px",
                                                        style: {
                                                            width: '50px',
                                                            fontWeight: 600
                                                        },
                                                        children: "Email:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "group-inputs",
                                                            children: editInput == 'email' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "df tac p0rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    name: "email",
                                                                    type: "text",
                                                                    className: "c2",
                                                                    defaultValue: (selectedContact || companyContact)?.['email'],
                                                                    placeholder: "Enter email",
                                                                    onBlur: ()=>{
                                                                        saveSettings(), setEditInput(null);
                                                                    },
                                                                    onChange: (event)=>handleContactChange(event)
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "ml0-5rem df jcfe",
                                                                style: {
                                                                    display: 'flex'
                                                                },
                                                                children: (selectedContact || companyContact)?.['email']
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs14px",
                                                        style: {
                                                            width: '50px',
                                                            fontWeight: 600
                                                        },
                                                        children: "Tel:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "group-inputs",
                                                            children: editInput == 'phone' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "df tac p0rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    name: "phone",
                                                                    type: "text",
                                                                    className: "c2",
                                                                    defaultValue: (selectedContact || companyContact)?.['phone'],
                                                                    placeholder: "Enter telephone number",
                                                                    onBlur: ()=>{
                                                                        saveSettings(), setEditInput(null);
                                                                    },
                                                                    onChange: (event)=>handleContactChange(event)
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "ml0-5rem df jcfe",
                                                                style: {
                                                                    display: 'flex'
                                                                },
                                                                children: (selectedContact || companyContact)?.['phone']
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            (selectedContact || companyContact)?.['linkedIn'] && (selectedContact || companyContact)?.['linkedIn'] !== "" && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs14px",
                                                        style: {
                                                            width: '50px',
                                                            fontWeight: 600
                                                        },
                                                        children: "LinkedIn:"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "group-inputs",
                                                            children: editInput == 'linkedIn' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "df tac p0rem",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    name: "linkedIn",
                                                                    type: "text",
                                                                    className: "c2",
                                                                    defaultValue: (selectedContact || companyContact)?.['linkedIn'],
                                                                    placeholder: "Enter linkedIn Profile",
                                                                    onBlur: ()=>{
                                                                        saveSettings(), setEditInput(null);
                                                                    },
                                                                    onChange: (event)=>handleContactChange(event)
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "cp tdu c3-hover ml0-5rem df jcfe",
                                                                style: {
                                                                    display: 'flex'
                                                                },
                                                                children: (selectedContact || companyContact)?.['linkedIn'] && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: "link-area",
                                                                    href: (selectedContact || companyContact)?.['linkedIn'].includes('https') ? (selectedContact || companyContact)?.['linkedIn'] : `https://${(selectedContact || companyContact)?.['linkedIn']}`,
                                                                    target: "_blank",
                                                                    children: (selectedContact || companyContact)?.['linkedIn'].length > 24 ? `${(selectedContact || companyContact)?.['linkedIn'].slice(0, 24)}...` : (selectedContact || companyContact)?.['linkedIn']
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            children: "Investor Bio"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "group-inputs",
                            children: editInput == 'bio' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "df tac p0rem",
                                style: {
                                    border: '1px solid #eaeaea',
                                    borderRadius: '12px',
                                    padding: '12px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    rows: 5,
                                    name: "bio",
                                    type: "text",
                                    className: "c2",
                                    value: companyContact?.['bio'] || '',
                                    placeholder: "Enter bio",
                                    onBlur: ()=>{
                                        saveSettings(), setEditInput(null);
                                    },
                                    onChange: (event)=>handleContactChange(event)
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                onClick: ()=>setEditInput('bio'),
                                style: {
                                    borderBottom: '1px solid #eaeaea',
                                    paddingBottom: '12px'
                                },
                                children: companyContact?.['bio'] || 'Enter bio here...'
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "table-container bg1 bo5 bw2px bss br10px p1rem mt1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "table-header df aic py1rem px0-5rem mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w25 tal fs0-875rem fw600 c15",
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w25 tal fs0-875rem fw600 c15",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w20 tal fs0-875rem fw600 c15",
                                            children: "Phone"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w20 tal fs0-875rem fw600 c15",
                                            children: "Business Card"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w20 tal fs0-875rem fw600 c15",
                                            children: "Role"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w10 tac fs0-875rem fw600 c15",
                                            children: "Contact"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "table-body",
                                    children: company['members'] && company['members'].length > 0 ? company['members'].map((member, index)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: `table-row df aic py1rem px0-5rem mb0-5rem bg1`,
                                            style: {
                                                transition: 'background-color 0.2s'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w25 df aic",
                                                    children: [
                                                        member?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w3rem h3rem br100 bo5 bw2px bss new-shadow",
                                                            src: member['profile'],
                                                            alt: ""
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "w3rem h3rem df jcc aic br100 bg16 new-shadow c15 fs0-875rem fw600",
                                                            children: member?.['firstName'] ? member?.['firstName']?.[0] + (member?.['lastName'] ? member?.['lastName']?.[0] : "") : "?"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                            className: "fs0-875rem fw600 c15 mb0-25rem ml0-5rem",
                                                            children: member?.['firstName'] ? member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : "") : "Unknown"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w25",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem c15",
                                                        children: member['email'] || 'N/A'
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w20",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fs0-75rem c15",
                                                        children: member['phone'] || member['phoneNumber'] || 'N/A'
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w20",
                                                    children: (0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(member) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "45",
                                                        height: "43",
                                                        viewBox: "0 0 45 43",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M30.0807 5H7.91406C4.63656 5 1.97656 7.66 1.97656 10.9375V26.7708C1.97656 30.0483 4.63656 32.7083 7.91406 32.7083H30.0807C33.3582 32.7083 36.0182 30.0483 36.0182 26.7708V10.9375C36.0182 7.66 33.3582 5 30.0807 5ZM33.6432 26.7708C33.6432 28.7342 32.0441 30.3333 30.0807 30.3333H7.91406C5.95073 30.3333 4.35156 28.7342 4.35156 26.7708V10.9375C4.35156 8.97417 5.95073 7.375 7.91406 7.375H30.0807C32.0441 7.375 33.6432 8.97417 33.6432 10.9375V26.7708ZM17.4457 20.2C18.1582 19.4242 18.6016 18.395 18.6016 17.2708C18.6016 14.8642 16.6541 12.9167 14.2474 12.9167C11.8407 12.9167 9.89323 14.8642 9.89323 17.2708C9.89323 18.395 10.3366 19.4242 11.0491 20.2C9.95656 20.8967 9.10156 21.9417 8.65823 23.2242C8.4524 23.8417 8.76906 24.5225 9.4024 24.7283C10.0199 24.9342 10.7007 24.6017 10.9066 23.9842C11.3974 22.575 12.7274 21.625 14.2474 21.625C15.7674 21.625 17.1132 22.575 17.5882 23.9842C17.7624 24.475 18.2216 24.7917 18.7124 24.7917C18.8391 24.7917 18.9657 24.7758 19.0924 24.7283C19.7099 24.5225 20.0424 23.8417 19.8366 23.2242C19.3932 21.9417 18.5382 20.8967 17.4457 20.2ZM12.2682 17.2708C12.2682 16.1783 13.1549 15.2917 14.2474 15.2917C15.3399 15.2917 16.2266 16.1783 16.2266 17.2708C16.2266 18.3633 15.3399 19.25 14.2474 19.25C13.1549 19.25 12.2682 18.3633 12.2682 17.2708ZM29.6849 15.6875C29.6849 16.3367 29.1466 16.875 28.4974 16.875H23.7474C23.0982 16.875 22.5599 16.3367 22.5599 15.6875C22.5599 15.0383 23.0982 14.5 23.7474 14.5H28.4974C29.1466 14.5 29.6849 15.0383 29.6849 15.6875ZM29.6849 22.0208C29.6849 22.67 29.1466 23.2083 28.4974 23.2083H23.7474C23.0982 23.2083 22.5599 22.67 22.5599 22.0208C22.5599 21.3717 23.0982 20.8333 23.7474 20.8333H28.4974C29.1466 20.8333 29.6849 21.3717 29.6849 22.0208Z",
                                                                fill: "#151313"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "32.5",
                                                                cy: "29.5",
                                                                r: "9.5",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M33 19C27.5 19 23 23.5 23 29C23 34.5 27.5 39 33 39C38.5 39 43 34.5 43 29C43 23.5 38.5 19 33 19ZM37.3 26.6L32.7 32.6C32.5 32.8 32.2 33 31.9 33C31.6 33 31.3 32.9 31.1 32.6L28.7 29.5C28.4 29.1 28.4 28.4 28.9 28.1C29.4 27.8 30 27.8 30.3 28.3L31.9 30.4L35.7 25.4C36 25 36.7 24.9 37.1 25.2C37.6 25.5 37.6 26.1 37.3 26.6Z",
                                                                fill: "#02BC7D"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "44",
                                                        height: "42",
                                                        viewBox: "0 0 44 42",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M30.0834 5.14648H7.91669C4.63919 5.14648 1.97919 7.80648 1.97919 11.084V26.9173C1.97919 30.1948 4.63919 32.8548 7.91669 32.8548H30.0834C33.3609 32.8548 36.0209 30.1948 36.0209 26.9173V11.084C36.0209 7.80648 33.3609 5.14648 30.0834 5.14648ZM33.6459 26.9173C33.6459 28.8807 32.0467 30.4798 30.0834 30.4798H7.91669C5.95335 30.4798 4.35419 28.8807 4.35419 26.9173V11.084C4.35419 9.12065 5.95335 7.52148 7.91669 7.52148H30.0834C32.0467 7.52148 33.6459 9.12065 33.6459 11.084V26.9173ZM17.4484 20.3465C18.1609 19.5707 18.6042 18.5415 18.6042 17.4173C18.6042 15.0107 16.6567 13.0632 14.25 13.0632C11.8434 13.0632 9.89585 15.0107 9.89585 17.4173C9.89585 18.5415 10.3392 19.5707 11.0517 20.3465C9.95919 21.0432 9.10419 22.0882 8.66085 23.3707C8.45502 23.9882 8.77169 24.669 9.40502 24.8748C10.0225 25.0807 10.7034 24.7482 10.9092 24.1307C11.4 22.7215 12.73 21.7715 14.25 21.7715C15.77 21.7715 17.1159 22.7215 17.5909 24.1307C17.765 24.6215 18.2242 24.9382 18.715 24.9382C18.8417 24.9382 18.9684 24.9223 19.095 24.8748C19.7125 24.669 20.045 23.9882 19.8392 23.3707C19.3959 22.0882 18.5409 21.0432 17.4484 20.3465ZM12.2709 17.4173C12.2709 16.3248 13.1575 15.4382 14.25 15.4382C15.3425 15.4382 16.2292 16.3248 16.2292 17.4173C16.2292 18.5098 15.3425 19.3965 14.25 19.3965C13.1575 19.3965 12.2709 18.5098 12.2709 17.4173ZM29.6875 15.834C29.6875 16.4832 29.1492 17.0215 28.5 17.0215H23.75C23.1009 17.0215 22.5625 16.4832 22.5625 15.834C22.5625 15.1848 23.1009 14.6465 23.75 14.6465H28.5C29.1492 14.6465 29.6875 15.1848 29.6875 15.834ZM29.6875 22.1673C29.6875 22.8165 29.1492 23.3548 28.5 23.3548H23.75C23.1009 23.3548 22.5625 22.8165 22.5625 22.1673C22.5625 21.5182 23.1009 20.9798 23.75 20.9798H28.5C29.1492 20.9798 29.6875 21.5182 29.6875 22.1673Z",
                                                                fill: "#151313"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "31.5",
                                                                cy: "30.5",
                                                                r: "9.5",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                "clip-path": "url(#clip0_2434_60524)",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M32 20C26.4858 20 22 24.4858 22 30C22 35.5142 26.4858 40 32 40C37.5142 40 42 35.5142 42 30C42 24.4858 37.5142 20 32 20Z",
                                                                        fill: "#F14D4D"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M35.6826 32.5033C36.0083 32.8292 36.0083 33.3558 35.6826 33.6817C35.5201 33.8442 35.3067 33.9259 35.0933 33.9259C34.88 33.9259 34.6666 33.8442 34.5041 33.6817L32 31.1774L29.4959 33.6817C29.3334 33.8442 29.1201 33.9259 28.9067 33.9259C28.6933 33.9259 28.48 33.8442 28.3175 33.6817C27.9917 33.3558 27.9917 32.8292 28.3175 32.5033L30.8217 29.9992L28.3175 27.495C27.9917 27.1691 27.9917 26.6425 28.3175 26.3166C28.6434 25.9908 29.17 25.9908 29.4959 26.3166L32 28.8209L34.5041 26.3166C34.8301 25.9908 35.3566 25.9908 35.6826 26.3166C36.0083 26.6425 36.0083 27.1691 35.6826 27.495L33.1783 29.9992L35.6826 32.5033Z",
                                                                        fill: "#FAFAFA"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                    id: "clip0_2434_60524",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                        width: "20",
                                                                        height: "20",
                                                                        fill: "white",
                                                                        transform: "translate(22 20)"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w20",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `fs0-75rem pr0-75rem py0-25rem br20px c15`,
                                                        children: member['role'] && `${member['role']} ${member['_id'] === company['creatorId']['_id'] ? 'Owner' : ''}` || member['designation'] || member['title'] || member['job'] || 'Member'
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 tac",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                        className: `cp df jcc ${!(0, $8ec3d7e6915201e2$export$c760f1fe68383d8d)(member) && member['_id'] !== company['creatorId']['_id'] && 'op50'}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "radio",
                                                            name: "preferredContact",
                                                            value: member['_id'],
                                                            checked: selectedContact?.['_id'] === member['_id'],
                                                            onChange: ()=>handleSetLead(member),
                                                            className: "cp",
                                                            style: {
                                                                width: '18px',
                                                                height: '18px',
                                                                accentColor: '#2979ff'
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        }, member['_id']);
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc aic py2rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "fs1rem c15",
                                            children: "No team members found"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "cp bg4 c1 fw400 fs1rem px3rem py0-5rem br15px",
                                        onClick: handleSavePreferredContact,
                                        children: "Save Preferred Contact"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $def17927b8072e3f$export$2e2bcd8739ae039), {
                page: "Settings",
                company: company,
                breadcrum: [
                    'View',
                    '/Settings',
                    `/${selectedInvestorTab}`
                ],
                heading: `${user?.['role']} Settings`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "td250 px6rem py1rem w100 df setting-inverter-page-main",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w80 mr1rem gg1rem bg1 setting-inverter-page",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ttc df jcc tac",
                                children: indexTab && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "w100 c15 fs2rem fw500 mb1rem df aic jcc",
                                    children: indexTab == "AdvisorMatch" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c4",
                                                children: "Advisor"
                                            }),
                                            "Match",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "cp mb2rem",
                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: 'howItWorksModal'
                                                    })),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 27 27",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "13.5",
                                                            cy: "13.5",
                                                            r: "13.5",
                                                            transform: "matrix(1 0 0 -1 0 27)",
                                                            fill: "#59B8FD"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M12.1581 11.0172C12.1652 10.5566 12.5413 10.1875 13.0019 10.1875C13.4624 10.1875 13.8386 10.5602 13.8456 11.0172L14.1269 18.5969C14.1445 18.8852 14.039 19.1664 13.8351 19.3844C13.6171 19.6164 13.3148 19.75 13.0019 19.75C12.689 19.75 12.3867 19.6164 12.1687 19.3844C11.9648 19.1664 11.8593 18.8852 11.8769 18.5969L12.1581 11.0172Z",
                                                            fill: "white"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M13 6.25C13.6213 6.25 14.125 6.75368 14.125 7.375C14.125 7.99632 13.6213 8.5 13 8.5C12.3787 8.5 11.875 7.99632 11.875 7.375C11.875 6.75368 12.3787 6.25 13 6.25Z",
                                                            fill: "white"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : indexTab
                                })
                            }),
                            indexTab == "Companies House Data" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df jcc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    onClick: ()=>fetchCompany(),
                                    className: "cp tac c1 bg3 bg4-hover br5px shadow px2rem py0-5rem fw500 mt1rem",
                                    children: "Refresh"
                                })
                            }),
                            indexTab == "Companies House Data" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: companiesHouseData()
                            }),
                            indexTab == "Company Profile" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: companyProfile()
                            }),
                            indexTab == "Director's Information" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: directorsInfo()
                            }),
                            user?.['role'] == 'Advisor' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    indexTab == "Advisor Permissions" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: permissionsTab()
                                    }),
                                    indexTab == "AdvisorMatch" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a13e63b7a73e33fd$export$2e2bcd8739ae039), {
                                        user: user,
                                        company: company,
                                        advisors: advisors,
                                        setAdvisors: setAdvisors,
                                        clientMatchTabs: clientMatchTabs,
                                        selectedClientMatchTab: selectedClientMatchTab,
                                        setSelectedClientMatchTab: setSelectedClientMatchTab
                                    })
                                ]
                            }) : user?.['role'] == 'Investor' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    indexTab == "Investor Permissions" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: permissionsTab()
                                    }),
                                    indexTab == "InvestorMatch Criteria" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b40dd314a65fd52f$export$2e2bcd8739ae039), {
                                        user: user,
                                        company: company,
                                        options: options,
                                        isValid: isValid,
                                        ukRegions: ukRegions,
                                        setCompany: setCompany,
                                        companyContact: companyContact,
                                        setAuditLogList: setAuditLogList,
                                        investorMatchTabs: investorMatchTabs,
                                        setSelectedContact: setSelectedContact,
                                        selectedInvestorTab: selectedInvestorTab,
                                        setSelectedInvestorTab: setSelectedInvestorTab
                                    }),
                                    indexTab == "Investment Leads" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: investmentLeads()
                                    }),
                                    indexTab == "Preferred Contact For Leads" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: preferredContactForLeads()
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                        ]
                    }),
                    getSidebarHTML()
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'addContact',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr oya",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "w20 pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 pb0-5rem",
                            children: "Add Investor Team Member"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc gg1rem px2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "form-group df jsc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "img-upload-area pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "img-box pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: newContact['profilePicture'] || (parcelRequire("cfmAr")),
                                                    alt: "Profile",
                                                    className: "profile-img w7rem h7rem advisor-profile shadow"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "input-file",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "add-btn bg5",
                                                        onClick: ()=>{
                                                            setIsImageModal(true), setUploadType('newContactImage'), setCurrentImage('');
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            viewBox: "0 0 487 487",
                                                            className: "zi3",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z                M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9                v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z                M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z                M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb0-5rem fs0-75rem tal df jcfs w100",
                                    children: "Please note that Contact can only be added if all fields are completed"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dg gtcr2-md gg1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    name: "firstName",
                                                    type: "text",
                                                    placeholder: "First Name",
                                                    className: "pl4rem shadow bg5 w100 br5px p1rem",
                                                    value: newContact['firstName'] || '',
                                                    onChange: (event)=>handleNewContactChange(event)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                    viewBox: "0 0 640 512",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                        className: "fa-secondary"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pr",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    name: "lastName",
                                                    type: "text",
                                                    placeholder: "Last Name",
                                                    className: "pl4rem shadow bg5 w100 br5px p1rem",
                                                    value: newContact['lastName'] || '',
                                                    onChange: (event)=>handleNewContactChange(event)
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                    viewBox: "0 0 640 512",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z",
                                                        className: "fa-secondary"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            name: "email",
                                            type: "email",
                                            placeholder: "Email",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem",
                                            value: newContact['email'] || '',
                                            onChange: (event)=>handleNewContactChange(event)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            viewBox: "0 0 512 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z",
                                                    className: "fa-secondary"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z",
                                                    className: "fa-primary"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            name: "phone",
                                            type: "text",
                                            placeholder: "Phone Number",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem",
                                            value: newContact['phone'],
                                            onChange: (event)=>handleNewContactChange(event)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 384 512",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-primary",
                                                    d: "M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    className: "fa-secondary",
                                                    d: "M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            name: "linkedIn",
                                            type: "url",
                                            placeholder: "LinkedIn",
                                            className: "pl4rem shadow bg5 w100 br5px p1rem",
                                            value: newContact['linkedIn'],
                                            onChange: (event)=>handleNewContactChange(event)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                            version: "1.1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 310 310",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        id: "XMLID_802_",
                                                        d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73             C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        id: "XMLID_803_",
                                                        d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4             c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        id: "XMLID_804_",
                                                        d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599             c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319             c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995             C310,145.43,300.549,94.761,230.454,94.761z"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcsb tar mt1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            className: "pr shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem w30 usn cp ttu bsbb tac",
                                            onClick: ()=>addNewContact(),
                                            children: [
                                                "Add Contact",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "tooltip-area-custom cp",
                                                    style: {
                                                        top: '-8px',
                                                        right: '-8px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                        className: "icon",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "h2rem",
                                                                src: (parcelRequire("24u8s")),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "overlay-box",
                                                                style: {
                                                                    left: 'auto',
                                                                    top: '0',
                                                                    right: '-380px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                    className: "fs0-75rem c6",
                                                                    children: [
                                                                        "We want to provide a great experience to both investors and applicant companies. We recognize that you may not be the correct contact but ask you that you complete all the fields for any individual named as replacement. We ask that the contact email not be enquiries@vcname.com etc. We want our curated leads to go to a named individual for assessment.",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                        " Thank you,",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                        " Diligentsia Team"
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df jce",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "fs0-75rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            children: "Designate as main recipient for leads"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "switch-box",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                                name: "isMainRecipient",
                                                                className: "success",
                                                                checked: isMainRecipient,
                                                                onChange: (event)=>handleNewContactChange(event)
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'officersReadMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "avtar-area df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem",
                                src: (parcelRequire("dR1A7")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-gradient fs1-5rem tac",
                            children: "Officers"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setOfficersReadMore({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "c15 group-inputs mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Name:"
                                        }),
                                        "  ",
                                        officersReadMore['name'] ? officersReadMore['name'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Role:"
                                        }),
                                        "  ",
                                        officersReadMore['officer_role'] ? officersReadMore['officer_role'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Address:"
                                        }),
                                        " ",
                                        officersReadMore['address'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                officersReadMore['address']['premises'] && officersReadMore['address']['premises'],
                                                officersReadMore['address']['address_line_1'] && ', ' + officersReadMore['address']['address_line_1'],
                                                officersReadMore['address']['address_line_2'] && ', ' + officersReadMore['address']['address_line_2'],
                                                officersReadMore['address']['locality'] && ' - ' + officersReadMore['address']['locality'],
                                                officersReadMore['address']['region'] && ', ' + officersReadMore['address']['region'],
                                                officersReadMore['address']['country'] && ', ' + officersReadMore['address']['country']
                                            ]
                                        }) : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Nationality:"
                                        }),
                                        "  ",
                                        officersReadMore['nationality'] ? officersReadMore['nationality'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Occupation:"
                                        }),
                                        "  ",
                                        officersReadMore['occupation'] ? officersReadMore['occupation'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "DOB:"
                                        }),
                                        "  ",
                                        officersReadMore['date_of_birth'] ? officersReadMore['date_of_birth']['month'] + '/' + officersReadMore['date_of_birth']['year'] : '-'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'controlReadMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "avtar-area df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem",
                                src: (parcelRequire("dR1A7")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-gradient fs1-5rem tac",
                            children: "Persons with Significant Control"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setControlReadMore({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "c15 group-inputs mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Name:"
                                        }),
                                        "  ",
                                        controlReadMore['name'] ? controlReadMore['name'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Controls:"
                                        }),
                                        controlReadMore['natures_of_control'] && controlReadMore['natures_of_control'].length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: controlReadMore['natures_of_control'].map((control, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: control
                                                    })
                                                }, idx))
                                        }) : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "E-Tag:"
                                        }),
                                        "  ",
                                        controlReadMore['etag'] ? controlReadMore['etag'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Notified Date:"
                                        }),
                                        "  ",
                                        controlReadMore['notified_on'] ? controlReadMore['notified_on'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Address:"
                                        }),
                                        " ",
                                        controlReadMore['address'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                controlReadMore['address']['premises'] && controlReadMore['address']['premises'],
                                                controlReadMore['address']['address_line_1'] && ', ' + controlReadMore['address']['address_line_1'],
                                                controlReadMore['address']['address_line_2'] && ', ' + controlReadMore['address']['address_line_2'],
                                                controlReadMore['address']['locality'] && ' - ' + controlReadMore['address']['locality'],
                                                controlReadMore['address']['region'] && ', ' + controlReadMore['address']['region'],
                                                controlReadMore['address']['country'] && ', ' + controlReadMore['address']['country']
                                            ]
                                        }) : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Nationality:"
                                        }),
                                        "  ",
                                        controlReadMore['nationality'] ? controlReadMore['nationality'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "DOB:"
                                        }),
                                        "  ",
                                        controlReadMore['date_of_birth'] ? controlReadMore['date_of_birth']['month'] + '/' + controlReadMore['date_of_birth']['year'] : '-'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'chargeReadMore',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "avtar-area df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h2rem",
                                src: (parcelRequire("dR1A7")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "text-gradient fs1-5rem tac",
                            children: "Charges"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                                setChargeReadMore({});
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "c15 group-inputs mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Persons Entitled:"
                                        }),
                                        "  ",
                                        chargeReadMore['persons_entitled'] ? chargeReadMore['persons_entitled'][0]['name'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Charge Description:"
                                        }),
                                        "  ",
                                        chargeReadMore['classification'] ? chargeReadMore?.['classification']?.['description'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Status:"
                                        }),
                                        "  ",
                                        chargeReadMore['status'] ? chargeReadMore['status'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "E-Tag:"
                                        }),
                                        "  ",
                                        chargeReadMore['etag'] ? chargeReadMore['etag'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Charge Number:"
                                        }),
                                        "  ",
                                        chargeReadMore['charge_number'] ? chargeReadMore['charge_number'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Delivered On:"
                                        }),
                                        "  ",
                                        chargeReadMore['delivered_on'] ? chargeReadMore['delivered_on'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Satisfied On:"
                                        }),
                                        "  ",
                                        chargeReadMore['satisfied_on'] ? chargeReadMore['satisfied_on'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Short Particulars:"
                                        }),
                                        "  ",
                                        chargeReadMore['particulars'] ? chargeReadMore?.['particulars']?.['description'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Amount secured description:"
                                        }),
                                        "  ",
                                        chargeReadMore['secured_details'] ? chargeReadMore?.['secured_details']?.['description'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Transaction filing type:"
                                        }),
                                        "  ",
                                        chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['filing_type'] : '-'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "mb0-5rem ttc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Transaction filing Delivered On:"
                                        }),
                                        "  ",
                                        chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['delivered_on'] : '-'
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'uploadCvData',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>closeDirectorPopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "c15 fs1-25rem fw600 mt0-5rem",
                            children: "Director CV Info"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "group-inputs mt2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "c14 fs1rem fw500 mb0-5rem",
                                    children: "Upload CV Here"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "fileUpload",
                                    className: "w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "c3 pen fs1rem fw500 df aic tac",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    class: "mr0-5rem",
                                                    width: "23",
                                                    height: "23",
                                                    viewBox: "0 0 23 23",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                            "clip-path": "url(#clip0_2183_912)",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
                                                                    fill: "white"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M11.4914 17.7883C10.4699 17.7883 9.44852 17.7883 8.4273 17.7883C7.02663 17.7883 6.01589 16.7811 6.0087 15.3809C6.00601 14.8922 6.00601 14.4033 6.0087 13.9142C6.0114 13.4102 6.31687 13.0859 6.78406 13.085C7.25124 13.0841 7.56076 13.4062 7.5639 13.9097C7.56704 14.4133 7.5639 14.9052 7.5639 15.4029C7.56749 15.9249 7.87431 16.229 8.3981 16.2295C10.4672 16.2295 12.5362 16.2295 14.605 16.2295C15.1292 16.2295 15.4365 15.9249 15.4405 15.4034C15.4441 14.9056 15.4405 14.4079 15.4405 13.9102C15.4405 13.4124 15.7509 13.0841 16.2199 13.085C16.6889 13.0859 16.9988 13.4102 16.9948 13.9138C16.9899 14.5503 17.0253 15.1936 16.9454 15.8216C16.7989 16.9707 15.8192 17.782 14.6566 17.7874C13.6041 17.7905 12.5475 17.7883 11.4914 17.7883Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M10.726 7.89412C10.6074 8.00463 10.5377 8.06527 10.473 8.13041C9.97531 8.63309 9.48027 9.13891 8.98029 9.63978C8.62541 9.99557 8.13082 10.0216 7.81008 9.71031C7.48934 9.399 7.50192 8.88824 7.85096 8.53695C8.86709 7.51453 9.88652 6.4957 10.9092 5.48047C11.2686 5.12109 11.7385 5.12109 12.0979 5.48047C13.1275 6.50169 14.1529 7.52726 15.1741 8.55717C15.5101 8.89633 15.5119 9.40619 15.1997 9.71076C14.8875 10.0153 14.3911 10.0019 14.0484 9.6618C13.5408 9.15643 13.0408 8.64297 12.5368 8.13445C12.4716 8.06887 12.402 8.00777 12.2982 7.90984C12.2915 8.0509 12.2834 8.14209 12.2834 8.23328C12.2834 9.84104 12.2856 11.4483 12.2834 13.0561C12.2834 13.6594 11.7524 14.0183 11.2003 13.8036C10.8949 13.6846 10.7291 13.4195 10.7291 13.0314C10.7273 11.4412 10.7273 9.85107 10.7291 8.26113L10.726 7.89412Z",
                                                                    fill: "#4A67FF"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                id: "clip0_2183_912",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                    width: "23",
                                                                    height: "23",
                                                                    fill: "white"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                "Upload"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            onChange: (e1)=>setAttachment(e1.target.files[0]),
                                            className: "dn",
                                            id: "fileUpload",
                                            type: "file"
                                        })
                                    ]
                                }),
                                attachment && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic my1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            class: "fa fa-circle c4",
                                            style: {
                                                fontSize: '10px'
                                            },
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            target: "_blank",
                                            href: attachment?.location,
                                            className: "c3 fs0-75rem fw500 tdu",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "px0-5rem",
                                                children: attachment?.name
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcse",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        onClick: ()=>handleSubmitDirector(),
                                        className: "df aic jcc cp bg4 c1 br20px px3rem py0-75rem fw500 mt2rem",
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'deleteFiles',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem fw600 my1rem",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem",
                            children: "Are you sure you want to delete this file?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-25rem fw500 mb1rem",
                            children: attachment && attachment.originalname
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>confirmDeleteFiles(),
                            className: "shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic",
                            children: "Delete File"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            className: "c3-hover td250 fs1-25rem cp",
                            children: "Cancel"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'auditLogs',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 center-horizontally",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO",
                            style: {
                                top: '15px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs1-5rem fw600 tac ttu",
                            children: [
                                company['cName'],
                                " Company Audit Log"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c4 fs0-75rem ttu w100 tac mb1rem",
                            children: "See the history of Company Audit Updated"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ma oya dg gg0-5rem mb2rem w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs1rem ml1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Company Details"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Company Name:"
                                                }),
                                                " ",
                                                company['cName']
                                            ]
                                        }),
                                        company?.['creatorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Company Owner:"
                                                }),
                                                " ",
                                                company['creatorId']['firstName'] + ' ' + company['creatorId']['lastName']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Created At:"
                                                }),
                                                " ",
                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(company['creaedAt']).format('ll')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Payment Source:"
                                                }),
                                                " ",
                                                company['paymentSource']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Stage of development:"
                                                }),
                                                " ",
                                                company['cStage']
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "df fw500 ttc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600 mr0-5rem",
                                                    children: "Company Objectives:"
                                                }),
                                                " ",
                                                company['testType']
                                            ]
                                        })
                                    ]
                                }),
                                auditLogList && auditLogList.length > 0 && auditLogList.map((log)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df my0-5rem",
                                        children: [
                                            (log?.['userId']?.['profile'] || log?.['userId']?.['profilePicture']) && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: `ass ml0-5rem br100 w2rem h2rem client-profile`,
                                                src: log?.['userId']?.['profile'] || log?.['userId']?.['profilePicture'],
                                                "data-tooltip": log?.['userId'].firstName ? log?.['userId'].firstName + " " + log?.['userId'].lastName : "Register to show your name here"
                                            }) || /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: `ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem client-profile`,
                                                children: [
                                                    log?.['userId']?.['firstName']?.[0] || "?",
                                                    log?.['userId']?.['lastName']?.[0] || "?"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "w100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs0-75rem ml1rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: log['message']
                                                            }),
                                                            " at ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: new Date(log.timestamp).toLocaleString()
                                                            }),
                                                            " by ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                                                children: [
                                                                    log?.['userId']['firstName'],
                                                                    " ",
                                                                    log?.['userId']['lastName']
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    log['payload']['update'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 fs1rem",
                                                                children: [
                                                                    "Changes to ",
                                                                    company['cName'],
                                                                    " - Company Details:"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df w100",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "mr0-5rem",
                                                                        children: Object.keys(log['payload']['update']).map((key)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                className: "fw600",
                                                                                children: [
                                                                                    companyKeys[key],
                                                                                    ":"
                                                                                ]
                                                                            });
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        children: Object.values(log['payload']['update']).map((value)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                children: typeof value == 'string' ? value : typeof value == 'boolean' && value ? 'True' : 'False'
                                                                            });
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    log['payload']?.['data']?.['childUpdates'] && log['payload']?.['data']?.['childUpdates'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 fs1rem",
                                                                children: [
                                                                    log['payload']['data']['type'] && log['payload']['data']['type'],
                                                                    " Group Info:"
                                                                ]
                                                            }),
                                                            log['payload']?.['data']?.['childUpdates'].map((data)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        companies && companies.length > 0 && companies.map((company)=>{
                                                                            if (company['_id'] == log['payload']?.['data']?.['parentId']) {
                                                                                if (company['childrenCompanies']) for (let childCompnay of company['childrenCompanies']){
                                                                                    if (childCompnay['_id'] == data['companyId']) return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "fw600",
                                                                                                children: "Company Name:"
                                                                                            }),
                                                                                            " ",
                                                                                            childCompnay['cName']
                                                                                        ]
                                                                                    });
                                                                                }
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: "Group:"
                                                                                }),
                                                                                " ",
                                                                                data['group']
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: "Percentage:"
                                                                                }),
                                                                                " ",
                                                                                data['percentage'],
                                                                                "%"
                                                                            ]
                                                                        })
                                                                    ]
                                                                });
                                                            })
                                                        ]
                                                    }),
                                                    log['payload']['directorId'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500 fs1rem",
                                                                children: [
                                                                    "Changes to ",
                                                                    log['payload']['directorId']['name'],
                                                                    " - Director's Information:"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "CV:"
                                                                    }),
                                                                    log['files'].length > 0 && log['files'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                            className: "fw400 mr0-5rem fs0-75rem tdu",
                                                                            target: "_blank",
                                                                            href: file?.location,
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                children: file?.originalname
                                                                            })
                                                                        }))
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "df fw500",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fw600 mr0-5rem",
                                                                        children: "LinkedIn:"
                                                                    }),
                                                                    log['payload']['linkedIn'] && log['payload']['linkedIn'] !== 'undefined' ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                        className: "fw400 mr0-5rem fs0-75rem tdu",
                                                                        target: "_blank",
                                                                        href: log['payload']['linkedIn'],
                                                                        children: log['payload']['linkedIn']
                                                                    }) : '-'
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: isImageModal,
                onClose: ()=>setIsImageModal(false),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `top-header py1rem px2rem df jcsb aic ${user['role'] == 'Advisor' ? 'advisor-bg' : 'investor-bg'}`,
                            style: {
                                borderRadius: '8px 8px 0 0'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "fs1-5rem c15 fw500 ttc",
                                    children: "Upload Profile Picture"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w60px",
                                    src: (parcelRequire("4vGhj")),
                                    alt: "TODO"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc p3rem",
                            children: [
                                currentImage == '' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    for: "profile",
                                    className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "pen fs1rem fw500 tac",
                                            children: "Upload picture"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "input-btn pa t0 w100 op0 l0 cp",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                className: "w100 l0 h5rem cp",
                                                onChange: (e1)=>handleImage(e1),
                                                id: "currentImage",
                                                type: "file",
                                                accept: "image/jpeg, image/jpg, image/png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                            children: "Max file size 5MB"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pr",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                        ref: $a5d74d48e8d56916$var$cropper,
                                        guides: false,
                                        aspectRatio: 1,
                                        className: "cropper-settings",
                                        src: currentImage
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcse",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>setIsImageModal(false),
                                            className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>uploadImage(),
                                            className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                            children: Object.keys(currentImage).length == 0 ? 'Upload' : 'Crop & Upload'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'howItWorks',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100 pt4rem pb0-5rem px2rem bsbb df fdc maw900px pr br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fw600 pb0-5rem",
                            children: "How does it work?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my0-5rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "how-it-works taj",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Qualify unsolicited approaches to your Web site for funding"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Add FREE Diligentsia widget to your website In minutes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Fully automated - saves your staff time on qualification of poor fit approaches"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Reserves human interaction for high value target company interactions - still very important"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Automated reporting - completeness, fit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Sits within a complete set of automated modules to improve investment success Rates"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Valuable report for the enquiring Company - its approach not wasted even if unsuccessful - generates goodwill for your firm"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Receive qualified leads that appear to meet your investment criteria"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "You create FREE questionnaire in  minutes and Attach to your web site"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "You can add/edit sections and questions to Bespoke it to your firm's requirements"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Companies approaching your firm for funding Via your web site are directed to complete the questionnaire"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Automated emails can be generated - Interested/thank you but not a close enough fit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        className: "mb0-5rem",
                                        children: "Process workflow management from your Investor dashboard"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "mb0-5rem",
                                        children: [
                                            "If you wish to progress, other modules can Be added to that company's account eg:",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                style: {
                                                    listStyleType: "initial"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Detailed Due Diligence Questionnaire"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Warranty Disclosures"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Directors' Questionnaires"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Data Repository"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        children: "Business Audit"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'companyDelete',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "company-name fs1-25rem",
                            children: company['cName']
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h2rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600",
                                children: "Delete Company"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "To delete the Advisor Company you need to book a call"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                href: "https://koalendar.com/e/meet-with-mark-bernstein",
                                target: "_blank",
                                className: "w9rem shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 cp ttu bsbb tac fs0-75rem mb0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            className: "w1rem f1 pr mr0-5rem tp5px",
                                            version: "1.1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 202.592 202.592",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M198.048,160.105l-31.286-31.29c-6.231-6.206-16.552-6.016-23.001,0.433l-15.761,15.761                 c-0.995-0.551-2.026-1.124-3.11-1.732c-9.953-5.515-23.577-13.074-37.914-27.421C72.599,101.48,65.03,87.834,59.5,77.874                 c-0.587-1.056-1.145-2.072-1.696-3.038l10.579-10.565l5.2-5.207c6.46-6.46,6.639-16.778,0.419-23.001L42.715,4.769                 c-6.216-6.216-16.541-6.027-23.001,0.433l-8.818,8.868l0.243,0.24c-2.956,3.772-5.429,8.124-7.265,12.816                 c-1.696,4.466-2.752,8.729-3.235,12.998c-4.13,34.25,11.52,65.55,53.994,108.028c58.711,58.707,106.027,54.273,108.067,54.055                 c4.449-0.53,8.707-1.593,13.038-3.275c4.652-1.818,9.001-4.284,12.769-7.233l0.193,0.168l8.933-8.747                 C204.079,176.661,204.265,166.343,198.048,160.105z M190.683,176.164l-3.937,3.93l-1.568,1.507                 c-2.469,2.387-6.743,5.74-12.984,8.181c-3.543,1.364-7.036,2.24-10.59,2.663c-0.447,0.043-44.95,3.84-100.029-51.235                 C14.743,94.38,7.238,67.395,10.384,41.259c0.394-3.464,1.263-6.95,2.652-10.593c2.462-6.277,5.812-10.547,8.181-13.02l5.443-5.497                 c2.623-2.63,6.714-2.831,9.112-0.433l31.286,31.286c2.394,2.401,2.205,6.492-0.422,9.13L45.507,73.24l1.95,3.282                 c1.084,1.829,2.23,3.879,3.454,6.106c5.812,10.482,13.764,24.83,29.121,40.173c15.317,15.325,29.644,23.27,40.094,29.067                 c2.258,1.249,4.32,2.398,6.17,3.5l3.289,1.95l21.115-21.122c2.634-2.623,6.739-2.817,9.137-0.426l31.272,31.279                 C193.5,169.446,193.31,173.537,190.683,176.164z"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    "Book a call"
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "howItWorksModal",
                open: modal['open'] == 'howItWorksModal',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg20 shadow w100 px4rem py2rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        zoom: '0.9',
                        maxWidth: '1350px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fww w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "w100 tac c15 fs1-75rem fw500 mt1rem",
                                    children: "Simple onboarding ramp"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                    className: "w100 tac c3 fs1-25rem fw500 mb2rem",
                                    children: "Show value in minutes WITHOUT using client data"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "step-top-box df w100 jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("aCagb")),
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "step-box-images df jcsb mt1rem mb2rem mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "step-img df jcc px1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "",
                                                src: (parcelRequire("gB01D")),
                                                alt: "step image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "step-img df jcc px1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "",
                                                src: (parcelRequire("MEFCn")),
                                                alt: "step image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "step-img df jcc px1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "",
                                                src: (parcelRequire("1XVow")),
                                                alt: "step image"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "checklist-area aic df bg1 py0-5rem w90 mla mra br45px mb1rem jcsb bsbb",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "checklist-inner w100 df jcc",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c15 fs1rem fsi fw500",
                                            children: "Start free. Prove fast. Upgrade only when your client clearly sees the impact."
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
















function $da1b2edfeb15e6cc$export$2e2bcd8739ae039() {
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "expansionpack-page py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Function Expansion Pack \u2013 DD",
                            subheading: "Referencing Module\u200B"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ma lef-img-area",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("l1H8g")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "ma w100 right-text-area",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Any company needing to demonstrate that they  are well-prepared for third party referencing in due diligence on their customers, suppliers, partners and shareholders on investment or exit.\u200B \u200B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "number-sec",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                            className: "bg5 br5px shadow",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Sections: "
                                                        }),
                                                        " 4"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Number of Questions: "
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "AI Generated Company Specific Questions included? "
                                                        }),
                                                        " Yes/No"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                            className: "icon",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "h10rem",
                                                                    src: (parcelRequire("lApJY")),
                                                                    alt: ""
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: "Benefit: "
                                                        }),
                                                        " This module automates the process of obtaining third party references from your top (up to 5) customers, suppliers, partners and shareholders, by sending them a quick questionnaire to fill in in relation to their dealings with your business.  This enables you to identify blocking issues early, and once completed you can show at the start of the diligence process to demonstrate your company\u2019s good standing amongst its stakeholders."
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "about-img",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "text-box bg5 br5px shadow",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "\u201CGetting references part way through an investment/sale process is stressful and time-consuming.  Getting ahead of any issues/reluctance saved  us time during our transaction.\u201D  Steven Brough,, CEO\u200B"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "boost-sec bg-gradient c1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container py5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "dg gg2rem gtcr3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h10rem",
                                        src: (parcelRequire("5g3Sv")),
                                        alt: ""
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb py4rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    className: "fds c1 fs2rem tac",
                                    children: [
                                        "Boost your Diligentsia",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c3 fds ",
                                            children: "certification score\u2026\u200B"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h100 df fdc jcsb aic py4rem",
                                children: loggedIn ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/billing/64a5c8a5605162e8bf9ce86a",
                                    style: {
                                        padding: '15px',
                                        position: 'relative'
                                    },
                                    className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                    children: [
                                        "One off purchase \u2013 BUY NOW!",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tooltip-btn",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\xa3 500"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>showMessage("LogIn to - BUY NOW!"),
                                    style: {
                                        padding: '15px',
                                        position: 'relative'
                                    },
                                    className: "br5px shadow cp c1 px1rem my0-5rem fw600 m1rem bg4 bg3-hover td250",
                                    children: [
                                        "One off purchase \u2013 BUY NOW!",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "tooltip-btn",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "\xa3 500"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "benfits-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0c77e93f5c0874$export$2e2bcd8739ae039), {
                            wrapperClass: "mb2rem tac",
                            heading: "Benefits"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr3",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("5k6Ll")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Enhanced credibility and trust:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Providing a pre-collected set of business references from key stakeholders can demonstrate the company's strong relationships and proven track record. This helps build credibility and trust with potential investors, increasing the likelihood of securing investment.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("82L9j")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Faster due diligence process:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "By proactively gathering and presenting business references, the company can streamline the due diligence process for potential investors. This saves time for both parties and allows for more efficient investment discussions and decision-making.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("8F1Ms")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Showcasing success stories:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Business references can highlight the company's successful collaborations, projects, and partnerships, showcasing the company's ability to deliver results and work effectively with diverse stakeholders. This can make the company more attractive to investors seeking growth opportunities.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("jTIek")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Positive word-of-mouth marketing:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "References from satisfied customers, suppliers, partners, and shareholders can serve as a powerful form of word-of-mouth marketing, potentially attracting additional investors and business opportunities. These positive testimonials can help reinforce the company's reputation and expand its network."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("cRc7X")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Demonstrating adaptability and resilience:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "Business references can provide insight into how the company has navigated challenges and adapted to changing market conditions. This information can be valuable to potential investors, who may be more inclined to invest in a company that has proven its ability to overcome obstacles and adapt to change.\u200B"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc jcsb aic bg5 br5px shadow p2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "img-box mb2rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h8rem",
                                                src: (parcelRequire("4YzyZ")),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        children: "Strengthened negotiation position:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: "By presenting a strong set of business references, the company can bolster its negotiating position during investment discussions. This can lead to more favorable investment terms, valuation, and potential partnerships, as investors will have greater confidence in the company's ability to deliver on its promises and drive growth."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "modal-sec py4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container df fdc",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "heading",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "h5rem",
                                src: (parcelRequire("eHMrP")),
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "dg gg2rem gtcr2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Share Capital and Authority"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Business Plan"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Management Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Properties"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Assets,Debt & Stock"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Employment and Consultancy Arrangements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Records & Registers"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Group Structure"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Borrowings & Facilities"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df tac  fdc",
                                    style: {
                                        padding: '0 25px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Information"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Accounts"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Events Since The Accounts Date"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Litigation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Intellectual Property"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Contracts with Connected Persons"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Statutory & Legal Requirements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Insurance"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Agreements & Captial Commitments"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "w100 jcsb bg5 br5px shadow px1rem py0-5rem py0-5rem mb0-5rem",
                                            children: "Social Obligations"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $b308604577d1df27$var$PricingPersonaHero = ({ eyebrow: eyebrow, dotColor: dotColor, title: title, subtitle: subtitle, primaryCta: primaryCta, secondaryCta: secondaryCta })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-pricing-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-pricing-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-eyebrow-pill",
                        "data-lp-reveal": true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    background: dotColor
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: dotColor
                                },
                                children: eyebrow
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "lp-h1",
                        style: {
                            margin: '0 0 16px'
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "lp-lead",
                        style: {
                            maxWidth: '640px',
                            margin: '0 auto 30px'
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": "120",
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-cta-row",
                        style: {
                            justifyContent: 'center'
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": "180",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "lp-btn lp-btn--primary",
                                style: {
                                    borderRadius: '50px'
                                },
                                href: primaryCta.href,
                                children: primaryCta.text
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "lp-btn lp-btn--pe-outline",
                                style: {
                                    borderRadius: '50px'
                                },
                                href: secondaryCta.href,
                                children: secondaryCta.text
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $b308604577d1df27$export$2e2bcd8739ae039 = $b308604577d1df27$var$PricingPersonaHero;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




const $e19c9e89f12fb1b2$var$JOURNEY_TABS = [
    {
        key: 'investment',
        label: 'Investment',
        img: (parcelRequire("f44BT"))
    },
    {
        key: 'growth',
        label: 'Growth',
        img: (parcelRequire("eRrFC"))
    },
    {
        key: 'exit',
        label: 'Exit',
        img: (parcelRequire("kzdFc"))
    }
];
const $e19c9e89f12fb1b2$var$VALID_KEYS = $e19c9e89f12fb1b2$var$JOURNEY_TABS.map((t)=>t.key);

// `active`/`onChange` are optional — when supplied the parent owns the state, so the closing CTA
// can change its wording with the selected stage. Falls back to local state when used standalone.
const $e19c9e89f12fb1b2$var$PricingJourneySection = ({ active: activeProp, onChange: onChange })=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [activeLocal, setActiveLocal] = (0, $acw62.useState)('investment');
    const active = activeProp ?? activeLocal;
    const setActive = (key)=>{
        setActiveLocal(key);
        if (onChange) onChange(key);
    };
    // Pre-select the journey stage from the ?journey= param (set by the Companies "See what's included" CTA).
    (0, $acw62.useEffect)(()=>{
        const key = new URLSearchParams(location.search).get('journey');
        if (key && $e19c9e89f12fb1b2$var$VALID_KEYS.includes(key)) setActive(key);
    }, [
        location.search
    ]);
    const current = $e19c9e89f12fb1b2$var$JOURNEY_TABS.find((t)=>t.key === active);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "whats-included",
        className: "lp-journey-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-container",
                style: {
                    textAlign: 'center',
                    paddingBottom: 8
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "lp-h2",
                        style: {
                            margin: '0 auto 14px',
                            maxWidth: 'none'
                        },
                        "data-lp-reveal": true,
                        children: [
                            "Your journey to investment, ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: '#6366f1'
                                },
                                children: "step by step"
                            }),
                            " \u2014 in as little as 3 days"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "lp-sub",
                        style: {
                            margin: '0 auto'
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": "80",
                        children: "Every tier builds on the last. Here's exactly what you unlock at each stage."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-journey-tabs-wrap",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-journey-tabs",
                    children: $e19c9e89f12fb1b2$var$JOURNEY_TABS.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `lp-journey-tab ${active === t.key ? 'is-active' : ''}`,
                            onClick: ()=>setActive(t.key),
                            children: t.label
                        }, t.key))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-container",
                style: {
                    paddingBottom: 40
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-journey-img",
                    "data-lp-reveal": true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: current.img,
                        alt: `${current.label} \u{2014} what you get`
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-pricing-banner",
                    "data-lp-reveal": true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "eyebrow",
                                        children: "Pro & Portfolio Pro \u2014 Continuous Monitoring"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Now continue to 'always on' \u2014 ready for your next round or exit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: "Your Diligence Pack doesn't go in a drawer. Diligentsia monitors your KPIs, flags what needs updating and keeps your certification current \u2014 so when your next investor conversation starts, you're already prepared. Raise faster, exit cleaner."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w130px",
                                src: (parcelRequire("6U4As")),
                                alt: "Diligentsia"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $e19c9e89f12fb1b2$export$2e2bcd8739ae039 = $e19c9e89f12fb1b2$var$PricingJourneySection;


const $f1592fc9ecfe05b9$var$CARDS = [
    {
        label: 'Free',
        amount: "\xa30",
        sub: 'free',
        text: 'Get oriented and see what transaction ready looks like.',
        cta: {
            text: 'Get started free',
            href: $16250bd714b02a14$export$51e82cdd7353a0e1
        },
        variant: ''
    },
    {
        label: 'Lite',
        amount: "\xa38.25",
        sub: "/ mo \xb7 \xa399/yr*",
        sub2: '*billed annually',
        text: 'Build your data foundation and start your pre-seed raise.',
        cta: {
            text: 'Get started',
            href: $16250bd714b02a14$export$51e82cdd7353a0e1
        },
        variant: 'lp-price--lite'
    },
    {
        label: 'Pro',
        amount: "\xa383.25",
        sub: "/ mo \xb7 \xa3999/yr*",
        sub2: '*billed annually',
        text: 'Everything you need to pass Pre-Seed / Seed / Series A due diligence.',
        cta: {
            text: 'Get Pro',
            href: $16250bd714b02a14$export$51e82cdd7353a0e1
        },
        variant: 'lp-price--pro',
        badge: 'Most Popular'
    },
    {
        label: 'Portfolio Pro',
        amount: "\xa366.67",
        sub: "/ mo \xb7 \xa3800/yr* via advisor",
        sub2: '*billed annually',
        text: 'All Pro features at a 20% discount, introduced by your advisor.',
        cta: {
            text: 'Learn more',
            href: '#whats-included'
        },
        variant: 'lp-price--dark',
        badge: '20% off Pro',
        badgeColor: '#1F8A5B'
    }
];
// Closing CTA copy per journey stage — the investor framing only fits the Investment tab.
const $f1592fc9ecfe05b9$var$CTA_COPY = {
    investment: {
        lead: 'You pitch for Investment',
        rest: " \u2014 qualified, diligence-backed, more attractive to every investor."
    },
    growth: {
        lead: 'Turbo Boost Your Business',
        rest: ' and Accelerate Growth & Value'
    },
    exit: {
        lead: 'You pitch for Seller',
        rest: " \u2014 qualified, diligence-backed, more attractive to every buyer."
    }
};
const $f1592fc9ecfe05b9$var$PricingCompaniesPanel = ()=>{
    const [journey, setJourney] = (0, $acw62.useState)('investment');
    const cta = $f1592fc9ecfe05b9$var$CTA_COPY[journey] || $f1592fc9ecfe05b9$var$CTA_COPY.investment;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "tabpanel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b308604577d1df27$export$2e2bcd8739ae039), {
                eyebrow: "Pricing",
                dotColor: "#FC7785",
                title: "Simple plans. Built for every stage.",
                subtitle: "Start free. Upgrade when you're ready to grow, raise or exit.",
                primaryCta: {
                    text: 'Try for free',
                    href: $16250bd714b02a14$export$51e82cdd7353a0e1
                },
                secondaryCta: {
                    text: "See what you get \u2193",
                    href: '#whats-included'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                className: "lp-pricing-sec",
                style: {
                    paddingTop: 0,
                    background: 'transparent'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-pricing-grid lp-pricing-grid--4",
                        children: $f1592fc9ecfe05b9$var$CARDS.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `lp-price ${c.variant}`,
                                "data-lp-reveal": true,
                                "data-lp-delay": i * 70,
                                children: [
                                    c.badge && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-price-badge lp-price-badge--center",
                                        style: c.badgeColor ? {
                                            background: c.badgeColor
                                        } : undefined,
                                        children: c.badge
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lbl",
                                        style: {
                                            color: c.label == 'Pro' || c.label == 'Portfolio Pro' ? '#fff' : '#5b6472'
                                        },
                                        children: c.label
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `amt ${c.variant === 'lp-price--lite' ? 'blue' : c.variant === 'lp-price--dark' || c.variant === 'lp-price--pro' ? 'white' : ''}`,
                                        children: c.amount
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "sub",
                                        style: {
                                            marginBottom: '5px'
                                        },
                                        children: c.sub
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "sub",
                                        children: c.sub2
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: {
                                            flex: 1
                                        },
                                        children: c.text
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: `lp-price-btn ${c.variant === 'lp-price--pro' ? 'lp-price-btn--white' : c.variant === 'lp-price--dark' ? 'lp-price-btn--outline' : 'lp-price-btn--dark'}`,
                                        href: c.cta.href,
                                        children: c.cta.text
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-pricing-nudge",
                        "data-lp-reveal": true,
                        "data-lp-delay": "80",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "emoji",
                                children: "\uD83E\uDDED"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ttl",
                                        children: "Need expert guidance?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "txt",
                                        children: " We'll match you with an advisor who specialises in your sector \u2014 and they'll unlock Portfolio Pro for you too. "
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: "#whats-included",
                                        children: "AdvisorMatch call \u2192"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e19c9e89f12fb1b2$export$2e2bcd8739ae039), {
                active: journey,
                onChange: setJourney
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "lp-cta",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-card lp-cta-card--emoji",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "emoji",
                            children: "\uD83E\uDD1D"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-cta-inner",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                    style: {
                                        fontSize: 'clamp(20px,2.8vw,28px)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: cta.lead
                                        }),
                                        cta.rest
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    className: "lp-cta-btn",
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Try for FREE"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "note",
                                            children: "no credit card required"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $f1592fc9ecfe05b9$export$2e2bcd8739ae039 = $f1592fc9ecfe05b9$var$PricingCompaniesPanel;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $9306b4e86b1c9318$var$PricingTwoCardGrid = ({ free: free, paid: paid })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pricing-sec",
        style: {
            paddingTop: 0,
            paddingBottom: 60,
            background: 'transparent'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pricing-two-grid",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-price",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lbl",
                            children: free.label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "amt",
                            children: free.amount
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sub",
                            children: free.sub
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                marginBottom: '20px',
                                flex: 1
                            },
                            children: free.text
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "w100 lp-price-btn lp-price-btn--dark",
                            href: free.cta.href,
                            children: free.cta.text
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-price lp-price--pro",
                    "data-lp-reveal": true,
                    "data-lp-delay": "100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-price-badge lp-price-badge--top-center",
                            children: paid.badge
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lbl",
                            style: {
                                color: '#fff'
                            },
                            children: paid.label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "amt white",
                            children: paid.amount
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "sub",
                            children: paid.sub
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            style: {
                                flex: 1
                            },
                            children: paid.text
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "w100 lp-price-btn lp-price-btn--white",
                            href: paid.cta.href,
                            children: paid.cta.text
                        })
                    ]
                })
            ]
        })
    });
var $9306b4e86b1c9318$export$2e2bcd8739ae039 = $9306b4e86b1c9318$var$PricingTwoCardGrid;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $116ae14061740245$var$PricingFeatureTable = ({ freeColLabel: freeColLabel, paidColLabel: paidColLabel, freeSummary: freeSummary, rows: rows, footnote: footnote })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pricing-sec",
        style: {
            paddingTop: 0,
            background: 'transparent'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-container",
            style: {
                maxWidth: 1100
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-h2",
                    style: {
                        textAlign: 'center',
                        margin: '0 auto 36px',
                        maxWidth: 'none'
                    },
                    "data-lp-reveal": true,
                    children: "What's included"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-feature-table",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-ft-head lp-ft-head--feature",
                            children: "Feature"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-ft-head lp-ft-head--free",
                            children: freeColLabel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-ft-head lp-ft-head--paid",
                            children: paidColLabel
                        }),
                        rows.map((row, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-ft-cell lp-ft-cell--feature",
                                        children: row.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-ft-cell",
                                        children: row.freeItems ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            children: row.freeItems.map((t, j)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        "\u2713 ",
                                                        t
                                                    ]
                                                }, j))
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "lp-ft-dash",
                                            children: "\u2014"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-ft-cell",
                                        children: row.paidItems ? /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            children: row.paidItems.map((t, j)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        "\u2713 ",
                                                        t
                                                    ]
                                                }, j))
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: freeSummary
                                        })
                                    })
                                ]
                            }, i))
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-price-note",
                    children: footnote
                })
            ]
        })
    });
var $116ae14061740245$export$2e2bcd8739ae039 = $116ae14061740245$var$PricingFeatureTable;


const $f532e7dfaf5ad433$var$ROWS = [
    {
        title: "\uD83D\uDCCA Your Dashboard",
        freeItems: [
            'Portfolio dashboard',
            'Workflow Manager',
            'AnyList Checklist Builder',
            'Client Benchmarking',
            'Unaudited Certification support',
            'Connect clients to investor database',
            'Promotion to new clients',
            'Chargeable quarterly reviews',
            'Agentic & phone support'
        ]
    },
    {
        title: "\uD83D\uDE80 Client \u2014 Investment",
        paidItems: [
            'All Company Pro tools',
            'Foundational & Value Diligence Packs',
            'AnyList & ResearchAid builders',
            'InvestorMatch 1-click intros (Gold cert)'
        ]
    },
    {
        title: "\uD83D\uDCC8 Client \u2014 Growth",
        paidItems: [
            'Growth Readiness Checklist',
            "20\xd7 Healthboost Modules",
            'AppStore modules'
        ]
    },
    {
        title: "\uD83C\uDFC1 Client \u2014 Exit",
        paidItems: [
            'Exit Readiness Checklist',
            'Foundational & Value Diligence Packs',
            'CF / Businesses For Sale introductions'
        ]
    }
];
const $f532e7dfaf5ad433$var$PricingAdvisorsPanel = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "tabpanel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b308604577d1df27$export$2e2bcd8739ae039), {
                eyebrow: "For Advisors",
                dotColor: "#E8820C",
                title: "Free for you. Powerful for your clients.",
                subtitle: "Your advisor account is always free. Add client companies at a 20% discount on Pro.",
                primaryCta: {
                    text: 'Create advisor account',
                    href: $16250bd714b02a14$export$51e82cdd7353a0e1
                },
                secondaryCta: {
                    text: "Learn more \u2193",
                    href: '#advisors-included'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9306b4e86b1c9318$export$2e2bcd8739ae039), {
                free: {
                    label: "Free \u2014 Your Advisor Account",
                    amount: "\xa30",
                    sub: 'free always',
                    text: 'Your full dashboard and portfolio management tools.',
                    cta: {
                        text: 'Get started free',
                        href: $16250bd714b02a14$export$51e82cdd7353a0e1
                    }
                },
                paid: {
                    label: 'Portfolio Pro',
                    amount: "\xa366.67",
                    sub: "/ mo \xb7 \xa3800/yr \xb7 code ADVISOR20",
                    text: 'Give every client the full Pro toolkit across Investment, Growth & Exit.',
                    badge: 'Per client company',
                    cta: {
                        text: 'Add a client',
                        href: $16250bd714b02a14$export$51e82cdd7353a0e1
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "advisors-included",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $116ae14061740245$export$2e2bcd8739ae039), {
                    freeColLabel: "Free \u2014 you",
                    paidColLabel: "Portfolio Pro / client",
                    freeSummary: "All free tools + full Company Pro per client",
                    rows: $f532e7dfaf5ad433$var$ROWS,
                    footnote: "* Portfolio Pro (\xa3800/yr per client) via your dashboard. Code ADVISOR20 at checkout."
                })
            })
        ]
    });
var $f532e7dfaf5ad433$export$2e2bcd8739ae039 = $f532e7dfaf5ad433$var$PricingAdvisorsPanel;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $9ad3fa5d20ca7d38$var$ROWS = [
    {
        title: "\uD83D\uDD0D Free Triaging",
        freeItems: [
            'Portfolio dashboard',
            'InvestorMatch application',
            'Fit Report vs criteria',
            'Investment Readiness Report',
            'Workflow Manager',
            'Research Reports (5 types)',
            'Data Repository & Business Audit access',
            'AnyList & ResearchAid further diligence',
            'Match rejected applicants with other investors',
            'Agentic & phone support'
        ]
    },
    {
        title: "\uD83D\uDCC8 Portfolio \u2014 Growth",
        paidItems: [
            'Growth Readiness Checklist',
            '100-Day Value Growth Plan',
            "20\xd7 Healthboost Modules",
            'Shared data repository',
            'Quarterly portfolio reviews',
            'Portfolio Benchmarking'
        ]
    },
    {
        title: "\uD83C\uDFC1 Portfolio \u2014 Exit",
        paidItems: [
            'Exit Readiness Checklist',
            'Foundational & Value Diligence Packs',
            'AnyList & ResearchAid builders',
            "Draft Warranty Disclosures & Directors' Questionnaires"
        ]
    }
];
const $9ad3fa5d20ca7d38$var$PricingInvestorsPanel = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        role: "tabpanel",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b308604577d1df27$export$2e2bcd8739ae039), {
                eyebrow: "For Investors",
                dotColor: "#1F8A5B",
                title: "Free to triage. Powerful for your portfolio.",
                subtitle: "Your investor account is always free. Onboard portfolio companies at 20% off Pro.",
                primaryCta: {
                    text: 'Create investor account',
                    href: $16250bd714b02a14$export$51e82cdd7353a0e1
                },
                secondaryCta: {
                    text: "Learn more \u2193",
                    href: '#investors-included'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9306b4e86b1c9318$export$2e2bcd8739ae039), {
                free: {
                    label: "Free \u2014 Your Investor Account",
                    amount: "\xa30",
                    sub: 'free always',
                    text: "Full applicant triaging, diligence reports & portfolio dashboard \u2014 at zero cost.",
                    cta: {
                        text: 'Get started free',
                        href: $16250bd714b02a14$export$51e82cdd7353a0e1
                    }
                },
                paid: {
                    label: 'Portfolio Pro',
                    amount: "\xa366.67",
                    sub: "/ mo \xb7 \xa3800/yr \xb7 code INVESTOR20",
                    text: 'Onboard a portfolio company to the full Pro toolkit.',
                    badge: 'Per portfolio company',
                    cta: {
                        text: 'Add a company',
                        href: $16250bd714b02a14$export$51e82cdd7353a0e1
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "investors-included",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $116ae14061740245$export$2e2bcd8739ae039), {
                    freeColLabel: "Free \u2014 you",
                    paidColLabel: "Portfolio Pro / company",
                    freeSummary: "All free tools + full Company Pro per investee",
                    rows: $9ad3fa5d20ca7d38$var$ROWS,
                    footnote: "* Portfolio Pro (\xa3800/yr per company) via your investor dashboard. Code INVESTOR20 at checkout."
                })
            })
        ]
    });
var $9ad3fa5d20ca7d38$export$2e2bcd8739ae039 = $9ad3fa5d20ca7d38$var$PricingInvestorsPanel;


const $9f89aac6a38bd88f$var$PERSONAS = [
    {
        key: 'companies',
        label: 'Companies'
    },
    {
        key: 'advisors',
        label: 'Advisors'
    },
    {
        key: 'investors',
        label: 'Investors'
    }
];
const $9f89aac6a38bd88f$var$PricingTabsSection = ()=>{
    const [persona, setPersona] = (0, $acw62.useState)('companies');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-pricing-tabbar",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-pricing-tabbar-inner",
                    role: "tablist",
                    children: $9f89aac6a38bd88f$var$PERSONAS.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `lp-pricing-tab ${persona === p.key ? 'is-active' : ''}`,
                            role: "tab",
                            "aria-selected": persona === p.key,
                            onClick: ()=>setPersona(p.key),
                            children: p.label
                        }, p.key))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: persona === 'companies' ? 'block' : 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f1592fc9ecfe05b9$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: persona === 'advisors' ? 'block' : 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f532e7dfaf5ad433$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: persona === 'investors' ? 'block' : 'none'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad3fa5d20ca7d38$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $9f89aac6a38bd88f$export$2e2bcd8739ae039 = $9f89aac6a38bd88f$var$PricingTabsSection;



const $f99123378f0e24b0$var$PricingPlans = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    // Scroll to a hash target (e.g. #whats-included from the Companies "See what's included" CTA).
    // The section renders after tabs/images settle, so poll briefly until it exists.
    (0, $acw62.useEffect)(()=>{
        const id = location.hash?.replace('#', '');
        if (!id) return;
        let tries = 0;
        const timer = setInterval(()=>{
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                clearInterval(timer);
            } else if (++tries > 40) clearInterval(timer); // give up after ~4s
        }, 100);
        return ()=>clearInterval(timer);
    }, [
        location.hash
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-page",
        ref: rootRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9f89aac6a38bd88f$export$2e2bcd8739ae039), {})
    });
};
var $f99123378f0e24b0$export$2e2bcd8739ae039 = $f99123378f0e24b0$var$PricingPlans;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $c580680d7ae6c419$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
// The three-step deal journey shown in the dark card. Steps 1–2 are the Diligentsia + Morsebridge
// partnership; step 3 is the firm running it themselves — hence the distinct marker colours.
const $c580680d7ae6c419$var$STEPS = [
    {
        n: '1',
        tone: 'blue',
        title: 'Qualified dealflow',
        body: 'Pre-diligenced opportunities matched to your thesis'
    },
    {
        n: '2',
        tone: 'pink',
        title: 'Transaction prep & diligence',
        body: 'Target companies made investment-ready, fast'
    },
    {
        n: '3',
        tone: 'green',
        title: 'Platform & monitoring',
        body: "Your firm's deal stack, running in-house"
    }
];
const $c580680d7ae6c419$var$PEHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-hero",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pe-hero-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "lp-pe-eyebrow",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "dot"
                                }),
                                "For Private Equity"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "lp-pe-h1",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: [
                                "Increase portfolio value.",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Simply."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-pe-lede",
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Structured research and deal identification process. Qualify leads faster, cut initial diligence cost, and grow portfolio company value."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "lp-pe-btn lp-pe-btn--primary",
                            href: $c580680d7ae6c419$var$KOALENDAR,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "data-lp-reveal": true,
                            "data-lp-delay": "180",
                            children: "Book a call"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-pe-journey",
                    "data-lp-reveal": true,
                    "data-lp-delay": "140",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-pe-journey-glow",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-pe-journey-label",
                            children: "The PE deal journey"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-pe-journey-steps",
                            children: $c580680d7ae6c419$var$STEPS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-pe-journey-step",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `lp-pe-journey-num is-${s.tone}`,
                                                    children: s.n
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "t",
                                                            children: s.title
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "d",
                                                            children: s.body
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        i < $c580680d7ae6c419$var$STEPS.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-pe-journey-rule"
                                        })
                                    ]
                                }, s.n))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-pe-journey-foot",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Steps 1 & 2 delivered by Diligentsia"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mb",
                                    children: "+ Morsebridge"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $c580680d7ae6c419$export$2e2bcd8739ae039 = $c580680d7ae6c419$var$PEHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $ae9ccaeac9e778ad$var$PEPartnershipStrip = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-strip",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pe-strip-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-pe-strip-brand",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("ayKVW")),
                            alt: "Morsebridge"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "MORSEBRIDGE"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "Diligentsia leads on dealflow, diligence and portfolio value. Diligentsia's platform layer for private equity firms is delivered in partnership with Morsebridge, the agent layer for PE deal teams."
                })
            ]
        })
    });
var $ae9ccaeac9e778ad$export$2e2bcd8739ae039 = $ae9ccaeac9e778ad$var$PEPartnershipStrip;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Single centred statement framing why PE differs from VC — sets up Combined Services below.
const $15a64e4a1d4f248c$var$PEThesisStatement = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-thesis",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-pe-wrap",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                "data-lp-reveal": true,
                children: [
                    "VCs get flooded with inbound and have to sift through it. ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "PE houses work the other way round"
                    }),
                    " \u2014 they set a thesis, then go hunting for the best-fit opportunities. Fewer deals, bigger cheques, and budget that finally makes external diligence worthwhile."
                ]
            })
        })
    });
var $15a64e4a1d4f248c$export$2e2bcd8739ae039 = $15a64e4a1d4f248c$var$PEThesisStatement;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Six Morsebridge services then three Diligentsia ones — the brand label on each card is what
// tells the reader which side of the partnership delivers it.
const $832a6266e5d9d8ea$var$SERVICES = [
    {
        brand: 'mb',
        title: 'Deal sourcing',
        body: 'Proprietary origination and target identification, verified across multiple sources.'
    },
    {
        brand: 'mb',
        title: 'CIM and SIM screening',
        body: 'Fast first-view screening of inbound opportunities with a clear go or pass read.'
    },
    {
        brand: 'mb',
        title: 'Commercial due diligence',
        body: 'Market, customer and competitive assessment to test the investment thesis.'
    },
    {
        brand: 'mb',
        title: 'Financial due diligence and QoE',
        body: 'Quality of earnings, addback validation and an adjusted EBITDA you can defend.'
    },
    {
        brand: 'mb',
        title: 'Management due diligence',
        body: 'Owner dependence, team capability and key-person risk assessment.'
    },
    {
        brand: 'mb',
        title: 'IC memo preparation',
        body: 'Decision-ready investment committee memos built from the diligence record.'
    },
    {
        brand: 'dg',
        title: 'Investment readiness and diligence packs',
        body: 'Diligence-pack creation and reverse vendor diligence, financial and technical.'
    },
    {
        brand: 'dg',
        title: 'Portfolio monitoring',
        body: 'Post-investment reporting roll-ups and performance monitoring across the portfolio.'
    },
    {
        brand: 'dg',
        title: 'Exit preparation',
        body: 'Exit-readiness assessment and vendor diligence, viewed the way a buyer will.'
    }
];


const $832a6266e5d9d8ea$var$ICONS = {
    mb: (parcelRequire("aHS0B")),
    dg: (parcelRequire("9r8tK"))
};
const $832a6266e5d9d8ea$var$LABELS = {
    mb: 'MORSEBRIDGE',
    dg: 'DILIGENTSIA'
};
const $832a6266e5d9d8ea$var$PECombinedServices = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-services",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pe-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-pe-services-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-pe-h2",
                            "data-lp-reveal": true,
                            children: "Combined Services"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "80",
                            children: "Each engagement is scoped to your firm. We build the tools and workflows into your stack, configured to how you source, diligence and monitor."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-pe-services-grid",
                    children: $832a6266e5d9d8ea$var$SERVICES.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-pe-service",
                            "data-lp-reveal": true,
                            "data-lp-delay": i % 3 * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "lp-pe-service-icon",
                                    src: $832a6266e5d9d8ea$var$ICONS[s.brand],
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: `w100 lp-pe-service-brand is-${s.brand}`,
                                    children: $832a6266e5d9d8ea$var$LABELS[s.brand]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "w100",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: s.body
                                })
                            ]
                        }, s.title))
                })
            ]
        })
    });
var $832a6266e5d9d8ea$export$2e2bcd8739ae039 = $832a6266e5d9d8ea$var$PECombinedServices;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $31029db0fdbf9c3a$var$RESOURCES = [
    {
        kind: 'RESOURCE',
        title: 'Sample IC memo',
        body: 'An anonymized investment committee memo produced from a live deal. Shows exactly what you receive and to what standard.',
        cta: 'Download PDF'
    },
    {
        kind: 'RESOURCE',
        title: 'AI deal-sourcing guide',
        body: 'How we build proprietary origination pipelines across web, filings and trade sources, and verify every signal before it reaches you.',
        cta: 'Download PDF'
    },
    {
        kind: 'TOOL',
        title: 'LP Scouting Tool',
        body: 'A basic version, free for PE and VC firms. Identify and shortlist limited partners that fit your fund profile, then take the shortlist straight into outreach.',
        cta: 'Open Tool'
    }
];

const $31029db0fdbf9c3a$var$PEResourcesSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-resources",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pe-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-pe-resources-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-pe-h2 is-dark",
                            "data-lp-reveal": true,
                            children: "Free Resources & Tools"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "80",
                            children: "Three resources showing how we source, screen and diligence deals."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-pe-resources-grid",
                    children: $31029db0fdbf9c3a$var$RESOURCES.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-pe-resource",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-pe-resource-top",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "lp-pe-resource-kind",
                                            children: r.kind
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "lp-pe-resource-badge",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (parcelRequire("ayKVW")),
                                                    alt: ""
                                                }),
                                                "MORSEBRIDGE"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "w100",
                                    children: r.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: r.body
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "lp-pe-btn lp-pe-btn--purple",
                                    href: "#",
                                    children: r.cta
                                })
                            ]
                        }, r.title))
                })
            ]
        })
    });
var $31029db0fdbf9c3a$export$2e2bcd8739ae039 = $31029db0fdbf9c3a$var$PEResourcesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1d510f629fd3e535$var$FunnelIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z"
        })
    });
const $1d510f629fd3e535$var$ShieldIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
        })
    });
const $1d510f629fd3e535$var$TrendIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M23 6l-9.5 9.5-5-5L1 18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17 6h6v6"
            })
        ]
    });
// `ghost` is the oversized pale numeral behind each card's top-right corner.
const $1d510f629fd3e535$var$CARDS = [
    {
        tone: 'blue',
        Icon: $1d510f629fd3e535$var$FunnelIcon,
        ghost: "\xa30",
        title: 'Free qualified deal flow',
        body: 'Come onto our platform for free, and receive qualified, pre-diligenced dealflow from the companies, VCs and advisors already on our platform.'
    },
    {
        tone: 'pink',
        Icon: $1d510f629fd3e535$var$ShieldIcon,
        ghost: '60%',
        title: 'AI diligence at a fraction of the cost',
        body: 'Enable your companies to be quickly pre-diligenced in days, prior to going to the expense of full diligence.'
    },
    {
        tone: 'green',
        Icon: $1d510f629fd3e535$var$TrendIcon,
        ghost: 'Gold',
        title: 'Speed your portfolio exits',
        body: 'Keep your portfolio companies always "exit ready" \u2014 for trade sale, secondary, or PISCES.'
    }
];
const $1d510f629fd3e535$var$PEWhySection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-why",
        style: {
            marginBottom: 0
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pe-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-pe-why-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "lp-pe-eyebrow",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "dot"
                                }),
                                "Why Diligentsia"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-pe-h2 is-lg",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Exit quicker, at higher valuations."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-pe-why-grid",
                    children: $1d510f629fd3e535$var$CARDS.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-pe-why-card",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-pe-why-ghost",
                                    "aria-hidden": "true",
                                    children: c.ghost
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `lp-pe-why-icon is-${c.tone}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(c.Icon, {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: c.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.body
                                })
                            ]
                        }, c.title))
                })
            ]
        })
    });
var $1d510f629fd3e535$export$2e2bcd8739ae039 = $1d510f629fd3e535$var$PEWhySection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// `state` drives the step marker: done = plain, active = filled blue with the "You are here" pill,
// next = dashed outline for the stage that isn't live yet.
const $336d624f4b98bd91$var$STAGES = [
    {
        n: '1',
        state: 'done',
        title: 'Seed',
        body: 'Angel networks and early companies onboard to Diligentsia.'
    },
    {
        n: '2',
        state: 'done',
        title: 'Venture Capital',
        body: 'VCs and advisors keep company records diligenced as they scale.'
    },
    {
        n: '3',
        state: 'active',
        title: 'Private Equity',
        body: "Qualified dealflow and target-company diligence, delivered with Morsebridge's platform layer."
    },
    {
        n: '4',
        state: 'next',
        title: 'PISCES / Exit',
        body: 'Portfolio companies kept exit-ready for trade sale, secondary or PISCES.'
    }
];
const $336d624f4b98bd91$var$PELifecycleSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-lifecycle",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pe-lifecycle-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-pe-eyebrow lp-pe-eyebrow--muted",
                            "data-lp-reveal": true,
                            children: "The Diligentsia lifecycle"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-pe-h2",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "We stay with the company, not just the round."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-pe-lifecycle-lede",
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Diligentsia already works with seed-stage companies, angel networks, VCs and advisors. That means some of dealflow reaching PE houses through our platform may have been in diligenced hands for years before it lands with you."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-pe-coming",
                            "data-lp-reveal": true,
                            "data-lp-delay": "160",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Coming next"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "We're extending the platform to bring VC-sourced opportunities \u2014 follow-on funding rounds, secondaries and PISCES-ready companies \u2014 direct to PE houses looking for their next thesis-fit deal."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-pe-stages",
                    children: $336d624f4b98bd91$var$STAGES.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-pe-stage${i === $336d624f4b98bd91$var$STAGES.length - 1 ? ' is-last' : ''}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `lp-pe-stage-num is-${s.state}`,
                                    children: s.n
                                }),
                                i < $336d624f4b98bd91$var$STAGES.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-pe-stage-line",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-pe-stage-title",
                                            children: [
                                                s.title,
                                                s.state === 'active' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "lp-pe-stage-here",
                                                    children: "You are here"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: s.body
                                        })
                                    ]
                                })
                            ]
                        }, s.n))
                })
            ]
        })
    });
var $336d624f4b98bd91$export$2e2bcd8739ae039 = $336d624f4b98bd91$var$PELifecycleSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $acfc8c1938fbad1b$var$PEInvestorMatchSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-pe-im",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-pe-im-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-pe-eyebrow lp-pe-eyebrow--dark",
                    "data-lp-reveal": true,
                    children: "For Investors"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-pe-h2 is-dark",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "Diligentsia InvestorMatch"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: "Register your fund for free on Diligentsia InvestorMatch, to be matched with qualified diligenced opportunities meeting your investment criteria, and secondary opportunities from the other 50 VCs/PEs already on InvestorMatch."
                })
            ]
        })
    });
var $acfc8c1938fbad1b$export$2e2bcd8739ae039 = $acfc8c1938fbad1b$var$PEInvestorMatchSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $3c90f55b9811b869$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $3c90f55b9811b869$var$PECtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-pe-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-pe-wrap",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-pe-cta-band",
                "data-lp-reveal": true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Ready to grow your portfolio value"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Join Diligentsia free \u2014 and start delivering more for every portfolio company, with Morsebridge powering the platform layer."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-pe-cta-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "lp-pe-btn lp-pe-btn--white",
                                href: $3c90f55b9811b869$var$KOALENDAR,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Book a call"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "lp-pe-btn lp-pe-btn--ghost",
                                to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                children: "Register free"
                            })
                        ]
                    })
                ]
            })
        })
    });
var $3c90f55b9811b869$export$2e2bcd8739ae039 = $3c90f55b9811b869$var$PECtaSection;



const $2009f489cd1d844c$var$LandingHomePEs = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page lp-pe-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c580680d7ae6c419$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae9ccaeac9e778ad$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15a64e4a1d4f248c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $832a6266e5d9d8ea$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31029db0fdbf9c3a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d510f629fd3e535$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $336d624f4b98bd91$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acfc8c1938fbad1b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c90f55b9811b869$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2009f489cd1d844c$export$2e2bcd8739ae039 = $2009f489cd1d844c$var$LandingHomePEs;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $069e19d99083c4f2$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
// Design colours for the deal-card status tags (--green / --amber in the design file).
const $069e19d99083c4f2$var$GREEN = '#1EAD5C';
const $069e19d99083c4f2$var$AMBER = '#E8A83C';
const $069e19d99083c4f2$var$CORAL = '#FC7785';
const $069e19d99083c4f2$var$BLUE = '#4A67FF';

const $069e19d99083c4f2$var$VCHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero lp-hero--vc",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "For VC firms"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: "Impact on your portfolio returns if we could help you avoid the worst two investments in every ten? Or rescue/exit them?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "Free application triaging in 3\u20134 minutes. Free early investment readiness assessments. Diligence pack before IC, not after. Portfolio companies always ready for follow-on rounds or exit. Plus qualified, prediligenced deal flow meeting your investment criteria."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--primary",
                                        href: $069e19d99083c4f2$var$KOALENDAR,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Book a 30-min call"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--pe-outline",
                                        href: "#try-the-demo",
                                        children: "See how it works \u2193"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-hero-social",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: "Free to VC firms \xb7 No IT setup \xb7 40+ VCs already on platform"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-hero-art",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-hero-stage lp-hero-stage--vc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "lp-hero-photo",
                                    src: (parcelRequire("dbmM1")),
                                    alt: "VC partner"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-vc-dealcard",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "200",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dc-top",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "t",
                                                    children: "360\xb0 Deal View"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "live",
                                                    children: "Live"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "dc-label",
                                            style: {
                                                color: $069e19d99083c4f2$var$CORAL
                                            },
                                            children: "Your 180\xb0"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dc-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "lbl",
                                                    children: "Pitch deck quality"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "val",
                                                    style: {
                                                        color: $069e19d99083c4f2$var$GREEN
                                                    },
                                                    children: "\u2713 Strong"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "dc-divider"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "dc-label",
                                            style: {
                                                color: $069e19d99083c4f2$var$BLUE
                                            },
                                            children: "The other 180\xb0 \u2014 Diligentsia"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dc-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "lbl",
                                                    children: "Automated diligence pack"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "val",
                                                    style: {
                                                        color: $069e19d99083c4f2$var$AMBER
                                                    },
                                                    children: "\u26A0 2 gaps"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
var $069e19d99083c4f2$export$2e2bcd8739ae039 = $069e19d99083c4f2$var$VCHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

// The Kestrel Logistics deal workspace is a standalone vanilla-JS app, served as a static file from
// /demos/ (copied into dist by the `build`/`start` npm scripts, never bundled by Parcel).
//
// Reason: it must run in an iframe, not inline. It owns `location.hash` for its own routing, calls
// window.scrollTo(0,0) on every render, writes `document.documentElement.dataset.theme`, and defines
// ~30 globals wired through inline onclick attributes. The iframe gives it its own document, hash,
// scroll position and global scope, so none of that can reach the landing page — and its 460 lines
// of CSS cannot collide with the utility classes.
// The sandbox's lead-capture gate posts to the Diligentsia API, which sits on a different origin in
// every environment. Passing the base in as ?api=… keeps that environment logic in env.js only —
// the query string must precede the hash, which the demo's own router owns.
const $a1841db8dc3a8e13$var$DEMO_SRC = `/demos/kestrel-demo.html?api=${encodeURIComponent((0, $6a6b4b5ab5be324d$export$61abde59b50deb8e))}#/pipeline`;
const $a1841db8dc3a8e13$var$SandboxSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-demo-section",
        id: "try-the-demo",
        style: {
            marginBottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-demo-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "lp-demo-eyebrow",
                        "data-lp-reveal": true,
                        children: "Try it yourself"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        style: {
                            fontSize: '34px',
                            fontWeight: '600'
                        },
                        children: "This is the platform your applicants land in \u2014 try it live"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "lp-sub",
                        "data-lp-reveal": true,
                        "data-lp-delay": "120",
                        style: {
                            fontSize: '15px'
                        },
                        children: [
                            "Below is Diligentsia's actual deal workspace, loaded with a real sample application \u2014 ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: "Kestrel Logistics"
                            }),
                            ", a seed-stage logistics SaaS company \u2014 moving through intake, AI analysis, triage, diligence, stress-testing and the IC memo. Click through the pipeline exactly as your team would."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-demo-shell",
                "data-lp-reveal": true,
                "data-lp-delay": "160",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-demo-bar",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lp-demo-dot"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lp-demo-dot"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lp-demo-dot"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lp-demo-url",
                                children: "app.diligentsia.co.uk/pipeline"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lp-demo-badge",
                                children: "\u25CF Sample data \u2014 Kestrel Logistics"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                        className: "lp-demo-iframe",
                        src: $a1841db8dc3a8e13$var$DEMO_SRC,
                        title: "Diligentsia deal management demo \u2014 Kestrel Logistics",
                        loading: "lazy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-demo-footnote",
                children: "This is a live interactive sandbox \u2014 nothing you click here affects real data. Book a call to see it running on your own pipeline."
            })
        ]
    });
var $a1841db8dc3a8e13$export$2e2bcd8739ae039 = $a1841db8dc3a8e13$var$SandboxSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Five capabilities unlocked by a single company account, then the two-way dealflow callout.
// Both live in one dark section, separated by a hairline divider, exactly as in the design.
const $dc4a3de35a277dec$var$CAPABILITIES = [
    {
        num: '01',
        icon: "\u2713",
        title: 'Investment readiness assessment',
        body: "A continuously updated score against the criteria investors actually use \u2014 so founders know exactly what to fix, before you ever have to say no."
    },
    {
        num: '02',
        icon: "\uD83D\uDCC1",
        title: 'Comprehensive diligence pack',
        body: "A living data room assembling legal, corporate, IP and governance documentation automatically \u2014 the same pack that protects valuation at exit."
    },
    {
        num: '03',
        icon: "\uD83D\uDCCA",
        title: 'Financial modelling & self-diligence',
        body: 'Founders build and stress-test their own financial model on-platform, catching the numbers issues before they ever reach your associates.'
    },
    {
        num: '04',
        icon: "\u2325",
        title: 'Software & technical self-diligence',
        body: "Automated architecture, code-health and security review for software companies \u2014 surfaced to founders as a fix-list, not a rejection letter."
    },
    {
        num: '05',
        icon: "\u21C4",
        title: 'Investor matching on rejection',
        body: "Pass on a deal and the company doesn\u2019t just disappear. Diligentsia matches them to other investors on the platform whose thesis fits \u2014 turning your \u201Cno\u201D into someone else\u2019s \u201Cyes.\u201D",
        highlight: true
    }
];
const $dc4a3de35a277dec$var$FLOWS = [
    {
        dir: 'out',
        tag: 'Outbound',
        title: 'You pass on a deal',
        body: "It doesn\u2019t disappear. It\u2019s matched against every other investor\u2019s thesis on the platform and routed to whoever\u2019s actually a fit."
    },
    {
        dir: 'in',
        tag: 'Inbound',
        title: 'Other investors pass on a deal',
        body: "If it matches your criteria, it lands in your pipeline automatically \u2014 pre-qualified, pre-diligenced, ready to review."
    }
];
const $dc4a3de35a277dec$var$EcosystemSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-eco-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-eco-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-eco-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-eco-eyebrow",
                            "data-lp-reveal": true,
                            children: "Beyond deal management"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Other platforms score a deck. We stay with the company."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Deal triage and diligence scoring are table stakes \u2014 several vendors now offer something similar. What none of them offer is what happens next. The same Kestrel Logistics account you just clicked through doesn't stop at your decision. It keeps working."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-eco-hub",
                    "data-lp-reveal": true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "lp-eco-hub-pill",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "dot"
                                }),
                                "One Kestrel Logistics account on Diligentsia"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-eco-hub-arrow",
                            children: "\u2192"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-eco-hub-note",
                            children: "unlocks all five, automatically"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-eco-grid",
                    children: $dc4a3de35a277dec$var$CAPABILITIES.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-eco-card${c.highlight ? ' is-highlight' : ''}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 70,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-eco-num",
                                    children: c.num
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-eco-icon",
                                    "aria-hidden": "true",
                                    children: c.icon
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: c.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.body
                                })
                            ]
                        }, c.num))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "lp-eco-foot",
                    "data-lp-reveal": true,
                    children: [
                        "Five capabilities. One account. ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "No other platform builds this ecosystem."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-eco-divider"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-net-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-net-eyebrow",
                            "data-lp-reveal": true,
                            children: "And it flows back to you"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Dealflow doesn't only leave your pipeline. It arrives in it."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Every VC and advisor on Diligentsia runs the same thesis-matching engine. When another investor passes on a company that fits your sector, stage, geography or check size, it lands in your pipeline pre-qualified and pre-diligenced \u2014 the same 360\xb0 view you just saw on Kestrel Logistics, already attached."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-net-flow",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-flow-card is-${$dc4a3de35a277dec$var$FLOWS[0]['dir']}`,
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-flow-tag",
                                    children: $dc4a3de35a277dec$var$FLOWS[0]['tag']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: $dc4a3de35a277dec$var$FLOWS[0]['title']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: $dc4a3de35a277dec$var$FLOWS[0]['body']
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-flow-arrow",
                            "aria-hidden": "true",
                            children: "\u21C4"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-flow-card is-${$dc4a3de35a277dec$var$FLOWS[1]['dir']}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": "100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-flow-tag",
                                    children: $dc4a3de35a277dec$var$FLOWS[1]['tag']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: $dc4a3de35a277dec$var$FLOWS[1]['title']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: $dc4a3de35a277dec$var$FLOWS[1]['body']
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "lp-net-foot",
                    "data-lp-reveal": true,
                    children: [
                        "40+ investors and advisors. ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "One shared engine, working in both directions."
                        })
                    ]
                })
            ]
        })
    });
var $dc4a3de35a277dec$export$2e2bcd8739ae039 = $dc4a3de35a277dec$var$EcosystemSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Replaces the old For-VC-firms / For-portfolio-companies tab switcher. The two "effects on returns"
// that used to be their own section are now the blue closing line on each stage card.
const $6fa249cef6b70dc7$var$STAGES = [
    {
        num: '01',
        title: "360\xb0 view at application",
        body: 'Every applicant gets a free Diligentsia account. Governance gaps, IP issues, and documentation holes surface automatically before your analysts spend serious time.',
        effect: "\u2192 Fewer bad investments: risks visible at week one, not week twelve."
    },
    {
        num: '02',
        title: 'Preliminary DD before IC',
        body: "Concurrent corporate readiness alongside your market evaluation. Series A compressed from 10\u201330 weeks to 6\u201315 weeks. ~\xa325,000 saved (mid-scenario).",
        effect: "\u2192 Avoiding your worst two investments in ten does more for returns than any other single lever."
    },
    {
        num: '03',
        title: 'Always on post-investment',
        body: 'Portfolio companies stay on platform. Governance stays clean. Unified dashboard for portfolio managers. Every next round or exit starts from a position of strength.',
        effect: "\u2192 Higher exit valuations: a maintained Diligence Pack removes the buyer\u2019s excuse to chip price."
    }
];
const $6fa249cef6b70dc7$var$VCStagesSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-stages-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-stages-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-stages-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-h2",
                            "data-lp-reveal": true,
                            style: {
                                fontWeight: '600'
                            },
                            children: "Three stages. Two effects on returns."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-sub",
                            "data-lp-reveal": true,
                            "data-lp-delay": "80",
                            style: {
                                maxWidth: '700px'
                            },
                            children: "From first application to portfolio exit \u2014 always working, and each stage pays for itself."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-stages-grid",
                    children: $6fa249cef6b70dc7$var$STAGES.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-stage-card",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 90,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-stage-num",
                                    children: s.num
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "w100",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: s.body
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "lp-stage-effect",
                                    children: s.effect
                                })
                            ]
                        }, s.num))
                })
            ]
        })
    });
var $6fa249cef6b70dc7$export$2e2bcd8739ae039 = $6fa249cef6b70dc7$var$VCStagesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Light hairline strip, per the updated design — not the dark glow band the other landing pages use,
// so this keeps its own `lp-vcstats-*` classes rather than restyling the shared `.lp-stats`.
const $8dfed0cfba32d773$var$STATS = [
    {
        count: 40,
        suffix: '+',
        label: 'VCs on the platform'
    },
    {
        raw: 'Free',
        label: 'to investors and advisors'
    },
    {
        count: 60,
        prefix: '~',
        suffix: '%',
        label: 'AI auto-populated modules'
    },
    {
        count: 13,
        suffix: ' wks',
        label: 'saved on a Series A (mid scenario)'
    },
    {
        raw: "360\xb0",
        label: 'Deal View, always live'
    }
];
const $8dfed0cfba32d773$var$VCStatsBand = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-vcstats",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-vcstats-strip",
            children: $8dfed0cfba32d773$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-vcstats-item",
                    "data-lp-reveal": true,
                    "data-lp-delay": i * 70,
                    children: [
                        s.raw ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-vcstats-num",
                            children: s.raw
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-vcstats-num",
                            "data-count": s.count,
                            "data-prefix": s.prefix,
                            "data-suffix": s.suffix,
                            children: [
                                s.prefix,
                                s.count,
                                s.suffix
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-vcstats-label",
                            children: s.label
                        })
                    ]
                }, i))
        })
    });
var $8dfed0cfba32d773$export$2e2bcd8739ae039 = $8dfed0cfba32d773$var$VCStatsBand;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Static 2×2 grid on the light section background, per the updated design — this replaced the dark
// autoplay carousel the other landing pages still use.
const $56de386a060f0ca8$var$QUOTES = [
    {
        q: "My kind of utopia is to get a conversational application process \u2014 AI accepted through to pre-screen initial DD without us physically doing anything.",
        a: "\u2014 Peter Evison, COO, EHE Capital"
    },
    {
        q: 'Putting a deal in front of a VC with the Diligentsia outputs alongside the deck. You have answered 60 questions they did not even ask yet.',
        a: "\u2014 Fractional CFO, CFO Centre"
    },
    {
        q: 'I think there is definitely a market need for a platform like this.',
        a: "\u2014 Kevin Jackson, Chairman, AI Forge"
    },
    {
        q: 'A living, breathing data room that syncs with your documents to maintain continuous readiness.',
        a: "\u2014 Founder, advanced medtech company (active fundraising)"
    }
];
const $56de386a060f0ca8$var$VCQuotesSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-vcquotes",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-vcquotes-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vcquotes-head",
                    "data-lp-reveal": true,
                    children: "Trusted by investors and founders who know due diligence."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vcquotes-grid",
                    children: $56de386a060f0ca8$var$QUOTES.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-vcquotes-card",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "lp-vcquotes-quote",
                                    children: item.q
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-vcquotes-attrib",
                                    children: item.a
                                })
                            ]
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-vcquotes-foot",
                    "data-lp-reveal": true,
                    children: "Trusted by 40+ VCs and their portfolio companies."
                })
            ]
        })
    });
var $56de386a060f0ca8$export$2e2bcd8739ae039 = $56de386a060f0ca8$var$VCQuotesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $f03e2eaabb0a3d09$var$VCPricingSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-vcprice",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-vcprice-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vcprice-head",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        children: "What does it cost?"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-vcprice-grid",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-vcprice-card is-highlight",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-vcprice-tag",
                                    children: "VC Firm"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "Free"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-vcprice-amount",
                                    children: "\xa30"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "No platform fees, no licence costs, no commitment. Investor access is always free on Diligentsia."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-vc-price-card lp-vc-price-card--paid",
                            "data-lp-reveal": true,
                            "data-lp-delay": "100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "label",
                                    children: "Portfolio / Applicant Company"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "price",
                                    children: [
                                        "\xa383.25",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "/ mo"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "\xa3999/yr, billed annually. Portfolio company rate: \xa366.67/mo (\xa3800/yr \u2014 20% off via your firm). Companies bear the cost \u2014 not your firm."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: "#",
                                    children: "Full pricing \u2192"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vcprice-foot",
                    "data-lp-reveal": true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: $16250bd714b02a14$export$bcdbe1127ca0dc8c,
                        children: "Full pricing \u2192"
                    })
                })
            ]
        })
    });
var $f03e2eaabb0a3d09$export$2e2bcd8739ae039 = $f03e2eaabb0a3d09$var$VCPricingSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $83ae49b79d9745dc$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const $83ae49b79d9745dc$var$VCCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cta-card",
            "data-lp-reveal": true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cta-glow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Ready to get started?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "sub",
                            children: "Book a 30-minute call to see the 360-degree triage dashboard."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "lp-cta-btn",
                            href: $83ae49b79d9745dc$var$KOALENDAR,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "av",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("eC1vN")),
                                        alt: "Mark Bernstein"
                                    })
                                }),
                                "Book a call"
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $83ae49b79d9745dc$export$2e2bcd8739ae039 = $83ae49b79d9745dc$var$VCCtaSection;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

// AUTO-GENERATED from the AEO markdown batch ("Diligentsia Resources - AEO articles").
// Regenerate with the conversion script rather than editing bodyHtml by hand.
// Each article: hub-and-spoke AEO page at /[icpSlug]/[slug] with JSON-LD schema blocks.
const $7393559700759e6c$export$aa103e2c51dcf48a = {
    "vc": {
        "name": "VC & Investors",
        "hubPath": "/vc",
        "legacyPath": "/landing-page-vcs",
        "anchorText": "Diligentsia for VC Firms"
    },
    "ceo": {
        "name": "Companies",
        "hubPath": "/ceo",
        "legacyPath": "/landing-page",
        "anchorText": "Diligentsia for Companies"
    },
    "cfo": {
        "name": "Fractional CFOs",
        "hubPath": "/cfo",
        "legacyPath": "/landing-page-fractional",
        "anchorText": "Diligentsia for Fractional CFOs"
    },
    "angel-network": {
        "name": "Angel Networks",
        "hubPath": "/angel-network",
        "legacyPath": "/landing-page-angel-networks",
        "anchorText": "Diligentsia for Angel Networks"
    },
    "accelerator": {
        "name": "Accelerators",
        "hubPath": "/accelerator",
        "legacyPath": null,
        "anchorText": "Diligentsia for Accelerators"
    },
    "pisces": {
        "name": "PISCES",
        "hubPath": "/pisces",
        "legacyPath": "/landing-page-pisces",
        "anchorText": "Diligentsia for PISCES Disclosures"
    }
};
const $7393559700759e6c$export$48a6bbfb0f95d83a = [
    {
        "icpSlug": "vc",
        "slug": "what-vcs-look-for-series-a",
        "category": "VC & Investors",
        "title": "What Do VCs Look for in a Series A Company in 2026?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-vcs-look-for-series-a.jpg",
        "metaDescription": "What VCs look for in a Series A company \u2014 covering revenue thresholds, team requirements, governance standards, due diligence expectations, and how the criteria differ from seed stage. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/vc/what-vcs-look-for-series-a/",
        "bodyHtml": '<p>At Series A, venture capital firms are looking for evidence that a company has found product-market fit, has a credible path to scale, and is operationally mature enough to deploy significant capital responsibly. The bar is materially higher than seed \u2014 and the scrutiny applied to corporate governance and documentation reflects this.</p>\n<h2>How Series A differs from seed</h2>\n<p>At seed stage, VCs are typically betting on the founder and the hypothesis. Due diligence is lighter, documentation requirements are less rigorous, and the investment decision often turns on conviction about the team rather than proof of the business model.</p>\n<p>At Series A, that changes. A Series A investor is deploying \xa32M\u2013\xa310M+ into a company that must demonstrate it can build a repeatable, scalable business. Due diligence is professional and thorough. Corporate documentation is scrutinised. Financial records are reviewed by accountants. Legal due diligence is conducted by specialist lawyers on both sides.</p>\n<p><em>Source: Diligentsia Series A Fundraising Analysis (2026), benchmarked against BVCA process notes.</em></p>\n<h2>Revenue and traction thresholds</h2>\n<p>There is no universal revenue threshold for a Series A, but most UK VCs expect to see meaningful commercial traction \u2014 typically \xa3500k\u2013\xa32M ARR for SaaS businesses, or equivalent proof of demand in other sectors. The key question is not the absolute revenue figure but what it demonstrates: that the company has validated its go-to-market model, has a measurable customer acquisition cost, and can articulate a credible path to the revenue multiples that will justify the next round valuation.</p>\n<p>Deep tech and life sciences companies often raise Series A on product milestones rather than revenue. The common thread is evidence: that something real has happened, and that the company understands why.</p>\n<h2>Team and organisational maturity</h2>\n<p>Series A investors look for early evidence of organisational infrastructure \u2014 not just a founding team:</p>\n<ul><li>A named CFO or VP Finance \u2014 even part-time or fractional \u2014 demonstrates financial rigour</li><li>Clear ownership of product, sales, and operations functions</li><li>Documented processes for hiring, onboarding, and performance management</li><li>Board minutes and written resolutions in place \u2014 showing the company is governed, not just run</li><li>Option schemes documented and compliant \u2014 CSOP or EMI in place for key hires</li></ul>\n<h2>Corporate governance standards</h2>\n<p>The most common reason Series A deals collapse \u2014 or prices are chipped at the last minute \u2014 is not the market or the team. It is corporate governance gaps that surface late in due diligence. Issues acceptable at seed stage (informal founder agreements, IP not formally assigned, cap table discrepancies) become material problems at Series A, where professional investors conduct thorough legal and financial review.</p>\n<p>The corporate governance standards a Series A investor will expect:</p>\n<ul><li><strong>IP ownership:</strong> all intellectual property formally assigned to the company. Employment and contractor IP assignment agreements signed by all contributors.</li><li><strong>Cap table:</strong> current, accurate, and matching the shareholder register. All option grants documented with signed agreements.</li><li><strong>Founder arrangements:</strong> equity splits, vesting schedules, and leaver provisions documented and legally binding.</li><li><strong>Shareholder agreements:</strong> existing investor rights documented, including pre-emption rights, information rights, and drag-along provisions.</li><li><strong>Material contracts:</strong> all significant commercial relationships covered by signed agreements.</li><li><strong>Regulatory compliance:</strong> a clear record of compliance decisions relevant to the sector.</li></ul>\n<h2>Financial rigour</h2>\n<p>Series A investors conduct financial due diligence via accountants, who will review management accounts, financial projections, and underlying assumptions in detail:</p>\n<ul><li><strong>Complete:</strong> management accounts for every period since incorporation, filed on time</li><li><strong>Consistent:</strong> figures matching across the pitch deck, the data room, and the underlying records</li><li><strong>Auditable:</strong> revenue recognition policies documented, cash position reconciled, key assumptions clearly stated</li><li><strong>Credible:</strong> projections built from documented assumptions, with sensitivity analysis where relevant</li></ul>\n<h2>The AI factor</h2>\n<p>AI tools are now routinely deployed in Series A due diligence. They surface gaps in corporate documentation, inconsistencies across document sets, and under-disclosed risks faster than human reviewers. For companies, this means the standard for documentation quality is rising. A data room that would have passed muster two years ago may now generate a long list of AI-identified flags that slow the transaction or reduce investor confidence.</p>\n<blockquote><p><em>"AI tools are now routinely deployed in Series A due diligence. They surface gaps in corporate documentation, inconsistencies across document sets, and under-disclosed risks faster than human reviewers."</em></p><p>\u2014 Diligentsia Series A Fundraising Analysis (2026)</p></blockquote>\n<p>There is also a structural risk: some investors are beginning to request direct access to company cloud storage rather than a curated data room. This exposes companies to unfiltered scrutiny \u2014 including superseded documents, internal communications, and incomplete records never intended for investor review. Companies with a structured, curated Diligence Pack retain control of what investors see and in what context.</p>\n<h2>Timeline and cost expectations</h2>\n<p><strong>10\u201318 weeks</strong> \u2014 typical duration of a well-prepared Series A from first investor conversation to close.</p>\n<p><strong>20\u201330 weeks</strong> \u2014 typical duration for a poorly prepared Series A \u2014 or it does not close at all.</p>\n<blockquote><p><em>"Companies that complete a structured Diligence Pack before beginning investor conversations typically compress their Series A timeline by 4\u201315 weeks and reduce external professional fees by \xa315,000\u2013\xa325,000."</em></p><p>\u2014 Diligentsia Series A Fundraising Analysis (2026)</p></blockquote>\n<h2>How Diligentsia helps Series A companies</h2>\n<p>Diligentsia is a UK investment readiness platform designed to help companies meet the corporate governance and documentation standards that Series A investors expect. The platform auto-populates approximately 60% of diligence modules from existing company documents, with human review mandatory on every answer. The output is a certified Diligence Pack \u2014 structured, evidence-linked, shareable with controlled access \u2014 that compresses the due diligence process for both the company and the investor.</p>\n<p>Companies that have worked with VCs through the Diligentsia platform report faster transaction timelines, fewer late-stage surprises, and stronger negotiating positions on price.</p>\n<p><strong>Diligentsia Pro: \xa31,000/year.</strong> Start at <a href="/vc/">diligentsia.co.uk/vc/</a></p>',
        "peopleAlsoAsk": [
            {
                "q": "What revenue do you need for a Series A?",
                "a": "Most UK VCs expect \xa3500k\u2013\xa32M ARR for SaaS businesses at Series A, or equivalent proof of demand in other sectors. Deep tech and life sciences companies often raise on product milestones rather than revenue. The key question is not the absolute figure but what it demonstrates: validated go-to-market, measurable CAC, and a credible path to the revenue multiples that justify the next round valuation."
            },
            {
                "q": "Why do Series A deals collapse?",
                "a": "The most common reason Series A deals collapse or valuations are chipped is not the market or the team \u2014 it is corporate governance gaps that surface late in due diligence. Issues acceptable at seed (informal founder agreements, IP not formally assigned, cap table discrepancies) become material problems at Series A when professional investors conduct thorough legal and financial review. Preparation before term sheet removes this risk."
            }
        ],
        "faqs": [
            {
                "q": "What do VCs look for in a Series A company?",
                "a": "Series A investors look for evidence of product-market fit, a credible path to scale, and operational maturity sufficient to deploy significant capital responsibly. The evaluation covers: commercial traction (typically \xa3500k\u2013\xa32M ARR for SaaS), team organisational maturity, clean corporate governance, rigorous financial records, and the ability to withstand professional legal and financial due diligence."
            },
            {
                "q": "How is Series A different from seed funding?",
                "a": "At seed, VCs bet on the founder and the hypothesis \u2014 due diligence is light, documentation less rigorous, and the decision often turns on team conviction. At Series A, a \xa32M\u2013\xa310M+ deployment requires professional due diligence: accountant-reviewed financials, lawyer-conducted legal due diligence, and structured corporate documentation review. Issues that were overlooked at seed become deal-breakers at Series A."
            },
            {
                "q": "What corporate governance does a Series A investor expect?",
                "a": "A Series A investor expects: all IP formally assigned to the company; a clean, current cap table matching the shareholder register; founder equity splits and vesting schedules legally documented; all option grants with signed agreements; material contracts in place; board minutes and written resolutions on file; and a clear compliance record for regulated activities. Issues in any of these areas can collapse the deal or justify a price reduction at close."
            },
            {
                "q": "How much does a Series A slow down if the company is unprepared?",
                "a": "A well-prepared Series A takes 10\u201318 weeks from first investor conversation to close. A poorly prepared one takes 20\u201330 weeks \u2014 or fails to close entirely. The difference is largely how quickly the company responds to due diligence requests and whether responses reveal issues requiring remediation. Companies that complete a Diligence Pack before investor conversations typically compress their timeline by 4\u201315 weeks and save \xa315,000\u2013\xa325,000 in professional fees."
            },
            {
                "q": "How does AI affect Series A due diligence?",
                "a": "AI tools are now standard in Series A due diligence. They surface documentation gaps, cross-document inconsistencies, and under-disclosed risks faster than human reviewers. The practical effect for companies: the documentation quality threshold is rising. Some investors are also requesting direct access to cloud storage rather than curated data rooms \u2014 exposing companies to unfiltered review of internal documents. A structured, curated Diligence Pack lets companies control what investors see and in what context."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "What Do VCs Look for in a Series A Company in 2026?",
                "description": "What VCs look for in a Series A company \u2014 covering revenue thresholds, team requirements, governance standards, due diligence expectations, and how the criteria differ from seed stage.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/vc/what-vcs-look-for-series-a/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-vcs-look-for-series-a.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What revenue do you need for a Series A?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Most UK VCs expect \xa3500k\u2013\xa32M ARR for SaaS businesses at Series A, or equivalent proof of demand in other sectors. Deep tech and life sciences companies often raise on product milestones rather than revenue. The key question is not the absolute figure but what it demonstrates: validated go-to-market, measurable CAC, and a credible path to the revenue multiples that justify the next round valuation."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Why do Series A deals collapse?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most common reason Series A deals collapse or valuations are chipped is not the market or the team \u2014 it is corporate governance gaps that surface late in due diligence. Issues acceptable at seed (informal founder agreements, IP not formally assigned, cap table discrepancies) become material problems at Series A when professional investors conduct thorough legal and financial review. Preparation before term sheet removes this risk."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What do VCs look for in a Series A company?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Series A investors look for evidence of product-market fit, a credible path to scale, and operational maturity sufficient to deploy significant capital responsibly. The evaluation covers: commercial traction (typically \xa3500k\u2013\xa32M ARR for SaaS), team organisational maturity, clean corporate governance, rigorous financial records, and the ability to withstand professional legal and financial due diligence."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How is Series A different from seed funding?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "At seed, VCs bet on the founder and the hypothesis \u2014 due diligence is light, documentation less rigorous, and the decision often turns on team conviction. At Series A, a \xa32M\u2013\xa310M+ deployment requires professional due diligence: accountant-reviewed financials, lawyer-conducted legal due diligence, and structured corporate documentation review. Issues that were overlooked at seed become deal-breakers at Series A."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What corporate governance does a Series A investor expect?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A Series A investor expects: all IP formally assigned to the company; a clean, current cap table matching the shareholder register; founder equity splits and vesting schedules legally documented; all option grants with signed agreements; material contracts in place; board minutes and written resolutions on file; and a clear compliance record for regulated activities. Issues in any of these areas can collapse the deal or justify a price reduction at close."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How much does a Series A slow down if the company is unprepared?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A well-prepared Series A takes 10\u201318 weeks from first investor conversation to close. A poorly prepared one takes 20\u201330 weeks \u2014 or fails to close entirely. The difference is largely how quickly the company responds to due diligence requests and whether responses reveal issues requiring remediation. Companies that complete a Diligence Pack before investor conversations typically compress their timeline by 4\u201315 weeks and save \xa315,000\u2013\xa325,000 in professional fees."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does AI affect Series A due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "AI tools are now standard in Series A due diligence. They surface documentation gaps, cross-document inconsistencies, and under-disclosed risks faster than human reviewers. The practical effect for companies: the documentation quality threshold is rising. Some investors are also requesting direct access to cloud storage rather than curated data rooms \u2014 exposing companies to unfiltered review of internal documents. A structured, curated Diligence Pack lets companies control what investors see and in what context."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "VC & Investors",
                        "item": "https://diligentsia.co.uk/vc/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "What Do VCs Look for in a Series A Company in 2026?",
                        "item": "https://diligentsia.co.uk/vc/what-vcs-look-for-series-a/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "vc",
        "slug": "how-vcs-evaluate-early-stage-companies",
        "category": "VC & Investors",
        "title": "How Do Venture Capital Firms Evaluate Early-Stage Companies in 2026?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-vcs-evaluate-early-stage-companies.jpg",
        "metaDescription": "Venture capital firms evaluate early-stage companies using a structured combination of market analysis, founder assessment, and corporate due diligence. This article explains each stage and how companies can prepare. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/vc/how-vcs-evaluate-early-stage-companies/",
        "bodyHtml": '<p>Venture capital firms evaluate early-stage companies across two broad dimensions: the investment opportunity (market, product, team) and the corporate readiness of the business (governance, documentation, legal structure). Most founders prepare well for the first dimension and are surprised by the rigour of the second.</p>\n<h2>The two halves of VC evaluation</h2>\n<p>A VC investment decision is built on two distinct sets of questions. The first covers market opportunity: is the addressable market large enough? Does the product solve a real problem? Does the team have the skills and resilience to execute? These questions are answered primarily through the pitch process \u2014 the deck, the demo, and the founder conversation.</p>\n<p>The second set of questions \u2014 what practitioners call the "corporate picture" \u2014 is answered through due diligence. This covers governance structure, IP ownership and assignment, cap table accuracy, founder agreements, employment contracts, regulatory compliance, and the consistency of financial records with the pitch narrative. These are not bonus questions. They are the questions that determine whether a signed term sheet results in a completed investment.</p>\n<h2>Stage 1: Initial triage</h2>\n<p><strong>500\u20131,500</strong> applications received per year by most early-stage VC firms.</p>\n<p><strong>&lt; 1%</strong> of applications result in investment \u2014 making initial triage a filtering exercise, not an evaluation exercise.</p>\n<p>At this stage, the VC is asking: does this company clear a minimum bar on market, thesis fit, and founder quality to justify spending analyst time on it? AI tools are increasingly used here to assess pitch deck quality, market sizing, and fit. What AI cannot easily assess at this stage is the corporate picture \u2014 whether the governance, IP, and documentation will survive a professional due diligence process.</p>\n<h2>Stage 2: Initial diligence and Investment Committee</h2>\n<p>Companies that pass initial triage move into structured evaluation: information pack review, founder reference checks, competitive landscape assessment, and initial corporate documentation review. The goal is to build enough conviction for an Investment Committee (IC). The IC wants to understand not just the investment thesis but the risk profile \u2014 including governance gaps, undisclosed liabilities, and documentation inconsistencies.</p>\n<p>A common failure mode is for issues to surface at IC or after term sheet \u2014 at which point the deal either collapses or the investor uses the gaps to justify a price reduction. Companies that arrive at IC with a structured, pre-prepared Diligence Pack are significantly less likely to face this outcome.</p>\n<h2>Stage 3: Post-term-sheet due diligence</h2>\n<p><strong>10\u201330 weeks</strong> \u2014 typical duration of a Series A due diligence process from term sheet to close.</p>\n<p><strong>\xa365,000\u2013\xa3113,000</strong> \u2014 external professional fees for legal, financial, and commercial due diligence at Series A (Diligentsia analysis, 2026, benchmarked against BVCA process notes and UK legal cost surveys).</p>\n<p>After a term sheet is issued, formal due diligence begins: legal review of all corporate documentation, financial review of management accounts, and commercial validation. Management time is severely disrupted \u2014 CEOs and CFOs typically spend 30\u201350% of their working hours responding to requests during this period.</p>\n<h3>Due diligence preparation options compared</h3>\n<p>| Option | Cost | Permanence | Reusable? | |---|---|---|---| | External due diligence firm | \xa365,000\u2013\xa3113,000 per Series A | One transaction only | No | | Virtual Data Room (VDR) | \xa3300\u2013\xa3800/month | Active while subscription live | Partially | | Diligentsia (AI-assisted platform) | \xa31,000/year | Permanent, compounding asset | Yes \u2014 every future transaction | | No preparation | \xa30 upfront | n/a | No \u2014 rework each time |</p>\n<h2>What VCs look for that founders often miss</h2>\n<ul><li><strong>IP ownership:</strong> has all intellectual property been formally assigned to the company? Employee and contractor IP assignment agreements are a common gap.</li><li><strong>Cap table accuracy:</strong> does the current cap table match the corporate record? Inconsistencies between shareholder registers and option agreements are a frequent complication.</li><li><strong>Founder agreements:</strong> are co-founder equity splits documented? Are vesting schedules in place? Are there any side agreements that do not appear in the formal corporate record?</li><li><strong>Financial record consistency:</strong> do the management accounts match the narrative in the pitch deck? Are projections based on documented assumptions?</li><li><strong>Regulatory compliance:</strong> for regulated sectors, is there a clear record of compliance decisions and filings?</li></ul>\n<h2>How AI is changing VC evaluation</h2>\n<p>AI tools are now standard in early-stage VC. They are used to analyse pitch decks, assess market opportunity, and increasingly to run initial corporate diligence. As these tools improve, they will surface more issues, faster, than human analysts did. Companies that arrive with unstructured documentation \u2014 files spread across cloud folders, inconsistent versions, gaps in the corporate record \u2014 will find investor conversations slower and less conclusive.</p>\n<blockquote><p><em>"The companies that fare best in an AI-augmented due diligence environment are those with a structured, curated, human-reviewed document set \u2014 not a dump of raw cloud storage."</em></p><p>\u2014 Diligentsia Series A Fundraising Analysis (2026)</p></blockquote>\n<h2>How Diligentsia helps</h2>\n<p>Diligentsia is a UK investment readiness platform that helps companies prepare the structured corporate documentation VCs expect \u2014 and helps VC firms surface the corporate picture at the point of application, not six weeks into a due diligence process. The platform auto-populates approximately 60% of diligence modules from existing company documents, with human review mandatory on every answer. The result is a certified Diligence Pack: structured, evidence-linked, and shareable with controlled access.</p>\n<p>For VC firms, Diligentsia provides free access to applicant readiness profiles alongside every pitch \u2014 giving analysts a 360-degree view of both the investment opportunity and the corporate health of the company before serious analyst time is committed.</p>\n<p>Learn more at <a href="/vc/">diligentsia.co.uk/vc/</a></p>',
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "How do venture capital firms evaluate early-stage companies?",
                "a": "VC evaluation covers two dimensions: the investment opportunity (market size, product, team \u2014 assessed through the pitch) and the corporate picture (governance, IP ownership, cap table, documentation \u2014 assessed through due diligence). Most founders prepare extensively for the first and underestimate the scrutiny applied to the second. Companies that arrive at IC or term sheet with documented governance gaps risk deal collapse or last-minute price reduction."
            },
            {
                "q": "How many applications does a VC fund receive, and what proportion get funded?",
                "a": "Most early-stage VC firms receive between 500 and 1,500 applications per year and invest in fewer than 1%. Initial triage is therefore a filtering exercise focused on minimum bars for market, thesis fit, and founder quality \u2014 not a full evaluation. AI tools are increasingly used at this stage to assess pitch quality and market sizing."
            },
            {
                "q": "How long does Series A due diligence take, and what does it cost?",
                "a": "A standard Series A due diligence process takes 10\u201330 weeks and costs the company \xa365,000\u2013\xa3113,000 in external professional fees (legal, financial, and commercial combined). Management time is severely disrupted: CEOs and CFOs typically spend 30\u201350% of working hours responding to due diligence requests during this period. Companies that complete a structured Diligence Pack before investor conversations begin can compress this timeline by 4\u201315 weeks."
            },
            {
                "q": "What is a Diligence Pack, and how does it help with VC due diligence?",
                "a": "A Diligence Pack is a structured, evidence-linked document set covering all corporate categories a VC will scrutinise: governance, IP, cap table, financials, people, commercial contracts, and regulatory compliance. Prepared in advance, it means VC questions can be answered in days rather than weeks \u2014 reducing the risk of deal collapse, last-minute price chipping, and management distraction during the transaction. Diligentsia builds certified Diligence Packs with AI assistance at \xa31,000/year."
            },
            {
                "q": "How can companies improve their chances of passing VC due diligence?",
                "a": "The single most effective step is to complete a structured Diligence Pack before beginning investor conversations \u2014 not after term sheet. This surfaces issues early, when they can be fixed, rather than late, when they become deal-breakers. The key areas: IP formally assigned, cap table reconciled, founder agreements documented, financial records consistent with pitch narrative, and all key commercial relationships covered by signed contracts."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Do Venture Capital Firms Evaluate Early-Stage Companies in 2026?",
                "description": "Venture capital firms evaluate early-stage companies using a structured combination of market analysis, founder assessment, and corporate due diligence. This article explains each stage and how companies can prepare.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/vc/how-vcs-evaluate-early-stage-companies/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-vcs-evaluate-early-stage-companies.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "How do venture capital firms evaluate early-stage companies?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "VC evaluation covers two dimensions: the investment opportunity (market size, product, team \u2014 assessed through the pitch) and the corporate picture (governance, IP ownership, cap table, documentation \u2014 assessed through due diligence). Most founders prepare extensively for the first and underestimate the scrutiny applied to the second. Companies that arrive at IC or term sheet with documented governance gaps risk deal collapse or last-minute price reduction."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How many applications does a VC fund receive, and what proportion get funded?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Most early-stage VC firms receive between 500 and 1,500 applications per year and invest in fewer than 1%. Initial triage is therefore a filtering exercise focused on minimum bars for market, thesis fit, and founder quality \u2014 not a full evaluation. AI tools are increasingly used at this stage to assess pitch quality and market sizing."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long does Series A due diligence take, and what does it cost?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A standard Series A due diligence process takes 10\u201330 weeks and costs the company \xa365,000\u2013\xa3113,000 in external professional fees (legal, financial, and commercial combined). Management time is severely disrupted: CEOs and CFOs typically spend 30\u201350% of working hours responding to due diligence requests during this period. Companies that complete a structured Diligence Pack before investor conversations begin can compress this timeline by 4\u201315 weeks."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is a Diligence Pack, and how does it help with VC due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A Diligence Pack is a structured, evidence-linked document set covering all corporate categories a VC will scrutinise: governance, IP, cap table, financials, people, commercial contracts, and regulatory compliance. Prepared in advance, it means VC questions can be answered in days rather than weeks \u2014 reducing the risk of deal collapse, last-minute price chipping, and management distraction during the transaction. Diligentsia builds certified Diligence Packs with AI assistance at \xa31,000/year."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How can companies improve their chances of passing VC due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The single most effective step is to complete a structured Diligence Pack before beginning investor conversations \u2014 not after term sheet. This surfaces issues early, when they can be fixed, rather than late, when they become deal-breakers. The key areas: IP formally assigned, cap table reconciled, founder agreements documented, financial records consistent with pitch narrative, and all key commercial relationships covered by signed contracts."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "VC & Investors",
                        "item": "https://diligentsia.co.uk/vc/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Do Venture Capital Firms Evaluate Early-Stage Companies in 2026?",
                        "item": "https://diligentsia.co.uk/vc/how-vcs-evaluate-early-stage-companies/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "vc",
        "slug": "how-to-prepare-for-vc-due-diligence",
        "category": "VC & Investors",
        "title": "How to Prepare for VC Due Diligence in 2026",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-prepare-for-vc-due-diligence.jpg",
        "metaDescription": "A practical guide to preparing for venture capital due diligence \u2014 covering documentation, governance, IP, financials, and how to avoid the most common reasons deals collapse or valuations are chipped. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/",
        "bodyHtml": "<p>Preparing for VC due diligence means organising the corporate evidence that supports your investment narrative \u2014 before your investor's team asks for it. The companies that close faster and hold their valuations are the ones that do this work before term sheet, not after it.</p>\n<h2>Why preparation matters more than founders expect</h2>\n<p>Most founders spend months preparing their pitch: refining the deck, rehearsing the narrative, building the financial model. They spend far less time on the corporate documentation that due diligence will scrutinise. This is an asymmetric risk. A compelling pitch that fails due diligence costs you the deal and months of management time. A less polished pitch from a well-organised company often closes faster than expected.</p>\n<p>The most common reason VC deals collapse or valuations are chipped is not that the business is wrong. It is that something unexpected surfaces in due diligence \u2014 something the founders knew about, assumed was unimportant, or hoped would not be noticed. Preparation removes that risk by surfacing issues early, when you still have time to fix them.</p>\n<h2>Step 1: Build a structured data repository</h2>\n<p>Create a single, structured repository of all company documents \u2014 not a Dropbox folder, but a curated, organised document set with a clear version control system. Every document should be the current, final version. Superseded drafts and working documents should be removed or clearly labelled.</p>\n<p>The core document categories a VC will expect to see:</p>\n<ul><li><strong>Corporate:</strong> certificate of incorporation, articles of association, shareholder register, board minutes, cap table</li><li><strong>Financial:</strong> management accounts (last 3 years or since incorporation), financial projections, bank statements</li><li><strong>IP:</strong> all IP assignment agreements, patent applications, trademark registrations, software licences</li><li><strong>People:</strong> employment contracts for all key employees, contractor agreements, option pool documentation and individual option agreements</li><li><strong>Commercial:</strong> material customer and supplier contracts, partnership agreements, any signed LOIs</li><li><strong>Regulatory:</strong> any regulatory filings, compliance records, FCA permissions (where applicable)</li></ul>\n<h2>Step 2: Resolve the issues AI will find</h2>\n<p>AI tools are now standard in VC due diligence. They will analyse your document set and surface gaps, inconsistencies, and under-disclosed risks faster than any human reviewer. Before you share anything with an investor, run the same analysis yourself.</p>\n<p>The issues AI will find if you do not fix them first:</p>\n<ul><li>IP not formally assigned to the company \u2014 particularly common where founders or early contractors developed core IP before the company was incorporated</li><li>Cap table inconsistencies \u2014 shareholder register does not match option agreements or pitch deck statements</li><li>Missing founder agreements \u2014 equity splits undocumented, vesting schedules absent, or based on informal arrangements</li><li>Financial record gaps \u2014 management accounts missing, or projections not linked to documented assumptions</li><li>Contract gaps \u2014 key commercial relationships without signed agreements</li></ul>\n<h2>Step 3: Prepare your corporate governance record</h2>\n<p>VCs invest in companies, not just ideas. A company with clean governance is significantly easier to invest in, cheaper to due diligence, and more attractive at exit. Your governance record should include:</p>\n<ul><li>Board minutes from all board meetings, signed and filed</li><li>Written resolutions for all significant corporate decisions</li><li>A clean, current shareholder register \u2014 matching the cap table in your pitch deck</li><li>Signed option agreements for every option holder, matched to a current CSOP or EMI scheme record</li><li>Directors' service agreements or appointment letters for all current directors</li></ul>\n<h2>Step 4: Prepare investment-specific documents</h2>\n<p>In addition to the corporate record, a VC will expect transaction-specific documents. The earlier you prepare these, the faster due diligence will move:</p>\n<ul><li><strong>Directors' Questionnaires</strong> \u2014 detailed personal and professional background on each director</li><li><strong>Draft Warranty Disclosures</strong> \u2014 disclosures against the warranties you will give in the investment agreement. These require careful preparation and legal review.</li><li><strong>A confirmed use of proceeds</strong> \u2014 how the investment will be deployed, with timeline and milestones</li><li><strong>Data room</strong> \u2014 a structured, permission-controlled repository that investors and their lawyers can access without requiring access to your entire cloud storage</li></ul>\n<h2>Step 5: Control what investors see</h2>\n<p>As AI tools become standard in investor due diligence, there is increasing pressure on companies to open their cloud storage \u2014 Google Drive, Dropbox, SharePoint \u2014 directly to investor tools. This is a significant risk. Giving an investor unfiltered access to your entire cloud means they see everything: the superseded drafts, the internal discussions, the documents you would rather they contextualised before seeing.</p>\n<p>The alternative is a curated, structured data room with a defined permission layer. You control exactly which documents each party can see, and in what context. This is not about hiding information \u2014 it is about presenting your company correctly and ensuring investors are working from the right version of every document.</p>\n<h2>How long does it take?</h2>\n<p><strong>3 working days</strong> \u2014 minimum time to complete a structured Diligence Pack for a well-organised company using Diligentsia with AI assistance.</p>\n<p><strong>5\u201310 working days</strong> \u2014 typical time for an initial Diligence Pack build for most companies (with ongoing maintenance thereafter).</p>\n<p><strong>4\u201315 weeks</strong> \u2014 compression in Series A timeline for companies with a pre-prepared Diligence Pack, versus companies assembling documentation reactively.</p>\n<p><strong>\xa315,000\u2013\xa330,000</strong> \u2014 reduction in external professional fees for companies with structured preparation, versus those who are not prepared (Diligentsia Series A Fundraising Analysis, 2026).</p>\n<h2>Diligentsia pricing</h2>\n<p>| Plan | Price | Best for | Key benefit | |---|---|---|---| | Diligentsia Pro | \xa31,000/year | Companies preparing for VC funding | Full Diligence Pack, 60% AI pre-population, certified, investor-shareable | | Portfolio company rate | \xa3800/year | Portfolio companies via VC partner | All Pro features at portfolio rate | | Free Starter | Free | Early-stage companies not yet raising | Core governance modules, AI assistance, upgrade when ready |</p>\n<p><strong>Ready to prepare your Diligence Pack?</strong> <a href=\"/vc/\">diligentsia.co.uk/vc/</a></p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "What is a VC Diligence Pack?",
                "a": "A Diligence Pack is a structured, evidence-linked document set covering all corporate categories a VC will scrutinise in due diligence: governance, IP, cap table, financials, people, commercial contracts, and regulatory compliance. Prepared before investor conversations begin, it means VC questions can be answered in days rather than weeks \u2014 reducing the risk of deal collapse, price chipping, and management distraction. Diligentsia builds certified Diligence Packs with AI assistance at \xa31,000/year."
            },
            {
                "q": "What are the most common reasons VC deals collapse or valuations get chipped?",
                "a": "The most common causes are corporate governance gaps surfacing in due diligence: IP not formally assigned to the company; cap table inconsistencies between the shareholder register and option agreements; undocumented or informal founder arrangements; financial record gaps or inconsistencies with the pitch deck; and key commercial relationships without signed contracts. These issues were known to the founders in most cases \u2014 but not fixed because they were assumed unimportant until they became deal-breakers."
            },
            {
                "q": "How do I prepare for VC due diligence quickly?",
                "a": "The fastest approach is to use an AI-assisted platform to auto-populate your Diligence Pack from documents you already hold. Diligentsia's AI (Clarence) pre-populates approximately 60% of standard due diligence modules from existing company documents, with human review mandatory on every answer. A well-organised company can complete an initial certified pack in as little as 3 working days. The investment is \xa31,000/year \u2014 less than one day of legal fees."
            },
            {
                "q": "Why should I prepare a Diligence Pack before raising, not after term sheet?",
                "a": "Preparation after term sheet is reactive \u2014 by the time issues surface, the deal timeline is already extended and the investor may use gaps to justify a price reduction. Preparation before investor conversations means issues are found and fixed before they become visible to investors. It also signals organisational maturity: companies that arrive at IC with a structured pack are significantly more likely to close at their target valuation."
            },
            {
                "q": "What is the portfolio company rate for Diligentsia?",
                "a": "Diligentsia offers a portfolio company rate of \xa3800/year \u2014 compared to the standard Pro price of \xa31,000/year \u2014 for companies joining through a VC or accelerator partner. Ask your VC or accelerator whether they are a Diligentsia partner, or contact us directly at [diligentsia.co.uk/vc/](https://diligentsia.co.uk/vc/)"
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How to Prepare for VC Due Diligence in 2026",
                "description": "A practical guide to preparing for venture capital due diligence \u2014 covering documentation, governance, IP, financials, and how to avoid the most common reasons deals collapse or valuations are chipped.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-prepare-for-vc-due-diligence.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is a VC Diligence Pack?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A Diligence Pack is a structured, evidence-linked document set covering all corporate categories a VC will scrutinise in due diligence: governance, IP, cap table, financials, people, commercial contracts, and regulatory compliance. Prepared before investor conversations begin, it means VC questions can be answered in days rather than weeks \u2014 reducing the risk of deal collapse, price chipping, and management distraction. Diligentsia builds certified Diligence Packs with AI assistance at \xa31,000/year."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What are the most common reasons VC deals collapse or valuations get chipped?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most common causes are corporate governance gaps surfacing in due diligence: IP not formally assigned to the company; cap table inconsistencies between the shareholder register and option agreements; undocumented or informal founder arrangements; financial record gaps or inconsistencies with the pitch deck; and key commercial relationships without signed contracts. These issues were known to the founders in most cases \u2014 but not fixed because they were assumed unimportant until they became deal-breakers."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How do I prepare for VC due diligence quickly?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The fastest approach is to use an AI-assisted platform to auto-populate your Diligence Pack from documents you already hold. Diligentsia's AI (Clarence) pre-populates approximately 60% of standard due diligence modules from existing company documents, with human review mandatory on every answer. A well-organised company can complete an initial certified pack in as little as 3 working days. The investment is \xa31,000/year \u2014 less than one day of legal fees."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Why should I prepare a Diligence Pack before raising, not after term sheet?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Preparation after term sheet is reactive \u2014 by the time issues surface, the deal timeline is already extended and the investor may use gaps to justify a price reduction. Preparation before investor conversations means issues are found and fixed before they become visible to investors. It also signals organisational maturity: companies that arrive at IC with a structured pack are significantly more likely to close at their target valuation."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the portfolio company rate for Diligentsia?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Diligentsia offers a portfolio company rate of \xa3800/year \u2014 compared to the standard Pro price of \xa31,000/year \u2014 for companies joining through a VC or accelerator partner. Ask your VC or accelerator whether they are a Diligentsia partner, or contact us directly at diligentsia.co.uk/vc/"
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "VC & Investors",
                        "item": "https://diligentsia.co.uk/vc/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How to Prepare for VC Due Diligence in 2026",
                        "item": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/"
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "HowTo",
                "name": "How to Prepare for VC Due Diligence in 2026",
                "step": [
                    {
                        "@type": "HowToStep",
                        "position": 1,
                        "name": "Why preparation matters more than founders expect",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-1"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 2,
                        "name": "Step 1: Build a structured data repository",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-2"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 3,
                        "name": "Step 2: Resolve the issues AI will find",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-3"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 4,
                        "name": "Step 3: Prepare your corporate governance record",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-4"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 5,
                        "name": "Step 4: Prepare investment-specific documents",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-5"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 6,
                        "name": "Step 5: Control what investors see",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-6"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 7,
                        "name": "How long does it take?",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-7"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 8,
                        "name": "Diligentsia pricing",
                        "url": "https://diligentsia.co.uk/vc/how-to-prepare-for-vc-due-diligence/#step-8"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "ceo",
        "slug": "what-do-investors-check-in-due-diligence",
        "category": "Companies",
        "title": "What Do Investors Actually Check in Due Diligence \u2014 and What Does It Cost to Prepare? (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-do-investors-check-in-due-diligence.jpg",
        "metaDescription": "Investment due diligence covers far more than the pitch. This article explains what investors examine, why most companies fail at the evidence stage, and what preparation actually costs in 2026. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/ceo/what-do-investors-check-in-due-diligence/",
        "bodyHtml": "<p>Investors \u2014 whether angels, VCs, or family offices \u2014 receive hundreds of applications. They invest in a handful. The companies that close rounds are not always the strongest businesses: they are the best-prepared ones. A structured diligence pack signals that you understand what investors need, reduces their risk, and answers the questions they have not asked yet. That is the difference between interest and a term sheet.</p>\n<h2>The two things investors are actually checking</h2>\n<p>Every investment decision involves two distinct evaluation tracks running simultaneously. The first is the investment case: market opportunity, product differentiation, team quality, commercial traction. This is what the pitch addresses. The second is the corporate picture: governance structure, IP ownership, cap table accuracy, employment documentation, regulatory compliance, and whether the financial record supports the narrative in the deck.</p>\n<p>Most founders invest months in the pitch and days \u2014 if that \u2014 on the corporate picture. This is an asymmetric mistake. A compelling pitch that fails due diligence costs the deal entirely. A well-prepared corporate record is what converts investor interest into a signed term sheet.</p>\n<h2>The odds \u2014 and what shifts them</h2>\n<p><strong>&lt; 1%</strong> of unsolicited funding applications to VC firms result in investment. (PAR Equity benchmark: 1,000\u20131,500 applications per year, approximately 10 investments.)</p>\n<p><strong>60%</strong> of a standard due diligence module set can be auto-populated by Diligentsia's AI (Clarence) from documents a company already holds. Human review is mandatory on every answer.</p>\n<p><strong>3 days</strong> \u2014 minimum time for a well-organised company to complete a certified Diligence Pack using Diligentsia Pro with AI assistance.</p>\n<p>The companies that shift the odds in their favour are not the ones with the best decks. They are the ones who arrive at investor conversations with structured, verified evidence ready \u2014 so the answer to every due diligence question is already prepared. Investors notice. The conversation is different when you are not scrambling.</p>\n<h2>What investors check: the corporate picture in detail</h2>\n<ul><li><strong>IP ownership:</strong> has all intellectual property been formally assigned to the company? Employee and contractor IP assignment agreements are the most common gap at early stage.</li><li><strong>Cap table accuracy:</strong> does the current cap table match the shareholder register? Discrepancies between option agreements and the corporate record are a frequent due diligence flag.</li><li><strong>Founder arrangements:</strong> are co-founder equity splits documented? Are vesting schedules in place? Informal arrangements that worked at the start become material issues at investment.</li><li><strong>Financial record consistency:</strong> do the management accounts match the pitch deck narrative? Are financial projections built from documented assumptions?</li><li><strong>Governance documentation:</strong> are board minutes and written resolutions in place? Is the company governed, or just run?</li><li><strong>Employment and contractor documentation:</strong> are all key employees and contractors on signed agreements? Are IP assignment clauses in place?</li><li><strong>Regulatory compliance:</strong> for regulated sectors, is there a documented record of compliance decisions?</li></ul>\n<h2>What \"structured preparation\" means in practice</h2>\n<p>Structured preparation does not mean hiring a law firm to produce a data room. It means organising the documents your company already holds into a coherent, evidence-linked record \u2014 one that can be shared with investors at speed, with controlled access. The difference between a prepared company and an unprepared one is not the quality of the underlying business. It is the quality of the evidence that supports it.</p>\n<p>Diligentsia is a structured AI platform \u2014 not a chatbot. It operates on your actual documents, links every answer to its source evidence, and requires you to review and sign off every response. The result is a Diligence Pack that investors trust: not because AI wrote it, but because you verified it.</p>\n<h3>Investment readiness preparation options compared</h3>\n<p>| Option | Cost | Permanence | Reusable? | |---|---|---|---| | External due diligence firm | \xa310,000\u2013\xa350,000 per transaction | One transaction only | No | | Virtual Data Room (VDR) | \xa3300\u2013\xa3800/month | Active while subscription live | Partially | | Diligentsia Pro (AI-assisted) | \xa31,000/year | Permanent, compounding asset | Yes \u2014 every future transaction | | No preparation | \xa30 upfront | n/a | No \u2014 rework each time |</p>\n<h2>The InvestorMatch network</h2>\n<p><strong>700+</strong> UK investors in the Diligentsia InvestorMatch database \u2014 angels, angel networks, VCs, and PE firms.</p>\n<p><strong>40+</strong> VC firms integrated into the platform as of June 2026.</p>\n<p>Once you reach Gold certification, InvestorMatch compares your company profile against the investor database and generates a scored Fit Report for each match. The best matches get a 1-click introduction request. You control who sees your pack. You choose who to connect with.</p>\n<h2>What Diligentsia costs</h2>\n<p>| Plan | Price | Best for | What's included | |---|---|---|---| | Free | Free | Companies not yet raising | Investment readiness checklist, KPI suggestions, InvestorMatch fit score only | | Lite | \xa3100/year | Early-stage companies | Business Audit (20 sections), Data Repository (20 sections) | | Pro | \xa31,000/year | Companies actively preparing to raise | Full platform: all modules, AI reports, InvestorMatch introductions, Diligence Pack, certification | | Portfolio Pro | \xa3800/year | Companies via advisor or investor | All Pro features at discounted rate |</p>\n<p>A year of Diligentsia Pro costs less than a day of a fractional CFO \u2014 and far less than the cost of a failed fundraise.</p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "What do investors check during due diligence?",
                "a": "Investors check two things: the investment case (market, product, team \u2014 addressed by the pitch) and the corporate picture (IP ownership, cap table, governance, financials, employment documentation, regulatory compliance \u2014 addressed by due diligence). Most founders prepare extensively for the pitch and underestimate the corporate picture. Issues in the corporate picture are the most common cause of deals collapsing or valuations being chipped at close."
            },
            {
                "q": "What is a Diligence Pack, and why do I need one?",
                "a": "A Diligence Pack is a structured, evidence-linked document set that covers all the corporate categories an investor will examine. It is prepared before investor conversations begin \u2014 not after term sheet. A pre-prepared pack means investor questions can be answered in days rather than weeks, signals organisational maturity, and removes the risk of late-stage surprises that collapse deals or reduce valuations. Diligentsia builds certified Diligence Packs with AI assistance at \xa31,000/year."
            },
            {
                "q": "What does investment readiness preparation cost?",
                "a": "Traditional externally managed due diligence costs \xa310,000\u2013\xa350,000 per transaction. Virtual Data Rooms cost \xa3300\u2013\xa3800/month. AI-assisted platforms like Diligentsia have reduced this to \xa31,000/year \u2014 producing a permanent, reusable asset rather than a one-transaction document set. A well-organised company can complete an initial certified pack in as little as 3 working days."
            },
            {
                "q": "How does 60% AI autofill work?",
                "a": "Diligentsia's AI (Clarence) analyses the documents you already hold \u2014 financial statements, contracts, board papers, IP filings, company filings \u2014 and pre-populates approximately 60% of standard due diligence modules. Every AI-generated answer is linked to its source document and requires your explicit review and sign-off before it can be shared with investors. The remaining 40% is completed by you, typically in areas where documentation gaps exist."
            },
            {
                "q": "How do I get matched with investors on InvestorMatch?",
                "a": "Once your Diligentsia pack reaches Gold certification, InvestorMatch compares your company profile against 700+ UK investors in the database and generates a scored Fit Report for each match. The best matches receive a 1-click introduction request. You control which investors can see your pack and decide who to connect with. Start at [diligentsia.co.uk/company/](https://diligentsia.co.uk/company/)"
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "What Do Investors Actually Check in Due Diligence \u2014 and What Does It Cost to Prepare? (2026)",
                "description": "Investment due diligence covers far more than the pitch. This article explains what investors examine, why most companies fail at the evidence stage, and what preparation actually costs in 2026.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/ceo/what-do-investors-check-in-due-diligence/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-do-investors-check-in-due-diligence.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What do investors check during due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Investors check two things: the investment case (market, product, team \u2014 addressed by the pitch) and the corporate picture (IP ownership, cap table, governance, financials, employment documentation, regulatory compliance \u2014 addressed by due diligence). Most founders prepare extensively for the pitch and underestimate the corporate picture. Issues in the corporate picture are the most common cause of deals collapsing or valuations being chipped at close."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is a Diligence Pack, and why do I need one?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A Diligence Pack is a structured, evidence-linked document set that covers all the corporate categories an investor will examine. It is prepared before investor conversations begin \u2014 not after term sheet. A pre-prepared pack means investor questions can be answered in days rather than weeks, signals organisational maturity, and removes the risk of late-stage surprises that collapse deals or reduce valuations. Diligentsia builds certified Diligence Packs with AI assistance at \xa31,000/year."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What does investment readiness preparation cost?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Traditional externally managed due diligence costs \xa310,000\u2013\xa350,000 per transaction. Virtual Data Rooms cost \xa3300\u2013\xa3800/month. AI-assisted platforms like Diligentsia have reduced this to \xa31,000/year \u2014 producing a permanent, reusable asset rather than a one-transaction document set. A well-organised company can complete an initial certified pack in as little as 3 working days."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does 60% AI autofill work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Diligentsia's AI (Clarence) analyses the documents you already hold \u2014 financial statements, contracts, board papers, IP filings, company filings \u2014 and pre-populates approximately 60% of standard due diligence modules. Every AI-generated answer is linked to its source document and requires your explicit review and sign-off before it can be shared with investors. The remaining 40% is completed by you, typically in areas where documentation gaps exist."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How do I get matched with investors on InvestorMatch?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Once your Diligentsia pack reaches Gold certification, InvestorMatch compares your company profile against 700+ UK investors in the database and generates a scored Fit Report for each match. The best matches receive a 1-click introduction request. You control which investors can see your pack and decide who to connect with. Start at diligentsia.co.uk/company/"
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Companies",
                        "item": "https://diligentsia.co.uk/ceo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "What Do Investors Actually Check in Due Diligence \u2014 and What Does It Cost to Prepare? (2026)",
                        "item": "https://diligentsia.co.uk/ceo/what-do-investors-check-in-due-diligence/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "ceo",
        "slug": "how-ai-is-changing-due-diligence-growth-stage",
        "category": "Companies",
        "title": "How Is AI Changing Due Diligence for Growth-Stage Companies in 2026?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-ai-is-changing-due-diligence-growth-stage.jpg",
        "metaDescription": "AI is reshaping how growth-stage companies prepare for investor due diligence. This article explains what has changed, what growth-stage investors now expect, and how the best-prepared companies are responding. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/ceo/how-ai-is-changing-due-diligence-growth-stage/",
        "bodyHtml": "<p>Growth-stage companies face a structural funding problem that AI has made both harder and easier to navigate. Harder, because AI tools deployed by investors now surface documentation gaps, governance inconsistencies, and under-disclosed risks faster than human analysts ever did. Easier, because the same AI that powers investor scrutiny can also be used to prepare \u2014 organising the evidence that investors will look for before they ask for it.</p>\n<h2>The growth valley \u2014 and why governance gaps cause it</h2>\n<p>Growth-stage companies occupy an awkward position in the funding market. Angel syndicates are typically too small for the \xa3500k\u2013\xa35m rounds these companies need. Institutional VCs want proof of governance, metrics, and team structure before they engage in serious diligence. The result is a valley that is not caused by the quality of the business \u2014 it is caused by the quality of the evidence that supports it.</p>\n<p><strong>64%</strong> of UK scaleups never formalise governance \u2014 even at growth stage. <em>(ScaleUp Institute, UK Scaleup Report)</em></p>\n<p>The 64% figure represents companies with commercial traction, a growing team, and real customers \u2014 that have not documented their governance decisions, formalised their board structure, or built the KPI framework that growth investors need to see. This is not a business quality issue. It is an evidence quality issue. And it is fixable.</p>\n<h2>What growth-stage investors now look for</h2>\n<p>The criteria for growth-stage investment have become more rigorous as AI tools make it faster to identify companies with governance gaps. A Series A investor deploying \xa32M\u2013\xa310M will expect to see, before serious due diligence begins:</p>\n<ul><li>A structured data repository \u2014 not files spread across cloud folders and email threads, but a curated, version-controlled document set</li><li>A KPI framework \u2014 the metrics that matter to growth investors, tracked consistently and presented in board-ready format</li><li>Management information pack \u2014 board minutes, written resolutions, and MI structure that shows the company is governed, not just run</li><li>Clean IP and employment documentation \u2014 all agreements signed, all IP assigned, option schemes documented and compliant</li><li>A credible go-to-market record \u2014 documented route to market, competitive positioning, and customer contract evidence</li></ul>\n<h2>Why scattered data fails AI-powered due diligence</h2>\n<p>AI tools used in investor due diligence are not searching for what is there \u2014 they are surfacing what is missing. A company whose documents are spread across a shared Google Drive, three email chains, and someone's local folder does not present well to an AI system. The AI reports gaps, inconsistencies, and unverified assertions. The investor sees risk \u2014 not because the business is risky, but because the evidence is disorganised.</p>\n<blockquote><p><em>\"The data organisation piece is massive \u2014 because you can't just drop LLMs on top of data that's all over the place. Your output's going to reflect it.\"</em></p><p>\u2014 Investment Manager, early-stage fund (May 2026)</p></blockquote>\n<p>The companies that navigate AI-powered due diligence well are those that have done the data organisation work before the investor's tools arrive. This is not a one-off exercise \u2014 it is a continuous practice. The companies that build and maintain a structured evidence base are permanently more fundable than those that scramble when investor interest arrives.</p>\n<h2>What AI can do for growth-stage companies</h2>\n<p>The same AI that investors use to scrutinise companies can be used by companies to prepare. Diligentsia's AI (Clarence) auto-populates approximately 60% of growth readiness modules from documents the company already holds \u2014 management accounts, contracts, board papers, company filings. Every answer is linked to source evidence and requires human review before it can be shared.</p>\n<p>The practical effect: a company can complete a structured growth readiness assessment in days rather than months \u2014 surfacing its own governance gaps before an investor's AI does. Red, amber, and green scoring shows exactly which areas need attention before the next funding conversation.</p>\n<blockquote><p><em>\"Despite the bug, the tool was highly effective for consolidating business information into a structured document in under a day.\"</em></p><p>\u2014 Founder, AI startup in Ordnance Survey accelerator (March 2026)</p></blockquote>\n<h2>The Control Room effect</h2>\n<p>Companies that build a structured evidence base do not just perform better in due diligence \u2014 they operate better. Board meetings are more structured. Strategic decisions are better documented. New advisors, CFOs, and non-executives can onboard faster. The structured governance record that makes a company fundable also makes it a better-run business.</p>\n<blockquote><p><em>\"The Control Room concept significantly increases a business's perceived value to investors.\"</em></p><p>\u2014 Fractional advisor, LionSwan / Catalyst Growth (May 2026)</p></blockquote>\n<h2>The Diligentsia Growth Ready platform</h2>\n<p>Diligentsia's Growth Ready modules address the specific gaps growth-stage investors identify:</p>\n<ul><li>Business Audit \u2014 20 sections covering every business function</li><li>Growth Readiness Report \u2014 investor-grade assessment of your growth stage</li><li>KPI Framework \u2014 track and present the metrics that matter to follow-on investors</li><li>Management Information Pack \u2014 board-ready MI structure</li><li>Market Opportunity, Competitive Advantage, and Route to Market Reports \u2014 AI-generated from your own data</li><li>HealthBoost Modules (\xd720) \u2014 targeted improvement modules across all business functions</li><li>InvestorMatch \u2014 700+ UK investors, with growth-stage filters</li></ul>\n<p><strong>Diligentsia Pro: \xa31,000/year.</strong> Start at <a href=\"/company/\">diligentsia.co.uk/company/</a></p>",
        "peopleAlsoAsk": [
            {
                "q": "Why is growth-stage funding harder than seed?",
                "a": "Growth-stage funding falls in a structural valley: angel syndicates are typically too small for the rounds these companies need, while institutional VCs expect proof of governance and metrics that many growth-stage companies have not yet formalised. 64% of UK scaleups never formalise governance, even at growth stage (ScaleUp Institute). The gap is not between investor appetite and company quality \u2014 it is between what investors need to see as evidence and what most growth-stage companies have assembled."
            },
            {
                "q": "What does a growth-stage investor's data room check look like?",
                "a": "Growth-stage investors use AI tools that surface documentation gaps, cross-document inconsistencies, and under-disclosed risks faster than human analysts. A data room that would have passed muster two years ago may now generate a long list of AI-identified flags. Investors now expect a structured, curated evidence set \u2014 not a dump of raw cloud storage."
            }
        ],
        "faqs": [
            {
                "q": "What do growth-stage investors look for before a Series A?",
                "a": "Growth-stage investors expect: commercial traction (typically \xa3500k\u2013\xa32M ARR for SaaS), a structured data repository, a KPI framework tracking the right metrics, clean corporate governance (board minutes, resolutions, IP assigned, option schemes documented), a management information pack, and the ability to respond to due diligence requests in days rather than weeks."
            },
            {
                "q": "How is AI changing investor due diligence for companies?",
                "a": "AI tools deployed by investors now surface documentation gaps, governance inconsistencies, and under-disclosed risks faster than human analysts. A company with disorganised cloud storage presents as higher risk under AI scrutiny \u2014 not because the business is risky, but because the evidence is disorganised. The practical response: organise and structure your evidence base before investors' AI tools do it for you."
            },
            {
                "q": "What is a Growth Readiness assessment?",
                "a": "A Growth Readiness assessment is a structured audit of every business dimension a growth-stage investor will examine: governance, financials, IP, people, commercial traction, KPI framework, and board structure. Diligentsia's AI auto-populates approximately 60% of assessment responses from documents the company already holds, with human review mandatory on every answer. Red/amber/green scoring shows exactly which areas need attention before the next funding conversation."
            },
            {
                "q": "How does Diligentsia help growth-stage companies get funded?",
                "a": "Diligentsia helps in three ways: (1) structuring the evidence base so AI-powered investor tools find a well-organised record rather than gaps; (2) identifying governance gaps before investors do, with time to fix them; and (3) connecting prepared companies to 700+ UK investors via InvestorMatch, with growth-stage filters to identify the right VCs and angel syndicates. Diligentsia Pro is \xa31,000/year."
            },
            {
                "q": "What is the Diligentsia Control Room?",
                "a": "The Control Room is Diligentsia's unified dashboard for a company's full evidence base: all documents, all module responses, all certifications, all investor connections. It replaces scattered cloud storage with a single, structured, searchable record that improves continuously. Companies using it report better board meetings, faster advisor onboarding, and materially improved investor confidence."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Is AI Changing Due Diligence for Growth-Stage Companies in 2026?",
                "description": "AI is reshaping how growth-stage companies prepare for investor due diligence. This article explains what has changed, what growth-stage investors now expect, and how the best-prepared companies are responding.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/ceo/how-ai-is-changing-due-diligence-growth-stage/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-ai-is-changing-due-diligence-growth-stage.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Why is growth-stage funding harder than seed?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Growth-stage funding falls in a structural valley: angel syndicates are typically too small for the rounds these companies need, while institutional VCs expect proof of governance and metrics that many growth-stage companies have not yet formalised. 64% of UK scaleups never formalise governance, even at growth stage (ScaleUp Institute). The gap is not between investor appetite and company quality \u2014 it is between what investors need to see as evidence and what most growth-stage companies have assembled."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What does a growth-stage investor's data room check look like?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Growth-stage investors use AI tools that surface documentation gaps, cross-document inconsistencies, and under-disclosed risks faster than human analysts. A data room that would have passed muster two years ago may now generate a long list of AI-identified flags. Investors now expect a structured, curated evidence set \u2014 not a dump of raw cloud storage."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What do growth-stage investors look for before a Series A?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Growth-stage investors expect: commercial traction (typically \xa3500k\u2013\xa32M ARR for SaaS), a structured data repository, a KPI framework tracking the right metrics, clean corporate governance (board minutes, resolutions, IP assigned, option schemes documented), a management information pack, and the ability to respond to due diligence requests in days rather than weeks."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How is AI changing investor due diligence for companies?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "AI tools deployed by investors now surface documentation gaps, governance inconsistencies, and under-disclosed risks faster than human analysts. A company with disorganised cloud storage presents as higher risk under AI scrutiny \u2014 not because the business is risky, but because the evidence is disorganised. The practical response: organise and structure your evidence base before investors' AI tools do it for you."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is a Growth Readiness assessment?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A Growth Readiness assessment is a structured audit of every business dimension a growth-stage investor will examine: governance, financials, IP, people, commercial traction, KPI framework, and board structure. Diligentsia's AI auto-populates approximately 60% of assessment responses from documents the company already holds, with human review mandatory on every answer. Red/amber/green scoring shows exactly which areas need attention before the next funding conversation."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does Diligentsia help growth-stage companies get funded?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Diligentsia helps in three ways: (1) structuring the evidence base so AI-powered investor tools find a well-organised record rather than gaps; (2) identifying governance gaps before investors do, with time to fix them; and (3) connecting prepared companies to 700+ UK investors via InvestorMatch, with growth-stage filters to identify the right VCs and angel syndicates. Diligentsia Pro is \xa31,000/year."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the Diligentsia Control Room?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The Control Room is Diligentsia's unified dashboard for a company's full evidence base: all documents, all module responses, all certifications, all investor connections. It replaces scattered cloud storage with a single, structured, searchable record that improves continuously. Companies using it report better board meetings, faster advisor onboarding, and materially improved investor confidence."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Companies",
                        "item": "https://diligentsia.co.uk/ceo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Is AI Changing Due Diligence for Growth-Stage Companies in 2026?",
                        "item": "https://diligentsia.co.uk/ceo/how-ai-is-changing-due-diligence-growth-stage/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "ceo",
        "slug": "how-to-prepare-for-exit-due-diligence",
        "category": "Companies",
        "title": "How Do Companies Prepare for Exit Due Diligence in 2026?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-prepare-for-exit-due-diligence.jpg",
        "metaDescription": "A practical guide to preparing for buyer due diligence at exit \u2014 covering the four most common value destroyers, how to build a Vendor Diligence Pack, and how to protect your valuation before the process starts. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/",
        "bodyHtml": "<p>Preparing for exit due diligence means identifying and fixing the issues that buyers will use to reprice your deal \u2014 before their team finds them. The companies that exit at full value are not the ones with the highest EBITDA. They are the ones that arrive at the process with a clean corporate record and no surprises.</p>\n<h2>The cost of being unprepared at exit</h2>\n<p><strong>\xa3150,000\u2013\xa3400,000</strong> \u2014 typical adviser fees for a standard SME exit transaction (legal, financial, and commercial due diligence combined).</p>\n<p><strong>8\u201312 weeks</strong> \u2014 time a buyer's due diligence team will typically spend in your business \u2014 looking for everything they can use to reprice the deal.</p>\n<p><strong>\xa3600,000</strong> \u2014 value of a 10% improvement in exit preparation on a \xa36M sale. Against a platform cost of \xa31,000/year, this is one of the highest-return decisions a founder can make.</p>\n<p>The real cost of being unprepared is not the adviser fees \u2014 significant as they are. It is the gap between the price you expect and the price you accept, after 8 weeks of due diligence have surfaced everything the buyer's team can use against you. Every issue they find \u2014 unassigned IP, incomplete contracts, governance gaps, key-person risk \u2014 becomes leverage to reduce the price. Preparation removes that leverage.</p>\n<h2>The four most common exit value destroyers</h2>\n<h3>1. IP not formally assigned to the company</h3>\n<p>Founders who developed code, patents, or brand assets before incorporation \u2014 or through contractors without IP assignment clauses \u2014 face material valuation risk when buyers discover that IP ownership is unclear. This is the single most common structural issue in SME exits and the hardest to fix quickly once due diligence has started. Diligentsia's IP audit surfaces this issue in the first week of preparation \u2014 not the first week of due diligence.</p>\n<h3>2. Key customer concentration</h3>\n<p>If your top three customers represent more than 50% of revenue, buyers apply a risk discount of 20\u201340% on your comparable multiple \u2014 regardless of trading quality. This is a structural issue, not a trading quality issue. Documenting customer contracts, demonstrating renewal history, and flagging concentration risk proactively (rather than letting the buyer find it) allows you to frame the narrative rather than respond to it.</p>\n<h3>3. Governance gaps \u2014 missing board minutes and shareholder resolutions</h3>\n<p>A buyer's legal team will ask for board minutes, shareholder resolutions, and documented records of significant management decisions. Absence is not just an inconvenience \u2014 it triggers extended legal review, raises questions about undisclosed liabilities, and gives buyers grounds to reprice. The governance record that was informal at seed stage becomes a deal-protection issue at exit.</p>\n<h3>4. Founder dependency visible in the data room</h3>\n<p>If the business cannot demonstrate it runs independently of the founder \u2014 through documented processes, a functioning management team, and evidence of delegated decision-making \u2014 the buyer will price in the departure risk. This typically manifests as an earnout requirement (deferring a portion of the price to post-completion performance) or a direct reduction in the headline multiple.</p>\n<h2>Step 1: Build your permanent data room</h2>\n<p>Connect your existing documents to a structured, permanent repository \u2014 Google Drive, SharePoint, Dropbox, OneDrive, or direct upload. Diligentsia indexes and structures them automatically. The result is a permanent, searchable data repository that is always current \u2014 not a 6-week assembly project triggered by buyer interest.</p>\n<p>Core document categories: Corporate (incorporation, articles, shareholder register, board minutes, cap table); Financial (management accounts, projections); IP (assignment agreements, patents, trademarks); People (employment and contractor agreements, option documentation); Commercial (material contracts, customer agreements); Regulatory.</p>\n<h2>Step 2: Audit yourself before the buyer does</h2>\n<p>Diligentsia's Business Audit and Exit Readiness module cover every dimension a buyer's due diligence team will examine: legal structure, IP, contracts, employment, governance, financials, and key-person risk. Red flags appear in your dashboard \u2014 with remediation guidance \u2014 not in the buyer's report.</p>\n<p>The critical difference between finding issues in your own audit and the buyer finding them: when you find them, you have time to fix them. When the buyer finds them, they become negotiating leverage.</p>\n<h2>Step 3: Generate your Vendor Diligence Pack</h2>\n<p>A Vendor Diligence Pack is a structured, certified document set produced by the seller before the buyer's due diligence process begins. It demonstrates proactive transparency, signals a well-organised business, and changes the dynamic of the transaction.</p>\n<p>Buyers who receive a pre-prepared Vendor Diligence Pack spend less time on information requests and more time on valuation \u2014 which is exactly the dynamic you want. The conversation shifts from \"what are you hiding?\" to \"what is this business worth?\"</p>\n<h2>Step 4: Document and mitigate founder dependency</h2>\n<p>Diligentsia's Exit Readiness module includes a Founder Dependency Assessment: a structured analysis of key-person risk, with a documented remediation plan. This means you control the narrative \u2014 presenting an honest assessment with a clear mitigation story \u2014 rather than leaving the buyer to draw their own conclusions.</p>\n<h2>Step 5: Control what the buyer sees</h2>\n<p>Some buyers now request direct access to company cloud storage during due diligence. This exposes you to unfiltered review of superseded documents, internal communications, and records never intended for buyer scrutiny. A structured, permission-controlled data room gives you control: you determine what each party can see, and in what context.</p>\n<h2>How long does exit preparation take?</h2>\n<p><strong>3 working days</strong> \u2014 minimum time for a well-organised company to complete an initial certified Diligence Pack using Diligentsia Pro with AI assistance.</p>\n<p><strong>5\u201310 working days</strong> \u2014 typical time for an initial pack build for most companies, with ongoing maintenance thereafter.</p>\n<p>The earlier you start, the more remediation time you have \u2014 and the stronger your pack when a buyer appears. Diligentsia is a continuous exit preparation platform, not a one-off data room builder. Every month you use it, the pack gets stronger.</p>\n<h2>Diligentsia Exit Ready pricing</h2>\n<p>| Plan | Price | Best for | Key benefit | |---|---|---|---| | Free | Free | Companies not yet planning exit | Exit readiness checklist, basic audit modules | | Lite | \xa3100/year | Early-stage exit preparation | Business Audit (20 sections), Exit Readiness Report | | Pro | \xa31,000/year | Full exit preparation | All exit modules, Warranty Disclosures, Directors' Questionnaires, AI reports, Vendor Diligence Pack, Bronze/Silver/Gold certification |</p>\n<p>At \xa31,000/year, Diligentsia Pro costs less than one hour of M&amp;A legal advice.</p>\n<p><strong>Ready to protect your exit valuation?</strong> <a href=\"/company/\">diligentsia.co.uk/company/</a></p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "How do companies prepare for exit due diligence?",
                "a": "The most effective approach is to start preparation well before a buyer appears \u2014 not after a term sheet or letter of intent. This means: building a permanent, structured data repository; auditing your own corporate picture (IP, governance, contracts, founder dependency) with the same scrutiny a buyer will apply; generating a Vendor Diligence Pack that pre-answers buyer questions; and controlling what buyers see through a structured, permission-controlled data room rather than raw cloud access."
            },
            {
                "q": "What are the most common causes of exit valuation being chipped?",
                "a": "The four most common causes are: (1) IP not formally assigned to the company \u2014 especially common where founders or contractors developed core assets before incorporation; (2) key customer concentration above 50% of revenue \u2014 typically triggers a 20\u201340% risk discount; (3) missing governance documentation (board minutes, shareholder resolutions) \u2014 gives buyers grounds to extend timelines and reprice; and (4) founder dependency visible in the data room \u2014 typically results in earnout requirements or a direct reduction in the headline multiple."
            },
            {
                "q": "What is a Vendor Diligence Pack?",
                "a": "A Vendor Diligence Pack is a structured, certified document set produced by the seller before the buyer's due diligence process begins. It is the seller's equivalent of a buyer's due diligence report \u2014 demonstrating proactive transparency and presenting the business in its best light. Buyers who receive one spend less time on information requests and more time on valuation. Diligentsia produces certified Vendor Diligence Packs with AI assistance at \xa31,000/year."
            },
            {
                "q": "How long does exit due diligence take?",
                "a": "A buyer's due diligence team typically spends 8\u201312 weeks in a business, reviewing all corporate documentation, conducting financial review, and assessing commercial risk. Adviser fees for a standard SME exit transaction typically run to \xa3150,000\u2013\xa3400,000. Companies with a pre-prepared Vendor Diligence Pack compress the buyer's review timeline significantly."
            },
            {
                "q": "Why should I prepare for exit before a buyer appears?",
                "a": "The best time to fix a governance gap, unassigned IP, or missing contract is before a buyer's team finds it \u2014 not after. Once due diligence has started, every issue the buyer finds becomes negotiating leverage. Fixing issues under buyer pressure is more expensive, more disruptive, and less effective than fixing them proactively. The preparation cost (\xa31,000/year on Diligentsia Pro) is a fraction of the value protection it delivers."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Do Companies Prepare for Exit Due Diligence in 2026?",
                "description": "A practical guide to preparing for buyer due diligence at exit \u2014 covering the four most common value destroyers, how to build a Vendor Diligence Pack, and how to protect your valuation before the process starts.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-prepare-for-exit-due-diligence.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "How do companies prepare for exit due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most effective approach is to start preparation well before a buyer appears \u2014 not after a term sheet or letter of intent. This means: building a permanent, structured data repository; auditing your own corporate picture (IP, governance, contracts, founder dependency) with the same scrutiny a buyer will apply; generating a Vendor Diligence Pack that pre-answers buyer questions; and controlling what buyers see through a structured, permission-controlled data room rather than raw cloud access."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What are the most common causes of exit valuation being chipped?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The four most common causes are: (1) IP not formally assigned to the company \u2014 especially common where founders or contractors developed core assets before incorporation; (2) key customer concentration above 50% of revenue \u2014 typically triggers a 20\u201340% risk discount; (3) missing governance documentation (board minutes, shareholder resolutions) \u2014 gives buyers grounds to extend timelines and reprice; and (4) founder dependency visible in the data room \u2014 typically results in earnout requirements or a direct reduction in the headline multiple."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is a Vendor Diligence Pack?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A Vendor Diligence Pack is a structured, certified document set produced by the seller before the buyer's due diligence process begins. It is the seller's equivalent of a buyer's due diligence report \u2014 demonstrating proactive transparency and presenting the business in its best light. Buyers who receive one spend less time on information requests and more time on valuation. Diligentsia produces certified Vendor Diligence Packs with AI assistance at \xa31,000/year."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long does exit due diligence take?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A buyer's due diligence team typically spends 8\u201312 weeks in a business, reviewing all corporate documentation, conducting financial review, and assessing commercial risk. Adviser fees for a standard SME exit transaction typically run to \xa3150,000\u2013\xa3400,000. Companies with a pre-prepared Vendor Diligence Pack compress the buyer's review timeline significantly."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Why should I prepare for exit before a buyer appears?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The best time to fix a governance gap, unassigned IP, or missing contract is before a buyer's team finds it \u2014 not after. Once due diligence has started, every issue the buyer finds becomes negotiating leverage. Fixing issues under buyer pressure is more expensive, more disruptive, and less effective than fixing them proactively. The preparation cost (\xa31,000/year on Diligentsia Pro) is a fraction of the value protection it delivers."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Companies",
                        "item": "https://diligentsia.co.uk/ceo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Do Companies Prepare for Exit Due Diligence in 2026?",
                        "item": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/"
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "HowTo",
                "name": "How Do Companies Prepare for Exit Due Diligence in 2026?",
                "step": [
                    {
                        "@type": "HowToStep",
                        "position": 1,
                        "name": "The four most common exit value destroyers",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-1"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 2,
                        "name": "Step 1: Build your permanent data room",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-2"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 3,
                        "name": "Step 2: Audit yourself before the buyer does",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-3"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 4,
                        "name": "Step 3: Generate your Vendor Diligence Pack",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-4"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 5,
                        "name": "Step 4: Document and mitigate founder dependency",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-5"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 6,
                        "name": "Step 5: Control what the buyer sees",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-6"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 7,
                        "name": "How long does exit preparation take?",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-7"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 8,
                        "name": "Diligentsia Exit Ready pricing",
                        "url": "https://diligentsia.co.uk/ceo/how-to-prepare-for-exit-due-diligence/#step-8"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "cfo",
        "slug": "how-fractional-cfos-use-diligentsia",
        "category": "Fractional CFOs",
        "title": "How Fractional CFOs Use Diligentsia to Onboard Faster, Prove Value, and Surface More Billable Work",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-fractional-cfos-use-diligentsia.jpg",
        "metaDescription": "A practical guide to how fractional CFOs use Diligentsia: walking in at 60%, surfacing billable work systematically, and proving advisory value continuously. Free advisor account \u2014 no cost to you. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/cfo/how-fractional-cfos-use-diligentsia/",
        "bodyHtml": '<p>Fractional CFOs face a structural challenge that most accept as unavoidable: each new client engagement starts from zero. Document archaeology in the first weeks. Slow onboarding. No systematic way to surface the next billable opportunity. Value that is invisible between transactions.</p>\n<p>Diligentsia was built to address this directly. Here is how fractional CFOs are using it in practice.</p>\n<h2>Step 1: Set up your free advisor account (30 minutes)</h2>\n<p>Your advisor account is completely free. No platform fees, no licence costs, no revenue share on your income. Setup involves a 30-minute onboarding call with Mark Bernstein (founder and CEO), a walk through the advisor dashboard using dummy data, and connection of your first client to the platform.</p>\n<p>No credit card required. No commitment. Your account gives you full platform access, a single dashboard for all your clients, and visibility across every stage of every client engagement.</p>\n<h2>Step 2: Walk in at 60%, not zero</h2>\n<p>Diligentsia\'s AI (Clarence) auto-populates approximately 60% of your new client\'s diligence modules from documents they already hold \u2014 financial statements, contracts, board papers, company filings. Every answer is linked to its source document. Human review is mandatory: nothing is shared until your client marks it as reviewed.</p>\n<blockquote><p><em>"You could walk into any assignment and start at 60% instead of zero."</em></p><p>\u2014 FR, Fractional CFO and Diligentsia investor</p></blockquote>\n<h2>Step 3: Structure the quarterly review cycle</h2>\n<p>Diligentsia flags every gap, outstanding item, and improvement opportunity across your client\'s full knowledge base. The platform generates structured quarterly review agendas automatically \u2014 based on completion status, risk flags, and module health scores.</p>\n<p>For fractional CFOs, this is the upsell engine. Advisory opportunities that would previously have been discovered by accident \u2014 or not at all \u2014 are surfaced systematically every quarter.</p>\n<blockquote><p><em>"It gives me a way to upsell into clients."</em></p><p>\u2014 Fractional CFO, Diligentsia platform user</p></blockquote>\n<h2>Step 4: Apply it across your whole client book</h2>\n<p>Most fractional CFOs think of diligence and data room preparation as serving the 20% of their client book that is actively raising. Diligentsia operates across the full lifecycle: Investment Ready, Growth Ready, and Exit Ready.</p>\n<p>The 80% of clients not currently in transaction mode benefit from growth modules, governance improvement, and health monitoring. Better organised businesses grow faster \u2014 and your engagement longevity stops depending on whether a transaction is imminent.</p>\n<blockquote><p><em>"This product is valuable wherever you are on your journey. Better organised businesses grow faster."</em></p><p>\u2014 JC, Fractional CFO</p></blockquote>\n<h2>Step 5: Prove your value \u2014 visibly and continuously</h2>\n<p>Diligentsia\'s Bronze/Silver/Gold certification gives clients a third-party validated score of their business health. Every quarterly review has a structured, shareable output. Your value is no longer invisible between transactions \u2014 it is on the dashboard.</p>\n<p>For fractional CFOs whose engagement longevity depends on demonstrating impact, this changes the conversation. Progress is measurable. Improvement is documented. The argument for continued engagement does not depend on a transaction being near.</p>\n<blockquote><p><em>"It amplifies my ability to show value to a client \u2014 without the client even realising how much I\'ve leveraged the platform."</em></p><p>\u2014 FR, Fractional CFO and Diligentsia investor</p></blockquote>\n<h2>Diligentsia pricing</h2>\n<p>| Plan | Who it\'s for | Cost | What\'s included | |---|---|---|---| | Advisor account | Fractional CFOs | Free | Full platform access, single client dashboard, quarterly review agendas, all modules | | Diligentsia Pro | SME clients | \xa31,000/year | Full Diligence Pack, AI pre-population (60%), Bronze/Silver/Gold certification, investor sharing | | Starter tier | Early-stage clients (pre-revenue) | Free | Core governance modules, AI assistance, upgrade when ready to raise | | Client introduction benefit | Your referral | \u2014 | 20% discount for clients you introduce |</p>\n<p><strong>Ready to set up your free advisor account?</strong> <a href="/cfo">diligentsia.co.uk/cfo</a></p>',
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "Is Diligentsia free for fractional CFOs?",
                "a": "Yes. Advisor accounts for fractional CFOs are completely free \u2014 no platform fees, no licence costs, no revenue share on advisory income. Your clients pay \xa31,000/year for Diligentsia Pro, or can start on the free Starter tier if they are not yet raising. CFOs who introduce clients receive a 20% discount for those clients."
            },
            {
                "q": "How does the \"walk in at 60%\" benefit work in practice?",
                "a": "When you connect a new client to Diligentsia, Clarence AI analyses the documents they already hold and auto-populates approximately 60% of their standard due diligence modules. Every answer is linked to a source document and requires your client's explicit review and sign-off. The result is that the first weeks of a new engagement are advisory and strategic, not spent on document archaeology."
            },
            {
                "q": "How does Diligentsia help fractional CFOs surface more billable work?",
                "a": "Diligentsia continuously flags gaps, outstanding items, and improvement opportunities across your client's full knowledge base. The platform generates structured quarterly review agendas automatically, based on completion status, risk flags, and module health scores. Advisory opportunities that would previously have been discovered by accident \u2014 or missed entirely \u2014 are surfaced systematically every quarter."
            },
            {
                "q": "Does Diligentsia work for clients who are not currently raising?",
                "a": "Yes. Diligentsia operates across the full company lifecycle: Investment Ready, Growth Ready, and Exit Ready. The 80% of clients not currently in transaction mode benefit from growth modules, governance improvement, and health monitoring. Better organised businesses grow faster \u2014 and your engagement longevity stops depending on a transaction being near."
            },
            {
                "q": "How do I get started with Diligentsia as a fractional CFO?",
                "a": "Set up your free advisor account at [diligentsia.co.uk/cfo](https://diligentsia.co.uk/cfo). Setup involves a 30-minute onboarding call with Mark Bernstein (founder and CEO) and a walkthrough of the advisor dashboard using dummy data. No credit card required. You can connect your first client immediately after the call."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Fractional CFOs Use Diligentsia to Onboard Faster, Prove Value, and Surface More Billable Work",
                "description": "A practical guide to how fractional CFOs use Diligentsia: walking in at 60%, surfacing billable work systematically, and proving advisory value continuously. Free advisor account \u2014 no cost to you.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/cfo/how-fractional-cfos-use-diligentsia/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-fractional-cfos-use-diligentsia.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Is Diligentsia free for fractional CFOs?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes. Advisor accounts for fractional CFOs are completely free \u2014 no platform fees, no licence costs, no revenue share on advisory income. Your clients pay \xa31,000/year for Diligentsia Pro, or can start on the free Starter tier if they are not yet raising. CFOs who introduce clients receive a 20% discount for those clients."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does the \"walk in at 60%\" benefit work in practice?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "When you connect a new client to Diligentsia, Clarence AI analyses the documents they already hold and auto-populates approximately 60% of their standard due diligence modules. Every answer is linked to a source document and requires your client's explicit review and sign-off. The result is that the first weeks of a new engagement are advisory and strategic, not spent on document archaeology."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does Diligentsia help fractional CFOs surface more billable work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Diligentsia continuously flags gaps, outstanding items, and improvement opportunities across your client's full knowledge base. The platform generates structured quarterly review agendas automatically, based on completion status, risk flags, and module health scores. Advisory opportunities that would previously have been discovered by accident \u2014 or missed entirely \u2014 are surfaced systematically every quarter."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Does Diligentsia work for clients who are not currently raising?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes. Diligentsia operates across the full company lifecycle: Investment Ready, Growth Ready, and Exit Ready. The 80% of clients not currently in transaction mode benefit from growth modules, governance improvement, and health monitoring. Better organised businesses grow faster \u2014 and your engagement longevity stops depending on a transaction being near."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How do I get started with Diligentsia as a fractional CFO?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Set up your free advisor account at diligentsia.co.uk/cfo. Setup involves a 30-minute onboarding call with Mark Bernstein (founder and CEO) and a walkthrough of the advisor dashboard using dummy data. No credit card required. You can connect your first client immediately after the call."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Fractional CFOs",
                        "item": "https://diligentsia.co.uk/cfo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Fractional CFOs Use Diligentsia to Onboard Faster, Prove Value, and Surface More Billable Work",
                        "item": "https://diligentsia.co.uk/cfo/how-fractional-cfos-use-diligentsia/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "angel-network",
        "slug": "what-angel-investors-look-for",
        "category": "Angel Networks",
        "title": "What Do Angel Investors Look for Before Committing? (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-angel-investors-look-for.jpg",
        "metaDescription": "Angel investors look for four things before committing: a credible team, a real market opportunity, a coherent business model, and an absence of undisclosed risk. How companies signal organisation determines which rounds close. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/angel-network/what-angel-investors-look-for/",
        "bodyHtml": "<p>Angel investors look for evidence of four things before committing to an investment: a credible team, a real market opportunity, a business model with a plausible path to returns, and an absence of undisclosed risks that would change the investment decision. How these are weighted varies by investor, but all four must be sufficiently addressed for a round to close.</p>\n<h2>Team</h2>\n<p>Most experienced angel investors rank team above all other factors at early stage. The rationale is straightforward: the business plan will almost certainly change, the market assumptions will be tested, and the product will evolve \u2014 but the team is the constant. Angels are investing in the judgment, resilience, and capability of the founders as much as in the business as currently described.</p>\n<p>What investors assess specifically: relevant domain experience, evidence of previous execution (have they built something before?), the quality of the founding team's relationships (do they complement each other?), and the absence of red flags in the founders' backgrounds, equity arrangements, or prior commitments.</p>\n<h2>Market opportunity</h2>\n<p>Angels want to invest in businesses that can return at least 10\xd7 the investment, because most of their portfolio will return nothing. This requires a large enough market. The standard expectation is that the company is targeting a market of at least \xa3100M\u2013\xa3500M, with a credible theory of how they will capture a meaningful share.</p>\n<p>The quality of market analysis matters as much as the conclusion. An investor who sees a well-researched market opportunity assessment \u2014 covering market size, competitive landscape, growth drivers, and the company's specific positioning \u2014 will have more confidence than one who sees a slide with a large TAM number and no supporting evidence.</p>\n<h2>Business model and financial projections</h2>\n<p>Angels look for a business model that is understandable and financially coherent. They do not expect certainty at early stage, but they expect founders to understand the economics of their own business: unit economics, gross margin, the path to profitability, and the key assumptions on which the projections rest.</p>\n<p>The most common failure mode in financial projections is hockey-stick revenue growth with no explanation of the mechanism. Investors want to know what changes at what point to drive the step-change \u2014 a new sales hire, a partnership, a product launch \u2014 and whether the assumption is defensible.</p>\n<h2>Absence of undisclosed risk</h2>\n<p>This is the factor that kills the most advanced-stage deals. An investor who is interested in the team, the market, and the business model will still walk away \u2014 or extract significant price adjustments \u2014 if due diligence surfaces surprises they were not told about.</p>\n<p>Common deal-killers at due diligence stage include: IP ownership disputes (especially where founders have written code under a previous employment contract), undocumented equity arrangements between co-founders, material contracts with clauses that change the business's risk profile, and governance records that suggest the company is less well-run than it appeared.</p>\n<p>None of these need to be fatal if disclosed early. Many can be remediated with legal advice before investor conversations begin. The same issue that kills a deal when discovered by an investor during due diligence is often resolved in a week if the founder identifies it first.</p>\n<h2>The quality signal investors are missing</h2>\n<p>One structural problem in angel investing is the absence of a quick quality signal. Investors receive hundreds of approaches and have limited time. Before the detailed process begins, they are making a judgment based on a pitch deck and a brief conversation.</p>\n<p>The companies that generate the strongest first impressions \u2014 that cause an investor to accelerate their process rather than manage it down \u2014 are the ones that signal organisation and preparedness from the first interaction. A structured Diligence Pack, with a Bronze/Silver/Gold certification, provides exactly this signal.</p>\n<blockquote><p><em>\"Putting a deal in front of a VC with the Diligentsia outputs alongside the deck. You've answered 60 questions they didn't even ask yet.\"</em></p><p>\u2014 Fractional CFO, Diligentsia investor</p></blockquote>\n<p>The same principle applies at angel stage. The founder who arrives prepared does not just make a better impression. They close their round faster, at less dilution, with greater confidence on both sides of the table.</p>\n<h2>The AI dimension</h2>\n<p>Angel investors are increasingly using AI tools to analyse documentation submitted by companies. These tools can surface gaps, inconsistencies, and undisclosed risks faster than any human reviewer.</p>\n<p>The implication for founders is important: companies whose documentation is disorganised, incomplete, or inconsistent will find that AI-assisted due diligence reveals more problems than a manual review might have caught. The companies whose documentation is well-structured, evidence-backed, and internally consistent will find that AI-assisted due diligence confirms their quality \u2014 and accelerates the investor's confidence.</p>\n<blockquote><p><em>\"You can't just drop LLMs on top of data that's all over the place \u2014 because your output's going to reflect it.\"</em></p></blockquote>\n<p>A structured, verified knowledge base is the foundation on which any useful AI analysis depends.</p>",
        "peopleAlsoAsk": [
            {
                "q": "How do I prepare documentation for angel investor due diligence?",
                "a": "The most effective approach is to build a structured Diligence Pack before approaching investors \u2014 covering corporate records, IP, financials, and commercial evidence. AI-assisted platforms can pre-populate around 60% of standard modules from documents you already have."
            },
            {
                "q": "How do angel networks improve startup funding rates?",
                "a": "Angel networks improve funding rates by aggregating investor attention, providing a credibility signal, and creating follow-on momentum. The strongest networks also establish an investment readiness standard that ensures cohort companies arrive prepared."
            }
        ],
        "faqs": [
            {
                "q": "What do angel investors prioritise most when evaluating a company?",
                "a": "Most experienced angel investors prioritise team above all other factors at early stage. The rationale is that the business plan will change, but the team is the constant. Domain experience, prior execution, and the absence of background red flags are the most commonly cited criteria. Market size and financial coherence are the second and third priorities."
            },
            {
                "q": "What causes angel investment deals to collapse during due diligence?",
                "a": "The most common deal-killers at due diligence stage are undisclosed risks \u2014 IP ownership disputes, undocumented equity arrangements between co-founders, and material contracts with problematic clauses. None of these need to be fatal if disclosed early; many can be remediated in a week if the founder identifies them first rather than waiting for the investor to discover them."
            },
            {
                "q": "How does a Bronze/Silver/Gold certification affect investor confidence?",
                "a": "A Diligentsia Bronze/Silver/Gold certification tells an investor, before a single document has been exchanged, that the company has completed a rigorous self-assessment of its investment readiness. This accelerates the investor's process and reduces the discovery risk that causes deals to stall. One fractional CFO described the effect as answering 60 investor questions before they were even asked."
            },
            {
                "q": "How is AI changing the way angel investors conduct due diligence?",
                "a": "Angel investors are increasingly using AI tools to analyse company documentation \u2014 surfacing gaps, inconsistencies, and undisclosed risks faster than any human reviewer. Companies with well-structured, evidence-backed documentation find that AI analysis confirms their quality. Companies with disorganised documentation find that AI reveals more problems than a manual review would have caught."
            },
            {
                "q": "What market size do angel investors typically require?",
                "a": "The standard expectation for angel-stage investment is a total addressable market of at least \xa3100M\u2013\xa3500M, with a credible theory of how the company captures a meaningful share. Angels need businesses that can return at least 10\xd7 the investment, because most of their portfolio will return nothing \u2014 which requires a large enough market to support that outcome."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "What Do Angel Investors Look for Before Committing? (2026)",
                "description": "Angel investors look for four things before committing: a credible team, a real market opportunity, a coherent business model, and an absence of undisclosed risk. How companies signal organisation determines which rounds close.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/angel-network/what-angel-investors-look-for/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-angel-investors-look-for.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "How do I prepare documentation for angel investor due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most effective approach is to build a structured Diligence Pack before approaching investors \u2014 covering corporate records, IP, financials, and commercial evidence. AI-assisted platforms can pre-populate around 60% of standard modules from documents you already have."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How do angel networks improve startup funding rates?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Angel networks improve funding rates by aggregating investor attention, providing a credibility signal, and creating follow-on momentum. The strongest networks also establish an investment readiness standard that ensures cohort companies arrive prepared."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What do angel investors prioritise most when evaluating a company?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Most experienced angel investors prioritise team above all other factors at early stage. The rationale is that the business plan will change, but the team is the constant. Domain experience, prior execution, and the absence of background red flags are the most commonly cited criteria. Market size and financial coherence are the second and third priorities."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What causes angel investment deals to collapse during due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most common deal-killers at due diligence stage are undisclosed risks \u2014 IP ownership disputes, undocumented equity arrangements between co-founders, and material contracts with problematic clauses. None of these need to be fatal if disclosed early; many can be remediated in a week if the founder identifies them first rather than waiting for the investor to discover them."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does a Bronze/Silver/Gold certification affect investor confidence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A Diligentsia Bronze/Silver/Gold certification tells an investor, before a single document has been exchanged, that the company has completed a rigorous self-assessment of its investment readiness. This accelerates the investor's process and reduces the discovery risk that causes deals to stall. One fractional CFO described the effect as answering 60 investor questions before they were even asked."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How is AI changing the way angel investors conduct due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Angel investors are increasingly using AI tools to analyse company documentation \u2014 surfacing gaps, inconsistencies, and undisclosed risks faster than any human reviewer. Companies with well-structured, evidence-backed documentation find that AI analysis confirms their quality. Companies with disorganised documentation find that AI reveals more problems than a manual review would have caught."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What market size do angel investors typically require?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The standard expectation for angel-stage investment is a total addressable market of at least \xa3100M\u2013\xa3500M, with a credible theory of how the company captures a meaningful share. Angels need businesses that can return at least 10\xd7 the investment, because most of their portfolio will return nothing \u2014 which requires a large enough market to support that outcome."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Angel Networks",
                        "item": "https://diligentsia.co.uk/angel-network/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "What Do Angel Investors Look for Before Committing? (2026)",
                        "item": "https://diligentsia.co.uk/angel-network/what-angel-investors-look-for/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "accelerator",
        "slug": "how-to-prepare-due-diligence-pack-seed-investment",
        "category": "Accelerators",
        "title": "How to Prepare a Due Diligence Pack for Seed Investment",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-prepare-due-diligence-pack-seed-investment.jpg",
        "metaDescription": "A complete guide to preparing a due diligence pack for seed investment: what investors expect, how to organise documentation efficiently, and how to build a certified pack in as little as three days using AI assistance. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/",
        "bodyHtml": "<p>A due diligence pack for seed investment is a structured collection of documents and information that enables an investor to assess a company's legal, financial, commercial, and governance position before committing capital. A well-prepared pack reduces the time between investor interest and investment decision, minimises surprises during the diligence process, and signals to investors that the founding team understands how professional transactions work.</p>\n<h2>What investors expect at seed stage</h2>\n<p>Seed-stage due diligence is less extensive than Series A or later rounds, but investors still require a structured record of the business. The specific documents required vary by investor and deal size, but there is a common core that virtually all seed investors expect:</p>\n<h3>Corporate structure</h3>\n<ul><li>Certificate of incorporation and company registration details</li><li>Articles of association (current, signed version)</li><li>Cap table \u2014 full shareholder register showing all shareholders, share classes, and ownership percentages</li><li>Any shareholder agreements, investor rights agreements, or side letters</li><li>Details of any outstanding convertible notes, SAFEs, or option pools</li></ul>\n<h3>Founding team</h3>\n<ul><li>Directors' details and backgrounds (often in the form of a directors' questionnaire)</li><li>Confirmation of any prior IP assignments from founders to the company</li><li>Disclosure of any conflicts of interest</li><li>Details of any equity promises or informal commitments not yet formally documented</li></ul>\n<h3>Intellectual property</h3>\n<ul><li>List of owned IP \u2014 patents, trademarks, copyrights, trade secrets</li><li>Confirmation that all IP developed by employees and contractors has been assigned to the company</li><li>Any IP licences in or out</li></ul>\n<h3>Key contracts</h3>\n<ul><li>Customer contracts (particularly any material revenue contracts)</li><li>Supplier and partner agreements</li><li>Employment contracts for key team members</li><li>Any non-competes, NDAs, or exclusivity arrangements</li></ul>\n<h3>Financial information</h3>\n<ul><li>Last 12\u201324 months of management accounts (or since incorporation if younger)</li><li>Current year budget and financial projections (12\u201324 months)</li><li>Details of existing debt or liabilities</li><li>Bank statements (typically last 3\u20136 months)</li></ul>\n<h3>Commercial position</h3>\n<ul><li>Evidence of revenue or pipeline (customer references, LOIs, ARR/MRR data)</li><li>Market size analysis</li><li>Competitive landscape summary</li><li>Route to market and sales strategy</li></ul>\n<h2>Common reasons seed diligence stalls</h2>\n<p>The most frequent causes of delay or deal failure during seed due diligence are not fundamental problems with the business \u2014 they are information gaps and disclosure issues that erode investor confidence:</p>\n<ol><li><strong>Undocumented equity arrangements</strong> \u2014 Informal promises about share options or co-founder equity that have not been formally documented. Investors find this in almost every first-time founder company.</li></ol>\n<ol><li><strong>IP not properly assigned</strong> \u2014 Code written by a contractor, a previous employer, or a founding team member before the company was incorporated, without a formal IP assignment agreement.</li></ol>\n<ol><li><strong>Incomplete or inconsistent cap table</strong> \u2014 Discrepancies between the shareholder register, any option scheme documentation, and what founders believe the equity split to be.</li></ol>\n<ol><li><strong>Slow responses to information requests</strong> \u2014 Not because the information does not exist, but because it is unorganised. A company that takes two weeks to produce documents that should be readily available signals poor internal governance.</li></ol>\n<ol><li><strong>Surprising disclosures</strong> \u2014 Issues that emerge late in the process that investors feel should have been disclosed earlier. Any surprise raises the question of what else has not been disclosed.</li></ol>\n<h2>How to prepare efficiently</h2>\n<h3>Step 1: Start before you need it</h3>\n<p>The worst time to assemble a due diligence pack is when an investor has already expressed interest and is waiting for information. Build the pack proactively \u2014 ideally during a programme period or in the months before you begin active fundraising.</p>\n<h3>Step 2: Use a structured framework</h3>\n<p>A structured diligence framework ensures you address all standard investor requirements systematically rather than reactively. Platforms like Diligentsia provide a pre-built framework covering all standard due diligence modules, with AI assistance to auto-populate approximately 60% of the content from documents you already have.</p>\n<h3>Step 3: Organise documents centrally</h3>\n<p>All documents should live in a single, searchable repository with clear version control. Investors increasingly use AI tools to analyse documentation, which means unorganised or poorly named files slow down the process and can create a poor impression.</p>\n<h3>Step 4: Review every answer</h3>\n<p>No due diligence material should be shared with investors without human review. AI-assisted tools can accelerate preparation, but every answer must be reviewed and signed off by a director or authorised person. This is both a governance requirement and a practical safeguard against errors.</p>\n<h3>Step 5: Control access carefully</h3>\n<p>Share your Diligence Pack through a permission-controlled mechanism, not a public link or unprotected shared drive. You should be able to see who has accessed which documents, revoke access if needed, and provide different levels of visibility to different parties.</p>\n<h2>What a Bronze / Silver / Gold certification means</h2>\n<ul><li><strong>Bronze</strong> \u2014 the company has completed the basic governance and corporate record modules. Suitable for very early stage or pre-revenue companies.</li><li><strong>Silver</strong> \u2014 full Diligence Pack is substantially complete, including financial information and commercial evidence. Appropriate for most seed rounds.</li><li><strong>Gold</strong> \u2014 comprehensive diligence including directors' questionnaires, warranty disclosure drafts, and full IP and contract analysis. Appropriate for larger seed rounds or companies approaching Series A.</li></ul>\n<p>A certified Diligence Pack does not replace investor due diligence \u2014 it structures and accelerates it. The investor still asks questions; the difference is that the answers are already prepared.</p>\n<h2>How long does it take?</h2>\n<p>A well-organised company with existing documents already assembled can complete a full seed-stage Diligence Pack in as little as three days using a structured platform with AI assistance. Most companies should allow one to two weeks. The primary variable is the state of the company's existing documentation \u2014 not the complexity of the business.</p>\n<h2>Diligentsia pricing</h2>\n<p>| Plan | Who it's for | Cost | What's included | |---|---|---|---| | Company subscription | Early-stage companies | \xa31,000/year | Full Diligence Pack, AI pre-population (60% autofill), Bronze/Silver/Gold certification, controlled investor sharing | | Advisor account | Fractional CFOs, lawyers, accountants | Free | Platform access to manage and review client packs, sign-off tools, multiple client management | | Accelerator integration | Programme operators | Contact Diligentsia | Cohort-wide access, programme dashboard, cohort performance reporting |</p>\n<h2>Summary checklist</h2>\n<p>Before beginning active fundraising, confirm your Diligence Pack covers all six areas:</p>\n<ul><li><strong>Corporate:</strong> Incorporation docs, articles, cap table, shareholder agreements, convertible instruments</li><li><strong>Founders:</strong> Director details, IP assignments, conflict disclosures, equity documentation</li><li><strong>IP:</strong> Owned IP register, assignment confirmations, licences</li><li><strong>Contracts:</strong> Material customer/supplier contracts, employment agreements, NDAs</li><li><strong>Financial:</strong> Management accounts, projections, bank statements</li><li><strong>Commercial:</strong> Revenue evidence, market analysis, competitive landscape</li></ul>\n<p><strong>Ready to build your Diligence Pack?</strong> <a href=\"/accelerator\">diligentsia.co.uk/accelerator</a></p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "What documents do investors require for seed due diligence?",
                "a": "Seed investors typically require: certificate of incorporation and articles of association, a complete cap table showing all shareholders and share classes, director details and IP assignment confirmations, key contracts (customer, supplier, employment), management accounts and financial projections for 12\u201324 months, and commercial evidence including revenue data or customer references."
            },
            {
                "q": "How long does it take to prepare a due diligence pack?",
                "a": "A well-organised company using a structured platform with AI assistance can complete a full seed-stage Diligence Pack in as little as three days. Most companies should allow one to two weeks. The AI pre-population feature auto-completes approximately 60% of standard modules from documents already uploaded \u2014 every answer must then be reviewed and signed off by a director."
            },
            {
                "q": "What is Bronze, Silver, or Gold Diligentsia certification?",
                "a": "Diligentsia certification levels indicate the completeness of a company's Diligence Pack. Bronze covers basic governance and corporate records, suitable for very early-stage companies. Silver means the full pack is substantially complete including financials and commercial evidence, appropriate for most seed rounds. Gold includes directors' questionnaires, warranty disclosure drafts, and full IP analysis \u2014 appropriate for larger rounds or companies approaching Series A."
            },
            {
                "q": "Do accelerator programme companies need a due diligence pack?",
                "a": "Yes \u2014 particularly if the programme culminates in a demo day or investor introduction. Investment readiness documentation is the most common gap between investor interest and investor commitment. A company that can share a certified Diligence Pack immediately after demo day compresses due diligence timelines and reduces the risk of a round stalling on information gaps."
            },
            {
                "q": "How much does it cost to prepare a due diligence pack with Diligentsia?",
                "a": "A company subscription to Diligentsia costs \xa31,000 per year \u2014 less than a single day of fractional CFO time. This includes the full Diligence Pack framework, AI pre-population across all modules, Bronze/Silver/Gold certification, and permission-controlled sharing with investors. Fractional CFO and advisor accounts are free."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How to Prepare a Due Diligence Pack for Seed Investment",
                "description": "A complete guide to preparing a due diligence pack for seed investment: what investors expect, how to organise documentation efficiently, and how to build a certified pack in as little as three days using AI assistance.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-prepare-due-diligence-pack-seed-investment.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What documents do investors require for seed due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Seed investors typically require: certificate of incorporation and articles of association, a complete cap table showing all shareholders and share classes, director details and IP assignment confirmations, key contracts (customer, supplier, employment), management accounts and financial projections for 12\u201324 months, and commercial evidence including revenue data or customer references."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long does it take to prepare a due diligence pack?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A well-organised company using a structured platform with AI assistance can complete a full seed-stage Diligence Pack in as little as three days. Most companies should allow one to two weeks. The AI pre-population feature auto-completes approximately 60% of standard modules from documents already uploaded \u2014 every answer must then be reviewed and signed off by a director."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is Bronze, Silver, or Gold Diligentsia certification?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Diligentsia certification levels indicate the completeness of a company's Diligence Pack. Bronze covers basic governance and corporate records, suitable for very early-stage companies. Silver means the full pack is substantially complete including financials and commercial evidence, appropriate for most seed rounds. Gold includes directors' questionnaires, warranty disclosure drafts, and full IP analysis \u2014 appropriate for larger rounds or companies approaching Series A."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Do accelerator programme companies need a due diligence pack?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes \u2014 particularly if the programme culminates in a demo day or investor introduction. Investment readiness documentation is the most common gap between investor interest and investor commitment. A company that can share a certified Diligence Pack immediately after demo day compresses due diligence timelines and reduces the risk of a round stalling on information gaps."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How much does it cost to prepare a due diligence pack with Diligentsia?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A company subscription to Diligentsia costs \xa31,000 per year \u2014 less than a single day of fractional CFO time. This includes the full Diligence Pack framework, AI pre-population across all modules, Bronze/Silver/Gold certification, and permission-controlled sharing with investors. Fractional CFO and advisor accounts are free."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Accelerators",
                        "item": "https://diligentsia.co.uk/accelerator/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How to Prepare a Due Diligence Pack for Seed Investment",
                        "item": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/"
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "HowTo",
                "name": "How to Prepare a Due Diligence Pack for Seed Investment",
                "step": [
                    {
                        "@type": "HowToStep",
                        "position": 1,
                        "name": "What investors expect at seed stage",
                        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/#step-1"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 2,
                        "name": "Common reasons seed diligence stalls",
                        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/#step-2"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 3,
                        "name": "How to prepare efficiently",
                        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/#step-3"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 4,
                        "name": "What a Bronze / Silver / Gold certification means",
                        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/#step-4"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 5,
                        "name": "How long does it take?",
                        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/#step-5"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 6,
                        "name": "Diligentsia pricing",
                        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/#step-6"
                    },
                    {
                        "@type": "HowToStep",
                        "position": 7,
                        "name": "Summary checklist",
                        "url": "https://diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/#step-7"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "accelerator",
        "slug": "how-long-does-startup-due-diligence-take",
        "category": "Accelerators",
        "title": "How Long Does Startup Due Diligence Take? (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-long-does-startup-due-diligence-take.jpg",
        "metaDescription": "Startup due diligence takes 4\u201312 weeks on average, but well-prepared companies can complete it in 2\u20134 weeks. Learn what drives timeline variance and how AI tools are changing investor analysis. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/accelerator/how-long-does-startup-due-diligence-take/",
        "bodyHtml": '<p>Startup due diligence typically takes between four and twelve weeks from the point of initial investor interest to a completed process, with the wide variance explained almost entirely by the state of the company\'s preparation \u2014 not the complexity of the business. Well-prepared companies with organised documentation can compress this to two to four weeks; companies that begin assembling information reactively often find the process drags for three months or more.</p>\n<h2>Typical due diligence timelines by stage</h2>\n<h3>Pre-seed and seed (under \xa31M)</h3>\n<ul><li>Well-prepared company: <strong>2\u20134 weeks</strong></li><li>Average company: <strong>6\u20138 weeks</strong></li><li>Unprepared company: <strong>10\u201316 weeks or stalled</strong></li></ul>\n<p>At pre-seed and seed, institutional investors typically conduct a lighter-touch diligence focused on founders, IP ownership, cap table structure, and commercial evidence. The process is shorter in scope but can still drag significantly if basic information is not readily available.</p>\n<h3>Seed (\xa31M\u2013\xa33M) and pre-Series A</h3>\n<ul><li>Well-prepared company: <strong>4\u20136 weeks</strong></li><li>Average company: <strong>8\u201312 weeks</strong></li><li>Unprepared company: <strong>3\u20136 months or abandoned</strong></li></ul>\n<p>Rounds in this range attract more rigorous diligence, often involving legal counsel on both sides. The company is expected to have organised financial records, a complete cap table, IP assignments, key contracts, and a structured data room. Gaps at this stage are taken more seriously.</p>\n<h3>Series A and above</h3>\n<ul><li>Well-prepared company: <strong>6\u201310 weeks</strong></li><li>Average company: <strong>12\u201316 weeks</strong></li><li>Significant issues: <strong>Indefinite delay or repriced deal</strong></li></ul>\n<p>Series A diligence is comprehensive, typically involving specialist legal, financial, and technical advisers. At this stage, issues discovered in diligence regularly result in deal repricing rather than deal abandonment \u2014 the investor uses each gap as leverage on the valuation.</p>\n<h2>What causes due diligence to take longer</h2>\n<h3>1. Information assembled reactively</h3>\n<p>The most common cause of extended due diligence timelines is the company assembling information after the investor has asked for it, rather than before. A company that receives a due diligence request list and spends the next two weeks locating, formatting, and uploading documents has already lost momentum. An investor waiting for information reassesses their confidence in the management team with every passing week.</p>\n<h3>2. Surprises during the process</h3>\n<p>Issues that emerge unexpectedly during diligence \u2014 undocumented equity arrangements, IP that was not properly assigned, contracts with problematic terms \u2014 add weeks or months to the process while they are resolved. Some issues cannot be resolved quickly. In the worst cases, they cause investors to withdraw.</p>\n<p>The damage from a discovered surprise is not just the time taken to resolve it. It is the implicit question it raises: what else is there that we have not found yet?</p>\n<h3>3. Inconsistent or incomplete documentation</h3>\n<p>Investors increasingly use AI tools to analyse company documentation. AI-assisted analysis surfaces inconsistencies \u2014 discrepancies between the cap table and the shareholder register, contracts that reference documents not included in the data room, financial models that do not reconcile with management accounts. Each inconsistency generates a follow-up question, and follow-up questions slow the process.</p>\n<blockquote><p><em>"A folder of unorganised PDFs is not a data room. It is an invitation for extended enquiry."</em></p></blockquote>\n<h3>4. Multiple decision-makers on the investor side</h3>\n<p>VC investment committees, angel group votes, and co-investment structures all add time on the investor side that is outside the company\'s control. The company can influence this by ensuring their information is clear, complete, and well-presented \u2014 reducing the time any individual decision-maker needs to spend forming a view.</p>\n<h2>How AI is changing due diligence timelines</h2>\n<p>Investors are increasingly deploying AI tools to assist with due diligence analysis. This has two effects companies need to understand:</p>\n<p><strong>Faster initial analysis:</strong> AI can scan a company\'s documents and generate a structured risk report within minutes. A process that previously required a week of analyst time now takes hours. This compresses the early stages of diligence significantly for investors who are organised.</p>\n<p><strong>More issues surfaced:</strong> AI does not miss things. A human analyst reviewing a large volume of documents might not catch a specific clause in a supplier contract or an inconsistency in director appointment dates. AI will find these. Companies that previously passed human review without issue may find that AI-assisted investors surface 15\u201320 issues where a human reviewer found five.</p>\n<p>The practical implication for companies: organise your documentation before investors look at it with AI tools, not after. Issues that you know about and have addressed are manageable. Issues that investors discover \u2014 and that you then have to explain \u2014 undermine confidence and delay the process.</p>\n<h2>The cost of a slow process</h2>\n<p>Beyond the direct time cost, a prolonged due diligence process has material commercial consequences:</p>\n<ul><li><strong>Management distraction:</strong> Founders spending two to three months responding to diligence requests are not selling, building, or hiring. The opportunity cost is significant.</li><li><strong>Adviser fees:</strong> Legal and financial advisers on both sides charge by the hour. A two-month process costs materially more than a six-week process \u2014 the difference can reach tens of thousands of pounds.</li><li><strong>Funding gap risk:</strong> A round that takes longer than expected creates cash flow pressure if the company is operating close to its runway, forcing founders into a weaker negotiating position.</li><li><strong>Deal abandonment:</strong> A meaningful proportion of deals that begin due diligence do not complete. Prolonged processes, competing deal flow, and changing market conditions all contribute.</li></ul>\n<blockquote><p><em>"The fastest-closing companies are typically the best-prepared ones."</em></p></blockquote>\n<h2>How to compress due diligence timelines</h2>\n<p>The single most effective action a company can take to reduce due diligence timelines is to build a complete, organised Diligence Pack before beginning active fundraising.</p>\n<p>The key steps:</p>\n<ol><li><strong>Centralise documentation:</strong> Upload all existing documents to a structured repository \u2014 contracts, financial models, incorporation documents, IP records, board papers.</li><li><strong>AI pre-population:</strong> AI tools can analyse uploaded documents and auto-populate approximately 60% of standard due diligence modules, flagging gaps and inconsistencies before they reach investors.</li><li><strong>Human review:</strong> Every answer is reviewed and signed off by a director or authorised person. Nothing is shared with investors until it has been reviewed.</li><li><strong>Controlled sharing:</strong> The completed pack is shared with investors via a permission-controlled link. The company sees who has accessed which documents and retains the ability to revoke access.</li></ol>\n<h2>Summary timeline table</h2>\n<p>| Preparation level | Typical seed DD timeline | |---|---| | Full Diligence Pack prepared in advance | 2\u20134 weeks | | Partial preparation, some gaps | 6\u20138 weeks | | No preparation, assembled reactively | 10\u201316 weeks | | Surprises discovered during process | 4+ months or deal abandoned |</p>\n<p>The fastest-closing companies share a consistent characteristic: they treated due diligence preparation as an ongoing discipline rather than a pre-fundraise scramble.</p>',
        "peopleAlsoAsk": [
            {
                "q": "What documents do investors request during seed due diligence?",
                "a": "Seed investors typically request: certificate of incorporation, articles of association, complete cap table, director details and IP assignment confirmations, key customer and supplier contracts, management accounts, financial projections, and commercial evidence."
            },
            {
                "q": "How do accelerator programmes help with investor readiness?",
                "a": "Accelerator programmes improve investor readiness through pitch preparation, investor introductions, and operational validation. The strongest programmes also help cohort companies build structured Diligence Packs before demo day."
            }
        ],
        "faqs": [
            {
                "q": "How long does seed round due diligence typically take?",
                "a": "Seed round due diligence typically takes six to eight weeks for an average company, but well-prepared companies with an organised Diligence Pack can complete the process in two to four weeks. Companies that begin assembling information reactively after investor enquiry often find the process extends to ten to sixteen weeks."
            },
            {
                "q": "What is the most common cause of slow due diligence?",
                "a": "The most common cause is reactive information assembly \u2014 companies locating, formatting, and uploading documents after the investor has already asked for them. Every week an investor waits for information, their confidence in the management team reduces. Proactive preparation using a structured Diligence Pack eliminates this problem."
            },
            {
                "q": "How is AI changing startup due diligence timelines?",
                "a": "AI tools enable investors to conduct faster initial document analysis, compressing a week of analyst time into hours. However, AI also surfaces more issues: companies may find AI-assisted investors identify 15\u201320 problems where a human reviewer found five. Companies that organise their documentation before investor analysis are better positioned than those who do so reactively."
            },
            {
                "q": "What is the cost of a prolonged due diligence process?",
                "a": "Beyond management time, a prolonged due diligence process incurs legal and financial adviser fees that can reach tens of thousands of pounds. Cash flow pressure and deal abandonment are also material risks. A six-week process typically costs significantly less than a two-to-three month process."
            },
            {
                "q": "Can a startup shorten its due diligence timeline?",
                "a": "Yes. A company that prepares a complete, structured Diligence Pack before active fundraising \u2014 using a platform with AI-assisted pre-population \u2014 can reduce seed-stage due diligence to two to four weeks. The key is proactive preparation during a programme period or in the months before fundraising begins."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Long Does Startup Due Diligence Take? (2026)",
                "description": "Startup due diligence takes 4\u201312 weeks on average, but well-prepared companies can complete it in 2\u20134 weeks. Learn what drives timeline variance and how AI tools are changing investor analysis.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/accelerator/how-long-does-startup-due-diligence-take/"
                },
                "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-long-does-startup-due-diligence-take.jpg"
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What documents do investors request during seed due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Seed investors typically request: certificate of incorporation, articles of association, complete cap table, director details and IP assignment confirmations, key customer and supplier contracts, management accounts, financial projections, and commercial evidence."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How do accelerator programmes help with investor readiness?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Accelerator programmes improve investor readiness through pitch preparation, investor introductions, and operational validation. The strongest programmes also help cohort companies build structured Diligence Packs before demo day."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long does seed round due diligence typically take?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Seed round due diligence typically takes six to eight weeks for an average company, but well-prepared companies with an organised Diligence Pack can complete the process in two to four weeks. Companies that begin assembling information reactively after investor enquiry often find the process extends to ten to sixteen weeks."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the most common cause of slow due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most common cause is reactive information assembly \u2014 companies locating, formatting, and uploading documents after the investor has already asked for them. Every week an investor waits for information, their confidence in the management team reduces. Proactive preparation using a structured Diligence Pack eliminates this problem."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How is AI changing startup due diligence timelines?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "AI tools enable investors to conduct faster initial document analysis, compressing a week of analyst time into hours. However, AI also surfaces more issues: companies may find AI-assisted investors identify 15\u201320 problems where a human reviewer found five. Companies that organise their documentation before investor analysis are better positioned than those who do so reactively."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the cost of a prolonged due diligence process?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Beyond management time, a prolonged due diligence process incurs legal and financial adviser fees that can reach tens of thousands of pounds. Cash flow pressure and deal abandonment are also material risks. A six-week process typically costs significantly less than a two-to-three month process."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Can a startup shorten its due diligence timeline?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes. A company that prepares a complete, structured Diligence Pack before active fundraising \u2014 using a platform with AI-assisted pre-population \u2014 can reduce seed-stage due diligence to two to four weeks. The key is proactive preparation during a programme period or in the months before fundraising begins."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Accelerators",
                        "item": "https://diligentsia.co.uk/accelerator/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Long Does Startup Due Diligence Take? (2026)",
                        "item": "https://diligentsia.co.uk/accelerator/how-long-does-startup-due-diligence-take/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "pisces",
        "slug": "what-is-pisces-core-disclosures",
        "category": "PISCES",
        "title": "What Is PISCES and What Do Private Companies Need to Disclose? (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-is-pisces-core-disclosures.jpg",
        "metaDescription": "PISCES (Private Intermittent Securities and Capital Exchange System) is the UK's new FCA-regulated framework for private company share trading. This article explains what PISCES is, who it is for, and what Core Disclosure obligations companies face. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/pisces/what-is-pisces-core-disclosures/",
        "bodyHtml": "<p>PISCES is the UK's new regulated market structure for private company shares. It allows existing shareholders in eligible private companies to sell shares during defined intermittent trading windows \u2014 without the company needing to list on a public market. For private company shareholders, management teams, and employees with equity, it represents the first structured route to partial liquidity outside of a full exit or primary fundraising round.</p>\n<h2>What PISCES is \u2014 and what it is not</h2>\n<p>PISCES is a secondary liquidity mechanism, not a primary fundraising tool. Companies do not raise new capital through PISCES trading windows \u2014 existing shareholders sell existing shares to new or existing investors. The company itself does not receive proceeds from PISCES trades.</p>\n<p>PISCES is regulated by the FCA under the framework established in PS 2.3.2R, with admission standards set by individual FCA-authorised operators (such as the London Stock Exchange's Private Share Market). Each operator determines its own admission criteria within the FCA framework. Companies must satisfy admission requirements before participating in any trading window and must produce Core Disclosures for each subsequent window.</p>\n<p><em>Source: FCA Policy Statement PS 2.3.2R and LSE Private Share Market Appendix 2 framework.</em></p>\n<h2>Who PISCES is designed for</h2>\n<p>PISCES is designed for growth-stage private companies \u2014 typically post-revenue, with a track record and governance structure sufficient to satisfy FCA-aligned disclosure requirements. The natural candidates are companies that have completed seed and Series A rounds, have employee share schemes in place, and have shareholders who have held equity for several years without a liquidity event.</p>\n<ul><li>Founders and co-founders seeking partial liquidity without triggering a full exit process</li><li>Early employees with vested options or shares looking to realise some value</li><li>Early angel investors seeking a partial exit route ahead of an IPO or trade sale</li><li>Growth-stage companies using PISCES to improve employee equity retention by demonstrating the shares have real value</li></ul>\n<h2>The Core Disclosure requirement</h2>\n<p>Before each PISCES trading window, participating companies must complete Core Disclosures \u2014 a structured set of regulatory disclosures across 17 prescribed categories. These are not a general-purpose business description. They are a specific regulatory framework structured against PS 2.3.2R and the relevant operator's admission appendix.</p>\n<p><strong>17</strong> Core Disclosure (CD) categories that every PISCES application must address \u2014 covering corporate structure, financials, risk factors, governance, IP, major shareholders, and director information.</p>\n<p><strong>73</strong> structured questions in the Diligentsia PISCES Disclosure Module \u2014 legally reviewed for completeness against all 17 CD categories.</p>\n<p><strong>62%</strong> of checklist responses auto-populated from a company's existing Data Repository on the Diligentsia platform \u2014 reducing completion time from days to hours.</p>\n<h2>The 17 Core Disclosure categories</h2>\n<p>The FCA framework requires disclosure across 17 defined categories. These are not sequential \u2014 they are interdependent, and operators are required to check for consistency across all 17 before admitting a company to a trading window. Key categories include:</p>\n<ul><li><strong>CD1\u2013CD3:</strong> Company overview, business description, and financial position (including going concern)</li><li><strong>CD4\u2013CD5:</strong> Shareholder register, major shareholders, and related party relationships</li><li><strong>CD6\u2013CD8:</strong> Director information, service agreements, and conflicts of interest</li><li><strong>CD9\u2013CD11:</strong> IP ownership, material contracts, and litigation disclosures</li><li><strong>CD12\u2013CD14:</strong> Employee share schemes, option pool, and allotment history</li><li><strong>CD15\u2013CD17:</strong> Risk factors, regulatory compliance, and any other material information</li></ul>\n<p>Cross-CD consistency is a specific obligation: declarations in one category must be consistent with declarations in all others. A share register in CD4 that does not match the major shareholder declaration in CD12, or going-concern language in CD3 that conflicts with the risk tone in CD15, will be flagged by operators \u2014 and by AI tools now standard in operator review workflows.</p>\n<p>PISCES disclosure preparation options compared:</p>\n<div class=\"lp-aeo-table-wrap\"><table><thead><tr><th>Option</th><th>Cost</th><th>Reusable across windows?</th><th>Operator audit trail?</th></tr></thead><tbody><tr><td>Manual / Word document</td><td>Adviser time: \xa35,000\u2013\xa320,000+</td><td>No \u2014 rebuild each window</td><td>No</td></tr><tr><td>Generic data room (VDR)</td><td>\xa3300\u2013\xa3800/month</td><td>Partially</td><td>Limited</td></tr><tr><td>Diligentsia PISCES Module</td><td>From \xa34,999/year</td><td>Yes \u2014 delta only each window</td><td>Yes \u2014 AI review + director cert</td></tr><tr><td>No formal preparation</td><td>\xa30 upfront</td><td>n/a</td><td>No \u2014 regulatory exposure</td></tr></tbody></table></div>\n<h2>Window-over-window obligations</h2>\n<p>A PISCES trading window is not a one-off event. Companies that establish PISCES as a liquidity mechanism must produce updated Core Disclosures for each subsequent window. This means the disclosure burden compounds over time unless companies maintain a continuously updated corporate record.</p>\n<p>The window-over-window approach means that companies with a structured, maintained Data Repository can re-certify material changes only \u2014 with prior disclosures carrying forward. Companies without structured preparation face a full rebuild exercise for every window.</p>\n<h2>Diligentsia PISCES Disclosure Module</h2>\n<p>Diligentsia's PISCES module is the only disclosure preparation tool built specifically around PS 2.3.2R and the LSE PSM Appendix 2 framework \u2014 not adapted from a generic diligence questionnaire. Its 73 structured questions map every FCA Core Disclosure requirement. The AI Analyser independently reviews each of the 17 CD sections, producing a scored report that forms the company's preparation record and the operator's structured review file.</p>\n<p>Diligentsia PISCES Module: from \xa34,999/year. Start at <a href=\"/pisces/\">diligentsia.co.uk/pisces/</a></p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "What is PISCES in the UK?",
                "a": "PISCES (Private Intermittent Securities and Capital Exchange System) is a new UK FCA-regulated market structure for trading shares in private companies. It allows existing shareholders to sell shares during defined intermittent trading windows \u2014 without the company needing to list publicly. It is a secondary liquidity mechanism, not a primary fundraising tool. The FCA framework is set out in Policy Statement PS 2.3.2R; individual operators set admission criteria within this framework."
            },
            {
                "q": "Who can participate in PISCES trading windows?",
                "a": "PISCES is designed for growth-stage private companies that meet FCA-aligned admission criteria. Eligible sellers include founders seeking partial liquidity, early employees with vested equity, and early investors seeking a partial exit ahead of a full exit event. Companies must satisfy their operator's admission requirements and complete Core Disclosures before each trading window."
            },
            {
                "q": "What are PISCES Core Disclosures?",
                "a": "Core Disclosures are a structured set of regulatory disclosures across 17 prescribed categories that companies must complete before each PISCES trading window. They are structured against PS 2.3.2R and the relevant operator's admission appendix. Categories cover corporate structure, financials, risk factors, governance, IP, shareholder register, director information, and material contracts. Cross-CD consistency is a specific obligation \u2014 declarations must be consistent across all 17 categories."
            },
            {
                "q": "How long do PISCES Core Disclosures take to complete?",
                "a": "The time varies significantly by preparation level. Companies using a structured platform like Diligentsia, with an existing Data Repository, can have approximately 62% of responses auto-populated \u2014 reducing completion from days to hours. Companies preparing from scratch using Word documents and manual document review typically spend 2\u20134 weeks and significant adviser time. Window-over-window re-certification for companies on a structured platform covers material changes only."
            },
            {
                "q": "Is PISCES right for my company?",
                "a": "PISCES is most suitable for growth-stage companies with: existing shareholders who want partial liquidity; a track record sufficient to satisfy disclosure requirements; governance structures (board minutes, shareholder register, cap table) that can support the 17-category Core Disclosure process; and a commitment to ongoing window-over-window disclosure obligations. A free 10-minute eligibility check is available at diligentsia.co.uk/pisces/"
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "What Is PISCES and What Do Private Companies Need to Disclose? (2026)",
                "description": "PISCES (Private Intermittent Securities and Capital Exchange System) is the UK's new FCA-regulated framework for private company share trading. This article explains what PISCES is, who it is for, and what Core Disclosure obligations companies face.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/pisces/what-is-pisces-core-disclosures/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is PISCES in the UK?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "PISCES (Private Intermittent Securities and Capital Exchange System) is a new UK FCA-regulated market structure for trading shares in private companies. It allows existing shareholders to sell shares during defined intermittent trading windows \u2014 without the company needing to list publicly. It is a secondary liquidity mechanism, not a primary fundraising tool. The FCA framework is set out in Policy Statement PS 2.3.2R; individual operators set admission criteria within this framework."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Who can participate in PISCES trading windows?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "PISCES is designed for growth-stage private companies that meet FCA-aligned admission criteria. Eligible sellers include founders seeking partial liquidity, early employees with vested equity, and early investors seeking a partial exit ahead of a full exit event. Companies must satisfy their operator's admission requirements and complete Core Disclosures before each trading window."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What are PISCES Core Disclosures?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Core Disclosures are a structured set of regulatory disclosures across 17 prescribed categories that companies must complete before each PISCES trading window. They are structured against PS 2.3.2R and the relevant operator's admission appendix. Categories cover corporate structure, financials, risk factors, governance, IP, shareholder register, director information, and material contracts. Cross-CD consistency is a specific obligation \u2014 declarations must be consistent across all 17 categories."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long do PISCES Core Disclosures take to complete?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The time varies significantly by preparation level. Companies using a structured platform like Diligentsia, with an existing Data Repository, can have approximately 62% of responses auto-populated \u2014 reducing completion from days to hours. Companies preparing from scratch using Word documents and manual document review typically spend 2\u20134 weeks and significant adviser time. Window-over-window re-certification for companies on a structured platform covers material changes only."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Is PISCES right for my company?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "PISCES is most suitable for growth-stage companies with: existing shareholders who want partial liquidity; a track record sufficient to satisfy disclosure requirements; governance structures (board minutes, shareholder register, cap table) that can support the 17-category Core Disclosure process; and a commitment to ongoing window-over-window disclosure obligations. A free 10-minute eligibility check is available at diligentsia.co.uk/pisces/"
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "PISCES",
                        "item": "https://diligentsia.co.uk/pisces/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "What Is PISCES and What Do Private Companies Need to Disclose? (2026)",
                        "item": "https://diligentsia.co.uk/pisces/what-is-pisces-core-disclosures/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "pisces",
        "slug": "how-to-complete-pisces-core-disclosures",
        "category": "PISCES",
        "title": "How Do Companies Complete PISCES Core Disclosures in 2026?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-complete-pisces-core-disclosures.jpg",
        "metaDescription": "A practical guide to completing PISCES Core Disclosures \u2014 covering eligibility, the 5-step preparation process, the 17 Core Disclosure categories, and how structured preparation reduces completion time from weeks to hours. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/pisces/how-to-complete-pisces-core-disclosures/",
        "bodyHtml": "<p>Completing PISCES Core Disclosures is a structured regulatory process, not a general-purpose business description exercise. The FCA framework (PS 2.3.2R) prescribes 17 specific disclosure categories. Operators apply their own admission criteria within this framework and are required to verify consistency across all 17 categories before admitting a company to a trading window.</p>\n<h2>Before you start: confirm PISCES eligibility</h2>\n<p>Not every private company is eligible for PISCES. Eligibility criteria are set by individual FCA-authorised operators and typically include requirements around company size, governance maturity, trading history, and share structure. Before investing time in Core Disclosure preparation, confirm your company meets the operator's admission criteria.</p>\n<p>Diligentsia offers a free 10-minute eligibility check. If your company qualifies, the eligibility check also identifies which elements of your existing governance record will support disclosure preparation and which gaps need to be addressed first.</p>\n<h2>Step 1: Build your Data Repository</h2>\n<p>The single most important preparation step is to organise your corporate documents into a structured, version-controlled Data Repository before beginning the disclosure questionnaire. This is not about creating new documents \u2014 it is about organising what you already have.</p>\n<p>The documents that feed PISCES disclosures directly: certificate of incorporation, articles of association, current shareholder register, cap table, board minutes and written resolutions, employment contracts for directors, option scheme documentation and individual option agreements, material commercial contracts, IP assignment agreements, latest management accounts and financial projections, and any regulatory correspondence or filings.</p>\n<p>Companies with a structured Data Repository on the Diligentsia platform have approximately 62% of their Core Disclosure responses auto-populated from documents they have already uploaded \u2014 reducing completion from days to hours.</p>\n<h2>Step 2: Complete the module \u2014 AI does 62% of the work</h2>\n<p>The Diligentsia PISCES Disclosure Module maps 73 structured questions against all 17 Core Disclosure categories. For companies with an existing Data Repository, approximately 62% of responses are pre-populated by Clarence AI from documents already in the platform. Human review is mandatory \u2014 every AI-generated response must be explicitly marked as reviewed by the responsible director.</p>\n<p>For the remaining responses, the module guides you through each question with context on what the FCA requirement means in practice. Risk scoring is applied to every question \u2014 showing which responses require board-level attention before submission.</p>\n<h2>Step 3: Run the AI Analyser</h2>\n<p>Before submitting to your operator, run Diligentsia's AI Analyser across the completed module. The Analyser reviews each of the 17 CD sections independently, producing a scored report that identifies gaps, inconsistencies, and risk flags. Critically, it checks cross-CD consistency \u2014 catching contradictions across the 17 categories that manual review would miss.</p>\n<p>Critical risk flags (score -4 or -5) \u2014 covering unresolved issues such as criminal conviction, going concern failure, or undisclosed regulatory sanctions \u2014 automatically block certification until resolved. This prevents submissions that would be rejected by the operator from leaving the platform.</p>\n<h2>Step 4: Director sign-off and certification</h2>\n<p>Once the AI Analyser is satisfied and all material responses are reviewed, the responsible director completes formal certification within the module. This is integrated into the workflow \u2014 not a separate document. The certification captures the director's identity, a timestamp, and the AI Analyser's review outputs \u2014 forming a structured record of the preparation process.</p>\n<p>Diligentsia awards Bronze, Silver, or Gold certification based on completeness and risk score. The operator receives a structured admission pack with the AI review outputs, section scores, and the director's certification \u2014 not a document bundle.</p>\n<h2>Step 5: Submit to your PISCES operator</h2>\n<p>The Diligentsia platform generates a formatted Core Disclosure Document automatically from the verified, certified checklist \u2014 carrying the company's director certification and your operator's review timestamp. For operators using Diligentsia as their admission infrastructure, submission is direct from the platform. For other operators, the structured document can be exported and submitted via the operator's standard process.</p>\n<h2>Window-over-window: subsequent trading windows</h2>\n<p>For subsequent trading windows, re-certification covers material changes only. The platform tracks exactly which CD sections have been updated since the prior window \u2014 so your review (and the operator's re-review) is focused on new material only. First-window preparation typically takes days; subsequent windows typically take hours.</p>\n<h2>Diligentsia PISCES Module pricing</h2>\n<p>Purpose-built for PS 2.3.2R and LSE PSM Appendix 2:</p>\n<div class=\"lp-aeo-table-wrap\"><table><thead><tr><th>Plan</th><th>Price</th><th>Best for</th><th>Key features</th></tr></thead><tbody><tr><td>Free eligibility check</td><td>Free</td><td>All companies considering PISCES</td><td>10-minute check \u2014 confirms eligibility and identifies preparation gaps</td></tr><tr><td>PISCES Module (SaaS)</td><td>From \xa34,999/year</td><td>Companies preparing for PISCES trading</td><td>73-question module, 62% autofill, AI Analyser, director certification, window-over-window tracking, operator-ready output</td></tr></tbody></table></div>\n<p>The Diligentsia PISCES module is the only disclosure preparation tool built specifically around PS 2.3.2R and the LSE PSM Appendix 2 framework \u2014 not adapted from a generic diligence questionnaire.</p>\n<h2>Ready to start your PISCES preparation?</h2>\n<p>Begin with a free 10-minute eligibility check. If your company qualifies, the check identifies your preparation gaps and shows exactly what is required before your first trading window.</p>\n<p><strong><a href=\"/pisces/\">diligentsia.co.uk/pisces/</a></strong></p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "How do companies complete PISCES Core Disclosures?",
                "a": "PISCES Core Disclosures are completed through a 5-step process: (1) confirm eligibility with your chosen operator; (2) build a structured Data Repository of corporate documents; (3) complete the 17-category, 73-question disclosure module (approximately 62% auto-populated from existing documents on the Diligentsia platform); (4) run an AI review for cross-CD consistency and gap identification; and (5) complete director certification and submit to the operator."
            },
            {
                "q": "How long does it take to complete PISCES disclosures?",
                "a": "Completion time varies significantly by preparation level. Companies using Diligentsia with an existing Data Repository can have approximately 62% of responses auto-populated \u2014 reducing first-window completion to days rather than weeks. Subsequent trading windows require only a review of material changes and typically take hours. Companies preparing from scratch using manual approaches typically spend 2\u20134 weeks on first-window preparation, with similar time required at each subsequent window."
            },
            {
                "q": "What is the cost of PISCES disclosure preparation?",
                "a": "Manual preparation via adviser time typically costs \xa35,000\u2013\xa320,000+ per window (legal and advisory fees). The Diligentsia PISCES Module is available from \xa34,999/year \u2014 covering first and subsequent windows, with auto-population from existing documents, AI review, director certification, and operator-ready output. A free 10-minute eligibility check is available before any commitment."
            },
            {
                "q": "What happens after the director certification step?",
                "a": "After director certification, the Diligentsia platform generates a formatted Core Disclosure Document from the verified, certified checklist \u2014 carrying the director's certification and a timestamped AI review audit trail. For operators using Diligentsia as their admission infrastructure, the structured operator admission pack is delivered directly. For other operators, the document can be exported and submitted via the operator's standard process."
            },
            {
                "q": "Does PISCES preparation have value outside the trading window?",
                "a": "Yes. The corporate documentation organised for PISCES Core Disclosures \u2014 shareholder register, cap table, director information, IP records, material contracts, financial records \u2014 is the same documentation required for investor due diligence, M&amp;A processes, and general governance. Data built for PISCES does not sit idle between windows: it becomes the foundation of your company's permanent governance record, available for every future transaction or investor conversation."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Do Companies Complete PISCES Core Disclosures in 2026?",
                "description": "A practical guide to completing PISCES Core Disclosures \u2014 covering eligibility, the 5-step preparation process, the 17 Core Disclosure categories, and how structured preparation reduces completion time from weeks to hours.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/pisces/how-to-complete-pisces-core-disclosures/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "How do companies complete PISCES Core Disclosures?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "PISCES Core Disclosures are completed through a 5-step process: (1) confirm eligibility with your chosen operator; (2) build a structured Data Repository of corporate documents; (3) complete the 17-category, 73-question disclosure module (approximately 62% auto-populated from existing documents on the Diligentsia platform); (4) run an AI review for cross-CD consistency and gap identification; and (5) complete director certification and submit to the operator."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long does it take to complete PISCES disclosures?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Completion time varies significantly by preparation level. Companies using Diligentsia with an existing Data Repository can have approximately 62% of responses auto-populated \u2014 reducing first-window completion to days rather than weeks. Subsequent trading windows require only a review of material changes and typically take hours. Companies preparing from scratch using manual approaches typically spend 2\u20134 weeks on first-window preparation, with similar time required at each subsequent window."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the cost of PISCES disclosure preparation?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Manual preparation via adviser time typically costs \xa35,000\u2013\xa320,000+ per window (legal and advisory fees). The Diligentsia PISCES Module is available from \xa34,999/year \u2014 covering first and subsequent windows, with auto-population from existing documents, AI review, director certification, and operator-ready output. A free 10-minute eligibility check is available before any commitment."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What happens after the director certification step?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "After director certification, the Diligentsia platform generates a formatted Core Disclosure Document from the verified, certified checklist \u2014 carrying the director's certification and a timestamped AI review audit trail. For operators using Diligentsia as their admission infrastructure, the structured operator admission pack is delivered directly. For other operators, the document can be exported and submitted via the operator's standard process."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Does PISCES preparation have value outside the trading window?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes. The corporate documentation organised for PISCES Core Disclosures \u2014 shareholder register, cap table, director information, IP records, material contracts, financial records \u2014 is the same documentation required for investor due diligence, M&amp;A processes, and general governance. Data built for PISCES does not sit idle between windows: it becomes the foundation of your company's permanent governance record, available for every future transaction or investor conversation."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "PISCES",
                        "item": "https://diligentsia.co.uk/pisces/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Do Companies Complete PISCES Core Disclosures in 2026?",
                        "item": "https://diligentsia.co.uk/pisces/how-to-complete-pisces-core-disclosures/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "pisces",
        "slug": "how-ai-is-changing-pisces-disclosure-preparation",
        "category": "PISCES",
        "title": "How Is AI Changing PISCES Disclosure Preparation for Private Companies in 2026?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-ai-is-changing-pisces-disclosure-preparation.jpg",
        "metaDescription": "AI tools are changing how PISCES operators review Core Disclosures \u2014 and raising the bar for what constitutes adequate preparation. This article explains what has changed and what companies need to do differently to pass operator review in 2026. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/pisces/how-ai-is-changing-pisces-disclosure-preparation/",
        "bodyHtml": "<p>PISCES Core Disclosure preparation has historically been a manual exercise: a company director completes a Word document, an adviser reviews it, and it is submitted to the operator for assessment. This approach is slow, inconsistent, produces no structured audit trail \u2014 and is increasingly inadequate as operators deploy AI tools to review submissions at scale.</p>\n<h2>How operators are now reviewing Core Disclosures</h2>\n<p>PISCES operators are required by the FCA to satisfy themselves that applicant companies have made complete and accurate Core Disclosures across all 17 categories before each trading window. As applicant pipelines grow, manual document review does not scale. Operators are increasingly deploying AI tools that analyse disclosure documents with a depth and speed that was previously impossible for human reviewers.</p>\n<p>These tools do not just check for completeness. They identify inconsistencies across the 17 Core Disclosure categories \u2014 for example, where the share register in CD4 does not match the major shareholder declaration in CD12, or where going-concern language in CD3 conflicts with the risk tone in CD15. They flag under-disclosed risk factors, incomplete director information, and contradictions that a manual reviewer might miss on a single read-through.</p>\n<p><strong>\"AI tools are now capable of analysing disclosure documents with a depth and speed that was previously impossible. Investors and their advisers will use these tools. Gaps, inconsistencies, and under-disclosed risk factors will be surfaced.\"</strong></p>\n<p>\u2014 Diligentsia PISCES Platform Documentation (2026)</p>\n<h2>What AI-powered review means for company preparation</h2>\n<p>The practical implication is that disclosure documents which would have passed a manual review may not pass an AI-assisted operator review. The bar has moved. Companies that prepare rigorously \u2014 with structured data, cross-checked disclosures, and a clean audit trail \u2014 will attract investor confidence and pass operator review faster. Companies that have not will face questions they were not expecting, delayed windows, and potential re-submission requirements.</p>\n<p>The most common failure modes under AI-powered review:</p>\n<ul><li><strong>Cross-CD inconsistencies:</strong> declarations in one category that contradict another \u2014 particularly between the shareholder register (CD4), major shareholder disclosures (CD12), and option scheme records (CD13)</li><li><strong>Going concern language:</strong> any indication in CD3 (financial position) that conflicts with the risk factor disclosure in CD15</li><li><strong>Director information gaps:</strong> incomplete or inconsistent biographical information across CD6, CD7, and CD8</li><li><strong>IP ownership gaps:</strong> informal IP arrangements not formally documented in CD9</li><li><strong>Material contract gaps:</strong> significant commercial relationships not covered in CD10</li></ul>\n<h2>The structured evidence approach</h2>\n<p>The companies that navigate AI-powered operator review most effectively are those that have organised their corporate evidence before the disclosure process begins \u2014 not during it. This means maintaining a structured, current Data Repository: a canonical document store where every corporate record is version-controlled and consistently formatted.</p>\n<p>When a structured Data Repository exists, approximately 62% of PISCES Core Disclosure responses can be auto-populated from documents the company already holds \u2014 with every answer linked to its source document and requiring human review before submission. The disclosure process becomes a structured review exercise, not an information collection exercise.</p>\n<p><strong>\"Companies that have prepared rigorously \u2014 with structured data, cross-checked disclosures, and a clean audit trail \u2014 will attract investor confidence. Companies that have not will face questions they were not expecting.\"</strong></p>\n<p>\u2014 Diligentsia PISCES Platform Documentation (2026)</p>\n<h2>Window-over-window: the compounding preparation advantage</h2>\n<p>PISCES is a recurring obligation, not a one-off event. Companies that plan to operate multiple trading windows need a preparation approach that compounds rather than restarts. A structured platform with window-over-window delta tracking means that subsequent windows require only a review of material changes since the prior disclosure \u2014 not a full rebuild.</p>\n<p>Companies using a structured preparation platform report that first-window preparation takes days; subsequent window re-certification takes hours. Companies using manual approaches face near-full preparation time at every window \u2014 with the additional risk that prior disclosures are no longer consistent with the current corporate record.</p>\n<p><strong>\"Data you upload for PISCES does not sit idle between trading windows. It becomes the foundation of your company's governance record \u2014 available for the next investor conversation, the next due diligence exercise, or the next M&amp;amp;A process.\"</strong></p>\n<p>\u2014 Diligentsia PISCES Company Documentation (2026)</p>\n<h2>The director certification requirement</h2>\n<p>Every PISCES Core Disclosure submission requires director certification \u2014 a formal sign-off that the disclosures are complete and accurate. This is not a procedural formality. In the event of a regulatory challenge, the director's certification is the company's documented assurance that the disclosure process was conducted with appropriate rigour.</p>\n<p>Diligentsia builds Director Certification directly into the module workflow \u2014 not as separate paperwork, but as an integrated step in the disclosure completion process. The AI Analyser's review outputs, the director's certification, and a timestamped audit trail are all captured in the same structured record.</p>\n<h2>The Diligentsia AI Analyser</h2>\n<p>Diligentsia's AI Analyser independently reviews each of the 17 Core Disclosure sections \u2014 producing a scored mini-diligence report per section. It applies the same scrutiny as an operator's review tool, before the company's documents reach the operator. Issues are surfaced and resolved internally, not by the operator at the point of admission.</p>\n<ul><li><strong>Section-by-section scoring:</strong> each CD section receives a structured assessment with gap identification</li><li><strong>Cross-CD consistency check:</strong> AI cross-references declarations across all 17 sections</li><li><strong>Critical score auto-block:</strong> unresolved scores of -4 or -5 (criminal conviction, going concern failure, undisclosed sanctions) automatically block certification</li><li><strong>Timestamped audit trail:</strong> every AI review output is captured with a timestamp \u2014 forming the company's preparation record</li></ul>\n<p>Diligentsia PISCES Module: from \xa34,999/year. Start at <a href=\"/pisces/\">diligentsia.co.uk/pisces/</a></p>",
        "peopleAlsoAsk": [
            {
                "q": "What do PISCES operators check before a trading window?",
                "a": "PISCES operators are required to satisfy themselves that applicant companies have made complete and accurate Core Disclosures across all 17 FCA-prescribed categories. This includes checking cross-CD consistency \u2014 that declarations in one category are consistent with all others. AI tools are increasingly used for this review, identifying inconsistencies and under-disclosed risk factors that manual reviewers might miss. Companies should apply the same level of scrutiny to their own preparation before submitting."
            },
            {
                "q": "What happens if a PISCES disclosure is inadequate?",
                "a": "If a PISCES operator determines that Core Disclosures are incomplete or inconsistent, the company will be required to re-submit before the trading window can proceed. Repeated inadequate submissions risk delayed or cancelled windows \u2014 and the reputational consequences with existing shareholders who were expecting a liquidity opportunity. Where disclosures contain material errors, the company and its directors face regulatory exposure under the FCA's PISCES framework."
            }
        ],
        "faqs": [
            {
                "q": "How is AI changing PISCES disclosure preparation?",
                "a": "AI tools deployed by PISCES operators now analyse Core Disclosure documents across all 17 categories, identifying inconsistencies, under-disclosed risk factors, and gaps that manual reviewers might miss. The practical effect for companies: the standard for disclosure quality is rising. Preparation that passed manual review two years ago may not pass AI-assisted operator review today. The response: apply the same AI scrutiny to your own preparation before submission."
            },
            {
                "q": "What is cross-CD consistency in PISCES disclosures?",
                "a": "Cross-CD consistency means that declarations made in one Core Disclosure category must be consistent with declarations in all other categories. Common examples of inconsistency: a shareholder register in CD4 that does not match the major shareholder declaration in CD12; going-concern language in CD3 that conflicts with risk factor disclosures in CD15; or option scheme records in CD13 that do not reconcile with the allotment history in CD14. AI-powered operator review specifically targets these cross-category inconsistencies."
            },
            {
                "q": "How does window-over-window PISCES preparation work?",
                "a": "Companies with a maintained, structured Data Repository can re-certify material changes only for each subsequent trading window \u2014 with prior disclosures carrying forward. Diligentsia tracks the delta between windows: exactly which CD sections were updated, what changed, and when \u2014 so the company's re-review and the operator's re-review are both focused on new material only. Companies without structured preparation face a near-full rebuild at each window."
            },
            {
                "q": "What is the director certification requirement for PISCES?",
                "a": "Director certification is a formal sign-off that the Core Disclosures are complete and accurate, required before submission to the operator. It is the company's documented assurance of disclosure rigour. In the event of a regulatory challenge, the director's certification and the preparation process that preceded it are the primary evidence of compliance. Diligentsia integrates director certification directly into the module workflow, with a timestamped audit trail."
            },
            {
                "q": "What risk score levels matter in PISCES disclosure preparation?",
                "a": "Diligentsia's AI Analyser assigns risk scores to every PISCES disclosure question. Critical scores of -4 or -5 \u2014 triggered by unresolved issues such as criminal conviction, going concern failure, or undisclosed sanctions \u2014 automatically block certification and trigger operator alerts. These represent the L1 mandatory FCA requirements: 100% completion across all L1 questions is a prerequisite for any certification level."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Is AI Changing PISCES Disclosure Preparation for Private Companies in 2026?",
                "description": "AI tools are changing how PISCES operators review Core Disclosures \u2014 and raising the bar for what constitutes adequate preparation. This article explains what has changed and what companies need to do differently to pass operator review in 2026.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/pisces/how-ai-is-changing-pisces-disclosure-preparation/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What do PISCES operators check before a trading window?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "PISCES operators are required to satisfy themselves that applicant companies have made complete and accurate Core Disclosures across all 17 FCA-prescribed categories. This includes checking cross-CD consistency \u2014 that declarations in one category are consistent with all others. AI tools are increasingly used for this review, identifying inconsistencies and under-disclosed risk factors that manual reviewers might miss. Companies should apply the same level of scrutiny to their own preparation before submitting."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What happens if a PISCES disclosure is inadequate?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "If a PISCES operator determines that Core Disclosures are incomplete or inconsistent, the company will be required to re-submit before the trading window can proceed. Repeated inadequate submissions risk delayed or cancelled windows \u2014 and the reputational consequences with existing shareholders who were expecting a liquidity opportunity. Where disclosures contain material errors, the company and its directors face regulatory exposure under the FCA's PISCES framework."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How is AI changing PISCES disclosure preparation?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "AI tools deployed by PISCES operators now analyse Core Disclosure documents across all 17 categories, identifying inconsistencies, under-disclosed risk factors, and gaps that manual reviewers might miss. The practical effect for companies: the standard for disclosure quality is rising. Preparation that passed manual review two years ago may not pass AI-assisted operator review today. The response: apply the same AI scrutiny to your own preparation before submission."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is cross-CD consistency in PISCES disclosures?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Cross-CD consistency means that declarations made in one Core Disclosure category must be consistent with declarations in all other categories. Common examples of inconsistency: a shareholder register in CD4 that does not match the major shareholder declaration in CD12; going-concern language in CD3 that conflicts with risk factor disclosures in CD15; or option scheme records in CD13 that do not reconcile with the allotment history in CD14. AI-powered operator review specifically targets these cross-category inconsistencies."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does window-over-window PISCES preparation work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Companies with a maintained, structured Data Repository can re-certify material changes only for each subsequent trading window \u2014 with prior disclosures carrying forward. Diligentsia tracks the delta between windows: exactly which CD sections were updated, what changed, and when \u2014 so the company's re-review and the operator's re-review are both focused on new material only. Companies without structured preparation face a near-full rebuild at each window."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the director certification requirement for PISCES?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Director certification is a formal sign-off that the Core Disclosures are complete and accurate, required before submission to the operator. It is the company's documented assurance of disclosure rigour. In the event of a regulatory challenge, the director's certification and the preparation process that preceded it are the primary evidence of compliance. Diligentsia integrates director certification directly into the module workflow, with a timestamped audit trail."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What risk score levels matter in PISCES disclosure preparation?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Diligentsia's AI Analyser assigns risk scores to every PISCES disclosure question. Critical scores of -4 or -5 \u2014 triggered by unresolved issues such as criminal conviction, going concern failure, or undisclosed sanctions \u2014 automatically block certification and trigger operator alerts. These represent the L1 mandatory FCA requirements: 100% completion across all L1 questions is a prerequisite for any certification level."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "PISCES",
                        "item": "https://diligentsia.co.uk/pisces/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Is AI Changing PISCES Disclosure Preparation for Private Companies in 2026?",
                        "item": "https://diligentsia.co.uk/pisces/how-ai-is-changing-pisces-disclosure-preparation/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "cfo",
        "slug": "sme-due-diligence-cost-statistics",
        "category": "Fractional CFOs",
        "title": "What Does SME Due Diligence Cost \u2014 and How Are Fractional CFOs Responding? (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/sme-due-diligence-cost-statistics.jpg",
        "metaDescription": "Current statistics on SME due diligence: cost, time, completion rates, and the impact of AI. Data relevant to fractional CFOs advising clients on investment readiness, exit preparation, and growth governance. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/cfo/sme-due-diligence-cost-statistics/",
        "bodyHtml": '<p>Understanding the data landscape for SME due diligence helps fractional CFOs frame the conversation with clients correctly \u2014 and identify where preparation creates the most value. This article presents the key statistics relevant to the fractional CFO advisory context in 2026.</p>\n<h2>The scale of the diligence gap</h2>\n<p><strong>70%</strong> of SME equity investments and exits are never externally diligenced. Triangulated estimate from British Business Bank, Beauhurst, and UKBAA report data.</p>\n<p><strong>&amp;lt; 1%</strong> of unsolicited applications to VC funds result in investment (PAR Equity: 1,000\u20131,500 applications, approximately 10 investments per year).</p>\n<p>The core problem: traditional due diligence costs \xa310,000\u2013\xa350,000 per SME transaction. At deal sizes common in early-stage investment (\xa325k\u2013\xa32M), this cost is prohibitive. The result is that most investment decisions are made on incomplete information \u2014 which increases risk for investors and leaves companies vulnerable to price chipping and deal collapse.</p>\n<h2>The cost of traditional due diligence</h2>\n<h2>\xa310,000\u2013\xa350,000</h2>\n<p>typical cost of externally managed due diligence per SME transaction (legal, financial, and technical diligence combined).</p>\n<h2>\xa3300\u2013\xa3800/month</h2>\n<p>average Virtual Data Room (VDR) cost \u2014 and VDRs disappear when the transaction ends. Diligentsia costs \xa31,000/year and is a permanent, compounding asset.</p>\n<p>Diligence preparation options compared:</p>\n<div class="lp-aeo-table-wrap"><table><thead><tr><th>Option</th><th>Cost</th><th>Permanence</th><th>Reusable?</th></tr></thead><tbody><tr><td>External diligence firm</td><td>\xa310,000\u2013\xa350,000 per transaction</td><td>One transaction only</td><td>No</td></tr><tr><td>Virtual Data Room (VDR)</td><td>\xa3300\u2013\xa3800/month</td><td>Active while subscription live</td><td>Partially</td></tr><tr><td>Diligentsia (AI-assisted platform)</td><td>\xa31,000/year</td><td>Permanent, compounding asset</td><td>Yes \u2014 every future transaction</td></tr><tr><td>No preparation</td><td>\xa30 upfront</td><td>n/a</td><td>No \u2014 rework each time</td></tr></tbody></table></div>\n<p>For fractional CFOs advising clients on exit preparation, the practical message is that the traditional diligence model is unaffordable for most SMEs. The choice has historically been between unaffordable preparation and unprepared companies. AI has changed this equation.</p>\n<h2>The time cost of unpreparedness</h2>\n<p><strong>"It is not that it does not get done. It just takes longer to answer those questions three months down the line than if they are answered three weeks into it. That is the biggest problem."</strong></p>\n<p>\u2014 Investment Manager, early-stage fund</p>\n<p><strong>3 days</strong> time required to complete a full certified Diligence Pack for a well-organised company using Diligentsia Pro.</p>\n<p><strong>3\u20136 months</strong> additional time added to a funding round when companies are not prepared before investor conversations begin (practitioner estimate).</p>\n<h2>The AI autofill impact</h2>\n<p><strong>~60%</strong> of diligence modules auto-populated by Clarence AI at Diligentsia platform launch (June 2026). Every answer evidence-linked and human-reviewed.</p>\n<p>The 60% autofill figure represents the proportion of diligence module questions that can be answered directly from documents a company already holds \u2014 financial statements, contracts, employment records, board papers, IP filings. The remaining 40% requires active input from the company team, typically in areas where documentation gaps exist.</p>\n<p>Importantly, AI autofill does not remove the human review requirement. Every AI-generated answer must be explicitly marked as reviewed by a named reviewer, with a timestamp. The audit trail is immutable. This is what distinguishes a verified diligence pack from a generated document.</p>\n<h2>Platform adoption and community data</h2>\n<p><strong>80+</strong> fractional CFOs using Diligentsia as of June 2026, drawn from the largest UK CFO organisations.</p>\n<p><strong>40+</strong> VC investors integrated into InvestorMatch \u2014 providing direct introduction access for prepared companies.</p>\n<p><strong>200+</strong> live companies on the Diligentsia platform as of June 2026.</p>\n<p><strong>1,053</strong> total signups since platform launch.</p>\n<h2>What the data tells fractional CFOs</h2>\n<ul><li>Clients who are not actively raising are still affected by the diligence gap \u2014 because unprepared companies grow slower, face higher acquisition costs, and are more vulnerable to last-minute price chipping in future transactions.</li><li>The 60% AI autofill rate means that most of the work required to reach a credible first certification level can be done in days, not months \u2014 changing the "I don\'t have time" objection from a barrier to a question of prioritisation.</li><li><strong>The cost argument is asymmetric:</strong> \xa31,000/year vs. \xa310,000\u2013\xa350,000 per transaction \u2014 and Diligentsia work is done once and reused for every future transaction.</li><li>Fractional CFOs who introduce clients to the platform benefit from the same structured data their clients build \u2014 using it to surface advisory opportunities, generate quarterly review agendas, and demonstrate ongoing value.</li></ul>\n<p>See how fractional CFOs use the platform in practice: <a href="/cfo/how-fractional-cfos-use-diligentsia/">diligentsia.co.uk/cfo/how-fractional-cfos-use-diligentsia/</a></p>',
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "What does SME due diligence typically cost in the UK?",
                "a": "Traditional externally managed due diligence for an SME transaction costs \xa310,000\u2013\xa350,000 (legal, financial, and technical combined). Virtual Data Rooms cost \xa3300\u2013\xa3800/month. AI-assisted investment readiness platforms like Diligentsia have reduced this to \xa31,000/year \u2014 less than one day of fractional CFO time \u2014 while producing a permanent, reusable asset rather than a one-transaction document set."
            },
            {
                "q": "What proportion of SME investments are never externally diligenced?",
                "a": "70% of SME equity investments and exits are never externally diligenced, based on triangulated data from the British Business Bank, Beauhurst, and UKBAA. The structural cause is that traditional diligence costs (\xa310,000\u2013\xa350,000) are prohibitive at typical angel and early-stage deal sizes (\xa325,000\u2013\xa32M). AI-assisted platforms have changed this economics for the first time."
            },
            {
                "q": "How much time does poor preparation add to a funding round?",
                "a": "Practitioner data indicates that companies that begin assembling documentation reactively after investor interest is established add three to six months to their funding rounds, compared to companies with pre-prepared Diligence Packs. A well-organised company using a structured AI-assisted platform can complete a full certified pack in as little as three days."
            },
            {
                "q": "How does 60% AI autofill work in practice?",
                "a": "Diligentsia's AI (Clarence) pre-populates approximately 60% of standard due diligence modules from documents the company already holds \u2014 financial statements, contracts, board papers, IP filings. Every AI-generated answer is linked to its source document and requires explicit human review and sign-off before it can be shared with investors. The remaining 40% is completed actively by the company team, typically in areas where documentation gaps exist."
            },
            {
                "q": "How many fractional CFOs are using Diligentsia?",
                "a": "As of June 2026, 80+ fractional CFOs are using Diligentsia, drawn from the largest UK CFO organisations. Several fractional CFOs have become investors in the platform after using it with clients. The platform also has 40+ VC investors integrated into InvestorMatch, providing prepared companies with direct introduction access."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "What Does SME Due Diligence Cost \u2014 and How Are Fractional CFOs Responding? (2026)",
                "description": "Current statistics on SME due diligence: cost, time, completion rates, and the impact of AI. Data relevant to fractional CFOs advising clients on investment readiness, exit preparation, and growth governance.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/cfo/sme-due-diligence-cost-statistics/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What does SME due diligence typically cost in the UK?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Traditional externally managed due diligence for an SME transaction costs \xa310,000\u2013\xa350,000 (legal, financial, and technical combined). Virtual Data Rooms cost \xa3300\u2013\xa3800/month. AI-assisted investment readiness platforms like Diligentsia have reduced this to \xa31,000/year \u2014 less than one day of fractional CFO time \u2014 while producing a permanent, reusable asset rather than a one-transaction document set."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What proportion of SME investments are never externally diligenced?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "70% of SME equity investments and exits are never externally diligenced, based on triangulated data from the British Business Bank, Beauhurst, and UKBAA. The structural cause is that traditional diligence costs (\xa310,000\u2013\xa350,000) are prohibitive at typical angel and early-stage deal sizes (\xa325,000\u2013\xa32M). AI-assisted platforms have changed this economics for the first time."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How much time does poor preparation add to a funding round?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Practitioner data indicates that companies that begin assembling documentation reactively after investor interest is established add three to six months to their funding rounds, compared to companies with pre-prepared Diligence Packs. A well-organised company using a structured AI-assisted platform can complete a full certified pack in as little as three days."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does 60% AI autofill work in practice?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Diligentsia's AI (Clarence) pre-populates approximately 60% of standard due diligence modules from documents the company already holds \u2014 financial statements, contracts, board papers, IP filings. Every AI-generated answer is linked to its source document and requires explicit human review and sign-off before it can be shared with investors. The remaining 40% is completed actively by the company team, typically in areas where documentation gaps exist."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How many fractional CFOs are using Diligentsia?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "As of June 2026, 80+ fractional CFOs are using Diligentsia, drawn from the largest UK CFO organisations. Several fractional CFOs have become investors in the platform after using it with clients. The platform also has 40+ VC investors integrated into InvestorMatch, providing prepared companies with direct introduction access."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Fractional CFOs",
                        "item": "https://diligentsia.co.uk/cfo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "What Does SME Due Diligence Cost \u2014 and How Are Fractional CFOs Responding? (2026)",
                        "item": "https://diligentsia.co.uk/cfo/sme-due-diligence-cost-statistics/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "cfo",
        "slug": "how-ai-is-changing-fractional-cfo-role",
        "category": "Fractional CFOs",
        "title": "How AI Is Changing the Role of the Fractional CFO \u2014 and What the Best Are Doing About It (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-ai-is-changing-fractional-cfo-role.jpg",
        "metaDescription": "AI tools are reshaping fractional CFO work. This article explains what is changing, what is not, and how the best fractional CFOs are using AI to become more valuable to their clients \u2014 not less. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/cfo/how-ai-is-changing-fractional-cfo-role/",
        "bodyHtml": '<p>Artificial intelligence is changing the economics of financial advisory work faster than most fractional CFOs anticipated. Tasks that once justified a day of time \u2014 financial analysis, market research, document compilation \u2014 can now be completed in minutes by AI tools that cost less than \xa320 per month. Clients are noticing. And many are asking harder questions about the value of professional advisory time.</p>\n<p>The question for every fractional CFO is not whether AI will affect their work. It already has. The question is whether they respond by defending the old model, or redefining what a fractional CFO delivers in an AI era.</p>\n<h2>What AI can do \u2014 and what it cannot</h2>\n<p>AI tools are exceptionally good at generating plausible answers from large volumes of text. They can summarise documents, draft reports, and produce analyses at speed. For fractional CFOs, this means some tasks that previously occupied significant engagement time can now be partially automated.</p>\n<p>But AI has a critical limitation: it can only work with structured, complete, verified data. Point a large language model at a messy Dropbox folder of inconsistent documents, and the output reflects the mess. "Rubbish in, rubbish out" has not changed because the tool is smarter.</p>\n<p>What AI cannot replace: the judgment required to interpret AI output in the context of a real business; the trust relationship built over years of client engagement; the ability to verify that AI-generated answers are accurate and evidence-backed; and the strategic advisory function that converts data into decisions.</p>\n<h2>The fractional CFO as AI conductor</h2>\n<p>The fractional CFOs who are winning the AI argument are positioning themselves not as providers of raw analysis \u2014 which AI can increasingly replicate \u2014 but as the orchestrators of AI-powered advisory work. They are the people who make AI work correctly for their clients, not the people being replaced by it.</p>\n<p>This reframing requires a tool that makes AI work properly \u2014 one that structures the client\'s data before AI touches it, ensures human review on every AI-generated output, and produces verified, auditable results that a generic AI tool cannot.</p>\n<p><strong>"You could walk into any assignment and start at 60% instead of zero."</strong></p>\n<p>\u2014 FR, Fractional CFO and Diligentsia investor</p>\n<h2>The structured evidence approach</h2>\n<p>Diligentsia operates a structured evidence graph: a platform that links regulatory assertions, evidence documents, human review workflows, risk scoring, and audit trails into a single verified system. When AI auto-populates approximately 60% of a company\'s diligence modules, every answer is linked to its source document and requires explicit human sign-off before it can be shared.</p>\n<p>This is the technical moat that generic AI cannot replicate. It is not the AI capability itself \u2014 it is the verification layer, the audit trail, and the certification framework built around it that produces outputs clients and investors trust.</p>\n<p><strong>"AI generates answers. Diligentsia generates trust."</strong></p>\n<p>\u2014 Diligentsia positioning statement</p>\n<h2>What the best fractional CFOs are doing differently</h2>\n<ul><li>Walking into every new client engagement with a structured, AI-populated foundation \u2014 not a blank page</li><li>Using quarterly review cycles to surface new billable work systematically, not by accident</li><li>Presenting clients with third-party validated certification scores (Bronze/Silver/Gold) that make advisory progress measurable</li><li>Treating the AI disruption conversation as a business development argument, not a threat to defend against</li></ul>\n<p>The fractional CFOs who set the standard now will be the ones who define what the role means in five years. Those who wait will be explaining themselves to clients who have already decided.</p>\n<p>See the practical guide: <a href="/cfo/how-fractional-cfos-use-diligentsia/">diligentsia.co.uk/cfo/how-fractional-cfos-use-diligentsia/</a></p>\n<h2>Summary</h2>\n<ul><li>AI is changing what fractional CFOs do, but not what they are worth to clients who understand the difference.</li><li>The value shift is from task execution to structured advisory judgment \u2014 and the verification layer that makes AI outputs trustworthy.</li><li>The best fractional CFOs are becoming AI conductors: using platforms like Diligentsia to make AI work correctly, not just quickly.</li><li>80+ fractional CFOs have adopted this model; several have become investors in the platform after using it.</li></ul>',
        "peopleAlsoAsk": [
            {
                "q": "Will AI replace fractional CFOs?",
                "a": "AI will replace the task-execution components of fractional CFO work \u2014 document compilation, data analysis, standard reporting. It will not replace the judgment, trust relationship, or strategic advisory function that converts data into business decisions. The fractional CFOs who position themselves as AI conductors \u2014 structuring client data and verifying AI outputs \u2014 will become more valuable, not less."
            },
            {
                "q": "How can fractional CFOs use AI to win more clients?",
                "a": "The most effective approach is to use AI-assisted platforms to demonstrate structured value from day one: walking into new engagements with AI-populated client foundations, surfacing billable opportunities systematically through quarterly review cycles, and providing clients with measurable certification scores. See the practical guide: diligentsia.co.uk/cfo/how-fractional-cfos-use-diligentsia/"
            }
        ],
        "faqs": [
            {
                "q": "How is AI changing fractional CFO work?",
                "a": "AI is automating the task-execution components of fractional CFO work \u2014 analysis, document compilation, standard reporting \u2014 at a cost of less than \xa320/month. This is shifting client expectations from time-based task delivery toward strategic advisory judgment. The fractional CFOs responding most effectively are repositioning as AI conductors: structuring client data, verifying AI outputs, and demonstrating value through certified, auditable results."
            },
            {
                "q": "What is the difference between AI-generated analysis and AI-verified analysis?",
                "a": "AI-generated analysis uses a language model to produce plausible output from whatever data it has \u2014 including unverified, inconsistent, or incomplete sources. AI-verified analysis requires that every AI-generated answer is linked to a source document, reviewed by a named human reviewer, and timestamped. Diligentsia's structured evidence approach produces the latter \u2014 output that clients and investors trust, not just output that reads well."
            },
            {
                "q": "How do the best fractional CFOs use Diligentsia?",
                "a": 'The leading fractional CFOs on Diligentsia use it in three ways: (1) walking into new client engagements with AI-populated client foundations rather than a blank page \u2014 "starting at 60% instead of zero"; (2) using quarterly review cycles to surface billable advisory opportunities systematically; and (3) providing clients with Bronze/Silver/Gold certification scores that make advisory progress visible and demonstrable.'
            },
            {
                "q": "Do fractional CFOs pay for Diligentsia?",
                "a": "No. Advisor accounts for fractional CFOs are completely free \u2014 no platform fees, no licence costs, no revenue share on advisory income. Companies pay \xa31,000/year for Diligentsia Pro. A free Starter tier is available for early-stage clients not yet raising. CFOs who introduce clients receive a 20% client discount."
            },
            {
                "q": "How many fractional CFOs use Diligentsia?",
                "a": "80+ fractional CFOs are using Diligentsia as of June 2026, drawn from the largest UK CFO organisations including the CFO Centre. Several have become investors in the platform after using it with clients \u2014 described as the strongest possible validation of the product's value."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How AI Is Changing the Role of the Fractional CFO \u2014 and What the Best Are Doing About It (2026)",
                "description": "AI tools are reshaping fractional CFO work. This article explains what is changing, what is not, and how the best fractional CFOs are using AI to become more valuable to their clients \u2014 not less.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/cfo/how-ai-is-changing-fractional-cfo-role/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "Will AI replace fractional CFOs?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "AI will replace the task-execution components of fractional CFO work \u2014 document compilation, data analysis, standard reporting. It will not replace the judgment, trust relationship, or strategic advisory function that converts data into business decisions. The fractional CFOs who position themselves as AI conductors \u2014 structuring client data and verifying AI outputs \u2014 will become more valuable, not less."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How can fractional CFOs use AI to win more clients?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most effective approach is to use AI-assisted platforms to demonstrate structured value from day one: walking into new engagements with AI-populated client foundations, surfacing billable opportunities systematically through quarterly review cycles, and providing clients with measurable certification scores. See the practical guide: diligentsia.co.uk/cfo/how-fractional-cfos-use-diligentsia/"
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How is AI changing fractional CFO work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "AI is automating the task-execution components of fractional CFO work \u2014 analysis, document compilation, standard reporting \u2014 at a cost of less than \xa320/month. This is shifting client expectations from time-based task delivery toward strategic advisory judgment. The fractional CFOs responding most effectively are repositioning as AI conductors: structuring client data, verifying AI outputs, and demonstrating value through certified, auditable results."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the difference between AI-generated analysis and AI-verified analysis?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "AI-generated analysis uses a language model to produce plausible output from whatever data it has \u2014 including unverified, inconsistent, or incomplete sources. AI-verified analysis requires that every AI-generated answer is linked to a source document, reviewed by a named human reviewer, and timestamped. Diligentsia's structured evidence approach produces the latter \u2014 output that clients and investors trust, not just output that reads well."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How do the best fractional CFOs use Diligentsia?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": 'The leading fractional CFOs on Diligentsia use it in three ways: (1) walking into new client engagements with AI-populated client foundations rather than a blank page \u2014 "starting at 60% instead of zero"; (2) using quarterly review cycles to surface billable advisory opportunities systematically; and (3) providing clients with Bronze/Silver/Gold certification scores that make advisory progress visible and demonstrable.'
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Do fractional CFOs pay for Diligentsia?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "No. Advisor accounts for fractional CFOs are completely free \u2014 no platform fees, no licence costs, no revenue share on advisory income. Companies pay \xa31,000/year for Diligentsia Pro. A free Starter tier is available for early-stage clients not yet raising. CFOs who introduce clients receive a 20% client discount."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How many fractional CFOs use Diligentsia?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "80+ fractional CFOs are using Diligentsia as of June 2026, drawn from the largest UK CFO organisations including the CFO Centre. Several have become investors in the platform after using it with clients \u2014 described as the strongest possible validation of the product's value."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Fractional CFOs",
                        "item": "https://diligentsia.co.uk/cfo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How AI Is Changing the Role of the Fractional CFO \u2014 and What the Best Are Doing About It (2026)",
                        "item": "https://diligentsia.co.uk/cfo/how-ai-is-changing-fractional-cfo-role/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "angel-network",
        "slug": "how-angel-networks-improve-startup-funding-rates",
        "category": "Angel Networks",
        "title": "How Do Angel Networks Improve Startup Funding Rates? (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-angel-networks-improve-startup-funding-rates.jpg",
        "metaDescription": "Angel networks improve startup funding rates by aggregating investor attention, providing a credibility signal, and creating follow-on momentum \u2014 but investment readiness is the decisive factor once initial interest is established. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/angel-network/how-angel-networks-improve-startup-funding-rates/",
        "bodyHtml": "<p>Angel networks improve startup funding rates by connecting early-stage companies with structured pools of private investors, providing access to capital that would otherwise require founders to approach investors individually. However, the degree to which any individual network improves a founder's odds varies significantly \u2014 and is heavily influenced by one factor most networks do not discuss: investment readiness.</p>\n<h2>What an angel network does</h2>\n<p>An angel network is an organised group of individual investors \u2014 typically high-net-worth individuals \u2014 who pool their deal flow, share due diligence, and co-invest in early-stage companies. In the UK, the major networks include UKBAA members and regional syndicates, as well as specialist funds focused on hardware, healthcare, or technology.</p>\n<p>Networks improve funding rates in three ways. First, they aggregate investor attention: rather than a founder cold-approaching 200 individual angels, they present to a curated group at one event. Second, they provide a credibility signal: a company that has been accepted by an angel network has passed at least a basic filter, which other investors recognise. Third, they create follow-on momentum: angels who co-invest through a network are more likely to participate in subsequent rounds.</p>\n<h2>The acceptance rate problem</h2>\n<p>The headline numbers are sobering. A typical UK angel network receives between 200 and 700 applications per year and invests in between 10 and 15 companies \u2014 an acceptance rate of below 2% (UKBAA data).</p>\n<p>The companies that do not get funded fall into three categories: those unsuitable for the network's focus (wrong sector, wrong stage); those that are fundamentally not investable; and those that are genuinely promising but not yet prepared for investor scrutiny.</p>\n<p><strong>The third category is the most actionable \u2014 and the most overlooked.</strong></p>\n<h2>Why investment readiness determines outcomes</h2>\n<p>Research and practitioner experience consistently show that the determining factor in whether an angel investment proceeds \u2014 once initial interest is established \u2014 is how quickly and completely a company can respond to due diligence questions.</p>\n<p><strong>\u201CIt is not that it doesn't get done. It just takes longer to answer those questions three months down the line than if they are answered three weeks into it. That is the biggest problem.\u201D</strong></p>\n<p>Companies that arrive at investor conversations with structured documentation \u2014 a business audit, directors' questionnaires, IP ownership records, draft warranty disclosures, and an organised data repository \u2014 close faster, at less dilution, and with fewer last-minute price adjustments caused by documentation gaps.</p>\n<h2>The diligence gap at angel deal sizes</h2>\n<p>The challenge is structural. At deal sizes of \xa325,000 to \xa3500,000 \u2014 the typical range for angel investment \u2014 external diligence fees of \xa310,000 to \xa350,000 are not commercially viable. As a result, 70% of angel-backed companies are never externally diligenced (British Business Bank data). Angels invest on gut feel and intuition \u2014 not because they want to, but because there has been no affordable alternative.</p>\n<p>This gap has consequences for both parties. Angels who invest without structured diligence lose money on a higher proportion of deals. Founders who have not prepared for diligence find their rounds stalling when investor interest is at its peak.</p>\n<h2>How structured preparation changes the outcome</h2>\n<p>Companies that complete a structured investment readiness process before approaching angel networks improve their outcomes in measurable ways. The key elements are: a structured data repository, a business audit, directors' questionnaires, IP and legal documentation, and a market opportunity assessment. When assembled in advance, investor due diligence becomes a verification exercise rather than a discovery process \u2014 substantially faster and less friction-generating.</p>\n<p>AI-assisted platforms have made this process accessible at angel deal economics. A well-organised company can complete a full certified preparation pack \u2014 including research reports and a Bronze/Silver/Gold certification \u2014 in as little as three days, at a fraction of the cost of traditional advisory services.</p>\n<p>See our preparation guide: <a href=\"/angel-network/how-to-prepare-for-angel-due-diligence/\">diligentsia.co.uk/angel-network/how-to-prepare-for-angel-due-diligence/</a></p>\n<h2>What the best-performing angel networks do differently</h2>\n<p>The networks that generate the strongest returns for their members share one characteristic: they establish a quality threshold at the front end of their process \u2014 requiring structured preparation before a company presents to the investment committee, not after.</p>\n<p>The effect is twofold. Companies that complete the preparation process arrive better equipped to answer investor questions. And the networks themselves develop a reputation for curating fundable, organised companies \u2014 which attracts better-quality angels and creates a reinforcing cycle of improved outcomes.</p>\n<p><strong>The first network to establish a publicly visible, consistent quality standard \u2014 communicated via a certification framework that investors can see at a glance \u2014 will have a structural advantage over competitors who rely on subjective screening alone.</strong></p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "What is the typical acceptance rate at UK angel networks?",
                "a": "A typical UK angel network receives between 200 and 700 applications per year and invests in 10 to 15 companies \u2014 an acceptance rate of below 2%, according to UKBAA data. The companies most likely to be funded are those that combine commercial promise with investment-ready documentation."
            },
            {
                "q": "Why do so many angel-backed companies never receive external due diligence?",
                "a": "At typical angel deal sizes of \xa325,000 to \xa3500,000, traditional external diligence fees of \xa310,000 to \xa350,000 are not commercially viable. As a result, 70% of angel-backed companies are never externally diligenced (British Business Bank data). AI-assisted investment readiness platforms have made structured diligence accessible at angel deal economics for the first time."
            },
            {
                "q": "How does a Diligence Pack help companies succeed with angel networks?",
                "a": "A structured Diligence Pack \u2014 covering corporate records, IP, financials, and commercial evidence \u2014 transforms investor due diligence from a discovery process into a verification exercise. Companies with pre-prepared packs close faster, at less dilution, and with fewer last-minute surprises that erode investor confidence."
            },
            {
                "q": "What should angel networks require from companies before investment committee?",
                "a": "The strongest-performing angel networks require structured preparation before a company presents to the investment committee. At minimum: a complete cap table, IP ownership confirmation, directors' questionnaires, financial projections with stated assumptions, and a summary of material contracts and risks. A Bronze/Silver/Gold certification from an investment readiness platform provides an at-a-glance quality signal for the committee."
            },
            {
                "q": "Is Diligentsia free for angel networks and investors?",
                "a": "Yes. Diligentsia is free for angel networks and individual angel investors. Companies pay from \xa31,000 per year for a full subscription including AI pre-population, Bronze/Silver/Gold certification, and permission-controlled sharing. The cost is less than a single day of fractional CFO time."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Do Angel Networks Improve Startup Funding Rates? (2026)",
                "description": "Angel networks improve startup funding rates by aggregating investor attention, providing a credibility signal, and creating follow-on momentum \u2014 but investment readiness is the decisive factor once initial interest is established.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/angel-network/how-angel-networks-improve-startup-funding-rates/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is the typical acceptance rate at UK angel networks?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A typical UK angel network receives between 200 and 700 applications per year and invests in 10 to 15 companies \u2014 an acceptance rate of below 2%, according to UKBAA data. The companies most likely to be funded are those that combine commercial promise with investment-ready documentation."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Why do so many angel-backed companies never receive external due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "At typical angel deal sizes of \xa325,000 to \xa3500,000, traditional external diligence fees of \xa310,000 to \xa350,000 are not commercially viable. As a result, 70% of angel-backed companies are never externally diligenced (British Business Bank data). AI-assisted investment readiness platforms have made structured diligence accessible at angel deal economics for the first time."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does a Diligence Pack help companies succeed with angel networks?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A structured Diligence Pack \u2014 covering corporate records, IP, financials, and commercial evidence \u2014 transforms investor due diligence from a discovery process into a verification exercise. Companies with pre-prepared packs close faster, at less dilution, and with fewer last-minute surprises that erode investor confidence."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What should angel networks require from companies before investment committee?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The strongest-performing angel networks require structured preparation before a company presents to the investment committee. At minimum: a complete cap table, IP ownership confirmation, directors' questionnaires, financial projections with stated assumptions, and a summary of material contracts and risks. A Bronze/Silver/Gold certification from an investment readiness platform provides an at-a-glance quality signal for the committee."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Is Diligentsia free for angel networks and investors?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes. Diligentsia is free for angel networks and individual angel investors. Companies pay from \xa31,000 per year for a full subscription including AI pre-population, Bronze/Silver/Gold certification, and permission-controlled sharing. The cost is less than a single day of fractional CFO time."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Angel Networks",
                        "item": "https://diligentsia.co.uk/angel-network/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Do Angel Networks Improve Startup Funding Rates? (2026)",
                        "item": "https://diligentsia.co.uk/angel-network/how-angel-networks-improve-startup-funding-rates/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "angel-network",
        "slug": "how-to-prepare-for-angel-due-diligence",
        "category": "Angel Networks",
        "title": "How to Prepare for Angel Investment Due Diligence",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-to-prepare-for-angel-due-diligence.jpg",
        "metaDescription": "A practical guide to preparing for angel investment due diligence: what investors check, which documents to have ready, and how to use AI-assisted tools to build a complete certified pack in as little as three days. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/angel-network/how-to-prepare-for-angel-due-diligence/",
        "bodyHtml": "<p>Angel investment due diligence is the process by which an investor verifies the claims made in a pitch and assesses the risks associated with an investment. Unlike institutional VC due diligence \u2014 which is typically conducted by a dedicated team over several weeks \u2014 angel diligence is often done by the investor themselves, part-time, alongside other commitments. This makes the quality and organisation of what a founder provides enormously consequential.</p>\n<h2>What angel investors are checking for</h2>\n<p>Angel investors conducting due diligence are trying to answer five questions: Is the team credible and capable? Does the business have legal and governance foundations in place? Are the financial projections reasonable and supported by evidence? Is the market opportunity real? And are there any undisclosed risks that would change the investment thesis?</p>\n<p>The challenge for founders is that these questions are rarely asked in a structured sequence. An angel may start with the pitch deck, move to financials, then jump to IP questions when something looks unclear. Companies that are not organised tend to provide information in a piecemeal, reactive way \u2014 which creates the impression of disorganisation even when the underlying business is sound.</p>\n<h2>The documentation a company should have ready</h2>\n<p>Before approaching any angel network or investor, a company should have the following organised and accessible:</p>\n<p><strong>Corporate and legal: </strong>Certificate of incorporation, shareholder register, cap table, any shareholder or founders' agreements, service contracts for key staff, summary of any outstanding legal issues.</p>\n<p><strong>Intellectual property: </strong>Evidence of IP ownership (assignments, registrations, or work-for-hire arrangements where relevant) \u2014 especially critical for technology businesses where IP ownership is often disputed.</p>\n<p><strong>Financial records: </strong>Last 2\u20133 years of accounts if available, current management accounts, financial projections with clear assumptions, bank statements for the last 3 months.</p>\n<p><strong>Business operations: </strong>Key customer contracts or letters of intent, supplier agreements, evidence of revenue or pipeline, summary of the competitive landscape.</p>\n<p><strong>People: </strong>CVs or LinkedIn profiles of key team members, details of any advisory relationships.</p>\n<p><strong>Pitch materials: </strong>A current pitch deck, executive summary, and any previous investor correspondence.</p>\n<h2>Why preparation before the pitch matters</h2>\n<p>Most founders assemble due diligence materials after they have generated investor interest \u2014 which means doing it under time pressure, in parallel with a live investor conversation, while the round is on the line.</p>\n<p>This is the wrong sequence. The data room that takes three months to build under pressure could have been built in three days before the first investor meeting. The documents that contain surprises \u2014 IP disputes, undocumented founder agreements, missing contracts \u2014 are far better identified and addressed before an investor finds them than after.</p>\n<p><strong>\u201CIt is not that it doesn't get done. It just takes longer to answer those questions three months down the line than if they are answered three weeks into it.\u201D</strong></p>\n<p>The round that stalls is almost always the one where documentation was reactive rather than proactive.</p>\n<h2>How long angel investment due diligence takes</h2>\n<p>For a well-organised company \u2014 with all key documents in place and a structured data repository \u2014 due diligence can be completed within two to four weeks of initial investor interest. For a company that has not prepared, the same process takes three to six months, if it completes at all.</p>\n<p>The variability is almost entirely on the company side. Investors can only move as fast as the information they receive allows. Companies that compress due diligence time close rounds faster, at less dilution, with fewer last-minute price adjustments.</p>\n<p>For full timeline data: <a href=\"/accelerator/how-long-does-startup-due-diligence-take/\">diligentsia.co.uk/accelerator/how-long-does-startup-due-diligence-take/</a></p>\n<h2>The SEIS/EIS dimension</h2>\n<p>For UK angel investment, SEIS (Seed Enterprise Investment Scheme) and EIS (Enterprise Investment Scheme) tax relief are frequently significant factors. Investors relying on SEIS/EIS relief need evidence that the investment meets the relevant criteria, and the investment decision must be documented on a sound basis.</p>\n<p>Structured diligence \u2014 with evidence-backed answers, human-reviewed records, and an audit trail \u2014 provides a defensible foundation for the SEIS/EIS claim. Ad-hoc, gut-feel investing leaves both investor and company exposed if the relief is later challenged.</p>\n<h2>How to prepare efficiently: a step-by-step approach</h2>\n<p>The most effective way to prepare for angel due diligence is to answer the investor's questions before they ask them. The five steps:</p>\n<p><strong>Step 1: Start during or before fundraising preparation</strong></p>\n<p>Build the pack proactively \u2014 ideally in the months before active investor outreach, not in response to an investor's request list. Even starting during an accelerator programme period substantially reduces the time pressure.</p>\n<p><strong>Step 2: Use a structured framework</strong></p>\n<p>Work through a structured diligence framework covering legal, financial, operational, and commercial aspects of the business. Platforms like Diligentsia provide a pre-built framework with AI assistance that auto-populates approximately 60% of standard modules from documents you already have.</p>\n<p><strong>Step 3: Surface and address surprises early</strong></p>\n<p>The due diligence process will surface issues. Issues found by the founder before investor conversations are manageable. Issues found by the investor during due diligence are deal-threatening. Use the preparation process to find and resolve problems proactively.</p>\n<p><strong>Step 4: Review every answer</strong></p>\n<p>No due diligence material should reach an investor without human review and sign-off by a director or authorised person. AI assistance accelerates preparation; human review ensures accuracy and accountability.</p>\n<p><strong>Step 5: Control access carefully</strong></p>\n<p>Share your Diligence Pack through a permission-controlled mechanism. You should know who has accessed which documents, be able to revoke access, and provide different visibility levels to different parties (SEIS/EIS investors vs. strategic investors, for example).</p>\n<h2>Diligentsia pricing</h2>\n<p>Building a complete, certified Diligence Pack costs less than a day of fractional CFO time:</p>\n<div class=\"lp-aeo-table-wrap\"><table><thead><tr><th>Plan</th><th>Who it's for</th><th>Cost</th><th>What's included</th></tr></thead><tbody><tr><td>Company subscription</td><td>Early-stage companies seeking angel investment</td><td>\xa31,000/year</td><td>Full Diligence Pack, AI pre-population (60% autofill), Bronze/Silver/Gold certification, controlled investor sharing</td></tr><tr><td>Angel investor account</td><td>Individual angel investors and syndicates</td><td>Free</td><td>Platform access to review company packs, AI-assisted analysis, portfolio visibility</td></tr><tr><td>Angel network account</td><td>Network operators and EIR/deal flow managers</td><td>Free</td><td>Network dashboard, cohort quality reporting, integration with investment committee process</td></tr></tbody></table></div>\n<h2>Ready to prepare for angel due diligence?</h2>\n<p>Diligentsia helps early-stage companies build certified Diligence Packs in as little as three days. AI pre-populates 60% of standard modules from documents you already have. Angel network and investor accounts are free.</p>\n<p><strong><a href=\"/angel-network\">diligentsia.co.uk/angel-network</a></strong></p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "What documents do angel investors require during due diligence?",
                "a": "Angel investors typically require: certificate of incorporation and articles of association, a complete cap table, IP ownership evidence (especially for tech companies), key customer and supplier contracts, management accounts and financial projections, and commercial evidence including revenue data or letters of intent. A structured Diligence Pack addresses all of these systematically before the investor asks."
            },
            {
                "q": "How long does angel investment due diligence typically take?",
                "a": "For a well-organised company with all key documents in place, angel due diligence can be completed in two to four weeks. For a company that begins assembling information reactively after investor interest, the same process typically takes three to six months \u2014 if it completes at all."
            },
            {
                "q": "Why does investment readiness matter for SEIS/EIS investments?",
                "a": "Investors relying on SEIS or EIS tax relief need evidence that the investment meets the relevant criteria and that the investment decision is documented on a sound basis. Structured diligence with evidence-backed answers, human-reviewed records, and an audit trail provides a defensible foundation for the SEIS/EIS claim \u2014 protecting both investor and company if the relief is later challenged."
            },
            {
                "q": "How much does it cost to prepare a Diligence Pack with Diligentsia?",
                "a": "A company subscription to Diligentsia costs \xa31,000 per year \u2014 less than a single day of fractional CFO time. This includes the full Diligence Pack framework, AI pre-population across all modules, Bronze/Silver/Gold certification, and permission-controlled sharing with investors. Angel network and investor accounts are free."
            },
            {
                "q": "Can angel investment due diligence be completed in three days?",
                "a": "Yes, for a well-organised company that uses a structured platform with AI assistance. Diligentsia's AI engine pre-populates approximately 60% of standard due diligence modules from documents uploaded by the company. Every answer is then reviewed and signed off by a director. The total elapsed time from start to a certified, investor-ready pack can be as little as three days."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How to Prepare for Angel Investment Due Diligence",
                "description": "A practical guide to preparing for angel investment due diligence: what investors check, which documents to have ready, and how to use AI-assisted tools to build a complete certified pack in as little as three days.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/angel-network/how-to-prepare-for-angel-due-diligence/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What documents do angel investors require during due diligence?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Angel investors typically require: certificate of incorporation and articles of association, a complete cap table, IP ownership evidence (especially for tech companies), key customer and supplier contracts, management accounts and financial projections, and commercial evidence including revenue data or letters of intent. A structured Diligence Pack addresses all of these systematically before the investor asks."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long does angel investment due diligence typically take?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "For a well-organised company with all key documents in place, angel due diligence can be completed in two to four weeks. For a company that begins assembling information reactively after investor interest, the same process typically takes three to six months \u2014 if it completes at all."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Why does investment readiness matter for SEIS/EIS investments?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Investors relying on SEIS or EIS tax relief need evidence that the investment meets the relevant criteria and that the investment decision is documented on a sound basis. Structured diligence with evidence-backed answers, human-reviewed records, and an audit trail provides a defensible foundation for the SEIS/EIS claim \u2014 protecting both investor and company if the relief is later challenged."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How much does it cost to prepare a Diligence Pack with Diligentsia?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A company subscription to Diligentsia costs \xa31,000 per year \u2014 less than a single day of fractional CFO time. This includes the full Diligence Pack framework, AI pre-population across all modules, Bronze/Silver/Gold certification, and permission-controlled sharing with investors. Angel network and investor accounts are free."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Can angel investment due diligence be completed in three days?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes, for a well-organised company that uses a structured platform with AI assistance. Diligentsia's AI engine pre-populates approximately 60% of standard due diligence modules from documents uploaded by the company. Every answer is then reviewed and signed off by a director. The total elapsed time from start to a certified, investor-ready pack can be as little as three days."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Angel Networks",
                        "item": "https://diligentsia.co.uk/angel-network/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How to Prepare for Angel Investment Due Diligence",
                        "item": "https://diligentsia.co.uk/angel-network/how-to-prepare-for-angel-due-diligence/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "accelerator",
        "slug": "how-accelerators-improve-startup-funding-rates",
        "category": "Accelerators",
        "title": "How Do Accelerator Programmes Improve Startup Funding Rates? (2026)",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-accelerators-improve-startup-funding-rates.jpg",
        "metaDescription": "Accelerator programmes improve startup funding rates through endorsement, investor introductions, and operational validation. Learn how investment readiness infrastructure extends these gains. Last updated: June 2026.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/accelerator/how-accelerators-improve-startup-funding-rates/",
        "bodyHtml": "<p>Accelerator programmes significantly improve startup funding rates by providing structured mentorship, investor introductions, and operational validation that increase a company's credibility with investors. Research consistently shows that accelerator graduates raise capital at substantially higher rates and faster timescales than comparable non-accelerator companies.</p>\n<h2>What the data shows</h2>\n<p>Studies of major accelerator programmes indicate that graduates are between two and five times more likely to raise institutional funding than non-accelerator startups at the same stage. Y Combinator companies have raised over $600 billion in total funding cumulatively. UK-based research from the British Business Bank suggests accelerator participation correlates with a 20\u201340% improvement in the likelihood of securing investment within 18 months of programme completion.</p>\n<p>The baseline comparison matters: fewer than 1 in 100 companies that approach investors for funding are successful. Accelerator programmes materially shift those odds by providing several advantages that investors specifically look for.</p>\n<h2>Why accelerators improve funding outcomes</h2>\n<p><strong>1. Signal and endorsement</strong></p>\n<p>When a recognised accelerator accepts a company into its cohort, it functions as a quality signal to investors. Programme directors screen hundreds of applications and accept a small fraction \u2014 typically 2\u20135%. Investors, particularly VCs who maintain relationships with strong accelerator programmes, treat an acceptance as evidence that a company has already passed a meaningful filter.</p>\n<p>This endorsement effect is most pronounced for programmes with established investor networks. A company graduating from a well-regarded programme arrives at investor conversations with implicit credibility that cold-approach companies must earn from scratch.</p>\n<p><strong>2. Investor introductions</strong></p>\n<p>Most accelerators maintain active relationships with a network of venture capital firms, angel investors, and family offices. Demo days \u2014 the culminating event of most accelerator programmes \u2014 are specifically designed to facilitate investor introductions at scale. A single demo day can put a company in front of 50\u2013200 investors in a few hours, a volume of introductions that would take most founders months to arrange independently.</p>\n<p>Beyond demo day, programme alumni networks, mentor relationships, and direct VC partnerships create ongoing referral channels that continue to benefit graduates after the programme ends.</p>\n<p><strong>3. Operational validation</strong></p>\n<p>Accelerators compress years of operational learning into months. Companies that complete a programme typically have a clearer value proposition, a refined financial model, and a more disciplined approach to growth metrics. Investors assessing an accelerator graduate are assessing a company that has already been stress-tested by experienced operators.</p>\n<p>This validation reduces the perceived risk premium that investors attach to early-stage companies, which in turn supports better valuations.</p>\n<p><strong>4. Pitch preparation</strong></p>\n<p>Accelerators provide structured pitch preparation, including repeated practice sessions with experienced operators and investors. The result is founders who can communicate their business more clearly and handle investor questions more confidently \u2014 factors that directly affect an investor's comfort level and willingness to commit.</p>\n<h2>The gap that most accelerators do not close</h2>\n<p>Despite these advantages, accelerators consistently face a challenge that sits outside their core programme structure: investment readiness documentation.</p>\n<p>Getting a company investor-interested is different from getting it investor-ready. When a VC moves beyond a pitch and asks for structured documentation \u2014 governance records, ownership history, contracts register, financial models, director background information \u2014 many accelerator graduates are not prepared to respond quickly or completely.</p>\n<p>The due diligence process, which follows initial investor interest, is where a significant proportion of funding rounds stall or fail. According to data from deal advisers and fractional CFOs working with early-stage companies, the most common reasons rounds drag or collapse are not problems with the business itself \u2014 they are information gaps, slow responses, and unexpected disclosures that erode investor confidence.</p>\n<p><strong>The companies that close funding rounds fastest are not always the best businesses. They are the best-prepared ones.</strong></p>\n<h2>How investment readiness infrastructure changes outcomes</h2>\n<p>Platforms like Diligentsia extend the impact of accelerator programmes by addressing the documentation and diligence gap. Companies that build a structured Diligence Pack during their programme period arrive at investor conversations with:</p>\n<ul><li>A certified, evidence-backed record of their business (Bronze, Silver, or Gold certification)</li><li>Pre-populated answers to the standard questions investors ask in due diligence</li><li>A data repository that supports AI-assisted investor analysis</li><li>A shareable, permission-controlled pack that can be sent to multiple investors without repeat preparation</li></ul>\n<p>The practical effect is a compressed due diligence timeline. A company that has done this preparation can move from term sheet to close in weeks rather than months \u2014 and does so with fewer surprises emerging along the way.</p>\n<p>Learn more about how to prepare a structured Diligence Pack: <a href=\"/accelerator/how-to-prepare-due-diligence-pack-seed-investment/\">diligentsia.co.uk/accelerator/how-to-prepare-due-diligence-pack-seed-investment/</a></p>\n<h2>Summary</h2>\n<p>Accelerators improve startup funding rates through endorsement, introductions, operational validation, and pitch preparation. The strongest accelerator programmes add a further layer \u2014 investment readiness infrastructure \u2014 that ensures the quality of the pitch is matched by the quality of what is behind it.</p>\n<p>For programme directors, the question is not whether your cohort companies need this. It is which programmes ensure their graduates have it.</p>",
        "peopleAlsoAsk": [],
        "faqs": [
            {
                "q": "How much more likely are accelerator graduates to raise funding?",
                "a": "Research indicates accelerator graduates are two to five times more likely to raise institutional funding than comparable non-accelerator startups. UK data from the British Business Bank shows accelerator participation correlates with a 20\u201340% improvement in securing investment within 18 months of programme completion."
            },
            {
                "q": "What is the most common reason accelerator-backed companies fail to close a funding round?",
                "a": "The most common reason is not the quality of the business \u2014 it is inadequate investment readiness documentation. Information gaps, slow responses to due diligence requests, and unexpected disclosures during the process erode investor confidence and cause rounds to stall or collapse."
            },
            {
                "q": "How does a Diligence Pack improve funding outcomes for accelerator cohorts?",
                "a": "A structured Diligence Pack gives cohort companies a certified, evidence-backed record of their business before investor conversations begin. Companies with a pre-prepared pack can compress due diligence from months to weeks, reducing the risk of rounds stalling on documentation rather than commercial substance."
            },
            {
                "q": "What is the difference between being investor-interested and investor-ready?",
                "a": "Investor-interest means an investor wants to learn more about the business. Investor-ready means the company can respond quickly and completely to due diligence requests. Many accelerator graduates secure investor interest but fail the investor-ready test because they have not prepared structured documentation in advance."
            }
        ],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Do Accelerator Programmes Improve Startup Funding Rates? (2026)",
                "description": "Accelerator programmes improve startup funding rates through endorsement, investor introductions, and operational validation. Learn how investment readiness infrastructure extends these gains.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/accelerator/how-accelerators-improve-startup-funding-rates/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "How much more likely are accelerator graduates to raise funding?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Research indicates accelerator graduates are two to five times more likely to raise institutional funding than comparable non-accelerator startups. UK data from the British Business Bank shows accelerator participation correlates with a 20\u201340% improvement in securing investment within 18 months of programme completion."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the most common reason accelerator-backed companies fail to close a funding round?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "The most common reason is not the quality of the business \u2014 it is inadequate investment readiness documentation. Information gaps, slow responses to due diligence requests, and unexpected disclosures during the process erode investor confidence and cause rounds to stall or collapse."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does a Diligence Pack improve funding outcomes for accelerator cohorts?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "A structured Diligence Pack gives cohort companies a certified, evidence-backed record of their business before investor conversations begin. Companies with a pre-prepared pack can compress due diligence from months to weeks, reducing the risk of rounds stalling on documentation rather than commercial substance."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What is the difference between being investor-interested and investor-ready?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Investor-interest means an investor wants to learn more about the business. Investor-ready means the company can respond quickly and completely to due diligence requests. Many accelerator graduates secure investor interest but fail the investor-ready test because they have not prepared structured documentation in advance."
                        }
                    }
                ]
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Accelerators",
                        "item": "https://diligentsia.co.uk/accelerator/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Do Accelerator Programmes Improve Startup Funding Rates? (2026)",
                        "item": "https://diligentsia.co.uk/accelerator/how-accelerators-improve-startup-funding-rates/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "ceo",
        "slug": "how-long-to-get-investment-ready",
        "category": "Companies",
        "title": "How Long Does It Take a Growth-Stage Company to Get Investment Ready?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/how-long-to-get-investment-ready.jpg",
        "metaDescription": "With a structured platform and existing documents in place, a growth-stage company can complete the foundational investment readiness process in three to five days. Without structured support, the same process typically takes three to six months \u2014 and often produces incomplete or inconsistent outputs that slow the funding process rather than accelerating it.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/ceo/how-long-to-get-investment-ready/",
        "bodyHtml": "<p>With a structured platform and existing documents in place, a growth-stage company can complete the foundational investment readiness process in three to five days. Without structured support, the same process typically takes three to six months \u2014 and often produces incomplete or inconsistent outputs that slow the funding process rather than accelerating it.</p>\n<h2>What \"investment ready\" actually means</h2>\n<p>Investment readiness is not the same as having a strong pitch deck. It refers to a company's ability to respond quickly and completely to investor due diligence requests \u2014 to demonstrate, through organised documentation, that the business is what the pitch deck says it is.</p>\n<p>Investors, particularly those making institutional-scale investments, use a standardised set of diligence questions. They ask about governance structure, shareholder agreements, IP ownership, key contracts, financial history, director backgrounds, regulatory compliance, and a range of other areas that most early-stage companies have not systematically documented.</p>\n<p>A company is investment ready when it can answer these questions immediately, completely, and with evidence linked to source documents. Most companies cannot \u2014 not because the underlying business is weak, but because the documentation has never been organised for this purpose.</p>\n<h2>Why it takes longer than founders expect</h2>\n<p>The typical founder's experience of getting investment ready looks something like this:</p>\n<p>A term sheet arrives or an investor expresses serious interest. The investor asks for a data room. The founder asks their lawyer or accountant to help compile one. The lawyer or accountant asks for documents. The founder discovers that some documents don't exist, some are in the wrong format, some are inconsistent with other documents, and some have never been formally executed.</p>\n<p>The process of gathering, reviewing, and correcting this takes weeks. During those weeks, investor interest cools. Questions that the investor asked in the first meeting are still unanswered three months later. The transaction drags, or the investor moves on.</p>\n<p>This is not an unusual experience. It is the standard experience for growth-stage companies going through their first or second funding process. The problem is not the quality of the business \u2014 it is the absence of organised documentation.</p>\n<h2>What structured preparation looks like</h2>\n<p>The fastest and most reliable path to investment readiness follows a defined sequence:</p>\n<p><strong>Document gathering</strong> (1\u20132 days): Collect existing corporate, financial, legal, and commercial documents into a single accessible location. Most companies have most of what they need \u2014 it is typically stored across email, cloud drives, and physical files rather than in a single organised structure.</p>\n<p><strong>Structured diagnostic</strong> (1\u20133 days): A systematic assessment of what's in place, what's missing, and where risks are present. Platforms like Diligentsia use AI to read existing documents and identify gaps automatically \u2014 approximately 60% of the diagnostic is completed from existing documentation, with human review required for every answer.</p>\n<p><strong>Gap remediation</strong> (varies): Addressing the gaps identified in the diagnostic. Some gaps are resolved quickly \u2014 a document that needs to be formally executed, a record that needs to be created. Others require more work \u2014 restructuring shareholdings, addressing regulatory compliance issues, or formalising IP ownership that has been treated informally. This phase is where experienced advisory support adds the most value.</p>\n<p><strong>Certification</strong> (1 day): Producing the certified output \u2014 a structured, evidence-linked Diligence Pack \u2014 that investors can access directly. This is the investor-facing document that replaces the traditional data room request process.</p>\n<h2>The difference between prepared and unprepared companies</h2>\n<p>Data from deal advisers and fractional CFOs working with early-stage companies consistently shows that the single most common reason funding rounds drag or collapse is not the quality of the business \u2014 it is the pace and completeness of the company's response to due diligence requests.</p>\n<p>An investor who has to ask the same question three times, or who waits three weeks for a document that should have taken an hour to produce, draws conclusions about the management team's competence and the company's organisational culture. Those conclusions are hard to reverse.</p>\n<p>A company that responds immediately and completely \u2014 that can direct an investor to a certified, organised, evidence-backed record of the business \u2014 creates the opposite impression. The investor moves faster, asks fewer follow-up questions, and encounters fewer surprises. Rounds that might take nine months take three. Conditions that might be imposed on a slow, opaque process are not imposed on a fast, transparent one.</p>\n<h2>When to start</h2>\n<p>The right time to start building investment readiness infrastructure is not when a term sheet arrives. It is at least six months before any serious fundraising process begins \u2014 and ideally as a continuous practice throughout the company's growth journey.</p>\n<p>Companies that maintain their Diligence Pack on an ongoing basis are not just prepared for investment. They are prepared for any transaction: a major contract bid that requires governance evidence, an acquisition approach, or an exit process. The work done for one purpose is available for all purposes.</p>\n<p>The cost of starting early is three to five days of structured effort, once. The cost of starting late is measured in months of deal timeline and in risk to the transaction itself.</p>\n<h2>Summary</h2>\n<p>Investment readiness for a growth-stage company takes three to five days with a structured platform and existing documents in place. Without this, the same preparation takes months and typically produces incomplete results. The companies that close funding rounds fastest are not the ones with the strongest pitches \u2014 they are the ones that arrive at investor conversations already organised. Structured investment readiness infrastructure, built and maintained throughout the growth journey, is the most reliable way to ensure that when the moment comes, a company is ready for it.</p>\n<p><em>The Dignus Muneris and Diligentsia partnership helps growth-stage companies get organised and stay ready \u2014 across growth, investment, and exit. Learn more at dignusmuneris.co.uk.</em></p>",
        "peopleAlsoAsk": [],
        "faqs": [],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Long Does It Take a Growth-Stage Company to Get Investment Ready?",
                "description": "With a structured platform and existing documents in place, a growth-stage company can complete the foundational investment readiness process in three to five days. Without structured support, the same process typically takes three to six months \u2014 and often produces incomplete or inconsistent outputs that slow the funding process rather than accelerating it.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/ceo/how-long-to-get-investment-ready/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Companies",
                        "item": "https://diligentsia.co.uk/ceo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Long Does It Take a Growth-Stage Company to Get Investment Ready?",
                        "item": "https://diligentsia.co.uk/ceo/how-long-to-get-investment-ready/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "ceo",
        "slug": "get-more-value-from-business-support-adviser",
        "category": "Companies",
        "title": "How Do Growth-Stage Companies Get More Value From Their Business Support Adviser?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/get-more-value-from-business-support-adviser.jpg",
        "metaDescription": "Growth-stage companies get more value from their business support adviser by arriving at every session prepared \u2014 with their key documents organised, their gaps identified, and a clear picture of where they stand. The more organised a company is before the advisory relationship begins, the more productive every hour of adviser time becomes.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/ceo/get-more-value-from-business-support-adviser/",
        "bodyHtml": "<p>Growth-stage companies get more value from their business support adviser by arriving at every session prepared \u2014 with their key documents organised, their gaps identified, and a clear picture of where they stand. The more organised a company is before the advisory relationship begins, the more productive every hour of adviser time becomes.</p>\n<h2>The structural problem with advisory time</h2>\n<p>Business support advisers \u2014 whether working through growth hubs, innovation programmes, or independent practices \u2014 are typically hired for their expertise in strategy, funding, market development, or operational improvement. That is the work they are best placed to do.</p>\n<p>In practice, a significant proportion of every advisory engagement is spent on groundwork that precedes the real work: understanding what documents the company has, identifying what's missing, surfacing risks the company may not be aware of, and gathering enough of a picture to have a meaningful strategic conversation.</p>\n<p>This groundwork is necessary. But it is not the highest-value use of a senior adviser's time \u2014 and it is not what companies are typically paying for or hoping to get.</p>\n<p>The practical consequence is that companies who arrive at advisory sessions without organised documentation get less from those sessions. The adviser spends time they could spend on strategy instead gathering the information needed to have the strategy conversation at the next meeting.</p>\n<h2>What changes when a company arrives organised</h2>\n<p>When a company enters an advisory relationship with its core documents structured, assessed, and gap-analysed, the first session can begin where most engagements currently spend three or four sessions getting to.</p>\n<p>The adviser sees immediately: what the company has in place, where the significant gaps are, which risks are present that the company may not have recognised, and how the company's current state compares to what it will need at its next major milestone \u2014 whether that is a funding round, a major contract, or an exit.</p>\n<p>That picture, established in the first session rather than the fourth, has a compounding effect on everything that follows. The adviser's time is spent on the things that move the company forward. Gaps are identified and addressed early rather than discovered at a critical moment. The company makes better use of every hour of support it receives.</p>\n<h2>How technology has changed what is possible</h2>\n<p>Until recently, getting a company properly organised before an advisory engagement required significant manual effort \u2014 typically by a consultant, a fractional CFO, or a solicitor working through documents over several weeks. For most growth-stage companies, that work was either too expensive to commission or too time-consuming to do in-house.</p>\n<p>Platforms like Diligentsia have changed this. The platform's AI, Clarence, reads a company's existing documents and auto-populates approximately 60% of a structured diagnostic automatically \u2014 identifying gaps, flagging risks, and building an evidence-linked record of the company's current state. A well-organised company with its documents already available can complete this process in as little as three days. The review and approval process \u2014 which requires human confirmation of every answer \u2014 can typically be handled by a co-founder or a senior team member without requiring the CEO's direct involvement.</p>\n<p>The result is a structured, certified record of the company that its adviser can access directly, with a clear view of where the company stands before the first session begins.</p>\n<h2>What to do before your first advisory session</h2>\n<p>Companies that want to make the most of business support advisory relationships should, before the first session:</p>\n<p><strong>Gather existing documents.</strong> Financial statements, shareholder agreements, key contracts, IP records, director information, and any previous funding documentation. Most companies have most of this already \u2014 it is typically not organised or easily accessible.</p>\n<p><strong>Complete a structured diagnostic.</strong> Tools like Diligentsia can be used to assess what's in place and identify what's missing. The diagnostic produces a gap analysis that the adviser can use immediately.</p>\n<p><strong>Understand your objectives clearly.</strong> Growth, investment readiness, a major contract bid, or exit preparation each require different emphases from an advisory relationship. The clearer a company is about its objectives, the more focused the advisory work can be.</p>\n<p><strong>Be honest about the risks.</strong> Advisers add more value when they have a complete picture. Companies that disclose risks early give their adviser the opportunity to address them; companies that disclose risks late face them at the worst possible moment.</p>\n<h2>The difference an organised company makes at critical moments</h2>\n<p>The point at which being organised matters most is not during the advisory relationship \u2014 it is when a company reaches a transaction. A funding round, a major contract bid, or an acquisition conversation all require a company to produce structured, evidenced documentation quickly and completely.</p>\n<p>Companies that have maintained a well-organised record throughout their growth journey produce this documentation in days rather than weeks. They avoid the delays and surprises that erode investor or buyer confidence. They close transactions faster, with fewer conditions, at better valuations.</p>\n<p>Companies that have not maintained this record scramble to reconstruct it under time pressure \u2014 and however good the underlying business is, the scramble creates exactly the impression that sophisticated investors and buyers find most concerning.</p>\n<p>Business support advisers who use platforms like Diligentsia build this habit from the start of the relationship rather than waiting for the crisis. The companies they work with arrive at critical moments already prepared.</p>\n<h2>Summary</h2>\n<p>Growth-stage companies get more value from business support advisory relationships by arriving organised \u2014 with documents structured, gaps identified, and a clear picture of their current state. Technology now makes this possible in days rather than weeks. Companies that invest in getting organised early benefit not only from more productive advisory sessions but from being continuously prepared for the transactions, bids, and opportunities that define their growth journey.</p>\n<p><em>The Dignus Muneris and Diligentsia partnership provides structured, evidenced business support for growth-stage companies across the UK. Learn more at dignusmuneris.co.uk.</em></p>",
        "peopleAlsoAsk": [],
        "faqs": [],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "How Do Growth-Stage Companies Get More Value From Their Business Support Adviser?",
                "description": "Growth-stage companies get more value from their business support adviser by arriving at every session prepared \u2014 with their key documents organised, their gaps identified, and a clear picture of where they stand. The more organised a company is before the advisory relationship begins, the more productive every hour of adviser time becomes.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/ceo/get-more-value-from-business-support-adviser/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Companies",
                        "item": "https://diligentsia.co.uk/ceo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "How Do Growth-Stage Companies Get More Value From Their Business Support Adviser?",
                        "item": "https://diligentsia.co.uk/ceo/get-more-value-from-business-support-adviser/"
                    }
                ]
            }
        ]
    },
    {
        "icpSlug": "cfo",
        "slug": "what-happens-when-grant-funding-ends",
        "category": "Fractional CFOs",
        "title": "What Happens to Business Support Organisations When Grant Funding Ends?",
        "image": "https://diligentsia.co.uk/images/landing-pages/aeo/what-happens-when-grant-funding-ends.jpg",
        "metaDescription": "Business support organisations that lose grant funding typically face a rapid contraction in capacity \u2014 reduced headcount, narrower programme scope, and a shrinking client base \u2014 unless they have already built alternative revenue streams. The organisations that navigate this transition successfully are those that convert their expertise and client relationships into chargeable services before the funding gap arrives.",
        "lastUpdated": "June 2026",
        "url": "https://diligentsia.co.uk/cfo/what-happens-when-grant-funding-ends/",
        "bodyHtml": "<p>Business support organisations that lose grant funding typically face a rapid contraction in capacity \u2014 reduced headcount, narrower programme scope, and a shrinking client base \u2014 unless they have already built alternative revenue streams. The organisations that navigate this transition successfully are those that convert their expertise and client relationships into chargeable services before the funding gap arrives.</p>\n<h2>Why grant dependency is a structural risk</h2>\n<p>Most UK business support delivery \u2014 growth hubs, innovation programmes, Innovate UK delivery partners, catapult network affiliates \u2014 has been built on public funding. The model works well when funding is stable: organisations hire specialist teams, develop programme methodology, and build deep relationships within their sectors.</p>\n<p>The problem is structural. When the funding ends or reduces, the cost base remains. Senior practitioners, delivery infrastructure, and client pipelines do not disappear \u2014 but the revenue that sustains them does. The result, for many organisations, is a rapid and painful restructuring.</p>\n<p>This is not a hypothetical risk. The UK business support landscape has undergone significant programme consolidation over the past three years. Organisations that assumed funding continuity have found themselves responding to crises that were, in retrospect, foreseeable.</p>\n<h2>The organisations that survive \u2014 and grow</h2>\n<p>Research into business support sector resilience consistently identifies the same characteristic in organisations that navigate funding transitions without significant disruption: they had already developed services their clients valued independently of grant funding.</p>\n<p>These services share several features. They are structured \u2014 clients receive a defined output, not just access to adviser time. They are evidenced \u2014 clients can see and demonstrate the value received. And they are priced in a way that reflects real market value rather than the subsidised rates that grant programmes typically impose.</p>\n<p>The organisations that built these services typically did so for one of three reasons: foresight (they anticipated the funding environment would change), competitive pressure (they saw peer organisations developing chargeable offers), or crisis (a programme ended and they had to adapt quickly). The first group is in the strongest position. The second adapts successfully. The third finds the transition hardest.</p>\n<h2>What the new model looks like in practice</h2>\n<p>The delivery organisations that have made this transition most effectively have moved from selling time to selling outcomes. The shift is important.</p>\n<p>Selling time \u2014 advisory hours, programme participation, facilitated workshops \u2014 ties revenue directly to headcount and faces constant pressure on both rate and volume. Selling outcomes \u2014 a certified readiness assessment, a structured diligence pack, an evidenced growth report \u2014 creates a service that clients can see, evaluate, and recommend.</p>\n<p>Automation has made this shift significantly more accessible. Platforms like Diligentsia allow delivery organisations to offer structured, evidenced outputs at a fraction of the cost of producing them through human resource alone. The AI does the diagnostic and organisational groundwork. The specialist adviser focuses on interpretation, strategy, and the guidance that requires human judgement.</p>\n<p>For the delivery organisation, the economics are compelling: higher value output at lower delivery cost, with a service that clients pay for because it produces something demonstrable.</p>\n<h2>The role of sector expertise in the transition</h2>\n<p>Not every delivery organisation can make this transition equally well. The organisations that succeed have genuine sector depth \u2014 practitioners who understand the specific challenges of the companies they serve well enough to convert that understanding into structured services.</p>\n<p>In the UK innovation and business support ecosystem, that expertise is concentrated in a small number of organisations and individuals who have spent their careers in senior delivery roles within Innovate UK, catapults, growth hubs, and regional programmes. Their knowledge of what companies need \u2014 and what funders, investors, and buyers look for \u2014 is not easily replicated by generalist advisory firms.</p>\n<p>The risk is that this expertise becomes stranded in organisations whose funding model cannot sustain it. The opportunity is that organisations with this expertise, and the right operational tools, can offer something the market genuinely needs: structured, expert, affordable business support that does not require a grant to exist.</p>\n<h2>Summary</h2>\n<p>Grant dependency is a structural risk for UK business support organisations. The organisations that navigate funding transitions successfully are those that build chargeable, outcome-based services before the funding gap arrives. Automation tools have made this more accessible than at any previous point, allowing specialist practitioners to focus on high-value advisory work while structured platforms handle the diagnostic groundwork. Organisations that make this transition retain their expertise, their client relationships, and their financial sustainability. Those that do not face an increasingly difficult choice between shrinking to fit diminishing public funding or restructuring under pressure.</p>\n<p><em>Dignus Muneris works with UK business support delivery organisations to build sustainable, chargeable service models backed by the Diligentsia platform. Learn more at dignusmuneris.co.uk.</em></p>",
        "peopleAlsoAsk": [],
        "faqs": [],
        "schema": [
            {
                "@context": "https://schema.org",
                "@type": "Article",
                "headline": "What Happens to Business Support Organisations When Grant Funding Ends?",
                "description": "Business support organisations that lose grant funding typically face a rapid contraction in capacity \u2014 reduced headcount, narrower programme scope, and a shrinking client base \u2014 unless they have already built alternative revenue streams. The organisations that navigate this transition successfully are those that convert their expertise and client relationships into chargeable services before the funding gap arrives.",
                "datePublished": "2026-06-01",
                "dateModified": "2026-06-01",
                "author": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Diligentsia",
                    "url": "https://diligentsia.co.uk",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://diligentsia.co.uk/images/logo.png"
                    }
                },
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "https://diligentsia.co.uk/cfo/what-happens-when-grant-funding-ends/"
                }
            },
            {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://diligentsia.co.uk/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Fractional CFOs",
                        "item": "https://diligentsia.co.uk/cfo/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 3,
                        "name": "What Happens to Business Support Organisations When Grant Funding Ends?",
                        "item": "https://diligentsia.co.uk/cfo/what-happens-when-grant-funding-ends/"
                    }
                ]
            }
        ]
    }
];
const $7393559700759e6c$export$d83e8ce00c129c02 = (icpSlug)=>$7393559700759e6c$export$48a6bbfb0f95d83a.filter((a)=>a['icpSlug'] === icpSlug);
const $7393559700759e6c$export$62668476d728a9c9 = (icpSlug, slug)=>$7393559700759e6c$export$48a6bbfb0f95d83a.find((a)=>a['icpSlug'] === icpSlug && a['slug'] === slug);


// Local cover images for AEO articles, bundled by Parcel for in-SPA rendering.
// The article data's `image` field holds the public absolute URL (used in JSON-LD schema
// and the static crawler snapshots); these requires are the same files for the live app.





















const $d8512033fd45e289$var$AEO_COVERS = {
    'what-vcs-look-for-series-a': (parcelRequire("6OAvy")),
    'how-ai-is-changing-due-diligence-growth-stage': (parcelRequire("7OZMl")),
    'how-vcs-evaluate-early-stage-companies': (parcelRequire("leiZk")),
    'how-to-prepare-for-vc-due-diligence': (parcelRequire("fLEMS")),
    'what-do-investors-check-in-due-diligence': (parcelRequire("kbpHI")),
    'how-to-prepare-for-exit-due-diligence': (parcelRequire("jcBRH")),
    'how-fractional-cfos-use-diligentsia': (parcelRequire("bnQh1")),
    'what-angel-investors-look-for': (parcelRequire("j4E5S")),
    'how-to-prepare-due-diligence-pack-seed-investment': (parcelRequire("b8il8")),
    'how-long-does-startup-due-diligence-take': (parcelRequire("dZoB9")),
    'what-is-pisces-core-disclosures': (parcelRequire("jJl01")),
    'how-to-complete-pisces-core-disclosures': (parcelRequire("8iBsD")),
    'how-ai-is-changing-pisces-disclosure-preparation': (parcelRequire("7WyJA")),
    'sme-due-diligence-cost-statistics': (parcelRequire("4fMcK")),
    'how-ai-is-changing-fractional-cfo-role': (parcelRequire("lmUZO")),
    'what-happens-when-grant-funding-ends': (parcelRequire("3uZxt")),
    'how-angel-networks-improve-startup-funding-rates': (parcelRequire("427SA")),
    'how-to-prepare-for-angel-due-diligence': (parcelRequire("3hTs8")),
    'how-accelerators-improve-startup-funding-rates': (parcelRequire("iajSD")),
    'how-long-to-get-investment-ready': (parcelRequire("1NWfs")),
    'get-more-value-from-business-support-adviser': (parcelRequire("724aZ"))
};
const $d8512033fd45e289$export$6bf64eb9217fe938 = (slug, fallbackUrl)=>$d8512033fd45e289$var$AEO_COVERS[slug] || fallbackUrl;
var $d8512033fd45e289$export$2e2bcd8739ae039 = $d8512033fd45e289$var$AEO_COVERS;


// Above this count the row no longer fits on one line, so it becomes a carousel rather than
// wrapping into a ragged second row.
const $88019eab2786a681$var$CAROUSEL_THRESHOLD = 3;
/**
 * Hub-page "Resources" block — links down to every AEO article in this ICP's cluster
 * (hub-and-spoke internal linking). Rendered below main hub content, above the footer.
 * Cards reuse the resources-page .lp-res-card design (cover, category, title, excerpt)
 * so the hub sections match the /resources grid exactly.
 *
 * Up to three articles render as a plain grid; beyond that they scroll horizontally with
 * prev/next controls, three visible at desktop width.
 */ const $88019eab2786a681$var$AeoResourcesSection = ({ icpSlug: icpSlug, heading: heading = 'Resources' })=>{
    const articles = (0, $7393559700759e6c$export$d83e8ce00c129c02)(icpSlug);
    const trackRef = (0, $acw62.useRef)(null);
    const [atStart, setAtStart] = (0, $acw62.useState)(true);
    const [atEnd, setAtEnd] = (0, $acw62.useState)(false);
    const isCarousel = articles.length > $88019eab2786a681$var$CAROUSEL_THRESHOLD;
    const syncArrows = (0, $acw62.useCallback)(()=>{
        const el = trackRef.current;
        if (!el) return;
        // 2px tolerance — fractional scroll widths otherwise leave the end arrow permanently enabled.
        setAtStart(el.scrollLeft <= 2);
        setAtEnd(el.scrollLeft + el.clientWidth >= el.scrollWidth - 2);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!isCarousel) return;
        const el = trackRef.current;
        if (!el) return;
        syncArrows();
        el.addEventListener('scroll', syncArrows, {
            passive: true
        });
        window.addEventListener('resize', syncArrows);
        return ()=>{
            el.removeEventListener('scroll', syncArrows);
            window.removeEventListener('resize', syncArrows);
        };
    }, [
        isCarousel,
        syncArrows,
        articles.length
    ]);
    const scrollByPage = (direction)=>{
        const el = trackRef.current;
        if (!el) return;
        const card = el.querySelector('.lp-aeo-res-card');
        // Advance one card at a time so partially-visible cards are never skipped.
        const step = card ? card.getBoundingClientRect().width + 22 : el.clientWidth;
        el.scrollBy({
            left: direction * step,
            behavior: 'smooth'
        });
    };
    if (!articles.length) return null;
    const cards = articles.map((a)=>{
        const href = `/${a['icpSlug']}/${a['slug']}`;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-res-card lp-aeo-res-card",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: href,
                    className: "img cp",
                    style: {
                        backgroundImage: `url(${(0, $d8512033fd45e289$export$6bf64eb9217fe938)(a['slug'], a['image'])})`,
                        display: 'block'
                    },
                    "aria-label": a['title']
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "cats",
                            children: a['category']
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: href,
                            style: {
                                textDecoration: 'none',
                                color: 'inherit'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "cp",
                                children: a['title']
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: a['metaDescription'].replace(/\s*Last updated:.*$/, '')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: href,
                            children: "Read article \u2192"
                        })
                    ]
                })
            ]
        }, a['slug']);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-aeo-resources",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-aeo-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-aeo-resources-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-h2",
                            children: heading
                        }),
                        isCarousel && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-arrows",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "lp-arrow",
                                    onClick: ()=>scrollByPage(-1),
                                    disabled: atStart,
                                    "aria-label": "Previous resources",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                            points: "15 18 9 12 15 6"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    className: "lp-arrow",
                                    onClick: ()=>scrollByPage(1),
                                    disabled: atEnd,
                                    "aria-label": "Next resources",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                            points: "9 18 15 12 9 6"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                isCarousel ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-aeo-carousel",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "track",
                        ref: trackRef,
                        children: cards
                    })
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-aeo-resources-grid",
                    children: cards
                })
            ]
        })
    });
};
var $88019eab2786a681$export$2e2bcd8739ae039 = $88019eab2786a681$var$AeoResourcesSection;



var $acw62 = parcelRequire("acw62");
const $282a70cc4e13b055$var$SITE = 'https://diligentsia.co.uk';
function $282a70cc4e13b055$export$c897dcc6e6415719({ title: title, description: description, canonicalPath: canonicalPath, schema: schema = [] }) {
    (0, $acw62.useEffect)(()=>{
        const prevTitle = document.title;
        if (title) document.title = title;
        // Meta description
        let metaDesc = document.querySelector('meta[name="description"]');
        const createdMeta = !metaDesc;
        if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
        }
        const prevDesc = metaDesc.getAttribute('content');
        if (description) metaDesc.setAttribute('content', description);
        // Canonical link
        let canonical = document.querySelector('link[rel="canonical"]');
        const createdCanonical = !canonical;
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        const prevCanonical = canonical.getAttribute('href');
        if (canonicalPath) canonical.setAttribute('href', `${$282a70cc4e13b055$var$SITE}${canonicalPath}`);
        // JSON-LD schema blocks
        const scripts = (schema || []).map((block)=>{
            const s = document.createElement('script');
            s.type = 'application/ld+json';
            s.setAttribute('data-aeo-schema', 'true');
            s.text = JSON.stringify(block);
            document.head.appendChild(s);
            return s;
        });
        return ()=>{
            document.title = prevTitle;
            if (createdMeta) metaDesc.remove();
            else if (prevDesc != null) metaDesc.setAttribute('content', prevDesc);
            if (createdCanonical) canonical.remove();
            else if (prevCanonical != null) canonical.setAttribute('href', prevCanonical);
            scripts.forEach((s)=>s.remove());
        };
    // Reason: serialize schema so the effect re-runs only when the page actually changes.
    }, [
        title,
        description,
        canonicalPath,
        JSON.stringify(schema)
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}
var $282a70cc4e13b055$export$2e2bcd8739ae039 = $282a70cc4e13b055$export$c897dcc6e6415719;



const $1070c78a15f5f98b$var$SITE = 'https://diligentsia.co.uk';
const $1070c78a15f5f98b$export$9e391abc4320db66 = (icpSlug)=>{
    const hub = (0, $7393559700759e6c$export$aa103e2c51dcf48a)[icpSlug];
    if (!hub) return [];
    const articles = (0, $7393559700759e6c$export$d83e8ce00c129c02)(icpSlug);
    return [
        {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `Diligentsia for ${hub['name']}`,
            url: `${$1070c78a15f5f98b$var$SITE}${hub['hubPath']}/`,
            publisher: {
                '@type': 'Organization',
                name: 'Diligentsia',
                url: $1070c78a15f5f98b$var$SITE
            },
            hasPart: articles.map((a)=>({
                    '@type': 'Article',
                    headline: a['title'],
                    url: a['url']
                }))
        }
    ];
};
var $1070c78a15f5f98b$export$2e2bcd8739ae039 = $1070c78a15f5f98b$export$9e391abc4320db66;



const $7a85918df077e633$var$LandingHomeVCs = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    (0, $282a70cc4e13b055$export$2e2bcd8739ae039)({
        canonicalPath: `${(0, $7393559700759e6c$export$aa103e2c51dcf48a)['vc']['hubPath']}/`,
        schema: (0, $1070c78a15f5f98b$export$2e2bcd8739ae039)('vc')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $069e19d99083c4f2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1841db8dc3a8e13$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc4a3de35a277dec$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6fa249cef6b70dc7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8dfed0cfba32d773$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56de386a060f0ca8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f03e2eaabb0a3d09$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83ae49b79d9745dc$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88019eab2786a681$export$2e2bcd8739ae039), {
                icpSlug: "vc"
            })
        ]
    });
};
var $7a85918df077e633$export$2e2bcd8739ae039 = $7a85918df077e633$var$LandingHomeVCs;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $41b3e6b42faeeb34$var$BARS = [
    {
        nm: 'Business Audit',
        w: '92%',
        cls: 'blue'
    },
    {
        nm: 'Data Repository',
        w: '78%',
        cls: 'blue'
    },
    {
        nm: 'IP Audit',
        w: '100%',
        cls: 'green'
    },
    {
        nm: 'AI auto-filled',
        w: '60%',
        cls: 'pink'
    }
];

const $41b3e6b42faeeb34$var$CompaniesHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "For Companies"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: [
                                    "The pitch gets you the meeting.",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lp-h1",
                                        style: {
                                            color: '#FC7785'
                                        },
                                        children: "The pack gets you the money."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "AI-built diligence packs. transaction ready in days. Free to start. Once gold, 1-click connect to investors."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "lp-btn lp-btn--primary",
                                        to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                        children: "Get started free"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--ghost",
                                        href: "#lifecycle",
                                        children: "See how it works \u2193"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-hero-social",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            background: '#FC7785',
                                            display: 'inline-block',
                                            flex: 'none'
                                        }
                                    }),
                                    "Less than 1% of unsolicited VC applications succeed \xb7 We help you beat the odds"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-hero-art",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-hero-stage lp-hero-stage--co",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-hero-panel",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "lp-hero-photo",
                                    src: (parcelRequire("gNT8r")),
                                    alt: "Company CEO"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-hero-pack lp-float",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "200",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pk-top",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "t",
                                                    children: "Diligence Pack"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "g",
                                                    children: "Gold \u2713"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pk-chips",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "bronze",
                                                    children: "Bronze \u2713"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "silver",
                                                    children: "Silver \u2713"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "gold",
                                                    children: "Gold \u2713"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pk-bars",
                                            children: $41b3e6b42faeeb34$var$BARS.map((b, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pk-bar",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "nm",
                                                            children: b.nm
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "track",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: b.cls,
                                                                style: {
                                                                    width: b.w
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }, i))
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pk-btn",
                                            children: "Share Diligence Pack \u2192"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
var $41b3e6b42faeeb34$export$2e2bcd8739ae039 = $41b3e6b42faeeb34$var$CompaniesHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $3e656caa8f38c5aa$var$STATS = [
    {
        count: 40,
        suffix: '+',
        label: 'VC firms',
        pink: true
    },
    {
        count: 60,
        prefix: 'Upto ',
        suffix: '%',
        label: 'AI auto-fill'
    },
    {
        count: 3,
        prefix: 'From ',
        suffix: ' days',
        label: 'to self-certified pack',
        raw: true
    }
];
const $3e656caa8f38c5aa$var$GLOWS = [
    {
        top: -100,
        left: -100,
        size: 440,
        c: 'rgba(252,119,133,0.38)'
    },
    {
        top: -60,
        right: -80,
        size: 480,
        c: 'rgba(74,103,255,0.36)'
    }
];
const $3e656caa8f38c5aa$var$CompaniesStatBand = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-stats lp-stats--glow",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-stats-bg",
                "aria-hidden": "true",
                children: $3e656caa8f38c5aa$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: g.top + 'px',
                            left: g.left != null ? g.left + 'px' : 'auto',
                            right: g.right != null ? g.right + 'px' : 'auto',
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(76px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-stats-grid",
                children: $3e656caa8f38c5aa$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-lp-reveal": true,
                        "data-lp-delay": i * 80,
                        children: [
                            s.raw ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `lp-stat-num ${s.pink ? 'pink' : ''}`,
                                children: [
                                    s.prefix,
                                    s.count,
                                    s.suffix
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `lp-stat-num ${s.pink ? 'pink' : ''}`,
                                "data-count": s.count,
                                "data-prefix": s.prefix,
                                "data-suffix": s.suffix,
                                children: [
                                    s.prefix,
                                    s.count,
                                    s.suffix
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-stat-label",
                                children: s.label
                            })
                        ]
                    }, i))
            })
        ]
    });
var $3e656caa8f38c5aa$export$2e2bcd8739ae039 = $3e656caa8f38c5aa$var$CompaniesStatBand;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

// Content for the 2-minute demo walkthrough — one entry per journey.
// Ported from the three journey handoffs. `visual` keys map into journeyVisuals.js.
const $7e4e66f8a07acc7a$export$2142ca635aaed20d = {
    1: 'Direct \u2192 InvestorMatch',
    2: 'Introduced by a Partner',
    3: 'Preparing to Exit'
};
const $7e4e66f8a07acc7a$export$6ba6058b278c7af1 = [
    {
        n: 1,
        title: 'Direct \u2192 InvestorMatch',
        desc: "You've come to us direct, and want to be InvestorMatched."
    },
    {
        n: 2,
        title: 'Introduced by a Partner',
        desc: "You've been introduced by one of our investor partners, and want to maximise your chances at their Investment Committee."
    },
    {
        n: 3,
        title: 'Preparing to Exit',
        desc: "You're getting your company ready to exit at its highest possible valuation."
    }
];
const $7e4e66f8a07acc7a$export$372ccd13f5108d46 = {
    1: {
        badge: "Journey 1 of 3 \xb7 Direct \u2192 InvestorMatch",
        costBar: "Plans \xa3100 \u2013 \xa31,750 pa",
        costNote: "Pricing is based on your certification tier and company stage.",
        introMessage: "Great choice \u2014 <b>Direct \u2192 InvestorMatch</b> is exactly what this walkthrough covers. Click Next and I'll take you through all 8 stages.",
        steps: [
            {
                title: "Step 1 \xb7 InvestorCheck",
                text: "First, I take a quick look at your pitch deck \u2014 completely free, no commitment. In seconds I'll tell you roughly how many matched investors are already waiting for a company like yours on Diligentsia.",
                visual: null
            },
            {
                title: "Step 2 \xb7 Connect & Upload",
                text: "Next, point me at where your company documents already live \u2014 Google Drive, Dropbox, SharePoint \u2014 or just drag files straight in. You never have to re-type anything; I start reading the moment it lands. Or manually upload. If you need help deciding what \u2014 I'll take you through a checklist.",
                visual: 'connect'
            },
            {
                title: "Step 3 \xb7 Auto-Populate",
                text: "Now I get to work. 200 of my analyser agents scan everything you've given me and draft answers for each diligence module, with the evidence attached. A second, independent AI checks every draft and scores how confident it is.",
                visual: 'populate'
            },
            {
                title: "Step 4 \xb7 Review & Refine",
                text: "Nothing goes out under your name until you've seen it. I show you every drafted answer next to its evidence \u2014 you just confirm it's right, or correct it. That's what keeps the pack honest.",
                visual: 'review'
            },
            {
                title: "Step 5 \xb7 Generate Pack",
                text: "One click, and I compile every module \u2014 foundational, value, and independently verified \u2014 into a single, investor-ready diligence pack. The same format investors already know how to read.",
                visual: 'pack'
            },
            {
                title: "Step 6 \xb7 Self-Certify",
                text: "Before anyone else sees it, I run the same stress-tests an investor would run \u2014 and flag anything risky so you can fix it first. The more you resolve, the higher you climb: Bronze, Silver, Gold. We only match Gold-certified companies with our full investor network.",
                visual: 'certify'
            },
            {
                title: "Step 7 \xb7 InvestorMatch",
                text: "Your certification level decides how many investors \u2014 and how good a fit \u2014 you unlock. Bronze gets you a handful; Gold opens the door to our whole matched network. One click and you're connected.",
                visual: 'match'
            },
            {
                title: "Step 8 \xb7 Investor Diligence",
                text: "Finally, you decide who sees what, and when. Once you grant access, investors \u2014 or their own AI \u2014 can query your pack directly. No more chasing the same questions over email.",
                visual: 'diligence'
            }
        ],
        timeEstimates: [
            {
                label: 'Instant',
                free: true
            },
            {
                label: '10 minutes',
                free: true
            },
            {
                label: 'From 3 days+',
                free: true
            },
            {
                label: '30 minutes',
                free: true
            },
            {
                label: '3 minutes',
                free: true
            },
            {
                label: 'From 1 day',
                free: true
            },
            {
                label: 'Depends on tier',
                variable: true
            },
            {
                label: 'Depends on investor',
                variable: true
            }
        ]
    },
    2: {
        badge: "Journey 2 of 3 \xb7 Introduced by a Partner",
        costBar: "Plans \xa3100 \u2013 \xa31,750 pa",
        costNote: "Your investor may have agreed to subsidise this \u2014 please check.",
        introMessage: "You've been introduced by one of our investor partners, so first I'll triage your fit against what they're looking for \u2014 that part's on us, and it's free. Once you're through, I'll get you investment-ready, also at no cost, before we move into the same diligence process every company on the platform goes through. If their Investment Committee doesn't proceed, that's not the end of the road \u2014 I'll InvestorMatch you with other investors on the platform. Click Next to see how it works.",
        steps: [
            {
                title: "Step 1 \xb7 Triage",
                text: "You've been introduced by one of our investor partners, so I start by checking your fit against what they invest in \u2014 sector, stage, geography, that sort of thing. This is a 3-minute triage of your application \u2014 there's nothing for you to do here. It's the standard first stop for every partner-introduced company, and it's completely free.",
                visual: 'webform'
            },
            {
                title: "Step 2 \xb7 Investment Readiness",
                text: "You complete a checklist to assess how investment-ready you are. It's designed to help you \u2014 while giving your VC additional information to speed up their investment decision. This is also completely free.",
                visual: 'readiness'
            },
            {
                title: "Step 3 \xb7 Connect & Upload",
                text: "Point me at where your company documents already live \u2014 Google Drive, Dropbox, SharePoint \u2014 or just drag files straight in. I start reading the moment it lands. Or manually upload. If you need help deciding what \u2014 I'll take you through a checklist.",
                visual: 'connect'
            },
            {
                title: "Step 4 \xb7 Auto-Populate",
                text: "Now I get to work. 200 of my analyser agents scan everything you've given me and draft answers for every diligence module your partner VC's team will ask about, with the evidence attached. A second, independent AI checks every draft and scores how confident it is.",
                visual: 'populate'
            },
            {
                title: "Step 5 \xb7 Review & Refine",
                text: "Nothing goes out under your name until you've seen it. I show you every drafted answer next to its evidence \u2014 you just confirm it's right, or correct it. That's what keeps the pack honest, and keeps you in control of your own story.",
                visual: 'review'
            },
            {
                title: "Step 6 \xb7 Generate Pack",
                text: "One click, and I compile every module \u2014 foundational, value, and independently verified \u2014 into a single, investment-ready diligence pack. The same format your partner VC's own team already knows how to read.",
                visual: 'pack'
            },
            {
                title: "Step 7 \xb7 Self-Certify",
                text: "Before your partner VC sees it, I run the same stress-tests their diligence team will run \u2014 and flag anything that could work against you, so you can fix it first. The more you resolve, the higher you climb: Bronze, Silver, Gold.",
                visual: 'certify'
            },
            {
                title: "Step 8 \xb7 Investor Diligence",
                text: "Your partner VC \u2014 or their own AI \u2014 can now query your pack directly, with no more chasing the same questions over email. You control what's shared and with whom throughout.",
                visual: 'diligence'
            },
            {
                title: "Step 9 \xb7 Investment Committee",
                text: "The Investment Committee has a complete pack of information created by you on our platform \u2014 giving them more information with which to make a better decision. And you have strengthened your company in the process. If they reject you, we offer you InvestorMatching with other VCs on our platform.",
                visual: 'memo'
            },
            {
                title: "Step 10 \xb7 InvestorMatch",
                text: "If the Investment Committee doesn't proceed, this isn't the end of the road \u2014 I'll InvestorMatch you with other investors already on the platform, using the same pack you've already built. It takes minutes.",
                visual: 'match'
            }
        ],
        timeEstimates: [
            {
                label: '3 minutes',
                free: true
            },
            {
                label: '30 minutes',
                free: true
            },
            {
                label: '10 minutes',
                free: true
            },
            {
                label: '30 minutes',
                free: true
            },
            {
                label: 'From 3 days+',
                free: true
            },
            {
                label: '3 minutes',
                free: true
            },
            {
                label: 'From 1 day',
                free: true
            },
            {
                label: 'Depends on investor',
                variable: true
            },
            {
                label: 'Depends on investor',
                variable: true
            },
            {
                label: '3 minutes',
                free: true
            }
        ]
    },
    3: {
        badge: "Journey 3 of 3 \xb7 Preparing to Exit",
        costBar: "Plans \xa3100 \u2013 \xa31,750 pa",
        costNote: "Pricing is based on your certification tier and company stage.",
        introMessage: "You can only sell your company once, so let's get you the highest possible price. Buyers now run sophisticated AI diligence tools \u2014 it pays to run those same tools on yourself first, so you're never caught out or price-chipped. Click Next to see how it works.",
        steps: [
            {
                title: "Step 1 \xb7 Connect & Upload",
                text: "Point me at where your company documents already live \u2014 Google Drive, Dropbox, SharePoint \u2014 or just drag files straight in. I start reading the moment it lands. Or manually upload. If you need help deciding what \u2014 I'll take you through a checklist.",
                visual: 'connect'
            },
            {
                title: "Step 2 \xb7 Auto-Populate",
                text: "Now I get to work. 200 of my analyser agents scan everything you've given me and draft answers for every diligence module a purchaser's team will ask about, with the evidence attached. A second, independent AI checks every draft and scores how confident it is.",
                visual: 'populate'
            },
            {
                title: "Step 3 \xb7 Review & Refine",
                text: "Nothing goes out under your name until you've seen it. I show you every drafted answer next to its evidence \u2014 you just confirm it's right, or correct it. That's what keeps the pack honest, and keeps you in control of your own story.",
                visual: 'review'
            },
            {
                title: "Step 4 \xb7 Generate Pack",
                text: "One click, and I compile every module \u2014 foundational, value, and independently verified \u2014 into a single, exit-ready diligence pack. The same format a purchaser's own advisers already know how to read.",
                visual: 'pack'
            },
            {
                title: "Step 5 \xb7 Self-Certify",
                text: "Before any purchaser sees it, I run the same stress-tests their diligence team will run \u2014 and flag anything that could be used to chip your price, so you can fix it first. The more you resolve, the higher you climb: Bronze, Silver, Gold.",
                visual: 'certify'
            },
            {
                title: "Step 6 \xb7 Purchaser Diligence",
                text: "When you're ready to go to market, you decide who sees what, and when. Grant access to each prospective purchaser and they \u2014 or their own AI \u2014 can query your pack directly, with no more chasing the same questions over email. If a purchaser walks away, your pack stays live and ready for the next one.",
                visual: 'diligence'
            }
        ],
        timeEstimates: [
            {
                label: '10 minutes',
                free: true
            },
            {
                label: 'From 3 days+',
                free: true
            },
            {
                label: '30 minutes',
                free: true
            },
            {
                label: '3 minutes',
                free: true
            },
            {
                label: 'From 1 day',
                free: true
            },
            {
                label: 'Depends on purchaser',
                variable: true
            }
        ]
    }
};
var $7e4e66f8a07acc7a$export$2e2bcd8739ae039 = $7e4e66f8a07acc7a$export$372ccd13f5108d46;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Step visuals for the 2-minute demo, ported from the journey handoffs.
// `connect`, `populate` and `pack` are identical across all three journeys; the rest differ, so
// getVisual() prefers the journey's own version and falls back to the shared one.
const $9b33bb7066f3abbf$var$SHARED_VISUALS = {
    connect: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "vw-label",
                children: "Connects to"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "icon-row",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "icon-chip",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "icon-circle",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    viewBox: "0 0 40 40",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M14 4h12l12 20-6 10H8l-6-10z",
                                            fill: "#e8eaf6"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M14 4h12l6 10H8z",
                                            fill: "#00ac47"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M8 14l6 10h20l6-10-6 10H8z",
                                            fill: "#ffba00"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M14 24h20l-6 10H20z",
                                            fill: "#2684fc"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Google Drive"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "icon-chip",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "icon-circle",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    viewBox: "0 0 40 32",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M10 2 0 9l10 7 10-7z",
                                            fill: "#0061ff"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M30 2 20 9l10 7 10-7z",
                                            fill: "#0061ff"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M0 23l10 7 10-7-10-7z",
                                            fill: "#0061ff"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M40 23l-10 7-10-7 10-7z",
                                            fill: "#0061ff"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Dropbox"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "icon-chip",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "icon-circle",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    viewBox: "0 0 40 40",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                            cx: "15",
                                            cy: "12",
                                            r: "9",
                                            fill: "#036c70"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                            cx: "26",
                                            cy: "14",
                                            r: "7",
                                            fill: "#1a9ba1"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                            cx: "16",
                                            cy: "27",
                                            r: "6",
                                            fill: "#37c6d0"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "SharePoint"
                            })
                        ]
                    })
                ]
            })
        ]
    }),
    populate: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "vw-label",
                children: "What I'm auto-populating"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lozenge-legend",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lz-dot none"
                            }),
                            "Not started"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lz-dot low"
                            }),
                            "Low risk"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lz-dot medium"
                            }),
                            "Medium risk"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lz-dot high"
                            }),
                            "High risk"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lozenge-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge low",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Data Repository"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "Low risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-bottom",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "92% complete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "95% confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge low",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Business Audit"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "Low risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-bottom",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "78% complete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "88% confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge medium",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Directors' Questionnaires"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "Medium risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-bottom",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "45% complete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "81% confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge high",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Draft Warranty Disclosures"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "High risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-bottom",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "30% complete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "74% confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge low",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Market Opportunity"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "Low risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-bottom",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "100% complete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "93% confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge medium",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Route to Market"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "Medium risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-bottom",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "65% complete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "84% confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge low",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Competitive Advantage"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "Low risk"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-bottom",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "88% complete"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "90% confidence"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lozenge none",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lz-top",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-name",
                                        children: "Technology Advantage"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lz-tag",
                                        children: "Not started"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lz-bottom",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Not started yet"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }),
    pack: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "pack-hero",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pack-trio",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pack-trio-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-trio-head",
                                    children: "Foundational Diligence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-yellow",
                                    children: "\u2713 Data Repository"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-pink",
                                    children: "\u2713 Business Audit"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-blue",
                                    children: "\u2713 Directors' Questionnaires"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-teal",
                                    children: "\u2713 Draft Warranty Disclosures"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pack-trio-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-trio-head",
                                    children: "Value Diligence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-yellow",
                                    children: "\u2713 Market Opportunity"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-green",
                                    children: "\u2713 Route to Market"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-green",
                                    children: "\u2713 Competitive Advantage"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-green",
                                    children: "\u2713 Technology Advantage"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-purple",
                                    children: "\u2713 SWOT"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pack-trio-card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-trio-head",
                                    children: "Other"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-blue",
                                    children: "\u2713 Financial Diligence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pack-hero-row c-teal",
                                    children: "\u2713 Software / Technical DD"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "pack-hero-sparkle sp1",
                    children: "\u2726"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "pack-hero-sparkle sp2",
                    children: "\u2726"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "pack-hero-sparkle sp3",
                    children: "\u2726"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pack-hero-tooltip",
                    children: "Clarence \xb7 You control contents and circulation"
                })
            ]
        })
    })
};
const $9b33bb7066f3abbf$var$JOURNEY_VISUALS = {
    1: {
        review: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "rl-header",
                    children: "1 / 4 reviewed"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence high",
                                    children: "High confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "rl-status-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "rl-status done",
                                            children: "\u2713 Reviewed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "rl-reviewer",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "rl-avatar",
                                                    children: "BC"
                                                }),
                                                "Benjamin Clark \xb7 Aug 1, 2026, 8:06 AM"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "What is your current monthly recurring revenue?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "\xa328,200 MRR, drawn from Kestrel Logistics' latest management accounts."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence high",
                                    children: "High confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "Do you hold any registered IP (patents, trademarks)?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "One UK trademark identified (Companies House filing, 2023). No patents found."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence medium",
                                    children: "Medium confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "Are there any related-party transactions?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "One director loan of \xa315k identified \u2014 recommend confirming repayment terms."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence medium",
                                    children: "Medium confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "What is your customer concentration risk?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "Top client represents 34% of revenue \u2014 flagged for further review."
                        })
                    ]
                })
            ]
        }),
        certify: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cert-ladder",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier passed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Not yet certified"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "5 matched investors"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-check",
                                    children: "\u2713"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier passed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Bronze"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "3+ investors"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-check",
                                    children: "\u2713"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier current",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Silver"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "8+ investors"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-here",
                                    children: "You are here"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier locked",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Gold"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "17+ investors"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-lock",
                                    children: "\uD83D\uDD12"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cert-footer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-count",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-count-num",
                                    children: "10"
                                }),
                                "investors matched to you now"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "cert-callout",
                            children: "Only 3 more questions to answer to reach Gold"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "cert-note",
                    children: "Answer a few more questions in Review & Refine, then resolve any flagged risks, to reach Gold and unlock even more investors."
                })
            ]
        }),
        match: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "im-tabs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "im-tab",
                            children: "Bronze \xb7 3"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "im-tab active",
                            children: "Silver \xb7 8"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "im-tab",
                            children: "Gold \xb7 17"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "im-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-avatar",
                                    style: {
                                        background: '#3b5bfd'
                                    },
                                    children: "FL"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "im-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-name",
                                            children: "Freya Lindqvist"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-firm",
                                            children: "Nordwind Capital \xb7 B2B SaaS \xb7 Seed-A"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "im-match",
                                    children: "96%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-bottom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-status active",
                                    children: "Active \xb7 invested 2mo ago"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-connect",
                                    children: "1-Click Connect"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "im-links",
                            children: "Investment criteria \xb7 About the firm \xb7 About Freya"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "im-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-avatar",
                                    style: {
                                        background: '#1fa971'
                                    },
                                    children: "MD"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "im-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-name",
                                            children: "Marcus Delaney"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-firm",
                                            children: "Harborline Ventures \xb7 Fintech \xb7 Series A"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "im-match",
                                    children: "94%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-bottom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-status active",
                                    children: "Active \xb7 invested 4mo ago"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-connect",
                                    children: "1-Click Connect"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "im-links",
                            children: "Investment criteria \xb7 About the firm \xb7 About Marcus"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "im-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-avatar",
                                    style: {
                                        background: '#d99b2b'
                                    },
                                    children: "PA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "im-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-name",
                                            children: "Priya Anand"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-firm",
                                            children: "Anchorpoint Partners \xb7 Vertical SaaS"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "im-match",
                                    children: "92%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-bottom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-status slow",
                                    children: "Slowing \xb7 last deal 9mo ago"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-connect",
                                    children: "1-Click Connect"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "im-links",
                            children: "Investment criteria \xb7 About the firm \xb7 About Priya"
                        })
                    ]
                })
            ]
        }),
        diligence: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "diligence-block",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dblock-head",
                            children: "Investors querying Kestrel Logistics' pack"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "access-mini2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Investor"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Access"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Tools"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Status"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-name",
                                                    children: "Freya Lindqvist"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-sub",
                                                    children: "Nordwind Capital \xb7 3 queries"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Full pack"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Internal tools only"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "status-pill viewed",
                                                children: "Viewed"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-name",
                                                    children: "Marcus Delaney"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-sub",
                                                    children: "Harborline Ventures \xb7 5 queries"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Full pack"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "External MCP link"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "status-pill mcp",
                                                children: "AI connected"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-name",
                                                    children: "Priya Anand"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-sub",
                                                    children: "Anchorpoint Partners"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Summary only"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Internal tools only"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "status-pill pending",
                                                children: "Pending"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "diligence-block",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dblock-head",
                            children: "External investors (not yet on Diligentsia)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "access-mini2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Access"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Status"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-name",
                                                    children: "Phil Smith"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-sub",
                                                    children: "phil.smith@yopmail.com"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Summary only"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "status-pill viewed",
                                                children: "Active"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dblock-note",
                            children: "They don't need to register \u2014 we send a secure link by email, and they interrogate your pack directly. External AI diligence tools (MCP) only connect once they register on Diligentsia."
                        })
                    ]
                })
            ]
        })
    },
    2: {
        review: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "rl-header",
                    children: "1 / 4 reviewed"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence high",
                                    children: "High confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "rl-status-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "rl-status done",
                                            children: "\u2713 Reviewed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "rl-reviewer",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "rl-avatar",
                                                    children: "BC"
                                                }),
                                                "Benjamin Clark \xb7 Aug 1, 2026, 8:06 AM"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "What is your current monthly recurring revenue?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "\xa328,200 MRR, drawn from your latest management accounts."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence high",
                                    children: "High confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "Do you hold any registered IP (patents, trademarks)?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "One UK trademark identified (Companies House filing, 2023). No patents found."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence medium",
                                    children: "Medium confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "Are there any related-party transactions?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "One director loan of \xa315k identified \u2014 recommend confirming repayment terms."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence medium",
                                    children: "Medium confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "What is your customer concentration risk?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "Top client represents 34% of revenue \u2014 flagged for further review."
                        })
                    ]
                })
            ]
        }),
        certify: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cert-ladder",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier passed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAShklEQVR4nO2d3bKiOhCFG51795z3f8ZT2wfYci6mek67XN0JCgiyvioLVNQEs+ifhGQYx9GEEJzTuwsgxJaRQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQokECEKJBAhCiQQIQo+PXuAhyJ6/V6t1qRL16E24phGB7242uXy2V4+JB4mkErTM1PFEI8v5kg5hLIMAw2DIN9fX1JJDMhgcyIC4OJwszsdrs9vDaOY3o8AwUSn59OJxuGwU6nP56zrMnrKAZZAG/0+JgDF0UURva76NKJ6SgGWQDWeBnjOHYfW/0OulhiPiSQN8KC7Cku1jiOdjqdZrNO4hEJZEYul8twvV7HKVfxV6wIsyBiXiSQmXGR+POeRlsdg9YBj62ey7K8jrJYK5JluapGPVUgCL6vzNY0ZEHezBSLYCarsDayIG9gSvp1StA+9XhZkzayIG+m1Uin9mVMEcz1eh0lkhpZkJ0xVTCtGEYCqVFPuhAFcrE+HPWNvIYEsjOmukToksXPa6xWG8UgQhQoBhGiQAIRokACEaJAAhGiQAIRokACEaJAAhGiQAIRokACEaJAAhGiQAIRokACEaJAAhGiQAIRokACEaJAAhGiQAIRokACEaJAAhGiQAIRokACEaJAAhGiQPNiHYw4F5amHW2jebE+GJ+cOluW2mddlFByZEEsn2Fw7w1nHEf7/v4e2QTWry4gehQObUGu1+tD46lgDWprIoqrWHndsjp6fbSues4hBRKFUTWkntWfhmF4W8NCy4d16hFIXDo61kdrh/zhcALxRnW73f42otvtZma5QKptbGBrNShc69DdpSiKWL+qXsMw/LUgsT7+nUcXySFjkNvtNptAzufzWsUuifXB5y2BxNdR9EfnUAJx1yoKI26ZNWUuSHztdrvZ6XRavUGhC4Vix7pFWD2y8h/d1TqUQMzuG5M3oGhRECYQF8TpdLprqGs1JhZjREGY3VtJfy3WyeuAgToetybuOm5JkIeIQaLPHgXx8/PzIJDW1dYbFz7i+0v+wW4Fo6CZNewVSCx/rAfWyWz5hsvS7e8Wy+EsCPKMQBgx0F0TJowegWBZtxJLIe928Q4lEOazM5crgpkesz+NMmaNMDj+/v4el7AkGEOxcmN8lcVWmAL247xe7wTL8U7X61ACyWANHXFRuFhQSGb2IKRXr36sn4PFTyzx0Eo+bLEnPQ6LYX0439/f49fX16qFlkACrY61eByzONF1caE8I5JWP0ePUDLR94hiK8LB8g/DsLrLJYFMJBNF3F+in4RZCnxUruIn4PVaUyQSSIPMmvifVQnEXbFnfehWzISBOB5fld/LmT3eTU/8tAaHEIg3zGxka9UwsoYWY5L4XeM43sUhwzA8CKkHbOxZrMGC8WpkQDb+yvfZa+9OtWI9xnFczYocQiDIs1fO+EdFIXiDZN+B8YhZbUmqTFWWxmWZLCxDVfd4TE/v+lLgfSuZFamSKXNzSIFEMPOE7kn1R6AVyQRi9r+7xXqsGZmlQIFUmSosB+sgxIe455ACyawHS996A0fr4e8xFyz2k8R9f+/7+3uM3x2/t2U5sudMJCjcngd+7l0c0oJgXn9t3xYbgY+l8isnsxyxkbA/yt/P+kk8Bom/jw0XxVfFGFk/RyYOHDLCLEjlYq79H2FdnklTz8nhLAj64y4Ss3uBxEYdYSJBsnRrFSCzz1VCaVkO/A0cb4XiiCOSfbuF4DwTzFqB+uEE4mTCYNupfQooDGdugfTUkQmDWRDBOZRAcIYPs1oo7jZhbMLiEQZmllqZM3TxWv0cmVAyQbAtK8u7LQeSWZA14pBZBdJKY27hxDORmN3fD4EnPvZjxLijcrdYDNOTXkZxZJYjE0b8nSlD2reA/zdrBeA9zCaQWLEt3vgS8XLFeys8WI4Wxez+ym/WDhKZSFiQngnEP5dlsRAUIP4OulIYa2zZcjDwvCwdhxzKxcrAbFLmQrEsV4Uf15Nuxc+17nTM6oCiyASypav0lplNIKzR7MGSeBlZH0DMcvVYkMr9icfE7+y1IP46sxhYXrbPBOn7W/1/MtaMQ2YRSBwewXz1Lc8HizFJvM+c9Y/4Ft0fFpf4OahiGvwM+z12jIMNP8tSYbZqS7FHCz+HGNftJkjP1MwC1S0SYxJ/zTNX3rjMeD+JGU/Xsv1IFCB7r7pKZrFGlqXCYHxPMQdjzThEMUgBNuDMksTXppCN8kVXqipfJRCNr3qdxSzI1q0GI1oSjBOqHncWQ7D9XlqiY3ESGzaSxR57tRzIGnHIopcXLPhe/pjL5TL0ZIVa45gQFsOwuwLxWMYzZdvL+a9giQt3s5b4vVkE0vKZ94iLpBoe3nO1Rti5qh6R7Hd6y+b1WvzkrQSLReb+DcUgHWTZrLj/8/OzepkqYZjt083dGovFIFnKd0/EoQ9ZPwmLUeaMSVhqNnuN9XN4PSb96AapUuGx7c2d0Vo8BokVW8pPXBJ3tZys36Fyr17tc2Cdez2Py+UyfJI4qu6Epdz7ly0I3kPtfIIFcVg/Sc+V25nrT5sijFl+cEO0OlOX6nNTknxGPFZR38Pn8PI/2ZuB+RRaWSvmCq1Vhk+EtSPWUbsUq8Ygezf9rfL3NNpWrILHHI3MXWf9H2swiwXx7SdbDrN8zqo16e072WNCBMnO75rnXM7yB+ENyqcVEq+jjsIOcO3x1tV7yhVuihuVDVXJsmdLrVOyFlmssabrKQvSIC4b3ZpR/VX3qzU8BZ+zWRZZ2fbibuGFyPeRNV1bCaSgNU9u76Oi1YcSYd/dK9y9iCTCLObaMZ9crA6yiaKziaSXXpsj+34mtq2uPbgXJJAEXE02e7TmyGVXPBy6UsG+axiGOyH6b8ahL2b3c355nfYWj2SWYy1rIoEQ0LWqLEi0Imb3V3f8A5kbxfpCMoHh/ul0sp+fn78999iP4uXa0+yJU92ppUXyskCm+NBbZ0q2akrMkXUItt7z5y3B4DzC8X56LNeWJ9BgTLEgS7Q9WZCEah2O7PWK7CJSCaIVy0TXKvsuVoaj9tI/wyIWZG/jhGIq1+x5C4LEK7o/x/NRnZt4LLuCsucu3mEY7gTGfucdyyr3MjUbaLbMVEYvC+RyuQz//vvvuNdxRGy4fgy+KwsSj0fwAsGWF8DzhGnN3vMYf99jjmx2ebx/ZcuT+2UCiVYWz+Xc9ZjFxcosCL63NeJ8wlMyVPF9BOudzaYej3Hwu7NzF92q+JrDLAiWDW8j3lqGq7IgLPZYasTAbDFIdtXaA1P7OTJxRLwRPisQLN/UbA2bjohZMLPt378Sz/faZZ1FIC4Oz7tnacWtXKVitipr+K2VnfzzWSNsrcfhx0Sy78f+jHh89dzrgWXDfpItWZHKYrOsnNmyXsosArlcLkMcQTqlI+xdZNai9XoM5B2sb3Sv2BodWdYJf98FFC8+mNJlIokNKVp2tFyssb1TJK0ECIv5vC5LJRtmc7H2EHOY3feQmz3+KZnlqNK5mUCYUCqBRGKMwD7Dgnv23Pejy8X6Sfw7x3F8S19Jz7i3jCXb26H7QdgAv2zbggXlrZkOYzYmfo9bDDPe2FsNJhLdk8wdNJu+jvtRmE0gPocUu+Jswbd1qitUFXf4Zx2WtcuWHmCP+B1YPpZtimXP6sX2p9Q/ftbLsdZ/96zlWNpjmdWCbHltwkgWa+C4qkoc2Igr6xEbOv6h1Z/LBGJmdwLGbFoVk/hnsR6VQMyWXwgpuldZPbDM7IKzBIdysZ69vyOSpWqrgBw7CbOGhvNumVnqbmHgHaliEn/eY0FibLIUvff5M4vtD61RuBDZjUbZuh1ItZoTWo5nYcsuOGhRpoL13EuiZU0OIZBslC57rRUIt4Jx1ucRG1x1tcuWg8N9xxt41k/i9cD9rP7Z8UuJZcosMZUFWZJDCCTS40pF/9vs/2xT5lZlAonHTnED2G9XjSf2k2BdWaYsOx/sc1j3OfDAv+e/iHHS2vGH2cEE0uuGsCxT9uf0WI8p4ojHsvvIWe/7lIbSOm5uMWS0xsE5LN6TQDYCCqWyHCiQZ2KCChwW4uCVH92lrY+P672vJnNplx6uf2iBZFcivCpVVqOKN17NsMRZ5XFN91gWh12FW3VZ82ocy8nKm5UfM4LxvC/N4QTCGnEMdFnjarlVGHf4Z+ZKP8bvYaKIaWB/xAwVc1l6EgpLNsBYzmpWGC9DLO/5fP57/pfmEALxBuYDKlmDr0a9sobExOHHL5WXjxYFhW2WjwaOtCzI0pald7YYLGvm0i7NIQSCxKtShAWIvs0E8s6xS9iBmKVseywI1m/uGIqRTXaHZDHfGiM0DiUQFmfglZI1JvT3s6vsWkNq4u0FLQtixoeX9FiMuevVO2I3ZuaqhMgaHEogZrn7ZPbYMZa5UO8UB9bDOZ/PDw2Njc5ldVorBmmJA60Hs3ZrWg8zs2ENU7o1rtfrWA1QZALx5/H1d4kDYVdmVjeHCcSnKF0ilsIJwMdxtJ+fH7vdbndbLJ8/PCj37ZozsRzOgkQwyDXrF8jWLixfX19D76hYJpA1YTPGZKzd74Ec0oKY/clo4RUXcWFkAtmC9UBilohNh2pW90jPXafYY+5lilbD9zFz5dbi169fdj6f7Xw+2+/fv1c/14e1IHjVZNkodoVdqiHNTYyrsn6TpWMO/z0za6Z1q76ntfo8GIcVCI6cZTCBbFkUZvf1Yg0+1gct49wxh/NscL6FOO+wAom8ww9fg2z81lp1xd5x1nNeEWOPd3HYGMSprEh1n/1eiDGAgwJZIuZgWTXfetzBhBJjD3/8888/bzv/h7cgrcaxZ3GYrV9+JgoUSI9rtYWRCmYSiJiRynpkM8VEa5YNf3knEohYhGpuYySm098x3qpCs4SJl+lZmYu5VpjGxR7zd7tXZrIgYiaie4WxRwzE0YLEwYfn8/muk/Dd1sNMAhEvUt1bzqyGb2MfDLMgW1n5SgIRi4LjrTAoZ4+tiMNMMYh4Ao85psxU6VTxx7vGW1VIIGISTBxm+Vgrs8cbudg4qy25VRG5WKIJG1vl2yzeqPo72N2CWxSHmQQiJoCra1W95uz2geo22q0igYiUqn/DjA9GxOPN2vOKbdV6mEkgogAbfLYsHbsxC10rNq+Vb7eMBCIeiJbDt2xpOnY/v9n9HZfMasSe8i10BlZIIKKkWrsxE0i0ClXcsWXXypFAxB3VkJFKIHEii17rsQckEHGXxm3dv1H1dZi1A/K9uFaOBHIw4oKcLNaoLEbWO96KOfYqDjMJ5JCM4/h32iN/7tsegSC9VmNv4jCTQA5BdKGqJa5ZzMH6OZxqip49ZqwYh5q0gU3QsMc/bQooDhSDGe/nwGP9ODaHFrtVNgpjD9mqjI8XCAagSOue5z0LCGc0qSxEFWew7BTeJpu5Vns+f2ZysQ5B7Ol+RSDZgMNoLT5FGM7hBMKyLxXolu3hj4+zqWND7xFIPJaB4ohDR/Zwfqbw8S6W2eOgu5Zbxa6YzhrT0LSWgq5AQWSxBmanzPho3QgLwH1y6U+yGpFDCMRhswxG0NdmrD1PE5a3iqNYQ68sCLMw7HfigEMcbPjr16/N3QU4J4dzsXrJ1qzYgkBaIseGngkkI5vRPos3PplDWRCzOqtV9RFEXhFJdb7RErB99vnoEmbZJzwWrQuWAZdFYLOP7D2F28PhBBKp0qAtkTi98cwUKlFkjd3Lkh3bW66YvmX3cnxipqri0AIxe1wBiWV5nGesSU8MkX2mFRtkAmbxg+/H+ArLzubFjcLw/SMIw1EM0kHmjpitKxDcYtaJlYf1XeD7UTCZtfh0Vyrj8BbE7HEVVjOzn5+fh4A2m4ggghmwHiuEVIIYhqFMx2J54gyGPY9P7A1/BQkkEBf2dIFU02f2MMWCTLUYmUCyHu9MEHuap2pt5GIFcABebIBZWnTNCwzLcsXXfT8bZZsJgglE4viDLAjher2O2f0QZnnQ7M9b72f0flcrBR2zT77NBMIsisTxPxJIAROKWd1Q0dK84mL5fvaZmN51WgKJI3GjYPz5keMNhgTSAZuk2SwXyBQLMlUwEZa27XWx/H0JokYCmQh2LuJ+a0Ts1LRvlVpm2+ohMUxHApmBOFp4aYFgo/fX2HsSxOtIIDMTJ0NouVvZa/g+ZtcwxpAglkMCWYDqhiWk5/wzgUgU6yCBLAybXicyRSASxvpIIG+m545BieF9SCBCFHz27WBCvIgEIkSBBCJEgQQiRMF/xnWq7Nr/Y9sAAAAASUVORK5CYII=",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Not yet certified"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Not sale-ready"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-check",
                                    children: "\u2713"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier passed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Bronze"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Minor issues remain"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-check",
                                    children: "\u2713"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier current",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAA4JUlEQVR4nO19bXPjuI71AanMVu1MT3r3///Ep+4kne5bz+2IxH7AC0FKlp0Xx3YipBRbsiyTEg+BA4AkMTN22WWXdUmXLsAuu1yz7ADZZZcN2QGyyy4bsgNkl102ZAfILrtsyA6QXXbZkB0gu+yyITtAdtllQ3aA7LLLhuwA2WWXDdkBsssuG7IDZJddNmQHyC67bMgOkF122ZAdILvssiE7QHbZZUN2gOyyy4bsANlllw3ZAbLLLhuyA2SXXTZkB8guu2zIDpBddtmQHSC77LIhO0B22WVDdoDsssuG7ADZZZcN2QGyyy4bsgNkl102ZAfILrtsyA6QXXbZkB0gu+yyIdOlC3Bt8vj0iwEGAwADzIxDa6jIOXruASHQ0d8kP4VABFA7ACLC/bc/j19kl7MIfeUFdB5//mJUBisgmBlcGcxo+x1A5LMoa/cvHkkbALHzDBBEPUDifkoCNpIDuP9rB81HyJcFyMPTT26A6AFSa9iHHBPpAcIQJC11SNAAJ2mQAwBJAohkACHyLaW0g+QD5MsB5PGHAKMiaox6MkBqBIjeuxEgPSgOt2H75BSAUAKIEpJrlORg2YFyPvkyAHl8+rdqjOoaowYNAphJVQeABDNKAWN4qEpUeoBQpz+2hABAG7m+BWEATCIkSs3UohE4BKJdm5xLvgRJf3z6xbUuOcX6PhYGUxMa9nhxDBQhciJAjp7dTDtzHoAB9i8yHn785J3Qv798aoA8Pv1iA8A6QGTbdENdkxgeK1BRFVzkXjAicqAA2MHyDvLpTKzHp5/sXijzUFUDAzuvIASNMZhQdfBa+R1y369/CtEjIwdZvls7ROPZoaGbpBRMsM4NzLKvn7N/Tn5JUtMs7Zrl1fIpAPL440lMKG2o7BxCGYKZJAuAtFiGvPgV+v1DcZAeOSLk/47K2lljDMSIOzMcHGKUCUCQAucJ3CV+PwXv1/e/d6C8RG4aIA8/fnKtRqwBRYF7mthIdOzxo1vWQWNX7AGyFvc4t0SAjPsEJejdCctkiKiJoltYXmnXKC+QmwXIw+MTV1aXrAKEFSD8AoBI92xXvX6A8BhZWbPiTgBISmkHyQlycwB5+CEco9YCB0itqNbwqzEDgFkYLbPuSws7ChBjFWbavET6Br4SZT9yvfh9Zj4CEAbH32O7BodrCUByTgARsnKWnDKIgO9//7WDZENuBiDmkapVGnzReEatcgysnp3anD1r/KHXEGPbePu9GDXAKG+53wJyAoUK8ioeG0CMpxgwUgeQtr9rk3W5CYBIHKM2jcFQoLAG+0rwUg1fXgVIkyPt+cVyToCsXu/gjtVNgZHFq5VXTC7aTa6DcvVxkMcfP5VrHAII3ITaZUPUrVdp3QQD5F7f7yZXJ1erQaJJ1YDRAMLcAAKuAIIGMZIKLHrVr6lBehdx5/61JMiUBnfwDhTgSgHy8PSLa6lqPtWWM4VlRFx4RvXvjgAZtctY29R5SV/eJsb7dwwgb5HDnGptpwcIAKRgcglgWo4XFDAwjqJByK8OlKsCiHANRjSpPNu2WtCPu/ciW3U4kg9144//6ONrgXWP3HtSZJI3pLEUAwoRIQGgJJwlJcJXNb2uBiCNaxwBCJrvdQfI6wEib2PknTcBklL6kiC5CoA8/vjFndtWU847gFjQT15ge+MTWzb4GDU4A5l/TbDkPSX+9Erlujp7nATdGwMInLTLd5LykkSEnPOX1CQXB4ili9QhrlHB/XgNB4hHOAAs28Q5OcCaLH6PB31GPYg/+nbH59sHGlm1hX3STiIiELMSdwVJTq5JvhIvuShAHn5ofGMACHNFiUR8o4xXB5CFDKT6ggBZk0X5o0lGhOzxkuwASV+IvF9s2h/RHBXr2+XNvl1EKgO1YvGMHn78/BIP6SIa5J8fP5lrRbE8KuMbwaRigptWy0kRmtyaBlmYYGeW48+3N1lHDUKUfNyJJTkSBX6SP3cE/sMB8o9zjuKJhkU1hiUdYvRWLcN7/v+yXqixcbVyibTP7DZfnNO/4MdjNnAEiQBEkh1TzshEuP+k40w+FCAP6q2KppRNkgDLq3px9ux5ynpIluUT2svU4LIGkJYfedl29KLnTdRNIpESgdA0CKkGySlpLtd/fzqQfFguVvRWrQHko02jt0pLqQdYU4gPR2Va3dJtVbOTygBx7cabRJPsM8qHAMS9VQyJcXBtnMO1RnxPMmPICmi20kbOJT7CJIxWRBiey2AQL8emt9K2DqBWeKO6hU6BDyC/VpbBjMwgSY7D49Mv/mx85OwAsYnaLBpu7lyuzaSKs4yItLHga27IlbdnkZj7ZGPb21xZFWQOhOhM6Kwq62HbZAqWEIjUyMhHAuVFyZRWd1WVkT8xKhIn1FqRQGDiT+l9PDtAYjZu81TpCMAQ47iCgP5BsZkYZcCiZRVXEHPLCTOgdxixXCdJ1wAInDR1oyb/7OplkdojSGn1rqiVkOiKH+Ir5awAeXj4EQY6tddbvY2eH2b1MJc0lxMAkkApQY0rIAF5ZcKFW5QKIEPmBXh4fOLv999uAPWnydkA8miTKlheVdQgbpVcP1TcrNJXcy6UUtRslDrGlJgIEEsnzzkhpQxkAiAeIFazxc69PeH+/mh60GcaeHUWgHSjABUcnowIKMGl4PqEu4VIj1+HV5QRG0GtFbVUlFpRSvF96QQMJOHrFjOghMoJOTMwzLPLnPXcxXwlF5HR5Fu6hYMTmwEi06gAEoMqA5BI+2dIRzkLQKrGNOLWe6yAhQ+K+vdXcWc5apBmWpVSMM/F31tsJ06EDQA2CCmlBIaNueB2LHAwuppKv0QYUO+dcDEKRJ0/BUjeHSAPj08c4xwe+5CO5QYbgQiv5IzN89wBxMxIU4gpAMTMqpRCXhOlYUTjbUutVZ+vJ6vcvLn1rgB5/PGLD2kOc4NuxTmu5S4yW0qIao3wauaVbfNcMFczt4JXDhJ5zkRIOavmsJRxRqqMmqQDSSmkqFzLTThBojVQ9Z5VMNzlB4DAeHz6yfffbhMk7waQxziuwxah6Uh5MK9IQ2/aEjvr6sK3sQUtCcxtDZGYBVBKwezbjHnW48qzTBIROCVkbTyJCnJJqLn2IyaVf3iaCrWBYdfoBnaz0OOgMUhqwVQxF6Q+t6sm3wUgj0+/msfKe9zoBj3NW3UtTaGP7DftYc6GUlSLzE2TOEB0/gjTIMwsnKoQSpLEzFQZ2UBHQmw5Xb9HT6SVc8EnmQGqACX3VFaNtN8qH3kzQHxStyHHSic7/BTCWI6HqLVirhXzXJsG4bHS0oPWSgfGvVRUnXIHAPIF6vaewrqR5dNY1rXC4hZNrTcDxKPkboKM5hU30wG4HjURpOsJdS7P0XMVhwOXUjGXuq5B9EpC1NVzVQmkn5dakWNHkhhJv1dDxD3mb12z9MaB56FoYqO0j8QvsySuSd4EkAefErR2AUGbZCHyjiE8IPa17lyqGZgppaVaNa3MTLRYR7E4yKwcRF89O1m7A6KWp0UJoJpQKqt5VlGoIqWCmgg1kd6P5MmQCS2QekmgHI+LNKdEh5bKqBAvXmUGuCLx9QN+lDcBhGsksI17mC+8LUijEkc4XdG9isCQfe74Uxw3X62BD5uRbot4pgRUTiDuCf76pqZIguRoJb3KDWgQoHUxESTuZKgVnADmBOaKx6cnvv92O6korwbIw49/r48pvz0tuhAJ2Ww16ANbAAjQrPBNDhIBAgAZSDfPRpoIf5P3Mi/wRYvzYnm1/60zQw5t45d8mpnrEe/9YszDXNXcOEenLcoSGH2u2YqZFrWImmnGW6IG8qEB5ga6NeGW4TxuVr/HG5rw4dUaxN24wcSSDnQ0qxrH8KSKM47pODZxXF84Mwfkryq7bPGOijkEBeNWSwSHcDDvFEgIKtcqGoRSB46aC0pJKKnoeG+0yaX1lQmwcflxHfVRPhpD3QI/hwoReKflaRHp7ChUQSA8/vjFtzCO/VUAeXy0QVArvebG9+iChBxYj1S7EyHUwXv3ERhzCb29ebZq910TaxQMBqcK5tQBj6hgTtSBwsaN+H3kZbbBTQm3LkiGVRtYbicG8CoT60bq9ipZ5lv1sY4x3nPaNdfjKOb2HY+70f7JpM2xJYC5hbm1XqVBlvblmvtvKc3Dfx3ifXPnrTJOIC7cUjQhscyyr3lXxhXq4h5IDa2OEkmuqJrpWmoFlQpQ0UmiRw2SUJNEn5lb4uMt6pHufmhEXfhJcuvj2sexvxggDzEhET5iIpDd4MntJkdu8pK7MeKOaLu5MLdPbSy1HQi+Ivlcv9DyrUIaSSmYZwGFvcrx1usbAYd5ryTBDB5ToQYcSStR8yoVUDHeoe5dnaQtp4qakiY3opF1tQ+tSofl47qg1aegA8Ga2P2oYJZ8s6p1olpxrbqSf//DQH0ZQB5//pvNw9I4x+kP4z26iT64d+Rc+9UDLSp6mWpljXGM4JBAYPHU9jJ4nFq2spXPU/c0ic+my6mVUKgCpUE1aTBNJnZIKCkhpQoi0ySxuuy/cSoONnwWHyjWUVRUkGtHuS/Xl+3Lv//FqDNeDJCqiL8WE2lN1JEm7xlA6KPIz7DPVwJ4JfKOuW2ae9Wff3q5agUIVUypSqgEFJIUFNvy4vqEhZfLkMFWp9sbaFX9xvUT012D8O8HAcdLAfL4pJ6rMc/qBT366aVUk4LNfu0+dDOOh551LEkrW+uxGbG3byMES2HXFpLCPoeU9shFGkHvtSmtFEDNzwrAPVkMlOp8jFSDJBBmSj65A1GFL2jDslSczJPLnqoD6uvT1EpzC5/GX+L9ebvjbL3BNy+nTKfVzE++Ji3CRbcZQDkNILY0WgxiNZduyLfyFtvqSXhBB8ctTYHs5g0AsWPES4B4OcL+2EB6V6yljxTRGKVgfp4xP4uJ9aybjxy0nKsulb8t7uM0xE0s6yNDIFJUCQrZvZGcLF9Ic06QJdFIAQCkJAAkXWukb38xrtRzPtbfjylQm89CeY7Vh9b84oPE+9l+Nx5r+8xyTUkckGOJli7yiwpXMM8CEJ5PA8haNNTI47k0iJlKvAAge8OPN97LGVisU4MRYPp5y5EqblI9z0VBUYJGKQKiUlxzxHm9Rk7a7ypYdAk5JInUVwCFAUIR8wkSA5lteiCdaK4ykJOMOmyr0MZfaMs4r72uaZDmHVvPbHhfDdKbtHaIzYGhA8auZjwMF6AWNbFOAMjjD11YU1MpLu12ME0GDABhHf03HOehxR4DyPpWPJu3zSfc95QnlR0VVIFo0lQi1EqYSwXNFURzaGAKQF20Ji7TDMTo+2GALDIX9DuXnB7AR+RWQOfPu4rsM35+0Ab+Ag3SzAhbl7yZQUt5n1suvb70MDU2dvM4qfay5EBZIhptqeioQcxNiqZ1mHX8RbE0dgOImFjP8yymlsU+ygxfsoFb2Tj8Tn/PVuoD6ChU4STm4Gwmk2gQWXk2ufu8VkbV5c+yuoJJv9SWdU4BLGsAaYCyewkATATSaentyTUe8o7wYQZTM93EjGNfA+ZqeAhz0yCnAmR1Ega9WFOZ5lthJ57AMu5wSvm816wGEBtbEpdo45X9YOePoOoA03KmfMHQUnwA1PNz4x1G1G0tEyuLK6UVDWJ2f4hCDmae5HxREYJRAFAhMIrmYBFYWQwz6/h1Ie/Fgokk3W4iARQRdwBJASBG9Nu+8hKwAosVJFpgetlzWwNSaxchCODvzQtHsL5LnjOQL25l1UbQeQbq8zZAbKy5JSXaQztUj9dmWnkDtkYRJ38I5Hb9VcFS1wFSETRI5FIAWCd9s+BfDAoKMZ9R5jYYrPEhfcBYrrKrnx6mZVwDv5BgWTGuQKTJP+a9Y9SaUHX9jRQBYiaXAkRoi05Gdwwg7t7iLgdMVv+ItVCm8g7axG4HM8PccGYhXM2IQyFFASQnerGqbnxG/sGMYN9rwmCpHSAqSzBPTA89XnpO0JtYzS3t+wgAqQ0gteoowUDQWzr7CBAcjeiv1hGt2VGtrm3b0ggVcyEwzwCS8w8+CpAUAJJ8DZLDAEltX6/jppj9Rr658Mo7SG1brUA9ApBu3UBtvEBnLXRCAMZRlceaUeMF7GZMmStK1ZhDN2NIAEY0sWr0KkXeUpW8a7mj5wkCkGJDaT1IOHu6Sa0SH2GohqLgsVqrmFspgWQfiuQ7j4JOcgCZ7xdQxtoI+nENkjxOkqhumFh2rHqATnK/CJl1gju9FldNeWlPVsCz8Sw3xa0ublYWeq1+XRqkgI9xkJ6gxzmf1N8dzJfuBpIfAbped0SPcgG2KXXEnfo8t3SPoi7WUptmcXPPxotrA6tG1g9ykPa5AaR2GktTSYqVxVJKGvcwYHSP0hqgU7LIzdhNnhEozAyqQDFnMMWZ77VuiaXR5wEg1tizxE2yN/6EHAEyLGlFmmKf0JIjUxbA1cTICbAR8QlVNQqjteu+Dmvml8dDAEkrIeskjMDJeiLCtdDAsrjSR4uZ6w0kJwBkA+ELVcLeWE4rTtQeLQ/q+fkZpRT8fn5GsUTBMBJvAYA6NPzw+fjqWkT347gOK0Nct51rdY3U13lFqPW3dvJSg7D/J4hCT7WCqc9yZ2akVJFzkilKOfIF9YCRpK0QJfGJqZYpWwBxkLVpUVPN4JyQzddqHQClLuodqvhGYedAULMXfAWeLPcaiInFx0ysj5J+/IV4j56fn/H7+RnPv2fM8zPmMDS1J91tVr8tYMgruWuRsAIQW84gOAk+oldrcYGR5ImnR0h47Qg10ABAlFAANZGoN7FwBCBTwsQMsE2mPfVuYcp4L6J+G1K77XUaRFXmKRbpJv+IXqXapvR8fn7G79/P+M/v3/j9+xnPz8+aD9VIu62vAQR/C8f+WYEQO3BNt3aAwPhJnK6Ilc/U8L2oQcivv6gdifnQbK3xDFoAzsFdq0z/U40vMSoTEomZk2pqJDsCxDZA3bZ94LBr2IwOZIkImZNyzKTVbHNzETEocVd9HIi+v17avZJn857XfkVZnIecQNLBI0js+TeTaqxPdO7o/e5MDmBobwYQtvmmNN3jWQHyn9/4z/Os6eYNIIEHB73fmzT+kf8e+W/aYUZT8S0A6YUDg1qdWJu442M0OZuPv69xvKHdx7BuRtydqk10vC4x6UwghIIq2gJ9nAMdQEjMohEgLBVg8AIgE2fXHCDNB6vVz2nmlfHL8IBPBgq3+xfQFZ9a47MXRAgzJBZyAgd5/PGLLabQGrF+eKI3g3C6B8u8ZDZ7uplav59n/P793Ai7aZDuhxopXJQheA1oBSDyPW6vQQutUIe+RosfDEhant32OkrTdmqV5L2akmjoCARA+AbQJppTTdIAkQDLAsYREytpzCRow5QSclYzUxflTEbQqZ13Frk6DXICSTcxi+zcwtz4iE2H47MXDgDpZEPny0fN77/mR1gDyKVs7orm9l3LrSJAIt/h1bxBROwaRc7XTsG0SOAflQk56diUYRzKxd2tF5UTOUiMTUQTizRR4Z0NUfcuOYhde4mL2WaPdy+WeqI6E8s6b981e1keuDec8LuS8RpMEDubsegsFV/hsJlUw75pqkV5Bg3Tv3gjjuajN/yuPoFER05gGmPUIOQfuxlG+ldrWOnKynMBgERr4nLyQg1iKs84S3y8wbRF98B4i8StGkGwh2wPU7wnZvNa9Lf9DqxcBlxvA62n9PIg9Khdw9JfJyPO3NUlmj7d+AoaGvSifuTchBZ40FR1IyFkHKdxpnhZ74jaD2pMxQAfauX3bAUgya4nqSRMVd81A4zUHnYuE477/R+f60onsioH27xewNyreuhSq1JpHgZYAcK8pUEQ8qCsISLck7URdMCRG9Y3UHsYMes06ai6nGRV2Kzvq8724XlYPjkCB3eslpBbA+l+j2IpVoo7PPCWgtm+v9kmzINlps+KBmlL5WCpQV4oHWANm0G7u4eLw30ILT16wcztG/O1yM+Nx15Z2GN1QejwLqVFuA4a4QVxkHMXOVk6RTKAZExTxlQmzb+yhtBKUtbmpTq1V/uiQoAuA5eObOi2ryOnchD0iI4xB/vMTKrDXfIoQ4/O3PdiiZBywpQz5iljmjPupgyuUygPgFKkLFx1nAE38Ay9j6V2d2U7gHYKffyheyKpI+1yEY+DRbVyANECW/F1dfpF9smmEEIj2maZoB1ramSoUzAvY3Ji64hMW9sWsnv92bTxJucSK761tYuYWdZ+TouDcAeGCBC30xmg4emvD/LUT8fDps4Tea+Wc0aeMu7KhHJXNC+Gu2fvzYkl0EcgoBrFXtajlVcbYLiAN0A910l7x69arZlbE/Z2G8g/owFggSD90oAXxCMxxmMAoHjKmnNCz15CuweHZPo203XKer99a0Axs6sLNkaud6Kwnb42HY5MQCztiLHa3j5WrARmYm16seSfe4yiBtGB9iNxfqmYSZyIdHUleWBTzqjThLuYmMipJf0FgJp2qKjwQM0CiXxwt38Q5CA69LW4XCVRzylO0iCLO9CRlIMQH7+1vFR0arTxJc4vTFsoGJbgEIDkbCvxmuZYOjnOJhEkuMCSba49mia5ilwsoLeLpymh1knzrmrnDiKP7NqNDMmLMGcCbzTKzy/m/FjjGpNqjmmahONNGdN0mId8TVEtspmLpRrEtEfPQTgo9Lex4ujJSomQcwLXjGmCpD+YqcfNmLOgZSxXKdDobwVZOvXISQbb3/K5Wnq26YNwYtAAowHZTCz7vHfbjiJjwDlowv4HxlQuJyydVyx0Fp07Vt5bz2/vUyLhGKY1pglTbuAQzTF1JlbL7xpMrA8S0yAfL9Ze2Nv+Jgfp9F20q+NZo1mwOBA+OtBwWo8nZgDn3PGJyHsQzCp/R9J4C8kUOrVGDcINBPZdj2v0SY8OmGDyxLiK3ZMl57DOo9H81XoqOBqA+g5m8BILHEO2chhm0l0vhXsYuYOYrGZaJUxTxt00Ycr6qgCZpuxu9WZekXPEN8uJrf06lH7sVLcA8oGlJbIAFvUAYU9jk6ZnwA6N0LgqAUCxnrT6IKou5Z2Xv/sSDeIU9cDHizjHIC/XIH2RFxwXwUvV8Y02ECrn3Fzmut2F9x1BHzXIanTwlfKxSugdRO721XAQQMczsAzinwggmHvXPJmqykhzlUYTigjzPPuhou7gryKJsOAbOY+co38VDSKjEuN337A636eSowD5COBHGzelhAyZiibmEUnqteGawdw0SOf9YUBmpGAZz+0cCl0X3HlwOwtqOGmVdIwnvLLeb7h8F9UndDGOrFxuMo/VNKnWmHB3JxrETSvVHqTmLQUNcnu9/vvLNkDUD9v7wk3tKmFdBApfRtp9vIK6KcXdm5GYUeTJA1DtomWydIoUi6RlEhOymVXsZQ/xAxMzlVryU+/KHFrsGkc4bdjYuixNtAEwkf4A679m4CA0d66aVtOUkacJd3eTgmRy7jFpvCnn7BNmS4wkjEjEO3AQ2oiM+XOL8janz9uEwiZyGCAfWUZqjz2l1Bb4iz54asv1yEpFRrrhN5oAdDGboD2Y6/rziPJiDfI2OVmDUP+lmCvVgoCRlAsAptxzjsY9pk7DiPYZucdXFwHKVXEQE9cW2tCzRZORPTlRZvFs7jjovFg+hzAYrJOucdAUa2T9VuVgrGNKgWdMA+8QThLP7wBy6UpdmVyHBok/G/kI0DLliJDVZYvaUtwZaEsmI8Zs4nu5ZmWbPDoQ/heohIWJtiz80i6KHy/cvOG669/o+RXQ9fKmOSLnEPMpBgEDODxanl3bpIFzkHoPj1X188uJGoTDBvQuyHNgqFPvREgyDlV/LcvDmwBOZlJZQQNAtMQSWQcYBYDMQVWhA1tCivyL0n4iJxix4O62xmmiiXQoTjJeooVhuPmx7d6EGMeYPpINCMo5prvJ4x7COQRESc2wmOK+Bur3er6E9VSs8foUXi+mycw5odtVmlgmwhkICQlMMl4bKYMngIuZWHIuQxh0zOxl9GNFSBElsyRqYz2qFnrZBNOoQQYFdShOcqoGGcdqZCfkLYdtzbTKeUKeTHNkTVqkXnucVJ6vIg0hVw2QKASLk0DiJHos0hCwzecb5vKtplES5tkAZDMxXq4+r5WEZc7U5LxjWt1ylnO6OMdOxE+SdwfIOZx0PtEALE4CIZX2g+525jAjvAGk+uRw7MfbyDlJbDSvV28hnV0O3SjXOE19tLyonpxbBLxl6fZR82lqfIMWnOMDQBKp3gvlMjMsBvuKNjVITHNe9ziutaOR8r60hjFfa8FHQGCqMts5M8okeqSlnYgGmarMr1pKRckZUy2+xgalJGnxZEGNwSrqKrWsYR+47++KW1TrFGTdrxuFsEx9MS+ELovQyHlqIEmaTqL5VkLSG/9wgCSJmBvIDlbsHBKJbDw0xM0o/H24UAOGvE8nRNLj+cDRFv+eGmQVLDqxmRco231n1DqhTBVTKahGXJOtPZ68YVWfO6rBmbn/vdPL+IYKjjeKh9eFBmnadOHN6ki7DYZqniqfljQtn87XnuYnCvXbtga5XrHZzQFpoIn5+BhrstVjP0d+lkTONXpOR+ru+VW7nCaiPTY1SPOcNK+JH7iQxKGfth/HVycfujv0sN77Rru+mUUtkDi6bvue9VDVT++Atw3VxeXX0naiRm+VChyFVrUM9B5EW/ISemM0v7syhOd6mXZm2iP5vd3kIP5qBeYBOEMUazG+AuZOfccqBFeqR4CZhwYRXKKxPh034Ob9QvSGHQbFWgyw5y+9X/d4On3jeP2Ptmuvo8/ub1gTMjSu9Q16z+TrawHLc4gMS2YNhAzubW1DXTpfoAEfLpFPUAYob2uQ8SbbB5u5Oh/RLZnzQGMZfWmMU8QZWeDxkbZ/4JyN8i/BIYCIoApxvSWlGLMdj9wsG/PeUmT4QL3GSTW6q3Tvog67Bg0Sd2Jbu//25yVYuoIj+fY1DFPGx00wvMuNS+q2DQ2yVNNA4yQHZSMX6Zxi1sg4l9fpm5pd6PtcHru8wQ08Dtld+nG3RiiuyGDTrZY1zJccZ983TeLZBNcgK+7dVRk0yEXEtYeYV0gbJpYVuJ8bydbjHogsR89ksG0DXzinxEZszyM2oMq1b0gt9I4Gi3Yh5gCRgU+3iRPiLx4uF3WA8Av4N2PiCQMdLyCiri4ODoLMa6YdQkUPjr5e+iudkX9e+MThBvZrjpPB72AszA6li5lXxuUaQJimDQ0SwJFIFrivWNcgfaf6sRrEmtqil0VdHjNNUZfH9SrL6x/gyMEZ9H4SvGtybXZvk4Mj9eVuq/syuAMKzo2Dk+SUcki1r2AsinGPJNqDOL+Mg9wKYWFb5tpyssb1L95yceUx1eep6wl6V453bKBGo7jWg/WqO896BwkcJG1okPu//6T/969H9rHOwR53t2XwnFwQ94jmxKgZbABVv1LWAQ3CfNwCGayruFbV+NWDXtqFxG/2JphpkMZHmjaxei3rc1rP/RGy8OSpNIuvz1C+7GjG1EysNIHqkZkVpcAJFJb1Gj+XOaj0Ieqz7SjquSsc5uBh3wwcLaNXeEhb753DQjydcID7ooFxfxrIXbF2MJL2RtDNwcFgXz+lJ/ORv3dOYGZfZ9waf9WEy2QaUVfmjabjQKusOOeV4TeZu8N+Ei2YB3V7FxMikJJz1AlMJwFkiMZ2jWRsXN3LB1d4XYOs8Y2DHCSS6VN/dXAQnFbOcb/3BCxNtabhKguRryM4mBv4GR1IPlLWarcm5AHBXoNciqBrqTqSTlsk3SQlILGwD+Z6G2Mo2DgIVm118Bt5yAWkVmEhBNXoWKvbrdXq2qTnH8Dm1KM6z2vtNUiioPrHL0QvJn2cBjFbv3GMOvSoK9xksNnXrrlZfmrW3WgahVMOlvfwtUczLrp5ZZ4v0m2NS1ndGxH5OOncuWjPZXXin6g5cA38Ay0OkjLAGaAjAPGBOSzg4JpQyXzs0kBskL8d7ddJb3bla4n81vecBKs3KYIkLvxZdXyIrOAaYiJYgqMj2dQs4xb7Ic9IcNekJ0LhQI2pe/Heg7uDB2qIHgCVQSTr2nberA4oHhkZagS/3vtJuIe+LF9PQgwkwknhphU0T4/89R2L9Rpx82oCkphKmwC5//Yn/fP4k5MuL1zNRGNZ+P4UDfIRfVivQdCI+aorVAk67PmtaBAa3xM8w95iQwkA94OPVntApn4GFraGsjyX2Yj8soYxCHjIE7fJu7hLkzyLjJBkYNEA4sQTa9tFhcgJOqgC6YQht5GDAAUo1+tqr1jnHKsbzF2K01QbAXFBmZxJ+QAdAUij3R7UA9ZN1EP1qlU9hrXLYjhUt1tIPCOMWU+XF7r7Tjz/fxb+IbPfHAXI/be/6J8fP8V5ywmcZG4pU4t66c6n1/Ug7Ywzirk2W+9aq6ypXmqRobel6L6aW6HMVnQK/7t0CBrHnSTk3JY0o9TsaC0N7J64VwnLmAxZT683S0sT6tXUcTOLBlNqhWfF+EitjJQY72tWHZKDPisAcT1K6FSnEmOjdA0eLCvqBFABEgN8wpBbADpMk8CsfIQgvnlq4xuianU3fySceGVMROwO7zXjJch+dSSz1psWBUctDhhzjXb9d8wZMxtZ69GAQd30OjbFp4xzJx2xSF4OEHQ1rxiPaWWQ2VaaV9C/M/ISknvg/AcBHDVJXaxOW2YXC9Ckqhyq/oY26R0MWzHdjOzEzFRLX4oLiQ7zAV9cKIPSHVAJwInLQN//9Sc9Pv1k1pys6Ld2dsVGSntQ+O/i9UT9uARiXps3J5odXcMcHuBIOZw4aqBUwCFj3O/uwsyFNs9UaqvDAvDG6CAoqs1KRVLQVqoynZ3OGVy1V1ksvtPxXWuQAo660CDrXjtx//JZllTrrYUVDTJwNNfGrpXlHt/fX2IGk6XQf/0P8X/+xeKu3crmHeT+21/08OMnCwm+5nHd6qna4B+sPTIhbSKWaLl24jRN+ONuwjTd+RQ7SVdn6gFi0e2K2QDyPOOZCEQF89ycCvzS4JL1NJoP1vLOsLrl/Np7+b7S1i8Z5xO+dMl6of/6X+Lf//CLF/GMPUAdNYiZAAfUROthzpVS0Ny2zTu1snkvLB4jZx7unbL0mrYknE+no0sJ3N3d4e6PP3CX2yI0NmuKXZyZUSqDa0EuFXMpmIlAM+G53ZBmlghLAVc1o7RW7nnyorY6NrI//HVmVdyH1/V97njbfH/htbLmEUyroD1SInz/+9tVaI8o9Mf/EPDCiePuv/1JDz9+cmULIJrbTu13f4itvtZYzUXqxwEZ+3DywxpiCv5+7fu8PFV/X8ZA6xh2EBD4g4HDGntc1+/ubsLdH3f4448/8F9/KEB0QUxfhCYAxAl5KZhKwfNckHXKT7PHLW5SahHCXkniTO7hMrpPYI2SmyOhd5C0e83eYkdwsHYKCx/2K6Sz+9AAHZwe7sRpDgznH8NsM9csL572p0tedJ92u/GH/BjW251TXJmNQShqnihO1kCTfzZOjxN5x92UVWtM+OOPu267m+50ak+b8zYCRIl5mTGXjJRmHV8jJbWxNjMVpJJ8BsjKYjN5zETvWR3dIAbw6PcN95q5mXpteyfN0RyW7bf0QMMMh2cA91RFzZES4f7vK/BcbciLAXL/7b/pnx8/WOIj6g2rIz2/rPTep7A1G6ObgtNMKVnEMqO5ctcA8oe/CkCaibUOEEIq7MCTjqTN8phSQSklRMQruFicpnamUgSIzxJ5Ld6fIyKxjv55fP/7Ooj5lrxq4rg++qkaJRFSlfBUH7FdiwwroLpYylskqvG4nFhbHoCrpqJr0C0uHpN8BsI2G2NSd64A5E7W9rtTzXGn23TXljGzewHr+XVgU8pIqTbzTc+bpow8Z8xzQZnnwdNW1ftU3FSTWEYNPKK5R/t5wHC2oJNrjpE/jRqEevPZy5ba69oMj9corwLI92/f6F+PT5xqRSax46kSCgFJ4xJtQZvQyRl5NmDw4bSLJs0z1I+1kOs5MyHtoYjC9JtCrGutIOhaI3qdnDJSlsYalxDIedL3U1vCTNfZME1yd3cXZk6PsZBI0pOnu6TMSHNCouKALaXgbp7wPM8oRcrowcwinjgHTKlC+Lmg1mYsZV3rI06c13dex57kcbNLuGLvZBmdu40rsZ/fnp6atGZiKQe5iqDgCfLqqUfjWHVWO5hJErIBd7jgkAZhuci7dHaxUfhkzlkI9N1UwMwyJ6+6U71BZdE0suAlyXemSbVHi3XIIpjx/eQaJuUEShnJYkNogTIHSGXRSkkDjFOWRl9m3M2Tm1izxkjmUoSPlJgFwKg1dXEc03hTVhPRotNq+L9XrlOkFfF5Rg2C8No/nOj9jGbmbcirAZISwCkFtyrAmr9yiWEJNNi3vjZ4KQAzSiKPWsdzbOkAW2jGliprr7JSrK8Mq9cVL5cAxCLUI0ASMWoKmiRVlJKQSxENUSYxsTqAzAKQ0gAjACmoM2HuAKLacm0u3jMn97xKkrSb+7/++woLty6vBsj9X3/Rw+OTRNfVM1TZuICq29jjCOmA2EX9Gktvu1vRvg0NXrVHrRWJgFKFh0BNMCPhbk7dJUzZTKcsgcApY5rM3AoawAh+Il/8EugBIq9iiwt/kLSQkitqlcVIa6koU8FcCrhWPJcioCkzSqmY5hlzqZjnGaVmlDQjFckSAItnKKe2nHO35mDIcXqt9jjgxO0NrAOd4ThS0EzQW9IewBsX0Pl+/43+eXhyzeoeLapqt/Z8wY8490DgK0uHjJhh22WID8HypWzhmLu7CQxGSqTEF07KRYPkjoxPUwDI3aRmVmq2vhPj5DEMsvUTtZwJwVJnRuJokjAys+eCVdUOk3KNXArmecZUkkTfc0aeZ+ScRJtQEoApQACpry3v3HESd6CEiMmJDbRzsMQD0b8Le3Y9QqSD5A4YDo50JQmJL5A3L3+QUptCObG8l7EHSr6Zhh4I7b1zxODff7EM/MNzpibJQSIg58Y/ogerX5VpbemyjLu7frnklAbjxdxGGpUXgMh7CnEMrzfb8FlGTRU5JyfjuYgGLCUhzRUlFfntMiPNSQBSeoCklCQ/zFexzS2JkqjjAC+VhocNDeJPod0Le/Yxan4V4z1eIW8GyP3fkqMFqAaB3thSPnREQr9O+NRyrhK5jQ8cA0hoaAqQaWoeIgfjaglibFvfrzSKluIC1WwJpACxAGcigCAewpSAVDReksoAELmGlVfKftl1QZKllKzmXH1BgADAdwVJVpXLTGCWwFwlauYWj73QEF50m2vd5DokUYNMOaNO4jkgkDSsWrwnF7OoBQZzasS7kXUBiq8BmFrU3TXDK+4TkfXKUrFaCZaVUILNLh6ximru41SRKKEk8X41gDAo2WpSaibmtuxaNHPWIu4HpTOhoCaxudi5s7Sam134ZwrPIndAIdz/dVvmFfCOi3h+//svenj8yZ4sV1tCozSMwdTw/+GeeSNm34098NqgH/JnL+S75gmTxkeICLlMKFxCBMui7Br9ztSvNe7E3aLq5L2wAaT9b2Xu69UXkPpdl5QAZh3DbPUAQDSBqKKQBBhLZuRkY1skRhIBkjUtZnIuMgI7weKHW2aOxax46MYUFi0YGCtL7boCELmnESA5X3/O1SF51yXYvt//Rf96+MGW7ZtI1jcX0t7Pch6J4FKCBhkwtCaRpE85a9xDNUWpqJwX57fGb1vzAkXO0TWoLbfNK4WIdH1ORUhSt7Hmi9VKSFVSVXKR6HocXegmo61LmEIK/mj7n0LQOVSR0YHCR21a2fW/33+Qu54dGOr1uzVybvLuaxRazpP0jh83j5a0LYnLePScCJwlVWNxLrVFLZN7Wi67nl/73aZJa5KBV6lWqUtNQWkZQADPCAi5ZB8ZD0lYJn3adqvgAM4AEE9rNtWeWOf1XZpKZt9uXA3Bqtn4TTUdkqSbIBDxOAakXRWS6Aed+yv66ynEEQbzr7vKQbJ+WMTKG5ZhQ+9lamn3BE7cx1EYwbwCLKbk3CUREuWQcgIn/uDDtzECbtQg3efusm4pQpYD14bRUshQSFefrXtM3h0g99/+pIfHJ06JwLWlo6QQyY7S4UPzpLp2OZL2zjwzseAkAYndSySNah2A0exwTy0CMMy2PlTRU4n6eN5K7CCWx7SgNdYUEhSlLrkzT8296jzAwaZTEynMeaUi8bpya1k7sqVbfrzx/rukoy4NJPl2UtlPkbMsAx3HXlhsxD033AfSEF5PuPLmb4KAVEkXpzc5cu1gl0tnu2JenXkci/x2Xw6bT+ulP20ag9BVrbtzPeCiRu9VxnieX4faXIl9HlwIDN6gS3dNzgKQ+7//on8ef7JHkv0T1kgZjx3S+0kCUtf3nwiQAz37xcS9Qy/jQ4e17LaYcuda/dbFmTGHojnn+4y8I8pZAAJohJ0TsrluCQBYRsuRxJs9X4vZp/gfhbEyqRh1L+2w2doUTqQVvRMbEDUgxeZwKagcizb3Hzc0RM+SL6vcrCUAZq6uaxCPd3C7mCexq+kbzarINVPQGikRvn8ScABnBMj9tz/p8emXuWNAlaBrJAW3YR8jOUTarXdLdi01qHkBlPAgEVvJIGugUbOhxWKuQ44CBsM649wmDjIus6xNY+FC/AeADGfBrkAkU7BSGGi2oj0+k5wNIEAAicZCAMhT09F2sVcCFDR2zoq0Xj++DHEKCjvcrn2KDB3uTcgp5W0zuZgGCZojACTGOfxemPPDnBhGyldNq9uMlm/J2eF+/+1POmyrvsxVemuN95Zl9V6nbd5xC2PMXypn1SAm302TKN+w3B5iHcNB3Eji2INF4cGZz4MJorkSMWI/yi1mlAKt6hy5Ei3NoNWGHYb8cdQgZmLpKV34I3C5OCKwZR408yp/QtPK5EMAAqi59eMX2ywdGYaVigpNbLSTfYRVLzy8GXO8yL+7LRyBduVqaY0TeKrnQMLMRKXhu/49bufYvgtBx5IrzNRV1Y3piLlVKaaVEO6/3c4owZfIhwEEkJVzHx5/stm5WZ8WAZ6O3h7gGpOOxHNJMRxXpxnmNy8xgbA7HjSGnRn3W2CwSeSCfswzElq+VzSpckr4nyuZU/dc8qEAASSh8Z+HJ05wa6sJj1NmrrdjUwA6gtZxRNCDwQSxSR+/iqylvrH5R4ZtTWKKzQIgn9xjtSb0MetGLOVfD09ss57H1Z/a+oLRRm45QkyQOZesAqvp5AEgoA4globRn39b0kzNMY1Fxt94r1OD9wpR47TxON65jHEOtIFPOWgQnyQip0/nsVqTiwEEAP55+Mk+OVptYx2qcZMK1yhVmWQFAmPlBen2nCzdsXQI+wwDYEa5ZhIfgRH3O7ctkasMeemnXfJvqn1KCOPHAxk37pGDBsm5DRP4CuAALgwQAHj48ZNrCesJoq0jWGtclQkCkBDM8lGCZlATOkAsAdK/+neD3AJAFjlUHUCgtucSIOOTbqMXDRhhxkkdT5JTGwAlUfLPzTlG+XAOMor5zh8enrgmXdMCDFmBxOyqCpTDmVLVXaDwLKzekPpCotO/viQfS4Ympw4gpjns9fv99S1R8BFycYCYfP/+jR5//GTpzVi1AUOeOAGJULn6/L+dLc3BdFDxd26TvzxOblm1l0Xa6KJqh1paPPs+d8lW/XmWq4agNdyNSy22EYcb53T7YzreIlcDEECygAHgn8cnY5nhUwY4wVYfZQY4JZ3aJwRGooT4AGmITQ4cON9OHg7QBq6WHx3KezpRNr7OwIH5xsJbj2W0owZ09190Keq9lyqHocef3YV7ilycgxySh8cnLmHi5rgQpq3eyuFVpBERbQdY6/43OcjCw7VN6tvvtisc/uwUuAzfH59PAIjxsi7aMXi2DFSuQdDct1FrWABw0tfvOzgAXJkGifL9/hv98/jEsUF4pq3HSeIrEG2KrYZYw9DG9wFI+/ZSXgqQRdRv8XFnPh4pjaWmSz3WAbLIqdrB4XK1GsTk4fEnizeruOYwTeLrAFqWqppfPr4EbQip9a7ycrjOlrkq7+FxgcPnj3vjyX3o7tjdXhSti/kMn3f8KsSIbMRfFwfqXbl5RYOknPC/91+Xb6zJ1WoQk+/3f9Hj07+ZKiRfqyhAiFBZxp/bwjIeTAyBMIubRBeptam15aDFJOF2AGlolFh8p5dFC9/89JjCiCc4F/JRkMaqrLaqJSiAI4WJFSiFyRWa10pmcMw6z/AuUa5eg0R5fPrFzj1K5CItuAiWyaFlCTPWBWeqRJF9DfWgSVoHrMmOrf2JZTKkU4wA6RIrVxoYvRQg8Xp6QvApiGZoptJ63EcuYXODkb3aEhEdQAQw939/zmTDt8rVa5AocZzzw+MTN4AAVSdPrNym+ZHGJtqlHOgHmufn0IfRRKLFqWOrWrSyFYdTp5Bq/3lMxjyQr7mQCE9z2Y4AEZNKEw4DQD5rFu57yU1pkFFEo+h6fgVgFp7ClVEsRUXX07AcL/OCsZliIa7QaRJ7PYKAPvJ+3G28cB+sapCxPKYxoOZTcs1hEXAri0fGdWisRMVlHREZJpuRd2CcLDcNEJPHp58sAKkdiRewyGupA0A0z6vGlGG1sbYAMhpA3mr9O4fdtKrXIqvoEi9deQwWm+/G4B6gC5bC572Nk8UlB4hwi6ya4zOO+junfAqAmDz+UI/XAYBE71dMhOw4edd8+/3lHlYAMsjCxOp1yGoQMgDEPGmAmEwW5EtAR7rltDjTSNMgt7Zw5jXJpwIIADz++MURIIgBRmwDBEDn8TodIO1TGof5vwEgZAFP9S65V2oDIG3rAbKD43Xy6QBi8vjjJxsfqdw2NoBwBIgFGOWfA2TYBwYSDayojBWbDIcP0WCziWe5cY7opepS0tEAsvo5AbRrjTfLpwWIyeOTjIO3NHlzE7MFFOPct2jHZV/8VmO6eAeohQo41h6Hias5BCIHQCBwCmAg4TgMkB0U7yefHiBRDCz9vFDjPsI+QZLvW2DOzmuvRwCyoWEY6JYnaKbRuL8EiOwnT/Dc5TzypQCyJgYaAKpNSAKOQO8KxgiMtwNE9poGiUsxAKohBoDs2uFj5csDZE1sUdLqI/LkHplLuAGI9fP47QEAGwDx9TWS7SflDjsgrkV2gGzI49O/N02yynx8Qc+FQmlu4UioASHV37/w4KRrlB0gJ8jjz3+L78oAUnsTq93CZdteptOH/+Z1UoTs0e3rkx0gbxCbvX7rFo4A2U2m25IdILvssiGff2q8XXZ5g+wA2WWXDdkBsssuG7IDZJddNuT/ANMBceLmTtEZAAAAAElFTkSuQmCC",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Silver"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Potentially investment ready"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-here",
                                    children: "You are here"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier locked",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Gold"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Sophisticated"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-lock",
                                    children: "\uD83D\uDD12"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cert-footer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-count",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-count-num",
                                    children: "3"
                                }),
                                "open items flagged by Ardent Capital's diligence"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "cert-callout",
                            children: "Cap table, churn rate and carrier concentration"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "cert-note",
                    children: "Resolve the cap table, churn and concentration findings flagged by Ardent Capital's diligence to reach Gold \u2014 with nothing left outstanding for the Investment Committee."
                })
            ]
        }),
        match: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "im-tabs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "im-tab",
                            children: "Bronze \xb7 3"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "im-tab active",
                            children: "Silver \xb7 8"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "im-tab",
                            children: "Gold \xb7 17"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "im-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-avatar",
                                    style: {
                                        background: '#3b5bfd'
                                    },
                                    children: "FL"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "im-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-name",
                                            children: "Freya Lindqvist"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-firm",
                                            children: "Nordwind Capital \xb7 B2B SaaS \xb7 Seed-A"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "im-match",
                                    children: "96%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-bottom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-status active",
                                    children: "Active \xb7 invested 2mo ago"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-connect",
                                    children: "1-Click Connect"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "im-links",
                            children: "Investment criteria \xb7 About the firm \xb7 About Freya"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "im-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-avatar",
                                    style: {
                                        background: '#1fa971'
                                    },
                                    children: "MD"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "im-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-name",
                                            children: "Marcus Delaney"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "im-firm",
                                            children: "Harborline Ventures \xb7 Fintech \xb7 Series A"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "im-match",
                                    children: "94%"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "im-bottom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-status active",
                                    children: "Active \xb7 invested 4mo ago"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "im-connect",
                                    children: "1-Click Connect"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "im-links",
                            children: "Investment criteria \xb7 About the firm \xb7 About Marcus"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginTop: '10px',
                        fontSize: '9.5px',
                        color: 'var(--muted)'
                    },
                    children: "Matched from the same profile Ardent Capital reviewed \u2014 one-click connect to participating investors."
                })
            ]
        }),
        diligence: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "diligence-block",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dblock-head",
                        children: "Partner VC diligence access"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        className: "access-mini2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: "Reviewer"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: "Access"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: "Tools"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                        children: "Status"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "am-name",
                                                children: "Ardent Capital"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "am-sub",
                                                children: "9 queries so far"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: "Full pack"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: "External MCP link"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "status-pill mcp",
                                            children: "AI connected"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "am-name",
                                                children: "Investment Committee"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "am-sub",
                                                children: "Not yet opened"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: "Summary only"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: "Internal tools only"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "status-pill pending",
                                            children: "Pending"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "dblock-note",
                        children: "Your partner VC sees the same evidence-backed pack throughout \u2014 no chasing the same questions over email, and a clean record for their Investment Committee."
                    })
                ]
            })
        }),
        webform: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "vw-label",
                    children: "Partner website application"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mini-widget",
                    style: {
                        padding: '0',
                        overflow: 'hidden'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                background: '#eef0f6',
                                padding: '6px 10px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                borderBottom: '1px solid var(--border)'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        width: '7px',
                                        height: '7px',
                                        borderRadius: '50%',
                                        background: '#ff5f57',
                                        display: 'inline-block'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        width: '7px',
                                        height: '7px',
                                        borderRadius: '50%',
                                        background: '#febc2e',
                                        display: 'inline-block'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        width: '7px',
                                        height: '7px',
                                        borderRadius: '50%',
                                        background: '#28c840',
                                        display: 'inline-block'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        background: '#fff',
                                        borderRadius: '5px',
                                        padding: '2px 8px',
                                        fontSize: '9px',
                                        color: '#7d81a0',
                                        marginLeft: '6px'
                                    },
                                    children: "partnervc.com/refer-a-company"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                padding: '12px 14px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '10.5px',
                                        fontWeight: '800',
                                        color: 'var(--navy)'
                                    },
                                    children: "Refer a portfolio company"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '5px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '9px',
                                                color: 'var(--muted)',
                                                fontWeight: '700'
                                            },
                                            children: "Company name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                border: '1px solid var(--border)',
                                                borderRadius: '6px',
                                                padding: '5px 8px',
                                                fontSize: '10px',
                                                color: 'var(--navy)',
                                                background: '#fbfbfd'
                                            },
                                            children: "Kestrel Logistics"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '5px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                fontSize: '9px',
                                                color: 'var(--muted)',
                                                fontWeight: '700'
                                            },
                                            children: "Introducing partner"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                border: '1px solid var(--border)',
                                                borderRadius: '6px',
                                                padding: '5px 8px',
                                                fontSize: '10px',
                                                color: 'var(--navy)',
                                                background: '#fbfbfd'
                                            },
                                            children: "Ardent Capital"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        marginTop: '2px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '9.5px',
                                                fontWeight: '800',
                                                color: '#fff',
                                                background: 'var(--blue)',
                                                borderRadius: '14px',
                                                padding: '5px 12px',
                                                flex: 'none'
                                            },
                                            children: "Submit application \u2192"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '9px',
                                                fontWeight: '700',
                                                color: 'var(--muted)'
                                            },
                                            children: "Sent straight to"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '9px',
                                                fontWeight: '800',
                                                color: 'var(--blue-deep)',
                                                background: 'var(--blue-pale)',
                                                padding: '3px 10px',
                                                borderRadius: '12px'
                                            },
                                            children: "Diligentsia Triage"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        marginTop: '10px',
                        display: 'flex',
                        gap: '6px',
                        flexWrap: 'wrap'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: '9px',
                                fontWeight: '700',
                                color: 'var(--blue-deep)',
                                background: 'var(--blue-pale)',
                                padding: '3px 9px',
                                borderRadius: '10px'
                            },
                            children: "Sector: Logistics SaaS"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontSize: '9px',
                                fontWeight: '700',
                                color: 'var(--blue-deep)',
                                background: 'var(--blue-pale)',
                                padding: '3px 9px',
                                borderRadius: '10px'
                            },
                            children: "Stage: Post-Revenue Early Stage"
                        })
                    ]
                })
            ]
        }),
        readiness: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "vw-label",
                    children: "Investment Readiness Checklist"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mini-widget",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '9px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '5px',
                                            background: 'var(--green)',
                                            color: '#fff',
                                            fontSize: '10px',
                                            fontWeight: '800',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flex: 'none'
                                        },
                                        children: "\u2713"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '10.5px',
                                            color: 'var(--navy)',
                                            fontWeight: '700'
                                        },
                                        children: "Last 12 months' management accounts ready"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '9px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '5px',
                                            background: 'var(--green)',
                                            color: '#fff',
                                            fontSize: '10px',
                                            fontWeight: '800',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flex: 'none'
                                        },
                                        children: "\u2713"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '10.5px',
                                            color: 'var(--navy)',
                                            fontWeight: '700'
                                        },
                                        children: "Founders' service agreements signed"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '9px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '5px',
                                            background: 'var(--green)',
                                            color: '#fff',
                                            fontSize: '10px',
                                            fontWeight: '800',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flex: 'none'
                                        },
                                        children: "\u2713"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '10.5px',
                                            color: 'var(--navy)',
                                            fontWeight: '700'
                                        },
                                        children: "Board minutes for the last 2 quarters"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '9px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '5px',
                                            border: '1.5px solid #f3c2c2',
                                            background: '#fdeaea',
                                            flex: 'none'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '10.5px',
                                            color: 'var(--navy)',
                                            fontWeight: '700'
                                        },
                                        children: "Cap table (fully diluted) \u2014 outstanding, flagged for the IC"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '9px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '5px',
                                            border: '1.5px solid var(--border)',
                                            flex: 'none'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '10.5px',
                                            color: 'var(--muted)',
                                            fontWeight: '700'
                                        },
                                        children: "IP assignment confirmed for all contributors"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '9px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '5px',
                                            border: '1.5px solid var(--border)',
                                            flex: 'none'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            fontSize: '10.5px',
                                            color: 'var(--muted)',
                                            fontWeight: '700'
                                        },
                                        children: "12-month cash-flow forecast prepared"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginTop: '10px',
                        fontSize: '9.5px',
                        color: 'var(--muted)'
                    },
                    children: "3 of 6 complete \xb7 shared with Ardent Capital automatically"
                })
            ]
        }),
        memo: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "vw-label",
                    children: "Investment Committee Memo"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mini-widget",
                    style: {
                        padding: '14px 16px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '10px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        fontSize: '11px',
                                        fontWeight: '800',
                                        color: 'var(--navy)'
                                    },
                                    children: "Kestrel Logistics \u2014 IC Memo"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    style: {
                                        fontSize: '8.5px',
                                        fontWeight: '800',
                                        color: 'var(--blue-deep)',
                                        background: 'var(--blue-pale)',
                                        padding: '2px 8px',
                                        borderRadius: '9px',
                                        flex: 'none'
                                    },
                                    children: "Auto-compiled"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '7px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                width: '16px',
                                                height: '16px',
                                                borderRadius: '5px',
                                                background: 'var(--green)',
                                                color: '#fff',
                                                fontSize: '10px',
                                                fontWeight: '800',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flex: 'none'
                                            },
                                            children: "\u2713"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '10px',
                                                color: 'var(--navy)',
                                                fontWeight: '700'
                                            },
                                            children: "Triage summary \u2014 fit against mandate"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                width: '16px',
                                                height: '16px',
                                                borderRadius: '5px',
                                                background: 'var(--green)',
                                                color: '#fff',
                                                fontSize: '10px',
                                                fontWeight: '800',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flex: 'none'
                                            },
                                            children: "\u2713"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '10px',
                                                color: 'var(--navy)',
                                                fontWeight: '700'
                                            },
                                            children: "Investment Readiness Checklist \u2014 3 of 6 complete"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                width: '16px',
                                                height: '16px',
                                                borderRadius: '5px',
                                                background: 'var(--green)',
                                                color: '#fff',
                                                fontSize: '10px',
                                                fontWeight: '800',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flex: 'none'
                                            },
                                            children: "\u2713"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '10px',
                                                color: 'var(--navy)',
                                                fontWeight: '700'
                                            },
                                            children: "Full diligence pack \u2014 foundational + value modules"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                width: '16px',
                                                height: '16px',
                                                borderRadius: '5px',
                                                background: 'var(--green)',
                                                color: '#fff',
                                                fontSize: '10px',
                                                fontWeight: '800',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flex: 'none'
                                            },
                                            children: "\u2713"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '10px',
                                                color: 'var(--navy)',
                                                fontWeight: '700'
                                            },
                                            children: "Self-Certification tier \u2014 Silver"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                width: '16px',
                                                height: '16px',
                                                borderRadius: '5px',
                                                background: 'var(--green)',
                                                color: '#fff',
                                                fontSize: '10px',
                                                fontWeight: '800',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flex: 'none'
                                            },
                                            children: "\u2713"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            style: {
                                                fontSize: '10px',
                                                color: 'var(--navy)',
                                                fontWeight: '700'
                                            },
                                            children: "Ardent Capital diligence Q&A log"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginTop: '10px',
                        fontSize: '9.5px',
                        color: 'var(--muted)'
                    },
                    children: "Compiled automatically \u2014 ready for the Investment Committee's review."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '8px',
                        marginTop: '12px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            id: "icProgressBtn",
                            style: {
                                flex: '1',
                                border: 'none',
                                background: 'var(--green)',
                                color: '#fff',
                                fontSize: '11px',
                                fontWeight: '800',
                                padding: '9px 10px',
                                borderRadius: '9px',
                                cursor: 'pointer'
                            },
                            children: "Progress \u2192"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            id: "icRejectBtn",
                            style: {
                                flex: '1',
                                border: '1.5px solid #f3c2c2',
                                background: '#fdeaea',
                                color: '#a12b2b',
                                fontSize: '11px',
                                fontWeight: '800',
                                padding: '9px 10px',
                                borderRadius: '9px',
                                cursor: 'pointer'
                            },
                            children: "Reject"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "icOutcome",
                    style: {
                        display: 'none',
                        marginTop: '10px',
                        fontSize: '10.5px',
                        fontWeight: '700',
                        padding: '9px 11px',
                        borderRadius: '9px'
                    }
                })
            ]
        })
    },
    3: {
        review: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "rl-header",
                    children: "1 / 4 reviewed"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence high",
                                    children: "High confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "rl-status-col",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "rl-status done",
                                            children: "\u2713 Reviewed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "rl-reviewer",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "rl-avatar",
                                                    children: "BC"
                                                }),
                                                "Benjamin Clark \xb7 Aug 1, 2026, 8:06 AM"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "What is your current monthly recurring revenue?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "\xa328,200 MRR, drawn from Kestrel Logistics' latest management accounts."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence high",
                                    children: "High confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "Do you hold any registered IP (patents, trademarks)?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "One UK trademark identified (Companies House filing, 2023). No patents found."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence medium",
                                    children: "Medium confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "Are there any related-party transactions?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "One director loan of \xa315k identified \u2014 recommend confirming repayment terms."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "rl-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "rl-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-confidence medium",
                                    children: "Medium confidence"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "rl-status pending",
                                    children: "Mark as Reviewed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-question",
                            children: "What is your customer concentration risk?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "rl-answer",
                            children: "Top client represents 34% of revenue \u2014 flagged for further review."
                        })
                    ]
                })
            ]
        }),
        certify: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cert-ladder",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier passed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Not yet certified"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Not sale-ready"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-check",
                                    children: "\u2713"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier passed",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Bronze"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Minor issues remain"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-check",
                                    children: "\u2713"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier current",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,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",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Silver"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Sale-ready"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-here",
                                    children: "You are here"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-tier locked",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAABCxklEQVR4nO196XLjSM7tQZKSXdUT0bPc93/Bb3qpiOkuWyKB+wNLIpOUbJc32kVUsLiIlrjkSeAASCSJCHbZZZd1Ke99AbvssmXZAbLLLldkB8guu1yRHSC77HJFdoDssssV2QGyyy5XZAfILrtckR0gu+xyRXaA7LLLFdkBsssuV2QHyC67XJEdILvsckV2gOyyyxXZAbLLLldkB8guu1yRHSC77HJFdoDssssV2QGyyy5XZAfILrtckR0gu+xyRXaA7LLLFdkBsssuV2QHyC67XJEdILvsckV2gOyyyxXZAbLLLldkB8guu1yRHSC77HJFdoDssssVGd/7Al5Vzn8KhAEIIGJr2/eFfRsA2NaS1k+tfk8Xtv1Q0eMEaP9EqP2UbZdSzz38c+VLdnkroU8z/cH5m4BnADPAZwPCBOEZkAkAAzJDz2H7nAHmtO9A6kAUsvas+va7AhAi2yYDSNFjVAAM6dig+8WO0QCigwFm0M99+/DrDpw3kA8NEDn/KdroJwUBTyA5A3yy/ROEz4Cc4xzdn20xAKEDTqNlfBsAZAGH/ghlq5WK/iW5lija+NOayghgNECMBogDQCNQDqByBMoIkB6TMtp+ATCCygAc/rWD5ZXkQwJEpm8CVkCAz6YxDBh8AvjOjt9D+D4dP0NsrQA5QxK49FjSLr4O0+shoaQtkMwp1xAKAtUE2sipHAAcTGscDRA3CpJyAyo3QDnavq8P+h100L8n0zqHf+9AeWH5cABRrWEawRs7Ozjugfke4O8BFJnv9DjfA/OpAsRA1WqYuYLEzS8yzaK/vnJBnUlVMkAGtAAZEkC0YWsD90Z/BA03QLk1MNyCBt92oNgyjAkgDrBRl523vJh8LJJ+/l0qGDJA7gMgwndAgMK257v6+Xyqfy/ZBDOussZTAiBrmiQBYlWDGN9wbgEzkUoGiplR5UavoUy6Pfh1VJOQxDnVASC7Xpr0e+mggD79V5zDYNy5ynNk2wA5f5PaOOa2x597syqbV3emSbIGOduxU9IYZ5A4WGY0ZhZ8LboNABBIp0WoA4h0Xily7hEayRwBzKZhRI+BOwWVduJ6ZojMgBx0oQOonBVkMkKMt4SWohHEv8vuDftx2RxA5PSHumYl9ejOEZCBMVWARCO/h8z3jUaB5M/nFgCuEaJ9J29T0/C9wa+5fa9okNXvggEiu53tfjFBeABw0u8RApgQIC0TSCaAXQMdjLQfKpEPjTQEsQeNgPxXQDuhf6psByBnI95iBNqBIL3GONdzYv9kJlLSJI12OUcDrCZT19BLQbh5w2llxxoO8hSAANXESkS9+dy/37XE1AEDdvyswKCTebiMc7i5FlzkCNCNAeYIDHYcBpTT74LjTuYfK9sAyOkPUS2RGvV8Ug+UnKqJxGeInM2Va41GpgYwLen2cxO3kKRJXItQbviUGjTXY7amVYDUbbqoQXwzu4+p/izbZwWqVdjiODIB7LEQa+RO+IvHRlSDEDmZvw0vGMTIvbi7mIHTb6JkfucnD8n7A+T+NwlNwCdgvlNgTMolJDiFawoDgNvkrnXA1vjdHFNACCbUAKKbbpVjUNYo1GsWb8C1HS3iHs0uQfIBsb+kdKADh4SpJUBxB8EI4AzIWPnETBUcEWgcIDRoLKWMkHJjruEv4QUT+WKguQGGY71HYmD6JrST+KvyfgA5eZCvmkXKH/5Wr9P0N2T+Dpn/NuKdTKesBcKr416nCZXDOBCkfi7J7m/MG9TWLKLraDo1+LdoTdTvZq5By3OoT2NJ18MlgaQAkqPsqtUk0lPMfeyxlTJazOQWGO5tfdLnMdgzw1R/v0iP7l1W5H0AcvpT3bXirloHwHdg+huY/7b1X7o9f18CBAkE4u5Q9zglQDR5WJIa6AoPcSHPhUp/e0kWofW1XKzMJ3rhdJ6BhAwg5MDIzoJklgVAhuomLvaMSn5ODBRbDwn4RGpuHf+zI+WCvD1A7n9TvjF7oO4eZK5Ymb+D5r8g01/ApGuZ/1oByGyNNwX1HpNHlTvvhnek8yhOQHew21r8pX5Oa5+v5XPl33CtBSjAzYNFqTFLAorYf0b4xQCiLl/TrsV5lmmo0gU8M/B3kFyUtwPI6Q8BTxA+gZxvyBmYv1tw7x6Y/1ZATKo5ZPrLtIjFMsKr1ZlHwqmT7qLe2f4XN4BSg6R0bhyQlb9fl/bjHlg9fATGwmM/FFpoBqlaKG02X+fnuUOBBkBGi5HkNBkHiAEG2ezUfXJNfH+W8IqNe8zE5fUBYsCoXqp7S/fwyLZHuu+UbwQwvifz6q4xr8RNpSDZSTssAnlre9dMnuem3jz095fyurIWyUdzwNCxkY+RmmRBvin9hCMsmaHuTi7q3BCZ1CyzFBaSAzCfZc/tUnldgJx+k0gJmSdETlRwjjsDwl3a/g5M3wFxYHjQ7wwl4BNqS8nmlEvfi38U6c29FfNvcS5Q73VWMPDZjqUxJrO5jbP2KK6NM0DM20VHAKOmrBz/30d8mC8mrwOQ6U/xTFuZNUmwAsJdt/dqXiWASADlDhH/EDOtYKZVP+CJuga0MJnyB5eOv7escZRL+34s34+nqZA1eg80uuNiguZreSdzUiB4trMDo9wCw62ucQQV/ulB8uIAkembBMeYDBSTawIHxHcDxPcEkhwU9Ei4BfrE4hpggDjlQy15AvVGVReniJW0hy7Lc9qG2PVcMbsefR2o193clFhspppPImc9kRlE5vomD6ieAa7p9JhvEzi+QOQEKhMgt8BgF3f+r/KTn5CbvLwG4bNlzN6rtkiAcF7hsQ2Z/jaAOMc4GSgUEMQJGBF1Q0NsF658atDSf7iy+ZrvnLr1pVNW4iXXkNNZWOF4cM+eE/5ijgx2gJwAWOdlqShSXINYtoJMwJDjR/b9RdQy+MlA8rIAOf+R0tHNXOK/lVPwXYprWPDPAKImlkfIp+qJaYJ5LtQG4PoO+mrw67kE/C1l7ebSRwBaEOXz7Hl5UJQGI/IjtMM5xwAtlLNxEM9Xc3NNNGZSSvtMp2/yM6XQvxxAzn+KeA5VcIm/TUv8rUFACwBKAojM3xG5Vp6sBwAkIOTkckm9bTatqO1kr766HEfYoGRtcvmEK595gBS2tkCizAYSHz9yhkbpLcWnnBNA/JknN7IAGKR61KY/BOPPkRX8IgCRkw9kSiZVgOMv1RQOEI+S873tm2creEYyEcg4xTUL5Ude05Ze7RM50OJ+pd1Rq8ieIRlIQAaMAiFGLRZhg7MkeQejE8muZEHEUAYG5AbgnyO4+HyA3P8mkUvFTrpdU9SgH9hduDl1xIm5aQ83qxp+kCLIva3+6V/PQxJh9nQsOTAioJjGs4hF4CkPK3avoLmHDYWReOnu4UH/hkSU5P8EEfjnAeT+v6E51GvV51LZekoAyYmHHkBs+MZHjWNsWfpYESp4Gq+YReWZEs4kxU/MbTz6FxQNBB8/r7n1YwA5/WnjN3yMt7ppZf475VL9DZn/B0z/A7nXyswpSuCgnEvl7qleQzQc47rJ9abygAf37eSh9BZfZ47SgYZ9u5jSFjPR0mhHBwgADAyKWl6fV54MEDl9k5pH5QG+aj55oqFqkP9p0uH8d4qi13R1wgzpXLhAtrM7N+5W0rM3AwwsOos+bqqScr8AIMajCMQzloNzEDCLcpNJU1JEfPCZuX4tGCukA7bo/Jvg8DlNradrkBjcZFFx5xduUs1/JWKeCHokG7obVzkHUTKpVr1SmYNgG9qj75SzvOv1PaRdVzSNeLr9FLjBbPEUZmAw54lM1pmZ6xekJYfKQT1i5z/lMxaGeBpAPPGQ29SRy5zDYyEpOi6MOnLPXlLx/9Za21a66s8sHmealH8QAHgCpGmN4h1ZKlnER1vs2CeUp92VWDTWhsZi6l23rkXc1buWbFj5ho7fTgAI7wm6Y28cvxDLipUaEWg/TxuLIGXWiH3iy1vIA1pEFhs1btJolYJIbHQTjEiDjVMqEFFuFCAYgE9oaj0aIHL6XYi9MmHNvJVJibkDpAYGO3DYkE+tHNWlUTRDU2n5OdZ3X1zMvhYAJGJp9YSoPhlrX0lFM+nnFAS36Hd4LOet5MGf6vLYJG97aJYt2dHBoacQEaK0UCxH1SYRb/lcBSEeBRA5/yE6dsCqGM731bTK0fJ+/EYeAeiDc3IUfME5NhDgECh5BQwYUvlrNBbTLP34DfewEZlJ8nCg832kA0k+nt2/YKCQgYVUU/CdmlVzKoWKQdNSgGqOnf+Qz1CD60GASKSud9zD+ceU+EfkX9l5TR2qDyqcPDwiNp3IZYAQAcU1os/z8aGk8zx4PTEe0JRlcqDwUc0u6nK2cNBaZx9ckzysQVIFQ/GyPPNddevOSXv40Fmx6Qc8K9citcE4QnMQYuw1sOzQ3kPctIIBQAQsEiaXOEB8P/2pmiAELkXv2aqjtK5qbOM+V6UPJrq3saBNl78H+ACZDyAaIeI3lYYQk5jZ9bHlMkDO30RsmKywm1QW88gR83DtqitXkreKcmYudSYHKWRyzOPdTJFkcdQCKA4INjxokExXGl0OwNgfUykgKuHwIZipJYC8C2FfkS6WlL3salllkBgfiYqP3lHeA/Oo4KBif2736S2KYDGSj+3+vQyQXOlwVt4hkw5+qgmJ7QCoyjusWACpS1cVxlosYwOcI4nzDhEBi0achU2jsAGi308NilhQiulKrkE4iUa4jftspNNuyyt0kHiZJfdkDpB5MJdKfY/klezZ50I5vP49vKKsA2QR78jjO/rlvjtvgtZ1IgT38OenredjCAMsDDEgXAQIJ4AMgJuOhYE6zdpnEOeSXrnypDdMxcAA27aawWzjTWj60FxkHSCSwBGjAm3obI5xzD5hTXLlevIhWeDPvTp9Ju5y551FzJRyELCuZwdCBYuIAHacJfefaoMLEYQJUswU49Kakvpz27p9oIn96D5Qa42VToP4CZRuqYB8kiAeIXTUaDt/3CDi8spjbIeV5Jm+d4T8+0qU3Ksk+piO6spt3JzZDt9QAxESe+HVvBIWMDNkZl0zV9D0GqTSKpCQlQ8lEBNKKRARDUpHQzJSKxtwAz8UaiLAbE2AJgj7tHIpiBrmY4GUAzDXaRiEj2pmnf4UOn48LrIEiMxaIX2+B6bvtT5us2TTKldL1zgHRWbuWoxjfff9RVCJuYBNe/DMYJ4TSJIGgQJElWSdSoeYTOMUXROlWAq2Rr0eEL9wVo8jbHqGrGlmBYfOomWAmG0aBj7VfK0PKC1AfI6OZF4tc6xyrCMXVfhEYmBgX6ZOi4goCTcNoiEA9cgREYh1IBIxg9jd2EOU1v244oOspnSMKheJ/KybjpfeAJgg5z+EPljwsAWIzBCZUrwjjQpsikm3lQ4juNSbVLVPfdOb+mFJGkSYIfMMnmfM81TNLUgEDx0oJK5BJABCDii2uIhY+kZRt6gQtS7WTUry/0Z0fa777E4YP2/U6ih0p9qj3Few0KDE/fRNcPw4hL0BiPg8ffMpUkl0fMf/KkC4HUce82tQVcYeMPNY4LYbASL+4SZT1R4z5lkXnk2rxBQKsLiI2EwCxUyt2eIhDCoM4gJiAUNsEqtqmkj0JRt6QGtjbiL9xNmTEncBN2SdaITMRxDdAHRn0zHcW7S9RJr8R5IAiNgsTyLnqkEiW/evlLFr2gOpvH4EAbMGIXwIDbIWGHSQzAw2LcLGR5pRdQYUlvrug3f0C6BBtRR9J1ACydbF7zl7G9hGKZBqRzqgDozLi82ZyKM+qA80DVzSIKY91sZ7THdLr1UushCSwfBRAh5JGIB5ry4tawCJZGRCmFf9oieYr4dKTe77kOLvnMx76VVS1mYd9sWnjxt0+SAg0eH3p9+jlm4fPQ9weNyD79Vj5VUxvCKG8Q+1r4Htag+pnaHvusYQVu8VqxfLtUZeam1gJKCY65bcRKumWqtBABCBIQoaC5wuMg02JeaSBtDet6TPJ/VSeYWaVL0/NAgPIJ9OTixg/AECiKNEBfbz8uYMEOKAMWJONoENuV2a0ygi1iHbxUcaECWswT516zo43L3rZL029AYgnn9EBAijCDUchuaiPGT21BvtREpx5qHXIRZr2Ei21lLSZUmAI5N21STCkxags/ZDfKecpBws2u7eLgPIB3D9juGuzeqwn0I5ouQ2Y6xXxmgqBFgezqW4xxYkeamicacoeTWlqhbgZHKFeSV9j2oEv2iQsXCpGmQmcAp8FNhEn1IiW1i9WRt8XlcldxJe/cRM9KJ1lsU1yHxQUMA0CA3Q3mLcvFdrHSBxLC3NdGfJBv2oYppDHuAcYKm3/FC4x7IyOOIgVOMgZl75MgAfdLzIJanV5Zdjh0ZE8mLmIuSFsrcro5pOUyBe+KQjB332ocWMss47zDaNlw/bNtXb5/W8q+j11hiHhEs3wDCvaxCJtHZpzQu03YMYl2FikJlaPPNi3nQi1SBMpBUKa6rvB5HMP9IxGwKgyao+ZfcdMLvW0GCpOA/BqKaXzG9/C0+QUSerMTPKSXie7gwdOJoH5OkVbSPIuVfvL2JDzbtUkpRv1RBxrjEP6cDSktOWpkbg0PiMOjHyIzBQUQWJCIOk6PVtFicdGNI1el+op7mppcFmDQVY3azJWemgrmAaARwgcoTWR9uujDLfwbN3Q4OYiSWuPRalQZNsPdzhAT2gag/pyHjEORI4Os0hIuttherPOD9hUfOKAc38j3AgQQpbpm9pRipSLv7wIaQP4LgWMROLTgAKMBPEq8yTJjDqWHYvRDdvuqbWCL6zm8rEvK+Zu2078UkiuMo5VvnHU4UBNmpOYXoipaEQwIzCrPOX47NwkTxmpEDHjFiMhD1Pq+O4w7bbl2kQBYh4EJDPnVnVxzzo3bQGdXvNENFEjXRXomNz0yfnWlXTataExKxBWDUB25iPheu/u6a2NBBbAxFIQAXqwSoMKRRes+JeNGBB2qtDkOp3v7vZSu1mtbF0kdkI+dnOIQgKMA+a1ctf4JMlUdPGtilJg0wXBj+l5DQbyUBNzjaeBRLyYnF+QJq9lfkwugMNPtRUiaILjSvX09hbUj5Pc2dizYmwpzHpmZxnoEh3SSw6tsheOrv7G1BizjNoJlBxjjPHTVZlQ3GrjSMAaBwfFH+3gtjl47EDz3CcuGOhSZZIjhnPz7IEVmG/Oh1EJfMJVCrHFZlAbCVONyqmQbh1zbk/O9IqugLTpjlesjNrwyc/+MUej3CAGG/QYxxku9EcKRmxahJutA1HcmJ/sc0PN7t2AZa6pBqCmQIcZWbTJgyxz/W7e9u+k7WH/qZK5ULHSNZOXBuIRJ6WyADICIh6SElWwgcbjYdoHKQBiI8MzMT8A4s1bF6Ld8xcATFx5+pVkPCP3D77D7NqDeffFhchj7R7npb1oKpBKFzDhegD0pOkDXhClAyiLq6GnuNuU4toHCSioOeqQbwmq7cwgnpaUmYekRcJfQLwk9364t2FawuuGkQdS32GrppWnsquZpZpEGbI7LwjFWnIpklnYhkJ6S9Fx4kAEGYQyNJPCKWwxkuKLcSwkbsKCq+vBULhFiTPHqLb8IbnfAmqbzpnFmSLA4LIwGiWCeC18MH2xOIgnipw1uG2MX9HvnDzxKAthLZML3n8jWab+tI7l+6Tppqhp44nkyoatO8LahrJxGDjHAqQSdcOEJ5jqK0A1SXshRmkQ7Ys19osKmEXIRAK2MZOFKKqPeYZVBQMRXyoctFnWqiuuaTflebnCYkDycPYaTDdHHmkULtTLWIHipubovMhCkETGR0offDZ625tVoOYieXkSs4V3dnwDg3if9oFBx8pEU+w7wsife38i/vuXcqAaAHiCYdqUlWNEWsHiOdbcdZAHNqjuYqL7am7VoYlFKToOgnKbBqECESswRKpY/nJcrXIKk965SDtjDhpcVuutK3FpbpjIe8/R4iwfDhSNzFreyLTGrmGwcJTuj2pHCRcdL19+AoSpo8EQNrPm1O7P32aBmkAMq0s/XiPAEj/4n/wVqGWCDNHLIQtDuJ8BJOaUSSwOTTNO2VcJLohM2upMXPREPe19t52+qlTezVKnD0aPc+4smxwDvZRS4W63ehcJFcp6TxYwJPdV2uN2Ht/FtGfbXqdata1gEALqDWAXNMgk7l1M/+IFBO2a6l/X00GN0oeMEhWuEjzHNgyflmAyNOatTm5BhEGUTH1UyCFQFYpvkRhiFApLUAIXcoKWaQofU46akfIsohLtQTcXHtS2n33QPT3EncN831t6bTIBs0sNbHihtzM8mm32NR+/YOMDX0XC099I2JdaATrUm2pGG/hQImGmf/+KQDxOroZIACkDQqqicWxVM3BKSCoG5R/3O850bImWJGN++Cu9fr9nsnNpKn+mRQbRDXoeHblIEWLOwwKCCZCIbQaJL8UypygmsTkiaPGb6jouc0IlJjgq95Pg7VVqb/bpiJJeOakAwkFMDxvq4KFtggQkTPyjZHbiHHD6cafTjkAoDZaQY1DCINn31YXrJtelwHSAmJNg6AHiEAB4t4pBwnPqZyPjyiUFauyBX3TYUq3ppVjsSutBonZZqH5WGVQws6mQYpqCiqWMg8zzxJA+nUPGG/+cV6xqiuC6gyAAbF77kjf8zRJIMn73gHGmJo1LbK9zN5ROUe+qWwXvoARnqSPQUwRoJMwcRqXqpteFzTGKkCAMNfCISCwAU8VIDnVXVNLXvx2V0WYWwy6WVQEVEhNqgwQkAIHzkEyMPQLKq0oC4BEzS7Aqq0QqBRNtDVzKxyRb1ZH+AoP2VjiomkQQM2JZDcuegKXH7h269Wdf8zZ1DknHiAaD4jonPi4DaR9VIAEeAwQFkyQHlDeezuJN7CI/WbVXCsIecrtdjYJ1UsD3DZ3U5M5ngsVBnNBKYlj5HUGCK4BhGocBQYQUoARABpUSxVTF8VLsRT1lq1py5dJl0gaZKFNVrjIhmTUCiUmZD5/m4WWpG2A0d0llZ7bxOqzdE8VzORhz4FiTOcZ07mLQ4j2sgCUMBuZj31CBRC4bdOd7eP8J3MXH9fRDJyK+8TSudODpqdcqV0Joaat+2FHiTiHF7t+ARfNHdO/0SRGfY4OEDWBYgx7PPZ1gJANxAqAGGDItBKJgWKQRKYHZPM5ByK9M6JrIFmYkiuPy9+DgyP47oqJJfOmijmMSsiTxA2saQ/gRzVINEojqkqQZ8zThOmsfGDm2YbBGsFLgTq/tnUNkn4nr4HEqNPfcj0vDJ5L5tWLaRC7As/NIp0iQb1J+kcSXIMbgPBFQPT7rRuYyKo6Fo3eFynAoIUSdOpBQvFgHheL2Ndn+mMa5BpRzRrkCkA2pEXGps6q6m8Ewl9BhNHwkHliTMn1GgBxsyy7XUObPACQdENE/UHBOpBe4u6eIDbBjlwh3ZVkI63LCkAk/q4HCJWiXjCprmEQAQwMpqnePt+r4x3MFkxkGx+znZhIp0G663G12HYpWGmJD0vDQ2DerMRHLD/KU8yVWLsG8V6+1yBJQazcg7an2q0r9nX/0pO/YIn/mPR/2rmsYxUmmjX0xvskHVDkigZB8k5VzlKs19bAvI5mDI3un7mZSa/Za6T21GiPqVvz0rR9J0kcRHsWKaT3YHVkKb2QkCYZKx1fqaMphLB2AbfgWsIcRdrYPFoBEH1QvAjcxbfb+8w/2l4DeQt0F6jdT8ud6gERdPe7alVf+fzan7px70C/MODLd8W5Qv7lrEEo7gdOPUhsll07QHVMCjOrB8ucEvYqngGD7oIfPBetecUOirw4aLZRM0sBYg9U59YztRuNvdcgLyBZmxhQvKqhr8k0x9LEas2qvsNbXmJtlPXD/AXUaiT07fqlNUgm8dKs9U860CxQxuvX5F9N0GnNIRZD0VKnCo5U2eUSxXxVuaRB1rTIZjTIhKYLKkPdfw+x58Lm7HFt++7G6C4vJD3/8ERGHzOSeMgGpAKEdOyw2qJG6sLWMLudXq7TWaHOofJr5D25YYM/POJLG01B7ecLLULt/pVy665d2qfSftPiJ9IJYnwi7oJMA+Y6Y1e6Av201TfN3/hj8meVzdl+uXiHr9k5uvbIGqTXHFMl7BuQUUv7uL1q9VPDoiH1B4ap1eX+dLL62NfiCO65ibUHyBCNJiwAC2D51/T1ozJn8AbUttgV9SMXd65+/hAg+s/7EyjOqn9Q43PVjGxk5VFnIy227HfiM3++3Z1IkJX2lyhtBDeDlyN/SBY9E9Z+OXpACNo4iIGDbSn22QbiIcnEsmw1sVZ6qSf90ctVZMGju/AAVtFAWCkFUgQywOqAaA5SxAkudbCdVntNy/X5GmT5hU8uGHdJixPCEvDkxFrQTxdqjtS0FUp/1xYBfGnJ/MOJOgPkY0ZyVq+d984yKpIzGJwEvtJsQEWXUkpdhoJixZybzhQwM0sf2EZ42/YldUCFCsieMxWb5amUZBm8lzxifMgGZITPGBQaPrnjVlXn06X6ALSXUmAwylAwjAViLj3tv2YtqG9V9SFWV0pIYxoJREubfEUaE2tF/TTn+m/WT6+aUE+VB75w9WPCZQ2VrqXRyhEHqeAoQwsUHVtSmuCix01eU4P4lBltNN21Rp8D+P494phtX3X0ctQ+IrQmQGIhl6W/J2ONBFiPpibVMBTIOAQgq7rXbaYCmifMwc99gJXyNzZ+oWBxENjwoGTSUAZ/Lqx98Vplcb9tA+1HyV8mOIu/F9SBSunZtL/XOXlzbhfBhin7z3ZwyaYSEcowVA09FN0fBgXLYMmRluGbMh4XPOZHpf3T7FqoAMjb0u1vQRQg8bBfR2rjV998GQoGBrxaOkF99URzDAjiwoFOAtX4iA9dhT7S4OQL20ylbW6PAPc7apBH/3lPfIBGC8C1hAFkGHuADKFJcoawd1CvaXotQbO2bEfGh095OQkiLqIFvjHWl1NsFF0BUAh8VhuUMOnAuxnwhyc+2Ghbz3Ib0nO7oaCMYwJIafmf85FdVkUBsmqjv9xDcw0CwFK3S7gbSwHKVDAURikFk9nQM3GUsxGYp2NWG5WloEDAVKuiAFi6OtcM9uxVMg9ZLqz+ohrjqdJbTKj3lI+1kvhDGhAVmmIcMIxDBYglLzp5zx4sX/fVXX9mGXMUvZ18E/D4CCWTYyEPPMycaEdALdBM0CkCSFOx55nN7esaZU7thYNj6HqGG+LMtBJL6C5tAQjjPUINJ+gBsUaKH5bLnORRn/ecY/UnCDFOgzqAlGROOThG4yJjQaEBZdBOqmT+ESBJLOQxN36pB8kPr1/y9zfHtyfjhTt4cckZpsVA4m5IzRPiZP/qiwqHGmZr1ATS+UOVi4hAJI2os7MvytY1SCdLgFpDBlpCXrK3qmqOWI+JrPs4d7gHq9Te65mk/Ek3RmvtbnuIeVMOAigoYoCQp1sXmJKwyR3zACJB7BNmMAETRMM3nnSHVJHkZxDrYIqNFOw5RcNB+mMGEEF5tVDXZ5I30yCAfrVGxStZICIFhzn8B3eRIw2OqlYgZrPQZp7DzaukXadcbkwt9+raz61lvTQawy7tsTh7UOM8RiWl/UgsXrFwFjzDuUaYTgWDmVRD1iDDYGPRS5Q5hXVSlRtS3P/rCdX1NQ3S5O6/v3QAWZFFa5F68T9yD8kGDX5iL0wGBcUgAFybACkIBpvvjtSrxRJxAh1DUixFXk+p6eTImOnaaxpvIdA6VFcfADWf9OM1nsxZJG/qN4SGhXn1rEHl+AaBFBjuxi0GkGFEGUYFSXbnmreqppb4FVez6umvs/+LS2SkgkPS3/lcjZkH1RgPqjn5jnJBg7zhZVEFSs3HKtbArcGY67ctmuZm1lzjIWwRRCssIfBYSxJpfvp1NcgThRYb9cCCiFPBYG7cYRwCIGNojz5q7nwDbe/8Zq+aVtZXNMi7Q0NlBSDvK6WUMIWGESCMBgqfyIyqNmBBEdFiBKWGRrT82BNa+keRnl+MI8YOIGUYF9wDpWArJstHkyVAyLIJm+Ov3NJMi2gUWOfy86qCM7mZUYea+jgRnU9Qx647HhiCYukY7v5th7U+5Ha9cpmdylh9Kk94VGSXs2i71O10rtxSCoZBtcUwFgwWCByaWAcF72jdwelG3q0DyW2rpCUd30jnNkq4+QYQpQAeZRfHNVvz+T0TZcIOGBEVozsGEmIUUgYvVtiBx8GKPwxa21YEJEUBJRY7IalEfZUhrA1AaveyCdVed3tcOUz6hQdsLnNcJw5jaJH2JMogsVQdN610qQChMmgwdqCaa2UFqmucw67+xZRKvknT49VHnw63nbFYsqS2QV36FP33lhFkQ2zTRbZoBt4Kzt67ab0oQoHAAewFCnwqNeEBwyDggVEGqeny4iTXR0Dq3wU+nqNBuv2VYoRP1yBonzItfqg2FiJz09ISJO7NqtF0IGfrAu9lZV0j7l2787a3IR4yVjCUleWd9JxxNe1dqzkgl/z9RZo8Lwgwz4CzkU8lBMs4WI95OECk7+M2J2vtrTe33l9WNEj2JAAZJE92Yf6ANGUuDbcWd4dIFwCLNG7lHeyTZLo5klpIUzDyoonoRk/e+4Fu4tIX9CoDWFUh68+44yJmbnlhuFgKNSZraJB3i6KuaezEP2jQQiF5cathA+VHR5SxAsIvzHpuohw8Ynu/9rDNFqBVlvmDktJRdAOxbhpFM0qOUo8qOq1yDEZzNk3w8ijLZpLHdyRzLPYSYJzMJLt6Aeie/ObcKgHI50ppLyH/YB1/f9HCdRXrzyOt/ThQHR/Nl72iSLs0MQ3UHTItQTRAue8I0AixNez4FmTUi/OHWKL3aZlm3YqJ5N+oQ3KbnHqQWIMoVFBivr9uSRe+qDm3+lvSAgLP1CA/KNKsV369fSipk6Ag5NsU74i9M3aNocAgGpMm2cb810mDwA3/JBu34bOm3o7ZustV6bnGCJRuic/eX0YqB1QHv5sMAq1LZC2wsQk6I/qNG2XVJGnb/2WbO6uBzvP40DU/OpLeuXXd2rxk7q95rdZU1JqH1NdLayvFNuzeBWSW4EaCCQAa7hHaw82pMS1mdm1kEp0RwzHtir11NaNi5J4JiaQG4XOHvyJYVlvEj31RM/tUXPPaBT9xzLmkOAZhJfDXOznaMe5rdbsCEOn+pfvfQVHXyZ1r/71+JpM0jo8m9w3OV5PTh4qmu2CoPIMOrYnlINmIjFQyQKyyBHldIstDbxpp12LfAuehBfo+9fKp8cKkkuIf0yCXf8spfatB6EkaZFXj5OttKiI+pr/YRMebJNnB2R4O7uFASdsb0R4AMKIcUZuV10udsBUb8GcWhuY0Mz7D23CQpKWUC/xjO9IAhDBDZLZOiBHRpnDnJJ1P1HaHrySuOPreNEr4X6o9GzVoJWmVsAYuy8KiWvPjP9LuI+DyuNkLxlvWlIKYGbfRIluiFhclcY4mM8Pjbb0Gce3xr81oDwAYabhFLfVo86OTAGIBRLex81uxUT1qHuT5Q17j3irLlrRbAYO0eO2sdNyvNze8tjDV8rolbSziBxfsId/M54v91oUGvQY99YlQnCDweVRacEizvGWb6gxQcRuRqjkbpWKT1ghQtAttlHu4jCg3iKp2UtS8KlYrtc9XaDSIU7K3BXxohYc0R6NFLmmQR3TFT83dyuf/qAZJzFxxzZCUa7ZdLdLfUY559IuBpJg3q2wnOJhFTawMEADgEcAZW7MHQ8xv4ImLy0W2UPf4+eLjv0hrPG+kXO0j5VqO34VlA3MS9jLCTSxRjaG+/cnQnBLHvGdLniR3W76l9NpBZ6XyLF+p8xoi97Z1RiUBrisBt6rcakBriLUG2ZKPXKNl0p/woBaQ7p7rjFu1YMU7SP7d5iI693mvKfJ6bdmgjDR8QUyDxYO9vwngEwQOEjWzpHu5am7L0vZ+QYkmaA0dMErhmkKk1RwxXkQs/Sq5eZtmnr99yUH6GrzKD/zFp4awsCo8GOJfLVjPi1/cof5uc6pFnIyDcNc5NNzK7Uh3phAZP3zB97Jws1O7m4EBAmGo3ilK60XOlSUoblBGjLcGjgmai8UQPqeLNw4Sz8Zefv+Q3kiT9J6rrDkaDSJLDSItAUnbXeNda/RAGlfhATnqMNIDRpa/ucDKNTXgHUKeW5Cv8q3mPb2WZA7XqGQPCnq7GQE6GEgOdaFDpz22k1rSy4hiAMEEBcIMlPvN5cT0wsBF/sE+9baf+BriwWEqsSuQ9fbem1XP7UukWzYl3maGBIxjWg5VqyC1sQ3yDwAYMXwBxCZQJAIwA3xMbrfkyeqVxhtKWBJiblyWVpuwdPa5aZhVz8+VVmUEJEoSpdyuEhqkxGehNAi1rGkqzxVVVR7tOaPF7oPxHr/3mN4BZgK/dpAqoV2StwpuQjk4boBBF3Kg9FpkozLS8BXAGZgns1snoNxFIpl0Q3DDusrv3Z7Tk6cTW5OeDvhc4olHKFi6BnLNxdubBCu9+cLlEAmRnmKvwCAkYKT8J7tYvV4SQBhiYPPh8av32OElagU315i41xo4OhPL78LB+ZJAqZ7+3ACMo8LMK8+vGm5Awy0wfLHlFhhuQeUGKAeQa5ON8g8AGDF+AWQE6KzZ7XIG5mO9yV6LZHszF7V9ZckaJAcEF4sT2r7h+Jeg1yTe3dbbijEWQB13kgYkERwwLUBizncAGlNSwDj8mpvx31q5UenOEfuG9v5bPsIiNkNx/arX0SDpByS7Mjwg6ITcNUcGyBfQcAMMrkWcqG8ZIMMtwOZJELYb89yYbY4TbiRNaecN/8VoRykBjEcDxJrzzD6d2CtInmbcuFdhgvhw23cTz7FygByBcruypDaGgveeyfaaKEDcP40ZkPtkI7przlAuqZiDJA1i0lpYL2Fvtd/deDVTT+raY+m9enwTzeNLfNbdEkN5yaYKQK1SmKqG+AWKMJiUCxQRcCkxAlO1wvJqxGxTcrKxcuPVMdXxrjVzq5hZ5f+/2CtIruTk/IspM7xsT+Ie1GkP1SC3kNJpkA2L5mLRoI1fZoDvq7eBDjpOuBzU9CIr87mWXypSU7fTS6EnAqU/U6c9yKRHXxTLEihrATRCh2NCuGcBI95EVnyQbLJLBcQQBSIMIMUAgqLxLqo9tl5HAc0C0KxHbcIfIb+u6uMla1jevtbuPscxJDdKXLpvXUgAKeZseJHxOvWB+rDkMBvj9RI8AZHCc3ULGr4A4xdg/KogKbdqZhn/oK0DBMONop8JKFPyVR+NSB0h5QTwATr1bMNskRvuAgovrDhXCXrWFj3nsGugFrENyS6oY7m1SmdbNWUYBpt4NAGEyABSOoAw5iK1Wr0RfedE8GtbeS6UAiSNUyKcDb3z4YoWMY/ai72DcMmhotOPNxrEI+VZgyxJeuvF2i7/AHxMumuFxm+d14fqtxaBZv0C750cFPGOiIFYztKamH/BC6/pOyUMlM0oagEyGkB6DRIapwMIM6iIzZylkwJxIchsxe6cWPs1pY0AxYXrF+dYDf9o9/GunTEBzRjzSxzEj9t5G+YfADAqz7CuIWkOv5HwW5cJAk4v0DYiVV57cmpSyW39Qo9AcKXnDM3h6xrHyGaVcwsY1xhI69hqvVuqRaCLTjPQA0QrqZgLOE8GBAVIma1GV9Ftnoumxcxs8Rs2K7E+M7hG4OoPrp635b2tL4mjADWj/3kPHEmxhZWwlKxBcvzj1uIfrkksHpI1yMZlLIdfSc5/CoixDOzcQvheNYbMIK9yIgB4hmAym1RC7dZHaEYDJTuY8tO+IA9RlmSDo2kctYG45HkwihFrn6OPiFDGASOleTa8nGdvYlk93CYu4tvJ3GRhDDNj5gE8zOBZwFxs7SBJCYexNvDYV7EFTpzYJ6xUl296XI1GSucG73+StdX+oWQzOp3h30hRUqZASufiLTeVh4R55QDZTmGGazICAB3+SXL6TWoymWmN4RaUACKuNRhAObldsf6GsiP/xR+DACu9qP/kIlcqaY5SBgyja4wBw1A1xjAqMR8aE2tUYOWZneyWmtpb0PT7mRkDC5gHBcRs65wOMxsoPMFyJpCoiSiiJlr/2PpOoHFIeP/k28995BmR9rjrk898LmkOMsJNh9p+AiQ3FRhmtn8EcADNHIUp0LOwIW0QlczVpJrd8C2os86aCBZOrveQWm3QADISxphHQ9eHbn4NB0nVIF7FsdUegnWADJEPxuBZtUEAZGIwz+CZMcc+YyZECTI3rRhsrrq3fmqPlX68x4C2xtXxwjJ+GHAAGSDWE1DyQqiJdQ4NokAwtliMJcoMRFRdzAmYdbt1a60/84VFGXifbetEuhQYn7BZmEbdHg+6PTpADnZOIuoOkN68yr/sGzmKzyKqKTJABjO/phllZsw0g+cZRNApHmZSYNiT1NngpbmnJpnhpSVxjcZnHyA1QLjvnHLkfASVEdJokOVCGxtz/pAEQOjwK4F/E3EbcrgB+BbEBg5zoUjodAZo1sFVMoQ6jrpPAuUn5EfW+MeScCwmkkxzSvQF4nzG1nDDqofVAnqoQT/jFuMwYDgUjONoABlxiIkvda4/N7ty1fTQRKDGK7m4VKnAAHTtiZXMswJknjEXwjAzpkKYJ71YIgVMzNc3Q5m21fItgzsKCM20BnERK6rmsU1RVjadUwapc4B25XvITClbU7mxOIc7eCxBkY6bK8jwGGmngaZB7chyMKJ+hoRZBWg+h2mNMiOygMVS5WGDdIAg0+H5IDwrmTFsfvMilYGCRI+j9brkk0DWwN9wASDjaOvDUE2rIOhDmlrA5nUPDXL5GkUsgm4upLnovgJEPVs0acyFJwa8kRd3C9uaZjApL5HZOp5CdQapwaP8ncMgtoEGO4+VhtCYBmkCjakAAywKnnOuSibiiXN4VsYHlPaqj/8k8EmqDXmrQBjdrJpsOetaTpbH5Xbo69byJaAJ5mkj11mmiAgycHCDiIyvAGTIALFpkxUgFNojqsebdgIeB5DQsABQqreqMLTR2/eoKWVesAyQwmpqzQxihgza01AhDEXvdxhLeN78WlVlvuDDdq4ZPMMlxTrosBLnuG3B4Zzk+HF4R5YlrGlUlTjMEGFEoUwBFACmOXiG8Mm8WZbHhWIaREKDRI1YL/WL/B4f91KjR7TcqGHQhsKHEQcWFCJMQwGkB0g3G1MppkGMgxhAyuBTKStAlLeYKWMBREgFSGMwZsvGDhbjW+SeJpI63TEAn47Zg5U0e9ykgGfGMBcl7zOHd86vYzwMGA8GbLv2Wu0+mYNuEj62JWRXmORtuylysypxVDpahPyrppKMv+h24879uNoDWAPIzb8Jd/8nOh+I5934wiCZITwBPIHkHsIHI2bm5aLqcl2GPTxW4mS6s2/b0+wTo/2EMK2GsWB03kPAPBSM8xAAKTbdcTHzxd27qkWomlOjBwKdjJPFSGpiYphBVIkypavOoTNKnziPjdgFqY0pGACf5KcQaM7AYPN6VddwuK8LMFBBOSTTcBhUk/jEnVTBkS7qobDSVQ6iICkJIDnO8QU0/KLAGH8Bxn+AMkgGCzofPx73cFmHdjnYhvdB1m362HU5AXyG8B1Q7ixPa0IMpSObiLl5+q5SkMyUhUpZck1K/MN6eBkHHPzqiDCPA5hrvnv2ZgVvMW/UUEgj5mbPj6VG0h0UOsdGf62Pl+pwco0BEEOnkAMjD7yiQpCh2Iy9glk4Iu8eSPRrKaSu6mEYVeN5pD88bXrBGdgPXn4fw5K0+A/Hw/BqiEfTEl+B8R8NQDD8UvOuLCD4kWUdIMd/Ek7fvLu3sxjAGeATwLfQcetuZ54AGW1iwDwOIiUWPYOgAwAKUKSgiGAc9cuKNXxtTOsAcdPGG/4QiYkGjDCjbJrp8kqdXQGKVRoUc3sX1ki7sE5GKiwYxKa2lgsASZyq2PRrerxUcK85DF/iBoJ/GD8d3bRKIBm+AmMe8/EZAQIAx1+1md3/Jsq9RbnHeAbkDpjvIbN7K85aibHMGtwCqvcq85hGEmIo7a4ASS0cUjMD3vsKeCgY5jlGD/r3Rr/pppHHSJy0U+29Iy+ri6H02/mq4/OLD6/+fH9WKWpukZlNWkhfwFKsA6+jBFUhV4Com5mSB6tqjsgPS46E1g3cPeO1G1reASpJT9yj3CTu8Y8EkK9A+dKYVx8t7tHLw+zp5j+E+98kAMIngL8Awwk03ClR93KlxsR13APDvVqS1TcAz6RrHQBYCYLoWf4/mRvLvVnMAhmK2ekXmm7XWEoCjbuD43N0oPDz/PKkbU1rbasHFSXfNhHZ0Fi7ewGo6KMt+gMQAwrgiYfSfnfmRkAEMf1KvTNZPkpDhgARCIz7SueETx72PvoCDDV9nUxrUJhYX0DliyUkegb4x5ZH3QHd/Idw/38COUOGWzWxxhMw34EcIMJ1dJmQahRooyJJZlcUUqsNLL2q7ofrp9E4zJYHFCTa+164bqDNS6JlAy5dL/vy47hb13Cx66jB6u73uvynnP3uj4MW11sHXjmgV3Vf891pwFM6JbSGk3LktJE0xnz8amTczSwb8xEu3hE0fkzXbpbHQ3yRn3XSByNnJe8QK/pgC85mbqWisgI95t6rHNUCkv1/+blmL407ARYByKvmWv/dL26sP0pWNRbQacKVJ9FZTe52ftxtJIcJd4fii1OBjjIAsKBxSYHAYWW7i318dNPK5fEAOfyLwGfBcDQNojlaFGko3tAJwt77oI5qguVphdmwwiSruZ2kVQHanirAIrXlqmS/MaXdjCB3ab+uLAHamYOSjMr+UuN0afYXZYIaqQfyGJPKEfM1eKQ8zfqEY9IavwDDLyDXGjbGXE0qB8jHydR9jDzNSKQRVG4ggwYKSRiRAp9LSM6pAoowhNTDRPZSyFU86Z8EvlIw0b7UxqSvuCud6FJqUCErvuLVXWpyjd7jrS7x0t1Nrwk7u/HSEKZGmlx4A4qnDzFZ/S43rfKQB9UeZIScOm+VD6n1OlefDRzAEwFCx3+T8Fmo3AAjpz6XDCD+oAElmWI1fzWfSzUI5z7NTK6Hfzt0jreNhZ/+fUyl15KF5ri0v/hMunO6kZYOEH/ujYmV4hxNfpVxDAMIDV8j1kFpWPZnMauyPN3N4FxExP7an7CZVDHXyIzI2xILIsb4ka5m1ApX2OUNpAFST8pva6wjiLibVnl8uXurNjAA6BXk6QChUV2TQLIP7OFayc0634hG3sV5SsRInM1bKkXDC7qfQ9fThfsx3EDxuax5oKQ30TLR2QgqE8uWcLFiYV5VzUmPUpyLgYFhZZmmFxsyC5+CwHOsbqrmGL4Cwz9s/UsFi5lWVI4QGkEfOJ3kmjwZIHT4lUS+iWUPImzXAIgYABJI/C1TAbg0GkWSO8V8U0DfnHObzl6eB8CVTrzAXd/fLOtjK42J1BDotXOiZ0jno70tQfqcUB0RdSx5jXO4SeW1rH4JYl5Nq68a6/C6BeUAOv77U4ID+BENAoCOVqrl/vfOJ8ka/xgn6ItLY0nIyDsNAJ8RyY0OIDJukudO80LO0bt2jSk0iDeA92/wLy8VMPoosgaRVaAHTkJzmHcRQMQ3indqVs6ppMzcwUm4e62y5qh5VkTHTxEMvCbPuju6+TfJ/W9SizfMwGjp8AEQf6FGAPleo/GYLMB4RgzlDW2SikOgK42eTSNaWb94oG9DEi2elygAlhpkoYE8ZcQ9jlYHjXyAnKeP/NJxDluXFe7xCYKB1+TZ8Keb/5DcKUgIrGNIfJx6mFY1RVr4OzCfAJyA+ayAsZGJ4holesXOeHaLIoWTW+zUBP18dCtU4/EizSqOiuoB6c3M/s/6NTxdPaeNjBUYPjQ2R8aHr5ZC8tWOm0vXYx40Ap/YtHJ5Ef1YbhUkWgPLqjZ5L+XgmG+A+Q6Yb0DlDpAThO4BHlWjyFlNLx++66ZXAktkZXimn+40ob4mt6Qnsi8ygclrS++mRaMtpPm8NbFak0qfhUTKiA+lPlrc4ggpN6Byq+lDw02QcvJSoWPajslvbkDDEe9cxvHN5OUMyAgiWg8eABkQ4wfmO2C6AYbvqjnoO2getEA23wMoRiRhmDDTLbRRT9DRtPeLTX/rmLgkfVxjUUhhBSD+/BrnyRCag4oD4SYaPw1qPsX++CVSSchHB3p2Lh1/Cs3h8mIAoZtfSU5/CuSo74XT9FrlqNO6zUbqpgPA36H2MEELQyVPTGQfWtxkjXz/NK/oinjfsajn26WOxHyBOb7xxcj4L8Dha/VeRTaupawPXrHE+MpPBA7gJTUIADr+k3D6UyA2iUouQsd5TogRmEcIBstN0pcoRKkHLCBuS4lCRNPHRT/3KuaSbKr1t5eCKNnM2qLF1SnKINrm7NDaxInfxbk+TXcJzkExRNa5xk3KqfoKOugIQDr8Ah0+e4uYnoCOwHCwkj1WR/eDFl54jry4j47sIWq93wMg9oLYPB9eLoZGEDl5NC/XTKiT9PhUwsW0kcdOnLAXCyLmKJpuNJVFuta2eMNNuvkKYq41iTWv8kNNSC6hMjf4CuBqLqUfIIRWzZ1DjU0N0LEAneYYv4DGrxAfHjv+Q/OrDl8B+gIab42XHAEcIIMR+Z8QGC6v5sSmwz+JAMj5D9HYR5qligAgg8M8XZTckHwAZredz9Bpqn1QltkWVljNpSGwoWmyNwzoK0m8+PiP3vO0+LxXEQ/9PaEWz0uACU3ozooSz5HS7LFUDtVksuGxdaBTyq0qX4DxxmIb2pHRzc9lTq3Jq0d56PAvrR7vL3oE2jRcd9lmgJhnK+ImBhDxInWmSShPTuhLF0OBg8haXo6jJHdxuuKru8+Wq8HMToN4449rKN1xQvA4uFMkzUPu5pUT7Rg/7ksf/Lupf//JsnJ/VN4kDFoO/yQ5f5OlqeBmgHm6fF6S6QaQk675Xof1yhnUAMWH9KZESEnR+PAAcQWIAK2LGGiLNPT+YSwB8qAJ1e02FlzrdVr9XeMRZkeZCWX7UXrHtIWkCoc0gIJvHMO0ogCIm1ieOuKR8jQScDiADv/ZgZHkzfIEyGYSkrv/ir9oolET3dhI5OQp1neqQYoWh9BgolZUITnrtkxp7fWDp/SLCg5xdzFE4wgEuJahPhswtlMD7jXMGp6yXIphACtxjHySBz7zl5Yax/BJMj2xsNi6qXI4wuvjquZIc72UW3PfmhvX860i+HcEHXaTqpc3T6ShctD2MBYNEjrf8Bc730DKLcAnyOwAOdlyD4iZXB5cFP9sBih5tASARfaj0QdY/GJMwSSCf5UfxDlJFoDoDnQaRNbOWaAugcJT0GElXmP2YXN04IAaADw0DT7SQsx8otG9VDm2oR6rHRzr8vYAOf5q5pbzjaIAYS9leaygmG+qBuGTbd+1gGFvRGf9AabUABNHEVo2zAJt4NeGMvRt+anDHvLf55jnqiQzKqehowJCAeKpIqO5b3M5nlRAevSx4g6UmwoMSsD6yWIbT5F3ScWkPHHj/e8SleJzvITP0OJ0DoR7YLjXYKOBRmbTQN6IYF4yz1SNnD4vrN0N1Fpwjkvt5IJdteqxvebG6jmIxy46rUGqMajkOf/6obB5JrA0m9P4RSPiAZDbAJHGNw6qaVwLfdJxHC8l756rHK7Ek8dNDsB80NKm5QgqJwgbcDgRebZekMfq9ZotdVtGgMwLBi9LlGbHcrG5xOtAK3OfRqxCsAg9XuMkAHqAtFOWAdRwEPPkOeHWud6QJ6XRucQ7jUEHYDBNEuaUzcsRlQ27qQgGn9jGOpWfOLbxFHl3gIT4Czt53GQEWeMnHi2p8VDNDN+ebVYjPiXwuAl2BlEGiGsRE3UbpEbuXCUFGRu3MJ4MkMaNtajmZrWPMxF3U8rBUQ7mnUrF26Khu/bIE6+6y/ZW4xoxV4c9yx0YT5LtAMTl+C9NV4kSNDYKkZ3U+6CrQ+1pHSBsdYKdxPNZ9226hjrSMY8xaYONFSCXAnoPAKTfl6Sd0G+nQCkSOGjQHt/zn1KyYUwp4IAJgBwSQI4AtbWq9qDfj8n2AALUXu7+dxEulpJiEXWfn4LPVWMM9y0o+iUA4vGTlLLSLU1JnGV1NTwIkFXE2DEqZrKV2G/iGgF4BYjP9kVuFjmxprQ/1LgHRWnQA0BKxqkcd57xDKHlmOhtiZz+FOEJwATMdeoFsNYJlgDGpLxF/DONkwhPS4CkohENYKw0UXAVYbPCkvtpVWNcJvt1cJfHfkgbt+ia4LyjtACxSTF1GEHNXwsO0ewfVPtkd6+ZYZ+1mMJbyeYBAgBy+iYAW6OfDCCsAPBA4WxzuXspVJ7tc5vThBkkEwS2D+l4CdvfSwVNAGUt8dFkAZA+W6DlGKENxfe9oXcapBziMyoWA3FweCJigMoChz5DsWmXnW88Xz4EQFzk9E1q1NwbtJcX0tQTcS1hGoPS55IBA241SwCE0XAVrJlcSRqA5CovdrwByFABYdFwCtNpRYM0ACFE9Dy+j5I2ydtD60rf5YflQwEk5PwtCkVobNrnJWFIAk8F0mQaZ7Lp40zLuPZhyxTmqQPIDMlAWUsTWWiQDBIyzaBcg6LhjwEGyiZSuHeHBkxUPL7j0fWO3NuUc3uC4cvLxwTIFZHTHxK1ubyIHaoGAU/GW1IulydBsmsQ0yhsAGGfvfchDZIBYusFQA4R14jkQjoAQwcQaPIhhUlFe+ziHeTTAWQhpz+Vv8ys5hcbb3kSQLLXqxPqd64BZGyAUQGS0tNpULBg2DnEBuTzAySJnP6UKIUaAHFOYpMA9RxEOhPrqlAygXStY50MIME7xsoxctoHBtDN7nXakvxUAMki938kwl8BIQ0gPNHxWuCwE+o4SDO1wJA8V5WT7HGK7cpPC5As4maYu3Sb+TQyMB7zrFa8WBksHizczacPITtAnirnbw8/sN3F+mlkB8guu1yRzznryS67vJD8f6iOLdZV+G0UAAAAAElFTkSuQmCC",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-tier-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-name",
                                            children: "Gold"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "cert-tier-sub",
                                            children: "Fully de-risked"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-lock",
                                    children: "\uD83D\uDD12"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "cert-footer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cert-count",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "cert-count-num",
                                    children: "10"
                                }),
                                "issues resolved so far"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "cert-callout",
                            children: "Only 3 more questions to answer to reach Gold"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "cert-note",
                    children: "Answer a few more questions in Review & Refine, then resolve any flagged risks, to reach Gold and go into a sale with nothing left for a buyer to find."
                })
            ]
        }),
        diligence: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "diligence-block",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dblock-head",
                            children: "Prospective purchasers querying Kestrel Logistics' pack"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "access-mini2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Purchaser"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Access"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Tools"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                            children: "Status"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-name",
                                                    children: "Purchaser 1"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-sub",
                                                    children: "3 queries so far"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Full pack"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Internal tools only"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "status-pill viewed",
                                                children: "Viewed"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-name",
                                                    children: "Purchaser 2"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-sub",
                                                    children: "5 queries so far"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Full pack"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "External MCP link"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "status-pill mcp",
                                                children: "AI connected"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-name",
                                                    children: "Purchaser 3"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "am-sub",
                                                    children: "Not yet opened"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Summary only"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: "Internal tools only"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "status-pill pending",
                                                children: "Pending"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dblock-note",
                            children: "Every prospective purchaser sees the same evidence-backed pack \u2014 so no bidder can price-chip you on an inconsistency between what different buyers were told."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '8px',
                        marginTop: '12px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            id: "purchProgressBtn",
                            style: {
                                flex: '1',
                                border: 'none',
                                background: 'var(--green)',
                                color: '#fff',
                                fontSize: '11px',
                                fontWeight: '800',
                                padding: '9px 10px',
                                borderRadius: '9px',
                                cursor: 'pointer'
                            },
                            children: "Purchaser makes an offer \u2192"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            type: "button",
                            id: "purchRejectBtn",
                            style: {
                                flex: '1',
                                border: '1.5px solid #f3c2c2',
                                background: '#fdeaea',
                                color: '#a12b2b',
                                fontSize: '11px',
                                fontWeight: '800',
                                padding: '9px 10px',
                                borderRadius: '9px',
                                cursor: 'pointer'
                            },
                            children: "Purchaser walks away"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "purchOutcome",
                    style: {
                        display: 'none',
                        marginTop: '10px',
                        fontSize: '10.5px',
                        fontWeight: '700',
                        padding: '9px 11px',
                        borderRadius: '9px'
                    }
                })
            ]
        })
    }
};
const $9b33bb7066f3abbf$export$617b4b8c3db9ac89 = (journey, key)=>{
    if (!key) return null;
    const own = $9b33bb7066f3abbf$var$JOURNEY_VISUALS[journey] || {};
    return own[key] || $9b33bb7066f3abbf$var$SHARED_VISUALS[key] || null;
};
var $9b33bb7066f3abbf$export$2e2bcd8739ae039 = $9b33bb7066f3abbf$export$617b4b8c3db9ac89;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

const $6641f482f998b426$export$dbd3d24e1fa95fb7 = 'dlg-journey-gate-passed';
const $6641f482f998b426$export$26b5c6381583867 = 'dlg-journey-gate-watermark';
// Common free/personal providers — not exhaustive, but covers the overwhelming majority of real
// personal addresses. Extend by adding the domain, lowercase, no leading "@".
const $6641f482f998b426$var$PERSONAL_EMAIL_DOMAINS = [
    'gmail.com',
    'googlemail.com',
    'yahoo.com',
    'yahoo.co.uk',
    'yahoo.co.in',
    'ymail.com',
    'rocketmail.com',
    'hotmail.com',
    'hotmail.co.uk',
    'outlook.com',
    'live.com',
    'live.co.uk',
    'msn.com',
    'icloud.com',
    'me.com',
    'mac.com',
    'aol.com',
    'protonmail.com',
    'proton.me',
    'pm.me',
    'mail.com',
    'gmx.com',
    'gmx.co.uk',
    'zoho.com',
    'yandex.com',
    'yandex.ru',
    'qq.com',
    '163.com',
    '126.com'
];
const $6641f482f998b426$var$FIELDS = [
    {
        name: 'firstName',
        label: 'First name',
        type: 'text',
        autoComplete: 'given-name'
    },
    {
        name: 'lastName',
        label: 'Last name',
        type: 'text',
        autoComplete: 'family-name'
    },
    {
        name: 'email',
        label: 'Work email address',
        type: 'email',
        autoComplete: 'email',
        full: true,
        hint: "Please use your company email \u2014 not a personal address (Gmail, Yahoo, etc.)"
    },
    {
        name: 'title',
        label: 'Job title',
        type: 'text',
        autoComplete: 'organization-title'
    },
    {
        name: 'company',
        label: 'Company',
        type: 'text',
        autoComplete: 'organization'
    }
];
const $6641f482f998b426$var$EMPTY = {
    firstName: '',
    lastName: '',
    email: '',
    title: '',
    company: ''
};
const $6641f482f998b426$var$isPersonalEmail = (email)=>{
    const domain = email.split('@')[1];
    return !!domain && $6641f482f998b426$var$PERSONAL_EMAIL_DOMAINS.includes(domain.trim().toLowerCase());
};
/**
 * Records the access request — the server emails the details to the team and returns the caller's
 * IP for the watermark. Resolves to a placeholder on any failure so the visitor is never blocked
 * by a mail or network problem.
 *
 * @param {object} data - the submitted form values
 * @returns {Promise<string>} the caller's IP, or 'IP unavailable'
 */ const $6641f482f998b426$var$recordEntry = (data)=>fetch(`${(0, $6a6b4b5ab5be324d$export$61abde59b50deb8e)}/api/sandbox/entry`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...data,
            source: 'Companies 2-minute demo'
        }),
        cache: 'no-store'
    }).then((r)=>r.json()).then((j)=>j && j['body'] && j['body']['ip'] || 'IP unavailable').catch(()=>'IP unavailable');
const $6641f482f998b426$var$formatWatermark = (data, ip)=>{
    const stamp = `${new Date().toISOString().slice(0, 16).replace('T', ' ')} UTC`;
    return `${data['email']}   \xb7   ${ip}   \xb7   ${stamp}`;
};
/**
 * @param {function} onPass  - called with the watermark string once the form validates
 * @param {function} onClose - called when the visitor dismisses the gate
 */ const $6641f482f998b426$var$JourneyGate = ({ onPass: onPass, onClose: onClose })=>{
    const [values, setValues] = (0, $acw62.useState)($6641f482f998b426$var$EMPTY);
    const [error, setError] = (0, $acw62.useState)('');
    const [isBusy, setIsBusy] = (0, $acw62.useState)(false);
    const firstFieldRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (firstFieldRef.current) firstFieldRef.current.focus();
        const onKeyDown = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        return ()=>document.removeEventListener('keydown', onKeyDown);
    }, [
        onClose
    ]);
    const setField = (name)=>(e)=>setValues({
                ...values,
                [name]: e['target']['value']
            });
    const handleSubmit = (e)=>{
        e.preventDefault();
        const data = Object.keys($6641f482f998b426$var$EMPTY).reduce((acc, k)=>({
                ...acc,
                [k]: (values[k] || '').trim()
            }), {});
        if (!Object.values(data).every((v)=>v.length > 0) || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data['email'])) return setError('Please fill in every field with a valid email address.');
        if ($6641f482f998b426$var$isPersonalEmail(data['email'])) return setError("Please use your work email address \u2014 personal addresses (Gmail, Yahoo, etc.) aren't accepted.");
        setError('');
        setIsBusy(true);
        $6641f482f998b426$var$recordEntry(data).then((ip)=>onPass($6641f482f998b426$var$formatWatermark(data, ip)));
    };
    // Portalled to <body>: the demo panel sits inside a sticky, overflow:hidden section, and later
    // sections on the page open their own stacking contexts — so a z-index inside the panel is not
    // enough and page content paints over the card. The wrapper re-applies .dlg-journey-demo so the
    // scoped selectors and the panel's CSS variables still reach the gate.
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "dlg-journey-demo jd-gate-portal",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "jd-gate",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": "Before you dive in",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "jd-gate-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "jd-gate-close",
                        "aria-label": "Close",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            viewBox: "0 0 14 14",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M1 1l12 12M13 1L1 13",
                                stroke: "currentColor",
                                strokeWidth: "1.8",
                                strokeLinecap: "round"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "jd-gate-brand",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "26",
                                height: "26",
                                viewBox: "0 0 26 26",
                                fill: "none",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M2 16L8 8L13 14L24 2",
                                        stroke: "#FB7785",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M2 20L9 12L14 18L24 6",
                                        stroke: "#4A67FF",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Diligentsia"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "jd-gate-title",
                        children: "Before you dive in"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "jd-gate-sub",
                        children: "This is a live interactive sandbox of the Diligentsia deal workspace. Tell us a little about you and it's all yours. 2 minute demo."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        className: "jd-gate-form",
                        onSubmit: handleSubmit,
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "jd-gate-only-inputs",
                                children: "Your only inputs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "jd-gate-grid",
                                children: $6641f482f998b426$var$FIELDS.map((f, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: `jd-gate-field${f['full'] ? ' is-full' : ''}`,
                                        children: [
                                            f['label'],
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                ref: i === 0 ? firstFieldRef : undefined,
                                                type: f['type'],
                                                value: values[f['name']],
                                                autoComplete: f['autoComplete'],
                                                onChange: setField(f['name'])
                                            }),
                                            f['hint'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "jd-gate-hint",
                                                children: f['hint']
                                            })
                                        ]
                                    }, f['name']))
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "jd-gate-error",
                                children: error
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "submit",
                                className: "jd-gate-submit",
                                disabled: isBusy,
                                children: isBusy ? "Just a moment\u2026" : "Enter the sandbox \u2192"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "jd-gate-notice",
                        children: [
                            "\uD83D\uDD12 For security, every screen in this sandbox is watermarked with your email address, IP address, and access time. Please don't screenshot or share outside your organisation.",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "jd-gate-copyright",
                                children: "\xa9 2026 Diligentsia Limited. All rights reserved. Unauthorised reproduction or distribution of this content is prohibited."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "jd-gate-footnote",
                        children: [
                            "Sample data only \u2014 nothing you do in the sandbox affects a real deal. See our ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "/policy-privacy",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "privacy policy"
                            }),
                            "."
                        ]
                    })
                ]
            })
        })
    }), document.body);
};
var $6641f482f998b426$export$2e2bcd8739ae039 = $6641f482f998b426$var$JourneyGate;


var $528cff1d73fd70a2$exports = {};
$528cff1d73fd70a2$exports = new URL("diligentsia.ff820755.png", import.meta.url).toString();


var $872e2d8305952d90$exports = {};
$872e2d8305952d90$exports = new URL("clarence-transparent.88cf0204.png", import.meta.url).toString();


const $9d9e846cf98fabc1$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $9d9e846cf98fabc1$var$INTRO = -1; // the "Which journey fits you?" cover; 0..n-1 are the walkthrough steps
/**
 * Builds the tiled, diagonal watermark as an SVG data URI, matching the VC sandbox's tile. The
 * colour is baked in, so the fill is the light-theme value — the demo panel is always light.
 *
 * @param {string} text - "email · ip · timestamp"
 * @returns {string} a data: URI for use as background-image
 */ const $9d9e846cf98fabc1$var$watermarkTile = (text)=>{
    const tileW = 420, tileH = 210;
    const safe = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${tileW}" height="${tileH}">` + `<text x="${tileW / 2}" y="${tileH / 2}" transform="rotate(-24 ${tileW / 2} ${tileH / 2})" ` + 'text-anchor="middle" dominant-baseline="middle" font-family="Poppins, Arial, sans-serif" ' + `font-size="12" fill="rgba(60,64,90,0.22)">${safe}</text></svg>`;
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
};
/** sessionStorage is unavailable in some privacy modes, so every access is guarded. */ const $9d9e846cf98fabc1$var$readSession = (key)=>{
    try {
        return sessionStorage.getItem(key);
    } catch (e) {
        return null;
    }
};
const $9d9e846cf98fabc1$var$writeSession = (key, value)=>{
    try {
        sessionStorage.setItem(key, value);
    } catch (e) {}
};
/**
 * The 2-minute demo — "Which journey fits you?" plus all three walkthroughs.
 *
 * The handoff shipped one HTML file per journey, where picking a different card navigated to
 * another file. Here all three live in one component, so selecting a card just swaps the active
 * journey in place and resets to the cover.
 */ const $9d9e846cf98fabc1$var$JourneyDemo = ()=>{
    const [journey, setJourney] = (0, $acw62.useState)(1);
    const [current, setCurrent] = (0, $acw62.useState)($9d9e846cf98fabc1$var$INTRO);
    // Which utility row is open beneath the tracker: 'time', 'cost', or neither.
    const [activeUtil, setActiveUtil] = (0, $acw62.useState)(null);
    // The lead-capture gate stands between the cover and the first step. Passing it watermarks the
    // panel for the rest of the browser session, matching the VC sandbox.
    const [isGateOpen, setIsGateOpen] = (0, $acw62.useState)(false);
    const [watermark, setWatermark] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if ($9d9e846cf98fabc1$var$readSession((0, $6641f482f998b426$export$dbd3d24e1fa95fb7)) === '1') setWatermark($9d9e846cf98fabc1$var$readSession((0, $6641f482f998b426$export$26b5c6381583867)) || '');
    }, []);
    const isUnlocked = !!watermark;
    const data = (0, $7e4e66f8a07acc7a$export$372ccd13f5108d46)[journey];
    const steps = data['steps'];
    const isIntro = current === $9d9e846cf98fabc1$var$INTRO;
    const step = isIntro ? null : steps[current];
    const lastIndex = steps.length - 1;
    // Re-selecting the same card is a no-op; switching journeys restarts at the cover.
    const chooseJourney = (n)=>{
        if (n === journey) return;
        setJourney(n);
        setCurrent($9d9e846cf98fabc1$var$INTRO);
    };
    // Leaving the cover is what starts the journey, so that is where the gate sits. Once passed it
    // stays passed for the session, including after a restart back to the cover.
    const onNext = ()=>{
        if (isIntro && !isUnlocked) return setIsGateOpen(true);
        setCurrent(current === lastIndex ? $9d9e846cf98fabc1$var$INTRO : current + 1);
    };
    const onGatePass = (wm)=>{
        $9d9e846cf98fabc1$var$writeSession((0, $6641f482f998b426$export$dbd3d24e1fa95fb7), '1');
        $9d9e846cf98fabc1$var$writeSession((0, $6641f482f998b426$export$26b5c6381583867), wm);
        setWatermark(wm);
        setIsGateOpen(false);
        setCurrent(0);
    };
    const onBack = ()=>{
        if (current > $9d9e846cf98fabc1$var$INTRO) setCurrent(current - 1);
    };
    const toggleUtil = (key)=>setActiveUtil(activeUtil === key ? null : key);
    const visual = (0, $acw62.useMemo)(()=>isIntro ? null : (0, $9b33bb7066f3abbf$export$617b4b8c3db9ac89)(journey, step['visual']), [
        isIntro,
        journey,
        step
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "dlg-journey-demo",
        children: [
            isGateOpen && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6641f482f998b426$export$2e2bcd8739ae039), {
                onPass: onGatePass,
                onClose: ()=>setIsGateOpen(false)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "browser",
                children: [
                    isUnlocked && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "jd-watermark",
                        "aria-hidden": "true",
                        style: {
                            backgroundImage: `url("${$9d9e846cf98fabc1$var$watermarkTile(watermark)}")`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "chrome",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "dots",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "url",
                                children: "app.diligentsia.co.uk/how-it-works"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "sample-tag",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "d"
                                    }),
                                    "Quick walkthrough"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "topnav",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "brand",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "mark",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: $528cff1d73fd70a2$exports,
                                            alt: "Diligentsia"
                                        })
                                    }),
                                    "Diligentsia"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    marginLeft: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    gap: '5px'
                                },
                                children: [
                                    !isIntro && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "journey-badge",
                                        style: {
                                            marginTop: 0
                                        },
                                        children: data['badge']
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "subtitle",
                                        style: {
                                            marginLeft: 0
                                        },
                                        children: "Clarence will explain each step as you go"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "head",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "eyebrow",
                                children: isIntro ? 'Getting Started' : 'Your journey'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: isIntro ? 'Which journey fits you?' : (0, $7e4e66f8a07acc7a$export$2142ca635aaed20d)[journey]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: isIntro ? "We offer a number of bespoke company journeys \u2014 pick the one that matches where you are today." : `Step ${current + 1} of ${steps.length} \u{2014} ${step['title'].split(" \xb7 ")[1]}`
                            })
                        ]
                    }),
                    !isIntro && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "util-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: `util-btn${activeUtil === 'time' ? ' active' : ''}`,
                                onClick: ()=>toggleUtil('time'),
                                children: "Estimated Time"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                type: "button",
                                className: `util-btn${activeUtil === 'cost' ? ' active' : ''}`,
                                onClick: ()=>toggleUtil('cost'),
                                children: "Cost"
                            })
                        ]
                    }),
                    !isIntro && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tracker",
                        children: steps.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `tstep${i === current ? ' active' : ''}${i < current ? ' done' : ''}`,
                                onClick: ()=>isUnlocked ? setCurrent(i) : setIsGateOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tline"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tfree",
                                        style: i === 0 ? undefined : {
                                            visibility: 'hidden'
                                        },
                                        children: "Free"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tcircle",
                                        children: i + 1
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tlabel",
                                        children: s['title'].split(" \xb7 ")[1]
                                    })
                                ]
                            }, s['title']))
                    }),
                    !isIntro && activeUtil === 'time' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "time-row",
                        style: {
                            display: 'flex'
                        },
                        children: data['timeEstimates'].map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `time-chip${t['variable'] ? ' variable' : ''}${t['free'] ? ' free' : ''}`,
                                children: t['label']
                            }, i))
                    }),
                    !isIntro && activeUtil === 'cost' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cost-bar",
                                style: {
                                    display: 'block'
                                },
                                children: data['costBar']
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "cost-note",
                                style: {
                                    display: 'block'
                                },
                                children: data['costNote']
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "stage",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "clarence-panel",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "clarence-char",
                                        src: $872e2d8305952d90$exports,
                                        alt: "Clarence"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "right-col",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: `step-visual${isIntro || visual ? ' show' : ''}${isIntro ? ' is-cover' : ''}`,
                                                children: isIntro ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "vw-label",
                                                            children: "Choose your journey"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "journey-cards",
                                                            children: (0, $7e4e66f8a07acc7a$export$6ba6058b278c7af1).map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: `journey-card${journey === c['n'] ? ' selected' : ''}`,
                                                                    onClick: ()=>chooseJourney(c['n']),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "jc-num",
                                                                            children: c['n']
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "jc-title",
                                                                            children: c['title']
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "jc-desc",
                                                                            children: c['desc']
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "jc-radio-row",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                    type: "radio",
                                                                                    name: "journeySelect",
                                                                                    value: c['n'],
                                                                                    checked: journey === c['n'],
                                                                                    onChange: ()=>chooseJourney(c['n'])
                                                                                }),
                                                                                "Select this journey"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, c['n']))
                                                        })
                                                    ]
                                                }) : visual
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "jd-bubble show",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "jd-bubble-tag",
                                                        children: isIntro ? 'Before we begin' : `Step ${current + 1} of ${steps.length}`
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        children: isIntro ? `Selected: ${(0, $7e4e66f8a07acc7a$export$2142ca635aaed20d)[journey]}` : step['title'].split(" \xb7 ")[1]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        children: isIntro ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    children: "Hi, I'm Clarence, our AI Manager. Let me explain your journey in 2 minutes."
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: data['introMessage']
                                                                    }
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: step['text']
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "nav-row",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: "btn ghost",
                                        onClick: onBack,
                                        disabled: isIntro,
                                        children: "\u2190 Back"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "progress-dots",
                                        children: steps.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `${!isIntro && i === current ? 'active' : ''}${!isIntro && i < current ? ' done' : ''}`.trim()
                                            }, s['title']))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "button",
                                        className: "btn primary",
                                        onClick: onNext,
                                        children: current === lastIndex ? "Restart from the top \u21BA" : "Next \u2192"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "footer-note",
                        children: [
                            "This is a ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "live interactive sandbox"
                            }),
                            " \u2014 nothing you click here affects real data.",
                            ' ',
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: $9d9e846cf98fabc1$var$KOALENDAR,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Book a call"
                            }),
                            " to see the full experience for your own company."
                        ]
                    })
                ]
            })
        ]
    });
};
var $9d9e846cf98fabc1$export$2e2bcd8739ae039 = $9d9e846cf98fabc1$var$JourneyDemo;



const $65d09bf35a1d8357$var$IconBolt = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
            points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
        })
    });
const $65d09bf35a1d8357$var$IconTrend = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "23 6 13.5 15.5 8.5 10.5 1 18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "17 6 23 6 23 12"
            })
        ]
    });
const $65d09bf35a1d8357$var$IconClock = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "12 6 12 12 16 14"
            })
        ]
    });
const $65d09bf35a1d8357$var$IconBars = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "18",
                y1: "20",
                x2: "18",
                y2: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "20",
                x2: "12",
                y2: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "20",
                x2: "6",
                y2: "14"
            })
        ]
    });
const $65d09bf35a1d8357$var$IconShield = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
        })
    });
const $65d09bf35a1d8357$var$IconUsers = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M23 21v-2a4 4 0 0 0-3-3.87"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16 3.13a4 4 0 0 1 0 7.75"
            })
        ]
    });
const $65d09bf35a1d8357$var$IconAlert = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "8",
                x2: "12",
                y2: "12"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "16",
                x2: "12.01",
                y2: "16"
            })
        ]
    });



const $65d09bf35a1d8357$var$TABS = [
    {
        key: 'investment',
        label: 'Investment Ready',
        img: (parcelRequire("jm5NV")),
        width: '50%',
        h: 'Arrive with the pack that lets an investor say yes.',
        p: "Most founders invest months on the pitch and days on the corporate picture. Diligentsia fixes the asymmetry \u2014 governance, IP, cap table, financials, all structured before you need them.",
        feats: [
            {
                Icon: $65d09bf35a1d8357$var$IconBolt,
                t: 'Close your round faster',
                d: 'Structured packs cut information requests. Rounds stall on paperwork, not the business case.'
            },
            {
                Icon: $65d09bf35a1d8357$var$IconTrend,
                t: 'Protect your valuation',
                d: "A 10% uplift on a \xa31m round is \xa3100k in your pocket. On a \xa35m round, \xa3500k."
            },
            {
                Icon: $65d09bf35a1d8357$var$IconClock,
                t: 'Start before the call comes',
                d: "Build it now. When interest arrives, you're ready in hours, not weeks."
            }
        ]
    },
    {
        key: 'growth',
        label: 'Growth Ready',
        img: (parcelRequire("b6j5K")),
        width: '100%',
        h: "Let's now help you turbo boost your growth and value",
        p: 'Diligentsia provides you a set of tools to systematically go through your business and quickly improve and create value.',
        feats: [
            {
                Icon: $65d09bf35a1d8357$var$IconBars,
                t: '20x Healthboost Modules',
                d: 'Use our AI capabilities to systematically identify areas of value add across your business'
            },
            {
                Icon: $65d09bf35a1d8357$var$IconShield,
                t: 'Fix commercial gaps early ',
                d: 'Use our 200+ specialist AI agents to analyse your business across 20 areas and identify gaps and weaknesses. And then we help you fix them.'
            },
            {
                Icon: $65d09bf35a1d8357$var$IconUsers,
                t: 'Harness our specialist partners',
                d: 'AdvisorMatch with 80+ advisors, or the AppStore partners integrated into our paltform.'
            }
        ]
    },
    {
        key: 'exit',
        label: 'Exit Ready',
        img: (parcelRequire("5I4PL")),
        width: '100%',
        h: "Don\u2019t allow your exit value to be chipped by 10%.",
        p: "Most exits don't fail. They get chipped \u2014 by surprises that were entirely preventable.",
        callout: {
            big: "\xa31,000,000",
            text: "value of a 10% improvement in exit preparation on a \xa310M sale. Against \xa31,000/year \u2014 one of the highest-return decisions a founder can make."
        },
        iconVariant: 'alert',
        feats: [
            {
                Icon: $65d09bf35a1d8357$var$IconAlert,
                t: 'Use our 200 AI agents to get you exit ready',
                d: 'Comprehensive diligence pack, research reports, and detailed gap analysis'
            },
            {
                Icon: $65d09bf35a1d8357$var$IconAlert,
                t: 'Use the AI diligence tools we provide your buyers',
                d: 'Reverse diligence yourself with the ai diligence tools we offer buyers before you go out to market'
            },
            {
                Icon: $65d09bf35a1d8357$var$IconAlert,
                t: 'You can now go out to the market with confidence',
                d: 'You should now be in a position to push back on chipping'
            }
        ]
    }
];
// The demo is a scroll stop like the other three, but has no TABS entry — it renders the
// interactive walkthrough instead of the copy/art panel.
const $65d09bf35a1d8357$var$DEMO_KEY = 'demo';
const $65d09bf35a1d8357$var$KEYS = [
    ...$65d09bf35a1d8357$var$TABS.map((t)=>t.key),
    $65d09bf35a1d8357$var$DEMO_KEY
];
const $65d09bf35a1d8357$var$CompaniesLifecycleSection = ()=>{
    const [active, setActive] = (0, $acw62.useState)('investment');
    const [progress, setProgress] = (0, $acw62.useState)(0); // 0..1 through the scroll wrapper
    const wrapRef = (0, $acw62.useRef)(null);
    const compute = (0, $acw62.useCallback)(()=>{
        const wrap = wrapRef.current;
        if (!wrap) return;
        const wTop = wrap.getBoundingClientRect().top + window.scrollY;
        const range = wrap.offsetHeight - window.innerHeight;
        if (range <= 0) {
            setProgress(0);
            return;
        }
        const scrolled = Math.max(0, Math.min(window.scrollY - wTop, range));
        const p = scrolled / range;
        setProgress(p);
        // Four evenly-spaced stops — the demo is the last one, not a special case.
        const key = p >= 0.75 ? 'demo' : p >= 0.5 ? 'exit' : p >= 0.25 ? 'growth' : 'investment';
        setActive((prev)=>prev === key ? prev : key);
    }, []);
    (0, $acw62.useEffect)(()=>{
        compute();
        window.addEventListener('scroll', compute, {
            passive: true
        });
        window.addEventListener('resize', compute, {
            passive: true
        });
        return ()=>{
            window.removeEventListener('scroll', compute);
            window.removeEventListener('resize', compute);
        };
    }, [
        compute
    ]);
    const goTo = (key)=>{
        const wrap = wrapRef.current;
        if (!wrap) return;
        const wTop = wrap.getBoundingClientRect().top + window.scrollY;
        const range = wrap.offsetHeight - window.innerHeight;
        const idx = $65d09bf35a1d8357$var$KEYS.indexOf(key);
        const target = idx <= 0 ? 0 : idx / ($65d09bf35a1d8357$var$KEYS.length - 1);
        window.scrollTo({
            top: wTop + target * range,
            behavior: 'smooth'
        });
    };
    const tab = $65d09bf35a1d8357$var$TABS.find((t)=>t.key === active) || $65d09bf35a1d8357$var$TABS[$65d09bf35a1d8357$var$TABS.length - 1];
    const barWidth = Math.max(4, Math.round(progress * 100));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "lifecycle",
        className: "lp-life-scroll",
        ref: wrapRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
            className: "lp-life-sticky",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-life-bar",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-life-tabs",
                            role: "tablist",
                            children: [
                                $65d09bf35a1d8357$var$TABS.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        role: "tab",
                                        className: `lp-life-tab ${t.key === active ? 'is-active' : ''}`,
                                        onClick: ()=>goTo(t.key),
                                        children: t.label
                                    }, t.key)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    type: "button",
                                    role: "tab",
                                    className: `lp-life-tab ${active === $65d09bf35a1d8357$var$DEMO_KEY ? 'is-active' : ''}`,
                                    onClick: ()=>goTo($65d09bf35a1d8357$var$DEMO_KEY),
                                    children: "2-minute demo"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-life-track",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-life-progress",
                                style: {
                                    width: barWidth + '%'
                                }
                            })
                        })
                    ]
                }),
                active === $65d09bf35a1d8357$var$DEMO_KEY ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-life-content lp-life-demo",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d9e846cf98fabc1$export$2e2bcd8739ae039), {})
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-life-content",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-life-panel",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "c",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        children: tab.h
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "lead",
                                        children: tab.p
                                    }),
                                    tab.callout && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "lp-life-callout",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "big",
                                                children: tab.callout.big
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: tab.callout.text
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-life-feats",
                                        children: tab.feats.map(({ Icon: Icon, t: t, d: d }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-life-feat",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `lp-fi ${tab.iconVariant === 'alert' ? 'lp-fi--alert' : ''}`,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "ft",
                                                                children: t
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "fd",
                                                                children: d
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "lp-btn lp-btn--primary",
                                        to: `${$16250bd714b02a14$export$bcdbe1127ca0dc8c}?journey=${active}#whats-included`,
                                        children: "See what's included"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-life-art",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: tab.img,
                                    alt: tab.label,
                                    style: {
                                        width: tab.width,
                                        marginTop: tab.label === 'Investment Ready' ? '100px' : '0'
                                    }
                                })
                            })
                        ]
                    }, active)
                })
            ]
        })
    });
};
var $65d09bf35a1d8357$export$2e2bcd8739ae039 = $65d09bf35a1d8357$var$CompaniesLifecycleSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $226327b8001c1df2$var$STEPS = [
    {
        img: (parcelRequire("lka2d")),
        no: '01',
        t: 'Give us your documents',
        d: 'Upload your documents directly or via your cloud'
    },
    {
        img: (parcelRequire("lACR8")),
        no: '02',
        t: 'AI auto-fills upto 60%',
        d: 'Clarence (Our Agent Manager) interrogates your knowledge base and pre-populates answers where she can. Nothing published without your review.'
    },
    {
        img: (parcelRequire("2inU5")),
        no: '03',
        t: 'Certify and share',
        d: "Bronze, Silver, or Gold self-certification. Share your pack with controlled access \u2014 each counter party sees exactly what you choose and when."
    }
];
const $226327b8001c1df2$var$CompaniesHowItWorks = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "how-it-works",
        className: "lp-howto-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-eyebrow",
                "data-lp-reveal": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "lp-badge lp-badge--up",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                        "How it works"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-howto-head",
                "data-lp-reveal": true,
                "data-lp-delay": "60",
                children: "Scattered documents to certified pack \u2014 in 3 steps."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-howto",
                children: $226327b8001c1df2$var$STEPS.map(({ img: img, no: no, t: t, d: d }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-howstep",
                        "data-lp-reveal": true,
                        "data-lp-delay": i * 120,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-howstep-img",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: img,
                                    alt: t
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "no",
                                children: no
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: t
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: d
                            })
                        ]
                    }, i))
            })
        ]
    });
var $226327b8001c1df2$export$2e2bcd8739ae039 = $226327b8001c1df2$var$CompaniesHowItWorks;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $e7769479fb16d2e9$var$CompaniesPricingSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-pricing-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-eyebrow",
                "data-lp-reveal": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "lp-badge lp-badge--up",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                        "Pricing"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-h2",
                "data-lp-reveal": true,
                "data-lp-delay": "60",
                style: {
                    textAlign: 'center',
                    margin: '0 auto 10px',
                    maxWidth: 680
                },
                children: "Transparent. No hidden fees."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                "data-lp-reveal": true,
                style: {
                    textAlign: 'center',
                    color: '#5B6472',
                    fontSize: 17,
                    margin: '0 auto 44px'
                },
                children: "Costs less than a day of an advisor\u2019s time"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-pricing-grid lp-pricing-grid--4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-price",
                        "data-lp-reveal": true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lbl",
                                style: {
                                    color: '#00ee51'
                                },
                                children: "Free"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "amt",
                                children: "\xa30"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Readiness checklists, KPI suggestions, InvestorMatch fit score."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-price lp-price--lite",
                        "data-lp-reveal": true,
                        "data-lp-delay": "80",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lbl",
                                style: {
                                    color: '#00ee51'
                                },
                                children: "Lite"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "amt blue",
                                children: [
                                    "\xa38.25",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "per",
                                        children: " / mo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                style: {
                                    marginBottom: '5px'
                                },
                                children: "\xa399/yr*"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                children: "* billed annually"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Business Audit + Data Repository (20 sections each)."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-price lp-price--pro",
                        "data-lp-reveal": true,
                        "data-lp-delay": "160",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-price-badge",
                                children: "Popular"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lbl",
                                style: {
                                    color: '#00ff57'
                                },
                                children: "Pro"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "amt white",
                                children: [
                                    "\xa383.25",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "per",
                                        children: " / mo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                style: {
                                    marginBottom: '5px'
                                },
                                children: "\xa3999/yr*"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                children: "* billed annually"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Full platform \u2014 all modules, AI reports, self-certifications, InvestorMatch connections."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-price lp-price--dark",
                        "data-lp-reveal": true,
                        "data-lp-delay": "240",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lbl",
                                style: {
                                    color: '#fff'
                                },
                                children: "Portfolio Pro"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "amt",
                                children: [
                                    "\xa366.67",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "per",
                                        children: " / mo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                style: {
                                    marginBottom: '5px'
                                },
                                children: "\xa3800/yr*"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                children: "* billed annually"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "All Pro features \u2014 20% off via a Diligentsia partner introduction."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-price-note",
                "data-lp-reveal": true,
                children: "All prices exclude VAT. Portfolio Pro available via partner introduction. * billed annually"
            })
        ]
    });
var $e7769479fb16d2e9$export$2e2bcd8739ae039 = $e7769479fb16d2e9$var$CompaniesPricingSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $cfaf45e08ae16d72$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $cfaf45e08ae16d72$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $cfaf45e08ae16d72$var$QUOTES = [
    {
        q: "That's the minimum requirement for a data room \u2014 it helps me follow that structure and have it all in one place. Probably enough to start due diligence with an investor.",
        a: "\u2014 CEO, AI startup, active \xa31.5M seed round"
    },
    {
        q: 'A living, breathing data room that syncs with SharePoint to maintain continuous readiness.',
        a: "\u2014 Founder, medtech company"
    },
    {
        q: 'Proactive organisation to secure a higher valuation and prevent last-minute price chipping.',
        a: "\u2014 Advisor, company preparing for sale (April 2026)"
    },
    {
        q: "Putting a deal in front of a VC with the Diligentsia outputs alongside the deck. You've answered 60 questions they didn't even ask yet.",
        a: "\u2014 Fractional CFO, Diligentsia investor"
    },
    {
        q: "If you don't have a good data room \u2014 people get all hot and excited. And then they lose interest rapidly.",
        a: "\u2014 MD, accelerator incubator (May 2026)"
    }
];
const $cfaf45e08ae16d72$var$GLOWS = [
    {
        top: -110,
        left: -90,
        size: 480,
        c: 'rgba(252,119,133,0.42)'
    },
    {
        top: 20,
        right: -120,
        size: 540,
        c: 'rgba(74,103,255,0.40)'
    },
    {
        bottom: -150,
        left: '12%',
        size: 520,
        c: 'rgba(74,103,255,0.34)'
    },
    {
        bottom: -110,
        right: '6%',
        size: 420,
        c: 'rgba(252,119,133,0.32)'
    }
];
const $cfaf45e08ae16d72$var$pos = (v)=>v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v;
const $cfaf45e08ae16d72$var$CompaniesQuotesSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, page: page, pages: pages, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)($cfaf45e08ae16d72$var$QUOTES.length, {
        autoplayMs: 5500
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-quotes",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-quotes-bg",
                "aria-hidden": "true",
                children: $cfaf45e08ae16d72$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: $cfaf45e08ae16d72$var$pos(g.top),
                            bottom: $cfaf45e08ae16d72$var$pos(g.bottom),
                            left: $cfaf45e08ae16d72$var$pos(g.left),
                            right: $cfaf45e08ae16d72$var$pos(g.right),
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(78px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        children: "What founders and advisors say."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-arrows",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Previous quotes",
                                onClick: prev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cfaf45e08ae16d72$var$ChevronL, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Next quotes",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cfaf45e08ae16d72$var$ChevronR, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-slide-anim",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-track",
                            ref: trackRef,
                            children: $cfaf45e08ae16d72$var$QUOTES.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                    className: "lp-qcard",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": i % 3 * 120,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("figcaption", {
                                            children: item.a
                                        })
                                    ]
                                }, i))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-foot",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-dots",
                        style: {
                            margin: 0,
                            padding: 0
                        },
                        children: Array.from({
                            length: pages
                        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `lp-dot ${i === page ? 'is-active' : ''}`,
                                "aria-label": `Go to slide ${i + 1}`,
                                onClick: ()=>goTo(i)
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $cfaf45e08ae16d72$export$2e2bcd8739ae039 = $cfaf45e08ae16d72$var$CompaniesQuotesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $c5b280d91621a701$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $c5b280d91621a701$var$CompaniesCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "cta",
        className: "lp-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cta-card",
            "data-lp-reveal": true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cta-glow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Become the best-prepared company in the room."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "sub",
                            children: "Start free \u2014 no credit card required. Takes 2 minutes."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-cta-btns",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    className: "lp-cta-btn",
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    children: "Start free"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "lp-cta-btn lp-cta-btn--outline",
                                    href: $c5b280d91621a701$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Book a call"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $c5b280d91621a701$export$2e2bcd8739ae039 = $c5b280d91621a701$var$CompaniesCtaSection;







const $151980f13be271b8$export$58cfd9be695cf66b = [
    'banner-title',
    'life-cycle-title',
    'clinet-review-title',
    'how-its-work-title',
    'work-block-scaling',
    'key-features',
    'video-section-title',
    'register-form-title',
    'not-sure',
    'pricing-title',
    'pricing-section'
];
const $151980f13be271b8$var$LandingHomeCompanies = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    (0, $282a70cc4e13b055$export$2e2bcd8739ae039)({
        canonicalPath: `${(0, $7393559700759e6c$export$aa103e2c51dcf48a)['ceo']['hubPath']}/`,
        schema: (0, $1070c78a15f5f98b$export$2e2bcd8739ae039)('ceo')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41b3e6b42faeeb34$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3e656caa8f38c5aa$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65d09bf35a1d8357$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $226327b8001c1df2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7769479fb16d2e9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfaf45e08ae16d72$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5b280d91621a701$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88019eab2786a681$export$2e2bcd8739ae039), {
                icpSlug: "ceo"
            })
        ]
    });
};
var $151980f13be271b8$export$2e2bcd8739ae039 = $151980f13be271b8$var$LandingHomeCompanies;




var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $6cdb796ffe249f75$var$__assign = function() {
    $6cdb796ffe249f75$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6cdb796ffe249f75$var$__assign.apply(this, arguments);
};
function $6cdb796ffe249f75$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $6cdb796ffe249f75$var$hashFragment = '';
var $6cdb796ffe249f75$var$observer = null;
var $6cdb796ffe249f75$var$asyncTimerId = null;
var $6cdb796ffe249f75$var$scrollFunction = null;
function $6cdb796ffe249f75$var$reset() {
    $6cdb796ffe249f75$var$hashFragment = '';
    if ($6cdb796ffe249f75$var$observer !== null) $6cdb796ffe249f75$var$observer.disconnect();
    if ($6cdb796ffe249f75$var$asyncTimerId !== null) {
        window.clearTimeout($6cdb796ffe249f75$var$asyncTimerId);
        $6cdb796ffe249f75$var$asyncTimerId = null;
    }
}
function $6cdb796ffe249f75$var$isInteractiveElement(element) {
    var formTags = [
        'BUTTON',
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    var linkTags = [
        'A',
        'AREA'
    ];
    return formTags.includes(element.tagName) && !element.hasAttribute('disabled') || linkTags.includes(element.tagName) && element.hasAttribute('href');
}
function $6cdb796ffe249f75$var$getElAndScroll() {
    var element = null;
    if ($6cdb796ffe249f75$var$hashFragment === '#') // use document.body instead of document.documentElement because of a bug in smoothscroll-polyfill in safari
    // see https://github.com/iamdustan/smoothscroll/issues/138
    // while smoothscroll-polyfill is not included, it is the recommended way to implement smoothscroll
    // in browsers that don't natively support el.scrollIntoView({ behavior: 'smooth' })
    element = document.body;
    else {
        // check for element with matching id before assume '#top' is the top of the document
        // see https://html.spec.whatwg.org/multipage/browsing-the-web.html#target-element
        var id = $6cdb796ffe249f75$var$hashFragment.replace('#', '');
        element = document.getElementById(id);
        if (element === null && $6cdb796ffe249f75$var$hashFragment === '#top') // see above comment for why document.body instead of document.documentElement
        element = document.body;
    }
    if (element !== null) {
        $6cdb796ffe249f75$var$scrollFunction(element);
        // update focus to where the page is scrolled to
        // unfortunately this doesn't work in safari (desktop and iOS) when blur() is called
        var originalTabIndex = element.getAttribute('tabindex');
        if (originalTabIndex === null && !$6cdb796ffe249f75$var$isInteractiveElement(element)) element.setAttribute('tabindex', -1);
        element.focus({
            preventScroll: true
        });
        if (originalTabIndex === null && !$6cdb796ffe249f75$var$isInteractiveElement(element)) {
            // for some reason calling blur() in safari resets the focus region to where it was previously,
            // if blur() is not called it works in safari, but then are stuck with default focus styles
            // on an element that otherwise might never had focus styles applied, so not an option
            element.blur();
            element.removeAttribute('tabindex');
        }
        $6cdb796ffe249f75$var$reset();
        return true;
    }
    return false;
}
function $6cdb796ffe249f75$var$hashLinkScroll(timeout) {
    // Push onto callback queue so it runs after the DOM is updated
    window.setTimeout(function() {
        if ($6cdb796ffe249f75$var$getElAndScroll() === false) {
            if ($6cdb796ffe249f75$var$observer === null) $6cdb796ffe249f75$var$observer = new MutationObserver($6cdb796ffe249f75$var$getElAndScroll);
            $6cdb796ffe249f75$var$observer.observe(document, {
                attributes: true,
                childList: true,
                subtree: true
            });
            // if the element doesn't show up in specified timeout or 10 seconds, stop checking
            $6cdb796ffe249f75$var$asyncTimerId = window.setTimeout(function() {
                $6cdb796ffe249f75$var$reset();
            }, timeout || 10000);
        }
    }, 0);
}
function $6cdb796ffe249f75$export$68b36bde1041b215(As) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        var linkHash = '';
        if (typeof props.to === 'string' && props.to.includes('#')) linkHash = "#" + props.to.split('#').slice(1).join('#');
        else if (typeof props.to === 'object' && typeof props.to.hash === 'string') linkHash = props.to.hash;
        var passDownProps = {};
        if (As === (0, $040dbb9c344a508d$export$b0d92dbee9b5b60d)) passDownProps.isActive = function(match, location) {
            return match && match.isExact && location.hash === linkHash;
        };
        function handleClick(e) {
            $6cdb796ffe249f75$var$reset();
            $6cdb796ffe249f75$var$hashFragment = props.elementId ? "#" + props.elementId : linkHash;
            if (props.onClick) props.onClick(e);
            if ($6cdb796ffe249f75$var$hashFragment !== '' && // ignore non-vanilla click events, same as react-router
            // below logic adapted from react-router: https://github.com/ReactTraining/react-router/blob/fc91700e08df8147bd2bb1be19a299cbb14dbcaa/packages/react-router-dom/modules/Link.js#L43-L48
            !e.defaultPrevented && // onClick prevented default
            e.button === 0 && // ignore everything but left clicks
            (!props.target || props.target === '_self') && // let browser handle "target=_blank" etc
            !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey // ignore clicks with modifier keys
            )) {
                $6cdb796ffe249f75$var$scrollFunction = props.scroll || function(el) {
                    return props.smooth ? el.scrollIntoView({
                        behavior: 'smooth'
                    }) : el.scrollIntoView();
                };
                $6cdb796ffe249f75$var$hashLinkScroll(props.timeout);
            }
        }
        var filteredProps = $6cdb796ffe249f75$var$__rest(props, [
            "scroll",
            "smooth",
            "timeout",
            "elementId"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(As, $6cdb796ffe249f75$var$__assign({}, passDownProps, filteredProps, {
            onClick: handleClick,
            ref: ref
        }), props.children);
    });
}
var $6cdb796ffe249f75$export$4ca9840115f43bad = $6cdb796ffe249f75$export$68b36bde1041b215((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a));
var $6cdb796ffe249f75$export$137982c271569408 = $6cdb796ffe249f75$export$68b36bde1041b215((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d));
var $6cdb796ffe249f75$var$propTypes;







const $ebd74e09b91c9d05$var$Banner = ({ data: data, isAnimationVisible: isAnimationVisible, refs: refs, calImage: calImage })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg1 bpr brnr banner-bg",
        style: {
            backgroundImage: `url(${(parcelRequire("1CdQQ"))})`,
            backgroundPosition: 'right top',
            backgroundSize: '100% 50%'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "main-banner-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pt1rem df fdc",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row df pr",
                        style: {
                            flexWrap: "nowrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "col-sm df jcc fdc gg2rem",
                                style: {
                                    width: "70%",
                                    paddingRight: "100px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        ref: refs?.current?.[0],
                                        className: `fs1-75rem c15 tslp ${isAnimationVisible[0] ? 'op1 tty0' : 'op0 ttx20'}`,
                                        style: {
                                            lineHeight: '50px'
                                        },
                                        children: data?.['bannersubTitle']
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fw500 c15 mih12rem ",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c15 fs3-5rem",
                                            style: {
                                                lineHeight: '70px'
                                            },
                                            children: data?.['bannerTitle']
                                        })
                                    }),
                                    data?.['bannerDescription'] && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs1rem c15 tslp w100 xl-mt0rem",
                                        children: data['bannerDescription']
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "col-sm mt2rem df jce pr right-img-area",
                                style: {
                                    width: '30%',
                                    height: '400px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: data?.bannerImage,
                                            className: `zi1 pr person-img`,
                                            style: {
                                                ...data?.imageStyle,
                                                height: '100%'
                                            }
                                        }),
                                        data?.videoButton ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: data?.videoButton,
                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: "videoCompanies"
                                                })),
                                            className: `zi1 pa cp pillIcon`,
                                            style: {
                                                left: "54%",
                                                bottom: "33px",
                                                width: "172px !important",
                                                height: "50px"
                                            }
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            calImage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pr bg1 pb3rem mt4rem bsbb calcluter-sec cb",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 p4rem mt2rem w100 df br45px bsbb",
                    style: {
                        background: "radial-gradient(70% 70% at 24.51% 50.12%, #F5F7FF 0%, #E8ECFF 100%)"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w30 df jcc",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: calImage,
                                className: "w90 ofcon"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w70 df jcc fdc pl2rem pr2rem",
                            children: [
                                data?.gurantee?.point1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fw400 fs1-75rem c15",
                                    style: {
                                        lineHeight: '40px'
                                    },
                                    children: data?.gurantee?.point1
                                }),
                                data?.gurantee?.point2 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fw400 fs1-75rem c15",
                                    style: {
                                        lineHeight: '40px'
                                    },
                                    children: data?.gurantee?.point2
                                }),
                                data?.gurantee?.point3 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "fw400 fs1-75rem c15",
                                    style: {
                                        lineHeight: '40px'
                                    },
                                    children: data?.gurantee?.point3
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "fw400 df jcs",
                                    children: [
                                        data?.gurantee?.['quickDemoBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "pr df w100 jcfs mt2rem bottom-demo-btn",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: "/demoChecklist",
                                                    className: "cp bg4 bg3-hover td250 br40px df jcsb aic pl2rem pr2rem c1 tal",
                                                    style: {
                                                        paddingTop: "10px",
                                                        paddingBottom: "10px",
                                                        width: '357px'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "db",
                                                            children: [
                                                                "Quick Demo - Try It Now!",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "c1 db w100 sm-p0rem",
                                                                    style: {
                                                                        fontSize: "11px",
                                                                        lineHeight: "15px"
                                                                    },
                                                                    children: "No registration required"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "20",
                                                            height: "17",
                                                            viewBox: "0 0 28 25",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                                                                fill: "white"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        data?.['description']?.['isTestBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: (0, $16250bd714b02a14$export$c99881788c0caafd),
                                            className: "bsbb jcc w400px bg1 tal df fdc aic fw500 mt1rem px1rem c1 bg4 br19px cp secend-sec-btn td250",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    "FREE 2-Minute Test",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "fw400 c21 df fdc",
                                                        style: {
                                                            marginTop: '-2px',
                                                            fontSize: '13px',
                                                            lineHeight: '15px',
                                                            fontStyle: 'italic'
                                                        },
                                                        children: "No registration required"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "21",
                                                            height: "18",
                                                            viewBox: "0 0 21 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M1.39612 10.336H15.818L11.43 14.7241C10.1696 15.9845 12.0602 17.875 13.3206 16.6147L17.3169 12.6121L19.9847 9.94019C20.5017 9.42008 20.5017 8.58008 19.9847 8.05996L13.3206 1.38812C13.0671 1.12758 12.7181 0.981397 12.3545 0.984421C11.1542 0.984572 10.5652 2.4465 11.43 3.2788L15.8284 7.66688H1.32711C-0.521408 7.75859 -0.383387 10.4281 1.39612 10.336Z",
                                                                fill: "#FC7785"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        !data?.gurantee?.['quickDemoBtn'] && data?.['description']?.['isInvestorBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                                            to: "#investor-lookup",
                                            style: {
                                                width: '333px',
                                                paddingLeft: '30px'
                                            },
                                            className: "bsbb jcc w400px bg1 tal df fdc aic fw500 mt1rem pt1rem px1rem c1 bg4 br19px cp secend-sec-btn td250",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    "Investor Database Check",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "21",
                                                            height: "18",
                                                            viewBox: "0 0 21 18",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M1.39612 10.336H15.818L11.43 14.7241C10.1696 15.9845 12.0602 17.875 13.3206 16.6147L17.3169 12.6121L19.9847 9.94019C20.5017 9.42008 20.5017 8.58008 19.9847 8.05996L13.3206 1.38812C13.0671 1.12758 12.7181 0.981397 12.3545 0.984421C11.1542 0.984572 10.5652 2.4465 11.43 3.2788L15.8284 7.66688H1.32711C-0.521408 7.75859 -0.383387 10.4281 1.39612 10.336Z",
                                                                fill: "#FC7785"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'videoCompanies',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "bg1 shadow w100 p2-5rem bsbb df fdc m1rem maw900px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            style: {
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: '0'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                src: data.videoLink + "&output=embed",
                                frameborder: "0",
                                webkitallowfullscreen: "true",
                                mozallowfullscreen: "true",
                                allowFullScreen: true,
                                style: {
                                    position: 'absolute',
                                    top: '0',
                                    left: '0',
                                    width: '100%',
                                    height: '100%'
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $ebd74e09b91c9d05$export$2e2bcd8739ae039 = $ebd74e09b91c9d05$var$Banner;




var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");
var $77361c2db032a628$exports = {};


(function webpackUniversalModuleDefinition(root, factory) {
    $77361c2db032a628$exports = factory((parcelRequire("acw62")), (parcelRequire("1u0KT")));
})($77361c2db032a628$exports, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 4);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            var throwOnDirectAccess, ReactIs;
            // By explicitly using `prop-types` you are opting into new production behavior.
            // http://fb.me/prop-types-in-prod
            module1.exports = __webpack_require__(5)();
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__1__;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__2__;
        /***/ },
        /* 3 */ /***/ function(module1, exports) {
            // Tell whether the rect is visible, given an offset
            //
            // return: boolean
            module1.exports = function(offset, rect, containmentRect) {
                var offsetDir = offset.direction;
                var offsetVal = offset.value; // Rules for checking different kind of offsets. In example if the element is
                // 90px below viewport and offsetTop is 100, it is considered visible.
                switch(offsetDir){
                    case 'top':
                        return containmentRect.top + offsetVal < rect.top && containmentRect.bottom > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right;
                    case 'left':
                        return containmentRect.left + offsetVal < rect.left && containmentRect.bottom > rect.bottom && containmentRect.top < rect.top && containmentRect.right > rect.right;
                    case 'bottom':
                        return containmentRect.bottom - offsetVal > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right && containmentRect.top < rect.top;
                    case 'right':
                        return containmentRect.right - offsetVal > rect.right && containmentRect.left < rect.left && containmentRect.top < rect.top && containmentRect.bottom > rect.bottom;
                }
            };
        /***/ },
        /* 4 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() {
                return VisibilitySensor;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
            /* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
            /* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(_lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__);
            function _typeof(obj) {
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function normalizeRect(rect) {
                if (rect.width === undefined) rect.width = rect.right - rect.left;
                if (rect.height === undefined) rect.height = rect.bottom - rect.top;
                return rect;
            }
            var VisibilitySensor = /*#__PURE__*/ function(_React$Component) {
                _inherits(VisibilitySensor, _React$Component);
                function VisibilitySensor(props) {
                    var _this;
                    _classCallCheck(this, VisibilitySensor);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(VisibilitySensor).call(this, props));
                    _defineProperty(_assertThisInitialized(_this), "getContainer", function() {
                        return _this.props.containment || window;
                    });
                    _defineProperty(_assertThisInitialized(_this), "addEventListener", function(target, event, delay, throttle) {
                        if (!_this.debounceCheck) _this.debounceCheck = {};
                        var timeout;
                        var func;
                        var later = function later() {
                            timeout = null;
                            _this.check();
                        };
                        if (throttle > -1) func = function func() {
                            if (!timeout) timeout = setTimeout(later, throttle || 0);
                        };
                        else func = function func() {
                            clearTimeout(timeout);
                            timeout = setTimeout(later, delay || 0);
                        };
                        var info = {
                            target: target,
                            fn: func,
                            getLastTimeout: function getLastTimeout() {
                                return timeout;
                            }
                        };
                        target.addEventListener(event, info.fn);
                        _this.debounceCheck[event] = info;
                    });
                    _defineProperty(_assertThisInitialized(_this), "startWatching", function() {
                        if (_this.debounceCheck || _this.interval) return;
                        if (_this.props.intervalCheck) _this.interval = setInterval(_this.check, _this.props.intervalDelay);
                        if (_this.props.scrollCheck) _this.addEventListener(_this.getContainer(), "scroll", _this.props.scrollDelay, _this.props.scrollThrottle);
                        if (_this.props.resizeCheck) _this.addEventListener(window, "resize", _this.props.resizeDelay, _this.props.resizeThrottle);
                         // if dont need delayed call, check on load ( before the first interval fires )
                        !_this.props.delayedCall && _this.check();
                    });
                    _defineProperty(_assertThisInitialized(_this), "stopWatching", function() {
                        if (_this.debounceCheck) {
                            // clean up event listeners and their debounce callers
                            for(var debounceEvent in _this.debounceCheck)if (_this.debounceCheck.hasOwnProperty(debounceEvent)) {
                                var debounceInfo = _this.debounceCheck[debounceEvent];
                                clearTimeout(debounceInfo.getLastTimeout());
                                debounceInfo.target.removeEventListener(debounceEvent, debounceInfo.fn);
                                _this.debounceCheck[debounceEvent] = null;
                            }
                        }
                        _this.debounceCheck = null;
                        if (_this.interval) _this.interval = clearInterval(_this.interval);
                    });
                    _defineProperty(_assertThisInitialized(_this), "check", function() {
                        var el = _this.node;
                        var rect;
                        var containmentRect; // if the component has rendered to null, dont update visibility
                        if (!el) return _this.state;
                        rect = normalizeRect(_this.roundRectDown(el.getBoundingClientRect()));
                        if (_this.props.containment) {
                            var containmentDOMRect = _this.props.containment.getBoundingClientRect();
                            containmentRect = {
                                top: containmentDOMRect.top,
                                left: containmentDOMRect.left,
                                bottom: containmentDOMRect.bottom,
                                right: containmentDOMRect.right
                            };
                        } else containmentRect = {
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight || document.documentElement.clientHeight,
                            right: window.innerWidth || document.documentElement.clientWidth
                        };
                         // Check if visibility is wanted via offset?
                        var offset = _this.props.offset || {};
                        var hasValidOffset = _typeof(offset) === "object";
                        if (hasValidOffset) {
                            containmentRect.top += offset.top || 0;
                            containmentRect.left += offset.left || 0;
                            containmentRect.bottom -= offset.bottom || 0;
                            containmentRect.right -= offset.right || 0;
                        }
                        var visibilityRect = {
                            top: rect.top >= containmentRect.top,
                            left: rect.left >= containmentRect.left,
                            bottom: rect.bottom <= containmentRect.bottom,
                            right: rect.right <= containmentRect.right
                        }; // https://github.com/joshwnj/react-visibility-sensor/pull/114
                        var hasSize = rect.height > 0 && rect.width > 0;
                        var isVisible = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right; // check for partial visibility
                        if (hasSize && _this.props.partialVisibility) {
                            var partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left; // account for partial visibility on a single edge
                            if (typeof _this.props.partialVisibility === "string") partialVisible = visibilityRect[_this.props.partialVisibility];
                             // if we have minimum top visibility set by props, lets check, if it meets the passed value
                            // so if for instance element is at least 200px in viewport, then show it.
                            isVisible = _this.props.minTopValue ? partialVisible && rect.top <= containmentRect.bottom - _this.props.minTopValue : partialVisible;
                        } // Deprecated options for calculating offset.
                        if (typeof offset.direction === "string" && typeof offset.value === "number") {
                            console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", offset.direction, offset.value);
                            isVisible = _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default()(offset, rect, containmentRect);
                        }
                        var state = _this.state; // notify the parent when the value changes
                        if (_this.state.isVisible !== isVisible) {
                            state = {
                                isVisible: isVisible,
                                visibilityRect: visibilityRect
                            };
                            _this.setState(state);
                            if (_this.props.onChange) _this.props.onChange(isVisible);
                        }
                        return state;
                    });
                    _this.state = {
                        isVisible: null,
                        visibilityRect: {}
                    };
                    return _this;
                }
                _createClass(VisibilitySensor, [
                    {
                        key: "componentDidMount",
                        value: function componentDidMount() {
                            this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);
                            if (this.props.active) this.startWatching();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            this.stopWatching();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function componentDidUpdate(prevProps) {
                            // re-register node in componentDidUpdate if children diffs [#103]
                            this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);
                            if (this.props.active && !prevProps.active) {
                                this.setState({
                                    isVisible: null,
                                    visibilityRect: {}
                                });
                                this.startWatching();
                            } else if (!this.props.active) this.stopWatching();
                        }
                    },
                    {
                        key: "roundRectDown",
                        value: function roundRectDown(rect) {
                            return {
                                top: Math.floor(rect.top),
                                left: Math.floor(rect.left),
                                bottom: Math.floor(rect.bottom),
                                right: Math.floor(rect.right)
                            };
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            if (this.props.children instanceof Function) return this.props.children({
                                isVisible: this.state.isVisible,
                                visibilityRect: this.state.visibilityRect
                            });
                            return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(this.props.children);
                        }
                    }
                ]);
                return VisibilitySensor;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _defineProperty(VisibilitySensor, "defaultProps", {
                active: true,
                partialVisibility: false,
                minTopValue: 0,
                scrollCheck: false,
                scrollDelay: 250,
                scrollThrottle: -1,
                resizeCheck: false,
                resizeDelay: 250,
                resizeThrottle: -1,
                intervalCheck: true,
                intervalDelay: 100,
                delayedCall: false,
                offset: {},
                containment: null,
                children: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null)
            });
            _defineProperty(VisibilitySensor, "propTypes", {
                onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
                active: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                partialVisibility: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([
                        "top",
                        "right",
                        "bottom",
                        "left"
                    ])
                ]),
                delayedCall: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                offset: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
                        top: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                        left: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                        bottom: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                        right: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
                    }),
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
                        direction: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf([
                            "top",
                            "right",
                            "bottom",
                            "left"
                        ]),
                        value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
                    })
                ]),
                scrollCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                scrollDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                scrollThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                resizeCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                resizeDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                resizeThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                intervalCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
                intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
                containment: typeof window !== "undefined" ? prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(window.Element) : prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
                children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.element,
                    prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func
                ]),
                minTopValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
            });
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = __webpack_require__(6);
            function emptyFunction() {}
            function emptyFunctionWithReset() {}
            emptyFunctionWithReset.resetWarningCache = emptyFunction;
            module1.exports = function() {
                function shim(props, propName, componentName, location, propFullName, secret) {
                    if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                    return;
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                }
                shim.isRequired = shim;
                function getShim() {
                    return shim;
                }
                // Important!
                // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
                var ReactPropTypes = {
                    array: shim,
                    bool: shim,
                    func: shim,
                    number: shim,
                    object: shim,
                    string: shim,
                    symbol: shim,
                    any: shim,
                    arrayOf: getShim,
                    element: shim,
                    elementType: shim,
                    instanceOf: getShim,
                    node: shim,
                    objectOf: getShim,
                    oneOf: getShim,
                    oneOfType: getShim,
                    shape: getShim,
                    exact: getShim,
                    checkPropTypes: emptyFunctionWithReset,
                    resetWarningCache: emptyFunction
                };
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            /**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
            module1.exports = ReactPropTypesSecret;
        /***/ }
    ]);
});




//Check for alternate index for row reverse 
function $4b5290202474e6ed$var$isReverse(number) {
    return number % 2 !== 0;
}



const $4b5290202474e6ed$var$SocialMediaIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("gPTbN")),
                style: {
                    marginLeft: '10px'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("3zMud")),
                style: {
                    marginLeft: '10px'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("8BoXF")),
                style: {
                    marginLeft: '10px'
                }
            })
        ]
    });
};
const $4b5290202474e6ed$var$Keyfeatures = ({ data: data, refs: refs, isAnimationVisible: isAnimationVisible, showAll: showAll, toggleShowAll: toggleShowAll, subTitle: subTitle, len: len })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [animationBoxOne, setAnimationBoxOne] = (0, $acw62.useState)(false);
    const [animationBoxTwo, setAnimationBoxTwo] = (0, $acw62.useState)(false);
    const [animationBoxThree, setAnimationBoxThree] = (0, $acw62.useState)(false);
    const [selectedFeature, setSelectedFeature] = (0, $acw62.useState)({});
    const handleSeeMore = async (data)=>{
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
        setSelectedFeature(data);
    };
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedFeature({});
    };
    const handleVisibilitySensor = (obj)=>{
        if (obj?.['title'] == "Bespoked Business Audit") setAnimationBoxOne(true);
        else setAnimationBoxOne(false);
        if (obj?.['title'] == "Key Performance Indicators (KPI) Report" || obj?.['title'] == "Your Investee Company\u2019s FREE KPI Report") setAnimationBoxTwo(true);
        else setAnimationBoxTwo(false);
        if (obj?.['title'] == "FREE Applicant Company Leads Module") setAnimationBoxThree(true);
        else setAnimationBoxThree(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "homeMainBanner",
                className: "bg1 mih100vh oh",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: refs?.current?.[5],
                        className: `tslp mt4rem ${isAnimationVisible[5] ? 'op1 tty0' : 'op0 ttx20'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "fw500 df jcc fs2-5rem mb0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "Key modules"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15 ml0-5rem",
                                        children: "and features"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "fw400 fs1rem df jcc c15",
                                children: subTitle ? subTitle : 'Reusable diligence - building your businesses stronger'
                            })
                        ]
                    }),
                    data?.slice(0, len)?.map((obj, i)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "container py3rem w100 df fww aic hero-saf pr",
                            style: {
                                position: obj?.hasAnimation && "relative",
                                flexDirection: $4b5290202474e6ed$var$isReverse(i) && 'row-reverse'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w60 pl2rem pr2rem bsbb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic features-icon ml2rem",
                                            children: [
                                                obj?.icon,
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "fw500 fs1-5rem c15 pl1rem",
                                                    children: obj?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pl3rem pt1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                className: "custom-list",
                                                children: obj?.points?.map((objpoints, index, arrr)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                            style: {
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px'
                                                            },
                                                            className: "c14 fs1rem fw400 df aic",
                                                            children: [
                                                                objpoints,
                                                                obj?.pointsImage && index === 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($4b5290202474e6ed$var$SocialMediaIcon, {})
                                                            ]
                                                        }, `${objpoints}-${index}`)
                                                    });
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77361c2db032a628$exports))), {
                                            onChange: ()=>handleVisibilitySensor(obj),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        onClick: ()=>handleSeeMore(obj),
                                                        style: {
                                                            width: '196px'
                                                        },
                                                        id: "openLoginPopup",
                                                        className: "bsbb jcc w200px w9rem df aic fw500 py0-5rem px1rem c1 bo3 br19px cp mr1-5rem-xl ml2rem mt1rem br35px bss bw1px",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "127",
                                                            height: "32",
                                                            viewBox: "0 0 127 32",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M5.255 21.112C4.47633 21.112 3.77233 20.9787 3.143 20.712C2.52433 20.4453 2.03366 20.0613 1.671 19.56C1.30833 19.0587 1.12166 18.4667 1.111 17.784H3.511C3.543 18.2427 3.703 18.6053 3.991 18.872C4.28966 19.1387 4.695 19.272 5.207 19.272C5.72966 19.272 6.14033 19.1493 6.439 18.904C6.73767 18.648 6.887 18.3173 6.887 17.912C6.887 17.5813 6.78567 17.3093 6.583 17.096C6.38033 16.8827 6.12433 16.7173 5.815 16.6C5.51633 16.472 5.10033 16.3333 4.567 16.184C3.84167 15.9707 3.24967 15.7627 2.791 15.56C2.343 15.3467 1.95366 15.032 1.623 14.616C1.303 14.1893 1.143 13.624 1.143 12.92C1.143 12.2587 1.30833 11.6827 1.639 11.192C1.96966 10.7013 2.43366 10.328 3.031 10.072C3.62833 9.80533 4.311 9.672 5.079 9.672C6.231 9.672 7.16433 9.95467 7.879 10.52C8.60433 11.0747 9.00433 11.8533 9.079 12.856H6.615C6.59366 12.472 6.42833 12.1573 6.119 11.912C5.82033 11.656 5.42033 11.528 4.919 11.528C4.48166 11.528 4.12966 11.64 3.863 11.864C3.607 12.088 3.479 12.4133 3.479 12.84C3.479 13.1387 3.575 13.3893 3.767 13.592C3.96967 13.784 4.215 13.944 4.503 14.072C4.80166 14.1893 5.21767 14.328 5.751 14.488C6.47633 14.7013 7.06833 14.9147 7.527 15.128C7.98567 15.3413 8.38033 15.6613 8.711 16.088C9.04167 16.5147 9.207 17.0747 9.207 17.768C9.207 18.3653 9.05233 18.92 8.743 19.432C8.43366 19.944 7.98033 20.3547 7.383 20.664C6.78567 20.9627 6.07633 21.112 5.255 21.112ZM20.269 16.376C20.269 16.696 20.2477 16.984 20.205 17.24H13.725C13.7783 17.88 14.0023 18.3813 14.397 18.744C14.7917 19.1067 15.277 19.288 15.853 19.288C16.685 19.288 17.277 18.9307 17.629 18.216H20.045C19.789 19.0693 19.2983 19.7733 18.573 20.328C17.8477 20.872 16.957 21.144 15.901 21.144C15.0477 21.144 14.2797 20.9573 13.597 20.584C12.925 20.2 12.397 19.6613 12.013 18.968C11.6397 18.2747 11.453 17.4747 11.453 16.568C11.453 15.6507 11.6397 14.8453 12.013 14.152C12.3863 13.4587 12.909 12.9253 13.581 12.552C14.253 12.1787 15.0263 11.992 15.901 11.992C16.7437 11.992 17.4957 12.1733 18.157 12.536C18.829 12.8987 19.3463 13.416 19.709 14.088C20.0823 14.7493 20.269 15.512 20.269 16.376ZM17.949 15.736C17.9383 15.16 17.7303 14.7013 17.325 14.36C16.9197 14.008 16.4237 13.832 15.837 13.832C15.2823 13.832 14.813 14.0027 14.429 14.344C14.0557 14.6747 13.8263 15.1387 13.741 15.736H17.949ZM31.024 16.376C31.024 16.696 31.0027 16.984 30.96 17.24H24.48C24.5333 17.88 24.7573 18.3813 25.152 18.744C25.5467 19.1067 26.032 19.288 26.608 19.288C27.44 19.288 28.032 18.9307 28.384 18.216H30.8C30.544 19.0693 30.0533 19.7733 29.328 20.328C28.6027 20.872 27.712 21.144 26.656 21.144C25.8027 21.144 25.0347 20.9573 24.352 20.584C23.68 20.2 23.152 19.6613 22.768 18.968C22.3947 18.2747 22.208 17.4747 22.208 16.568C22.208 15.6507 22.3947 14.8453 22.768 14.152C23.1413 13.4587 23.664 12.9253 24.336 12.552C25.008 12.1787 25.7813 11.992 26.656 11.992C27.4987 11.992 28.2507 12.1733 28.912 12.536C29.584 12.8987 30.1013 13.416 30.464 14.088C30.8373 14.7493 31.024 15.512 31.024 16.376ZM28.704 15.736C28.6933 15.16 28.4853 14.7013 28.08 14.36C27.6747 14.008 27.1787 13.832 26.592 13.832C26.0373 13.832 25.568 14.0027 25.184 14.344C24.8107 14.6747 24.5813 15.1387 24.496 15.736H28.704ZM50.4075 9.832V21H48.1675V13.736L45.1755 21H43.4795L40.4715 13.736V21H38.2315V9.832H40.7755L44.3275 18.136L47.8795 9.832H50.4075ZM57.4381 21.144C56.5848 21.144 55.8168 20.9573 55.1341 20.584C54.4515 20.2 53.9128 19.6613 53.5181 18.968C53.1341 18.2747 52.9421 17.4747 52.9421 16.568C52.9421 15.6613 53.1395 14.8613 53.5341 14.168C53.9395 13.4747 54.4888 12.9413 55.1821 12.568C55.8755 12.184 56.6488 11.992 57.5021 11.992C58.3555 11.992 59.1288 12.184 59.8221 12.568C60.5155 12.9413 61.0595 13.4747 61.4541 14.168C61.8595 14.8613 62.0621 15.6613 62.0621 16.568C62.0621 17.4747 61.8541 18.2747 61.4381 18.968C61.0328 19.6613 60.4781 20.2 59.7741 20.584C59.0808 20.9573 58.3021 21.144 57.4381 21.144ZM57.4381 19.192C57.8435 19.192 58.2221 19.096 58.5741 18.904C58.9368 18.7013 59.2248 18.4027 59.4381 18.008C59.6515 17.6133 59.7581 17.1333 59.7581 16.568C59.7581 15.7253 59.5341 15.08 59.0861 14.632C58.6488 14.1733 58.1101 13.944 57.4701 13.944C56.8301 13.944 56.2915 14.1733 55.8541 14.632C55.4275 15.08 55.2141 15.7253 55.2141 16.568C55.2141 17.4107 55.4221 18.0613 55.8381 18.52C56.2648 18.968 56.7981 19.192 57.4381 19.192ZM66.8252 13.512C67.1132 13.0427 67.4866 12.6747 67.9452 12.408C68.4146 12.1413 68.9479 12.008 69.5452 12.008V14.36H68.9532C68.2492 14.36 67.7159 14.5253 67.3532 14.856C67.0012 15.1867 66.8252 15.7627 66.8252 16.584V21H64.5852V12.136H66.8252V13.512ZM80.174 16.376C80.174 16.696 80.1527 16.984 80.11 17.24H73.63C73.6833 17.88 73.9073 18.3813 74.302 18.744C74.6967 19.1067 75.182 19.288 75.758 19.288C76.59 19.288 77.182 18.9307 77.534 18.216H79.95C79.694 19.0693 79.2033 19.7733 78.478 20.328C77.7527 20.872 76.862 21.144 75.806 21.144C74.9527 21.144 74.1847 20.9573 73.502 20.584C72.83 20.2 72.302 19.6613 71.918 18.968C71.5447 18.2747 71.358 17.4747 71.358 16.568C71.358 15.6507 71.5447 14.8453 71.918 14.152C72.2913 13.4587 72.814 12.9253 73.486 12.552C74.158 12.1787 74.9313 11.992 75.806 11.992C76.6487 11.992 77.4007 12.1733 78.062 12.536C78.734 12.8987 79.2513 13.416 79.614 14.088C79.9873 14.7493 80.174 15.512 80.174 16.376ZM77.854 15.736C77.8433 15.16 77.6353 14.7013 77.23 14.36C76.8247 14.008 76.3287 13.832 75.742 13.832C75.1873 13.832 74.718 14.0027 74.334 14.344C73.9607 14.6747 73.7313 15.1387 73.646 15.736H77.854Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M102.396 17.336H116.818L112.43 21.7241C111.17 22.9845 113.06 24.875 114.321 23.6147L118.317 19.6121L120.985 16.9402C121.502 16.4201 121.502 15.5801 120.985 15.06L114.321 8.38812C114.067 8.12758 113.718 7.9814 113.354 7.98442C112.154 7.98457 111.565 9.4465 112.43 10.2788L116.828 14.6669H102.327C100.479 14.7586 100.617 17.4281 102.396 17.336Z",
                                                                    fill: "#4A67FF"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    obj?.['isInvestorLookupBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                                                        to: "#investor-lookup",
                                                        className: "mt1rem p1rem px2rem shadow c1 bg4 bg3-hover br35px cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                                        children: "Investor Database Check"
                                                    }),
                                                    obj?.['isTwoMinuteTestBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                                                        to: "#not-sure-yet",
                                                        className: "mt1rem p1rem px2rem shadow c1 bg4 bg3-hover br35px cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                                        children: "Take FREE Test"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "pr w40 cp df",
                                    style: {
                                        justifyContent: $4b5290202474e6ed$var$isReverse(i) ? "start" : 'center'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: obj?.image,
                                        className: "zi0 h100 w100"
                                    })
                                }),
                                obj?.['title'] == "Bespoked Business Audit" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation1",
                                    className: `pa animation-img-box ${animationBoxOne ? ' animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.['title'] == "Key Performance Indicators (KPI) Report" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation2",
                                    className: `pa animation-img-box ${animationBoxTwo ? ' animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.['title'] == "FREE Applicant Company Leads Module" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation3",
                                    className: `pa animation-img-box ${animationBoxThree ? 'animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.['title'] == "Your Investee Company\u2019s FREE KPI Report" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation4",
                                    className: `pa animation-img-box ${animationBoxTwo ? ' animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.hasComment && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `w100 pr df testmonial-user`,
                                    style: {
                                        justifyContent: !$4b5290202474e6ed$var$isReverse(i) ? "start" : 'end',
                                        ...obj?.conmmentData?.style
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "br40px p2rem mt1rem pr",
                                        style: {
                                            backgroundColor: obj?.conmmentData?.bg,
                                            width: '56%'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df quote-area",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "quote-icon",
                                                    style: {
                                                        width: '5%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: obj?.conmmentData?.userIcon,
                                                        height: "70px",
                                                        width: "70px",
                                                        style: {
                                                            borderRadius: '50%'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w90",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c14 fw400 fs1rem pl2rem mb1rem",
                                                            children: obj?.conmmentData?.desc
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "pl2rem c4 fw500 fs1rem fsi",
                                                            style: {
                                                                color: obj?.fontColor,
                                                                lineHeight: '1.4'
                                                            },
                                                            children: obj?.conmmentData?.title
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "pl2rem c14 fw300 fs1rem",
                                                            children: obj?.conmmentData?.comment
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "69",
                                                            height: "40",
                                                            viewBox: "0 0 69 40",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            style: {
                                                                position: 'absolute',
                                                                right: "40px",
                                                                bottom: '20px',
                                                                width: '40px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                fill: obj?.fontColor,
                                                                d: "M33.8861 4.00184C34.3733 4.39166 34.4708 4.87894 34.2759 5.70732L24.9201 38.1114C24.7739 38.7449 24.2379 39.1834 23.5557 39.1834H1.5307C0.653596 39.1834 0.3125 38.7936 0.3125 37.9652V34.6517C0.361228 34.0183 0.556146 33.4335 0.897241 32.9463L25.3587 0.688337C25.7485 0.103602 26.5769 -0.0913116 27.2103 0.298512L33.8861 4.00184ZM68.1906 4.00184C68.6778 4.39166 68.7753 4.87894 68.5804 5.70732L59.2246 38.1114C59.0784 38.7936 58.445 39.2322 57.7628 39.1834H35.8352C34.9581 39.1834 34.617 38.7936 34.617 37.9652V34.6517C34.6657 34.0183 34.8606 33.4335 35.2017 32.9463L59.5657 0.688337C59.9555 0.103602 60.7839 -0.0913087 61.4174 0.347243L68.1906 4.00184Z"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                obj?.hasAnimation && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: obj?.animationImage,
                                    className: `zi0 pa ${obj?.animationClass}`,
                                    style: {
                                        ...obj?.animationStyle
                                    }
                                })
                            ]
                        }, `${obj?.key}-${i}`);
                    }),
                    showAll && data?.slice(len)?.map((obj, i)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "container py3rem w100 df fww aic hero-saf pr",
                            style: {
                                position: obj?.hasAnimation && "relative",
                                flexDirection: $4b5290202474e6ed$var$isReverse(i + 10) && 'row-reverse',
                                transition: "all 1s ease"
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w60 pl2rem pr2rem bsbb",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df aic features-icon ml2rem",
                                            children: [
                                                obj?.icon,
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "fw500 fs1-5rem c15 pl1rem",
                                                    children: obj?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "pl3rem pt1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                className: "custom-list",
                                                children: obj?.points?.map((objpoints, index, arrr)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        style: {
                                                            paddingTop: '10px',
                                                            paddingBottom: '10px'
                                                        },
                                                        className: "c14 fs1rem fw400 df aic",
                                                        children: objpoints
                                                    }, `${objpoints}-${index}`);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77361c2db032a628$exports))), {
                                            onChange: ()=>handleVisibilitySensor(obj),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        onClick: ()=>handleSeeMore(obj),
                                                        style: {
                                                            width: '196px'
                                                        },
                                                        id: "openLoginPopup",
                                                        className: "bsbb jcc w200px w9rem df aic fw500 py0-5rem px1rem c1 bo3 br19px cp mr1-5rem-xl ml2rem mt1rem br35px bss bw1px",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "127",
                                                            height: "32",
                                                            viewBox: "0 0 127 32",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M5.255 21.112C4.47633 21.112 3.77233 20.9787 3.143 20.712C2.52433 20.4453 2.03366 20.0613 1.671 19.56C1.30833 19.0587 1.12166 18.4667 1.111 17.784H3.511C3.543 18.2427 3.703 18.6053 3.991 18.872C4.28966 19.1387 4.695 19.272 5.207 19.272C5.72966 19.272 6.14033 19.1493 6.439 18.904C6.73767 18.648 6.887 18.3173 6.887 17.912C6.887 17.5813 6.78567 17.3093 6.583 17.096C6.38033 16.8827 6.12433 16.7173 5.815 16.6C5.51633 16.472 5.10033 16.3333 4.567 16.184C3.84167 15.9707 3.24967 15.7627 2.791 15.56C2.343 15.3467 1.95366 15.032 1.623 14.616C1.303 14.1893 1.143 13.624 1.143 12.92C1.143 12.2587 1.30833 11.6827 1.639 11.192C1.96966 10.7013 2.43366 10.328 3.031 10.072C3.62833 9.80533 4.311 9.672 5.079 9.672C6.231 9.672 7.16433 9.95467 7.879 10.52C8.60433 11.0747 9.00433 11.8533 9.079 12.856H6.615C6.59366 12.472 6.42833 12.1573 6.119 11.912C5.82033 11.656 5.42033 11.528 4.919 11.528C4.48166 11.528 4.12966 11.64 3.863 11.864C3.607 12.088 3.479 12.4133 3.479 12.84C3.479 13.1387 3.575 13.3893 3.767 13.592C3.96967 13.784 4.215 13.944 4.503 14.072C4.80166 14.1893 5.21767 14.328 5.751 14.488C6.47633 14.7013 7.06833 14.9147 7.527 15.128C7.98567 15.3413 8.38033 15.6613 8.711 16.088C9.04167 16.5147 9.207 17.0747 9.207 17.768C9.207 18.3653 9.05233 18.92 8.743 19.432C8.43366 19.944 7.98033 20.3547 7.383 20.664C6.78567 20.9627 6.07633 21.112 5.255 21.112ZM20.269 16.376C20.269 16.696 20.2477 16.984 20.205 17.24H13.725C13.7783 17.88 14.0023 18.3813 14.397 18.744C14.7917 19.1067 15.277 19.288 15.853 19.288C16.685 19.288 17.277 18.9307 17.629 18.216H20.045C19.789 19.0693 19.2983 19.7733 18.573 20.328C17.8477 20.872 16.957 21.144 15.901 21.144C15.0477 21.144 14.2797 20.9573 13.597 20.584C12.925 20.2 12.397 19.6613 12.013 18.968C11.6397 18.2747 11.453 17.4747 11.453 16.568C11.453 15.6507 11.6397 14.8453 12.013 14.152C12.3863 13.4587 12.909 12.9253 13.581 12.552C14.253 12.1787 15.0263 11.992 15.901 11.992C16.7437 11.992 17.4957 12.1733 18.157 12.536C18.829 12.8987 19.3463 13.416 19.709 14.088C20.0823 14.7493 20.269 15.512 20.269 16.376ZM17.949 15.736C17.9383 15.16 17.7303 14.7013 17.325 14.36C16.9197 14.008 16.4237 13.832 15.837 13.832C15.2823 13.832 14.813 14.0027 14.429 14.344C14.0557 14.6747 13.8263 15.1387 13.741 15.736H17.949ZM31.024 16.376C31.024 16.696 31.0027 16.984 30.96 17.24H24.48C24.5333 17.88 24.7573 18.3813 25.152 18.744C25.5467 19.1067 26.032 19.288 26.608 19.288C27.44 19.288 28.032 18.9307 28.384 18.216H30.8C30.544 19.0693 30.0533 19.7733 29.328 20.328C28.6027 20.872 27.712 21.144 26.656 21.144C25.8027 21.144 25.0347 20.9573 24.352 20.584C23.68 20.2 23.152 19.6613 22.768 18.968C22.3947 18.2747 22.208 17.4747 22.208 16.568C22.208 15.6507 22.3947 14.8453 22.768 14.152C23.1413 13.4587 23.664 12.9253 24.336 12.552C25.008 12.1787 25.7813 11.992 26.656 11.992C27.4987 11.992 28.2507 12.1733 28.912 12.536C29.584 12.8987 30.1013 13.416 30.464 14.088C30.8373 14.7493 31.024 15.512 31.024 16.376ZM28.704 15.736C28.6933 15.16 28.4853 14.7013 28.08 14.36C27.6747 14.008 27.1787 13.832 26.592 13.832C26.0373 13.832 25.568 14.0027 25.184 14.344C24.8107 14.6747 24.5813 15.1387 24.496 15.736H28.704ZM50.4075 9.832V21H48.1675V13.736L45.1755 21H43.4795L40.4715 13.736V21H38.2315V9.832H40.7755L44.3275 18.136L47.8795 9.832H50.4075ZM57.4381 21.144C56.5848 21.144 55.8168 20.9573 55.1341 20.584C54.4515 20.2 53.9128 19.6613 53.5181 18.968C53.1341 18.2747 52.9421 17.4747 52.9421 16.568C52.9421 15.6613 53.1395 14.8613 53.5341 14.168C53.9395 13.4747 54.4888 12.9413 55.1821 12.568C55.8755 12.184 56.6488 11.992 57.5021 11.992C58.3555 11.992 59.1288 12.184 59.8221 12.568C60.5155 12.9413 61.0595 13.4747 61.4541 14.168C61.8595 14.8613 62.0621 15.6613 62.0621 16.568C62.0621 17.4747 61.8541 18.2747 61.4381 18.968C61.0328 19.6613 60.4781 20.2 59.7741 20.584C59.0808 20.9573 58.3021 21.144 57.4381 21.144ZM57.4381 19.192C57.8435 19.192 58.2221 19.096 58.5741 18.904C58.9368 18.7013 59.2248 18.4027 59.4381 18.008C59.6515 17.6133 59.7581 17.1333 59.7581 16.568C59.7581 15.7253 59.5341 15.08 59.0861 14.632C58.6488 14.1733 58.1101 13.944 57.4701 13.944C56.8301 13.944 56.2915 14.1733 55.8541 14.632C55.4275 15.08 55.2141 15.7253 55.2141 16.568C55.2141 17.4107 55.4221 18.0613 55.8381 18.52C56.2648 18.968 56.7981 19.192 57.4381 19.192ZM66.8252 13.512C67.1132 13.0427 67.4866 12.6747 67.9452 12.408C68.4146 12.1413 68.9479 12.008 69.5452 12.008V14.36H68.9532C68.2492 14.36 67.7159 14.5253 67.3532 14.856C67.0012 15.1867 66.8252 15.7627 66.8252 16.584V21H64.5852V12.136H66.8252V13.512ZM80.174 16.376C80.174 16.696 80.1527 16.984 80.11 17.24H73.63C73.6833 17.88 73.9073 18.3813 74.302 18.744C74.6967 19.1067 75.182 19.288 75.758 19.288C76.59 19.288 77.182 18.9307 77.534 18.216H79.95C79.694 19.0693 79.2033 19.7733 78.478 20.328C77.7527 20.872 76.862 21.144 75.806 21.144C74.9527 21.144 74.1847 20.9573 73.502 20.584C72.83 20.2 72.302 19.6613 71.918 18.968C71.5447 18.2747 71.358 17.4747 71.358 16.568C71.358 15.6507 71.5447 14.8453 71.918 14.152C72.2913 13.4587 72.814 12.9253 73.486 12.552C74.158 12.1787 74.9313 11.992 75.806 11.992C76.6487 11.992 77.4007 12.1733 78.062 12.536C78.734 12.8987 79.2513 13.416 79.614 14.088C79.9873 14.7493 80.174 15.512 80.174 16.376ZM77.854 15.736C77.8433 15.16 77.6353 14.7013 77.23 14.36C76.8247 14.008 76.3287 13.832 75.742 13.832C75.1873 13.832 74.718 14.0027 74.334 14.344C73.9607 14.6747 73.7313 15.1387 73.646 15.736H77.854Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M102.396 17.336H116.818L112.43 21.7241C111.17 22.9845 113.06 24.875 114.321 23.6147L118.317 19.6121L120.985 16.9402C121.502 16.4201 121.502 15.5801 120.985 15.06L114.321 8.38812C114.067 8.12758 113.718 7.9814 113.354 7.98442C112.154 7.98457 111.565 9.4465 112.43 10.2788L116.828 14.6669H102.327C100.479 14.7586 100.617 17.4281 102.396 17.336Z",
                                                                    fill: "#4A67FF"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    obj?.['isInvestorLookupBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                                                        to: "#investor-lookup",
                                                        className: "mt1rem p1rem px2rem shadow c1 bg4 bg3-hover br35px cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                                        children: "Investor Database Check"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `pr w40 cp df  ${$4b5290202474e6ed$var$isReverse(i + 10) ? "jcs" : "jcc"}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: obj?.image,
                                        className: "zi0 h100 w100"
                                    })
                                }),
                                obj?.['title'] == "Bespoked Business Audit" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation1",
                                    className: `pa animation-img-box ${animationBoxOne ? ' animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.['title'] == "Key Performance Indicators (KPI) Report" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation2",
                                    className: `pa animation-img-box ${animationBoxTwo ? ' animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.['title'] == "FREE Applicant Company Leads Module" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation3",
                                    className: `pa animation-img-box ${animationBoxThree ? ' animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.['title'] == "Your Investee Company\u2019s FREE KPI Report" && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    id: "balloon-animation4",
                                    className: `pa animation-img-box ${animationBoxTwo ? ' animation-img-boxUP' : ' animation-img-box-down'}`,
                                    src: obj?.baloonAnimationImage,
                                    alt: ""
                                }),
                                obj?.hasComment && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100 pr df testmonial-user",
                                    style: {
                                        marginTop: '0px',
                                        justifyContent: $4b5290202474e6ed$var$isReverse(i) ? "end" : 'start'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "br40px p2rem mt1rem pr",
                                        style: {
                                            backgroundColor: obj?.conmmentData?.bg,
                                            width: '56%'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df quote-area",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "quote-icon",
                                                    style: {
                                                        width: '5%'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: obj?.conmmentData?.userIcon,
                                                        height: "70px",
                                                        width: "70px",
                                                        style: {
                                                            borderRadius: '50%'
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w90",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "c14 fw400 fs1rem pl2rem mb1rem",
                                                            children: obj?.conmmentData?.desc
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "pl2rem c4 fw500 fs1rem fsi",
                                                            style: {
                                                                color: obj?.fontColor,
                                                                lineHeight: '1.4'
                                                            },
                                                            children: obj?.conmmentData?.title
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "pl2rem c14 fw300 fs1rem",
                                                            children: obj?.conmmentData?.comment
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "69",
                                                            height: "40",
                                                            viewBox: "0 0 69 40",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            style: {
                                                                position: 'absolute',
                                                                right: "40px",
                                                                bottom: '20px',
                                                                width: '40px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                fill: obj?.fontColor,
                                                                d: "M33.8861 4.00184C34.3733 4.39166 34.4708 4.87894 34.2759 5.70732L24.9201 38.1114C24.7739 38.7449 24.2379 39.1834 23.5557 39.1834H1.5307C0.653596 39.1834 0.3125 38.7936 0.3125 37.9652V34.6517C0.361228 34.0183 0.556146 33.4335 0.897241 32.9463L25.3587 0.688337C25.7485 0.103602 26.5769 -0.0913116 27.2103 0.298512L33.8861 4.00184ZM68.1906 4.00184C68.6778 4.39166 68.7753 4.87894 68.5804 5.70732L59.2246 38.1114C59.0784 38.7936 58.445 39.2322 57.7628 39.1834H35.8352C34.9581 39.1834 34.617 38.7936 34.617 37.9652V34.6517C34.6657 34.0183 34.8606 33.4335 35.2017 32.9463L59.5657 0.688337C59.9555 0.103602 60.7839 -0.0913087 61.4174 0.347243L68.1906 4.00184Z"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                obj?.hasAnimation && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: obj?.animationImage,
                                    className: "zi0 pa",
                                    style: {
                                        ...obj?.animationStyle
                                    }
                                })
                            ]
                        }, `${obj?.key}- ${i + 10}`);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc fdc aic tac see-aal-features",
                        children: [
                            showAll && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "267",
                                height: "53",
                                viewBox: "0 0 267 53",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "mb1rem cp",
                                onClick: toggleShowAll,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                        opacity: "0.8",
                                        width: "267",
                                        height: "53",
                                        rx: "26.5",
                                        fill: "#060606"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M52.3003 32.112C51.5216 32.112 50.8176 31.9787 50.1883 31.712C49.5696 31.4453 49.079 31.0613 48.7163 30.56C48.3536 30.0587 48.167 29.4667 48.1563 28.784H50.5563C50.5883 29.2427 50.7483 29.6053 51.0363 29.872C51.335 30.1387 51.7403 30.272 52.2523 30.272C52.775 30.272 53.1856 30.1493 53.4843 29.904C53.783 29.648 53.9323 29.3173 53.9323 28.912C53.9323 28.5813 53.831 28.3093 53.6283 28.096C53.4256 27.8827 53.1696 27.7173 52.8603 27.6C52.5616 27.472 52.1456 27.3333 51.6123 27.184C50.887 26.9707 50.295 26.7627 49.8363 26.56C49.3883 26.3467 48.999 26.032 48.6683 25.616C48.3483 25.1893 48.1883 24.624 48.1883 23.92C48.1883 23.2587 48.3536 22.6827 48.6843 22.192C49.015 21.7013 49.479 21.328 50.0763 21.072C50.6736 20.8053 51.3563 20.672 52.1243 20.672C53.2763 20.672 54.2096 20.9547 54.9243 21.52C55.6496 22.0747 56.0496 22.8533 56.1243 23.856H53.6603C53.639 23.472 53.4736 23.1573 53.1643 22.912C52.8656 22.656 52.4656 22.528 51.9643 22.528C51.527 22.528 51.175 22.64 50.9083 22.864C50.6523 23.088 50.5243 23.4133 50.5243 23.84C50.5243 24.1387 50.6203 24.3893 50.8123 24.592C51.015 24.784 51.2603 24.944 51.5483 25.072C51.847 25.1893 52.263 25.328 52.7963 25.488C53.5216 25.7013 54.1136 25.9147 54.5723 26.128C55.031 26.3413 55.4256 26.6613 55.7563 27.088C56.087 27.5147 56.2523 28.0747 56.2523 28.768C56.2523 29.3653 56.0976 29.92 55.7883 30.432C55.479 30.944 55.0256 31.3547 54.4283 31.664C53.831 31.9627 53.1216 32.112 52.3003 32.112ZM64.0663 23.008C64.7383 23.008 65.3356 23.1573 65.8583 23.456C66.381 23.744 66.7863 24.176 67.0743 24.752C67.373 25.3173 67.5223 26 67.5223 26.8V32H65.2823V27.104C65.2823 26.4 65.1063 25.8613 64.7543 25.488C64.4023 25.104 63.9223 24.912 63.3143 24.912C62.6956 24.912 62.205 25.104 61.8423 25.488C61.4903 25.8613 61.3143 26.4 61.3143 27.104V32H59.0743V20.16H61.3143V24.24C61.6023 23.856 61.9863 23.5573 62.4663 23.344C62.9463 23.12 63.4796 23.008 64.0663 23.008ZM74.4684 32.144C73.6151 32.144 72.8471 31.9573 72.1644 31.584C71.4818 31.2 70.9431 30.6613 70.5484 29.968C70.1644 29.2747 69.9724 28.4747 69.9724 27.568C69.9724 26.6613 70.1698 25.8613 70.5644 25.168C70.9698 24.4747 71.5191 23.9413 72.2124 23.568C72.9058 23.184 73.6791 22.992 74.5324 22.992C75.3858 22.992 76.1591 23.184 76.8524 23.568C77.5458 23.9413 78.0898 24.4747 78.4844 25.168C78.8898 25.8613 79.0924 26.6613 79.0924 27.568C79.0924 28.4747 78.8844 29.2747 78.4684 29.968C78.0631 30.6613 77.5084 31.2 76.8044 31.584C76.1111 31.9573 75.3324 32.144 74.4684 32.144ZM74.4684 30.192C74.8738 30.192 75.2524 30.096 75.6044 29.904C75.9671 29.7013 76.2551 29.4027 76.4684 29.008C76.6818 28.6133 76.7884 28.1333 76.7884 27.568C76.7884 26.7253 76.5644 26.08 76.1164 25.632C75.6791 25.1733 75.1404 24.944 74.5004 24.944C73.8604 24.944 73.3218 25.1733 72.8844 25.632C72.4578 26.08 72.2444 26.7253 72.2444 27.568C72.2444 28.4107 72.4524 29.0613 72.8684 29.52C73.2951 29.968 73.8284 30.192 74.4684 30.192ZM93.9036 23.136L91.3116 32H88.8956L87.2796 25.808L85.6636 32H83.2316L80.6236 23.136H82.8956L84.4636 29.888L86.1596 23.136H88.5276L90.1916 29.872L91.7596 23.136H93.9036ZM102.928 30.224H106.608V32H100.688V20.832H102.928V30.224ZM117.152 27.376C117.152 27.696 117.13 27.984 117.088 28.24H110.608C110.661 28.88 110.885 29.3813 111.28 29.744C111.674 30.1067 112.16 30.288 112.736 30.288C113.568 30.288 114.16 29.9307 114.512 29.216H116.928C116.672 30.0693 116.181 30.7733 115.456 31.328C114.73 31.872 113.84 32.144 112.784 32.144C111.93 32.144 111.162 31.9573 110.48 31.584C109.808 31.2 109.28 30.6613 108.896 29.968C108.522 29.2747 108.336 28.4747 108.336 27.568C108.336 26.6507 108.522 25.8453 108.896 25.152C109.269 24.4587 109.792 23.9253 110.464 23.552C111.136 23.1787 111.909 22.992 112.784 22.992C113.626 22.992 114.378 23.1733 115.04 23.536C115.712 23.8987 116.229 24.416 116.592 25.088C116.965 25.7493 117.152 26.512 117.152 27.376ZM114.832 26.736C114.821 26.16 114.613 25.7013 114.208 25.36C113.802 25.008 113.306 24.832 112.72 24.832C112.165 24.832 111.696 25.0027 111.312 25.344C110.938 25.6747 110.709 26.1387 110.624 26.736H114.832ZM123.059 32.144C122.333 32.144 121.683 32.016 121.107 31.76C120.531 31.4933 120.072 31.136 119.731 30.688C119.4 30.24 119.219 29.744 119.187 29.2H121.443C121.485 29.5413 121.651 29.824 121.939 30.048C122.237 30.272 122.605 30.384 123.043 30.384C123.469 30.384 123.8 30.2987 124.035 30.128C124.28 29.9573 124.403 29.7387 124.403 29.472C124.403 29.184 124.253 28.9707 123.955 28.832C123.667 28.6827 123.203 28.5227 122.563 28.352C121.901 28.192 121.357 28.0267 120.931 27.856C120.515 27.6853 120.152 27.424 119.843 27.072C119.544 26.72 119.395 26.2453 119.395 25.648C119.395 25.1573 119.533 24.7093 119.811 24.304C120.099 23.8987 120.504 23.5787 121.027 23.344C121.56 23.1093 122.184 22.992 122.899 22.992C123.955 22.992 124.797 23.2587 125.427 23.792C126.056 24.3147 126.403 25.024 126.467 25.92H124.323C124.291 25.568 124.141 25.2907 123.875 25.088C123.619 24.8747 123.272 24.768 122.835 24.768C122.429 24.768 122.115 24.8427 121.891 24.992C121.677 25.1413 121.571 25.3493 121.571 25.616C121.571 25.9147 121.72 26.144 122.019 26.304C122.317 26.4533 122.781 26.608 123.411 26.768C124.051 26.928 124.579 27.0933 124.995 27.264C125.411 27.4347 125.768 27.7013 126.067 28.064C126.376 28.416 126.536 28.8853 126.547 29.472C126.547 29.984 126.403 30.4427 126.115 30.848C125.837 31.2533 125.432 31.5733 124.899 31.808C124.376 32.032 123.763 32.144 123.059 32.144ZM132.658 32.144C131.932 32.144 131.282 32.016 130.706 31.76C130.13 31.4933 129.671 31.136 129.33 30.688C128.999 30.24 128.818 29.744 128.786 29.2H131.042C131.084 29.5413 131.25 29.824 131.538 30.048C131.836 30.272 132.204 30.384 132.642 30.384C133.068 30.384 133.399 30.2987 133.634 30.128C133.879 29.9573 134.002 29.7387 134.002 29.472C134.002 29.184 133.852 28.9707 133.554 28.832C133.266 28.6827 132.802 28.5227 132.162 28.352C131.5 28.192 130.956 28.0267 130.53 27.856C130.114 27.6853 129.751 27.424 129.442 27.072C129.143 26.72 128.994 26.2453 128.994 25.648C128.994 25.1573 129.132 24.7093 129.41 24.304C129.698 23.8987 130.103 23.5787 130.626 23.344C131.159 23.1093 131.783 22.992 132.498 22.992C133.554 22.992 134.396 23.2587 135.026 23.792C135.655 24.3147 136.002 25.024 136.066 25.92H133.922C133.89 25.568 133.74 25.2907 133.474 25.088C133.218 24.8747 132.871 24.768 132.434 24.768C132.028 24.768 131.714 24.8427 131.49 24.992C131.276 25.1413 131.17 25.3493 131.17 25.616C131.17 25.9147 131.319 26.144 131.618 26.304C131.916 26.4533 132.38 26.608 133.01 26.768C133.65 26.928 134.178 27.0933 134.594 27.264C135.01 27.4347 135.367 27.7013 135.666 28.064C135.975 28.416 136.135 28.8853 136.146 29.472C136.146 29.984 136.002 30.4427 135.714 30.848C135.436 31.2533 135.031 31.5733 134.498 31.808C133.975 32.032 133.362 32.144 132.658 32.144ZM150.453 20.832V22.64H145.797V25.504H149.365V27.28H145.797V32H143.557V20.832H150.453ZM161.161 27.376C161.161 27.696 161.14 27.984 161.097 28.24H154.617C154.671 28.88 154.895 29.3813 155.289 29.744C155.684 30.1067 156.169 30.288 156.745 30.288C157.577 30.288 158.169 29.9307 158.521 29.216H160.937C160.681 30.0693 160.191 30.7733 159.465 31.328C158.74 31.872 157.849 32.144 156.793 32.144C155.94 32.144 155.172 31.9573 154.489 31.584C153.817 31.2 153.289 30.6613 152.905 29.968C152.532 29.2747 152.345 28.4747 152.345 27.568C152.345 26.6507 152.532 25.8453 152.905 25.152C153.279 24.4587 153.801 23.9253 154.473 23.552C155.145 23.1787 155.919 22.992 156.793 22.992C157.636 22.992 158.388 23.1733 159.049 23.536C159.721 23.8987 160.239 24.416 160.601 25.088C160.975 25.7493 161.161 26.512 161.161 27.376ZM158.841 26.736C158.831 26.16 158.623 25.7013 158.217 25.36C157.812 25.008 157.316 24.832 156.729 24.832C156.175 24.832 155.705 25.0027 155.321 25.344C154.948 25.6747 154.719 26.1387 154.633 26.736H158.841ZM163.1 27.536C163.1 26.64 163.276 25.8453 163.628 25.152C163.991 24.4587 164.476 23.9253 165.084 23.552C165.703 23.1787 166.391 22.992 167.148 22.992C167.81 22.992 168.386 23.1253 168.876 23.392C169.378 23.6587 169.778 23.9947 170.076 24.4V23.136H172.332V32H170.076V30.704C169.788 31.12 169.388 31.4667 168.876 31.744C168.375 32.0107 167.794 32.144 167.132 32.144C166.386 32.144 165.703 31.952 165.084 31.568C164.476 31.184 163.991 30.6453 163.628 29.952C163.276 29.248 163.1 28.4427 163.1 27.536ZM170.076 27.568C170.076 27.024 169.97 26.56 169.756 26.176C169.543 25.7813 169.255 25.4827 168.892 25.28C168.53 25.0667 168.14 24.96 167.724 24.96C167.308 24.96 166.924 25.0613 166.572 25.264C166.22 25.4667 165.932 25.7653 165.708 26.16C165.495 26.544 165.388 27.0027 165.388 27.536C165.388 28.0693 165.495 28.5387 165.708 28.944C165.932 29.3387 166.22 29.6427 166.572 29.856C166.935 30.0693 167.319 30.176 167.724 30.176C168.14 30.176 168.53 30.0747 168.892 29.872C169.255 29.6587 169.543 29.36 169.756 28.976C169.97 28.5813 170.076 28.112 170.076 27.568ZM178.008 24.976V29.264C178.008 29.5627 178.077 29.7813 178.216 29.92C178.365 30.048 178.611 30.112 178.952 30.112H179.992V32H178.584C176.696 32 175.752 31.0827 175.752 29.248V24.976H174.696V23.136H175.752V20.944H178.008V23.136H179.992V24.976H178.008ZM190.851 23.136V32H188.595V30.88C188.307 31.264 187.928 31.568 187.459 31.792C187 32.0053 186.499 32.112 185.955 32.112C185.262 32.112 184.648 31.968 184.115 31.68C183.582 31.3813 183.16 30.9493 182.851 30.384C182.552 29.808 182.403 29.1253 182.403 28.336V23.136H184.643V28.016C184.643 28.72 184.819 29.264 185.171 29.648C185.523 30.0213 186.003 30.208 186.611 30.208C187.23 30.208 187.715 30.0213 188.067 29.648C188.419 29.264 188.595 28.72 188.595 28.016V23.136H190.851ZM196.181 24.512C196.469 24.0427 196.843 23.6747 197.301 23.408C197.771 23.1413 198.304 23.008 198.901 23.008V25.36H198.309C197.605 25.36 197.072 25.5253 196.709 25.856C196.357 26.1867 196.181 26.7627 196.181 27.584V32H193.941V23.136H196.181V24.512ZM209.53 27.376C209.53 27.696 209.509 27.984 209.466 28.24H202.986C203.039 28.88 203.263 29.3813 203.658 29.744C204.053 30.1067 204.538 30.288 205.114 30.288C205.946 30.288 206.538 29.9307 206.89 29.216H209.306C209.05 30.0693 208.559 30.7733 207.834 31.328C207.109 31.872 206.218 32.144 205.162 32.144C204.309 32.144 203.541 31.9573 202.858 31.584C202.186 31.2 201.658 30.6613 201.274 29.968C200.901 29.2747 200.714 28.4747 200.714 27.568C200.714 26.6507 200.901 25.8453 201.274 25.152C201.647 24.4587 202.17 23.9253 202.842 23.552C203.514 23.1787 204.287 22.992 205.162 22.992C206.005 22.992 206.757 23.1733 207.418 23.536C208.09 23.8987 208.607 24.416 208.97 25.088C209.343 25.7493 209.53 26.512 209.53 27.376ZM207.21 26.736C207.199 26.16 206.991 25.7013 206.586 25.36C206.181 25.008 205.685 24.832 205.098 24.832C204.543 24.832 204.074 25.0027 203.69 25.344C203.317 25.6747 203.087 26.1387 203.002 26.736H207.21ZM215.437 32.144C214.712 32.144 214.061 32.016 213.485 31.76C212.909 31.4933 212.45 31.136 212.109 30.688C211.778 30.24 211.597 29.744 211.565 29.2H213.821C213.864 29.5413 214.029 29.824 214.317 30.048C214.616 30.272 214.984 30.384 215.421 30.384C215.848 30.384 216.178 30.2987 216.413 30.128C216.658 29.9573 216.781 29.7387 216.781 29.472C216.781 29.184 216.632 28.9707 216.333 28.832C216.045 28.6827 215.581 28.5227 214.941 28.352C214.28 28.192 213.736 28.0267 213.309 27.856C212.893 27.6853 212.53 27.424 212.221 27.072C211.922 26.72 211.773 26.2453 211.773 25.648C211.773 25.1573 211.912 24.7093 212.189 24.304C212.477 23.8987 212.882 23.5787 213.405 23.344C213.938 23.1093 214.562 22.992 215.277 22.992C216.333 22.992 217.176 23.2587 217.805 23.792C218.434 24.3147 218.781 25.024 218.845 25.92H216.701C216.669 25.568 216.52 25.2907 216.253 25.088C215.997 24.8747 215.65 24.768 215.213 24.768C214.808 24.768 214.493 24.8427 214.269 24.992C214.056 25.1413 213.949 25.3493 213.949 25.616C213.949 25.9147 214.098 26.144 214.397 26.304C214.696 26.4533 215.16 26.608 215.789 26.768C216.429 26.928 216.957 27.0933 217.373 27.264C217.789 27.4347 218.146 27.7013 218.445 28.064C218.754 28.416 218.914 28.8853 218.925 29.472C218.925 29.984 218.781 30.4427 218.493 30.848C218.216 31.2533 217.81 31.5733 217.277 31.808C216.754 32.032 216.141 32.144 215.437 32.144Z",
                                        fill: "#F9F9F9"
                                    })
                                ]
                            }),
                            !showAll && /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "267",
                                height: "53",
                                viewBox: "0 0 267 53",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "cp",
                                style: {
                                    padding: '20px'
                                },
                                onClick: toggleShowAll,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                        opacity: "0.8",
                                        width: "267",
                                        height: "53",
                                        rx: "26.5",
                                        fill: "#060606"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M67.0944 32.112C66.3157 32.112 65.6117 31.9787 64.9824 31.712C64.3637 31.4453 63.873 31.0613 63.5104 30.56C63.1477 30.0587 62.961 29.4667 62.9504 28.784H65.3504C65.3824 29.2427 65.5424 29.6053 65.8304 29.872C66.129 30.1387 66.5344 30.272 67.0464 30.272C67.569 30.272 67.9797 30.1493 68.2784 29.904C68.577 29.648 68.7264 29.3173 68.7264 28.912C68.7264 28.5813 68.625 28.3093 68.4224 28.096C68.2197 27.8827 67.9637 27.7173 67.6544 27.6C67.3557 27.472 66.9397 27.3333 66.4064 27.184C65.681 26.9707 65.089 26.7627 64.6304 26.56C64.1824 26.3467 63.793 26.032 63.4624 25.616C63.1424 25.1893 62.9824 24.624 62.9824 23.92C62.9824 23.2587 63.1477 22.6827 63.4784 22.192C63.809 21.7013 64.273 21.328 64.8704 21.072C65.4677 20.8053 66.1504 20.672 66.9184 20.672C68.0704 20.672 69.0037 20.9547 69.7184 21.52C70.4437 22.0747 70.8437 22.8533 70.9184 23.856H68.4544C68.433 23.472 68.2677 23.1573 67.9584 22.912C67.6597 22.656 67.2597 22.528 66.7584 22.528C66.321 22.528 65.969 22.64 65.7024 22.864C65.4464 23.088 65.3184 23.4133 65.3184 23.84C65.3184 24.1387 65.4144 24.3893 65.6064 24.592C65.809 24.784 66.0544 24.944 66.3424 25.072C66.641 25.1893 67.057 25.328 67.5904 25.488C68.3157 25.7013 68.9077 25.9147 69.3664 26.128C69.825 26.3413 70.2197 26.6613 70.5504 27.088C70.881 27.5147 71.0464 28.0747 71.0464 28.768C71.0464 29.3653 70.8917 29.92 70.5824 30.432C70.273 30.944 69.8197 31.3547 69.2224 31.664C68.625 31.9627 67.9157 32.112 67.0944 32.112ZM82.1084 27.376C82.1084 27.696 82.087 27.984 82.0444 28.24H75.5644C75.6177 28.88 75.8417 29.3813 76.2364 29.744C76.631 30.1067 77.1164 30.288 77.6924 30.288C78.5244 30.288 79.1164 29.9307 79.4684 29.216H81.8844C81.6284 30.0693 81.1377 30.7733 80.4124 31.328C79.687 31.872 78.7964 32.144 77.7404 32.144C76.887 32.144 76.119 31.9573 75.4364 31.584C74.7644 31.2 74.2364 30.6613 73.8524 29.968C73.479 29.2747 73.2924 28.4747 73.2924 27.568C73.2924 26.6507 73.479 25.8453 73.8524 25.152C74.2257 24.4587 74.7484 23.9253 75.4204 23.552C76.0924 23.1787 76.8657 22.992 77.7404 22.992C78.583 22.992 79.335 23.1733 79.9964 23.536C80.6684 23.8987 81.1857 24.416 81.5484 25.088C81.9217 25.7493 82.1084 26.512 82.1084 27.376ZM79.7884 26.736C79.7777 26.16 79.5697 25.7013 79.1644 25.36C78.759 25.008 78.263 24.832 77.6764 24.832C77.1217 24.832 76.6524 25.0027 76.2684 25.344C75.895 25.6747 75.6657 26.1387 75.5804 26.736H79.7884ZM92.8634 27.376C92.8634 27.696 92.842 27.984 92.7994 28.24H86.3194C86.3727 28.88 86.5967 29.3813 86.9914 29.744C87.386 30.1067 87.8714 30.288 88.4474 30.288C89.2794 30.288 89.8714 29.9307 90.2234 29.216H92.6394C92.3834 30.0693 91.8927 30.7733 91.1674 31.328C90.442 31.872 89.5514 32.144 88.4954 32.144C87.642 32.144 86.874 31.9573 86.1914 31.584C85.5194 31.2 84.9914 30.6613 84.6074 29.968C84.234 29.2747 84.0474 28.4747 84.0474 27.568C84.0474 26.6507 84.234 25.8453 84.6074 25.152C84.9807 24.4587 85.5034 23.9253 86.1754 23.552C86.8474 23.1787 87.6207 22.992 88.4954 22.992C89.338 22.992 90.09 23.1733 90.7514 23.536C91.4234 23.8987 91.9407 24.416 92.3034 25.088C92.6767 25.7493 92.8634 26.512 92.8634 27.376ZM90.5434 26.736C90.5327 26.16 90.3247 25.7013 89.9194 25.36C89.514 25.008 89.018 24.832 88.4314 24.832C87.8767 24.832 87.4074 25.0027 87.0234 25.344C86.65 25.6747 86.4207 26.1387 86.3354 26.736H90.5434ZM106.919 29.872H102.471L101.735 32H99.3829L103.399 20.816H106.007L110.023 32H107.655L106.919 29.872ZM106.311 28.08L104.695 23.408L103.079 28.08H106.311ZM114.644 20.16V32H112.404V20.16H114.644ZM119.977 20.16V32H117.737V20.16H119.977ZM134.659 20.832V22.64H130.003V25.504H133.571V27.28H130.003V32H127.763V20.832H134.659ZM145.367 27.376C145.367 27.696 145.346 27.984 145.303 28.24H138.823C138.876 28.88 139.1 29.3813 139.495 29.744C139.89 30.1067 140.375 30.288 140.951 30.288C141.783 30.288 142.375 29.9307 142.727 29.216H145.143C144.887 30.0693 144.396 30.7733 143.671 31.328C142.946 31.872 142.055 32.144 140.999 32.144C140.146 32.144 139.378 31.9573 138.695 31.584C138.023 31.2 137.495 30.6613 137.111 29.968C136.738 29.2747 136.551 28.4747 136.551 27.568C136.551 26.6507 136.738 25.8453 137.111 25.152C137.484 24.4587 138.007 23.9253 138.679 23.552C139.351 23.1787 140.124 22.992 140.999 22.992C141.842 22.992 142.594 23.1733 143.255 23.536C143.927 23.8987 144.444 24.416 144.807 25.088C145.18 25.7493 145.367 26.512 145.367 27.376ZM143.047 26.736C143.036 26.16 142.828 25.7013 142.423 25.36C142.018 25.008 141.522 24.832 140.935 24.832C140.38 24.832 139.911 25.0027 139.527 25.344C139.154 25.6747 138.924 26.1387 138.839 26.736H143.047ZM147.306 27.536C147.306 26.64 147.482 25.8453 147.834 25.152C148.197 24.4587 148.682 23.9253 149.29 23.552C149.909 23.1787 150.597 22.992 151.354 22.992C152.015 22.992 152.591 23.1253 153.082 23.392C153.583 23.6587 153.983 23.9947 154.282 24.4V23.136H156.538V32H154.282V30.704C153.994 31.12 153.594 31.4667 153.082 31.744C152.581 32.0107 151.999 32.144 151.338 32.144C150.591 32.144 149.909 31.952 149.29 31.568C148.682 31.184 148.197 30.6453 147.834 29.952C147.482 29.248 147.306 28.4427 147.306 27.536ZM154.282 27.568C154.282 27.024 154.175 26.56 153.962 26.176C153.749 25.7813 153.461 25.4827 153.098 25.28C152.735 25.0667 152.346 24.96 151.93 24.96C151.514 24.96 151.13 25.0613 150.778 25.264C150.426 25.4667 150.138 25.7653 149.914 26.16C149.701 26.544 149.594 27.0027 149.594 27.536C149.594 28.0693 149.701 28.5387 149.914 28.944C150.138 29.3387 150.426 29.6427 150.778 29.856C151.141 30.0693 151.525 30.176 151.93 30.176C152.346 30.176 152.735 30.0747 153.098 29.872C153.461 29.6587 153.749 29.36 153.962 28.976C154.175 28.5813 154.282 28.112 154.282 27.568ZM162.214 24.976V29.264C162.214 29.5627 162.283 29.7813 162.422 29.92C162.571 30.048 162.817 30.112 163.158 30.112H164.198V32H162.79C160.902 32 159.958 31.0827 159.958 29.248V24.976H158.902V23.136H159.958V20.944H162.214V23.136H164.198V24.976H162.214ZM175.057 23.136V32H172.801V30.88C172.513 31.264 172.134 31.568 171.665 31.792C171.206 32.0053 170.705 32.112 170.161 32.112C169.468 32.112 168.854 31.968 168.321 31.68C167.788 31.3813 167.366 30.9493 167.057 30.384C166.758 29.808 166.609 29.1253 166.609 28.336V23.136H168.849V28.016C168.849 28.72 169.025 29.264 169.377 29.648C169.729 30.0213 170.209 30.208 170.817 30.208C171.436 30.208 171.921 30.0213 172.273 29.648C172.625 29.264 172.801 28.72 172.801 28.016V23.136H175.057ZM180.387 24.512C180.675 24.0427 181.048 23.6747 181.507 23.408C181.976 23.1413 182.51 23.008 183.107 23.008V25.36H182.515C181.811 25.36 181.278 25.5253 180.915 25.856C180.563 26.1867 180.387 26.7627 180.387 27.584V32H178.147V23.136H180.387V24.512ZM193.736 27.376C193.736 27.696 193.715 27.984 193.672 28.24H187.192C187.245 28.88 187.469 29.3813 187.864 29.744C188.259 30.1067 188.744 30.288 189.32 30.288C190.152 30.288 190.744 29.9307 191.096 29.216H193.512C193.256 30.0693 192.765 30.7733 192.04 31.328C191.315 31.872 190.424 32.144 189.368 32.144C188.515 32.144 187.747 31.9573 187.064 31.584C186.392 31.2 185.864 30.6613 185.48 29.968C185.107 29.2747 184.92 28.4747 184.92 27.568C184.92 26.6507 185.107 25.8453 185.48 25.152C185.853 24.4587 186.376 23.9253 187.048 23.552C187.72 23.1787 188.493 22.992 189.368 22.992C190.211 22.992 190.963 23.1733 191.624 23.536C192.296 23.8987 192.813 24.416 193.176 25.088C193.549 25.7493 193.736 26.512 193.736 27.376ZM191.416 26.736C191.405 26.16 191.197 25.7013 190.792 25.36C190.387 25.008 189.891 24.832 189.304 24.832C188.749 24.832 188.28 25.0027 187.896 25.344C187.523 25.6747 187.293 26.1387 187.208 26.736H191.416ZM199.643 32.144C198.918 32.144 198.267 32.016 197.691 31.76C197.115 31.4933 196.656 31.136 196.315 30.688C195.984 30.24 195.803 29.744 195.771 29.2H198.027C198.07 29.5413 198.235 29.824 198.523 30.048C198.822 30.272 199.19 30.384 199.627 30.384C200.054 30.384 200.384 30.2987 200.619 30.128C200.864 29.9573 200.987 29.7387 200.987 29.472C200.987 29.184 200.838 28.9707 200.539 28.832C200.251 28.6827 199.787 28.5227 199.147 28.352C198.486 28.192 197.942 28.0267 197.515 27.856C197.099 27.6853 196.736 27.424 196.427 27.072C196.128 26.72 195.979 26.2453 195.979 25.648C195.979 25.1573 196.118 24.7093 196.395 24.304C196.683 23.8987 197.088 23.5787 197.611 23.344C198.144 23.1093 198.768 22.992 199.483 22.992C200.539 22.992 201.382 23.2587 202.011 23.792C202.64 24.3147 202.987 25.024 203.051 25.92H200.907C200.875 25.568 200.726 25.2907 200.459 25.088C200.203 24.8747 199.856 24.768 199.419 24.768C199.014 24.768 198.699 24.8427 198.475 24.992C198.262 25.1413 198.155 25.3493 198.155 25.616C198.155 25.9147 198.304 26.144 198.603 26.304C198.902 26.4533 199.366 26.608 199.995 26.768C200.635 26.928 201.163 27.0933 201.579 27.264C201.995 27.4347 202.352 27.7013 202.651 28.064C202.96 28.416 203.12 28.8853 203.131 29.472C203.131 29.984 202.987 30.4427 202.699 30.848C202.422 31.2533 202.016 31.5733 201.483 31.808C200.96 32.032 200.347 32.144 199.643 32.144Z",
                                        fill: "#F9F9F9"
                                    })
                                ]
                            }),
                            !showAll && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "c4",
                                        children: [
                                            data?.length - len,
                                            " more Features to go "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcc mt1rem mb2rem fw500 ",
                                        style: {
                                            lineHeight: '24px',
                                            color: '#15131380',
                                            fontSize: '12px',
                                            fontStyle: 'italic'
                                        },
                                        children: "* = Expansion Packs are additional to Pro subscription and are charged separately"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "df jcc cp",
                                        style: {
                                            width: "100%",
                                            color: '#151313'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `row pl2rem pr2rem bottom-features ${data?.length - len === 5 ? "w70" : data?.length - len === 2 ? "w30" : 'w50'}`,
                                            children: data?.slice(len)?.map((obj, inIndex)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    style: {
                                                        width: data?.length - len === 3 ? '33.3%' : data?.length - len === 2 ? "50%" : data?.length - len === 5 ? "20%" : '25%'
                                                    },
                                                    children: obj?.title.includes('-') ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "c4-hover column df fdc jcs",
                                                        onClick: toggleShowAll,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    "\u2022 ",
                                                                    obj?.title?.split(" - ")?.[0]
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                children: obj?.title?.split(" - ")?.[1]
                                                            })
                                                        ]
                                                    }, inIndex) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "c4-hover column df jcs",
                                                        onClick: toggleShowAll,
                                                        children: [
                                                            "\u2022 ",
                                                            obj?.title
                                                        ]
                                                    }, inIndex)
                                                });
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 32 32",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "cp jumping-button",
                                        style: {
                                            margin: "20px 0px"
                                        },
                                        onClick: toggleShowAll,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M14.6641 7.39612L14.6641 21.818L10.276 17.43C9.01561 16.1696 7.12507 18.0602 8.38547 19.3206L12.388 23.3169L15.0599 25.9847C15.58 26.5017 16.42 26.5017 16.9402 25.9847L23.612 19.3206C23.8725 19.0671 24.0187 18.7181 24.0157 18.3545C24.0155 17.1542 22.5536 16.5652 21.7213 17.43L17.3332 21.8284L17.3332 7.32711C17.2415 5.47859 14.5721 5.61661 14.6641 7.39612Z",
                                            fill: "#060606"
                                        })
                                    })
                                ]
                            }),
                            showAll && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "32",
                                height: "32",
                                viewBox: "0 0 32 32",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "cp pb2rem",
                                onClick: toggleShowAll,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M17.336 24.6039L17.336 10.182L21.7241 14.57C22.9845 15.8304 24.875 13.9398 23.6147 12.6794L19.6121 8.68308L16.9402 6.01534C16.4201 5.4983 15.5801 5.4983 15.06 6.01534L8.38812 12.6794C8.12758 12.9329 7.9814 13.2819 7.98442 13.6455C7.98457 14.8458 9.4465 15.4348 10.2788 14.57L14.6669 10.1716L14.6669 24.6729C14.7586 26.5214 17.4281 26.3834 17.336 24.6039Z",
                                    fill: "#060606"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "keyFeatureSeeMore",
                open: modal['open'] == 'openSeeMore',
                onClose: onModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 p3rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '1rem',
                        maxWidth: '1350px',
                        ...selectedFeature?.seeMoreSection?.cardPaddingBottom
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        width: "55%",
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mb2rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 df aic",
                                                    children: selectedFeature?.seeMoreSection?.icon
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w90 fw500 c15 pl1rem df aic",
                                                    style: {
                                                        fontSize: '26px',
                                                        lineHeight: '37.32px'
                                                    },
                                                    children: selectedFeature?.seeMoreSection?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: " mt0-5rem",
                                            style: {
                                                paddingLeft: '22px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    style: {
                                                        lineHeight: (index === 0 || index === arrr?.length - 1) && '0px',
                                                        paddingBottom: index === 0 ? "15px" : "3px",
                                                        paddingTop: index === arrr?.length - 1 ? '15px' : "3px",
                                                        paddingLeft: "20px",
                                                        borderLeft: '2px solid #D3D9FC',
                                                        ...selectedFeature?.seeMoreSection?.liStyle
                                                    },
                                                    className: "df fdc fs1rem c14 fs1rem fw400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "circle"
                                                                }),
                                                                objpoints
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: selectedFeature?.seeMoreSection?.subMenu && selectedFeature?.seeMoreSection?.subMenu?.index === index && selectedFeature?.seeMoreSection?.subMenu?.points?.map((str, i, arr)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                    style: {
                                                                        lineHeight: '20px',
                                                                        marginTop: (index === arrr?.length - 1 || index === 0) && i === 0 && '1rem'
                                                                    },
                                                                    children: str
                                                                });
                                                            })
                                                        })
                                                    ]
                                                }, `${objpoints}-${index}`);
                                            })
                                        }),
                                        selectedFeature?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt1rem",
                                            style: {
                                                border: '1px solid gray',
                                                padding: "10px",
                                                borderRadius: '10px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.notePoint
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jce",
                                    style: {
                                        width: '45%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedFeature?.seeMoreSection?.image,
                                        className: "w100 h100",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                })
                            ]
                        }),
                        selectedFeature?.['isInvestorLookupBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                            onClick: ()=>onModalClose(),
                            to: "#investor-lookup",
                            className: "my2rem p1rem px2rem shadow c1 bg4 bg3-hover br35px cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                            children: "Investor Database Check"
                        }),
                        selectedFeature?.['isTwoMinuteTestBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                            onClick: ()=>onModalClose(),
                            to: "#not-sure-yet",
                            className: "my2rem p1rem px2rem shadow c1 bg4 bg3-hover br35px cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                            children: "Take FREE Test"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#F9F9F9"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "#151313"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $4b5290202474e6ed$export$2e2bcd8739ae039 = $4b5290202474e6ed$var$Keyfeatures;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $121a871ca085f0a0$var$ContentCard = ({ description: description, title: title, icon: icon })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "col-sm bg1 br60px p2rem cp oh new-shadow shadowContainer bsbb",
        style: {
            width: '47%'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "shadowPaperCrasouel",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aifs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "br10px bg19 p0-5rem",
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fw500 fs1-5rem ml2rem c15 df tas df jcsb w100 xlfdc",
                            style: {
                                lineHeight: '39.81px',
                                textAlign: 'left'
                            },
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fw400 fs1-25rem mt1rem c14 tas px1rem pr3rem",
                    style: {
                        lineHeight: '2rem'
                    },
                    children: description
                })
            ]
        })
    });
};
var $121a871ca085f0a0$export$2e2bcd8739ae039 = $121a871ca085f0a0$var$ContentCard;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $548dc43ff1aaadf8$var$VideoSection = ({ data: data, refs: refs, isAnimationVisible: isAnimationVisible, playVideo: playVideo, isPlay: isPlay })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "video-container bg20 pr bscon brne",
        style: {
            backgroundImage: `url(${(parcelRequire("jtDwL"))})`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: refs?.current?.[6],
                className: `df jcc tslp ${isAnimationVisible?.[6] ? 'op1 tty0' : 'op0 ttx20'}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fw500 fs2-125rem c15 tac w60",
                    style: {
                        lineHeight: '62.2px'
                    },
                    children: data?.title
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pr ma cp w70 br40px mt3rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                        id: "video",
                        className: "bg1 bsbb pr bss bw5px bo5 w100 br40px",
                        controls: true,
                        poster: data?.thumbnail,
                        preload: "none",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("source", {
                            src: data?.videoURL,
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        onClick: (e)=>playVideo(e),
                        className: `${isPlay && 'dn'}  pa center`,
                        style: {
                            width: '80px',
                            height: '80px'
                        },
                        width: "146",
                        height: "146",
                        viewBox: "0 0 146 146",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M73.1295 0.384033C33.2267 0.384033 0.767578 32.8463 0.767578 72.7459C0.767578 112.646 33.2267 145.108 73.1295 145.108C113.032 145.108 145.491 112.646 145.491 72.7459C145.491 32.8463 113.032 0.384033 73.1295 0.384033ZM101.896 75.2811L59.6854 102.417C59.1908 102.738 58.6195 102.897 58.0542 102.897C57.5595 102.897 57.0589 102.773 56.6115 102.529C55.6397 101.999 55.039 100.986 55.039 99.8816V45.6102C55.039 44.5061 55.6397 43.4931 56.6115 42.9631C57.5654 42.439 58.7608 42.4712 59.6854 43.075L101.896 70.2107C102.756 70.7642 103.28 71.7213 103.28 72.7459C103.28 73.7706 102.756 74.7274 101.896 75.2811Z",
                            fill: "white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("bEcQf")),
                className: "w10 pa",
                style: {
                    top: '-70px',
                    right: '0px',
                    width: '110px'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("g80Ou")),
                className: "pa",
                style: {
                    width: '14% ',
                    top: '-70px',
                    left: '-129px'
                }
            })
        ]
    });
};
var $548dc43ff1aaadf8$export$2e2bcd8739ae039 = $548dc43ff1aaadf8$var$VideoSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $07a979154404148b$var$style = {
    lineHeight: '30px',
    textAlign: "left"
};



const $07a979154404148b$var$ReviewSection = ({ data: data, refs: refs, isAnimationVisible: isAnimationVisible })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "client-review-container bg20 pr",
        style: {
            ...data?.containerStyle
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: refs?.current?.[2],
                className: `df jcc tslp mb2-5rem ${isAnimationVisible[2] ? 'op1 tty0' : 'op0 ttx20'}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "c15 fw500 fs2-125rem",
                    style: {
                        lineHeight: '55px'
                    },
                    children: data?.title
                })
            }),
            data?.isExtandable ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 br40px pr pt3rem px3rem mt4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fw400 fs1-25rem c14 ",
                        style: {
                            lineHeight: '36px',
                            textAlign: 'left'
                        },
                        children: data?.description?.desc1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mt1rem fw400 fs1-25rem c14 ",
                        style: {
                            lineHeight: '36px',
                            textAlign: 'left'
                        },
                        children: data?.description?.desc2
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w60 mt1rem mb3rem pr3rem",
                                children: [
                                    data?.description?.desc3 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt1rem fw400 fs1-25rem c14 ",
                                        style: {
                                            lineHeight: '36px',
                                            textAlign: 'left'
                                        },
                                        children: data?.description?.desc3
                                    }),
                                    data?.description?.desc4 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt1rem fw400 fs1-25rem c14 ",
                                        style: {
                                            lineHeight: '36px',
                                            textAlign: 'left'
                                        },
                                        children: data?.description?.desc4
                                    }),
                                    data?.description?.desc5 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt1rem fw400 fs1-25rem c14 ",
                                        style: {
                                            lineHeight: '36px',
                                            textAlign: 'left'
                                        },
                                        children: data?.description?.desc5
                                    }),
                                    data?.description?.desc6 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt1rem fw400 fs1-25rem c14 ",
                                        style: {
                                            lineHeight: '24.88px',
                                            textAlign: 'left'
                                        },
                                        children: data?.description?.desc6
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt2rem fw500 fs1-25rem c15",
                                        style: {
                                            lineHeight: '36px'
                                        },
                                        children: data?.description?.clientName
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw300 fs1rem c14",
                                        style: {
                                            lineHeight: '36px'
                                        },
                                        children: data?.description?.designation
                                    }),
                                    data?.['isInvestorLookupBtn'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                                        to: "#investor-lookup",
                                        className: "registerButtonAnimation mt2rem pt1rem pb1rem pl2rem pr2rem shadow c1 bg4 bg3-hover br35px mt1rem mb1rem mr2-5rem cp fw600 fs0-75rem pr zi0 br10px td250 registerButtonAnimation secend-sec-btn",
                                        children: [
                                            "Investor Database Check",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    width: "21",
                                                    height: "18",
                                                    viewBox: "0 0 21 18",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M1.39612 10.336H15.818L11.43 14.7241C10.1696 15.9845 12.0602 17.875 13.3206 16.6147L17.3169 12.6121L19.9847 9.94019C20.5017 9.42008 20.5017 8.58008 19.9847 8.05996L13.3206 1.38812C13.0671 1.12758 12.7181 0.981397 12.3545 0.984421C11.1542 0.984572 10.5652 2.4465 11.43 3.2788L15.8284 7.66688H1.32711C-0.521408 7.75859 -0.383387 10.4281 1.39612 10.336Z",
                                                        fill: "#FC7785"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w40 df jce review-img",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: data?.clientImage,
                                    style: {
                                        width: '62%',
                                        ...data?.clientImageStyle
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("isHPH")),
                        className: "ar pa",
                        style: {
                            width: '4%',
                            top: '-15px',
                            right: '-14px'
                        }
                    })
                ]
            }) : //Section for those who have text only on left 
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg1 br30px pr pt2rem  pr3rem pl3rem mt2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df w100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w60 mt1-5rem mb3rem pr3rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw400 fs1-25rem c14",
                                        style: {
                                            ...$07a979154404148b$var$style
                                        },
                                        children: data?.description?.desc1
                                    }),
                                    data?.description?.desc2 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt1rem fw400 fs1-25rem c14",
                                        style: {
                                            ...$07a979154404148b$var$style
                                        },
                                        children: data?.description?.desc2
                                    }),
                                    data?.description?.desc3 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt1rem fw400 fs1-25rem c14",
                                        style: {
                                            ...$07a979154404148b$var$style
                                        },
                                        children: data?.description?.desc3
                                    }),
                                    data?.description?.desc4 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt1rem fw400 fs1-25rem c14",
                                        style: {
                                            ...$07a979154404148b$var$style
                                        },
                                        children: data?.description?.desc4
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "mt2rem fw500 fs1-5rem c15",
                                        style: {
                                            lineHeight: '36px'
                                        },
                                        children: data?.description?.clientName
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw300 fs1-25rem c14",
                                        style: {
                                            lineHeight: '36px'
                                        },
                                        children: data?.description?.designation
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w40 df jce review-img",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: data?.clientImage,
                                    style: {
                                        ...data?.imageStyle
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("isHPH")),
                        className: "ar pa",
                        style: {
                            width: '4%',
                            top: '-15px',
                            right: '-14px'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: (parcelRequire("huYd5")),
                className: "pa",
                style: {
                    width: '7%',
                    top: '-106px',
                    left: '0px'
                }
            })
        ]
    });
};
var $07a979154404148b$export$2e2bcd8739ae039 = $07a979154404148b$var$ReviewSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $49f316fc09454086$var$PricingSection = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "pricing-container bg1 pr bscon brne pr",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `pb2rem df jcc fdc tslp ttx20`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fw500 fs2-125rem c15 tac w60",
                        style: {
                            lineHeight: '62.2px'
                        },
                        children: [
                            "Our ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Pricing"
                            }),
                            " Plan"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "fw400 fs1rem c15 mt0-5rem mb1rem tac",
                        style: {
                            lineHeight: '#151313'
                        },
                        children: [
                            "We offer a range of pricing plans tailored to fit your needs. To explore the details of each plan ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "and find the one that's right for you, please see the complete list."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "cp fw400 df jcc w100",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/pricing-plan",
                    className: "bsbb jcc w300px df fdc aic fw500 py0-5rem c1 bg3 br19px cp",
                    children: "See Details"
                })
            })
        ]
    });
};
var $49f316fc09454086$export$2e2bcd8739ae039 = $49f316fc09454086$var$PricingSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $8aa2eea31a033eba$var$settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...window.innerWidth < 768 && {
        adaptiveHeight: true
    }
};

const $8aa2eea31a033eba$var$AboutUsCrousel = ({ crouselClass: crouselClass, data: data, hasNoPadding: hasNoPadding })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: `${crouselClass} ${hasNoPadding ? ' pt1rem pb3rem bscov pr pl4rem pr4rem silder-box pr oh' : " pt1rem pb3rem bscov pr pl4rem pr4rem silder-box pr oh"}`,
            style: {
                backgroundImage: !hasNoPadding && `url(${(parcelRequire("aXBsB"))})`
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                ...$8aa2eea31a033eba$var$settings,
                interval: hasNoPadding && 6000,
                autoPlay: hasNoPadding ? true : false,
                children: data?.slider?.map((component, idx)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `df fdc aic tac tslp`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fw500 fs2-125rem mb1rem c15 aboutTitleSection",
                                        style: {
                                            lineHeight: '44px',
                                            width: '100%'
                                        },
                                        children: data?.title?.[idx]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "fw400 fs1-25rem c15 mb1rem smfs1rem",
                                        style: {
                                            lineHeight: '29px'
                                        },
                                        children: data?.subTitle?.[idx]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: idx == 0 && 'first-slide',
                                children: component
                            })
                        ]
                    });
                })
            })
        })
    });
};
var $8aa2eea31a033eba$export$2e2bcd8739ae039 = $8aa2eea31a033eba$var$AboutUsCrousel;



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");
var $789841e442673d90$export$2a51ca354add32e1 = function maskEmail(stringValue) {
    var oldStringValue = stringValue;
    var re = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
    var foundEmails = [];
    var match;
    while(match = stringValue.match(re)){
        foundEmails.push(match[0]);
        stringValue = stringValue.replace(match[0], "");
    }
    var maskedEmails = [];
    for(var i = 0; i < foundEmails.length; i++){
        var strArr = foundEmails[i].split('@');
        var left = strArr[0].length <= 1 ? '*' : strArr[0].length <= 2 ? '**' : strArr[0].slice(0, 1) + '*'.repeat(strArr[0].length - 2) + strArr[0].slice(strArr[0].length - 1, strArr[0].length);
        var domain = strArr[1].split('.')[0];
        var right = domain.length <= 1 ? '*' : domain.length <= 2 ? '**' : domain.slice(0, 1) + '*'.repeat(domain.length - 2) + domain.slice(domain.length - 1, domain.length);
        maskedEmails.push(left + '@' + right + '.' + strArr[1].split('.')[1]);
    }
    stringValue = oldStringValue;
    for(var i = 0; i < foundEmails.length; i++)stringValue = $789841e442673d90$var$replaceAll(stringValue, foundEmails[i], maskedEmails[i]);
    return stringValue;
};
function $789841e442673d90$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($789841e442673d90$var$escapeRegExp(find), 'g'), replace);
}
function $789841e442673d90$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}



var $acw62 = parcelRequire("acw62");





















const $5f914f5770b03b8c$var$InvestorLookup = ({ refs: refs, isAnimationVisible: isAnimationVisible })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [stepNo, setStepNo] = (0, $acw62.useState)(1);
    let [executable, setExecutable] = (0, $acw62.useState)({});
    let [isConfirmed, setIsConfirmed] = (0, $acw62.useState)(false);
    let [isSearchable, setIsSearchable] = (0, $acw62.useState)(true);
    let [isValidEmail, setIsValidEmail] = (0, $acw62.useState)(false);
    let [companyOptions, setCompanyOptions] = (0, $acw62.useState)([]);
    let [isInvestorBio, setIsInvestorBio] = (0, $acw62.useState)(false);
    let [selectedCompany, setSelectedCompany] = (0, $acw62.useState)({});
    let [formData, setFormData] = (0, $acw62.useState)({
        orgName: '',
        ukRegNo: '',
        name: '',
        email: ''
    });
    let searchTimeout;
    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let invalidEmails = [
        '@hotmail.com',
        '@gmail.com'
    ];
    // let invalidEmails = ['@hotmail.com', '@gmail.com', '@yopmail.com'];
    let otherSections = [
        'About the Company',
        'Fit Metrics',
        'Diligence Reports',
        'Detailed Answers',
        'Investors Bespoked Q/A'
    ];
    (0, $acw62.useEffect)(()=>{
        let id;
        if (location?.hash) id = location.hash.split('#')[1];
        if (id) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'howItWorks'
            }));
            setTimeout(()=>document.getElementById(id).scrollIntoView({
                    behavior: "smooth"
                }), 200);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        let id;
        if (location?.hash) id = location.hash.split('#')[1];
        if (id) document.getElementById(id).scrollIntoView({
            behavior: "smooth"
        });
        if (!formData?.['orgName'] || formData?.['orgName'] == '') {
            setCompanyOptions([]);
            setSelectedCompany({});
        }
    }, [
        formData?.['orgName']
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedCompany && selectedCompany['title']) {
            setIsSearchable(false);
            setFormData({
                ...formData,
                orgName: selectedCompany['title'],
                ukRegNo: selectedCompany['company_number']
            });
        }
    }, [
        selectedCompany
    ]);
    const resetStates = ()=>{
        setStepNo(1);
        setIsValidEmail(false);
        setIsConfirmed(false);
        setCompanyOptions([]);
        setSelectedCompany({});
        setFormData({
            orgName: '',
            ukRegNo: '',
            name: '',
            email: ''
        });
        setExecutable({});
    };
    const searchCompany = async (input)=>{
        if (!input) return;
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/search/${input}`);
        if (!response || response['code'] != 200) return;
        setCompanyOptions(response['body']['items'].slice(0, 5));
    };
    const searchCompanyTimeout = (e)=>{
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(()=>searchCompany(e.target.value), 1000);
    };
    const handleSelectCompany = (company)=>{
        // if (!company['isInvestorExists']) showMessage(`This company can't be selected`);
        // else {
        setSelectedCompany(company);
        setCompanyOptions([]);
    // }
    };
    const handleEmailBlur = ()=>{
        if (emailRegex.test(formData?.['email']) == false) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter valid email');
        else if (invalidEmails.some((invalidEmail)=>formData?.['email'].endsWith(invalidEmail))) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('This email domain is not allowed');
        else setIsValidEmail(true);
    };
    const requestInvestorAccess = async ()=>{
        let data = {
            ...executable?.['orgDetails'],
            isInvestorLookup: true,
            userEmail: formData['email'],
            userLastName: formData['name'].split(' ')?.length > 1 ? formData['name'].split(' ')?.[1] : '',
            userFirstName: formData['name'].split(' ')?.length > 1 ? formData['name'].split(' ')?.[0] : formData['name']
        };
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/requestInvestorAccess`, data);
        if (response['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            setStepNo(3);
        }
    };
    const handleInvestorLookupClose = ()=>{
        if (stepNo == 1 || stepNo == 2) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            resetStates();
        } else if (stepNo == 3) {
            if ([
                'login',
                'emailOwner'
            ].includes(executable?.['action'])) {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                resetStates();
            } else setStepNo(2);
        }
    };
    const handleAction = async ()=>{
        if (stepNo == 1) {
            if (formData?.['orgName'] == '' || formData?.['ukRegNo'] == '' || formData?.['name'] == '' || formData?.['email'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out all fields');
            if (formData['name'].split(' ')?.length == 1) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide full name');
            if (invalidEmails.some((invalidEmail)=>formData?.['email'].endsWith(invalidEmail))) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('This email domain is not allowed');
            if (!isConfirmed) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please check the confirmation');
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/company/investorLookup', {
                orgName: formData?.['orgName'],
                ukRegNo: formData?.['ukRegNo'],
                firstName: formData?.['firstName'],
                lastName: formData?.['lastName'],
                email: formData?.['email']
            });
            if (response && response['code'] == 200) {
                setExecutable(response['body']);
                setStepNo(2);
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            }
        } else if (stepNo == 2) {
            if (executable?.['action'] == 'register') {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                resetStates();
                localStorage.removeItem('registerAs');
                window.location = '/register';
            // Redirect to login route
            } else if (executable?.['action'] == 'emailOwner') await requestInvestorAccess();
            else if (executable?.['action'] == 'matched' || executable?.['action'] == 'login') {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                if (executable?.['isVerified']) window.location = '/login';
                else window.location.href = `${location.origin}/reset_password/${executable?.['temp_password']}`;
                resetStates();
            }
        }
    };
    const handleBack = ()=>{
        if (stepNo == 1 && selectedCompany && selectedCompany['title']) setSelectedCompany({});
        else if (stepNo == 2) setExecutable({});
        setStepNo(stepNo - 1);
    };
    const aboutTheInvestorContent = ()=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "h80vh",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "",
                    id: "About the Investor",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "df jcc aic mb1rem fs1-5rem",
                        children: "About the Investor"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "report-start invest-reports",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `progress-area-report`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr bg1 p0-5rem shadow df fww aic mb1rem w80 mla mra br8px",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `user-area w30`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "logo-box df jcc fww w100 mb0-5rem pt1rem blur-disabled",
                                            children: [
                                                executable?.['organisation']?.['company']?.['source']?.['isBVCA'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w30 mr0-5rem",
                                                    src: (parcelRequire("aWpLg")),
                                                    alt: "image"
                                                }),
                                                executable?.['organisation']?.['company']?.['source']?.['isCrunchBase'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w30 mr0-5rem",
                                                    src: (parcelRequire("3c5p9")),
                                                    alt: "image"
                                                }),
                                                executable?.['organisation']?.['company']?.['source']?.['isSeedLegals'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w2rem ",
                                                    src: (parcelRequire("kZBx4")),
                                                    alt: "image"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `user-area w40`,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "logo-box df jcc fww w100 mb0-5rem pt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "shadow h4rem w4rem br100 mb1rem blur-disabled",
                                                    src: executable?.['organisation']?.['company']?.['logo'] || (parcelRequire("cfmAr")),
                                                    alt: "image"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    className: "user-text-fit db tac w100 jcc lh2 fs1rem my0-5rem",
                                                    children: executable?.['organisation']?.['company']?.['cName']
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "progress-box w30",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "progress-bar blur-disabled",
                                                style: {
                                                    width: 40,
                                                    height: 40
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                                    className: `${executable?.['organisation']?.['company']?.['promptScore'] > 67 ? 'green' : executable?.['organisation']?.['company']?.['promptScore'] > 33 ? 'orange' : 'red'}`,
                                                    value: executable?.['organisation']?.['company']?.['promptScore'] || 0,
                                                    text: (executable?.['organisation']?.['company']?.['promptScore'] || 0) + "%",
                                                    styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                                        strokeLinecap: 'round',
                                                        strokeWidth: '5px',
                                                        textSize: '20px',
                                                        pathTransitionDuration: 0.5,
                                                        trailColor: '#d6d6d6',
                                                        backgroundColor: '#fc7785',
                                                        dominantBaseline: 'ideographic'
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    marginBottom: '0',
                                                    fontSize: '10px'
                                                },
                                                className: "text-center-area",
                                                children: "Prompt Response Score"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "progress-area dg gtcr2a gg1rem mb1-3rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "h100 df fdc jcsb aic",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                        className: "list-company-detail",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs0-75rem",
                                                        children: "Full Company Name: "
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs0-75rem fw700 lh1 usn c6 blur-disabled",
                                                        children: executable?.['organisation']?.['company']['cName'] ? executable?.['organisation']?.['company']['cName'] : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs0-75rem",
                                                        children: "Address: "
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs0-75rem fw700 lh1 usn c6 blur-disabled",
                                                        children: executable?.['organisation']?.['company']['cAddress'] ? executable?.['organisation']?.['company']['cAddress'] : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs0-75rem",
                                                        children: "Website: "
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs0-75rem fw700 lh1 usn c6 blur-disabled",
                                                        children: executable?.['organisation']?.['company']['cWebsite'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                            className: "tdu wordbreak",
                                                            href: executable?.['organisation']?.['company']['cWebsite'],
                                                            target: "_blank",
                                                            children: executable?.['organisation']?.['company']['cWebsite']
                                                        }) : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "df aic ass fs0-75rem tar",
                                                    children: [
                                                        "Tel:",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            className: "fs0-75rem fw700 lh1 usn c6 tar ml0-5rem blur-disabled",
                                                            children: executable?.['organisation']?.['company']['cPhone'] && executable?.['organisation']?.['company']['cPhone'] !== '?' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    executable?.['organisation']?.['company']?.['cPhone'],
                                                                    " ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                        className: "cp bg1",
                                                                        id: "copy",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            id: executable?.['organisation']?.['company']?.['cPhone'],
                                                                            className: "fa fa-clipboard c4",
                                                                            style: {
                                                                                fontSize: '12px'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            }) : '-'
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs0-75rem",
                                                        children: "Business Location: "
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs0-75rem fw700 lh1 usn c6 blur-disabled",
                                                        children: executable?.['organisation']?.['company']?.['cCountry'] ? executable?.['organisation']?.['company']?.['cCountry'] : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs0-75rem",
                                                        children: "Funds for Investment: "
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs0-75rem fw700 lh1 usn c6 blur-disabled",
                                                        children: executable?.['organisation']?.['company']?.['fundSize'] ? executable?.['organisation']?.['company']?.['fundSize'] : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs0-75rem",
                                                        children: "No. of Investments made: "
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs0-75rem fw700 lh1 usn c6 blur-disabled",
                                                        children: executable?.['organisation']?.['company']?.['investment']?.['noOfInvestments'] ? executable?.['organisation']?.['company']?.['investment']?.['noOfInvestments'] : '-'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "ass fs0-75rem",
                                                        children: "Date of last Investment: "
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        className: "fs0-75rem fw700 lh1 usn c6 blur-disabled",
                                                        children: executable?.['organisation']?.['company']?.['investment']?.['lastInvestmentDate'] ? executable?.['organisation']?.['company']?.['investment']?.['lastInvestmentDate'] : '-'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "description-box mt1rem mb1rem pr bg1 p1rem shadow df fww aic br8px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "fs1rem mb0-75rem",
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-75rem blur-disabled",
                                children: executable?.['organisation']?.['company']?.['description'] ? executable?.['organisation']?.['company']?.['description'].length > 800 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        executable?.['organisation']?.['company']?.['description'].substring(0, 800),
                                        "..."
                                    ]
                                }) : executable?.['organisation']?.['company']?.['description'] : executable?.['organisation']?.['company']?.['companyDescription'] ? executable?.['organisation']?.['company']?.['companyDescription'].length > 800 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        executable?.['organisation']?.['company']?.['companyDescription'].substring(0, 800),
                                        "..."
                                    ]
                                }) : executable?.['organisation']?.['company']?.['companyDescription'] : '-'
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "description-box mt1rem mb1rem pr bg1 p1rem shadow df fww aic br8px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "fs1rem mb0-75rem",
                            children: "Investment Criteria"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-75rem blur-disabled",
                                children: executable?.['organisation']?.['company']?.['investmentCriteria'] ? executable?.['organisation']?.['company']?.['investmentCriteria'].length > 800 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        executable?.['organisation']?.['company']?.['investmentCriteria'].substring(0, 800),
                                        "..."
                                    ]
                                }) : executable?.['organisation']?.['company']?.['investmentCriteria'] : '-'
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "report-start invest-reports",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `progress-area-report`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `pr bg1 p0-5rem shadow df fww aic mb1rem w60 mla mra br8px`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `user-area w20 blur-disabled`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "user-img",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: " h4rem w4rem br100",
                                            src: executable?.['organisation']?.['company']?.['creatorId']?.['profile'] || executable?.['organisation']?.['company']?.['creatorId']?.['profilePicture'] || (parcelRequire("cfmAr")),
                                            alt: "image"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `progress-box w50 blur-disabled`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "text-box tal",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                className: "fs0-75rem df",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: executable?.['organisation']?.['company']?.['creatorId']?.['firstName'] ? executable?.['organisation']?.['company']?.['creatorId']?.['firstName'] + ' ' + executable?.['organisation']?.['company']?.['creatorId']?.['lastName'] : 'Name'
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                        id: executable?.['organisation']?.['company']?.['creatorId']?.['linkedIn'] ? 'investorLinkedIn' : 'noLinkedIn',
                                                        className: "icon ml0-5rem bg1 cp",
                                                        style: {
                                                            width: '22px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            id: executable?.['organisation']?.['company']?.['creatorId']?.['linkedIn'],
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                id: executable?.['organisation']?.['company']?.['creatorId']?.['linkedIn'],
                                                                version: "1.1",
                                                                className: "f3",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 310 310",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73              C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4              c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599              c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319              c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995              C310,145.43,300.549,94.761,230.454,94.761z"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "fs0-75rem c6",
                                                children: [
                                                    "Phone: ",
                                                    executable?.['organisation']?.['company']?.['creatorId']?.['phone'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            executable?.['organisation']?.['company']?.['creatorId']?.['phone'],
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                className: "cp bg1",
                                                                id: "copy",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    id: executable?.['organisation']?.['company']?.['creatorId']?.['phone'],
                                                                    className: "fa fa-clipboard c4",
                                                                    style: {
                                                                        fontSize: '12px'
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }) : '-'
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "button-list w30",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "shadow bg3 bg4-hover c1 td250 br5px py0-5rem px2rem fw600 usn cp ttu bsbb tac df jcc aic mla mra fs0-75rem",
                                        onClick: ()=>setIsInvestorBio(true),
                                        children: "Bio"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "over-content-btn",
                    className: "btn-group fit-btn-group mt2rem",
                    children: otherSections.map((section, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            id: `content-btn-${idx}`,
                            style: {
                                marginBottom: '5px'
                            },
                            className: `df c6 jcc ttc td250 c3-hover px1rem py0-5rem new-report-btn reports-btn-area`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "pen usn ass mr0-5rem tac fs1rem",
                                children: section
                            })
                        });
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "investor-lookup",
                className: "pr bg20 lpbb investorLookup-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: refs?.current?.[8],
                        className: `tslp pb2rem ${isAnimationVisible[8] ? 'op1 tty0' : 'op0 ttx20'}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "fw500 tac c15 fs2rem",
                            style: {
                                lineHeight: '162.2px'
                            },
                            children: [
                                "Investor & Applicant Curated ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c23",
                                    children: "Lead Matching"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "investor-box df fww aifs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "left-certificate-area df fww w70 pt3rem pb1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "certificate-box tac w20 pr mr1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pa round-box",
                                                src: (parcelRequire("P76E6")),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1rem c1 mb2rem",
                                                children: "Gold Certified"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w8rem",
                                                src: (parcelRequire("aGe1o")),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "certificate-box tac w20 pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pa round-box",
                                                src: (parcelRequire("P76E6")),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "fs1rem c15 mb0-5rem",
                                                children: [
                                                    "Applicant ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " Company Pack"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w8rem",
                                                src: (parcelRequire("giguH")),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "certificate-box tac w35 pr mr1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pa round-box",
                                                src: (parcelRequire("P76E6")),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1rem c15 mb1rem",
                                                children: "\u201CFit\u201D Report"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w200px",
                                                src: (parcelRequire("9itwL")),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "certificate-box tac w20 pr",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pa round-box",
                                                src: (parcelRequire("P76E6")),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "fs1rem c15 mb1rem",
                                                children: "Investor Pack"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w8rem",
                                                src: (parcelRequire("gbppE")),
                                                alt: ""
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w30 list-right-area",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg1 br15px shadow p2rem benefits-box",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: "Benefits For Investor"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "pt1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                    className: "custom-list",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            style: {
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px'
                                                            },
                                                            className: "c14 fs0-75rem fw400 df aic",
                                                            children: "FREE leads generation"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            style: {
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px'
                                                            },
                                                            className: "c14 fs0-75rem fw400 df aic",
                                                            children: "Only for companies with gold certification"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            style: {
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px'
                                                            },
                                                            className: "c14 fs0-75rem fw400 df aic",
                                                            children: "Matched to your investment criteria"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            style: {
                                                                paddingTop: '10px',
                                                                paddingBottom: '10px'
                                                            },
                                                            className: "c14 fs0-75rem fw400 df aic",
                                                            children: "Diligentsia Pack supplied with the lead:"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs0-75rem fw400 df aic ml2rem",
                                                    children: "- Data Repository Report"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs0-75rem fw400 df aic ml2rem",
                                                    children: "- 20-section Business Audit"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs0-75rem fw400 df aic ml2rem",
                                                    children: "- Directors\u2019 Questionnaires"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c14 fs0-75rem fw400 df aic ml2rem",
                                                    children: "- Draft Warranty Disclosures"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 investor-lookup-full-img",
                                style: {
                                    display: 'none'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w100",
                                    src: (parcelRequire("lmLdj")),
                                    alt: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr tac mt2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fw400 fs1rem w100 tac c15 mb1rem",
                                style: {
                                    lineHeight: '24px',
                                    fontSize: '0.96rem'
                                },
                                children: [
                                    "Have we already added your fund/firm and contact details to our database from publicly available information?",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " You can check here (and later update/amend)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "p1rem pl2rem pr2rem shadow c1 bg4 bg3-hover br35px mt1rem mb1rem mr2-5rem cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: 'howItWorks'
                                    })),
                                children: "Investor Database Check"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'howItWorks',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `mah90 oya bg20 shadow w100 pt3rem pl3rem pr3rem pb2rem bsbb df fdc m1rem br20px pr maw80`,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "c15 fs2rem fw400 mb2rem",
                                    children: "How does it work?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcsb aic step-box-modal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "step-box-box-1 w100",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w100",
                                            src: (parcelRequire("24ldb")),
                                            alt: ""
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "p1rem pl4rem pr4rem shadow c1 bg4 bg3-hover br35px mt1rem mb1rem mr2-5rem cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'investorDatabaseCheck'
                                            })),
                                        children: "Let\u2019s Go!"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>{
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })), resetStates();
                            },
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '100px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'investorDatabaseCheck',
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic investor-modal-database",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `mah90 oya bg1 shadow w100 pt3rem pl3rem pr3rem pb2rem bsbb df fdc m1rem br5px pr smp1rem form-modal-steps ${!(stepNo == 2 || stepNo == 3) ? 'maw600px' : 'maw700px'}`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc gg1rem",
                                children: [
                                    stepNo == 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                className: "c15 fs1-5rem fw400 mb2rem",
                                                children: "Investor Lookup"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "text",
                                                            name: "orgName",
                                                            id: "searchCompany",
                                                            onKeyUp: searchCompanyTimeout,
                                                            placeholder: "Enter your fund/firm",
                                                            value: formData?.['orgName'] || '',
                                                            className: "bg1 w100 br10px p1rem bss bs1px bo28",
                                                            onChange: (e)=>{
                                                                setFormData({
                                                                    ...formData,
                                                                    orgName: e['target']['value'],
                                                                    ukRegNo: ''
                                                                }), setIsSearchable(true);
                                                            }
                                                        })
                                                    }),
                                                    formData?.['orgName'] != '' && isSearchable && companyOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "dropdown-box pa b0 w100",
                                                        children: companyOptions.map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                onClick: ()=>handleSelectCompany(option),
                                                                className: `cp df fww jcfs aic shadow br5px p0-5rem bg1`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs0-75rem fw600 mr1rem",
                                                                        children: option['title']
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs0-75rem mr1rem",
                                                                        children: option['company_number']
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs0-75rem ttu fw600",
                                                                        children: option['company_status']
                                                                    })
                                                                ]
                                                            }, idx))
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "pr",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: "name",
                                                    type: "text",
                                                    placeholder: "Enter your name",
                                                    value: formData?.['name'] || '',
                                                    className: "bg1 w100 br10px p1rem bss bs1px bo28",
                                                    onChange: (e)=>setFormData({
                                                            ...formData,
                                                            name: e['target']['value']
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pt0-5rem pb0-5rem pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "email",
                                                        type: "email",
                                                        onBlur: ()=>handleEmailBlur(),
                                                        value: formData?.['email'] || '',
                                                        placeholder: "Enter your company email address",
                                                        className: "bg1 w100 br10px p1rem bss bs1px bo28 pl3rem",
                                                        onChange: (e)=>{
                                                            setFormData({
                                                                ...formData,
                                                                email: e['target']['value']
                                                            }), setIsValidEmail(false);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        style: {
                                                            top: '30px',
                                                            left: '20px'
                                                        },
                                                        className: "pa emailIcon",
                                                        width: "16",
                                                        height: "12",
                                                        viewBox: "0 0 16 12",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z",
                                                            fill: "black"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "pt1rem pb1rem df cp",
                                                for: "confirmation",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w2rem h2rem pr",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "checkbox",
                                                            id: "confirmation",
                                                            checked: isConfirmed,
                                                            onChange: ()=>setIsConfirmed(!isConfirmed),
                                                            className: "bo5 bw2px bss cp td250 w2rem h2rem br10px lpins"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "w100 fs1rem lh3 ml1rem usn fw400 c15",
                                                        style: {
                                                            lineHeight: '28px'
                                                        },
                                                        children: "I confirm that I am authorized by the organisation above to conduct this search."
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : stepNo == 2 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                className: "c15 fs1-5rem fw600 mb2rem",
                                                children: "Search Results - Investor Lookup"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df w100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "text",
                                                                id: "orgResult",
                                                                disabled: true,
                                                                value: formData?.['orgName'] || '',
                                                                className: "pr1rem pl1rem bg1 lpins br10px h40px tal custom-input w90"
                                                            }),
                                                            executable?.['firmFound'] == true ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "21",
                                                                height: "14",
                                                                style: {
                                                                    width: '1.3rem'
                                                                },
                                                                className: "ml1rem mt0-5rem",
                                                                viewBox: "0 0 21 14",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M8.24482 13.3358C8.08872 13.339 7.93353 13.3112 7.78826 13.2541C7.64299 13.1969 7.51053 13.1116 7.39855 13.0029L1.2696 6.8569C1.05196 6.63957 0.929687 6.3448 0.929688 6.03744C0.929687 5.73008 1.05196 5.43531 1.2696 5.21797C1.48724 5.00064 1.78242 4.87853 2.09021 4.87853C2.398 4.87853 2.69318 5.00064 2.91082 5.21797L8.24482 10.5189L18.2204 0.531648C18.4476 0.322891 18.7451 0.207031 19.0538 0.207031C19.3626 0.207031 19.6601 0.322891 19.8873 0.531648C20.1081 0.752507 20.2321 1.05183 20.2321 1.36391C20.2321 1.67599 20.1081 1.97533 19.8873 2.19619L9.06543 13.0029C8.95734 13.1096 8.8292 13.194 8.68837 13.2511C8.54755 13.3082 8.39682 13.337 8.24482 13.3358Z",
                                                                    fill: "#42D342"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                className: "w1rem ml1rem",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 320 512",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    className: "pen fa-primary",
                                                                    fill: "#fd6474",
                                                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df w100 mt0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "text",
                                                                id: "userResult",
                                                                disabled: true,
                                                                value: formData?.['email'] || '',
                                                                className: "pr1rem pl1rem bg1 lpins br10px h40px tal custom-input w90"
                                                            }),
                                                            executable?.['userFound'] == true ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "21",
                                                                height: "14",
                                                                style: {
                                                                    width: '1.3rem'
                                                                },
                                                                className: "ml1rem mt0-5rem",
                                                                viewBox: "0 0 21 14",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M8.24482 13.3358C8.08872 13.339 7.93353 13.3112 7.78826 13.2541C7.64299 13.1969 7.51053 13.1116 7.39855 13.0029L1.2696 6.8569C1.05196 6.63957 0.929687 6.3448 0.929688 6.03744C0.929687 5.73008 1.05196 5.43531 1.2696 5.21797C1.48724 5.00064 1.78242 4.87853 2.09021 4.87853C2.398 4.87853 2.69318 5.00064 2.91082 5.21797L8.24482 10.5189L18.2204 0.531648C18.4476 0.322891 18.7451 0.207031 19.0538 0.207031C19.3626 0.207031 19.6601 0.322891 19.8873 0.531648C20.1081 0.752507 20.2321 1.05183 20.2321 1.36391C20.2321 1.67599 20.1081 1.97533 19.8873 2.19619L9.06543 13.0029C8.95734 13.1096 8.8292 13.194 8.68837 13.2511C8.54755 13.3082 8.39682 13.337 8.24482 13.3358Z",
                                                                    fill: "#42D342"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                className: "w1rem ml1rem",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 320 512",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    className: "pen fa-primary",
                                                                    fill: "#fd6474",
                                                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: "Further information only made available to authorized and verified users logged into platform"
                                            }),
                                            executable?.['action'] == 'matched' && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "bg1 c3 tdu cp my1rem",
                                                onClick: ()=>setStepNo(3),
                                                children: "Investor Report"
                                            })
                                        ]
                                    }) : stepNo == 3 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: executable?.['action'] == 'matched' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: aboutTheInvestorContent()
                                        }) : [
                                            'login',
                                            'emailOwner'
                                        ].includes(executable?.['action']) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                    className: "tac mb1-5rem",
                                                    children: "Access Request Sent"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                "Hi ",
                                                                formData?.['name'],
                                                                ","
                                                            ]
                                                        }),
                                                        executable?.['userFound'] == true ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: " We have your email registered on our platform, but it is NOT associated to this investor account."
                                                        }) : null,
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                "We have emailed the account owner ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: (0, $789841e442673d90$export$2a51ca354add32e1)(executable?.['orgDetails']?.['contactEmail'])
                                                                }),
                                                                " inviting them to add you to their account. Once they grant you access, you will receive a confirmation email to ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                    children: formData?.['email']
                                                                }),
                                                                " granting you access."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                                    ]
                                                })
                                            ]
                                        }) : null
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `df jcsb aic w100 ${stepNo == 1 && 'search-center-btn'}`,
                                        children: [
                                            stepNo == 1 || stepNo == 3 && [
                                                'login',
                                                'emailOwner'
                                            ].includes(executable?.['action']) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `df aic td250 br5px p1rem pr2rem pl2rem bsbb tac c3-hover fs0-75rem cp jcc mt1rem ttu bo3 bss br35px investor-back-btn`,
                                                onClick: ()=>handleBack(),
                                                children: "Back"
                                            }),
                                            stepNo == 3 ? null : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                onClick: ()=>handleAction(),
                                                className: `df aic td250 p1rem pl4rem pr4rem bsbb tac br35px jcc bg4 bg3-hover c1 fw600 ttu fs1rem mr1rem investor-search-btn cp ${stepNo == 1 && (!isValidEmail || !isConfirmed) && 'button-disabled cna'} ${!(stepNo == 2 && [
                                                    'login',
                                                    'matched',
                                                    'emailOwner'
                                                ].includes(executable?.['action'])) ? '' : ''}`,
                                                children: stepNo == 1 ? 'Search' : stepNo == 2 ? executable?.['action'] == 'register' ? 'Register for FREE' : executable?.['action'] == 'matched' || executable?.['action'] == 'login' ? executable?.['isVerified'] ? 'Investor Login' : 'Set Password' : executable?.['action'] == 'emailOwner' ? 'Request Firm Access' : null : null
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>handleInvestorLookupClose(),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '100px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: isInvestorBio,
                onClose: ()=>setIsInvestorBio(false),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah100 oya bg1 shadow w100 px3rem py1rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            "data-scroll-to": "About the Investor",
                            className: "close-popup",
                            onClick: ()=>setIsInvestorBio(false),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr modal-bio investor-leads-tooltip",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "tac c6 lh2 fs1-75rem mb2rem",
                                    children: "Investor Bio"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "user-area blur-disabled",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "user-img",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "h4rem w4rem br100",
                                                src: executable?.['organisation']?.['company']?.['creatorId']?.['profile'] || executable?.['organisation']?.['company']?.['creatorId']?.['profilePicture'] || (parcelRequire("cfmAr")),
                                                alt: "image"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "text-box",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                    className: "fs0-75rem df",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: executable?.['organisation']?.['company']?.['creatorId']?.['firstName'] ? executable?.['organisation']?.['company']?.['creatorId']?.['firstName'] + ' ' + executable?.['organisation']?.['company']?.['creatorId']?.['lastName'] : 'Name'
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "icon ml0-5rem bg1 cp",
                                                            style: {
                                                                width: '22px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                version: "1.1",
                                                                className: "f3",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 310 310",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73 C77.16,101.969,74.922,99.73,72.16,99.73z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4 c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599 c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319 c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995 C310,145.43,300.549,94.761,230.454,94.761z"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs0-75rem df",
                                                    children: executable?.['organisation']?.['company']?.['creatorId']?.['email'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            executable?.['organisation']?.['company']?.['creatorId']?.['email'],
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                className: "cp bg1",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-clipboard c4",
                                                                    style: {
                                                                        fontSize: '12px'
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }) : '-'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs0-75rem df",
                                                    children: executable?.['organisation']?.['company']?.['creatorId']?.['phone'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            executable?.['organisation']?.['company']?.['creatorId']?.['phone'],
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                className: "cp bg1",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-clipboard c4",
                                                                    style: {
                                                                        fontSize: '12px'
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }) : '-'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "description-box mt1rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "fs1rem mb1rem",
                                            children: "Bio"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem blur-disabled",
                                            children: executable?.['organisation']?.['company']?.['creatorId']?.['bio'] ? executable?.['organisation']?.['company']?.['creatorId']?.['bio'] : '-'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "description-box mt1rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            className: "fs1rem mb1rem",
                                            children: "About"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem blur-disabled",
                                            children: executable?.['organisation']?.['company']?.['creatorId']?.['linkedinAbout'] ? executable?.['organisation']?.['company']?.['creatorId']?.['linkedinAbout'] : '-'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $5f914f5770b03b8c$export$2e2bcd8739ae039 = $5f914f5770b03b8c$var$InvestorLookup;



var $ayMG0 = parcelRequire("ayMG0");






var $acw62 = parcelRequire("acw62");









const $844e14ef8ac4298d$var$PlusIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "30px",
        height: "30px",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fd6474",
                d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M21,14h6v20h-6V14z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fill: "#fff",
                d: "M14,21h20v6H14V21z"
            })
        ]
    });
};




const $844e14ef8ac4298d$var$RegisterSection = ({ registerationType: registerationType, refs: refs, isAnimationVisible: isAnimationVisible, registerPage: registerPage })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const company = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const { categories: categories } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.common);
    let [stepNo, setStepNo] = (0, $acw62.useState)(1);
    let [animation, setAnimation] = (0, $acw62.useState)(1);
    let [companyDescription, setCompanyDescription] = (0, $acw62.useState)({});
    let [formData, setFormData] = (0, $acw62.useState)({
        role: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        designation: '',
        phone: '',
        firmName: '',
        firmAddress: '',
        website: '',
        firmLogo: '',
        testType: '',
        company5Words: ''
    });
    let [isAgreed, setIsAgreed] = (0, $acw62.useState)(false);
    let [registerAs, setRegisterAs] = (0, $acw62.useState)('');
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    let [advisorType, setAdvisorType] = (0, $acw62.useState)(false);
    let [passwordType, setPasswordType] = (0, $acw62.useState)(true);
    let [companyOptions, setCompanyOptions] = (0, $acw62.useState)([]);
    let [advisorHashData, setAdvisorHashData] = (0, $acw62.useState)('');
    let [selectedCompany, setSelectedCompany] = (0, $acw62.useState)({});
    let [existingAdvisor, setExistingAdvisor] = (0, $acw62.useState)({});
    let [websiteStatus, setWebsiteStatus] = (0, $acw62.useState)('Check');
    let [advisorTypeValue, setAdvisorTypeValue] = (0, $acw62.useState)('');
    let [isValidPassword, setIsValidPassword] = (0, $acw62.useState)(false);
    let [selectedAdvisorType, setSelectedAdvisorType] = (0, $acw62.useState)(null);
    let [confirmPasswordType, setConfirmPasswordType] = (0, $acw62.useState)(true);
    let [passwordError, setPasswordError] = (0, $acw62.useState)({
        password: '',
        confirmPassword: ''
    });
    let searchTimeout;
    let formCheck = [
        'firstName',
        'lastName',
        'email',
        'password'
    ];
    let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
    // Custom react select 
    const customStyles = {
        control: (provided, state)=>({
                ...provided,
                cursor: "pointer",
                border: 'none',
                boxShadow: 'none',
                minHeight: 'initial'
            }),
        valueContainer: (provided)=>({
                ...provided
            }),
        input: (provided)=>({
                ...provided,
                margin: 0,
                padding: 0
            }),
        placeholder: (provided)=>({
                ...provided,
                margin: 0,
                padding: 0
            }),
        dropdownIndicator: (provided)=>({
                ...provided,
                padding: 0
            }),
        indicatorSeparator: ()=>({
                display: 'none'
            }),
        menu: (provided, state)=>({
                ...provided,
                width: "96%",
                marginTop: 0
            }),
        option: (provided, state)=>({
                ...provided,
                backgroundColor: state.isSelected ? "#fc7785" : state.isFocused ? "#fde3e6" : provided.backgroundColor,
                color: state.isSelected ? "white" : provided.color,
                ':active': {
                    ...provided[':active'],
                    backgroundColor: state.isSelected ? "#fc7785" : "#fde3e6"
                }
            })
    };
    (0, $acw62.useEffect)(()=>{
        if (dispatch) dispatch((0, $defbea5c5b83142b$export$416ec9f5729de215)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        const timeout = setTimeout(()=>setAnimation(true), 2000);
        return ()=>clearTimeout(timeout);
    }, []);
    (0, $acw62.useEffect)(()=>{
        setRegisterAs(registerationType);
        if (registerationType === 'Advisor') setAdvisorType(true);
        setFormData({
            ...formData,
            role: registerationType
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!formData?.['firmName'] || formData?.['firmName'] == '') {
            setCompanyOptions([]);
            setSelectedCompany({});
        }
    }, [
        formData?.['firmName']
    ]);
    //Handle on advisor type added
    const onAdvisorTypeAdded = async ()=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/admin/create/custom-category`, {
            name: advisorTypeValue
        });
        if (res?.code === 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            const newCategories = res?.body ? {
                ...res.body,
                label: res.body.name,
                value: res.body._id
            } : {};
            dispatch((0, $defbea5c5b83142b$export$1ed4ec267b4d265c)([
                newCategories,
                ...categories
            ]));
        }
    };
    const CustomOption = (props)=>{
        const { data: data, innerRef: innerRef, innerProps: innerProps } = props;
        return data.hasAdd ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df jcsb aic",
            ref: innerRef,
            ...advisorTypeValue ? innerProps : {},
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginLeft: '11px',
                        color: advisorTypeValue === '' && 'gray'
                    },
                    children: data.label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71c322247f7fbf93$export$2e2bcd8739ae039), {
                    color: "primary",
                    "aria-label": "upload picture",
                    component: "span",
                    onClick: (event)=>{
                        event.stopPropagation();
                        event.preventDefault();
                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: 'advisorType'
                        }));
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($844e14ef8ac4298d$var$PlusIcon, {})
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e5db4f66b3bbccc3$export$db3b6bfb95261072).Option, {
                ...props
            })
        });
    };
    const resetStates = ()=>{
        setStepNo(1);
        setIsAgreed(false);
        setCompanyOptions([]);
        setSelectedCompany({});
        setWebsiteStatus('Check');
        setIsValidPassword(false);
        setFormData({
            role: '',
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            confirmPassword: '',
            designation: '',
            phone: '',
            firmName: '',
            firmAddress: '',
            website: '',
            firmLogo: '',
            company5Words: ''
        });
    };
    const handleRegisterAs = (value)=>{
        if (value === "Advisor") setAdvisorType(true);
        else setAdvisorType(false);
        setRegisterAs(value);
        setFormData({
            ...formData,
            role: value
        });
        setStepNo(1);
        setIsAgreed(false);
        setCompanyOptions([]);
        setSelectedCompany({});
        setWebsiteStatus('Check');
    };
    //Reseting all advisor type select to intial if radio button change
    (0, $acw62.useEffect)(()=>{
        setSelectedAdvisorType(null);
        setAdvisorTypeValue('');
    }, [
        registerAs
    ]);
    const handlePasswordBlur = (type)=>{
        let errors = {
            ...passwordError
        };
        if (type === 'password') {
            if (formData?.['password'] === '' || formData?.['password'].length < 8) errors['password'] = 'Password must be 8 characters long';
            else if (!passwordPattern.test(formData?.['password'])) errors['password'] = 'Combination of uppercase, lowercase, digit & special character is required';
            else errors['password'] = '';
        }
        if (type === 'confirmPassword' || formData?.['password'] && formData?.['confirmPassword']) {
            if (formData?.['password'] === '' || formData?.['password'].length < 8) errors['password'] = 'Password must be 8 characters long';
            else if (formData?.['password'] !== formData?.['confirmPassword']) errors['confirmPassword'] = "Password and Confirm Password don't match";
            else if (!passwordPattern.test(formData?.['password'])) errors['password'] = 'Combination of uppercase, lowercase, digit & special character is required';
            else errors['confirmPassword'] = '';
        }
        setPasswordError(errors);
        if (!errors['password'] && !errors['confirmPassword']) setIsValidPassword(true);
    };
    const searchCompany = async (input)=>{
        if (!input) return;
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/search/${input}`);
        if (!response || response['code'] != 200) return;
        setCompanyOptions(response['body']['items'].slice(0, 5));
    };
    const searchCompanyTimeout = (e)=>{
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(()=>searchCompany(e.target.value), 1000);
    };
    //On advisor modal close
    const onAdvisorModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedAdvisorType(null);
        setAdvisorTypeValue('');
    };
    const requestAdvisorAccess = async ()=>{
        let data = {
            firmId: existingAdvisor['_id'],
            firmName: existingAdvisor['cName'],
            contactId: existingAdvisor['contactId'],
            contactName: existingAdvisor['contactName'],
            contactEmail: existingAdvisor['contactEmail'],
            userFirstName: formData['firstName'],
            userLastName: formData['lastName'],
            userEmail: formData['email']
        };
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/requestInvestorAccess`, data);
        if (response['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            resetStates();
        }
    };
    const isURL = (str)=>{
        var pattern = new RegExp("^((ft|htt)ps?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%@_.~+&:]*)*(\\?[;&a-z\\d%@_.,~+&:=-]*)?(\\#[-a-z\\d_]*)?$", "i"); // fragment locator
        return pattern.test(str);
    };
    const openWindow = (url)=>{
        if (window.innerWidth <= 640) {
            var a = document.createElement("a");
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");
            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);
            a.dispatchEvent(dispatch);
        } else {
            var width = window.innerWidth * 0.8;
            var height = width * window.innerHeight / window.innerWidth;
            window.open(url, "newwindow", "width=" + width + ", height=" + height + ", top=" + (window.innerHeight - height) / 2 + ", left=" + (window.innerWidth - width) / 2);
        }
        return false;
    };
    const verifyWebsite = async ()=>{
        try {
            let companyWebsite = document.querySelector(`#companyWebsite`).value;
            if (!companyWebsite) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide website link');
            if (!isURL(companyWebsite)) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Invalid company url');
            if (companyWebsite.indexOf('http') < 0) companyWebsite = `http://${companyWebsite}`;
            openWindow(companyWebsite);
            setWebsiteStatus('Confirm');
        } catch (e) {
            return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(e);
        }
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e)=>{
        e.preventDefault();
        const logo = e.dataTransfer.files[0];
        let maxSizeInBytes = 5242880;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = ()=>{
                if (logo.size > maxSizeInBytes) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`File size must be less than 1MB`);
                else setFormData((prevFormData)=>({
                        ...prevFormData,
                        firmLogo: logoUrl
                    }));
            };
        }
    };
    const handleImageChange = async (event)=>{
        let logo = event.target.files[0];
        if (event.target.files) {
            const newAttachment = [];
            for (const file of event.target.files)newAttachment.push(file);
            setAttachment(newAttachment);
        }
        let maxSizeInBytes = 5242880;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = ()=>{
                if (logo.size > maxSizeInBytes) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`File size must be less than 5Mb`);
                else setFormData((prevFormData)=>({
                        ...prevFormData,
                        firmLogo: logoUrl
                    }));
            };
        }
    };
    const restrictedForDevices = ()=>{
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobile = mobileRegex.test(userAgent);
        return isMobile;
    };
    const handleNextRegister = async ()=>{
        // if (restrictedForDevices()) {
        //     return showMessage('You can Login/Register on Laptop')
        // }
        if (registerAs == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select Register as');
        if (registerAs === 'Advisor' && !selectedAdvisorType) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select the advisor type');
        let type = localStorage.getItem('testType');
        let stage = localStorage.getItem('cStage');
        if (stepNo == 1) {
            let isError = false;
            const data = formCheck?.map((field)=>{
                if (formData?.[field] !== '') return false;
                return true;
            });
            if (!isError && passwordError['password'] == '' && passwordError['confirmPassword'] == '') {
                if (data.includes(true)) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out all fields');
                else {
                    if (!isAgreed) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please accept the terms & conditions');
                    if (registerAs == 'User') {
                        setIsLoading(true);
                        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user', {
                            firstName: formData?.['firstName'],
                            lastName: formData?.['lastName'],
                            email: formData?.['email'],
                            password: `${formData?.['password']}`
                        });
                        if (response && response['code'] == 200) {
                            const hash = response['body'];
                            dispatch((0, $7fa194fc86099528$export$9b16b760c6b5c1ae)({
                                emailEnabled: true,
                                hash: hash
                            }));
                            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                            resetStates();
                        }
                        setIsLoading(false);
                    } else {
                        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/checkExistingUser', {
                            email: formData?.['email']
                        });
                        if (response && response['code'] == 200) {
                            if ((registerAs == 'Advisor' || registerAs == 'Investor') && company?.['cName'] && company?.['cWebsite']) {
                                await setFormData({
                                    ...formData,
                                    role: registerAs,
                                    cType: company["cType"],
                                    firmName: company['cName'],
                                    website: company['cWebsite'],
                                    ukRegNo: company["ukRegNo"],
                                    firmAddress: company["cAddress"],
                                    doIncorporation: company["doIncorporation"],
                                    testType: type ? type : 'investment',
                                    cStage: stage ? stage : 'Pre-Revenue'
                                });
                                setStepNo(3);
                                setWebsiteStatus('Confirmed');
                            } else setStepNo(2);
                        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    }
                }
            }
        } else if (stepNo == 2) {
            if (selectedCompany && selectedCompany['title']) {
                let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/checkExistingCompany`, {
                    ukRegNo: selectedCompany["company_number"]
                });
                if (response['code'] == 200) {
                    if (Object.keys(response['body']).length > 0) {
                        if (![
                            'client',
                            'advisor'
                        ].includes(response['body']?.['cCategory'])) {
                            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                            setExistingAdvisor(response['body']);
                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                open: 'existingAdvisor'
                            }));
                        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`This is ${response['body']?.['cCategory']} company. You can't add it.`);
                    } else {
                        setStepNo(3);
                        setFormData({
                            ...formData,
                            role: registerAs,
                            cType: selectedCompany["type"],
                            firmName: selectedCompany["title"],
                            ukRegNo: selectedCompany["company_number"],
                            firmAddress: selectedCompany["address_snippet"],
                            doIncorporation: selectedCompany["date_of_creation"],
                            testType: type ?? 'growth',
                            cStage: stage ?? 'Pre-Revenue'
                        });
                    }
                }
            }
        } else if (stepNo == 3) {
            if (formData['firmName'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out Firm Name');
            else if (formData['firmAddress'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out the Firm Address');
            else if (formData['designation'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out your designation');
            else if (formData['phone'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out phone Number');
            else if (formData['website'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill out the website');
            else if (formData['company5Words'].split(' ').length < 5) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please provide 5 words that describe your ${registerAs == 'Advisor' || registerAs == 'Investor' ? 'client' : ''} company business activites`);
            else if (formData['firmLogo'] === '') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please upload firm logo');
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($bad1c3ae594eb6ef$exports))).isURL(formData['website'])) (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter valid webiste URL');
            else if (websiteStatus != 'Confirmed') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please check and confirm company website');
            else {
                setIsLoading(true);
                const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/advisor', {
                    attachment: attachment,
                    ...formData,
                    isParent: true,
                    advisorType: selectedAdvisorType?.value
                }, false);
                if (response && response['code'] == 200) {
                    await setCompanyDescription(response['body']?.['newCompany']?.['companyDescription']);
                    await setAdvisorHashData(response['body']?.['hash']);
                    await dispatch((0, $b4397434d961d2b4$export$50f0ed8944cb1d90)(response['body']?.['newCompany']));
                    dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    }));
                    if (response['body']?.['newCompany']?.['companyDescription']) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: 'descriptionPopup'
                    }));
                    (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                    resetStates();
                }
                setIsLoading(false);
            }
        }
    };
    const handleBack = ()=>{
        if (stepNo == 2) {
            if (selectedCompany && selectedCompany['title']) setSelectedCompany({});
            else setStepNo(1);
        } else setStepNo(stepNo - 1);
    };
    const handleLogin = ()=>{
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobile = mobileRegex.test(userAgent);
        if (isMobile) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `df bg1 pr brne bscov ${registerPage ? ' h100vh register-page' : ' h100vh'}`,
                style: {
                    backgroundImage: `url(${(parcelRequire("3DCvD"))})`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: registerPage ? 'register-page-container' : 'register-container register-container-not-sure pr',
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                ref: refs?.current?.[7],
                                className: `tslp ${isAnimationVisible[7] ? 'op1 tty0' : 'op0 ttx20'}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 fs2-125rem c15",
                                        style: {
                                            lineHeight: '40.2px'
                                        },
                                        children: "Register with"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fw500 fs2-125rem c4",
                                        style: {
                                            lineHeight: '40.2px'
                                        },
                                        children: "Diligentsia for FREE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem fw400 c15 w80 pt1rem",
                                        style: {
                                            lineHeight: '24px'
                                        },
                                        children: registerAs == 'Advisor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: "Please register as Advisor using your professional email."
                                        }) : registerAs == 'Investor' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: "Please provide your main fund/company name as registered at UK Companies House."
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "Explore how we can help you reach your next corporate milestone.",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "(No credit card required)"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pt1rem pb3rem pr4rem pr0rem-xs",
                                children: [
                                    stepNo == 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df gg1rem pt0-5rem pb0-5rem ",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr w50",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "firstName",
                                                                style: {
                                                                    paddingLeft: '50px'
                                                                },
                                                                className: "pl1rem lpins w100 br10px p1rem custom-input",
                                                                type: "text",
                                                                placeholder: "First Name",
                                                                value: formData?.['firstName'] || '',
                                                                onChange: (e)=>{
                                                                    if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                                    setFormData({
                                                                        ...formData,
                                                                        firstName: e['target']['value']
                                                                    });
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                style: {
                                                                    top: '17px',
                                                                    left: '20px'
                                                                },
                                                                className: "pa",
                                                                width: "14",
                                                                height: "16",
                                                                viewBox: "0 0 14 16",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    "fill-rule": "evenodd",
                                                                    "clip-rule": "evenodd",
                                                                    d: "M7 2C5.34314 2 4 3.34315 4 5C4 6.65683 5.34314 8 7 8C8.65683 8 10 6.65683 10 5C10 3.34315 8.65683 2 7 2ZM2.5 5C2.5 2.51472 4.51472 0.5 7 0.5C9.48528 0.5 11.5 2.51472 11.5 5C11.5 7.48528 9.48528 9.5 7 9.5C4.51472 9.5 2.5 7.48528 2.5 5ZM2.35986 11.4624C3.58257 10.6981 5.22507 10.25 7 10.25C8.77495 10.25 10.4174 10.6981 11.6402 11.4624C12.8522 12.22 13.75 13.3626 13.75 14.75C13.75 15.1642 13.4142 15.5 13 15.5C12.5858 15.5 12.25 15.1642 12.25 14.75C12.25 14.0664 11.8046 13.334 10.8452 12.7344C9.89627 12.1414 8.53878 11.75 7 11.75C5.46123 11.75 4.10372 12.1414 3.15485 12.7344C2.19543 13.334 1.75 14.0664 1.75 14.75C1.75 15.1642 1.41421 15.5 1 15.5C0.58579 15.5 0.25 15.1642 0.25 14.75C0.25 13.3626 1.14771 12.22 2.35986 11.4624Z",
                                                                    fill: "black"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "w50",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "lastName",
                                                            className: "pl1rem lpins w100 br10px p1rem custom-input",
                                                            type: "text",
                                                            placeholder: "Last Name",
                                                            value: formData?.['lastName'] || '',
                                                            onChange: (e)=>{
                                                                if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                                setFormData({
                                                                    ...formData,
                                                                    lastName: e['target']['value']
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pt0-5rem pb0-5rem pr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        id: "email",
                                                        style: {
                                                            paddingLeft: '50px'
                                                        },
                                                        className: "pl1rem lpins w100 br10px p1rem custom-input",
                                                        type: "email",
                                                        placeholder: "Email - your company email address only please",
                                                        value: formData?.['email'] || '',
                                                        onChange: (e)=>{
                                                            if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                            setFormData({
                                                                ...formData,
                                                                email: e['target']['value']
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        style: {
                                                            top: '30px',
                                                            left: '20px'
                                                        },
                                                        className: "pa",
                                                        width: "16",
                                                        height: "12",
                                                        viewBox: "0 0 16 12",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M14.1875 0.375H1.8125C1.36495 0.375 0.935725 0.55279 0.619257 0.869257C0.30279 1.18572 0.125 1.61495 0.125 2.0625V9.9375C0.125 10.3851 0.30279 10.8143 0.619257 11.1307C0.935725 11.4472 1.36495 11.625 1.8125 11.625H14.1875C14.6351 11.625 15.0643 11.4472 15.3807 11.1307C15.6972 10.8143 15.875 10.3851 15.875 9.9375V2.0625C15.875 1.61495 15.6972 1.18572 15.3807 0.869257C15.0643 0.55279 14.6351 0.375 14.1875 0.375ZM13.9456 1.5L8.24187 6.045C8.07875 6.19688 7.92125 6.19688 7.72438 6.045L2.05437 1.5H13.9456ZM14.1875 10.5H1.8125C1.66332 10.5 1.52024 10.4407 1.41475 10.3352C1.30926 10.2298 1.25 10.0867 1.25 9.9375V2.29875L6.99312 6.87187C7.26606 7.13682 7.63087 7.28597 8.01125 7.28813C8.36973 7.28661 8.71398 7.1477 8.97312 6.9L14.75 2.29875V9.9375C14.75 10.0867 14.6907 10.2298 14.5852 10.3352C14.4798 10.4407 14.3367 10.5 14.1875 10.5Z",
                                                            fill: "black"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df gg1rem pt0-5rem pb0-5rem ",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr w50 password-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                                id: "password",
                                                                className: "pl1rem lpins w100 br10px p1rem custom-input",
                                                                InputProps: {
                                                                    style: {
                                                                        height: '52px'
                                                                    }
                                                                },
                                                                type: passwordType ? 'password' : 'text',
                                                                placeholder: "Password",
                                                                value: formData?.['password'] || '',
                                                                onChange: (e)=>{
                                                                    if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                                    setFormData({
                                                                        ...formData,
                                                                        password: e['target']['value']
                                                                    });
                                                                    setIsValidPassword(false);
                                                                    setPasswordError({
                                                                        password: '',
                                                                        confirmPassword: ''
                                                                    });
                                                                },
                                                                onBlur: (e)=>handlePasswordBlur('password'),
                                                                required: true,
                                                                error: !!passwordError['password'],
                                                                helperText: passwordError['password']
                                                            }),
                                                            !passwordType ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                className: "pa cp",
                                                                onClick: ()=>setPasswordType(!passwordType),
                                                                width: "27",
                                                                height: "21",
                                                                viewBox: "0 0 27 21",
                                                                fill: "none",
                                                                xmlns: "http:www.w3.org/2000/svg",
                                                                style: {
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    right: "12px",
                                                                    maxWidth: '20px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                                                    fill: "#404040"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                className: "pa cp",
                                                                onClick: ()=>setPasswordType(!passwordType),
                                                                width: "27",
                                                                height: "21",
                                                                viewBox: "0 0 27 21",
                                                                fill: "none",
                                                                xmlns: "http:www.w3.org/2000/svg",
                                                                style: {
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    right: "12px",
                                                                    maxWidth: '20px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                                                        fill: "#404040"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                                                        fill: "#404040"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                style: {
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    left: '20px'
                                                                },
                                                                className: "pa",
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 18 18",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M13.0078 12.8672C13.3961 12.8672 13.7109 12.5524 13.7109 12.1641C13.7109 11.7757 13.3961 11.4609 13.0078 11.4609C12.6195 11.4609 12.3047 11.7757 12.3047 12.1641C12.3047 12.5524 12.6195 12.8672 13.0078 12.8672Z",
                                                                        fill: "black"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M16.1719 12.7266C16.5602 12.7266 16.875 12.4118 16.875 12.0234V9.42188C16.875 7.87106 15.6133 6.60938 14.0625 6.60938H13.2174V4.12966C13.2174 1.85256 11.3249 0 8.9987 0C6.67248 0 4.77995 1.85256 4.77995 4.12966V6.60938H3.9375C2.38669 6.60938 1.125 7.87106 1.125 9.42188V15.1875C1.125 16.7383 2.38669 18 3.9375 18H14.0625C15.6133 18 16.875 16.7383 16.875 15.1875C16.875 14.7992 16.5602 14.4844 16.1719 14.4844C15.7835 14.4844 15.4688 14.7992 15.4688 15.1875C15.4688 15.9629 14.8379 16.5938 14.0625 16.5938H3.9375C3.16209 16.5938 2.53125 15.9629 2.53125 15.1875V9.42188C2.53125 8.64647 3.16209 8.01562 3.9375 8.01562H14.0625C14.8379 8.01562 15.4688 8.64647 15.4688 9.42188V12.0234C15.4688 12.4118 15.7835 12.7266 16.1719 12.7266ZM11.8112 6.60938H6.1862V4.12966C6.1862 2.62796 7.44789 1.40625 8.9987 1.40625C10.5495 1.40625 11.8112 2.62796 11.8112 4.12966V6.60938Z",
                                                                        fill: "black"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M7.69922 12.8672C8.08754 12.8672 8.40234 12.5524 8.40234 12.1641C8.40234 11.7757 8.08754 11.4609 7.69922 11.4609C7.31089 11.4609 6.99609 11.7757 6.99609 12.1641C6.99609 12.5524 7.31089 12.8672 7.69922 12.8672Z",
                                                                        fill: "black"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M5.0625 12.8672C5.45083 12.8672 5.76562 12.5524 5.76562 12.1641C5.76562 11.7757 5.45083 11.4609 5.0625 11.4609C4.67417 11.4609 4.35938 11.7757 4.35938 12.1641C4.35938 12.5524 4.67417 12.8672 5.0625 12.8672Z",
                                                                        fill: "black"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M10.3359 12.8672C10.7243 12.8672 11.0391 12.5524 11.0391 12.1641C11.0391 11.7757 10.7243 11.4609 10.3359 11.4609C9.94761 11.4609 9.63281 11.7757 9.63281 12.1641C9.63281 12.5524 9.94761 12.8672 10.3359 12.8672Z",
                                                                        fill: "black"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr w50 password-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                                                id: "confirmPassword",
                                                                InputProps: {
                                                                    style: {
                                                                        height: '52px'
                                                                    }
                                                                },
                                                                className: "pl1rem lpins w100 br10px p1rem custom-input",
                                                                type: confirmPasswordType ? 'password' : 'text',
                                                                placeholder: "Confirm Password",
                                                                value: formData?.['confirmPassword'] || '',
                                                                onChange: (e)=>{
                                                                    if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                                    setFormData({
                                                                        ...formData,
                                                                        confirmPassword: e['target']['value']
                                                                    });
                                                                    setIsValidPassword(false);
                                                                    setPasswordError({
                                                                        password: '',
                                                                        confirmPassword: ''
                                                                    });
                                                                },
                                                                onBlur: (e)=>handlePasswordBlur('confirmPassword'),
                                                                required: true,
                                                                error: !!passwordError['confirmPassword'],
                                                                helperText: passwordError['confirmPassword']
                                                            }),
                                                            !confirmPasswordType ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                className: "pa cp",
                                                                onClick: ()=>setConfirmPasswordType(!confirmPasswordType),
                                                                width: "27",
                                                                height: "21",
                                                                viewBox: "0 0 27 21",
                                                                fill: "none",
                                                                xmlns: "http:www.w3.org/2000/svg",
                                                                style: {
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    right: "12px",
                                                                    maxWidth: '20px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                                                    fill: "#404040"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                className: "pa cp",
                                                                onClick: ()=>setConfirmPasswordType(!confirmPasswordType),
                                                                width: "27",
                                                                height: "21",
                                                                viewBox: "0 0 27 21",
                                                                fill: "none",
                                                                xmlns: "http:www.w3.org/2000/svg",
                                                                style: {
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    right: "12px",
                                                                    maxWidth: '20px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                                                        fill: "#404040"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                                                        fill: "#404040"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                className: "pa",
                                                                style: {
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    left: '20px'
                                                                },
                                                                width: "18",
                                                                height: "18",
                                                                viewBox: "0 0 18 18",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                        "clip-path": "url(#clip0_684_21433)",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M11.8828 12.8672C12.2711 12.8672 12.5859 12.5524 12.5859 12.1641C12.5859 11.7757 12.2711 11.4609 11.8828 11.4609C11.4945 11.4609 11.1797 11.7757 11.1797 12.1641C11.1797 12.5524 11.4945 12.8672 11.8828 12.8672Z",
                                                                                fill: "black"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M8.36716 16.5937H2.81249C2.03709 16.5937 1.40624 15.9628 1.40624 15.1874V9.42184C1.40624 8.64643 2.03709 8.01559 2.81249 8.01559H12.9374C13.7129 8.01559 14.3437 8.64643 14.3437 9.42184V10.8281C14.3437 11.2164 14.6585 11.5312 15.0468 11.5312C15.4352 11.5312 15.7499 11.2164 15.7499 10.8281V9.42184C15.7499 7.87103 14.4883 6.60935 12.9374 6.60935H12.0924V4.12965C12.0924 1.85255 10.1999 0 7.87367 0C5.54746 0 3.65493 1.85255 3.65493 4.12965V6.60935H2.81249C1.26168 6.60935 0 7.87103 0 9.42184V15.1874C0 16.7382 1.26168 17.9999 2.81249 17.9999H8.36716C8.75549 17.9999 9.07028 17.6851 9.07028 17.2968C9.07028 16.9085 8.75549 16.5937 8.36716 16.5937ZM5.06118 4.12965C5.06118 2.62795 6.32286 1.40624 7.87367 1.40624C9.42447 1.40624 10.6862 2.62795 10.6862 4.12965V6.60935H5.06118V4.12965Z",
                                                                                fill: "black"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M17.7067 11.4518C17.3909 11.2257 16.9517 11.2984 16.7257 11.6142L13.26 16.4552C13.1653 16.565 13.0467 16.5887 12.9832 16.5929C12.918 16.5972 12.7925 16.5889 12.682 16.4853L10.4423 14.2996C10.1643 14.0283 9.71917 14.0338 9.44798 14.3117C9.17675 14.5896 9.18216 15.0348 9.4601 15.306L11.7038 17.4956C11.7059 17.4976 11.708 17.4996 11.7101 17.5016C12.0464 17.8219 12.4954 18 12.9574 18C12.9971 18 13.0369 17.9987 13.0766 17.996C13.5799 17.9625 14.0497 17.7178 14.3657 17.3247C14.3738 17.3145 14.3817 17.3041 14.3893 17.2935L17.8691 12.4328C18.0951 12.1171 18.0224 11.6778 17.7067 11.4518Z",
                                                                                fill: "black"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M9.21093 12.8672C9.59926 12.8672 9.91406 12.5524 9.91406 12.1641C9.91406 11.7757 9.59926 11.4609 9.21093 11.4609C8.82261 11.4609 8.50781 11.7757 8.50781 12.1641C8.50781 12.5524 8.82261 12.8672 9.21093 12.8672Z",
                                                                                fill: "black"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M3.9375 12.8672C4.32582 12.8672 4.64062 12.5524 4.64062 12.1641C4.64062 11.7757 4.32582 11.4609 3.9375 11.4609C3.54917 11.4609 3.23438 11.7757 3.23438 12.1641C3.23438 12.5524 3.54917 12.8672 3.9375 12.8672Z",
                                                                                fill: "black"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M6.57422 12.8672C6.96254 12.8672 7.27734 12.5524 7.27734 12.1641C7.27734 11.7757 6.96254 11.4609 6.57422 11.4609C6.18589 11.4609 5.87109 11.7757 5.87109 12.1641C5.87109 12.5524 6.18589 12.8672 6.57422 12.8672Z",
                                                                                fill: "black"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                            id: "clip0_684_21433",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                width: "18",
                                                                                height: "18",
                                                                                fill: "white"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fw500 fs1-125rem c15 pt1rem pb0-5rem",
                                                style: {
                                                    lineHeight: '22.39px'
                                                },
                                                children: "Register as"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df pt1rem pb1rem gg1rem registerAs",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "user",
                                                                name: "registerAs",
                                                                style: {
                                                                    height: '19px',
                                                                    width: '19px'
                                                                },
                                                                type: "radio",
                                                                value: "User",
                                                                checked: registerAs == 'User',
                                                                onChange: (e)=>{
                                                                    handleRegisterAs(e['target']['value']);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                className: "fw400 fs1-125rem ml1rem c15",
                                                                for: "user",
                                                                style: {
                                                                    lineHeight: '22.39px'
                                                                },
                                                                children: "Company"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "advisor",
                                                                name: "registerAs",
                                                                style: {
                                                                    height: '19px',
                                                                    width: '19px'
                                                                },
                                                                type: "radio",
                                                                value: "Advisor",
                                                                checked: registerAs == 'Advisor',
                                                                onChange: (e)=>{
                                                                    handleRegisterAs(e['target']['value']);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                for: "advisor",
                                                                className: "fw400 fs1-125rem ml1rem c15",
                                                                style: {
                                                                    lineHeight: '22.39px'
                                                                },
                                                                children: "Advisor"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "investor",
                                                                name: "registerAs",
                                                                style: {
                                                                    height: '19px',
                                                                    width: '19px'
                                                                },
                                                                type: "radio",
                                                                value: "Investor",
                                                                checked: registerAs == 'Investor',
                                                                onChange: (e)=>{
                                                                    handleRegisterAs(e['target']['value']);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                for: "investor",
                                                                className: "fw400 fs1-125rem ml1rem c15",
                                                                style: {
                                                                    lineHeight: '22.39px'
                                                                },
                                                                children: "Investor"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            advisorType ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w50 react-custom-select",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7532f3e29d96fa2a$export$2e2bcd8739ae039), {
                                                    placeholder: "Select Advisor Type",
                                                    styles: customStyles,
                                                    value: selectedAdvisorType,
                                                    className: "p0-5rem mdp0-25rem lpins w100 br10px  custom-input cp bg1",
                                                    components: {
                                                        Option: CustomOption
                                                    },
                                                    options: categories,
                                                    onChange: (value)=>{
                                                        setSelectedAdvisorType(value);
                                                    }
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "pt1rem pb1rem df cp",
                                                for: "registerTerms",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "checkbox w2rem h2rem pr inputWrapper",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "registerTerms",
                                                            className: "bo5 bw2px bss cp td250 w2rem h2rem br10px lpins",
                                                            type: "checkbox",
                                                            checked: isAgreed,
                                                            onChange: ()=>{
                                                                if (restrictedForDevices()) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can Login/Register on Laptop');
                                                                setIsAgreed(!isAgreed);
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs1rem lh3 ml1rem usn fw400 registerTerms",
                                                        style: {
                                                            lineHeight: '28px'
                                                        },
                                                        children: [
                                                            "I agree to \xa0",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                className: "c3 c4-hover td250 fw500",
                                                                to: "/terms-conditions-individuals-terms",
                                                                target: "_blank",
                                                                children: "terms and conditions \xa0"
                                                            }),
                                                            "and \xa0",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                className: "c3 c4-hover td250 fw500",
                                                                href: "/policy",
                                                                target: "_blank",
                                                                children: "policies"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : stepNo == 2 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: `pr mb1-5rem ${(formData?.['firmName'] == '' || companyOptions.length == 0) && 'company-searchbox'}`,
                                            children: [
                                                Object.keys(selectedCompany).length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pt0-5rem pb0-5rem pr",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                id: "searchCompany",
                                                                name: "firmName",
                                                                className: "pl4rem lpins w100 br10px p1rem custom-input",
                                                                type: "text",
                                                                placeholder: "Search your Firm Name/Number",
                                                                value: formData?.['firmName'] || '',
                                                                onChange: (e)=>setFormData({
                                                                        ...formData,
                                                                        firmName: e['target']['value']
                                                                    }),
                                                                onKeyUp: searchCompanyTimeout
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                viewBox: "0 0 512 512",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        className: "fa-primary",
                                                                        d: "M512 144v288c0 26.5-21.5 48-48 48h-416C21.5 480 0 458.5 0 432v-288C0 117.5 21.5 96 48 96h416C490.5 96 512 117.5 512 144z"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        className: "fa-secondary",
                                                                        d: "M176 96H128V48C128 21.5 149.5 0 176 0h160C362.5 0 384 21.5 384 48V96h-48V48h-160V96z"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                selectedCompany && selectedCompany['title'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "shadow bg1 br10px p1rem mb0-5rem dg gg0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                                className: "c4 fs1-5rem ttu w100 tac",
                                                                children: "Company Info"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "c15",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Company Status:"
                                                                    }),
                                                                    ' ',
                                                                    selectedCompany['company_status'].toUpperCase(),
                                                                    ' '
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "c15",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Company Number:"
                                                                    }),
                                                                    ' ',
                                                                    selectedCompany['company_number'],
                                                                    ' '
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "c15",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Company Title:"
                                                                    }),
                                                                    " ",
                                                                    selectedCompany['title'],
                                                                    ' '
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "c15",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Company Date of Creation:"
                                                                    }),
                                                                    ' ',
                                                                    selectedCompany['date_of_creation'],
                                                                    ' '
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "c15",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Company Description:"
                                                                    }),
                                                                    ' ',
                                                                    selectedCompany['description'],
                                                                    ' '
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: "c15",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                        children: "Company Address:"
                                                                    }),
                                                                    ' ',
                                                                    selectedCompany['address_snippet'],
                                                                    ' '
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }) : formData?.['firmName'] != '' && companyOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: companyOptions.map((option, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            onClick: ()=>setSelectedCompany(option),
                                                            className: "cp df fww jcfs aic shadow bg1 br5px p1rem mb0-5rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "fw600 mr1rem",
                                                                    children: option['title']
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "mr1rem",
                                                                    children: option['company_number']
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "ttu fw600",
                                                                    children: option['company_status']
                                                                })
                                                            ]
                                                        }, idx))
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df jcc mt5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "empty-text",
                                                            children: "Please enter a firm name to search for UK businesses."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "empty-text",
                                                            children: "Please add the name of YOUR firm/company, NOT your client/investee company"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : stepNo == 3 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "company-searchbox",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt0-5rem pb0-5rem pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "firmName",
                                                            name: "firmName",
                                                            className: "pl4rem lpins w100 br10px p1rem custom-input",
                                                            type: "text",
                                                            placeholder: "Firm Name",
                                                            value: formData?.['firmName'] || '',
                                                            onChange: (e)=>setFormData({
                                                                    ...formData,
                                                                    firmName: e['target']['value']
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            viewBox: "0 0 1024 1024",
                                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M564.2 138.8c0.1-10.3-10.5-17.4-20.6-13.9L212.7 243.6c-6 2.1-10 7.7-10 13.9v572.6h361.5V138.8zM359.8 716.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m135.8 357c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-87.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3V272zM838.2 338.3c0.1-5.5-3-10.5-7.9-13.1L613.4 211.6c-10.2-5.4-22.6 1.9-22.6 13.1v605.5h247.4V338.3z m-83.6 378c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-86.8c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-91.3c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.5c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z m0-89.4c0 12.3-10.2 22.3-23 22.3h-40.2c-12.7 0-23-9.9-23-22.3v-14.8c0-12.3 10.2-22.3 23-22.3h40.2c12.7 0 23 9.9 23 22.3v14.8z",
                                                                    fill: "#66AFFF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M876 900.8H147.2c-8.4 0-15.2-8-15.2-17.7v-35.3c0-9.7 6.8-17.7 15.2-17.7H876c8.4 0 15.2 8 15.2 17.7v35.3c0 9.8-6.8 17.7-15.2 17.7z"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt0-5rem pb0-5rem pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "firmAddress",
                                                            name: "firmAddress",
                                                            className: "pl4rem lpins w100 br10px p1rem custom-input",
                                                            type: "text",
                                                            placeholder: "Firm Address",
                                                            value: formData?.['firmAddress'] || '',
                                                            onChange: (e)=>setFormData({
                                                                    ...formData,
                                                                    firmAddress: e['target']['value']
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            viewBox: "0 0 256 256",
                                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            className: "fa-secondary",
                                                                            d: "M42.1,122.7h37.7v8.9H42.1V122.7L42.1,122.7z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            className: "fa-primary",
                                                                            d: "M42.1,147h37.7v8.9H42.1V147L42.1,147z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M42.1,172h37.7v8.9H42.1V172L42.1,172z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M42.1,197.1h37.7v8.9H42.1V197.1L42.1,197.1z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M107.1,74.6h60.3v8.9h-60.3V74.6z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M107.1,103.7h32.6v8.9h-32.6V103.7z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M107.1,132.8h18.7v8.9h-18.7V132.8z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M200.1,145.3c0-9.3-7.6-17-17-17s-16.9,7.6-16.9,17c0,9.3,7.6,17,16.9,17C192.5,162.2,200.1,154.6,200.1,145.3z M183.1,153.4c-4.5,0-8.1-3.6-8.1-8.1c0-4.5,3.6-8.1,8.1-8.1c4.5,0,8.1,3.6,8.1,8.1C191.3,149.7,187.6,153.4,183.1,153.4z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M190,223c4.2-5.3,11.6-15,18.9-25.9c15.1-22.6,22.8-39.7,22.8-50.7c0-26.8-21.8-48.6-48.6-48.6s-48.6,21.8-48.6,48.6c0,11,7.7,28.1,22.8,50.7c7.3,10.9,14.7,20.6,18.9,25.9h-25.1h-25.7v-26.3h18.8v-8.9h-27.6V223h-19V96.8V50.5h51.4h27.8v38.9h8.9V41.7h-36.7V24.1H88.8v17.6v8.9v28.6h-53v17.6H24.3V223H10v8.9h14.2h64.6h8.9h19h34.6h30.2H246V223H190z M97.7,32.9h42.6v8.7H97.7V32.9z M44.7,88h42.6v8.7H44.7V88z M33.1,223V105.6h2.7h53V223H33.1z M143.4,146.4c0-21.9,17.8-39.7,39.8-39.7c21.9,0,39.8,17.8,39.8,39.7c0,17.1-26.1,53.8-39.8,71.1C169.5,200.2,143.4,163.5,143.4,146.4z"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt0-5rem pb0-5rem pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "designation",
                                                            name: "designation",
                                                            className: "pl4rem lpins w100 br10px p1rem custom-input",
                                                            type: "text",
                                                            placeholder: "Your Designation",
                                                            value: formData?.['designation'] || '',
                                                            onChange: (e)=>setFormData({
                                                                    ...formData,
                                                                    designation: e['target']['value']
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            viewBox: "0 0 367.004 367.004",
                                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        className: "fa-primary",
                                                                        d: "M160.937,197.203c24.125,0,80.846-29.033,80.846-98.603c0-9.705-0.236-19.081-1.037-27.94 c-1.313-17.427-4.883-32.872-13.768-44.71C215.578,9.838,195.629,0,160.937,0c-34.68,0-54.628,9.833-66.029,25.937 C86.012,37.778,82.44,53.231,81.127,70.669c-0.799,8.856-1.035,18.229-1.035,27.932C80.092,168.17,136.812,197.203,160.937,197.203 z M187.328,36.123c-2.355,5.951-3.535,8.926-5.891,14.877c-15.209-4.297-25.791-4.297-41,0c-2.355-5.951-3.533-8.926-5.891-14.877 C153.566,30.365,168.308,30.365,187.328,36.123z M92.119,83.517c0.932,2.037,4.889,9.869,11.014,10.604 c7.041,0.844,18.729-24.936,57.805-24.998c39.076,0.063,50.764,25.842,57.805,24.998c6.125-0.735,10.082-8.567,11.014-10.604 c0.189,4.992,0.259,10.046,0.259,15.084c0,34.006-15.015,55.076-27.612,66.763c-15.871,14.726-33.492,20.071-41.465,20.071 c-7.973,0-25.594-5.345-41.465-20.071c-12.598-11.687-27.612-32.757-27.612-66.763C91.86,93.562,91.93,88.509,92.119,83.517z"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        className: "fa-primary",
                                                                        d: "M232.705,211.768c2.605-2.606,5.371-4.994,8.26-7.181c-11.223-6.117-22.109-11.933-29.153-15.697l-0.331-0.177 c-1.982-1.059-4.403-0.847-6.169,0.541c-9.085,7.132-19.035,11.938-29.574,14.283c-1.861,0.414-3.391,1.738-4.066,3.521 l-10.734,28.291l-10.734-28.291c-0.675-1.783-2.204-3.106-4.066-3.521c-10.539-2.346-20.489-7.152-29.573-14.283 c-1.769-1.388-4.188-1.601-6.17-0.541c-17.138,9.158-58.25,31.302-69.829,39.106c-19.621,13.219-28.199,61.053-29.72,70.508 c-0.15,0.938-0.064,1.898,0.253,2.793c0.703,1.982,18.709,48.548,149.84,48.548c5.933,0,11.627-0.098,17.105-0.28 c0.481-6.064,3.029-11.993,7.657-16.622l31.512-31.511C203.113,271.581,208.833,235.64,232.705,211.768z"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        className: "fa-secondary",
                                                                        d: "M336.396,219.546c-12.79-12.79-29.821-19.834-47.957-19.834c-18.135,0-35.166,7.044-47.955,19.834 c-21.512,21.511-26.052,54.982-11.04,81.396l1.317,2.319l-37.284,37.284c-6.042,6.043-6.041,15.876,0.002,21.92 c2.927,2.927,6.819,4.539,10.958,4.539c4.142,0,8.033-1.612,10.96-4.54l37.285-37.283l2.317,1.315 c10.126,5.748,21.698,8.787,33.464,8.787c18.127,0,35.149-7.04,47.933-19.824c12.791-12.79,19.835-29.822,19.835-47.957 C356.231,249.367,349.187,232.336,336.396,219.546z M319.779,298.842c-8.357,8.358-19.488,12.962-31.339,12.962 c-11.851,0-22.982-4.603-31.341-12.962c-17.281-17.281-17.281-45.399,0-62.68c8.359-8.359,19.49-12.962,31.341-12.962 c11.851,0,22.981,4.604,31.339,12.963c8.359,8.358,12.963,19.488,12.963,31.339S328.138,290.483,319.779,298.842z"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt0-5rem pb0-5rem pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $331000cdd042dde5$export$2e2bcd8739ae039), {
                                                            name: "phone",
                                                            className: "pl4rem lpins w100 br10px p1rem custom-input",
                                                            country: "GB",
                                                            international: true,
                                                            placeholder: "Your Phone Number",
                                                            withCountryCallingCode: true,
                                                            value: formData?.['phone'],
                                                            onChange: (e)=>setFormData({
                                                                    ...formData,
                                                                    phone: e
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 384 512",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    className: "fa-primary",
                                                                    d: "M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    className: "fa-secondary",
                                                                    d: "M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt0-5rem pb0-5rem pr",
                                                    children: [
                                                        websiteStatus == 'Check' ? /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "verify-btn shadow shadow bg9 c1 p1rem fw600 cp ttu",
                                                            type: "button",
                                                            value: websiteStatus,
                                                            onClick: ()=>verifyWebsite()
                                                        }) : websiteStatus == 'Confirm' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    className: "verify-btn shadow shadow bg9 c1 p1rem mr6rem fw600 cp ttu",
                                                                    type: "button",
                                                                    value: "Check",
                                                                    onClick: ()=>verifyWebsite()
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    className: "verify-btn shadow shadow bg8 c1 p1rem fw600 cp ttu",
                                                                    type: "button",
                                                                    value: websiteStatus,
                                                                    onClick: ()=>setWebsiteStatus('Confirmed')
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "verify-btn shadow shadow bg7 c1 p1rem fw600 ttu",
                                                            type: "button",
                                                            value: websiteStatus
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "companyWebsite",
                                                            name: "website",
                                                            className: "pl4rem lpins w100 br10px p1rem custom-input",
                                                            type: "text",
                                                            placeholder: "Website",
                                                            value: formData?.['website'] || '',
                                                            onChange: (e)=>{
                                                                setFormData({
                                                                    ...formData,
                                                                    website: e['target']['value']
                                                                }), setWebsiteStatus('Check');
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            viewBox: "0 0 512 512",
                                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256s256-114.62,256-256S397.38,0,256,0z M172.211,41.609 c-24.934,27.119-44.68,66.125-56.755,111.992H49.749C75.179,102.741,118.869,62.524,172.211,41.609z M25.6,256 c0-26.999,5.077-52.727,13.662-76.8h70.494c-4.608,24.294-7.356,49.963-7.356,76.8s2.748,52.506,7.347,76.8H39.262 C30.677,308.727,25.6,283,25.6,256z M49.749,358.4h65.707c12.083,45.867,31.821,84.872,56.755,111.991 C118.869,449.476,75.179,409.259,49.749,358.4z M243.2,485.188c-43.81-8.252-81.877-58.24-101.359-126.788H243.2V485.188z M243.2,332.8H135.74c-4.924-24.166-7.74-49.997-7.74-76.8s2.816-52.634,7.74-76.8H243.2V332.8z M243.2,153.6H141.841 C161.323,85.052,199.39,35.063,243.2,26.812V153.6z M462.251,153.6h-65.707c-12.083-45.867-31.821-84.873-56.755-111.992 C393.131,62.524,436.821,102.741,462.251,153.6z M268.8,26.812c43.81,8.252,81.877,58.24,101.359,126.788H268.8V26.812z M268.8,179.2h107.46c4.924,24.166,7.74,49.997,7.74,76.8s-2.816,52.634-7.74,76.8H268.8V179.2z M268.8,485.188V358.4h101.359 C350.677,426.948,312.61,476.937,268.8,485.188z M339.789,470.391c24.934-27.127,44.672-66.125,56.755-111.991h65.707 C436.821,409.259,393.131,449.476,339.789,470.391z M402.244,332.8c4.608-24.294,7.356-49.963,7.356-76.8 s-2.748-52.506-7.347-76.8h70.494c8.576,24.073,13.653,49.801,13.653,76.8c0,27-5.077,52.727-13.662,76.8H402.244z"
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pr pt0-5rem pb0-5rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            id: "company5Words",
                                                            name: "company5Keywords",
                                                            type: "text",
                                                            placeholder: `Please add 5 keywords which explain your ${registerAs == 'Advisor' || registerAs == 'Investor' ? 'client' : ''} business activities\u{200B}`,
                                                            className: "pl4rem shadow bg5 w100 br5px p1rem",
                                                            value: formData?.['company5Words'],
                                                            onChange: (e)=>setFormData({
                                                                    ...formData,
                                                                    company5Words: e['target']['value']
                                                                })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            className: "center-vertically f3 pa l0 ml1rem w2rem",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 512 512",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    className: "fa-primary",
                                                                    d: "M23.1 512c-6.156 0-12.28-2.344-16.97-7.031c-9.375-9.375-9.375-24.56 0-33.94l303.1-303.1c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-303.1 303.1C36.28 509.7 30.16 512 23.1 512z"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    className: "fa-secondary",
                                                                    d: "M467.1 241.1L351.1 288h94.34c-7.711 14.85-16.29 29.28-25.87 43.01l-132.5 52.99h85.65c-59.34 52.71-144.1 80.35-264.5 52.82l235.9-235.9c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L75.11 402.1C-2.957 61.97 362.5 8.436 478.9 .0846c18.87-1.354 34.41 14.19 33.05 33.05C508.7 78.53 498.5 161.8 467.1 241.1z"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pl1rem lpins br10px p1rem custom-input mt1rem bg1 pr",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                            className: "df mb0-5rem",
                                                            children: "Firm Logo"
                                                        }),
                                                        formData?.['firmLogo'] == '' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            onDragOver: onDragOver,
                                                            onDrop: (e)=>onDrop(e),
                                                            for: "fileUpload",
                                                            className: "w100 bsbb bg5 br5px df jcc aic px2rem py5rem bsd bo6 bw2px cp mb0-5rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "pen fs0-75rem fw500 tac",
                                                                    children: "Click here or drag and drop files (Max 160x160)"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    onChange: handleImageChange,
                                                                    className: "dn",
                                                                    id: "fileUpload",
                                                                    type: "file",
                                                                    accept: "image/*"
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    className: "close-popup c3",
                                                                    onClick: ()=>setFormData((prevFormData)=>({
                                                                                ...prevFormData,
                                                                                firmLogo: ''
                                                                            })),
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        viewBox: "0 0 256 256",
                                                                        style: {
                                                                            position: "relative",
                                                                            top: "4px"
                                                                        },
                                                                        className: "pen fds h1rem f1 mr0-5rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            className: "pen fa-primary",
                                                                                            d: "M94.6,3.6c-5.7,1.5-10.5,5.6-13.3,11.2l-1.7,3.4L79.5,28l-0.2,9.7H47.5c-30.4,0-32,0-33.7,0.9c-3.4,1.8-4.9,6.8-2.7,9.7c2.2,2.8,3.3,3.3,8.8,3.5c4.8,0.2,5.1,0.2,5.4,1.2c0.1,0.6,5.6,41.9,12.3,91.9c6.6,49.9,12.2,91.4,12.4,92c0.1,0.7,1,2.7,2,4.5c2.8,5.4,7.9,9.4,13.6,10.9c2.6,0.7,10.2,0.8,62.6,0.8c65.2,0,62.8,0.1,67.7-2.8c5.6-3.3,9.8-9.4,10.8-15.6c0.2-1.6,5.7-43,12.3-91.8c6.5-48.9,11.9-89.4,12-89.9c0.2-1,0.6-1,5.3-1.2c4.3-0.1,5.4-0.3,6.5-1.2c2.3-1.7,3.3-3.4,3.3-5.7c0-2.7-1.3-4.9-3.6-6.2c-1.8-1-2.3-1-33.8-1h-31.9l-0.2-9.7l-0.1-9.7l-1.7-3.4c-2.8-5.7-7.7-9.7-13.6-11.2C156.9,2.5,98.8,2.5,94.6,3.6z M159.3,18.1c2.8,1.7,3.1,2.9,3.1,11.8v7.9H128H93.7v-7.9c0-8.8,0.3-10.1,3.1-11.8c1.5-0.9,2.7-1,31.3-1C156.6,17.1,157.8,17.1,159.3,18.1z M216.3,55c-0.2,1.7-5.7,42.7-12.1,91.1c-9,67.4-11.9,88.3-12.6,89.4c-0.4,0.8-1.7,2-2.7,2.5c-1.9,1-1.9,1-60.9,1c-53.2,0-59.2-0.1-60.7-0.8c-3.6-1.7-2.6,4.2-15.7-93.9C45.1,95,39.6,54,39.5,53.3l-0.2-1.3H128h88.7L216.3,55z"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M78.2,70c-1.7,1-2.8,2.6-3.3,4.4c-0.1,0.6,1.8,32.8,4.4,71.4c3.9,57.9,4.8,70.5,5.5,72c2.6,5.3,9.9,5.2,12.5-0.1c0.9-1.8,0.8-3-3.8-72.7c-5.2-77.6-4.6-72.6-8.1-74.9C83.3,68.9,80.3,68.8,78.2,70z"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M124.7,69.9c-0.9,0.4-2.1,1.5-2.6,2.4c-1,1.6-1,2.4-1,73.1c0,70.9,0,71.6,1,73.1c2.6,4.2,9.2,4.2,11.8,0c1-1.6,1-2.3,1-73.1s0-71.6-1-73.1C132.1,69.4,128,68.3,124.7,69.9z"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                            d: "M170.7,70.2c-3.5,2.3-2.9-2.7-8.1,74.8c-4.7,70-4.8,70.8-3.8,72.7c2.6,5.3,10,5.4,12.5,0.1c0.7-1.4,1.6-13.5,5.3-69.2c2.5-37.1,4.5-69.2,4.6-71.2c0.1-3.1,0-3.9-1-5.3C177.9,69,173.8,68.2,170.7,70.2z"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        className: "poupup-img shadow brw5 tac",
                                                                        src: formData['firmLogo'],
                                                                        alt: "Firm Logo"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic jcsb pr",
                                        children: [
                                            registerAs != 'User' && stepNo != 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                style: {
                                                    width: '35%',
                                                    height: '50px',
                                                    lineHeight: '30px'
                                                },
                                                className: `shadow df jcc fdc aic c6 bg1 br35px cp fw600 fs1-25rem pr zi0 br10px`,
                                                onClick: ()=>handleBack(),
                                                children: "Back"
                                            }),
                                            stepNo == 2 && !(selectedCompany && selectedCompany['title']) ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    style: {
                                                        width: '320px',
                                                        height: '54px',
                                                        lineHeight: '30px',
                                                        cursor: `${!isValidPassword ? 'not-allowed' : 'pointer'}`
                                                    },
                                                    className: `${animation ? 'registerButtonAnimation' : ''} shadow rainbow c1 bg4 br35px mt1rem mb1rem mr2-5rem cp fw500 fs1rem pr zi0 br10px ${(isLoading || !isValidPassword) && 'button-disabled'}
                                        ${isLoading || !isValidPassword ? '' : 'rainbow '}`,
                                                    disabled: isLoading,
                                                    onClick: ()=>{
                                                        if (!isLoading) handleNextRegister();
                                                    },
                                                    children: stepNo == 1 ? registerAs == '' || registerAs == 'User' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            "Register For Free",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw400 c21 df fdc",
                                                                style: {
                                                                    marginTop: "-2px",
                                                                    fontSize: '10px',
                                                                    lineHeight: '15px',
                                                                    fontStyle: 'italic'
                                                                },
                                                                children: "No credit card required"
                                                            })
                                                        ]
                                                    }) : 'Next' : stepNo == 2 ? selectedCompany && selectedCompany['title'] && 'Confirm & Next' : 'Register'
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "td250 fs1rem cp fw600 c15 mt0-5rem",
                                        style: {
                                            lineHeight: '28px'
                                        },
                                        children: [
                                            "Already registered? ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                className: "c3 ml0-5rem",
                                                to: $16250bd714b02a14$export$eed606b4351295d7,
                                                onClick: ()=>handleLogin(),
                                                children: "Log in"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr  bscov brnr form-right-image df aic jcc",
                        style: {
                            width: "55%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "c15 fs1-5rem",
                                children: [
                                    "Not Sure ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "Yet?"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: (parcelRequire("7LSyE")),
                                className: "pa book-call",
                                style: {
                                    width: '40%',
                                    cursor: 'pointer',
                                    position: 'relative',
                                    top: '-15%',
                                    left: '-60px'
                                },
                                onClick: ()=>window.open('https://koalendar.com/e/meet-with-mark-bernstein', '_blank')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'existingAdvisor',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw700px pr pt3rem br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                setExistingAdvisor({}), setStepNo(2), dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                }));
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "h3rem pa t0 l0 m1rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-gradient fw600 mt2rem",
                            children: `Existing ${registerAs} - ${existingAdvisor['cName']}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "tac my1rem oa",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "fs1rem taj px0-5rem",
                                children: [
                                    "Hi ",
                                    `${formData['firstName']} ${formData['lastName']}`,
                                    ", ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "We will notify ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                        children: [
                                            existingAdvisor['contactName'],
                                            " "
                                        ]
                                    }),
                                    " of your wish to add your Diligentsia account and request that they grant you access. ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Please click below REQUEST to grant for access",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Kind Regards "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcse",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>requestAdvisorAccess(),
                                className: "bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic",
                                children: "Request"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "descriptionPopup",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "mah90 oya bg1 p3rem shadow w100 bsbb df fdc maw600px br5px pr zi9",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "close-popup",
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ''
                                        })),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        style: {
                                            position: "relative",
                                            top: "4px"
                                        },
                                        className: "pen fds h1rem f1 mr0-5rem",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 320 512",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            className: "pen fa-primary",
                                            d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "text-gradient fs2rem tac lh1 fw600 mb0-5rem",
                                    children: "Company Description"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "c4 fs1rem ttu w100 tac mb1rem",
                                    children: "AI Generated"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df fdc fs1rem",
                                    children: [
                                        companyDescription,
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c4 fs1-25rem fw600 w100 tac ttu pt1rem my1rem",
                                            children: "You can later edit description in Company Settings"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc fdc fdr-md aic fs1rem px2rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "shadow my1rem bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w40 bsbb tac",
                                        onClick: ()=>{
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            })), dispatch((0, $7fa194fc86099528$export$9b16b760c6b5c1ae)({
                                                emailEnabled: true,
                                                hash: advisorHashData
                                            }));
                                        },
                                        children: "Next"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            style: {
                                position: 'relative'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/girl-1730109127115.webp",
                                    alt: "messageLadie",
                                    className: "girlImage"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    onClick: ()=>{
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'introVideo'
                                        }));
                                        dispatch((0, $ee5327cdf6cdce8c$export$25316803c042c1e3)({
                                            modalHistory: "descriptionPopup"
                                        }));
                                    },
                                    src: (parcelRequire("lp3wv")),
                                    className: "pa cp",
                                    alt: "clickToHearMe",
                                    style: {
                                        maxWidth: "130px",
                                        zIndex: 99,
                                        top: "-210px",
                                        left: "15px"
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "advisorType",
                onClose: onAdvisorModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 p2rem shadow w30 bsbb df fdc maw600px br5px pr",
                    style: {
                        outline: 'none'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: onAdvisorModalClose,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc fs1-5rem",
                            children: "Add Advisor type"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            id: "advisorType",
                            style: {
                                paddingLeft: '50px'
                            },
                            className: "mt1rem pl1rem lpins w100 br10px p1rem custom-input",
                            type: "text",
                            value: advisorTypeValue,
                            placeholder: "Advisor Type",
                            onChange: (e)=>setAdvisorTypeValue(e['target']['value'])
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: `shadow bg3 c1 td250 br5px p0-5rem fw600 cp ttu bsbb tac mt1rem df jcc aic w50 `,
                            style: {
                                backgroundColor: advisorTypeValue === "" && "lightgray",
                                cursor: advisorTypeValue === "" ? 'not-allowed' : "pointer"
                            },
                            onClick: ()=>{
                                advisorTypeValue !== "" && onAdvisorTypeAdded();
                            },
                            children: "Add"
                        })
                    ]
                })
            })
        ]
    });
};
var $844e14ef8ac4298d$export$2e2bcd8739ae039 = $844e14ef8ac4298d$var$RegisterSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $4e6123e31e77b8e5$var$dummyIcon = /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
    width: "74",
    height: "74",
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M8.96204 74.0005H47.1957C40.4123 70.3005 35.7872 63.2088 35.7872 54.8837C35.7872 42.8586 45.654 32.9919 57.6791 32.9919H57.9874V8.01673C57.9874 3.70003 54.2874 0 49.9707 0H8.96204C4.64534 0 0.945312 3.70003 0.945312 8.01673V65.9838C0.945312 70.3005 4.337 74.0005 8.96204 74.0005ZM16.0538 12.3334H42.5706C44.4206 12.3334 45.654 13.8751 45.654 15.4168C45.654 17.2668 44.4206 18.5001 42.5706 18.5001H16.0538C14.2037 18.5001 12.9704 17.2668 12.9704 15.4168C12.9704 13.8751 14.5121 12.3334 16.0538 12.3334ZM16.0538 26.8252H33.3206C35.1706 26.8252 36.4039 28.3669 36.4039 29.9086C36.4039 31.7586 35.1706 32.9919 33.3206 32.9919H16.0538C14.2037 32.9919 12.9704 31.7586 12.9704 29.9086C12.9704 28.0585 14.5121 26.8252 16.0538 26.8252Z",
            fill: "#4A67FF"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M57.6821 39.4668C49.0488 39.4668 41.957 46.5585 41.957 55.1919C41.957 63.8253 49.0488 70.917 57.6821 70.917C66.3155 70.917 73.4073 63.8253 73.4073 55.1919C73.4073 46.5585 66.3155 39.4668 57.6821 39.4668ZM65.3905 53.6502L57.6821 61.0503C57.0655 61.667 56.4488 61.9753 55.5238 61.9753C54.5988 61.9753 53.9821 61.667 53.3654 61.0503L49.6654 57.0419C48.4321 55.8086 48.4321 53.9586 49.9738 52.7252C51.2071 51.4919 53.0571 51.4919 54.2905 52.7252L55.8321 54.5752L61.3822 49.3335C62.6155 48.1002 64.4655 48.1002 65.6989 49.3335C66.6239 50.2585 66.6239 52.4169 65.3905 53.6502Z",
            fill: "#4A67FF"
        })
    ]
});
const $4e6123e31e77b8e5$var$WorkCards = ({ isAnimationVisible: isAnimationVisible, refs: refs, data: data })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: refs?.current?.[4],
        className: `pt2rem pl2rem pr2rem pb0-5rem br30px bg1 bsflp pr work-card-box  ${isAnimationVisible?.[4] && 'scaleAnimation'}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pb1rem df jcsb md-h4rem",
                style: {
                    alignItems: 'end',
                    minHeight: '45px',
                    height: '45px',
                    borderBottom: '3px solid #15131380'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "pr w80",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "fw500 fs1-25rem c15 w100",
                                style: {
                                    lineHeight: '22.81px'
                                },
                                children: data?.title1
                            }),
                            data?.title2 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "fw500 fs1-25rem c15 w100",
                                children: data?.title2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jce pr",
                        style: {
                            top: '-20px',
                            height: '100%',
                            width: "56px",
                            visibility: data?.icon || data?.image ? 'visible' : 'hidden',
                            marginBottom: !data?.icon && '10px'
                        },
                        children: data?.icon ? data['icon'] : data?.image ? data['image'] : $4e6123e31e77b8e5$var$dummyIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fs14px pt1-5rem pb1rem c14",
                style: {
                    lineHeight: '27px'
                },
                children: data?.desc
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pa df jcc aic bg1 how-its-work-circle fw500 c15 fs1-25rem",
                style: {
                    top: '-20px',
                    left: '-20px',
                    lineHeight: '47.27px'
                },
                children: data?.serialNumber
            })
        ]
    });
};
var $4e6123e31e77b8e5$export$2e2bcd8739ae039 = $4e6123e31e77b8e5$var$WorkCards;


const $5fb5645b2fc70803$var$HowItsWorkSection = ({ data: data, refs: refs, isAnimationVisible: isAnimationVisible })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "pr lwbg how-its-work",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container work-container",
            style: {
                padding: Number(data?.IMAGES_ARRAY?.length) === 4 && '40px 0px'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    ref: refs?.current?.[3],
                    className: `tac fw500 fs2-125rem c21 tslp mb2rem ${isAnimationVisible[3] ? 'op1 tty0' : 'op0 ttx20'}`,
                    style: {
                        lineHeight: '62.2px'
                    },
                    children: data?.title
                }),
                Number(data?.IMAGES_ARRAY?.length) === 3 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcsb w100 mt4rem mb4rem",
                    children: data?.IMAGES_ARRAY?.map((workObj, i, arr)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6123e31e77b8e5$export$2e2bcd8739ae039), {
                            refs: refs,
                            data: {
                                ...workObj,
                                serialNumber: i + 1
                            }
                        }, `${workObj?.title}-${i}`);
                    })
                }),
                Number(data?.IMAGES_ARRAY?.length) === 4 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc mt4rem",
                            children: data?.IMAGES_ARRAY?.slice(0, 2)?.map((workObj, i, arr)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6123e31e77b8e5$export$2e2bcd8739ae039), {
                                    isMargin: i === 1 && true,
                                    refs: refs,
                                    data: {
                                        ...workObj,
                                        serialNumber: i + 1
                                    }
                                }, `${workObj?.title}-${i}`);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc mt2rem mb4rem",
                            children: data?.IMAGES_ARRAY?.slice(2, 4)?.map((workObj, i, arr)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6123e31e77b8e5$export$2e2bcd8739ae039), {
                                    isMargin: i === 1 && true,
                                    refs: refs,
                                    data: {
                                        ...workObj,
                                        serialNumber: i + 3
                                    }
                                }, `${workObj?.title}-${i}`);
                            })
                        })
                    ]
                }),
                Number(data?.IMAGES_ARRAY?.length) === 5 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcsb mt4rem",
                            children: data?.IMAGES_ARRAY?.slice(0, 3)?.map((workObj, i, arr)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6123e31e77b8e5$export$2e2bcd8739ae039), {
                                    refs: refs,
                                    data: {
                                        ...workObj,
                                        serialNumber: i + 1
                                    }
                                }, `${workObj?.title}-${i}`);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc mt3rem w100 mb4rem",
                            children: data?.IMAGES_ARRAY?.slice(3, 5)?.map((workObj, i, arr)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6123e31e77b8e5$export$2e2bcd8739ae039), {
                                    isMargin: i === 1 && true,
                                    refs: refs,
                                    data: {
                                        ...workObj,
                                        serialNumber: i + 4
                                    }
                                }, `${workObj?.title}-${i}`);
                            })
                        })
                    ]
                }),
                Number(data?.IMAGES_ARRAY?.length) === 6 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcsb mt4rem",
                            children: data?.IMAGES_ARRAY?.slice(0, 3)?.map((workObj, i, arr)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6123e31e77b8e5$export$2e2bcd8739ae039), {
                                    refs: refs,
                                    data: {
                                        ...workObj,
                                        serialNumber: i + 1
                                    }
                                }, `${workObj?.title}-${i}`);
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df jcc mt3rem w100 mb2rem",
                            children: data?.IMAGES_ARRAY?.slice(3, 6)?.map((workObj, i, arr)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4e6123e31e77b8e5$export$2e2bcd8739ae039), {
                                    isMargin: i === 1 && true,
                                    refs: refs,
                                    data: {
                                        ...workObj,
                                        serialNumber: i + 4
                                    }
                                }, `${workObj?.title}-${i}`);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "w100 tac c1",
                    children: data?.description
                })
            ]
        })
    });
};
var $5fb5645b2fc70803$export$2e2bcd8739ae039 = $5fb5645b2fc70803$var$HowItsWorkSection;



var $ayMG0 = parcelRequire("ayMG0");




var $acw62 = parcelRequire("acw62");














const $25b39fd976a73bd1$var$KeyFeaturesModules = ({ data: data, refs: refs, isAnimationVisible: isAnimationVisible, subTitle: subTitle, len: len })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const [kpiAnimationBox, setKPIAnimationBox] = (0, $acw62.useState)(false);
    const [businessAnimationBox, setBusinessAnimationBox] = (0, $acw62.useState)(false);
    const [selectedFeature, setSelectedFeature] = (0, $acw62.useState)({});
    const [proPLusSelected, setProPLusSelected] = (0, $acw62.useState)({});
    const [appStoreGrowthSelected, setAppStoreGrowthSelected] = (0, $acw62.useState)({});
    const [coreModulesProSelected, setCoreModulesProSelected] = (0, $acw62.useState)({});
    const [coreModulesFreeSelected, setCoreModulesFreeSelected] = (0, $acw62.useState)({});
    const [coreModulesLiteSelected, setCoreModulesLiteSelected] = (0, $acw62.useState)({});
    const [coreModulesPortfolioSelected, setCoreModulesPortfolioSelected] = (0, $acw62.useState)({});
    const [appStoreInvestmentSelected, setAppStoreInvestmentSelected] = (0, $acw62.useState)({});
    const handleCoreModulesPortfolioMore = async (item)=>{
        setSelectedFeature(item);
        setCoreModulesFreeSelected(item);
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const handleCoreModuleFreeSeeMore = async (item, scroll)=>{
        if (scroll) {
            document.getElementById('not-sure-yet').scrollIntoView({
                behavior: 'smooth'
            });
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        } else {
            setSelectedFeature(item);
            setCoreModulesFreeSelected(item);
            await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'openSeeMore'
            }));
        }
    };
    const handleCoreModuleLiteSeeMore = async (item)=>{
        setSelectedFeature(item);
        setCoreModulesLiteSelected(item);
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const handleCoreModuleProSeeMore = async (item)=>{
        setSelectedFeature(item);
        setCoreModulesProSelected(item);
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const handleAppStoreInvestmentSeeMore = async (item)=>{
        setSelectedFeature(item);
        setAppStoreInvestmentSelected(item);
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const handleAppStoreGrowthSeeMore = async (item)=>{
        setSelectedFeature(item);
        setAppStoreGrowthSelected(item);
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const handleProPlusSeeMore = async (item)=>{
        setSelectedFeature(item);
        setProPLusSelected(item);
        await dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'openSeeMore'
        }));
    };
    const onModalClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        setSelectedFeature({});
        setProPLusSelected({});
        setCoreModulesProSelected({});
        setAppStoreGrowthSelected({});
        setCoreModulesFreeSelected({});
        setCoreModulesLiteSelected({});
        setAppStoreInvestmentSelected({});
        setCoreModulesPortfolioSelected({});
    };
    const mouseOverCoreModulesPro = (item)=>{
        setCoreModulesProSelected(item);
    // if (item['title'] == "20-Section Business Audit") {
    //     if (kpiAnimationBox) setKPIAnimationBox(false);
    //     setBusinessAnimationBox(true);
    // }
    // if (item['title'] == "Key Performance Indicators (KPI) Report") {
    //     if (businessAnimationBox) setBusinessAnimationBox(false);
    //     setKPIAnimationBox(true);
    // }
    };
    const mouseOutCoreModulesPro = (item)=>{
        if (modal['open'] == '') setCoreModulesProSelected({});
    // if (item['title'] == "20-Section Business Audit") setBusinessAnimationBox(false);
    // if (item['title'] == "Key Performance Indicators (KPI) Report") setKPIAnimationBox(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "homeMainBanner",
                className: "bg1 py4rem pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        ref: refs?.current?.[5],
                        className: `tslp mt4rem ${isAnimationVisible[5] ? 'op1 tty0' : 'op0 ttx20'}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "fw500 df jcc fs2-5rem mb0-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "Key modules"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c15 ml0-5rem",
                                        children: "and features"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "fw400 fs1rem df jcc c15",
                                children: subTitle ? subTitle : 'Reusable diligence - building your businesses stronger'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "keyfeautre-container py3rem w100 df fww aic hero-saf pr",
                        children: [
                            data?.['titleOne'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "for-yoy-box p1rem pl3rem pr3rem br10px c1 df jcc mla mra pr zi2",
                                children: data['titleOne']
                            }),
                            data?.['portfolioModules'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bss p2rem br15px w100 keyfeature-box keyfeature-box-company-pro df fww mb3rem pr gg1-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-75rem c7 w100 mb2rem ml1rem",
                                        children: "FREE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "keyfeature-box-portfolio-innner pr",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "w100 df fww pr bsbb sm-fdc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w30 df fdc zi9 bsbb pr pt8rem pl4rem sm-w100 sm-pt0rem sm-pl0rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "fs1-5rem c15 fw500",
                                                            children: [
                                                                "Diligentsia ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                " Porfolio Pro ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                " FREE ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                                            ]
                                                        }),
                                                        data?.['subTiltle'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            className: "fs1rem c12 pr3rem xstac sm-pr0rem",
                                                            children: data?.['subTiltle']
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w70 df fww pt1rem sm-w100",
                                                    children: data['portfolioModules'].map((item)=>{
                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "cp w25 keyfeature-wihte-item bg1 new-shadow br15px p2rem zi9 pr bsbb fdc-xs",
                                                            style: {
                                                                width: item?.['isTwoMinuteTestBtn'] && '35%'
                                                            },
                                                            onMouseOver: ()=>setCoreModulesPortfolioSelected(item),
                                                            onMouseOut: ()=>modal['open'] == '' && setCoreModulesPortfolioSelected({}),
                                                            onClick: ()=>handleCoreModulesPortfolioMore(item),
                                                            children: [
                                                                item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: (parcelRequire("dlp4j")),
                                                                    className: "pa",
                                                                    alt: "star-img",
                                                                    style: {
                                                                        width: item?.['isTwoMinuteTestBtn'] ? '5%' : '8%',
                                                                        right: '8%'
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df aic features-icon",
                                                                    children: item?.icon
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df fw500 fs1-25rem c15",
                                                                    children: item?.title
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "bottom-area"
                                                                })
                                                            ]
                                                        });
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    Object.keys(coreModulesPortfolioSelected).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "seemore-box zi9",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "seemore-inner zi9",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df w100 smfdrr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pl2rem mt1rem",
                                                        style: {
                                                            width: "50%",
                                                            height: '100%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df w100 mb1rem smfdrr",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "w10 df aic",
                                                                        children: coreModulesPortfolioSelected?.seeMoreSection?.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "w90 fw500 c15 pl1rem df aic",
                                                                        style: {
                                                                            fontSize: '26px',
                                                                            lineHeight: '37.32px'
                                                                        },
                                                                        children: coreModulesPortfolioSelected?.seeMoreSection?.title
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                className: " mt0-5rem",
                                                                style: {
                                                                    paddingLeft: '22px'
                                                                },
                                                                children: coreModulesPortfolioSelected?.seeMoreSection?.points?.map((objpoints, index)=>{
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        style: {
                                                                            lineHeight: '25px',
                                                                            paddingBottom: "3px",
                                                                            paddingTop: "3px",
                                                                            paddingLeft: "20px",
                                                                            borderLeft: '2px solid #D3D9FC',
                                                                            ...coreModulesPortfolioSelected?.seeMoreSection?.liStyle
                                                                        },
                                                                        className: "df fdc fs1rem c14 fw400",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "pr fs1rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "circle"
                                                                                    }),
                                                                                    objpoints
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                children: coreModulesPortfolioSelected?.seeMoreSection?.subMenu && coreModulesPortfolioSelected?.seeMoreSection?.subMenu?.index === index && coreModulesPortfolioSelected?.seeMoreSection?.subMenu?.points?.map((str)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                                        style: {
                                                                                            lineHeight: '30px'
                                                                                        },
                                                                                        children: str
                                                                                    });
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, `${objpoints}-${index}`);
                                                                })
                                                            }),
                                                            coreModulesPortfolioSelected?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt1rem",
                                                                style: {
                                                                    border: '1px solid gray',
                                                                    padding: "10px",
                                                                    borderRadius: '10px'
                                                                },
                                                                children: coreModulesPortfolioSelected?.seeMoreSection?.notePoint
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic jce",
                                                        style: {
                                                            width: '45%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: coreModulesPortfolioSelected?.seeMoreSection?.image,
                                                            className: "w70",
                                                            style: {
                                                                objectFit: 'fill'
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            data?.['freeModules'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bss p2rem br25px w100 keyfeature-box keyfeature-box-free df fww mb3rem pr gg1-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-75rem c7 w100 mb2rem ml1rem copyButtonText",
                                        children: "FREE"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "keyfeature-box-grid",
                                        children: data?.['freeModules'].map((item)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "cp w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr fdc-xs",
                                                style: {
                                                    width: '100%'
                                                },
                                                onMouseOver: ()=>setCoreModulesFreeSelected(item),
                                                onMouseOut: ()=>{
                                                    modal['open'] == '' && setCoreModulesFreeSelected({});
                                                },
                                                children: [
                                                    item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("dlp4j")),
                                                        className: "pa",
                                                        alt: "star-img",
                                                        style: {
                                                            width: item?.['isTwoMinuteTestBtn'] ? '5%' : '8%',
                                                            right: '8%'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic features-icon",
                                                        onClick: ()=>handleCoreModuleFreeSeeMore(item, false),
                                                        children: item?.icon
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df fw500 fs1-25rem c15 xlfdc xxlfdc",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "aboutDescription xlmra",
                                                                onClick: ()=>handleCoreModuleFreeSeeMore(item, false),
                                                                children: item?.title
                                                            }),
                                                            item?.['isTwoMinuteTestBtn'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                onClick: ()=>handleCoreModuleFreeSeeMore(item, true),
                                                                className: `w250px fs1rem bg1 br35px pr cp c4 arrowBtnAnimation df jcc aic py0-5rem my0-5rem xlmra`,
                                                                style: {
                                                                    border: '1px solid #FC7785'
                                                                },
                                                                children: [
                                                                    "2-Minute Test",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "13",
                                                                        height: "13",
                                                                        viewBox: "0 0 21 18",
                                                                        fill: "none",
                                                                        xmlns: "http:www.w3.org/2000/svg",
                                                                        style: {
                                                                            marginLeft: '10px',
                                                                            stroke: '#FC7785'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M1.39612 10.331H15.818L11.43 14.7191C10.1696 15.9795 12.0602 17.87 13.3206 16.6096L17.3169 12.6071L19.9847 9.93519C20.5017 9.41507 20.5017 8.57507 19.9847 8.05496L13.3206 1.38311C13.0671 1.12258 12.7181 0.976392 12.3545 0.979416C11.1542 0.979567 10.5652 2.4415 11.43 3.2738L15.8284 7.66187H1.32711C-0.521408 7.75359 -0.383387 10.4231 1.39612 10.331Z",
                                                                            fill: "#FC7785"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "bottom-area",
                                                        onClick: ()=>handleCoreModuleFreeSeeMore(item, false)
                                                    })
                                                ]
                                            });
                                        })
                                    }),
                                    Object.keys(coreModulesFreeSelected).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "seemore-box",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "seemore-inner",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df w100 smfdrr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pl2rem mt1rem",
                                                        style: {
                                                            width: "50%",
                                                            height: '100%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df w100 mb1rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "w10 df aic",
                                                                        children: coreModulesFreeSelected?.seeMoreSection?.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "w90 fw500 c15 pl1rem df aic",
                                                                        style: {
                                                                            fontSize: '26px',
                                                                            lineHeight: '37.32px'
                                                                        },
                                                                        children: coreModulesFreeSelected?.seeMoreSection?.title
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                className: " mt0-5rem",
                                                                style: {
                                                                    paddingLeft: '22px'
                                                                },
                                                                children: coreModulesFreeSelected?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        style: {
                                                                            lineHeight: '25px',
                                                                            paddingBottom: "3px",
                                                                            paddingTop: "3px",
                                                                            paddingLeft: "20px",
                                                                            borderLeft: '2px solid #D3D9FC',
                                                                            ...coreModulesFreeSelected?.seeMoreSection?.liStyle
                                                                        },
                                                                        className: "df fdc c14 fs1-25rem fw400",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "pr",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "circle"
                                                                                    }),
                                                                                    objpoints
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                children: coreModulesFreeSelected?.seeMoreSection?.subMenu && coreModulesFreeSelected?.seeMoreSection?.subMenu?.index === index && coreModulesFreeSelected?.seeMoreSection?.subMenu?.points?.map((str)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                                        style: {
                                                                                            lineHeight: '30px'
                                                                                        },
                                                                                        children: str
                                                                                    });
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, `${objpoints}-${index}`);
                                                                })
                                                            }),
                                                            coreModulesFreeSelected?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt1rem",
                                                                style: {
                                                                    border: '1px solid gray',
                                                                    padding: "10px",
                                                                    borderRadius: '10px'
                                                                },
                                                                children: coreModulesFreeSelected?.seeMoreSection?.notePoint
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic jce",
                                                        style: {
                                                            width: '45%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: coreModulesFreeSelected?.seeMoreSection?.image,
                                                            className: "w70",
                                                            style: {
                                                                objectFit: 'fill'
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            data?.['coreModulesLite'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg20 bss bo5 bsbb p2rem br25px w100 keyfeature-box keyfeature-box-core df fww mb3rem pr gg1-5rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                        className: "fs1-25rem c15 w100 mb2rem copyButtonText",
                                        children: [
                                            "Core Modules - ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c7",
                                                children: "Lite"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "keyfeature-box-grid",
                                        children: data?.['coreModulesLite'].map((item)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "cp w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr fdc-xs",
                                                onMouseOver: ()=>setCoreModulesLiteSelected(item),
                                                onMouseOut: ()=>{
                                                    modal['open'] == '' && setCoreModulesLiteSelected({});
                                                },
                                                onClick: ()=>handleCoreModuleLiteSeeMore(item),
                                                children: [
                                                    item['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("dlp4j")),
                                                        className: "pa",
                                                        alt: "star-img",
                                                        style: {
                                                            width: '8%',
                                                            right: '8%'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic features-icon",
                                                        children: item?.icon
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "fw500 fs1-25rem c15 aboutDescription",
                                                        children: item?.title
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "bottom-area"
                                                    })
                                                ]
                                            });
                                        })
                                    }),
                                    Object.keys(coreModulesLiteSelected).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "seemore-box",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "seemore-inner",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df w100 smfdrr",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pl3rem",
                                                        style: {
                                                            width: "55%",
                                                            height: '100%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df w100 mb1rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "w10 df aic",
                                                                        children: coreModulesLiteSelected?.seeMoreSection?.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "w90 fw500 c15 pl1rem df aic",
                                                                        style: {
                                                                            fontSize: '26px',
                                                                            lineHeight: '37.32px'
                                                                        },
                                                                        children: coreModulesLiteSelected?.seeMoreSection?.title
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                className: " mt0-5rem",
                                                                style: {
                                                                    paddingLeft: '22px'
                                                                },
                                                                children: coreModulesLiteSelected?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        style: {
                                                                            lineHeight: '25px',
                                                                            paddingBottom: "3px",
                                                                            paddingTop: "3px",
                                                                            paddingLeft: "20px",
                                                                            borderLeft: '2px solid #D3D9FC',
                                                                            ...coreModulesLiteSelected?.seeMoreSection?.liStyle
                                                                        },
                                                                        className: "df fdc c14 fs1-25rem fw400",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "pr",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "circle"
                                                                                    }),
                                                                                    objpoints
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                children: coreModulesLiteSelected?.seeMoreSection?.subMenu && coreModulesLiteSelected?.seeMoreSection?.subMenu?.index === index && coreModulesLiteSelected?.seeMoreSection?.subMenu?.points?.map((str)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                                        style: {
                                                                                            lineHeight: '30px'
                                                                                        },
                                                                                        children: str
                                                                                    });
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, `${objpoints}-${index}`);
                                                                })
                                                            }),
                                                            coreModulesLiteSelected?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "mt1rem",
                                                                style: {
                                                                    border: '1px solid gray',
                                                                    padding: "10px",
                                                                    borderRadius: '10px'
                                                                },
                                                                children: coreModulesLiteSelected?.seeMoreSection?.notePoint
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df aic jce",
                                                        style: {
                                                            width: '45%'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            src: coreModulesLiteSelected?.seeMoreSection?.image,
                                                            className: "w70",
                                                            style: {
                                                                objectFit: 'fill'
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            data?.['titleTwo'] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "for-yoy-box p1rem pl3rem pr3rem br10px c1 df jcc mla mra pr zi2",
                                children: data['titleTwo']
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bg20 bss bo3 bw2px br50px p2rem bsbb coreModulesProSec",
                                children: [
                                    data?.['coreModulesPro'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg20 bss bo5 bsbb p2rem br25px w100 keyfeature-box keyfeature-box-core-pro df fww mb2rem pr gg1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "fs1-25rem c15 w100 mb2rem copyButtonText",
                                                children: [
                                                    "Core Modules - ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c7",
                                                        children: "PRO"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "keyfeature-box-grid",
                                                children: data?.['coreModulesPro'].map((item)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "cp w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr fdc-xs",
                                                        onMouseOver: ()=>mouseOverCoreModulesPro(item),
                                                        onMouseOut: ()=>mouseOutCoreModulesPro(item),
                                                        onClick: ()=>handleCoreModuleProSeeMore(item),
                                                        children: [
                                                            item['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: (parcelRequire("dlp4j")),
                                                                className: "pa",
                                                                alt: "star-img",
                                                                style: {
                                                                    width: '8%',
                                                                    right: '8%'
                                                                }
                                                            }),
                                                            item['isCertificate'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                src: (parcelRequire("hHzl1")),
                                                                className: "pa certiImage",
                                                                alt: "star-img",
                                                                style: {
                                                                    width: '50%',
                                                                    right: '8%'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df aic features-icon",
                                                                children: item?.icon
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: `fw500 fs1-25rem c15 aboutDescription ${item?.['isCertificate'] && ' mt1rem'} w50`,
                                                                children: item?.title
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "bottom-area"
                                                            })
                                                        ]
                                                    });
                                                })
                                            }),
                                            Object.keys(coreModulesProSelected).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "seemore-box",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "seemore-inner",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df w100 smfdrr",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "pl2rem mt1rem",
                                                                style: {
                                                                    width: "50%",
                                                                    height: '100%'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "df w100 mb1rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w10 df aic",
                                                                                children: coreModulesProSelected?.seeMoreSection?.icon
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "w90 fw500 c15 pl1rem df aic",
                                                                                style: {
                                                                                    fontSize: '26px',
                                                                                    lineHeight: '37.32px'
                                                                                },
                                                                                children: coreModulesProSelected?.seeMoreSection?.title
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                        className: " mt0-5rem",
                                                                        style: {
                                                                            paddingLeft: '22px'
                                                                        },
                                                                        children: coreModulesProSelected?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                style: {
                                                                                    lineHeight: '25px',
                                                                                    paddingBottom: "3px",
                                                                                    paddingTop: "3px",
                                                                                    paddingLeft: "20px",
                                                                                    borderLeft: '2px solid #D3D9FC',
                                                                                    ...coreModulesProSelected?.seeMoreSection?.liStyle
                                                                                },
                                                                                className: "df fdc c14 fs1-25rem fw400",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "pr",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                className: "circle"
                                                                                            }),
                                                                                            objpoints
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        children: coreModulesProSelected?.seeMoreSection?.subMenu && coreModulesProSelected?.seeMoreSection?.subMenu?.index === index && coreModulesProSelected?.seeMoreSection?.subMenu?.points?.map((str)=>{
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                                                style: {
                                                                                                    lineHeight: '30px'
                                                                                                },
                                                                                                children: str
                                                                                            });
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, `${objpoints}-${index}`);
                                                                        })
                                                                    }),
                                                                    coreModulesProSelected?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "mt1rem",
                                                                        style: {
                                                                            border: '1px solid gray',
                                                                            padding: "10px",
                                                                            borderRadius: '10px'
                                                                        },
                                                                        children: coreModulesProSelected?.seeMoreSection?.notePoint
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "df aic jce",
                                                                style: {
                                                                    width: '45%'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    src: coreModulesProSelected?.seeMoreSection?.image,
                                                                    className: "w70",
                                                                    style: {
                                                                        objectFit: 'fill'
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (data?.['appStoreInvestment'] || data?.['appStoreGrowth']) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "bg20 bss bsbb bo5 p2rem br25px w100 keyfeature-box keyfeature-box-core df fww keyfeature-box-two keyfeature-box-appstore pr gg1-5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                className: "fs1-25rem c15 w100 copyButtonText",
                                                children: [
                                                    "Diligentsia ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c4",
                                                        children: "AppStore"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem mb1-5rem w100 c2 mt0-5rem aboutSmallDescription",
                                                children: "In-platform Expansion Pack purchases - requires Pro subscription"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs1rem mb1rem w100 c15 fw600",
                                                children: "Investment/Exit Ready"
                                            }),
                                            data?.['appStoreInvestment'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "keyfeature-box-grid",
                                                        children: data?.['appStoreInvestment'].map((item)=>{
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "cp w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr fdc-xs",
                                                                onMouseOver: ()=>setAppStoreInvestmentSelected(item),
                                                                onMouseOut: ()=>{
                                                                    modal['open'] == '' && setAppStoreInvestmentSelected({});
                                                                },
                                                                onClick: ()=>handleAppStoreInvestmentSeeMore(item),
                                                                children: [
                                                                    item['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: (parcelRequire("dlp4j")),
                                                                        className: "pa",
                                                                        alt: "star-img",
                                                                        style: {
                                                                            width: '8%',
                                                                            right: '8%'
                                                                        }
                                                                    }),
                                                                    item['isGoldCertificate'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: (parcelRequire("jVRke")),
                                                                        className: "pa",
                                                                        alt: "star-img",
                                                                        style: {
                                                                            width: '20%',
                                                                            right: '8%'
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df aic features-icon",
                                                                        children: item?.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "fw500 fs1-25rem c15 aboutDescription",
                                                                        children: item?.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bottom-area"
                                                                    })
                                                                ]
                                                            });
                                                        })
                                                    }),
                                                    Object.keys(appStoreInvestmentSelected).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: `seemore-box mb2rem pr ${appStoreInvestmentSelected['title'] == 'Diligentsia Pro PLUS' ? 'seemore-box-pro' : ''} `,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "seemore-inner",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df w100 smfdrr",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pl2rem mt1rem",
                                                                        style: {
                                                                            width: "50%",
                                                                            height: '100%'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df w100 mb1rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "w10 df aic",
                                                                                        children: appStoreInvestmentSelected?.seeMoreSection?.icon
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "w90 fw500 c15 pl1rem df aic",
                                                                                        style: {
                                                                                            fontSize: '26px',
                                                                                            lineHeight: '37.32px'
                                                                                        },
                                                                                        children: appStoreInvestmentSelected?.seeMoreSection?.title
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                                className: " mt0-5rem",
                                                                                style: {
                                                                                    paddingLeft: '22px'
                                                                                },
                                                                                children: appStoreInvestmentSelected?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                        style: {
                                                                                            lineHeight: '25px',
                                                                                            paddingBottom: "3px",
                                                                                            paddingTop: "3px",
                                                                                            paddingLeft: "20px",
                                                                                            borderLeft: '2px solid #D3D9FC',
                                                                                            ...appStoreInvestmentSelected?.seeMoreSection?.liStyle
                                                                                        },
                                                                                        className: "df fdc c14 fs1-25rem fw400",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "pr",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "circle"
                                                                                                    }),
                                                                                                    objpoints
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                children: appStoreInvestmentSelected?.seeMoreSection?.subMenu && appStoreInvestmentSelected?.seeMoreSection?.subMenu?.index === index && appStoreInvestmentSelected?.seeMoreSection?.subMenu?.points?.map((str, i, arr)=>{
                                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                                                        style: {
                                                                                                            lineHeight: '30px'
                                                                                                        },
                                                                                                        children: str
                                                                                                    });
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }, `${objpoints}-${index}`);
                                                                                })
                                                                            }),
                                                                            appStoreInvestmentSelected?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "mt1rem",
                                                                                style: {
                                                                                    border: '1px solid gray',
                                                                                    padding: "10px",
                                                                                    borderRadius: '10px'
                                                                                },
                                                                                children: appStoreInvestmentSelected?.seeMoreSection?.notePoint
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df aic jce",
                                                                        style: {
                                                                            width: '45%'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: appStoreInvestmentSelected?.seeMoreSection?.image,
                                                                            className: "w70",
                                                                            style: {
                                                                                objectFit: 'fill'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs1rem mb1rem w100 c15 fw600 mt2rem",
                                                children: "Growth Ready"
                                            }),
                                            data?.['appStoreGrowth'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "keyfeature-box-grid",
                                                        children: data?.['appStoreGrowth'].map((item)=>{
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "cp w100 keyfeature-wihte-item bg1 new-shadow br15px p2rem pr fdc-xs",
                                                                onMouseOver: ()=>setAppStoreGrowthSelected(item),
                                                                onMouseOut: ()=>{
                                                                    modal['open'] == '' && setAppStoreGrowthSelected({});
                                                                },
                                                                onClick: ()=>handleAppStoreGrowthSeeMore(item),
                                                                children: [
                                                                    item['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: (parcelRequire("dlp4j")),
                                                                        className: "pa",
                                                                        alt: "star-img",
                                                                        style: {
                                                                            width: '8%',
                                                                            right: '8%'
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df aic features-icon",
                                                                        children: item?.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "fw500 fs1-25rem c15 aboutDescription",
                                                                        children: item?.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bottom-area"
                                                                    })
                                                                ]
                                                            });
                                                        })
                                                    }),
                                                    Object.keys(appStoreGrowthSelected).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "seemore-box",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "seemore-inner",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df w100 smfdrr",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pl2rem mt1rem",
                                                                        style: {
                                                                            width: "50%",
                                                                            height: '100%'
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "df w100 mb1rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "w10 df aic",
                                                                                        children: appStoreGrowthSelected?.seeMoreSection?.icon
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "w90 fw500 c15 pl1rem df aic",
                                                                                        style: {
                                                                                            fontSize: '26px',
                                                                                            lineHeight: '37.32px'
                                                                                        },
                                                                                        children: appStoreGrowthSelected?.seeMoreSection?.title
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                                className: "mt0-5rem",
                                                                                style: {
                                                                                    paddingLeft: '22px'
                                                                                },
                                                                                children: appStoreGrowthSelected?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                        style: {
                                                                                            lineHeight: '25px',
                                                                                            paddingBottom: "3px",
                                                                                            paddingTop: "3px",
                                                                                            paddingLeft: "20px",
                                                                                            borderLeft: '2px solid #D3D9FC',
                                                                                            ...appStoreGrowthSelected?.seeMoreSection?.liStyle
                                                                                        },
                                                                                        className: "df fdc c14 fs1-25rem fw400",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "pr",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "circle"
                                                                                                    }),
                                                                                                    objpoints
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                children: appStoreGrowthSelected?.seeMoreSection?.subMenu && appStoreGrowthSelected?.seeMoreSection?.subMenu?.index === index && appStoreGrowthSelected?.seeMoreSection?.subMenu?.points?.map((str, i, arr)=>{
                                                                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                        className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                                                        style: {
                                                                                                            lineHeight: '30px'
                                                                                                        },
                                                                                                        children: str
                                                                                                    });
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }, `${objpoints}-${index}`);
                                                                                })
                                                                            }),
                                                                            appStoreGrowthSelected?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "mt1rem",
                                                                                style: {
                                                                                    border: '1px solid gray',
                                                                                    padding: "10px",
                                                                                    borderRadius: '10px'
                                                                                },
                                                                                children: appStoreGrowthSelected?.seeMoreSection?.notePoint
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df aic jce",
                                                                        style: {
                                                                            width: '45%'
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: appStoreGrowthSelected?.seeMoreSection?.image,
                                                                            className: "w70",
                                                                            style: {
                                                                                objectFit: 'fill'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    data?.['proPlus'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "bsbb pt2rem pl2rem w100 keyfeature-box df fww keyfeature-box-proplus pr gg1-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "keyfeature-box-grid",
                                                    children: [
                                                        data?.['proPlus'].map((item)=>{
                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "cp keyfeature-wihte-item bg1 new-shadow br15px px1rem py2-5rem pr bgyellow fdc-xs",
                                                                style: {
                                                                    background: '#fffbd3',
                                                                    border: '1px solid #f9e84b'
                                                                },
                                                                onMouseOver: ()=>setProPLusSelected(item),
                                                                onMouseOut: ()=>{
                                                                    modal['open'] == '' && setProPLusSelected({});
                                                                },
                                                                onClick: ()=>handleProPlusSeeMore(item),
                                                                children: [
                                                                    item?.['isStar'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: (parcelRequire("dlp4j")),
                                                                        className: "pa",
                                                                        alt: "star-img",
                                                                        style: {
                                                                            width: item?.['isTwoMinuteTestBtn'] ? '5%' : '8%',
                                                                            right: '8%'
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df aic features-icon",
                                                                        children: item?.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "df fw500 fs1-25rem c15 aboutDescription",
                                                                        children: item?.title
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "bottom-area"
                                                                    })
                                                                ]
                                                            });
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "w20"
                                                        })
                                                    ]
                                                }),
                                                Object.keys(proPLusSelected).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "seemore-box",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "seemore-inner",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df w100 smfdrr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "pl2rem mt1rem",
                                                                    style: {
                                                                        width: "50%",
                                                                        height: '100%'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                            className: "df w100 mb1rem",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "w10 df aic",
                                                                                    children: proPLusSelected?.seeMoreSection?.icon
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                    className: "w90 fw500 c15 pl1rem df aic seemore_title",
                                                                                    style: {
                                                                                        fontSize: '26px',
                                                                                        lineHeight: '37.32px'
                                                                                    },
                                                                                    children: proPLusSelected?.seeMoreSection?.title
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                            className: "mt0-5rem",
                                                                            style: {
                                                                                paddingLeft: '22px'
                                                                            },
                                                                            children: proPLusSelected?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                    style: {
                                                                                        lineHeight: '25px',
                                                                                        paddingBottom: "3px",
                                                                                        paddingTop: "3px",
                                                                                        paddingLeft: "20px",
                                                                                        borderLeft: '2px solid #D3D9FC',
                                                                                        ...proPLusSelected?.seeMoreSection?.liStyle
                                                                                    },
                                                                                    className: "df fdc c14 fs1-25rem fw400",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "pr",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "circle"
                                                                                                }),
                                                                                                objpoints
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                            children: proPLusSelected?.seeMoreSection?.subMenu && proPLusSelected?.seeMoreSection?.subMenu?.index === index && proPLusSelected?.seeMoreSection?.subMenu?.points?.map((str, i, arr)=>{
                                                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                                    className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                                                    style: {
                                                                                                        lineHeight: '30px'
                                                                                                    },
                                                                                                    children: str
                                                                                                });
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }, `${objpoints}-${index}`);
                                                                            })
                                                                        }),
                                                                        proPLusSelected?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "mt1rem",
                                                                            style: {
                                                                                border: '1px solid gray',
                                                                                padding: "10px",
                                                                                borderRadius: '10px'
                                                                            },
                                                                            children: proPLusSelected?.seeMoreSection?.notePoint
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "df aic jce",
                                                                    style: {
                                                                        width: '45%'
                                                                    },
                                                                    children: [
                                                                        proPLusSelected?.seeMoreSection?.image && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: proPLusSelected?.seeMoreSection?.image,
                                                                            className: "w60",
                                                                            style: {
                                                                                objectFit: 'fill'
                                                                            }
                                                                        }),
                                                                        proPLusSelected?.seeMoreSection?.image_one && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            src: proPLusSelected?.seeMoreSection?.image_one,
                                                                            className: "w60",
                                                                            style: {
                                                                                objectFit: 'fill'
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df pt2rem pl3rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("dlp4j")),
                                        className: "w20px h20px mr0-5rem",
                                        alt: "star-img"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c12 fs0-75rem",
                                        children: "=  completed modules required for Gold Certification"
                                    })
                                ]
                            }),
                            kpiAnimationBox && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                id: "balloon-animation2",
                                className: `pa animation-img-box animation-img-boxUP`,
                                src: (parcelRequire("7JLrt")),
                                alt: ""
                            }),
                            businessAnimationBox && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                id: "balloon-animation1",
                                className: `pa animation-img-box animation-img-boxUP`,
                                src: (parcelRequire("hkSFW")),
                                alt: ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "keyFeatureSeeMore",
                open: modal['open'] == 'openSeeMore',
                onClose: onModalClose,
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 p4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        maxWidth: '1350px',
                        ...selectedFeature?.seeMoreSection?.cardPaddingBottom
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df w100 smfdrr sm-fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        width: "55%",
                                        height: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w10 df aic",
                                                    children: selectedFeature?.seeMoreSection?.icon
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w90 fw500 c15 pl1rem df aic",
                                                    style: {
                                                        fontSize: '26px',
                                                        lineHeight: '37.32px'
                                                    },
                                                    children: selectedFeature?.seeMoreSection?.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: " mt0-5rem",
                                            style: {
                                                paddingLeft: '22px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.points?.map((objpoints, index, arrr)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    style: {
                                                        lineHeight: '25px',
                                                        paddingBottom: "3px",
                                                        paddingTop: "3px",
                                                        paddingLeft: "20px",
                                                        borderLeft: '2px solid #D3D9FC',
                                                        ...selectedFeature?.seeMoreSection?.liStyle
                                                    },
                                                    className: "df fdc c14 fs1-25rem fw400",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "circle"
                                                                }),
                                                                objpoints
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            children: selectedFeature?.seeMoreSection?.subMenu && selectedFeature?.seeMoreSection?.subMenu?.index === index && selectedFeature?.seeMoreSection?.subMenu?.points?.map((str, i, arr)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "fs1rem c14 fs1rem fw400 df aic pl2rem",
                                                                    style: {
                                                                        lineHeight: '30px'
                                                                    },
                                                                    children: str
                                                                });
                                                            })
                                                        })
                                                    ]
                                                }, `${objpoints}-${index}`);
                                            })
                                        }),
                                        selectedFeature?.seeMoreSection?.notePoint && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mt1rem",
                                            style: {
                                                border: '1px solid gray',
                                                padding: "10px",
                                                borderRadius: '10px'
                                            },
                                            children: selectedFeature?.seeMoreSection?.notePoint
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jce",
                                    style: {
                                        width: '45%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: selectedFeature?.seeMoreSection?.image,
                                        className: "w70",
                                        style: {
                                            objectFit: 'fill'
                                        }
                                    })
                                })
                            ]
                        }),
                        selectedFeature?.['isInvestorLookupBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                            onClick: ()=>onModalClose(),
                            to: "#investor-lookup",
                            className: "my2rem p1rem px2rem shadow c1 bg4 bg3-hover br35px cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                            children: "Investor Database Check"
                        }),
                        selectedFeature?.['isTwoMinuteTestBtn'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cdb796ffe249f75$export$4ca9840115f43bad), {
                            onClick: ()=>onModalClose(),
                            to: "#not-sure-yet",
                            className: "my2rem p1rem px2rem shadow c1 bg4 bg3-hover br35px cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                            children: "Take FREE Test"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>onModalClose(),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $25b39fd976a73bd1$export$2e2bcd8739ae039 = $25b39fd976a73bd1$var$KeyFeaturesModules;



var $ayMG0 = parcelRequire("ayMG0");
const $0e5eabdbd79984d1$export$93ec00425a6a5969 = {
    'Companies': {
        "plans": [
            "FREE",
            "LITE",
            "PRO",
            "PRO Plus"
        ],
        "pricing": {
            "FREE": "\xa30",
            "LITE": "\xa38.25",
            "PRO": "\xa383.25",
            "PRO Plus": "Custom"
        },
        "buttonText": {
            "FREE": /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcc fdc fw600",
                children: [
                    "Get Started ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs10px fw400",
                        children: "No credit card required"
                    })
                ]
            }),
            "LITE": /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcc fdc fw600",
                children: [
                    "Get Started ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs10px fw400",
                        children: "Upgrade from dashboard"
                    })
                ]
            }),
            "PRO": /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcc fdc fw600",
                children: [
                    "Get Started ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs10px fw400",
                        children: "Upgrade from dashboard"
                    })
                ]
            }),
            "PRO Plus": "Book a call"
        },
        "features": {
            "Your Investment Journey &": {
                "Investment Readiness Checklist": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": 'image1'
                },
                "Completeness and Risk Scoring": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Bespoked reporting with recommendations for remediation ": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Foundational Diligence": {
                    "KPI Report": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Data Repository": {
                        "FREE": false,
                        "LITE": "20 sections",
                        "PRO": "160 sections & User defined sections & AI Filing Manager",
                        "PRO Plus": false
                    },
                    "Sync": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "RAG AI Foundation Layer": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Business Audit": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Draft Directors\u2019 Questionnaires": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Draft Warranty Disclosures": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Workflow Manager": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Unaudited Certification": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "Value Diligence": {
                    "AnyList Checklist Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Diligentsia AppStore access": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "ResearchAid Reports": {
                    "Market Opportunity": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Route To Market": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Competitor Analysis": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Technology Advantage": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "SWOT": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "ResearchAid Report Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "InvestorMatch": {
                    "OneForm Investor Application": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Database InvestorMatch\u200B": {
                        "FREE": "Count",
                        "LITE": "+ Names",
                        "PRO": "+ FIT Reports",
                        "PRO Plus": false
                    },
                    "InvestorMatch \u2013 1-click introductions (gold certification only)\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                }
            },
            "Your Growth Journey & ": {
                "Growth Readiness Checklist": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Completeness and Risk Scoring": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Bespoked reporting with recommendations for remediation ": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Foundational Diligence": {
                    "KPI Report": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Data Repository": {
                        "FREE": false,
                        "LITE": "20 sections",
                        "PRO": "160 sections & User defined sections & AI Filing Manager",
                        "PRO Plus": false
                    },
                    "Sync": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "RAG AI Foundation Layer": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Business Audit": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    // "Draft Directors’ Questionnaires": {
                    //     "FREE": false,
                    //     "LITE": false,
                    //     "PRO": "AppStore (extra)",
                    //     "PRO Plus": false
                    // },
                    // "Draft Warranty Disclosures": {
                    //     "FREE": false,
                    //     "LITE": false,
                    //     "PRO": "AppStore (extra)",
                    //     "PRO Plus": false
                    // },
                    "Workflow Manager": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Unaudited Certification": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "Value Diligence": {
                    "AnyList Checklist Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Diligentsia AppStore access": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "ResearchAid Reports": {
                    "Market Opportunity": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Route To Market": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Competitor Analysis": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Technology Advantage": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "SWOT": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "ResearchAid Report Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "Healthboost Modules": {
                    "Cybersecurity Review - partner module": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Loan Readiness Checklist - partner module": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Enhancing Your Business Plan\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Long Term Growth Planning\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Your KPIs": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Mitigating Your Key Risks\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Compliance\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Building New Funding Relationships\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Your Existing Funding Terms\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Increasing Your Revenues\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Driving Your Margins and Profit\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Improving Your Cashflow\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Boosting Outsourcing Efficiency\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Strengthen Your Internal Controls\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Optimising Your Taxation\u200B\u200B": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Enhancing Your Social Media": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    }
                }
            },
            "Your Exit Journey & ": {
                "Investment Readiness Checklist": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Completeness and Risk Scoring": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Bespoked reporting with recommendations for remediation ": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Foundational Diligence": {
                    "KPI Report": {
                        "FREE": true,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Data Repository": {
                        "FREE": false,
                        "LITE": "20 sections",
                        "PRO": "160 sections & User defined sections & AI Filing Manager",
                        "PRO Plus": false
                    },
                    "Sync": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "RAG AI Foundation Layer": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Business Audit": {
                        "FREE": false,
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Draft Directors\u2019 Questionnaires": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Draft Warranty Disclosures": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Workflow Manager": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Unaudited Certification": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "Value Diligence": {
                    "AnyList Checklist Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Diligentsia AppStore access": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "ResearchAid Reports": {
                    "Market Opportunity": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Route To Market": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Competitor Analysis": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Technology Advantage": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "SWOT": {
                        "FREE": "Report Summary",
                        "LITE": true,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "ResearchAid Report Builder": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                },
                "Exit Introductions\u200B": {
                    "Corporate Finance Boutiques (larger companies)": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    },
                    "Businesses For Sale (smaller companies)\xa0": {
                        "FREE": false,
                        "LITE": false,
                        "PRO": true,
                        "PRO Plus": false
                    }
                }
            },
            "Support": {
                "Agentic and telephone support": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Account Manager": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                }
            },
            "Dedicated Advisor": {
                "Can't or don\u2019t want to do it yourself?": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": false,
                    "PRO Plus": true
                },
                "Diligentsia Audited Certification": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": false,
                    "PRO Plus": true
                }
            }
        }
    },
    'Advisors': {
        "plans": [
            "Portfolio PRO",
            "Portfolio PRO ",
            "PRO Plus"
        ],
        "subTitle": {
            "Portfolio PRO": "Dashboard and tools for you",
            "Portfolio PRO ": "For your client company",
            "PRO Plus": "For a Client Project"
        },
        "pricing": {
            "Portfolio PRO": "FREE",
            "Portfolio PRO ": "\xa366.67",
            "PRO Plus": "Custom"
        },
        "buttonText": {
            "Portfolio PRO": /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcc fdc fw600",
                children: [
                    "Get Started ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs10px fw400",
                        children: "No credit card required"
                    })
                ]
            }),
            "Portfolio PRO ": '',
            "PRO Plus": "Book a call"
        },
        tag: {
            "Portfolio PRO": true
        },
        discount: {
            "Portfolio PRO ": '20%'
        },
        "features": {
            "Boost Margins - New Revenue Streams - New Clients": {
                "FREE Portfolio Pro Account": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image1',
                    "PRO Plus": 'image5'
                },
                "FREE Portfolio dashboard to monitor the progress of all your clients": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Put all your clients on the same data repository structure to aid document access - saves time for everyone": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "WorkFlow Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Client Benchmarking": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Connect with Investor database once achieved gold unaudited certification": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Offer new service revenue streams to existing clients": {
                    "Assist with preparation Unaudited Certification": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    },
                    "Chargeable quarterly reviews": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    },
                    "Delivery of new AppStore services": {
                        "Portfolio PRO": false,
                        "Portfolio PRO ": "AppStore (extra)",
                        "PRO Plus": false
                    },
                    "Focal point for integration of new RAG foundation layer and AI tools": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    }
                },
                "Find new clients": {
                    "Promotion to potential new clients": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    },
                    "Context sensitive service leads": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false,
                        "PRO Plus": false
                    }
                }
            },
            "Accelerate Your Client\u2019s Investment Journey &": {
                "All Company Pro tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image2',
                    "PRO Plus": 'image6'
                },
                "Investment Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Foundational Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Value Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "InvestorMatch \u2013 1-click introductions (gold certification only)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                }
            },
            "Accelerate Your Client\u2019s Growth Journey &": {
                "All Company Pro tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image3',
                    "PRO Plus": 'image7'
                },
                "Growth Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "20 x Healthboost Modules to systematically improve each area of the business": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AppStore modules for focussed improvement": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Focal point for integration of new RAG foundation layer and AI tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                }
            },
            "Accelerate Your Client\u2019s Exit Journey &": {
                "All Company Pro tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image4',
                    "PRO Plus": 'image8'
                },
                "Exit Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Foundational Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Value Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Corporate Finance Boutiques (larger companies)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Businesses For Sale (smaller companies)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                }
            },
            "Support": {
                "Agentic and telephone support": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                },
                "Account Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false,
                    "PRO Plus": false
                }
            },
            "Dedicated Advisor (fixed price packages or bespoke)": {
                "Clients can't or don\u2019t want to do it yourself?": {
                    "Portfolio PRO": "-",
                    "Portfolio PRO ": false,
                    "PRO Plus": true
                },
                "Diligentsia Audited Certification": {
                    "Portfolio PRO": "-",
                    "Portfolio PRO ": false,
                    "PRO Plus": true
                }
            }
        }
    },
    'Investors': {
        "plans": [
            "Portfolio PRO",
            "Portfolio PRO "
        ],
        "subTitle": {
            "Portfolio PRO": "Dashboard and tools for you",
            "Portfolio PRO ": "For your Applicant Company"
        },
        "pricing": {
            "Portfolio PRO": "FREE",
            "Portfolio PRO ": "\xa366.67"
        },
        "buttonText": {
            "Portfolio PRO": /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcc fdc fw600",
                children: [
                    "Get Started ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs10px fw400",
                        children: "No credit card required"
                    })
                ]
            }),
            "Portfolio PRO ": ''
        },
        tag: {
            "Portfolio PRO": true
        },
        discount: {
            "Portfolio PRO ": '20%'
        },
        "features": {
            "FREE Triaging of Applicant Companies &": {
                "FREE Portfolio Pro Account": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": 'image1'
                },
                "FREE Portfolio dashboard to monitor the progress of all your portfolio companies and applicants": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "OneForm InvestorMatch application (or integration of your existing form) - from your web site": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Fit Report on each applicant against your criteria": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Investment Readiness Report": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "WorkFlow Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "ResearchAid\xa0Reports": {
                    "Market Opportunity": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "Route To Market": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "Competitor Analysis": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "Technology Advantage": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "SWOT": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    }
                },
                "Further Pre-Investment Diligence &": {
                    "Data Repository": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": 'image2'
                    },
                    "Sync": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "Business Audit": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "Draft Directors\u2019 Questionnaires": {
                        "Portfolio PRO": "AppStore (extra)",
                        "Portfolio PRO ": false
                    },
                    "Draft Warranty Disclosures": {
                        "Portfolio PRO": "AppStore (extra)",
                        "Portfolio PRO ": false
                    },
                    "Further diligence - AnyList Checklist Builder": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "Further diligence - ResearchAid Report Builder": {
                        "Portfolio PRO": true,
                        "Portfolio PRO ": false
                    },
                    "We can match your rejected applicants with other investors": {
                        "Portfolio PRO": "AppStore (extra)",
                        "Portfolio PRO ": false
                    }
                }
            },
            "Post-Investment  Growth - Portfolio Companies &": {
                "Growth Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": "image3"
                },
                "100-Day Portfolio Value Growth Plan": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "20 x Healthboost Modules to systematically improve each area of the business": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Put all your clients on the same data repository structure to aid document access - saves time for everyone": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "AppStore modules for focussed improvement": {
                    "Portfolio PRO": "AppStore (extra)",
                    "Portfolio PRO ": false
                },
                "Quarterly portfolio Reviews": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Portfolio Benchmarking": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Focal point for integration of new RAG foundation layer and AI tools": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                }
            },
            "Portfolio Companies Permanently Exit Ready &": {
                "Exit Readiness Checklist": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": "image4"
                },
                "Foundational Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "AnyList Checklist Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Value Diligence Pack (see Company Pro for details)": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "ResearchAid Report Builder": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                }
            },
            "Support": {
                "Agentic and telephone support": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Account Manager": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                }
            },
            "Dedicated Advisor": {
                "Can't or don\u2019t want to do it yourself?": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                },
                "Diligentsia Audited Certification": {
                    "Portfolio PRO": true,
                    "Portfolio PRO ": false
                }
            }
        }
    }
};
const $0e5eabdbd79984d1$export$42a2f1c980fb3973 = {
    'Companies': {
        "plans": [
            "FREE",
            "LITE",
            "PRO",
            "PRO Plus"
        ],
        "headings": [
            "FREE",
            "LITE",
            "PRO",
            "PRO Plus"
        ],
        "pricing": {
            "FREE": "\xa30",
            "LITE": "\xa38.25",
            "PRO": "\xa383.25",
            "PRO Plus": "Custom"
        },
        "buttonText": {
            "FREE": /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df aic jcc fdc fw600",
                children: [
                    "Get Started ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs10px fw400",
                        children: "No credit card required"
                    })
                ]
            }),
            "LITE": 'Buy Now',
            "PRO": 'Buy Now',
            "PRO Plus": "Book a call"
        },
        "features": {
            "We Get You Organised": {
                "Try us out for FREE - no credit card required": {
                    "FREE": true,
                    "LITE": false,
                    "PRO": false,
                    "PRO Plus": 'image1'
                },
                "Investment Readiness": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Growth Readiness": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Exit Readiness": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "OneForm Application to multiple investors": {
                    "FREE": true,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "InvestorMatch - Looking for investment?": {
                    "FREE": "Number of matches",
                    "LITE": "Investor names",
                    "PRO": "InvestorConnect",
                    "PRO Plus": false
                },
                "Foundational Diligence Pack &": {
                    "FREE": false,
                    "LITE": true,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Value Diligence Pack &": {
                    "FREE": false,
                    "LITE": "5 reports",
                    "PRO": "Report Builder",
                    "PRO Plus": false
                },
                "AnyList Checklist Builder": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Diligentsia AppStore access": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Workflow Manager": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "Healthboost Modules": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": "AppStore (extra)",
                    "PRO Plus": false
                },
                "Unaudited Certification": {
                    "FREE": false,
                    "LITE": false,
                    "PRO": true,
                    "PRO Plus": false
                },
                "BUY_BUTTONS": {
                    "FREE": 'Get Started',
                    "LITE": 'Buy Now',
                    "PRO": 'Buy Now'
                }
            }
        }
    }
};
const $0e5eabdbd79984d1$export$dbcbf79151ffbae0 = {
    title: 'FREE',
    price: 'FREE',
    subTitle: "Let\u2019s get to know each other",
    points: [
        "FREE - no credit card required",
        'Entry level service',
        "Straightforward business value with practical recommendations",
        "See the power of our AI in action",
        "2-Minute Test to your company\xa0and its objectives",
        "Key Performance Indicator (\u201CKPI\u201D) Report tailored to your business and its industry"
    ],
    buttonText: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df jcc fdc aic w100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    lineHeight: '13px'
                },
                children: "Register for FREE"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fw400 c21",
                style: {
                    lineHeight: '13px',
                    fontStyle: 'italic',
                    fontSize: '10px'
                },
                children: "No credit card required"
            })
        ]
    }),
    buttonIdentifier: 'register'
};



const $0e5eabdbd79984d1$export$112a537719d1276b = {
    title: 'Lite',
    price: "\xa35",
    perMonth: true,
    subTitle: 'For micro businesses',
    hasWarning: [
        6,
        7,
        8
    ],
    points: [
        "Aimed at\xa0 businesses <5 employees wanting to organise themselves better",
        "2-Minute Test to your company\xa0and its objectives",
        "Key Performance Indicators (\u201CKPI\u201D)Report tailored to your business and its industry",
        'Data Repository - 20 sections eg. contracts',
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic",
            children: [
                "Syncs with",
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "pl0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("gPTbN")),
                            className: "w20 "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("3zMud")),
                            className: "w20 ",
                            style: {
                                marginLeft: '5px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("8BoXF")),
                            className: "w20 ",
                            style: {
                                marginLeft: '5px'
                            }
                        })
                    ]
                })
            ]
        }),
        'Customised Business Audit to your company and its objectives',
        'No certification',
        'No collaboration with Investors or Advisors',
        'No access to Diligentsia AppStore'
    ],
    buttonText: 'Buy Now',
    buttonIdentifier: 'payment'
};






const $0e5eabdbd79984d1$export$84fe5b53737f699c = {
    title: 'Pro',
    price: "\xa350",
    perMonth: true,
    subTitle: 'For SMEs',
    points: [
        "Aimed at\xa0growth businesses >5 employees",
        '2-Minute Test',
        "Customised Key Performance Indicators (KPIs)",
        "Data Repository - 20 sections, 160 subsections,\xa0user-defined sections,\xa0AI Filing Assistant",
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic",
            children: [
                "Syncs with",
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "pl0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("gPTbN")),
                            className: "w20 "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("3zMud")),
                            className: "w20 ",
                            style: {
                                marginLeft: '5px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("8BoXF")),
                            className: "w20 ",
                            style: {
                                marginLeft: '5px'
                            }
                        })
                    ]
                })
            ]
        }),
        'Customised Business Audit',
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        width: "60%"
                    },
                    children: "Unaudited Certification"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "pl0-5rem",
                    style: {
                        width: '40%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("iQeGV")),
                            style: {
                                width: '24%'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("l61of")),
                            style: {
                                marginLeft: '5px',
                                width: '24%'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("gI7Us")),
                            style: {
                                marginLeft: '5px',
                                width: '24%'
                            }
                        })
                    ]
                })
            ]
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "fw600",
                children: "Diligentsia AppStore"
            })
        }),
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                "Audited certification available via",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "fw600",
                    children: " Diligentsia PLUS"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                "Collaborate and share with advisors and investors via ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "fw600",
                    children: "Diligentsia Portfolio Pro"
                })
            ]
        })
    ],
    buttonText: 'Buy Now**',
    hasPopular: true,
    buttonIdentifier: 'payment'
};






const $0e5eabdbd79984d1$export$793932ede7161c97 = {
    title: 'Pro',
    price: "\xa350",
    perMonth: true,
    subTitle: 'For SMEs',
    points: [
        "Aimed at\xa0growth businesses >5 employees",
        '2-Minute Test',
        "Customised Key Performance Indicators (KPIs)",
        "Data Repository - 20 sections, 160 subsections,\xa0user-defined sections,\xa0AI Filing Assistant",
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic",
            children: [
                "Syncs to",
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "pl0-5rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("gPTbN")),
                            className: "w20 "
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("3zMud")),
                            className: "w20 ",
                            style: {
                                marginLeft: '5px'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("8BoXF")),
                            className: "w20 ",
                            style: {
                                marginLeft: '5px'
                            }
                        })
                    ]
                })
            ]
        }),
        'Customised Business Audit',
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        width: "60%"
                    },
                    children: "Unaudited Certification"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "pl0-5rem",
                    style: {
                        width: '40%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("iQeGV")),
                            style: {
                                width: '24%'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("l61of")),
                            style: {
                                marginLeft: '5px',
                                width: '24%'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("gI7Us")),
                            style: {
                                marginLeft: '5px',
                                width: '24%'
                            }
                        })
                    ]
                })
            ]
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "fw600",
                children: "Diligentsia AppStore"
            })
        }),
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                "Audited certification available via",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "fw600",
                    children: " Diligentsia PLUS"
                })
            ]
        }),
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                "Collaborate and share with advisors and investors via ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "fw600",
                    children: "Diligentsia Portfolio Pro"
                })
            ]
        })
    ],
    buttonText: 'Buy Now**',
    hasPopular: true,
    hasFooterText: true,
    buttonIdentifier: 'payment'
};



const $0e5eabdbd79984d1$export$376e2b2731789978 = {
    contactSection: true,
    title: 'Pro PLUS',
    price: 'Contact Us',
    subTitle: 'AUDITED diligence certification',
    points: [
        "Advisor supported diligence? Don\u2019t want to?",
        'Consultancy services',
        "Addition assurance from professional third-parties",
        'Have your own accountant or lawyer work through your diligence modules',
        'Inexpensive - designed to be quick and cost-effective.',
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df aic w100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    style: {
                        width: "60%"
                    },
                    children: "Audited certification"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "pl0-5rem",
                    style: {
                        width: '40%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("dDjqz")),
                            style: {
                                width: '24%'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("6tYxP")),
                            style: {
                                marginLeft: '5px',
                                width: '24%'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("jndeQ")),
                            style: {
                                marginLeft: '5px',
                                width: '24%'
                            }
                        })
                    ]
                })
            ]
        })
    ],
    buttonText: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "30",
                height: "30",
                viewBox: "0 0 39 39",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.9",
                        d: "M33.3804 4.33135H30.3365C30.3365 4.06704 30.2812 3.80565 30.1742 3.56399C30.0671 3.32233 29.9106 3.10577 29.7148 2.92823C29.519 2.75069 29.2882 2.61612 29.0373 2.53317C28.7863 2.45022 28.5207 2.42072 28.2577 2.44659C27.7806 2.50563 27.3422 2.73901 27.0268 3.10184C26.7115 3.46466 26.5414 3.93129 26.5493 4.41196V5.27811C26.5493 5.7122 26.6983 6.13314 26.9716 6.47044C27.2448 6.80774 27.6256 7.04092 28.0503 7.13093C28.1718 7.15386 28.2795 7.22337 28.3505 7.32465C28.4215 7.42592 28.45 7.55091 28.4301 7.67296C28.4102 7.795 28.3433 7.90441 28.2438 7.97784C28.1443 8.05127 28.0201 8.0829 27.8976 8.06597C27.2514 7.93885 26.6694 7.59143 26.2509 7.083C25.8323 6.57457 25.6032 5.93665 25.6026 5.27811V4.33135H20.329C20.3267 4.08071 20.2747 3.83301 20.1759 3.60262C20.0772 3.37224 19.9337 3.16374 19.7537 2.98923C19.5738 2.81471 19.361 2.67764 19.1277 2.58597C18.8944 2.49429 18.6453 2.44983 18.3947 2.45517C18.1441 2.46051 17.897 2.51553 17.6678 2.61705C17.4387 2.71858 17.2319 2.86458 17.0596 3.04659C16.8872 3.22861 16.7527 3.44302 16.6639 3.67741C16.575 3.91179 16.5336 4.16147 16.5419 4.41199L16.5419 5.27811C16.5418 5.7122 16.6909 6.13313 16.9641 6.47043C17.2374 6.80773 17.6182 7.04091 18.0428 7.13093C18.1643 7.15388 18.272 7.2234 18.343 7.32467C18.4139 7.42593 18.4425 7.55091 18.4225 7.67293C18.4026 7.79496 18.3358 7.90436 18.2363 7.97779C18.1368 8.05121 18.0126 8.08285 17.8901 8.06595C17.244 7.93882 16.662 7.5914 16.2434 7.08297C15.8249 6.57455 15.5957 5.93663 15.5951 5.27809V4.33135H12.5512C11.7984 4.33275 11.0767 4.63244 10.5444 5.1648C10.012 5.69716 9.71233 6.41879 9.71094 7.17165V9.80842H36.2207V7.17165C36.2193 6.41878 35.9196 5.69715 35.3872 5.1648C34.8549 4.63244 34.1332 4.33275 33.3804 4.33135ZM17.4887 4.33135C17.4924 4.08268 17.5937 3.84544 17.7709 3.67089C17.9481 3.49634 18.1868 3.3985 18.4355 3.3985C18.6842 3.39851 18.9229 3.49636 19.1 3.67091C19.2772 3.84547 19.3786 4.08272 19.3822 4.33139L17.4887 4.33135ZM27.4961 4.33135C27.4998 4.08268 27.6012 3.84544 27.7784 3.67089C27.9555 3.49634 28.1942 3.3985 28.4429 3.3985C28.6916 3.39851 28.9303 3.49636 29.1075 3.67091C29.2846 3.84547 29.386 4.08272 29.3897 4.33139L27.4961 4.33135Z",
                        fill: "#FEFEFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.9",
                        d: "M9.74219 17.1934C9.87852 17.459 10.8695 19.0329 10.954 19.27C11.2572 19.9563 11.3021 20.729 11.0806 21.4458C10.8591 22.1626 10.386 22.7752 9.74849 23.1707C9.7935 23.9237 10.1243 24.6311 10.6733 25.1485C11.2223 25.6658 11.9481 25.954 12.7024 25.9543H33.2286C34.0134 25.9531 34.7657 25.6409 35.3206 25.086C35.8755 24.5311 36.1877 23.7788 36.1888 22.994V11.0078H9.74219V17.1934ZM30.4261 13.3495C30.6717 13.3528 30.9061 13.4527 31.0786 13.6275C31.251 13.8023 31.3477 14.0381 31.3477 14.2837C31.3477 14.5292 31.251 14.765 31.0785 14.9398C30.906 15.1146 30.6717 15.2145 30.4261 15.2178C30.1805 15.2145 29.9461 15.1146 29.7736 14.9398C29.6012 14.7649 29.5045 14.5292 29.5045 14.2836C29.5045 14.038 29.6012 13.8023 29.7737 13.6275C29.9462 13.4527 30.1805 13.3528 30.4261 13.3495ZM30.4261 17.5469C30.6716 17.5503 30.9059 17.6502 31.0783 17.8251C31.2506 17.9999 31.3473 18.2355 31.3473 18.481C31.3473 18.7266 31.2506 18.9622 31.0782 19.137C30.9058 19.3118 30.6716 19.4117 30.4261 19.4152C30.1806 19.4117 29.9463 19.3118 29.7739 19.137C29.6016 18.9622 29.5049 18.7265 29.5049 18.481C29.5049 18.2355 29.6016 17.9999 29.774 17.825C29.9464 17.6502 30.1806 17.5503 30.4261 17.5469ZM30.4261 21.7442C30.6717 21.7475 30.9061 21.8474 31.0786 22.0223C31.251 22.1971 31.3477 22.4328 31.3477 22.6784C31.3477 22.924 31.251 23.1597 31.0785 23.3345C30.906 23.5094 30.6717 23.6092 30.4261 23.6126C30.1805 23.6092 29.9461 23.5093 29.7736 23.3345C29.6012 23.1597 29.5045 22.924 29.5045 22.6784C29.5045 22.4328 29.6012 22.1971 29.7737 22.0222C29.9462 21.8474 30.1805 21.7475 30.4261 21.7442ZM22.9655 13.3495C23.2111 13.3528 23.4455 13.4527 23.618 13.6275C23.7905 13.8023 23.8872 14.0381 23.8872 14.2837C23.8872 14.5292 23.7904 14.765 23.618 14.9398C23.4455 15.1146 23.2111 15.2145 22.9655 15.2178C22.7199 15.2145 22.4855 15.1146 22.3131 14.9398C22.1406 14.7649 22.0439 14.5292 22.0439 14.2836C22.0439 14.038 22.1406 13.8023 22.3131 13.6275C22.4856 13.4527 22.72 13.3528 22.9655 13.3495ZM22.9655 17.5469C23.211 17.5503 23.4453 17.6502 23.6177 17.8251C23.7901 17.9999 23.8867 18.2355 23.8867 18.481C23.8867 18.7266 23.79 18.9622 23.6177 19.137C23.4453 19.3118 23.211 19.4117 22.9655 19.4152C22.72 19.4117 22.4857 19.3118 22.3134 19.137C22.141 18.9622 22.0443 18.7265 22.0443 18.481C22.0443 18.2355 22.141 17.9999 22.3134 17.825C22.4858 17.6502 22.7201 17.5503 22.9655 17.5469ZM22.9655 21.7442C23.2111 21.7475 23.4455 21.8474 23.618 22.0223C23.7905 22.1971 23.8872 22.4328 23.8872 22.6784C23.8872 22.924 23.7904 23.1597 23.618 23.3345C23.4455 23.5094 23.2111 23.6092 22.9655 23.6126C22.7199 23.6092 22.4855 23.5094 22.3131 23.3345C22.1406 23.1597 22.0439 22.924 22.0439 22.6784C22.0439 22.4328 22.1406 22.1971 22.3131 22.0222C22.4856 21.8474 22.72 21.7475 22.9655 21.7442ZM15.505 13.3495C15.7493 13.3547 15.9818 13.4554 16.1527 13.63C16.3237 13.8047 16.4194 14.0393 16.4194 14.2837C16.4194 14.528 16.3236 14.7626 16.1527 14.9373C15.9818 15.1119 15.7492 15.2126 15.5049 15.2178C15.2606 15.2126 15.0281 15.1119 14.8572 14.9373C14.6862 14.7626 14.5905 14.528 14.5905 14.2836C14.5905 14.0393 14.6862 13.8046 14.8572 13.63C15.0281 13.4554 15.2607 13.3547 15.505 13.3495ZM15.505 17.5469C15.7493 17.552 15.9819 17.6527 16.1529 17.8273C16.3239 18.002 16.4196 18.2366 16.4196 18.481C16.4196 18.7254 16.3239 18.9601 16.1529 19.1347C15.9819 19.3094 15.7493 19.41 15.5049 19.4152C15.2606 19.41 15.028 19.3093 14.857 19.1347C14.686 18.9601 14.5902 18.7254 14.5902 18.481C14.5902 18.2366 14.686 18.002 14.857 17.8273C15.028 17.6527 15.2606 17.552 15.505 17.5469ZM15.505 21.7442C15.7493 21.7494 15.9819 21.8501 16.1529 22.0247C16.3239 22.1993 16.4197 22.434 16.4196 22.6784C16.4196 22.9228 16.3239 23.1575 16.1529 23.3321C15.9819 23.5067 15.7493 23.6074 15.5049 23.6126C15.2606 23.6074 15.028 23.5067 14.857 23.3321C14.686 23.1575 14.5902 22.9228 14.5902 22.6784C14.5902 22.434 14.686 22.1993 14.857 22.0247C15.028 21.85 15.2606 21.7494 15.505 21.7442Z",
                        fill: "#FEFEFE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M21.993 30.9786L19.7586 29.6342C19.5111 29.4866 19.2327 29.3987 18.9453 29.3775C18.6579 29.3563 18.3695 29.4024 18.1031 29.512C17.8366 29.6217 17.5993 29.7919 17.4101 30.0092C17.2209 30.2266 17.0849 30.485 17.013 30.7641C16.9356 30.9948 16.8076 31.2054 16.6383 31.3802C16.4689 31.5551 16.2626 31.6898 16.0344 31.7746C15.8062 31.8593 15.5619 31.8919 15.3195 31.8699C15.0771 31.848 14.8427 31.772 14.6334 31.6476C13.2117 30.7997 11.9014 29.7777 10.7327 28.6054C9.56324 27.4388 8.54149 26.133 7.69034 24.7173C7.56427 24.5008 7.48903 24.2585 7.47032 24.0087C7.4516 23.7589 7.4899 23.5081 7.58232 23.2753C7.67473 23.0424 7.81885 22.8336 8.00378 22.6646C8.18871 22.4957 8.40963 22.3709 8.64984 22.2998C8.89934 22.2223 9.12966 22.0929 9.32573 21.9202C9.52179 21.7475 9.67919 21.5353 9.78762 21.2976C9.89604 21.0599 9.95306 20.802 9.95494 20.5407C9.95681 20.2794 9.90351 20.0207 9.79851 19.7814C9.84927 19.8024 8.3863 17.4031 8.35944 17.345C8.10616 16.9272 7.69801 16.6264 7.22391 16.5081C6.74982 16.3899 6.24821 16.4639 5.8284 16.7139C4.45345 17.5364 3.44502 18.8536 3.00966 20.3955C2.57429 21.9374 2.74495 23.5875 3.48667 25.0076C5.89802 29.647 9.67986 33.431 14.3178 35.8451C15.738 36.5888 17.3888 36.7613 18.9321 36.3271C20.4753 35.8929 21.794 34.8849 22.6179 33.5097C22.8707 33.0912 22.9468 32.5894 22.8297 32.1147C22.7125 31.6401 22.4115 31.2314 21.993 30.9786Z",
                        fill: "#FEFEFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: {
                    marginLeft: '7px'
                },
                children: "Book a Call"
            })
        ]
    }),
    buttonIdentifier: 'book-call'
};
const $0e5eabdbd79984d1$export$565475a71a38b71e = {
    title: 'Portfolio Pro',
    price: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "c4",
        children: "FREE"
    }),
    subTitle: 'For advisors and Investors',
    points: [
        "Collaboration ecosystem",
        'FREE accounts for advisors and investors',
        'FREE Portfolio dashboard to monitor client/investee company progress',
        'FREE tools eg. bespoked anylist checklist builder, client benchmarking, activity updates',
        "Advisors - FREE revenue generating services - context sensitive service leads, Diligentsia Pro PLus\xa0",
        'Investors - FREE curated leads with diligence packs, matching your investment criteria',
        'Either you subscribe your companies and recharge, OR your companies subscribe via an invitation from you via your dashboard'
    ],
    buttonText: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "df jcc fdc aic w100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    lineHeight: '13px'
                },
                children: "Try for FREE"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fw400 c21",
                style: {
                    lineHeight: '13px',
                    fontStyle: 'italic',
                    fontSize: '10px'
                },
                children: "No credit card required"
            })
        ]
    }),
    hasHightlightSection: true,
    buttonIdentifier: 'register'
};





// Slider Section
const $cf9800d02c9ef389$var$SliderSection1 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "inner-container",
                style: {
                    padding: '15px 255px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "row df jcsa",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $121a871ca085f0a0$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "42",
                                height: "42",
                                viewBox: "0 0 42 42",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_394_13491)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M24.3436 25.7665C31.3912 25.7665 37.1248 19.9871 37.1248 12.8833C37.1248 5.77951 31.3912 0 24.3436 0C17.2961 0 11.5625 5.77943 11.5625 12.8832C11.5625 19.987 17.2961 25.7665 24.3436 25.7665ZM20.2366 16.9035C20.6084 16.3352 21.3706 16.1756 21.9389 16.5476C22.7671 17.0892 23.0795 17.1392 24.1722 17.1315C25.2388 17.1245 25.8577 16.3295 25.9813 15.5938C26.0415 15.2359 26.0645 14.3621 24.9815 13.9792C23.7112 13.5301 22.4112 13.0168 21.5067 12.3074C20.6023 11.5981 20.1881 10.3734 20.4259 9.11161C20.6838 7.74373 21.638 6.65484 22.9162 6.26985C22.9278 6.26641 22.9391 6.26362 22.9507 6.26018V5.79403C22.9507 5.11488 23.5013 4.56429 24.1804 4.56429C24.8596 4.56429 25.4101 5.11488 25.4101 5.79403V6.1827C26.2454 6.38209 26.8287 6.76421 27.0655 6.94121C27.6095 7.34792 27.7208 8.11847 27.3142 8.66251C26.9076 9.20654 26.137 9.31788 25.593 8.91108C25.341 8.72268 24.6445 8.31769 23.6256 8.62471C23.0303 8.80409 22.8759 9.39141 22.8428 9.5671C22.7778 9.91233 22.8507 10.2359 23.0245 10.3722C23.6515 10.8639 24.78 11.2993 25.8012 11.6603C27.6843 12.3259 28.7313 14.0705 28.4068 16.0015C28.2475 16.949 27.7708 17.828 27.0646 18.4769C26.5835 18.9189 26.0235 19.2341 25.4101 19.414V19.9724C25.4101 20.6515 24.8596 21.2021 24.1804 21.2021C23.5013 21.2021 22.9507 20.6515 22.9507 19.9724V19.5367C22.1555 19.4402 21.488 19.1916 20.5925 18.6057C20.0242 18.234 19.8649 17.4718 20.2366 16.9035Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M4.6587 29.8984H1.85474C1.17559 29.8984 0.625 30.449 0.625 31.1282V40.7685C0.625 41.4476 1.17559 41.9982 1.85474 41.9982H4.65878L4.6587 29.8984Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M41.0087 29.8122C38.7039 27.5072 34.9534 27.5072 32.6486 29.8122L28.9648 33.4959L27.455 35.0058C26.8448 35.616 26.0171 35.9588 25.1541 35.9588H17.8123C17.1492 35.9588 16.5786 35.4492 16.5474 34.7869C16.5141 34.0797 17.0776 33.4959 17.7774 33.4959H25.24C26.7404 33.4959 28.0418 32.4277 28.2997 30.9496C28.359 30.6102 28.3899 30.2612 28.3899 29.9051C28.39 29.2247 27.8387 28.6726 27.1584 28.6726H23.0694C21.7331 28.6726 20.4498 28.0664 19.0911 27.4245C17.666 26.7514 16.1925 26.0553 14.4695 25.9406C12.9625 25.8402 11.452 26.0052 9.97985 26.4303C8.40357 26.8855 7.27049 28.2859 7.13309 29.9028C7.12785 29.9024 7.12252 29.9023 7.11719 29.902V41.9936L28.3037 41.9994C29.7603 41.9994 31.1299 41.4321 32.1601 40.402L41.0085 31.5537C41.4896 31.0729 41.4896 30.2931 41.0087 29.8122Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_394_13491",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "42",
                                                height: "42",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            title: "Investment Stage",
                            description: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "pl1-5rem",
                                style: {
                                    listStyleType: "disc"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "\u201CFREE Investor Portfolio Pro Dashboard."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "With our bronze/silver/gold certification save wasted time looking at companies that are not \u201Cinvestment-ready\u201D\u201D."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Pre-diligence companies will improve the quality of companies offered to you by the angel networks, reducing\xa0 your risk."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Shorter transaction times, more certainty, lower professional fees."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Curated, diligenced leads with a bespoked and completed DD Pack meeting your investment criteria if you are registered on our investor database."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $121a871ca085f0a0$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "42",
                                height: "42",
                                viewBox: "0 0 42 42",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M39.375 38.0625H2.625C1.90312 38.0625 1.3125 38.6531 1.3125 39.375C1.3125 40.0969 1.90312 40.6875 2.625 40.6875H39.375C40.0969 40.6875 40.6875 40.0969 40.6875 39.375C40.6875 38.6531 40.0969 38.0625 39.375 38.0625Z",
                                        fill: "#4A67FF"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M19.6875 23.625C18.2437 23.625 17.0625 24.8062 17.0625 26.25V35.4375H24.9375V26.25C24.9375 24.8062 23.7562 23.625 22.3125 23.625H19.6875Z",
                                        fill: "#4A67FF"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M8.53125 28.875C7.0875 28.875 5.90625 30.0562 5.90625 31.5V35.4375H13.7812V31.5C13.7812 30.0562 12.6 28.875 11.1562 28.875H8.53125Z",
                                        fill: "#4A67FF"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M25.595 21H28.22V35.4375H36.095V21H38.72C39.1925 21 39.6256 20.7506 39.8488 20.3438C40.085 19.9369 40.085 19.4381 39.8488 19.0312L35.255 10.9856C34.625 9.87 33.4306 9.1875 32.1575 9.1875C30.8844 9.1875 29.69 9.88312 29.06 10.9856L24.4663 19.0312C24.23 19.4381 24.23 19.9369 24.4663 20.3438C24.7025 20.7506 25.1356 21 25.595 21Z",
                                        fill: "#4A67FF"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M11.8125 22.3125C17.6006 22.3125 22.3125 17.6006 22.3125 11.8125C22.3125 6.02437 17.6006 1.3125 11.8125 1.3125C6.02437 1.3125 1.3125 6.02437 1.3125 11.8125C1.3125 17.6006 6.02437 22.3125 11.8125 22.3125ZM12.6919 13.125H10.9462C9.25313 13.125 7.88813 11.7469 7.88813 10.0669C7.88813 8.53125 9.03 7.25812 10.5131 7.04812V6.5625C10.5131 5.84062 11.1038 5.25 11.8256 5.25C12.5475 5.25 13.1381 5.84062 13.1381 6.5625V6.99563H14.4506C15.1725 6.99563 15.7631 7.58625 15.7631 8.30813C15.7631 9.03 15.1725 9.62062 14.4506 9.62062H10.9462C10.71 9.62062 10.5131 9.8175 10.5131 10.0538C10.5131 10.29 10.71 10.4869 10.9462 10.4869H12.6919C14.385 10.4869 15.75 11.865 15.75 13.545C15.75 15.0806 14.6081 16.3538 13.125 16.5638V17.0494C13.125 17.7712 12.5344 18.3619 11.8125 18.3619C11.0906 18.3619 10.5 17.7712 10.5 17.0494V16.6163H9.1875C8.46562 16.6163 7.875 16.0256 7.875 15.3038C7.875 14.5819 8.46562 13.9913 9.1875 13.9913H12.6919C12.9281 13.9913 13.125 13.7944 13.125 13.5581C13.125 13.3219 12.9281 13.125 12.6919 13.125Z",
                                        fill: "#4A67FF"
                                    })
                                ]
                            }),
                            title: "Post Investment Stage",
                            description: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "pl1-5rem",
                                style: {
                                    listStyleType: "disc"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Easier portfolio monitoring."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Easier to attract following on funding from VCs etc with a pre-dilgenced pack."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Curated next-stage investor introductions from Diligentsia investor database."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Quicker transactions with lower costs and more certainty of completion."
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc mt2rem mb6rem bottom-button-slider",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg1 c0 br30px bsflp w40 fw600 py1rem px2rem mb1rem fs1rem df jcc c15",
                    children: "Improved angel portfolio returns, savings in time and cost"
                })
            })
        ]
    });
};



const $cf9800d02c9ef389$var$SliderSection2 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "inner-container",
                style: {
                    padding: '15px 255px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "row df jcsa",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $121a871ca085f0a0$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "42",
                                height: "42",
                                viewBox: "0 0 42 42",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_336_3310)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M24.3436 25.7665C31.3912 25.7665 37.1248 19.9871 37.1248 12.8833C37.1248 5.77951 31.3912 0 24.3436 0C17.2961 0 11.5625 5.77943 11.5625 12.8832C11.5625 19.987 17.2961 25.7665 24.3436 25.7665ZM20.2366 16.9035C20.6084 16.3352 21.3706 16.1756 21.9389 16.5476C22.7671 17.0892 23.0795 17.1392 24.1722 17.1315C25.2388 17.1245 25.8577 16.3295 25.9813 15.5938C26.0415 15.2359 26.0645 14.3621 24.9815 13.9792C23.7112 13.5301 22.4112 13.0168 21.5067 12.3074C20.6023 11.5981 20.1881 10.3734 20.4259 9.11161C20.6838 7.74373 21.638 6.65484 22.9162 6.26985C22.9278 6.26641 22.9391 6.26362 22.9507 6.26018V5.79403C22.9507 5.11488 23.5013 4.56429 24.1804 4.56429C24.8596 4.56429 25.4101 5.11488 25.4101 5.79403V6.1827C26.2454 6.38209 26.8287 6.76421 27.0655 6.94121C27.6095 7.34792 27.7208 8.11847 27.3142 8.66251C26.9076 9.20654 26.137 9.31788 25.593 8.91108C25.341 8.72268 24.6445 8.31769 23.6256 8.62471C23.0303 8.80409 22.8759 9.39141 22.8428 9.5671C22.7778 9.91233 22.8507 10.2359 23.0245 10.3722C23.6515 10.8639 24.78 11.2993 25.8012 11.6603C27.6843 12.3259 28.7313 14.0705 28.4068 16.0015C28.2475 16.949 27.7708 17.828 27.0646 18.4769C26.5835 18.9189 26.0235 19.2341 25.4101 19.414V19.9724C25.4101 20.6515 24.8596 21.2021 24.1804 21.2021C23.5013 21.2021 22.9507 20.6515 22.9507 19.9724V19.5367C22.1555 19.4402 21.488 19.1916 20.5925 18.6057C20.0242 18.234 19.8649 17.4718 20.2366 16.9035Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M4.6587 29.8984H1.85474C1.17559 29.8984 0.625 30.449 0.625 31.1282V40.7685C0.625 41.4476 1.17559 41.9982 1.85474 41.9982H4.65878L4.6587 29.8984Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M41.0087 29.8122C38.7039 27.5072 34.9534 27.5072 32.6486 29.8122L28.9648 33.4959L27.455 35.0058C26.8448 35.616 26.0171 35.9588 25.1541 35.9588H17.8123C17.1492 35.9588 16.5786 35.4492 16.5474 34.7869C16.5141 34.0797 17.0776 33.4959 17.7774 33.4959H25.24C26.7404 33.4959 28.0418 32.4277 28.2997 30.9496C28.359 30.6102 28.3899 30.2612 28.3899 29.9051C28.39 29.2247 27.8387 28.6726 27.1584 28.6726H23.0694C21.7331 28.6726 20.4498 28.0664 19.0911 27.4245C17.666 26.7514 16.1925 26.0553 14.4695 25.9406C12.9625 25.8402 11.452 26.0052 9.97985 26.4303C8.40357 26.8855 7.27049 28.2859 7.13309 29.9028C7.12785 29.9024 7.12252 29.9023 7.11719 29.902V41.9936L28.3037 41.9994C29.7603 41.9994 31.1299 41.4321 32.1601 40.402L41.0085 31.5537C41.4896 31.0729 41.4896 30.2931 41.0087 29.8122Z",
                                                fill: "#4A67FF"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_336_3310",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "42",
                                                height: "42",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            }),
                            title: "Pre-Investment",
                            description: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "pl1-5rem fs1-25rem",
                                style: {
                                    listStyleType: 'disc'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Simple and effective self-diligencing by your applicant company through quick and simple to use platform."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Quicker, more certain transactions. Lower costs."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Designed for their advisors to assist/audit if company wishes."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "You can monitor progress from your FREE portfolio dashboard."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: "Comprehensive DD pack at outset:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        className: "ml1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Comprehensive Data Repository."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "20-section business Audit Report."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Draft Warranty Disclosures."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: "Directors\u2019 Questionnaire."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc jcsb",
                            style: {
                                width: '47%',
                                gap: '25px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "col-sm bg1  br40px p2-5rem new-shadow cp oh shadowContainer",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "shadowPaperCrasouel",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df tas",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "br10px bg19 p0-5rem df jcc",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "42",
                                                            height: "42",
                                                            viewBox: "0 0 42 42",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M39.375 38.0625H2.625C1.90312 38.0625 1.3125 38.6531 1.3125 39.375C1.3125 40.0969 1.90312 40.6875 2.625 40.6875H39.375C40.0969 40.6875 40.6875 40.0969 40.6875 39.375C40.6875 38.6531 40.0969 38.0625 39.375 38.0625Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M19.6875 23.625C18.2437 23.625 17.0625 24.8062 17.0625 26.25V35.4375H24.9375V26.25C24.9375 24.8062 23.7562 23.625 22.3125 23.625H19.6875Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M8.53125 28.875C7.0875 28.875 5.90625 30.0562 5.90625 31.5V35.4375H13.7812V31.5C13.7812 30.0562 12.6 28.875 11.1562 28.875H8.53125Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M25.595 21H28.22V35.4375H36.095V21H38.72C39.1925 21 39.6256 20.7506 39.8488 20.3438C40.085 19.9369 40.085 19.4381 39.8488 19.0312L35.255 10.9856C34.625 9.87 33.4306 9.1875 32.1575 9.1875C30.8844 9.1875 29.69 9.88312 29.06 10.9856L24.4663 19.0312C24.23 19.4381 24.23 19.9369 24.4663 20.3438C24.7025 20.7506 25.1356 21 25.595 21Z",
                                                                    fill: "#4A67FF"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M11.8125 22.3125C17.6006 22.3125 22.3125 17.6006 22.3125 11.8125C22.3125 6.02437 17.6006 1.3125 11.8125 1.3125C6.02437 1.3125 1.3125 6.02437 1.3125 11.8125C1.3125 17.6006 6.02437 22.3125 11.8125 22.3125ZM12.6919 13.125H10.9462C9.25313 13.125 7.88813 11.7469 7.88813 10.0669C7.88813 8.53125 9.03 7.25812 10.5131 7.04812V6.5625C10.5131 5.84062 11.1038 5.25 11.8256 5.25C12.5475 5.25 13.1381 5.84062 13.1381 6.5625V6.99563H14.4506C15.1725 6.99563 15.7631 7.58625 15.7631 8.30813C15.7631 9.03 15.1725 9.62062 14.4506 9.62062H10.9462C10.71 9.62062 10.5131 9.8175 10.5131 10.0538C10.5131 10.29 10.71 10.4869 10.9462 10.4869H12.6919C14.385 10.4869 15.75 11.865 15.75 13.545C15.75 15.0806 14.6081 16.3538 13.125 16.5638V17.0494C13.125 17.7712 12.5344 18.3619 11.8125 18.3619C11.0906 18.3619 10.5 17.7712 10.5 17.0494V16.6163H9.1875C8.46562 16.6163 7.875 16.0256 7.875 15.3038C7.875 14.5819 8.46562 13.9913 9.1875 13.9913H12.6919C12.9281 13.9913 13.125 13.7944 13.125 13.5581C13.125 13.3219 12.9281 13.125 12.6919 13.125Z",
                                                                    fill: "#4A67FF"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fw500 fs1-5rem ml1rem c15",
                                                        style: {
                                                            lineHeight: '39.81px'
                                                        },
                                                        children: "Post-Investment Growth Acceleration"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fw400 fs1rem mt1rem c14 tas",
                                                style: {
                                                    lineHeight: '1.9rem'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                    className: "pl1-5rem fs1-25rem",
                                                    style: {
                                                        listStyleType: 'disc'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            children: "Increased operational efficiency."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            children: "Identify areas to strengthen."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            children: "Bespoked to the company and industry"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            children: "Real-time reporting with completeness and risk-scoring. In depth risk area analysis."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            children: "KPI reporting."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            children: "Benchmarking."
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                            children: "Extensive application of AI."
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "col-sm",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcc aic",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("iQeGV")),
                                                className: "h60"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("l61of")),
                                                className: "h60"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("gI7Us")),
                                                className: "h60"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "df jcc mt2rem mb2rem bottom-button-slider",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "bg1 c0 br30px bsflp w40 fw600 py1rem px2rem mb1rem fs1rem df jcc c15",
                    children: "Increased efficiency for everyone, stronger companies"
                })
            })
        ]
    });
};

const $cf9800d02c9ef389$var$SliderSection3 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "inner-container",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "row df jcc",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "mb6rem",
                    src: (parcelRequire("cV878")),
                    style: {
                        width: '140vh'
                    }
                })
            })
        })
    });
};

// Main Banner Section data 
const $cf9800d02c9ef389$var$MAIN_BANNER_DATA = {
    //Verticle text slider content
    SLIDER_TEXT_CONTANT: [
        {
            str: "More investible companies?",
            className: 'item-a'
        },
        {
            str: "Easier due diligence?",
            className: 'item-b'
        },
        {
            str: "Higher exit valuations?",
            className: 'item-c'
        }
    ],
    bannerTitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `fw500 fs3rem c15 tslp mt2rem`,
            style: {
                fontSize: '70px',
                lineHeight: '90px'
            },
            children: [
                "Increase your portfolio ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: "value."
                }),
                " Simply."
            ]
        })
    }),
    bannersubTitle: 'Angel Investors',
    bannerDescription: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "Our easy-to-use AI platform - FREE to investors\xa0- delivers cost-effective diligence in advance of you making your investment \u2013 saving your time and helping you avoid the duds. Post investment, our Healthboost modules strengthen your companies; we then help them prepare for value-maximisation at exit. We also supply you pre-diligenced investment leads meeting your criteria."
    }),
    //Banner Image
    bannerImage: (parcelRequire("9RTcM")),
    // videoButton: require('../../../../images/videoButton.png'),
    videoLink: "https://www.loom.com/embed/6b034457010b4e23bdebf23f31cb812c?sid=4bfb2e43-d8fc-45c3-a99f-60f3873b38ed",
    posterImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Warren, hear my story, Video-1731331671555.webp",
    //Contact right information
    contactInfo: {
        user: 'Meet Warren,',
        designation: 'the Angel Investor'
    },
    //Active menu
    activeMenu: "menu-bar-6",
    //descriptions info
    description: {
        headingOne: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Automated low-cost diligence platform assisted ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: "by AI"
                }),
                " that allows companies, their advisors and investors to more easily pick their winners through their investment, growth and exit lifecycle."
            ]
        }),
        headingTwo: `Due diligence should be a reusable asset not an overhead.
            Diligentsia delivers a standardised methodology for fast
            qualification, reduced transaction times, less cost and less
            risk for everyone.`,
        isInvestorBtn: true
    },
    // gurantee: {
    //     title: 'Could Diligentsia’s platform deliver to your portfolio:',
    //     point1: 'Up to 10%+ increase in your overall portfolio investment gains?'
    // },
    gurantee: {
        point1: 'Save time',
        point2: 'Focus on value',
        point3: 'Improve portfolio returns',
        quickDemoBtn: true
    },
    cubeStyle: {
        top: '47px',
        left: "-72px",
        width: '50%'
    }
};
// About us Content
const $cf9800d02c9ef389$var$ABOUT_US_CONTENT = {
    title: [
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "c15",
            children: [
                "We help you invest with your eyes",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: ` Wide Open`
                })
            ]
        }),
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "c15",
            children: [
                "Improve your",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: ` Angel Investment `
                }),
                "Profitability"
            ]
        }),
        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "c15",
            children: [
                "Adding value to your",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "c4",
                    children: ` Company`
                })
            ]
        })
    ],
    subTitle: [
        'Standardising transparency across your portfolio',
        'Weed out out the duds, improve your overall portfolio returns',
        'Standardising transparency across your portfolio'
    ],
    slider: [
        /*#__PURE__*/ (0, $ayMG0.jsx)($cf9800d02c9ef389$var$SliderSection3, {}),
        /*#__PURE__*/ (0, $ayMG0.jsx)($cf9800d02c9ef389$var$SliderSection1, {}),
        /*#__PURE__*/ (0, $ayMG0.jsx)($cf9800d02c9ef389$var$SliderSection2, {})
    ]
};

// Review Section data
const $cf9800d02c9ef389$var$REVIEW_CONTENT_DATA = {
    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            "Hear from our",
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "c4",
                children: ` Co-founder`
            })
        ]
    }),
    description: {
        desc1: `Three of us, having experienced on multiple occasions as angel investors being asked to invested
    in companies that upon investigation were not \u{201C}investment ready\u{201D}, conceived the idea of a diligencing 
        platform with self - certification to save us time when assessing investments.`,
        desc2: `Effective diligence at the seed stage is not cost - effective \u{2013} until now.`,
        desc3: `Our thesis is that if we could avoid the bottom two performing investments out of every ten,
    or reprice the deal, then portfolio returns would be transformed.`,
        desc4: `If you sign up \u{2013} FREE \u{2013} you can also join our investor database and be passed
         Diligentsia Gold - certified investment opportunities meeting your investment criteria,
    and received curated leads, a \u{201C}Fit\u{201D} Report, and DD Pack.`,
        desc5: `We would love to work with you.`,
        desc6: `NB.Diligentsia does not provide investment advice \u{2013} we merely provide you the tools to make your own investment decisions.`,
        clientName: 'Conor Davey',
        designation: 'Co-founder and Advisor, Diligentsia'
    },
    clientImage: (parcelRequire("elPjF")),
    isExtandable: true
};
// How its work data
const $cf9800d02c9ef389$var$HOW_ITS_WORK_DATA = {
    IMAGES_ARRAY: [
        {
            title1: 'FREE',
            title2: 'Registration',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "74",
                height: "74",
                viewBox: "0 0 74 74",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8.96204 74.0005H47.1957C40.4123 70.3005 35.7872 63.2088 35.7872 54.8837C35.7872 42.8586 45.654 32.9919 57.6791 32.9919H57.9874V8.01673C57.9874 3.70003 54.2874 0 49.9707 0H8.96204C4.64534 0 0.945312 3.70003 0.945312 8.01673V65.9838C0.945312 70.3005 4.337 74.0005 8.96204 74.0005ZM16.0538 12.3334H42.5706C44.4206 12.3334 45.654 13.8751 45.654 15.4168C45.654 17.2668 44.4206 18.5001 42.5706 18.5001H16.0538C14.2037 18.5001 12.9704 17.2668 12.9704 15.4168C12.9704 13.8751 14.5121 12.3334 16.0538 12.3334ZM16.0538 26.8252H33.3206C35.1706 26.8252 36.4039 28.3669 36.4039 29.9086C36.4039 31.7586 35.1706 32.9919 33.3206 32.9919H16.0538C14.2037 32.9919 12.9704 31.7586 12.9704 29.9086C12.9704 28.0585 14.5121 26.8252 16.0538 26.8252Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M57.6821 39.4668C49.0488 39.4668 41.957 46.5585 41.957 55.1919C41.957 63.8253 49.0488 70.917 57.6821 70.917C66.3155 70.917 73.4073 63.8253 73.4073 55.1919C73.4073 46.5585 66.3155 39.4668 57.6821 39.4668ZM65.3905 53.6502L57.6821 61.0503C57.0655 61.667 56.4488 61.9753 55.5238 61.9753C54.5988 61.9753 53.9821 61.667 53.3654 61.0503L49.6654 57.0419C48.4321 55.8086 48.4321 53.9586 49.9738 52.7252C51.2071 51.4919 53.0571 51.4919 54.2905 52.7252L55.8321 54.5752L61.3822 49.3335C62.6155 48.1002 64.4655 48.1002 65.6989 49.3335C66.6239 50.2585 66.6239 52.4169 65.3905 53.6502Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            desc: 'No credit card required. Get going with FREE modules such as KPI Report and 2-Minute Test.'
        },
        {
            title1: 'Add Company ',
            title2: 'Portfolio',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "71",
                height: "71",
                viewBox: "0 0 71 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M13.5309 15.2913C13.5309 12.4565 14.3716 9.68528 15.9466 7.32817C17.5215 4.97107 19.7601 3.13393 22.3792 2.04907C24.9982 0.964218 27.8802 0.68037 30.6606 1.23343C33.441 1.78648 35.9949 3.1516 37.9995 5.15615C40.004 7.1607 41.3692 9.71466 41.9222 12.4951C42.4753 15.2754 42.1914 18.1574 41.1066 20.7765C40.0217 23.3956 38.1846 25.6341 35.8275 27.2091C33.4704 28.784 30.6991 29.6247 27.8643 29.6247C24.0628 29.6247 20.4171 28.1146 17.7291 25.4265C15.0411 22.7385 13.5309 19.0928 13.5309 15.2913ZM38.9404 59.438C37.9911 58.5526 37.3147 57.4144 36.9909 56.1573C36.6671 54.9002 36.7094 53.5768 37.1129 52.343C37.5052 51.0922 38.2463 49.9793 39.2492 49.135C40.2521 48.2908 41.4751 47.7504 42.7745 47.5772L47.2537 46.9322C47.2537 46.9322 47.9704 46.8641 48.1854 46.4305L49.6187 43.5638C49.7335 43.3563 49.7834 43.1192 49.762 42.883C49.7174 42.681 49.6182 42.4951 49.4754 42.3455C47.591 40.4505 45.3268 38.9759 42.8316 38.0186C40.3365 37.0613 37.667 36.6431 34.9987 36.7913H20.6654C6.11703 36.7913 0.957031 47.4338 0.957031 56.5714C0.957031 64.7413 5.29286 69.0413 13.4987 69.0413H40.6962C41.2695 69.0413 41.635 68.6114 41.807 67.6797L42.5237 63.5588C42.5621 63.3835 42.5524 63.201 42.4956 63.0307C42.4389 62.8604 42.3371 62.7086 42.2012 62.5914L38.9404 59.438ZM70.3555 55.5644C70.5674 55.3605 70.7173 55.1007 70.7879 54.8152C70.8584 54.5296 70.8467 54.2299 70.7542 53.9507C70.6616 53.6715 70.4919 53.4242 70.2648 53.2374C70.0376 53.0505 69.7622 52.9318 69.4704 52.8948L62.3324 51.8808C62.078 51.8455 61.836 51.7492 61.6269 51.6C61.4179 51.4509 61.2481 51.2534 61.1319 51.0243L58.036 44.8897C57.8909 44.6084 57.6713 44.3726 57.401 44.2079C57.1308 44.0432 56.8205 43.9561 56.5041 43.9561C56.1876 43.9561 55.8773 44.0432 55.6071 44.2079C55.3369 44.3726 55.1172 44.6084 54.9722 44.8897L51.8798 51.0243C51.7634 51.2532 51.5935 51.4505 51.3845 51.5996C51.1755 51.7488 50.9336 51.8452 50.6794 51.8808L43.5414 52.8948C43.2488 52.9304 42.9723 53.0485 42.7442 53.2351C42.5161 53.4218 42.3458 53.6695 42.253 53.9492C42.1603 54.229 42.1489 54.5294 42.2203 54.8153C42.2917 55.1013 42.4429 55.3611 42.6563 55.5644L47.8163 60.4879C48.0022 60.6635 48.1417 60.8823 48.2223 61.1249C48.303 61.3676 48.3223 61.6264 48.2785 61.8783L47.0996 68.6113C47.0498 68.9235 47.0881 69.2433 47.2101 69.5348C47.3322 69.8264 47.5331 70.0781 47.7904 70.2617C48.0477 70.4452 48.3511 70.5534 48.6665 70.5739C48.9819 70.5944 49.2968 70.5266 49.5757 70.3779L55.7641 67.1959C55.9934 67.0775 56.2478 67.0156 56.5059 67.0156C56.764 67.0156 57.0183 67.0775 57.2476 67.1959L63.4396 70.3815C63.7184 70.5292 64.0329 70.5962 64.3477 70.5752C64.6625 70.5542 64.9652 70.4459 65.2219 70.2625C65.4786 70.0791 65.6792 69.8278 65.8011 69.5368C65.923 69.2458 65.9614 68.9266 65.9121 68.6149L64.7404 61.8747C64.6968 61.6231 64.7159 61.3646 64.7959 61.1222C64.8759 60.8797 65.0143 60.6606 65.199 60.4843L70.3555 55.5644Z",
                    fill: "#4A67FF"
                })
            }),
            desc: 'Add a company you are considering investing in.'
        },
        {
            title1: 'Access',
            title2: 'Permission',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "86",
                height: "86",
                viewBox: "0 0 86 86",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M55.8774 22.0582C53.0547 21.6951 49.9472 20.9691 46.394 19.8301C42.6798 18.5784 39.1761 16.901 35.9819 14.8232H35.9324C29.0737 19.1917 21.4473 21.8578 13.8828 22.5588C14.898 47.6305 22.2644 63.7149 35.6972 70.4116C43.9674 65.5925 49.7243 58.583 53.4137 48.7445C52.4975 48.4692 51.7299 47.8057 51.3338 46.892L50.3557 47.5554C49.7986 47.9309 49.1548 48.1312 48.4863 48.1312C47.7187 48.1312 46.9758 47.8684 46.3816 47.3676L45.0816 46.3037L43.4474 47.4553C42.8779 47.8558 42.2218 48.056 41.5408 48.056C41.2932 48.056 41.0456 48.0311 40.8104 47.9809L40.8227 49.1701C40.8351 51.7611 38.7675 53.8765 36.2049 53.9015C36.1925 53.9015 36.1925 53.9015 36.1801 53.9015C33.6297 53.9015 31.5498 51.8237 31.5374 49.2327L31.4383 33.1733C31.4259 30.5823 33.4811 28.4669 36.0439 28.4544H36.0934C38.6314 28.4544 40.6989 30.5322 40.7237 33.1107V33.1232H57.2764C57.5612 31.2457 57.7592 29.7061 57.883 28.3793C58.0811 26.4641 58.2421 24.4614 58.3535 22.4211C57.4621 22.2709 56.6574 22.1708 55.8774 22.0582Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M69.1828 10.7173C66.2499 10.6603 63.431 10.4325 60.7401 10.0481C57.6221 9.6495 54.2621 8.8237 50.717 7.699C45.4777 5.962 40.8221 3.47046 36.679 0.323974C36.138 -0.103132 35.3834 -0.103133 34.8281 0.295556C24.8619 7.47116 14.1413 11.0447 2.62319 10.8027C1.74047 10.7885 0.985947 11.5003 1.0002 12.3831C1.3703 50.8666 12.6178 74.8566 35.0843 83.883C35.5115 84.054 36.0098 84.0397 36.4227 83.8261C48.8377 77.4905 59.0601 67.2396 65.0256 49.5284C65.0113 49.4998 64.9828 49.4571 64.9686 49.4287H58.7469C54.2906 61.7013 47.1861 70.4003 36.9068 76.38C36.4654 76.6362 35.9386 76.7643 35.4261 76.7643C34.9847 76.7643 34.5291 76.6647 34.1305 76.4654C17.6721 68.3501 8.67406 49.2436 7.37849 19.6868C7.30732 18.1207 8.4748 16.7966 10.0409 16.6543C18.2985 15.8996 26.6274 13.0095 34.1447 8.2827C35.0843 7.68476 36.2946 7.68476 37.2342 8.29695C40.7224 10.518 44.538 12.3262 48.5672 13.6786C52.4682 14.9173 55.8709 15.7004 58.9747 16.099C59.8574 16.2272 60.7401 16.341 61.6513 16.4265C63.2174 16.5831 64.3706 17.9357 64.2852 19.5017C64.1428 21.8651 63.9577 24.1858 63.73 26.3927C63.5876 27.8448 63.3882 29.5106 63.075 31.5038H65.2391C66.435 29.4536 68.0154 27.7025 69.852 26.3072C69.8663 26.2217 69.8804 26.1506 69.8804 26.0794C70.2934 22.1641 70.6493 16.1702 70.7347 12.3262C70.749 11.4576 70.0514 10.7457 69.1828 10.7173Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M85.5527 40.2396C85.0175 35.636 81.0891 31.8459 76.2416 31.2812C71.616 30.7405 67.4939 32.9567 65.4624 36.4359C65.195 36.8939 64.6651 37.1577 64.1129 37.1577L41.2188 37.1577V44.9676H42.1322C42.2927 44.9676 42.4484 44.9159 42.5737 44.8209L44.7293 43.188C45.021 42.9671 45.4437 42.9991 45.6946 43.2611L46.9109 44.5314C47.1498 44.7809 47.5469 44.8235 47.8386 44.6311L49.9818 43.2172C50.2406 43.0466 50.5873 43.0588 50.8319 43.2473L52.6578 44.654C52.8995 44.8402 53.2412 44.8547 53.4994 44.6895L55.6347 43.3239C56.007 43.0858 56.5161 43.2326 56.6853 43.6269L57.2582 44.9615C57.3666 45.214 57.6256 45.3791 57.9133 45.3791H63.8705C64.5168 45.3791 65.0723 45.7428 65.3752 46.2788C67.193 49.4563 70.7478 51.6002 74.848 51.6002C81.1901 51.6002 86.2597 46.4223 85.5527 40.2396ZM77.0293 44.3933C75.2923 44.3933 73.8987 43.0438 73.8987 41.3976C73.8987 39.7515 75.2923 38.4115 77.0293 38.4115C78.7663 38.4115 80.1802 39.7515 80.1802 41.3976C80.1802 43.0438 78.7663 44.3933 77.0293 44.3933Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            desc: "Platform manages your access to your investee company\u2019s module and data."
        },
        {
            title1: 'Start',
            title2: 'Creating Value',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                style: {
                    width: '70px',
                    height: '70px'
                },
                width: "86",
                height: "86",
                viewBox: "0 0 86 86",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        "clip-path": "url(#clip0_394_12209)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M39.3102 79.7844C38.4756 81.261 38.9063 83.0785 40.3683 83.9768C41.8037 84.8591 43.686 84.3979 44.5509 82.952L45.8073 80.8515C46.6721 79.4057 46.2053 77.5009 44.7699 76.6185C43.3188 75.7268 41.4705 76.2169 40.5876 77.6437C41.5402 76.0506 41.0259 73.9522 39.4444 72.9803C37.863 72.0085 35.7896 72.5166 34.8369 74.1094C35.9047 72.3244 35.3282 69.973 33.556 68.8838C31.7837 67.7946 29.4602 68.3641 28.3926 70.1489C29.3453 68.556 28.831 66.4576 27.2496 65.4858C25.6681 64.5139 23.5946 65.022 22.6419 66.6147L20.554 70.1052C19.6013 71.6981 20.0367 73.9381 21.697 74.7684C23.3572 75.5985 25.3519 75.2323 26.3046 73.6395L25.867 74.371C24.7994 76.1558 25.3757 78.5075 27.1479 79.5965C28.92 80.6857 31.2435 80.1163 32.3113 78.3313L33.1458 76.9365C32.1941 78.529 32.7086 80.6266 34.2896 81.5983C35.8711 82.5702 37.9445 82.0622 38.8972 80.4694L39.3102 79.7844ZM20.487 33.4462L9.3347 30L4.36719 56.666L12.5318 59.1891C15.1835 50.6081 17.8354 42.0272 20.487 33.4462ZM13.5193 39.3688C12.3215 39.3688 11.3505 38.3978 11.3505 37.2001C11.3505 36.0025 12.3215 35.0313 13.5193 35.0313C14.7171 35.0313 15.6879 36.0024 15.6879 37.2001C15.6879 38.3979 14.7171 39.3688 13.5193 39.3688ZM38.852 37.074C38.6185 37.2898 38.3854 37.5141 38.1521 37.7476C35.6744 40.2264 32.9298 42.5439 30.0909 44.5953C26.343 47.3038 24.1967 48.2068 20.0318 49.7706C24.1075 54.2213 27.2758 58.275 34.1721 56.4164C36.1694 55.8783 38.1069 54.9259 39.9228 53.9485C41.6411 53.0236 43.3291 52.0343 45.0235 51.0618L64.3765 62.0219L66.3544 61.4285C66.4906 62.1559 66.39 62.9313 66.0146 63.6248C65.1564 65.2103 63.1643 65.8119 61.5926 64.9385C63.4205 65.9784 64.0965 68.3305 63.0934 70.1837C62.0935 72.0312 59.8604 72.9652 56.4212 71.0032C58.0623 71.9804 58.6601 74.1197 57.7453 75.8096C56.8235 77.5125 54.285 77.9485 52.5945 77.0022C54.8769 79.0558 52.6983 83.5966 48.2447 81.9998C49.6759 79.3336 48.779 75.9282 46.177 74.3291C45.2615 73.7666 44.2519 73.4958 43.2525 73.4885C42.7741 72.3631 41.9593 71.3715 40.8517 70.6908C39.8449 70.072 38.7227 69.7879 37.6168 69.8064C37.1219 68.5122 36.2189 67.366 34.9632 66.5942C33.7081 65.8229 32.2848 65.5392 30.9177 65.688C30.4274 64.6894 29.6629 63.8145 28.6566 63.196C26.1455 61.6529 22.9161 62.1922 21.0157 64.3122C19.313 61.6517 18.4991 59.6068 15.873 57.479L21.9512 37.8112L22.1663 37.1148C28.5925 38.6707 32.5492 35.2616 38.852 37.074ZM64.0468 37.804C54.8544 39.6718 48.8866 30.8089 40.0528 39.6473C34.769 44.9339 28.0866 49.6167 24.6996 50.8884C30.514 57.2375 35.5062 53.3332 45.0198 47.971L64.7029 59.1179L70.1303 57.4896L64.0468 37.804ZM73.4682 59.1889L81.6328 56.666L76.6653 30L65.513 33.4462L73.4682 59.1889ZM74.6495 37.2C74.6495 38.3978 73.6785 39.3686 72.4807 39.3686C71.2829 39.3686 70.3119 38.3976 70.3119 37.2C70.3119 36.0024 71.2829 35.0312 72.4807 35.0312C73.6785 35.0313 74.6495 36.0022 74.6495 37.2Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M40 5.92969L42.3175 10.6256L47.5 11.3784L43.75 15.0338L44.635 20.1947L40 17.7581L35.365 20.1947L36.25 15.0338L32.5 11.3784L37.6825 10.6256L40 5.92969Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M56.875 21.6836L58.6131 25.2058L62.5 25.7702L59.6875 28.5114L60.3512 32.3833L56.875 30.5552L53.3987 32.3833L54.0625 28.5114L51.25 25.7702L55.1369 25.2058L56.875 21.6836Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M58.75 1.8125L59.9088 4.16094L62.5 4.53688L60.625 6.365L61.0675 8.945L58.75 7.72719L56.4325 8.945L56.875 6.365L55 4.53688L57.5912 4.16094L58.75 1.8125Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M22.6289 1.8125L23.7877 4.16094L26.3789 4.53688L24.5039 6.365L24.9464 8.945L22.6289 7.72719L20.3114 8.945L20.7539 6.365L18.8789 4.53688L21.4702 4.16094L22.6289 1.8125Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M23.125 21.6836L24.8631 25.2058L28.75 25.7702L25.9375 28.5114L26.6012 32.3833L23.125 30.5552L19.6487 32.3833L20.3125 28.5114L17.5 25.7702L21.3869 25.2058L23.125 21.6836Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.375 18.6875C65.4105 18.6875 66.25 17.848 66.25 16.8125C66.25 15.777 65.4105 14.9375 64.375 14.9375C63.3395 14.9375 62.5 15.777 62.5 16.8125C62.5 17.848 63.3395 18.6875 64.375 18.6875Z",
                                fill: "#F8664F"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M15.625 18.3311C16.6605 18.3311 17.5 17.4916 17.5 16.4561C17.5 15.4205 16.6605 14.5811 15.625 14.5811C14.5895 14.5811 13.75 15.4205 13.75 16.4561C13.75 17.4916 14.5895 18.3311 15.625 18.3311Z",
                                fill: "#F8664F"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M66.0805 17.5814C65.9569 17.8595 65.7675 18.1033 65.5286 18.2918C65.2897 18.4802 65.0086 18.6077 64.7094 18.6633C64.4102 18.7188 64.102 18.7007 63.8114 18.6105C63.5208 18.5203 63.2565 18.3608 63.0414 18.1456C62.8262 17.9304 62.6666 17.6661 62.5765 17.3755C62.4863 17.0849 62.4681 16.7767 62.5237 16.4776C62.5792 16.1784 62.7067 15.8972 62.8952 15.6584C63.0837 15.4195 63.3275 15.2301 63.6055 15.1064C63.4924 15.3468 63.4347 15.6095 63.4368 15.8752C63.4382 16.372 63.6363 16.8481 63.9876 17.1994C64.3389 17.5507 64.8149 17.7487 65.3118 17.7502C65.5774 17.7523 65.8401 17.6946 66.0805 17.5814Z",
                                fill: "#CC5144"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M17.3305 17.225C17.2069 17.503 17.0175 17.7468 16.7786 17.9353C16.5397 18.1238 16.2586 18.2513 15.9594 18.3068C15.6602 18.3624 15.352 18.3443 15.0614 18.2541C14.7708 18.1639 14.5065 18.0043 14.2914 17.7891C14.0762 17.574 13.9166 17.3097 13.8264 17.0191C13.7363 16.7285 13.7181 16.4203 13.7737 16.1211C13.8292 15.8219 13.9567 15.5408 14.1452 15.3019C14.3337 15.063 14.5775 14.8736 14.8555 14.75C14.7424 14.9904 14.6847 15.2531 14.6868 15.5188C14.6882 16.0156 14.8863 16.4916 15.2376 16.8429C15.5889 17.1942 16.0649 17.3923 16.5618 17.3938C16.8274 17.3958 17.0901 17.3381 17.3305 17.225Z",
                                fill: "#CC5144"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M40 5.92969L39.3437 10.2497C39.2673 10.748 39.3263 11.2576 39.5143 11.7253C39.7024 12.193 40.0127 12.6015 40.4128 12.9082C40.8129 13.2148 41.2881 13.4083 41.7886 13.4684C42.2891 13.5285 42.7965 13.4529 43.2578 13.2497L47.5 11.3747L43.75 15.0309L44.635 20.1872L40 17.7581L35.365 20.1956L36.25 15.0309L32.5 11.3747L37.6825 10.6247L40 5.92969Z",
                                fill: "#FCBC04"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M56.875 21.6875L56.5712 23.7453C56.4969 24.2494 56.5609 24.7643 56.7565 25.2349C56.9521 25.7054 57.2718 26.114 57.6815 26.417C58.0912 26.72 58.5756 26.9059 59.0828 26.955C59.59 27.0041 60.101 26.9144 60.5612 26.6956L62.5 25.7703L59.6875 28.5116L60.3512 32.3834L56.875 30.5553L53.3987 32.3834L54.0625 28.5116L51.25 25.7703L55.1369 25.2078L56.875 21.6875Z",
                                fill: "#FCBC04"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M58.75 1.8125L58.5456 3.28719C58.4987 3.63074 58.548 3.98056 58.688 4.29778C58.828 4.615 59.0532 4.88719 59.3386 5.0841C59.624 5.281 59.9584 5.39491 60.3047 5.41317C60.6509 5.43142 60.9955 5.3533 61.3 5.1875L62.5 4.53125L60.625 6.35938L61.0675 8.93938L58.75 7.72719L56.4325 8.94594L56.875 6.365L55 4.53688L57.5912 4.16188L58.75 1.8125Z",
                                fill: "#FCBC04"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M22.6261 1.8125L22.4217 3.28719C22.3747 3.63087 22.4239 3.98085 22.564 4.29822C22.704 4.61558 22.9293 4.88787 23.2149 5.08482C23.5004 5.28176 23.835 5.39563 24.1814 5.41376C24.5278 5.43188 24.8725 5.35356 25.177 5.1875L26.3761 4.53125L24.5011 6.35938L24.9436 8.93938L22.6261 7.72062L20.3114 8.945L20.7539 6.365L18.8789 4.53688L21.4702 4.16188L22.6261 1.8125Z",
                                fill: "#FCBC04"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M23.125 21.6875L22.8212 23.7453C22.7469 24.2494 22.8109 24.7643 23.0065 25.2349C23.2021 25.7054 23.5218 26.114 23.9315 26.417C24.3412 26.72 24.8256 26.9059 25.3328 26.955C25.84 27.0041 26.351 26.9144 26.8112 26.6956L28.75 25.7703L25.9375 28.5116L26.6012 32.3834L23.125 30.5553L19.6487 32.3834L20.3125 28.5116L17.5 25.7703L21.3869 25.2078L23.125 21.6875Z",
                                fill: "#FCBC04"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M46.0824 30.2465C46.0075 30.2466 45.9329 30.2377 45.8602 30.2203C45.6186 30.1615 45.4104 30.0091 45.2811 29.7967C45.1519 29.5844 45.1123 29.3293 45.1711 29.0878C46.7602 22.5817 49.8889 16.5526 54.2939 11.5078C54.4578 11.3206 54.6893 11.2061 54.9375 11.1896C55.1858 11.173 55.4304 11.2558 55.6177 11.4197C55.8049 11.5835 55.9194 11.815 55.9359 12.0633C55.9524 12.3115 55.8696 12.5562 55.7058 12.7434C51.4986 17.5602 48.5103 23.3175 46.9927 29.5303C46.9431 29.7344 46.8264 29.9159 46.6614 30.0458C46.4963 30.1757 46.2924 30.2464 46.0824 30.2465Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M34.8521 30.246C34.6422 30.2457 34.4385 30.1749 34.2736 30.045C34.1088 29.9151 33.9922 29.7337 33.9427 29.5298C32.4248 23.3172 29.437 17.5601 25.2305 12.7429C25.0829 12.5544 25.0131 12.3165 25.0353 12.0781C25.0575 11.8397 25.1701 11.6188 25.3499 11.4608C25.5298 11.3027 25.7633 11.2195 26.0026 11.2282C26.2419 11.2368 26.4688 11.3367 26.6368 11.5073C31.0421 16.552 34.1711 22.5811 35.7605 29.0873C35.8193 29.3288 35.7797 29.5838 35.6505 29.7962C35.5213 30.0086 35.313 30.1609 35.0715 30.2198C34.9996 30.2369 34.926 30.2457 34.8521 30.246Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M32.5 6.5C33.0178 6.5 33.4375 6.08027 33.4375 5.5625C33.4375 5.04473 33.0178 4.625 32.5 4.625C31.9822 4.625 31.5625 5.04473 31.5625 5.5625C31.5625 6.08027 31.9822 6.5 32.5 6.5Z",
                                fill: "#F9E109"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M47.5 6.5C48.0178 6.5 48.4375 6.08027 48.4375 5.5625C48.4375 5.04473 48.0178 4.625 47.5 4.625C46.9822 4.625 46.5625 5.04473 46.5625 5.5625C46.5625 6.08027 46.9822 6.5 47.5 6.5Z",
                                fill: "#F8664F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_394_12209",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "86",
                                height: "86",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            desc: 'You work collaboratively with your portfolio companies to create value for everyone.'
        },
        {
            title1: 'New',
            title2: 'Opportunities',
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                style: {
                    width: '70px',
                    height: '70px'
                },
                width: "72",
                height: "72",
                viewBox: "0 0 72 72",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M47.7821 36.0791L43.9094 39.9518C43.0803 40.7809 43.0803 42.1227 43.9094 42.9518L49.4075 48.45C50.2366 49.2791 51.5785 49.2791 52.4075 48.45L56.2803 44.5773L47.7821 36.0791Z",
                        fill: "url(#paint0_radial_1924_606)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M29.1927 28.2355C30.0218 29.0645 31.3636 29.0645 32.1927 28.2355L36.0654 24.3627L27.5672 15.8645L23.6945 19.7373C22.8654 20.5664 22.8654 21.9082 23.6945 22.7373L29.1927 28.2355Z",
                        fill: "url(#paint1_radial_1924_606)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M28.2543 65.9918C28.3416 65.9264 28.4288 65.85 28.4943 65.7518C30.4252 62.9046 33.6216 61.2027 37.0579 61.1591C37.1016 61.1591 37.1343 61.17 37.1779 61.17C37.2216 61.17 37.2543 61.1591 37.2979 61.1591C40.7343 61.2027 43.9307 62.9046 45.8616 65.7518C45.927 65.85 46.0143 65.9155 46.1016 65.9918C43.9743 68.5664 40.7779 70.2136 37.1779 70.2136C33.5779 70.2136 30.3816 68.5664 28.2543 65.9918Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M41.0837 59.6427C41.4109 59.3482 41.7055 59.01 41.9673 58.6282C42.6219 57.6573 42.9709 56.5336 42.9709 55.3663C42.9709 52.17 40.3746 49.5736 37.1782 49.5736C33.9819 49.5736 31.3855 52.17 31.3855 55.3663C31.3855 56.5227 31.7346 57.6573 32.3891 58.6173C32.64 58.9882 32.9455 59.3263 33.2728 59.6318C30.7855 60.4391 28.6037 61.9991 27.0219 64.1482C26.1273 62.5009 25.6146 60.6245 25.6146 58.6282C25.6146 52.2354 30.7964 47.0536 37.1891 47.0536C43.5819 47.0536 48.7637 52.2354 48.7637 58.6282C48.7637 60.6354 48.24 62.5009 47.3564 64.1482C45.7528 62.01 43.56 60.45 41.0837 59.6427Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M37.255 59.0094H37.1786C37.1786 59.0094 37.1241 59.0094 37.1023 59.0094C35.9241 58.9875 34.8332 58.3985 34.1677 57.4275C33.7532 56.8166 33.535 56.1075 33.535 55.3766C33.535 53.3694 35.1714 51.733 37.1786 51.733C39.1859 51.733 40.8223 53.3694 40.8223 55.3766C40.8223 56.1075 40.6041 56.8166 40.1895 57.4275C39.5241 58.3985 38.4332 58.9875 37.255 59.0094Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M11.673 55.258H11.6076H11.5421C10.5821 55.2362 9.68759 54.7562 9.14213 53.9598C8.80395 53.458 8.62941 52.8798 8.62941 52.2798C8.62941 50.6326 9.97123 49.2908 11.6185 49.2908C13.2658 49.2908 14.5967 50.6326 14.5967 52.2798C14.5967 52.8798 14.4221 53.458 14.073 53.9598C13.5276 54.7562 12.633 55.2362 11.673 55.258Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M11.6074 45.1221C17.1056 45.1221 21.5674 49.5839 21.5674 55.0821C21.5674 56.7512 21.1419 58.3003 20.4219 59.6857C19.091 57.9076 17.291 56.5985 15.251 55.8785C15.4692 55.6603 15.6765 55.4203 15.851 55.1585C16.4292 54.2966 16.7347 53.293 16.7347 52.2676C16.7347 49.4421 14.4328 47.1294 11.6074 47.1294C8.78193 47.1294 6.4692 49.4312 6.4692 52.2676C6.4692 53.293 6.77466 54.2966 7.35284 55.1476C7.52738 55.4094 7.73465 55.6494 7.96375 55.8676C5.91284 56.5876 4.11284 57.8966 2.79284 59.6748C2.07284 58.3003 1.64738 56.7403 1.64738 55.0712C1.64738 49.5839 6.1092 45.1221 11.6074 45.1221Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M11.4977 57.4049C11.5305 57.4049 11.5632 57.4158 11.5959 57.4158C11.6286 57.4158 11.6614 57.4049 11.6941 57.4049C14.6068 57.4376 17.3014 58.8885 18.9377 61.2885C19.0032 61.3867 19.0905 61.463 19.1777 61.5285C17.345 63.6776 14.6286 65.0412 11.5959 65.0412C8.55228 65.0412 5.83591 63.6776 4.00318 61.5285C4.09046 61.463 4.17773 61.3867 4.24319 61.2885C5.89046 58.8776 8.59591 57.4376 11.4977 57.4049Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M18.0436 36.7218C18.0872 36.7763 18.1417 36.8091 18.1963 36.8527C16.7236 38.3254 14.7054 39.2309 12.4581 39.2309C10.2108 39.2309 8.18174 38.3145 6.71992 36.8418C6.77447 36.7982 6.82901 36.7654 6.87265 36.7109C8.22538 34.9654 10.2545 33.9618 12.4581 33.9618C14.6617 33.9618 16.6908 34.9763 18.0436 36.7218Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M15.7744 32.4479C15.8835 32.3279 15.9817 32.197 16.0798 32.0551C16.5817 31.3133 16.8435 30.4733 16.8435 29.5897C16.8435 27.1788 14.8798 25.2151 12.4689 25.2151C10.058 25.2151 8.09438 27.1788 8.09438 29.5897C8.09438 30.4624 8.3562 31.3133 8.84711 32.0551C8.9453 32.197 9.04348 32.3279 9.15257 32.4479C7.72348 33.0042 6.44711 33.9097 5.43257 35.1206C4.76711 33.9424 4.35257 32.5897 4.35257 31.1388C4.35257 26.6551 7.98529 23.0333 12.458 23.0333C16.9417 23.0333 20.5635 26.6661 20.5635 31.1388C20.5635 32.5897 20.1598 33.9424 19.4835 35.1206C18.4689 33.9097 17.2035 33.0042 15.7744 32.4479Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M12.4581 31.826C11.7163 31.826 11.029 31.466 10.6145 30.8551C10.3636 30.4842 10.2327 30.0478 10.2327 29.6005C10.2327 28.3678 11.2363 27.3751 12.4581 27.3751C13.68 27.3751 14.6836 28.3787 14.6836 29.6005C14.6836 30.0478 14.5527 30.4842 14.2909 30.8551C13.8763 31.466 13.189 31.826 12.4581 31.826Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M35.4107 30.7555C35.2798 30.7009 35.138 30.6682 34.9962 30.6682C34.5816 30.6682 34.178 30.9191 34.0035 31.3227L31.8325 36.5264C31.6907 36.8536 31.7344 37.2355 31.9307 37.5409C32.1271 37.8355 32.4653 38.0209 32.8253 38.0209H35.6071L34.2325 41.5773C34.0144 42.1336 34.298 42.7555 34.8435 42.9627C35.3889 43.1809 36.0216 42.8973 36.2289 42.3518L38.1816 37.3446C38.3125 37.0173 38.2689 36.6464 38.0616 36.3518C37.8653 36.0573 37.5271 35.8827 37.178 35.8827H34.4398L35.9889 32.1627C36.218 31.6173 35.9562 30.9846 35.4107 30.7555Z",
                        fill: "#FCBC04"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M60.9823 53.8718C60.7532 53.61 60.4041 53.4682 60.0441 53.5118C59.695 53.5555 59.3896 53.7627 59.2259 54.0791L57.9605 56.5118L55.3859 53.4136C55.1677 53.1627 54.8623 53.0209 54.5568 53.0209C54.3168 53.0209 54.0768 53.0973 53.8696 53.2718C53.4114 53.6536 53.3459 54.33 53.7277 54.7882L57.3387 59.13C57.5677 59.4027 57.9277 59.5555 58.2768 59.5118C58.6368 59.4791 58.9532 59.2609 59.1168 58.9446L60.4041 56.4791L62.9132 59.3373C63.3059 59.7846 63.9823 59.8282 64.4296 59.4355C64.8768 59.0427 64.9205 58.3664 64.5277 57.9191L60.9823 53.8718Z",
                        fill: "#F9E109"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M14.6948 15.1555L17.3784 14.3918L17.0294 18.1882C16.9748 18.7773 17.4112 19.3009 18.0003 19.3555C18.5894 19.41 19.113 18.9736 19.1675 18.3845L19.6584 13.0282C19.6912 12.6791 19.5494 12.33 19.2766 12.1009C19.0039 11.8718 18.633 11.7955 18.2948 11.8936L15.6657 12.6464L16.1457 8.64273C16.2112 8.05364 15.7966 7.51909 15.2075 7.45364C15.1639 7.45364 15.1203 7.44273 15.0766 7.44273C14.5421 7.44273 14.073 7.84637 14.0075 8.39182L13.3421 13.9991C13.2984 14.3591 13.4403 14.7082 13.713 14.9482C13.9748 15.1664 14.3457 15.2536 14.6948 15.1555Z",
                        fill: "#F9E109"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M43.7018 16.7264C46.8109 13.6173 51.8618 13.2682 55.1673 16.1591C57.0655 17.8173 58.0036 20.1082 58.0036 22.41C58.0146 24.5264 57.2073 26.6427 55.5818 28.2682L49.2873 34.5627L57.7855 43.0609L64.4073 36.4391C72.3382 28.5082 72.3382 15.6573 64.4073 7.73727L64.3964 7.72636C56.4655 -0.204548 43.6146 -0.204548 35.6946 7.72636L29.0727 14.3482L37.5709 22.8464L43.7018 16.7264Z",
                        fill: "url(#paint2_radial_1924_606)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("radialGradient", {
                                id: "paint0_radial_1924_606",
                                cx: "0",
                                cy: "0",
                                r: "1",
                                gradientUnits: "userSpaceOnUse",
                                gradientTransform: "translate(41.0628 44.0172) rotate(-15.2126) scale(18.5908 18.6757)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        "stop-color": "#88FFC6"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.28",
                                        "stop-color": "#88FFC6"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.71",
                                        "stop-color": "#4DEB9F"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.83",
                                        "stop-color": "#32CA81"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("radialGradient", {
                                id: "paint1_radial_1924_606",
                                cx: "0",
                                cy: "0",
                                r: "1",
                                gradientUnits: "userSpaceOnUse",
                                gradientTransform: "translate(20.848 23.8026) rotate(-15.2126) scale(18.5908 18.6757)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        "stop-color": "#88FFC6"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.28",
                                        "stop-color": "#88FFC6"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.71",
                                        "stop-color": "#4DEB9F"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.83",
                                        "stop-color": "#32CA81"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("radialGradient", {
                                id: "paint2_radial_1924_606",
                                cx: "0",
                                cy: "0",
                                r: "1",
                                gradientUnits: "userSpaceOnUse",
                                gradientTransform: "translate(22.0039 27.0004) rotate(-15.2126) scale(59.0699 59.3398)",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        "stop-color": "#88FFC6"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.28",
                                        "stop-color": "#88FFC6"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.71",
                                        "stop-color": "#4DEB9F"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                        offset: "0.83",
                                        "stop-color": "#32CA81"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            desc: 'Receive FREE curated leads from companies already on Diligentsia platform.'
        }
    ],
    title: 'How it works?',
    description: 'Rapidly increase the value of your network!'
};


















// Key features modules array
const $cf9800d02c9ef389$var$KEY_FEATURE_MODULES = {
    subHeading: 'making everyone stronger',
    subTiltle: 'For Investors',
    titleOne: "For You",
    titleTwo: "For Your Portfolio",
    portfolioModules: [
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "71",
                height: "73",
                viewBox: "0 0 71 73",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M48.7686 16.1188C49.3136 16.1188 49.7577 16.5627 49.7577 17.1085C49.7577 17.6532 49.3138 18.0972 48.7686 18.0972C48.2235 18.0972 47.7804 17.6532 47.7804 17.1085C47.7804 16.5627 48.2236 16.1188 48.7686 16.1188ZM48.7686 20.3894C50.5785 20.3894 52.0494 18.9164 52.0494 17.1085C52.0494 15.2991 50.5785 13.8264 48.7686 13.8264C46.9596 13.8264 45.4886 15.2991 45.4886 17.1085C45.4886 18.9164 46.9596 20.3894 48.7686 20.3894ZM38.7781 16.1188C39.3239 16.1188 39.7663 16.5627 39.7663 17.1085C39.7663 17.6532 39.3239 18.0972 38.7781 18.0972C38.2323 18.0972 37.7891 17.6532 37.7891 17.1085C37.7891 16.5627 38.2323 16.1188 38.7781 16.1188ZM38.7781 20.3894C40.5872 20.3894 42.0589 18.9164 42.0589 17.1085C42.0589 15.2991 40.5872 13.8264 38.7781 13.8264C36.969 13.8264 35.4973 15.2991 35.4973 17.1085C35.4973 18.9164 36.9692 20.3894 38.7781 20.3894ZM28.7869 16.1188C29.3327 16.1188 29.7759 16.5627 29.7759 17.1085C29.7759 17.6532 29.3327 18.0972 28.7869 18.0972C28.2426 18.0972 27.7987 17.6532 27.7987 17.1085C27.7987 16.5627 28.2426 16.1188 28.7869 16.1188ZM28.7869 20.3894C30.5968 20.3894 32.0677 18.9164 32.0677 17.1085C32.0677 15.2991 30.5968 13.8264 28.7869 13.8264C26.9778 13.8264 25.5061 15.2991 25.5061 17.1085C25.5061 18.9164 26.9778 20.3894 28.7869 20.3894ZM19.8089 9.17606V25.0395C19.8089 28.2139 22.3902 30.8658 25.5635 30.9501C26.1853 30.9659 26.6803 31.4745 26.6803 32.0949V39.1434L34.5358 31.2868C34.7509 31.072 35.0436 30.9516 35.3469 30.9516H51.8351C55.0949 30.9516 57.7474 28.2996 57.7474 25.0394V9.17606C57.7474 5.91549 55.0949 3.26397 51.8351 3.26397H25.7212C22.4606 3.26397 19.8089 5.91549 19.8089 9.17606ZM24.3877 33.1337V41.9114C24.3877 42.9305 25.6259 43.4411 26.3447 42.722L35.8208 33.2439H51.8351C56.3588 33.2439 60.0392 29.5639 60.0392 25.0395V9.17606C60.0392 4.65223 56.3588 0.97168 51.8351 0.97168H25.7212C21.1974 0.97168 17.5171 4.65223 17.5171 9.17606V25.0395C17.5171 29.0667 20.5093 32.4861 24.3877 33.1337ZM65.903 53.0112C65.8568 53.0497 65.8196 53.0753 65.7695 53.1098L41.1605 69.1492C40.7925 69.3899 40.4069 69.4487 39.9831 69.33L24.7775 65.0764C24.1078 64.8888 23.4576 64.8872 22.789 65.0694L17.1614 66.6038V50.5328L25.2976 48.2808L39.883 52.1887C41.6952 52.6745 42.7757 54.544 42.2896 56.3576C41.8044 58.1698 39.9339 59.2486 38.1209 58.7631L23.2347 54.7748C22.6225 54.6114 21.9958 54.9738 21.8308 55.5857C21.6675 56.1961 22.0297 56.8249 22.6411 56.9882L37.5273 60.9779C40.3313 61.728 43.2903 60.2405 44.3283 57.491L64.7257 48.3223C65.0338 48.1832 65.3047 48.1562 65.6322 48.2291C68.0017 48.7591 67.9526 51.3125 65.903 53.0112ZM14.8694 68.4132C14.8694 69.1422 14.2766 69.7367 13.5456 69.7367H4.90163C4.17057 69.7367 3.57778 69.1422 3.57778 68.4132V49.4897C3.57778 48.7606 4.17057 48.1661 4.90163 48.1661H13.5456C14.2766 48.1661 14.8694 48.7608 14.8694 49.4897V68.4132ZM69.5947 49.2133C69.2041 47.5943 67.9103 46.3911 66.1336 45.9927C65.3168 45.8094 64.5494 45.8881 63.786 46.2306L44.6606 54.8291C44.3995 52.5739 42.7966 50.597 40.4758 49.9739L25.5896 45.9854C25.3922 45.9326 25.1843 45.9338 24.9863 45.9882L16.931 48.2174C16.4159 46.8493 15.0929 45.8739 13.5459 45.8739H4.90163C2.90747 45.8739 1.28516 47.4953 1.28516 49.4895V68.413C1.28516 70.4057 2.90731 72.0286 4.90163 72.0286H13.5456C15.3425 72.0286 16.836 70.7108 17.1159 68.9917L23.392 67.2812C23.6638 67.2067 23.8877 67.2067 24.1595 67.2825L39.3651 71.5373C40.4163 71.8316 41.4759 71.6784 42.4113 71.0692L67.0203 55.0294C67.1448 54.9479 67.2507 54.8704 67.3656 54.7744C69.1992 53.2532 70.0531 51.1228 69.5947 49.2133Z",
                    fill: "#4A67FF",
                    stroke: "#4A67FF",
                    "stroke-width": "1.5"
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Your FREE Diligentsia ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Portfolio Pro Dashboard"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "71",
                    height: "73",
                    viewBox: "0 0 71 73",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M48.7686 16.1188C49.3136 16.1188 49.7577 16.5627 49.7577 17.1085C49.7577 17.6532 49.3138 18.0972 48.7686 18.0972C48.2235 18.0972 47.7804 17.6532 47.7804 17.1085C47.7804 16.5627 48.2236 16.1188 48.7686 16.1188ZM48.7686 20.3894C50.5785 20.3894 52.0494 18.9164 52.0494 17.1085C52.0494 15.2991 50.5785 13.8264 48.7686 13.8264C46.9596 13.8264 45.4886 15.2991 45.4886 17.1085C45.4886 18.9164 46.9596 20.3894 48.7686 20.3894ZM38.7781 16.1188C39.3239 16.1188 39.7663 16.5627 39.7663 17.1085C39.7663 17.6532 39.3239 18.0972 38.7781 18.0972C38.2323 18.0972 37.7891 17.6532 37.7891 17.1085C37.7891 16.5627 38.2323 16.1188 38.7781 16.1188ZM38.7781 20.3894C40.5872 20.3894 42.0589 18.9164 42.0589 17.1085C42.0589 15.2991 40.5872 13.8264 38.7781 13.8264C36.969 13.8264 35.4973 15.2991 35.4973 17.1085C35.4973 18.9164 36.9692 20.3894 38.7781 20.3894ZM28.7869 16.1188C29.3327 16.1188 29.7759 16.5627 29.7759 17.1085C29.7759 17.6532 29.3327 18.0972 28.7869 18.0972C28.2426 18.0972 27.7987 17.6532 27.7987 17.1085C27.7987 16.5627 28.2426 16.1188 28.7869 16.1188ZM28.7869 20.3894C30.5968 20.3894 32.0677 18.9164 32.0677 17.1085C32.0677 15.2991 30.5968 13.8264 28.7869 13.8264C26.9778 13.8264 25.5061 15.2991 25.5061 17.1085C25.5061 18.9164 26.9778 20.3894 28.7869 20.3894ZM19.8089 9.17606V25.0395C19.8089 28.2139 22.3902 30.8658 25.5635 30.9501C26.1853 30.9659 26.6803 31.4745 26.6803 32.0949V39.1434L34.5358 31.2868C34.7509 31.072 35.0436 30.9516 35.3469 30.9516H51.8351C55.0949 30.9516 57.7474 28.2996 57.7474 25.0394V9.17606C57.7474 5.91549 55.0949 3.26397 51.8351 3.26397H25.7212C22.4606 3.26397 19.8089 5.91549 19.8089 9.17606ZM24.3877 33.1337V41.9114C24.3877 42.9305 25.6259 43.4411 26.3447 42.722L35.8208 33.2439H51.8351C56.3588 33.2439 60.0392 29.5639 60.0392 25.0395V9.17606C60.0392 4.65223 56.3588 0.97168 51.8351 0.97168H25.7212C21.1974 0.97168 17.5171 4.65223 17.5171 9.17606V25.0395C17.5171 29.0667 20.5093 32.4861 24.3877 33.1337ZM65.903 53.0112C65.8568 53.0497 65.8196 53.0753 65.7695 53.1098L41.1605 69.1492C40.7925 69.3899 40.4069 69.4487 39.9831 69.33L24.7775 65.0764C24.1078 64.8888 23.4576 64.8872 22.789 65.0694L17.1614 66.6038V50.5328L25.2976 48.2808L39.883 52.1887C41.6952 52.6745 42.7757 54.544 42.2896 56.3576C41.8044 58.1698 39.9339 59.2486 38.1209 58.7631L23.2347 54.7748C22.6225 54.6114 21.9958 54.9738 21.8308 55.5857C21.6675 56.1961 22.0297 56.8249 22.6411 56.9882L37.5273 60.9779C40.3313 61.728 43.2903 60.2405 44.3283 57.491L64.7257 48.3223C65.0338 48.1832 65.3047 48.1562 65.6322 48.2291C68.0017 48.7591 67.9526 51.3125 65.903 53.0112ZM14.8694 68.4132C14.8694 69.1422 14.2766 69.7367 13.5456 69.7367H4.90163C4.17057 69.7367 3.57778 69.1422 3.57778 68.4132V49.4897C3.57778 48.7606 4.17057 48.1661 4.90163 48.1661H13.5456C14.2766 48.1661 14.8694 48.7608 14.8694 49.4897V68.4132ZM69.5947 49.2133C69.2041 47.5943 67.9103 46.3911 66.1336 45.9927C65.3168 45.8094 64.5494 45.8881 63.786 46.2306L44.6606 54.8291C44.3995 52.5739 42.7966 50.597 40.4758 49.9739L25.5896 45.9854C25.3922 45.9326 25.1843 45.9338 24.9863 45.9882L16.931 48.2174C16.4159 46.8493 15.0929 45.8739 13.5459 45.8739H4.90163C2.90747 45.8739 1.28516 47.4953 1.28516 49.4895V68.413C1.28516 70.4057 2.90731 72.0286 4.90163 72.0286H13.5456C15.3425 72.0286 16.836 70.7108 17.1159 68.9917L23.392 67.2812C23.6638 67.2067 23.8877 67.2067 24.1595 67.2825L39.3651 71.5373C40.4163 71.8316 41.4759 71.6784 42.4113 71.0692L67.0203 55.0294C67.1448 54.9479 67.2507 54.8704 67.3656 54.7744C69.1992 53.2532 70.0531 51.1228 69.5947 49.2133Z",
                        fill: "#4A67FF",
                        stroke: "#4A67FF",
                        "stroke-width": "1.5"
                    })
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Your FREE Diligentsia ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Portfolio Pro Dashboard"
                    ]
                }),
                points: [
                    'FREE dashboard for your portfolio company monitoring',
                    'At a glance bronze/silver/gold certification',
                    'All your portfolio companies in one place - see status',
                    'FREE tools - client benchmarking, automated anylist checklist creator',
                    'Access your company dashboards and module status and reports (with permissions)',
                    'Set up permissions for each of your investment directors',
                    `Review FREE curated, pre-diligenced leads introduced by Diligentsia from its companies reaching gold certification status and matching your investment criteria`
                ],
                image: (parcelRequire("aEyq0")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                },
                cardPaddingBottom: {
                    paddingBottom: '3rem'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "65",
                height: "65",
                viewBox: "0 0 65 65",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    "clip-path": "url(#clip0_2144_2961)",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M59.0649 45.2617C57.0984 43.7326 54.4454 42.424 51.1735 41.365L40.4602 15.9917L46.5688 12.8672C47.8444 12.2148 47.9682 10.436 46.7958 9.61325L33.5931 0.345958C32.6001 -0.350612 31.2153 0.0464848 30.744 1.16567L13.8201 41.3655C10.5497 42.4252 7.89796 43.734 5.93215 45.2629C2.81301 47.6887 2.1582 50.1543 2.1582 51.7955C2.1582 55.6194 5.54178 59.0754 11.6857 61.5269C23.2874 66.1564 41.7041 66.1591 53.3124 61.5269C59.4562 59.0753 62.8399 55.6194 62.8399 51.7955C62.8399 50.1538 62.185 47.6876 59.0649 45.2617ZM49.8453 48.0099C49.4554 49.2351 46.5891 51.0364 41.5124 52.088V46.8234C44.1716 46.3314 46.5386 45.6198 48.4568 44.7218L49.8453 48.0099ZM33.3379 4.81977L42.0218 10.9152L38.975 12.4737C38.5486 11.4667 37.4225 11.0485 36.4752 11.4488C35.5064 11.8578 35.0526 12.9749 35.4618 13.9437C35.8866 14.9496 46.9737 41.2087 46.9737 41.2087C43.6382 42.8044 38.1992 43.7977 32.4992 43.7977C26.7962 43.7977 21.3544 42.8033 18.0195 41.2063L33.3379 4.81977ZM37.704 47.3561V52.6739C34.3705 53.0263 30.6339 53.0271 27.2941 52.6739V47.3561C30.6937 47.6896 34.303 47.6897 37.704 47.3561ZM16.5398 44.721C18.4583 45.6195 20.8258 46.3313 23.4858 46.8234V52.088C18.4091 51.0364 15.5428 49.2351 15.153 48.0099C16.0614 45.8585 15.7407 46.6188 16.5398 44.721ZM51.9009 57.9898C41.1996 62.2598 23.7987 62.26 13.0972 57.9898C8.63223 56.2082 5.96668 53.8926 5.96668 51.7955C5.96668 49.9205 8.14868 47.8888 11.7689 46.2336L11.4485 46.9925C11.3494 47.227 11.2984 47.4789 11.2984 47.7333C11.2984 52.2226 17.4375 55.0875 25.0009 56.209C30.2578 56.8805 34.5371 56.9913 39.9969 56.209C47.5603 55.0875 53.6994 52.2226 53.6994 47.7333C53.6994 47.4789 53.6485 47.227 53.5494 46.9925L53.2292 46.2341C56.8494 47.8887 59.0313 49.9202 59.0313 51.7957C59.0314 53.8925 56.3659 56.2082 51.9009 57.9898Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.05446 20.1165L6.23549 21.564C6.35305 22.5043 7.14419 23.2151 8.09174 23.2317C9.07217 23.2425 9.85875 22.5406 10.005 21.6299L10.3029 19.7759C10.7195 17.1847 12.4866 14.9561 14.9131 13.9605C16.4081 13.3486 16.5262 11.3715 15.2166 10.5656L13.8455 9.72178C12.0268 8.60284 10.7581 6.757 10.3644 4.65815L9.99661 2.69615C9.82511 1.78098 9.01745 1.12859 8.08641 1.14318C7.15562 1.16197 6.37501 1.85105 6.2407 2.77232L6.01955 4.28898C5.68047 6.61406 4.31589 8.61617 2.27595 9.78207L0.959737 10.534C-0.43226 11.3293 -0.275859 13.3944 1.22658 13.9668C3.85557 14.9685 5.70548 17.3248 6.05446 20.1165ZM8.15179 9.2857C8.81814 10.3546 9.66045 11.3123 10.6465 12.1125C9.66198 12.9104 8.81535 13.8672 8.1429 14.9374C7.46144 13.8655 6.60263 12.9121 5.60036 12.12C6.61329 11.3192 7.47312 10.3608 8.15179 9.2857Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M64.0731 25.7884L62.6117 24.9115C60.7798 23.8125 59.5036 21.978 59.1099 19.8784L58.7446 17.93C58.5729 17.0149 57.7612 16.3614 56.8344 16.3771C55.9036 16.3959 55.1231 17.085 54.9887 18.0061L54.7509 19.6365C54.4212 21.8971 53.1013 23.8556 51.1298 25.0098L49.8175 25.7779C48.4474 26.5799 48.6057 28.6172 50.0872 29.1953C52.6459 30.1939 54.4472 32.5073 54.7878 35.2329L54.9835 36.7979C55.1023 37.7491 55.9106 38.466 56.8735 38.466C57.8064 38.466 58.6046 37.7885 58.7531 36.864L59.0523 35.0021C59.4669 32.4225 61.2314 30.2172 63.6575 29.2468L63.801 29.1895C65.2596 28.6055 65.422 26.5977 64.0731 25.7884ZM56.9159 30.1397C56.2488 29.0814 55.4084 28.1387 54.4267 27.3525C55.4202 26.5564 56.2629 25.6061 56.9276 24.5417C57.6 25.6024 58.448 26.5493 59.4408 27.3379C58.4484 28.1256 57.5947 29.0746 56.9159 30.1397Z",
                            fill: "#4A67FF"
                        })
                    ]
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "aboutDescription",
                children: "FREE Website Lead Qualification Widget"
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "65",
                    height: "65",
                    viewBox: "0 0 65 65",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        "clip-path": "url(#clip0_2144_2961)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M59.0649 45.2617C57.0984 43.7326 54.4454 42.424 51.1735 41.365L40.4602 15.9917L46.5688 12.8672C47.8444 12.2148 47.9682 10.436 46.7958 9.61325L33.5931 0.345958C32.6001 -0.350612 31.2153 0.0464848 30.744 1.16567L13.8201 41.3655C10.5497 42.4252 7.89796 43.734 5.93215 45.2629C2.81301 47.6887 2.1582 50.1543 2.1582 51.7955C2.1582 55.6194 5.54178 59.0754 11.6857 61.5269C23.2874 66.1564 41.7041 66.1591 53.3124 61.5269C59.4562 59.0753 62.8399 55.6194 62.8399 51.7955C62.8399 50.1538 62.185 47.6876 59.0649 45.2617ZM49.8453 48.0099C49.4554 49.2351 46.5891 51.0364 41.5124 52.088V46.8234C44.1716 46.3314 46.5386 45.6198 48.4568 44.7218L49.8453 48.0099ZM33.3379 4.81977L42.0218 10.9152L38.975 12.4737C38.5486 11.4667 37.4225 11.0485 36.4752 11.4488C35.5064 11.8578 35.0526 12.9749 35.4618 13.9437C35.8866 14.9496 46.9737 41.2087 46.9737 41.2087C43.6382 42.8044 38.1992 43.7977 32.4992 43.7977C26.7962 43.7977 21.3544 42.8033 18.0195 41.2063L33.3379 4.81977ZM37.704 47.3561V52.6739C34.3705 53.0263 30.6339 53.0271 27.2941 52.6739V47.3561C30.6937 47.6896 34.303 47.6897 37.704 47.3561ZM16.5398 44.721C18.4583 45.6195 20.8258 46.3313 23.4858 46.8234V52.088C18.4091 51.0364 15.5428 49.2351 15.153 48.0099C16.0614 45.8585 15.7407 46.6188 16.5398 44.721ZM51.9009 57.9898C41.1996 62.2598 23.7987 62.26 13.0972 57.9898C8.63223 56.2082 5.96668 53.8926 5.96668 51.7955C5.96668 49.9205 8.14868 47.8888 11.7689 46.2336L11.4485 46.9925C11.3494 47.227 11.2984 47.4789 11.2984 47.7333C11.2984 52.2226 17.4375 55.0875 25.0009 56.209C30.2578 56.8805 34.5371 56.9913 39.9969 56.209C47.5603 55.0875 53.6994 52.2226 53.6994 47.7333C53.6994 47.4789 53.6485 47.227 53.5494 46.9925L53.2292 46.2341C56.8494 47.8887 59.0313 49.9202 59.0313 51.7957C59.0314 53.8925 56.3659 56.2082 51.9009 57.9898Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M6.05446 20.1165L6.23549 21.564C6.35305 22.5043 7.14419 23.2151 8.09174 23.2317C9.07217 23.2425 9.85875 22.5406 10.005 21.6299L10.3029 19.7759C10.7195 17.1847 12.4866 14.9561 14.9131 13.9605C16.4081 13.3486 16.5262 11.3715 15.2166 10.5656L13.8455 9.72178C12.0268 8.60284 10.7581 6.757 10.3644 4.65815L9.99661 2.69615C9.82511 1.78098 9.01745 1.12859 8.08641 1.14318C7.15562 1.16197 6.37501 1.85105 6.2407 2.77232L6.01955 4.28898C5.68047 6.61406 4.31589 8.61617 2.27595 9.78207L0.959737 10.534C-0.43226 11.3293 -0.275859 13.3944 1.22658 13.9668C3.85557 14.9685 5.70548 17.3248 6.05446 20.1165ZM8.15179 9.2857C8.81814 10.3546 9.66045 11.3123 10.6465 12.1125C9.66198 12.9104 8.81535 13.8672 8.1429 14.9374C7.46144 13.8655 6.60263 12.9121 5.60036 12.12C6.61329 11.3192 7.47312 10.3608 8.15179 9.2857Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M64.0731 25.7884L62.6117 24.9115C60.7798 23.8125 59.5036 21.978 59.1099 19.8784L58.7446 17.93C58.5729 17.0149 57.7612 16.3614 56.8344 16.3771C55.9036 16.3959 55.1231 17.085 54.9887 18.0061L54.7509 19.6365C54.4212 21.8971 53.1013 23.8556 51.1298 25.0098L49.8175 25.7779C48.4474 26.5799 48.6057 28.6172 50.0872 29.1953C52.6459 30.1939 54.4472 32.5073 54.7878 35.2329L54.9835 36.7979C55.1023 37.7491 55.9106 38.466 56.8735 38.466C57.8064 38.466 58.6046 37.7885 58.7531 36.864L59.0523 35.0021C59.4669 32.4225 61.2314 30.2172 63.6575 29.2468L63.801 29.1895C65.2596 28.6055 65.422 26.5977 64.0731 25.7884ZM56.9159 30.1397C56.2488 29.0814 55.4084 28.1387 54.4267 27.3525C55.4202 26.5564 56.2629 25.6061 56.9276 24.5417C57.6 25.6024 58.448 26.5493 59.4408 27.3379C58.4484 28.1256 57.5947 29.0746 56.9159 30.1397Z",
                                fill: "#4A67FF"
                            })
                        ]
                    })
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "aboutDescription",
                    children: "Functional Expansion Pack - Lead Qualification Widget"
                }),
                points: [
                    'Swamped with unsolicited applications for investment?',
                    "Attach our FREE \u201Cno-code\u201D widget to your web site enquiries/contact us page",
                    "Applicant companies complete short questionnaire bespoked to your organisation\u2019s investment criteria (Diligentsia questionnaire wizard)",
                    "\u201CFit Report\u201D generated in real time",
                    "Review/accept/reject\xa0 applications in your Portfolio Pro dashboard",
                    'Use as a base for further stages of our automated diligence process',
                    "Rejected companies benefit - we offer them alternative investors with a potentially better \u201Cfit\u201D. Their time not wasted."
                ],
                image: (parcelRequire("ki3OO")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "69",
                height: "67",
                viewBox: "0 0 69 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                        fill: "#4A67FF",
                        stroke: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                        fill: "#4A67FF",
                        stroke: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "aboutDescription",
                children: "FREE Applicant Leads Module"
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "69",
                    height: "67",
                    viewBox: "0 0 69 67",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "aboutDescription",
                    children: "FREE Applicant Leads Module"
                }),
                subMenu: {
                    index: 4,
                    points: [
                        '- Data Repository Report',
                        `- 20-section Business Audit`,
                        "- Directors\u2019 questionnaires",
                        '- Draft Warranty Disclosures'
                    ]
                },
                points: [
                    'Open to Diligentsia gold certification only',
                    "Matches applicant company investment requirements against your fund\u2019s investment criteria for initial screening",
                    'List of curated applicant company leads, with contact details',
                    "A \u201CFit Report\u201D which shows each the party the Fit with the other",
                    'Supported with a comprehensive Due Diligence Pack, already completed:'
                ],
                image: (parcelRequire("3i2EE")),
                notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        fontSize: "14px",
                        color: 'gray',
                        fontStyle: 'italic'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontWeight: "bold",
                                fontStyle: 'normal'
                            },
                            children: `Please Note: `
                        }),
                        "Diligentsia does NOT give investment advice, nor do we generate revenue from successful introductions via our platform. Nor do we take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice."
                    ]
                }),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "FREE AnyList",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Checklist Builder"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "83",
                    height: "83",
                    viewBox: "0 0 83 83",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "FREE AnyList",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Checklist Builder"
                    ]
                }),
                points: [
                    'Undertaking M&A? Create relevant automated due diligence checklists bespoked to target company',
                    `10 sections; 10 questions per section`,
                    `You can add your own questions and desired answers`,
                    `Questions: can choose subjective, objective or a mixture`,
                    `Completeness and risk scoring`,
                    `Reporting`,
                    `Workflow Manager: Can send to target company and monitor completeness`
                ],
                image: (parcelRequire("lB7oR")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "65",
                height: "65",
                viewBox: "0 0 65 65",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    "clip-path": "url(#clip0_2119_192)",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M54.9743 42.4394C57.0327 38.6748 58.1973 34.3686 58.1973 29.7915C58.1973 28.5728 58.0618 27.3811 57.8993 26.1894C61.1764 25.404 63.6139 22.479 63.6139 18.9582C63.6139 14.8415 60.2827 11.5103 56.166 11.5103C54.5952 11.5103 53.1598 11.9978 51.9681 12.8103C46.9577 6.879 39.6181 3.38525 31.791 3.38525C17.2202 3.38525 5.38477 15.2207 5.38477 29.7915C5.38477 44.3623 17.2202 56.1978 31.791 56.1978C36.3681 56.1978 40.6743 55.0332 44.4389 52.9748L50.9118 59.4478C52.3743 60.9103 54.2702 61.6144 56.1931 61.6144C58.116 61.6144 60.0118 60.8832 61.4743 59.4478C64.3723 56.5498 64.3723 51.8103 61.4743 48.9123L55.0014 42.4394H54.9743ZM56.166 15.5728C58.0348 15.5728 59.5514 17.0894 59.5514 18.9582C59.5514 20.8269 58.0348 22.3436 56.166 22.3436C54.2973 22.3436 52.7806 20.8269 52.7806 18.9582C52.7806 17.0894 54.2973 15.5728 56.166 15.5728ZM31.791 7.44775C38.6431 7.44775 45.0889 10.6436 49.3139 16.0332C48.9348 16.9269 48.7181 17.929 48.7181 18.9582C48.7181 20.2853 49.0973 21.4769 49.6931 22.5603L35.7452 36.5082L30.0577 30.8207C30.7077 29.7103 31.1139 28.4373 31.1139 27.0832C31.1139 22.9665 27.7827 19.6353 23.666 19.6353C19.5493 19.6353 16.2181 22.9665 16.2181 27.0832C16.2181 28.3019 16.5431 29.4394 17.0577 30.4686L10.6118 36.8873C9.85352 34.6665 9.44727 32.2832 9.44727 29.7915C9.44727 17.4686 19.4681 7.44775 31.791 7.44775ZM20.2806 27.0832C20.2806 25.2144 21.7973 23.6978 23.666 23.6978C25.5348 23.6978 27.0514 25.2144 27.0514 27.0832C27.0514 28.9519 25.5348 30.4686 23.666 30.4686C21.7973 30.4686 20.2806 28.9519 20.2806 27.0832ZM12.3993 40.8415L19.8202 33.4207C20.9306 34.0978 22.2577 34.504 23.666 34.504C24.9118 34.504 26.1035 34.1519 27.1327 33.6103L34.3098 40.7873C34.716 41.1936 35.2306 41.3832 35.7452 41.3832C36.2598 41.3832 36.7743 41.1936 37.1806 40.7873L52.5639 25.404C52.9431 25.6207 53.3493 25.8103 53.7556 25.9457C53.9723 27.2186 54.1348 28.4915 54.1348 29.7644C54.1348 42.0873 44.1139 52.1082 31.791 52.1082C23.5035 52.1082 16.2452 47.5582 12.3993 40.8144V40.8415ZM58.5493 56.5498C57.2223 57.8769 55.0827 57.8769 53.7556 56.5498L47.8785 50.6728C49.666 49.2915 51.291 47.6665 52.6723 45.879L58.5493 51.7561C59.8764 53.0832 59.8764 55.2228 58.5493 56.5498Z",
                        fill: "#4A67FF"
                    })
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "FREE Portfolio ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Benchmarking"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "65",
                    height: "65",
                    viewBox: "0 0 65 65",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        "clip-path": "url(#clip0_2119_192)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M54.9743 42.4394C57.0327 38.6748 58.1973 34.3686 58.1973 29.7915C58.1973 28.5728 58.0618 27.3811 57.8993 26.1894C61.1764 25.404 63.6139 22.479 63.6139 18.9582C63.6139 14.8415 60.2827 11.5103 56.166 11.5103C54.5952 11.5103 53.1598 11.9978 51.9681 12.8103C46.9577 6.879 39.6181 3.38525 31.791 3.38525C17.2202 3.38525 5.38477 15.2207 5.38477 29.7915C5.38477 44.3623 17.2202 56.1978 31.791 56.1978C36.3681 56.1978 40.6743 55.0332 44.4389 52.9748L50.9118 59.4478C52.3743 60.9103 54.2702 61.6144 56.1931 61.6144C58.116 61.6144 60.0118 60.8832 61.4743 59.4478C64.3723 56.5498 64.3723 51.8103 61.4743 48.9123L55.0014 42.4394H54.9743ZM56.166 15.5728C58.0348 15.5728 59.5514 17.0894 59.5514 18.9582C59.5514 20.8269 58.0348 22.3436 56.166 22.3436C54.2973 22.3436 52.7806 20.8269 52.7806 18.9582C52.7806 17.0894 54.2973 15.5728 56.166 15.5728ZM31.791 7.44775C38.6431 7.44775 45.0889 10.6436 49.3139 16.0332C48.9348 16.9269 48.7181 17.929 48.7181 18.9582C48.7181 20.2853 49.0973 21.4769 49.6931 22.5603L35.7452 36.5082L30.0577 30.8207C30.7077 29.7103 31.1139 28.4373 31.1139 27.0832C31.1139 22.9665 27.7827 19.6353 23.666 19.6353C19.5493 19.6353 16.2181 22.9665 16.2181 27.0832C16.2181 28.3019 16.5431 29.4394 17.0577 30.4686L10.6118 36.8873C9.85352 34.6665 9.44727 32.2832 9.44727 29.7915C9.44727 17.4686 19.4681 7.44775 31.791 7.44775ZM20.2806 27.0832C20.2806 25.2144 21.7973 23.6978 23.666 23.6978C25.5348 23.6978 27.0514 25.2144 27.0514 27.0832C27.0514 28.9519 25.5348 30.4686 23.666 30.4686C21.7973 30.4686 20.2806 28.9519 20.2806 27.0832ZM12.3993 40.8415L19.8202 33.4207C20.9306 34.0978 22.2577 34.504 23.666 34.504C24.9118 34.504 26.1035 34.1519 27.1327 33.6103L34.3098 40.7873C34.716 41.1936 35.2306 41.3832 35.7452 41.3832C36.2598 41.3832 36.7743 41.1936 37.1806 40.7873L52.5639 25.404C52.9431 25.6207 53.3493 25.8103 53.7556 25.9457C53.9723 27.2186 54.1348 28.4915 54.1348 29.7644C54.1348 42.0873 44.1139 52.1082 31.791 52.1082C23.5035 52.1082 16.2452 47.5582 12.3993 40.8144V40.8415ZM58.5493 56.5498C57.2223 57.8769 55.0827 57.8769 53.7556 56.5498L47.8785 50.6728C49.666 49.2915 51.291 47.6665 52.6723 45.879L58.5493 51.7561C59.8764 53.0832 59.8764 55.2228 58.5493 56.5498Z",
                            fill: "#4A67FF"
                        })
                    })
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "FREE Portfolio ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Benchmarking"
                    ]
                }),
                points: [
                    'Benchmark your client/portfolio companies',
                    'Simple scoring system',
                    'Against each or our wider database (anonymized)',
                    'Benchmarking report'
                ],
                image: (parcelRequire("9883i")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        }
    ],
    coreModulesPro: [
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 84 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Your Portfolio Investee",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " Dashboard"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "83",
                    height: "83",
                    viewBox: "0 0 84 83",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Your Portfolio Investee",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Dashboard"
                    ]
                }),
                subMenu: {
                    index: 0,
                    points: [
                        "\u2022 Access all areas (module completion)",
                        `\u{2022} Dashboard and reports`,
                        "\u2022 Dashboard only"
                    ]
                },
                points: [
                    'Your investee company can authorise you:',
                    'At a glance module status and certification',
                    'Bespoked module reporting, with completeness and risk scoring',
                    'Modules prepopulated where possible from e.g. Companies House',
                    'Easy one-stop shop for your companies and their  advisors to work collaboratively with you',
                    'Great for active NEDs to access key company documents'
                ],
                image: (parcelRequire("7B6TB")),
                imageStyle: {
                    height: '84%',
                    width: '100%'
                },
                cardPaddingBottom: {
                    paddingBottom: '3rem'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "70",
                height: "59",
                viewBox: "0 0 70 59",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                    fill: "#4A67FF"
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Portfolio Company\u2019s",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Data Repository"
                ]
            }),
            isStar: true,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "70",
                    height: "59",
                    viewBox: "0 0 70 59",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                        fill: "#4A67FF"
                    })
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Portfolio Company\u2019s",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Data Repository"
                    ]
                }),
                points: [
                    `All an investee company's key corporate documentsin one place \u{2013} easily accessible to all - incuding active NEDs`,
                    `Standard format - 20 sections \u{2013} 160 subsections -  standardise across all your portfolio - saves you time and cost`,
                    `Up to 5 user-defined sections`,
                    `Section checklists for easy creation`,
                    'Already got a bunch of files?  AI Filing Manager will upload and organise their existing files/data room with a few clicks',
                    'Prepopulated docs from UK Companies House',
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "df",
                            children: [
                                "Can sync to company\u2019s chosen cloud provider ",
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "df ml1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                            className: "pen fds w2rem mr0-5rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                            className: "pen fds w2rem mr0-5rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                            className: "pen fds w2rem"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    'AI Deduper will help weed out old files',
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Client unable/too busy?  Advisors can provide this chargeable service"
                    })
                ],
                image: (parcelRequire("3Unna")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "73",
                viewBox: "0 0 83 73",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M80.1158 48.9268L69.851 39.8704C70.6327 37.8154 71.0621 35.588 71.0621 33.262C71.0621 28.5795 69.3262 24.2949 66.4648 21.0171V2.45703C66.4648 1.11412 65.3761 0.0253906 64.0332 0.0253906H12.1582C10.8153 0.0253906 9.72656 1.11412 9.72656 2.45703V35.6895H2.43164C1.08873 35.6895 0 36.7782 0 38.1211V65.6797C0 69.7021 3.2725 72.9746 7.29492 72.9746H59.1699C63.1923 72.9746 66.4648 69.7021 66.4648 65.6797V59.1206L68.0858 60.9574C71.3387 64.6438 77.0272 64.8213 80.5037 61.345C83.9801 57.8684 83.8024 52.1795 80.1158 48.9268ZM9.72656 65.6797C9.72656 67.0205 8.63573 68.1113 7.29492 68.1113C5.95412 68.1113 4.86328 67.0205 4.86328 65.6797V40.5527H9.72656V65.6797ZM61.6016 65.6797C61.6016 67.0205 60.5107 68.1113 59.1699 68.1113H14.1732C14.443 67.3505 14.5898 66.5319 14.5898 65.6797V4.88867H61.6016V17.0425C58.8895 15.501 55.2112 14.6152 51.875 14.6152C51.8457 14.6152 51.8351 14.6152 51.8348 14.6152H21.8848C20.5419 14.6152 19.4531 15.704 19.4531 17.0469C19.4531 18.3898 20.5419 19.4785 21.8848 19.4785H39.88C38.3507 20.871 37.0537 22.514 36.0534 24.3418H21.8848C20.5419 24.3418 19.4531 25.4305 19.4531 26.7734C19.4531 28.1164 20.5419 29.2051 21.8848 29.2051H34.2227C33.9316 30.5117 33.7769 31.869 33.7769 33.2619C33.7769 33.5321 33.7841 33.8007 33.7954 34.0684H21.8848C20.5419 34.0684 19.4531 35.1571 19.4531 36.5C19.4531 37.8429 20.5419 38.9316 21.8848 38.9316H34.6595C35.2183 40.6782 36.028 42.3134 37.0464 43.7949H21.8848C20.5419 43.7949 19.4531 44.8836 19.4531 46.2266C19.4531 47.5695 20.5419 48.6582 21.8848 48.6582H41.9197C44.9121 50.7053 48.5281 51.9044 52.4195 51.9044C54.7458 51.9044 56.9733 51.4749 59.0286 50.693L61.6016 53.6092V65.6797ZM52.4195 47.0413C44.8216 47.0413 38.6402 40.8599 38.6402 33.262C38.6402 25.6641 44.8216 19.4827 52.4195 19.4827C60.0174 19.4827 66.1988 25.6641 66.1988 33.262C66.1988 40.8599 60.0174 47.0413 52.4195 47.0413ZM77.0647 57.9062C75.5718 59.3991 73.129 59.3227 71.7323 57.7397L63.4112 48.3095C64.9622 47.1734 66.3316 45.8041 67.4675 44.253L76.8982 52.5736C78.4814 53.9704 78.5576 56.4134 77.0647 57.9062Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M36.4746 53.5215H21.8848C20.5419 53.5215 19.4531 54.6102 19.4531 55.9531C19.4531 57.296 20.5419 58.3848 21.8848 58.3848H36.4746C37.8175 58.3848 38.9062 57.296 38.9062 55.9531C38.9062 54.6102 37.8175 53.5215 36.4746 53.5215Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Business Audit ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "PRO"
                ]
            }),
            isStar: true,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "83",
                    height: "73",
                    viewBox: "0 0 83 73",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M80.1158 48.9268L69.851 39.8704C70.6327 37.8154 71.0621 35.588 71.0621 33.262C71.0621 28.5795 69.3262 24.2949 66.4648 21.0171V2.45703C66.4648 1.11412 65.3761 0.0253906 64.0332 0.0253906H12.1582C10.8153 0.0253906 9.72656 1.11412 9.72656 2.45703V35.6895H2.43164C1.08873 35.6895 0 36.7782 0 38.1211V65.6797C0 69.7021 3.2725 72.9746 7.29492 72.9746H59.1699C63.1923 72.9746 66.4648 69.7021 66.4648 65.6797V59.1206L68.0858 60.9574C71.3387 64.6438 77.0272 64.8213 80.5037 61.345C83.9801 57.8684 83.8024 52.1795 80.1158 48.9268ZM9.72656 65.6797C9.72656 67.0205 8.63573 68.1113 7.29492 68.1113C5.95412 68.1113 4.86328 67.0205 4.86328 65.6797V40.5527H9.72656V65.6797ZM61.6016 65.6797C61.6016 67.0205 60.5107 68.1113 59.1699 68.1113H14.1732C14.443 67.3505 14.5898 66.5319 14.5898 65.6797V4.88867H61.6016V17.0425C58.8895 15.501 55.2112 14.6152 51.875 14.6152C51.8457 14.6152 51.8351 14.6152 51.8348 14.6152H21.8848C20.5419 14.6152 19.4531 15.704 19.4531 17.0469C19.4531 18.3898 20.5419 19.4785 21.8848 19.4785H39.88C38.3507 20.871 37.0537 22.514 36.0534 24.3418H21.8848C20.5419 24.3418 19.4531 25.4305 19.4531 26.7734C19.4531 28.1164 20.5419 29.2051 21.8848 29.2051H34.2227C33.9316 30.5117 33.7769 31.869 33.7769 33.2619C33.7769 33.5321 33.7841 33.8007 33.7954 34.0684H21.8848C20.5419 34.0684 19.4531 35.1571 19.4531 36.5C19.4531 37.8429 20.5419 38.9316 21.8848 38.9316H34.6595C35.2183 40.6782 36.028 42.3134 37.0464 43.7949H21.8848C20.5419 43.7949 19.4531 44.8836 19.4531 46.2266C19.4531 47.5695 20.5419 48.6582 21.8848 48.6582H41.9197C44.9121 50.7053 48.5281 51.9044 52.4195 51.9044C54.7458 51.9044 56.9733 51.4749 59.0286 50.693L61.6016 53.6092V65.6797ZM52.4195 47.0413C44.8216 47.0413 38.6402 40.8599 38.6402 33.262C38.6402 25.6641 44.8216 19.4827 52.4195 19.4827C60.0174 19.4827 66.1988 25.6641 66.1988 33.262C66.1988 40.8599 60.0174 47.0413 52.4195 47.0413ZM77.0647 57.9062C75.5718 59.3991 73.129 59.3227 71.7323 57.7397L63.4112 48.3095C64.9622 47.1734 66.3316 45.8041 67.4675 44.253L76.8982 52.5736C78.4814 53.9704 78.5576 56.4134 77.0647 57.9062Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M36.4746 53.5215H21.8848C20.5419 53.5215 19.4531 54.6102 19.4531 55.9531C19.4531 57.296 20.5419 58.3848 21.8848 58.3848H36.4746C37.8175 58.3848 38.9062 57.296 38.9062 55.9531C38.9062 54.6102 37.8175 53.5215 36.4746 53.5215Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Business Audit ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "PRO"
                    ]
                }),
                points: [
                    "Step by step audit of your investee company's business - great for pre-investment review",
                    'Quick - multiple choice questions',
                    `Individually bespoked to your applicant  company's business, industry, stage of development and objective`,
                    'At a  a glance red/amber/green status',
                    'Both section and overall completeness and risk scores',
                    'Quickly identify strengths and weaknesses',
                    'Risks and recommendations for each section - company gains from experience',
                    '...all in real-time',
                    'Improvement tracking over time',
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Client unable/too busy? Advisors can provide this chargeable service via Diligentsia Pro Plus"
                    })
                ],
                image: (parcelRequire("izGj8")),
                imageStyle: {
                    height: '76%',
                    width: '100%'
                },
                cardPaddingBottom: {
                    paddingBottom: '3rem'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "53",
                height: "67",
                viewBox: "0 0 53 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M48.6759 19.8499C47.7963 19.009 46.8867 18.1396 46.5988 17.4418C46.2825 16.6754 46.3086 15.3671 46.3338 14.1019C46.3786 11.8552 46.4292 9.30893 44.6987 7.57008C42.9651 5.82808 40.4148 5.8676 38.1666 5.90371C36.904 5.92347 35.5975 5.94428 34.8342 5.62616C34.1366 5.33539 33.2694 4.42487 32.4308 3.54445C30.8482 1.88306 29.0548 0 26.4995 0C23.9442 0 22.1508 1.88306 20.5683 3.54432C19.7298 4.42487 18.8626 5.33539 18.1649 5.62603C17.4018 5.94415 16.0953 5.92347 14.8326 5.90345C12.5825 5.86904 10.034 5.82795 8.30051 7.56981C6.56977 9.30867 6.62054 11.8551 6.6653 14.1018C6.69042 15.3671 6.71659 16.6754 6.40044 17.4416C6.11242 18.1394 5.20281 19.009 4.32318 19.8498C2.66663 21.4334 0.789062 23.2282 0.789062 25.7802C0.789062 28.3322 2.66663 30.1271 4.32318 31.7105C5.20281 32.5514 6.11242 33.4208 6.40031 34.1185C6.71659 34.885 6.69055 36.1933 6.6653 37.4586C6.62054 39.7052 6.5699 42.2514 8.30038 43.9904C9.39136 45.0866 10.8056 45.4771 12.2645 45.6072V65.037C12.2645 65.6959 12.5951 66.3107 13.1447 66.6742C13.694 67.0378 14.3895 67.1012 14.9957 66.8434L26.4995 61.9507L38.0035 66.8434C38.25 66.9482 38.5112 66.9999 38.7715 66.9999C39.151 66.9999 39.5284 66.8899 39.8543 66.6742C40.4038 66.3108 40.7345 65.6959 40.7345 65.037V45.6077C42.1934 45.4776 43.6075 45.087 44.6985 43.991C46.4292 42.2521 46.3785 39.7056 46.3337 37.459C46.3086 36.1937 46.2824 34.8854 46.5986 34.1192C46.8866 33.4213 47.7962 32.5518 48.6758 31.711C50.3324 30.1273 52.2099 28.3326 52.2099 25.7806C52.2099 23.2286 50.3325 21.4336 48.6759 19.8499ZM27.2676 58.0115C26.7769 57.8026 26.2221 57.8026 25.7314 58.0115L16.1903 62.0693V45.6517C16.9681 45.667 17.6775 45.7316 18.1649 45.9346C18.8626 46.2254 19.7298 47.1359 20.5683 48.0163C22.1508 49.6777 23.9442 51.5608 26.4995 51.5608C29.0548 51.5608 30.8482 49.6777 32.4306 48.0164C33.2692 47.1359 34.1364 46.2254 34.8341 45.9347C35.3216 45.7315 36.0309 45.6667 36.8087 45.6514V62.0692L27.2676 58.0115ZM45.9631 28.8732C44.7886 29.9958 43.5743 31.1567 42.9697 32.6216C42.3411 34.145 42.3755 35.8694 42.4087 37.5372C42.4379 39.0027 42.471 40.664 41.9159 41.2216C41.3588 41.7811 39.6957 41.7554 38.2281 41.7319C36.5634 41.706 34.8418 41.6788 33.3241 42.311C31.8636 42.9195 30.7066 44.1342 29.5876 45.309C28.5491 46.3993 27.3722 47.635 26.4992 47.635C25.6263 47.635 24.4493 46.3992 23.4107 45.3088C22.2918 44.1341 21.1349 42.9195 19.6744 42.3108C18.4612 41.8055 17.1179 41.7213 15.7774 41.7213C15.441 41.7213 15.1044 41.7267 14.7705 41.7319C13.3027 41.7548 11.6396 41.7813 11.0826 41.2216C10.5277 40.6639 10.5608 39.0029 10.5899 37.5372C10.6231 35.8694 10.6575 34.1448 10.0288 32.6214C9.42433 31.1567 8.20996 29.9958 7.0355 28.873C5.94753 27.8331 4.71445 26.6543 4.71445 25.7804C4.71445 24.9066 5.94753 23.7277 7.0355 22.6877C8.20996 21.5651 9.42433 20.4042 10.0289 18.9393C10.6575 17.4159 10.6231 15.6915 10.5899 14.0237C10.5607 12.558 10.5276 10.8968 11.0827 10.3392C11.6398 9.77963 13.3037 9.80554 14.7703 9.82897C16.436 9.85488 18.157 9.88223 19.6747 9.24979C21.1351 8.64142 22.292 7.42665 23.4108 6.25193C24.4495 5.16148 25.6265 3.92578 26.4995 3.92578C27.3725 3.92578 28.5495 5.16148 29.588 6.2518C30.7069 7.42665 31.8638 8.64129 33.3242 9.24965C34.842 9.8821 36.5632 9.85449 38.2285 9.82884C39.6961 9.80594 41.3592 9.77977 41.9163 10.3392C42.4711 10.8968 42.438 12.5579 42.409 14.0235C42.3757 15.6912 42.3413 17.4158 42.9701 18.9393C43.5745 20.404 44.7889 21.5648 45.9634 22.6876C47.0513 23.7275 48.2844 24.9064 48.2844 25.7803C48.2844 26.6542 47.0512 27.8331 45.9631 28.8732Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M26.4999 11.4922C18.7286 11.4922 12.4062 17.8321 12.4062 25.6249C12.4062 33.4177 18.7286 39.7577 26.4999 39.7577C34.2713 39.7577 40.5936 33.4178 40.5936 25.625C40.5936 17.8322 34.2713 11.4922 26.4999 11.4922ZM26.4999 35.8319C20.8933 35.8319 16.332 31.2531 16.332 25.625C16.332 19.9969 20.8933 15.4181 26.4999 15.4181C32.1066 15.4181 36.6678 19.9969 36.6678 25.625C36.6678 31.2531 32.1066 35.8319 26.4999 35.8319Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M28.8024 21.9187L25.2446 25.4765L24.1985 24.4304C23.4321 23.6639 22.1892 23.6639 21.4226 24.4304C20.656 25.1968 20.656 26.4397 21.4226 27.2063L23.8567 29.6404C24.2248 30.0085 24.724 30.2154 25.2446 30.2154C25.7652 30.2154 26.2645 30.0087 26.6325 29.6404L31.5782 24.6946C32.3448 23.928 32.3448 22.6853 31.5782 21.9187C30.8117 21.1521 29.5688 21.1521 28.8024 21.9187Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: 'Diligentsia Certification',
            isStar: false,
            isCertificate: true,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "53",
                    height: "67",
                    viewBox: "0 0 53 67",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M48.6759 19.8499C47.7963 19.009 46.8867 18.1396 46.5988 17.4418C46.2825 16.6754 46.3086 15.3671 46.3338 14.1019C46.3786 11.8552 46.4292 9.30893 44.6987 7.57008C42.9651 5.82808 40.4148 5.8676 38.1666 5.90371C36.904 5.92347 35.5975 5.94428 34.8342 5.62616C34.1366 5.33539 33.2694 4.42487 32.4308 3.54445C30.8482 1.88306 29.0548 0 26.4995 0C23.9442 0 22.1508 1.88306 20.5683 3.54432C19.7298 4.42487 18.8626 5.33539 18.1649 5.62603C17.4018 5.94415 16.0953 5.92347 14.8326 5.90345C12.5825 5.86904 10.034 5.82795 8.30051 7.56981C6.56977 9.30867 6.62054 11.8551 6.6653 14.1018C6.69042 15.3671 6.71659 16.6754 6.40044 17.4416C6.11242 18.1394 5.20281 19.009 4.32318 19.8498C2.66663 21.4334 0.789062 23.2282 0.789062 25.7802C0.789062 28.3322 2.66663 30.1271 4.32318 31.7105C5.20281 32.5514 6.11242 33.4208 6.40031 34.1185C6.71659 34.885 6.69055 36.1933 6.6653 37.4586C6.62054 39.7052 6.5699 42.2514 8.30038 43.9904C9.39136 45.0866 10.8056 45.4771 12.2645 45.6072V65.037C12.2645 65.6959 12.5951 66.3107 13.1447 66.6742C13.694 67.0378 14.3895 67.1012 14.9957 66.8434L26.4995 61.9507L38.0035 66.8434C38.25 66.9482 38.5112 66.9999 38.7715 66.9999C39.151 66.9999 39.5284 66.8899 39.8543 66.6742C40.4038 66.3108 40.7345 65.6959 40.7345 65.037V45.6077C42.1934 45.4776 43.6075 45.087 44.6985 43.991C46.4292 42.2521 46.3785 39.7056 46.3337 37.459C46.3086 36.1937 46.2824 34.8854 46.5986 34.1192C46.8866 33.4213 47.7962 32.5518 48.6758 31.711C50.3324 30.1273 52.2099 28.3326 52.2099 25.7806C52.2099 23.2286 50.3325 21.4336 48.6759 19.8499ZM27.2676 58.0115C26.7769 57.8026 26.2221 57.8026 25.7314 58.0115L16.1903 62.0693V45.6517C16.9681 45.667 17.6775 45.7316 18.1649 45.9346C18.8626 46.2254 19.7298 47.1359 20.5683 48.0163C22.1508 49.6777 23.9442 51.5608 26.4995 51.5608C29.0548 51.5608 30.8482 49.6777 32.4306 48.0164C33.2692 47.1359 34.1364 46.2254 34.8341 45.9347C35.3216 45.7315 36.0309 45.6667 36.8087 45.6514V62.0692L27.2676 58.0115ZM45.9631 28.8732C44.7886 29.9958 43.5743 31.1567 42.9697 32.6216C42.3411 34.145 42.3755 35.8694 42.4087 37.5372C42.4379 39.0027 42.471 40.664 41.9159 41.2216C41.3588 41.7811 39.6957 41.7554 38.2281 41.7319C36.5634 41.706 34.8418 41.6788 33.3241 42.311C31.8636 42.9195 30.7066 44.1342 29.5876 45.309C28.5491 46.3993 27.3722 47.635 26.4992 47.635C25.6263 47.635 24.4493 46.3992 23.4107 45.3088C22.2918 44.1341 21.1349 42.9195 19.6744 42.3108C18.4612 41.8055 17.1179 41.7213 15.7774 41.7213C15.441 41.7213 15.1044 41.7267 14.7705 41.7319C13.3027 41.7548 11.6396 41.7813 11.0826 41.2216C10.5277 40.6639 10.5608 39.0029 10.5899 37.5372C10.6231 35.8694 10.6575 34.1448 10.0288 32.6214C9.42433 31.1567 8.20996 29.9958 7.0355 28.873C5.94753 27.8331 4.71445 26.6543 4.71445 25.7804C4.71445 24.9066 5.94753 23.7277 7.0355 22.6877C8.20996 21.5651 9.42433 20.4042 10.0289 18.9393C10.6575 17.4159 10.6231 15.6915 10.5899 14.0237C10.5607 12.558 10.5276 10.8968 11.0827 10.3392C11.6398 9.77963 13.3037 9.80554 14.7703 9.82897C16.436 9.85488 18.157 9.88223 19.6747 9.24979C21.1351 8.64142 22.292 7.42665 23.4108 6.25193C24.4495 5.16148 25.6265 3.92578 26.4995 3.92578C27.3725 3.92578 28.5495 5.16148 29.588 6.2518C30.7069 7.42665 31.8638 8.64129 33.3242 9.24965C34.842 9.8821 36.5632 9.85449 38.2285 9.82884C39.6961 9.80594 41.3592 9.77977 41.9163 10.3392C42.4711 10.8968 42.438 12.5579 42.409 14.0235C42.3757 15.6912 42.3413 17.4158 42.9701 18.9393C43.5745 20.404 44.7889 21.5648 45.9634 22.6876C47.0513 23.7275 48.2844 24.9064 48.2844 25.7803C48.2844 26.6542 47.0512 27.8331 45.9631 28.8732Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M26.4999 11.4922C18.7286 11.4922 12.4062 17.8321 12.4062 25.6249C12.4062 33.4177 18.7286 39.7577 26.4999 39.7577C34.2713 39.7577 40.5936 33.4178 40.5936 25.625C40.5936 17.8322 34.2713 11.4922 26.4999 11.4922ZM26.4999 35.8319C20.8933 35.8319 16.332 31.2531 16.332 25.625C16.332 19.9969 20.8933 15.4181 26.4999 15.4181C32.1066 15.4181 36.6678 19.9969 36.6678 25.625C36.6678 31.2531 32.1066 35.8319 26.4999 35.8319Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M28.8024 21.9187L25.2446 25.4765L24.1985 24.4304C23.4321 23.6639 22.1892 23.6639 21.4226 24.4304C20.656 25.1968 20.656 26.4397 21.4226 27.2063L23.8567 29.6404C24.2248 30.0085 24.724 30.2154 25.2446 30.2154C25.7652 30.2154 26.2645 30.0087 26.6325 29.6404L31.5782 24.6946C32.3448 23.928 32.3448 22.6853 31.5782 21.9187C30.8117 21.1521 29.5688 21.1521 28.8024 21.9187Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: 'Diligentsia Certification',
                subMenu: {
                    index: 3,
                    points: [
                        " Bronze \u2013 basic level reached",
                        "Silver \u2013 potentially investible",
                        "Gold \u2013 sophisticated "
                    ]
                },
                points: [
                    `A simple feature to enable investors to distinguish between companies \u{2013} driving up quality and saving time on investigation`,
                    "Your companies\u2019 self-complete checklist modules and recieve certification",
                    'Detailed automated reporting, with suggestions for improvement.  Completeness and risk scoring.',
                    'Unaudited certification:',
                    'Digital certification valid for 3 months',
                    `Or, with Diligentsia Pro PLUS, have their lawyer or accountant can assist and provide you an AUDITED certificate`
                ],
                image: (parcelRequire("9WBs6")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                },
                notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        fontSize: "14px",
                        color: 'gray',
                        fontStyle: 'italic'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontWeight: "bold",
                                fontStyle: 'normal'
                            },
                            children: `Please Note: `
                        }),
                        "Diligentsia does NOT take responsiblity for the unaudited self-certification, which is indicative.  Third parties should undertake their own diligence. We remind companies, however, that third parties may seek to rely on information provided by companies in completion of our modules, and should do so accuratly and honestly with this in mind."
                    ]
                }),
                cardPaddingBottom: {
                    paddingBottom: '3rem'
                }
            }
        }
    ],
    appStoreInvestment: [
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "61",
                height: "61",
                viewBox: "0 0 61 61",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M41.5097 47.2986C42.4967 47.2986 43.2968 46.4985 43.2968 45.5115V36.5761C43.2968 35.5892 42.4967 34.7891 41.5097 34.7891C40.5228 34.7891 39.7227 35.5892 39.7227 36.5761V45.5115C39.7227 46.4985 40.5227 47.2986 41.5097 47.2986Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M41.5097 53.8515C42.4967 53.8515 43.2968 53.0514 43.2968 52.0644C43.2968 51.0774 42.4967 50.2773 41.5097 50.2773C40.5228 50.2773 39.7227 51.0774 39.7227 52.0644C39.7227 53.0514 40.5228 53.8515 41.5097 53.8515Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M60.2943 52.9947L49.8187 34.5083C50.755 31.0922 51.2296 27.567 51.2296 24.0177V4.16964C51.2296 2.81325 49.7777 1.9514 48.5869 2.60106L48.076 2.87973C41.2031 6.62879 32.6536 5.65292 26.8021 0.451565L26.8019 0.451327C26.1248 -0.150442 25.1047 -0.150442 24.4277 0.451327L24.4275 0.451565C18.576 5.65304 10.0267 6.62867 3.15372 2.87985L2.64273 2.60106C1.45194 1.9514 0 2.81325 0 4.16964V24.0177C0 31.9811 2.3599 39.6761 6.82438 46.2704C11.2891 52.8647 17.5571 57.9136 24.951 60.8712C25.3682 61.0381 25.8325 61.0405 26.2517 60.8804C26.6152 60.9573 26.9952 60.9989 27.3896 60.9989H55.6299C59.7378 60.999 62.3195 56.5686 60.2943 52.9947ZM23.8277 48.27C17.7053 44.2901 13.3882 38.1987 11.6176 31.2144H23.8277V48.27ZM23.8277 27.6403H10.9459C10.7984 26.4495 10.7225 25.2404 10.7225 24.0178V15.8434C11.169 15.8639 11.6157 15.8743 12.0604 15.8743C16.1158 15.8743 20.1304 15.0271 23.8277 13.4103V27.6403ZM24.7354 8.96974C20.8807 11.1487 16.4977 12.3004 12.0604 12.3004C11.0876 12.3004 10.105 12.244 9.1396 12.1329C8.07879 12.0106 7.14832 12.8401 7.14832 13.9079V24.0178C7.14832 35.6899 13.2668 46.2912 23.2324 52.0996L22.7252 52.9946C22.2606 53.8145 22.041 54.6793 22.0241 55.5257C10.6815 49.1987 3.57416 37.283 3.57416 24.0177V7.0366C6.29588 8.1627 9.17558 8.71562 12.0449 8.71538C16.874 8.71514 21.6705 7.14775 25.6148 4.10638C31.9028 8.95509 40.3531 10.058 47.6555 7.0366V24.0178C47.6555 25.9771 47.4964 27.9283 47.1813 29.854L46.1742 28.0768C45.6362 27.1274 44.8798 26.4293 44.0208 25.9773C44.0595 25.3235 44.0813 24.6685 44.0813 24.0178V13.9079C44.0813 12.8401 43.1509 12.0106 42.0901 12.1328C41.1248 12.2439 40.142 12.3003 39.1692 12.3003C34.7319 12.3003 30.349 11.1485 26.4942 8.96962C25.9485 8.66129 25.2811 8.66129 24.7354 8.96974ZM27.4019 27.6403V13.4104C31.0991 15.0271 35.1137 15.8744 39.1692 15.8744C39.614 15.8744 40.0606 15.8641 40.5071 15.8436V24.0179C40.5071 24.4965 40.4946 24.9779 40.471 25.459C39.1748 25.7103 37.9597 26.4384 37.1234 27.6403H27.4019ZM35.0674 31.2145L27.4019 44.7418V31.2145H35.0674ZM55.6299 57.4249H27.3897C26.0205 57.4249 25.1598 55.948 25.835 54.7568L39.9551 29.839C40.6396 28.631 42.3801 28.631 43.0647 29.839L57.1848 54.7568C57.8597 55.948 56.9991 57.4249 55.6299 57.4249Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Expansion Pack - ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Warranty Disclosure"
                ]
            }),
            isStar: true,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "61",
                    height: "61",
                    viewBox: "0 0 61 61",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M41.5097 47.2986C42.4967 47.2986 43.2968 46.4985 43.2968 45.5115V36.5761C43.2968 35.5892 42.4967 34.7891 41.5097 34.7891C40.5228 34.7891 39.7227 35.5892 39.7227 36.5761V45.5115C39.7227 46.4985 40.5227 47.2986 41.5097 47.2986Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M41.5097 53.8515C42.4967 53.8515 43.2968 53.0514 43.2968 52.0644C43.2968 51.0774 42.4967 50.2773 41.5097 50.2773C40.5228 50.2773 39.7227 51.0774 39.7227 52.0644C39.7227 53.0514 40.5228 53.8515 41.5097 53.8515Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M60.2943 52.9947L49.8187 34.5083C50.755 31.0922 51.2296 27.567 51.2296 24.0177V4.16964C51.2296 2.81325 49.7777 1.9514 48.5869 2.60106L48.076 2.87973C41.2031 6.62879 32.6536 5.65292 26.8021 0.451565L26.8019 0.451327C26.1248 -0.150442 25.1047 -0.150442 24.4277 0.451327L24.4275 0.451565C18.576 5.65304 10.0267 6.62867 3.15372 2.87985L2.64273 2.60106C1.45194 1.9514 0 2.81325 0 4.16964V24.0177C0 31.9811 2.3599 39.6761 6.82438 46.2704C11.2891 52.8647 17.5571 57.9136 24.951 60.8712C25.3682 61.0381 25.8325 61.0405 26.2517 60.8804C26.6152 60.9573 26.9952 60.9989 27.3896 60.9989H55.6299C59.7378 60.999 62.3195 56.5686 60.2943 52.9947ZM23.8277 48.27C17.7053 44.2901 13.3882 38.1987 11.6176 31.2144H23.8277V48.27ZM23.8277 27.6403H10.9459C10.7984 26.4495 10.7225 25.2404 10.7225 24.0178V15.8434C11.169 15.8639 11.6157 15.8743 12.0604 15.8743C16.1158 15.8743 20.1304 15.0271 23.8277 13.4103V27.6403ZM24.7354 8.96974C20.8807 11.1487 16.4977 12.3004 12.0604 12.3004C11.0876 12.3004 10.105 12.244 9.1396 12.1329C8.07879 12.0106 7.14832 12.8401 7.14832 13.9079V24.0178C7.14832 35.6899 13.2668 46.2912 23.2324 52.0996L22.7252 52.9946C22.2606 53.8145 22.041 54.6793 22.0241 55.5257C10.6815 49.1987 3.57416 37.283 3.57416 24.0177V7.0366C6.29588 8.1627 9.17558 8.71562 12.0449 8.71538C16.874 8.71514 21.6705 7.14775 25.6148 4.10638C31.9028 8.95509 40.3531 10.058 47.6555 7.0366V24.0178C47.6555 25.9771 47.4964 27.9283 47.1813 29.854L46.1742 28.0768C45.6362 27.1274 44.8798 26.4293 44.0208 25.9773C44.0595 25.3235 44.0813 24.6685 44.0813 24.0178V13.9079C44.0813 12.8401 43.1509 12.0106 42.0901 12.1328C41.1248 12.2439 40.142 12.3003 39.1692 12.3003C34.7319 12.3003 30.349 11.1485 26.4942 8.96962C25.9485 8.66129 25.2811 8.66129 24.7354 8.96974ZM27.4019 27.6403V13.4104C31.0991 15.0271 35.1137 15.8744 39.1692 15.8744C39.614 15.8744 40.0606 15.8641 40.5071 15.8436V24.0179C40.5071 24.4965 40.4946 24.9779 40.471 25.459C39.1748 25.7103 37.9597 26.4384 37.1234 27.6403H27.4019ZM35.0674 31.2145L27.4019 44.7418V31.2145H35.0674ZM55.6299 57.4249H27.3897C26.0205 57.4249 25.1598 55.948 25.835 54.7568L39.9551 29.839C40.6396 28.631 42.3801 28.631 43.0647 29.839L57.1848 54.7568C57.8597 55.948 56.9991 57.4249 55.6299 57.4249Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Expansion Pack - ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Warranty Disclosure"
                    ]
                }),
                points: [
                    'Quick way of uncovering issues prior to your investment',
                    'Normally an expensive exercise at the end of a transaction',
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "Get ahead, early completion will identify showstoppers and give the company time to fix them"
                    }),
                    'Can upload supporting files and notes',
                    'Based on the UK BVCA standard disclosure letter',
                    'At a glance section completion and risk scoring',
                    'Contributes to Diligentsia certification',
                    'Part of DD Pack made available to you',
                    'Still subject to formal legal review later in investment/exit process'
                ],
                image: (parcelRequire("bnaJ5")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                },
                cardPaddingBottom: {
                    paddingBottom: '2rem'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Expansion Pack - ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Directors\u2019 Questionnaires"
                ]
            }),
            isStar: true,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "83",
                    height: "83",
                    viewBox: "0 0 83 83",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Expansion Pack - ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Directors\u2019 Questionnaires"
                    ]
                }),
                points: [
                    'Quick way of uncovering issues prior to your investment',
                    'Normally part of purchase/sale or investment',
                    'Identify any issues in advance - time for rectificaton',
                    'Pre-population from Companies House where relevant to save time',
                    'Completeness and risk scoring',
                    'Impress your counterparty with your organisation',
                    'Contributes to Diligentsia certification',
                    'Still subject to formal legal review later in investment/exit process'
                ],
                image: (parcelRequire("3e8So")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M52.2423 4.99072C38.0392 4.99072 26.4843 16.5456 26.4843 30.7488C26.4843 35.4433 27.7474 39.8481 29.9507 43.6424L6.94712 66.646C4.35096 69.242 4.35096 73.4662 6.94712 76.0622C8.24505 77.3603 9.95015 78.0093 11.6551 78.0093C13.3601 78.0093 15.0653 77.3604 16.3631 76.0622L39.3714 53.0538C43.1605 55.2488 47.557 56.5066 52.242 56.5066C66.4452 56.5066 78.0001 44.9516 78.0001 30.7486C78.0001 16.5456 66.4454 4.99072 52.2423 4.99072ZM13.3351 73.0341C12.4087 73.9605 10.9015 73.9605 9.97525 73.0342C9.04897 72.1079 9.04897 70.6007 9.97525 69.6742L11.4192 68.2303L14.7791 71.5901L13.3351 73.0341ZM17.8072 68.5621L14.4474 65.2023L16.7667 62.8829L20.1265 66.2429L17.8072 68.5621ZM23.1545 63.2147L19.7947 59.8547L32.4432 47.2062C33.4586 48.4257 34.5841 49.5505 35.8046 50.5646L23.1545 63.2147ZM52.2423 52.2242C40.4006 52.2242 30.7669 42.5903 30.7669 30.7488C30.7669 18.9072 40.4006 9.27329 52.2423 9.27329C64.084 9.27329 73.7178 18.907 73.7178 30.7488C73.7178 42.5905 64.084 52.2242 52.2423 52.2242Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M64.3496 34.2106C64.3496 33.028 63.391 32.0693 62.2084 32.0693L43.3429 32.0693C42.1604 32.0693 41.2017 33.028 41.2017 34.2105C41.2017 35.3931 42.1604 36.3518 43.3429 36.3518L62.2084 36.3518C63.391 36.3519 64.3496 35.3931 64.3496 34.2106Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M59.5693 27.026C59.5693 25.8434 58.6107 24.8848 57.4281 24.8848L43.215 24.8848C42.0325 24.8848 41.0738 25.8434 41.0738 27.026C41.0738 28.2085 42.0325 29.1672 43.215 29.1672L57.4281 29.1672C58.6107 29.1673 59.5693 28.2085 59.5693 27.026Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M64.2217 19.5357C64.2217 18.3532 63.263 17.3945 62.0805 17.3945L43.215 17.3945C42.0324 17.3945 41.0738 18.3532 41.0738 19.5357C41.0738 20.7183 42.0324 21.677 43.215 21.677L62.0805 21.677C63.263 21.6771 64.2217 20.7183 64.2217 19.5357Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: `Due Diligence Pack`,
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "83",
                    height: "83",
                    viewBox: "0 0 83 83",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M52.2423 4.99219C38.0392 4.99219 26.4843 16.5471 26.4843 30.7502C26.4843 35.4448 27.7474 39.8496 29.9507 43.6439L6.94712 66.6474C4.35096 69.2434 4.35096 73.4677 6.94712 76.0637C8.24505 77.3618 9.95015 78.0108 11.6551 78.0108C13.3601 78.0108 15.0653 77.3619 16.3631 76.0637L39.3714 53.0553C43.1605 55.2502 47.557 56.5081 52.242 56.5081C66.4452 56.5081 78.0001 44.953 78.0001 30.7501C78.0001 16.5471 66.4454 4.99219 52.2423 4.99219ZM13.3351 73.0356C12.4087 73.962 10.9015 73.962 9.97525 73.0357C9.04897 72.1094 9.04897 70.6021 9.97525 69.6757L11.4192 68.2317L14.7791 71.5916L13.3351 73.0356ZM17.8072 68.5636L14.4474 65.2037L16.7667 62.8844L20.1265 66.2444L17.8072 68.5636ZM23.1545 63.2161L19.7947 59.8561L32.4432 47.2076C33.4586 48.4271 34.5841 49.5519 35.8046 50.5661L23.1545 63.2161ZM52.2423 52.2257C40.4006 52.2257 30.7669 42.5918 30.7669 30.7502C30.7669 18.9087 40.4006 9.27476 52.2423 9.27476C64.084 9.27476 73.7178 18.9085 73.7178 30.7502C73.7178 42.5919 64.084 52.2257 52.2423 52.2257Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M59.5703 27.024C59.5703 25.8415 58.6117 24.8828 57.4291 24.8828L43.216 24.8828C42.0334 24.8828 41.0748 25.8415 41.0748 27.024C41.0748 28.2066 42.0334 29.1652 43.216 29.1652L57.4291 29.1652C58.6117 29.1654 59.5703 28.2066 59.5703 27.024Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M64.2187 19.5318C64.2187 18.3493 63.2601 17.3906 62.0775 17.3906L43.2121 17.3906C42.0295 17.3906 41.0709 18.3493 41.0709 19.5318C41.0709 20.7144 42.0295 21.6731 43.2121 21.6731L62.0775 21.6731C63.2601 21.6732 64.2187 20.7144 64.2187 19.5318Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: `Due Diligence Pack`,
                subMenu: {
                    index: 0,
                    points: [
                        '- Data Repository Report',
                        '- 20-sections Business Audit',
                        "- Directors\u2019 questionnaires",
                        '- Draft Warranty Disclosures '
                    ]
                },
                points: [
                    `Pulls together a complete pack of each of the key completed modules' reports:`,
                    `Tracks the sending of the DD Pack to investors introduced through the platform`
                ],
                notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        fontSize: "14px",
                        color: 'gray',
                        fontStyle: 'italic'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontWeight: "bold",
                                fontStyle: 'normal'
                            },
                            children: `Please Note: `
                        }),
                        "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation. Parties looking for more assurance should take additional external professional advice"
                    ]
                }),
                image: (parcelRequire("7J3ig")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "69",
                height: "67",
                viewBox: "0 0 69 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                        fill: "#4A67FF",
                        stroke: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                        fill: "#4A67FF",
                        stroke: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Investor Leads ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Database"
                ]
            }),
            isStar: false,
            isGoldCertificate: true,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "69",
                    height: "67",
                    viewBox: "0 0 69 67",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Investor Leads ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Database"
                    ]
                }),
                subMenu: {
                    index: 3,
                    points: [
                        '- Data Repository Report',
                        '- 20-section Business Audit',
                        "- Directors\u2019 questionnaires",
                        '- Draft Warranty Disclosures'
                    ]
                },
                points: [
                    'Open to Diligentsia gold certification only',
                    `Matches applicants' investment requirements against your stated investment criteria  - if you subscribe FREE to our platform`,
                    "A \u201CFit Report\u201D which shows each the party the Fit with the other",
                    'Supported with a comprehensive  Due Diligence Pack, already completed:'
                ],
                image: (parcelRequire("3i2EE")),
                notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        fontSize: "14px",
                        color: 'gray',
                        fontStyle: 'italic'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            style: {
                                fontWeight: "bold",
                                fontStyle: 'normal'
                            },
                            children: `Please Note: `
                        }),
                        "Diligentsia does NOT give investment advice, nor do we generate revenue from successful introductions via our platform.  Nor do we take responsiblity for the contents of the diligence packs - we merely provice the tools for their generation.  Parties looking for more assurance should take additional external professional advice"
                    ]
                }),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        }
    ],
    appStoreGrowth: [
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "68",
                height: "67",
                viewBox: "0 0 68 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M64.0352 39.6001C64.0352 38.9205 63.6512 38.2993 63.0434 37.9955L57.8805 35.4141L63.0434 32.8326C63.6512 32.5288 64.0352 31.9076 64.0352 31.2281C64.0352 30.5485 63.6512 29.9273 63.0434 29.6235L49.5381 22.8709C49.4693 22.3346 49.1618 21.8353 48.6573 21.544L47.1862 20.6946C47.256 20.1359 47.2911 19.579 47.2911 19.0288C47.2911 18.4787 47.256 17.9218 47.1862 17.363L48.6573 16.5136C49.5155 16.0181 49.8094 14.9211 49.3139 14.063L45.7259 7.84849C45.2304 6.99036 44.1333 6.69626 43.2753 7.19189L41.7979 8.04476C40.9022 7.36555 39.9398 6.80582 38.9191 6.37035V4.67682C38.9191 3.68605 38.1159 2.88281 37.1251 2.88281H29.9491C28.9583 2.88281 28.1551 3.68605 28.1551 4.67682V6.37035C27.1344 6.80582 26.172 7.36555 25.2763 8.04476L23.7989 7.19189C22.9405 6.69626 21.8436 6.99048 21.3483 7.84849L17.7603 14.063C17.2648 14.9211 17.5588 16.0183 18.4169 16.5136L19.888 17.363C19.8183 17.9218 19.7831 18.4787 19.7831 19.0288C19.7831 19.579 19.8183 20.1359 19.888 20.6946L18.4169 21.544C17.9125 21.8353 17.6049 22.3347 17.5362 22.8709L4.03079 29.6235C3.42298 29.9273 3.03906 30.5485 3.03906 31.2281C3.03906 31.9076 3.42298 32.5288 4.03079 32.8326L9.19369 35.4141L4.03079 37.9955C3.42298 38.2993 3.03906 38.9205 3.03906 39.6001C3.03906 40.2796 3.42298 40.9008 4.03079 41.2046L9.19369 43.7861L4.03079 46.3675C3.42298 46.6713 3.03906 47.2925 3.03906 47.9721C3.03906 48.6516 3.42298 49.2729 4.03079 49.5766L32.7348 63.9287C32.9873 64.055 33.2621 64.1181 33.5371 64.1181C33.8121 64.1181 34.0869 64.055 34.3394 63.9287L63.0434 49.5766C63.6512 49.2729 64.0352 48.6516 64.0352 47.9721C64.0352 47.2925 63.6512 46.6713 63.0434 46.3675L57.8805 43.7861L63.0434 41.2046C63.6512 40.9008 64.0352 40.2796 64.0352 39.6001ZM23.6189 21.2352C23.4545 20.4926 23.3711 19.7503 23.3711 19.0288C23.3711 18.3074 23.4545 17.5651 23.6189 16.8225C23.7883 16.0581 23.4424 15.2722 22.7644 14.8809L21.7645 14.3036L23.5585 11.1963L24.5658 11.7777C25.2444 12.1694 26.0983 12.0755 26.6756 11.5459C27.7965 10.5176 29.0788 9.77202 30.4867 9.32974C31.2344 9.09473 31.7431 8.40188 31.7431 7.61814V6.47082H35.3311V7.61814C35.3311 8.40188 35.8398 9.09485 36.5875 9.32974C37.9954 9.77202 39.2777 10.5177 40.3986 11.5459C40.9758 12.0755 41.8298 12.1694 42.5084 11.7777L43.5157 11.1963L45.3097 14.3036L44.3099 14.8809C43.6318 15.2722 43.286 16.0582 43.4553 16.8225C43.6198 17.5651 43.7031 18.3074 43.7031 19.0288C43.7031 19.7503 43.6198 20.4926 43.4553 21.2352C43.286 21.9996 43.6318 22.7855 44.3099 23.1768L45.3097 23.7541L43.5157 26.8613L42.5084 26.2798C41.8298 25.8881 40.9756 25.982 40.3986 26.5116C39.2778 27.5399 37.9956 28.2857 36.5875 28.7279C35.8398 28.9628 35.3311 29.6558 35.3311 30.4395V31.5869H31.7431V30.4395C31.7431 29.6558 31.2344 28.9628 30.4867 28.7279C29.0787 28.2857 27.7964 27.5398 26.6756 26.5116C26.0986 25.982 25.2444 25.888 24.5658 26.2798L23.5585 26.8613L21.7645 23.7541L22.7644 23.1768C23.4425 22.7855 23.7883 21.9996 23.6189 21.2352ZM8.84457 31.2281L19.0038 26.1484L21.3483 30.2091C21.8438 31.0673 22.941 31.3613 23.7989 30.8657L25.2763 30.0127C26.172 30.692 27.1344 31.2516 28.1551 31.6872V33.3809C28.1551 34.3716 28.9583 35.1749 29.9491 35.1749H37.1251C38.1159 35.1749 38.9191 34.3716 38.9191 33.3809V31.6873C39.9398 31.2517 40.9022 30.6921 41.7979 30.0128L43.2753 30.8658C44.1332 31.3613 45.2305 31.0672 45.7259 30.2092L48.0704 26.1485L58.2296 31.2281L33.5371 43.5743L8.84457 31.2281ZM58.2296 47.9721L33.5371 60.3183L8.84457 47.9721L13.2051 45.7918L32.7348 55.5566C32.9873 55.6829 33.2621 55.7461 33.5371 55.7461C33.8121 55.7461 34.0869 55.6829 34.3394 55.5566L53.8691 45.7918L58.2296 47.9721ZM33.5371 51.9463L8.84457 39.6001L13.2051 37.4198L32.7348 47.1846C32.9873 47.3109 33.2621 47.3741 33.5371 47.3741C33.8121 47.3741 34.0869 47.3109 34.3394 47.1846L53.8691 37.4198L58.2296 39.6001L33.5371 51.9463Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M33.5389 25.6091C37.1661 25.6091 40.117 22.6582 40.117 19.0311C40.117 15.404 37.1661 12.4531 33.5389 12.4531C29.9118 12.4531 26.9609 15.404 26.9609 19.0311C26.9609 22.6582 29.9118 25.6091 33.5389 25.6091ZM33.5389 16.0411C35.1876 16.0411 36.529 17.3824 36.529 19.0311C36.529 20.6798 35.1876 22.0211 33.5389 22.0211C31.8903 22.0211 30.5489 20.6798 30.5489 19.0311C30.5489 17.3824 31.8903 16.0411 33.5389 16.0411Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Expansion Pack - ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " Software Development"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "68",
                    height: "67",
                    viewBox: "0 0 68 67",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M64.0352 39.6001C64.0352 38.9205 63.6512 38.2993 63.0434 37.9955L57.8805 35.4141L63.0434 32.8326C63.6512 32.5288 64.0352 31.9076 64.0352 31.2281C64.0352 30.5485 63.6512 29.9273 63.0434 29.6235L49.5381 22.8709C49.4693 22.3346 49.1618 21.8353 48.6573 21.544L47.1862 20.6946C47.256 20.1359 47.2911 19.579 47.2911 19.0288C47.2911 18.4787 47.256 17.9218 47.1862 17.363L48.6573 16.5136C49.5155 16.0181 49.8094 14.9211 49.3139 14.063L45.7259 7.84849C45.2304 6.99036 44.1333 6.69626 43.2753 7.19189L41.7979 8.04476C40.9022 7.36555 39.9398 6.80582 38.9191 6.37035V4.67682C38.9191 3.68605 38.1159 2.88281 37.1251 2.88281H29.9491C28.9583 2.88281 28.1551 3.68605 28.1551 4.67682V6.37035C27.1344 6.80582 26.172 7.36555 25.2763 8.04476L23.7989 7.19189C22.9405 6.69626 21.8436 6.99048 21.3483 7.84849L17.7603 14.063C17.2648 14.9211 17.5588 16.0183 18.4169 16.5136L19.888 17.363C19.8183 17.9218 19.7831 18.4787 19.7831 19.0288C19.7831 19.579 19.8183 20.1359 19.888 20.6946L18.4169 21.544C17.9125 21.8353 17.6049 22.3347 17.5362 22.8709L4.03079 29.6235C3.42298 29.9273 3.03906 30.5485 3.03906 31.2281C3.03906 31.9076 3.42298 32.5288 4.03079 32.8326L9.19369 35.4141L4.03079 37.9955C3.42298 38.2993 3.03906 38.9205 3.03906 39.6001C3.03906 40.2796 3.42298 40.9008 4.03079 41.2046L9.19369 43.7861L4.03079 46.3675C3.42298 46.6713 3.03906 47.2925 3.03906 47.9721C3.03906 48.6516 3.42298 49.2729 4.03079 49.5766L32.7348 63.9287C32.9873 64.055 33.2621 64.1181 33.5371 64.1181C33.8121 64.1181 34.0869 64.055 34.3394 63.9287L63.0434 49.5766C63.6512 49.2729 64.0352 48.6516 64.0352 47.9721C64.0352 47.2925 63.6512 46.6713 63.0434 46.3675L57.8805 43.7861L63.0434 41.2046C63.6512 40.9008 64.0352 40.2796 64.0352 39.6001ZM23.6189 21.2352C23.4545 20.4926 23.3711 19.7503 23.3711 19.0288C23.3711 18.3074 23.4545 17.5651 23.6189 16.8225C23.7883 16.0581 23.4424 15.2722 22.7644 14.8809L21.7645 14.3036L23.5585 11.1963L24.5658 11.7777C25.2444 12.1694 26.0983 12.0755 26.6756 11.5459C27.7965 10.5176 29.0788 9.77202 30.4867 9.32974C31.2344 9.09473 31.7431 8.40188 31.7431 7.61814V6.47082H35.3311V7.61814C35.3311 8.40188 35.8398 9.09485 36.5875 9.32974C37.9954 9.77202 39.2777 10.5177 40.3986 11.5459C40.9758 12.0755 41.8298 12.1694 42.5084 11.7777L43.5157 11.1963L45.3097 14.3036L44.3099 14.8809C43.6318 15.2722 43.286 16.0582 43.4553 16.8225C43.6198 17.5651 43.7031 18.3074 43.7031 19.0288C43.7031 19.7503 43.6198 20.4926 43.4553 21.2352C43.286 21.9996 43.6318 22.7855 44.3099 23.1768L45.3097 23.7541L43.5157 26.8613L42.5084 26.2798C41.8298 25.8881 40.9756 25.982 40.3986 26.5116C39.2778 27.5399 37.9956 28.2857 36.5875 28.7279C35.8398 28.9628 35.3311 29.6558 35.3311 30.4395V31.5869H31.7431V30.4395C31.7431 29.6558 31.2344 28.9628 30.4867 28.7279C29.0787 28.2857 27.7964 27.5398 26.6756 26.5116C26.0986 25.982 25.2444 25.888 24.5658 26.2798L23.5585 26.8613L21.7645 23.7541L22.7644 23.1768C23.4425 22.7855 23.7883 21.9996 23.6189 21.2352ZM8.84457 31.2281L19.0038 26.1484L21.3483 30.2091C21.8438 31.0673 22.941 31.3613 23.7989 30.8657L25.2763 30.0127C26.172 30.692 27.1344 31.2516 28.1551 31.6872V33.3809C28.1551 34.3716 28.9583 35.1749 29.9491 35.1749H37.1251C38.1159 35.1749 38.9191 34.3716 38.9191 33.3809V31.6873C39.9398 31.2517 40.9022 30.6921 41.7979 30.0128L43.2753 30.8658C44.1332 31.3613 45.2305 31.0672 45.7259 30.2092L48.0704 26.1485L58.2296 31.2281L33.5371 43.5743L8.84457 31.2281ZM58.2296 47.9721L33.5371 60.3183L8.84457 47.9721L13.2051 45.7918L32.7348 55.5566C32.9873 55.6829 33.2621 55.7461 33.5371 55.7461C33.8121 55.7461 34.0869 55.6829 34.3394 55.5566L53.8691 45.7918L58.2296 47.9721ZM33.5371 51.9463L8.84457 39.6001L13.2051 37.4198L32.7348 47.1846C32.9873 47.3109 33.2621 47.3741 33.5371 47.3741C33.8121 47.3741 34.0869 47.3109 34.3394 47.1846L53.8691 37.4198L58.2296 39.6001L33.5371 51.9463Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M33.5389 25.6091C37.1661 25.6091 40.117 22.6582 40.117 19.0311C40.117 15.404 37.1661 12.4531 33.5389 12.4531C29.9118 12.4531 26.9609 15.404 26.9609 19.0311C26.9609 22.6582 29.9118 25.6091 33.5389 25.6091ZM33.5389 16.0411C35.1876 16.0411 36.529 17.3824 36.529 19.0311C36.529 20.6798 35.1876 22.0211 33.5389 22.0211C31.8903 22.0211 30.5489 20.6798 30.5489 19.0311C30.5489 17.3824 31.8903 16.0411 33.5389 16.0411Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Expansion Pack - ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Software Development"
                    ]
                }),
                points: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Aimed at: "
                            }),
                            " software development companies wishing to undertake an in depth audit of their software development structure, processes and protections"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "14 sections - "
                            }),
                            " I.T. Staff, Products & Services, Software Development Process, Software & Services Utilised, Hardware, Network Infrastructure, Backup & Recovery, Documentation,Network Security.Cybersecurity Compliance, Agreements, Quality, Financial"
                        ]
                    }),
                    'Completeness and risk scoring',
                    'Automated reporting - including risks and recommendations',
                    'Tailored to business objectives',
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Benefit: "
                            }),
                            " working though these questions will strengthen the business, identify weaknesses, and giving you an opportunity to plug them prior to being subject to due diligence over a key area of your business"
                        ]
                    })
                ],
                image: (parcelRequire("8QUJK")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "67",
                height: "67",
                viewBox: "0 0 67 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    "clip-path": "url(#clip0_1533_32239)",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M21.5997 27.9316C22.1418 27.9316 22.5812 27.4923 22.5812 26.9502C22.5812 26.408 22.1418 25.9688 21.5997 25.9688H16.1689C15.6269 25.9688 15.1875 26.408 15.1875 26.9502V39.8724C15.1875 40.4146 15.6269 40.8539 16.1689 40.8539H21.5997C22.1418 40.8539 22.5812 40.4146 22.5812 39.8724C22.5812 39.3303 22.1418 38.891 21.5997 38.891H17.1504V34.3927H21.1992C21.7412 34.3927 22.1806 33.9534 22.1806 33.4112C22.1806 32.8692 21.7412 32.4298 21.1992 32.4298H17.1504V27.9316H21.5997Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M50.826 32.4347H46.9349C46.3927 32.4347 45.9534 32.8741 45.9534 33.4161C45.9534 33.9583 46.3927 34.3975 46.9349 34.3975H49.7845C49.5031 36.6774 48.1996 38.9554 45.2117 38.9554C42.1666 38.9554 39.6895 36.4705 39.6895 33.4161C39.6895 30.3617 42.1668 27.877 45.2117 27.877C46.318 27.877 47.385 28.2036 48.2975 28.8218C48.7465 29.1257 49.3566 29.0082 49.6605 28.5595C49.9644 28.1107 49.8471 27.5005 49.3983 27.1965C48.1596 26.3575 46.7119 25.9141 45.2117 25.9141C41.0844 25.9141 37.7266 29.2795 37.7266 33.4161C37.7266 37.5528 41.0844 40.9183 45.2117 40.9183C49.0952 40.9183 51.8074 37.8333 51.8074 33.4161C51.8074 32.8739 51.368 32.4347 50.826 32.4347Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M31.9293 32.5995C30.2253 31.9693 28.647 31.2806 28.2836 31.1202C27.8016 30.7754 27.5668 30.2175 27.6537 29.6136C27.7595 28.878 28.3155 28.2902 29.141 28.0409C31.3242 27.3818 33.2803 28.9623 33.3142 28.9902C33.7286 29.3367 34.3458 29.2833 34.6942 28.8697C35.0435 28.4552 34.9908 27.8361 34.5762 27.4867C34.4643 27.3924 31.7982 25.1879 28.5736 26.1619C27.0218 26.6305 25.925 27.8461 25.711 29.3342C25.5122 30.7163 26.1088 32.0455 27.268 32.8032C27.3114 32.8314 27.357 32.8563 27.4042 32.8775C27.4786 32.9107 29.251 33.7018 31.2486 34.4405C32.7774 35.0058 33.5491 35.9171 33.3659 36.9407C33.1911 37.9179 32.1129 38.9563 30.4596 38.9563C28.9884 38.9563 27.5661 38.3545 26.6549 37.3463C26.2914 36.9443 25.6707 36.9127 25.2687 37.2763C24.8666 37.6397 24.8352 38.2605 25.1987 38.6626C26.4757 40.0757 28.4424 40.9192 30.4596 40.9192C32.8474 40.9192 34.9274 39.3574 35.2982 37.2865C35.5771 35.7262 34.8388 33.6755 31.9293 32.5995Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M58.3116 10.8509C52.7477 4.70627 45.1676 0.856514 36.9676 0.0107693C36.9676 0.0107693 36.9676 0.0107693 36.9676 0.0106384C36.3851 -0.0483792 35.8033 0.140974 35.3691 0.532506C34.9353 0.923906 34.6864 1.48385 34.6864 2.0684V4.2018C33.897 4.1704 33.1028 4.1704 32.3135 4.2018V2.06853C32.3135 1.48385 32.0647 0.924037 31.6308 0.532636C31.1967 0.140974 30.614 -0.0491643 30.0324 0.0109001C21.8324 0.856514 14.2524 4.70627 8.68828 10.8509C3.08553 17.0382 0 25.0516 0 33.415C0 38.1806 0.977258 42.7879 2.90469 47.1088C3.1435 47.6444 3.59994 48.055 4.15701 48.2353C4.36403 48.3025 4.57825 48.3356 4.79194 48.3356C5.15154 48.3356 5.50918 48.2417 5.82625 48.0583L7.666 46.9933C8.03424 47.6958 8.43205 48.385 8.8563 49.0558L7.01459 50.1219C6.50986 50.414 6.15065 50.9092 6.02921 51.4801C5.90712 52.0543 6.03484 52.6565 6.37979 53.1327C7.84698 55.1575 9.54318 57.0216 11.4214 58.6731C11.8284 59.031 12.4485 58.9913 12.8066 58.5841C13.1645 58.1771 13.1247 57.5568 12.7176 57.1989C10.9486 55.6435 9.35095 53.8879 7.9692 51.9811C7.94879 51.9528 7.94199 51.9218 7.94905 51.8885C7.95861 51.8434 7.98805 51.8264 7.99786 51.8208L13.7455 48.4935L13.7478 48.4772C18.2877 54.4459 25.4521 58.3055 33.5 58.3055C41.5459 58.3055 48.7089 54.4479 53.2488 48.4817C53.2526 48.4896 53.2545 48.4938 53.2545 48.4938L59.002 51.8208C59.0117 51.8264 59.0413 51.8435 59.0508 51.8888C59.0579 51.922 59.0512 51.953 59.0308 51.9812C53.1072 60.1564 43.5631 65.037 33.5 65.037C27.4847 65.037 21.636 63.333 16.5864 60.1091C16.1297 59.8174 15.5229 59.9513 15.2311 60.4081C14.9394 60.865 15.0733 61.4719 15.5301 61.7634C20.8958 65.1892 27.1096 66.9999 33.5 66.9999C38.8773 66.9999 44.2234 65.6917 48.9604 63.2165C53.5436 60.8218 57.5756 57.335 60.6203 53.1329C60.9652 52.6569 61.093 52.0549 60.971 51.4808C60.8496 50.9097 60.4905 50.4145 59.9857 50.1221L58.1438 49.056C58.5683 48.3849 58.9662 47.6957 59.3343 46.9936L61.174 48.0585C61.4911 48.242 61.8486 48.3358 62.2082 48.3358C62.4218 48.3358 62.6362 48.3027 62.8433 48.2356C63.4002 48.0551 63.8566 47.6445 64.0954 47.1092C66.0226 42.7878 67 38.1805 67 33.415C67 25.0516 63.9145 17.0382 58.3116 10.8509ZM34.6864 6.16705V8.55366C34.2931 8.53508 33.8977 8.52461 33.5 8.52461C33.1039 8.52461 32.7084 8.53718 32.3135 8.55615V6.16705C33.1027 6.13329 33.8973 6.13329 34.6864 6.16705ZM10.5568 48.0715C10.1306 47.4019 9.7328 46.7124 9.36665 46.0089L11.4321 44.8132C11.7972 45.5208 12.195 46.2087 12.6239 46.8749L10.5568 48.0715ZM33.5 56.3426C20.892 56.3426 10.6345 46.0573 10.6345 33.415C10.6345 26.5315 13.6793 20.0732 18.9878 15.6964C19.4061 15.3514 19.4656 14.733 19.1208 14.3146C18.7761 13.8967 18.1574 13.8371 17.7392 14.1817C11.9766 18.9329 8.67179 25.9432 8.67179 33.415C8.67179 36.8213 9.35854 40.0697 10.5995 43.0292L4.84311 46.3595C4.83355 46.365 4.80476 46.3816 4.7621 46.3681C4.7324 46.3584 4.71068 46.3387 4.69759 46.3092C2.88296 42.2416 1.96289 37.9033 1.96289 33.415C1.96289 17.1471 14.1167 3.62576 30.2337 1.96332C30.2654 1.95979 30.2928 1.96895 30.3159 1.99002C30.339 2.01069 30.3506 2.03713 30.3506 2.06853V8.72692C27.3316 9.11361 24.3957 10.0515 21.724 11.497C21.2472 11.755 21.0698 12.3504 21.3279 12.8273C21.5858 13.3039 22.1813 13.4812 22.658 13.2234C25.9663 11.4335 29.7154 10.4875 33.5 10.4875C46.1082 10.4875 56.3655 20.7728 56.3655 33.415C56.3655 46.0573 46.1082 56.3426 33.5 56.3426ZM56.4431 48.0714L54.376 46.8748C54.8048 46.2086 55.2026 45.5207 55.5677 44.8131L57.6332 46.0086C57.2673 46.712 56.8694 47.4015 56.4431 48.0714ZM62.3025 46.3093C62.2893 46.3388 62.2677 46.3584 62.238 46.3681C62.1959 46.3817 62.1666 46.3651 62.1572 46.3595L56.4063 43.0305C56.4063 43.0305 56.4017 43.0325 56.3988 43.0337C57.6409 40.073 58.3283 36.823 58.3283 33.4149C58.3283 20.7596 48.8583 10.28 36.6493 8.72378V2.06853C36.6493 2.03726 36.6609 2.01082 36.6839 1.99002C36.7074 1.96895 36.7359 1.9594 36.7663 1.96332V1.96319C52.8818 3.62707 65.0371 17.148 65.0371 33.415C65.0371 37.9032 64.1172 42.2414 62.3025 46.3093Z",
                            fill: "#4A67FF",
                            stroke: "#4A67FF"
                        })
                    ]
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Expansion Pack - ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " ESG"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "67",
                    height: "67",
                    viewBox: "0 0 67 67",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        "clip-path": "url(#clip0_1533_32239)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.5997 27.9316C22.1418 27.9316 22.5812 27.4923 22.5812 26.9502C22.5812 26.408 22.1418 25.9688 21.5997 25.9688H16.1689C15.6269 25.9688 15.1875 26.408 15.1875 26.9502V39.8724C15.1875 40.4146 15.6269 40.8539 16.1689 40.8539H21.5997C22.1418 40.8539 22.5812 40.4146 22.5812 39.8724C22.5812 39.3303 22.1418 38.891 21.5997 38.891H17.1504V34.3927H21.1992C21.7412 34.3927 22.1806 33.9534 22.1806 33.4112C22.1806 32.8692 21.7412 32.4298 21.1992 32.4298H17.1504V27.9316H21.5997Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M50.826 32.4347H46.9349C46.3927 32.4347 45.9534 32.8741 45.9534 33.4161C45.9534 33.9583 46.3927 34.3975 46.9349 34.3975H49.7845C49.5031 36.6774 48.1996 38.9554 45.2117 38.9554C42.1666 38.9554 39.6895 36.4705 39.6895 33.4161C39.6895 30.3617 42.1668 27.877 45.2117 27.877C46.318 27.877 47.385 28.2036 48.2975 28.8218C48.7465 29.1257 49.3566 29.0082 49.6605 28.5595C49.9644 28.1107 49.8471 27.5005 49.3983 27.1965C48.1596 26.3575 46.7119 25.9141 45.2117 25.9141C41.0844 25.9141 37.7266 29.2795 37.7266 33.4161C37.7266 37.5528 41.0844 40.9183 45.2117 40.9183C49.0952 40.9183 51.8074 37.8333 51.8074 33.4161C51.8074 32.8739 51.368 32.4347 50.826 32.4347Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M31.9293 32.5995C30.2253 31.9693 28.647 31.2806 28.2836 31.1202C27.8016 30.7754 27.5668 30.2175 27.6537 29.6136C27.7595 28.878 28.3155 28.2902 29.141 28.0409C31.3242 27.3818 33.2803 28.9623 33.3142 28.9902C33.7286 29.3367 34.3458 29.2833 34.6942 28.8697C35.0435 28.4552 34.9908 27.8361 34.5762 27.4867C34.4643 27.3924 31.7982 25.1879 28.5736 26.1619C27.0218 26.6305 25.925 27.8461 25.711 29.3342C25.5122 30.7163 26.1088 32.0455 27.268 32.8032C27.3114 32.8314 27.357 32.8563 27.4042 32.8775C27.4786 32.9107 29.251 33.7018 31.2486 34.4405C32.7774 35.0058 33.5491 35.9171 33.3659 36.9407C33.1911 37.9179 32.1129 38.9563 30.4596 38.9563C28.9884 38.9563 27.5661 38.3545 26.6549 37.3463C26.2914 36.9443 25.6707 36.9127 25.2687 37.2763C24.8666 37.6397 24.8352 38.2605 25.1987 38.6626C26.4757 40.0757 28.4424 40.9192 30.4596 40.9192C32.8474 40.9192 34.9274 39.3574 35.2982 37.2865C35.5771 35.7262 34.8388 33.6755 31.9293 32.5995Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M58.3116 10.8509C52.7477 4.70627 45.1676 0.856514 36.9676 0.0107693C36.9676 0.0107693 36.9676 0.0107693 36.9676 0.0106384C36.3851 -0.0483792 35.8033 0.140974 35.3691 0.532506C34.9353 0.923906 34.6864 1.48385 34.6864 2.0684V4.2018C33.897 4.1704 33.1028 4.1704 32.3135 4.2018V2.06853C32.3135 1.48385 32.0647 0.924037 31.6308 0.532636C31.1967 0.140974 30.614 -0.0491643 30.0324 0.0109001C21.8324 0.856514 14.2524 4.70627 8.68828 10.8509C3.08553 17.0382 0 25.0516 0 33.415C0 38.1806 0.977258 42.7879 2.90469 47.1088C3.1435 47.6444 3.59994 48.055 4.15701 48.2353C4.36403 48.3025 4.57825 48.3356 4.79194 48.3356C5.15154 48.3356 5.50918 48.2417 5.82625 48.0583L7.666 46.9933C8.03424 47.6958 8.43205 48.385 8.8563 49.0558L7.01459 50.1219C6.50986 50.414 6.15065 50.9092 6.02921 51.4801C5.90712 52.0543 6.03484 52.6565 6.37979 53.1327C7.84698 55.1575 9.54318 57.0216 11.4214 58.6731C11.8284 59.031 12.4485 58.9913 12.8066 58.5841C13.1645 58.1771 13.1247 57.5568 12.7176 57.1989C10.9486 55.6435 9.35095 53.8879 7.9692 51.9811C7.94879 51.9528 7.94199 51.9218 7.94905 51.8885C7.95861 51.8434 7.98805 51.8264 7.99786 51.8208L13.7455 48.4935L13.7478 48.4772C18.2877 54.4459 25.4521 58.3055 33.5 58.3055C41.5459 58.3055 48.7089 54.4479 53.2488 48.4817C53.2526 48.4896 53.2545 48.4938 53.2545 48.4938L59.002 51.8208C59.0117 51.8264 59.0413 51.8435 59.0508 51.8888C59.0579 51.922 59.0512 51.953 59.0308 51.9812C53.1072 60.1564 43.5631 65.037 33.5 65.037C27.4847 65.037 21.636 63.333 16.5864 60.1091C16.1297 59.8174 15.5229 59.9513 15.2311 60.4081C14.9394 60.865 15.0733 61.4719 15.5301 61.7634C20.8958 65.1892 27.1096 66.9999 33.5 66.9999C38.8773 66.9999 44.2234 65.6917 48.9604 63.2165C53.5436 60.8218 57.5756 57.335 60.6203 53.1329C60.9652 52.6569 61.093 52.0549 60.971 51.4808C60.8496 50.9097 60.4905 50.4145 59.9857 50.1221L58.1438 49.056C58.5683 48.3849 58.9662 47.6957 59.3343 46.9936L61.174 48.0585C61.4911 48.242 61.8486 48.3358 62.2082 48.3358C62.4218 48.3358 62.6362 48.3027 62.8433 48.2356C63.4002 48.0551 63.8566 47.6445 64.0954 47.1092C66.0226 42.7878 67 38.1805 67 33.415C67 25.0516 63.9145 17.0382 58.3116 10.8509ZM34.6864 6.16705V8.55366C34.2931 8.53508 33.8977 8.52461 33.5 8.52461C33.1039 8.52461 32.7084 8.53718 32.3135 8.55615V6.16705C33.1027 6.13329 33.8973 6.13329 34.6864 6.16705ZM10.5568 48.0715C10.1306 47.4019 9.7328 46.7124 9.36665 46.0089L11.4321 44.8132C11.7972 45.5208 12.195 46.2087 12.6239 46.8749L10.5568 48.0715ZM33.5 56.3426C20.892 56.3426 10.6345 46.0573 10.6345 33.415C10.6345 26.5315 13.6793 20.0732 18.9878 15.6964C19.4061 15.3514 19.4656 14.733 19.1208 14.3146C18.7761 13.8967 18.1574 13.8371 17.7392 14.1817C11.9766 18.9329 8.67179 25.9432 8.67179 33.415C8.67179 36.8213 9.35854 40.0697 10.5995 43.0292L4.84311 46.3595C4.83355 46.365 4.80476 46.3816 4.7621 46.3681C4.7324 46.3584 4.71068 46.3387 4.69759 46.3092C2.88296 42.2416 1.96289 37.9033 1.96289 33.415C1.96289 17.1471 14.1167 3.62576 30.2337 1.96332C30.2654 1.95979 30.2928 1.96895 30.3159 1.99002C30.339 2.01069 30.3506 2.03713 30.3506 2.06853V8.72692C27.3316 9.11361 24.3957 10.0515 21.724 11.497C21.2472 11.755 21.0698 12.3504 21.3279 12.8273C21.5858 13.3039 22.1813 13.4812 22.658 13.2234C25.9663 11.4335 29.7154 10.4875 33.5 10.4875C46.1082 10.4875 56.3655 20.7728 56.3655 33.415C56.3655 46.0573 46.1082 56.3426 33.5 56.3426ZM56.4431 48.0714L54.376 46.8748C54.8048 46.2086 55.2026 45.5207 55.5677 44.8131L57.6332 46.0086C57.2673 46.712 56.8694 47.4015 56.4431 48.0714ZM62.3025 46.3093C62.2893 46.3388 62.2677 46.3584 62.238 46.3681C62.1959 46.3817 62.1666 46.3651 62.1572 46.3595L56.4063 43.0305C56.4063 43.0305 56.4017 43.0325 56.3988 43.0337C57.6409 40.073 58.3283 36.823 58.3283 33.4149C58.3283 20.7596 48.8583 10.28 36.6493 8.72378V2.06853C36.6493 2.03726 36.6609 2.01082 36.6839 1.99002C36.7074 1.96895 36.7359 1.9594 36.7663 1.96332V1.96319C52.8818 3.62707 65.0371 17.148 65.0371 33.415C65.0371 37.9032 64.1172 42.2414 62.3025 46.3093Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            })
                        ]
                    })
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Expansion Pack - ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " ESG"
                    ]
                }),
                points: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Aimed at: "
                            }),
                            " any company needing to demonstrate that they are well-prepared and score highly on an ESG"
                        ]
                    }),
                    '4 main sections - Sustainability Governance, Environmental, Social, Governance',
                    'Completeness and risk scoring',
                    'Automated reporting - including risks and recommendations',
                    'Tailored to business objectives',
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Benefit: "
                            }),
                            " Working though these questions will strengthen the business, identify weaknesses, and giving you an opportunity to plug them prior to being subject to due diligence if you have stressed your ESG credentials"
                        ]
                    })
                ],
                image: (parcelRequire("bMTa0")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "94",
                height: "94",
                viewBox: "0 0 67 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M50.8079 33.1927H56.9494C57.7555 33.1927 58.4091 32.5391 58.4091 31.733C58.4091 30.9269 57.7555 30.2733 56.9494 30.2733H51.3882C52.0876 25.8634 51.7631 22.8804 51.7446 22.7197C51.6785 22.1428 51.2767 21.6602 50.7215 21.4904C48.5034 20.8118 46.5708 20.1227 44.8894 19.4473V15.8386H49.9022C50.5047 17.5376 52.1272 18.758 54.0301 18.758C56.4447 18.758 58.4091 16.7936 58.4091 14.379C58.4091 11.9644 56.4447 10 54.0301 10C52.1272 10 50.5047 11.2204 49.9022 12.9193H43.4297C42.6236 12.9193 41.9701 13.5729 41.9701 14.379V18.1776C36.56 15.6233 34.7662 13.5282 34.6582 13.3975C34.0754 12.5952 32.9201 12.5944 32.3368 13.3975C32.2289 13.5282 30.4351 15.6233 25.0249 18.1776V14.379C25.0249 13.5729 24.3714 12.9193 23.5653 12.9193H17.0928C16.4903 11.2204 14.8678 10 12.9649 10C10.5504 10 8.58594 11.9644 8.58594 14.379C8.58594 16.7936 10.5504 18.758 12.9649 18.758C14.8678 18.758 16.4903 17.5376 17.0928 15.8386H22.1056V19.4473C20.4243 20.1227 18.4917 20.8118 16.2735 21.4904C15.7183 21.6602 15.3165 22.1428 15.2504 22.7197C15.2319 22.8804 14.9074 25.8634 15.6068 30.2733H10.0456C9.23948 30.2733 8.58594 30.9269 8.58594 31.733C8.58594 32.5391 9.23948 33.1927 10.0456 33.1927H16.1871C16.5114 34.5487 16.8955 35.844 17.3746 37.1869H13.3649C12.5587 37.1869 11.9052 37.8404 11.9052 38.6466C11.9052 39.4527 12.5587 40.1062 13.3649 40.1062H18.5529C19.8104 42.8864 21.3487 45.4248 23.1855 47.8007H17.0928C16.4903 46.1017 14.8678 44.8814 12.9649 44.8814C10.5504 44.8814 8.58594 46.8458 8.58594 49.2603C8.58594 51.6749 10.5504 53.6393 12.9649 53.6393C14.8678 53.6393 16.4903 52.419 17.0928 50.72H25.675C27.7309 52.9123 30.0655 54.9256 32.6624 56.7372C33.164 57.0873 33.831 57.0873 34.3326 56.7372C36.9296 54.9256 39.264 52.9123 41.32 50.72H49.9022C50.5047 52.419 52.1272 53.6393 54.0301 53.6393C56.4447 53.6393 58.4091 51.6749 58.4091 49.2603C58.4091 46.8458 56.4447 44.8814 54.0301 44.8814C52.1272 44.8814 50.5047 46.1017 49.9022 47.8007H43.8095C45.6437 45.428 47.183 42.89 48.4421 40.1062H53.6301C54.4363 40.1062 55.0898 39.4527 55.0898 38.6466C55.0898 37.8404 54.4363 37.1869 53.6301 37.1869H49.6204C50.0991 35.8451 50.4834 34.5498 50.8079 33.1927ZM54.0301 12.9193C54.8349 12.9193 55.4898 13.5741 55.4898 14.379C55.4898 15.1838 54.8349 15.8386 54.0301 15.8386C53.2252 15.8386 52.5704 15.1838 52.5704 14.379C52.5704 13.5741 53.2252 12.9193 54.0301 12.9193ZM12.9649 15.8386C12.1601 15.8386 11.5053 15.1838 11.5053 14.379C11.5053 13.5741 12.1601 12.9193 12.9649 12.9193C13.7698 12.9193 14.4246 13.5741 14.4246 14.379C14.4246 15.1838 13.7698 15.8386 12.9649 15.8386ZM12.9649 50.72C12.1601 50.72 11.5053 50.0652 11.5053 49.2603C11.5053 48.4555 12.1601 47.8007 12.9649 47.8007C13.7698 47.8007 14.4246 48.4555 14.4246 49.2603C14.4246 50.0652 13.7698 50.72 12.9649 50.72ZM54.0301 47.8007C54.8349 47.8007 55.4898 48.4555 55.4898 49.2603C55.4898 50.0652 54.8349 50.72 54.0301 50.72C53.2252 50.72 52.5704 50.0652 52.5704 49.2603C52.5704 48.4555 53.2252 47.8007 54.0301 47.8007ZM33.4971 53.7462C26.6477 48.7357 21.7331 42.1635 19.406 33.9673C18.1094 29.4002 18.0409 25.6455 18.0955 23.9798C23.062 22.3971 29.5575 19.7958 33.4975 16.3414C37.4248 19.7845 43.9463 22.4015 48.9016 23.9805C49.0001 26.8496 48.5974 30.367 47.624 33.8431C46.0743 39.3772 42.3648 47.2479 33.4971 53.7462Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39.7501 29.8005V28.8506C39.7501 25.4049 36.9468 22.6016 33.5011 22.6016C30.0554 22.6016 27.2521 25.4049 27.2521 28.8506V29.8005C26.2149 30.1639 25.4688 31.1521 25.4688 32.3118V40.6711C25.4688 42.1382 26.6623 43.3317 28.1293 43.3317H38.8727C40.3398 43.3317 41.5333 42.1382 41.5333 40.6711V32.3118C41.5333 31.1521 40.7872 30.1639 39.7501 29.8005ZM33.5011 25.5209C35.337 25.5209 36.8308 27.0146 36.8308 28.8506V29.6512H30.1714V28.8506C30.1714 27.0146 31.6651 25.5209 33.5011 25.5209ZM38.614 40.4123H28.3882V32.5705H38.6141V40.4123H38.614Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M33.4987 34.5156C32.6926 34.5156 32.0391 35.1692 32.0391 35.9753V37.0053C32.0391 37.8114 32.6926 38.465 33.4987 38.465C34.3048 38.465 34.9584 37.8114 34.9584 37.0053V35.9753C34.9584 35.1691 34.3048 34.5156 33.4987 34.5156Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "aboutDescription",
                children: [
                    "Expansion Pack - ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " Cybersecurity"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "67",
                    height: "67",
                    viewBox: "0 0 67 67",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M50.8079 33.1927H56.9494C57.7555 33.1927 58.4091 32.5391 58.4091 31.733C58.4091 30.9269 57.7555 30.2733 56.9494 30.2733H51.3882C52.0876 25.8634 51.7631 22.8804 51.7446 22.7197C51.6785 22.1428 51.2767 21.6602 50.7215 21.4904C48.5034 20.8118 46.5708 20.1227 44.8894 19.4473V15.8386H49.9022C50.5047 17.5376 52.1272 18.758 54.0301 18.758C56.4447 18.758 58.4091 16.7936 58.4091 14.379C58.4091 11.9644 56.4447 10 54.0301 10C52.1272 10 50.5047 11.2204 49.9022 12.9193H43.4297C42.6236 12.9193 41.9701 13.5729 41.9701 14.379V18.1776C36.56 15.6233 34.7662 13.5282 34.6582 13.3975C34.0754 12.5952 32.9201 12.5944 32.3368 13.3975C32.2289 13.5282 30.4351 15.6233 25.0249 18.1776V14.379C25.0249 13.5729 24.3714 12.9193 23.5653 12.9193H17.0928C16.4903 11.2204 14.8678 10 12.9649 10C10.5504 10 8.58594 11.9644 8.58594 14.379C8.58594 16.7936 10.5504 18.758 12.9649 18.758C14.8678 18.758 16.4903 17.5376 17.0928 15.8386H22.1056V19.4473C20.4243 20.1227 18.4917 20.8118 16.2735 21.4904C15.7183 21.6602 15.3165 22.1428 15.2504 22.7197C15.2319 22.8804 14.9074 25.8634 15.6068 30.2733H10.0456C9.23948 30.2733 8.58594 30.9269 8.58594 31.733C8.58594 32.5391 9.23948 33.1927 10.0456 33.1927H16.1871C16.5114 34.5487 16.8955 35.844 17.3746 37.1869H13.3649C12.5587 37.1869 11.9052 37.8404 11.9052 38.6466C11.9052 39.4527 12.5587 40.1062 13.3649 40.1062H18.5529C19.8104 42.8864 21.3487 45.4248 23.1855 47.8007H17.0928C16.4903 46.1017 14.8678 44.8814 12.9649 44.8814C10.5504 44.8814 8.58594 46.8458 8.58594 49.2603C8.58594 51.6749 10.5504 53.6393 12.9649 53.6393C14.8678 53.6393 16.4903 52.419 17.0928 50.72H25.675C27.7309 52.9123 30.0655 54.9256 32.6624 56.7372C33.164 57.0873 33.831 57.0873 34.3326 56.7372C36.9296 54.9256 39.264 52.9123 41.32 50.72H49.9022C50.5047 52.419 52.1272 53.6393 54.0301 53.6393C56.4447 53.6393 58.4091 51.6749 58.4091 49.2603C58.4091 46.8458 56.4447 44.8814 54.0301 44.8814C52.1272 44.8814 50.5047 46.1017 49.9022 47.8007H43.8095C45.6437 45.428 47.183 42.89 48.4421 40.1062H53.6301C54.4363 40.1062 55.0898 39.4527 55.0898 38.6466C55.0898 37.8404 54.4363 37.1869 53.6301 37.1869H49.6204C50.0991 35.8451 50.4834 34.5498 50.8079 33.1927ZM54.0301 12.9193C54.8349 12.9193 55.4898 13.5741 55.4898 14.379C55.4898 15.1838 54.8349 15.8386 54.0301 15.8386C53.2252 15.8386 52.5704 15.1838 52.5704 14.379C52.5704 13.5741 53.2252 12.9193 54.0301 12.9193ZM12.9649 15.8386C12.1601 15.8386 11.5053 15.1838 11.5053 14.379C11.5053 13.5741 12.1601 12.9193 12.9649 12.9193C13.7698 12.9193 14.4246 13.5741 14.4246 14.379C14.4246 15.1838 13.7698 15.8386 12.9649 15.8386ZM12.9649 50.72C12.1601 50.72 11.5053 50.0652 11.5053 49.2603C11.5053 48.4555 12.1601 47.8007 12.9649 47.8007C13.7698 47.8007 14.4246 48.4555 14.4246 49.2603C14.4246 50.0652 13.7698 50.72 12.9649 50.72ZM54.0301 47.8007C54.8349 47.8007 55.4898 48.4555 55.4898 49.2603C55.4898 50.0652 54.8349 50.72 54.0301 50.72C53.2252 50.72 52.5704 50.0652 52.5704 49.2603C52.5704 48.4555 53.2252 47.8007 54.0301 47.8007ZM33.4971 53.7462C26.6477 48.7357 21.7331 42.1635 19.406 33.9673C18.1094 29.4002 18.0409 25.6455 18.0955 23.9798C23.062 22.3971 29.5575 19.7958 33.4975 16.3414C37.4248 19.7845 43.9463 22.4015 48.9016 23.9805C49.0001 26.8496 48.5974 30.367 47.624 33.8431C46.0743 39.3772 42.3648 47.2479 33.4971 53.7462Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M39.7501 29.8005V28.8506C39.7501 25.4049 36.9468 22.6016 33.5011 22.6016C30.0554 22.6016 27.2521 25.4049 27.2521 28.8506V29.8005C26.2149 30.1639 25.4688 31.1521 25.4688 32.3118V40.6711C25.4688 42.1382 26.6623 43.3317 28.1293 43.3317H38.8727C40.3398 43.3317 41.5333 42.1382 41.5333 40.6711V32.3118C41.5333 31.1521 40.7872 30.1639 39.7501 29.8005ZM33.5011 25.5209C35.337 25.5209 36.8308 27.0146 36.8308 28.8506V29.6512H30.1714V28.8506C30.1714 27.0146 31.6651 25.5209 33.5011 25.5209ZM38.614 40.4123H28.3882V32.5705H38.6141V40.4123H38.614Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M33.4987 34.5156C32.6926 34.5156 32.0391 35.1692 32.0391 35.9753V37.0053C32.0391 37.8114 32.6926 38.465 33.4987 38.465C34.3048 38.465 34.9584 37.8114 34.9584 37.0053V35.9753C34.9584 35.1691 34.3048 34.5156 33.4987 34.5156Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "aboutDescription",
                    children: [
                        "Expansion Pack - ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Cybersecurity"
                    ]
                }),
                points: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Aimed at: "
                            }),
                            " Any company with significant I.T. systems and processes which are key to its operations, and which may be at risk of unauthorised access"
                        ]
                    }),
                    '10 sections x 10 questions (including user-generated)',
                    'Bespoked to the company, its objectives and the types of underlying architecture used',
                    'Completeness and risk reporting',
                    'Risks and recommendations',
                    'This module includes an online 30 minute report review meeting to discuss its contents',
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Benefits: "
                            }),
                            " Cybersecurity is frequently overlooked, notwithstanding that many companies record their I.T. platforms as one of their their main assets. Lifting the lid on, and assessing, the \u201Cblack hole\u201D will benefit both internal and external stakeholders"
                        ]
                    })
                ],
                image: (parcelRequire("jQaaA")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        },
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8 8V75H59.3055V50.9663L75 35.2745L66.6706 26.947L59.3055 34.3109V8L8 8ZM55.379 38.2367L51.4526 42.1625V15.8516H43.5997V11.9258H55.379V38.2367ZM27.7631 11.9258H39.6733V15.8516H27.7631V11.9258ZM47.5262 19.7773V46.0883L45.52 48.0941L42.6897 56.5826L41.3579 60.585L47.5262 58.5291V63.2227H19.7793V19.7773H47.5262ZM47.5635 54.3784L48.9515 50.2144L61.1179 38.0506L63.8945 40.8263L51.7282 52.9906L47.5635 54.3784ZM55.379 71.0742H11.9264V11.9258H23.8366V15.8516H15.8529V67.1484H51.4526V57.2205L53.8494 56.4215L55.379 54.8921V71.0742ZM69.4473 35.2745L66.6706 38.0506L63.8945 35.2745L66.6706 32.4988L69.4473 35.2745Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39 26.7721L36.3298 24L30.1117 30.4549L27.6702 27.9207L25 30.6928L30.1117 36L39 26.7721Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39 38.7721L36.3298 36L30.1117 42.4549L27.6702 39.9207L25 42.6928L30.1117 48L39 38.7721Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M39 50.7721L36.3298 48L30.1117 54.4549L27.6702 51.9207L25 54.6928L30.1117 60L39 50.7721Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "c4",
                        children: "AnyList"
                    }),
                    " AnyList Checklist ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " Builder"
                ]
            }),
            isStar: false,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                    width: "65",
                    height: "65",
                    viewBox: "0 0 65 65",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        "clip-path": "url(#clip0_1258_26722)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.0762 30.7226C22.1279 30.7226 22.9805 29.8701 22.9805 28.8184C22.9805 27.7666 22.1279 26.9141 21.0762 26.9141C20.0245 26.9141 19.1719 27.7666 19.1719 28.8184C19.1719 29.8701 20.0245 30.7226 21.0762 30.7226Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M56.8305 35.0965C56.0911 34.3487 54.8855 34.342 54.1375 35.0816L43.9312 45.1756L41.4617 42.7061C40.7182 41.9625 39.5124 41.9625 38.7687 42.7061C38.025 43.4498 38.025 44.6555 38.7687 45.3992L42.5773 49.2078C42.9491 49.5796 43.4364 49.7656 43.9239 49.7656C44.4079 49.7656 44.8919 49.5823 45.263 49.2153L56.8157 37.7895C57.5635 37.05 57.57 35.8442 56.8305 35.0965Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M55.4783 23.1054H42.0213V9.52145C42.0213 4.27132 37.75 0 32.4999 0H9.52145C4.27132 0 0 4.27132 0 9.52145V28.8183C0 33.4164 3.27665 37.2637 7.61716 38.1484V44.0526C7.61716 44.8199 8.07775 45.5123 8.78538 45.8088C9.4986 46.1077 10.314 45.9442 10.8567 45.4101L18.0452 38.3397H26.787V47.8612C26.787 53.1113 31.0583 57.3826 36.3085 57.3826H38.2128V63.0955C38.2128 63.8657 38.6766 64.5601 39.3883 64.8548C40.0999 65.1496 40.919 64.9866 41.4636 64.4419L48.523 57.3826H55.4783C60.7285 57.3826 64.9998 53.1113 64.9998 47.8612V32.6268C64.9998 27.3767 60.7286 23.1054 55.4783 23.1054ZM26.787 32.6268V34.5311H17.2656C16.7659 34.5311 16.2864 34.7274 15.9302 35.0778L11.4257 39.5084V36.4354C11.4257 35.3837 10.5731 34.5311 9.52145 34.5311C6.37137 34.5311 3.80858 31.9683 3.80858 28.8183V9.52145C3.80858 6.37137 6.37137 3.80858 9.52145 3.80858H32.4999C35.65 3.80858 38.2128 6.37137 38.2128 9.52145V23.1054H36.3085C31.0583 23.1054 26.787 27.3767 26.787 32.6268ZM61.1912 47.8612C61.1912 51.0112 58.6284 53.574 55.4783 53.574H47.7342C47.2291 53.574 46.7447 53.7747 46.3878 54.1319L42.0213 58.4981V55.4783C42.0213 54.4267 41.1687 53.574 40.1171 53.574H36.3085C33.1584 53.574 30.5956 51.0112 30.5956 47.8612V32.6268C30.5956 29.4768 33.1584 26.914 36.3085 26.914H55.4783C58.6284 26.914 61.1912 29.4768 61.1912 32.6268V47.8612Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M21.0762 7.61719C17.9261 7.61719 15.3633 10.18 15.3633 13.3301C15.3633 14.3817 16.2159 15.2344 17.2676 15.2344C18.3192 15.2344 19.1719 14.3817 19.1719 13.3301C19.1719 12.28 20.0261 11.4258 21.0762 11.4258C22.1262 11.4258 22.9804 12.28 22.9804 13.3301C22.9804 13.8252 22.4192 14.797 21.5734 15.1334C20.1145 15.7136 19.1719 17.103 19.1719 18.6729V21.2011C19.1719 22.2528 20.0245 23.1054 21.0762 23.1054C22.1278 23.1054 22.9677 22.2528 22.9677 21.2011L22.9684 18.6724C25.1393 17.8087 26.789 15.512 26.789 13.3301C26.789 10.18 24.2264 7.61719 21.0762 7.61719Z",
                                fill: "#4A67FF",
                                stroke: "#4A67FF"
                            })
                        ]
                    })
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "AnyList"
                        }),
                        " AnyList Checklist ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        " Builder"
                    ]
                }),
                points: [
                    'Undertaking M&A? Create relevant automated dule diligence checklists bespoked to target company',
                    'You can add your own questions and desired answers',
                    'Questions: Can choose subjective, objective or a mixture',
                    'Completeness and risk scoring',
                    'Reporting',
                    'Workflow Manager: Can send to target company and monitor completeness'
                ],
                image: (parcelRequire("8DFan")),
                imageStyle: {
                    height: '92%'
                }
            }
        }
    ],
    proPlus: [
        {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M66.7745 20.1305C62.2389 20.1305 58.5491 23.8399 58.5491 28.3996C58.5491 30.2228 59.1574 31.8945 60.1553 33.263L54.5322 40.7986L47.1836 26.2215C48.7436 24.7157 49.7254 22.6098 49.7254 20.2691C49.7254 15.7094 46.0357 12 41.5 12C36.9643 12 33.2745 15.7094 33.2745 20.2691C33.2745 22.6098 34.2564 24.7157 35.8164 26.2215L28.4678 40.7986L22.8447 33.263C23.8426 31.8945 24.4509 30.2228 24.4509 28.3996C24.4509 23.8399 20.7611 20.1305 16.2254 20.1305C11.6898 20.1305 8 23.8399 8 28.3996C8 32.4637 10.9367 35.8336 14.7856 36.5224L17.5738 59.881C17.7175 61.0909 18.7375 62 19.9491 62H63.0509C64.2625 62 65.2825 61.0909 65.4262 59.881L68.2144 36.5224C72.0633 35.8336 75 32.4637 75 28.3996C75 23.8399 71.3102 20.1305 66.7745 20.1305ZM66.7745 31.8576C64.8783 31.8576 63.3348 30.3072 63.3348 28.3996C63.3348 26.4921 64.8783 24.9416 66.7745 24.9416C68.6708 24.9416 70.2143 26.4921 70.2143 28.3996C70.2143 30.3072 68.6708 31.8576 66.7745 31.8576ZM22.0721 57.1889L19.664 37.0164L26.9489 46.7796C27.4443 47.4468 28.2645 47.825 29.0707 47.7334C29.8956 47.6606 30.6235 47.1673 30.9974 46.4249L40.0863 28.3945C40.5476 28.4756 41.0159 28.5382 41.5 28.5382C41.9841 28.5382 42.4524 28.4756 42.9137 28.3945L52.0026 46.4249C52.3765 47.1673 53.1044 47.6606 53.9293 47.7334C54.7518 47.8227 55.5557 47.4468 56.0511 46.7796L63.336 37.0164L60.9279 57.1889H22.0721ZM12.7857 28.3996C12.7857 26.4921 14.3292 24.9416 16.2254 24.9416C18.1217 24.9416 19.6652 26.4921 19.6652 28.3996C19.6652 30.3072 18.1217 31.8576 16.2254 31.8576C14.3292 31.8576 12.7857 30.3072 12.7857 28.3996ZM38.0603 20.2691C38.0603 18.3616 39.6037 16.8111 41.5 16.8111C43.3963 16.8111 44.9397 18.3616 44.9397 20.2691C44.9397 22.1767 43.3963 23.7271 41.5 23.7271C39.6037 23.7271 38.0603 22.1767 38.0603 20.2691Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M62.6515 71C63.9484 71 65 69.8818 65 68.5C65 67.1182 63.9484 66 62.6515 66H20.3485C19.0516 66 18 67.1182 18 68.5C18 69.8818 19.0516 71 20.3485 71H62.6515Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: `Diligentsia Pro PLUS`,
            isStar: true,
            seeMoreSection: {
                icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                    width: "83",
                    height: "83",
                    viewBox: "0 0 83 83",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M66.7745 20.1305C62.2389 20.1305 58.5491 23.8399 58.5491 28.3996C58.5491 30.2228 59.1574 31.8945 60.1553 33.263L54.5322 40.7986L47.1836 26.2215C48.7436 24.7157 49.7254 22.6098 49.7254 20.2691C49.7254 15.7094 46.0357 12 41.5 12C36.9643 12 33.2745 15.7094 33.2745 20.2691C33.2745 22.6098 34.2564 24.7157 35.8164 26.2215L28.4678 40.7986L22.8447 33.263C23.8426 31.8945 24.4509 30.2228 24.4509 28.3996C24.4509 23.8399 20.7611 20.1305 16.2254 20.1305C11.6898 20.1305 8 23.8399 8 28.3996C8 32.4637 10.9367 35.8336 14.7856 36.5224L17.5738 59.881C17.7175 61.0909 18.7375 62 19.9491 62H63.0509C64.2625 62 65.2825 61.0909 65.4262 59.881L68.2144 36.5224C72.0633 35.8336 75 32.4637 75 28.3996C75 23.8399 71.3102 20.1305 66.7745 20.1305ZM66.7745 31.8576C64.8783 31.8576 63.3348 30.3072 63.3348 28.3996C63.3348 26.4921 64.8783 24.9416 66.7745 24.9416C68.6708 24.9416 70.2143 26.4921 70.2143 28.3996C70.2143 30.3072 68.6708 31.8576 66.7745 31.8576ZM22.0721 57.1889L19.664 37.0164L26.9489 46.7796C27.4443 47.4468 28.2645 47.825 29.0707 47.7334C29.8956 47.6606 30.6235 47.1673 30.9974 46.4249L40.0863 28.3945C40.5476 28.4756 41.0159 28.5382 41.5 28.5382C41.9841 28.5382 42.4524 28.4756 42.9137 28.3945L52.0026 46.4249C52.3765 47.1673 53.1044 47.6606 53.9293 47.7334C54.7518 47.8227 55.5557 47.4468 56.0511 46.7796L63.336 37.0164L60.9279 57.1889H22.0721ZM12.7857 28.3996C12.7857 26.4921 14.3292 24.9416 16.2254 24.9416C18.1217 24.9416 19.6652 26.4921 19.6652 28.3996C19.6652 30.3072 18.1217 31.8576 16.2254 31.8576C14.3292 31.8576 12.7857 30.3072 12.7857 28.3996ZM38.0603 20.2691C38.0603 18.3616 39.6037 16.8111 41.5 16.8111C43.3963 16.8111 44.9397 18.3616 44.9397 20.2691C44.9397 22.1767 43.3963 23.7271 41.5 23.7271C39.6037 23.7271 38.0603 22.1767 38.0603 20.2691Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M62.6515 71C63.9484 71 65 69.8818 65 68.5C65 67.1182 63.9484 66 62.6515 66H20.3485C19.0516 66 18 67.1182 18 68.5C18 69.8818 19.0516 71 20.3485 71H62.6515Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                title: `Diligentsia Pro PLUS`,
                points: [
                    `Your applicant companies self-diligence and then pay  their advisors for an "audit" of their modules on a chargeable basis`,
                    'Audited certificate valid for 3 months',
                    'Periodic reporting of changes to repository and  other modules to keep you abreast of developments',
                    'Option of quarterly reviews'
                ],
                image: (parcelRequire("kretz")),
                imageStyle: {
                    height: '90%',
                    width: '94%'
                }
            }
        }
    ]
};



































// Key features array
const $cf9800d02c9ef389$var$KEY_FEATURE = [
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "71",
            height: "73",
            viewBox: "0 0 71 73",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M48.7686 16.1188C49.3136 16.1188 49.7577 16.5627 49.7577 17.1085C49.7577 17.6532 49.3138 18.0972 48.7686 18.0972C48.2235 18.0972 47.7804 17.6532 47.7804 17.1085C47.7804 16.5627 48.2236 16.1188 48.7686 16.1188ZM48.7686 20.3894C50.5785 20.3894 52.0494 18.9164 52.0494 17.1085C52.0494 15.2991 50.5785 13.8264 48.7686 13.8264C46.9596 13.8264 45.4886 15.2991 45.4886 17.1085C45.4886 18.9164 46.9596 20.3894 48.7686 20.3894ZM38.7781 16.1188C39.3239 16.1188 39.7663 16.5627 39.7663 17.1085C39.7663 17.6532 39.3239 18.0972 38.7781 18.0972C38.2323 18.0972 37.7891 17.6532 37.7891 17.1085C37.7891 16.5627 38.2323 16.1188 38.7781 16.1188ZM38.7781 20.3894C40.5872 20.3894 42.0589 18.9164 42.0589 17.1085C42.0589 15.2991 40.5872 13.8264 38.7781 13.8264C36.969 13.8264 35.4973 15.2991 35.4973 17.1085C35.4973 18.9164 36.9692 20.3894 38.7781 20.3894ZM28.7869 16.1188C29.3327 16.1188 29.7759 16.5627 29.7759 17.1085C29.7759 17.6532 29.3327 18.0972 28.7869 18.0972C28.2426 18.0972 27.7987 17.6532 27.7987 17.1085C27.7987 16.5627 28.2426 16.1188 28.7869 16.1188ZM28.7869 20.3894C30.5968 20.3894 32.0677 18.9164 32.0677 17.1085C32.0677 15.2991 30.5968 13.8264 28.7869 13.8264C26.9778 13.8264 25.5061 15.2991 25.5061 17.1085C25.5061 18.9164 26.9778 20.3894 28.7869 20.3894ZM19.8089 9.17606V25.0395C19.8089 28.2139 22.3902 30.8658 25.5635 30.9501C26.1853 30.9659 26.6803 31.4745 26.6803 32.0949V39.1434L34.5358 31.2868C34.7509 31.072 35.0436 30.9516 35.3469 30.9516H51.8351C55.0949 30.9516 57.7474 28.2996 57.7474 25.0394V9.17606C57.7474 5.91549 55.0949 3.26397 51.8351 3.26397H25.7212C22.4606 3.26397 19.8089 5.91549 19.8089 9.17606ZM24.3877 33.1337V41.9114C24.3877 42.9305 25.6259 43.4411 26.3447 42.722L35.8208 33.2439H51.8351C56.3588 33.2439 60.0392 29.5639 60.0392 25.0395V9.17606C60.0392 4.65223 56.3588 0.97168 51.8351 0.97168H25.7212C21.1974 0.97168 17.5171 4.65223 17.5171 9.17606V25.0395C17.5171 29.0667 20.5093 32.4861 24.3877 33.1337ZM65.903 53.0112C65.8568 53.0497 65.8196 53.0753 65.7695 53.1098L41.1605 69.1492C40.7925 69.3899 40.4069 69.4487 39.9831 69.33L24.7775 65.0764C24.1078 64.8888 23.4576 64.8872 22.789 65.0694L17.1614 66.6038V50.5328L25.2976 48.2808L39.883 52.1887C41.6952 52.6745 42.7757 54.544 42.2896 56.3576C41.8044 58.1698 39.9339 59.2486 38.1209 58.7631L23.2347 54.7748C22.6225 54.6114 21.9958 54.9738 21.8308 55.5857C21.6675 56.1961 22.0297 56.8249 22.6411 56.9882L37.5273 60.9779C40.3313 61.728 43.2903 60.2405 44.3283 57.491L64.7257 48.3223C65.0338 48.1832 65.3047 48.1562 65.6322 48.2291C68.0017 48.7591 67.9526 51.3125 65.903 53.0112ZM14.8694 68.4132C14.8694 69.1422 14.2766 69.7367 13.5456 69.7367H4.90163C4.17057 69.7367 3.57778 69.1422 3.57778 68.4132V49.4897C3.57778 48.7606 4.17057 48.1661 4.90163 48.1661H13.5456C14.2766 48.1661 14.8694 48.7608 14.8694 49.4897V68.4132ZM69.5947 49.2133C69.2041 47.5943 67.9103 46.3911 66.1336 45.9927C65.3168 45.8094 64.5494 45.8881 63.786 46.2306L44.6606 54.8291C44.3995 52.5739 42.7966 50.597 40.4758 49.9739L25.5896 45.9854C25.3922 45.9326 25.1843 45.9338 24.9863 45.9882L16.931 48.2174C16.4159 46.8493 15.0929 45.8739 13.5459 45.8739H4.90163C2.90747 45.8739 1.28516 47.4953 1.28516 49.4895V68.413C1.28516 70.4057 2.90731 72.0286 4.90163 72.0286H13.5456C15.3425 72.0286 16.836 70.7108 17.1159 68.9917L23.392 67.2812C23.6638 67.2067 23.8877 67.2067 24.1595 67.2825L39.3651 71.5373C40.4163 71.8316 41.4759 71.6784 42.4113 71.0692L67.0203 55.0294C67.1448 54.9479 67.2507 54.8704 67.3656 54.7744C69.1992 53.2532 70.0531 51.1228 69.5947 49.2133Z",
                fill: "#4A67FF",
                stroke: "#4A67FF",
                "stroke-width": "1.5"
            })
        }),
        title: `FREE Portfolio Dashboard`,
        points: [
            'FREE dashboard for portfolio monitoring',
            'All your portfolio companies in one place',
            'Access your portfolio company dashboards for module status and reports (with portfolio company permissions)',
            ,
            'FREE tools - automated anylist checklist creation, portfolio benchmarking,'
        ],
        image: (parcelRequire("aEyq0")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "7%",
            right: '0px',
            top: '150px'
        },
        animationImage: (parcelRequire("1RI5O")),
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "71",
                height: "73",
                viewBox: "0 0 71 73",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M48.7686 16.1188C49.3136 16.1188 49.7577 16.5627 49.7577 17.1085C49.7577 17.6532 49.3138 18.0972 48.7686 18.0972C48.2235 18.0972 47.7804 17.6532 47.7804 17.1085C47.7804 16.5627 48.2236 16.1188 48.7686 16.1188ZM48.7686 20.3894C50.5785 20.3894 52.0494 18.9164 52.0494 17.1085C52.0494 15.2991 50.5785 13.8264 48.7686 13.8264C46.9596 13.8264 45.4886 15.2991 45.4886 17.1085C45.4886 18.9164 46.9596 20.3894 48.7686 20.3894ZM38.7781 16.1188C39.3239 16.1188 39.7663 16.5627 39.7663 17.1085C39.7663 17.6532 39.3239 18.0972 38.7781 18.0972C38.2323 18.0972 37.7891 17.6532 37.7891 17.1085C37.7891 16.5627 38.2323 16.1188 38.7781 16.1188ZM38.7781 20.3894C40.5872 20.3894 42.0589 18.9164 42.0589 17.1085C42.0589 15.2991 40.5872 13.8264 38.7781 13.8264C36.969 13.8264 35.4973 15.2991 35.4973 17.1085C35.4973 18.9164 36.9692 20.3894 38.7781 20.3894ZM28.7869 16.1188C29.3327 16.1188 29.7759 16.5627 29.7759 17.1085C29.7759 17.6532 29.3327 18.0972 28.7869 18.0972C28.2426 18.0972 27.7987 17.6532 27.7987 17.1085C27.7987 16.5627 28.2426 16.1188 28.7869 16.1188ZM28.7869 20.3894C30.5968 20.3894 32.0677 18.9164 32.0677 17.1085C32.0677 15.2991 30.5968 13.8264 28.7869 13.8264C26.9778 13.8264 25.5061 15.2991 25.5061 17.1085C25.5061 18.9164 26.9778 20.3894 28.7869 20.3894ZM19.8089 9.17606V25.0395C19.8089 28.2139 22.3902 30.8658 25.5635 30.9501C26.1853 30.9659 26.6803 31.4745 26.6803 32.0949V39.1434L34.5358 31.2868C34.7509 31.072 35.0436 30.9516 35.3469 30.9516H51.8351C55.0949 30.9516 57.7474 28.2996 57.7474 25.0394V9.17606C57.7474 5.91549 55.0949 3.26397 51.8351 3.26397H25.7212C22.4606 3.26397 19.8089 5.91549 19.8089 9.17606ZM24.3877 33.1337V41.9114C24.3877 42.9305 25.6259 43.4411 26.3447 42.722L35.8208 33.2439H51.8351C56.3588 33.2439 60.0392 29.5639 60.0392 25.0395V9.17606C60.0392 4.65223 56.3588 0.97168 51.8351 0.97168H25.7212C21.1974 0.97168 17.5171 4.65223 17.5171 9.17606V25.0395C17.5171 29.0667 20.5093 32.4861 24.3877 33.1337ZM65.903 53.0112C65.8568 53.0497 65.8196 53.0753 65.7695 53.1098L41.1605 69.1492C40.7925 69.3899 40.4069 69.4487 39.9831 69.33L24.7775 65.0764C24.1078 64.8888 23.4576 64.8872 22.789 65.0694L17.1614 66.6038V50.5328L25.2976 48.2808L39.883 52.1887C41.6952 52.6745 42.7757 54.544 42.2896 56.3576C41.8044 58.1698 39.9339 59.2486 38.1209 58.7631L23.2347 54.7748C22.6225 54.6114 21.9958 54.9738 21.8308 55.5857C21.6675 56.1961 22.0297 56.8249 22.6411 56.9882L37.5273 60.9779C40.3313 61.728 43.2903 60.2405 44.3283 57.491L64.7257 48.3223C65.0338 48.1832 65.3047 48.1562 65.6322 48.2291C68.0017 48.7591 67.9526 51.3125 65.903 53.0112ZM14.8694 68.4132C14.8694 69.1422 14.2766 69.7367 13.5456 69.7367H4.90163C4.17057 69.7367 3.57778 69.1422 3.57778 68.4132V49.4897C3.57778 48.7606 4.17057 48.1661 4.90163 48.1661H13.5456C14.2766 48.1661 14.8694 48.7608 14.8694 49.4897V68.4132ZM69.5947 49.2133C69.2041 47.5943 67.9103 46.3911 66.1336 45.9927C65.3168 45.8094 64.5494 45.8881 63.786 46.2306L44.6606 54.8291C44.3995 52.5739 42.7966 50.597 40.4758 49.9739L25.5896 45.9854C25.3922 45.9326 25.1843 45.9338 24.9863 45.9882L16.931 48.2174C16.4159 46.8493 15.0929 45.8739 13.5459 45.8739H4.90163C2.90747 45.8739 1.28516 47.4953 1.28516 49.4895V68.413C1.28516 70.4057 2.90731 72.0286 4.90163 72.0286H13.5456C15.3425 72.0286 16.836 70.7108 17.1159 68.9917L23.392 67.2812C23.6638 67.2067 23.8877 67.2067 24.1595 67.2825L39.3651 71.5373C40.4163 71.8316 41.4759 71.6784 42.4113 71.0692L67.0203 55.0294C67.1448 54.9479 67.2507 54.8704 67.3656 54.7744C69.1992 53.2532 70.0531 51.1228 69.5947 49.2133Z",
                    fill: "#4A67FF",
                    stroke: "#4A67FF",
                    "stroke-width": "1.5"
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "FREE Portfolio",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Dashboard"
                ]
            }),
            points: [
                'FREE dashboard for your portfolio company monitoring',
                'At a glance bronze/silver/gold certification',
                'All your portfolio companies in one place - see status',
                'FREE tools - client benchmarking, automated anylist checklist creator',
                'Access your company dashboards and module status and reports (with permissions)',
                'Set up permissions for each of your investment directors',
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        lineHeight: '20px',
                        marginBottom: '-5px'
                    },
                    children: "Review FREE curated, pre-diligenced leads introduced by Diligentsia from its companies reaching gold certification status and matching your investment criteria,"
                })
            ],
            image: (parcelRequire("aEyq0")),
            imageStyle: {
                height: '90%',
                width: '94%'
            },
            cardPaddingBottom: {
                paddingBottom: '3rem'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "84",
            height: "83",
            viewBox: "0 0 84 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z",
                    fill: "#4A67FF"
                })
            ]
        }),
        title: 'Your Portfolio Investee Dashboard',
        points: [
            'Your portfolio company can authorize your access',
            'At a glance module status and certification',
            `Access to specialist modules e.g. warranty disclosures/directors\u{2019} questionnaires*`
        ],
        image: (parcelRequire("cGrEE")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "7%",
            left: '-85px',
            top: '0px'
        },
        animationImage: (parcelRequire("g2mEf")),
        dataRepo: true,
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "84",
                height: "83",
                viewBox: "0 0 84 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M33.9088 30H12.0907C9.28355 30 7 27.7432 7 24.9684V12.031C7 9.25678 9.28355 7 12.0907 7H33.9088C36.7165 7 39 9.25678 39 12.031V24.9684C39 27.7432 36.7165 30 33.9088 30ZM12.0907 11.3125C11.6896 11.3125 11.3636 11.6346 11.3636 12.031V24.9684C11.3636 25.3654 11.6896 25.6875 12.0907 25.6875H33.9088C34.3104 25.6875 34.6364 25.3654 34.6364 24.9684V12.031C34.6364 11.6346 34.3104 11.3125 33.9088 11.3125H12.0907Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M33.9088 76H12.0907C9.28355 76 7 73.7572 7 71.0002V41.0003C7 38.2428 9.28355 36 12.0907 36H33.9088C36.7165 36 39 38.2428 39 41.0003V71.0002C39 73.7572 36.7165 76 33.9088 76ZM12.0907 40.2857C11.6896 40.2857 11.3636 40.6059 11.3636 41.0003V71.0002C11.3636 71.3941 11.6896 71.7143 12.0907 71.7143H33.9088C34.3104 71.7143 34.6364 71.3941 34.6364 71.0002V41.0003C34.6364 40.6059 34.3104 40.2857 33.9088 40.2857H12.0907Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M71.0684 76H49.9321C47.2122 76 45 73.7432 45 70.969V58.0316C45 55.2568 47.2122 53 49.9321 53H71.0684C73.7878 53 76 55.2568 76 58.0316V70.969C76 73.7432 73.7878 76 71.0684 76ZM49.9321 57.3125C49.5431 57.3125 49.2272 57.6346 49.2272 58.0316V70.969C49.2272 71.3654 49.5431 71.6875 49.9321 71.6875H71.0684C71.4569 71.6875 71.7728 71.3654 71.7728 70.969V58.0316C71.7728 57.6346 71.4569 57.3125 71.0684 57.3125H49.9321Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M71.0684 47H49.9321C47.2122 47 45 44.7572 45 41.9997V11.9998C45 9.24277 47.2122 7 49.9321 7H71.0684C73.7878 7 76 9.24277 76 11.9998V41.9997C76 44.7572 73.7878 47 71.0684 47ZM49.9321 11.2857C49.5431 11.2857 49.2272 11.6059 49.2272 11.9998V41.9997C49.2272 42.3941 49.5431 42.7143 49.9321 42.7143H71.0684C71.4569 42.7143 71.7728 42.3941 71.7728 41.9997V11.9998C71.7728 11.6059 71.4569 11.2857 71.0684 11.2857H49.9321Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Your Portfolio Investee",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " Dashboard"
                ]
            }),
            subMenu: {
                index: 0,
                points: [
                    "\u2022 Access all areas (module completion)",
                    `\u{2022} Dashboard and reports`,
                    "\u2022 Dashboard only"
                ]
            },
            points: [
                'Your investee company can authorise you:',
                'At a glance module status and certification',
                'Bespoked module reporting, with completeness and risk scoring',
                'Modules prepopulated where possible from e.g. Companies House',
                'Easy one-stop shop for your companies and their  advisors to work collaboratively with you',
                'Great for active NEDs to access key company documents'
            ],
            image: (parcelRequire("7B6TB")),
            imageStyle: {
                height: '84%',
                width: '100%'
            },
            cardPaddingBottom: {
                paddingBottom: '3rem'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "53",
            height: "67",
            viewBox: "0 0 53 67",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M48.6759 19.8499C47.7963 19.009 46.8867 18.1396 46.5988 17.4418C46.2825 16.6754 46.3086 15.3671 46.3338 14.1019C46.3786 11.8552 46.4292 9.30893 44.6987 7.57008C42.9651 5.82808 40.4148 5.8676 38.1666 5.90371C36.904 5.92347 35.5975 5.94428 34.8342 5.62616C34.1366 5.33539 33.2694 4.42487 32.4308 3.54445C30.8482 1.88306 29.0548 0 26.4995 0C23.9442 0 22.1508 1.88306 20.5683 3.54432C19.7298 4.42487 18.8626 5.33539 18.1649 5.62603C17.4018 5.94415 16.0953 5.92347 14.8326 5.90345C12.5825 5.86904 10.034 5.82795 8.30051 7.56981C6.56977 9.30867 6.62054 11.8551 6.6653 14.1018C6.69042 15.3671 6.71659 16.6754 6.40044 17.4416C6.11242 18.1394 5.20281 19.009 4.32318 19.8498C2.66663 21.4334 0.789062 23.2282 0.789062 25.7802C0.789062 28.3322 2.66663 30.1271 4.32318 31.7105C5.20281 32.5514 6.11242 33.4208 6.40031 34.1185C6.71659 34.885 6.69055 36.1933 6.6653 37.4586C6.62054 39.7052 6.5699 42.2514 8.30038 43.9904C9.39136 45.0866 10.8056 45.4771 12.2645 45.6072V65.037C12.2645 65.6959 12.5951 66.3107 13.1447 66.6742C13.694 67.0378 14.3895 67.1012 14.9957 66.8434L26.4995 61.9507L38.0035 66.8434C38.25 66.9482 38.5112 66.9999 38.7715 66.9999C39.151 66.9999 39.5284 66.8899 39.8543 66.6742C40.4038 66.3108 40.7345 65.6959 40.7345 65.037V45.6077C42.1934 45.4776 43.6075 45.087 44.6985 43.991C46.4292 42.2521 46.3785 39.7056 46.3337 37.459C46.3086 36.1937 46.2824 34.8854 46.5986 34.1192C46.8866 33.4213 47.7962 32.5518 48.6758 31.711C50.3324 30.1273 52.2099 28.3326 52.2099 25.7806C52.2099 23.2286 50.3325 21.4336 48.6759 19.8499ZM27.2676 58.0115C26.7769 57.8026 26.2221 57.8026 25.7314 58.0115L16.1903 62.0693V45.6517C16.9681 45.667 17.6775 45.7316 18.1649 45.9346C18.8626 46.2254 19.7298 47.1359 20.5683 48.0163C22.1508 49.6777 23.9442 51.5608 26.4995 51.5608C29.0548 51.5608 30.8482 49.6777 32.4306 48.0164C33.2692 47.1359 34.1364 46.2254 34.8341 45.9347C35.3216 45.7315 36.0309 45.6667 36.8087 45.6514V62.0692L27.2676 58.0115ZM45.9631 28.8732C44.7886 29.9958 43.5743 31.1567 42.9697 32.6216C42.3411 34.145 42.3755 35.8694 42.4087 37.5372C42.4379 39.0027 42.471 40.664 41.9159 41.2216C41.3588 41.7811 39.6957 41.7554 38.2281 41.7319C36.5634 41.706 34.8418 41.6788 33.3241 42.311C31.8636 42.9195 30.7066 44.1342 29.5876 45.309C28.5491 46.3993 27.3722 47.635 26.4992 47.635C25.6263 47.635 24.4493 46.3992 23.4107 45.3088C22.2918 44.1341 21.1349 42.9195 19.6744 42.3108C18.4612 41.8055 17.1179 41.7213 15.7774 41.7213C15.441 41.7213 15.1044 41.7267 14.7705 41.7319C13.3027 41.7548 11.6396 41.7813 11.0826 41.2216C10.5277 40.6639 10.5608 39.0029 10.5899 37.5372C10.6231 35.8694 10.6575 34.1448 10.0288 32.6214C9.42433 31.1567 8.20996 29.9958 7.0355 28.873C5.94753 27.8331 4.71445 26.6543 4.71445 25.7804C4.71445 24.9066 5.94753 23.7277 7.0355 22.6877C8.20996 21.5651 9.42433 20.4042 10.0289 18.9393C10.6575 17.4159 10.6231 15.6915 10.5899 14.0237C10.5607 12.558 10.5276 10.8968 11.0827 10.3392C11.6398 9.77963 13.3037 9.80554 14.7703 9.82897C16.436 9.85488 18.157 9.88223 19.6747 9.24979C21.1351 8.64142 22.292 7.42665 23.4108 6.25193C24.4495 5.16148 25.6265 3.92578 26.4995 3.92578C27.3725 3.92578 28.5495 5.16148 29.588 6.2518C30.7069 7.42665 31.8638 8.64129 33.3242 9.24965C34.842 9.8821 36.5632 9.85449 38.2285 9.82884C39.6961 9.80594 41.3592 9.77977 41.9163 10.3392C42.4711 10.8968 42.438 12.5579 42.409 14.0235C42.3757 15.6912 42.3413 17.4158 42.9701 18.9393C43.5745 20.404 44.7889 21.5648 45.9634 22.6876C47.0513 23.7275 48.2844 24.9064 48.2844 25.7803C48.2844 26.6542 47.0512 27.8331 45.9631 28.8732Z",
                fill: "#4A67FF"
            })
        }),
        title: 'Diligentsia Certification',
        points: [
            'At-a-glance bronze/silver/gold certification will save angels time',
            'Completeness and risk scoring',
            'Digital certification valid for 3 months',
            `Gold certification \u{2013} helps investors identify those comapny ready for investment`
        ],
        image: (parcelRequire("9WBs6")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "10%",
            right: '0px',
            top: '-10px'
        },
        animationImage: (parcelRequire("gkva9")),
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "53",
                height: "67",
                viewBox: "0 0 53 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M48.6759 19.8499C47.7963 19.009 46.8867 18.1396 46.5988 17.4418C46.2825 16.6754 46.3086 15.3671 46.3338 14.1019C46.3786 11.8552 46.4292 9.30893 44.6987 7.57008C42.9651 5.82808 40.4148 5.8676 38.1666 5.90371C36.904 5.92347 35.5975 5.94428 34.8342 5.62616C34.1366 5.33539 33.2694 4.42487 32.4308 3.54445C30.8482 1.88306 29.0548 0 26.4995 0C23.9442 0 22.1508 1.88306 20.5683 3.54432C19.7298 4.42487 18.8626 5.33539 18.1649 5.62603C17.4018 5.94415 16.0953 5.92347 14.8326 5.90345C12.5825 5.86904 10.034 5.82795 8.30051 7.56981C6.56977 9.30867 6.62054 11.8551 6.6653 14.1018C6.69042 15.3671 6.71659 16.6754 6.40044 17.4416C6.11242 18.1394 5.20281 19.009 4.32318 19.8498C2.66663 21.4334 0.789062 23.2282 0.789062 25.7802C0.789062 28.3322 2.66663 30.1271 4.32318 31.7105C5.20281 32.5514 6.11242 33.4208 6.40031 34.1185C6.71659 34.885 6.69055 36.1933 6.6653 37.4586C6.62054 39.7052 6.5699 42.2514 8.30038 43.9904C9.39136 45.0866 10.8056 45.4771 12.2645 45.6072V65.037C12.2645 65.6959 12.5951 66.3107 13.1447 66.6742C13.694 67.0378 14.3895 67.1012 14.9957 66.8434L26.4995 61.9507L38.0035 66.8434C38.25 66.9482 38.5112 66.9999 38.7715 66.9999C39.151 66.9999 39.5284 66.8899 39.8543 66.6742C40.4038 66.3108 40.7345 65.6959 40.7345 65.037V45.6077C42.1934 45.4776 43.6075 45.087 44.6985 43.991C46.4292 42.2521 46.3785 39.7056 46.3337 37.459C46.3086 36.1937 46.2824 34.8854 46.5986 34.1192C46.8866 33.4213 47.7962 32.5518 48.6758 31.711C50.3324 30.1273 52.2099 28.3326 52.2099 25.7806C52.2099 23.2286 50.3325 21.4336 48.6759 19.8499ZM27.2676 58.0115C26.7769 57.8026 26.2221 57.8026 25.7314 58.0115L16.1903 62.0693V45.6517C16.9681 45.667 17.6775 45.7316 18.1649 45.9346C18.8626 46.2254 19.7298 47.1359 20.5683 48.0163C22.1508 49.6777 23.9442 51.5608 26.4995 51.5608C29.0548 51.5608 30.8482 49.6777 32.4306 48.0164C33.2692 47.1359 34.1364 46.2254 34.8341 45.9347C35.3216 45.7315 36.0309 45.6667 36.8087 45.6514V62.0692L27.2676 58.0115ZM45.9631 28.8732C44.7886 29.9958 43.5743 31.1567 42.9697 32.6216C42.3411 34.145 42.3755 35.8694 42.4087 37.5372C42.4379 39.0027 42.471 40.664 41.9159 41.2216C41.3588 41.7811 39.6957 41.7554 38.2281 41.7319C36.5634 41.706 34.8418 41.6788 33.3241 42.311C31.8636 42.9195 30.7066 44.1342 29.5876 45.309C28.5491 46.3993 27.3722 47.635 26.4992 47.635C25.6263 47.635 24.4493 46.3992 23.4107 45.3088C22.2918 44.1341 21.1349 42.9195 19.6744 42.3108C18.4612 41.8055 17.1179 41.7213 15.7774 41.7213C15.441 41.7213 15.1044 41.7267 14.7705 41.7319C13.3027 41.7548 11.6396 41.7813 11.0826 41.2216C10.5277 40.6639 10.5608 39.0029 10.5899 37.5372C10.6231 35.8694 10.6575 34.1448 10.0288 32.6214C9.42433 31.1567 8.20996 29.9958 7.0355 28.873C5.94753 27.8331 4.71445 26.6543 4.71445 25.7804C4.71445 24.9066 5.94753 23.7277 7.0355 22.6877C8.20996 21.5651 9.42433 20.4042 10.0289 18.9393C10.6575 17.4159 10.6231 15.6915 10.5899 14.0237C10.5607 12.558 10.5276 10.8968 11.0827 10.3392C11.6398 9.77963 13.3037 9.80554 14.7703 9.82897C16.436 9.85488 18.157 9.88223 19.6747 9.24979C21.1351 8.64142 22.292 7.42665 23.4108 6.25193C24.4495 5.16148 25.6265 3.92578 26.4995 3.92578C27.3725 3.92578 28.5495 5.16148 29.588 6.2518C30.7069 7.42665 31.8638 8.64129 33.3242 9.24965C34.842 9.8821 36.5632 9.85449 38.2285 9.82884C39.6961 9.80594 41.3592 9.77977 41.9163 10.3392C42.4711 10.8968 42.438 12.5579 42.409 14.0235C42.3757 15.6912 42.3413 17.4158 42.9701 18.9393C43.5745 20.404 44.7889 21.5648 45.9634 22.6876C47.0513 23.7275 48.2844 24.9064 48.2844 25.7803C48.2844 26.6542 47.0512 27.8331 45.9631 28.8732Z",
                    fill: "#4A67FF"
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Diligentsia",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Certification"
                ]
            }),
            subMenu: {
                index: 3,
                points: [
                    " Bronze \u2013 basic level reached",
                    "Silver \u2013 potentially investible",
                    "Gold \u2013 sophisticated "
                ]
            },
            points: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginBottom: "-5px",
                        lineHeight: '20px'
                    },
                    children: "A simple feature to enable investors to distinguish between companies \u2013 driving up quality and saving time on investigation"
                }),
                "Your companies\u2019 self-complete checklist modules and recieve certification",
                'Detailed automated reporting, with suggestions for improvement.  Completeness and risk scoring.',
                'Unaudited certification:',
                'Digital certification valid for 3 months',
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        lineHeight: '20px',
                        marginTop: '-5px'
                    },
                    children: "Or, with Diligentsia Pro PLUS, have their lawyer or accountant can assist and provide you an AUDITED certificate"
                })
            ],
            image: (parcelRequire("9WBs6")),
            imageStyle: {
                height: '90%',
                width: '94%'
            },
            notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: "14px",
                    color: 'gray',
                    fontStyle: 'italic'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontWeight: "bold",
                            fontStyle: 'normal'
                        },
                        children: `Please Note: `
                    }),
                    "Diligentsia does NOT take responsiblity for the unaudited self-certification, which is indicative.  Third parties should undertake their own diligence. We remind companies, however, that third parties may seek to rely on information provided by companies in completion of our modules, and should do so accuratly and honestly with this in mind."
                ]
            }),
            cardPaddingBottom: {
                paddingBottom: '3rem'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "70",
            height: "59",
            viewBox: "0 0 70 59",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                fill: "#4A67FF"
            })
        }),
        title: "Portfolio Company\u2019s Data Repository",
        points: [
            'All their key corporate documents in one place',
            'Can link to',
            "Checklists to aid repository building, or use Diligentsia AI Filing Manager",
            `If you are an active NED investor you can access the company's key corporate documents easily`
        ],
        pointsImage: true,
        image: (parcelRequire("bb24K")),
        buttonLink: 'www.google.com',
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "70",
                height: "59",
                viewBox: "0 0 70 59",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M10.7249 0H38.096C40.2314 0 42.2643 0.253668 44.1239 1.24651L44.2923 1.34461C46.1689 2.39888 47.6851 4.12695 48.6606 6.94398L50.9295 13.4916H59.275C62.2269 13.4916 64.9097 14.6935 66.8511 16.6257C68.7923 18.5578 70 21.2292 70 24.1662V48.3244C70 51.2623 68.7923 53.9335 66.8511 55.8659C64.9097 57.798 62.2258 59 59.275 59H10.7249C7.77418 59 5.09016 57.798 3.14885 55.8659L2.99157 55.6953C1.14286 53.775 0 51.1751 0 48.3244V10.6755C0 7.74557 1.20661 5.07817 3.14789 3.14399V3.13312C5.08918 1.20094 7.77317 0 10.7249 0ZM39.0089 37.0841C41.1672 37.0841 42.9165 38.8258 42.9165 40.9742C42.9165 43.1233 41.1672 44.8641 39.0089 44.8641C36.8506 44.8641 35.1016 43.1233 35.1016 40.9742C35.1016 38.8258 36.8506 37.0841 39.0089 37.0841ZM28.9749 37.082C31.1332 37.082 32.8825 38.8249 32.8825 40.9742C32.8825 43.1233 31.1332 44.8662 28.9749 44.8662C26.8166 44.8662 25.0676 43.1233 25.0676 40.9742C25.0676 38.8249 26.8166 37.082 28.9749 37.082ZM18.7529 37.085C20.9112 37.085 22.6604 38.8258 22.6604 40.9742C22.6604 43.1224 20.9112 44.8632 18.7529 44.8632C16.5946 44.8632 14.8454 43.1224 14.8454 40.9742C14.8454 38.8258 16.5946 37.085 18.7529 37.085ZM38.096 5.24365H10.7249C9.22765 5.24365 7.86272 5.85599 6.87317 6.84092C5.88161 7.82087 5.26835 9.18133 5.26835 10.6755V48.3244C5.26835 49.7612 5.83584 51.0739 6.7567 52.049L6.87413 52.1579C7.86371 53.143 9.22864 53.7561 10.7249 53.7561H59.275C60.7713 53.7561 62.1362 53.143 63.1257 52.1579C64.1153 51.1731 64.7316 49.8146 64.7316 48.3244V24.1662C64.7316 22.6769 64.1153 21.3184 63.1257 20.3335C62.1362 19.3485 60.7724 18.7352 59.275 18.7352H49.0539C47.96 18.7332 46.9385 18.0505 46.5642 16.9636L43.6811 8.64427C43.1792 7.19664 42.5163 6.36234 41.7458 5.91249L41.6331 5.85599C40.7193 5.3685 39.4778 5.24365 38.096 5.24365Z",
                    fill: "#4A67FF"
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Portfolio Company\u2019s",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Data Repository"
                ]
            }),
            points: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginBottom: '-5px',
                        lineHeight: '20px'
                    },
                    children: "All an investee company's key corporate documentsin one place \u2013 easily accessible to all - incuding active NEDs"
                }),
                `Standard format - 20 sections \u{2013} 160 subsections -  standardise across all your portfolio - saves you time and cost`,
                `Up to 5 user-defined sections`,
                `Section checklists for easy creation`,
                'Already got a bunch of files?  AI Filing Manager will upload and organise their existing files/data room with a few clicks',
                'Prepopulated docs from UK Companies House',
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "df",
                        children: [
                            "Can sync to company\u2019s chosen cloud provider ",
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "df ml1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3374f3d4d67b8b1$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem mr0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $182b9a3f1701449a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem mr0-5rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1720bb8dd8ef814a$export$2e2bcd8739ae039), {
                                        className: "pen fds w2rem"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                'AI Deduper will help weed out old files',
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontWeight: "nold"
                    },
                    children: "Client unable/too busy?  Advisors can provide this chargeable service"
                })
            ],
            image: (parcelRequire("3Unna")),
            imageStyle: {
                height: '90%',
                width: '94%'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "83",
            height: "83",
            viewBox: "0 0 83 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    "clip-path": "url(#clip0_394_9580)",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M80.1158 53.9268L69.851 44.8704C70.6327 42.8154 71.0621 40.588 71.0621 38.262C71.0621 33.5795 69.3262 29.2949 66.4648 26.0171V7.45703C66.4648 6.11412 65.3761 5.02539 64.0332 5.02539H12.1582C10.8153 5.02539 9.72656 6.11412 9.72656 7.45703V40.6895H2.43164C1.08873 40.6895 0 41.7782 0 43.1211V70.6797C0 74.7021 3.2725 77.9746 7.29492 77.9746H59.1699C63.1923 77.9746 66.4648 74.7021 66.4648 70.6797V64.1206L68.0858 65.9574C71.3387 69.6438 77.0272 69.8213 80.5037 66.345C83.9801 62.8684 83.8024 57.1795 80.1158 53.9268ZM9.72656 70.6797C9.72656 72.0205 8.63573 73.1113 7.29492 73.1113C5.95412 73.1113 4.86328 72.0205 4.86328 70.6797V45.5527H9.72656V70.6797ZM61.6016 70.6797C61.6016 72.0205 60.5107 73.1113 59.1699 73.1113H14.1732C14.443 72.3505 14.5898 71.5319 14.5898 70.6797V9.88867H61.6016V22.0425C58.8895 20.501 55.2112 19.6152 51.875 19.6152C51.8457 19.6152 51.8351 19.6152 51.8348 19.6152H21.8848C20.5419 19.6152 19.4531 20.704 19.4531 22.0469C19.4531 23.3898 20.5419 24.4785 21.8848 24.4785H39.88C38.3507 25.871 37.0537 27.514 36.0534 29.3418H21.8848C20.5419 29.3418 19.4531 30.4305 19.4531 31.7734C19.4531 33.1164 20.5419 34.2051 21.8848 34.2051H34.2227C33.9316 35.5117 33.7769 36.869 33.7769 38.2619C33.7769 38.5321 33.7841 38.8007 33.7954 39.0684H21.8848C20.5419 39.0684 19.4531 40.1571 19.4531 41.5C19.4531 42.8429 20.5419 43.9316 21.8848 43.9316H34.6595C35.2183 45.6782 36.028 47.3134 37.0464 48.7949H21.8848C20.5419 48.7949 19.4531 49.8836 19.4531 51.2266C19.4531 52.5695 20.5419 53.6582 21.8848 53.6582H41.9197C44.9121 55.7053 48.5281 56.9044 52.4195 56.9044C54.7458 56.9044 56.9733 56.4749 59.0286 55.693L61.6016 58.6092V70.6797ZM52.4195 52.0413C44.8216 52.0413 38.6402 45.8599 38.6402 38.262C38.6402 30.6641 44.8216 24.4827 52.4195 24.4827C60.0174 24.4827 66.1988 30.6641 66.1988 38.262C66.1988 45.8599 60.0174 52.0413 52.4195 52.0413ZM77.0647 62.9062C75.5718 64.3991 73.129 64.3227 71.7323 62.7397L63.4112 53.3095C64.9622 52.1734 66.3316 50.8041 67.4675 49.253L76.8982 57.5736C78.4814 58.9704 78.5576 61.4134 77.0647 62.9062Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M36.4746 58.5215H21.8848C20.5419 58.5215 19.4531 59.6102 19.4531 60.9531C19.4531 62.296 20.5419 63.3848 21.8848 63.3848H36.4746C37.8175 63.3848 38.9062 62.296 38.9062 60.9531C38.9062 59.6102 37.8175 58.5215 36.4746 58.5215Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M60.8736 33.1868C60.7902 32.9535 60.6679 32.7416 60.5137 32.5631C60.3596 32.3845 60.1766 32.2429 59.9752 32.1463C59.7737 32.0497 59.5579 32 59.3398 32C59.1218 32 58.906 32.0498 58.7046 32.1464C58.5032 32.2431 58.3202 32.3847 58.166 32.5633L51.4352 40.3585L47.8339 36.1876C47.5226 35.8271 47.1004 35.6245 46.6601 35.6245C46.2198 35.6245 45.7976 35.8271 45.4862 36.1876C45.1749 36.5482 45 37.0372 45 37.5471C45 38.057 45.1749 38.5461 45.4862 38.9066L50.2613 44.4368C50.4154 44.6154 50.5984 44.757 50.7998 44.8536C51.0012 44.9503 51.2171 45 51.4351 45C51.6531 45 51.869 44.9503 52.0704 44.8536C52.2718 44.757 52.4548 44.6154 52.609 44.4368L60.5137 35.282C60.6679 35.1035 60.7902 34.8916 60.8736 34.6583C60.9571 34.4251 61 34.175 61 33.9226C61 33.6701 60.9571 33.4201 60.8736 33.1868Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_394_9580",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "83",
                            height: "83",
                            fill: "white"
                        })
                    })
                })
            ]
        }),
        title: `Bespoked Business Audit`,
        points: [
            "Step by step audit of each investee\xa0business",
            'Quickly identify strengths and weaknesses',
            `Individually bespoked to their business,
                industry, stage of development and objective`,
            `Reporting of risks and recommendations for rectification`
        ],
        image: (parcelRequire("izGj8")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "4%",
            right: '0px',
            bottom: '0px',
            animation: 'rotate 10s linear infinite'
        },
        baloonAnimationImage: (parcelRequire("3eaG9")),
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        "clip-path": "url(#clip0_394_9580)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M80.1158 53.9268L69.851 44.8704C70.6327 42.8154 71.0621 40.588 71.0621 38.262C71.0621 33.5795 69.3262 29.2949 66.4648 26.0171V7.45703C66.4648 6.11412 65.3761 5.02539 64.0332 5.02539H12.1582C10.8153 5.02539 9.72656 6.11412 9.72656 7.45703V40.6895H2.43164C1.08873 40.6895 0 41.7782 0 43.1211V70.6797C0 74.7021 3.2725 77.9746 7.29492 77.9746H59.1699C63.1923 77.9746 66.4648 74.7021 66.4648 70.6797V64.1206L68.0858 65.9574C71.3387 69.6438 77.0272 69.8213 80.5037 66.345C83.9801 62.8684 83.8024 57.1795 80.1158 53.9268ZM9.72656 70.6797C9.72656 72.0205 8.63573 73.1113 7.29492 73.1113C5.95412 73.1113 4.86328 72.0205 4.86328 70.6797V45.5527H9.72656V70.6797ZM61.6016 70.6797C61.6016 72.0205 60.5107 73.1113 59.1699 73.1113H14.1732C14.443 72.3505 14.5898 71.5319 14.5898 70.6797V9.88867H61.6016V22.0425C58.8895 20.501 55.2112 19.6152 51.875 19.6152C51.8457 19.6152 51.8351 19.6152 51.8348 19.6152H21.8848C20.5419 19.6152 19.4531 20.704 19.4531 22.0469C19.4531 23.3898 20.5419 24.4785 21.8848 24.4785H39.88C38.3507 25.871 37.0537 27.514 36.0534 29.3418H21.8848C20.5419 29.3418 19.4531 30.4305 19.4531 31.7734C19.4531 33.1164 20.5419 34.2051 21.8848 34.2051H34.2227C33.9316 35.5117 33.7769 36.869 33.7769 38.2619C33.7769 38.5321 33.7841 38.8007 33.7954 39.0684H21.8848C20.5419 39.0684 19.4531 40.1571 19.4531 41.5C19.4531 42.8429 20.5419 43.9316 21.8848 43.9316H34.6595C35.2183 45.6782 36.028 47.3134 37.0464 48.7949H21.8848C20.5419 48.7949 19.4531 49.8836 19.4531 51.2266C19.4531 52.5695 20.5419 53.6582 21.8848 53.6582H41.9197C44.9121 55.7053 48.5281 56.9044 52.4195 56.9044C54.7458 56.9044 56.9733 56.4749 59.0286 55.693L61.6016 58.6092V70.6797ZM52.4195 52.0413C44.8216 52.0413 38.6402 45.8599 38.6402 38.262C38.6402 30.6641 44.8216 24.4827 52.4195 24.4827C60.0174 24.4827 66.1988 30.6641 66.1988 38.262C66.1988 45.8599 60.0174 52.0413 52.4195 52.0413ZM77.0647 62.9062C75.5718 64.3991 73.129 64.3227 71.7323 62.7397L63.4112 53.3095C64.9622 52.1734 66.3316 50.8041 67.4675 49.253L76.8982 57.5736C78.4814 58.9704 78.5576 61.4134 77.0647 62.9062Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M36.4746 58.5215H21.8848C20.5419 58.5215 19.4531 59.6102 19.4531 60.9531C19.4531 62.296 20.5419 63.3848 21.8848 63.3848H36.4746C37.8175 63.3848 38.9062 62.296 38.9062 60.9531C38.9062 59.6102 37.8175 58.5215 36.4746 58.5215Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M60.8736 33.1868C60.7902 32.9535 60.6679 32.7416 60.5137 32.5631C60.3596 32.3845 60.1766 32.2429 59.9752 32.1463C59.7737 32.0497 59.5579 32 59.3398 32C59.1218 32 58.906 32.0498 58.7046 32.1464C58.5032 32.2431 58.3202 32.3847 58.166 32.5633L51.4352 40.3585L47.8339 36.1876C47.5226 35.8271 47.1004 35.6245 46.6601 35.6245C46.2198 35.6245 45.7976 35.8271 45.4862 36.1876C45.1749 36.5482 45 37.0372 45 37.5471C45 38.057 45.1749 38.5461 45.4862 38.9066L50.2613 44.4368C50.4154 44.6154 50.5984 44.757 50.7998 44.8536C51.0012 44.9503 51.2171 45 51.4351 45C51.6531 45 51.869 44.9503 52.0704 44.8536C52.2718 44.757 52.4548 44.6154 52.609 44.4368L60.5137 35.282C60.6679 35.1035 60.7902 34.8916 60.8736 34.6583C60.9571 34.4251 61 34.175 61 33.9226C61 33.6701 60.9571 33.4201 60.8736 33.1868Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_394_9580",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "83",
                                height: "83",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Bespoked Business",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Audit"
                ]
            }),
            points: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginBottom: "-5px",
                        lineHeight: '20px'
                    },
                    children: "Step by step audit of your investee company's business - great for pre-investment review"
                }),
                'Quick - multiple choice questions',
                `Individually bespoked to your applicant  company's business, industry, stage of development and objective`,
                'At a  a glance red/amber/green status',
                'Both section and overall completeness and risk scores',
                'Quickly identify strengths and weaknesses',
                'Risks and recommendations for each section - company gains from experience',
                "\u2026...all in real-time",
                'Improvement tracking over time',
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontWeight: 'bold'
                    },
                    children: "Client unable/too busy?  Advisors can provide this chargeable service via Diligentsia Pro Plus"
                })
            ],
            image: (parcelRequire("izGj8")),
            imageStyle: {
                height: '76%',
                width: '100%'
            },
            cardPaddingBottom: {
                paddingBottom: '3rem'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "83",
            height: "83",
            viewBox: "0 0 83 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    "clip-path": "url(#clip0_394_9639)",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M82.3516 5.76409L72.6686 0.173748C72.4715 0.0599237 72.2478 0 72.0202 0C71.7925 0 71.5689 0.0599237 71.3717 0.173748L61.6888 5.76409C61.4916 5.87791 61.3279 6.04162 61.2141 6.23877C61.1003 6.43591 61.0403 6.65954 61.0403 6.88718V18.0682C61.0403 18.2958 61.1003 18.5195 61.2141 18.7166C61.3279 18.9138 61.4916 19.0775 61.6888 19.1913L71.3717 24.7818C71.5689 24.8955 71.7925 24.9554 72.0202 24.9554C72.2478 24.9554 72.4714 24.8955 72.6686 24.7818L82.3516 19.1913C82.5487 19.0775 82.7124 18.9138 82.8262 18.7166C82.9401 18.5195 83 18.2958 83 18.0682V6.88718C83 6.65954 82.9401 6.43591 82.8262 6.23877C82.7124 6.04162 82.5487 5.87791 82.3516 5.76409ZM72.0202 2.79425L79.1094 6.88718L72.0202 10.9801L64.931 6.88718L72.0202 2.79425ZM63.6341 9.13353L70.7233 13.2265V21.413L63.6341 17.3201V9.13353ZM73.317 21.4123V13.2265L80.4062 9.13353V17.3201L73.317 21.4123ZM47.7088 42.7968V71.7266H53.0746C53.4186 71.7266 53.7484 71.8632 53.9916 72.1064C54.2348 72.3496 54.3715 72.6795 54.3715 73.0234C54.3715 73.3674 54.2348 73.6973 53.9916 73.9405C53.7484 74.1837 53.4186 74.3203 53.0746 74.3203H46.4119C46.068 74.3203 45.7381 74.1837 45.4949 73.9405C45.2517 73.6973 45.115 73.3674 45.115 73.0234V42.7968H39.0744C38.7304 42.7968 38.4005 42.6602 38.1573 42.417C37.9141 42.1738 37.7775 41.8439 37.7775 41.5C37.7775 41.156 37.9141 40.8261 38.1573 40.5829C38.4005 40.3397 38.7304 40.2031 39.0744 40.2031H45.115V9.9765C45.115 9.63255 45.2517 9.30268 45.4949 9.05947C45.7381 8.81626 46.068 8.67963 46.4119 8.67963H53.0746C53.4186 8.67963 53.7484 8.81626 53.9916 9.05947C54.2348 9.30268 54.3715 9.63255 54.3715 9.9765C54.3715 10.3205 54.2348 10.6503 53.9916 10.8935C53.7484 11.1367 53.4186 11.2734 53.0746 11.2734H47.7088V40.2031H53.0746C53.4186 40.2031 53.7484 40.3397 53.9916 40.5829C54.2348 40.8261 54.3715 41.156 54.3715 41.5C54.3715 41.8439 54.2348 42.1738 53.9916 42.417C53.7484 42.6602 53.4186 42.7968 53.0746 42.7968H47.7088ZM82.3516 34.7864L72.6686 29.1959C72.4715 29.082 72.2478 29.0221 72.0202 29.0221C71.7925 29.0221 71.5689 29.082 71.3717 29.1959L61.6888 34.7864C61.4916 34.9002 61.3279 35.0639 61.2141 35.261C61.1003 35.4582 61.0403 35.6818 61.0403 35.9095V47.0903C61.0403 47.318 61.1002 47.5416 61.2141 47.7388C61.3279 47.936 61.4916 48.0997 61.6888 48.2136L71.3717 53.8041C71.5689 53.9179 71.7925 53.9778 72.0202 53.9778C72.2478 53.9778 72.4715 53.9179 72.6686 53.8041L82.3516 48.2136C82.5487 48.0997 82.7125 47.936 82.8263 47.7388C82.9401 47.5416 83 47.318 83 47.0903V35.9095C83 35.6818 82.9401 35.4582 82.8262 35.261C82.7124 35.0639 82.5487 34.9002 82.3516 34.7864ZM72.0202 31.8165L79.1094 35.9095L72.0202 40.0024L64.931 35.9095L72.0202 31.8165ZM63.6341 38.1558L70.7233 42.2486V50.4351L63.6341 46.3422V38.1558ZM73.317 50.4346V42.2481L80.4062 38.1557V46.3422L73.317 50.4346ZM82.3516 63.8086L72.6686 58.2181C72.4715 58.1043 72.2478 58.0444 72.0202 58.0444C71.7925 58.0444 71.5689 58.1043 71.3717 58.2181L61.6888 63.8086C61.4916 63.9225 61.3279 64.0862 61.2141 64.2833C61.1003 64.4805 61.0403 64.7041 61.0403 64.9317V76.1126C61.0403 76.3402 61.1003 76.5639 61.2141 76.761C61.3279 76.9582 61.4916 77.1219 61.6888 77.2357L71.3717 82.8262C71.5689 82.94 71.7925 82.9999 72.0202 82.9999C72.2478 82.9999 72.4715 82.94 72.6686 82.8262L82.3516 77.2357C82.5487 77.1219 82.7124 76.9582 82.8262 76.761C82.9401 76.5639 83 76.3402 83 76.1126V64.9317C83 64.7041 82.9401 64.4805 82.8262 64.2833C82.7124 64.0862 82.5487 63.9225 82.3516 63.8086ZM72.0202 60.8396L79.1094 64.9317L72.0202 69.0247L64.931 64.9317L72.0202 60.8396ZM63.6341 67.1781L70.7233 71.271V79.4576L63.6341 75.3646V67.1781ZM73.317 79.4571V71.2705L80.4062 67.1781V75.3646L73.317 79.4571ZM26.2406 41.192C24.2839 40.7044 22.2929 40.3664 20.2849 40.1807C23.2074 38.5424 25.2521 34.8395 25.2521 30.5415C25.2521 25.2281 22.0608 21.9272 16.9234 21.9272C11.786 21.9272 8.59439 25.2279 8.59439 30.5414C8.59439 34.8311 10.6315 38.5279 13.545 40.1707C11.5374 40.3499 9.54773 40.6921 7.59563 41.1941C2.6975 42.4538 0 45.1474 0 48.7767V59.7757C0 60.1196 0.136635 60.4495 0.379846 60.6927C0.623057 60.9359 0.952922 61.0726 1.29688 61.0726C1.64083 61.0726 1.97069 60.9359 2.2139 60.6927C2.45712 60.4495 2.59375 60.1196 2.59375 59.7757V48.7767C2.59375 45.7863 5.66475 44.369 8.24115 43.7064C13.8988 42.2515 19.7444 42.2526 25.6162 43.7092C27.7212 44.2313 31.2527 45.584 31.2527 48.7767V59.7757C31.2527 60.1196 31.3894 60.4495 31.6326 60.6927C31.8758 60.9359 32.2057 61.0726 32.5496 61.0726C32.8936 61.0726 33.2234 60.9359 33.4666 60.6927C33.7099 60.4495 33.8465 60.1196 33.8465 59.7757V48.7767C33.8465 45.1554 31.0743 42.3916 26.2406 41.192ZM11.1881 30.5414C11.1881 25.303 14.7815 24.5208 16.9234 24.5208C19.0654 24.5208 22.6584 25.303 22.6584 30.5414C22.6584 34.9224 20.0857 38.4867 16.9234 38.4867C13.7611 38.4867 11.1881 34.9224 11.1881 30.5414ZM9.69414 51.4444V59.7759C9.69414 60.1198 9.55751 60.4497 9.31429 60.6929C9.07108 60.9361 8.74122 61.0727 8.39727 61.0727C8.05331 61.0727 7.72345 60.9361 7.48024 60.6929C7.23703 60.4497 7.10039 60.1198 7.10039 59.7759V51.4444C7.10039 51.1004 7.23703 50.7706 7.48024 50.5274C7.72345 50.2842 8.05331 50.1475 8.39727 50.1475C8.74122 50.1475 9.07108 50.2842 9.31429 50.5274C9.55751 50.7706 9.69414 51.1004 9.69414 51.4444ZM26.7453 51.4444V59.7759C26.7453 60.1198 26.6087 60.4497 26.3654 60.6929C26.1222 60.9361 25.7924 61.0727 25.4484 61.0727C25.1045 61.0727 24.7746 60.9361 24.5314 60.6929C24.2882 60.4497 24.1515 60.1198 24.1515 59.7759V51.4444C24.1515 51.1004 24.2882 50.7706 24.5314 50.5274C24.7746 50.2842 25.1045 50.1475 25.4484 50.1475C25.7924 50.1475 26.1222 50.2842 26.3654 50.5274C26.6087 50.7706 26.7453 51.1004 26.7453 51.4444Z",
                        fill: "#4A67FF"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_394_9639",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "83",
                            height: "83",
                            fill: "white"
                        })
                    })
                })
            ]
        }),
        title: `Expansion Packs* `,
        points: [
            'Enable your portfolio companies to go into more depth e.g. cybersecurity',
            'Bespoked to each company, its industry etc.',
            `Count towards their certification`
        ],
        image: (parcelRequire("9yeTX")),
        buttonLink: 'www.google.com',
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                        "clip-path": "url(#clip0_394_9639)",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M82.3516 5.76409L72.6686 0.173748C72.4715 0.0599237 72.2478 0 72.0202 0C71.7925 0 71.5689 0.0599237 71.3717 0.173748L61.6888 5.76409C61.4916 5.87791 61.3279 6.04162 61.2141 6.23877C61.1003 6.43591 61.0403 6.65954 61.0403 6.88718V18.0682C61.0403 18.2958 61.1003 18.5195 61.2141 18.7166C61.3279 18.9138 61.4916 19.0775 61.6888 19.1913L71.3717 24.7818C71.5689 24.8955 71.7925 24.9554 72.0202 24.9554C72.2478 24.9554 72.4714 24.8955 72.6686 24.7818L82.3516 19.1913C82.5487 19.0775 82.7124 18.9138 82.8262 18.7166C82.9401 18.5195 83 18.2958 83 18.0682V6.88718C83 6.65954 82.9401 6.43591 82.8262 6.23877C82.7124 6.04162 82.5487 5.87791 82.3516 5.76409ZM72.0202 2.79425L79.1094 6.88718L72.0202 10.9801L64.931 6.88718L72.0202 2.79425ZM63.6341 9.13353L70.7233 13.2265V21.413L63.6341 17.3201V9.13353ZM73.317 21.4123V13.2265L80.4062 9.13353V17.3201L73.317 21.4123ZM47.7088 42.7968V71.7266H53.0746C53.4186 71.7266 53.7484 71.8632 53.9916 72.1064C54.2348 72.3496 54.3715 72.6795 54.3715 73.0234C54.3715 73.3674 54.2348 73.6973 53.9916 73.9405C53.7484 74.1837 53.4186 74.3203 53.0746 74.3203H46.4119C46.068 74.3203 45.7381 74.1837 45.4949 73.9405C45.2517 73.6973 45.115 73.3674 45.115 73.0234V42.7968H39.0744C38.7304 42.7968 38.4005 42.6602 38.1573 42.417C37.9141 42.1738 37.7775 41.8439 37.7775 41.5C37.7775 41.156 37.9141 40.8261 38.1573 40.5829C38.4005 40.3397 38.7304 40.2031 39.0744 40.2031H45.115V9.9765C45.115 9.63255 45.2517 9.30268 45.4949 9.05947C45.7381 8.81626 46.068 8.67963 46.4119 8.67963H53.0746C53.4186 8.67963 53.7484 8.81626 53.9916 9.05947C54.2348 9.30268 54.3715 9.63255 54.3715 9.9765C54.3715 10.3205 54.2348 10.6503 53.9916 10.8935C53.7484 11.1367 53.4186 11.2734 53.0746 11.2734H47.7088V40.2031H53.0746C53.4186 40.2031 53.7484 40.3397 53.9916 40.5829C54.2348 40.8261 54.3715 41.156 54.3715 41.5C54.3715 41.8439 54.2348 42.1738 53.9916 42.417C53.7484 42.6602 53.4186 42.7968 53.0746 42.7968H47.7088ZM82.3516 34.7864L72.6686 29.1959C72.4715 29.082 72.2478 29.0221 72.0202 29.0221C71.7925 29.0221 71.5689 29.082 71.3717 29.1959L61.6888 34.7864C61.4916 34.9002 61.3279 35.0639 61.2141 35.261C61.1003 35.4582 61.0403 35.6818 61.0403 35.9095V47.0903C61.0403 47.318 61.1002 47.5416 61.2141 47.7388C61.3279 47.936 61.4916 48.0997 61.6888 48.2136L71.3717 53.8041C71.5689 53.9179 71.7925 53.9778 72.0202 53.9778C72.2478 53.9778 72.4715 53.9179 72.6686 53.8041L82.3516 48.2136C82.5487 48.0997 82.7125 47.936 82.8263 47.7388C82.9401 47.5416 83 47.318 83 47.0903V35.9095C83 35.6818 82.9401 35.4582 82.8262 35.261C82.7124 35.0639 82.5487 34.9002 82.3516 34.7864ZM72.0202 31.8165L79.1094 35.9095L72.0202 40.0024L64.931 35.9095L72.0202 31.8165ZM63.6341 38.1558L70.7233 42.2486V50.4351L63.6341 46.3422V38.1558ZM73.317 50.4346V42.2481L80.4062 38.1557V46.3422L73.317 50.4346ZM82.3516 63.8086L72.6686 58.2181C72.4715 58.1043 72.2478 58.0444 72.0202 58.0444C71.7925 58.0444 71.5689 58.1043 71.3717 58.2181L61.6888 63.8086C61.4916 63.9225 61.3279 64.0862 61.2141 64.2833C61.1003 64.4805 61.0403 64.7041 61.0403 64.9317V76.1126C61.0403 76.3402 61.1003 76.5639 61.2141 76.761C61.3279 76.9582 61.4916 77.1219 61.6888 77.2357L71.3717 82.8262C71.5689 82.94 71.7925 82.9999 72.0202 82.9999C72.2478 82.9999 72.4715 82.94 72.6686 82.8262L82.3516 77.2357C82.5487 77.1219 82.7124 76.9582 82.8262 76.761C82.9401 76.5639 83 76.3402 83 76.1126V64.9317C83 64.7041 82.9401 64.4805 82.8262 64.2833C82.7124 64.0862 82.5487 63.9225 82.3516 63.8086ZM72.0202 60.8396L79.1094 64.9317L72.0202 69.0247L64.931 64.9317L72.0202 60.8396ZM63.6341 67.1781L70.7233 71.271V79.4576L63.6341 75.3646V67.1781ZM73.317 79.4571V71.2705L80.4062 67.1781V75.3646L73.317 79.4571ZM26.2406 41.192C24.2839 40.7044 22.2929 40.3664 20.2849 40.1807C23.2074 38.5424 25.2521 34.8395 25.2521 30.5415C25.2521 25.2281 22.0608 21.9272 16.9234 21.9272C11.786 21.9272 8.59439 25.2279 8.59439 30.5414C8.59439 34.8311 10.6315 38.5279 13.545 40.1707C11.5374 40.3499 9.54773 40.6921 7.59563 41.1941C2.6975 42.4538 0 45.1474 0 48.7767V59.7757C0 60.1196 0.136635 60.4495 0.379846 60.6927C0.623057 60.9359 0.952922 61.0726 1.29688 61.0726C1.64083 61.0726 1.97069 60.9359 2.2139 60.6927C2.45712 60.4495 2.59375 60.1196 2.59375 59.7757V48.7767C2.59375 45.7863 5.66475 44.369 8.24115 43.7064C13.8988 42.2515 19.7444 42.2526 25.6162 43.7092C27.7212 44.2313 31.2527 45.584 31.2527 48.7767V59.7757C31.2527 60.1196 31.3894 60.4495 31.6326 60.6927C31.8758 60.9359 32.2057 61.0726 32.5496 61.0726C32.8936 61.0726 33.2234 60.9359 33.4666 60.6927C33.7099 60.4495 33.8465 60.1196 33.8465 59.7757V48.7767C33.8465 45.1554 31.0743 42.3916 26.2406 41.192ZM11.1881 30.5414C11.1881 25.303 14.7815 24.5208 16.9234 24.5208C19.0654 24.5208 22.6584 25.303 22.6584 30.5414C22.6584 34.9224 20.0857 38.4867 16.9234 38.4867C13.7611 38.4867 11.1881 34.9224 11.1881 30.5414ZM9.69414 51.4444V59.7759C9.69414 60.1198 9.55751 60.4497 9.31429 60.6929C9.07108 60.9361 8.74122 61.0727 8.39727 61.0727C8.05331 61.0727 7.72345 60.9361 7.48024 60.6929C7.23703 60.4497 7.10039 60.1198 7.10039 59.7759V51.4444C7.10039 51.1004 7.23703 50.7706 7.48024 50.5274C7.72345 50.2842 8.05331 50.1475 8.39727 50.1475C8.74122 50.1475 9.07108 50.2842 9.31429 50.5274C9.55751 50.7706 9.69414 51.1004 9.69414 51.4444ZM26.7453 51.4444V59.7759C26.7453 60.1198 26.6087 60.4497 26.3654 60.6929C26.1222 60.9361 25.7924 61.0727 25.4484 61.0727C25.1045 61.0727 24.7746 60.9361 24.5314 60.6929C24.2882 60.4497 24.1515 60.1198 24.1515 59.7759V51.4444C24.1515 51.1004 24.2882 50.7706 24.5314 50.5274C24.7746 50.2842 25.1045 50.1475 25.4484 50.1475C25.7924 50.1475 26.1222 50.2842 26.3654 50.5274C26.6087 50.7706 26.7453 51.1004 26.7453 51.4444Z",
                            fill: "#4A67FF"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_394_9639",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "83",
                                height: "83",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            title: `Expansion Packs*`,
            subMenu: {
                index: 5,
                points: [
                    "\u2022 Warranty Disclosures",
                    `\u{2022} Directors' Questionnaires`,
                    `\u{2022} Software Development`,
                    `\u{2022} ESG`,
                    `\u{2022} Cybersecurity`,
                    `\u{2022} Investor Leads for follow on rounds`,
                    `\u{2022} more coming to Diligentsia AppStore soon`
                ]
            },
            points: [
                'Enable your companies to go into more depth',
                'Some count towards their certification',
                'Bespoked to their company, its industry etc.',
                'Where possible, prepopulated',
                'Completeness and risk scoring',
                'Help prepare them for exit'
            ],
            image: (parcelRequire("2VRxR")),
            notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: "14px",
                    color: 'gray',
                    fontStyle: 'italic'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontWeight: "bold",
                            fontStyle: 'normal'
                        },
                        children: `Please Note: `
                    }),
                    "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provide the tools for their generation.  Parties looking for more assurance should take additional external professional advice."
                ]
            }),
            imageStyle: {
                height: '85%',
                width: '94%'
            },
            cardPaddingBottom: {
                paddingBottom: '2rem'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "61",
            height: "61",
            viewBox: "0 0 61 61",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M41.5097 47.2986C42.4967 47.2986 43.2968 46.4985 43.2968 45.5115V36.5761C43.2968 35.5892 42.4967 34.7891 41.5097 34.7891C40.5228 34.7891 39.7227 35.5892 39.7227 36.5761V45.5115C39.7227 46.4985 40.5227 47.2986 41.5097 47.2986Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M41.5097 53.8515C42.4967 53.8515 43.2968 53.0514 43.2968 52.0644C43.2968 51.0774 42.4967 50.2773 41.5097 50.2773C40.5228 50.2773 39.7227 51.0774 39.7227 52.0644C39.7227 53.0514 40.5228 53.8515 41.5097 53.8515Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M60.2943 52.9947L49.8187 34.5083C50.755 31.0922 51.2296 27.567 51.2296 24.0177V4.16964C51.2296 2.81325 49.7777 1.9514 48.5869 2.60106L48.076 2.87973C41.2031 6.62879 32.6536 5.65292 26.8021 0.451565L26.8019 0.451327C26.1248 -0.150442 25.1047 -0.150442 24.4277 0.451327L24.4275 0.451565C18.576 5.65304 10.0267 6.62867 3.15372 2.87985L2.64273 2.60106C1.45194 1.9514 0 2.81325 0 4.16964V24.0177C0 31.9811 2.3599 39.6761 6.82438 46.2704C11.2891 52.8647 17.5571 57.9136 24.951 60.8712C25.3682 61.0381 25.8325 61.0405 26.2517 60.8804C26.6152 60.9573 26.9952 60.9989 27.3896 60.9989H55.6299C59.7378 60.999 62.3195 56.5686 60.2943 52.9947ZM23.8277 48.27C17.7053 44.2901 13.3882 38.1987 11.6176 31.2144H23.8277V48.27ZM23.8277 27.6403H10.9459C10.7984 26.4495 10.7225 25.2404 10.7225 24.0178V15.8434C11.169 15.8639 11.6157 15.8743 12.0604 15.8743C16.1158 15.8743 20.1304 15.0271 23.8277 13.4103V27.6403ZM24.7354 8.96974C20.8807 11.1487 16.4977 12.3004 12.0604 12.3004C11.0876 12.3004 10.105 12.244 9.1396 12.1329C8.07879 12.0106 7.14832 12.8401 7.14832 13.9079V24.0178C7.14832 35.6899 13.2668 46.2912 23.2324 52.0996L22.7252 52.9946C22.2606 53.8145 22.041 54.6793 22.0241 55.5257C10.6815 49.1987 3.57416 37.283 3.57416 24.0177V7.0366C6.29588 8.1627 9.17558 8.71562 12.0449 8.71538C16.874 8.71514 21.6705 7.14775 25.6148 4.10638C31.9028 8.95509 40.3531 10.058 47.6555 7.0366V24.0178C47.6555 25.9771 47.4964 27.9283 47.1813 29.854L46.1742 28.0768C45.6362 27.1274 44.8798 26.4293 44.0208 25.9773C44.0595 25.3235 44.0813 24.6685 44.0813 24.0178V13.9079C44.0813 12.8401 43.1509 12.0106 42.0901 12.1328C41.1248 12.2439 40.142 12.3003 39.1692 12.3003C34.7319 12.3003 30.349 11.1485 26.4942 8.96962C25.9485 8.66129 25.2811 8.66129 24.7354 8.96974ZM27.4019 27.6403V13.4104C31.0991 15.0271 35.1137 15.8744 39.1692 15.8744C39.614 15.8744 40.0606 15.8641 40.5071 15.8436V24.0179C40.5071 24.4965 40.4946 24.9779 40.471 25.459C39.1748 25.7103 37.9597 26.4384 37.1234 27.6403H27.4019ZM35.0674 31.2145L27.4019 44.7418V31.2145H35.0674ZM55.6299 57.4249H27.3897C26.0205 57.4249 25.1598 55.948 25.835 54.7568L39.9551 29.839C40.6396 28.631 42.3801 28.631 43.0647 29.839L57.1848 54.7568C57.8597 55.948 56.9991 57.4249 55.6299 57.4249Z",
                    fill: "#4A67FF"
                })
            ]
        }),
        title: `Expansion Pack - Warranty Disclosure * `,
        points: [
            'Normally an expensive exercise at the end of a transaction',
            'Get ahead, early completion will identify showstoppers',
            `Based on the UK BVCA standard disclosure letter`
        ],
        image: (parcelRequire("bnaJ5")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "10%",
            left: '0px'
        },
        animationImage: (parcelRequire("gkva9")),
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "61",
                height: "61",
                viewBox: "0 0 61 61",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M41.5097 47.2986C42.4967 47.2986 43.2968 46.4985 43.2968 45.5115V36.5761C43.2968 35.5892 42.4967 34.7891 41.5097 34.7891C40.5228 34.7891 39.7227 35.5892 39.7227 36.5761V45.5115C39.7227 46.4985 40.5227 47.2986 41.5097 47.2986Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M41.5097 53.8515C42.4967 53.8515 43.2968 53.0514 43.2968 52.0644C43.2968 51.0774 42.4967 50.2773 41.5097 50.2773C40.5228 50.2773 39.7227 51.0774 39.7227 52.0644C39.7227 53.0514 40.5228 53.8515 41.5097 53.8515Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M60.2943 52.9947L49.8187 34.5083C50.755 31.0922 51.2296 27.567 51.2296 24.0177V4.16964C51.2296 2.81325 49.7777 1.9514 48.5869 2.60106L48.076 2.87973C41.2031 6.62879 32.6536 5.65292 26.8021 0.451565L26.8019 0.451327C26.1248 -0.150442 25.1047 -0.150442 24.4277 0.451327L24.4275 0.451565C18.576 5.65304 10.0267 6.62867 3.15372 2.87985L2.64273 2.60106C1.45194 1.9514 0 2.81325 0 4.16964V24.0177C0 31.9811 2.3599 39.6761 6.82438 46.2704C11.2891 52.8647 17.5571 57.9136 24.951 60.8712C25.3682 61.0381 25.8325 61.0405 26.2517 60.8804C26.6152 60.9573 26.9952 60.9989 27.3896 60.9989H55.6299C59.7378 60.999 62.3195 56.5686 60.2943 52.9947ZM23.8277 48.27C17.7053 44.2901 13.3882 38.1987 11.6176 31.2144H23.8277V48.27ZM23.8277 27.6403H10.9459C10.7984 26.4495 10.7225 25.2404 10.7225 24.0178V15.8434C11.169 15.8639 11.6157 15.8743 12.0604 15.8743C16.1158 15.8743 20.1304 15.0271 23.8277 13.4103V27.6403ZM24.7354 8.96974C20.8807 11.1487 16.4977 12.3004 12.0604 12.3004C11.0876 12.3004 10.105 12.244 9.1396 12.1329C8.07879 12.0106 7.14832 12.8401 7.14832 13.9079V24.0178C7.14832 35.6899 13.2668 46.2912 23.2324 52.0996L22.7252 52.9946C22.2606 53.8145 22.041 54.6793 22.0241 55.5257C10.6815 49.1987 3.57416 37.283 3.57416 24.0177V7.0366C6.29588 8.1627 9.17558 8.71562 12.0449 8.71538C16.874 8.71514 21.6705 7.14775 25.6148 4.10638C31.9028 8.95509 40.3531 10.058 47.6555 7.0366V24.0178C47.6555 25.9771 47.4964 27.9283 47.1813 29.854L46.1742 28.0768C45.6362 27.1274 44.8798 26.4293 44.0208 25.9773C44.0595 25.3235 44.0813 24.6685 44.0813 24.0178V13.9079C44.0813 12.8401 43.1509 12.0106 42.0901 12.1328C41.1248 12.2439 40.142 12.3003 39.1692 12.3003C34.7319 12.3003 30.349 11.1485 26.4942 8.96962C25.9485 8.66129 25.2811 8.66129 24.7354 8.96974ZM27.4019 27.6403V13.4104C31.0991 15.0271 35.1137 15.8744 39.1692 15.8744C39.614 15.8744 40.0606 15.8641 40.5071 15.8436V24.0179C40.5071 24.4965 40.4946 24.9779 40.471 25.459C39.1748 25.7103 37.9597 26.4384 37.1234 27.6403H27.4019ZM35.0674 31.2145L27.4019 44.7418V31.2145H35.0674ZM55.6299 57.4249H27.3897C26.0205 57.4249 25.1598 55.948 25.835 54.7568L39.9551 29.839C40.6396 28.631 42.3801 28.631 43.0647 29.839L57.1848 54.7568C57.8597 55.948 56.9991 57.4249 55.6299 57.4249Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Expansion Pack - Draft Warranty",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    " Disclosure*"
                ]
            }),
            points: [
                'Quick way of uncovering issues prior to your investment',
                'Normally an expensive exercise at the end of a transaction',
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Get ahead, early completion will identify showstoppers and give the company time to fix them"
                }),
                'Can upload supporting files and notes',
                'Based on the UK BVCA standard disclosure letter',
                'At a glance section completion and risk scoring',
                'Contributes to Diligentsia certification',
                'Part of DD Pack made available to you',
                'Still subject to formal legal review later in investment/exit process'
            ],
            image: (parcelRequire("bnaJ5")),
            imageStyle: {
                height: '90%',
                width: '94%'
            },
            cardPaddingBottom: {
                paddingBottom: '2rem'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "83",
            height: "83",
            viewBox: "0 0 83 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                    fill: "#4A67FF"
                })
            ]
        }),
        title: `Expansion Pack - Directors\u{2019} Questionnaires * `,
        points: [
            'Find out who you are investing in',
            'Normally part of purchase/sale or investment',
            'Pre-population from Companies House where relevant',
            `Per director.Identify any issues in advance`
        ],
        image: (parcelRequire("etzTw")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "4%",
            right: '0px',
            top: '150px',
            animation: 'rotate 10s linear infinite'
        },
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M29.7246 39.668C30.8087 39.668 31.6875 38.7891 31.6875 37.7051C31.6875 36.621 30.8087 35.7422 29.7246 35.7422C28.6405 35.7422 27.7617 36.621 27.7617 37.7051C27.7617 38.7891 28.6405 39.668 29.7246 39.668Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M66.5793 44.1764C65.8171 43.4056 64.5744 43.3987 63.8033 44.1611L53.283 54.5657L50.7376 52.0202C49.9711 51.2536 48.7282 51.2536 47.9616 52.0202C47.1951 52.7868 47.1951 54.0295 47.9616 54.7961L51.8874 58.7219C52.2707 59.1052 52.7729 59.2969 53.2754 59.2969C53.7744 59.2969 54.2733 59.1079 54.6558 58.7296L66.5639 46.9523C67.3348 46.19 67.3415 44.9471 66.5793 44.1764Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M65.1855 31.8164H51.3144V17.8144C51.3144 12.4028 46.9116 8 41.5 8H17.8144C12.4028 8 8 12.4028 8 17.8144V37.705C8 42.4446 11.3775 46.4103 15.8516 47.3223V53.4082C15.8516 54.1991 16.3263 54.9128 17.0557 55.2185C17.7909 55.5265 18.6314 55.358 19.1908 54.8074L26.6005 47.5195H35.6113V57.3339C35.6113 62.7456 40.0141 67.1484 45.4257 67.1484H47.3886V73.037C47.3886 73.831 47.8668 74.5468 48.6004 74.8505C49.3339 75.1543 50.1782 74.9863 50.7395 74.4249L58.0161 67.1484H65.1855C70.5972 67.1484 74.9999 62.7456 74.9999 57.3339V41.6308C74.9999 36.2191 70.5973 31.8164 65.1855 31.8164ZM35.6113 41.6308V43.5937H25.7969C25.2818 43.5937 24.7875 43.796 24.4203 44.1572L19.7773 48.7242V45.5566C19.7773 44.4726 18.8985 43.5937 17.8144 43.5937C14.5674 43.5937 11.9258 40.9521 11.9258 37.705V17.8144C11.9258 14.5674 14.5674 11.9258 17.8144 11.9258H41.5C44.747 11.9258 47.3886 14.5674 47.3886 17.8144V31.8164H45.4257C40.0141 31.8164 35.6113 36.2191 35.6113 41.6308ZM71.0742 57.3339C71.0742 60.5809 68.4325 63.2226 65.1855 63.2226H57.2031C56.6824 63.2226 56.1832 63.4295 55.8152 63.7976L51.3144 68.2982V65.1855C51.3144 64.1015 50.4356 63.2226 49.3515 63.2226H45.4257C42.1787 63.2226 39.5371 60.5809 39.5371 57.3339V41.6308C39.5371 38.3838 42.1787 35.7422 45.4257 35.7422H65.1855C68.4325 35.7422 71.0742 38.3838 71.0742 41.6308V57.3339Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M29.7246 15.8516C26.4776 15.8516 23.8359 18.4932 23.8359 21.7402C23.8359 22.8243 24.7148 23.7031 25.7988 23.7031C26.8829 23.7031 27.7617 22.8243 27.7617 21.7402C27.7617 20.6579 28.6423 19.7773 29.7246 19.7773C30.8069 19.7773 31.6875 20.6579 31.6875 21.7402C31.6875 22.2506 31.109 23.2523 30.2372 23.5991C28.7333 24.1971 27.7617 25.6292 27.7617 27.2474V29.8535C27.7617 30.9375 28.6406 31.8164 29.7246 31.8164C30.8086 31.8164 31.6744 30.9375 31.6744 29.8535L31.6751 27.2469C33.9128 26.3567 35.6133 23.9893 35.6133 21.7402C35.6133 18.4932 32.9717 15.8516 29.7246 15.8516Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Expansion Pack - Draft Directors\u2019 ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Questionnaires*"
                ]
            }),
            points: [
                'Quick way of uncovering issues prior to your investment',
                'Normally part of purchase/sale or investment',
                'Identify any issues in advance - time for rectificaton',
                'Pre-population from Companies House where relevant to save time',
                'Completeness and risk scoring',
                'Impress your counterparty with your organisation',
                'Contributes to Diligentsia certification',
                'Still subject to formal legal review later in investment/exit process'
            ],
            image: (parcelRequire("3e8So")),
            imageStyle: {
                height: '90%',
                width: '94%'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "83",
            height: "83",
            viewBox: "0 0 83 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M52.2423 4.99023C38.0392 4.99023 26.4843 16.5451 26.4843 30.7483C26.4843 35.4428 27.7474 39.8476 29.9507 43.6419L6.94712 66.6455C4.35096 69.2415 4.35096 73.4657 6.94712 76.0617C8.24505 77.3598 9.95015 78.0089 11.6551 78.0089C13.3601 78.0089 15.0653 77.36 16.3631 76.0617L39.3714 53.0533C43.1605 55.2483 47.557 56.5062 52.242 56.5062C66.4452 56.5062 78.0001 44.9511 78.0001 30.7481C78.0001 16.5451 66.4454 4.99023 52.2423 4.99023ZM13.3351 73.0336C12.4087 73.96 10.9015 73.96 9.97525 73.0337C9.04897 72.1075 9.04897 70.6002 9.97525 69.6737L11.4192 68.2298L14.7791 71.5896L13.3351 73.0336ZM17.8072 68.5616L14.4474 65.2018L16.7667 62.8824L20.1265 66.2424L17.8072 68.5616ZM23.1545 63.2142L19.7947 59.8542L32.4432 47.2057C33.4586 48.4252 34.5841 49.55 35.8046 50.5641L23.1545 63.2142ZM52.2423 52.2237C40.4006 52.2237 30.7669 42.5898 30.7669 30.7483C30.7669 18.9067 40.4006 9.2728 52.2423 9.2728C64.084 9.2728 73.7178 18.9066 73.7178 30.7483C73.7178 42.59 64.084 52.2237 52.2423 52.2237Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M59.5703 27.026C59.5703 25.8434 58.6117 24.8848 57.4291 24.8848L43.216 24.8848C42.0334 24.8848 41.0748 25.8434 41.0748 27.026C41.0748 28.2085 42.0334 29.1672 43.216 29.1672L57.4291 29.1672C58.6117 29.1673 59.5703 28.2085 59.5703 27.026Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M64.2227 19.5357C64.2227 18.3532 63.264 17.3945 62.0814 17.3945L43.216 17.3945C42.0334 17.3945 41.0748 18.3532 41.0748 19.5357C41.0748 20.7183 42.0334 21.677 43.216 21.677L62.0814 21.677C63.264 21.6771 64.2227 20.7183 64.2227 19.5357Z",
                    fill: "#4A67FF"
                })
            ]
        }),
        title: `Applicant Company Due Diligence Pack*`,
        points: [
            'Bespoked to each company',
            'Completeness and risk scoring'
        ],
        image: (parcelRequire("7J3ig")),
        buttonLink: 'www.google.com',
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M52.2423 4.99023C38.0392 4.99023 26.4843 16.5451 26.4843 30.7483C26.4843 35.4428 27.7474 39.8476 29.9507 43.6419L6.94712 66.6455C4.35096 69.2415 4.35096 73.4657 6.94712 76.0617C8.24505 77.3598 9.95015 78.0089 11.6551 78.0089C13.3601 78.0089 15.0653 77.36 16.3631 76.0617L39.3714 53.0533C43.1605 55.2483 47.557 56.5062 52.242 56.5062C66.4452 56.5062 78.0001 44.9511 78.0001 30.7481C78.0001 16.5451 66.4454 4.99023 52.2423 4.99023ZM13.3351 73.0336C12.4087 73.96 10.9015 73.96 9.97525 73.0337C9.04897 72.1075 9.04897 70.6002 9.97525 69.6737L11.4192 68.2298L14.7791 71.5896L13.3351 73.0336ZM17.8072 68.5616L14.4474 65.2018L16.7667 62.8824L20.1265 66.2424L17.8072 68.5616ZM23.1545 63.2142L19.7947 59.8542L32.4432 47.2057C33.4586 48.4252 34.5841 49.55 35.8046 50.5641L23.1545 63.2142ZM52.2423 52.2237C40.4006 52.2237 30.7669 42.5898 30.7669 30.7483C30.7669 18.9067 40.4006 9.2728 52.2423 9.2728C64.084 9.2728 73.7178 18.9066 73.7178 30.7483C73.7178 42.59 64.084 52.2237 52.2423 52.2237Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M62 41C62 39.8954 60.5183 39 58.6906 39L44.3094 39C42.4817 39 41 39.8954 41 41C41 42.1046 42.4817 43 44.3094 43L58.6906 43C60.5185 43 62 42.1044 62 41Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M64.3516 34.2115C64.3516 33.029 63.3929 32.0703 62.2103 32.0703L43.3449 32.0703C42.1623 32.0703 41.2037 33.029 41.2037 34.2115C41.2037 35.3941 42.1623 36.3527 43.3449 36.3527L62.2103 36.3527C63.3929 36.3529 64.3516 35.3941 64.3516 34.2115Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M59.5703 27.026C59.5703 25.8434 58.6117 24.8848 57.4291 24.8848L43.216 24.8848C42.0334 24.8848 41.0748 25.8434 41.0748 27.026C41.0748 28.2085 42.0334 29.1672 43.216 29.1672L57.4291 29.1672C58.6117 29.1673 59.5703 28.2085 59.5703 27.026Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M64.2227 19.5357C64.2227 18.3532 63.264 17.3945 62.0814 17.3945L43.216 17.3945C42.0334 17.3945 41.0748 18.3532 41.0748 19.5357C41.0748 20.7183 42.0334 21.677 43.216 21.677L62.0814 21.677C63.264 21.6771 64.2227 20.7183 64.2227 19.5357Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Applicant Company Due ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Diligence Pack*"
                ]
            }),
            subMenu: {
                index: 1,
                points: [
                    '- Data Repository Report',
                    '- 20-section Business Audit',
                    "- Directors\u2019 questionnaires",
                    '- Draft Warranty Disclosures '
                ]
            },
            points: [
                'Open to Diligentsia gold certification only',
                'Supported with a comprehensive  Due Diligence Pack, already completed:'
            ],
            image: (parcelRequire("7J3ig")),
            notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: "14px",
                    color: 'gray',
                    fontStyle: 'italic'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontWeight: "bold",
                            fontStyle: 'normal'
                        },
                        children: `Please Note: `
                    }),
                    "Diligentsia does NOT take responsiblity for the contents of the diligence packs - we merely provice the tools for their generation.  Parties looking for more assurance should take additional external professional advice."
                ]
            }),
            imageStyle: {
                height: '90%',
                width: '94%'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
            width: "67",
            height: "67",
            viewBox: "0 0 67 67",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0 0V67H51.3055V42.9663L67 27.2745L58.6706 18.947L51.3055 26.3109V0L0 0ZM47.379 30.2367L43.4526 34.1625V7.85156H35.5997V3.92578H47.379V30.2367ZM19.7631 3.92578H31.6733V7.85156H19.7631V3.92578ZM39.5262 11.7773V38.0883L37.52 40.0941L34.6897 48.5826L33.3579 52.585L39.5262 50.5291V55.2227H11.7793V11.7773H39.5262ZM39.5635 46.3784L40.9515 42.2144L53.1179 30.0506L55.8945 32.8263L43.7282 44.9906L39.5635 46.3784ZM47.379 63.0742H3.92644V3.92578H15.8366V7.85156H7.85288V59.1484H43.4526V49.2205L45.8494 48.4215L47.379 46.8921V63.0742ZM61.4473 27.2745L58.6706 30.0506L55.8945 27.2745L58.6706 24.4988L61.4473 27.2745Z",
                fill: "#4A67FF"
            })
        }),
        title: 'FREE - AnyList Checklist Builder',
        points: [
            `Create relevant automated due diligence
            checklists\xa0 bespoked to target company`,
            'You can add your own questions and desired answers',
            'Monitor checklist completion by target company'
        ],
        image: (parcelRequire("h66Qq")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "13%",
            left: '-160px',
            top: '-10px',
            rotate: '-23deg'
        },
        animationImage: (parcelRequire("dyyh4")),
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                width: "67",
                height: "67",
                viewBox: "0 0 67 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M0 0V67H51.3055V42.9663L67 27.2745L58.6706 18.947L51.3055 26.3109V0L0 0ZM47.379 30.2367L43.4526 34.1625V7.85156H35.5997V3.92578H47.379V30.2367ZM19.7631 3.92578H31.6733V7.85156H19.7631V3.92578ZM39.5262 11.7773V38.0883L37.52 40.0941L34.6897 48.5826L33.3579 52.585L39.5262 50.5291V55.2227H11.7793V11.7773H39.5262ZM39.5635 46.3784L40.9515 42.2144L53.1179 30.0506L55.8945 32.8263L43.7282 44.9906L39.5635 46.3784ZM47.379 63.0742H3.92644V3.92578H15.8366V7.85156H7.85288V59.1484H43.4526V49.2205L45.8494 48.4215L47.379 46.8921V63.0742ZM61.4473 27.2745L58.6706 30.0506L55.8945 27.2745L58.6706 24.4988L61.4473 27.2745Z",
                    fill: "#4A67FF"
                })
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "FREE - AnyList Checklist",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Builder"
                ]
            }),
            points: [
                'Want to undertake further DD?',
                'Create relevant automated dule diligence checklists bespoked to target company',
                'You can add your own questions and desired answers',
                'Questions: can choose subjective, objective or a mixture',
                'Completeness and risk scoring',
                'Reporting',
                'Workflow Manager: Can send to target company and monitor completeness'
            ],
            image: (parcelRequire("lB7oR")),
            imageStyle: {
                height: '90%',
                width: '94%'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "83",
            height: "83",
            viewBox: "0 0 83 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    "clip-path": "url(#clip0_394_9659)",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M19.3209 32.9883H32.339L38.3074 38.9978C38.8873 39.5761 39.9146 39.6626 40.5844 38.9978L46.5528 32.9883H59.5707C60.4599 32.9883 61.1807 32.2625 61.1807 31.3672V5.42969C61.1807 4.53436 60.4599 3.80859 59.5707 3.80859H19.3209C18.4317 3.80859 17.7109 4.53436 17.7109 5.42969V31.3672C17.7109 32.2625 18.4317 32.9883 19.3209 32.9883ZM20.9309 7.05078H57.9607V29.7461H45.8858C45.4588 29.7461 45.0492 29.917 44.7473 30.2209L39.4458 35.559L34.1443 30.2209C33.8424 29.917 33.4328 29.7461 33.0058 29.7461H20.9309V7.05078Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M77.13 66.6956C76.5013 66.0626 75.4818 66.0626 74.853 66.6956C74.2243 67.3287 74.2243 68.3552 74.853 68.9884L76.9345 71.0843H8.04995V9.34345L10.1315 11.4394C10.7114 12.0176 11.7388 12.1042 12.4085 11.4394C13.0372 10.8063 13.0372 9.77985 12.4085 9.14665L7.57855 4.28337C6.94985 3.65033 5.9304 3.65033 5.30154 4.28337L0.471566 9.14665C-0.157135 9.77969 -0.157135 10.8062 0.471566 11.4394C1.10027 12.0724 2.11971 12.0724 2.74858 11.4394L4.82997 9.34345V15.3185H1.60999C0.720793 15.3185 0 16.0442 0 16.9396C0 17.8349 0.720793 18.5607 1.60999 18.5607H4.82997V23.424H1.60999C0.720793 23.424 0 24.1497 0 25.045C0 25.9404 0.720793 26.6661 1.60999 26.6661H4.82997V31.5294H1.60999C0.720793 31.5294 0 32.2552 0 33.1505C0 34.0458 0.720793 34.7716 1.60999 34.7716H4.82997V39.6349H1.60999C0.720793 39.6349 0 40.3606 0 41.256C0 42.1513 0.720793 42.8771 1.60999 42.8771H4.82997V47.7404H1.60999C0.720793 47.7404 0 48.4661 0 49.3615C0 50.2568 0.720793 50.9825 1.60999 50.9825H4.82997V55.8458H1.60999C0.720793 55.8458 0 56.5716 0 57.4669C0 58.3623 0.720793 59.088 1.60999 59.088H4.82997V63.9513H1.60999C0.720793 63.9513 0 64.6771 0 65.5724C0 66.4677 0.720793 67.1935 1.60999 67.1935H4.82997V72.7052C4.82997 73.6005 5.55076 74.3263 6.43996 74.3263H11.5919V77.5685C11.5919 78.4638 12.3127 79.1896 13.2019 79.1896C14.0911 79.1896 14.8119 78.4638 14.8119 77.5685V74.3263H19.6419V77.5685C19.6419 78.4638 20.3627 79.1896 21.2519 79.1896C22.1411 79.1896 22.8619 78.4638 22.8619 77.5685V74.3263H27.6918V77.5685C27.6918 78.4638 28.4126 79.1896 29.3018 79.1896C30.191 79.1896 30.9118 78.4638 30.9118 77.5685V74.3263H35.7418V77.5685C35.7418 78.4638 36.4626 79.1896 37.3518 79.1896C38.241 79.1896 38.9618 78.4638 38.9618 77.5685V74.3263H43.7917V77.5685C43.7917 78.4638 44.5125 79.1896 45.4017 79.1896C46.2909 79.1896 47.0117 78.4638 47.0117 77.5685V74.3263H51.8417V77.5685C51.8417 78.4638 52.5625 79.1896 53.4517 79.1896C54.3409 79.1896 55.0617 78.4638 55.0617 77.5685V74.3263H59.8916V77.5685C59.8916 78.4638 60.6124 79.1896 61.5016 79.1896C62.3908 79.1896 63.1116 78.4638 63.1116 77.5685V74.3263H67.9416V77.5685C67.9416 78.4638 68.6624 79.1896 69.5516 79.1896C70.4408 79.1896 71.1616 78.4638 71.1616 77.5685V74.3263H76.9347L74.8531 76.4222C74.2244 77.0552 74.2244 78.0817 74.8531 78.7149C75.433 79.2932 76.4604 79.3797 77.1301 78.7149L81.9601 73.8516C82.5888 73.2186 82.5888 72.1921 81.9601 71.5589L77.13 66.6956Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M33.1676 26.5039C33.5526 26.5039 33.9386 26.3658 34.2466 26.0855C34.9064 25.4852 34.9578 24.46 34.3616 23.7959L29.2806 18.1353L33.9364 13.1934C34.5483 12.5439 34.5215 11.5179 33.8763 10.9017C33.2312 10.2855 32.2123 10.3126 31.6003 10.9622L28.3372 14.4258V11.9141C28.3372 11.0187 27.6164 10.293 26.7272 10.293C25.838 10.293 25.1172 11.0187 25.1172 11.9141V24.8828C25.1172 25.7781 25.838 26.5039 26.7272 26.5039C27.6164 26.5039 28.3372 25.7781 28.3372 24.8828V21.9195L31.9727 25.9698C32.2905 26.324 32.7283 26.5039 33.1676 26.5039Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M39.2819 26.5039C40.1711 26.5039 40.8919 25.7781 40.8919 24.8828V20.0195H42.5018C45.1651 20.0195 47.3318 17.8379 47.3318 15.1562C47.3318 12.4746 45.1651 10.293 42.5018 10.293H39.2819C38.3927 10.293 37.6719 11.0187 37.6719 11.9141V24.8828C37.6719 25.7781 38.3927 26.5039 39.2819 26.5039ZM40.8919 13.5352H42.5018C43.3896 13.5352 44.1118 14.2624 44.1118 15.1562C44.1118 16.0501 43.3896 16.7773 42.5018 16.7773H40.8919V13.5352Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M52.1647 13.5352C53.0539 13.5352 53.7747 12.8094 53.7747 11.9141C53.7747 11.0188 53.0539 10.293 52.1647 10.293C51.2755 10.293 50.5547 11.0188 50.5547 11.9141C50.5547 12.8094 51.2755 13.5352 52.1647 13.5352Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M52.1647 26.5039C53.0518 26.5039 53.7747 25.776 53.7747 24.8828V19.209C53.7747 18.3158 53.0518 17.5879 52.1647 17.5879C51.2776 17.5879 50.5547 18.3158 50.5547 19.209V24.8828C50.5547 25.776 51.2776 26.5039 52.1647 26.5039Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M80.8207 26.5039H71.1608C70.2716 26.5039 69.5508 27.2297 69.5508 28.125C69.5508 29.0203 70.2716 29.7461 71.1608 29.7461H77.0675L70.5184 36.6763C69.9637 37.2433 69.9014 38.34 70.5747 38.9669C71.1249 39.5174 72.2308 39.592 72.8513 38.9101L79.2107 32.1795V37.8516C79.2107 38.7469 79.9315 39.4727 80.8207 39.4727C81.7099 39.4727 82.4307 38.7469 82.4307 37.8516V28.125C82.4307 27.2297 81.7099 26.5039 80.8207 26.5039Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M55.1585 52.9325L49.8607 50.5987C49.8932 50.3527 49.9116 50.1024 49.9116 49.8476C49.9116 46.7191 47.3837 44.1738 44.2766 44.1738C42.5346 44.1738 40.9748 44.9741 39.9402 46.2287L30.432 42.0403C29.7516 41.7408 28.9567 41.9482 28.5067 42.5421L11.9238 64.4269C11.3845 65.1387 11.5204 66.156 12.2272 66.699C12.8438 67.1857 13.9197 67.1439 14.4837 66.3936L30.2996 45.5209L38.6778 49.2116C38.6545 49.4206 38.6415 49.6326 38.6415 49.8478C38.6415 52.9763 41.1693 55.5216 44.2764 55.5216C45.9772 55.5216 47.5032 54.7579 48.5373 53.5544L54.9008 56.3579C55.1052 56.4487 55.321 56.4941 55.5448 56.4941C55.9843 56.4941 56.4109 56.3109 56.7136 55.9899L62.8654 49.4796C63.4211 48.9126 63.4799 47.8164 62.809 47.189C62.2584 46.6399 61.1536 46.5618 60.5325 47.2457L55.1585 52.9325ZM44.2766 52.2792C42.945 52.2792 41.8616 51.1884 41.8616 49.8476C41.8616 48.5068 42.945 47.416 44.2766 47.416C45.6082 47.416 46.6916 48.5068 46.6916 49.8476C46.6916 51.1884 45.6082 52.2792 44.2766 52.2792Z",
                            fill: "#4A67FF"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M66.692 44.6992C67.5812 44.6992 68.302 43.9734 68.302 43.0781C68.302 42.1828 67.5812 41.457 66.692 41.457C65.8028 41.457 65.082 42.1828 65.082 43.0781C65.082 43.9734 65.8028 44.6992 66.692 44.6992Z",
                            fill: "#4A67FF"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                        id: "clip0_394_9659",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                            width: "82.4315",
                            height: "83",
                            fill: "white"
                        })
                    })
                })
            ]
        }),
        title: "Your Investee Company\u2019s FREE KPI Report",
        points: [
            'AI generated list of Key Performance Indicators',
            'Specifically generated for their business',
            'Portfolio Benchmarking'
        ],
        image: (parcelRequire("kk8Qe")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "4%",
            left: '-100px',
            bottom: '0px',
            animation: 'rotate 10s linear infinite'
        },
        animationImage: (parcelRequire("isHPH")),
        baloonAnimationImage: (parcelRequire("3KuBs")),
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        "clip-path": "url(#clip0_394_9659)",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M19.3209 32.9883H32.339L38.3074 38.9978C38.8873 39.5761 39.9146 39.6626 40.5844 38.9978L46.5528 32.9883H59.5707C60.4599 32.9883 61.1807 32.2625 61.1807 31.3672V5.42969C61.1807 4.53436 60.4599 3.80859 59.5707 3.80859H19.3209C18.4317 3.80859 17.7109 4.53436 17.7109 5.42969V31.3672C17.7109 32.2625 18.4317 32.9883 19.3209 32.9883ZM20.9309 7.05078H57.9607V29.7461H45.8858C45.4588 29.7461 45.0492 29.917 44.7473 30.2209L39.4458 35.559L34.1443 30.2209C33.8424 29.917 33.4328 29.7461 33.0058 29.7461H20.9309V7.05078Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M77.13 66.6956C76.5013 66.0626 75.4818 66.0626 74.853 66.6956C74.2243 67.3287 74.2243 68.3552 74.853 68.9884L76.9345 71.0843H8.04995V9.34345L10.1315 11.4394C10.7114 12.0176 11.7388 12.1042 12.4085 11.4394C13.0372 10.8063 13.0372 9.77985 12.4085 9.14665L7.57855 4.28337C6.94985 3.65033 5.9304 3.65033 5.30154 4.28337L0.471566 9.14665C-0.157135 9.77969 -0.157135 10.8062 0.471566 11.4394C1.10027 12.0724 2.11971 12.0724 2.74858 11.4394L4.82997 9.34345V15.3185H1.60999C0.720793 15.3185 0 16.0442 0 16.9396C0 17.8349 0.720793 18.5607 1.60999 18.5607H4.82997V23.424H1.60999C0.720793 23.424 0 24.1497 0 25.045C0 25.9404 0.720793 26.6661 1.60999 26.6661H4.82997V31.5294H1.60999C0.720793 31.5294 0 32.2552 0 33.1505C0 34.0458 0.720793 34.7716 1.60999 34.7716H4.82997V39.6349H1.60999C0.720793 39.6349 0 40.3606 0 41.256C0 42.1513 0.720793 42.8771 1.60999 42.8771H4.82997V47.7404H1.60999C0.720793 47.7404 0 48.4661 0 49.3615C0 50.2568 0.720793 50.9825 1.60999 50.9825H4.82997V55.8458H1.60999C0.720793 55.8458 0 56.5716 0 57.4669C0 58.3623 0.720793 59.088 1.60999 59.088H4.82997V63.9513H1.60999C0.720793 63.9513 0 64.6771 0 65.5724C0 66.4677 0.720793 67.1935 1.60999 67.1935H4.82997V72.7052C4.82997 73.6005 5.55076 74.3263 6.43996 74.3263H11.5919V77.5685C11.5919 78.4638 12.3127 79.1896 13.2019 79.1896C14.0911 79.1896 14.8119 78.4638 14.8119 77.5685V74.3263H19.6419V77.5685C19.6419 78.4638 20.3627 79.1896 21.2519 79.1896C22.1411 79.1896 22.8619 78.4638 22.8619 77.5685V74.3263H27.6918V77.5685C27.6918 78.4638 28.4126 79.1896 29.3018 79.1896C30.191 79.1896 30.9118 78.4638 30.9118 77.5685V74.3263H35.7418V77.5685C35.7418 78.4638 36.4626 79.1896 37.3518 79.1896C38.241 79.1896 38.9618 78.4638 38.9618 77.5685V74.3263H43.7917V77.5685C43.7917 78.4638 44.5125 79.1896 45.4017 79.1896C46.2909 79.1896 47.0117 78.4638 47.0117 77.5685V74.3263H51.8417V77.5685C51.8417 78.4638 52.5625 79.1896 53.4517 79.1896C54.3409 79.1896 55.0617 78.4638 55.0617 77.5685V74.3263H59.8916V77.5685C59.8916 78.4638 60.6124 79.1896 61.5016 79.1896C62.3908 79.1896 63.1116 78.4638 63.1116 77.5685V74.3263H67.9416V77.5685C67.9416 78.4638 68.6624 79.1896 69.5516 79.1896C70.4408 79.1896 71.1616 78.4638 71.1616 77.5685V74.3263H76.9347L74.8531 76.4222C74.2244 77.0552 74.2244 78.0817 74.8531 78.7149C75.433 79.2932 76.4604 79.3797 77.1301 78.7149L81.9601 73.8516C82.5888 73.2186 82.5888 72.1921 81.9601 71.5589L77.13 66.6956Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M33.1676 26.5039C33.5526 26.5039 33.9386 26.3658 34.2466 26.0855C34.9064 25.4852 34.9578 24.46 34.3616 23.7959L29.2806 18.1353L33.9364 13.1934C34.5483 12.5439 34.5215 11.5179 33.8763 10.9017C33.2312 10.2855 32.2123 10.3126 31.6003 10.9622L28.3372 14.4258V11.9141C28.3372 11.0187 27.6164 10.293 26.7272 10.293C25.838 10.293 25.1172 11.0187 25.1172 11.9141V24.8828C25.1172 25.7781 25.838 26.5039 26.7272 26.5039C27.6164 26.5039 28.3372 25.7781 28.3372 24.8828V21.9195L31.9727 25.9698C32.2905 26.324 32.7283 26.5039 33.1676 26.5039Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M39.2819 26.5039C40.1711 26.5039 40.8919 25.7781 40.8919 24.8828V20.0195H42.5018C45.1651 20.0195 47.3318 17.8379 47.3318 15.1562C47.3318 12.4746 45.1651 10.293 42.5018 10.293H39.2819C38.3927 10.293 37.6719 11.0187 37.6719 11.9141V24.8828C37.6719 25.7781 38.3927 26.5039 39.2819 26.5039ZM40.8919 13.5352H42.5018C43.3896 13.5352 44.1118 14.2624 44.1118 15.1562C44.1118 16.0501 43.3896 16.7773 42.5018 16.7773H40.8919V13.5352Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.1647 13.5352C53.0539 13.5352 53.7747 12.8094 53.7747 11.9141C53.7747 11.0188 53.0539 10.293 52.1647 10.293C51.2755 10.293 50.5547 11.0188 50.5547 11.9141C50.5547 12.8094 51.2755 13.5352 52.1647 13.5352Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M52.1647 26.5039C53.0518 26.5039 53.7747 25.776 53.7747 24.8828V19.209C53.7747 18.3158 53.0518 17.5879 52.1647 17.5879C51.2776 17.5879 50.5547 18.3158 50.5547 19.209V24.8828C50.5547 25.776 51.2776 26.5039 52.1647 26.5039Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M80.8207 26.5039H71.1608C70.2716 26.5039 69.5508 27.2297 69.5508 28.125C69.5508 29.0203 70.2716 29.7461 71.1608 29.7461H77.0675L70.5184 36.6763C69.9637 37.2433 69.9014 38.34 70.5747 38.9669C71.1249 39.5174 72.2308 39.592 72.8513 38.9101L79.2107 32.1795V37.8516C79.2107 38.7469 79.9315 39.4727 80.8207 39.4727C81.7099 39.4727 82.4307 38.7469 82.4307 37.8516V28.125C82.4307 27.2297 81.7099 26.5039 80.8207 26.5039Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M55.1585 52.9325L49.8607 50.5987C49.8932 50.3527 49.9116 50.1024 49.9116 49.8476C49.9116 46.7191 47.3837 44.1738 44.2766 44.1738C42.5346 44.1738 40.9748 44.9741 39.9402 46.2287L30.432 42.0403C29.7516 41.7408 28.9567 41.9482 28.5067 42.5421L11.9238 64.4269C11.3845 65.1387 11.5204 66.156 12.2272 66.699C12.8438 67.1857 13.9197 67.1439 14.4837 66.3936L30.2996 45.5209L38.6778 49.2116C38.6545 49.4206 38.6415 49.6326 38.6415 49.8478C38.6415 52.9763 41.1693 55.5216 44.2764 55.5216C45.9772 55.5216 47.5032 54.7579 48.5373 53.5544L54.9008 56.3579C55.1052 56.4487 55.321 56.4941 55.5448 56.4941C55.9843 56.4941 56.4109 56.3109 56.7136 55.9899L62.8654 49.4796C63.4211 48.9126 63.4799 47.8164 62.809 47.189C62.2584 46.6399 61.1536 46.5618 60.5325 47.2457L55.1585 52.9325ZM44.2766 52.2792C42.945 52.2792 41.8616 51.1884 41.8616 49.8476C41.8616 48.5068 42.945 47.416 44.2766 47.416C45.6082 47.416 46.6916 48.5068 46.6916 49.8476C46.6916 51.1884 45.6082 52.2792 44.2766 52.2792Z",
                                fill: "#4A67FF"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M66.692 44.6992C67.5812 44.6992 68.302 43.9734 68.302 43.0781C68.302 42.1828 67.5812 41.457 66.692 41.457C65.8028 41.457 65.082 42.1828 65.082 43.0781C65.082 43.9734 65.8028 44.6992 66.692 44.6992Z",
                                fill: "#4A67FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_394_9659",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "82.4315",
                                height: "83",
                                fill: "white"
                            })
                        })
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Your Investee Company\u2019s",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "FREE KPI Report"
                ]
            }),
            points: [
                `Complementary with your investee company's registration`,
                'AI generated list of Key Performance Indicators',
                'Specifically generated for their business',
                'Based on their industry',
                'For each KPI, we explain the KPI, how to calculate it, and what the target benchmark is'
            ],
            image: (parcelRequire("kk8Qe")),
            imageStyle: {
                height: '90%',
                width: '94%'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "69",
            height: "67",
            viewBox: "0 0 69 67",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                    fill: "#4A67FF",
                    stroke: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                    fill: "#4A67FF",
                    stroke: "#4A67FF"
                })
            ]
        }),
        title: `FREE Applicant Company Leads Module`,
        points: [
            `One - click to pitch deck, synopses with contact details & bios`,
            `You receive FREE curated leads from companies which have attained Diligentsia Gold certification and meet your investment criteria`
        ],
        image: (parcelRequire("gXpUq")),
        buttonLink: 'www.google.com',
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "69",
                height: "67",
                viewBox: "0 0 69 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M56.1591 48.7341C55.6139 48.5044 54.9405 48.287 54.1539 48.0866V44.4279C54.9064 44.4967 55.6214 44.6494 56.273 44.8784C56.9539 45.1579 57.403 44.9568 57.7465 44.5567C57.9701 44.2916 58.0832 43.9883 58.0832 43.655C58.0832 43.0409 57.7663 42.5897 57.202 42.3886C56.3023 42.0451 55.2785 41.8277 54.1539 41.7418V40.8932C54.1539 40.5858 54.0408 40.3098 53.8268 40.0958C53.3933 39.6623 52.647 39.6657 52.2271 40.108C52.0274 40.3221 51.9218 40.5933 51.9218 40.8932V41.7881C51.1277 41.904 50.423 42.1371 49.8218 42.482C49.0898 42.9018 48.5275 43.4437 48.1519 44.0919C47.7764 44.7394 47.5855 45.4557 47.5855 46.2218C47.5855 47.1058 47.8275 47.8542 48.3032 48.4458C48.7551 49.0081 49.327 49.4477 50.0031 49.7524C50.5361 49.993 51.1802 50.2213 51.9218 50.4326V53.9421C51.0337 53.846 50.1715 53.6142 49.3536 53.2516C48.8308 53.0158 48.1921 53.1255 47.8111 53.5399C47.5746 53.7969 47.4492 54.1179 47.4492 54.4669C47.4492 54.747 47.5337 55.0088 47.698 55.2419C47.8588 55.4743 48.0674 55.6447 48.3121 55.7462C49.4347 56.2247 50.6472 56.5314 51.9218 56.6602V57.5592C51.9218 57.9682 52.099 58.2231 52.2523 58.3703C52.4602 58.5639 52.7287 58.6661 53.0293 58.6661C53.3469 58.6661 53.625 58.5564 53.8336 58.3492C54.0428 58.1427 54.1539 57.8693 54.1539 57.5592V56.6582C54.9166 56.5682 55.6105 56.3733 56.2225 56.0761C56.9845 55.7053 57.5843 55.1969 58.0055 54.563L58.0062 54.5616C58.4315 53.9182 58.6469 53.193 58.6469 52.4058C58.6469 51.4448 58.3981 50.65 57.9081 50.0448C57.4419 49.4682 56.8537 49.0272 56.1591 48.7341ZM55.8497 52.2892C55.8497 52.8815 55.6609 53.6626 54.1539 53.9189V51.0256C54.6883 51.1987 55.1102 51.378 55.4114 51.5606C55.7147 51.744 55.8497 51.9689 55.8497 52.2892ZM51.9218 44.5628V47.5039C51.4637 47.3471 51.0998 47.1726 50.8353 46.9825C50.5402 46.7718 50.4018 46.4863 50.4018 46.0855C50.4018 45.6479 50.5606 45.318 50.9028 45.0474C51.1706 44.8355 51.5121 44.6733 51.9218 44.5628Z",
                        fill: "#4A67FF",
                        stroke: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M58.6329 35.2558C59.4408 33.8736 60.2015 32.3665 60.5914 31.0681C62.4419 30.8761 63.8944 29.3262 63.8944 27.4257V25.4648C63.8944 23.4351 62.2436 21.7843 60.2139 21.7843H56.7917V21.2942C56.7917 16.9993 54.2241 13.3001 50.5474 11.6287C51.6196 10.5267 52.2864 9.02783 52.2864 7.37227C52.2864 4.00049 49.5437 1.25781 46.1726 1.25781C42.8008 1.25781 40.0582 4.00049 40.0582 7.37227C40.0582 9.02792 40.7249 10.5269 41.7973 11.6289C38.1207 13.3003 35.5529 16.9995 35.5529 21.2942V21.7843H29.3376V21.2942C29.3376 16.9995 26.7702 13.3004 23.0938 11.629C24.1662 10.527 24.833 9.02792 24.833 7.37227C24.833 4.00049 22.0903 1.25781 18.7186 1.25781C15.3468 1.25781 12.6041 4.00049 12.6041 7.37227C12.6041 9.02792 13.2709 10.527 14.3433 11.629C10.6669 13.3004 8.09953 16.9995 8.09953 21.2942V21.7843H4.67663C2.64688 21.7843 0.996094 23.4351 0.996094 25.4648V27.4257C0.996094 29.3309 2.45595 30.8838 4.31301 31.0696C6.06671 36.8101 16.2999 50.393 25.9447 55.2847L27.3494 64.5548C27.4646 65.3168 28.1734 65.8458 28.9389 65.7258C29.7009 65.6099 30.225 64.8984 30.1098 64.1364L28.7085 54.8907C28.5844 53.959 28.0133 53.1649 27.1259 52.7042C18.6286 48.4348 9.33046 36.1534 7.24823 31.107H57.6252C57.2803 31.9392 56.7208 33.042 55.8892 34.4119C54.9248 34.215 53.9249 34.1155 52.9039 34.1155C43.4527 34.1155 36.0963 42.9068 38.1488 52.409C38.1562 52.4438 38.1584 52.48 38.1661 52.5147C38.0393 52.5836 37.9146 52.649 37.7912 52.7103C36.9372 53.1213 36.334 53.9249 36.1732 54.8825L34.7691 64.1364C34.6532 64.8984 35.1774 65.6099 35.9401 65.7258C36.0109 65.7367 36.0811 65.7415 36.1513 65.7415C36.8295 65.7415 37.4245 65.246 37.5295 64.5548L39.0222 55.2165C39.03 55.2126 39.0378 55.2073 39.0457 55.2034C41.3684 60.5573 46.7055 64.3149 52.9087 64.3149C61.2287 64.3149 67.9982 57.5455 67.9982 49.2254C67.9982 42.9243 64.1214 37.5182 58.6329 35.2558ZM42.8499 7.37227C42.8499 5.54018 44.3405 4.04957 46.1726 4.04957C48.0047 4.04957 49.4946 5.54018 49.4946 7.37227C49.4946 9.15827 48.0758 10.6089 46.3073 10.6813C46.262 10.6808 46.2181 10.6745 46.1726 10.6745C46.1271 10.6745 46.0833 10.6808 46.0379 10.6813C44.2695 10.6089 42.8499 9.15827 42.8499 7.37227ZM38.3447 21.2942C38.3447 17.0233 41.7841 13.5459 46.0379 13.4731C46.0838 13.4741 46.1264 13.4867 46.1726 13.4867C46.2187 13.4867 46.2614 13.4741 46.3073 13.4731C50.5605 13.5459 53.9999 17.0233 53.9999 21.2942V21.7843H38.3447V21.2942ZM15.3958 7.37227C15.3958 5.54018 16.8865 4.04957 18.7186 4.04957C20.5506 4.04957 22.0413 5.54018 22.0413 7.37227C22.0413 9.15827 20.6217 10.6089 18.8533 10.6813C18.8079 10.6808 18.764 10.6745 18.7186 10.6745C18.6731 10.6745 18.6292 10.6808 18.5839 10.6813C16.8154 10.6089 15.3958 9.15827 15.3958 7.37227ZM10.8913 21.2942C10.8913 17.0233 14.3307 13.5459 18.5839 13.4731C18.6298 13.4741 18.6724 13.4867 18.7186 13.4867C18.7647 13.4867 18.8073 13.4741 18.8533 13.4731C23.1064 13.5459 26.5458 17.0233 26.5458 21.2942V21.7843H10.8913V21.2942ZM3.78785 25.4648C3.78785 24.9748 4.18657 24.576 4.67663 24.576H60.2139C60.7039 24.576 61.1026 24.9748 61.1026 25.4648V27.4257C61.1026 27.9158 60.7039 28.3145 60.2139 28.3145H4.67663C4.18657 28.3145 3.78785 27.9158 3.78785 27.4257V25.4648ZM52.9087 61.5232C46.0668 61.5232 40.6021 55.9359 40.6021 49.2261C40.6021 42.5099 46.1258 36.7888 53.1469 36.9234C59.7761 37.0497 65.2064 42.494 65.2064 49.2254C65.2064 56.0065 59.6897 61.5232 52.9087 61.5232Z",
                        fill: "#4A67FF",
                        stroke: "#4A67FF"
                    })
                ]
            }),
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "FREE Applicant Company ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    "Leads Module"
                ]
            }),
            subMenu: {
                index: 3,
                points: [
                    '- Data Repository Report',
                    '- 20-section Business Audit',
                    "- Directors\u2019 questionnaires",
                    '- Draft Warranty Disclosures'
                ]
            },
            points: [
                'Open to Diligentsia gold certification only',
                `Matches applicants' investment requirements against your statedinvestment criteria  - if you subscribe FREE to our platform`,
                "A \u201CFit Report\u201D which shows each the party the Fit with the other",
                'Supported with a comprehensive  Due Diligence Pack, already completed:'
            ],
            image: (parcelRequire("3i2EE")),
            notePoint: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    fontSize: "14px",
                    color: 'gray',
                    fontStyle: 'italic'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            fontWeight: "bold",
                            fontStyle: 'normal'
                        },
                        children: `Please Note: `
                    }),
                    "Diligentsia does NOT give investment advice, nor do we generate revenue from successful introductions via our platform.  Nor do we take responsiblity for the contents of the diligence packs - we merely provice the tools for their generation.  Parties looking for more assurance should take additional external professional advice"
                ]
            }),
            imageStyle: {
                height: '90%',
                width: '94%'
            }
        }
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "83",
            height: "83",
            viewBox: "0 0 83 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M66.7745 20.1305C62.2389 20.1305 58.5491 23.8399 58.5491 28.3996C58.5491 30.2228 59.1574 31.8945 60.1553 33.263L54.5322 40.7986L47.1836 26.2215C48.7436 24.7157 49.7254 22.6098 49.7254 20.2691C49.7254 15.7094 46.0357 12 41.5 12C36.9643 12 33.2745 15.7094 33.2745 20.2691C33.2745 22.6098 34.2564 24.7157 35.8164 26.2215L28.4678 40.7986L22.8447 33.263C23.8426 31.8945 24.4509 30.2228 24.4509 28.3996C24.4509 23.8399 20.7611 20.1305 16.2254 20.1305C11.6898 20.1305 8 23.8399 8 28.3996C8 32.4637 10.9367 35.8336 14.7856 36.5224L17.5738 59.881C17.7175 61.0909 18.7375 62 19.9491 62H63.0509C64.2625 62 65.2825 61.0909 65.4262 59.881L68.2144 36.5224C72.0633 35.8336 75 32.4637 75 28.3996C75 23.8399 71.3102 20.1305 66.7745 20.1305ZM66.7745 31.8576C64.8783 31.8576 63.3348 30.3072 63.3348 28.3996C63.3348 26.4921 64.8783 24.9416 66.7745 24.9416C68.6708 24.9416 70.2143 26.4921 70.2143 28.3996C70.2143 30.3072 68.6708 31.8576 66.7745 31.8576ZM22.0721 57.1889L19.664 37.0164L26.9489 46.7796C27.4443 47.4468 28.2645 47.825 29.0707 47.7334C29.8956 47.6606 30.6235 47.1673 30.9974 46.4249L40.0863 28.3945C40.5476 28.4756 41.0159 28.5382 41.5 28.5382C41.9841 28.5382 42.4524 28.4756 42.9137 28.3945L52.0026 46.4249C52.3765 47.1673 53.1044 47.6606 53.9293 47.7334C54.7518 47.8227 55.5557 47.4468 56.0511 46.7796L63.336 37.0164L60.9279 57.1889H22.0721ZM12.7857 28.3996C12.7857 26.4921 14.3292 24.9416 16.2254 24.9416C18.1217 24.9416 19.6652 26.4921 19.6652 28.3996C19.6652 30.3072 18.1217 31.8576 16.2254 31.8576C14.3292 31.8576 12.7857 30.3072 12.7857 28.3996ZM38.0603 20.2691C38.0603 18.3616 39.6037 16.8111 41.5 16.8111C43.3963 16.8111 44.9397 18.3616 44.9397 20.2691C44.9397 22.1767 43.3963 23.7271 41.5 23.7271C39.6037 23.7271 38.0603 22.1767 38.0603 20.2691Z",
                    fill: "#4A67FF"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M62.6515 71C63.9484 71 65 69.8818 65 68.5C65 67.1182 63.9484 66 62.6515 66H20.3485C19.0516 66 18 67.1182 18 68.5C18 69.8818 19.0516 71 20.3485 71H62.6515Z",
                    fill: "#4A67FF"
                })
            ]
        }),
        title: 'Diligentsia Pro PLUS',
        points: [
            `External review of  a company\u{2019}s self - audited diligence`,
            'Certification is valid for 3 months'
        ],
        image: (parcelRequire("kretz")),
        buttonLink: 'www.google.com',
        hasAnimation: true,
        animationStyle: {
            width: "4%",
            left: '-100px',
            bottom: '0px',
            animation: 'rotate 10s linear infinite'
        },
        animationImage: (parcelRequire("isHPH")),
        seeMoreSection: {
            icon: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                width: "83",
                height: "83",
                viewBox: "0 0 83 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M66.7745 20.1305C62.2389 20.1305 58.5491 23.8399 58.5491 28.3996C58.5491 30.2228 59.1574 31.8945 60.1553 33.263L54.5322 40.7986L47.1836 26.2215C48.7436 24.7157 49.7254 22.6098 49.7254 20.2691C49.7254 15.7094 46.0357 12 41.5 12C36.9643 12 33.2745 15.7094 33.2745 20.2691C33.2745 22.6098 34.2564 24.7157 35.8164 26.2215L28.4678 40.7986L22.8447 33.263C23.8426 31.8945 24.4509 30.2228 24.4509 28.3996C24.4509 23.8399 20.7611 20.1305 16.2254 20.1305C11.6898 20.1305 8 23.8399 8 28.3996C8 32.4637 10.9367 35.8336 14.7856 36.5224L17.5738 59.881C17.7175 61.0909 18.7375 62 19.9491 62H63.0509C64.2625 62 65.2825 61.0909 65.4262 59.881L68.2144 36.5224C72.0633 35.8336 75 32.4637 75 28.3996C75 23.8399 71.3102 20.1305 66.7745 20.1305ZM66.7745 31.8576C64.8783 31.8576 63.3348 30.3072 63.3348 28.3996C63.3348 26.4921 64.8783 24.9416 66.7745 24.9416C68.6708 24.9416 70.2143 26.4921 70.2143 28.3996C70.2143 30.3072 68.6708 31.8576 66.7745 31.8576ZM22.0721 57.1889L19.664 37.0164L26.9489 46.7796C27.4443 47.4468 28.2645 47.825 29.0707 47.7334C29.8956 47.6606 30.6235 47.1673 30.9974 46.4249L40.0863 28.3945C40.5476 28.4756 41.0159 28.5382 41.5 28.5382C41.9841 28.5382 42.4524 28.4756 42.9137 28.3945L52.0026 46.4249C52.3765 47.1673 53.1044 47.6606 53.9293 47.7334C54.7518 47.8227 55.5557 47.4468 56.0511 46.7796L63.336 37.0164L60.9279 57.1889H22.0721ZM12.7857 28.3996C12.7857 26.4921 14.3292 24.9416 16.2254 24.9416C18.1217 24.9416 19.6652 26.4921 19.6652 28.3996C19.6652 30.3072 18.1217 31.8576 16.2254 31.8576C14.3292 31.8576 12.7857 30.3072 12.7857 28.3996ZM38.0603 20.2691C38.0603 18.3616 39.6037 16.8111 41.5 16.8111C43.3963 16.8111 44.9397 18.3616 44.9397 20.2691C44.9397 22.1767 43.3963 23.7271 41.5 23.7271C39.6037 23.7271 38.0603 22.1767 38.0603 20.2691Z",
                        fill: "#4A67FF"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M62.6515 71C63.9484 71 65 69.8818 65 68.5C65 67.1182 63.9484 66 62.6515 66H20.3485C19.0516 66 18 67.1182 18 68.5C18 69.8818 19.0516 71 20.3485 71H62.6515Z",
                        fill: "#4A67FF"
                    })
                ]
            }),
            title: `Diligentsia Pro PLUS`,
            points: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        marginBottom: "-5px",
                        lineHeight: '20px'
                    },
                    children: 'Your applicant companies self-diligence and then pay  their advisors for an "audit" of their modules on a chargeable basis'
                }),
                'Audited certificate valid for 3 months',
                'Periodic reporting of changes to repository and  other modules to keep you abreast of developments',
                'Option of quarterly reviews'
            ],
            image: (parcelRequire("kretz")),
            imageStyle: {
                height: '90%',
                width: '94%'
            }
        }
    }
];

// Video section data
const $cf9800d02c9ef389$var$VIDEO_SECTION = {
    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            "  How ",
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "c4",
                children: " Diligentsia "
            }),
            " can help Warren, Angel investor"
        ]
    }),
    videoURL: 'https://diligentsia-website-assets.s3.us-east-2.amazonaws.com/Diligentsia_For_Angel_Investors.mp4',
    thumbnail: (parcelRequire("fNv1Y"))
};
// Pricing constant
const $cf9800d02c9ef389$var$PRICING_CONSTANT = {
    footer: '* = Expansion Packs are additional to Pro subscription and are charged separately',
    subHeading: "For Your Network Portfolio Companies",
    points: [
        (0, $0e5eabdbd79984d1$export$565475a71a38b71e),
        (0, $0e5eabdbd79984d1$export$793932ede7161c97),
        (0, $0e5eabdbd79984d1$export$376e2b2731789978)
    ]
};

const $cf9800d02c9ef389$var$LandingHomeAngels = ()=>{
    const [showAll, setShowAll] = (0, $acw62.useState)(false);
    const [isPlay, setIsPlay] = (0, $acw62.useState)(false);
    const [hasHover, setHasHover] = (0, $acw62.useState)(false);
    const refs = (0, $acw62.useRef)((0, $151980f13be271b8$export$58cfd9be695cf66b).map(()=>/*#__PURE__*/ (0, $acw62.createRef)()));
    const [isAnimationVisible, setIsAnimationVisible] = (0, $acw62.useState)(false);
    ///Observer so appllying fadeup animation
    (0, $acw62.useEffect)(()=>{
        const observers = refs.current.map((ref, index)=>new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting) setIsAnimationVisible((prev)=>({
                        ...prev,
                        [index]: true
                    }));
            }, {
                threshold: 0.5
            }));
        refs.current.forEach((ref, index)=>{
            if (ref.current) observers[index].observe(ref.current);
        });
        return ()=>{
            refs.current.forEach((ref, index)=>{
                if (ref.current) observers[index].unobserve(ref.current);
            });
        };
    }, []);
    const toggleShowAll = ()=>setShowAll((prev)=>!prev);
    // Video for diligentisa Help 
    function playVideo(e) {
        let video = document.getElementById("video");
        if (video.paused == true) {
            setIsPlay(true);
            video.play();
        }
        e.target.controls = true;
        if (e?.target?.nextElementSibling) e.target.nextElementSibling.remove();
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "poppins-font-style angels-page-font *",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebd74e09b91c9d05$export$2e2bcd8739ae039), {
                    data: $cf9800d02c9ef389$var$MAIN_BANNER_DATA,
                    isAnimationVisible: isAnimationVisible,
                    refs: refs,
                    calImage: (parcelRequire("lt5KC")),
                    hasTo: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8aa2eea31a033eba$export$2e2bcd8739ae039), {
                    data: $cf9800d02c9ef389$var$ABOUT_US_CONTENT,
                    isAnimationVisible: isAnimationVisible,
                    refs: refs
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25b39fd976a73bd1$export$2e2bcd8739ae039), {
                    subTitle: "Making everyone stronger",
                    data: $cf9800d02c9ef389$var$KEY_FEATURE_MODULES,
                    refs: refs,
                    isAnimationVisible: isAnimationVisible,
                    setHasHover: setHasHover,
                    hasHover: hasHover
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5fb5645b2fc70803$export$2e2bcd8739ae039), {
                    data: $cf9800d02c9ef389$var$HOW_ITS_WORK_DATA,
                    refs: refs,
                    isAnimationVisible: isAnimationVisible
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $844e14ef8ac4298d$export$2e2bcd8739ae039), {
                    registerationType: "Investor",
                    refs: refs,
                    isAnimationVisible: isAnimationVisible
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f914f5770b03b8c$export$2e2bcd8739ae039), {
                    refs: refs,
                    isAnimationVisible: isAnimationVisible
                })
            ]
        })
    });
};
var $cf9800d02c9ef389$export$2e2bcd8739ae039 = $cf9800d02c9ef389$var$LandingHomeAngels;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $e274595e78bd6925$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';



const $e274595e78bd6925$var$PiscesHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge lp-badge--up",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "PISCES \xb7 LSE Private Market"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: [
                                    "The infrastructure",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lp-h1",
                                        style: {
                                            color: '#FC7785'
                                        },
                                        children: "PISCES needs to work."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "Buyers need to trust seller Information Memoranda. Sellers need preparation to be fast and affordable. Operators need automated compliance. Diligentsia closes all three gaps \u2014 structured disclosures, AI-reviewed, director-certified."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "lp-btn lp-btn--primary",
                                        to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                        children: "Start your eligibility check"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--ghost",
                                        href: "#how-it-works",
                                        children: "See how it works"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-hero-note",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: "We can introduce you to platform operators:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df aic mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w150px h50px mr1rem",
                                        src: (parcelRequire("fXJEg")),
                                        alt: "PISCES private market"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w130px h70px",
                                        src: (parcelRequire("59R3Z")),
                                        alt: "PISCES private market"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-hero-art",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-stage",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "lp-acc-photo",
                                src: (parcelRequire("7j8Vt")),
                                alt: "PISCES private market"
                            })
                        })
                    })
                ]
            })
        ]
    });
var $e274595e78bd6925$export$2e2bcd8739ae039 = $e274595e78bd6925$var$PiscesHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $e67d371698680555$var$IconEyeOff = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "1",
                y1: "1",
                x2: "23",
                y2: "23"
            })
        ]
    });
const $e67d371698680555$var$IconClock = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "12 6 12 12 16 14"
            })
        ]
    });
const $e67d371698680555$var$IconFile = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "14 2 14 8 20 8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "9",
                y1: "14",
                x2: "15",
                y2: "14"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "9",
                y1: "18",
                x2: "12",
                y2: "18"
            })
        ]
    });
const $e67d371698680555$var$CARDS = [
    {
        bg: '#4A67FF',
        Icon: $e67d371698680555$var$IconEyeOff,
        t: "Sellers \u2013 PISCES transaction readiness",
        d: 'Automated processes to help you meet your regulatory requirements across multiple windows'
    },
    {
        bg: '#FC7785',
        Icon: $e67d371698680555$var$IconClock,
        t: "Buyers \u2013 automated diligence tools",
        d: "We give you the AI diligence tools to increase your confidence in the seller\u2019s information."
    },
    {
        bg: '#6e56cf',
        Icon: $e67d371698680555$var$IconFile,
        t: "Operators \u2013 automated process recording",
        d: 'We give you automated reporting to support your compliance with regulatory requirements'
    }
];
const $e67d371698680555$var$PiscesProblemSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-prob-sec",
        style: {
            marginBottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-prob-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-eyebrow",
                        "data-lp-reveal": true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-ww-eyebrow",
                            children: "The opportunity"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        style: {
                            maxWidth: '1200px'
                        },
                        children: "One integrated platform for sellers, buyers, platform operators and regulator"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "lp-prob-lead",
                        "data-lp-reveal": true,
                        "data-lp-delay": "120",
                        children: "PISCES will work if the process is quick, inexpensive and easy for all stakeholders"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-prob-grid",
                children: $e67d371698680555$var$CARDS.map(({ bg: bg, Icon: Icon, t: t, d: d }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-prob-card",
                        style: {
                            background: bg
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": i * 120,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-prob-icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: t
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: d
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-prob-close",
                "data-lp-reveal": true,
                children: "Diligentsia closes all three gaps \u2014 simultaneously."
            })
        ]
    });
var $e67d371698680555$export$2e2bcd8739ae039 = $e67d371698680555$var$PiscesProblemSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $bf6c2ddd593ffe50$var$STATS = [
    {
        count: 17,
        label: 'FCA Core Disclosure sections',
        pink: true
    },
    {
        count: 73,
        label: 'Structured questions in the module',
        pink: true
    },
    {
        count: 5,
        label: "Stakeholder types \u2014 one platform",
        pink: true
    }
];
const $bf6c2ddd593ffe50$var$GLOWS = [
    {
        top: -80,
        left: -80,
        size: 400,
        c: 'rgba(74,103,255,0.28)'
    },
    {
        bottom: -80,
        right: -60,
        size: 360,
        c: 'rgba(252,119,133,0.24)'
    }
];
const $bf6c2ddd593ffe50$var$PiscesStatsBand = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-stats lp-stats--glow",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-stats-bg",
                "aria-hidden": "true",
                children: $bf6c2ddd593ffe50$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: g.top != null ? g.top + 'px' : 'auto',
                            bottom: g.bottom != null ? g.bottom + 'px' : 'auto',
                            left: g.left != null ? g.left + 'px' : 'auto',
                            right: g.right != null ? g.right + 'px' : 'auto',
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(76px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-stats-grid",
                children: $bf6c2ddd593ffe50$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-lp-reveal": true,
                        "data-lp-delay": i * 80,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `lp-stat-num ${s.pink ? 'pink' : ''}`,
                                "data-count": s.count,
                                children: s.count
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-stat-label",
                                children: s.label
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-stats-cap",
                children: "The only platform purpose-built around FCA PS 25/6 and LSE PSM Appendix 2."
            })
        ]
    });
var $bf6c2ddd593ffe50$export$2e2bcd8739ae039 = $bf6c2ddd593ffe50$var$PiscesStatsBand;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $aed478ff0edb377c$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
// -- feature icons --
const $aed478ff0edb377c$var$S = (p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: p
    });
const $aed478ff0edb377c$var$IcUpload = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "16 16 12 12 8 16"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "12",
                x2: "12",
                y2: "21"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcServer = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "8",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "14",
                width: "20",
                height: "8",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "6.01",
                y2: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "18",
                x2: "6.01",
                y2: "18"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcRefresh = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "1 4 1 10 7 10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M3.51 15a9 9 0 1 0 .49-3.51"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcShield = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
    }));
const $aed478ff0edb377c$var$IcAward = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "8",
                r: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcUsers = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "9",
                cy: "7",
                r: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M23 21v-2a4 4 0 0 0-3-3.87"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16 3.13a4 4 0 0 1 0 7.75"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcBriefcase = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "7",
                width: "20",
                height: "14",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcZap = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
        points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
    }));
const $aed478ff0edb377c$var$IcDatabase = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("ellipse", {
                cx: "12",
                cy: "5",
                rx: "9",
                ry: "3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcMonitor = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "3",
                width: "20",
                height: "14",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "8",
                y1: "21",
                x2: "16",
                y2: "21"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "17",
                x2: "12",
                y2: "21"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcFileCheck = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "14 2 14 8 20 8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9 15l2 2 4-4"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcCode = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "16 18 22 12 16 6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "8 6 2 12 8 18"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcTrophy = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "8",
                y1: "2",
                x2: "8",
                y2: "18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "16",
                y1: "6",
                x2: "16",
                y2: "22"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcLink = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcBars = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "18",
                y1: "20",
                x2: "18",
                y2: "10"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "20",
                x2: "12",
                y2: "4"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "20",
                x2: "6",
                y2: "14"
            })
        ]
    }));
const $aed478ff0edb377c$var$IcCheck = ()=>$aed478ff0edb377c$var$S(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "22 4 12 14.01 9 11.01"
            })
        ]
    }));
const $aed478ff0edb377c$var$TABS = [
    {
        label: 'Sellers',
        h: 'Build once. Use everywhere.',
        hPink: ' Get transaction ready more quickly at less cost. And then repeat.',
        lead: 'Giving buyers confidence in your disclosures will be critical to the success of your transaction. We help you create that confidence.',
        features: [
            {
                Icon: $aed478ff0edb377c$var$IcUpload,
                t: 'One upload, used everywhere',
                d: 'Automated population of your 17- section Core Disclosures from information you upload or pulled from our other modules.'
            },
            {
                Icon: $aed478ff0edb377c$var$IcServer,
                t: 'AI self-diligence sandbox',
                d: "Simulate what a buyer's AI will find \u2014 and fix gaps before advisors review."
            },
            {
                Icon: $aed478ff0edb377c$var$IcRefresh,
                t: 'Window-over-window economics',
                d: 'Second window: deltas only. Marginal cost per window falls with every repeat.'
            }
        ],
        cta: {
            text: 'Start your free eligibility check',
            to: $16250bd714b02a14$export$51e82cdd7353a0e1
        },
        card: {
            title: 'Disclosure module at a glance',
            type: 'stats',
            rows: [
                {
                    pre: 'Upto',
                    big: '60%',
                    label: 'AI autofill from your documents'
                },
                {
                    big: '73',
                    label: 'structured questions, all 17 CDs'
                },
                {
                    big: "\u0394",
                    label: 're-certify changes only'
                },
                {
                    big: "1\xd7",
                    label: 'upload, used everywhere'
                }
            ],
            note: "\xa34,999/year \u2014 replaces material professional fees for document collation"
        }
    },
    {
        label: 'Buyers',
        h: 'Better information.',
        hPink: 'More confident investment.',
        lead: "All 17 Core Disclosures structured, AI-reviewed, and director-certified before the window opens. Every buyer sees the same information simultaneously \u2014 no asymmetry.",
        features: [
            {
                Icon: $aed478ff0edb377c$var$IcShield,
                t: 'AI-ready data',
                d: 'Seller data is structured so that you can interrogate within our platform at no cost, or use our MCP hooks to your own diligence tools.'
            },
            {
                Icon: $aed478ff0edb377c$var$IcAward,
                t: 'Regular investor?',
                d: "All sellers\u2019 data will be have same structure, facilitating quicker analysis and decision making."
            },
            {
                Icon: $aed478ff0edb377c$var$IcUsers,
                t: 'Full information parity',
                d: 'The same structured data available to all buyers simultaneously. No advantage to connected parties.'
            }
        ],
        card: {
            title: 'What buyers get',
            type: 'stats',
            rows: [
                {
                    big: '17',
                    label: 'CDs structured & AI-reviewed per window'
                },
                {
                    big: 'AI',
                    label: 'natural language query of seller data'
                },
                {
                    big: '100%',
                    label: 'information parity across all buyers'
                }
            ]
        }
    },
    {
        label: 'Advisors',
        h: 'Focus on advice.',
        hPink: 'Not the document chase.',
        lead: 'AI populates upto 60% of disclosures from existing documents before your first meeting. Advisors review, not build. Free access to all client data on the platform.',
        features: [
            {
                Icon: $aed478ff0edb377c$var$IcBriefcase,
                t: 'Included, not replaced',
                d: 'Advisors access all client data in one place at no charge. Add colleagues in one click.'
            },
            {
                Icon: $aed478ff0edb377c$var$IcZap,
                t: 'Collation eliminated',
                d: 'Upto 60% of disclosures AI-pre-populated. Structured knowledge base queryable in natural language.'
            },
            {
                Icon: $aed478ff0edb377c$var$IcDatabase,
                t: 'One dataset, all parties',
                d: 'Company builds it once. Each authorised advisor accesses their relevant portion directly.'
            }
        ],
        cta: {
            text: 'Set up your free advisor account',
            to: $16250bd714b02a14$export$51e82cdd7353a0e1
        },
        card: {
            title: 'What advisors get',
            type: 'checks',
            rows: [
                'Free advisor access',
                'free tools to quickly add value',
                'Natural language query',
                '60+ advisors already on platform'
            ]
        }
    },
    {
        label: 'Operators',
        h: 'Automated oversight.',
        hPink: 'Stronger regulatory standing.',
        lead: "The FCA requires operators to satisfy themselves all 17 CDs are complete before every trading window. Most manage this with a Word document. Diligentsia is the infrastructure layer that makes this scalable.",
        features: [
            {
                Icon: $aed478ff0edb377c$var$IcMonitor,
                t: 'Live risk dashboard',
                d: "Every applicant's completion, risk score, and compliance gate in one view. Flags before the window opens."
            },
            {
                Icon: $aed478ff0edb377c$var$IcFileCheck,
                t: 'Automated regulatory file',
                d: "AI produces a scored review record per section \u2014 your structured FCA 'reasonable review' document, automatically."
            },
            {
                Icon: $aed478ff0edb377c$var$IcCode,
                t: 'API + MCP integration',
                d: "REST API and MCP support \u2014 surface disclosure workflow outputs inside your existing admission portal."
            }
        ],
        cta: {
            text: 'Discuss an operator partnership',
            href: $aed478ff0edb377c$var$KOALENDAR
        },
        card: {
            title: 'Core Disclosures',
            type: 'checks',
            rows: [
                '17-CD framework, 73 questions',
                'Traffic light quality scoring',
                'Window-over-window delta tracking',
                'Hard gate enforcement (CD7/CD12)',
                'Immutable audit log',
                'FCA compliance pack generator'
            ]
        }
    },
    {
        label: 'Regulators',
        h: 'The oversight infrastructure',
        hPink: "PS 25/6 describes \u2014 already built.",
        quote: {
            text: 'Such checks could be automated, such as checking that companies have provided information required by the core information disclosures.',
            src: "\u2014 FCA PS 25/6 para 2.50"
        },
        features: [
            {
                Icon: $aed478ff0edb377c$var$IcTrophy,
                t: 'Uniform structured reporting',
                d: "Consistent disclosure data across all operators \u2014 cross-operator benchmarking and supervisory review made simple."
            },
            {
                Icon: $aed478ff0edb377c$var$IcLink,
                t: 'Chain-of-evidence audit trail',
                d: 'Every action, data change, and director certification in an immutable, timestamped, queryable log.'
            },
            {
                Icon: $aed478ff0edb377c$var$IcBars,
                t: 'Proportionate oversight by design',
                d: "Automated flags mean a 3-person team can oversee 50 companies \u2014 the proportionate model PS 25/6 describes."
            }
        ],
        cta: {
            text: 'Request a regulator briefing',
            href: $aed478ff0edb377c$var$KOALENDAR
        },
        card: {
            title: "Let\u2019s discuss",
            type: 'numbered',
            rows: [
                {
                    no: '01',
                    t: 'Core Disclosure oversight',
                    sub: 'PSM Rule 3.4'
                },
                {
                    no: '02',
                    t: 'Timing compliance',
                    sub: 'PSM Rule 3.6, 3.8'
                },
                {
                    no: '03',
                    t: 'Record keeping, 5 years',
                    sub: 'MAR Art. 18'
                }
            ]
        }
    }
];
const $aed478ff0edb377c$var$CtaButton = ({ cta: cta })=>{
    if (!cta) return null;
    if (cta.href) return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        className: "lp-btn lp-btn--primary",
        href: cta.href,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            borderRadius: '50px'
        },
        children: cta.text
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
        className: "lp-btn lp-btn--primary",
        to: cta.to,
        style: {
            borderRadius: '50px'
        },
        children: cta.text
    });
};
const $aed478ff0edb377c$var$SideCard = ({ card: card })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-aud-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: card.title
            }),
            card.type === 'stats' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-aud-statlist",
                children: card.rows.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "big",
                                children: [
                                    r.pre && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "pre",
                                        children: r.pre
                                    }),
                                    r.big
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "lbl",
                                children: r.label
                            })
                        ]
                    }, i))
            }),
            card.type === 'checks' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-aud-checklist",
                children: card.rows.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "ic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($aed478ff0edb377c$var$IcCheck, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: r
                            })
                        ]
                    }, i))
            }),
            card.type === 'numbered' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-aud-numlist",
                children: card.rows.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "no",
                                children: r.no
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "txt",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        style: {
                                            fontSize: '14px',
                                            fontWeight: '500'
                                        },
                                        children: r.t
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "w100",
                                        children: r.sub
                                    })
                                ]
                            })
                        ]
                    }, i))
            }),
            card.note && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-aud-note",
                children: card.note
            })
        ]
    });
const $aed478ff0edb377c$var$PiscesAudienceTabs = ()=>{
    const [active, setActive] = (0, $acw62.useState)(0);
    const [progress, setProgress] = (0, $acw62.useState)(0); // 0..1 through the scroll wrapper
    const wrapRef = (0, $acw62.useRef)(null);
    // Reason: derive the active audience from how far the sticky wrapper has been scrolled (matches Companies lifecycle scroll-scrub)
    const compute = (0, $acw62.useCallback)(()=>{
        const wrap = wrapRef.current;
        if (!wrap) return;
        const wTop = wrap.getBoundingClientRect().top + window.scrollY;
        const range = wrap.offsetHeight - window.innerHeight;
        if (range <= 0) {
            setProgress(0);
            return;
        }
        const scrolled = Math.max(0, Math.min(window.scrollY - wTop, range));
        const p = scrolled / range;
        setProgress(p);
        const idx = Math.max(0, Math.min($aed478ff0edb377c$var$TABS.length - 1, Math.floor(p * $aed478ff0edb377c$var$TABS.length)));
        setActive((prev)=>prev === idx ? prev : idx);
    }, []);
    (0, $acw62.useEffect)(()=>{
        compute();
        window.addEventListener('scroll', compute, {
            passive: true
        });
        window.addEventListener('resize', compute, {
            passive: true
        });
        return ()=>{
            window.removeEventListener('scroll', compute);
            window.removeEventListener('resize', compute);
        };
    }, [
        compute
    ]);
    const goTo = (idx)=>{
        const wrap = wrapRef.current;
        if (!wrap) return;
        const wTop = wrap.getBoundingClientRect().top + window.scrollY;
        const range = wrap.offsetHeight - window.innerHeight;
        if (range <= 0) {
            setActive(idx);
            return;
        } // mobile / un-pinned: switch on click
        const target = idx / ($aed478ff0edb377c$var$TABS.length - 1);
        window.scrollTo({
            top: wTop + target * range,
            behavior: 'smooth'
        });
    };
    const tab = $aed478ff0edb377c$var$TABS[active];
    const barWidth = Math.max(4, Math.round(progress * 100));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: "audiences",
        className: "lp-aud-scroll",
        ref: wrapRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
            className: "lp-aud-sticky",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-aud-bar",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-aud-pills",
                            role: "tablist",
                            children: $aed478ff0edb377c$var$TABS.map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    role: "tab",
                                    className: `lp-aud-pill ${i === active ? 'is-active' : ''}`,
                                    onClick: ()=>goTo(i),
                                    children: t.label
                                }, i))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-aud-progress",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    width: `${barWidth}%`
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-aud-body",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-aud-panel",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-aud-copy",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                        className: "lp-h2",
                                        style: {
                                            fontSize: '30px'
                                        },
                                        children: [
                                            tab.h,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                style: {
                                                    fontWeight: '600',
                                                    color: '#FC7785'
                                                },
                                                children: tab.hPink
                                            })
                                        ]
                                    }),
                                    tab.quote ? /*#__PURE__*/ (0, $ayMG0.jsxs)("blockquote", {
                                        className: "lp-aud-quote",
                                        children: [
                                            "\u201C",
                                            tab.quote.text,
                                            "\u201D",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
                                                children: tab.quote.src
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "lp-aud-lead",
                                        children: tab.lead
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-aud-features",
                                        children: tab.features.map(({ Icon: Icon, t: t, d: d }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-aud-feat",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "ic",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {})
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                style: {
                                                                    fontSize: '14px',
                                                                    fontWeight: '500'
                                                                },
                                                                children: t
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    fontSize: '12px'
                                                                },
                                                                children: d
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic fww",
                                        style: {
                                            gap: '12px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($aed478ff0edb377c$var$CtaButton, {
                                                cta: tab.cta
                                            }),
                                            tab.cta && !tab.cta.href && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                className: "lp-btn lp-btn--ghost",
                                                href: $aed478ff0edb377c$var$KOALENDAR,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                style: {
                                                    borderRadius: '50px'
                                                },
                                                children: "Book a call"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($aed478ff0edb377c$var$SideCard, {
                                card: tab.card
                            })
                        ]
                    }, active)
                })
            ]
        })
    });
};
var $aed478ff0edb377c$export$2e2bcd8739ae039 = $aed478ff0edb377c$var$PiscesAudienceTabs;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $d2ac92e9f65496a6$var$STEPS = [
    {
        t: 'Free eligibility check',
        d: '10 minutes. No commitment. Confirm you qualify before spending anything.'
    },
    {
        t: 'Connect your documents',
        d: 'Drive, SharePoint, Dropbox or direct upload. One connection, all 17 sections of your Core Disclosures.'
    },
    {
        t: 'AI auto-fills ~60%',
        d: 'Clarence pre-populates from your docs. Your team reviews and certifies every answer.'
    },
    {
        t: 'Analyser reviews all 17 CDs',
        d: "AI flags gaps and inconsistencies against FCA standards \u2014 before anyone else sees them."
    },
    {
        t: 'Human Review',
        d: 'All documents are subject to verified human review so that there is a compliance audit trail.'
    }
];
const $d2ac92e9f65496a6$var$PiscesHowItWorks = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "how-it-works",
        className: "lp-steps5-sec",
        style: {
            marginBottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-prob-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-eyebrow",
                        "data-lp-reveal": true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-ww-eyebrow",
                            children: "How it works"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        style: {
                            fontSize: '35px',
                            maxWidth: '1200px'
                        },
                        children: "From eligibility check to window-ready \u2014 in days."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-steps5",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-steps5-line",
                        "aria-hidden": "true"
                    }),
                    $d2ac92e9f65496a6$var$STEPS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-step5",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 100,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "no",
                                    children: i + 1
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: s.t
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: s.d
                                })
                            ]
                        }, i))
                ]
            })
        ]
    });
var $d2ac92e9f65496a6$export$2e2bcd8739ae039 = $d2ac92e9f65496a6$var$PiscesHowItWorks;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $1d7923c92d39b602$var$Chevron = ({ open: open })=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        className: `lp-disc-chev ${open ? 'open' : ''}`,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "6 9 12 15 18 9"
        })
    });
const $1d7923c92d39b602$var$PiscesDisclosureModule = ()=>{
    const [modOpen, setModOpen] = (0, $acw62.useState)(true);
    const [cdOpen, setCdOpen] = (0, $acw62.useState)(true);
    const [openCD, setOpenCD] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-disc-sec",
        style: {
            marginBottom: 0
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-prob-head",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-eyebrow",
                    "data-lp-reveal": true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "lp-ww-eyebrow",
                        children: "The Disclosure Module"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    style: {
                        fontSize: '35px',
                        maxWidth: '1200px'
                    },
                    children: "73 questions. All 17 Core Disclosures. Nothing missed."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-prob-lead",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: "Structured against PS 2.3.2R and the LSE PSM Appendix 2 framework \u2014 the same standards your operator uses for admission assessment. Not a general-purpose questionnaire."
                })
            ]
        })
    });
};
var $1d7923c92d39b602$export$2e2bcd8739ae039 = $1d7923c92d39b602$var$PiscesDisclosureModule;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $d77f097c5efc750d$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $d77f097c5efc750d$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $d77f097c5efc750d$var$QUOTES = [
    {
        q: "This is not just a PISCES tool \u2014 it is a full lifecycle platform. Data uploaded for PISCES immediately supports our investor conversations and M&A preparation. We have built the record once and it works everywhere.",
        a: "\u2014 Founder, UK growth company \u2014 preparing for first PISCES trading window"
    },
    {
        q: 'The preparation burden is what stops most private companies from pursuing PISCES. Sixty percent autofill from documents the company already holds changes the economics entirely. A company arriving at lawyers with structured disclosures is a materially cheaper instruction.',
        a: "\u2014 Fractional CFO \u2014 advising companies through PISCES preparation"
    },
    {
        q: "Diligentsia is not a form provider. It is the compliance infrastructure layer \u2014 automated completeness checking, immutable audit trail, director certification, and the FCA-standard reasonable review record generated automatically for every applicant.",
        a: "\u2014 PISCES Operator \u2014 using Diligentsia for admission oversight"
    }
];
const $d77f097c5efc750d$var$GLOWS = [
    {
        top: -60,
        left: -60,
        size: 480,
        c: 'rgba(74,103,255,0.42)'
    },
    {
        bottom: -80,
        right: -60,
        size: 420,
        c: 'rgba(252,119,133,0.40)'
    }
];
const $d77f097c5efc750d$var$pos = (v)=>v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v;
const $d77f097c5efc750d$var$PiscesQuotesSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, page: page, pages: pages, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)($d77f097c5efc750d$var$QUOTES.length, {
        autoplayMs: 5500
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-quotes",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-quotes-bg",
                "aria-hidden": "true",
                children: $d77f097c5efc750d$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: $d77f097c5efc750d$var$pos(g.top),
                            bottom: $d77f097c5efc750d$var$pos(g.bottom),
                            left: $d77f097c5efc750d$var$pos(g.left),
                            right: $d77f097c5efc750d$var$pos(g.right),
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(78px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-quotes-eyebrow",
                                "data-lp-reveal": true,
                                children: "What they say."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "lp-h2",
                                "data-lp-reveal": true,
                                style: {
                                    fontSize: '30px'
                                },
                                children: "Trusted by sellers, operators, and advisors."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-arrows",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Previous quotes",
                                onClick: prev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d77f097c5efc750d$var$ChevronL, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Next quotes",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d77f097c5efc750d$var$ChevronR, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-slide-anim",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-track",
                            ref: trackRef,
                            children: $d77f097c5efc750d$var$QUOTES.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                    className: "lp-qcard",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": i % 3 * 120,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("figcaption", {
                                            children: item.a
                                        })
                                    ]
                                }, i))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-foot",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-dots",
                    style: {
                        margin: 0,
                        padding: 0
                    },
                    children: Array.from({
                        length: pages
                    }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `lp-dot ${i === page ? 'is-active' : ''}`,
                            "aria-label": `Go to slide ${i + 1}`,
                            onClick: ()=>goTo(i)
                        }, i))
                })
            })
        ]
    });
};
var $d77f097c5efc750d$export$2e2bcd8739ae039 = $d77f097c5efc750d$var$PiscesQuotesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $736e95ec2b2aaf02$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $736e95ec2b2aaf02$var$PiscesCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "cta",
        className: "lp-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cta-card lp-cta-card--dark",
            "data-lp-reveal": true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cta-glow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Ready to open your first trading window?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "sub",
                            children: [
                                "Start with a free eligibility check \u2014 10 minutes, no ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                " commitment."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-cta-btns",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    className: "lp-btn lp-btn--primary",
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    children: "Start free eligibility check"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "lp-cta-btn lp-cta-btn--outline",
                                    href: $736e95ec2b2aaf02$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Book a call"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $736e95ec2b2aaf02$export$2e2bcd8739ae039 = $736e95ec2b2aaf02$var$PiscesCtaSection;




const $b8439927cc3eeaed$var$LandingHomePisces = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e274595e78bd6925$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e67d371698680555$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf6c2ddd593ffe50$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aed478ff0edb377c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2ac92e9f65496a6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d7923c92d39b602$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d77f097c5efc750d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $736e95ec2b2aaf02$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88019eab2786a681$export$2e2bcd8739ae039), {
                icpSlug: "pisces"
            })
        ]
    });
};
var $b8439927cc3eeaed$export$2e2bcd8739ae039 = $b8439927cc3eeaed$var$LandingHomePisces;



var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");
































const $874872454e1b05af$var$LandingHomeClimb26 = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const params = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let [playVideo, setPlayVideo] = (0, $acw62.useState)(false);
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let [isLoggedInViaLink, setIsLoggedInViaLink] = (0, $acw62.useState)(false);
    let [isInvestor, setIsInvestor] = (0, $acw62.useState)(false);
    let [companyId, setCompanyId] = (0, $acw62.useState)(null);
    let [passwordError, setPasswordError] = (0, $acw62.useState)('');
    let [password, setPassword] = (0, $acw62.useState)({
        newPassword: '',
        newPasswordType: true,
        confirmPassword: '',
        confirmPasswordType: true
    });
    const videoRef = (0, $acw62.useRef)(null);
    let PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
    (0, $acw62.useEffect)(()=>{
        if (playVideo && videoRef['current']) videoRef['current'].play();
    }, [
        playVideo
    ]);
    (0, $acw62.useEffect)(()=>{
        let urlParams = new URLSearchParams(location?.search);
        let token = urlParams.get('token');
        let cId = urlParams.get('companyId');
        let userType = urlParams.get('userType');
        let partnerId = params?.['partnerId'] || urlParams.get('partnerId');
        if (token) {
            (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(token);
            localStorage.setItem('token', token);
            getUser();
            setIsLoggedInViaLink(true);
            setCompanyId(cId);
            if (userType === 'investor') setIsInvestor(true);
        }
        if (partnerId) getPartner(partnerId);
        else getPartner('CSF');
    }, []);
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/user');
        if (response['code'] == 200 && response['body']) dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(response['body']['user']));
    };
    const getPartner = async (id)=>{
        setIsLoader({
            show: true,
            message: 'Loading Partner...'
        });
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/${id}`);
        if (res['code'] == 200) dispatch((0, $3d3d7a2ee763f32a$export$6af6109222273956)(res['body']));
        setIsLoader({
            show: false,
            message: 'Loading...'
        });
    };
    const handleCheckReadiness = async ()=>{
        const companyRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getCompany/${companyId}`);
        const freshCompany = companyRes?.['body'];
        if (freshCompany?.['modules']?.['Investment Readiness']) {
            window.location.href = `/company/${companyId}#${partner['moduleName']}`;
            return;
        }
        if (user && partner?.['_id'] && companyId) {
            let data = {
                partnerId: partner['_id'],
                category: 'partner',
                companies: {
                    [companyId]: freshCompany['cName']
                },
                memberPermissions: {
                    [user['_id']]: {
                        ...user,
                        company: {
                            [companyId]: freshCompany['cName']
                        }
                    }
                }
            };
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'generatePartnerPopup'
            }));
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/checklist/create/0', data);
            if (res?.['code'] == 200) {
                window.location.href = `/company/${companyId}#${partner['moduleName']}`;
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
            }
        }
    };
    const handleSetPassword = async ()=>{
        if (password['newPassword'] == '' || password['confirmPassword'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter both passwords!');
        if (password['newPassword'] != password['confirmPassword']) return setPasswordError('Passwords don`t match!');
        if (!PASSWORD_PATTERN.test(password['newPassword'])) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Password must contain atleast one capital letter, one special character and a number');
            setPasswordError('Password must contain atleast one capital letter, one special character and a number');
            return;
        }
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/setPassword', {
            key: user['email'],
            password: password['newPassword']
        });
        if (res && res['code'] == 200) {
            if (isInvestor) {
                window.location.href = '/investor-dashboard';
                return;
            }
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            handleCheckReadiness();
        }
    };
    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "poppins-font-style accounts-page-font *",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "landing-page-climb26 bg15 c1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "climb26-hero",
                                style: {
                                    position: 'relative',
                                    width: '100%',
                                    overflow: 'hidden'
                                },
                                children: [
                                    !playVideo && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        style: {
                                            height: "100%",
                                            width: '100%',
                                            position: 'relative'
                                        },
                                        onClick: ()=>setPlayVideo(true),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w100 h100 cp pr",
                                                src: (parcelRequire("3WQfg")),
                                                alt: "Video Thumbnail",
                                                style: {
                                                    objectFit: 'cover',
                                                    display: 'block'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pa cp",
                                                style: {
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: 'clamp(40px, 10vw, 80px)'
                                                },
                                                src: (parcelRequire("i6Lkf")),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    playVideo && /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
                                        ref: videoRef,
                                        controls: true,
                                        style: {
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("source", {
                                            src: "https://diligentsia-website-assets.s3.us-east-2.amazonaws.com/climb26.mp4",
                                            type: "video/mp4"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc companies-section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic px8rem py4rem sm-px0rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs1-25rem mb0-5rem",
                                                        children: "Companies"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "fs2-5rem fw300 w100 mb0-5rem",
                                                        children: [
                                                            "FREE Investor",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "c4",
                                                                children: "Match"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " for ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw600 fsi",
                                                                children: "Companies"
                                                            }),
                                                            " attending"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "df w50 mb1rem",
                                                        src: (parcelRequire("iRgdw")),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs1-25rem fsi lsmd",
                                                        children: "1st - 2nd July, Leeds"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "df w20",
                                                src: (parcelRequire("3S7TI")),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                                        className: "silder-box bg5 br40px mx6rem pr",
                                        style: {
                                            bottom: '70px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                                            ...settings,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("duAsp")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("YlaV4")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("j0cx9")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("99eVd")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("6ji0O")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("1lqJw")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("87Kue")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("dFPSK")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("gVfeF")),
                                                            alt: "climb26-company-slide"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    partner && partner?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df jcc pb1rem",
                                        children: [
                                            isLoggedInViaLink ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                        open: 'setPasswordPopup'
                                                    })),
                                                className: "df jcc new-shadow cp c1 bg4 fw400 fs1rem br38px px2-5rem py0-5rem mr1rem",
                                                children: "Setup My Account"
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: `${$16250bd714b02a14$export$51e82cdd7353a0e1}#${partner['_id']}?Superflow`,
                                                className: "df fdc aic jcc new-shadow cp c1 bg4 fs12px fw600 br38px px3rem py0-5rem mr1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "fs9px fw300",
                                                        children: "Not yet registered?"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "+ Start For FREE"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: "https://koalendar.com/e/meet-with-mark-bernstein",
                                                target: "_blank",
                                                className: "df jcc aic c0 cp px2rem py0-5rem fw400 fs1rem bw1px bss bo0 br38px",
                                                children: "Book a Call"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc jcc investor-section pb3rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcsb aic px8rem py4rem sm-px0rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df fdc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs1-25rem mb0-5rem",
                                                        children: "Investors"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "fs2-5rem fw300 w100 mb0-5rem",
                                                        children: [
                                                            "FREE Investor",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "c4",
                                                                children: "Match"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            " for ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "fw600 fsi",
                                                                children: "Investors"
                                                            }),
                                                            " attending"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "df w50 mb1rem",
                                                        src: (parcelRequire("iRgdw")),
                                                        alt: ""
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "w100 fs1-25rem fsi lsmd",
                                                        children: "1st - 2nd July, Leeds"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "df w20",
                                                src: (parcelRequire("7VzoB")),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                                        className: "silder-box bg5 br40px mx6rem pr",
                                        style: {
                                            bottom: '70px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($87bcb1e0ef590b5f$exports))), {
                                            ...settings,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("ewAEC")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("3fHVW")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("53r3z")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("5NQYz")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("lQLLF")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("5phyI")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("7Z5XR")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "img-slider-box mx0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "br10px",
                                                            src: (parcelRequire("gVfeF")),
                                                            alt: "climb26-investor-slide"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w100 df jcc pb1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            onClick: ()=>window.open('https://koalendar.com/e/meet-with-mark-bernstein', '_blank'),
                                            className: "df jcc new-shadow cp c1 bg4 fw400 fs1rem br38px px2-5rem py0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "27",
                                                    height: "27",
                                                    viewBox: "0 0 39 39",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            opacity: "0.9",
                                                            d: "M33.3804 4.33135H30.3365C30.3365 4.06704 30.2812 3.80565 30.1742 3.56399C30.0671 3.32233 29.9106 3.10577 29.7148 2.92823C29.519 2.75069 29.2882 2.61612 29.0373 2.53317C28.7863 2.45022 28.5207 2.42072 28.2577 2.44659C27.7806 2.50563 27.3422 2.73901 27.0268 3.10184C26.7115 3.46466 26.5414 3.93129 26.5493 4.41196V5.27811C26.5493 5.7122 26.6983 6.13314 26.9716 6.47044C27.2448 6.80774 27.6256 7.04092 28.0503 7.13093C28.1718 7.15386 28.2795 7.22337 28.3505 7.32465C28.4215 7.42592 28.45 7.55091 28.4301 7.67296C28.4102 7.795 28.3433 7.90441 28.2438 7.97784C28.1443 8.05127 28.0201 8.0829 27.8976 8.06597C27.2514 7.93885 26.6694 7.59143 26.2509 7.083C25.8323 6.57457 25.6032 5.93665 25.6026 5.27811V4.33135H20.329C20.3267 4.08071 20.2747 3.83301 20.1759 3.60262C20.0772 3.37224 19.9337 3.16374 19.7537 2.98923C19.5738 2.81471 19.361 2.67764 19.1277 2.58597C18.8944 2.49429 18.6453 2.44983 18.3947 2.45517C18.1441 2.46051 17.897 2.51553 17.6678 2.61705C17.4387 2.71858 17.2319 2.86458 17.0596 3.04659C16.8872 3.22861 16.7527 3.44302 16.6639 3.67741C16.575 3.91179 16.5336 4.16147 16.5419 4.41199L16.5419 5.27811C16.5418 5.7122 16.6909 6.13313 16.9641 6.47043C17.2374 6.80773 17.6182 7.04091 18.0428 7.13093C18.1643 7.15388 18.272 7.2234 18.343 7.32467C18.4139 7.42593 18.4425 7.55091 18.4225 7.67293C18.4026 7.79496 18.3358 7.90436 18.2363 7.97779C18.1368 8.05121 18.0126 8.08285 17.8901 8.06595C17.244 7.93882 16.662 7.5914 16.2434 7.08297C15.8249 6.57455 15.5957 5.93663 15.5951 5.27809V4.33135H12.5512C11.7984 4.33275 11.0767 4.63244 10.5444 5.1648C10.012 5.69716 9.71233 6.41879 9.71094 7.17165V9.80842H36.2207V7.17165C36.2193 6.41878 35.9196 5.69715 35.3872 5.1648C34.8549 4.63244 34.1332 4.33275 33.3804 4.33135ZM17.4887 4.33135C17.4924 4.08268 17.5937 3.84544 17.7709 3.67089C17.9481 3.49634 18.1868 3.3985 18.4355 3.3985C18.6842 3.39851 18.9229 3.49636 19.1 3.67091C19.2772 3.84547 19.3786 4.08272 19.3822 4.33139L17.4887 4.33135ZM27.4961 4.33135C27.4998 4.08268 27.6012 3.84544 27.7784 3.67089C27.9555 3.49634 28.1942 3.3985 28.4429 3.3985C28.6916 3.39851 28.9303 3.49636 29.1075 3.67091C29.2846 3.84547 29.386 4.08272 29.3897 4.33139L27.4961 4.33135Z",
                                                            fill: "#FEFEFE"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            opacity: "0.9",
                                                            d: "M9.74219 17.1934C9.87852 17.459 10.8695 19.0329 10.954 19.27C11.2572 19.9563 11.3021 20.729 11.0806 21.4458C10.8591 22.1626 10.386 22.7752 9.74849 23.1707C9.7935 23.9237 10.1243 24.6311 10.6733 25.1485C11.2223 25.6658 11.9481 25.954 12.7024 25.9543H33.2286C34.0134 25.9531 34.7657 25.6409 35.3206 25.086C35.8755 24.5311 36.1877 23.7788 36.1888 22.994V11.0078H9.74219V17.1934ZM30.4261 13.3495C30.6717 13.3528 30.9061 13.4527 31.0786 13.6275C31.251 13.8023 31.3477 14.0381 31.3477 14.2837C31.3477 14.5292 31.251 14.765 31.0785 14.9398C30.906 15.1146 30.6717 15.2145 30.4261 15.2178C30.1805 15.2145 29.9461 15.1146 29.7736 14.9398C29.6012 14.7649 29.5045 14.5292 29.5045 14.2836C29.5045 14.038 29.6012 13.8023 29.7737 13.6275C29.9462 13.4527 30.1805 13.3528 30.4261 13.3495ZM30.4261 17.5469C30.6716 17.5503 30.9059 17.6502 31.0783 17.8251C31.2506 17.9999 31.3473 18.2355 31.3473 18.481C31.3473 18.7266 31.2506 18.9622 31.0782 19.137C30.9058 19.3118 30.6716 19.4117 30.4261 19.4152C30.1806 19.4117 29.9463 19.3118 29.7739 19.137C29.6016 18.9622 29.5049 18.7265 29.5049 18.481C29.5049 18.2355 29.6016 17.9999 29.774 17.825C29.9464 17.6502 30.1806 17.5503 30.4261 17.5469ZM30.4261 21.7442C30.6717 21.7475 30.9061 21.8474 31.0786 22.0223C31.251 22.1971 31.3477 22.4328 31.3477 22.6784C31.3477 22.924 31.251 23.1597 31.0785 23.3345C30.906 23.5094 30.6717 23.6092 30.4261 23.6126C30.1805 23.6092 29.9461 23.5093 29.7736 23.3345C29.6012 23.1597 29.5045 22.924 29.5045 22.6784C29.5045 22.4328 29.6012 22.1971 29.7737 22.0222C29.9462 21.8474 30.1805 21.7475 30.4261 21.7442ZM22.9655 13.3495C23.2111 13.3528 23.4455 13.4527 23.618 13.6275C23.7905 13.8023 23.8872 14.0381 23.8872 14.2837C23.8872 14.5292 23.7904 14.765 23.618 14.9398C23.4455 15.1146 23.2111 15.2145 22.9655 15.2178C22.7199 15.2145 22.4855 15.1146 22.3131 14.9398C22.1406 14.7649 22.0439 14.5292 22.0439 14.2836C22.0439 14.038 22.1406 13.8023 22.3131 13.6275C22.4856 13.4527 22.72 13.3528 22.9655 13.3495ZM22.9655 17.5469C23.211 17.5503 23.4453 17.6502 23.6177 17.8251C23.7901 17.9999 23.8867 18.2355 23.8867 18.481C23.8867 18.7266 23.79 18.9622 23.6177 19.137C23.4453 19.3118 23.211 19.4117 22.9655 19.4152C22.72 19.4117 22.4857 19.3118 22.3134 19.137C22.141 18.9622 22.0443 18.7265 22.0443 18.481C22.0443 18.2355 22.141 17.9999 22.3134 17.825C22.4858 17.6502 22.7201 17.5503 22.9655 17.5469ZM22.9655 21.7442C23.2111 21.7475 23.4455 21.8474 23.618 22.0223C23.7905 22.1971 23.8872 22.4328 23.8872 22.6784C23.8872 22.924 23.7904 23.1597 23.618 23.3345C23.4455 23.5094 23.2111 23.6092 22.9655 23.6126C22.7199 23.6092 22.4855 23.5094 22.3131 23.3345C22.1406 23.1597 22.0439 22.924 22.0439 22.6784C22.0439 22.4328 22.1406 22.1971 22.3131 22.0222C22.4856 21.8474 22.72 21.7475 22.9655 21.7442ZM15.505 13.3495C15.7493 13.3547 15.9818 13.4554 16.1527 13.63C16.3237 13.8047 16.4194 14.0393 16.4194 14.2837C16.4194 14.528 16.3236 14.7626 16.1527 14.9373C15.9818 15.1119 15.7492 15.2126 15.5049 15.2178C15.2606 15.2126 15.0281 15.1119 14.8572 14.9373C14.6862 14.7626 14.5905 14.528 14.5905 14.2836C14.5905 14.0393 14.6862 13.8046 14.8572 13.63C15.0281 13.4554 15.2607 13.3547 15.505 13.3495ZM15.505 17.5469C15.7493 17.552 15.9819 17.6527 16.1529 17.8273C16.3239 18.002 16.4196 18.2366 16.4196 18.481C16.4196 18.7254 16.3239 18.9601 16.1529 19.1347C15.9819 19.3094 15.7493 19.41 15.5049 19.4152C15.2606 19.41 15.028 19.3093 14.857 19.1347C14.686 18.9601 14.5902 18.7254 14.5902 18.481C14.5902 18.2366 14.686 18.002 14.857 17.8273C15.028 17.6527 15.2606 17.552 15.505 17.5469ZM15.505 21.7442C15.7493 21.7494 15.9819 21.8501 16.1529 22.0247C16.3239 22.1993 16.4197 22.434 16.4196 22.6784C16.4196 22.9228 16.3239 23.1575 16.1529 23.3321C15.9819 23.5067 15.7493 23.6074 15.5049 23.6126C15.2606 23.6074 15.028 23.5067 14.857 23.3321C14.686 23.1575 14.5902 22.9228 14.5902 22.6784C14.5902 22.434 14.686 22.1993 14.857 22.0247C15.028 21.85 15.2606 21.7494 15.505 21.7442Z",
                                                            fill: "#FEFEFE"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M21.993 30.9786L19.7586 29.6342C19.5111 29.4866 19.2327 29.3987 18.9453 29.3775C18.6579 29.3563 18.3695 29.4024 18.1031 29.512C17.8366 29.6217 17.5993 29.7919 17.4101 30.0092C17.2209 30.2266 17.0849 30.485 17.013 30.7641C16.9356 30.9948 16.8076 31.2054 16.6383 31.3802C16.4689 31.5551 16.2626 31.6898 16.0344 31.7746C15.8062 31.8593 15.5619 31.8919 15.3195 31.8699C15.0771 31.848 14.8427 31.772 14.6334 31.6476C13.2117 30.7997 11.9014 29.7777 10.7327 28.6054C9.56324 27.4388 8.54149 26.133 7.69034 24.7173C7.56427 24.5008 7.48903 24.2585 7.47032 24.0087C7.4516 23.7589 7.4899 23.5081 7.58232 23.2753C7.67473 23.0424 7.81885 22.8336 8.00378 22.6646C8.18871 22.4957 8.40963 22.3709 8.64984 22.2998C8.89934 22.2223 9.12966 22.0929 9.32573 21.9202C9.52179 21.7475 9.67919 21.5353 9.78762 21.2976C9.89604 21.0599 9.95306 20.802 9.95494 20.5407C9.95681 20.2794 9.90351 20.0207 9.79851 19.7814C9.84927 19.8024 8.3863 17.4031 8.35944 17.345C8.10616 16.9272 7.69801 16.6264 7.22391 16.5081C6.74982 16.3899 6.24821 16.4639 5.8284 16.7139C4.45345 17.5364 3.44502 18.8536 3.00966 20.3955C2.57429 21.9374 2.74495 23.5875 3.48667 25.0076C5.89802 29.647 9.67986 33.431 14.3178 35.8451C15.738 36.5888 17.3888 36.7613 18.9321 36.3271C20.4753 35.8929 21.794 34.8849 22.6179 33.5097C22.8707 33.0912 22.9468 32.5894 22.8297 32.1147C22.7125 31.6401 22.4115 31.2314 21.993 30.9786Z",
                                                            fill: "#FEFEFE"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "pl0-5rem fw600 c1",
                                                    children: "Book a Call"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "setPasswordPopup",
                open: modal['open'] == 'setPasswordPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style bg1 shadow df fdc aic m1rem br20px",
                    style: {
                        outline: 'none',
                        padding: '2rem',
                        maxWidth: '480px',
                        width: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "mb1-5rem",
                            src: (parcelRequire("bJ68K")),
                            alt: "",
                            style: {
                                width: '60px',
                                height: '60px',
                                objectFit: 'contain'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-75rem fw600 c15 tac mb0-5rem",
                            children: "Set Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-875rem fw400 c28 tac mb1-5rem",
                            children: "Choose a strong password for your account"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 pr mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    id: "newPassword",
                                    className: "df w100",
                                    placeholder: "New Password",
                                    value: password['newPassword'],
                                    type: password['newPasswordType'] ? 'password' : 'text',
                                    onChange: (e)=>{
                                        setPassword({
                                            ...password,
                                            newPassword: e['target']['value']
                                        });
                                        setPasswordError('');
                                    },
                                    helperText: passwordError,
                                    FormHelperTextProps: {
                                        sx: {
                                            width: '100%',
                                            color: 'red',
                                            fontStyle: 'italic'
                                        }
                                    }
                                }),
                                password['newPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            newPasswordType: !password['newPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-35%)',
                                        right: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                        fill: "#404040"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            newPasswordType: !password['newPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-50%)',
                                        right: '12px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                            fill: "#404040"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                            fill: "#404040"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 pr mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    id: "confirmPassword",
                                    className: "df w100",
                                    placeholder: "Confirm Password",
                                    value: password['confirmPassword'],
                                    type: password['confirmPasswordType'] ? 'password' : 'text',
                                    onChange: (e)=>{
                                        setPassword({
                                            ...password,
                                            confirmPassword: e['target']['value']
                                        });
                                        setPasswordError('');
                                    },
                                    helperText: passwordError,
                                    FormHelperTextProps: {
                                        sx: {
                                            width: '100%',
                                            color: 'red',
                                            fontStyle: 'italic'
                                        }
                                    }
                                }),
                                password['confirmPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            confirmPasswordType: !password['confirmPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-35%)',
                                        right: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                        fill: "#404040"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            confirmPasswordType: !password['confirmPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-50%)',
                                        right: '12px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                            fill: "#404040"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                            fill: "#404040"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "w100 fs12px fw400 c28 mb1-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fas fa-info-circle mr0-5rem"
                                }),
                                "Must include uppercase, lowercase, number & special character"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>handleSetPassword(),
                            className: `w100 df aic jcc c1 fw500 fs14px br50px py0-75rem mb0-75rem ${password['newPassword'] == '' || password['confirmPassword'] == '' ? 'bg12' : 'cp bg3'}`,
                            children: "Set Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            className: "w100 tac cp",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs14px fw400",
                                style: {
                                    color: '#15131380'
                                },
                                children: "Cancel"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $874872454e1b05af$export$2e2bcd8739ae039 = $874872454e1b05af$var$LandingHomeClimb26;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $ab44d7ce771effd8$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $ab44d7ce771effd8$var$CLIENTS = [
    {
        nm: 'Acme Holdings',
        tier: 'Gold',
        w: '84%',
        cls: 'gold'
    },
    {
        nm: 'Bloom & Co',
        tier: 'Silver',
        w: '61%',
        cls: 'silver'
    },
    {
        nm: 'Nova Ventures',
        tier: 'Bronze',
        w: '38%',
        cls: 'bronze'
    }
];

const $ab44d7ce771effd8$var$AccountantsHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge lp-badge--up",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "For Accountants"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: [
                                    "Grow your clients\u2019",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        style: {
                                            color: '#FC7785'
                                        },
                                        children: "value."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Simply."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "Our platform, free to accountancy practices \u2013 helps you deliver existing corporate finance services at higher margins, more quickly at less cost and introduces dealflow to you."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--primary",
                                        href: $ab44d7ce771effd8$var$KOALENDAR,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Book a call"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "lp-btn lp-btn--ghost",
                                        to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                        children: "Register free"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-hero-art",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-stage",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "lp-acc-photo",
                                    src: (parcelRequire("jEpcG")),
                                    alt: "Accountant professional"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-acc-clientcard lp-float",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "200",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "cc-top",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "t",
                                                    children: "Client health"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "n",
                                                    children: "3 active"
                                                })
                                            ]
                                        }),
                                        $ab44d7ce771effd8$var$CLIENTS.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "cc-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "cc-head",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: "nm",
                                                                children: c.nm
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                className: `tier ${c.cls}`,
                                                                children: c.tier
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "track",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: c.cls,
                                                            style: {
                                                                width: c.w
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, i))
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
var $ab44d7ce771effd8$export$2e2bcd8739ae039 = $ab44d7ce771effd8$var$AccountantsHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $d48ff7d989b034e9$var$IconUpload = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "16 16 12 12 8 16"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "12",
                y1: "12",
                x2: "12",
                y2: "21"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
            })
        ]
    });
const $d48ff7d989b034e9$var$IconServer = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "2",
                width: "20",
                height: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "14",
                width: "20",
                height: "8",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "6.01",
                y2: "6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "18",
                x2: "6.01",
                y2: "18"
            })
        ]
    });
const $d48ff7d989b034e9$var$IconTrend = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "23 6 13.5 15.5 8.5 10.5 1 18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "17 6 23 6 23 12"
            })
        ]
    });
const $d48ff7d989b034e9$var$STEPS = [
    {
        Icon: $d48ff7d989b034e9$var$IconUpload,
        cls: 'blue',
        no: 'Step 01',
        t: 'Connect your clients',
        d: 'Add one or more client companies and invite your team. One structured workspace keeps every engagement organised from day one.'
    },
    {
        Icon: $d48ff7d989b034e9$var$IconServer,
        cls: 'pink',
        no: 'Step 02',
        t: 'Let AI do the groundwork',
        d: "Clarence interrogates the client\u2019s documents and pre-populates the diligence modules \u2014 you review and refine instead of starting from a blank page."
    },
    {
        Icon: $d48ff7d989b034e9$var$IconTrend,
        cls: 'green',
        no: 'Step 03',
        t: 'Deliver insight, grow revenue',
        d: 'Turn the outputs into higher-value advisory. Improve service margins, unlock new revenue streams, and win introductions to new clients.'
    }
];
const $d48ff7d989b034e9$var$AccountantsHowItWorks = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "how-it-works",
        className: "lp-acc-steps-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-eyebrow",
                "data-lp-reveal": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-ww-eyebrow",
                    children: "How it works"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-h2 lp-acc-steps-head",
                "data-lp-reveal": true,
                "data-lp-delay": "60",
                children: "Three steps to more value for your clients."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-acc-steps-sub",
                "data-lp-reveal": true,
                "data-lp-delay": "120",
                children: "From onboarding to ongoing advisory \u2014 Diligentsia structures the work so you can focus on the insight."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-acc-steps",
                children: $d48ff7d989b034e9$var$STEPS.map(({ Icon: Icon, cls: cls, no: no, t: t, d: d }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-acc-stepcard",
                        "data-lp-reveal": true,
                        "data-lp-delay": i * 120,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `lp-acc-icon ${cls}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-acc-steplabel",
                                children: no
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: t
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: d
                            })
                        ]
                    }, i))
            })
        ]
    });
var $d48ff7d989b034e9$export$2e2bcd8739ae039 = $d48ff7d989b034e9$var$AccountantsHowItWorks;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $47b1da18461aeff8$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $47b1da18461aeff8$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $47b1da18461aeff8$var$QUOTES = [
    {
        q: 'It automates the routine groundwork so my team spends their time on advice, not admin. Our service margins have genuinely improved.',
        a: "\u2014 Partner, mid-tier accountancy firm"
    },
    {
        q: 'Being able to offer clients a structured route to investment and exit readiness has opened a new, high-margin revenue stream for the practice.',
        a: "\u2014 Director, advisory & corporate finance"
    },
    {
        q: "Clients see the value immediately \u2014 a clear picture of where they stand and what to fix. It has made us far stickier as their adviser.",
        a: "\u2014 Managing Partner, regional firm"
    },
    {
        q: 'Free to us, valuable to the client. The introductions to new clients through the platform are a welcome bonus.',
        a: "\u2014 Founder, boutique accountancy practice"
    },
    {
        q: 'The AI does about 60% of the heavy lifting and we sign off the rest. It is the efficiency gain we have been looking for.',
        a: "\u2014 Client Services Lead, accountancy group"
    }
];
const $47b1da18461aeff8$var$GLOWS = [
    {
        top: -110,
        left: -90,
        size: 480,
        c: 'rgba(252,119,133,0.42)'
    },
    {
        top: 20,
        right: -120,
        size: 540,
        c: 'rgba(74,103,255,0.40)'
    },
    {
        bottom: -150,
        left: '12%',
        size: 520,
        c: 'rgba(74,103,255,0.34)'
    },
    {
        bottom: -110,
        right: '6%',
        size: 420,
        c: 'rgba(252,119,133,0.32)'
    }
];
const $47b1da18461aeff8$var$pos = (v)=>v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v;
const $47b1da18461aeff8$var$AccountantsQuotesSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, page: page, pages: pages, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)($47b1da18461aeff8$var$QUOTES.length, {
        autoplayMs: 5500
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-quotes",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-quotes-bg",
                "aria-hidden": "true",
                children: $47b1da18461aeff8$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: $47b1da18461aeff8$var$pos(g.top),
                            bottom: $47b1da18461aeff8$var$pos(g.bottom),
                            left: $47b1da18461aeff8$var$pos(g.left),
                            right: $47b1da18461aeff8$var$pos(g.right),
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(78px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-quotes-eyebrow",
                                "data-lp-reveal": true,
                                children: "What they say."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "lp-quotes-sub",
                                "data-lp-reveal": true,
                                children: "Here\u2019s what accountants and their clients say about working with Diligentsia."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-arrows",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Previous quotes",
                                onClick: prev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($47b1da18461aeff8$var$ChevronL, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Next quotes",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($47b1da18461aeff8$var$ChevronR, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-slide-anim",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-track",
                            ref: trackRef,
                            children: $47b1da18461aeff8$var$QUOTES.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                    className: "lp-qcard",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": i % 3 * 120,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("figcaption", {
                                            children: item.a
                                        })
                                    ]
                                }, i))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-foot",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        "data-lp-reveal": true,
                        children: "Real feedback from accountants and their clients using Diligentsia."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-dots",
                        style: {
                            margin: 0,
                            padding: 0
                        },
                        children: Array.from({
                            length: pages
                        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `lp-dot ${i === page ? 'is-active' : ''}`,
                                "aria-label": `Go to slide ${i + 1}`,
                                onClick: ()=>goTo(i)
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $47b1da18461aeff8$export$2e2bcd8739ae039 = $47b1da18461aeff8$var$AccountantsQuotesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


const $a8409220a00249f6$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $a8409220a00249f6$var$AccountantsCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "cta",
        className: "lp-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cta-card",
            "data-lp-reveal": true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cta-glow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Ready to grow your clients\u2019 value?"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "sub",
                            children: "Join Diligentsia free \u2014 and start delivering more for every client."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-cta-btns",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "lp-cta-btn",
                                    href: $a8409220a00249f6$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Book a call"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    className: "lp-cta-btn lp-cta-btn--outline",
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    children: "Register free"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $a8409220a00249f6$export$2e2bcd8739ae039 = $a8409220a00249f6$var$AccountantsCtaSection;



const $08be363c0766a6d2$var$LandingHomeAccountant = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab44d7ce771effd8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d48ff7d989b034e9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8409220a00249f6$export$2e2bcd8739ae039), {})
        ]
    });
};
var $08be363c0766a6d2$export$2e2bcd8739ae039 = $08be363c0766a6d2$var$LandingHomeAccountant;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $12ad8f0e3e9a2f5e$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $12ad8f0e3e9a2f5e$var$ROWS = [
    {
        nm: 'Northwind Ltd',
        badge: 'gold',
        label: 'Gold',
        pct: '82%',
        pctCls: 'g'
    },
    {
        nm: 'Atlas Bio',
        badge: 'silver',
        label: 'Silver',
        pct: '61%',
        pctCls: 'a'
    },
    {
        nm: 'Cedar Labs',
        badge: 'bronze',
        label: 'Bronze',
        pct: '48%',
        pctCls: 'a'
    }
];

const $12ad8f0e3e9a2f5e$var$AngelHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "For angel networks"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: "Your network becomes the quality standard."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "The first network to deliver pre-diligenced companies will set the bar. Free to the network. No friction for your applicants. Diligence tools for your angels."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "lp-btn lp-btn--primary",
                                    href: $12ad8f0e3e9a2f5e$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Book a 20-min demo"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-hero-social",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "d",
                                        style: {
                                            width: 7,
                                            height: 7,
                                            borderRadius: '50%',
                                            background: '#FC7785',
                                            display: 'inline-block'
                                        }
                                    }),
                                    "Free to angel networks \xb7 No IT setup \xb7 Starts in days"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-hero-art",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-hero-stage lp-hero-stage--angel",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-hero-panel",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "lp-hero-photo",
                                    src: (parcelRequire("asck4")),
                                    alt: "Angel network partner"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-hero-dash lp-float",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "200",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-dash-top",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "t",
                                                    children: "Applicant dashboard"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "lp-dash-ring",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "62",
                                                            height: "62",
                                                            viewBox: "0 0 62 62",
                                                            "aria-hidden": "true",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                    cx: "31",
                                                                    cy: "31",
                                                                    r: "26",
                                                                    fill: "none",
                                                                    stroke: "#EAF6EF",
                                                                    strokeWidth: "7"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                    cx: "31",
                                                                    cy: "31",
                                                                    r: "26",
                                                                    fill: "none",
                                                                    stroke: "#1F8A5B",
                                                                    strokeWidth: "7",
                                                                    strokeLinecap: "round",
                                                                    strokeDasharray: "163.4",
                                                                    strokeDashoffset: "29.4"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "p",
                                                            children: "82%"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-dash-rows",
                                            children: $12ad8f0e3e9a2f5e$var$ROWS.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "lp-dash-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "nm",
                                                            children: r.nm
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "rt",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: `badge ${r.badge}`,
                                                                    children: r.label
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: `pct ${r.pctCls}`,
                                                                    children: r.pct
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, i))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-hero-pill lp-float",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                                points: "20 6 9 17 4 12"
                                            })
                                        }),
                                        "Pre-diligenced"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
var $12ad8f0e3e9a2f5e$export$2e2bcd8739ae039 = $12ad8f0e3e9a2f5e$var$AngelHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $5adebaf0d0c5b080$var$STATS = [
    {
        count: 70,
        suffix: '%',
        label: 'of angel-backed companies never properly diligenced'
    },
    {
        count: 2,
        prefix: '<',
        suffix: '%',
        label: 'of applications result in investment'
    },
    {
        count: 60,
        prefix: '~',
        suffix: '%',
        label: 'of diligence auto-populated by AI'
    },
    {
        count: 0,
        prefix: "\xa3",
        label: 'cost to the angel network',
        pink: true
    }
];
const $5adebaf0d0c5b080$var$GLOWS = [
    {
        top: -80,
        left: -100,
        size: 420,
        c: 'rgba(252,119,133,0.36)'
    },
    {
        top: -80,
        right: -100,
        size: 440,
        c: 'rgba(74,103,255,0.38)'
    }
];
const $5adebaf0d0c5b080$var$AngelStatBand = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-stats lp-stats--glow",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-stats-bg",
                "aria-hidden": "true",
                children: $5adebaf0d0c5b080$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: g.top + 'px',
                            left: g.left != null ? g.left + 'px' : 'auto',
                            right: g.right != null ? g.right + 'px' : 'auto',
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(74px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-stats-grid",
                children: $5adebaf0d0c5b080$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        "data-lp-reveal": true,
                        "data-lp-delay": i * 80,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: `lp-stat-num ${s.pink ? 'pink' : ''}`,
                                "data-count": s.count,
                                "data-prefix": s.prefix || '',
                                "data-suffix": s.suffix || '',
                                children: (s.prefix || '') + s.count + (s.suffix || '')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-stat-label",
                                children: s.label
                            })
                        ]
                    }, i))
            })
        ]
    });
var $5adebaf0d0c5b080$export$2e2bcd8739ae039 = $5adebaf0d0c5b080$var$AngelStatBand;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $889f6085dfa376b2$var$AngelProblemSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-split",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-split-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "c",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-h2",
                            "data-lp-reveal": true,
                            children: "The conflict between volume and quality."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lead",
                            "data-lp-reveal": true,
                            "data-lp-delay": "80",
                            children: "Networks need fee-paying applicants to survive \u2014 which creates pressure to accept companies regardless of readiness. The result is an overwhelmed IC, members who feel their time is wasted, and returns nobody publishes."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                    className: "lp-quote-card lp-float",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mk",
                            children: "\u201C"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                            children: "Angels invest on gut feel \u2014 not because they want to, but because deal sizes of \xa325k\u2013\xa3500k were always too small to justify external diligence. Until now."
                        })
                    ]
                })
            ]
        })
    });
var $889f6085dfa376b2$export$2e2bcd8739ae039 = $889f6085dfa376b2$var$AngelProblemSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $81eead98d6dfbdcc$exports = {};
$81eead98d6dfbdcc$exports = new URL("about-cycle.a5c99cb7.png", import.meta.url).toString();


/**
 * The "Your Angel Network" virtuous-cycle graphic, sitting between the problem framing and the
 * three flows. Reason: the diagram is supplied as artwork rather than markup, so its five labels
 * live in the image — the alt text carries them for anyone who cannot see it.
 */ const $b7c66dd4aa78e1e4$var$AngelValueCycleSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-an-cycle-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "lp-an-cycle-head",
                "data-lp-reveal": true,
                children: [
                    "Adding value through your ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Network"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-an-cycle-sub",
                "data-lp-reveal": true,
                "data-lp-delay": "80",
                children: "Improved network portfolio returns, improved network reputation"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                className: "lp-an-cycle-art",
                src: $81eead98d6dfbdcc$exports,
                alt: "Your Angel Network cycle: 1 effective due diligence, 2 at-a-glance certification, 3 more investors will invest, 4 improved angel network reputation, 5 more investors and more good quality companies",
                "data-lp-reveal": true,
                "data-lp-delay": "160"
            })
        ]
    });
var $b7c66dd4aa78e1e4$export$2e2bcd8739ae039 = $b7c66dd4aa78e1e4$var$AngelValueCycleSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $69c7bb5a36e1d3fa$var$FLOWS = [
    {
        n: '01',
        cls: 'blue',
        t: 'All applicants',
        d: 'Every application triggers a free structured readiness profile. Your team sees a readiness score before reading a deck.',
        get: 'Pre-screening done before your team opens a single deck.'
    },
    {
        n: '02',
        cls: 'pink',
        t: 'Rejected applicants',
        d: "Every company you decline gets a warm handover \u2014 to VCs, advisors, and other programmes.",
        get: "A constructive exit that protects your network's reputation."
    },
    {
        n: '03',
        cls: 'green',
        t: 'Accepted pitchers',
        d: 'Every invited company completes a certified Diligence Pack during the pre-pitch waiting period.',
        getImg: (parcelRequire("9WBJo"))
    },
    {
        n: '04',
        cls: 'blue',
        t: 'Diligence Tools',
        d: 'We give your angels access to the toolkit that we provide our VCs.',
        get: 'More informed angel investors before they invest.'
    }
];
const $69c7bb5a36e1d3fa$var$AngelFlowsSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "how-it-works",
        className: "lp-flows-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-flows-head",
                "data-lp-reveal": true,
                children: "Three flows. One platform. No cost to the network."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-flows",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-flows-line",
                        "aria-hidden": "true"
                    }),
                    $69c7bb5a36e1d3fa$var$FLOWS.map((f, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-flow",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 120,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `n ${f.cls}`,
                                    children: f.n
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: f.t
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: f.d
                                }),
                                f.getImg ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "lp-flow-cert",
                                    src: f.getImg,
                                    alt: "Bronze / Silver / Gold certification"
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "get",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "You get:"
                                        }),
                                        " ",
                                        f.get
                                    ]
                                })
                            ]
                        }, i))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "lp-flows-foot",
                "data-lp-reveal": true,
                children: [
                    "Operator setup: 30 minutes. Company onboarding: 20 minutes.",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Starts in days, not months."
                    })
                ]
            })
        ]
    });
var $69c7bb5a36e1d3fa$export$2e2bcd8739ae039 = $69c7bb5a36e1d3fa$var$AngelFlowsSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $87a169b968399780$var$CARDS = [
    {
        image: (parcelRequire("lgmiQ")),
        t: 'Better signal',
        d: 'Your IC sees only companies that have passed a structured readiness filter. Less noise. More signal.'
    },
    {
        image: (parcelRequire("dZpNf")),
        t: 'Faster closes',
        d: 'A certified Diligence Pack is already in place before due diligence begins. Angels spend time deciding, not chasing documents.'
    },
    {
        image: (parcelRequire("fj5w3")),
        t: 'First-mover advantage',
        d: 'The networks that establish a quality standard now will attract better deal flow for years. The question is which network gets there first.'
    }
];
const $87a169b968399780$var$AngelChangesSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-change-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-h2",
                "data-lp-reveal": true,
                style: {
                    textAlign: 'center',
                    margin: '0 auto 52px',
                    maxWidth: 680
                },
                children: "What changes for your network."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-change-grid",
                children: $87a169b968399780$var$CARDS.map(({ image: image, t: t, d: d }, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-change",
                        "data-lp-reveal": true,
                        "data-lp-delay": i * 100,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "ic",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: image,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: t
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: d
                            })
                        ]
                    }, i))
            })
        ]
    });
var $87a169b968399780$export$2e2bcd8739ae039 = $87a169b968399780$var$AngelChangesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $55226786d88251d7$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $55226786d88251d7$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $55226786d88251d7$var$QUOTES = [
    {
        q: "It's not that it doesn't get done. It just takes longer to answer those questions three weeks down the line than if they're answered three days into it.",
        a: ''
    },
    {
        q: "I think it's a really good service to be able to offer \u2014 especially with rejections and with those that we want to keep an eye on for the next three to six months.",
        a: ''
    },
    {
        q: 'The pitch gets the meeting. The Diligence Pack gets the money.',
        a: ''
    },
    {
        q: "There's quite a few companies that we don't even accept on our platform because they're below being ready \u2014 a lot of founders think in terms of product, not in terms of the investment thesis.",
        a: ''
    },
    {
        q: "I'd love to be able to look at business plans and know that there are questions they'll have to field that they're just not prepared for \u2014 which is why some of this would be quite good.",
        a: ''
    },
    {
        q: 'If you can demonstrate that a company is really well organised and clearly very well run, would I pay a 10% premium? Of course I would.',
        a: ''
    },
    {
        q: 'Better organised businesses do better. Better organised businesses grow faster.',
        a: ''
    }
];
const $55226786d88251d7$var$GLOWS = [
    {
        top: -110,
        left: -90,
        size: 480,
        c: 'rgba(252,119,133,0.42)'
    },
    {
        top: 20,
        right: -120,
        size: 540,
        c: 'rgba(74,103,255,0.40)'
    },
    {
        bottom: -150,
        left: '12%',
        size: 520,
        c: 'rgba(74,103,255,0.34)'
    },
    {
        bottom: -110,
        right: '6%',
        size: 420,
        c: 'rgba(252,119,133,0.32)'
    }
];
const $55226786d88251d7$var$pos = (v)=>v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v;
const $55226786d88251d7$var$AngelQuotesSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, page: page, pages: pages, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)($55226786d88251d7$var$QUOTES.length, {
        autoplayMs: 5500
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-quotes",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-quotes-bg",
                "aria-hidden": "true",
                children: $55226786d88251d7$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: $55226786d88251d7$var$pos(g.top),
                            bottom: $55226786d88251d7$var$pos(g.bottom),
                            left: $55226786d88251d7$var$pos(g.left),
                            right: $55226786d88251d7$var$pos(g.right),
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(78px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        children: "What people in the room are saying."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-arrows",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Previous quotes",
                                onClick: prev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($55226786d88251d7$var$ChevronL, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Next quotes",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($55226786d88251d7$var$ChevronR, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-slide-anim",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-track",
                            ref: trackRef,
                            children: $55226786d88251d7$var$QUOTES.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                    className: "lp-qcard",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": i % 3 * 120,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("figcaption", {
                                            children: item.a
                                        })
                                    ]
                                }, i))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-foot",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        "data-lp-reveal": true,
                        children: "Diligentsia is free to angel networks. No platform fees, no per-application charges."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-dots",
                        style: {
                            margin: 0,
                            padding: 0
                        },
                        children: Array.from({
                            length: pages
                        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `lp-dot ${i === page ? 'is-active' : ''}`,
                                "aria-label": `Go to slide ${i + 1}`,
                                onClick: ()=>goTo(i)
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $55226786d88251d7$export$2e2bcd8739ae039 = $55226786d88251d7$var$AngelQuotesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $4249991914926b28$var$AngelPricingSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-pricing-sec",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "lp-h2",
                "data-lp-reveal": true,
                style: {
                    textAlign: 'center',
                    margin: '0 auto 44px',
                    maxWidth: 680
                },
                children: "Simple, transparent pricing."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-pricing-grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-price",
                        "data-lp-reveal": true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lbl",
                                children: "Angel network"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "amt",
                                children: "Free"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Full platform access: applicant triage, readiness dashboard, certification visibility, warm rejection flow. No fees, no setup costs, no commitment."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-price lp-price--pro",
                        "data-lp-reveal": true,
                        "data-lp-delay": "100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lbl",
                                style: {
                                    color: "#fff"
                                },
                                children: "Applicant companies"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "amt",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "per",
                                        children: "From"
                                    }),
                                    " \xa38.25",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "per",
                                        children: " / mo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "sub",
                                children: "\xa399/yr \xb7 billed annually"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "You get them the pitch. We get them the money, and their next round follow on funding."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "lp-price-note",
                "data-lp-reveal": true,
                children: "Networks may subsidise applicant costs. Cohort and bulk pricing available."
            })
        ]
    });
var $4249991914926b28$export$2e2bcd8739ae039 = $4249991914926b28$var$AngelPricingSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $28650b35ca2e5218$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const $28650b35ca2e5218$var$AngelCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "cta",
        className: "lp-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cta-card",
            "data-lp-reveal": true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cta-glow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Become the network that sets the standard."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "sub",
                            children: "A 20-minute demo using a company similar to your typical applicant. No commitment. No IT setup. Starts in days."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "lp-cta-btn",
                            href: $28650b35ca2e5218$var$KOALENDAR,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "av",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("3jD7H")),
                                        alt: ""
                                    })
                                }),
                                "Book a Call"
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $28650b35ca2e5218$export$2e2bcd8739ae039 = $28650b35ca2e5218$var$AngelCtaSection;







const $8615d6566591df2f$var$AngelsNetworks = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    (0, $282a70cc4e13b055$export$2e2bcd8739ae039)({
        canonicalPath: `${(0, $7393559700759e6c$export$aa103e2c51dcf48a)['angel-network']['hubPath']}/`,
        schema: (0, $1070c78a15f5f98b$export$2e2bcd8739ae039)('angel-network')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12ad8f0e3e9a2f5e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5adebaf0d0c5b080$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $889f6085dfa376b2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7c66dd4aa78e1e4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69c7bb5a36e1d3fa$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87a169b968399780$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55226786d88251d7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4249991914926b28$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28650b35ca2e5218$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88019eab2786a681$export$2e2bcd8739ae039), {
                icpSlug: "angel-network"
            })
        ]
    });
};
var $8615d6566591df2f$export$2e2bcd8739ae039 = $8615d6566591df2f$var$AngelsNetworks;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $711effddec1d9025$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';




// Partner organisations the platform's fractional CFOs come from — follows the "…on the platform from" line.
const $711effddec1d9025$var$PARTNER_LOGOS = [
    {
        src: (parcelRequire("8oTWu")),
        alt: 'Fractionality'
    },
    {
        src: (parcelRequire("cN5F9")),
        alt: 'Ascentis'
    },
    {
        src: (parcelRequire("at5J5")),
        alt: 'The CFO Centre'
    },
    {
        src: (parcelRequire("5Qq06")),
        alt: 'The FD Consultant'
    }
];




const $711effddec1d9025$var$FractionalHeroSection = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-badge",
                                "data-lp-reveal": true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    "For fractional CFOs"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "lp-h1",
                                "data-lp-reveal": true,
                                "data-lp-delay": "60",
                                children: "The AI-powered toolkit that makes you indispensable"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-lead",
                                "data-lp-reveal": true,
                                "data-lp-delay": "120",
                                children: "Free for advisors.\xa0 Built for your whole client book. Let's show you how you can add value to your clients immediately."
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-cta-row",
                                "data-lp-reveal": true,
                                "data-lp-delay": "180",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--primary",
                                        href: $711effddec1d9025$var$KOALENDAR,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Book a 30-min call"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        className: "lp-btn lp-btn--ghost",
                                        href: "#process",
                                        children: "See how it works \u2193"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-hero-social",
                                "data-lp-reveal": true,
                                "data-lp-delay": "240",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "lp-avatars",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("hvcd1")),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("1GDu4")),
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                src: (parcelRequire("9AO8n")),
                                                alt: ""
                                            })
                                        ]
                                    }),
                                    "Join 80+ fractional CFOs already on the platform from"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-hero-logos",
                                "data-lp-reveal": true,
                                "data-lp-delay": "300",
                                children: $711effddec1d9025$var$PARTNER_LOGOS.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lp-hero-logo",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: l.src,
                                            alt: l.alt
                                        })
                                    }, l.alt))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-hero-art",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-hero-stage",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "lp-hero-photo",
                                    src: (parcelRequire("fqEzo")),
                                    alt: "Fractional CFO"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lp-hero-card lp-float",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "200",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-hero-card-top",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "t",
                                                    children: "Diligence pack"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "g",
                                                    children: "Gold \u2605"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-ring",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    width: "148",
                                                    height: "148",
                                                    viewBox: "0 0 148 148",
                                                    "aria-hidden": "true",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "74",
                                                            cy: "74",
                                                            r: "62",
                                                            fill: "none",
                                                            stroke: "#EEF1FF",
                                                            strokeWidth: "14"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "74",
                                                            cy: "74",
                                                            r: "62",
                                                            fill: "none",
                                                            stroke: "#4A67FF",
                                                            strokeWidth: "14",
                                                            strokeLinecap: "round",
                                                            strokeDasharray: "389.6",
                                                            strokeDashoffset: "155.8"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "lp-ring-c",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "p",
                                                            children: "60%"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "s",
                                                            children: "auto-filled"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "lp-hero-card-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "d"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "bar"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "l",
                                                    children: "Review"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $711effddec1d9025$export$2e2bcd8739ae039 = $711effddec1d9025$var$FractionalHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1092dd053565fc66$var$STATS = [
    {
        count: 80,
        suffix: '+',
        label: 'advisors'
    },
    {
        count: 40,
        suffix: '+',
        label: 'VCs'
    },
    {
        count: 60,
        prefix: '~',
        suffix: '%',
        label: 'AI auto-fill'
    },
    {
        count: 0,
        prefix: "\xa3",
        label: 'cost to you',
        pink: true
    }
];
const $1092dd053565fc66$var$FractionalStatBand = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-stats",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-stats-grid",
            children: $1092dd053565fc66$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    "data-lp-reveal": true,
                    "data-lp-delay": i * 80,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `lp-stat-num ${s.pink ? 'pink' : ''}`,
                            "data-count": s.count,
                            "data-prefix": s.prefix || '',
                            "data-suffix": s.suffix || '',
                            children: (s.prefix || '') + s.count + (s.suffix || '')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-stat-label",
                            children: s.label
                        })
                    ]
                }, i))
        })
    });
var $1092dd053565fc66$export$2e2bcd8739ae039 = $1092dd053565fc66$var$FractionalStatBand;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $cf7b959aeb887a45$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $cf7b959aeb887a45$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $cf7b959aeb887a45$var$CARDS = [
    {
        c: 'oklch(0.64 0.19 354)',
        t: 'Free advisor account',
        d: "Zero cost, no licence, no revenue share. Only your clients pay \u2014 and they get 20% off Pro."
    },
    {
        c: 'oklch(0.70 0.16 44)',
        t: 'Be found by new clients',
        d: 'Your AdvisorMatch profile is promoted to unaffiliated companies and 40+ VCs on the platform.'
    },
    {
        c: 'oklch(0.61 0.20 248)',
        t: 'AI makes you indispensable',
        d: 'You become the trusted conductor: structured, verified, human-reviewed evidence no generic LLM can match.'
    },
    {
        c: 'oklch(0.58 0.19 277)',
        t: 'Surface billable work',
        d: "Quarterly reviews flag gaps and upsell opportunities across your portfolio \u2013 using our 200 analyser agents."
    },
    {
        c: 'oklch(0.60 0.21 328)',
        t: 'Prove your value visibly',
        d: 'Bronze, Silver and Gold self-certification puts your impact on the dashboard every quarter.'
    },
    {
        c: 'oklch(0.63 0.17 212)',
        t: 'Start at 60%, not zero',
        d: "AI auto-populates many modules \u2013 saving you time that you then use to maximise value add."
    },
    {
        c: 'oklch(0.56 0.20 302)',
        t: 'Whole company lifecycle platform',
        d: "Hop on wherever - investment, growth, and exit \u2013 we have journeys for each stage."
    },
    {
        c: 'oklch(0.68 0.18 22)',
        t: 'Investor-grade credibility',
        d: "Hand a VC a certified Diligence Pack alongside the deck \u2014 answers to questions they hadn't asked."
    }
];
const $cf7b959aeb887a45$var$FractionHelpSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, page: page, pages: pages, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)($cf7b959aeb887a45$var$CARDS.length, {
        autoplayMs: 20000
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-section",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "lp-h2",
                                "data-lp-reveal": true,
                                children: "Why 80+ fractional CFOs are already on the platform"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-sub",
                                "data-lp-reveal": true,
                                "data-lp-delay": "80",
                                children: "Increase margins on existing services. Offer new AI-services. Increase engagement length. Introductions to new clients."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-arrows",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Previous cards",
                                onClick: prev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cf7b959aeb887a45$var$ChevronL, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Next cards",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cf7b959aeb887a45$var$ChevronR, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-track",
                        ref: trackRef,
                        children: $cf7b959aeb887a45$var$CARDS.map((card, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-vcard",
                                "data-lp-reveal": true,
                                "data-lp-delay": i % 3 * 100,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-vcard-num",
                                        style: {
                                            background: card.c
                                        },
                                        children: String(i + 1).padStart(2, '0')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: card.t
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: card.d
                                    })
                                ]
                            }, i))
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-dots",
                children: Array.from({
                    length: pages
                }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `lp-dot ${i === page ? 'is-active' : ''}`,
                        "aria-label": `Go to cards ${i + 1}`,
                        onClick: ()=>goTo(i)
                    }, i))
            })
        ]
    });
};
var $cf7b959aeb887a45$export$2e2bcd8739ae039 = $cf7b959aeb887a45$var$FractionHelpSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $20d89bc6f2e26894$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $20d89bc6f2e26894$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $20d89bc6f2e26894$var$QUOTES = [
    {
        q: 'You could walk into any assignment and start at 60% instead of zero.',
        a: 'RD, Fractional CFO'
    },
    {
        q: "Putting a deal in front of a VC, you've answered 60 questions they didn't even ask yet.",
        a: 'CL, Fractional CFO'
    },
    {
        q: "It amplifies my ability to show value \u2014 without the client even realising how much I've leveraged the platform.",
        a: 'FR, Fractional CFO'
    },
    {
        q: 'What you want is every CFO to see what I saw.',
        a: 'JH, CFO Centre'
    },
    {
        q: 'It gives me a way to upsell into clients.',
        a: 'AW, Fractional CFO'
    },
    {
        q: 'Better organised businesses do better. Better organised businesses grow faster.',
        a: 'JC, Fractional CFO'
    },
    {
        q: "Lots of small companies don't know where their documents are \u2014 they're in the MD's email or his wife's recipe folder.",
        a: 'KT, Fractional CFO'
    }
];
const $20d89bc6f2e26894$var$GLOWS = [
    {
        top: 6,
        left: '1597px',
        size: 480,
        c: 'rgba(252,119,133,0.42)'
    },
    {
        top: 254,
        left: '370px',
        size: 540,
        c: 'rgba(74,103,255,0.40)'
    },
    {
        top: 694,
        left: '-329px',
        size: 520,
        c: 'rgba(74,103,255,0.34)'
    },
    {
        top: 666,
        left: '2222px',
        size: 420,
        c: 'rgba(252,119,133,0.32)'
    }
];

const $20d89bc6f2e26894$var$FractionalCarouselSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, page: page, pages: pages, next: next, prev: prev, goTo: goTo, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)($20d89bc6f2e26894$var$QUOTES.length, {
        autoplayMs: 5500
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        id: "quotes",
        className: "lp-quotes",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-quotes-bg",
                "aria-hidden": "true",
                children: $20d89bc6f2e26894$var$GLOWS.map((g, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        style: {
                            top: g.top + 'px',
                            left: g.left,
                            width: g.size + 'px',
                            height: g.size + 'px',
                            background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`,
                            filter: 'blur(78px)'
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "lp-h2",
                        "data-lp-reveal": true,
                        children: "CFOs who use it, swear by it."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-arrows",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Previous quotes",
                                onClick: prev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($20d89bc6f2e26894$var$ChevronL, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "lp-arrow",
                                "aria-label": "Next quotes",
                                onClick: next,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($20d89bc6f2e26894$var$ChevronR, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-slide-anim",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-track",
                            ref: trackRef,
                            children: $20d89bc6f2e26894$var$QUOTES.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("figure", {
                                    className: "lp-qcard",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": i % 3 * 120,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("blockquote", {
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("figcaption", {
                                            children: item.a
                                        })
                                    ]
                                }, i))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-foot",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        "data-lp-reveal": true,
                        children: "CFOs setting AI-augmented practice standards now will set the bar for the next five years."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-dots",
                        style: {
                            margin: 0,
                            padding: 0
                        },
                        children: Array.from({
                            length: pages
                        }).map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: `lp-dot ${i === page ? 'is-active' : ''}`,
                                "aria-label": `Go to slide ${i + 1}`,
                                onClick: ()=>goTo(i)
                            }, i))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "lp-group-photo",
                    "data-lp-reveal": true,
                    src: (parcelRequire("3wIsR")),
                    alt: "Fractional CFOs"
                })
            })
        ]
    });
};
var $20d89bc6f2e26894$export$2e2bcd8739ae039 = $20d89bc6f2e26894$var$FractionalCarouselSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $4043f3a28eb8eb80$var$STEPS = [
    {
        t: 'Book a 30-min onboarding call',
        d: 'We create your free account, give you dummy data, and walk you through the platform.'
    },
    {
        t: 'Add your clients to free tier',
        d: 'You can add your clients for free, first create demonstrable value with no proprietary data, and then invite them in.'
    },
    {
        t: 'Quickly show value',
        d: "Platform design to show how it will support you in demonstrating increased value add to your clients."
    },
    {
        t: 'Find new clients',
        d: 'And then through AdvisorMatch, you are promoted to new clients looking for advisors.'
    }
];
const $4043f3a28eb8eb80$var$FractionalProcessSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "process",
        className: "lp-process",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-process-head",
                    "data-lp-reveal": true,
                    children: "How it works."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-steps",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-steps-line",
                            "aria-hidden": "true"
                        }),
                        $4043f3a28eb8eb80$var$STEPS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-step",
                                "data-lp-reveal": true,
                                "data-lp-delay": i * 100,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "n",
                                        children: i + 1
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: s.t
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: s.d
                                            })
                                        ]
                                    })
                                ]
                            }, i))
                    ]
                })
            ]
        })
    });
var $4043f3a28eb8eb80$export$2e2bcd8739ae039 = $4043f3a28eb8eb80$var$FractionalProcessSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1497eb0781275f88$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const $1497eb0781275f88$var$FractionalCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        id: "cta",
        className: "lp-cta",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-cta-card",
            "data-lp-reveal": true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-cta-glow",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-cta-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "Become indispensable."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "sub",
                            children: "Free advisor account. 30-minute call. No preparation needed."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            className: "lp-cta-btn",
                            href: $1497eb0781275f88$var$KOALENDAR,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "av",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: (parcelRequire("1GDu4")),
                                        alt: ""
                                    })
                                }),
                                "Book a call"
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $1497eb0781275f88$export$2e2bcd8739ae039 = $1497eb0781275f88$var$FractionalCtaSection;







const $d106aebef4cb508a$var$Fractional = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    (0, $282a70cc4e13b055$export$2e2bcd8739ae039)({
        canonicalPath: `${(0, $7393559700759e6c$export$aa103e2c51dcf48a)['cfo']['hubPath']}/`,
        schema: (0, $1070c78a15f5f98b$export$2e2bcd8739ae039)('cfo')
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $711effddec1d9025$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1092dd053565fc66$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf7b959aeb887a45$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20d89bc6f2e26894$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4043f3a28eb8eb80$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1497eb0781275f88$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88019eab2786a681$export$2e2bcd8739ae039), {
                icpSlug: "cfo"
            })
        ]
    });
};
var $d106aebef4cb508a$export$2e2bcd8739ae039 = $d106aebef4cb508a$var$Fractional;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");





function $38ffdb0de19d2e99$export$2e2bcd8739ae039({ handleCreateChecklist: handleCreateChecklist, isAIChecklist: isAIChecklist, setIsAIChecklist: setIsAIChecklist, checklistObj: checklistObj, setChecklistObj: setChecklistObj }) {
    let [company, setCompany] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        let id, name;
        if (location?.search) {
            id = location.search.split('=')[1].split(';')[0];
            name = location.search.split('=')[2].replaceAll('%20', ' ');
            setCompany({
                id: id,
                name: name
            });
        }
    }, []);
    const handleModuleName = (value)=>{
        setChecklistObj({
            ...checklistObj,
            moduleName: value
        });
        if (!checklistObj['genType']) setChecklistObj({
            ...checklistObj,
            genType: 'automatic'
        });
        if (!checklistObj['companies'] && Object.values(company).length > 0) {
            let companies = {
                ...checklistObj['companies'],
                [company['id']]: company['name']
            };
            checklistObj = {
                ...checklistObj,
                companies: companies
            };
            setChecklistObj(checklistObj);
        }
    };
    const handleNextStep = async ()=>{
        if (!checklistObj['moduleName']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter checklist name');
        else handleCreateChecklist();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "checklist-form-area df fww w100",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-form w50",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "w100 fw500 c15 db",
                                        for: "checkListName",
                                        children: [
                                            "Your Checklist Name ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: !checklistObj['moduleName'] ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        defaultValue: checklistObj['moduleName'] || '',
                                        onChange: (e)=>handleModuleName(e.target.value),
                                        onInput: (e)=>handleModuleName(e.target.value),
                                        onBlur: (e)=>handleModuleName(e.target.value),
                                        id: "checkListName",
                                        placeholder: "e.g. Human Resources Checklist 1.0",
                                        className: "lpins w100 br10px p1rem mt0-5rem",
                                        type: "text"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr mt1rem zi9",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "w100 fw500 c15 db op50",
                                        for: "checkListName",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "tar tooltip-box w100 db",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon pa cp",
                                                style: {
                                                    left: '35px',
                                                    bottom: '10px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    style: {
                                                        height: '13px'
                                                    },
                                                    src: (parcelRequire("24u8s")),
                                                    alt: "info"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "tooltip-area w100",
                                                style: {
                                                    bottom: "50px",
                                                    left: "65px"
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "overlay-box",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "fs0-75rem c15",
                                                        children: "Advisors and Investors can charge for checklists with prior arrangement with Diligentsia"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
                                        className: "dropdown-add-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                                                variant: "success",
                                                id: "dropdown-basic",
                                                className: "dropdown-btn cp op50 lpins br10px p1rem pr mt0-5rem",
                                                children: [
                                                    checklistObj?.['price'] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            "\xa3",
                                                            checklistObj['price']
                                                        ]
                                                    }) : 'FREE',
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "icon-right pa r0 mr1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "23",
                                                                height: "23",
                                                                viewBox: "0 0 23 23",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M11.3369 16.67C11.1615 16.671 10.9876 16.6374 10.8251 16.571C10.6627 16.5047 10.515 16.4069 10.3904 16.2834L2.39204 8.285C2.14102 8.03398 2 7.69352 2 7.33852C2 6.98352 2.14102 6.64306 2.39204 6.39204C2.64306 6.14102 2.98352 6 3.33852 6C3.69352 6 4.03398 6.14102 4.285 6.39204L11.3369 13.4573L18.3888 6.40537C18.6438 6.18698 18.9719 6.07286 19.3074 6.08582C19.6429 6.09878 19.9611 6.23786 20.1986 6.47528C20.436 6.71269 20.575 7.03094 20.588 7.36644C20.601 7.70194 20.4868 8.02998 20.2685 8.285L12.2701 16.2834C12.0218 16.5297 11.6866 16.6685 11.3369 16.67Z",
                                                                    fill: "#4A67FF"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                                                className: "dropdown-content cp shadow fww",
                                                children: [
                                                    50,
                                                    80,
                                                    100,
                                                    150
                                                ].map((price)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Item, {
                                                        onClick: ()=>setChecklistObj({
                                                                ...checklistObj,
                                                                price: price
                                                            }),
                                                        className: "tal",
                                                        children: [
                                                            "\xa3",
                                                            price,
                                                            " ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    color: '#909090',
                                                                    fontSize: '10px'
                                                                },
                                                                children: "(Plus VAT, if applicable)"
                                                            })
                                                        ]
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                        className: "c15 fs1-25rem mb0-5rem",
                                        children: "Create checklist using AI?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "manual-ai-area w100 pr fww",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "switch-area df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15",
                                                    children: "Manual"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                    name: "manualai",
                                                    className: "success w100",
                                                    checked: isAIChecklist,
                                                    onChange: (e)=>{
                                                        setIsAIChecklist(!isAIChecklist), setChecklistObj({
                                                            ...checklistObj,
                                                            genType: e.target.checked ? 'automatic' : 'manual'
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c15",
                                                    children: "AI-generated"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                disabled: !checklistObj['moduleName'],
                                onClick: ()=>handleNextStep(),
                                className: `shadow c1 mt2rem fw400 fs1rem pr br38px w200px h3rem df aic jcc ${!checklistObj['moduleName'] ? ' bg16 cna' : ' bg4 bg3-hover cp'}`,
                                children: [
                                    "Ok, next",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon pr ml0-5rem",
                                        style: {
                                            top: '3px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "30",
                                            height: "30",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "selection-area-right w50 pl5rem bsbb",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "manual-ai-area w100 pr fww",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100 df jce",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("aX9EE")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "tip-box w100 p2rem bg20 w100",
                                    style: {
                                        marginTop: '-6px',
                                        borderRadius: '40px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                            className: "c15 fs0-75rem df aic mb1rem",
                                            style: {
                                                fontSize: '14px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "icon mr1rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "db w2rem",
                                                        src: (parcelRequire("iBc1P")),
                                                        alt: ""
                                                    })
                                                }),
                                                "Top Tip"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs0-75rem",
                                            style: {
                                                fontSize: '12px',
                                                color: '#15131380'
                                            },
                                            children: [
                                                "It is worth you considering the shape and purpose of your checklist at the outset. Who is it for?  What is its purpose? How long do you will the user prepared to spend on it?  This will help you choose the variables to deliver your objective.  Variables you select later will include:\u200B",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            "Checklist length \u2013 20/50/100 questions",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                children: "Along with automatic recommendations, do you want the user to have their answers risk-scored?\u200B"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                children: "Is the checklist to be issued to be used internally or for completion by external parties?"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                children: "If you are an advisor or investor, do you want the checklist to be made to a single company or made available on all your client/investor dashboards?\u200B"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                                children: "Do you want to restrict access to it?\u200B"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bottom-btn-area df aic w100 jcsb mt3rem bsbb",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "c15 fs1rem",
                    style: {
                        color: '#15131350'
                    },
                    children: [
                        "1/6 Checklist Setup ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "fs0-75rem",
                            children: "( * = fields requiring mandatory completion)"
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");





var $acw62 = parcelRequire("acw62");









function $ebf8e58e77ef0c20$export$2e2bcd8739ae039({ allCompaines: allCompaines, checklistObj: checklistObj, setChecklistObj: setChecklistObj, handleCreateChecklist: handleCreateChecklist }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const cropper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef(null);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [company, setCompany] = (0, $acw62.useState)();
    let [loading, setLoading] = (0, $acw62.useState)(false);
    let [logoType, setLogoType] = (0, $acw62.useState)('');
    let [uploadLogo, setUploadLogo] = (0, $acw62.useState)("");
    let [accordion, setAccordion] = (0, $acw62.useState)('logo');
    let [isDisabled, setIsDisabled] = (0, $acw62.useState)(false);
    let diligentsiaLogo = "https://checklist-icons.s3.us-east-2.amazonaws.com/checklist-logo.png";
    (0, $acw62.useEffect)(()=>{
        let companyId;
        if (location?.search) companyId = location.search.split('=')[1].split(';')[0];
        if (allCompaines.length > 0 && companyId) allCompaines.filter((company)=>{
            if (company['_id'] == companyId) {
                // Advisors/Investors creating a checklist for a client company should default to their OWN firm logo, not the client's.
                const isCreatingForClient = [
                    'advisor',
                    'investor'
                ].includes(user?.['role']?.toLowerCase()) && user?.['companyId']?.['_id'] && user['companyId']['_id'] != companyId;
                const existingLogo = isCreatingForClient ? user?.['companyId']?.['logo'] || company?.['logo'] : company?.['logo'];
                if (checklistObj?.['imageURL'] == diligentsiaLogo && existingLogo) setChecklistObj({
                    ...checklistObj,
                    imageURL: existingLogo
                });
                setLogoType('existing');
                setCompany(company);
            }
        });
        if (!checklistObj?.['memberPermissions']) setChecklistObj({
            ...checklistObj,
            memberPermissions: {}
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (checklistObj?.['companyMembers'] && checklistObj?.['companyMembers'].length > 0) {
            if (Object.keys(checklistObj['memberPermissions']) == 0) setIsDisabled(true);
            else setIsDisabled(false);
        }
    }, [
        checklistObj
    ]);
    const handleExistingLogo = (logo)=>{
        if (uploadLogo) {
            delete checklistObj['attachment'];
            setChecklistObj(checklistObj);
            setUploadLogo("");
        }
        setChecklistObj({
            ...checklistObj,
            imageURL: logo
        });
        setLogoType('existing');
    };
    const handleAlternativeLogo = ()=>{
        if (uploadLogo == "") dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: "uploadChecklistLogo"
        }));
        else setLogoType('upload');
    };
    const handleChecklistLogo = async (e)=>{
        let logo = e.target.files[0];
        if (logo && logo.size > 5242880) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Photo Size must be less than 5MB");
        logo = await URL.createObjectURL(logo);
        setUploadLogo(logo);
    };
    const updateLogo = async ()=>{
        let attachment = [];
        if (cropper.current && uploadLogo) {
            setLoading(true);
            let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([
                blob
            ], "checklist logo", {
                type: "image/png"
            });
            let imageURL = await URL.createObjectURL(coverFile);
            setUploadLogo(imageURL);
            attachment.push(coverFile);
            setChecklistObj({
                ...checklistObj,
                attachment: attachment
            });
            setLogoType('upload');
            setLoading(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please upload image first");
    };
    const crossUploadImage = ()=>{
        delete checklistObj['attachment'];
        setChecklistObj(checklistObj);
        setUploadLogo("");
        setLogoType('existing');
    };
    const selectMember = async (member)=>{
        if (checklistObj?.['memberPermissions'] && checklistObj?.['memberPermissions']?.[member['_id']]?.['company']?.['memberPermissions']?.[member['_id']]?.[checklistObj['moduleKey']] == true) {
            delete checklistObj['memberPermissions'][member['_id']];
            setChecklistObj(checklistObj);
        } else {
            let memberPermissions = {
                ...checklistObj['memberPermissions'],
                [member['_id']]: member
            };
            setChecklistObj({
                ...checklistObj,
                memberPermissions: memberPermissions
            });
        }
    };
    const selectAdvisor = async (member)=>{
        if (checklistObj?.['advisorPermissions'] && checklistObj?.['advisorPermissions']?.[member['_id']]?.['company']?.['advisorPermissions']?.[member['_id']]?.['modules'][checklistObj['moduleKey']] == true) {
            delete checklistObj['advisorPermissions'][member['_id']];
            setChecklistObj(checklistObj);
        } else {
            let advisorPermissions = {
                ...checklistObj['advisorPermissions'],
                [member['_id']]: member
            };
            setChecklistObj({
                ...checklistObj,
                advisorPermissions: advisorPermissions
            });
        }
    };
    const selectInvestor = async (member)=>{
        console.log(checklistObj?.['investorPermissions'] && checklistObj?.['investorPermissions']?.[member['_id']]?.['company']?.['investors']?.[member['_id']], '--- IGNORE ---');
        if (checklistObj?.['investorPermissions'] && checklistObj?.['investorPermissions']?.[member['_id']]?.['company']?.['investors']?.[member['_id']]?.['modules']?.[checklistObj['moduleKey']] == true) {
            console.log("removing investor--- IGNORE ---");
            delete checklistObj['investorPermissions'][member['_id']];
            setChecklistObj(checklistObj);
        } else {
            console.log("adding investor--- IGNORE ---");
            let investorPermissions = {
                ...checklistObj['investorPermissions'],
                [member['_id']]: member
            };
            setChecklistObj({
                ...checklistObj,
                investorPermissions: investorPermissions
            });
        }
    };
    const handleNextStep = async ()=>{
        if (!checklistObj['imageURL']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select checklist logo');
        else handleCreateChecklist();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "checklist-form-area df fww w100",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "checklist-form w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: accordion == 'logo',
                            onChange: ()=>setAccordion('logo'),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: "1. Logo upload"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc jcsb",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "description-box df fww",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "left-box w60",
                                                    children: [
                                                        checklistObj?.['imageURL'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "cp pr mb1rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            type: "radio",
                                                                            className: "cp pr",
                                                                            id: "checklist-logo-current",
                                                                            name: "checklist-logo-current",
                                                                            checked: logoType == 'existing',
                                                                            style: {
                                                                                height: '19px',
                                                                                width: '19px',
                                                                                top: '4px'
                                                                            },
                                                                            onClick: ()=>handleExistingLogo(checklistObj?.['imageURL'])
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                            className: "fw400 fs1-125rem ml1rem c15",
                                                                            for: "checklist-logo-current",
                                                                            style: {
                                                                                lineHeight: '22.39px'
                                                                            },
                                                                            children: "Use existing logo"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "pr db ml2rem mb1rem",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        className: "new-shadow db w100px bo20 bw1px bss br15px p0-5rem",
                                                                        src: checklistObj?.['imageURL'],
                                                                        alt: ""
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "cp pr mb1rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "radio",
                                                                    className: "cp pr",
                                                                    id: "checklist-logo-upload",
                                                                    name: "checklist-logo-upload",
                                                                    checked: logoType == 'upload',
                                                                    style: {
                                                                        height: '19px',
                                                                        width: '19px',
                                                                        top: '4px'
                                                                    },
                                                                    onClick: ()=>handleAlternativeLogo()
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    className: "fw400 fs1-125rem ml1rem c15",
                                                                    for: "checklist-logo-upload",
                                                                    style: {
                                                                        lineHeight: '22.39px'
                                                                    },
                                                                    children: "Upload alternative checklist logo\u200B\u200B"
                                                                })
                                                            ]
                                                        }),
                                                        Object.keys(uploadLogo).length > 0 && logoType == 'upload' && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                            className: "pr db ml2rem mb1rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                    className: "new-shadow db w100px bo20 bw1px bss br15px",
                                                                    src: uploadLogo,
                                                                    alt: ""
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "fa fa-times-circle pl1rem cp pa c4",
                                                                    style: {
                                                                        top: '-5px',
                                                                        fontSize: '18px',
                                                                        left: '75px'
                                                                    },
                                                                    onClick: ()=>crossUploadImage()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                            onClick: ()=>{
                                                                setUploadLogo("");
                                                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: "uploadChecklistLogo"
                                                                }));
                                                            },
                                                            className: "cp ml1rem bsbb df jcc aic fw500 py0-5rem px2rem c1 bg3 bg4-hover br10px",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    className: "icon pr mr0-5rem",
                                                                    style: {
                                                                        top: '4px'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "20",
                                                                        height: "20",
                                                                        viewBox: "0 0 20 20",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M17.6087 4.78261H15.5217L14.3696 3.04348C13.9348 2.3913 13.1739 2 12.3913 2H7.6087C6.82609 2 6.06522 2.3913 5.63043 3.04348L4.47826 4.78261H2.3913C1.06522 4.78261 0 5.84783 0 7.17391V15.6087C0 16.9348 1.06522 18 2.3913 18H17.6087C18.9348 18 20 16.9348 20 15.6087V7.17391C20 5.84783 18.9348 4.78261 17.6087 4.78261ZM10 16.0435C7.02174 16.0435 4.6087 13.6304 4.6087 10.6522C4.6087 7.67391 7.02174 5.28261 10 5.28261C12.9783 5.28261 15.3913 7.69565 15.3913 10.6739C15.3913 13.6304 12.9783 16.0435 10 16.0435ZM17.3043 8.15217C17.2826 8.15217 17.2609 8.15217 17.2174 8.15217H16.3478C15.9565 8.13043 15.6522 7.80435 15.6739 7.41304C15.6957 7.04348 15.9783 6.76087 16.3478 6.73913H17.2174C17.6087 6.71739 17.9348 7.02174 17.9565 7.41304C17.9783 7.80435 17.6957 8.13043 17.3043 8.15217Z",
                                                                                fill: "white"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M10 7.67578C8.34783 7.67578 7 9.02361 7 10.6758C7 12.328 8.34783 13.654 10 13.654C11.6522 13.654 13 12.3062 13 10.654C13 9.00187 11.6522 7.67578 10 7.67578Z",
                                                                                fill: "white"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                "Upload"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "fs0-75rem db ml2rem",
                                                            children: "Max file size 5MB"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "right-box w40 bsbb pr1rem pl4rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "tip-box w100 p2rem bg20 w100 bsbb",
                                                        style: {
                                                            marginTop: '-6px',
                                                            borderRadius: '40px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                                className: "c15 fs0-75rem df aic mb1rem",
                                                                style: {
                                                                    fontSize: '14px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "icon mr1rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "db w2rem",
                                                                            src: (parcelRequire("iBc1P")),
                                                                            alt: ""
                                                                        })
                                                                    }),
                                                                    "Example"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "db mt1rem w100",
                                                                src: (parcelRequire("dF0gl")),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "c15 fs0-75rem",
                                                                style: {
                                                                    fontSize: '12px',
                                                                    color: '#15131380'
                                                                },
                                                                children: "Logo will appear on the face of the checklist."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        checklistObj?.['companyMembers'] && checklistObj?.['companyMembers'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: accordion == 'permissions',
                            onChange: ()=>setAccordion('permissions'),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: [
                                            "2. Checklist access permission ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: isDisabled ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc jcsb",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "description-box df fww mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                    className: "fw400 c15 fs1rem w100",
                                                    children: "Choose team members you want to grant access to"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "left-box w70",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr mt1rem",
                                                        children: [
                                                            checklistObj['companyMembers'].filter((member)=>checklistObj['createdBy']?.['role'] && checklistObj['createdBy']?.['role'].toLowerCase() === "advisor" && checklistObj['category'] === 'internal' ? member['role'].toLowerCase() !== "user" : member).map((member, ind)=>{
                                                                const isAdmin = member['role'] && member['role'].toLowerCase() === "user" && company && company['creatorId'] && company['creatorId']['_id'] === member['_id'];
                                                                const isCreator = checklistObj['createdBy']['_id'] === member['_id'];
                                                                const bgColor = member['role'] && member['role'].toLowerCase() === "user" || company && company.creatorId && company.creatorId.role.toLowerCase() === "user" && member['role'] && member['role'].toLowerCase() === "member" ? "bg3" : member['role'] && member['role'].toLowerCase() === "investor" ? "bg7" : "bg8";
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    for: member['_id'],
                                                                    className: `py0-5rem df cp ${!isAdmin && "ml1rem"}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "checkbox w2rem h2rem pr",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                defaultChecked: isCreator || checklistObj?.['memberPermissions']?.[member['_id']]?.['company']?.['memberPermissions']?.[member['_id']]?.[checklistObj['moduleKey']],
                                                                                id: member['_id'],
                                                                                disabled: isCreator || isAdmin,
                                                                                onChange: ()=>selectMember(member),
                                                                                className: `new-shadow bg1 bo5 bw2px bss cp td250 w2rem h2rem br8px greenTick`,
                                                                                type: "checkbox"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: `w250px fs1rem lh3 ml1rem usn df aic bo5 bw2px bss px1rem py0-5rem br8px ${bgColor}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                    className: "user-img mr1rem pr",
                                                                                    style: {
                                                                                        top: '4px'
                                                                                    },
                                                                                    children: member?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                        className: "w2rem h2rem br100 bo5 bw2px bss c1",
                                                                                        src: member['profile'],
                                                                                        alt: ""
                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "w30px h30px df jcc aic br100 bg16 p0-5rem new-shadow c1",
                                                                                        children: member?.['firstName'] ? member?.['firstName']?.[0] + (member?.['lastName'] ? member?.['lastName']?.[0] : "") : "?"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "text-box",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                                                            className: "fs0-75rem c1",
                                                                                            children: member?.['firstName'] ? member?.['firstName'] + " " + (member?.['lastName'] ? member?.['lastName'] : "") : "?"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                                                            className: "fs0-75rem db c1",
                                                                                            style: {
                                                                                                marginTop: '-3px'
                                                                                            },
                                                                                            children: [
                                                                                                member['designation'] || member['title'],
                                                                                                " - ",
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                    className: "fs0-5rem c1",
                                                                                                    children: member['company']['cName']
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                });
                                                            }),
                                                            checklistObj['createdBy']?.['role'] && checklistObj['createdBy']?.['role'].toLowerCase() === "advisor" && checklistObj['category'] === 'external' || checklistObj['createdBy']?.['role'] && (checklistObj['createdBy']?.['role'].toLowerCase() === "user" || checklistObj['createdBy']?.['role'].toLowerCase() === "member") && checklistObj['category'] === 'external' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                children: [
                                                                    checklistObj['companyAdvisors'].map((advisor, ind)=>{
                                                                        const isAdmin = advisor['role'] && advisor['role'].toLowerCase() === "advisor" && checklistObj['createdBy']['_id'] === advisor['_id'];
                                                                        const bgColor = advisor['role'] && advisor['role'].toLowerCase() === "user" || company && company.creatorId && company.creatorId.role.toLowerCase() === "user" && advisor['role'] && advisor['role'].toLowerCase() === "member" ? "bg3" : advisor['role'] && advisor['role'].toLowerCase() === "investor" ? "bg7" : "bg8";
                                                                        const isCreator = checklistObj['createdBy']['_id'] === advisor['_id'];
                                                                        if (checklistObj['companyMembers'].some((member)=>member['_id'] === advisor['_id'])) return null;
                                                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            for: advisor['_id'],
                                                                            className: `py0-5rem df cp ${!isAdmin && "ml1rem"}`,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "checkbox w2rem h2rem pr",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                        defaultChecked: isAdmin || checklistObj?.['advisorPermissions']?.[advisor['_id']]?.['company']?.['advisors']?.[advisor['_id']]?.['modules'][checklistObj['moduleKey']],
                                                                                        id: advisor['_id'],
                                                                                        disabled: isAdmin,
                                                                                        onChange: ()=>selectAdvisor(advisor),
                                                                                        className: `new-shadow bg1 bo5 bw2px bss cp td250 w2rem h2rem br8px ${isCreator && "greenTick"}`,
                                                                                        type: "checkbox"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                    className: `w250px fs1rem lh3 ml1rem usn df aic bo5 bw2px bss px1rem py0-5rem br8px ${bgColor}`,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                            className: "user-img mr1rem pr",
                                                                                            style: {
                                                                                                top: '4px'
                                                                                            },
                                                                                            children: advisor?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                className: "w2rem h2rem br100 bo5 bw2px bss c1",
                                                                                                src: advisor['profile'],
                                                                                                alt: ""
                                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "w30px h30px df jcc aic br100 bg16 p0-5rem new-shadow c1",
                                                                                                children: advisor?.['firstName'] ? advisor?.['firstName']?.[0] + (advisor?.['lastName'] ? advisor?.['lastName']?.[0] : "") : "?"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                            className: "text-box",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                                                                    className: "fs0-75rem c1",
                                                                                                    children: advisor?.['firstName'] ? advisor?.['firstName'] + " " + (advisor?.['lastName'] ? advisor?.['lastName'] : "") : "?"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                                                                    className: "fs0-75rem db c1",
                                                                                                    style: {
                                                                                                        marginTop: '-3px'
                                                                                                    },
                                                                                                    children: [
                                                                                                        advisor['designation'] || advisor['title'],
                                                                                                        " - ",
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                            className: "fs0-5rem c1",
                                                                                                            children: advisor['company']['cName']
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        });
                                                                    }),
                                                                    checklistObj['createdBy']?.['role'] && checklistObj['createdBy']?.['role'].toLowerCase() === "investor" && checklistObj['category'] === 'external' || checklistObj['createdBy']?.['role'] && (checklistObj['createdBy']?.['role'].toLowerCase() === "user" || checklistObj['createdBy']?.['role'].toLowerCase() === "member") && checklistObj['category'] === 'external' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                        children: checklistObj['companyInvestors'].filter((inv)=>inv['role'] && inv['role'].toLowerCase() === "investor").map((investor)=>{
                                                                            const isAdmin = investor['role'] && investor['role'].toLowerCase() === "user" && checklistObj['createdBy']['_id'] === investor['_id'];
                                                                            const bgColor = investor['role'] && investor['role'].toLowerCase() === "user" || company && company.creatorId && company.creatorId.role.toLowerCase() === "user" && investor['role'] && investor['role'].toLowerCase() === "member" ? "bg3" : investor['role'] && investor['role'].toLowerCase() === "investor" ? "bg7" : "bg8";
                                                                            const isCreator = checklistObj['createdBy']['_id'] === investor['_id'];
                                                                            if (checklistObj['companyMembers'].some((member)=>member['id'] === investor['_id'])) return null;
                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                for: investor['_id'],
                                                                                className: `py0-5rem df cp ${!isAdmin && "ml1rem"}`,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "checkbox w2rem h2rem pr",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                            defaultChecked: checklistObj?.['investorPermissions']?.[investor['_id']]?.['company']?.['investors']?.[investor['_id']]?.['modules' || {}][checklistObj['moduleKey']],
                                                                                            id: investor['_id'],
                                                                                            disabled: isAdmin,
                                                                                            onChange: ()=>selectInvestor(investor),
                                                                                            className: `new-shadow bg1 bo5 bw2px bss cp td250 w2rem h2rem br8px ${isCreator && "greenTick"}`,
                                                                                            type: "checkbox"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: `w250px fs1rem lh3 ml1rem usn df aic bo5 bw2px bss px1rem py0-5rem br8px ${bgColor}`,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                className: "user-img mr1rem pr",
                                                                                                style: {
                                                                                                    top: '4px'
                                                                                                },
                                                                                                children: investor?.['profile'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                                    className: "w2rem h2rem br100 bo5 bw2px bss c1",
                                                                                                    src: investor['profile'],
                                                                                                    alt: ""
                                                                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                    className: "w30px h30px df jcc aic br100 bg16 p0-5rem new-shadow c1",
                                                                                                    children: investor?.['firstName'] ? investor?.['firstName']?.[0] + (investor?.['lastName'] ? investor?.['lastName']?.[0] : "") : "?"
                                                                                                })
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                                className: "text-box",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                                                                        className: "fs0-75rem c1",
                                                                                                        children: investor?.['firstName'] ? investor?.['firstName'] + " " + (investor?.['lastName'] ? investor?.['lastName'] : "") : "?"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                                                                                        className: "fs0-75rem db c1",
                                                                                                        style: {
                                                                                                            marginTop: '-3px'
                                                                                                        },
                                                                                                        children: [
                                                                                                            investor['designation'] || investor['title'],
                                                                                                            " - ",
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                                className: "fs0-5rem c1",
                                                                                                                children: investor['company']['cName']
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            });
                                                                        })
                                                                    }) : null
                                                                ]
                                                            }) : null
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "right-box w30 bsbb pr1rem pl4rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "tip-box w100 p2rem bg20 w100 bsbb",
                                                        style: {
                                                            marginTop: '-6px',
                                                            borderRadius: '40px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                                className: "c15 fs0-75rem df aic mb1rem",
                                                                style: {
                                                                    fontSize: '14px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "icon mr1rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "db w2rem",
                                                                            src: (parcelRequire("iBc1P")),
                                                                            alt: ""
                                                                        })
                                                                    }),
                                                                    "Top Tip"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "c15 fs0-75rem",
                                                                style: {
                                                                    fontSize: '12px',
                                                                    color: '#15131380'
                                                                },
                                                                children: [
                                                                    "You can allocate access permissions\u200B to your colleagues in the \u200Bcompany/companies you have selected to\u200B receive this checklist\u200B.",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    "You can also later amend these permissions from your dashboard."
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bottom-btn-area df aic w100 jcsb mt2rem bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 fs1rem",
                        style: {
                            color: '#15131350'
                        },
                        children: [
                            "5/6 Logo Upload & Permissions ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem",
                                children: "( * = fields requiring mandatory completion)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        disabled: isDisabled,
                        onClick: ()=>handleNextStep(),
                        className: `shadow c1 cp fw400 fs1rem pr br38px w200px h3rem df aic jcc ${isDisabled ? ' bg16 cna' : ' bg4 bg3-hover cp'}`,
                        children: [
                            "Ok, next",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon pr ml0-5rem",
                                style: {
                                    top: '3px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "uploadChecklistLogo",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>{
                                setUploadLogo("");
                                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ""
                                }));
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: "Upload Profile Picture"
                        }),
                        uploadLogo == "" ? /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            for: "profile",
                            className: "w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pen fs1rem fw500 tac",
                                    children: "Upload picture"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        className: "",
                                        onChange: (e)=>handleChecklistLogo(e),
                                        id: "profile",
                                        type: "file",
                                        accept: "image/jpeg, image/jpg, image/png"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "Max file size 5MB"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "img-box pr",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cf7e14040ecbb1be$exports))), {
                                style: {
                                    maxHeight: "500px"
                                },
                                ref: cropper,
                                guides: false,
                                aspectRatio: 1,
                                className: "cropper-settings",
                                src: uploadLogo
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        setUploadLogo("");
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ""
                                        }));
                                    },
                                    className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>{
                                        if (!loading) updateLogo();
                                    },
                                    className: `shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem ${loading && "button-disabled"}`,
                                    children: Object.keys(uploadLogo).length == 0 ? "Upload" : "Crop & Upload"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


function $7fbcbe771bda0ade$export$2e2bcd8739ae039({ handleCreateChecklist: handleCreateChecklist, isAIChecklist: isAIChecklist, checklistObj: checklistObj, setChecklistObj: setChecklistObj }) {
    let [isDisabled, setIsDisabled] = (0, $acw62.useState)(true);
    let [sections, setSections] = (0, $acw62.useState)([
        '',
        '',
        ''
    ]);
    (0, $acw62.useEffect)(()=>{
        if (checklistObj?.['sections'] && checklistObj?.['sections'].length > 0) setSections(checklistObj['sections']);
    }, []);
    (0, $acw62.useEffect)(()=>{
        for(let i = 0; i < sections.length + 1; i++)if (sections[i] == "") setIsDisabled(true);
        else setIsDisabled(false);
    }, [
        sections
    ]);
    const handleSectionName = async (value, idx)=>{
        let array = [
            ...sections
        ];
        array[idx] = value;
        await setSections(array);
        setChecklistObj({
            ...checklistObj,
            sections: array
        });
    };
    const deleteSection = async (idx)=>{
        let newArray = [
            ...sections
        ];
        newArray.splice(idx, 1);
        setSections(newArray);
    };
    const addSection = async ()=>{
        if (sections.length >= 10) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('You can add maximum 10 sections!');
        setSections([
            ...sections,
            ''
        ]);
    };
    const handleNextStep = async ()=>{
        for(let i = 0; i < sections.length + 1; i++)if (sections[i] == "") return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(`Please Enter Section ${i + 1} Name!`);
        handleCreateChecklist(sections);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "checklist-form-area df fww w100",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "checklist-form w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: sections.map((item, idx)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic w100 mb0-5rem pr",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "pa ml1rem c15",
                                            children: [
                                                "Section ",
                                                idx + 1
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            value: item,
                                            name: `section-${idx}`,
                                            placeholder: "Add your section heading here",
                                            className: "pl6rem bss bw2px bo5 w100 br25px p1rem",
                                            onChange: (e)=>handleSectionName(e.target.value, idx)
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-trash pr2rem pa r0 c4 cp",
                                            style: {
                                                "cursor": "pointer"
                                            },
                                            onClick: ()=>deleteSection(idx)
                                        })
                                    ]
                                });
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>addSection(),
                            className: "df aic w100 mb0-5rem pr cp bss bw2px bo5 w100 br25px p1rem bsbb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pa ml0-5rem c15 w2rem h2rem br100 bg3 cp tac lh2",
                                    style: {
                                        lineHeight: '40px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M18.3098 11.5825H11.5805V18.3118C11.5805 19.1859 10.8714 19.895 9.9973 19.895C9.1232 19.895 8.41406 19.1859 8.41406 18.3118V11.5825H1.6848C0.810699 11.5825 0.101562 10.8734 0.101562 9.99925C0.101562 9.12515 0.810699 8.41602 1.6848 8.41602H8.41406V1.68675C8.41406 0.812653 9.1232 0.103516 9.9973 0.103516C10.8714 0.103516 11.5805 0.812653 11.5805 1.68675V8.41602H18.3098C19.1839 8.41602 19.893 9.12515 19.893 9.99925C19.893 10.8734 19.1839 11.5825 18.3098 11.5825Z",
                                            fill: "#FAFAFA"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pr c15 ml3rem",
                                    children: "Add Section"
                                })
                            ]
                        }),
                        isAIChecklist && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "ai-logo pa",
                            style: {
                                transform: 'translate(-50%, -50%)',
                                left: '50%',
                                top: '50%'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "533",
                                height: "444",
                                viewBox: "0 0 533 444",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        opacity: "0.08",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M391.899 421.101L236.964 14.9119C235.29 10.5257 232.308 6.74937 228.416 4.0855C224.524 1.42164 219.906 -0.00336658 215.178 5.97253e-06H177.592C172.858 -0.00310047 168.236 1.42396 164.34 4.09129C160.445 6.75862 157.461 10.5397 155.786 14.9309L1.09927 421.101C0.124901 423.661 -0.208861 426.418 0.126531 429.134C0.461923 431.851 1.45641 434.446 3.02489 436.697C4.59337 438.948 6.68911 440.789 9.13215 442.061C11.5752 443.333 14.2926 443.998 17.0518 444H56.6848C61.5226 444.001 66.2403 442.507 70.1826 439.726C74.1248 436.944 77.0956 433.014 78.6817 428.481L104.083 356.122C104.083 355.951 104.217 355.781 104.294 355.591L141.861 248.646C141.861 248.323 142.052 248.001 142.167 247.679L155.556 209.735L174.282 156.613C181.551 135.972 210.989 135.972 218.276 156.613L236.983 209.735L309.306 415.238L314.011 428.519C315.608 433.037 318.58 436.951 322.518 439.721C326.455 442.491 331.162 443.979 335.989 443.981H375.947C378.705 443.983 381.423 443.32 383.866 442.05C386.31 440.781 388.406 438.942 389.975 436.692C391.543 434.441 392.538 431.847 392.874 429.131C393.209 426.416 392.875 423.66 391.899 421.101Z",
                                                fill: "url(#paint0_linear_4294_615)"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M517.315 444H471.685C467.525 444 463.536 442.351 460.594 439.416C457.653 436.48 456 432.499 456 428.348V15.6329C456.005 11.485 457.66 7.50882 460.601 4.57764C463.542 1.64645 467.529 8.46447e-06 471.685 1.15116e-05H517.315C519.374 -0.00248186 521.413 0.40009 523.316 1.1846C525.219 1.96911 526.948 3.12018 528.405 4.57208C529.862 6.02397 531.017 7.7481 531.806 9.646C532.594 11.5439 533 13.5783 533 15.6329V428.348C533 430.404 532.594 432.439 531.806 434.338C531.018 436.237 529.863 437.962 528.406 439.416C526.95 440.869 525.22 442.022 523.317 442.808C521.414 443.595 519.375 444 517.315 444Z",
                                                fill: "url(#paint1_linear_4294_615)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint0_linear_4294_615",
                                                x1: "-1118.55",
                                                y1: "-1003.86",
                                                x2: "1638.13",
                                                y2: "1775.47",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#00EEEF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#AF00D4"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                id: "paint1_linear_4294_615",
                                                x1: "-921.502",
                                                y1: "-1191",
                                                x2: "1835.26",
                                                y2: "1571.66",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        "stop-color": "#00EEEF"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#AF00D4"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bottom-btn-area df aic w100 jcsb mt2rem bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs1rem",
                        style: {
                            color: '#15131350'
                        },
                        children: "3/6 Section Creation"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        disabled: isDisabled,
                        onClick: ()=>handleNextStep(),
                        className: `shadow c1 cp fw400 fs1rem pr br38px w200px h3rem df aic jcc ${isDisabled ? ' bg16 cna' : ' bg4 bg3-hover cp'}`,
                        children: [
                            "Ok, next",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon pr ml0-5rem",
                                style: {
                                    top: '3px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");










function $274b48a63e25e3eb$export$2e2bcd8739ae039({ handleCreateChecklist: handleCreateChecklist, checklistObj: checklistObj, sections: sections }) {
    const svg = {
        'question': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "26",
            height: "26",
            viewBox: "0 0 26 26",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M9.65515 3.27344H16.4278C20.2366 3.27344 23.3242 6.36109 23.3242 10.1699V13.5562C23.3242 15.5649 22.4647 17.3726 21.0942 18.633V22.2411C21.0942 22.9156 20.2787 23.2534 19.8018 22.7765L17.4074 20.3821C17.0873 20.4277 16.7604 20.4526 16.4277 20.4526H9.65506C5.84625 20.4526 2.7586 17.365 2.7586 13.5562V10.1699C2.75869 6.36109 5.84635 3.27344 9.65515 3.27344Z",
                    fill: "url(#paint0_linear_4328_472)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M9.65515 3.27344H16.4278C20.2366 3.27344 23.3242 6.36109 23.3242 10.1699V13.5562C23.3242 15.5649 22.4647 17.3726 21.0942 18.633V22.2411C21.0942 22.9156 20.2787 23.2534 19.8018 22.7765L17.4074 20.3821C17.0873 20.4277 16.7604 20.4526 16.4277 20.4526H9.65506C5.84625 20.4526 2.7586 17.365 2.7586 13.5562V10.1699C2.75869 6.36109 5.84635 3.27344 9.65515 3.27344Z",
                    fill: "url(#paint1_linear_4328_472)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M12.6264 14.1054H13.4622C14.1929 14.1054 14.7852 13.513 14.7852 12.7824V8.99877C14.7852 8.26806 14.1928 7.67578 13.4622 7.67578H12.6264C11.8957 7.67578 11.3035 8.26815 11.3035 8.99877V12.7824C11.3035 13.513 11.8957 14.1054 12.6264 14.1054Z",
                    fill: "url(#paint2_linear_4328_472)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M2.97206 15.2689L10.8972 7.34375V12.437C10.8972 13.5823 11.8234 14.5119 12.9686 14.516L15.1836 14.524L9.26593 20.4416C6.2208 20.2726 3.70277 18.1287 2.97206 15.2689Z",
                    fill: "url(#paint3_linear_4328_472)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M13.6115 15.8823V15.2021C14.9486 15.038 15.9219 14.2521 15.9219 12.4694V9.36164C15.9219 7.33263 14.667 6.59375 13.0485 6.59375C11.43 6.59375 10.1635 7.33263 10.1635 9.36164V12.4694C10.1635 14.2521 11.1487 15.0379 12.4856 15.2021V15.8823C12.4856 16.2576 12.767 16.4454 13.0484 16.4454C13.3298 16.4454 13.6115 16.2576 13.6115 15.8823ZM11.9931 9.36164C11.9931 8.56417 12.3918 8.18888 13.0486 8.18888C13.7054 8.18888 14.0924 8.56417 14.0924 9.36164V12.4694C14.0924 13.009 13.9282 13.349 13.6116 13.525V13.0089C13.6116 12.6219 13.3301 12.4577 13.0486 12.4577C12.7671 12.4577 12.4858 12.6219 12.4858 13.0089V13.525C12.1808 13.349 11.9932 13.0089 11.9932 12.4694V9.36164H11.9931Z",
                    fill: "url(#paint4_linear_4328_472)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M10.7079 13.6797L17.4102 20.3819C17.0899 20.4275 16.7631 20.4523 16.4302 20.4523H9.65764C5.89033 20.4523 2.83062 17.4311 2.76424 13.6797H10.7079Z",
                    fill: "url(#paint5_linear_4328_472)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint0_linear_4328_472",
                            x1: "19.7395",
                            y1: "7.12208",
                            x2: "10.7318",
                            y2: "16.1298",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#62DBFB"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1912",
                                    "stop-color": "#57D5FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5232",
                                    "stop-color": "#3BC5F7"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.954",
                                    "stop-color": "#0DABF2"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#08A9F1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint1_linear_4328_472",
                            x1: "19.7395",
                            y1: "7.12208",
                            x2: "10.7318",
                            y2: "16.1298",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#62DBFB"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1912",
                                    "stop-color": "#57D5FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5232",
                                    "stop-color": "#3BC5F7"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.954",
                                    "stop-color": "#0DABF2"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#08A9F1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint2_linear_4328_472",
                            x1: "11.9848",
                            y1: "11.1625",
                            x2: "14.6077",
                            y2: "10.4894",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#0593FC",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.6831",
                                    "stop-color": "#0389FC",
                                    "stop-opacity": "0.683"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0182FC"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint3_linear_4328_472",
                            x1: "5.65592",
                            y1: "16.068",
                            x2: "13.873",
                            y2: "12.0291",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#0593FC",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.6831",
                                    "stop-color": "#0389FC",
                                    "stop-opacity": "0.683"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0182FC"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint4_linear_4328_472",
                            x1: "17.9313",
                            y1: "6.04214",
                            x2: "10.5819",
                            y2: "13.3915",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EAF9FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#B3DAFE"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint5_linear_4328_472",
                            x1: "10.0873",
                            y1: "17.6442",
                            x2: "10.0873",
                            y2: "21.0327",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#0593FC",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.6831",
                                    "stop-color": "#0389FC",
                                    "stop-opacity": "0.683"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0182FC"
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        'risk': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "26",
            height: "26",
            viewBox: "0 0 26 26",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M20.0826 22.9981H5.91517C3.74799 22.9981 2.33844 20.7174 3.30763 18.7791L10.3913 4.61155C11.4657 2.46282 14.532 2.46282 15.6064 4.61155L22.6901 18.779C23.6594 20.7174 22.2498 22.9981 20.0826 22.9981Z",
                    fill: "url(#paint0_linear_4328_484)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M20.0826 22.9981H5.91517C3.74799 22.9981 2.33844 20.7174 3.30763 18.7791L10.3913 4.61155C11.4657 2.46282 14.532 2.46282 15.6064 4.61155L22.6901 18.779C23.6594 20.7174 22.2498 22.9981 20.0826 22.9981Z",
                    fill: "url(#paint1_linear_4328_484)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    opacity: "0.4",
                    d: "M21.9911 19.1305L14.9074 4.96303C14.5387 4.22548 13.8262 3.78516 13.0016 3.78516C12.177 3.78516 11.4646 4.22548 11.0958 4.96303L4.01206 19.1305C3.67938 19.7959 3.71424 20.5709 4.10533 21.2036C4.49641 21.8364 5.17403 22.2142 5.91788 22.2142H20.0854C20.8292 22.2142 21.5068 21.8364 21.8979 21.2036C22.289 20.5709 22.3238 19.7959 21.9911 19.1305ZM21.2306 20.7912C20.9835 21.191 20.5554 21.4297 20.0854 21.4297H5.91788C5.4479 21.4297 5.01977 21.191 4.7727 20.7912C4.5256 20.3914 4.50357 19.9017 4.71378 19.4814L11.7975 5.31391C12.034 4.84097 12.4728 4.56972 13.0016 4.56972C13.5304 4.56972 13.9692 4.84097 14.2057 5.31391L21.2894 19.4814C21.4996 19.9017 21.4776 20.3914 21.2306 20.7912Z",
                    fill: "url(#paint2_linear_4328_484)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M20.0842 22.9982H18.9686L12.5201 16.5498C12.3295 16.4564 12.2337 16.2952 12.2337 16.0649C12.2337 15.1949 12.198 14.5743 12.1266 12.6051C12.0552 10.6363 12.0195 10.2319 12.0195 9.36185C12.0195 9.08411 12.1141 8.86995 12.3031 8.71893C12.4918 8.56752 12.7366 8.49219 13.037 8.49219C13.3375 8.49219 13.5584 8.57065 13.6988 8.72796C13.7259 8.75777 19.6044 14.6343 21.6336 16.6627L22.6919 18.7794C23.6613 20.7176 22.2515 22.9982 20.0842 22.9982Z",
                    fill: "url(#paint3_linear_4328_484)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M18.5065 22.9968H15.5888L12.244 19.6519C12.0216 19.4558 11.9102 19.2271 11.9102 18.9654C11.9102 18.6928 12.0216 18.461 12.244 18.2704C12.4664 18.0797 12.7366 17.9844 13.0544 17.9844C13.3341 17.9844 13.5761 18.0797 13.7801 18.2704L18.5065 22.9968Z",
                    fill: "url(#paint4_linear_4328_484)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M11.9102 18.9668C11.9102 18.6942 12.0214 18.4627 12.2437 18.272C12.4661 18.0814 12.7364 17.9858 13.0542 17.9858C13.334 17.9858 13.5758 18.0814 13.7798 18.272C13.9838 18.4627 14.0861 18.6942 14.0861 18.9668C14.0861 19.2285 13.9839 19.4573 13.7798 19.6535C13.5758 19.8497 13.3339 19.9478 13.0542 19.9478C12.7364 19.9478 12.4661 19.8496 12.2437 19.6535C12.0214 19.4573 11.9102 19.2285 11.9102 18.9668ZM12.0172 9.36197C12.0172 9.08435 12.1116 8.86991 12.3006 8.71885C12.4895 8.5678 12.7342 8.49219 13.0347 8.49219C13.3351 8.49219 13.5558 8.57084 13.6966 8.728C13.8373 8.88515 13.9078 9.09642 13.9078 9.36197C13.9078 10.2321 13.8927 10.6363 13.8632 12.6054C13.8334 14.5746 13.8187 15.1951 13.8187 16.0649C13.8187 16.2464 13.7337 16.3884 13.5639 16.491C13.3939 16.5935 13.2175 16.6449 13.0347 16.6449C12.4991 16.6449 12.2313 16.4517 12.2313 16.0649C12.2313 15.1951 12.1955 14.5746 12.1242 12.6054C12.0528 10.6362 12.0172 10.2321 12.0172 9.36197Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint0_linear_4328_484",
                            x1: "8.01357",
                            y1: "11.5532",
                            x2: "30.8345",
                            y2: "34.3742",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFB92D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#F59500"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint1_linear_4328_484",
                            x1: "11.043",
                            y1: "14.5826",
                            x2: "17.9221",
                            y2: "21.4613",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFB92D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#F59500"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint2_linear_4328_484",
                            x1: "3.78514",
                            y1: "12.9999",
                            x2: "22.2177",
                            y2: "12.9999",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFF465"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FFE600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint3_linear_4328_484",
                            x1: "19.5323",
                            y1: "19.0831",
                            x2: "8.38856",
                            y2: "7.93939",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#BE3F45",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#BE3F45"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint4_linear_4328_484",
                            x1: "15.9216",
                            y1: "21.8729",
                            x2: "12.2866",
                            y2: "18.2374",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#BE3F45",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#BE3F45"
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        'recommendation': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "26",
            height: "26",
            viewBox: "0 0 26 26",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    "clip-path": "url(#clip0_4332_1464)",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M20.0781 20.309C19.7727 19.4909 18.8578 19.0751 18.0404 19.3827L14.712 20.6343C13.7823 20.9842 12.8032 21.1454 11.8281 21.1233L12.6412 24.1989C13.8773 24.0917 15.1036 23.8222 16.2866 23.3859L19.1524 22.3284C19.9684 22.0276 20.3826 21.1237 20.0781 20.309Z",
                            fill: "url(#paint0_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M22.1231 20.036C21.7701 19.2561 20.8486 18.9126 20.0708 19.2709L16.9034 20.7287C15.6706 21.2965 14.3198 21.5143 12.9926 21.3804L11.7617 24.4855C14.0921 24.6879 16.4573 24.2951 18.6255 23.3138L21.3539 22.0784C22.1309 21.7268 22.475 20.8126 22.1231 20.036Z",
                            fill: "url(#paint1_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M23.5444 20.0951C23.134 19.3243 22.1722 19.0326 21.4025 19.4452L18.2679 21.1242C17.0479 21.7781 15.6849 22.0836 14.3231 22.0302L13.2695 25.2629C15.6585 25.3235 18.0444 24.777 20.1912 23.6445L22.8927 22.2188C23.662 21.8132 23.9536 20.8626 23.5444 20.0951Z",
                            fill: "url(#paint2_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M12.9968 0C12.5455 0 12.1797 0.365835 12.1797 0.817114V2.51624C12.1797 2.96752 12.5455 3.33335 12.9968 3.33335C13.4481 3.33335 13.8139 2.96752 13.8139 2.51624V0.817114C13.8139 0.365835 13.4481 0 12.9968 0Z",
                            fill: "url(#paint3_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M24.8717 11.875H23.1726C22.7213 11.875 22.3555 12.2408 22.3555 12.6921C22.3555 13.1434 22.7213 13.5092 23.1726 13.5092H24.8717C25.323 13.5092 25.6888 13.1434 25.6888 12.6921C25.6888 12.2408 25.323 11.875 24.8717 11.875Z",
                            fill: "url(#paint4_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.82483 11.875H1.12571C0.674429 11.875 0.308594 12.2408 0.308594 12.6921C0.308594 13.1434 0.674429 13.5092 1.12571 13.5092H2.82483C3.27611 13.5092 3.64195 13.1434 3.64195 12.6921C3.6419 12.2408 3.27606 11.875 2.82483 11.875Z",
                            fill: "url(#paint5_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M5.18004 3.71588C4.86096 3.39679 4.34356 3.39679 4.02447 3.71588C3.70538 4.03496 3.70538 4.55231 4.02447 4.8714L5.22593 6.07285C5.54501 6.39194 6.06236 6.39194 6.3815 6.07285C6.70058 5.75377 6.70058 5.23642 6.3815 4.91728L5.18004 3.71588Z",
                            fill: "url(#paint6_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M21.9713 3.71588C21.6522 3.39679 21.1349 3.39679 20.8158 3.71588L19.6143 4.91733C19.2952 5.23642 19.2952 5.75377 19.6143 6.0729C19.9334 6.39199 20.4507 6.39199 20.7699 6.0729L21.9713 4.87145C22.2904 4.55236 22.2904 4.03496 21.9713 3.71588Z",
                            fill: "url(#paint7_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.6799 6.3713C3.19003 9.86117 3.19003 15.5194 6.6799 19.0092C10.1698 22.4991 15.828 22.4991 19.3178 19.0092C22.8077 15.5194 22.8077 9.86117 19.3178 6.3713C15.828 2.88144 10.1698 2.88144 6.6799 6.3713Z",
                            fill: "url(#paint8_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M12.9985 5.96484C9.28434 5.96484 6.27344 8.97575 6.27344 12.6899C6.27344 16.4041 9.28434 19.415 12.9985 19.415C16.7127 19.415 19.7236 16.4041 19.7236 12.6899C19.7236 8.97575 16.7127 5.96484 12.9985 5.96484Z",
                            fill: "url(#paint9_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.67988 19.0065C10.1697 22.4963 15.828 22.4963 19.3178 19.0065C21.0628 17.2615 21.9352 14.9745 21.9352 12.6875H4.0625C4.0625 14.9745 4.93498 17.2615 6.67988 19.0065Z",
                            fill: "url(#paint10_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M19.7204 12.884L17.8912 11.0549C17.6976 10.8154 17.416 10.6396 17.0649 10.5886L16.2742 10.4737C16.2431 10.4428 14.0664 8.275 14.0664 8.275C13.4901 7.56244 12.313 7.64631 11.8785 8.52679L11.1269 10.0495C11.0484 10.2086 10.8966 10.3189 10.721 10.3443L9.04068 10.5885C7.96652 10.7446 7.53762 12.0646 8.31487 12.8223C8.31487 12.8223 9.61263 14.1179 9.62318 14.129C9.68344 14.2357 9.70704 14.3609 9.68583 14.4847L9.39876 16.1583C9.312 16.6643 9.51765 17.1132 9.85998 17.3927L11.7701 19.3029C12.1683 19.3763 12.5787 19.4151 12.9982 19.4151C16.6475 19.4151 19.6176 16.5084 19.7204 12.884Z",
                            fill: "url(#paint11_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M14.1724 8.47218L14.9239 9.99486C15.0024 10.154 15.1543 10.2642 15.3298 10.2897L17.0102 10.5339C18.0844 10.69 18.5133 12.01 17.736 12.7677L16.5201 13.9529C16.393 14.0768 16.3351 14.2552 16.365 14.4301L16.6521 16.1036C16.8355 17.1735 15.7126 17.9892 14.7519 17.4842L13.2489 16.694C13.0919 16.6115 12.9042 16.6115 12.7472 16.694L11.2442 17.4842C10.2835 17.9893 9.1606 17.1735 9.34408 16.1036L9.63115 14.4301C9.66112 14.2552 9.60316 14.0768 9.47612 13.9529L8.26018 12.7677C7.48294 12.01 7.91183 10.69 8.98599 10.5339L10.6664 10.2897C10.8419 10.2642 10.9937 10.154 11.0723 9.99486L11.8238 8.47218C12.3041 7.49886 13.6921 7.49886 14.1724 8.47218Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M14.7518 17.4861L13.2489 16.6959C13.0919 16.6133 12.9043 16.6133 12.7473 16.6959L11.2444 17.4861C10.2836 17.9912 9.1606 17.1755 9.34403 16.1054L9.63125 14.4321C9.66108 14.2571 9.60326 14.0786 9.47602 13.9548L8.26013 12.7696C7.84225 12.3622 7.77307 11.7923 7.96537 11.3281L16.3697 14.2263C16.3551 14.293 16.3531 14.3629 16.3649 14.4321L16.6521 16.1054C16.8356 17.1755 15.7126 17.9912 14.7518 17.4861Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M13.2508 16.694L14.7538 17.4842C15.7146 17.9893 16.8374 17.1735 16.654 16.1036L16.3669 14.4301C16.337 14.2552 16.3949 14.0768 16.522 13.9529L17.7379 12.7677C18.5152 12.01 18.0863 10.69 17.0121 10.5339L15.3317 10.2897C15.1562 10.2642 15.0044 10.154 14.9258 9.99486L14.1743 8.47218C13.9342 7.98552 13.4671 7.74219 13 7.74219V16.6321C13.0861 16.6321 13.1723 16.6527 13.2508 16.694Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M11.2444 17.4861L12.7473 16.6959C12.9044 16.6133 13.0919 16.6133 13.2489 16.6959L14.7518 17.4861C15.7126 17.9912 16.8356 17.1755 16.6522 16.1054L16.365 14.4321C16.3351 14.2571 16.3929 14.0786 16.5202 13.9548L17.7361 12.7696C18.154 12.3622 18.2231 11.7923 18.0308 11.3281L9.62653 14.2263C9.64111 14.293 9.64315 14.3629 9.63132 14.4321L9.3441 16.1054C9.16057 17.1755 10.2836 17.9912 11.2444 17.4861Z",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M17.0971 14.9922L15.8347 16.2546C14.8147 17.2745 13.4314 17.8475 11.989 17.8475H10.7734V21.348C13.7318 22.1058 17.0026 21.3275 19.3185 19.0115C19.6237 18.7063 19.9017 18.3841 20.1535 18.0486L17.0971 14.9922Z",
                            fill: "url(#paint12_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M23.1622 19.5813L21.8579 20.558C21.8006 20.5982 21.7429 20.6376 21.6847 20.6763C20.1189 21.7196 18.2276 22.1545 16.3547 21.974C14.7884 21.8231 14.1616 21.7128 12.1443 20.6237C11.7925 20.4338 11.744 20.0538 12.0358 19.7805L12.1157 19.7056C13.6803 19.0767 15.1821 18.3051 16.6027 17.4013C17.4184 16.8824 17.6411 15.7899 17.0981 14.99C16.6039 14.262 15.6403 14.0274 14.8646 14.4429C13.5328 15.1562 12.0658 15.591 10.5542 15.7157C10.2654 15.7395 9.97491 15.7317 9.68671 15.7017C8.77875 15.6071 6.58048 15.3936 5.84427 15.4606C5.83749 15.4612 5.83066 15.4618 5.82383 15.4625C3.89672 15.6408 2.31821 17.0688 1.94182 18.9674L1.91944 19.0804C1.43278 21.5328 3.0273 23.9158 5.48022 24.4021L9.71587 25.2417L12.3838 25.7447C16.5715 26.4999 20.8881 25.5677 24.3806 23.1538L25.2282 22.5225C26.0447 21.9585 26.2459 20.8411 25.678 20.0264C25.108 19.2088 23.9782 19.0091 23.1622 19.5813Z",
                            fill: "url(#paint13_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M3.80144 16.1797C2.85952 16.8102 2.17327 17.799 1.94182 18.9663L1.91944 19.0793C1.43278 21.5317 3.0273 23.9147 5.48022 24.401L9.71588 25.2407L12.3838 25.7437C12.7649 25.8124 13.1469 25.8667 13.5294 25.9077L3.80144 16.1797Z",
                            fill: "url(#paint14_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M17.0989 14.99C16.6046 14.262 15.641 14.0274 14.8654 14.4429C13.3963 15.2297 11.7629 15.6776 10.0865 15.7444C10.0613 15.7454 10.0362 15.7465 10.011 15.7478C7.17758 15.8896 6.89143 19.966 9.67695 20.5039C9.87715 20.5425 10.0842 20.5226 10.2734 20.4466L12.1165 19.7057C13.681 19.0767 15.183 18.3051 16.6035 17.4013C17.4191 16.8824 17.6419 15.7899 17.0989 14.99Z",
                            fill: "url(#paint15_linear_4332_1464)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.69457 24.7566H1.10735C0.495784 24.7566 0 24.2609 0 23.6493V16.2402C0 15.6286 0.495784 15.1328 1.10735 15.1328H2.69457C3.30613 15.1328 3.80191 15.6286 3.80191 16.2402V23.6493C3.80191 24.2609 3.30618 24.7566 2.69457 24.7566Z",
                            fill: "url(#paint16_linear_4332_1464)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint0_linear_4332_1464",
                            x1: "15.764",
                            y1: "19.4036",
                            x2: "16.0639",
                            y2: "20.8796",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFEEE6"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FFB09E"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint1_linear_4332_1464",
                            x1: "16.2827",
                            y1: "19.5834",
                            x2: "16.702",
                            y2: "21.3933",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFEEE6"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FFB09E"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint2_linear_4332_1464",
                            x1: "17.5333",
                            y1: "20.7331",
                            x2: "18.0831",
                            y2: "22.0342",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFEEE6"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FFB09E"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint3_linear_4332_1464",
                            x1: "12.1864",
                            y1: "3.5",
                            x2: "10.5612",
                            y2: "1.53682",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEF0AE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FAC600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint4_linear_4332_1464",
                            x1: "22.498",
                            y1: "12.502",
                            x2: "24.6324",
                            y2: "14.045",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEF0AE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FAC600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint5_linear_4332_1464",
                            x1: "3.49805",
                            y1: "11.9689",
                            x2: "1.4124",
                            y2: "10.461",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEF0AE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FAC600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint6_linear_4332_1464",
                            x1: "6.11026",
                            y1: "6.05077",
                            x2: "3.70104",
                            y2: "3.73927",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEF0AE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FAC600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint7_linear_4332_1464",
                            x1: "19.248",
                            y1: "5.74902",
                            x2: "21.4114",
                            y2: "3.65934",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEF0AE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FAC600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint8_linear_4332_1464",
                            x1: "4",
                            y1: "11.5",
                            x2: "23.7975",
                            y2: "18.6796",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEF0AE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FAC600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint9_linear_4332_1464",
                            x1: "17.3019",
                            y1: "18.1751",
                            x2: "5.87424",
                            y2: "7.21116",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEF0AE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FAC600"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint10_linear_4332_1464",
                            x1: "15.5175",
                            y1: "17.7627",
                            x2: "17.4198",
                            y2: "20.1175",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FE9738",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FE9738"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint11_linear_4332_1464",
                            x1: "17.5",
                            y1: "19",
                            x2: "10.4578",
                            y2: "7.4007",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#BE3F45",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#BE3F45"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint12_linear_4332_1464",
                            x1: "15.4635",
                            y1: "18.1901",
                            x2: "15.4635",
                            y2: "21.3788",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FE9738",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FE9738"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint13_linear_4332_1464",
                            x1: "12.0588",
                            y1: "15.5361",
                            x2: "16.5197",
                            y2: "28.04",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFEEE6"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FFB09E"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint14_linear_4332_1464",
                            x1: "9.09172",
                            y1: "21.0437",
                            x2: "1.43228",
                            y2: "21.0437",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFB09E",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#EC806B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint15_linear_4332_1464",
                            x1: "12.511",
                            y1: "17.1585",
                            x2: "15.3498",
                            y2: "19.9972",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FFB09E",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#EC806B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint16_linear_4332_1464",
                            x1: "0.518622",
                            y1: "19.9447",
                            x2: "3.59591",
                            y2: "19.9447",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0182FC"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_4332_1464",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "26",
                                height: "26",
                                fill: "white"
                            })
                        })
                    ]
                })
            ]
        }),
        'tool-tip': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "23",
            height: "22",
            viewBox: "0 0 23 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M19.0954 7.59459C19.0954 3.39534 15.6873 -0.00792367 11.4862 1.38565e-05C7.32805 0.00786511 3.97026 3.31889 3.90715 7.47656C3.86673 10.1385 5.19613 12.4926 7.23603 13.8795C7.24414 13.885 7.24902 13.8941 7.24902 13.904C7.6515 14.1551 7.8961 14.5961 7.8961 15.0705V16.7815H15.1055V15.055C15.1055 14.5891 15.3416 14.1547 15.7326 13.9013L15.7526 13.8883C17.7696 12.523 19.0954 10.2136 19.0954 7.59459Z",
                    fill: "url(#paint0_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M11.5034 12.8115C14.3444 12.8115 16.6474 10.5084 16.6474 7.66747C16.6474 4.8265 14.3444 2.52344 11.5034 2.52344C8.66244 2.52344 6.35938 4.8265 6.35938 7.66747C6.35938 10.5084 8.66244 12.8115 11.5034 12.8115Z",
                    fill: "url(#paint1_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M18.6955 10.0334L13.9165 5.25445C13.8453 5.12309 13.7329 5.03125 13.5718 5.03125H9.51909C9.20948 5.03125 9.07812 5.36898 9.07812 5.67855C9.07812 5.96628 9.18213 6.22322 9.37022 6.31169L10.8136 7.78363V11.4386C10.8136 11.5865 10.9026 11.6978 11.0365 11.7728L15.107 15.8433V15.0539C15.107 14.5879 15.343 14.1536 15.7341 13.9001L15.7541 13.8872C17.1136 12.9669 18.1584 11.6173 18.6955 10.0334Z",
                    fill: "url(#paint2_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M13.5288 4.99219H9.47612C9.16651 4.99219 9.03516 5.32992 9.03516 5.63948C9.03516 5.99598 9.19464 6.30555 9.47612 6.30555H10.7707V11.3996C10.7707 11.6998 11.1366 11.8499 11.5025 11.8499C11.8684 11.8499 12.2342 11.6998 12.2342 11.3996V6.30555H13.5289C13.8103 6.30555 13.9698 5.99598 13.9698 5.63948C13.9697 5.32988 13.8384 4.99219 13.5288 4.99219Z",
                    fill: "url(#paint3_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M21.8055 6.92578H20.1917C19.8076 6.92578 19.4961 7.2372 19.4961 7.62139C19.4961 8.00554 19.8075 8.31701 20.1917 8.31701H21.8055C22.1896 8.31701 22.5011 8.00559 22.5011 7.62139C22.5011 7.2372 22.1897 6.92578 21.8055 6.92578Z",
                    fill: "url(#paint4_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M3.505 7.62139C3.505 7.23724 3.19358 6.92578 2.80939 6.92578H1.19561C0.811419 6.92578 0.5 7.2372 0.5 7.62139C0.5 8.00554 0.811419 8.31701 1.19561 8.31701H2.80939C3.19354 8.31696 3.505 8.00554 3.505 7.62139Z",
                    fill: "url(#paint5_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M19.7422 11.485C19.4705 11.2133 19.0301 11.2133 18.7584 11.485C18.4868 11.7566 18.4868 12.1971 18.7584 12.4687L19.8995 13.6098C20.1712 13.8815 20.6116 13.8815 20.8833 13.6098C21.1549 13.3382 21.1549 12.8977 20.8833 12.6261L19.7422 11.485Z",
                    fill: "url(#paint6_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M3.10153 1.63342C2.82989 1.36178 2.38944 1.36178 2.1178 1.63342C1.84615 1.90507 1.84615 2.34551 2.1178 2.61716L3.2589 3.75826C3.53055 4.02991 3.97099 4.02991 4.24264 3.75826C4.51428 3.48662 4.51428 3.04617 4.24264 2.77453L3.10153 1.63342Z",
                    fill: "url(#paint7_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M4.24264 11.485C3.97099 11.2133 3.53055 11.2133 3.2589 11.485L2.1178 12.6261C1.84615 12.8977 1.84615 13.3382 2.1178 13.6098C2.38944 13.8815 2.82989 13.8815 3.10153 13.6098L4.24264 12.4687C4.51428 12.197 4.51428 11.7566 4.24264 11.485Z",
                    fill: "url(#paint8_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M18.7584 3.75826C19.0301 4.02991 19.4705 4.02991 19.7422 3.75826L20.8833 2.61716C21.1549 2.34551 21.1549 1.90507 20.8833 1.63342C20.6116 1.36178 20.1712 1.36178 19.8995 1.63342L18.7584 2.77453C18.4868 3.04617 18.4868 3.48662 18.7584 3.75826Z",
                    fill: "url(#paint9_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M15.1038 15.4497L12.4735 12.8194C12.2449 12.5502 11.9041 12.3789 11.5232 12.3789C10.8351 12.3789 10.2773 12.9367 10.2773 13.6248C10.2773 13.6696 10.2795 13.7141 10.2842 13.7576C10.3188 14.0842 10.4801 14.3732 10.7178 14.5751L12.9239 16.7812H15.1038V15.4497Z",
                    fill: "url(#paint10_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M11.4998 14.8434C12.1879 14.8434 12.7458 14.2856 12.7458 13.5975C12.7458 12.9094 12.1879 12.3516 11.4998 12.3516C10.8117 12.3516 10.2539 12.9094 10.2539 13.5975C10.2539 14.2856 10.8117 14.8434 11.4998 14.8434Z",
                    fill: "url(#paint11_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M4.42578 10.3516C4.98797 11.7927 5.97705 13.0202 7.23834 13.8778C7.24645 13.8833 7.25133 13.8924 7.25133 13.9022C7.65381 14.1534 7.89841 14.5943 7.89841 15.0687V16.7797H15.1078V15.0533C15.1078 14.5873 15.3439 14.153 15.7349 13.8995L15.7549 13.8865C17.0224 13.0286 18.0166 11.7977 18.5807 10.3516H4.42578V10.3516Z",
                    fill: "url(#paint12_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M14.6805 15.5156H8.31754C7.65243 15.5156 7.11328 16.0548 7.11328 16.7199C7.11328 17.385 7.65247 17.9241 8.31754 17.9241H14.6805C15.3456 17.9241 15.8848 17.385 15.8848 16.7199C15.8848 16.0548 15.3456 15.5156 14.6805 15.5156Z",
                    fill: "url(#paint13_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M7.97656 19.457C8.60604 20.9614 9.94697 22.0002 11.4996 22.0002C13.0522 22.0002 14.3931 20.9614 15.0226 19.457H7.97656Z",
                    fill: "url(#paint14_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M7.97656 19.457C8.60604 20.9614 9.94697 22.0002 11.4996 22.0002C13.0522 22.0002 14.3931 20.9614 15.0226 19.457H7.97656Z",
                    fill: "url(#paint15_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M14.6805 17.9219H8.31754C7.65243 17.9219 7.11328 18.4611 7.11328 19.1261C7.11328 19.7913 7.65247 20.3304 8.31754 20.3304H14.6805C15.3456 20.3304 15.8848 19.7912 15.8848 19.1261C15.8848 18.461 15.3456 17.9219 14.6805 17.9219Z",
                    fill: "url(#paint16_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M14.6805 15.5156H8.31754C7.65243 15.5156 7.11328 16.0548 7.11328 16.7199C7.11328 17.385 7.65247 17.9241 8.31754 17.9241H14.6805C15.3456 17.9241 15.8848 17.385 15.8848 16.7199C15.8848 16.0548 15.3456 15.5156 14.6805 15.5156Z",
                    fill: "url(#paint17_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M14.6806 17.9219L11.5121 17.8047L8.31754 17.9219C7.65243 17.9219 7.11328 18.4611 7.11328 19.1262C7.11328 19.7913 7.65247 20.3304 8.31754 20.3304H14.6806C15.3457 20.3304 15.8848 19.7912 15.8848 19.1262C15.8849 18.461 15.3457 17.9219 14.6806 17.9219Z",
                    fill: "url(#paint18_linear_4332_1505)"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint0_linear_4332_1505",
                            x1: "5.93971",
                            y1: "3.05907",
                            x2: "15.0821",
                            y2: "12.2015",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint1_linear_4332_1505",
                            x1: "9.58814",
                            y1: "5.75216",
                            x2: "17.3877",
                            y2: "13.5517",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint2_linear_4332_1505",
                            x1: "17.8051",
                            y1: "13.8419",
                            x2: "5.67629",
                            y2: "1.71302",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#D52C1C",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.28",
                                    "stop-color": "#D12C1E",
                                    "stop-opacity": "0.28"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5735",
                                    "stop-color": "#C42C23",
                                    "stop-opacity": "0.574"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8721",
                                    "stop-color": "#AF2B2C",
                                    "stop-opacity": "0.872"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#A42B31"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint3_linear_4332_1505",
                            x1: "9.55614",
                            y1: "5.5966",
                            x2: "14.2863",
                            y2: "10.3268",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#E38523"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#C4237C"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint4_linear_4332_1505",
                            x1: "18.5774",
                            y1: "6.71341",
                            x2: "23.2577",
                            y2: "8.46855",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint5_linear_4332_1505",
                            x1: "-0.418726",
                            y1: "6.71341",
                            x2: "4.26166",
                            y2: "8.46855",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint6_linear_4332_1505",
                            x1: "17.4346",
                            y1: "11.6526",
                            x2: "22.0474",
                            y2: "13.3824",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint7_linear_4332_1505",
                            x1: "0.793997",
                            y1: "1.80097",
                            x2: "5.40674",
                            y2: "3.53075",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint8_linear_4332_1505",
                            x1: "1.46243",
                            y1: "11.9032",
                            x2: "4.78304",
                            y2: "13.1485",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint9_linear_4332_1505",
                            x1: "18.1031",
                            y1: "2.05165",
                            x2: "21.4237",
                            y2: "3.29689",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#F7E07D"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E69642"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint10_linear_4332_1505",
                            x1: "15.1922",
                            y1: "17.2937",
                            x2: "11.3785",
                            y2: "13.48",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#D52C1C",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.28",
                                    "stop-color": "#D12C1E",
                                    "stop-opacity": "0.28"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5735",
                                    "stop-color": "#C42C23",
                                    "stop-opacity": "0.574"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8721",
                                    "stop-color": "#AF2B2C",
                                    "stop-opacity": "0.872"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#A42B31"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint11_linear_4332_1505",
                            x1: "10.8794",
                            y1: "12.977",
                            x2: "12.0204",
                            y2: "14.118",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#E38523"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#C4237C"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint12_linear_4332_1505",
                            x1: "11.5033",
                            y1: "12.2928",
                            x2: "11.5033",
                            y2: "15.8093",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#D52C1C",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.28",
                                    "stop-color": "#D12C1E",
                                    "stop-opacity": "0.28"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5735",
                                    "stop-color": "#C42C23",
                                    "stop-opacity": "0.574"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8721",
                                    "stop-color": "#AF2B2C",
                                    "stop-opacity": "0.872"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#A42B31"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint13_linear_4332_1505",
                            x1: "11.499",
                            y1: "16.221",
                            x2: "11.499",
                            y2: "17.6877",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EEF4FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#CFE7FD"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint14_linear_4332_1505",
                            x1: "8.50191",
                            y1: "20.7286",
                            x2: "13.9964",
                            y2: "20.7286",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#464646"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint15_linear_4332_1505",
                            x1: "11.4996",
                            y1: "21.6335",
                            x2: "11.4996",
                            y2: "20.7058",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#464646",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#202020"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint16_linear_4332_1505",
                            x1: "11.499",
                            y1: "18.2893",
                            x2: "11.499",
                            y2: "20.017",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EEF4FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#CFE7FD"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint17_linear_4332_1505",
                            x1: "11.499",
                            y1: "16.7818",
                            x2: "11.499",
                            y2: "18.2916",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#8AAADC",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#8AAADC"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint18_linear_4332_1505",
                            x1: "11.4991",
                            y1: "19.2079",
                            x2: "11.4991",
                            y2: "20.2268",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#8AAADC",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#8AAADC"
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        'toolbox-offer': /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
            width: "26",
            height: "26",
            viewBox: "0 0 26 26",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                    "clip-path": "url(#clip0_4332_1543)",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M3.80078 7.40625H22.2021V11.1521H3.80078V7.40625Z",
                            fill: "url(#paint0_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M3.80078 7.40625H8.22629V11.1521H3.80078V7.40625Z",
                            fill: "url(#paint1_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M8.82812 7.40625H13.2536V11.1521H8.82812V7.40625Z",
                            fill: "url(#paint2_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M3.76817 21.3742H1.64453L2.86663 7.38367C2.90798 6.91021 3.3044 6.54688 3.77969 6.54688C4.30994 6.54688 4.72956 6.9955 4.69418 7.52453L3.76817 21.3742Z",
                            fill: "url(#paint3_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M24.3525 21.3741H22.2288L21.3029 7.52453C21.2675 6.99545 21.6871 6.54688 22.2174 6.54688C22.6926 6.54688 23.0891 6.91016 23.1304 7.38367L24.3525 21.3741Z",
                            fill: "url(#paint4_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M4.50912 10.2969L3.76786 21.3764H1.64453L2.61214 10.2969H4.50912Z",
                            fill: "url(#paint5_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M24.3529 21.3764H22.2295L21.4883 10.2969H23.3853L24.3529 21.3764Z",
                            fill: "url(#paint6_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.69531 4.71875H9.51886V12.889H6.69531V4.71875Z",
                            fill: "url(#paint7_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.69531 4.71875H9.51886V8.12873H6.69531V4.71875Z",
                            fill: "url(#paint8_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.91016 1.96875H6.59517V4.30987H2.91016V1.96875Z",
                            fill: "url(#paint9_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M2.91016 1.96875H6.59517V4.30987H2.91016V1.96875Z",
                            fill: "url(#paint10_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M3.10584 5.24269H1.71C1.46672 5.24269 1.26953 5.0455 1.26953 4.80222V1.47172C1.26953 1.22844 1.46672 1.03125 1.71 1.03125H3.10584C3.34912 1.03125 3.54632 1.22844 3.54632 1.47172V4.80217C3.54637 5.04545 3.34912 5.24269 3.10584 5.24269Z",
                            fill: "url(#paint11_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M12.8378 5.24269H5.45548C4.9731 5.24269 4.58203 4.85162 4.58203 4.36924V1.9047C4.58203 1.42232 4.9731 1.03125 5.45548 1.03125H9.98519C11.9359 1.03125 13.5172 2.61261 13.5172 4.56327C13.5173 4.93849 13.2131 5.24269 12.8378 5.24269Z",
                            fill: "url(#paint12_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M1.86719 5.24264H3.10693C3.35021 5.24264 3.5474 5.04545 3.5474 4.80217V1.47172C3.5474 1.22844 3.35021 1.03125 3.10693 1.03125H1.86719V5.24264Z",
                            fill: "url(#paint13_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M8.11278 21.7772C6.56818 21.7772 5.33777 20.485 5.41347 18.9422L5.82259 10.6056C5.849 10.0674 6.29309 9.64453 6.83195 9.64453H9.39356C9.93243 9.64453 10.3765 10.0674 10.4029 10.6056L10.812 18.9422C10.8877 20.4849 9.65734 21.7772 8.11278 21.7772Z",
                            fill: "url(#paint14_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.812 18.9441L10.4318 11.1953H5.8753L5.79144 11.2417L5.41347 18.9441C5.33777 20.4868 6.56818 21.7791 8.11278 21.7791C9.65734 21.7791 10.8877 20.4868 10.812 18.9441Z",
                            fill: "url(#paint15_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M5.51966 16.7773L5.41347 18.9416C5.33777 20.4843 6.56818 21.7766 8.11278 21.7766C9.65739 21.7766 10.8878 20.4844 10.8121 18.9416L10.7059 16.7773H5.51966Z",
                            fill: "url(#paint16_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M11.1066 11.8645C11.4597 14.3914 11.4728 16.9449 11.1448 19.4889C11.0347 20.343 9.81787 20.401 9.62134 19.5625C9.39784 18.609 9.24531 17.4929 9.19423 16.2961C9.11959 14.5468 9.27544 12.9505 9.58902 11.7707C9.80635 10.9532 10.9895 11.0267 11.1066 11.8645Z",
                            fill: "url(#paint17_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.1081 17.2038C10.0364 17.2759 9.99183 17.3747 9.99219 17.4845C9.99244 17.703 10.1703 17.8803 10.3893 17.8798L11.3042 17.8783C11.3238 17.6142 11.3391 17.3495 11.3504 17.0859L10.3881 17.0872C10.2782 17.0875 10.1796 17.1324 10.1081 17.2038Z",
                            fill: "url(#paint18_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.1078 15.4815C10.0363 15.5529 9.99203 15.6522 9.99219 15.7614C9.99265 15.9805 10.1703 16.1572 10.3888 16.157L11.3796 16.1557C11.3826 15.8915 11.3822 15.6274 11.3778 15.3633L10.3877 15.3649C10.2784 15.365 10.1795 15.4093 10.1078 15.4815Z",
                            fill: "url(#paint19_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M10.1038 13.7626C10.032 13.8347 9.98798 13.9333 9.98828 14.043C9.98854 14.2616 10.1658 14.4391 10.3849 14.4386L11.3465 14.4371C11.3341 14.1727 11.3176 13.9084 11.2969 13.6445L10.3836 13.646C10.2739 13.6463 10.1752 13.6911 10.1038 13.7626Z",
                            fill: "url(#paint20_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M5.11868 11.8645C4.76549 14.3914 4.75244 16.9449 5.08044 19.4889C5.19056 20.343 6.40736 20.401 6.60389 19.5625C6.82739 18.609 6.97992 17.4929 7.03101 16.2961C7.10564 14.5468 6.94979 12.9505 6.63621 11.7707C6.41888 10.9532 5.23578 11.0267 5.11868 11.8645Z",
                            fill: "url(#paint21_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.11333 17.2038C6.18506 17.2759 6.22962 17.3747 6.22926 17.4845C6.22901 17.703 6.05119 17.8803 5.83218 17.8798L4.91723 17.8783C4.89765 17.6142 4.88236 17.3495 4.87109 17.0859L5.8334 17.0872C5.94321 17.0875 6.04186 17.1324 6.11333 17.2038Z",
                            fill: "url(#paint22_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.11747 15.4815C6.18894 15.5529 6.23324 15.6522 6.23309 15.7614C6.23263 15.9805 6.05502 16.1572 5.83646 16.157L4.84571 16.1557C4.8427 15.8915 4.84306 15.6274 4.84744 15.3633L5.83753 15.3649C5.94684 15.365 6.04574 15.4093 6.11747 15.4815Z",
                            fill: "url(#paint23_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M6.12171 13.7626C6.19344 13.8347 6.23748 13.9333 6.23718 14.043C6.23692 14.2616 6.05961 14.4391 5.84055 14.4386L4.87891 14.4371C4.89135 14.1727 4.90776 13.9084 4.92851 13.6445L5.84177 13.646C5.95158 13.6463 6.05023 13.6911 6.12171 13.7626Z",
                            fill: "url(#paint24_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M4.58203 2.69531V4.37134C4.58203 4.85372 4.9731 5.24479 5.45548 5.24479H12.8378C13.213 5.24479 13.5172 4.94059 13.5172 4.56538C13.5172 3.87841 13.3204 3.23774 12.9812 2.69531H4.58203Z",
                            fill: "url(#paint25_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M16.4628 1.92083L13.185 9.19145C12.4381 10.8483 13.6499 12.7239 15.4673 12.7239H20.2118C22.0292 12.7239 23.241 10.8483 22.494 9.19145L19.2164 1.92083C18.6817 0.734723 16.9975 0.734723 16.4628 1.92083Z",
                            fill: "url(#paint26_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M13.185 9.19238C12.4381 10.8492 13.6499 12.7248 15.4674 12.7248H20.2118C22.0293 12.7248 23.2411 10.8492 22.4941 9.19238L21.733 7.50391H13.9462L13.185 9.19238Z",
                            fill: "url(#paint27_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M20.2121 12.7246C21.6147 12.7246 22.6563 11.6075 22.7155 10.3359H17.8398V12.7246H20.2121Z",
                            fill: "url(#paint28_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M18.5362 15.2403V11.0337C18.5362 10.6483 18.2238 10.3359 17.8384 10.3359C17.453 10.3359 17.1406 10.6483 17.1406 11.0337V15.2403H18.5362Z",
                            fill: "url(#paint29_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M18.5362 15.2403V11.0337C18.5362 10.6483 18.2238 10.3359 17.8384 10.3359C17.453 10.3359 17.1406 10.6483 17.1406 11.0337V15.2403H18.5362Z",
                            fill: "url(#paint30_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M19.1155 13.9688H16.561C15.9048 13.9688 15.4947 14.6793 15.823 15.2475C16.3114 16.0926 16.4344 17.1003 16.1637 18.0382L15.3664 20.8008C15.2251 21.2905 15.5926 21.779 16.1022 21.779H19.5743C20.0839 21.779 20.4513 21.2905 20.31 20.8008L19.5127 18.0382C19.2421 17.1003 19.3651 16.0927 19.8534 15.2475C20.1818 14.6793 19.7718 13.9688 19.1155 13.9688Z",
                            fill: "url(#paint31_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M19.1155 13.9688H16.561C15.9048 13.9688 15.4947 14.6793 15.823 15.2475C16.3114 16.0926 16.4344 17.1003 16.1637 18.0382L15.3664 20.8008C15.2251 21.2905 15.5926 21.779 16.1022 21.779H19.5743C20.0839 21.779 20.4513 21.2905 20.31 20.8008L19.5127 18.0382C19.2421 17.1003 19.3651 16.0927 19.8534 15.2475C20.1818 14.6793 19.7718 13.9688 19.1155 13.9688Z",
                            fill: "url(#paint32_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M20.31 20.8006L19.5127 18.0379C19.4435 17.7981 19.4002 17.5537 19.382 17.3086H16.2944C16.2762 17.5537 16.233 17.7981 16.1637 18.0379L15.3664 20.8006C15.2251 21.2903 15.5926 21.7788 16.1022 21.7788H19.5743C20.0839 21.7787 20.4513 21.2902 20.31 20.8006Z",
                            fill: "url(#paint33_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M26 17.5936V23.1306C26 24.1445 25.1781 24.9664 24.1642 24.9664H23.6727C23.4284 24.9664 23.1901 24.9043 22.9691 24.8002C22.7975 24.7194 22.6056 24.6743 22.4033 24.6743H21.3689C21.1668 24.6743 20.9749 24.7193 20.8032 24.8002C20.5822 24.9043 20.3438 24.9664 20.0996 24.9664H17.7487C17.5045 24.9664 17.2661 24.9043 17.0452 24.8002C16.8735 24.7193 16.6816 24.6743 16.4794 24.6743H15.4445C15.2423 24.6743 15.0504 24.7193 14.8787 24.8002C14.6577 24.9043 14.4194 24.9664 14.1751 24.9664H11.8248C11.5806 24.9664 11.3422 24.9043 11.1212 24.8002C10.9495 24.7194 10.7577 24.6743 10.5554 24.6743H9.52054C9.31835 24.6743 9.12646 24.7193 8.95476 24.8002C8.73376 24.9043 8.49542 24.9664 8.25123 24.9664H5.90037C5.65612 24.9664 5.41779 24.9043 5.19679 24.8002C5.02509 24.7194 4.83325 24.6743 4.63101 24.6743H3.59667C3.39443 24.6743 3.20254 24.7193 3.03089 24.8002C2.80989 24.9043 2.57155 24.9664 2.32731 24.9664H1.8358C0.821906 24.9664 0 24.1445 0 23.1306V17.5941C0 16.58 0.822161 15.7578 1.83631 15.7578H24.1642C25.1781 15.7578 26 16.5797 26 17.5936Z",
                            fill: "url(#paint34_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M18.0308 21.4563H7.97053C7.19287 21.4563 6.5625 20.8259 6.5625 20.0483V18.7283C6.5625 17.9507 7.19292 17.3203 7.97053 17.3203H18.0307C18.8084 17.3203 19.4388 17.9507 19.4388 18.7283V20.0483C19.4388 20.8259 18.8084 21.4563 18.0308 21.4563Z",
                            fill: "url(#paint35_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M5.96221 24.2373V24.9659H5.90048C5.65623 24.9659 5.4179 24.9037 5.1969 24.7997C5.02519 24.7189 4.83335 24.6737 4.63112 24.6737H3.59672C3.39448 24.6737 3.20259 24.7188 3.03094 24.7997C2.80994 24.9037 2.57161 24.9659 2.32736 24.9659H2.26562V24.2373C2.26562 23.5022 2.86159 22.9062 3.59672 22.9062H4.63112C5.36625 22.9062 5.96221 23.5022 5.96221 24.2373Z",
                            fill: "url(#paint36_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M11.8885 24.2373V24.9659H11.8267C11.5825 24.9659 11.3441 24.9037 11.1231 24.7997C10.9514 24.7189 10.7596 24.6737 10.5574 24.6737H9.52245C9.32026 24.6737 9.12837 24.7188 8.95667 24.7997C8.73567 24.9037 8.49734 24.9659 8.25314 24.9659H8.19141V24.2373C8.19141 23.5022 8.78737 22.9062 9.5225 22.9062H10.5574C11.2925 22.9062 11.8885 23.5022 11.8885 24.2373Z",
                            fill: "url(#paint37_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M17.8103 24.2373V24.9659H17.7486C17.5043 24.9659 17.266 24.9037 17.0451 24.7997C16.8734 24.7188 16.6815 24.6737 16.4793 24.6737H15.4444C15.2422 24.6737 15.0503 24.7188 14.8786 24.7997C14.6576 24.9037 14.4193 24.9659 14.175 24.9659H14.1133V24.2373C14.1133 23.5022 14.7092 22.9062 15.4444 22.9062H16.4793C17.2144 22.9062 17.8103 23.5022 17.8103 24.2373Z",
                            fill: "url(#paint38_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M23.7357 24.2373V24.9659H23.6739C23.4297 24.9659 23.1913 24.9037 22.9703 24.7997C22.7987 24.7189 22.6068 24.6737 22.4046 24.6737H21.3702C21.168 24.6737 20.9761 24.7188 20.8044 24.7997C20.5834 24.9037 20.345 24.9659 20.1008 24.9659H20.0391V24.2373C20.0391 23.5022 20.635 22.9062 21.3702 22.9062H22.4046C23.1397 22.9062 23.7357 23.5022 23.7357 24.2373Z",
                            fill: "url(#paint39_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M0 18.7852V23.1306C0 24.1445 0.821906 24.9664 1.8358 24.9664H2.32731C2.57155 24.9664 2.80989 24.9043 3.03089 24.8002C3.20259 24.7194 3.39448 24.6743 3.59667 24.6743H4.63106C4.83325 24.6743 5.02514 24.7194 5.19684 24.8002C5.41779 24.9043 5.65617 24.9664 5.90042 24.9664H8.25128C8.49553 24.9664 8.73386 24.9043 8.95481 24.8002C9.12651 24.7194 9.3184 24.6743 9.52059 24.6743H10.5555C10.7577 24.6743 10.9496 24.7194 11.1213 24.8002C11.3423 24.9043 11.5806 24.9664 11.8249 24.9664H14.1752C14.4194 24.9664 14.6578 24.9043 14.8788 24.8002C15.0504 24.7194 15.2423 24.6743 15.4446 24.6743H16.4795C16.6817 24.6743 16.8735 24.7194 17.0452 24.8002C17.2662 24.9043 17.5046 24.9664 17.7488 24.9664H20.0997C20.3439 24.9664 20.5823 24.9043 20.8033 24.8002C20.9749 24.7194 21.1668 24.6743 21.369 24.6743H22.4034C22.6057 24.6743 22.7975 24.7194 22.9692 24.8002C23.1902 24.9043 23.4286 24.9664 23.6728 24.9664H24.1643C25.1782 24.9664 26.0001 24.1445 26.0001 23.1306V18.7852H0Z",
                            fill: "url(#paint40_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M15.2799 19.0487H10.7197C10.4905 19.0487 10.3047 18.8629 10.3047 18.6337C10.3047 18.4045 10.4905 18.2188 10.7197 18.2188H15.2799C15.5091 18.2188 15.6948 18.4046 15.6948 18.6337C15.6948 18.8629 15.5091 19.0487 15.2799 19.0487Z",
                            fill: "url(#paint41_linear_4332_1543)"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M14.2385 20.5487H11.7587C11.5295 20.5487 11.3438 20.3629 11.3438 20.1337C11.3438 19.9045 11.5296 19.7188 11.7587 19.7188H14.2385C14.4677 19.7188 14.6534 19.9046 14.6534 20.1337C14.6534 20.3629 14.4676 20.5487 14.2385 20.5487Z",
                            fill: "url(#paint42_linear_4332_1543)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint0_linear_4332_1543",
                            x1: "13.0014",
                            y1: "8.12049",
                            x2: "13.0014",
                            y2: "12.5081",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint1_linear_4332_1543",
                            x1: "6.32299",
                            y1: "9.27917",
                            x2: "4.58965",
                            y2: "9.27917",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#1F3596",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.4068",
                                    "stop-color": "#1D3290",
                                    "stop-opacity": "0.407"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.9508",
                                    "stop-color": "#192B7F",
                                    "stop-opacity": "0.951"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#192A7D"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint2_linear_4332_1543",
                            x1: "11.3843",
                            y1: "9.27917",
                            x2: "9.03923",
                            y2: "9.27917",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#1F3596",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.4068",
                                    "stop-color": "#1D3290",
                                    "stop-opacity": "0.407"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.9508",
                                    "stop-color": "#192B7F",
                                    "stop-opacity": "0.951"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#192A7D"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint3_linear_4332_1543",
                            x1: "1.09695",
                            y1: "13.26",
                            x2: "5.17757",
                            y2: "14.9356",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint4_linear_4332_1543",
                            x1: "19.8784",
                            y1: "12.9605",
                            x2: "25.2681",
                            y2: "15.1736",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint5_linear_4332_1543",
                            x1: "3.07683",
                            y1: "13.5936",
                            x2: "3.07683",
                            y2: "16.1107",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#1F3596",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.4068",
                                    "stop-color": "#1D3290",
                                    "stop-opacity": "0.407"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.9508",
                                    "stop-color": "#192B7F",
                                    "stop-opacity": "0.951"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#192A7D"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint6_linear_4332_1543",
                            x1: "22.9206",
                            y1: "13.5936",
                            x2: "22.9206",
                            y2: "16.1107",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#1F3596",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.4068",
                                    "stop-color": "#1D3290",
                                    "stop-opacity": "0.407"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.9508",
                                    "stop-color": "#192B7F",
                                    "stop-opacity": "0.951"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#192A7D"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint7_linear_4332_1543",
                            x1: "7.01533",
                            y1: "8.81061",
                            x2: "9.32743",
                            y2: "8.81061",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EAF9FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#B3DAFE"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint8_linear_4332_1543",
                            x1: "8.04815",
                            y1: "6.83419",
                            x2: "8.42729",
                            y2: "4.61346",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1128",
                                    "stop-color": "#A9D6FC",
                                    "stop-opacity": "0.113"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.3072",
                                    "stop-color": "#8DCAF4",
                                    "stop-opacity": "0.307"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5596",
                                    "stop-color": "#60B7E8",
                                    "stop-opacity": "0.56"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8571",
                                    "stop-color": "#229ED8",
                                    "stop-opacity": "0.857"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0290CF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint9_linear_4332_1543",
                            x1: "4.75264",
                            y1: "2.29637",
                            x2: "4.75264",
                            y2: "3.9118",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EAF9FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#B3DAFE"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint10_linear_4332_1543",
                            x1: "4.26646",
                            y1: "3.14659",
                            x2: "3.16088",
                            y2: "3.14659",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1128",
                                    "stop-color": "#A9D6FC",
                                    "stop-opacity": "0.113"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.3072",
                                    "stop-color": "#8DCAF4",
                                    "stop-opacity": "0.307"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5596",
                                    "stop-color": "#60B7E8",
                                    "stop-opacity": "0.56"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8571",
                                    "stop-color": "#229ED8",
                                    "stop-opacity": "0.857"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0290CF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint11_linear_4332_1543",
                            x1: "1.63721",
                            y1: "3.14426",
                            x2: "3.44333",
                            y2: "3.14426",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EAF9FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#B3DAFE"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint12_linear_4332_1543",
                            x1: "7.91299",
                            y1: "2.1703",
                            x2: "10.3142",
                            y2: "6.23261",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EAF9FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#B3DAFE"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint13_linear_4332_1543",
                            x1: "2.38316",
                            y1: "3.14421",
                            x2: "3.89867",
                            y2: "3.14417",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1128",
                                    "stop-color": "#A9D6FC",
                                    "stop-opacity": "0.113"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.3072",
                                    "stop-color": "#8DCAF4",
                                    "stop-opacity": "0.307"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5596",
                                    "stop-color": "#60B7E8",
                                    "stop-opacity": "0.56"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8571",
                                    "stop-color": "#229ED8",
                                    "stop-opacity": "0.857"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0290CF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint14_linear_4332_1543",
                            x1: "7.4281",
                            y1: "15.7166",
                            x2: "10.6623",
                            y2: "15.7166",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEE45A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FEA613"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint15_linear_4332_1543",
                            x1: "9.77775",
                            y1: "14.1967",
                            x2: "7.78951",
                            y2: "16.2359",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEA613",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E94444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint16_linear_4332_1543",
                            x1: "8.12265",
                            y1: "19.7044",
                            x2: "8.12268",
                            y2: "22.4308",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEA613",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#E94444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint17_linear_4332_1543",
                            x1: "9.62498",
                            y1: "15.6856",
                            x2: "11.2803",
                            y2: "15.6636",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint18_linear_4332_1543",
                            x1: "10.6731",
                            y1: "17.1445",
                            x2: "10.7037",
                            y2: "17.8344",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint19_linear_4332_1543",
                            x1: "10.6971",
                            y1: "15.3878",
                            x2: "10.7019",
                            y2: "16.2969",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint20_linear_4332_1543",
                            x1: "10.7055",
                            y1: "13.7357",
                            x2: "10.6709",
                            y2: "14.5467",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint21_linear_4332_1543",
                            x1: "5.40676",
                            y1: "15.6841",
                            x2: "6.68878",
                            y2: "15.6841",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint22_linear_4332_1543",
                            x1: "5.53209",
                            y1: "17.1875",
                            x2: "5.50151",
                            y2: "17.8775",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint23_linear_4332_1543",
                            x1: "5.51193",
                            y1: "15.4309",
                            x2: "5.50713",
                            y2: "16.3399",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint24_linear_4332_1543",
                            x1: "5.5037",
                            y1: "13.7787",
                            x2: "5.5383",
                            y2: "14.5898",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#5A5A5A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#444444"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint25_linear_4332_1543",
                            x1: "9.05941",
                            y1: "4.08972",
                            x2: "9.05941",
                            y2: "6.11469",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1128",
                                    "stop-color": "#A9D6FC",
                                    "stop-opacity": "0.113"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.3072",
                                    "stop-color": "#8DCAF4",
                                    "stop-opacity": "0.307"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5596",
                                    "stop-color": "#60B7E8",
                                    "stop-opacity": "0.56"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8571",
                                    "stop-color": "#229ED8",
                                    "stop-opacity": "0.857"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0290CF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint26_linear_4332_1543",
                            x1: "15.8663",
                            y1: "6.29429",
                            x2: "18.8763",
                            y2: "9.30427",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EAF9FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#B3DAFE"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint27_linear_4332_1543",
                            x1: "17.8396",
                            y1: "10.2369",
                            x2: "17.8396",
                            y2: "13.3978",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1128",
                                    "stop-color": "#A9D6FC",
                                    "stop-opacity": "0.113"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.3072",
                                    "stop-color": "#8DCAF4",
                                    "stop-opacity": "0.307"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5596",
                                    "stop-color": "#60B7E8",
                                    "stop-opacity": "0.56"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8571",
                                    "stop-color": "#229ED8",
                                    "stop-opacity": "0.857"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0290CF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint28_linear_4332_1543",
                            x1: "20.7769",
                            y1: "11.5356",
                            x2: "17.0986",
                            y2: "11.5356",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1128",
                                    "stop-color": "#A9D6FC",
                                    "stop-opacity": "0.113"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.3072",
                                    "stop-color": "#8DCAF4",
                                    "stop-opacity": "0.307"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5596",
                                    "stop-color": "#60B7E8",
                                    "stop-opacity": "0.56"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8571",
                                    "stop-color": "#229ED8",
                                    "stop-opacity": "0.857"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0290CF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint29_linear_4332_1543",
                            x1: "17.1241",
                            y1: "12.7932",
                            x2: "18.5799",
                            y2: "12.7932",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#EAF9FA"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#B3DAFE"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint30_linear_4332_1543",
                            x1: "17.8472",
                            y1: "12.9943",
                            x2: "17.8472",
                            y2: "14.4501",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#B3DAFE",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.1128",
                                    "stop-color": "#A9D6FC",
                                    "stop-opacity": "0.113"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.3072",
                                    "stop-color": "#8DCAF4",
                                    "stop-opacity": "0.307"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.5596",
                                    "stop-color": "#60B7E8",
                                    "stop-opacity": "0.56"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.8571",
                                    "stop-color": "#229ED8",
                                    "stop-opacity": "0.857"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#0290CF"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint31_linear_4332_1543",
                            x1: "16.5267",
                            y1: "17.8738",
                            x2: "19.7154",
                            y2: "17.8738",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FD4755"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#A72B2B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint32_linear_4332_1543",
                            x1: "17.8383",
                            y1: "14.8358",
                            x2: "17.8383",
                            y2: "15.9112",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#A72B2B",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#42210B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint33_linear_4332_1543",
                            x1: "17.847",
                            y1: "20.1302",
                            x2: "17.847",
                            y2: "22.0753",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#A72B2B",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#42210B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint34_linear_4332_1543",
                            x1: "11.1386",
                            y1: "15.2008",
                            x2: "15.6248",
                            y2: "27.64",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint35_linear_4332_1543",
                            x1: "13.0007",
                            y1: "21.9223",
                            x2: "13.0007",
                            y2: "14.5215",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint36_linear_4332_1543",
                            x1: "4.11392",
                            y1: "25.1979",
                            x2: "4.11392",
                            y2: "21.5126",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint37_linear_4332_1543",
                            x1: "10.0399",
                            y1: "25.1979",
                            x2: "10.0399",
                            y2: "21.5126",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint38_linear_4332_1543",
                            x1: "15.9618",
                            y1: "25.1979",
                            x2: "15.9618",
                            y2: "21.5126",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint39_linear_4332_1543",
                            x1: "21.8874",
                            y1: "25.1979",
                            x2: "21.8874",
                            y2: "21.5126",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#60B7FF"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#2740B0"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint40_linear_4332_1543",
                            x1: "13",
                            y1: "21.666",
                            x2: "13",
                            y2: "25.5408",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#1F3596",
                                    "stop-opacity": "0"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.4068",
                                    "stop-color": "#1D3290",
                                    "stop-opacity": "0.407"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "0.9508",
                                    "stop-color": "#192B7F",
                                    "stop-opacity": "0.951"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#192A7D"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint41_linear_4332_1543",
                            x1: "12.6849",
                            y1: "18.1389",
                            x2: "14.4692",
                            y2: "20.9428",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEE45A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FEA613"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                            id: "paint42_linear_4332_1543",
                            x1: "12.0039",
                            y1: "18.5707",
                            x2: "13.7883",
                            y2: "21.3746",
                            gradientUnits: "userSpaceOnUse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    "stop-color": "#FEE45A"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                    offset: "1",
                                    "stop-color": "#FEA613"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                            id: "clip0_4332_1543",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                width: "26",
                                height: "26",
                                fill: "white"
                            })
                        })
                    ]
                })
            ]
        })
    };
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [sectionAccordion, setSectionAccordion] = (0, $acw62.useState)('');
    let [questionAccordion, setQuestionAccordion] = (0, $acw62.useState)('');
    // let [deleteFile, setDeleteFile] = useState({ file: '', questionId: '', sectionIndex: '', questionIndex: '' });
    function getQuestionKeys(question) {
        let keys = [
            'qDescription'
        ]; // 'commentPoints', 'filePoints', 'completionScore'], //TODO: maybe use later
        if (question['questionType'].includes('F')) keys.push('templateFiles');
        if ([
            'esg',
            'software-development',
            'directors-questionnaire',
            'warranty-disclosure',
            'repository'
        ].includes(question['type'])) keys = keys.concat([
            'topTip',
            'toolboxOffer'
        ]);
        if ([
            'esg',
            'software-development',
            'business-audit-investment',
            'business-audit-growth',
            'business-audit-exit'
        ].includes(question['type'])) keys = keys.concat([
            'riskDescription',
            'recommendDescription'
        ]);
        else if (question['questionType'].includes('YN') && question['type'] != 'repository') keys = keys.concat([
            'ifYes',
            'riskIfYes',
            'ifNo',
            'riskIfNo'
        ]);
        if (question['questionType'].includes('1to5')) keys = keys.concat([
            'if1',
            'riskIf1',
            'if2',
            'riskIf2',
            'if3',
            'riskIf3',
            'if4',
            'riskIf4',
            'if5',
            'riskIf5'
        ]);
        if (question['questionType'].includes('D/ND')) keys = keys.concat([
            'ifD',
            'riskIfD',
            'ifNS',
            'riskIfNS',
            'ifND',
            'riskIfND'
        ]);
        return [
            ...keys
        ];
    }
    const saveQuestion = async (e, question, sectionIndex, questionIndex)=>{
        let attachment = [];
        if (e.target.files) for (const file of e.target.files)attachment.push(file);
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/question/update`, {
            attachment: attachment,
            questionId: question['_id'],
            [e.target.name]: e.target.value
        });
        if (!res || res['code'] != 200) return;
        if (res['code'] == '200') {
            sections[sectionIndex]['questions'][questionIndex] = res['body'];
            setQuestionAccordion('');
            setQuestionAccordion(question['qNo']);
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    const confirmDeleteFile = async (deleteFile)=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/repository/deleteTemplate', {
            file: deleteFile['file'],
            questionId: deleteFile['questionId']
        });
        if (!res || res['code'] != 200) return;
        if (res['code'] == '200') {
            sections[deleteFile['sectionIndex']]['questions'][deleteFile['questionIndex']] = res['body'];
            setQuestionAccordion('');
            setQuestionAccordion(res['body']['qNo']);
        }
        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "checklist-form-area df fww w100",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "checklist-form w100",
                    children: sections.length > 0 && sections.map((section, sectionIndex)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: sectionAccordion == section?.['sectionName'],
                            onChange: ()=>{
                                sectionAccordion == section['sectionName'] ? setSectionAccordion('') : setSectionAccordion(section?.['sectionName']);
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: [
                                            "Section ",
                                            sectionIndex + 1,
                                            ": ",
                                            section?.['sectionName']
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc jcsb",
                                        children: section?.['questions'].length > 0 && section['questions'].map((question, questionIndex)=>{
                                            let maxRisk = 5;
                                            let minRisk = -5;
                                            let questionKeys = getQuestionKeys(question);
                                            let riskKeys = questionKeys.filter((k)=>k.startsWith("riskIf"));
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                                                expanded: questionAccordion == question?.['qNo'],
                                                onChange: ()=>{
                                                    questionAccordion == question?.['qNo'] ? setQuestionAccordion('') : setQuestionAccordion(question?.['qNo']);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                                            className: "fw400",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "df aic w100 pr",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                        className: "pa c15 fw400",
                                                                        children: [
                                                                            "Ques ",
                                                                            questionIndex + 1,
                                                                            ":"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: `fw400 ml5rem ${question['qDescription'] ? ' c15' : ' c16'}`,
                                                                        children: question['qDescription'] || 'Your question shows here once added'
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "df fdc jcsb",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                className: "description-box df fww mt0-5rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pr mb1rem w100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                className: "w100 fw500 c15 df aic",
                                                                                for: "qDescription",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon pr mr0-5rem",
                                                                                        style: {
                                                                                            top: '4px'
                                                                                        },
                                                                                        children: svg['question']
                                                                                    }),
                                                                                    " Question No. ",
                                                                                    questionIndex + 1,
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                name: "qDescription",
                                                                                defaultValue: question?.['qDescription'],
                                                                                onBlur: (e)=>saveQuestion(e, question, sectionIndex, questionIndex),
                                                                                type: "text",
                                                                                placeholder: "Write question in your own words",
                                                                                className: "bss bw2px bo5 w100 br8px p1rem mt0-5rem"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pr mb1rem w100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                className: "w100 fw500 c15 df aic",
                                                                                for: "riskDescription",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon pr mr0-5rem",
                                                                                        style: {
                                                                                            top: '4px'
                                                                                        },
                                                                                        children: svg['risk']
                                                                                    }),
                                                                                    " Risk "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                defaultValue: question?.['riskDescription'],
                                                                                name: "riskDescription",
                                                                                onBlur: (e)=>saveQuestion(e, question, sectionIndex, questionIndex),
                                                                                type: "text",
                                                                                placeholder: "Explain risk if the answer is \u201CNo\u201D",
                                                                                className: "bss bw2px bo5 w100 br8px p1rem mt0-5rem"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pr mb1rem w100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                className: "w100 fw500 c15 df aic",
                                                                                for: "recommendDescription",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon pr mr0-5rem",
                                                                                        style: {
                                                                                            top: '4px'
                                                                                        },
                                                                                        children: svg['recommendation']
                                                                                    }),
                                                                                    " Recommendation "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                defaultValue: question?.['recommendDescription'],
                                                                                name: "recommendDescription",
                                                                                onBlur: (e)=>saveQuestion(e, question, sectionIndex, questionIndex),
                                                                                type: "text",
                                                                                placeholder: "Yes: Great! Nothing more to do at this time.",
                                                                                className: "bss bw2px bo5 w100 br8px p1rem mt0-5rem"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    checklistObj['riskScoring'] && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "pr mb1rem w100",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                    className: "heading-box df jcc fww",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                                                            className: "df aic c15 fs1rem w100 jcc",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                    className: "icon mr0-5rem pr",
                                                                                                    style: {
                                                                                                        top: '4px'
                                                                                                    },
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                        width: "18",
                                                                                                        height: "18",
                                                                                                        viewBox: "0 0 18 18",
                                                                                                        fill: "none",
                                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                                                                cx: "9",
                                                                                                                cy: "9",
                                                                                                                r: "9",
                                                                                                                transform: "matrix(1 0 0 -1 0 18)",
                                                                                                                fill: "#59B8FD"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M8.10282 7.34219C8.10751 7.03516 8.35829 6.78906 8.66532 6.78906C8.97236 6.78906 9.22314 7.0375 9.22782 7.34219L9.41532 12.3953C9.42704 12.5875 9.35673 12.775 9.22079 12.9203C9.07548 13.075 8.87392 13.1641 8.66532 13.1641C8.45673 13.1641 8.25517 13.075 8.10986 12.9203C7.97392 12.775 7.90361 12.5875 7.91532 12.3953L8.10282 7.34219Z",
                                                                                                                fill: "white"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M8.66406 4.16406C9.07828 4.16406 9.41406 4.49985 9.41406 4.91406C9.41406 5.32828 9.07828 5.66406 8.66406 5.66406C8.24985 5.66406 7.91406 5.32828 7.91406 4.91406C7.91406 4.49985 8.24985 4.16406 8.66406 4.16406Z",
                                                                                                                fill: "white"
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                }),
                                                                                                "Assign Risk Scores"
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                            className: "w100 fs0-75rem tac",
                                                                                            style: {
                                                                                                color: '#65656580'
                                                                                            },
                                                                                            children: "(Default if no action taken)"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df jcsb w100",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                                children: "Low Risk"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                                                children: "High Risk"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "checklistRiskSlider riskSlider bsbb pr w100 tac",
                                                                                        children: riskKeys.map((key, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                "data-id": key,
                                                                                                name: key,
                                                                                                onChange: (e)=>saveQuestion(e, question, sectionIndex, questionIndex),
                                                                                                type: "range",
                                                                                                className: key + " pen pa oyv l0 w100",
                                                                                                min: minRisk,
                                                                                                max: maxRisk,
                                                                                                defaultValue: question[key]
                                                                                            }, idx))
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "df jcsb w100 df jcsb w100 mt1-5rem",
                                                                                        children: Array(Math.abs(minRisk) + Math.abs(maxRisk) + 1).fill(1).map((j, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                className: "w1rem tac",
                                                                                                children: minRisk + i
                                                                                            }, i))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pr mb1rem w100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                className: "w100 fw500 c15 df aic",
                                                                                for: "topTip",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon pr mr0-5rem",
                                                                                        style: {
                                                                                            top: '4px'
                                                                                        },
                                                                                        children: svg['tool-tip']
                                                                                    }),
                                                                                    " Tool Tip ",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c16 fw400 ml0-5rem",
                                                                                        children: "(Optional)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                defaultValue: question?.['topTip'],
                                                                                name: "topTip",
                                                                                onBlur: (e)=>saveQuestion(e, question, sectionIndex, questionIndex),
                                                                                type: "text",
                                                                                placeholder: "Yes: Great! Nothing more to do at this time.",
                                                                                className: "bss bw2px bo5 w100 br8px p1rem mt0-5rem"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pr mb1rem w100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                className: "w100 fw500 c15 df aic",
                                                                                for: "toolboxOffer",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon pr mr0-5rem",
                                                                                        style: {
                                                                                            top: '4px'
                                                                                        },
                                                                                        children: svg['toolbox-offer']
                                                                                    }),
                                                                                    " Toolbox Offer ",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c16 fw400 ml0-5rem",
                                                                                        children: "(Optional)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                defaultValue: question?.['toolboxOffer'],
                                                                                name: "toolboxOffer",
                                                                                onBlur: (e)=>saveQuestion(e, question, sectionIndex, questionIndex),
                                                                                type: "text",
                                                                                placeholder: "Please provide toolbox offer for help.",
                                                                                className: "bss bw2px bo5 w100 br8px p1rem mt0-5rem"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "pr mb1rem w100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                className: "w100 fw500 c15 df aic",
                                                                                for: "templateFiles",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                        className: "icon pr mr0-5rem text-gradient fa fa-file-text",
                                                                                        style: {
                                                                                            fontSize: '22px'
                                                                                        }
                                                                                    }),
                                                                                    " Template Files ",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "c16 fw400 ml0-5rem",
                                                                                        children: "(Optional)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                for: "profile",
                                                                                className: "w100 bsbb bg5 br5px tac p1rem bsd bo3 bw2px cp pr upload-pic-area db mt0-5rem",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "pen fs1rem fw500 tac",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                            width: "70",
                                                                                            height: "70",
                                                                                            viewBox: "0 0 70 70",
                                                                                            fill: "none",
                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                    d: "M59.4632 31.0446C58.5439 25.1606 53.4429 20.6445 47.3047 20.6445C44.9955 20.6445 42.7766 21.2834 40.852 22.4751C37.924 17.5543 32.6528 14.4922 26.7969 14.4922C17.7506 14.4922 10.3906 21.8522 10.3906 30.8984C10.3906 30.9545 10.3906 31.0126 10.3927 31.0687C4.57871 32.048 0 37.1168 0 43.2031C0 49.9883 5.65619 55.5078 12.4414 55.5078H57.5586C64.3438 55.5078 70 49.9883 70 43.2031C70 37.0649 65.3472 31.9639 59.4632 31.0446Z",
                                                                                                    fill: "white"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                                    "clip-path": "url(#clip0_4332_1603)",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M35 56C42.732 56 49 49.732 49 42C49 34.268 42.732 28 35 28C27.268 28 21 34.268 21 42C21 49.732 27.268 56 35 56Z",
                                                                                                            fill: "#4A67FF"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M34.9857 49.6555C33.7421 49.6555 32.4987 49.6555 31.2554 49.6555C29.5503 49.6555 28.3198 48.4294 28.3111 46.7248C28.3078 46.1298 28.3078 45.5346 28.3111 44.9392C28.3143 44.3256 28.6862 43.9308 29.255 43.9297C29.8237 43.9286 30.2005 44.3207 30.2043 44.9338C30.2082 45.5468 30.2043 46.1456 30.2043 46.7516C30.2087 47.387 30.5822 47.7573 31.2199 47.7578C33.7388 47.7578 36.2575 47.7578 38.7761 47.7578C39.4143 47.7578 39.7883 47.387 39.7932 46.7521C39.7976 46.1462 39.7932 45.5402 39.7932 44.9343C39.7932 44.3284 40.1711 43.9286 40.7421 43.9297C41.313 43.9308 41.6904 44.3256 41.6854 44.9387C41.6794 45.7136 41.7226 46.4967 41.6253 47.2613C41.447 48.6602 40.2543 49.6478 38.8389 49.6544C37.5576 49.6582 36.2714 49.6555 34.9857 49.6555Z",
                                                                                                            fill: "white"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                            d: "M34.0538 37.6102C33.9094 37.7448 33.8247 37.8186 33.7459 37.8979C33.14 38.5098 32.5373 39.1256 31.9286 39.7354C31.4966 40.1685 30.8945 40.2002 30.504 39.8212C30.1136 39.4423 30.1289 38.8205 30.5538 38.3928C31.7908 37.1481 33.0319 35.9078 34.2769 34.6719C34.7144 34.2344 35.2865 34.2344 35.724 34.6719C36.9774 35.9151 38.2257 37.1636 39.469 38.4174C39.878 38.8303 39.8802 39.451 39.5001 39.8218C39.12 40.1926 38.5158 40.1762 38.0985 39.7622C37.4805 39.147 36.8718 38.5219 36.2583 37.9028C36.179 37.823 36.0942 37.7486 35.9679 37.6294C35.9597 37.8011 35.9498 37.9121 35.9498 38.0231C35.9498 39.9804 35.9525 41.9371 35.9498 43.8944C35.9498 44.6288 35.3034 45.0658 34.6313 44.8044C34.2594 44.6595 34.0576 44.3368 34.0576 43.8643C34.0554 41.9284 34.0554 39.9926 34.0576 38.057L34.0538 37.6102Z",
                                                                                                            fill: "white"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                        id: "clip0_4332_1603",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                            width: "28",
                                                                                                            height: "28",
                                                                                                            fill: "white",
                                                                                                            transform: "translate(21 28)"
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                            className: "",
                                                                                            id: "profile",
                                                                                            type: "file",
                                                                                            accept: "/*",
                                                                                            onChange: (e)=>saveQuestion(e, question, sectionIndex, questionIndex)
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                                        className: "c12 fw400 fsi fs0-75rem",
                                                                                        children: [
                                                                                            "If you have a template document or spreadsheet you want to offer the user who will complete the template, you can upload it ",
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                            " here. Upload or drag and drop (max 100MB)"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "df fww mt1rem",
                                                                                children: question['templateFiles'] && question['templateFiles'].map((file)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                        className: "df jcc aic br25px lh1 bg3 c1 px0-5rem fw600 mr0-5rem mb0-5rem",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                                                                className: "fw400 py0-5rem pl0-5rem",
                                                                                                target: "_blank",
                                                                                                to: file['location'],
                                                                                                children: file['originalname']
                                                                                            }, file['originalname'] + file['etag']),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                className: "fa fa-trash pl1rem pr0-5rem",
                                                                                                style: {
                                                                                                    "cursor": "pointer"
                                                                                                },
                                                                                                onClick: ()=>confirmDeleteFile({
                                                                                                        file: file,
                                                                                                        questionId: question['_id'],
                                                                                                        sectionIndex: sectionIndex,
                                                                                                        questionIndex: questionIndex
                                                                                                    })
                                                                                            })
                                                                                        ]
                                                                                    }))
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            });
                                        })
                                    })
                                })
                            ]
                        });
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bottom-btn-area df aic w100 jcsb mt2rem bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs1rem",
                        style: {
                            color: '#15131350'
                        },
                        children: "4/6 Question Creation"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>handleCreateChecklist(),
                        className: "shadow c1 bg4 bg3-hover cp fw400 fs1rem pr br38px w200px h3rem df aic jcc",
                        children: [
                            "Ok, next",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon pr ml0-5rem",
                                style: {
                                    top: '3px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");













function $fdcfc9d0c6aeefa0$export$2e2bcd8739ae039({ stepTab: stepTab, handleCreateChecklist: handleCreateChecklist, allCompaines: allCompaines, isAIChecklist: isAIChecklist, checklistObj: checklistObj, setChecklistObj: setChecklistObj, selectedCompany: selectedCompany }) {
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [isDisabled, setIsDisabled] = (0, $acw62.useState)(true);
    let [questionType, setQuestionType] = (0, $acw62.useState)();
    let [totalQuestions, setTotalQuestions] = (0, $acw62.useState)();
    let [isAllCompanies, setIsAllCompanies] = (0, $acw62.useState)(false);
    let [descriptionCount, setDescriptionCount] = (0, $acw62.useState)(0);
    let [accordion, setAccordion] = (0, $acw62.useState)('checklistDetail');
    let [isGenricBespoked, setIsGenricBespoked] = (0, $acw62.useState)(false);
    let [focusAreaCount, setFocusAreaCount] = (0, $acw62.useState)({
        focus1: 0,
        focus2: 0,
        focus3: 0
    });
    (0, $acw62.useEffect)(()=>{
        if (allCompaines.length > 0 && checklistObj?.['companies']) {
            if (!allCompaines.includes(({ _id: _id })=>checklistObj?.['companies']?.[_id])) setIsAllCompanies(true);
        }
        if (checklistObj?.['moduleDescription']) setDescriptionCount(checklistObj?.['moduleDescription'].length);
        checkBespoked();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!checklistObj['moduleDescription'] || !totalQuestions || !questionType || !Object.keys(checklistObj['companies']).length) setIsDisabled(true);
        else setIsDisabled(false);
    }, [
        checklistObj
    ]);
    (0, $acw62.useEffect)(()=>{
        if (checklistObj?.['step'] > stepTab) {
            setTotalQuestions(checklistObj['totalQuestions']);
            setQuestionType(checklistObj['questionType']);
            setIsDisabled(false);
        }
    }, [
        stepTab
    ]);
    const handleModuleDescription = (e)=>{
        if (e.target.value.length <= 500) {
            setChecklistObj({
                ...checklistObj,
                moduleDescription: e.target.value
            });
            setDescriptionCount(e.target.value.length);
        }
    };
    const handleAreaFocus = async (e)=>{
        if (e.target.value.length <= 200) {
            let focusArea = {
                ...checklistObj['focusArea'],
                [e.target.name]: e.target.value
            };
            setChecklistObj({
                ...checklistObj,
                focusArea: focusArea
            });
            focusAreaCount = {
                ...focusAreaCount,
                [e.target.name]: e.target.value.length
            };
            setFocusAreaCount(focusAreaCount);
        }
    };
    const selectAllCompanies = async ()=>{
        let companies = {};
        allCompaines.map((company)=>{
            companies = {
                ...companies,
                [company['_id']]: company['cName']
            };
        });
        setIsAllCompanies(false);
        setChecklistObj({
            ...checklistObj,
            companies: companies
        });
    };
    const selectSingleCompany = async (company)=>{
        if (checklistObj?.['companies'] && checklistObj?.['companies']?.[company['_id']]) {
            delete checklistObj['companies'][company['_id']];
            if (!Object.keys(checklistObj['companies']).length) setIsDisabled(true);
            console.log("...disabling");
            setChecklistObj(checklistObj);
        } else {
            let companies = {
                ...checklistObj['companies'],
                [company['_id']]: company['cName']
            };
            checklistObj = {
                ...checklistObj,
                companies: companies
            };
            setChecklistObj(checklistObj);
        }
        if (Object.keys(checklistObj?.['companies']).length == 1) {
            await checkBespoked();
            setIsGenricBespoked(true);
        } else {
            await checkBespoked();
            setIsGenricBespoked(false);
        }
    };
    const checkBespoked = ()=>{
        if (checklistObj?.['companies'] && Object.keys(checklistObj['companies']).length == 1) {
            setChecklistObj({
                ...checklistObj,
                bespoked: true
            });
            setIsGenricBespoked(true);
        } else {
            setChecklistObj({
                ...checklistObj,
                bespoked: false
            });
            setIsGenricBespoked(false);
        }
    };
    const handleNextStep = async ()=>{
        if (!checklistObj['moduleDescription']) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter checklist detail');
        else if (!checklistObj['companies'] || Object.keys(checklistObj['companies']).length == 0) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please select your checklist for?');
        else handleCreateChecklist();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "checklist-form-area df fww w100",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "checklist-form w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: accordion == 'checklistDetail',
                            onChange: ()=>{
                                accordion == 'checklistDetail' ? setAccordion('') : setAccordion('checklistDetail');
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: [
                                            "1. ",
                                            checklistObj['moduleName'] || 'Your',
                                            " checklist detail ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: isDisabled ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc jcsb",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "description-box df fww",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "left-box w60",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "pr",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                className: "c15 mb1rem db w100",
                                                                children: [
                                                                    "Description ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: isDisabled ? 'c40' : 'c34',
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                value: checklistObj['moduleDescription'] || '',
                                                                rows: "3",
                                                                style: {
                                                                    resize: 'none'
                                                                },
                                                                name: "moduleDescription",
                                                                className: "bss bw2px bo5 w100 br10px p1rem",
                                                                onChange: (e)=>handleModuleDescription(e),
                                                                placeholder: "Your checklist description should be concise but comprehensive \u2013\u200B this will appear as your checklist module description"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                className: `pa b0 r0 mb1rem mr1rem ${descriptionCount >= 499 ? 'c4' : 'c16'}`,
                                                                children: [
                                                                    descriptionCount,
                                                                    "/500"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "right-box w40 bsbb pr1rem pl4rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "tip-box w100 p2rem bg20 w100 bsbb",
                                                        style: {
                                                            marginTop: '-6px',
                                                            borderRadius: '40px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                                className: "c15 fs0-75rem df aic mb1rem",
                                                                style: {
                                                                    fontSize: '14px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "icon mr1rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "db w2rem",
                                                                            src: (parcelRequire("iBc1P")),
                                                                            alt: ""
                                                                        })
                                                                    }),
                                                                    "Example"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                                className: "c15 fs0-75rem",
                                                                style: {
                                                                    fontSize: '14px'
                                                                },
                                                                children: "Description:"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "c15 fs0-75rem",
                                                                style: {
                                                                    fontSize: '12px',
                                                                    color: '#15131380'
                                                                },
                                                                children: [
                                                                    "A checklist for the creation of a business plan for the set up of a chain of doggy daycare centers in the UK. The focus of the checklist should include",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    "1. Commercial considerations ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    "2. Regulatory requirements ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    "3. Financing requirements"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "db w80",
                                                                style: {
                                                                    marginTop: '-13px'
                                                                },
                                                                src: (parcelRequire("8SKvM")),
                                                                alt: ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                isAIChecklist && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "left-box w60 focus-area",
                                                        style: {
                                                            marginTop: '-130px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                                                className: "c15 fs1-2rem lh2 mb1rem",
                                                                children: [
                                                                    "b) Areas of focus ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        className: "fs1rem c15 fsi",
                                                                        style: {
                                                                            color: '#15131330'
                                                                        },
                                                                        children: "(optional)"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "fs1rem c15 mb1rem db w100 w100 ",
                                                                children: "To increase relevance\u200B you are welcome to add up to three areas of your specific focus"
                                                            }),
                                                            [
                                                                'first',
                                                                'second',
                                                                'third'
                                                            ].map((item, idx)=>{
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "pr mb-05rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "c15 mb1rem db w100",
                                                                            children: [
                                                                                "0",
                                                                                idx + 1,
                                                                                " - Area of focus"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                            value: checklistObj?.['focusArea']?.[`focus${idx + 1}`] || '',
                                                                            onChange: (e)=>handleAreaFocus(e),
                                                                            rows: "2",
                                                                            style: {
                                                                                resize: 'none'
                                                                            },
                                                                            name: `focus${idx + 1}`,
                                                                            className: "bss bw2px bo5 w100 br10px p1rem",
                                                                            placeholder: `Write your ${item} objective focus in your own words (up to 200 characters max)`
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                            className: `pa b0 r0 mb1rem mr1rem ${focusAreaCount[`focus${idx + 1}`] >= 199 ? 'c4' : 'c16'}`,
                                                                            children: [
                                                                                focusAreaCount[`focus${idx + 1}`],
                                                                                "/200"
                                                                            ]
                                                                        })
                                                                    ]
                                                                });
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: accordion == 'checklistFor',
                            onChange: ()=>{
                                accordion == 'checklistFor' ? setAccordion('') : setAccordion('checklistFor');
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: [
                                            "2. Who is your checklist for? ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: isDisabled ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df fdc jcsb",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "description-box df fww mt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "left-box w50",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "ml1rem mt1rem",
                                                            children: allCompaines.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                children: isAllCompanies && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "pr ml2rem nt0-5rem",
                                                                            style: {
                                                                                height: '20vh',
                                                                                overflow: 'auto'
                                                                            },
                                                                            children: [
                                                                                ...allCompaines
                                                                            ]?.sort((a, b)=>{
                                                                                const userRole = user?.role?.toLowerCase?.();
                                                                                const userCompanyId = user?.companyId?._id;
                                                                                const isUserCompanyA = [
                                                                                    'investor',
                                                                                    'advisor'
                                                                                ].includes(userRole) && userCompanyId === a?._id;
                                                                                const isUserCompanyB = [
                                                                                    'investor',
                                                                                    'advisor'
                                                                                ].includes(userRole) && userCompanyId === b?._id;
                                                                                if (isUserCompanyA && !isUserCompanyB) return -1;
                                                                                if (!isUserCompanyA && isUserCompanyB) return 1;
                                                                                const aHasService = a?.servicedBy !== null && a?.servicedBy !== undefined;
                                                                                const bHasService = b?.servicedBy !== null && b?.servicedBy !== undefined;
                                                                                if (!aHasService && bHasService) return -1;
                                                                                if (aHasService && !bHasService) return 1;
                                                                                return 0;
                                                                            })?.filter((company)=>company?.['subscription'] && company?.['subscription']?.toLowerCase() != 'free').map((company)=>{
                                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                    for: company['_id'],
                                                                                    className: `df cp py0-5rem ${company && company['group'] && company['group'] === 'Subsidiary' && company['parentId'] && allCompaines.map((item)=>item['_id']).includes(company['parentId']) && 'ml1-5rem'}`,
                                                                                    onClick: ()=>{
                                                                                        selectSingleCompany(company);
                                                                                        setChecklistObj({
                                                                                            ...checklistObj,
                                                                                            bespoked: Object.keys(checklistObj['companies']).length > 1 ? false : true
                                                                                        });
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "checkbox w2rem h2rem pr",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                defaultChecked: checklistObj?.['companies']?.[company['_id']],
                                                                                                id: company['_id'],
                                                                                                className: "new-shadow bg1 bo5 bw2px bss cp td250 w2rem h2rem br8px",
                                                                                                type: "checkbox"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                                            className: "w100 fs1rem lh3 ml1rem usn",
                                                                                            children: [
                                                                                                company?.cName,
                                                                                                ' ',
                                                                                                [
                                                                                                    'investor',
                                                                                                    'advisor'
                                                                                                ].includes(user?.role?.toLowerCase()) && user?.companyId?._id === company?._id ? '(my firm)' : ''
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "c15 op70 fs0-75rem my1rem",
                                                                            children: "You can choose specific users once the checklist is built"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "right-box w50 bsbb pr1rem pl4rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "tip-box w100 p2rem bg20 w100 bsbb",
                                                            style: {
                                                                marginTop: '-6px',
                                                                borderRadius: '40px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                                    className: "c15 fs0-75rem df aic mb1rem",
                                                                    style: {
                                                                        fontSize: '14px'
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                            className: "icon mr1rem",
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                className: "db w2rem",
                                                                                src: (parcelRequire("iBc1P")),
                                                                                alt: ""
                                                                            })
                                                                        }),
                                                                        "Top Tip"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                                    className: "ml1rem mx0-5rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "c15 fs0-75rem op60",
                                                                            children: [
                                                                                "If you are using AI to create a checklist for ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: " just one company,"
                                                                                }),
                                                                                " that checklist will be crafted ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: "  specifically for that company.\u200B"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "c15 fs0-75rem op60 mt1rem",
                                                                            children: [
                                                                                "If you choose ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: " more than one company,\u200B"
                                                                                }),
                                                                                " the checklist will be ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "fw600",
                                                                                    children: "more generic "
                                                                                }),
                                                                                "and less specific to any one company.\u200B\u200B"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fdc jcsb",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "description-box df fww",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "left-box w40",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "switch-area df aic w100",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "c15",
                                                                    children: "Generic"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {
                                                                    name: "genericBespoked",
                                                                    className: "success w100",
                                                                    checked: checklistObj['bespoked'],
                                                                    onChange: (e)=>setChecklistObj({
                                                                            ...checklistObj,
                                                                            bespoked: e.target.checked
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                    className: "c15",
                                                                    children: "Company specific (AI supported)"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: accordion == 'totalQuestions',
                            onChange: ()=>{
                                accordion == 'totalQuestions' ? setAccordion('') : setAccordion('totalQuestions');
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: [
                                            "3. Specify number of questions ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: isDisabled ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "description-box df fww",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df w100 my1rem",
                                                children: [
                                                    20,
                                                    50,
                                                    100
                                                ].map((item, idx)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "pr objective-area w80px mr0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr mb1rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "radio",
                                                                    value: item,
                                                                    className: "cp pr",
                                                                    id: `totalQuestions${idx}`,
                                                                    name: `total-questions-${idx}`,
                                                                    style: {
                                                                        height: '19px',
                                                                        width: '19px',
                                                                        top: '4px'
                                                                    },
                                                                    checked: totalQuestions == item,
                                                                    onChange: (e)=>{
                                                                        setTotalQuestions(e.target.value), setChecklistObj({
                                                                            ...checklistObj,
                                                                            totalQuestions: e.target.value
                                                                        });
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    className: "fw400 fs1-125rem ml1rem c15",
                                                                    for: `totalQuestions${idx}`,
                                                                    style: {
                                                                        lineHeight: '22.39px'
                                                                    },
                                                                    children: item
                                                                })
                                                            ]
                                                        })
                                                    });
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                className: "c15 fs1rem df aic mb1rem fw400 w100",
                                                children: "There will always be 10 sections\u200B"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: accordion == 'questionnaireStyle',
                            onChange: ()=>{
                                accordion == 'questionnaireStyle' ? setAccordion('') : setAccordion('questionnaireStyle');
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: [
                                            "4. Questionnaire Style ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: isDisabled ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "description-box df fww",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                className: "c15 fs1rem df aic mb1rem fw400 w100",
                                                children: "Choose your style of questionnaire"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df w100",
                                                children: [
                                                    'Objective',
                                                    'Quantitative',
                                                    'Subjective'
                                                ].map((item)=>{
                                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: `pr objective-area w25 mr2rem cp ${item != 'Objective' && ' op50 cna'}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "pr mb1rem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                            id: item,
                                                                            type: "radio",
                                                                            className: "pr",
                                                                            checked: questionType == item,
                                                                            style: {
                                                                                height: '19px',
                                                                                width: '19px',
                                                                                top: '4px'
                                                                            },
                                                                            onChange: (e)=>{
                                                                                if (item == 'Objective') setQuestionType(item), setChecklistObj({
                                                                                    ...checklistObj,
                                                                                    questionType: item
                                                                                });
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                            className: "fw400 fs1-125rem ml1rem c15",
                                                                            for: item,
                                                                            style: {
                                                                                lineHeight: '22.39px'
                                                                            },
                                                                            children: [
                                                                                item,
                                                                                " ",
                                                                                item != 'Objective' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c16 fs1rem",
                                                                                    children: "(coming soon)"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "bo3 bw1px bss bsbb p2rem br20px",
                                                                    style: {
                                                                        backgroundColor: '#F6F7FE',
                                                                        minHeight: '345px'
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: "objective-box",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                                className: "fw400 fs1rem mb1rem",
                                                                                children: "01- Question"
                                                                            }),
                                                                            item == 'Objective' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "checkbox-area df jcsb aic",
                                                                                        children: [
                                                                                            'Yes',
                                                                                            'No',
                                                                                            'N/A'
                                                                                        ].map((item)=>{
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                                for: item,
                                                                                                className: "py0-5rem df cp mr1rem",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "checkbox w2rem h2rem pr",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                            disabled: true,
                                                                                                            id: item,
                                                                                                            className: "new-shadow bg1 bo5 bw2px bss cp td250 w2rem h2rem br8px",
                                                                                                            type: "checkbox"
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "w100 fs1rem lh3 ml1rem usn",
                                                                                                        children: item
                                                                                                    })
                                                                                                ]
                                                                                            });
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                                        className: "list-fit mt1rem",
                                                                                        children: [
                                                                                            'Quick and easy (companies more likely to complete)',
                                                                                            'Good for risk scoring',
                                                                                            'Will build up a less in depth picture',
                                                                                            'Risk/recommendations including Checklist Report'
                                                                                        ].map((item)=>{
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                                className: "df aic fs0-75rem mb0-5rem",
                                                                                                children: [
                                                                                                    item == 'Will build up a less in depth picture' ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "icon mr1rem",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                            width: "18",
                                                                                                            height: "18",
                                                                                                            viewBox: "0 0 18 18",
                                                                                                            fill: "none",
                                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M2.02395 15.143C2.56575 13.7876 4.22715 11.336 6.03795 8.89156C4.32975 6.93316 2.77995 5.14936 2.37675 4.64536C1.56315 3.62836 1.61895 3.19276 3.14355 3.18556C4.23615 3.18016 4.61415 3.04876 5.33775 3.80656C5.76255 4.25116 6.67695 5.34016 7.72815 6.66676C9.40935 4.49956 10.9664 2.63116 11.6216 1.94356C12.5576 0.962556 13.0472 1.13356 14.462 1.14076C16.4348 1.15156 16.5086 1.71496 15.4538 3.03076C14.867 3.76516 12.4028 6.59476 9.87915 9.48556C11.1842 11.2658 12.3506 13.0082 12.7448 13.9964C13.2668 15.3032 12.1058 15.8738 11.1176 14.7218C10.574 14.0864 9.46695 12.8192 8.21595 11.3864C6.46275 13.3934 4.88235 15.2042 4.12995 16.0826C2.85195 17.573 1.34715 16.835 2.02395 15.143Z",
                                                                                                                fill: "#ED1C24"
                                                                                                            })
                                                                                                        })
                                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "icon mr1rem",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                            width: "18",
                                                                                                            height: "18",
                                                                                                            viewBox: "0 0 18 18",
                                                                                                            fill: "none",
                                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                                                    "clip-path": "url(#clip0_4428_3023)",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M7.14602 10.8459C7.05212 10.9467 6.90152 10.9698 6.78122 10.9035L1.31882 7.88012C1.23662 7.83452 1.15712 7.81532 1.08332 7.81532C0.936616 7.81532 0.812416 7.89092 0.730816 7.98392C0.607816 8.12402 0.527116 8.37272 0.704416 8.61272L6.95792 17.0742C7.12172 17.2956 7.37312 17.4141 7.64192 17.3985C7.91402 17.3829 8.14982 17.2368 8.28812 16.9971L17.3253 1.35422C17.4909 1.06772 17.3568 0.823519 17.1921 0.701419C17.0277 0.579919 16.7754 0.531619 16.5609 0.761119L7.14602 10.8459Z",
                                                                                                                        fill: "url(#paint0_linear_4428_3023)"
                                                                                                                    })
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                                                    children: [
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                                            id: "paint0_linear_4428_3023",
                                                                                                                            x1: "9.00152",
                                                                                                                            y1: "17.3999",
                                                                                                                            x2: "9.00152",
                                                                                                                            y2: "0.598097",
                                                                                                                            gradientUnits: "userSpaceOnUse",
                                                                                                                            children: [
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    "stop-color": "#00E54E"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "0.18",
                                                                                                                                    "stop-color": "#00E54E"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "0.73",
                                                                                                                                    "stop-color": "#15D757"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "1",
                                                                                                                                    "stop-color": "#04C747"
                                                                                                                                })
                                                                                                                            ]
                                                                                                                        }),
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                                            id: "clip0_4428_3023",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                                                width: "18",
                                                                                                                                height: "18",
                                                                                                                                fill: "white"
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    }),
                                                                                                    item
                                                                                                ]
                                                                                            });
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            item == 'Quantitative' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "checkbox-area df jcsb aic",
                                                                                        children: [
                                                                                            '1',
                                                                                            '2',
                                                                                            '3',
                                                                                            '4',
                                                                                            '5'
                                                                                        ].map((item)=>{
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                                                for: item,
                                                                                                className: "py0-5rem df fdc cp mr1rem",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "w100 fs1rem lh3 usn tac mb0-5rem",
                                                                                                        children: item
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                                        className: "checkbox w2rem h2rem pr",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                                                            disabled: true,
                                                                                                            id: item,
                                                                                                            className: "new-shadow bg1 bo5 bw2px bss cp td250 w2rem h2rem br8px",
                                                                                                            type: "checkbox"
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            });
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                        className: "df jcsb aic w100",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "fs0-75rem c40",
                                                                                                children: "Poor"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                                className: "fs0-75rem c34",
                                                                                                children: "Excellent"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                                        className: "list-fit mt1rem",
                                                                                        children: [
                                                                                            'Richer than yes/no',
                                                                                            'Good for risk scoring (but capable of over-optimism)',
                                                                                            'Will build up a less in depth picture',
                                                                                            'Risk/recommendations including Checklist Report'
                                                                                        ].map((item)=>{
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                                className: "df aic fs0-75rem mb0-5rem",
                                                                                                children: [
                                                                                                    item == 'Will build up a less in depth picture' ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "icon mr1rem",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                            width: "18",
                                                                                                            height: "18",
                                                                                                            viewBox: "0 0 18 18",
                                                                                                            fill: "none",
                                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M2.02395 15.143C2.56575 13.7876 4.22715 11.336 6.03795 8.89156C4.32975 6.93316 2.77995 5.14936 2.37675 4.64536C1.56315 3.62836 1.61895 3.19276 3.14355 3.18556C4.23615 3.18016 4.61415 3.04876 5.33775 3.80656C5.76255 4.25116 6.67695 5.34016 7.72815 6.66676C9.40935 4.49956 10.9664 2.63116 11.6216 1.94356C12.5576 0.962556 13.0472 1.13356 14.462 1.14076C16.4348 1.15156 16.5086 1.71496 15.4538 3.03076C14.867 3.76516 12.4028 6.59476 9.87915 9.48556C11.1842 11.2658 12.3506 13.0082 12.7448 13.9964C13.2668 15.3032 12.1058 15.8738 11.1176 14.7218C10.574 14.0864 9.46695 12.8192 8.21595 11.3864C6.46275 13.3934 4.88235 15.2042 4.12995 16.0826C2.85195 17.573 1.34715 16.835 2.02395 15.143Z",
                                                                                                                fill: "#ED1C24"
                                                                                                            })
                                                                                                        })
                                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "icon mr1rem",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                            width: "18",
                                                                                                            height: "18",
                                                                                                            viewBox: "0 0 18 18",
                                                                                                            fill: "none",
                                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                                                    "clip-path": "url(#clip0_4428_3023)",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M7.14602 10.8459C7.05212 10.9467 6.90152 10.9698 6.78122 10.9035L1.31882 7.88012C1.23662 7.83452 1.15712 7.81532 1.08332 7.81532C0.936616 7.81532 0.812416 7.89092 0.730816 7.98392C0.607816 8.12402 0.527116 8.37272 0.704416 8.61272L6.95792 17.0742C7.12172 17.2956 7.37312 17.4141 7.64192 17.3985C7.91402 17.3829 8.14982 17.2368 8.28812 16.9971L17.3253 1.35422C17.4909 1.06772 17.3568 0.823519 17.1921 0.701419C17.0277 0.579919 16.7754 0.531619 16.5609 0.761119L7.14602 10.8459Z",
                                                                                                                        fill: "url(#paint0_linear_4428_3023)"
                                                                                                                    })
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                                                    children: [
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                                            id: "paint0_linear_4428_3023",
                                                                                                                            x1: "9.00152",
                                                                                                                            y1: "17.3999",
                                                                                                                            x2: "9.00152",
                                                                                                                            y2: "0.598097",
                                                                                                                            gradientUnits: "userSpaceOnUse",
                                                                                                                            children: [
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    "stop-color": "#00E54E"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "0.18",
                                                                                                                                    "stop-color": "#00E54E"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "0.73",
                                                                                                                                    "stop-color": "#15D757"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "1",
                                                                                                                                    "stop-color": "#04C747"
                                                                                                                                })
                                                                                                                            ]
                                                                                                                        }),
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                                            id: "clip0_4428_3023",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                                                width: "18",
                                                                                                                                height: "18",
                                                                                                                                fill: "white"
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    }),
                                                                                                    item
                                                                                                ]
                                                                                            });
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            item == 'Subjective' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                        className: "pr mt1rem",
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                                                                            disabled: true,
                                                                                            type: "text",
                                                                                            style: {
                                                                                                resize: 'none'
                                                                                            },
                                                                                            placeholder: "Enter your answer here 200 characters max",
                                                                                            className: "bg1 bss bw2px bo5 w100 br20px p1rem"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                                                                        className: "list-fit mt1rem",
                                                                                        children: [
                                                                                            'Good for in depth analysis',
                                                                                            'Time-consuming for company',
                                                                                            'Risk scoring not accurate',
                                                                                            'Risk/recommendations including Checklist Report'
                                                                                        ].map((item)=>{
                                                                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                                                className: "df aic fs0-75rem mb0-5rem",
                                                                                                children: [
                                                                                                    item == 'Time-consuming for company' || item == 'Risk scoring not accurate' ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "icon mr1rem",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                                            width: "18",
                                                                                                            height: "18",
                                                                                                            viewBox: "0 0 18 18",
                                                                                                            fill: "none",
                                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                d: "M2.02395 15.143C2.56575 13.7876 4.22715 11.336 6.03795 8.89156C4.32975 6.93316 2.77995 5.14936 2.37675 4.64536C1.56315 3.62836 1.61895 3.19276 3.14355 3.18556C4.23615 3.18016 4.61415 3.04876 5.33775 3.80656C5.76255 4.25116 6.67695 5.34016 7.72815 6.66676C9.40935 4.49956 10.9664 2.63116 11.6216 1.94356C12.5576 0.962556 13.0472 1.13356 14.462 1.14076C16.4348 1.15156 16.5086 1.71496 15.4538 3.03076C14.867 3.76516 12.4028 6.59476 9.87915 9.48556C11.1842 11.2658 12.3506 13.0082 12.7448 13.9964C13.2668 15.3032 12.1058 15.8738 11.1176 14.7218C10.574 14.0864 9.46695 12.8192 8.21595 11.3864C6.46275 13.3934 4.88235 15.2042 4.12995 16.0826C2.85195 17.573 1.34715 16.835 2.02395 15.143Z",
                                                                                                                fill: "#ED1C24"
                                                                                                            })
                                                                                                        })
                                                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                                        className: "icon mr1rem",
                                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                                            width: "18",
                                                                                                            height: "18",
                                                                                                            viewBox: "0 0 18 18",
                                                                                                            fill: "none",
                                                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                                                    "clip-path": "url(#clip0_4428_3023)",
                                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                                        d: "M7.14602 10.8459C7.05212 10.9467 6.90152 10.9698 6.78122 10.9035L1.31882 7.88012C1.23662 7.83452 1.15712 7.81532 1.08332 7.81532C0.936616 7.81532 0.812416 7.89092 0.730816 7.98392C0.607816 8.12402 0.527116 8.37272 0.704416 8.61272L6.95792 17.0742C7.12172 17.2956 7.37312 17.4141 7.64192 17.3985C7.91402 17.3829 8.14982 17.2368 8.28812 16.9971L17.3253 1.35422C17.4909 1.06772 17.3568 0.823519 17.1921 0.701419C17.0277 0.579919 16.7754 0.531619 16.5609 0.761119L7.14602 10.8459Z",
                                                                                                                        fill: "url(#paint0_linear_4428_3023)"
                                                                                                                    })
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                                                    children: [
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                                            id: "paint0_linear_4428_3023",
                                                                                                                            x1: "9.00152",
                                                                                                                            y1: "17.3999",
                                                                                                                            x2: "9.00152",
                                                                                                                            y2: "0.598097",
                                                                                                                            gradientUnits: "userSpaceOnUse",
                                                                                                                            children: [
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    "stop-color": "#00E54E"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "0.18",
                                                                                                                                    "stop-color": "#00E54E"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "0.73",
                                                                                                                                    "stop-color": "#15D757"
                                                                                                                                }),
                                                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                                                    offset: "1",
                                                                                                                                    "stop-color": "#04C747"
                                                                                                                                })
                                                                                                                            ]
                                                                                                                        }),
                                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                                            id: "clip0_4428_3023",
                                                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                                                width: "18",
                                                                                                                                height: "18",
                                                                                                                                fill: "white"
                                                                                                                            })
                                                                                                                        })
                                                                                                                    ]
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    }),
                                                                                                    item
                                                                                                ]
                                                                                            });
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    });
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
                            expanded: accordion == 'riskScoring',
                            onChange: ()=>{
                                accordion == 'riskScoring' ? setAccordion('') : setAccordion('riskScoring');
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                                    expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {}),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                        className: "fw500",
                                        children: "5. Include risk scoring?"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df fdc jcsb",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "description-box df fww mt0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "left-box w50",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    id: "Include",
                                                                    name: "include",
                                                                    style: {
                                                                        height: '19px',
                                                                        width: '19px',
                                                                        top: '4px'
                                                                    },
                                                                    type: "radio",
                                                                    className: "cp pr",
                                                                    checked: checklistObj['riskScoring'],
                                                                    onChange: ()=>setChecklistObj({
                                                                            ...checklistObj,
                                                                            riskScoring: true
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                                    className: "fw400 fs1-125rem ml1rem c15",
                                                                    for: "Include",
                                                                    style: {
                                                                        lineHeight: '22.39px'
                                                                    },
                                                                    children: "Include \u200B"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pr mt1rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    id: "NotInclude",
                                                                    name: "not-include",
                                                                    style: {
                                                                        height: '19px',
                                                                        width: '19px',
                                                                        top: '4px'
                                                                    },
                                                                    type: "radio",
                                                                    className: "cp pr",
                                                                    checked: !checklistObj['riskScoring'],
                                                                    onChange: ()=>setChecklistObj({
                                                                            ...checklistObj,
                                                                            riskScoring: false
                                                                        })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                                    className: "fw400 fs1-125rem ml1rem c15 fw500",
                                                                    for: "NotInclude",
                                                                    style: {
                                                                        lineHeight: '22.39px'
                                                                    },
                                                                    children: [
                                                                        "Do ",
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                            className: "c4",
                                                                            children: "NOT"
                                                                        }),
                                                                        " include\u200B "
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "right-box w50 bsbb pr1rem pl4rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "tip-box w100 p2rem bg20 w100 bsbb",
                                                        style: {
                                                            marginTop: '-6px',
                                                            borderRadius: '40px'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                                                className: "c15 fs0-75rem df aic",
                                                                style: {
                                                                    fontSize: '14px'
                                                                },
                                                                children: "Example"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "db mb1rem",
                                                                src: (parcelRequire("9BNWP")),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                                className: "c15 fs0-75rem df aic mb1rem",
                                                                style: {
                                                                    fontSize: '14px'
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                        className: "icon mr1rem",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                            className: "db w2rem",
                                                                            src: (parcelRequire("iBc1P")),
                                                                            alt: ""
                                                                        })
                                                                    }),
                                                                    "Top Tip"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                                className: "list-fit mt1rem",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        className: "df aic fs0-75rem mb0-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                className: "icon mr1rem",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                                    width: "18",
                                                                                    height: "18",
                                                                                    viewBox: "0 0 18 18",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                                                                            "clip-path": "url(#clip0_4428_3023)",
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                                d: "M7.14602 10.8459C7.05212 10.9467 6.90152 10.9698 6.78122 10.9035L1.31882 7.88012C1.23662 7.83452 1.15712 7.81532 1.08332 7.81532C0.936616 7.81532 0.812416 7.89092 0.730816 7.98392C0.607816 8.12402 0.527116 8.37272 0.704416 8.61272L6.95792 17.0742C7.12172 17.2956 7.37312 17.4141 7.64192 17.3985C7.91402 17.3829 8.14982 17.2368 8.28812 16.9971L17.3253 1.35422C17.4909 1.06772 17.3568 0.823519 17.1921 0.701419C17.0277 0.579919 16.7754 0.531619 16.5609 0.761119L7.14602 10.8459Z",
                                                                                                fill: "url(#paint0_linear_4428_3023)"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                                                                                    id: "paint0_linear_4428_3023",
                                                                                                    x1: "9.00152",
                                                                                                    y1: "17.3999",
                                                                                                    x2: "9.00152",
                                                                                                    y2: "0.598097",
                                                                                                    gradientUnits: "userSpaceOnUse",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                            "stop-color": "#00E54E"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                            offset: "0.18",
                                                                                                            "stop-color": "#00E54E"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                            offset: "0.73",
                                                                                                            "stop-color": "#15D757"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                                                                            offset: "1",
                                                                                                            "stop-color": "#04C747"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                                    id: "clip0_4428_3023",
                                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                                        width: "18",
                                                                                                        height: "18",
                                                                                                        fill: "white"
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            "Risk scoring is good for checklists involving: questions\u200B designed to assess risk e.g. \u201CDo you have any legal disputes outstanding?\u201D"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                                        className: "df aic fs0-75rem mb0-5rem",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                                className: "icon mr1rem",
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                                    width: "18",
                                                                                    height: "18",
                                                                                    viewBox: "0 0 18 18",
                                                                                    fill: "none",
                                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M2.02395 15.143C2.56575 13.7876 4.22715 11.336 6.03795 8.89156C4.32975 6.93316 2.77995 5.14936 2.37675 4.64536C1.56315 3.62836 1.61895 3.19276 3.14355 3.18556C4.23615 3.18016 4.61415 3.04876 5.33775 3.80656C5.76255 4.25116 6.67695 5.34016 7.72815 6.66676C9.40935 4.49956 10.9664 2.63116 11.6216 1.94356C12.5576 0.962556 13.0472 1.13356 14.462 1.14076C16.4348 1.15156 16.5086 1.71496 15.4538 3.03076C14.867 3.76516 12.4028 6.59476 9.87915 9.48556C11.1842 11.2658 12.3506 13.0082 12.7448 13.9964C13.2668 15.3032 12.1058 15.8738 11.1176 14.7218C10.574 14.0864 9.46695 12.8192 8.21595 11.3864C6.46275 13.3934 4.88235 15.2042 4.12995 16.0826C2.85195 17.573 1.34715 16.835 2.02395 15.143Z",
                                                                                        fill: "#ED1C24"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            "Risk scoring is less effective for internal checklists designed\u200B to track workflow process  e.g. \u201CHave you reviewed\u200B the business plan?\u201D"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bottom-btn-area df aic w100 jcsb mt2rem bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "c15 fs1rem",
                        style: {
                            color: '#15131350'
                        },
                        children: [
                            "2/6 Choose Checklist Features ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem",
                                children: "( * = fields requiring mandatory completion)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        disabled: isDisabled,
                        onClick: ()=>handleNextStep(),
                        className: `shadow c1 fw400 fs1rem pr br38px w200px h3rem df aic jcc ${isDisabled ? ' bg16 cna' : ' bg4 bg3-hover cp'}`,
                        children: [
                            "Ok, next",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon pr ml0-5rem",
                                style: {
                                    top: '3px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $45fvw = parcelRequire("45fvw");



var $acw62 = parcelRequire("acw62");








function $880908b40fd15380$export$2e2bcd8739ae039({ checklistObj: checklistObj, setChecklistObj: setChecklistObj, handleCreateChecklist: handleCreateChecklist }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let [companyId, setCompanyId] = (0, $acw62.useState)();
    let [deleteModuleName, setDeleteModuleName] = (0, $acw62.useState)('');
    let [isActive, setIsActive] = (0, $acw62.useState)(checklistObj['isActive']);
    (0, $acw62.useEffect)(()=>{
        if (location?.search) companyId = location.search.split('=')[1].split(';')[0];
        if (companyId) setCompanyId(companyId);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (checklistObj['isActive'] != isActive) handleCreateChecklist();
    }, [
        checklistObj
    ]);
    const handleActivationChecklist = async ()=>{
        await setChecklistObj({
            ...checklistObj,
            isActive: !isActive
        });
        await setIsActive(!isActive);
    };
    const deleteModule = async (moduleName)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/repository/deleteModule`, {
            moduleName: moduleName
        });
        if (res?.['code'] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            if (companyId) {
                if ((user['role'] == 'Advisor' || user['role'] == 'Investor') && companyId == user['companyId']['_id']) {
                    localStorage.setItem('isAnylistBuilder', true);
                    window.location.href = `/advisor-dashboard`;
                } else {
                    const isFromNewUrl = localStorage.getItem('checklistCreatedFromNewUrl') === '1';
                    localStorage.removeItem('checklistCreatedFromNewUrl');
                    window.location.href = `/company/${companyId}`;
                }
            }
        }
    };
    const handleGoToChecklist = ()=>{
        if (companyId) {
            const isFromNewUrl = localStorage.getItem('checklistCreatedFromNewUrl') === '1';
            localStorage.removeItem('checklistCreatedFromNewUrl');
            let redirect = true;
            if ((user['role'] == 'Advisor' || user['role'] == 'Investor') && Object.keys(checklistObj['companies']).length == 1) {
                if (checklistObj['companies'][companyId]) redirect = false;
                else redirect = true;
            }
            if ((user['role'] == 'Advisor' || user['role'] == 'Investor') && companyId == user['companyId']['_id'] && redirect) {
                localStorage.setItem('isAnylistBuilder', true);
                window.location.href = `/${user['role'].toLowerCase()}-dashboard`;
            } else {
                localStorage.setItem('isAnylistTab', true);
                window.location.href = `/company/${companyId}`;
            }
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "checklist-form-area df fww w100 mb5rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-form w50",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mt2rem w100 keyfeature-box keyfeature-box-core df fww keyfeature-box-two keyfeature-box-anylist pr bsbb",
                                style: {
                                    border: 'none',
                                    backgroundColor: 'transparent'
                                },
                                children: [
                                    isActive ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w100 df aic mb1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "db mr1rem",
                                                src: (parcelRequire("bP0qH")),
                                                alt: ""
                                            }),
                                            "Activated!"
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        className: "fs1-25rem c15 w100 fw400 mb1rem",
                                        children: "Activate your checklist to add to your dashboard"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "cp w50 keyfeature-wihte-item bg1 br15px p2rem zi9 pr bsbb",
                                        style: {
                                            width: '51%',
                                            border: '1px solid #B5BFDE'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "df fw500 fs1-25rem c15 aic",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic pr w100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon-diligenstia mr1rem pr",
                                                            children: checklistObj?.['imageURL'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "br10px w50px h50px",
                                                                src: checklistObj?.['imageURL'],
                                                                alt: "logo image"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "fs1rem fw500 c15 lh2 title-box-feature w70",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                    className: "db ttc",
                                                                    style: {
                                                                        color: '#15131350',
                                                                        fontSize: '9px'
                                                                    },
                                                                    children: checklistObj?.['genType'] == 'automatic' ? 'AI-generated' : 'Manually-generated'
                                                                }),
                                                                checklistObj?.['moduleName']
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "df mt2rem jcsb bottom-details w100 aic pr",
                                                style: {
                                                    top: '17px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "df mb1rem w70",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "fs1rem fw400 c15 lh2",
                                                            children: [
                                                                "Creator: ",
                                                                checklistObj?.['createdBy']?.['firstName'],
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(checklistObj['createdAt']).format('DD/MMM/YY')
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                        style: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: isActive,
                                                                onChange: handleActivationChecklist,
                                                                style: {
                                                                    display: 'none'
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "pr br50px",
                                                                style: {
                                                                    width: '40px',
                                                                    height: '20px',
                                                                    background: isActive ? '#008000' : '#F44336',
                                                                    transition: 'background-color 0.3s ease',
                                                                    position: 'relative',
                                                                    borderRadius: '50px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    style: {
                                                                        position: 'absolute',
                                                                        top: '2px',
                                                                        left: isActive ? '22px' : '2px',
                                                                        width: '16px',
                                                                        height: '16px',
                                                                        backgroundColor: '#fff',
                                                                        borderRadius: '50%',
                                                                        transition: 'left 0.3s ease'
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                style: {
                                                                    marginLeft: '8px',
                                                                    fontSize: '14px',
                                                                    color: isActive ? '#008000' : '#F44336'
                                                                },
                                                                children: isActive ? 'Activated' : 'Deactivated'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "remove-edit-araa",
                                children: checklistObj?.['createdBy']?.['_id'] == user?.['_id'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    onClick: ()=>{
                                        setDeleteModuleName(checklistObj?.['moduleName']);
                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: 'confirmDeleteModule'
                                        }));
                                    },
                                    className: "edit-remove bg1 df aic mt2rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "fa fa-trash pr0-5rem c4 cp",
                                            style: {
                                                fontSize: '20px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs0-75rem mr1rem c43 cp",
                                            children: "Permanently delete this AnyList Checklist"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "selection-area-right w50 mt1rem pl5rem bsbb",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "manual-ai-area w100 pr fww jcfe",
                            children: isActive ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tip-box p2rem bg20 w50",
                                style: {
                                    borderRadius: '40px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                        className: "c15 fs0-75rem df aic mb1rem",
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon mr1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "db w2rem",
                                                    src: (parcelRequire("h2aya")),
                                                    alt: ""
                                                })
                                            }),
                                            "Pawsitively Perfect!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c15 fs0-75rem",
                                        style: {
                                            fontSize: '12px',
                                            color: '#15131380'
                                        },
                                        children: "Time to give yourself a tail-wagging treat!"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "db w100",
                                        src: (parcelRequire("6fqXD")),
                                        alt: ""
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "tip-box w100 p2rem bg20 w100",
                                style: {
                                    borderRadius: '40px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                        className: "c15 fs0-75rem df aic mb1rem",
                                        style: {
                                            fontSize: '14px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "icon mr1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "db w2rem",
                                                    src: (parcelRequire("iBc1P")),
                                                    alt: ""
                                                })
                                            }),
                                            "Top Tip"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "c15 fs0-75rem",
                                        style: {
                                            fontSize: '12px',
                                            color: '#15131380'
                                        },
                                        children: [
                                            "Activation will make your checklist visible and accessible by users on their AnyList Checklist Builder tab on their dashboard(s)",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "You can now ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "active-btn pr df bg1 br50px mr0-5rem bw1px bss fs0-75rem px1rem py0-5rem bsbb aic active-btn cp c7",
                                                style: {
                                                    display: 'inline-block',
                                                    padding: '5px 11px',
                                                    fontSize: '9px',
                                                    marginRight: '-1px'
                                                },
                                                children: "Activate"
                                            }),
                                            " your new checklist immediately or you can return here to activate it later from your dashboard.",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Don\u2019t worry! You can always return here to ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "pr df bg1 br50px mr0-5rem bw1px bss fs0-75rem px1rem py0-5rem bsbb aic active-btn cp c12",
                                                style: {
                                                    display: 'inline-block',
                                                    padding: '5px 11px',
                                                    fontSize: '9px',
                                                    marginRight: '-1px'
                                                },
                                                children: "Deactivate"
                                            }),
                                            " and make further edits from your AnyList Checklist Builder tab on your dashboard."
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bottom-btn-area df aic jcfe w100 bsbb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs0-75rem mr1rem",
                        style: {
                            color: '#151313b3'
                        },
                        children: "Before (Go to checklist), you need to activate it!"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("buttom", {
                        onClick: ()=>handleGoToChecklist(),
                        className: `shadow c1 cp fw400 fs1rem pr br38px w200px h3rem df aic jcc bg4 bg3-hover`,
                        children: [
                            "Go to checklist",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon pr ml0-5rem",
                                style: {
                                    top: '3px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "confirmDeleteModule",
                open: modal['open'] === 'confirmDeleteModule',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "poppins-font-style mah100 bg1 shadow w100 pt2rem px4rem df fdc m1rem pr br10px pr",
                            style: {
                                outline: 'none',
                                paddingBottom: '2rem',
                                maxWidth: '550px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "top-logo pa t0 r0 mr1rem mt1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w4rem",
                                        src: (parcelRequire("bJ68K")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "content-area creaing-modal pr mt2rem mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "c15 fs2rem tac lh1 fw600 mb1rem",
                                            children: "CONFIRMATION"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem tac mb2rem",
                                            children: "Are you sure you want to delete this module?"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsa gg1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            open: ''
                                                        })),
                                                    className: "new-shadow cp c14 bg1 fw400 fs1rem pr br38px bw1px bss bsbb w200px h3rem df aic jcc",
                                                    children: "Cancel"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    onClick: ()=>{
                                                        deleteModule(deleteModuleName);
                                                        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                            open: ''
                                                        }));
                                                    },
                                                    className: "shadow c1 bg4 cp fw400 fs1rem pr br38px px0-5rem w200px h3rem df aic jcc",
                                                    children: "Confirm"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}














function $2a0c9d5cb2da57b5$export$2e2bcd8739ae039({}) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let [stepTab, setStepTab] = (0, $acw62.useState)(1);
    let [sections, setSections] = (0, $acw62.useState)([]);
    let [companyId, setCompanyId] = (0, $acw62.useState)();
    let [checklistId, setChecklistId] = (0, $acw62.useState)();
    let [selectedCompany, setSelectedCompany] = (0, $acw62.useState)(null);
    let [isDisabled, setIsDisabled] = (0, $acw62.useState)(true);
    let [checklistObj, setChecklistObj] = (0, $acw62.useState)({});
    let [allCompaines, setAllCompaines] = (0, $acw62.useState)([]);
    let [isAIChecklist, setIsAIChecklist] = (0, $acw62.useState)(true);
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading Checklist...'
    });
    let tabs = {
        1: 'Checklist Setup',
        2: 'Choose Checklist Features',
        3: 'Section Creation',
        4: 'Question Creation',
        5: 'Logo Upload & Permissions',
        6: 'Checklist Activation'
    };
    const popupMessage = {
        1: {
            'generic': 'Creating your checklist'
        },
        2: {
            'manual': 'Setting up checklist features',
            'automatic': 'Generating checklist sections'
        },
        3: {
            'manual': 'Adding checklist sections',
            'automatic': 'Generating checklist questions'
        },
        4: {
            'generic': 'Updating checklist questions'
        },
        5: {
            'generic': 'Updating checklist logo & permissions'
        },
        6: {
            'generic': 'Updating checklist activation'
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (allCompaines.length && location?.search) {
            let _companyId = location.search.split('=')[1].split(';')[0];
            const _company = allCompaines.filter((c)=>c['_id'] === _companyId);
            if (_company && _company[0]) setSelectedCompany(_company[0]);
        }
    }, [
        allCompaines
    ]);
    (0, $acw62.useEffect)(()=>{
        getChecklistData();
        if (location?.search) companyId = location.search.split('=')[1].split(';')[0];
        if (companyId) setCompanyId(companyId);
    }, []);
    const getChecklistData = async ()=>{
        if (location?.hash) checklistId = location.hash.split('#')[1];
        if (checklistId) {
            setIsLoader({
                show: true,
                message: 'Loading Checklist...'
            });
            setChecklistId(checklistId);
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/get/${checklistId}`);
            if (res['code'] == 200) {
                await setChecklistData(res['body']);
                setIsLoader({
                    show: false,
                    message: 'Loading Checklist...'
                });
            }
        }
    };
    function formatCompanies(companies) {
        const childrenMap = {};
        // Step 1: Map children by parentId
        companies.forEach((c)=>{
            const parentId = c.parentId || null; // handle undefined/null
            if (parentId) {
                if (!childrenMap[parentId]) childrenMap[parentId] = [];
                childrenMap[parentId].push(c);
            }
        });
        // Step 2: Recursive function for parent + children
        function buildHierarchy(company) {
            const result = [
                company
            ];
            const children = childrenMap[company._id] || [];
            children.forEach((child)=>{
                result.push(...buildHierarchy(child));
            });
            return result;
        }
        // Step 3: Build final ordered result
        const result = [];
        companies.forEach((c)=>{
            if (c.group === "Parent") result.push(...buildHierarchy(c));
        });
        // Step 4: Add leftover companies (no group / standalone / not in hierarchy)
        companies.forEach((c)=>{
            if (!result.find((r)=>r._id === c._id)) result.push(c);
        });
        return result;
    }
    const setChecklistData = async (data)=>{
        if (data?.['sections'] && data['sections'].length > 0) setSections(data['sections']);
        if (data?.['allCompaines']) {
            if (companyId) {
                let company = data?.['allCompaines'].filter(({ _id: _id })=>_id == companyId);
                let companies = data?.['allCompaines'].filter(({ _id: _id })=>_id != companyId);
                allCompaines = company.concat(companies);
                setAllCompaines(formatCompanies(allCompaines));
            } else setAllCompaines(formatCompanies(data?.['allCompaines']));
        }
        const members = data['module']['companyMembers'] || [];
        const advisors = data['module']['companyAdvisors'] || [];
        const investors = data['module']['companyInvestors'] || [];
        members.forEach((member)=>{
            if (!member || !member._id || !member.company) return; // Skip if member data is invalid
            // Ensure `memberPermissions` object exists
            if (!data.module.memberPermissions) data.module.memberPermissions = {};
            // Ensure memberPermissions entry exists for the member
            if (!data.module.memberPermissions[member._id]) data.module.memberPermissions[member._id] = {};
            const havePermission = member.company.memberPermissions?.[member._id]?.[data.module.moduleKey] ?? null;
            data.module.memberPermissions[member._id] = {
                ...member,
                ['company']: {
                    ...member.company,
                    ['memberPermissions']: {
                        ...member.company.memberPermissions,
                        [member._id]: {
                            ...member.company.memberPermissions?.[member._id],
                            [data.module.moduleKey]: havePermission || havePermission === null ? true : false
                        }
                    }
                }
            };
        });
        advisors.forEach((advisor)=>{
            if (!advisor || !advisor._id || !advisor.company) return; // Skip if advisor data is invalid
            // Ensure `advisorPermissions` object exists
            if (!data.module.advisorPermissions) data.module.advisorPermissions = {};
            // Ensure advisorPermissions entry exists for the advisor
            if (!data.module.advisorPermissions[advisor._id]) data.module.advisorPermissions[advisor._id] = {};
            const havePermission = advisor.company.advisors?.[advisor._id]?.['modules'][data.module.moduleKey] ?? null;
            if (havePermission) data.module.advisorPermissions[advisor._id] = {
                ...advisor,
                ['company']: {
                    ...advisor.company,
                    ['advisorPermissions']: {
                        ...advisor.company.advisorPermissions,
                        [advisor._id]: {
                            ...advisor.company.advisorPermissions?.[advisor._id],
                            ['modules']: {
                                ...advisor.company.advisorPermissions?.[advisor._id]?.modules,
                                [data.module.moduleKey]: havePermission ? true : false
                            }
                        }
                    }
                }
            };
            else delete data.module.advisorPermissions[advisor._id];
        });
        investors.forEach((investor)=>{
            if (!investor || !investor._id || !investor.company) return; // Skip if investor data is invalid
            // Ensure `investorPermissions` object exists
            if (!data.module.investorPermissions) data.module.investorPermissions = {};
            // Ensure investorPermissions entry exists for the investor
            if (!data.module.investorPermissions[investor._id]) data.module.investorPermissions[investor._id] = {};
            const havePermission = investor.company.investors?.[investor._id]?.['modules' || {}]?.[data.module.moduleKey] ?? null;
            if (havePermission) data.module.investorPermissions[investor._id] = {
                ...investor,
                ['company']: {
                    ...investor.company,
                    ['investorPermissions']: {
                        ...investor.company.investorPermissions,
                        [investor._id]: {
                            ...investor.company.investorPermissions?.[investor._id],
                            ['modules']: {
                                ...investor.company.investorPermissions?.[investor._id]?.modules,
                                [data.module.moduleKey]: havePermission ? true : false
                            }
                        }
                    }
                }
            };
            else delete data.module.investorPermissions[investor._id];
        });
        data['module']['companyMembers'] = members;
        data['module']['companyAdvisors'] = advisors;
        data['module']['companyInvestors'] = investors;
        if (data?.['module']) setChecklistObj(data['module']);
        setIsAIChecklist(data?.['module']?.['genType'] == 'automatic' ? true : false);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (data['module']['step']) setTimeout(()=>setStepTab(data['module']['step']), 100);
    };
    const handleCreateChecklist = async (data)=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'checklistPopup'
        }));
        if (checklistObj['step'] == 3) checklistObj['sections'] = data;
        // if (stepTab === 1 && user && user['role'] && user['role'].toLowerCase() === "advisor" && user['companyId']['_id'] !== companyId) {
        //     checklistObj['category'] = 'external'
        // }
        checklistObj['category'] = 'external';
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/${stepTab}`, checklistObj);
        if (res?.['code'] != 200) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        if (res?.['code'] == 200) {
            let checklistId = res['body']?.['module']?.['_id'];
            if (checklistId) {
                let path = location.href.split('?')[1];
                if (location.href.includes('#')) window.location.href = `/createChecklist?${path}`;
                else window.location.href = `/createChecklist?${path}#${checklistId}`;
                if (res['code'] == 200) getChecklistData();
                else dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
            }
        }
    };
    const handleSidebar = async (idx)=>{
        if (checklistObj?.['step'] >= idx + 1) setStepTab(idx + 1);
        else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please fill required fields and click (Ok, next) button');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            checklistId && isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "checklist-builder-page mt2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "top-header-area df aic w100 jcc mb1rem px5rem bsbb",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "c15 fs1-75rem lh2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "c4",
                                    children: "AnyList "
                                }),
                                "Checklist Builder"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "checklist-setup df fww w100 bsbb h100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w80 left-setup-area bsbb py2rem px5rem pr",
                                style: {
                                    border: '1px solid #82828234',
                                    borderLeft: 'none',
                                    borderBottom: 'none'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "heading-setup df aic w100 mb1rem fww",
                                        children: [
                                            stepTab > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                onClick: ()=>setStepTab(stepTab - 1),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                    className: "cp mr1rem",
                                                    width: "22",
                                                    height: "16",
                                                    viewBox: "0 0 22 16",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                                        fill: "#151313"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "steps c15 fs1-25rem mr1rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: stepTab
                                                    }),
                                                    " / ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                className: "c15 fs2rem lh2",
                                                children: tabs[stepTab]
                                            }),
                                            stepTab > 1 && checklistObj?.['moduleName'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                                className: "fs1-25rem fw400 mt0-5rem c3 db w100 ",
                                                children: [
                                                    checklistObj['moduleName'],
                                                    " ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "fs1rem c15 fsi ttc",
                                                        style: {
                                                            color: '#15131330'
                                                        },
                                                        children: [
                                                            "(",
                                                            checklistObj['genType'],
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    tabs[stepTab] == 'Checklist Setup' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38ffdb0de19d2e99$export$2e2bcd8739ae039), {
                                            isDisabled: isDisabled,
                                            setIsDisabled: setIsDisabled,
                                            isAIChecklist: isAIChecklist,
                                            setIsAIChecklist: setIsAIChecklist,
                                            checklistObj: checklistObj,
                                            setChecklistObj: setChecklistObj,
                                            handleCreateChecklist: handleCreateChecklist
                                        })
                                    }),
                                    tabs[stepTab] == 'Choose Checklist Features' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdcfc9d0c6aeefa0$export$2e2bcd8739ae039), {
                                            stepTab: stepTab,
                                            allCompaines: allCompaines,
                                            isAIChecklist: isAIChecklist,
                                            setIsAIChecklist: setIsAIChecklist,
                                            checklistObj: checklistObj,
                                            setChecklistObj: setChecklistObj,
                                            handleCreateChecklist: handleCreateChecklist,
                                            selectedCompany: selectedCompany
                                        })
                                    }),
                                    tabs[stepTab] == 'Section Creation' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7fbcbe771bda0ade$export$2e2bcd8739ae039), {
                                            isAIChecklist: isAIChecklist,
                                            setIsAIChecklist: setIsAIChecklist,
                                            sectionsData: sections,
                                            checklistObj: checklistObj,
                                            setChecklistObj: setChecklistObj,
                                            handleCreateChecklist: handleCreateChecklist
                                        })
                                    }),
                                    tabs[stepTab] == 'Question Creation' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $274b48a63e25e3eb$export$2e2bcd8739ae039), {
                                            sections: sections,
                                            setSections: setSections,
                                            checklistObj: checklistObj,
                                            handleCreateChecklist: handleCreateChecklist,
                                            getChecklistData: getChecklistData
                                        })
                                    }),
                                    tabs[stepTab] == 'Logo Upload & Permissions' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ebf8e58e77ef0c20$export$2e2bcd8739ae039), {
                                            allCompaines: allCompaines,
                                            checklistObj: checklistObj,
                                            setChecklistObj: setChecklistObj,
                                            handleCreateChecklist: handleCreateChecklist
                                        })
                                    }),
                                    tabs[stepTab] == 'Checklist Activation' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $880908b40fd15380$export$2e2bcd8739ae039), {
                                            checklistObj: checklistObj,
                                            setChecklistObj: setChecklistObj,
                                            handleCreateChecklist: handleCreateChecklist
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w20 right-step-area py2rem pl2rem pr1rem bsbb pr",
                                style: {
                                    border: '1px solid #82828234',
                                    borderRight: 'none',
                                    borderBottom: 'none',
                                    backgroundColor: '#F9F9FF'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "top-area mb2rem",
                                        children: isAIChecklist ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: [
                                                'Choose Checklist Features',
                                                'Section Creation',
                                                'Logo Upload & Permissions',
                                                'Question Creation',
                                                'Checklist Activation'
                                            ].includes(tabs[stepTab]) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "pr mt1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "df aic pr",
                                                    style: {
                                                        marginRight: '-34px',
                                                        marginLeft: '-71px'
                                                    },
                                                    children: [
                                                        tabs[stepTab] == 'Choose Checklist Features' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w90",
                                                            src: (parcelRequire("itq9G")),
                                                            alt: ""
                                                        }),
                                                        tabs[stepTab] == 'Section Creation' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w90",
                                                            src: (parcelRequire("el9yf")),
                                                            alt: ""
                                                        }),
                                                        tabs[stepTab] == 'Logo Upload & Permissions' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w90",
                                                            src: (parcelRequire("6COsh")),
                                                            alt: ""
                                                        }),
                                                        tabs[stepTab] == 'Question Creation' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w90",
                                                            src: (parcelRequire("5QU0j")),
                                                            alt: ""
                                                        }),
                                                        tabs[stepTab] == 'Checklist Activation' && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "w90",
                                                            src: (parcelRequire("ksxjC")),
                                                            alt: ""
                                                        })
                                                    ]
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                            children: [
                                                'Choose Checklist Features',
                                                'Section Creation',
                                                'Logo Upload & Permissions',
                                                'Question Creation'
                                            ].includes(tabs[stepTab]) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "pr mt3rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        className: "df aic pr",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: "icon mr1rem pr",
                                                                style: {
                                                                    top: '5px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "24",
                                                                    height: "24",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "12",
                                                                            transform: "matrix(1 0 0 -1 0 24)",
                                                                            fill: "#59B8FD"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M10.8064 9.79219C10.8126 9.38281 11.147 9.05469 11.5564 9.05469C11.9657 9.05469 12.3001 9.38594 12.3064 9.79219L12.5564 16.5297C12.572 16.7859 12.4782 17.0359 12.297 17.2297C12.1032 17.4359 11.8345 17.5547 11.5564 17.5547C11.2782 17.5547 11.0095 17.4359 10.8157 17.2297C10.6345 17.0359 10.5407 16.7859 10.5564 16.5297L10.8064 9.79219Z",
                                                                            fill: "white"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M11.5547 5.55469C12.107 5.55469 12.5547 6.0024 12.5547 6.55469C12.5547 7.10697 12.107 7.55469 11.5547 7.55469C11.0024 7.55469 10.5547 7.10697 10.5547 6.55469C10.5547 6.0024 11.0024 5.55469 11.5547 5.55469Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            tabs[stepTab] == 'Choose Checklist Features' && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                className: "c15 fs1rem",
                                                                children: [
                                                                    "Expand fields to fully view",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    "details."
                                                                ]
                                                            }),
                                                            tabs[stepTab] == 'Logo Upload & Permissions' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "c15 fs1rem",
                                                                children: "Please use high quality logo"
                                                            }),
                                                            (tabs[stepTab] == 'Section Creation' || tabs[stepTab] == 'Question Creation') && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                className: "c15 fs1rem",
                                                                children: "Expand fields to fully view details. Overwrite to add your questions."
                                                            })
                                                        ]
                                                    }),
                                                    tabs[stepTab] == 'Choose Checklist Features' && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "bottom-area ml1rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "28",
                                                            height: "45",
                                                            viewBox: "0 0 28 45",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M26.5 37V38H27.5V37H26.5ZM0.292892 36.2929C-0.0976315 36.6834 -0.0976315 37.3166 0.292892 37.7071L6.65685 44.0711C7.04738 44.4616 7.68054 44.4616 8.07107 44.0711C8.46159 43.6805 8.46159 43.0474 8.07107 42.6569L2.41421 37L8.07107 31.3431C8.46159 30.9526 8.46159 30.3195 8.07107 29.9289C7.68054 29.5384 7.04738 29.5384 6.65685 29.9289L0.292892 36.2929ZM25.5 0L25.5 37H27.5L27.5 0H25.5ZM26.5 36H1V38H26.5V36Z",
                                                                fill: "#777676"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "bottom-checklist pb2rem df fww ",
                                        style: {
                                            width: '85%',
                                            alignContent: 'flex-end'
                                        },
                                        children: Object.values(tabs).map((item, idx)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>handleSidebar(idx),
                                                className: `df aic checklist-btn bo20 bw1px bss br15px bg0 w100 tal mb0-5rem bsbb cp ${stepTab == idx + 1 && ' active'}`,
                                                children: [
                                                    item == 'Checklist Activation' && checklistObj['isActive'] && checklistObj?.['step'] > 5 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "number-area bo20 bw2px bss tac br100 w2rem h2rem pr",
                                                        src: (parcelRequire("xz5vj")),
                                                        alt: ""
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                        children: checklistObj?.['step'] > idx + 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "number-area bo20 bw2px bss tac br100 w2rem h2rem pr",
                                                            src: (parcelRequire("8MWG0")),
                                                            alt: ""
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "number-area bo20 bw2px bss tac br100 w2rem h2rem pr",
                                                            children: idx + 1
                                                        })
                                                    }),
                                                    " ",
                                                    item
                                                ]
                                            });
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "checklistPopup",
                open: modal['open'] == 'checklistPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "content-area creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w70 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: popupMessage?.[stepTab]?.[checklistObj?.['genType']] || popupMessage?.[stepTab]?.['generic']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar ${isAIChecklist && stepTab == 2 && ` sections-progress-bar`} ${isAIChecklist && stepTab == 3 && ` questions-progress-bar`}`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: "This may take couple of minutes"
                                        })
                                    ]
                                }),
                                isAIChecklist && stepTab == 3 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pa",
                                    style: {
                                        bottom: '10px',
                                        right: '-507px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("1fXrE")),
                                        alt: ""
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");

function $70fc0a9b4abdab16$export$2e2bcd8739ae039({ selectedCompany: selectedCompany, moduleName: moduleName, handleChecklistNext: handleChecklistNext }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: selectedCompany && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    id: "pdf",
                    className: "shadow w70 p2rem ma td250 dg gg2rem new-report df fdc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df aic jcsb pdfHeaderCustom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "tal c15 lh1 mt1rem fs1-25rem ",
                                            children: "KPI Report"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fsi tal c15 fs1rem fw400 mb1rem",
                                            children: selectedCompany['cName']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt3rem c15",
                                            children: [
                                                "Report Date: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600",
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date()).format('MMM DD, YYYY')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50 df fdc jcsb aife",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w80px h80px mb2rem",
                                            src: (parcelRequire("hiMCQ")),
                                            alt: "bonusIcon"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs12px fw500 w100 tar",
                                            children: "Bespoke KPI report for your company"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg52 br5px py0-5rem df aic jcsb mb1rem mt1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1 ml1rem",
                                            children: "#KPI Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1",
                                            children: "KPI Description"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1",
                                            children: "KPI Calculation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1",
                                            children: "KPI Metric"
                                        })
                                    ]
                                }),
                                selectedCompany?.['keyPerformanceIndicators'] && selectedCompany['keyPerformanceIndicators'].map((kpi, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            verticalAlign: 'inherit'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px fw500 fsi",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: kpi['title'] || '-'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px",
                                                children: kpi['name'] || '-'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px",
                                                children: kpi['calculation'] || '-'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px",
                                                children: kpi['metric'] || '-'
                                            })
                                        ]
                                    }, idx))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic w100 jcsb bsbb mt2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fs1rem",
                            style: {
                                color: '#15131350'
                            },
                            children: "3/4 Section Review & Approval"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>handleChecklistNext(moduleName),
                            "data-tooltip": moduleName ? 'Checklist Created! you can click Next to view checklist' : 'Your checklist creation is in progress, please wait!',
                            className: `shadow c1 fw400 fs1rem pr br38px w300px py0-5rem df aic jcc ${moduleName ? 'bg4 bg3-hover cp' : 'bg16 cna'}`,
                            children: [
                                "Ok, next",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon pr ml0-5rem",
                                    style: {
                                        top: '3px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "30",
                                        height: "30",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





function $e269f76036a89368$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    (0, $acw62.useEffect)(()=>{
        localStorage.removeItem('isPartnerChecklist');
        localStorage.setItem('isDemoChecklist', true);
    }, []);
    const handleLetsGo = async ()=>{
        await localStorage.setItem('isDemoChecklist', true);
        localStorage.removeItem('testType');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addCompany'
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fww w100 my2rem",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df w100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw300 w100",
                                    children: "Welcome to the demo checklist creation process."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw500 w100",
                                    children: "Demo purpose:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw300 w100",
                                    children: "To  quickly show you the power of a small part of our platform features\u200B"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: 'introVideo'
                                })),
                            className: "cp pa smdn",
                            src: (parcelRequire("01Jdq")),
                            alt: "",
                            style: {
                                top: '19px',
                                left: '62%'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc w100 mt2rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc bg38 p3rem br20px ",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                className: "fs1-5rem fw400 c15",
                                children: "How it works?"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("72cmh")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1rem c12 fw300",
                                children: "For the purposes of this demo we have removed a number of additional features available in the full platform"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "pa w80px sm-recorrect",
                                src: (parcelRequire("lNukX")),
                                alt: "",
                                style: {
                                    left: '48%',
                                    bottom: '15%'
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 df jcc mt3rem sm-mt5rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>handleLetsGo(),
                        className: "df aic jcc cp shadow c1 fw400 fs1rem pr br38px w400px py1rem bg4 bg3-hover",
                        children: "Let's Go! - It's FREE"
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





function $e4b6b21231d63eea$export$2e2bcd8739ae039({ checklistObj: checklistObj, setChecklistObj: setChecklistObj, submitCreateChecklist: submitCreateChecklist }) {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let [descriptionCount, setDescriptionCount] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{}, []);
    const handleModuleDescription = (e)=>{
        if (e.target.value.length <= 500) {
            setChecklistObj({
                ...checklistObj,
                moduleDescription: e.target.value
            });
            setDescriptionCount(e.target.value.length);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "description-box df fww",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "left-box w60",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr mt1rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "w100 fw500 c15 db",
                                        for: "checkListName",
                                        children: [
                                            "Your Checklist Name ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: !checklistObj['moduleName'] ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        defaultValue: checklistObj['moduleName'] || '',
                                        onChange: (e)=>setChecklistObj({
                                                ...checklistObj,
                                                moduleName: e.target.value
                                            }),
                                        onBlur: (e)=>setChecklistObj({
                                                ...checklistObj,
                                                moduleName: e.target.value
                                            }),
                                        onInput: (e)=>setChecklistObj({
                                                ...checklistObj,
                                                moduleName: e.target.value
                                            }),
                                        id: "checkListName",
                                        placeholder: "e.g. Human Resources Checklist 1.0",
                                        className: "lpins w100 br10px p1rem mt0-5rem",
                                        type: "text"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pr mt2rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "w100 fw500 c15 db",
                                        children: [
                                            "Write Checklist Description ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: !checklistObj['moduleDescription'] ? 'c40' : 'c34',
                                                children: "*"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                        value: checklistObj['moduleDescription'] || '',
                                        rows: "4",
                                        style: {
                                            resize: 'none'
                                        },
                                        name: "moduleDescription",
                                        className: "lpins w100 br10px p1rem mt0-5rem",
                                        onChange: (e)=>handleModuleDescription(e),
                                        placeholder: "Your checklist description should be concise but comprehensive \u2013\u200B this will appear as your checklist module description"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: `pa b0 r0 mb1rem mr1rem ${descriptionCount >= 499 ? 'c4' : 'c16'}`,
                                        children: [
                                            descriptionCount,
                                            "/500"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "right-box w40 bsbb pr1rem pl4rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "tip-box w100 p2rem bg20 w100 bsbb",
                            style: {
                                marginTop: '-6px',
                                borderRadius: '40px'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                    className: "c15 fs0-75rem df aic mb1rem",
                                    style: {
                                        fontSize: '14px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "icon mr1rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "db w2rem",
                                                src: (parcelRequire("iBc1P")),
                                                alt: ""
                                            })
                                        }),
                                        "Example"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "c15 fs0-75rem",
                                    style: {
                                        fontSize: '14px'
                                    },
                                    children: "Description:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "c15 fs0-75rem",
                                    style: {
                                        fontSize: '12px',
                                        color: '#15131380'
                                    },
                                    children: [
                                        "A checklist for the creation of a business plan for the set up of a chain of doggy daycare centers in the UK. The focus of the checklist should include",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "1. Commercial considerations ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "2. Regulatory requirements ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "3. Financing requirements"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "db w80",
                                    style: {
                                        marginTop: '-13px'
                                    },
                                    src: (parcelRequire("8SKvM")),
                                    alt: ""
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pr df aic w100 jcsb bsbb",
                style: {
                    top: '30%'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs1rem",
                        style: {
                            color: '#15131350'
                        },
                        children: "2/4 Section Review & Approval"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        disabled: !checklistObj['moduleName'] || !checklistObj['moduleDescription'],
                        onClick: ()=>submitCreateChecklist(),
                        className: `c1 shadow fw400 fs1rem pr br38px w200px py0-5rem df aic jcc ${!checklistObj['moduleName'] || !checklistObj['moduleDescription'] ? ' bg16 cna' : ' bg4 bg3-hover cp'}`,
                        children: [
                            "Ok, next",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon pr ml0-5rem",
                                style: {
                                    top: '3px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}












function $f7b932a99b2c3500$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let [stepTab, setStepTab] = (0, $acw62.useState)(1);
    let [moduleName, setModuleName] = (0, $acw62.useState)();
    let [companyObj, setCompanyObj] = (0, $acw62.useState)({});
    let [checklistObj, setChecklistObj] = (0, $acw62.useState)({});
    let tabs = {
        1: 'Add target company',
        2: 'Create your checklist',
        3: 'FREE KPI Report',
        5: 'Explore checklist'
    };
    (0, $acw62.useEffect)(()=>{
        let _id, cName;
        if (location?.search) {
            let queryString = location.search;
            let urlParams = new URLSearchParams(queryString);
            _id = urlParams.get('companyId');
            cName = urlParams.get('cName');
            setCompanyObj({
                _id: _id,
                cName: cName
            });
        }
        if (_id) {
            setStepTab(2);
            getCompany(_id);
            if (user && Object.keys(user).length == 0) getUser();
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        setChecklistObj({
            ...checklistObj,
            companies: {
                [companyObj['_id']]: companyObj['cName']
            }
        });
    }, [
        companyObj
    ]);
    (0, $acw62.useEffect)(()=>{
        setChecklistObj({
            ...checklistObj,
            memberPermissions: {
                [user['_id']]: {
                    ...user,
                    company: companyObj
                }
            }
        });
    }, [
        user
    ]);
    const getCompany = async (id)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${id}`);
        if (res['code'] == 200) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(res['body']));
    };
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        if (response && response['code'] == 200) {
            let user = response?.['body']?.['user'];
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
        }
    };
    const generateKPIReport = async ()=>{
        if (!selectedCompany['keyPerformanceIndicators'] || Object.values(selectedCompany['keyPerformanceIndicators']).length == 0) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Generating your KPI report, please wait!');
            await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/generateKPI/${companyObj['_id']}`);
            await getCompany(companyObj['_id']);
            setStepTab(3);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        } else {
            setStepTab(3);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        }
    };
    const submitCreateChecklist = async ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'demoChecklistPopup'
        }));
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, checklistObj);
        if (res?.['code'] == 200) {
            if (res?.['body']?.['module']) setModuleName(res['body']['module']['moduleName']);
        }
    };
    const handleChecklistNext = async (moduleName)=>{
        if (moduleName) {
            await localStorage.setItem('isDemoChecklist', true);
            window.location.href = `/company/${selectedCompany['_id']}#${moduleName}`;
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Your checklist creation is in progress, please wait!');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "checklist-builder-page mt8rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "checklist-setup df fww w100 bsbb h100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `${stepTab == 1 ? 'w100' : 'w80'} left-setup-area bsbb py2rem px5rem pr`,
                            style: {
                                border: '1px solid #82828234',
                                borderLeft: 'none',
                                borderBottom: 'none'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic w100 my1rem fww",
                                    children: [
                                        stepTab > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>setStepTab(stepTab - 1),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "cp mr1rem",
                                                width: "22",
                                                height: "16",
                                                viewBox: "0 0 22 16",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                                    fill: "#151313"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "steps c15 fs1-25rem mr1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: stepTab
                                                }),
                                                " / ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "4"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs2rem lh2 fw400",
                                            children: stepTab == 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    "Demo ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "c4",
                                                        children: "AnyList"
                                                    }),
                                                    " Checklist"
                                                ]
                                            }) : tabs[stepTab]
                                        }),
                                        stepTab == 2 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "df w100 mt0-5rem",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "c12 fs1rem lh2 fsi",
                                                children: "(AI Generated)"
                                            })
                                        })
                                    ]
                                }),
                                tabs[stepTab] == 'Add target company' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e269f76036a89368$export$2e2bcd8739ae039), {}),
                                tabs[stepTab] == 'Create your checklist' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4b6b21231d63eea$export$2e2bcd8739ae039), {
                                    checklistObj: checklistObj,
                                    setChecklistObj: setChecklistObj,
                                    submitCreateChecklist: submitCreateChecklist
                                }),
                                tabs[stepTab] == 'FREE KPI Report' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70fc0a9b4abdab16$export$2e2bcd8739ae039), {
                                    selectedCompany: selectedCompany,
                                    moduleName: moduleName,
                                    handleChecklistNext: handleChecklistNext
                                })
                            ]
                        }),
                        stepTab > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w20 right-step-area py2rem pl2rem pr1rem bsbb pr",
                            style: {
                                border: '1px solid #82828234',
                                borderRight: 'none',
                                borderBottom: 'none',
                                backgroundColor: '#F9F9FF'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "top-area h40vh",
                                    children: [
                                        stepTab == 2 && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "pr",
                                            style: {
                                                right: '130px'
                                            },
                                            src: (parcelRequire("8BbWM")),
                                            alt: ""
                                        }),
                                        stepTab == 3 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "pr",
                                                    style: {
                                                        right: '130px'
                                                    },
                                                    src: (parcelRequire("6BG4x")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "w100 df jcc",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        onClick: ()=>handleChecklistNext(moduleName),
                                                        "data-tooltip": moduleName ? 'Checklist Created! you can click Next to view checklist' : 'Your checklist creation is in progress, please wait!',
                                                        className: `shadow c1 fw400 fs1rem pr br38px w300px py0-5rem mt1rem df aic jcc ${moduleName ? 'bg4 bg3-hover cp' : 'bg16 cna'}`,
                                                        children: [
                                                            "Ok, next",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: "icon pr ml0-5rem",
                                                                style: {
                                                                    top: '3px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    width: "30",
                                                                    height: "30",
                                                                    viewBox: "0 0 30 30",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                                        fill: "white"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bottom-checklist pb1rem h50vh df fww ",
                                    style: {
                                        width: '85%',
                                        alignContent: 'flex-end'
                                    },
                                    children: Object.values(tabs).map((item, idx)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                            className: `df aic checklist-btn bo20 bw1px bss br15px bg0 w100 tal mb0-5rem bsbb cp ${stepTab == idx + 1 && ' active'}`,
                                            children: [
                                                stepTab > idx + 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "number-area bo20 bw2px bss tac br100 w2rem h2rem pr",
                                                    src: (parcelRequire("8MWG0")),
                                                    alt: ""
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "number-area bo20 bw2px bss tac br100 w2rem h2rem pr",
                                                    children: idx + 1
                                                }),
                                                " ",
                                                item
                                            ]
                                        });
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "demoChecklistPopup",
                open: modal['open'] == 'demoChecklistPopup',
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: "Performing checklist creation magic!"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: "This may take couple of minutes, meanwhile you can check Free Bonus KPI Report."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            class: "w100 df jcc",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                onClick: ()=>generateKPIReport(),
                                                className: "df aic jcc pr cp shadow c1 fw400 fs1rem br38px w300px h3rem bg4 bg3-hover",
                                                children: [
                                                    "Free KPI Report",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "icon pr ml0-5rem",
                                                        style: {
                                                            top: '3px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                            width: "30",
                                                            height: "30",
                                                            viewBox: "0 0 30 30",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                                fill: "white"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pa",
                                    style: {
                                        top: '10px',
                                        right: '-345px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("dLJ5b")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");

function $ddca16fd475d168e$export$2e2bcd8739ae039({ selectedCompany: selectedCompany, moduleName: moduleName, handleChecklistNext: handleChecklistNext }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: selectedCompany && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                    id: "pdf",
                    className: "shadow w70 p2rem ma td250 dg gg2rem new-report df fdc",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df aic jcsb pdfHeaderCustom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "tal c15 lh1 mt1rem fs1-25rem ",
                                            children: "KPI Report"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fsi tal c15 fs1rem fw400 mb1rem",
                                            children: selectedCompany['cName']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "mt3rem c15",
                                            children: [
                                                "Report Date: ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "fw600",
                                                    children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(new Date()).format('MMM DD, YYYY')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50 df fdc jcsb aife",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w80px h80px mb2rem",
                                            src: (parcelRequire("hiMCQ")),
                                            alt: "bonusIcon"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs12px fw500 w100 tar",
                                            children: "Bespoke KPI report for your company"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "bg52 br5px py0-5rem df aic jcsb mb1rem mt1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1 ml1rem",
                                            children: "#KPI Name"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1",
                                            children: "KPI Description"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1",
                                            children: "KPI Calculation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "miw8rem c1",
                                            children: "KPI Metric"
                                        })
                                    ]
                                }),
                                selectedCompany?.['keyPerformanceIndicators'] && selectedCompany['keyPerformanceIndicators'].map((kpi, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        style: {
                                            verticalAlign: 'inherit'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px fw500 fsi",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: kpi['title'] || '-'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px",
                                                children: kpi['name'] || '-'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px",
                                                children: kpi['calculation'] || '-'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                className: "miw8rem tal c15 fs12px",
                                                children: kpi['metric'] || '-'
                                            })
                                        ]
                                    }, idx))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df aic w100 jcsb bsbb my2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 fs1rem",
                            style: {
                                color: '#15131350'
                            },
                            children: "3/4 Your New Checklist"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                            onClick: ()=>handleChecklistNext(moduleName),
                            "data-tooltip": moduleName ? 'Checklist Created! you can click Next to view checklist' : 'Your checklist creation is in progress, please wait!',
                            className: `shadow c1 fw400 fs1rem pr br38px w300px py0-5rem df aic jcc ${moduleName ? 'bg4 bg3-hover cp' : 'bg16 cna'}`,
                            children: [
                                "Ok, next",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "icon pr ml0-5rem",
                                    style: {
                                        top: '3px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "30",
                                        height: "30",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                            fill: "white"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

function $b4e60d73ac260165$export$2e2bcd8739ae039({ partner: partner, checklistObj: checklistObj, setChecklistObj: setChecklistObj, handleCreateChecklist: handleCreateChecklist }) {
    let [focusAreaCount, setFocusAreaCount] = (0, $acw62.useState)({
        focus1: 0,
        focus2: 0,
        focus3: 0
    });
    const handleAreaFocus = async (e, item)=>{
        if (e.target.value.length <= 200) {
            setChecklistObj({
                ...checklistObj,
                [item]: e.target.value
            });
            focusAreaCount = {
                ...focusAreaCount,
                [e.target.name]: e.target.value.length
            };
            setFocusAreaCount(focusAreaCount);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc w80",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "w100 c15 fs1rem fw400 lh2 mb1rem",
                        children: [
                            "Areas of your specific focus ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs1rem c15 fsi",
                                style: {
                                    color: '#15131330'
                                },
                                children: "(optional)"
                            })
                        ]
                    }),
                    Object.values(partner['focusArea']).map((item, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb-05rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "c15 fs0-75rem my0-5rem db w100",
                                    children: [
                                        "0",
                                        idx + 1,
                                        " - ",
                                        item
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: checklistObj?.[item] || '',
                                    onChange: (e)=>handleAreaFocus(e, item),
                                    onBlur: (e)=>handleAreaFocus(e, item),
                                    onInput: (e)=>handleAreaFocus(e, item),
                                    rows: "3",
                                    style: {
                                        resize: 'none',
                                        background: '#F4FFE1'
                                    },
                                    name: `focus${idx + 1}`,
                                    className: "bss bw2px bo5 w100 br10px p1rem mb1rem fs0-75rem",
                                    placeholder: "Write your objective focus in your own words (up to 200 characters max)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: `pa b0 r0 mb2rem mr1rem fs0-75rem ${focusAreaCount[`focus${idx + 1}`] >= 199 ? 'c4' : 'c16'}`,
                                    children: [
                                        focusAreaCount[`focus${idx + 1}`],
                                        "/200"
                                    ]
                                })
                            ]
                        });
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "w100 pr b0 df jcsb px2rem pr4rem mt2rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 fs1rem",
                        children: "Don\u2019t worry! The rest of our checklist is multiple choice."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        onClick: ()=>handleCreateChecklist(),
                        className: `shadow c1 fw400 fs1rem pr br38px w200px h3rem df aic jcc bg4 bg3-hover cp`,
                        children: [
                            "Ok, next",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                className: "icon pr ml0-5rem",
                                style: {
                                    top: '3px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");












function $478f2275f53f6473$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    (0, $acw62.useEffect)(()=>{
        localStorage.removeItem('isDemoChecklist');
        localStorage.setItem('isPartnerChecklist', true);
    }, []);
    const handleLetsGo = async ()=>{
        await localStorage.setItem('isPartnerChecklist', true);
        localStorage.removeItem('testType');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addCompany'
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: partner?.['type'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc w100 partner-checklist-page",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "df jcsb aic px8rem sm-px0rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: `fs1-5rem fw300 w100 c15 ${partner?.['type'] === "Business is Investment Ready" && "mt2rem sm-mt0-5rem"}`,
                                    children: partner['type'] == 'Business for Sale' ? '' : 'For Companies'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs2-5rem fw400 w100 c15 my1rem lh2",
                                    children: partner['type'] == 'Business for Sale' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Prepare Your Business For Sale ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "& Sell More Quickly"
                                            })
                                        ]
                                    }) : partner['type'] == 'Cyber DueDil' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "FREE Cybersecurity Process ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Assessment"
                                        ]
                                    }) : partner['type'] == 'Business is Investment Ready' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Ensure Your Business Is Investment ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Ready & ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c4",
                                                children: "Close Funding More Quickly"
                                            })
                                        ]
                                    }) : "Rejected for a Loan? Let\u2019s Try To Fix It"
                                })
                            ]
                        }),
                        partner['type'] == 'Business for Sale' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w200px",
                            src: (parcelRequire("tYq1A")),
                            alt: ""
                        }) : partner['type'] == 'Cyber DueDil' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w300px mb1rem",
                            src: (parcelRequire("kTWaK")),
                            alt: ""
                        }) : partner['type'] == 'Business is Investment Ready' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w200px",
                            src: (parcelRequire("2XZuD")),
                            alt: ""
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "df w200px",
                            src: (parcelRequire("bazo5")),
                            alt: ""
                        })
                    ]
                }),
                (partner['type'] == 'Business for Sale' || partner['type'] == 'Business is Investment Ready') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100",
                        children: [
                            partner['type'] == 'Business for Sale' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "benifets-column df fww w100 jcc gg1-5rem pl4rem pr10rem",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w30 bg63 py1rem px2rem mb2rem br8px",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "45",
                                                        height: "45",
                                                        viewBox: "0 0 45 45",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "22.5",
                                                                cy: "22.5",
                                                                r: "22.5",
                                                                fill: "#FF9900"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                "clip-path": "url(#clip0_749_2)",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M27.5138 16.7164C27.5138 16.7091 27.5138 16.7019 27.5138 16.6967C27.5138 16.3531 27.4765 16.0229 27.4108 15.7C26.9718 13.5845 25.1627 12 23.001 12C20.8215 12 19.0019 13.6063 18.5793 15.7456C18.5216 16.0416 18.4898 16.35 18.4888 16.6646C18.4888 16.675 18.4868 16.6863 18.4868 16.6967C18.4868 19.0771 20.1906 21.0405 22.3965 21.3479C22.5948 21.3748 22.7952 21.3944 23.001 21.3944C23.182 21.3944 23.357 21.382 23.5315 21.3593C25.7667 21.085 27.5033 19.1144 27.5138 16.7164Z",
                                                                        fill: "white"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M33.3768 23.1465L31.5646 25.6583L29.7524 23.1465C29.5402 23.2241 29.3378 23.3204 29.137 23.4249C30.5897 24.9411 31.4915 27.04 31.4915 29.3666V30.9998H37.0001V28.5614C37.0001 26.0578 35.4857 23.9361 33.3768 23.1465Z",
                                                                        fill: "white"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M28.9953 16.763C28.887 16.8955 28.7885 17.0341 28.7005 17.1821C28.3714 17.7255 28.1775 18.3662 28.1775 19.0544C28.1775 19.2635 28.1974 19.4663 28.2312 19.663C28.349 20.3626 28.6617 20.9877 29.1122 21.4794C29.3463 21.7381 29.6173 21.9585 29.9176 22.1345C30.4053 22.417 30.9656 22.5785 31.5646 22.5785C33.4335 22.5785 34.9508 21.0012 34.9508 19.0544C34.9508 17.445 33.9123 16.0882 32.4963 15.667C32.376 15.6328 32.2527 15.6048 32.1289 15.5821C32.0285 15.5655 31.9281 15.5531 31.8262 15.5448C31.7396 15.5386 31.6537 15.5293 31.5646 15.5293C30.535 15.5293 29.6163 16.0095 28.9953 16.763Z",
                                                                        fill: "white"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M12.6223 23.1465L14.4354 25.6583L16.2476 23.1465C16.4599 23.2241 16.6622 23.3204 16.8631 23.4249C15.4089 24.9411 14.508 27.04 14.508 29.3666V30.9998H9V28.5614C9 26.0578 10.5143 23.9361 12.6223 23.1465Z",
                                                                        fill: "white"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M17.0043 16.763C17.1127 16.8955 17.2121 17.0341 17.3006 17.1821C17.6287 17.7255 17.8216 18.3662 17.8216 19.0544C17.8216 19.2635 17.8017 19.4663 17.7679 19.663C17.6511 20.3626 17.3384 20.9877 16.888 21.4794C16.6533 21.7381 16.3829 21.9585 16.0826 22.1345C15.5948 22.417 15.0345 22.5785 14.4355 22.5785C12.5667 22.5785 11.0493 21.0012 11.0493 19.0544C11.0493 17.445 12.0884 16.0882 13.5043 15.667C13.6236 15.6328 13.7464 15.6048 13.8732 15.5821C13.9696 15.5655 14.072 15.5531 14.174 15.5448C14.2605 15.5386 14.3465 15.5293 14.4355 15.5293C15.4641 15.5293 16.3838 16.0095 17.0043 16.763Z",
                                                                        fill: "white"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M27.6633 23.5162C27.1856 23.0898 26.6531 22.7306 26.0819 22.444C25.8641 22.3342 25.6439 22.2349 25.4142 22.1479L24.8315 22.9594L23.5314 24.7612L22.9985 25.4992L22.3964 24.664L21.1864 22.9831L20.5858 22.1479C20.3461 22.24 20.112 22.3466 19.8838 22.4615C19.3125 22.7503 18.7831 23.1115 18.3048 23.5431C18.0413 23.7801 17.7937 24.0399 17.5655 24.3152C16.4415 25.6606 15.7549 27.4273 15.7549 29.3669V31H30.2451V29.3669C30.2451 27.4118 29.5486 25.6348 28.4071 24.28C28.1774 24.0078 27.9288 23.7532 27.6633 23.5162Z",
                                                                        fill: "white"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                    id: "clip0_749_2",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                        width: "28",
                                                                        height: "19",
                                                                        fill: "white",
                                                                        transform: "translate(9 12)"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "text-box mt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "c64 fs1-25rem",
                                                        children: "More Interested Buyers"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c14",
                                                        children: "Buyers will spend more time on businesses which are already prepared for sale."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w30 bg63 py1rem px2rem mb2rem br8px",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "45",
                                                        height: "45",
                                                        viewBox: "0 0 45 45",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "22.5",
                                                                cy: "22.5",
                                                                r: "22.5",
                                                                fill: "#FF9900"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                "fill-rule": "evenodd",
                                                                "clip-rule": "evenodd",
                                                                d: "M24.1666 22.3266V17.1668C24.1666 16.5228 23.6439 16.0002 22.9999 16.0002C22.3559 16.0002 21.8333 16.5228 21.8333 17.1668V22.9871C21.8312 23.193 21.8837 23.3964 21.9849 23.5755C22.0986 23.7687 22.2486 23.9159 22.4279 24.017L27.4684 26.9272C28.0261 27.2492 28.7401 27.0579 29.0621 26.5002C29.3841 25.9424 29.1928 25.2285 28.6351 24.9065L24.1666 22.3266ZM22.9999 11.3335C29.4434 11.3335 34.6666 16.5567 34.6666 23.0002C34.6666 29.4436 29.4434 34.6668 22.9999 34.6668C16.5564 34.6668 11.3333 29.4436 11.3333 23.0002C11.3333 16.5567 16.5564 11.3335 22.9999 11.3335Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "text-box mt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "c64 fs1-25rem",
                                                        children: "Quicker Sale"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c14",
                                                        children: "Having your key documents already organised speeds up your sale process."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w30 bg63 py1rem px2rem mb2rem br8px",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "45",
                                                        height: "45",
                                                        viewBox: "0 0 45 45",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                cx: "22.5",
                                                                cy: "22.5",
                                                                r: "22.5",
                                                                fill: "#FF9900"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M22.9701 11.0535C22.9009 11.0949 19.0578 17.219 18.8228 17.6476C18.7399 17.7996 18.7952 17.9932 18.9472 18.1452C19.0302 18.2282 19.2652 18.2558 20.1361 18.2558H21.2144V25.7623V33.2688L21.3941 33.4347L21.56 33.6144H23.2051C24.1451 33.6144 24.9054 33.5868 24.9884 33.5453C25.0575 33.5038 25.1404 33.3932 25.1819 33.2826C25.2372 33.1029 25.2096 33.0338 24.864 32.5776C23.5369 30.7666 23.0945 28.5271 23.6613 26.3291C23.841 25.6241 24.4492 24.3799 24.9054 23.7716L25.2649 23.3016V20.7856V18.242H26.3293C27.2832 18.242 27.4214 18.2282 27.5182 18.1176C27.5873 18.0485 27.6426 17.9102 27.6426 17.8135C27.6426 17.689 26.9238 16.4725 25.6519 14.4404C24.5598 12.6847 23.606 11.1917 23.5507 11.1226C23.4124 10.9982 23.1221 10.9567 22.9701 11.0535Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M15.7549 21.6153C15.4784 21.8227 15.4784 21.8365 15.4784 27.5597C15.4784 33.4488 15.4784 33.4211 15.7963 33.5594C15.9484 33.6147 19.0588 33.6147 19.2109 33.5594C19.5289 33.4349 19.5289 33.4488 19.5289 27.532V21.9609L19.3491 21.7397L19.1694 21.5186H17.5244C16.3355 21.5324 15.8378 21.56 15.7549 21.6153Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M29.9797 22.3618C27.5052 22.7488 25.5698 24.5875 25.0721 27.0343C24.8786 27.9467 24.9477 29.1079 25.238 29.965C25.9292 32.0387 27.6987 33.5731 29.8138 33.9464C30.4082 34.057 31.7768 33.9879 32.3298 33.8358C32.8136 33.6975 33.726 33.2828 34.1684 32.9787C34.6384 32.6469 35.3435 31.9281 35.7167 31.3751C37.3618 28.9282 36.8226 25.4998 34.514 23.6059C33.961 23.1497 32.9795 22.6659 32.2607 22.4862C31.6248 22.3341 30.5465 22.2788 29.9797 22.3618ZM31.293 24.2004C31.3206 24.228 31.3621 24.4077 31.3898 24.6151L31.4312 24.9745L31.8736 25.0989C32.4819 25.2648 32.6616 25.3478 32.6616 25.4998C32.6616 25.6657 32.4542 26.3708 32.3851 26.4399C32.3574 26.4814 32.1501 26.4261 31.9289 26.3431C31.4589 26.1772 30.7538 26.1358 30.5188 26.274C30.2977 26.3984 30.2009 26.6472 30.3115 26.8823C30.3806 27.0205 30.6294 27.1726 31.3206 27.5043C32.3713 28.002 32.6754 28.2923 32.8689 28.9144C33.1316 29.7991 32.703 30.6148 31.763 31.0433L31.3621 31.223V31.6378C31.3621 32.1354 31.2792 32.2045 30.7538 32.1769L30.3529 32.1492L30.3115 31.7622C30.27 31.306 30.2147 31.2092 29.9935 31.2092C29.7309 31.2092 28.9429 30.9327 28.8323 30.8221C28.7494 30.7254 28.7632 30.6286 28.8599 30.2553C28.9291 29.9927 29.012 29.7715 29.0397 29.73C29.0811 29.6886 29.2194 29.7162 29.3714 29.7853C30.5465 30.2968 31.4865 30.1447 31.4865 29.4535C31.4865 29.1632 31.2377 28.942 30.6709 28.707C29.2332 28.1126 28.8323 27.6979 28.8323 26.7855C28.8323 26.0666 29.2194 25.5137 29.9382 25.1957C30.3253 25.0298 30.3668 24.9745 30.3668 24.5736C30.3668 24.3386 30.4082 24.228 30.4912 24.1727C30.588 24.1036 31.2239 24.1174 31.293 24.2004Z",
                                                                fill: "white"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M10.2098 24.9189C10.113 24.9327 9.9886 25.0295 9.90565 25.1263C9.76741 25.306 9.76741 25.3751 9.78124 29.315L9.80888 33.324L9.97477 33.4622C10.1268 33.5866 10.2651 33.6005 11.7996 33.6005C13.334 33.6005 13.4723 33.5866 13.6243 33.4622L13.7902 33.324L13.8179 29.3841C13.8317 26.8405 13.8041 25.3751 13.7626 25.2645C13.6382 24.9189 13.3617 24.8774 11.7996 24.8774C10.9978 24.8913 10.2927 24.9051 10.2098 24.9189Z",
                                                                fill: "white"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "text-box mt0-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        className: "c64 fs1-25rem",
                                                        children: "Higher Valuation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        className: "c14",
                                                        children: "More interested buyers more likely to create an auction."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `checklist-column df fww w100 jcc gg1-5rem mb2rem px3rem pt2rem pb4rem sm-px1rem aic ${partner['type'] == 'Business for Sale' && "bg25 px10rem business-for-sale "}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "w50 text-box",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                className: `c15 fs1-5rem df aic pr ${partner['type'] == 'Business for Sale' && "c64 fs2rem mb2rem"}`,
                                                children: [
                                                    "Complete FREE ",
                                                    partner['type'] == 'Business is Investment Ready' ? 'Investment Ready Checklist' : 'Exit Checklist',
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "ml1rem w3rem h3rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                            width: "73",
                                                            height: "73",
                                                            viewBox: "0 0 73 73",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M58.8111 21.6562C56.1404 18.3011 52.7474 15.5914 48.8846 13.729C45.0219 11.8667 40.7888 10.8994 36.5005 10.8994C32.2122 10.8994 27.979 11.8667 24.1163 13.729C20.2535 15.5914 16.8605 18.3011 14.1899 21.6562C-0.672507 40.2712 12.6728 67.9199 36.5005 67.9199C60.3281 67.9199 73.6963 40.294 58.8111 21.6562ZM53.9406 54.107C51.7993 56.6466 49.129 58.6879 46.1166 60.0882C43.1042 61.4885 39.8224 62.214 36.5005 62.214C33.1786 62.214 29.8967 61.4885 26.8843 60.0882C23.8719 58.6879 21.2017 56.6466 19.0603 54.107C6.53624 39.2903 17.1896 16.5918 36.5005 16.5918C55.8113 16.5918 66.4646 39.2789 53.9406 54.107Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M37.6411 21.1538C37.6411 21.4563 37.5209 21.7464 37.307 21.9604C37.0931 22.1742 36.803 22.2944 36.5005 22.2944C36.198 22.2944 35.9078 22.1742 35.6939 21.9604C35.48 21.7464 35.3599 21.4563 35.3599 21.1538C35.3599 20.8513 35.48 20.5611 35.6939 20.3473C35.9078 20.1333 36.198 20.0132 36.5005 20.0132C36.803 20.0132 37.0931 20.1333 37.307 20.3473C37.5209 20.5611 37.6411 20.8513 37.6411 21.1538Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M37.6411 57.6538C37.6411 57.9563 37.5209 58.2464 37.307 58.4604C37.0931 58.6742 36.803 58.7944 36.5005 58.7944C36.198 58.7944 35.9078 58.6742 35.6939 58.4604C35.48 58.2464 35.3599 57.9563 35.3599 57.6538C35.3599 57.3513 35.48 57.0611 35.6939 56.8473C35.9078 56.6333 36.198 56.5132 36.5005 56.5132C36.803 56.5132 37.0931 56.6333 37.307 56.8473C37.5209 57.0611 37.6411 57.3513 37.6411 57.6538Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M54.7505 40.5444C54.448 40.5444 54.1578 40.4242 53.9439 40.2104C53.73 39.9964 53.6099 39.7063 53.6099 39.4038C53.6099 39.1013 53.73 38.8111 53.9439 38.5973C54.1578 38.3833 54.448 38.2632 54.7505 38.2632C55.053 38.2632 55.3431 38.3833 55.557 38.5973C55.7709 38.8111 55.8911 39.1013 55.8911 39.4038C55.8911 39.7063 55.7709 39.9964 55.557 40.2104C55.3431 40.4242 55.053 40.5444 54.7505 40.5444Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M18.2505 40.5444C17.948 40.5444 17.6578 40.4242 17.4439 40.2104C17.23 39.9964 17.1099 39.7063 17.1099 39.4038C17.1099 39.1013 17.23 38.8111 17.4439 38.5973C17.6578 38.3833 17.948 38.2632 18.2505 38.2632C18.553 38.2632 18.8431 38.3833 19.057 38.5973C19.2709 38.8111 19.3911 39.1013 19.3911 39.4038C19.3911 39.7063 19.2709 39.9964 19.057 40.2104C18.8431 40.4242 18.553 40.5444 18.2505 40.5444Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M24.3985 25.7164C24.5488 25.9359 24.6176 26.2011 24.5929 26.466C24.5683 26.7309 24.4518 26.9789 24.2637 27.1671C24.0755 27.3551 23.8277 27.4716 23.5627 27.4962C23.2978 27.5208 23.0326 27.4521 22.8131 27.3018C22.6628 27.0822 22.5941 26.8171 22.6187 26.5521C22.6432 26.2873 22.7597 26.0393 22.9478 25.8511C23.136 25.663 23.384 25.5466 23.6488 25.522C23.9138 25.4974 24.1789 25.5661 24.3985 25.7164Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M50.1879 51.5059C50.3381 51.7255 50.4069 51.9907 50.3823 52.2556C50.3576 52.5205 50.2412 52.7685 50.053 52.9566C49.865 53.1448 49.617 53.2612 49.352 53.2858C49.0872 53.3104 48.822 53.2416 48.6024 53.0914C48.4522 52.8719 48.3834 52.6066 48.408 52.3418C48.4326 52.0768 48.549 51.8289 48.7372 51.6408C48.9253 51.4526 49.1733 51.3362 49.4382 51.3115C49.7031 51.2869 49.9683 51.3557 50.1879 51.5059Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M50.1879 27.3018C49.9683 27.4521 49.7031 27.5208 49.4382 27.4962C49.1733 27.4716 48.9253 27.3551 48.7372 27.1671C48.549 26.9789 48.4326 26.7309 48.408 26.466C48.3834 26.2011 48.4522 25.9359 48.6024 25.7164C48.822 25.5661 49.0872 25.4974 49.352 25.522C49.617 25.5466 49.865 25.663 50.053 25.8511C50.2412 26.0393 50.3576 26.2873 50.3823 26.5521C50.4069 26.8171 50.3381 27.0822 50.1879 27.3018Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M24.3985 53.0914C24.1789 53.2416 23.9138 53.3104 23.6488 53.2858C23.384 53.2612 23.136 53.1448 22.9478 52.9566C22.7597 52.7685 22.6432 52.5205 22.6187 52.2556C22.5941 51.9907 22.6628 51.7255 22.8131 51.5059C23.0326 51.3557 23.2978 51.2869 23.5627 51.3115C23.8277 51.3362 24.0755 51.4526 24.2637 51.6408C24.4518 51.8289 24.5683 52.0768 24.5929 52.3418C24.6176 52.6066 24.5488 52.8719 24.3985 53.0914Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M38.6465 7.51465H33.2788V15.0294H38.6465V7.51465Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M32.2055 3.22044C30.4268 3.22044 28.9849 4.66235 28.9849 6.44103C28.9849 8.21971 30.4268 9.66162 32.2055 9.66162H39.7202C41.4988 9.66162 42.9407 8.21971 42.9407 6.44103C42.9407 4.66235 41.4988 3.22044 39.7202 3.22044L32.2055 3.22044Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M41.2482 29.3025H34.2918V32.974C34.5924 32.6018 35.0218 32.3012 35.58 32.0722C36.1382 31.8288 36.7322 31.7072 37.3621 31.7072C38.5072 31.7072 39.4447 31.9577 40.1747 32.4587C40.9047 32.9596 41.4343 33.6037 41.7635 34.391C42.0928 35.164 42.2574 35.9941 42.2574 36.8816C42.2574 38.5277 41.785 39.8516 40.8403 40.8537C39.9099 41.8556 38.5787 42.3566 36.8468 42.3566C35.215 42.3566 33.9125 41.9487 32.9391 41.1328C31.9658 40.3169 31.4147 39.2505 31.2859 37.9337H34.2059C34.3347 38.5062 34.621 38.9643 35.0647 39.3078C35.5228 39.6513 36.1025 39.8231 36.8038 39.8231C37.6484 39.8231 38.2853 39.5582 38.7147 39.0287C39.1441 38.499 39.3588 37.7977 39.3588 36.9246C39.3588 36.0371 39.1369 35.3643 38.6932 34.9063C38.2638 34.434 37.6269 34.1978 36.7824 34.1978C36.1812 34.1978 35.6802 34.3481 35.2794 34.6487C34.8787 34.9493 34.5924 35.35 34.4206 35.851H31.5435V26.6616H41.2482V29.3025Z",
                                                                    fill: "#01b976"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M36.8496 45.3046L35.5292 52.7978H34.0155L34.8743 47.9455L32.0187 52.7978H30.8701L29.7214 47.9347L28.8626 52.7978H27.3489L28.6801 45.3046H30.387L31.7933 50.8655L35.1427 45.3046H36.8496ZM38.9474 46.1419C38.7112 46.1419 38.5215 46.074 38.3784 45.938C38.2353 45.8021 38.1637 45.6303 38.1637 45.4227C38.1637 45.1365 38.2711 44.8931 38.4858 44.6927C38.7077 44.4852 38.9653 44.3813 39.2587 44.3813C39.4877 44.3813 39.6739 44.4494 39.817 44.5853C39.9601 44.7213 40.0317 44.8931 40.0317 45.1006C40.0317 45.3869 39.9243 45.6338 39.7096 45.8413C39.4949 46.0418 39.2408 46.1419 38.9474 46.1419ZM39.57 46.8505L38.518 52.7978H37.0043L38.0564 46.8505H39.57ZM44.3507 46.7646C44.9661 46.7646 45.4492 46.9328 45.7999 47.2691C46.1578 47.5984 46.3367 48.0707 46.3367 48.6862C46.3367 48.9153 46.3188 49.1228 46.283 49.3088L45.6604 52.7978H44.1682L44.7479 49.5128C44.7694 49.384 44.7801 49.2588 44.7801 49.1371C44.7801 48.7793 44.6835 48.5074 44.4902 48.3212C44.3042 48.1352 44.0358 48.0421 43.6851 48.0421C43.2843 48.0421 42.9408 48.1638 42.6545 48.4071C42.3754 48.6433 42.1893 48.9868 42.0963 49.4377L41.5058 52.7978H39.9922L41.0442 46.8505H42.5579L42.4291 47.5805C42.6724 47.33 42.9623 47.1332 43.2986 46.99C43.635 46.8397 43.9857 46.7646 44.3507 46.7646Z",
                                                                    fill: "#01b976"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: `c15 ${partner['type'] == 'Business for Sale' && "c14"}`,
                                                children: "Get a report on what to fix personalized to your business:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                className: `bfs-checklist mt1rem mb1rem ml3rem sm-ml1rem ${partner['type'] == 'Business for Sale' && "bfs-checklist-business"}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "24",
                                                                    height: "24",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "12",
                                                                            fill: "#42d342"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M10.3057 16.9998C10.1924 17.0022 10.0799 16.9811 9.97451 16.9375C9.86915 16.894 9.77308 16.829 9.69186 16.7462L5.24654 12.065C5.16838 11.9831 5.10638 11.8857 5.06408 11.7787C5.02178 11.6716 5 11.5568 5 11.4408C5 11.3249 5.02178 11.2102 5.06408 11.1031C5.10638 10.996 5.16838 10.8987 5.24654 10.8167C5.3247 10.7347 5.41749 10.6697 5.51961 10.6254C5.62173 10.581 5.73119 10.5582 5.84173 10.5582C5.95226 10.5582 6.06172 10.581 6.16384 10.6254C6.26597 10.6697 6.35875 10.7347 6.43692 10.8167L10.3057 14.8542L17.5409 7.24727C17.7057 7.08826 17.9215 7 18.1454 7C18.3694 7 18.5851 7.08826 18.7499 7.24727C18.9101 7.41549 19 7.64347 19 7.88118C19 8.11888 18.9101 8.34686 18.7499 8.51509L10.9008 16.7462C10.8224 16.8275 10.7295 16.8918 10.6274 16.9353C10.5252 16.9788 10.4159 17.0007 10.3057 16.9998Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            "Organize key documents"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "24",
                                                                    height: "24",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "12",
                                                                            fill: "#42d342"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M10.3057 16.9998C10.1924 17.0022 10.0799 16.9811 9.97451 16.9375C9.86915 16.894 9.77308 16.829 9.69186 16.7462L5.24654 12.065C5.16838 11.9831 5.10638 11.8857 5.06408 11.7787C5.02178 11.6716 5 11.5568 5 11.4408C5 11.3249 5.02178 11.2102 5.06408 11.1031C5.10638 10.996 5.16838 10.8987 5.24654 10.8167C5.3247 10.7347 5.41749 10.6697 5.51961 10.6254C5.62173 10.581 5.73119 10.5582 5.84173 10.5582C5.95226 10.5582 6.06172 10.581 6.16384 10.6254C6.26597 10.6697 6.35875 10.7347 6.43692 10.8167L10.3057 14.8542L17.5409 7.24727C17.7057 7.08826 17.9215 7 18.1454 7C18.3694 7 18.5851 7.08826 18.7499 7.24727C18.9101 7.41549 19 7.64347 19 7.88118C19 8.11888 18.9101 8.34686 18.7499 8.51509L10.9008 16.7462C10.8224 16.8275 10.7295 16.8918 10.6274 16.9353C10.5252 16.9788 10.4159 17.0007 10.3057 16.9998Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            partner['type'] == 'Business is Investment Ready' ? 'KPI report' : 'Business audit'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "24",
                                                                    height: "24",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "12",
                                                                            fill: "#42d342"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M10.3057 16.9998C10.1924 17.0022 10.0799 16.9811 9.97451 16.9375C9.86915 16.894 9.77308 16.829 9.69186 16.7462L5.24654 12.065C5.16838 11.9831 5.10638 11.8857 5.06408 11.7787C5.02178 11.6716 5 11.5568 5 11.4408C5 11.3249 5.02178 11.2102 5.06408 11.1031C5.10638 10.996 5.16838 10.8987 5.24654 10.8167C5.3247 10.7347 5.41749 10.6697 5.51961 10.6254C5.62173 10.581 5.73119 10.5582 5.84173 10.5582C5.95226 10.5582 6.06172 10.581 6.16384 10.6254C6.26597 10.6697 6.35875 10.7347 6.43692 10.8167L10.3057 14.8542L17.5409 7.24727C17.7057 7.08826 17.9215 7 18.1454 7C18.3694 7 18.5851 7.08826 18.7499 7.24727C18.9101 7.41549 19 7.64347 19 7.88118C19 8.11888 18.9101 8.34686 18.7499 8.51509L10.9008 16.7462C10.8224 16.8275 10.7295 16.8918 10.6274 16.9353C10.5252 16.9788 10.4159 17.0007 10.3057 16.9998Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            partner['type'] == 'Business is Investment Ready' ? 'Likely areas of diligence focus on your business' : 'Risks and recommendations'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                    width: "24",
                                                                    height: "24",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                            cx: "12",
                                                                            cy: "12",
                                                                            r: "12",
                                                                            fill: "#42d342"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            d: "M10.3057 16.9998C10.1924 17.0022 10.0799 16.9811 9.97451 16.9375C9.86915 16.894 9.77308 16.829 9.69186 16.7462L5.24654 12.065C5.16838 11.9831 5.10638 11.8857 5.06408 11.7787C5.02178 11.6716 5 11.5568 5 11.4408C5 11.3249 5.02178 11.2102 5.06408 11.1031C5.10638 10.996 5.16838 10.8987 5.24654 10.8167C5.3247 10.7347 5.41749 10.6697 5.51961 10.6254C5.62173 10.581 5.73119 10.5582 5.84173 10.5582C5.95226 10.5582 6.06172 10.581 6.16384 10.6254C6.26597 10.6697 6.35875 10.7347 6.43692 10.8167L10.3057 14.8542L17.5409 7.24727C17.7057 7.08826 17.9215 7 18.1454 7C18.3694 7 18.5851 7.08826 18.7499 7.24727C18.9101 7.41549 19 7.64347 19 7.88118C19 8.11888 18.9101 8.34686 18.7499 8.51509L10.9008 16.7462C10.8224 16.8275 10.7295 16.8918 10.6274 16.9353C10.5252 16.9788 10.4159 17.0007 10.3057 16.9998Z",
                                                                            fill: "white"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            partner['type'] == 'Business is Investment Ready' ? 'Report to show investors' : 'Diligence reports to show buyers'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w100 df jcfs my1rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    onClick: ()=>handleLetsGo(),
                                                    className: "df aic jcc cp shadow c1 fw400 fs1rem pr br38px w400px py1rem bg4 bg3-hover",
                                                    children: "Let's Go! - It's FREE"
                                                })
                                            }),
                                            (0, $bebe1cbb5a309c8c$export$464b02f563870b9e)() ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs0-75rem fw300 c12",
                                                children: "Diligentsia requires you to upload documents and works best on a desktop or laptop computer"
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w40 img-box df jcc",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w80",
                                            src: (parcelRequire("9bT7c")),
                                            alt: ""
                                        })
                                    })
                                ]
                            }),
                            partner['type'] == 'Business is Investment Ready' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pr how-its-work mb3rem benefits-ehe",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "container py5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                            className: "fs1-5rem fw600 c15 w100 tac",
                                            children: "Benefits Include"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df jcsb mt2rem sm-fdc",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt2rem pl2rem pr2rem pb0-5rem br30px bg1 bsflp pr work-card-box sm-mx0rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pb1rem df jcsb",
                                                            style: {
                                                                alignItems: 'end',
                                                                minHeight: '45px',
                                                                height: '45px',
                                                                borderBottom: '2px solid #15131350'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "pr w80",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "fw500 fs1-25rem c15 w100",
                                                                        style: {
                                                                            lineHeight: '22.81px'
                                                                        },
                                                                        children: "More Interested Investors"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jce pr aic",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "52",
                                                                        height: "37",
                                                                        viewBox: "0 0 52 37",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                                                "clip-path": "url(#clip0_863_571)",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M34.3835 9.55381C34.3835 9.54027 34.3835 9.52672 34.3835 9.51705C34.3835 8.87444 34.3142 8.25699 34.1923 7.65309C33.377 3.69677 30.0172 0.733398 26.0027 0.733398C21.955 0.733398 18.5757 3.73743 17.7909 7.73825C17.6838 8.29183 17.6247 8.86864 17.6228 9.45705C17.6228 9.4764 17.6191 9.49769 17.6191 9.51705C17.6191 13.9689 20.7833 17.6407 24.88 18.2156C25.2483 18.2659 25.6204 18.3026 26.0027 18.3026C26.3388 18.3026 26.6638 18.2794 26.9878 18.2369C31.139 17.7239 34.3641 14.0386 34.3835 9.55381Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M45.2704 21.5796L41.905 26.2772L38.5395 21.5796C38.1453 21.7247 37.7696 21.9048 37.3965 22.1002C40.0944 24.9358 41.7692 28.8612 41.7692 33.2124V36.2667H51.9994V31.7065C51.9994 27.0243 49.187 23.0564 45.2704 21.5796Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M37.1341 9.64096C36.9328 9.8887 36.75 10.1481 36.5866 10.4249C35.9753 11.441 35.6152 12.6392 35.6152 13.9263C35.6152 14.3173 35.6522 14.6967 35.715 15.0644C35.9338 16.3729 36.5146 17.542 37.351 18.4614C37.786 18.9453 38.2891 19.3575 38.8468 19.6866C39.7525 20.215 40.7931 20.517 41.9057 20.517C45.3763 20.517 48.1943 17.5672 48.1943 13.9263C48.1943 10.9165 46.2655 8.37897 43.636 7.59119C43.4125 7.52731 43.1835 7.47503 42.9536 7.43245C42.7671 7.40149 42.5806 7.37827 42.3914 7.36278C42.2307 7.35116 42.071 7.33374 41.9057 7.33374C39.9935 7.33374 38.2873 8.23185 37.1341 9.64096Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M6.72713 21.5796L10.0944 26.2772L13.4598 21.5796C13.854 21.7247 14.2298 21.9048 14.6028 22.1002C11.9022 24.9358 10.2292 28.8612 10.2292 33.2124V36.2667H0V31.7065C0 27.0243 2.81235 23.0564 6.72713 21.5796Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M14.8659 9.64096C15.0672 9.8887 15.2518 10.1481 15.4162 10.4249C16.0255 11.441 16.3838 12.6392 16.3838 13.9263C16.3838 14.3173 16.3468 14.6967 16.2841 15.0644C16.0671 16.3729 15.4863 17.542 14.6498 18.4614C14.214 18.9453 13.7118 19.3575 13.1541 19.6866C12.2483 20.215 11.2078 20.517 10.0952 20.517C6.62455 20.517 3.80664 17.5672 3.80664 13.9263C3.80664 10.9165 5.73633 8.37897 8.36589 7.59119C8.58747 7.52731 8.81553 7.47503 9.05096 7.43245C9.23008 7.40149 9.42028 7.37827 9.60956 7.36278C9.77022 7.35116 9.92995 7.33374 10.0952 7.33374C12.0055 7.33374 13.7136 8.23185 14.8659 9.64096Z",
                                                                                        fill: "#4A67FF"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                        d: "M34.6606 22.2705C33.7734 21.4731 32.7845 20.8014 31.7236 20.2652C31.3192 20.06 30.9102 19.8742 30.4837 19.7117L29.4016 21.2292L26.9871 24.599L25.9973 25.979L24.8792 24.4171L22.6319 21.2736L21.5166 19.7117C21.0715 19.8839 20.6367 20.0833 20.2129 20.2981C19.152 20.8381 18.1687 21.5136 17.2805 22.3208C16.7912 22.764 16.3314 23.2499 15.9076 23.7647C13.82 26.281 12.5449 29.5851 12.5449 33.2123V36.2666H39.4553V33.2123C39.4553 29.556 38.1618 26.2326 36.0418 23.699C35.6153 23.1899 35.1537 22.7137 34.6606 22.2705Z",
                                                                                        fill: "#4A67FF"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                                                    id: "clip0_863_571",
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                                        width: "52",
                                                                                        height: "35.5333",
                                                                                        fill: "white",
                                                                                        transform: "translate(0 0.733398)"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "fs1rem pt1-5rem pb1rem c14",
                                                            style: {
                                                                lineHeight: '27px'
                                                            },
                                                            children: "Investors will spend more time on businesses which are already prepared for diligence and funding."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt2rem pl2rem pr2rem pb0-5rem br30px bg1 bsflp pr work-card-box sm-mx0rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pb1rem df jcsb",
                                                            style: {
                                                                alignItems: 'end',
                                                                minHeight: '45px',
                                                                height: '45px',
                                                                borderBottom: '2px solid #15131350'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "pr w80",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "fw500 fs1-25rem c15 w100",
                                                                        style: {
                                                                            lineHeight: '22.81px'
                                                                        },
                                                                        children: "Quicker Investment Close"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jce pr aic",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                        width: "44",
                                                                        height: "44",
                                                                        viewBox: "0 0 44 44",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                            "fill-rule": "evenodd",
                                                                            "clip-rule": "evenodd",
                                                                            d: "M24.2 20.7298V11C24.2 9.7856 23.2144 8.8 22 8.8C20.7856 8.8 19.8 9.7856 19.8 11V21.9754C19.7961 22.3636 19.8952 22.7473 20.086 23.0849C20.3004 23.4492 20.5831 23.7268 20.9213 23.9175L30.4263 29.4053C31.478 30.0125 32.8243 29.6517 33.4315 28.6C34.0387 27.5483 33.678 26.2019 32.6263 25.5947L24.2 20.7298ZM22 0C34.1506 0 44 9.84943 44 22C44 34.1506 34.1506 44 22 44C9.84943 44 0 34.1506 0 22C0 9.84943 9.84943 0 22 0Z",
                                                                            fill: "#4A67FF"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "fs1rem pt1-5rem pb1rem c14",
                                                            style: {
                                                                lineHeight: '27px'
                                                            },
                                                            children: "Having your key documents already organised speeds up your transaction process."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pt2rem pl2rem pr2rem pb0-5rem br30px bg1 bsflp pr work-card-box sm-mx0rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "pb1rem df jcsb",
                                                            style: {
                                                                alignItems: 'end',
                                                                minHeight: '45px',
                                                                height: '45px',
                                                                borderBottom: '2px solid #15131350'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "pr w80",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "fw500 fs1-25rem c15 w100",
                                                                        style: {
                                                                            lineHeight: '22.81px'
                                                                        },
                                                                        children: "Lower Professional Fees"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jce pr aic",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                        width: "31",
                                                                        height: "52",
                                                                        viewBox: "0 0 31 52",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M31.0007 15.4351C31.0007 7.03357 24.1656 0.198486 15.7641 0.198486C7.36254 0.198486 0.527344 7.03357 0.527344 15.4351C0.527344 23.8366 7.36245 30.6717 15.764 30.6717C24.1655 30.6717 31.0007 23.8366 31.0007 15.4351ZM9.85316 19.0836H12.8766C12.8766 20.1311 13.7288 20.9833 14.7763 20.9833H16.7179C17.7993 20.9833 18.6791 20.1035 18.6791 19.0221C18.6791 17.9407 17.7994 17.0609 16.7179 17.0609H14.8103C12.0618 17.0609 9.82564 14.8248 9.82564 12.0763C9.82564 9.51641 11.7656 7.40202 14.2524 7.12366V4.60776H17.2758V7.12931C19.7426 7.42752 21.6609 9.53254 21.6609 12.0785H18.6375C18.6375 10.9959 17.7567 10.1152 16.6742 10.1152H14.8104C13.729 10.1152 12.8492 10.9949 12.8492 12.0763C12.8492 13.1576 13.729 14.0375 14.8104 14.0375H16.718C19.4665 14.0375 21.7026 16.2736 21.7026 19.022C21.7026 21.5818 19.7627 23.6962 17.2759 23.9746V26.4906H14.2525V23.9784C11.7832 23.7161 9.85316 21.6211 9.85316 19.0836Z",
                                                                                fill: "#4A67FF"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                                d: "M25.813 30.6733C22.9285 32.5818 19.474 33.6952 15.764 33.6952C12.0539 33.6952 8.59931 32.5819 5.71494 30.6733V37.2909H0.572266V39.4769L15.764 51.8015L30.9556 39.4769V37.2909H25.8129L25.813 30.6733Z",
                                                                                fill: "#4A67FF"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "fs1rem pt1-5rem pb1rem c14",
                                                            style: {
                                                                lineHeight: '27px'
                                                            },
                                                            children: "Better organised information and documents will save advisor costs."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "df jcc w100",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `df fdc bg38 p2rem br20px ${partner['type'] == 'Business for Sale' || "px10rem sm-px9px"}`,
                        children: [
                            partner['type'] == 'Business for Sale' ? /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                className: "fs1-5rem fw400 c15 mb2rem",
                                children: "How we work"
                            }) : partner['type'] == 'Business is Investment Ready' ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                        className: "fs1-5rem fw500 c15",
                                        children: "Get Investment Ready"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem fw400 c3 mb1-5rem",
                                        children: "Increase your chances of getting funded"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                className: "fs1-5rem fw400 c15 mb2rem",
                                children: "How we work"
                            }),
                            partner['type'] == 'Business for Sale' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("hILNG")),
                                alt: ""
                            }) : partner['type'] == 'Cyber DueDil' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("crPA1")),
                                alt: ""
                            }) : partner['type'] == 'Business is Investment Ready' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("1cmaD")),
                                alt: ""
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("hBWDP")),
                                alt: ""
                            })
                        ]
                    })
                }),
                ![
                    'Business for Sale',
                    'Cyber DueDil',
                    'Business is Investment Ready'
                ].includes(partner['type']) ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc mt2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleLetsGo(),
                                className: "df aic jcc cp shadow c1 fw400 fs1rem pr br38px w400px py1rem bg4 bg3-hover",
                                children: "Let's Go! - It's FREE"
                            })
                        }),
                        (0, $bebe1cbb5a309c8c$export$464b02f563870b9e)() ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Diligentsia requires you to upload documents and works best on a desktop or laptop computer"
                        }) : null
                    ]
                }) : null,
                partner['type'] == 'Business for Funding' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Diligentsia provides tools, not financial advice, to help improve your ABF loan application. We earn a flat fee per successful resubmission, not commission on loan amounts."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Your information is only shared with Alternative Business Funding\xa0Limited with your permission."
                        })
                    ]
                }),
                partner['type'] == 'Business for Sale' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Diligentsia provides tools, not financial advice, to help improve your business for sale. We may receive a flat fee from BFS upon eventual sale of your business."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: [
                                "Your information is only shared with ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "c3",
                                    href: "https://www.businessesforsale.com/",
                                    target: "_blank",
                                    children: "BusinessesForSale.com"
                                }),
                                " with your permission"
                            ]
                        })
                    ]
                }),
                partner['type'] == 'Cyber DueDil' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w100 df jcc mt2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>handleLetsGo(),
                                className: "df aic jcc cp shadow c1 fw400 fs1rem pr br38px w400px py1rem bg4 bg3-hover",
                                children: "Let's Go! - It's FREE"
                            })
                        }),
                        (0, $bebe1cbb5a309c8c$export$464b02f563870b9e)() ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Diligentsia requires you to upload documents and works best on a desktop or laptop computer"
                        }) : null,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Diligentsia is not responsible for the results of this initial self-assessment - you should take subsequent expert advice"
                        })
                    ]
                }),
                partner['type'] == 'Business is Investment Ready' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Diligentsia provides tools, not financial advice, to help improve your business for investment."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-75rem fw300 c12 mt1rem",
                            children: "Your information may be shared with EHE as part of this process."
                        })
                    ]
                })
            ]
        })
    });
}














function $9ce8c16714c6900b$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const isPartnerChecklist = location.pathname.startsWith('/partnerChecklist/');
    let [stepTab, setStepTab] = (0, $acw62.useState)(1);
    let [moduleName, setModuleName] = (0, $acw62.useState)();
    let [isPrequelQues, setIsPrequelQues] = (0, $acw62.useState)(false);
    let [isGenerateKPI, setIsGenerateKPI] = (0, $acw62.useState)(false);
    let [companyObj, setCompanyObj] = (0, $acw62.useState)({});
    let [checklistObj, setChecklistObj] = (0, $acw62.useState)({});
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let tabs = {
        1: 'Add target company',
        2: 'FREE KPI Report',
        3: 'Complete checklist',
        5: 'Register & store your checklist'
    };
    (0, $acw62.useEffect)(()=>{
        // if (restrictedForDevices()) showMessage(`This feature is not available on mobile/tablet devices`);
        let pathname = location.pathname.split('/');
        if (pathname) {
            let partnerId = pathname[pathname.length - 1];
            if (partnerId) {
                setIsLoader({
                    show: true,
                    message: 'Loading Partner...'
                });
                getPartner(partnerId);
                localStorage.setItem('partnerId', partnerId);
            }
        }
        let _id, cName;
        if (location?.search) {
            let queryString = location.search;
            let urlParams = new URLSearchParams(queryString);
            _id = urlParams.get('companyId');
            cName = urlParams.get('cName');
            setCompanyObj({
                _id: _id,
                cName: cName
            });
        }
        if (_id && cName) {
            getCompany(_id);
            setStepTab(2);
            if (user && Object.keys(user).length == 0) getUser();
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        setChecklistObj({
            ...checklistObj,
            partnerId: partner['_id']
        });
    }, [
        partner
    ]);
    (0, $acw62.useEffect)(()=>{
        setChecklistObj({
            ...checklistObj,
            companies: {
                [companyObj['_id']]: companyObj['cName']
            }
        });
    }, [
        companyObj
    ]);
    (0, $acw62.useEffect)(()=>{
        setChecklistObj({
            ...checklistObj,
            memberPermissions: {
                [user['_id']]: {
                    ...user,
                    company: companyObj
                }
            }
        });
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        if (partner?.['focusArea'] && (partner['focusArea']?.['focus1'].length > 0 || partner['focusArea']?.['focus2'].length > 0 || partner['focusArea']?.['focus3'].length > 0)) setIsPrequelQues(true);
        else handleCreateChecklist();
    }, [
        checklistObj
    ]);
    const handleCreateChecklist = ()=>{
        if (checklistObj['companies'] && checklistObj['memberPermissions'] && checklistObj['partnerId']) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'partnerChecklistPopup'
            }));
            createChecklist();
            setChecklistObj({});
        }
    };
    const createChecklist = async ()=>{
        const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, checklistObj);
        if (res?.['code'] == 200) {
            if (res?.['body']?.['module']) setModuleName(res['body']['module']['moduleName']);
        }
    };
    const getPartner = async (id)=>{
        setIsLoader({
            show: true,
            message: 'Loading Partner...'
        });
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/${id}`, 'return-response');
        if (res['code'] == 200) {
            dispatch((0, $3d3d7a2ee763f32a$export$6af6109222273956)(res['body']));
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
        } else {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            setTimeout(()=>window.location.href = '/homepage', 500);
        }
    };
    const getCompany = async (id, lightweight = true)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${id}?lightweight=${lightweight}`);
        if (res['code'] == 200) dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(res['body']));
    };
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        if (response && response['code'] == 200) {
            let user = response?.['body']?.['user'];
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
        }
    };
    const generateKPIReport = async ()=>{
        if (!selectedCompany['keyPerformanceIndicators'] || Object.values(selectedCompany['keyPerformanceIndicators']).length === 0) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Generating your KPI report, please wait!');
            setIsGenerateKPI(true);
            let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/generateKPI/${companyObj['_id']}`);
            if (res['code'] === 200) {
                await getCompany(companyObj['_id'], false);
                setStepTab(2);
                setIsPrequelQues(false);
                setIsGenerateKPI(false);
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
            }
        } else {
            setStepTab(2);
            setIsPrequelQues(false);
            setIsGenerateKPI(false);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        }
    };
    const handleChecklistNext = async (moduleName)=>{
        if (moduleName) {
            await localStorage.setItem('isPartnerChecklist', true);
            window.location.href = `/company/${selectedCompany['_id']}#${moduleName}`;
        } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Your checklist creation is in progress, please wait!');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "checklist-builder-page",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "checklist-setup df fww w100 bsbb h100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `${stepTab == 1 ? 'w100' : 'w80 pl2rem'} left-setup-area bsbb pr mb2rem`,
                            style: {
                                border: '1px solid #82828234',
                                borderLeft: 'none',
                                borderBottom: 'none'
                            },
                            children: [
                                stepTab > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df aic w100 my1rem fww",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            onClick: ()=>setStepTab(stepTab - 1),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "cp mr1rem",
                                                width: "22",
                                                height: "16",
                                                viewBox: "0 0 22 16",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                                    fill: "#151313"
                                                })
                                            })
                                        }),
                                        !isPrequelQues && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "steps c15 fs1-25rem mr1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: stepTab
                                                }),
                                                " / ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: "4"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "c15 fs2rem lh2 fw400",
                                            children: isPrequelQues ? 'User Prequel Questions' : tabs[stepTab]
                                        }),
                                        stepTab > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "df w100 mt0-5rem c3",
                                            children: [
                                                partner?.['moduleName'] && partner['moduleName'],
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c12 fs1rem lh2 fsi ml0-5rem",
                                                    children: "(AI Generated)"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isPrequelQues && stepTab > 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4e60d73ac260165$export$2e2bcd8739ae039), {
                                    partner: partner,
                                    checklistObj: checklistObj,
                                    setChecklistObj: setChecklistObj,
                                    handleCreateChecklist: handleCreateChecklist
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        tabs[stepTab] == 'Add target company' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $478f2275f53f6473$export$2e2bcd8739ae039), {}),
                                        tabs[stepTab] == 'FREE KPI Report' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddca16fd475d168e$export$2e2bcd8739ae039), {
                                            selectedCompany: selectedCompany,
                                            moduleName: moduleName,
                                            handleChecklistNext: handleChecklistNext
                                        })
                                    ]
                                })
                            ]
                        }),
                        stepTab > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w20 right-step-area py2rem pl2rem pr1rem bsbb pr",
                            style: {
                                border: '1px solid #82828234',
                                borderRight: 'none',
                                borderBottom: 'none',
                                backgroundColor: '#F9F9FF'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "top-area h40vh",
                                    children: stepTab == 2 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            isPrequelQues ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pr",
                                                style: {
                                                    right: '130px'
                                                },
                                                src: (parcelRequire("5NO0k")),
                                                alt: ""
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pr",
                                                style: {
                                                    right: '130px'
                                                },
                                                src: (parcelRequire("8Dtkj")),
                                                alt: ""
                                            }),
                                            !isPrequelQues && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                class: "w100 df jcc",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                    onClick: ()=>handleChecklistNext(moduleName),
                                                    "data-tooltip": moduleName ? 'Checklist Created! you can click Next to view checklist' : 'Your checklist creation is in progress, please wait!',
                                                    className: `shadow c1 fw400 fs1rem pr br38px w300px py0-5rem mt1rem df aic jcc ${moduleName ? 'bg4 bg3-hover cp' : 'bg16 cna'}`,
                                                    children: [
                                                        "Ok, next",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            className: "icon pr ml0-5rem",
                                                            style: {
                                                                top: '3px'
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                width: "30",
                                                                height: "30",
                                                                viewBox: "0 0 30 30",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                    d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                                    fill: "white"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "bottom-checklist pb1rem h50vh df fww ",
                                    style: {
                                        width: '85%',
                                        alignContent: 'flex-end'
                                    },
                                    children: !isPrequelQues && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: Object.values(tabs).map((item, idx)=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                className: `df aic checklist-btn bo20 bw1px bss br15px bg0 w100 tal mb0-5rem bsbb cp ${stepTab == idx + 1 && ' active'}`,
                                                children: [
                                                    stepTab > idx + 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        className: "number-area bo20 bw2px bss tac br100 w2rem h2rem pr",
                                                        src: (parcelRequire("8MWG0")),
                                                        alt: ""
                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                        className: "number-area bo20 bw2px bss tac br100 w2rem h2rem pr",
                                                        children: idx + 1
                                                    }),
                                                    " ",
                                                    item
                                                ]
                                            });
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "partnerChecklistPopup",
                open: modal['open'] == 'partnerChecklistPopup',
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-5rem c15 mb1rem",
                                            children: "Performing checklist creation magic!"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar module-progress-bar`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: [
                                                "This may take couple of minutes ",
                                                Object.keys(selectedCompany).length > 0 && ', meanwhile you can check Free Bonus KPI Report.'
                                            ]
                                        }),
                                        Object.keys(selectedCompany).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    class: "w100 df jcc",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                        disabled: isGenerateKPI,
                                                        onClick: ()=>generateKPIReport(),
                                                        className: `df aic jcc pr cp shadow c1 fw400 fs1rem br38px w300px h3rem ${isGenerateKPI ? 'bg16 cna' : 'bg4 bg3-hover'}`,
                                                        children: [
                                                            "Free KPI Report",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                className: "icon pr ml0-5rem",
                                                                style: {
                                                                    top: '3px'
                                                                },
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                                    width: "30",
                                                                    height: "30",
                                                                    viewBox: "0 0 30 30",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                                        fill: "white"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pa",
                                    style: {
                                        top: '10px',
                                        right: '-345px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("eWGre")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $45fvw = parcelRequire("45fvw");







var $472fc6d2654aeb65$var$CloseBtn = function CloseBtn(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "m10.274 9.002 3.864-3.864a.9.9 0 1 0-1.273-1.273L9.002 7.73 5.138 3.865a.9.9 0 1 0-1.273 1.273L7.73 9.002l-3.864 3.863a.9.9 0 1 0 1.273 1.273l3.864-3.864 3.863 3.864a.897.897 0 0 0 1.273 0 .9.9 0 0 0 0-1.273l-3.864-3.863Z",
            fill: "#4C4B4B",
            opacity: ".7"
        })
    });
};
$472fc6d2654aeb65$var$CloseBtn.defaultProps = {
    width: "18",
    height: "18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};




function $472fc6d2654aeb65$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { id: companyIdFromRoute } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    // Company can arrive via navigation state (ResearchAid tab) or Redux (selectedCompany). When opened
    // from the dashboard, a direct link, or after a refresh, neither may include companyDescription /
    // researchAidReports, so the effect below fetches the lightweight company by the URL id.
    const [company, setLocalCompany] = (0, $acw62.useState)(()=>location.state?.company || selectedCompany);
    let [isLoadingCompany, setIsLoadingCompany] = (0, $acw62.useState)(false);
    // const reportType = new URLSearchParams(location.search).keys().next().value;
    let [prompt, setPrompt] = (0, $acw62.useState)('');
    let [reportId, setReportId] = (0, $acw62.useState)();
    let [reportType, setReportType] = (0, $acw62.useState)();
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [reportData, setReportData] = (0, $acw62.useState)({});
    let [showFiles, setShowFiles] = (0, $acw62.useState)(false);
    let [isGenerateFocusAreas, setIsGenerateFocusAreas] = (0, $acw62.useState)(true);
    let [focusArea, setFocusArea] = (0, $acw62.useState)({
        focus1: '',
        focus2: '',
        focus3: ''
    });
    let [focusAreaCount, setFocusAreaCount] = (0, $acw62.useState)({
        focus1: 0,
        focus2: 0,
        focus3: 0
    });
    // OPTIMIZATION: Lazy load reports when not available (excluded in lightweight mode)
    let [reports, setReports] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        const routeId = companyIdFromRoute;
        if (!routeId) return;
        const candidate = location.state?.company || selectedCompany;
        // Use the in-memory company only if it matches the route AND already has the full data we need
        // (companyDescription). Otherwise fetch the lightweight company so description + reports render.
        if (candidate?._id && String(candidate._id) === String(routeId) && candidate?.['companyDescription']) {
            setLocalCompany(candidate);
            return;
        }
        let cancelled = false;
        const fetchCompanyLight = async ()=>{
            setIsLoadingCompany(true);
            try {
                setIsLoading(true);
                const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/modules/company-light/${routeId}`);
                if (cancelled) return;
                if (res?.['code'] === 200 && res?.['body']) {
                    setLocalCompany(res['body']);
                    dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({
                        ...res['body'],
                        from: 'researchAid'
                    }));
                }
            } catch (e) {
                if (!cancelled) console.error('Failed to fetch company light:', e);
            } finally{
                if (!cancelled) {
                    setIsLoadingCompany(false);
                    setIsLoading(false);
                }
            }
        };
        fetchCompanyLight();
        return ()=>{
            cancelled = true;
        };
    }, [
        companyIdFromRoute,
        location.state?.company,
        selectedCompany,
        dispatch
    ]);
    // Fetch reports if not available
    (0, $acw62.useEffect)(()=>{
        const fetchReports = async ()=>{
            if (company?._id && company?.['reportsCount'] !== undefined && !company?.['researchAidReports'] && !company?.['customReports']) try {
                setIsLoading(true);
                const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/${company._id}/reports`);
                if (response['code'] == 200 && response['body']?.['reports']) {
                    // Merge both report arrays
                    const allReports = [
                        ...response['body']['reports']['researchAidReports'] || [],
                        ...response['body']['reports']['customReports'] || []
                    ];
                    setReports(allReports);
                }
            } catch (e) {
                console.error('Failed to fetch reports:', e);
            } finally{
                setIsLoading(false);
            }
        };
        fetchReports();
    }, [
        company?._id,
        company?.['reportsCount']
    ]);
    (0, $acw62.useEffect)(()=>window.scrollTo(0, 0), []);
    (0, $acw62.useEffect)(()=>{
        if (window.location.hash) {
            reportId = window.location.hash.split('?')[0];
            reportType = window.location.hash.split('?')[1];
            if (reportType) setReportType(reportType);
            if (reportId) {
                reportId = reportId.replaceAll('#', '');
                setReportId(reportId);
            }
        } else {
            reportType = window.location.search;
            if (reportType) {
                reportType = reportType.replaceAll('?', '');
                setReportType(reportType);
            }
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (reportData?.['fileurl'] && reportData['fileurl'].length > 0) {
            reportData['fileurl'].map((file)=>attachment.push(file));
            setAttachment(attachment);
            setShowFiles(true);
        }
    }, [
        reportData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (company?.['_id']) {
            // Use lazy-loaded reports or fallback to company data
            const customReports = company?.['customReports'] || reports.filter((r)=>r.reportType === 'customReport');
            const researchAidReports = company?.['researchAidReports'] || reports;
            if (reportId && reportType == 'customReport') customReports?.filter((report)=>{
                if (report['_id'] == reportId) {
                    setReportData(report);
                    setPrompt(report['prompt']);
                }
            });
            else if (reportId && reportType) researchAidReports?.filter((report)=>{
                if (report['_id'] == reportId) setReportData(report);
            });
            else researchAidReports?.filter((report)=>{
                if (report['reportType'] == reportType) setReportData(report);
            });
        }
        if (company?.['_id'] && reportType && isGenerateFocusAreas) {
            setIsGenerateFocusAreas(false);
            generateFocusAreas(company['_id'], reportType);
        }
    }, [
        company,
        reportId,
        reportType,
        reports
    ]);
    const generateFocusAreas = async (companyId, reportType)=>{
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/generateFocusAreas`, {
            companyId: companyId,
            reportType: reportType
        });
        if (res?.['code'] == '200') {
            let prepopulateFiles = res['body']['files'];
            let prepopulateFocusArea = res['body']['focusArea'];
            if (prepopulateFiles && prepopulateFiles.length > 0) {
                prepopulateFiles.map((file)=>attachment.push(file));
                setAttachment(attachment);
                setShowFiles(true);
            }
            if (prepopulateFocusArea) {
                if (prepopulateFocusArea['focus1']) setFocusArea({
                    ...focusArea,
                    focus1: prepopulateFocusArea['focus1']
                });
                if (prepopulateFocusArea['focus2']) setFocusArea({
                    ...focusArea,
                    focus2: prepopulateFocusArea['focus2']
                });
                if (prepopulateFocusArea['focus3']) setFocusArea({
                    ...focusArea,
                    focus3: prepopulateFocusArea['focus3']
                });
            }
        }
    };
    const handleAreaFocus = async (e)=>{
        if (e.target.value.length <= 200) {
            setFocusArea({
                ...focusArea,
                [e.target.name]: e.target.value
            });
            focusAreaCount = {
                ...focusAreaCount,
                [e.target.name]: e.target.value.length
            };
            setFocusAreaCount(focusAreaCount);
        }
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e)=>{
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        const fileInput = e.currentTarget.querySelector("input[type='file']");
        if (fileInput) fileInput.value = null; // Reset the input field
        handleFileUpload(e);
    };
    const handleFileUpload = (e)=>{
        if (e.target.files) {
            setShowFiles(false);
            for (const file of e.target.files)attachment.push(file);
            e.preventDefault();
            setAttachment(attachment);
            setTimeout(()=>setShowFiles(true), 100);
            const fileInput = e.currentTarget.querySelector("input[type='file']");
            if (fileInput) fileInput.value = null; // Reset the input field
        }
    };
    const deleteUploadedFile = (file)=>{
        setShowFiles(false);
        let index = attachment.indexOf(file);
        if (index > -1) attachment.splice(index, 1);
        setAttachment(attachment);
        setTimeout(()=>setShowFiles(true), 100);
    };
    const handleGenerateReport = async ()=>{
        if (reportType == 'customReport' && prompt == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter the required prompt');
        try {
            let data, res;
            if (reportType == 'customReport') {
                if (reportId) data = {
                    reportId: reportId,
                    reportType: reportType,
                    prompt: prompt,
                    attachment: attachment,
                    focusArea: focusArea
                };
                else data = {
                    reportType: reportType,
                    prompt: prompt,
                    attachment: attachment,
                    focusArea: focusArea
                };
            } else data = {
                reportType: reportType,
                query: 'create a detailed report using provided system message',
                attachment: attachment,
                focusArea: focusArea
            };
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'generateResearchAid'
            }));
            if (reportType == 'customReport') res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/customReport/${company['_id']}`, data);
            else res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/generateReport/${company['_id']}`, data);
            if (res['code'] == 200) {
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
                window.location.href = `/company/${company['_id']}#${res['body']['reportId']}?${reportType}-researchaid`;
            } else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
        } catch (error) {
            console.error(error);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Something went wrong.');
        }
    };
    if (isLoadingCompany) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
        message: "Loading..."
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        class: "w100 df jcc pt3rem pb2rem research-genrate-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc w80 px3rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        class: "df",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                disabled: isLoading,
                                to: `/company/${companyIdFromRoute}`,
                                onClick: ()=>localStorage.setItem('isResearchAid', true),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    className: "cp mr1rem",
                                    width: "22",
                                    height: "16",
                                    viewBox: "0 0 22 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                        fill: "#151313"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                class: "w100 c15 fs1-25rem fw500 mb0-5rem",
                                children: reportData?.['name'] ? reportData['name'] : 'Create Your ResearchAid Report'
                            })
                        ]
                    }),
                    reportData?.['updatedAt'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        class: "w100 fs1rem c36 fw300",
                        children: [
                            "Last edited ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(reportData['updatedAt']).format('ll')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "w100 c15 fs1rem fw400 lh2 my1rem",
                        children: [
                            "1. Description ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem c16 fsi",
                                children: "(predefined)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        rows: "8",
                        className: "bg1 bss bw2px bo5 w100 br10px p1rem mb1rem fs0-75rem c12",
                        value: company?.['companyDescription'] || '',
                        readOnly: true
                    }),
                    reportType == 'customReport' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "w100 c15 fs1rem fw400 lh2 mb0-5rem",
                                children: [
                                    "Prompt * ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "fs0-75rem c16 fsi",
                                        children: "(required)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                value: prompt || reportData?.['prompt'],
                                onChange: (e)=>setPrompt(e.target.value),
                                rows: "6",
                                className: "bg1 bss bw2px bo5 w100 br10px p1rem mb2rem fs0-75rem c12"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "w100 c15 fs1rem fw500 lh2 my0-5rem",
                        children: [
                            "2. Areas of your specific focus ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem c16 fsi",
                                style: {
                                    color: '#15131330'
                                },
                                children: "(optional)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "w100 c15 fs0-875rem fw400 lh2 mb1rem",
                        children: "To increase relevance you are welcome to add up to three areas of your specific report focus "
                    }),
                    [
                        'focus1',
                        'focus2',
                        'focus3'
                    ].map((item, idx)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb-05rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    className: "c15 fs0-75rem my0-5rem db w100",
                                    children: [
                                        "0",
                                        idx + 1,
                                        " - Area of focus"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    value: focusArea[item] || reportData?.['focusArea']?.[item],
                                    onChange: (e)=>handleAreaFocus(e),
                                    onBlur: (e)=>handleAreaFocus(e),
                                    onInput: (e)=>handleAreaFocus(e),
                                    rows: "3",
                                    style: {
                                        background: '#F4FFE1'
                                    },
                                    name: item,
                                    className: "bss bw2px bo5 w100 br10px p1rem mb1rem fs0-75rem",
                                    placeholder: "Write your objective focus in your own words (up to 200 characters max)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: `pa b0 r0 mb2rem mr1rem fs0-75rem ${focusAreaCount[item] >= 199 ? 'c4' : 'c16'}`,
                                    children: [
                                        focusAreaCount[item],
                                        "/200"
                                    ]
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "w100 c15 fs1rem fw500 lh2 mt1rem mb0-5rem",
                        children: [
                            "3. Add files ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs0-75rem c16 fsi",
                                style: {
                                    color: '#15131330'
                                },
                                children: "(optional)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "w100 c15 fs0-875rem fw400 lh2 mb1rem",
                        children: "If you have any document that will add context or background to this report, please upload it here. "
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        onDragOver: onDragOver,
                        onDrop: (e)=>onDrop(e),
                        for: "fileUpload",
                        className: "w100 bsbb bg50 br5px df jcc fdc aic px2rem py1rem bsd bo3 bw2px cp mb0-5rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "70",
                                height: "70",
                                viewBox: "0 0 70 70",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M59.4632 31.0446C58.5439 25.1606 53.4429 20.6445 47.3047 20.6445C44.9955 20.6445 42.7766 21.2834 40.852 22.4751C37.924 17.5543 32.6528 14.4922 26.7969 14.4922C17.7506 14.4922 10.3906 21.8522 10.3906 30.8984C10.3906 30.9545 10.3906 31.0126 10.3927 31.0687C4.57871 32.048 0 37.1168 0 43.2031C0 49.9883 5.65619 55.5078 12.4414 55.5078H57.5586C64.3438 55.5078 70 49.9883 70 43.2031C70 37.0649 65.3472 31.9639 59.4632 31.0446Z",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                        "clip-path": "url(#clip0_5984_51759)",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M35 56C42.732 56 49 49.732 49 42C49 34.268 42.732 28 35 28C27.268 28 21 34.268 21 42C21 49.732 27.268 56 35 56Z",
                                                fill: "#4A67FF"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M34.9896 49.6555C33.746 49.6555 32.5026 49.6555 31.2593 49.6555C29.5542 49.6555 28.3237 48.4294 28.315 46.7248C28.3117 46.1298 28.3117 45.5346 28.315 44.9392C28.3182 44.3256 28.6901 43.9308 29.2589 43.9297C29.8276 43.9286 30.2044 44.3207 30.2082 44.9338C30.2121 45.5468 30.2082 46.1456 30.2082 46.7516C30.2126 47.387 30.5861 47.7573 31.2238 47.7578C33.7427 47.7578 36.2614 47.7578 38.78 47.7578C39.4182 47.7578 39.7922 47.387 39.7971 46.7521C39.8015 46.1462 39.7971 45.5402 39.7971 44.9343C39.7971 44.3284 40.175 43.9286 40.746 43.9297C41.3169 43.9308 41.6943 44.3256 41.6893 44.9387C41.6833 45.7136 41.7265 46.4967 41.6292 47.2613C41.4509 48.6602 40.2582 49.6478 38.8429 49.6544C37.5615 49.6582 36.2753 49.6555 34.9896 49.6555Z",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M34.0577 37.6102C33.9133 37.7448 33.8286 37.8186 33.7498 37.8979C33.1439 38.5098 32.5412 39.1256 31.9325 39.7354C31.5005 40.1685 30.8984 40.2002 30.5079 39.8212C30.1175 39.4423 30.1328 38.8205 30.5577 38.3928C31.7947 37.1481 33.0358 35.9078 34.2808 34.6719C34.7183 34.2344 35.2904 34.2344 35.7279 34.6719C36.9813 35.9151 38.2296 37.1636 39.4729 38.4174C39.8819 38.8303 39.8841 39.451 39.504 39.8218C39.124 40.1926 38.5197 40.1762 38.1024 39.7622C37.4844 39.147 36.8758 38.5219 36.2622 37.9028C36.1829 37.823 36.0981 37.7486 35.9718 37.6294C35.9636 37.8011 35.9537 37.9121 35.9537 38.0231C35.9537 39.9804 35.9565 41.9371 35.9537 43.8944C35.9537 44.6288 35.3073 45.0658 34.6352 44.8044C34.2633 44.6595 34.0615 44.3368 34.0615 43.8643C34.0593 41.9284 34.0593 39.9926 34.0615 38.057L34.0577 37.6102Z",
                                                fill: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                            id: "clip0_5984_51759",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                width: "28",
                                                height: "28",
                                                fill: "white",
                                                transform: "translate(21 28)"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "pen fs1rem fw500 c49 tac op80 mt1rem mb2rem fsi",
                                children: "Click here or drag and drop files (max 10MB)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                onChange: (e)=>handleFileUpload(e),
                                className: "dn",
                                id: "fileUpload",
                                type: "file",
                                multiple: true,
                                accept: "application/*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fww my1rem mah20 oscy",
                        children: showFiles && attachment.length > 0 && attachment.map((file)=>{
                            let fileName;
                            if (file?.['name']) fileName = file['name'];
                            else {
                                fileName = file.split('/');
                                fileName = fileName[fileName.length - 1];
                            }
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `df jcc aic br5px lh1 px1rem py0-5rem fw600 mr0-5rem mb0-5rem cp pr pageCutBg upload-file`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "py0-5rem pl0-5rem",
                                        children: fileName
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($472fc6d2654aeb65$var$CloseBtn, {
                                        onClick: ()=>deleteUploadedFile(file),
                                        className: "mx1rem"
                                    })
                                ]
                            });
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 pr b0 df jcsb px2rem pr4rem mt2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "c15 fs1rem"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                onClick: ()=>handleGenerateReport(),
                                className: `shadow c1 fw400 fs1rem pr br38px w200px h3rem df aic jcc bg4 bg3-hover cp`,
                                children: [
                                    "Ok, next",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: "icon pr ml0-5rem",
                                        style: {
                                            top: '3px'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "30",
                                            height: "30",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M6.42954 17.0154H21.1966L16.7035 22.1842C15.413 23.6688 17.3488 25.8957 18.6394 24.4111L22.7314 19.6964L25.463 16.5491C25.9924 15.9365 25.9924 14.9471 25.463 14.3344L18.6394 6.47557C18.3798 6.16869 18.0225 5.99649 17.6502 6.00005C16.4212 6.00023 15.818 7.72225 16.7035 8.70263L21.2073 13.8714H6.35888C4.46611 13.9794 4.60744 17.1238 6.42954 17.0154Z",
                                                fill: "white"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w20 sidebar-researchaid-img",
                style: {
                    border: '1px solid #82828234',
                    borderRight: 'none',
                    borderBottom: 'none',
                    backgroundColor: '#F9F9FF'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "pa",
                    style: {
                        right: '10px'
                    },
                    src: (parcelRequire("4kGay")),
                    alt: "research-aid-ai"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "generateResearchAid",
                open: modal['open'] == 'generateResearchAid',
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg1 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "creaing-modal pr mb3rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df jcc",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w10rem",
                                        src: (parcelRequire("hA45b")),
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "text-box w90 df jcc tac fdc mla mra",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            className: "fs1-25rem fw500 c15 mb1rem",
                                            children: "Generating Your Diligentsia ResearchAid Report"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "my1rem tac",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "checklist-progress",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `checklist-progress-bar questions-progress-bar`
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c15 fs1rem mt1rem",
                                            children: "This may take a few minutes"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img-box pa",
                                    style: {
                                        top: '10px',
                                        right: '-345px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "",
                                        src: (parcelRequire("29DXw")),
                                        alt: ""
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");


parcelRequire("acw62");






const $05ee9988ffef0fd3$var$ManualAdd = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w100 df fdc px8rem",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df ais jcsb",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        class: "df fdc pt2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/investor-dashboard#index?QualifiedLeads",
                                className: "w100 cp mb0-5rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "22",
                                    height: "16",
                                    viewBox: "0 0 22 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z",
                                        fill: "#151313"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "w100 fs1-5rem fw300 c15",
                                children: "Add Applicant"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "w100 fs2rem fw500 c15",
                                children: [
                                    "Investor",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "c4",
                                        children: "Match"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (parcelRequire("htxVj")),
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pr w100 bg5 br15px df fdc aic p3rem",
                style: {
                    top: '-110px'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "fs1-5rem c15 mb2rem",
                        children: "How it works"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        class: "w90",
                        src: (parcelRequire("gJSKe")),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "tac fs14px c12",
                        children: [
                            "Diligentsia provides tools, not financial advice, to help match investors and companies. We do not receive commissions from investors and are not liable for the ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "consequences of investment decisions by any party.  In completing your One",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "c4",
                                children: "Form"
                            }),
                            " you confirm that you are happy for the information you provide to be shared ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "with applicants on our database"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "pr w100 df jcc",
                style: {
                    top: '-70px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: 'addApplicantPopup'
                        })),
                    className: "df jcc cp c1 bg4 fw400 fs1rem br38px w300px py0-5rem",
                    children: "Let's Go!"
                })
            })
        ]
    });
};
var $05ee9988ffef0fd3$export$2e2bcd8739ae039 = $05ee9988ffef0fd3$var$ManualAdd;



var $ayMG0 = parcelRequire("ayMG0");




var $acw62 = parcelRequire("acw62");



































function $d6c8fd5efa964b3d$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let [showList, setShowList] = (0, $acw62.useState)([]);
    let [isLoggedInViaLink, setIsLoggedInViaLink] = (0, $acw62.useState)(false);
    let [companyId, setCompanyId] = (0, $acw62.useState)(null);
    let [passwordError, setPasswordError] = (0, $acw62.useState)('');
    let [password, setPassword] = (0, $acw62.useState)({
        newPassword: '',
        newPasswordType: true,
        confirmPassword: '',
        confirmPasswordType: true
    });
    let PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let [step3Hover, setStep3Hover] = (0, $acw62.useState)(null); // Angel Groups step-3 hover: 'accepted' | 'unsuccessful' | null
    let climb26OneFormList = [
        'Add your Pitch Deck',
        'Answer quick questions (most multiple choice)',
        'We match your criteria against our investor database',
        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Detailed Investor",
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    class: "c4 mr0-5rem",
                    children: "Match"
                }),
                " Report on each VC from your dashboard"
            ]
        })
    ];
    let eheOneFormList = [
        'Add your Pitch Deck',
        'Answer 6 quick questions',
        'We quickly match your business against our criteria',
        'Whatever the result - we`ll give you a complementary pitch analysis'
    ];
    let seedlogalsOneFormList = [
        'One application form - see whether you match to 40+ VC/PE investors',
        'Complete investment readiness checklist - impress your investors',
        'Complementary set of ResearchAid Reports',
        'Save time. Quicker deals. Lower professional fees',
        'Upgrade for further diligence modules and 1-click introductions',
        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Return to ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    className: "mx0-5rem",
                    src: (parcelRequire("47A80")),
                    alt: ""
                }),
                " for transaction documentation "
            ]
        })
    ];
    let oneFormList = [
        'One application form - see whether you match to 40+ VC/PE investors',
        'Complete investment readiness checklist - impress your investors',
        'Complementary set of ResearchAid Reports',
        'Save time. Quicker deals. Lower professional fees',
        'Upgrade for further diligence modules and 1-click introductions'
    ];
    (0, $acw62.useEffect)(()=>{
        let urlParams = new URLSearchParams(location?.search);
        let token = urlParams.get('token');
        let cId = urlParams.get('companyId');
        if (token) {
            (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(token);
            localStorage.setItem('token', token);
            getUser();
            setIsLoggedInViaLink(true);
            setCompanyId(cId);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (user?.['type'] == 'Superflow' && user?.['partnerId'] && !user['isAgreeWithDisclaimer'] && !isLoggedInViaLink) dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'disclaimerModal'
        }));
    }, [
        user,
        isLoggedInViaLink
    ]);
    (0, $acw62.useEffect)(()=>{
        let pathname = location.pathname.split('/');
        if (pathname) {
            let partnerId = pathname[pathname.length - 1];
            if (partnerId) getPartner(partnerId);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (partner && partner?.['name'] == 'Climb26 Super Flow') setShowList(climb26OneFormList);
        else if (partner && partner?.['name'] == 'EHE Super Flow') setShowList(eheOneFormList);
        else if (partner && partner?.['name'] == 'Seedlegals Super Flow') setShowList(seedlogalsOneFormList);
        else setShowList(oneFormList);
    }, [
        partner
    ]);
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)('/user');
        if (response['code'] == 200 && response['body']) dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(response['body']['user']));
    };
    const handleSetPassword = async ()=>{
        if (password['newPassword'] == '' || password['confirmPassword'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter both passwords!');
        if (password['newPassword'] != password['confirmPassword']) return setPasswordError('Passwords don`t match!');
        if (!PASSWORD_PATTERN.test(password['newPassword'])) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Password must contain atleast one capital letter, one special character and a number');
            setPasswordError('Password must contain atleast one capital letter, one special character and a number');
            return;
        }
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/setPassword', {
            key: user['email'],
            password: password['newPassword']
        });
        if (res && res['code'] == 200) {
            const typeRes = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
                type: 'Superflow'
            });
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ''
            }));
            if (typeRes) window.location.href = `/company/${companyId}#investor-lead`;
        }
    };
    const getPartner = async (id)=>{
        setIsLoader({
            show: true,
            message: 'Loading Partner...'
        });
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/${id}`);
        if (res['code'] == 200) {
            dispatch((0, $3d3d7a2ee763f32a$export$6af6109222273956)(res['body']));
            setTimeout(()=>setIsLoader({
                    show: false,
                    message: 'Loading...'
                }), 1000);
        } else {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
            setTimeout(()=>window.location.href = '/homepage', 500);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            Object.keys(partner).length > 0 && !isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc w100 super-flow-page",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb aic px8rem sm-px0rem mb1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc",
                                children: [
                                    partner && partner?.['name'] == 'Angel Groups Super Flow' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 fs15px c12 mb1rem",
                                        children: "Recommended for all AngelGroups Applicants"
                                    }),
                                    partner && partner?.['name'] == 'British Design Fund Super Flow' && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "w100 fs15px c12 mb1rem",
                                        children: "Recommended for all BritishDesignFund Applicants"
                                    }),
                                    partner && partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw500 w100 c15",
                                        children: [
                                            "Investor",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c4",
                                                children: "Match"
                                            }),
                                            " - Identify Relevant ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Investors Before Show Attendance"
                                        ]
                                    }) : partner && partner?.['name'] == 'EHE Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw500 w100 c15",
                                        children: [
                                            "We Use Investor",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c4",
                                                children: "Match"
                                            }),
                                            " To Simplify  ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Your Search For Investment"
                                        ]
                                    }) : partner && partner?.['name'] == 'Angel Groups Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw600 w100 c15 lh2",
                                        children: [
                                            "Let's Help You Speed Up ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Our ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c58",
                                                children: "Acceptance Decision"
                                            })
                                        ]
                                    }) : partner && partner?.['name'] == 'British Design Fund Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw600 w100 c15 lh2",
                                        children: [
                                            "Let's Help You Speed Up ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Our ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "c39",
                                                children: "Acceptance Decision"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw500 w100 c15 lh2",
                                        children: [
                                            "Investment Ready? Want to Be ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Matched With Investors? For FREE?"
                                        ]
                                    }),
                                    partner && partner?.['name'] == 'Angel Groups Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs1rem fw300 w100 c14 mt0-5rem",
                                        children: [
                                            "Diligentsia is the UK's leading automated diligence platform \u2014 trusted by VCs, ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " advisors and founders like you"
                                        ]
                                    }) : partner && partner?.['name'] == 'British Design Fund Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs1rem fw300 w100 c14 mt0-5rem",
                                        children: [
                                            "Diligentsia is the UK's leading automated diligence platform \u2014 trusted by VCs, ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " advisors and founders like you"
                                        ]
                                    }) : partner && partner?.['name'] != 'Climb26 Super Flow' && partner?.['name'] != 'EHE Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs1rem fw300 w100 c14 mt0-5rem",
                                        children: [
                                            "Investors invest in <1% of unsolicited applications to their web sites. Improve your chances ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " by first getting matched and then demonstrate to them that you are \u201Cinvestment-ready\u201D. "
                                        ]
                                    }) : null,
                                    partner && (partner?.['name'] == 'Angel Groups Super Flow' || partner?.['name'] == 'British Design Fund Super Flow') && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "w100 df mt5rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: `${$16250bd714b02a14$export$51e82cdd7353a0e1}#${partner['_id']}?Superflow`,
                                                className: "df jcc cp c1 bg3 bg4-hover fw400 fs1rem br38px px2rem py1rem mr1rem",
                                                children: "+ Start For FREE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: `https://koalendar.com/e/meet-with-mark-bernstein`,
                                                target: "_blank",
                                                className: "df jcc cp c3 bg1 fw400 fs1rem bs1px bo3 br38px px2rem py1rem",
                                                children: "Book a call"
                                            })
                                        ]
                                    }),
                                    partner && (partner?.['name'] == 'Angel Groups Super Flow' || partner?.['name'] == 'British Design Fund Super Flow') && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "w100 fs10px c12 mt1rem ml1rem",
                                        children: [
                                            "An ",
                                            partner?.['name'] == 'Angel Groups Super Flow' ? 'Angelgroups' : 'BDF',
                                            "  benefit - No credit card  \xb7 Takes 30 minutes \xb7  Free"
                                        ]
                                    })
                                ]
                            }),
                            partner && partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("5I8Ls")),
                                alt: ""
                            }) : partner && partner?.['name'] == 'EHE Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("bc4ez")),
                                alt: ""
                            }) : partner && partner?.['name'] == 'Seedlegals Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("dl4Qp")),
                                alt: ""
                            }) : partner && partner?.['name'] == 'SU2SU Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df my5rem",
                                src: (parcelRequire("79gM3")),
                                alt: ""
                            }) : partner && partner?.['name'] == 'Angel Groups Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df w30 my2rem mr4rem",
                                src: (parcelRequire("1z0JF")),
                                alt: ""
                            }) : partner && partner?.['name'] == 'British Design Fund Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df w30 my2rem mr4rem",
                                src: (parcelRequire("aBAKs")),
                                alt: ""
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("iWPnk")),
                                alt: ""
                            })
                        ]
                    }),
                    partner && (partner?.['name'] == 'Angel Groups Super Flow' || partner?.['name'] == 'British Design Fund Super Flow') ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df fdc aic bg20 py4rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs1-75rem fw600 c15",
                                children: "Speeding Your Journey To Funding"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "mt2rem",
                                src: (parcelRequire("2jAKB")),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df jcc aifs fww gg1rem w100 mt2rem bsbb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("cqG6l")),
                                            alt: "Check your investment readiness"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: partner?.['name'] == 'Angel Groups Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("2NoJu")),
                                            alt: "Initial screening decision by AngelGroups"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "",
                                            src: (parcelRequire("kYJGG")),
                                            alt: "Initial screening decision by AngelGroups"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr df fdc",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "cp",
                                                onMouseEnter: ()=>setStep3Hover('accepted'),
                                                onMouseLeave: ()=>setStep3Hover(null),
                                                src: step3Hover === 'accepted' ? (parcelRequire("lGMEG")) : (parcelRequire("bzTgU")),
                                                alt: "Accepted \u2014 let's help you create your diligence pack"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "w10 pr zi2",
                                                style: {
                                                    left: '70px',
                                                    bottom: '70px'
                                                },
                                                src: (parcelRequire("cSf3N")),
                                                alt: "Or"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "pr cp",
                                                style: {
                                                    bottom: '130px'
                                                },
                                                onMouseEnter: ()=>setStep3Hover('unsuccessful'),
                                                onMouseLeave: ()=>setStep3Hover(null),
                                                src: step3Hover === 'unsuccessful' ? (parcelRequire("af8S3")) : (parcelRequire("928kb")),
                                                alt: "Unsuccessful \u2014 let's InvestorMatch you to other investors"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            partner?.['name'] == 'Angel Groups Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-75rem c12",
                                children: "Upgrade* = plans from \xa39 per month; \u201CANGELG20\u201D unlocks 20% discount on Pro \u2013 from \xa363.25 per month"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "fs0-75rem c12",
                                children: "Upgrade* = plans from \xa39 per month; \u201CBDF20\u201D unlocks 20% discount on Pro \u2013 from \xa363.25 per month"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "super-flow df aic jcc fww w100 bg38 br35px gg1-5rem py2rem mx6rem mb4rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50 text-box pl3rem",
                                    children: [
                                        partner && (partner?.['name'] == 'Climb26 Super Flow' || partner?.['name'] == 'EHE Super Flow') ? /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                            className: "c15 fs1-5rem df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        "Complete One",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            class: "c4 mr0-25rem",
                                                            children: "Form"
                                                        }),
                                                        " once"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "ml5rem mb1rem w3rem h3rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "73",
                                                        height: "73",
                                                        viewBox: "0 0 73 73",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M58.8111 21.6562C56.1404 18.3011 52.7474 15.5914 48.8846 13.729C45.0219 11.8667 40.7888 10.8994 36.5005 10.8994C32.2122 10.8994 27.979 11.8667 24.1163 13.729C20.2535 15.5914 16.8605 18.3011 14.1899 21.6562C-0.672507 40.2712 12.6728 67.9199 36.5005 67.9199C60.3281 67.9199 73.6963 40.294 58.8111 21.6562ZM53.9406 54.107C51.7993 56.6466 49.129 58.6879 46.1166 60.0882C43.1042 61.4885 39.8224 62.214 36.5005 62.214C33.1786 62.214 29.8967 61.4885 26.8843 60.0882C23.8719 58.6879 21.2017 56.6466 19.0603 54.107C6.53624 39.2903 17.1896 16.5918 36.5005 16.5918C55.8113 16.5918 66.4646 39.2789 53.9406 54.107Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M37.6411 21.1538C37.6411 21.4563 37.5209 21.7464 37.307 21.9604C37.0931 22.1742 36.803 22.2944 36.5005 22.2944C36.198 22.2944 35.9078 22.1742 35.6939 21.9604C35.48 21.7464 35.3599 21.4563 35.3599 21.1538C35.3599 20.8513 35.48 20.5611 35.6939 20.3473C35.9078 20.1333 36.198 20.0132 36.5005 20.0132C36.803 20.0132 37.0931 20.1333 37.307 20.3473C37.5209 20.5611 37.6411 20.8513 37.6411 21.1538Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M37.6411 57.6538C37.6411 57.9563 37.5209 58.2464 37.307 58.4604C37.0931 58.6742 36.803 58.7944 36.5005 58.7944C36.198 58.7944 35.9078 58.6742 35.6939 58.4604C35.48 58.2464 35.3599 57.9563 35.3599 57.6538C35.3599 57.3513 35.48 57.0611 35.6939 56.8473C35.9078 56.6333 36.198 56.5132 36.5005 56.5132C36.803 56.5132 37.0931 56.6333 37.307 56.8473C37.5209 57.0611 37.6411 57.3513 37.6411 57.6538Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M54.7505 40.5444C54.448 40.5444 54.1578 40.4242 53.9439 40.2104C53.73 39.9964 53.6099 39.7063 53.6099 39.4038C53.6099 39.1013 53.73 38.8111 53.9439 38.5973C54.1578 38.3833 54.448 38.2632 54.7505 38.2632C55.053 38.2632 55.3431 38.3833 55.557 38.5973C55.7709 38.8111 55.8911 39.1013 55.8911 39.4038C55.8911 39.7063 55.7709 39.9964 55.557 40.2104C55.3431 40.4242 55.053 40.5444 54.7505 40.5444Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M18.2505 40.5444C17.948 40.5444 17.6578 40.4242 17.4439 40.2104C17.23 39.9964 17.1099 39.7063 17.1099 39.4038C17.1099 39.1013 17.23 38.8111 17.4439 38.5973C17.6578 38.3833 17.948 38.2632 18.2505 38.2632C18.553 38.2632 18.8431 38.3833 19.057 38.5973C19.2709 38.8111 19.3911 39.1013 19.3911 39.4038C19.3911 39.7063 19.2709 39.9964 19.057 40.2104C18.8431 40.4242 18.553 40.5444 18.2505 40.5444Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M24.3985 25.7164C24.5488 25.9359 24.6176 26.2011 24.5929 26.466C24.5683 26.7309 24.4518 26.9789 24.2637 27.1671C24.0755 27.3551 23.8277 27.4716 23.5627 27.4962C23.2978 27.5208 23.0326 27.4521 22.8131 27.3018C22.6628 27.0822 22.5941 26.8171 22.6187 26.5521C22.6432 26.2873 22.7597 26.0393 22.9478 25.8511C23.136 25.663 23.384 25.5466 23.6488 25.522C23.9138 25.4974 24.1789 25.5661 24.3985 25.7164Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M50.1879 51.5059C50.3381 51.7255 50.4069 51.9907 50.3823 52.2556C50.3576 52.5205 50.2412 52.7685 50.053 52.9566C49.865 53.1448 49.617 53.2612 49.352 53.2858C49.0872 53.3104 48.822 53.2416 48.6024 53.0914C48.4522 52.8719 48.3834 52.6066 48.408 52.3418C48.4326 52.0768 48.549 51.8289 48.7372 51.6408C48.9253 51.4526 49.1733 51.3362 49.4382 51.3115C49.7031 51.2869 49.9683 51.3557 50.1879 51.5059Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M50.1879 27.3018C49.9683 27.4521 49.7031 27.5208 49.4382 27.4962C49.1733 27.4716 48.9253 27.3551 48.7372 27.1671C48.549 26.9789 48.4326 26.7309 48.408 26.466C48.3834 26.2011 48.4522 25.9359 48.6024 25.7164C48.822 25.5661 49.0872 25.4974 49.352 25.522C49.617 25.5466 49.865 25.663 50.053 25.8511C50.2412 26.0393 50.3576 26.2873 50.3823 26.5521C50.4069 26.8171 50.3381 27.0822 50.1879 27.3018Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M24.3985 53.0914C24.1789 53.2416 23.9138 53.3104 23.6488 53.2858C23.384 53.2612 23.136 53.1448 22.9478 52.9566C22.7597 52.7685 22.6432 52.5205 22.6187 52.2556C22.5941 51.9907 22.6628 51.7255 22.8131 51.5059C23.0326 51.3557 23.2978 51.2869 23.5627 51.3115C23.8277 51.3362 24.0755 51.4526 24.2637 51.6408C24.4518 51.8289 24.5683 52.0768 24.5929 52.3418C24.6176 52.6066 24.5488 52.8719 24.3985 53.0914Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M38.6465 7.51465H33.2788V15.0294H38.6465V7.51465Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M32.2055 3.22044C30.4268 3.22044 28.9849 4.66235 28.9849 6.44103C28.9849 8.21971 30.4268 9.66162 32.2055 9.66162H39.7202C41.4988 9.66162 42.9407 8.21971 42.9407 6.44103C42.9407 4.66235 41.4988 3.22044 39.7202 3.22044L32.2055 3.22044Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M41.2482 29.3025H34.2918V32.974C34.5924 32.6018 35.0218 32.3012 35.58 32.0722C36.1382 31.8288 36.7322 31.7072 37.3621 31.7072C38.5072 31.7072 39.4447 31.9577 40.1747 32.4587C40.9047 32.9596 41.4343 33.6037 41.7635 34.391C42.0928 35.164 42.2574 35.9941 42.2574 36.8816C42.2574 38.5277 41.785 39.8516 40.8403 40.8537C39.9099 41.8556 38.5787 42.3566 36.8468 42.3566C35.215 42.3566 33.9125 41.9487 32.9391 41.1328C31.9658 40.3169 31.4147 39.2505 31.2859 37.9337H34.2059C34.3347 38.5062 34.621 38.9643 35.0647 39.3078C35.5228 39.6513 36.1025 39.8231 36.8038 39.8231C37.6484 39.8231 38.2853 39.5582 38.7147 39.0287C39.1441 38.499 39.3588 37.7977 39.3588 36.9246C39.3588 36.0371 39.1369 35.3643 38.6932 34.9063C38.2638 34.434 37.6269 34.1978 36.7824 34.1978C36.1812 34.1978 35.6802 34.3481 35.2794 34.6487C34.8787 34.9493 34.5924 35.35 34.4206 35.851H31.5435V26.6616H41.2482V29.3025Z",
                                                                fill: "#01b976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M36.8496 45.3046L35.5292 52.7978H34.0155L34.8743 47.9455L32.0187 52.7978H30.8701L29.7214 47.9347L28.8626 52.7978H27.3489L28.6801 45.3046H30.387L31.7933 50.8655L35.1427 45.3046H36.8496ZM38.9474 46.1419C38.7112 46.1419 38.5215 46.074 38.3784 45.938C38.2353 45.8021 38.1637 45.6303 38.1637 45.4227C38.1637 45.1365 38.2711 44.8931 38.4858 44.6927C38.7077 44.4852 38.9653 44.3813 39.2587 44.3813C39.4877 44.3813 39.6739 44.4494 39.817 44.5853C39.9601 44.7213 40.0317 44.8931 40.0317 45.1006C40.0317 45.3869 39.9243 45.6338 39.7096 45.8413C39.4949 46.0418 39.2408 46.1419 38.9474 46.1419ZM39.57 46.8505L38.518 52.7978H37.0043L38.0564 46.8505H39.57ZM44.3507 46.7646C44.9661 46.7646 45.4492 46.9328 45.7999 47.2691C46.1578 47.5984 46.3367 48.0707 46.3367 48.6862C46.3367 48.9153 46.3188 49.1228 46.283 49.3088L45.6604 52.7978H44.1682L44.7479 49.5128C44.7694 49.384 44.7801 49.2588 44.7801 49.1371C44.7801 48.7793 44.6835 48.5074 44.4902 48.3212C44.3042 48.1352 44.0358 48.0421 43.6851 48.0421C43.2843 48.0421 42.9408 48.1638 42.6545 48.4071C42.3754 48.6433 42.1893 48.9868 42.0963 49.4377L41.5058 52.7978H39.9922L41.0442 46.8505H42.5579L42.4291 47.5805C42.6724 47.33 42.9623 47.1332 43.2986 46.99C43.635 46.8397 43.9857 46.7646 44.3507 46.7646Z",
                                                                fill: "#01b976"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                            className: "c15 fs1-5rem df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    children: [
                                                        "Quick Investor",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            class: "c4",
                                                            children: "Match"
                                                        }),
                                                        " One",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            class: "c4",
                                                            children: "Form"
                                                        }),
                                                        " Process"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "ml5rem mb1rem w3rem h3rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                        src: (parcelRequire("cylnH")),
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        partner && (partner?.['name'] == 'Climb26 Super Flow' || partner?.['name'] == 'EHE Super Flow') && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c14",
                                            children: "Application only goes to VCs where you match their requirements"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "one-form my1rem",
                                            children: showList.length > 0 && showList.map((item)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                        cx: "12",
                                                                        cy: "12",
                                                                        r: "12",
                                                                        fill: "#42d342"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M10.3057 16.9998C10.1924 17.0022 10.0799 16.9811 9.97451 16.9375C9.86915 16.894 9.77308 16.829 9.69186 16.7462L5.24654 12.065C5.16838 11.9831 5.10638 11.8857 5.06408 11.7787C5.02178 11.6716 5 11.5568 5 11.4408C5 11.3249 5.02178 11.2102 5.06408 11.1031C5.10638 10.996 5.16838 10.8987 5.24654 10.8167C5.3247 10.7347 5.41749 10.6697 5.51961 10.6254C5.62173 10.581 5.73119 10.5582 5.84173 10.5582C5.95226 10.5582 6.06172 10.581 6.16384 10.6254C6.26597 10.6697 6.35875 10.7347 6.43692 10.8167L10.3057 14.8542L17.5409 7.24727C17.7057 7.08826 17.9215 7 18.1454 7C18.3694 7 18.5851 7.08826 18.7499 7.24727C18.9101 7.41549 19 7.64347 19 7.88118C19 8.11888 18.9101 8.34686 18.7499 8.51509L10.9008 16.7462C10.8224 16.8275 10.7295 16.8918 10.6274 16.9353C10.5252 16.9788 10.4159 17.0007 10.3057 16.9998Z",
                                                                        fill: "white"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            class: "df jcc aic c14",
                                                            children: item
                                                        })
                                                    ]
                                                });
                                            })
                                        }),
                                        partner && (partner?.['name'] == 'Climb26 Super Flow' || partner?.['name'] == 'EHE Super Flow') && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "w100 df jcfs my1rem",
                                                    children: [
                                                        partner?.['name'] == 'Climb26 Super Flow' && isLoggedInViaLink ? /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: 'setPasswordPopup'
                                                                })),
                                                            className: "df jcc cp c1 bg4 bg3-hover fw400 fs1rem br38px px4rem py0-75rem mr1rem",
                                                            children: "Let's Go! - It's FREE"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            to: `${$16250bd714b02a14$export$51e82cdd7353a0e1}#${partner['_id']}?Superflow`,
                                                            className: "df jcc cp c1 bg4 bg3-hover fw400 fs1rem br38px px4rem py0-75rem mr1rem",
                                                            children: "Let's Go! - It's FREE"
                                                        }),
                                                        partner?.['name'] != 'Climb26 Super Flow' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            to: `https://koalendar.com/e/meet-with-mark-bernstein`,
                                                            target: "_blank",
                                                            className: "df jcc cp c1 bg4 bg3-hover fw400 fs1rem br38px px4rem py0-75rem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                                    class: "fa fa-phone c1 mr0-5rem"
                                                                }),
                                                                "Book a call"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs10px fw400 c32 mt2rem",
                                                    children: [
                                                        "Previously completed a Diligentsia One",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            class: "c4",
                                                            children: "Form"
                                                        }),
                                                        " application?"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                    className: "fs10px fw400 c32",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                            to: "/login",
                                                            class: "c3 fw500",
                                                            children: "Log in"
                                                        }),
                                                        " here and submit with one click "
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w40 img-box df jcc",
                                    children: partner && partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w90",
                                        src: (parcelRequire("1U6Hr")),
                                        alt: ""
                                    }) : partner && partner?.['name'] == 'EHE Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w90",
                                        src: (parcelRequire("eaQ0b")),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "w90",
                                        src: (parcelRequire("dH1Di")),
                                        alt: ""
                                    })
                                }),
                                partner && partner?.['name'] != 'Climb26 Super Flow' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "container w100 df jcsb pr",
                                            style: {
                                                top: '-4%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "h90",
                                                    src: (parcelRequire("6Org2")),
                                                    alt: ""
                                                }),
                                                partner?.['name'] == 'Seedlegals Super Flow' || partner?.['name'] == 'SU2SU Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "pr6rem",
                                                    src: (parcelRequire("4cpGT")),
                                                    alt: ""
                                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "pr6rem",
                                                    src: (parcelRequire("h7dyn")),
                                                    alt: ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "w100 df jcc mb1rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: `${$16250bd714b02a14$export$51e82cdd7353a0e1}#${partner['_id']}?Superflow`,
                                                    className: "df jcc cp c1 bg4 bg3-hover fw400 fs1rem br38px px4rem py0-75rem mr1rem",
                                                    children: "Let's Go! - FREE"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: `https://koalendar.com/e/meet-with-mark-bernstein`,
                                                    target: "_blank",
                                                    className: "df jcc cp c1 bg4 bg3-hover fw400 fs1rem br38px px4rem py0-75rem",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            class: "fa fa-phone c1 mr0-5rem"
                                                        }),
                                                        "Book a call"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    partner && (partner?.['name'] == 'Climb26 Super Flow' || partner?.['name'] == 'EHE Super Flow') && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w100 df jcc bg38 p2rem mb5rem",
                        style: {
                            backgroundImage: `url(${(parcelRequire("epuex"))})`
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "fw500 c15",
                                    children: "How it works?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "fw500 c15 mb2rem",
                                    children: "(not available on mobile)"
                                }),
                                partner && partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w80",
                                    src: (parcelRequire("3iSKt")),
                                    alt: ""
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "w90",
                                    src: (parcelRequire("4UmTt")),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "w70 tac",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        class: "fs14px c12",
                                        children: [
                                            "Diligentsia provides tools, not financial advice, to help match investors and companies. We do not receive commissions from investors and are not liable for the consequences of investment decisions by any party. In completing your One",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                class: "c4",
                                                children: "Form"
                                            }),
                                            " you confirm that you are happy for the information you provide to be shared with investors on our database ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: partner && partner?.['name'] == 'Climb26 Super Flow' && ', Climb26 and its Expo virtual stand partner'
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "setPasswordPopup",
                open: modal['open'] == 'setPasswordPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style bg1 shadow df fdc aic m1rem br20px",
                    style: {
                        outline: 'none',
                        padding: '2rem',
                        maxWidth: '480px',
                        width: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "mb1-5rem",
                            src: (parcelRequire("bJ68K")),
                            alt: "",
                            style: {
                                width: '60px',
                                height: '60px',
                                objectFit: 'contain'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs1-75rem fw600 c15 tac mb0-5rem",
                            children: "Set Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "fs0-875rem fw400 c28 tac mb1-5rem",
                            children: "Choose a strong password for your account"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 pr mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    id: "newPassword",
                                    className: "df w100",
                                    placeholder: "New Password",
                                    value: password['newPassword'],
                                    type: password['newPasswordType'] ? 'password' : 'text',
                                    onChange: (e)=>{
                                        setPassword({
                                            ...password,
                                            newPassword: e['target']['value']
                                        });
                                        setPasswordError('');
                                    },
                                    helperText: passwordError,
                                    FormHelperTextProps: {
                                        sx: {
                                            width: '100%',
                                            color: 'red',
                                            fontStyle: 'italic'
                                        }
                                    }
                                }),
                                password['newPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            newPasswordType: !password['newPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-35%)',
                                        right: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                        fill: "#404040"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            newPasswordType: !password['newPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-50%)',
                                        right: '12px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                            fill: "#404040"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                            fill: "#404040"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 pr mb0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                    id: "confirmPassword",
                                    className: "df w100",
                                    placeholder: "Confirm Password",
                                    value: password['confirmPassword'],
                                    type: password['confirmPasswordType'] ? 'password' : 'text',
                                    onChange: (e)=>{
                                        setPassword({
                                            ...password,
                                            confirmPassword: e['target']['value']
                                        });
                                        setPasswordError('');
                                    },
                                    helperText: passwordError,
                                    FormHelperTextProps: {
                                        sx: {
                                            width: '100%',
                                            color: 'red',
                                            fontStyle: 'italic'
                                        }
                                    }
                                }),
                                password['confirmPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            confirmPasswordType: !password['confirmPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-35%)',
                                        right: '12px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                        fill: "#404040"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    onClick: ()=>setPassword({
                                            ...password,
                                            confirmPasswordType: !password['confirmPasswordType']
                                        }),
                                    className: "pa cp",
                                    width: "27",
                                    height: "21",
                                    viewBox: "0 0 27 21",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    style: {
                                        top: '35%',
                                        transform: 'translateY(-50%)',
                                        right: '12px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                            fill: "#404040"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                            fill: "#404040"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "w100 fs12px fw400 c28 mb1-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                    className: "fas fa-info-circle mr0-5rem"
                                }),
                                "Must include uppercase, lowercase, number & special character"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: ()=>handleSetPassword(),
                            className: `w100 df aic jcc c1 fw500 fs14px br50px py0-75rem mb0-75rem ${password['newPassword'] == '' || password['confirmPassword'] == '' ? 'bg12' : 'cp bg3'}`,
                            children: "Set Password"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            className: "w100 tac cp",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "fs14px fw400",
                                style: {
                                    color: '#15131380'
                                },
                                children: "Cancel"
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");








const $75e9d2b4413835d1$var$InvestorMatchStats = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigation = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let company = {
        ...selectedCompany
    };
    const [stats, setStats] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [promptScore, setPromptScore] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        let companyId = searchParams.get('companyId');
        if (companyId) getInvestorMatchStats(companyId);
    }, []);
    const getInvestorMatchStats = async (id)=>{
        try {
            setLoading(true);
            const res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getInvestorMatchStats/${id}`);
            if (res && res?.['code'] == 200) setStats(res?.['body']);
        } catch (error) {
            console.error('Error fetching stats:', error?.['response']?.['data']);
        } finally{
            setLoading(false);
        }
    };
    const getInvestorMatchStatusData = ()=>{
        if (!stats?.investorMatchStatus) return [];
        const { thisMonth: thisMonth, lastMonth: lastMonth, ytd: ytd, lastYear: lastYear } = stats.investorMatchStatus;
        return [
            {
                index: 'No. of Applications',
                thisMonth: thisMonth.total,
                lastMonth: lastMonth.total,
                ytd: ytd.total,
                lastYear: lastYear.total
            },
            {
                index: 'Accepted',
                thisMonth: thisMonth.accepted,
                lastMonth: lastMonth.accepted,
                ytd: ytd.accepted,
                lastYear: lastYear.accepted,
                color: 'green'
            },
            {
                index: 'Rejected',
                thisMonth: thisMonth.rejected,
                lastMonth: lastMonth.rejected,
                ytd: ytd.rejected,
                lastYear: lastYear.rejected,
                color: 'red'
            },
            {
                index: 'Still Pending',
                thisMonth: thisMonth.pending,
                lastMonth: lastMonth.pending,
                ytd: ytd.pending,
                lastYear: lastYear.pending,
                color: 'orange'
            },
            {
                index: 'Added to Portfolio (post investment)',
                thisMonth: thisMonth.addedToPortfolio,
                lastMonth: lastMonth.addedToPortfolio,
                ytd: ytd.addedToPortfolio,
                lastYear: lastYear.addedToPortfolio
            }
        ];
    };
    const getSourceData = ()=>{
        if (!stats?.source) return [];
        const { thisMonth: thisMonth, lastMonth: lastMonth, ytd: ytd, lastYear: lastYear } = stats.source;
        return [
            {
                index: 'Integration added',
                thisMonth: thisMonth.integration,
                lastMonth: lastMonth.integration,
                ytd: ytd.integration,
                lastYear: lastYear.integration
            },
            {
                index: 'Manually added',
                thisMonth: thisMonth.manual,
                lastMonth: lastMonth.manual,
                ytd: ytd.manual,
                lastYear: lastYear.manual
            },
            {
                index: 'Diligentsia InvestorMatch',
                thisMonth: thisMonth.diligentsia,
                lastMonth: lastMonth.diligentsia,
                ytd: ytd.diligentsia,
                lastYear: lastYear.diligentsia
            }
        ];
    };
    const getPromptResponseData = ()=>{
        if (!stats?.promptResponseScore) return [];
        const { thisMonth: thisMonth, lastMonth: lastMonth, ytd: ytd, lastYear: lastYear } = stats.promptResponseScore;
        return [
            {
                index: 'Prompt Response Score',
                thisMonth: thisMonth,
                lastMonth: lastMonth,
                ytd: ytd,
                lastYear: lastYear
            }
        ];
    };
    const investorMatchStatusData = getInvestorMatchStatusData();
    const sourceData = getSourceData();
    const promptResponseData = getPromptResponseData();
    const rejectionReasons = stats?.rejectionReasons || [];
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "w100 df fdc px8rem poppins-font-style",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "df jcc aic py3rem",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b074148cf394a24e$export$4bf83b24a11cff0b), {
                height: "80",
                width: "80",
                color: "#8496f4",
                ariaLabel: "three-dots-loading"
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w100 df fdc px8rem poppins-font-style",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $def17927b8072e3f$export$2e2bcd8739ae039), {
                page: "InvestorMatch Stats",
                company: company,
                breadcrum: [
                    'Investor View',
                    '/Portfolio Index',
                    '/InvestorMatch',
                    '/Module Report'
                ],
                heading: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Investor",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "c4",
                            children: "Match"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w100 df jcc mb2rem",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "c15 fs1-5rem fw500",
                    children: "Statistics"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb3rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "c14 fs1-25rem fw600 ml2rem mb1rem ttu ls1px",
                        children: "INVESTORMATCH STATUS"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bo31 bw1px bss br25px bg5 p2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100",
                            style: {
                                borderCollapse: 'collapse'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        className: "bg5",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tal",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "INDEX"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "THIS MONTH"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "LAST MONTH"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "YTD"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "LAST YEAR"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: investorMatchStatusData.map((row, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: idx !== investorMatchStatusData.length - 1 ? 'bb31 bw1px' : '',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: `c15 fs14px py1rem tal ${row.color || ''}`,
                                                    children: row.index
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.thisMonth
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.lastMonth
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.ytd
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.lastYear
                                                })
                                            ]
                                        }, idx))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb4rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "c14 fs1-25rem fw600 ml2rem mb1rem ttu ls1px",
                        children: "SOURCE"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bo31 bw1px bss br25px bg5 p2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100",
                            style: {
                                borderCollapse: 'collapse'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        className: "bg5",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tal",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "INDEX"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "THIS MONTH"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "LAST MONTH"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "YTD"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "LAST YEAR"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: sourceData.map((row, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: idx !== sourceData.length - 1 ? 'bb31 bw1px' : '',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tal",
                                                    children: row.index
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.thisMonth
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.lastMonth
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.ytd
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.lastYear
                                                })
                                            ]
                                        }, idx))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb3rem pr",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                className: "c14 fs1-25rem fw600 ml2rem my1rem ttu ls1px",
                                children: "PROMPT RESPONSE SCORE"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tooltip-input",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "tooltip-area cp pr",
                                    style: {
                                        top: '-10px',
                                        left: '10px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                        className: "icon",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                classNaw2rem: true,
                                                me: "h2rem",
                                                width: "18",
                                                height: "19",
                                                viewBox: "0 0 18 19",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                                                        "clip-path": "url(#clip0_2661_6508)",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M9 18.1133C13.9628 18.1133 18 14.076 18 9.11328C18 4.15052 13.9628 0.113281 9 0.113281C4.03724 0.113281 0 4.15052 0 9.11328C0 14.076 4.03724 18.1133 9 18.1133ZM9 1.91328C12.97 1.91328 16.2 5.14326 16.2 9.11328C16.2 13.0833 12.97 16.3133 9 16.3133C5.02998 16.3133 1.8 13.0833 1.8 9.11328C1.8 5.14326 5.02998 1.91328 9 1.91328Z",
                                                                fill: "#FC7785"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M8.69665 11.6919C8.50359 11.6919 8.34746 11.5299 8.34746 11.3297C8.34746 10.8559 8.41225 10.4466 8.54117 10.1025C8.63575 9.84312 8.78929 9.5817 9.00049 9.31758C9.15597 9.12538 9.43454 8.84446 9.8375 8.47618C10.2405 8.10723 10.5022 7.81355 10.6233 7.59446C10.7445 7.37538 10.8041 7.13613 10.8041 6.87672C10.8041 6.40696 10.6272 5.995 10.2741 5.63949C9.92107 5.28398 9.48767 5.10656 8.97458 5.10656C8.47898 5.10656 8.06501 5.26785 7.73331 5.58976C7.49102 5.82497 7.30897 6.15696 7.18847 6.58573C7.10555 6.88008 6.82892 7.06825 6.53545 7.03196C6.16359 6.98627 5.9187 6.60454 6.02495 6.23156C6.18821 5.65831 6.4616 5.19661 6.84447 4.84581C7.37635 4.35723 8.07991 4.11328 8.95514 4.11328C9.88156 4.11328 10.6207 4.37471 11.1727 4.89823C11.7247 5.42175 12 6.05414 12 6.79608C12 7.22551 11.9028 7.62135 11.7091 7.9829C11.5154 8.34514 11.1358 8.78532 10.5715 9.30414C10.1925 9.65293 9.9444 9.91032 9.82778 10.0756C9.71117 10.241 9.62501 10.4312 9.5693 10.6455C9.52783 10.8048 9.49933 11.0387 9.48378 11.3458C9.47406 11.5394 9.31923 11.6912 9.13265 11.6912H8.69665V11.6919ZM8.28268 13.4258C8.28268 13.0461 8.57939 12.7383 8.94542 12.7383C9.31145 12.7383 9.60817 13.0461 9.60817 13.4258C9.60817 13.8055 9.31145 14.1133 8.94542 14.1133C8.57939 14.1133 8.28268 13.8055 8.28268 13.4258Z",
                                                                fill: "#FC7785",
                                                                stroke: "#FC7785",
                                                                "stroke-width": "0.5"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                                                            id: "clip0_2661_6508",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                                                width: "18",
                                                                height: "18",
                                                                fill: "white",
                                                                transform: "translate(0 0.113281)"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "overlay-box",
                                                style: {
                                                    left: 'auto',
                                                    top: '0',
                                                    right: '22px',
                                                    zIndex: '9',
                                                    width: '400px'
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "fs14px",
                                                    children: "The Prompt Response Score is a score provided to each applicant company to indicate the promptness of any initial response from an investor \u2013 whether positive or negative. Any initial response that takes more than 10 days is marked negatively"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "bo31 bw1px bss br25px bg5 p2rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                className: "w100",
                                style: {
                                    borderCollapse: 'collapse'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: "bg5",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "c15 fs14px fw600 ttu pb1rem bg5 tal",
                                                    style: {
                                                        borderBottom: '1px solid #d3d3d3'
                                                    },
                                                    children: "INDEX"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                    style: {
                                                        borderBottom: '1px solid #d3d3d3'
                                                    },
                                                    children: "THIS MONTH"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                    style: {
                                                        borderBottom: '1px solid #d3d3d3'
                                                    },
                                                    children: "LAST MONTH"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                    style: {
                                                        borderBottom: '1px solid #d3d3d3'
                                                    },
                                                    children: "YTD"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                    className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                    style: {
                                                        borderBottom: '1px solid #d3d3d3'
                                                    },
                                                    children: "LAST YEAR"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                        children: promptResponseData.map((row, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "c15 fs14px py1rem tal",
                                                        children: row.index
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "c15 fs14px py1rem tac",
                                                        children: row.thisMonth
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "c15 fs14px py1rem tac",
                                                        children: row.lastMonth
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "c15 fs14px py1rem tac",
                                                        children: row.ytd
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                        className: "c15 fs14px py1rem tac",
                                                        children: row.lastYear
                                                    })
                                                ]
                                            }, idx))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pa",
                                style: {
                                    top: '-20px',
                                    right: '0px'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "progress-bar",
                                    style: {
                                        width: 60,
                                        height: 60,
                                        backgroundColor: '#FBFBFB',
                                        borderRadius: '50%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94a0b690fd9978ec$export$14082143029b37c8), {
                                        className: `${promptScore > 83 ? 'green' : promptScore > 66.6 ? 'orange' : 'red'}`,
                                        value: promptScore || 0,
                                        text: `${promptScore || 0}%`,
                                        strokeWidth: 18,
                                        styles: (0, $94a0b690fd9978ec$export$5115a192ad9bf57f)({
                                            strokeLinecap: 'round',
                                            strokeWidth: '5px',
                                            textSize: '18px',
                                            pathTransitionDuration: 0.5,
                                            trailColor: '#d6d6d6',
                                            backgroundColor: '#fc7785',
                                            dominantBaseline: 'ideographic'
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mb3rem",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "c14 fs1-25rem fw600 ml2rem mb1rem ttu ls1px",
                        children: "REASON FOR REJECTION"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "bo31 bw1px bss br25px bg5 p2rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                            className: "w100",
                            style: {
                                borderCollapse: 'collapse'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        className: "bb31 bw1px",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tal",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "REASONS"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "THIS MONTH"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "LAST MONTH"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "YTD"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                className: "c15 fs14px fw600 ttu pb1rem bg5 tac",
                                                style: {
                                                    borderBottom: '1px solid #d3d3d3'
                                                },
                                                children: "LAST YEAR"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                    children: rejectionReasons.map((row, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                            className: idx !== rejectionReasons.length - 1 ? 'bb31 bw1px' : '',
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tal",
                                                    style: {
                                                        fontStyle: 'italic',
                                                        minWidth: '500px'
                                                    },
                                                    children: row.reason
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.thisMonth
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.lastMonth
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.ytd
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                    className: "c15 fs14px py1rem tac",
                                                    children: row.lastYear
                                                })
                                            ]
                                        }, idx))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $75e9d2b4413835d1$export$2e2bcd8739ae039 = $75e9d2b4413835d1$var$InvestorMatchStats;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");
















function $945faba68f239814$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let partner = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.partner);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let [company, setCompany] = (0, $acw62.useState)({});
    let [passwordError, setPasswordError] = (0, $acw62.useState)('');
    let [isExternalAPI, setIsExternalAPI] = (0, $acw62.useState)(false);
    let [isInvestor, setIsInvestor] = (0, $acw62.useState)(false);
    let [passwordIntent, setPasswordIntent] = (0, $acw62.useState)('dashboard');
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let [password, setPassword] = (0, $acw62.useState)({
        newPassword: '',
        newPasswordType: true,
        confirmPassword: '',
        confirmPasswordType: true
    });
    let PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;
    let climb26OneForm = [
        'Increase investor interest in you',
        'Answer 10 sections of questions bespoked to your business',
        'Report gives you risks and recommendations on what to improve',
        'Whatever the result - you will get a set of additional valuable reports',
        'Can be reused to support subsequent applications to other VCs'
    ];
    let climb26InvestorForm = [
        'Find companies matching your investment criteria',
        'Receive a tailored list of matches before the event',
        'Connect with pre-qualified companies on-site',
        "Save time \u2014 we do the matching for you",
        'Completely free for attending investors'
    ];
    let eheOneForm = [
        'Speeds up our diligence',
        'Answer 10 sections of questions bespoked to your business',
        'Report gives you risks and recommendations on what to improve',
        'Whatever the result - you will get a set of additional valuable reports',
        'Can be reused to support subsequent applications to other VCs'
    ];
    (0, $acw62.useEffect)(()=>{
        let urlParams = new URLSearchParams(location?.search);
        if (urlParams.size > 0) {
            let _id = urlParams.get('companyId');
            let cName = urlParams.get('cName');
            setCompany({
                _id: _id,
                cName: cName
            });
            let token = urlParams.get('token');
            let source = urlParams.get('source');
            if (token) {
                (0, $bebe1cbb5a309c8c$export$57e714f81a2c3d86)(token);
                localStorage.setItem('token', token);
                if (!user['_id']) getUser();
            }
            if (source) setIsExternalAPI(true);
            let userType = urlParams.get('userType');
            if (userType === 'investor') setIsInvestor(true);
        }
        if (location?.pathname) {
            let partnerId = location?.pathname.split('/');
            partnerId = partnerId[partnerId.length - 1];
            getPartner(partnerId);
        }
    }, []);
    // useEffect(() => {
    //     if (isExternalAPI) dispatch(toggleModal({ open: 'setPasswordPopup' }));
    // }, [isExternalAPI]);
    const getUser = async ()=>{
        let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        if (response['code'] == 200 && response['body']) {
            user = response['body']['user'];
            dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(user));
        }
    };
    const getPartner = async (id)=>{
        setIsLoader({
            show: true,
            message: 'Loading Partner...'
        });
        let res = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/checklist/partner/${id}`);
        if (res['code'] == 200) dispatch((0, $3d3d7a2ee763f32a$export$6af6109222273956)(res['body']));
        else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        setIsLoader({
            show: false,
            message: 'Loading...'
        });
    };
    const handleCheckReadiness = async ()=>{
        // Fetch fresh company data to check if Investment Readiness module already exists (created in background)
        const companyRes = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/getCompany/${company['_id']}`);
        const freshCompany = companyRes?.['body'];
        if (freshCompany?.['modules']?.['Investment Readiness']) {
            window.location.href = `/company/${company['_id']}#${partner['moduleName']}`;
            return;
        }
        if (user && partner?.['_id'] && Object.keys(company).length > 0) {
            let data = {
                partnerId: partner['_id'],
                category: 'partner',
                companies: {
                    [company['_id']]: company['cName']
                },
                memberPermissions: {
                    [user['_id']]: {
                        ...user,
                        company: {
                            [company['_id']]: company['cName']
                        }
                    }
                }
            };
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'generatePartnerPopup'
            }));
            const res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/checklist/create/0`, data);
            if (res?.['code'] == 200) {
                window.location.href = `/company/${company['_id']}#${partner['moduleName']}`;
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
            }
        }
    };
    const handleNotToday = async ()=>{
        if (user && user['type'] == 'Superflow') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
                type: 'User'
            });
            if (res['code'] == '200') window.location.href = `/company/${company['_id']}`;
        }
    };
    const handleSetPassword = async ()=>{
        if (password['newPassword'] == '' || password['confirmPassword'] == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please enter both passwords!');
        if (password['newPassword'] != password['confirmPassword']) return setPasswordError('Passwords doesn`t match!');
        if (!PASSWORD_PATTERN.test(password['newPassword'])) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Password must contain atleast one capital letter, one special character and a number');
            setPasswordError('Password must contain atleast one capital letter, one special character and a number');
            return;
        }
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/setPassword`, {
            key: user['email'],
            password: password['newPassword']
        });
        if (res && res['code'] == 200) {
            if (isInvestor) {
                window.location.href = '/investor-dashboard';
                return;
            }
            if (passwordIntent === 'checklist') {
                dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                    open: ''
                }));
                handleCheckReadiness();
            } else window.location.href = '/dashboard';
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                message: isLoader['message']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc w100 super-flow-page",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcsb aic px8rem sm-px0rem mb1rem",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "df fdc",
                                children: [
                                    isInvestor ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw500 w100 c15",
                                        children: [
                                            "Find Your Next ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Investment at Climb"
                                        ]
                                    }) : partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw500 w100 c15",
                                        children: [
                                            "Investment Ready? Increase ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Investors Interest In You"
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fs2-5rem fw500 w100 c15",
                                        children: [
                                            "Investment Ready? Let`s help You ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " Speed Up Our Investment Decision"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "fs1rem fw300 w100 c15 mt0-5rem",
                                        children: isInvestor ? 'We match you with screened, pre-qualified companies attending Climb that fit your investment criteria' : 'Investors spend more time on applications from companies that can demonstrate that they are investment ready'
                                    })
                                ]
                            }),
                            partner?.['name'] == 'Climb26 Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("y9sDx")),
                                alt: ""
                            }) : partner?.['name'] == 'EHE Super Flow' ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("bc4ez")),
                                alt: ""
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "df",
                                src: (parcelRequire("iWPnk")),
                                alt: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df jcc w100",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "super-flow df fww w100 bg38 br35px mx3rem ml6rem p2rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "c15 fs1-5rem fw500 df aic",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: isInvestor ? 'Your FREE InvestorMatch Service' : 'Complete Investment Readiness Checklist'
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                    className: "ml1rem mb1rem w3rem h3rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        width: "56",
                                                        height: "56",
                                                        viewBox: "0 0 56 56",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M45.116 16.6131C43.0672 14.0393 40.4644 11.9607 37.5012 10.532C34.5379 9.10337 31.2907 8.36133 28.001 8.36133C24.7113 8.36133 21.464 9.10337 18.5008 10.532C15.5375 11.9607 12.9347 14.0393 10.886 16.6131C-0.51526 30.8931 9.7222 52.1031 28.001 52.1031C46.2798 52.1031 56.5347 30.9106 45.116 16.6131ZM41.3798 41.5069C39.737 43.4551 37.6886 45.021 35.3778 46.0952C33.0669 47.1694 30.5494 47.726 28.001 47.726C25.4527 47.726 22.9351 47.1694 20.6242 46.0952C18.3134 45.021 16.265 43.4551 14.6222 41.5069C5.01474 30.1406 13.1872 12.7281 28.001 12.7281C42.8148 12.7281 50.9872 30.1319 41.3798 41.5069Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M28.8759 16.2285C28.8759 16.4605 28.7837 16.6831 28.6196 16.8473C28.4556 17.0113 28.233 17.1035 28.001 17.1035C27.7689 17.1035 27.5463 17.0113 27.3822 16.8473C27.2181 16.6831 27.126 16.4605 27.126 16.2285C27.126 15.9964 27.2181 15.7738 27.3822 15.6098C27.5463 15.4456 27.7689 15.3535 28.001 15.3535C28.233 15.3535 28.4556 15.4456 28.6196 15.6098C28.7837 15.7738 28.8759 15.9964 28.8759 16.2285Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M28.8759 44.2285C28.8759 44.4606 28.7837 44.6831 28.6196 44.8473C28.4556 45.0113 28.233 45.1035 28.001 45.1035C27.7689 45.1035 27.5463 45.0113 27.3822 44.8473C27.2181 44.6831 27.126 44.4606 27.126 44.2285C27.126 43.9964 27.2181 43.7738 27.3822 43.6098C27.5463 43.4456 27.7689 43.3535 28.001 43.3535C28.233 43.3535 28.4556 43.4456 28.6196 43.6098C28.7837 43.7738 28.8759 43.9964 28.8759 44.2285Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M42.001 31.1035C41.7689 31.1035 41.5463 31.0113 41.3822 30.8473C41.2181 30.6831 41.126 30.4606 41.126 30.2285C41.126 29.9964 41.2181 29.7738 41.3822 29.6098C41.5463 29.4456 41.7689 29.3535 42.001 29.3535C42.233 29.3535 42.4556 29.4456 42.6196 29.6098C42.7837 29.7738 42.8759 29.9964 42.8759 30.2285C42.8759 30.4606 42.7837 30.6831 42.6196 30.8473C42.4556 31.0113 42.233 31.1035 42.001 31.1035Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M14.001 31.1035C13.7689 31.1035 13.5463 31.0113 13.3822 30.8473C13.2181 30.6831 13.126 30.4606 13.126 30.2285C13.126 29.9964 13.2181 29.7738 13.3822 29.6098C13.5463 29.4456 13.7689 29.3535 14.001 29.3535C14.233 29.3535 14.4556 29.4456 14.6196 29.6098C14.7837 29.7738 14.8759 29.9964 14.8759 30.2285C14.8759 30.4606 14.7837 30.6831 14.6196 30.8473C14.4556 31.0113 14.233 31.1035 14.001 31.1035Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M18.7167 19.7271C18.832 19.8955 18.8849 20.0989 18.8659 20.3021C18.847 20.5053 18.7577 20.6956 18.6134 20.84C18.469 20.9842 18.2789 21.0736 18.0756 21.0924C17.8724 21.1113 17.669 21.0586 17.5006 20.9433C17.3853 20.7748 17.3326 20.5715 17.3514 20.3682C17.3703 20.1651 17.4596 19.9748 17.6039 19.8304C17.7483 19.6861 17.9385 19.5968 18.1417 19.578C18.3449 19.5591 18.5483 19.6118 18.7167 19.7271Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M38.5 39.5123C38.6152 39.6807 38.668 39.8842 38.6491 40.0874C38.6302 40.2906 38.541 40.4808 38.3966 40.6251C38.2523 40.7695 38.0621 40.8588 37.8588 40.8777C37.6556 40.8965 37.4523 40.8437 37.2837 40.7285C37.1685 40.5601 37.1157 40.3566 37.1346 40.1535C37.1536 39.9502 37.2428 39.76 37.3872 39.6157C37.5314 39.4714 37.7217 39.3821 37.925 39.3631C38.1281 39.3443 38.3316 39.397 38.5 39.5123Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M38.5 20.9433C38.3316 21.0586 38.1281 21.1113 37.925 21.0924C37.7217 21.0736 37.5314 20.9842 37.3872 20.84C37.2428 20.6956 37.1536 20.5053 37.1346 20.3021C37.1157 20.0989 37.1685 19.8955 37.2837 19.7271C37.4523 19.6118 37.6556 19.5591 37.8588 19.578C38.0621 19.5968 38.2523 19.6861 38.3966 19.8304C38.541 19.9748 38.6302 20.1651 38.6491 20.3682C38.668 20.5715 38.6152 20.7748 38.5 20.9433Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M18.7167 40.7285C18.5483 40.8437 18.3449 40.8965 18.1417 40.8777C17.9385 40.8588 17.7483 40.7695 17.6039 40.6251C17.4596 40.4808 17.3703 40.2906 17.3514 40.0874C17.3326 39.8842 17.3853 39.6807 17.5006 39.5123C17.669 39.397 17.8724 39.3443 18.0756 39.3631C18.2789 39.3821 18.469 39.4714 18.6134 39.6157C18.7577 39.76 18.847 39.9502 18.8659 40.1535C18.8849 40.3566 18.832 40.5601 18.7167 40.7285Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M29.6469 5.76562H25.5293V11.5304H29.6469V5.76562Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M24.705 2.4707C23.3405 2.4707 22.2344 3.57683 22.2344 4.94129C22.2344 6.30576 23.3405 7.41188 24.705 7.41188H30.4697C31.8342 7.41188 32.9403 6.30576 32.9403 4.94129C32.9403 3.57683 31.8342 2.4707 30.4697 2.4707H24.705Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M19.044 23.871C19.1007 22.7377 19.4973 21.865 20.234 21.253C20.982 20.6297 21.9623 20.318 23.175 20.318C24.0023 20.318 24.7107 20.4653 25.3 20.76C25.8893 21.0433 26.3313 21.4343 26.626 21.933C26.932 22.4203 27.085 22.9757 27.085 23.599C27.085 24.313 26.898 24.9193 26.524 25.418C26.1613 25.9053 25.725 26.234 25.215 26.404V26.472C25.8723 26.676 26.3823 27.0387 26.745 27.56C27.119 28.0813 27.306 28.75 27.306 29.566C27.306 30.246 27.1473 30.8523 26.83 31.385C26.524 31.9177 26.065 32.337 25.453 32.643C24.8523 32.9377 24.127 33.085 23.277 33.085C21.9963 33.085 20.9537 32.762 20.149 32.116C19.3443 31.47 18.9193 30.518 18.874 29.26H21.186C21.2087 29.8153 21.3957 30.263 21.747 30.603C22.1097 30.9317 22.6027 31.096 23.226 31.096C23.804 31.096 24.246 30.9373 24.552 30.62C24.8693 30.2913 25.028 29.872 25.028 29.362C25.028 28.682 24.8127 28.1947 24.382 27.9C23.9513 27.6053 23.2827 27.458 22.376 27.458H21.883V25.503H22.376C23.9853 25.503 24.79 24.9647 24.79 23.888C24.79 23.4007 24.6427 23.021 24.348 22.749C24.0647 22.477 23.651 22.341 23.107 22.341C22.5743 22.341 22.1607 22.4883 21.866 22.783C21.5827 23.0663 21.4183 23.429 21.373 23.871H19.044ZM28.6768 26.642C28.6768 24.6813 29.0281 23.1457 29.7308 22.035C30.4448 20.9243 31.6234 20.369 33.2668 20.369C34.9101 20.369 36.0831 20.9243 36.7858 22.035C37.4998 23.1457 37.8568 24.6813 37.8568 26.642C37.8568 28.614 37.4998 30.161 36.7858 31.283C36.0831 32.405 34.9101 32.966 33.2668 32.966C31.6234 32.966 30.4448 32.405 29.7308 31.283C29.0281 30.161 28.6768 28.614 28.6768 26.642ZM35.5108 26.642C35.5108 25.8033 35.4541 25.1007 35.3408 24.534C35.2388 23.956 35.0234 23.4857 34.6948 23.123C34.3774 22.7603 33.9014 22.579 33.2668 22.579C32.6321 22.579 32.1504 22.7603 31.8218 23.123C31.5044 23.4857 31.2891 23.956 31.1758 24.534C31.0738 25.1007 31.0228 25.8033 31.0228 26.642C31.0228 27.5033 31.0738 28.2287 31.1758 28.818C31.2778 29.396 31.4931 29.8663 31.8218 30.229C32.1504 30.5803 32.6321 30.756 33.2668 30.756C33.9014 30.756 34.3831 30.5803 34.7118 30.229C35.0404 29.8663 35.2558 29.396 35.3578 28.818C35.4598 28.2287 35.5108 27.5033 35.5108 26.642Z",
                                                                fill: "#01B976"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M28.2678 34.7552L27.2548 40.5034H26.0936L26.7525 36.7811L24.5619 40.5034H23.6807L22.7995 36.7728L22.1407 40.5034H20.9795L22.0007 34.7552H23.3101L24.3889 39.0211L26.9584 34.7552H28.2678ZM29.877 35.3975C29.6959 35.3975 29.5503 35.3454 29.4406 35.2411C29.3308 35.1368 29.2759 35.005 29.2759 34.8458C29.2759 34.6262 29.3582 34.4395 29.5229 34.2858C29.6931 34.1266 29.8908 34.0469 30.1159 34.0469C30.2915 34.0469 30.4343 34.0991 30.5441 34.2034C30.6538 34.3077 30.7088 34.4395 30.7088 34.5987C30.7088 34.8183 30.6265 35.0077 30.4617 35.1669C30.297 35.3207 30.102 35.3975 29.877 35.3975ZM30.3547 35.9411L29.5476 40.5034H28.3865L29.1935 35.9411H30.3547ZM34.022 35.8752C34.4941 35.8752 34.8647 36.0042 35.1338 36.2622C35.4082 36.5148 35.5456 36.8771 35.5456 37.3493C35.5456 37.525 35.5317 37.6842 35.5044 37.8269L35.0267 40.5034H33.882L34.3267 37.9834C34.3432 37.8846 34.3514 37.7885 34.3514 37.6952C34.3514 37.4207 34.2773 37.2121 34.1291 37.0693C33.9864 36.9266 33.7805 36.8552 33.5114 36.8552C33.204 36.8552 32.9405 36.9485 32.7209 37.1352C32.5067 37.3164 32.364 37.5799 32.2926 37.9258L31.8397 40.5034H30.6785L31.4856 35.9411H32.6467L32.5479 36.5011C32.7346 36.3089 32.9569 36.1579 33.215 36.0481C33.4729 35.9328 33.742 35.8752 34.022 35.8752Z",
                                                                fill: "#01B976"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                            className: "one-form mt0-5rem",
                                            children: (isInvestor ? climb26InvestorForm : partner?.['name'] == 'Climb26 Super Flow' ? climb26OneForm : eheOneForm).map((item)=>{
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                                        cx: "12",
                                                                        cy: "12",
                                                                        r: "12",
                                                                        fill: "#42d342"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                        d: "M10.3057 16.9998C10.1924 17.0022 10.0799 16.9811 9.97451 16.9375C9.86915 16.894 9.77308 16.829 9.69186 16.7462L5.24654 12.065C5.16838 11.9831 5.10638 11.8857 5.06408 11.7787C5.02178 11.6716 5 11.5568 5 11.4408C5 11.3249 5.02178 11.2102 5.06408 11.1031C5.10638 10.996 5.16838 10.8987 5.24654 10.8167C5.3247 10.7347 5.41749 10.6697 5.51961 10.6254C5.62173 10.581 5.73119 10.5582 5.84173 10.5582C5.95226 10.5582 6.06172 10.581 6.16384 10.6254C6.26597 10.6697 6.35875 10.7347 6.43692 10.8167L10.3057 14.8542L17.5409 7.24727C17.7057 7.08826 17.9215 7 18.1454 7C18.3694 7 18.5851 7.08826 18.7499 7.24727C18.9101 7.41549 19 7.64347 19 7.88118C19 8.11888 18.9101 8.34686 18.7499 8.51509L10.9008 16.7462C10.8224 16.8275 10.7295 16.8918 10.6274 16.9353C10.5252 16.9788 10.4159 17.0007 10.3057 16.9998Z",
                                                                        fill: "white"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            class: "c14",
                                                            children: item
                                                        })
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w250px h170px mr3rem",
                                                    src: (parcelRequire("6Org2")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w180px",
                                                    src: (parcelRequire("aLtQ4")),
                                                    alt: ""
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w50 df fdc",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcc mb3rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "mr3rem",
                                                    src: (parcelRequire("erEj1")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w180px",
                                                    src: (parcelRequire("6qGM8")),
                                                    alt: ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            class: "df jcsa",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "",
                                                    src: (parcelRequire("geNqC")),
                                                    alt: ""
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w100 df jcc mb1rem",
                                    children: [
                                        !isInvestor && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            onClick: ()=>{
                                                setPasswordIntent('checklist');
                                                isExternalAPI ? dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                    open: 'setPasswordPopup'
                                                })) : handleCheckReadiness();
                                            },
                                            className: "df aic jcc cp c1 bg4 bg3-hover fw400 fs1rem br38px w300px py0-75rem mr1rem",
                                            children: "Check readiness - FREE"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            target: "_blank",
                                            to: "https://koalendar.com/e/meet-with-mark-bernstein",
                                            className: "df aic jcc cp c1 bg4 bg3-hover fw400 fs1rem br38px w300px py0-75rem",
                                            children: "Or...book a call"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                id: "setPasswordPopup",
                open: modal['open'] == 'setPasswordPopup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic advisor-dashboard-seemore",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style mah100 bg38 shadow w100 py2rem px4rem df fdc m1rem pr br10px pr",
                    style: {
                        outline: 'none',
                        paddingBottom: '2rem',
                        maxWidth: '750px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-logo pa t0 r0 mr1rem mt1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w4rem",
                                src: (parcelRequire("bJ68K")),
                                alt: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w100 df fdc aic",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "w100 tac fw500 fs2-125rem c15 mt2rem mb1rem",
                                    children: "Set Password"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w80 pr mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            id: "newPassword",
                                            className: "df w100",
                                            placeholder: "New Password",
                                            value: password['newPassword'],
                                            type: password['newPasswordType'] ? 'password' : 'text',
                                            onChange: (e)=>{
                                                setPassword({
                                                    ...password,
                                                    newPassword: e['target']['value']
                                                }), setPasswordError('');
                                            },
                                            helperText: passwordError,
                                            FormHelperTextProps: {
                                                sx: {
                                                    width: '100%',
                                                    color: 'red',
                                                    fontStyle: 'italic'
                                                }
                                            }
                                        }),
                                        password['newPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            onClick: ()=>setPassword({
                                                    ...password,
                                                    newPasswordType: !password['newPasswordType']
                                                }),
                                            className: "pa cp",
                                            width: "27",
                                            height: "21",
                                            viewBox: "0 0 27 21",
                                            fill: "none",
                                            xmlns: "http:www.w3.org/2000/svg",
                                            style: {
                                                top: '35%',
                                                transform: 'translateY(-35%)',
                                                right: "12px"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                                fill: "#404040"
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            onClick: ()=>setPassword({
                                                    ...password,
                                                    newPasswordType: !password['newPasswordType']
                                                }),
                                            className: "pa cp",
                                            width: "27",
                                            height: "21",
                                            viewBox: "0 0 27 21",
                                            fill: "none",
                                            xmlns: "http:www.w3.org/2000/svg",
                                            style: {
                                                top: '35%',
                                                transform: 'translateY(-50%)',
                                                right: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                                    fill: "#404040"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                                    fill: "#404040"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "w80 pr mb1rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8826083c5af4ea7$export$2e2bcd8739ae039), {
                                            id: "confirmPassword",
                                            className: "df w100",
                                            placeholder: "Confirm Password",
                                            value: password['confirmPassword'],
                                            type: password['confirmPasswordType'] ? 'password' : 'text',
                                            onChange: (e)=>{
                                                setPassword({
                                                    ...password,
                                                    confirmPassword: e['target']['value']
                                                }), setPasswordError('');
                                            },
                                            helperText: passwordError,
                                            FormHelperTextProps: {
                                                sx: {
                                                    width: '100%',
                                                    color: 'red',
                                                    fontStyle: 'italic'
                                                }
                                            }
                                        }),
                                        password['confirmPasswordType'] ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            onClick: ()=>setPassword({
                                                    ...password,
                                                    confirmPasswordType: !password['confirmPasswordType']
                                                }),
                                            className: "pa cp",
                                            width: "27",
                                            height: "21",
                                            viewBox: "0 0 27 21",
                                            fill: "none",
                                            xmlns: "http:www.w3.org/2000/svg",
                                            style: {
                                                top: '35%',
                                                transform: 'translateY(-35%)',
                                                right: "12px"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M26.8887 11.0394C26.8432 11.1372 26.1704 13.1688 24 15.5C19 21 9.45935 22.4011 3.5 16.0003C1 13.5003 0.156749 11.1372 0.111239 11.0394C0.0380833 10.8821 0 10.7087 0 10.5328C0 10.357 0.0380833 10.1836 0.111239 10.0263C0.156749 9.92845 1.5 7.00036 3.5 5.00036C8.5 0.000362396 17 -0.999638 23.5 5.00036C25.4204 6.72473 26.8432 9.92845 26.8887 10.0263C26.9619 10.1836 26.9999 10.357 26.9999 10.5328C26.9999 10.7087 26.9619 10.8821 26.8887 11.0394ZM22.088 6.87801C17.0809 1.50015 8.5 2.50015 4.95721 6.82959C3.58301 8.29409 2.67851 9.77977 2.26217 10.5341C2.67128 11.277 3.55522 12.7304 4.91191 14.1876C9.93318 19.5808 18.0417 18.5001 22.0429 14.236C23.4174 12.7712 24.3219 11.2851 24.7378 10.5318C24.3287 9.78878 23.4447 8.33515 22.088 6.87801ZM13.5 16.1214C10.6309 16.1214 8 13.6132 8 10.5318C8 7.4502 10.6309 4.94436 13.5 4.94436C16.369 4.94436 19 7.41856 19 10.5001C19 13.5816 16.369 16.1214 13.5 16.1214Z",
                                                fill: "#404040"
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            onClick: ()=>setPassword({
                                                    ...password,
                                                    confirmPasswordType: !password['confirmPasswordType']
                                                }),
                                            className: "pa cp",
                                            width: "27",
                                            height: "21",
                                            viewBox: "0 0 27 21",
                                            fill: "none",
                                            xmlns: "http:www.w3.org/2000/svg",
                                            style: {
                                                top: '35%',
                                                transform: 'translateY(-50%)',
                                                right: "12px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M23.2877 2.2875C23.7377 1.8375 23.7377 1.1625 23.2877 0.7125C22.8377 0.2625 22.1627 0.2625 21.7127 0.7125L19.9127 2.5125C18.0002 1.5 15.8627 0.9375 13.5002 0.9375C7.6502 0.9375 2.47519 4.3125 0.225195 9.7125L0.112695 10.05C0.000195317 10.3875 0.000195317 10.6125 0.112695 10.95L0.225195 11.2875C1.3502 13.875 3.03769 15.9 5.06269 17.3625L3.71269 18.7125C3.26269 19.1625 3.26269 19.8375 3.71269 20.2875C3.93769 20.5125 4.16269 20.625 4.50019 20.625C4.83769 20.625 5.06269 20.5125 5.28769 20.2875L23.2877 2.2875ZM2.36269 10.5C4.27519 6 8.55019 3.1875 13.5002 3.1875C15.1877 3.1875 16.7627 3.525 18.2252 4.0875L16.5377 5.775C15.6377 5.2125 14.6252 4.875 13.5002 4.875C10.4627 4.875 7.87519 7.4625 7.87519 10.5C7.87519 11.625 8.21269 12.6375 8.77519 13.5375L6.63769 15.675C4.83769 14.4375 3.26269 12.75 2.36269 10.5ZM26.7752 9.825C25.9877 8.025 24.9752 6.45 23.6252 5.2125L22.0502 6.7875C23.0627 7.8 23.9627 9.15 24.6377 10.6125C22.6127 15.1125 18.4502 17.925 13.5002 17.925C12.7127 17.925 11.9252 17.8125 11.2502 17.7L9.3377 19.5C10.6877 19.8375 12.0377 20.0625 13.5002 20.0625C19.3502 20.0625 24.5252 16.6875 26.7752 11.2875L26.8877 10.95C27.0002 10.725 27.0002 10.3875 26.8877 10.05L26.7752 9.825Z",
                                                    fill: "#404040"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M19.1254 10.4999C19.1254 10.2749 19.1254 10.0499 19.0129 9.7124L12.7129 16.0124C12.9379 16.0124 13.1629 16.1249 13.5004 16.1249C16.5379 16.1249 19.1254 13.5374 19.1254 10.4999Z",
                                                    fill: "#404040"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcsb",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: ()=>handleSetPassword(),
                                        className: `df aic jcc c1 fw400 fs1rem br38px px3rem py0-5rem my1rem ${password['newPassword'] == '' || password['confirmPassword'] == '' ? 'cna bg12' : 'cp bg4'}`,
                                        children: "Set Password"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");








const $4d4d9ec6d06bfc90$var$TestPage = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const { isFromLinkedIn: isFromLinkedIn } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.linkedIn);
    const [testType, setTestType] = (0, $acw62.useState)();
    const [registerAs, setRegisterAs] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        localStorage.removeItem('isDemoChecklist');
        localStorage.removeItem('isPartnerChecklist');
    }, []);
    const handleLetsGo = async ()=>{
        await localStorage.setItem('registerAs', registerAs);
        await localStorage.setItem('testType', testType.toLowerCase());
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'addCompany'
        }));
    };
    const handleSubmit = ()=>{
        localStorage.removeItem('isDemoChecklist');
        localStorage.removeItem('isPartnerChecklist');
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'welcome2MinuteTest'
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "poppins-font-style test-Page test-page-font *",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w100 df aifs jcc test-two-minute-page",
                    style: {
                        backgroundImage: `url(${(parcelRequire("fltHn"))})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: 'center',
                        height: '100vh'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "w70 px5rem py8rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs3rem fw400 c15 mb0-5rem",
                                    children: [
                                        "FREE 2-Minute ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "c4",
                                            children: "Test"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "fs1rem fw300 c15 mb2rem",
                                    children: [
                                        "Let's pick your who you want to register as and what your objective is, and begin our FREE 2-minute test! ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        " No email or credit card required. "
                                    ]
                                }),
                                isFromLinkedIn && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "mb3rem",
                                    src: (parcelRequire("gnZup")),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs1-25rem c15 fsi mb0-5rem",
                                    children: "Who are you?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100 df aic",
                                    children: [
                                        {
                                            'User': 'Company'
                                        },
                                        {
                                            'Advisor': 'Advisor practice/Company'
                                        },
                                        {
                                            'Investor': 'Investor company/Fund'
                                        }
                                    ].map((item)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            onClick: ()=>setRegisterAs(Object.keys(item)[0]),
                                            className: "cp df mr1rem mb0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: Object.keys(item)[0],
                                                    className: "cp w20px h20px",
                                                    name: "are-you",
                                                    type: "radio",
                                                    value: Object.keys(item)[0]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "cp fs1rem fw300 ml0-5rem c15",
                                                    for: Object.keys(item)[0],
                                                    children: Object.values(item)[0]
                                                })
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "fs1-25rem c15 fsi mb0-5rem mt2rem",
                                    children: "Choose your objective"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w100 df aic",
                                    children: [
                                        {
                                            'investment': 'Investment Ready'
                                        },
                                        {
                                            'growth': 'Growth Ready'
                                        },
                                        {
                                            'exit': 'Exit Ready'
                                        }
                                    ].map((item)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            onClick: ()=>setTestType(Object.keys(item)[0]),
                                            className: "cp df mr1rem mb0-5rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                    id: Object.keys(item)[0],
                                                    className: "cp w20px h20px",
                                                    name: "your-objective",
                                                    type: "radio",
                                                    value: Object.keys(item)[0]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                    className: "cp fs1rem fw300 ml0-5rem c15",
                                                    for: Object.keys(item)[0],
                                                    children: Object.values(item)[0]
                                                })
                                            ]
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "fs1rem fw300 c15 mt2rem",
                                    children: "For you or your client or your portfolio company."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    disabled: !registerAs || !testType,
                                    onClick: ()=>handleSubmit(),
                                    className: `w20 submitButton tac mt3rem c1 td250 br50px fs1rem py0-75rem fw500 ${!registerAs || !testType ? 'bg16 cna' : 'bg4 bg3-hover cp'}`,
                                    children: "Submit"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w30 df mt8rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "w100",
                                src: (parcelRequire("2LVbM")),
                                alt: ""
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                    id: "welcome2MinuteTestModal",
                    open: modal['open'] == 'welcome2MinuteTest',
                    onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                            open: ''
                        })),
                    className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: `mah90 oya bg20 shadow w100 pt3rem pl3rem pr3rem pb2rem bsbb df fdc m1rem br20px pr maw80`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "close-popup",
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: ''
                                            }))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "c15 fs2rem fw500 mb2rem",
                                        children: "FREE \u201C2-Minute\u201D Test"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "df jcsb aic step-box-modal style-two",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "w100",
                                            src: (parcelRequire("6QpiR")),
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "tac w100 db",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c15 db",
                                                children: [
                                                    "To see how simple the process is, experience it first hand.",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    "Take the test and see."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                className: "p1rem pl5rem pr5rem shadow c1 bg4 bg3-hover br35px mt1rem mb1rem cp fw600 fs1rem pr zi0 br10px td250 registerButtonAnimation",
                                                onClick: ()=>handleLetsGo(),
                                                children: "Let\u2019s Go!"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                className: "pa cp",
                                onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                        open: ''
                                    })),
                                style: {
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    bottom: '120px'
                                },
                                width: "60",
                                height: "60",
                                viewBox: "0 0 60 60",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                        opacity: "0.8",
                                        x: "4",
                                        y: "4",
                                        width: "52",
                                        height: "52",
                                        rx: "26",
                                        fill: "#151313"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M48.5606 11.4375C44.8894 7.76665 40.2121 5.26685 35.1201 4.2542C30.0282 3.24156 24.7503 3.76155 19.9539 5.74843C15.1575 7.73531 11.058 11.0998 8.17374 15.4166C5.28947 19.7333 3.75 24.8084 3.75 30C3.75 35.1917 5.28947 40.2667 8.17374 44.5835C11.058 48.9002 15.1575 52.2647 19.9539 54.2516C24.7503 56.2385 30.0282 56.7585 35.1201 55.7458C40.2121 54.7332 44.8894 52.2334 48.5606 48.5625C50.9984 46.1249 52.9322 43.231 54.2516 40.0461C55.5709 36.8611 56.25 33.4474 56.25 30C56.25 26.5526 55.5709 23.1389 54.2516 19.954C52.9322 16.769 50.9984 13.8751 48.5606 11.4375ZM39.3731 36.6375C39.5604 36.8129 39.7098 37.0249 39.8119 37.2603C39.914 37.4958 39.9666 37.7496 39.9666 38.0063C39.9666 38.2629 39.914 38.5168 39.8119 38.7522C39.7098 38.9876 39.5604 39.1996 39.3731 39.375C39.1979 39.5488 38.9901 39.6863 38.7617 39.7796C38.5332 39.8729 38.2886 39.9202 38.0419 39.9188C37.55 39.9167 37.0786 39.7214 36.7294 39.375L29.9981 32.6438L23.3606 39.375C23.0114 39.7214 22.54 39.9167 22.0481 39.9188C21.8013 39.9202 21.5567 39.8729 21.3283 39.7796C21.0998 39.6863 20.8921 39.5488 20.7169 39.375C20.3676 39.0237 20.1716 38.5485 20.1716 38.0531C20.1716 37.5578 20.3676 37.0826 20.7169 36.7313L27.3544 30L20.7169 23.3625C20.4097 23.0038 20.2492 22.5424 20.2674 22.0705C20.2856 21.5986 20.4812 21.151 20.8152 20.8171C21.1491 20.4832 21.5967 20.2875 22.0686 20.2693C22.5405 20.2511 23.0019 20.4116 23.3606 20.7188L29.9981 27.3563L36.6356 20.7188C36.8092 20.539 37.0165 20.3952 37.2457 20.2956C37.4748 20.196 37.7214 20.1424 37.9712 20.1381C38.2211 20.1337 38.4693 20.1786 38.7018 20.2702C38.9343 20.3618 39.1465 20.4983 39.3262 20.6719C39.506 20.8455 39.6498 21.0528 39.7494 21.2819C39.849 21.5111 39.9026 21.7576 39.9069 22.0075C39.9113 22.2573 39.8664 22.5056 39.7748 22.7381C39.6832 22.9706 39.5467 23.1828 39.3731 23.3625L32.6419 30L39.3731 36.6375Z",
                                        fill: "white"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $4d4d9ec6d06bfc90$export$2e2bcd8739ae039 = $4d4d9ec6d06bfc90$var$TestPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $6238ac0b849c9c3e$export$38165aa3a38f65a7 = {
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/81dc3570f6dec9cf592951684ecbfa919b426828e28b1d611707a28ebb65124e?placeholderIfAbsent=true&apiKey=0e804629346e4662b140bf48de8efc48",
    bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/1-min-1729774465871.png",
    category: [
        "Accountants",
        "AI"
    ],
    title: "AI Revolution: Transforming Mid-Sized UK Accountancy Practices",
    slug: "ai-revolution-transforming-mid-sized-uk-accountancy-practices",
    excerpt: "In today's rapidly evolving business landscape, Artificial Intelligence (AI) is no longer a futuristic concept\u2014it's a present reality that's reshaping industries worldwide. For mid-sized UK accountancy practices, AI is poised to revolutionize how services are delivered and how firms bill their clients. Embracing AI offers...",
    author: {
        name: "Mark Bernstein,",
        role: "Founder, Diligentisa Limited",
        avatar: "https://cdn.builder.io/api/v1/image/assets/TEMP/5befabb28211e5f2bce830c5bc7118c66425f3e35a838c8be474f4168b59b98b?placeholderIfAbsent=true&apiKey=0e804629346e4662b140bf48de8efc48"
    },
    date: "Oct 12, 2024, 10:32AM",
    postData: {
        "section1": {
            "type": "content",
            "data": {
                "introduction": "In today's rapidly evolving business landscape, Artificial Intelligence (AI) is no longer a futuristic concept\u2014it's a present reality that's reshaping industries worldwide. For mid-sized UK accountancy practices, AI is poised to revolutionize how services are delivered and how firms bill their clients. Embracing AI offers unprecedented opportunities for efficiency, enhanced client experiences, and innovative billing models that reflect the true value provided.",
                "sections": [
                    {
                        "title": "The AI Impact on Service Delivery",
                        "subTitle": "Automation of Routine Tasks",
                        "introduction": "One of the most significant ways AI is transforming accountancy is through the automation of repetitive and time-consuming tasks. Bookkeeping, data entry, and basic reconciliations can now be handled by AI-powered software.",
                        "points": [
                            "Reduced Manual Errors: AI algorithms minimize human error by automating data processing.",
                            "Time Efficiency: Accountants can redirect their focus from mundane tasks to strategic advisory roles.",
                            "Cost Savings: Automation reduces operational costs, allowing practices to offer competitive pricing or invest in other growth areas."
                        ]
                    },
                    {
                        "subTitle": "Enhanced Data Analysis and Insights",
                        "introduction": "AI excels at processing vast amounts of data quickly and accurately, offering deeper insights for informed decision-making.",
                        "points": [
                            "Predictive Analytics: AI can forecast financial trends, helping clients anticipate market shifts and adjust strategies accordingly.",
                            "Real-Time Reporting: Immediate access to up-to-date financial information enables more agile business decisions.",
                            "Anomaly Detection: AI systems can identify irregularities or fraudulent activities faster than traditional methods."
                        ]
                    },
                    {
                        "subTitle": "Personalized Client Services",
                        "introduction": "AI enables accountants to offer tailored services that meet individual client needs, boosting client satisfaction.",
                        "points": [
                            "Customized Financial Planning: AI analyses client data to create personalized financial strategies.",
                            "Responsive Support: AI-powered chatbots provide instant answers to common queries, enhancing client engagement.",
                            "Adaptive Services: Machine learning algorithms adapt to client behaviours, offering services that evolve with client needs."
                        ]
                    }
                ]
            }
        },
        "section2": {
            "type": "card",
            "cardStyle": "default",
            "data": {
                "title": "Diligentsia Pro PLUS",
                "titlePrefixIcon": "https://cdn.builder.io/api/v1/image/assets/TEMP/5f322ee968595006f8b88c04d866ef69428cde2743b351d9d30f72aa1d21ea1f?placeholderIfAbsent=true&apiKey=0e804629346e4662b140bf48de8efc48",
                "points": [
                    "You can charge for quarterly reviews/completion",
                    "Process designed for your junior staff using checklists to ensure completeness",
                    "Certification is valid for 3 months"
                ],
                "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/diligentsiaProPlus-1729675426470.png"
            }
        },
        "section3": {
            "type": "content",
            "data": {
                "subTitle": "Adjacent Business Audit/Review Services:",
                "introduction": "AI allows you to expand into adjacent services such as compliance audits, regulatory reviews, and risk assessments. These services can offset revenue losses from automated tasks and provide additional value to clients.\xa0 Diligentsia\u2019s platform has been designed from the ground up with this in mind for firms such as yours."
            }
        },
        "section4": {
            "type": "card",
            "cardStyle": "default",
            "data": {
                title: "Due Diligence Pack",
                "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                "points": [
                    "Bespoked to each company",
                    "Completeness and risk scoring",
                    "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter",
                    "Can be made available by the company to angels within the network"
                ],
                "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
            }
        },
        "section5": {
            "type": "content",
            "data": {
                "subTitle": "Compliance and Regulatory Audits:",
                "introduction": "Offer comprehensive audits to ensure clients adhere to the latest regulations, leveraging AI to analyze compliance data efficiently.\xa0 Diligentsia\u2019s platform allows you to create detailed AI-generated checklists, with automated risk scoring and recommendations, all bespoked to your client, its industry, stage of development and business objectives."
            }
        },
        "section6": {
            "type": "content",
            "data": {
                "subTitle": "Risk Management Consulting:",
                "introduction": "Provide strategic advice on risk mitigation, using AI to identify potential legal risks in business operations."
            }
        },
        "section7": {
            "type": "card",
            "cardStyle": "default",
            "data": {
                "title": "20-Section Business Audit",
                "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/document%201-1729676889972.png",
                "points": [
                    "Step by step audit of each company\u2019s\xa0business",
                    "Quickly identify strengths and weaknesses",
                    "Individually bespoked to their business, industry, stage of development and objective",
                    "Reporting of risks and recommendations for rectification"
                ],
                "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/20sectionBusinessAudit-1729675364365.png"
            }
        },
        "section8": {
            "type": "content",
            "data": {
                "subTitle": "Diligentsia\u2019s AnyList AI checklist builder",
                "introduction": "Enables you to create a bespoked any checklist in minutes."
            }
        },
        "section9": {
            "type": "card",
            "cardStyle": "default",
            "data": {
                "title": "Expansion Pack - AnyList Checklist Builder",
                "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/questions-1729675682686.png",
                "points": [
                    "Undertaking M&A? Create relevant automated dule diligence checklists bespoked to target company",
                    "You can add your own questions and desired answers",
                    "Questions: Can choose subjective, objective or a mixture",
                    "Completeness and risk scoring"
                ],
                "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/anylistChecklist-1729675261266.png"
            }
        },
        "section10": {
            "type": "content",
            "data": {
                "title": "Transforming Billing Models",
                "subTitle": "Value-Based Billing",
                "introduction": "As AI automates routine tasks, the traditional hourly billing model may become less relevant. Instead, practices can adopt value-based billing, charging clients based on the value delivered rather than time spent.",
                "sections": [
                    {
                        "points": [
                            "Outcome-Oriented Fees: Pricing is linked to the achievement of specific financial goals or improvements.",
                            "Enhanced Transparency: Clients have a clearer understanding of what they are paying for and the benefits received.",
                            "Increased Client Satisfaction: Value-based billing aligns the interests of the practice and the client, fostering stronger relationships."
                        ]
                    },
                    {
                        "subTitle": "Subscription Models",
                        "introduction": "Offering services through subscription packages provides clients with predictable costs and continuous support.",
                        "points": [
                            "Tiered Services: Different levels of service packages cater to varying client needs and budgets.",
                            "Continuous Revenue: Subscriptions create steady income for the practice, aiding in financial planning.\xa0 Diligentsia\u2019s Pro Plus solution is designed to assist your firm in this regards.",
                            "Scalable Solutions: Clients can easily upgrade or adjust their subscriptions as their business grows."
                        ]
                    },
                    {
                        "subTitle": "Performance-Based Incentives",
                        "introduction": "In some cases, practices might adopt performance-based billing, where fees are tied to the results achieved.",
                        "points": [
                            "Shared Success: Both the client and the practice benefit from improved financial performance.",
                            "Motivation for Excellence: Practices are incentivized to deliver the best possible outcomes.",
                            "Customized Agreements: Billing structures can be tailored to specific projects or objectives."
                        ]
                    }
                ]
            }
        },
        "section11": {
            "type": "content",
            "data": {
                "title": "Challenges and Considerations",
                "subTitle": "Data Security and Compliance",
                "introduction": "With increased reliance on AI and data analytics, ensuring data security is paramount.",
                "sections": [
                    {
                        "points": [
                            "Regulatory Compliance: Adherence to GDPR and other data protection laws is essential. Diligentsia has a solution that enables you to audit this area.",
                            "Cybersecurity Measures: Implementing robust security protocols to protect sensitive financial information.Diligentsia has a solution that enables you to audit this area.",
                            "Client Trust: Demonstrating a commitment to data security builds client confidence."
                        ]
                    },
                    {
                        "subTitle": "Ethical Use of AI",
                        "introduction": "Responsible use of AI technologies is crucial to maintain professional integrity.",
                        "points": [
                            "Transparency: Being open about how AI is used in service delivery.\xa0 Diligentsia uses digital watermarking on work product created by AI.",
                            "Avoiding Bias: Ensuring AI algorithms do not inadvertently discriminate or make unfair assessments.",
                            "Continuous Monitoring: Regularly reviewing AI systems for accuracy and ethical compliance."
                        ]
                    },
                    {
                        "subTitle": "Staff Training and Adaptation",
                        "introduction": "The introduction of AI requires a shift in skill sets and workplace culture.",
                        "points": [
                            "Upskilling Employees: Providing training on AI tools and data analytics.",
                            "Change Management: Encouraging a culture that embraces innovation and continuous improvement.",
                            "Redefining Roles: Transitioning staff from transactional tasks to strategic advisory positions."
                        ]
                    }
                ]
            }
        },
        "section12": {
            "type": "content",
            "data": {
                "title": "Embracing the Future",
                "subTitle": "Enhanced Advisory Services",
                "introduction": "With AI handling routine tasks, accountants can focus more on providing strategic insights and advisory services.",
                "sections": [
                    {
                        "points": [
                            "Sourcing investment For Growth Clients"
                        ]
                    }
                ]
            }
        },
        "section13": {
            "type": "card",
            "cardStyle": "default",
            "data": {
                "title": "Expansion Pack \u2013 Investor Leads Module*",
                "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/human-resources-1729682616410.png",
                "points": [
                    "Open to Diligentsia gold certification only",
                    "Matches your investment requirements against investors\u2019 investment criteria",
                    "List of curated investor leads, with contact details",
                    "A \u201CFit Report\u201D which shows each the party the Fit with the other"
                ],
                "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/expentionPack-1729675017984.png"
            }
        },
        "section1212": {
            "type": "content",
            "data": {
                "sections": [
                    {
                        "points": [
                            "Business Strategy Consulting: Helping clients with growth strategies, mergers, acquisitions, and market expansion.Diligentsia platform is designed to encourage the generation of fees through business auditing.",
                            "Financial Risk Management: Advising on risk mitigation strategies using data-driven insights.",
                            "Tax Planning: Offering sophisticated tax optimization strategies personalized to each client."
                        ]
                    }
                ]
            }
        },
        "section14": {
            "type": "content",
            "data": {
                "sections": [
                    {
                        "subTitle": "Collaboration with Technology Providers",
                        "introduction": "Partnering with AI and tech firms can enhance service offerings and keep practices at the forefront of innovation.",
                        "points": [
                            "Customized AI Solutions: Developing tools tailored to the practice's specific needs. Diligentsia\u2019s platform has been created by accountants for accountants \u2013 enabling your firm to earn higher margins from existing services, new revenue streams to existing clients and additional revenues from introductions to new clients.",
                            "Ongoing Support and Updates: Ensuring AI systems remain current with technological advancements.",
                            "Competitive Advantage: Differentiating the practice by offering cutting-edge services."
                        ]
                    },
                    {
                        "subTitle": "Client Education",
                        "introduction": "Educating clients about the benefits of AI-enhanced services is essential for acceptance and trust.",
                        "points": [
                            "Demonstrating Value: Showcasing case studies or examples of improved outcomes due to AI.",
                            "Transparent Communication: Explaining how AI works and addressing any concerns.",
                            "Interactive Tools: Providing clients with user-friendly interfaces to interact with AI services. Diligentsia\u2019s platform has been designed with ease-of use in mind \u2013 by advisors and investors, but also their clients."
                        ]
                    }
                ]
            }
        },
        "section15": {
            "type": "content",
            "data": {
                title: "Conclusion",
                "introduction": `AI is set to transform mid-sized UK accountancy practices fundamentally. By automating routine tasks, enhancing data analysis, and enabling personalized services, AI allows accountants to deliver greater value to their clients. Embracing new billing models reflects this enhanced value, moving away from traditional hourly rates to more innovative, client-aligned approaches.`,
                "sections": [
                    {
                        introduction: "While challenges such as data security, ethical considerations, and the need for staff training exist, they are manageable with proactive strategies. Practices that adapt to these changes will not only survive but thrive in the new landscape, offering superior services that meet the evolving needs of their clients."
                    },
                    {
                        subTitle: "Ready to Embrace the Future of Accounting?",
                        introduction: "If you're a mid-sized UK accountancy practice looking to harness the power of AI, we're here to help. Contact us today to discover how our AI-driven solutions can transform your service delivery and billing models, positioning you at the forefront of the industry."
                    }
                ]
            }
        }
    }
};
const $6238ac0b849c9c3e$export$d09847bb5c97319b = [
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Mask%20group%20%2813%29-1729772925281.png",
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/2-min-1729774662225.png",
        category: [
            "Angels",
            "Angel Investors",
            "AI"
        ],
        title: "Harnessing AI: Revolutionizing Angel Investment in Early-Stage Startups",
        slug: "harnessing-ai-revolutionizing-angel-investment-in-early-stage-startups",
        excerpt: "In the ever-evolving world of startup funding, angel investors play a pivotal role in nurturing early-stage small and medium-sized enterprises...",
        author: {
            name: "Isaac",
            role: "Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/pic-1729851406062.png"
        },
        date: "Oct 1, 2024, 2:05PM",
        postData: {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In the ever-evolving world of startup funding, angel investors play a pivotal role in nurturing early-stage small and medium-sized enterprises (SMEs). However, the traditional methods of selecting and supporting startups are often time-consuming, costly, and fraught with uncertainty. Enter Artificial Intelligence (AI)\u2014a transformative technology poised to revolutionize the angel investment landscape.",
                    "list": [
                        {
                            "listHeading": "This article explores how AI can enhance the angel investment process by:",
                            "points": [
                                "Identifying Promising Startups for Investment",
                                "Facilitating Cost-Effective Pre-Investment Due Diligence",
                                "Facilitating Cost-Effective Pre-Investment Due Diligence",
                                "Enhancing Portfolio Returns for Angel Investors"
                            ]
                        }
                    ]
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "title": "1. Identifying Promising Startups for Investment",
                    "subTitle": "AI-Powered Deal Sourcing",
                    "introduction": "Traditionally, angel investors rely on personal networks, pitch events, and referrals to discover investment opportunities. AI can significantly broaden this horizon:",
                    "sections": [
                        {
                            "points": [
                                "Data Mining and Analysis: AI algorithms can scan vast amounts of data from startup databases, social media, news articles, and industry reports to identify startups that match specific investment criteria."
                            ]
                        }
                    ]
                }
            },
            "section3": {
                "type": "card",
                "cardStyle": "secondary",
                "data": {
                    "title": "Investor & Applicant Curated <r>Lead Matching",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000001416%201-1729685942444.png"
                }
            },
            "section5": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "pointSideImage": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002246-1729838306319.png",
                            "points": [
                                "Predictive Analytics: Machine learning models can predict a startup's potential for success by analyzing patterns in historical data, such as founder experience, market trends, and funding history.",
                                "Automated Scoring Systems: AI tools can assign scores to startups based on predefined metrics, helping nvestors prioritize companies with the highest potential. Diligentsia has such a system, which result in a company achieving bronze/silver or gold certification."
                            ]
                        }
                    ]
                }
            },
            "section6": {
                "type": "content",
                "data": {
                    "subTitle": "Benefits for Angel Investors",
                    "sections": [
                        {
                            "points": [
                                "Efficiency: Streamlines the sourcing process, saving time and resources.",
                                "Expanded Opportunities: Uncovers hidden gems that might be overlooked through traditional methods.",
                                "Data-Driven Decisions: Reduces reliance on intuition by providing objective assessments."
                            ]
                        }
                    ]
                }
            },
            "section7": {
                "type": "content",
                "data": {
                    "title": "2. Facilitating Cost-Effective Pre-Investment Due Diligence",
                    "subTitle": "The Challenge of Due Diligence",
                    "introduction": "Conducting thorough due diligence on early-stage startups is often cost-prohibitive for individual angel investors. Traditional methods require extensive time and resources, making it impractical for small investments."
                }
            },
            "section8": {
                "type": "content",
                "data": {
                    "subTitle": "AI-Enabled Due Diligence"
                }
            },
            "section9": {
                "type": "card",
                "cardStyle": "secondary",
                "bgImage": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002247-1729834244758.png",
                "data": {
                    "title": "We help you invest with your eyes <r>Wide Open",
                    "subTitle": "Standardising transparency across your portfolio",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002248-1729687473079.png"
                }
            },
            "section10": {
                "type": "content",
                "data": {
                    "introduction": "AI offers a solution by automating and enhancing the due diligence process:",
                    "sections": [
                        {
                            "points": [
                                "Financial Analysis: AI algorithms can quickly assess financial statements, burn rates, and revenue projections, identifying red flags and opportunities.",
                                "Market Evaluation: AI tools analyze market size, competition, and customer sentiment to evaluate the startup's market fit.",
                                "Founder Assessment: Natural Language Processing (NLP) can analyze founders' online presence, including social media and past ventures, to assess credibility and track records.",
                                "Legal and Compliance Checks: AI can automate background checks and identify potential legal issues by scanning public records and regulatory databases.",
                                "Diligence Pack: Diligentsia\u2019s platform enables applicant companies to self-diligence quickly and easily through AI-assisted checklist modules with \u201Cyes/no\u201D answers. Each module is bespoked to the specific company, its industry, stage of development and business objectives. The AI does the rest \u2013 completeness and risk scoring, automated reporting with recommendations for rectification where necessary, along with workflow processes."
                            ]
                        }
                    ]
                }
            },
            "section11": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Due Diligence Pack",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                    "points": [
                        "Bespoked to each company",
                        "Completeness and risk scoring",
                        "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter",
                        "Can be made available by the company to angels within the network"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
                }
            },
            "section12": {
                "type": "content",
                "data": {
                    "subTitle": "Advantages",
                    "sections": [
                        {
                            "points": [
                                "Cost Savings: Reduces the expenses associated with manual due diligence.",
                                "Speed: Accelerates the evaluation process, allowing investors to act quickly.",
                                "Comprehensive Insights: Provides a 360-degree view of the startup's potential and risks.\xa0 Diligentsia\u2019s platform provides such detailed insights."
                            ]
                        }
                    ]
                }
            },
            "section13": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "20-Section Business Audit",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/document%201-1729676889972.png",
                    "points": [
                        "Step by step audit of each company\u2019s\xa0business",
                        "Quickly identify strengths and weaknesses",
                        "Individually bespoked to their business, industry, stage of development and objective",
                        "Reporting of risks and recommendations for rectification"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/20sectionBusinessAudit-1729675364365.png"
                }
            },
            "section14": {
                "type": "content",
                "data": {
                    "title": "3. Supporting the First 100 Days Post-Investment",
                    "subTitle": "Importance of the Initial Growth Phase",
                    "introduction": "The first 100 days post-investment are critical for setting the foundation of a startup's success. Angel investors can add significant value by providing strategic support during this phase.",
                    "sections": [
                        {
                            "subTitle": "AI-Driven Post-Investment Support",
                            "points": [
                                "Business Audits: AI tools can conduct comprehensive audits of key business areas such as operations, finance, marketing, and HR to identify strengths and weaknesses.\xa0 Diligentsia\u2019s Healthboost modules deliver this functionality.",
                                "Customized Growth Plans: Machine learning models can recommend tailored growth strategies based on industry trends and the startup's unique positioning.",
                                "Performance Monitoring: AI systems track key performance indicators (KPIs) in real-time, enabling proactive management and swift course corrections.\xa0Diligentsia\u2019s platform has KPI Reporting.",
                                "Resource Optimization: AI can identify areas where automation or process improvements can increase efficiency and reduce costs.\xa0 Diligentsia\u2019s Healthboost modules deliver this functionality."
                            ]
                        }
                    ]
                }
            },
            "section15": {
                "type": "image",
                "data": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002248%20%281%29-1729848854893.png"
            },
            "section16": {
                "type": "content",
                "data": {
                    "subTitle": "Benefits for Startups and Investors",
                    "sections": [
                        {
                            "points": [
                                "Accelerated Growth: Strategic insights and optimization lead to faster scaling.",
                                "Risk Mitigation: Early identification of issues prevents minor problems from becoming major setbacks.",
                                "Enhanced Collaboration: Data-driven insights facilitate better communication between investors and founders."
                            ]
                        }
                    ]
                }
            },
            "section17": {
                "type": "content",
                "data": {
                    "title": "4. Enhancing Portfolio Returns for Angel Investors",
                    "subTitle": "Compounding Effects of AI Integration",
                    "introduction": "By improving the selection process and providing robust post-investment support, AI significantly enhances the potential returns on investment:",
                    "sections": [
                        {
                            "points": [
                                "Higher Success Rates: Better due diligence and support increase the likelihood of startup success.",
                                "Efficient Capital Allocation: AI helps investors allocate resources to the most promising ventures.",
                                "Informed Exit Strategies: Data analytics can signal optimal timing for exits, maximizing returns."
                            ]
                        },
                        {
                            "subTitle": "Why AI Enhances Returns",
                            "points": [
                                "Reduced Failure Rates: Identifying risks early and supporting startups effectively reduces the chances of failure.",
                                "Value Creation: Startups leveraging AI are often more innovative and competitive, increasing their market valuation.",
                                "Scalability: AI allows investors to manage larger portfolios without a proportional increase in workload."
                            ]
                        },
                        {
                            "subTitle": "Real-World Impact",
                            "points": [
                                "Investor Alpha: By integrating AI, an angel investor could see a significant increase in the overall performance of their investment portfolio.",
                                "Startup Success Stories: Startups receiving AI-driven support are more likely to achieve key milestones, attract additional funding, or reach successful exits."
                            ]
                        }
                    ]
                }
            },
            "section18": {
                "type": "content",
                "data": {
                    "title": "Conclusion",
                    "introduction": "Artificial Intelligence is revolutionizing the angel investment landscape by enabling investors to make smarter, data-driven decisions and provide meaningful support to their portfolio companies. From identifying the most promising startups to enhancing their growth trajectory, AI offers tools that can significantly improve investment outcomes.",
                    "sections": [
                        {
                            introduction: "For angel investors making multiple investments, the integration of AI not only streamlines operations but also enhances the potential for higher returns. By embracing AI, investors position themselves at the forefront of innovation, ready to capitalize on the opportunities of tomorrow."
                        },
                        {
                            subTitle: "Ready to Transform Your Investment Strategy with AI?",
                            introduction: "If you're an angel investor looking to leverage AI to enhance your investment process and portfolio returns, we're here to help. Contact us today to discover how our AI-driven solutions can revolutionize your investment approach and support your portfolio startups' growth."
                        }
                    ]
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/2-min-1729842103570.png",
        category: [
            "Angel Investors",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/3-min-1729774692275.png",
        title: "AI Revolution: Transforming Angel Investor Networks for Enhanced Portfolio Returns",
        slug: "ai-revolution-transforming-angel-investor-networks-for-enhanced-portfolio-returns",
        excerpt: "In the dynamic landscape of startup funding, angel investor networks play a crucial role in nurturing early-stage SMEs. However...",
        author: {
            name: "Mark Bernstein",
            role: "Founder, Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/pic-1729851406062.png"
        },
        date: "Oct 6, 2024, 9:30AM",
        postData: {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In the dynamic landscape of startup funding, angel investor networks play a crucial role in nurturing early-stage SMEs. However, traditional methods often present challenges, particularly in pre-investment due diligence and post-investment support. Enter Artificial Intelligence (AI)\u2014a transformative technology poised to revolutionize how angel investor networks operate."
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "list": [
                        {
                            "listHeading": "This article explores how AI can:",
                            "points": [
                                "Enable Effective Pre-Investment Due Diligence <break> of applicant SMEs, overcoming cost barriers.",
                                "Support the Initial First 100-Day Growth <break> of businesses post-investment by auditing the basics of each business area.",
                                "Enhance Portfolio Returns <break> for both the angel network and its investors."
                            ]
                        }
                    ]
                }
            },
            "section3": {
                "type": "card",
                "cardStyle": "secondary",
                "bgImage": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002247-1729834244758.png",
                "data": {
                    "title": "Adding value to your <r>Network",
                    "subTitle": "Improved network portfolio returns, improved network reputation",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/2-1729752839938.png",
                    "maxWidth": "400px"
                }
            },
            "section5": {
                "type": "content",
                "data": {
                    "title": "1. AI-Enabled Effective Pre-Investment Due Diligence",
                    "subTitle": "Overcoming Cost Constraints",
                    "introduction": "Conducting thorough pre-investment due diligence on applicant companies is traditionally expensive and time-consuming. For angel investors dealing with early-stage startups, the cost often outweighs the potential investment, leading to reliance on limited information and gut instinct."
                }
            },
            "section6": {
                "type": "content",
                "data": {
                    "introduction": "Diligentsia\u2019s platform enables applicant companies to self-diligence quickly and easily through AI-assisted checklist modules with \u201Cyes/no\u201D answers. Each module is bespoked to the specific company, its industry, stage of development and business objectives. The AI does the rest \u2013 completeness and risk scoring, automated reporting with recommendations for rectification where necessary, along with workflow processes."
                }
            },
            "section7": {
                "type": "content",
                "data": {
                    "introduction": "The company then gets certified \u2013 bronze/silver/gold \u2013 assisting angels to determine its level of preparedness and encouraging companies to become better prepared."
                }
            },
            "section7": {
                "type": "content",
                "data": {
                    "subTitle": "AI-Powered Due Diligence",
                    "sections": [
                        {
                            "pointHeading": "AI offers a solution by automating and accelerating the due diligence process:",
                            "points": [
                                "Automated Data Analysis: AI algorithms can swiftly analyze financial statements, business plans, and market data, providing a comprehensive overview of the company's viability."
                            ]
                        }
                    ]
                }
            },
            "section8": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "20-Section Business Audit",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/document%201-1729676889972.png",
                    "points": [
                        "Step by step audit of each company\u2019s\xa0business",
                        "Quickly identify strengths and weaknesses",
                        "Individually bespoked to their business, industry, stage of development and objective",
                        "Reporting of risks and recommendations for rectification"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/20sectionBusinessAudit-1729675364365.png"
                }
            },
            "section9": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "pointSideImage": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002246-1729838306319.png",
                            "points": [
                                "Risk Assessment: Machine learning models identify potential risks by detecting patterns and anomalies that might be missed by human analysts.",
                                "Background Checks: Natural Language Processing (NLP) tools can scan news articles, social media, and public records to provide insights into the company's reputation and the founders' backgrounds.",
                                "Automated Scoring Systems: AI tools can assign scores to startups based on predefined metrics, helping investors prioritize companies with the highest potential. Diligentsia has such a system, which result in a company achieving bronze/silver or gold certification."
                            ]
                        }
                    ]
                }
            },
            "section10": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Due Diligence Pack",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                    "points": [
                        "Bespoked to each company",
                        "Completeness and risk scoring",
                        "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter",
                        "Can be made available by the company to angels within the network"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
                }
            },
            "section11": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Diligence Pack: Diligentsia\u2019s platform enables applicant companies to self-diligence quickly and easily through AI-assisted checklist modules with \u201Cyes/no\u201D answers. Each module is bespoked to the specific company, its industry, stage of development and business objectives. The AI does the rest \u2013 completeness and risk scoring, automated reporting with recommendations for rectification where necessary, along with workflow processes."
                            ]
                        }
                    ]
                }
            },
            "section12": {
                "type": "content",
                "data": {
                    "subTitle": "Benefits for Angel Networks",
                    "sections": [
                        {
                            "points": [
                                "Cost Efficiency: Reduces expenses associated with due diligence, allowing networks to evaluate more startups without incurring prohibitive costs.\xa0 Diligentsia\u2019s platform was created to achieve this.",
                                "Speed: Accelerates the decision-making process, enabling investors to seize promising opportunities quickly.",
                                "Informed Decisions: Provides deeper insights, leading to more accurate assessments and better investment choices."
                            ]
                        }
                    ]
                }
            },
            "section13": {
                "type": "content",
                "data": {
                    "title": "2. Supporting the Initial First 100-Day Growth Post-Investment",
                    "subTitle": 'Auditing "The Basics"',
                    "introduction": "The first 100 days post-investment are critical for setting the trajectory of a startup's success. AI can assist angel investors in auditing and optimizing fundamental aspects of the business:",
                    "sections": [
                        {
                            "points": [
                                "Operational Efficiency: AI tools analyze workflows to identify bottlenecks and recommend process improvements.",
                                "Financial Management: AI-powered accounting software offers real-time financial monitoring, cash flow analysis, and budgeting assistance.",
                                "Market Strategy: AI-driven analytics help refine target markets, optimize pricing strategies, and enhance customer segmentation.",
                                "Product Development: Machine learning models predict customer needs and preferences, guiding product enhancements and innovations."
                            ]
                        }
                    ]
                }
            },
            "section14": {
                "type": "image",
                "data": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002248%20%281%29-1729848854893.png"
            },
            "section15": {
                "type": "content",
                "data": {
                    "title": "Implementation Strategies",
                    "sections": [
                        {
                            "points": [
                                "Customized AI Solutions: Tailor AI tools to address the specific challenges and opportunities within each startup.",
                                "Collaborative Platforms: Utilize AI-enabled platforms that facilitate communication and knowledge sharing between investors and startups. Our Diligentsia.co.uk is one such platform.",
                                "Performance Monitoring: Set up AI systems to track key performance indicators (KPIs), allowing for real-time adjustments and support. Diligentsia\u2019s platform offers each company a free bespoked KPI Report along with explanations on how to implement. There are then additional modules to progress this reporting and benchmarking."
                            ]
                        }
                    ]
                }
            },
            "section16": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Your Portfolio Company\u2019s FREE KPI Report",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/kpi%20%281%29-1729760548948.png",
                    "points": [
                        "AI generated list of Key Performance Indicators",
                        "Specifically generated for their business",
                        "Portfolio bench marking"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000000954-1729760566606.png"
                }
            },
            "section17": {
                "type": "content",
                "data": {
                    "subTitle": "Outcomes for Startups",
                    "sections": [
                        {
                            "points": [
                                "Customized AI Solutions: Tailor AI tools to address the specific challenges and opportunities within each startup.",
                                "Collaborative Platforms: Utilize AI-enabled platforms that facilitate communication and knowledge sharing between investors and startups. Our Diligentsia.co.uk is one such platform.",
                                "Performance Monitoring: Set up AI systems to track key performance indicators (KPIs), allowing for real-time adjustments and support. Diligentsia\u2019s platform offers each company a free bespoked KPI Report along with explanations on how to implement. There are then additional modules to progress this reporting and benchmarking."
                            ]
                        }
                    ]
                }
            },
            "section18": {
                "type": "content",
                "data": {
                    "title": "3. Enhancing Portfolio Returns for Angel Networks and Investors",
                    "subTitle": "Compounding Benefits",
                    "introduction": "By improving due diligence and providing robust post-investment support, AI enhances overall portfolio performance:",
                    "sections": [
                        {
                            "points": [
                                "Risk Mitigation: Better pre-investment analysis reduces the likelihood of investing in under performing startups.",
                                "Increased Success Rates: Effective support boosts startups' chances of success, leading to higher valuations.",
                                "Optimized Exits: Well-prepared companies are more attractive to follow-on investors or acquirers, potentially leading to lucrative exits. Diligence Packs: Diligentsia enables you or your company to self-diligence prior to the process to identify issues and enable them to be rectified prior to the commencement of the process. The pack includes Data Room Report, Business Audit covering 20 areas eg. IP, legal, draft warranty disclosures and directors\u2019 questionnaires."
                            ]
                        }
                    ]
                }
            },
            "section19": {
                "type": "content",
                "data": {
                    "subTitle": "Why AI Enhances Returns",
                    "sections": [
                        {
                            "points": [
                                "Data-Driven Decisions: AI provides actionable insights, reducing reliance on intuition and increasing investment accuracy.",
                                "Scalable Support: AI tools can be applied across multiple startups, standardizing best practices and maximizing resource efficiency.",
                                "Early Intervention: Real-time monitoring enables prompt action to address issues before they escalate, preserving value."
                            ]
                        }
                    ]
                }
            },
            "section20": {
                "type": "content",
                "data": {
                    "title": "Conclusion",
                    "introduction": "Artificial Intelligence is set to revolutionize angel investor networks, offering tools that enhance every stage of the investment lifecycle. From cost-effective pre-investment due diligence to strategic post-investment support, AI empowers investors to make smarter decisions and drive the success of their portfolio companies. By embracing AI, angel networks can overcome traditional barriers, improve investment outcomes, and significantly enhance portfolio returns. This not only benefits the investors but also contributes to a more robust and dynamic startup ecosystem.",
                    "sections": [
                        {
                            subTitle: "Ready to Elevate Your Angel Investment Strategy with AI?",
                            introduction: "If you're part of an angel investor network aiming to boost portfolio returns and streamline operations through AI, we're here to assist. Contact us today to discover how our AI-driven solutions can transform your investment processes and support your portfolio startups' growth."
                        }
                    ]
                }
            },
            "section21": {
                "type": "card",
                "cardStyle": "secondary",
                "data": {
                    "title": "Investor & Applicant Curated <r>Lead Matching",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000001416%201-1729685942444.png"
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/3-min-1729842133020.png",
        category: [
            "Companies",
            "Exit",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/4-min-1729774860663.png",
        title: "AI Revolution: Transforming Professional Services for UK SMEs Seeking a Trade Exit/Sale",
        slug: "ai-revolution-transforming-professional-services-for-uk-smes-seeking-a-trade-exitsale",
        excerpt: "In today's fast-paced business environment, Artificial Intelligence (AI) is not just a buzzword\u2014it's a transformative force...",
        author: {
            name: "Irij Mahmood",
            role: "Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/irij%20photo-1730098047371.png"
        },
        date: "Oct 6, 2024, 9:30AM",
        "postData": {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In today's fast-paced business environment, Artificial Intelligence (AI) is not just a buzzword\u2014it's a transformative force reshaping industries worldwide. For UK small and medium-sized enterprises (SMEs) aiming for a trade exit or sale, AI is revolutionizing professional services, offering innovative solutions to streamline the process and maximize value."
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "title": "The AI Impact on Professional Services",
                    "subTitle": "Automating Due Diligence Processes",
                    "introduction": "Due diligence is a critical phase in any trade exit or sale, involving exhaustive checks on financials, legal obligations, and operational practices. AI-powered tools can automate significant portions of this process. Machine learning algorithms can sift through vast amounts of data\u2014financial records, contracts, compliance documents\u2014to identify inconsistencies or red flags more efficiently than manual reviews.\xa0 Diligentsia\u2019s automated platform helps you to self create a draft diligence pack in advance of the exit \u2013 saving you substantial professional fees and providing you the opportunity to resolve issues well in advance of the transaction."
                }
            },
            "section3": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Due Diligence Pack",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                    "points": [
                        "Bespoked to each company",
                        "Completeness and risk scoring",
                        "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter",
                        "Can be made available by the company to angels within the network"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
                }
            },
            "section4": {
                "type": "content",
                "data": {
                    "subTitle": "Enhanced Valuation Models",
                    "introduction": "Accurate business valuation is paramount when preparing for a sale. AI enhances traditional valuation models by incorporating real-time data analysis and predictive analytics. By assessing market trends, competitor performance, and internal financial metrics, AI provides a more precise and dynamic valuation, ensuring that SMEs receive a fair and optimized price."
                }
            },
            "section5": {
                "type": "content",
                "data": {
                    "subTitle": "Personalized Buyer Matching",
                    "introduction": "Finding the right buyer can significantly impact the success of a trade exit. AI platforms are now capable of matching SMEs with potential buyers by analyzing compatibility factors such as industry focus, company culture, and strategic goals. This personalized matchmaking increases the likelihood of a successful sale and a smoother transition post-acquisition. Diligentsia has links with a number of organisations who can help in this regard."
                }
            },
            "section6": {
                "type": "content",
                "data": {
                    "title": "How AI Benefits UK SMEs in Trade Exits/Sales",
                    "subTitle": "Streamlined Transaction Processes",
                    "introduction": "AI reduces the time and resources required to complete a sale. Automated document processing, smart contract generation, and AI-driven negotiation tools expedite transactions, allowing SMEs to close deals faster while reducing legal and administrative costs."
                }
            },
            "section7": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Expansion Pack - Warranty Disclosure*",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%20%287%29-1729761910743.png",
                    "points": [
                        "Save thousands on lawyers\u2019 fees",
                        "Normally an expensive exercise at the end of a transaction",
                        "Based on the UK BVCA standard disclosure letter"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002256-1729763422808.png"
                }
            },
            "section8": {
                "type": "content",
                "data": {
                    "subTitle": "Improved Negotiation Strategies",
                    "introduction": "AI can analyze previous negotiation outcomes and market data to recommend optimal negotiation strategies. By understanding the buyer's profile and the SME's strengths, AI tools can suggest terms and conditions that are more likely to be accepted, leading to more favorable outcomes."
                }
            },
            "section9": {
                "type": "content",
                "data": {
                    "subTitle": "Risk Assessment and Mitigation",
                    "introduction": "Identifying potential risks before entering negotiations is crucial. AI systems can predict potential pitfalls by analyzing historical data and market indicators. This proactive approach allows SMEs to address issues beforehand, making them more attractive to buyers and reducing the likelihood of deal failures. Diligentsia\u2019s platform incorporates extensive bespoked risk reporting and recommendations for improvement \u2013 all personalised to your company."
                }
            },
            "section10": {
                "type": "image",
                "data": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Frame%203474777-1729762335122.png"
            },
            "section11": {
                "type": "content",
                "data": {
                    "title": "Overcoming Challenges and Ethical Considerations",
                    "sections": [
                        {
                            "subTitle": "Data Security and Confidentiality",
                            "introduction": "The trade exit process involves sensitive information that must be protected. SMEs must ensure that AI tools comply with data protection regulations like the UK's Data Protection Act and GDPR. Implementing robust cybersecurity measures is essential to maintain confidentiality and build trust with potential buyers. Diligentsia is DPA compliant."
                        },
                        {
                            "subTitle": "Integration with Existing Systems",
                            "introduction": "Adopting AI technologies may require integration with current IT systems. SMEs should assess their technological infrastructure to ensure compatibility. Working with professional service providers who specialize in AI can facilitate a seamless integration process. Diligentsia\u2019s Data Repository integrates with Dropbox, Sharepoint and Drive."
                        },
                        {
                            "subTitle": "Ethical AI Deployment",
                            "introduction": "Transparent and ethical use of AI is vital. SMEs should ensure that AI algorithms used in valuations and buyer matching are free from biases that could affect outcomes. Ethical AI practices not only comply with regulations but also enhance the company's reputation during the sale process. Diligentsia\u2019s platform contains AIO digital watermarking where appropriate."
                        }
                    ]
                }
            },
            "section12": {
                "type": "content",
                "data": {
                    "title": "Practical Steps for SMEs Embracing AI",
                    "sections": [
                        {
                            "subTitle": "1. Evaluate Your Needs",
                            "introduction": "Identify specific areas in the trade exit process where AI can add value. This could be in due diligence, valuation, buyer matching, or negotiation support."
                        },
                        {
                            "subTitle": "2. Choose the Right AI Tools",
                            "introduction": "Select AI solutions that are tailored to your industry and business size. Consider scalability, user-friendliness, and the level of support provided by the vendor."
                        },
                        {
                            "subTitle": "3. Partner with AI-Savvy Professionals",
                            "introduction": "Collaborate with professional service firms that have expertise in AI. They can provide guidance on best practices, ensure compliance with regulations, and help you leverage AI effectively throughout the sale process."
                        },
                        {
                            "subTitle": "4. Train Your Team",
                            "introduction": "Invest in training programs to up skill your staff. Understanding how to work alongside AI tools will maximize their benefits and improve overall efficiency."
                        },
                        {
                            "subTitle": "5. Monitor and Adapt",
                            "introduction": "Continuously monitor the impact of AI on your processes. Be prepared to make adjustments and stay updated with the latest AI developments to maintain a competitive edge."
                        }
                    ]
                }
            },
            "section13": {
                "type": "content",
                "data": {
                    "title": "The Road Ahead: Maximizing Exit Value with AI",
                    "sections": [
                        {
                            "introduction": "For UK SMEs, embracing AI is more than a technological upgrade\u2014it's a strategic move that can significantly enhance the value and success of a trade exit or sale. By leveraging AI, SMEs can present a more robust, efficient, and attractive proposition to potential buyers."
                        }
                    ]
                }
            },
            "section14": {
                "type": "content",
                "data": {
                    "title": "Conclusion",
                    "introduction": "AI is revolutionizing the delivery of professional services, offering UK SMEs unprecedented opportunities to optimize their trade exit or sale processes. By adopting AI technologies, SMEs can enhance efficiency, reduce risks, and ultimately achieve better outcomes in their exit strategies.",
                    "sections": [
                        {
                            subTitle: "Ready to Leverage AI for your organisation\u2019s growth?",
                            introduction: "If you're a UK SME planning a trade exit or sale, integrating AI into your strategy could be the key to unlocking maximum value. Contact us today to discover how our AI-driven professional services platform can guide you through a seamless and profitable exit process."
                        }
                    ]
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/7-min-1729842170948.png",
        category: [
            "Lawyers",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/8-min-1729775423415.png",
        title: "AI Revolution: Transforming Mid-Sized UK Corporate Law Firms",
        slug: "ai-revolution-transforming-mid-sized-uk-corporate-law-firms",
        excerpt: "In the rapidly evolving landscape of legal services, Artificial Intelligence (AI) is not just a buzzword\u2014it's a transformative force...",
        author: {
            name: "Isaac",
            role: "Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/image-1730098103998.png"
        },
        date: "Oct 6, 2024, 9:30AM",
        "postData": {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In the rapidly evolving landscape of legal services, Artificial Intelligence (AI) is not just a buzzword\u2014it's a transformative force reshaping the industry. For mid-sized firms of corporate lawyers, understanding and embracing AI is no longer optional; it's imperative. This presentation outlines the main threats and opportunities posed by AI to your business and argues why adopting an AI professional services platform is crucial for your continued success. We will focus less on automated document creation and more on adjacent business audit and review services that can offset the loss of fees due to automation. Additionally, we will explore novel billing structures suitable for the AI-driven future.",
                    "title": "The Looming Threats of AI",
                    "list": [
                        {
                            "points": [
                                "Reduction in Traditional Revenue Streams: AI-powered platforms are automating tasks traditionally billed by lawyers, such as contract drafting, due diligence, and basic legal research. This automation leads to a reduction in billable hours and challenges the conventional revenue models of law firms.",
                                "Emergence of AI-Driven Competitors: Tech-savvy competitors and alternative legal service providers are leveraging AI to offer faster, more cost-effective solutions. They can undercut your pricing by reducing operational costs through automation, posing a significant threat to your market share. Examples are SeedLegals, Vestd and Diligentsia.",
                                "Changing Client Expectations: Clients are increasingly expecting more for less. With awareness of AI capabilities, clients demand quicker turnaround times and lower costs, pressuring firms to adapt or risk losing business.",
                                "Disintermediation Risks:  AI tools enable clients to handle certain legal tasks in-house without the need for external counsel. This direct access diminishes your role and value proposition as legal advisors. Whilst Diligentsia\u2019s platform has been designed to be used both by advisors and standalone by a client, in practice many clients will still want to offload this work to their advisors.\xa0 Diligentsia Pro PLUS solution is specifically designed to enable advisors such as your firm to earn additional revenues from new services and new clients.",
                                "Skill Obsolescence Among Lawyers: Without AI integration, your lawyers risk falling behind in efficiency and effectiveness. This gap can make them less competitive compared to peers who utilize AI tools."
                            ]
                        }
                    ]
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "title": "The Promising Opportunities of AI",
                    "list": [
                        {
                            "points": [
                                "Operational Efficiency: Automation of routine tasks frees up your lawyers to focus on complex legal matters and client relationships. This efficiency can lead to increased capacity without a proportional increase in workload.",
                                "Data-Driven Insights: Leveraging AI across your client base provides you with aggregated data insights. These insights can inform best practices, market trends, and tailored advice for your clients.",
                                "Competitive Differentiation:  Early adoption of AI positions your firm as an innovator in the legal market. This differentiation can attract new clients seeking cutting-edge legal solutions and retain existing clients looking for continual improvement.",
                                " Upskilling Your Workforce: Integrating AI into your operations offers professional development opportunities for your lawyers. This investment in your talent pool enhances job satisfaction and loyalty.",
                                "Adjacent Business Audit/Review Services: AI allows you to expand into adjacent services such as compliance audits, regulatory reviews, and risk assessments. These services can offset revenue losses from automated tasks and provide additional value to clients. Diligentsia\u2019s platform has been designed from the ground up with this in mind for firms such as yours."
                            ]
                        }
                    ]
                }
            },
            "section3": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "Diligentsia Pro PLUS",
                    "titlePrefixIcon": "https://cdn.builder.io/api/v1/image/assets/TEMP/5f322ee968595006f8b88c04d866ef69428cde2743b351d9d30f72aa1d21ea1f?placeholderIfAbsent=true&apiKey=0e804629346e4662b140bf48de8efc48",
                    "points": [
                        "You can charge for quarterly reviews/completion",
                        "Process designed for your junior staff using checklists to ensure completeness",
                        "Certification is valid for 3 months"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/diligentsiaProPlus-1729675426470.png"
                }
            },
            "section4": {
                "type": "content",
                "data": {
                    "list": [
                        {
                            "points": [
                                "Enhanced Advisory Services: AI can process and analyse vast amounts of data, enabling your lawyers to provide deeper strategic insights and more informed legal advice."
                            ]
                        }
                    ]
                }
            },
            "section5": {
                "type": "content",
                "data": {
                    "title": "Counteracting Fee Losses with Adjacent Services",
                    "list": [
                        {
                            "introduction": "As automation reduces fees from traditional legal tasks, expanding into adjacent services can compensate for this loss"
                        }
                    ]
                }
            },
            "section6": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Due Diligence Pack",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                    "points": [
                        "Bespoked to each company",
                        "Completeness and risk scoring",
                        "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter",
                        "Can be made available by the company to angels within the network"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
                }
            },
            "section50": {
                "type": "content",
                "data": {
                    "title": "Counteracting Fee Losses with Adjacent Services",
                    "list": [
                        {
                            "points": [
                                "Compliance and Regulatory Audits: Offer comprehensive audits to ensure clients adhere to the latest regulations, leveraging AI to analyze compliance data efficiently. Diligentsia\u2019s platform allows you to create detailed AI-generated checklists, with automated risk scoring and recommendations, all bespoked to your client, its industry, stage of development and business objectives.",
                                "Risk Management Consulting:  Provide strategic advice on risk mitigation, using AI to identify potential legal risks in business operations."
                            ]
                        }
                    ]
                }
            },
            "section7": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "20-Section Business Audit",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/document%201-1729676889972.png",
                    "points": [
                        "Step by step audit of each company\u2019s\xa0business",
                        "Quickly identify strengths and weaknesses",
                        "Individually bespoked to their business, industry, stage of development and objective",
                        "Reporting of risks and recommendations for rectification"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/20sectionBusinessAudit-1729675364365.png"
                }
            },
            "section51": {
                "type": "content",
                "data": {
                    "title": "Counteracting Fee Losses with Adjacent Services",
                    "list": [
                        {
                            "points": [
                                "Corporate Governance Reviews: Assist clients in evaluating and improving their governance structures, with AI aiding in the analysis of governance data and practices.",
                                "Cybersecurity and Data Privacy Advisory: With AI, offer services that help clients navigate the complexities of data protection laws and cybersecurity risks. We have created ready to sue checklists, or you can create your own in minutes \u2013 incorporating completeness and risk scoring, automated reporting, billing and workflow management",
                                "Intellectual Property Portfolio Management: Use AI tools to help clients manage and protect their IP assets more effectively.\xa0 Diligentsia has business audit flows in this area.",
                                "Environmental, Social, and Governance (ESG) Consulting: Leverage AI to analyze ESG performance and guide clients in meeting sustainability goals. Diligentsia has business audit flows in this area.",
                                "Diligentsia\u2019s AnyList AI checklist builder: enables you to create a bespoked any checklist in minutes:."
                            ]
                        }
                    ]
                }
            },
            "section9": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "Expansion Pack - AnyList Checklist Builder",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/questions-1729675682686.png",
                    "points": [
                        "Undertaking M&A? Create relevant automated dule diligence checklists bespoked to target company",
                        "You can add your own questions and desired answers",
                        "Questions: Can choose subjective, objective or a mixture",
                        "Completeness and risk scoring"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/anylistChecklist-1729675261266.png"
                }
            },
            "section10": {
                "type": "content",
                "data": {
                    "title": "Novel Billing Structures for the AI Era",
                    "list": [
                        {
                            "introduction": "Traditional hourly billing may become less relevant as AI increases efficiency. Adopting novel billing structures can align your services with client expectations:",
                            "points": [
                                "Value-Based Pricing: Shift to pricing based on the value delivered rather than time spent. Charge clients for the expertise and outcomes provided, such as successful compliance audits or risk mitigation strategies.",
                                "Subscription Models: Offer ongoing legal advisory services for a fixed monthly or annual fee. This model provides clients with consistent access to your expertise and fosters long-term relationships. Diligentsia\u2019s Pro PLUS solution was built with this in mind.",
                                "Fixed-Fee Arrangements: Provide a set price for specific services or projects. This approach offers cost predictability for clients and encourages efficiency within your firm.",
                                "Performance-Based Fees: Tie fees to the achievement of specific outcomes or milestones. For example, a bonus for successful regulatory approvals or dispute resolutions.",
                                "Retainer Agreements with Flexible Scope: Establish retainers that cover a range of services, allowing clients to access various legal and advisory services as needed. Diligentsia\u2019s Pro PLUS solution was built with this in mind.",
                                "Hybrid Models: Combine different billing methods to suit client needs and service types. For instance, a base subscription fee supplemented by fixed fees for specialized projects.",
                                "Collaborative Risk Sharing: In high-stakes matters, consider fee arrangements that share risk and reward with clients, aligning your interests closely with theirs."
                            ]
                        }
                    ]
                }
            },
            "section11": {
                "type": "content",
                "data": {
                    "title": "Why You Must Adopt an AI Professional Services Platform",
                    "list": [
                        {
                            "points": [
                                "Staying Competitive: AI is becoming integral in legal services. Adopting an AI platform ensures you remain competitive and relevant in a rapidly changing market.",
                                "Meeting Client Needs: Clients expect modern solutions and efficiency. AI integration demonstrates your commitment to innovation and client service excellence.",
                                "Enhancing Service Value: AI enhances your ability to deliver high-quality services, justifying premium pricing and fostering client trust.",
                                "Expanding Service Offerings: An AI platform enables you to offer new services, such as data analytics and predictive legal outcomes, expanding your revenue streams.",
                                "Improving Efficiency and Profitability: AI streamlines operations, reducing costs and increasing profitability without compromising on service quality.",
                                "Attracting and Retaining Talent: Embracing AI creates an innovative work environment, attracting top legal talent eager to work with cutting-edge tools.",
                                "Mitigating Risks: Proactively adopting AI reduces the risk of being outpaced by competitors and helps navigate the legal implications of AI in practice."
                            ]
                        }
                    ]
                }
            },
            "section12": {
                "type": "content",
                "data": {
                    "introduction": "Adopting an AI platform requires careful planning:",
                    "title": "Implementation Strategy",
                    "sections": [
                        {
                            "points": [
                                "Assessment: Analyse your firm's current services, workflows, and areas where AI can add the most value.",
                                "Technology Selection: Choose AI tools and platforms that align with your strategic goals and integrate seamlessly with existing systems.",
                                "Skill Development: Invest in training your lawyers and staff to use AI tools effectively, fostering a culture of continuous learning.",
                                "Process Integration: Redesign workflows to incorporate AI, ensuring that technology enhances rather than disrupts service delivery.",
                                "Client Communication: Educate clients on how AI integration benefits them, addressing any concerns about confidentiality and data security.",
                                "Ethical Considerations: Establish guidelines to ensure AI is used responsibly, maintaining compliance with legal ethics and professional standards.",
                                "Monitoring and Evaluation: Regularly assess the impact of AI on your services, making adjustments as necessary to optimize performance."
                            ]
                        }
                    ]
                }
            },
            "section13": {
                "type": "content",
                "data": {
                    "introduction": "The advent of AI presents both significant threats and unparalleled opportunities for your corporate law firm. By focusing on adjacent business audit and review services, you can not only offset revenue losses from automated legal document creation but also provide greater value to your clients. Embracing novel billing structures further aligns your services with client expectations and market trends.",
                    "title": "Conclusion",
                    "sections": [
                        {
                            "introduction": "Adopting an AI professional services platform is essential to:",
                            "points": [
                                "Stay competitive in an evolving legal landscape.",
                                "Meet and exceed client expectations.",
                                "Enhance the value and efficiency of your services.",
                                "Expand into new, lucrative service areas.",
                                "Attract and retain top talent.",
                                "Ensure long-term profitability and growth."
                            ]
                        },
                        {
                            "introduction": "Investing in AI is investing in your firm's future. It empowers you to deliver superior value, sustain growth, and maintain your competitive advantage. Embrace AI not just as a tool, but as a catalyst for innovation and excellence in your organization."
                        },
                        {
                            "introduction": "By strategically integrating AI and redefining your service offerings and billing models, your firm can navigate the challenges posed by technological advancements. This proactive approach positions you for sustained success in the AI-driven era of legal services."
                        },
                        {
                            "title": "Ready to Transform Your Firm\u2019s Operations & Opportunities with AI?",
                            "introduction": "If you're a legal firm looking to transform your firm\u2019s operations and opportunities through AI, we're here to help. Contact us today to discover how our AI-driven solutions can revolutionize your processes and support your clients\u2019 growth."
                        }
                    ]
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Mask%20group%20%286%29-1729772647713.png",
        category: [
            "Companies",
            "Growth",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Mask%20group%20%283%29-min-1729847868996.png",
        title: "AI Revolution: Transforming Professional Services for Fast-growth UK SMEs",
        slug: "ai-revolution-transforming-professional-services-for-fast-growth-uk-smes",
        excerpt: "Securing investment is a significant milestone for any small or medium-sized enterprise (SME). It marks the beginning of an...",
        author: {
            name: "Mark Bernstein",
            role: "Founder, Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/pic-1729851406062.png"
        },
        date: "Oct 6, 2024, 9:30AM",
        "postData": {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "Securing investment is a significant milestone for any small or medium-sized enterprise (SME). It marks the beginning of an exciting journey toward rapid growth and, eventually, a successful exit. In today's digital age, Artificial Intelligence (AI) stands out as a powerful catalyst that can accelerate this journey. For UK SMEs in the post-investment, pre-exit phase, leveraging AI can unlock unprecedented opportunities for scaling operations, optimizing processes, and enhancing competitiveness."
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "title": "The AI Impact on Professional Services",
                    "sections": [
                        {
                            "subTitle": "Driving Operational Excellence",
                            "introduction": "AI technologies are transforming professional services by automating routine tasks, enhancing data analysis, and enabling smarter decision-making. For growth-focused SMEs, AI can streamline operations, reduce costs, and improve efficiency across various business functions.\xa0 Diligentsia\u2019s platform has 18 Healthboost modules each covering a different area of your business\u2019s activities \u2013 and each bespoked to your own company, its industry, stage of development and business objectives."
                        },
                        {
                            "subTitle": "Enhancing Strategic Decision-Making",
                            "introduction": "With AI-powered analytics, SMEs can gain deeper insights into market trends, customer behaviours, and operational performance. These insights enable more informed strategic decisions, helping businesses adapt quickly to changing market conditions and stay ahead of the competition. Diligentsia provides you the opportunity to benchmark yourselves against competitors."
                        },
                        {
                            "subTitle": "AI-Driven Financial Modelling and Forecasting",
                            "introduction": "Investors want to see robust financial models and realistic forecasts. AI can enhance financial modelling by analysing historical data and current market conditions to generate more accurate projections. Machine learning models can adjust forecasts in real-time as new data becomes available, providing dynamic insights that are invaluable during funding negotiations."
                        }
                    ]
                }
            },
            "section3": {
                "type": "content",
                "data": {
                    "title": "How AI Benefits UK SMEs in Investment Rounds",
                    "sections": [
                        {
                            "subTitle": "Streamlined Transaction Processes",
                            "introduction": "AI reduces the time and resources required to complete a sale. Automated document processing, smart contract generation, and AI-driven negotiation tools expedite transactions, allowing SMEs to close deals faster while reducing legal and administrative costs. Diligentsia\u2019s platform has a suite of modules to increase value, speed up transactions and reduce the risk of transactions failing to complete."
                        }
                    ]
                }
            },
            "section4": {
                "type": "content",
                "data": {
                    "title": "How AI Can Accelerate Growth for UK SMEs",
                    "sections": [
                        {
                            "subTitle": "1. Optimizing Operations and Efficiency"
                        },
                        {
                            "subTitle": "Automation of Routine Tasks",
                            "introduction": "AI-powered automation tools can handle repetitive tasks such as data entry, scheduling, and report generation. This not only reduces the risk of human error but also frees up employees to focus on strategic initiatives that drive growth."
                        },
                        {
                            "subTitle": "Supply Chain and Inventory Management",
                            "introduction": "AI algorithms can predict demand patterns, optimize inventory levels, and streamline supply chain operations. By reducing bottlenecks and improving logistics, SMEs can enhance customer satisfaction and reduce operational costs."
                        },
                        {
                            "subTitle": "Predictive Maintenance",
                            "introduction": "For SMEs in manufacturing or equipment-intensive industries, AI can predict equipment failures before they occur. Predictive maintenance reduces downtime and extends the lifespan of assets, contributing to cost savings and operational efficiency."
                        },
                        {
                            "subTitle": "2. Enhancing Customer Engagement and Marketing"
                        },
                        {
                            "subTitle": "Personalized Marketing Strategies",
                            "introduction": "AI enables hyper-personalization in marketing by analysing customer data to deliver tailored content and offers. This increases engagement rates, boosts conversion, and fosters customer loyalty."
                        },
                        {
                            "subTitle": "Customer Service Automation",
                            "introduction": "AI-powered chatbots and virtual assistants provide instant customer support, improving response times and customer satisfaction. These tools can handle common inquiries, allowing human agents to focus on more complex issues.\xa0 You should try Intelligentsia, Diligentsia\u2019s own chatbot \u2013 she\u2019s great!"
                        },
                        {
                            "subTitle": "Sentiment Analysis",
                            "introduction": "By analysing customer feedback and social media interactions, AI can gauge public sentiment toward your brand. This real-time insight allows SMEs to address concerns promptly and adjust strategies accordingly."
                        },
                        {
                            "subTitle": "3. Data-Driven Decision Making"
                        },
                        {
                            "subTitle": "Advanced Analytics",
                            "introduction": "AI-driven analytics platforms process vast amounts of data to uncover patterns and trends that might be invisible to the human eye. This information is crucial for making strategic decisions about product development, market expansion, and resource allocation."
                        },
                        {
                            "subTitle": "Real-Time Monitoring",
                            "introduction": "AI systems can provide real-time monitoring of key performance indicators (KPIs), enabling SMEs to respond swiftly to changes in the business environment."
                        },
                        {
                            "subTitle": "4. Innovating Product and Service Offerings"
                        },
                        {
                            "subTitle": "AI in Research and Development",
                            "introduction": "AI accelerates R&D by simulating scenarios, optimizing designs, and predicting outcomes. This speeds up the product development cycle and reduces time-to-market."
                        },
                        {
                            "subTitle": "Enhancing Product Features",
                            "introduction": "Integrating AI into products or services can add value and differentiate offerings in the marketplace. Features like AI-driven recommendations or predictive functionalities enhance user experience and satisfaction."
                        },
                        {
                            "subTitle": "5. Scaling Up Operations"
                        },
                        {
                            "subTitle": "Talent Acquisition and Management",
                            "introduction": "AI tools streamline recruitment by automating resume screening and identifying candidates who best fit the company culture and job requirements. AI can also aid in employee engagement and retention through personalized development plans"
                        },
                        {
                            "subTitle": "Financial Management",
                            "introduction": "AI-powered financial tools assist in budgeting, forecasting, and risk management. They provide real-time financial insights, helping SMEs manage cash flow effectively during rapid growth phases."
                        },
                        {
                            "subTitle": "Business Reviews",
                            "introduction": "Diligentsia has a number of tools to assist you in turboboosting your growth:"
                        }
                    ]
                }
            },
            "section5": {
                "type": "image",
                "data": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002248%20%281%29-1729848854893.png"
            },
            "section6": {
                "type": "content",
                "data": {
                    "title": "Overcoming Challenges and Ethical Considerations",
                    "sections": [
                        {
                            "subTitle": "Data Privacy and Security",
                            "introduction": "With increased reliance on data, ensuring its security is paramount. SMEs must comply with data protection regulations like the UK's Data Protection Act and GDPR. Implementing robust cybersecurity measures protects against breaches and builds trust with customers and stakeholders."
                        },
                        {
                            "subTitle": "Ethical AI Use",
                            "introduction": "Transparent and responsible use of AI is essential. SMEs should ensure their AI systems are free from biases and operate within ethical guidelines. This includes being transparent about how AI is used in decision-making processes.\xa0 Where Diligentsia uses Ai to prepare reports, we use digital AI watermarks."
                        },
                        {
                            "subTitle": "Bridging the Skill Gap",
                            "introduction": "Adopting AI technologies may require new skill sets. Investing in employee training or hiring specialists ensures that the team can effectively leverage AI tools. Partnering with external experts or consultants can also provide the necessary expertise without overextending resources."
                        }
                    ]
                }
            },
            "section7": {
                "type": "content",
                "data": {
                    "title": "Practical Steps for SMEs Embracing AI",
                    "sections": [
                        {
                            "subTitle": "1. Conduct a Needs Assessment",
                            "introduction": "Identify areas within your business where AI can have the most significant impact. This could be in operations, customer engagement, product development, or strategic planning."
                        },
                        {
                            "subTitle": "2. Develop an AI Strategy Aligned with Business Goals",
                            "introduction": "Create a roadmap for AI adoption that aligns with your growth objectives. Set clear goals, timelines, and metrics for success."
                        },
                        {
                            "subTitle": "3. Invest in the Right Technologies",
                            "introduction": "Select AI tools and platforms that fit your specific needs and scale. Consider factors such as ease of integration, scalability, user-friendliness, and vendor support."
                        },
                        {
                            "subTitle": "4. Build Strategic Partnerships",
                            "introduction": "Collaborate with professional service providers specializing in AI. They can offer expertise, resources, and support to ensure successful implementation and adoption."
                        },
                        {
                            "subTitle": "5. Focus on Change Management",
                            "introduction": "Prepare your organization for the changes that come with AI adoption. Communicate the benefits, address concerns, and involve employees in the transition to foster a culture that embraces innovation."
                        }
                    ]
                }
            },
            "section8": {
                "type": "content",
                "data": {
                    "title": "Conclusion",
                    "introduction": "AI is a powerful enabler for UK SMEs seeking rapid growth in the post-investment, pre-exit phase. By harnessing AI technologies, businesses can optimize operations, enhance customer engagement, make data-driven decisions, and innovate their offerings. This not only accelerates growth but also increases the company's attractiveness to potential buyers or investors when the time comes for an exit.",
                    "sections": [
                        {
                            subTitle: "Ready to Leverage AI for your organisation\u2019s growth?",
                            "introduction": "If you're a UK SME seeking to turboboost your growth, integrating AI into your strategy could be the key to unlocking maximum value. Contact us today to discover how our AI-driven professional services platform can guide you through a your growth process. Prior to maximising value on exit"
                        }
                    ]
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/6-min-1729842154481.png",
        category: [
            "Accountants",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Mask%20group%20%284%29-1729850340529.png",
        title: "AI Revolution: Transforming Professional Services for UK SMEs Seeking Investment",
        slug: "ai-revolution-transforming-professional-services-for-uk-smes-seeking-investment",
        excerpt: "In the rapidly evolving business landscape, Artificial Intelligence (AI) is no longer a futuristic concept\u2014it's a present...",
        author: {
            name: "Mark Bernstein",
            role: "Founder, Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/pic-1729851406062.png"
        },
        date: "Oct 6, 2024, 9:30AM",
        "postData": {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In the rapidly evolving business landscape, Artificial Intelligence (AI) is no longer a futuristic concept\u2014it's a present reality that's reshaping industries across the globe. For UK-based small and medium-sized enterprises (SMEs) eyeing angel or venture capital (VC) funding, AI is poised to revolutionize the way professional services are delivered, offering unprecedented opportunities for growth and efficiency."
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "title": "The AI Impact on Professional Services",
                    "sections": [
                        {
                            "subTitle": "Automating Due Diligence Processes",
                            "introduction": "Due diligence is a critical phase in any investment process, involving exhaustive checks on financials, legal obligations, and operational practices. AI-powered tools can automate significant portions of this process. Machine learning algorithms can sift through vast amounts of data\u2014financial records, contracts, compliance documents\u2014to identify inconsistencies or red flags more efficiently than manual reviews. Diligentsia\u2019s automated platform helps you to self-create a draft diligence pack in advance of the investment \u2013 saving you substantial professional fees and providing you the opportunity to resolve issues well in advance of the transaction."
                        }
                    ]
                }
            },
            "section3": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Due Diligence Pack",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                    "points": [
                        "Bespoked to each company",
                        "Completeness and risk scoring",
                        "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter",
                        "Can be made available by the company to angels within the network"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
                }
            },
            "section4": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "subTitle": "AI-Driven Financial Modeling and Forecasting",
                            "introduction": "Investors want to see robust financial models and realistic forecasts. AI can enhance financial modeling by analyzing historical data and current market conditions to generate more accurate projections. Machine learning models can adjust forecasts in real-time as new data becomes available, providing dynamic insights that are invaluable during funding negotiations."
                        },
                        {
                            "subTitle": "Enhanced Valuation Models",
                            "introduction": "Accurate business valuation is paramount when preparing for an investment AI enhances traditional valuation models by incorporating real-time data analysis and predictive analytics. By assessing market trends, competitor performance, and internal financial metrics, AI provides a more precise and dynamic valuation, ensuring that SMEs receive a fair and optimized investment valuation."
                        },
                        {
                            "subTitle": "Personalized Investor Matching"
                        }
                    ]
                }
            },
            "section5": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "Expansion Pack \u2013 Investor Leads Module*",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/human-resources-1729682616410.png",
                    "points": [
                        "Open to Diligentsia gold certification only",
                        "Matches your investment requirements against investors\u2019 investment criteria",
                        "List of curated investor leads, with contact details"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/expentionPack-1729675017984.png"
                }
            },
            "section6": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "introduction": "Finding the right investor can significantly impact the success of a fast growth business AI platforms are now capable of matching SMEs with potential investors by analyzing compatibility factors such as industry focus, company culture, and strategic goals. This personalized matchmaking increases the likelihood of a successful sale and a smoother transition post-acquisition. Diligentsia has its own lead-matching module containing our database of over 700 investors."
                        },
                        {
                            "title": "How AI Benefits UK SMEs in Investment Rounds",
                            "subTitle": "Streamlined Transaction Processes",
                            "introduction": "AI reduces the time and resources required to complete a sale. Automated document processing, smart contract generation, and AI-driven negotiation tools expedite transactions, allowing SMEs to close deals faster while reducing legal and administrative costs."
                        }
                    ]
                }
            },
            "section7": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Expansion Pack - Warranty Disclosure*",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%20%287%29-1729761910743.png",
                    "points": [
                        "Save thousands on lawyers\u2019 fees",
                        "Normally an expensive exercise at the end of a transaction",
                        "Based on the UK BVCA standard disclosure letter"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002256-1729763422808.png"
                }
            },
            "section8": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "subTitle": "Improved Negotiation Strategies",
                            "introduction": "AI can analyze previous negotiation outcomes and market data to recommend optimal negotiation strategies. By understanding the buyer's profile and the SME's strengths, AI tools can suggest terms and conditions that are more likely to be accepted, leading to more favorable outcomes."
                        },
                        {
                            "subTitle": "Risk Assessment and Mitigation",
                            "introduction": "Identifying potential risks before entering negotiations is crucial. AI systems can predict potential pitfalls by analyzing historical data and market indicators. This proactive approach allows SMEs to address issues beforehand, making them more attractive to buyers and reducing the likelihood of deal failures.\xa0 Diligentsia\u2019s platform incorporates extensive bespoked risk reporting and recommendations for improvement \u2013 all personalised to your company."
                        }
                    ]
                }
            },
            "section9": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "20-Section Business Audit",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/document%201-1729676889972.png",
                    "points": [
                        "Step by step audit of each company\u2019s\xa0business",
                        "Quickly identify strengths and weaknesses",
                        "Individually bespoked to their business, industry, stage of development and objective"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/20sectionBusinessAudit-1729675364365.png"
                }
            },
            "section10": {
                "type": "content",
                "data": {
                    "title": "Overcoming Challenges and Ethical Considerations",
                    "sections": [
                        {
                            "subTitle": "Data Security and Confidentiality",
                            "introduction": "The investment process involves sensitive information that must be protected. SMEs must ensure that AI tools comply with data protection regulations like the UK's Data Protection Act and GDPR. Implementing robust cybersecurity measures is essential to maintain confidentiality and build trust with potential buyers. Diligentsia is DPA compliant."
                        },
                        {
                            "subTitle": "Integration with Existing Systems",
                            "introduction": "Adopting AI technologies may require integration with current IT systems. SMEs should assess their technological infrastructure to ensure compatibility. Working with professional service providers who specialize in AI can facilitate a seamless integration process.\xa0 Diligentsia\u2019s Data Repository integrates with Dropbox, Sharepoint and Drive."
                        },
                        {
                            "subTitle": "Ethical AI Deployment",
                            "introduction": "Transparent and ethical use of AI is vital. SMEs should ensure that AI algorithms used in valuations and buyer matching are free from biases that could affect outcomes. Ethical AI practices not only comply with regulations but also enhance the company's reputation during the investment process. Diligentsia\u2019s platform contains AIO digital watermarking where appropriate."
                        },
                        {
                            "subTitle": "Practical Steps for SMEs Embracing AI"
                        },
                        {
                            "subTitle": "1. Evaluate Your Needs",
                            "introduction": "Identify specific areas in the investment process where AI can add value. This could be in due diligence, valuation, buyer matching, or negotiation support."
                        },
                        {
                            "subTitle": "2. Choose the Right AI Tools",
                            "introduction": "Select AI solutions that are tailored to your industry and business size. Consider scalability, user-friendliness, and the level of support provided by the vendor."
                        },
                        {
                            "subTitle": "3. Partner with AI-Savvy Professionals",
                            "introduction": "Collaborate with professional service firms that have expertise in AI. They can provide guidance on best practices, ensure compliance with regulations, and help you leverage AI effectively throughout the sale process."
                        },
                        {
                            "subTitle": "4. Train Your Team",
                            "introduction": "Invest in training programs to upskill your staff. Understanding how to work alongside AI tools will maximize their benefits and improve overall efficiency."
                        },
                        {
                            "subTitle": "5. Monitor and Adapt",
                            "introduction": "Continuously monitor the impact of AI on your processes. Be prepared to make adjustments and stay updated with the latest AI developments to maintain a competitive edge."
                        }
                    ]
                }
            },
            "section11": {
                "type": "content",
                "data": {
                    "title": "The Road Ahead: Maximizing Investment Value with AI",
                    "introduction": "For UK SMEs, embracing AI is more than a technological upgrade\u2014it's a strategic move that can significantly enhance the value and success of an investment round. By leveraging AI, SMEs can present a more robust, efficient, and attractive proposition to potential buyers."
                }
            },
            "section12": {
                "type": "content",
                "data": {
                    "title": "Conclusion",
                    "introduction": "AI is revolutionizing the delivery of professional services, offering UK SMEs unprecedented opportunities to optimize their investment processes. By adopting AI technologies, SMEs can enhance efficiency, reduce risks, and ultimately achieve better outcomes in their investment strategies.",
                    "sections": [
                        {
                            "subTitle": "Ready to Leverage AI for a Successful Investment?",
                            "introduction": "If you're a UK SME planning an investment round, integrating AI into your strategy could be the key to unlocking maximum value. Contact us today to discover how our AI-driven professional services platform can guide you through a seamless and profitable investment process."
                        }
                    ]
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/4-min-1729842141081.png",
        category: [
            "Accountants",
            "Fractional CFOs",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Mask%20group%20%285%29-min-1729852720100.png",
        title: "Harnessing AI: Securing the Future of Your Fractional CFO Services Business",
        slug: "harnessing-ai-securing-the-future-of-your-fractional-cfo-services-business",
        excerpt: "In the rapidly evolving landscape of financial services, Artificial Intelligence (AI) is not just a buzzword\u2014it's a transformative...",
        author: {
            name: "Isaac",
            role: "Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/image-1730098103998.png"
        },
        date: "Oct 6, 2024, 9:30AM",
        "postData": {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In the rapidly evolving landscape of financial services, Artificial Intelligence (AI) is not just a buzzword\u2014it's a transformative force reshaping industries worldwide. For organizations like yours, offering fractional CFOs to SME clients at premium rates, understanding and embracing AI is no longer optional; it's imperative. This presentation outlines the main threats and opportunities posed by AI to your business and argues why adopting an AI professional services platform such as Diligentsia is crucial for your continued success."
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "title": "The Looming Threats of AI",
                    "list": [
                        {
                            "points": [
                                "Automation of Financial Tasks: AI systems are increasingly capable of performing tasks traditionally handled by CFOs, such as financial analysis, forecasting, and risk assessment. Advanced algorithms can process vast amounts of data faster and more accurately than humans, potentially reducing the demand for human expertise in these areas.",
                                "Emergence of AI-Driven Competitors: Competitors who integrate AI into their services can offer faster, more cost-effective solutions. They can undercut your pricing by reducing operational costs through automation, posing a significant threat to your market share.",
                                "Disintermediation Risks: AI platforms enable SMEs to access sophisticated financial tools directly, bypassing intermediaries like your organization. This direct access diminishes your role and value proposition as a bridge between CFOs and clients. Diligentsia\u2019s platform is a good example of this, designed by accountants for accountants, but which can be used either by your clients directly, or by the fractional CFO on behalf of their client. Many clients will not want to undertake the tasks themselves \u2013 increasing the opportunities for the fractional CFO.",
                                "Changing Client Expectations: As AI becomes more prevalent, clients will expect their financial service providers to leverage the latest technology. Failure to meet these expectations can lead to client attrition. Implementing Diligentsia\u2019s platform and immediately seeing the benefits of services bespoked to an individual client\u2019s circumstances and objectives will help meet those expectations.",
                                "Skill Obsolescence Among CFOs: Without AI integration, your CFOs risk falling behind in efficiency and effectiveness. This gap can make them less competitive compared to peers who utilize AI tools. Diligentsia\u2019s platform will save your fractional CFOs time on the boring, low value stuff \u2013 allowing them to focus on high value-creation tasks."
                            ]
                        }
                    ]
                }
            },
            "section3": {
                "type": "content",
                "data": {
                    "title": "The Promising Opportunities of AI",
                    "list": [
                        {
                            "points": [
                                "Enhanced Service Offerings: AI can empower your CFOs to provide deeper insights through real-time analytics, predictive modelling, and data visualization. This enhancement elevates the quality and value of services you offer to clients. Diligentsia\u2019s platform automatically generates risks and recommendation reports across the client\u2019s business for you to present \u2013 opening up new revenue generation opportunities.",
                                "Operational Efficiency: Automation of routine tasks frees up your CFOs to focus on strategic decision-making and personalized client interactions. This efficiency can lead to serving more clients without a proportional increase in workload.",
                                "Competitive Differentiation: Early adoption of AI positions your organization as an innovator in the market. This differentiation can attract new clients seeking cutting-edge financial solutions and retain existing clients looking for continual improvement.",
                                "Cost Reduction: AI can streamline your internal processes, reducing overhead costs. These savings can improve your profit margins or be passed on to clients in the form of competitive pricing.",
                                "Scalability: An AI platform allows you to scale your services rapidly. You can extend your reach to more SMEs without the constraints of human resource limitations.",
                                "Data-Driven Insights: Leveraging AI across your client base provides you with aggregated data insights. These insights can inform best practices, benchmarking, and tailored advice for your clients. Diligentsia can provide aggregated analytics and reporting at the centre, but also on a granular level, encouraging cross-selling and standardisation/quality assurance and interoperability between CFOs.",
                                "Upskilling Your Workforce: Integrating AI into your operations offers professional development opportunities for your CFOs. This investment in your talent pool enhances job satisfaction and loyalty."
                            ]
                        }
                    ]
                }
            },
            "section4": {
                "type": "image",
                "data": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/12194%201-1729754109222.png"
            },
            "section5": {
                "type": "content",
                "data": {
                    "title": "The Future of Client Billing",
                    "introduction": "The traditional model of billing clients per hour or day, at rates in excess of \xa31,000 per man-day, may become less sustainable in the AI-driven future. Here's how client billing is likely to evolve:",
                    "list": [
                        {
                            "points": [
                                "Value-Based Pricing: Shift from time-based billing to value-based pricing. Charge clients based on the tangible outcomes and benefits your services deliver, such as cost savings, revenue growth, or efficiency improvements facilitated by AI insights.",
                                "Subscription Models: Adopt a subscription-based approach where clients pay a recurring fee for continuous access to your CFO expertise and AI-powered tools. This model provides predictable revenue streams and fosters long-term client relationships.",
                                "Tiered Service Packages: Offer tiered packages (e.g., Basic, Premium, Enterprise) with varying levels of AI integration and human interaction. Clients can choose the package that best fits their needs and budgets, providing flexibility and clarity in pricing.",
                                "Performance-Based Fees: Implement a model where fees are tied to the achievement of specific financial metrics or KPIs. AI analytics can track performance in real-time, ensuring transparency and accountability.",
                                "Project-Based Pricing: For specific initiatives or projects, provide a fixed-price quote. AI tools can enhance efficiency, allowing you to complete projects more quickly while maintaining profitability.",
                                "Hybrid Models: Combine elements of the above models to create customized billing arrangements. For instance, a base subscription fee supplemented by performance bonuses or additional services charged on a project basis.",
                                "Freemium Offerings: Provide basic AI-powered financial tools for free or at a low cost to attract SMEs. Offer advanced features and personalized CFO services at premium rates, upselling clients as they recognize the value provided."
                            ]
                        }
                    ]
                }
            },
            "section6": {
                "type": "content",
                "data": {
                    "title": "Why You Must Adopt an AI Professional Services Platform",
                    "introduction": "Given the outlined threats and opportunities, adopting an AI professional services platform is not just beneficial\u2014it's essential. Here's why:",
                    "list": [
                        {
                            "points": [
                                "Staying Competitive: In a market where AI is becoming standard, you must keep pace to maintain your competitive edge. An AI platform ensures you offer services that meet or exceed industry standards.",
                                "Meeting Client Needs: Your clients are evolving. SMEs are becoming more tech-savvy and data-driven. By incorporating AI, you align your services with their needs, enhancing client satisfaction and loyalty.",
                                "Maximizing Value Creation: AI enhances your ability to deliver value to clients through improved efficiency and insights. This value creation strengthens your reputation and justifies new, innovative billing models.",
                                "Risk Mitigation: By proactively adopting AI, you mitigate the risk of disruption from competitors and technological obsolescence. It's a strategic move to safeguard your business model.",
                                "Driving Growth: An AI platform opens new revenue streams. You can develop AI-based products and services, offering them as standalone solutions or bundled with your CFO services.",
                                "Improving Decision-Making: AI provides powerful tools for internal decision-making. Predictive analytics can inform your strategy, operations, and resource allocation more effectively.",
                                "Cultivating Innovation Culture: Embracing AI fosters a culture of innovation within your organization. This culture is vital for attracting top talent and encouraging continuous improvement."
                            ]
                        }
                    ]
                }
            },
            "section7": {
                "type": "content",
                "data": {
                    "title": "Implementation Strategy",
                    "introduction": "Adopting an AI platform requires a strategic approach:",
                    "sections": [
                        {
                            "points": [
                                "Assessment: Evaluate your current processes to identify areas where AI can have the most impact.",
                                "Partnering: Collaborate with AI experts or vendors who can tailor solutions to your specific needs. At Diligentsia we would be delighted to have a conversation as to how we might assist you.",
                                "Training: Invest in training programs to equip your CFOs with the necessary skills to leverage AI tools effectively.",
                                "Integration: Ensure seamless integration of AI into your existing systems to avoid disruption. Diligentsia already integrates into SharePoint, Dropbox and Drive.",
                                "Monitoring: Establish metrics to monitor the impact of AI on your performance and make adjustments as needed."
                            ]
                        }
                    ]
                }
            },
            "section8": {
                "type": "content",
                "data": {
                    "title": "Conclusion",
                    "introduction": "The advent of AI presents both significant threats and unparalleled opportunities for your organization. Ignoring AI is not an option if you aim to remain a leader in providing top-tier fractional CFO services to SMEs. By adopting an AI professional services platform at the heart of your organization, you position yourself to overcome the threats and fully capitalize on the opportunities. This strategic move will enhance your service offerings, improve operational efficiency, and ensure you meet the evolving needs of your clients."
                }
            },
            "section9": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "introduction": "Investing in AI is investing in your future. It empowers you to deliver superior value, sustain growth, and maintain your competitive advantage in a rapidly changing industry landscape. Embrace AI not just as a tool, but as a catalyst for innovation and excellence in your organization. By re-imagining your billing models and integrating AI at the core of your services, you can offer more flexible, value-driven pricing that aligns with client expectations and market trends. This approach not only meets the evolving demands of your clients but also positions your organization for sustained growth and success in the AI-driven era of financial services."
                        }
                    ]
                }
            },
            "section10": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "introduction": "Connect with me on LinkedIn or reply to this email to start a conversation about leveraging AI for your practice's growth and success."
                        }
                    ]
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/8-min-1729842183029.png",
        category: [
            "PEs",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/9-min-1729774978357.png",
        title: "AI Revolution: Transforming Small and Mid-Sized PE Firms for Enhanced Portfolio Returns",
        slug: "ai-revolution-transforming-small-and-mid-sized-pe-firms-for-enhanced-portfolio-returns",
        excerpt: "In the ever-evolving world of startup funding, angel investors play a pivotal role in nurturing early-stage small and medium-sized...",
        author: {
            name: "Irij Mahmood",
            role: "Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/irij%20photo-1730098047371.png"
        },
        date: "Oct 1, 2024, 2:05PM",
        postData: {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In the ever-evolving world of startup funding, angel investors play a pivotal role in nurturing early-stage small and medium-sized enterprises (SMEs). However, the traditional methods of selecting and supporting startups are often time-consuming, costly, and fraught with uncertainty. Enter Artificial Intelligence (AI)\u2014a transformative technology poised to revolutionize the angel investment landscape.",
                    "list": [
                        {
                            "listHeading": "This article explores how AI can enhance the angel investment process by:",
                            "points": [
                                "Identifying Promising Startups for Investment",
                                "Facilitating Cost-Effective Pre-Investment Due Diligence",
                                "Facilitating Cost-Effective Pre-Investment Due Diligence",
                                "Enhancing Portfolio Returns for Angel Investors"
                            ]
                        }
                    ]
                }
            },
            "section2": {
                "type": "content",
                "data": {
                    "title": "1. AI-Enabled Effective Pre-Investment Due Diligence of SMEs",
                    "sections": [
                        {
                            "subTitle": "Reducing the Cost and Time of Due Diligence",
                            "introduction": "Traditionally, conducting preliminary due diligence on small and medium-sized enterprises (SMEs) is both time-consuming and expensive. For deals that don't materialize, PE firms bear the abort costs, making extensive due diligence on every applicant impractical."
                        },
                        {
                            "subTitle": "AI-Powered Due Diligence",
                            "introduction": "AI transforms this scenario by automating and expediting the due diligence process:"
                        }
                    ]
                }
            },
            "section3": {
                "type": "card",
                "cardStyle": "secondary",
                "data": {
                    "title": "Investor & Applicant Curated <r>Lead Matching",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000001416%201-1729685942444.png"
                }
            },
            "section4": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Automated Data Collection and Analysis: AI algorithms can swiftly gather and analyze financial records, market data, and operational metrics, providing a comprehensive overview of the applicant company."
                            ]
                        }
                    ]
                }
            },
            "section5": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Due Diligence Pack",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                    "points": [
                        "Bespoked to each company",
                        "Completeness and risk scoring",
                        "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
                }
            },
            "section6": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Automated Due Diligence: Diligence Pack: Diligentsia\u2019s platform enables applicant companies to self-diligence quickly and easily through AI-assisted checklist modules with \u201Cyes/no\u201D answers. Each module is bespoked to the specific company, its industry, stage of development and business objectives. The AI does the rest \u2013 completeness and risk scoring, automated reporting with recommendations for rectification where necessary, along with workflow processes."
                            ]
                        }
                    ]
                }
            },
            "section7": {
                "type": "card",
                "cardStyle": "secondary",
                "bgImage": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002247-1729834244758.png",
                "data": {
                    "title": "More Information = <r>Better Decisions",
                    "subTitle": "Let us help do the boring bits\u2026",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Frame%203474357%201-1729768996070.png",
                    "maxWidth": "700px"
                }
            },
            "section8": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Risk Assessment: Machine learning models identify potential risks by detecting patterns and anomalies in data that might be overlooked by human analysts.",
                                "Enhanced Accuracy: AI reduces human error, ensuring that critical information is not missed during the evaluation process."
                            ]
                        }
                    ]
                }
            },
            "section9": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "Expansion Pack - AnyList Checklist Builder",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/questions-1729675682686.png",
                    "points": [
                        "Create relevant automated due diligence checklists\xa0 bespoked to target company",
                        "You can add your own questions and desired answers",
                        "Monitor checklist completion by target company"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/anylistChecklist-1729675261266.png"
                }
            },
            "section10": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Diligentsia\u2019s AnyList AI checklist builder: enables you to create a bespoked any checklist in minutes:"
                            ]
                        },
                        {
                            "subTitle": "Benefits for PE Firms",
                            "points": [
                                "Cost Efficiency: By automating preliminary due diligence, PE firms can evaluate more opportunities without incurring prohibitive costs.",
                                "Faster Decision-Making: Accelerated due diligence processes enable quicker investment decisions, giving firms a competitive advantage in securing deals.",
                                "Better Investment Choices: Deeper insights lead to more informed decisions, reducing the likelihood of investing in under performing companies."
                            ]
                        }
                    ]
                }
            },
            "section11": {
                "type": "content",
                "data": {
                    "title": "2. Supporting the Initial 100-Day Growth Post-Investment",
                    "subTitle": "The Critical First 100 Days",
                    "introduction": "The initial 100 days post-investment are crucial for setting the tone and trajectory of the portfolio company's growth. Effective support during this period can significantly impact the long-term success of the investment. Diligentsia\u2019s Healthboost program takes the organisation through a structured process covering each area. Each module is bespoked to the company, its industry, stage of development and business objectives. Each comes with completeness and risk scoring, reporting and recommendations for rectification, and a workflow manager to assist in rectification process control.",
                    "sections": [
                        {
                            "subTitle": "AI-Driven Growth Strategies",
                            "introduction": "AI offers tools to turbocharge this growth phase:",
                            "points": [
                                "Operational Efficiency: AI can automate routine tasks, optimize supply chains, and improve resource allocation."
                            ]
                        }
                    ]
                }
            },
            "section12": {
                "type": "image",
                "data": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002248%20%281%29-1729848854893.png"
            },
            "section13": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Business Audits : systematic analysis of each area of a company\u2019s activities.\xa0 Diligentsia\u2019s platform has been designed to assist in this area \u2013 with checklists bespoked to a company\u2019s industry, stage of development and business audit.\xa0 Our modules all have completeness and risks scoring, recommendations for improvement and a workflow manager to assist in rectifying weaknesses identified",
                                "Market Analysis: AI-powered analytics provide real-time insights into market trends, customer behaviors, and competitor strategies.",
                                "Personalized Marketing: Machine learning models enable hyper-targeted marketing campaigns, enhancing customer acquisition and retention."
                            ]
                        },
                        {
                            "subTitle": "Implementation Tactics",
                            "points": [
                                "Process Optimization: AI identifies bottlenecks and suggests improvements in operational workflows.",
                                "Predictive Analytics: Forecasting tools help anticipate market shifts and adjust strategies accordingly.",
                                "Employee Training: AI-driven training programs can upskill staff quickly, aligning them with new technologies and processes."
                            ]
                        },
                        {
                            "subTitle": "Outcomes for Portfolio Companies",
                            "points": [
                                "Accelerated Growth: Streamlined operations and effective strategies lead to rapid scaling.",
                                "Competitive Advantage: Early adoption of AI positions companies ahead of competitors.",
                                "Increased Valuation: Enhanced performance boosts the company's market value."
                            ]
                        }
                    ]
                }
            },
            "section14": {
                "type": "content",
                "data": {
                    "title": "3. Effective Preparation of Portfolio Companies Prior to Exit",
                    "subTitle": "Maximizing Exit Value",
                    "introduction": "Preparing a portfolio company for exit requires meticulous planning to maximize its valuation and appeal to potential buyers.",
                    "sections": [
                        {
                            "subTitle": "AI in Exit Preparation",
                            "introduction": "AI assists in several key areas:",
                            "points": [
                                "Financial Optimization: AI algorithms analyze financial data to identify areas for cost reduction and revenue enhancement.",
                                "Market Positioning: AI tools assess market dynamics to position the company favorably against competitors.",
                                "Compliance and Risk Management: Automated checks ensure all regulatory compliances are met, reducing potential liabilities.",
                                "Diligence Packs: Diligentsia enables you or your company to self-diligence prior to the transaction commencement to identify issues and enable them to be rectified prior to the commencement of the process. The pack includes Data Room Report, Business Audit covering 20 areas eg. IP, legal, draft warranty disclosures and directors\u2019 questionnaires. The final documents will be prepared by professionals, but the exercise will speed up transactions and make them less kikely to fall over at the end. It will also impress the purchasers."
                            ]
                        },
                        {
                            "subTitle": "Strategic Benefits",
                            "points": [
                                "Data-Driven Narratives: AI provides compelling data to build a strong investment thesis for potential buyers.",
                                "Targeted Buyer Identification: AI platforms can identify and prioritize potential buyers whose strategic goals align with the portfolio company.",
                                "Efficient Deal Structuring: AI models can simulate various deal scenarios, optimizing terms and conditions for the best outcomes."
                            ]
                        }
                    ]
                }
            },
            "section15": {
                "type": "content",
                "data": {
                    "title": "4. Enhancing Portfolio Returns Through AI Implementation",
                    "subTitle": "Compounding Benefits",
                    "introduction": "The integration of AI across the investment lifecycle amplifies returns through:",
                    "sections": [
                        {
                            "points": [
                                "Improved Investment Selection: Effective due diligence reduces the risk of investing in under performing companies.",
                                "Operational Excellence: Enhanced performance of portfolio companies leads to higher profitability.",
                                "Optimized Exits: Well-prepared companies fetch better valuations and attract more favorable terms."
                            ]
                        },
                        {
                            "subTitle": "Why AI Enhances Returns",
                            "points": [
                                "Risk Mitigation: AI's predictive capabilities identify potential pitfalls early, allowing for proactive measures.",
                                "Scalability: AI solutions can be scaled across multiple portfolio companies, standardizing best practices.",
                                "Innovation Culture: Embracing AI fosters a culture of innovation, attracting talent and encouraging continuous improvement."
                            ]
                        },
                        {
                            "title": "Embracing the AI Revolution",
                            "subTitle": "For PE Firms",
                            "points": [
                                "Invest in AI Capabilities: Building in-house AI expertise or partnering with AI specialists can provide a significant competitive advantage.",
                                "Educate and Train Staff: Ensure that team members are proficient in AI tools and understand their strategic applications.",
                                "Ethical Considerations: Implement AI responsibly, adhering to data privacy regulations and promoting transparency."
                            ]
                        },
                        {
                            "subTitle": "For Portfolio Companies",
                            "points": [
                                "Alignment with PE Firms: Collaborate closely with investors to integrate AI solutions effectively.",
                                "Cultural Readiness: Foster an organizational culture that embraces technological innovation.",
                                "Continuous Improvement: Leverage AI for ongoing optimization, not just during the initial growth phase."
                            ]
                        }
                    ]
                }
            },
            "section16": {
                "type": "content",
                "data": {
                    title: "Conclusion",
                    "introduction": `AI is set to transform mid-sized UK accountancy practices fundamentally. By automating routine tasks, enhancing data analysis, and enabling personalized services, AI allows accountants to deliver greater value to their clients. Embracing new billing models reflects this enhanced value, moving away from traditional hourly rates to more innovative, client-aligned approaches.`,
                    "sections": [
                        {
                            introduction: "While challenges such as data security, ethical considerations, and the need for staff training exist, they are manageable with proactive strategies. Practices that adapt to these changes will not only survive but thrive in the new landscape, offering superior services that meet the evolving needs of their clients."
                        },
                        {
                            subTitle: "Ready to Embrace the Future of Accounting?",
                            introduction: "If you're a mid-sized UK accountancy practice looking to harness the power of AI, we're here to help. Contact us today to discover how our AI-driven solutions can transform your service delivery and billing models, positioning you at the forefront of the industry."
                        }
                    ]
                }
            }
        }
    },
    {
        image: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/9-min-1729842193093.png",
        category: [
            "VCs",
            "AI"
        ],
        bannerImage: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/10-min-1729775008080.png",
        title: "AI Revolution: AI-Enabled Effective Pre-Investment Due Diligence of SMEs",
        slug: "ai-revolution-ai-enabled-effective-pre-investment-due-diligence-of-smes",
        excerpt: "In the rapidly evolving world of venture capital (VC), staying ahead of the curve is essential. Artificial Intelligence (AI) is...",
        author: {
            name: "Irij Mahmood",
            role: "Diligentisa Limited",
            avatar: "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/irij%20photo-1730098047371.png"
        },
        date: "Oct 6, 2024, 9:30AM",
        "postData": {
            "section1": {
                "type": "content",
                "data": {
                    "introduction": "In the rapidly evolving world of venture capital (VC), staying ahead of the curve is essential. Artificial Intelligence (AI) is no longer just a buzzword\u2014it's a transformative force reshaping industries across the globe. Early-stage VC firms and funds are uniquely positioned to leverage AI to revolutionize their operations, from pre-investment due diligence to supporting portfolio companies and preparing for successful exits. This article explores how AI is set to change the future of early-stage VC firms and enhance portfolio returns.",
                    "title": "1. AI-Enabled Effective Pre-Investment Due Diligence of SMEs",
                    "sections": [
                        {
                            "subTitle": "Overcoming Cost Constraints",
                            "introduction": "Traditionally, conducting extensive due diligence on small and medium-sized enterprises (SMEs) was not cost-effective for early-stage investments. The resources required often outweighed the potential benefits, leading to a reliance on limited information and intuition."
                        },
                        {
                            "subTitle": "AI-Powered Data Analysis",
                            "introduction": "AI changes the game by automating and accelerating the due diligence process:",
                            "points": [
                                "Data Mining and Analysis: AI algorithms can scan vast amounts of data from startup databases, social media, news articles, and industry reports to identify startups that match specific investment criteria."
                            ]
                        }
                    ]
                }
            },
            "section2": {
                "type": "card",
                "cardStyle": "secondary",
                "data": {
                    "title": "Investor & Applicant Curated <r>Lead Matching",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000001416%201-1729685942444.png"
                }
            },
            "section3": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Automated Financial Analysis: AI algorithms can quickly analyze financial statements, identify patterns, and detect anomalies that might indicate risks or opportunities.\xa0Data Mining and Analysis: AI algorithms can scan vast amounts of data from startup databases, social media, news articles, and industry reports to identify startups that match specific investment criteria.",
                                "Market and Competitor Insights: Machine learning models assess market trends, customer sentiment, and competitor activities, providing a comprehensive market analysis in a fraction of the time."
                            ]
                        }
                    ]
                }
            },
            "section4": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    title: "Due Diligence Pack",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002253-1729676971484.png",
                    "points": [
                        "Bespoked to each company",
                        "\u201CFit\u201D Report - against your firm\u2019s stated investment ceriter"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/dueDiligencePack-1729675301787.png"
                }
            },
            "section5": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Automated Due Diligence: Diligence Pack Diligentsia\u2019s platform enables applicant companies to self-diligence quickly and easily through AI-assisted checklist modules with \u201Cyes/no\u201D answers. Each module is bespoked to the specific company, its industry, stage of development and business objectives. The AI does the rest \u2013 completeness and risk scoring, automated reporting with recommendations for rectification where necessary, along with workflow processes."
                            ]
                        }
                    ]
                }
            },
            "section6": {
                "type": "card",
                "cardStyle": "secondary",
                "bgImage": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002247-1729834244758.png",
                "data": {
                    "title": "More Information = <r>Better Decisions",
                    "subTitle": "Let us help do the boring bits...",
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Frame%203474357%201-1729768996070.png",
                    "maxWidth": "700px"
                }
            },
            "section7": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Risk Assessment: AI tools evaluate regulatory compliance, legal risks, and operational vulnerabilities by scanning vast datasets, including news articles, legal documents, and social media."
                            ]
                        },
                        {
                            "subTitle": "Enhanced Decision-Making",
                            "introduction": "By providing deeper insights and uncovering hidden risks or growth potential, AI enables VC firms to make more informed investment decisions. This level of due diligence was previously unattainable for smaller transactions due to time and cost constraints. Diligentsia\u2019s AnyList AI checklist builder enables you to create a bespoked any checklist in minutes:"
                        }
                    ]
                }
            },
            "section8": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "Expansion Pack - AnyList Checklist Builder",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/questions-1729675682686.png",
                    "points": [
                        "Investment or M&A - Create relevant automated due diligence checklists\xa0 bespoked to target company",
                        "You can add your own questions and desired answers",
                        "Monitor checklist completion by target company"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/anylistChecklist-1729675261266.png"
                }
            },
            "section9": {
                "type": "content",
                "data": {
                    "title": "2. Supporting the Growth of Businesses Post-Investment",
                    "sections": [
                        {
                            "subTitle": "Operational Efficiency",
                            "introduction": "\xa0Post-investment, VC firms can leverage AI to support their portfolio companies in several ways:",
                            "points": [
                                "Process Automation: AI automates routine tasks, freeing up resources for strategic initiatives.",
                                "Predictive Maintenance: For companies with physical assets, AI predicts equipment failures before they occur, reducing downtime and maintenance costs."
                            ]
                        }
                    ]
                }
            },
            "section10": {
                "type": "image",
                "data": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002248%20%281%29-1729848854893.png"
            },
            "section11": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "points": [
                                "Business Audits: systematic analysis of each area of a company\u2019s activities.\xa0 Diligentsia\u2019s platform has been designed to assist in this area \u2013 with checklists bespoked to a company\u2019s industry, stage of development and business audit.\xa0 Our modules all have completeness and risks scoring, recommendations for improvement and a workflow manager to assist in rectifying weaknesses identified."
                            ]
                        },
                        {
                            "subTitle": "Strategic Insights",
                            "points": [
                                "Customer Segmentation and Personalization: AI analyzes customer data to identify segments and tailor marketing strategies, enhancing customer engagement and conversion rates.",
                                "Product Development: Machine learning models predict customer needs and preferences, guiding product innovation and feature enhancements"
                            ]
                        },
                        {
                            "subTitle": "Performance Monitoring",
                            "introduction": "AI tools provide real-time monitoring of key performance indicators (KPIs), allowing VC firms to:",
                            "points": [
                                "Track Progress: Monitor the growth trajectory of portfolio companies.",
                                "Identify Issues Early: Detect underperformance or deviations from growth plans promptly.",
                                "Provide Targeted Support: Offer strategic guidance or resources where needed to keep companies on track.",
                                "Tools: Diligentsia has developed a suite of tools to assist in this area."
                            ]
                        }
                    ]
                }
            },
            "section12": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "Your Portfolio Company\u2019s FREE KPI Report",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/questions-1729675682686.png",
                    "points": [
                        "AI generated list of Key Performance Indicators",
                        "Specifically generated for their business",
                        "Portfolio benchmarking"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000000954%20%281%29-1729771737358.png"
                }
            },
            "section13": {
                "type": "content",
                "data": {
                    "title": "3. Effective Preparation of Portfolio Investee Companies Prior to Exit",
                    "sections": [
                        {
                            "subTitle": "Optimizing Operations for Maximum Value",
                            "introduction": "Before exiting an investment, ensuring the portfolio company is operating at peak performance is crucial. AI aids in:",
                            "points": [
                                "Process Optimization: Identifying inefficiencies and streamlining operations to improve margins.",
                                "Financial Forecasting: Providing accurate financial projections to present a compelling case to potential buyers."
                            ]
                        }
                    ]
                }
            },
            "section14": {
                "type": "card",
                "cardStyle": "default",
                "data": {
                    "title": "Expansion Pack - Warranty Disclosure*",
                    "titlePrefixIcon": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%20%287%29-1729761910743.png",
                    "points": [
                        "Normally an expensive exercise at the end of a transaction",
                        "Get ahead \u2013 early completion will identify showstoppers",
                        "Based on the UK BVCA standard disclosure letter"
                    ],
                    "image": "https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group%201000002256-1729763422808.png"
                }
            },
            "section15": {
                "type": "content",
                "data": {
                    "sections": [
                        {
                            "introduction": "Diligence Packs: Diligentsia enables you or your company to self-diligence prior to the process to identify issues and enable them to be rectified prior to the commencement of the process. The pack includes Data Room Report, Business Audit covering 20 areas eg. IP, legal, draft warranty disclosures and directors\u2019 questionnaires."
                        },
                        {
                            "subTitle": "Identifying Potential Buyers",
                            "introduction": "AI platforms can:",
                            "points": [
                                "Matchmaking: Use algorithms to identify and rank potential acquirers based on strategic fit, financial capacity, and acquisition history.",
                                "Market Analysis: Assess market conditions to time the exit optimally."
                            ]
                        },
                        {
                            "subTitle": "Enhancing Valuation",
                            "introduction": "By leveraging AI to improve operational performance and market positioning, portfolio companies become more attractive to buyers, potentially commanding higher valuations."
                        }
                    ]
                }
            },
            "section16": {
                "type": "content",
                "data": {
                    "title": "4. Enhancing Portfolio Returns Through AI",
                    "sections": [
                        {
                            "subTitle": "Reducing Investment Risks",
                            "introduction": "Effective due diligence reduces the likelihood of investing in underperforming companies. AI's ability to uncover risks that might be missed in traditional analyses protects the firm's investments. Diligentsia\u2019s platform provides a number of low cost tools to enable this to be undertaken time and cost-effectively."
                        },
                        {
                            "subTitle": "Accelerating Growth",
                            "introduction": "Supporting portfolio companies with AI-driven strategies accelerates their growth, leading to:",
                            "points": [
                                "Higher Revenues: Through improved customer acquisition and retention.",
                                "Better Margins: Via operational efficiencies and cost reductions.",
                                "Competitive Advantage: Staying ahead in the market with innovative products and services."
                            ]
                        },
                        {
                            "subTitle": "Maximizing Exit Outcomes",
                            "introduction": "Effective preparation for exit ensures that the full value of the investment is realized. AI contributes by:",
                            "points": [
                                "Timing the Market: Identifying the optimal moment to sell",
                                "Attractive Valuations: Presenting a strong, data-backed case to potential buyers."
                            ]
                        },
                        {
                            "subTitle": "Compounding Returns",
                            "introduction": "The cumulative effect of better investment choices, accelerated growth, and maximized exit values leads to enhanced overall portfolio returns. VC firms leveraging AI can outperform competitors who rely on traditional methods."
                        }
                    ]
                }
            },
            "section17": {
                "type": "content",
                "data": {
                    "title": "Embracing the AI Transformation",
                    "sections": [
                        {
                            "subTitle": "Staying Competitive",
                            "introduction": "As AI becomes integral to VC operations, firms that adopt these technologies position themselves at the forefront of the industry. Early adopters gain a competitive edge in sourcing deals, supporting portfolio companies, and achieving superior returns."
                        },
                        {
                            "subTitle": "Building Expertise",
                            "introduction": "Developing in-house AI capabilities or partnering with AI specialists allows VC firms to:",
                            "points": [
                                "Customize Solutions: Tailor AI tools to their specific investment strategies and portfolio needs.",
                                "Continuously Innovate: Stay ahead of technological advancements and industry trends."
                            ]
                        },
                        {
                            "subTitle": "Ethical Considerations",
                            "introduction": "Responsible use of AI is essential:",
                            "points": [
                                "Data Privacy: Ensuring compliance with data protection regulations like GDPR.",
                                "Bias Mitigation: Monitoring algorithms to prevent biased decision-making.",
                                "Transparency: Being open with portfolio companies about how AI influences decisions and support."
                            ]
                        }
                    ]
                }
            },
            "section18": {
                "type": "content",
                "data": {
                    "title": "Conclusion",
                    "introduction": "Artificial Intelligence is set to revolutionize the future operations of early-stage VC firms and funds. By enabling effective pre-investment due diligence, supporting post-investment growth, and preparing portfolio companies for successful exits, AI enhances portfolio returns significantly. The integration of AI into VC processes not only reduces risks but also unlocks new opportunities for value creation.",
                    "sections": [
                        {
                            "introduction": "Early-stage VC firms that embrace AI technologies position themselves for greater success in an increasingly competitive landscape. The ability to make data-driven decisions, provide superior support to portfolio companies, and optimize exit strategies will differentiate leading firms from the rest."
                        },
                        {
                            "subTitle": "Ready to Transform Your VC Operations with AI?",
                            "introduction": "If you're an early-stage VC firm looking to enhance your portfolio returns through AI, we're here to help. Contact us today to discover how our AI-driven solutions can revolutionize your investment processes and support your portfolio companies' growth."
                        }
                    ]
                }
            }
        }
    }
];



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $453ce6990b6f7038$var$SearchIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#9aa3b4",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "11",
                cy: "11",
                r: "8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "21",
                y1: "21",
                x2: "16.65",
                y2: "16.65"
            })
        ]
    });
const $453ce6990b6f7038$var$ResourcesHeroSection = ({ query: query, onQueryChange: onQueryChange })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-hero lp-res-hero",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-hero-glow lp-glow-anim",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-res-hero-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-badge",
                        "data-lp-reveal": true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                            "Knowledge hub"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                        className: "lp-h1",
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        children: [
                            "Everything you need",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    color: '#FC7785'
                                },
                                children: "to know."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "lp-lead",
                        style: {
                            margin: '0 auto 32px'
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": "120",
                        children: "Guides, articles, and short films for companies, advisors, and investors."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-res-search",
                        "data-lp-reveal": true,
                        "data-lp-delay": "180",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($453ce6990b6f7038$var$SearchIcon, {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                type: "text",
                                placeholder: "Search resources\u2026",
                                value: query,
                                onChange: (e)=>onQueryChange(e.target.value)
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $453ce6990b6f7038$export$2e2bcd8739ae039 = $453ce6990b6f7038$var$ResourcesHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Maps the new design's category pills to the raw `category` tags already used in blogData.js.


const $d32af10bb5eccc25$export$eeaae31398f3db9d = [
    'All',
    'Companies',
    'VC & Investors',
    'Angel Networks',
    'Fractional CFOs',
    'Accelerators',
    'AI'
];
const $d32af10bb5eccc25$export$f0e3c6b14487780d = [
    'All',
    'AEO Articles',
    'Blog Posts'
];
const $d32af10bb5eccc25$var$PILL_MATCH = {
    'Companies': [
        'Companies'
    ],
    'VC & Investors': [
        'VCs',
        'PEs',
        'VC & Investors'
    ],
    'Angel Networks': [
        'Angels',
        'Angel Investors',
        'Angel Networks'
    ],
    'Fractional CFOs': [
        'Fractional CFOs'
    ],
    'Accelerators': [
        'Accelerators'
    ],
    'AI': [
        'AI'
    ]
};
const $d32af10bb5eccc25$export$59dae37af5dce357 = (post, pill)=>{
    if (pill === 'All') return true;
    const rawTags = $d32af10bb5eccc25$var$PILL_MATCH[pill] || [];
    return (post.category || []).some((c)=>rawTags.includes(c));
};
const $d32af10bb5eccc25$var$CATEGORY_LABELS = {
    VCs: 'VC Firms',
    PEs: 'PE Firms',
    Angels: 'Angel Networks',
    'Angel Investors': 'Angel Investors',
    Companies: 'Companies',
    'Fractional CFOs': 'Fractional CFOs',
    Accountants: 'Accountants',
    Lawyers: 'Lawyers',
    AI: 'AI',
    Growth: 'Growth',
    Exit: 'Exit'
};
const $d32af10bb5eccc25$export$312b808f6ccb3cb4 = (rawTag)=>$d32af10bb5eccc25$var$CATEGORY_LABELS[rawTag] || rawTag;
// Articles awaiting a cover fall back to a per-hub gradient — ArticleCard uses `gradient` whenever
// `image` is falsy, so a card without artwork still reads as a card rather than an empty box.
const $d32af10bb5eccc25$var$AEO_HUB_GRADIENT = {
    'vc': 'linear-gradient(135deg,#1e2744 0%,#1f2a44 100%)',
    'ceo': 'linear-gradient(135deg,#1a2340 0%,#1e1f3a 100%)',
    'cfo': 'linear-gradient(135deg,#1e2744 0%,#2a1f3a 100%)',
    'angel-network': 'linear-gradient(135deg,#1a2038 0%,#222040 100%)',
    'accelerator': 'linear-gradient(135deg,#1f2a44 0%,#2a1f3a 100%)',
    'pisces': 'linear-gradient(135deg,#002d63 0%,#4A67FF 100%)'
};
const $d32af10bb5eccc25$export$cad234b82aa3a8fa = (0, $7393559700759e6c$export$48a6bbfb0f95d83a).map((a)=>({
        slug: a['slug'],
        title: a['title'],
        excerpt: a['metaDescription'].replace(/\s*Last updated:.*$/, ''),
        category: [
            a['category']
        ],
        date: `Last updated ${a['lastUpdated']}`,
        author: {
            name: 'Diligentsia'
        },
        isAeo: true,
        href: `/${a['icpSlug']}/${a['slug']}`,
        image: (0, $d8512033fd45e289$export$6bf64eb9217fe938)(a['slug'], a['image']),
        gradient: $d32af10bb5eccc25$var$AEO_HUB_GRADIENT[a['icpSlug']] || 'linear-gradient(135deg,#1e2744 0%,#1f2a44 100%)'
    }));
const $d32af10bb5eccc25$export$4db8dbc41f3d9a7a = [
    {
        id: '1182144295',
        tag: 'Growth',
        tagBg: '#FC7785',
        tagColor: '#fff',
        title: 'Why Use Diligentsia to Turboboost Your Growth',
        gradient: 'linear-gradient(135deg,#1e2744 0%,#2a1f3a 100%)',
        playBg: 'rgba(252,119,133,.95)'
    },
    {
        id: '1182141959',
        tag: 'Fundraising',
        tagBg: '#4A67FF',
        tagColor: '#fff',
        title: 'Why Use Diligentsia For Your Raise',
        gradient: 'linear-gradient(135deg,#1e2744 0%,#1f2a44 100%)',
        playBg: 'rgba(74,103,255,.95)'
    },
    {
        id: '1182142295',
        tag: 'Advisors',
        tagBg: '#EEF1FF',
        tagColor: '#4A67FF',
        title: 'Diligentsia For Fractional CFOs',
        gradient: 'linear-gradient(135deg,#1a2340 0%,#1e1f3a 100%)',
        playBg: 'rgba(74,103,255,.95)'
    },
    {
        id: '1176583795',
        tag: 'Fundraising',
        tagBg: '#4A67FF',
        tagColor: '#fff',
        title: 'Why Use Diligentsia For Your Raise? (Full)',
        gradient: 'linear-gradient(135deg,#1e2744 0%,#1f2a44 100%)',
        playBg: 'rgba(74,103,255,.95)'
    },
    {
        id: '1165405797',
        tag: 'Overview',
        tagBg: '#EEF1FF',
        tagColor: '#0E1116',
        title: "Diligentsia \u2014 Platform Overview",
        gradient: 'linear-gradient(135deg,#1a2038 0%,#222040 100%)',
        playBg: 'rgba(252,119,133,.95)'
    }
];
const $d32af10bb5eccc25$export$4312051b2736c6d1 = [
    {
        title: 'VC Due Diligence',
        items: [
            {
                q: 'What do VCs look for in a Series A company?',
                a: "Series A investors look for evidence of product-market fit, a credible path to scale, and operational maturity. They evaluate commercial traction (typically \xa3500k\u2013\xa32M ARR for SaaS), team structure, clean corporate governance, rigorous financial records, and the ability to withstand professional legal and financial due diligence."
            },
            {
                q: 'What are the most common reasons VC deals collapse?',
                a: 'Corporate governance gaps surfacing in due diligence: IP not formally assigned; cap table inconsistencies; undocumented founder arrangements; financial record gaps; and key commercial relationships without signed contracts.'
            },
            {
                q: 'How long does Series A due diligence take and what does it cost?',
                a: "10\u201330 weeks and \xa365,000\u2013\xa3113,000 in external professional fees. CEOs and CFOs typically spend 30\u201350% of working hours responding to requests. Companies with a structured Diligence Pack can compress this by 4\u201315 weeks."
            }
        ]
    },
    {
        title: 'Investment Readiness',
        items: [
            {
                q: 'What do investors actually check in due diligence?',
                a: "Two things: the investment case (market, product, team \u2014 addressed by the pitch) and the corporate picture (IP ownership, cap table, governance, financials, employment documentation \u2014 addressed by due diligence). Issues in the corporate picture are the most common cause of deals collapsing."
            },
            {
                q: 'What is a Diligence Pack and why do I need one?',
                a: "A structured, evidence-linked document set covering all corporate categories an investor will examine. Prepared before investor conversations \u2014 not after term sheet. Diligentsia builds certified Diligence Packs with AI assistance at \xa31,000/year."
            },
            {
                q: 'What does investment readiness preparation cost?',
                a: "Traditional due diligence costs \xa310,000\u2013\xa350,000 per transaction. Virtual Data Rooms cost \xa3300\u2013\xa3800/month. Diligentsia Pro is \xa31,000/year \u2014 a permanent, reusable asset. A well-organised company can complete an initial certified pack in as little as 3 working days."
            }
        ]
    },
    {
        title: 'Exit Preparation',
        items: [
            {
                q: 'What are the most common causes of exit valuation being chipped?',
                a: "(1) IP not formally assigned; (2) key customer concentration above 50% of revenue \u2014 triggers a 20\u201340% risk discount; (3) missing governance documentation; (4) founder dependency visible in the data room \u2014 typically results in earnout requirements or a multiple reduction."
            },
            {
                q: 'What is a Vendor Diligence Pack?',
                a: "A structured, certified document set produced by the seller before the buyer's due diligence process begins. Buyers who receive one spend less time on information requests and more time on valuation. Diligentsia produces certified Vendor Diligence Packs at \xa31,000/year."
            },
            {
                q: 'Why prepare for exit before a buyer appears?',
                a: "Every issue a buyer finds becomes negotiating leverage. Fixing issues under buyer pressure is more expensive and less effective than fixing them proactively. At \xa31,000/year, the preparation cost is a fraction of the value protection it delivers."
            }
        ]
    },
    {
        title: 'Fractional CFOs',
        items: [
            {
                q: 'Is Diligentsia free for fractional CFOs?',
                a: "Yes. Advisor accounts are completely free \u2014 no platform fees, no licence costs, no revenue share. Clients pay \xa31,000/year for Pro. CFOs who introduce clients receive a 20% discount for those clients."
            },
            {
                q: 'How does the "walk in at 60%" benefit work?',
                a: "When you connect a new client, Clarence AI analyses their existing documents and auto-populates ~60% of their diligence modules. Every answer requires client review and sign-off. The first weeks of a new engagement become advisory \u2014 not document archaeology."
            },
            {
                q: 'How does Diligentsia help fractional CFOs surface more billable work?',
                a: "The platform continuously flags gaps and improvement opportunities across your client's knowledge base and generates structured quarterly review agendas automatically \u2014 surfacing advisory opportunities that would otherwise be missed."
            }
        ]
    },
    {
        title: 'Angel Networks & Accelerators',
        items: [
            {
                q: 'What do angel investors prioritise most?',
                a: "Team above all else at early stage \u2014 domain experience, prior execution, and absence of background red flags. Market size (minimum \xa3100M\u2013\xa3500M TAM) and financial coherence are second and third priorities."
            },
            {
                q: 'How long does seed round due diligence take?',
                a: "6\u20138 weeks for an average company. Well-prepared companies with an organised Diligence Pack can complete it in 2\u20134 weeks. Companies assembling information reactively often take 10\u201316 weeks."
            },
            {
                q: 'What is Bronze, Silver, or Gold Diligentsia certification?',
                a: "Certification levels indicate Diligence Pack completeness. Bronze: basic governance. Silver: full pack including financials, appropriate for most seed rounds. Gold: includes warranty disclosure drafts and full IP analysis \u2014 appropriate for larger rounds or Series A."
            }
        ]
    }
];


const $b831a2c819614167$var$ResourcesFilterBar = ({ active: active, onChange: onChange, typeActive: typeActive, onTypeChange: onTypeChange })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-res-filterbar",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-res-filterbar-inner",
            style: {
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 10
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 10
                    },
                    children: (0, $d32af10bb5eccc25$export$eeaae31398f3db9d).map((pill)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `lp-res-pill ${active === pill ? 'is-active' : ''}`,
                            onClick: ()=>onChange(pill),
                            children: pill
                        }, pill))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 10
                    },
                    children: (0, $d32af10bb5eccc25$export$f0e3c6b14487780d).map((pill)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `lp-res-pill ${typeActive === pill ? 'is-active' : ''}`,
                            onClick: ()=>onTypeChange(pill),
                            children: pill
                        }, pill))
                })
            ]
        })
    });
var $b831a2c819614167$export$2e2bcd8739ae039 = $b831a2c819614167$var$ResourcesFilterBar;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $c4943d7d564b0dc8$var$AuthorIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#5B6472",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    });
const $c4943d7d564b0dc8$var$authorName = (post)=>(post.author?.name || '').replace(/,\s*$/, '');
// AEO hub-and-spoke articles live at their own /[icp]/[slug] URL — the grid links out to them.
const $c4943d7d564b0dc8$var$detailHref = (post)=>post.isAeo ? post.href : $16250bd714b02a14$export$2aac1f04473d9900.replace(':slug', post.slug);
const $c4943d7d564b0dc8$var$cardImgStyle = (post)=>post.image ? {
        backgroundImage: `url(${post.image})`
    } : {
        background: post.gradient
    };
const $c4943d7d564b0dc8$var$FeaturedCard = ({ post: post })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-res-featured",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ribbon",
                children: "Featured"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: $c4943d7d564b0dc8$var$detailHref(post),
                className: "img cp",
                style: {
                    backgroundImage: `url(${post.image})`,
                    display: 'block'
                },
                "aria-label": post.title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "cats",
                        children: (post.category || []).slice(0, 2).map((0, $d32af10bb5eccc25$export$312b808f6ccb3cb4)).join(" \xb7 ")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: $c4943d7d564b0dc8$var$detailHref(post),
                        style: {
                            textDecoration: 'none',
                            color: 'inherit'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "cp",
                            children: post.title
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: post.excerpt
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "author",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "avatar",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c4943d7d564b0dc8$var$AuthorIcon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    $c4943d7d564b0dc8$var$authorName(post),
                                    " \xb7 ",
                                    post.date
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: $c4943d7d564b0dc8$var$detailHref(post),
                        children: "Read article \u2192"
                    })
                ]
            })
        ]
    });
const $c4943d7d564b0dc8$var$ArticleCard = ({ post: post })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-res-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: $c4943d7d564b0dc8$var$detailHref(post),
                className: "img cp",
                style: {
                    ...$c4943d7d564b0dc8$var$cardImgStyle(post),
                    display: 'block'
                },
                "aria-label": post.title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "cats",
                        children: (post.category || []).slice(0, 2).map((0, $d32af10bb5eccc25$export$312b808f6ccb3cb4)).join(" \xb7 ")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: $c4943d7d564b0dc8$var$detailHref(post),
                        style: {
                            textDecoration: 'none',
                            color: 'inherit'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "cp",
                            children: post.title
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: post.excerpt
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "author",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "avatar",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c4943d7d564b0dc8$var$AuthorIcon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    $c4943d7d564b0dc8$var$authorName(post),
                                    " \xb7 ",
                                    post.date
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: $c4943d7d564b0dc8$var$detailHref(post),
                        children: "Read article \u2192"
                    })
                ]
            })
        ]
    });
const $c4943d7d564b0dc8$var$ResourcesArticleGrid = ({ featured: featured, posts: posts, totalCount: totalCount, visiblePosts: visiblePosts, hasMore: hasMore, onShowMore: onShowMore })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            featured && /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "lp-res-featured-sec",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-container",
                    style: {
                        maxWidth: 1200
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($c4943d7d564b0dc8$var$FeaturedCard, {
                        post: featured
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "lp-res-grid-sec",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-container",
                    style: {
                        maxWidth: 1200
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-res-grid-head",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: "All resources"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "count",
                                    children: [
                                        totalCount,
                                        " article",
                                        totalCount === 1 ? '' : 's'
                                    ]
                                })
                            ]
                        }),
                        totalCount === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-res-empty",
                            children: "No results."
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-res-grid",
                                    children: visiblePosts.map((post)=>/*#__PURE__*/ (0, $ayMG0.jsx)($c4943d7d564b0dc8$var$ArticleCard, {
                                            post: post
                                        }, post.slug))
                                }),
                                hasMore && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-res-showmore",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        onClick: onShowMore,
                                        children: "Show more articles"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
var $c4943d7d564b0dc8$export$2e2bcd8739ae039 = $c4943d7d564b0dc8$var$ResourcesArticleGrid;



const $772c58e033d05b1f$var$PAGE_SIZE = 9;
const $772c58e033d05b1f$var$matchesQuery = (post, query)=>{
    if (!query.trim()) return true;
    const q = query.trim().toLowerCase();
    return post.title.toLowerCase().includes(q) || (post.excerpt || '').toLowerCase().includes(q);
};
const $772c58e033d05b1f$var$ResourcesMainSection = ()=>{
    const [query, setQuery] = (0, $acw62.useState)('');
    const [category, setCategory] = (0, $acw62.useState)('All');
    const [contentType, setContentType] = (0, $acw62.useState)('All');
    const [visibleCount, setVisibleCount] = (0, $acw62.useState)($772c58e033d05b1f$var$PAGE_SIZE);
    const matches = (post)=>(0, $d32af10bb5eccc25$export$59dae37af5dce357)(post, category) && $772c58e033d05b1f$var$matchesQuery(post, query);
    const matchesType = (post)=>contentType === 'All' || (contentType === 'AEO Articles' ? post.isAeo : !post.isAeo);
    const featuredVisible = matchesType((0, $6238ac0b849c9c3e$export$38165aa3a38f65a7)) && matches((0, $6238ac0b849c9c3e$export$38165aa3a38f65a7)) ? (0, $6238ac0b849c9c3e$export$38165aa3a38f65a7) : null;
    // AEO articles listed first — their canonical home is /[icp]/[slug], this grid links out to them.
    const otherPosts = (0, $acw62.useMemo)(()=>[
            ...(0, $d32af10bb5eccc25$export$cad234b82aa3a8fa),
            ...(0, $6238ac0b849c9c3e$export$d09847bb5c97319b)
        ].filter((p)=>p.slug !== (0, $6238ac0b849c9c3e$export$38165aa3a38f65a7).slug && matchesType(p) && matches(p)), [
        category,
        query,
        contentType
    ]);
    const totalCount = (featuredVisible ? 1 : 0) + otherPosts.length;
    const visiblePosts = otherPosts.slice(0, visibleCount);
    const hasMore = visibleCount < otherPosts.length;
    // Reason: the two filter rows can select disjoint sets — e.g. no AEO article carries the `AI`
    // category tag, so "AI" + "AEO Articles" renders an empty grid. Each row resets the other so the
    // user always lands on results, and only ever has one filter dimension active at a time.
    const handleCategoryChange = (c)=>{
        setCategory(c);
        setContentType('All');
        setVisibleCount($772c58e033d05b1f$var$PAGE_SIZE);
    };
    const handleTypeChange = (t)=>{
        setContentType(t);
        setCategory('All');
        setVisibleCount($772c58e033d05b1f$var$PAGE_SIZE);
    };
    const handleQueryChange = (q)=>{
        setQuery(q);
        setVisibleCount($772c58e033d05b1f$var$PAGE_SIZE);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $453ce6990b6f7038$export$2e2bcd8739ae039), {
                query: query,
                onQueryChange: handleQueryChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b831a2c819614167$export$2e2bcd8739ae039), {
                active: category,
                onChange: handleCategoryChange,
                typeActive: contentType,
                onTypeChange: handleTypeChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4943d7d564b0dc8$export$2e2bcd8739ae039), {
                featured: featuredVisible,
                totalCount: totalCount,
                visiblePosts: visiblePosts,
                hasMore: hasMore,
                onShowMore: ()=>setVisibleCount((v)=>v + $772c58e033d05b1f$var$PAGE_SIZE)
            })
        ]
    });
};
var $772c58e033d05b1f$export$2e2bcd8739ae039 = $772c58e033d05b1f$var$ResourcesMainSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $bc21a28eb66f2ee0$var$VIMEO_ID = '1165405797';
const $bc21a28eb66f2ee0$var$VIMEO_SRC = `https://player.vimeo.com/video/${$bc21a28eb66f2ee0$var$VIMEO_ID}?title=0&byline=0&portrait=0&badge=0&autopause=0`;
const $bc21a28eb66f2ee0$var$ResourcesFeatureVideoSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-res-feature",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-res-feature-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-badge",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                "Watch"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-h2",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Diligentsia short video."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-sub",
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "The whole platform in one short film \u2014 from first upload to an investor-ready diligence pack."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-res-feature-player",
                    "data-lp-reveal": true,
                    "data-lp-delay": "180",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                        title: "Diligentsia Ad",
                        src: $bc21a28eb66f2ee0$var$VIMEO_SRC,
                        frameBorder: "0",
                        allow: "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share",
                        referrerPolicy: "strict-origin-when-cross-origin",
                        allowFullScreen: true
                    })
                })
            ]
        })
    });
var $bc21a28eb66f2ee0$export$2e2bcd8739ae039 = $bc21a28eb66f2ee0$var$ResourcesFeatureVideoSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


const $23b4b3e4cb158b66$var$ChevronL = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $23b4b3e4cb158b66$var$ChevronR = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#fff",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
const $23b4b3e4cb158b66$var$PlayIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "white",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
            points: "5 3 19 12 5 21 5 3"
        })
    });
const $23b4b3e4cb158b66$var$CloseIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "white",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
const $23b4b3e4cb158b66$var$ResourcesVideoSection = ()=>{
    const { viewportRef: viewportRef, trackRef: trackRef, next: next, prev: prev, pause: pause, resume: resume } = (0, $560d16798825a58a$export$2df8346413809f96)((0, $d32af10bb5eccc25$export$4db8dbc41f3d9a7a).length, {
        autoplayMs: 0
    });
    const [openId, setOpenId] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!openId) return;
        const onKey = (e)=>{
            if (e.key === 'Escape') setOpenId(null);
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    }, [
        openId
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-res-videos",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-res-videos-head",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "eyebrow",
                        children: "Short films"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Diligentsia in under 3 minutes."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-res-videos-arrows",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        "aria-label": "Previous",
                        onClick: prev,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($23b4b3e4cb158b66$var$ChevronL, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        "aria-label": "Next",
                        onClick: next,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($23b4b3e4cb158b66$var$ChevronR, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-viewport",
                onMouseEnter: pause,
                onMouseLeave: resume,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-vp-inner",
                    ref: viewportRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-track",
                        ref: trackRef,
                        children: (0, $d32af10bb5eccc25$export$4db8dbc41f3d9a7a).map((v)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-res-vidcard",
                                onClick: ()=>setOpenId(v.id),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "thumb",
                                        style: {
                                            background: v.gradient
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "play",
                                            style: {
                                                background: v.playBg
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($23b4b3e4cb158b66$var$PlayIcon, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "meta",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "tag",
                                                style: {
                                                    background: v.tagBg,
                                                    color: v.tagColor
                                                },
                                                children: v.tag
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "title",
                                                children: v.title
                                            })
                                        ]
                                    })
                                ]
                            }, v.id))
                    })
                })
            }),
            openId && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-res-vidmodal",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "scrim",
                        onClick: ()=>setOpenId(null)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "panel",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "close",
                                "aria-label": "Close",
                                onClick: ()=>setOpenId(null),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($23b4b3e4cb158b66$var$CloseIcon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "frame",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                    title: "Diligentsia video",
                                    src: `https://player.vimeo.com/video/${openId}?autoplay=1&title=0&byline=0&portrait=0`,
                                    frameBorder: "0",
                                    allow: "autoplay; fullscreen; picture-in-picture",
                                    allowFullScreen: true
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $23b4b3e4cb158b66$export$2e2bcd8739ae039 = $23b4b3e4cb158b66$var$ResourcesVideoSection;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

const $e25e7f69fdf7bc91$var$Chevron = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "6 9 12 15 18 9"
        })
    });
const $e25e7f69fdf7bc91$var$FaqGroup = ({ group: group, groupIndex: groupIndex })=>{
    const [open, setOpen] = (0, $acw62.useState)(groupIndex === 0);
    const [openQ, setOpenQ] = (0, $acw62.useState)(0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-faq-group",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: "lp-faq-group-btn",
                onClick: ()=>setOpen((o)=>!o),
                children: [
                    group.title,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        className: open ? 'is-open' : '',
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e25e7f69fdf7bc91$var$Chevron, {})
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-faq-group-body",
                children: group.items.map((item, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-faq-item",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                className: "lp-faq-q",
                                onClick: ()=>setOpenQ((q)=>q === i ? -1 : i),
                                children: [
                                    item.q,
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        className: openQ === i ? 'is-open' : '',
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e25e7f69fdf7bc91$var$Chevron, {})
                                    })
                                ]
                            }),
                            openQ === i && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "lp-faq-a",
                                children: item.a
                            })
                        ]
                    }, i))
            })
        ]
    });
};
const $e25e7f69fdf7bc91$var$ResourcesFaqSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-faq-sec",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-faq-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-faq-head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-pe-eyebrow",
                            "data-lp-reveal": true,
                            children: "FAQs"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "lp-h2",
                            style: {
                                margin: '0 auto 10px',
                                maxWidth: 'none'
                            },
                            "data-lp-reveal": true,
                            children: "Common questions \u2014 answered."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-sub",
                            style: {
                                margin: '0 auto'
                            },
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: "Last updated June 2026."
                        })
                    ]
                }),
                (0, $d32af10bb5eccc25$export$4312051b2736c6d1).map((group, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($e25e7f69fdf7bc91$var$FaqGroup, {
                        group: group,
                        groupIndex: i
                    }, group.title))
            ]
        })
    });
var $e25e7f69fdf7bc91$export$2e2bcd8739ae039 = $e25e7f69fdf7bc91$var$ResourcesFaqSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $b2d7e8f6ac77b7f1$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $b2d7e8f6ac77b7f1$var$DILIGENTSIA = 'https://diligentsia.co.uk';
const $b2d7e8f6ac77b7f1$var$ResourcesCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-res-cta",
        style: {
            margin: '0px'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                className: "lp-res-cta-glow lp-res-cta-glow--l"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                "aria-hidden": "true",
                className: "lp-res-cta-glow lp-res-cta-glow--r"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-res-cta-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        "data-lp-reveal": true,
                        children: "Ready to build your Diligence Pack?"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        "data-lp-reveal": true,
                        "data-lp-delay": "60",
                        children: "Start free. No credit card required."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-cta-row",
                        style: {
                            justifyContent: 'center'
                        },
                        "data-lp-reveal": true,
                        "data-lp-delay": "120",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "lp-btn lp-btn--pe-pink",
                                href: $b2d7e8f6ac77b7f1$var$DILIGENTSIA,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Get started free"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "lp-btn lp-btn--dark-outline",
                                href: $b2d7e8f6ac77b7f1$var$KOALENDAR,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Book a call"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $b2d7e8f6ac77b7f1$export$2e2bcd8739ae039 = $b2d7e8f6ac77b7f1$var$ResourcesCtaSection;



const $ec2c02f066103c13$var$BlogPage = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $772c58e033d05b1f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bc21a28eb66f2ee0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23b4b3e4cb158b66$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e25e7f69fdf7bc91$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2d7e8f6ac77b7f1$export$2e2bcd8739ae039), {})
        ]
    });
};
var $ec2c02f066103c13$export$2e2bcd8739ae039 = $ec2c02f066103c13$var$BlogPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



// Estimates reading time from the real postData content (no readTime field exists on post objects).
const $cafaddba4cc24580$var$WORDS_PER_MINUTE = 200;
const $cafaddba4cc24580$var$collectText = (value, out)=>{
    if (!value) return;
    if (typeof value === 'string') {
        out.push(value);
        return;
    }
    if (Array.isArray(value)) {
        value.forEach((v)=>$cafaddba4cc24580$var$collectText(v, out));
        return;
    }
    if (typeof value === 'object') Object.values(value).forEach((v)=>$cafaddba4cc24580$var$collectText(v, out));
};
const $cafaddba4cc24580$export$646e4fdc0e38989c = (postData)=>{
    const chunks = [];
    $cafaddba4cc24580$var$collectText(postData, chunks);
    const wordCount = chunks.join(' ').trim().split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.round(wordCount / $cafaddba4cc24580$var$WORDS_PER_MINUTE));
};
const $cafaddba4cc24580$export$9acf1a0a0a3c8f42 = (post)=>(post?.author?.name || '').replace(/,\s*$/, '');


const $57784938e92dc49e$var$BackIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
const $57784938e92dc49e$var$AuthorIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    });
const $57784938e92dc49e$var$ArticleHeroBanner = ({ post: post })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "lp-article-hero",
        style: {
            backgroundImage: `url(${post.bannerImage || post.image})`
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "overlay"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: $16250bd714b02a14$export$ce939e14da856e20,
                        className: "back",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($57784938e92dc49e$var$BackIcon, {}),
                            "Back to Resources"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tags",
                        children: (post.category || []).slice(0, 2).map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: (0, $d32af10bb5eccc25$export$312b808f6ccb3cb4)(c)
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: post.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "meta",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "author",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "avatar",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($57784938e92dc49e$var$AuthorIcon, {})
                                    }),
                                    (0, $cafaddba4cc24580$export$9acf1a0a0a3c8f42)(post)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "sep",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: post.date
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "sep",
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    (0, $cafaddba4cc24580$export$646e4fdc0e38989c)(post.postData),
                                    " min read"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $57784938e92dc49e$export$2e2bcd8739ae039 = $57784938e92dc49e$var$ArticleHeroBanner;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// BlogSection.js

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
function $eceef20b9809ef04$var$ContentSection({ keyName: keyName, value: value, styles: styles }) {
    if (keyName === "title") return /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
        children: value
    });
    if (keyName === "subTitle") return /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
        children: value
    });
    if (keyName === "introduction") return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        children: value
    });
    if (keyName === "sections" && Array.isArray(value)) return value.map((section, sectionIndex)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `${section.pointSideImage && "df aifs"}`,
            children: [
                section.title && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: section.title
                }),
                section.subTitle && /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    children: section.subTitle
                }),
                section.introduction && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: section.introduction.split("Contact us today").map((part, index, arr)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                            children: [
                                part,
                                index < arr.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                children: "Contact us today"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index))
                }),
                section.points && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    style: {
                        ...section.pointSideImage && {
                            width: "75%",
                            paddingRight: "30px"
                        }
                    },
                    className: styles.customUL,
                    children: [
                        section.listHeading && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: section.listHeading
                        }),
                        section.points.map((point, pointIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "df aifs jcfs",
                                    children: point.includes("<break>") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: styles.listTopic,
                                                children: point.split("<break>")[0]
                                            }),
                                            " ",
                                            point.split("<break>")[1],
                                            " ",
                                            point.split("<break>")[2] ? point.split("<break>")[2] : ""
                                        ]
                                    }) : point.includes(":") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: styles.listTopic,
                                                children: point.split(":")[0]
                                            }),
                                            ": ",
                                            point.split(":")[1],
                                            point.split(":")[2] ? `: ${point.split(":")[2]}` : ""
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: styles.listTopic,
                                        children: point
                                    })
                                })
                            }, pointIndex))
                    ]
                }),
                section.pointSideImage && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    style: {
                        width: "25%",
                        objectFit: 'contain',
                        marginTop: '2rem'
                    },
                    src: section.pointSideImage,
                    alt: "certificates"
                })
            ]
        }, sectionIndex);
    });
    if (keyName === "list" && Array.isArray(value)) return value.map((listData, listDataIndex)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                listData.title && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: listData.title
                }),
                listData.subTitle && /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    children: listData.subTitle
                }),
                listData.introduction && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: listData.introduction
                }),
                listData.points && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: styles.customList,
                    children: [
                        listData.listHeading && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: listData.listHeading
                        }),
                        listData.points.map((point, pointIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "df aifs jcfs",
                                    children: point.includes("<break>") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: styles.listTopic,
                                                children: point.split("<break>")[0]
                                            }),
                                            " ",
                                            point.split("<break>")[1]
                                        ]
                                    }) : point.includes(":") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: styles.listTopic,
                                                children: point.split(":")[0]
                                            }),
                                            ": ",
                                            point.split(":")[1]
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: styles.listTopic,
                                        children: point
                                    })
                                })
                            }, pointIndex))
                    ]
                })
            ]
        }, listDataIndex));
    return null;
}
var $eceef20b9809ef04$export$2e2bcd8739ae039 = $eceef20b9809ef04$var$ContentSection;


function $3a714b9c5df15c82$var$BlogSection({ data: data, styles: styles }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: styles.blogText,
        children: Object.entries(data).map(([key, value], index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eceef20b9809ef04$export$2e2bcd8739ae039), {
                keyName: key,
                value: value,
                styles: styles
            }, index);
        })
    });
}
var $3a714b9c5df15c82$export$2e2bcd8739ae039 = $3a714b9c5df15c82$var$BlogSection;


/**
 * This code was generated by Builder.io.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $ff8b75eace11797a$exports = {};

$parcel$export($ff8b75eace11797a$exports, "BlogCard", () => $ff8b75eace11797a$export$ae3ea6b85618c07d, (v) => $ff8b75eace11797a$export$ae3ea6b85618c07d = v);
$parcel$export($ff8b75eace11797a$exports, "ColorRed", () => $ff8b75eace11797a$export$2b11c9f33d1d909f, (v) => $ff8b75eace11797a$export$2b11c9f33d1d909f = v);
$parcel$export($ff8b75eace11797a$exports, "SecondaryCard", () => $ff8b75eace11797a$export$e359f6dcf5a52550, (v) => $ff8b75eace11797a$export$e359f6dcf5a52550 = v);
$parcel$export($ff8b75eace11797a$exports, "SecondaryCardHeading", () => $ff8b75eace11797a$export$1868cb160cdc2b66, (v) => $ff8b75eace11797a$export$1868cb160cdc2b66 = v);
$parcel$export($ff8b75eace11797a$exports, "active", () => $ff8b75eace11797a$export$89da14300d534261, (v) => $ff8b75eace11797a$export$89da14300d534261 = v);
$parcel$export($ff8b75eace11797a$exports, "aifs", () => $ff8b75eace11797a$export$a72b859737cd8b68, (v) => $ff8b75eace11797a$export$a72b859737cd8b68 = v);
$parcel$export($ff8b75eace11797a$exports, "authorAvatar", () => $ff8b75eace11797a$export$c1164c16b7125bc3, (v) => $ff8b75eace11797a$export$c1164c16b7125bc3 = v);
$parcel$export($ff8b75eace11797a$exports, "authorDetails", () => $ff8b75eace11797a$export$5599088923cb3524, (v) => $ff8b75eace11797a$export$5599088923cb3524 = v);
$parcel$export($ff8b75eace11797a$exports, "authorInfo", () => $ff8b75eace11797a$export$ebb07a49917dcfb0, (v) => $ff8b75eace11797a$export$ebb07a49917dcfb0 = v);
$parcel$export($ff8b75eace11797a$exports, "authorName", () => $ff8b75eace11797a$export$9acf1a0a0a3c8f42, (v) => $ff8b75eace11797a$export$9acf1a0a0a3c8f42 = v);
$parcel$export($ff8b75eace11797a$exports, "authorTitle", () => $ff8b75eace11797a$export$a6dc576feb01e87a, (v) => $ff8b75eace11797a$export$a6dc576feb01e87a = v);
$parcel$export($ff8b75eace11797a$exports, "bannerBlogTitle", () => $ff8b75eace11797a$export$723570ab92d8ae23, (v) => $ff8b75eace11797a$export$723570ab92d8ae23 = v);
$parcel$export($ff8b75eace11797a$exports, "blogBannerCardTitle", () => $ff8b75eace11797a$export$441030a6ac2d24cb, (v) => $ff8b75eace11797a$export$441030a6ac2d24cb = v);
$parcel$export($ff8b75eace11797a$exports, "blogContent", () => $ff8b75eace11797a$export$642cb4a64ef890f, (v) => $ff8b75eace11797a$export$642cb4a64ef890f = v);
$parcel$export($ff8b75eace11797a$exports, "blogFooter", () => $ff8b75eace11797a$export$9b0b86500a99dca5, (v) => $ff8b75eace11797a$export$9b0b86500a99dca5 = v);
$parcel$export($ff8b75eace11797a$exports, "blogPost", () => $ff8b75eace11797a$export$b83d4a670847abb0, (v) => $ff8b75eace11797a$export$b83d4a670847abb0 = v);
$parcel$export($ff8b75eace11797a$exports, "blogPostAuthor", () => $ff8b75eace11797a$export$fe83eed724a02199, (v) => $ff8b75eace11797a$export$fe83eed724a02199 = v);
$parcel$export($ff8b75eace11797a$exports, "blogPostCard", () => $ff8b75eace11797a$export$789f4d1fff079b6b, (v) => $ff8b75eace11797a$export$789f4d1fff079b6b = v);
$parcel$export($ff8b75eace11797a$exports, "blogPostCategories", () => $ff8b75eace11797a$export$760a9884e4739759, (v) => $ff8b75eace11797a$export$760a9884e4739759 = v);
$parcel$export($ff8b75eace11797a$exports, "blogPostExcerpt", () => $ff8b75eace11797a$export$d008d0032a2adf7, (v) => $ff8b75eace11797a$export$d008d0032a2adf7 = v);
$parcel$export($ff8b75eace11797a$exports, "blogPostGrid", () => $ff8b75eace11797a$export$1964fede22fa5c30, (v) => $ff8b75eace11797a$export$1964fede22fa5c30 = v);
$parcel$export($ff8b75eace11797a$exports, "blogPostImage", () => $ff8b75eace11797a$export$eed6cb2fc83620c2, (v) => $ff8b75eace11797a$export$eed6cb2fc83620c2 = v);
$parcel$export($ff8b75eace11797a$exports, "blogPostTitle", () => $ff8b75eace11797a$export$e295fe6a173f439b, (v) => $ff8b75eace11797a$export$e295fe6a173f439b = v);
$parcel$export($ff8b75eace11797a$exports, "blogText", () => $ff8b75eace11797a$export$17d8e5ea80d81a60, (v) => $ff8b75eace11797a$export$17d8e5ea80d81a60 = v);
$parcel$export($ff8b75eace11797a$exports, "blogTitle", () => $ff8b75eace11797a$export$64d6db2d189e2183, (v) => $ff8b75eace11797a$export$64d6db2d189e2183 = v);
$parcel$export($ff8b75eace11797a$exports, "category", () => $ff8b75eace11797a$export$657ee1858213601f, (v) => $ff8b75eace11797a$export$657ee1858213601f = v);
$parcel$export($ff8b75eace11797a$exports, "companyAddress", () => $ff8b75eace11797a$export$f7ce96dcdd7835b8, (v) => $ff8b75eace11797a$export$f7ce96dcdd7835b8 = v);
$parcel$export($ff8b75eace11797a$exports, "companyInfo", () => $ff8b75eace11797a$export$fa042d9ee760a18a, (v) => $ff8b75eace11797a$export$fa042d9ee760a18a = v);
$parcel$export($ff8b75eace11797a$exports, "customList", () => $ff8b75eace11797a$export$e1b86944a419e3b3, (v) => $ff8b75eace11797a$export$e1b86944a419e3b3 = v);
$parcel$export($ff8b75eace11797a$exports, "customUL", () => $ff8b75eace11797a$export$6418327a41207d8a, (v) => $ff8b75eace11797a$export$6418327a41207d8a = v);
$parcel$export($ff8b75eace11797a$exports, "df", () => $ff8b75eace11797a$export$2055d1a955f03d83, (v) => $ff8b75eace11797a$export$2055d1a955f03d83 = v);
$parcel$export($ff8b75eace11797a$exports, "featureContent", () => $ff8b75eace11797a$export$86e24950d671c6b9, (v) => $ff8b75eace11797a$export$86e24950d671c6b9 = v);
$parcel$export($ff8b75eace11797a$exports, "featureImage", () => $ff8b75eace11797a$export$3f81c6f362d1b70c, (v) => $ff8b75eace11797a$export$3f81c6f362d1b70c = v);
$parcel$export($ff8b75eace11797a$exports, "featureItem", () => $ff8b75eace11797a$export$2d9fa6c5be4e3616, (v) => $ff8b75eace11797a$export$2d9fa6c5be4e3616 = v);
$parcel$export($ff8b75eace11797a$exports, "featureList", () => $ff8b75eace11797a$export$b59041d470cc5109, (v) => $ff8b75eace11797a$export$b59041d470cc5109 = v);
$parcel$export($ff8b75eace11797a$exports, "featureSection", () => $ff8b75eace11797a$export$ff5afbeeb0fedaed, (v) => $ff8b75eace11797a$export$ff5afbeeb0fedaed = v);
$parcel$export($ff8b75eace11797a$exports, "featureTitle", () => $ff8b75eace11797a$export$8d386854f48ac1a2, (v) => $ff8b75eace11797a$export$8d386854f48ac1a2 = v);
$parcel$export($ff8b75eace11797a$exports, "featureTitleImage", () => $ff8b75eace11797a$export$ea5512afc85fedab, (v) => $ff8b75eace11797a$export$ea5512afc85fedab = v);
$parcel$export($ff8b75eace11797a$exports, "footerContent", () => $ff8b75eace11797a$export$a65ca8467dbb209e, (v) => $ff8b75eace11797a$export$a65ca8467dbb209e = v);
$parcel$export($ff8b75eace11797a$exports, "footerLogo", () => $ff8b75eace11797a$export$185e4800edb7da70, (v) => $ff8b75eace11797a$export$185e4800edb7da70 = v);
$parcel$export($ff8b75eace11797a$exports, "footerNav", () => $ff8b75eace11797a$export$b518e15883e48b4c, (v) => $ff8b75eace11797a$export$b518e15883e48b4c = v);
$parcel$export($ff8b75eace11797a$exports, "footerNavColumn", () => $ff8b75eace11797a$export$6ac99bcf0d7adca, (v) => $ff8b75eace11797a$export$6ac99bcf0d7adca = v);
$parcel$export($ff8b75eace11797a$exports, "footerNavList", () => $ff8b75eace11797a$export$5f865a99fad0f3ab, (v) => $ff8b75eace11797a$export$5f865a99fad0f3ab = v);
$parcel$export($ff8b75eace11797a$exports, "footerNavTitle", () => $ff8b75eace11797a$export$85ba2909805d3ca5, (v) => $ff8b75eace11797a$export$85ba2909805d3ca5 = v);
$parcel$export($ff8b75eace11797a$exports, "header", () => $ff8b75eace11797a$export$38e42c68cf43b5d4, (v) => $ff8b75eace11797a$export$38e42c68cf43b5d4 = v);
$parcel$export($ff8b75eace11797a$exports, "headerContent", () => $ff8b75eace11797a$export$838c0e7679321ff3, (v) => $ff8b75eace11797a$export$838c0e7679321ff3 = v);
$parcel$export($ff8b75eace11797a$exports, "headerDecoration", () => $ff8b75eace11797a$export$227fbc432d797c5a, (v) => $ff8b75eace11797a$export$227fbc432d797c5a = v);
$parcel$export($ff8b75eace11797a$exports, "headerImage", () => $ff8b75eace11797a$export$cf79e069f2284a16, (v) => $ff8b75eace11797a$export$cf79e069f2284a16 = v);
$parcel$export($ff8b75eace11797a$exports, "latestBlogPosts", () => $ff8b75eace11797a$export$2286a6b6ee8c140c, (v) => $ff8b75eace11797a$export$2286a6b6ee8c140c = v);
$parcel$export($ff8b75eace11797a$exports, "listTopic", () => $ff8b75eace11797a$export$31dc0a720efc94a4, (v) => $ff8b75eace11797a$export$31dc0a720efc94a4 = v);
$parcel$export($ff8b75eace11797a$exports, "logo", () => $ff8b75eace11797a$export$db3c28d99448dcff, (v) => $ff8b75eace11797a$export$db3c28d99448dcff = v);
$parcel$export($ff8b75eace11797a$exports, "mainContent", () => $ff8b75eace11797a$export$ad430d422a89f9f0, (v) => $ff8b75eace11797a$export$ad430d422a89f9f0 = v);
$parcel$export($ff8b75eace11797a$exports, "navItem", () => $ff8b75eace11797a$export$f1de0d6ae757bad, (v) => $ff8b75eace11797a$export$f1de0d6ae757bad = v);
$parcel$export($ff8b75eace11797a$exports, "navList", () => $ff8b75eace11797a$export$b5cb804542eb9e20, (v) => $ff8b75eace11797a$export$b5cb804542eb9e20 = v);
$parcel$export($ff8b75eace11797a$exports, "navigation", () => $ff8b75eace11797a$export$428e7c787d57587d, (v) => $ff8b75eace11797a$export$428e7c787d57587d = v);
$parcel$export($ff8b75eace11797a$exports, "postDate", () => $ff8b75eace11797a$export$d070aafd0b7e1693, (v) => $ff8b75eace11797a$export$d070aafd0b7e1693 = v);
$parcel$export($ff8b75eace11797a$exports, "secondaryCardImage", () => $ff8b75eace11797a$export$d71997929ae64865, (v) => $ff8b75eace11797a$export$d71997929ae64865 = v);
$parcel$export($ff8b75eace11797a$exports, "sectionTitle", () => $ff8b75eace11797a$export$1a952fe22cdce89e, (v) => $ff8b75eace11797a$export$1a952fe22cdce89e = v);
$parcel$export($ff8b75eace11797a$exports, "socialIcons", () => $ff8b75eace11797a$export$fc1c8ad213f4f5c0, (v) => $ff8b75eace11797a$export$fc1c8ad213f4f5c0 = v);
$parcel$export($ff8b75eace11797a$exports, "visually-hidden", () => $ff8b75eace11797a$export$f55b3345e7b94a21, (v) => $ff8b75eace11797a$export$f55b3345e7b94a21 = v);
var $ff8b75eace11797a$export$ae3ea6b85618c07d;
var $ff8b75eace11797a$export$2b11c9f33d1d909f;
var $ff8b75eace11797a$export$e359f6dcf5a52550;
var $ff8b75eace11797a$export$1868cb160cdc2b66;
var $ff8b75eace11797a$export$89da14300d534261;
var $ff8b75eace11797a$export$a72b859737cd8b68;
var $ff8b75eace11797a$export$c1164c16b7125bc3;
var $ff8b75eace11797a$export$5599088923cb3524;
var $ff8b75eace11797a$export$ebb07a49917dcfb0;
var $ff8b75eace11797a$export$9acf1a0a0a3c8f42;
var $ff8b75eace11797a$export$a6dc576feb01e87a;
var $ff8b75eace11797a$export$723570ab92d8ae23;
var $ff8b75eace11797a$export$441030a6ac2d24cb;
var $ff8b75eace11797a$export$642cb4a64ef890f;
var $ff8b75eace11797a$export$9b0b86500a99dca5;
var $ff8b75eace11797a$export$b83d4a670847abb0;
var $ff8b75eace11797a$export$fe83eed724a02199;
var $ff8b75eace11797a$export$789f4d1fff079b6b;
var $ff8b75eace11797a$export$760a9884e4739759;
var $ff8b75eace11797a$export$d008d0032a2adf7;
var $ff8b75eace11797a$export$1964fede22fa5c30;
var $ff8b75eace11797a$export$eed6cb2fc83620c2;
var $ff8b75eace11797a$export$e295fe6a173f439b;
var $ff8b75eace11797a$export$17d8e5ea80d81a60;
var $ff8b75eace11797a$export$64d6db2d189e2183;
var $ff8b75eace11797a$export$657ee1858213601f;
var $ff8b75eace11797a$export$f7ce96dcdd7835b8;
var $ff8b75eace11797a$export$fa042d9ee760a18a;
var $ff8b75eace11797a$export$e1b86944a419e3b3;
var $ff8b75eace11797a$export$6418327a41207d8a;
var $ff8b75eace11797a$export$2055d1a955f03d83;
var $ff8b75eace11797a$export$86e24950d671c6b9;
var $ff8b75eace11797a$export$3f81c6f362d1b70c;
var $ff8b75eace11797a$export$2d9fa6c5be4e3616;
var $ff8b75eace11797a$export$b59041d470cc5109;
var $ff8b75eace11797a$export$ff5afbeeb0fedaed;
var $ff8b75eace11797a$export$8d386854f48ac1a2;
var $ff8b75eace11797a$export$ea5512afc85fedab;
var $ff8b75eace11797a$export$a65ca8467dbb209e;
var $ff8b75eace11797a$export$185e4800edb7da70;
var $ff8b75eace11797a$export$b518e15883e48b4c;
var $ff8b75eace11797a$export$6ac99bcf0d7adca;
var $ff8b75eace11797a$export$5f865a99fad0f3ab;
var $ff8b75eace11797a$export$85ba2909805d3ca5;
var $ff8b75eace11797a$export$38e42c68cf43b5d4;
var $ff8b75eace11797a$export$838c0e7679321ff3;
var $ff8b75eace11797a$export$227fbc432d797c5a;
var $ff8b75eace11797a$export$cf79e069f2284a16;
var $ff8b75eace11797a$export$2286a6b6ee8c140c;
var $ff8b75eace11797a$export$31dc0a720efc94a4;
var $ff8b75eace11797a$export$db3c28d99448dcff;
var $ff8b75eace11797a$export$ad430d422a89f9f0;
var $ff8b75eace11797a$export$f1de0d6ae757bad;
var $ff8b75eace11797a$export$b5cb804542eb9e20;
var $ff8b75eace11797a$export$428e7c787d57587d;
var $ff8b75eace11797a$export$d070aafd0b7e1693;
var $ff8b75eace11797a$export$d71997929ae64865;
var $ff8b75eace11797a$export$1a952fe22cdce89e;
var $ff8b75eace11797a$export$fc1c8ad213f4f5c0;
var $ff8b75eace11797a$export$f55b3345e7b94a21;
$ff8b75eace11797a$export$ae3ea6b85618c07d = `kd6iYG_BlogCard`;
$ff8b75eace11797a$export$2b11c9f33d1d909f = `kd6iYG_ColorRed`;
$ff8b75eace11797a$export$e359f6dcf5a52550 = `kd6iYG_SecondaryCard`;
$ff8b75eace11797a$export$1868cb160cdc2b66 = `kd6iYG_SecondaryCardHeading`;
$ff8b75eace11797a$export$89da14300d534261 = `kd6iYG_active`;
$ff8b75eace11797a$export$a72b859737cd8b68 = `kd6iYG_aifs`;
$ff8b75eace11797a$export$c1164c16b7125bc3 = `kd6iYG_authorAvatar`;
$ff8b75eace11797a$export$5599088923cb3524 = `kd6iYG_authorDetails`;
$ff8b75eace11797a$export$ebb07a49917dcfb0 = `kd6iYG_authorInfo`;
$ff8b75eace11797a$export$9acf1a0a0a3c8f42 = `kd6iYG_authorName`;
$ff8b75eace11797a$export$a6dc576feb01e87a = `kd6iYG_authorTitle`;
$ff8b75eace11797a$export$723570ab92d8ae23 = `kd6iYG_bannerBlogTitle`;
$ff8b75eace11797a$export$441030a6ac2d24cb = `kd6iYG_blogBannerCardTitle`;
$ff8b75eace11797a$export$642cb4a64ef890f = `kd6iYG_blogContent`;
$ff8b75eace11797a$export$9b0b86500a99dca5 = `kd6iYG_blogFooter`;
$ff8b75eace11797a$export$b83d4a670847abb0 = `kd6iYG_blogPost`;
$ff8b75eace11797a$export$fe83eed724a02199 = `kd6iYG_blogPostAuthor`;
$ff8b75eace11797a$export$789f4d1fff079b6b = `kd6iYG_blogPostCard`;
$ff8b75eace11797a$export$760a9884e4739759 = `kd6iYG_blogPostCategories`;
$ff8b75eace11797a$export$d008d0032a2adf7 = `kd6iYG_blogPostExcerpt`;
$ff8b75eace11797a$export$1964fede22fa5c30 = `kd6iYG_blogPostGrid`;
$ff8b75eace11797a$export$eed6cb2fc83620c2 = `kd6iYG_blogPostImage`;
$ff8b75eace11797a$export$e295fe6a173f439b = `kd6iYG_blogPostTitle`;
$ff8b75eace11797a$export$17d8e5ea80d81a60 = `kd6iYG_blogText`;
$ff8b75eace11797a$export$64d6db2d189e2183 = `kd6iYG_blogTitle`;
$ff8b75eace11797a$export$657ee1858213601f = `kd6iYG_category`;
$ff8b75eace11797a$export$f7ce96dcdd7835b8 = `kd6iYG_companyAddress`;
$ff8b75eace11797a$export$fa042d9ee760a18a = `kd6iYG_companyInfo`;
$ff8b75eace11797a$export$e1b86944a419e3b3 = `kd6iYG_customList`;
$ff8b75eace11797a$export$6418327a41207d8a = `kd6iYG_customUL`;
$ff8b75eace11797a$export$2055d1a955f03d83 = `kd6iYG_df`;
$ff8b75eace11797a$export$86e24950d671c6b9 = `kd6iYG_featureContent`;
$ff8b75eace11797a$export$3f81c6f362d1b70c = `kd6iYG_featureImage`;
$ff8b75eace11797a$export$2d9fa6c5be4e3616 = `kd6iYG_featureItem`;
$ff8b75eace11797a$export$b59041d470cc5109 = `kd6iYG_featureList`;
$ff8b75eace11797a$export$ff5afbeeb0fedaed = `kd6iYG_featureSection`;
$ff8b75eace11797a$export$8d386854f48ac1a2 = `kd6iYG_featureTitle`;
$ff8b75eace11797a$export$ea5512afc85fedab = `kd6iYG_featureTitleImage`;
$ff8b75eace11797a$export$a65ca8467dbb209e = `kd6iYG_footerContent`;
$ff8b75eace11797a$export$185e4800edb7da70 = `kd6iYG_footerLogo`;
$ff8b75eace11797a$export$b518e15883e48b4c = `kd6iYG_footerNav`;
$ff8b75eace11797a$export$6ac99bcf0d7adca = `kd6iYG_footerNavColumn`;
$ff8b75eace11797a$export$5f865a99fad0f3ab = `kd6iYG_footerNavList`;
$ff8b75eace11797a$export$85ba2909805d3ca5 = `kd6iYG_footerNavTitle`;
$ff8b75eace11797a$export$38e42c68cf43b5d4 = `kd6iYG_header`;
$ff8b75eace11797a$export$838c0e7679321ff3 = `kd6iYG_headerContent`;
$ff8b75eace11797a$export$227fbc432d797c5a = `kd6iYG_headerDecoration`;
$ff8b75eace11797a$export$cf79e069f2284a16 = `kd6iYG_headerImage`;
$ff8b75eace11797a$export$2286a6b6ee8c140c = `kd6iYG_latestBlogPosts`;
$ff8b75eace11797a$export$31dc0a720efc94a4 = `kd6iYG_listTopic`;
$ff8b75eace11797a$export$db3c28d99448dcff = `kd6iYG_logo`;
$ff8b75eace11797a$export$ad430d422a89f9f0 = `kd6iYG_mainContent`;
$ff8b75eace11797a$export$f1de0d6ae757bad = `kd6iYG_navItem`;
$ff8b75eace11797a$export$b5cb804542eb9e20 = `kd6iYG_navList`;
$ff8b75eace11797a$export$428e7c787d57587d = `kd6iYG_navigation`;
$ff8b75eace11797a$export$d070aafd0b7e1693 = `kd6iYG_postDate`;
$ff8b75eace11797a$export$d71997929ae64865 = `kd6iYG_secondaryCardImage`;
$ff8b75eace11797a$export$1a952fe22cdce89e = `kd6iYG_sectionTitle`;
$ff8b75eace11797a$export$fc1c8ad213f4f5c0 = `kd6iYG_socialIcons`;
$ff8b75eace11797a$export$f55b3345e7b94a21 = `kd6iYG_visually-hidden`;


function $9fdb4eaddf0b9a30$var$DefaultCard({ title: title, titlePrefixIcon: titlePrefixIcon, features: features, imageSrc: imageSrc, maxWidth: maxWidth }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: $ff8b75eace11797a$export$86e24950d671c6b9,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: $ff8b75eace11797a$export$441030a6ac2d24cb,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: titlePrefixIcon,
                                alt: `${title} illustration`,
                                className: $ff8b75eace11797a$export$ea5512afc85fedab
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: $ff8b75eace11797a$export$8d386854f48ac1a2,
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: $ff8b75eace11797a$export$b59041d470cc5109,
                        children: features && features.length && features.map((feature, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                className: $ff8b75eace11797a$export$2d9fa6c5be4e3616,
                                children: feature
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: imageSrc,
                alt: `${title} illustration`,
                className: $ff8b75eace11797a$export$3f81c6f362d1b70c,
                style: {
                    maxWidth: maxWidth
                }
            })
        ]
    });
}
var $9fdb4eaddf0b9a30$export$2e2bcd8739ae039 = $9fdb4eaddf0b9a30$var$DefaultCard;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

const $888d41fdc5123461$var$CardWrapper = ({ children: children, bgImage: bgImage })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
            className: $ff8b75eace11797a$export$ff5afbeeb0fedaed,
            style: {
                ...bgImage !== "" ? {
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                } : {}
            },
            children: children
        })
    });
};
var $888d41fdc5123461$export$2e2bcd8739ae039 = $888d41fdc5123461$var$CardWrapper;


/**
 * This code was generated by Builder.io.
 */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

function $7a84db39cca01cd3$var$SecondaryCard({ title: title, subTitle: subTitle, imageSrc: imageSrc, maxWidth: maxWidth }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: $ff8b75eace11797a$export$e359f6dcf5a52550,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: $ff8b75eace11797a$export$1868cb160cdc2b66,
                    children: title.includes("<r>") ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            title.split("<r>")[0],
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: $ff8b75eace11797a$export$2b11c9f33d1d909f,
                                children: title.split("<r>")[1]
                            })
                        ]
                    }) : title
                }),
                subTitle ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        " ",
                        subTitle
                    ]
                }) : "",
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: imageSrc,
                    alt: `${title} illustration`,
                    className: $ff8b75eace11797a$export$d71997929ae64865,
                    style: {
                        maxWidth: maxWidth
                    }
                })
            ]
        })
    });
}
var $7a84db39cca01cd3$export$2e2bcd8739ae039 = $7a84db39cca01cd3$var$SecondaryCard;


function $ccd279d374963392$var$BlogContent({ sec: { data: data, type: type, cardStyle: cardStyle, bgImage: bgImage = "" }, styles: styles }) {
    if (type === "content") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3a714b9c5df15c82$export$2e2bcd8739ae039), {
        styles: styles,
        data: data
    });
    else if (type === "card") return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: `${styles.BlogCard} cardBlog`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $888d41fdc5123461$export$2e2bcd8739ae039), {
            bgImage: bgImage ?? "",
            children: !cardStyle || cardStyle === "default" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9fdb4eaddf0b9a30$export$2e2bcd8739ae039), {
                title: data.title,
                features: data.points,
                titlePrefixIcon: data.titlePrefixIcon,
                imageSrc: data.image,
                maxWidth: data.maxWidth ?? "auto"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7a84db39cca01cd3$export$2e2bcd8739ae039), {
                title: data.title,
                features: data?.points ?? [],
                subTitle: data.subTitle,
                imageSrc: data.image,
                maxWidth: data.maxWidth ?? "auto"
            })
        })
    });
    else if (type === "image") return /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
        src: data,
        alt: "diligentsia",
        className: "w100 p2rem bsbb"
    });
    return null;
}
var $ccd279d374963392$export$2e2bcd8739ae039 = $ccd279d374963392$var$BlogContent;




const $106aa085c5a430b4$var$AuthorIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#5B6472",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    });
const $106aa085c5a430b4$var$ArticleBody = ({ post: post })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-article-body-sec",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-article-body-inner",
            children: [
                post.excerpt && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lead",
                    children: post.excerpt
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "article-body",
                    children: Object.values(post.postData || {}).map((sec, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccd279d374963392$export$2e2bcd8739ae039), {
                            sec: sec,
                            styles: $ff8b75eace11797a$exports
                        }, i))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-article-author-card",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "avatar",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($106aa085c5a430b4$var$AuthorIcon, {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "name",
                                    children: (0, $cafaddba4cc24580$export$9acf1a0a0a3c8f42)(post)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "role",
                                    children: post.author?.role
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $106aa085c5a430b4$export$2e2bcd8739ae039 = $106aa085c5a430b4$var$ArticleBody;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $0b564af4660766c6$var$detailHref = (post)=>$16250bd714b02a14$export$2aac1f04473d9900.replace(':slug', post.slug);
const $0b564af4660766c6$var$ArticleRelatedSection = ({ currentSlug: currentSlug })=>{
    const related = [
        ...(0, $6238ac0b849c9c3e$export$d09847bb5c97319b),
        (0, $6238ac0b849c9c3e$export$38165aa3a38f65a7)
    ].filter((p)=>p.slug !== currentSlug).slice(0, 5);
    if (!related.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-article-related",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-container",
            style: {
                maxWidth: 1200
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "head",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-pe-eyebrow",
                                    children: "Keep reading"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: "More from Diligentsia"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: $16250bd714b02a14$export$ce939e14da856e20,
                            children: "View all \u2192"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "grid",
                    children: related.map((post)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "card",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "img",
                                    style: {
                                        backgroundImage: `url(${post.image})`
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "body",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "tag",
                                            children: (0, $d32af10bb5eccc25$export$312b808f6ccb3cb4)((post.category || [])[0])
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: post.title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: $0b564af4660766c6$var$detailHref(post),
                                            children: "Read \u2192"
                                        })
                                    ]
                                })
                            ]
                        }, post.slug))
                })
            ]
        })
    });
};
var $0b564af4660766c6$export$2e2bcd8739ae039 = $0b564af4660766c6$var$ArticleRelatedSection;




const $d3bb8352184af0c4$var$BlogDetailPage = ()=>{
    const { slug: slug } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const data = (0, $acw62.useMemo)(()=>[
            ...(0, $6238ac0b849c9c3e$export$d09847bb5c97319b),
            (0, $6238ac0b849c9c3e$export$38165aa3a38f65a7)
        ].find((blog)=>blog.slug === slug), [
        slug
    ]);
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $560d16798825a58a$export$8bb697ee33fbba2b)(rootRef);
    (0, $acw62.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        slug
    ]);
    if (!data) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57784938e92dc49e$export$2e2bcd8739ae039), {
                post: data
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $106aa085c5a430b4$export$2e2bcd8739ae039), {
                post: data
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b564af4660766c6$export$2e2bcd8739ae039), {
                currentSlug: data.slug
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2d7e8f6ac77b7f1$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d3bb8352184af0c4$export$2e2bcd8739ae039 = $d3bb8352184af0c4$var$BlogDetailPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $f7b4055b83aa856d$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
// The "mirror" teaser: what follow-on investors run on graduates, and the same tools the cohort
// runs on itself first. The whole page argues this reversal, so the hero states it up front.
const $f7b4055b83aa856d$var$INVESTOR_RUNS = [
    'Corporate & legal diligence, AI-assisted',
    'Financial model stress-test',
    'Technical & code due diligence'
];
const $f7b4055b83aa856d$var$COHORT_RUNS = [
    'Same corporate & legal tools, self-diligenced',
    'Same financial model tools, self-built',
    'Same technical DD tools, self-tested'
];
const $f7b4055b83aa856d$var$AccHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("header", {
        className: "lp-acc-hero",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-hero-inner",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "lp-acc-eyebrow",
                            "data-lp-reveal": true,
                            children: "For Accelerators & Venture Studios"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "lp-acc-h1",
                            "data-lp-reveal": true,
                            "data-lp-delay": "60",
                            children: [
                                "One platform. ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                    className: "lp-acc-h1",
                                    children: "Every"
                                }),
                                " deal, every company, all the way to funding."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-acc-lede",
                            "data-lp-reveal": true,
                            "data-lp-delay": "120",
                            children: "Diligentsia is the only platform that runs deal management for your programme and investment-readiness for your cohort \u2014 the same platform, the same standard, from application to follow-on close."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-acc-lede",
                            "data-lp-reveal": true,
                            "data-lp-delay": "160",
                            children: "InvestorMatch with 40+ VCs already on platform"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-ctas",
                            "data-lp-reveal": true,
                            "data-lp-delay": "200",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                className: "lp-acc-btn lp-acc-btn--primary",
                                href: $f7b4055b83aa856d$var$KOALENDAR,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "Book a call \u2192"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-mirror",
                    "data-lp-reveal": true,
                    "data-lp-delay": "140",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-mt-label",
                            children: "What follow-on investors will run on your graduates"
                        }),
                        $f7b4055b83aa856d$var$INVESTOR_RUNS.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-acc-chip lp-acc-chip--indigo",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ck",
                                        children: "\u2192"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: t
                                    })
                                ]
                            }, t)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-mirror-line",
                            children: "reversed, before demo day"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-mt-label",
                            children: "What your cohort runs on itself, first"
                        }),
                        $f7b4055b83aa856d$var$COHORT_RUNS.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-acc-chip lp-acc-chip--coral",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "ck",
                                        children: "\u2713"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: t
                                    })
                                ]
                            }, t))
                    ]
                })
            ]
        })
    });
var $f7b4055b83aa856d$export$2e2bcd8739ae039 = $f7b4055b83aa856d$var$AccHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Sticky under the site header. `top` matches the header height so it pins directly beneath it.
const $194439ba83320691$var$AccTabBar = ({ tabs: tabs, active: active, onChange: onChange })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-acc-tabbar-wrap",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-acc-wrap",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "lp-acc-tabbar",
                role: "tablist",
                children: tabs.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        role: "tab",
                        "aria-selected": active === t.id,
                        className: `lp-acc-tab${active === t.id ? ' is-active' : ''}`,
                        onClick: ()=>onChange(t.id),
                        children: t.label
                    }, t.id))
            })
        })
    });
var $194439ba83320691$export$2e2bcd8739ae039 = $194439ba83320691$var$AccTabBar;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $90ba9ff2614c2ef1$var$STATS = [
    {
        tone: 'yellow',
        value: "6\u20138 wks",
        label: 'Average seed due diligence, unprepared'
    },
    {
        tone: 'green',
        value: "2\u20134 wks",
        label: 'Same round, fully prepared'
    },
    {
        tone: 'coral',
        value: "15\u201320",
        label: 'Issues an AI reviewer finds, vs. 5 for a human'
    },
    {
        tone: 'indigo',
        value: '<1%',
        label: 'Of pitched companies get funded at all'
    }
];
const $90ba9ff2614c2ef1$var$AccMarketContextSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "Our Experience"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "Your cohort is about to face a different kind of investor diligence."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-acc-sub",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: "Your programme does the hard work: validating the model, sharpening the pitch, connecting founders to mentors. But your companies still arrive at demo day with a deck and optimism \u2014 not a structured evidence base. Meanwhile, VCs are moving AI diligence tools from experiment to standard practice, and AI does not miss what a tired human reviewer might. Companies that arrive unprepared don't lose the deal at the pitch. They lose it three weeks into diligence, one gap at a time."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-pullquote",
                    "data-lp-reveal": true,
                    "data-lp-delay": "160",
                    children: '"A folder of unorganised PDFs is not a data room. It is an invitation for extended enquiry."'
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-stat-row",
                    children: $90ba9ff2614c2ef1$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-acc-fstat is-${s.tone}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-acc-circle",
                                    children: s.value
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flabel",
                                    children: s.label
                                })
                            ]
                        }, s.label))
                })
            ]
        })
    });
var $90ba9ff2614c2ef1$export$2e2bcd8739ae039 = $90ba9ff2614c2ef1$var$AccMarketContextSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $d391d6b977f38c80$var$INVESTOR_TOOLS = [
    {
        icon: "\u2696",
        title: 'Corporate & Legal DD',
        body: "Governance, cap table, IP assignment, contracts \u2014 read by AI in minutes."
    },
    {
        icon: "\u03A3",
        title: 'Financial Model AI',
        body: 'Model coherence, forecast discipline, and stress evidence, scored automatically.'
    },
    {
        icon: "\u2325",
        title: 'Technical & Code DD',
        body: 'Architecture and code quality assessed without ever extracting source.'
    }
];
const $d391d6b977f38c80$var$COHORT_TOOLS = [
    {
        icon: "\u2696",
        title: 'Self-diligence corporate & legal',
        body: "Find undocumented equity or IP gaps before an investor's AI does.*"
    },
    {
        icon: "\u03A3",
        title: 'Build & reverse the model',
        body: 'Create an institutional-grade model, then stress-test it the way they will.*'
    },
    {
        icon: "\u2325",
        title: 'Technical DD, no code extraction',
        body: "Score and remediate the stack before it's used as valuation leverage.*"
    }
];
const $d391d6b977f38c80$var$ToolGrid = ({ tools: tools })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-acc-thesis-icons",
        children: tools.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-acc-ti",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-acc-ti-icon",
                        "aria-hidden": "true",
                        children: t.icon
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: t.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: t.body
                    })
                ]
            }, t.title))
    });
const $d391d6b977f38c80$var$AccReverseDiligenceSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec lp-acc-sec--black",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "The reverse-diligence principle"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "If your investors are going to run AI diligence on your graduates, your graduates should run it on themselves first."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-acc-sub",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: "Diligentsia builds the diligence tools follow-on investors are adopting as standard. We give VCs the toolkit. Which means your cohort companies can use the identical toolkit on themselves \u2014 before an investor ever does \u2014 and walk into demo day already having remediated key issues."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-thesis",
                    "data-lp-reveal": true,
                    "data-lp-delay": "160",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-thesis-half is-top",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-acc-thesis-cap",
                                    children: "Deployed by follow-on investors"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d391d6b977f38c80$var$ToolGrid, {
                                    tools: $d391d6b977f38c80$var$INVESTOR_TOOLS
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-thesis-mid",
                            children: "reverse-diligenced, on the same platform"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-thesis-half is-bottom",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-acc-thesis-cap",
                                    children: "Available to your cohort, first"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d391d6b977f38c80$var$ToolGrid, {
                                    tools: $d391d6b977f38c80$var$COHORT_TOOLS
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-acc-thesis-footnote",
                                    children: "* = partner integration"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "lp-acc-thesis-tagline",
                    "data-lp-reveal": true,
                    children: [
                        "Same tools. Same standard. ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "Whoever runs them first controls the negotiation."
                        })
                    ]
                })
            ]
        })
    });
var $d391d6b977f38c80$export$2e2bcd8739ae039 = $d391d6b977f38c80$var$AccReverseDiligenceSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $b68dd51eeebdaa47$var$PROGRAMME = [
    'Free deal management platform, application to IC',
    "Application triage in 3\u20134 minutes, no cost",
    "Cohort dashboard \u2014 readiness, risk, certification, live",
    'Sponsor reporting your team no longer has to chase'
];
const $b68dd51eeebdaa47$var$COHORT = [
    'Diligence Pack, up to 60% auto-populated from documents',
    'Corporate, financial, and technical reverse-diligence',
    'Bronze / Silver / Gold certification investors recognise',
    '1-click InvestorMatch to 40+ active VCs'
];
const $b68dd51eeebdaa47$var$EcosystemMark = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 40 40",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4 26L13 15L19 22L24 16",
                stroke: "#FC7785",
                strokeWidth: "4.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19 22L24 16L36 9",
                stroke: "#4A67FF",
                strokeWidth: "4.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
// `onSeeCohort` switches the page to the Cohort Companies tab — the design wires this button to its
// own switchTab('3'), so it stays an in-page tab change rather than a link.
const $b68dd51eeebdaa47$var$AccOnePlatformSection = ({ onSeeCohort: onSeeCohort })=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "Our Differentiator"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "You are joining one integrated ecosystem."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-acc-sub",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: "Other tools help a VC screen deal flow. Others help a founder build a data room. Diligentsia is the one platform where your deal management, your cohort's investor readiness, and your follow-on investors' diligence all run on the same rails \u2014 so nothing gets lost in translation between them."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-banner",
                    "data-lp-reveal": true,
                    "data-lp-delay": "160",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-banner-col",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "For your programme"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    children: $b68dd51eeebdaa47$var$PROGRAMME.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: t
                                        }, t))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-banner-mid",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "badge",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($b68dd51eeebdaa47$var$EcosystemMark, {})
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "One Ecosystem"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-banner-col",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: "For your cohort"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    children: $b68dd51eeebdaa47$var$COHORT.map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: t
                                        }, t))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-center-cta",
                    "data-lp-reveal": true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "button",
                        className: "lp-acc-btn lp-acc-btn--outline",
                        onClick: onSeeCohort,
                        children: "See what your cohort gets \u2192"
                    })
                })
            ]
        })
    });
var $b68dd51eeebdaa47$export$2e2bcd8739ae039 = $b68dd51eeebdaa47$var$AccOnePlatformSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $ae463d354380f20d$var$MODULES = [
    {
        free: true,
        title: 'Deal Management Platform',
        body: 'Initial application through to investment committee, one dashboard.'
    },
    {
        free: true,
        title: 'Application Triage',
        body: "Structured fit report in 3\u20134 minutes, before you read a single deck."
    },
    {
        free: true,
        title: 'Cohort Dashboard',
        body: 'Completion rates, risk flags, and certification, live across every company.'
    },
    {
        free: false,
        title: 'Existing Workflow Integration',
        body: 'Runs alongside Notion, Airtable, Salesforce, or your CRM via API.'
    }
];
const $ae463d354380f20d$var$AccOperatorModulesSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec lp-acc-sec--lavender",
        id: "modules",
        style: {
            marginBottom: 0
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "The platform, module by module"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "Every module built for your programme."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-acc-sub",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: "Free for your programme, always. Everything you need to run deal flow from application to investment committee \u2014 with full visibility into every cohort company's readiness along the way."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-modules",
                    "data-lp-reveal": true,
                    "data-lp-delay": "160",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-mod-legend",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lg-item",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "lg-swatch is-free"
                                    }),
                                    "Free"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-mod-groups is-single",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-acc-mod-group is-white",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-acc-mod-group-head",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "For the Operator"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-acc-mod-who",
                                        children: "Every programme, at no cost"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-acc-mod-card-row",
                                        children: $ae463d354380f20d$var$MODULES.map((m)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-acc-mod-card",
                                                children: [
                                                    m.free && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: "lp-acc-mod-tag is-free",
                                                        children: "Free"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        children: m.title
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: m.body
                                                    })
                                                ]
                                            }, m.title))
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
var $ae463d354380f20d$export$2e2bcd8739ae039 = $ae463d354380f20d$var$AccOperatorModulesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $9c830cafe8c2f4d7$var$REASONS = [
    {
        n: '01',
        title: 'Amplify the readiness of every company you graduate',
        body: 'Your programme makes the business better. Diligentsia makes sure investors find the same quality behind the pitch as in it.'
    },
    {
        n: '02',
        title: 'See exactly where every cohort company stands, in real time',
        body: "Completeness scores, risk flags, and certification, updated continuously \u2014 weeks before an investor conversation begins."
    },
    {
        n: '03',
        title: 'Turn demo day conversations into commitments',
        body: "When interest moves past the pitch, what's behind it needs to match \u2014 governance, ownership, contracts, risk."
    },
    {
        n: '04',
        title: 'Free your mentors from formatting work',
        body: "Clarence auto-populates up to 60% of diligence modules from each company's own documents. Mentors focus on strategy, not structuring."
    },
    {
        n: '05',
        title: "Don't let your companies get exposed by someone else's AI",
        body: 'Investors already run AI diligence. Programmes whose graduates arrive certified have a measurable, compounding advantage.'
    },
    {
        n: '06',
        title: 'Screen investment readiness, not just the pitch',
        body: "AI can score a market opportunity. It can't tell you if the IP is in dispute or the cap table doesn't reconcile. We add that layer."
    },
    {
        n: '07',
        title: 'Give every applicant a constructive next step',
        body: "Companies you don't accept are introduced to Diligentsia's broader network \u2014 a warm handover, not a dead end."
    },
    {
        n: '08',
        title: 'Keep sight of your portfolio after the programme ends',
        body: "Diligentsia keeps every graduate's readiness record live and connected to InvestorMatch, long after demo day."
    },
    {
        n: '09',
        title: 'Produce the outcome data your sponsors are asking for',
        body: "Completion rates, readiness scores, certification levels, and funded outcomes \u2014 always current, never chased."
    }
];
const $9c830cafe8c2f4d7$var$AccFirstMoversSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec lp-acc-sec--black",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "Why programme directors are moving now"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "First movers set the standard. Everyone else adopts it later, from a weaker position."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-reasons",
                    children: $9c830cafe8c2f4d7$var$REASONS.map((r, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-reason",
                            "data-lp-reveal": true,
                            "data-lp-delay": i % 3 * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "rn",
                                    children: r.n
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: r.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: r.body
                                })
                            ]
                        }, r.n))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-pullquote",
                    "data-lp-reveal": true,
                    children: [
                        "\"It's not that it doesn't get done. It just takes longer to answer those questions three weeks down the line than if they're answered three days into it.\"",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("cite", {
                            children: "\u2014 Investment Manager, EHE Ventures"
                        })
                    ]
                })
            ]
        })
    });
var $9c830cafe8c2f4d7$export$2e2bcd8739ae039 = $9c830cafe8c2f4d7$var$AccFirstMoversSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $f14087fb1395f798$var$FLOWS = [
    {
        tone: '1',
        step: 'All applicants free',
        title: 'Free readiness profile',
        body: 'Generate goodwill. Following application via web form from your website, every applicant is offered a free investment readiness check whilst awaiting your initial gating. No cost, no commitment.'
    },
    {
        tone: '2',
        step: 'Rejected applicants',
        title: 'A warm handover, not a dead end',
        body: "Every company you don't accept is introduced to Diligentsia's broader network \u2014 matched to other VCs, advisors, and programmes. Your brand stays associated with a constructive outcome."
    },
    {
        tone: '3',
        step: 'Successful cohort invitees',
        title: 'Onboarded from day one',
        body: 'Every company you accept begins their Diligentsia journey as part of onboarding. By demo day: a completed Diligence Pack, Bronze/Silver/Gold certification, and 1-click access to 40+ VCs.'
    }
];
const $f14087fb1395f798$var$AccFlowsSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "How the partnership works"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "Three flows, one platform \u2014 practical and low-friction for both sides."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-flows",
                    children: $f14087fb1395f798$var$FLOWS.map((f, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-acc-flow is-${f.tone}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 90,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-acc-flow-step",
                                    children: f.step
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: f.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: f.body
                                })
                            ]
                        }, f.title))
                })
            ]
        })
    });
var $f14087fb1395f798$export$2e2bcd8739ae039 = $f14087fb1395f798$var$AccFlowsSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $f3e48d5c7f47a112$var$TIERS = [
    {
        tone: 'white',
        who: 'Programme Operator',
        amount: 'Free',
        per: 'No platform fees*, no revenue share where Accelerator adds their cohort',
        items: [
            'Deal management platform',
            'Cohort dashboard & sponsor reporting',
            'Application triage for every applicant'
        ],
        note: '* = Additional fees may be charged for partner services'
    },
    {
        tone: 'lite',
        who: 'Application Triage',
        amount: 'Free',
        per: "For every applicant, accepted or not \u2014 no commitment required",
        items: [
            '20-minute structured overview',
            'Readiness score before you read the deck',
            'Warm handover if not accepted'
        ]
    }
];
const $f3e48d5c7f47a112$var$AccProgrammePricingSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec lp-acc-sec--lavender",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "Pricing for your firm"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "Free for the programme. Always."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-pricing is-two",
                    children: $f3e48d5c7f47a112$var$TIERS.map((t, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-acc-price-card is-${t.tone}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 90,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "who",
                                    children: t.who
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "amt",
                                    children: t.amount
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "per",
                                    children: t.per
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    children: t.items.map((x)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: x
                                        }, x))
                                }),
                                t.note && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-acc-price-note",
                                    children: t.note
                                })
                            ]
                        }, t.who))
                })
            ]
        })
    });
var $f3e48d5c7f47a112$export$2e2bcd8739ae039 = $f3e48d5c7f47a112$var$AccProgrammePricingSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $9c9beb6ffe131583$var$CERTS = [
    {
        tone: 'bronze',
        name: 'Bronze',
        body: 'Basic governance and corporate records complete. Suited to very early-stage or pre-revenue companies.'
    },
    {
        tone: 'silver',
        name: 'Silver',
        body: 'Full Diligence Pack substantially complete, including financials and commercial evidence. Right for most seed rounds.'
    },
    {
        tone: 'gold',
        name: 'Gold',
        body: "Directors' questionnaires, warranty drafts, and full IP and contract analysis. For larger rounds or Series A and above."
    }
];
const $9c9beb6ffe131583$var$STEPS = [
    {
        n: '1',
        title: 'Upload once',
        body: 'Contracts, financials, pitch materials, and board papers into your Data Repository.'
    },
    {
        n: '2',
        title: 'Clarence auto-fills',
        body: '~60% of your diligence modules populated straight from your own knowledge base.'
    },
    {
        n: '3',
        title: 'You review',
        body: 'Every answer signed off by a director. Nothing is final until you approve it.'
    },
    {
        n: '4',
        title: 'Pack generated',
        body: 'Shareable with your programme, investors, and advisors via one controlled link.'
    },
    {
        n: '5',
        title: 'Keep it current',
        body: "Every future round, every M&A process \u2014 your record is already there."
    }
];
const $9c9beb6ffe131583$var$STATS = [
    {
        tone: 'green',
        value: '60%',
        label: 'of modules auto-filled by AI'
    },
    {
        tone: 'indigo',
        value: '40+',
        label: 'VCs on InvestorMatch'
    },
    {
        tone: 'yellow',
        value: '1x',
        label: 'upload, used every round'
    }
];
const $9c9beb6ffe131583$var$AccCohortHeroSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "For your cohort companies"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-cohort-hero",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "lp-acc-h2",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "60",
                                    children: "The pitch gets you the meeting. The Diligence Pack gets you the money."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "lp-acc-sub",
                                    "data-lp-reveal": true,
                                    "data-lp-delay": "120",
                                    children: "You've already beaten the odds \u2014 fewer than 1 in 100 companies that approach investors get funded, and your accelerator changed those odds by getting you in the room. What happens next depends on how fast you can answer the questions that come after the pitch. Diligentsia turns investment readiness from a 3-week scramble into an exercise in value creation that can take as little as three days."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-pullquote",
                            "data-lp-reveal": true,
                            "data-lp-delay": "160",
                            children: '"The fastest-closing companies are typically the best-prepared ones."'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-cert-row",
                    children: $9c9beb6ffe131583$var$CERTS.map((c, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-acc-cert is-${c.tone}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "cert-name",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "cert-dot"
                                        }),
                                        c.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: c.body
                                })
                            ]
                        }, c.name))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-steps5",
                    children: $9c9beb6ffe131583$var$STEPS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-step5",
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 70,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "s5num",
                                    children: s.n
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: s.body
                                })
                            ]
                        }, s.n))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "lp-acc-stat-row is-three",
                    children: $9c9beb6ffe131583$var$STATS.map((s, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: `lp-acc-fstat is-${s.tone}`,
                            "data-lp-reveal": true,
                            "data-lp-delay": i * 80,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "lp-acc-circle",
                                    children: s.value
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flabel",
                                    children: s.label
                                })
                            ]
                        }, s.label))
                })
            ]
        })
    });
var $9c9beb6ffe131583$export$2e2bcd8739ae039 = $9c9beb6ffe131583$var$AccCohortHeroSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1e5e4822c6f30c59$var$GROUPS = [
    {
        tone: 'lite',
        title: 'For Applicants',
        who: 'Every company who applies, before acceptance',
        cards: [
            {
                tag: 'free',
                label: 'Free',
                title: 'Investment Readiness Check',
                body: 'A 30-minute bespoke module, no commitment required.'
            },
            {
                tag: 'free',
                label: 'Free',
                title: 'Pitch Deck Analyser',
                body: 'Suggested diligence focus areas, generated automatically.'
            },
            {
                tag: 'rev',
                label: 'Reverse Diligence',
                title: 'AI CEO Stress Test',
                body: 'Reverse-engineers the business case to find its own quick wins first.'
            },
            {
                tag: 'rev',
                label: 'Reverse Diligence',
                title: 'Research Aid',
                body: 'A set of research reports on market and opportunity.'
            }
        ]
    },
    {
        tone: 'pro',
        title: 'For Accepted Cohort',
        who: 'Onboarded into the programme, building the pack',
        cards: [
            {
                tag: 'lite',
                label: 'Pro',
                title: 'Complete Diligence Pack',
                body: '~60% auto-filled by Clarence from upload or cloud ingestion.'
            },
            {
                tag: 'rev',
                label: 'Reverse Diligence',
                title: 'Corporate & Legal DD',
                body: "Use Diligentsia's tools or connect your own advisors via MCP."
            },
            {
                tag: 'rev',
                label: 'Reverse Diligence',
                title: 'Financial Model',
                body: 'Creation and reverse diligence, scored against a consistent standard.'
            },
            {
                tag: 'rev',
                label: 'Reverse Diligence',
                title: 'Technical DD',
                body: 'Full software due diligence, without extracting source code.'
            }
        ]
    }
];
const $1e5e4822c6f30c59$var$LEGEND = [
    {
        sw: 'free',
        label: 'Free'
    },
    {
        sw: 'lite',
        label: 'Included in Pro'
    },
    {
        sw: 'rev',
        label: 'Reverse diligence'
    }
];
const $1e5e4822c6f30c59$var$AccCohortModulesSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec lp-acc-sec--lavender",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "The platform, module by module"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "Every module built for you, from application to funding."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "lp-acc-sub",
                    "data-lp-reveal": true,
                    "data-lp-delay": "120",
                    children: "Free triage while you apply. Reverse-diligence tools once you're accepted \u2014 so by demo day, nothing in your data room is a surprise, even to you."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-modules",
                    "data-lp-reveal": true,
                    "data-lp-delay": "160",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-mod-legend",
                            children: $1e5e4822c6f30c59$var$LEGEND.map((l)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "lg-item",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `lg-swatch is-${l.sw}`
                                        }),
                                        l.label
                                    ]
                                }, l.label))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-acc-mod-groups is-double",
                            children: $1e5e4822c6f30c59$var$GROUPS.map((g)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `lp-acc-mod-group is-${g.tone}`,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-acc-mod-group-head",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: g.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "lp-acc-mod-who",
                                            children: g.who
                                        }),
                                        g.cards.map((c)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "lp-acc-mod-card",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: `lp-acc-mod-tag is-${c.tag}`,
                                                        children: c.label
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                        children: c.title
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        children: c.body
                                                    })
                                                ]
                                            }, c.title))
                                    ]
                                }, g.title))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-mod-timeline",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "Weeks, unprepared"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "arrow-long",
                                    children: "\u2192"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pill",
                                    children: "Days, with a certified pack"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $1e5e4822c6f30c59$export$2e2bcd8739ae039 = $1e5e4822c6f30c59$var$AccCohortModulesSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $61acfbe5022ed2c4$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $61acfbe5022ed2c4$var$AccCohortPricingSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lp-acc-wrap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "lp-acc-kicker",
                    "data-lp-reveal": true,
                    children: "Pricing for your company"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "lp-acc-h2",
                    "data-lp-reveal": true,
                    "data-lp-delay": "60",
                    children: "Fair for the cohort companies."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-acc-pricing is-two",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-price-card is-pro",
                            "data-lp-reveal": true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "who",
                                    children: "Cohort Company \u2014 Pro"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "amt",
                                    children: [
                                        "\xa31,000",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "unit",
                                            children: "/yr"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "per",
                                    children: "Less than a day of a fractional CFO's time. Bulk cohort pricing available."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Full Diligence Pack, AI pre-population"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Corporate, financial & technical reverse-diligence"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Bronze / Silver / Gold certification"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "1-click InvestorMatch, 40+ VCs"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    className: "lp-acc-btn lp-acc-btn--white",
                                    href: $61acfbe5022ed2c4$var$KOALENDAR,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Get Pro for your cohort"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "lp-acc-price-card is-lite",
                            "data-lp-reveal": true,
                            "data-lp-delay": "90",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "who",
                                    children: "Application Triage"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "amt",
                                    children: "Free"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "per",
                                    children: "For every applicant, accepted or not \u2014 no commitment required"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "20-minute structured overview"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Readiness score before you read the deck"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: "Warm handover if not accepted"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
var $61acfbe5022ed2c4$export$2e2bcd8739ae039 = $61acfbe5022ed2c4$var$AccCohortPricingSection;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $175a73693733cc89$var$KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const $175a73693733cc89$var$AccCtaSection = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("section", {
        className: "lp-acc-sec",
        id: "book",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-acc-wrap",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-acc-cta-band",
                "data-lp-reveal": true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "lp-acc-kicker is-onband",
                        children: "Let's talk"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Let's discuss a formal partnership."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Book 30 minutes to walk through the co-origination model, what first-mover advantage looks like for your programme, and what the next steps would involve."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "ctas",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "lp-acc-btn lp-acc-btn--white",
                            href: $175a73693733cc89$var$KOALENDAR,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Book a call \u2192"
                        })
                    })
                ]
            })
        })
    });
var $175a73693733cc89$export$2e2bcd8739ae039 = $175a73693733cc89$var$AccCtaSection;








const $1fee6437e8ec95a7$var$TABS = [
    {
        id: 'platform',
        label: 'Deal Management Platform'
    },
    {
        id: 'firm',
        label: 'Your Firm'
    },
    {
        id: 'cohort',
        label: 'Cohort Companies'
    }
];
// Accelerators & Venture Studios. Also the ICP hub page anchoring the /accelerator/* AEO article
// cluster — the canonical path, schema and resources list below are what make it that hub, so they
// must stay even though the marketing design does not show them.
const $1fee6437e8ec95a7$var$LandingHomeAccelerator = ()=>{
    const rootRef = (0, $acw62.useRef)(null);
    // 'Your Firm' is the design's default landing tab, not the first one in the bar.
    const [tab, setTab] = (0, $acw62.useState)('firm');
    // Passing the tab re-runs the reveal observer over the newly mounted panel.
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef, tab);
    (0, $282a70cc4e13b055$export$2e2bcd8739ae039)({
        title: "Diligentsia for Accelerators \u2014 Investment-Ready Cohorts",
        description: 'Diligentsia helps accelerators get every cohort company investment-ready: certified Diligence Packs, AI-assisted document analysis, and consistent cohort reporting.',
        canonicalPath: '/accelerator/',
        schema: (0, $1070c78a15f5f98b$export$2e2bcd8739ae039)('accelerator')
    });
    const goToCohort = ()=>{
        setTab('cohort');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page lp-acc-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7b4055b83aa856d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $194439ba83320691$export$2e2bcd8739ae039), {
                tabs: $1fee6437e8ec95a7$var$TABS,
                active: tab,
                onChange: setTab
            }),
            tab === 'platform' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1841db8dc3a8e13$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc4a3de35a277dec$export$2e2bcd8739ae039), {})
                ]
            }),
            tab === 'firm' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90ba9ff2614c2ef1$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d391d6b977f38c80$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b68dd51eeebdaa47$export$2e2bcd8739ae039), {
                        onSeeCohort: goToCohort
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae463d354380f20d$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c830cafe8c2f4d7$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f14087fb1395f798$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3e48d5c7f47a112$export$2e2bcd8739ae039), {})
                ]
            }),
            tab === 'cohort' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c9beb6ffe131583$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e5e4822c6f30c59$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $61acfbe5022ed2c4$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $175a73693733cc89$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88019eab2786a681$export$2e2bcd8739ae039), {
                icpSlug: "accelerator",
                heading: "Accelerator resources"
            })
        ]
    });
};
var $1fee6437e8ec95a7$export$2e2bcd8739ae039 = $1fee6437e8ec95a7$var$LandingHomeAccelerator;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





/**
 * AEO article page — hub-and-spoke spoke. One focused question per URL at /[icpSlug]/[slug].
 * Renders H1 question, direct-answer body, People-also-ask, FAQ section (required for FAQPage
 * schema), contextual hub link CTA, and sibling-article links for the cluster.
 */ const $62ce930ac0a2a41f$var$AeoArticlePage = ({ icpSlug: icpSlug, slugOverride: slugOverride })=>{
    const params = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const articleSlug = slugOverride || params['articleSlug'];
    const article = (0, $7393559700759e6c$export$62668476d728a9c9)(icpSlug, articleSlug);
    const hub = (0, $7393559700759e6c$export$aa103e2c51dcf48a)[icpSlug];
    const rootRef = (0, $acw62.useRef)(null);
    (0, $560d16798825a58a$export$145a783b8793b02)(rootRef);
    (0, $acw62.useEffect)(()=>{
        window.scrollTo({
            top: 0
        });
    }, [
        icpSlug,
        articleSlug
    ]);
    (0, $282a70cc4e13b055$export$2e2bcd8739ae039)({
        title: article ? article['title'] : 'Article not found',
        description: article ? article['metaDescription'] : '',
        canonicalPath: article ? `/${article['icpSlug']}/${article['slug']}/` : undefined,
        schema: article ? article['schema'] : []
    });
    if (!article || !hub) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "lp-page",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
            className: "lp-aeo-article",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-aeo-inner",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "lp-h1",
                        children: "Article not found"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "lp-lead",
                        children: [
                            "This article does not exist. Browse our ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/resources",
                                children: "resources"
                            }),
                            " instead."
                        ]
                    })
                ]
            })
        })
    });
    const siblings = (0, $7393559700759e6c$export$d83e8ce00c129c02)(icpSlug).filter((a)=>a['slug'] !== article['slug']);
    // Rough read time from the body text (same 200wpm heuristic the blog pages use)
    const readMins = Math.max(1, Math.round(article['bodyHtml'].replace(/<[^>]+>/g, ' ').split(/\s+/).filter(Boolean).length / 200));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lp-page",
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                className: "lp-article-hero",
                style: {
                    backgroundImage: `url(${(0, $d8512033fd45e289$export$6bf64eb9217fe938)(article['slug'], article['image'])})`
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "overlay"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/resources",
                                className: "back",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                                            points: "15 18 9 12 15 6"
                                        })
                                    }),
                                    "Back to Resources"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "tags",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: article['category']
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: article['title']
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "meta",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "author",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "avatar",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "white",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                                            cx: "12",
                                                            cy: "7",
                                                            r: "4"
                                                        })
                                                    ]
                                                })
                                            }),
                                            "Diligentsia"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "sep",
                                        children: "\xb7"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            "Last updated ",
                                            article['lastUpdated']
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "sep",
                                        children: "\xb7"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            readMins,
                                            " min read"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("article", {
                className: "lp-aeo-article lp-aeo-article--with-hero",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lp-aeo-inner",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                            className: "lp-aeo-breadcrumb",
                            "aria-label": "Breadcrumb",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: hub['hubPath'],
                                    children: hub['name']
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: "/"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "lp-aeo-crumb-current",
                                    children: article['title']
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "lp-aeo-meta",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                                children: article['metaDescription']
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "lp-aeo-body",
                            dangerouslySetInnerHTML: {
                                __html: article['bodyHtml']
                            }
                        }),
                        article['peopleAlsoAsk'] && article['peopleAlsoAsk'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "lp-aeo-faq",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: "People also ask"
                                }),
                                article['peopleAlsoAsk'].map((qa, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "lp-aeo-faq-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: qa['q']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: qa['a']
                                            })
                                        ]
                                    }, `paa-${i}`))
                            ]
                        }),
                        article['faqs'] && article['faqs'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "lp-aeo-faq",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: "Frequently asked questions"
                                }),
                                article['faqs'].map((qa, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "lp-aeo-faq-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                children: qa['q']
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                children: qa['a']
                                            })
                                        ]
                                    }, `faq-${i}`))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "lp-aeo-cta",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: "Get investment-ready with Diligentsia"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "Build a certified, evidence-linked Diligence Pack with AI assistance \u2014 from \xa31,000/year. Learn more about ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: hub['hubPath'],
                                            children: hub['anchorText']
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    className: "lp-btn lp-btn--primary",
                                    to: "/register",
                                    children: "Get started free"
                                })
                            ]
                        }),
                        siblings.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            className: "lp-aeo-related",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: "Related articles"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                                    children: siblings.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: `/${s['icpSlug']}/${s['slug']}`,
                                                children: s['title']
                                            })
                                        }, s['slug']))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "lp-aeo-published",
                            children: [
                                "Published by Diligentsia \xb7 diligentsia.co.uk \xb7 Last updated ",
                                article['lastUpdated']
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $62ce930ac0a2a41f$export$2e2bcd8739ae039 = $62ce930ac0a2a41f$var$AeoArticlePage;



parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $1710999fd8a821f2$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
Object.defineProperty($1710999fd8a821f2$exports, "__esModule", {
    value: true
});
$1710999fd8a821f2$exports.default = void 0;

var $1710999fd8a821f2$var$_createSvgIcon = $1jnue((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1710999fd8a821f2$var$_default = $1710999fd8a821f2$exports.default = (0, $1710999fd8a821f2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');




const $78e5711177513786$var$PaymentSuccess = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const query = new URLSearchParams(location.search);
    const type = query.get("type");
    const sessionId = query.get("session_id");
    (0, $acw62.useEffect)(()=>{
        if (type !== "temp-module" || !sessionId) return;
        (async ()=>{
            try {
                await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/modules/complete-temp-module-purchase", {
                    sessionId: sessionId
                });
            } catch (e) {
                console.error("complete-temp-module-purchase:", e);
            }
        })();
    }, [
        type,
        sessionId
    ]);
    let message = "You have successfully completed the payment!";
    if (type === "upgrade") message = "You have successfully upgraded the subscription.";
    else if (type === "module" || type === "temp-module") message = "You have successfully purchased an additional Diligentsia module.";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic fdc mih80vh p2rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc aic g1rem bg-white p2rem br8 sh1 w100% max-w500px tac",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "fs2rem fw600 c15",
                    children: "\uD83C\uDF89 Payment Successful!"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fs1rem c15",
                    children: message
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    onClick: ()=>navigate(user && user['role'] === "Advisor" ? "/advisor-dashboard" : user && user['role'] === "Investor" ? "/investor-dashboard" : user && user['role'] === "Admin" ? "/admin" : "/dashboard"),
                    prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1710999fd8a821f2$exports))), {
                        style: {
                            fontSize: "1.2rem"
                        }
                    }),
                    customClassName: "df mt2rem",
                    btnType: "warning",
                    text: "Go to Dashboard"
                })
            ]
        })
    });
};
var $78e5711177513786$export$2e2bcd8739ae039 = $78e5711177513786$var$PaymentSuccess;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $96a2936a1b048091$var$PaymentCancel = ()=>{
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state?.user);
    const query = new URLSearchParams(location.search);
    const type = query.get("type");
    let message = "Your payment was cancelled.";
    if (type === "upgrade") message = "You have cancelled the subscription upgrade process.";
    else if (type === "module") message = "You have cancelled the purchase of the additional Diligentsia module.";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "df jcc aic fdc mih80vh p2rem",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "df fdc aic g1rem bg1 p2rem br8 sh1 w100% max-w500px tac",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "fs2rem fw600 c15",
                    children: "\u274C Payment Cancelled"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "fs1rem c15",
                    children: message
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                    onClick: ()=>navigate(!user || !user['role'] ? "/login" : user['role'].toLowerCase() === 'investor' ? "/investor-dashboard" : user['role'].toLowerCase() === 'advisor' ? "/advisor-dashboard" : "/dashboard"),
                    prefixIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1710999fd8a821f2$exports))), {
                        style: {
                            fontSize: "1.2rem"
                        }
                    }),
                    customClassName: "df mt2rem",
                    btnType: "warning",
                    text: "Go to Dashboard"
                })
            ]
        })
    });
};
var $96a2936a1b048091$export$2e2bcd8739ae039 = $96a2936a1b048091$var$PaymentCancel;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






const $5602480d08610dfa$var$IconMail = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "22,6 12,12 2,6"
            })
        ]
    });
const $5602480d08610dfa$var$ForgotPassword = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const [forgotPasswordEmail, setForgotPasswordEmail] = (0, $acw62.useState)('');
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const resetStates = ()=>{
        setForgotPasswordEmail('');
        setIsLoading(false);
    };
    const handleResetPassword = async ()=>{
        if (!forgotPasswordEmail || forgotPasswordEmail == '') return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Please provide email');
        setIsLoading(true);
        let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/forgotPassword', {
            email: forgotPasswordEmail
        });
        if (response && response['code'] == 200) {
            resetStates();
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: "resendForgotPasswordEmail",
                historyData: {
                    email: forgotPasswordEmail
                }
            }));
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
        }
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "lp-page",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lp-auth-main",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-auth-glow lp-auth-glow--tr",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "lp-auth-glow lp-auth-glow--bl",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "lp-auth-wrap lp-auth-wrap--narrow",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "lp-auth-card",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "lp-auth-title",
                                        children: "Forgotten"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                        className: "lp-auth-title pink",
                                        children: "password?"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "lp-auth-desc",
                                        children: "Enter the email address linked to your account and we'll send you a link to reset your password."
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "lp-auth-field lp-auth-field--icon-wide",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5602480d08610dfa$var$IconMail, {})
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "forgotPasswordEmail",
                                                type: "email",
                                                value: forgotPasswordEmail || '',
                                                placeholder: "Email",
                                                onChange: (e)=>setForgotPasswordEmail(e['target']['value'])
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "lp-auth-actions",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "lp-auth-submit",
                                            onClick: ()=>handleResetPassword(),
                                            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                                className: "fa fa-spinner fa-spin"
                                            }) : 'Reset Password'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "lp-auth-foot",
                                        children: [
                                            "Don't have an account? ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                                children: "Create new account"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "lp-auth-trust",
                                children: "Trusted by 50+ investors, advisors & companies"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $5602480d08610dfa$export$2e2bcd8739ae039 = $5602480d08610dfa$var$ForgotPassword;



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");














function $0bbfe88e25eb340a$export$2e2bcd8739ae039() {
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const sectionRefs = (0, $acw62.useRef)([]);
    const { id: companyId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    const company = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company?.selectedCompany || {});
    let [report, setReport] = (0, $acw62.useState)({});
    let [reportType, setReportType] = (0, $acw62.useState)('');
    let [isShowReport, setIsShowReport] = (0, $acw62.useState)(false);
    let [isDirectorsReport, setIsDirectorsReport] = (0, $acw62.useState)(false);
    let [isLoader, setIsLoader] = (0, $acw62.useState)({
        show: false,
        message: 'Loading...'
    });
    let [aiEnhanced, setAiEnchaned] = (0, $acw62.useState)(false);
    let [directors, setDirectors] = (0, $acw62.useState)(company?.['directors'] || []);
    (0, $acw62.useEffect)(()=>{
        (async ()=>{
            // Handle new shareCode format
            if (location.pathname.includes('shareCode')) {
                const pathParts = location.pathname.split('/');
                const codeIndex = pathParts.indexOf('shareCode');
                const companyIndex = pathParts.indexOf('diligence-pack');
                if (codeIndex !== -1 && companyIndex !== -1) {
                    const code = pathParts[codeIndex + 1];
                    const companyId = pathParts[companyIndex + 1];
                    // Call API to validate code and get permissions
                    const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/external-permission/${companyId}/${code}/company`, 'return-response');
                    if (response?.code === 200) {
                        // Set user and company in Redux
                        dispatch((0, $3e06475c4dbec09d$export$e3ac7a5d19605772)(response.body.user));
                        // Add permissions to company object before storing in Redux
                        const companyWithPermissions = {
                            ...response.body.company,
                            externalUserPermissions: response.body.permissions
                        };
                        dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(companyWithPermissions));
                        return;
                    } else {
                        (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response?.message || 'Invalid or expired share link');
                        setTimeout(()=>navigate('/'), 3000);
                    }
                }
            }
        })();
    }, [
        location.pathname,
        navigate,
        companyId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (company?.['directors']) setDirectors(company['directors']);
    }, [
        company
    ]);
    (0, $acw62.useEffect)(()=>{
        if (report?.['type'] && !isShowReport && !isDirectorsReport) {
            setReportType('report');
            getModule(report?.['type']);
        }
        if (report?.['htmlReport'] && report?.['reportType'] && !isShowReport) {
            setReportType('researchaid');
            navigate(`#${report['_id']}?${report['reportType']}-researchaid`);
            setIsShowReport(true);
            // Fetch Papermill PDF for ResearchAid reports
            if (isResearchAidReportType(report['reportType']) && !report.reportUrl) getResearchAidReport(report);
        }
    }, [
        report
    ]);
    (0, $acw62.useEffect)(()=>{
        if (reportType === 'report' && report?.['type'] && !isShowReport) {
            const moduleName = report['type'];
            const moduleHasSections = company?.modules?.[moduleName]?.sections?.length > 0;
            if (moduleHasSections) setIsShowReport(true);
        }
    }, [
        company.modules,
        report,
        reportType,
        isShowReport
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDirectorsReport) {
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'showDirectors'
            }));
            setIsDirectorsReport(false);
        }
    }, [
        isDirectorsReport
    ]);
    // Papermill modules - use getModuleReport API
    const PAPERMILL_MODULES = [
        'Investment Readiness',
        'repository',
        'warranty-disclosure',
        'directors-questionnaire'
    ];
    const isPapermillModule = (moduleType)=>{
        return PAPERMILL_MODULES.includes(moduleType) || moduleType?.startsWith('business-audit-') || moduleType?.startsWith('directors-questionnaire');
    };
    // ResearchAid report types - use getModuleReport API with reportType
    const RESEARCHAID_REPORT_TYPES = [
        'marketReport',
        'competitorReport',
        'routeToMarketReport',
        'TCAR3',
        'swotAnalysis',
        'insuranceGapAnalysis'
    ];
    const isResearchAidReportType = (reportType)=>RESEARCHAID_REPORT_TYPES.includes(reportType);
    // Fetch ResearchAid report PDF
    const getResearchAidReport = async (reportData)=>{
        try {
            if (!reportData?._id || !reportData?.reportType) return;
            setIsLoader({
                show: true,
                message: 'Loading Report PDF...'
            });
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getModuleReport`, {
                companyId: companyId,
                reportType: reportData.reportType,
                reportId: reportData._id
            });
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
            if (response?.code === 200 && response?.body?.reportUrl) setReport((prev)=>({
                    ...prev,
                    reportUrl: response.body.reportUrl
                }));
        } catch (err) {
            console.error("Error fetching ResearchAid report PDF:", err);
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
        }
    };
    const getModule = async (moduleName)=>{
        try {
            if (!moduleName) return;
            // Use getModuleReport for Papermill modules
            if (isPapermillModule(moduleName)) {
                setIsLoader({
                    show: true,
                    message: 'Loading Report...'
                });
                let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getModuleReport`, {
                    companyId: companyId,
                    moduleName: moduleName
                });
                setIsLoader({
                    show: false,
                    message: 'Loading...'
                });
                if (response?.code === 200 && response?.body) {
                    const finalUpdatedData = {
                        ...company,
                        modules: {
                            ...company['modules'],
                            [moduleName]: {
                                ...company['modules']?.[moduleName],
                                reportUrl: response.body.reportUrl,
                                reportGeneratedAt: response.body.reportGeneratedAt,
                                sections: response.body.sections || [],
                                stats: response.body.stats || {},
                                type: response.body.type || moduleName
                            }
                        },
                        from: "papermill"
                    };
                    await dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(finalUpdatedData));
                }
                return;
            } else if (!company['modules']?.[moduleName]?.['sections']) {
                setIsLoader({
                    show: true,
                    message: 'Loading...'
                });
                let obj = {
                    companyId: companyId,
                    moduleName: moduleName
                };
                let response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/company/getModule`, obj);
                setIsLoader({
                    show: false,
                    message: 'Loading...'
                });
                if (response['code'] != 200) return;
                if (response && response?.body) {
                    const finalUpdatedData = {
                        ...company,
                        modules: {
                            ...company['modules'],
                            ...response['body']
                        },
                        from: "getModule"
                    };
                    await dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(finalUpdatedData));
                }
            }
        } catch (err) {
            setIsShowReport(false);
            console.error("Error fetching module data:", err);
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("An error occurred while getting the module");
        } finally{
            setIsLoader({
                show: false,
                message: 'Loading...'
            });
        }
    };
    const sortSections = (a, b)=>{
        let valueA = (a?.sectionNo || a?.no).match(/\d+/g);
        let valueB = (b?.sectionNo || b?.no).match(/\d+/g);
        return valueA - valueB;
    };
    const sanitiseTab = (t)=>decodeURIComponent(t).replace(/(-sync)?-report$/, "");
    const showPopupPercent = (percent, type)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: `${percent > 67 ? type === 'Risk' ? 'c9' : 'c34' : percent > 33 ? 'c39' : percent > 0 ? type === 'Risk' ? 'c34' : 'c9' : 'c28'}`,
            children: [
                percent,
                "% ",
                type
            ]
        });
    };
    const handleDirectorReportView = async (director)=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
        const moduleName = `directors-questionnaire_${director['_id']}`;
        setReport({
            type: moduleName
        });
        setReportType('report');
        await getModule(moduleName);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                class: "py4rem",
                children: [
                    isLoader['show'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                        message: isLoader['message']
                    }),
                    !company?.['_id'] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6577913b75629c54$export$2e2bcd8739ae039), {
                        message: "Loading Diligence Pack..."
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            isShowReport && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "w100 df jce",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    onClick: ()=>{
                                        setIsShowReport(false);
                                        setReport({});
                                        setReportType('');
                                        if (window.location.hash) window.history.replaceState(null, '', location.pathname);
                                    },
                                    className: "cp df aic jcc bg4 c1 fw400 fs1rem br30px px2rem py0-5rem mr7rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            class: "fa fa-arrow-circle-left c1 mr0-5rem"
                                        }),
                                        " Back to Diligence"
                                    ]
                                })
                            }),
                            company?.['_id'] && Object.keys(company).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: Object.keys(report).length > 0 && isShowReport ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "td250 px4rem bg1 py2rem w100 df",
                                    children: reportType == 'researchaid' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: report.reportUrl ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "w100 df jcc",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9310f9c2b7964d10$export$2e2bcd8739ae039), {
                                                src: report.reportUrl,
                                                className: "w90 br10px",
                                                style: {
                                                    height: '100vh'
                                                },
                                                title: "Papermill Report PDF"
                                            })
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "w80 mr1rem dg bg5 py2rem",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91ba6c0aac080db6$export$2e2bcd8739ae039), {
                                                        company: company,
                                                        tab: `${report['reportType']}-researchaid`
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $013ff032d592f1b0$export$2e2bcd8739ae039), {
                                                    company: company,
                                                    tab: `${report['reportType']}-researchaid`
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "w80 mr3rem dg bg5 py2rem",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33a9b39b88c46765$export$2e2bcd8739ae039), {
                                                    sectionRefs: sectionRefs,
                                                    user: user,
                                                    company: company,
                                                    module: company.modules[report['type']],
                                                    tab: `${report['type']}-report`,
                                                    sortSections: sortSections,
                                                    aiEnhanced: aiEnhanced,
                                                    setAiEnchaned: setAiEnchaned,
                                                    moduleCertification: company?.['moduleCertification'][report?.['type'].includes('business-audit') ? 'business-audit-' + company['testType'] : report?.['type']]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $73a5f3cb80d8115d$export$2e2bcd8739ae039), {
                                                sectionRefs: sectionRefs,
                                                user: user,
                                                company: company,
                                                module: company.modules[report['type']],
                                                tab: `${report['type']}-report`,
                                                sortSections: sortSections,
                                                moduleCertification: company?.['moduleCertification'][report?.['type'].includes('business-audit') ? 'business-audit-' + company['testType'] : report?.['type']],
                                                sanitiseTab: sanitiseTab,
                                                setIsLoader: setIsLoader,
                                                setCompany: ()=>{},
                                                setTab: ()=>{},
                                                isExternalPage: true
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    class: "container",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86727a4e8cc19e92$export$2e2bcd8739ae039), {
                                        company: company,
                                        setReport: setReport,
                                        setIsDirectorsReport: setIsDirectorsReport,
                                        isExternal: true
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'showDirectors',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop showDirectors td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "pr maw800px inner-showDirectors pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: 'relative',
                                    top: '4px'
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "top-header",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "text-gradient fw600 tac mb1rem",
                                children: "LIST OF QUESTIONNAIRES"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "table-area-showDirectors",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                                    id: "table",
                                    className: "table-showDirectors",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            className: "ps t0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: "Designation"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: "Progress"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: directors && directors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: directors.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: `${item['headShot'] && 'df aic '} c6 fw500 ttc`,
                                                                children: [
                                                                    item['headShot'] && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        src: item['headShot']['location'],
                                                                        className: "w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem"
                                                                    }),
                                                                    item['name']
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                className: "c6 fw500 ttc",
                                                                children: item['designation']
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                className: "p1rem c6 fw500 ttc",
                                                                children: [
                                                                    "(",
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['completionPercent'] || 0, 'Completeness'),
                                                                    " / ",
                                                                    showPopupPercent(company?.['modules']?.[`directors-questionnaire_${item['_id']}`]?.['stats']?.['riskPercent'] || 0, 'Risk'),
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                                    onClick: ()=>handleDirectorReportView(item),
                                                                    className: "cp bg4 bg3-hover c1 tac fs0-75rem fw500 px1rem py0-5rem br5px",
                                                                    children: "View"
                                                                })
                                                            })
                                                        ]
                                                    }, idx))
                                            })
                                        })
                                    ]
                                }),
                                directors && directors.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tac py1rem",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "text-gradient fw600",
                                        children: "No Directors by this Company"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "logo-modal",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        className: "h2rem",
                                        src: (parcelRequire("aR1CT")),
                                        alt: "TODO"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $68e175927b7464d6$exports = {};
$68e175927b7464d6$exports = new URL("1.8d2ccbcd.png", import.meta.url).toString();


var $06f25fb35bb93f74$exports = {};
$06f25fb35bb93f74$exports = new URL("1.1.bf7cc66c.png", import.meta.url).toString();


var $e8984d21b4ceb9ed$exports = {};
$e8984d21b4ceb9ed$exports = new URL("2.8956b714.png", import.meta.url).toString();


var $9f4a44f067c30888$exports = {};
$9f4a44f067c30888$exports = new URL("2.1.a56b091a.png", import.meta.url).toString();


var $4e4e344f02859944$exports = {};
$4e4e344f02859944$exports = new URL("3.e1e1a162.png", import.meta.url).toString();


var $38b9f6dcecfd5483$exports = {};
$38b9f6dcecfd5483$exports = new URL("3.1.bdd81098.png", import.meta.url).toString();


var $c075303d8a38672e$exports = {};
$c075303d8a38672e$exports = new URL("4.b0eefce6.png", import.meta.url).toString();


var $52235b8205b4a3ec$exports = {};
$52235b8205b4a3ec$exports = new URL("4.1.77bc405f.png", import.meta.url).toString();


var $015790a0054aa1ee$exports = {};
$015790a0054aa1ee$exports = new URL("5.0eae77b5.png", import.meta.url).toString();


var $d90ddae74ee517d2$exports = {};
$d90ddae74ee517d2$exports = new URL("6.ff03b220.png", import.meta.url).toString();


var $3841008c67a2b62b$exports = {};
$3841008c67a2b62b$exports = new URL("6.1.b8ec2aff.png", import.meta.url).toString();


var $0c280a576e483a41$exports = {};
$0c280a576e483a41$exports = new URL("7.3f97efe8.png", import.meta.url).toString();


const $007b001e77f39b29$var$ImageData = [
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($68e175927b7464d6$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($06f25fb35bb93f74$exports))),
        subImgHeight: '307px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($e8984d21b4ceb9ed$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($9f4a44f067c30888$exports))),
        subImgHeight: '217px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($4e4e344f02859944$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($38b9f6dcecfd5483$exports)))
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($c075303d8a38672e$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($52235b8205b4a3ec$exports)))
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($015790a0054aa1ee$exports)))
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($d90ddae74ee517d2$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($3841008c67a2b62b$exports))),
        subImgHeight: '266px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($0c280a576e483a41$exports)))
    }
];
const $007b001e77f39b29$var$useIsMobile = ()=>{
    if (typeof window !== "undefined") return window.innerWidth <= 768;
    return false;
};



const $007b001e77f39b29$var$InvestmentReadyJourney = ()=>{
    const [hoveredIndex, setHoveredIndex] = (0, $acw62.useState)(null);
    const isMobile = $007b001e77f39b29$var$useIsMobile();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                background: '#f8fafc',
                minHeight: '100vh'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        margin: '0 auto',
                        padding: isMobile ? '1rem' : '2rem 80px 0'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb2rem",
                            children: "Investment Ready"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fw600 fs2rem mb0-5rem",
                            children: "Your investment journey with Diligentsia to funding"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb2rem fs18px font-poppins",
                            children: "Qualified, investment-ready applications with self-diligence pack to matched investors with 1-click introductions. Quicker. More interest. More certainty."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 h100",
                    style: {
                        backgroundImage: `url(${(parcelRequire("55qLI"))})`,
                        backgroundSize: '100%',
                        backgroundRepeat: 'no-repeat'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aifs jcc container pr",
                        style: {
                            background: `url(${(parcelRequire("ewrEr"))})`,
                            backgroundSize: isMobile ? "100% 100%" : "contain",
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            paddingBottom: isMobile ? '190px' : '250px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "py2rem px1rem dg ",
                            style: {
                                maxWidth: isMobile ? '100%' : '60%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("5fCxK")),
                                    className: "pa",
                                    style: {
                                        top: '10px',
                                        position: isMobile ? 'relative' : 'absolute',
                                        right: isMobile ? '0px' : '40px',
                                        maxWidth: isMobile ? '270px' : '380px'
                                    },
                                    alt: "didYouKnow"
                                }),
                                $007b001e77f39b29$var$ImageData.map((imgData, index)=>{
                                    const hasSubImage = !!imgData?.subImg;
                                    const isRight = index % 2 !== 0;
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "my0-5rem pr",
                                        style: {
                                            position: 'relative',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: isRight ? 'flex-end' : 'flex-start'
                                        },
                                        onMouseEnter: ()=>!isMobile && setHoveredIndex(index),
                                        onMouseLeave: ()=>!isMobile && setHoveredIndex(null),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                position: 'relative',
                                                height: hasSubImage && imgData.subImgHeight ? imgData.subImgHeight || 'auto' : 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: imgData?.main,
                                                    alt: `image${index + 1}`,
                                                    style: {
                                                        maxWidth: isMobile ? '300px' : '420px',
                                                        position: 'relative',
                                                        left: isMobile ? "0" : isRight ? '50%' : '-50%',
                                                        transition: 'transform 0.3s ease'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                                                    children: !isMobile && hoveredIndex === index && hasSubImage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).img, {
                                                        src: imgData.subImg,
                                                        alt: `subimage${index + 1}`,
                                                        initial: {
                                                            opacity: 0,
                                                            x: isMobile ? 0 : isRight ? 40 : -40
                                                        },
                                                        animate: {
                                                            opacity: 1,
                                                            x: 0
                                                        },
                                                        exit: {
                                                            opacity: 0,
                                                            x: isMobile ? 0 : isRight ? 20 : -20
                                                        },
                                                        transition: {
                                                            duration: 0.3
                                                        },
                                                        style: {
                                                            position: 'absolute',
                                                            top: '0%',
                                                            [isRight ? 'left' : 'right']: isMobile ? 0 : '150%',
                                                            transform: 'translateY(-50%)',
                                                            marginLeft: isMobile ? '' : isRight ? '1rem' : '',
                                                            marginRight: isMobile ? '' : !isRight ? '1rem' : '',
                                                            borderRadius: '10px',
                                                            zIndex: 10,
                                                            height: hasSubImage && imgData.subImgHeight ? imgData.subImgHeight || 'auto' : 'auto'
                                                        }
                                                    }, "subImg")
                                                })
                                            ]
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    className: "bg4 fw700 fs0-75rem c1 py0-5rem px0-5rem df jcc aic br45px cp mt1rem mb10rem",
                                    style: {
                                        lineHeight: '25.5px',
                                        width: isMobile ? '300px' : '400px',
                                        height: isMobile ? '50px' : '70px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcc fdc aic w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fs1-25rem",
                                                children: "Try for FREE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fw400 fs14px c21",
                                                style: {
                                                    lineHeight: '20px',
                                                    fontStyle: 'italic'
                                                },
                                                children: "No credit card required"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $007b001e77f39b29$export$2e2bcd8739ae039 = $007b001e77f39b29$var$InvestmentReadyJourney;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $ceefcba60bcfee89$exports = {};
$ceefcba60bcfee89$exports = new URL("1.c711818e.png", import.meta.url).toString();


var $2114c7b0d483af68$exports = {};
$2114c7b0d483af68$exports = new URL("1.1.9a25f7b7.png", import.meta.url).toString();


var $8aee89b5525603d5$exports = {};
$8aee89b5525603d5$exports = new URL("2.a5ad09de.png", import.meta.url).toString();


var $f3c7a66bffd28710$exports = {};
$f3c7a66bffd28710$exports = new URL("2.1.875c640c.png", import.meta.url).toString();


var $f1366333fb11badc$exports = {};
$f1366333fb11badc$exports = new URL("3.6a9d29df.png", import.meta.url).toString();


var $84cb58c2994ae1e8$exports = {};
$84cb58c2994ae1e8$exports = new URL("3.1.5887c6ab.png", import.meta.url).toString();


var $f6bc26e871292638$exports = {};
$f6bc26e871292638$exports = new URL("4.0738b820.png", import.meta.url).toString();


var $defea5b97ada19ad$exports = {};
$defea5b97ada19ad$exports = new URL("4.1.d41ac0cf.png", import.meta.url).toString();


var $841bb3920f517b33$exports = {};
$841bb3920f517b33$exports = new URL("5.ae51b701.png", import.meta.url).toString();


const $2195d1d77cec74e8$var$ImageData = [
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($ceefcba60bcfee89$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($2114c7b0d483af68$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($8aee89b5525603d5$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($f3c7a66bffd28710$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($f1366333fb11badc$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($84cb58c2994ae1e8$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($f6bc26e871292638$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($defea5b97ada19ad$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($841bb3920f517b33$exports)))
    }
];
const $2195d1d77cec74e8$var$useIsMobile = ()=>{
    if (typeof window !== "undefined") return window.innerWidth <= 768;
    return false;
};


const $2195d1d77cec74e8$var$GrowthReadyJourney = ()=>{
    const [hoveredIndex, setHoveredIndex] = (0, $acw62.useState)(null);
    const isMobile = $2195d1d77cec74e8$var$useIsMobile();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                background: '#f8fafc',
                minHeight: '100vh'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "container",
                    style: {
                        margin: '0 auto',
                        padding: '2rem 0rem 0 0rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb2rem",
                            children: "Growth Ready"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fw600 fs2rem mb0-5rem",
                            children: "Your journey with Diligentsia to growth"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb2rem fs18px font-poppins",
                            children: "Self-improvement modules to turboboost your growth - or we can introduce an advisor to help you"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 h100",
                    style: {
                        backgroundImage: `url(${(parcelRequire("55qLI"))})`,
                        backgroundSize: '100%',
                        backgroundRepeat: 'no-repeat'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aifs jcc container",
                        style: {
                            background: `url(${(parcelRequire("glVqS"))})`,
                            backgroundSize: isMobile ? "100% 100%" : "contain",
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            paddingBottom: isMobile ? '190px' : '250px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "py2rem px1rem dg ",
                            style: {
                                maxWidth: isMobile ? '100%' : '60%'
                            },
                            children: [
                                $2195d1d77cec74e8$var$ImageData.map((imgData, index)=>{
                                    const hasSubImage = !!imgData?.subImg;
                                    const isRight = index % 2 !== 0;
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "my0-5rem pr",
                                        style: {
                                            position: 'relative',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: isRight ? 'flex-end' : 'flex-start'
                                        },
                                        onMouseEnter: ()=>!isMobile && setHoveredIndex(index),
                                        onMouseLeave: ()=>!isMobile && setHoveredIndex(null),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                position: 'relative',
                                                height: hasSubImage && imgData.subImgHeight ? imgData.subImgHeight || 'auto' : 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: imgData?.main,
                                                    alt: `image${index + 1}`,
                                                    style: {
                                                        maxWidth: isMobile ? '300px' : '420px',
                                                        position: 'relative',
                                                        left: isMobile ? "0" : isRight ? '50%' : '-50%',
                                                        transition: 'transform 0.3s ease'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                                                    children: !isMobile && hoveredIndex === index && hasSubImage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).img, {
                                                        src: imgData.subImg,
                                                        alt: `subimage${index + 1}`,
                                                        initial: {
                                                            opacity: 0,
                                                            x: isMobile ? 0 : isRight ? 40 : -40
                                                        },
                                                        animate: {
                                                            opacity: 1,
                                                            x: 0
                                                        },
                                                        exit: {
                                                            opacity: 0,
                                                            x: isMobile ? 0 : isRight ? 20 : -20
                                                        },
                                                        transition: {
                                                            duration: 0.3
                                                        },
                                                        style: {
                                                            position: 'absolute',
                                                            top: '0%',
                                                            [isRight ? 'left' : 'right']: isMobile ? 0 : '150%',
                                                            transform: 'translateY(-50%)',
                                                            marginLeft: isMobile ? '' : isRight ? '1rem' : '',
                                                            marginRight: isMobile ? '' : !isRight ? '1rem' : '',
                                                            height: hasSubImage && imgData.subImgHeight ? imgData.subImgHeight || 'auto' : 'auto',
                                                            borderRadius: '10px',
                                                            zIndex: 10
                                                        }
                                                    }, "subImg")
                                                })
                                            ]
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    className: "bg4 fw700 fs0-75rem c1 py0-5rem px0-5rem df jcc aic br45px cp mt8rem mb10rem",
                                    style: {
                                        lineHeight: '25.5px',
                                        width: '400px',
                                        height: '70px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcc fdc aic w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fs1-25rem",
                                                children: "Try for FREE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fw400 fs14px c21",
                                                style: {
                                                    lineHeight: '20px',
                                                    fontStyle: 'italic'
                                                },
                                                children: "No credit card required"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $2195d1d77cec74e8$export$2e2bcd8739ae039 = $2195d1d77cec74e8$var$GrowthReadyJourney;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");




var $a20b9bf2b27e0bc3$exports = {};
$a20b9bf2b27e0bc3$exports = new URL("1.b84ec870.png", import.meta.url).toString();


var $7d3b34689ac97b81$exports = {};
$7d3b34689ac97b81$exports = new URL("1.1.3ae4053b.png", import.meta.url).toString();


var $eb7433bbf2889237$exports = {};
$eb7433bbf2889237$exports = new URL("2.01a34422.png", import.meta.url).toString();


var $939d6109705c9fb1$exports = {};
$939d6109705c9fb1$exports = new URL("2.1.a022e55b.png", import.meta.url).toString();


var $3510adf4c9505684$exports = {};
$3510adf4c9505684$exports = new URL("3.1bcd3f7a.png", import.meta.url).toString();


var $b88c3e2bb55483a3$exports = {};
$b88c3e2bb55483a3$exports = new URL("3.1.77bc405f.png", import.meta.url).toString();


var $754c30e8e231bf64$exports = {};
$754c30e8e231bf64$exports = new URL("4.70884f9b.png", import.meta.url).toString();


var $1509262e66658a74$exports = {};
$1509262e66658a74$exports = new URL("4.1.460d1838.png", import.meta.url).toString();


var $2b41d07f6e5460bd$exports = {};
$2b41d07f6e5460bd$exports = new URL("5.5e549a98.png", import.meta.url).toString();


var $8b22ddc5aa10882e$exports = {};
$8b22ddc5aa10882e$exports = new URL("5.1.6e234f77.png", import.meta.url).toString();


var $b46fe6e745c35302$exports = {};
$b46fe6e745c35302$exports = new URL("6.59f0a7f5.png", import.meta.url).toString();


const $6902416b7eb7e9be$var$ImageData = [
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($a20b9bf2b27e0bc3$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($7d3b34689ac97b81$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($eb7433bbf2889237$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($939d6109705c9fb1$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($3510adf4c9505684$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($b88c3e2bb55483a3$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($754c30e8e231bf64$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($1509262e66658a74$exports))),
        subImgHeight: '260px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($2b41d07f6e5460bd$exports))),
        subImg: (0, (/*@__PURE__*/$parcel$interopDefault($8b22ddc5aa10882e$exports))),
        subImgHeight: '190px'
    },
    {
        main: (0, (/*@__PURE__*/$parcel$interopDefault($b46fe6e745c35302$exports)))
    }
];
const $6902416b7eb7e9be$var$useIsMobile = ()=>{
    if (typeof window !== "undefined") return window.innerWidth <= 768;
    return false;
};


const $6902416b7eb7e9be$var$ExitReadyJourney = ()=>{
    const [hoveredIndex, setHoveredIndex] = (0, $acw62.useState)(null);
    const isMobile = $6902416b7eb7e9be$var$useIsMobile();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                background: '#f8fafc',
                minHeight: '100vh'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "container",
                    style: {
                        margin: '0 auto',
                        padding: '2rem 0rem 0 0rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb2rem",
                            children: "Exit Ready"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "c15 fw600 fs2rem mb0-5rem",
                            children: "Your journey with Diligentsia to exit"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "c15 mb2rem fs18px font-poppins",
                            children: "Sell your business more quickly, with more certainty, at the value you deserve"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w100 h100",
                    style: {
                        backgroundImage: `url(${(parcelRequire("55qLI"))})`,
                        backgroundSize: '100%',
                        backgroundRepeat: 'no-repeat'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df aifs jcc container",
                        style: {
                            background: `url(${(parcelRequire("glVqS"))})`,
                            backgroundSize: isMobile ? "100% 100%" : "contain",
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            paddingBottom: isMobile ? '190px' : '250px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "py2rem px1rem dg ",
                            style: {
                                maxWidth: isMobile ? '100%' : '60%'
                            },
                            children: [
                                $6902416b7eb7e9be$var$ImageData.map((imgData, index)=>{
                                    const hasSubImage = !!imgData?.subImg;
                                    const isRight = index % 2 !== 0;
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "my0-5rem pr",
                                        style: {
                                            position: 'relative',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: isRight ? 'flex-end' : 'flex-start'
                                        },
                                        onMouseEnter: ()=>!isMobile && setHoveredIndex(index),
                                        onMouseLeave: ()=>!isMobile && setHoveredIndex(null),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                position: 'relative',
                                                height: hasSubImage && imgData.subImgHeight ? imgData.subImgHeight || 'auto' : 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: imgData?.main,
                                                    alt: `image${index + 1}`,
                                                    style: {
                                                        maxWidth: isMobile ? '300px' : '420px',
                                                        position: 'relative',
                                                        left: isMobile ? "0" : isRight ? '50%' : '-50%',
                                                        transition: 'transform 0.3s ease'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
                                                    children: !isMobile && hoveredIndex === index && hasSubImage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).img, {
                                                        src: imgData.subImg,
                                                        alt: `subimage${index + 1}`,
                                                        initial: {
                                                            opacity: 0,
                                                            x: isMobile ? 0 : isRight ? 40 : -40
                                                        },
                                                        animate: {
                                                            opacity: 1,
                                                            x: 0
                                                        },
                                                        exit: {
                                                            opacity: 0,
                                                            x: isMobile ? 0 : isRight ? 20 : -20
                                                        },
                                                        transition: {
                                                            duration: 0.3
                                                        },
                                                        style: {
                                                            position: 'absolute',
                                                            top: '0%',
                                                            [isRight ? 'left' : 'right']: isMobile ? 0 : '150%',
                                                            transform: 'translateY(-50%)',
                                                            marginLeft: isMobile ? '' : isRight ? '1rem' : '',
                                                            marginRight: isMobile ? '' : !isRight ? '1rem' : '',
                                                            height: hasSubImage && imgData.subImgHeight ? imgData.subImgHeight || 'auto' : 'auto',
                                                            borderRadius: '10px',
                                                            zIndex: 10
                                                        }
                                                    }, "subImg")
                                                })
                                            ]
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: $16250bd714b02a14$export$51e82cdd7353a0e1,
                                    className: "bg4 fw700 fs0-75rem c1 py0-5rem px0-5rem df jcc aic br45px cp mt8rem mb10rem",
                                    style: {
                                        lineHeight: '25.5px',
                                        width: '400px',
                                        height: '70px'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df jcc fdc aic w100",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fs1-25rem",
                                                children: "Try for FREE"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "fw400 fs14px c21",
                                                style: {
                                                    lineHeight: '20px',
                                                    fontStyle: 'italic'
                                                },
                                                children: "No credit card required"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $6902416b7eb7e9be$export$2e2bcd8739ae039 = $6902416b7eb7e9be$var$ExitReadyJourney;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");





const $7f677696145d7b59$var$ConfirmEmailChange = ()=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const userId = window.location.pathname.split('/').pop();
    const type = new URLSearchParams(window.location.search).get('type') || 'email';
    const [state, setState] = (0, $acw62.useState)({
        loading: true,
        success: false,
        error: null
    });
    const confirmEmailChange = async (userId)=>{
        try {
            setState({
                loading: true,
                success: false,
                error: null
            });
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/user/confirmEmailChange/${userId}?type=${type}`, {});
            if (response && response.code === 200) {
                setState({
                    loading: false,
                    success: true,
                    error: null
                });
                (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Email change confirmed successfully.");
                // Redirect to profile after 2 seconds
                setTimeout(()=>{
                    // navigate(PROFILE);
                    window.location.href = (0, $16250bd714b02a14$export$91c3232a793620f2);
                }, 2000);
            } else {
                const errorMsg = response?.message || "Failed to confirm email change. Please try again.";
                setState({
                    loading: false,
                    success: false,
                    error: errorMsg
                });
            }
        } catch (error) {
            console.error("Error confirming email change:", error);
            const errorMsg = "An error occurred while confirming email change.";
            setState({
                loading: false,
                success: false,
                error: errorMsg
            });
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (userId) confirmEmailChange(userId);
        else setState({
            loading: false,
            success: false,
            error: "Invalid confirmation link."
        });
    }, [
        userId
    ]);
    const LoadingDots = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
            className: "df aic jcc",
            style: {
                gap: '8px'
            },
            children: [
                0,
                1,
                2
            ].map((index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                    className: "br100",
                    style: {
                        width: '8px',
                        height: '8px',
                        backgroundColor: '#FC7785'
                    },
                    animate: {
                        scale: [
                            1,
                            1.2,
                            1
                        ],
                        opacity: [
                            0.7,
                            1,
                            0.7
                        ]
                    },
                    transition: {
                        duration: 1,
                        repeat: Infinity,
                        delay: index * 0.2
                    }
                }, index))
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mih100vh df aic jcc bg5",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container df fdc aic tac",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                    initial: {
                        opacity: 0,
                        y: 30
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    transition: {
                        duration: 0.6
                    },
                    className: "df fdc aic bg1 p3rem br25px",
                    style: {
                        maxWidth: '500px',
                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                        minHeight: '300px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                            initial: {
                                scale: 0
                            },
                            animate: {
                                scale: 1
                            },
                            transition: {
                                delay: 0.2,
                                duration: 0.5
                            },
                            className: "mb2rem",
                            children: [
                                state.loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcc br100 mb1rem",
                                    style: {
                                        width: '80px',
                                        height: '80px',
                                        backgroundColor: '#FC778520'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "40",
                                        height: "40",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        style: {
                                            color: '#FC7785'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            stroke: "currentColor",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                        })
                                    })
                                }),
                                state.success && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcc br100 mb1rem",
                                    style: {
                                        width: '80px',
                                        height: '80px',
                                        backgroundColor: '#40dda120'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "40",
                                        height: "40",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        style: {
                                            color: '#40dda1'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            stroke: "currentColor",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                    })
                                }),
                                state.error && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "df aic jcc br100 mb1rem",
                                    style: {
                                        width: '80px',
                                        height: '80px',
                                        backgroundColor: '#dd404020'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "40",
                                        height: "40",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        style: {
                                            color: '#dd4040'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            stroke: "currentColor",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df fdc aic",
                            children: [
                                state.loading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).h1, {
                                            className: "c6 fw600 fs2rem mb1rem tac",
                                            initial: {
                                                opacity: 0
                                            },
                                            animate: {
                                                opacity: 1
                                            },
                                            transition: {
                                                delay: 0.3
                                            },
                                            children: "Email Change Confirmation"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                                            className: "df fdc aic",
                                            initial: {
                                                opacity: 0
                                            },
                                            animate: {
                                                opacity: 1
                                            },
                                            transition: {
                                                delay: 0.4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    className: "c6 fs1-125rem mb2rem tac op75",
                                                    children: "Processing your email change confirmation"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)(LoadingDots, {})
                                            ]
                                        })
                                    ]
                                }),
                                state.success && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                                    initial: {
                                        opacity: 0,
                                        scale: 0.8
                                    },
                                    animate: {
                                        opacity: 1,
                                        scale: 1
                                    },
                                    transition: {
                                        duration: 0.5
                                    },
                                    className: "df fdc aic tac",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "c6 fw600 fs2rem mb1rem",
                                            children: "Success!"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c6 fs1-125rem mb2rem op75",
                                            children: "Your email change has been confirmed successfully."
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c4 fs1rem fw500",
                                            children: "Redirecting to your profile..."
                                        })
                                    ]
                                }),
                                state.error && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $a93b6401f922fd1e$export$e25e478948902b8b).div, {
                                    initial: {
                                        opacity: 0,
                                        scale: 0.8
                                    },
                                    animate: {
                                        opacity: 1,
                                        scale: 1
                                    },
                                    transition: {
                                        duration: 0.5
                                    },
                                    className: "df fdc aic tac",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                            className: "c6 fw600 fs2rem mb1rem",
                                            children: "Confirmation Failed"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "c9 fs1-125rem mb2rem tac",
                                            children: state.error
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a93b6401f922fd1e$export$e25e478948902b8b).button, {
                                            whileHover: {
                                                scale: 1.05
                                            },
                                            whileTap: {
                                                scale: 0.95
                                            },
                                            className: "px2rem py1rem c1 fw600 br25px td300 bss bw0px cp",
                                            style: {
                                                backgroundColor: '#FC7785'
                                            },
                                            onClick: ()=>window.location.reload(),
                                            children: "Try Again"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $7f677696145d7b59$export$2e2bcd8739ae039 = $7f677696145d7b59$var$ConfirmEmailChange;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");






var $ayMG0 = parcelRequire("ayMG0");

var $e17d7513b520bdfe$exports = {};
$e17d7513b520bdfe$exports = new URL("investment.48af5bb2.png", import.meta.url).toString();


var $91b4450bbfda6600$exports = {};
$91b4450bbfda6600$exports = new URL("exit.774e25f3.png", import.meta.url).toString();


var $2bf6ba9e480e2afc$exports = {};
$2bf6ba9e480e2afc$exports = new URL("growth.39f1e255.png", import.meta.url).toString();


var $8f87d093d74202f4$exports = {};
$8f87d093d74202f4$exports = new URL("advisorInvestment.566c7a3f.png", import.meta.url).toString();


var $5c4379f6054e8afe$exports = {};
$5c4379f6054e8afe$exports = new URL("advisorExit.387bee2f.png", import.meta.url).toString();


var $094685b3fbb74354$exports = {};
$094685b3fbb74354$exports = new URL("advisorGrowth.6b1d0fdc.png", import.meta.url).toString();


var $3dab7528e824298c$exports = {};
$3dab7528e824298c$exports = new URL("investorInvestment.5cfdf7a2.png", import.meta.url).toString();


var $65e3e81ebe96ea95$exports = {};
$65e3e81ebe96ea95$exports = new URL("investorExit.722d5f06.png", import.meta.url).toString();


var $c61bc4023886545e$exports = {};
$c61bc4023886545e$exports = new URL("investorGrowth.0d8693a1.png", import.meta.url).toString();


const $fdcce4a081a5f48f$var$PricingPageJourney = ({ modaldata: modaldata, userType: userType = "company" })=>{
    let image = (0, (/*@__PURE__*/$parcel$interopDefault($e17d7513b520bdfe$exports)));
    if ([
        "company",
        "user",
        'member'
    ].includes(userType?.toLowerCase()) && modaldata?.toLowerCase()?.includes("exit")) image = (0, (/*@__PURE__*/$parcel$interopDefault($91b4450bbfda6600$exports)));
    else if ([
        "company",
        "user",
        'member'
    ].includes(userType?.toLowerCase()) && modaldata?.toLowerCase()?.includes("growth")) image = (0, (/*@__PURE__*/$parcel$interopDefault($2bf6ba9e480e2afc$exports)));
    if (userType === "advisor" && modaldata?.toLowerCase()?.includes("investment")) image = (0, (/*@__PURE__*/$parcel$interopDefault($8f87d093d74202f4$exports)));
    if (userType === "advisor" && modaldata?.toLowerCase()?.includes("exit")) image = (0, (/*@__PURE__*/$parcel$interopDefault($5c4379f6054e8afe$exports)));
    else if (userType === "advisor" && modaldata?.toLowerCase()?.includes("growth")) image = (0, (/*@__PURE__*/$parcel$interopDefault($094685b3fbb74354$exports)));
    if (userType === "investor" && modaldata?.toLowerCase()?.includes("investment")) image = (0, (/*@__PURE__*/$parcel$interopDefault($3dab7528e824298c$exports)));
    if (userType === "investor" && modaldata?.toLowerCase()?.includes("exit")) image = (0, (/*@__PURE__*/$parcel$interopDefault($65e3e81ebe96ea95$exports)));
    else if (userType === "investor" && modaldata?.toLowerCase()?.includes("growth")) image = (0, (/*@__PURE__*/$parcel$interopDefault($c61bc4023886545e$exports)));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
        modalType: "pricingPage",
        modalCardClasses: "maw90 bg38",
        customStyle: {
            padding: '0px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: image,
            alt: "Pricing Journey",
            className: "w100"
        })
    });
};
var $fdcce4a081a5f48f$export$2e2bcd8739ae039 = $fdcce4a081a5f48f$var$PricingPageJourney;



var $ayMG0 = parcelRequire("ayMG0");







const $e184fbb5396d43ef$var$renderTitle = (titleText, handleModal)=>{
    if (titleText.includes('|')) {
        const [beforePipe] = titleText.split('|');
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                color: `${beforePipe.includes("Try us out for FREE - no credit card required") ? "#10B981" : "#151313"}`
            },
            children: [
                beforePipe,
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("gAPn9")),
                    alt: "helpCircle",
                    width: 16,
                    height: 16,
                    className: "ml0-5rem"
                })
            ]
        });
    } else if (titleText.includes('&')) {
        const [beforePipe] = titleText.split('&');
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                color: `${beforePipe.includes("Try us out for FREE - no credit card required") ? "#10B981" : "#151313"}`
            },
            children: [
                beforePipe,
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (parcelRequire("9Xx3j")),
                    onClick: ()=>handleModal(titleText),
                    alt: "helpCircle",
                    width: 16,
                    height: 16,
                    className: "ml0-5rem cp"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            color: `${titleText.includes("Try us out for FREE - no credit card required") ? "#10B981" : "#151313"}`
        },
        children: titleText
    });
};






const $e184fbb5396d43ef$var$FeatureRow = ({ label: label, values: values, plans: plans, handleModal: handleModal, subscription: subscription, handlePaymentPopup: handlePaymentPopup, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        sx: {
            paddingTop: '12px',
            paddingBottom: '12px',
            borderBottom: '1px solid #8282823a',
            height: label === "BUY_BUTTONS" ? '80px' : '60px',
            verticalAlign: 'center',
            margin: '0px 0px 0px -8px',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                xs: plans.length === 2 ? 7 : plans.length === 3 ? 5 : plans.length === 4 ? 3 : 4,
                sx: {
                    ...plans.length === 1 && {
                        maxWidth: '80% !important',
                        width: '80%!important',
                        flexBasis: '80% !important'
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                    variant: "body2",
                    className: "tal fw400 df aic pl0-5rem",
                    sx: {
                        fontSize: '13px !important'
                    },
                    children: [
                        label === "BUY_BUTTONS" ? "" : $e184fbb5396d43ef$var$renderTitle(label, handleModal),
                        label.includes('Sync') ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                className: "ml1rem",
                                src: (parcelRequire("cLEoh")),
                                alt: "dataRooms"
                            })
                        }) : label.includes('Unaudited Certification') || [
                            'Chargeable quarterly reviews',
                            'Quarterly portfolio Reviews'
                        ].includes(label) ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df aic jcc",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ml0-5rem",
                                    src: (parcelRequire("e3B3T")),
                                    alt: "certificationPricing"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ml0-5rem",
                                    src: (parcelRequire("7ccEw")),
                                    alt: "certificationPricing2"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    className: "ml0-5rem",
                                    src: (parcelRequire("61dei")),
                                    alt: "certificationPricing3"
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            plans.map((plan, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    xs: plans.length === index + 1 ? 3 : 2,
                    sx: {
                        ...plans.length === 1 && {
                            maxWidth: '20% !important',
                            width: '20%!important',
                            flexBasis: '20% !important'
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                        className: "fw400 fs11px pr",
                        sx: {
                            fontSize: '13px !important'
                        },
                        align: "center",
                        children: values[plan] && typeof values[plan] === 'string' && values[plan].includes("image") ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: `pa ${plans.length === index + 1 ? 'w70 mxa' : 'w100'}`,
                            style: {
                                left: `${plans.length === index + 1 ? '15%' : '0'}`,
                                top: '-30px'
                            },
                            src: (parcelRequire("38fuN")),
                            alt: "info"
                        }) : typeof values[plan] === 'boolean' ? values[plan] ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: (parcelRequire("9gced")),
                            alt: "allowedIcon"
                        }) : plan.toLowerCase().includes('pro plus') ? '' : '-' : label === "BUY_BUTTONS" ? plans.length === index + 1 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 mxa tac pb1rem df aic jcc",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "br50px py0-75rem cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac bg1 c4 bw1px bss bo4 br50px df aic jcc px0-5rem w100",
                                    type: "button",
                                    style: {
                                        maxHeight: "45px",
                                        paddingLeft: "8px",
                                        paddingRight: "8px",
                                        width: "180px"
                                    },
                                    onClick: ()=>window.open("https://koalendar.com/e/meet-with-mark-bernstein"),
                                    disabled: disabled,
                                    children: "Book a call"
                                })
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: subscription?.toLowerCase() !== plan?.toLowerCase() ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w100 mxa tac pb1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "br50px py0-75rem cp px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac bg4 c1 df aic jcc px0-5rem mxa",
                                    type: "button",
                                    style: {
                                        maxHeight: "45px",
                                        paddingLeft: "8px",
                                        paddingRight: "8px",
                                        width: "180px"
                                    },
                                    onClick: disabled ? undefined : ()=>handlePaymentPopup(plan),
                                    disabled: disabled,
                                    children: plan !== "FREE" ? values[plan] : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "df aic jcc fdc fw600",
                                        children: [
                                            " Get Started ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fs10px fw400",
                                                children: "No credit card required"
                                            })
                                        ]
                                    })
                                })
                            }) : ''
                        }) : values[plan] || '-'
                    })
                }, plan))
        ]
    });
};
const $e184fbb5396d43ef$var$InnerFeatureAccordion = ({ items: items, plans: plans, tab: tab, subscription: subscription, selectedCompany: selectedCompany, handlePaymentPopup: handlePaymentPopup })=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const activeTab = tab;
    const disabled = !(selectedCompany && Object.keys(selectedCompany)?.length);
    const handleModal = ()=>{
        if (disabled) return;
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'pricingPage'
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5c228c234852d575$export$2e2bcd8739ae039), {
        defaultExpanded: true,
        disableGutters: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a792f5a0c37e2ab$export$2e2bcd8739ae039), {
                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c842ddb70f8ccad0$exports))), {
                    sx: {
                        color: '#4A67FF'
                    }
                }),
                sx: {
                    padding: '12px 16px',
                    backgroundColor: '#FFDB4299'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    alignItems: "center",
                    sx: {
                        paddingTop: '0px',
                        paddingBottom: '0px',
                        margin: '0px 0px 0px -8px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                            xs: plans.length === 2 ? 7 : plans.length === 3 ? 5 : plans.length === 4 ? 3 : 4,
                            sx: {
                                ...plans.length === 1 && {
                                    maxWidth: '80% !important',
                                    width: '80%!important',
                                    flexBasis: '80% !important'
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                variant: "subtitle1",
                                sx: {
                                    fontWeight: 600,
                                    textAlign: 'left',
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingLeft: '8px'
                                },
                                children: $e184fbb5396d43ef$var$renderTitle("We Get You Organised", handleModal)
                            })
                        }),
                        plans.map((plan, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9450fbc34cc5b2ea$export$2e2bcd8739ae039), {
                                xs: plans.length === index + 1 ? 3 : 2,
                                sx: {
                                    paddingTop: "0px !important",
                                    ...plans.length === 1 && {
                                        maxWidth: '20% !important',
                                        width: '20%!important',
                                        flexBasis: '20% !important'
                                    }
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2531239e3a525689$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontSize: '13px !important',
                                        fontWeight: '600',
                                        marginLeft: '1rem'
                                    },
                                    align: "center",
                                    children: [
                                        (0, $0e5eabdbd79984d1$export$42a2f1c980fb3973)[activeTab]?.['subTitle']?.[plan] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "fs11px fw400 mb0rem",
                                            children: (0, $0e5eabdbd79984d1$export$42a2f1c980fb3973)[activeTab]['subTitle'][plan]
                                        }),
                                        plan
                                    ]
                                })
                            }, plan))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b78273c1c27a2e1$export$2e2bcd8739ae039), {
                sx: {
                    padding: '0px'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $595185d0d7275c3b$export$2e2bcd8739ae039), {
                    elevation: 0,
                    sx: {
                        margin: "0px !important"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            padding: '0 16px 0px'
                        },
                        children: Object.entries(items).map(([feature, value])=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($e184fbb5396d43ef$var$FeatureRow, {
                                handlePaymentPopup: handlePaymentPopup,
                                selectedCompany: selectedCompany,
                                subscription: subscription,
                                activeTab: activeTab,
                                label: feature,
                                values: value,
                                plans: plans,
                                handleModal: handleModal,
                                disabled: disabled
                            }, feature);
                        })
                    })
                })
            })
        ]
    });
};
var $e184fbb5396d43ef$export$2e2bcd8739ae039 = $e184fbb5396d43ef$var$InnerFeatureAccordion;




var $81643d343a3846cd$exports = {};
$81643d343a3846cd$exports = new URL("innerPricingPlan.e3352f07.png", import.meta.url).toString();


var $7c91ea3d4394ff5e$exports = {};
$7c91ea3d4394ff5e$exports = new URL("activeLite.e67a85a4.png", import.meta.url).toString();


var $9844a83dab97dc6a$exports = {};
$9844a83dab97dc6a$exports = new URL("proCard.387eb881.png", import.meta.url).toString();


var $7cc65f364dc6793a$exports = {};
$7cc65f364dc6793a$exports = new URL("proTip.c1c3fc34.png", import.meta.url).toString();





// Helper function to get modified plan based on subscription
const $acf2833d3933aae4$var$getModifiedPricingPlan = (subscription, basePlanData, setPricingData)=>{
    const deepClone = JSON.parse(JSON.stringify(basePlanData));
    const planData = deepClone['Companies'];
    if (subscription && subscription === 'Free') {
        Object.values(planData.features).forEach((features)=>{
            Object.values(features).forEach((value)=>delete value['FREE']);
        });
        planData.plans = planData.plans.filter((p)=>p !== 'FREE');
        planData.headings = planData.headings.filter((p)=>p !== 'FREE');
        delete planData.pricing['FREE'];
        delete planData.buttonText['FREE'];
    }
    if (subscription && subscription === 'Lite') {
        Object.values(planData.features).forEach((features)=>{
            Object.values(features).forEach((value)=>delete value['FREE']);
        });
        planData.plans = planData.plans.filter((p)=>p !== 'FREE' && p !== 'LITE');
        planData.headings = planData.headings.filter((p)=>p !== 'FREE' && p !== 'LITE');
        delete planData.pricing['FREE'];
        delete planData.buttonText['FREE'];
    }
    if (subscription && subscription === 'Pro') {
        Object.values(planData.features).forEach((features)=>{
            Object.values(features).forEach((value)=>{
                delete value['FREE'];
                delete value['LITE'];
            });
        });
        planData.plans = planData.plans.filter((p)=>p !== 'FREE' && p !== 'LITE' && p !== 'PRO');
        planData.headings = planData.headings.filter((p)=>p !== 'FREE' && p !== 'LITE' && p !== 'PRO');
        delete planData.pricing['FREE'];
        delete planData.pricing['LITE'];
        delete planData.buttonText['FREE'];
        delete planData.buttonText['LITE'];
    }
    setPricingData({
        "Companies": planData
    });
};


const $acf2833d3933aae4$var$InnerPricingPage = ()=>{
    const [tab] = (0, $acw62.useState)("Companies");
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const { id: id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [modalData, setModalData] = (0, $acw62.useState)(null);
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const [selectedPlan, setSelectedPlan] = (0, $acw62.useState)();
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    const [pricingData, setPricingData] = (0, $acw62.useState)();
    const fetchCompanyData = async (companyId)=>{
        const spinner = document.getElementById('e1jygW4piZH1');
        spinner.classList.remove('op0');
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/company/get/${companyId}`);
        dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)(response['body']));
        spinner.classList.add('op0');
    };
    (0, $acw62.useEffect)(()=>{
        if (id) fetchCompanyData(id);
    }, [
        id
    ]);
    const handleCopy = (code)=>{
        navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    const handleModalOpen = (data)=>{
        setModalData(data);
    };
    (0, $acw62.useEffect)(()=>{
        if (selectedCompany && Object.keys(selectedCompany).length && selectedCompany['subscription']) $acf2833d3933aae4$var$getModifiedPricingPlan(selectedCompany?.subscription, (0, $0e5eabdbd79984d1$export$42a2f1c980fb3973), setPricingData);
        else if (selectedCompany && Object.keys(selectedCompany).length && !selectedCompany['subscription']) setPricingData((0, $0e5eabdbd79984d1$export$42a2f1c980fb3973));
    }, [
        selectedCompany
    ]);
    const capitalizeWords = (text)=>text.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    const handlePaymentPopup = (paymentPlan)=>{
        if (disabled) return;
        paymentPlan = capitalizeWords(paymentPlan);
        if (paymentPlan == 'Portfolio Pro') paymentPlan = "Pro";
        let activePlans = [
            'Free',
            'Lite',
            'Pro'
        ];
        if (activePlans.includes(paymentPlan)) {
            setSelectedPlan(paymentPlan);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: 'subscriptionPaymentConfirm'
            }));
        }
    };
    // Disable all buttons and onClick events if no company is selected
    const disabled = !(selectedCompany && Object.keys(selectedCompany)?.length);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "poppins-font-style bg1 pricing-plan-page",
                style: {
                    backgroundImage: `url(${selectedCompany && selectedCompany['subscription'] === "Lite" ? (0, (/*@__PURE__*/$parcel$interopDefault($7c91ea3d4394ff5e$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($81643d343a3846cd$exports)))})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#F5F7FF',
                    minHeight: '100vh',
                    overflowY: 'scroll'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b79a979012c7be98$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df jcc fdc aic pt2rem pb5rem pricing-tabs oh",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "pb1rem df jcc fdc tslp op1 tty0  w100 tal",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "dib fw500 fs2-125rem c15 tal w100 pl3rem",
                                    style: {
                                        lineHeight: '62.2px'
                                    },
                                    children: "Our Plans"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "w100 tac",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `dg gtcr5 pt4rem gg1rem w90 ma px2rem`,
                                        children: [
                                            pricingData?.[tab]?.plans.length === 2 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                                                ]
                                            }) : pricingData?.[tab]?.plans.length === 3 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                                                ]
                                            }) : pricingData?.[tab]?.plans.length === 1 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                                                ]
                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                                            }),
                                            pricingData?.[tab].plans.map((plan, index)=>{
                                                const isPaid = plan === "LITE" || plan === "PRO";
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "pr",
                                                    children: [
                                                        selectedCompany && !selectedCompany['subscription'] && plan === "PRO" || selectedCompany && selectedCompany['subscription'] && selectedCompany['subscription']?.toLowerCase() === "free" && plan === "PRO" ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                            className: "pa",
                                                            style: {
                                                                top: '-58%',
                                                                zIndex: 0,
                                                                left: '12px'
                                                            },
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9844a83dab97dc6a$exports))),
                                                            alt: "proCard"
                                                        }) : selectedCompany && selectedCompany['subscription'] && selectedCompany['subscription']?.toLowerCase() === "lite" && plan === "PRO" ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "pa",
                                                                style: {
                                                                    top: '-31%',
                                                                    zIndex: 0,
                                                                    left: '0px'
                                                                },
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($7cc65f364dc6793a$exports))),
                                                                alt: "proTip"
                                                            })
                                                        }) : '',
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            className: "df jcsb fdc aic bg1 br20px bo65 bw1px w100 mb1rem p1rem pr",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                    className: "pr w100",
                                                                    children: [
                                                                        pricingData?.[tab].tag?.[plan] && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "df aic jcc",
                                                                            style: {
                                                                                width: '283px',
                                                                                height: '24px',
                                                                                position: 'absolute',
                                                                                top: '31px',
                                                                                left: '-299px'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                                src: (parcelRequire("kCxNU")),
                                                                                alt: "tag"
                                                                            })
                                                                        }),
                                                                        plan === "PRO" ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "df aic jcsb",
                                                                            style: {
                                                                                height: '24px'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                                className: "c4 fs10px fw600 w100 tal",
                                                                                children: "MOST POPULAR"
                                                                            })
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "df aic jcsb",
                                                                            style: {
                                                                                height: '24px'
                                                                            }
                                                                        }),
                                                                        pricingData?.[tab]?.discount?.[plan] && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "c1 fs1rem fw600 tac pa",
                                                                            style: {
                                                                                backgroundImage: `url(${(parcelRequire("1DYXg"))})`,
                                                                                minHeight: '73px',
                                                                                backgroundSize: 'contain',
                                                                                backgroundRepeat: 'no-repeat',
                                                                                backgroundPosition: 'right center',
                                                                                right: '4px',
                                                                                top: '-20px',
                                                                                padding: '4px'
                                                                            },
                                                                            children: [
                                                                                pricingData?.[tab].discount[plan],
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                                " off"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: `fs1-5rem c15 fw500 tal ${pricingData?.[tab]?.subTitle ? 'mb0-5rem' : 'mb2rem'}`,
                                                                            children: [
                                                                                plan,
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c4 db fs12px fw400",
                                                                                    style: {
                                                                                        height: '18px'
                                                                                    },
                                                                                    children: pricingData?.[tab]?.subTitle?.[plan] || ""
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                            className: "c15 fw500 tal",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "c3 fs2rem fw600",
                                                                                    children: pricingData?.[tab].pricing[plan]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    children: ![
                                                                                        'Custom',
                                                                                        'FREE'
                                                                                    ].includes(pricingData?.[tab].pricing[plan]) && `/month${isPaid ? "*" : ''}`
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                    className: "db c15 op60 fs14px fw400",
                                                                                    children: isPaid ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                                        children: "* billed annually"
                                                                                    }) : ''
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                                            className: "fs1rem c15",
                                                                            children: plan.description
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                    className: "df jcc fdc aic w100 mt1rem",
                                                                    children: 'Portfolio PRO ' === plan ? /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                                        className: "tal c71 fw400 cp fs12px pr",
                                                                        children: [
                                                                            "*= only available through ",
                                                                            tab === "Investors" ? 'Investor' : "Advisor",
                                                                            " dashboard.",
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "c4 cp",
                                                                                onClick: ()=>handleCopy(tab === "Investors" ? 'Code: INVESTOR20' : 'Code: ADVISOR20')
                                                                            }),
                                                                            copied && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "pa t0 r0 bg1",
                                                                                style: {
                                                                                    padding: '4px',
                                                                                    borderRadius: '12px'
                                                                                },
                                                                                children: "(Copied!)"
                                                                            }),
                                                                            ". Billed annually"
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                                                            style: {
                                                                                maxHeight: "45px",
                                                                                paddingLeft: "8px",
                                                                                paddingRight: '8px',
                                                                                marginTop: isPaid ? '0px' : '25px'
                                                                            },
                                                                            customClassName: "df aic jcc px0-5rem w100",
                                                                            onClick: ()=>{
                                                                                if (pricingData?.[tab].buttonText[plan] === "Book a call") window.open("https://koalendar.com/e/meet-with-mark-bernstein");
                                                                                else handlePaymentPopup(plan);
                                                                            },
                                                                            btnType: pricingData?.[tab].pricing[plan] !== 'Custom' ? "warning" : "warningOutlined",
                                                                            text: pricingData?.[tab].buttonText[plan]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, index)
                                                    ]
                                                });
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "w90 ma",
                                        children: pricingData?.[tab] && Object.keys(pricingData?.[tab]).length && Object.entries(pricingData?.[tab].features).map(([section, items])=>{
                                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e184fbb5396d43ef$export$2e2bcd8739ae039), {
                                                subscription: selectedCompany['subscription'] || null,
                                                selectedCompany: selectedCompany,
                                                tab: tab,
                                                title: section,
                                                titleInfo: section,
                                                items: items,
                                                plans: pricingData?.[tab].headings,
                                                onModalOpen: handleModalOpen,
                                                handlePaymentPopup: handlePaymentPopup,
                                                disabled: disabled
                                            }, section);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da20b8fe5a9fd138$export$2e2bcd8739ae039), {
                plan: selectedPlan,
                defaultStep: selectedPlan === "Free" ? "freeMembership" : "subscriptionUpgrade",
                company: selectedCompany,
                companyId: selectedCompany['_id']
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdcce4a081a5f48f$export$2e2bcd8739ae039), {
                modaldata: modalData
            })
        ]
    });
};
var $acf2833d3933aae4$export$2e2bcd8739ae039 = $acf2833d3933aae4$var$InnerPricingPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");











const $2d4f9d5a6ae099ba$var$DiscountCodeStep = ({ promoCode: promoCode, setPromoCode: setPromoCode, isValidCoupon: isValidCoupon, isCheckingCoupon: isCheckingCoupon, handlePurchase: handlePurchase, loading: loading, dispatch: dispatch })=>{
    const handleClose = ()=>{
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ''
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ec55e6e0def7a00$export$2e2bcd8739ae039), {
            onCloseHandler: handleClose,
            modalType: "subscriptionPaymentConfirmClientCompany",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "df fdc jcc aic",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        style: {
                            width: '93px',
                            height: '75px'
                        },
                        src: (parcelRequire("jdo6l")),
                        alt: "logoDiligentsia"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "c15 tac mt1rem fw400 fs22px",
                        children: "Please confirm you wish to purchase this Pro subscription"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "c15 op60 fs10px my0-5rem tac fw500",
                        children: "If you have a valid promo code, please insert it here"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5b44d85b61a8772$export$2e2bcd8739ae039), {
                        promoCode: promoCode,
                        setPromoCode: (e)=>{
                            setPromoCode(e);
                            if (!e || e && e === "") setPromoCodeData(null);
                        },
                        isValid: isValidCoupon,
                        isChecking: isCheckingCoupon
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "df fdc aic jcc w100 mt3rem mb1rem",
                        style: {
                            width: '280px'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                            onClick: handlePurchase,
                            btnType: "warning",
                            customClassName: "w100",
                            text: "Continue to Purchase",
                            disabled: loading || isCheckingCoupon || !isValidCoupon && promoCode !== ''
                        })
                    })
                ]
            })
        })
    });
};



const $2d4f9d5a6ae099ba$var$IndirectCompanyBillingPage = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const defaultPromoCodeData = {
        advisor: {
            code: 'ADVISOR20'
        },
        investor: {
            code: 'INVESTOR20'
        }
    };
    const { id: id, subscription: subscription, role: role } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [promoCode, setPromoCode] = (0, $acw62.useState)(defaultPromoCodeData[role]?.code || '');
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [promoCodeData, setPromoCodeData1] = (0, $acw62.useState)(null);
    const [amount, setAmount] = (0, $acw62.useState)({
        totalAmount: 83.25,
        sellingPrice: 66.60
    });
    const [isValidCoupon, setIsValidCoupon] = (0, $acw62.useState)(true);
    const [isCheckingCoupon, setIsCheckingCoupon] = (0, $acw62.useState)(false);
    const checkCoupon = (0, $acw62.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($d9f195cb3938646c$exports)))(async (code)=>{
        if (!code) {
            setIsValidCoupon(true);
            setIsCheckingCoupon(false);
            return;
        }
        try {
            const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`/payment/checkCoupon/${code}`, {
                amount: (0, $6a6b4b5ab5be324d$export$75ca824b364dfc45)['Pro']?.price
            });
            setPromoCodeData1(response?.body);
            setIsValidCoupon(response?.code === 200);
        } catch (error) {
            setIsValidCoupon(false);
        } finally{
            setIsCheckingCoupon(false);
        }
    }, 1000), []);
    (0, $acw62.useEffect)(()=>{
        setIsCheckingCoupon(true);
        checkCoupon(promoCode);
    }, [
        promoCode,
        checkCoupon
    ]);
    (0, $acw62.useEffect)(()=>{
        if (promoCodeData) {
            if (promoCodeData?.discountType === 'percentage') {
                const discountAmount = amount.totalAmount / 100 * (promoCodeData?.discountValue || 0);
                if (amount.totalAmount >= discountAmount) setAmount((prev)=>({
                        ...prev,
                        sellingPrice: Number(prev.totalAmount - discountAmount).toFixed(2)
                    }));
                else (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)('Invalid coupon code!');
            } else setAmount((prev)=>({
                    ...prev,
                    sellingPrice: Number(prev.totalAmount - (promoCodeData?.discountValue || 0)).toFixed(2)
                }));
        }
    }, [
        promoCodeData
    ]);
    const capitalizeWords = (text)=>text.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
    const handleBuySubscription = async ()=>{
        let data = {
            endPoint: `/payment/upgrade-subscription/${id}`,
            payload: {
                packageName: capitalizeWords(subscription),
                ...role && promoCode && promoCode !== "" && promoCodeData && {
                    promoCode: promoCodeData?.stripePromotionCodeId
                }
            }
        };
        if (promoCodeData && promoCodeData?.discountType === "percentage" && promoCodeData?.discountValue === 100) {
            data.endPoint = `/payment/subscriptionWithAccessCode/${id}`;
            data.payload = {
                ...data.payload,
                ...role && promoCode && promoCode !== "" && promoCodeData && {
                    promoCode: promoCodeData?.code
                }
            };
        }
        setLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)(`${data?.endPoint}`, data?.payload);
        if (response?.code === 200) {
            if (response?.body?.url) window.location.href = response.body?.url;
            else window.location.href = `/company/${id}`;
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $115f4662e48b5c59$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "poppins-font-style bg1 pricing-indirectCompany-billing-page bg72",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "df aic jcc h100",
                        style: {
                            minHeight: '100vh'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "pl5rem c15",
                                style: {
                                    width: '65%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                        style: {
                                            width: '550px'
                                        },
                                        children: [
                                            "Your ",
                                            capitalizeWords(role),
                                            " Has Negotiated You A Discount!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "pr shadow bg1 br10px py1rem px2rem mt2rem",
                                        style: {
                                            width: '480px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                style: {
                                                    backgroundImage: `url(${(parcelRequire("1DYXg"))})`,
                                                    minHeight: Number(promoCodeData?.discountValue) === 100 ? '82px' : '72px',
                                                    backgroundSize: 'contain',
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundPosition: 'right center',
                                                    right: '30px',
                                                    top: '0px',
                                                    padding: '8px 6px 9px',
                                                    fontSize: '1rem',
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                },
                                                className: "c1 fs1rem fw600 tac pa",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        children: [
                                                            promoCodeData?.discountValue || 20,
                                                            promoCodeData && promoCodeData?.discountType !== "percentage" ? "\xa3" : "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Off"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                className: "fw600",
                                                children: "Portfolio PRO"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                style: {
                                                    textDecoration: 'line-through'
                                                },
                                                className: "c73 fw500 fs1-25rem",
                                                children: [
                                                    "\xa3",
                                                    amount?.totalAmount,
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c15 fw500 tal",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                        className: "c3 fs2rem fw600",
                                                        children: [
                                                            "\xa3",
                                                            amount?.sellingPrice
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "/month*"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                className: "c71 fw400 mt1rem fs12px",
                                                children: [
                                                    "*= only available via ",
                                                    capitalizeWords(role),
                                                    ".. Billed annually "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "fw500 mt4rem",
                                        style: {
                                            color: '#000'
                                        },
                                        children: [
                                            "Your ",
                                            capitalizeWords(role),
                                            " discount code :",
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "c4",
                                                children: [
                                                    " ",
                                                    defaultPromoCodeData[role]?.code
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "c15 op60 fs14px",
                                        children: "Insert code on next screen"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f26e6702e19c1cff$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'subscriptionPaymentConfirmClientCompany'
                                            }));
                                        },
                                        customClassName: "mt3rem",
                                        btnType: "warning",
                                        text: 'Buy Now',
                                        style: {
                                            width: '250px'
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    backgroundImage: `url(${(parcelRequire("2hF7P"))})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    width: '40%',
                                    minHeight: '100vh'
                                },
                                className: "pr",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: (parcelRequire("6OV3P")),
                                    atl: "portfolioPro.png",
                                    className: "pa",
                                    style: {
                                        maxWidth: '150px',
                                        top: '20px',
                                        right: '40px'
                                    }
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($2d4f9d5a6ae099ba$var$DiscountCodeStep, {
                    promoCode: promoCode,
                    setPromoCode: setPromoCode,
                    isValidCoupon: isValidCoupon,
                    isCheckingCoupon: isCheckingCoupon,
                    handlePurchase: handleBuySubscription,
                    loading: loading,
                    dispatch: dispatch
                })
            ]
        })
    });
};
var $2d4f9d5a6ae099ba$export$2e2bcd8739ae039 = $2d4f9d5a6ae099ba$var$IndirectCompanyBillingPage;



function $7ae1d2af47f5ebdd$export$2e2bcd8739ae039() {
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    // useEffect(() => {
    // 	const interval = setInterval(() => {
    // 		const element = document.querySelector(".intercom-lightweight-app-launcher");
    // 		if (element) {
    // 			element.style.right = "70px";
    // 			element.style.bottom = "16px";
    // 			clearInterval(interval); // Stop checking once the element is found
    // 		}
    // 	}, 2000); // Check every 500ms
    // 	return () => clearInterval(interval); // Cleanup on unmount
    // }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06516233abcfeeff$export$3ae376d12526dd6f), {
        mode: "wait",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            location: location,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$a7c5707626fc90f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5daf7e3b2477c4e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$eed606b4351295d7,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7fc0f1ed201d442$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$51e82cdd7353a0e1,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ba5b94d95666305b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$635fd87e6c3d3ece,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c5daf7e3b2477c4e$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$c99881788c0caafd,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d4d9ec6d06bfc90$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$e479859894f5f058,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5602480d08610dfa$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$babdbb7ea7999cc6,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$f6a76601f46caf3c,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $007b001e77f39b29$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$fa9c0935e7d8e746,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2195d1d77cec74e8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$91d019707a9c3d97,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6902416b7eb7e9be$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$db9cf68015d1273f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7b932a99b2c3500$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$ff5ab0b53eba7ce1,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2a0c9d5cb2da57b5$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$8491d203699f4c89,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ce8c16714c6900b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$d0d710be9382ff47,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $472fc6d2654aeb65$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$6cb6d7e1fbb020d5,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05ee9988ffef0fd3$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$e2f78a34a24c9f45,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6c8fd5efa964b3d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$a97ee4ebdc82a34c,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $945faba68f239814$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$41835e10bef063e6,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $75e9d2b4413835d1$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$ce939e14da856e20,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ec2c02f066103c13$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$2aac1f04473d9900,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3bb8352184af0c4$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$7d34e7fbe54f4a80,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$5d923b12188e7414,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $08be363c0766a6d2$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$20de159c79d2d5f2,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8439927cc3eeaed$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$2c56bebcf5dc2850,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7a85918df077e633$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$fa0d235fc547c669,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2009f489cd1d844c$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$9c09018d5bb1154,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d106aebef4cb508a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$9eeeba16e1010f7f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8615d6566591df2f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$5236f07d836cb2a7,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf9800d02c9ef389$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$575c5f34c66beb48,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $874872454e1b05af$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: `${$16250bd714b02a14$export$575c5f34c66beb48}/:partnerId`,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $874872454e1b05af$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$4cb4d3804cb0d2a2,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $874872454e1b05af$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/cfo",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d106aebef4cb508a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/vc",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7a85918df077e633$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/angel-network",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8615d6566591df2f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/ceo",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/accelerator",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fee6437e8ec95a7$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/pisces",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8439927cc3eeaed$export$2e2bcd8739ae039), {})
                }),
                (0, $7393559700759e6c$export$48a6bbfb0f95d83a).map((a)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                        path: `/${a['icpSlug']}/${a['slug']}`,
                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62ce930ac0a2a41f$export$2e2bcd8739ae039), {
                            icpSlug: a['icpSlug'],
                            slugOverride: a['slug']
                        })
                    }, `${a['icpSlug']}/${a['slug']}`)),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/reset_password/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b7fc0f1ed201d442$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/newMember/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/verifyEmail/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/verifyAdvisor/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/investorToken/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/newAdvisorCompany/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/newInvestorCompany/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/hashToken/:hash/company/:hash",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/hashToken/:hash/diligence-pack/:id",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bbfe88e25eb340a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/shareCode/:code/diligence-pack/:id",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bbfe88e25eb340a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$ad1b5946f5a165f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bbfe88e25eb340a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$77c1af69987805fb,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $151980f13be271b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$5ac24c51d0564925,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55e201de1e0213a0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$3ef311402a6d1da9,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c258519ff7ca2636$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$37575e7e3c62bf69,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af4eea075ad440c5$export$2e2bcd8739ae039), {
                        persona: "company"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$bd37f69dd4d7c31e,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af4eea075ad440c5$export$2e2bcd8739ae039), {
                        persona: "advisor"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$e571b1dcb5172d6f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af4eea075ad440c5$export$2e2bcd8739ae039), {
                        persona: "investor"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$f8d8776d8b70eb77,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41f44fb76c6a08f2$export$2e2bcd8739ae039), {
                        persona: "company"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$d8a91f63c9f7c142,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41f44fb76c6a08f2$export$2e2bcd8739ae039), {
                        persona: "advisor"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$8f15a807ba2937ff,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41f44fb76c6a08f2$export$2e2bcd8739ae039), {
                        persona: "investor"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$1473cb2f5aa9c69d,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $556c68a6e221b21b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$5a1672aaaff636c9,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1abcaa77a9db32b9$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$eec6248d2d9b1ed5,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c0e3557e009ae460$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$a31271cda3788ac2,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5b6eb2f7a73a2be0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$96427145056c985f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd1f8ea7559652d0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$aa02a5bce6b6bc60,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c35aff80e2c7af97$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$ba754712644f810e,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5bc3cd9adce0fa1$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$c43fdfcb733f4e5d,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcc62cc1bbeb4cc1$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$dbad77b037a0a446,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a013422192363c1$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$e92271f784cbfcf3,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8139c82c7f40ced$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$893498aa7359709f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa31fe49377072f4$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$6bdd9dea0e57de2f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d4f9d5a6ae099ba$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$3623221f872af69b,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acf2833d3933aae4$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$d90f8d6beb6e3252,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $78e5711177513786$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$d7b8dff6af31ceb7,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96a2936a1b048091$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$c1df9e7d4593f04c,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3ceb5821786f07$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$240514314008da16,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6dc8626146af9081$export$2e2bcd8739ae039), {
                        optimized: true
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$4695c1a423ffe431,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b373ac8016a3b01b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$fa573b5b2799a94a,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bc49bb66b774dc6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$c45d6aa39a7ae97c,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bc49bb66b774dc6$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$361fa494492daab9 + "/*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $618f91e944784bb8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$1b4f59059fb09cf3,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ea756d09d9085bc$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$5c5adc4f183023d2,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5d74d48e8d56916$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$fec5a8397856135d,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a5d74d48e8d56916$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$88e43bd5bf664bb,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f677696145d7b59$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/gDriveCallBack",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd0345cd00b1f91a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/dropBoxCallBack",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd0345cd00b1f91a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/sharePointCallBack",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd0345cd00b1f91a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$2b9b886dddb4ba32,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ac049553753afae$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$91c3232a793620f2,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $805db674703862ea$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$b2e11634d600f33e,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2d3545d01b66bc9$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$e3d31417f21c1ce7,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33a9b39b88c46765$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$25d3d6b2b16f29ee,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e0b9224e21e310b1$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$a3b74c08fbf97cc,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84d216fb247af9d4$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$dd6eb49e7cb5a5c0,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2306e3952f6c12d7$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$17214b626e4a2996,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57ddb9eef2997aee$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$a4cdcf96e9da6a11,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da1b2edfeb15e6cc$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$df7a117e66af0ef0,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1f609915e12f5806$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$f43de61a26b1e3d1,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d9b1817c81587b8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$c221831e2ad64aae,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1adba59ff1f5733d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$8b41d37ee61ee20f,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48b84a93907f65b5$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$79ffb24037556cb1,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adcd4d700abdf82f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$21297016b65d8d06,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4ffab1c8e4b00da$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$e1ec66dfdd97ff54,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f46017e55c99f31$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$721554a0ca024204,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac1fa5dee7f1aa41$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$7cbd13c49e6bb251,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4804c4a670f053d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$3dad34f770fcb308,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55e201de1e0213a0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$bcdbe1127ca0dc8c,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f99123378f0e24b0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$f8b031824e68df83,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a46bd5ef9aae83ce$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$d37021401d41152,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dfadbc8fab0c0d9$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$8bb39b3eb744faa7,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb095ef15aab9fd$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$7dc602c5018e66b9,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1918fdab20a82fe5$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: $16250bd714b02a14$export$a9826d71ea65c977,
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $789cb6667d9385ea$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d02462af2757b484$export$2e2bcd8739ae039), {})
                })
            ]
        }, location.pathname)
    });
}



var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");





var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1bb46af2548eb120$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}), 'SettingsOutlined');




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $b4501f0db6859ce3$var$Destination = function Destination(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#a)",
                fill: "#4A67FF",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8.396 6.02a2.596 2.596 0 0 0-2.592-2.592A2.596 2.596 0 0 0 3.21 6.02a2.596 2.596 0 0 0 2.593 2.593A2.596 2.596 0 0 0 8.396 6.02Zm-2.592.954a.955.955 0 0 1 0-1.907.955.955 0 0 1 0 1.907Z"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M28 13.688a.82.82 0 0 0-.515-.728l-8.71-3.484a.82.82 0 0 0-1.124.76v12.019a2.904 2.904 0 0 0-2.006 2.148H4.055c-.874 0-1.585-.71-1.585-1.584 0-.874.711-1.585 1.585-1.585h7.414a3.06 3.06 0 0 0 3.058-3.057 3.06 3.06 0 0 0-3.058-3.058H7.25l3.526-5.894a6.442 6.442 0 0 0 .913-3.306A5.85 5.85 0 0 0 5.844.075 5.85 5.85 0 0 0 0 5.92v.021c0 1.148.308 2.278.89 3.268l4.208 7.146a.823.823 0 0 0 .704.404h5.667a1.42 1.42 0 0 1 1.419 1.419 1.42 1.42 0 0 1-1.419 1.418H4.055A3.227 3.227 0 0 0 .832 22.82a3.227 3.227 0 0 0 3.223 3.223h11.703a2.9 2.9 0 0 0 2.712 1.883 2.898 2.898 0 0 0 2.895-2.895 2.9 2.9 0 0 0-2.075-2.775v-3.703l8.255-4.097a.82.82 0 0 0 .454-.767ZM2.302 8.376a4.806 4.806 0 0 1-.664-2.436v-.02a4.21 4.21 0 0 1 4.205-4.206 4.21 4.21 0 0 1 4.205 4.205c0 .868-.235 1.72-.68 2.465l-3.559 5.95-3.507-5.958ZM19.726 25.03c0 .693-.564 1.256-1.256 1.256a1.257 1.257 0 0 1-1.255-1.256c0-.691.562-1.254 1.253-1.255h.005c.691.002 1.253.564 1.253 1.256Zm-.436-8.307v-5.276l5.885 2.354-5.885 2.922Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h28v28H0z"
                    })
                })
            })
        ]
    });
};
$b4501f0db6859ce3$var$Destination.defaultProps = {
    width: "28",
    height: "28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $b4501f0db6859ce3$var$JourneyGuide = ()=>{
    const dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const [userType, setUserType] = (0, $acw62.useState)('company');
    const [modalData, setModalData] = (0, $acw62.useState)('investment');
    const handleJourney = (modelType)=>{
        setModalData(modelType);
        if (user) setUserType(user['role'].toLowerCase());
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: 'pricingPage'
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "usn pr bsbb w100 td250 my0-5rem ass",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "py1rem bg19 br20px",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($b4501f0db6859ce3$var$Destination, {
                                    width: "24",
                                    className: "center-vertically f3 pa destinationIcon",
                                    style: {
                                        left: '4px',
                                        width: '30px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "pl2rem c15 ml1rem fs14px",
                                    children: "Your Journey"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                            className: "mt0-5rem px0-5rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "journeyLi cp",
                                    style: {
                                        padding: '4px 8px'
                                    },
                                    onClick: ()=>handleJourney('investment'),
                                    children: "To Investment"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "journeyLi cp",
                                    style: {
                                        padding: '4px 8px'
                                    },
                                    onClick: ()=>handleJourney('growth'),
                                    children: "To Growth"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                    className: "journeyLi cp",
                                    style: {
                                        padding: '4px 8px'
                                    },
                                    onClick: ()=>handleJourney('exit'),
                                    children: "To Exit"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdcce4a081a5f48f$export$2e2bcd8739ae039), {
                modaldata: modalData,
                userType: userType
            })
        ]
    });
};
var $b4501f0db6859ce3$export$2e2bcd8739ae039 = $b4501f0db6859ce3$var$JourneyGuide;


const $4ed3d4aabf5e4436$var$ClarenceIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        className: "center-vertically f3 pa l0 w2rem",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14 2C7.36705 2 2 7.36752 2 14C2 20.633 7.36752 26 14 26C20.633 26 26 20.6325 26 14C26 7.36705 20.6324 2 14 2ZM14 24.125C8.40345 24.125 3.875 19.5962 3.875 14C3.875 8.40345 8.40383 3.875 14 3.875C19.5965 3.875 24.125 8.40383 24.125 14C24.125 19.5965 19.5961 24.125 14 24.125Z",
                fill: "#6366f1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14 7V14L18 16",
                stroke: "#6366f1",
                strokeWidth: "2",
                strokeLinecap: "round"
            })
        ]
    });
};
const $4ed3d4aabf5e4436$var$BillingIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        className: "center-vertically f3 pa l0 w2rem",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M25.1893 12.8537C24.6636 12.355 23.9493 12.0903 23.2319 12.1286C22.7199 12.1555 22.2274 12.3349 21.8052 12.6491L16.2805 16.7894C16.2784 16.791 16.2763 16.7926 16.2741 16.7942C14.9352 17.8155 13.0647 17.8155 11.7258 16.7942C11.7237 16.7926 11.7216 16.791 11.7195 16.7894L6.19231 12.6473C5.77259 12.3349 5.28012 12.1556 4.76806 12.1286C4.05064 12.0907 3.33636 12.3551 2.8107 12.8538C2.28791 13.3497 2 14.0242 2 14.753V20.375C2 23.4766 4.52338 26 7.625 26H20.375C23.4766 26 26 23.4766 26 20.375V14.753C26 14.0242 25.7121 13.3497 25.1893 12.8537ZM24.125 20.375C24.125 22.4427 22.4427 24.125 20.375 24.125H7.625C5.55725 24.125 3.875 22.4427 3.875 20.375V14.753C3.875 14.4848 3.998 14.3119 4.10117 14.214C4.24395 14.0785 4.44022 14 4.63264 14C4.64492 14 4.6572 14.0004 4.66944 14.001C4.81311 14.0086 4.94886 14.0592 5.07031 14.1496L10.5919 18.2875C12.5991 19.816 15.4009 19.816 17.4081 18.2875L22.9272 14.1515C23.0511 14.0592 23.1868 14.0086 23.3305 14.001C23.5355 13.9907 23.7469 14.0699 23.8988 14.214C24.002 14.3119 24.125 14.4849 24.125 14.7531V20.375H24.125ZM4.34375 9.35938V7.625C4.34375 4.52338 6.86713 2 9.96875 2H18.125C21.2266 2 23.75 4.52338 23.75 7.625V9.35938C23.75 9.87716 23.3303 10.2969 22.8125 10.2969C22.2947 10.2969 21.875 9.87716 21.875 9.35938V7.625C21.875 5.55725 20.1927 3.875 18.125 3.875H9.96875C7.901 3.875 6.21875 5.55725 6.21875 7.625V9.35938C6.21875 9.87716 5.79903 10.2969 5.28125 10.2969C4.76347 10.2969 4.34375 9.87716 4.34375 9.35938ZM13.1328 14.3281V14.2059C12.7507 14.1284 12.3249 14.0105 11.8959 13.84C11.4147 13.6487 11.1797 13.1037 11.371 12.6225C11.5623 12.1414 12.1075 11.9064 12.5885 12.0976C13.3223 12.3892 13.9916 12.4531 14.1875 12.4531C14.446 12.4531 14.6562 12.2428 14.6562 11.9844C14.6562 11.7215 14.3783 11.5156 14.0234 11.5156C12.5002 11.5156 11.3516 10.508 11.3516 9.17188C11.3516 8.07341 12.1113 7.14945 13.1328 6.89684V6.82812C13.1328 6.31034 13.5525 5.89062 14.0703 5.89062C14.5881 5.89062 15.0078 6.31034 15.0078 6.82812V7.00063C15.2487 7.06414 15.5159 7.15006 15.8164 7.26688C16.2989 7.45452 16.538 7.99784 16.3503 8.48042C16.1626 8.963 15.6192 9.20206 15.1368 9.01437C14.4334 8.74081 14.0283 8.70312 13.6953 8.70312C13.4368 8.70312 13.2266 8.91341 13.2266 9.17188C13.2266 9.43911 13.5692 9.64062 14.0234 9.64062C15.4297 9.64062 16.5312 10.6701 16.5312 11.9844C16.5312 12.9882 15.8967 13.8464 15.0078 14.1796V14.3281C15.0078 14.8459 14.5881 15.2656 14.0703 15.2656C13.5525 15.2656 13.1328 14.8459 13.1328 14.3281Z",
            fill: "#767B90"
        })
    });
};
const $4ed3d4aabf5e4436$var$AuditLogIcon = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        className: "center-vertically f3 pa l0",
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z",
            fill: "#4A67FF"
        })
    });
};










function $4ed3d4aabf5e4436$export$2e2bcd8739ae039() {
    let dispatch = (0, $20d80f3cecee513e$export$8ad76b76a4c905f8)();
    let modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    let reduxUser = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    let { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.company);
    let [user, setUser] = (0, $acw62.useState)();
    let [attachment, setAttachment] = (0, $acw62.useState)([]);
    let [bugDescription, setBugDescription] = (0, $acw62.useState)();
    let [permissionLevel, setPermissionLevel] = (0, $acw62.useState)('ALL');
    (0, $acw62.useEffect)(()=>{
        if (reduxUser && reduxUser['role'] == 'Advisor' && Object.keys(selectedCompany).length && selectedCompany['advisors'] && selectedCompany['advisors']?.[reduxUser['_id']] && selectedCompany['advisors']?.[reduxUser['_id']]?.['type']) {
            permissionLevel = selectedCompany['advisors']?.[reduxUser['_id']]?.['type'];
            setPermissionLevel(permissionLevel);
        }
        if (reduxUser && reduxUser['role'] == 'Investor' && Object.keys(selectedCompany).length && selectedCompany['investors'] && selectedCompany['investors']?.[reduxUser['_id']] && selectedCompany['investors']?.[reduxUser['_id']]?.['type']) {
            permissionLevel = selectedCompany['investors']?.[reduxUser['_id']]?.['type'];
            setPermissionLevel(permissionLevel);
        }
    }, [
        selectedCompany
    ]);
    (0, $acw62.useEffect)(()=>{
        getUser();
    }, []);
    const handeResetSelectedCompany = ()=>{
        dispatch((0, $b4397434d961d2b4$export$56500b0941c6fe84)({}));
    };
    const updateUserType = async ()=>{
        if (user && user['type'] == 'Superflow') {
            let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/user/updateUserType', {
                type: 'User'
            });
            if (res['code'] != '200') (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res['message']);
        }
    };
    const getUser = async ()=>{
        let userProfile = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
        const { body: body } = userProfile;
        setUser(body["user"]);
    };
    const onDragOver = (e)=>e.preventDefault();
    const onDrop = (e)=>{
        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        e.target.querySelector("input").value = null;
        handleAttachmentFile(e);
    };
    const handleAttachmentFile = async (e)=>{
        if (e.target.files) {
            let newAttachment = [];
            for (const file of e.target.files)await newAttachment.push(file);
            setAttachment(newAttachment);
        }
    };
    const hideBugPopup = ()=>{
        setBugDescription("");
        setAttachment([]);
        dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
            open: ""
        }));
    };
    const handleDelete = async (targetFile)=>{
        let updateAttachments = await attachment.filter((file)=>file.name !== targetFile.name);
        setAttachment(updateAttachments);
    };
    const handleSubmitBug = async ()=>{
        if (!bugDescription) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please add bug description!");
        const wordCount = bugDescription?.split(/\s+/).length;
        if (wordCount < 5) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)("Please elaborate bug in minimum five words");
        let data;
        if (attachment) data = {
            attachment: attachment,
            bugDescription: bugDescription
        };
        else data = {
            bugDescription: bugDescription
        };
        let res = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)("/user/reportBug", data);
        hideBugPopup();
        if (res || res["code"] == 200) {
            (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(res["message"]);
            dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                open: ""
            }));
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
        className: `pf t0 l0 zi2 h100 shadow bg1 zi3 poppins-font-style ${user?.['type'] == 'External' && 'dn'}`,
        style: {
            zIndex: '1200'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                id: "expandHeader",
                style: {
                    borderWidth: "15px"
                },
                className: "bss bo1 oxh wsn df fdc h100 poppins-font-style",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "ass df fdc aic mb1rem",
                        to: "/",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            id: "logo",
                            className: "w10rem",
                            src: (parcelRequire("aR1CT")),
                            alt: "TODO"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w100 wsn pr df fdc fs1rem fw500 h90vh",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df fdc",
                                style: {
                                    minHeight: '30vh'
                                },
                                children: [
                                    user?.['role'] == "Guest" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        onClick: handeResetSelectedCompany,
                                        className: "c6 c6-hover usn pr pl3rem bsbb w100 td250 my1rem px0-5rem ass cna",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 576 512",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M343.1 416H232.9C227.4 406.5 224 395.8 224 384c0-35.38 28.62-64 64-64c5.625 0 11 1 16.25 2.375l108.5-144.8c8-10.62 23-12.75 33.62-4.875c10.62 8 12.75 23 4.875 33.63l-108.6 144.8C348.5 360.8 352 371.9 352 384C352 395.8 348.6 406.5 343.1 416z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M288 32c-159 0-288 129-288 288c0 52.75 14.25 102.3 39 144.8c5.625 9.625 16.38 15.25 27.5 15.25h443c11.12 0 21.88-5.625 27.5-15.25C561.8 422.3 576 372.8 576 320C576 161 447 32 288 32zM288 96c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S270.4 96 288 96zM96 384c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S113.6 384 96 384zM144 224c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S161.6 224 144 224zM343.1 416H232.9C227.4 406.5 224 395.8 224 384c0-35.38 28.62-64 64-64c5.625 0 11 1 16.25 2.375l108.5-144.8c8-10.62 23-12.75 33.62-4.875c10.62 8 12.75 23 4.875 33.63l-108.6 144.8C348.5 360.8 352 371.9 352 384C352 395.8 348.6 406.5 343.1 416zM480 384c-17.62 0-31.92-14.38-31.92-32s14.38-32 32-32S512 334.4 512 352S497.6 384 480 384z"
                                                    })
                                                ]
                                            }),
                                            "Company Index"
                                        ]
                                    }) : user?.["role"] == "Advisor" || user?.["role"] == "Investor" ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: user?.["role"] == "Advisor" ? $16250bd714b02a14$export$fa573b5b2799a94a : $16250bd714b02a14$export$c45d6aa39a7ae97c,
                                        onClick: handeResetSelectedCompany,
                                        className: "c6 c6-hover usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f33 f3-hover pa l0",
                                                width: "28",
                                                height: "28",
                                                viewBox: "0 0 28 28",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "f33 f3-hover",
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M5.0776 2.33398C3.59327 2.33398 2.33594 3.59132 2.33594 5.07565V10.3257C2.33594 11.81 3.59327 13.0673 5.0776 13.0673H10.3276C11.812 13.0673 13.0693 11.81 13.0693 10.3257V5.07565C13.0693 3.59132 11.812 2.33398 10.3276 2.33398H5.0776ZM4.66927 5.07565C4.66927 4.87999 4.88193 4.66732 5.0776 4.66732H10.3276C10.5233 4.66732 10.7359 4.87999 10.7359 5.07565V10.3257C10.7359 10.5213 10.5233 10.734 10.3276 10.734H5.0776C4.88193 10.734 4.66927 10.5213 4.66927 10.3257V5.07565Z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "f33 f3-hover",
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M17.6792 2.33398C16.1948 2.33398 14.9375 3.59132 14.9375 5.07565V10.3257C14.9375 11.81 16.1948 13.0673 17.6792 13.0673H22.9292C24.4135 13.0673 25.6708 11.81 25.6708 10.3257V5.07565C25.6708 3.59132 24.4135 2.33398 22.9292 2.33398H17.6792ZM17.2708 5.07565C17.2708 4.87999 17.4835 4.66732 17.6792 4.66732H22.9292C23.1248 4.66732 23.3375 4.87999 23.3375 5.07565V10.3257C23.3375 10.5213 23.1248 10.734 22.9292 10.734H17.6792C17.4835 10.734 17.2708 10.5213 17.2708 10.3257V5.07565Z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "f33 f3-hover",
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M2.33594 17.6753C2.33594 16.1909 3.59327 14.9336 5.0776 14.9336H10.3276C11.812 14.9336 13.0693 16.1909 13.0693 17.6753V22.9253C13.0693 24.4096 11.812 25.6669 10.3276 25.6669H5.0776C3.59327 25.6669 2.33594 24.4096 2.33594 22.9253V17.6753ZM5.0776 17.2669C4.88193 17.2669 4.66927 17.4796 4.66927 17.6753V22.9253C4.66927 23.1209 4.88193 23.3336 5.0776 23.3336H10.3276C10.5233 23.3336 10.7359 23.1209 10.7359 22.9253V17.6753C10.7359 17.4796 10.5233 17.2669 10.3276 17.2669H5.0776Z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "f33 f3-hover",
                                                        "fill-rule": "evenodd",
                                                        "clip-rule": "evenodd",
                                                        d: "M17.6792 14.9336C16.1948 14.9336 14.9375 16.1909 14.9375 17.6753V22.9253C14.9375 24.4096 16.1948 25.6669 17.6792 25.6669H22.9292C24.4135 25.6669 25.6708 24.4096 25.6708 22.9253V17.6753C25.6708 16.1909 24.4135 14.9336 22.9292 14.9336H17.6792ZM17.2708 17.6753C17.2708 17.4796 17.4835 17.2669 17.6792 17.2669H22.9292C23.1248 17.2669 23.3375 17.4796 23.3375 17.6753V22.9253C23.3375 23.1209 23.1248 23.3336 22.9292 23.3336H17.6792C17.4835 23.3336 17.2708 23.1209 17.2708 22.9253V17.6753Z"
                                                    })
                                                ]
                                            }),
                                            user?.["role"] == "Advisor" ? "Client " : "Portfolio ",
                                            " View"
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: $16250bd714b02a14$export$4695c1a423ffe431,
                                        onClick: ()=>{
                                            updateUserType();
                                        },
                                        className: "c6 c6-hover usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                viewBox: "0 0 576 512",
                                                className: "center-vertically f3 pa l0 w2rem",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-primary",
                                                        d: "M343.1 416H232.9C227.4 406.5 224 395.8 224 384c0-35.38 28.62-64 64-64c5.625 0 11 1 16.25 2.375l108.5-144.8c8-10.62 23-12.75 33.62-4.875c10.62 8 12.75 23 4.875 33.63l-108.6 144.8C348.5 360.8 352 371.9 352 384C352 395.8 348.6 406.5 343.1 416z"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        className: "fa-secondary",
                                                        d: "M288 32c-159 0-288 129-288 288c0 52.75 14.25 102.3 39 144.8c5.625 9.625 16.38 15.25 27.5 15.25h443c11.12 0 21.88-5.625 27.5-15.25C561.8 422.3 576 372.8 576 320C576 161 447 32 288 32zM288 96c17.62 0 32 14.38 32 32s-14.38 32-32 32s-32-14.38-32-32S270.4 96 288 96zM96 384c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S113.6 384 96 384zM144 224c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S161.6 224 144 224zM343.1 416H232.9C227.4 406.5 224 395.8 224 384c0-35.38 28.62-64 64-64c5.625 0 11 1 16.25 2.375l108.5-144.8c8-10.62 23-12.75 33.62-4.875c10.62 8 12.75 23 4.875 33.63l-108.6 144.8C348.5 360.8 352 371.9 352 384C352 395.8 348.6 406.5 343.1 416zM480 384c-17.62 0-31.92-14.38-31.92-32s14.38-32 32-32S512 334.4 512 352S497.6 384 480 384z"
                                                    })
                                                ]
                                            }),
                                            "Company Index"
                                        ]
                                    }),
                                    [
                                        'Advisor',
                                        'Investor'
                                    ].includes(user?.["role"]) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        onClick: handeResetSelectedCompany,
                                        to: user?.["role"] == 'Advisor' ? $16250bd714b02a14$export$5c5adc4f183023d2 : $16250bd714b02a14$export$fec5a8397856135d,
                                        className: "c6 c6-hover usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 w2rem",
                                                width: "28",
                                                height: "28",
                                                viewBox: "0 0 28 28",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M21.0032 6.87501H11.2171C11.0107 6.29119 10.6045 5.79915 10.0704 5.48583C9.53628 5.17251 8.9086 5.0581 8.2983 5.16281C7.68799 5.26752 7.13434 5.58462 6.73522 6.05805C6.3361 6.53149 6.11719 7.13078 6.11719 7.75001C6.11719 8.36923 6.3361 8.96852 6.73522 9.44196C7.13434 9.91539 7.68799 10.2325 8.2983 10.3372C8.9086 10.4419 9.53628 10.3275 10.0704 10.0142C10.6045 9.70087 11.0107 9.20882 11.2171 8.62501H21.0032C21.2353 8.62501 21.4579 8.53282 21.622 8.36872C21.786 8.20463 21.8782 7.98207 21.8782 7.75001C21.8782 7.51794 21.786 7.29538 21.622 7.13129C21.4579 6.96719 21.2353 6.87501 21.0032 6.87501ZM8.75324 8.62501C8.58018 8.62501 8.41101 8.57369 8.26711 8.47754C8.12322 8.3814 8.01107 8.24474 7.94484 8.08485C7.87861 7.92497 7.86129 7.74903 7.89505 7.5793C7.92881 7.40957 8.01215 7.25366 8.13452 7.13129C8.25689 7.00892 8.4128 6.92558 8.58253 6.89182C8.75227 6.85806 8.9282 6.87538 9.08808 6.94161C9.24797 7.00784 9.38463 7.11999 9.48077 7.26388C9.57692 7.40777 9.62824 7.57695 9.62824 7.75001C9.62824 7.98207 9.53605 8.20463 9.37195 8.36872C9.20786 8.53282 8.9853 8.62501 8.75324 8.62501Z",
                                                        fill: "#767B90"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M21 13.125H16.4638C16.2855 12.6137 15.9525 12.1706 15.511 11.857C15.0696 11.5435 14.5415 11.375 14 11.375C13.4585 11.375 12.9304 11.5435 12.489 11.857C12.0475 12.1706 11.7145 12.6137 11.5362 13.125H7C6.76794 13.125 6.54538 13.2172 6.38128 13.3812C6.21719 13.5453 6.125 13.7679 6.125 14C6.125 14.232 6.21719 14.4546 6.38128 14.6187C6.54538 14.7828 6.76794 14.875 7 14.875H11.5362C11.7145 15.3862 12.0475 15.8294 12.489 16.1429C12.9304 16.4565 13.4585 16.6249 14 16.6249C14.5415 16.6249 15.0696 16.4565 15.511 16.1429C15.9525 15.8294 16.2855 15.3862 16.4638 14.875H21C21.2321 14.875 21.4546 14.7828 21.6187 14.6187C21.7828 14.4546 21.875 14.232 21.875 14C21.875 13.7679 21.7828 13.5453 21.6187 13.3812C21.4546 13.2172 21.2321 13.125 21 13.125ZM14 14.875C13.8269 14.875 13.6578 14.8237 13.5139 14.7275C13.37 14.6314 13.2578 14.4947 13.1916 14.3348C13.1254 14.1749 13.1081 13.999 13.1418 13.8293C13.1756 13.6595 13.2589 13.5036 13.3813 13.3812C13.5037 13.2589 13.6596 13.1755 13.8293 13.1418C13.999 13.108 14.175 13.1253 14.3348 13.1916C14.4947 13.2578 14.6314 13.37 14.7275 13.5138C14.8237 13.6577 14.875 13.8269 14.875 14C14.875 14.232 14.7828 14.4546 14.6187 14.6187C14.4546 14.7828 14.2321 14.875 14 14.875Z",
                                                        fill: "#767B90"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M21.0032 19.375H11.2171C11.0107 18.7912 10.6045 18.2991 10.0704 17.9858C9.53628 17.6725 8.9086 17.5581 8.2983 17.6628C7.68799 17.7675 7.13434 18.0846 6.73522 18.5581C6.3361 19.0315 6.11719 19.6308 6.11719 20.25C6.11719 20.8692 6.3361 21.4685 6.73522 21.942C7.13434 22.4154 7.68799 22.7325 8.2983 22.8372C8.9086 22.9419 9.53628 22.8275 10.0704 22.5142C10.6045 22.2009 11.0107 21.7088 11.2171 21.125H21.0032C21.2353 21.125 21.4579 21.0328 21.622 20.8687C21.786 20.7046 21.8782 20.4821 21.8782 20.25C21.8782 20.0179 21.786 19.7954 21.622 19.6313C21.4579 19.4672 21.2353 19.375 21.0032 19.375ZM8.75324 21.125C8.58018 21.125 8.41101 21.0737 8.26711 20.9775C8.12322 20.8814 8.01107 20.7447 7.94484 20.5849C7.87861 20.425 7.86129 20.249 7.89505 20.0793C7.92881 19.9096 8.01215 19.7537 8.13452 19.6313C8.25689 19.5089 8.4128 19.4256 8.58253 19.3918C8.75227 19.3581 8.9282 19.3754 9.08808 19.4416C9.24797 19.5078 9.38463 19.62 9.48077 19.7639C9.57692 19.9078 9.62824 20.0769 9.62824 20.25C9.62824 20.4821 9.53605 20.7046 9.37195 20.8687C9.20786 21.0328 8.9853 21.125 8.75324 21.125Z",
                                                        fill: "#767B90"
                                                    })
                                                ]
                                            }),
                                            user?.["role"],
                                            " Settings"
                                        ]
                                    }),
                                    selectedCompany && Object.keys(selectedCompany).length > 0 && user && user?.['role'] && [
                                        'User',
                                        'Member',
                                        'Admin'
                                    ].includes(user?.['role']) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        onClick: ()=>updateUserType(),
                                        className: "usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                        to: `/company/company-settings/${selectedCompany._id}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1bb46af2548eb120$export$2e2bcd8739ae039), {
                                                className: "center-vertically f3 pa l0",
                                                style: {
                                                    width: "30px",
                                                    color: "#767b90"
                                                }
                                            }),
                                            "Company Settings"
                                        ]
                                    }),
                                    user?.["email"] != "temp" && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: $16250bd714b02a14$export$91c3232a793620f2,
                                                onClick: ()=>{
                                                    updateUserType(), handeResetSelectedCompany();
                                                },
                                                className: "usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                        className: "center-vertically f3 pa l0 w2rem",
                                                        width: "28",
                                                        height: "28",
                                                        viewBox: "0 0 28 28",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M20.7702 14.1576C20.689 14.0746 20.5921 14.0086 20.4851 13.9634C20.3781 13.9183 20.2632 13.8949 20.1471 13.8945C20.031 13.8942 19.916 13.917 19.8087 13.9616C19.7015 14.0062 19.6042 14.0717 19.5226 14.1542C19.4409 14.2368 19.3765 14.3348 19.3331 14.4425C19.2897 14.5502 19.2682 14.6655 19.2698 14.7816C19.2714 14.8977 19.2961 15.0123 19.3424 15.1188C19.3888 15.2252 19.4559 15.3214 19.5398 15.4017C20.2821 16.1322 20.8711 17.0036 21.2721 17.9648C21.6731 18.926 21.8781 19.9576 21.875 20.9991C21.875 22.0693 18.8074 23.6241 14 23.6241C9.1927 23.6241 6.12504 22.0685 6.12504 20.9973C6.1221 19.963 6.32434 18.9384 6.72007 17.9827C7.11581 17.0271 7.69716 16.1594 8.43049 15.43C8.51343 15.3491 8.57949 15.2526 8.62484 15.146C8.67018 15.0394 8.69391 14.9248 8.69465 14.809C8.69538 14.6932 8.67311 14.5783 8.62912 14.4712C8.58512 14.364 8.52029 14.2667 8.43838 14.1847C8.35647 14.1028 8.25911 14.038 8.15195 13.994C8.04479 13.95 7.92996 13.9277 7.81412 13.9285C7.69828 13.9292 7.58374 13.9529 7.47715 13.9983C7.37055 14.0436 7.27402 14.1097 7.19315 14.1926C6.29665 15.0844 5.58596 16.1452 5.10222 17.3135C4.61849 18.4819 4.37132 19.7346 4.37504 20.9991C4.37504 23.8407 9.33367 25.3741 14 25.3741C18.6664 25.3741 23.625 23.8407 23.625 20.9991C23.6289 19.726 23.3784 18.4651 22.8881 17.2902C22.3979 16.1154 21.6778 15.0503 20.7702 14.1576Z",
                                                                fill: "#767B90"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                                d: "M14 14.875C15.2114 14.875 16.3956 14.5158 17.4029 13.8428C18.4101 13.1697 19.1952 12.2131 19.6588 11.0939C20.1224 9.97474 20.2436 8.74321 20.0073 7.55507C19.771 6.36694 19.1876 5.27557 18.331 4.41897C17.4744 3.56238 16.3831 2.97903 15.1949 2.74269C14.0068 2.50636 12.7753 2.62765 11.6561 3.09124C10.5369 3.55483 9.58027 4.33988 8.90725 5.34713C8.23422 6.35439 7.875 7.53859 7.875 8.75C7.87688 10.3739 8.52279 11.9307 9.67104 13.079C10.8193 14.2272 12.3761 14.8731 14 14.875ZM14 4.375C14.8653 4.375 15.7112 4.63159 16.4306 5.11232C17.1501 5.59305 17.7108 6.27634 18.042 7.07576C18.3731 7.87519 18.4597 8.75486 18.2909 9.60352C18.1221 10.4522 17.7054 11.2317 17.0936 11.8436C16.4817 12.4554 15.7022 12.8721 14.8535 13.0409C14.0049 13.2097 13.1252 13.1231 12.3258 12.792C11.5263 12.4608 10.8431 11.9001 10.3623 11.1806C9.88159 10.4612 9.625 9.6153 9.625 8.75C9.62637 7.5901 10.0877 6.4781 10.9079 5.65792C11.7281 4.83774 12.8401 4.37637 14 4.375Z",
                                                                fill: "#767B90"
                                                            })
                                                        ]
                                                    }),
                                                    "User Profile"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: $16250bd714b02a14$export$893498aa7359709f,
                                                onClick: handeResetSelectedCompany,
                                                className: "usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($4ed3d4aabf5e4436$var$BillingIcon, {}),
                                                    "Billing"
                                                ]
                                            }),
                                            selectedCompany && (selectedCompany['subscription'] == 'Lite' || selectedCompany['subscription'] == 'Pro') && user?.['type'] != 'Superflow' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                to: "#company-audit-log",
                                                className: "usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($4ed3d4aabf5e4436$var$AuditLogIcon, {}),
                                                    "Audit Log"
                                                ]
                                            })
                                        ]
                                    }),
                                    user?.["role"] == "Admin" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: $16250bd714b02a14$export$df7a117e66af0ef0,
                                            onClick: handeResetSelectedCompany,
                                            className: "dropdown-item usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                    className: "center-vertically f3 pa l0 w2rem",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 512 512",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-primary",
                                                            d: "M384 278.6c-23.16-23.16-57.57-27.57-85.39-13.9L191.1 158L191.1 95.99l-127.1-95.99L0 63.1l96 127.1l62.04 .0077l106.7 106.6c-13.67 27.82-9.251 62.23 13.91 85.39l117 117.1c14.62 14.5 38.21 14.5 52.71-.0016l52.75-52.75c14.5-14.5 14.5-38.08-.0016-52.71L384 278.6z"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            className: "fa-secondary",
                                                            d: "M227.9 307L168.7 247.9l-148.9 148.9c-26.37 26.37-26.37 69.08 0 95.45C32.96 505.4 50.21 512 67.5 512s34.54-6.592 47.72-19.78l119.1-119.1C225.5 352.3 222.6 329.4 227.9 307zM64 472c-13.25 0-24-10.75-24-24c0-13.26 10.75-24 24-24S88 434.7 88 448C88 461.3 77.25 472 64 472zM507.7 109.3c-1.641-6.43-8.184-10.31-14.61-8.67c-2.094 .5352-4.006 1.623-5.533 3.152l-74.45 74.5l-67.96-11.32l-11.32-68.01l74.45-74.45c4.697-4.688 4.707-12.29 .0195-16.99c-1.564-1.568-3.531-2.674-5.686-3.193c-49.09-12.22-100.1 2.191-136.7 37.98C226.2 81.94 215.2 139.5 231.8 189.6L227.7 193.7l70.95 70.97c28.5-14.14 62.84-8.55 85.39 13.9l7.516 7.474c29.64-4.719 57.03-18.67 78.22-39.93C505.6 210.3 519.1 158.4 507.7 109.3z"
                                                        })
                                                    ]
                                                }),
                                                "Admin"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                class: "df fdc",
                                style: {
                                    minHeight: '23vh'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4501f0db6859ce3$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "bottom-support df fdc w100",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "join-community-wrapper pr my1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                className: "join-community-icon",
                                                src: (parcelRequire("jbHw4")),
                                                alt: "Community"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "join-community-card bg5 bw1px bo3 br15px bss p1rem",
                                                style: {
                                                    width: '205px'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                        class: "df",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                className: "",
                                                                src: (parcelRequire("lnUEE")),
                                                                alt: "Join our community"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h4", {
                                                                className: "c15 fs14px fw500 lh1 mb1rem",
                                                                children: [
                                                                    "Join the ",
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                                        className: "w90",
                                                                        src: (parcelRequire("79gM3")),
                                                                        alt: ""
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                                    "community"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        className: "c12 fs13px fw300 mb1rem lh2 pl1-5rem",
                                                        children: [
                                                            "Connect with 2,000+",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "founders, investors &",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                            "advisors."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        class: "df jcc mb0-5rem",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                                    open: 'join-community-popup'
                                                                })),
                                                            className: "cp tac bg4 c1 br15px py0-5rem px2rem fw500 fs0-75rem",
                                                            children: "Find out more"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        className: "dropdown-item usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass",
                                        to: "https://intercom.help/diligentsia-limited/en",
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                                className: "center-vertically f3 pa l0 w2rem",
                                                width: "28",
                                                height: "28",
                                                viewBox: "0 0 28 28",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M14 2C7.36705 2 2 7.36752 2 14C2 20.633 7.36752 26 14 26C20.633 26 26 20.6325 26 14C26 7.36705 20.6324 2 14 2ZM14 24.125C8.40345 24.125 3.875 19.5962 3.875 14C3.875 8.40345 8.40383 3.875 14 3.875C19.5965 3.875 24.125 8.40383 24.125 14C24.125 19.5965 19.5961 24.125 14 24.125Z",
                                                        fill: "#767B90"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M14 12.0449C13.4822 12.0449 13.0625 12.4646 13.0625 12.9824V19.0196C13.0625 19.5374 13.4822 19.9571 14 19.9571C14.5178 19.9571 14.9375 19.5373 14.9375 19.0195V12.9824C14.9375 12.4646 14.5178 12.0449 14 12.0449Z",
                                                        fill: "#767B90"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                        d: "M14 10.8984C14.699 10.8984 15.2656 10.3318 15.2656 9.63281C15.2656 8.93383 14.699 8.36719 14 8.36719C13.301 8.36719 12.7344 8.93383 12.7344 9.63281C12.7344 10.3318 13.301 10.8984 14 10.8984Z",
                                                        fill: "#767B90"
                                                    })
                                                ]
                                            }),
                                            "Help Centre"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "usn pr pl3rem bsbb w100 td250 c4-hover my1rem px0-5rem ass cp",
                                        onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                                open: 'confirmLogout'
                                            })),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                className: "center-vertically f9 pa l0 w2rem",
                                                width: "24",
                                                height: "22",
                                                viewBox: "0 0 24 22",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d: "M3.57538 3.57524C7.01194 0.138669 12.2353 -0.416571 16.2505 1.90417C16.8084 2.22662 16.9991 2.94023 16.6768 3.49809C16.3543 4.05594 15.6407 4.24677 15.0829 3.92434C11.9592 2.11895 7.89612 2.55432 5.22529 5.22515C2.03601 8.41443 2.03601 13.5853 5.22529 16.7746C7.89612 19.4453 11.9592 19.8807 15.0829 18.0753C15.6407 17.753 16.3543 17.9437 16.6768 18.5016C16.9991 19.0595 16.8084 19.773 16.2505 20.0955C12.2353 22.4162 7.01194 21.861 3.57538 18.4245C-0.525127 14.324 -0.525127 7.67573 3.57538 3.57524ZM18.3417 6.6749C18.7973 6.21928 19.536 6.21928 19.9916 6.6749L22.198 8.88128C22.4063 9.08953 22.609 9.29218 22.7668 9.47792C22.9399 9.68197 23.1261 9.94085 23.2359 10.2788C23.3881 10.7475 23.3881 11.2523 23.2359 11.7208C23.1261 12.0589 22.9399 12.3178 22.7668 12.5218C22.609 12.7075 22.4063 12.9103 22.198 13.1184L19.9916 15.3248C19.536 15.7804 18.7973 15.7804 18.3417 15.3248C17.8861 14.8692 17.8861 14.1305 18.3417 13.6749L19.8501 12.1665H11C10.3557 12.1665 9.83333 11.6442 9.83333 10.9998C9.83333 10.3555 10.3557 9.83317 11 9.83317H19.8501L18.3417 8.32481C17.8861 7.8692 17.8861 7.1305 18.3417 6.6749Z",
                                                    fill: "#767B90"
                                                })
                                            }),
                                            "Logout"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal["open"] == "report-bug",
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ""
                    })),
                className: "backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "close-popup",
                            onClick: ()=>hideBugPopup(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                style: {
                                    position: "relative",
                                    top: "4px"
                                },
                                className: "pen fds h1rem f1 mr0-5rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 320 512",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    className: "pen fa-primary",
                                    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                            className: "text-gradient fs2rem tac lh1 fw600 mb2rem",
                            children: [
                                " ",
                                "Report a Bug"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pr mb1rem",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                    children: [
                                        "Enter a description of the bug or suggested improvement below....",
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "It is always useful if you are able to attach a screenshot..."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                    rows: "4",
                                    value: bugDescription,
                                    onChange: (e)=>setBugDescription(e.target.value),
                                    placeholder: "Please add bug description or suggestion for improvement here",
                                    className: "bss bw2px bo5 w100 br5px p1rem mt1rem"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                            onDragOver: onDragOver,
                            onDrop: (e)=>onDrop(e),
                            for: "attachment",
                            className: "w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "pen fs1rem fw500 tac",
                                    children: "Click here or drag and drop attachment (max 5MB)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    multiple: true,
                                    type: "file",
                                    className: "dn",
                                    id: "attachment",
                                    onChange: (e)=>handleAttachmentFile(e),
                                    accept: "image/jpeg, image/jpg, image/png"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "df fdc aic my1rem",
                            children: attachment && attachment.map((item, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "df jcc br25px lh1 bg3 c1 px1rem fw600 mt0-5rem",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: item,
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "py0-5rem pl0-5rem",
                                                children: item["name"].substring(0, 20) + "..."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            onClick: ()=>handleDelete(item),
                                            className: "p0-5rem f9 w1rem h1rem cp",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 320 512",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                className: "pen fa-primary",
                                                d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32.0 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                                            })
                                        })
                                    ]
                                }, item["name"]))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "df jcse",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                            open: ""
                                        })),
                                    className: "shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    onClick: ()=>handleSubmitBug(),
                                    className: "shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bdcbfecdf3275a2$export$2e2bcd8739ae039), {
                open: modal['open'] == 'join-community-popup',
                onClose: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                        open: ''
                    })),
                className: "backdrop td500 zi4 df jcc aic",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "poppins-font-style w100 maw1300px mah100 bg1 shadow df jcc pr",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w70 pl5rem px3rem py2rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "w100 h100 df fdc jcsb",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "df jcsb",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                            href: "https://www.startup2standup.com/",
                                            target: "_blank",
                                            class: "cp df fdc c15 fs0-75rem",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    className: "w50",
                                                    src: (parcelRequire("79gM3")),
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    class: "w100 mt0-5rem ml0-5rem c12",
                                                    children: "www.startup2standup.com"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "w100 df fdc c15 my3rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c4 fs14px fw400 mb0-5rem",
                                                children: "A founder community built to cut through isolation and drive growth with peer support."
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "w100 fs28px fw500 lh2 mb1-5rem",
                                                children: [
                                                    "A supportive network and structured resources ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " for startup and growth founders"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: "w100 c14 fs1rem fw300 mb1-5rem",
                                                children: "Shared experience, encouragement and practical insight to accelerate your journey"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                                class: "fs14px fw300 pl1rem mb1rem c14",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        class: "mb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Community of founders"
                                                            }),
                                                            " who understand the entrepreneurial grind"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                        class: "mb0-5rem",
                                                        children: "Peer-to-peer support, shared learning and encouragement"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        class: "mb0-5rem",
                                                        children: [
                                                            "Group sessions, ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "expert"
                                                            }),
                                                            " input and practical ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "workshops"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        class: "mb0-5rem",
                                                        children: [
                                                            "Access to a curated ",
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "network of investors and specialist advisors"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        class: "mb0-5rem",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                                children: "Expert insight"
                                                            }),
                                                            " at a founder-friendly, low-cost entry point"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                class: `w100 c15 fs1rem fw400 my1-5rem`,
                                                children: "Supportive ecosystem tailored to early-stage and scaling founders"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            class: "w30",
                            style: {
                                backgroundColor: '#99ceff'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                class: "df fdc aic w100 h100",
                                style: {
                                    backgroundImage: `url(${(parcelRequire("bEnHb"))})`,
                                    backgroundPosition: 'center',
                                    backgroundSize: 'cover'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        class: "w100 df jcfe mt1rem",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            class: "mr2-5rem",
                                            src: (parcelRequire("jSVu6"))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        class: "w50 mt0-5rem",
                                        src: (parcelRequire("79gM3"))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "new-shadow df fdc aic br10px mx4rem mt4rem p1rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                class: "pr w50",
                                                style: {
                                                    bottom: '25%'
                                                },
                                                src: (parcelRequire("jUCG1"))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "c15 fs1rem fw500 tac lh2 pr",
                                                style: {
                                                    bottom: '10%'
                                                },
                                                children: [
                                                    "Limited free trial - ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " 3 introductory founder ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " sessions"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "c14 fs10px fw300 tac lh2",
                                                children: [
                                                    "Let the SU2SU community help you get to ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " where you want to get, more quickly ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " with less stress"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                                className: "df jcc aic cp bg4 c1 br15px py0-5rem px2rem fw500 fs0-75rem my1-5rem",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        class: "mr1rem",
                                                        children: "Try for free"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                                        width: "17",
                                                        height: "12",
                                                        viewBox: "0 0 28 25",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                            d: "M2.57843 14.5715H21.6274L15.8315 21.1082C14.1667 22.9858 16.6639 25.8021 18.3287 23.9245L23.6072 17.9621L27.1308 13.9818C27.8138 13.207 27.8138 11.9557 27.1308 11.1809L18.3287 1.24207C17.9938 0.853956 17.5329 0.636189 17.0526 0.640694C15.4672 0.640919 14.6892 2.8187 15.8315 4.05856L21.6411 10.5953H2.48727C0.0456802 10.7319 0.227984 14.7086 2.57843 14.5715Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        class: "df jcc px3rem mt2rem",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                class: "w20",
                                                src: (parcelRequire("dacuF"))
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                class: "c14 fs11px fw300 fsi lh2",
                                                children: [
                                                    "\u201CI\u2019m part of this vibrant community - it ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " works!  I suggest you give it a go...every ",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                    " Wednesday at 8.30am for 30 mins\u201D"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            className: "pa cp",
                            onClick: ()=>dispatch((0, $ee5327cdf6cdce8c$export$313c6d35f75fc0e)({
                                    open: ''
                                })),
                            style: {
                                left: '650px',
                                bottom: '-80px'
                            },
                            width: "60",
                            height: "60",
                            viewBox: "0 0 60 60",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                                    opacity: "0.8",
                                    x: "4",
                                    y: "4",
                                    width: "52",
                                    height: "52",
                                    rx: "26",
                                    fill: "#151313"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z",
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $3681f371b73747aa$exports = {};
'use strict';
function $3681f371b73747aa$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $acw62 = parcelRequire("acw62");
var $3681f371b73747aa$var$React__default = $3681f371b73747aa$var$_interopDefault($acw62);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $3681f371b73747aa$var$__assign = function() {
    $3681f371b73747aa$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3681f371b73747aa$var$__assign.apply(this, arguments);
};
function $3681f371b73747aa$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3681f371b73747aa$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $3681f371b73747aa$var$css_248z = ".scroll-to-top {\n  background-color: white;\n  right: 40px;\n  bottom: 40px;\n  position: fixed;\n  z-index: 2;\n  cursor: pointer;\n  border-radius: 7px;\n  width: 40px;\n  height: 40px;\n  box-shadow: 0 9px 25px 0 rgba(132, 128, 177, 0.28);\n  border: none;\n}\n\n.scroll-to-top:active {\n  transform: matrix(0.95, 0, 0, 0.95, 0, 0);\n}\n";
$3681f371b73747aa$var$styleInject($3681f371b73747aa$var$css_248z);
function $3681f371b73747aa$var$scrollToTop(smooth) {
    if (smooth === void 0) smooth = false;
    if (smooth) window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    else document.documentElement.scrollTop = 0;
}
var $3681f371b73747aa$var$ScrollToTop = function(_a) {
    var _b = _a.top, top = _b === void 0 ? 20 : _b, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.color, color = _d === void 0 ? "black" : _d, _e = _a.smooth, smooth = _e === void 0 ? false : _e, _f = _a.component, component = _f === void 0 ? "" : _f, _g = _a.viewBox, viewBox = _g === void 0 ? "0 0 256 256" : _g, _h = _a.svgPath, svgPath = _h === void 0 ? "M222.138,91.475l-89.6-89.6c-2.5-2.5-6.551-2.5-9.051,0l-89.6,89.6c-2.5,2.5-2.5,6.551,0,9.051s6.744,2.5,9.244,0L122,21.85  V249.6c0,3.535,2.466,6.4,6,6.4s6-2.865,6-6.4V21.85l78.881,78.676c1.25,1.25,2.992,1.875,4.629,1.875s3.326-0.625,4.576-1.875  C224.586,98.025,224.638,93.975,222.138,91.475z" : _h, _j = _a.width, width = _j === void 0 ? "28" : _j, _k = _a.height, height = _k === void 0 ? "28" : _k, props = $3681f371b73747aa$var$__rest(_a, [
        "top",
        "className",
        "color",
        "smooth",
        "component",
        "viewBox",
        "svgPath",
        "width",
        "height"
    ]);
    var _l = $acw62.useState(false), visible = _l[0], setVisible = _l[1];
    $acw62.useEffect(function() {
        var onScroll = function() {
            setVisible(document.documentElement.scrollTop >= top);
        };
        onScroll();
        document.addEventListener("scroll", onScroll);
        return function() {
            return document.removeEventListener("scroll", onScroll);
        };
    }, [
        top
    ]);
    return $3681f371b73747aa$var$React__default.createElement($3681f371b73747aa$var$React__default.Fragment, null, visible && $3681f371b73747aa$var$React__default.createElement("button", $3681f371b73747aa$var$__assign({
        className: "scroll-to-top " + className,
        onClick: function() {
            return $3681f371b73747aa$var$scrollToTop(smooth);
        },
        "aria-label": "Scroll to top"
    }, props), component || $3681f371b73747aa$var$React__default.createElement("svg", {
        width: width,
        height: height,
        fill: color,
        viewBox: viewBox
    }, $3681f371b73747aa$var$React__default.createElement("path", {
        d: svgPath
    }))));
};
$3681f371b73747aa$exports = $3681f371b73747aa$var$ScrollToTop;


function $743b6185e190fb3d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
                className: "w100 zi-1 pf b0 l0 bg5"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3681f371b73747aa$exports))), {
                smooth: true,
                viewBox: "9 0 9 45",
                svgPath: "M24.2285 18.1712C24.4081 18.3446 24.5513 18.552 24.6498 18.7814C24.7483 19.0107 24.8002 19.2574 24.8023 19.507C24.8045 19.7566 24.7569 20.0041 24.6624 20.2351C24.5679 20.4662 24.4283 20.6761 24.2518 20.8526C24.0753 21.0291 23.8654 21.1686 23.6344 21.2632C23.4034 21.3577 23.1559 21.4052 22.9063 21.4031C22.6567 21.4009 22.41 21.349 22.1806 21.2505C21.9513 21.152 21.7439 21.0088 21.5705 20.8293L15.3803 14.639V36.4185C15.3803 36.9171 15.1822 37.3952 14.8297 37.7477C14.4771 38.1003 13.999 38.2983 13.5005 38.2983C13.0019 38.2983 12.5238 38.1003 12.1712 37.7477C11.8187 37.3952 11.6206 36.9171 11.6206 36.4185V14.639L5.43044 20.8293C5.0759 21.1717 4.60106 21.3611 4.10818 21.3569C3.6153 21.3526 3.14382 21.1549 2.79529 20.8064C2.44676 20.4578 2.24906 19.9863 2.24477 19.4935C2.24049 19.0006 2.42997 18.5257 2.77239 18.1712L12.1714 8.77216C12.346 8.5971 12.5535 8.45821 12.7819 8.36345C13.0102 8.26868 13.2551 8.2199 13.5023 8.2199C13.7496 8.2199 13.9944 8.26868 14.2228 8.36345C14.4512 8.45821 14.6586 8.5971 14.8332 8.77216L24.2285 18.1712ZM24.7793 0.702148H2.2216C1.72305 0.702148 1.24491 0.900199 0.89238 1.25273C0.539848 1.60526 0.341797 2.0834 0.341797 2.58196C0.341797 3.08051 0.539848 3.55865 0.89238 3.91118C1.24491 4.26371 1.72305 4.46176 2.2216 4.46176H24.7793C25.2779 4.46176 25.756 4.26371 26.1085 3.91118C26.4611 3.55865 26.6591 3.08051 26.6591 2.58196C26.6591 2.0834 26.4611 1.60526 26.1085 1.25273C25.756 0.900199 25.2779 0.702148 24.7793 0.702148Z"
            })
        ]
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Generic tool icon for message badges
const $eb6c320ac2717c03$var$ToolIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const $eb6c320ac2717c03$var$ChatMessages = ({ messages: messages })=>{
    if (!messages || messages.length === 0) return null;
    const formatTime = (timestamp)=>{
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    const formatContent = (content)=>{
        if (!content) return '';
        // Simple markdown-like formatting
        return content.split('\n').map((line, i)=>{
            // Bold text
            line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
            // Bullet points
            if (line.startsWith('- ') || line.startsWith("\u2022 ")) return `<li key="${i}">${line.substring(2)}</li>`;
            // Numbered lists
            if (/^\d+\.\s/.test(line)) return `<li key="${i}">${line.replace(/^\d+\.\s/, '')}</li>`;
            return line;
        }).join('<br/>');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "clarence-messages",
        children: messages.map((msg, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `clarence-message clarence-message-${msg['role']}`,
                children: [
                    msg['role'] === 'assistant' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "clarence-message-avatar",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z",
                                    fill: "#6366f1"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M12 6v6l4 2",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-message-content",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "clarence-message-text",
                                dangerouslySetInnerHTML: {
                                    __html: formatContent(msg['content'])
                                }
                            }),
                            msg['sources'] && msg['sources'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "clarence-message-sources",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "sources-label",
                                        children: "Sources:"
                                    }),
                                    msg['sources'].map((source, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: source,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "source-link",
                                            children: source.split('/').pop()
                                        }, i))
                                ]
                            }),
                            msg['role'] === 'assistant' && msg['toolsUsed'] && msg['toolsUsed'].length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "message-tools-used",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "message-tools-label",
                                        children: "Tools used:"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "message-tools-badges",
                                        children: msg['toolsUsed'].map((tool, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "message-tool-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($eb6c320ac2717c03$var$ToolIcon, {}),
                                                    tool['displayName'] || tool['name']
                                                ]
                                            }, i))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "clarence-message-time",
                                children: formatTime(msg['timestamp'])
                            })
                        ]
                    })
                ]
            }, idx))
    });
};
var $eb6c320ac2717c03$export$2e2bcd8739ae039 = $eb6c320ac2717c03$var$ChatMessages;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $c66a69b5e86dec42$var$ChatInput = /*#__PURE__*/ (0, $acw62.forwardRef)(({ onSend: onSend, disabled: disabled, onFileSelect: onFileSelect, selectedFiles: selectedFiles }, ref)=>{
    const [message, setMessage] = (0, $acw62.useState)('');
    const inputRef = (0, $acw62.useRef)(null);
    // Expose focus method to parent
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            focus: ()=>inputRef.current?.focus()
        }));
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!message.trim() || disabled) return;
        onSend(message);
        setMessage('');
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clarence-input-container",
        children: [
            selectedFiles && selectedFiles.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "clarence-selected-files",
                children: selectedFiles.map((file, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "selected-file-chip",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: file.split('/').pop()
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>onFileSelect(selectedFiles.filter((_, i)=>i !== idx)),
                                children: "\xd7"
                            })
                        ]
                    }, idx))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                className: "clarence-input-form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                        ref: inputRef,
                        value: message,
                        onChange: (e)=>setMessage(e.target.value),
                        onKeyDown: handleKeyDown,
                        placeholder: "Ask Clarence about your documents...",
                        disabled: disabled,
                        rows: 1,
                        className: "clarence-input"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        type: "submit",
                        className: "clarence-send-btn",
                        disabled: disabled || !message.trim(),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    })
                ]
            })
        ]
    });
});
var $c66a69b5e86dec42$export$2e2bcd8739ae039 = $c66a69b5e86dec42$var$ChatInput;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
// Generic icon for tool badges
const $60f165536c9ffc45$var$ToolIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
// Generic icon for generating response
const $60f165536c9ffc45$var$SparkleIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z",
            stroke: "currentColor",
            strokeWidth: "2"
        })
    });
const $60f165536c9ffc45$var$AgentActions = ({ actions: actions })=>{
    if (!actions || actions.length === 0) return null;
    // Separate tool actions and general actions
    const toolActions = actions.filter((a)=>a['toolName']);
    const generalActions = actions.filter((a)=>!a['toolName']);
    // Get unique tools (keep latest status for each tool)
    const uniqueToolActions = [];
    const seenTools = new Set();
    for(let i = toolActions.length - 1; i >= 0; i--){
        const action = toolActions[i];
        if (!seenTools.has(action['toolName'])) {
            seenTools.add(action['toolName']);
            uniqueToolActions.unshift(action);
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clarence-agent-actions",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "agent-actions-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "pulse-dot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Clarence is working..."
                    })
                ]
            }),
            uniqueToolActions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "agent-tools-used",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "tools-label",
                        children: "Using tools:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "tools-badges",
                        children: uniqueToolActions.map((action, idx)=>{
                            const isComplete = action['status'] === 'completed';
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: `tool-badge ${isComplete ? 'completed' : 'active'}`,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($60f165536c9ffc45$var$ToolIcon, {}),
                                    action['toolDisplayName'] || action['toolName'],
                                    isComplete && /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        className: "tool-check",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M20 6L9 17l-5-5",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                ]
                            }, idx);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                className: "agent-actions-list",
                children: generalActions.map((action, idx)=>{
                    const isComplete = action['status'] === 'completed';
                    const isFailed = action['status'] === 'failed';
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        className: `agent-action-item ${action['status']}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "action-icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($60f165536c9ffc45$var$SparkleIcon, {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "action-label",
                                children: action['description'] || 'Processing...'
                            }),
                            !isComplete && !isFailed && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "action-spinner"
                            }),
                            isComplete && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "action-check",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M20 6L9 17l-5-5",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            isFailed && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "action-error",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M18 6L6 18M6 6l12 12",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round"
                                    })
                                })
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
var $60f165536c9ffc45$export$2e2bcd8739ae039 = $60f165536c9ffc45$var$AgentActions;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $89a9e7ddc60e9a10$var$SuggestedPrompts = ({ suggestions: suggestions, onSelect: onSelect })=>{
    if (!suggestions || suggestions.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clarence-suggestions",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "suggestions-label",
                children: "Suggested questions:"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "suggestions-list",
                children: suggestions.map((suggestion, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "suggestion-chip",
                        onClick: ()=>onSelect(suggestion),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: suggestion
                            })
                        ]
                    }, idx))
            })
        ]
    });
};
var $89a9e7ddc60e9a10$export$2e2bcd8739ae039 = $89a9e7ddc60e9a10$var$SuggestedPrompts;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $07bdfbdd1618c971$var$DOCUMENT_TYPES = [
    {
        code: 'D001',
        name: 'Key Shareholder/Investor Documents'
    },
    {
        code: 'D002',
        name: 'Commercial Activities'
    },
    {
        code: 'D003',
        name: 'Legal'
    },
    {
        code: 'D004',
        name: 'Property'
    },
    {
        code: 'D005',
        name: 'Intellectual Property'
    },
    {
        code: 'D006',
        name: 'Insurance'
    },
    {
        code: 'D007',
        name: 'Corporate Structure'
    },
    {
        code: 'D008',
        name: 'Financial Information'
    },
    {
        code: 'D009',
        name: 'Employment & HR'
    },
    {
        code: 'D010',
        name: 'Regulatory & Compliance'
    },
    {
        code: 'DXXX',
        name: 'Other / Unallocated'
    }
];
const $07bdfbdd1618c971$var$ClassificationConfirm = ({ classification: classification, onConfirm: onConfirm, onDismiss: onDismiss })=>{
    const [showCorrection, setShowCorrection] = (0, $acw62.useState)(false);
    const [selectedCode, setSelectedCode] = (0, $acw62.useState)(classification?.['suggestedSectionCode'] || '');
    const [selectedType, setSelectedType] = (0, $acw62.useState)(classification?.['documentType'] || '');
    if (!classification) return null;
    const confidencePercent = Math.round((classification['confidence'] || 0) * 100);
    const fileName = classification['fileName'] || classification['fileUrl']?.split('/').pop() || 'Document';
    const handleConfirm = ()=>{
        onConfirm(true);
    };
    const handleCorrect = ()=>{
        onConfirm(false, selectedType, selectedCode);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "clarence-modal-overlay",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "clarence-classification-modal",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            children: "Document Classification"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "modal-close",
                            onClick: onDismiss,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "modal-body",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "document-preview",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "document-icon",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                        width: "32",
                                        height: "32",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z",
                                                stroke: "#6366f1",
                                                strokeWidth: "2"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M14 2v6h6M16 13H8M16 17H8M10 9H8",
                                                stroke: "#6366f1",
                                                strokeWidth: "2",
                                                strokeLinecap: "round"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "document-info",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "document-name",
                                        children: fileName
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "classification-result",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Clarence thinks this document is:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "suggested-type",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: classification['documentType']
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "confidence-badge",
                                            style: {
                                                backgroundColor: confidencePercent > 70 ? '#10b981' : '#f59e0b'
                                            },
                                            children: [
                                                confidencePercent,
                                                "% confident"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-code",
                                    children: [
                                        "Section: ",
                                        classification['sectionCode'],
                                        " - ",
                                        classification['sectionName']
                                    ]
                                }),
                                classification['reasoning'] && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "reasoning",
                                    children: classification['reasoning']
                                })
                            ]
                        }),
                        !showCorrection ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    className: "btn-confirm",
                                    onClick: handleConfirm,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M20 6L9 17l-5-5",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round"
                                            })
                                        }),
                                        "Yes, that's correct"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                                    className: "btn-correct",
                                    onClick: ()=>setShowCorrection(true),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                    d: "M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2"
                                                })
                                            ]
                                        }),
                                        "No, let me correct"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "correction-form",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "Select the correct section:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                    value: selectedCode,
                                    onChange: (e)=>setSelectedCode(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                            value: "",
                                            children: "-- Select Section --"
                                        }),
                                        $07bdfbdd1618c971$var$DOCUMENT_TYPES.map((dt)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("option", {
                                                value: dt.code,
                                                children: [
                                                    dt.code,
                                                    " - ",
                                                    dt.name
                                                ]
                                            }, dt.code))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    children: "Document type (optional):"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                    type: "text",
                                    value: selectedType,
                                    onChange: (e)=>setSelectedType(e.target.value),
                                    placeholder: "e.g., Pitch Deck, Board Minutes"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "modal-actions",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "btn-cancel",
                                            onClick: ()=>setShowCorrection(false),
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "btn-submit",
                                            onClick: handleCorrect,
                                            disabled: !selectedCode,
                                            children: "Submit Correction"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $07bdfbdd1618c971$export$2e2bcd8739ae039 = $07bdfbdd1618c971$var$ClassificationConfirm;



const $e79bfd6713ba5be2$var$ClarenceChat = ({ companyId: companyId, onClose: onClose, onExpand: onExpand, isExpanded: isExpanded })=>{
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state['user']);
    const [conversationId, setConversationId] = (0, $acw62.useState)(null);
    const [conversations, setConversations] = (0, $acw62.useState)([]);
    const [messages, setMessages] = (0, $acw62.useState)([]);
    const [agentActions, setAgentActions] = (0, $acw62.useState)([]);
    const [suggestions, setSuggestions] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isLoadingHistory, setIsLoadingHistory] = (0, $acw62.useState)(true);
    const [pendingClassification, setPendingClassification] = (0, $acw62.useState)(null);
    const [selectedFiles, setSelectedFiles] = (0, $acw62.useState)([]);
    const [showHistory, setShowHistory] = (0, $acw62.useState)(true);
    const [isCreatingConversation, setIsCreatingConversation] = (0, $acw62.useState)(false);
    const messagesEndRef = (0, $acw62.useRef)(null);
    const chatInputRef = (0, $acw62.useRef)(null);
    // Load conversation history on mount
    (0, $acw62.useEffect)(()=>{
        if (!companyId) return;
        loadConversations();
    }, [
        companyId
    ]);
    // Socket listeners
    (0, $acw62.useEffect)(()=>{
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).emit('register', {
            userId: user?.['_id'] || user?.['id']
        });
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('clarence:action', handleAgentAction);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('clarence:response', handleAgentResponse);
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('clarence:classification', handleClassification);
        return ()=>{
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('clarence:action', handleAgentAction);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('clarence:response', handleAgentResponse);
            (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('clarence:classification', handleClassification);
        };
    }, []);
    // Auto-scroll to bottom
    (0, $acw62.useEffect)(()=>{
        messagesEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        messages,
        agentActions
    ]);
    // Auto-focus input after response
    (0, $acw62.useEffect)(()=>{
        if (!isLoading) chatInputRef.current?.focus();
    }, [
        isLoading
    ]);
    const loadConversations = async ()=>{
        setIsLoadingHistory(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/clarence/conversations/${companyId}`, true);
        if (response?.['code'] === 200) {
            const convos = response['body']['conversations'] || [];
            setConversations(convos);
            // If there are conversations, show history view
            if (convos.length > 0) setShowHistory(true);
            else {
                // No history, start new conversation
                setShowHistory(false);
                await createNewConversation();
            }
        } else {
            setShowHistory(false);
            await createNewConversation();
        }
        setIsLoadingHistory(false);
    };
    const createNewConversation = async ()=>{
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/conversation', {
            companyId: companyId
        }, true);
        if (response?.['code'] === 201 || response?.['code'] === 200) {
            setConversationId(response['body']['conversationId']);
            setSuggestions(response['body']['suggestions'] || []);
            setMessages([]);
            setShowHistory(false);
        }
    };
    const loadConversation = async (convId)=>{
        setIsLoading(true);
        const response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/clarence/conversation/${convId}`, true);
        if (response?.['code'] === 200) {
            const conversation = response['body']['conversation'];
            setConversationId(convId);
            setMessages(conversation['messages'] || []);
            setSuggestions(conversation['context']?.['suggestedPrompts'] || []);
            setShowHistory(false);
        }
        setIsLoading(false);
    };
    const handleNewChat = async ()=>{
        setIsCreatingConversation(true);
        setMessages([]);
        setConversationId(null);
        setSuggestions([]);
        await createNewConversation();
        setIsCreatingConversation(false);
    };
    const handleBackToHistory = ()=>{
        setShowHistory(true);
        loadConversations();
    };
    const handleAgentAction = (0, $acw62.useCallback)((action)=>{
        setAgentActions((prev)=>{
            // For tool actions, match by toolName; for others, match by actionType
            const matchKey = action['toolName'] ? 'toolName' : 'actionType';
            const existing = prev.findIndex((a)=>a[matchKey] === action[matchKey] && a['runId'] === action['runId']);
            if (existing >= 0) {
                const updated = [
                    ...prev
                ];
                updated[existing] = action;
                return updated;
            }
            return [
                ...prev,
                action
            ];
        });
    }, []);
    const handleAgentResponse = (0, $acw62.useCallback)((data)=>{
        if (data['message']) setMessages((prev)=>[
                ...prev,
                data['message']
            ]);
        if (data['suggestions']) setSuggestions(data['suggestions']);
        setIsLoading(false);
        setAgentActions([]);
    }, []);
    const handleClassification = (0, $acw62.useCallback)((data)=>{
        if (data['needsConfirmation']) setPendingClassification(data['classification']);
    }, []);
    const sendMessage = async (content)=>{
        if (!content?.trim() || !conversationId || isLoading) return;
        setIsLoading(true);
        setAgentActions([]);
        const userMessage = {
            role: 'user',
            content: content,
            timestamp: new Date().toISOString()
        };
        setMessages((prev)=>[
                ...prev,
                userMessage
            ]);
        const response = await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/chat', {
            conversationId: conversationId,
            message: content,
            files: selectedFiles
        }, true, null, true);
        if (response?.['code'] !== 200) {
            setIsLoading(false);
            setMessages((prev)=>[
                    ...prev,
                    {
                        role: 'assistant',
                        content: 'Sorry, something went wrong. Please try again.',
                        timestamp: new Date().toISOString()
                    }
                ]);
            return;
        }
        if (response['body']?.['response']) {
            setMessages((prev)=>[
                    ...prev,
                    {
                        role: 'assistant',
                        content: response['body']['response'],
                        timestamp: new Date().toISOString(),
                        toolsUsed: response['body']['toolsUsed'] || []
                    }
                ]);
            setSuggestions(response['body']['suggestions'] || []);
            setIsLoading(false);
            setAgentActions([]);
        }
    };
    const handleSuggestionClick = (suggestion)=>{
        sendMessage(suggestion);
    };
    const handleClassificationConfirm = async (confirmed, correctedType, correctedSectionCode)=>{
        if (!pendingClassification) return;
        await (0, $bebe1cbb5a309c8c$export$42ff643f16b1faa2)('/clarence/classify/confirm', {
            conversationId: conversationId,
            fileUrl: pendingClassification['fileUrl'],
            confirmed: confirmed,
            correctedType: correctedType,
            correctedSectionCode: correctedSectionCode
        }, true);
        setPendingClassification(null);
    };
    const handleFileSelect = (files)=>{
        setSelectedFiles(files);
    };
    const formatDate = (dateString)=>{
        const date = new Date(dateString);
        const now = new Date();
        const diff = now - date;
        const minutes = Math.floor(diff / 60000);
        const hours = Math.floor(diff / 3600000);
        const days = Math.floor(diff / 86400000);
        // For today, show relative time
        if (days === 0) {
            if (minutes < 1) return 'Just now';
            if (minutes < 60) return `${minutes} min ago`;
            return `${hours} hour${hours > 1 ? 's' : ''} ago`;
        }
        if (days === 1) return 'Yesterday';
        if (days < 7) return `${days} days ago`;
        return date.toLocaleDateString();
    };
    // Show loading state
    if (isLoadingHistory) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clarence-chat",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "clarence-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-header-left",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "clarence-avatar",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z",
                                        fill: "currentColor"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "clarence-header-info",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Clarence AI"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "clarence-status",
                                        children: "Ask about your documents"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-header-actions",
                        children: [
                            onExpand && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "clarence-expand-btn",
                                onClick: onExpand,
                                title: isExpanded ? "Collapse" : "Expand",
                                children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            onClose && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "clarence-close-btn",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M18 6L6 18M6 6l12 12",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "clarence-body clarence-loading",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "clarence-typing",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                    ]
                })
            })
        ]
    });
    // Show conversation history
    if (showHistory && conversations.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clarence-chat",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "clarence-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-header-left",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "clarence-avatar",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z",
                                        fill: "currentColor"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "clarence-header-info",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Clarence AI"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "clarence-status",
                                        children: "Your conversations"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-header-actions",
                        children: [
                            onExpand && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "clarence-expand-btn",
                                onClick: onExpand,
                                title: isExpanded ? "Collapse" : "Expand",
                                children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            onClose && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "clarence-close-btn",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M18 6L6 18M6 6l12 12",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "clarence-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "clarence-new-chat-btn",
                        onClick: handleNewChat,
                        disabled: isCreatingConversation,
                        children: [
                            isCreatingConversation ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "clarence-btn-loader",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                    d: "M12 5v14M5 12h14",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round"
                                })
                            }),
                            isCreatingConversation ? 'Creating...' : 'New Conversation'
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "clarence-history-list",
                        children: conversations.map((conv)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "clarence-history-item",
                                onClick: ()=>loadConversation(conv['_id']),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "clarence-history-icon",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                                d: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "clarence-history-content",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "clarence-history-title",
                                                children: conv['title'] || 'Conversation'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "clarence-history-meta",
                                                children: [
                                                    conv['messageCount'] || 0,
                                                    " messages \u2022 ",
                                                    formatDate(conv['lastMessageAt'] || conv['createdAt'])
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "clarence-history-arrow",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M9 18l6-6-6-6",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                ]
                            }, conv['_id']))
                    })
                ]
            })
        ]
    });
    // Show chat view
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "clarence-chat",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "clarence-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-header-left",
                        children: [
                            conversations.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "clarence-back-btn",
                                onClick: handleBackToHistory,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15 18l-6-6 6-6",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "clarence-avatar",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z",
                                        fill: "currentColor"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "clarence-header-info",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                        children: "Clarence AI"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "clarence-status",
                                        children: "Ask about your documents"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-header-actions",
                        children: [
                            onExpand && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "clarence-expand-btn",
                                onClick: onExpand,
                                title: isExpanded ? "Collapse" : "Expand",
                                children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            onClose && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "clarence-close-btn",
                                onClick: onClose,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M18 6L6 18M6 6l12 12",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "clarence-body",
                children: [
                    messages.length === 0 && !isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-welcome",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "clarence-welcome-icon",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                    width: "48",
                                    height: "48",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z",
                                            fill: "#6366f1",
                                            opacity: "0.2"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                            d: "M12 6v6l4 2",
                                            stroke: "#6366f1",
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: "Hello! I'm Clarence"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "Your AI assistant for document analysis. Ask me anything about your company documents."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb6c320ac2717c03$export$2e2bcd8739ae039), {
                        messages: messages
                    }),
                    isLoading && agentActions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60f165536c9ffc45$export$2e2bcd8739ae039), {
                        actions: agentActions
                    }),
                    isLoading && agentActions.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "clarence-typing",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: messagesEndRef
                    })
                ]
            }),
            messages.length === 0 && suggestions.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $89a9e7ddc60e9a10$export$2e2bcd8739ae039), {
                suggestions: suggestions,
                onSelect: handleSuggestionClick
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c66a69b5e86dec42$export$2e2bcd8739ae039), {
                ref: chatInputRef,
                onSend: sendMessage,
                disabled: isLoading,
                onFileSelect: handleFileSelect,
                selectedFiles: selectedFiles
            }),
            pendingClassification && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $07bdfbdd1618c971$export$2e2bcd8739ae039), {
                classification: pendingClassification,
                onConfirm: handleClassificationConfirm,
                onDismiss: ()=>setPendingClassification(null)
            })
        ]
    });
};
var $e79bfd6713ba5be2$export$2e2bcd8739ae039 = $e79bfd6713ba5be2$var$ClarenceChat;



var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");



const $f765fce87cef9dc5$var$ClarenceWidget = ()=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state['user']);
    const { selectedCompany: selectedCompany } = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state['company']);
    // Listen for sidebar button click
    (0, $acw62.useEffect)(()=>{
        const handleOpenClarence = ()=>setIsOpen(true);
        window.addEventListener('openClarence', handleOpenClarence);
        return ()=>window.removeEventListener('openClarence', handleOpenClarence);
    }, []);
    // Don't show for guests, if no company selected, or if AI features are disabled
    if (!(0, $6a6b4b5ab5be324d$export$2908142509316f06) || !user || user['role'] === 'Guest' || !selectedCompany?.['_id']) return null;
    const toggleChat = ()=>{
        setIsOpen(!isOpen);
        if (isOpen) setIsExpanded(false); // Reset expanded state when closing
    };
    const toggleExpand = ()=>setIsExpanded(!isExpanded);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `clarence-widget ${isExpanded ? 'expanded' : ''}`,
        children: [
            isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `clarence-widget-chat ${isExpanded ? 'expanded' : ''}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e79bfd6713ba5be2$export$2e2bcd8739ae039), {
                    companyId: selectedCompany['_id'],
                    onClose: toggleChat,
                    onExpand: toggleExpand,
                    isExpanded: isExpanded
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: `clarence-widget-button ${isOpen ? 'active' : ''}`,
                onClick: toggleChat,
                title: isOpen ? "Close" : "Chat with Clarence AI",
                children: [
                    isOpen ? /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                            d: "M18 6L6 18M6 6l12 12",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round"
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z",
                                fill: "currentColor",
                                opacity: "0.2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                d: "M12 6v6l4 2",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                                cx: "12",
                                cy: "12",
                                r: "9",
                                stroke: "currentColor",
                                strokeWidth: "2"
                            })
                        ]
                    }),
                    !isOpen && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "widget-label",
                        children: "Ask Clarence"
                    })
                ]
            })
        ]
    });
};
var $f765fce87cef9dc5$export$2e2bcd8739ae039 = $f765fce87cef9dc5$var$ClarenceWidget;













function $f9b54c50c4e21fd5$export$2e2bcd8739ae039() {
    const blogSlice = (0, $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b)({
        name: "BLOGS",
        initialState: {
            q: '',
            tab: 'All',
            page: 1,
            pageSize: 9,
            filtered: false,
            rawData: [
                ...(0, $6238ac0b849c9c3e$export$d09847bb5c97319b)
            ],
            blogPosts: $6238ac0b849c9c3e$export$d09847bb5c97319b,
            featuredPost: $6238ac0b849c9c3e$export$38165aa3a38f65a7
        },
        reducers: {
            FILTER_BLOG: (state, action)=>{
                return {
                    ...state,
                    ...action.payload
                };
            }
        }
    });
    return blogSlice.reducer;
}
const $f9b54c50c4e21fd5$export$4a11d81aa84ca0c8 = (0, $74cf642ba7fa99c2$export$309c7a02b0b0bc62)("BLOGS/FILTER_BLOG");






function $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039() {
    const location1 = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const user = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.user);
    const modal = (0, $d8fc8d639f906efc$export$2105062e25df4afe)((state)=>state.modal);
    (0, $acw62.useEffect)(()=>{
        if (modal['open'] == '') {
            let inputs = document.getElementsByTagName('input');
            for(var i = 0; i < inputs.length; i++)if (inputs[i]['id'] !== "userPermission" && (inputs[i]['type'] == "text" || inputs[i]['type'] == "email" || inputs[i]['type'] == "password")) inputs[i]['value'] = "";
        }
    }, [
        modal
    ]);
    (0, $acw62.useEffect)(()=>{
        if (user['emailVerified']) {
            localStorage.removeItem('isDemoChecklist');
            localStorage.removeItem('isPartnerChecklist');
        }
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!user?.['_id'] || !(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039)) return;
        const userId = String(user['_id']);
        const doRegister = ()=>(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).emit('register', {
                userId: userId
            });
        // Register immediately (handles initial connect and user-state changes)
        if ((0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).connected) doRegister();
        // Re-register on every reconnect so emitToUser keeps working
        // after brief network drops during long background jobs (e.g. AI generation)
        (0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).on('connect', doRegister);
        return ()=>(0, $bebe1cbb5a309c8c$export$2e2bcd8739ae039).off('connect', doRegister);
    }, [
        user?.['_id']
    ]);
    const isFooter = (0, $16250bd714b02a14$export$68d31c12ec503eb8).find((r)=>r.split("/").every((s, i)=>s === location1.pathname.split("/")[i] || s[0] === ":"));
    const isLoggedInPage = (0, $16250bd714b02a14$export$95d9d456783cd0b0).find((r)=>r.split("/").every((s, i)=>s === location1.pathname.split("/")[i] || s[0] === ":"));
    // Standalone pages ship their own header/footer — render neither set of global chrome.
    const isStandalone = (0, $16250bd714b02a14$export$71ef1e7f4bfe9c77).find((r)=>r.split("/").every((s, i)=>s === location1.pathname.split("/")[i] || s[0] === ":"));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            !isStandalone && (isLoggedInPage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4ed3d4aabf5e4436$export$2e2bcd8739ae039), {}) || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b2e7a02006d70e66$export$2e2bcd8739ae039), {})),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ae1d2af47f5ebdd$export$2e2bcd8739ae039), {}),
            !isStandalone && ((isFooter || isLoggedInPage) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $743b6185e190fb3d$export$2e2bcd8739ae039), {}) || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5e6b7f8047c4b0f$export$2e2bcd8739ae039), {})),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0868b271c9ad66ad$export$2e2bcd8739ae039), {}),
            isLoggedInPage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f765fce87cef9dc5$export$2e2bcd8739ae039), {})
        ]
    });
}
(async ()=>{
    if (typeof document !== "undefined") {
        let user = {};
        let module = {};
        let partner = {};
        let company = {};
        let companies = [];
        let modal = {
            open: ''
        };
        let linkedIn = {
            isFromLinkedIn: false
        };
        let loginType = {
            smsEnabled: '',
            twoFaEnabled: '',
            emailEnabled: '',
            hash: ''
        };
        if (!window.__PRELOADED_STATE__) {
            if ((0, $16250bd714b02a14$export$95d9d456783cd0b0).find((r)=>r.split("/").every((s, i)=>s === location.pathname.split("/")[i] || s[0] === ":"))) {
                let response = await (0, $bebe1cbb5a309c8c$export$e17608451341e929)(`/user`);
                if (!response || response['code'] != 200) return (0, $bebe1cbb5a309c8c$export$787f5d117f138d13)(response['message']);
                else {
                    const { body: body } = response;
                    user = body['user'];
                // companies = body['companies'];
                }
            }
        }
        const userReducer = (0, $3e06475c4dbec09d$export$2e2bcd8739ae039)(user);
        const modalReducer = (0, $ee5327cdf6cdce8c$export$2e2bcd8739ae039)(modal);
        const partnerReducer = (0, $3d3d7a2ee763f32a$export$2e2bcd8739ae039)(partner);
        const moduleReducer = (0, $b73aa58a82b722b1$export$2e2bcd8739ae039)(module);
        const loginReducer = (0, $7fa194fc86099528$export$2e2bcd8739ae039)(loginType);
        const companyReducer = (0, $b4397434d961d2b4$export$2e2bcd8739ae039)(company);
        const companiesReducer = (0, $b9bcf9787e5ad456$export$2e2bcd8739ae039)(companies);
        const getFileManagement = (0, $b11447c30838833f$export$2e2bcd8739ae039)();
        const linkedInReducer = (0, $c968c32a840f1f4e$export$2e2bcd8739ae039)(linkedIn);
        const fileAllocationReducer = (0, $12074930bd2c1829$export$2e2bcd8739ae039)();
        const filterBlog = (0, $f9b54c50c4e21fd5$export$2e2bcd8739ae039)();
        const appReducers = (0, $22a1fae7337b63c9$export$2e2bcd8739ae039)();
        const filesReducer = (0, $e0a7c253e2df808f$export$2e2bcd8739ae039)();
        const clarenceReducer = (0, $d1a7983fbe4975c9$export$2e2bcd8739ae039)();
        const dealRoomReducer = (0, $0b8fb0446eadf91e$export$2e2bcd8739ae039)();
        const persistConfig = {
            key: 'root',
            version: 1,
            storage: $b36a05dffe55b995$export$2e2bcd8739ae039
        };
        const reducer = (0, $ad4393542232627c$export$66e4520cdb265d18)({
            user: userReducer,
            modal: modalReducer,
            module: moduleReducer,
            partner: partnerReducer,
            loginType: loginReducer,
            company: companyReducer,
            companies: companiesReducer,
            linkedIn: linkedInReducer,
            fileAllocation: fileAllocationReducer,
            blogs: filterBlog,
            appData: appReducers,
            common: (0, $defbea5c5b83142b$export$2e2bcd8739ae039),
            files: filesReducer,
            getFileManagement: getFileManagement,
            clarence: clarenceReducer,
            dealRoom: dealRoomReducer
        });
        const persistedReducer = (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(persistConfig, reducer);
        const store = (0, $74cf642ba7fa99c2$export$7d8a5b498da695ac)({
            reducer: {
                // persistedReducer,
                user: userReducer,
                modal: modalReducer,
                module: moduleReducer,
                partner: partnerReducer,
                company: companyReducer,
                loginType: loginReducer,
                companies: companiesReducer,
                linkedIn: linkedInReducer,
                fileAllocation: fileAllocationReducer,
                blogs: filterBlog,
                appData: appReducers,
                common: (0, $defbea5c5b83142b$export$2e2bcd8739ae039),
                files: filesReducer,
                fileManagement: getFileManagement,
                clarence: clarenceReducer,
                dealRoom: dealRoomReducer
            },
            preloadedState: window.__PRELOADED_STATE__
        });
        // let persistor = persistStore(store);
        delete window.__PRELOADED_STATE__;
        (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).hydrate(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f4d8f6ffbbb628$export$2e2bcd8739ae039), {
                store: store,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($4c8cda5d2c6d1d8b$export$2e2bcd8739ae039, {})
            })
        }), document.getElementById("root"));
    }
})();


//# sourceMappingURL=index.7eefb795.js.map
